
      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$exportWildcard(dest, source) {
  Object.keys(source).forEach(function(key) {
    if (key === 'default' || key === '__esModule' || Object.prototype.hasOwnProperty.call(dest, key)) {
      return;
    }

    Object.defineProperty(dest, key, {
      enumerable: true,
      get: function get() {
        return source[key];
      }
    });
  });

  return dest;
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$extendImportMap(map) {
  Object.assign(parcelRequire.i ??= {}, map);
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$resolve(url) {
  url = parcelRequire.i?.[url] || url;
  return new URL($parcel$distDir + url, import.meta.url).toString();
}
var $parcel$distDir = "../";

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequirecaae"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequirecaae"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("cKjOO", function(module, exports) {

var $4TZ3D = parcelRequire("4TZ3D");
"use strict";
































module.exports = function() {
    var makeSelfResolutionError = function() {
        return new TypeError("circular promise resolution chain\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
    };
    var reflectHandler = function() {
        return new Promise.PromiseInspection(this._target());
    };
    var apiRejection = function(msg) {
        return Promise.reject(new TypeError(msg));
    };
    function Proxyable() {}
    var UNDEFINED_BINDING = {};
    var util = (parcelRequire("hXEBa"));
    var getDomain;
    if (util.isNode) getDomain = function() {
        var ret = $4TZ3D.domain;
        if (ret === undefined) ret = null;
        return ret;
    };
    else getDomain = function() {
        return null;
    };
    util.notEnumerableProp(Promise, "_getDomain", getDomain);
    var es5 = (parcelRequire("gK3jX"));
    var Async = (parcelRequire("j6mSd"));
    var async = new Async();
    es5.defineProperty(Promise, "_async", {
        value: async
    });
    var errors = (parcelRequire("2cTYx"));
    var TypeError = Promise.TypeError = errors.TypeError;
    Promise.RangeError = errors.RangeError;
    var CancellationError = Promise.CancellationError = errors.CancellationError;
    Promise.TimeoutError = errors.TimeoutError;
    Promise.OperationalError = errors.OperationalError;
    Promise.RejectionError = errors.OperationalError;
    Promise.AggregateError = errors.AggregateError;
    var INTERNAL = function() {};
    var APPLY = {};
    var NEXT_FILTER = {};
    var tryConvertToPromise = (parcelRequire("6EneY"))(Promise, INTERNAL);
    var PromiseArray = (parcelRequire("aQ62d"))(Promise, INTERNAL, tryConvertToPromise, apiRejection, Proxyable);
    var Context = (parcelRequire("1hNea"))(Promise);
    /*jshint unused:false*/ var createContext = Context.create;
    var debug = (parcelRequire("b3Gcj"))(Promise, Context);
    var CapturedTrace = debug.CapturedTrace;
    var PassThroughHandlerContext = (parcelRequire("kXSTn"))(Promise, tryConvertToPromise);
    var catchFilter = (parcelRequire("lH3Jl"))(NEXT_FILTER);
    var nodebackForPromise = (parcelRequire("ai1Zk"));
    var errorObj = util.errorObj;
    var tryCatch = util.tryCatch;
    function check(self, executor) {
        if (typeof executor !== "function") throw new TypeError("expecting a function but got " + util.classString(executor));
        if (self.constructor !== Promise) throw new TypeError("the promise constructor cannot be invoked directly\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
    }
    function Promise(executor) {
        this._bitField = 0;
        this._fulfillmentHandler0 = undefined;
        this._rejectionHandler0 = undefined;
        this._promise0 = undefined;
        this._receiver0 = undefined;
        if (executor !== INTERNAL) {
            check(this, executor);
            this._resolveFromExecutor(executor);
        }
        this._promiseCreated();
        this._fireEvent("promiseCreated", this);
    }
    Promise.prototype.toString = function() {
        return "[object Promise]";
    };
    Promise.prototype.caught = Promise.prototype["catch"] = function(fn) {
        var len = arguments.length;
        if (len > 1) {
            var catchInstances = new Array(len - 1), j = 0, i;
            for(i = 0; i < len - 1; ++i){
                var item = arguments[i];
                if (util.isObject(item)) catchInstances[j++] = item;
                else return apiRejection("expecting an object but got A catch statement predicate " + util.classString(item));
            }
            catchInstances.length = j;
            fn = arguments[i];
            return this.then(undefined, catchFilter(catchInstances, fn, this));
        }
        return this.then(undefined, fn);
    };
    Promise.prototype.reflect = function() {
        return this._then(reflectHandler, reflectHandler, undefined, this, undefined);
    };
    Promise.prototype.then = function(didFulfill, didReject) {
        if (debug.warnings() && arguments.length > 0 && typeof didFulfill !== "function" && typeof didReject !== "function") {
            var msg = ".then() only accepts functions but was passed: " + util.classString(didFulfill);
            if (arguments.length > 1) msg += ", " + util.classString(didReject);
            this._warn(msg);
        }
        return this._then(didFulfill, didReject, undefined, undefined, undefined);
    };
    Promise.prototype.done = function(didFulfill, didReject) {
        var promise = this._then(didFulfill, didReject, undefined, undefined, undefined);
        promise._setIsFinal();
    };
    Promise.prototype.spread = function(fn) {
        if (typeof fn !== "function") return apiRejection("expecting a function but got " + util.classString(fn));
        return this.all()._then(fn, undefined, undefined, APPLY, undefined);
    };
    Promise.prototype.toJSON = function() {
        var ret = {
            isFulfilled: false,
            isRejected: false,
            fulfillmentValue: undefined,
            rejectionReason: undefined
        };
        if (this.isFulfilled()) {
            ret.fulfillmentValue = this.value();
            ret.isFulfilled = true;
        } else if (this.isRejected()) {
            ret.rejectionReason = this.reason();
            ret.isRejected = true;
        }
        return ret;
    };
    Promise.prototype.all = function() {
        if (arguments.length > 0) this._warn(".all() was passed arguments but it does not take any");
        return new PromiseArray(this).promise();
    };
    Promise.prototype.error = function(fn) {
        return this.caught(util.originatesFromRejection, fn);
    };
    Promise.getNewLibraryCopy = module.exports;
    Promise.is = function(val) {
        return val instanceof Promise;
    };
    Promise.fromNode = Promise.fromCallback = function(fn) {
        var ret = new Promise(INTERNAL);
        ret._captureStackTrace();
        var multiArgs = arguments.length > 1 ? !!Object(arguments[1]).multiArgs : false;
        var result = tryCatch(fn)(nodebackForPromise(ret, multiArgs));
        if (result === errorObj) ret._rejectCallback(result.e, true);
        if (!ret._isFateSealed()) ret._setAsyncGuaranteed();
        return ret;
    };
    Promise.all = function(promises) {
        return new PromiseArray(promises).promise();
    };
    Promise.cast = function(obj) {
        var ret = tryConvertToPromise(obj);
        if (!(ret instanceof Promise)) {
            ret = new Promise(INTERNAL);
            ret._captureStackTrace();
            ret._setFulfilled();
            ret._rejectionHandler0 = obj;
        }
        return ret;
    };
    Promise.resolve = Promise.fulfilled = Promise.cast;
    Promise.reject = Promise.rejected = function(reason) {
        var ret = new Promise(INTERNAL);
        ret._captureStackTrace();
        ret._rejectCallback(reason, true);
        return ret;
    };
    Promise.setScheduler = function(fn) {
        if (typeof fn !== "function") throw new TypeError("expecting a function but got " + util.classString(fn));
        return async.setScheduler(fn);
    };
    Promise.prototype._then = function(didFulfill, didReject, _, receiver, internalData) {
        var haveInternalData = internalData !== undefined;
        var promise = haveInternalData ? internalData : new Promise(INTERNAL);
        var target = this._target();
        var bitField = target._bitField;
        if (!haveInternalData) {
            promise._propagateFrom(this, 3);
            promise._captureStackTrace();
            if (receiver === undefined && (this._bitField & 2097152) !== 0) {
                if (!((bitField & 50397184) === 0)) receiver = this._boundValue();
                else receiver = target === this ? undefined : this._boundTo;
            }
            this._fireEvent("promiseChained", this, promise);
        }
        var domain = getDomain();
        if (!((bitField & 50397184) === 0)) {
            var handler, value, settler = target._settlePromiseCtx;
            if ((bitField & 33554432) !== 0) {
                value = target._rejectionHandler0;
                handler = didFulfill;
            } else if ((bitField & 16777216) !== 0) {
                value = target._fulfillmentHandler0;
                handler = didReject;
                target._unsetRejectionIsUnhandled();
            } else {
                settler = target._settlePromiseLateCancellationObserver;
                value = new CancellationError("late cancellation observer");
                target._attachExtraTrace(value);
                handler = didReject;
            }
            async.invoke(settler, target, {
                handler: domain === null ? handler : typeof handler === "function" && util.domainBind(domain, handler),
                promise: promise,
                receiver: receiver,
                value: value
            });
        } else target._addCallbacks(didFulfill, didReject, promise, receiver, domain);
        return promise;
    };
    Promise.prototype._length = function() {
        return this._bitField & 65535;
    };
    Promise.prototype._isFateSealed = function() {
        return (this._bitField & 117506048) !== 0;
    };
    Promise.prototype._isFollowing = function() {
        return (this._bitField & 67108864) === 67108864;
    };
    Promise.prototype._setLength = function(len) {
        this._bitField = this._bitField & -65536 | len & 65535;
    };
    Promise.prototype._setFulfilled = function() {
        this._bitField = this._bitField | 33554432;
        this._fireEvent("promiseFulfilled", this);
    };
    Promise.prototype._setRejected = function() {
        this._bitField = this._bitField | 16777216;
        this._fireEvent("promiseRejected", this);
    };
    Promise.prototype._setFollowing = function() {
        this._bitField = this._bitField | 67108864;
        this._fireEvent("promiseResolved", this);
    };
    Promise.prototype._setIsFinal = function() {
        this._bitField = this._bitField | 4194304;
    };
    Promise.prototype._isFinal = function() {
        return (this._bitField & 4194304) > 0;
    };
    Promise.prototype._unsetCancelled = function() {
        this._bitField = this._bitField & -65537;
    };
    Promise.prototype._setCancelled = function() {
        this._bitField = this._bitField | 65536;
        this._fireEvent("promiseCancelled", this);
    };
    Promise.prototype._setWillBeCancelled = function() {
        this._bitField = this._bitField | 8388608;
    };
    Promise.prototype._setAsyncGuaranteed = function() {
        if (async.hasCustomScheduler()) return;
        this._bitField = this._bitField | 134217728;
    };
    Promise.prototype._receiverAt = function(index) {
        var ret = index === 0 ? this._receiver0 : this[index * 4 - 4 + 3];
        if (ret === UNDEFINED_BINDING) return undefined;
        else if (ret === undefined && this._isBound()) return this._boundValue();
        return ret;
    };
    Promise.prototype._promiseAt = function(index) {
        return this[index * 4 - 4 + 2];
    };
    Promise.prototype._fulfillmentHandlerAt = function(index) {
        return this[index * 4 - 4 + 0];
    };
    Promise.prototype._rejectionHandlerAt = function(index) {
        return this[index * 4 - 4 + 1];
    };
    Promise.prototype._boundValue = function() {};
    Promise.prototype._migrateCallback0 = function(follower) {
        var bitField = follower._bitField;
        var fulfill = follower._fulfillmentHandler0;
        var reject = follower._rejectionHandler0;
        var promise = follower._promise0;
        var receiver = follower._receiverAt(0);
        if (receiver === undefined) receiver = UNDEFINED_BINDING;
        this._addCallbacks(fulfill, reject, promise, receiver, null);
    };
    Promise.prototype._migrateCallbackAt = function(follower, index) {
        var fulfill = follower._fulfillmentHandlerAt(index);
        var reject = follower._rejectionHandlerAt(index);
        var promise = follower._promiseAt(index);
        var receiver = follower._receiverAt(index);
        if (receiver === undefined) receiver = UNDEFINED_BINDING;
        this._addCallbacks(fulfill, reject, promise, receiver, null);
    };
    Promise.prototype._addCallbacks = function(fulfill, reject, promise, receiver, domain) {
        var index = this._length();
        if (index >= 65531) {
            index = 0;
            this._setLength(0);
        }
        if (index === 0) {
            this._promise0 = promise;
            this._receiver0 = receiver;
            if (typeof fulfill === "function") this._fulfillmentHandler0 = domain === null ? fulfill : util.domainBind(domain, fulfill);
            if (typeof reject === "function") this._rejectionHandler0 = domain === null ? reject : util.domainBind(domain, reject);
        } else {
            var base = index * 4 - 4;
            this[base + 2] = promise;
            this[base + 3] = receiver;
            if (typeof fulfill === "function") this[base + 0] = domain === null ? fulfill : util.domainBind(domain, fulfill);
            if (typeof reject === "function") this[base + 1] = domain === null ? reject : util.domainBind(domain, reject);
        }
        this._setLength(index + 1);
        return index;
    };
    Promise.prototype._proxy = function(proxyable, arg) {
        this._addCallbacks(undefined, undefined, arg, proxyable, null);
    };
    Promise.prototype._resolveCallback = function(value, shouldBind) {
        if ((this._bitField & 117506048) !== 0) return;
        if (value === this) return this._rejectCallback(makeSelfResolutionError(), false);
        var maybePromise = tryConvertToPromise(value, this);
        if (!(maybePromise instanceof Promise)) return this._fulfill(value);
        if (shouldBind) this._propagateFrom(maybePromise, 2);
        var promise = maybePromise._target();
        if (promise === this) {
            this._reject(makeSelfResolutionError());
            return;
        }
        var bitField = promise._bitField;
        if ((bitField & 50397184) === 0) {
            var len = this._length();
            if (len > 0) promise._migrateCallback0(this);
            for(var i = 1; i < len; ++i)promise._migrateCallbackAt(this, i);
            this._setFollowing();
            this._setLength(0);
            this._setFollowee(promise);
        } else if ((bitField & 33554432) !== 0) this._fulfill(promise._value());
        else if ((bitField & 16777216) !== 0) this._reject(promise._reason());
        else {
            var reason = new CancellationError("late cancellation observer");
            promise._attachExtraTrace(reason);
            this._reject(reason);
        }
    };
    Promise.prototype._rejectCallback = function(reason, synchronous, ignoreNonErrorWarnings) {
        var trace = util.ensureErrorObject(reason);
        var hasStack = trace === reason;
        if (!hasStack && !ignoreNonErrorWarnings && debug.warnings()) {
            var message = "a promise was rejected with a non-error: " + util.classString(reason);
            this._warn(message, true);
        }
        this._attachExtraTrace(trace, synchronous ? hasStack : false);
        this._reject(reason);
    };
    Promise.prototype._resolveFromExecutor = function(executor) {
        var promise = this;
        this._captureStackTrace();
        this._pushContext();
        var synchronous = true;
        var r = this._execute(executor, function(value) {
            promise._resolveCallback(value);
        }, function(reason) {
            promise._rejectCallback(reason, synchronous);
        });
        synchronous = false;
        this._popContext();
        if (r !== undefined) promise._rejectCallback(r, true);
    };
    Promise.prototype._settlePromiseFromHandler = function(handler, receiver, value, promise) {
        var bitField = promise._bitField;
        if ((bitField & 65536) !== 0) return;
        promise._pushContext();
        var x;
        if (receiver === APPLY) {
            if (!value || typeof value.length !== "number") {
                x = errorObj;
                x.e = new TypeError("cannot .spread() a non-array: " + util.classString(value));
            } else x = tryCatch(handler).apply(this._boundValue(), value);
        } else x = tryCatch(handler).call(receiver, value);
        var promiseCreated = promise._popContext();
        bitField = promise._bitField;
        if ((bitField & 65536) !== 0) return;
        if (x === NEXT_FILTER) promise._reject(value);
        else if (x === errorObj) promise._rejectCallback(x.e, false);
        else {
            debug.checkForgottenReturns(x, promiseCreated, "", promise, this);
            promise._resolveCallback(x);
        }
    };
    Promise.prototype._target = function() {
        var ret = this;
        while(ret._isFollowing())ret = ret._followee();
        return ret;
    };
    Promise.prototype._followee = function() {
        return this._rejectionHandler0;
    };
    Promise.prototype._setFollowee = function(promise) {
        this._rejectionHandler0 = promise;
    };
    Promise.prototype._settlePromise = function(promise, handler, receiver, value) {
        var isPromise = promise instanceof Promise;
        var bitField = this._bitField;
        var asyncGuaranteed = (bitField & 134217728) !== 0;
        if ((bitField & 65536) !== 0) {
            if (isPromise) promise._invokeInternalOnCancel();
            if (receiver instanceof PassThroughHandlerContext && receiver.isFinallyHandler()) {
                receiver.cancelPromise = promise;
                if (tryCatch(handler).call(receiver, value) === errorObj) promise._reject(errorObj.e);
            } else if (handler === reflectHandler) promise._fulfill(reflectHandler.call(receiver));
            else if (receiver instanceof Proxyable) receiver._promiseCancelled(promise);
            else if (isPromise || promise instanceof PromiseArray) promise._cancel();
            else receiver.cancel();
        } else if (typeof handler === "function") {
            if (!isPromise) handler.call(receiver, value, promise);
            else {
                if (asyncGuaranteed) promise._setAsyncGuaranteed();
                this._settlePromiseFromHandler(handler, receiver, value, promise);
            }
        } else if (receiver instanceof Proxyable) {
            if (!receiver._isResolved()) {
                if ((bitField & 33554432) !== 0) receiver._promiseFulfilled(value, promise);
                else receiver._promiseRejected(value, promise);
            }
        } else if (isPromise) {
            if (asyncGuaranteed) promise._setAsyncGuaranteed();
            if ((bitField & 33554432) !== 0) promise._fulfill(value);
            else promise._reject(value);
        }
    };
    Promise.prototype._settlePromiseLateCancellationObserver = function(ctx) {
        var handler = ctx.handler;
        var promise = ctx.promise;
        var receiver = ctx.receiver;
        var value = ctx.value;
        if (typeof handler === "function") {
            if (!(promise instanceof Promise)) handler.call(receiver, value, promise);
            else this._settlePromiseFromHandler(handler, receiver, value, promise);
        } else if (promise instanceof Promise) promise._reject(value);
    };
    Promise.prototype._settlePromiseCtx = function(ctx) {
        this._settlePromise(ctx.promise, ctx.handler, ctx.receiver, ctx.value);
    };
    Promise.prototype._settlePromise0 = function(handler, value, bitField) {
        var promise = this._promise0;
        var receiver = this._receiverAt(0);
        this._promise0 = undefined;
        this._receiver0 = undefined;
        this._settlePromise(promise, handler, receiver, value);
    };
    Promise.prototype._clearCallbackDataAtIndex = function(index) {
        var base = index * 4 - 4;
        this[base + 2] = this[base + 3] = this[base + 0] = this[base + 1] = undefined;
    };
    Promise.prototype._fulfill = function(value) {
        var bitField = this._bitField;
        if ((bitField & 117506048) >>> 16) return;
        if (value === this) {
            var err = makeSelfResolutionError();
            this._attachExtraTrace(err);
            return this._reject(err);
        }
        this._setFulfilled();
        this._rejectionHandler0 = value;
        if ((bitField & 65535) > 0) {
            if ((bitField & 134217728) !== 0) this._settlePromises();
            else async.settlePromises(this);
        }
    };
    Promise.prototype._reject = function(reason) {
        var bitField = this._bitField;
        if ((bitField & 117506048) >>> 16) return;
        this._setRejected();
        this._fulfillmentHandler0 = reason;
        if (this._isFinal()) return async.fatalError(reason, util.isNode);
        if ((bitField & 65535) > 0) async.settlePromises(this);
        else this._ensurePossibleRejectionHandled();
    };
    Promise.prototype._fulfillPromises = function(len, value) {
        for(var i = 1; i < len; i++){
            var handler = this._fulfillmentHandlerAt(i);
            var promise = this._promiseAt(i);
            var receiver = this._receiverAt(i);
            this._clearCallbackDataAtIndex(i);
            this._settlePromise(promise, handler, receiver, value);
        }
    };
    Promise.prototype._rejectPromises = function(len, reason) {
        for(var i = 1; i < len; i++){
            var handler = this._rejectionHandlerAt(i);
            var promise = this._promiseAt(i);
            var receiver = this._receiverAt(i);
            this._clearCallbackDataAtIndex(i);
            this._settlePromise(promise, handler, receiver, reason);
        }
    };
    Promise.prototype._settlePromises = function() {
        var bitField = this._bitField;
        var len = bitField & 65535;
        if (len > 0) {
            if ((bitField & 16842752) !== 0) {
                var reason = this._fulfillmentHandler0;
                this._settlePromise0(this._rejectionHandler0, reason, bitField);
                this._rejectPromises(len, reason);
            } else {
                var value = this._rejectionHandler0;
                this._settlePromise0(this._fulfillmentHandler0, value, bitField);
                this._fulfillPromises(len, value);
            }
            this._setLength(0);
        }
        this._clearCancellationData();
    };
    Promise.prototype._settledValue = function() {
        var bitField = this._bitField;
        if ((bitField & 33554432) !== 0) return this._rejectionHandler0;
        else if ((bitField & 16777216) !== 0) return this._fulfillmentHandler0;
    };
    function deferResolve(v) {
        this.promise._resolveCallback(v);
    }
    function deferReject(v) {
        this.promise._rejectCallback(v, false);
    }
    Promise.defer = Promise.pending = function() {
        debug.deprecated("Promise.defer", "new Promise");
        var promise = new Promise(INTERNAL);
        return {
            promise: promise,
            resolve: deferResolve,
            reject: deferReject
        };
    };
    util.notEnumerableProp(Promise, "_makeSelfResolutionError", makeSelfResolutionError);
    (parcelRequire("9cIlW"))(Promise, INTERNAL, tryConvertToPromise, apiRejection, debug);
    (parcelRequire("974rV"))(Promise, INTERNAL, tryConvertToPromise, debug);
    (parcelRequire("9AKvF"))(Promise, PromiseArray, apiRejection, debug);
    (parcelRequire("lMy0l"))(Promise);
    (parcelRequire("fxINL"))(Promise);
    (parcelRequire("6BFxN"))(Promise, PromiseArray, tryConvertToPromise, INTERNAL, async, getDomain);
    Promise.Promise = Promise;
    Promise.version = "3.4.7";
    (parcelRequire("37iDz"))(Promise, PromiseArray, apiRejection, tryConvertToPromise, INTERNAL, debug);
    (parcelRequire("ifPKm"))(Promise);
    (parcelRequire("lUyBJ"))(Promise, apiRejection, tryConvertToPromise, createContext, INTERNAL, debug);
    (parcelRequire("a0oFK"))(Promise, INTERNAL, debug);
    (parcelRequire("ehX3Q"))(Promise, apiRejection, INTERNAL, tryConvertToPromise, Proxyable, debug);
    (parcelRequire("hLNAV"))(Promise);
    (parcelRequire("lFI4k"))(Promise, INTERNAL);
    (parcelRequire("12mNB"))(Promise, PromiseArray, tryConvertToPromise, apiRejection);
    (parcelRequire("ilsIA"))(Promise, INTERNAL, tryConvertToPromise, apiRejection);
    (parcelRequire("4Qilm"))(Promise, PromiseArray, apiRejection, tryConvertToPromise, INTERNAL, debug);
    (parcelRequire("lr4sX"))(Promise, PromiseArray, debug);
    (parcelRequire("8zVAW"))(Promise, PromiseArray, apiRejection);
    (parcelRequire("5begG"))(Promise, INTERNAL);
    (parcelRequire("b7rK3"))(Promise, INTERNAL);
    (parcelRequire("fLPkU"))(Promise);
    util.toFastProperties(Promise);
    util.toFastProperties(Promise.prototype);
    function fillTypes(value) {
        var p = new Promise(INTERNAL);
        p._fulfillmentHandler0 = value;
        p._rejectionHandler0 = value;
        p._promise0 = value;
        p._receiver0 = value;
    }
    // Complete slack tracking, opt out of field-type tracking and           
    // stabilize map                                                         
    fillTypes({
        a: 1
    });
    fillTypes({
        b: 2
    });
    fillTypes({
        c: 3
    });
    fillTypes(1);
    fillTypes(function() {});
    fillTypes(undefined);
    fillTypes(false);
    fillTypes(new Promise(INTERNAL));
    debug.setBounds(Async.firstLineError, util.lastLineError);
    return Promise;
};

});
parcelRegister("4TZ3D", function(module, exports) {
// shim for using process in browser
var $391ba9420d9eb0df$var$process = module.exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $391ba9420d9eb0df$var$cachedSetTimeout;
var $391ba9420d9eb0df$var$cachedClearTimeout;
function $391ba9420d9eb0df$var$defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function $391ba9420d9eb0df$var$defaultClearTimeout() {
    throw new Error('clearTimeout has not been defined');
}
(function() {
    try {
        if (typeof setTimeout === 'function') $391ba9420d9eb0df$var$cachedSetTimeout = setTimeout;
        else $391ba9420d9eb0df$var$cachedSetTimeout = $391ba9420d9eb0df$var$defaultSetTimout;
    } catch (e) {
        $391ba9420d9eb0df$var$cachedSetTimeout = $391ba9420d9eb0df$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') $391ba9420d9eb0df$var$cachedClearTimeout = clearTimeout;
        else $391ba9420d9eb0df$var$cachedClearTimeout = $391ba9420d9eb0df$var$defaultClearTimeout;
    } catch (e) {
        $391ba9420d9eb0df$var$cachedClearTimeout = $391ba9420d9eb0df$var$defaultClearTimeout;
    }
})();
function $391ba9420d9eb0df$var$runTimeout(fun) {
    if ($391ba9420d9eb0df$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($391ba9420d9eb0df$var$cachedSetTimeout === $391ba9420d9eb0df$var$defaultSetTimout || !$391ba9420d9eb0df$var$cachedSetTimeout) && setTimeout) {
        $391ba9420d9eb0df$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $391ba9420d9eb0df$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $391ba9420d9eb0df$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $391ba9420d9eb0df$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $391ba9420d9eb0df$var$runClearTimeout(marker) {
    if ($391ba9420d9eb0df$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($391ba9420d9eb0df$var$cachedClearTimeout === $391ba9420d9eb0df$var$defaultClearTimeout || !$391ba9420d9eb0df$var$cachedClearTimeout) && clearTimeout) {
        $391ba9420d9eb0df$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $391ba9420d9eb0df$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $391ba9420d9eb0df$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $391ba9420d9eb0df$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $391ba9420d9eb0df$var$queue = [];
var $391ba9420d9eb0df$var$draining = false;
var $391ba9420d9eb0df$var$currentQueue;
var $391ba9420d9eb0df$var$queueIndex = -1;
function $391ba9420d9eb0df$var$cleanUpNextTick() {
    if (!$391ba9420d9eb0df$var$draining || !$391ba9420d9eb0df$var$currentQueue) return;
    $391ba9420d9eb0df$var$draining = false;
    if ($391ba9420d9eb0df$var$currentQueue.length) $391ba9420d9eb0df$var$queue = $391ba9420d9eb0df$var$currentQueue.concat($391ba9420d9eb0df$var$queue);
    else $391ba9420d9eb0df$var$queueIndex = -1;
    if ($391ba9420d9eb0df$var$queue.length) $391ba9420d9eb0df$var$drainQueue();
}
function $391ba9420d9eb0df$var$drainQueue() {
    if ($391ba9420d9eb0df$var$draining) return;
    var timeout = $391ba9420d9eb0df$var$runTimeout($391ba9420d9eb0df$var$cleanUpNextTick);
    $391ba9420d9eb0df$var$draining = true;
    var len = $391ba9420d9eb0df$var$queue.length;
    while(len){
        $391ba9420d9eb0df$var$currentQueue = $391ba9420d9eb0df$var$queue;
        $391ba9420d9eb0df$var$queue = [];
        while(++$391ba9420d9eb0df$var$queueIndex < len)if ($391ba9420d9eb0df$var$currentQueue) $391ba9420d9eb0df$var$currentQueue[$391ba9420d9eb0df$var$queueIndex].run();
        $391ba9420d9eb0df$var$queueIndex = -1;
        len = $391ba9420d9eb0df$var$queue.length;
    }
    $391ba9420d9eb0df$var$currentQueue = null;
    $391ba9420d9eb0df$var$draining = false;
    $391ba9420d9eb0df$var$runClearTimeout(timeout);
}
$391ba9420d9eb0df$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $391ba9420d9eb0df$var$queue.push(new $391ba9420d9eb0df$var$Item(fun, args));
    if ($391ba9420d9eb0df$var$queue.length === 1 && !$391ba9420d9eb0df$var$draining) $391ba9420d9eb0df$var$runTimeout($391ba9420d9eb0df$var$drainQueue);
};
// v8 likes predictible objects
function $391ba9420d9eb0df$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$391ba9420d9eb0df$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$391ba9420d9eb0df$var$process.title = 'browser';
$391ba9420d9eb0df$var$process.browser = true;
$391ba9420d9eb0df$var$process.env = {};
$391ba9420d9eb0df$var$process.argv = [];
$391ba9420d9eb0df$var$process.version = ''; // empty string to avoid regexp issues
$391ba9420d9eb0df$var$process.versions = {};
function $391ba9420d9eb0df$var$noop() {}
$391ba9420d9eb0df$var$process.on = $391ba9420d9eb0df$var$noop;
$391ba9420d9eb0df$var$process.addListener = $391ba9420d9eb0df$var$noop;
$391ba9420d9eb0df$var$process.once = $391ba9420d9eb0df$var$noop;
$391ba9420d9eb0df$var$process.off = $391ba9420d9eb0df$var$noop;
$391ba9420d9eb0df$var$process.removeListener = $391ba9420d9eb0df$var$noop;
$391ba9420d9eb0df$var$process.removeAllListeners = $391ba9420d9eb0df$var$noop;
$391ba9420d9eb0df$var$process.emit = $391ba9420d9eb0df$var$noop;
$391ba9420d9eb0df$var$process.prependListener = $391ba9420d9eb0df$var$noop;
$391ba9420d9eb0df$var$process.prependOnceListener = $391ba9420d9eb0df$var$noop;
$391ba9420d9eb0df$var$process.listeners = function(name) {
    return [];
};
$391ba9420d9eb0df$var$process.binding = function(name) {
    throw new Error('process.binding is not supported');
};
$391ba9420d9eb0df$var$process.cwd = function() {
    return '/';
};
$391ba9420d9eb0df$var$process.chdir = function(dir) {
    throw new Error('process.chdir is not supported');
};
$391ba9420d9eb0df$var$process.umask = function() {
    return 0;
};

});

parcelRegister("hXEBa", function(module, exports) {

var $4TZ3D = parcelRequire("4TZ3D");
"use strict";

var $gK3jX = parcelRequire("gK3jX");
var $d137706287f624bb$var$canEvaluate = typeof navigator == "undefined";
var $d137706287f624bb$var$errorObj = {
    e: {}
};
var $d137706287f624bb$var$tryCatchTarget;
var $d137706287f624bb$var$globalObject = typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : typeof $parcel$global !== "undefined" ? $parcel$global : module.exports !== undefined ? module.exports : null;
function $d137706287f624bb$var$tryCatcher() {
    try {
        var target = $d137706287f624bb$var$tryCatchTarget;
        $d137706287f624bb$var$tryCatchTarget = null;
        return target.apply(this, arguments);
    } catch (e) {
        $d137706287f624bb$var$errorObj.e = e;
        return $d137706287f624bb$var$errorObj;
    }
}
function $d137706287f624bb$var$tryCatch(fn) {
    $d137706287f624bb$var$tryCatchTarget = fn;
    return $d137706287f624bb$var$tryCatcher;
}
var $d137706287f624bb$var$inherits = function(Child, Parent) {
    var hasProp = {}.hasOwnProperty;
    function T() {
        this.constructor = Child;
        this.constructor$ = Parent;
        for(var propertyName in Parent.prototype)if (hasProp.call(Parent.prototype, propertyName) && propertyName.charAt(propertyName.length - 1) !== "$") this[propertyName + "$"] = Parent.prototype[propertyName];
    }
    T.prototype = Parent.prototype;
    Child.prototype = new T();
    return Child.prototype;
};
function $d137706287f624bb$var$isPrimitive(val) {
    return val == null || val === true || val === false || typeof val === "string" || typeof val === "number";
}
function $d137706287f624bb$var$isObject(value) {
    return typeof value === "function" || typeof value === "object" && value !== null;
}
function $d137706287f624bb$var$maybeWrapAsError(maybeError) {
    if (!$d137706287f624bb$var$isPrimitive(maybeError)) return maybeError;
    return new Error($d137706287f624bb$var$safeToString(maybeError));
}
function $d137706287f624bb$var$withAppended(target, appendee) {
    var len = target.length;
    var ret = new Array(len + 1);
    var i;
    for(i = 0; i < len; ++i)ret[i] = target[i];
    ret[i] = appendee;
    return ret;
}
function $d137706287f624bb$var$getDataPropertyOrDefault(obj, key, defaultValue) {
    if ($gK3jX.isES5) {
        var desc = Object.getOwnPropertyDescriptor(obj, key);
        if (desc != null) return desc.get == null && desc.set == null ? desc.value : defaultValue;
    } else return ({}).hasOwnProperty.call(obj, key) ? obj[key] : undefined;
}
function $d137706287f624bb$var$notEnumerableProp(obj, name, value) {
    if ($d137706287f624bb$var$isPrimitive(obj)) return obj;
    var descriptor = {
        value: value,
        configurable: true,
        enumerable: false,
        writable: true
    };
    $gK3jX.defineProperty(obj, name, descriptor);
    return obj;
}
function $d137706287f624bb$var$thrower(r) {
    throw r;
}
var $d137706287f624bb$var$inheritedDataKeys = function() {
    var excludedPrototypes = [
        Array.prototype,
        Object.prototype,
        Function.prototype
    ];
    var isExcludedProto = function(val) {
        for(var i = 0; i < excludedPrototypes.length; ++i){
            if (excludedPrototypes[i] === val) return true;
        }
        return false;
    };
    if ($gK3jX.isES5) {
        var getKeys = Object.getOwnPropertyNames;
        return function(obj) {
            var ret = [];
            var visitedKeys = Object.create(null);
            while(obj != null && !isExcludedProto(obj)){
                var keys;
                try {
                    keys = getKeys(obj);
                } catch (e) {
                    return ret;
                }
                for(var i = 0; i < keys.length; ++i){
                    var key = keys[i];
                    if (visitedKeys[key]) continue;
                    visitedKeys[key] = true;
                    var desc = Object.getOwnPropertyDescriptor(obj, key);
                    if (desc != null && desc.get == null && desc.set == null) ret.push(key);
                }
                obj = $gK3jX.getPrototypeOf(obj);
            }
            return ret;
        };
    } else {
        var hasProp = {}.hasOwnProperty;
        return function(obj) {
            if (isExcludedProto(obj)) return [];
            var ret = [];
            /*jshint forin:false */ enumeration: for(var key in obj)if (hasProp.call(obj, key)) ret.push(key);
            else {
                for(var i = 0; i < excludedPrototypes.length; ++i){
                    if (hasProp.call(excludedPrototypes[i], key)) continue enumeration;
                }
                ret.push(key);
            }
            return ret;
        };
    }
}();
var $d137706287f624bb$var$thisAssignmentPattern = /this\s*\.\s*\S+\s*=/;
function $d137706287f624bb$var$isClass(fn) {
    try {
        if (typeof fn === "function") {
            var keys = $gK3jX.names(fn.prototype);
            var hasMethods = $gK3jX.isES5 && keys.length > 1;
            var hasMethodsOtherThanConstructor = keys.length > 0 && !(keys.length === 1 && keys[0] === "constructor");
            var hasThisAssignmentAndStaticMethods = $d137706287f624bb$var$thisAssignmentPattern.test(fn + "") && $gK3jX.names(fn).length > 0;
            if (hasMethods || hasMethodsOtherThanConstructor || hasThisAssignmentAndStaticMethods) return true;
        }
        return false;
    } catch (e) {
        return false;
    }
}
function $d137706287f624bb$var$toFastProperties(obj) {
    /*jshint -W027,-W055,-W031*/ function FakeConstructor() {}
    FakeConstructor.prototype = obj;
    var l = 8;
    while(l--)new FakeConstructor();
    return obj;
}
var $d137706287f624bb$var$rident = /^[a-z$_][a-z$_0-9]*$/i;
function $d137706287f624bb$var$isIdentifier(str) {
    return $d137706287f624bb$var$rident.test(str);
}
function $d137706287f624bb$var$filledRange(count, prefix, suffix) {
    var ret = new Array(count);
    for(var i = 0; i < count; ++i)ret[i] = prefix + i + suffix;
    return ret;
}
function $d137706287f624bb$var$safeToString(obj) {
    try {
        return obj + "";
    } catch (e) {
        return "[no string representation]";
    }
}
function $d137706287f624bb$var$isError(obj) {
    return obj !== null && typeof obj === "object" && typeof obj.message === "string" && typeof obj.name === "string";
}
function $d137706287f624bb$var$markAsOriginatingFromRejection(e) {
    try {
        $d137706287f624bb$var$notEnumerableProp(e, "isOperational", true);
    } catch (ignore) {}
}
function $d137706287f624bb$var$originatesFromRejection(e) {
    if (e == null) return false;
    return e instanceof Error["__BluebirdErrorTypes__"].OperationalError || e["isOperational"] === true;
}
function $d137706287f624bb$var$canAttachTrace(obj) {
    return $d137706287f624bb$var$isError(obj) && $gK3jX.propertyIsWritable(obj, "stack");
}
var $d137706287f624bb$var$ensureErrorObject = function() {
    if (!("stack" in new Error())) return function(value) {
        if ($d137706287f624bb$var$canAttachTrace(value)) return value;
        try {
            throw new Error($d137706287f624bb$var$safeToString(value));
        } catch (err) {
            return err;
        }
    };
    else return function(value) {
        if ($d137706287f624bb$var$canAttachTrace(value)) return value;
        return new Error($d137706287f624bb$var$safeToString(value));
    };
}();
function $d137706287f624bb$var$classString(obj) {
    return ({}).toString.call(obj);
}
function $d137706287f624bb$var$copyDescriptors(from, to, filter) {
    var keys = $gK3jX.names(from);
    for(var i = 0; i < keys.length; ++i){
        var key = keys[i];
        if (filter(key)) try {
            $gK3jX.defineProperty(to, key, $gK3jX.getDescriptor(from, key));
        } catch (ignore) {}
    }
}
var $d137706287f624bb$var$asArray = function(v) {
    if ($gK3jX.isArray(v)) return v;
    return null;
};
if (typeof Symbol !== "undefined" && Symbol.iterator) {
    var $d137706287f624bb$var$ArrayFrom = typeof Array.from === "function" ? function(v) {
        return Array.from(v);
    } : function(v) {
        var ret = [];
        var it = v[Symbol.iterator]();
        var itResult;
        while(!(itResult = it.next()).done)ret.push(itResult.value);
        return ret;
    };
    $d137706287f624bb$var$asArray = function(v) {
        if ($gK3jX.isArray(v)) return v;
        else if (v != null && typeof v[Symbol.iterator] === "function") return $d137706287f624bb$var$ArrayFrom(v);
        return null;
    };
}
var $d137706287f624bb$var$isNode = false;
var $d137706287f624bb$var$hasEnvVariables = false;
function $d137706287f624bb$var$env(key) {
    return $d137706287f624bb$var$hasEnvVariables ? $4TZ3D.env[key] : undefined;
}
function $d137706287f624bb$var$getNativePromise() {
    if (typeof Promise === "function") try {
        var promise = new Promise(function() {});
        if (({}).toString.call(promise) === "[object Promise]") return Promise;
    } catch (e) {}
}
function $d137706287f624bb$var$domainBind(self1, cb) {
    return self1.bind(cb);
}
var $d137706287f624bb$var$ret = {
    isClass: $d137706287f624bb$var$isClass,
    isIdentifier: $d137706287f624bb$var$isIdentifier,
    inheritedDataKeys: $d137706287f624bb$var$inheritedDataKeys,
    getDataPropertyOrDefault: $d137706287f624bb$var$getDataPropertyOrDefault,
    thrower: $d137706287f624bb$var$thrower,
    isArray: $gK3jX.isArray,
    asArray: $d137706287f624bb$var$asArray,
    notEnumerableProp: $d137706287f624bb$var$notEnumerableProp,
    isPrimitive: $d137706287f624bb$var$isPrimitive,
    isObject: $d137706287f624bb$var$isObject,
    isError: $d137706287f624bb$var$isError,
    canEvaluate: $d137706287f624bb$var$canEvaluate,
    errorObj: $d137706287f624bb$var$errorObj,
    tryCatch: $d137706287f624bb$var$tryCatch,
    inherits: $d137706287f624bb$var$inherits,
    withAppended: $d137706287f624bb$var$withAppended,
    maybeWrapAsError: $d137706287f624bb$var$maybeWrapAsError,
    toFastProperties: $d137706287f624bb$var$toFastProperties,
    filledRange: $d137706287f624bb$var$filledRange,
    toString: $d137706287f624bb$var$safeToString,
    canAttachTrace: $d137706287f624bb$var$canAttachTrace,
    ensureErrorObject: $d137706287f624bb$var$ensureErrorObject,
    originatesFromRejection: $d137706287f624bb$var$originatesFromRejection,
    markAsOriginatingFromRejection: $d137706287f624bb$var$markAsOriginatingFromRejection,
    classString: $d137706287f624bb$var$classString,
    copyDescriptors: $d137706287f624bb$var$copyDescriptors,
    hasDevTools: typeof chrome !== "undefined" && chrome && typeof chrome.loadTimes === "function",
    isNode: $d137706287f624bb$var$isNode,
    hasEnvVariables: $d137706287f624bb$var$hasEnvVariables,
    env: $d137706287f624bb$var$env,
    global: $d137706287f624bb$var$globalObject,
    getNativePromise: $d137706287f624bb$var$getNativePromise,
    domainBind: $d137706287f624bb$var$domainBind
};
$d137706287f624bb$var$ret.isRecentNode = $d137706287f624bb$var$ret.isNode && function() {
    var version = $4TZ3D.versions.node.split(".").map(Number);
    return version[0] === 0 && version[1] > 10 || version[0] > 0;
}();
if ($d137706287f624bb$var$ret.isNode) $d137706287f624bb$var$ret.toFastProperties($4TZ3D);
try {
    throw new Error();
} catch (e) {
    $d137706287f624bb$var$ret.lastLineError = e;
}
module.exports = $d137706287f624bb$var$ret;

});
parcelRegister("gK3jX", function(module, exports) {
var $c30384af80716577$var$isES5 = function() {
    "use strict";
    return this === undefined;
}();
if ($c30384af80716577$var$isES5) module.exports = {
    freeze: Object.freeze,
    defineProperty: Object.defineProperty,
    getDescriptor: Object.getOwnPropertyDescriptor,
    keys: Object.keys,
    names: Object.getOwnPropertyNames,
    getPrototypeOf: Object.getPrototypeOf,
    isArray: Array.isArray,
    isES5: $c30384af80716577$var$isES5,
    propertyIsWritable: function(obj, prop) {
        var descriptor = Object.getOwnPropertyDescriptor(obj, prop);
        return !!(!descriptor || descriptor.writable || descriptor.set);
    }
};
else {
    var $c30384af80716577$var$has = {}.hasOwnProperty;
    var $c30384af80716577$var$str = {}.toString;
    var $c30384af80716577$var$proto = {}.constructor.prototype;
    var $c30384af80716577$var$ObjectKeys = function(o) {
        var ret = [];
        for(var key in o)if ($c30384af80716577$var$has.call(o, key)) ret.push(key);
        return ret;
    };
    var $c30384af80716577$var$ObjectGetDescriptor = function(o, key) {
        return {
            value: o[key]
        };
    };
    var $c30384af80716577$var$ObjectDefineProperty = function(o, key, desc) {
        o[key] = desc.value;
        return o;
    };
    var $c30384af80716577$var$ObjectFreeze = function(obj) {
        return obj;
    };
    var $c30384af80716577$var$ObjectGetPrototypeOf = function(obj) {
        try {
            return Object(obj).constructor.prototype;
        } catch (e) {
            return $c30384af80716577$var$proto;
        }
    };
    var $c30384af80716577$var$ArrayIsArray = function(obj) {
        try {
            return $c30384af80716577$var$str.call(obj) === "[object Array]";
        } catch (e) {
            return false;
        }
    };
    module.exports = {
        isArray: $c30384af80716577$var$ArrayIsArray,
        keys: $c30384af80716577$var$ObjectKeys,
        names: $c30384af80716577$var$ObjectKeys,
        defineProperty: $c30384af80716577$var$ObjectDefineProperty,
        getDescriptor: $c30384af80716577$var$ObjectGetDescriptor,
        freeze: $c30384af80716577$var$ObjectFreeze,
        getPrototypeOf: $c30384af80716577$var$ObjectGetPrototypeOf,
        isES5: $c30384af80716577$var$isES5,
        propertyIsWritable: function() {
            return true;
        }
    };
}

});


parcelRegister("j6mSd", function(module, exports) {

var $4TZ3D = parcelRequire("4TZ3D");
"use strict";
var $de80520bc0795bf4$var$firstLineError;
try {
    throw new Error();
} catch (e) {
    $de80520bc0795bf4$var$firstLineError = e;
}

var $78noU = parcelRequire("78noU");

var $7Ugrx = parcelRequire("7Ugrx");

var $hXEBa = parcelRequire("hXEBa");
function $de80520bc0795bf4$var$Async() {
    this._customScheduler = false;
    this._isTickUsed = false;
    this._lateQueue = new $7Ugrx(16);
    this._normalQueue = new $7Ugrx(16);
    this._haveDrainedQueues = false;
    this._trampolineEnabled = true;
    var self = this;
    this.drainQueues = function() {
        self._drainQueues();
    };
    this._schedule = $78noU;
}
$de80520bc0795bf4$var$Async.prototype.setScheduler = function(fn) {
    var prev = this._schedule;
    this._schedule = fn;
    this._customScheduler = true;
    return prev;
};
$de80520bc0795bf4$var$Async.prototype.hasCustomScheduler = function() {
    return this._customScheduler;
};
$de80520bc0795bf4$var$Async.prototype.enableTrampoline = function() {
    this._trampolineEnabled = true;
};
$de80520bc0795bf4$var$Async.prototype.disableTrampolineIfNecessary = function() {
    if ($hXEBa.hasDevTools) this._trampolineEnabled = false;
};
$de80520bc0795bf4$var$Async.prototype.haveItemsQueued = function() {
    return this._isTickUsed || this._haveDrainedQueues;
};
$de80520bc0795bf4$var$Async.prototype.fatalError = function(e, isNode) {
    if (isNode) {
        $4TZ3D.stderr.write("Fatal " + (e instanceof Error ? e.stack : e) + "\n");
        $4TZ3D.exit(2);
    } else this.throwLater(e);
};
$de80520bc0795bf4$var$Async.prototype.throwLater = function(fn, arg) {
    if (arguments.length === 1) {
        arg = fn;
        fn = function() {
            throw arg;
        };
    }
    if (typeof setTimeout !== "undefined") setTimeout(function() {
        fn(arg);
    }, 0);
    else try {
        this._schedule(function() {
            fn(arg);
        });
    } catch (e) {
        throw new Error("No async scheduler available\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
    }
};
function $de80520bc0795bf4$var$AsyncInvokeLater(fn, receiver, arg) {
    this._lateQueue.push(fn, receiver, arg);
    this._queueTick();
}
function $de80520bc0795bf4$var$AsyncInvoke(fn, receiver, arg) {
    this._normalQueue.push(fn, receiver, arg);
    this._queueTick();
}
function $de80520bc0795bf4$var$AsyncSettlePromises(promise) {
    this._normalQueue._pushOne(promise);
    this._queueTick();
}
if (!$hXEBa.hasDevTools) {
    $de80520bc0795bf4$var$Async.prototype.invokeLater = $de80520bc0795bf4$var$AsyncInvokeLater;
    $de80520bc0795bf4$var$Async.prototype.invoke = $de80520bc0795bf4$var$AsyncInvoke;
    $de80520bc0795bf4$var$Async.prototype.settlePromises = $de80520bc0795bf4$var$AsyncSettlePromises;
} else {
    $de80520bc0795bf4$var$Async.prototype.invokeLater = function(fn, receiver, arg) {
        if (this._trampolineEnabled) $de80520bc0795bf4$var$AsyncInvokeLater.call(this, fn, receiver, arg);
        else this._schedule(function() {
            setTimeout(function() {
                fn.call(receiver, arg);
            }, 100);
        });
    };
    $de80520bc0795bf4$var$Async.prototype.invoke = function(fn, receiver, arg) {
        if (this._trampolineEnabled) $de80520bc0795bf4$var$AsyncInvoke.call(this, fn, receiver, arg);
        else this._schedule(function() {
            fn.call(receiver, arg);
        });
    };
    $de80520bc0795bf4$var$Async.prototype.settlePromises = function(promise) {
        if (this._trampolineEnabled) $de80520bc0795bf4$var$AsyncSettlePromises.call(this, promise);
        else this._schedule(function() {
            promise._settlePromises();
        });
    };
}
$de80520bc0795bf4$var$Async.prototype._drainQueue = function(queue) {
    while(queue.length() > 0){
        var fn = queue.shift();
        if (typeof fn !== "function") {
            fn._settlePromises();
            continue;
        }
        var receiver = queue.shift();
        var arg = queue.shift();
        fn.call(receiver, arg);
    }
};
$de80520bc0795bf4$var$Async.prototype._drainQueues = function() {
    this._drainQueue(this._normalQueue);
    this._reset();
    this._haveDrainedQueues = true;
    this._drainQueue(this._lateQueue);
};
$de80520bc0795bf4$var$Async.prototype._queueTick = function() {
    if (!this._isTickUsed) {
        this._isTickUsed = true;
        this._schedule(this.drainQueues);
    }
};
$de80520bc0795bf4$var$Async.prototype._reset = function() {
    this._isTickUsed = false;
};
module.exports = $de80520bc0795bf4$var$Async;
module.exports.firstLineError = $de80520bc0795bf4$var$firstLineError;

});
parcelRegister("78noU", function(module, exports) {

var $4TZ3D = parcelRequire("4TZ3D");
"use strict";

var $hXEBa = parcelRequire("hXEBa");
var $531b6eab24b5e2a9$var$schedule;
var $531b6eab24b5e2a9$var$noAsyncScheduler = function() {
    throw new Error("No async scheduler available\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
};
var $531b6eab24b5e2a9$var$NativePromise = $hXEBa.getNativePromise();
if ($hXEBa.isNode && typeof MutationObserver === "undefined") {
    var $531b6eab24b5e2a9$var$GlobalSetImmediate = $parcel$global.setImmediate;
    var $531b6eab24b5e2a9$var$ProcessNextTick = $4TZ3D.nextTick;
    $531b6eab24b5e2a9$var$schedule = $hXEBa.isRecentNode ? function(fn) {
        $531b6eab24b5e2a9$var$GlobalSetImmediate.call($parcel$global, fn);
    } : function(fn) {
        $531b6eab24b5e2a9$var$ProcessNextTick.call($4TZ3D, fn);
    };
} else if (typeof $531b6eab24b5e2a9$var$NativePromise === "function" && typeof $531b6eab24b5e2a9$var$NativePromise.resolve === "function") {
    var $531b6eab24b5e2a9$var$nativePromise = $531b6eab24b5e2a9$var$NativePromise.resolve();
    $531b6eab24b5e2a9$var$schedule = function(fn) {
        $531b6eab24b5e2a9$var$nativePromise.then(fn);
    };
} else if (typeof MutationObserver !== "undefined" && !(typeof window !== "undefined" && window.navigator && (window.navigator.standalone || window.cordova))) $531b6eab24b5e2a9$var$schedule = function() {
    var div = document.createElement("div");
    var opts = {
        attributes: true
    };
    var toggleScheduled = false;
    var div2 = document.createElement("div");
    var o2 = new MutationObserver(function() {
        div.classList.toggle("foo");
        toggleScheduled = false;
    });
    o2.observe(div2, opts);
    var scheduleToggle = function() {
        if (toggleScheduled) return;
        toggleScheduled = true;
        div2.classList.toggle("foo");
    };
    return function schedule(fn) {
        var o = new MutationObserver(function() {
            o.disconnect();
            fn();
        });
        o.observe(div, opts);
        scheduleToggle();
    };
}();
else if (typeof setImmediate !== "undefined") $531b6eab24b5e2a9$var$schedule = function(fn) {
    setImmediate(fn);
};
else if (typeof setTimeout !== "undefined") $531b6eab24b5e2a9$var$schedule = function(fn) {
    setTimeout(fn, 0);
};
else $531b6eab24b5e2a9$var$schedule = $531b6eab24b5e2a9$var$noAsyncScheduler;
module.exports = $531b6eab24b5e2a9$var$schedule;

});

parcelRegister("7Ugrx", function(module, exports) {
"use strict";
function $5c1a84a479439c2e$var$arrayMove(src, srcIndex, dst, dstIndex, len) {
    for(var j = 0; j < len; ++j){
        dst[j + dstIndex] = src[j + srcIndex];
        src[j + srcIndex] = void 0;
    }
}
function $5c1a84a479439c2e$var$Queue(capacity) {
    this._capacity = capacity;
    this._length = 0;
    this._front = 0;
}
$5c1a84a479439c2e$var$Queue.prototype._willBeOverCapacity = function(size) {
    return this._capacity < size;
};
$5c1a84a479439c2e$var$Queue.prototype._pushOne = function(arg) {
    var length = this.length();
    this._checkCapacity(length + 1);
    var i = this._front + length & this._capacity - 1;
    this[i] = arg;
    this._length = length + 1;
};
$5c1a84a479439c2e$var$Queue.prototype.push = function(fn, receiver, arg) {
    var length = this.length() + 3;
    if (this._willBeOverCapacity(length)) {
        this._pushOne(fn);
        this._pushOne(receiver);
        this._pushOne(arg);
        return;
    }
    var j = this._front + length - 3;
    this._checkCapacity(length);
    var wrapMask = this._capacity - 1;
    this[j + 0 & wrapMask] = fn;
    this[j + 1 & wrapMask] = receiver;
    this[j + 2 & wrapMask] = arg;
    this._length = length;
};
$5c1a84a479439c2e$var$Queue.prototype.shift = function() {
    var front = this._front, ret = this[front];
    this[front] = undefined;
    this._front = front + 1 & this._capacity - 1;
    this._length--;
    return ret;
};
$5c1a84a479439c2e$var$Queue.prototype.length = function() {
    return this._length;
};
$5c1a84a479439c2e$var$Queue.prototype._checkCapacity = function(size) {
    if (this._capacity < size) this._resizeTo(this._capacity << 1);
};
$5c1a84a479439c2e$var$Queue.prototype._resizeTo = function(capacity) {
    var oldCapacity = this._capacity;
    this._capacity = capacity;
    var front = this._front;
    var length = this._length;
    var moveItemsCount = front + length & oldCapacity - 1;
    $5c1a84a479439c2e$var$arrayMove(this, 0, this, oldCapacity, moveItemsCount);
};
module.exports = $5c1a84a479439c2e$var$Queue;

});


parcelRegister("2cTYx", function(module, exports) {
"use strict";

var $gK3jX = parcelRequire("gK3jX");
var $19b81f4cf92e709a$var$Objectfreeze = $gK3jX.freeze;

var $hXEBa = parcelRequire("hXEBa");
var $19b81f4cf92e709a$var$inherits = $hXEBa.inherits;
var $19b81f4cf92e709a$var$notEnumerableProp = $hXEBa.notEnumerableProp;
function $19b81f4cf92e709a$var$subError(nameProperty, defaultMessage) {
    function SubError(message) {
        if (!(this instanceof SubError)) return new SubError(message);
        $19b81f4cf92e709a$var$notEnumerableProp(this, "message", typeof message === "string" ? message : defaultMessage);
        $19b81f4cf92e709a$var$notEnumerableProp(this, "name", nameProperty);
        if (Error.captureStackTrace) Error.captureStackTrace(this, this.constructor);
        else Error.call(this);
    }
    $19b81f4cf92e709a$var$inherits(SubError, Error);
    return SubError;
}
var $19b81f4cf92e709a$var$_TypeError, $19b81f4cf92e709a$var$_RangeError;
var $19b81f4cf92e709a$var$Warning = $19b81f4cf92e709a$var$subError("Warning", "warning");
var $19b81f4cf92e709a$var$CancellationError = $19b81f4cf92e709a$var$subError("CancellationError", "cancellation error");
var $19b81f4cf92e709a$var$TimeoutError = $19b81f4cf92e709a$var$subError("TimeoutError", "timeout error");
var $19b81f4cf92e709a$var$AggregateError = $19b81f4cf92e709a$var$subError("AggregateError", "aggregate error");
try {
    $19b81f4cf92e709a$var$_TypeError = TypeError;
    $19b81f4cf92e709a$var$_RangeError = RangeError;
} catch (e) {
    $19b81f4cf92e709a$var$_TypeError = $19b81f4cf92e709a$var$subError("TypeError", "type error");
    $19b81f4cf92e709a$var$_RangeError = $19b81f4cf92e709a$var$subError("RangeError", "range error");
}
var $19b81f4cf92e709a$var$methods = "join pop push shift unshift slice filter forEach some every map indexOf lastIndexOf reduce reduceRight sort reverse".split(" ");
for(var $19b81f4cf92e709a$var$i = 0; $19b81f4cf92e709a$var$i < $19b81f4cf92e709a$var$methods.length; ++$19b81f4cf92e709a$var$i)if (typeof Array.prototype[$19b81f4cf92e709a$var$methods[$19b81f4cf92e709a$var$i]] === "function") $19b81f4cf92e709a$var$AggregateError.prototype[$19b81f4cf92e709a$var$methods[$19b81f4cf92e709a$var$i]] = Array.prototype[$19b81f4cf92e709a$var$methods[$19b81f4cf92e709a$var$i]];
$gK3jX.defineProperty($19b81f4cf92e709a$var$AggregateError.prototype, "length", {
    value: 0,
    configurable: false,
    writable: true,
    enumerable: true
});
$19b81f4cf92e709a$var$AggregateError.prototype["isOperational"] = true;
var $19b81f4cf92e709a$var$level = 0;
$19b81f4cf92e709a$var$AggregateError.prototype.toString = function() {
    var indent = Array($19b81f4cf92e709a$var$level * 4 + 1).join(" ");
    var ret = "\n" + indent + "AggregateError of:" + "\n";
    $19b81f4cf92e709a$var$level++;
    indent = Array($19b81f4cf92e709a$var$level * 4 + 1).join(" ");
    for(var i = 0; i < this.length; ++i){
        var str = this[i] === this ? "[Circular AggregateError]" : this[i] + "";
        var lines = str.split("\n");
        for(var j = 0; j < lines.length; ++j)lines[j] = indent + lines[j];
        str = lines.join("\n");
        ret += str + "\n";
    }
    $19b81f4cf92e709a$var$level--;
    return ret;
};
function $19b81f4cf92e709a$var$OperationalError(message) {
    if (!(this instanceof $19b81f4cf92e709a$var$OperationalError)) return new $19b81f4cf92e709a$var$OperationalError(message);
    $19b81f4cf92e709a$var$notEnumerableProp(this, "name", "OperationalError");
    $19b81f4cf92e709a$var$notEnumerableProp(this, "message", message);
    this.cause = message;
    this["isOperational"] = true;
    if (message instanceof Error) {
        $19b81f4cf92e709a$var$notEnumerableProp(this, "message", message.message);
        $19b81f4cf92e709a$var$notEnumerableProp(this, "stack", message.stack);
    } else if (Error.captureStackTrace) Error.captureStackTrace(this, this.constructor);
}
$19b81f4cf92e709a$var$inherits($19b81f4cf92e709a$var$OperationalError, Error);
var $19b81f4cf92e709a$var$errorTypes = Error["__BluebirdErrorTypes__"];
if (!$19b81f4cf92e709a$var$errorTypes) {
    $19b81f4cf92e709a$var$errorTypes = $19b81f4cf92e709a$var$Objectfreeze({
        CancellationError: $19b81f4cf92e709a$var$CancellationError,
        TimeoutError: $19b81f4cf92e709a$var$TimeoutError,
        OperationalError: $19b81f4cf92e709a$var$OperationalError,
        RejectionError: $19b81f4cf92e709a$var$OperationalError,
        AggregateError: $19b81f4cf92e709a$var$AggregateError
    });
    $gK3jX.defineProperty(Error, "__BluebirdErrorTypes__", {
        value: $19b81f4cf92e709a$var$errorTypes,
        writable: false,
        enumerable: false,
        configurable: false
    });
}
module.exports = {
    Error: Error,
    TypeError: $19b81f4cf92e709a$var$_TypeError,
    RangeError: $19b81f4cf92e709a$var$_RangeError,
    CancellationError: $19b81f4cf92e709a$var$errorTypes.CancellationError,
    OperationalError: $19b81f4cf92e709a$var$errorTypes.OperationalError,
    TimeoutError: $19b81f4cf92e709a$var$errorTypes.TimeoutError,
    AggregateError: $19b81f4cf92e709a$var$errorTypes.AggregateError,
    Warning: $19b81f4cf92e709a$var$Warning
};

});

parcelRegister("6EneY", function(module, exports) {
"use strict";

module.exports = function(Promise, INTERNAL) {
    var util = (parcelRequire("hXEBa"));
    var errorObj = util.errorObj;
    var isObject = util.isObject;
    function tryConvertToPromise(obj, context) {
        if (isObject(obj)) {
            if (obj instanceof Promise) return obj;
            var then = getThen(obj);
            if (then === errorObj) {
                if (context) context._pushContext();
                var ret = Promise.reject(then.e);
                if (context) context._popContext();
                return ret;
            } else if (typeof then === "function") {
                if (isAnyBluebirdPromise(obj)) {
                    var ret = new Promise(INTERNAL);
                    obj._then(ret._fulfill, ret._reject, undefined, ret, null);
                    return ret;
                }
                return doThenable(obj, then, context);
            }
        }
        return obj;
    }
    function doGetThen(obj) {
        return obj.then;
    }
    function getThen(obj) {
        try {
            return doGetThen(obj);
        } catch (e) {
            errorObj.e = e;
            return errorObj;
        }
    }
    var hasProp = {}.hasOwnProperty;
    function isAnyBluebirdPromise(obj) {
        try {
            return hasProp.call(obj, "_promise0");
        } catch (e) {
            return false;
        }
    }
    function doThenable(x, then, context) {
        var promise = new Promise(INTERNAL);
        var ret = promise;
        if (context) context._pushContext();
        promise._captureStackTrace();
        if (context) context._popContext();
        var synchronous = true;
        var result = util.tryCatch(then).call(x, resolve, reject);
        synchronous = false;
        if (promise && result === errorObj) {
            promise._rejectCallback(result.e, true, true);
            promise = null;
        }
        function resolve(value) {
            if (!promise) return;
            promise._resolveCallback(value);
            promise = null;
        }
        function reject(reason) {
            if (!promise) return;
            promise._rejectCallback(reason, synchronous, true);
            promise = null;
        }
        return ret;
    }
    return tryConvertToPromise;
};

});

parcelRegister("aQ62d", function(module, exports) {
"use strict";

module.exports = function(Promise, INTERNAL, tryConvertToPromise, apiRejection, Proxyable) {
    var util = (parcelRequire("hXEBa"));
    var isArray = util.isArray;
    function toResolutionValue(val) {
        switch(val){
            case -2:
                return [];
            case -3:
                return {};
        }
    }
    function PromiseArray(values) {
        var promise = this._promise = new Promise(INTERNAL);
        if (values instanceof Promise) promise._propagateFrom(values, 3);
        promise._setOnCancel(this);
        this._values = values;
        this._length = 0;
        this._totalResolved = 0;
        this._init(undefined, -2);
    }
    util.inherits(PromiseArray, Proxyable);
    PromiseArray.prototype.length = function() {
        return this._length;
    };
    PromiseArray.prototype.promise = function() {
        return this._promise;
    };
    PromiseArray.prototype._init = function init(_, resolveValueIfEmpty) {
        var values = tryConvertToPromise(this._values, this._promise);
        if (values instanceof Promise) {
            values = values._target();
            var bitField = values._bitField;
            this._values = values;
            if ((bitField & 50397184) === 0) {
                this._promise._setAsyncGuaranteed();
                return values._then(init, this._reject, undefined, this, resolveValueIfEmpty);
            } else if ((bitField & 33554432) !== 0) values = values._value();
            else if ((bitField & 16777216) !== 0) return this._reject(values._reason());
            else return this._cancel();
        }
        values = util.asArray(values);
        if (values === null) {
            var err = apiRejection("expecting an array or an iterable object but got " + util.classString(values)).reason();
            this._promise._rejectCallback(err, false);
            return;
        }
        if (values.length === 0) {
            if (resolveValueIfEmpty === -5) this._resolveEmptyArray();
            else this._resolve(toResolutionValue(resolveValueIfEmpty));
            return;
        }
        this._iterate(values);
    };
    PromiseArray.prototype._iterate = function(values) {
        var len = this.getActualLength(values.length);
        this._length = len;
        this._values = this.shouldCopyValues() ? new Array(len) : this._values;
        var result = this._promise;
        var isResolved = false;
        var bitField = null;
        for(var i = 0; i < len; ++i){
            var maybePromise = tryConvertToPromise(values[i], result);
            if (maybePromise instanceof Promise) {
                maybePromise = maybePromise._target();
                bitField = maybePromise._bitField;
            } else bitField = null;
            if (isResolved) {
                if (bitField !== null) maybePromise.suppressUnhandledRejections();
            } else if (bitField !== null) {
                if ((bitField & 50397184) === 0) {
                    maybePromise._proxy(this, i);
                    this._values[i] = maybePromise;
                } else if ((bitField & 33554432) !== 0) isResolved = this._promiseFulfilled(maybePromise._value(), i);
                else if ((bitField & 16777216) !== 0) isResolved = this._promiseRejected(maybePromise._reason(), i);
                else isResolved = this._promiseCancelled(i);
            } else isResolved = this._promiseFulfilled(maybePromise, i);
        }
        if (!isResolved) result._setAsyncGuaranteed();
    };
    PromiseArray.prototype._isResolved = function() {
        return this._values === null;
    };
    PromiseArray.prototype._resolve = function(value) {
        this._values = null;
        this._promise._fulfill(value);
    };
    PromiseArray.prototype._cancel = function() {
        if (this._isResolved() || !this._promise._isCancellable()) return;
        this._values = null;
        this._promise._cancel();
    };
    PromiseArray.prototype._reject = function(reason) {
        this._values = null;
        this._promise._rejectCallback(reason, false);
    };
    PromiseArray.prototype._promiseFulfilled = function(value, index) {
        this._values[index] = value;
        var totalResolved = ++this._totalResolved;
        if (totalResolved >= this._length) {
            this._resolve(this._values);
            return true;
        }
        return false;
    };
    PromiseArray.prototype._promiseCancelled = function() {
        this._cancel();
        return true;
    };
    PromiseArray.prototype._promiseRejected = function(reason) {
        this._totalResolved++;
        this._reject(reason);
        return true;
    };
    PromiseArray.prototype._resultCancelled = function() {
        if (this._isResolved()) return;
        var values = this._values;
        this._cancel();
        if (values instanceof Promise) values.cancel();
        else {
            for(var i = 0; i < values.length; ++i)if (values[i] instanceof Promise) values[i].cancel();
        }
    };
    PromiseArray.prototype.shouldCopyValues = function() {
        return true;
    };
    PromiseArray.prototype.getActualLength = function(len) {
        return len;
    };
    return PromiseArray;
};

});

parcelRegister("1hNea", function(module, exports) {
"use strict";
module.exports = function(Promise) {
    var longStackTraces = false;
    var contextStack = [];
    Promise.prototype._promiseCreated = function() {};
    Promise.prototype._pushContext = function() {};
    Promise.prototype._popContext = function() {
        return null;
    };
    Promise._peekContext = Promise.prototype._peekContext = function() {};
    function Context() {
        this._trace = new Context.CapturedTrace(peekContext());
    }
    Context.prototype._pushContext = function() {
        if (this._trace !== undefined) {
            this._trace._promiseCreated = null;
            contextStack.push(this._trace);
        }
    };
    Context.prototype._popContext = function() {
        if (this._trace !== undefined) {
            var trace = contextStack.pop();
            var ret = trace._promiseCreated;
            trace._promiseCreated = null;
            return ret;
        }
        return null;
    };
    function createContext() {
        if (longStackTraces) return new Context();
    }
    function peekContext() {
        var lastIndex = contextStack.length - 1;
        if (lastIndex >= 0) return contextStack[lastIndex];
        return undefined;
    }
    Context.CapturedTrace = null;
    Context.create = createContext;
    Context.deactivateLongStackTraces = function() {};
    Context.activateLongStackTraces = function() {
        var Promise_pushContext = Promise.prototype._pushContext;
        var Promise_popContext = Promise.prototype._popContext;
        var Promise_PeekContext = Promise._peekContext;
        var Promise_peekContext = Promise.prototype._peekContext;
        var Promise_promiseCreated = Promise.prototype._promiseCreated;
        Context.deactivateLongStackTraces = function() {
            Promise.prototype._pushContext = Promise_pushContext;
            Promise.prototype._popContext = Promise_popContext;
            Promise._peekContext = Promise_PeekContext;
            Promise.prototype._peekContext = Promise_peekContext;
            Promise.prototype._promiseCreated = Promise_promiseCreated;
            longStackTraces = false;
        };
        longStackTraces = true;
        Promise.prototype._pushContext = Context.prototype._pushContext;
        Promise.prototype._popContext = Context.prototype._popContext;
        Promise._peekContext = Promise.prototype._peekContext = peekContext;
        Promise.prototype._promiseCreated = function() {
            var ctx = this._peekContext();
            if (ctx && ctx._promiseCreated == null) ctx._promiseCreated = this;
        };
    };
    return Context;
};

});

parcelRegister("b3Gcj", function(module, exports) {

var $4TZ3D = parcelRequire("4TZ3D");
"use strict";


module.exports = function(Promise, Context) {
    var getDomain = Promise._getDomain;
    var async = Promise._async;
    var Warning = (parcelRequire("2cTYx")).Warning;
    var util = (parcelRequire("hXEBa"));
    var canAttachTrace = util.canAttachTrace;
    var unhandledRejectionHandled;
    var possiblyUnhandledRejection;
    var bluebirdFramePattern = /[\\\/]bluebird[\\\/]js[\\\/](release|debug|instrumented)/;
    var nodeFramePattern = /\((?:timers\.js):\d+:\d+\)/;
    var parseLinePattern = /[\/<\(](.+?):(\d+):(\d+)\)?\s*$/;
    var stackFramePattern = null;
    var formatStack = null;
    var indentStackFrames = false;
    var printWarning;
    var debugging = !!(util.env("BLUEBIRD_DEBUG") != 0 && (util.env("BLUEBIRD_DEBUG") || util.env("NODE_ENV") === "development"));
    var warnings = !!(util.env("BLUEBIRD_WARNINGS") != 0 && (debugging || util.env("BLUEBIRD_WARNINGS")));
    var longStackTraces = !!(util.env("BLUEBIRD_LONG_STACK_TRACES") != 0 && (debugging || util.env("BLUEBIRD_LONG_STACK_TRACES")));
    var wForgottenReturn = util.env("BLUEBIRD_W_FORGOTTEN_RETURN") != 0 && (warnings || !!util.env("BLUEBIRD_W_FORGOTTEN_RETURN"));
    Promise.prototype.suppressUnhandledRejections = function() {
        var target = this._target();
        target._bitField = target._bitField & -1048577 | 524288;
    };
    Promise.prototype._ensurePossibleRejectionHandled = function() {
        if ((this._bitField & 524288) !== 0) return;
        this._setRejectionIsUnhandled();
        async.invokeLater(this._notifyUnhandledRejection, this, undefined);
    };
    Promise.prototype._notifyUnhandledRejectionIsHandled = function() {
        fireRejectionEvent("rejectionHandled", unhandledRejectionHandled, undefined, this);
    };
    Promise.prototype._setReturnedNonUndefined = function() {
        this._bitField = this._bitField | 268435456;
    };
    Promise.prototype._returnedNonUndefined = function() {
        return (this._bitField & 268435456) !== 0;
    };
    Promise.prototype._notifyUnhandledRejection = function() {
        if (this._isRejectionUnhandled()) {
            var reason = this._settledValue();
            this._setUnhandledRejectionIsNotified();
            fireRejectionEvent("unhandledRejection", possiblyUnhandledRejection, reason, this);
        }
    };
    Promise.prototype._setUnhandledRejectionIsNotified = function() {
        this._bitField = this._bitField | 262144;
    };
    Promise.prototype._unsetUnhandledRejectionIsNotified = function() {
        this._bitField = this._bitField & -262145;
    };
    Promise.prototype._isUnhandledRejectionNotified = function() {
        return (this._bitField & 262144) > 0;
    };
    Promise.prototype._setRejectionIsUnhandled = function() {
        this._bitField = this._bitField | 1048576;
    };
    Promise.prototype._unsetRejectionIsUnhandled = function() {
        this._bitField = this._bitField & -1048577;
        if (this._isUnhandledRejectionNotified()) {
            this._unsetUnhandledRejectionIsNotified();
            this._notifyUnhandledRejectionIsHandled();
        }
    };
    Promise.prototype._isRejectionUnhandled = function() {
        return (this._bitField & 1048576) > 0;
    };
    Promise.prototype._warn = function(message, shouldUseOwnTrace, promise) {
        return warn(message, shouldUseOwnTrace, promise || this);
    };
    Promise.onPossiblyUnhandledRejection = function(fn) {
        var domain = getDomain();
        possiblyUnhandledRejection = typeof fn === "function" ? domain === null ? fn : util.domainBind(domain, fn) : undefined;
    };
    Promise.onUnhandledRejectionHandled = function(fn) {
        var domain = getDomain();
        unhandledRejectionHandled = typeof fn === "function" ? domain === null ? fn : util.domainBind(domain, fn) : undefined;
    };
    var disableLongStackTraces = function() {};
    Promise.longStackTraces = function() {
        if (async.haveItemsQueued() && !config.longStackTraces) throw new Error("cannot enable long stack traces after promises have been created\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
        if (!config.longStackTraces && longStackTracesIsSupported()) {
            var Promise_captureStackTrace = Promise.prototype._captureStackTrace;
            var Promise_attachExtraTrace = Promise.prototype._attachExtraTrace;
            config.longStackTraces = true;
            disableLongStackTraces = function() {
                if (async.haveItemsQueued() && !config.longStackTraces) throw new Error("cannot enable long stack traces after promises have been created\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
                Promise.prototype._captureStackTrace = Promise_captureStackTrace;
                Promise.prototype._attachExtraTrace = Promise_attachExtraTrace;
                Context.deactivateLongStackTraces();
                async.enableTrampoline();
                config.longStackTraces = false;
            };
            Promise.prototype._captureStackTrace = longStackTracesCaptureStackTrace;
            Promise.prototype._attachExtraTrace = longStackTracesAttachExtraTrace;
            Context.activateLongStackTraces();
            async.disableTrampolineIfNecessary();
        }
    };
    Promise.hasLongStackTraces = function() {
        return config.longStackTraces && longStackTracesIsSupported();
    };
    var fireDomEvent = function() {
        try {
            if (typeof CustomEvent === "function") {
                var event = new CustomEvent("CustomEvent");
                util.global.dispatchEvent(event);
                return function(name, event) {
                    var domEvent = new CustomEvent(name.toLowerCase(), {
                        detail: event,
                        cancelable: true
                    });
                    return !util.global.dispatchEvent(domEvent);
                };
            } else if (typeof Event === "function") {
                var event = new Event("CustomEvent");
                util.global.dispatchEvent(event);
                return function(name, event) {
                    var domEvent = new Event(name.toLowerCase(), {
                        cancelable: true
                    });
                    domEvent.detail = event;
                    return !util.global.dispatchEvent(domEvent);
                };
            } else {
                var event = document.createEvent("CustomEvent");
                event.initCustomEvent("testingtheevent", false, true, {});
                util.global.dispatchEvent(event);
                return function(name, event) {
                    var domEvent = document.createEvent("CustomEvent");
                    domEvent.initCustomEvent(name.toLowerCase(), false, true, event);
                    return !util.global.dispatchEvent(domEvent);
                };
            }
        } catch (e) {}
        return function() {
            return false;
        };
    }();
    var fireGlobalEvent = function() {
        if (util.isNode) return function() {
            return $4TZ3D.emit.apply($4TZ3D, arguments);
        };
        else {
            if (!util.global) return function() {
                return false;
            };
            return function(name) {
                var methodName = "on" + name.toLowerCase();
                var method = util.global[methodName];
                if (!method) return false;
                method.apply(util.global, [].slice.call(arguments, 1));
                return true;
            };
        }
    }();
    function generatePromiseLifecycleEventObject(name, promise) {
        return {
            promise: promise
        };
    }
    var eventToObjectGenerator = {
        promiseCreated: generatePromiseLifecycleEventObject,
        promiseFulfilled: generatePromiseLifecycleEventObject,
        promiseRejected: generatePromiseLifecycleEventObject,
        promiseResolved: generatePromiseLifecycleEventObject,
        promiseCancelled: generatePromiseLifecycleEventObject,
        promiseChained: function(name, promise, child) {
            return {
                promise: promise,
                child: child
            };
        },
        warning: function(name, warning) {
            return {
                warning: warning
            };
        },
        unhandledRejection: function(name, reason, promise) {
            return {
                reason: reason,
                promise: promise
            };
        },
        rejectionHandled: generatePromiseLifecycleEventObject
    };
    var activeFireEvent = function(name) {
        var globalEventFired = false;
        try {
            globalEventFired = fireGlobalEvent.apply(null, arguments);
        } catch (e) {
            async.throwLater(e);
            globalEventFired = true;
        }
        var domEventFired = false;
        try {
            domEventFired = fireDomEvent(name, eventToObjectGenerator[name].apply(null, arguments));
        } catch (e) {
            async.throwLater(e);
            domEventFired = true;
        }
        return domEventFired || globalEventFired;
    };
    Promise.config = function(opts) {
        opts = Object(opts);
        if ("longStackTraces" in opts) {
            if (opts.longStackTraces) Promise.longStackTraces();
            else if (!opts.longStackTraces && Promise.hasLongStackTraces()) disableLongStackTraces();
        }
        if ("warnings" in opts) {
            var warningsOption = opts.warnings;
            config.warnings = !!warningsOption;
            wForgottenReturn = config.warnings;
            if (util.isObject(warningsOption)) {
                if ("wForgottenReturn" in warningsOption) wForgottenReturn = !!warningsOption.wForgottenReturn;
            }
        }
        if ("cancellation" in opts && opts.cancellation && !config.cancellation) {
            if (async.haveItemsQueued()) throw new Error("cannot enable cancellation after promises are in use");
            Promise.prototype._clearCancellationData = cancellationClearCancellationData;
            Promise.prototype._propagateFrom = cancellationPropagateFrom;
            Promise.prototype._onCancel = cancellationOnCancel;
            Promise.prototype._setOnCancel = cancellationSetOnCancel;
            Promise.prototype._attachCancellationCallback = cancellationAttachCancellationCallback;
            Promise.prototype._execute = cancellationExecute;
            propagateFromFunction = cancellationPropagateFrom;
            config.cancellation = true;
        }
        if ("monitoring" in opts) {
            if (opts.monitoring && !config.monitoring) {
                config.monitoring = true;
                Promise.prototype._fireEvent = activeFireEvent;
            } else if (!opts.monitoring && config.monitoring) {
                config.monitoring = false;
                Promise.prototype._fireEvent = defaultFireEvent;
            }
        }
        return Promise;
    };
    function defaultFireEvent() {
        return false;
    }
    Promise.prototype._fireEvent = defaultFireEvent;
    Promise.prototype._execute = function(executor, resolve, reject) {
        try {
            executor(resolve, reject);
        } catch (e) {
            return e;
        }
    };
    Promise.prototype._onCancel = function() {};
    Promise.prototype._setOnCancel = function(handler) {};
    Promise.prototype._attachCancellationCallback = function(onCancel) {};
    Promise.prototype._captureStackTrace = function() {};
    Promise.prototype._attachExtraTrace = function() {};
    Promise.prototype._clearCancellationData = function() {};
    Promise.prototype._propagateFrom = function(parent, flags) {};
    function cancellationExecute(executor, resolve, reject) {
        var promise = this;
        try {
            executor(resolve, reject, function(onCancel) {
                if (typeof onCancel !== "function") throw new TypeError("onCancel must be a function, got: " + util.toString(onCancel));
                promise._attachCancellationCallback(onCancel);
            });
        } catch (e) {
            return e;
        }
    }
    function cancellationAttachCancellationCallback(onCancel) {
        if (!this._isCancellable()) return this;
        var previousOnCancel = this._onCancel();
        if (previousOnCancel !== undefined) {
            if (util.isArray(previousOnCancel)) previousOnCancel.push(onCancel);
            else this._setOnCancel([
                previousOnCancel,
                onCancel
            ]);
        } else this._setOnCancel(onCancel);
    }
    function cancellationOnCancel() {
        return this._onCancelField;
    }
    function cancellationSetOnCancel(onCancel) {
        this._onCancelField = onCancel;
    }
    function cancellationClearCancellationData() {
        this._cancellationParent = undefined;
        this._onCancelField = undefined;
    }
    function cancellationPropagateFrom(parent, flags) {
        if ((flags & 1) !== 0) {
            this._cancellationParent = parent;
            var branchesRemainingToCancel = parent._branchesRemainingToCancel;
            if (branchesRemainingToCancel === undefined) branchesRemainingToCancel = 0;
            parent._branchesRemainingToCancel = branchesRemainingToCancel + 1;
        }
        if ((flags & 2) !== 0 && parent._isBound()) this._setBoundTo(parent._boundTo);
    }
    function bindingPropagateFrom(parent, flags) {
        if ((flags & 2) !== 0 && parent._isBound()) this._setBoundTo(parent._boundTo);
    }
    var propagateFromFunction = bindingPropagateFrom;
    function boundValueFunction() {
        var ret = this._boundTo;
        if (ret !== undefined) {
            if (ret instanceof Promise) {
                if (ret.isFulfilled()) return ret.value();
                else return undefined;
            }
        }
        return ret;
    }
    function longStackTracesCaptureStackTrace() {
        this._trace = new CapturedTrace(this._peekContext());
    }
    function longStackTracesAttachExtraTrace(error, ignoreSelf) {
        if (canAttachTrace(error)) {
            var trace = this._trace;
            if (trace !== undefined) {
                if (ignoreSelf) trace = trace._parent;
            }
            if (trace !== undefined) trace.attachExtraTrace(error);
            else if (!error.__stackCleaned__) {
                var parsed = parseStackAndMessage(error);
                util.notEnumerableProp(error, "stack", parsed.message + "\n" + parsed.stack.join("\n"));
                util.notEnumerableProp(error, "__stackCleaned__", true);
            }
        }
    }
    function checkForgottenReturns(returnValue, promiseCreated, name, promise, parent) {
        if (returnValue === undefined && promiseCreated !== null && wForgottenReturn) {
            if (parent !== undefined && parent._returnedNonUndefined()) return;
            if ((promise._bitField & 65535) === 0) return;
            if (name) name = name + " ";
            var handlerLine = "";
            var creatorLine = "";
            if (promiseCreated._trace) {
                var traceLines = promiseCreated._trace.stack.split("\n");
                var stack = cleanStack(traceLines);
                for(var i = stack.length - 1; i >= 0; --i){
                    var line = stack[i];
                    if (!nodeFramePattern.test(line)) {
                        var lineMatches = line.match(parseLinePattern);
                        if (lineMatches) handlerLine = "at " + lineMatches[1] + ":" + lineMatches[2] + ":" + lineMatches[3] + " ";
                        break;
                    }
                }
                if (stack.length > 0) {
                    var firstUserLine = stack[0];
                    for(var i = 0; i < traceLines.length; ++i)if (traceLines[i] === firstUserLine) {
                        if (i > 0) creatorLine = "\n" + traceLines[i - 1];
                        break;
                    }
                }
            }
            var msg = "a promise was created in a " + name + "handler " + handlerLine + "but was not returned from it, " + "see http://goo.gl/rRqMUw" + creatorLine;
            promise._warn(msg, true, promiseCreated);
        }
    }
    function deprecated(name, replacement) {
        var message = name + " is deprecated and will be removed in a future version.";
        if (replacement) message += " Use " + replacement + " instead.";
        return warn(message);
    }
    function warn(message, shouldUseOwnTrace, promise) {
        if (!config.warnings) return;
        var warning = new Warning(message);
        var ctx;
        if (shouldUseOwnTrace) promise._attachExtraTrace(warning);
        else if (config.longStackTraces && (ctx = Promise._peekContext())) ctx.attachExtraTrace(warning);
        else {
            var parsed = parseStackAndMessage(warning);
            warning.stack = parsed.message + "\n" + parsed.stack.join("\n");
        }
        if (!activeFireEvent("warning", warning)) formatAndLogError(warning, "", true);
    }
    function reconstructStack(message, stacks) {
        for(var i = 0; i < stacks.length - 1; ++i){
            stacks[i].push("From previous event:");
            stacks[i] = stacks[i].join("\n");
        }
        if (i < stacks.length) stacks[i] = stacks[i].join("\n");
        return message + "\n" + stacks.join("\n");
    }
    function removeDuplicateOrEmptyJumps(stacks) {
        for(var i = 0; i < stacks.length; ++i)if (stacks[i].length === 0 || i + 1 < stacks.length && stacks[i][0] === stacks[i + 1][0]) {
            stacks.splice(i, 1);
            i--;
        }
    }
    function removeCommonRoots(stacks) {
        var current = stacks[0];
        for(var i = 1; i < stacks.length; ++i){
            var prev = stacks[i];
            var currentLastIndex = current.length - 1;
            var currentLastLine = current[currentLastIndex];
            var commonRootMeetPoint = -1;
            for(var j = prev.length - 1; j >= 0; --j)if (prev[j] === currentLastLine) {
                commonRootMeetPoint = j;
                break;
            }
            for(var j = commonRootMeetPoint; j >= 0; --j){
                var line = prev[j];
                if (current[currentLastIndex] === line) {
                    current.pop();
                    currentLastIndex--;
                } else break;
            }
            current = prev;
        }
    }
    function cleanStack(stack) {
        var ret = [];
        for(var i = 0; i < stack.length; ++i){
            var line = stack[i];
            var isTraceLine = "    (No stack trace)" === line || stackFramePattern.test(line);
            var isInternalFrame = isTraceLine && shouldIgnore(line);
            if (isTraceLine && !isInternalFrame) {
                if (indentStackFrames && line.charAt(0) !== " ") line = "    " + line;
                ret.push(line);
            }
        }
        return ret;
    }
    function stackFramesAsArray(error) {
        var stack = error.stack.replace(/\s+$/g, "").split("\n");
        for(var i = 0; i < stack.length; ++i){
            var line = stack[i];
            if ("    (No stack trace)" === line || stackFramePattern.test(line)) break;
        }
        if (i > 0 && error.name != "SyntaxError") stack = stack.slice(i);
        return stack;
    }
    function parseStackAndMessage(error) {
        var stack = error.stack;
        var message = error.toString();
        stack = typeof stack === "string" && stack.length > 0 ? stackFramesAsArray(error) : [
            "    (No stack trace)"
        ];
        return {
            message: message,
            stack: error.name == "SyntaxError" ? stack : cleanStack(stack)
        };
    }
    function formatAndLogError(error, title, isSoft) {
        if (typeof console !== "undefined") {
            var message;
            if (util.isObject(error)) {
                var stack = error.stack;
                message = title + formatStack(stack, error);
            } else message = title + String(error);
            if (typeof printWarning === "function") printWarning(message, isSoft);
            else if (typeof console.log === "function" || typeof console.log === "object") console.log(message);
        }
    }
    function fireRejectionEvent(name, localHandler, reason, promise) {
        var localEventFired = false;
        try {
            if (typeof localHandler === "function") {
                localEventFired = true;
                if (name === "rejectionHandled") localHandler(promise);
                else localHandler(reason, promise);
            }
        } catch (e) {
            async.throwLater(e);
        }
        if (name === "unhandledRejection") {
            if (!activeFireEvent(name, reason, promise) && !localEventFired) formatAndLogError(reason, "Unhandled rejection ");
        } else activeFireEvent(name, promise);
    }
    function formatNonError(obj) {
        var str;
        if (typeof obj === "function") str = "[function " + (obj.name || "anonymous") + "]";
        else {
            str = obj && typeof obj.toString === "function" ? obj.toString() : util.toString(obj);
            var ruselessToString = /\[object [a-zA-Z0-9$_]+\]/;
            if (ruselessToString.test(str)) try {
                var newStr = JSON.stringify(obj);
                str = newStr;
            } catch (e) {}
            if (str.length === 0) str = "(empty array)";
        }
        return "(<" + snip(str) + ">, no stack trace)";
    }
    function snip(str) {
        var maxChars = 41;
        if (str.length < maxChars) return str;
        return str.substr(0, maxChars - 3) + "...";
    }
    function longStackTracesIsSupported() {
        return typeof captureStackTrace === "function";
    }
    var shouldIgnore = function() {
        return false;
    };
    var parseLineInfoRegex = /[\/<\(]([^:\/]+):(\d+):(?:\d+)\)?\s*$/;
    function parseLineInfo(line) {
        var matches = line.match(parseLineInfoRegex);
        if (matches) return {
            fileName: matches[1],
            line: parseInt(matches[2], 10)
        };
    }
    function setBounds(firstLineError, lastLineError) {
        if (!longStackTracesIsSupported()) return;
        var firstStackLines = firstLineError.stack.split("\n");
        var lastStackLines = lastLineError.stack.split("\n");
        var firstIndex = -1;
        var lastIndex = -1;
        var firstFileName;
        var lastFileName;
        for(var i = 0; i < firstStackLines.length; ++i){
            var result = parseLineInfo(firstStackLines[i]);
            if (result) {
                firstFileName = result.fileName;
                firstIndex = result.line;
                break;
            }
        }
        for(var i = 0; i < lastStackLines.length; ++i){
            var result = parseLineInfo(lastStackLines[i]);
            if (result) {
                lastFileName = result.fileName;
                lastIndex = result.line;
                break;
            }
        }
        if (firstIndex < 0 || lastIndex < 0 || !firstFileName || !lastFileName || firstFileName !== lastFileName || firstIndex >= lastIndex) return;
        shouldIgnore = function(line) {
            if (bluebirdFramePattern.test(line)) return true;
            var info = parseLineInfo(line);
            if (info) {
                if (info.fileName === firstFileName && firstIndex <= info.line && info.line <= lastIndex) return true;
            }
            return false;
        };
    }
    function CapturedTrace(parent) {
        this._parent = parent;
        this._promisesCreated = 0;
        var length = this._length = 1 + (parent === undefined ? 0 : parent._length);
        captureStackTrace(this, CapturedTrace);
        if (length > 32) this.uncycle();
    }
    util.inherits(CapturedTrace, Error);
    Context.CapturedTrace = CapturedTrace;
    CapturedTrace.prototype.uncycle = function() {
        var length = this._length;
        if (length < 2) return;
        var nodes = [];
        var stackToIndex = {};
        for(var i = 0, node = this; node !== undefined; ++i){
            nodes.push(node);
            node = node._parent;
        }
        length = this._length = i;
        for(var i = length - 1; i >= 0; --i){
            var stack = nodes[i].stack;
            if (stackToIndex[stack] === undefined) stackToIndex[stack] = i;
        }
        for(var i = 0; i < length; ++i){
            var currentStack = nodes[i].stack;
            var index = stackToIndex[currentStack];
            if (index !== undefined && index !== i) {
                if (index > 0) {
                    nodes[index - 1]._parent = undefined;
                    nodes[index - 1]._length = 1;
                }
                nodes[i]._parent = undefined;
                nodes[i]._length = 1;
                var cycleEdgeNode = i > 0 ? nodes[i - 1] : this;
                if (index < length - 1) {
                    cycleEdgeNode._parent = nodes[index + 1];
                    cycleEdgeNode._parent.uncycle();
                    cycleEdgeNode._length = cycleEdgeNode._parent._length + 1;
                } else {
                    cycleEdgeNode._parent = undefined;
                    cycleEdgeNode._length = 1;
                }
                var currentChildLength = cycleEdgeNode._length + 1;
                for(var j = i - 2; j >= 0; --j){
                    nodes[j]._length = currentChildLength;
                    currentChildLength++;
                }
                return;
            }
        }
    };
    CapturedTrace.prototype.attachExtraTrace = function(error) {
        if (error.__stackCleaned__) return;
        this.uncycle();
        var parsed = parseStackAndMessage(error);
        var message = parsed.message;
        var stacks = [
            parsed.stack
        ];
        var trace = this;
        while(trace !== undefined){
            stacks.push(cleanStack(trace.stack.split("\n")));
            trace = trace._parent;
        }
        removeCommonRoots(stacks);
        removeDuplicateOrEmptyJumps(stacks);
        util.notEnumerableProp(error, "stack", reconstructStack(message, stacks));
        util.notEnumerableProp(error, "__stackCleaned__", true);
    };
    var captureStackTrace = function stackDetection() {
        var v8stackFramePattern = /^\s*at\s*/;
        var v8stackFormatter = function(stack, error) {
            if (typeof stack === "string") return stack;
            if (error.name !== undefined && error.message !== undefined) return error.toString();
            return formatNonError(error);
        };
        if (typeof Error.stackTraceLimit === "number" && typeof Error.captureStackTrace === "function") {
            Error.stackTraceLimit += 6;
            stackFramePattern = v8stackFramePattern;
            formatStack = v8stackFormatter;
            var captureStackTrace = Error.captureStackTrace;
            shouldIgnore = function(line) {
                return bluebirdFramePattern.test(line);
            };
            return function(receiver, ignoreUntil) {
                Error.stackTraceLimit += 6;
                captureStackTrace(receiver, ignoreUntil);
                Error.stackTraceLimit -= 6;
            };
        }
        var err = new Error();
        if (typeof err.stack === "string" && err.stack.split("\n")[0].indexOf("stackDetection@") >= 0) {
            stackFramePattern = /@/;
            formatStack = v8stackFormatter;
            indentStackFrames = true;
            return function captureStackTrace(o) {
                o.stack = new Error().stack;
            };
        }
        var hasStackAfterThrow;
        try {
            throw new Error();
        } catch (e) {
            hasStackAfterThrow = "stack" in e;
        }
        if (!("stack" in err) && hasStackAfterThrow && typeof Error.stackTraceLimit === "number") {
            stackFramePattern = v8stackFramePattern;
            formatStack = v8stackFormatter;
            return function captureStackTrace(o) {
                Error.stackTraceLimit += 6;
                try {
                    throw new Error();
                } catch (e) {
                    o.stack = e.stack;
                }
                Error.stackTraceLimit -= 6;
            };
        }
        formatStack = function(stack, error) {
            if (typeof stack === "string") return stack;
            if ((typeof error === "object" || typeof error === "function") && error.name !== undefined && error.message !== undefined) return error.toString();
            return formatNonError(error);
        };
        return null;
    }([]);
    if (typeof console !== "undefined" && typeof console.warn !== "undefined") {
        printWarning = function(message) {
            console.warn(message);
        };
        if (util.isNode && $4TZ3D.stderr.isTTY) printWarning = function(message, isSoft) {
            var color = isSoft ? "\u001b[33m" : "\u001b[31m";
            console.warn(color + message + "\u001b[0m\n");
        };
        else if (!util.isNode && typeof new Error().stack === "string") printWarning = function(message, isSoft) {
            console.warn("%c" + message, isSoft ? "color: darkorange" : "color: red");
        };
    }
    var config = {
        warnings: warnings,
        longStackTraces: false,
        cancellation: false,
        monitoring: false
    };
    if (longStackTraces) Promise.longStackTraces();
    return {
        longStackTraces: function() {
            return config.longStackTraces;
        },
        warnings: function() {
            return config.warnings;
        },
        cancellation: function() {
            return config.cancellation;
        },
        monitoring: function() {
            return config.monitoring;
        },
        propagateFromFunction: function() {
            return propagateFromFunction;
        },
        boundValueFunction: function() {
            return boundValueFunction;
        },
        checkForgottenReturns: checkForgottenReturns,
        setBounds: setBounds,
        warn: warn,
        deprecated: deprecated,
        CapturedTrace: CapturedTrace,
        fireDomEvent: fireDomEvent,
        fireGlobalEvent: fireGlobalEvent
    };
};

});

parcelRegister("kXSTn", function(module, exports) {
"use strict";

module.exports = function(Promise, tryConvertToPromise) {
    var util = (parcelRequire("hXEBa"));
    var CancellationError = Promise.CancellationError;
    var errorObj = util.errorObj;
    function PassThroughHandlerContext(promise, type, handler) {
        this.promise = promise;
        this.type = type;
        this.handler = handler;
        this.called = false;
        this.cancelPromise = null;
    }
    PassThroughHandlerContext.prototype.isFinallyHandler = function() {
        return this.type === 0;
    };
    function FinallyHandlerCancelReaction(finallyHandler) {
        this.finallyHandler = finallyHandler;
    }
    FinallyHandlerCancelReaction.prototype._resultCancelled = function() {
        checkCancel(this.finallyHandler);
    };
    function checkCancel(ctx, reason) {
        if (ctx.cancelPromise != null) {
            if (arguments.length > 1) ctx.cancelPromise._reject(reason);
            else ctx.cancelPromise._cancel();
            ctx.cancelPromise = null;
            return true;
        }
        return false;
    }
    function succeed() {
        return finallyHandler.call(this, this.promise._target()._settledValue());
    }
    function fail(reason) {
        if (checkCancel(this, reason)) return;
        errorObj.e = reason;
        return errorObj;
    }
    function finallyHandler(reasonOrValue) {
        var promise = this.promise;
        var handler = this.handler;
        if (!this.called) {
            this.called = true;
            var ret = this.isFinallyHandler() ? handler.call(promise._boundValue()) : handler.call(promise._boundValue(), reasonOrValue);
            if (ret !== undefined) {
                promise._setReturnedNonUndefined();
                var maybePromise = tryConvertToPromise(ret, promise);
                if (maybePromise instanceof Promise) {
                    if (this.cancelPromise != null) {
                        if (maybePromise._isCancelled()) {
                            var reason = new CancellationError("late cancellation observer");
                            promise._attachExtraTrace(reason);
                            errorObj.e = reason;
                            return errorObj;
                        } else if (maybePromise.isPending()) maybePromise._attachCancellationCallback(new FinallyHandlerCancelReaction(this));
                    }
                    return maybePromise._then(succeed, fail, undefined, this, undefined);
                }
            }
        }
        if (promise.isRejected()) {
            checkCancel(this);
            errorObj.e = reasonOrValue;
            return errorObj;
        } else {
            checkCancel(this);
            return reasonOrValue;
        }
    }
    Promise.prototype._passThrough = function(handler, type, success, fail) {
        if (typeof handler !== "function") return this.then();
        return this._then(success, fail, undefined, new PassThroughHandlerContext(this, type, handler), undefined);
    };
    Promise.prototype.lastly = Promise.prototype["finally"] = function(handler) {
        return this._passThrough(handler, 0, finallyHandler, finallyHandler);
    };
    Promise.prototype.tap = function(handler) {
        return this._passThrough(handler, 1, finallyHandler);
    };
    return PassThroughHandlerContext;
};

});

parcelRegister("lH3Jl", function(module, exports) {
"use strict";


module.exports = function(NEXT_FILTER) {
    var util = (parcelRequire("hXEBa"));
    var getKeys = (parcelRequire("gK3jX")).keys;
    var tryCatch = util.tryCatch;
    var errorObj = util.errorObj;
    function catchFilter(instances, cb, promise) {
        return function(e) {
            var boundTo = promise._boundValue();
            predicateLoop: for(var i = 0; i < instances.length; ++i){
                var item = instances[i];
                if (item === Error || item != null && item.prototype instanceof Error) {
                    if (e instanceof item) return tryCatch(cb).call(boundTo, e);
                } else if (typeof item === "function") {
                    var matchesPredicate = tryCatch(item).call(boundTo, e);
                    if (matchesPredicate === errorObj) return matchesPredicate;
                    else if (matchesPredicate) return tryCatch(cb).call(boundTo, e);
                } else if (util.isObject(e)) {
                    var keys = getKeys(item);
                    for(var j = 0; j < keys.length; ++j){
                        var key = keys[j];
                        if (item[key] != e[key]) continue predicateLoop;
                    }
                    return tryCatch(cb).call(boundTo, e);
                }
            }
            return NEXT_FILTER;
        };
    }
    return catchFilter;
};

});

parcelRegister("ai1Zk", function(module, exports) {
"use strict";

var $hXEBa = parcelRequire("hXEBa");
var $77dd20a0d536b2a4$var$maybeWrapAsError = $hXEBa.maybeWrapAsError;

var $2cTYx = parcelRequire("2cTYx");
var $77dd20a0d536b2a4$var$OperationalError = $2cTYx.OperationalError;

var $gK3jX = parcelRequire("gK3jX");
function $77dd20a0d536b2a4$var$isUntypedError(obj) {
    return obj instanceof Error && $gK3jX.getPrototypeOf(obj) === Error.prototype;
}
var $77dd20a0d536b2a4$var$rErrorKey = /^(?:name|message|stack|cause)$/;
function $77dd20a0d536b2a4$var$wrapAsOperationalError(obj) {
    var ret;
    if ($77dd20a0d536b2a4$var$isUntypedError(obj)) {
        ret = new $77dd20a0d536b2a4$var$OperationalError(obj);
        ret.name = obj.name;
        ret.message = obj.message;
        ret.stack = obj.stack;
        var keys = $gK3jX.keys(obj);
        for(var i = 0; i < keys.length; ++i){
            var key = keys[i];
            if (!$77dd20a0d536b2a4$var$rErrorKey.test(key)) ret[key] = obj[key];
        }
        return ret;
    }
    $hXEBa.markAsOriginatingFromRejection(obj);
    return obj;
}
function $77dd20a0d536b2a4$var$nodebackForPromise(promise, multiArgs) {
    return function(err, value) {
        if (promise === null) return;
        if (err) {
            var wrapped = $77dd20a0d536b2a4$var$wrapAsOperationalError($77dd20a0d536b2a4$var$maybeWrapAsError(err));
            promise._attachExtraTrace(wrapped);
            promise._reject(wrapped);
        } else if (!multiArgs) promise._fulfill(value);
        else {
            var $_len = arguments.length;
            var args = new Array(Math.max($_len - 1, 0));
            for(var $_i = 1; $_i < $_len; ++$_i)args[$_i - 1] = arguments[$_i];
            promise._fulfill(args);
        }
        promise = null;
    };
}
module.exports = $77dd20a0d536b2a4$var$nodebackForPromise;

});

parcelRegister("9cIlW", function(module, exports) {
"use strict";

module.exports = function(Promise, INTERNAL, tryConvertToPromise, apiRejection, debug) {
    var util = (parcelRequire("hXEBa"));
    var tryCatch = util.tryCatch;
    Promise.method = function(fn) {
        if (typeof fn !== "function") throw new Promise.TypeError("expecting a function but got " + util.classString(fn));
        return function() {
            var ret = new Promise(INTERNAL);
            ret._captureStackTrace();
            ret._pushContext();
            var value = tryCatch(fn).apply(this, arguments);
            var promiseCreated = ret._popContext();
            debug.checkForgottenReturns(value, promiseCreated, "Promise.method", ret);
            ret._resolveFromSyncValue(value);
            return ret;
        };
    };
    Promise.attempt = Promise["try"] = function(fn) {
        if (typeof fn !== "function") return apiRejection("expecting a function but got " + util.classString(fn));
        var ret = new Promise(INTERNAL);
        ret._captureStackTrace();
        ret._pushContext();
        var value;
        if (arguments.length > 1) {
            debug.deprecated("calling Promise.try with more than 1 argument");
            var arg = arguments[1];
            var ctx = arguments[2];
            value = util.isArray(arg) ? tryCatch(fn).apply(ctx, arg) : tryCatch(fn).call(ctx, arg);
        } else value = tryCatch(fn)();
        var promiseCreated = ret._popContext();
        debug.checkForgottenReturns(value, promiseCreated, "Promise.try", ret);
        ret._resolveFromSyncValue(value);
        return ret;
    };
    Promise.prototype._resolveFromSyncValue = function(value) {
        if (value === util.errorObj) this._rejectCallback(value.e, false);
        else this._resolveCallback(value, true);
    };
};

});

parcelRegister("974rV", function(module, exports) {
"use strict";
module.exports = function(Promise, INTERNAL, tryConvertToPromise, debug) {
    var calledBind = false;
    var rejectThis = function(_, e) {
        this._reject(e);
    };
    var targetRejected = function(e, context) {
        context.promiseRejectionQueued = true;
        context.bindingPromise._then(rejectThis, rejectThis, null, this, e);
    };
    var bindingResolved = function(thisArg, context) {
        if ((this._bitField & 50397184) === 0) this._resolveCallback(context.target);
    };
    var bindingRejected = function(e, context) {
        if (!context.promiseRejectionQueued) this._reject(e);
    };
    Promise.prototype.bind = function(thisArg) {
        if (!calledBind) {
            calledBind = true;
            Promise.prototype._propagateFrom = debug.propagateFromFunction();
            Promise.prototype._boundValue = debug.boundValueFunction();
        }
        var maybePromise = tryConvertToPromise(thisArg);
        var ret = new Promise(INTERNAL);
        ret._propagateFrom(this, 1);
        var target = this._target();
        ret._setBoundTo(maybePromise);
        if (maybePromise instanceof Promise) {
            var context = {
                promiseRejectionQueued: false,
                promise: ret,
                target: target,
                bindingPromise: maybePromise
            };
            target._then(INTERNAL, targetRejected, undefined, ret, context);
            maybePromise._then(bindingResolved, bindingRejected, undefined, ret, context);
            ret._setOnCancel(maybePromise);
        } else ret._resolveCallback(target);
        return ret;
    };
    Promise.prototype._setBoundTo = function(obj) {
        if (obj !== undefined) {
            this._bitField = this._bitField | 2097152;
            this._boundTo = obj;
        } else this._bitField = this._bitField & -2097153;
    };
    Promise.prototype._isBound = function() {
        return (this._bitField & 2097152) === 2097152;
    };
    Promise.bind = function(thisArg, value) {
        return Promise.resolve(value).bind(thisArg);
    };
};

});

parcelRegister("9AKvF", function(module, exports) {
"use strict";

module.exports = function(Promise, PromiseArray, apiRejection, debug) {
    var util = (parcelRequire("hXEBa"));
    var tryCatch = util.tryCatch;
    var errorObj = util.errorObj;
    var async = Promise._async;
    Promise.prototype["break"] = Promise.prototype.cancel = function() {
        if (!debug.cancellation()) return this._warn("cancellation is disabled");
        var promise = this;
        var child = promise;
        while(promise._isCancellable()){
            if (!promise._cancelBy(child)) {
                if (child._isFollowing()) child._followee().cancel();
                else child._cancelBranched();
                break;
            }
            var parent = promise._cancellationParent;
            if (parent == null || !parent._isCancellable()) {
                if (promise._isFollowing()) promise._followee().cancel();
                else promise._cancelBranched();
                break;
            } else {
                if (promise._isFollowing()) promise._followee().cancel();
                promise._setWillBeCancelled();
                child = promise;
                promise = parent;
            }
        }
    };
    Promise.prototype._branchHasCancelled = function() {
        this._branchesRemainingToCancel--;
    };
    Promise.prototype._enoughBranchesHaveCancelled = function() {
        return this._branchesRemainingToCancel === undefined || this._branchesRemainingToCancel <= 0;
    };
    Promise.prototype._cancelBy = function(canceller) {
        if (canceller === this) {
            this._branchesRemainingToCancel = 0;
            this._invokeOnCancel();
            return true;
        } else {
            this._branchHasCancelled();
            if (this._enoughBranchesHaveCancelled()) {
                this._invokeOnCancel();
                return true;
            }
        }
        return false;
    };
    Promise.prototype._cancelBranched = function() {
        if (this._enoughBranchesHaveCancelled()) this._cancel();
    };
    Promise.prototype._cancel = function() {
        if (!this._isCancellable()) return;
        this._setCancelled();
        async.invoke(this._cancelPromises, this, undefined);
    };
    Promise.prototype._cancelPromises = function() {
        if (this._length() > 0) this._settlePromises();
    };
    Promise.prototype._unsetOnCancel = function() {
        this._onCancelField = undefined;
    };
    Promise.prototype._isCancellable = function() {
        return this.isPending() && !this._isCancelled();
    };
    Promise.prototype.isCancellable = function() {
        return this.isPending() && !this.isCancelled();
    };
    Promise.prototype._doInvokeOnCancel = function(onCancelCallback, internalOnly) {
        if (util.isArray(onCancelCallback)) for(var i = 0; i < onCancelCallback.length; ++i)this._doInvokeOnCancel(onCancelCallback[i], internalOnly);
        else if (onCancelCallback !== undefined) {
            if (typeof onCancelCallback === "function") {
                if (!internalOnly) {
                    var e = tryCatch(onCancelCallback).call(this._boundValue());
                    if (e === errorObj) {
                        this._attachExtraTrace(e.e);
                        async.throwLater(e.e);
                    }
                }
            } else onCancelCallback._resultCancelled(this);
        }
    };
    Promise.prototype._invokeOnCancel = function() {
        var onCancelCallback = this._onCancel();
        this._unsetOnCancel();
        async.invoke(this._doInvokeOnCancel, this, onCancelCallback);
    };
    Promise.prototype._invokeInternalOnCancel = function() {
        if (this._isCancellable()) {
            this._doInvokeOnCancel(this._onCancel(), true);
            this._unsetOnCancel();
        }
    };
    Promise.prototype._resultCancelled = function() {
        this.cancel();
    };
};

});

parcelRegister("lMy0l", function(module, exports) {
"use strict";
module.exports = function(Promise) {
    function returner() {
        return this.value;
    }
    function thrower() {
        throw this.reason;
    }
    Promise.prototype["return"] = Promise.prototype.thenReturn = function(value) {
        if (value instanceof Promise) value.suppressUnhandledRejections();
        return this._then(returner, undefined, undefined, {
            value: value
        }, undefined);
    };
    Promise.prototype["throw"] = Promise.prototype.thenThrow = function(reason) {
        return this._then(thrower, undefined, undefined, {
            reason: reason
        }, undefined);
    };
    Promise.prototype.catchThrow = function(reason) {
        if (arguments.length <= 1) return this._then(undefined, thrower, undefined, {
            reason: reason
        }, undefined);
        else {
            var _reason = arguments[1];
            var handler = function() {
                throw _reason;
            };
            return this.caught(reason, handler);
        }
    };
    Promise.prototype.catchReturn = function(value) {
        if (arguments.length <= 1) {
            if (value instanceof Promise) value.suppressUnhandledRejections();
            return this._then(undefined, returner, undefined, {
                value: value
            }, undefined);
        } else {
            var _value = arguments[1];
            if (_value instanceof Promise) _value.suppressUnhandledRejections();
            var handler = function() {
                return _value;
            };
            return this.caught(value, handler);
        }
    };
};

});

parcelRegister("fxINL", function(module, exports) {
"use strict";
module.exports = function(Promise) {
    function PromiseInspection(promise) {
        if (promise !== undefined) {
            promise = promise._target();
            this._bitField = promise._bitField;
            this._settledValueField = promise._isFateSealed() ? promise._settledValue() : undefined;
        } else {
            this._bitField = 0;
            this._settledValueField = undefined;
        }
    }
    PromiseInspection.prototype._settledValue = function() {
        return this._settledValueField;
    };
    var value = PromiseInspection.prototype.value = function() {
        if (!this.isFulfilled()) throw new TypeError("cannot get fulfillment value of a non-fulfilled promise\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
        return this._settledValue();
    };
    var reason = PromiseInspection.prototype.error = PromiseInspection.prototype.reason = function() {
        if (!this.isRejected()) throw new TypeError("cannot get rejection reason of a non-rejected promise\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
        return this._settledValue();
    };
    var isFulfilled = PromiseInspection.prototype.isFulfilled = function() {
        return (this._bitField & 33554432) !== 0;
    };
    var isRejected = PromiseInspection.prototype.isRejected = function() {
        return (this._bitField & 16777216) !== 0;
    };
    var isPending = PromiseInspection.prototype.isPending = function() {
        return (this._bitField & 50397184) === 0;
    };
    var isResolved = PromiseInspection.prototype.isResolved = function() {
        return (this._bitField & 50331648) !== 0;
    };
    PromiseInspection.prototype.isCancelled = function() {
        return (this._bitField & 8454144) !== 0;
    };
    Promise.prototype.__isCancelled = function() {
        return (this._bitField & 65536) === 65536;
    };
    Promise.prototype._isCancelled = function() {
        return this._target().__isCancelled();
    };
    Promise.prototype.isCancelled = function() {
        return (this._target()._bitField & 8454144) !== 0;
    };
    Promise.prototype.isPending = function() {
        return isPending.call(this._target());
    };
    Promise.prototype.isRejected = function() {
        return isRejected.call(this._target());
    };
    Promise.prototype.isFulfilled = function() {
        return isFulfilled.call(this._target());
    };
    Promise.prototype.isResolved = function() {
        return isResolved.call(this._target());
    };
    Promise.prototype.value = function() {
        return value.call(this._target());
    };
    Promise.prototype.reason = function() {
        var target = this._target();
        target._unsetRejectionIsUnhandled();
        return reason.call(target);
    };
    Promise.prototype._value = function() {
        return this._settledValue();
    };
    Promise.prototype._reason = function() {
        this._unsetRejectionIsUnhandled();
        return this._settledValue();
    };
    Promise.PromiseInspection = PromiseInspection;
};

});

parcelRegister("6BFxN", function(module, exports) {
"use strict";

module.exports = function(Promise, PromiseArray, tryConvertToPromise, INTERNAL, async, getDomain) {
    var util = (parcelRequire("hXEBa"));
    var canEvaluate = util.canEvaluate;
    var tryCatch = util.tryCatch;
    var errorObj = util.errorObj;
    var reject;
    if (canEvaluate) {
        var thenCallback = function(i) {
            return new Function("value", "holder", "                             \n\
            'use strict';                                                    \n\
            holder.pIndex = value;                                           \n\
            holder.checkFulfillment(this);                                   \n\
            ".replace(/Index/g, i));
        };
        var promiseSetter = function(i) {
            return new Function("promise", "holder", "                           \n\
            'use strict';                                                    \n\
            holder.pIndex = promise;                                         \n\
            ".replace(/Index/g, i));
        };
        var generateHolderClass = function(total) {
            var props = new Array(total);
            for(var i = 0; i < props.length; ++i)props[i] = "this.p" + (i + 1);
            var assignment = props.join(" = ") + " = null;";
            var cancellationCode = "var promise;\n" + props.map(function(prop) {
                return "                                                         \n\
                promise = " + prop + ";                                      \n\
                if (promise instanceof Promise) {                            \n\
                    promise.cancel();                                        \n\
                }                                                            \n\
            ";
            }).join("\n");
            var passedArguments = props.join(", ");
            var name = "Holder$" + total;
            var code = "return function(tryCatch, errorObj, Promise, async) {    \n\
            'use strict';                                                    \n\
            function [TheName](fn) {                                         \n\
                [TheProperties]                                              \n\
                this.fn = fn;                                                \n\
                this.asyncNeeded = true;                                     \n\
                this.now = 0;                                                \n\
            }                                                                \n\
                                                                             \n\
            [TheName].prototype._callFunction = function(promise) {          \n\
                promise._pushContext();                                      \n\
                var ret = tryCatch(this.fn)([ThePassedArguments]);           \n\
                promise._popContext();                                       \n\
                if (ret === errorObj) {                                      \n\
                    promise._rejectCallback(ret.e, false);                   \n\
                } else {                                                     \n\
                    promise._resolveCallback(ret);                           \n\
                }                                                            \n\
            };                                                               \n\
                                                                             \n\
            [TheName].prototype.checkFulfillment = function(promise) {       \n\
                var now = ++this.now;                                        \n\
                if (now === [TheTotal]) {                                    \n\
                    if (this.asyncNeeded) {                                  \n\
                        async.invoke(this._callFunction, this, promise);     \n\
                    } else {                                                 \n\
                        this._callFunction(promise);                         \n\
                    }                                                        \n\
                                                                             \n\
                }                                                            \n\
            };                                                               \n\
                                                                             \n\
            [TheName].prototype._resultCancelled = function() {              \n\
                [CancellationCode]                                           \n\
            };                                                               \n\
                                                                             \n\
            return [TheName];                                                \n\
        }(tryCatch, errorObj, Promise, async);                               \n\
        ";
            code = code.replace(/\[TheName\]/g, name).replace(/\[TheTotal\]/g, total).replace(/\[ThePassedArguments\]/g, passedArguments).replace(/\[TheProperties\]/g, assignment).replace(/\[CancellationCode\]/g, cancellationCode);
            return new Function("tryCatch", "errorObj", "Promise", "async", code)(tryCatch, errorObj, Promise, async);
        };
        var holderClasses = [];
        var thenCallbacks = [];
        var promiseSetters = [];
        for(var i = 0; i < 8; ++i){
            holderClasses.push(generateHolderClass(i + 1));
            thenCallbacks.push(thenCallback(i + 1));
            promiseSetters.push(promiseSetter(i + 1));
        }
        reject = function(reason) {
            this._reject(reason);
        };
    }
    Promise.join = function() {
        var last = arguments.length - 1;
        var fn;
        if (last > 0 && typeof arguments[last] === "function") {
            fn = arguments[last];
            if (last <= 8 && canEvaluate) {
                var ret = new Promise(INTERNAL);
                ret._captureStackTrace();
                var HolderClass = holderClasses[last - 1];
                var holder = new HolderClass(fn);
                var callbacks = thenCallbacks;
                for(var i = 0; i < last; ++i){
                    var maybePromise = tryConvertToPromise(arguments[i], ret);
                    if (maybePromise instanceof Promise) {
                        maybePromise = maybePromise._target();
                        var bitField = maybePromise._bitField;
                        if ((bitField & 50397184) === 0) {
                            maybePromise._then(callbacks[i], reject, undefined, ret, holder);
                            promiseSetters[i](maybePromise, holder);
                            holder.asyncNeeded = false;
                        } else if ((bitField & 33554432) !== 0) callbacks[i].call(ret, maybePromise._value(), holder);
                        else if ((bitField & 16777216) !== 0) ret._reject(maybePromise._reason());
                        else ret._cancel();
                    } else callbacks[i].call(ret, maybePromise, holder);
                }
                if (!ret._isFateSealed()) {
                    if (holder.asyncNeeded) {
                        var domain = getDomain();
                        if (domain !== null) holder.fn = util.domainBind(domain, holder.fn);
                    }
                    ret._setAsyncGuaranteed();
                    ret._setOnCancel(holder);
                }
                return ret;
            }
        }
        var $_len = arguments.length;
        var args = new Array($_len);
        for(var $_i = 0; $_i < $_len; ++$_i)args[$_i] = arguments[$_i];
        if (fn) args.pop();
        var ret = new PromiseArray(args).promise();
        return fn !== undefined ? ret.spread(fn) : ret;
    };
};

});

parcelRegister("37iDz", function(module, exports) {
"use strict";

module.exports = function(Promise, PromiseArray, apiRejection, tryConvertToPromise, INTERNAL, debug) {
    var getDomain = Promise._getDomain;
    var util = (parcelRequire("hXEBa"));
    var tryCatch = util.tryCatch;
    var errorObj = util.errorObj;
    var async = Promise._async;
    function MappingPromiseArray(promises, fn, limit, _filter) {
        this.constructor$(promises);
        this._promise._captureStackTrace();
        var domain = getDomain();
        this._callback = domain === null ? fn : util.domainBind(domain, fn);
        this._preservedValues = _filter === INTERNAL ? new Array(this.length()) : null;
        this._limit = limit;
        this._inFlight = 0;
        this._queue = [];
        async.invoke(this._asyncInit, this, undefined);
    }
    util.inherits(MappingPromiseArray, PromiseArray);
    MappingPromiseArray.prototype._asyncInit = function() {
        this._init$(undefined, -2);
    };
    MappingPromiseArray.prototype._init = function() {};
    MappingPromiseArray.prototype._promiseFulfilled = function(value, index) {
        var values = this._values;
        var length = this.length();
        var preservedValues = this._preservedValues;
        var limit = this._limit;
        if (index < 0) {
            index = index * -1 - 1;
            values[index] = value;
            if (limit >= 1) {
                this._inFlight--;
                this._drainQueue();
                if (this._isResolved()) return true;
            }
        } else {
            if (limit >= 1 && this._inFlight >= limit) {
                values[index] = value;
                this._queue.push(index);
                return false;
            }
            if (preservedValues !== null) preservedValues[index] = value;
            var promise = this._promise;
            var callback = this._callback;
            var receiver = promise._boundValue();
            promise._pushContext();
            var ret = tryCatch(callback).call(receiver, value, index, length);
            var promiseCreated = promise._popContext();
            debug.checkForgottenReturns(ret, promiseCreated, preservedValues !== null ? "Promise.filter" : "Promise.map", promise);
            if (ret === errorObj) {
                this._reject(ret.e);
                return true;
            }
            var maybePromise = tryConvertToPromise(ret, this._promise);
            if (maybePromise instanceof Promise) {
                maybePromise = maybePromise._target();
                var bitField = maybePromise._bitField;
                if ((bitField & 50397184) === 0) {
                    if (limit >= 1) this._inFlight++;
                    values[index] = maybePromise;
                    maybePromise._proxy(this, (index + 1) * -1);
                    return false;
                } else if ((bitField & 33554432) !== 0) ret = maybePromise._value();
                else if ((bitField & 16777216) !== 0) {
                    this._reject(maybePromise._reason());
                    return true;
                } else {
                    this._cancel();
                    return true;
                }
            }
            values[index] = ret;
        }
        var totalResolved = ++this._totalResolved;
        if (totalResolved >= length) {
            if (preservedValues !== null) this._filter(values, preservedValues);
            else this._resolve(values);
            return true;
        }
        return false;
    };
    MappingPromiseArray.prototype._drainQueue = function() {
        var queue = this._queue;
        var limit = this._limit;
        var values = this._values;
        while(queue.length > 0 && this._inFlight < limit){
            if (this._isResolved()) return;
            var index = queue.pop();
            this._promiseFulfilled(values[index], index);
        }
    };
    MappingPromiseArray.prototype._filter = function(booleans, values) {
        var len = values.length;
        var ret = new Array(len);
        var j = 0;
        for(var i = 0; i < len; ++i)if (booleans[i]) ret[j++] = values[i];
        ret.length = j;
        this._resolve(ret);
    };
    MappingPromiseArray.prototype.preservedValues = function() {
        return this._preservedValues;
    };
    function map(promises, fn, options, _filter) {
        if (typeof fn !== "function") return apiRejection("expecting a function but got " + util.classString(fn));
        var limit = 0;
        if (options !== undefined) {
            if (typeof options === "object" && options !== null) {
                if (typeof options.concurrency !== "number") return Promise.reject(new TypeError("'concurrency' must be a number but it is " + util.classString(options.concurrency)));
                limit = options.concurrency;
            } else return Promise.reject(new TypeError("options argument must be an object but it is " + util.classString(options)));
        }
        limit = typeof limit === "number" && isFinite(limit) && limit >= 1 ? limit : 0;
        return new MappingPromiseArray(promises, fn, limit, _filter).promise();
    }
    Promise.prototype.map = function(fn, options) {
        return map(this, fn, options, null);
    };
    Promise.map = function(promises, fn, options, _filter) {
        return map(promises, fn, options, _filter);
    };
};

});

parcelRegister("ifPKm", function(module, exports) {
"use strict";
var $d4a1c484b63b68a4$var$cr = Object.create;
if ($d4a1c484b63b68a4$var$cr) {
    var $d4a1c484b63b68a4$var$callerCache = $d4a1c484b63b68a4$var$cr(null);
    var $d4a1c484b63b68a4$var$getterCache = $d4a1c484b63b68a4$var$cr(null);
    $d4a1c484b63b68a4$var$callerCache[" size"] = $d4a1c484b63b68a4$var$getterCache[" size"] = 0;
}

module.exports = function(Promise) {
    var util = (parcelRequire("hXEBa"));
    var canEvaluate = util.canEvaluate;
    var isIdentifier = util.isIdentifier;
    var getMethodCaller;
    var getGetter;
    var makeMethodCaller = function(methodName) {
        return new Function("ensureMethod", "                                    \n\
        return function(obj) {                                               \n\
            'use strict'                                                     \n\
            var len = this.length;                                           \n\
            ensureMethod(obj, 'methodName');                                 \n\
            switch(len) {                                                    \n\
                case 1: return obj.methodName(this[0]);                      \n\
                case 2: return obj.methodName(this[0], this[1]);             \n\
                case 3: return obj.methodName(this[0], this[1], this[2]);    \n\
                case 0: return obj.methodName();                             \n\
                default:                                                     \n\
                    return obj.methodName.apply(obj, this);                  \n\
            }                                                                \n\
        };                                                                   \n\
        ".replace(/methodName/g, methodName))(ensureMethod);
    };
    var makeGetter = function(propertyName) {
        return new Function("obj", "                                             \n\
        'use strict';                                                        \n\
        return obj.propertyName;                                             \n\
        ".replace("propertyName", propertyName));
    };
    var getCompiled = function(name, compiler, cache) {
        var ret = cache[name];
        if (typeof ret !== "function") {
            if (!isIdentifier(name)) return null;
            ret = compiler(name);
            cache[name] = ret;
            cache[" size"]++;
            if (cache[" size"] > 512) {
                var keys = Object.keys(cache);
                for(var i = 0; i < 256; ++i)delete cache[keys[i]];
                cache[" size"] = keys.length - 256;
            }
        }
        return ret;
    };
    getMethodCaller = function(name) {
        return getCompiled(name, makeMethodCaller, $d4a1c484b63b68a4$var$callerCache);
    };
    getGetter = function(name) {
        return getCompiled(name, makeGetter, $d4a1c484b63b68a4$var$getterCache);
    };
    function ensureMethod(obj, methodName) {
        var fn;
        if (obj != null) fn = obj[methodName];
        if (typeof fn !== "function") {
            var message = "Object " + util.classString(obj) + " has no method '" + util.toString(methodName) + "'";
            throw new Promise.TypeError(message);
        }
        return fn;
    }
    function caller(obj) {
        var methodName = this.pop();
        var fn = ensureMethod(obj, methodName);
        return fn.apply(obj, this);
    }
    Promise.prototype.call = function(methodName) {
        var $_len = arguments.length;
        var args = new Array(Math.max($_len - 1, 0));
        for(var $_i = 1; $_i < $_len; ++$_i)args[$_i - 1] = arguments[$_i];
        if (canEvaluate) {
            var maybeCaller = getMethodCaller(methodName);
            if (maybeCaller !== null) return this._then(maybeCaller, undefined, undefined, args, undefined);
        }
        args.push(methodName);
        return this._then(caller, undefined, undefined, args, undefined);
    };
    function namedGetter(obj) {
        return obj[this];
    }
    function indexedGetter(obj) {
        var index = +this;
        if (index < 0) index = Math.max(0, index + obj.length);
        return obj[index];
    }
    Promise.prototype.get = function(propertyName) {
        var isIndex = typeof propertyName === "number";
        var getter;
        if (!isIndex) {
            if (canEvaluate) {
                var maybeGetter = getGetter(propertyName);
                getter = maybeGetter !== null ? maybeGetter : namedGetter;
            } else getter = namedGetter;
        } else getter = indexedGetter;
        return this._then(getter, undefined, undefined, propertyName, undefined);
    };
};

});

parcelRegister("lUyBJ", function(module, exports) {
"use strict";



module.exports = function(Promise, apiRejection, tryConvertToPromise, createContext, INTERNAL, debug) {
    var util = (parcelRequire("hXEBa"));
    var TypeError = (parcelRequire("2cTYx")).TypeError;
    var inherits = (parcelRequire("hXEBa")).inherits;
    var errorObj = util.errorObj;
    var tryCatch = util.tryCatch;
    var NULL = {};
    function thrower(e) {
        setTimeout(function() {
            throw e;
        }, 0);
    }
    function castPreservingDisposable(thenable) {
        var maybePromise = tryConvertToPromise(thenable);
        if (maybePromise !== thenable && typeof thenable._isDisposable === "function" && typeof thenable._getDisposer === "function" && thenable._isDisposable()) maybePromise._setDisposable(thenable._getDisposer());
        return maybePromise;
    }
    function dispose(resources, inspection) {
        var i = 0;
        var len = resources.length;
        var ret = new Promise(INTERNAL);
        function iterator() {
            if (i >= len) return ret._fulfill();
            var maybePromise = castPreservingDisposable(resources[i++]);
            if (maybePromise instanceof Promise && maybePromise._isDisposable()) {
                try {
                    maybePromise = tryConvertToPromise(maybePromise._getDisposer().tryDispose(inspection), resources.promise);
                } catch (e) {
                    return thrower(e);
                }
                if (maybePromise instanceof Promise) return maybePromise._then(iterator, thrower, null, null, null);
            }
            iterator();
        }
        iterator();
        return ret;
    }
    function Disposer(data, promise, context) {
        this._data = data;
        this._promise = promise;
        this._context = context;
    }
    Disposer.prototype.data = function() {
        return this._data;
    };
    Disposer.prototype.promise = function() {
        return this._promise;
    };
    Disposer.prototype.resource = function() {
        if (this.promise().isFulfilled()) return this.promise().value();
        return NULL;
    };
    Disposer.prototype.tryDispose = function(inspection) {
        var resource = this.resource();
        var context = this._context;
        if (context !== undefined) context._pushContext();
        var ret = resource !== NULL ? this.doDispose(resource, inspection) : null;
        if (context !== undefined) context._popContext();
        this._promise._unsetDisposable();
        this._data = null;
        return ret;
    };
    Disposer.isDisposer = function(d) {
        return d != null && typeof d.resource === "function" && typeof d.tryDispose === "function";
    };
    function FunctionDisposer(fn, promise, context) {
        this.constructor$(fn, promise, context);
    }
    inherits(FunctionDisposer, Disposer);
    FunctionDisposer.prototype.doDispose = function(resource, inspection) {
        var fn = this.data();
        return fn.call(resource, resource, inspection);
    };
    function maybeUnwrapDisposer(value) {
        if (Disposer.isDisposer(value)) {
            this.resources[this.index]._setDisposable(value);
            return value.promise();
        }
        return value;
    }
    function ResourceList(length) {
        this.length = length;
        this.promise = null;
        this[length - 1] = null;
    }
    ResourceList.prototype._resultCancelled = function() {
        var len = this.length;
        for(var i = 0; i < len; ++i){
            var item = this[i];
            if (item instanceof Promise) item.cancel();
        }
    };
    Promise.using = function() {
        var len = arguments.length;
        if (len < 2) return apiRejection("you must pass at least 2 arguments to Promise.using");
        var fn = arguments[len - 1];
        if (typeof fn !== "function") return apiRejection("expecting a function but got " + util.classString(fn));
        var input;
        var spreadArgs = true;
        if (len === 2 && Array.isArray(arguments[0])) {
            input = arguments[0];
            len = input.length;
            spreadArgs = false;
        } else {
            input = arguments;
            len--;
        }
        var resources = new ResourceList(len);
        for(var i = 0; i < len; ++i){
            var resource = input[i];
            if (Disposer.isDisposer(resource)) {
                var disposer = resource;
                resource = resource.promise();
                resource._setDisposable(disposer);
            } else {
                var maybePromise = tryConvertToPromise(resource);
                if (maybePromise instanceof Promise) resource = maybePromise._then(maybeUnwrapDisposer, null, null, {
                    resources: resources,
                    index: i
                }, undefined);
            }
            resources[i] = resource;
        }
        var reflectedResources = new Array(resources.length);
        for(var i = 0; i < reflectedResources.length; ++i)reflectedResources[i] = Promise.resolve(resources[i]).reflect();
        var resultPromise = Promise.all(reflectedResources).then(function(inspections) {
            for(var i = 0; i < inspections.length; ++i){
                var inspection = inspections[i];
                if (inspection.isRejected()) {
                    errorObj.e = inspection.error();
                    return errorObj;
                } else if (!inspection.isFulfilled()) {
                    resultPromise.cancel();
                    return;
                }
                inspections[i] = inspection.value();
            }
            promise._pushContext();
            fn = tryCatch(fn);
            var ret = spreadArgs ? fn.apply(undefined, inspections) : fn(inspections);
            var promiseCreated = promise._popContext();
            debug.checkForgottenReturns(ret, promiseCreated, "Promise.using", promise);
            return ret;
        });
        var promise = resultPromise.lastly(function() {
            var inspection = new Promise.PromiseInspection(resultPromise);
            return dispose(resources, inspection);
        });
        resources.promise = promise;
        promise._setOnCancel(resources);
        return promise;
    };
    Promise.prototype._setDisposable = function(disposer) {
        this._bitField = this._bitField | 131072;
        this._disposer = disposer;
    };
    Promise.prototype._isDisposable = function() {
        return (this._bitField & 131072) > 0;
    };
    Promise.prototype._getDisposer = function() {
        return this._disposer;
    };
    Promise.prototype._unsetDisposable = function() {
        this._bitField = this._bitField & -131073;
        this._disposer = undefined;
    };
    Promise.prototype.disposer = function(fn) {
        if (typeof fn === "function") return new FunctionDisposer(fn, this, createContext());
        throw new TypeError();
    };
};

});

parcelRegister("a0oFK", function(module, exports) {
"use strict";

module.exports = function(Promise, INTERNAL, debug) {
    var util = (parcelRequire("hXEBa"));
    var TimeoutError = Promise.TimeoutError;
    function HandleWrapper(handle) {
        this.handle = handle;
    }
    HandleWrapper.prototype._resultCancelled = function() {
        clearTimeout(this.handle);
    };
    var afterValue = function(value) {
        return delay(+this).thenReturn(value);
    };
    var delay = Promise.delay = function(ms, value) {
        var ret;
        var handle;
        if (value !== undefined) {
            ret = Promise.resolve(value)._then(afterValue, null, null, ms, undefined);
            if (debug.cancellation() && value instanceof Promise) ret._setOnCancel(value);
        } else {
            ret = new Promise(INTERNAL);
            handle = setTimeout(function() {
                ret._fulfill();
            }, +ms);
            if (debug.cancellation()) ret._setOnCancel(new HandleWrapper(handle));
            ret._captureStackTrace();
        }
        ret._setAsyncGuaranteed();
        return ret;
    };
    Promise.prototype.delay = function(ms) {
        return delay(ms, this);
    };
    var afterTimeout = function(promise, message, parent) {
        var err;
        if (typeof message !== "string") {
            if (message instanceof Error) err = message;
            else err = new TimeoutError("operation timed out");
        } else err = new TimeoutError(message);
        util.markAsOriginatingFromRejection(err);
        promise._attachExtraTrace(err);
        promise._reject(err);
        if (parent != null) parent.cancel();
    };
    function successClear(value) {
        clearTimeout(this.handle);
        return value;
    }
    function failureClear(reason) {
        clearTimeout(this.handle);
        throw reason;
    }
    Promise.prototype.timeout = function(ms, message) {
        ms = +ms;
        var ret, parent;
        var handleWrapper = new HandleWrapper(setTimeout(function timeoutTimeout() {
            if (ret.isPending()) afterTimeout(ret, message, parent);
        }, ms));
        if (debug.cancellation()) {
            parent = this.then();
            ret = parent._then(successClear, failureClear, undefined, handleWrapper, undefined);
            ret._setOnCancel(handleWrapper);
        } else ret = this._then(successClear, failureClear, undefined, handleWrapper, undefined);
        return ret;
    };
};

});

parcelRegister("ehX3Q", function(module, exports) {
"use strict";


module.exports = function(Promise, apiRejection, INTERNAL, tryConvertToPromise, Proxyable, debug) {
    var errors = (parcelRequire("2cTYx"));
    var TypeError = errors.TypeError;
    var util = (parcelRequire("hXEBa"));
    var errorObj = util.errorObj;
    var tryCatch = util.tryCatch;
    var yieldHandlers = [];
    function promiseFromYieldHandler(value, yieldHandlers, traceParent) {
        for(var i = 0; i < yieldHandlers.length; ++i){
            traceParent._pushContext();
            var result = tryCatch(yieldHandlers[i])(value);
            traceParent._popContext();
            if (result === errorObj) {
                traceParent._pushContext();
                var ret = Promise.reject(errorObj.e);
                traceParent._popContext();
                return ret;
            }
            var maybePromise = tryConvertToPromise(result, traceParent);
            if (maybePromise instanceof Promise) return maybePromise;
        }
        return null;
    }
    function PromiseSpawn(generatorFunction, receiver, yieldHandler, stack) {
        if (debug.cancellation()) {
            var internal = new Promise(INTERNAL);
            var _finallyPromise = this._finallyPromise = new Promise(INTERNAL);
            this._promise = internal.lastly(function() {
                return _finallyPromise;
            });
            internal._captureStackTrace();
            internal._setOnCancel(this);
        } else {
            var promise = this._promise = new Promise(INTERNAL);
            promise._captureStackTrace();
        }
        this._stack = stack;
        this._generatorFunction = generatorFunction;
        this._receiver = receiver;
        this._generator = undefined;
        this._yieldHandlers = typeof yieldHandler === "function" ? [
            yieldHandler
        ].concat(yieldHandlers) : yieldHandlers;
        this._yieldedPromise = null;
        this._cancellationPhase = false;
    }
    util.inherits(PromiseSpawn, Proxyable);
    PromiseSpawn.prototype._isResolved = function() {
        return this._promise === null;
    };
    PromiseSpawn.prototype._cleanup = function() {
        this._promise = this._generator = null;
        if (debug.cancellation() && this._finallyPromise !== null) {
            this._finallyPromise._fulfill();
            this._finallyPromise = null;
        }
    };
    PromiseSpawn.prototype._promiseCancelled = function() {
        if (this._isResolved()) return;
        var implementsReturn = typeof this._generator["return"] !== "undefined";
        var result;
        if (!implementsReturn) {
            var reason = new Promise.CancellationError("generator .return() sentinel");
            Promise.coroutine.returnSentinel = reason;
            this._promise._attachExtraTrace(reason);
            this._promise._pushContext();
            result = tryCatch(this._generator["throw"]).call(this._generator, reason);
            this._promise._popContext();
        } else {
            this._promise._pushContext();
            result = tryCatch(this._generator["return"]).call(this._generator, undefined);
            this._promise._popContext();
        }
        this._cancellationPhase = true;
        this._yieldedPromise = null;
        this._continue(result);
    };
    PromiseSpawn.prototype._promiseFulfilled = function(value) {
        this._yieldedPromise = null;
        this._promise._pushContext();
        var result = tryCatch(this._generator.next).call(this._generator, value);
        this._promise._popContext();
        this._continue(result);
    };
    PromiseSpawn.prototype._promiseRejected = function(reason) {
        this._yieldedPromise = null;
        this._promise._attachExtraTrace(reason);
        this._promise._pushContext();
        var result = tryCatch(this._generator["throw"]).call(this._generator, reason);
        this._promise._popContext();
        this._continue(result);
    };
    PromiseSpawn.prototype._resultCancelled = function() {
        if (this._yieldedPromise instanceof Promise) {
            var promise = this._yieldedPromise;
            this._yieldedPromise = null;
            promise.cancel();
        }
    };
    PromiseSpawn.prototype.promise = function() {
        return this._promise;
    };
    PromiseSpawn.prototype._run = function() {
        this._generator = this._generatorFunction.call(this._receiver);
        this._receiver = this._generatorFunction = undefined;
        this._promiseFulfilled(undefined);
    };
    PromiseSpawn.prototype._continue = function(result) {
        var promise = this._promise;
        if (result === errorObj) {
            this._cleanup();
            if (this._cancellationPhase) return promise.cancel();
            else return promise._rejectCallback(result.e, false);
        }
        var value = result.value;
        if (result.done === true) {
            this._cleanup();
            if (this._cancellationPhase) return promise.cancel();
            else return promise._resolveCallback(value);
        } else {
            var maybePromise = tryConvertToPromise(value, this._promise);
            if (!(maybePromise instanceof Promise)) {
                maybePromise = promiseFromYieldHandler(maybePromise, this._yieldHandlers, this._promise);
                if (maybePromise === null) {
                    this._promiseRejected(new TypeError("A value %s was yielded that could not be treated as a promise\u000a\u000a    See http://goo.gl/MqrFmX\u000a\u000a".replace("%s", value) + "From coroutine:\u000a" + this._stack.split("\n").slice(1, -7).join("\n")));
                    return;
                }
            }
            maybePromise = maybePromise._target();
            var bitField = maybePromise._bitField;
            if ((bitField & 50397184) === 0) {
                this._yieldedPromise = maybePromise;
                maybePromise._proxy(this, null);
            } else if ((bitField & 33554432) !== 0) Promise._async.invoke(this._promiseFulfilled, this, maybePromise._value());
            else if ((bitField & 16777216) !== 0) Promise._async.invoke(this._promiseRejected, this, maybePromise._reason());
            else this._promiseCancelled();
        }
    };
    Promise.coroutine = function(generatorFunction, options) {
        if (typeof generatorFunction !== "function") throw new TypeError("generatorFunction must be a function\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
        var yieldHandler = Object(options).yieldHandler;
        var PromiseSpawn$ = PromiseSpawn;
        var stack = new Error().stack;
        return function() {
            var generator = generatorFunction.apply(this, arguments);
            var spawn = new PromiseSpawn$(undefined, undefined, yieldHandler, stack);
            var ret = spawn.promise();
            spawn._generator = generator;
            spawn._promiseFulfilled(undefined);
            return ret;
        };
    };
    Promise.coroutine.addYieldHandler = function(fn) {
        if (typeof fn !== "function") throw new TypeError("expecting a function but got " + util.classString(fn));
        yieldHandlers.push(fn);
    };
    Promise.spawn = function(generatorFunction) {
        debug.deprecated("Promise.spawn()", "Promise.coroutine()");
        if (typeof generatorFunction !== "function") return apiRejection("generatorFunction must be a function\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
        var spawn = new PromiseSpawn(generatorFunction, this);
        var ret = spawn.promise();
        spawn._run(Promise.spawn);
        return ret;
    };
};

});

parcelRegister("hLNAV", function(module, exports) {
"use strict";

module.exports = function(Promise) {
    var util = (parcelRequire("hXEBa"));
    var async = Promise._async;
    var tryCatch = util.tryCatch;
    var errorObj = util.errorObj;
    function spreadAdapter(val, nodeback) {
        var promise = this;
        if (!util.isArray(val)) return successAdapter.call(promise, val, nodeback);
        var ret = tryCatch(nodeback).apply(promise._boundValue(), [
            null
        ].concat(val));
        if (ret === errorObj) async.throwLater(ret.e);
    }
    function successAdapter(val, nodeback) {
        var promise = this;
        var receiver = promise._boundValue();
        var ret = val === undefined ? tryCatch(nodeback).call(receiver, null) : tryCatch(nodeback).call(receiver, null, val);
        if (ret === errorObj) async.throwLater(ret.e);
    }
    function errorAdapter(reason, nodeback) {
        var promise = this;
        if (!reason) {
            var newReason = new Error(reason + "");
            newReason.cause = reason;
            reason = newReason;
        }
        var ret = tryCatch(nodeback).call(promise._boundValue(), reason);
        if (ret === errorObj) async.throwLater(ret.e);
    }
    Promise.prototype.asCallback = Promise.prototype.nodeify = function(nodeback, options) {
        if (typeof nodeback == "function") {
            var adapter = successAdapter;
            if (options !== undefined && Object(options).spread) adapter = spreadAdapter;
            this._then(adapter, errorAdapter, undefined, this, nodeback);
        }
        return this;
    };
};

});

parcelRegister("lFI4k", function(module, exports) {
"use strict";



module.exports = function(Promise, INTERNAL) {
    var THIS = {};
    var util = (parcelRequire("hXEBa"));
    var nodebackForPromise = (parcelRequire("ai1Zk"));
    var withAppended = util.withAppended;
    var maybeWrapAsError = util.maybeWrapAsError;
    var canEvaluate = util.canEvaluate;
    var TypeError = (parcelRequire("2cTYx")).TypeError;
    var defaultSuffix = "Async";
    var defaultPromisified = {
        __isPromisified__: true
    };
    var noCopyProps = [
        "arity",
        "length",
        "name",
        "arguments",
        "caller",
        "callee",
        "prototype",
        "__isPromisified__"
    ];
    var noCopyPropsPattern = new RegExp("^(?:" + noCopyProps.join("|") + ")$");
    var defaultFilter = function(name) {
        return util.isIdentifier(name) && name.charAt(0) !== "_" && name !== "constructor";
    };
    function propsFilter(key) {
        return !noCopyPropsPattern.test(key);
    }
    function isPromisified(fn) {
        try {
            return fn.__isPromisified__ === true;
        } catch (e) {
            return false;
        }
    }
    function hasPromisified(obj, key, suffix) {
        var val = util.getDataPropertyOrDefault(obj, key + suffix, defaultPromisified);
        return val ? isPromisified(val) : false;
    }
    function checkValid(ret, suffix, suffixRegexp) {
        for(var i = 0; i < ret.length; i += 2){
            var key = ret[i];
            if (suffixRegexp.test(key)) {
                var keyWithoutAsyncSuffix = key.replace(suffixRegexp, "");
                for(var j = 0; j < ret.length; j += 2){
                    if (ret[j] === keyWithoutAsyncSuffix) throw new TypeError("Cannot promisify an API that has normal methods with '%s'-suffix\u000a\u000a    See http://goo.gl/MqrFmX\u000a".replace("%s", suffix));
                }
            }
        }
    }
    function promisifiableMethods(obj, suffix, suffixRegexp, filter) {
        var keys = util.inheritedDataKeys(obj);
        var ret = [];
        for(var i = 0; i < keys.length; ++i){
            var key = keys[i];
            var value = obj[key];
            var passesDefaultFilter = filter === defaultFilter ? true : defaultFilter(key, value, obj);
            if (typeof value === "function" && !isPromisified(value) && !hasPromisified(obj, key, suffix) && filter(key, value, obj, passesDefaultFilter)) ret.push(key, value);
        }
        checkValid(ret, suffix, suffixRegexp);
        return ret;
    }
    var escapeIdentRegex = function(str) {
        return str.replace(/([$])/, "\\$");
    };
    var makeNodePromisifiedEval;
    var switchCaseArgumentOrder = function(likelyArgumentCount) {
        var ret = [
            likelyArgumentCount
        ];
        var min = Math.max(0, likelyArgumentCount - 1 - 3);
        for(var i = likelyArgumentCount - 1; i >= min; --i)ret.push(i);
        for(var i = likelyArgumentCount + 1; i <= 3; ++i)ret.push(i);
        return ret;
    };
    var argumentSequence = function(argumentCount) {
        return util.filledRange(argumentCount, "_arg", "");
    };
    var parameterDeclaration = function(parameterCount) {
        return util.filledRange(Math.max(parameterCount, 3), "_arg", "");
    };
    var parameterCount = function(fn) {
        if (typeof fn.length === "number") return Math.max(Math.min(fn.length, 1024), 0);
        return 0;
    };
    makeNodePromisifiedEval = function(callback, receiver, originalName, fn, _, multiArgs) {
        var newParameterCount = Math.max(0, parameterCount(fn) - 1);
        var argumentOrder = switchCaseArgumentOrder(newParameterCount);
        var shouldProxyThis = typeof callback === "string" || receiver === THIS;
        function generateCallForArgumentCount(count) {
            var args = argumentSequence(count).join(", ");
            var comma = count > 0 ? ", " : "";
            var ret;
            if (shouldProxyThis) ret = "ret = callback.call(this, {{args}}, nodeback); break;\n";
            else ret = receiver === undefined ? "ret = callback({{args}}, nodeback); break;\n" : "ret = callback.call(receiver, {{args}}, nodeback); break;\n";
            return ret.replace("{{args}}", args).replace(", ", comma);
        }
        function generateArgumentSwitchCase() {
            var ret = "";
            for(var i = 0; i < argumentOrder.length; ++i)ret += "case " + argumentOrder[i] + ":" + generateCallForArgumentCount(argumentOrder[i]);
            ret += "                                                             \n\
        default:                                                             \n\
            var args = new Array(len + 1);                                   \n\
            var i = 0;                                                       \n\
            for (var i = 0; i < len; ++i) {                                  \n\
               args[i] = arguments[i];                                       \n\
            }                                                                \n\
            args[i] = nodeback;                                              \n\
            [CodeForCall]                                                    \n\
            break;                                                           \n\
        ".replace("[CodeForCall]", shouldProxyThis ? "ret = callback.apply(this, args);\n" : "ret = callback.apply(receiver, args);\n");
            return ret;
        }
        var getFunctionCode = typeof callback === "string" ? "this != null ? this['" + callback + "'] : fn" : "fn";
        var body = "'use strict';                                                \n\
        var ret = function (Parameters) {                                    \n\
            'use strict';                                                    \n\
            var len = arguments.length;                                      \n\
            var promise = new Promise(INTERNAL);                             \n\
            promise._captureStackTrace();                                    \n\
            var nodeback = nodebackForPromise(promise, " + multiArgs + ");   \n\
            var ret;                                                         \n\
            var callback = tryCatch([GetFunctionCode]);                      \n\
            switch(len) {                                                    \n\
                [CodeForSwitchCase]                                          \n\
            }                                                                \n\
            if (ret === errorObj) {                                          \n\
                promise._rejectCallback(maybeWrapAsError(ret.e), true, true);\n\
            }                                                                \n\
            if (!promise._isFateSealed()) promise._setAsyncGuaranteed();     \n\
            return promise;                                                  \n\
        };                                                                   \n\
        notEnumerableProp(ret, '__isPromisified__', true);                   \n\
        return ret;                                                          \n\
    ".replace("[CodeForSwitchCase]", generateArgumentSwitchCase()).replace("[GetFunctionCode]", getFunctionCode);
        body = body.replace("Parameters", parameterDeclaration(newParameterCount));
        return new Function("Promise", "fn", "receiver", "withAppended", "maybeWrapAsError", "nodebackForPromise", "tryCatch", "errorObj", "notEnumerableProp", "INTERNAL", body)(Promise, fn, receiver, withAppended, maybeWrapAsError, nodebackForPromise, util.tryCatch, util.errorObj, util.notEnumerableProp, INTERNAL);
    };
    function makeNodePromisifiedClosure(callback, receiver, _, fn, __, multiArgs) {
        var defaultThis = function() {
            return this;
        }();
        var method = callback;
        if (typeof method === "string") callback = fn;
        function promisified() {
            var _receiver = receiver;
            if (receiver === THIS) _receiver = this;
            var promise = new Promise(INTERNAL);
            promise._captureStackTrace();
            var cb = typeof method === "string" && this !== defaultThis ? this[method] : callback;
            var fn = nodebackForPromise(promise, multiArgs);
            try {
                cb.apply(_receiver, withAppended(arguments, fn));
            } catch (e) {
                promise._rejectCallback(maybeWrapAsError(e), true, true);
            }
            if (!promise._isFateSealed()) promise._setAsyncGuaranteed();
            return promise;
        }
        util.notEnumerableProp(promisified, "__isPromisified__", true);
        return promisified;
    }
    var makeNodePromisified = canEvaluate ? makeNodePromisifiedEval : makeNodePromisifiedClosure;
    function promisifyAll(obj, suffix, filter, promisifier, multiArgs) {
        var suffixRegexp = new RegExp(escapeIdentRegex(suffix) + "$");
        var methods = promisifiableMethods(obj, suffix, suffixRegexp, filter);
        for(var i = 0, len = methods.length; i < len; i += 2){
            var key = methods[i];
            var fn = methods[i + 1];
            var promisifiedKey = key + suffix;
            if (promisifier === makeNodePromisified) obj[promisifiedKey] = makeNodePromisified(key, THIS, key, fn, suffix, multiArgs);
            else {
                var promisified = promisifier(fn, function() {
                    return makeNodePromisified(key, THIS, key, fn, suffix, multiArgs);
                });
                util.notEnumerableProp(promisified, "__isPromisified__", true);
                obj[promisifiedKey] = promisified;
            }
        }
        util.toFastProperties(obj);
        return obj;
    }
    function promisify(callback, receiver, multiArgs) {
        return makeNodePromisified(callback, receiver, undefined, callback, null, multiArgs);
    }
    Promise.promisify = function(fn, options) {
        if (typeof fn !== "function") throw new TypeError("expecting a function but got " + util.classString(fn));
        if (isPromisified(fn)) return fn;
        options = Object(options);
        var receiver = options.context === undefined ? THIS : options.context;
        var multiArgs = !!options.multiArgs;
        var ret = promisify(fn, receiver, multiArgs);
        util.copyDescriptors(fn, ret, propsFilter);
        return ret;
    };
    Promise.promisifyAll = function(target, options) {
        if (typeof target !== "function" && typeof target !== "object") throw new TypeError("the target of promisifyAll must be an object or a function\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
        options = Object(options);
        var multiArgs = !!options.multiArgs;
        var suffix = options.suffix;
        if (typeof suffix !== "string") suffix = defaultSuffix;
        var filter = options.filter;
        if (typeof filter !== "function") filter = defaultFilter;
        var promisifier = options.promisifier;
        if (typeof promisifier !== "function") promisifier = makeNodePromisified;
        if (!util.isIdentifier(suffix)) throw new RangeError("suffix must be a valid identifier\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
        var keys = util.inheritedDataKeys(target);
        for(var i = 0; i < keys.length; ++i){
            var value = target[keys[i]];
            if (keys[i] !== "constructor" && util.isClass(value)) {
                promisifyAll(value.prototype, suffix, filter, promisifier, multiArgs);
                promisifyAll(value, suffix, filter, promisifier, multiArgs);
            }
        }
        return promisifyAll(target, suffix, filter, promisifier, multiArgs);
    };
};

});

parcelRegister("12mNB", function(module, exports) {
"use strict";


module.exports = function(Promise, PromiseArray, tryConvertToPromise, apiRejection) {
    var util = (parcelRequire("hXEBa"));
    var isObject = util.isObject;
    var es5 = (parcelRequire("gK3jX"));
    var Es6Map;
    if (typeof Map === "function") Es6Map = Map;
    var mapToEntries = function() {
        var index = 0;
        var size = 0;
        function extractEntry(value, key) {
            this[index] = value;
            this[index + size] = key;
            index++;
        }
        return function mapToEntries(map) {
            size = map.size;
            index = 0;
            var ret = new Array(map.size * 2);
            map.forEach(extractEntry, ret);
            return ret;
        };
    }();
    var entriesToMap = function(entries) {
        var ret = new Es6Map();
        var length = entries.length / 2 | 0;
        for(var i = 0; i < length; ++i){
            var key = entries[length + i];
            var value = entries[i];
            ret.set(key, value);
        }
        return ret;
    };
    function PropertiesPromiseArray(obj) {
        var isMap = false;
        var entries;
        if (Es6Map !== undefined && obj instanceof Es6Map) {
            entries = mapToEntries(obj);
            isMap = true;
        } else {
            var keys = es5.keys(obj);
            var len = keys.length;
            entries = new Array(len * 2);
            for(var i = 0; i < len; ++i){
                var key = keys[i];
                entries[i] = obj[key];
                entries[i + len] = key;
            }
        }
        this.constructor$(entries);
        this._isMap = isMap;
        this._init$(undefined, -3);
    }
    util.inherits(PropertiesPromiseArray, PromiseArray);
    PropertiesPromiseArray.prototype._init = function() {};
    PropertiesPromiseArray.prototype._promiseFulfilled = function(value, index) {
        this._values[index] = value;
        var totalResolved = ++this._totalResolved;
        if (totalResolved >= this._length) {
            var val;
            if (this._isMap) val = entriesToMap(this._values);
            else {
                val = {};
                var keyOffset = this.length();
                for(var i = 0, len = this.length(); i < len; ++i)val[this._values[i + keyOffset]] = this._values[i];
            }
            this._resolve(val);
            return true;
        }
        return false;
    };
    PropertiesPromiseArray.prototype.shouldCopyValues = function() {
        return false;
    };
    PropertiesPromiseArray.prototype.getActualLength = function(len) {
        return len >> 1;
    };
    function props(promises) {
        var ret;
        var castValue = tryConvertToPromise(promises);
        if (!isObject(castValue)) return apiRejection("cannot await properties of a non-object\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
        else if (castValue instanceof Promise) ret = castValue._then(Promise.props, undefined, undefined, undefined, undefined);
        else ret = new PropertiesPromiseArray(castValue).promise();
        if (castValue instanceof Promise) ret._propagateFrom(castValue, 2);
        return ret;
    }
    Promise.prototype.props = function() {
        return props(this);
    };
    Promise.props = function(promises) {
        return props(promises);
    };
};

});

parcelRegister("ilsIA", function(module, exports) {
"use strict";

module.exports = function(Promise, INTERNAL, tryConvertToPromise, apiRejection) {
    var util = (parcelRequire("hXEBa"));
    var raceLater = function(promise) {
        return promise.then(function(array) {
            return race(array, promise);
        });
    };
    function race(promises, parent) {
        var maybePromise = tryConvertToPromise(promises);
        if (maybePromise instanceof Promise) return raceLater(maybePromise);
        else {
            promises = util.asArray(promises);
            if (promises === null) return apiRejection("expecting an array or an iterable object but got " + util.classString(promises));
        }
        var ret = new Promise(INTERNAL);
        if (parent !== undefined) ret._propagateFrom(parent, 3);
        var fulfill = ret._fulfill;
        var reject = ret._reject;
        for(var i = 0, len = promises.length; i < len; ++i){
            var val = promises[i];
            if (val === undefined && !(i in promises)) continue;
            Promise.cast(val)._then(fulfill, reject, undefined, ret, null);
        }
        return ret;
    }
    Promise.race = function(promises) {
        return race(promises, undefined);
    };
    Promise.prototype.race = function() {
        return race(this, undefined);
    };
};

});

parcelRegister("4Qilm", function(module, exports) {
"use strict";

module.exports = function(Promise, PromiseArray, apiRejection, tryConvertToPromise, INTERNAL, debug) {
    var getDomain = Promise._getDomain;
    var util = (parcelRequire("hXEBa"));
    var tryCatch = util.tryCatch;
    function ReductionPromiseArray(promises, fn, initialValue, _each) {
        this.constructor$(promises);
        var domain = getDomain();
        this._fn = domain === null ? fn : util.domainBind(domain, fn);
        if (initialValue !== undefined) {
            initialValue = Promise.resolve(initialValue);
            initialValue._attachCancellationCallback(this);
        }
        this._initialValue = initialValue;
        this._currentCancellable = null;
        if (_each === INTERNAL) this._eachValues = Array(this._length);
        else if (_each === 0) this._eachValues = null;
        else this._eachValues = undefined;
        this._promise._captureStackTrace();
        this._init$(undefined, -5);
    }
    util.inherits(ReductionPromiseArray, PromiseArray);
    ReductionPromiseArray.prototype._gotAccum = function(accum) {
        if (this._eachValues !== undefined && this._eachValues !== null && accum !== INTERNAL) this._eachValues.push(accum);
    };
    ReductionPromiseArray.prototype._eachComplete = function(value) {
        if (this._eachValues !== null) this._eachValues.push(value);
        return this._eachValues;
    };
    ReductionPromiseArray.prototype._init = function() {};
    ReductionPromiseArray.prototype._resolveEmptyArray = function() {
        this._resolve(this._eachValues !== undefined ? this._eachValues : this._initialValue);
    };
    ReductionPromiseArray.prototype.shouldCopyValues = function() {
        return false;
    };
    ReductionPromiseArray.prototype._resolve = function(value) {
        this._promise._resolveCallback(value);
        this._values = null;
    };
    ReductionPromiseArray.prototype._resultCancelled = function(sender) {
        if (sender === this._initialValue) return this._cancel();
        if (this._isResolved()) return;
        this._resultCancelled$();
        if (this._currentCancellable instanceof Promise) this._currentCancellable.cancel();
        if (this._initialValue instanceof Promise) this._initialValue.cancel();
    };
    ReductionPromiseArray.prototype._iterate = function(values) {
        this._values = values;
        var value;
        var i;
        var length = values.length;
        if (this._initialValue !== undefined) {
            value = this._initialValue;
            i = 0;
        } else {
            value = Promise.resolve(values[0]);
            i = 1;
        }
        this._currentCancellable = value;
        if (!value.isRejected()) for(; i < length; ++i){
            var ctx = {
                accum: null,
                value: values[i],
                index: i,
                length: length,
                array: this
            };
            value = value._then(gotAccum, undefined, undefined, ctx, undefined);
        }
        if (this._eachValues !== undefined) value = value._then(this._eachComplete, undefined, undefined, this, undefined);
        value._then(completed, completed, undefined, value, this);
    };
    Promise.prototype.reduce = function(fn, initialValue) {
        return reduce(this, fn, initialValue, null);
    };
    Promise.reduce = function(promises, fn, initialValue, _each) {
        return reduce(promises, fn, initialValue, _each);
    };
    function completed(valueOrReason, array) {
        if (this.isFulfilled()) array._resolve(valueOrReason);
        else array._reject(valueOrReason);
    }
    function reduce(promises, fn, initialValue, _each) {
        if (typeof fn !== "function") return apiRejection("expecting a function but got " + util.classString(fn));
        var array = new ReductionPromiseArray(promises, fn, initialValue, _each);
        return array.promise();
    }
    function gotAccum(accum) {
        this.accum = accum;
        this.array._gotAccum(accum);
        var value = tryConvertToPromise(this.value, this.array._promise);
        if (value instanceof Promise) {
            this.array._currentCancellable = value;
            return value._then(gotValue, undefined, undefined, this, undefined);
        } else return gotValue.call(this, value);
    }
    function gotValue(value) {
        var array = this.array;
        var promise = array._promise;
        var fn = tryCatch(array._fn);
        promise._pushContext();
        var ret;
        if (array._eachValues !== undefined) ret = fn.call(promise._boundValue(), value, this.index, this.length);
        else ret = fn.call(promise._boundValue(), this.accum, value, this.index, this.length);
        if (ret instanceof Promise) array._currentCancellable = ret;
        var promiseCreated = promise._popContext();
        debug.checkForgottenReturns(ret, promiseCreated, array._eachValues !== undefined ? "Promise.each" : "Promise.reduce", promise);
        return ret;
    }
};

});

parcelRegister("lr4sX", function(module, exports) {
"use strict";

module.exports = function(Promise, PromiseArray, debug) {
    var PromiseInspection = Promise.PromiseInspection;
    var util = (parcelRequire("hXEBa"));
    function SettledPromiseArray(values) {
        this.constructor$(values);
    }
    util.inherits(SettledPromiseArray, PromiseArray);
    SettledPromiseArray.prototype._promiseResolved = function(index, inspection) {
        this._values[index] = inspection;
        var totalResolved = ++this._totalResolved;
        if (totalResolved >= this._length) {
            this._resolve(this._values);
            return true;
        }
        return false;
    };
    SettledPromiseArray.prototype._promiseFulfilled = function(value, index) {
        var ret = new PromiseInspection();
        ret._bitField = 33554432;
        ret._settledValueField = value;
        return this._promiseResolved(index, ret);
    };
    SettledPromiseArray.prototype._promiseRejected = function(reason, index) {
        var ret = new PromiseInspection();
        ret._bitField = 16777216;
        ret._settledValueField = reason;
        return this._promiseResolved(index, ret);
    };
    Promise.settle = function(promises) {
        debug.deprecated(".settle()", ".reflect()");
        return new SettledPromiseArray(promises).promise();
    };
    Promise.prototype.settle = function() {
        return Promise.settle(this);
    };
};

});

parcelRegister("8zVAW", function(module, exports) {
"use strict";



module.exports = function(Promise, PromiseArray, apiRejection) {
    var util = (parcelRequire("hXEBa"));
    var RangeError = (parcelRequire("2cTYx")).RangeError;
    var AggregateError = (parcelRequire("2cTYx")).AggregateError;
    var isArray = util.isArray;
    var CANCELLATION = {};
    function SomePromiseArray(values) {
        this.constructor$(values);
        this._howMany = 0;
        this._unwrap = false;
        this._initialized = false;
    }
    util.inherits(SomePromiseArray, PromiseArray);
    SomePromiseArray.prototype._init = function() {
        if (!this._initialized) return;
        if (this._howMany === 0) {
            this._resolve([]);
            return;
        }
        this._init$(undefined, -5);
        var isArrayResolved = isArray(this._values);
        if (!this._isResolved() && isArrayResolved && this._howMany > this._canPossiblyFulfill()) this._reject(this._getRangeError(this.length()));
    };
    SomePromiseArray.prototype.init = function() {
        this._initialized = true;
        this._init();
    };
    SomePromiseArray.prototype.setUnwrap = function() {
        this._unwrap = true;
    };
    SomePromiseArray.prototype.howMany = function() {
        return this._howMany;
    };
    SomePromiseArray.prototype.setHowMany = function(count) {
        this._howMany = count;
    };
    SomePromiseArray.prototype._promiseFulfilled = function(value) {
        this._addFulfilled(value);
        if (this._fulfilled() === this.howMany()) {
            this._values.length = this.howMany();
            if (this.howMany() === 1 && this._unwrap) this._resolve(this._values[0]);
            else this._resolve(this._values);
            return true;
        }
        return false;
    };
    SomePromiseArray.prototype._promiseRejected = function(reason) {
        this._addRejected(reason);
        return this._checkOutcome();
    };
    SomePromiseArray.prototype._promiseCancelled = function() {
        if (this._values instanceof Promise || this._values == null) return this._cancel();
        this._addRejected(CANCELLATION);
        return this._checkOutcome();
    };
    SomePromiseArray.prototype._checkOutcome = function() {
        if (this.howMany() > this._canPossiblyFulfill()) {
            var e = new AggregateError();
            for(var i = this.length(); i < this._values.length; ++i)if (this._values[i] !== CANCELLATION) e.push(this._values[i]);
            if (e.length > 0) this._reject(e);
            else this._cancel();
            return true;
        }
        return false;
    };
    SomePromiseArray.prototype._fulfilled = function() {
        return this._totalResolved;
    };
    SomePromiseArray.prototype._rejected = function() {
        return this._values.length - this.length();
    };
    SomePromiseArray.prototype._addRejected = function(reason) {
        this._values.push(reason);
    };
    SomePromiseArray.prototype._addFulfilled = function(value) {
        this._values[this._totalResolved++] = value;
    };
    SomePromiseArray.prototype._canPossiblyFulfill = function() {
        return this.length() - this._rejected();
    };
    SomePromiseArray.prototype._getRangeError = function(count) {
        var message = "Input array must contain at least " + this._howMany + " items but contains only " + count + " items";
        return new RangeError(message);
    };
    SomePromiseArray.prototype._resolveEmptyArray = function() {
        this._reject(this._getRangeError(0));
    };
    function some(promises, howMany) {
        if ((howMany | 0) !== howMany || howMany < 0) return apiRejection("expecting a positive integer\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
        var ret = new SomePromiseArray(promises);
        var promise = ret.promise();
        ret.setHowMany(howMany);
        ret.init();
        return promise;
    }
    Promise.some = function(promises, howMany) {
        return some(promises, howMany);
    };
    Promise.prototype.some = function(howMany) {
        return some(this, howMany);
    };
    Promise._SomePromiseArray = SomePromiseArray;
};

});

parcelRegister("5begG", function(module, exports) {
"use strict";
module.exports = function(Promise, INTERNAL) {
    var PromiseMap = Promise.map;
    Promise.prototype.filter = function(fn, options) {
        return PromiseMap(this, fn, options, INTERNAL);
    };
    Promise.filter = function(promises, fn, options) {
        return PromiseMap(promises, fn, options, INTERNAL);
    };
};

});

parcelRegister("b7rK3", function(module, exports) {
"use strict";
module.exports = function(Promise, INTERNAL) {
    var PromiseReduce = Promise.reduce;
    var PromiseAll = Promise.all;
    function promiseAllThis() {
        return PromiseAll(this);
    }
    function PromiseMapSeries(promises, fn) {
        return PromiseReduce(promises, fn, INTERNAL, INTERNAL);
    }
    Promise.prototype.each = function(fn) {
        return PromiseReduce(this, fn, INTERNAL, 0)._then(promiseAllThis, undefined, undefined, this, undefined);
    };
    Promise.prototype.mapSeries = function(fn) {
        return PromiseReduce(this, fn, INTERNAL, INTERNAL);
    };
    Promise.each = function(promises, fn) {
        return PromiseReduce(promises, fn, INTERNAL, 0)._then(promiseAllThis, undefined, undefined, promises, undefined);
    };
    Promise.mapSeries = PromiseMapSeries;
};

});

parcelRegister("fLPkU", function(module, exports) {
"use strict";
module.exports = function(Promise) {
    var SomePromiseArray = Promise._SomePromiseArray;
    function any(promises) {
        var ret = new SomePromiseArray(promises);
        var promise = ret.promise();
        ret.setHowMany(1);
        ret.setUnwrap();
        ret.init();
        return promise;
    }
    Promise.any = function(promises) {
        return any(promises);
    };
    Promise.prototype.any = function() {
        return any(this);
    };
};

});


parcelRegister("jxEQL", function(module, exports) {

$parcel$export(module.exports, "readString", function () { return $e3a0c95e2abae57e$export$dda73877cb166cd3; }, function (v) { return $e3a0c95e2abae57e$export$dda73877cb166cd3 = v; });
var $e3a0c95e2abae57e$export$dda73877cb166cd3;

var $d93yU = parcelRequire("d93yU");
parcelRequire("9jAvV");
var $bPbGS = parcelRequire("bPbGS");

var $jah0F = parcelRequire("jah0F");

var $doJbW = parcelRequire("doJbW");
var $e3a0c95e2abae57e$var$Element = $doJbW.Element;
$e3a0c95e2abae57e$export$dda73877cb166cd3 = $e3a0c95e2abae57e$var$readString;
var $e3a0c95e2abae57e$var$Node = $jah0F.Node;
function $e3a0c95e2abae57e$var$readString(xmlString, namespaceMap) {
    namespaceMap = namespaceMap || {};
    try {
        var document = $jah0F.parseFromString(xmlString, "text/xml");
    } catch (error) {
        return $d93yU.reject(error);
    }
    if (document.documentElement.tagName === "parsererror") return $d93yU.resolve(new Error(document.documentElement.textContent));
    function convertNode(node) {
        switch(node.nodeType){
            case $e3a0c95e2abae57e$var$Node.ELEMENT_NODE:
                return convertElement(node);
            case $e3a0c95e2abae57e$var$Node.TEXT_NODE:
                return $doJbW.text(node.nodeValue);
        }
    }
    function convertElement(element) {
        var convertedName = convertName(element);
        var convertedChildren = [];
        $bPbGS.default(element.childNodes, function(childNode) {
            var convertedNode = convertNode(childNode);
            if (convertedNode) convertedChildren.push(convertedNode);
        });
        var convertedAttributes = {};
        $bPbGS.default(element.attributes, function(attribute) {
            convertedAttributes[convertName(attribute)] = attribute.value;
        });
        return new $e3a0c95e2abae57e$var$Element(convertedName, convertedAttributes, convertedChildren);
    }
    function convertName(node) {
        if (node.namespaceURI) {
            var mappedPrefix = namespaceMap[node.namespaceURI];
            var prefix;
            if (mappedPrefix) prefix = mappedPrefix + ":";
            else prefix = "{" + node.namespaceURI + "}";
            return prefix + node.localName;
        } else return node.localName;
    }
    return $d93yU.resolve(convertNode(document.documentElement));
}

});
parcelRegister("d93yU", function(module, exports) {

$parcel$export(module.exports, "when", function () { return $991ee0f65a60b17a$export$a55877ca9db47377; }, function (v) { return $991ee0f65a60b17a$export$a55877ca9db47377 = v; });
$parcel$export(module.exports, "resolve", function () { return $991ee0f65a60b17a$export$f7ad0328861e2f03; }, function (v) { return $991ee0f65a60b17a$export$f7ad0328861e2f03 = v; });
$parcel$export(module.exports, "props", function () { return $991ee0f65a60b17a$export$8128bb6492cf3de7; }, function (v) { return $991ee0f65a60b17a$export$8128bb6492cf3de7 = v; });
$parcel$export(module.exports, "reject", function () { return $991ee0f65a60b17a$export$2800f3ceda99eb84; }, function (v) { return $991ee0f65a60b17a$export$2800f3ceda99eb84 = v; });
$parcel$export(module.exports, "mapSeries", function () { return $991ee0f65a60b17a$export$9a85c32cda85b0dd; }, function (v) { return $991ee0f65a60b17a$export$9a85c32cda85b0dd = v; });
$parcel$export(module.exports, "attempt", function () { return $991ee0f65a60b17a$export$77f9e426014f6edd; }, function (v) { return $991ee0f65a60b17a$export$77f9e426014f6edd = v; });
var $991ee0f65a60b17a$export$260e5c0943f31606;
var $991ee0f65a60b17a$export$a55877ca9db47377;
var $991ee0f65a60b17a$export$f7ad0328861e2f03;
var $991ee0f65a60b17a$export$84bf76cd7afc7469;
var $991ee0f65a60b17a$export$8128bb6492cf3de7;
var $991ee0f65a60b17a$export$2800f3ceda99eb84;
var $991ee0f65a60b17a$export$1d1d2ed6b55cf67f;
var $991ee0f65a60b17a$export$9a85c32cda85b0dd;
var $991ee0f65a60b17a$export$77f9e426014f6edd;
var $991ee0f65a60b17a$export$8429d1d5679bc81e;
parcelRequire("9jAvV");
var $5yjjJ = parcelRequire("5yjjJ");

var $991ee0f65a60b17a$var$bluebird = (parcelRequire("cKjOO"))();
$991ee0f65a60b17a$export$260e5c0943f31606 = $991ee0f65a60b17a$var$defer;
$991ee0f65a60b17a$export$a55877ca9db47377 = $991ee0f65a60b17a$var$bluebird.resolve;
$991ee0f65a60b17a$export$f7ad0328861e2f03 = $991ee0f65a60b17a$var$bluebird.resolve;
$991ee0f65a60b17a$export$84bf76cd7afc7469 = $991ee0f65a60b17a$var$bluebird.all;
$991ee0f65a60b17a$export$8128bb6492cf3de7 = $991ee0f65a60b17a$var$bluebird.props;
$991ee0f65a60b17a$export$2800f3ceda99eb84 = $991ee0f65a60b17a$var$bluebird.reject;
$991ee0f65a60b17a$export$1d1d2ed6b55cf67f = $991ee0f65a60b17a$var$bluebird.promisify;
$991ee0f65a60b17a$export$9a85c32cda85b0dd = $991ee0f65a60b17a$var$bluebird.mapSeries;
$991ee0f65a60b17a$export$77f9e426014f6edd = $991ee0f65a60b17a$var$bluebird.attempt;
$991ee0f65a60b17a$export$8429d1d5679bc81e = function(func) {
    var args = Array.prototype.slice.call(arguments, 1);
    var promisedFunc = $991ee0f65a60b17a$var$bluebird.promisify(func);
    return promisedFunc.apply(null, args);
};
$991ee0f65a60b17a$var$bluebird.prototype.fail = $991ee0f65a60b17a$var$bluebird.prototype.caught;
$991ee0f65a60b17a$var$bluebird.prototype.also = function(func) {
    return this.then(function(value) {
        var returnValue = $5yjjJ.default({}, value, func(value));
        return $991ee0f65a60b17a$var$bluebird.props(returnValue);
    });
};
function $991ee0f65a60b17a$var$defer() {
    var resolve;
    var reject;
    var promise = new $991ee0f65a60b17a$var$bluebird.Promise(function(resolveArg, rejectArg) {
        resolve = resolveArg;
        reject = rejectArg;
    });
    return {
        resolve: resolve,
        reject: reject,
        promise: promise
    };
}

});
parcelRegister("9jAvV", function(module, exports) {
// ESM Exports
// ===========
// This module is the package entry point for ES module users. In other words,
// it is the module they are interfacing with when they import from the whole
// package instead of from a submodule, like this:
//
// ```js
// import { map } from 'underscore';
// ```
//
// The difference with `./index-default`, which is the package entry point for
// CommonJS, AMD and UMD users, is purely technical. In ES modules, named and
// default exports are considered to be siblings, so when you have a default
// export, its properties are not automatically available as named exports. For
// this reason, we re-export the named exports in addition to providing the same
// default export as in `./index-default`.

var $dxtty = parcelRequire("dxtty");

var $hMAdV = parcelRequire("hMAdV");
$parcel$exportWildcard(module.exports, $hMAdV);

});
parcelRegister("dxtty", function(module, exports) {
// Default Export
// ==============
// In this module, we mix our bundled exports into the `_` object and export
// the result. This is analogous to setting `module.exports = _` in CommonJS.
// Hence, this module is also the entry point of our UMD bundle and the package
// entry point for CommonJS and AMD users. In other words, this is (the source
// of) the module you are interfacing with when you do any of the following:
//
// ```js
// // CommonJS
// var _ = require('underscore');
//
// // AMD
// define(['underscore'], function(_) {...});
//
// // UMD in the browser
// // _ is available as a global variable
// ```
parcelRequire("hMAdV");
var $j2rdI = parcelRequire("j2rdI");
var $hMAdV = parcelRequire("hMAdV");
// Add all of the Underscore functions to the wrapper object.
var $9db538b41c10062f$var$_ = (0, $j2rdI.default)($hMAdV);
// Legacy Node.js API.
$9db538b41c10062f$var$_._ = $9db538b41c10062f$var$_;
var // Export the Underscore API.
$9db538b41c10062f$export$2e2bcd8739ae039 = $9db538b41c10062f$var$_;

});
parcelRegister("hMAdV", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "VERSION", function () { return (parcelRequire("lKa0l")).VERSION; });
$parcel$export(module.exports, "restArguments", function () { return (parcelRequire("cutdK")).default; });
$parcel$export(module.exports, "isObject", function () { return (parcelRequire("dYssA")).default; });
$parcel$export(module.exports, "isNull", function () { return (parcelRequire("7WZB1")).default; });
$parcel$export(module.exports, "isUndefined", function () { return (parcelRequire("j3POm")).default; });
$parcel$export(module.exports, "isBoolean", function () { return (parcelRequire("aY7I7")).default; });
$parcel$export(module.exports, "isElement", function () { return (parcelRequire("euF0v")).default; });
$parcel$export(module.exports, "isString", function () { return (parcelRequire("jmGFg")).default; });
$parcel$export(module.exports, "isNumber", function () { return (parcelRequire("1KDWp")).default; });
$parcel$export(module.exports, "isDate", function () { return (parcelRequire("8e2WD")).default; });
$parcel$export(module.exports, "isRegExp", function () { return (parcelRequire("cCZdY")).default; });
$parcel$export(module.exports, "isError", function () { return (parcelRequire("3bgcR")).default; });
$parcel$export(module.exports, "isSymbol", function () { return (parcelRequire("jBakT")).default; });
$parcel$export(module.exports, "isArrayBuffer", function () { return (parcelRequire("lxQta")).default; });
$parcel$export(module.exports, "isDataView", function () { return (parcelRequire("icElx")).default; });
$parcel$export(module.exports, "isArray", function () { return (parcelRequire("3rBlz")).default; });
$parcel$export(module.exports, "isFunction", function () { return (parcelRequire("ciHuQ")).default; });
$parcel$export(module.exports, "isArguments", function () { return (parcelRequire("g7r4I")).default; });
$parcel$export(module.exports, "isFinite", function () { return (parcelRequire("3fPql")).default; });
$parcel$export(module.exports, "isNaN", function () { return (parcelRequire("5hVse")).default; });
$parcel$export(module.exports, "isTypedArray", function () { return (parcelRequire("dt9Az")).default; });
$parcel$export(module.exports, "isEmpty", function () { return (parcelRequire("15h2w")).default; });
$parcel$export(module.exports, "isMatch", function () { return (parcelRequire("d6SxQ")).default; });
$parcel$export(module.exports, "isEqual", function () { return (parcelRequire("8C01Z")).default; });
$parcel$export(module.exports, "isMap", function () { return (parcelRequire("4okfY")).default; });
$parcel$export(module.exports, "isWeakMap", function () { return (parcelRequire("fchA7")).default; });
$parcel$export(module.exports, "isSet", function () { return (parcelRequire("axeJL")).default; });
$parcel$export(module.exports, "isWeakSet", function () { return (parcelRequire("32ogZ")).default; });
$parcel$export(module.exports, "keys", function () { return (parcelRequire("4LWsK")).default; });
$parcel$export(module.exports, "allKeys", function () { return (parcelRequire("jZVkW")).default; });
$parcel$export(module.exports, "values", function () { return (parcelRequire("gNJrf")).default; });
$parcel$export(module.exports, "pairs", function () { return (parcelRequire("6u5iL")).default; });
$parcel$export(module.exports, "invert", function () { return (parcelRequire("loFvT")).default; });
$parcel$export(module.exports, "functions", function () { return (parcelRequire("l07og")).default; });
$parcel$export(module.exports, "methods", function () { return (parcelRequire("l07og")).default; });
$parcel$export(module.exports, "extend", function () { return (parcelRequire("5yjjJ")).default; });
$parcel$export(module.exports, "extendOwn", function () { return (parcelRequire("dlMHj")).default; });
$parcel$export(module.exports, "assign", function () { return (parcelRequire("dlMHj")).default; });
$parcel$export(module.exports, "defaults", function () { return (parcelRequire("euU6m")).default; });
$parcel$export(module.exports, "create", function () { return (parcelRequire("lCMkx")).default; });
$parcel$export(module.exports, "clone", function () { return (parcelRequire("5mG2j")).default; });
$parcel$export(module.exports, "tap", function () { return (parcelRequire("coY6d")).default; });
$parcel$export(module.exports, "get", function () { return (parcelRequire("bnzgB")).default; });
$parcel$export(module.exports, "has", function () { return (parcelRequire("jF7N8")).default; });
$parcel$export(module.exports, "mapObject", function () { return (parcelRequire("dVbMh")).default; });
$parcel$export(module.exports, "identity", function () { return (parcelRequire("3Ft8y")).default; });
$parcel$export(module.exports, "constant", function () { return (parcelRequire("2bZSn")).default; });
$parcel$export(module.exports, "noop", function () { return (parcelRequire("3xRL4")).default; });
$parcel$export(module.exports, "toPath", function () { return (parcelRequire("86pzb")).default; });
$parcel$export(module.exports, "property", function () { return (parcelRequire("cVGk0")).default; });
$parcel$export(module.exports, "propertyOf", function () { return (parcelRequire("4H9Bb")).default; });
$parcel$export(module.exports, "matcher", function () { return (parcelRequire("fWh3j")).default; });
$parcel$export(module.exports, "matches", function () { return (parcelRequire("fWh3j")).default; });
$parcel$export(module.exports, "times", function () { return (parcelRequire("g62W6")).default; });
$parcel$export(module.exports, "random", function () { return (parcelRequire("5ImvW")).default; });
$parcel$export(module.exports, "now", function () { return (parcelRequire("ci2Hm")).default; });
$parcel$export(module.exports, "escape", function () { return (parcelRequire("cVKPu")).default; });
$parcel$export(module.exports, "unescape", function () { return (parcelRequire("fhZ4W")).default; });
$parcel$export(module.exports, "templateSettings", function () { return (parcelRequire("ibdiz")).default; });
$parcel$export(module.exports, "template", function () { return (parcelRequire("aQvus")).default; });
$parcel$export(module.exports, "result", function () { return (parcelRequire("aaIUq")).default; });
$parcel$export(module.exports, "uniqueId", function () { return (parcelRequire("ijUFs")).default; });
$parcel$export(module.exports, "chain", function () { return (parcelRequire("1Jw0L")).default; });
$parcel$export(module.exports, "iteratee", function () { return (parcelRequire("4THUh")).default; });
$parcel$export(module.exports, "partial", function () { return (parcelRequire("57hXU")).default; });
$parcel$export(module.exports, "bind", function () { return (parcelRequire("87tT8")).default; });
$parcel$export(module.exports, "bindAll", function () { return (parcelRequire("aDTbd")).default; });
$parcel$export(module.exports, "memoize", function () { return (parcelRequire("iW6qG")).default; });
$parcel$export(module.exports, "delay", function () { return (parcelRequire("dMNsc")).default; });
$parcel$export(module.exports, "defer", function () { return (parcelRequire("jzlx4")).default; });
$parcel$export(module.exports, "throttle", function () { return (parcelRequire("4olrn")).default; });
$parcel$export(module.exports, "debounce", function () { return (parcelRequire("j6hEX")).default; });
$parcel$export(module.exports, "wrap", function () { return (parcelRequire("boUYN")).default; });
$parcel$export(module.exports, "negate", function () { return (parcelRequire("fEZb2")).default; });
$parcel$export(module.exports, "compose", function () { return (parcelRequire("g6hdv")).default; });
$parcel$export(module.exports, "after", function () { return (parcelRequire("6JKsG")).default; });
$parcel$export(module.exports, "before", function () { return (parcelRequire("i0BUd")).default; });
$parcel$export(module.exports, "once", function () { return (parcelRequire("l46qR")).default; });
$parcel$export(module.exports, "findKey", function () { return (parcelRequire("2qFVg")).default; });
$parcel$export(module.exports, "findIndex", function () { return (parcelRequire("e2Yic")).default; });
$parcel$export(module.exports, "findLastIndex", function () { return (parcelRequire("iL92E")).default; });
$parcel$export(module.exports, "sortedIndex", function () { return (parcelRequire("ghC52")).default; });
$parcel$export(module.exports, "indexOf", function () { return (parcelRequire("5YGUS")).default; });
$parcel$export(module.exports, "lastIndexOf", function () { return (parcelRequire("3fsu4")).default; });
$parcel$export(module.exports, "find", function () { return (parcelRequire("bss2W")).default; });
$parcel$export(module.exports, "detect", function () { return (parcelRequire("bss2W")).default; });
$parcel$export(module.exports, "findWhere", function () { return (parcelRequire("emdBE")).default; });
$parcel$export(module.exports, "each", function () { return (parcelRequire("bPbGS")).default; });
$parcel$export(module.exports, "forEach", function () { return (parcelRequire("bPbGS")).default; });
$parcel$export(module.exports, "map", function () { return (parcelRequire("gfTwJ")).default; });
$parcel$export(module.exports, "collect", function () { return (parcelRequire("gfTwJ")).default; });
$parcel$export(module.exports, "reduce", function () { return (parcelRequire("jD3Ao")).default; });
$parcel$export(module.exports, "foldl", function () { return (parcelRequire("jD3Ao")).default; });
$parcel$export(module.exports, "inject", function () { return (parcelRequire("jD3Ao")).default; });
$parcel$export(module.exports, "reduceRight", function () { return (parcelRequire("6BBNz")).default; });
$parcel$export(module.exports, "foldr", function () { return (parcelRequire("6BBNz")).default; });
$parcel$export(module.exports, "filter", function () { return (parcelRequire("efEt3")).default; });
$parcel$export(module.exports, "select", function () { return (parcelRequire("efEt3")).default; });
$parcel$export(module.exports, "reject", function () { return (parcelRequire("8BknA")).default; });
$parcel$export(module.exports, "every", function () { return (parcelRequire("22GE8")).default; });
$parcel$export(module.exports, "all", function () { return (parcelRequire("22GE8")).default; });
$parcel$export(module.exports, "some", function () { return (parcelRequire("ctpBH")).default; });
$parcel$export(module.exports, "any", function () { return (parcelRequire("ctpBH")).default; });
$parcel$export(module.exports, "contains", function () { return (parcelRequire("9z2eX")).default; });
$parcel$export(module.exports, "includes", function () { return (parcelRequire("9z2eX")).default; });
$parcel$export(module.exports, "include", function () { return (parcelRequire("9z2eX")).default; });
$parcel$export(module.exports, "invoke", function () { return (parcelRequire("kDigY")).default; });
$parcel$export(module.exports, "pluck", function () { return (parcelRequire("gS9W9")).default; });
$parcel$export(module.exports, "where", function () { return (parcelRequire("9zRTj")).default; });
$parcel$export(module.exports, "max", function () { return (parcelRequire("fUZrG")).default; });
$parcel$export(module.exports, "min", function () { return (parcelRequire("2OrAw")).default; });
$parcel$export(module.exports, "shuffle", function () { return (parcelRequire("jujdW")).default; });
$parcel$export(module.exports, "sample", function () { return (parcelRequire("3k55B")).default; });
$parcel$export(module.exports, "sortBy", function () { return (parcelRequire("eVdJn")).default; });
$parcel$export(module.exports, "groupBy", function () { return (parcelRequire("dqbTp")).default; });
$parcel$export(module.exports, "indexBy", function () { return (parcelRequire("bJcvr")).default; });
$parcel$export(module.exports, "countBy", function () { return (parcelRequire("bRnHN")).default; });
$parcel$export(module.exports, "partition", function () { return (parcelRequire("2fwpY")).default; });
$parcel$export(module.exports, "toArray", function () { return (parcelRequire("1N8dN")).default; });
$parcel$export(module.exports, "size", function () { return (parcelRequire("iTCYf")).default; });
$parcel$export(module.exports, "pick", function () { return (parcelRequire("3fpzD")).default; });
$parcel$export(module.exports, "omit", function () { return (parcelRequire("jrEl1")).default; });
$parcel$export(module.exports, "first", function () { return (parcelRequire("fcTdF")).default; });
$parcel$export(module.exports, "head", function () { return (parcelRequire("fcTdF")).default; });
$parcel$export(module.exports, "take", function () { return (parcelRequire("fcTdF")).default; });
$parcel$export(module.exports, "initial", function () { return (parcelRequire("c4yYd")).default; });
$parcel$export(module.exports, "last", function () { return (parcelRequire("hB3Xt")).default; });
$parcel$export(module.exports, "rest", function () { return (parcelRequire("2lrEW")).default; });
$parcel$export(module.exports, "tail", function () { return (parcelRequire("2lrEW")).default; });
$parcel$export(module.exports, "drop", function () { return (parcelRequire("2lrEW")).default; });
$parcel$export(module.exports, "compact", function () { return (parcelRequire("ees8X")).default; });
$parcel$export(module.exports, "flatten", function () { return (parcelRequire("1TwZj")).default; });
$parcel$export(module.exports, "without", function () { return (parcelRequire("5jrxQ")).default; });
$parcel$export(module.exports, "uniq", function () { return (parcelRequire("iUtSI")).default; });
$parcel$export(module.exports, "unique", function () { return (parcelRequire("iUtSI")).default; });
$parcel$export(module.exports, "union", function () { return (parcelRequire("1XgTs")).default; });
$parcel$export(module.exports, "intersection", function () { return (parcelRequire("2ycy0")).default; });
$parcel$export(module.exports, "difference", function () { return (parcelRequire("89CXs")).default; });
$parcel$export(module.exports, "unzip", function () { return (parcelRequire("e9qP4")).default; });
$parcel$export(module.exports, "transpose", function () { return (parcelRequire("e9qP4")).default; });
$parcel$export(module.exports, "zip", function () { return (parcelRequire("8DaDZ")).default; });
$parcel$export(module.exports, "object", function () { return (parcelRequire("kdGCR")).default; });
$parcel$export(module.exports, "range", function () { return (parcelRequire("ds2Lz")).default; });
$parcel$export(module.exports, "chunk", function () { return (parcelRequire("idngN")).default; });
$parcel$export(module.exports, "mixin", function () { return (parcelRequire("j2rdI")).default; });
$parcel$export(module.exports, "default", function () { return (parcelRequire("OKn95")).default; });
// Named Exports
// =============
//     Underscore.js 1.13.8
//     https://underscorejs.org
//     (c) 2009-2026 Jeremy Ashkenas, Julian Gonggrijp, and DocumentCloud and Investigative Reporters & Editors
//     Underscore may be freely distributed under the MIT license.
// Baseline setup.

var $lKa0l = parcelRequire("lKa0l");

var $cutdK = parcelRequire("cutdK");

var $dYssA = parcelRequire("dYssA");

var $7WZB1 = parcelRequire("7WZB1");

var $j3POm = parcelRequire("j3POm");

var $aY7I7 = parcelRequire("aY7I7");

var $euF0v = parcelRequire("euF0v");

var $jmGFg = parcelRequire("jmGFg");

var $1KDWp = parcelRequire("1KDWp");

var $8e2WD = parcelRequire("8e2WD");

var $cCZdY = parcelRequire("cCZdY");

var $3bgcR = parcelRequire("3bgcR");

var $jBakT = parcelRequire("jBakT");

var $lxQta = parcelRequire("lxQta");

var $icElx = parcelRequire("icElx");

var $3rBlz = parcelRequire("3rBlz");

var $ciHuQ = parcelRequire("ciHuQ");

var $g7r4I = parcelRequire("g7r4I");

var $3fPql = parcelRequire("3fPql");

var $5hVse = parcelRequire("5hVse");

var $dt9Az = parcelRequire("dt9Az");

var $15h2w = parcelRequire("15h2w");

var $d6SxQ = parcelRequire("d6SxQ");

var $8C01Z = parcelRequire("8C01Z");

var $4okfY = parcelRequire("4okfY");

var $fchA7 = parcelRequire("fchA7");

var $axeJL = parcelRequire("axeJL");

var $32ogZ = parcelRequire("32ogZ");

var $4LWsK = parcelRequire("4LWsK");

var $jZVkW = parcelRequire("jZVkW");

var $gNJrf = parcelRequire("gNJrf");

var $6u5iL = parcelRequire("6u5iL");

var $loFvT = parcelRequire("loFvT");

var $l07og = parcelRequire("l07og");

var $5yjjJ = parcelRequire("5yjjJ");

var $dlMHj = parcelRequire("dlMHj");

var $euU6m = parcelRequire("euU6m");

var $lCMkx = parcelRequire("lCMkx");

var $5mG2j = parcelRequire("5mG2j");

var $coY6d = parcelRequire("coY6d");

var $bnzgB = parcelRequire("bnzgB");

var $jF7N8 = parcelRequire("jF7N8");

var $dVbMh = parcelRequire("dVbMh");

var $3Ft8y = parcelRequire("3Ft8y");

var $2bZSn = parcelRequire("2bZSn");

var $3xRL4 = parcelRequire("3xRL4");

var $86pzb = parcelRequire("86pzb");

var $cVGk0 = parcelRequire("cVGk0");

var $4H9Bb = parcelRequire("4H9Bb");

var $fWh3j = parcelRequire("fWh3j");

var $g62W6 = parcelRequire("g62W6");

var $5ImvW = parcelRequire("5ImvW");

var $ci2Hm = parcelRequire("ci2Hm");

var $cVKPu = parcelRequire("cVKPu");

var $fhZ4W = parcelRequire("fhZ4W");

var $ibdiz = parcelRequire("ibdiz");

var $aQvus = parcelRequire("aQvus");

var $aaIUq = parcelRequire("aaIUq");

var $ijUFs = parcelRequire("ijUFs");

var $1Jw0L = parcelRequire("1Jw0L");

var $4THUh = parcelRequire("4THUh");

var $57hXU = parcelRequire("57hXU");

var $87tT8 = parcelRequire("87tT8");

var $aDTbd = parcelRequire("aDTbd");

var $iW6qG = parcelRequire("iW6qG");

var $dMNsc = parcelRequire("dMNsc");

var $jzlx4 = parcelRequire("jzlx4");

var $4olrn = parcelRequire("4olrn");

var $j6hEX = parcelRequire("j6hEX");

var $boUYN = parcelRequire("boUYN");

var $fEZb2 = parcelRequire("fEZb2");

var $g6hdv = parcelRequire("g6hdv");

var $6JKsG = parcelRequire("6JKsG");

var $i0BUd = parcelRequire("i0BUd");

var $l46qR = parcelRequire("l46qR");

var $2qFVg = parcelRequire("2qFVg");

var $e2Yic = parcelRequire("e2Yic");

var $iL92E = parcelRequire("iL92E");

var $ghC52 = parcelRequire("ghC52");

var $5YGUS = parcelRequire("5YGUS");

var $3fsu4 = parcelRequire("3fsu4");

var $bss2W = parcelRequire("bss2W");

var $emdBE = parcelRequire("emdBE");

var $bPbGS = parcelRequire("bPbGS");

var $gfTwJ = parcelRequire("gfTwJ");

var $jD3Ao = parcelRequire("jD3Ao");

var $6BBNz = parcelRequire("6BBNz");

var $efEt3 = parcelRequire("efEt3");

var $8BknA = parcelRequire("8BknA");

var $22GE8 = parcelRequire("22GE8");

var $ctpBH = parcelRequire("ctpBH");

var $9z2eX = parcelRequire("9z2eX");

var $kDigY = parcelRequire("kDigY");

var $gS9W9 = parcelRequire("gS9W9");

var $9zRTj = parcelRequire("9zRTj");

var $fUZrG = parcelRequire("fUZrG");

var $2OrAw = parcelRequire("2OrAw");

var $jujdW = parcelRequire("jujdW");

var $3k55B = parcelRequire("3k55B");

var $eVdJn = parcelRequire("eVdJn");

var $dqbTp = parcelRequire("dqbTp");

var $bJcvr = parcelRequire("bJcvr");

var $bRnHN = parcelRequire("bRnHN");

var $2fwpY = parcelRequire("2fwpY");

var $1N8dN = parcelRequire("1N8dN");

var $iTCYf = parcelRequire("iTCYf");

var $3fpzD = parcelRequire("3fpzD");

var $jrEl1 = parcelRequire("jrEl1");

var $fcTdF = parcelRequire("fcTdF");

var $c4yYd = parcelRequire("c4yYd");

var $hB3Xt = parcelRequire("hB3Xt");

var $2lrEW = parcelRequire("2lrEW");

var $ees8X = parcelRequire("ees8X");

var $1TwZj = parcelRequire("1TwZj");

var $5jrxQ = parcelRequire("5jrxQ");

var $iUtSI = parcelRequire("iUtSI");

var $1XgTs = parcelRequire("1XgTs");

var $2ycy0 = parcelRequire("2ycy0");

var $89CXs = parcelRequire("89CXs");

var $e9qP4 = parcelRequire("e9qP4");

var $8DaDZ = parcelRequire("8DaDZ");

var $kdGCR = parcelRequire("kdGCR");

var $ds2Lz = parcelRequire("ds2Lz");

var $idngN = parcelRequire("idngN");

var $j2rdI = parcelRequire("j2rdI");

var $OKn95 = parcelRequire("OKn95");

});
parcelRegister("lKa0l", function(module, exports) {

$parcel$export(module.exports, "VERSION", function () { return $fd45a78d45b76e49$export$a4ad2735b021c132; });
$parcel$export(module.exports, "root", function () { return $fd45a78d45b76e49$export$e8e78c978b129247; });
$parcel$export(module.exports, "ArrayProto", function () { return $fd45a78d45b76e49$export$aabeece9448a227a; });
$parcel$export(module.exports, "ObjProto", function () { return $fd45a78d45b76e49$export$e77bb59b5e655b3d; });
$parcel$export(module.exports, "SymbolProto", function () { return $fd45a78d45b76e49$export$e229dcb397ceea81; });
$parcel$export(module.exports, "push", function () { return $fd45a78d45b76e49$export$4cbf152802aa238; });
$parcel$export(module.exports, "slice", function () { return $fd45a78d45b76e49$export$58adb3bec8346d0f; });
$parcel$export(module.exports, "toString", function () { return $fd45a78d45b76e49$export$f84e8e69fd4488a5; });
$parcel$export(module.exports, "hasOwnProperty", function () { return $fd45a78d45b76e49$export$5a15a386532a5ea4; });
$parcel$export(module.exports, "supportsArrayBuffer", function () { return $fd45a78d45b76e49$export$20eaf89d899ede58; });
$parcel$export(module.exports, "supportsDataView", function () { return $fd45a78d45b76e49$export$a2e478ad34dac33e; });
$parcel$export(module.exports, "nativeIsArray", function () { return $fd45a78d45b76e49$export$552cf9b635cef256; });
$parcel$export(module.exports, "nativeKeys", function () { return $fd45a78d45b76e49$export$e676cf06d7fd2114; });
$parcel$export(module.exports, "nativeCreate", function () { return $fd45a78d45b76e49$export$5b53dc95b548c58c; });
$parcel$export(module.exports, "nativeIsView", function () { return $fd45a78d45b76e49$export$35fc70fc5e80d5a7; });
$parcel$export(module.exports, "_isNaN", function () { return $fd45a78d45b76e49$export$a739ba33a90be0a1; });
$parcel$export(module.exports, "_isFinite", function () { return $fd45a78d45b76e49$export$8b48b92f6c9d5ad; });
$parcel$export(module.exports, "hasEnumBug", function () { return $fd45a78d45b76e49$export$7dcea4d27900b116; });
$parcel$export(module.exports, "nonEnumerableProps", function () { return $fd45a78d45b76e49$export$f8fa596d5e31cb19; });
$parcel$export(module.exports, "MAX_ARRAY_INDEX", function () { return $fd45a78d45b76e49$export$63b3abc5cd28bc48; });
// Current version.
var $fd45a78d45b76e49$export$a4ad2735b021c132 = '1.13.8';
var $fd45a78d45b76e49$export$e8e78c978b129247 = typeof self == 'object' && self.self === self && self || typeof $parcel$global == 'object' && $parcel$global.global === $parcel$global && $parcel$global || Function('return this')() || {};
var $fd45a78d45b76e49$export$aabeece9448a227a = Array.prototype, $fd45a78d45b76e49$export$e77bb59b5e655b3d = Object.prototype;
var $fd45a78d45b76e49$export$e229dcb397ceea81 = typeof Symbol !== 'undefined' ? Symbol.prototype : null;
var $fd45a78d45b76e49$export$4cbf152802aa238 = $fd45a78d45b76e49$export$aabeece9448a227a.push, $fd45a78d45b76e49$export$58adb3bec8346d0f = $fd45a78d45b76e49$export$aabeece9448a227a.slice, $fd45a78d45b76e49$export$f84e8e69fd4488a5 = $fd45a78d45b76e49$export$e77bb59b5e655b3d.toString, $fd45a78d45b76e49$export$5a15a386532a5ea4 = $fd45a78d45b76e49$export$e77bb59b5e655b3d.hasOwnProperty;
var $fd45a78d45b76e49$export$20eaf89d899ede58 = typeof ArrayBuffer !== 'undefined', $fd45a78d45b76e49$export$a2e478ad34dac33e = typeof DataView !== 'undefined';
var $fd45a78d45b76e49$export$552cf9b635cef256 = Array.isArray, $fd45a78d45b76e49$export$e676cf06d7fd2114 = Object.keys, $fd45a78d45b76e49$export$5b53dc95b548c58c = Object.create, $fd45a78d45b76e49$export$35fc70fc5e80d5a7 = $fd45a78d45b76e49$export$20eaf89d899ede58 && ArrayBuffer.isView;
var $fd45a78d45b76e49$export$a739ba33a90be0a1 = isNaN, $fd45a78d45b76e49$export$8b48b92f6c9d5ad = isFinite;
var $fd45a78d45b76e49$export$7dcea4d27900b116 = !({
    toString: null
}).propertyIsEnumerable('toString');
var $fd45a78d45b76e49$export$f8fa596d5e31cb19 = [
    'valueOf',
    'isPrototypeOf',
    'toString',
    'propertyIsEnumerable',
    'hasOwnProperty',
    'toLocaleString'
];
var $fd45a78d45b76e49$export$63b3abc5cd28bc48 = Math.pow(2, 53) - 1;

});

parcelRegister("cutdK", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $917ef4036c6c5a35$export$2e2bcd8739ae039; });
// Some functions take a variable number of arguments, or a few expected
// arguments at the beginning and then a variable number of values to operate
// on. This helper accumulates all remaining arguments past the function’s
// argument length (or an explicit `startIndex`), into an array that becomes
// the last argument. Similar to ES6’s "rest parameter".
function $917ef4036c6c5a35$export$2e2bcd8739ae039(func, startIndex) {
    startIndex = startIndex == null ? func.length - 1 : +startIndex;
    return function() {
        var length = Math.max(arguments.length - startIndex, 0), rest = Array(length), index = 0;
        for(; index < length; index++)rest[index] = arguments[index + startIndex];
        switch(startIndex){
            case 0:
                return func.call(this, rest);
            case 1:
                return func.call(this, arguments[0], rest);
            case 2:
                return func.call(this, arguments[0], arguments[1], rest);
        }
        var args = Array(startIndex + 1);
        for(index = 0; index < startIndex; index++)args[index] = arguments[index];
        args[startIndex] = rest;
        return func.apply(this, args);
    };
}

});

parcelRegister("dYssA", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $02a01cb7f883ee65$export$2e2bcd8739ae039; });
// Is a given variable an object?
function $02a01cb7f883ee65$export$2e2bcd8739ae039(obj) {
    var type = typeof obj;
    return type === 'function' || type === 'object' && !!obj;
}

});

parcelRegister("7WZB1", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5c9dbae7df9c123e$export$2e2bcd8739ae039; });
// Is a given value equal to null?
function $5c9dbae7df9c123e$export$2e2bcd8739ae039(obj) {
    return obj === null;
}

});

parcelRegister("j3POm", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $de067cc8b883de9a$export$2e2bcd8739ae039; });
// Is a given variable undefined?
function $de067cc8b883de9a$export$2e2bcd8739ae039(obj) {
    return obj === void 0;
}

});

parcelRegister("aY7I7", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7fc57d1fa6a647f7$export$2e2bcd8739ae039; });

var $lKa0l = parcelRequire("lKa0l");
function $7fc57d1fa6a647f7$export$2e2bcd8739ae039(obj) {
    return obj === true || obj === false || (0, $lKa0l.toString).call(obj) === '[object Boolean]';
}

});

parcelRegister("euF0v", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a8d3ad38baef3f2d$export$2e2bcd8739ae039; });
// Is a given value a DOM element?
function $a8d3ad38baef3f2d$export$2e2bcd8739ae039(obj) {
    return !!(obj && obj.nodeType === 1);
}

});

parcelRegister("jmGFg", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e1912aae5bd6172e$export$2e2bcd8739ae039; });

var $kaO6k = parcelRequire("kaO6k");
var $e1912aae5bd6172e$export$2e2bcd8739ae039 = (0, $kaO6k.default)('String');

});
parcelRegister("kaO6k", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $eafb9ad7fb62d71d$export$2e2bcd8739ae039; });

var $lKa0l = parcelRequire("lKa0l");
function $eafb9ad7fb62d71d$export$2e2bcd8739ae039(name) {
    var tag = '[object ' + name + ']';
    return function(obj) {
        return (0, $lKa0l.toString).call(obj) === tag;
    };
}

});


parcelRegister("1KDWp", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $146911c9abe54fd6$export$2e2bcd8739ae039; });

var $kaO6k = parcelRequire("kaO6k");
var $146911c9abe54fd6$export$2e2bcd8739ae039 = (0, $kaO6k.default)('Number');

});

parcelRegister("8e2WD", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5fd1ea4e094f2268$export$2e2bcd8739ae039; });

var $kaO6k = parcelRequire("kaO6k");
var $5fd1ea4e094f2268$export$2e2bcd8739ae039 = (0, $kaO6k.default)('Date');

});

parcelRegister("cCZdY", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $93188688681a4ed7$export$2e2bcd8739ae039; });

var $kaO6k = parcelRequire("kaO6k");
var $93188688681a4ed7$export$2e2bcd8739ae039 = (0, $kaO6k.default)('RegExp');

});

parcelRegister("3bgcR", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $250ef87289f29527$export$2e2bcd8739ae039; });

var $kaO6k = parcelRequire("kaO6k");
var $250ef87289f29527$export$2e2bcd8739ae039 = (0, $kaO6k.default)('Error');

});

parcelRegister("jBakT", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e4497d8698f85f63$export$2e2bcd8739ae039; });

var $kaO6k = parcelRequire("kaO6k");
var $e4497d8698f85f63$export$2e2bcd8739ae039 = (0, $kaO6k.default)('Symbol');

});

parcelRegister("lxQta", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $faf5615e5fcf5db2$export$2e2bcd8739ae039; });

var $kaO6k = parcelRequire("kaO6k");
var $faf5615e5fcf5db2$export$2e2bcd8739ae039 = (0, $kaO6k.default)('ArrayBuffer');

});

parcelRegister("icElx", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d408a4f40d858b2f$export$2e2bcd8739ae039; });

var $kaO6k = parcelRequire("kaO6k");

var $ciHuQ = parcelRequire("ciHuQ");

var $lxQta = parcelRequire("lxQta");

var $a227F = parcelRequire("a227F");
var $d408a4f40d858b2f$var$isDataView = (0, $kaO6k.default)('DataView');
// In IE 10 - Edge 13, we need a different heuristic
// to determine whether an object is a `DataView`.
// Also, in cases where the native `DataView` is
// overridden we can't rely on the tag itself.
function $d408a4f40d858b2f$var$alternateIsDataView(obj) {
    return obj != null && (0, $ciHuQ.default)(obj.getInt8) && (0, $lxQta.default)(obj.buffer);
}
var $d408a4f40d858b2f$export$2e2bcd8739ae039 = (0, $a227F.hasDataViewBug) ? $d408a4f40d858b2f$var$alternateIsDataView : $d408a4f40d858b2f$var$isDataView;

});
parcelRegister("ciHuQ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8f48e7fdff0325a3$export$2e2bcd8739ae039; });

var $kaO6k = parcelRequire("kaO6k");

var $lKa0l = parcelRequire("lKa0l");
var $8f48e7fdff0325a3$var$isFunction = (0, $kaO6k.default)('Function');
// Optimize `isFunction` if appropriate. Work around some `typeof` bugs in old
// v8, IE 11 (#1621), Safari 8 (#1929), and PhantomJS (#2236).
var $8f48e7fdff0325a3$var$nodelist = (0, $lKa0l.root).document && (0, $lKa0l.root).document.childNodes;
if (typeof /./ != 'function' && typeof Int8Array != 'object' && typeof $8f48e7fdff0325a3$var$nodelist != 'function') $8f48e7fdff0325a3$var$isFunction = function(obj) {
    return typeof obj == 'function' || false;
};
var $8f48e7fdff0325a3$export$2e2bcd8739ae039 = $8f48e7fdff0325a3$var$isFunction;

});

parcelRegister("a227F", function(module, exports) {

$parcel$export(module.exports, "hasDataViewBug", function () { return $74dbbccfad5f06a0$export$29b9ed4126fa90ab; });
$parcel$export(module.exports, "isIE11", function () { return $74dbbccfad5f06a0$export$f7bad96d83325a34; });

var $lKa0l = parcelRequire("lKa0l");

var $deY0B = parcelRequire("deY0B");
var $74dbbccfad5f06a0$export$29b9ed4126fa90ab = (0, $lKa0l.supportsDataView) && (!/\[native code\]/.test(String(DataView)) || (0, $deY0B.default)(new DataView(new ArrayBuffer(8)))), $74dbbccfad5f06a0$export$f7bad96d83325a34 = typeof Map !== 'undefined' && (0, $deY0B.default)(new Map);

});
parcelRegister("deY0B", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9a3b21a767ce281d$export$2e2bcd8739ae039; });

var $kaO6k = parcelRequire("kaO6k");
var $9a3b21a767ce281d$export$2e2bcd8739ae039 = (0, $kaO6k.default)('Object');

});



parcelRegister("3rBlz", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2820dd0e65ff89bf$export$2e2bcd8739ae039; });

var $lKa0l = parcelRequire("lKa0l");

var $kaO6k = parcelRequire("kaO6k");
var // Is a given value an array?
// Delegates to ECMA5's native `Array.isArray`.
$2820dd0e65ff89bf$export$2e2bcd8739ae039 = (0, $lKa0l.nativeIsArray) || (0, $kaO6k.default)('Array');

});

parcelRegister("g7r4I", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bbc24d55df6be415$export$2e2bcd8739ae039; });

var $kaO6k = parcelRequire("kaO6k");

var $iFtQd = parcelRequire("iFtQd");
var $bbc24d55df6be415$var$isArguments = (0, $kaO6k.default)('Arguments');
// Define a fallback version of the method in browsers (ahem, IE < 9), where
// there isn't any inspectable "Arguments" type.
(function() {
    if (!$bbc24d55df6be415$var$isArguments(arguments)) $bbc24d55df6be415$var$isArguments = function(obj) {
        return (0, $iFtQd.default)(obj, 'callee');
    };
})();
var $bbc24d55df6be415$export$2e2bcd8739ae039 = $bbc24d55df6be415$var$isArguments;

});
parcelRegister("iFtQd", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d9733427d810fc85$export$2e2bcd8739ae039; });

var $lKa0l = parcelRequire("lKa0l");
function $d9733427d810fc85$export$2e2bcd8739ae039(obj, key) {
    return obj != null && (0, $lKa0l.hasOwnProperty).call(obj, key);
}

});


parcelRegister("3fPql", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $25eaa98a301eb170$export$2e2bcd8739ae039; });

var $lKa0l = parcelRequire("lKa0l");

var $jBakT = parcelRequire("jBakT");
function $25eaa98a301eb170$export$2e2bcd8739ae039(obj) {
    return !(0, $jBakT.default)(obj) && (0, $lKa0l._isFinite)(obj) && !isNaN(parseFloat(obj));
}

});

parcelRegister("5hVse", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3d9b1b881ae2a14d$export$2e2bcd8739ae039; });

var $lKa0l = parcelRequire("lKa0l");

var $1KDWp = parcelRequire("1KDWp");
function $3d9b1b881ae2a14d$export$2e2bcd8739ae039(obj) {
    return (0, $1KDWp.default)(obj) && (0, $lKa0l._isNaN)(obj);
}

});

parcelRegister("dt9Az", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9ce56beae01cdc5a$export$2e2bcd8739ae039; });

var $lKa0l = parcelRequire("lKa0l");

var $icElx = parcelRequire("icElx");

var $2bZSn = parcelRequire("2bZSn");

var $3EMBS = parcelRequire("3EMBS");
// Is a given value a typed array?
var $9ce56beae01cdc5a$var$typedArrayPattern = /\[object ((I|Ui)nt(8|16|32)|Float(32|64)|Uint8Clamped|Big(I|Ui)nt64)Array\]/;
function $9ce56beae01cdc5a$var$isTypedArray(obj) {
    // `ArrayBuffer.isView` is the most future-proof, so use it when available.
    // Otherwise, fall back on the above regular expression.
    return (0, $lKa0l.nativeIsView) ? (0, $lKa0l.nativeIsView)(obj) && !(0, $icElx.default)(obj) : (0, $3EMBS.default)(obj) && $9ce56beae01cdc5a$var$typedArrayPattern.test((0, $lKa0l.toString).call(obj));
}
var $9ce56beae01cdc5a$export$2e2bcd8739ae039 = (0, $lKa0l.supportsArrayBuffer) ? $9ce56beae01cdc5a$var$isTypedArray : (0, $2bZSn.default)(false);

});
parcelRegister("2bZSn", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $198c9b253a5a7550$export$2e2bcd8739ae039; });
// Predicate-generating function. Often useful outside of Underscore.
function $198c9b253a5a7550$export$2e2bcd8739ae039(value) {
    return function() {
        return value;
    };
}

});

parcelRegister("3EMBS", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2a9ad0721604b89c$export$2e2bcd8739ae039; });

var $2KQXF = parcelRequire("2KQXF");

var $4irFB = parcelRequire("4irFB");
var // Internal helper to determine whether we should spend extensive checks against
// `ArrayBuffer` et al.
$2a9ad0721604b89c$export$2e2bcd8739ae039 = (0, $2KQXF.default)((0, $4irFB.default));

});
parcelRegister("2KQXF", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2018f5aa0195bc45$export$2e2bcd8739ae039; });

var $lKa0l = parcelRequire("lKa0l");
function $2018f5aa0195bc45$export$2e2bcd8739ae039(getSizeProperty) {
    return function(collection) {
        var sizeProperty = getSizeProperty(collection);
        return typeof sizeProperty == 'number' && sizeProperty >= 0 && sizeProperty <= (0, $lKa0l.MAX_ARRAY_INDEX);
    };
}

});

parcelRegister("4irFB", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $320e4e8cb0e3d61b$export$2e2bcd8739ae039; });

var $6UQLi = parcelRequire("6UQLi");
var // Internal helper to obtain the `byteLength` property of an object.
$320e4e8cb0e3d61b$export$2e2bcd8739ae039 = (0, $6UQLi.default)('byteLength');

});
parcelRegister("6UQLi", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5090e671bd4d0504$export$2e2bcd8739ae039; });
// Internal helper to generate a function to obtain property `key` from `obj`.
function $5090e671bd4d0504$export$2e2bcd8739ae039(key) {
    return function(obj) {
        return obj == null ? void 0 : obj[key];
    };
}

});




parcelRegister("15h2w", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0ca379c9fa8199fb$export$2e2bcd8739ae039; });

var $ikQKR = parcelRequire("ikQKR");

var $3rBlz = parcelRequire("3rBlz");

var $jmGFg = parcelRequire("jmGFg");

var $g7r4I = parcelRequire("g7r4I");

var $4LWsK = parcelRequire("4LWsK");
function $0ca379c9fa8199fb$export$2e2bcd8739ae039(obj) {
    if (obj == null) return true;
    // Skip the more expensive `toString`-based type checks if `obj` has no
    // `.length`.
    var length = (0, $ikQKR.default)(obj);
    if (typeof length == 'number' && ((0, $3rBlz.default)(obj) || (0, $jmGFg.default)(obj) || (0, $g7r4I.default)(obj))) return length === 0;
    return (0, $ikQKR.default)((0, $4LWsK.default)(obj)) === 0;
}

});
parcelRegister("ikQKR", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d59304448fb7f1b2$export$2e2bcd8739ae039; });

var $6UQLi = parcelRequire("6UQLi");
var // Internal helper to obtain the `length` property of an object.
$d59304448fb7f1b2$export$2e2bcd8739ae039 = (0, $6UQLi.default)('length');

});

parcelRegister("4LWsK", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3798e6b1c8ea6498$export$2e2bcd8739ae039; });

var $dYssA = parcelRequire("dYssA");

var $lKa0l = parcelRequire("lKa0l");

var $iFtQd = parcelRequire("iFtQd");

var $gviFy = parcelRequire("gviFy");
function $3798e6b1c8ea6498$export$2e2bcd8739ae039(obj) {
    if (!(0, $dYssA.default)(obj)) return [];
    if (0, $lKa0l.nativeKeys) return (0, $lKa0l.nativeKeys)(obj);
    var keys = [];
    for(var key in obj)if ((0, $iFtQd.default)(obj, key)) keys.push(key);
    // Ahem, IE < 9.
    if (0, $lKa0l.hasEnumBug) (0, $gviFy.default)(obj, keys);
    return keys;
}

});
parcelRegister("gviFy", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c03e05e62ea77cff$export$2e2bcd8739ae039; });

var $lKa0l = parcelRequire("lKa0l");

var $ciHuQ = parcelRequire("ciHuQ");

var $iFtQd = parcelRequire("iFtQd");
// Internal helper to create a simple lookup structure.
// `collectNonEnumProps` used to depend on `_.contains`, but this led to
// circular imports. `emulatedSet` is a one-off solution that only works for
// arrays of strings.
function $c03e05e62ea77cff$var$emulatedSet(keys) {
    var hash = {};
    for(var l = keys.length, i = 0; i < l; ++i)hash[keys[i]] = true;
    return {
        contains: function(key) {
            return hash[key] === true;
        },
        push: function(key) {
            hash[key] = true;
            return keys.push(key);
        }
    };
}
function $c03e05e62ea77cff$export$2e2bcd8739ae039(obj, keys) {
    keys = $c03e05e62ea77cff$var$emulatedSet(keys);
    var nonEnumIdx = (0, $lKa0l.nonEnumerableProps).length;
    var constructor = obj.constructor;
    var proto = (0, $ciHuQ.default)(constructor) && constructor.prototype || (0, $lKa0l.ObjProto);
    // Constructor is a special case.
    var prop = 'constructor';
    if ((0, $iFtQd.default)(obj, prop) && !keys.contains(prop)) keys.push(prop);
    while(nonEnumIdx--){
        prop = (0, $lKa0l.nonEnumerableProps)[nonEnumIdx];
        if (prop in obj && obj[prop] !== proto[prop] && !keys.contains(prop)) keys.push(prop);
    }
}

});



parcelRegister("d6SxQ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $98b62560df0e6e12$export$2e2bcd8739ae039; });

var $4LWsK = parcelRequire("4LWsK");
function $98b62560df0e6e12$export$2e2bcd8739ae039(object, attrs) {
    var _keys = (0, $4LWsK.default)(attrs), length = _keys.length;
    if (object == null) return !length;
    var obj = Object(object);
    for(var i = 0; i < length; i++){
        var key = _keys[i];
        if (attrs[key] !== obj[key] || !(key in obj)) return false;
    }
    return true;
}

});

parcelRegister("8C01Z", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6451e588103ae5e6$export$2e2bcd8739ae039; });

var $tYVIv = parcelRequire("tYVIv");

var $lKa0l = parcelRequire("lKa0l");

var $4irFB = parcelRequire("4irFB");

var $dt9Az = parcelRequire("dt9Az");

var $ciHuQ = parcelRequire("ciHuQ");

var $a227F = parcelRequire("a227F");

var $icElx = parcelRequire("icElx");

var $4LWsK = parcelRequire("4LWsK");

var $iFtQd = parcelRequire("iFtQd");

var $3Dbqh = parcelRequire("3Dbqh");
// We use this string twice, so give it a name for minification.
var $6451e588103ae5e6$var$tagDataView = '[object DataView]';
function $6451e588103ae5e6$export$2e2bcd8739ae039(a, b) {
    var todo = [
        {
            a: a,
            b: b
        }
    ];
    // Initializing stacks of traversed objects for cycle detection.
    var aStack = [], bStack = [];
    while(todo.length){
        var frame = todo.pop();
        if (frame === true) {
            // Remove the first object from the stack of traversed objects.
            aStack.pop();
            bStack.pop();
            continue;
        }
        a = frame.a;
        b = frame.b;
        // Identical objects are equal. `0 === -0`, but they aren't identical.
        // See the [Harmony `egal` proposal](https://wiki.ecmascript.org/doku.php?id=harmony:egal).
        if (a === b) {
            if (a !== 0 || 1 / a === 1 / b) continue;
            return false;
        }
        // `null` or `undefined` only equal to itself (strict comparison).
        if (a == null || b == null) return false;
        // `NaN`s are equivalent, but non-reflexive.
        if (a !== a) {
            if (b !== b) continue;
            return false;
        }
        // Exhaust primitive checks
        var type = typeof a;
        if (type !== 'function' && type !== 'object' && typeof b != 'object') return false;
        // Internal recursive comparison function for `_.isEqual`.
        // Unwrap any wrapped objects.
        if (a instanceof (0, $tYVIv.default)) a = a._wrapped;
        if (b instanceof (0, $tYVIv.default)) b = b._wrapped;
        // Compare `[[Class]]` names.
        var className = (0, $lKa0l.toString).call(a);
        if (className !== (0, $lKa0l.toString).call(b)) return false;
        // Work around a bug in IE 10 - Edge 13.
        if ((0, $a227F.hasDataViewBug) && className == '[object Object]' && (0, $icElx.default)(a)) {
            if (!(0, $icElx.default)(b)) return false;
            className = $6451e588103ae5e6$var$tagDataView;
        }
        switch(className){
            // These types are compared by value.
            case '[object RegExp]':
            // RegExps are coerced to strings for comparison (Note: '' + /a/i === '/a/i')
            case '[object String]':
                // Primitives and their corresponding object wrappers are equivalent; thus, `"5"` is
                // equivalent to `new String("5")`.
                if ('' + a === '' + b) continue;
                return false;
            case '[object Number]':
                todo.push({
                    a: +a,
                    b: +b
                });
                continue;
            case '[object Date]':
            case '[object Boolean]':
                // Coerce dates and booleans to numeric primitive values. Dates are compared by their
                // millisecond representations. Note that invalid dates with millisecond representations
                // of `NaN` are not equivalent.
                if (+a === +b) continue;
                return false;
            case '[object Symbol]':
                if ((0, $lKa0l.SymbolProto).valueOf.call(a) === (0, $lKa0l.SymbolProto).valueOf.call(b)) continue;
                return false;
            case '[object ArrayBuffer]':
            case $6451e588103ae5e6$var$tagDataView:
                // Coerce to typed array so we can fall through.
                todo.push({
                    a: (0, $3Dbqh.default)(a),
                    b: (0, $3Dbqh.default)(b)
                });
                continue;
        }
        var areArrays = className === '[object Array]';
        if (!areArrays && (0, $dt9Az.default)(a)) {
            var byteLength = (0, $4irFB.default)(a);
            if (byteLength !== (0, $4irFB.default)(b)) return false;
            if (a.buffer === b.buffer && a.byteOffset === b.byteOffset) continue;
            areArrays = true;
        }
        if (!areArrays) {
            if (typeof a != 'object' || typeof b != 'object') return false;
            // Objects with different constructors are not equivalent, but `Object`s or `Array`s
            // from different frames are.
            var aCtor = a.constructor, bCtor = b.constructor;
            if (aCtor !== bCtor && !((0, $ciHuQ.default)(aCtor) && aCtor instanceof aCtor && (0, $ciHuQ.default)(bCtor) && bCtor instanceof bCtor) && 'constructor' in a && 'constructor' in b) return false;
        }
        // Assume equality for cyclic structures. The algorithm for detecting cyclic
        // structures is adapted from ES 5.1 section 15.12.3, abstract operation `JO`.
        var length = aStack.length;
        while(length--)// Linear search. Performance is inversely proportional to the number of
        // unique nested structures.
        if (aStack[length] === a) {
            if (bStack[length] === b) break;
            return false;
        }
        if (length >= 0) continue;
        // Add the first object to the stack of traversed objects.
        aStack.push(a);
        bStack.push(b);
        todo.push(true);
        // Recursively compare objects and arrays.
        if (areArrays) {
            // Compare array lengths to determine if a deep comparison is necessary.
            length = a.length;
            if (length !== b.length) return false;
            // Deep compare the contents, ignoring non-numeric properties.
            while(length--)todo.push({
                a: a[length],
                b: b[length]
            });
        } else {
            // Deep compare objects.
            var _keys = (0, $4LWsK.default)(a), key;
            length = _keys.length;
            // Ensure that both objects contain the same number of properties before comparing deep equality.
            if ((0, $4LWsK.default)(b).length !== length) return false;
            while(length--){
                // Deep compare each member
                key = _keys[length];
                if (!(0, $iFtQd.default)(b, key)) return false;
                todo.push({
                    a: a[key],
                    b: b[key]
                });
            }
        }
    }
    return true;
}

});
parcelRegister("tYVIv", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $05a1f8f5f6aa68c7$export$2e2bcd8739ae039; });

var $lKa0l = parcelRequire("lKa0l");
function $05a1f8f5f6aa68c7$export$2e2bcd8739ae039(obj) {
    if (obj instanceof $05a1f8f5f6aa68c7$export$2e2bcd8739ae039) return obj;
    if (!(this instanceof $05a1f8f5f6aa68c7$export$2e2bcd8739ae039)) return new $05a1f8f5f6aa68c7$export$2e2bcd8739ae039(obj);
    this._wrapped = obj;
}
$05a1f8f5f6aa68c7$export$2e2bcd8739ae039.VERSION = (0, $lKa0l.VERSION);
// Extracts the result from a wrapped and chained object.
$05a1f8f5f6aa68c7$export$2e2bcd8739ae039.prototype.value = function() {
    return this._wrapped;
};
// Provide unwrapping proxies for some methods used in engine operations
// such as arithmetic and JSON stringification.
$05a1f8f5f6aa68c7$export$2e2bcd8739ae039.prototype.valueOf = $05a1f8f5f6aa68c7$export$2e2bcd8739ae039.prototype.toJSON = $05a1f8f5f6aa68c7$export$2e2bcd8739ae039.prototype.value;
$05a1f8f5f6aa68c7$export$2e2bcd8739ae039.prototype.toString = function() {
    return String(this._wrapped);
};

});

parcelRegister("3Dbqh", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2a4ddff2e0a81a69$export$2e2bcd8739ae039; });

var $4irFB = parcelRequire("4irFB");
function $2a4ddff2e0a81a69$export$2e2bcd8739ae039(bufferSource) {
    return new Uint8Array(bufferSource.buffer || bufferSource, bufferSource.byteOffset || 0, (0, $4irFB.default)(bufferSource));
}

});


parcelRegister("4okfY", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $33291ddd8a7d055e$export$2e2bcd8739ae039; });

var $kaO6k = parcelRequire("kaO6k");

var $a227F = parcelRequire("a227F");

var $aunrg = parcelRequire("aunrg");
var $33291ddd8a7d055e$export$2e2bcd8739ae039 = (0, $a227F.isIE11) ? (0, $aunrg.ie11fingerprint)((0, $aunrg.mapMethods)) : (0, $kaO6k.default)('Map');

});
parcelRegister("aunrg", function(module, exports) {

$parcel$export(module.exports, "ie11fingerprint", function () { return $7a2ee33154ac74ff$export$15230eca1f400e40; });
$parcel$export(module.exports, "weakMapMethods", function () { return $7a2ee33154ac74ff$export$2f74b890a72cf48; });
$parcel$export(module.exports, "mapMethods", function () { return $7a2ee33154ac74ff$export$de9acb94190bb764; });
$parcel$export(module.exports, "setMethods", function () { return $7a2ee33154ac74ff$export$60e14a5e2a057f78; });

var $ikQKR = parcelRequire("ikQKR");

var $ciHuQ = parcelRequire("ciHuQ");

var $jZVkW = parcelRequire("jZVkW");
function $7a2ee33154ac74ff$export$15230eca1f400e40(methods) {
    var length = (0, $ikQKR.default)(methods);
    return function(obj) {
        if (obj == null) return false;
        // `Map`, `WeakMap` and `Set` have no enumerable keys.
        var keys = (0, $jZVkW.default)(obj);
        if ((0, $ikQKR.default)(keys)) return false;
        for(var i = 0; i < length; i++){
            if (!(0, $ciHuQ.default)(obj[methods[i]])) return false;
        }
        // If we are testing against `WeakMap`, we need to ensure that
        // `obj` doesn't have a `forEach` method in order to distinguish
        // it from a regular `Map`.
        return methods !== $7a2ee33154ac74ff$export$2f74b890a72cf48 || !(0, $ciHuQ.default)(obj[$7a2ee33154ac74ff$var$forEachName]);
    };
}
// In the interest of compact minification, we write
// each string in the fingerprints only once.
var $7a2ee33154ac74ff$var$forEachName = 'forEach', $7a2ee33154ac74ff$var$hasName = 'has', $7a2ee33154ac74ff$var$commonInit = [
    'clear',
    'delete'
], $7a2ee33154ac74ff$var$mapTail = [
    'get',
    $7a2ee33154ac74ff$var$hasName,
    'set'
];
var $7a2ee33154ac74ff$export$de9acb94190bb764 = $7a2ee33154ac74ff$var$commonInit.concat($7a2ee33154ac74ff$var$forEachName, $7a2ee33154ac74ff$var$mapTail), $7a2ee33154ac74ff$export$2f74b890a72cf48 = $7a2ee33154ac74ff$var$commonInit.concat($7a2ee33154ac74ff$var$mapTail), $7a2ee33154ac74ff$export$60e14a5e2a057f78 = [
    'add'
].concat($7a2ee33154ac74ff$var$commonInit, $7a2ee33154ac74ff$var$forEachName, $7a2ee33154ac74ff$var$hasName);

});
parcelRegister("jZVkW", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e8f030bc7ef3ef30$export$2e2bcd8739ae039; });

var $dYssA = parcelRequire("dYssA");

var $lKa0l = parcelRequire("lKa0l");

var $gviFy = parcelRequire("gviFy");
function $e8f030bc7ef3ef30$export$2e2bcd8739ae039(obj) {
    if (!(0, $dYssA.default)(obj)) return [];
    var keys = [];
    for(var key in obj)keys.push(key);
    // Ahem, IE < 9.
    if (0, $lKa0l.hasEnumBug) (0, $gviFy.default)(obj, keys);
    return keys;
}

});



parcelRegister("fchA7", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b1059d5068e79eb4$export$2e2bcd8739ae039; });

var $kaO6k = parcelRequire("kaO6k");

var $a227F = parcelRequire("a227F");

var $aunrg = parcelRequire("aunrg");
var $b1059d5068e79eb4$export$2e2bcd8739ae039 = (0, $a227F.isIE11) ? (0, $aunrg.ie11fingerprint)((0, $aunrg.weakMapMethods)) : (0, $kaO6k.default)('WeakMap');

});

parcelRegister("axeJL", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7ab86af64a0a33ee$export$2e2bcd8739ae039; });

var $kaO6k = parcelRequire("kaO6k");

var $a227F = parcelRequire("a227F");

var $aunrg = parcelRequire("aunrg");
var $7ab86af64a0a33ee$export$2e2bcd8739ae039 = (0, $a227F.isIE11) ? (0, $aunrg.ie11fingerprint)((0, $aunrg.setMethods)) : (0, $kaO6k.default)('Set');

});

parcelRegister("32ogZ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $236463227a08cef1$export$2e2bcd8739ae039; });

var $kaO6k = parcelRequire("kaO6k");
var $236463227a08cef1$export$2e2bcd8739ae039 = (0, $kaO6k.default)('WeakSet');

});

parcelRegister("gNJrf", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c3b47810725b204d$export$2e2bcd8739ae039; });

var $4LWsK = parcelRequire("4LWsK");
function $c3b47810725b204d$export$2e2bcd8739ae039(obj) {
    var _keys = (0, $4LWsK.default)(obj);
    var length = _keys.length;
    var values = Array(length);
    for(var i = 0; i < length; i++)values[i] = obj[_keys[i]];
    return values;
}

});

parcelRegister("6u5iL", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4b89a83258ce913c$export$2e2bcd8739ae039; });

var $4LWsK = parcelRequire("4LWsK");
function $4b89a83258ce913c$export$2e2bcd8739ae039(obj) {
    var _keys = (0, $4LWsK.default)(obj);
    var length = _keys.length;
    var pairs = Array(length);
    for(var i = 0; i < length; i++)pairs[i] = [
        _keys[i],
        obj[_keys[i]]
    ];
    return pairs;
}

});

parcelRegister("loFvT", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f93c0a8ce98119b4$export$2e2bcd8739ae039; });

var $4LWsK = parcelRequire("4LWsK");
function $f93c0a8ce98119b4$export$2e2bcd8739ae039(obj) {
    var result = {};
    var _keys = (0, $4LWsK.default)(obj);
    for(var i = 0, length = _keys.length; i < length; i++)result[obj[_keys[i]]] = _keys[i];
    return result;
}

});

parcelRegister("l07og", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f49f549e92d6c158$export$2e2bcd8739ae039; });

var $ciHuQ = parcelRequire("ciHuQ");
function $f49f549e92d6c158$export$2e2bcd8739ae039(obj) {
    var names = [];
    for(var key in obj)if ((0, $ciHuQ.default)(obj[key])) names.push(key);
    return names.sort();
}

});

parcelRegister("5yjjJ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $40af1cbfa1b864a6$export$2e2bcd8739ae039; });

var $82Out = parcelRequire("82Out");

var $jZVkW = parcelRequire("jZVkW");
var // Extend a given object with all the properties in passed-in object(s).
$40af1cbfa1b864a6$export$2e2bcd8739ae039 = (0, $82Out.default)((0, $jZVkW.default));

});
parcelRegister("82Out", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5db5acfbcc83b687$export$2e2bcd8739ae039; });
// An internal function for creating assigner functions.
function $5db5acfbcc83b687$export$2e2bcd8739ae039(keysFunc, defaults) {
    return function(obj) {
        var length = arguments.length;
        if (defaults) obj = Object(obj);
        if (length < 2 || obj == null) return obj;
        for(var index = 1; index < length; index++){
            var source = arguments[index], keys = keysFunc(source), l = keys.length;
            for(var i = 0; i < l; i++){
                var key = keys[i];
                if (!defaults || obj[key] === void 0) obj[key] = source[key];
            }
        }
        return obj;
    };
}

});


parcelRegister("dlMHj", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9b8302d5d30fe52c$export$2e2bcd8739ae039; });

var $82Out = parcelRequire("82Out");

var $4LWsK = parcelRequire("4LWsK");
var // Assigns a given object with all the own properties in the passed-in
// object(s).
// (https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Object/assign)
$9b8302d5d30fe52c$export$2e2bcd8739ae039 = (0, $82Out.default)((0, $4LWsK.default));

});

parcelRegister("euU6m", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a8df62a94007042d$export$2e2bcd8739ae039; });

var $82Out = parcelRequire("82Out");

var $jZVkW = parcelRequire("jZVkW");
var // Fill in a given object with default properties.
$a8df62a94007042d$export$2e2bcd8739ae039 = (0, $82Out.default)((0, $jZVkW.default), true);

});

parcelRegister("lCMkx", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fbe2a2f3394297f2$export$2e2bcd8739ae039; });

var $k4rnP = parcelRequire("k4rnP");

var $dlMHj = parcelRequire("dlMHj");
function $fbe2a2f3394297f2$export$2e2bcd8739ae039(prototype, props) {
    var result = (0, $k4rnP.default)(prototype);
    if (props) (0, $dlMHj.default)(result, props);
    return result;
}

});
parcelRegister("k4rnP", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e9c96c21cac81316$export$2e2bcd8739ae039; });

var $dYssA = parcelRequire("dYssA");

var $lKa0l = parcelRequire("lKa0l");
// Create a naked function reference for surrogate-prototype-swapping.
function $e9c96c21cac81316$var$ctor() {
    return function() {};
}
function $e9c96c21cac81316$export$2e2bcd8739ae039(prototype) {
    if (!(0, $dYssA.default)(prototype)) return {};
    if (0, $lKa0l.nativeCreate) return (0, $lKa0l.nativeCreate)(prototype);
    var Ctor = $e9c96c21cac81316$var$ctor();
    Ctor.prototype = prototype;
    var result = new Ctor;
    Ctor.prototype = null;
    return result;
}

});


parcelRegister("5mG2j", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3e7f9d584d5115e1$export$2e2bcd8739ae039; });

var $dYssA = parcelRequire("dYssA");

var $3rBlz = parcelRequire("3rBlz");

var $5yjjJ = parcelRequire("5yjjJ");
function $3e7f9d584d5115e1$export$2e2bcd8739ae039(obj) {
    if (!(0, $dYssA.default)(obj)) return obj;
    return (0, $3rBlz.default)(obj) ? obj.slice() : (0, $5yjjJ.default)({}, obj);
}

});

parcelRegister("coY6d", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9076585c945d0835$export$2e2bcd8739ae039; });
// Invokes `interceptor` with the `obj` and then returns `obj`.
// The primary purpose of this method is to "tap into" a method chain, in
// order to perform operations on intermediate results within the chain.
function $9076585c945d0835$export$2e2bcd8739ae039(obj, interceptor) {
    interceptor(obj);
    return obj;
}

});

parcelRegister("bnzgB", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $848d32eefb02b4da$export$2e2bcd8739ae039; });

var $fXtgO = parcelRequire("fXtgO");

var $5SQJQ = parcelRequire("5SQJQ");

var $j3POm = parcelRequire("j3POm");
function $848d32eefb02b4da$export$2e2bcd8739ae039(object, path, defaultValue) {
    var value = (0, $5SQJQ.default)(object, (0, $fXtgO.default)(path));
    return (0, $j3POm.default)(value) ? defaultValue : value;
}

});
parcelRegister("fXtgO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b9e3122a3d4873c0$export$2e2bcd8739ae039; });

var $tYVIv = parcelRequire("tYVIv");
parcelRequire("86pzb");
function $b9e3122a3d4873c0$export$2e2bcd8739ae039(path) {
    return (0, $tYVIv.default).toPath(path);
}

});
parcelRegister("86pzb", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5e62b73e5d1c15e5$export$2e2bcd8739ae039; });

var $tYVIv = parcelRequire("tYVIv");

var $3rBlz = parcelRequire("3rBlz");
function $5e62b73e5d1c15e5$export$2e2bcd8739ae039(path) {
    return (0, $3rBlz.default)(path) ? path : [
        path
    ];
}
(0, $tYVIv.default).toPath = $5e62b73e5d1c15e5$export$2e2bcd8739ae039;

});


parcelRegister("5SQJQ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $448ae7a87e4a2152$export$2e2bcd8739ae039; });
// Internal function to obtain a nested property in `obj` along `path`.
function $448ae7a87e4a2152$export$2e2bcd8739ae039(obj, path) {
    var length = path.length;
    for(var i = 0; i < length; i++){
        if (obj == null) return void 0;
        obj = obj[path[i]];
    }
    return length ? obj : void 0;
}

});


parcelRegister("jF7N8", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e507e3e584dfdee5$export$2e2bcd8739ae039; });

var $iFtQd = parcelRequire("iFtQd");

var $fXtgO = parcelRequire("fXtgO");
function $e507e3e584dfdee5$export$2e2bcd8739ae039(obj, path) {
    path = (0, $fXtgO.default)(path);
    var length = path.length;
    for(var i = 0; i < length; i++){
        var key = path[i];
        if (!(0, $iFtQd.default)(obj, key)) return false;
        obj = obj[key];
    }
    return !!length;
}

});

parcelRegister("dVbMh", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a229bc0ceff8ccb9$export$2e2bcd8739ae039; });

var $2N7PR = parcelRequire("2N7PR");

var $4LWsK = parcelRequire("4LWsK");
function $a229bc0ceff8ccb9$export$2e2bcd8739ae039(obj, iteratee, context) {
    iteratee = (0, $2N7PR.default)(iteratee, context);
    var _keys = (0, $4LWsK.default)(obj), length = _keys.length, results = {};
    for(var index = 0; index < length; index++){
        var currentKey = _keys[index];
        results[currentKey] = iteratee(obj[currentKey], currentKey, obj);
    }
    return results;
}

});
parcelRegister("2N7PR", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $20863c513f4c5f03$export$2e2bcd8739ae039; });

var $tYVIv = parcelRequire("tYVIv");

var $9HxXt = parcelRequire("9HxXt");

var $4THUh = parcelRequire("4THUh");
function $20863c513f4c5f03$export$2e2bcd8739ae039(value, context, argCount) {
    if ((0, $tYVIv.default).iteratee !== (0, $4THUh.default)) return (0, $tYVIv.default).iteratee(value, context);
    return (0, $9HxXt.default)(value, context, argCount);
}

});
parcelRegister("9HxXt", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7102789920b8b530$export$2e2bcd8739ae039; });

var $3Ft8y = parcelRequire("3Ft8y");

var $ciHuQ = parcelRequire("ciHuQ");

var $dYssA = parcelRequire("dYssA");

var $3rBlz = parcelRequire("3rBlz");

var $fWh3j = parcelRequire("fWh3j");

var $cVGk0 = parcelRequire("cVGk0");

var $8Vo92 = parcelRequire("8Vo92");
function $7102789920b8b530$export$2e2bcd8739ae039(value, context, argCount) {
    if (value == null) return 0, $3Ft8y.default;
    if ((0, $ciHuQ.default)(value)) return (0, $8Vo92.default)(value, context, argCount);
    if ((0, $dYssA.default)(value) && !(0, $3rBlz.default)(value)) return (0, $fWh3j.default)(value);
    return (0, $cVGk0.default)(value);
}

});
parcelRegister("3Ft8y", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2abbcd6b24db8ed7$export$2e2bcd8739ae039; });
// Keep the identity function around for default iteratees.
function $2abbcd6b24db8ed7$export$2e2bcd8739ae039(value) {
    return value;
}

});

parcelRegister("fWh3j", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b9a980078a789e7a$export$2e2bcd8739ae039; });

var $dlMHj = parcelRequire("dlMHj");

var $d6SxQ = parcelRequire("d6SxQ");
function $b9a980078a789e7a$export$2e2bcd8739ae039(attrs) {
    attrs = (0, $dlMHj.default)({}, attrs);
    return function(obj) {
        return (0, $d6SxQ.default)(obj, attrs);
    };
}

});

parcelRegister("cVGk0", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $969ba31d7768ba70$export$2e2bcd8739ae039; });

var $5SQJQ = parcelRequire("5SQJQ");

var $fXtgO = parcelRequire("fXtgO");
function $969ba31d7768ba70$export$2e2bcd8739ae039(path) {
    path = (0, $fXtgO.default)(path);
    return function(obj) {
        return (0, $5SQJQ.default)(obj, path);
    };
}

});

parcelRegister("8Vo92", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $67f6604087000f2e$export$2e2bcd8739ae039; });
// Internal function that returns an efficient (for current engines) version
// of the passed-in callback, to be repeatedly applied in other Underscore
// functions.
function $67f6604087000f2e$export$2e2bcd8739ae039(func, context, argCount) {
    if (context === void 0) return func;
    switch(argCount == null ? 3 : argCount){
        case 1:
            return function(value) {
                return func.call(context, value);
            };
        // The 2-argument case is omitted because we’re not using it.
        case 3:
            return function(value, index, collection) {
                return func.call(context, value, index, collection);
            };
        case 4:
            return function(accumulator, value, index, collection) {
                return func.call(context, accumulator, value, index, collection);
            };
    }
    return function() {
        return func.apply(context, arguments);
    };
}

});


parcelRegister("4THUh", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $390e5b75b413a44b$export$2e2bcd8739ae039; });

var $tYVIv = parcelRequire("tYVIv");

var $9HxXt = parcelRequire("9HxXt");
function $390e5b75b413a44b$export$2e2bcd8739ae039(value, context) {
    return (0, $9HxXt.default)(value, context, Infinity);
}
(0, $tYVIv.default).iteratee = $390e5b75b413a44b$export$2e2bcd8739ae039;

});



parcelRegister("3xRL4", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $294e276a23aba8c2$export$2e2bcd8739ae039; });
// Predicate-generating function. Often useful outside of Underscore.
function $294e276a23aba8c2$export$2e2bcd8739ae039() {}

});

parcelRegister("4H9Bb", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $36b29fb0b1fbdaa0$export$2e2bcd8739ae039; });

var $3xRL4 = parcelRequire("3xRL4");

var $bnzgB = parcelRequire("bnzgB");
function $36b29fb0b1fbdaa0$export$2e2bcd8739ae039(obj) {
    if (obj == null) return 0, $3xRL4.default;
    return function(path) {
        return (0, $bnzgB.default)(obj, path);
    };
}

});

parcelRegister("g62W6", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bb7f7bea14a9552b$export$2e2bcd8739ae039; });

var $8Vo92 = parcelRequire("8Vo92");
function $bb7f7bea14a9552b$export$2e2bcd8739ae039(n, iteratee, context) {
    var accum = Array(Math.max(0, n));
    iteratee = (0, $8Vo92.default)(iteratee, context, 1);
    for(var i = 0; i < n; i++)accum[i] = iteratee(i);
    return accum;
}

});

parcelRegister("5ImvW", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $429286a346d684d4$export$2e2bcd8739ae039; });
// Return a random integer between `min` and `max` (inclusive).
function $429286a346d684d4$export$2e2bcd8739ae039(min, max) {
    if (max == null) {
        max = min;
        min = 0;
    }
    return min + Math.floor(Math.random() * (max - min + 1));
}

});

parcelRegister("ci2Hm", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8f29424f9db62903$export$2e2bcd8739ae039; });
// A (possibly faster) way to get the current timestamp as an integer.
var $8f29424f9db62903$export$2e2bcd8739ae039 = Date.now || function() {
    return new Date().getTime();
};

});

parcelRegister("cVKPu", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $969f2246596dae7c$export$2e2bcd8739ae039; });

var $d73jR = parcelRequire("d73jR");

var $3smh0 = parcelRequire("3smh0");
var // Function for escaping strings to HTML interpolation.
$969f2246596dae7c$export$2e2bcd8739ae039 = (0, $d73jR.default)((0, $3smh0.default));

});
parcelRegister("d73jR", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $98be80f16f262867$export$2e2bcd8739ae039; });

var $4LWsK = parcelRequire("4LWsK");
function $98be80f16f262867$export$2e2bcd8739ae039(map) {
    var escaper = function(match) {
        return map[match];
    };
    // Regexes for identifying a key that needs to be escaped.
    var source = '(?:' + (0, $4LWsK.default)(map).join('|') + ')';
    var testRegexp = RegExp(source);
    var replaceRegexp = RegExp(source, 'g');
    return function(string) {
        string = string == null ? '' : '' + string;
        return testRegexp.test(string) ? string.replace(replaceRegexp, escaper) : string;
    };
}

});

parcelRegister("3smh0", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $284543a3600ee326$export$2e2bcd8739ae039; });
// Internal list of HTML entities for escaping.
var $284543a3600ee326$export$2e2bcd8739ae039 = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#x27;',
    '`': '&#x60;'
};

});


parcelRegister("fhZ4W", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b217d27aa643e094$export$2e2bcd8739ae039; });

var $d73jR = parcelRequire("d73jR");

var $6v6ZH = parcelRequire("6v6ZH");
var // Function for unescaping strings from HTML interpolation.
$b217d27aa643e094$export$2e2bcd8739ae039 = (0, $d73jR.default)((0, $6v6ZH.default));

});
parcelRegister("6v6ZH", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4bbb1032ca93487c$export$2e2bcd8739ae039; });

var $loFvT = parcelRequire("loFvT");

var $3smh0 = parcelRequire("3smh0");
var // Internal list of HTML entities for unescaping.
$4bbb1032ca93487c$export$2e2bcd8739ae039 = (0, $loFvT.default)((0, $3smh0.default));

});


parcelRegister("ibdiz", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d3c391de4c9cbc35$export$2e2bcd8739ae039; });

var $tYVIv = parcelRequire("tYVIv");
var // By default, Underscore uses ERB-style template delimiters. Change the
// following template settings to use alternative delimiters.
$d3c391de4c9cbc35$export$2e2bcd8739ae039 = (0, $tYVIv.default).templateSettings = {
    evaluate: /<%([\s\S]+?)%>/g,
    interpolate: /<%=([\s\S]+?)%>/g,
    escape: /<%-([\s\S]+?)%>/g
};

});

parcelRegister("aQvus", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7e5730070b8474ce$export$2e2bcd8739ae039; });

var $euU6m = parcelRequire("euU6m");

var $tYVIv = parcelRequire("tYVIv");
parcelRequire("ibdiz");
// When customizing `_.templateSettings`, if you don't want to define an
// interpolation, evaluation or escaping regex, we need one that is
// guaranteed not to match.
var $7e5730070b8474ce$var$noMatch = /(.)^/;
// Certain characters need to be escaped so that they can be put into a
// string literal.
var $7e5730070b8474ce$var$escapes = {
    "'": "'",
    '\\': '\\',
    '\r': 'r',
    '\n': 'n',
    '\u2028': 'u2028',
    '\u2029': 'u2029'
};
var $7e5730070b8474ce$var$escapeRegExp = /\\|'|\r|\n|\u2028|\u2029/g;
function $7e5730070b8474ce$var$escapeChar(match) {
    return '\\' + $7e5730070b8474ce$var$escapes[match];
}
// In order to prevent third-party code injection through
// `_.templateSettings.variable`, we test it against the following regular
// expression. It is intentionally a bit more liberal than just matching valid
// identifiers, but still prevents possible loopholes through defaults or
// destructuring assignment.
var $7e5730070b8474ce$var$bareIdentifier = /^\s*(\w|\$)+\s*$/;
function $7e5730070b8474ce$export$2e2bcd8739ae039(text, settings, oldSettings) {
    if (!settings && oldSettings) settings = oldSettings;
    settings = (0, $euU6m.default)({}, settings, (0, $tYVIv.default).templateSettings);
    // Combine delimiters into one regular expression via alternation.
    var matcher = RegExp([
        (settings.escape || $7e5730070b8474ce$var$noMatch).source,
        (settings.interpolate || $7e5730070b8474ce$var$noMatch).source,
        (settings.evaluate || $7e5730070b8474ce$var$noMatch).source
    ].join('|') + '|$', 'g');
    // Compile the template source, escaping string literals appropriately.
    var index = 0;
    var source = "__p+='";
    text.replace(matcher, function(match, escape, interpolate, evaluate, offset) {
        source += text.slice(index, offset).replace($7e5730070b8474ce$var$escapeRegExp, $7e5730070b8474ce$var$escapeChar);
        index = offset + match.length;
        if (escape) source += "'+\n((__t=(" + escape + "))==null?'':_.escape(__t))+\n'";
        else if (interpolate) source += "'+\n((__t=(" + interpolate + "))==null?'':__t)+\n'";
        else if (evaluate) source += "';\n" + evaluate + "\n__p+='";
        // Adobe VMs need the match returned to produce the correct offset.
        return match;
    });
    source += "';\n";
    var argument = settings.variable;
    if (argument) {
        // Insure against third-party code injection. (CVE-2021-23358)
        if (!$7e5730070b8474ce$var$bareIdentifier.test(argument)) throw new Error('variable is not a bare identifier: ' + argument);
    } else {
        // If a variable is not specified, place data values in local scope.
        source = 'with(obj||{}){\n' + source + '}\n';
        argument = 'obj';
    }
    source = "var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};\n" + source + 'return __p;\n';
    var render;
    try {
        render = new Function(argument, '_', source);
    } catch (e) {
        e.source = source;
        throw e;
    }
    var template = function(data) {
        return render.call(this, data, (0, $tYVIv.default));
    };
    // Provide the compiled source as a convenience for precompilation.
    template.source = 'function(' + argument + '){\n' + source + '}';
    return template;
}

});

parcelRegister("aaIUq", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $767dac910fcf452d$export$2e2bcd8739ae039; });

var $ciHuQ = parcelRequire("ciHuQ");

var $fXtgO = parcelRequire("fXtgO");
function $767dac910fcf452d$export$2e2bcd8739ae039(obj, path, fallback) {
    path = (0, $fXtgO.default)(path);
    var length = path.length;
    if (!length) return (0, $ciHuQ.default)(fallback) ? fallback.call(obj) : fallback;
    for(var i = 0; i < length; i++){
        var prop = obj == null ? void 0 : obj[path[i]];
        if (prop === void 0) {
            prop = fallback;
            i = length; // Ensure we don't continue iterating.
        }
        obj = (0, $ciHuQ.default)(prop) ? prop.call(obj) : prop;
    }
    return obj;
}

});

parcelRegister("ijUFs", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d565f55da980c913$export$2e2bcd8739ae039; });
// Generate a unique integer id (unique within the entire client session).
// Useful for temporary DOM ids.
var $d565f55da980c913$var$idCounter = 0;
function $d565f55da980c913$export$2e2bcd8739ae039(prefix) {
    var id = ++$d565f55da980c913$var$idCounter + '';
    return prefix ? prefix + id : id;
}

});

parcelRegister("1Jw0L", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1432d3315f35cb6a$export$2e2bcd8739ae039; });

var $tYVIv = parcelRequire("tYVIv");
function $1432d3315f35cb6a$export$2e2bcd8739ae039(obj) {
    var instance = (0, $tYVIv.default)(obj);
    instance._chain = true;
    return instance;
}

});

parcelRegister("57hXU", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3b9b8ab4b7a036a7$export$2e2bcd8739ae039; });

var $cutdK = parcelRequire("cutdK");

var $48OGH = parcelRequire("48OGH");

var $tYVIv = parcelRequire("tYVIv");
// Partially apply a function by creating a version that has had some of its
// arguments pre-filled, without changing its dynamic `this` context. `_` acts
// as a placeholder by default, allowing any combination of arguments to be
// pre-filled. Set `_.partial.placeholder` for a custom placeholder argument.
var $3b9b8ab4b7a036a7$var$partial = (0, $cutdK.default)(function(func, boundArgs) {
    var placeholder = $3b9b8ab4b7a036a7$var$partial.placeholder;
    var bound = function() {
        var position = 0, length = boundArgs.length;
        var args = Array(length);
        for(var i = 0; i < length; i++)args[i] = boundArgs[i] === placeholder ? arguments[position++] : boundArgs[i];
        while(position < arguments.length)args.push(arguments[position++]);
        return (0, $48OGH.default)(func, bound, this, this, args);
    };
    return bound;
});
$3b9b8ab4b7a036a7$var$partial.placeholder = (0, $tYVIv.default);
var $3b9b8ab4b7a036a7$export$2e2bcd8739ae039 = $3b9b8ab4b7a036a7$var$partial;

});
parcelRegister("48OGH", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $303f3a4ed1eb9c24$export$2e2bcd8739ae039; });

var $k4rnP = parcelRequire("k4rnP");

var $dYssA = parcelRequire("dYssA");
function $303f3a4ed1eb9c24$export$2e2bcd8739ae039(sourceFunc, boundFunc, context, callingContext, args) {
    if (!(callingContext instanceof boundFunc)) return sourceFunc.apply(context, args);
    var self = (0, $k4rnP.default)(sourceFunc.prototype);
    var result = sourceFunc.apply(self, args);
    if ((0, $dYssA.default)(result)) return result;
    return self;
}

});


parcelRegister("87tT8", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5e96295e607d4716$export$2e2bcd8739ae039; });

var $cutdK = parcelRequire("cutdK");

var $ciHuQ = parcelRequire("ciHuQ");

var $48OGH = parcelRequire("48OGH");
var // Create a function bound to a given object (assigning `this`, and arguments,
// optionally).
$5e96295e607d4716$export$2e2bcd8739ae039 = (0, $cutdK.default)(function(func, context, args) {
    if (!(0, $ciHuQ.default)(func)) throw new TypeError('Bind must be called on a function');
    var bound = (0, $cutdK.default)(function(callArgs) {
        return (0, $48OGH.default)(func, bound, context, this, args.concat(callArgs));
    });
    return bound;
});

});

parcelRegister("aDTbd", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7bf8597fef205af3$export$2e2bcd8739ae039; });

var $cutdK = parcelRequire("cutdK");

var $llkFL = parcelRequire("llkFL");

var $87tT8 = parcelRequire("87tT8");
var // Bind a number of an object's methods to that object. Remaining arguments
// are the method names to be bound. Useful for ensuring that all callbacks
// defined on an object belong to it.
$7bf8597fef205af3$export$2e2bcd8739ae039 = (0, $cutdK.default)(function(obj, keys) {
    keys = (0, $llkFL.default)(keys, false, false);
    var index = keys.length;
    if (index < 1) throw new Error('bindAll must be passed function names');
    while(index--){
        var key = keys[index];
        obj[key] = (0, $87tT8.default)(obj[key], obj);
    }
    return obj;
});

});
parcelRegister("llkFL", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f89b984ecde65903$export$2e2bcd8739ae039; });

var $ikQKR = parcelRequire("ikQKR");

var $7oRXK = parcelRequire("7oRXK");

var $3rBlz = parcelRequire("3rBlz");

var $g7r4I = parcelRequire("g7r4I");
function $f89b984ecde65903$export$2e2bcd8739ae039(input, depth, strict) {
    if (!depth && depth !== 0) depth = Infinity;
    var output = [], idx = 0, i = 0, length = (0, $ikQKR.default)(input) || 0, stack = [];
    while(true){
        if (i >= length) {
            if (!stack.length) break;
            var frame = stack.pop();
            i = frame.i;
            input = frame.v;
            length = (0, $ikQKR.default)(input);
            continue;
        }
        var value = input[i++];
        if (stack.length >= depth) output[idx++] = value;
        else if ((0, $7oRXK.default)(value) && ((0, $3rBlz.default)(value) || (0, $g7r4I.default)(value))) {
            // Flatten current level of array or arguments object.
            stack.push({
                i: i,
                v: input
            });
            i = 0;
            input = value;
            length = (0, $ikQKR.default)(input);
        } else if (!strict) output[idx++] = value;
    }
    return output;
}

});
parcelRegister("7oRXK", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5634a22be85944be$export$2e2bcd8739ae039; });

var $2KQXF = parcelRequire("2KQXF");

var $ikQKR = parcelRequire("ikQKR");
var // Internal helper for collection methods to determine whether a collection
// should be iterated as an array or as an object.
// Related: https://people.mozilla.org/~jorendorff/es6-draft.html#sec-tolength
// Avoids a very nasty iOS 8 JIT bug on ARM-64. #2094
$5634a22be85944be$export$2e2bcd8739ae039 = (0, $2KQXF.default)((0, $ikQKR.default));

});



parcelRegister("iW6qG", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $dc92a182cf94c73b$export$2e2bcd8739ae039; });

var $iFtQd = parcelRequire("iFtQd");
function $dc92a182cf94c73b$export$2e2bcd8739ae039(func, hasher) {
    var memoize = function(key) {
        var cache = memoize.cache;
        var address = '' + (hasher ? hasher.apply(this, arguments) : key);
        if (!(0, $iFtQd.default)(cache, address)) cache[address] = func.apply(this, arguments);
        return cache[address];
    };
    memoize.cache = {};
    return memoize;
}

});

parcelRegister("dMNsc", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a0961e886d0178b8$export$2e2bcd8739ae039; });

var $cutdK = parcelRequire("cutdK");
var // Delays a function for the given number of milliseconds, and then calls
// it with the arguments supplied.
$a0961e886d0178b8$export$2e2bcd8739ae039 = (0, $cutdK.default)(function(func, wait, args) {
    return setTimeout(function() {
        return func.apply(null, args);
    }, wait);
});

});

parcelRegister("jzlx4", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e3f1fd16961c6151$export$2e2bcd8739ae039; });

var $57hXU = parcelRequire("57hXU");

var $dMNsc = parcelRequire("dMNsc");

var $tYVIv = parcelRequire("tYVIv");
var // Defers a function, scheduling it to run after the current call stack has
// cleared.
$e3f1fd16961c6151$export$2e2bcd8739ae039 = (0, $57hXU.default)((0, $dMNsc.default), (0, $tYVIv.default), 1);

});

parcelRegister("4olrn", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $332a08fc537f22e3$export$2e2bcd8739ae039; });

var $ci2Hm = parcelRequire("ci2Hm");
function $332a08fc537f22e3$export$2e2bcd8739ae039(func, wait, options) {
    var timeout, context, args, result;
    var previous = 0;
    if (!options) options = {};
    var later = function() {
        previous = options.leading === false ? 0 : (0, $ci2Hm.default)();
        timeout = null;
        result = func.apply(context, args);
        if (!timeout) context = args = null;
    };
    var throttled = function() {
        var _now = (0, $ci2Hm.default)();
        if (!previous && options.leading === false) previous = _now;
        var remaining = wait - (_now - previous);
        context = this;
        args = arguments;
        if (remaining <= 0 || remaining > wait) {
            if (timeout) {
                clearTimeout(timeout);
                timeout = null;
            }
            previous = _now;
            result = func.apply(context, args);
            if (!timeout) context = args = null;
        } else if (!timeout && options.trailing !== false) timeout = setTimeout(later, remaining);
        return result;
    };
    throttled.cancel = function() {
        clearTimeout(timeout);
        previous = 0;
        timeout = context = args = null;
    };
    return throttled;
}

});

parcelRegister("j6hEX", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $de7c46b238e5fb62$export$2e2bcd8739ae039; });

var $cutdK = parcelRequire("cutdK");

var $ci2Hm = parcelRequire("ci2Hm");
function $de7c46b238e5fb62$export$2e2bcd8739ae039(func, wait, immediate) {
    var timeout, previous, args, result, context;
    var later = function() {
        var passed = (0, $ci2Hm.default)() - previous;
        if (wait > passed) timeout = setTimeout(later, wait - passed);
        else {
            timeout = null;
            if (!immediate) result = func.apply(context, args);
            // This check is needed because `func` can recursively invoke `debounced`.
            if (!timeout) args = context = null;
        }
    };
    var debounced = (0, $cutdK.default)(function(_args) {
        context = this;
        args = _args;
        previous = (0, $ci2Hm.default)();
        if (!timeout) {
            timeout = setTimeout(later, wait);
            if (immediate) result = func.apply(context, args);
        }
        return result;
    });
    debounced.cancel = function() {
        clearTimeout(timeout);
        timeout = args = context = null;
    };
    return debounced;
}

});

parcelRegister("boUYN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $84ce2291500747a9$export$2e2bcd8739ae039; });

var $57hXU = parcelRequire("57hXU");
function $84ce2291500747a9$export$2e2bcd8739ae039(func, wrapper) {
    return (0, $57hXU.default)(wrapper, func);
}

});

parcelRegister("fEZb2", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b66a0bea00e88a59$export$2e2bcd8739ae039; });
// Returns a negated version of the passed-in predicate.
function $b66a0bea00e88a59$export$2e2bcd8739ae039(predicate) {
    return function() {
        return !predicate.apply(this, arguments);
    };
}

});

parcelRegister("g6hdv", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bb8a8fcc4668ce1e$export$2e2bcd8739ae039; });
// Returns a function that is the composition of a list of functions, each
// consuming the return value of the function that follows.
function $bb8a8fcc4668ce1e$export$2e2bcd8739ae039() {
    var args = arguments;
    var start = args.length - 1;
    return function() {
        var i = start;
        var result = args[start].apply(this, arguments);
        while(i--)result = args[i].call(this, result);
        return result;
    };
}

});

parcelRegister("6JKsG", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4e7afc604bb82c24$export$2e2bcd8739ae039; });
// Returns a function that will only be executed on and after the Nth call.
function $4e7afc604bb82c24$export$2e2bcd8739ae039(times, func) {
    return function() {
        if (--times < 1) return func.apply(this, arguments);
    };
}

});

parcelRegister("i0BUd", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d1c5a15f9953a5c5$export$2e2bcd8739ae039; });
// Returns a function that will only be executed up to (but not including) the
// Nth call.
function $d1c5a15f9953a5c5$export$2e2bcd8739ae039(times, func) {
    var memo;
    return function() {
        if (--times > 0) memo = func.apply(this, arguments);
        if (times <= 1) func = null;
        return memo;
    };
}

});

parcelRegister("l46qR", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f55ef6052a3bde1f$export$2e2bcd8739ae039; });

var $57hXU = parcelRequire("57hXU");

var $i0BUd = parcelRequire("i0BUd");
var // Returns a function that will be executed at most one time, no matter how
// often you call it. Useful for lazy initialization.
$f55ef6052a3bde1f$export$2e2bcd8739ae039 = (0, $57hXU.default)((0, $i0BUd.default), 2);

});

parcelRegister("2qFVg", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1c4e87734d199eee$export$2e2bcd8739ae039; });

var $2N7PR = parcelRequire("2N7PR");

var $4LWsK = parcelRequire("4LWsK");
function $1c4e87734d199eee$export$2e2bcd8739ae039(obj, predicate, context) {
    predicate = (0, $2N7PR.default)(predicate, context);
    var _keys = (0, $4LWsK.default)(obj), key;
    for(var i = 0, length = _keys.length; i < length; i++){
        key = _keys[i];
        if (predicate(obj[key], key, obj)) return key;
    }
}

});

parcelRegister("e2Yic", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a3a0056b8b01c8db$export$2e2bcd8739ae039; });

var $flkTB = parcelRequire("flkTB");
var // Returns the first index on an array-like that passes a truth test.
$a3a0056b8b01c8db$export$2e2bcd8739ae039 = (0, $flkTB.default)(1);

});
parcelRegister("flkTB", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b2b906a9d38b81d5$export$2e2bcd8739ae039; });

var $2N7PR = parcelRequire("2N7PR");

var $ikQKR = parcelRequire("ikQKR");
function $b2b906a9d38b81d5$export$2e2bcd8739ae039(dir) {
    return function(array, predicate, context) {
        predicate = (0, $2N7PR.default)(predicate, context);
        var length = (0, $ikQKR.default)(array);
        var index = dir > 0 ? 0 : length - 1;
        for(; index >= 0 && index < length; index += dir){
            if (predicate(array[index], index, array)) return index;
        }
        return -1;
    };
}

});


parcelRegister("iL92E", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $da83a14fa8ec9fff$export$2e2bcd8739ae039; });

var $flkTB = parcelRequire("flkTB");
var // Returns the last index on an array-like that passes a truth test.
$da83a14fa8ec9fff$export$2e2bcd8739ae039 = (0, $flkTB.default)(-1);

});

parcelRegister("ghC52", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bdabc5cbdaf555d8$export$2e2bcd8739ae039; });

var $2N7PR = parcelRequire("2N7PR");

var $ikQKR = parcelRequire("ikQKR");
function $bdabc5cbdaf555d8$export$2e2bcd8739ae039(array, obj, iteratee, context) {
    iteratee = (0, $2N7PR.default)(iteratee, context, 1);
    var value = iteratee(obj);
    var low = 0, high = (0, $ikQKR.default)(array);
    while(low < high){
        var mid = Math.floor((low + high) / 2);
        if (iteratee(array[mid]) < value) low = mid + 1;
        else high = mid;
    }
    return low;
}

});

parcelRegister("5YGUS", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $45a3d8aa6e700ce3$export$2e2bcd8739ae039; });

var $ghC52 = parcelRequire("ghC52");

var $e2Yic = parcelRequire("e2Yic");

var $f4Gob = parcelRequire("f4Gob");
var // Return the position of the first occurrence of an item in an array,
// or -1 if the item is not included in the array.
// If the array is large and already in sort order, pass `true`
// for **isSorted** to use binary search.
$45a3d8aa6e700ce3$export$2e2bcd8739ae039 = (0, $f4Gob.default)(1, (0, $e2Yic.default), (0, $ghC52.default));

});
parcelRegister("f4Gob", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $af981c4fd97a8462$export$2e2bcd8739ae039; });

var $ikQKR = parcelRequire("ikQKR");

var $lKa0l = parcelRequire("lKa0l");

var $5hVse = parcelRequire("5hVse");
function $af981c4fd97a8462$export$2e2bcd8739ae039(dir, predicateFind, sortedIndex) {
    return function(array, item, idx) {
        var i = 0, length = (0, $ikQKR.default)(array);
        if (typeof idx == 'number') {
            if (dir > 0) i = idx >= 0 ? idx : Math.max(idx + length, i);
            else length = idx >= 0 ? Math.min(idx + 1, length) : idx + length + 1;
        } else if (sortedIndex && idx && length) {
            idx = sortedIndex(array, item);
            return array[idx] === item ? idx : -1;
        }
        if (item !== item) {
            idx = predicateFind((0, $lKa0l.slice).call(array, i, length), (0, $5hVse.default));
            return idx >= 0 ? idx + i : -1;
        }
        for(idx = dir > 0 ? i : length - 1; idx >= 0 && idx < length; idx += dir){
            if (array[idx] === item) return idx;
        }
        return -1;
    };
}

});


parcelRegister("3fsu4", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $25d8de2992580312$export$2e2bcd8739ae039; });

var $iL92E = parcelRequire("iL92E");

var $f4Gob = parcelRequire("f4Gob");
var // Return the position of the last occurrence of an item in an array,
// or -1 if the item is not included in the array.
$25d8de2992580312$export$2e2bcd8739ae039 = (0, $f4Gob.default)(-1, (0, $iL92E.default));

});

parcelRegister("bss2W", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $857810acf45a661d$export$2e2bcd8739ae039; });

var $7oRXK = parcelRequire("7oRXK");

var $e2Yic = parcelRequire("e2Yic");

var $2qFVg = parcelRequire("2qFVg");
function $857810acf45a661d$export$2e2bcd8739ae039(obj, predicate, context) {
    var keyFinder = (0, $7oRXK.default)(obj) ? (0, $e2Yic.default) : (0, $2qFVg.default);
    var key = keyFinder(obj, predicate, context);
    if (key !== void 0 && key !== -1) return obj[key];
}

});

parcelRegister("emdBE", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a73dacaa05ccfdbb$export$2e2bcd8739ae039; });

var $bss2W = parcelRequire("bss2W");

var $fWh3j = parcelRequire("fWh3j");
function $a73dacaa05ccfdbb$export$2e2bcd8739ae039(obj, attrs) {
    return (0, $bss2W.default)(obj, (0, $fWh3j.default)(attrs));
}

});

parcelRegister("bPbGS", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $89bd869dab881381$export$2e2bcd8739ae039; });

var $8Vo92 = parcelRequire("8Vo92");

var $7oRXK = parcelRequire("7oRXK");

var $4LWsK = parcelRequire("4LWsK");
function $89bd869dab881381$export$2e2bcd8739ae039(obj, iteratee, context) {
    iteratee = (0, $8Vo92.default)(iteratee, context);
    var i, length;
    if ((0, $7oRXK.default)(obj)) for(i = 0, length = obj.length; i < length; i++)iteratee(obj[i], i, obj);
    else {
        var _keys = (0, $4LWsK.default)(obj);
        for(i = 0, length = _keys.length; i < length; i++)iteratee(obj[_keys[i]], _keys[i], obj);
    }
    return obj;
}

});

parcelRegister("gfTwJ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bd591e90477af54a$export$2e2bcd8739ae039; });

var $2N7PR = parcelRequire("2N7PR");

var $7oRXK = parcelRequire("7oRXK");

var $4LWsK = parcelRequire("4LWsK");
function $bd591e90477af54a$export$2e2bcd8739ae039(obj, iteratee, context) {
    iteratee = (0, $2N7PR.default)(iteratee, context);
    var _keys = !(0, $7oRXK.default)(obj) && (0, $4LWsK.default)(obj), length = (_keys || obj).length, results = Array(length);
    for(var index = 0; index < length; index++){
        var currentKey = _keys ? _keys[index] : index;
        results[index] = iteratee(obj[currentKey], currentKey, obj);
    }
    return results;
}

});

parcelRegister("jD3Ao", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $03b012567460dd15$export$2e2bcd8739ae039; });

var $KgPOi = parcelRequire("KgPOi");
var // **Reduce** builds up a single result from a list of values, aka `inject`,
// or `foldl`.
$03b012567460dd15$export$2e2bcd8739ae039 = (0, $KgPOi.default)(1);

});
parcelRegister("KgPOi", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $08b15b00d08a85fd$export$2e2bcd8739ae039; });

var $7oRXK = parcelRequire("7oRXK");

var $4LWsK = parcelRequire("4LWsK");

var $8Vo92 = parcelRequire("8Vo92");
function $08b15b00d08a85fd$export$2e2bcd8739ae039(dir) {
    // Wrap code that reassigns argument variables in a separate function than
    // the one that accesses `arguments.length` to avoid a perf hit. (#1991)
    var reducer = function(obj, iteratee, memo, initial) {
        var _keys = !(0, $7oRXK.default)(obj) && (0, $4LWsK.default)(obj), length = (_keys || obj).length, index = dir > 0 ? 0 : length - 1;
        if (!initial) {
            memo = obj[_keys ? _keys[index] : index];
            index += dir;
        }
        for(; index >= 0 && index < length; index += dir){
            var currentKey = _keys ? _keys[index] : index;
            memo = iteratee(memo, obj[currentKey], currentKey, obj);
        }
        return memo;
    };
    return function(obj, iteratee, memo, context) {
        var initial = arguments.length >= 3;
        return reducer(obj, (0, $8Vo92.default)(iteratee, context, 4), memo, initial);
    };
}

});


parcelRegister("6BBNz", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4cf384cb4103366f$export$2e2bcd8739ae039; });

var $KgPOi = parcelRequire("KgPOi");
var // The right-associative version of reduce, also known as `foldr`.
$4cf384cb4103366f$export$2e2bcd8739ae039 = (0, $KgPOi.default)(-1);

});

parcelRegister("efEt3", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a601db6defdca403$export$2e2bcd8739ae039; });

var $2N7PR = parcelRequire("2N7PR");

var $bPbGS = parcelRequire("bPbGS");
function $a601db6defdca403$export$2e2bcd8739ae039(obj, predicate, context) {
    var results = [];
    predicate = (0, $2N7PR.default)(predicate, context);
    (0, $bPbGS.default)(obj, function(value, index, list) {
        if (predicate(value, index, list)) results.push(value);
    });
    return results;
}

});

parcelRegister("8BknA", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6431965fb9a38135$export$2e2bcd8739ae039; });

var $efEt3 = parcelRequire("efEt3");

var $fEZb2 = parcelRequire("fEZb2");

var $2N7PR = parcelRequire("2N7PR");
function $6431965fb9a38135$export$2e2bcd8739ae039(obj, predicate, context) {
    return (0, $efEt3.default)(obj, (0, $fEZb2.default)((0, $2N7PR.default)(predicate)), context);
}

});

parcelRegister("22GE8", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $17ccd959cd154dde$export$2e2bcd8739ae039; });

var $2N7PR = parcelRequire("2N7PR");

var $7oRXK = parcelRequire("7oRXK");

var $4LWsK = parcelRequire("4LWsK");
function $17ccd959cd154dde$export$2e2bcd8739ae039(obj, predicate, context) {
    predicate = (0, $2N7PR.default)(predicate, context);
    var _keys = !(0, $7oRXK.default)(obj) && (0, $4LWsK.default)(obj), length = (_keys || obj).length;
    for(var index = 0; index < length; index++){
        var currentKey = _keys ? _keys[index] : index;
        if (!predicate(obj[currentKey], currentKey, obj)) return false;
    }
    return true;
}

});

parcelRegister("ctpBH", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $914c0e7c15408708$export$2e2bcd8739ae039; });

var $2N7PR = parcelRequire("2N7PR");

var $7oRXK = parcelRequire("7oRXK");

var $4LWsK = parcelRequire("4LWsK");
function $914c0e7c15408708$export$2e2bcd8739ae039(obj, predicate, context) {
    predicate = (0, $2N7PR.default)(predicate, context);
    var _keys = !(0, $7oRXK.default)(obj) && (0, $4LWsK.default)(obj), length = (_keys || obj).length;
    for(var index = 0; index < length; index++){
        var currentKey = _keys ? _keys[index] : index;
        if (predicate(obj[currentKey], currentKey, obj)) return true;
    }
    return false;
}

});

parcelRegister("9z2eX", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6f691ed4dc02b231$export$2e2bcd8739ae039; });

var $7oRXK = parcelRequire("7oRXK");

var $gNJrf = parcelRequire("gNJrf");

var $5YGUS = parcelRequire("5YGUS");
function $6f691ed4dc02b231$export$2e2bcd8739ae039(obj, item, fromIndex, guard) {
    if (!(0, $7oRXK.default)(obj)) obj = (0, $gNJrf.default)(obj);
    if (typeof fromIndex != 'number' || guard) fromIndex = 0;
    return (0, $5YGUS.default)(obj, item, fromIndex) >= 0;
}

});

parcelRegister("kDigY", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f0559fbd1d840c88$export$2e2bcd8739ae039; });

var $cutdK = parcelRequire("cutdK");

var $ciHuQ = parcelRequire("ciHuQ");

var $gfTwJ = parcelRequire("gfTwJ");

var $5SQJQ = parcelRequire("5SQJQ");

var $fXtgO = parcelRequire("fXtgO");
var // Invoke a method (with arguments) on every item in a collection.
$f0559fbd1d840c88$export$2e2bcd8739ae039 = (0, $cutdK.default)(function(obj, path, args) {
    var contextPath, func;
    if ((0, $ciHuQ.default)(path)) func = path;
    else {
        path = (0, $fXtgO.default)(path);
        contextPath = path.slice(0, -1);
        path = path[path.length - 1];
    }
    return (0, $gfTwJ.default)(obj, function(context) {
        var method = func;
        if (!method) {
            if (contextPath && contextPath.length) context = (0, $5SQJQ.default)(context, contextPath);
            if (context == null) return void 0;
            method = context[path];
        }
        return method == null ? method : method.apply(context, args);
    });
});

});

parcelRegister("gS9W9", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c48965be961a0b5e$export$2e2bcd8739ae039; });

var $gfTwJ = parcelRequire("gfTwJ");

var $cVGk0 = parcelRequire("cVGk0");
function $c48965be961a0b5e$export$2e2bcd8739ae039(obj, key) {
    return (0, $gfTwJ.default)(obj, (0, $cVGk0.default)(key));
}

});

parcelRegister("9zRTj", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6f912f9beed8a45b$export$2e2bcd8739ae039; });

var $efEt3 = parcelRequire("efEt3");

var $fWh3j = parcelRequire("fWh3j");
function $6f912f9beed8a45b$export$2e2bcd8739ae039(obj, attrs) {
    return (0, $efEt3.default)(obj, (0, $fWh3j.default)(attrs));
}

});

parcelRegister("fUZrG", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b96bbfc8df9255ae$export$2e2bcd8739ae039; });

var $7oRXK = parcelRequire("7oRXK");

var $gNJrf = parcelRequire("gNJrf");

var $2N7PR = parcelRequire("2N7PR");

var $bPbGS = parcelRequire("bPbGS");
function $b96bbfc8df9255ae$export$2e2bcd8739ae039(obj, iteratee, context) {
    var result = -Infinity, lastComputed = -Infinity, value, computed;
    if (iteratee == null || typeof iteratee == 'number' && typeof obj[0] != 'object' && obj != null) {
        obj = (0, $7oRXK.default)(obj) ? obj : (0, $gNJrf.default)(obj);
        for(var i = 0, length = obj.length; i < length; i++){
            value = obj[i];
            if (value != null && value > result) result = value;
        }
    } else {
        iteratee = (0, $2N7PR.default)(iteratee, context);
        (0, $bPbGS.default)(obj, function(v, index, list) {
            computed = iteratee(v, index, list);
            if (computed > lastComputed || computed === -Infinity && result === -Infinity) {
                result = v;
                lastComputed = computed;
            }
        });
    }
    return result;
}

});

parcelRegister("2OrAw", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $20c5a6b2bb99f83f$export$2e2bcd8739ae039; });

var $7oRXK = parcelRequire("7oRXK");

var $gNJrf = parcelRequire("gNJrf");

var $2N7PR = parcelRequire("2N7PR");

var $bPbGS = parcelRequire("bPbGS");
function $20c5a6b2bb99f83f$export$2e2bcd8739ae039(obj, iteratee, context) {
    var result = Infinity, lastComputed = Infinity, value, computed;
    if (iteratee == null || typeof iteratee == 'number' && typeof obj[0] != 'object' && obj != null) {
        obj = (0, $7oRXK.default)(obj) ? obj : (0, $gNJrf.default)(obj);
        for(var i = 0, length = obj.length; i < length; i++){
            value = obj[i];
            if (value != null && value < result) result = value;
        }
    } else {
        iteratee = (0, $2N7PR.default)(iteratee, context);
        (0, $bPbGS.default)(obj, function(v, index, list) {
            computed = iteratee(v, index, list);
            if (computed < lastComputed || computed === Infinity && result === Infinity) {
                result = v;
                lastComputed = computed;
            }
        });
    }
    return result;
}

});

parcelRegister("jujdW", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e2ffbb203f30980c$export$2e2bcd8739ae039; });

var $3k55B = parcelRequire("3k55B");
function $e2ffbb203f30980c$export$2e2bcd8739ae039(obj) {
    return (0, $3k55B.default)(obj, Infinity);
}

});
parcelRegister("3k55B", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $26b72ff9def6829e$export$2e2bcd8739ae039; });

var $7oRXK = parcelRequire("7oRXK");

var $gNJrf = parcelRequire("gNJrf");

var $ikQKR = parcelRequire("ikQKR");

var $5ImvW = parcelRequire("5ImvW");

var $1N8dN = parcelRequire("1N8dN");
function $26b72ff9def6829e$export$2e2bcd8739ae039(obj, n, guard) {
    if (n == null || guard) {
        if (!(0, $7oRXK.default)(obj)) obj = (0, $gNJrf.default)(obj);
        return obj[(0, $5ImvW.default)(obj.length - 1)];
    }
    var sample = (0, $1N8dN.default)(obj);
    var length = (0, $ikQKR.default)(sample);
    n = Math.max(Math.min(n, length), 0);
    var last = length - 1;
    for(var index = 0; index < n; index++){
        var rand = (0, $5ImvW.default)(index, last);
        var temp = sample[index];
        sample[index] = sample[rand];
        sample[rand] = temp;
    }
    return sample.slice(0, n);
}

});
parcelRegister("1N8dN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $14e0beac4b981966$export$2e2bcd8739ae039; });

var $3rBlz = parcelRequire("3rBlz");

var $lKa0l = parcelRequire("lKa0l");

var $jmGFg = parcelRequire("jmGFg");

var $7oRXK = parcelRequire("7oRXK");

var $gfTwJ = parcelRequire("gfTwJ");

var $3Ft8y = parcelRequire("3Ft8y");

var $gNJrf = parcelRequire("gNJrf");
// Safely create a real, live array from anything iterable.
var $14e0beac4b981966$var$reStrSymbol = /[^\ud800-\udfff]|[\ud800-\udbff][\udc00-\udfff]|[\ud800-\udfff]/g;
function $14e0beac4b981966$export$2e2bcd8739ae039(obj) {
    if (!obj) return [];
    if ((0, $3rBlz.default)(obj)) return (0, $lKa0l.slice).call(obj);
    if ((0, $jmGFg.default)(obj)) // Keep surrogate pair characters together.
    return obj.match($14e0beac4b981966$var$reStrSymbol);
    if ((0, $7oRXK.default)(obj)) return (0, $gfTwJ.default)(obj, (0, $3Ft8y.default));
    return (0, $gNJrf.default)(obj);
}

});



parcelRegister("eVdJn", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $02cdb1b6867de149$export$2e2bcd8739ae039; });

var $2N7PR = parcelRequire("2N7PR");

var $gS9W9 = parcelRequire("gS9W9");

var $gfTwJ = parcelRequire("gfTwJ");
function $02cdb1b6867de149$export$2e2bcd8739ae039(obj, iteratee, context) {
    var index = 0;
    iteratee = (0, $2N7PR.default)(iteratee, context);
    return (0, $gS9W9.default)((0, $gfTwJ.default)(obj, function(value, key, list) {
        return {
            value: value,
            index: index++,
            criteria: iteratee(value, key, list)
        };
    }).sort(function(left, right) {
        var a = left.criteria;
        var b = right.criteria;
        if (a !== b) {
            if (a > b || a === void 0) return 1;
            if (a < b || b === void 0) return -1;
        }
        return left.index - right.index;
    }), 'value');
}

});

parcelRegister("dqbTp", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9c56edb3465e8721$export$2e2bcd8739ae039; });

var $5DPc6 = parcelRequire("5DPc6");

var $iFtQd = parcelRequire("iFtQd");
var // Groups the object's values by a criterion. Pass either a string attribute
// to group by, or a function that returns the criterion.
$9c56edb3465e8721$export$2e2bcd8739ae039 = (0, $5DPc6.default)(function(result, value, key) {
    if ((0, $iFtQd.default)(result, key)) result[key].push(value);
    else result[key] = [
        value
    ];
});

});
parcelRegister("5DPc6", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $41b84e5cd8af26ee$export$2e2bcd8739ae039; });

var $2N7PR = parcelRequire("2N7PR");

var $bPbGS = parcelRequire("bPbGS");
function $41b84e5cd8af26ee$export$2e2bcd8739ae039(behavior, partition) {
    return function(obj, iteratee, context) {
        var result = partition ? [
            [],
            []
        ] : {};
        iteratee = (0, $2N7PR.default)(iteratee, context);
        (0, $bPbGS.default)(obj, function(value, index) {
            var key = iteratee(value, index, obj);
            behavior(result, value, key);
        });
        return result;
    };
}

});


parcelRegister("bJcvr", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $889d99270c0c4253$export$2e2bcd8739ae039; });

var $5DPc6 = parcelRequire("5DPc6");
var // Indexes the object's values by a criterion, similar to `_.groupBy`, but for
// when you know that your index values will be unique.
$889d99270c0c4253$export$2e2bcd8739ae039 = (0, $5DPc6.default)(function(result, value, key) {
    result[key] = value;
});

});

parcelRegister("bRnHN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8a270854b2c89792$export$2e2bcd8739ae039; });

var $5DPc6 = parcelRequire("5DPc6");

var $iFtQd = parcelRequire("iFtQd");
var // Counts instances of an object that group by a certain criterion. Pass
// either a string attribute to count by, or a function that returns the
// criterion.
$8a270854b2c89792$export$2e2bcd8739ae039 = (0, $5DPc6.default)(function(result, value, key) {
    if ((0, $iFtQd.default)(result, key)) result[key]++;
    else result[key] = 1;
});

});

parcelRegister("2fwpY", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1a3620ff2b2d0061$export$2e2bcd8739ae039; });

var $5DPc6 = parcelRequire("5DPc6");
var // Split a collection into two arrays: one whose elements all pass the given
// truth test, and one whose elements all do not pass the truth test.
$1a3620ff2b2d0061$export$2e2bcd8739ae039 = (0, $5DPc6.default)(function(result, value, pass) {
    result[pass ? 0 : 1].push(value);
}, true);

});

parcelRegister("iTCYf", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $dc1b97d2613cc98e$export$2e2bcd8739ae039; });

var $7oRXK = parcelRequire("7oRXK");

var $4LWsK = parcelRequire("4LWsK");
function $dc1b97d2613cc98e$export$2e2bcd8739ae039(obj) {
    if (obj == null) return 0;
    return (0, $7oRXK.default)(obj) ? obj.length : (0, $4LWsK.default)(obj).length;
}

});

parcelRegister("3fpzD", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $25d69c3d18b9086f$export$2e2bcd8739ae039; });

var $cutdK = parcelRequire("cutdK");

var $ciHuQ = parcelRequire("ciHuQ");

var $8Vo92 = parcelRequire("8Vo92");

var $jZVkW = parcelRequire("jZVkW");

var $cHHKf = parcelRequire("cHHKf");

var $llkFL = parcelRequire("llkFL");
var // Return a copy of the object only containing the allowed properties.
$25d69c3d18b9086f$export$2e2bcd8739ae039 = (0, $cutdK.default)(function(obj, keys) {
    var result = {}, iteratee = keys[0];
    if (obj == null) return result;
    if ((0, $ciHuQ.default)(iteratee)) {
        if (keys.length > 1) iteratee = (0, $8Vo92.default)(iteratee, keys[1]);
        keys = (0, $jZVkW.default)(obj);
    } else {
        iteratee = (0, $cHHKf.default);
        keys = (0, $llkFL.default)(keys, false, false);
        obj = Object(obj);
    }
    for(var i = 0, length = keys.length; i < length; i++){
        var key = keys[i];
        var value = obj[key];
        if (iteratee(value, key, obj)) result[key] = value;
    }
    return result;
});

});
parcelRegister("cHHKf", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $93fb6f09932fc0de$export$2e2bcd8739ae039; });
// Internal `_.pick` helper function to determine whether `key` is an enumerable
// property name of `obj`.
function $93fb6f09932fc0de$export$2e2bcd8739ae039(value, key, obj) {
    return key in obj;
}

});


parcelRegister("jrEl1", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e27fd4376120ac63$export$2e2bcd8739ae039; });

var $cutdK = parcelRequire("cutdK");

var $ciHuQ = parcelRequire("ciHuQ");

var $fEZb2 = parcelRequire("fEZb2");

var $gfTwJ = parcelRequire("gfTwJ");

var $llkFL = parcelRequire("llkFL");

var $9z2eX = parcelRequire("9z2eX");

var $3fpzD = parcelRequire("3fpzD");
var // Return a copy of the object without the disallowed properties.
$e27fd4376120ac63$export$2e2bcd8739ae039 = (0, $cutdK.default)(function(obj, keys) {
    var iteratee = keys[0], context;
    if ((0, $ciHuQ.default)(iteratee)) {
        iteratee = (0, $fEZb2.default)(iteratee);
        if (keys.length > 1) context = keys[1];
    } else {
        keys = (0, $gfTwJ.default)((0, $llkFL.default)(keys, false, false), String);
        iteratee = function(value, key) {
            return !(0, $9z2eX.default)(keys, key);
        };
    }
    return (0, $3fpzD.default)(obj, iteratee, context);
});

});

parcelRegister("fcTdF", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b122cf7206c4600f$export$2e2bcd8739ae039; });

var $c4yYd = parcelRequire("c4yYd");
function $b122cf7206c4600f$export$2e2bcd8739ae039(array, n, guard) {
    if (array == null || array.length < 1) return n == null || guard ? void 0 : [];
    if (n == null || guard) return array[0];
    return (0, $c4yYd.default)(array, array.length - n);
}

});
parcelRegister("c4yYd", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8ca0fc1d9d26540f$export$2e2bcd8739ae039; });

var $lKa0l = parcelRequire("lKa0l");
function $8ca0fc1d9d26540f$export$2e2bcd8739ae039(array, n, guard) {
    return (0, $lKa0l.slice).call(array, 0, Math.max(0, array.length - (n == null || guard ? 1 : n)));
}

});


parcelRegister("hB3Xt", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ccf8f6656096fc9e$export$2e2bcd8739ae039; });

var $2lrEW = parcelRequire("2lrEW");
function $ccf8f6656096fc9e$export$2e2bcd8739ae039(array, n, guard) {
    if (array == null || array.length < 1) return n == null || guard ? void 0 : [];
    if (n == null || guard) return array[array.length - 1];
    return (0, $2lrEW.default)(array, Math.max(0, array.length - n));
}

});
parcelRegister("2lrEW", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1b52ff80b70daaf3$export$2e2bcd8739ae039; });

var $lKa0l = parcelRequire("lKa0l");
function $1b52ff80b70daaf3$export$2e2bcd8739ae039(array, n, guard) {
    return (0, $lKa0l.slice).call(array, n == null || guard ? 1 : n);
}

});


parcelRegister("ees8X", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a5c83433fdfe3e44$export$2e2bcd8739ae039; });

var $efEt3 = parcelRequire("efEt3");
function $a5c83433fdfe3e44$export$2e2bcd8739ae039(array) {
    return (0, $efEt3.default)(array, Boolean);
}

});

parcelRegister("1TwZj", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $161484322f084ce0$export$2e2bcd8739ae039; });

var $llkFL = parcelRequire("llkFL");
function $161484322f084ce0$export$2e2bcd8739ae039(array, depth) {
    return (0, $llkFL.default)(array, depth, false);
}

});

parcelRegister("5jrxQ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3de417f0ce666c4e$export$2e2bcd8739ae039; });

var $cutdK = parcelRequire("cutdK");

var $89CXs = parcelRequire("89CXs");
var // Return a version of the array that does not contain the specified value(s).
$3de417f0ce666c4e$export$2e2bcd8739ae039 = (0, $cutdK.default)(function(array, otherArrays) {
    return (0, $89CXs.default)(array, otherArrays);
});

});
parcelRegister("89CXs", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5efd623734a14e6b$export$2e2bcd8739ae039; });

var $cutdK = parcelRequire("cutdK");

var $llkFL = parcelRequire("llkFL");

var $efEt3 = parcelRequire("efEt3");

var $9z2eX = parcelRequire("9z2eX");
var // Take the difference between one array and a number of other arrays.
// Only the elements present in just the first array will remain.
$5efd623734a14e6b$export$2e2bcd8739ae039 = (0, $cutdK.default)(function(array, rest) {
    rest = (0, $llkFL.default)(rest, true, true);
    return (0, $efEt3.default)(array, function(value) {
        return !(0, $9z2eX.default)(rest, value);
    });
});

});


parcelRegister("iUtSI", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $dc44a2cf659b8de9$export$2e2bcd8739ae039; });

var $aY7I7 = parcelRequire("aY7I7");

var $2N7PR = parcelRequire("2N7PR");

var $ikQKR = parcelRequire("ikQKR");

var $9z2eX = parcelRequire("9z2eX");
function $dc44a2cf659b8de9$export$2e2bcd8739ae039(array, isSorted, iteratee, context) {
    if (!(0, $aY7I7.default)(isSorted)) {
        context = iteratee;
        iteratee = isSorted;
        isSorted = false;
    }
    if (iteratee != null) iteratee = (0, $2N7PR.default)(iteratee, context);
    var result = [];
    var seen = [];
    for(var i = 0, length = (0, $ikQKR.default)(array); i < length; i++){
        var value = array[i], computed = iteratee ? iteratee(value, i, array) : value;
        if (isSorted && !iteratee) {
            if (!i || seen !== computed) result.push(value);
            seen = computed;
        } else if (iteratee) {
            if (!(0, $9z2eX.default)(seen, computed)) {
                seen.push(computed);
                result.push(value);
            }
        } else if (!(0, $9z2eX.default)(result, value)) result.push(value);
    }
    return result;
}

});

parcelRegister("1XgTs", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $16c867d0c8d96094$export$2e2bcd8739ae039; });

var $cutdK = parcelRequire("cutdK");

var $iUtSI = parcelRequire("iUtSI");

var $llkFL = parcelRequire("llkFL");
var // Produce an array that contains the union: each distinct element from all of
// the passed-in arrays.
$16c867d0c8d96094$export$2e2bcd8739ae039 = (0, $cutdK.default)(function(arrays) {
    return (0, $iUtSI.default)((0, $llkFL.default)(arrays, true, true));
});

});

parcelRegister("2ycy0", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1db87d6b6cafdd1f$export$2e2bcd8739ae039; });

var $ikQKR = parcelRequire("ikQKR");

var $9z2eX = parcelRequire("9z2eX");
function $1db87d6b6cafdd1f$export$2e2bcd8739ae039(array) {
    var result = [];
    var argsLength = arguments.length;
    for(var i = 0, length = (0, $ikQKR.default)(array); i < length; i++){
        var item = array[i];
        if ((0, $9z2eX.default)(result, item)) continue;
        var j;
        for(j = 1; j < argsLength; j++){
            if (!(0, $9z2eX.default)(arguments[j], item)) break;
        }
        if (j === argsLength) result.push(item);
    }
    return result;
}

});

parcelRegister("e9qP4", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a4d6b663e257bc5d$export$2e2bcd8739ae039; });

var $fUZrG = parcelRequire("fUZrG");

var $ikQKR = parcelRequire("ikQKR");

var $gS9W9 = parcelRequire("gS9W9");
function $a4d6b663e257bc5d$export$2e2bcd8739ae039(array) {
    var length = array && (0, $fUZrG.default)(array, (0, $ikQKR.default)).length || 0;
    var result = Array(length);
    for(var index = 0; index < length; index++)result[index] = (0, $gS9W9.default)(array, index);
    return result;
}

});

parcelRegister("8DaDZ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $648a38f2341332c5$export$2e2bcd8739ae039; });

var $cutdK = parcelRequire("cutdK");

var $e9qP4 = parcelRequire("e9qP4");
var // Zip together multiple lists into a single array -- elements that share
// an index go together.
$648a38f2341332c5$export$2e2bcd8739ae039 = (0, $cutdK.default)((0, $e9qP4.default));

});

parcelRegister("kdGCR", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $eb861621d01e2e0e$export$2e2bcd8739ae039; });

var $ikQKR = parcelRequire("ikQKR");
function $eb861621d01e2e0e$export$2e2bcd8739ae039(list, values) {
    var result = {};
    for(var i = 0, length = (0, $ikQKR.default)(list); i < length; i++)if (values) result[list[i]] = values[i];
    else result[list[i][0]] = list[i][1];
    return result;
}

});

parcelRegister("ds2Lz", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9cb00938f165cd06$export$2e2bcd8739ae039; });
// Generate an integer Array containing an arithmetic progression. A port of
// the native Python `range()` function. See
// [the Python documentation](https://docs.python.org/library/functions.html#range).
function $9cb00938f165cd06$export$2e2bcd8739ae039(start, stop, step) {
    if (stop == null) {
        stop = start || 0;
        start = 0;
    }
    if (!step) step = stop < start ? -1 : 1;
    var length = Math.max(Math.ceil((stop - start) / step), 0);
    var range = Array(length);
    for(var idx = 0; idx < length; idx++, start += step)range[idx] = start;
    return range;
}

});

parcelRegister("idngN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d42b7dcf53b1de61$export$2e2bcd8739ae039; });

var $lKa0l = parcelRequire("lKa0l");
function $d42b7dcf53b1de61$export$2e2bcd8739ae039(array, count) {
    if (count == null || count < 1) return [];
    var result = [];
    var i = 0, length = array.length;
    while(i < length)result.push((0, $lKa0l.slice).call(array, i, i += count));
    return result;
}

});

parcelRegister("j2rdI", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ddc3519bb2fc2ff8$export$2e2bcd8739ae039; });

var $tYVIv = parcelRequire("tYVIv");

var $bPbGS = parcelRequire("bPbGS");

var $l07og = parcelRequire("l07og");

var $lKa0l = parcelRequire("lKa0l");

var $cYBQd = parcelRequire("cYBQd");
function $ddc3519bb2fc2ff8$export$2e2bcd8739ae039(obj) {
    (0, $bPbGS.default)((0, $l07og.default)(obj), function(name) {
        var func = (0, $tYVIv.default)[name] = obj[name];
        (0, $tYVIv.default).prototype[name] = function() {
            var args = [
                this._wrapped
            ];
            (0, $lKa0l.push).apply(args, arguments);
            return (0, $cYBQd.default)(this, func.apply((0, $tYVIv.default), args));
        };
    });
    return 0, $tYVIv.default;
}

});
parcelRegister("cYBQd", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9728711803967dc4$export$2e2bcd8739ae039; });

var $tYVIv = parcelRequire("tYVIv");
function $9728711803967dc4$export$2e2bcd8739ae039(instance, obj) {
    return instance._chain ? (0, $tYVIv.default)(obj).chain() : obj;
}

});


parcelRegister("OKn95", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0988a433cdc9bbe6$export$2e2bcd8739ae039; });

var $tYVIv = parcelRequire("tYVIv");

var $bPbGS = parcelRequire("bPbGS");

var $lKa0l = parcelRequire("lKa0l");

var $cYBQd = parcelRequire("cYBQd");
// Add all mutator `Array` functions to the wrapper.
(0, $bPbGS.default)([
    'pop',
    'push',
    'reverse',
    'shift',
    'sort',
    'splice',
    'unshift'
], function(name) {
    var method = (0, $lKa0l.ArrayProto)[name];
    (0, $tYVIv.default).prototype[name] = function() {
        var obj = this._wrapped;
        if (obj != null) {
            method.apply(obj, arguments);
            if ((name === 'shift' || name === 'splice') && obj.length === 0) delete obj[0];
        }
        return (0, $cYBQd.default)(this, obj);
    };
});
// Add all accessor `Array` functions to the wrapper.
(0, $bPbGS.default)([
    'concat',
    'join',
    'slice'
], function(name) {
    var method = (0, $lKa0l.ArrayProto)[name];
    (0, $tYVIv.default).prototype[name] = function() {
        var obj = this._wrapped;
        if (obj != null) obj = method.apply(obj, arguments);
        return (0, $cYBQd.default)(this, obj);
    };
});
var $0988a433cdc9bbe6$export$2e2bcd8739ae039 = (0, $tYVIv.default);

});





parcelRegister("jah0F", function(module, exports) {

$parcel$export(module.exports, "parseFromString", function () { return $df3c2546698cd37a$export$26cfb4a895d40b24; }, function (v) { return $df3c2546698cd37a$export$26cfb4a895d40b24 = v; });
$parcel$export(module.exports, "Node", function () { return $df3c2546698cd37a$export$85c928794f8d04d4; }, function (v) { return $df3c2546698cd37a$export$85c928794f8d04d4 = v; });
var $df3c2546698cd37a$export$26cfb4a895d40b24;
var $df3c2546698cd37a$export$85c928794f8d04d4;

var $7cu9k = parcelRequire("7cu9k");

var $6aORb = parcelRequire("6aORb");
function $df3c2546698cd37a$var$parseFromString(string) {
    var error = null;
    var domParser = new $7cu9k.DOMParser({
        errorHandler: function(level, message) {
            error = {
                level: level,
                message: message
            };
        }
    });
    var document = domParser.parseFromString(string);
    if (error === null) return document;
    else throw new Error(error.level + ": " + error.message);
}
$df3c2546698cd37a$export$26cfb4a895d40b24 = $df3c2546698cd37a$var$parseFromString;
$df3c2546698cd37a$export$85c928794f8d04d4 = $6aORb.Node;

});
parcelRegister("7cu9k", function(module, exports) {

$parcel$export(module.exports, "DOMParser", function () { return $53e10a6f388afa3b$export$1059c6e7d2ce5669; }, function (v) { return $53e10a6f388afa3b$export$1059c6e7d2ce5669 = v; });
var $53e10a6f388afa3b$export$455426655eab1d48;
var $53e10a6f388afa3b$export$64f0bed4ae6f0f24;
var $53e10a6f388afa3b$export$1059c6e7d2ce5669;

var $6aORb = parcelRequire("6aORb");
$53e10a6f388afa3b$export$455426655eab1d48 = $6aORb.DOMImplementation;
$53e10a6f388afa3b$export$64f0bed4ae6f0f24 = $6aORb.XMLSerializer;

$53e10a6f388afa3b$export$1059c6e7d2ce5669 = (parcelRequire("dQ0RX")).DOMParser;

});
parcelRegister("6aORb", function(module, exports) {

$parcel$export(module.exports, "DOMImplementation", function () { return $47eb2057f4163810$export$455426655eab1d48; }, function (v) { return $47eb2057f4163810$export$455426655eab1d48 = v; });
$parcel$export(module.exports, "Node", function () { return $47eb2057f4163810$export$85c928794f8d04d4; }, function (v) { return $47eb2057f4163810$export$85c928794f8d04d4 = v; });
$parcel$export(module.exports, "XMLSerializer", function () { return $47eb2057f4163810$export$64f0bed4ae6f0f24; }, function (v) { return $47eb2057f4163810$export$64f0bed4ae6f0f24 = v; });
//if(typeof require == 'function'){
var $47eb2057f4163810$export$d1d99cf900472499;
var $47eb2057f4163810$export$fe58bcf938607f6a;
var $47eb2057f4163810$export$455426655eab1d48;
var $47eb2057f4163810$export$db77ccec0bb4ccac;
var $47eb2057f4163810$export$85c928794f8d04d4;
var $47eb2057f4163810$export$79b41aa5d56abdff;
var $47eb2057f4163810$export$5118471ee5d5453b;
var $47eb2057f4163810$export$64f0bed4ae6f0f24;

var $aeRet = parcelRequire("aeRet");
var $47eb2057f4163810$var$find = $aeRet.find;
var $47eb2057f4163810$var$NAMESPACE = $aeRet.NAMESPACE;
/**
 * A prerequisite for `[].filter`, to drop elements that are empty
 * @param {string} input
 * @returns {boolean}
 */ function $47eb2057f4163810$var$notEmptyString(input) {
    return input !== '';
}
/**
 * @see https://infra.spec.whatwg.org/#split-on-ascii-whitespace
 * @see https://infra.spec.whatwg.org/#ascii-whitespace
 *
 * @param {string} input
 * @returns {string[]} (can be empty)
 */ function $47eb2057f4163810$var$splitOnASCIIWhitespace(input) {
    // U+0009 TAB, U+000A LF, U+000C FF, U+000D CR, U+0020 SPACE
    return input ? input.split(/[\t\n\f\r ]+/).filter($47eb2057f4163810$var$notEmptyString) : [];
}
/**
 * Adds element as a key to current if it is not already present.
 *
 * @param {Record<string, boolean | undefined>} current
 * @param {string} element
 * @returns {Record<string, boolean | undefined>}
 */ function $47eb2057f4163810$var$orderedSetReducer(current, element) {
    if (!current.hasOwnProperty(element)) current[element] = true;
    return current;
}
/**
 * @see https://infra.spec.whatwg.org/#ordered-set
 * @param {string} input
 * @returns {string[]}
 */ function $47eb2057f4163810$var$toOrderedSet(input) {
    if (!input) return [];
    var list = $47eb2057f4163810$var$splitOnASCIIWhitespace(input);
    return Object.keys(list.reduce($47eb2057f4163810$var$orderedSetReducer, {}));
}
/**
 * Uses `list.indexOf` to implement something like `Array.prototype.includes`,
 * which we can not rely on being available.
 *
 * @param {any[]} list
 * @returns {function(any): boolean}
 */ function $47eb2057f4163810$var$arrayIncludes(list) {
    return function(element) {
        return list && list.indexOf(element) !== -1;
    };
}
function $47eb2057f4163810$var$copy(src, dest) {
    for(var p in src)if (Object.prototype.hasOwnProperty.call(src, p)) dest[p] = src[p];
}
/**
^\w+\.prototype\.([_\w]+)\s*=\s*((?:.*\{\s*?[\r\n][\s\S]*?^})|\S.*?(?=[;\r\n]));?
^\w+\.prototype\.([_\w]+)\s*=\s*(\S.*?(?=[;\r\n]));?
 */ function $47eb2057f4163810$var$_extends(Class, Super) {
    var pt = Class.prototype;
    if (!(pt instanceof Super)) {
        function t() {}
        t.prototype = Super.prototype;
        t = new t();
        $47eb2057f4163810$var$copy(pt, t);
        Class.prototype = pt = t;
    }
    if (pt.constructor != Class) {
        if (typeof Class != 'function') console.error("unknown Class:" + Class);
        pt.constructor = Class;
    }
}
// Node Types
var $47eb2057f4163810$var$NodeType = {};
var $47eb2057f4163810$var$ELEMENT_NODE = $47eb2057f4163810$var$NodeType.ELEMENT_NODE = 1;
var $47eb2057f4163810$var$ATTRIBUTE_NODE = $47eb2057f4163810$var$NodeType.ATTRIBUTE_NODE = 2;
var $47eb2057f4163810$var$TEXT_NODE = $47eb2057f4163810$var$NodeType.TEXT_NODE = 3;
var $47eb2057f4163810$var$CDATA_SECTION_NODE = $47eb2057f4163810$var$NodeType.CDATA_SECTION_NODE = 4;
var $47eb2057f4163810$var$ENTITY_REFERENCE_NODE = $47eb2057f4163810$var$NodeType.ENTITY_REFERENCE_NODE = 5;
var $47eb2057f4163810$var$ENTITY_NODE = $47eb2057f4163810$var$NodeType.ENTITY_NODE = 6;
var $47eb2057f4163810$var$PROCESSING_INSTRUCTION_NODE = $47eb2057f4163810$var$NodeType.PROCESSING_INSTRUCTION_NODE = 7;
var $47eb2057f4163810$var$COMMENT_NODE = $47eb2057f4163810$var$NodeType.COMMENT_NODE = 8;
var $47eb2057f4163810$var$DOCUMENT_NODE = $47eb2057f4163810$var$NodeType.DOCUMENT_NODE = 9;
var $47eb2057f4163810$var$DOCUMENT_TYPE_NODE = $47eb2057f4163810$var$NodeType.DOCUMENT_TYPE_NODE = 10;
var $47eb2057f4163810$var$DOCUMENT_FRAGMENT_NODE = $47eb2057f4163810$var$NodeType.DOCUMENT_FRAGMENT_NODE = 11;
var $47eb2057f4163810$var$NOTATION_NODE = $47eb2057f4163810$var$NodeType.NOTATION_NODE = 12;
// ExceptionCode
var $47eb2057f4163810$var$ExceptionCode = {};
var $47eb2057f4163810$var$ExceptionMessage = {};
var $47eb2057f4163810$var$INDEX_SIZE_ERR = $47eb2057f4163810$var$ExceptionCode.INDEX_SIZE_ERR = ($47eb2057f4163810$var$ExceptionMessage[1] = "Index size error", 1);
var $47eb2057f4163810$var$DOMSTRING_SIZE_ERR = $47eb2057f4163810$var$ExceptionCode.DOMSTRING_SIZE_ERR = ($47eb2057f4163810$var$ExceptionMessage[2] = "DOMString size error", 2);
var $47eb2057f4163810$var$HIERARCHY_REQUEST_ERR = $47eb2057f4163810$var$ExceptionCode.HIERARCHY_REQUEST_ERR = ($47eb2057f4163810$var$ExceptionMessage[3] = "Hierarchy request error", 3);
var $47eb2057f4163810$var$WRONG_DOCUMENT_ERR = $47eb2057f4163810$var$ExceptionCode.WRONG_DOCUMENT_ERR = ($47eb2057f4163810$var$ExceptionMessage[4] = "Wrong document", 4);
var $47eb2057f4163810$var$INVALID_CHARACTER_ERR = $47eb2057f4163810$var$ExceptionCode.INVALID_CHARACTER_ERR = ($47eb2057f4163810$var$ExceptionMessage[5] = "Invalid character", 5);
var $47eb2057f4163810$var$NO_DATA_ALLOWED_ERR = $47eb2057f4163810$var$ExceptionCode.NO_DATA_ALLOWED_ERR = ($47eb2057f4163810$var$ExceptionMessage[6] = "No data allowed", 6);
var $47eb2057f4163810$var$NO_MODIFICATION_ALLOWED_ERR = $47eb2057f4163810$var$ExceptionCode.NO_MODIFICATION_ALLOWED_ERR = ($47eb2057f4163810$var$ExceptionMessage[7] = "No modification allowed", 7);
var $47eb2057f4163810$var$NOT_FOUND_ERR = $47eb2057f4163810$var$ExceptionCode.NOT_FOUND_ERR = ($47eb2057f4163810$var$ExceptionMessage[8] = "Not found", 8);
var $47eb2057f4163810$var$NOT_SUPPORTED_ERR = $47eb2057f4163810$var$ExceptionCode.NOT_SUPPORTED_ERR = ($47eb2057f4163810$var$ExceptionMessage[9] = "Not supported", 9);
var $47eb2057f4163810$var$INUSE_ATTRIBUTE_ERR = $47eb2057f4163810$var$ExceptionCode.INUSE_ATTRIBUTE_ERR = ($47eb2057f4163810$var$ExceptionMessage[10] = "Attribute in use", 10);
//level2
var $47eb2057f4163810$var$INVALID_STATE_ERR = $47eb2057f4163810$var$ExceptionCode.INVALID_STATE_ERR = ($47eb2057f4163810$var$ExceptionMessage[11] = "Invalid state", 11);
var $47eb2057f4163810$var$SYNTAX_ERR = $47eb2057f4163810$var$ExceptionCode.SYNTAX_ERR = ($47eb2057f4163810$var$ExceptionMessage[12] = "Syntax error", 12);
var $47eb2057f4163810$var$INVALID_MODIFICATION_ERR = $47eb2057f4163810$var$ExceptionCode.INVALID_MODIFICATION_ERR = ($47eb2057f4163810$var$ExceptionMessage[13] = "Invalid modification", 13);
var $47eb2057f4163810$var$NAMESPACE_ERR = $47eb2057f4163810$var$ExceptionCode.NAMESPACE_ERR = ($47eb2057f4163810$var$ExceptionMessage[14] = "Invalid namespace", 14);
var $47eb2057f4163810$var$INVALID_ACCESS_ERR = $47eb2057f4163810$var$ExceptionCode.INVALID_ACCESS_ERR = ($47eb2057f4163810$var$ExceptionMessage[15] = "Invalid access", 15);
/**
 * DOM Level 2
 * Object DOMException
 * @see http://www.w3.org/TR/2000/REC-DOM-Level-2-Core-20001113/ecma-script-binding.html
 * @see http://www.w3.org/TR/REC-DOM-Level-1/ecma-script-language-binding.html
 */ function $47eb2057f4163810$var$DOMException(code, message) {
    if (message instanceof Error) var error = message;
    else {
        error = this;
        Error.call(this, $47eb2057f4163810$var$ExceptionMessage[code]);
        this.message = $47eb2057f4163810$var$ExceptionMessage[code];
        if (Error.captureStackTrace) Error.captureStackTrace(this, $47eb2057f4163810$var$DOMException);
    }
    error.code = code;
    if (message) this.message = this.message + ": " + message;
    return error;
}
$47eb2057f4163810$var$DOMException.prototype = Error.prototype;
$47eb2057f4163810$var$copy($47eb2057f4163810$var$ExceptionCode, $47eb2057f4163810$var$DOMException);
/**
 * @see http://www.w3.org/TR/2000/REC-DOM-Level-2-Core-20001113/core.html#ID-536297177
 * The NodeList interface provides the abstraction of an ordered collection of nodes, without defining or constraining how this collection is implemented. NodeList objects in the DOM are live.
 * The items in the NodeList are accessible via an integral index, starting from 0.
 */ function $47eb2057f4163810$var$NodeList() {}
$47eb2057f4163810$var$NodeList.prototype = {
    /**
	 * The number of nodes in the list. The range of valid child node indices is 0 to length-1 inclusive.
	 * @standard level1
	 */ length: 0,
    /**
	 * Returns the indexth item in the collection. If index is greater than or equal to the number of nodes in the list, this returns null.
	 * @standard level1
	 * @param index  unsigned long
	 *   Index into the collection.
	 * @return Node
	 * 	The node at the indexth position in the NodeList, or null if that is not a valid index.
	 */ item: function(index) {
        return index >= 0 && index < this.length ? this[index] : null;
    },
    toString: function(isHTML, nodeFilter, options) {
        var requireWellFormed = !!options && !!options.requireWellFormed;
        for(var buf = [], i = 0; i < this.length; i++)$47eb2057f4163810$var$serializeToString(this[i], buf, isHTML, nodeFilter, null, requireWellFormed);
        return buf.join('');
    },
    /**
	 * @private
	 * @param {function (Node):boolean} predicate
	 * @returns {Node[]}
	 */ filter: function(predicate) {
        return Array.prototype.filter.call(this, predicate);
    },
    /**
	 * @private
	 * @param {Node} item
	 * @returns {number}
	 */ indexOf: function(item) {
        return Array.prototype.indexOf.call(this, item);
    }
};
function $47eb2057f4163810$var$LiveNodeList(node, refresh) {
    this._node = node;
    this._refresh = refresh;
    $47eb2057f4163810$var$_updateLiveList(this);
}
function $47eb2057f4163810$var$_updateLiveList(list) {
    var inc = list._node._inc || list._node.ownerDocument._inc;
    if (list._inc !== inc) {
        var ls = list._refresh(list._node);
        $47eb2057f4163810$var$__set__(list, 'length', ls.length);
        if (!list.$$length || ls.length < list.$$length) {
            for(var i = ls.length; i in list; i++)if (Object.prototype.hasOwnProperty.call(list, i)) delete list[i];
        }
        $47eb2057f4163810$var$copy(ls, list);
        list._inc = inc;
    }
}
$47eb2057f4163810$var$LiveNodeList.prototype.item = function(i) {
    $47eb2057f4163810$var$_updateLiveList(this);
    return this[i] || null;
};
$47eb2057f4163810$var$_extends($47eb2057f4163810$var$LiveNodeList, $47eb2057f4163810$var$NodeList);
/**
 * Objects implementing the NamedNodeMap interface are used
 * to represent collections of nodes that can be accessed by name.
 * Note that NamedNodeMap does not inherit from NodeList;
 * NamedNodeMaps are not maintained in any particular order.
 * Objects contained in an object implementing NamedNodeMap may also be accessed by an ordinal index,
 * but this is simply to allow convenient enumeration of the contents of a NamedNodeMap,
 * and does not imply that the DOM specifies an order to these Nodes.
 * NamedNodeMap objects in the DOM are live.
 * used for attributes or DocumentType entities
 */ function $47eb2057f4163810$var$NamedNodeMap() {}
function $47eb2057f4163810$var$_findNodeIndex(list, node) {
    var i = list.length;
    while(i--){
        if (list[i] === node) return i;
    }
}
function $47eb2057f4163810$var$_addNamedNode(el, list, newAttr, oldAttr) {
    if (oldAttr) list[$47eb2057f4163810$var$_findNodeIndex(list, oldAttr)] = newAttr;
    else list[list.length++] = newAttr;
    if (el) {
        newAttr.ownerElement = el;
        var doc = el.ownerDocument;
        if (doc) {
            oldAttr && $47eb2057f4163810$var$_onRemoveAttribute(doc, el, oldAttr);
            $47eb2057f4163810$var$_onAddAttribute(doc, el, newAttr);
        }
    }
}
function $47eb2057f4163810$var$_removeNamedNode(el, list, attr) {
    //console.log('remove attr:'+attr)
    var i = $47eb2057f4163810$var$_findNodeIndex(list, attr);
    if (i >= 0) {
        var lastIndex = list.length - 1;
        while(i < lastIndex)list[i] = list[++i];
        list.length = lastIndex;
        if (el) {
            var doc = el.ownerDocument;
            if (doc) {
                $47eb2057f4163810$var$_onRemoveAttribute(doc, el, attr);
                attr.ownerElement = null;
            }
        }
    } else throw new $47eb2057f4163810$var$DOMException($47eb2057f4163810$var$NOT_FOUND_ERR, new Error(el.tagName + '@' + attr));
}
$47eb2057f4163810$var$NamedNodeMap.prototype = {
    length: 0,
    item: $47eb2057f4163810$var$NodeList.prototype.item,
    getNamedItem: function(key) {
        //		if(key.indexOf(':')>0 || key == 'xmlns'){
        //			return null;
        //		}
        //console.log()
        var i = this.length;
        while(i--){
            var attr = this[i];
            //console.log(attr.nodeName,key)
            if (attr.nodeName == key) return attr;
        }
    },
    setNamedItem: function(attr) {
        var el = attr.ownerElement;
        if (el && el != this._ownerElement) throw new $47eb2057f4163810$var$DOMException($47eb2057f4163810$var$INUSE_ATTRIBUTE_ERR);
        var oldAttr = this.getNamedItem(attr.nodeName);
        $47eb2057f4163810$var$_addNamedNode(this._ownerElement, this, attr, oldAttr);
        return oldAttr;
    },
    /* returns Node */ setNamedItemNS: function(attr) {
        var el = attr.ownerElement, oldAttr;
        if (el && el != this._ownerElement) throw new $47eb2057f4163810$var$DOMException($47eb2057f4163810$var$INUSE_ATTRIBUTE_ERR);
        oldAttr = this.getNamedItemNS(attr.namespaceURI, attr.localName);
        $47eb2057f4163810$var$_addNamedNode(this._ownerElement, this, attr, oldAttr);
        return oldAttr;
    },
    /* returns Node */ removeNamedItem: function(key) {
        var attr = this.getNamedItem(key);
        $47eb2057f4163810$var$_removeNamedNode(this._ownerElement, this, attr);
        return attr;
    },
    //for level2
    removeNamedItemNS: function(namespaceURI, localName) {
        var attr = this.getNamedItemNS(namespaceURI, localName);
        $47eb2057f4163810$var$_removeNamedNode(this._ownerElement, this, attr);
        return attr;
    },
    getNamedItemNS: function(namespaceURI, localName) {
        var i = this.length;
        while(i--){
            var node = this[i];
            if (node.localName == localName && node.namespaceURI == namespaceURI) return node;
        }
        return null;
    }
};
/**
 * The DOMImplementation interface represents an object providing methods
 * which are not dependent on any particular document.
 * Such an object is returned by the `Document.implementation` property.
 *
 * __The individual methods describe the differences compared to the specs.__
 *
 * @constructor
 *
 * @see https://developer.mozilla.org/en-US/docs/Web/API/DOMImplementation MDN
 * @see https://www.w3.org/TR/REC-DOM-Level-1/level-one-core.html#ID-102161490 DOM Level 1 Core (Initial)
 * @see https://www.w3.org/TR/DOM-Level-2-Core/core.html#ID-102161490 DOM Level 2 Core
 * @see https://www.w3.org/TR/DOM-Level-3-Core/core.html#ID-102161490 DOM Level 3 Core
 * @see https://dom.spec.whatwg.org/#domimplementation DOM Living Standard
 */ function $47eb2057f4163810$var$DOMImplementation() {}
$47eb2057f4163810$var$DOMImplementation.prototype = {
    /**
	 * The DOMImplementation.hasFeature() method returns a Boolean flag indicating if a given feature is supported.
	 * The different implementations fairly diverged in what kind of features were reported.
	 * The latest version of the spec settled to force this method to always return true, where the functionality was accurate and in use.
	 *
	 * @deprecated It is deprecated and modern browsers return true in all cases.
	 *
	 * @param {string} feature
	 * @param {string} [version]
	 * @returns {boolean} always true
	 *
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/DOMImplementation/hasFeature MDN
	 * @see https://www.w3.org/TR/REC-DOM-Level-1/level-one-core.html#ID-5CED94D7 DOM Level 1 Core
	 * @see https://dom.spec.whatwg.org/#dom-domimplementation-hasfeature DOM Living Standard
	 */ hasFeature: function(feature, version) {
        return true;
    },
    /**
	 * Creates an XML Document object of the specified type with its document element.
	 *
	 * __It behaves slightly different from the description in the living standard__:
	 * - There is no interface/class `XMLDocument`, it returns a `Document` instance.
	 * - `contentType`, `encoding`, `mode`, `origin`, `url` fields are currently not declared.
	 * - this implementation is not validating names or qualified names
	 *   (when parsing XML strings, the SAX parser takes care of that)
	 *
	 * @param {string|null} namespaceURI
	 * @param {string} qualifiedName
	 * @param {DocumentType=null} doctype
	 * @returns {Document}
	 *
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/DOMImplementation/createDocument MDN
	 * @see https://www.w3.org/TR/DOM-Level-2-Core/core.html#Level-2-Core-DOM-createDocument DOM Level 2 Core (initial)
	 * @see https://dom.spec.whatwg.org/#dom-domimplementation-createdocument  DOM Level 2 Core
	 *
	 * @see https://dom.spec.whatwg.org/#validate-and-extract DOM: Validate and extract
	 * @see https://www.w3.org/TR/xml/#NT-NameStartChar XML Spec: Names
	 * @see https://www.w3.org/TR/xml-names/#ns-qualnames XML Namespaces: Qualified names
	 */ createDocument: function(namespaceURI, qualifiedName, doctype) {
        var doc = new $47eb2057f4163810$var$Document();
        doc.implementation = this;
        doc.childNodes = new $47eb2057f4163810$var$NodeList();
        doc.doctype = doctype || null;
        if (doctype) doc.appendChild(doctype);
        if (qualifiedName) {
            var root = doc.createElementNS(namespaceURI, qualifiedName);
            doc.appendChild(root);
        }
        return doc;
    },
    /**
	 * Returns a doctype, with the given `qualifiedName`, `publicId`, and `systemId`.
	 *
	 * __This implementation differs from the specification:__
	 * - this implementation is not validating names or qualified names
	 *   (when parsing XML strings, the SAX parser takes care of that)
	 *
	 * Note: `internalSubset` can only be introduced via a direct property write to `node.internalSubset` after creation.
	 * Creation-time validation of `publicId`, `systemId` is not enforced.
	 * The serializer-level check covers all mutation vectors, including direct property writes.
	 * `internalSubset` is only serialized as `[ ... ]` when both `publicId` and `systemId` are
	 * absent (empty or `'.'`) — if either external identifier is present, `internalSubset` is
	 * silently omitted from the serialized output.
	 *
	 * @param {string} qualifiedName
	 * @param {string} [publicId]
	 * The external subset public identifier. Stored verbatim including surrounding quotes.
	 * When serialized with `requireWellFormed: true` (via the 4th-parameter options object),
	 * throws `DOMException` with code `INVALID_STATE_ERR` if the value is non-empty and does
	 * not match the XML `PubidLiteral` production (W3C DOM Parsing §3.2.1.3; XML 1.0 [12]).
	 * @param {string} [systemId]
	 * The external subset system identifier. Stored verbatim including surrounding quotes.
	 * When serialized with `requireWellFormed: true`, throws `DOMException` with code
	 * `INVALID_STATE_ERR` if the value is non-empty and does not match the XML `SystemLiteral`
	 * production (W3C DOM Parsing §3.2.1.3; XML 1.0 [11]).
	 * @returns {DocumentType} which can either be used with `DOMImplementation.createDocument` upon document creation
	 * 				  or can be put into the document via methods like `Node.insertBefore()` or `Node.replaceChild()`
	 *
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/DOMImplementation/createDocumentType MDN
	 * @see https://www.w3.org/TR/DOM-Level-2-Core/core.html#Level-2-Core-DOM-createDocType DOM Level 2 Core
	 * @see https://dom.spec.whatwg.org/#dom-domimplementation-createdocumenttype DOM Living Standard
	 *
	 * @see https://dom.spec.whatwg.org/#validate-and-extract DOM: Validate and extract
	 * @see https://www.w3.org/TR/xml/#NT-NameStartChar XML Spec: Names
	 * @see https://www.w3.org/TR/xml-names/#ns-qualnames XML Namespaces: Qualified names
	 */ createDocumentType: function(qualifiedName, publicId, systemId) {
        var node = new $47eb2057f4163810$var$DocumentType();
        node.name = qualifiedName;
        node.nodeName = qualifiedName;
        node.publicId = publicId || '';
        node.systemId = systemId || '';
        return node;
    }
};
/**
 * @see http://www.w3.org/TR/2000/REC-DOM-Level-2-Core-20001113/core.html#ID-1950641247
 */ function $47eb2057f4163810$var$Node() {}
$47eb2057f4163810$var$Node.prototype = {
    firstChild: null,
    lastChild: null,
    previousSibling: null,
    nextSibling: null,
    attributes: null,
    parentNode: null,
    childNodes: null,
    ownerDocument: null,
    nodeValue: null,
    namespaceURI: null,
    prefix: null,
    localName: null,
    // Modified in DOM Level 2:
    insertBefore: function(newChild, refChild) {
        return $47eb2057f4163810$var$_insertBefore(this, newChild, refChild);
    },
    replaceChild: function(newChild, oldChild) {
        $47eb2057f4163810$var$_insertBefore(this, newChild, oldChild, $47eb2057f4163810$var$assertPreReplacementValidityInDocument);
        if (oldChild) this.removeChild(oldChild);
    },
    removeChild: function(oldChild) {
        return $47eb2057f4163810$var$_removeChild(this, oldChild);
    },
    appendChild: function(newChild) {
        return this.insertBefore(newChild, null);
    },
    hasChildNodes: function() {
        return this.firstChild != null;
    },
    cloneNode: function(deep) {
        return $47eb2057f4163810$var$cloneNode(this.ownerDocument || this, this, deep);
    },
    // Modified in DOM Level 2:
    /**
	 * Puts the specified node and all of its subtree into a "normalized" form. In a normalized
	 * subtree, no text nodes in the subtree are empty and there are no adjacent text nodes.
	 *
	 * Specifically, this method merges any adjacent text nodes (i.e., nodes for which `nodeType`
	 * is `TEXT_NODE`) into a single node with the combined data. It also removes any empty text
	 * nodes.
	 *
	 * This method iteratively traverses all child nodes to normalize all descendant nodes within
	 * the subtree.
	 *
	 * @throws {DOMException}
	 * May throw a DOMException if operations within removeChild or appendData (which are
	 * potentially invoked in this method) do not meet their specific constraints.
	 * @see {@link Node.removeChild}
	 * @see {@link CharacterData.appendData}
	 * @see ../docs/walk-dom.md.
	 */ normalize: function() {
        $47eb2057f4163810$var$walkDOM(this, null, {
            enter: function(node) {
                // Merge adjacent text children of node before walkDOM schedules them.
                // walkDOM reads lastChild/previousSibling after enter returns, so the
                // surviving post-merge children are what it descends into.
                var child = node.firstChild;
                while(child){
                    var next = child.nextSibling;
                    if (next !== null && next.nodeType === $47eb2057f4163810$var$TEXT_NODE && child.nodeType === $47eb2057f4163810$var$TEXT_NODE) {
                        node.removeChild(next);
                        child.appendData(next.data);
                    // Do not advance child: re-check new nextSibling for another text run
                    } else child = next;
                }
                return true; // descend into surviving children
            }
        });
    },
    // Introduced in DOM Level 2:
    isSupported: function(feature, version) {
        return this.ownerDocument.implementation.hasFeature(feature, version);
    },
    // Introduced in DOM Level 2:
    hasAttributes: function() {
        return this.attributes.length > 0;
    },
    /**
	 * Look up the prefix associated to the given namespace URI, starting from this node.
	 * **The default namespace declarations are ignored by this method.**
	 * See Namespace Prefix Lookup for details on the algorithm used by this method.
	 *
	 * _Note: The implementation seems to be incomplete when compared to the algorithm described in the specs._
	 *
	 * @param {string | null} namespaceURI
	 * @returns {string | null}
	 * @see https://www.w3.org/TR/DOM-Level-3-Core/core.html#Node3-lookupNamespacePrefix
	 * @see https://www.w3.org/TR/DOM-Level-3-Core/namespaces-algorithms.html#lookupNamespacePrefixAlgo
	 * @see https://dom.spec.whatwg.org/#dom-node-lookupprefix
	 * @see https://github.com/xmldom/xmldom/issues/322
	 */ lookupPrefix: function(namespaceURI) {
        var el = this;
        while(el){
            var map = el._nsMap;
            //console.dir(map)
            if (map) for(var n in map){
                if (Object.prototype.hasOwnProperty.call(map, n) && map[n] === namespaceURI) return n;
            }
            el = el.nodeType == $47eb2057f4163810$var$ATTRIBUTE_NODE ? el.ownerDocument : el.parentNode;
        }
        return null;
    },
    // Introduced in DOM Level 3:
    lookupNamespaceURI: function(prefix) {
        var el = this;
        while(el){
            var map = el._nsMap;
            //console.dir(map)
            if (map) {
                if (Object.prototype.hasOwnProperty.call(map, prefix)) return map[prefix];
            }
            el = el.nodeType == $47eb2057f4163810$var$ATTRIBUTE_NODE ? el.ownerDocument : el.parentNode;
        }
        return null;
    },
    // Introduced in DOM Level 3:
    isDefaultNamespace: function(namespaceURI) {
        var prefix = this.lookupPrefix(namespaceURI);
        return prefix == null;
    }
};
function $47eb2057f4163810$var$_xmlEncoder(c) {
    return c == '<' && '&lt;' || c == '>' && '&gt;' || c == '&' && '&amp;' || c == '"' && '&quot;' || '&#' + c.charCodeAt() + ';';
}
$47eb2057f4163810$var$copy($47eb2057f4163810$var$NodeType, $47eb2057f4163810$var$Node);
$47eb2057f4163810$var$copy($47eb2057f4163810$var$NodeType, $47eb2057f4163810$var$Node.prototype);
/**
 * @param {Node} node
 * Root of the subtree to visit.
 * @param {function(Node): boolean} callback
 * Called for each node in depth-first pre-order. Return a truthy value to stop traversal early.
 * @return {boolean} `true` if traversal was aborted by the callback, `false` otherwise.
 */ function $47eb2057f4163810$var$_visitNode(node, callback) {
    return $47eb2057f4163810$var$walkDOM(node, null, {
        enter: function(n) {
            return callback(n) ? $47eb2057f4163810$var$walkDOM.STOP : true;
        }
    }) === $47eb2057f4163810$var$walkDOM.STOP;
}
/**
 * Depth-first pre/post-order DOM tree walker.
 *
 * Visits every node in the subtree rooted at `node`. For each node:
 *
 * 1. Calls `callbacks.enter(node, context)` before descending into the node's children. The
 * return value becomes the `context` passed to each child's `enter` call and to the matching
 * `exit` call.
 * 2. If `enter` returns `null` or `undefined`, the node's children are skipped;
 * sibling traversal continues normally.
 * 3. If `enter` returns `walkDOM.STOP`, the entire traversal is aborted immediately — no
 * further `enter` or `exit` calls are made.
 * 4. `lastChild` and `previousSibling` are read **after** `enter` returns, so `enter` may
 * safely modify the node's own child list before the walker descends. Modifying siblings of
 * the current node or any other part of the tree produces unpredictable results: nodes already
 * queued on the stack are visited regardless of DOM changes, and newly inserted nodes outside
 * the current child list are never visited.
 * 5. Calls `callbacks.exit(node, context)` (if provided) after all of a node's children have
 * been visited, passing the same `context` that `enter`
 * returned for that node.
 *
 * This implementation uses an explicit stack and does not recurse — it is safe on arbitrarily
 * deep trees.
 *
 * @param {Node} node
 * Root of the subtree to walk.
 * @param {*} context
 * Initial context value passed to the root node's `enter`.
 * @param {{ enter: function(Node, *): *, exit?: function(Node, *): void }} callbacks
 * @returns {void | walkDOM.STOP}
 * @see ../docs/walk-dom.md.
 */ function $47eb2057f4163810$var$walkDOM(node, context, callbacks) {
    // Each stack frame is {node, context, phase}:
    //   walkDOM.ENTER — call enter, then push children
    //   walkDOM.EXIT  — call exit
    var stack = [
        {
            node: node,
            context: context,
            phase: $47eb2057f4163810$var$walkDOM.ENTER
        }
    ];
    while(stack.length > 0){
        var frame = stack.pop();
        if (frame.phase === $47eb2057f4163810$var$walkDOM.ENTER) {
            var childContext = callbacks.enter(frame.node, frame.context);
            if (childContext === $47eb2057f4163810$var$walkDOM.STOP) return $47eb2057f4163810$var$walkDOM.STOP;
            // Push exit frame before children so it fires after all children are processed (Last In First Out)
            stack.push({
                node: frame.node,
                context: childContext,
                phase: $47eb2057f4163810$var$walkDOM.EXIT
            });
            if (childContext === null || childContext === undefined) continue; // skip children
            // lastChild is read after enter returns, so enter may modify the child list.
            var child = frame.node.lastChild;
            // Traverse from lastChild backwards so that pushing onto the stack
            // naturally yields firstChild on top (processed first).
            while(child){
                stack.push({
                    node: child,
                    context: childContext,
                    phase: $47eb2057f4163810$var$walkDOM.ENTER
                });
                child = child.previousSibling;
            }
        } else // frame.phase === walkDOM.EXIT
        if (callbacks.exit) callbacks.exit(frame.node, frame.context);
    }
}
/**
 * Sentinel value returned from a `walkDOM` `enter` callback to abort the entire traversal
 * immediately.
 *
 * @type {symbol}
 */ $47eb2057f4163810$var$walkDOM.STOP = Symbol('walkDOM.STOP');
/**
 * Phase constant for a stack frame that has not yet been visited.
 * The `enter` callback is called and children are scheduled.
 *
 * @type {number}
 */ $47eb2057f4163810$var$walkDOM.ENTER = 0;
/**
 * Phase constant for a stack frame whose subtree has been fully visited.
 * The `exit` callback is called.
 *
 * @type {number}
 */ $47eb2057f4163810$var$walkDOM.EXIT = 1;
function $47eb2057f4163810$var$Document() {
    this.ownerDocument = this;
}
function $47eb2057f4163810$var$_onAddAttribute(doc, el, newAttr) {
    doc && doc._inc++;
    var ns = newAttr.namespaceURI;
    if (ns === $47eb2057f4163810$var$NAMESPACE.XMLNS) //update namespace
    el._nsMap[newAttr.prefix ? newAttr.localName : ''] = newAttr.value;
}
function $47eb2057f4163810$var$_onRemoveAttribute(doc, el, newAttr, remove) {
    doc && doc._inc++;
    var ns = newAttr.namespaceURI;
    if (ns === $47eb2057f4163810$var$NAMESPACE.XMLNS) //update namespace
    delete el._nsMap[newAttr.prefix ? newAttr.localName : ''];
}
/**
 * Updates `el.childNodes`, updating the indexed items and it's `length`.
 * Passing `newChild` means it will be appended.
 * Otherwise it's assumed that an item has been removed,
 * and `el.firstNode` and it's `.nextSibling` are used
 * to walk the current list of child nodes.
 *
 * @param {Document} doc
 * @param {Node} el
 * @param {Node} [newChild]
 * @private
 */ function $47eb2057f4163810$var$_onUpdateChild(doc, el, newChild) {
    if (doc && doc._inc) {
        doc._inc++;
        //update childNodes
        var cs = el.childNodes;
        if (newChild) cs[cs.length++] = newChild;
        else {
            var child = el.firstChild;
            var i = 0;
            while(child){
                cs[i++] = child;
                child = child.nextSibling;
            }
            cs.length = i;
            delete cs[cs.length];
        }
    }
}
/**
 * Removes the connections between `parentNode` and `child`
 * and any existing `child.previousSibling` or `child.nextSibling`.
 *
 * @see https://github.com/xmldom/xmldom/issues/135
 * @see https://github.com/xmldom/xmldom/issues/145
 *
 * @param {Node} parentNode
 * @param {Node} child
 * @returns {Node} the child that was removed.
 * @private
 */ function $47eb2057f4163810$var$_removeChild(parentNode, child) {
    var previous = child.previousSibling;
    var next = child.nextSibling;
    if (previous) previous.nextSibling = next;
    else parentNode.firstChild = next;
    if (next) next.previousSibling = previous;
    else parentNode.lastChild = previous;
    child.parentNode = null;
    child.previousSibling = null;
    child.nextSibling = null;
    $47eb2057f4163810$var$_onUpdateChild(parentNode.ownerDocument, parentNode);
    return child;
}
/**
 * Returns `true` if `node` can be a parent for insertion.
 * @param {Node} node
 * @returns {boolean}
 */ function $47eb2057f4163810$var$hasValidParentNodeType(node) {
    return node && (node.nodeType === $47eb2057f4163810$var$Node.DOCUMENT_NODE || node.nodeType === $47eb2057f4163810$var$Node.DOCUMENT_FRAGMENT_NODE || node.nodeType === $47eb2057f4163810$var$Node.ELEMENT_NODE);
}
/**
 * Returns `true` if `node` can be inserted according to it's `nodeType`.
 * @param {Node} node
 * @returns {boolean}
 */ function $47eb2057f4163810$var$hasInsertableNodeType(node) {
    return node && ($47eb2057f4163810$var$isElementNode(node) || $47eb2057f4163810$var$isTextNode(node) || $47eb2057f4163810$var$isDocTypeNode(node) || node.nodeType === $47eb2057f4163810$var$Node.DOCUMENT_FRAGMENT_NODE || node.nodeType === $47eb2057f4163810$var$Node.COMMENT_NODE || node.nodeType === $47eb2057f4163810$var$Node.PROCESSING_INSTRUCTION_NODE);
}
/**
 * Returns true if `node` is a DOCTYPE node
 * @param {Node} node
 * @returns {boolean}
 */ function $47eb2057f4163810$var$isDocTypeNode(node) {
    return node && node.nodeType === $47eb2057f4163810$var$Node.DOCUMENT_TYPE_NODE;
}
/**
 * Returns true if the node is an element
 * @param {Node} node
 * @returns {boolean}
 */ function $47eb2057f4163810$var$isElementNode(node) {
    return node && node.nodeType === $47eb2057f4163810$var$Node.ELEMENT_NODE;
}
/**
 * Returns true if `node` is a text node
 * @param {Node} node
 * @returns {boolean}
 */ function $47eb2057f4163810$var$isTextNode(node) {
    return node && node.nodeType === $47eb2057f4163810$var$Node.TEXT_NODE;
}
/**
 * Check if en element node can be inserted before `child`, or at the end if child is falsy,
 * according to the presence and position of a doctype node on the same level.
 *
 * @param {Document} doc The document node
 * @param {Node} child the node that would become the nextSibling if the element would be inserted
 * @returns {boolean} `true` if an element can be inserted before child
 * @private
 * https://dom.spec.whatwg.org/#concept-node-ensure-pre-insertion-validity
 */ function $47eb2057f4163810$var$isElementInsertionPossible(doc, child) {
    var parentChildNodes = doc.childNodes || [];
    if ($47eb2057f4163810$var$find(parentChildNodes, $47eb2057f4163810$var$isElementNode) || $47eb2057f4163810$var$isDocTypeNode(child)) return false;
    var docTypeNode = $47eb2057f4163810$var$find(parentChildNodes, $47eb2057f4163810$var$isDocTypeNode);
    return !(child && docTypeNode && parentChildNodes.indexOf(docTypeNode) > parentChildNodes.indexOf(child));
}
/**
 * Check if en element node can be inserted before `child`, or at the end if child is falsy,
 * according to the presence and position of a doctype node on the same level.
 *
 * @param {Node} doc The document node
 * @param {Node} child the node that would become the nextSibling if the element would be inserted
 * @returns {boolean} `true` if an element can be inserted before child
 * @private
 * https://dom.spec.whatwg.org/#concept-node-ensure-pre-insertion-validity
 */ function $47eb2057f4163810$var$isElementReplacementPossible(doc, child) {
    var parentChildNodes = doc.childNodes || [];
    function hasElementChildThatIsNotChild(node) {
        return $47eb2057f4163810$var$isElementNode(node) && node !== child;
    }
    if ($47eb2057f4163810$var$find(parentChildNodes, hasElementChildThatIsNotChild)) return false;
    var docTypeNode = $47eb2057f4163810$var$find(parentChildNodes, $47eb2057f4163810$var$isDocTypeNode);
    return !(child && docTypeNode && parentChildNodes.indexOf(docTypeNode) > parentChildNodes.indexOf(child));
}
/**
 * @private
 * Steps 1-5 of the checks before inserting and before replacing a child are the same.
 *
 * @param {Node} parent the parent node to insert `node` into
 * @param {Node} node the node to insert
 * @param {Node=} child the node that should become the `nextSibling` of `node`
 * @returns {Node}
 * @throws DOMException for several node combinations that would create a DOM that is not well-formed.
 * @throws DOMException if `child` is provided but is not a child of `parent`.
 * @see https://dom.spec.whatwg.org/#concept-node-ensure-pre-insertion-validity
 * @see https://dom.spec.whatwg.org/#concept-node-replace
 */ function $47eb2057f4163810$var$assertPreInsertionValidity1to5(parent, node, child) {
    // 1. If `parent` is not a Document, DocumentFragment, or Element node, then throw a "HierarchyRequestError" DOMException.
    if (!$47eb2057f4163810$var$hasValidParentNodeType(parent)) throw new $47eb2057f4163810$var$DOMException($47eb2057f4163810$var$HIERARCHY_REQUEST_ERR, 'Unexpected parent node type ' + parent.nodeType);
    // 2. If `node` is a host-including inclusive ancestor of `parent`, then throw a "HierarchyRequestError" DOMException.
    // not implemented!
    // 3. If `child` is non-null and its parent is not `parent`, then throw a "NotFoundError" DOMException.
    if (child && child.parentNode !== parent) throw new $47eb2057f4163810$var$DOMException($47eb2057f4163810$var$NOT_FOUND_ERR, 'child not in parent');
    if (// 4. If `node` is not a DocumentFragment, DocumentType, Element, or CharacterData node, then throw a "HierarchyRequestError" DOMException.
    !$47eb2057f4163810$var$hasInsertableNodeType(node) || // 5. If either `node` is a Text node and `parent` is a document,
    // the sax parser currently adds top level text nodes, this will be fixed in 0.9.0
    // || (node.nodeType === Node.TEXT_NODE && parent.nodeType === Node.DOCUMENT_NODE)
    // or `node` is a doctype and `parent` is not a document, then throw a "HierarchyRequestError" DOMException.
    $47eb2057f4163810$var$isDocTypeNode(node) && parent.nodeType !== $47eb2057f4163810$var$Node.DOCUMENT_NODE) throw new $47eb2057f4163810$var$DOMException($47eb2057f4163810$var$HIERARCHY_REQUEST_ERR, 'Unexpected node type ' + node.nodeType + ' for parent node type ' + parent.nodeType);
}
/**
 * @private
 * Step 6 of the checks before inserting and before replacing a child are different.
 *
 * @param {Document} parent the parent node to insert `node` into
 * @param {Node} node the node to insert
 * @param {Node | undefined} child the node that should become the `nextSibling` of `node`
 * @returns {Node}
 * @throws DOMException for several node combinations that would create a DOM that is not well-formed.
 * @throws DOMException if `child` is provided but is not a child of `parent`.
 * @see https://dom.spec.whatwg.org/#concept-node-ensure-pre-insertion-validity
 * @see https://dom.spec.whatwg.org/#concept-node-replace
 */ function $47eb2057f4163810$var$assertPreInsertionValidityInDocument(parent, node, child) {
    var parentChildNodes = parent.childNodes || [];
    var nodeChildNodes = node.childNodes || [];
    // DocumentFragment
    if (node.nodeType === $47eb2057f4163810$var$Node.DOCUMENT_FRAGMENT_NODE) {
        var nodeChildElements = nodeChildNodes.filter($47eb2057f4163810$var$isElementNode);
        // If node has more than one element child or has a Text node child.
        if (nodeChildElements.length > 1 || $47eb2057f4163810$var$find(nodeChildNodes, $47eb2057f4163810$var$isTextNode)) throw new $47eb2057f4163810$var$DOMException($47eb2057f4163810$var$HIERARCHY_REQUEST_ERR, 'More than one element or text in fragment');
        // Otherwise, if `node` has one element child and either `parent` has an element child,
        // `child` is a doctype, or `child` is non-null and a doctype is following `child`.
        if (nodeChildElements.length === 1 && !$47eb2057f4163810$var$isElementInsertionPossible(parent, child)) throw new $47eb2057f4163810$var$DOMException($47eb2057f4163810$var$HIERARCHY_REQUEST_ERR, 'Element in fragment can not be inserted before doctype');
    }
    // Element
    if ($47eb2057f4163810$var$isElementNode(node)) {
        // `parent` has an element child, `child` is a doctype,
        // or `child` is non-null and a doctype is following `child`.
        if (!$47eb2057f4163810$var$isElementInsertionPossible(parent, child)) throw new $47eb2057f4163810$var$DOMException($47eb2057f4163810$var$HIERARCHY_REQUEST_ERR, 'Only one element can be added and only after doctype');
    }
    // DocumentType
    if ($47eb2057f4163810$var$isDocTypeNode(node)) {
        // `parent` has a doctype child,
        if ($47eb2057f4163810$var$find(parentChildNodes, $47eb2057f4163810$var$isDocTypeNode)) throw new $47eb2057f4163810$var$DOMException($47eb2057f4163810$var$HIERARCHY_REQUEST_ERR, 'Only one doctype is allowed');
        var parentElementChild = $47eb2057f4163810$var$find(parentChildNodes, $47eb2057f4163810$var$isElementNode);
        // `child` is non-null and an element is preceding `child`,
        if (child && parentChildNodes.indexOf(parentElementChild) < parentChildNodes.indexOf(child)) throw new $47eb2057f4163810$var$DOMException($47eb2057f4163810$var$HIERARCHY_REQUEST_ERR, 'Doctype can only be inserted before an element');
        // or `child` is null and `parent` has an element child.
        if (!child && parentElementChild) throw new $47eb2057f4163810$var$DOMException($47eb2057f4163810$var$HIERARCHY_REQUEST_ERR, 'Doctype can not be appended since element is present');
    }
}
/**
 * @private
 * Step 6 of the checks before inserting and before replacing a child are different.
 *
 * @param {Document} parent the parent node to insert `node` into
 * @param {Node} node the node to insert
 * @param {Node | undefined} child the node that should become the `nextSibling` of `node`
 * @returns {Node}
 * @throws DOMException for several node combinations that would create a DOM that is not well-formed.
 * @throws DOMException if `child` is provided but is not a child of `parent`.
 * @see https://dom.spec.whatwg.org/#concept-node-ensure-pre-insertion-validity
 * @see https://dom.spec.whatwg.org/#concept-node-replace
 */ function $47eb2057f4163810$var$assertPreReplacementValidityInDocument(parent, node, child) {
    var parentChildNodes = parent.childNodes || [];
    var nodeChildNodes = node.childNodes || [];
    // DocumentFragment
    if (node.nodeType === $47eb2057f4163810$var$Node.DOCUMENT_FRAGMENT_NODE) {
        var nodeChildElements = nodeChildNodes.filter($47eb2057f4163810$var$isElementNode);
        // If `node` has more than one element child or has a Text node child.
        if (nodeChildElements.length > 1 || $47eb2057f4163810$var$find(nodeChildNodes, $47eb2057f4163810$var$isTextNode)) throw new $47eb2057f4163810$var$DOMException($47eb2057f4163810$var$HIERARCHY_REQUEST_ERR, 'More than one element or text in fragment');
        // Otherwise, if `node` has one element child and either `parent` has an element child that is not `child` or a doctype is following `child`.
        if (nodeChildElements.length === 1 && !$47eb2057f4163810$var$isElementReplacementPossible(parent, child)) throw new $47eb2057f4163810$var$DOMException($47eb2057f4163810$var$HIERARCHY_REQUEST_ERR, 'Element in fragment can not be inserted before doctype');
    }
    // Element
    if ($47eb2057f4163810$var$isElementNode(node)) {
        // `parent` has an element child that is not `child` or a doctype is following `child`.
        if (!$47eb2057f4163810$var$isElementReplacementPossible(parent, child)) throw new $47eb2057f4163810$var$DOMException($47eb2057f4163810$var$HIERARCHY_REQUEST_ERR, 'Only one element can be added and only after doctype');
    }
    // DocumentType
    if ($47eb2057f4163810$var$isDocTypeNode(node)) {
        function hasDoctypeChildThatIsNotChild(node) {
            return $47eb2057f4163810$var$isDocTypeNode(node) && node !== child;
        }
        // `parent` has a doctype child that is not `child`,
        if ($47eb2057f4163810$var$find(parentChildNodes, hasDoctypeChildThatIsNotChild)) throw new $47eb2057f4163810$var$DOMException($47eb2057f4163810$var$HIERARCHY_REQUEST_ERR, 'Only one doctype is allowed');
        var parentElementChild = $47eb2057f4163810$var$find(parentChildNodes, $47eb2057f4163810$var$isElementNode);
        // or an element is preceding `child`.
        if (child && parentChildNodes.indexOf(parentElementChild) < parentChildNodes.indexOf(child)) throw new $47eb2057f4163810$var$DOMException($47eb2057f4163810$var$HIERARCHY_REQUEST_ERR, 'Doctype can only be inserted before an element');
    }
}
/**
 * @private
 * @param {Node} parent the parent node to insert `node` into
 * @param {Node} node the node to insert
 * @param {Node=} child the node that should become the `nextSibling` of `node`
 * @returns {Node}
 * @throws DOMException for several node combinations that would create a DOM that is not well-formed.
 * @throws DOMException if `child` is provided but is not a child of `parent`.
 * @see https://dom.spec.whatwg.org/#concept-node-ensure-pre-insertion-validity
 */ function $47eb2057f4163810$var$_insertBefore(parent, node, child, _inDocumentAssertion) {
    // To ensure pre-insertion validity of a node into a parent before a child, run these steps:
    $47eb2057f4163810$var$assertPreInsertionValidity1to5(parent, node, child);
    // If parent is a document, and any of the statements below, switched on the interface node implements,
    // are true, then throw a "HierarchyRequestError" DOMException.
    if (parent.nodeType === $47eb2057f4163810$var$Node.DOCUMENT_NODE) (_inDocumentAssertion || $47eb2057f4163810$var$assertPreInsertionValidityInDocument)(parent, node, child);
    var cp = node.parentNode;
    if (cp) cp.removeChild(node); //remove and update
    if (node.nodeType === $47eb2057f4163810$var$DOCUMENT_FRAGMENT_NODE) {
        var newFirst = node.firstChild;
        if (newFirst == null) return node;
        var newLast = node.lastChild;
    } else newFirst = newLast = node;
    var pre = child ? child.previousSibling : parent.lastChild;
    newFirst.previousSibling = pre;
    newLast.nextSibling = child;
    if (pre) pre.nextSibling = newFirst;
    else parent.firstChild = newFirst;
    if (child == null) parent.lastChild = newLast;
    else child.previousSibling = newLast;
    do {
        newFirst.parentNode = parent;
        // Update ownerDocument for each node being inserted
        var targetDoc = parent.ownerDocument || parent;
        $47eb2057f4163810$var$_updateOwnerDocument(newFirst, targetDoc);
    }while (newFirst !== newLast && (newFirst = newFirst.nextSibling));
    $47eb2057f4163810$var$_onUpdateChild(parent.ownerDocument || parent, parent);
    //console.log(parent.lastChild.nextSibling == null)
    if (node.nodeType == $47eb2057f4163810$var$DOCUMENT_FRAGMENT_NODE) node.firstChild = node.lastChild = null;
    return node;
}
/**
 * Recursively updates the ownerDocument property for a node and all its descendants
 * @param {Node} node
 * @param {Document} newOwnerDocument
 * @private
 */ function $47eb2057f4163810$var$_updateOwnerDocument(node, newOwnerDocument) {
    if (node.ownerDocument === newOwnerDocument) return;
    node.ownerDocument = newOwnerDocument;
    // Update attributes if this is an element
    if (node.nodeType === $47eb2057f4163810$var$ELEMENT_NODE && node.attributes) for(var i = 0; i < node.attributes.length; i++){
        var attr = node.attributes.item(i);
        if (attr) attr.ownerDocument = newOwnerDocument;
    }
    // Recursively update child nodes
    var child = node.firstChild;
    while(child){
        $47eb2057f4163810$var$_updateOwnerDocument(child, newOwnerDocument);
        child = child.nextSibling;
    }
}
/**
 * Appends `newChild` to `parentNode`.
 * If `newChild` is already connected to a `parentNode` it is first removed from it.
 *
 * @see https://github.com/xmldom/xmldom/issues/135
 * @see https://github.com/xmldom/xmldom/issues/145
 * @param {Node} parentNode
 * @param {Node} newChild
 * @returns {Node}
 * @private
 */ function $47eb2057f4163810$var$_appendSingleChild(parentNode, newChild) {
    if (newChild.parentNode) newChild.parentNode.removeChild(newChild);
    newChild.parentNode = parentNode;
    newChild.previousSibling = parentNode.lastChild;
    newChild.nextSibling = null;
    if (newChild.previousSibling) newChild.previousSibling.nextSibling = newChild;
    else parentNode.firstChild = newChild;
    parentNode.lastChild = newChild;
    $47eb2057f4163810$var$_onUpdateChild(parentNode.ownerDocument, parentNode, newChild);
    // Update ownerDocument for the new child and all its descendants
    var targetDoc = parentNode.ownerDocument || parentNode;
    $47eb2057f4163810$var$_updateOwnerDocument(newChild, targetDoc);
    return newChild;
}
$47eb2057f4163810$var$Document.prototype = {
    //implementation : null,
    nodeName: '#document',
    nodeType: $47eb2057f4163810$var$DOCUMENT_NODE,
    /**
	 * The DocumentType node of the document.
	 *
	 * @readonly
	 * @type DocumentType
	 */ doctype: null,
    documentElement: null,
    _inc: 1,
    insertBefore: function(newChild, refChild) {
        if (newChild.nodeType == $47eb2057f4163810$var$DOCUMENT_FRAGMENT_NODE) {
            var child = newChild.firstChild;
            while(child){
                var next = child.nextSibling;
                this.insertBefore(child, refChild);
                child = next;
            }
            return newChild;
        }
        $47eb2057f4163810$var$_insertBefore(this, newChild, refChild);
        $47eb2057f4163810$var$_updateOwnerDocument(newChild, this);
        if (this.documentElement === null && newChild.nodeType === $47eb2057f4163810$var$ELEMENT_NODE) this.documentElement = newChild;
        return newChild;
    },
    removeChild: function(oldChild) {
        if (this.documentElement == oldChild) this.documentElement = null;
        return $47eb2057f4163810$var$_removeChild(this, oldChild);
    },
    replaceChild: function(newChild, oldChild) {
        //raises
        $47eb2057f4163810$var$_insertBefore(this, newChild, oldChild, $47eb2057f4163810$var$assertPreReplacementValidityInDocument);
        $47eb2057f4163810$var$_updateOwnerDocument(newChild, this);
        if (oldChild) this.removeChild(oldChild);
        if ($47eb2057f4163810$var$isElementNode(newChild)) this.documentElement = newChild;
    },
    // Introduced in DOM Level 2:
    importNode: function(importedNode, deep) {
        return $47eb2057f4163810$var$importNode(this, importedNode, deep);
    },
    // Introduced in DOM Level 2:
    getElementById: function(id) {
        var rtv = null;
        $47eb2057f4163810$var$_visitNode(this.documentElement, function(node) {
            if (node.nodeType == $47eb2057f4163810$var$ELEMENT_NODE) {
                if (node.getAttribute('id') == id) {
                    rtv = node;
                    return true;
                }
            }
        });
        return rtv;
    },
    /**
	 * The `getElementsByClassName` method of `Document` interface returns an array-like object
	 * of all child elements which have **all** of the given class name(s).
	 *
	 * Returns an empty list if `classeNames` is an empty string or only contains HTML white space characters.
	 *
	 *
	 * Warning: This is a live LiveNodeList.
	 * Changes in the DOM will reflect in the array as the changes occur.
	 * If an element selected by this array no longer qualifies for the selector,
	 * it will automatically be removed. Be aware of this for iteration purposes.
	 *
	 * @param {string} classNames is a string representing the class name(s) to match; multiple class names are separated by (ASCII-)whitespace
	 *
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/Document/getElementsByClassName
	 * @see https://dom.spec.whatwg.org/#concept-getelementsbyclassname
	 */ getElementsByClassName: function(classNames) {
        var classNamesSet = $47eb2057f4163810$var$toOrderedSet(classNames);
        return new $47eb2057f4163810$var$LiveNodeList(this, function(base) {
            var ls = [];
            if (classNamesSet.length > 0) $47eb2057f4163810$var$_visitNode(base.documentElement, function(node) {
                if (node !== base && node.nodeType === $47eb2057f4163810$var$ELEMENT_NODE) {
                    var nodeClassNames = node.getAttribute('class');
                    // can be null if the attribute does not exist
                    if (nodeClassNames) {
                        // before splitting and iterating just compare them for the most common case
                        var matches = classNames === nodeClassNames;
                        if (!matches) {
                            var nodeClassNamesSet = $47eb2057f4163810$var$toOrderedSet(nodeClassNames);
                            matches = classNamesSet.every($47eb2057f4163810$var$arrayIncludes(nodeClassNamesSet));
                        }
                        if (matches) ls.push(node);
                    }
                }
            });
            return ls;
        });
    },
    //document factory method:
    createElement: function(tagName) {
        var node = new $47eb2057f4163810$var$Element();
        node.ownerDocument = this;
        node.nodeName = tagName;
        node.tagName = tagName;
        node.localName = tagName;
        node.childNodes = new $47eb2057f4163810$var$NodeList();
        var attrs = node.attributes = new $47eb2057f4163810$var$NamedNodeMap();
        attrs._ownerElement = node;
        return node;
    },
    createDocumentFragment: function() {
        var node = new $47eb2057f4163810$var$DocumentFragment();
        node.ownerDocument = this;
        node.childNodes = new $47eb2057f4163810$var$NodeList();
        return node;
    },
    createTextNode: function(data) {
        var node = new $47eb2057f4163810$var$Text();
        node.ownerDocument = this;
        node.appendData(data);
        return node;
    },
    createComment: function(data) {
        var node = new $47eb2057f4163810$var$Comment();
        node.ownerDocument = this;
        node.appendData(data);
        return node;
    },
    /**
	 * Returns a new CDATASection node whose data is `data`.
	 *
	 * __This implementation differs from the specification:__
	 * - calling this method on an HTML document does not throw `NotSupportedError`.
	 *
	 * @param {string} data
	 * @returns {CDATASection}
	 * @throws DOMException with code `INVALID_CHARACTER_ERR` if `data` contains `"]]>"`.
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/Document/createCDATASection
	 * @see https://dom.spec.whatwg.org/#dom-document-createcdatasection
	 */ createCDATASection: function(data) {
        if (data.indexOf(']]>') !== -1) throw new $47eb2057f4163810$var$DOMException($47eb2057f4163810$var$INVALID_CHARACTER_ERR, 'data contains "]]>"');
        var node = new $47eb2057f4163810$var$CDATASection();
        node.ownerDocument = this;
        node.appendData(data);
        return node;
    },
    /**
	 * Returns a ProcessingInstruction node whose target is target and data is data.
	 *
	 * __This implementation differs from the specification:__
	 * - it does not do any input validation on the arguments and doesn't throw "InvalidCharacterError".
	 *
	 * Note: When the resulting document is serialized with `requireWellFormed: true`, the
	 * serializer throws with code `INVALID_STATE_ERR` if `.data` contains `?>` (W3C DOM Parsing
	 * §3.2.1.7). Without that option the data is emitted verbatim.
	 *
	 * @param {string} target
	 * @param {string} data
	 * @returns {ProcessingInstruction}
	 * @see https://developer.mozilla.org/docs/Web/API/Document/createProcessingInstruction
	 * @see https://dom.spec.whatwg.org/#dom-document-createprocessinginstruction
	 * @see https://www.w3.org/TR/DOM-Parsing/#dfn-concept-serialize-xml §3.2.1.7
	 */ createProcessingInstruction: function(target, data) {
        var node = new $47eb2057f4163810$var$ProcessingInstruction();
        node.ownerDocument = this;
        node.tagName = node.nodeName = node.target = target;
        node.nodeValue = node.data = data;
        return node;
    },
    createAttribute: function(name) {
        var node = new $47eb2057f4163810$var$Attr();
        node.ownerDocument = this;
        node.name = name;
        node.nodeName = name;
        node.localName = name;
        node.specified = true;
        return node;
    },
    createEntityReference: function(name) {
        var node = new $47eb2057f4163810$var$EntityReference();
        node.ownerDocument = this;
        node.nodeName = name;
        return node;
    },
    // Introduced in DOM Level 2:
    createElementNS: function(namespaceURI, qualifiedName) {
        var node = new $47eb2057f4163810$var$Element();
        var pl = qualifiedName.split(':');
        var attrs = node.attributes = new $47eb2057f4163810$var$NamedNodeMap();
        node.childNodes = new $47eb2057f4163810$var$NodeList();
        node.ownerDocument = this;
        node.nodeName = qualifiedName;
        node.tagName = qualifiedName;
        node.namespaceURI = namespaceURI;
        if (pl.length == 2) {
            node.prefix = pl[0];
            node.localName = pl[1];
        } else //el.prefix = null;
        node.localName = qualifiedName;
        attrs._ownerElement = node;
        return node;
    },
    // Introduced in DOM Level 2:
    createAttributeNS: function(namespaceURI, qualifiedName) {
        var node = new $47eb2057f4163810$var$Attr();
        var pl = qualifiedName.split(':');
        node.ownerDocument = this;
        node.nodeName = qualifiedName;
        node.name = qualifiedName;
        node.namespaceURI = namespaceURI;
        node.specified = true;
        if (pl.length == 2) {
            node.prefix = pl[0];
            node.localName = pl[1];
        } else //el.prefix = null;
        node.localName = qualifiedName;
        return node;
    }
};
$47eb2057f4163810$var$_extends($47eb2057f4163810$var$Document, $47eb2057f4163810$var$Node);
function $47eb2057f4163810$var$Element() {
    this._nsMap = {};
}
$47eb2057f4163810$var$Element.prototype = {
    nodeType: $47eb2057f4163810$var$ELEMENT_NODE,
    hasAttribute: function(name) {
        return this.getAttributeNode(name) != null;
    },
    getAttribute: function(name) {
        var attr = this.getAttributeNode(name);
        return attr && attr.value || '';
    },
    getAttributeNode: function(name) {
        return this.attributes.getNamedItem(name);
    },
    setAttribute: function(name, value) {
        var attr = this.ownerDocument.createAttribute(name);
        attr.value = attr.nodeValue = "" + value;
        this.setAttributeNode(attr);
    },
    removeAttribute: function(name) {
        var attr = this.getAttributeNode(name);
        attr && this.removeAttributeNode(attr);
    },
    //four real opeartion method
    appendChild: function(newChild) {
        if (newChild.nodeType === $47eb2057f4163810$var$DOCUMENT_FRAGMENT_NODE) return this.insertBefore(newChild, null);
        else return $47eb2057f4163810$var$_appendSingleChild(this, newChild);
    },
    setAttributeNode: function(newAttr) {
        return this.attributes.setNamedItem(newAttr);
    },
    setAttributeNodeNS: function(newAttr) {
        return this.attributes.setNamedItemNS(newAttr);
    },
    removeAttributeNode: function(oldAttr) {
        //console.log(this == oldAttr.ownerElement)
        return this.attributes.removeNamedItem(oldAttr.nodeName);
    },
    //get real attribute name,and remove it by removeAttributeNode
    removeAttributeNS: function(namespaceURI, localName) {
        var old = this.getAttributeNodeNS(namespaceURI, localName);
        old && this.removeAttributeNode(old);
    },
    hasAttributeNS: function(namespaceURI, localName) {
        return this.getAttributeNodeNS(namespaceURI, localName) != null;
    },
    getAttributeNS: function(namespaceURI, localName) {
        var attr = this.getAttributeNodeNS(namespaceURI, localName);
        return attr && attr.value || '';
    },
    setAttributeNS: function(namespaceURI, qualifiedName, value) {
        var attr = this.ownerDocument.createAttributeNS(namespaceURI, qualifiedName);
        attr.value = attr.nodeValue = "" + value;
        this.setAttributeNode(attr);
    },
    getAttributeNodeNS: function(namespaceURI, localName) {
        return this.attributes.getNamedItemNS(namespaceURI, localName);
    },
    getElementsByTagName: function(tagName) {
        return new $47eb2057f4163810$var$LiveNodeList(this, function(base) {
            var ls = [];
            $47eb2057f4163810$var$_visitNode(base, function(node) {
                if (node !== base && node.nodeType == $47eb2057f4163810$var$ELEMENT_NODE && (tagName === '*' || node.tagName == tagName)) ls.push(node);
            });
            return ls;
        });
    },
    getElementsByTagNameNS: function(namespaceURI, localName) {
        return new $47eb2057f4163810$var$LiveNodeList(this, function(base) {
            var ls = [];
            $47eb2057f4163810$var$_visitNode(base, function(node) {
                if (node !== base && node.nodeType === $47eb2057f4163810$var$ELEMENT_NODE && (namespaceURI === '*' || node.namespaceURI === namespaceURI) && (localName === '*' || node.localName == localName)) ls.push(node);
            });
            return ls;
        });
    }
};
$47eb2057f4163810$var$Document.prototype.getElementsByTagName = $47eb2057f4163810$var$Element.prototype.getElementsByTagName;
$47eb2057f4163810$var$Document.prototype.getElementsByTagNameNS = $47eb2057f4163810$var$Element.prototype.getElementsByTagNameNS;
$47eb2057f4163810$var$_extends($47eb2057f4163810$var$Element, $47eb2057f4163810$var$Node);
function $47eb2057f4163810$var$Attr() {}
$47eb2057f4163810$var$Attr.prototype.nodeType = $47eb2057f4163810$var$ATTRIBUTE_NODE;
$47eb2057f4163810$var$_extends($47eb2057f4163810$var$Attr, $47eb2057f4163810$var$Node);
function $47eb2057f4163810$var$CharacterData() {}
$47eb2057f4163810$var$CharacterData.prototype = {
    data: '',
    substringData: function(offset, count) {
        return this.data.substring(offset, offset + count);
    },
    appendData: function(text) {
        text = this.data + text;
        this.nodeValue = this.data = text;
        this.length = text.length;
    },
    insertData: function(offset, text) {
        this.replaceData(offset, 0, text);
    },
    appendChild: function(newChild) {
        throw new Error($47eb2057f4163810$var$ExceptionMessage[$47eb2057f4163810$var$HIERARCHY_REQUEST_ERR]);
    },
    deleteData: function(offset, count) {
        this.replaceData(offset, count, "");
    },
    replaceData: function(offset, count, text) {
        var start = this.data.substring(0, offset);
        var end = this.data.substring(offset + count);
        text = start + text + end;
        this.nodeValue = this.data = text;
        this.length = text.length;
    }
};
$47eb2057f4163810$var$_extends($47eb2057f4163810$var$CharacterData, $47eb2057f4163810$var$Node);
function $47eb2057f4163810$var$Text() {}
$47eb2057f4163810$var$Text.prototype = {
    nodeName: "#text",
    nodeType: $47eb2057f4163810$var$TEXT_NODE,
    splitText: function(offset) {
        var text = this.data;
        var newText = text.substring(offset);
        text = text.substring(0, offset);
        this.data = this.nodeValue = text;
        this.length = text.length;
        var newNode = this.ownerDocument.createTextNode(newText);
        if (this.parentNode) this.parentNode.insertBefore(newNode, this.nextSibling);
        return newNode;
    }
};
$47eb2057f4163810$var$_extends($47eb2057f4163810$var$Text, $47eb2057f4163810$var$CharacterData);
function $47eb2057f4163810$var$Comment() {}
$47eb2057f4163810$var$Comment.prototype = {
    nodeName: "#comment",
    nodeType: $47eb2057f4163810$var$COMMENT_NODE
};
$47eb2057f4163810$var$_extends($47eb2057f4163810$var$Comment, $47eb2057f4163810$var$CharacterData);
function $47eb2057f4163810$var$CDATASection() {}
$47eb2057f4163810$var$CDATASection.prototype = {
    nodeName: "#cdata-section",
    nodeType: $47eb2057f4163810$var$CDATA_SECTION_NODE
};
$47eb2057f4163810$var$_extends($47eb2057f4163810$var$CDATASection, $47eb2057f4163810$var$CharacterData);
/**
 * Represents a DocumentType node (the `<!DOCTYPE ...>` declaration).
 *
 * `publicId`, `systemId`, and `internalSubset` are plain own-property assignments.
 * xmldom does not enforce the `readonly` constraint declared by the WHATWG DOM spec —
 * direct property writes succeed silently. Values are serialized verbatim when
 * `requireWellFormed` is false (the default). When the serializer is invoked with
 * `requireWellFormed: true` (via the 4th-parameter options object), it validates each
 * field and throws `DOMException` with code `INVALID_STATE_ERR` on invalid values.
 *
 * @class
 * @see https://developer.mozilla.org/en-US/docs/Web/API/DocumentType MDN
 */ function $47eb2057f4163810$var$DocumentType() {}
$47eb2057f4163810$var$DocumentType.prototype.nodeType = $47eb2057f4163810$var$DOCUMENT_TYPE_NODE;
$47eb2057f4163810$var$_extends($47eb2057f4163810$var$DocumentType, $47eb2057f4163810$var$Node);
function $47eb2057f4163810$var$Notation() {}
$47eb2057f4163810$var$Notation.prototype.nodeType = $47eb2057f4163810$var$NOTATION_NODE;
$47eb2057f4163810$var$_extends($47eb2057f4163810$var$Notation, $47eb2057f4163810$var$Node);
function $47eb2057f4163810$var$Entity() {}
$47eb2057f4163810$var$Entity.prototype.nodeType = $47eb2057f4163810$var$ENTITY_NODE;
$47eb2057f4163810$var$_extends($47eb2057f4163810$var$Entity, $47eb2057f4163810$var$Node);
function $47eb2057f4163810$var$EntityReference() {}
$47eb2057f4163810$var$EntityReference.prototype.nodeType = $47eb2057f4163810$var$ENTITY_REFERENCE_NODE;
$47eb2057f4163810$var$_extends($47eb2057f4163810$var$EntityReference, $47eb2057f4163810$var$Node);
function $47eb2057f4163810$var$DocumentFragment() {}
$47eb2057f4163810$var$DocumentFragment.prototype.nodeName = "#document-fragment";
$47eb2057f4163810$var$DocumentFragment.prototype.nodeType = $47eb2057f4163810$var$DOCUMENT_FRAGMENT_NODE;
$47eb2057f4163810$var$_extends($47eb2057f4163810$var$DocumentFragment, $47eb2057f4163810$var$Node);
function $47eb2057f4163810$var$ProcessingInstruction() {}
$47eb2057f4163810$var$ProcessingInstruction.prototype.nodeType = $47eb2057f4163810$var$PROCESSING_INSTRUCTION_NODE;
$47eb2057f4163810$var$_extends($47eb2057f4163810$var$ProcessingInstruction, $47eb2057f4163810$var$Node);
function $47eb2057f4163810$var$XMLSerializer() {}
/**
 * Returns the result of serializing `node` to XML.
 *
 * When `options.requireWellFormed` is `true`, the serializer throws for content that would
 * produce ill-formed XML.
 *
 * __This implementation differs from the specification:__
 * - CDATASection nodes whose data contains `]]>` are serialized by splitting the section
 *   at each `]]>` occurrence (following W3C DOM Level 3 Core `split-cdata-sections`
 *   default behaviour) unless `requireWellFormed` is `true`.
 * - when `requireWellFormed` is `true`, `DOMException` with code `INVALID_STATE_ERR`
 *   is only thrown to prevent injection vectors, not for all the spec mandated checks.
 *
 * @param {Node} node
 * @param {boolean} [isHtml]
 * @param {function} [nodeFilter]
 * @param {Object} [options]
 * @param {boolean} [options.requireWellFormed=false]
 * When `true`, throws for content that would produce ill-formed XML.
 * @returns {string}
 * @throws {DOMException}
 * With code `INVALID_STATE_ERR` when `requireWellFormed` is `true` and:
 * - a CDATASection node's data contains `"]]>"`,
 * - a Comment node's data contains `"-->"` (bare `"--"` does not throw on this branch),
 * - a ProcessingInstruction's data contains `"?>"`,
 * - a DocumentType's `publicId` is non-empty and does not match the XML `PubidLiteral`
 *   production,
 * - a DocumentType's `systemId` is non-empty and does not match the XML `SystemLiteral`
 *   production, or
 * - a DocumentType's `internalSubset` contains `"]>"`.
 * Note: xmldom does not enforce `readonly` on DocumentType fields — direct property
 * writes succeed and are covered by the serializer-level checks above.
 * @see https://html.spec.whatwg.org/#dom-xmlserializer-serializetostring
 * @see https://w3c.github.io/DOM-Parsing/#xml-serialization
 * @see https://github.com/w3c/DOM-Parsing/issues/84
 */ $47eb2057f4163810$var$XMLSerializer.prototype.serializeToString = function(node, isHtml, nodeFilter, options) {
    return $47eb2057f4163810$var$nodeSerializeToString.call(node, isHtml, nodeFilter, options);
};
$47eb2057f4163810$var$Node.prototype.toString = $47eb2057f4163810$var$nodeSerializeToString;
function $47eb2057f4163810$var$nodeSerializeToString(isHtml, nodeFilter, options) {
    var requireWellFormed = !!options && !!options.requireWellFormed;
    var buf = [];
    var refNode = this.nodeType == 9 && this.documentElement || this;
    var prefix = refNode.prefix;
    var uri = refNode.namespaceURI;
    if (uri && prefix == null) {
        //console.log(prefix)
        var prefix = refNode.lookupPrefix(uri);
        if (prefix == null) //isHTML = true;
        var visibleNamespaces = [
            {
                namespace: uri,
                prefix: null
            }
        ];
    }
    $47eb2057f4163810$var$serializeToString(this, buf, isHtml, nodeFilter, visibleNamespaces, requireWellFormed);
    //console.log('###',this.nodeType,uri,prefix,buf.join(''))
    return buf.join('');
}
function $47eb2057f4163810$var$needNamespaceDefine(node, isHTML, visibleNamespaces) {
    var prefix = node.prefix || '';
    var uri = node.namespaceURI;
    // According to [Namespaces in XML 1.0](https://www.w3.org/TR/REC-xml-names/#ns-using) ,
    // and more specifically https://www.w3.org/TR/REC-xml-names/#nsc-NoPrefixUndecl :
    // > In a namespace declaration for a prefix [...], the attribute value MUST NOT be empty.
    // in a similar manner [Namespaces in XML 1.1](https://www.w3.org/TR/xml-names11/#ns-using)
    // and more specifically https://www.w3.org/TR/xml-names11/#nsc-NSDeclared :
    // > [...] Furthermore, the attribute value [...] must not be an empty string.
    // so serializing empty namespace value like xmlns:ds="" would produce an invalid XML document.
    if (!uri) return false;
    if (prefix === "xml" && uri === $47eb2057f4163810$var$NAMESPACE.XML || uri === $47eb2057f4163810$var$NAMESPACE.XMLNS) return false;
    var i = visibleNamespaces.length;
    while(i--){
        var ns = visibleNamespaces[i];
        // get namespace prefix
        if (ns.prefix === prefix) return ns.namespace !== uri;
    }
    return true;
}
/**
 * Well-formed constraint: No < in Attribute Values
 * > The replacement text of any entity referred to directly or indirectly
 * > in an attribute value must not contain a <.
 * @see https://www.w3.org/TR/xml11/#CleanAttrVals
 * @see https://www.w3.org/TR/xml11/#NT-AttValue
 *
 * Literal whitespace other than space that appear in attribute values
 * are serialized as their entity references, so they will be preserved.
 * (In contrast to whitespace literals in the input which are normalized to spaces)
 * @see https://www.w3.org/TR/xml11/#AVNormalize
 * @see https://w3c.github.io/DOM-Parsing/#serializing-an-element-s-attributes
 */ function $47eb2057f4163810$var$addSerializedAttribute(buf, qualifiedName, value) {
    buf.push(' ', qualifiedName, '="', value.replace(/[<>&"\t\n\r]/g, $47eb2057f4163810$var$_xmlEncoder), '"');
}
function $47eb2057f4163810$var$serializeToString(node, buf, isHTML, nodeFilter, visibleNamespaces, requireWellFormed) {
    if (!visibleNamespaces) visibleNamespaces = [];
    $47eb2057f4163810$var$walkDOM(node, {
        ns: visibleNamespaces,
        isHTML: isHTML
    }, {
        enter: function(n, ctx) {
            var ns = ctx.ns;
            var html = ctx.isHTML;
            if (nodeFilter) {
                n = nodeFilter(n);
                if (n) {
                    if (typeof n == 'string') {
                        buf.push(n);
                        return null;
                    }
                } else return null;
            }
            switch(n.nodeType){
                case $47eb2057f4163810$var$ELEMENT_NODE:
                    var attrs = n.attributes;
                    var len = attrs.length;
                    var nodeName = n.tagName;
                    html = $47eb2057f4163810$var$NAMESPACE.isHTML(n.namespaceURI) || html;
                    var prefixedNodeName = nodeName;
                    if (!html && !n.prefix && n.namespaceURI) {
                        var defaultNS;
                        // lookup current default ns from `xmlns` attribute
                        for(var ai = 0; ai < attrs.length; ai++)if (attrs.item(ai).name === 'xmlns') {
                            defaultNS = attrs.item(ai).value;
                            break;
                        }
                        if (!defaultNS) // lookup current default ns in visibleNamespaces
                        for(var nsi = ns.length - 1; nsi >= 0; nsi--){
                            var nsEntry = ns[nsi];
                            if (nsEntry.prefix === '' && nsEntry.namespace === n.namespaceURI) {
                                defaultNS = nsEntry.namespace;
                                break;
                            }
                        }
                        if (defaultNS !== n.namespaceURI) for(var nsi = ns.length - 1; nsi >= 0; nsi--){
                            var nsEntry = ns[nsi];
                            if (nsEntry.namespace === n.namespaceURI) {
                                if (nsEntry.prefix) prefixedNodeName = nsEntry.prefix + ':' + nodeName;
                                break;
                            }
                        }
                    }
                    buf.push('<', prefixedNodeName);
                    // Build a fresh namespace snapshot for this element's children.
                    // The slice prevents sibling elements from inheriting each other's declarations.
                    var childNs = ns.slice();
                    for(var i = 0; i < len; i++){
                        var attr = attrs.item(i);
                        if (attr.prefix == 'xmlns') childNs.push({
                            prefix: attr.localName,
                            namespace: attr.value
                        });
                        else if (attr.nodeName == 'xmlns') childNs.push({
                            prefix: '',
                            namespace: attr.value
                        });
                    }
                    for(var i = 0; i < len; i++){
                        var attr = attrs.item(i);
                        if ($47eb2057f4163810$var$needNamespaceDefine(attr, html, childNs)) {
                            var attrPrefix = attr.prefix || '';
                            var uri = attr.namespaceURI;
                            $47eb2057f4163810$var$addSerializedAttribute(buf, attrPrefix ? 'xmlns:' + attrPrefix : 'xmlns', uri);
                            childNs.push({
                                prefix: attrPrefix,
                                namespace: uri
                            });
                        }
                        // Apply nodeFilter and serialize the attribute.
                        var filteredAttr = nodeFilter ? nodeFilter(attr) : attr;
                        if (filteredAttr) {
                            if (typeof filteredAttr === 'string') buf.push(filteredAttr);
                            else $47eb2057f4163810$var$addSerializedAttribute(buf, filteredAttr.name, filteredAttr.value);
                        }
                    }
                    // add namespace for current node
                    if (nodeName === prefixedNodeName && $47eb2057f4163810$var$needNamespaceDefine(n, html, childNs)) {
                        var nodePrefix = n.prefix || '';
                        var uri = n.namespaceURI;
                        $47eb2057f4163810$var$addSerializedAttribute(buf, nodePrefix ? 'xmlns:' + nodePrefix : 'xmlns', uri);
                        childNs.push({
                            prefix: nodePrefix,
                            namespace: uri
                        });
                    }
                    var child = n.firstChild;
                    if (child || html && !/^(?:meta|link|img|br|hr|input)$/i.test(nodeName)) {
                        buf.push('>');
                        if (html && /^script$/i.test(nodeName)) {
                            // Inline serialization for <script> children; return null to skip walkDOM descent.
                            while(child){
                                if (child.data) buf.push(child.data);
                                else $47eb2057f4163810$var$serializeToString(child, buf, html, nodeFilter, childNs.slice(), requireWellFormed);
                                child = child.nextSibling;
                            }
                            buf.push('</', nodeName, '>');
                            return null;
                        }
                        // Return child context; walkDOM descends and exit emits the closing tag.
                        return {
                            ns: childNs,
                            isHTML: html,
                            tag: prefixedNodeName
                        };
                    } else {
                        buf.push('/>');
                        return null;
                    }
                case $47eb2057f4163810$var$DOCUMENT_NODE:
                case $47eb2057f4163810$var$DOCUMENT_FRAGMENT_NODE:
                    // Descend into children; exit is a no-op (tag is null).
                    return {
                        ns: ns.slice(),
                        isHTML: html,
                        tag: null
                    };
                case $47eb2057f4163810$var$ATTRIBUTE_NODE:
                    $47eb2057f4163810$var$addSerializedAttribute(buf, n.name, n.value);
                    return null;
                case $47eb2057f4163810$var$TEXT_NODE:
                    /**
					 * The ampersand character (&) and the left angle bracket (<) must not appear in their literal form,
					 * except when used as markup delimiters, or within a comment, a processing instruction, or a CDATA section.
					 * If they are needed elsewhere, they must be escaped using either numeric character references or the strings
					 * `&amp;` and `&lt;` respectively.
					 * The right angle bracket (>) may be represented using the string " &gt; ", and must, for compatibility,
					 * be escaped using either `&gt;` or a character reference when it appears in the string `]]>` in content,
					 * when that string is not marking the end of a CDATA section.
					 *
					 * In the content of elements, character data is any string of characters
					 * which does not contain the start-delimiter of any markup
					 * and does not include the CDATA-section-close delimiter, `]]>`.
					 *
					 * @see https://www.w3.org/TR/xml/#NT-CharData
					 * @see https://w3c.github.io/DOM-Parsing/#xml-serializing-a-text-node
					 */ buf.push(n.data.replace(/[<&>]/g, $47eb2057f4163810$var$_xmlEncoder));
                    return null;
                case $47eb2057f4163810$var$CDATA_SECTION_NODE:
                    if (requireWellFormed && n.data.indexOf(']]>') !== -1) throw new $47eb2057f4163810$var$DOMException($47eb2057f4163810$var$INVALID_STATE_ERR, 'The CDATASection data contains "]]>"');
                    buf.push('<![CDATA[', n.data.replace(/]]>/g, ']]]]><![CDATA[>'), ']]>');
                    return null;
                case $47eb2057f4163810$var$COMMENT_NODE:
                    if (requireWellFormed && n.data.indexOf('-->') !== -1) throw new $47eb2057f4163810$var$DOMException($47eb2057f4163810$var$INVALID_STATE_ERR, 'The comment node data contains "-->"');
                    buf.push('<!--', n.data, '-->');
                    return null;
                case $47eb2057f4163810$var$DOCUMENT_TYPE_NODE:
                    if (requireWellFormed) {
                        if (n.publicId && !/^("[\x20\r\na-zA-Z0-9\-()+,.\/:=?;!*#@$_%']*"|'[\x20\r\na-zA-Z0-9\-()+,.\/:=?;!*#@$_%'"]*')$/.test(n.publicId)) throw new $47eb2057f4163810$var$DOMException($47eb2057f4163810$var$INVALID_STATE_ERR, 'DocumentType publicId is not a valid PubidLiteral');
                        if (n.systemId && !/^("[^"]*"|'[^']*')$/.test(n.systemId)) throw new $47eb2057f4163810$var$DOMException($47eb2057f4163810$var$INVALID_STATE_ERR, 'DocumentType systemId is not a valid SystemLiteral');
                        if (n.internalSubset && n.internalSubset.indexOf(']>') !== -1) throw new $47eb2057f4163810$var$DOMException($47eb2057f4163810$var$INVALID_STATE_ERR, 'DocumentType internalSubset contains "]>"');
                    }
                    var pubid = n.publicId;
                    var sysid = n.systemId;
                    buf.push('<!DOCTYPE ', n.name);
                    if (pubid) {
                        buf.push(' PUBLIC ', pubid);
                        if (sysid && sysid != '.') buf.push(' ', sysid);
                        buf.push('>');
                    } else if (sysid && sysid != '.') buf.push(' SYSTEM ', sysid, '>');
                    else {
                        var sub = n.internalSubset;
                        if (sub) buf.push(' [', sub, ']');
                        buf.push('>');
                    }
                    return null;
                case $47eb2057f4163810$var$PROCESSING_INSTRUCTION_NODE:
                    if (requireWellFormed && n.data.indexOf('?>') !== -1) throw new $47eb2057f4163810$var$DOMException($47eb2057f4163810$var$INVALID_STATE_ERR, 'The ProcessingInstruction data contains "?>"');
                    buf.push('<?', n.target, ' ', n.data, '?>');
                    return null;
                case $47eb2057f4163810$var$ENTITY_REFERENCE_NODE:
                    buf.push('&', n.nodeName, ';');
                    return null;
                //case ENTITY_NODE:
                //case NOTATION_NODE:
                default:
                    buf.push('??', n.nodeName);
                    return null;
            }
        },
        exit: function(n, childCtx) {
            if (childCtx && childCtx.tag) buf.push('</', childCtx.tag, '>');
        }
    });
}
/**
 * Imports a node from a different document into `doc`, creating a new copy.
 * Delegates to {@link walkDOM} for traversal. Each node in the subtree is shallow-cloned,
 * stamped with `doc` as its `ownerDocument`, and detached (`parentNode` set to `null`).
 * Children are imported recursively when `deep` is `true`; for {@link Attr} nodes `deep` is
 * always forced to `true`
 * because an attribute's value lives in a child text node.
 *
 * @param {Document} doc
 * The document that will own the imported node.
 * @param {Node} node
 * The node to import.
 * @param {boolean} deep
 * If `true`, descendants are imported recursively.
 * @returns {Node}
 * The newly imported node, now owned by `doc`.
 */ function $47eb2057f4163810$var$importNode(doc, node, deep) {
    var destRoot;
    $47eb2057f4163810$var$walkDOM(node, null, {
        enter: function(srcNode, destParent) {
            // Shallow-clone the node and stamp it into the target document.
            var destNode = srcNode.cloneNode(false);
            destNode.ownerDocument = doc;
            destNode.parentNode = null;
            // capture as the root of the imported subtree or attach to parent.
            if (destParent === null) destRoot = destNode;
            else destParent.appendChild(destNode);
            // ATTRIBUTE_NODE must always be imported deeply: its value lives in a child text node.
            var shouldDeep = srcNode.nodeType === $47eb2057f4163810$var$ATTRIBUTE_NODE || deep;
            return shouldDeep ? destNode : null;
        }
    });
    return destRoot;
}
//
//var _relationMap = {firstChild:1,lastChild:1,previousSibling:1,nextSibling:1,
//					attributes:1,childNodes:1,parentNode:1,documentElement:1,doctype,};
function $47eb2057f4163810$var$cloneNode(doc, node, deep) {
    var destRoot;
    $47eb2057f4163810$var$walkDOM(node, null, {
        enter: function(srcNode, destParent) {
            // 1. Create a blank node of the same type and copy all scalar own properties.
            var destNode = new srcNode.constructor();
            for(var n in srcNode)if (Object.prototype.hasOwnProperty.call(srcNode, n)) {
                var v = srcNode[n];
                if (typeof v != 'object') {
                    if (v != destNode[n]) destNode[n] = v;
                }
            }
            if (srcNode.childNodes) destNode.childNodes = new $47eb2057f4163810$var$NodeList();
            destNode.ownerDocument = doc;
            // 2. Handle node-type-specific setup.
            //    Attributes are not DOM children, so they are cloned inline here
            //    rather than by walkDOM descent.
            //    ATTRIBUTE_NODE forces deep=true so its own children are walked.
            var shouldDeep = deep;
            switch(destNode.nodeType){
                case $47eb2057f4163810$var$ELEMENT_NODE:
                    var attrs = srcNode.attributes;
                    var attrs2 = destNode.attributes = new $47eb2057f4163810$var$NamedNodeMap();
                    var len = attrs.length;
                    attrs2._ownerElement = destNode;
                    for(var i = 0; i < len; i++)destNode.setAttributeNode($47eb2057f4163810$var$cloneNode(doc, attrs.item(i), true));
                    break;
                case $47eb2057f4163810$var$ATTRIBUTE_NODE:
                    shouldDeep = true;
            }
            // 3. Attach to parent, or capture as the root of the cloned subtree.
            if (destParent !== null) destParent.appendChild(destNode);
            else destRoot = destNode;
            // 4. Return destNode as the context for children (causes walkDOM to descend),
            //    or null to skip children (shallow clone).
            return shouldDeep ? destNode : null;
        }
    });
    return destRoot;
}
function $47eb2057f4163810$var$__set__(object, key, value) {
    object[key] = value;
}
//do dynamic
try {
    if (Object.defineProperty) {
        Object.defineProperty($47eb2057f4163810$var$LiveNodeList.prototype, 'length', {
            get: function() {
                $47eb2057f4163810$var$_updateLiveList(this);
                return this.$$length;
            }
        });
        /**
		 * The text content of this node and its descendants.
		 *
		 * Setting `textContent` on an element or document fragment replaces all child nodes with a
		 * single text node; on other nodes it sets `data`, `value`, and `nodeValue` directly.
		 *
		 * @type {string | null}
		 * @see {@link https://dom.spec.whatwg.org/#dom-node-textcontent}
		 */ Object.defineProperty($47eb2057f4163810$var$Node.prototype, 'textContent', {
            get: function() {
                if (this.nodeType === $47eb2057f4163810$var$ELEMENT_NODE || this.nodeType === $47eb2057f4163810$var$DOCUMENT_FRAGMENT_NODE) {
                    var buf = [];
                    $47eb2057f4163810$var$walkDOM(this, null, {
                        enter: function(n) {
                            if (n.nodeType === $47eb2057f4163810$var$ELEMENT_NODE || n.nodeType === $47eb2057f4163810$var$DOCUMENT_FRAGMENT_NODE) return true; // enter children
                            if (n.nodeType === $47eb2057f4163810$var$PROCESSING_INSTRUCTION_NODE || n.nodeType === $47eb2057f4163810$var$COMMENT_NODE) return null; // excluded from text content
                            buf.push(n.nodeValue);
                        }
                    });
                    return buf.join('');
                }
                return this.nodeValue;
            },
            set: function(data) {
                switch(this.nodeType){
                    case $47eb2057f4163810$var$ELEMENT_NODE:
                    case $47eb2057f4163810$var$DOCUMENT_FRAGMENT_NODE:
                        while(this.firstChild)this.removeChild(this.firstChild);
                        if (data || String(data)) this.appendChild(this.ownerDocument.createTextNode(data));
                        break;
                    default:
                        this.data = data;
                        this.value = data;
                        this.nodeValue = data;
                }
            }
        });
        $47eb2057f4163810$var$__set__ = function(object, key, value) {
            //console.log(value)
            object['$$' + key] = value;
        };
    }
} catch (e) {}
$47eb2057f4163810$export$d1d99cf900472499 = $47eb2057f4163810$var$DocumentType;
$47eb2057f4163810$export$fe58bcf938607f6a = $47eb2057f4163810$var$DOMException;
$47eb2057f4163810$export$455426655eab1d48 = $47eb2057f4163810$var$DOMImplementation;
$47eb2057f4163810$export$db77ccec0bb4ccac = $47eb2057f4163810$var$Element;
$47eb2057f4163810$export$85c928794f8d04d4 = $47eb2057f4163810$var$Node;
$47eb2057f4163810$export$79b41aa5d56abdff = $47eb2057f4163810$var$NodeList;
$47eb2057f4163810$export$5118471ee5d5453b = $47eb2057f4163810$var$walkDOM;
$47eb2057f4163810$export$64f0bed4ae6f0f24 = $47eb2057f4163810$var$XMLSerializer; //}

});
parcelRegister("aeRet", function(module, exports) {

$parcel$export(module.exports, "find", function () { return $774481049d9a42bd$export$71aa6c912b956294; }, function (v) { return $774481049d9a42bd$export$71aa6c912b956294 = v; });
$parcel$export(module.exports, "freeze", function () { return $774481049d9a42bd$export$792f3d81ea979f55; }, function (v) { return $774481049d9a42bd$export$792f3d81ea979f55 = v; });
$parcel$export(module.exports, "NAMESPACE", function () { return $774481049d9a42bd$export$6aad947bda0f3f46; }, function (v) { return $774481049d9a42bd$export$6aad947bda0f3f46 = v; });
var $774481049d9a42bd$export$e6e34fd1f2686227;
var $774481049d9a42bd$export$71aa6c912b956294;
var $774481049d9a42bd$export$792f3d81ea979f55;
var $774481049d9a42bd$export$c6cb9dd1e3ada1aa;
var $774481049d9a42bd$export$6aad947bda0f3f46;
'use strict';
/**
 * Ponyfill for `Array.prototype.find` which is only available in ES6 runtimes.
 *
 * Works with anything that has a `length` property and index access properties, including NodeList.
 *
 * @template {unknown} T
 * @param {Array<T> | ({length:number, [number]: T})} list
 * @param {function (item: T, index: number, list:Array<T> | ({length:number, [number]: T})):boolean} predicate
 * @param {Partial<Pick<ArrayConstructor['prototype'], 'find'>>?} ac `Array.prototype` by default,
 * 				allows injecting a custom implementation in tests
 * @returns {T | undefined}
 *
 * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/find
 * @see https://tc39.es/ecma262/multipage/indexed-collections.html#sec-array.prototype.find
 */ function $774481049d9a42bd$var$find(list, predicate, ac) {
    if (ac === undefined) ac = Array.prototype;
    if (list && typeof ac.find === 'function') return ac.find.call(list, predicate);
    for(var i = 0; i < list.length; i++)if (Object.prototype.hasOwnProperty.call(list, i)) {
        var item = list[i];
        if (predicate.call(undefined, item, i, list)) return item;
    }
}
/**
 * "Shallow freezes" an object to render it immutable.
 * Uses `Object.freeze` if available,
 * otherwise the immutability is only in the type.
 *
 * Is used to create "enum like" objects.
 *
 * @template T
 * @param {T} object the object to freeze
 * @param {Pick<ObjectConstructor, 'freeze'> = Object} oc `Object` by default,
 * 				allows to inject custom object constructor for tests
 * @returns {Readonly<T>}
 *
 * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/freeze
 */ function $774481049d9a42bd$var$freeze(object, oc) {
    if (oc === undefined) oc = Object;
    return oc && typeof oc.freeze === 'function' ? oc.freeze(object) : object;
}
/**
 * Since we can not rely on `Object.assign` we provide a simplified version
 * that is sufficient for our needs.
 *
 * @param {Object} target
 * @param {Object | null | undefined} source
 *
 * @returns {Object} target
 * @throws TypeError if target is not an object
 *
 * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/assign
 * @see https://tc39.es/ecma262/multipage/fundamental-objects.html#sec-object.assign
 */ function $774481049d9a42bd$var$assign(target, source) {
    if (target === null || typeof target !== 'object') throw new TypeError('target is not an object');
    for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    return target;
}
/**
 * All mime types that are allowed as input to `DOMParser.parseFromString`
 *
 * @see https://developer.mozilla.org/en-US/docs/Web/API/DOMParser/parseFromString#Argument02 MDN
 * @see https://html.spec.whatwg.org/multipage/dynamic-markup-insertion.html#domparsersupportedtype WHATWG HTML Spec
 * @see DOMParser.prototype.parseFromString
 */ var $774481049d9a42bd$var$MIME_TYPE = $774481049d9a42bd$var$freeze({
    /**
	 * `text/html`, the only mime type that triggers treating an XML document as HTML.
	 *
	 * @see DOMParser.SupportedType.isHTML
	 * @see https://www.iana.org/assignments/media-types/text/html IANA MimeType registration
	 * @see https://en.wikipedia.org/wiki/HTML Wikipedia
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/DOMParser/parseFromString MDN
	 * @see https://html.spec.whatwg.org/multipage/dynamic-markup-insertion.html#dom-domparser-parsefromstring WHATWG HTML Spec
	 */ HTML: 'text/html',
    /**
	 * Helper method to check a mime type if it indicates an HTML document
	 *
	 * @param {string} [value]
	 * @returns {boolean}
	 *
	 * @see https://www.iana.org/assignments/media-types/text/html IANA MimeType registration
	 * @see https://en.wikipedia.org/wiki/HTML Wikipedia
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/DOMParser/parseFromString MDN
	 * @see https://html.spec.whatwg.org/multipage/dynamic-markup-insertion.html#dom-domparser-parsefromstring 	 */ isHTML: function(value) {
        return value === $774481049d9a42bd$var$MIME_TYPE.HTML;
    },
    /**
	 * `application/xml`, the standard mime type for XML documents.
	 *
	 * @see https://www.iana.org/assignments/media-types/application/xml IANA MimeType registration
	 * @see https://tools.ietf.org/html/rfc7303#section-9.1 RFC 7303
	 * @see https://en.wikipedia.org/wiki/XML_and_MIME Wikipedia
	 */ XML_APPLICATION: 'application/xml',
    /**
	 * `text/html`, an alias for `application/xml`.
	 *
	 * @see https://tools.ietf.org/html/rfc7303#section-9.2 RFC 7303
	 * @see https://www.iana.org/assignments/media-types/text/xml IANA MimeType registration
	 * @see https://en.wikipedia.org/wiki/XML_and_MIME Wikipedia
	 */ XML_TEXT: 'text/xml',
    /**
	 * `application/xhtml+xml`, indicates an XML document that has the default HTML namespace,
	 * but is parsed as an XML document.
	 *
	 * @see https://www.iana.org/assignments/media-types/application/xhtml+xml IANA MimeType registration
	 * @see https://dom.spec.whatwg.org/#dom-domimplementation-createdocument WHATWG DOM Spec
	 * @see https://en.wikipedia.org/wiki/XHTML Wikipedia
	 */ XML_XHTML_APPLICATION: 'application/xhtml+xml',
    /**
	 * `image/svg+xml`,
	 *
	 * @see https://www.iana.org/assignments/media-types/image/svg+xml IANA MimeType registration
	 * @see https://www.w3.org/TR/SVG11/ W3C SVG 1.1
	 * @see https://en.wikipedia.org/wiki/Scalable_Vector_Graphics Wikipedia
	 */ XML_SVG_IMAGE: 'image/svg+xml'
});
/**
 * Namespaces that are used in this code base.
 *
 * @see http://www.w3.org/TR/REC-xml-names
 */ var $774481049d9a42bd$var$NAMESPACE = $774481049d9a42bd$var$freeze({
    /**
	 * The XHTML namespace.
	 *
	 * @see http://www.w3.org/1999/xhtml
	 */ HTML: 'http://www.w3.org/1999/xhtml',
    /**
	 * Checks if `uri` equals `NAMESPACE.HTML`.
	 *
	 * @param {string} [uri]
	 *
	 * @see NAMESPACE.HTML
	 */ isHTML: function(uri) {
        return uri === $774481049d9a42bd$var$NAMESPACE.HTML;
    },
    /**
	 * The SVG namespace.
	 *
	 * @see http://www.w3.org/2000/svg
	 */ SVG: 'http://www.w3.org/2000/svg',
    /**
	 * The `xml:` namespace.
	 *
	 * @see http://www.w3.org/XML/1998/namespace
	 */ XML: 'http://www.w3.org/XML/1998/namespace',
    /**
	 * The `xmlns:` namespace
	 *
	 * @see https://www.w3.org/2000/xmlns/
	 */ XMLNS: 'http://www.w3.org/2000/xmlns/'
});
$774481049d9a42bd$export$e6e34fd1f2686227 = $774481049d9a42bd$var$assign;
$774481049d9a42bd$export$71aa6c912b956294 = $774481049d9a42bd$var$find;
$774481049d9a42bd$export$792f3d81ea979f55 = $774481049d9a42bd$var$freeze;
$774481049d9a42bd$export$c6cb9dd1e3ada1aa = $774481049d9a42bd$var$MIME_TYPE;
$774481049d9a42bd$export$6aad947bda0f3f46 = $774481049d9a42bd$var$NAMESPACE;

});


parcelRegister("dQ0RX", function(module, exports) {

$parcel$export(module.exports, "DOMParser", function () { return $a130ce54fd9772f1$export$1059c6e7d2ce5669; }, function (v) { return $a130ce54fd9772f1$export$1059c6e7d2ce5669 = v; });
var $a130ce54fd9772f1$export$181392475aa39887;
var $a130ce54fd9772f1$export$ba13e0e2f19e61a1;
var $a130ce54fd9772f1$export$1059c6e7d2ce5669;

var $aeRet = parcelRequire("aeRet");

var $6aORb = parcelRequire("6aORb");

var $3vNAZ = parcelRequire("3vNAZ");

var $lejlD = parcelRequire("lejlD");
var $a130ce54fd9772f1$var$DOMImplementation = $6aORb.DOMImplementation;
var $a130ce54fd9772f1$var$NAMESPACE = $aeRet.NAMESPACE;
var $a130ce54fd9772f1$var$ParseError = $lejlD.ParseError;
var $a130ce54fd9772f1$var$XMLReader = $lejlD.XMLReader;
/**
 * Normalizes line ending according to https://www.w3.org/TR/xml11/#sec-line-ends:
 *
 * > XML parsed entities are often stored in computer files which,
 * > for editing convenience, are organized into lines.
 * > These lines are typically separated by some combination
 * > of the characters CARRIAGE RETURN (#xD) and LINE FEED (#xA).
 * >
 * > To simplify the tasks of applications, the XML processor must behave
 * > as if it normalized all line breaks in external parsed entities (including the document entity)
 * > on input, before parsing, by translating all of the following to a single #xA character:
 * >
 * > 1. the two-character sequence #xD #xA
 * > 2. the two-character sequence #xD #x85
 * > 3. the single character #x85
 * > 4. the single character #x2028
 * > 5. any #xD character that is not immediately followed by #xA or #x85.
 *
 * @param {string} input
 * @returns {string}
 */ function $a130ce54fd9772f1$var$normalizeLineEndings(input) {
    return input.replace(/\r[\n\u0085]/g, '\n').replace(/[\r\u0085\u2028]/g, '\n');
}
/**
 * @typedef Locator
 * @property {number} [columnNumber]
 * @property {number} [lineNumber]
 */ /**
 * @typedef DOMParserOptions
 * @property {DOMHandler} [domBuilder]
 * @property {Function} [errorHandler]
 * @property {(string) => string} [normalizeLineEndings] used to replace line endings before parsing
 * 						defaults to `normalizeLineEndings`
 * @property {Locator} [locator]
 * @property {Record<string, string>} [xmlns]
 *
 * @see normalizeLineEndings
 */ /**
 * The DOMParser interface provides the ability to parse XML or HTML source code
 * from a string into a DOM `Document`.
 *
 * _xmldom is different from the spec in that it allows an `options` parameter,
 * to override the default behavior._
 *
 * @param {DOMParserOptions} [options]
 * @constructor
 *
 * @see https://developer.mozilla.org/en-US/docs/Web/API/DOMParser
 * @see https://html.spec.whatwg.org/multipage/dynamic-markup-insertion.html#dom-parsing-and-serialization
 */ function $a130ce54fd9772f1$var$DOMParser(options) {
    this.options = options || {
        locator: {}
    };
}
$a130ce54fd9772f1$var$DOMParser.prototype.parseFromString = function(source, mimeType) {
    var options = this.options;
    var sax = new $a130ce54fd9772f1$var$XMLReader();
    var domBuilder = options.domBuilder || new $a130ce54fd9772f1$var$DOMHandler(); //contentHandler and LexicalHandler
    var errorHandler = options.errorHandler;
    var locator = options.locator;
    var defaultNSMap = options.xmlns || {};
    var isHTML = /\/x?html?$/.test(mimeType); //mimeType.toLowerCase().indexOf('html') > -1;
    var entityMap = isHTML ? $3vNAZ.HTML_ENTITIES : $3vNAZ.XML_ENTITIES;
    if (locator) domBuilder.setDocumentLocator(locator);
    sax.errorHandler = $a130ce54fd9772f1$var$buildErrorHandler(errorHandler, domBuilder, locator);
    sax.domBuilder = options.domBuilder || domBuilder;
    if (isHTML) defaultNSMap[''] = $a130ce54fd9772f1$var$NAMESPACE.HTML;
    defaultNSMap.xml = defaultNSMap.xml || $a130ce54fd9772f1$var$NAMESPACE.XML;
    var normalize = options.normalizeLineEndings || $a130ce54fd9772f1$var$normalizeLineEndings;
    if (source && typeof source === 'string') sax.parse(normalize(source), defaultNSMap, entityMap);
    else sax.errorHandler.error('invalid doc source');
    return domBuilder.doc;
};
function $a130ce54fd9772f1$var$buildErrorHandler(errorImpl, domBuilder, locator) {
    if (!errorImpl) {
        if (domBuilder instanceof $a130ce54fd9772f1$var$DOMHandler) return domBuilder;
        errorImpl = domBuilder;
    }
    var errorHandler = {};
    var isCallback = errorImpl instanceof Function;
    locator = locator || {};
    function build(key) {
        var fn = errorImpl[key];
        if (!fn && isCallback) fn = errorImpl.length == 2 ? function(msg) {
            errorImpl(key, msg);
        } : errorImpl;
        errorHandler[key] = fn && function(msg) {
            fn('[xmldom ' + key + ']\t' + msg + $a130ce54fd9772f1$var$_locator(locator));
        } || function() {};
    }
    build('warning');
    build('error');
    build('fatalError');
    return errorHandler;
}
//console.log('#\n\n\n\n\n\n\n####')
/**
 * +ContentHandler+ErrorHandler
 * +LexicalHandler+EntityResolver2
 * -DeclHandler-DTDHandler
 *
 * DefaultHandler:EntityResolver, DTDHandler, ContentHandler, ErrorHandler
 * DefaultHandler2:DefaultHandler,LexicalHandler, DeclHandler, EntityResolver2
 * @link http://www.saxproject.org/apidoc/org/xml/sax/helpers/DefaultHandler.html
 */ function $a130ce54fd9772f1$var$DOMHandler() {
    this.cdata = false;
}
function $a130ce54fd9772f1$var$position(locator, node) {
    node.lineNumber = locator.lineNumber;
    node.columnNumber = locator.columnNumber;
}
/**
 * @see org.xml.sax.ContentHandler#startDocument
 * @link http://www.saxproject.org/apidoc/org/xml/sax/ContentHandler.html
 */ $a130ce54fd9772f1$var$DOMHandler.prototype = {
    startDocument: function() {
        this.doc = new $a130ce54fd9772f1$var$DOMImplementation().createDocument(null, null, null);
        if (this.locator) this.doc.documentURI = this.locator.systemId;
    },
    startElement: function(namespaceURI, localName, qName, attrs) {
        var doc = this.doc;
        var el = doc.createElementNS(namespaceURI, qName || localName);
        var len = attrs.length;
        $a130ce54fd9772f1$var$appendElement(this, el);
        this.currentElement = el;
        this.locator && $a130ce54fd9772f1$var$position(this.locator, el);
        for(var i = 0; i < len; i++){
            var namespaceURI = attrs.getURI(i);
            var value = attrs.getValue(i);
            var qName = attrs.getQName(i);
            var attr = doc.createAttributeNS(namespaceURI, qName);
            this.locator && $a130ce54fd9772f1$var$position(attrs.getLocator(i), attr);
            attr.value = attr.nodeValue = value;
            el.setAttributeNode(attr);
        }
    },
    endElement: function(namespaceURI, localName, qName) {
        var current = this.currentElement;
        var tagName = current.tagName;
        this.currentElement = current.parentNode;
    },
    startPrefixMapping: function(prefix, uri) {},
    endPrefixMapping: function(prefix) {},
    processingInstruction: function(target, data) {
        var ins = this.doc.createProcessingInstruction(target, data);
        this.locator && $a130ce54fd9772f1$var$position(this.locator, ins);
        $a130ce54fd9772f1$var$appendElement(this, ins);
    },
    ignorableWhitespace: function(ch, start, length) {},
    characters: function(chars, start, length) {
        chars = $a130ce54fd9772f1$var$_toString.apply(this, arguments);
        //console.log(chars)
        if (chars) {
            if (this.cdata) var charNode = this.doc.createCDATASection(chars);
            else var charNode = this.doc.createTextNode(chars);
            if (this.currentElement) this.currentElement.appendChild(charNode);
            else if (/^\s*$/.test(chars)) this.doc.appendChild(charNode);
            this.locator && $a130ce54fd9772f1$var$position(this.locator, charNode);
        }
    },
    skippedEntity: function(name) {},
    endDocument: function() {
        this.doc.normalize();
    },
    setDocumentLocator: function(locator) {
        if (this.locator = locator) locator.lineNumber = 0;
    },
    //LexicalHandler
    comment: function(chars, start, length) {
        chars = $a130ce54fd9772f1$var$_toString.apply(this, arguments);
        var comm = this.doc.createComment(chars);
        this.locator && $a130ce54fd9772f1$var$position(this.locator, comm);
        $a130ce54fd9772f1$var$appendElement(this, comm);
    },
    startCDATA: function() {
        //used in characters() methods
        this.cdata = true;
    },
    endCDATA: function() {
        this.cdata = false;
    },
    startDTD: function(name, publicId, systemId) {
        var impl = this.doc.implementation;
        if (impl && impl.createDocumentType) {
            var dt = impl.createDocumentType(name, publicId, systemId);
            this.locator && $a130ce54fd9772f1$var$position(this.locator, dt);
            $a130ce54fd9772f1$var$appendElement(this, dt);
            this.doc.doctype = dt;
        }
    },
    /**
	 * @see org.xml.sax.ErrorHandler
	 * @link http://www.saxproject.org/apidoc/org/xml/sax/ErrorHandler.html
	 */ warning: function(error) {
        console.warn('[xmldom warning]\t' + error, $a130ce54fd9772f1$var$_locator(this.locator));
    },
    error: function(error) {
        console.error('[xmldom error]\t' + error, $a130ce54fd9772f1$var$_locator(this.locator));
    },
    fatalError: function(error) {
        throw new $a130ce54fd9772f1$var$ParseError(error, this.locator);
    }
};
function $a130ce54fd9772f1$var$_locator(l) {
    if (l) return '\n@' + (l.systemId || '') + '#[line:' + l.lineNumber + ',col:' + l.columnNumber + ']';
}
function $a130ce54fd9772f1$var$_toString(chars, start, length) {
    if (typeof chars == 'string') return chars.substr(start, length);
    else {
        if (chars.length >= start + length || start) return new java.lang.String(chars, start, length) + '';
        return chars;
    }
}
/*
 * @link http://www.saxproject.org/apidoc/org/xml/sax/ext/LexicalHandler.html
 * used method of org.xml.sax.ext.LexicalHandler:
 *  #comment(chars, start, length)
 *  #startCDATA()
 *  #endCDATA()
 *  #startDTD(name, publicId, systemId)
 *
 *
 * IGNORED method of org.xml.sax.ext.LexicalHandler:
 *  #endDTD()
 *  #startEntity(name)
 *  #endEntity(name)
 *
 *
 * @link http://www.saxproject.org/apidoc/org/xml/sax/ext/DeclHandler.html
 * IGNORED method of org.xml.sax.ext.DeclHandler
 * 	#attributeDecl(eName, aName, type, mode, value)
 *  #elementDecl(name, model)
 *  #externalEntityDecl(name, publicId, systemId)
 *  #internalEntityDecl(name, value)
 * @link http://www.saxproject.org/apidoc/org/xml/sax/ext/EntityResolver2.html
 * IGNORED method of org.xml.sax.EntityResolver2
 *  #resolveEntity(String name,String publicId,String baseURI,String systemId)
 *  #resolveEntity(publicId, systemId)
 *  #getExternalSubset(name, baseURI)
 * @link http://www.saxproject.org/apidoc/org/xml/sax/DTDHandler.html
 * IGNORED method of org.xml.sax.DTDHandler
 *  #notationDecl(name, publicId, systemId) {};
 *  #unparsedEntityDecl(name, publicId, systemId, notationName) {};
 */ "endDTD,startEntity,endEntity,attributeDecl,elementDecl,externalEntityDecl,internalEntityDecl,resolveEntity,getExternalSubset,notationDecl,unparsedEntityDecl".replace(/\w+/g, function(key) {
    $a130ce54fd9772f1$var$DOMHandler.prototype[key] = function() {
        return null;
    };
});
/* Private static helpers treated below as private instance methods, so don't need to add these to the public API; we might use a Relator to also get rid of non-standard public properties */ function $a130ce54fd9772f1$var$appendElement(hander, node) {
    if (!hander.currentElement) hander.doc.appendChild(node);
    else hander.currentElement.appendChild(node);
} //appendChild and setAttributeNS are preformance key
$a130ce54fd9772f1$export$181392475aa39887 = $a130ce54fd9772f1$var$DOMHandler;
$a130ce54fd9772f1$export$ba13e0e2f19e61a1 = $a130ce54fd9772f1$var$normalizeLineEndings;
$a130ce54fd9772f1$export$1059c6e7d2ce5669 = $a130ce54fd9772f1$var$DOMParser;

});
parcelRegister("3vNAZ", function(module, exports) {

$parcel$export(module.exports, "XML_ENTITIES", function () { return $28eabcfdb4821410$export$91f0e5ff03dc84f; }, function (v) { return $28eabcfdb4821410$export$91f0e5ff03dc84f = v; });
$parcel$export(module.exports, "HTML_ENTITIES", function () { return $28eabcfdb4821410$export$b7e4d4631df36afa; }, function (v) { return $28eabcfdb4821410$export$b7e4d4631df36afa = v; });
/**
 * The entities that are predefined in every XML document.
 *
 * @see https://www.w3.org/TR/2006/REC-xml11-20060816/#sec-predefined-ent W3C XML 1.1
 * @see https://www.w3.org/TR/2008/REC-xml-20081126/#sec-predefined-ent W3C XML 1.0
 * @see https://en.wikipedia.org/wiki/List_of_XML_and_HTML_character_entity_references#Predefined_entities_in_XML Wikipedia
 */ var $28eabcfdb4821410$export$91f0e5ff03dc84f;
/**
 * A map of all entities that are detected in an HTML document.
 * They contain all entries from `XML_ENTITIES`.
 *
 * @see XML_ENTITIES
 * @see DOMParser.parseFromString
 * @see DOMImplementation.prototype.createHTMLDocument
 * @see https://html.spec.whatwg.org/#named-character-references WHATWG HTML(5) Spec
 * @see https://html.spec.whatwg.org/entities.json JSON
 * @see https://www.w3.org/TR/xml-entity-names/ W3C XML Entity Names
 * @see https://www.w3.org/TR/html4/sgml/entities.html W3C HTML4/SGML
 * @see https://en.wikipedia.org/wiki/List_of_XML_and_HTML_character_entity_references#Character_entity_references_in_HTML Wikipedia (HTML)
 * @see https://en.wikipedia.org/wiki/List_of_XML_and_HTML_character_entity_references#Entities_representing_special_characters_in_XHTML Wikpedia (XHTML)
 */ var $28eabcfdb4821410$export$b7e4d4631df36afa;
/**
 * @deprecated use `HTML_ENTITIES` instead
 * @see HTML_ENTITIES
 */ var $28eabcfdb4821410$export$79451380caed3f98;
'use strict';

var $aeRet = parcelRequire("aeRet");
var $28eabcfdb4821410$require$freeze = $aeRet.freeze;
$28eabcfdb4821410$export$91f0e5ff03dc84f = $28eabcfdb4821410$require$freeze({
    amp: '&',
    apos: "'",
    gt: '>',
    lt: '<',
    quot: '"'
});
$28eabcfdb4821410$export$b7e4d4631df36afa = $28eabcfdb4821410$require$freeze({
    Aacute: '\u00C1',
    aacute: '\u00E1',
    Abreve: '\u0102',
    abreve: '\u0103',
    ac: '\u223E',
    acd: '\u223F',
    acE: '\u223E\u0333',
    Acirc: '\u00C2',
    acirc: '\u00E2',
    acute: '\u00B4',
    Acy: '\u0410',
    acy: '\u0430',
    AElig: '\u00C6',
    aelig: '\u00E6',
    af: '\u2061',
    Afr: '\uD835\uDD04',
    afr: '\uD835\uDD1E',
    Agrave: '\u00C0',
    agrave: '\u00E0',
    alefsym: '\u2135',
    aleph: '\u2135',
    Alpha: '\u0391',
    alpha: '\u03B1',
    Amacr: '\u0100',
    amacr: '\u0101',
    amalg: '\u2A3F',
    AMP: '\u0026',
    amp: '\u0026',
    And: '\u2A53',
    and: '\u2227',
    andand: '\u2A55',
    andd: '\u2A5C',
    andslope: '\u2A58',
    andv: '\u2A5A',
    ang: '\u2220',
    ange: '\u29A4',
    angle: '\u2220',
    angmsd: '\u2221',
    angmsdaa: '\u29A8',
    angmsdab: '\u29A9',
    angmsdac: '\u29AA',
    angmsdad: '\u29AB',
    angmsdae: '\u29AC',
    angmsdaf: '\u29AD',
    angmsdag: '\u29AE',
    angmsdah: '\u29AF',
    angrt: '\u221F',
    angrtvb: '\u22BE',
    angrtvbd: '\u299D',
    angsph: '\u2222',
    angst: '\u00C5',
    angzarr: '\u237C',
    Aogon: '\u0104',
    aogon: '\u0105',
    Aopf: '\uD835\uDD38',
    aopf: '\uD835\uDD52',
    ap: '\u2248',
    apacir: '\u2A6F',
    apE: '\u2A70',
    ape: '\u224A',
    apid: '\u224B',
    apos: '\u0027',
    ApplyFunction: '\u2061',
    approx: '\u2248',
    approxeq: '\u224A',
    Aring: '\u00C5',
    aring: '\u00E5',
    Ascr: '\uD835\uDC9C',
    ascr: '\uD835\uDCB6',
    Assign: '\u2254',
    ast: '\u002A',
    asymp: '\u2248',
    asympeq: '\u224D',
    Atilde: '\u00C3',
    atilde: '\u00E3',
    Auml: '\u00C4',
    auml: '\u00E4',
    awconint: '\u2233',
    awint: '\u2A11',
    backcong: '\u224C',
    backepsilon: '\u03F6',
    backprime: '\u2035',
    backsim: '\u223D',
    backsimeq: '\u22CD',
    Backslash: '\u2216',
    Barv: '\u2AE7',
    barvee: '\u22BD',
    Barwed: '\u2306',
    barwed: '\u2305',
    barwedge: '\u2305',
    bbrk: '\u23B5',
    bbrktbrk: '\u23B6',
    bcong: '\u224C',
    Bcy: '\u0411',
    bcy: '\u0431',
    bdquo: '\u201E',
    becaus: '\u2235',
    Because: '\u2235',
    because: '\u2235',
    bemptyv: '\u29B0',
    bepsi: '\u03F6',
    bernou: '\u212C',
    Bernoullis: '\u212C',
    Beta: '\u0392',
    beta: '\u03B2',
    beth: '\u2136',
    between: '\u226C',
    Bfr: '\uD835\uDD05',
    bfr: '\uD835\uDD1F',
    bigcap: '\u22C2',
    bigcirc: '\u25EF',
    bigcup: '\u22C3',
    bigodot: '\u2A00',
    bigoplus: '\u2A01',
    bigotimes: '\u2A02',
    bigsqcup: '\u2A06',
    bigstar: '\u2605',
    bigtriangledown: '\u25BD',
    bigtriangleup: '\u25B3',
    biguplus: '\u2A04',
    bigvee: '\u22C1',
    bigwedge: '\u22C0',
    bkarow: '\u290D',
    blacklozenge: '\u29EB',
    blacksquare: '\u25AA',
    blacktriangle: '\u25B4',
    blacktriangledown: '\u25BE',
    blacktriangleleft: '\u25C2',
    blacktriangleright: '\u25B8',
    blank: '\u2423',
    blk12: '\u2592',
    blk14: '\u2591',
    blk34: '\u2593',
    block: '\u2588',
    bne: '\u003D\u20E5',
    bnequiv: '\u2261\u20E5',
    bNot: '\u2AED',
    bnot: '\u2310',
    Bopf: '\uD835\uDD39',
    bopf: '\uD835\uDD53',
    bot: '\u22A5',
    bottom: '\u22A5',
    bowtie: '\u22C8',
    boxbox: '\u29C9',
    boxDL: '\u2557',
    boxDl: '\u2556',
    boxdL: '\u2555',
    boxdl: '\u2510',
    boxDR: '\u2554',
    boxDr: '\u2553',
    boxdR: '\u2552',
    boxdr: '\u250C',
    boxH: '\u2550',
    boxh: '\u2500',
    boxHD: '\u2566',
    boxHd: '\u2564',
    boxhD: '\u2565',
    boxhd: '\u252C',
    boxHU: '\u2569',
    boxHu: '\u2567',
    boxhU: '\u2568',
    boxhu: '\u2534',
    boxminus: '\u229F',
    boxplus: '\u229E',
    boxtimes: '\u22A0',
    boxUL: '\u255D',
    boxUl: '\u255C',
    boxuL: '\u255B',
    boxul: '\u2518',
    boxUR: '\u255A',
    boxUr: '\u2559',
    boxuR: '\u2558',
    boxur: '\u2514',
    boxV: '\u2551',
    boxv: '\u2502',
    boxVH: '\u256C',
    boxVh: '\u256B',
    boxvH: '\u256A',
    boxvh: '\u253C',
    boxVL: '\u2563',
    boxVl: '\u2562',
    boxvL: '\u2561',
    boxvl: '\u2524',
    boxVR: '\u2560',
    boxVr: '\u255F',
    boxvR: '\u255E',
    boxvr: '\u251C',
    bprime: '\u2035',
    Breve: '\u02D8',
    breve: '\u02D8',
    brvbar: '\u00A6',
    Bscr: '\u212C',
    bscr: '\uD835\uDCB7',
    bsemi: '\u204F',
    bsim: '\u223D',
    bsime: '\u22CD',
    bsol: '\u005C',
    bsolb: '\u29C5',
    bsolhsub: '\u27C8',
    bull: '\u2022',
    bullet: '\u2022',
    bump: '\u224E',
    bumpE: '\u2AAE',
    bumpe: '\u224F',
    Bumpeq: '\u224E',
    bumpeq: '\u224F',
    Cacute: '\u0106',
    cacute: '\u0107',
    Cap: '\u22D2',
    cap: '\u2229',
    capand: '\u2A44',
    capbrcup: '\u2A49',
    capcap: '\u2A4B',
    capcup: '\u2A47',
    capdot: '\u2A40',
    CapitalDifferentialD: '\u2145',
    caps: '\u2229\uFE00',
    caret: '\u2041',
    caron: '\u02C7',
    Cayleys: '\u212D',
    ccaps: '\u2A4D',
    Ccaron: '\u010C',
    ccaron: '\u010D',
    Ccedil: '\u00C7',
    ccedil: '\u00E7',
    Ccirc: '\u0108',
    ccirc: '\u0109',
    Cconint: '\u2230',
    ccups: '\u2A4C',
    ccupssm: '\u2A50',
    Cdot: '\u010A',
    cdot: '\u010B',
    cedil: '\u00B8',
    Cedilla: '\u00B8',
    cemptyv: '\u29B2',
    cent: '\u00A2',
    CenterDot: '\u00B7',
    centerdot: '\u00B7',
    Cfr: '\u212D',
    cfr: '\uD835\uDD20',
    CHcy: '\u0427',
    chcy: '\u0447',
    check: '\u2713',
    checkmark: '\u2713',
    Chi: '\u03A7',
    chi: '\u03C7',
    cir: '\u25CB',
    circ: '\u02C6',
    circeq: '\u2257',
    circlearrowleft: '\u21BA',
    circlearrowright: '\u21BB',
    circledast: '\u229B',
    circledcirc: '\u229A',
    circleddash: '\u229D',
    CircleDot: '\u2299',
    circledR: '\u00AE',
    circledS: '\u24C8',
    CircleMinus: '\u2296',
    CirclePlus: '\u2295',
    CircleTimes: '\u2297',
    cirE: '\u29C3',
    cire: '\u2257',
    cirfnint: '\u2A10',
    cirmid: '\u2AEF',
    cirscir: '\u29C2',
    ClockwiseContourIntegral: '\u2232',
    CloseCurlyDoubleQuote: '\u201D',
    CloseCurlyQuote: '\u2019',
    clubs: '\u2663',
    clubsuit: '\u2663',
    Colon: '\u2237',
    colon: '\u003A',
    Colone: '\u2A74',
    colone: '\u2254',
    coloneq: '\u2254',
    comma: '\u002C',
    commat: '\u0040',
    comp: '\u2201',
    compfn: '\u2218',
    complement: '\u2201',
    complexes: '\u2102',
    cong: '\u2245',
    congdot: '\u2A6D',
    Congruent: '\u2261',
    Conint: '\u222F',
    conint: '\u222E',
    ContourIntegral: '\u222E',
    Copf: '\u2102',
    copf: '\uD835\uDD54',
    coprod: '\u2210',
    Coproduct: '\u2210',
    COPY: '\u00A9',
    copy: '\u00A9',
    copysr: '\u2117',
    CounterClockwiseContourIntegral: '\u2233',
    crarr: '\u21B5',
    Cross: '\u2A2F',
    cross: '\u2717',
    Cscr: '\uD835\uDC9E',
    cscr: '\uD835\uDCB8',
    csub: '\u2ACF',
    csube: '\u2AD1',
    csup: '\u2AD0',
    csupe: '\u2AD2',
    ctdot: '\u22EF',
    cudarrl: '\u2938',
    cudarrr: '\u2935',
    cuepr: '\u22DE',
    cuesc: '\u22DF',
    cularr: '\u21B6',
    cularrp: '\u293D',
    Cup: '\u22D3',
    cup: '\u222A',
    cupbrcap: '\u2A48',
    CupCap: '\u224D',
    cupcap: '\u2A46',
    cupcup: '\u2A4A',
    cupdot: '\u228D',
    cupor: '\u2A45',
    cups: '\u222A\uFE00',
    curarr: '\u21B7',
    curarrm: '\u293C',
    curlyeqprec: '\u22DE',
    curlyeqsucc: '\u22DF',
    curlyvee: '\u22CE',
    curlywedge: '\u22CF',
    curren: '\u00A4',
    curvearrowleft: '\u21B6',
    curvearrowright: '\u21B7',
    cuvee: '\u22CE',
    cuwed: '\u22CF',
    cwconint: '\u2232',
    cwint: '\u2231',
    cylcty: '\u232D',
    Dagger: '\u2021',
    dagger: '\u2020',
    daleth: '\u2138',
    Darr: '\u21A1',
    dArr: '\u21D3',
    darr: '\u2193',
    dash: '\u2010',
    Dashv: '\u2AE4',
    dashv: '\u22A3',
    dbkarow: '\u290F',
    dblac: '\u02DD',
    Dcaron: '\u010E',
    dcaron: '\u010F',
    Dcy: '\u0414',
    dcy: '\u0434',
    DD: '\u2145',
    dd: '\u2146',
    ddagger: '\u2021',
    ddarr: '\u21CA',
    DDotrahd: '\u2911',
    ddotseq: '\u2A77',
    deg: '\u00B0',
    Del: '\u2207',
    Delta: '\u0394',
    delta: '\u03B4',
    demptyv: '\u29B1',
    dfisht: '\u297F',
    Dfr: '\uD835\uDD07',
    dfr: '\uD835\uDD21',
    dHar: '\u2965',
    dharl: '\u21C3',
    dharr: '\u21C2',
    DiacriticalAcute: '\u00B4',
    DiacriticalDot: '\u02D9',
    DiacriticalDoubleAcute: '\u02DD',
    DiacriticalGrave: '\u0060',
    DiacriticalTilde: '\u02DC',
    diam: '\u22C4',
    Diamond: '\u22C4',
    diamond: '\u22C4',
    diamondsuit: '\u2666',
    diams: '\u2666',
    die: '\u00A8',
    DifferentialD: '\u2146',
    digamma: '\u03DD',
    disin: '\u22F2',
    div: '\u00F7',
    divide: '\u00F7',
    divideontimes: '\u22C7',
    divonx: '\u22C7',
    DJcy: '\u0402',
    djcy: '\u0452',
    dlcorn: '\u231E',
    dlcrop: '\u230D',
    dollar: '\u0024',
    Dopf: '\uD835\uDD3B',
    dopf: '\uD835\uDD55',
    Dot: '\u00A8',
    dot: '\u02D9',
    DotDot: '\u20DC',
    doteq: '\u2250',
    doteqdot: '\u2251',
    DotEqual: '\u2250',
    dotminus: '\u2238',
    dotplus: '\u2214',
    dotsquare: '\u22A1',
    doublebarwedge: '\u2306',
    DoubleContourIntegral: '\u222F',
    DoubleDot: '\u00A8',
    DoubleDownArrow: '\u21D3',
    DoubleLeftArrow: '\u21D0',
    DoubleLeftRightArrow: '\u21D4',
    DoubleLeftTee: '\u2AE4',
    DoubleLongLeftArrow: '\u27F8',
    DoubleLongLeftRightArrow: '\u27FA',
    DoubleLongRightArrow: '\u27F9',
    DoubleRightArrow: '\u21D2',
    DoubleRightTee: '\u22A8',
    DoubleUpArrow: '\u21D1',
    DoubleUpDownArrow: '\u21D5',
    DoubleVerticalBar: '\u2225',
    DownArrow: '\u2193',
    Downarrow: '\u21D3',
    downarrow: '\u2193',
    DownArrowBar: '\u2913',
    DownArrowUpArrow: '\u21F5',
    DownBreve: '\u0311',
    downdownarrows: '\u21CA',
    downharpoonleft: '\u21C3',
    downharpoonright: '\u21C2',
    DownLeftRightVector: '\u2950',
    DownLeftTeeVector: '\u295E',
    DownLeftVector: '\u21BD',
    DownLeftVectorBar: '\u2956',
    DownRightTeeVector: '\u295F',
    DownRightVector: '\u21C1',
    DownRightVectorBar: '\u2957',
    DownTee: '\u22A4',
    DownTeeArrow: '\u21A7',
    drbkarow: '\u2910',
    drcorn: '\u231F',
    drcrop: '\u230C',
    Dscr: '\uD835\uDC9F',
    dscr: '\uD835\uDCB9',
    DScy: '\u0405',
    dscy: '\u0455',
    dsol: '\u29F6',
    Dstrok: '\u0110',
    dstrok: '\u0111',
    dtdot: '\u22F1',
    dtri: '\u25BF',
    dtrif: '\u25BE',
    duarr: '\u21F5',
    duhar: '\u296F',
    dwangle: '\u29A6',
    DZcy: '\u040F',
    dzcy: '\u045F',
    dzigrarr: '\u27FF',
    Eacute: '\u00C9',
    eacute: '\u00E9',
    easter: '\u2A6E',
    Ecaron: '\u011A',
    ecaron: '\u011B',
    ecir: '\u2256',
    Ecirc: '\u00CA',
    ecirc: '\u00EA',
    ecolon: '\u2255',
    Ecy: '\u042D',
    ecy: '\u044D',
    eDDot: '\u2A77',
    Edot: '\u0116',
    eDot: '\u2251',
    edot: '\u0117',
    ee: '\u2147',
    efDot: '\u2252',
    Efr: '\uD835\uDD08',
    efr: '\uD835\uDD22',
    eg: '\u2A9A',
    Egrave: '\u00C8',
    egrave: '\u00E8',
    egs: '\u2A96',
    egsdot: '\u2A98',
    el: '\u2A99',
    Element: '\u2208',
    elinters: '\u23E7',
    ell: '\u2113',
    els: '\u2A95',
    elsdot: '\u2A97',
    Emacr: '\u0112',
    emacr: '\u0113',
    empty: '\u2205',
    emptyset: '\u2205',
    EmptySmallSquare: '\u25FB',
    emptyv: '\u2205',
    EmptyVerySmallSquare: '\u25AB',
    emsp: '\u2003',
    emsp13: '\u2004',
    emsp14: '\u2005',
    ENG: '\u014A',
    eng: '\u014B',
    ensp: '\u2002',
    Eogon: '\u0118',
    eogon: '\u0119',
    Eopf: '\uD835\uDD3C',
    eopf: '\uD835\uDD56',
    epar: '\u22D5',
    eparsl: '\u29E3',
    eplus: '\u2A71',
    epsi: '\u03B5',
    Epsilon: '\u0395',
    epsilon: '\u03B5',
    epsiv: '\u03F5',
    eqcirc: '\u2256',
    eqcolon: '\u2255',
    eqsim: '\u2242',
    eqslantgtr: '\u2A96',
    eqslantless: '\u2A95',
    Equal: '\u2A75',
    equals: '\u003D',
    EqualTilde: '\u2242',
    equest: '\u225F',
    Equilibrium: '\u21CC',
    equiv: '\u2261',
    equivDD: '\u2A78',
    eqvparsl: '\u29E5',
    erarr: '\u2971',
    erDot: '\u2253',
    Escr: '\u2130',
    escr: '\u212F',
    esdot: '\u2250',
    Esim: '\u2A73',
    esim: '\u2242',
    Eta: '\u0397',
    eta: '\u03B7',
    ETH: '\u00D0',
    eth: '\u00F0',
    Euml: '\u00CB',
    euml: '\u00EB',
    euro: '\u20AC',
    excl: '\u0021',
    exist: '\u2203',
    Exists: '\u2203',
    expectation: '\u2130',
    ExponentialE: '\u2147',
    exponentiale: '\u2147',
    fallingdotseq: '\u2252',
    Fcy: '\u0424',
    fcy: '\u0444',
    female: '\u2640',
    ffilig: '\uFB03',
    fflig: '\uFB00',
    ffllig: '\uFB04',
    Ffr: '\uD835\uDD09',
    ffr: '\uD835\uDD23',
    filig: '\uFB01',
    FilledSmallSquare: '\u25FC',
    FilledVerySmallSquare: '\u25AA',
    fjlig: '\u0066\u006A',
    flat: '\u266D',
    fllig: '\uFB02',
    fltns: '\u25B1',
    fnof: '\u0192',
    Fopf: '\uD835\uDD3D',
    fopf: '\uD835\uDD57',
    ForAll: '\u2200',
    forall: '\u2200',
    fork: '\u22D4',
    forkv: '\u2AD9',
    Fouriertrf: '\u2131',
    fpartint: '\u2A0D',
    frac12: '\u00BD',
    frac13: '\u2153',
    frac14: '\u00BC',
    frac15: '\u2155',
    frac16: '\u2159',
    frac18: '\u215B',
    frac23: '\u2154',
    frac25: '\u2156',
    frac34: '\u00BE',
    frac35: '\u2157',
    frac38: '\u215C',
    frac45: '\u2158',
    frac56: '\u215A',
    frac58: '\u215D',
    frac78: '\u215E',
    frasl: '\u2044',
    frown: '\u2322',
    Fscr: '\u2131',
    fscr: '\uD835\uDCBB',
    gacute: '\u01F5',
    Gamma: '\u0393',
    gamma: '\u03B3',
    Gammad: '\u03DC',
    gammad: '\u03DD',
    gap: '\u2A86',
    Gbreve: '\u011E',
    gbreve: '\u011F',
    Gcedil: '\u0122',
    Gcirc: '\u011C',
    gcirc: '\u011D',
    Gcy: '\u0413',
    gcy: '\u0433',
    Gdot: '\u0120',
    gdot: '\u0121',
    gE: '\u2267',
    ge: '\u2265',
    gEl: '\u2A8C',
    gel: '\u22DB',
    geq: '\u2265',
    geqq: '\u2267',
    geqslant: '\u2A7E',
    ges: '\u2A7E',
    gescc: '\u2AA9',
    gesdot: '\u2A80',
    gesdoto: '\u2A82',
    gesdotol: '\u2A84',
    gesl: '\u22DB\uFE00',
    gesles: '\u2A94',
    Gfr: '\uD835\uDD0A',
    gfr: '\uD835\uDD24',
    Gg: '\u22D9',
    gg: '\u226B',
    ggg: '\u22D9',
    gimel: '\u2137',
    GJcy: '\u0403',
    gjcy: '\u0453',
    gl: '\u2277',
    gla: '\u2AA5',
    glE: '\u2A92',
    glj: '\u2AA4',
    gnap: '\u2A8A',
    gnapprox: '\u2A8A',
    gnE: '\u2269',
    gne: '\u2A88',
    gneq: '\u2A88',
    gneqq: '\u2269',
    gnsim: '\u22E7',
    Gopf: '\uD835\uDD3E',
    gopf: '\uD835\uDD58',
    grave: '\u0060',
    GreaterEqual: '\u2265',
    GreaterEqualLess: '\u22DB',
    GreaterFullEqual: '\u2267',
    GreaterGreater: '\u2AA2',
    GreaterLess: '\u2277',
    GreaterSlantEqual: '\u2A7E',
    GreaterTilde: '\u2273',
    Gscr: '\uD835\uDCA2',
    gscr: '\u210A',
    gsim: '\u2273',
    gsime: '\u2A8E',
    gsiml: '\u2A90',
    Gt: '\u226B',
    GT: '\u003E',
    gt: '\u003E',
    gtcc: '\u2AA7',
    gtcir: '\u2A7A',
    gtdot: '\u22D7',
    gtlPar: '\u2995',
    gtquest: '\u2A7C',
    gtrapprox: '\u2A86',
    gtrarr: '\u2978',
    gtrdot: '\u22D7',
    gtreqless: '\u22DB',
    gtreqqless: '\u2A8C',
    gtrless: '\u2277',
    gtrsim: '\u2273',
    gvertneqq: '\u2269\uFE00',
    gvnE: '\u2269\uFE00',
    Hacek: '\u02C7',
    hairsp: '\u200A',
    half: '\u00BD',
    hamilt: '\u210B',
    HARDcy: '\u042A',
    hardcy: '\u044A',
    hArr: '\u21D4',
    harr: '\u2194',
    harrcir: '\u2948',
    harrw: '\u21AD',
    Hat: '\u005E',
    hbar: '\u210F',
    Hcirc: '\u0124',
    hcirc: '\u0125',
    hearts: '\u2665',
    heartsuit: '\u2665',
    hellip: '\u2026',
    hercon: '\u22B9',
    Hfr: '\u210C',
    hfr: '\uD835\uDD25',
    HilbertSpace: '\u210B',
    hksearow: '\u2925',
    hkswarow: '\u2926',
    hoarr: '\u21FF',
    homtht: '\u223B',
    hookleftarrow: '\u21A9',
    hookrightarrow: '\u21AA',
    Hopf: '\u210D',
    hopf: '\uD835\uDD59',
    horbar: '\u2015',
    HorizontalLine: '\u2500',
    Hscr: '\u210B',
    hscr: '\uD835\uDCBD',
    hslash: '\u210F',
    Hstrok: '\u0126',
    hstrok: '\u0127',
    HumpDownHump: '\u224E',
    HumpEqual: '\u224F',
    hybull: '\u2043',
    hyphen: '\u2010',
    Iacute: '\u00CD',
    iacute: '\u00ED',
    ic: '\u2063',
    Icirc: '\u00CE',
    icirc: '\u00EE',
    Icy: '\u0418',
    icy: '\u0438',
    Idot: '\u0130',
    IEcy: '\u0415',
    iecy: '\u0435',
    iexcl: '\u00A1',
    iff: '\u21D4',
    Ifr: '\u2111',
    ifr: '\uD835\uDD26',
    Igrave: '\u00CC',
    igrave: '\u00EC',
    ii: '\u2148',
    iiiint: '\u2A0C',
    iiint: '\u222D',
    iinfin: '\u29DC',
    iiota: '\u2129',
    IJlig: '\u0132',
    ijlig: '\u0133',
    Im: '\u2111',
    Imacr: '\u012A',
    imacr: '\u012B',
    image: '\u2111',
    ImaginaryI: '\u2148',
    imagline: '\u2110',
    imagpart: '\u2111',
    imath: '\u0131',
    imof: '\u22B7',
    imped: '\u01B5',
    Implies: '\u21D2',
    in: '\u2208',
    incare: '\u2105',
    infin: '\u221E',
    infintie: '\u29DD',
    inodot: '\u0131',
    Int: '\u222C',
    int: '\u222B',
    intcal: '\u22BA',
    integers: '\u2124',
    Integral: '\u222B',
    intercal: '\u22BA',
    Intersection: '\u22C2',
    intlarhk: '\u2A17',
    intprod: '\u2A3C',
    InvisibleComma: '\u2063',
    InvisibleTimes: '\u2062',
    IOcy: '\u0401',
    iocy: '\u0451',
    Iogon: '\u012E',
    iogon: '\u012F',
    Iopf: '\uD835\uDD40',
    iopf: '\uD835\uDD5A',
    Iota: '\u0399',
    iota: '\u03B9',
    iprod: '\u2A3C',
    iquest: '\u00BF',
    Iscr: '\u2110',
    iscr: '\uD835\uDCBE',
    isin: '\u2208',
    isindot: '\u22F5',
    isinE: '\u22F9',
    isins: '\u22F4',
    isinsv: '\u22F3',
    isinv: '\u2208',
    it: '\u2062',
    Itilde: '\u0128',
    itilde: '\u0129',
    Iukcy: '\u0406',
    iukcy: '\u0456',
    Iuml: '\u00CF',
    iuml: '\u00EF',
    Jcirc: '\u0134',
    jcirc: '\u0135',
    Jcy: '\u0419',
    jcy: '\u0439',
    Jfr: '\uD835\uDD0D',
    jfr: '\uD835\uDD27',
    jmath: '\u0237',
    Jopf: '\uD835\uDD41',
    jopf: '\uD835\uDD5B',
    Jscr: '\uD835\uDCA5',
    jscr: '\uD835\uDCBF',
    Jsercy: '\u0408',
    jsercy: '\u0458',
    Jukcy: '\u0404',
    jukcy: '\u0454',
    Kappa: '\u039A',
    kappa: '\u03BA',
    kappav: '\u03F0',
    Kcedil: '\u0136',
    kcedil: '\u0137',
    Kcy: '\u041A',
    kcy: '\u043A',
    Kfr: '\uD835\uDD0E',
    kfr: '\uD835\uDD28',
    kgreen: '\u0138',
    KHcy: '\u0425',
    khcy: '\u0445',
    KJcy: '\u040C',
    kjcy: '\u045C',
    Kopf: '\uD835\uDD42',
    kopf: '\uD835\uDD5C',
    Kscr: '\uD835\uDCA6',
    kscr: '\uD835\uDCC0',
    lAarr: '\u21DA',
    Lacute: '\u0139',
    lacute: '\u013A',
    laemptyv: '\u29B4',
    lagran: '\u2112',
    Lambda: '\u039B',
    lambda: '\u03BB',
    Lang: '\u27EA',
    lang: '\u27E8',
    langd: '\u2991',
    langle: '\u27E8',
    lap: '\u2A85',
    Laplacetrf: '\u2112',
    laquo: '\u00AB',
    Larr: '\u219E',
    lArr: '\u21D0',
    larr: '\u2190',
    larrb: '\u21E4',
    larrbfs: '\u291F',
    larrfs: '\u291D',
    larrhk: '\u21A9',
    larrlp: '\u21AB',
    larrpl: '\u2939',
    larrsim: '\u2973',
    larrtl: '\u21A2',
    lat: '\u2AAB',
    lAtail: '\u291B',
    latail: '\u2919',
    late: '\u2AAD',
    lates: '\u2AAD\uFE00',
    lBarr: '\u290E',
    lbarr: '\u290C',
    lbbrk: '\u2772',
    lbrace: '\u007B',
    lbrack: '\u005B',
    lbrke: '\u298B',
    lbrksld: '\u298F',
    lbrkslu: '\u298D',
    Lcaron: '\u013D',
    lcaron: '\u013E',
    Lcedil: '\u013B',
    lcedil: '\u013C',
    lceil: '\u2308',
    lcub: '\u007B',
    Lcy: '\u041B',
    lcy: '\u043B',
    ldca: '\u2936',
    ldquo: '\u201C',
    ldquor: '\u201E',
    ldrdhar: '\u2967',
    ldrushar: '\u294B',
    ldsh: '\u21B2',
    lE: '\u2266',
    le: '\u2264',
    LeftAngleBracket: '\u27E8',
    LeftArrow: '\u2190',
    Leftarrow: '\u21D0',
    leftarrow: '\u2190',
    LeftArrowBar: '\u21E4',
    LeftArrowRightArrow: '\u21C6',
    leftarrowtail: '\u21A2',
    LeftCeiling: '\u2308',
    LeftDoubleBracket: '\u27E6',
    LeftDownTeeVector: '\u2961',
    LeftDownVector: '\u21C3',
    LeftDownVectorBar: '\u2959',
    LeftFloor: '\u230A',
    leftharpoondown: '\u21BD',
    leftharpoonup: '\u21BC',
    leftleftarrows: '\u21C7',
    LeftRightArrow: '\u2194',
    Leftrightarrow: '\u21D4',
    leftrightarrow: '\u2194',
    leftrightarrows: '\u21C6',
    leftrightharpoons: '\u21CB',
    leftrightsquigarrow: '\u21AD',
    LeftRightVector: '\u294E',
    LeftTee: '\u22A3',
    LeftTeeArrow: '\u21A4',
    LeftTeeVector: '\u295A',
    leftthreetimes: '\u22CB',
    LeftTriangle: '\u22B2',
    LeftTriangleBar: '\u29CF',
    LeftTriangleEqual: '\u22B4',
    LeftUpDownVector: '\u2951',
    LeftUpTeeVector: '\u2960',
    LeftUpVector: '\u21BF',
    LeftUpVectorBar: '\u2958',
    LeftVector: '\u21BC',
    LeftVectorBar: '\u2952',
    lEg: '\u2A8B',
    leg: '\u22DA',
    leq: '\u2264',
    leqq: '\u2266',
    leqslant: '\u2A7D',
    les: '\u2A7D',
    lescc: '\u2AA8',
    lesdot: '\u2A7F',
    lesdoto: '\u2A81',
    lesdotor: '\u2A83',
    lesg: '\u22DA\uFE00',
    lesges: '\u2A93',
    lessapprox: '\u2A85',
    lessdot: '\u22D6',
    lesseqgtr: '\u22DA',
    lesseqqgtr: '\u2A8B',
    LessEqualGreater: '\u22DA',
    LessFullEqual: '\u2266',
    LessGreater: '\u2276',
    lessgtr: '\u2276',
    LessLess: '\u2AA1',
    lesssim: '\u2272',
    LessSlantEqual: '\u2A7D',
    LessTilde: '\u2272',
    lfisht: '\u297C',
    lfloor: '\u230A',
    Lfr: '\uD835\uDD0F',
    lfr: '\uD835\uDD29',
    lg: '\u2276',
    lgE: '\u2A91',
    lHar: '\u2962',
    lhard: '\u21BD',
    lharu: '\u21BC',
    lharul: '\u296A',
    lhblk: '\u2584',
    LJcy: '\u0409',
    ljcy: '\u0459',
    Ll: '\u22D8',
    ll: '\u226A',
    llarr: '\u21C7',
    llcorner: '\u231E',
    Lleftarrow: '\u21DA',
    llhard: '\u296B',
    lltri: '\u25FA',
    Lmidot: '\u013F',
    lmidot: '\u0140',
    lmoust: '\u23B0',
    lmoustache: '\u23B0',
    lnap: '\u2A89',
    lnapprox: '\u2A89',
    lnE: '\u2268',
    lne: '\u2A87',
    lneq: '\u2A87',
    lneqq: '\u2268',
    lnsim: '\u22E6',
    loang: '\u27EC',
    loarr: '\u21FD',
    lobrk: '\u27E6',
    LongLeftArrow: '\u27F5',
    Longleftarrow: '\u27F8',
    longleftarrow: '\u27F5',
    LongLeftRightArrow: '\u27F7',
    Longleftrightarrow: '\u27FA',
    longleftrightarrow: '\u27F7',
    longmapsto: '\u27FC',
    LongRightArrow: '\u27F6',
    Longrightarrow: '\u27F9',
    longrightarrow: '\u27F6',
    looparrowleft: '\u21AB',
    looparrowright: '\u21AC',
    lopar: '\u2985',
    Lopf: '\uD835\uDD43',
    lopf: '\uD835\uDD5D',
    loplus: '\u2A2D',
    lotimes: '\u2A34',
    lowast: '\u2217',
    lowbar: '\u005F',
    LowerLeftArrow: '\u2199',
    LowerRightArrow: '\u2198',
    loz: '\u25CA',
    lozenge: '\u25CA',
    lozf: '\u29EB',
    lpar: '\u0028',
    lparlt: '\u2993',
    lrarr: '\u21C6',
    lrcorner: '\u231F',
    lrhar: '\u21CB',
    lrhard: '\u296D',
    lrm: '\u200E',
    lrtri: '\u22BF',
    lsaquo: '\u2039',
    Lscr: '\u2112',
    lscr: '\uD835\uDCC1',
    Lsh: '\u21B0',
    lsh: '\u21B0',
    lsim: '\u2272',
    lsime: '\u2A8D',
    lsimg: '\u2A8F',
    lsqb: '\u005B',
    lsquo: '\u2018',
    lsquor: '\u201A',
    Lstrok: '\u0141',
    lstrok: '\u0142',
    Lt: '\u226A',
    LT: '\u003C',
    lt: '\u003C',
    ltcc: '\u2AA6',
    ltcir: '\u2A79',
    ltdot: '\u22D6',
    lthree: '\u22CB',
    ltimes: '\u22C9',
    ltlarr: '\u2976',
    ltquest: '\u2A7B',
    ltri: '\u25C3',
    ltrie: '\u22B4',
    ltrif: '\u25C2',
    ltrPar: '\u2996',
    lurdshar: '\u294A',
    luruhar: '\u2966',
    lvertneqq: '\u2268\uFE00',
    lvnE: '\u2268\uFE00',
    macr: '\u00AF',
    male: '\u2642',
    malt: '\u2720',
    maltese: '\u2720',
    Map: '\u2905',
    map: '\u21A6',
    mapsto: '\u21A6',
    mapstodown: '\u21A7',
    mapstoleft: '\u21A4',
    mapstoup: '\u21A5',
    marker: '\u25AE',
    mcomma: '\u2A29',
    Mcy: '\u041C',
    mcy: '\u043C',
    mdash: '\u2014',
    mDDot: '\u223A',
    measuredangle: '\u2221',
    MediumSpace: '\u205F',
    Mellintrf: '\u2133',
    Mfr: '\uD835\uDD10',
    mfr: '\uD835\uDD2A',
    mho: '\u2127',
    micro: '\u00B5',
    mid: '\u2223',
    midast: '\u002A',
    midcir: '\u2AF0',
    middot: '\u00B7',
    minus: '\u2212',
    minusb: '\u229F',
    minusd: '\u2238',
    minusdu: '\u2A2A',
    MinusPlus: '\u2213',
    mlcp: '\u2ADB',
    mldr: '\u2026',
    mnplus: '\u2213',
    models: '\u22A7',
    Mopf: '\uD835\uDD44',
    mopf: '\uD835\uDD5E',
    mp: '\u2213',
    Mscr: '\u2133',
    mscr: '\uD835\uDCC2',
    mstpos: '\u223E',
    Mu: '\u039C',
    mu: '\u03BC',
    multimap: '\u22B8',
    mumap: '\u22B8',
    nabla: '\u2207',
    Nacute: '\u0143',
    nacute: '\u0144',
    nang: '\u2220\u20D2',
    nap: '\u2249',
    napE: '\u2A70\u0338',
    napid: '\u224B\u0338',
    napos: '\u0149',
    napprox: '\u2249',
    natur: '\u266E',
    natural: '\u266E',
    naturals: '\u2115',
    nbsp: '\u00A0',
    nbump: '\u224E\u0338',
    nbumpe: '\u224F\u0338',
    ncap: '\u2A43',
    Ncaron: '\u0147',
    ncaron: '\u0148',
    Ncedil: '\u0145',
    ncedil: '\u0146',
    ncong: '\u2247',
    ncongdot: '\u2A6D\u0338',
    ncup: '\u2A42',
    Ncy: '\u041D',
    ncy: '\u043D',
    ndash: '\u2013',
    ne: '\u2260',
    nearhk: '\u2924',
    neArr: '\u21D7',
    nearr: '\u2197',
    nearrow: '\u2197',
    nedot: '\u2250\u0338',
    NegativeMediumSpace: '\u200B',
    NegativeThickSpace: '\u200B',
    NegativeThinSpace: '\u200B',
    NegativeVeryThinSpace: '\u200B',
    nequiv: '\u2262',
    nesear: '\u2928',
    nesim: '\u2242\u0338',
    NestedGreaterGreater: '\u226B',
    NestedLessLess: '\u226A',
    NewLine: '\u000A',
    nexist: '\u2204',
    nexists: '\u2204',
    Nfr: '\uD835\uDD11',
    nfr: '\uD835\uDD2B',
    ngE: '\u2267\u0338',
    nge: '\u2271',
    ngeq: '\u2271',
    ngeqq: '\u2267\u0338',
    ngeqslant: '\u2A7E\u0338',
    nges: '\u2A7E\u0338',
    nGg: '\u22D9\u0338',
    ngsim: '\u2275',
    nGt: '\u226B\u20D2',
    ngt: '\u226F',
    ngtr: '\u226F',
    nGtv: '\u226B\u0338',
    nhArr: '\u21CE',
    nharr: '\u21AE',
    nhpar: '\u2AF2',
    ni: '\u220B',
    nis: '\u22FC',
    nisd: '\u22FA',
    niv: '\u220B',
    NJcy: '\u040A',
    njcy: '\u045A',
    nlArr: '\u21CD',
    nlarr: '\u219A',
    nldr: '\u2025',
    nlE: '\u2266\u0338',
    nle: '\u2270',
    nLeftarrow: '\u21CD',
    nleftarrow: '\u219A',
    nLeftrightarrow: '\u21CE',
    nleftrightarrow: '\u21AE',
    nleq: '\u2270',
    nleqq: '\u2266\u0338',
    nleqslant: '\u2A7D\u0338',
    nles: '\u2A7D\u0338',
    nless: '\u226E',
    nLl: '\u22D8\u0338',
    nlsim: '\u2274',
    nLt: '\u226A\u20D2',
    nlt: '\u226E',
    nltri: '\u22EA',
    nltrie: '\u22EC',
    nLtv: '\u226A\u0338',
    nmid: '\u2224',
    NoBreak: '\u2060',
    NonBreakingSpace: '\u00A0',
    Nopf: '\u2115',
    nopf: '\uD835\uDD5F',
    Not: '\u2AEC',
    not: '\u00AC',
    NotCongruent: '\u2262',
    NotCupCap: '\u226D',
    NotDoubleVerticalBar: '\u2226',
    NotElement: '\u2209',
    NotEqual: '\u2260',
    NotEqualTilde: '\u2242\u0338',
    NotExists: '\u2204',
    NotGreater: '\u226F',
    NotGreaterEqual: '\u2271',
    NotGreaterFullEqual: '\u2267\u0338',
    NotGreaterGreater: '\u226B\u0338',
    NotGreaterLess: '\u2279',
    NotGreaterSlantEqual: '\u2A7E\u0338',
    NotGreaterTilde: '\u2275',
    NotHumpDownHump: '\u224E\u0338',
    NotHumpEqual: '\u224F\u0338',
    notin: '\u2209',
    notindot: '\u22F5\u0338',
    notinE: '\u22F9\u0338',
    notinva: '\u2209',
    notinvb: '\u22F7',
    notinvc: '\u22F6',
    NotLeftTriangle: '\u22EA',
    NotLeftTriangleBar: '\u29CF\u0338',
    NotLeftTriangleEqual: '\u22EC',
    NotLess: '\u226E',
    NotLessEqual: '\u2270',
    NotLessGreater: '\u2278',
    NotLessLess: '\u226A\u0338',
    NotLessSlantEqual: '\u2A7D\u0338',
    NotLessTilde: '\u2274',
    NotNestedGreaterGreater: '\u2AA2\u0338',
    NotNestedLessLess: '\u2AA1\u0338',
    notni: '\u220C',
    notniva: '\u220C',
    notnivb: '\u22FE',
    notnivc: '\u22FD',
    NotPrecedes: '\u2280',
    NotPrecedesEqual: '\u2AAF\u0338',
    NotPrecedesSlantEqual: '\u22E0',
    NotReverseElement: '\u220C',
    NotRightTriangle: '\u22EB',
    NotRightTriangleBar: '\u29D0\u0338',
    NotRightTriangleEqual: '\u22ED',
    NotSquareSubset: '\u228F\u0338',
    NotSquareSubsetEqual: '\u22E2',
    NotSquareSuperset: '\u2290\u0338',
    NotSquareSupersetEqual: '\u22E3',
    NotSubset: '\u2282\u20D2',
    NotSubsetEqual: '\u2288',
    NotSucceeds: '\u2281',
    NotSucceedsEqual: '\u2AB0\u0338',
    NotSucceedsSlantEqual: '\u22E1',
    NotSucceedsTilde: '\u227F\u0338',
    NotSuperset: '\u2283\u20D2',
    NotSupersetEqual: '\u2289',
    NotTilde: '\u2241',
    NotTildeEqual: '\u2244',
    NotTildeFullEqual: '\u2247',
    NotTildeTilde: '\u2249',
    NotVerticalBar: '\u2224',
    npar: '\u2226',
    nparallel: '\u2226',
    nparsl: '\u2AFD\u20E5',
    npart: '\u2202\u0338',
    npolint: '\u2A14',
    npr: '\u2280',
    nprcue: '\u22E0',
    npre: '\u2AAF\u0338',
    nprec: '\u2280',
    npreceq: '\u2AAF\u0338',
    nrArr: '\u21CF',
    nrarr: '\u219B',
    nrarrc: '\u2933\u0338',
    nrarrw: '\u219D\u0338',
    nRightarrow: '\u21CF',
    nrightarrow: '\u219B',
    nrtri: '\u22EB',
    nrtrie: '\u22ED',
    nsc: '\u2281',
    nsccue: '\u22E1',
    nsce: '\u2AB0\u0338',
    Nscr: '\uD835\uDCA9',
    nscr: '\uD835\uDCC3',
    nshortmid: '\u2224',
    nshortparallel: '\u2226',
    nsim: '\u2241',
    nsime: '\u2244',
    nsimeq: '\u2244',
    nsmid: '\u2224',
    nspar: '\u2226',
    nsqsube: '\u22E2',
    nsqsupe: '\u22E3',
    nsub: '\u2284',
    nsubE: '\u2AC5\u0338',
    nsube: '\u2288',
    nsubset: '\u2282\u20D2',
    nsubseteq: '\u2288',
    nsubseteqq: '\u2AC5\u0338',
    nsucc: '\u2281',
    nsucceq: '\u2AB0\u0338',
    nsup: '\u2285',
    nsupE: '\u2AC6\u0338',
    nsupe: '\u2289',
    nsupset: '\u2283\u20D2',
    nsupseteq: '\u2289',
    nsupseteqq: '\u2AC6\u0338',
    ntgl: '\u2279',
    Ntilde: '\u00D1',
    ntilde: '\u00F1',
    ntlg: '\u2278',
    ntriangleleft: '\u22EA',
    ntrianglelefteq: '\u22EC',
    ntriangleright: '\u22EB',
    ntrianglerighteq: '\u22ED',
    Nu: '\u039D',
    nu: '\u03BD',
    num: '\u0023',
    numero: '\u2116',
    numsp: '\u2007',
    nvap: '\u224D\u20D2',
    nVDash: '\u22AF',
    nVdash: '\u22AE',
    nvDash: '\u22AD',
    nvdash: '\u22AC',
    nvge: '\u2265\u20D2',
    nvgt: '\u003E\u20D2',
    nvHarr: '\u2904',
    nvinfin: '\u29DE',
    nvlArr: '\u2902',
    nvle: '\u2264\u20D2',
    nvlt: '\u003C\u20D2',
    nvltrie: '\u22B4\u20D2',
    nvrArr: '\u2903',
    nvrtrie: '\u22B5\u20D2',
    nvsim: '\u223C\u20D2',
    nwarhk: '\u2923',
    nwArr: '\u21D6',
    nwarr: '\u2196',
    nwarrow: '\u2196',
    nwnear: '\u2927',
    Oacute: '\u00D3',
    oacute: '\u00F3',
    oast: '\u229B',
    ocir: '\u229A',
    Ocirc: '\u00D4',
    ocirc: '\u00F4',
    Ocy: '\u041E',
    ocy: '\u043E',
    odash: '\u229D',
    Odblac: '\u0150',
    odblac: '\u0151',
    odiv: '\u2A38',
    odot: '\u2299',
    odsold: '\u29BC',
    OElig: '\u0152',
    oelig: '\u0153',
    ofcir: '\u29BF',
    Ofr: '\uD835\uDD12',
    ofr: '\uD835\uDD2C',
    ogon: '\u02DB',
    Ograve: '\u00D2',
    ograve: '\u00F2',
    ogt: '\u29C1',
    ohbar: '\u29B5',
    ohm: '\u03A9',
    oint: '\u222E',
    olarr: '\u21BA',
    olcir: '\u29BE',
    olcross: '\u29BB',
    oline: '\u203E',
    olt: '\u29C0',
    Omacr: '\u014C',
    omacr: '\u014D',
    Omega: '\u03A9',
    omega: '\u03C9',
    Omicron: '\u039F',
    omicron: '\u03BF',
    omid: '\u29B6',
    ominus: '\u2296',
    Oopf: '\uD835\uDD46',
    oopf: '\uD835\uDD60',
    opar: '\u29B7',
    OpenCurlyDoubleQuote: '\u201C',
    OpenCurlyQuote: '\u2018',
    operp: '\u29B9',
    oplus: '\u2295',
    Or: '\u2A54',
    or: '\u2228',
    orarr: '\u21BB',
    ord: '\u2A5D',
    order: '\u2134',
    orderof: '\u2134',
    ordf: '\u00AA',
    ordm: '\u00BA',
    origof: '\u22B6',
    oror: '\u2A56',
    orslope: '\u2A57',
    orv: '\u2A5B',
    oS: '\u24C8',
    Oscr: '\uD835\uDCAA',
    oscr: '\u2134',
    Oslash: '\u00D8',
    oslash: '\u00F8',
    osol: '\u2298',
    Otilde: '\u00D5',
    otilde: '\u00F5',
    Otimes: '\u2A37',
    otimes: '\u2297',
    otimesas: '\u2A36',
    Ouml: '\u00D6',
    ouml: '\u00F6',
    ovbar: '\u233D',
    OverBar: '\u203E',
    OverBrace: '\u23DE',
    OverBracket: '\u23B4',
    OverParenthesis: '\u23DC',
    par: '\u2225',
    para: '\u00B6',
    parallel: '\u2225',
    parsim: '\u2AF3',
    parsl: '\u2AFD',
    part: '\u2202',
    PartialD: '\u2202',
    Pcy: '\u041F',
    pcy: '\u043F',
    percnt: '\u0025',
    period: '\u002E',
    permil: '\u2030',
    perp: '\u22A5',
    pertenk: '\u2031',
    Pfr: '\uD835\uDD13',
    pfr: '\uD835\uDD2D',
    Phi: '\u03A6',
    phi: '\u03C6',
    phiv: '\u03D5',
    phmmat: '\u2133',
    phone: '\u260E',
    Pi: '\u03A0',
    pi: '\u03C0',
    pitchfork: '\u22D4',
    piv: '\u03D6',
    planck: '\u210F',
    planckh: '\u210E',
    plankv: '\u210F',
    plus: '\u002B',
    plusacir: '\u2A23',
    plusb: '\u229E',
    pluscir: '\u2A22',
    plusdo: '\u2214',
    plusdu: '\u2A25',
    pluse: '\u2A72',
    PlusMinus: '\u00B1',
    plusmn: '\u00B1',
    plussim: '\u2A26',
    plustwo: '\u2A27',
    pm: '\u00B1',
    Poincareplane: '\u210C',
    pointint: '\u2A15',
    Popf: '\u2119',
    popf: '\uD835\uDD61',
    pound: '\u00A3',
    Pr: '\u2ABB',
    pr: '\u227A',
    prap: '\u2AB7',
    prcue: '\u227C',
    prE: '\u2AB3',
    pre: '\u2AAF',
    prec: '\u227A',
    precapprox: '\u2AB7',
    preccurlyeq: '\u227C',
    Precedes: '\u227A',
    PrecedesEqual: '\u2AAF',
    PrecedesSlantEqual: '\u227C',
    PrecedesTilde: '\u227E',
    preceq: '\u2AAF',
    precnapprox: '\u2AB9',
    precneqq: '\u2AB5',
    precnsim: '\u22E8',
    precsim: '\u227E',
    Prime: '\u2033',
    prime: '\u2032',
    primes: '\u2119',
    prnap: '\u2AB9',
    prnE: '\u2AB5',
    prnsim: '\u22E8',
    prod: '\u220F',
    Product: '\u220F',
    profalar: '\u232E',
    profline: '\u2312',
    profsurf: '\u2313',
    prop: '\u221D',
    Proportion: '\u2237',
    Proportional: '\u221D',
    propto: '\u221D',
    prsim: '\u227E',
    prurel: '\u22B0',
    Pscr: '\uD835\uDCAB',
    pscr: '\uD835\uDCC5',
    Psi: '\u03A8',
    psi: '\u03C8',
    puncsp: '\u2008',
    Qfr: '\uD835\uDD14',
    qfr: '\uD835\uDD2E',
    qint: '\u2A0C',
    Qopf: '\u211A',
    qopf: '\uD835\uDD62',
    qprime: '\u2057',
    Qscr: '\uD835\uDCAC',
    qscr: '\uD835\uDCC6',
    quaternions: '\u210D',
    quatint: '\u2A16',
    quest: '\u003F',
    questeq: '\u225F',
    QUOT: '\u0022',
    quot: '\u0022',
    rAarr: '\u21DB',
    race: '\u223D\u0331',
    Racute: '\u0154',
    racute: '\u0155',
    radic: '\u221A',
    raemptyv: '\u29B3',
    Rang: '\u27EB',
    rang: '\u27E9',
    rangd: '\u2992',
    range: '\u29A5',
    rangle: '\u27E9',
    raquo: '\u00BB',
    Rarr: '\u21A0',
    rArr: '\u21D2',
    rarr: '\u2192',
    rarrap: '\u2975',
    rarrb: '\u21E5',
    rarrbfs: '\u2920',
    rarrc: '\u2933',
    rarrfs: '\u291E',
    rarrhk: '\u21AA',
    rarrlp: '\u21AC',
    rarrpl: '\u2945',
    rarrsim: '\u2974',
    Rarrtl: '\u2916',
    rarrtl: '\u21A3',
    rarrw: '\u219D',
    rAtail: '\u291C',
    ratail: '\u291A',
    ratio: '\u2236',
    rationals: '\u211A',
    RBarr: '\u2910',
    rBarr: '\u290F',
    rbarr: '\u290D',
    rbbrk: '\u2773',
    rbrace: '\u007D',
    rbrack: '\u005D',
    rbrke: '\u298C',
    rbrksld: '\u298E',
    rbrkslu: '\u2990',
    Rcaron: '\u0158',
    rcaron: '\u0159',
    Rcedil: '\u0156',
    rcedil: '\u0157',
    rceil: '\u2309',
    rcub: '\u007D',
    Rcy: '\u0420',
    rcy: '\u0440',
    rdca: '\u2937',
    rdldhar: '\u2969',
    rdquo: '\u201D',
    rdquor: '\u201D',
    rdsh: '\u21B3',
    Re: '\u211C',
    real: '\u211C',
    realine: '\u211B',
    realpart: '\u211C',
    reals: '\u211D',
    rect: '\u25AD',
    REG: '\u00AE',
    reg: '\u00AE',
    ReverseElement: '\u220B',
    ReverseEquilibrium: '\u21CB',
    ReverseUpEquilibrium: '\u296F',
    rfisht: '\u297D',
    rfloor: '\u230B',
    Rfr: '\u211C',
    rfr: '\uD835\uDD2F',
    rHar: '\u2964',
    rhard: '\u21C1',
    rharu: '\u21C0',
    rharul: '\u296C',
    Rho: '\u03A1',
    rho: '\u03C1',
    rhov: '\u03F1',
    RightAngleBracket: '\u27E9',
    RightArrow: '\u2192',
    Rightarrow: '\u21D2',
    rightarrow: '\u2192',
    RightArrowBar: '\u21E5',
    RightArrowLeftArrow: '\u21C4',
    rightarrowtail: '\u21A3',
    RightCeiling: '\u2309',
    RightDoubleBracket: '\u27E7',
    RightDownTeeVector: '\u295D',
    RightDownVector: '\u21C2',
    RightDownVectorBar: '\u2955',
    RightFloor: '\u230B',
    rightharpoondown: '\u21C1',
    rightharpoonup: '\u21C0',
    rightleftarrows: '\u21C4',
    rightleftharpoons: '\u21CC',
    rightrightarrows: '\u21C9',
    rightsquigarrow: '\u219D',
    RightTee: '\u22A2',
    RightTeeArrow: '\u21A6',
    RightTeeVector: '\u295B',
    rightthreetimes: '\u22CC',
    RightTriangle: '\u22B3',
    RightTriangleBar: '\u29D0',
    RightTriangleEqual: '\u22B5',
    RightUpDownVector: '\u294F',
    RightUpTeeVector: '\u295C',
    RightUpVector: '\u21BE',
    RightUpVectorBar: '\u2954',
    RightVector: '\u21C0',
    RightVectorBar: '\u2953',
    ring: '\u02DA',
    risingdotseq: '\u2253',
    rlarr: '\u21C4',
    rlhar: '\u21CC',
    rlm: '\u200F',
    rmoust: '\u23B1',
    rmoustache: '\u23B1',
    rnmid: '\u2AEE',
    roang: '\u27ED',
    roarr: '\u21FE',
    robrk: '\u27E7',
    ropar: '\u2986',
    Ropf: '\u211D',
    ropf: '\uD835\uDD63',
    roplus: '\u2A2E',
    rotimes: '\u2A35',
    RoundImplies: '\u2970',
    rpar: '\u0029',
    rpargt: '\u2994',
    rppolint: '\u2A12',
    rrarr: '\u21C9',
    Rrightarrow: '\u21DB',
    rsaquo: '\u203A',
    Rscr: '\u211B',
    rscr: '\uD835\uDCC7',
    Rsh: '\u21B1',
    rsh: '\u21B1',
    rsqb: '\u005D',
    rsquo: '\u2019',
    rsquor: '\u2019',
    rthree: '\u22CC',
    rtimes: '\u22CA',
    rtri: '\u25B9',
    rtrie: '\u22B5',
    rtrif: '\u25B8',
    rtriltri: '\u29CE',
    RuleDelayed: '\u29F4',
    ruluhar: '\u2968',
    rx: '\u211E',
    Sacute: '\u015A',
    sacute: '\u015B',
    sbquo: '\u201A',
    Sc: '\u2ABC',
    sc: '\u227B',
    scap: '\u2AB8',
    Scaron: '\u0160',
    scaron: '\u0161',
    sccue: '\u227D',
    scE: '\u2AB4',
    sce: '\u2AB0',
    Scedil: '\u015E',
    scedil: '\u015F',
    Scirc: '\u015C',
    scirc: '\u015D',
    scnap: '\u2ABA',
    scnE: '\u2AB6',
    scnsim: '\u22E9',
    scpolint: '\u2A13',
    scsim: '\u227F',
    Scy: '\u0421',
    scy: '\u0441',
    sdot: '\u22C5',
    sdotb: '\u22A1',
    sdote: '\u2A66',
    searhk: '\u2925',
    seArr: '\u21D8',
    searr: '\u2198',
    searrow: '\u2198',
    sect: '\u00A7',
    semi: '\u003B',
    seswar: '\u2929',
    setminus: '\u2216',
    setmn: '\u2216',
    sext: '\u2736',
    Sfr: '\uD835\uDD16',
    sfr: '\uD835\uDD30',
    sfrown: '\u2322',
    sharp: '\u266F',
    SHCHcy: '\u0429',
    shchcy: '\u0449',
    SHcy: '\u0428',
    shcy: '\u0448',
    ShortDownArrow: '\u2193',
    ShortLeftArrow: '\u2190',
    shortmid: '\u2223',
    shortparallel: '\u2225',
    ShortRightArrow: '\u2192',
    ShortUpArrow: '\u2191',
    shy: '\u00AD',
    Sigma: '\u03A3',
    sigma: '\u03C3',
    sigmaf: '\u03C2',
    sigmav: '\u03C2',
    sim: '\u223C',
    simdot: '\u2A6A',
    sime: '\u2243',
    simeq: '\u2243',
    simg: '\u2A9E',
    simgE: '\u2AA0',
    siml: '\u2A9D',
    simlE: '\u2A9F',
    simne: '\u2246',
    simplus: '\u2A24',
    simrarr: '\u2972',
    slarr: '\u2190',
    SmallCircle: '\u2218',
    smallsetminus: '\u2216',
    smashp: '\u2A33',
    smeparsl: '\u29E4',
    smid: '\u2223',
    smile: '\u2323',
    smt: '\u2AAA',
    smte: '\u2AAC',
    smtes: '\u2AAC\uFE00',
    SOFTcy: '\u042C',
    softcy: '\u044C',
    sol: '\u002F',
    solb: '\u29C4',
    solbar: '\u233F',
    Sopf: '\uD835\uDD4A',
    sopf: '\uD835\uDD64',
    spades: '\u2660',
    spadesuit: '\u2660',
    spar: '\u2225',
    sqcap: '\u2293',
    sqcaps: '\u2293\uFE00',
    sqcup: '\u2294',
    sqcups: '\u2294\uFE00',
    Sqrt: '\u221A',
    sqsub: '\u228F',
    sqsube: '\u2291',
    sqsubset: '\u228F',
    sqsubseteq: '\u2291',
    sqsup: '\u2290',
    sqsupe: '\u2292',
    sqsupset: '\u2290',
    sqsupseteq: '\u2292',
    squ: '\u25A1',
    Square: '\u25A1',
    square: '\u25A1',
    SquareIntersection: '\u2293',
    SquareSubset: '\u228F',
    SquareSubsetEqual: '\u2291',
    SquareSuperset: '\u2290',
    SquareSupersetEqual: '\u2292',
    SquareUnion: '\u2294',
    squarf: '\u25AA',
    squf: '\u25AA',
    srarr: '\u2192',
    Sscr: '\uD835\uDCAE',
    sscr: '\uD835\uDCC8',
    ssetmn: '\u2216',
    ssmile: '\u2323',
    sstarf: '\u22C6',
    Star: '\u22C6',
    star: '\u2606',
    starf: '\u2605',
    straightepsilon: '\u03F5',
    straightphi: '\u03D5',
    strns: '\u00AF',
    Sub: '\u22D0',
    sub: '\u2282',
    subdot: '\u2ABD',
    subE: '\u2AC5',
    sube: '\u2286',
    subedot: '\u2AC3',
    submult: '\u2AC1',
    subnE: '\u2ACB',
    subne: '\u228A',
    subplus: '\u2ABF',
    subrarr: '\u2979',
    Subset: '\u22D0',
    subset: '\u2282',
    subseteq: '\u2286',
    subseteqq: '\u2AC5',
    SubsetEqual: '\u2286',
    subsetneq: '\u228A',
    subsetneqq: '\u2ACB',
    subsim: '\u2AC7',
    subsub: '\u2AD5',
    subsup: '\u2AD3',
    succ: '\u227B',
    succapprox: '\u2AB8',
    succcurlyeq: '\u227D',
    Succeeds: '\u227B',
    SucceedsEqual: '\u2AB0',
    SucceedsSlantEqual: '\u227D',
    SucceedsTilde: '\u227F',
    succeq: '\u2AB0',
    succnapprox: '\u2ABA',
    succneqq: '\u2AB6',
    succnsim: '\u22E9',
    succsim: '\u227F',
    SuchThat: '\u220B',
    Sum: '\u2211',
    sum: '\u2211',
    sung: '\u266A',
    Sup: '\u22D1',
    sup: '\u2283',
    sup1: '\u00B9',
    sup2: '\u00B2',
    sup3: '\u00B3',
    supdot: '\u2ABE',
    supdsub: '\u2AD8',
    supE: '\u2AC6',
    supe: '\u2287',
    supedot: '\u2AC4',
    Superset: '\u2283',
    SupersetEqual: '\u2287',
    suphsol: '\u27C9',
    suphsub: '\u2AD7',
    suplarr: '\u297B',
    supmult: '\u2AC2',
    supnE: '\u2ACC',
    supne: '\u228B',
    supplus: '\u2AC0',
    Supset: '\u22D1',
    supset: '\u2283',
    supseteq: '\u2287',
    supseteqq: '\u2AC6',
    supsetneq: '\u228B',
    supsetneqq: '\u2ACC',
    supsim: '\u2AC8',
    supsub: '\u2AD4',
    supsup: '\u2AD6',
    swarhk: '\u2926',
    swArr: '\u21D9',
    swarr: '\u2199',
    swarrow: '\u2199',
    swnwar: '\u292A',
    szlig: '\u00DF',
    Tab: '\u0009',
    target: '\u2316',
    Tau: '\u03A4',
    tau: '\u03C4',
    tbrk: '\u23B4',
    Tcaron: '\u0164',
    tcaron: '\u0165',
    Tcedil: '\u0162',
    tcedil: '\u0163',
    Tcy: '\u0422',
    tcy: '\u0442',
    tdot: '\u20DB',
    telrec: '\u2315',
    Tfr: '\uD835\uDD17',
    tfr: '\uD835\uDD31',
    there4: '\u2234',
    Therefore: '\u2234',
    therefore: '\u2234',
    Theta: '\u0398',
    theta: '\u03B8',
    thetasym: '\u03D1',
    thetav: '\u03D1',
    thickapprox: '\u2248',
    thicksim: '\u223C',
    ThickSpace: '\u205F\u200A',
    thinsp: '\u2009',
    ThinSpace: '\u2009',
    thkap: '\u2248',
    thksim: '\u223C',
    THORN: '\u00DE',
    thorn: '\u00FE',
    Tilde: '\u223C',
    tilde: '\u02DC',
    TildeEqual: '\u2243',
    TildeFullEqual: '\u2245',
    TildeTilde: '\u2248',
    times: '\u00D7',
    timesb: '\u22A0',
    timesbar: '\u2A31',
    timesd: '\u2A30',
    tint: '\u222D',
    toea: '\u2928',
    top: '\u22A4',
    topbot: '\u2336',
    topcir: '\u2AF1',
    Topf: '\uD835\uDD4B',
    topf: '\uD835\uDD65',
    topfork: '\u2ADA',
    tosa: '\u2929',
    tprime: '\u2034',
    TRADE: '\u2122',
    trade: '\u2122',
    triangle: '\u25B5',
    triangledown: '\u25BF',
    triangleleft: '\u25C3',
    trianglelefteq: '\u22B4',
    triangleq: '\u225C',
    triangleright: '\u25B9',
    trianglerighteq: '\u22B5',
    tridot: '\u25EC',
    trie: '\u225C',
    triminus: '\u2A3A',
    TripleDot: '\u20DB',
    triplus: '\u2A39',
    trisb: '\u29CD',
    tritime: '\u2A3B',
    trpezium: '\u23E2',
    Tscr: '\uD835\uDCAF',
    tscr: '\uD835\uDCC9',
    TScy: '\u0426',
    tscy: '\u0446',
    TSHcy: '\u040B',
    tshcy: '\u045B',
    Tstrok: '\u0166',
    tstrok: '\u0167',
    twixt: '\u226C',
    twoheadleftarrow: '\u219E',
    twoheadrightarrow: '\u21A0',
    Uacute: '\u00DA',
    uacute: '\u00FA',
    Uarr: '\u219F',
    uArr: '\u21D1',
    uarr: '\u2191',
    Uarrocir: '\u2949',
    Ubrcy: '\u040E',
    ubrcy: '\u045E',
    Ubreve: '\u016C',
    ubreve: '\u016D',
    Ucirc: '\u00DB',
    ucirc: '\u00FB',
    Ucy: '\u0423',
    ucy: '\u0443',
    udarr: '\u21C5',
    Udblac: '\u0170',
    udblac: '\u0171',
    udhar: '\u296E',
    ufisht: '\u297E',
    Ufr: '\uD835\uDD18',
    ufr: '\uD835\uDD32',
    Ugrave: '\u00D9',
    ugrave: '\u00F9',
    uHar: '\u2963',
    uharl: '\u21BF',
    uharr: '\u21BE',
    uhblk: '\u2580',
    ulcorn: '\u231C',
    ulcorner: '\u231C',
    ulcrop: '\u230F',
    ultri: '\u25F8',
    Umacr: '\u016A',
    umacr: '\u016B',
    uml: '\u00A8',
    UnderBar: '\u005F',
    UnderBrace: '\u23DF',
    UnderBracket: '\u23B5',
    UnderParenthesis: '\u23DD',
    Union: '\u22C3',
    UnionPlus: '\u228E',
    Uogon: '\u0172',
    uogon: '\u0173',
    Uopf: '\uD835\uDD4C',
    uopf: '\uD835\uDD66',
    UpArrow: '\u2191',
    Uparrow: '\u21D1',
    uparrow: '\u2191',
    UpArrowBar: '\u2912',
    UpArrowDownArrow: '\u21C5',
    UpDownArrow: '\u2195',
    Updownarrow: '\u21D5',
    updownarrow: '\u2195',
    UpEquilibrium: '\u296E',
    upharpoonleft: '\u21BF',
    upharpoonright: '\u21BE',
    uplus: '\u228E',
    UpperLeftArrow: '\u2196',
    UpperRightArrow: '\u2197',
    Upsi: '\u03D2',
    upsi: '\u03C5',
    upsih: '\u03D2',
    Upsilon: '\u03A5',
    upsilon: '\u03C5',
    UpTee: '\u22A5',
    UpTeeArrow: '\u21A5',
    upuparrows: '\u21C8',
    urcorn: '\u231D',
    urcorner: '\u231D',
    urcrop: '\u230E',
    Uring: '\u016E',
    uring: '\u016F',
    urtri: '\u25F9',
    Uscr: '\uD835\uDCB0',
    uscr: '\uD835\uDCCA',
    utdot: '\u22F0',
    Utilde: '\u0168',
    utilde: '\u0169',
    utri: '\u25B5',
    utrif: '\u25B4',
    uuarr: '\u21C8',
    Uuml: '\u00DC',
    uuml: '\u00FC',
    uwangle: '\u29A7',
    vangrt: '\u299C',
    varepsilon: '\u03F5',
    varkappa: '\u03F0',
    varnothing: '\u2205',
    varphi: '\u03D5',
    varpi: '\u03D6',
    varpropto: '\u221D',
    vArr: '\u21D5',
    varr: '\u2195',
    varrho: '\u03F1',
    varsigma: '\u03C2',
    varsubsetneq: '\u228A\uFE00',
    varsubsetneqq: '\u2ACB\uFE00',
    varsupsetneq: '\u228B\uFE00',
    varsupsetneqq: '\u2ACC\uFE00',
    vartheta: '\u03D1',
    vartriangleleft: '\u22B2',
    vartriangleright: '\u22B3',
    Vbar: '\u2AEB',
    vBar: '\u2AE8',
    vBarv: '\u2AE9',
    Vcy: '\u0412',
    vcy: '\u0432',
    VDash: '\u22AB',
    Vdash: '\u22A9',
    vDash: '\u22A8',
    vdash: '\u22A2',
    Vdashl: '\u2AE6',
    Vee: '\u22C1',
    vee: '\u2228',
    veebar: '\u22BB',
    veeeq: '\u225A',
    vellip: '\u22EE',
    Verbar: '\u2016',
    verbar: '\u007C',
    Vert: '\u2016',
    vert: '\u007C',
    VerticalBar: '\u2223',
    VerticalLine: '\u007C',
    VerticalSeparator: '\u2758',
    VerticalTilde: '\u2240',
    VeryThinSpace: '\u200A',
    Vfr: '\uD835\uDD19',
    vfr: '\uD835\uDD33',
    vltri: '\u22B2',
    vnsub: '\u2282\u20D2',
    vnsup: '\u2283\u20D2',
    Vopf: '\uD835\uDD4D',
    vopf: '\uD835\uDD67',
    vprop: '\u221D',
    vrtri: '\u22B3',
    Vscr: '\uD835\uDCB1',
    vscr: '\uD835\uDCCB',
    vsubnE: '\u2ACB\uFE00',
    vsubne: '\u228A\uFE00',
    vsupnE: '\u2ACC\uFE00',
    vsupne: '\u228B\uFE00',
    Vvdash: '\u22AA',
    vzigzag: '\u299A',
    Wcirc: '\u0174',
    wcirc: '\u0175',
    wedbar: '\u2A5F',
    Wedge: '\u22C0',
    wedge: '\u2227',
    wedgeq: '\u2259',
    weierp: '\u2118',
    Wfr: '\uD835\uDD1A',
    wfr: '\uD835\uDD34',
    Wopf: '\uD835\uDD4E',
    wopf: '\uD835\uDD68',
    wp: '\u2118',
    wr: '\u2240',
    wreath: '\u2240',
    Wscr: '\uD835\uDCB2',
    wscr: '\uD835\uDCCC',
    xcap: '\u22C2',
    xcirc: '\u25EF',
    xcup: '\u22C3',
    xdtri: '\u25BD',
    Xfr: '\uD835\uDD1B',
    xfr: '\uD835\uDD35',
    xhArr: '\u27FA',
    xharr: '\u27F7',
    Xi: '\u039E',
    xi: '\u03BE',
    xlArr: '\u27F8',
    xlarr: '\u27F5',
    xmap: '\u27FC',
    xnis: '\u22FB',
    xodot: '\u2A00',
    Xopf: '\uD835\uDD4F',
    xopf: '\uD835\uDD69',
    xoplus: '\u2A01',
    xotime: '\u2A02',
    xrArr: '\u27F9',
    xrarr: '\u27F6',
    Xscr: '\uD835\uDCB3',
    xscr: '\uD835\uDCCD',
    xsqcup: '\u2A06',
    xuplus: '\u2A04',
    xutri: '\u25B3',
    xvee: '\u22C1',
    xwedge: '\u22C0',
    Yacute: '\u00DD',
    yacute: '\u00FD',
    YAcy: '\u042F',
    yacy: '\u044F',
    Ycirc: '\u0176',
    ycirc: '\u0177',
    Ycy: '\u042B',
    ycy: '\u044B',
    yen: '\u00A5',
    Yfr: '\uD835\uDD1C',
    yfr: '\uD835\uDD36',
    YIcy: '\u0407',
    yicy: '\u0457',
    Yopf: '\uD835\uDD50',
    yopf: '\uD835\uDD6A',
    Yscr: '\uD835\uDCB4',
    yscr: '\uD835\uDCCE',
    YUcy: '\u042E',
    yucy: '\u044E',
    Yuml: '\u0178',
    yuml: '\u00FF',
    Zacute: '\u0179',
    zacute: '\u017A',
    Zcaron: '\u017D',
    zcaron: '\u017E',
    Zcy: '\u0417',
    zcy: '\u0437',
    Zdot: '\u017B',
    zdot: '\u017C',
    zeetrf: '\u2128',
    ZeroWidthSpace: '\u200B',
    Zeta: '\u0396',
    zeta: '\u03B6',
    Zfr: '\u2128',
    zfr: '\uD835\uDD37',
    ZHcy: '\u0416',
    zhcy: '\u0436',
    zigrarr: '\u21DD',
    Zopf: '\u2124',
    zopf: '\uD835\uDD6B',
    Zscr: '\uD835\uDCB5',
    zscr: '\uD835\uDCCF',
    zwj: '\u200D',
    zwnj: '\u200C'
});
$28eabcfdb4821410$export$79451380caed3f98 = $28eabcfdb4821410$export$b7e4d4631df36afa;

});

parcelRegister("lejlD", function(module, exports) {

$parcel$export(module.exports, "XMLReader", function () { return $f749e9e42fd6b8a6$export$ccbc9f9f018333e9; }, function (v) { return $f749e9e42fd6b8a6$export$ccbc9f9f018333e9 = v; });
$parcel$export(module.exports, "ParseError", function () { return $f749e9e42fd6b8a6$export$f9c837a54db411d; }, function (v) { return $f749e9e42fd6b8a6$export$f9c837a54db411d = v; });
var $f749e9e42fd6b8a6$export$ccbc9f9f018333e9;
var $f749e9e42fd6b8a6$export$f9c837a54db411d;

var $aeRet = parcelRequire("aeRet");
var $f749e9e42fd6b8a6$require$NAMESPACE = $aeRet.NAMESPACE;
//[4]   	NameStartChar	   ::=   	":" | [A-Z] | "_" | [a-z] | [#xC0-#xD6] | [#xD8-#xF6] | [#xF8-#x2FF] | [#x370-#x37D] | [#x37F-#x1FFF] | [#x200C-#x200D] | [#x2070-#x218F] | [#x2C00-#x2FEF] | [#x3001-#xD7FF] | [#xF900-#xFDCF] | [#xFDF0-#xFFFD] | [#x10000-#xEFFFF]
//[4a]   	NameChar	   ::=   	NameStartChar | "-" | "." | [0-9] | #xB7 | [#x0300-#x036F] | [#x203F-#x2040]
//[5]   	Name	   ::=   	NameStartChar (NameChar)*
var $f749e9e42fd6b8a6$var$nameStartChar = /[A-Z_a-z\xC0-\xD6\xD8-\xF6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD]/ //\u10000-\uEFFFF
;
var $f749e9e42fd6b8a6$var$nameChar = new RegExp("[\\-\\.0-9" + $f749e9e42fd6b8a6$var$nameStartChar.source.slice(1, -1) + "\\u00B7\\u0300-\\u036F\\u203F-\\u2040]");
var $f749e9e42fd6b8a6$var$tagNamePattern = new RegExp('^' + $f749e9e42fd6b8a6$var$nameStartChar.source + $f749e9e42fd6b8a6$var$nameChar.source + '*(?:\:' + $f749e9e42fd6b8a6$var$nameStartChar.source + $f749e9e42fd6b8a6$var$nameChar.source + '*)?$');
//var tagNamePattern = /^[a-zA-Z_][\w\-\.]*(?:\:[a-zA-Z_][\w\-\.]*)?$/
//var handlers = 'resolveEntity,getExternalSubset,characters,endDocument,endElement,endPrefixMapping,ignorableWhitespace,processingInstruction,setDocumentLocator,skippedEntity,startDocument,startElement,startPrefixMapping,notationDecl,unparsedEntityDecl,error,fatalError,warning,attributeDecl,elementDecl,externalEntityDecl,internalEntityDecl,comment,endCDATA,endDTD,endEntity,startCDATA,startDTD,startEntity'.split(',')
//S_TAG,	S_ATTR,	S_EQ,	S_ATTR_NOQUOT_VALUE
//S_ATTR_SPACE,	S_ATTR_END,	S_TAG_SPACE, S_TAG_CLOSE
var $f749e9e42fd6b8a6$var$S_TAG = 0; //tag name offerring
var $f749e9e42fd6b8a6$var$S_ATTR = 1; //attr name offerring
var $f749e9e42fd6b8a6$var$S_ATTR_SPACE = 2; //attr name end and space offer
var $f749e9e42fd6b8a6$var$S_EQ = 3; //=space?
var $f749e9e42fd6b8a6$var$S_ATTR_NOQUOT_VALUE = 4; //attr value(no quot value only)
var $f749e9e42fd6b8a6$var$S_ATTR_END = 5; //attr value end and no space(quot end)
var $f749e9e42fd6b8a6$var$S_TAG_SPACE = 6; //(attr value end || tag end ) && (space offer)
var $f749e9e42fd6b8a6$var$S_TAG_CLOSE = 7; //closed el<el />
/**
 * Creates an error that will not be caught by XMLReader aka the SAX parser.
 *
 * @param {string} message
 * @param {any?} locator Optional, can provide details about the location in the source
 * @constructor
 */ function $f749e9e42fd6b8a6$var$ParseError(message, locator) {
    this.message = message;
    this.locator = locator;
    if (Error.captureStackTrace) Error.captureStackTrace(this, $f749e9e42fd6b8a6$var$ParseError);
}
$f749e9e42fd6b8a6$var$ParseError.prototype = new Error();
$f749e9e42fd6b8a6$var$ParseError.prototype.name = $f749e9e42fd6b8a6$var$ParseError.name;
function $f749e9e42fd6b8a6$var$XMLReader() {}
$f749e9e42fd6b8a6$var$XMLReader.prototype = {
    parse: function(source, defaultNSMap, entityMap) {
        var domBuilder = this.domBuilder;
        domBuilder.startDocument();
        $f749e9e42fd6b8a6$var$_copy(defaultNSMap, defaultNSMap = {});
        $f749e9e42fd6b8a6$var$parse(source, defaultNSMap, entityMap, domBuilder, this.errorHandler);
        domBuilder.endDocument();
    }
};
function $f749e9e42fd6b8a6$var$parse(source, defaultNSMapCopy, entityMap, domBuilder, errorHandler) {
    function fixedFromCharCode(code) {
        // String.prototype.fromCharCode does not supports
        // > 2 bytes unicode chars directly
        if (code > 0xffff) {
            code -= 0x10000;
            var surrogate1 = 0xd800 + (code >> 10), surrogate2 = 0xdc00 + (code & 0x3ff);
            return String.fromCharCode(surrogate1, surrogate2);
        } else return String.fromCharCode(code);
    }
    function entityReplacer(a) {
        var k = a.slice(1, -1);
        if (Object.hasOwnProperty.call(entityMap, k)) return entityMap[k];
        else if (k.charAt(0) === '#') return fixedFromCharCode(parseInt(k.substr(1).replace('x', '0x')));
        else {
            errorHandler.error('entity not found:' + a);
            return a;
        }
    }
    function appendText(end) {
        if (end > start) {
            var xt = source.substring(start, end).replace(/&#?\w+;/g, entityReplacer);
            locator && position(start);
            domBuilder.characters(xt, 0, end - start);
            start = end;
        }
    }
    function position(p, m) {
        while(p >= lineEnd && (m = linePattern.exec(source))){
            lineStart = m.index;
            lineEnd = lineStart + m[0].length;
            locator.lineNumber++;
        //console.log('line++:',locator,startPos,endPos)
        }
        locator.columnNumber = p - lineStart + 1;
    }
    var lineStart = 0;
    var lineEnd = 0;
    var linePattern = /.*(?:\r\n?|\n)|.*$/g;
    var locator = domBuilder.locator;
    var parseStack = [
        {
            currentNSMap: defaultNSMapCopy
        }
    ];
    var closeMap = {};
    var start = 0;
    while(true){
        try {
            var tagStart = source.indexOf('<', start);
            if (tagStart < 0) {
                if (!source.substr(start).match(/^\s*$/)) {
                    var doc = domBuilder.doc;
                    var text = doc.createTextNode(source.substr(start));
                    doc.appendChild(text);
                    domBuilder.currentElement = text;
                }
                return;
            }
            if (tagStart > start) appendText(tagStart);
            switch(source.charAt(tagStart + 1)){
                case '/':
                    var end = source.indexOf('>', tagStart + 3);
                    var tagName = source.substring(tagStart + 2, end).replace(/[ \t\n\r]+$/g, '');
                    var config = parseStack.pop();
                    if (end < 0) {
                        tagName = source.substring(tagStart + 2).replace(/[\s<].*/, '');
                        errorHandler.error("end tag name: " + tagName + ' is not complete:' + config.tagName);
                        end = tagStart + 1 + tagName.length;
                    } else if (tagName.match(/\s</)) {
                        tagName = tagName.replace(/[\s<].*/, '');
                        errorHandler.error("end tag name: " + tagName + ' maybe not complete');
                        end = tagStart + 1 + tagName.length;
                    }
                    var localNSMap = config.localNSMap;
                    var endMatch = config.tagName == tagName;
                    var endIgnoreCaseMach = endMatch || config.tagName && config.tagName.toLowerCase() == tagName.toLowerCase();
                    if (endIgnoreCaseMach) {
                        domBuilder.endElement(config.uri, config.localName, tagName);
                        if (localNSMap) {
                            for(var prefix in localNSMap)if (Object.prototype.hasOwnProperty.call(localNSMap, prefix)) domBuilder.endPrefixMapping(prefix);
                        }
                        if (!endMatch) errorHandler.fatalError("end tag name: " + tagName + ' is not match the current start tagName:' + config.tagName); // No known test case
                    } else parseStack.push(config);
                    end++;
                    break;
                // end elment
                case '?':
                    locator && position(tagStart);
                    end = $f749e9e42fd6b8a6$var$parseInstruction(source, tagStart, domBuilder);
                    break;
                case '!':
                    locator && position(tagStart);
                    end = $f749e9e42fd6b8a6$var$parseDCC(source, tagStart, domBuilder, errorHandler);
                    break;
                default:
                    locator && position(tagStart);
                    var el = new $f749e9e42fd6b8a6$var$ElementAttributes();
                    var currentNSMap = parseStack[parseStack.length - 1].currentNSMap;
                    //elStartEnd
                    var end = $f749e9e42fd6b8a6$var$parseElementStartPart(source, tagStart, el, currentNSMap, entityReplacer, errorHandler);
                    var len = el.length;
                    if (!el.closed && $f749e9e42fd6b8a6$var$fixSelfClosed(source, end, el.tagName, closeMap)) {
                        el.closed = true;
                        if (!entityMap.nbsp) errorHandler.warning('unclosed xml attribute');
                    }
                    if (locator && len) {
                        var locator2 = $f749e9e42fd6b8a6$var$copyLocator(locator, {});
                        //try{//attribute position fixed
                        for(var i = 0; i < len; i++){
                            var a = el[i];
                            position(a.offset);
                            a.locator = $f749e9e42fd6b8a6$var$copyLocator(locator, {});
                        }
                        domBuilder.locator = locator2;
                        if ($f749e9e42fd6b8a6$var$appendElement(el, domBuilder, currentNSMap)) parseStack.push(el);
                        domBuilder.locator = locator;
                    } else if ($f749e9e42fd6b8a6$var$appendElement(el, domBuilder, currentNSMap)) parseStack.push(el);
                    if ($f749e9e42fd6b8a6$require$NAMESPACE.isHTML(el.uri) && !el.closed) end = $f749e9e42fd6b8a6$var$parseHtmlSpecialContent(source, end, el.tagName, entityReplacer, domBuilder);
                    else end++;
            }
        } catch (e) {
            if (e instanceof $f749e9e42fd6b8a6$var$ParseError) throw e;
            errorHandler.error('element parse error: ' + e);
            end = -1;
        }
        if (end > start) start = end;
        else //TODO: 这里有可能sax回退，有位置错误风险
        appendText(Math.max(tagStart, start) + 1);
    }
}
function $f749e9e42fd6b8a6$var$copyLocator(f, t) {
    t.lineNumber = f.lineNumber;
    t.columnNumber = f.columnNumber;
    return t;
}
/**
 * @see #appendElement(source,elStartEnd,el,selfClosed,entityReplacer,domBuilder,parseStack);
 * @return end of the elementStartPart(end of elementEndPart for selfClosed el)
 */ function $f749e9e42fd6b8a6$var$parseElementStartPart(source, start, el, currentNSMap, entityReplacer, errorHandler) {
    /**
	 * @param {string} qname
	 * @param {string} value
	 * @param {number} startIndex
	 */ function addAttribute(qname, value, startIndex) {
        if (el.attributeNames.hasOwnProperty(qname)) errorHandler.fatalError('Attribute ' + qname + ' redefined');
        el.addValue(qname, // @see https://www.w3.org/TR/xml/#AVNormalize
        // since the xmldom sax parser does not "interpret" DTD the following is not implemented:
        // - recursive replacement of (DTD) entity references
        // - trimming and collapsing multiple spaces into a single one for attributes that are not of type CDATA
        value.replace(/[\t\n\r]/g, ' ').replace(/&#?\w+;/g, entityReplacer), startIndex);
    }
    var attrName;
    var value;
    var p = ++start;
    var s = $f749e9e42fd6b8a6$var$S_TAG; //status
    while(true){
        var c = source.charAt(p);
        switch(c){
            case '=':
                if (s === $f749e9e42fd6b8a6$var$S_ATTR) {
                    attrName = source.slice(start, p);
                    s = $f749e9e42fd6b8a6$var$S_EQ;
                } else if (s === $f749e9e42fd6b8a6$var$S_ATTR_SPACE) s = $f749e9e42fd6b8a6$var$S_EQ;
                else //fatalError: equal must after attrName or space after attrName
                throw new Error('attribute equal must after attrName'); // No known test case
                break;
            case '\'':
            case '"':
                if (s === $f749e9e42fd6b8a6$var$S_EQ || s === $f749e9e42fd6b8a6$var$S_ATTR //|| s == S_ATTR_SPACE
                ) {
                    if (s === $f749e9e42fd6b8a6$var$S_ATTR) {
                        errorHandler.warning('attribute value must after "="');
                        attrName = source.slice(start, p);
                    }
                    start = p + 1;
                    p = source.indexOf(c, start);
                    if (p > 0) {
                        value = source.slice(start, p);
                        addAttribute(attrName, value, start - 1);
                        s = $f749e9e42fd6b8a6$var$S_ATTR_END;
                    } else //fatalError: no end quot match
                    throw new Error('attribute value no end \'' + c + '\' match');
                } else if (s == $f749e9e42fd6b8a6$var$S_ATTR_NOQUOT_VALUE) {
                    value = source.slice(start, p);
                    addAttribute(attrName, value, start);
                    errorHandler.warning('attribute "' + attrName + '" missed start quot(' + c + ')!!');
                    start = p + 1;
                    s = $f749e9e42fd6b8a6$var$S_ATTR_END;
                } else //fatalError: no equal before
                throw new Error('attribute value must after "="'); // No known test case
                break;
            case '/':
                switch(s){
                    case $f749e9e42fd6b8a6$var$S_TAG:
                        el.setTagName(source.slice(start, p));
                    case $f749e9e42fd6b8a6$var$S_ATTR_END:
                    case $f749e9e42fd6b8a6$var$S_TAG_SPACE:
                    case $f749e9e42fd6b8a6$var$S_TAG_CLOSE:
                        s = $f749e9e42fd6b8a6$var$S_TAG_CLOSE;
                        el.closed = true;
                    case $f749e9e42fd6b8a6$var$S_ATTR_NOQUOT_VALUE:
                    case $f749e9e42fd6b8a6$var$S_ATTR:
                        break;
                    case $f749e9e42fd6b8a6$var$S_ATTR_SPACE:
                        el.closed = true;
                        break;
                    //case S_EQ:
                    default:
                        throw new Error("attribute invalid close char('/')") // No known test case
                        ;
                }
                break;
            case '':
                errorHandler.error('unexpected end of input');
                if (s == $f749e9e42fd6b8a6$var$S_TAG) el.setTagName(source.slice(start, p));
                return p;
            case '>':
                switch(s){
                    case $f749e9e42fd6b8a6$var$S_TAG:
                        el.setTagName(source.slice(start, p));
                    case $f749e9e42fd6b8a6$var$S_ATTR_END:
                    case $f749e9e42fd6b8a6$var$S_TAG_SPACE:
                    case $f749e9e42fd6b8a6$var$S_TAG_CLOSE:
                        break; //normal
                    case $f749e9e42fd6b8a6$var$S_ATTR_NOQUOT_VALUE:
                    case $f749e9e42fd6b8a6$var$S_ATTR:
                        value = source.slice(start, p);
                        if (value.slice(-1) === '/') {
                            el.closed = true;
                            value = value.slice(0, -1);
                        }
                    case $f749e9e42fd6b8a6$var$S_ATTR_SPACE:
                        if (s === $f749e9e42fd6b8a6$var$S_ATTR_SPACE) value = attrName;
                        if (s == $f749e9e42fd6b8a6$var$S_ATTR_NOQUOT_VALUE) {
                            errorHandler.warning('attribute "' + value + '" missed quot(")!');
                            addAttribute(attrName, value, start);
                        } else {
                            if (!$f749e9e42fd6b8a6$require$NAMESPACE.isHTML(currentNSMap['']) || !value.match(/^(?:disabled|checked|selected)$/i)) errorHandler.warning('attribute "' + value + '" missed value!! "' + value + '" instead!!');
                            addAttribute(value, value, start);
                        }
                        break;
                    case $f749e9e42fd6b8a6$var$S_EQ:
                        throw new Error('attribute value missed!!');
                }
                //			console.log(tagName,tagNamePattern,tagNamePattern.test(tagName))
                return p;
            /*xml space '\x20' | #x9 | #xD | #xA; */ case '\u0080':
                c = ' ';
            default:
                if (c <= ' ') switch(s){
                    case $f749e9e42fd6b8a6$var$S_TAG:
                        el.setTagName(source.slice(start, p)); //tagName
                        s = $f749e9e42fd6b8a6$var$S_TAG_SPACE;
                        break;
                    case $f749e9e42fd6b8a6$var$S_ATTR:
                        attrName = source.slice(start, p);
                        s = $f749e9e42fd6b8a6$var$S_ATTR_SPACE;
                        break;
                    case $f749e9e42fd6b8a6$var$S_ATTR_NOQUOT_VALUE:
                        var value = source.slice(start, p);
                        errorHandler.warning('attribute "' + value + '" missed quot(")!!');
                        addAttribute(attrName, value, start);
                    case $f749e9e42fd6b8a6$var$S_ATTR_END:
                        s = $f749e9e42fd6b8a6$var$S_TAG_SPACE;
                        break;
                }
                else //S_TAG,	S_ATTR,	S_EQ,	S_ATTR_NOQUOT_VALUE
                //S_ATTR_SPACE,	S_ATTR_END,	S_TAG_SPACE, S_TAG_CLOSE
                switch(s){
                    //case S_TAG:void();break;
                    //case S_ATTR:void();break;
                    //case S_ATTR_NOQUOT_VALUE:void();break;
                    case $f749e9e42fd6b8a6$var$S_ATTR_SPACE:
                        var tagName = el.tagName;
                        if (!$f749e9e42fd6b8a6$require$NAMESPACE.isHTML(currentNSMap['']) || !attrName.match(/^(?:disabled|checked|selected)$/i)) errorHandler.warning('attribute "' + attrName + '" missed value!! "' + attrName + '" instead2!!');
                        addAttribute(attrName, attrName, start);
                        start = p;
                        s = $f749e9e42fd6b8a6$var$S_ATTR;
                        break;
                    case $f749e9e42fd6b8a6$var$S_ATTR_END:
                        errorHandler.warning('attribute space is required"' + attrName + '"!!');
                    case $f749e9e42fd6b8a6$var$S_TAG_SPACE:
                        s = $f749e9e42fd6b8a6$var$S_ATTR;
                        start = p;
                        break;
                    case $f749e9e42fd6b8a6$var$S_EQ:
                        s = $f749e9e42fd6b8a6$var$S_ATTR_NOQUOT_VALUE;
                        start = p;
                        break;
                    case $f749e9e42fd6b8a6$var$S_TAG_CLOSE:
                        throw new Error("elements closed character '/' and '>' must be connected to");
                }
        } //end outer switch
        //console.log('p++',p)
        p++;
    }
}
/**
 * @return true if has new namespace define
 */ function $f749e9e42fd6b8a6$var$appendElement(el, domBuilder, currentNSMap) {
    var tagName = el.tagName;
    var localNSMap = null;
    //var currentNSMap = parseStack[parseStack.length-1].currentNSMap;
    var i = el.length;
    while(i--){
        var a = el[i];
        var qName = a.qName;
        var value = a.value;
        var nsp = qName.indexOf(':');
        if (nsp > 0) {
            var prefix = a.prefix = qName.slice(0, nsp);
            var localName = qName.slice(nsp + 1);
            var nsPrefix = prefix === 'xmlns' && localName;
        } else {
            localName = qName;
            prefix = null;
            nsPrefix = qName === 'xmlns' && '';
        }
        //can not set prefix,because prefix !== ''
        a.localName = localName;
        //prefix == null for no ns prefix attribute
        if (nsPrefix !== false) {
            if (localNSMap == null) {
                localNSMap = {};
                //console.log(currentNSMap,0)
                $f749e9e42fd6b8a6$var$_copy(currentNSMap, currentNSMap = {});
            //console.log(currentNSMap,1)
            }
            currentNSMap[nsPrefix] = localNSMap[nsPrefix] = value;
            a.uri = $f749e9e42fd6b8a6$require$NAMESPACE.XMLNS;
            domBuilder.startPrefixMapping(nsPrefix, value);
        }
    }
    var i = el.length;
    while(i--){
        a = el[i];
        var prefix = a.prefix;
        if (prefix) {
            if (prefix === 'xml') a.uri = $f749e9e42fd6b8a6$require$NAMESPACE.XML;
            if (prefix !== 'xmlns') a.uri = currentNSMap[prefix || ''];
        }
    }
    var nsp = tagName.indexOf(':');
    if (nsp > 0) {
        prefix = el.prefix = tagName.slice(0, nsp);
        localName = el.localName = tagName.slice(nsp + 1);
    } else {
        prefix = null; //important!!
        localName = el.localName = tagName;
    }
    //no prefix element has default namespace
    var ns = el.uri = currentNSMap[prefix || ''];
    domBuilder.startElement(ns, localName, tagName, el);
    //endPrefixMapping and startPrefixMapping have not any help for dom builder
    //localNSMap = null
    if (el.closed) {
        domBuilder.endElement(ns, localName, tagName);
        if (localNSMap) {
            for(prefix in localNSMap)if (Object.prototype.hasOwnProperty.call(localNSMap, prefix)) domBuilder.endPrefixMapping(prefix);
        }
    } else {
        el.currentNSMap = currentNSMap;
        el.localNSMap = localNSMap;
        //parseStack.push(el);
        return true;
    }
}
function $f749e9e42fd6b8a6$var$parseHtmlSpecialContent(source, elStartEnd, tagName, entityReplacer, domBuilder) {
    if (/^(?:script|textarea)$/i.test(tagName)) {
        var elEndStart = source.indexOf('</' + tagName + '>', elStartEnd);
        var text = source.substring(elStartEnd + 1, elEndStart);
        if (/[&<]/.test(text)) {
            if (/^script$/i.test(tagName)) {
                //if(!/\]\]>/.test(text)){
                //lexHandler.startCDATA();
                domBuilder.characters(text, 0, text.length);
                //lexHandler.endCDATA();
                return elEndStart;
            //}
            } //}else{//text area
            text = text.replace(/&#?\w+;/g, entityReplacer);
            domBuilder.characters(text, 0, text.length);
            return elEndStart;
        //}
        }
    }
    return elStartEnd + 1;
}
function $f749e9e42fd6b8a6$var$fixSelfClosed(source, elStartEnd, tagName, closeMap) {
    //if(tagName in closeMap){
    var pos = closeMap[tagName];
    if (pos == null) {
        //console.log(tagName)
        pos = source.lastIndexOf('</' + tagName + '>');
        if (pos < elStartEnd) pos = source.lastIndexOf('</' + tagName);
        closeMap[tagName] = pos;
    }
    return pos < elStartEnd;
//}
}
function $f749e9e42fd6b8a6$var$_copy(source, target) {
    for(var n in source)if (Object.prototype.hasOwnProperty.call(source, n)) target[n] = source[n];
}
function $f749e9e42fd6b8a6$var$parseDCC(source, start, domBuilder, errorHandler) {
    var next = source.charAt(start + 2);
    switch(next){
        case '-':
            if (source.charAt(start + 3) === '-') {
                var end = source.indexOf('-->', start + 4);
                //append comment source.substring(4,end)//<!--
                if (end > start) {
                    domBuilder.comment(source, start + 4, end - start - 4);
                    return end + 3;
                } else {
                    errorHandler.error("Unclosed comment");
                    return -1;
                }
            } else //error
            return -1;
        default:
            if (source.substr(start + 3, 6) == 'CDATA[') {
                var end = source.indexOf(']]>', start + 9);
                domBuilder.startCDATA();
                domBuilder.characters(source, start + 9, end - start - 9);
                domBuilder.endCDATA();
                return end + 3;
            }
            //<!DOCTYPE
            //startDTD(java.lang.String name, java.lang.String publicId, java.lang.String systemId)
            var matchs = $f749e9e42fd6b8a6$var$split(source, start);
            var len = matchs.length;
            if (len > 1 && /!doctype/i.test(matchs[0][0])) {
                var name = matchs[1][0];
                var pubid = false;
                var sysid = false;
                if (len > 3) {
                    if (/^public$/i.test(matchs[2][0])) {
                        pubid = matchs[3][0];
                        sysid = len > 4 && matchs[4][0];
                    } else if (/^system$/i.test(matchs[2][0])) sysid = matchs[3][0];
                }
                var lastMatch = matchs[len - 1];
                domBuilder.startDTD(name, pubid, sysid);
                domBuilder.endDTD();
                return lastMatch.index + lastMatch[0].length;
            }
    }
    return -1;
}
function $f749e9e42fd6b8a6$var$parseInstruction(source, start, domBuilder) {
    var end = source.indexOf('?>', start);
    if (end) {
        var match = source.substring(start, end).match(/^<\?(\S*)\s*([\s\S]*?)$/);
        if (match) {
            var len = match[0].length;
            domBuilder.processingInstruction(match[1], match[2]);
            return end + 2;
        } else return -1;
    }
    return -1;
}
function $f749e9e42fd6b8a6$var$ElementAttributes() {
    this.attributeNames = {};
}
$f749e9e42fd6b8a6$var$ElementAttributes.prototype = {
    setTagName: function(tagName) {
        if (!$f749e9e42fd6b8a6$var$tagNamePattern.test(tagName)) throw new Error('invalid tagName:' + tagName);
        this.tagName = tagName;
    },
    addValue: function(qName, value, offset) {
        if (!$f749e9e42fd6b8a6$var$tagNamePattern.test(qName)) throw new Error('invalid attribute:' + qName);
        this.attributeNames[qName] = this.length;
        this[this.length++] = {
            qName: qName,
            value: value,
            offset: offset
        };
    },
    length: 0,
    getLocalName: function(i) {
        return this[i].localName;
    },
    getLocator: function(i) {
        return this[i].locator;
    },
    getQName: function(i) {
        return this[i].qName;
    },
    getURI: function(i) {
        return this[i].uri;
    },
    getValue: function(i) {
        return this[i].value;
    }
};
function $f749e9e42fd6b8a6$var$split(source, start) {
    var match;
    var buf = [];
    var reg = /'[^']+'|"[^"]+"|[^\s<>\/=]+=?|(\/?\s*>|<)/g;
    reg.lastIndex = start;
    reg.exec(source); //skip <
    while(match = reg.exec(source)){
        buf.push(match);
        if (match[1]) return buf;
    }
}
$f749e9e42fd6b8a6$export$ccbc9f9f018333e9 = $f749e9e42fd6b8a6$var$XMLReader;
$f749e9e42fd6b8a6$export$f9c837a54db411d = $f749e9e42fd6b8a6$var$ParseError;

});




parcelRegister("doJbW", function(module, exports) {

$parcel$export(module.exports, "Element", function () { return $9c10925a27a67aa2$export$db77ccec0bb4ccac; }, function (v) { return $9c10925a27a67aa2$export$db77ccec0bb4ccac = v; });
$parcel$export(module.exports, "element", function () { return $9c10925a27a67aa2$export$8454457683f90105; }, function (v) { return $9c10925a27a67aa2$export$8454457683f90105 = v; });
$parcel$export(module.exports, "text", function () { return $9c10925a27a67aa2$export$6f093cfa640b7166; }, function (v) { return $9c10925a27a67aa2$export$6f093cfa640b7166 = v; });
$parcel$export(module.exports, "emptyElement", function () { return $9c10925a27a67aa2$export$ae6de35c16b306df; }, function (v) { return $9c10925a27a67aa2$export$ae6de35c16b306df = v; });
var $9c10925a27a67aa2$export$db77ccec0bb4ccac;
var $9c10925a27a67aa2$export$8454457683f90105;
var $9c10925a27a67aa2$export$6f093cfa640b7166;
var $9c10925a27a67aa2$export$ae6de35c16b306df;
parcelRequire("9jAvV");
var $5yjjJ = parcelRequire("5yjjJ");
var $efEt3 = parcelRequire("efEt3");
var $bss2W = parcelRequire("bss2W");
var $1TwZj = parcelRequire("1TwZj");
$9c10925a27a67aa2$export$db77ccec0bb4ccac = $9c10925a27a67aa2$var$Element;
$9c10925a27a67aa2$export$8454457683f90105 = function(name, attributes, children) {
    return new $9c10925a27a67aa2$var$Element(name, attributes, children);
};
$9c10925a27a67aa2$export$6f093cfa640b7166 = function(value) {
    return {
        type: "text",
        value: value
    };
};
var $9c10925a27a67aa2$var$emptyElement = $9c10925a27a67aa2$export$ae6de35c16b306df = {
    first: function() {
        return null;
    },
    firstOrEmpty: function() {
        return $9c10925a27a67aa2$var$emptyElement;
    },
    attributes: {},
    children: []
};
function $9c10925a27a67aa2$var$Element(name, attributes, children) {
    this.type = "element";
    this.name = name;
    this.attributes = attributes || {};
    this.children = children || [];
}
$9c10925a27a67aa2$var$Element.prototype.first = function(name) {
    return $bss2W.default(this.children, function(child) {
        return child.name === name;
    });
};
$9c10925a27a67aa2$var$Element.prototype.firstOrEmpty = function(name) {
    return this.first(name) || $9c10925a27a67aa2$var$emptyElement;
};
$9c10925a27a67aa2$var$Element.prototype.getElementsByTagName = function(name) {
    var elements = $efEt3.default(this.children, function(child) {
        return child.name === name;
    });
    return $9c10925a27a67aa2$var$toElementList(elements);
};
$9c10925a27a67aa2$var$Element.prototype.text = function() {
    if (this.children.length === 0) return "";
    else if (this.children.length !== 1 || this.children[0].type !== "text") throw new Error("Not implemented");
    return this.children[0].value;
};
var $9c10925a27a67aa2$var$elementListPrototype = {
    getElementsByTagName: function(name) {
        return $9c10925a27a67aa2$var$toElementList($1TwZj.default(this.map(function(element) {
            return element.getElementsByTagName(name);
        }, true)));
    }
};
function $9c10925a27a67aa2$var$toElementList(array) {
    return $5yjjJ.default(array, $9c10925a27a67aa2$var$elementListPrototype);
}

});


parcelRegister("42JRH", function(module, exports) {

$parcel$export(module.exports, "writeString", function () { return $2f1aed2feaf91759$export$48a3ce3d8cfe0ce1; }, function (v) { return $2f1aed2feaf91759$export$48a3ce3d8cfe0ce1 = v; });
var $2f1aed2feaf91759$export$48a3ce3d8cfe0ce1;
parcelRequire("9jAvV");
var $bPbGS = parcelRequire("bPbGS");
var $loFvT = parcelRequire("loFvT");

var $lwIqU = parcelRequire("lwIqU");
$2f1aed2feaf91759$export$48a3ce3d8cfe0ce1 = $2f1aed2feaf91759$var$writeString;
function $2f1aed2feaf91759$var$writeString(root, namespaces) {
    var uriToPrefix = $loFvT.default(namespaces);
    var nodeWriters = {
        element: writeElement,
        text: $2f1aed2feaf91759$var$writeTextNode
    };
    function writeNode(builder, node) {
        return nodeWriters[node.type](builder, node);
    }
    function writeElement(builder, element) {
        var elementBuilder = builder.element(mapElementName(element.name), element.attributes);
        element.children.forEach(function(child) {
            writeNode(elementBuilder, child);
        });
    }
    function mapElementName(name) {
        var longFormMatch = /^\{(.*)\}(.*)$/.exec(name);
        if (longFormMatch) {
            var prefix = uriToPrefix[longFormMatch[1]];
            return prefix + (prefix === "" ? "" : ":") + longFormMatch[2];
        } else return name;
    }
    function writeDocument(root) {
        var builder = $lwIqU.create(mapElementName(root.name), {
            version: '1.0',
            encoding: 'UTF-8',
            standalone: true
        });
        $bPbGS.default(namespaces, function(uri, prefix) {
            var key = "xmlns" + (prefix === "" ? "" : ":" + prefix);
            builder.attribute(key, uri);
        });
        root.children.forEach(function(child) {
            writeNode(builder, child);
        });
        return builder.end();
    }
    return writeDocument(root);
}
function $2f1aed2feaf91759$var$writeTextNode(builder, node) {
    builder.text(node.value);
}

});
parcelRegister("lwIqU", function(module, exports) {





// Generated by CoffeeScript 1.12.7
(function() {
    var XMLDocument, XMLDocumentCB, XMLStreamWriter, XMLStringWriter, assign, isFunction, ref;
    ref = (parcelRequire("lHgzn")), assign = ref.assign, isFunction = ref.isFunction;
    XMLDocument = (parcelRequire("lxI7F"));
    XMLDocumentCB = (parcelRequire("fJ5z4"));
    XMLStringWriter = (parcelRequire("hvQ8s"));
    XMLStreamWriter = (parcelRequire("9ZWoi"));
    module.exports.create = function(name, xmldec, doctype, options) {
        var doc, root;
        if (name == null) throw new Error("Root element needs a name.");
        options = assign({}, xmldec, doctype, options);
        doc = new XMLDocument(options);
        root = doc.element(name);
        if (!options.headless) {
            doc.declaration(options);
            if (options.pubID != null || options.sysID != null) doc.doctype(options);
        }
        return root;
    };
    module.exports.begin = function(options, onData, onEnd) {
        var ref1;
        if (isFunction(options)) {
            ref1 = [
                options,
                onData
            ], onData = ref1[0], onEnd = ref1[1];
            options = {};
        }
        if (onData) return new XMLDocumentCB(options, onData, onEnd);
        else return new XMLDocument(options);
    };
    module.exports.stringWriter = function(options) {
        return new XMLStringWriter(options);
    };
    module.exports.streamWriter = function(stream, options) {
        return new XMLStreamWriter(stream, options);
    };
}).call(module.exports);

});
parcelRegister("lHgzn", function(module, exports) {
// Generated by CoffeeScript 1.12.7
(function() {
    var assign, getValue, isArray, isEmpty, isFunction, isObject, isPlainObject, slice = [].slice, hasProp = {}.hasOwnProperty;
    assign = function() {
        var i, key, len, source, sources, target;
        target = arguments[0], sources = 2 <= arguments.length ? slice.call(arguments, 1) : [];
        if (isFunction(Object.assign)) Object.assign.apply(null, arguments);
        else for(i = 0, len = sources.length; i < len; i++){
            source = sources[i];
            if (source != null) for(key in source){
                if (!hasProp.call(source, key)) continue;
                target[key] = source[key];
            }
        }
        return target;
    };
    isFunction = function(val) {
        return !!val && Object.prototype.toString.call(val) === '[object Function]';
    };
    isObject = function(val) {
        var ref;
        return !!val && ((ref = typeof val) === 'function' || ref === 'object');
    };
    isArray = function(val) {
        if (isFunction(Array.isArray)) return Array.isArray(val);
        else return Object.prototype.toString.call(val) === '[object Array]';
    };
    isEmpty = function(val) {
        var key;
        if (isArray(val)) return !val.length;
        else {
            for(key in val){
                if (!hasProp.call(val, key)) continue;
                return false;
            }
            return true;
        }
    };
    isPlainObject = function(val) {
        var ctor, proto;
        return isObject(val) && (proto = Object.getPrototypeOf(val)) && (ctor = proto.constructor) && typeof ctor === 'function' && ctor instanceof ctor && Function.prototype.toString.call(ctor) === Function.prototype.toString.call(Object);
    };
    getValue = function(obj) {
        if (isFunction(obj.valueOf)) return obj.valueOf();
        else return obj;
    };
    module.exports.assign = assign;
    module.exports.isFunction = isFunction;
    module.exports.isObject = isObject;
    module.exports.isArray = isArray;
    module.exports.isEmpty = isEmpty;
    module.exports.isPlainObject = isPlainObject;
    module.exports.getValue = getValue;
}).call(module.exports);

});

parcelRegister("lxI7F", function(module, exports) {




// Generated by CoffeeScript 1.12.7
(function() {
    var XMLDocument, XMLNode, XMLStringWriter, XMLStringifier, isPlainObject, extend = function(child, parent) {
        for(var key in parent)if (hasProp.call(parent, key)) child[key] = parent[key];
        function ctor() {
            this.constructor = child;
        }
        ctor.prototype = parent.prototype;
        child.prototype = new ctor();
        child.__super__ = parent.prototype;
        return child;
    }, hasProp = {}.hasOwnProperty;
    isPlainObject = (parcelRequire("lHgzn")).isPlainObject;
    XMLNode = (parcelRequire("4iKOt"));
    XMLStringifier = (parcelRequire("7epDt"));
    XMLStringWriter = (parcelRequire("hvQ8s"));
    module.exports = XMLDocument = function(superClass) {
        extend(XMLDocument, superClass);
        function XMLDocument(options) {
            XMLDocument.__super__.constructor.call(this, null);
            this.name = "?xml";
            options || (options = {});
            if (!options.writer) options.writer = new XMLStringWriter();
            this.options = options;
            this.stringify = new XMLStringifier(options);
            this.isDocument = true;
        }
        XMLDocument.prototype.end = function(writer) {
            var writerOptions;
            if (!writer) writer = this.options.writer;
            else if (isPlainObject(writer)) {
                writerOptions = writer;
                writer = this.options.writer.set(writerOptions);
            }
            return writer.document(this);
        };
        XMLDocument.prototype.toString = function(options) {
            return this.options.writer.set(options).document(this);
        };
        return XMLDocument;
    }(XMLNode);
}).call(module.exports);

});
parcelRegister("4iKOt", function(module, exports) {










// Generated by CoffeeScript 1.12.7
(function() {
    var XMLCData, XMLComment, XMLDeclaration, XMLDocType, XMLDummy, XMLElement, XMLNode, XMLProcessingInstruction, XMLRaw, XMLText, getValue, isEmpty, isFunction, isObject, ref, hasProp = {}.hasOwnProperty;
    ref = (parcelRequire("lHgzn")), isObject = ref.isObject, isFunction = ref.isFunction, isEmpty = ref.isEmpty, getValue = ref.getValue;
    XMLElement = null;
    XMLCData = null;
    XMLComment = null;
    XMLDeclaration = null;
    XMLDocType = null;
    XMLRaw = null;
    XMLText = null;
    XMLProcessingInstruction = null;
    XMLDummy = null;
    module.exports = XMLNode = function() {
        function XMLNode(parent) {
            this.parent = parent;
            if (this.parent) {
                this.options = this.parent.options;
                this.stringify = this.parent.stringify;
            }
            this.children = [];
            if (!XMLElement) {
                XMLElement = (parcelRequire("75p21"));
                XMLCData = (parcelRequire("fR48K"));
                XMLComment = (parcelRequire("hoAyy"));
                XMLDeclaration = (parcelRequire("hIqqu"));
                XMLDocType = (parcelRequire("8SEjQ"));
                XMLRaw = (parcelRequire("eM366"));
                XMLText = (parcelRequire("cVqM2"));
                XMLProcessingInstruction = (parcelRequire("fDRfY"));
                XMLDummy = (parcelRequire("5k1kJ"));
            }
        }
        XMLNode.prototype.element = function(name, attributes, text) {
            var childNode, item, j, k, key, lastChild, len, len1, ref1, ref2, val;
            lastChild = null;
            if (attributes === null && text == null) ref1 = [
                {},
                null
            ], attributes = ref1[0], text = ref1[1];
            if (attributes == null) attributes = {};
            attributes = getValue(attributes);
            if (!isObject(attributes)) ref2 = [
                attributes,
                text
            ], text = ref2[0], attributes = ref2[1];
            if (name != null) name = getValue(name);
            if (Array.isArray(name)) for(j = 0, len = name.length; j < len; j++){
                item = name[j];
                lastChild = this.element(item);
            }
            else if (isFunction(name)) lastChild = this.element(name.apply());
            else if (isObject(name)) for(key in name){
                if (!hasProp.call(name, key)) continue;
                val = name[key];
                if (isFunction(val)) val = val.apply();
                if (isObject(val) && isEmpty(val)) val = null;
                if (!this.options.ignoreDecorators && this.stringify.convertAttKey && key.indexOf(this.stringify.convertAttKey) === 0) lastChild = this.attribute(key.substr(this.stringify.convertAttKey.length), val);
                else if (!this.options.separateArrayItems && Array.isArray(val)) for(k = 0, len1 = val.length; k < len1; k++){
                    item = val[k];
                    childNode = {};
                    childNode[key] = item;
                    lastChild = this.element(childNode);
                }
                else if (isObject(val)) {
                    lastChild = this.element(key);
                    lastChild.element(val);
                } else lastChild = this.element(key, val);
            }
            else if (this.options.skipNullNodes && text === null) lastChild = this.dummy();
            else {
                if (!this.options.ignoreDecorators && this.stringify.convertTextKey && name.indexOf(this.stringify.convertTextKey) === 0) lastChild = this.text(text);
                else if (!this.options.ignoreDecorators && this.stringify.convertCDataKey && name.indexOf(this.stringify.convertCDataKey) === 0) lastChild = this.cdata(text);
                else if (!this.options.ignoreDecorators && this.stringify.convertCommentKey && name.indexOf(this.stringify.convertCommentKey) === 0) lastChild = this.comment(text);
                else if (!this.options.ignoreDecorators && this.stringify.convertRawKey && name.indexOf(this.stringify.convertRawKey) === 0) lastChild = this.raw(text);
                else if (!this.options.ignoreDecorators && this.stringify.convertPIKey && name.indexOf(this.stringify.convertPIKey) === 0) lastChild = this.instruction(name.substr(this.stringify.convertPIKey.length), text);
                else lastChild = this.node(name, attributes, text);
            }
            if (lastChild == null) throw new Error("Could not create any elements with: " + name + ". " + this.debugInfo());
            return lastChild;
        };
        XMLNode.prototype.insertBefore = function(name, attributes, text) {
            var child, i, removed;
            if (this.isRoot) throw new Error("Cannot insert elements at root level. " + this.debugInfo(name));
            i = this.parent.children.indexOf(this);
            removed = this.parent.children.splice(i);
            child = this.parent.element(name, attributes, text);
            Array.prototype.push.apply(this.parent.children, removed);
            return child;
        };
        XMLNode.prototype.insertAfter = function(name, attributes, text) {
            var child, i, removed;
            if (this.isRoot) throw new Error("Cannot insert elements at root level. " + this.debugInfo(name));
            i = this.parent.children.indexOf(this);
            removed = this.parent.children.splice(i + 1);
            child = this.parent.element(name, attributes, text);
            Array.prototype.push.apply(this.parent.children, removed);
            return child;
        };
        XMLNode.prototype.remove = function() {
            var i, ref1;
            if (this.isRoot) throw new Error("Cannot remove the root element. " + this.debugInfo());
            i = this.parent.children.indexOf(this);
            [].splice.apply(this.parent.children, [
                i,
                i - i + 1
            ].concat(ref1 = [])), ref1;
            return this.parent;
        };
        XMLNode.prototype.node = function(name, attributes, text) {
            var child, ref1;
            if (name != null) name = getValue(name);
            attributes || (attributes = {});
            attributes = getValue(attributes);
            if (!isObject(attributes)) ref1 = [
                attributes,
                text
            ], text = ref1[0], attributes = ref1[1];
            child = new XMLElement(this, name, attributes);
            if (text != null) child.text(text);
            this.children.push(child);
            return child;
        };
        XMLNode.prototype.text = function(value) {
            var child;
            child = new XMLText(this, value);
            this.children.push(child);
            return this;
        };
        XMLNode.prototype.cdata = function(value) {
            var child;
            child = new XMLCData(this, value);
            this.children.push(child);
            return this;
        };
        XMLNode.prototype.comment = function(value) {
            var child;
            child = new XMLComment(this, value);
            this.children.push(child);
            return this;
        };
        XMLNode.prototype.commentBefore = function(value) {
            var child, i, removed;
            i = this.parent.children.indexOf(this);
            removed = this.parent.children.splice(i);
            child = this.parent.comment(value);
            Array.prototype.push.apply(this.parent.children, removed);
            return this;
        };
        XMLNode.prototype.commentAfter = function(value) {
            var child, i, removed;
            i = this.parent.children.indexOf(this);
            removed = this.parent.children.splice(i + 1);
            child = this.parent.comment(value);
            Array.prototype.push.apply(this.parent.children, removed);
            return this;
        };
        XMLNode.prototype.raw = function(value) {
            var child;
            child = new XMLRaw(this, value);
            this.children.push(child);
            return this;
        };
        XMLNode.prototype.dummy = function() {
            var child;
            child = new XMLDummy(this);
            this.children.push(child);
            return child;
        };
        XMLNode.prototype.instruction = function(target, value) {
            var insTarget, insValue, instruction, j, len;
            if (target != null) target = getValue(target);
            if (value != null) value = getValue(value);
            if (Array.isArray(target)) for(j = 0, len = target.length; j < len; j++){
                insTarget = target[j];
                this.instruction(insTarget);
            }
            else if (isObject(target)) for(insTarget in target){
                if (!hasProp.call(target, insTarget)) continue;
                insValue = target[insTarget];
                this.instruction(insTarget, insValue);
            }
            else {
                if (isFunction(value)) value = value.apply();
                instruction = new XMLProcessingInstruction(this, target, value);
                this.children.push(instruction);
            }
            return this;
        };
        XMLNode.prototype.instructionBefore = function(target, value) {
            var child, i, removed;
            i = this.parent.children.indexOf(this);
            removed = this.parent.children.splice(i);
            child = this.parent.instruction(target, value);
            Array.prototype.push.apply(this.parent.children, removed);
            return this;
        };
        XMLNode.prototype.instructionAfter = function(target, value) {
            var child, i, removed;
            i = this.parent.children.indexOf(this);
            removed = this.parent.children.splice(i + 1);
            child = this.parent.instruction(target, value);
            Array.prototype.push.apply(this.parent.children, removed);
            return this;
        };
        XMLNode.prototype.declaration = function(version, encoding, standalone) {
            var doc, xmldec;
            doc = this.document();
            xmldec = new XMLDeclaration(doc, version, encoding, standalone);
            if (doc.children[0] instanceof XMLDeclaration) doc.children[0] = xmldec;
            else doc.children.unshift(xmldec);
            return doc.root() || doc;
        };
        XMLNode.prototype.doctype = function(pubID, sysID) {
            var child, doc, doctype, i, j, k, len, len1, ref1, ref2;
            doc = this.document();
            doctype = new XMLDocType(doc, pubID, sysID);
            ref1 = doc.children;
            for(i = j = 0, len = ref1.length; j < len; i = ++j){
                child = ref1[i];
                if (child instanceof XMLDocType) {
                    doc.children[i] = doctype;
                    return doctype;
                }
            }
            ref2 = doc.children;
            for(i = k = 0, len1 = ref2.length; k < len1; i = ++k){
                child = ref2[i];
                if (child.isRoot) {
                    doc.children.splice(i, 0, doctype);
                    return doctype;
                }
            }
            doc.children.push(doctype);
            return doctype;
        };
        XMLNode.prototype.up = function() {
            if (this.isRoot) throw new Error("The root node has no parent. Use doc() if you need to get the document object.");
            return this.parent;
        };
        XMLNode.prototype.root = function() {
            var node;
            node = this;
            while(node){
                if (node.isDocument) return node.rootObject;
                else if (node.isRoot) return node;
                else node = node.parent;
            }
        };
        XMLNode.prototype.document = function() {
            var node;
            node = this;
            while(node){
                if (node.isDocument) return node;
                else node = node.parent;
            }
        };
        XMLNode.prototype.end = function(options) {
            return this.document().end(options);
        };
        XMLNode.prototype.prev = function() {
            var i;
            i = this.parent.children.indexOf(this);
            while(i > 0 && this.parent.children[i - 1].isDummy)i = i - 1;
            if (i < 1) throw new Error("Already at the first node. " + this.debugInfo());
            return this.parent.children[i - 1];
        };
        XMLNode.prototype.next = function() {
            var i;
            i = this.parent.children.indexOf(this);
            while(i < this.parent.children.length - 1 && this.parent.children[i + 1].isDummy)i = i + 1;
            if (i === -1 || i === this.parent.children.length - 1) throw new Error("Already at the last node. " + this.debugInfo());
            return this.parent.children[i + 1];
        };
        XMLNode.prototype.importDocument = function(doc) {
            var clonedRoot;
            clonedRoot = doc.root().clone();
            clonedRoot.parent = this;
            clonedRoot.isRoot = false;
            this.children.push(clonedRoot);
            return this;
        };
        XMLNode.prototype.debugInfo = function(name) {
            var ref1, ref2;
            name = name || this.name;
            if (name == null && !((ref1 = this.parent) != null ? ref1.name : void 0)) return "";
            else if (name == null) return "parent: <" + this.parent.name + ">";
            else if (!((ref2 = this.parent) != null ? ref2.name : void 0)) return "node: <" + name + ">";
            else return "node: <" + name + ">, parent: <" + this.parent.name + ">";
        };
        XMLNode.prototype.ele = function(name, attributes, text) {
            return this.element(name, attributes, text);
        };
        XMLNode.prototype.nod = function(name, attributes, text) {
            return this.node(name, attributes, text);
        };
        XMLNode.prototype.txt = function(value) {
            return this.text(value);
        };
        XMLNode.prototype.dat = function(value) {
            return this.cdata(value);
        };
        XMLNode.prototype.com = function(value) {
            return this.comment(value);
        };
        XMLNode.prototype.ins = function(target, value) {
            return this.instruction(target, value);
        };
        XMLNode.prototype.doc = function() {
            return this.document();
        };
        XMLNode.prototype.dec = function(version, encoding, standalone) {
            return this.declaration(version, encoding, standalone);
        };
        XMLNode.prototype.dtd = function(pubID, sysID) {
            return this.doctype(pubID, sysID);
        };
        XMLNode.prototype.e = function(name, attributes, text) {
            return this.element(name, attributes, text);
        };
        XMLNode.prototype.n = function(name, attributes, text) {
            return this.node(name, attributes, text);
        };
        XMLNode.prototype.t = function(value) {
            return this.text(value);
        };
        XMLNode.prototype.d = function(value) {
            return this.cdata(value);
        };
        XMLNode.prototype.c = function(value) {
            return this.comment(value);
        };
        XMLNode.prototype.r = function(value) {
            return this.raw(value);
        };
        XMLNode.prototype.i = function(target, value) {
            return this.instruction(target, value);
        };
        XMLNode.prototype.u = function() {
            return this.up();
        };
        XMLNode.prototype.importXMLBuilder = function(doc) {
            return this.importDocument(doc);
        };
        return XMLNode;
    }();
}).call(module.exports);

});
parcelRegister("75p21", function(module, exports) {



// Generated by CoffeeScript 1.12.7
(function() {
    var XMLAttribute, XMLElement, XMLNode, getValue, isFunction, isObject, ref, extend = function(child, parent) {
        for(var key in parent)if (hasProp.call(parent, key)) child[key] = parent[key];
        function ctor() {
            this.constructor = child;
        }
        ctor.prototype = parent.prototype;
        child.prototype = new ctor();
        child.__super__ = parent.prototype;
        return child;
    }, hasProp = {}.hasOwnProperty;
    ref = (parcelRequire("lHgzn")), isObject = ref.isObject, isFunction = ref.isFunction, getValue = ref.getValue;
    XMLNode = (parcelRequire("4iKOt"));
    XMLAttribute = (parcelRequire("4THOq"));
    module.exports = XMLElement = function(superClass) {
        extend(XMLElement, superClass);
        function XMLElement(parent, name, attributes) {
            XMLElement.__super__.constructor.call(this, parent);
            if (name == null) throw new Error("Missing element name. " + this.debugInfo());
            this.name = this.stringify.eleName(name);
            this.attributes = {};
            if (attributes != null) this.attribute(attributes);
            if (parent.isDocument) {
                this.isRoot = true;
                this.documentObject = parent;
                parent.rootObject = this;
            }
        }
        XMLElement.prototype.clone = function() {
            var att, attName, clonedSelf, ref1;
            clonedSelf = Object.create(this);
            if (clonedSelf.isRoot) clonedSelf.documentObject = null;
            clonedSelf.attributes = {};
            ref1 = this.attributes;
            for(attName in ref1){
                if (!hasProp.call(ref1, attName)) continue;
                att = ref1[attName];
                clonedSelf.attributes[attName] = att.clone();
            }
            clonedSelf.children = [];
            this.children.forEach(function(child) {
                var clonedChild;
                clonedChild = child.clone();
                clonedChild.parent = clonedSelf;
                return clonedSelf.children.push(clonedChild);
            });
            return clonedSelf;
        };
        XMLElement.prototype.attribute = function(name, value) {
            var attName, attValue;
            if (name != null) name = getValue(name);
            if (isObject(name)) for(attName in name){
                if (!hasProp.call(name, attName)) continue;
                attValue = name[attName];
                this.attribute(attName, attValue);
            }
            else {
                if (isFunction(value)) value = value.apply();
                if (!this.options.skipNullAttributes || value != null) this.attributes[name] = new XMLAttribute(this, name, value);
            }
            return this;
        };
        XMLElement.prototype.removeAttribute = function(name) {
            var attName, i, len;
            if (name == null) throw new Error("Missing attribute name. " + this.debugInfo());
            name = getValue(name);
            if (Array.isArray(name)) for(i = 0, len = name.length; i < len; i++){
                attName = name[i];
                delete this.attributes[attName];
            }
            else delete this.attributes[name];
            return this;
        };
        XMLElement.prototype.toString = function(options) {
            return this.options.writer.set(options).element(this);
        };
        XMLElement.prototype.att = function(name, value) {
            return this.attribute(name, value);
        };
        XMLElement.prototype.a = function(name, value) {
            return this.attribute(name, value);
        };
        return XMLElement;
    }(XMLNode);
}).call(module.exports);

});
parcelRegister("4THOq", function(module, exports) {
// Generated by CoffeeScript 1.12.7
(function() {
    var XMLAttribute;
    module.exports = XMLAttribute = function() {
        function XMLAttribute(parent, name, value) {
            this.options = parent.options;
            this.stringify = parent.stringify;
            this.parent = parent;
            if (name == null) throw new Error("Missing attribute name. " + this.debugInfo(name));
            if (value == null) throw new Error("Missing attribute value. " + this.debugInfo(name));
            this.name = this.stringify.attName(name);
            this.value = this.stringify.attValue(value);
        }
        XMLAttribute.prototype.clone = function() {
            return Object.create(this);
        };
        XMLAttribute.prototype.toString = function(options) {
            return this.options.writer.set(options).attribute(this);
        };
        XMLAttribute.prototype.debugInfo = function(name) {
            name = name || this.name;
            if (name == null) return "parent: <" + this.parent.name + ">";
            else return "attribute: {" + name + "}, parent: <" + this.parent.name + ">";
        };
        return XMLAttribute;
    }();
}).call(module.exports);

});


parcelRegister("fR48K", function(module, exports) {

// Generated by CoffeeScript 1.12.7
(function() {
    var XMLCData, XMLNode, extend = function(child, parent) {
        for(var key in parent)if (hasProp.call(parent, key)) child[key] = parent[key];
        function ctor() {
            this.constructor = child;
        }
        ctor.prototype = parent.prototype;
        child.prototype = new ctor();
        child.__super__ = parent.prototype;
        return child;
    }, hasProp = {}.hasOwnProperty;
    XMLNode = (parcelRequire("4iKOt"));
    module.exports = XMLCData = function(superClass) {
        extend(XMLCData, superClass);
        function XMLCData(parent, text) {
            XMLCData.__super__.constructor.call(this, parent);
            if (text == null) throw new Error("Missing CDATA text. " + this.debugInfo());
            this.text = this.stringify.cdata(text);
        }
        XMLCData.prototype.clone = function() {
            return Object.create(this);
        };
        XMLCData.prototype.toString = function(options) {
            return this.options.writer.set(options).cdata(this);
        };
        return XMLCData;
    }(XMLNode);
}).call(module.exports);

});

parcelRegister("hoAyy", function(module, exports) {

// Generated by CoffeeScript 1.12.7
(function() {
    var XMLComment, XMLNode, extend = function(child, parent) {
        for(var key in parent)if (hasProp.call(parent, key)) child[key] = parent[key];
        function ctor() {
            this.constructor = child;
        }
        ctor.prototype = parent.prototype;
        child.prototype = new ctor();
        child.__super__ = parent.prototype;
        return child;
    }, hasProp = {}.hasOwnProperty;
    XMLNode = (parcelRequire("4iKOt"));
    module.exports = XMLComment = function(superClass) {
        extend(XMLComment, superClass);
        function XMLComment(parent, text) {
            XMLComment.__super__.constructor.call(this, parent);
            if (text == null) throw new Error("Missing comment text. " + this.debugInfo());
            this.text = this.stringify.comment(text);
        }
        XMLComment.prototype.clone = function() {
            return Object.create(this);
        };
        XMLComment.prototype.toString = function(options) {
            return this.options.writer.set(options).comment(this);
        };
        return XMLComment;
    }(XMLNode);
}).call(module.exports);

});

parcelRegister("hIqqu", function(module, exports) {


// Generated by CoffeeScript 1.12.7
(function() {
    var XMLDeclaration, XMLNode, isObject, extend = function(child, parent) {
        for(var key in parent)if (hasProp.call(parent, key)) child[key] = parent[key];
        function ctor() {
            this.constructor = child;
        }
        ctor.prototype = parent.prototype;
        child.prototype = new ctor();
        child.__super__ = parent.prototype;
        return child;
    }, hasProp = {}.hasOwnProperty;
    isObject = (parcelRequire("lHgzn")).isObject;
    XMLNode = (parcelRequire("4iKOt"));
    module.exports = XMLDeclaration = function(superClass) {
        extend(XMLDeclaration, superClass);
        function XMLDeclaration(parent, version, encoding, standalone) {
            var ref;
            XMLDeclaration.__super__.constructor.call(this, parent);
            if (isObject(version)) ref = version, version = ref.version, encoding = ref.encoding, standalone = ref.standalone;
            if (!version) version = '1.0';
            this.version = this.stringify.xmlVersion(version);
            if (encoding != null) this.encoding = this.stringify.xmlEncoding(encoding);
            if (standalone != null) this.standalone = this.stringify.xmlStandalone(standalone);
        }
        XMLDeclaration.prototype.toString = function(options) {
            return this.options.writer.set(options).declaration(this);
        };
        return XMLDeclaration;
    }(XMLNode);
}).call(module.exports);

});

parcelRegister("8SEjQ", function(module, exports) {






// Generated by CoffeeScript 1.12.7
(function() {
    var XMLDTDAttList, XMLDTDElement, XMLDTDEntity, XMLDTDNotation, XMLDocType, XMLNode, isObject, extend = function(child, parent) {
        for(var key in parent)if (hasProp.call(parent, key)) child[key] = parent[key];
        function ctor() {
            this.constructor = child;
        }
        ctor.prototype = parent.prototype;
        child.prototype = new ctor();
        child.__super__ = parent.prototype;
        return child;
    }, hasProp = {}.hasOwnProperty;
    isObject = (parcelRequire("lHgzn")).isObject;
    XMLNode = (parcelRequire("4iKOt"));
    XMLDTDAttList = (parcelRequire("2p5ir"));
    XMLDTDEntity = (parcelRequire("1skwc"));
    XMLDTDElement = (parcelRequire("7tdGF"));
    XMLDTDNotation = (parcelRequire("7o9kV"));
    module.exports = XMLDocType = function(superClass) {
        extend(XMLDocType, superClass);
        function XMLDocType(parent, pubID, sysID) {
            var ref, ref1;
            XMLDocType.__super__.constructor.call(this, parent);
            this.name = "!DOCTYPE";
            this.documentObject = parent;
            if (isObject(pubID)) ref = pubID, pubID = ref.pubID, sysID = ref.sysID;
            if (sysID == null) ref1 = [
                pubID,
                sysID
            ], sysID = ref1[0], pubID = ref1[1];
            if (pubID != null) this.pubID = this.stringify.dtdPubID(pubID);
            if (sysID != null) this.sysID = this.stringify.dtdSysID(sysID);
        }
        XMLDocType.prototype.element = function(name, value) {
            var child;
            child = new XMLDTDElement(this, name, value);
            this.children.push(child);
            return this;
        };
        XMLDocType.prototype.attList = function(elementName, attributeName, attributeType, defaultValueType, defaultValue) {
            var child;
            child = new XMLDTDAttList(this, elementName, attributeName, attributeType, defaultValueType, defaultValue);
            this.children.push(child);
            return this;
        };
        XMLDocType.prototype.entity = function(name, value) {
            var child;
            child = new XMLDTDEntity(this, false, name, value);
            this.children.push(child);
            return this;
        };
        XMLDocType.prototype.pEntity = function(name, value) {
            var child;
            child = new XMLDTDEntity(this, true, name, value);
            this.children.push(child);
            return this;
        };
        XMLDocType.prototype.notation = function(name, value) {
            var child;
            child = new XMLDTDNotation(this, name, value);
            this.children.push(child);
            return this;
        };
        XMLDocType.prototype.toString = function(options) {
            return this.options.writer.set(options).docType(this);
        };
        XMLDocType.prototype.ele = function(name, value) {
            return this.element(name, value);
        };
        XMLDocType.prototype.att = function(elementName, attributeName, attributeType, defaultValueType, defaultValue) {
            return this.attList(elementName, attributeName, attributeType, defaultValueType, defaultValue);
        };
        XMLDocType.prototype.ent = function(name, value) {
            return this.entity(name, value);
        };
        XMLDocType.prototype.pent = function(name, value) {
            return this.pEntity(name, value);
        };
        XMLDocType.prototype.not = function(name, value) {
            return this.notation(name, value);
        };
        XMLDocType.prototype.up = function() {
            return this.root() || this.documentObject;
        };
        return XMLDocType;
    }(XMLNode);
}).call(module.exports);

});
parcelRegister("2p5ir", function(module, exports) {

// Generated by CoffeeScript 1.12.7
(function() {
    var XMLDTDAttList, XMLNode, extend = function(child, parent) {
        for(var key in parent)if (hasProp.call(parent, key)) child[key] = parent[key];
        function ctor() {
            this.constructor = child;
        }
        ctor.prototype = parent.prototype;
        child.prototype = new ctor();
        child.__super__ = parent.prototype;
        return child;
    }, hasProp = {}.hasOwnProperty;
    XMLNode = (parcelRequire("4iKOt"));
    module.exports = XMLDTDAttList = function(superClass) {
        extend(XMLDTDAttList, superClass);
        function XMLDTDAttList(parent, elementName, attributeName, attributeType, defaultValueType, defaultValue) {
            XMLDTDAttList.__super__.constructor.call(this, parent);
            if (elementName == null) throw new Error("Missing DTD element name. " + this.debugInfo());
            if (attributeName == null) throw new Error("Missing DTD attribute name. " + this.debugInfo(elementName));
            if (!attributeType) throw new Error("Missing DTD attribute type. " + this.debugInfo(elementName));
            if (!defaultValueType) throw new Error("Missing DTD attribute default. " + this.debugInfo(elementName));
            if (defaultValueType.indexOf('#') !== 0) defaultValueType = '#' + defaultValueType;
            if (!defaultValueType.match(/^(#REQUIRED|#IMPLIED|#FIXED|#DEFAULT)$/)) throw new Error("Invalid default value type; expected: #REQUIRED, #IMPLIED, #FIXED or #DEFAULT. " + this.debugInfo(elementName));
            if (defaultValue && !defaultValueType.match(/^(#FIXED|#DEFAULT)$/)) throw new Error("Default value only applies to #FIXED or #DEFAULT. " + this.debugInfo(elementName));
            this.elementName = this.stringify.eleName(elementName);
            this.attributeName = this.stringify.attName(attributeName);
            this.attributeType = this.stringify.dtdAttType(attributeType);
            this.defaultValue = this.stringify.dtdAttDefault(defaultValue);
            this.defaultValueType = defaultValueType;
        }
        XMLDTDAttList.prototype.toString = function(options) {
            return this.options.writer.set(options).dtdAttList(this);
        };
        return XMLDTDAttList;
    }(XMLNode);
}).call(module.exports);

});

parcelRegister("1skwc", function(module, exports) {


// Generated by CoffeeScript 1.12.7
(function() {
    var XMLDTDEntity, XMLNode, isObject, extend = function(child, parent) {
        for(var key in parent)if (hasProp.call(parent, key)) child[key] = parent[key];
        function ctor() {
            this.constructor = child;
        }
        ctor.prototype = parent.prototype;
        child.prototype = new ctor();
        child.__super__ = parent.prototype;
        return child;
    }, hasProp = {}.hasOwnProperty;
    isObject = (parcelRequire("lHgzn")).isObject;
    XMLNode = (parcelRequire("4iKOt"));
    module.exports = XMLDTDEntity = function(superClass) {
        extend(XMLDTDEntity, superClass);
        function XMLDTDEntity(parent, pe, name, value) {
            XMLDTDEntity.__super__.constructor.call(this, parent);
            if (name == null) throw new Error("Missing DTD entity name. " + this.debugInfo(name));
            if (value == null) throw new Error("Missing DTD entity value. " + this.debugInfo(name));
            this.pe = !!pe;
            this.name = this.stringify.eleName(name);
            if (!isObject(value)) this.value = this.stringify.dtdEntityValue(value);
            else {
                if (!value.pubID && !value.sysID) throw new Error("Public and/or system identifiers are required for an external entity. " + this.debugInfo(name));
                if (value.pubID && !value.sysID) throw new Error("System identifier is required for a public external entity. " + this.debugInfo(name));
                if (value.pubID != null) this.pubID = this.stringify.dtdPubID(value.pubID);
                if (value.sysID != null) this.sysID = this.stringify.dtdSysID(value.sysID);
                if (value.nData != null) this.nData = this.stringify.dtdNData(value.nData);
                if (this.pe && this.nData) throw new Error("Notation declaration is not allowed in a parameter entity. " + this.debugInfo(name));
            }
        }
        XMLDTDEntity.prototype.toString = function(options) {
            return this.options.writer.set(options).dtdEntity(this);
        };
        return XMLDTDEntity;
    }(XMLNode);
}).call(module.exports);

});

parcelRegister("7tdGF", function(module, exports) {

// Generated by CoffeeScript 1.12.7
(function() {
    var XMLDTDElement, XMLNode, extend = function(child, parent) {
        for(var key in parent)if (hasProp.call(parent, key)) child[key] = parent[key];
        function ctor() {
            this.constructor = child;
        }
        ctor.prototype = parent.prototype;
        child.prototype = new ctor();
        child.__super__ = parent.prototype;
        return child;
    }, hasProp = {}.hasOwnProperty;
    XMLNode = (parcelRequire("4iKOt"));
    module.exports = XMLDTDElement = function(superClass) {
        extend(XMLDTDElement, superClass);
        function XMLDTDElement(parent, name, value) {
            XMLDTDElement.__super__.constructor.call(this, parent);
            if (name == null) throw new Error("Missing DTD element name. " + this.debugInfo());
            if (!value) value = '(#PCDATA)';
            if (Array.isArray(value)) value = '(' + value.join(',') + ')';
            this.name = this.stringify.eleName(name);
            this.value = this.stringify.dtdElementValue(value);
        }
        XMLDTDElement.prototype.toString = function(options) {
            return this.options.writer.set(options).dtdElement(this);
        };
        return XMLDTDElement;
    }(XMLNode);
}).call(module.exports);

});

parcelRegister("7o9kV", function(module, exports) {

// Generated by CoffeeScript 1.12.7
(function() {
    var XMLDTDNotation, XMLNode, extend = function(child, parent) {
        for(var key in parent)if (hasProp.call(parent, key)) child[key] = parent[key];
        function ctor() {
            this.constructor = child;
        }
        ctor.prototype = parent.prototype;
        child.prototype = new ctor();
        child.__super__ = parent.prototype;
        return child;
    }, hasProp = {}.hasOwnProperty;
    XMLNode = (parcelRequire("4iKOt"));
    module.exports = XMLDTDNotation = function(superClass) {
        extend(XMLDTDNotation, superClass);
        function XMLDTDNotation(parent, name, value) {
            XMLDTDNotation.__super__.constructor.call(this, parent);
            if (name == null) throw new Error("Missing DTD notation name. " + this.debugInfo(name));
            if (!value.pubID && !value.sysID) throw new Error("Public or system identifiers are required for an external entity. " + this.debugInfo(name));
            this.name = this.stringify.eleName(name);
            if (value.pubID != null) this.pubID = this.stringify.dtdPubID(value.pubID);
            if (value.sysID != null) this.sysID = this.stringify.dtdSysID(value.sysID);
        }
        XMLDTDNotation.prototype.toString = function(options) {
            return this.options.writer.set(options).dtdNotation(this);
        };
        return XMLDTDNotation;
    }(XMLNode);
}).call(module.exports);

});


parcelRegister("eM366", function(module, exports) {

// Generated by CoffeeScript 1.12.7
(function() {
    var XMLNode, XMLRaw, extend = function(child, parent) {
        for(var key in parent)if (hasProp.call(parent, key)) child[key] = parent[key];
        function ctor() {
            this.constructor = child;
        }
        ctor.prototype = parent.prototype;
        child.prototype = new ctor();
        child.__super__ = parent.prototype;
        return child;
    }, hasProp = {}.hasOwnProperty;
    XMLNode = (parcelRequire("4iKOt"));
    module.exports = XMLRaw = function(superClass) {
        extend(XMLRaw, superClass);
        function XMLRaw(parent, text) {
            XMLRaw.__super__.constructor.call(this, parent);
            if (text == null) throw new Error("Missing raw text. " + this.debugInfo());
            this.value = this.stringify.raw(text);
        }
        XMLRaw.prototype.clone = function() {
            return Object.create(this);
        };
        XMLRaw.prototype.toString = function(options) {
            return this.options.writer.set(options).raw(this);
        };
        return XMLRaw;
    }(XMLNode);
}).call(module.exports);

});

parcelRegister("cVqM2", function(module, exports) {

// Generated by CoffeeScript 1.12.7
(function() {
    var XMLNode, XMLText, extend = function(child, parent) {
        for(var key in parent)if (hasProp.call(parent, key)) child[key] = parent[key];
        function ctor() {
            this.constructor = child;
        }
        ctor.prototype = parent.prototype;
        child.prototype = new ctor();
        child.__super__ = parent.prototype;
        return child;
    }, hasProp = {}.hasOwnProperty;
    XMLNode = (parcelRequire("4iKOt"));
    module.exports = XMLText = function(superClass) {
        extend(XMLText, superClass);
        function XMLText(parent, text) {
            XMLText.__super__.constructor.call(this, parent);
            if (text == null) throw new Error("Missing element text. " + this.debugInfo());
            this.value = this.stringify.eleText(text);
        }
        XMLText.prototype.clone = function() {
            return Object.create(this);
        };
        XMLText.prototype.toString = function(options) {
            return this.options.writer.set(options).text(this);
        };
        return XMLText;
    }(XMLNode);
}).call(module.exports);

});

parcelRegister("fDRfY", function(module, exports) {

// Generated by CoffeeScript 1.12.7
(function() {
    var XMLNode, XMLProcessingInstruction, extend = function(child, parent) {
        for(var key in parent)if (hasProp.call(parent, key)) child[key] = parent[key];
        function ctor() {
            this.constructor = child;
        }
        ctor.prototype = parent.prototype;
        child.prototype = new ctor();
        child.__super__ = parent.prototype;
        return child;
    }, hasProp = {}.hasOwnProperty;
    XMLNode = (parcelRequire("4iKOt"));
    module.exports = XMLProcessingInstruction = function(superClass) {
        extend(XMLProcessingInstruction, superClass);
        function XMLProcessingInstruction(parent, target, value) {
            XMLProcessingInstruction.__super__.constructor.call(this, parent);
            if (target == null) throw new Error("Missing instruction target. " + this.debugInfo());
            this.target = this.stringify.insTarget(target);
            if (value) this.value = this.stringify.insValue(value);
        }
        XMLProcessingInstruction.prototype.clone = function() {
            return Object.create(this);
        };
        XMLProcessingInstruction.prototype.toString = function(options) {
            return this.options.writer.set(options).processingInstruction(this);
        };
        return XMLProcessingInstruction;
    }(XMLNode);
}).call(module.exports);

});

parcelRegister("5k1kJ", function(module, exports) {

// Generated by CoffeeScript 1.12.7
(function() {
    var XMLDummy, XMLNode, extend = function(child, parent) {
        for(var key in parent)if (hasProp.call(parent, key)) child[key] = parent[key];
        function ctor() {
            this.constructor = child;
        }
        ctor.prototype = parent.prototype;
        child.prototype = new ctor();
        child.__super__ = parent.prototype;
        return child;
    }, hasProp = {}.hasOwnProperty;
    XMLNode = (parcelRequire("4iKOt"));
    module.exports = XMLDummy = function(superClass) {
        extend(XMLDummy, superClass);
        function XMLDummy(parent) {
            XMLDummy.__super__.constructor.call(this, parent);
            this.isDummy = true;
        }
        XMLDummy.prototype.clone = function() {
            return Object.create(this);
        };
        XMLDummy.prototype.toString = function(options) {
            return '';
        };
        return XMLDummy;
    }(XMLNode);
}).call(module.exports);

});


parcelRegister("7epDt", function(module, exports) {
// Generated by CoffeeScript 1.12.7
(function() {
    var XMLStringifier, bind = function(fn, me) {
        return function() {
            return fn.apply(me, arguments);
        };
    }, hasProp = {}.hasOwnProperty;
    module.exports = XMLStringifier = function() {
        function XMLStringifier(options) {
            this.assertLegalChar = bind(this.assertLegalChar, this);
            var key, ref, value;
            options || (options = {});
            this.noDoubleEncoding = options.noDoubleEncoding;
            ref = options.stringify || {};
            for(key in ref){
                if (!hasProp.call(ref, key)) continue;
                value = ref[key];
                this[key] = value;
            }
        }
        XMLStringifier.prototype.eleName = function(val) {
            val = '' + val || '';
            return this.assertLegalChar(val);
        };
        XMLStringifier.prototype.eleText = function(val) {
            val = '' + val || '';
            return this.assertLegalChar(this.elEscape(val));
        };
        XMLStringifier.prototype.cdata = function(val) {
            val = '' + val || '';
            val = val.replace(']]>', ']]]]><![CDATA[>');
            return this.assertLegalChar(val);
        };
        XMLStringifier.prototype.comment = function(val) {
            val = '' + val || '';
            if (val.match(/--/)) throw new Error("Comment text cannot contain double-hypen: " + val);
            return this.assertLegalChar(val);
        };
        XMLStringifier.prototype.raw = function(val) {
            return '' + val || '';
        };
        XMLStringifier.prototype.attName = function(val) {
            return val = '' + val || '';
        };
        XMLStringifier.prototype.attValue = function(val) {
            val = '' + val || '';
            return this.attEscape(val);
        };
        XMLStringifier.prototype.insTarget = function(val) {
            return '' + val || '';
        };
        XMLStringifier.prototype.insValue = function(val) {
            val = '' + val || '';
            if (val.match(/\?>/)) throw new Error("Invalid processing instruction value: " + val);
            return val;
        };
        XMLStringifier.prototype.xmlVersion = function(val) {
            val = '' + val || '';
            if (!val.match(/1\.[0-9]+/)) throw new Error("Invalid version number: " + val);
            return val;
        };
        XMLStringifier.prototype.xmlEncoding = function(val) {
            val = '' + val || '';
            if (!val.match(/^[A-Za-z](?:[A-Za-z0-9._-])*$/)) throw new Error("Invalid encoding: " + val);
            return val;
        };
        XMLStringifier.prototype.xmlStandalone = function(val) {
            if (val) return "yes";
            else return "no";
        };
        XMLStringifier.prototype.dtdPubID = function(val) {
            return '' + val || '';
        };
        XMLStringifier.prototype.dtdSysID = function(val) {
            return '' + val || '';
        };
        XMLStringifier.prototype.dtdElementValue = function(val) {
            return '' + val || '';
        };
        XMLStringifier.prototype.dtdAttType = function(val) {
            return '' + val || '';
        };
        XMLStringifier.prototype.dtdAttDefault = function(val) {
            if (val != null) return '' + val || '';
            else return val;
        };
        XMLStringifier.prototype.dtdEntityValue = function(val) {
            return '' + val || '';
        };
        XMLStringifier.prototype.dtdNData = function(val) {
            return '' + val || '';
        };
        XMLStringifier.prototype.convertAttKey = '@';
        XMLStringifier.prototype.convertPIKey = '?';
        XMLStringifier.prototype.convertTextKey = '#text';
        XMLStringifier.prototype.convertCDataKey = '#cdata';
        XMLStringifier.prototype.convertCommentKey = '#comment';
        XMLStringifier.prototype.convertRawKey = '#raw';
        XMLStringifier.prototype.assertLegalChar = function(str) {
            var res;
            res = str.match(/[\0\uFFFE\uFFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF]/);
            if (res) throw new Error("Invalid character in string: " + str + " at index " + res.index);
            return str;
        };
        XMLStringifier.prototype.elEscape = function(str) {
            var ampregex;
            ampregex = this.noDoubleEncoding ? /(?!&\S+;)&/g : /&/g;
            return str.replace(ampregex, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/\r/g, '&#xD;');
        };
        XMLStringifier.prototype.attEscape = function(str) {
            var ampregex;
            ampregex = this.noDoubleEncoding ? /(?!&\S+;)&/g : /&/g;
            return str.replace(ampregex, '&amp;').replace(/</g, '&lt;').replace(/"/g, '&quot;').replace(/\t/g, '&#x9;').replace(/\n/g, '&#xA;').replace(/\r/g, '&#xD;');
        };
        return XMLStringifier;
    }();
}).call(module.exports);

});

parcelRegister("hvQ8s", function(module, exports) {














// Generated by CoffeeScript 1.12.7
(function() {
    var XMLCData, XMLComment, XMLDTDAttList, XMLDTDElement, XMLDTDEntity, XMLDTDNotation, XMLDeclaration, XMLDocType, XMLDummy, XMLElement, XMLProcessingInstruction, XMLRaw, XMLStringWriter, XMLText, XMLWriterBase, extend = function(child, parent) {
        for(var key in parent)if (hasProp.call(parent, key)) child[key] = parent[key];
        function ctor() {
            this.constructor = child;
        }
        ctor.prototype = parent.prototype;
        child.prototype = new ctor();
        child.__super__ = parent.prototype;
        return child;
    }, hasProp = {}.hasOwnProperty;
    XMLDeclaration = (parcelRequire("hIqqu"));
    XMLDocType = (parcelRequire("8SEjQ"));
    XMLCData = (parcelRequire("fR48K"));
    XMLComment = (parcelRequire("hoAyy"));
    XMLElement = (parcelRequire("75p21"));
    XMLRaw = (parcelRequire("eM366"));
    XMLText = (parcelRequire("cVqM2"));
    XMLProcessingInstruction = (parcelRequire("fDRfY"));
    XMLDummy = (parcelRequire("5k1kJ"));
    XMLDTDAttList = (parcelRequire("2p5ir"));
    XMLDTDElement = (parcelRequire("7tdGF"));
    XMLDTDEntity = (parcelRequire("1skwc"));
    XMLDTDNotation = (parcelRequire("7o9kV"));
    XMLWriterBase = (parcelRequire("3pyEP"));
    module.exports = XMLStringWriter = function(superClass) {
        extend(XMLStringWriter, superClass);
        function XMLStringWriter(options) {
            XMLStringWriter.__super__.constructor.call(this, options);
        }
        XMLStringWriter.prototype.document = function(doc) {
            var child, i, len, r, ref;
            this.textispresent = false;
            r = '';
            ref = doc.children;
            for(i = 0, len = ref.length; i < len; i++){
                child = ref[i];
                if (child instanceof XMLDummy) continue;
                r += (function() {
                    switch(false){
                        case !(child instanceof XMLDeclaration):
                            return this.declaration(child);
                        case !(child instanceof XMLDocType):
                            return this.docType(child);
                        case !(child instanceof XMLComment):
                            return this.comment(child);
                        case !(child instanceof XMLProcessingInstruction):
                            return this.processingInstruction(child);
                        default:
                            return this.element(child, 0);
                    }
                }).call(this);
            }
            if (this.pretty && r.slice(-this.newline.length) === this.newline) r = r.slice(0, -this.newline.length);
            return r;
        };
        XMLStringWriter.prototype.attribute = function(att) {
            return ' ' + att.name + '="' + att.value + '"';
        };
        XMLStringWriter.prototype.cdata = function(node, level) {
            return this.space(level) + '<![CDATA[' + node.text + ']]>' + this.newline;
        };
        XMLStringWriter.prototype.comment = function(node, level) {
            return this.space(level) + '<!-- ' + node.text + ' -->' + this.newline;
        };
        XMLStringWriter.prototype.declaration = function(node, level) {
            var r;
            r = this.space(level);
            r += '<?xml version="' + node.version + '"';
            if (node.encoding != null) r += ' encoding="' + node.encoding + '"';
            if (node.standalone != null) r += ' standalone="' + node.standalone + '"';
            r += this.spacebeforeslash + '?>';
            r += this.newline;
            return r;
        };
        XMLStringWriter.prototype.docType = function(node, level) {
            var child, i, len, r, ref;
            level || (level = 0);
            r = this.space(level);
            r += '<!DOCTYPE ' + node.root().name;
            if (node.pubID && node.sysID) r += ' PUBLIC "' + node.pubID + '" "' + node.sysID + '"';
            else if (node.sysID) r += ' SYSTEM "' + node.sysID + '"';
            if (node.children.length > 0) {
                r += ' [';
                r += this.newline;
                ref = node.children;
                for(i = 0, len = ref.length; i < len; i++){
                    child = ref[i];
                    r += (function() {
                        switch(false){
                            case !(child instanceof XMLDTDAttList):
                                return this.dtdAttList(child, level + 1);
                            case !(child instanceof XMLDTDElement):
                                return this.dtdElement(child, level + 1);
                            case !(child instanceof XMLDTDEntity):
                                return this.dtdEntity(child, level + 1);
                            case !(child instanceof XMLDTDNotation):
                                return this.dtdNotation(child, level + 1);
                            case !(child instanceof XMLCData):
                                return this.cdata(child, level + 1);
                            case !(child instanceof XMLComment):
                                return this.comment(child, level + 1);
                            case !(child instanceof XMLProcessingInstruction):
                                return this.processingInstruction(child, level + 1);
                            default:
                                throw new Error("Unknown DTD node type: " + child.constructor.name);
                        }
                    }).call(this);
                }
                r += ']';
            }
            r += this.spacebeforeslash + '>';
            r += this.newline;
            return r;
        };
        XMLStringWriter.prototype.element = function(node, level) {
            var att, child, i, j, len, len1, name, r, ref, ref1, ref2, space, textispresentwasset;
            level || (level = 0);
            textispresentwasset = false;
            if (this.textispresent) {
                this.newline = '';
                this.pretty = false;
            } else {
                this.newline = this.newlinedefault;
                this.pretty = this.prettydefault;
            }
            space = this.space(level);
            r = '';
            r += space + '<' + node.name;
            ref = node.attributes;
            for(name in ref){
                if (!hasProp.call(ref, name)) continue;
                att = ref[name];
                r += this.attribute(att);
            }
            if (node.children.length === 0 || node.children.every(function(e) {
                return e.value === '';
            })) {
                if (this.allowEmpty) r += '></' + node.name + '>' + this.newline;
                else r += this.spacebeforeslash + '/>' + this.newline;
            } else if (this.pretty && node.children.length === 1 && node.children[0].value != null) {
                r += '>';
                r += node.children[0].value;
                r += '</' + node.name + '>' + this.newline;
            } else {
                if (this.dontprettytextnodes) {
                    ref1 = node.children;
                    for(i = 0, len = ref1.length; i < len; i++){
                        child = ref1[i];
                        if (child.value != null) {
                            this.textispresent++;
                            textispresentwasset = true;
                            break;
                        }
                    }
                }
                if (this.textispresent) {
                    this.newline = '';
                    this.pretty = false;
                    space = this.space(level);
                }
                r += '>' + this.newline;
                ref2 = node.children;
                for(j = 0, len1 = ref2.length; j < len1; j++){
                    child = ref2[j];
                    r += (function() {
                        switch(false){
                            case !(child instanceof XMLCData):
                                return this.cdata(child, level + 1);
                            case !(child instanceof XMLComment):
                                return this.comment(child, level + 1);
                            case !(child instanceof XMLElement):
                                return this.element(child, level + 1);
                            case !(child instanceof XMLRaw):
                                return this.raw(child, level + 1);
                            case !(child instanceof XMLText):
                                return this.text(child, level + 1);
                            case !(child instanceof XMLProcessingInstruction):
                                return this.processingInstruction(child, level + 1);
                            case !(child instanceof XMLDummy):
                                return '';
                            default:
                                throw new Error("Unknown XML node type: " + child.constructor.name);
                        }
                    }).call(this);
                }
                if (textispresentwasset) this.textispresent--;
                if (!this.textispresent) {
                    this.newline = this.newlinedefault;
                    this.pretty = this.prettydefault;
                }
                r += space + '</' + node.name + '>' + this.newline;
            }
            return r;
        };
        XMLStringWriter.prototype.processingInstruction = function(node, level) {
            var r;
            r = this.space(level) + '<?' + node.target;
            if (node.value) r += ' ' + node.value;
            r += this.spacebeforeslash + '?>' + this.newline;
            return r;
        };
        XMLStringWriter.prototype.raw = function(node, level) {
            return this.space(level) + node.value + this.newline;
        };
        XMLStringWriter.prototype.text = function(node, level) {
            return this.space(level) + node.value + this.newline;
        };
        XMLStringWriter.prototype.dtdAttList = function(node, level) {
            var r;
            r = this.space(level) + '<!ATTLIST ' + node.elementName + ' ' + node.attributeName + ' ' + node.attributeType;
            if (node.defaultValueType !== '#DEFAULT') r += ' ' + node.defaultValueType;
            if (node.defaultValue) r += ' "' + node.defaultValue + '"';
            r += this.spacebeforeslash + '>' + this.newline;
            return r;
        };
        XMLStringWriter.prototype.dtdElement = function(node, level) {
            return this.space(level) + '<!ELEMENT ' + node.name + ' ' + node.value + this.spacebeforeslash + '>' + this.newline;
        };
        XMLStringWriter.prototype.dtdEntity = function(node, level) {
            var r;
            r = this.space(level) + '<!ENTITY';
            if (node.pe) r += ' %';
            r += ' ' + node.name;
            if (node.value) r += ' "' + node.value + '"';
            else {
                if (node.pubID && node.sysID) r += ' PUBLIC "' + node.pubID + '" "' + node.sysID + '"';
                else if (node.sysID) r += ' SYSTEM "' + node.sysID + '"';
                if (node.nData) r += ' NDATA ' + node.nData;
            }
            r += this.spacebeforeslash + '>' + this.newline;
            return r;
        };
        XMLStringWriter.prototype.dtdNotation = function(node, level) {
            var r;
            r = this.space(level) + '<!NOTATION ' + node.name;
            if (node.pubID && node.sysID) r += ' PUBLIC "' + node.pubID + '" "' + node.sysID + '"';
            else if (node.pubID) r += ' PUBLIC "' + node.pubID + '"';
            else if (node.sysID) r += ' SYSTEM "' + node.sysID + '"';
            r += this.spacebeforeslash + '>' + this.newline;
            return r;
        };
        XMLStringWriter.prototype.openNode = function(node, level) {
            var att, name, r, ref;
            level || (level = 0);
            if (node instanceof XMLElement) {
                r = this.space(level) + '<' + node.name;
                ref = node.attributes;
                for(name in ref){
                    if (!hasProp.call(ref, name)) continue;
                    att = ref[name];
                    r += this.attribute(att);
                }
                r += (node.children ? '>' : '/>') + this.newline;
                return r;
            } else {
                r = this.space(level) + '<!DOCTYPE ' + node.rootNodeName;
                if (node.pubID && node.sysID) r += ' PUBLIC "' + node.pubID + '" "' + node.sysID + '"';
                else if (node.sysID) r += ' SYSTEM "' + node.sysID + '"';
                r += (node.children ? ' [' : '>') + this.newline;
                return r;
            }
        };
        XMLStringWriter.prototype.closeNode = function(node, level) {
            level || (level = 0);
            switch(false){
                case !(node instanceof XMLElement):
                    return this.space(level) + '</' + node.name + '>' + this.newline;
                case !(node instanceof XMLDocType):
                    return this.space(level) + ']>' + this.newline;
            }
        };
        return XMLStringWriter;
    }(XMLWriterBase);
}).call(module.exports);

});
parcelRegister("3pyEP", function(module, exports) {
// Generated by CoffeeScript 1.12.7
(function() {
    var XMLWriterBase, hasProp = {}.hasOwnProperty;
    module.exports = XMLWriterBase = function() {
        function XMLWriterBase(options) {
            var key, ref, ref1, ref2, ref3, ref4, ref5, ref6, value;
            options || (options = {});
            this.pretty = options.pretty || false;
            this.allowEmpty = (ref = options.allowEmpty) != null ? ref : false;
            if (this.pretty) {
                this.indent = (ref1 = options.indent) != null ? ref1 : '  ';
                this.newline = (ref2 = options.newline) != null ? ref2 : '\n';
                this.offset = (ref3 = options.offset) != null ? ref3 : 0;
                this.dontprettytextnodes = (ref4 = options.dontprettytextnodes) != null ? ref4 : 0;
            } else {
                this.indent = '';
                this.newline = '';
                this.offset = 0;
                this.dontprettytextnodes = 0;
            }
            this.spacebeforeslash = (ref5 = options.spacebeforeslash) != null ? ref5 : '';
            if (this.spacebeforeslash === true) this.spacebeforeslash = ' ';
            this.newlinedefault = this.newline;
            this.prettydefault = this.pretty;
            ref6 = options.writer || {};
            for(key in ref6){
                if (!hasProp.call(ref6, key)) continue;
                value = ref6[key];
                this[key] = value;
            }
        }
        XMLWriterBase.prototype.set = function(options) {
            var key, ref, value;
            options || (options = {});
            if ("pretty" in options) this.pretty = options.pretty;
            if ("allowEmpty" in options) this.allowEmpty = options.allowEmpty;
            if (this.pretty) {
                this.indent = "indent" in options ? options.indent : '  ';
                this.newline = "newline" in options ? options.newline : '\n';
                this.offset = "offset" in options ? options.offset : 0;
                this.dontprettytextnodes = "dontprettytextnodes" in options ? options.dontprettytextnodes : 0;
            } else {
                this.indent = '';
                this.newline = '';
                this.offset = 0;
                this.dontprettytextnodes = 0;
            }
            this.spacebeforeslash = "spacebeforeslash" in options ? options.spacebeforeslash : '';
            if (this.spacebeforeslash === true) this.spacebeforeslash = ' ';
            this.newlinedefault = this.newline;
            this.prettydefault = this.pretty;
            ref = options.writer || {};
            for(key in ref){
                if (!hasProp.call(ref, key)) continue;
                value = ref[key];
                this[key] = value;
            }
            return this;
        };
        XMLWriterBase.prototype.space = function(level) {
            var indent;
            if (this.pretty) {
                indent = (level || 0) + this.offset + 1;
                if (indent > 0) return new Array(indent).join(this.indent);
                else return '';
            } else return '';
        };
        return XMLWriterBase;
    }();
}).call(module.exports);

});



parcelRegister("fJ5z4", function(module, exports) {
















// Generated by CoffeeScript 1.12.7
(function() {
    var XMLAttribute, XMLCData, XMLComment, XMLDTDAttList, XMLDTDElement, XMLDTDEntity, XMLDTDNotation, XMLDeclaration, XMLDocType, XMLDocumentCB, XMLElement, XMLProcessingInstruction, XMLRaw, XMLStringWriter, XMLStringifier, XMLText, getValue, isFunction, isObject, isPlainObject, ref, hasProp = {}.hasOwnProperty;
    ref = (parcelRequire("lHgzn")), isObject = ref.isObject, isFunction = ref.isFunction, isPlainObject = ref.isPlainObject, getValue = ref.getValue;
    XMLElement = (parcelRequire("75p21"));
    XMLCData = (parcelRequire("fR48K"));
    XMLComment = (parcelRequire("hoAyy"));
    XMLRaw = (parcelRequire("eM366"));
    XMLText = (parcelRequire("cVqM2"));
    XMLProcessingInstruction = (parcelRequire("fDRfY"));
    XMLDeclaration = (parcelRequire("hIqqu"));
    XMLDocType = (parcelRequire("8SEjQ"));
    XMLDTDAttList = (parcelRequire("2p5ir"));
    XMLDTDEntity = (parcelRequire("1skwc"));
    XMLDTDElement = (parcelRequire("7tdGF"));
    XMLDTDNotation = (parcelRequire("7o9kV"));
    XMLAttribute = (parcelRequire("4THOq"));
    XMLStringifier = (parcelRequire("7epDt"));
    XMLStringWriter = (parcelRequire("hvQ8s"));
    module.exports = XMLDocumentCB = function() {
        function XMLDocumentCB(options, onData, onEnd) {
            var writerOptions;
            this.name = "?xml";
            options || (options = {});
            if (!options.writer) options.writer = new XMLStringWriter(options);
            else if (isPlainObject(options.writer)) {
                writerOptions = options.writer;
                options.writer = new XMLStringWriter(writerOptions);
            }
            this.options = options;
            this.writer = options.writer;
            this.stringify = new XMLStringifier(options);
            this.onDataCallback = onData || function() {};
            this.onEndCallback = onEnd || function() {};
            this.currentNode = null;
            this.currentLevel = -1;
            this.openTags = {};
            this.documentStarted = false;
            this.documentCompleted = false;
            this.root = null;
        }
        XMLDocumentCB.prototype.node = function(name, attributes, text) {
            var ref1, ref2;
            if (name == null) throw new Error("Missing node name.");
            if (this.root && this.currentLevel === -1) throw new Error("Document can only have one root node. " + this.debugInfo(name));
            this.openCurrent();
            name = getValue(name);
            if (attributes === null && text == null) ref1 = [
                {},
                null
            ], attributes = ref1[0], text = ref1[1];
            if (attributes == null) attributes = {};
            attributes = getValue(attributes);
            if (!isObject(attributes)) ref2 = [
                attributes,
                text
            ], text = ref2[0], attributes = ref2[1];
            this.currentNode = new XMLElement(this, name, attributes);
            this.currentNode.children = false;
            this.currentLevel++;
            this.openTags[this.currentLevel] = this.currentNode;
            if (text != null) this.text(text);
            return this;
        };
        XMLDocumentCB.prototype.element = function(name, attributes, text) {
            if (this.currentNode && this.currentNode instanceof XMLDocType) return this.dtdElement.apply(this, arguments);
            else return this.node(name, attributes, text);
        };
        XMLDocumentCB.prototype.attribute = function(name, value) {
            var attName, attValue;
            if (!this.currentNode || this.currentNode.children) throw new Error("att() can only be used immediately after an ele() call in callback mode. " + this.debugInfo(name));
            if (name != null) name = getValue(name);
            if (isObject(name)) for(attName in name){
                if (!hasProp.call(name, attName)) continue;
                attValue = name[attName];
                this.attribute(attName, attValue);
            }
            else {
                if (isFunction(value)) value = value.apply();
                if (!this.options.skipNullAttributes || value != null) this.currentNode.attributes[name] = new XMLAttribute(this, name, value);
            }
            return this;
        };
        XMLDocumentCB.prototype.text = function(value) {
            var node;
            this.openCurrent();
            node = new XMLText(this, value);
            this.onData(this.writer.text(node, this.currentLevel + 1), this.currentLevel + 1);
            return this;
        };
        XMLDocumentCB.prototype.cdata = function(value) {
            var node;
            this.openCurrent();
            node = new XMLCData(this, value);
            this.onData(this.writer.cdata(node, this.currentLevel + 1), this.currentLevel + 1);
            return this;
        };
        XMLDocumentCB.prototype.comment = function(value) {
            var node;
            this.openCurrent();
            node = new XMLComment(this, value);
            this.onData(this.writer.comment(node, this.currentLevel + 1), this.currentLevel + 1);
            return this;
        };
        XMLDocumentCB.prototype.raw = function(value) {
            var node;
            this.openCurrent();
            node = new XMLRaw(this, value);
            this.onData(this.writer.raw(node, this.currentLevel + 1), this.currentLevel + 1);
            return this;
        };
        XMLDocumentCB.prototype.instruction = function(target, value) {
            var i, insTarget, insValue, len, node;
            this.openCurrent();
            if (target != null) target = getValue(target);
            if (value != null) value = getValue(value);
            if (Array.isArray(target)) for(i = 0, len = target.length; i < len; i++){
                insTarget = target[i];
                this.instruction(insTarget);
            }
            else if (isObject(target)) for(insTarget in target){
                if (!hasProp.call(target, insTarget)) continue;
                insValue = target[insTarget];
                this.instruction(insTarget, insValue);
            }
            else {
                if (isFunction(value)) value = value.apply();
                node = new XMLProcessingInstruction(this, target, value);
                this.onData(this.writer.processingInstruction(node, this.currentLevel + 1), this.currentLevel + 1);
            }
            return this;
        };
        XMLDocumentCB.prototype.declaration = function(version, encoding, standalone) {
            var node;
            this.openCurrent();
            if (this.documentStarted) throw new Error("declaration() must be the first node.");
            node = new XMLDeclaration(this, version, encoding, standalone);
            this.onData(this.writer.declaration(node, this.currentLevel + 1), this.currentLevel + 1);
            return this;
        };
        XMLDocumentCB.prototype.doctype = function(root, pubID, sysID) {
            this.openCurrent();
            if (root == null) throw new Error("Missing root node name.");
            if (this.root) throw new Error("dtd() must come before the root node.");
            this.currentNode = new XMLDocType(this, pubID, sysID);
            this.currentNode.rootNodeName = root;
            this.currentNode.children = false;
            this.currentLevel++;
            this.openTags[this.currentLevel] = this.currentNode;
            return this;
        };
        XMLDocumentCB.prototype.dtdElement = function(name, value) {
            var node;
            this.openCurrent();
            node = new XMLDTDElement(this, name, value);
            this.onData(this.writer.dtdElement(node, this.currentLevel + 1), this.currentLevel + 1);
            return this;
        };
        XMLDocumentCB.prototype.attList = function(elementName, attributeName, attributeType, defaultValueType, defaultValue) {
            var node;
            this.openCurrent();
            node = new XMLDTDAttList(this, elementName, attributeName, attributeType, defaultValueType, defaultValue);
            this.onData(this.writer.dtdAttList(node, this.currentLevel + 1), this.currentLevel + 1);
            return this;
        };
        XMLDocumentCB.prototype.entity = function(name, value) {
            var node;
            this.openCurrent();
            node = new XMLDTDEntity(this, false, name, value);
            this.onData(this.writer.dtdEntity(node, this.currentLevel + 1), this.currentLevel + 1);
            return this;
        };
        XMLDocumentCB.prototype.pEntity = function(name, value) {
            var node;
            this.openCurrent();
            node = new XMLDTDEntity(this, true, name, value);
            this.onData(this.writer.dtdEntity(node, this.currentLevel + 1), this.currentLevel + 1);
            return this;
        };
        XMLDocumentCB.prototype.notation = function(name, value) {
            var node;
            this.openCurrent();
            node = new XMLDTDNotation(this, name, value);
            this.onData(this.writer.dtdNotation(node, this.currentLevel + 1), this.currentLevel + 1);
            return this;
        };
        XMLDocumentCB.prototype.up = function() {
            if (this.currentLevel < 0) throw new Error("The document node has no parent.");
            if (this.currentNode) {
                if (this.currentNode.children) this.closeNode(this.currentNode);
                else this.openNode(this.currentNode);
                this.currentNode = null;
            } else this.closeNode(this.openTags[this.currentLevel]);
            delete this.openTags[this.currentLevel];
            this.currentLevel--;
            return this;
        };
        XMLDocumentCB.prototype.end = function() {
            while(this.currentLevel >= 0)this.up();
            return this.onEnd();
        };
        XMLDocumentCB.prototype.openCurrent = function() {
            if (this.currentNode) {
                this.currentNode.children = true;
                return this.openNode(this.currentNode);
            }
        };
        XMLDocumentCB.prototype.openNode = function(node) {
            if (!node.isOpen) {
                if (!this.root && this.currentLevel === 0 && node instanceof XMLElement) this.root = node;
                this.onData(this.writer.openNode(node, this.currentLevel), this.currentLevel);
                return node.isOpen = true;
            }
        };
        XMLDocumentCB.prototype.closeNode = function(node) {
            if (!node.isClosed) {
                this.onData(this.writer.closeNode(node, this.currentLevel), this.currentLevel);
                return node.isClosed = true;
            }
        };
        XMLDocumentCB.prototype.onData = function(chunk, level) {
            this.documentStarted = true;
            return this.onDataCallback(chunk, level + 1);
        };
        XMLDocumentCB.prototype.onEnd = function() {
            this.documentCompleted = true;
            return this.onEndCallback();
        };
        XMLDocumentCB.prototype.debugInfo = function(name) {
            if (name == null) return "";
            else return "node: <" + name + ">";
        };
        XMLDocumentCB.prototype.ele = function() {
            return this.element.apply(this, arguments);
        };
        XMLDocumentCB.prototype.nod = function(name, attributes, text) {
            return this.node(name, attributes, text);
        };
        XMLDocumentCB.prototype.txt = function(value) {
            return this.text(value);
        };
        XMLDocumentCB.prototype.dat = function(value) {
            return this.cdata(value);
        };
        XMLDocumentCB.prototype.com = function(value) {
            return this.comment(value);
        };
        XMLDocumentCB.prototype.ins = function(target, value) {
            return this.instruction(target, value);
        };
        XMLDocumentCB.prototype.dec = function(version, encoding, standalone) {
            return this.declaration(version, encoding, standalone);
        };
        XMLDocumentCB.prototype.dtd = function(root, pubID, sysID) {
            return this.doctype(root, pubID, sysID);
        };
        XMLDocumentCB.prototype.e = function(name, attributes, text) {
            return this.element(name, attributes, text);
        };
        XMLDocumentCB.prototype.n = function(name, attributes, text) {
            return this.node(name, attributes, text);
        };
        XMLDocumentCB.prototype.t = function(value) {
            return this.text(value);
        };
        XMLDocumentCB.prototype.d = function(value) {
            return this.cdata(value);
        };
        XMLDocumentCB.prototype.c = function(value) {
            return this.comment(value);
        };
        XMLDocumentCB.prototype.r = function(value) {
            return this.raw(value);
        };
        XMLDocumentCB.prototype.i = function(target, value) {
            return this.instruction(target, value);
        };
        XMLDocumentCB.prototype.att = function() {
            if (this.currentNode && this.currentNode instanceof XMLDocType) return this.attList.apply(this, arguments);
            else return this.attribute.apply(this, arguments);
        };
        XMLDocumentCB.prototype.a = function() {
            if (this.currentNode && this.currentNode instanceof XMLDocType) return this.attList.apply(this, arguments);
            else return this.attribute.apply(this, arguments);
        };
        XMLDocumentCB.prototype.ent = function(name, value) {
            return this.entity(name, value);
        };
        XMLDocumentCB.prototype.pent = function(name, value) {
            return this.pEntity(name, value);
        };
        XMLDocumentCB.prototype.not = function(name, value) {
            return this.notation(name, value);
        };
        return XMLDocumentCB;
    }();
}).call(module.exports);

});

parcelRegister("9ZWoi", function(module, exports) {














// Generated by CoffeeScript 1.12.7
(function() {
    var XMLCData, XMLComment, XMLDTDAttList, XMLDTDElement, XMLDTDEntity, XMLDTDNotation, XMLDeclaration, XMLDocType, XMLDummy, XMLElement, XMLProcessingInstruction, XMLRaw, XMLStreamWriter, XMLText, XMLWriterBase, extend = function(child, parent) {
        for(var key in parent)if (hasProp.call(parent, key)) child[key] = parent[key];
        function ctor() {
            this.constructor = child;
        }
        ctor.prototype = parent.prototype;
        child.prototype = new ctor();
        child.__super__ = parent.prototype;
        return child;
    }, hasProp = {}.hasOwnProperty;
    XMLDeclaration = (parcelRequire("hIqqu"));
    XMLDocType = (parcelRequire("8SEjQ"));
    XMLCData = (parcelRequire("fR48K"));
    XMLComment = (parcelRequire("hoAyy"));
    XMLElement = (parcelRequire("75p21"));
    XMLRaw = (parcelRequire("eM366"));
    XMLText = (parcelRequire("cVqM2"));
    XMLProcessingInstruction = (parcelRequire("fDRfY"));
    XMLDummy = (parcelRequire("5k1kJ"));
    XMLDTDAttList = (parcelRequire("2p5ir"));
    XMLDTDElement = (parcelRequire("7tdGF"));
    XMLDTDEntity = (parcelRequire("1skwc"));
    XMLDTDNotation = (parcelRequire("7o9kV"));
    XMLWriterBase = (parcelRequire("3pyEP"));
    module.exports = XMLStreamWriter = function(superClass) {
        extend(XMLStreamWriter, superClass);
        function XMLStreamWriter(stream, options) {
            XMLStreamWriter.__super__.constructor.call(this, options);
            this.stream = stream;
        }
        XMLStreamWriter.prototype.document = function(doc) {
            var child, i, j, len, len1, ref, ref1, results;
            ref = doc.children;
            for(i = 0, len = ref.length; i < len; i++){
                child = ref[i];
                child.isLastRootNode = false;
            }
            doc.children[doc.children.length - 1].isLastRootNode = true;
            ref1 = doc.children;
            results = [];
            for(j = 0, len1 = ref1.length; j < len1; j++){
                child = ref1[j];
                if (child instanceof XMLDummy) continue;
                switch(false){
                    case !(child instanceof XMLDeclaration):
                        results.push(this.declaration(child));
                        break;
                    case !(child instanceof XMLDocType):
                        results.push(this.docType(child));
                        break;
                    case !(child instanceof XMLComment):
                        results.push(this.comment(child));
                        break;
                    case !(child instanceof XMLProcessingInstruction):
                        results.push(this.processingInstruction(child));
                        break;
                    default:
                        results.push(this.element(child));
                }
            }
            return results;
        };
        XMLStreamWriter.prototype.attribute = function(att) {
            return this.stream.write(' ' + att.name + '="' + att.value + '"');
        };
        XMLStreamWriter.prototype.cdata = function(node, level) {
            return this.stream.write(this.space(level) + '<![CDATA[' + node.text + ']]>' + this.endline(node));
        };
        XMLStreamWriter.prototype.comment = function(node, level) {
            return this.stream.write(this.space(level) + '<!-- ' + node.text + ' -->' + this.endline(node));
        };
        XMLStreamWriter.prototype.declaration = function(node, level) {
            this.stream.write(this.space(level));
            this.stream.write('<?xml version="' + node.version + '"');
            if (node.encoding != null) this.stream.write(' encoding="' + node.encoding + '"');
            if (node.standalone != null) this.stream.write(' standalone="' + node.standalone + '"');
            this.stream.write(this.spacebeforeslash + '?>');
            return this.stream.write(this.endline(node));
        };
        XMLStreamWriter.prototype.docType = function(node, level) {
            var child, i, len, ref;
            level || (level = 0);
            this.stream.write(this.space(level));
            this.stream.write('<!DOCTYPE ' + node.root().name);
            if (node.pubID && node.sysID) this.stream.write(' PUBLIC "' + node.pubID + '" "' + node.sysID + '"');
            else if (node.sysID) this.stream.write(' SYSTEM "' + node.sysID + '"');
            if (node.children.length > 0) {
                this.stream.write(' [');
                this.stream.write(this.endline(node));
                ref = node.children;
                for(i = 0, len = ref.length; i < len; i++){
                    child = ref[i];
                    switch(false){
                        case !(child instanceof XMLDTDAttList):
                            this.dtdAttList(child, level + 1);
                            break;
                        case !(child instanceof XMLDTDElement):
                            this.dtdElement(child, level + 1);
                            break;
                        case !(child instanceof XMLDTDEntity):
                            this.dtdEntity(child, level + 1);
                            break;
                        case !(child instanceof XMLDTDNotation):
                            this.dtdNotation(child, level + 1);
                            break;
                        case !(child instanceof XMLCData):
                            this.cdata(child, level + 1);
                            break;
                        case !(child instanceof XMLComment):
                            this.comment(child, level + 1);
                            break;
                        case !(child instanceof XMLProcessingInstruction):
                            this.processingInstruction(child, level + 1);
                            break;
                        default:
                            throw new Error("Unknown DTD node type: " + child.constructor.name);
                    }
                }
                this.stream.write(']');
            }
            this.stream.write(this.spacebeforeslash + '>');
            return this.stream.write(this.endline(node));
        };
        XMLStreamWriter.prototype.element = function(node, level) {
            var att, child, i, len, name, ref, ref1, space;
            level || (level = 0);
            space = this.space(level);
            this.stream.write(space + '<' + node.name);
            ref = node.attributes;
            for(name in ref){
                if (!hasProp.call(ref, name)) continue;
                att = ref[name];
                this.attribute(att);
            }
            if (node.children.length === 0 || node.children.every(function(e) {
                return e.value === '';
            })) {
                if (this.allowEmpty) this.stream.write('></' + node.name + '>');
                else this.stream.write(this.spacebeforeslash + '/>');
            } else if (this.pretty && node.children.length === 1 && node.children[0].value != null) {
                this.stream.write('>');
                this.stream.write(node.children[0].value);
                this.stream.write('</' + node.name + '>');
            } else {
                this.stream.write('>' + this.newline);
                ref1 = node.children;
                for(i = 0, len = ref1.length; i < len; i++){
                    child = ref1[i];
                    switch(false){
                        case !(child instanceof XMLCData):
                            this.cdata(child, level + 1);
                            break;
                        case !(child instanceof XMLComment):
                            this.comment(child, level + 1);
                            break;
                        case !(child instanceof XMLElement):
                            this.element(child, level + 1);
                            break;
                        case !(child instanceof XMLRaw):
                            this.raw(child, level + 1);
                            break;
                        case !(child instanceof XMLText):
                            this.text(child, level + 1);
                            break;
                        case !(child instanceof XMLProcessingInstruction):
                            this.processingInstruction(child, level + 1);
                            break;
                        case !(child instanceof XMLDummy):
                            '';
                            break;
                        default:
                            throw new Error("Unknown XML node type: " + child.constructor.name);
                    }
                }
                this.stream.write(space + '</' + node.name + '>');
            }
            return this.stream.write(this.endline(node));
        };
        XMLStreamWriter.prototype.processingInstruction = function(node, level) {
            this.stream.write(this.space(level) + '<?' + node.target);
            if (node.value) this.stream.write(' ' + node.value);
            return this.stream.write(this.spacebeforeslash + '?>' + this.endline(node));
        };
        XMLStreamWriter.prototype.raw = function(node, level) {
            return this.stream.write(this.space(level) + node.value + this.endline(node));
        };
        XMLStreamWriter.prototype.text = function(node, level) {
            return this.stream.write(this.space(level) + node.value + this.endline(node));
        };
        XMLStreamWriter.prototype.dtdAttList = function(node, level) {
            this.stream.write(this.space(level) + '<!ATTLIST ' + node.elementName + ' ' + node.attributeName + ' ' + node.attributeType);
            if (node.defaultValueType !== '#DEFAULT') this.stream.write(' ' + node.defaultValueType);
            if (node.defaultValue) this.stream.write(' "' + node.defaultValue + '"');
            return this.stream.write(this.spacebeforeslash + '>' + this.endline(node));
        };
        XMLStreamWriter.prototype.dtdElement = function(node, level) {
            this.stream.write(this.space(level) + '<!ELEMENT ' + node.name + ' ' + node.value);
            return this.stream.write(this.spacebeforeslash + '>' + this.endline(node));
        };
        XMLStreamWriter.prototype.dtdEntity = function(node, level) {
            this.stream.write(this.space(level) + '<!ENTITY');
            if (node.pe) this.stream.write(' %');
            this.stream.write(' ' + node.name);
            if (node.value) this.stream.write(' "' + node.value + '"');
            else {
                if (node.pubID && node.sysID) this.stream.write(' PUBLIC "' + node.pubID + '" "' + node.sysID + '"');
                else if (node.sysID) this.stream.write(' SYSTEM "' + node.sysID + '"');
                if (node.nData) this.stream.write(' NDATA ' + node.nData);
            }
            return this.stream.write(this.spacebeforeslash + '>' + this.endline(node));
        };
        XMLStreamWriter.prototype.dtdNotation = function(node, level) {
            this.stream.write(this.space(level) + '<!NOTATION ' + node.name);
            if (node.pubID && node.sysID) this.stream.write(' PUBLIC "' + node.pubID + '" "' + node.sysID + '"');
            else if (node.pubID) this.stream.write(' PUBLIC "' + node.pubID + '"');
            else if (node.sysID) this.stream.write(' SYSTEM "' + node.sysID + '"');
            return this.stream.write(this.spacebeforeslash + '>' + this.endline(node));
        };
        XMLStreamWriter.prototype.endline = function(node) {
            if (!node.isLastRootNode) return this.newline;
            else return '';
        };
        return XMLStreamWriter;
    }(XMLWriterBase);
}).call(module.exports);

});



parcelRegister("jKsvD", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $e6086d8520c6d42a$var$dingbats = [
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "32",
        "Dingbat hex": "20",
        "Unicode dec": "32",
        "Unicode hex": "20"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "33",
        "Dingbat hex": "21",
        "Unicode dec": "33",
        "Unicode hex": "21"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "34",
        "Dingbat hex": "22",
        "Unicode dec": "8704",
        "Unicode hex": "2200"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "35",
        "Dingbat hex": "23",
        "Unicode dec": "35",
        "Unicode hex": "23"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "36",
        "Dingbat hex": "24",
        "Unicode dec": "8707",
        "Unicode hex": "2203"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "37",
        "Dingbat hex": "25",
        "Unicode dec": "37",
        "Unicode hex": "25"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "38",
        "Dingbat hex": "26",
        "Unicode dec": "38",
        "Unicode hex": "26"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "39",
        "Dingbat hex": "27",
        "Unicode dec": "8717",
        "Unicode hex": "220D"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "40",
        "Dingbat hex": "28",
        "Unicode dec": "40",
        "Unicode hex": "28"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "41",
        "Dingbat hex": "29",
        "Unicode dec": "41",
        "Unicode hex": "29"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "42",
        "Dingbat hex": "2A",
        "Unicode dec": "42",
        "Unicode hex": "2A"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "43",
        "Dingbat hex": "2B",
        "Unicode dec": "43",
        "Unicode hex": "2B"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "44",
        "Dingbat hex": "2C",
        "Unicode dec": "44",
        "Unicode hex": "2C"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "45",
        "Dingbat hex": "2D",
        "Unicode dec": "8722",
        "Unicode hex": "2212"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "46",
        "Dingbat hex": "2E",
        "Unicode dec": "46",
        "Unicode hex": "2E"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "47",
        "Dingbat hex": "2F",
        "Unicode dec": "47",
        "Unicode hex": "2F"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "48",
        "Dingbat hex": "30",
        "Unicode dec": "48",
        "Unicode hex": "30"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "49",
        "Dingbat hex": "31",
        "Unicode dec": "49",
        "Unicode hex": "31"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "50",
        "Dingbat hex": "32",
        "Unicode dec": "50",
        "Unicode hex": "32"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "51",
        "Dingbat hex": "33",
        "Unicode dec": "51",
        "Unicode hex": "33"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "52",
        "Dingbat hex": "34",
        "Unicode dec": "52",
        "Unicode hex": "34"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "53",
        "Dingbat hex": "35",
        "Unicode dec": "53",
        "Unicode hex": "35"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "54",
        "Dingbat hex": "36",
        "Unicode dec": "54",
        "Unicode hex": "36"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "55",
        "Dingbat hex": "37",
        "Unicode dec": "55",
        "Unicode hex": "37"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "56",
        "Dingbat hex": "38",
        "Unicode dec": "56",
        "Unicode hex": "38"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "57",
        "Dingbat hex": "39",
        "Unicode dec": "57",
        "Unicode hex": "39"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "58",
        "Dingbat hex": "3A",
        "Unicode dec": "58",
        "Unicode hex": "3A"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "59",
        "Dingbat hex": "3B",
        "Unicode dec": "59",
        "Unicode hex": "3B"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "60",
        "Dingbat hex": "3C",
        "Unicode dec": "60",
        "Unicode hex": "3C"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "61",
        "Dingbat hex": "3D",
        "Unicode dec": "61",
        "Unicode hex": "3D"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "62",
        "Dingbat hex": "3E",
        "Unicode dec": "62",
        "Unicode hex": "3E"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "63",
        "Dingbat hex": "3F",
        "Unicode dec": "63",
        "Unicode hex": "3F"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "64",
        "Dingbat hex": "40",
        "Unicode dec": "8773",
        "Unicode hex": "2245"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "65",
        "Dingbat hex": "41",
        "Unicode dec": "913",
        "Unicode hex": "391"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "66",
        "Dingbat hex": "42",
        "Unicode dec": "914",
        "Unicode hex": "392"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "67",
        "Dingbat hex": "43",
        "Unicode dec": "935",
        "Unicode hex": "3A7"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "68",
        "Dingbat hex": "44",
        "Unicode dec": "916",
        "Unicode hex": "394"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "69",
        "Dingbat hex": "45",
        "Unicode dec": "917",
        "Unicode hex": "395"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "70",
        "Dingbat hex": "46",
        "Unicode dec": "934",
        "Unicode hex": "3A6"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "71",
        "Dingbat hex": "47",
        "Unicode dec": "915",
        "Unicode hex": "393"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "72",
        "Dingbat hex": "48",
        "Unicode dec": "919",
        "Unicode hex": "397"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "73",
        "Dingbat hex": "49",
        "Unicode dec": "921",
        "Unicode hex": "399"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "74",
        "Dingbat hex": "4A",
        "Unicode dec": "977",
        "Unicode hex": "3D1"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "75",
        "Dingbat hex": "4B",
        "Unicode dec": "922",
        "Unicode hex": "39A"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "76",
        "Dingbat hex": "4C",
        "Unicode dec": "923",
        "Unicode hex": "39B"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "77",
        "Dingbat hex": "4D",
        "Unicode dec": "924",
        "Unicode hex": "39C"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "78",
        "Dingbat hex": "4E",
        "Unicode dec": "925",
        "Unicode hex": "39D"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "79",
        "Dingbat hex": "4F",
        "Unicode dec": "927",
        "Unicode hex": "39F"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "80",
        "Dingbat hex": "50",
        "Unicode dec": "928",
        "Unicode hex": "3A0"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "81",
        "Dingbat hex": "51",
        "Unicode dec": "920",
        "Unicode hex": "398"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "82",
        "Dingbat hex": "52",
        "Unicode dec": "929",
        "Unicode hex": "3A1"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "83",
        "Dingbat hex": "53",
        "Unicode dec": "931",
        "Unicode hex": "3A3"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "84",
        "Dingbat hex": "54",
        "Unicode dec": "932",
        "Unicode hex": "3A4"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "85",
        "Dingbat hex": "55",
        "Unicode dec": "933",
        "Unicode hex": "3A5"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "86",
        "Dingbat hex": "56",
        "Unicode dec": "962",
        "Unicode hex": "3C2"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "87",
        "Dingbat hex": "57",
        "Unicode dec": "937",
        "Unicode hex": "3A9"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "88",
        "Dingbat hex": "58",
        "Unicode dec": "926",
        "Unicode hex": "39E"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "89",
        "Dingbat hex": "59",
        "Unicode dec": "936",
        "Unicode hex": "3A8"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "90",
        "Dingbat hex": "5A",
        "Unicode dec": "918",
        "Unicode hex": "396"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "91",
        "Dingbat hex": "5B",
        "Unicode dec": "91",
        "Unicode hex": "5B"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "92",
        "Dingbat hex": "5C",
        "Unicode dec": "8756",
        "Unicode hex": "2234"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "93",
        "Dingbat hex": "5D",
        "Unicode dec": "93",
        "Unicode hex": "5D"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "94",
        "Dingbat hex": "5E",
        "Unicode dec": "8869",
        "Unicode hex": "22A5"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "95",
        "Dingbat hex": "5F",
        "Unicode dec": "95",
        "Unicode hex": "5F"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "96",
        "Dingbat hex": "60",
        "Unicode dec": "8254",
        "Unicode hex": "203E"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "97",
        "Dingbat hex": "61",
        "Unicode dec": "945",
        "Unicode hex": "3B1"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "98",
        "Dingbat hex": "62",
        "Unicode dec": "946",
        "Unicode hex": "3B2"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "99",
        "Dingbat hex": "63",
        "Unicode dec": "967",
        "Unicode hex": "3C7"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "100",
        "Dingbat hex": "64",
        "Unicode dec": "948",
        "Unicode hex": "3B4"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "101",
        "Dingbat hex": "65",
        "Unicode dec": "949",
        "Unicode hex": "3B5"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "102",
        "Dingbat hex": "66",
        "Unicode dec": "966",
        "Unicode hex": "3C6"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "103",
        "Dingbat hex": "67",
        "Unicode dec": "947",
        "Unicode hex": "3B3"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "104",
        "Dingbat hex": "68",
        "Unicode dec": "951",
        "Unicode hex": "3B7"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "105",
        "Dingbat hex": "69",
        "Unicode dec": "953",
        "Unicode hex": "3B9"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "106",
        "Dingbat hex": "6A",
        "Unicode dec": "981",
        "Unicode hex": "3D5"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "107",
        "Dingbat hex": "6B",
        "Unicode dec": "954",
        "Unicode hex": "3BA"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "108",
        "Dingbat hex": "6C",
        "Unicode dec": "955",
        "Unicode hex": "3BB"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "109",
        "Dingbat hex": "6D",
        "Unicode dec": "956",
        "Unicode hex": "3BC"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "110",
        "Dingbat hex": "6E",
        "Unicode dec": "957",
        "Unicode hex": "3BD"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "111",
        "Dingbat hex": "6F",
        "Unicode dec": "959",
        "Unicode hex": "3BF"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "112",
        "Dingbat hex": "70",
        "Unicode dec": "960",
        "Unicode hex": "3C0"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "113",
        "Dingbat hex": "71",
        "Unicode dec": "952",
        "Unicode hex": "3B8"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "114",
        "Dingbat hex": "72",
        "Unicode dec": "961",
        "Unicode hex": "3C1"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "115",
        "Dingbat hex": "73",
        "Unicode dec": "963",
        "Unicode hex": "3C3"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "116",
        "Dingbat hex": "74",
        "Unicode dec": "964",
        "Unicode hex": "3C4"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "117",
        "Dingbat hex": "75",
        "Unicode dec": "965",
        "Unicode hex": "3C5"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "118",
        "Dingbat hex": "76",
        "Unicode dec": "982",
        "Unicode hex": "3D6"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "119",
        "Dingbat hex": "77",
        "Unicode dec": "969",
        "Unicode hex": "3C9"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "120",
        "Dingbat hex": "78",
        "Unicode dec": "958",
        "Unicode hex": "3BE"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "121",
        "Dingbat hex": "79",
        "Unicode dec": "968",
        "Unicode hex": "3C8"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "122",
        "Dingbat hex": "7A",
        "Unicode dec": "950",
        "Unicode hex": "3B6"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "123",
        "Dingbat hex": "7B",
        "Unicode dec": "123",
        "Unicode hex": "7B"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "124",
        "Dingbat hex": "7C",
        "Unicode dec": "124",
        "Unicode hex": "7C"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "125",
        "Dingbat hex": "7D",
        "Unicode dec": "125",
        "Unicode hex": "7D"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "126",
        "Dingbat hex": "7E",
        "Unicode dec": "126",
        "Unicode hex": "7E"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "160",
        "Dingbat hex": "A0",
        "Unicode dec": "8364",
        "Unicode hex": "20AC"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "161",
        "Dingbat hex": "A1",
        "Unicode dec": "978",
        "Unicode hex": "3D2"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "162",
        "Dingbat hex": "A2",
        "Unicode dec": "8242",
        "Unicode hex": "2032"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "163",
        "Dingbat hex": "A3",
        "Unicode dec": "8804",
        "Unicode hex": "2264"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "164",
        "Dingbat hex": "A4",
        "Unicode dec": "8260",
        "Unicode hex": "2044"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "165",
        "Dingbat hex": "A5",
        "Unicode dec": "8734",
        "Unicode hex": "221E"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "166",
        "Dingbat hex": "A6",
        "Unicode dec": "402",
        "Unicode hex": "192"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "167",
        "Dingbat hex": "A7",
        "Unicode dec": "9827",
        "Unicode hex": "2663"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "168",
        "Dingbat hex": "A8",
        "Unicode dec": "9830",
        "Unicode hex": "2666"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "169",
        "Dingbat hex": "A9",
        "Unicode dec": "9829",
        "Unicode hex": "2665"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "170",
        "Dingbat hex": "AA",
        "Unicode dec": "9824",
        "Unicode hex": "2660"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "171",
        "Dingbat hex": "AB",
        "Unicode dec": "8596",
        "Unicode hex": "2194"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "172",
        "Dingbat hex": "AC",
        "Unicode dec": "8592",
        "Unicode hex": "2190"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "173",
        "Dingbat hex": "AD",
        "Unicode dec": "8593",
        "Unicode hex": "2191"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "174",
        "Dingbat hex": "AE",
        "Unicode dec": "8594",
        "Unicode hex": "2192"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "175",
        "Dingbat hex": "AF",
        "Unicode dec": "8595",
        "Unicode hex": "2193"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "176",
        "Dingbat hex": "B0",
        "Unicode dec": "176",
        "Unicode hex": "B0"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "177",
        "Dingbat hex": "B1",
        "Unicode dec": "177",
        "Unicode hex": "B1"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "178",
        "Dingbat hex": "B2",
        "Unicode dec": "8243",
        "Unicode hex": "2033"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "179",
        "Dingbat hex": "B3",
        "Unicode dec": "8805",
        "Unicode hex": "2265"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "180",
        "Dingbat hex": "B4",
        "Unicode dec": "215",
        "Unicode hex": "D7"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "181",
        "Dingbat hex": "B5",
        "Unicode dec": "8733",
        "Unicode hex": "221D"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "182",
        "Dingbat hex": "B6",
        "Unicode dec": "8706",
        "Unicode hex": "2202"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "183",
        "Dingbat hex": "B7",
        "Unicode dec": "8226",
        "Unicode hex": "2022"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "184",
        "Dingbat hex": "B8",
        "Unicode dec": "247",
        "Unicode hex": "F7"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "185",
        "Dingbat hex": "B9",
        "Unicode dec": "8800",
        "Unicode hex": "2260"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "186",
        "Dingbat hex": "BA",
        "Unicode dec": "8801",
        "Unicode hex": "2261"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "187",
        "Dingbat hex": "BB",
        "Unicode dec": "8776",
        "Unicode hex": "2248"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "188",
        "Dingbat hex": "BC",
        "Unicode dec": "8230",
        "Unicode hex": "2026"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "189",
        "Dingbat hex": "BD",
        "Unicode dec": "9168",
        "Unicode hex": "23D0"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "190",
        "Dingbat hex": "BE",
        "Unicode dec": "9135",
        "Unicode hex": "23AF"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "191",
        "Dingbat hex": "BF",
        "Unicode dec": "8629",
        "Unicode hex": "21B5"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "192",
        "Dingbat hex": "C0",
        "Unicode dec": "8501",
        "Unicode hex": "2135"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "193",
        "Dingbat hex": "C1",
        "Unicode dec": "8465",
        "Unicode hex": "2111"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "194",
        "Dingbat hex": "C2",
        "Unicode dec": "8476",
        "Unicode hex": "211C"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "195",
        "Dingbat hex": "C3",
        "Unicode dec": "8472",
        "Unicode hex": "2118"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "196",
        "Dingbat hex": "C4",
        "Unicode dec": "8855",
        "Unicode hex": "2297"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "197",
        "Dingbat hex": "C5",
        "Unicode dec": "8853",
        "Unicode hex": "2295"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "198",
        "Dingbat hex": "C6",
        "Unicode dec": "8709",
        "Unicode hex": "2205"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "199",
        "Dingbat hex": "C7",
        "Unicode dec": "8745",
        "Unicode hex": "2229"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "200",
        "Dingbat hex": "C8",
        "Unicode dec": "8746",
        "Unicode hex": "222A"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "201",
        "Dingbat hex": "C9",
        "Unicode dec": "8835",
        "Unicode hex": "2283"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "202",
        "Dingbat hex": "CA",
        "Unicode dec": "8839",
        "Unicode hex": "2287"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "203",
        "Dingbat hex": "CB",
        "Unicode dec": "8836",
        "Unicode hex": "2284"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "204",
        "Dingbat hex": "CC",
        "Unicode dec": "8834",
        "Unicode hex": "2282"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "205",
        "Dingbat hex": "CD",
        "Unicode dec": "8838",
        "Unicode hex": "2286"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "206",
        "Dingbat hex": "CE",
        "Unicode dec": "8712",
        "Unicode hex": "2208"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "207",
        "Dingbat hex": "CF",
        "Unicode dec": "8713",
        "Unicode hex": "2209"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "208",
        "Dingbat hex": "D0",
        "Unicode dec": "8736",
        "Unicode hex": "2220"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "209",
        "Dingbat hex": "D1",
        "Unicode dec": "8711",
        "Unicode hex": "2207"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "210",
        "Dingbat hex": "D2",
        "Unicode dec": "174",
        "Unicode hex": "AE"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "211",
        "Dingbat hex": "D3",
        "Unicode dec": "169",
        "Unicode hex": "A9"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "212",
        "Dingbat hex": "D4",
        "Unicode dec": "8482",
        "Unicode hex": "2122"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "213",
        "Dingbat hex": "D5",
        "Unicode dec": "8719",
        "Unicode hex": "220F"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "214",
        "Dingbat hex": "D6",
        "Unicode dec": "8730",
        "Unicode hex": "221A"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "215",
        "Dingbat hex": "D7",
        "Unicode dec": "8901",
        "Unicode hex": "22C5"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "216",
        "Dingbat hex": "D8",
        "Unicode dec": "172",
        "Unicode hex": "AC"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "217",
        "Dingbat hex": "D9",
        "Unicode dec": "8743",
        "Unicode hex": "2227"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "218",
        "Dingbat hex": "DA",
        "Unicode dec": "8744",
        "Unicode hex": "2228"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "219",
        "Dingbat hex": "DB",
        "Unicode dec": "8660",
        "Unicode hex": "21D4"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "220",
        "Dingbat hex": "DC",
        "Unicode dec": "8656",
        "Unicode hex": "21D0"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "221",
        "Dingbat hex": "DD",
        "Unicode dec": "8657",
        "Unicode hex": "21D1"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "222",
        "Dingbat hex": "DE",
        "Unicode dec": "8658",
        "Unicode hex": "21D2"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "223",
        "Dingbat hex": "DF",
        "Unicode dec": "8659",
        "Unicode hex": "21D3"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "224",
        "Dingbat hex": "E0",
        "Unicode dec": "9674",
        "Unicode hex": "25CA"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "225",
        "Dingbat hex": "E1",
        "Unicode dec": "12296",
        "Unicode hex": "3008"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "226",
        "Dingbat hex": "E2",
        "Unicode dec": "174",
        "Unicode hex": "AE"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "227",
        "Dingbat hex": "E3",
        "Unicode dec": "169",
        "Unicode hex": "A9"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "228",
        "Dingbat hex": "E4",
        "Unicode dec": "8482",
        "Unicode hex": "2122"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "229",
        "Dingbat hex": "E5",
        "Unicode dec": "8721",
        "Unicode hex": "2211"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "230",
        "Dingbat hex": "E6",
        "Unicode dec": "9115",
        "Unicode hex": "239B"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "231",
        "Dingbat hex": "E7",
        "Unicode dec": "9116",
        "Unicode hex": "239C"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "232",
        "Dingbat hex": "E8",
        "Unicode dec": "9117",
        "Unicode hex": "239D"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "233",
        "Dingbat hex": "E9",
        "Unicode dec": "9121",
        "Unicode hex": "23A1"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "234",
        "Dingbat hex": "EA",
        "Unicode dec": "9122",
        "Unicode hex": "23A2"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "235",
        "Dingbat hex": "EB",
        "Unicode dec": "9123",
        "Unicode hex": "23A3"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "236",
        "Dingbat hex": "EC",
        "Unicode dec": "9127",
        "Unicode hex": "23A7"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "237",
        "Dingbat hex": "ED",
        "Unicode dec": "9128",
        "Unicode hex": "23A8"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "238",
        "Dingbat hex": "EE",
        "Unicode dec": "9129",
        "Unicode hex": "23A9"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "239",
        "Dingbat hex": "EF",
        "Unicode dec": "9130",
        "Unicode hex": "23AA"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "240",
        "Dingbat hex": "F0",
        "Unicode dec": "63743",
        "Unicode hex": "F8FF"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "241",
        "Dingbat hex": "F1",
        "Unicode dec": "12297",
        "Unicode hex": "3009"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "242",
        "Dingbat hex": "F2",
        "Unicode dec": "8747",
        "Unicode hex": "222B"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "243",
        "Dingbat hex": "F3",
        "Unicode dec": "8992",
        "Unicode hex": "2320"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "244",
        "Dingbat hex": "F4",
        "Unicode dec": "9134",
        "Unicode hex": "23AE"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "245",
        "Dingbat hex": "F5",
        "Unicode dec": "8993",
        "Unicode hex": "2321"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "246",
        "Dingbat hex": "F6",
        "Unicode dec": "9118",
        "Unicode hex": "239E"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "247",
        "Dingbat hex": "F7",
        "Unicode dec": "9119",
        "Unicode hex": "239F"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "248",
        "Dingbat hex": "F8",
        "Unicode dec": "9120",
        "Unicode hex": "23A0"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "249",
        "Dingbat hex": "F9",
        "Unicode dec": "9124",
        "Unicode hex": "23A4"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "250",
        "Dingbat hex": "FA",
        "Unicode dec": "9125",
        "Unicode hex": "23A5"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "251",
        "Dingbat hex": "FB",
        "Unicode dec": "9126",
        "Unicode hex": "23A6"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "252",
        "Dingbat hex": "FC",
        "Unicode dec": "9131",
        "Unicode hex": "23AB"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "253",
        "Dingbat hex": "FD",
        "Unicode dec": "9132",
        "Unicode hex": "23AC"
    },
    {
        "Typeface name": "Symbol",
        "Dingbat dec": "254",
        "Dingbat hex": "FE",
        "Unicode dec": "9133",
        "Unicode hex": "23AD"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "32",
        "Dingbat hex": "20",
        "Unicode dec": "32",
        "Unicode hex": "20"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "33",
        "Dingbat hex": "21",
        "Unicode dec": "128375",
        "Unicode hex": "1F577"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "34",
        "Dingbat hex": "22",
        "Unicode dec": "128376",
        "Unicode hex": "1F578"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "35",
        "Dingbat hex": "23",
        "Unicode dec": "128370",
        "Unicode hex": "1F572"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "36",
        "Dingbat hex": "24",
        "Unicode dec": "128374",
        "Unicode hex": "1F576"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "37",
        "Dingbat hex": "25",
        "Unicode dec": "127942",
        "Unicode hex": "1F3C6"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "38",
        "Dingbat hex": "26",
        "Unicode dec": "127894",
        "Unicode hex": "1F396"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "39",
        "Dingbat hex": "27",
        "Unicode dec": "128391",
        "Unicode hex": "1F587"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "40",
        "Dingbat hex": "28",
        "Unicode dec": "128488",
        "Unicode hex": "1F5E8"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "41",
        "Dingbat hex": "29",
        "Unicode dec": "128489",
        "Unicode hex": "1F5E9"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "42",
        "Dingbat hex": "2A",
        "Unicode dec": "128496",
        "Unicode hex": "1F5F0"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "43",
        "Dingbat hex": "2B",
        "Unicode dec": "128497",
        "Unicode hex": "1F5F1"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "44",
        "Dingbat hex": "2C",
        "Unicode dec": "127798",
        "Unicode hex": "1F336"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "45",
        "Dingbat hex": "2D",
        "Unicode dec": "127895",
        "Unicode hex": "1F397"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "46",
        "Dingbat hex": "2E",
        "Unicode dec": "128638",
        "Unicode hex": "1F67E"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "47",
        "Dingbat hex": "2F",
        "Unicode dec": "128636",
        "Unicode hex": "1F67C"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "48",
        "Dingbat hex": "30",
        "Unicode dec": "128469",
        "Unicode hex": "1F5D5"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "49",
        "Dingbat hex": "31",
        "Unicode dec": "128470",
        "Unicode hex": "1F5D6"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "50",
        "Dingbat hex": "32",
        "Unicode dec": "128471",
        "Unicode hex": "1F5D7"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "51",
        "Dingbat hex": "33",
        "Unicode dec": "9204",
        "Unicode hex": "23F4"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "52",
        "Dingbat hex": "34",
        "Unicode dec": "9205",
        "Unicode hex": "23F5"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "53",
        "Dingbat hex": "35",
        "Unicode dec": "9206",
        "Unicode hex": "23F6"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "54",
        "Dingbat hex": "36",
        "Unicode dec": "9207",
        "Unicode hex": "23F7"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "55",
        "Dingbat hex": "37",
        "Unicode dec": "9194",
        "Unicode hex": "23EA"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "56",
        "Dingbat hex": "38",
        "Unicode dec": "9193",
        "Unicode hex": "23E9"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "57",
        "Dingbat hex": "39",
        "Unicode dec": "9198",
        "Unicode hex": "23EE"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "58",
        "Dingbat hex": "3A",
        "Unicode dec": "9197",
        "Unicode hex": "23ED"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "59",
        "Dingbat hex": "3B",
        "Unicode dec": "9208",
        "Unicode hex": "23F8"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "60",
        "Dingbat hex": "3C",
        "Unicode dec": "9209",
        "Unicode hex": "23F9"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "61",
        "Dingbat hex": "3D",
        "Unicode dec": "9210",
        "Unicode hex": "23FA"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "62",
        "Dingbat hex": "3E",
        "Unicode dec": "128474",
        "Unicode hex": "1F5DA"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "63",
        "Dingbat hex": "3F",
        "Unicode dec": "128499",
        "Unicode hex": "1F5F3"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "64",
        "Dingbat hex": "40",
        "Unicode dec": "128736",
        "Unicode hex": "1F6E0"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "65",
        "Dingbat hex": "41",
        "Unicode dec": "127959",
        "Unicode hex": "1F3D7"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "66",
        "Dingbat hex": "42",
        "Unicode dec": "127960",
        "Unicode hex": "1F3D8"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "67",
        "Dingbat hex": "43",
        "Unicode dec": "127961",
        "Unicode hex": "1F3D9"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "68",
        "Dingbat hex": "44",
        "Unicode dec": "127962",
        "Unicode hex": "1F3DA"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "69",
        "Dingbat hex": "45",
        "Unicode dec": "127964",
        "Unicode hex": "1F3DC"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "70",
        "Dingbat hex": "46",
        "Unicode dec": "127981",
        "Unicode hex": "1F3ED"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "71",
        "Dingbat hex": "47",
        "Unicode dec": "127963",
        "Unicode hex": "1F3DB"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "72",
        "Dingbat hex": "48",
        "Unicode dec": "127968",
        "Unicode hex": "1F3E0"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "73",
        "Dingbat hex": "49",
        "Unicode dec": "127958",
        "Unicode hex": "1F3D6"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "74",
        "Dingbat hex": "4A",
        "Unicode dec": "127965",
        "Unicode hex": "1F3DD"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "75",
        "Dingbat hex": "4B",
        "Unicode dec": "128739",
        "Unicode hex": "1F6E3"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "76",
        "Dingbat hex": "4C",
        "Unicode dec": "128269",
        "Unicode hex": "1F50D"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "77",
        "Dingbat hex": "4D",
        "Unicode dec": "127956",
        "Unicode hex": "1F3D4"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "78",
        "Dingbat hex": "4E",
        "Unicode dec": "128065",
        "Unicode hex": "1F441"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "79",
        "Dingbat hex": "4F",
        "Unicode dec": "128066",
        "Unicode hex": "1F442"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "80",
        "Dingbat hex": "50",
        "Unicode dec": "127966",
        "Unicode hex": "1F3DE"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "81",
        "Dingbat hex": "51",
        "Unicode dec": "127957",
        "Unicode hex": "1F3D5"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "82",
        "Dingbat hex": "52",
        "Unicode dec": "128740",
        "Unicode hex": "1F6E4"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "83",
        "Dingbat hex": "53",
        "Unicode dec": "127967",
        "Unicode hex": "1F3DF"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "84",
        "Dingbat hex": "54",
        "Unicode dec": "128755",
        "Unicode hex": "1F6F3"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "85",
        "Dingbat hex": "55",
        "Unicode dec": "128364",
        "Unicode hex": "1F56C"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "86",
        "Dingbat hex": "56",
        "Unicode dec": "128363",
        "Unicode hex": "1F56B"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "87",
        "Dingbat hex": "57",
        "Unicode dec": "128360",
        "Unicode hex": "1F568"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "88",
        "Dingbat hex": "58",
        "Unicode dec": "128264",
        "Unicode hex": "1F508"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "89",
        "Dingbat hex": "59",
        "Unicode dec": "127892",
        "Unicode hex": "1F394"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "90",
        "Dingbat hex": "5A",
        "Unicode dec": "127893",
        "Unicode hex": "1F395"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "91",
        "Dingbat hex": "5B",
        "Unicode dec": "128492",
        "Unicode hex": "1F5EC"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "92",
        "Dingbat hex": "5C",
        "Unicode dec": "128637",
        "Unicode hex": "1F67D"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "93",
        "Dingbat hex": "5D",
        "Unicode dec": "128493",
        "Unicode hex": "1F5ED"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "94",
        "Dingbat hex": "5E",
        "Unicode dec": "128490",
        "Unicode hex": "1F5EA"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "95",
        "Dingbat hex": "5F",
        "Unicode dec": "128491",
        "Unicode hex": "1F5EB"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "96",
        "Dingbat hex": "60",
        "Unicode dec": "11156",
        "Unicode hex": "2B94"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "97",
        "Dingbat hex": "61",
        "Unicode dec": "10004",
        "Unicode hex": "2714"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "98",
        "Dingbat hex": "62",
        "Unicode dec": "128690",
        "Unicode hex": "1F6B2"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "99",
        "Dingbat hex": "63",
        "Unicode dec": "11036",
        "Unicode hex": "2B1C"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "100",
        "Dingbat hex": "64",
        "Unicode dec": "128737",
        "Unicode hex": "1F6E1"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "101",
        "Dingbat hex": "65",
        "Unicode dec": "128230",
        "Unicode hex": "1F4E6"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "102",
        "Dingbat hex": "66",
        "Unicode dec": "128753",
        "Unicode hex": "1F6F1"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "103",
        "Dingbat hex": "67",
        "Unicode dec": "11035",
        "Unicode hex": "2B1B"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "104",
        "Dingbat hex": "68",
        "Unicode dec": "128657",
        "Unicode hex": "1F691"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "105",
        "Dingbat hex": "69",
        "Unicode dec": "128712",
        "Unicode hex": "1F6C8"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "106",
        "Dingbat hex": "6A",
        "Unicode dec": "128745",
        "Unicode hex": "1F6E9"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "107",
        "Dingbat hex": "6B",
        "Unicode dec": "128752",
        "Unicode hex": "1F6F0"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "108",
        "Dingbat hex": "6C",
        "Unicode dec": "128968",
        "Unicode hex": "1F7C8"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "109",
        "Dingbat hex": "6D",
        "Unicode dec": "128372",
        "Unicode hex": "1F574"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "110",
        "Dingbat hex": "6E",
        "Unicode dec": "11044",
        "Unicode hex": "2B24"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "111",
        "Dingbat hex": "6F",
        "Unicode dec": "128741",
        "Unicode hex": "1F6E5"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "112",
        "Dingbat hex": "70",
        "Unicode dec": "128660",
        "Unicode hex": "1F694"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "113",
        "Dingbat hex": "71",
        "Unicode dec": "128472",
        "Unicode hex": "1F5D8"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "114",
        "Dingbat hex": "72",
        "Unicode dec": "128473",
        "Unicode hex": "1F5D9"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "115",
        "Dingbat hex": "73",
        "Unicode dec": "10067",
        "Unicode hex": "2753"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "116",
        "Dingbat hex": "74",
        "Unicode dec": "128754",
        "Unicode hex": "1F6F2"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "117",
        "Dingbat hex": "75",
        "Unicode dec": "128647",
        "Unicode hex": "1F687"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "118",
        "Dingbat hex": "76",
        "Unicode dec": "128653",
        "Unicode hex": "1F68D"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "119",
        "Dingbat hex": "77",
        "Unicode dec": "9971",
        "Unicode hex": "26F3"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "120",
        "Dingbat hex": "78",
        "Unicode dec": "10680",
        "Unicode hex": "29B8"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "121",
        "Dingbat hex": "79",
        "Unicode dec": "8854",
        "Unicode hex": "2296"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "122",
        "Dingbat hex": "7A",
        "Unicode dec": "128685",
        "Unicode hex": "1F6AD"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "123",
        "Dingbat hex": "7B",
        "Unicode dec": "128494",
        "Unicode hex": "1F5EE"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "124",
        "Dingbat hex": "7C",
        "Unicode dec": "9168",
        "Unicode hex": "23D0"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "125",
        "Dingbat hex": "7D",
        "Unicode dec": "128495",
        "Unicode hex": "1F5EF"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "126",
        "Dingbat hex": "7E",
        "Unicode dec": "128498",
        "Unicode hex": "1F5F2"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "128",
        "Dingbat hex": "80",
        "Unicode dec": "128697",
        "Unicode hex": "1F6B9"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "129",
        "Dingbat hex": "81",
        "Unicode dec": "128698",
        "Unicode hex": "1F6BA"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "130",
        "Dingbat hex": "82",
        "Unicode dec": "128713",
        "Unicode hex": "1F6C9"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "131",
        "Dingbat hex": "83",
        "Unicode dec": "128714",
        "Unicode hex": "1F6CA"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "132",
        "Dingbat hex": "84",
        "Unicode dec": "128700",
        "Unicode hex": "1F6BC"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "133",
        "Dingbat hex": "85",
        "Unicode dec": "128125",
        "Unicode hex": "1F47D"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "134",
        "Dingbat hex": "86",
        "Unicode dec": "127947",
        "Unicode hex": "1F3CB"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "135",
        "Dingbat hex": "87",
        "Unicode dec": "9975",
        "Unicode hex": "26F7"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "136",
        "Dingbat hex": "88",
        "Unicode dec": "127938",
        "Unicode hex": "1F3C2"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "137",
        "Dingbat hex": "89",
        "Unicode dec": "127948",
        "Unicode hex": "1F3CC"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "138",
        "Dingbat hex": "8A",
        "Unicode dec": "127946",
        "Unicode hex": "1F3CA"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "139",
        "Dingbat hex": "8B",
        "Unicode dec": "127940",
        "Unicode hex": "1F3C4"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "140",
        "Dingbat hex": "8C",
        "Unicode dec": "127949",
        "Unicode hex": "1F3CD"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "141",
        "Dingbat hex": "8D",
        "Unicode dec": "127950",
        "Unicode hex": "1F3CE"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "142",
        "Dingbat hex": "8E",
        "Unicode dec": "128664",
        "Unicode hex": "1F698"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "143",
        "Dingbat hex": "8F",
        "Unicode dec": "128480",
        "Unicode hex": "1F5E0"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "144",
        "Dingbat hex": "90",
        "Unicode dec": "128738",
        "Unicode hex": "1F6E2"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "145",
        "Dingbat hex": "91",
        "Unicode dec": "128176",
        "Unicode hex": "1F4B0"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "146",
        "Dingbat hex": "92",
        "Unicode dec": "127991",
        "Unicode hex": "1F3F7"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "147",
        "Dingbat hex": "93",
        "Unicode dec": "128179",
        "Unicode hex": "1F4B3"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "148",
        "Dingbat hex": "94",
        "Unicode dec": "128106",
        "Unicode hex": "1F46A"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "149",
        "Dingbat hex": "95",
        "Unicode dec": "128481",
        "Unicode hex": "1F5E1"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "150",
        "Dingbat hex": "96",
        "Unicode dec": "128482",
        "Unicode hex": "1F5E2"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "151",
        "Dingbat hex": "97",
        "Unicode dec": "128483",
        "Unicode hex": "1F5E3"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "152",
        "Dingbat hex": "98",
        "Unicode dec": "10031",
        "Unicode hex": "272F"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "153",
        "Dingbat hex": "99",
        "Unicode dec": "128388",
        "Unicode hex": "1F584"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "154",
        "Dingbat hex": "9A",
        "Unicode dec": "128389",
        "Unicode hex": "1F585"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "155",
        "Dingbat hex": "9B",
        "Unicode dec": "128387",
        "Unicode hex": "1F583"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "156",
        "Dingbat hex": "9C",
        "Unicode dec": "128390",
        "Unicode hex": "1F586"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "157",
        "Dingbat hex": "9D",
        "Unicode dec": "128441",
        "Unicode hex": "1F5B9"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "158",
        "Dingbat hex": "9E",
        "Unicode dec": "128442",
        "Unicode hex": "1F5BA"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "159",
        "Dingbat hex": "9F",
        "Unicode dec": "128443",
        "Unicode hex": "1F5BB"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "160",
        "Dingbat hex": "A0",
        "Unicode dec": "128373",
        "Unicode hex": "1F575"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "161",
        "Dingbat hex": "A1",
        "Unicode dec": "128368",
        "Unicode hex": "1F570"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "162",
        "Dingbat hex": "A2",
        "Unicode dec": "128445",
        "Unicode hex": "1F5BD"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "163",
        "Dingbat hex": "A3",
        "Unicode dec": "128446",
        "Unicode hex": "1F5BE"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "164",
        "Dingbat hex": "A4",
        "Unicode dec": "128203",
        "Unicode hex": "1F4CB"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "165",
        "Dingbat hex": "A5",
        "Unicode dec": "128466",
        "Unicode hex": "1F5D2"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "166",
        "Dingbat hex": "A6",
        "Unicode dec": "128467",
        "Unicode hex": "1F5D3"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "167",
        "Dingbat hex": "A7",
        "Unicode dec": "128366",
        "Unicode hex": "1F56E"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "168",
        "Dingbat hex": "A8",
        "Unicode dec": "128218",
        "Unicode hex": "1F4DA"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "169",
        "Dingbat hex": "A9",
        "Unicode dec": "128478",
        "Unicode hex": "1F5DE"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "170",
        "Dingbat hex": "AA",
        "Unicode dec": "128479",
        "Unicode hex": "1F5DF"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "171",
        "Dingbat hex": "AB",
        "Unicode dec": "128451",
        "Unicode hex": "1F5C3"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "172",
        "Dingbat hex": "AC",
        "Unicode dec": "128450",
        "Unicode hex": "1F5C2"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "173",
        "Dingbat hex": "AD",
        "Unicode dec": "128444",
        "Unicode hex": "1F5BC"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "174",
        "Dingbat hex": "AE",
        "Unicode dec": "127917",
        "Unicode hex": "1F3AD"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "175",
        "Dingbat hex": "AF",
        "Unicode dec": "127900",
        "Unicode hex": "1F39C"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "176",
        "Dingbat hex": "B0",
        "Unicode dec": "127896",
        "Unicode hex": "1F398"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "177",
        "Dingbat hex": "B1",
        "Unicode dec": "127897",
        "Unicode hex": "1F399"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "178",
        "Dingbat hex": "B2",
        "Unicode dec": "127911",
        "Unicode hex": "1F3A7"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "179",
        "Dingbat hex": "B3",
        "Unicode dec": "128191",
        "Unicode hex": "1F4BF"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "180",
        "Dingbat hex": "B4",
        "Unicode dec": "127902",
        "Unicode hex": "1F39E"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "181",
        "Dingbat hex": "B5",
        "Unicode dec": "128247",
        "Unicode hex": "1F4F7"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "182",
        "Dingbat hex": "B6",
        "Unicode dec": "127903",
        "Unicode hex": "1F39F"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "183",
        "Dingbat hex": "B7",
        "Unicode dec": "127916",
        "Unicode hex": "1F3AC"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "184",
        "Dingbat hex": "B8",
        "Unicode dec": "128253",
        "Unicode hex": "1F4FD"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "185",
        "Dingbat hex": "B9",
        "Unicode dec": "128249",
        "Unicode hex": "1F4F9"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "186",
        "Dingbat hex": "BA",
        "Unicode dec": "128254",
        "Unicode hex": "1F4FE"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "187",
        "Dingbat hex": "BB",
        "Unicode dec": "128251",
        "Unicode hex": "1F4FB"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "188",
        "Dingbat hex": "BC",
        "Unicode dec": "127898",
        "Unicode hex": "1F39A"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "189",
        "Dingbat hex": "BD",
        "Unicode dec": "127899",
        "Unicode hex": "1F39B"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "190",
        "Dingbat hex": "BE",
        "Unicode dec": "128250",
        "Unicode hex": "1F4FA"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "191",
        "Dingbat hex": "BF",
        "Unicode dec": "128187",
        "Unicode hex": "1F4BB"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "192",
        "Dingbat hex": "C0",
        "Unicode dec": "128421",
        "Unicode hex": "1F5A5"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "193",
        "Dingbat hex": "C1",
        "Unicode dec": "128422",
        "Unicode hex": "1F5A6"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "194",
        "Dingbat hex": "C2",
        "Unicode dec": "128423",
        "Unicode hex": "1F5A7"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "195",
        "Dingbat hex": "C3",
        "Unicode dec": "128377",
        "Unicode hex": "1F579"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "196",
        "Dingbat hex": "C4",
        "Unicode dec": "127918",
        "Unicode hex": "1F3AE"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "197",
        "Dingbat hex": "C5",
        "Unicode dec": "128379",
        "Unicode hex": "1F57B"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "198",
        "Dingbat hex": "C6",
        "Unicode dec": "128380",
        "Unicode hex": "1F57C"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "199",
        "Dingbat hex": "C7",
        "Unicode dec": "128223",
        "Unicode hex": "1F4DF"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "200",
        "Dingbat hex": "C8",
        "Unicode dec": "128385",
        "Unicode hex": "1F581"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "201",
        "Dingbat hex": "C9",
        "Unicode dec": "128384",
        "Unicode hex": "1F580"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "202",
        "Dingbat hex": "CA",
        "Unicode dec": "128424",
        "Unicode hex": "1F5A8"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "203",
        "Dingbat hex": "CB",
        "Unicode dec": "128425",
        "Unicode hex": "1F5A9"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "204",
        "Dingbat hex": "CC",
        "Unicode dec": "128447",
        "Unicode hex": "1F5BF"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "205",
        "Dingbat hex": "CD",
        "Unicode dec": "128426",
        "Unicode hex": "1F5AA"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "206",
        "Dingbat hex": "CE",
        "Unicode dec": "128476",
        "Unicode hex": "1F5DC"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "207",
        "Dingbat hex": "CF",
        "Unicode dec": "128274",
        "Unicode hex": "1F512"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "208",
        "Dingbat hex": "D0",
        "Unicode dec": "128275",
        "Unicode hex": "1F513"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "209",
        "Dingbat hex": "D1",
        "Unicode dec": "128477",
        "Unicode hex": "1F5DD"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "210",
        "Dingbat hex": "D2",
        "Unicode dec": "128229",
        "Unicode hex": "1F4E5"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "211",
        "Dingbat hex": "D3",
        "Unicode dec": "128228",
        "Unicode hex": "1F4E4"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "212",
        "Dingbat hex": "D4",
        "Unicode dec": "128371",
        "Unicode hex": "1F573"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "213",
        "Dingbat hex": "D5",
        "Unicode dec": "127779",
        "Unicode hex": "1F323"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "214",
        "Dingbat hex": "D6",
        "Unicode dec": "127780",
        "Unicode hex": "1F324"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "215",
        "Dingbat hex": "D7",
        "Unicode dec": "127781",
        "Unicode hex": "1F325"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "216",
        "Dingbat hex": "D8",
        "Unicode dec": "127782",
        "Unicode hex": "1F326"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "217",
        "Dingbat hex": "D9",
        "Unicode dec": "9729",
        "Unicode hex": "2601"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "218",
        "Dingbat hex": "DA",
        "Unicode dec": "127784",
        "Unicode hex": "1F328"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "219",
        "Dingbat hex": "DB",
        "Unicode dec": "127783",
        "Unicode hex": "1F327"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "220",
        "Dingbat hex": "DC",
        "Unicode dec": "127785",
        "Unicode hex": "1F329"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "221",
        "Dingbat hex": "DD",
        "Unicode dec": "127786",
        "Unicode hex": "1F32A"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "222",
        "Dingbat hex": "DE",
        "Unicode dec": "127788",
        "Unicode hex": "1F32C"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "223",
        "Dingbat hex": "DF",
        "Unicode dec": "127787",
        "Unicode hex": "1F32B"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "224",
        "Dingbat hex": "E0",
        "Unicode dec": "127772",
        "Unicode hex": "1F31C"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "225",
        "Dingbat hex": "E1",
        "Unicode dec": "127777",
        "Unicode hex": "1F321"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "226",
        "Dingbat hex": "E2",
        "Unicode dec": "128715",
        "Unicode hex": "1F6CB"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "227",
        "Dingbat hex": "E3",
        "Unicode dec": "128719",
        "Unicode hex": "1F6CF"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "228",
        "Dingbat hex": "E4",
        "Unicode dec": "127869",
        "Unicode hex": "1F37D"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "229",
        "Dingbat hex": "E5",
        "Unicode dec": "127864",
        "Unicode hex": "1F378"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "230",
        "Dingbat hex": "E6",
        "Unicode dec": "128718",
        "Unicode hex": "1F6CE"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "231",
        "Dingbat hex": "E7",
        "Unicode dec": "128717",
        "Unicode hex": "1F6CD"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "232",
        "Dingbat hex": "E8",
        "Unicode dec": "9413",
        "Unicode hex": "24C5"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "233",
        "Dingbat hex": "E9",
        "Unicode dec": "9855",
        "Unicode hex": "267F"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "234",
        "Dingbat hex": "EA",
        "Unicode dec": "128710",
        "Unicode hex": "1F6C6"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "235",
        "Dingbat hex": "EB",
        "Unicode dec": "128392",
        "Unicode hex": "1F588"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "236",
        "Dingbat hex": "EC",
        "Unicode dec": "127891",
        "Unicode hex": "1F393"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "237",
        "Dingbat hex": "ED",
        "Unicode dec": "128484",
        "Unicode hex": "1F5E4"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "238",
        "Dingbat hex": "EE",
        "Unicode dec": "128485",
        "Unicode hex": "1F5E5"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "239",
        "Dingbat hex": "EF",
        "Unicode dec": "128486",
        "Unicode hex": "1F5E6"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "240",
        "Dingbat hex": "F0",
        "Unicode dec": "128487",
        "Unicode hex": "1F5E7"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "241",
        "Dingbat hex": "F1",
        "Unicode dec": "128746",
        "Unicode hex": "1F6EA"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "242",
        "Dingbat hex": "F2",
        "Unicode dec": "128063",
        "Unicode hex": "1F43F"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "243",
        "Dingbat hex": "F3",
        "Unicode dec": "128038",
        "Unicode hex": "1F426"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "244",
        "Dingbat hex": "F4",
        "Unicode dec": "128031",
        "Unicode hex": "1F41F"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "245",
        "Dingbat hex": "F5",
        "Unicode dec": "128021",
        "Unicode hex": "1F415"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "246",
        "Dingbat hex": "F6",
        "Unicode dec": "128008",
        "Unicode hex": "1F408"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "247",
        "Dingbat hex": "F7",
        "Unicode dec": "128620",
        "Unicode hex": "1F66C"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "248",
        "Dingbat hex": "F8",
        "Unicode dec": "128622",
        "Unicode hex": "1F66E"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "249",
        "Dingbat hex": "F9",
        "Unicode dec": "128621",
        "Unicode hex": "1F66D"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "250",
        "Dingbat hex": "FA",
        "Unicode dec": "128623",
        "Unicode hex": "1F66F"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "251",
        "Dingbat hex": "FB",
        "Unicode dec": "128506",
        "Unicode hex": "1F5FA"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "252",
        "Dingbat hex": "FC",
        "Unicode dec": "127757",
        "Unicode hex": "1F30D"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "253",
        "Dingbat hex": "FD",
        "Unicode dec": "127759",
        "Unicode hex": "1F30F"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "254",
        "Dingbat hex": "FE",
        "Unicode dec": "127758",
        "Unicode hex": "1F30E"
    },
    {
        "Typeface name": "Webdings",
        "Dingbat dec": "255",
        "Dingbat hex": "FF",
        "Unicode dec": "128330",
        "Unicode hex": "1F54A"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "32",
        "Dingbat hex": "20",
        "Unicode dec": "32",
        "Unicode hex": "20"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "33",
        "Dingbat hex": "21",
        "Unicode dec": "128393",
        "Unicode hex": "1F589"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "34",
        "Dingbat hex": "22",
        "Unicode dec": "9986",
        "Unicode hex": "2702"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "35",
        "Dingbat hex": "23",
        "Unicode dec": "9985",
        "Unicode hex": "2701"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "36",
        "Dingbat hex": "24",
        "Unicode dec": "128083",
        "Unicode hex": "1F453"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "37",
        "Dingbat hex": "25",
        "Unicode dec": "128365",
        "Unicode hex": "1F56D"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "38",
        "Dingbat hex": "26",
        "Unicode dec": "128366",
        "Unicode hex": "1F56E"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "39",
        "Dingbat hex": "27",
        "Unicode dec": "128367",
        "Unicode hex": "1F56F"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "40",
        "Dingbat hex": "28",
        "Unicode dec": "128383",
        "Unicode hex": "1F57F"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "41",
        "Dingbat hex": "29",
        "Unicode dec": "9990",
        "Unicode hex": "2706"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "42",
        "Dingbat hex": "2A",
        "Unicode dec": "128386",
        "Unicode hex": "1F582"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "43",
        "Dingbat hex": "2B",
        "Unicode dec": "128387",
        "Unicode hex": "1F583"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "44",
        "Dingbat hex": "2C",
        "Unicode dec": "128234",
        "Unicode hex": "1F4EA"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "45",
        "Dingbat hex": "2D",
        "Unicode dec": "128235",
        "Unicode hex": "1F4EB"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "46",
        "Dingbat hex": "2E",
        "Unicode dec": "128236",
        "Unicode hex": "1F4EC"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "47",
        "Dingbat hex": "2F",
        "Unicode dec": "128237",
        "Unicode hex": "1F4ED"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "48",
        "Dingbat hex": "30",
        "Unicode dec": "128448",
        "Unicode hex": "1F5C0"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "49",
        "Dingbat hex": "31",
        "Unicode dec": "128449",
        "Unicode hex": "1F5C1"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "50",
        "Dingbat hex": "32",
        "Unicode dec": "128462",
        "Unicode hex": "1F5CE"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "51",
        "Dingbat hex": "33",
        "Unicode dec": "128463",
        "Unicode hex": "1F5CF"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "52",
        "Dingbat hex": "34",
        "Unicode dec": "128464",
        "Unicode hex": "1F5D0"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "53",
        "Dingbat hex": "35",
        "Unicode dec": "128452",
        "Unicode hex": "1F5C4"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "54",
        "Dingbat hex": "36",
        "Unicode dec": "8987",
        "Unicode hex": "231B"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "55",
        "Dingbat hex": "37",
        "Unicode dec": "128430",
        "Unicode hex": "1F5AE"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "56",
        "Dingbat hex": "38",
        "Unicode dec": "128432",
        "Unicode hex": "1F5B0"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "57",
        "Dingbat hex": "39",
        "Unicode dec": "128434",
        "Unicode hex": "1F5B2"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "58",
        "Dingbat hex": "3A",
        "Unicode dec": "128435",
        "Unicode hex": "1F5B3"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "59",
        "Dingbat hex": "3B",
        "Unicode dec": "128436",
        "Unicode hex": "1F5B4"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "60",
        "Dingbat hex": "3C",
        "Unicode dec": "128427",
        "Unicode hex": "1F5AB"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "61",
        "Dingbat hex": "3D",
        "Unicode dec": "128428",
        "Unicode hex": "1F5AC"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "62",
        "Dingbat hex": "3E",
        "Unicode dec": "9991",
        "Unicode hex": "2707"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "63",
        "Dingbat hex": "3F",
        "Unicode dec": "9997",
        "Unicode hex": "270D"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "64",
        "Dingbat hex": "40",
        "Unicode dec": "128398",
        "Unicode hex": "1F58E"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "65",
        "Dingbat hex": "41",
        "Unicode dec": "9996",
        "Unicode hex": "270C"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "66",
        "Dingbat hex": "42",
        "Unicode dec": "128399",
        "Unicode hex": "1F58F"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "67",
        "Dingbat hex": "43",
        "Unicode dec": "128077",
        "Unicode hex": "1F44D"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "68",
        "Dingbat hex": "44",
        "Unicode dec": "128078",
        "Unicode hex": "1F44E"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "69",
        "Dingbat hex": "45",
        "Unicode dec": "9756",
        "Unicode hex": "261C"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "70",
        "Dingbat hex": "46",
        "Unicode dec": "9758",
        "Unicode hex": "261E"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "71",
        "Dingbat hex": "47",
        "Unicode dec": "9757",
        "Unicode hex": "261D"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "72",
        "Dingbat hex": "48",
        "Unicode dec": "9759",
        "Unicode hex": "261F"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "73",
        "Dingbat hex": "49",
        "Unicode dec": "128400",
        "Unicode hex": "1F590"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "74",
        "Dingbat hex": "4A",
        "Unicode dec": "9786",
        "Unicode hex": "263A"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "75",
        "Dingbat hex": "4B",
        "Unicode dec": "128528",
        "Unicode hex": "1F610"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "76",
        "Dingbat hex": "4C",
        "Unicode dec": "9785",
        "Unicode hex": "2639"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "77",
        "Dingbat hex": "4D",
        "Unicode dec": "128163",
        "Unicode hex": "1F4A3"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "78",
        "Dingbat hex": "4E",
        "Unicode dec": "128369",
        "Unicode hex": "1F571"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "79",
        "Dingbat hex": "4F",
        "Unicode dec": "127987",
        "Unicode hex": "1F3F3"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "80",
        "Dingbat hex": "50",
        "Unicode dec": "127985",
        "Unicode hex": "1F3F1"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "81",
        "Dingbat hex": "51",
        "Unicode dec": "9992",
        "Unicode hex": "2708"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "82",
        "Dingbat hex": "52",
        "Unicode dec": "9788",
        "Unicode hex": "263C"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "83",
        "Dingbat hex": "53",
        "Unicode dec": "127778",
        "Unicode hex": "1F322"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "84",
        "Dingbat hex": "54",
        "Unicode dec": "10052",
        "Unicode hex": "2744"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "85",
        "Dingbat hex": "55",
        "Unicode dec": "128326",
        "Unicode hex": "1F546"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "86",
        "Dingbat hex": "56",
        "Unicode dec": "10014",
        "Unicode hex": "271E"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "87",
        "Dingbat hex": "57",
        "Unicode dec": "128328",
        "Unicode hex": "1F548"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "88",
        "Dingbat hex": "58",
        "Unicode dec": "10016",
        "Unicode hex": "2720"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "89",
        "Dingbat hex": "59",
        "Unicode dec": "10017",
        "Unicode hex": "2721"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "90",
        "Dingbat hex": "5A",
        "Unicode dec": "9770",
        "Unicode hex": "262A"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "91",
        "Dingbat hex": "5B",
        "Unicode dec": "9775",
        "Unicode hex": "262F"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "92",
        "Dingbat hex": "5C",
        "Unicode dec": "128329",
        "Unicode hex": "1F549"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "93",
        "Dingbat hex": "5D",
        "Unicode dec": "9784",
        "Unicode hex": "2638"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "94",
        "Dingbat hex": "5E",
        "Unicode dec": "9800",
        "Unicode hex": "2648"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "95",
        "Dingbat hex": "5F",
        "Unicode dec": "9801",
        "Unicode hex": "2649"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "96",
        "Dingbat hex": "60",
        "Unicode dec": "9802",
        "Unicode hex": "264A"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "97",
        "Dingbat hex": "61",
        "Unicode dec": "9803",
        "Unicode hex": "264B"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "98",
        "Dingbat hex": "62",
        "Unicode dec": "9804",
        "Unicode hex": "264C"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "99",
        "Dingbat hex": "63",
        "Unicode dec": "9805",
        "Unicode hex": "264D"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "100",
        "Dingbat hex": "64",
        "Unicode dec": "9806",
        "Unicode hex": "264E"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "101",
        "Dingbat hex": "65",
        "Unicode dec": "9807",
        "Unicode hex": "264F"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "102",
        "Dingbat hex": "66",
        "Unicode dec": "9808",
        "Unicode hex": "2650"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "103",
        "Dingbat hex": "67",
        "Unicode dec": "9809",
        "Unicode hex": "2651"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "104",
        "Dingbat hex": "68",
        "Unicode dec": "9810",
        "Unicode hex": "2652"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "105",
        "Dingbat hex": "69",
        "Unicode dec": "9811",
        "Unicode hex": "2653"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "106",
        "Dingbat hex": "6A",
        "Unicode dec": "128624",
        "Unicode hex": "1F670"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "107",
        "Dingbat hex": "6B",
        "Unicode dec": "128629",
        "Unicode hex": "1F675"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "108",
        "Dingbat hex": "6C",
        "Unicode dec": "9899",
        "Unicode hex": "26AB"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "109",
        "Dingbat hex": "6D",
        "Unicode dec": "128318",
        "Unicode hex": "1F53E"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "110",
        "Dingbat hex": "6E",
        "Unicode dec": "9724",
        "Unicode hex": "25FC"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "111",
        "Dingbat hex": "6F",
        "Unicode dec": "128911",
        "Unicode hex": "1F78F"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "112",
        "Dingbat hex": "70",
        "Unicode dec": "128912",
        "Unicode hex": "1F790"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "113",
        "Dingbat hex": "71",
        "Unicode dec": "10065",
        "Unicode hex": "2751"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "114",
        "Dingbat hex": "72",
        "Unicode dec": "10066",
        "Unicode hex": "2752"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "115",
        "Dingbat hex": "73",
        "Unicode dec": "128927",
        "Unicode hex": "1F79F"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "116",
        "Dingbat hex": "74",
        "Unicode dec": "10731",
        "Unicode hex": "29EB"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "117",
        "Dingbat hex": "75",
        "Unicode dec": "9670",
        "Unicode hex": "25C6"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "118",
        "Dingbat hex": "76",
        "Unicode dec": "10070",
        "Unicode hex": "2756"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "119",
        "Dingbat hex": "77",
        "Unicode dec": "11049",
        "Unicode hex": "2B29"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "120",
        "Dingbat hex": "78",
        "Unicode dec": "8999",
        "Unicode hex": "2327"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "121",
        "Dingbat hex": "79",
        "Unicode dec": "11193",
        "Unicode hex": "2BB9"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "122",
        "Dingbat hex": "7A",
        "Unicode dec": "8984",
        "Unicode hex": "2318"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "123",
        "Dingbat hex": "7B",
        "Unicode dec": "127989",
        "Unicode hex": "1F3F5"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "124",
        "Dingbat hex": "7C",
        "Unicode dec": "127990",
        "Unicode hex": "1F3F6"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "125",
        "Dingbat hex": "7D",
        "Unicode dec": "128630",
        "Unicode hex": "1F676"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "126",
        "Dingbat hex": "7E",
        "Unicode dec": "128631",
        "Unicode hex": "1F677"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "127",
        "Dingbat hex": "7F",
        "Unicode dec": "9647",
        "Unicode hex": "25AF"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "128",
        "Dingbat hex": "80",
        "Unicode dec": "127243",
        "Unicode hex": "1F10B"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "129",
        "Dingbat hex": "81",
        "Unicode dec": "10112",
        "Unicode hex": "2780"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "130",
        "Dingbat hex": "82",
        "Unicode dec": "10113",
        "Unicode hex": "2781"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "131",
        "Dingbat hex": "83",
        "Unicode dec": "10114",
        "Unicode hex": "2782"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "132",
        "Dingbat hex": "84",
        "Unicode dec": "10115",
        "Unicode hex": "2783"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "133",
        "Dingbat hex": "85",
        "Unicode dec": "10116",
        "Unicode hex": "2784"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "134",
        "Dingbat hex": "86",
        "Unicode dec": "10117",
        "Unicode hex": "2785"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "135",
        "Dingbat hex": "87",
        "Unicode dec": "10118",
        "Unicode hex": "2786"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "136",
        "Dingbat hex": "88",
        "Unicode dec": "10119",
        "Unicode hex": "2787"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "137",
        "Dingbat hex": "89",
        "Unicode dec": "10120",
        "Unicode hex": "2788"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "138",
        "Dingbat hex": "8A",
        "Unicode dec": "10121",
        "Unicode hex": "2789"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "139",
        "Dingbat hex": "8B",
        "Unicode dec": "127244",
        "Unicode hex": "1F10C"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "140",
        "Dingbat hex": "8C",
        "Unicode dec": "10122",
        "Unicode hex": "278A"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "141",
        "Dingbat hex": "8D",
        "Unicode dec": "10123",
        "Unicode hex": "278B"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "142",
        "Dingbat hex": "8E",
        "Unicode dec": "10124",
        "Unicode hex": "278C"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "143",
        "Dingbat hex": "8F",
        "Unicode dec": "10125",
        "Unicode hex": "278D"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "144",
        "Dingbat hex": "90",
        "Unicode dec": "10126",
        "Unicode hex": "278E"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "145",
        "Dingbat hex": "91",
        "Unicode dec": "10127",
        "Unicode hex": "278F"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "146",
        "Dingbat hex": "92",
        "Unicode dec": "10128",
        "Unicode hex": "2790"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "147",
        "Dingbat hex": "93",
        "Unicode dec": "10129",
        "Unicode hex": "2791"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "148",
        "Dingbat hex": "94",
        "Unicode dec": "10130",
        "Unicode hex": "2792"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "149",
        "Dingbat hex": "95",
        "Unicode dec": "10131",
        "Unicode hex": "2793"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "150",
        "Dingbat hex": "96",
        "Unicode dec": "128610",
        "Unicode hex": "1F662"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "151",
        "Dingbat hex": "97",
        "Unicode dec": "128608",
        "Unicode hex": "1F660"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "152",
        "Dingbat hex": "98",
        "Unicode dec": "128609",
        "Unicode hex": "1F661"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "153",
        "Dingbat hex": "99",
        "Unicode dec": "128611",
        "Unicode hex": "1F663"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "154",
        "Dingbat hex": "9A",
        "Unicode dec": "128606",
        "Unicode hex": "1F65E"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "155",
        "Dingbat hex": "9B",
        "Unicode dec": "128604",
        "Unicode hex": "1F65C"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "156",
        "Dingbat hex": "9C",
        "Unicode dec": "128605",
        "Unicode hex": "1F65D"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "157",
        "Dingbat hex": "9D",
        "Unicode dec": "128607",
        "Unicode hex": "1F65F"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "158",
        "Dingbat hex": "9E",
        "Unicode dec": "8729",
        "Unicode hex": "2219"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "159",
        "Dingbat hex": "9F",
        "Unicode dec": "8226",
        "Unicode hex": "2022"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "160",
        "Dingbat hex": "A0",
        "Unicode dec": "11037",
        "Unicode hex": "2B1D"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "161",
        "Dingbat hex": "A1",
        "Unicode dec": "11096",
        "Unicode hex": "2B58"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "162",
        "Dingbat hex": "A2",
        "Unicode dec": "128902",
        "Unicode hex": "1F786"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "163",
        "Dingbat hex": "A3",
        "Unicode dec": "128904",
        "Unicode hex": "1F788"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "164",
        "Dingbat hex": "A4",
        "Unicode dec": "128906",
        "Unicode hex": "1F78A"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "165",
        "Dingbat hex": "A5",
        "Unicode dec": "128907",
        "Unicode hex": "1F78B"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "166",
        "Dingbat hex": "A6",
        "Unicode dec": "128319",
        "Unicode hex": "1F53F"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "167",
        "Dingbat hex": "A7",
        "Unicode dec": "9642",
        "Unicode hex": "25AA"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "168",
        "Dingbat hex": "A8",
        "Unicode dec": "128910",
        "Unicode hex": "1F78E"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "169",
        "Dingbat hex": "A9",
        "Unicode dec": "128961",
        "Unicode hex": "1F7C1"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "170",
        "Dingbat hex": "AA",
        "Unicode dec": "128965",
        "Unicode hex": "1F7C5"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "171",
        "Dingbat hex": "AB",
        "Unicode dec": "9733",
        "Unicode hex": "2605"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "172",
        "Dingbat hex": "AC",
        "Unicode dec": "128971",
        "Unicode hex": "1F7CB"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "173",
        "Dingbat hex": "AD",
        "Unicode dec": "128975",
        "Unicode hex": "1F7CF"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "174",
        "Dingbat hex": "AE",
        "Unicode dec": "128979",
        "Unicode hex": "1F7D3"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "175",
        "Dingbat hex": "AF",
        "Unicode dec": "128977",
        "Unicode hex": "1F7D1"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "176",
        "Dingbat hex": "B0",
        "Unicode dec": "11216",
        "Unicode hex": "2BD0"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "177",
        "Dingbat hex": "B1",
        "Unicode dec": "8982",
        "Unicode hex": "2316"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "178",
        "Dingbat hex": "B2",
        "Unicode dec": "11214",
        "Unicode hex": "2BCE"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "179",
        "Dingbat hex": "B3",
        "Unicode dec": "11215",
        "Unicode hex": "2BCF"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "180",
        "Dingbat hex": "B4",
        "Unicode dec": "11217",
        "Unicode hex": "2BD1"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "181",
        "Dingbat hex": "B5",
        "Unicode dec": "10026",
        "Unicode hex": "272A"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "182",
        "Dingbat hex": "B6",
        "Unicode dec": "10032",
        "Unicode hex": "2730"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "183",
        "Dingbat hex": "B7",
        "Unicode dec": "128336",
        "Unicode hex": "1F550"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "184",
        "Dingbat hex": "B8",
        "Unicode dec": "128337",
        "Unicode hex": "1F551"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "185",
        "Dingbat hex": "B9",
        "Unicode dec": "128338",
        "Unicode hex": "1F552"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "186",
        "Dingbat hex": "BA",
        "Unicode dec": "128339",
        "Unicode hex": "1F553"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "187",
        "Dingbat hex": "BB",
        "Unicode dec": "128340",
        "Unicode hex": "1F554"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "188",
        "Dingbat hex": "BC",
        "Unicode dec": "128341",
        "Unicode hex": "1F555"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "189",
        "Dingbat hex": "BD",
        "Unicode dec": "128342",
        "Unicode hex": "1F556"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "190",
        "Dingbat hex": "BE",
        "Unicode dec": "128343",
        "Unicode hex": "1F557"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "191",
        "Dingbat hex": "BF",
        "Unicode dec": "128344",
        "Unicode hex": "1F558"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "192",
        "Dingbat hex": "C0",
        "Unicode dec": "128345",
        "Unicode hex": "1F559"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "193",
        "Dingbat hex": "C1",
        "Unicode dec": "128346",
        "Unicode hex": "1F55A"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "194",
        "Dingbat hex": "C2",
        "Unicode dec": "128347",
        "Unicode hex": "1F55B"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "195",
        "Dingbat hex": "C3",
        "Unicode dec": "11184",
        "Unicode hex": "2BB0"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "196",
        "Dingbat hex": "C4",
        "Unicode dec": "11185",
        "Unicode hex": "2BB1"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "197",
        "Dingbat hex": "C5",
        "Unicode dec": "11186",
        "Unicode hex": "2BB2"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "198",
        "Dingbat hex": "C6",
        "Unicode dec": "11187",
        "Unicode hex": "2BB3"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "199",
        "Dingbat hex": "C7",
        "Unicode dec": "11188",
        "Unicode hex": "2BB4"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "200",
        "Dingbat hex": "C8",
        "Unicode dec": "11189",
        "Unicode hex": "2BB5"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "201",
        "Dingbat hex": "C9",
        "Unicode dec": "11190",
        "Unicode hex": "2BB6"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "202",
        "Dingbat hex": "CA",
        "Unicode dec": "11191",
        "Unicode hex": "2BB7"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "203",
        "Dingbat hex": "CB",
        "Unicode dec": "128618",
        "Unicode hex": "1F66A"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "204",
        "Dingbat hex": "CC",
        "Unicode dec": "128619",
        "Unicode hex": "1F66B"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "205",
        "Dingbat hex": "CD",
        "Unicode dec": "128597",
        "Unicode hex": "1F655"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "206",
        "Dingbat hex": "CE",
        "Unicode dec": "128596",
        "Unicode hex": "1F654"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "207",
        "Dingbat hex": "CF",
        "Unicode dec": "128599",
        "Unicode hex": "1F657"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "208",
        "Dingbat hex": "D0",
        "Unicode dec": "128598",
        "Unicode hex": "1F656"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "209",
        "Dingbat hex": "D1",
        "Unicode dec": "128592",
        "Unicode hex": "1F650"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "210",
        "Dingbat hex": "D2",
        "Unicode dec": "128593",
        "Unicode hex": "1F651"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "211",
        "Dingbat hex": "D3",
        "Unicode dec": "128594",
        "Unicode hex": "1F652"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "212",
        "Dingbat hex": "D4",
        "Unicode dec": "128595",
        "Unicode hex": "1F653"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "213",
        "Dingbat hex": "D5",
        "Unicode dec": "9003",
        "Unicode hex": "232B"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "214",
        "Dingbat hex": "D6",
        "Unicode dec": "8998",
        "Unicode hex": "2326"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "215",
        "Dingbat hex": "D7",
        "Unicode dec": "11160",
        "Unicode hex": "2B98"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "216",
        "Dingbat hex": "D8",
        "Unicode dec": "11162",
        "Unicode hex": "2B9A"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "217",
        "Dingbat hex": "D9",
        "Unicode dec": "11161",
        "Unicode hex": "2B99"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "218",
        "Dingbat hex": "DA",
        "Unicode dec": "11163",
        "Unicode hex": "2B9B"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "219",
        "Dingbat hex": "DB",
        "Unicode dec": "11144",
        "Unicode hex": "2B88"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "220",
        "Dingbat hex": "DC",
        "Unicode dec": "11146",
        "Unicode hex": "2B8A"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "221",
        "Dingbat hex": "DD",
        "Unicode dec": "11145",
        "Unicode hex": "2B89"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "222",
        "Dingbat hex": "DE",
        "Unicode dec": "11147",
        "Unicode hex": "2B8B"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "223",
        "Dingbat hex": "DF",
        "Unicode dec": "129128",
        "Unicode hex": "1F868"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "224",
        "Dingbat hex": "E0",
        "Unicode dec": "129130",
        "Unicode hex": "1F86A"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "225",
        "Dingbat hex": "E1",
        "Unicode dec": "129129",
        "Unicode hex": "1F869"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "226",
        "Dingbat hex": "E2",
        "Unicode dec": "129131",
        "Unicode hex": "1F86B"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "227",
        "Dingbat hex": "E3",
        "Unicode dec": "129132",
        "Unicode hex": "1F86C"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "228",
        "Dingbat hex": "E4",
        "Unicode dec": "129133",
        "Unicode hex": "1F86D"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "229",
        "Dingbat hex": "E5",
        "Unicode dec": "129135",
        "Unicode hex": "1F86F"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "230",
        "Dingbat hex": "E6",
        "Unicode dec": "129134",
        "Unicode hex": "1F86E"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "231",
        "Dingbat hex": "E7",
        "Unicode dec": "129144",
        "Unicode hex": "1F878"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "232",
        "Dingbat hex": "E8",
        "Unicode dec": "129146",
        "Unicode hex": "1F87A"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "233",
        "Dingbat hex": "E9",
        "Unicode dec": "129145",
        "Unicode hex": "1F879"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "234",
        "Dingbat hex": "EA",
        "Unicode dec": "129147",
        "Unicode hex": "1F87B"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "235",
        "Dingbat hex": "EB",
        "Unicode dec": "129148",
        "Unicode hex": "1F87C"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "236",
        "Dingbat hex": "EC",
        "Unicode dec": "129149",
        "Unicode hex": "1F87D"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "237",
        "Dingbat hex": "ED",
        "Unicode dec": "129151",
        "Unicode hex": "1F87F"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "238",
        "Dingbat hex": "EE",
        "Unicode dec": "129150",
        "Unicode hex": "1F87E"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "239",
        "Dingbat hex": "EF",
        "Unicode dec": "8678",
        "Unicode hex": "21E6"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "240",
        "Dingbat hex": "F0",
        "Unicode dec": "8680",
        "Unicode hex": "21E8"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "241",
        "Dingbat hex": "F1",
        "Unicode dec": "8679",
        "Unicode hex": "21E7"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "242",
        "Dingbat hex": "F2",
        "Unicode dec": "8681",
        "Unicode hex": "21E9"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "243",
        "Dingbat hex": "F3",
        "Unicode dec": "11012",
        "Unicode hex": "2B04"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "244",
        "Dingbat hex": "F4",
        "Unicode dec": "8691",
        "Unicode hex": "21F3"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "245",
        "Dingbat hex": "F5",
        "Unicode dec": "11009",
        "Unicode hex": "2B01"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "246",
        "Dingbat hex": "F6",
        "Unicode dec": "11008",
        "Unicode hex": "2B00"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "247",
        "Dingbat hex": "F7",
        "Unicode dec": "11011",
        "Unicode hex": "2B03"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "248",
        "Dingbat hex": "F8",
        "Unicode dec": "11010",
        "Unicode hex": "2B02"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "249",
        "Dingbat hex": "F9",
        "Unicode dec": "129196",
        "Unicode hex": "1F8AC"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "250",
        "Dingbat hex": "FA",
        "Unicode dec": "129197",
        "Unicode hex": "1F8AD"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "251",
        "Dingbat hex": "FB",
        "Unicode dec": "128502",
        "Unicode hex": "1F5F6"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "252",
        "Dingbat hex": "FC",
        "Unicode dec": "10003",
        "Unicode hex": "2713"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "253",
        "Dingbat hex": "FD",
        "Unicode dec": "128503",
        "Unicode hex": "1F5F7"
    },
    {
        "Typeface name": "Wingdings",
        "Dingbat dec": "254",
        "Dingbat hex": "FE",
        "Unicode dec": "128505",
        "Unicode hex": "1F5F9"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "32",
        "Dingbat hex": "20",
        "Unicode dec": "32",
        "Unicode hex": "20"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "33",
        "Dingbat hex": "21",
        "Unicode dec": "128394",
        "Unicode hex": "1F58A"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "34",
        "Dingbat hex": "22",
        "Unicode dec": "128395",
        "Unicode hex": "1F58B"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "35",
        "Dingbat hex": "23",
        "Unicode dec": "128396",
        "Unicode hex": "1F58C"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "36",
        "Dingbat hex": "24",
        "Unicode dec": "128397",
        "Unicode hex": "1F58D"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "37",
        "Dingbat hex": "25",
        "Unicode dec": "9988",
        "Unicode hex": "2704"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "38",
        "Dingbat hex": "26",
        "Unicode dec": "9984",
        "Unicode hex": "2700"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "39",
        "Dingbat hex": "27",
        "Unicode dec": "128382",
        "Unicode hex": "1F57E"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "40",
        "Dingbat hex": "28",
        "Unicode dec": "128381",
        "Unicode hex": "1F57D"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "41",
        "Dingbat hex": "29",
        "Unicode dec": "128453",
        "Unicode hex": "1F5C5"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "42",
        "Dingbat hex": "2A",
        "Unicode dec": "128454",
        "Unicode hex": "1F5C6"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "43",
        "Dingbat hex": "2B",
        "Unicode dec": "128455",
        "Unicode hex": "1F5C7"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "44",
        "Dingbat hex": "2C",
        "Unicode dec": "128456",
        "Unicode hex": "1F5C8"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "45",
        "Dingbat hex": "2D",
        "Unicode dec": "128457",
        "Unicode hex": "1F5C9"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "46",
        "Dingbat hex": "2E",
        "Unicode dec": "128458",
        "Unicode hex": "1F5CA"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "47",
        "Dingbat hex": "2F",
        "Unicode dec": "128459",
        "Unicode hex": "1F5CB"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "48",
        "Dingbat hex": "30",
        "Unicode dec": "128460",
        "Unicode hex": "1F5CC"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "49",
        "Dingbat hex": "31",
        "Unicode dec": "128461",
        "Unicode hex": "1F5CD"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "50",
        "Dingbat hex": "32",
        "Unicode dec": "128203",
        "Unicode hex": "1F4CB"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "51",
        "Dingbat hex": "33",
        "Unicode dec": "128465",
        "Unicode hex": "1F5D1"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "52",
        "Dingbat hex": "34",
        "Unicode dec": "128468",
        "Unicode hex": "1F5D4"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "53",
        "Dingbat hex": "35",
        "Unicode dec": "128437",
        "Unicode hex": "1F5B5"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "54",
        "Dingbat hex": "36",
        "Unicode dec": "128438",
        "Unicode hex": "1F5B6"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "55",
        "Dingbat hex": "37",
        "Unicode dec": "128439",
        "Unicode hex": "1F5B7"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "56",
        "Dingbat hex": "38",
        "Unicode dec": "128440",
        "Unicode hex": "1F5B8"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "57",
        "Dingbat hex": "39",
        "Unicode dec": "128429",
        "Unicode hex": "1F5AD"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "58",
        "Dingbat hex": "3A",
        "Unicode dec": "128431",
        "Unicode hex": "1F5AF"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "59",
        "Dingbat hex": "3B",
        "Unicode dec": "128433",
        "Unicode hex": "1F5B1"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "60",
        "Dingbat hex": "3C",
        "Unicode dec": "128402",
        "Unicode hex": "1F592"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "61",
        "Dingbat hex": "3D",
        "Unicode dec": "128403",
        "Unicode hex": "1F593"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "62",
        "Dingbat hex": "3E",
        "Unicode dec": "128408",
        "Unicode hex": "1F598"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "63",
        "Dingbat hex": "3F",
        "Unicode dec": "128409",
        "Unicode hex": "1F599"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "64",
        "Dingbat hex": "40",
        "Unicode dec": "128410",
        "Unicode hex": "1F59A"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "65",
        "Dingbat hex": "41",
        "Unicode dec": "128411",
        "Unicode hex": "1F59B"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "66",
        "Dingbat hex": "42",
        "Unicode dec": "128072",
        "Unicode hex": "1F448"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "67",
        "Dingbat hex": "43",
        "Unicode dec": "128073",
        "Unicode hex": "1F449"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "68",
        "Dingbat hex": "44",
        "Unicode dec": "128412",
        "Unicode hex": "1F59C"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "69",
        "Dingbat hex": "45",
        "Unicode dec": "128413",
        "Unicode hex": "1F59D"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "70",
        "Dingbat hex": "46",
        "Unicode dec": "128414",
        "Unicode hex": "1F59E"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "71",
        "Dingbat hex": "47",
        "Unicode dec": "128415",
        "Unicode hex": "1F59F"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "72",
        "Dingbat hex": "48",
        "Unicode dec": "128416",
        "Unicode hex": "1F5A0"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "73",
        "Dingbat hex": "49",
        "Unicode dec": "128417",
        "Unicode hex": "1F5A1"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "74",
        "Dingbat hex": "4A",
        "Unicode dec": "128070",
        "Unicode hex": "1F446"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "75",
        "Dingbat hex": "4B",
        "Unicode dec": "128071",
        "Unicode hex": "1F447"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "76",
        "Dingbat hex": "4C",
        "Unicode dec": "128418",
        "Unicode hex": "1F5A2"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "77",
        "Dingbat hex": "4D",
        "Unicode dec": "128419",
        "Unicode hex": "1F5A3"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "78",
        "Dingbat hex": "4E",
        "Unicode dec": "128401",
        "Unicode hex": "1F591"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "79",
        "Dingbat hex": "4F",
        "Unicode dec": "128500",
        "Unicode hex": "1F5F4"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "80",
        "Dingbat hex": "50",
        "Unicode dec": "128504",
        "Unicode hex": "1F5F8"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "81",
        "Dingbat hex": "51",
        "Unicode dec": "128501",
        "Unicode hex": "1F5F5"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "82",
        "Dingbat hex": "52",
        "Unicode dec": "9745",
        "Unicode hex": "2611"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "83",
        "Dingbat hex": "53",
        "Unicode dec": "11197",
        "Unicode hex": "2BBD"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "84",
        "Dingbat hex": "54",
        "Unicode dec": "9746",
        "Unicode hex": "2612"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "85",
        "Dingbat hex": "55",
        "Unicode dec": "11198",
        "Unicode hex": "2BBE"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "86",
        "Dingbat hex": "56",
        "Unicode dec": "11199",
        "Unicode hex": "2BBF"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "87",
        "Dingbat hex": "57",
        "Unicode dec": "128711",
        "Unicode hex": "1F6C7"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "88",
        "Dingbat hex": "58",
        "Unicode dec": "10680",
        "Unicode hex": "29B8"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "89",
        "Dingbat hex": "59",
        "Unicode dec": "128625",
        "Unicode hex": "1F671"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "90",
        "Dingbat hex": "5A",
        "Unicode dec": "128628",
        "Unicode hex": "1F674"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "91",
        "Dingbat hex": "5B",
        "Unicode dec": "128626",
        "Unicode hex": "1F672"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "92",
        "Dingbat hex": "5C",
        "Unicode dec": "128627",
        "Unicode hex": "1F673"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "93",
        "Dingbat hex": "5D",
        "Unicode dec": "8253",
        "Unicode hex": "203D"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "94",
        "Dingbat hex": "5E",
        "Unicode dec": "128633",
        "Unicode hex": "1F679"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "95",
        "Dingbat hex": "5F",
        "Unicode dec": "128634",
        "Unicode hex": "1F67A"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "96",
        "Dingbat hex": "60",
        "Unicode dec": "128635",
        "Unicode hex": "1F67B"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "97",
        "Dingbat hex": "61",
        "Unicode dec": "128614",
        "Unicode hex": "1F666"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "98",
        "Dingbat hex": "62",
        "Unicode dec": "128612",
        "Unicode hex": "1F664"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "99",
        "Dingbat hex": "63",
        "Unicode dec": "128613",
        "Unicode hex": "1F665"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "100",
        "Dingbat hex": "64",
        "Unicode dec": "128615",
        "Unicode hex": "1F667"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "101",
        "Dingbat hex": "65",
        "Unicode dec": "128602",
        "Unicode hex": "1F65A"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "102",
        "Dingbat hex": "66",
        "Unicode dec": "128600",
        "Unicode hex": "1F658"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "103",
        "Dingbat hex": "67",
        "Unicode dec": "128601",
        "Unicode hex": "1F659"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "104",
        "Dingbat hex": "68",
        "Unicode dec": "128603",
        "Unicode hex": "1F65B"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "105",
        "Dingbat hex": "69",
        "Unicode dec": "9450",
        "Unicode hex": "24EA"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "106",
        "Dingbat hex": "6A",
        "Unicode dec": "9312",
        "Unicode hex": "2460"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "107",
        "Dingbat hex": "6B",
        "Unicode dec": "9313",
        "Unicode hex": "2461"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "108",
        "Dingbat hex": "6C",
        "Unicode dec": "9314",
        "Unicode hex": "2462"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "109",
        "Dingbat hex": "6D",
        "Unicode dec": "9315",
        "Unicode hex": "2463"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "110",
        "Dingbat hex": "6E",
        "Unicode dec": "9316",
        "Unicode hex": "2464"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "111",
        "Dingbat hex": "6F",
        "Unicode dec": "9317",
        "Unicode hex": "2465"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "112",
        "Dingbat hex": "70",
        "Unicode dec": "9318",
        "Unicode hex": "2466"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "113",
        "Dingbat hex": "71",
        "Unicode dec": "9319",
        "Unicode hex": "2467"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "114",
        "Dingbat hex": "72",
        "Unicode dec": "9320",
        "Unicode hex": "2468"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "115",
        "Dingbat hex": "73",
        "Unicode dec": "9321",
        "Unicode hex": "2469"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "116",
        "Dingbat hex": "74",
        "Unicode dec": "9471",
        "Unicode hex": "24FF"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "117",
        "Dingbat hex": "75",
        "Unicode dec": "10102",
        "Unicode hex": "2776"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "118",
        "Dingbat hex": "76",
        "Unicode dec": "10103",
        "Unicode hex": "2777"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "119",
        "Dingbat hex": "77",
        "Unicode dec": "10104",
        "Unicode hex": "2778"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "120",
        "Dingbat hex": "78",
        "Unicode dec": "10105",
        "Unicode hex": "2779"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "121",
        "Dingbat hex": "79",
        "Unicode dec": "10106",
        "Unicode hex": "277A"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "122",
        "Dingbat hex": "7A",
        "Unicode dec": "10107",
        "Unicode hex": "277B"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "123",
        "Dingbat hex": "7B",
        "Unicode dec": "10108",
        "Unicode hex": "277C"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "124",
        "Dingbat hex": "7C",
        "Unicode dec": "10109",
        "Unicode hex": "277D"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "125",
        "Dingbat hex": "7D",
        "Unicode dec": "10110",
        "Unicode hex": "277E"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "126",
        "Dingbat hex": "7E",
        "Unicode dec": "10111",
        "Unicode hex": "277F"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "128",
        "Dingbat hex": "80",
        "Unicode dec": "9737",
        "Unicode hex": "2609"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "129",
        "Dingbat hex": "81",
        "Unicode dec": "127765",
        "Unicode hex": "1F315"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "130",
        "Dingbat hex": "82",
        "Unicode dec": "9789",
        "Unicode hex": "263D"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "131",
        "Dingbat hex": "83",
        "Unicode dec": "9790",
        "Unicode hex": "263E"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "132",
        "Dingbat hex": "84",
        "Unicode dec": "11839",
        "Unicode hex": "2E3F"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "133",
        "Dingbat hex": "85",
        "Unicode dec": "10013",
        "Unicode hex": "271D"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "134",
        "Dingbat hex": "86",
        "Unicode dec": "128327",
        "Unicode hex": "1F547"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "135",
        "Dingbat hex": "87",
        "Unicode dec": "128348",
        "Unicode hex": "1F55C"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "136",
        "Dingbat hex": "88",
        "Unicode dec": "128349",
        "Unicode hex": "1F55D"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "137",
        "Dingbat hex": "89",
        "Unicode dec": "128350",
        "Unicode hex": "1F55E"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "138",
        "Dingbat hex": "8A",
        "Unicode dec": "128351",
        "Unicode hex": "1F55F"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "139",
        "Dingbat hex": "8B",
        "Unicode dec": "128352",
        "Unicode hex": "1F560"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "140",
        "Dingbat hex": "8C",
        "Unicode dec": "128353",
        "Unicode hex": "1F561"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "141",
        "Dingbat hex": "8D",
        "Unicode dec": "128354",
        "Unicode hex": "1F562"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "142",
        "Dingbat hex": "8E",
        "Unicode dec": "128355",
        "Unicode hex": "1F563"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "143",
        "Dingbat hex": "8F",
        "Unicode dec": "128356",
        "Unicode hex": "1F564"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "144",
        "Dingbat hex": "90",
        "Unicode dec": "128357",
        "Unicode hex": "1F565"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "145",
        "Dingbat hex": "91",
        "Unicode dec": "128358",
        "Unicode hex": "1F566"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "146",
        "Dingbat hex": "92",
        "Unicode dec": "128359",
        "Unicode hex": "1F567"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "147",
        "Dingbat hex": "93",
        "Unicode dec": "128616",
        "Unicode hex": "1F668"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "148",
        "Dingbat hex": "94",
        "Unicode dec": "128617",
        "Unicode hex": "1F669"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "149",
        "Dingbat hex": "95",
        "Unicode dec": "8901",
        "Unicode hex": "22C5"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "150",
        "Dingbat hex": "96",
        "Unicode dec": "128900",
        "Unicode hex": "1F784"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "151",
        "Dingbat hex": "97",
        "Unicode dec": "10625",
        "Unicode hex": "2981"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "152",
        "Dingbat hex": "98",
        "Unicode dec": "9679",
        "Unicode hex": "25CF"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "153",
        "Dingbat hex": "99",
        "Unicode dec": "9675",
        "Unicode hex": "25CB"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "154",
        "Dingbat hex": "9A",
        "Unicode dec": "128901",
        "Unicode hex": "1F785"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "155",
        "Dingbat hex": "9B",
        "Unicode dec": "128903",
        "Unicode hex": "1F787"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "156",
        "Dingbat hex": "9C",
        "Unicode dec": "128905",
        "Unicode hex": "1F789"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "157",
        "Dingbat hex": "9D",
        "Unicode dec": "8857",
        "Unicode hex": "2299"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "158",
        "Dingbat hex": "9E",
        "Unicode dec": "10687",
        "Unicode hex": "29BF"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "159",
        "Dingbat hex": "9F",
        "Unicode dec": "128908",
        "Unicode hex": "1F78C"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "160",
        "Dingbat hex": "A0",
        "Unicode dec": "128909",
        "Unicode hex": "1F78D"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "161",
        "Dingbat hex": "A1",
        "Unicode dec": "9726",
        "Unicode hex": "25FE"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "162",
        "Dingbat hex": "A2",
        "Unicode dec": "9632",
        "Unicode hex": "25A0"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "163",
        "Dingbat hex": "A3",
        "Unicode dec": "9633",
        "Unicode hex": "25A1"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "164",
        "Dingbat hex": "A4",
        "Unicode dec": "128913",
        "Unicode hex": "1F791"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "165",
        "Dingbat hex": "A5",
        "Unicode dec": "128914",
        "Unicode hex": "1F792"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "166",
        "Dingbat hex": "A6",
        "Unicode dec": "128915",
        "Unicode hex": "1F793"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "167",
        "Dingbat hex": "A7",
        "Unicode dec": "128916",
        "Unicode hex": "1F794"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "168",
        "Dingbat hex": "A8",
        "Unicode dec": "9635",
        "Unicode hex": "25A3"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "169",
        "Dingbat hex": "A9",
        "Unicode dec": "128917",
        "Unicode hex": "1F795"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "170",
        "Dingbat hex": "AA",
        "Unicode dec": "128918",
        "Unicode hex": "1F796"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "171",
        "Dingbat hex": "AB",
        "Unicode dec": "128919",
        "Unicode hex": "1F797"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "172",
        "Dingbat hex": "AC",
        "Unicode dec": "128920",
        "Unicode hex": "1F798"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "173",
        "Dingbat hex": "AD",
        "Unicode dec": "11049",
        "Unicode hex": "2B29"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "174",
        "Dingbat hex": "AE",
        "Unicode dec": "11045",
        "Unicode hex": "2B25"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "175",
        "Dingbat hex": "AF",
        "Unicode dec": "9671",
        "Unicode hex": "25C7"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "176",
        "Dingbat hex": "B0",
        "Unicode dec": "128922",
        "Unicode hex": "1F79A"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "177",
        "Dingbat hex": "B1",
        "Unicode dec": "9672",
        "Unicode hex": "25C8"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "178",
        "Dingbat hex": "B2",
        "Unicode dec": "128923",
        "Unicode hex": "1F79B"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "179",
        "Dingbat hex": "B3",
        "Unicode dec": "128924",
        "Unicode hex": "1F79C"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "180",
        "Dingbat hex": "B4",
        "Unicode dec": "128925",
        "Unicode hex": "1F79D"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "181",
        "Dingbat hex": "B5",
        "Unicode dec": "128926",
        "Unicode hex": "1F79E"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "182",
        "Dingbat hex": "B6",
        "Unicode dec": "11050",
        "Unicode hex": "2B2A"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "183",
        "Dingbat hex": "B7",
        "Unicode dec": "11047",
        "Unicode hex": "2B27"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "184",
        "Dingbat hex": "B8",
        "Unicode dec": "9674",
        "Unicode hex": "25CA"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "185",
        "Dingbat hex": "B9",
        "Unicode dec": "128928",
        "Unicode hex": "1F7A0"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "186",
        "Dingbat hex": "BA",
        "Unicode dec": "9686",
        "Unicode hex": "25D6"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "187",
        "Dingbat hex": "BB",
        "Unicode dec": "9687",
        "Unicode hex": "25D7"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "188",
        "Dingbat hex": "BC",
        "Unicode dec": "11210",
        "Unicode hex": "2BCA"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "189",
        "Dingbat hex": "BD",
        "Unicode dec": "11211",
        "Unicode hex": "2BCB"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "190",
        "Dingbat hex": "BE",
        "Unicode dec": "11200",
        "Unicode hex": "2BC0"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "191",
        "Dingbat hex": "BF",
        "Unicode dec": "11201",
        "Unicode hex": "2BC1"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "192",
        "Dingbat hex": "C0",
        "Unicode dec": "11039",
        "Unicode hex": "2B1F"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "193",
        "Dingbat hex": "C1",
        "Unicode dec": "11202",
        "Unicode hex": "2BC2"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "194",
        "Dingbat hex": "C2",
        "Unicode dec": "11043",
        "Unicode hex": "2B23"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "195",
        "Dingbat hex": "C3",
        "Unicode dec": "11042",
        "Unicode hex": "2B22"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "196",
        "Dingbat hex": "C4",
        "Unicode dec": "11203",
        "Unicode hex": "2BC3"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "197",
        "Dingbat hex": "C5",
        "Unicode dec": "11204",
        "Unicode hex": "2BC4"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "198",
        "Dingbat hex": "C6",
        "Unicode dec": "128929",
        "Unicode hex": "1F7A1"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "199",
        "Dingbat hex": "C7",
        "Unicode dec": "128930",
        "Unicode hex": "1F7A2"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "200",
        "Dingbat hex": "C8",
        "Unicode dec": "128931",
        "Unicode hex": "1F7A3"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "201",
        "Dingbat hex": "C9",
        "Unicode dec": "128932",
        "Unicode hex": "1F7A4"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "202",
        "Dingbat hex": "CA",
        "Unicode dec": "128933",
        "Unicode hex": "1F7A5"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "203",
        "Dingbat hex": "CB",
        "Unicode dec": "128934",
        "Unicode hex": "1F7A6"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "204",
        "Dingbat hex": "CC",
        "Unicode dec": "128935",
        "Unicode hex": "1F7A7"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "205",
        "Dingbat hex": "CD",
        "Unicode dec": "128936",
        "Unicode hex": "1F7A8"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "206",
        "Dingbat hex": "CE",
        "Unicode dec": "128937",
        "Unicode hex": "1F7A9"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "207",
        "Dingbat hex": "CF",
        "Unicode dec": "128938",
        "Unicode hex": "1F7AA"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "208",
        "Dingbat hex": "D0",
        "Unicode dec": "128939",
        "Unicode hex": "1F7AB"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "209",
        "Dingbat hex": "D1",
        "Unicode dec": "128940",
        "Unicode hex": "1F7AC"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "210",
        "Dingbat hex": "D2",
        "Unicode dec": "128941",
        "Unicode hex": "1F7AD"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "211",
        "Dingbat hex": "D3",
        "Unicode dec": "128942",
        "Unicode hex": "1F7AE"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "212",
        "Dingbat hex": "D4",
        "Unicode dec": "128943",
        "Unicode hex": "1F7AF"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "213",
        "Dingbat hex": "D5",
        "Unicode dec": "128944",
        "Unicode hex": "1F7B0"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "214",
        "Dingbat hex": "D6",
        "Unicode dec": "128945",
        "Unicode hex": "1F7B1"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "215",
        "Dingbat hex": "D7",
        "Unicode dec": "128946",
        "Unicode hex": "1F7B2"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "216",
        "Dingbat hex": "D8",
        "Unicode dec": "128947",
        "Unicode hex": "1F7B3"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "217",
        "Dingbat hex": "D9",
        "Unicode dec": "128948",
        "Unicode hex": "1F7B4"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "218",
        "Dingbat hex": "DA",
        "Unicode dec": "128949",
        "Unicode hex": "1F7B5"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "219",
        "Dingbat hex": "DB",
        "Unicode dec": "128950",
        "Unicode hex": "1F7B6"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "220",
        "Dingbat hex": "DC",
        "Unicode dec": "128951",
        "Unicode hex": "1F7B7"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "221",
        "Dingbat hex": "DD",
        "Unicode dec": "128952",
        "Unicode hex": "1F7B8"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "222",
        "Dingbat hex": "DE",
        "Unicode dec": "128953",
        "Unicode hex": "1F7B9"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "223",
        "Dingbat hex": "DF",
        "Unicode dec": "128954",
        "Unicode hex": "1F7BA"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "224",
        "Dingbat hex": "E0",
        "Unicode dec": "128955",
        "Unicode hex": "1F7BB"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "225",
        "Dingbat hex": "E1",
        "Unicode dec": "128956",
        "Unicode hex": "1F7BC"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "226",
        "Dingbat hex": "E2",
        "Unicode dec": "128957",
        "Unicode hex": "1F7BD"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "227",
        "Dingbat hex": "E3",
        "Unicode dec": "128958",
        "Unicode hex": "1F7BE"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "228",
        "Dingbat hex": "E4",
        "Unicode dec": "128959",
        "Unicode hex": "1F7BF"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "229",
        "Dingbat hex": "E5",
        "Unicode dec": "128960",
        "Unicode hex": "1F7C0"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "230",
        "Dingbat hex": "E6",
        "Unicode dec": "128962",
        "Unicode hex": "1F7C2"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "231",
        "Dingbat hex": "E7",
        "Unicode dec": "128964",
        "Unicode hex": "1F7C4"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "232",
        "Dingbat hex": "E8",
        "Unicode dec": "128966",
        "Unicode hex": "1F7C6"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "233",
        "Dingbat hex": "E9",
        "Unicode dec": "128969",
        "Unicode hex": "1F7C9"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "234",
        "Dingbat hex": "EA",
        "Unicode dec": "128970",
        "Unicode hex": "1F7CA"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "235",
        "Dingbat hex": "EB",
        "Unicode dec": "10038",
        "Unicode hex": "2736"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "236",
        "Dingbat hex": "EC",
        "Unicode dec": "128972",
        "Unicode hex": "1F7CC"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "237",
        "Dingbat hex": "ED",
        "Unicode dec": "128974",
        "Unicode hex": "1F7CE"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "238",
        "Dingbat hex": "EE",
        "Unicode dec": "128976",
        "Unicode hex": "1F7D0"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "239",
        "Dingbat hex": "EF",
        "Unicode dec": "128978",
        "Unicode hex": "1F7D2"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "240",
        "Dingbat hex": "F0",
        "Unicode dec": "10041",
        "Unicode hex": "2739"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "241",
        "Dingbat hex": "F1",
        "Unicode dec": "128963",
        "Unicode hex": "1F7C3"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "242",
        "Dingbat hex": "F2",
        "Unicode dec": "128967",
        "Unicode hex": "1F7C7"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "243",
        "Dingbat hex": "F3",
        "Unicode dec": "10031",
        "Unicode hex": "272F"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "244",
        "Dingbat hex": "F4",
        "Unicode dec": "128973",
        "Unicode hex": "1F7CD"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "245",
        "Dingbat hex": "F5",
        "Unicode dec": "128980",
        "Unicode hex": "1F7D4"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "246",
        "Dingbat hex": "F6",
        "Unicode dec": "11212",
        "Unicode hex": "2BCC"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "247",
        "Dingbat hex": "F7",
        "Unicode dec": "11213",
        "Unicode hex": "2BCD"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "248",
        "Dingbat hex": "F8",
        "Unicode dec": "8251",
        "Unicode hex": "203B"
    },
    {
        "Typeface name": "Wingdings 2",
        "Dingbat dec": "249",
        "Dingbat hex": "F9",
        "Unicode dec": "8258",
        "Unicode hex": "2042"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "32",
        "Dingbat hex": "20",
        "Unicode dec": "32",
        "Unicode hex": "20"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "33",
        "Dingbat hex": "21",
        "Unicode dec": "11104",
        "Unicode hex": "2B60"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "34",
        "Dingbat hex": "22",
        "Unicode dec": "11106",
        "Unicode hex": "2B62"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "35",
        "Dingbat hex": "23",
        "Unicode dec": "11105",
        "Unicode hex": "2B61"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "36",
        "Dingbat hex": "24",
        "Unicode dec": "11107",
        "Unicode hex": "2B63"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "37",
        "Dingbat hex": "25",
        "Unicode dec": "11110",
        "Unicode hex": "2B66"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "38",
        "Dingbat hex": "26",
        "Unicode dec": "11111",
        "Unicode hex": "2B67"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "39",
        "Dingbat hex": "27",
        "Unicode dec": "11113",
        "Unicode hex": "2B69"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "40",
        "Dingbat hex": "28",
        "Unicode dec": "11112",
        "Unicode hex": "2B68"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "41",
        "Dingbat hex": "29",
        "Unicode dec": "11120",
        "Unicode hex": "2B70"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "42",
        "Dingbat hex": "2A",
        "Unicode dec": "11122",
        "Unicode hex": "2B72"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "43",
        "Dingbat hex": "2B",
        "Unicode dec": "11121",
        "Unicode hex": "2B71"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "44",
        "Dingbat hex": "2C",
        "Unicode dec": "11123",
        "Unicode hex": "2B73"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "45",
        "Dingbat hex": "2D",
        "Unicode dec": "11126",
        "Unicode hex": "2B76"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "46",
        "Dingbat hex": "2E",
        "Unicode dec": "11128",
        "Unicode hex": "2B78"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "47",
        "Dingbat hex": "2F",
        "Unicode dec": "11131",
        "Unicode hex": "2B7B"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "48",
        "Dingbat hex": "30",
        "Unicode dec": "11133",
        "Unicode hex": "2B7D"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "49",
        "Dingbat hex": "31",
        "Unicode dec": "11108",
        "Unicode hex": "2B64"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "50",
        "Dingbat hex": "32",
        "Unicode dec": "11109",
        "Unicode hex": "2B65"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "51",
        "Dingbat hex": "33",
        "Unicode dec": "11114",
        "Unicode hex": "2B6A"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "52",
        "Dingbat hex": "34",
        "Unicode dec": "11116",
        "Unicode hex": "2B6C"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "53",
        "Dingbat hex": "35",
        "Unicode dec": "11115",
        "Unicode hex": "2B6B"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "54",
        "Dingbat hex": "36",
        "Unicode dec": "11117",
        "Unicode hex": "2B6D"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "55",
        "Dingbat hex": "37",
        "Unicode dec": "11085",
        "Unicode hex": "2B4D"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "56",
        "Dingbat hex": "38",
        "Unicode dec": "11168",
        "Unicode hex": "2BA0"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "57",
        "Dingbat hex": "39",
        "Unicode dec": "11169",
        "Unicode hex": "2BA1"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "58",
        "Dingbat hex": "3A",
        "Unicode dec": "11170",
        "Unicode hex": "2BA2"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "59",
        "Dingbat hex": "3B",
        "Unicode dec": "11171",
        "Unicode hex": "2BA3"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "60",
        "Dingbat hex": "3C",
        "Unicode dec": "11172",
        "Unicode hex": "2BA4"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "61",
        "Dingbat hex": "3D",
        "Unicode dec": "11173",
        "Unicode hex": "2BA5"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "62",
        "Dingbat hex": "3E",
        "Unicode dec": "11174",
        "Unicode hex": "2BA6"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "63",
        "Dingbat hex": "3F",
        "Unicode dec": "11175",
        "Unicode hex": "2BA7"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "64",
        "Dingbat hex": "40",
        "Unicode dec": "11152",
        "Unicode hex": "2B90"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "65",
        "Dingbat hex": "41",
        "Unicode dec": "11153",
        "Unicode hex": "2B91"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "66",
        "Dingbat hex": "42",
        "Unicode dec": "11154",
        "Unicode hex": "2B92"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "67",
        "Dingbat hex": "43",
        "Unicode dec": "11155",
        "Unicode hex": "2B93"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "68",
        "Dingbat hex": "44",
        "Unicode dec": "11136",
        "Unicode hex": "2B80"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "69",
        "Dingbat hex": "45",
        "Unicode dec": "11139",
        "Unicode hex": "2B83"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "70",
        "Dingbat hex": "46",
        "Unicode dec": "11134",
        "Unicode hex": "2B7E"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "71",
        "Dingbat hex": "47",
        "Unicode dec": "11135",
        "Unicode hex": "2B7F"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "72",
        "Dingbat hex": "48",
        "Unicode dec": "11140",
        "Unicode hex": "2B84"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "73",
        "Dingbat hex": "49",
        "Unicode dec": "11142",
        "Unicode hex": "2B86"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "74",
        "Dingbat hex": "4A",
        "Unicode dec": "11141",
        "Unicode hex": "2B85"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "75",
        "Dingbat hex": "4B",
        "Unicode dec": "11143",
        "Unicode hex": "2B87"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "76",
        "Dingbat hex": "4C",
        "Unicode dec": "11151",
        "Unicode hex": "2B8F"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "77",
        "Dingbat hex": "4D",
        "Unicode dec": "11149",
        "Unicode hex": "2B8D"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "78",
        "Dingbat hex": "4E",
        "Unicode dec": "11150",
        "Unicode hex": "2B8E"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "79",
        "Dingbat hex": "4F",
        "Unicode dec": "11148",
        "Unicode hex": "2B8C"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "80",
        "Dingbat hex": "50",
        "Unicode dec": "11118",
        "Unicode hex": "2B6E"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "81",
        "Dingbat hex": "51",
        "Unicode dec": "11119",
        "Unicode hex": "2B6F"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "82",
        "Dingbat hex": "52",
        "Unicode dec": "9099",
        "Unicode hex": "238B"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "83",
        "Dingbat hex": "53",
        "Unicode dec": "8996",
        "Unicode hex": "2324"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "84",
        "Dingbat hex": "54",
        "Unicode dec": "8963",
        "Unicode hex": "2303"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "85",
        "Dingbat hex": "55",
        "Unicode dec": "8997",
        "Unicode hex": "2325"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "86",
        "Dingbat hex": "56",
        "Unicode dec": "9251",
        "Unicode hex": "2423"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "87",
        "Dingbat hex": "57",
        "Unicode dec": "9085",
        "Unicode hex": "237D"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "88",
        "Dingbat hex": "58",
        "Unicode dec": "8682",
        "Unicode hex": "21EA"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "89",
        "Dingbat hex": "59",
        "Unicode dec": "11192",
        "Unicode hex": "2BB8"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "90",
        "Dingbat hex": "5A",
        "Unicode dec": "129184",
        "Unicode hex": "1F8A0"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "91",
        "Dingbat hex": "5B",
        "Unicode dec": "129185",
        "Unicode hex": "1F8A1"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "92",
        "Dingbat hex": "5C",
        "Unicode dec": "129186",
        "Unicode hex": "1F8A2"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "93",
        "Dingbat hex": "5D",
        "Unicode dec": "129187",
        "Unicode hex": "1F8A3"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "94",
        "Dingbat hex": "5E",
        "Unicode dec": "129188",
        "Unicode hex": "1F8A4"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "95",
        "Dingbat hex": "5F",
        "Unicode dec": "129189",
        "Unicode hex": "1F8A5"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "96",
        "Dingbat hex": "60",
        "Unicode dec": "129190",
        "Unicode hex": "1F8A6"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "97",
        "Dingbat hex": "61",
        "Unicode dec": "129191",
        "Unicode hex": "1F8A7"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "98",
        "Dingbat hex": "62",
        "Unicode dec": "129192",
        "Unicode hex": "1F8A8"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "99",
        "Dingbat hex": "63",
        "Unicode dec": "129193",
        "Unicode hex": "1F8A9"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "100",
        "Dingbat hex": "64",
        "Unicode dec": "129194",
        "Unicode hex": "1F8AA"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "101",
        "Dingbat hex": "65",
        "Unicode dec": "129195",
        "Unicode hex": "1F8AB"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "102",
        "Dingbat hex": "66",
        "Unicode dec": "129104",
        "Unicode hex": "1F850"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "103",
        "Dingbat hex": "67",
        "Unicode dec": "129106",
        "Unicode hex": "1F852"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "104",
        "Dingbat hex": "68",
        "Unicode dec": "129105",
        "Unicode hex": "1F851"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "105",
        "Dingbat hex": "69",
        "Unicode dec": "129107",
        "Unicode hex": "1F853"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "106",
        "Dingbat hex": "6A",
        "Unicode dec": "129108",
        "Unicode hex": "1F854"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "107",
        "Dingbat hex": "6B",
        "Unicode dec": "129109",
        "Unicode hex": "1F855"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "108",
        "Dingbat hex": "6C",
        "Unicode dec": "129111",
        "Unicode hex": "1F857"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "109",
        "Dingbat hex": "6D",
        "Unicode dec": "129110",
        "Unicode hex": "1F856"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "110",
        "Dingbat hex": "6E",
        "Unicode dec": "129112",
        "Unicode hex": "1F858"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "111",
        "Dingbat hex": "6F",
        "Unicode dec": "129113",
        "Unicode hex": "1F859"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "112",
        "Dingbat hex": "70",
        "Unicode dec": "9650",
        "Unicode hex": "25B2"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "113",
        "Dingbat hex": "71",
        "Unicode dec": "9660",
        "Unicode hex": "25BC"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "114",
        "Dingbat hex": "72",
        "Unicode dec": "9651",
        "Unicode hex": "25B3"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "115",
        "Dingbat hex": "73",
        "Unicode dec": "9661",
        "Unicode hex": "25BD"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "116",
        "Dingbat hex": "74",
        "Unicode dec": "9664",
        "Unicode hex": "25C0"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "117",
        "Dingbat hex": "75",
        "Unicode dec": "9654",
        "Unicode hex": "25B6"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "118",
        "Dingbat hex": "76",
        "Unicode dec": "9665",
        "Unicode hex": "25C1"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "119",
        "Dingbat hex": "77",
        "Unicode dec": "9655",
        "Unicode hex": "25B7"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "120",
        "Dingbat hex": "78",
        "Unicode dec": "9699",
        "Unicode hex": "25E3"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "121",
        "Dingbat hex": "79",
        "Unicode dec": "9698",
        "Unicode hex": "25E2"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "122",
        "Dingbat hex": "7A",
        "Unicode dec": "9700",
        "Unicode hex": "25E4"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "123",
        "Dingbat hex": "7B",
        "Unicode dec": "9701",
        "Unicode hex": "25E5"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "124",
        "Dingbat hex": "7C",
        "Unicode dec": "128896",
        "Unicode hex": "1F780"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "125",
        "Dingbat hex": "7D",
        "Unicode dec": "128898",
        "Unicode hex": "1F782"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "126",
        "Dingbat hex": "7E",
        "Unicode dec": "128897",
        "Unicode hex": "1F781"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "128",
        "Dingbat hex": "80",
        "Unicode dec": "128899",
        "Unicode hex": "1F783"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "129",
        "Dingbat hex": "81",
        "Unicode dec": "11205",
        "Unicode hex": "2BC5"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "130",
        "Dingbat hex": "82",
        "Unicode dec": "11206",
        "Unicode hex": "2BC6"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "131",
        "Dingbat hex": "83",
        "Unicode dec": "11207",
        "Unicode hex": "2BC7"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "132",
        "Dingbat hex": "84",
        "Unicode dec": "11208",
        "Unicode hex": "2BC8"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "133",
        "Dingbat hex": "85",
        "Unicode dec": "11164",
        "Unicode hex": "2B9C"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "134",
        "Dingbat hex": "86",
        "Unicode dec": "11166",
        "Unicode hex": "2B9E"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "135",
        "Dingbat hex": "87",
        "Unicode dec": "11165",
        "Unicode hex": "2B9D"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "136",
        "Dingbat hex": "88",
        "Unicode dec": "11167",
        "Unicode hex": "2B9F"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "137",
        "Dingbat hex": "89",
        "Unicode dec": "129040",
        "Unicode hex": "1F810"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "138",
        "Dingbat hex": "8A",
        "Unicode dec": "129042",
        "Unicode hex": "1F812"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "139",
        "Dingbat hex": "8B",
        "Unicode dec": "129041",
        "Unicode hex": "1F811"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "140",
        "Dingbat hex": "8C",
        "Unicode dec": "129043",
        "Unicode hex": "1F813"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "141",
        "Dingbat hex": "8D",
        "Unicode dec": "129044",
        "Unicode hex": "1F814"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "142",
        "Dingbat hex": "8E",
        "Unicode dec": "129046",
        "Unicode hex": "1F816"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "143",
        "Dingbat hex": "8F",
        "Unicode dec": "129045",
        "Unicode hex": "1F815"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "144",
        "Dingbat hex": "90",
        "Unicode dec": "129047",
        "Unicode hex": "1F817"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "145",
        "Dingbat hex": "91",
        "Unicode dec": "129048",
        "Unicode hex": "1F818"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "146",
        "Dingbat hex": "92",
        "Unicode dec": "129050",
        "Unicode hex": "1F81A"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "147",
        "Dingbat hex": "93",
        "Unicode dec": "129049",
        "Unicode hex": "1F819"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "148",
        "Dingbat hex": "94",
        "Unicode dec": "129051",
        "Unicode hex": "1F81B"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "149",
        "Dingbat hex": "95",
        "Unicode dec": "129052",
        "Unicode hex": "1F81C"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "150",
        "Dingbat hex": "96",
        "Unicode dec": "129054",
        "Unicode hex": "1F81E"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "151",
        "Dingbat hex": "97",
        "Unicode dec": "129053",
        "Unicode hex": "1F81D"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "152",
        "Dingbat hex": "98",
        "Unicode dec": "129055",
        "Unicode hex": "1F81F"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "153",
        "Dingbat hex": "99",
        "Unicode dec": "129024",
        "Unicode hex": "1F800"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "154",
        "Dingbat hex": "9A",
        "Unicode dec": "129026",
        "Unicode hex": "1F802"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "155",
        "Dingbat hex": "9B",
        "Unicode dec": "129025",
        "Unicode hex": "1F801"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "156",
        "Dingbat hex": "9C",
        "Unicode dec": "129027",
        "Unicode hex": "1F803"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "157",
        "Dingbat hex": "9D",
        "Unicode dec": "129028",
        "Unicode hex": "1F804"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "158",
        "Dingbat hex": "9E",
        "Unicode dec": "129030",
        "Unicode hex": "1F806"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "159",
        "Dingbat hex": "9F",
        "Unicode dec": "129029",
        "Unicode hex": "1F805"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "160",
        "Dingbat hex": "A0",
        "Unicode dec": "129031",
        "Unicode hex": "1F807"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "161",
        "Dingbat hex": "A1",
        "Unicode dec": "129032",
        "Unicode hex": "1F808"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "162",
        "Dingbat hex": "A2",
        "Unicode dec": "129034",
        "Unicode hex": "1F80A"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "163",
        "Dingbat hex": "A3",
        "Unicode dec": "129033",
        "Unicode hex": "1F809"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "164",
        "Dingbat hex": "A4",
        "Unicode dec": "129035",
        "Unicode hex": "1F80B"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "165",
        "Dingbat hex": "A5",
        "Unicode dec": "129056",
        "Unicode hex": "1F820"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "166",
        "Dingbat hex": "A6",
        "Unicode dec": "129058",
        "Unicode hex": "1F822"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "167",
        "Dingbat hex": "A7",
        "Unicode dec": "129060",
        "Unicode hex": "1F824"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "168",
        "Dingbat hex": "A8",
        "Unicode dec": "129062",
        "Unicode hex": "1F826"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "169",
        "Dingbat hex": "A9",
        "Unicode dec": "129064",
        "Unicode hex": "1F828"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "170",
        "Dingbat hex": "AA",
        "Unicode dec": "129066",
        "Unicode hex": "1F82A"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "171",
        "Dingbat hex": "AB",
        "Unicode dec": "129068",
        "Unicode hex": "1F82C"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "172",
        "Dingbat hex": "AC",
        "Unicode dec": "129180",
        "Unicode hex": "1F89C"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "173",
        "Dingbat hex": "AD",
        "Unicode dec": "129181",
        "Unicode hex": "1F89D"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "174",
        "Dingbat hex": "AE",
        "Unicode dec": "129182",
        "Unicode hex": "1F89E"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "175",
        "Dingbat hex": "AF",
        "Unicode dec": "129183",
        "Unicode hex": "1F89F"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "176",
        "Dingbat hex": "B0",
        "Unicode dec": "129070",
        "Unicode hex": "1F82E"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "177",
        "Dingbat hex": "B1",
        "Unicode dec": "129072",
        "Unicode hex": "1F830"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "178",
        "Dingbat hex": "B2",
        "Unicode dec": "129074",
        "Unicode hex": "1F832"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "179",
        "Dingbat hex": "B3",
        "Unicode dec": "129076",
        "Unicode hex": "1F834"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "180",
        "Dingbat hex": "B4",
        "Unicode dec": "129078",
        "Unicode hex": "1F836"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "181",
        "Dingbat hex": "B5",
        "Unicode dec": "129080",
        "Unicode hex": "1F838"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "182",
        "Dingbat hex": "B6",
        "Unicode dec": "129082",
        "Unicode hex": "1F83A"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "183",
        "Dingbat hex": "B7",
        "Unicode dec": "129081",
        "Unicode hex": "1F839"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "184",
        "Dingbat hex": "B8",
        "Unicode dec": "129083",
        "Unicode hex": "1F83B"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "185",
        "Dingbat hex": "B9",
        "Unicode dec": "129176",
        "Unicode hex": "1F898"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "186",
        "Dingbat hex": "BA",
        "Unicode dec": "129178",
        "Unicode hex": "1F89A"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "187",
        "Dingbat hex": "BB",
        "Unicode dec": "129177",
        "Unicode hex": "1F899"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "188",
        "Dingbat hex": "BC",
        "Unicode dec": "129179",
        "Unicode hex": "1F89B"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "189",
        "Dingbat hex": "BD",
        "Unicode dec": "129084",
        "Unicode hex": "1F83C"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "190",
        "Dingbat hex": "BE",
        "Unicode dec": "129086",
        "Unicode hex": "1F83E"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "191",
        "Dingbat hex": "BF",
        "Unicode dec": "129085",
        "Unicode hex": "1F83D"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "192",
        "Dingbat hex": "C0",
        "Unicode dec": "129087",
        "Unicode hex": "1F83F"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "193",
        "Dingbat hex": "C1",
        "Unicode dec": "129088",
        "Unicode hex": "1F840"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "194",
        "Dingbat hex": "C2",
        "Unicode dec": "129090",
        "Unicode hex": "1F842"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "195",
        "Dingbat hex": "C3",
        "Unicode dec": "129089",
        "Unicode hex": "1F841"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "196",
        "Dingbat hex": "C4",
        "Unicode dec": "129091",
        "Unicode hex": "1F843"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "197",
        "Dingbat hex": "C5",
        "Unicode dec": "129092",
        "Unicode hex": "1F844"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "198",
        "Dingbat hex": "C6",
        "Unicode dec": "129094",
        "Unicode hex": "1F846"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "199",
        "Dingbat hex": "C7",
        "Unicode dec": "129093",
        "Unicode hex": "1F845"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "200",
        "Dingbat hex": "C8",
        "Unicode dec": "129095",
        "Unicode hex": "1F847"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "201",
        "Dingbat hex": "C9",
        "Unicode dec": "11176",
        "Unicode hex": "2BA8"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "202",
        "Dingbat hex": "CA",
        "Unicode dec": "11177",
        "Unicode hex": "2BA9"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "203",
        "Dingbat hex": "CB",
        "Unicode dec": "11178",
        "Unicode hex": "2BAA"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "204",
        "Dingbat hex": "CC",
        "Unicode dec": "11179",
        "Unicode hex": "2BAB"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "205",
        "Dingbat hex": "CD",
        "Unicode dec": "11180",
        "Unicode hex": "2BAC"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "206",
        "Dingbat hex": "CE",
        "Unicode dec": "11181",
        "Unicode hex": "2BAD"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "207",
        "Dingbat hex": "CF",
        "Unicode dec": "11182",
        "Unicode hex": "2BAE"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "208",
        "Dingbat hex": "D0",
        "Unicode dec": "11183",
        "Unicode hex": "2BAF"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "209",
        "Dingbat hex": "D1",
        "Unicode dec": "129120",
        "Unicode hex": "1F860"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "210",
        "Dingbat hex": "D2",
        "Unicode dec": "129122",
        "Unicode hex": "1F862"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "211",
        "Dingbat hex": "D3",
        "Unicode dec": "129121",
        "Unicode hex": "1F861"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "212",
        "Dingbat hex": "D4",
        "Unicode dec": "129123",
        "Unicode hex": "1F863"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "213",
        "Dingbat hex": "D5",
        "Unicode dec": "129124",
        "Unicode hex": "1F864"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "214",
        "Dingbat hex": "D6",
        "Unicode dec": "129125",
        "Unicode hex": "1F865"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "215",
        "Dingbat hex": "D7",
        "Unicode dec": "129127",
        "Unicode hex": "1F867"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "216",
        "Dingbat hex": "D8",
        "Unicode dec": "129126",
        "Unicode hex": "1F866"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "217",
        "Dingbat hex": "D9",
        "Unicode dec": "129136",
        "Unicode hex": "1F870"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "218",
        "Dingbat hex": "DA",
        "Unicode dec": "129138",
        "Unicode hex": "1F872"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "219",
        "Dingbat hex": "DB",
        "Unicode dec": "129137",
        "Unicode hex": "1F871"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "220",
        "Dingbat hex": "DC",
        "Unicode dec": "129139",
        "Unicode hex": "1F873"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "221",
        "Dingbat hex": "DD",
        "Unicode dec": "129140",
        "Unicode hex": "1F874"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "222",
        "Dingbat hex": "DE",
        "Unicode dec": "129141",
        "Unicode hex": "1F875"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "223",
        "Dingbat hex": "DF",
        "Unicode dec": "129143",
        "Unicode hex": "1F877"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "224",
        "Dingbat hex": "E0",
        "Unicode dec": "129142",
        "Unicode hex": "1F876"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "225",
        "Dingbat hex": "E1",
        "Unicode dec": "129152",
        "Unicode hex": "1F880"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "226",
        "Dingbat hex": "E2",
        "Unicode dec": "129154",
        "Unicode hex": "1F882"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "227",
        "Dingbat hex": "E3",
        "Unicode dec": "129153",
        "Unicode hex": "1F881"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "228",
        "Dingbat hex": "E4",
        "Unicode dec": "129155",
        "Unicode hex": "1F883"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "229",
        "Dingbat hex": "E5",
        "Unicode dec": "129156",
        "Unicode hex": "1F884"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "230",
        "Dingbat hex": "E6",
        "Unicode dec": "129157",
        "Unicode hex": "1F885"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "231",
        "Dingbat hex": "E7",
        "Unicode dec": "129159",
        "Unicode hex": "1F887"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "232",
        "Dingbat hex": "E8",
        "Unicode dec": "129158",
        "Unicode hex": "1F886"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "233",
        "Dingbat hex": "E9",
        "Unicode dec": "129168",
        "Unicode hex": "1F890"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "234",
        "Dingbat hex": "EA",
        "Unicode dec": "129170",
        "Unicode hex": "1F892"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "235",
        "Dingbat hex": "EB",
        "Unicode dec": "129169",
        "Unicode hex": "1F891"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "236",
        "Dingbat hex": "EC",
        "Unicode dec": "129171",
        "Unicode hex": "1F893"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "237",
        "Dingbat hex": "ED",
        "Unicode dec": "129172",
        "Unicode hex": "1F894"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "238",
        "Dingbat hex": "EE",
        "Unicode dec": "129174",
        "Unicode hex": "1F896"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "239",
        "Dingbat hex": "EF",
        "Unicode dec": "129173",
        "Unicode hex": "1F895"
    },
    {
        "Typeface name": "Wingdings 3",
        "Dingbat dec": "240",
        "Dingbat hex": "F0",
        "Unicode dec": "129175",
        "Unicode hex": "1F897"
    }
];
module.exports.default = $e6086d8520c6d42a$var$dingbats;

});

parcelRegister("kUMgi", function(module, exports) {

$parcel$export(module.exports, "paragraph", function () { return $f39e79698ee33a3c$export$9c206ddddb32a9b; }, function (v) { return $f39e79698ee33a3c$export$9c206ddddb32a9b = v; });
$parcel$export(module.exports, "run", function () { return $f39e79698ee33a3c$export$889ea624f2cb2c57; }, function (v) { return $f39e79698ee33a3c$export$889ea624f2cb2c57 = v; });
$parcel$export(module.exports, "_elements", function () { return $f39e79698ee33a3c$export$297bfd0191b750db; }, function (v) { return $f39e79698ee33a3c$export$297bfd0191b750db = v; });
$parcel$export(module.exports, "_elementsOfType", function () { return $f39e79698ee33a3c$export$e7e1b0baa764e14f; }, function (v) { return $f39e79698ee33a3c$export$e7e1b0baa764e14f = v; });
$parcel$export(module.exports, "getDescendantsOfType", function () { return $f39e79698ee33a3c$export$a892993bbae48540; }, function (v) { return $f39e79698ee33a3c$export$a892993bbae48540 = v; });
$parcel$export(module.exports, "getDescendants", function () { return $f39e79698ee33a3c$export$d607bcb6675e3e03; }, function (v) { return $f39e79698ee33a3c$export$d607bcb6675e3e03 = v; });
var $f39e79698ee33a3c$export$9c206ddddb32a9b;
var $f39e79698ee33a3c$export$889ea624f2cb2c57;
var $f39e79698ee33a3c$export$297bfd0191b750db;
var $f39e79698ee33a3c$export$e7e1b0baa764e14f;
var $f39e79698ee33a3c$export$a892993bbae48540;
var $f39e79698ee33a3c$export$d607bcb6675e3e03;
parcelRequire("9jAvV");
var $5yjjJ = parcelRequire("5yjjJ");
var $gfTwJ = parcelRequire("gfTwJ");
$f39e79698ee33a3c$export$9c206ddddb32a9b = $f39e79698ee33a3c$var$paragraph;
$f39e79698ee33a3c$export$889ea624f2cb2c57 = $f39e79698ee33a3c$var$run;
$f39e79698ee33a3c$export$297bfd0191b750db = $f39e79698ee33a3c$var$elements;
$f39e79698ee33a3c$export$e7e1b0baa764e14f = $f39e79698ee33a3c$var$elementsOfType;
$f39e79698ee33a3c$export$a892993bbae48540 = $f39e79698ee33a3c$var$getDescendantsOfType;
$f39e79698ee33a3c$export$d607bcb6675e3e03 = $f39e79698ee33a3c$var$getDescendants;
function $f39e79698ee33a3c$var$paragraph(transform) {
    return $f39e79698ee33a3c$var$elementsOfType("paragraph", transform);
}
function $f39e79698ee33a3c$var$run(transform) {
    return $f39e79698ee33a3c$var$elementsOfType("run", transform);
}
function $f39e79698ee33a3c$var$elementsOfType(elementType, transform) {
    return $f39e79698ee33a3c$var$elements(function(element) {
        if (element.type === elementType) return transform(element);
        else return element;
    });
}
function $f39e79698ee33a3c$var$elements(transform) {
    return function transformElement(element) {
        if (element.children) {
            var children = $gfTwJ.default(element.children, transformElement);
            element = $5yjjJ.default(element, {
                children: children
            });
        }
        return transform(element);
    };
}
function $f39e79698ee33a3c$var$getDescendantsOfType(element, type) {
    return $f39e79698ee33a3c$var$getDescendants(element).filter(function(descendant) {
        return descendant.type === type;
    });
}
function $f39e79698ee33a3c$var$getDescendants(element) {
    var descendants = [];
    $f39e79698ee33a3c$var$visitDescendants(element, function(descendant) {
        descendants.push(descendant);
    });
    return descendants;
}
function $f39e79698ee33a3c$var$visitDescendants(element, visit) {
    if (element.children) element.children.forEach(function(child) {
        $f39e79698ee33a3c$var$visitDescendants(child, visit);
        visit(child);
    });
}

});

parcelRegister("3OjMG", function(module, exports) {
parcelRequire("9jAvV");
var $1TwZj = parcelRequire("1TwZj");
var $gfTwJ = parcelRequire("gfTwJ");

var $cLuIA = parcelRequire("cLuIA");
function $2c65635a21c9a7c6$var$simplify(nodes) {
    return $2c65635a21c9a7c6$var$collapse($2c65635a21c9a7c6$var$removeEmpty(nodes));
}
function $2c65635a21c9a7c6$var$collapse(nodes) {
    var children = [];
    nodes.map($2c65635a21c9a7c6$var$collapseNode).forEach(function(child) {
        $2c65635a21c9a7c6$var$appendChild(children, child);
    });
    return children;
}
function $2c65635a21c9a7c6$var$collapseNode(node) {
    return $2c65635a21c9a7c6$var$collapsers[node.type](node);
}
var $2c65635a21c9a7c6$var$collapsers = {
    element: $2c65635a21c9a7c6$var$collapseElement,
    text: $2c65635a21c9a7c6$var$identity,
    forceWrite: $2c65635a21c9a7c6$var$identity
};
function $2c65635a21c9a7c6$var$collapseElement(node) {
    return $cLuIA.elementWithTag(node.tag, $2c65635a21c9a7c6$var$collapse(node.children));
}
function $2c65635a21c9a7c6$var$identity(value) {
    return value;
}
function $2c65635a21c9a7c6$var$appendChild(children, child) {
    var lastChild = children[children.length - 1];
    if (child.type === "element" && !child.tag.fresh && lastChild && lastChild.type === "element" && child.tag.matchesElement(lastChild.tag)) {
        if (child.tag.separator) $2c65635a21c9a7c6$var$appendChild(lastChild.children, $cLuIA.text(child.tag.separator));
        child.children.forEach(function(grandChild) {
            // Mutation is fine since simplifying elements create a copy of the children.
            $2c65635a21c9a7c6$var$appendChild(lastChild.children, grandChild);
        });
    } else children.push(child);
}
function $2c65635a21c9a7c6$var$removeEmpty(nodes) {
    return $2c65635a21c9a7c6$var$flatMap(nodes, function(node) {
        return $2c65635a21c9a7c6$var$emptiers[node.type](node);
    });
}
function $2c65635a21c9a7c6$var$flatMap(values, func) {
    return $1TwZj.default($gfTwJ.default(values, func), true);
}
var $2c65635a21c9a7c6$var$emptiers = {
    element: $2c65635a21c9a7c6$var$elementEmptier,
    text: $2c65635a21c9a7c6$var$textEmptier,
    forceWrite: $2c65635a21c9a7c6$var$neverEmpty
};
function $2c65635a21c9a7c6$var$neverEmpty(node) {
    return [
        node
    ];
}
function $2c65635a21c9a7c6$var$elementEmptier(element) {
    var children = $2c65635a21c9a7c6$var$removeEmpty(element.children);
    if (children.length === 0 && !$cLuIA.isVoidElement(element)) return [];
    else return [
        $cLuIA.elementWithTag(element.tag, children)
    ];
}
function $2c65635a21c9a7c6$var$textEmptier(node) {
    if (node.value.length === 0) return [];
    else return [
        node
    ];
}
module.exports = $2c65635a21c9a7c6$var$simplify;

});
parcelRegister("cLuIA", function(module, exports) {

$parcel$export(module.exports, "freshElement", function () { return $94b1b3d026189e52$export$930fc3b604aa2e41; }, function (v) { return $94b1b3d026189e52$export$930fc3b604aa2e41 = v; });
$parcel$export(module.exports, "nonFreshElement", function () { return $94b1b3d026189e52$export$288e963e20e7093f; }, function (v) { return $94b1b3d026189e52$export$288e963e20e7093f = v; });
$parcel$export(module.exports, "elementWithTag", function () { return $94b1b3d026189e52$export$dca5772e3b681cdf; }, function (v) { return $94b1b3d026189e52$export$dca5772e3b681cdf = v; });
$parcel$export(module.exports, "text", function () { return $94b1b3d026189e52$export$6f093cfa640b7166; }, function (v) { return $94b1b3d026189e52$export$6f093cfa640b7166 = v; });
$parcel$export(module.exports, "forceWrite", function () { return $94b1b3d026189e52$export$a98c45d6a360f787; }, function (v) { return $94b1b3d026189e52$export$a98c45d6a360f787 = v; });
$parcel$export(module.exports, "isVoidElement", function () { return $94b1b3d026189e52$export$ce7b605508b1d8cd; }, function (v) { return $94b1b3d026189e52$export$ce7b605508b1d8cd = v; });
var $94b1b3d026189e52$export$930fc3b604aa2e41;
var $94b1b3d026189e52$export$288e963e20e7093f;
var $94b1b3d026189e52$export$dca5772e3b681cdf;
var $94b1b3d026189e52$export$6f093cfa640b7166;
var $94b1b3d026189e52$export$a98c45d6a360f787;
var $94b1b3d026189e52$export$ce7b605508b1d8cd;

var $hEvL6 = parcelRequire("hEvL6");
function $94b1b3d026189e52$var$nonFreshElement(tagName, attributes, children) {
    return $94b1b3d026189e52$var$elementWithTag($hEvL6.element(tagName, attributes, {
        fresh: false
    }), children);
}
function $94b1b3d026189e52$var$freshElement(tagName, attributes, children) {
    var tag = $hEvL6.element(tagName, attributes, {
        fresh: true
    });
    return $94b1b3d026189e52$var$elementWithTag(tag, children);
}
function $94b1b3d026189e52$var$elementWithTag(tag, children) {
    return {
        type: "element",
        tag: tag,
        children: children || []
    };
}
function $94b1b3d026189e52$var$text(value) {
    return {
        type: "text",
        value: value
    };
}
var $94b1b3d026189e52$var$forceWrite = {
    type: "forceWrite"
};
$94b1b3d026189e52$export$930fc3b604aa2e41 = $94b1b3d026189e52$var$freshElement;
$94b1b3d026189e52$export$288e963e20e7093f = $94b1b3d026189e52$var$nonFreshElement;
$94b1b3d026189e52$export$dca5772e3b681cdf = $94b1b3d026189e52$var$elementWithTag;
$94b1b3d026189e52$export$6f093cfa640b7166 = $94b1b3d026189e52$var$text;
$94b1b3d026189e52$export$a98c45d6a360f787 = $94b1b3d026189e52$var$forceWrite;
var $94b1b3d026189e52$var$voidTagNames = {
    "br": true,
    "hr": true,
    "img": true,
    "input": true
};
function $94b1b3d026189e52$var$isVoidElement(node) {
    return node.children.length === 0 && $94b1b3d026189e52$var$voidTagNames[node.tag.tagName];
}
$94b1b3d026189e52$export$ce7b605508b1d8cd = $94b1b3d026189e52$var$isVoidElement;

});
parcelRegister("hEvL6", function(module, exports) {

$parcel$export(module.exports, "topLevelElement", function () { return $cd9eceb8237fc342$export$3f0e324b0c23f49b; }, function (v) { return $cd9eceb8237fc342$export$3f0e324b0c23f49b = v; });
$parcel$export(module.exports, "elements", function () { return $cd9eceb8237fc342$export$7a5d735b2ab6389d; }, function (v) { return $cd9eceb8237fc342$export$7a5d735b2ab6389d = v; });
$parcel$export(module.exports, "element", function () { return $cd9eceb8237fc342$export$8454457683f90105; }, function (v) { return $cd9eceb8237fc342$export$8454457683f90105 = v; });
$parcel$export(module.exports, "empty", function () { return $cd9eceb8237fc342$export$6e22c362a0406a2c; }, function (v) { return $cd9eceb8237fc342$export$6e22c362a0406a2c = v; });
$parcel$export(module.exports, "ignore", function () { return $cd9eceb8237fc342$export$738b109e247a462c; }, function (v) { return $cd9eceb8237fc342$export$738b109e247a462c = v; });
var $cd9eceb8237fc342$export$3f0e324b0c23f49b;
var $cd9eceb8237fc342$export$7a5d735b2ab6389d;
var $cd9eceb8237fc342$export$8454457683f90105;
var $cd9eceb8237fc342$export$6e22c362a0406a2c;
var $cd9eceb8237fc342$export$738b109e247a462c;
parcelRequire("9jAvV");
var $3rBlz = parcelRequire("3rBlz");
var $8C01Z = parcelRequire("8C01Z");
var $jmGFg = parcelRequire("jmGFg");

var $8eobO = parcelRequire("8eobO");
$cd9eceb8237fc342$export$3f0e324b0c23f49b = $cd9eceb8237fc342$var$topLevelElement;
$cd9eceb8237fc342$export$7a5d735b2ab6389d = $cd9eceb8237fc342$var$elements;
$cd9eceb8237fc342$export$8454457683f90105 = $cd9eceb8237fc342$var$element;
function $cd9eceb8237fc342$var$topLevelElement(tagName, attributes) {
    return $cd9eceb8237fc342$var$elements([
        $cd9eceb8237fc342$var$element(tagName, attributes, {
            fresh: true
        })
    ]);
}
function $cd9eceb8237fc342$var$elements(elementStyles) {
    return new $cd9eceb8237fc342$var$HtmlPath(elementStyles.map(function(elementStyle) {
        if ($jmGFg.default(elementStyle)) return $cd9eceb8237fc342$var$element(elementStyle);
        else return elementStyle;
    }));
}
function $cd9eceb8237fc342$var$HtmlPath(elements) {
    this._elements = elements;
}
$cd9eceb8237fc342$var$HtmlPath.prototype.wrap = function wrap(children) {
    var result = children();
    for(var index = this._elements.length - 1; index >= 0; index--)result = this._elements[index].wrapNodes(result);
    return result;
};
function $cd9eceb8237fc342$var$element(tagName, attributes, options) {
    options = options || {};
    return new $cd9eceb8237fc342$var$Element(tagName, attributes, options);
}
function $cd9eceb8237fc342$var$Element(tagName, attributes, options) {
    var tagNames = {};
    if ($3rBlz.default(tagName)) {
        tagName.forEach(function(tagName) {
            tagNames[tagName] = true;
        });
        tagName = tagName[0];
    } else tagNames[tagName] = true;
    this.tagName = tagName;
    this.tagNames = tagNames;
    this.attributes = attributes || {};
    this.fresh = options.fresh;
    this.separator = options.separator;
}
$cd9eceb8237fc342$var$Element.prototype.matchesElement = function(element) {
    return this.tagNames[element.tagName] && $8C01Z.default(this.attributes || {}, element.attributes || {});
};
$cd9eceb8237fc342$var$Element.prototype.wrap = function wrap(generateNodes) {
    return this.wrapNodes(generateNodes());
};
$cd9eceb8237fc342$var$Element.prototype.wrapNodes = function wrapNodes(nodes) {
    return [
        $8eobO.elementWithTag(this, nodes)
    ];
};
$cd9eceb8237fc342$export$6e22c362a0406a2c = $cd9eceb8237fc342$var$elements([]);
$cd9eceb8237fc342$export$738b109e247a462c = {
    wrap: function() {
        return [];
    }
};

});
parcelRegister("8eobO", function(module, exports) {

$parcel$export(module.exports, "freshElement", function () { return $5fe26518616359bb$export$930fc3b604aa2e41; }, function (v) { return $5fe26518616359bb$export$930fc3b604aa2e41 = v; });
$parcel$export(module.exports, "nonFreshElement", function () { return $5fe26518616359bb$export$288e963e20e7093f; }, function (v) { return $5fe26518616359bb$export$288e963e20e7093f = v; });
$parcel$export(module.exports, "elementWithTag", function () { return $5fe26518616359bb$export$dca5772e3b681cdf; }, function (v) { return $5fe26518616359bb$export$dca5772e3b681cdf = v; });
$parcel$export(module.exports, "text", function () { return $5fe26518616359bb$export$6f093cfa640b7166; }, function (v) { return $5fe26518616359bb$export$6f093cfa640b7166 = v; });
$parcel$export(module.exports, "forceWrite", function () { return $5fe26518616359bb$export$a98c45d6a360f787; }, function (v) { return $5fe26518616359bb$export$a98c45d6a360f787 = v; });
$parcel$export(module.exports, "simplify", function () { return $5fe26518616359bb$export$798b53621063651; }, function (v) { return $5fe26518616359bb$export$798b53621063651 = v; });
$parcel$export(module.exports, "write", function () { return $5fe26518616359bb$export$68d8715fc104d294; }, function (v) { return $5fe26518616359bb$export$68d8715fc104d294 = v; });
var $5fe26518616359bb$export$930fc3b604aa2e41;
var $5fe26518616359bb$export$288e963e20e7093f;
var $5fe26518616359bb$export$dca5772e3b681cdf;
var $5fe26518616359bb$export$6f093cfa640b7166;
var $5fe26518616359bb$export$a98c45d6a360f787;
var $5fe26518616359bb$export$798b53621063651;
var $5fe26518616359bb$export$68d8715fc104d294;

var $cLuIA = parcelRequire("cLuIA");
$5fe26518616359bb$export$930fc3b604aa2e41 = $cLuIA.freshElement;
$5fe26518616359bb$export$288e963e20e7093f = $cLuIA.nonFreshElement;
$5fe26518616359bb$export$dca5772e3b681cdf = $cLuIA.elementWithTag;
$5fe26518616359bb$export$6f093cfa640b7166 = $cLuIA.text;
$5fe26518616359bb$export$a98c45d6a360f787 = $cLuIA.forceWrite;

$5fe26518616359bb$export$798b53621063651 = (parcelRequire("3OjMG"));
function $5fe26518616359bb$var$write(writer, nodes) {
    nodes.forEach(function(node) {
        $5fe26518616359bb$var$writeNode(writer, node);
    });
}
function $5fe26518616359bb$var$writeNode(writer, node) {
    $5fe26518616359bb$var$toStrings[node.type](writer, node);
}
var $5fe26518616359bb$var$toStrings = {
    element: $5fe26518616359bb$var$generateElementString,
    text: $5fe26518616359bb$var$generateTextString,
    forceWrite: function() {}
};
function $5fe26518616359bb$var$generateElementString(writer, node) {
    if ($cLuIA.isVoidElement(node)) writer.selfClosing(node.tag.tagName, node.tag.attributes);
    else {
        writer.open(node.tag.tagName, node.tag.attributes);
        $5fe26518616359bb$var$write(writer, node.children);
        writer.close(node.tag.tagName);
    }
}
function $5fe26518616359bb$var$generateTextString(writer, node) {
    writer.text(node.value);
}
$5fe26518616359bb$export$68d8715fc104d294 = $5fe26518616359bb$var$write;

});




parcelRegister("gOpjt", function(module, exports) {

$parcel$export(module.exports, "imgElement", function () { return $c3d4f3817c09ab04$export$447d08562cb82152; }, function (v) { return $c3d4f3817c09ab04$export$447d08562cb82152 = v; });
$parcel$export(module.exports, "inline", function () { return $c3d4f3817c09ab04$export$18c8ad048e32c7d5; }, function (v) { return $c3d4f3817c09ab04$export$18c8ad048e32c7d5 = v; });
$parcel$export(module.exports, "dataUri", function () { return $c3d4f3817c09ab04$export$bc36deb06467538e; }, function (v) { return $c3d4f3817c09ab04$export$bc36deb06467538e = v; });
var $c3d4f3817c09ab04$export$447d08562cb82152;
// Undocumented, but retained for backwards-compatibility with 0.3.x
var $c3d4f3817c09ab04$export$18c8ad048e32c7d5;
var $c3d4f3817c09ab04$export$bc36deb06467538e;
parcelRequire("9jAvV");
var $5yjjJ = parcelRequire("5yjjJ");

var $d93yU = parcelRequire("d93yU");

var $8eobO = parcelRequire("8eobO");
$c3d4f3817c09ab04$export$447d08562cb82152 = $c3d4f3817c09ab04$var$imgElement;
function $c3d4f3817c09ab04$var$imgElement(func) {
    return function(element, messages) {
        return $d93yU.when(func(element)).then(function(result) {
            var attributes = {};
            if (element.altText) attributes.alt = element.altText;
            $5yjjJ.default(attributes, result);
            return [
                $8eobO.freshElement("img", attributes)
            ];
        });
    };
}
$c3d4f3817c09ab04$export$18c8ad048e32c7d5 = $c3d4f3817c09ab04$export$447d08562cb82152;
$c3d4f3817c09ab04$export$bc36deb06467538e = $c3d4f3817c09ab04$var$imgElement(function(element) {
    return element.readAsBase64String().then(function(imageBuffer) {
        return {
            src: "data:" + element.contentType + ";base64," + imageBuffer
        };
    });
});

});

parcelRegister("17glP", function(module, exports) {

$parcel$export(module.exports, "Parser", function () { return $0d0320de2171a013$export$7acfa6ed01010e37; }, function (v) { return $0d0320de2171a013$export$7acfa6ed01010e37 = v; });
var $0d0320de2171a013$export$7acfa6ed01010e37;

var $3e5bH = parcelRequire("3e5bH");
$0d0320de2171a013$export$7acfa6ed01010e37 = function(options) {
    var parseTokens = function(parser, tokens) {
        return parser(new $3e5bH(tokens));
    };
    return {
        parseTokens: parseTokens
    };
};

});
parcelRegister("3e5bH", function(module, exports) {
var $2596b40f6501a16a$var$TokenIterator = module.exports = function(tokens, startIndex) {
    this._tokens = tokens;
    this._startIndex = startIndex || 0;
};
$2596b40f6501a16a$var$TokenIterator.prototype.head = function() {
    return this._tokens[this._startIndex];
};
$2596b40f6501a16a$var$TokenIterator.prototype.tail = function(startIndex) {
    return new $2596b40f6501a16a$var$TokenIterator(this._tokens, this._startIndex + 1);
};
$2596b40f6501a16a$var$TokenIterator.prototype.toArray = function() {
    return this._tokens.slice(this._startIndex);
};
$2596b40f6501a16a$var$TokenIterator.prototype.end = function() {
    return this._tokens[this._tokens.length - 1];
};
// TODO: doesn't need to be a method, can be a separate function,
// which simplifies implementation of the TokenIterator interface
$2596b40f6501a16a$var$TokenIterator.prototype.to = function(end) {
    var start = this.head().source;
    var endToken = end.head() || end.end();
    return start.to(endToken.source);
};

});


parcelRegister("moeVv", function(module, exports) {

$parcel$export(module.exports, "token", function () { return $0434dbb2acc97ec2$export$9e1725a4cfeada27; }, function (v) { return $0434dbb2acc97ec2$export$9e1725a4cfeada27 = v; });
$parcel$export(module.exports, "tokenOfType", function () { return $0434dbb2acc97ec2$export$41696449d44bc99f; }, function (v) { return $0434dbb2acc97ec2$export$41696449d44bc99f = v; });
$parcel$export(module.exports, "firstOf", function () { return $0434dbb2acc97ec2$export$320dfad4854fb566; }, function (v) { return $0434dbb2acc97ec2$export$320dfad4854fb566 = v; });
$parcel$export(module.exports, "then", function () { return $0434dbb2acc97ec2$export$ff2899a39f81dcfa; }, function (v) { return $0434dbb2acc97ec2$export$ff2899a39f81dcfa = v; });
$parcel$export(module.exports, "sequence", function () { return $0434dbb2acc97ec2$export$49bb65c2ea163039; }, function (v) { return $0434dbb2acc97ec2$export$49bb65c2ea163039 = v; });
$parcel$export(module.exports, "optional", function () { return $0434dbb2acc97ec2$export$516e28dec6a4b6d4; }, function (v) { return $0434dbb2acc97ec2$export$516e28dec6a4b6d4 = v; });
$parcel$export(module.exports, "zeroOrMoreWithSeparator", function () { return $0434dbb2acc97ec2$export$3efe17da37330ee1; }, function (v) { return $0434dbb2acc97ec2$export$3efe17da37330ee1 = v; });
$parcel$export(module.exports, "oneOrMoreWithSeparator", function () { return $0434dbb2acc97ec2$export$e4021a525ad1b87a; }, function (v) { return $0434dbb2acc97ec2$export$e4021a525ad1b87a = v; });
$parcel$export(module.exports, "zeroOrMore", function () { return $0434dbb2acc97ec2$export$d72c500c373b4da6; }, function (v) { return $0434dbb2acc97ec2$export$d72c500c373b4da6 = v; });
$parcel$export(module.exports, "oneOrMore", function () { return $0434dbb2acc97ec2$export$c207d1ebdac09916; }, function (v) { return $0434dbb2acc97ec2$export$c207d1ebdac09916 = v; });
$parcel$export(module.exports, "leftAssociative", function () { return $0434dbb2acc97ec2$export$ae4cf6488905ca50; }, function (v) { return $0434dbb2acc97ec2$export$ae4cf6488905ca50 = v; });
$parcel$export(module.exports, "nonConsuming", function () { return $0434dbb2acc97ec2$export$e85d6b145bf6c7b6; }, function (v) { return $0434dbb2acc97ec2$export$e85d6b145bf6c7b6 = v; });
var $0434dbb2acc97ec2$export$9e1725a4cfeada27;
var $0434dbb2acc97ec2$export$41696449d44bc99f;
var $0434dbb2acc97ec2$export$320dfad4854fb566;
var $0434dbb2acc97ec2$export$ff2899a39f81dcfa;
var $0434dbb2acc97ec2$export$49bb65c2ea163039;
var $0434dbb2acc97ec2$export$516e28dec6a4b6d4;
var $0434dbb2acc97ec2$export$3efe17da37330ee1;
var $0434dbb2acc97ec2$export$e4021a525ad1b87a;
var $0434dbb2acc97ec2$export$d72c500c373b4da6;
var $0434dbb2acc97ec2$export$c207d1ebdac09916;
var $0434dbb2acc97ec2$export$ae4cf6488905ca50;
var $0434dbb2acc97ec2$export$e85d6b145bf6c7b6;
parcelRequire("9jAvV");
var $5mG2j = parcelRequire("5mG2j");
var $bss2W = parcelRequire("bss2W");
var $jD3Ao = parcelRequire("jD3Ao");
var $3rBlz = parcelRequire("3rBlz");

var $2xu0n = parcelRequire("2xu0n");

var $cB0qU = parcelRequire("cB0qU");

var $5wxOh = parcelRequire("5wxOh");

var $e9ZHS = parcelRequire("e9ZHS");
$0434dbb2acc97ec2$export$9e1725a4cfeada27 = function(tokenType, value) {
    var matchValue = value !== undefined;
    return function(input) {
        var token = input.head();
        if (token && token.name === tokenType && (!matchValue || token.value === value)) return $cB0qU.success(token.value, input.tail(), token.source);
        else {
            var expected = $0434dbb2acc97ec2$var$describeToken({
                name: tokenType,
                value: value
            });
            return $0434dbb2acc97ec2$var$describeTokenMismatch(input, expected);
        }
    };
};
$0434dbb2acc97ec2$export$41696449d44bc99f = function(tokenType) {
    return $0434dbb2acc97ec2$export$9e1725a4cfeada27(tokenType);
};
$0434dbb2acc97ec2$export$320dfad4854fb566 = function(name, parsers) {
    if (!$3rBlz.default(parsers)) parsers = Array.prototype.slice.call(arguments, 1);
    return function(input) {
        return $e9ZHS.fromArray(parsers).map(function(parser) {
            return parser(input);
        }).filter(function(result) {
            return result.isSuccess() || result.isError();
        }).first() || $0434dbb2acc97ec2$var$describeTokenMismatch(input, name);
    };
};
$0434dbb2acc97ec2$export$ff2899a39f81dcfa = function(parser, func) {
    return function(input) {
        var result = parser(input);
        if (!result.map) console.log(result);
        return result.map(func);
    };
};
$0434dbb2acc97ec2$export$49bb65c2ea163039 = function() {
    var parsers = Array.prototype.slice.call(arguments, 0);
    var rule = function(input) {
        var result = $jD3Ao.default(parsers, function(memo, parser) {
            var result = memo.result;
            var hasCut = memo.hasCut;
            if (!result.isSuccess()) return {
                result: result,
                hasCut: hasCut
            };
            var subResult = parser(result.remaining());
            if (subResult.isCut()) return {
                result: result,
                hasCut: true
            };
            else if (subResult.isSuccess()) {
                var values;
                if (parser.isCaptured) values = result.value().withValue(parser, subResult.value());
                else values = result.value();
                var remaining = subResult.remaining();
                var source = input.to(remaining);
                return {
                    result: $cB0qU.success(values, remaining, source),
                    hasCut: hasCut
                };
            } else if (hasCut) return {
                result: $cB0qU.error(subResult.errors(), subResult.remaining()),
                hasCut: hasCut
            };
            else return {
                result: subResult,
                hasCut: hasCut
            };
        }, {
            result: $cB0qU.success(new $0434dbb2acc97ec2$var$SequenceValues(), input),
            hasCut: false
        }).result;
        var source = input.to(result.remaining());
        return result.map(function(values) {
            return values.withValue($0434dbb2acc97ec2$export$49bb65c2ea163039.source, source);
        });
    };
    rule.head = function() {
        var firstCapture = $bss2W.default(parsers, isCapturedRule);
        return $0434dbb2acc97ec2$export$ff2899a39f81dcfa(rule, $0434dbb2acc97ec2$export$49bb65c2ea163039.extract(firstCapture));
    };
    rule.map = function(func) {
        return $0434dbb2acc97ec2$export$ff2899a39f81dcfa(rule, function(result) {
            return func.apply(this, result.toArray());
        });
    };
    function isCapturedRule(subRule) {
        return subRule.isCaptured;
    }
    return rule;
};
var $0434dbb2acc97ec2$var$SequenceValues = function(values, valuesArray) {
    this._values = values || {};
    this._valuesArray = valuesArray || [];
};
$0434dbb2acc97ec2$var$SequenceValues.prototype.withValue = function(rule, value) {
    if (rule.captureName && rule.captureName in this._values) throw new Error("Cannot add second value for capture \"" + rule.captureName + "\"");
    else {
        var newValues = $5mG2j.default(this._values);
        newValues[rule.captureName] = value;
        var newValuesArray = this._valuesArray.concat([
            value
        ]);
        return new $0434dbb2acc97ec2$var$SequenceValues(newValues, newValuesArray);
    }
};
$0434dbb2acc97ec2$var$SequenceValues.prototype.get = function(rule) {
    if (rule.captureName in this._values) return this._values[rule.captureName];
    else throw new Error("No value for capture \"" + rule.captureName + "\"");
};
$0434dbb2acc97ec2$var$SequenceValues.prototype.toArray = function() {
    return this._valuesArray;
};
$0434dbb2acc97ec2$export$49bb65c2ea163039.capture = function(rule, name) {
    var captureRule = function() {
        return rule.apply(this, arguments);
    };
    captureRule.captureName = name;
    captureRule.isCaptured = true;
    return captureRule;
};
$0434dbb2acc97ec2$export$49bb65c2ea163039.extract = function(rule) {
    return function(result) {
        return result.get(rule);
    };
};
$0434dbb2acc97ec2$export$49bb65c2ea163039.applyValues = function(func) {
    // TODO: check captureName doesn't conflict with source or other captures
    var rules = Array.prototype.slice.call(arguments, 1);
    return function(result) {
        var values = rules.map(function(rule) {
            return result.get(rule);
        });
        return func.apply(this, values);
    };
};
$0434dbb2acc97ec2$export$49bb65c2ea163039.source = {
    captureName: "\u2603source\u2603"
};
$0434dbb2acc97ec2$export$49bb65c2ea163039.cut = function() {
    return function(input) {
        return $cB0qU.cut(input);
    };
};
$0434dbb2acc97ec2$export$516e28dec6a4b6d4 = function(rule) {
    return function(input) {
        var result = rule(input);
        if (result.isSuccess()) return result.map($2xu0n.some);
        else if (result.isFailure()) return $cB0qU.success($2xu0n.none, input);
        else return result;
    };
};
$0434dbb2acc97ec2$export$3efe17da37330ee1 = function(rule, separator) {
    return $0434dbb2acc97ec2$var$repeatedWithSeparator(rule, separator, false);
};
$0434dbb2acc97ec2$export$e4021a525ad1b87a = function(rule, separator) {
    return $0434dbb2acc97ec2$var$repeatedWithSeparator(rule, separator, true);
};
var $0434dbb2acc97ec2$var$zeroOrMore = $0434dbb2acc97ec2$export$d72c500c373b4da6 = function(rule) {
    return function(input) {
        var values = [];
        var result;
        while((result = rule(input)) && result.isSuccess()){
            input = result.remaining();
            values.push(result.value());
        }
        if (result.isError()) return result;
        else return $cB0qU.success(values, input);
    };
};
$0434dbb2acc97ec2$export$c207d1ebdac09916 = function(rule) {
    return $0434dbb2acc97ec2$export$e4021a525ad1b87a(rule, $0434dbb2acc97ec2$var$noOpRule);
};
function $0434dbb2acc97ec2$var$noOpRule(input) {
    return $cB0qU.success(null, input);
}
var $0434dbb2acc97ec2$var$repeatedWithSeparator = function(rule, separator, isOneOrMore) {
    return function(input) {
        var result = rule(input);
        if (result.isSuccess()) {
            var mainRule = $0434dbb2acc97ec2$export$49bb65c2ea163039.capture(rule, "main");
            var remainingRule = $0434dbb2acc97ec2$var$zeroOrMore($0434dbb2acc97ec2$export$ff2899a39f81dcfa($0434dbb2acc97ec2$export$49bb65c2ea163039(separator, mainRule), $0434dbb2acc97ec2$export$49bb65c2ea163039.extract(mainRule)));
            var remainingResult = remainingRule(result.remaining());
            return $cB0qU.success([
                result.value()
            ].concat(remainingResult.value()), remainingResult.remaining());
        } else if (isOneOrMore || result.isError()) return result;
        else return $cB0qU.success([], input);
    };
};
$0434dbb2acc97ec2$export$ae4cf6488905ca50 = function(leftRule, rightRule, func) {
    var rights;
    if (func) rights = [
        {
            func: func,
            rule: rightRule
        }
    ];
    else rights = rightRule;
    rights = rights.map(function(right) {
        return $0434dbb2acc97ec2$export$ff2899a39f81dcfa(right.rule, function(rightValue) {
            return function(leftValue, source) {
                return right.func(leftValue, rightValue, source);
            };
        });
    });
    var repeatedRule = $0434dbb2acc97ec2$export$320dfad4854fb566.apply(null, [
        "rules"
    ].concat(rights));
    return function(input) {
        var start = input;
        var leftResult = leftRule(input);
        if (!leftResult.isSuccess()) return leftResult;
        var repeatedResult = repeatedRule(leftResult.remaining());
        while(repeatedResult.isSuccess()){
            var remaining = repeatedResult.remaining();
            var source = start.to(repeatedResult.remaining());
            var right = repeatedResult.value();
            leftResult = $cB0qU.success(right(leftResult.value(), source), remaining, source);
            repeatedResult = repeatedRule(leftResult.remaining());
        }
        if (repeatedResult.isError()) return repeatedResult;
        return leftResult;
    };
};
$0434dbb2acc97ec2$export$ae4cf6488905ca50.firstOf = function() {
    return Array.prototype.slice.call(arguments, 0);
};
$0434dbb2acc97ec2$export$e85d6b145bf6c7b6 = function(rule) {
    return function(input) {
        return rule(input).changeRemaining(input);
    };
};
var $0434dbb2acc97ec2$var$describeToken = function(token) {
    if (token.value) return token.name + " \"" + token.value + "\"";
    else return token.name;
};
function $0434dbb2acc97ec2$var$describeTokenMismatch(input, expected) {
    var error;
    var token = input.head();
    if (token) error = $5wxOh.error({
        expected: expected,
        actual: $0434dbb2acc97ec2$var$describeToken(token),
        location: token.source
    });
    else error = $5wxOh.error({
        expected: expected,
        actual: "end of tokens"
    });
    return $cB0qU.failure([
        error
    ], input);
}

});
parcelRegister("2xu0n", function(module, exports) {

$parcel$export(module.exports, "none", function () { return $1d95f032bda6d6ff$export$f883a24d5edde77c; }, function (v) { return $1d95f032bda6d6ff$export$f883a24d5edde77c = v; });
$parcel$export(module.exports, "some", function () { return $1d95f032bda6d6ff$export$ad14ef4001db2bcd; }, function (v) { return $1d95f032bda6d6ff$export$ad14ef4001db2bcd = v; });
var $1d95f032bda6d6ff$export$f883a24d5edde77c;
var $1d95f032bda6d6ff$export$ad14ef4001db2bcd;
var $1d95f032bda6d6ff$export$707cacfe2982dfac;
var $1d95f032bda6d6ff$export$b601f49376b4621a;
$1d95f032bda6d6ff$export$f883a24d5edde77c = Object.create({
    value: function() {
        throw new Error('Called value on none');
    },
    isNone: function() {
        return true;
    },
    isSome: function() {
        return false;
    },
    map: function() {
        return $1d95f032bda6d6ff$export$f883a24d5edde77c;
    },
    flatMap: function() {
        return $1d95f032bda6d6ff$export$f883a24d5edde77c;
    },
    filter: function() {
        return $1d95f032bda6d6ff$export$f883a24d5edde77c;
    },
    toArray: function() {
        return [];
    },
    orElse: $1d95f032bda6d6ff$var$callOrReturn,
    valueOrElse: $1d95f032bda6d6ff$var$callOrReturn
});
function $1d95f032bda6d6ff$var$callOrReturn(value) {
    if (typeof value == "function") return value();
    else return value;
}
$1d95f032bda6d6ff$export$ad14ef4001db2bcd = function(value) {
    return new $1d95f032bda6d6ff$var$Some(value);
};
var $1d95f032bda6d6ff$var$Some = function(value) {
    this._value = value;
};
$1d95f032bda6d6ff$var$Some.prototype.value = function() {
    return this._value;
};
$1d95f032bda6d6ff$var$Some.prototype.isNone = function() {
    return false;
};
$1d95f032bda6d6ff$var$Some.prototype.isSome = function() {
    return true;
};
$1d95f032bda6d6ff$var$Some.prototype.map = function(func) {
    return new $1d95f032bda6d6ff$var$Some(func(this._value));
};
$1d95f032bda6d6ff$var$Some.prototype.flatMap = function(func) {
    return func(this._value);
};
$1d95f032bda6d6ff$var$Some.prototype.filter = function(predicate) {
    return predicate(this._value) ? this : $1d95f032bda6d6ff$export$f883a24d5edde77c;
};
$1d95f032bda6d6ff$var$Some.prototype.toArray = function() {
    return [
        this._value
    ];
};
$1d95f032bda6d6ff$var$Some.prototype.orElse = function(value) {
    return this;
};
$1d95f032bda6d6ff$var$Some.prototype.valueOrElse = function(value) {
    return this._value;
};
$1d95f032bda6d6ff$export$707cacfe2982dfac = function(value) {
    return value === $1d95f032bda6d6ff$export$f883a24d5edde77c || value instanceof $1d95f032bda6d6ff$var$Some;
};
$1d95f032bda6d6ff$export$b601f49376b4621a = function(value) {
    if (value == null) return $1d95f032bda6d6ff$export$f883a24d5edde77c;
    return new $1d95f032bda6d6ff$var$Some(value);
};

});

parcelRegister("cB0qU", function(module, exports) {
module.exports = {
    failure: function(errors, remaining) {
        if (errors.length < 1) throw new Error("Failure must have errors");
        return new $92b946be1245388d$var$Result({
            status: "failure",
            remaining: remaining,
            errors: errors
        });
    },
    error: function(errors, remaining) {
        if (errors.length < 1) throw new Error("Failure must have errors");
        return new $92b946be1245388d$var$Result({
            status: "error",
            remaining: remaining,
            errors: errors
        });
    },
    success: function(value, remaining, source) {
        return new $92b946be1245388d$var$Result({
            status: "success",
            value: value,
            source: source,
            remaining: remaining,
            errors: []
        });
    },
    cut: function(remaining) {
        return new $92b946be1245388d$var$Result({
            status: "cut",
            remaining: remaining,
            errors: []
        });
    }
};
var $92b946be1245388d$var$Result = function(options) {
    this._value = options.value;
    this._status = options.status;
    this._hasValue = options.value !== undefined;
    this._remaining = options.remaining;
    this._source = options.source;
    this._errors = options.errors;
};
$92b946be1245388d$var$Result.prototype.map = function(func) {
    if (this._hasValue) return new $92b946be1245388d$var$Result({
        value: func(this._value, this._source),
        status: this._status,
        remaining: this._remaining,
        source: this._source,
        errors: this._errors
    });
    else return this;
};
$92b946be1245388d$var$Result.prototype.changeRemaining = function(remaining) {
    return new $92b946be1245388d$var$Result({
        value: this._value,
        status: this._status,
        remaining: remaining,
        source: this._source,
        errors: this._errors
    });
};
$92b946be1245388d$var$Result.prototype.isSuccess = function() {
    return this._status === "success" || this._status === "cut";
};
$92b946be1245388d$var$Result.prototype.isFailure = function() {
    return this._status === "failure";
};
$92b946be1245388d$var$Result.prototype.isError = function() {
    return this._status === "error";
};
$92b946be1245388d$var$Result.prototype.isCut = function() {
    return this._status === "cut";
};
$92b946be1245388d$var$Result.prototype.value = function() {
    return this._value;
};
$92b946be1245388d$var$Result.prototype.remaining = function() {
    return this._remaining;
};
$92b946be1245388d$var$Result.prototype.source = function() {
    return this._source;
};
$92b946be1245388d$var$Result.prototype.errors = function() {
    return this._errors;
};

});

parcelRegister("5wxOh", function(module, exports) {

$parcel$export(module.exports, "error", function () { return $405a2adc4a0971cc$export$a3bc9b8ed74fc; }, function (v) { return $405a2adc4a0971cc$export$a3bc9b8ed74fc = v; });
var $405a2adc4a0971cc$export$a3bc9b8ed74fc;
$405a2adc4a0971cc$export$a3bc9b8ed74fc = function(options) {
    return new $405a2adc4a0971cc$var$Error(options);
};
var $405a2adc4a0971cc$var$Error = function(options) {
    this.expected = options.expected;
    this.actual = options.actual;
    this._location = options.location;
};
$405a2adc4a0971cc$var$Error.prototype.describe = function() {
    var locationDescription = this._location ? this._location.describe() + ":\n" : "";
    return locationDescription + "Expected " + this.expected + "\nbut got " + this.actual;
};
$405a2adc4a0971cc$var$Error.prototype.lineNumber = function() {
    return this._location.lineNumber();
};
$405a2adc4a0971cc$var$Error.prototype.characterNumber = function() {
    return this._location.characterNumber();
};

});

parcelRegister("e9ZHS", function(module, exports) {

$parcel$export(module.exports, "fromArray", function () { return $a4f1c59fb4692d8c$export$571d59b505e6bb4e; }, function (v) { return $a4f1c59fb4692d8c$export$571d59b505e6bb4e = v; });
var $a4f1c59fb4692d8c$export$571d59b505e6bb4e;
var $a4f1c59fb4692d8c$var$fromArray = $a4f1c59fb4692d8c$export$571d59b505e6bb4e = function(array) {
    var index = 0;
    var hasNext = function() {
        return index < array.length;
    };
    return new $a4f1c59fb4692d8c$var$LazyIterator({
        hasNext: hasNext,
        next: function() {
            if (!hasNext()) throw new Error("No more elements");
            else return array[index++];
        }
    });
};
var $a4f1c59fb4692d8c$var$LazyIterator = function(iterator) {
    this._iterator = iterator;
};
$a4f1c59fb4692d8c$var$LazyIterator.prototype.map = function(func) {
    var iterator = this._iterator;
    return new $a4f1c59fb4692d8c$var$LazyIterator({
        hasNext: function() {
            return iterator.hasNext();
        },
        next: function() {
            return func(iterator.next());
        }
    });
};
$a4f1c59fb4692d8c$var$LazyIterator.prototype.filter = function(condition) {
    var iterator = this._iterator;
    var moved = false;
    var hasNext = false;
    var next;
    var moveIfNecessary = function() {
        if (moved) return;
        moved = true;
        hasNext = false;
        while(iterator.hasNext() && !hasNext){
            next = iterator.next();
            hasNext = condition(next);
        }
    };
    return new $a4f1c59fb4692d8c$var$LazyIterator({
        hasNext: function() {
            moveIfNecessary();
            return hasNext;
        },
        next: function() {
            moveIfNecessary();
            var toReturn = next;
            moved = false;
            return toReturn;
        }
    });
};
$a4f1c59fb4692d8c$var$LazyIterator.prototype.first = function() {
    var iterator = this._iterator;
    if (this._iterator.hasNext()) return iterator.next();
    else return null;
};
$a4f1c59fb4692d8c$var$LazyIterator.prototype.toArray = function() {
    var result = [];
    while(this._iterator.hasNext())result.push(this._iterator.next());
    return result;
};

});


parcelRegister("8kl1m", function(module, exports) {
var $61007f4a0360e997$var$StringSource = module.exports = function(string, description) {
    var self = {
        asString: function() {
            return string;
        },
        range: function(startIndex, endIndex) {
            return new $61007f4a0360e997$var$StringSourceRange(string, description, startIndex, endIndex);
        }
    };
    return self;
};
var $61007f4a0360e997$var$StringSourceRange = function(string, description, startIndex, endIndex) {
    this._string = string;
    this._description = description;
    this._startIndex = startIndex;
    this._endIndex = endIndex;
};
$61007f4a0360e997$var$StringSourceRange.prototype.to = function(otherRange) {
    // TODO: Assert that tokens are the same across both iterators
    return new $61007f4a0360e997$var$StringSourceRange(this._string, this._description, this._startIndex, otherRange._endIndex);
};
$61007f4a0360e997$var$StringSourceRange.prototype.describe = function() {
    var position = this._position();
    var description = this._description ? this._description + "\n" : "";
    return description + "Line number: " + position.lineNumber + "\nCharacter number: " + position.characterNumber;
};
$61007f4a0360e997$var$StringSourceRange.prototype.lineNumber = function() {
    return this._position().lineNumber;
};
$61007f4a0360e997$var$StringSourceRange.prototype.characterNumber = function() {
    return this._position().characterNumber;
};
$61007f4a0360e997$var$StringSourceRange.prototype._position = function() {
    var self = this;
    var index = 0;
    var nextNewLine = function() {
        return self._string.indexOf("\n", index);
    };
    var lineNumber = 1;
    while(nextNewLine() !== -1 && nextNewLine() < this._startIndex){
        index = nextNewLine() + 1;
        lineNumber += 1;
    }
    var characterNumber = this._startIndex - index + 1;
    return {
        lineNumber: lineNumber,
        characterNumber: characterNumber
    };
};

});

parcelRegister("7f4pG", function(module, exports) {
module.exports = function(name, value, source) {
    this.name = name;
    this.value = value;
    if (source) this.source = source;
};

});

parcelRegister("fqgYr", function(module, exports) {

$parcel$export(module.exports, "parser", function () { return $b3a6735bfe1f7f08$export$8f49e4af10703ce3; }, function (v) { return $b3a6735bfe1f7f08$export$8f49e4af10703ce3 = v; });
$parcel$export(module.exports, "infix", function () { return $b3a6735bfe1f7f08$export$556631376a476def; }, function (v) { return $b3a6735bfe1f7f08$export$556631376a476def = v; });
var $b3a6735bfe1f7f08$export$8f49e4af10703ce3;
var $b3a6735bfe1f7f08$export$556631376a476def;

var $moeVv = parcelRequire("moeVv");

var $cB0qU = parcelRequire("cB0qU");
$b3a6735bfe1f7f08$export$8f49e4af10703ce3 = function(name, prefixRules, infixRuleBuilders) {
    var self = {
        rule: rule,
        leftAssociative: leftAssociative,
        rightAssociative: rightAssociative
    };
    var infixRules = new $b3a6735bfe1f7f08$var$InfixRules(infixRuleBuilders.map(createInfixRule));
    var prefixRule = $moeVv.firstOf(name, prefixRules);
    function createInfixRule(infixRuleBuilder) {
        return {
            name: infixRuleBuilder.name,
            rule: $b3a6735bfe1f7f08$var$lazyRule(infixRuleBuilder.ruleBuilder.bind(null, self))
        };
    }
    function rule() {
        return createRule(infixRules);
    }
    function leftAssociative(name) {
        return createRule(infixRules.untilExclusive(name));
    }
    function rightAssociative(name) {
        return createRule(infixRules.untilInclusive(name));
    }
    function createRule(infixRules) {
        return apply.bind(null, infixRules);
    }
    function apply(infixRules, tokens) {
        var leftResult = prefixRule(tokens);
        if (leftResult.isSuccess()) return infixRules.apply(leftResult);
        else return leftResult;
    }
    return self;
};
function $b3a6735bfe1f7f08$var$InfixRules(infixRules) {
    function untilExclusive(name) {
        return new $b3a6735bfe1f7f08$var$InfixRules(infixRules.slice(0, ruleNames().indexOf(name)));
    }
    function untilInclusive(name) {
        return new $b3a6735bfe1f7f08$var$InfixRules(infixRules.slice(0, ruleNames().indexOf(name) + 1));
    }
    function ruleNames() {
        return infixRules.map(function(rule) {
            return rule.name;
        });
    }
    function apply(leftResult) {
        var currentResult;
        var source;
        while(true){
            currentResult = applyToTokens(leftResult.remaining());
            if (currentResult.isSuccess()) {
                source = leftResult.source().to(currentResult.source());
                leftResult = $cB0qU.success(currentResult.value()(leftResult.value(), source), currentResult.remaining(), source);
            } else if (currentResult.isFailure()) return leftResult;
            else return currentResult;
        }
    }
    function applyToTokens(tokens) {
        return $moeVv.firstOf("infix", infixRules.map(function(infix) {
            return infix.rule;
        }))(tokens);
    }
    return {
        apply: apply,
        untilExclusive: untilExclusive,
        untilInclusive: untilInclusive
    };
}
$b3a6735bfe1f7f08$export$556631376a476def = function(name, ruleBuilder) {
    function map(func) {
        return $b3a6735bfe1f7f08$export$556631376a476def(name, function(parser) {
            var rule = ruleBuilder(parser);
            return function(tokens) {
                var result = rule(tokens);
                return result.map(function(right) {
                    return function(left, source) {
                        return func(left, right, source);
                    };
                });
            };
        });
    }
    return {
        name: name,
        ruleBuilder: ruleBuilder,
        map: map
    };
};
// TODO: move into a sensible place and remove duplication
var $b3a6735bfe1f7f08$var$lazyRule = function(ruleBuilder) {
    var rule;
    return function(input) {
        if (!rule) rule = ruleBuilder();
        return rule(input);
    };
};

});

parcelRegister("FZqT4", function(module, exports) {

$parcel$export(module.exports, "RegexTokeniser", function () { return $07e37bb2a56f8d7d$export$74d15b5d79bf9ea; }, function (v) { return $07e37bb2a56f8d7d$export$74d15b5d79bf9ea = v; });
var $07e37bb2a56f8d7d$export$74d15b5d79bf9ea;

var $7f4pG = parcelRequire("7f4pG");

var $8kl1m = parcelRequire("8kl1m");
$07e37bb2a56f8d7d$export$74d15b5d79bf9ea = $07e37bb2a56f8d7d$var$RegexTokeniser;
function $07e37bb2a56f8d7d$var$RegexTokeniser(rules) {
    rules = rules.map(function(rule) {
        return {
            name: rule.name,
            regex: new RegExp(rule.regex.source, "g")
        };
    });
    function tokenise(input, description) {
        var source = new $8kl1m(input, description);
        var index = 0;
        var tokens = [];
        while(index < input.length){
            var result = readNextToken(input, index, source);
            index = result.endIndex;
            tokens.push(result.token);
        }
        tokens.push(endToken(input, source));
        return tokens;
    }
    function readNextToken(string, startIndex, source) {
        for(var i = 0; i < rules.length; i++){
            var regex = rules[i].regex;
            regex.lastIndex = startIndex;
            var result = regex.exec(string);
            if (result) {
                var endIndex = startIndex + result[0].length;
                if (result.index === startIndex && endIndex > startIndex) {
                    var value = result[1];
                    var token = new $7f4pG(rules[i].name, value, source.range(startIndex, endIndex));
                    return {
                        token: token,
                        endIndex: endIndex
                    };
                }
            }
        }
        var endIndex = startIndex + 1;
        var token = new $7f4pG("unrecognisedCharacter", string.substring(startIndex, endIndex), source.range(startIndex, endIndex));
        return {
            token: token,
            endIndex: endIndex
        };
    }
    function endToken(input, source) {
        return new $7f4pG("end", null, source.range(input.length, input.length));
    }
    return {
        tokenise: tokenise
    };
}

});

parcelRegister("1OnEJ", function(module, exports) {

$parcel$export(module.exports, "element", function () { return $151ccf859b683093$export$8454457683f90105; }, function (v) { return $151ccf859b683093$export$8454457683f90105 = v; });
var $151ccf859b683093$export$8454457683f90105;

var $hEvL6 = parcelRequire("hEvL6");

var $8eobO = parcelRequire("8eobO");
$151ccf859b683093$export$8454457683f90105 = $151ccf859b683093$var$element;
function $151ccf859b683093$var$element(name) {
    return function(html) {
        return $8eobO.elementWithTag($hEvL6.element(name), [
            html
        ]);
    };
}

});

var $8543c47da0beab14$exports = {};
$parcel$extendImportMap({
    "94LWX": "77e8cc6f771fcb796abe423fba22a1d5d474f390/pdf.worker.min.13fd2e4a.js",
    "hW73M": "cda.8f0fae79.xsl"
});

/* global CONFIGURATION, setupNewRelic */ // This is a magic string replaced by rollup
const $4726de1158d3534e$export$31499a9cd224b78c = "10.50.0";


/** Internal global with common properties and Sentry extensions  */ /** Get's the global object for the current JavaScript runtime */ const $517c5b29f882562f$export$f1a6cdb1459e81d1 = globalThis;


/**
 * An object that contains globally accessible properties and maintains a scope stack.
 * @hidden
 */ /**
 * Returns the global shim registry.
 *
 * FIXME: This function is problematic, because despite always returning a valid Carrier,
 * it has an optional `__SENTRY__` property, which then in turn requires us to always perform an unnecessary check
 * at the call-site. We always access the carrier through this function, so we can guarantee that `__SENTRY__` is there.
 **/ function $b9fc213467403976$export$19eade501500c6c1() {
    // This ensures a Sentry carrier exists
    $b9fc213467403976$export$c8bfa33e4e8ae492((0, $517c5b29f882562f$export$f1a6cdb1459e81d1));
    return 0, $517c5b29f882562f$export$f1a6cdb1459e81d1;
}
/** Will either get the existing sentry carrier, or create a new one. */ function $b9fc213467403976$export$c8bfa33e4e8ae492(carrier) {
    const __SENTRY__ = carrier.__SENTRY__ = carrier.__SENTRY__ || {};
    // For now: First SDK that sets the .version property wins
    __SENTRY__.version = __SENTRY__.version || (0, $4726de1158d3534e$export$31499a9cd224b78c);
    // Intentionally populating and returning the version of "this" SDK instance
    // rather than what's set in .version so that "this" SDK always gets its carrier
    return __SENTRY__[0, $4726de1158d3534e$export$31499a9cd224b78c] = __SENTRY__[0, $4726de1158d3534e$export$31499a9cd224b78c] || {};
}
/**
 * Returns a global singleton contained in the global `__SENTRY__[]` object.
 *
 * If the singleton doesn't already exist in `__SENTRY__`, it will be created using the given factory
 * function and added to the `__SENTRY__` object.
 *
 * @param name name of the global singleton on __SENTRY__
 * @param creator creator Factory function to create the singleton if it doesn't already exist on `__SENTRY__`
 * @param obj (Optional) The global object on which to look for `__SENTRY__`, if not `GLOBAL_OBJ`'s return value
 * @returns the singleton
 */ function $b9fc213467403976$export$7e223ec222791509(name, creator, obj = (0, $517c5b29f882562f$export$f1a6cdb1459e81d1)) {
    const __SENTRY__ = obj.__SENTRY__ = obj.__SENTRY__ || {};
    const carrier = __SENTRY__[0, $4726de1158d3534e$export$31499a9cd224b78c] = __SENTRY__[0, $4726de1158d3534e$export$31499a9cd224b78c] || {};
    // Note: We do not want to set `carrier.version` here, as this may be called before any `init` is called, e.g. for the default scopes
    return carrier[name] || (carrier[name] = creator());
}



/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */ const $6d193f2c2b007873$export$16a28057038b10ef = typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__;



// eslint-disable-next-line @typescript-eslint/unbound-method
const $d1f309ce92d0a600$var$objectToString = Object.prototype.toString;
/**
 * Checks whether given value's type is one of a few Error or Error-like
 * {@link isError}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $d1f309ce92d0a600$export$e6127cc7fe7395c3(wat) {
    switch($d1f309ce92d0a600$var$objectToString.call(wat)){
        case '[object Error]':
        case '[object Exception]':
        case '[object DOMException]':
        case '[object WebAssembly.Exception]':
            return true;
        default:
            return $d1f309ce92d0a600$export$49034edbe6b62415(wat, Error);
    }
}
/**
 * Checks whether given value is an instance of the given built-in class.
 *
 * @param wat The value to be checked
 * @param className
 * @returns A boolean representing the result.
 */ function $d1f309ce92d0a600$var$isBuiltin(wat, className) {
    return $d1f309ce92d0a600$var$objectToString.call(wat) === `[object ${className}]`;
}
/**
 * Checks whether given value's type is ErrorEvent
 * {@link isErrorEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $d1f309ce92d0a600$export$9f9636d330b71954(wat) {
    return $d1f309ce92d0a600$var$isBuiltin(wat, 'ErrorEvent');
}
/**
 * Checks whether given value's type is DOMError
 * {@link isDOMError}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $d1f309ce92d0a600$export$ef9e2056653f0c8e(wat) {
    return $d1f309ce92d0a600$var$isBuiltin(wat, 'DOMError');
}
/**
 * Checks whether given value's type is DOMException
 * {@link isDOMException}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $d1f309ce92d0a600$export$12e869b2a583f783(wat) {
    return $d1f309ce92d0a600$var$isBuiltin(wat, 'DOMException');
}
/**
 * Checks whether given value's type is a string
 * {@link isString}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $d1f309ce92d0a600$export$844ec244b1367d54(wat) {
    return $d1f309ce92d0a600$var$isBuiltin(wat, 'String');
}
/**
 * Checks whether given string is parameterized
 * {@link isParameterizedString}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $d1f309ce92d0a600$export$dbcbffa59149b824(wat) {
    return typeof wat === 'object' && wat !== null && '__sentry_template_string__' in wat && '__sentry_template_values__' in wat;
}
/**
 * Checks whether given value is a primitive (undefined, null, number, boolean, string, bigint, symbol)
 * {@link isPrimitive}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $d1f309ce92d0a600$export$c3825b437cbdea5c(wat) {
    return wat === null || $d1f309ce92d0a600$export$dbcbffa59149b824(wat) || typeof wat !== 'object' && typeof wat !== 'function';
}
/**
 * Checks whether given value's type is an object literal, or a class instance.
 * {@link isPlainObject}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $d1f309ce92d0a600$export$53b83ca8eaab0383(wat) {
    return $d1f309ce92d0a600$var$isBuiltin(wat, 'Object');
}
/**
 * Checks whether given value's type is an Event instance
 * {@link isEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $d1f309ce92d0a600$export$9671ea99bd126ace(wat) {
    return typeof Event !== 'undefined' && $d1f309ce92d0a600$export$49034edbe6b62415(wat, Event);
}
/**
 * Checks whether given value's type is an Element instance
 * {@link isElement}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $d1f309ce92d0a600$export$45a5e7f76e0caa8d(wat) {
    return typeof Element !== 'undefined' && $d1f309ce92d0a600$export$49034edbe6b62415(wat, Element);
}
/**
 * Checks whether given value's type is an regexp
 * {@link isRegExp}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $d1f309ce92d0a600$export$49841c62b9eff15(wat) {
    return $d1f309ce92d0a600$var$isBuiltin(wat, 'RegExp');
}
/**
 * Checks whether given value has a then function.
 * @param wat A value to be checked.
 */ function $d1f309ce92d0a600$export$f5b060c2914b97c8(wat) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    return Boolean(wat?.then && typeof wat.then === 'function');
}
/**
 * Checks whether given value's type is a SyntheticEvent
 * {@link isSyntheticEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $d1f309ce92d0a600$export$bc2894c7158efbac(wat) {
    return $d1f309ce92d0a600$export$53b83ca8eaab0383(wat) && 'nativeEvent' in wat && 'preventDefault' in wat && 'stopPropagation' in wat;
}
/**
 * Checks whether given value's type is an instance of provided constructor.
 * {@link isInstanceOf}.
 *
 * @param wat A value to be checked.
 * @param base A constructor to be used in a check.
 * @returns A boolean representing the result.
 */ // TODO: fix in v11, convert any to unknown
// export function isInstanceOf<T>(wat: unknown, base: { new (...args: any[]): T }): wat is T {
function $d1f309ce92d0a600$export$49034edbe6b62415(wat, base) {
    try {
        return wat instanceof base;
    } catch  {
        return false;
    }
}
/**
 * Checks whether given value's type is a Vue ViewModel or a VNode.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $d1f309ce92d0a600$export$7916fad0ebc23f48(wat) {
    // Not using Object.prototype.toString because in Vue 3 it would read the instance's Symbol(Symbol.toStringTag) property.
    // We also need to check for __v_isVNode because Vue 3 component render instances have an internal __v_isVNode property.
    return !!(typeof wat === 'object' && wat !== null && (wat.__isVue || wat._isVue || wat.__v_isVNode));
}
/**
 * Checks whether the given parameter is a Standard Web API Request instance.
 *
 * Returns false if Request is not available in the current runtime.
 */ function $d1f309ce92d0a600$export$6d3d1f317d7cda57(request) {
    return typeof Request !== 'undefined' && $d1f309ce92d0a600$export$49034edbe6b62415(request, Request);
}



const $c765cb3edc177c69$var$WINDOW = (0, $517c5b29f882562f$export$f1a6cdb1459e81d1);
const $c765cb3edc177c69$var$DEFAULT_MAX_STRING_LENGTH = 80;
/**
 * Given a child DOM element, returns a query-selector statement describing that
 * and its ancestors
 * e.g. [HTMLElement] => body > div > input#foo.btn[name=baz]
 * @returns generated DOM path
 */ function $c765cb3edc177c69$export$5647df6b7814ac86(elem, options = {}) {
    if (!elem) return '<unknown>';
    // try/catch both:
    // - accessing event.target (see getsentry/raven-js#838, #768)
    // - `htmlTreeAsString` because it's complex, and just accessing the DOM incorrectly
    // - can throw an exception in some circumstances.
    try {
        let currentElem = elem;
        const MAX_TRAVERSE_HEIGHT = 5;
        const out = [];
        let height = 0;
        let len = 0;
        const separator = ' > ';
        const sepLength = separator.length;
        let nextStr;
        const keyAttrs = Array.isArray(options) ? options : options.keyAttrs;
        const maxStringLength = !Array.isArray(options) && options.maxStringLength || $c765cb3edc177c69$var$DEFAULT_MAX_STRING_LENGTH;
        while(currentElem && height++ < MAX_TRAVERSE_HEIGHT){
            nextStr = $c765cb3edc177c69$var$_htmlElementAsString(currentElem, keyAttrs);
            // bail out if
            // - nextStr is the 'html' element
            // - the length of the string that would be created exceeds maxStringLength
            //   (ignore this limit if we are on the first iteration)
            if (nextStr === 'html' || height > 1 && len + out.length * sepLength + nextStr.length >= maxStringLength) break;
            out.push(nextStr);
            len += nextStr.length;
            currentElem = currentElem.parentNode;
        }
        return out.reverse().join(separator);
    } catch  {
        return '<unknown>';
    }
}
/**
 * Returns a simple, query-selector representation of a DOM element
 * e.g. [HTMLElement] => input#foo.btn[name=baz]
 * @returns generated DOM path
 */ function $c765cb3edc177c69$var$_htmlElementAsString(el, keyAttrs) {
    const elem = el;
    const out = [];
    if (!elem?.tagName) return '';
    // @ts-expect-error WINDOW has HTMLElement
    if ($c765cb3edc177c69$var$WINDOW.HTMLElement) // If using the component name annotation plugin, this value may be available on the DOM node
    {
        if (elem instanceof HTMLElement && elem.dataset) {
            if (elem.dataset['sentryComponent']) return elem.dataset['sentryComponent'];
            if (elem.dataset['sentryElement']) return elem.dataset['sentryElement'];
        }
    }
    out.push(elem.tagName.toLowerCase());
    // Pairs of attribute keys defined in `serializeAttribute` and their values on element.
    const keyAttrPairs = keyAttrs?.length ? keyAttrs.filter((keyAttr)=>elem.getAttribute(keyAttr)).map((keyAttr)=>[
            keyAttr,
            elem.getAttribute(keyAttr)
        ]) : null;
    if (keyAttrPairs?.length) keyAttrPairs.forEach((keyAttrPair)=>{
        out.push(`[${keyAttrPair[0]}="${keyAttrPair[1]}"]`);
    });
    else {
        if (elem.id) out.push(`#${elem.id}`);
        const className = elem.className;
        if (className && (0, $d1f309ce92d0a600$export$844ec244b1367d54)(className)) {
            const classes = className.split(/\s+/);
            for (const c of classes)out.push(`.${c}`);
        }
    }
    for (const k of [
        'aria-label',
        'type',
        'name',
        'title',
        'alt'
    ]){
        const attr = elem.getAttribute(k);
        if (attr) out.push(`[${k}="${attr}"]`);
    }
    return out.join('');
}
/**
 * A safe form of location.href
 */ function $c765cb3edc177c69$export$1cfafeee2987818b() {
    try {
        return $c765cb3edc177c69$var$WINDOW.document.location.href;
    } catch  {
        return '';
    }
}
/**
 * Given a DOM element, traverses up the tree until it finds the first ancestor node
 * that has the `data-sentry-component` or `data-sentry-element` attribute with `data-sentry-component` taking
 * precedence. This attribute is added at build-time by projects that have the component name annotation plugin installed.
 *
 * @returns a string representation of the component for the provided DOM element, or `null` if not found
 */ function $c765cb3edc177c69$export$26727cfcc4d7e0fc(elem, maxTraverseHeight = 5) {
    // @ts-expect-error WINDOW has HTMLElement
    if (!$c765cb3edc177c69$var$WINDOW.HTMLElement) return null;
    let currentElem = elem;
    for(let i = 0; i < maxTraverseHeight; i++){
        if (!currentElem) return null;
        if (currentElem instanceof HTMLElement) {
            if (currentElem.dataset['sentryComponent']) return currentElem.dataset['sentryComponent'];
            if (currentElem.dataset['sentryElement']) return currentElem.dataset['sentryElement'];
        }
        currentElem = currentElem.parentNode;
    }
    return null;
}





const $6ed5aee3203eab87$export$2a2b1d2252a69ecb = [
    'debug',
    'info',
    'warn',
    'error',
    'log',
    'assert',
    'trace'
];
/** Prefix for logging strings */ const $6ed5aee3203eab87$var$PREFIX = 'Sentry Logger ';
/** This may be mutated by the console instrumentation. */ const $6ed5aee3203eab87$export$77c4ce905194557b = {};
/**
 * Temporarily disable sentry console instrumentations.
 *
 * @param callback The function to run against the original `console` messages
 * @returns The results of the callback
 */ function $6ed5aee3203eab87$export$cda52e2a8927a2ca(callback) {
    if (!('console' in (0, $517c5b29f882562f$export$f1a6cdb1459e81d1))) return callback();
    const console = (0, $517c5b29f882562f$export$f1a6cdb1459e81d1).console;
    const wrappedFuncs = {};
    const wrappedLevels = Object.keys($6ed5aee3203eab87$export$77c4ce905194557b);
    // Restore all wrapped console methods
    wrappedLevels.forEach((level)=>{
        const originalConsoleMethod = $6ed5aee3203eab87$export$77c4ce905194557b[level];
        wrappedFuncs[level] = console[level];
        console[level] = originalConsoleMethod;
    });
    try {
        return callback();
    } finally{
        // Revert restoration to wrapped state
        wrappedLevels.forEach((level)=>{
            console[level] = wrappedFuncs[level];
        });
    }
}
function $6ed5aee3203eab87$var$enable() {
    $6ed5aee3203eab87$var$_getLoggerSettings().enabled = true;
}
function $6ed5aee3203eab87$var$disable() {
    $6ed5aee3203eab87$var$_getLoggerSettings().enabled = false;
}
function $6ed5aee3203eab87$var$isEnabled() {
    return $6ed5aee3203eab87$var$_getLoggerSettings().enabled;
}
function $6ed5aee3203eab87$var$log(...args) {
    $6ed5aee3203eab87$var$_maybeLog('log', ...args);
}
function $6ed5aee3203eab87$var$warn(...args) {
    $6ed5aee3203eab87$var$_maybeLog('warn', ...args);
}
function $6ed5aee3203eab87$var$error(...args) {
    $6ed5aee3203eab87$var$_maybeLog('error', ...args);
}
function $6ed5aee3203eab87$var$_maybeLog(level, ...args) {
    if (!(0, $6d193f2c2b007873$export$16a28057038b10ef)) return;
    if ($6ed5aee3203eab87$var$isEnabled()) $6ed5aee3203eab87$export$cda52e2a8927a2ca(()=>{
        (0, $517c5b29f882562f$export$f1a6cdb1459e81d1).console[level](`${$6ed5aee3203eab87$var$PREFIX}[${level}]:`, ...args);
    });
}
function $6ed5aee3203eab87$var$_getLoggerSettings() {
    if (!(0, $6d193f2c2b007873$export$16a28057038b10ef)) return {
        enabled: false
    };
    return (0, $b9fc213467403976$export$7e223ec222791509)('loggerSettings', ()=>({
            enabled: false
        }));
}
/**
 * This is a logger singleton which either logs things or no-ops if logging is not enabled.
 */ const $6ed5aee3203eab87$export$1c9f709888824e05 = {
    enable: /** Enable logging. */ $6ed5aee3203eab87$var$enable,
    disable: /** Disable logging. */ $6ed5aee3203eab87$var$disable,
    isEnabled: /** Check if logging is enabled. */ $6ed5aee3203eab87$var$isEnabled,
    log: /** Log a message. */ $6ed5aee3203eab87$var$log,
    warn: /** Log a warning. */ $6ed5aee3203eab87$var$warn,
    error: /** Log an error. */ $6ed5aee3203eab87$var$error
};



/* eslint-disable @typescript-eslint/no-explicit-any */ /**
 * Replace a method in an object with a wrapped version of itself.
 *
 * If the method on the passed object is not a function, the wrapper will not be applied.
 *
 * @param source An object that contains a method to be wrapped.
 * @param name The name of the method to be wrapped.
 * @param replacementFactory A higher-order function that takes the original version of the given method and returns a
 * wrapped version. Note: The function returned by `replacementFactory` needs to be a non-arrow function, in order to
 * preserve the correct value of `this`, and the original method must be called using `origMethod.call(this, <other
 * args>)` or `origMethod.apply(this, [<other args>])` (rather than being called directly), again to preserve `this`.
 * @returns void
 */ function $10696cb2974e7335$export$9563e054e6f787fb(source, name, replacementFactory) {
    if (!(name in source)) return;
    // explicitly casting to unknown because we don't know the type of the method initially at all
    const original = source[name];
    if (typeof original !== 'function') return;
    const wrapped = replacementFactory(original);
    // Make sure it's a function first, as we need to attach an empty prototype for `defineProperties` to work
    // otherwise it'll throw "TypeError: Object.defineProperties called on non-object"
    if (typeof wrapped === 'function') $10696cb2974e7335$export$5c1499e2e5d010ae(wrapped, original);
    try {
        source[name] = wrapped;
    } catch  {
        (0, $6d193f2c2b007873$export$16a28057038b10ef) && (0, $6ed5aee3203eab87$export$1c9f709888824e05).log(`Failed to replace method "${name}" in object`, source);
    }
}
/**
 * Defines a non-enumerable property on the given object.
 *
 * @param obj The object on which to set the property
 * @param name The name of the property to be set
 * @param value The value to which to set the property
 */ function $10696cb2974e7335$export$e73679ffaf56810e(obj, name, value) {
    try {
        Object.defineProperty(obj, name, {
            value: // enumerable: false, // the default, so we can save on bundle size by not explicitly setting it
            value,
            writable: true,
            configurable: true
        });
    } catch  {
        (0, $6d193f2c2b007873$export$16a28057038b10ef) && (0, $6ed5aee3203eab87$export$1c9f709888824e05).log(`Failed to add non-enumerable property "${name}" to object`, obj);
    }
}
/**
 * Remembers the original function on the wrapped function and
 * patches up the prototype.
 *
 * @param wrapped the wrapper function
 * @param original the original function that gets wrapped
 */ function $10696cb2974e7335$export$5c1499e2e5d010ae(wrapped, original) {
    try {
        const proto = original.prototype || {};
        wrapped.prototype = original.prototype = proto;
        $10696cb2974e7335$export$e73679ffaf56810e(wrapped, '__sentry_original__', original);
    } catch  {} // eslint-disable-line no-empty
}
/**
 * Wrap a method on an object by name, only if it is not already wrapped.
 *
 * Note: to set the wrapped method as a non-enumerable property, pass
 * false as the `enumerable` argument. This could be detected, but only
 * by either walking up the prototype chain, or iterating over all fields
 * in a `for(in)` loop. Neither are an acceptable performance impact for
 * the rare case where we might patch a non-enumerable method.
 */ function $10696cb2974e7335$export$e00416b3cd122575(obj, field, wrapped, enumerable = true) {
    const original = obj[field];
    if (typeof original !== 'function') throw new Error(`Cannot wrap method: ${field} is not a function`);
    if ($10696cb2974e7335$export$e6cc1e135e2092e5(original)) throw new Error(`Attempting to wrap method ${field} multiple times`);
    $10696cb2974e7335$export$5c1499e2e5d010ae(wrapped, original);
    Object.defineProperty(obj, field, {
        writable: true,
        configurable: true,
        enumerable: enumerable,
        value: wrapped
    });
}
/**
 * This extracts the original function if available.  See
 * `markFunctionWrapped` for more information.
 *
 * @param func the function to unwrap
 * @returns the unwrapped version of the function if available.
 */ // eslint-disable-next-line @typescript-eslint/ban-types
function $10696cb2974e7335$export$e6cc1e135e2092e5(func) {
    return func.__sentry_original__;
}
/**
 * Transforms any `Error` or `Event` into a plain object with all of their enumerable properties, and some of their
 * non-enumerable properties attached.
 *
 * @param value Initial source that we have to transform in order for it to be usable by the serializer
 * @returns An Event or Error turned into an object - or the value argument itself, when value is neither an Event nor
 *  an Error.
 */ function $10696cb2974e7335$export$62ff257738bf57f5(value) {
    if ((0, $d1f309ce92d0a600$export$e6127cc7fe7395c3)(value)) return {
        message: value.message,
        name: value.name,
        stack: value.stack,
        ...$10696cb2974e7335$var$getOwnProperties(value)
    };
    else if ((0, $d1f309ce92d0a600$export$9671ea99bd126ace)(value)) {
        const newObj = {
            type: value.type,
            target: $10696cb2974e7335$var$serializeEventTarget(value.target),
            currentTarget: $10696cb2974e7335$var$serializeEventTarget(value.currentTarget),
            ...$10696cb2974e7335$var$getOwnProperties(value)
        };
        if (typeof CustomEvent !== 'undefined' && (0, $d1f309ce92d0a600$export$49034edbe6b62415)(value, CustomEvent)) newObj.detail = value.detail;
        return newObj;
    } else return value;
}
/** Creates a string representation of the target of an `Event` object */ function $10696cb2974e7335$var$serializeEventTarget(target) {
    try {
        return (0, $d1f309ce92d0a600$export$45a5e7f76e0caa8d)(target) ? (0, $c765cb3edc177c69$export$5647df6b7814ac86)(target) : Object.prototype.toString.call(target);
    } catch  {
        return '<unknown>';
    }
}
/** Filters out all but an object's own properties */ function $10696cb2974e7335$var$getOwnProperties(obj) {
    if (typeof obj === 'object' && obj !== null) return Object.fromEntries(Object.entries(obj));
    return {};
}
/**
 * Given any captured exception, extract its keys and create a sorted
 * and truncated list that will be used inside the event message.
 * eg. `Non-error exception captured with keys: foo, bar, baz`
 */ function $10696cb2974e7335$export$b0244d5063c0b61b(exception) {
    const keys = Object.keys($10696cb2974e7335$export$62ff257738bf57f5(exception));
    keys.sort();
    return !keys[0] ? '[object has no keys]' : keys.join(', ');
}
/**
 * Given any object, return a new object having removed all fields whose value was `undefined`.
 * Works recursively on objects and arrays.
 *
 * Attention: This function keeps circular references in the returned object.
 *
 * @deprecated This function is no longer used by the SDK and will be removed in a future major version.
 */ function $10696cb2974e7335$export$d25f2688db1bb433(inputValue) {
    // This map keeps track of what already visited nodes map to.
    // Our Set - based memoBuilder doesn't work here because we want to the output object to have the same circular
    // references as the input object.
    const memoizationMap = new Map();
    // This function just proxies `_dropUndefinedKeys` to keep the `memoBuilder` out of this function's API
    return $10696cb2974e7335$var$_dropUndefinedKeys(inputValue, memoizationMap);
}
function $10696cb2974e7335$var$_dropUndefinedKeys(inputValue, memoizationMap) {
    // Early return for primitive values
    if (inputValue === null || typeof inputValue !== 'object') return inputValue;
    // Check memo map first for all object types
    const memoVal = memoizationMap.get(inputValue);
    if (memoVal !== undefined) return memoVal;
    // handle arrays
    if (Array.isArray(inputValue)) {
        const returnValue = [];
        // Store mapping to handle circular references
        memoizationMap.set(inputValue, returnValue);
        inputValue.forEach((value)=>{
            returnValue.push($10696cb2974e7335$var$_dropUndefinedKeys(value, memoizationMap));
        });
        return returnValue;
    }
    if ($10696cb2974e7335$var$isPojo(inputValue)) {
        const returnValue = {};
        // Store mapping to handle circular references
        memoizationMap.set(inputValue, returnValue);
        const keys = Object.keys(inputValue);
        keys.forEach((key)=>{
            const val = inputValue[key];
            if (val !== undefined) returnValue[key] = $10696cb2974e7335$var$_dropUndefinedKeys(val, memoizationMap);
        });
        return returnValue;
    }
    // For other object types, return as is
    return inputValue;
}
function $10696cb2974e7335$var$isPojo(input) {
    // Plain objects have Object as constructor or no constructor
    const constructor = input.constructor;
    return constructor === Object || constructor === undefined;
}
/**
 * Ensure that something is an object.
 *
 * Turns `undefined` and `null` into `String`s and all other primitives into instances of their respective wrapper
 * classes (String, Boolean, Number, etc.). Acts as the identity function on non-primitives.
 *
 * @param wat The subject of the objectification
 * @returns A version of `wat` which can safely be used with `Object` class methods
 */ function $10696cb2974e7335$export$92b78acdbe066b6b(wat) {
    let objectified;
    switch(true){
        // this will catch both undefined and null
        case wat == undefined:
            objectified = new String(wat);
            break;
        // Though symbols and bigints do have wrapper classes (`Symbol` and `BigInt`, respectively), for whatever reason
        // those classes don't have constructors which can be used with the `new` keyword. We therefore need to cast each as
        // an object in order to wrap it.
        case typeof wat === 'symbol' || typeof wat === 'bigint':
            objectified = Object(wat);
            break;
        // this will catch the remaining primitives: `String`, `Number`, and `Boolean`
        case (0, $d1f309ce92d0a600$export$c3825b437cbdea5c)(wat):
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            objectified = new wat.constructor(wat);
            break;
        // by process of elimination, at this point we know that `wat` must already be an object
        default:
            objectified = wat;
            break;
    }
    return objectified;
}



// undefined = not yet resolved, null = no runner found, function = runner found
let $11bebf6401bbfdb9$var$RESOLVED_RUNNER;
/**
 * Simple wrapper that allows SDKs to *secretly* set context wrapper to generate safe random IDs in cache components contexts
 */ function $11bebf6401bbfdb9$export$ff239213cb80e2da(cb) {
    // Skips future symbol lookups if we've already resolved (or attempted to resolve) the runner once
    if ($11bebf6401bbfdb9$var$RESOLVED_RUNNER !== undefined) return $11bebf6401bbfdb9$var$RESOLVED_RUNNER ? $11bebf6401bbfdb9$var$RESOLVED_RUNNER(cb) : cb();
    const sym = Symbol.for('__SENTRY_SAFE_RANDOM_ID_WRAPPER__');
    const globalWithSymbol = (0, $517c5b29f882562f$export$f1a6cdb1459e81d1);
    if (sym in globalWithSymbol && typeof globalWithSymbol[sym] === 'function') {
        $11bebf6401bbfdb9$var$RESOLVED_RUNNER = globalWithSymbol[sym];
        return $11bebf6401bbfdb9$var$RESOLVED_RUNNER(cb);
    }
    $11bebf6401bbfdb9$var$RESOLVED_RUNNER = null;
    return cb();
}
/**
 * Identical to Math.random() but wrapped in withRandomSafeContext
 * to ensure safe random number generation in certain contexts (e.g., Next.js Cache Components).
 */ function $11bebf6401bbfdb9$export$9869d72de32a3917() {
    return $11bebf6401bbfdb9$export$ff239213cb80e2da(()=>Math.random());
}
/**
 * Identical to Date.now() but wrapped in withRandomSafeContext
 * to ensure safe time value generation in certain contexts (e.g., Next.js Cache Components).
 */ function $11bebf6401bbfdb9$export$65b1bada40c91b34() {
    return $11bebf6401bbfdb9$export$ff239213cb80e2da(()=>Date.now());
}



const $d64dedd9c6b2e07c$var$STACKTRACE_FRAME_LIMIT = 50;
const $d64dedd9c6b2e07c$export$27c7e15d453fc0ac = '?';
// Used to sanitize webpack (error: *) wrapped stack errors
const $d64dedd9c6b2e07c$var$WEBPACK_ERROR_REGEXP = /\(error: (.*)\)/;
const $d64dedd9c6b2e07c$var$STRIP_FRAME_REGEXP = /captureMessage|captureException/;
/**
 * Creates a stack parser with the supplied line parsers
 *
 * StackFrames are returned in the correct order for Sentry Exception
 * frames and with Sentry SDK internal frames removed from the top and bottom
 *
 */ function $d64dedd9c6b2e07c$export$a5739666fb2d03d4(...parsers) {
    const sortedParsers = parsers.sort((a, b)=>a[0] - b[0]).map((p)=>p[1]);
    return (stack, skipFirstLines = 0, framesToPop = 0)=>{
        const frames = [];
        const lines = stack.split('\n');
        for(let i = skipFirstLines; i < lines.length; i++){
            let line = lines[i];
            // Truncate lines over 1kb because many of the regular expressions use
            // backtracking which results in run time that increases exponentially
            // with input size. Huge strings can result in hangs/Denial of Service:
            // https://github.com/getsentry/sentry-javascript/issues/2286
            if (line.length > 1024) line = line.slice(0, 1024);
            // https://github.com/getsentry/sentry-javascript/issues/5459
            // Remove webpack (error: *) wrappers
            const cleanedLine = $d64dedd9c6b2e07c$var$WEBPACK_ERROR_REGEXP.test(line) ? line.replace($d64dedd9c6b2e07c$var$WEBPACK_ERROR_REGEXP, '$1') : line;
            // https://github.com/getsentry/sentry-javascript/issues/7813
            // Skip Error: lines
            // Using includes() instead of a regex to avoid O(n²) backtracking on long lines
            // https://github.com/getsentry/sentry-javascript/issues/20052
            if (cleanedLine.includes('Error: ')) continue;
            for (const parser of sortedParsers){
                const frame = parser(cleanedLine);
                if (frame) {
                    frames.push(frame);
                    break;
                }
            }
            if (frames.length >= $d64dedd9c6b2e07c$var$STACKTRACE_FRAME_LIMIT + framesToPop) break;
        }
        return $d64dedd9c6b2e07c$export$c55c24c0eeba0205(frames.slice(framesToPop));
    };
}
/**
 * Gets a stack parser implementation from Options.stackParser
 * @see Options
 *
 * If options contains an array of line parsers, it is converted into a parser
 */ function $d64dedd9c6b2e07c$export$1d5cf88b347146d4(stackParser) {
    if (Array.isArray(stackParser)) return $d64dedd9c6b2e07c$export$a5739666fb2d03d4(...stackParser);
    return stackParser;
}
/**
 * Removes Sentry frames from the top and bottom of the stack if present and enforces a limit of max number of frames.
 * Assumes stack input is ordered from top to bottom and returns the reverse representation so call site of the
 * function that caused the crash is the last frame in the array.
 * @hidden
 */ function $d64dedd9c6b2e07c$export$c55c24c0eeba0205(stack) {
    if (!stack.length) return [];
    const localStack = Array.from(stack);
    // If stack starts with one of our API calls, remove it (starts, meaning it's the top of the stack - aka last call)
    if (/sentryWrapped/.test($d64dedd9c6b2e07c$var$getLastStackFrame(localStack).function || '')) localStack.pop();
    // Reversing in the middle of the procedure allows us to just pop the values off the stack
    localStack.reverse();
    // If stack ends with one of our internal API calls, remove it (ends, meaning it's the bottom of the stack - aka top-most call)
    if ($d64dedd9c6b2e07c$var$STRIP_FRAME_REGEXP.test($d64dedd9c6b2e07c$var$getLastStackFrame(localStack).function || '')) {
        localStack.pop();
        // When using synthetic events, we will have a 2 levels deep stack, as `new Error('Sentry syntheticException')`
        // is produced within the scope itself, making it:
        //
        //   Sentry.captureException()
        //   scope.captureException()
        //
        // instead of just the top `Sentry` call itself.
        // This forces us to possibly strip an additional frame in the exact same was as above.
        if ($d64dedd9c6b2e07c$var$STRIP_FRAME_REGEXP.test($d64dedd9c6b2e07c$var$getLastStackFrame(localStack).function || '')) localStack.pop();
    }
    return localStack.slice(0, $d64dedd9c6b2e07c$var$STACKTRACE_FRAME_LIMIT).map((frame)=>({
            ...frame,
            filename: frame.filename || $d64dedd9c6b2e07c$var$getLastStackFrame(localStack).filename,
            function: frame.function || $d64dedd9c6b2e07c$export$27c7e15d453fc0ac
        }));
}
function $d64dedd9c6b2e07c$var$getLastStackFrame(arr) {
    return arr[arr.length - 1] || {};
}
const $d64dedd9c6b2e07c$var$defaultFunctionName = '<anonymous>';
/**
 * Safely extract function name from itself
 */ function $d64dedd9c6b2e07c$export$aad197c7121a6651(fn) {
    try {
        if (!fn || typeof fn !== 'function') return $d64dedd9c6b2e07c$var$defaultFunctionName;
        return fn.name || $d64dedd9c6b2e07c$var$defaultFunctionName;
    } catch  {
        // Just accessing custom props in some Selenium environments
        // can cause a "Permission denied" exception (see raven-js#495).
        return $d64dedd9c6b2e07c$var$defaultFunctionName;
    }
}
/**
 * Get's stack frames from an event without needing to check for undefined properties.
 */ function $d64dedd9c6b2e07c$export$91d8ca51bd9f6a47(event) {
    const exception = event.exception;
    if (exception) {
        const frames = [];
        try {
            // @ts-expect-error Object could be undefined
            exception.values.forEach((value)=>{
                // @ts-expect-error Value could be undefined
                if (value.stacktrace.frames) // @ts-expect-error Value could be undefined
                frames.push(...value.stacktrace.frames);
            });
            return frames;
        } catch  {
            return undefined;
        }
    }
    return undefined;
}
/**
 * Get the internal name of an internal Vue value, to represent it in a stacktrace.
 *
 * @param value The value to get the internal name of.
 */ function $d64dedd9c6b2e07c$export$b6d9c5eb2330759f(value) {
    // Check if it's a VNode (has __v_isVNode) or a component instance (has _isVue/__isVue)
    const isVNode = '__v_isVNode' in value && value.__v_isVNode;
    return isVNode ? '[VueVNode]' : '[VueViewModel]';
}
/**
 * Normalizes stack line paths by removing file:// prefix and leading slashes for Windows paths
 */ function $d64dedd9c6b2e07c$export$60c0d6c8e038267a(path) {
    let filename = path?.startsWith('file://') ? path.slice(7) : path;
    // If it's a Windows path, trim the leading slash so that `/C:/foo` becomes `C:/foo`
    if (filename?.match(/\/[A-Z]:/)) filename = filename.slice(1);
    return filename;
}


/**
 * Truncates given string to the maximum characters count
 *
 * @param str An object that contains serializable values
 * @param max Maximum number of characters in truncated string (0 = unlimited)
 * @returns string Encoded
 */ function $5b085f0f99265e84$export$6a506b36fdea397d(str, max = 0) {
    if (typeof str !== 'string' || max === 0) return str;
    return str.length <= max ? str : `${str.slice(0, max)}...`;
}
/**
 * This is basically just `trim_line` from
 * https://github.com/getsentry/sentry/blob/master/src/sentry/lang/javascript/processor.py#L67
 *
 * @param str An object that contains serializable values
 * @param max Maximum number of characters in truncated string
 * @returns string Encoded
 */ function $5b085f0f99265e84$export$4215662d762d6f9d(line, colno) {
    let newLine = line;
    const lineLength = newLine.length;
    if (lineLength <= 150) return newLine;
    if (colno > lineLength) // eslint-disable-next-line no-param-reassign
    colno = lineLength;
    let start = Math.max(colno - 60, 0);
    if (start < 5) start = 0;
    let end = Math.min(start + 140, lineLength);
    if (end > lineLength - 5) end = lineLength;
    if (end === lineLength) start = Math.max(end - 140, 0);
    newLine = newLine.slice(start, end);
    if (start > 0) newLine = `'{snip} ${newLine}`;
    if (end < lineLength) newLine += ' {snip}';
    return newLine;
}
/**
 * Join values in array
 * @param input array of values to be joined together
 * @param delimiter string to be placed in-between values
 * @returns Joined values
 */ function $5b085f0f99265e84$export$465e9d514283d4fd(input, delimiter) {
    if (!Array.isArray(input)) return '';
    const output = [];
    // eslint-disable-next-line typescript/prefer-for-of
    for(let i = 0; i < input.length; i++){
        const value = input[i];
        try {
            // This is a hack to fix a Vue3-specific bug that causes an infinite loop of
            // console warnings. This happens when a Vue template is rendered with
            // an undeclared variable, which we try to stringify, ultimately causing
            // Vue to issue another warning which repeats indefinitely.
            // see: https://github.com/getsentry/sentry-javascript/pull/8981
            if ((0, $d1f309ce92d0a600$export$7916fad0ebc23f48)(value)) output.push((0, $d64dedd9c6b2e07c$export$b6d9c5eb2330759f)(value));
            else output.push(String(value));
        } catch  {
            output.push('[value cannot be serialized]');
        }
    }
    return output.join(delimiter);
}
/**
 * Checks if the given value matches a regex or string
 *
 * @param value The string to test
 * @param pattern Either a regex or a string against which `value` will be matched
 * @param requireExactStringMatch If true, `value` must match `pattern` exactly. If false, `value` will match
 * `pattern` if it contains `pattern`. Only applies to string-type patterns.
 */ function $5b085f0f99265e84$export$cdded5b28a5f8c6d(value, pattern, requireExactStringMatch = false) {
    if (!(0, $d1f309ce92d0a600$export$844ec244b1367d54)(value)) return false;
    if ((0, $d1f309ce92d0a600$export$49841c62b9eff15)(pattern)) return pattern.test(value);
    if ((0, $d1f309ce92d0a600$export$844ec244b1367d54)(pattern)) return requireExactStringMatch ? value === pattern : value.includes(pattern);
    if (typeof pattern === 'function') return pattern(value);
    return false;
}
/**
 * Test the given string against an array of strings and regexes. By default, string matching is done on a
 * substring-inclusion basis rather than a strict equality basis
 *
 * @param testString The string to test
 * @param patterns The patterns against which to test the string
 * @param requireExactStringMatch If true, `testString` must match one of the given string patterns exactly in order to
 * count. If false, `testString` will match a string pattern if it contains that pattern.
 * @returns
 */ function $5b085f0f99265e84$export$a7a5ec66062ea5d(testString, patterns = [], requireExactStringMatch = false) {
    return patterns.some((pattern)=>$5b085f0f99265e84$export$cdded5b28a5f8c6d(testString, pattern, requireExactStringMatch));
}



function $76366c1ad7fe29b9$var$getCrypto() {
    const gbl = (0, $517c5b29f882562f$export$f1a6cdb1459e81d1);
    return gbl.crypto || gbl.msCrypto;
}
let $76366c1ad7fe29b9$var$emptyUuid;
function $76366c1ad7fe29b9$var$getRandomByte() {
    return (0, $11bebf6401bbfdb9$export$9869d72de32a3917)() * 16;
}
/**
 * UUID4 generator
 * @param crypto Object that provides the crypto API.
 * @returns string Generated UUID4.
 */ function $76366c1ad7fe29b9$export$19f53698e68b2496(crypto = $76366c1ad7fe29b9$var$getCrypto()) {
    try {
        if (crypto?.randomUUID) // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        return (0, $11bebf6401bbfdb9$export$ff239213cb80e2da)(()=>crypto.randomUUID()).replace(/-/g, '');
    } catch  {
    // some runtimes can crash invoking crypto
    // https://github.com/getsentry/sentry-javascript/issues/8935
    }
    if (!$76366c1ad7fe29b9$var$emptyUuid) // http://stackoverflow.com/questions/105034/how-to-create-a-guid-uuid-in-javascript/2117523#2117523
    // Concatenating the following numbers as strings results in '10000000100040008000100000000000'
    $76366c1ad7fe29b9$var$emptyUuid = "10000000100040008000100000000000";
    return $76366c1ad7fe29b9$var$emptyUuid.replace(/[018]/g, (c)=>// eslint-disable-next-line no-bitwise
        (c ^ ($76366c1ad7fe29b9$var$getRandomByte() & 15) >> c / 4).toString(16));
}
function $76366c1ad7fe29b9$var$getFirstException(event) {
    return event.exception?.values?.[0];
}
/**
 * Extracts either message or type+value from an event that can be used for user-facing logs
 * @returns event's description
 */ function $76366c1ad7fe29b9$export$4157119e2b157127(event) {
    const { message: message, event_id: eventId } = event;
    if (message) return message;
    const firstException = $76366c1ad7fe29b9$var$getFirstException(event);
    if (firstException) {
        if (firstException.type && firstException.value) return `${firstException.type}: ${firstException.value}`;
        return firstException.type || firstException.value || eventId || '<unknown>';
    }
    return eventId || '<unknown>';
}
/**
 * Adds exception values, type and value to an synthetic Exception.
 * @param event The event to modify.
 * @param value Value of the exception.
 * @param type Type of the exception.
 * @hidden
 */ function $76366c1ad7fe29b9$export$f26508487bf83ee7(event, value, type) {
    const exception = event.exception = event.exception || {};
    const values = exception.values = exception.values || [];
    const firstException = values[0] = values[0] || {};
    if (!firstException.value) firstException.value = value || '';
    if (!firstException.type) firstException.type = type || 'Error';
}
/**
 * Adds exception mechanism data to a given event. Uses defaults if the second parameter is not passed.
 *
 * @param event The event to modify.
 * @param newMechanism Mechanism data to add to the event.
 * @hidden
 */ function $76366c1ad7fe29b9$export$c69a9a0313b03bb1(event, newMechanism) {
    const firstException = $76366c1ad7fe29b9$var$getFirstException(event);
    if (!firstException) return;
    const defaultMechanism = {
        type: 'generic',
        handled: true
    };
    const currentMechanism = firstException.mechanism;
    firstException.mechanism = {
        ...defaultMechanism,
        ...currentMechanism,
        ...newMechanism
    };
    if (newMechanism && 'data' in newMechanism) {
        const mergedData = {
            ...currentMechanism?.data,
            ...newMechanism.data
        };
        firstException.mechanism.data = mergedData;
    }
}
// https://semver.org/#is-there-a-suggested-regular-expression-regex-to-check-a-semver-string
const $76366c1ad7fe29b9$var$SEMVER_REGEXP = /^(0|[1-9]\d*)\.(0|[1-9]\d*)\.(0|[1-9]\d*)(?:-((?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*)(?:\.(?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*))*))?(?:\+([0-9a-zA-Z-]+(?:\.[0-9a-zA-Z-]+)*))?$/;
/**
 * Represents Semantic Versioning object
 */ function $76366c1ad7fe29b9$var$_parseInt(input) {
    return parseInt(input || '', 10);
}
/**
 * Parses input into a SemVer interface
 * @param input string representation of a semver version
 */ function $76366c1ad7fe29b9$export$d364f2020ab30578(input) {
    const match = input.match($76366c1ad7fe29b9$var$SEMVER_REGEXP) || [];
    const major = $76366c1ad7fe29b9$var$_parseInt(match[1]);
    const minor = $76366c1ad7fe29b9$var$_parseInt(match[2]);
    const patch = $76366c1ad7fe29b9$var$_parseInt(match[3]);
    return {
        buildmetadata: match[5],
        major: isNaN(major) ? undefined : major,
        minor: isNaN(minor) ? undefined : minor,
        patch: isNaN(patch) ? undefined : patch,
        prerelease: match[4]
    };
}
/**
 * This function adds context (pre/post/line) lines to the provided frame
 *
 * @param lines string[] containing all lines
 * @param frame StackFrame that will be mutated
 * @param linesOfContext number of context lines we want to add pre/post
 */ function $76366c1ad7fe29b9$export$ec2291bfc64632f0(lines, frame, linesOfContext = 5) {
    // When there is no line number in the frame, attaching context is nonsensical and will even break grouping
    if (frame.lineno === undefined) return;
    const maxLines = lines.length;
    const sourceLine = Math.max(Math.min(maxLines - 1, frame.lineno - 1), 0);
    frame.pre_context = lines.slice(Math.max(0, sourceLine - linesOfContext), sourceLine).map((line)=>(0, $5b085f0f99265e84$export$4215662d762d6f9d)(line, 0));
    // We guard here to ensure this is not larger than the existing number of lines
    const lineIndex = Math.min(maxLines - 1, sourceLine);
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    frame.context_line = (0, $5b085f0f99265e84$export$4215662d762d6f9d)(lines[lineIndex], frame.colno || 0);
    frame.post_context = lines.slice(Math.min(sourceLine + 1, maxLines), sourceLine + 1 + linesOfContext).map((line)=>(0, $5b085f0f99265e84$export$4215662d762d6f9d)(line, 0));
}
/**
 * Checks whether or not we've already captured the given exception (note: not an identical exception - the very object
 * in question), and marks it captured if not.
 *
 * This is useful because it's possible for an error to get captured by more than one mechanism. After we intercept and
 * record an error, we rethrow it (assuming we've intercepted it before it's reached the top-level global handlers), so
 * that we don't interfere with whatever effects the error might have had were the SDK not there. At that point, because
 * the error has been rethrown, it's possible for it to bubble up to some other code we've instrumented. If it's not
 * caught after that, it will bubble all the way up to the global handlers (which of course we also instrument). This
 * function helps us ensure that even if we encounter the same error more than once, we only record it the first time we
 * see it.
 *
 * Note: It will ignore primitives (always return `false` and not mark them as seen), as properties can't be set on
 * them. {@link: Object.objectify} can be used on exceptions to convert any that are primitives into their equivalent
 * object wrapper forms so that this check will always work. However, because we need to flag the exact object which
 * will get rethrown, and because that rethrowing happens outside of the event processing pipeline, the objectification
 * must be done before the exception captured.
 *
 * @param A thrown exception to check or flag as having been seen
 * @returns `true` if the exception has already been captured, `false` if not (with the side effect of marking it seen)
 */ function $76366c1ad7fe29b9$export$6de4ffac6a2f1098(exception) {
    if ($76366c1ad7fe29b9$export$4a38e013f66150b(exception)) return true;
    try {
        // set it this way rather than by assignment so that it's not ennumerable and therefore isn't recorded by the
        // `ExtraErrorData` integration
        (0, $10696cb2974e7335$export$e73679ffaf56810e)(exception, '__sentry_captured__', true);
    } catch  {
    // `exception` is a primitive, so we can't mark it seen
    }
    return false;
}
/**
 * Checks whether we've already captured the given exception (note: not an identical exception - the very object).
 * It is considered already captured if it has the `__sentry_captured__` property set to `true`.
 *
 * @internal Only considered for internal usage
 */ function $76366c1ad7fe29b9$export$4a38e013f66150b(exception) {
    try {
        return exception.__sentry_captured__;
    } catch  {} // eslint-disable-line no-empty
}




const $27fab3c4acc6cd95$var$ONE_SECOND_IN_MS = 1000;
/**
 * A partial definition of the [Performance Web API]{@link https://developer.mozilla.org/en-US/docs/Web/API/Performance}
 * for accessing a high-resolution monotonic clock.
 */ /**
 * Returns a timestamp in seconds since the UNIX epoch using the Date API.
 */ function $27fab3c4acc6cd95$export$7740643b9eeaf0c4() {
    return (0, $11bebf6401bbfdb9$export$65b1bada40c91b34)() / $27fab3c4acc6cd95$var$ONE_SECOND_IN_MS;
}
/**
 * Returns a wrapper around the native Performance API browser implementation, or undefined for browsers that do not
 * support the API.
 *
 * Wrapping the native API works around differences in behavior from different browsers.
 */ function $27fab3c4acc6cd95$var$createUnixTimestampInSecondsFunc() {
    const { performance: performance } = (0, $517c5b29f882562f$export$f1a6cdb1459e81d1);
    // Some browser and environments don't have a performance or timeOrigin, so we fallback to
    // using Date.now() to compute the starting time.
    if (!performance?.now || !performance.timeOrigin) return $27fab3c4acc6cd95$export$7740643b9eeaf0c4;
    const timeOrigin = performance.timeOrigin;
    // performance.now() is a monotonic clock, which means it starts at 0 when the process begins. To get the current
    // wall clock time (actual UNIX timestamp), we need to add the starting time origin and the current time elapsed.
    //
    // TODO: This does not account for the case where the monotonic clock that powers performance.now() drifts from the
    // wall clock time, which causes the returned timestamp to be inaccurate. We should investigate how to detect and
    // correct for this.
    // See: https://github.com/getsentry/sentry-javascript/issues/2590
    // See: https://github.com/mdn/content/issues/4713
    // See: https://dev.to/noamr/when-a-millisecond-is-not-a-millisecond-3h6
    return ()=>{
        return (timeOrigin + (0, $11bebf6401bbfdb9$export$ff239213cb80e2da)(()=>performance.now())) / $27fab3c4acc6cd95$var$ONE_SECOND_IN_MS;
    };
}
let $27fab3c4acc6cd95$var$_cachedTimestampInSeconds;
/**
 * Returns a timestamp in seconds since the UNIX epoch using either the Performance or Date APIs, depending on the
 * availability of the Performance API.
 *
 * BUG: Note that because of how browsers implement the Performance API, the clock might stop when the computer is
 * asleep. This creates a skew between `dateTimestampInSeconds` and `timestampInSeconds`. The
 * skew can grow to arbitrary amounts like days, weeks or months.
 * See https://github.com/getsentry/sentry-javascript/issues/2590.
 */ function $27fab3c4acc6cd95$export$ee52dced521e3e18() {
    // We store this in a closure so that we don't have to create a new function every time this is called.
    const func = $27fab3c4acc6cd95$var$_cachedTimestampInSeconds ?? ($27fab3c4acc6cd95$var$_cachedTimestampInSeconds = $27fab3c4acc6cd95$var$createUnixTimestampInSecondsFunc());
    return func();
}
/**
 * Cached result of getBrowserTimeOrigin.
 */ let $27fab3c4acc6cd95$var$cachedTimeOrigin = null;
/**
 * Gets the time origin and the mode used to determine it.
 *
 * Unfortunately browsers may report an inaccurate time origin data, through either performance.timeOrigin or
 * performance.timing.navigationStart, which results in poor results in performance data. We only treat time origin
 * data as reliable if they are within a reasonable threshold of the current time.
 *
 * TODO: move to `@sentry/browser-utils` package.
 */ function $27fab3c4acc6cd95$var$getBrowserTimeOrigin() {
    const { performance: performance } = (0, $517c5b29f882562f$export$f1a6cdb1459e81d1);
    if (!performance?.now) return undefined;
    const threshold = 300000; // 5 minutes in milliseconds
    const performanceNow = (0, $11bebf6401bbfdb9$export$ff239213cb80e2da)(()=>performance.now());
    const dateNow = (0, $11bebf6401bbfdb9$export$65b1bada40c91b34)();
    const timeOrigin = performance.timeOrigin;
    if (typeof timeOrigin === 'number') {
        const timeOriginDelta = Math.abs(timeOrigin + performanceNow - dateNow);
        if (timeOriginDelta < threshold) return timeOrigin;
    }
    // TODO: Remove all code related to `performance.timing.navigationStart` once we drop support for Safari 14.
    // `performance.timeSince` is available in Safari 15.
    // see: https://caniuse.com/mdn-api_performance_timeorigin
    // While performance.timing.navigationStart is deprecated in favor of performance.timeOrigin, performance.timeOrigin
    // is not as widely supported. Namely, performance.timeOrigin is undefined in Safari as of writing.
    // Also as of writing, performance.timing is not available in Web Workers in mainstream browsers, so it is not always
    // a valid fallback. In the absence of an initial time provided by the browser, fallback to the current time from the
    // Date API.
    // eslint-disable-next-line deprecation/deprecation
    const navigationStart = performance.timing?.navigationStart;
    if (typeof navigationStart === 'number') {
        const navigationStartDelta = Math.abs(navigationStart + performanceNow - dateNow);
        if (navigationStartDelta < threshold) return navigationStart;
    }
    // Either both timeOrigin and navigationStart are skewed or neither is available, fallback to subtracting
    // `performance.now()` from `Date.now()`.
    return dateNow - performanceNow;
}
/**
 * The number of milliseconds since the UNIX epoch. This value is only usable in a browser, and only when the
 * performance API is available.
 */ function $27fab3c4acc6cd95$export$baf075a948ffc0bf() {
    if ($27fab3c4acc6cd95$var$cachedTimeOrigin === null) $27fab3c4acc6cd95$var$cachedTimeOrigin = $27fab3c4acc6cd95$var$getBrowserTimeOrigin();
    return $27fab3c4acc6cd95$var$cachedTimeOrigin;
}


/**
 * Creates a new `Session` object by setting certain default parameters. If optional @param context
 * is passed, the passed properties are applied to the session object.
 *
 * @param context (optional) additional properties to be applied to the returned session object
 *
 * @returns a new `Session` object
 */ function $71bbb010c8615be2$export$14a186326edbb264(context) {
    // Both timestamp and started are in seconds since the UNIX epoch.
    const startingTime = (0, $27fab3c4acc6cd95$export$ee52dced521e3e18)();
    const session = {
        sid: (0, $76366c1ad7fe29b9$export$19f53698e68b2496)(),
        init: true,
        timestamp: startingTime,
        started: startingTime,
        duration: 0,
        status: 'ok',
        errors: 0,
        ignoreDuration: false,
        toJSON: ()=>$71bbb010c8615be2$var$sessionToJSON(session)
    };
    if (context) $71bbb010c8615be2$export$531818e825e774db(session, context);
    return session;
}
/**
 * Updates a session object with the properties passed in the context.
 *
 * Note that this function mutates the passed object and returns void.
 * (Had to do this instead of returning a new and updated session because closing and sending a session
 * makes an update to the session after it was passed to the sending logic.
 * @see Client.captureSession )
 *
 * @param session the `Session` to update
 * @param context the `SessionContext` holding the properties that should be updated in @param session
 */ // eslint-disable-next-line complexity
function $71bbb010c8615be2$export$531818e825e774db(session, context = {}) {
    if (context.user) {
        if (!session.ipAddress && context.user.ip_address) session.ipAddress = context.user.ip_address;
        if (!session.did && !context.did) session.did = context.user.id || context.user.email || context.user.username;
    }
    session.timestamp = context.timestamp || (0, $27fab3c4acc6cd95$export$ee52dced521e3e18)();
    if (context.abnormal_mechanism) session.abnormal_mechanism = context.abnormal_mechanism;
    if (context.ignoreDuration) session.ignoreDuration = context.ignoreDuration;
    if (context.sid) // Good enough uuid validation. — Kamil
    session.sid = context.sid.length === 32 ? context.sid : (0, $76366c1ad7fe29b9$export$19f53698e68b2496)();
    if (context.init !== undefined) session.init = context.init;
    if (!session.did && context.did) session.did = `${context.did}`;
    if (typeof context.started === 'number') session.started = context.started;
    if (session.ignoreDuration) session.duration = undefined;
    else if (typeof context.duration === 'number') session.duration = context.duration;
    else {
        const duration = session.timestamp - session.started;
        session.duration = duration >= 0 ? duration : 0;
    }
    if (context.release) session.release = context.release;
    if (context.environment) session.environment = context.environment;
    if (!session.ipAddress && context.ipAddress) session.ipAddress = context.ipAddress;
    if (!session.userAgent && context.userAgent) session.userAgent = context.userAgent;
    if (typeof context.errors === 'number') session.errors = context.errors;
    if (context.status) session.status = context.status;
}
/**
 * Closes a session by setting its status and updating the session object with it.
 * Internally calls `updateSession` to update the passed session object.
 *
 * Note that this function mutates the passed session (@see updateSession for explanation).
 *
 * @param session the `Session` object to be closed
 * @param status the `SessionStatus` with which the session was closed. If you don't pass a status,
 *               this function will keep the previously set status, unless it was `'ok'` in which case
 *               it is changed to `'exited'`.
 */ function $71bbb010c8615be2$export$56521d9ba90f62ee(session, status) {
    let context = {};
    if (status) context = {
        status: status
    };
    else if (session.status === 'ok') context = {
        status: 'exited'
    };
    $71bbb010c8615be2$export$531818e825e774db(session, context);
}
/**
 * Serializes a passed session object to a JSON object with a slightly different structure.
 * This is necessary because the Sentry backend requires a slightly different schema of a session
 * than the one the JS SDKs use internally.
 *
 * @param session the session to be converted
 *
 * @returns a JSON object of the passed session
 */ function $71bbb010c8615be2$var$sessionToJSON(session) {
    return {
        sid: `${session.sid}`,
        init: session.init,
        // Make sure that sec is converted to ms for date constructor
        started: new Date(session.started * 1000).toISOString(),
        timestamp: new Date(session.timestamp * 1000).toISOString(),
        status: session.status,
        errors: session.errors,
        did: typeof session.did === 'number' || typeof session.did === 'string' ? `${session.did}` : undefined,
        duration: session.duration,
        abnormal_mechanism: session.abnormal_mechanism,
        attrs: {
            release: session.release,
            environment: session.environment,
            ip_address: session.ipAddress,
            user_agent: session.userAgent
        }
    };
}




/**
 * Shallow merge two objects.
 * Does not mutate the passed in objects.
 * Undefined/empty values in the merge object will overwrite existing values.
 *
 * By default, this merges 2 levels deep.
 */ function $cc0188753ac1c798$export$4950aa0f605343fb(initialObj, mergeObj, levels = 2) {
    // If the merge value is not an object, or we have no merge levels left,
    // we just set the value to the merge value
    if (!mergeObj || typeof mergeObj !== 'object' || levels <= 0) return mergeObj;
    // If the merge object is an empty object, and the initial object is not undefined, we return the initial object
    if (initialObj && Object.keys(mergeObj).length === 0) return initialObj;
    // Clone object
    const output = {
        ...initialObj
    };
    // Merge values into output, resursively
    for(const key in mergeObj)if (Object.prototype.hasOwnProperty.call(mergeObj, key)) output[key] = $cc0188753ac1c798$export$4950aa0f605343fb(output[key], mergeObj[key], levels - 1);
    return output;
}




/**
 * Generate a random, valid trace ID.
 */ function $1eac0e3178cad4a9$export$dc6d7ea554bcce10() {
    return (0, $76366c1ad7fe29b9$export$19f53698e68b2496)();
}
/**
 * Generate a random, valid span ID.
 */ function $1eac0e3178cad4a9$export$295213bc4d0c54ad() {
    return (0, $76366c1ad7fe29b9$export$19f53698e68b2496)().substring(16);
}




const $18f1bf9c6bfa5b9e$var$SCOPE_SPAN_FIELD = '_sentrySpan';
/**
 * Set the active span for a given scope.
 * NOTE: This should NOT be used directly, but is only used internally by the trace methods.
 */ function $18f1bf9c6bfa5b9e$export$3f25fa50c18e20ca(scope, span) {
    if (span) (0, $10696cb2974e7335$export$e73679ffaf56810e)(scope, $18f1bf9c6bfa5b9e$var$SCOPE_SPAN_FIELD, span);
    else // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
    delete scope[$18f1bf9c6bfa5b9e$var$SCOPE_SPAN_FIELD];
}
/**
 * Get the active span for a given scope.
 * NOTE: This should NOT be used directly, but is only used internally by the trace methods.
 */ function $18f1bf9c6bfa5b9e$export$91f063ebb8eff307(scope) {
    return scope[$18f1bf9c6bfa5b9e$var$SCOPE_SPAN_FIELD];
}




/**
 * Default value for maximum number of breadcrumbs added to an event.
 */ const $b569c377336cf232$var$DEFAULT_MAX_BREADCRUMBS = 100;
/**
 * A context to be used for capturing an event.
 * This can either be a Scope, or a partial ScopeContext,
 * or a callback that receives the current scope and returns a new scope to use.
 */ /**
 * Holds additional event information.
 */ class $b569c377336cf232$export$775b6bb06e53a214 {
    /** Flag if notifying is happening. */ /** Callback for client to receive scope changes. */ /** Callback list that will be called during event processing. */ /** Array of breadcrumbs. */ /** User */ /** Tags */ /** Attributes */ /** Extra */ /** Contexts */ /** Attachments */ /** Propagation Context for distributed tracing */ /**
   * A place to stash data which is needed at some point in the SDK's event processing pipeline but which shouldn't get
   * sent to Sentry
   */ /** Fingerprint */ /** Severity */ /**
   * Transaction Name
   *
   * IMPORTANT: The transaction name on the scope has nothing to do with root spans/transaction objects.
   * It's purpose is to assign a transaction to the scope that's added to non-transaction events.
   */ /** Session */ /** The client on this scope */ /** Contains the last event id of a captured event.  */ /** Conversation ID */ // NOTE: Any field which gets added here should get added not only to the constructor but also to the `clone` method.
    constructor(){
        this._notifyingListeners = false;
        this._scopeListeners = [];
        this._eventProcessors = [];
        this._breadcrumbs = [];
        this._attachments = [];
        this._user = {};
        this._tags = {};
        this._attributes = {};
        this._extra = {};
        this._contexts = {};
        this._sdkProcessingMetadata = {};
        this._propagationContext = {
            traceId: (0, $1eac0e3178cad4a9$export$dc6d7ea554bcce10)(),
            sampleRand: (0, $11bebf6401bbfdb9$export$9869d72de32a3917)()
        };
    }
    /**
   * Clone all data from this scope into a new scope.
   */ clone() {
        const newScope = new $b569c377336cf232$export$775b6bb06e53a214();
        newScope._breadcrumbs = [
            ...this._breadcrumbs
        ];
        newScope._tags = {
            ...this._tags
        };
        newScope._attributes = {
            ...this._attributes
        };
        newScope._extra = {
            ...this._extra
        };
        newScope._contexts = {
            ...this._contexts
        };
        if (this._contexts.flags) // We need to copy the `values` array so insertions on a cloned scope
        // won't affect the original array.
        newScope._contexts.flags = {
            values: [
                ...this._contexts.flags.values
            ]
        };
        newScope._user = this._user;
        newScope._level = this._level;
        newScope._session = this._session;
        newScope._transactionName = this._transactionName;
        newScope._fingerprint = this._fingerprint;
        newScope._eventProcessors = [
            ...this._eventProcessors
        ];
        newScope._attachments = [
            ...this._attachments
        ];
        newScope._sdkProcessingMetadata = {
            ...this._sdkProcessingMetadata
        };
        newScope._propagationContext = {
            ...this._propagationContext
        };
        newScope._client = this._client;
        newScope._lastEventId = this._lastEventId;
        newScope._conversationId = this._conversationId;
        (0, $18f1bf9c6bfa5b9e$export$3f25fa50c18e20ca)(newScope, (0, $18f1bf9c6bfa5b9e$export$91f063ebb8eff307)(this));
        return newScope;
    }
    /**
   * Update the client assigned to this scope.
   * Note that not every scope will have a client assigned - isolation scopes & the global scope will generally not have a client,
   * as well as manually created scopes.
   */ setClient(client) {
        this._client = client;
    }
    /**
   * Set the ID of the last captured error event.
   * This is generally only captured on the isolation scope.
   */ setLastEventId(lastEventId) {
        this._lastEventId = lastEventId;
    }
    /**
   * Get the client assigned to this scope.
   */ getClient() {
        return this._client;
    }
    /**
   * Get the ID of the last captured error event.
   * This is generally only available on the isolation scope.
   */ lastEventId() {
        return this._lastEventId;
    }
    /**
   * @inheritDoc
   */ addScopeListener(callback) {
        this._scopeListeners.push(callback);
    }
    /**
   * Add an event processor that will be called before an event is sent.
   */ addEventProcessor(callback) {
        this._eventProcessors.push(callback);
        return this;
    }
    /**
   * Set the user for this scope.
   * Set to `null` to unset the user.
   */ setUser(user) {
        // If null is passed we want to unset everything, but still define keys,
        // so that later down in the pipeline any existing values are cleared.
        this._user = user || {
            email: undefined,
            id: undefined,
            ip_address: undefined,
            username: undefined
        };
        if (this._session) (0, $71bbb010c8615be2$export$531818e825e774db)(this._session, {
            user: user
        });
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Get the user from this scope.
   */ getUser() {
        return this._user;
    }
    /**
   * Set the conversation ID for this scope.
   * Set to `null` to unset the conversation ID.
   */ setConversationId(conversationId) {
        this._conversationId = conversationId || undefined;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Set an object that will be merged into existing tags on the scope,
   * and will be sent as tags data with the event.
   */ setTags(tags) {
        this._tags = {
            ...this._tags,
            ...tags
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Set a single tag that will be sent as tags data with the event.
   */ setTag(key, value) {
        return this.setTags({
            [key]: value
        });
    }
    /**
   * Sets attributes onto the scope.
   *
   * These attributes are currently applied to logs and metrics.
   * In the future, they will also be applied to spans.
   *
   * Important: For now, only strings, numbers and boolean attributes are supported, despite types allowing for
   * more complex attribute types. We'll add this support in the future but already specify the wider type to
   * avoid a breaking change in the future.
   *
   * @param newAttributes - The attributes to set on the scope. You can either pass in key-value pairs, or
   * an object with a `value` and an optional `unit` (if applicable to your attribute).
   *
   * @example
   * ```typescript
   * scope.setAttributes({
   *   is_admin: true,
   *   payment_selection: 'credit_card',
   *   render_duration: { value: 'render_duration', unit: 'ms' },
   * });
   * ```
   */ setAttributes(newAttributes) {
        this._attributes = {
            ...this._attributes,
            ...newAttributes
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Sets an attribute onto the scope.
   *
   * These attributes are currently applied to logs and metrics.
   * In the future, they will also be applied to spans.
   *
   * Important: For now, only strings, numbers and boolean attributes are supported, despite types allowing for
   * more complex attribute types. We'll add this support in the future but already specify the wider type to
   * avoid a breaking change in the future.
   *
   * @param key - The attribute key.
   * @param value - the attribute value. You can either pass in a raw value, or an attribute
   * object with a `value` and an optional `unit` (if applicable to your attribute).
   *
   * @example
   * ```typescript
   * scope.setAttribute('is_admin', true);
   * scope.setAttribute('render_duration', { value: 'render_duration', unit: 'ms' });
   * ```
   */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    setAttribute(key, value) {
        return this.setAttributes({
            [key]: value
        });
    }
    /**
   * Removes the attribute with the given key from the scope.
   *
   * @param key - The attribute key.
   *
   * @example
   * ```typescript
   * scope.removeAttribute('is_admin');
   * ```
   */ removeAttribute(key) {
        if (key in this._attributes) {
            // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
            delete this._attributes[key];
            this._notifyScopeListeners();
        }
        return this;
    }
    /**
   * Set an object that will be merged into existing extra on the scope,
   * and will be sent as extra data with the event.
   */ setExtras(extras) {
        this._extra = {
            ...this._extra,
            ...extras
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Set a single key:value extra entry that will be sent as extra data with the event.
   */ setExtra(key, extra) {
        this._extra = {
            ...this._extra,
            [key]: extra
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Sets the fingerprint on the scope to send with the events.
   * @param {string[]} fingerprint Fingerprint to group events in Sentry.
   */ setFingerprint(fingerprint) {
        this._fingerprint = fingerprint;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Sets the level on the scope for future events.
   */ setLevel(level) {
        this._level = level;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Sets the transaction name on the scope so that the name of e.g. taken server route or
   * the page location is attached to future events.
   *
   * IMPORTANT: Calling this function does NOT change the name of the currently active
   * root span. If you want to change the name of the active root span, use
   * `Sentry.updateSpanName(rootSpan, 'new name')` instead.
   *
   * By default, the SDK updates the scope's transaction name automatically on sensible
   * occasions, such as a page navigation or when handling a new request on the server.
   */ setTransactionName(name) {
        this._transactionName = name;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Sets context data with the given name.
   * Data passed as context will be normalized. You can also pass `null` to unset the context.
   * Note that context data will not be merged - calling `setContext` will overwrite an existing context with the same key.
   */ setContext(key, context) {
        if (context === null) // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
        delete this._contexts[key];
        else this._contexts[key] = context;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Set the session for the scope.
   */ setSession(session) {
        if (!session) delete this._session;
        else this._session = session;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Get the session from the scope.
   */ getSession() {
        return this._session;
    }
    /**
   * Updates the scope with provided data. Can work in three variations:
   * - plain object containing updatable attributes
   * - Scope instance that'll extract the attributes from
   * - callback function that'll receive the current scope as an argument and allow for modifications
   */ update(captureContext) {
        if (!captureContext) return this;
        const scopeToMerge = typeof captureContext === 'function' ? captureContext(this) : captureContext;
        const scopeInstance = scopeToMerge instanceof $b569c377336cf232$export$775b6bb06e53a214 ? scopeToMerge.getScopeData() : (0, $d1f309ce92d0a600$export$53b83ca8eaab0383)(scopeToMerge) ? captureContext : undefined;
        const { tags: tags, attributes: attributes, extra: extra, user: user, contexts: contexts, level: level, fingerprint: fingerprint = [], propagationContext: propagationContext, conversationId: conversationId } = scopeInstance || {};
        this._tags = {
            ...this._tags,
            ...tags
        };
        this._attributes = {
            ...this._attributes,
            ...attributes
        };
        this._extra = {
            ...this._extra,
            ...extra
        };
        this._contexts = {
            ...this._contexts,
            ...contexts
        };
        if (user && Object.keys(user).length) this._user = user;
        if (level) this._level = level;
        if (fingerprint.length) this._fingerprint = fingerprint;
        if (propagationContext) this._propagationContext = propagationContext;
        if (conversationId) this._conversationId = conversationId;
        return this;
    }
    /**
   * Clears the current scope and resets its properties.
   * Note: The client will not be cleared.
   */ clear() {
        // client is not cleared here on purpose!
        this._breadcrumbs = [];
        this._tags = {};
        this._attributes = {};
        this._extra = {};
        this._user = {};
        this._contexts = {};
        this._level = undefined;
        this._transactionName = undefined;
        this._fingerprint = undefined;
        this._session = undefined;
        this._conversationId = undefined;
        (0, $18f1bf9c6bfa5b9e$export$3f25fa50c18e20ca)(this, undefined);
        this._attachments = [];
        this.setPropagationContext({
            traceId: (0, $1eac0e3178cad4a9$export$dc6d7ea554bcce10)(),
            sampleRand: (0, $11bebf6401bbfdb9$export$9869d72de32a3917)()
        });
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Adds a breadcrumb to the scope.
   * By default, the last 100 breadcrumbs are kept.
   */ addBreadcrumb(breadcrumb, maxBreadcrumbs) {
        const maxCrumbs = typeof maxBreadcrumbs === 'number' ? maxBreadcrumbs : $b569c377336cf232$var$DEFAULT_MAX_BREADCRUMBS;
        // No data has been changed, so don't notify scope listeners
        if (maxCrumbs <= 0) return this;
        const mergedBreadcrumb = {
            timestamp: (0, $27fab3c4acc6cd95$export$7740643b9eeaf0c4)(),
            ...breadcrumb,
            // Breadcrumb messages can theoretically be infinitely large and they're held in memory so we truncate them not to leak (too much) memory
            message: breadcrumb.message ? (0, $5b085f0f99265e84$export$6a506b36fdea397d)(breadcrumb.message, 2048) : breadcrumb.message
        };
        this._breadcrumbs.push(mergedBreadcrumb);
        if (this._breadcrumbs.length > maxCrumbs) {
            this._breadcrumbs = this._breadcrumbs.slice(-maxCrumbs);
            this._client?.recordDroppedEvent('buffer_overflow', 'log_item');
        }
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Get the last breadcrumb of the scope.
   */ getLastBreadcrumb() {
        return this._breadcrumbs[this._breadcrumbs.length - 1];
    }
    /**
   * Clear all breadcrumbs from the scope.
   */ clearBreadcrumbs() {
        this._breadcrumbs = [];
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Add an attachment to the scope.
   */ addAttachment(attachment) {
        this._attachments.push(attachment);
        return this;
    }
    /**
   * Clear all attachments from the scope.
   */ clearAttachments() {
        this._attachments = [];
        return this;
    }
    /**
   * Get the data of this scope, which should be applied to an event during processing.
   */ getScopeData() {
        return {
            breadcrumbs: this._breadcrumbs,
            attachments: this._attachments,
            contexts: this._contexts,
            tags: this._tags,
            attributes: this._attributes,
            extra: this._extra,
            user: this._user,
            level: this._level,
            fingerprint: this._fingerprint || [],
            eventProcessors: this._eventProcessors,
            propagationContext: this._propagationContext,
            sdkProcessingMetadata: this._sdkProcessingMetadata,
            transactionName: this._transactionName,
            span: (0, $18f1bf9c6bfa5b9e$export$91f063ebb8eff307)(this),
            conversationId: this._conversationId
        };
    }
    /**
   * Add data which will be accessible during event processing but won't get sent to Sentry.
   */ setSDKProcessingMetadata(newData) {
        this._sdkProcessingMetadata = (0, $cc0188753ac1c798$export$4950aa0f605343fb)(this._sdkProcessingMetadata, newData, 2);
        return this;
    }
    /**
   * Add propagation context to the scope, used for distributed tracing
   */ setPropagationContext(context) {
        this._propagationContext = context;
        return this;
    }
    /**
   * Get propagation context from the scope, used for distributed tracing
   */ getPropagationContext() {
        return this._propagationContext;
    }
    /**
   * Capture an exception for this scope.
   *
   * @returns {string} The id of the captured Sentry event.
   */ captureException(exception, hint) {
        const eventId = hint?.event_id || (0, $76366c1ad7fe29b9$export$19f53698e68b2496)();
        if (!this._client) {
            (0, $6d193f2c2b007873$export$16a28057038b10ef) && (0, $6ed5aee3203eab87$export$1c9f709888824e05).warn('No client configured on scope - will not capture exception!');
            return eventId;
        }
        const syntheticException = new Error('Sentry syntheticException');
        this._client.captureException(exception, {
            originalException: exception,
            syntheticException: syntheticException,
            ...hint,
            event_id: eventId
        }, this);
        return eventId;
    }
    /**
   * Capture a message for this scope.
   *
   * @returns {string} The id of the captured message.
   */ captureMessage(message, level, hint) {
        const eventId = hint?.event_id || (0, $76366c1ad7fe29b9$export$19f53698e68b2496)();
        if (!this._client) {
            (0, $6d193f2c2b007873$export$16a28057038b10ef) && (0, $6ed5aee3203eab87$export$1c9f709888824e05).warn('No client configured on scope - will not capture message!');
            return eventId;
        }
        const syntheticException = hint?.syntheticException ?? new Error(message);
        this._client.captureMessage(message, level, {
            originalException: message,
            syntheticException: syntheticException,
            ...hint,
            event_id: eventId
        }, this);
        return eventId;
    }
    /**
   * Capture a Sentry event for this scope.
   *
   * @returns {string} The id of the captured event.
   */ captureEvent(event, hint) {
        const eventId = event.event_id || hint?.event_id || (0, $76366c1ad7fe29b9$export$19f53698e68b2496)();
        if (!this._client) {
            (0, $6d193f2c2b007873$export$16a28057038b10ef) && (0, $6ed5aee3203eab87$export$1c9f709888824e05).warn('No client configured on scope - will not capture event!');
            return eventId;
        }
        this._client.captureEvent(event, {
            ...hint,
            event_id: eventId
        }, this);
        return eventId;
    }
    /**
   * This will be called on every set call.
   */ _notifyScopeListeners() {
        // We need this check for this._notifyingListeners to be able to work on scope during updates
        // If this check is not here we'll produce endless recursion when something is done with the scope
        // during the callback.
        if (!this._notifyingListeners) {
            this._notifyingListeners = true;
            this._scopeListeners.forEach((callback)=>{
                callback(this);
            });
            this._notifyingListeners = false;
        }
    }
}


/** Get the default current scope. */ function $4e962648dcc45e95$export$6f1b9191db9c4d5() {
    return (0, $b9fc213467403976$export$7e223ec222791509)('defaultCurrentScope', ()=>new (0, $b569c377336cf232$export$775b6bb06e53a214)());
}
/** Get the default isolation scope. */ function $4e962648dcc45e95$export$de9862929b76bf57() {
    return (0, $b9fc213467403976$export$7e223ec222791509)('defaultIsolationScope', ()=>new (0, $b569c377336cf232$export$775b6bb06e53a214)());
}



const $cb384223cf1427f4$var$isActualPromise = (p)=>p instanceof Promise && !p[$cb384223cf1427f4$var$kChainedCopy];
const $cb384223cf1427f4$var$kChainedCopy = Symbol('chained PromiseLike');
/**
 * Copy the properties from a decorated promiselike object onto its chained
 * actual promise.
 */ const $cb384223cf1427f4$export$64da0f40b0f924ba = (original, onSuccess, onError)=>{
    const chained = original.then((value)=>{
        onSuccess(value);
        return value;
    }, (err)=>{
        onError(err);
        throw err;
    });
    // if we're just dealing with "normal" Promise objects, return the chain
    return $cb384223cf1427f4$var$isActualPromise(chained) && $cb384223cf1427f4$var$isActualPromise(original) ? chained : $cb384223cf1427f4$var$copyProps(original, chained);
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $cb384223cf1427f4$var$copyProps = (original, chained)=>{
    let mutated = false;
    //oxlint-disable-next-line guard-for-in
    for(const key in original){
        if (key in chained) continue;
        mutated = true;
        const value = original[key];
        if (typeof value === 'function') Object.defineProperty(chained, key, {
            value: (...args)=>value.apply(original, args),
            enumerable: true,
            configurable: true,
            writable: true
        });
        else chained[key] = value;
    }
    if (mutated) Object.assign(chained, {
        [$cb384223cf1427f4$var$kChainedCopy]: true
    });
    return chained;
};




/**
 * This is an object that holds a stack of scopes.
 */ class $4748f9a4873ae0be$export$d36ec451f120cfba {
    constructor(scope, isolationScope){
        let assignedScope;
        if (!scope) assignedScope = new (0, $b569c377336cf232$export$775b6bb06e53a214)();
        else assignedScope = scope;
        let assignedIsolationScope;
        if (!isolationScope) assignedIsolationScope = new (0, $b569c377336cf232$export$775b6bb06e53a214)();
        else assignedIsolationScope = isolationScope;
        // scope stack for domains or the process
        this._stack = [
            {
                scope: assignedScope
            }
        ];
        this._isolationScope = assignedIsolationScope;
    }
    /**
   * Fork a scope for the stack.
   */ withScope(callback) {
        const scope = this._pushScope();
        let maybePromiseResult;
        try {
            maybePromiseResult = callback(scope);
        } catch (e) {
            this._popScope();
            throw e;
        }
        if ((0, $d1f309ce92d0a600$export$f5b060c2914b97c8)(maybePromiseResult)) return (0, $cb384223cf1427f4$export$64da0f40b0f924ba)(maybePromiseResult, ()=>this._popScope(), ()=>this._popScope());
        this._popScope();
        return maybePromiseResult;
    }
    /**
   * Get the client of the stack.
   */ getClient() {
        return this.getStackTop().client;
    }
    /**
   * Returns the scope of the top stack.
   */ getScope() {
        return this.getStackTop().scope;
    }
    /**
   * Get the isolation scope for the stack.
   */ getIsolationScope() {
        return this._isolationScope;
    }
    /**
   * Returns the topmost scope layer in the order domain > local > process.
   */ getStackTop() {
        return this._stack[this._stack.length - 1];
    }
    /**
   * Push a scope to the stack.
   */ _pushScope() {
        // We want to clone the content of prev scope
        const scope = this.getScope().clone();
        this._stack.push({
            client: this.getClient(),
            scope: scope
        });
        return scope;
    }
    /**
   * Pop a scope from the stack.
   */ _popScope() {
        if (this._stack.length <= 1) return false;
        return !!this._stack.pop();
    }
}
/**
 * Get the global async context stack.
 * This will be removed during the v8 cycle and is only here to make migration easier.
 */ function $4748f9a4873ae0be$var$getAsyncContextStack() {
    const registry = (0, $b9fc213467403976$export$19eade501500c6c1)();
    const sentry = (0, $b9fc213467403976$export$c8bfa33e4e8ae492)(registry);
    return sentry.stack = sentry.stack || new $4748f9a4873ae0be$export$d36ec451f120cfba((0, $4e962648dcc45e95$export$6f1b9191db9c4d5)(), (0, $4e962648dcc45e95$export$de9862929b76bf57)());
}
function $4748f9a4873ae0be$var$withScope(callback) {
    return $4748f9a4873ae0be$var$getAsyncContextStack().withScope(callback);
}
function $4748f9a4873ae0be$var$withSetScope(scope, callback) {
    const stack = $4748f9a4873ae0be$var$getAsyncContextStack();
    return stack.withScope(()=>{
        stack.getStackTop().scope = scope;
        return callback(scope);
    });
}
function $4748f9a4873ae0be$var$withIsolationScope(callback) {
    return $4748f9a4873ae0be$var$getAsyncContextStack().withScope(()=>{
        return callback($4748f9a4873ae0be$var$getAsyncContextStack().getIsolationScope());
    });
}
/**
 * Get the stack-based async context strategy.
 */ function $4748f9a4873ae0be$export$329d4d4d54e42710() {
    return {
        withIsolationScope: $4748f9a4873ae0be$var$withIsolationScope,
        withScope: $4748f9a4873ae0be$var$withScope,
        withSetScope: $4748f9a4873ae0be$var$withSetScope,
        withSetIsolationScope: (_isolationScope, callback)=>{
            return $4748f9a4873ae0be$var$withIsolationScope(callback);
        },
        getCurrentScope: ()=>$4748f9a4873ae0be$var$getAsyncContextStack().getScope(),
        getIsolationScope: ()=>$4748f9a4873ae0be$var$getAsyncContextStack().getIsolationScope()
    };
}


/**
 * @private Private API with no semver guarantees!
 *
 * Sets the global async context strategy
 */ function $22ac79c556bb203d$export$774ae0e6b6e444ca(strategy) {
    // Get main carrier (global for every environment)
    const registry = (0, $b9fc213467403976$export$19eade501500c6c1)();
    const sentry = (0, $b9fc213467403976$export$c8bfa33e4e8ae492)(registry);
    sentry.acs = strategy;
}
/**
 * Get the current async context strategy.
 * If none has been setup, the default will be used.
 */ function $22ac79c556bb203d$export$f639b0c2752203be(carrier) {
    const sentry = (0, $b9fc213467403976$export$c8bfa33e4e8ae492)(carrier);
    if (sentry.acs) return sentry.acs;
    // Otherwise, use the default one (stack)
    return (0, $4748f9a4873ae0be$export$329d4d4d54e42710)();
}





let $6c9d57d6c1e4fcbb$var$_externalPropagationContextProvider;
/**
 * Register an external propagation context provider function.
 * When registered, trace context will be read from the external source (e.g. OpenTelemetry)
 * instead of from the Sentry scope's propagation context.
 */ function $6c9d57d6c1e4fcbb$export$b5defb3466e9689b(fn) {
    $6c9d57d6c1e4fcbb$var$_externalPropagationContextProvider = fn;
}
/**
 * Get the external propagation context, if a provider has been registered.
 */ function $6c9d57d6c1e4fcbb$export$92547f779c920a71() {
    return $6c9d57d6c1e4fcbb$var$_externalPropagationContextProvider?.();
}
/**
 * Check if an external propagation context provider has been registered.
 */ function $6c9d57d6c1e4fcbb$export$53f0ae651a1c4298() {
    return $6c9d57d6c1e4fcbb$var$_externalPropagationContextProvider !== undefined;
}
/**
 * Get the currently active scope.
 */ function $6c9d57d6c1e4fcbb$export$c7be4b0125a10cba() {
    const carrier = (0, $b9fc213467403976$export$19eade501500c6c1)();
    const acs = (0, $22ac79c556bb203d$export$f639b0c2752203be)(carrier);
    return acs.getCurrentScope();
}
/**
 * Get the currently active isolation scope.
 * The isolation scope is active for the current execution context.
 */ function $6c9d57d6c1e4fcbb$export$68f3af03034c9e90() {
    const carrier = (0, $b9fc213467403976$export$19eade501500c6c1)();
    const acs = (0, $22ac79c556bb203d$export$f639b0c2752203be)(carrier);
    return acs.getIsolationScope();
}
/**
 * Get the global scope.
 * This scope is applied to _all_ events.
 */ function $6c9d57d6c1e4fcbb$export$aa55d5ab8e05984f() {
    return (0, $b9fc213467403976$export$7e223ec222791509)('globalScope', ()=>new (0, $b569c377336cf232$export$775b6bb06e53a214)());
}
/**
 * Creates a new scope with and executes the given operation within.
 * The scope is automatically removed once the operation
 * finishes or throws.
 */ /**
 * Either creates a new active scope, or sets the given scope as active scope in the given callback.
 */ function $6c9d57d6c1e4fcbb$export$ec58d9285c204497(...rest) {
    const carrier = (0, $b9fc213467403976$export$19eade501500c6c1)();
    const acs = (0, $22ac79c556bb203d$export$f639b0c2752203be)(carrier);
    // If a scope is defined, we want to make this the active scope instead of the default one
    if (rest.length === 2) {
        const [scope, callback] = rest;
        if (!scope) return acs.withScope(callback);
        return acs.withSetScope(scope, callback);
    }
    return acs.withScope(rest[0]);
}
/**
 * Attempts to fork the current isolation scope and the current scope based on the current async context strategy. If no
 * async context strategy is set, the isolation scope and the current scope will not be forked (this is currently the
 * case, for example, in the browser).
 *
 * Usage of this function in environments without async context strategy is discouraged and may lead to unexpected behaviour.
 *
 * This function is intended for Sentry SDK and SDK integration development. It is not recommended to be used in "normal"
 * applications directly because it comes with pitfalls. Use at your own risk!
 */ /**
 * Either creates a new active isolation scope, or sets the given isolation scope as active scope in the given callback.
 */ function $6c9d57d6c1e4fcbb$export$9a4fed82c350c2bd(...rest) {
    const carrier = (0, $b9fc213467403976$export$19eade501500c6c1)();
    const acs = (0, $22ac79c556bb203d$export$f639b0c2752203be)(carrier);
    // If a scope is defined, we want to make this the active scope instead of the default one
    if (rest.length === 2) {
        const [isolationScope, callback] = rest;
        if (!isolationScope) return acs.withIsolationScope(callback);
        return acs.withSetIsolationScope(isolationScope, callback);
    }
    return acs.withIsolationScope(rest[0]);
}
/**
 * Get the currently active client.
 */ function $6c9d57d6c1e4fcbb$export$6bb76d6eba7e258c() {
    return $6c9d57d6c1e4fcbb$export$c7be4b0125a10cba().getClient();
}
/**
 * Get a trace context for the given scope.
 */ function $6c9d57d6c1e4fcbb$export$1e83db7ee4876dc4(scope) {
    const externalContext = $6c9d57d6c1e4fcbb$export$92547f779c920a71();
    if (externalContext) return {
        trace_id: externalContext.traceId,
        span_id: externalContext.spanId
    };
    const propagationContext = scope.getPropagationContext();
    const { traceId: traceId, parentSpanId: parentSpanId, propagationSpanId: propagationSpanId } = propagationContext;
    const traceContext = {
        trace_id: traceId,
        span_id: propagationSpanId || (0, $1eac0e3178cad4a9$export$295213bc4d0c54ad)()
    };
    if (parentSpanId) traceContext.parent_span_id = parentSpanId;
    return traceContext;
}





const $305b4dfee0d746dc$export$b14a8888f80a0b3e = [];
/** Map of integrations assigned to a client */ /**
 * Remove duplicates from the given array, preferring the last instance of any duplicate. Not guaranteed to
 * preserve the order of integrations in the array.
 *
 * @private
 */ function $305b4dfee0d746dc$var$filterDuplicates(integrations) {
    const integrationsByName = {};
    integrations.forEach((currentInstance)=>{
        const { name: name } = currentInstance;
        const existingInstance = integrationsByName[name];
        // We want integrations later in the array to overwrite earlier ones of the same type, except that we never want a
        // default instance to overwrite an existing user instance
        if (existingInstance && !existingInstance.isDefaultInstance && currentInstance.isDefaultInstance) return;
        integrationsByName[name] = currentInstance;
    });
    return Object.values(integrationsByName);
}
/** Gets integrations to install */ function $305b4dfee0d746dc$export$68bc4c01ab8ae766(options) {
    const defaultIntegrations = options.defaultIntegrations || [];
    const userIntegrations = options.integrations;
    // We flag default instances, so that later we can tell them apart from any user-created instances of the same class
    defaultIntegrations.forEach((integration)=>{
        integration.isDefaultInstance = true;
    });
    let integrations;
    if (Array.isArray(userIntegrations)) integrations = [
        ...defaultIntegrations,
        ...userIntegrations
    ];
    else if (typeof userIntegrations === 'function') {
        const resolvedUserIntegrations = userIntegrations(defaultIntegrations);
        integrations = Array.isArray(resolvedUserIntegrations) ? resolvedUserIntegrations : [
            resolvedUserIntegrations
        ];
    } else integrations = defaultIntegrations;
    return $305b4dfee0d746dc$var$filterDuplicates(integrations);
}
/**
 * Given a list of integration instances this installs them all. When `withDefaults` is set to `true` then all default
 * integrations are added unless they were already provided before.
 * @param integrations array of integration instances
 * @param withDefault should enable default integrations
 */ function $305b4dfee0d746dc$export$51abed9797baa598(client, integrations) {
    const integrationIndex = {};
    integrations.forEach((integration)=>{
        if (integration?.beforeSetup) integration.beforeSetup(client);
    });
    integrations.forEach((integration)=>{
        // guard against empty provided integrations
        if (integration) $305b4dfee0d746dc$export$e7390a03b70a6f2f(client, integration, integrationIndex);
    });
    return integrationIndex;
}
/**
 * Execute the `afterAllSetup` hooks of the given integrations.
 */ function $305b4dfee0d746dc$export$35abcfd71227c6ca(client, integrations) {
    for (const integration of integrations)// guard against empty provided integrations
    if (integration?.afterAllSetup) integration.afterAllSetup(client);
}
/** Setup a single integration.  */ function $305b4dfee0d746dc$export$e7390a03b70a6f2f(client, integration, integrationIndex) {
    if (integrationIndex[integration.name]) {
        (0, $6d193f2c2b007873$export$16a28057038b10ef) && (0, $6ed5aee3203eab87$export$1c9f709888824e05).log(`Integration skipped because it was already installed: ${integration.name}`);
        return;
    }
    integrationIndex[integration.name] = integration;
    // `setupOnce` is only called the first time
    if (!$305b4dfee0d746dc$export$b14a8888f80a0b3e.includes(integration.name) && typeof integration.setupOnce === 'function') {
        integration.setupOnce();
        $305b4dfee0d746dc$export$b14a8888f80a0b3e.push(integration.name);
    }
    // `setup` is run for each client
    if (integration.setup && typeof integration.setup === 'function') integration.setup(client);
    if (typeof integration.preprocessEvent === 'function') {
        const callback = integration.preprocessEvent.bind(integration);
        client.on('preprocessEvent', (event, hint)=>callback(event, hint, client));
    }
    if (typeof integration.processEvent === 'function') {
        const callback = integration.processEvent.bind(integration);
        const processor = Object.assign((event, hint)=>callback(event, hint, client), {
            id: integration.name
        });
        client.addEventProcessor(processor);
    }
    [
        'processSpan',
        'processSegmentSpan'
    ].forEach((hook)=>{
        const callback = integration[hook];
        if (typeof callback === 'function') // The cast is needed because TS can't resolve overloads when the discriminant is a union type.
        // Both overloads have the same callback signature so this is safe.
        client.on(hook, (span)=>callback.call(integration, span, client));
    });
    (0, $6d193f2c2b007873$export$16a28057038b10ef) && (0, $6ed5aee3203eab87$export$1c9f709888824e05).log(`Integration installed: ${integration.name}`);
}
/** Add an integration to the current scope's client. */ function $305b4dfee0d746dc$export$2d8f5188773bcddd(integration) {
    const client = (0, $6c9d57d6c1e4fcbb$export$6bb76d6eba7e258c)();
    if (!client) {
        (0, $6d193f2c2b007873$export$16a28057038b10ef) && (0, $6ed5aee3203eab87$export$1c9f709888824e05).warn(`Cannot add integration "${integration.name}" because no SDK Client is available.`);
        return;
    }
    client.addIntegration(integration);
}
/**
 * Define an integration function that can be used to create an integration instance.
 * Note that this by design hides the implementation details of the integration, as they are considered internal.
 */ function $305b4dfee0d746dc$export$2323046b9414659f(fn) {
    return fn;
}


/**
 * Use this attribute to represent the source of a span name.
 * Must be one of: custom, url, route, view, component, task
 * TODO(v11): rename this to sentry.span.source'
 */ const $0633c8eb02923c67$export$d7a7d984b0791405 = 'sentry.source';
/**
 * Attributes that holds the sample rate that was locally applied to a span.
 * If this attribute is not defined, it means that the span inherited a sampling decision.
 *
 * NOTE: Is only defined on root spans.
 */ const $0633c8eb02923c67$export$ccfe0a40627cc34b = 'sentry.sample_rate';
/**
 * Attribute holding the sample rate of the previous trace.
 * This is used to sample consistently across subsequent traces in the browser SDK.
 *
 * Note: Only defined on root spans, if opted into consistent sampling
 */ const $0633c8eb02923c67$export$889fb736668e1ecc = 'sentry.previous_trace_sample_rate';
/**
 * Use this attribute to represent the operation of a span.
 */ const $0633c8eb02923c67$export$1a413bd9a88fdb09 = 'sentry.op';
/**
 * Use this attribute to represent the origin of a span.
 */ const $0633c8eb02923c67$export$cca8dd30f57f805e = 'sentry.origin';
/** The reason why an idle span finished. */ const $0633c8eb02923c67$export$ba73f34502b7a3b3 = 'sentry.idle_span_finish_reason';
/** The unit of a measurement, which may be stored as a TimedEvent. */ const $0633c8eb02923c67$export$f5f95cff026507b5 = 'sentry.measurement_unit';
/** The value of a measurement, which may be stored as a TimedEvent. */ const $0633c8eb02923c67$export$69cd5c610c7bb96a = 'sentry.measurement_value';
/** The release version of the application */ const $0633c8eb02923c67$export$f5cefb258679b29e = 'sentry.release';
/** The environment name (e.g., "production", "staging", "development") */ const $0633c8eb02923c67$export$d1b1dbb47f5ba57c = 'sentry.environment';
/** The segment name (e.g., "GET /users") */ const $0633c8eb02923c67$export$4626f2be16112c1c = 'sentry.segment.name';
/** The id of the segment that this span belongs to. */ const $0633c8eb02923c67$export$25fa4a1832d3736a = 'sentry.segment.id';
/** The name of the Sentry SDK (e.g., "sentry.php", "sentry.javascript") */ const $0633c8eb02923c67$export$87a4807042e1f1bb = 'sentry.sdk.name';
/** The version of the Sentry SDK */ const $0633c8eb02923c67$export$301ebe936458e291 = 'sentry.sdk.version';
/** The user ID (gated by sendDefaultPii) */ const $0633c8eb02923c67$export$1f9cc1d34ea098a0 = 'user.id';
/** The user email (gated by sendDefaultPii) */ const $0633c8eb02923c67$export$b7466609ef46c07e = 'user.email';
/** The user IP address (gated by sendDefaultPii) */ const $0633c8eb02923c67$export$8d592bdaea63b930 = 'user.ip_address';
/** The user username (gated by sendDefaultPii) */ const $0633c8eb02923c67$export$c05ee933d3f74b2b = 'user.name';
/**
 * A custom span name set by users guaranteed to be taken over any automatically
 * inferred name. This attribute is removed before the span is sent.
 *
 * @internal only meant for internal SDK usage
 * @hidden
 */ const $0633c8eb02923c67$export$165ce9a229f6f050 = 'sentry.custom_span_name';
/**
 * The id of the profile that this span occurred in.
 */ const $0633c8eb02923c67$export$1efec95406bbe327 = 'sentry.profile_id';
const $0633c8eb02923c67$export$fea48ba9f4550879 = 'sentry.exclusive_time';
const $0633c8eb02923c67$export$b016f89ac1066ec = 'cache.hit';
const $0633c8eb02923c67$export$3110e4c3f4386399 = 'cache.key';
const $0633c8eb02923c67$export$86be76deee227ff2 = 'cache.item_size';
/** TODO: Remove these once we update to latest semantic conventions */ const $0633c8eb02923c67$export$be7a251980e7e946 = 'http.request.method';
const $0633c8eb02923c67$export$25dfd73e0e32c6e1 = 'url.full';
/**
 * A span link attribute to mark the link as a special span link.
 *
 * Known values:
 * - `previous_trace`: The span links to the frontend root span of the previous trace.
 * - `next_trace`: The span links to the frontend root span of the next trace. (Not set by the SDK)
 *
 * Other values may be set as appropriate.
 * @see https://develop.sentry.dev/sdk/telemetry/traces/span-links/#link-types
 */ const $0633c8eb02923c67$export$ff77b5fd5b2d627b = 'sentry.link.type';
/**
 * =============================================================================
 * GEN AI ATTRIBUTES
 * Based on OpenTelemetry Semantic Conventions for Generative AI
 * @see https://opentelemetry.io/docs/specs/semconv/gen-ai/
 * =============================================================================
 */ /**
 * The conversation ID for linking messages across API calls.
 * For OpenAI Assistants API: thread_id
 * For LangGraph: configurable.thread_id
 */ const $0633c8eb02923c67$export$71a4a707257f2774 = 'gen_ai.conversation.id';




/**
 * Type-guard: The attribute object has the shape the official attribute object (value, type, unit).
 * https://develop.sentry.dev/sdk/telemetry/scopes/#setting-attributes
 */ function $78177fa8d256e3ec$export$f5706f332d297c38(maybeObj) {
    return typeof maybeObj === 'object' && maybeObj != null && !Array.isArray(maybeObj) && Object.keys(maybeObj).includes('value');
}
/**
 * Converts an attribute value to a typed attribute value.
 *
 * For now, we intentionally only support primitive values and attribute objects with primitive values.
 * If @param useFallback is true, we stringify non-primitive values to a string attribute value. Otherwise
 * we return `undefined` for unsupported values.
 *
 * @param value - The value of the passed attribute.
 * @param useFallback - If true, unsupported values will be stringified to a string attribute value.
 *                      Defaults to false. In this case, `undefined` is returned for unsupported values.
 * @returns The typed attribute.
 */ function $78177fa8d256e3ec$export$f18f8779fed6dfa(rawValue, useFallback) {
    const { value: value, unit: unit } = $78177fa8d256e3ec$export$f5706f332d297c38(rawValue) ? rawValue : {
        value: rawValue,
        unit: undefined
    };
    const attributeValue = $78177fa8d256e3ec$var$getTypedAttributeValue(value);
    const checkedUnit = unit && typeof unit === 'string' ? {
        unit: unit
    } : {};
    if (attributeValue) return {
        ...attributeValue,
        ...checkedUnit
    };
    if (!useFallback || useFallback === 'skip-undefined' && value === undefined) return;
    // Fallback: stringify the value
    // TODO(v11): be smarter here and use String constructor if stringify fails
    // (this is a breaking change for already existing attribute values)
    let stringValue = '';
    try {
        stringValue = JSON.stringify(value) ?? '';
    } catch  {
    // Do nothing
    }
    return {
        value: stringValue,
        type: 'string',
        ...checkedUnit
    };
}
/**
 * Serializes raw attributes to typed attributes as expected in our envelopes.
 *
 * @param attributes The raw attributes to serialize.
 * @param fallback   If true, unsupported values will be stringified to a string attribute value.
 *                   Defaults to false. In this case, `undefined` is returned for unsupported values.
 *
 * @returns The serialized attributes.
 */ function $78177fa8d256e3ec$export$4954cae66e755861(attributes, fallback = false) {
    const serializedAttributes = {};
    for (const [key, value] of Object.entries(attributes ?? {})){
        const typedValue = $78177fa8d256e3ec$export$f18f8779fed6dfa(value, fallback);
        if (typedValue) serializedAttributes[key] = typedValue;
    }
    return serializedAttributes;
}
/**
 * Estimates the serialized byte size of {@link Attributes},
 * with a couple of heuristics for performance.
 */ function $78177fa8d256e3ec$export$97341f7cd97c59f(attributes) {
    if (!attributes) return 0;
    let weight = 0;
    for (const [key, attr] of Object.entries(attributes)){
        weight += key.length * 2;
        weight += attr.type.length * 2;
        weight += (attr.unit?.length ?? 0) * 2;
        const val = attr.value;
        if (Array.isArray(val)) // Assumption: Individual array items have the same type and roughly the same size
        // probably not always true but allows us to cut down on runtime
        weight += $78177fa8d256e3ec$var$estimatePrimitiveSizeInBytes(val[0]) * val.length;
        else if ((0, $d1f309ce92d0a600$export$c3825b437cbdea5c)(val)) weight += $78177fa8d256e3ec$var$estimatePrimitiveSizeInBytes(val);
        else // default fallback for anything else (objects)
        weight += 100;
    }
    return weight;
}
function $78177fa8d256e3ec$var$estimatePrimitiveSizeInBytes(value) {
    if (typeof value === 'string') return value.length * 2;
    else if (typeof value === 'boolean') return 4;
    else if (typeof value === 'number') return 8;
    return 0;
}
/**
 * NOTE: We intentionally do not return anything for non-primitive values:
 *  - array support will come in the future but if we stringify arrays now,
 *    sending arrays (unstringified) later will be a subtle breaking change.
 *  - Objects are not supported yet and product support is still TBD.
 *  - We still keep the type signature for TypedAttributeValue wider to avoid a
 *    breaking change once we add support for non-primitive values.
 *  - Once we go back to supporting arrays and stringifying all other values,
 *    we already implemented the serialization logic here:
 *    https://github.com/getsentry/sentry-javascript/pull/18165
 */ function $78177fa8d256e3ec$var$getTypedAttributeValue(value) {
    const primitiveType = typeof value === 'string' ? 'string' : typeof value === 'boolean' ? 'boolean' : typeof value === 'number' && !Number.isNaN(value) ? Number.isInteger(value) ? 'integer' : 'double' : null;
    if (primitiveType) // @ts-expect-error - TS complains because {@link TypedAttributeValue} is strictly typed to
    // avoid setting the wrong `type` on the attribute value.
    // In this case, getPrimitiveType already does the check but TS doesn't know that.
    // The "clean" alternative is to return an object per `typeof value` case
    // but that would require more bundle size
    // Therefore, we ignore it.
    return {
        value: value,
        type: primitiveType
    };
}





const $7a6201d846b686cd$export$136e25984ba4a383 = 0;
const $7a6201d846b686cd$export$58f7963109c806fc = 1;
const $7a6201d846b686cd$export$f966a0446ece71e = 2;
/**
 * Converts a HTTP status code into a sentry status with a message.
 *
 * @param httpStatus The HTTP response status code.
 * @returns The span status or internal_error.
 */ // https://develop.sentry.dev/sdk/event-payloads/span/
function $7a6201d846b686cd$export$5fd4dc48a2131589(httpStatus) {
    if (httpStatus < 400 && httpStatus >= 100) return {
        code: $7a6201d846b686cd$export$58f7963109c806fc
    };
    if (httpStatus >= 400 && httpStatus < 500) switch(httpStatus){
        case 401:
            return {
                code: $7a6201d846b686cd$export$f966a0446ece71e,
                message: 'unauthenticated'
            };
        case 403:
            return {
                code: $7a6201d846b686cd$export$f966a0446ece71e,
                message: 'permission_denied'
            };
        case 404:
            return {
                code: $7a6201d846b686cd$export$f966a0446ece71e,
                message: 'not_found'
            };
        case 409:
            return {
                code: $7a6201d846b686cd$export$f966a0446ece71e,
                message: 'already_exists'
            };
        case 413:
            return {
                code: $7a6201d846b686cd$export$f966a0446ece71e,
                message: 'failed_precondition'
            };
        case 429:
            return {
                code: $7a6201d846b686cd$export$f966a0446ece71e,
                message: 'resource_exhausted'
            };
        case 499:
            return {
                code: $7a6201d846b686cd$export$f966a0446ece71e,
                message: 'cancelled'
            };
        default:
            return {
                code: $7a6201d846b686cd$export$f966a0446ece71e,
                message: 'invalid_argument'
            };
    }
    if (httpStatus >= 500 && httpStatus < 600) switch(httpStatus){
        case 501:
            return {
                code: $7a6201d846b686cd$export$f966a0446ece71e,
                message: 'unimplemented'
            };
        case 503:
            return {
                code: $7a6201d846b686cd$export$f966a0446ece71e,
                message: 'unavailable'
            };
        case 504:
            return {
                code: $7a6201d846b686cd$export$f966a0446ece71e,
                message: 'deadline_exceeded'
            };
        default:
            return {
                code: $7a6201d846b686cd$export$f966a0446ece71e,
                message: 'internal_error'
            };
    }
    return {
        code: $7a6201d846b686cd$export$f966a0446ece71e,
        message: 'internal_error'
    };
}
/**
 * Sets the Http status attributes on the current span based on the http code.
 * Additionally, the span's status is updated, depending on the http code.
 */ function $7a6201d846b686cd$export$2ad6630ec8164254(span, httpStatus) {
    span.setAttribute('http.response.status_code', httpStatus);
    const spanStatus = $7a6201d846b686cd$export$5fd4dc48a2131589(httpStatus);
    if (spanStatus.message !== 'unknown_error') span.setStatus(spanStatus);
}




/**
 * Interface representing a weak reference to an object.
 * This matches the standard WeakRef interface but is defined here
 * because WeakRef is not available in ES2020 type definitions.
 */ /**
 * Creates a weak reference to an object if WeakRef is available,
 * otherwise returns the object directly.
 *
 * This is useful for breaking circular references while maintaining
 * compatibility with environments that don't support WeakRef (e.g., older browsers).
 *
 * @param value - The object to create a weak reference to
 * @returns A WeakRef wrapper if available, or the original object as fallback
 */ function $c2e57656eaf2a594$export$f0b98edec95fcb33(value) {
    try {
        // @ts-expect-error - WeakRef may not be in the type definitions for older TS targets
        const WeakRefImpl = (0, $517c5b29f882562f$export$f1a6cdb1459e81d1).WeakRef;
        if (typeof WeakRefImpl === 'function') return new WeakRefImpl(value);
    } catch  {
    // WeakRef not available or construction failed
    }
    return value;
}
/**
 * Resolves a potentially weak reference, returning the underlying object
 * or undefined if the reference has been garbage collected.
 *
 * @param ref - A MaybeWeakRef or undefined
 * @returns The referenced object, or undefined if GC'd or ref was undefined
 */ function $c2e57656eaf2a594$export$a0592ad8c3586cf(ref) {
    if (!ref) return undefined;
    // Check if this is a WeakRef (has deref method)
    if (typeof ref === 'object' && 'deref' in ref && typeof ref.deref === 'function') try {
        return ref.deref();
    } catch  {
        // deref() failed - treat as GC'd
        return undefined;
    }
    // Direct reference fallback
    return ref;
}


const $360fa73c77afb99d$var$SCOPE_ON_START_SPAN_FIELD = '_sentryScope';
const $360fa73c77afb99d$var$ISOLATION_SCOPE_ON_START_SPAN_FIELD = '_sentryIsolationScope';
/** Store the scope & isolation scope for a span, which can the be used when it is finished. */ function $360fa73c77afb99d$export$cddb4027e3b0dd66(span, scope, isolationScope) {
    if (span) {
        (0, $10696cb2974e7335$export$e73679ffaf56810e)(span, $360fa73c77afb99d$var$ISOLATION_SCOPE_ON_START_SPAN_FIELD, (0, $c2e57656eaf2a594$export$f0b98edec95fcb33)(isolationScope));
        // We don't wrap the scope with a WeakRef here because webkit aggressively garbage collects
        // and scopes are not held in memory for long periods of time.
        (0, $10696cb2974e7335$export$e73679ffaf56810e)(span, $360fa73c77afb99d$var$SCOPE_ON_START_SPAN_FIELD, scope);
    }
}
/**
 * Grabs the scope and isolation scope off a span that were active when the span was started.
 * If WeakRef was used and scopes have been garbage collected, returns undefined for those scopes.
 */ function $360fa73c77afb99d$export$c08fbc656a245d03(span) {
    const spanWithScopes = span;
    return {
        scope: spanWithScopes[$360fa73c77afb99d$var$SCOPE_ON_START_SPAN_FIELD],
        isolationScope: (0, $c2e57656eaf2a594$export$a0592ad8c3586cf)(spanWithScopes[$360fa73c77afb99d$var$ISOLATION_SCOPE_ON_START_SPAN_FIELD])
    };
}









const $dfa5ff63e2991cbd$export$6e69537d67fa20f = 'sentry-';
const $dfa5ff63e2991cbd$export$eb0401070c617ea5 = /^sentry-/;
/**
 * Max length of a serialized baggage string
 *
 * https://www.w3.org/TR/baggage/#limits
 */ const $dfa5ff63e2991cbd$export$bdd844ddb2def819 = 8192;
/**
 * Takes a baggage header and turns it into Dynamic Sampling Context, by extracting all the "sentry-" prefixed values
 * from it.
 *
 * @param baggageHeader A very bread definition of a baggage header as it might appear in various frameworks.
 * @returns The Dynamic Sampling Context that was found on `baggageHeader`, if there was any, `undefined` otherwise.
 */ function $dfa5ff63e2991cbd$export$5b96ee2c8421f107(// Very liberal definition of what any incoming header might look like
baggageHeader) {
    const baggageObject = $dfa5ff63e2991cbd$export$397de414d189db00(baggageHeader);
    if (!baggageObject) return undefined;
    // Read all "sentry-" prefixed values out of the baggage object and put it onto a dynamic sampling context object.
    const dynamicSamplingContext = Object.entries(baggageObject).reduce((acc, [key, value])=>{
        if (key.startsWith($dfa5ff63e2991cbd$export$6e69537d67fa20f)) {
            const nonPrefixedKey = key.slice($dfa5ff63e2991cbd$export$6e69537d67fa20f.length);
            acc[nonPrefixedKey] = value;
        }
        return acc;
    }, {});
    // Only return a dynamic sampling context object if there are keys in it.
    // A keyless object means there were no sentry values on the header, which means that there is no DSC.
    if (Object.keys(dynamicSamplingContext).length > 0) return dynamicSamplingContext;
    else return undefined;
}
/**
 * Turns a Dynamic Sampling Object into a baggage header by prefixing all the keys on the object with "sentry-".
 *
 * @param dynamicSamplingContext The Dynamic Sampling Context to turn into a header. For convenience and compatibility
 * with the `getDynamicSamplingContext` method on the Transaction class ,this argument can also be `undefined`. If it is
 * `undefined` the function will return `undefined`.
 * @returns a baggage header, created from `dynamicSamplingContext`, or `undefined` either if `dynamicSamplingContext`
 * was `undefined`, or if `dynamicSamplingContext` didn't contain any values.
 */ function $dfa5ff63e2991cbd$export$56766feef403f365(// this also takes undefined for convenience and bundle size in other places
dynamicSamplingContext) {
    if (!dynamicSamplingContext) return undefined;
    // Prefix all DSC keys with "sentry-" and put them into a new object
    const sentryPrefixedDSC = Object.entries(dynamicSamplingContext).reduce((acc, [dscKey, dscValue])=>{
        if (dscValue) acc[`${$dfa5ff63e2991cbd$export$6e69537d67fa20f}${dscKey}`] = dscValue;
        return acc;
    }, {});
    return $dfa5ff63e2991cbd$export$12a7349a29a6e3c2(sentryPrefixedDSC);
}
/**
 * Take a baggage header and parse it into an object.
 */ function $dfa5ff63e2991cbd$export$397de414d189db00(baggageHeader) {
    if (!baggageHeader || !(0, $d1f309ce92d0a600$export$844ec244b1367d54)(baggageHeader) && !Array.isArray(baggageHeader)) return undefined;
    if (Array.isArray(baggageHeader)) // Combine all baggage headers into one object containing the baggage values so we can later read the Sentry-DSC-values from it
    return baggageHeader.reduce((acc, curr)=>{
        const currBaggageObject = $dfa5ff63e2991cbd$var$baggageHeaderToObject(curr);
        Object.entries(currBaggageObject).forEach(([key, value])=>{
            acc[key] = value;
        });
        return acc;
    }, {});
    return $dfa5ff63e2991cbd$var$baggageHeaderToObject(baggageHeader);
}
/**
 * Will parse a baggage header, which is a simple key-value map, into a flat object.
 *
 * @param baggageHeader The baggage header to parse.
 * @returns a flat object containing all the key-value pairs from `baggageHeader`.
 */ function $dfa5ff63e2991cbd$var$baggageHeaderToObject(baggageHeader) {
    return baggageHeader.split(',').map((baggageEntry)=>{
        const eqIdx = baggageEntry.indexOf('=');
        if (eqIdx === -1) // Likely an invalid entry
        return [];
        const key = baggageEntry.slice(0, eqIdx);
        const value = baggageEntry.slice(eqIdx + 1);
        return [
            key,
            value
        ].map((keyOrValue)=>{
            try {
                return decodeURIComponent(keyOrValue.trim());
            } catch  {
                // We ignore errors here, e.g. if the value cannot be URL decoded.
                // This will then be skipped in the next step
                return;
            }
        });
    }).reduce((acc, [key, value])=>{
        if (key && value) acc[key] = value;
        return acc;
    }, {});
}
/**
 * Turns a flat object (key-value pairs) into a baggage header, which is also just key-value pairs.
 *
 * @param object The object to turn into a baggage header.
 * @returns a baggage header string, or `undefined` if the object didn't have any values, since an empty baggage header
 * is not spec compliant.
 */ function $dfa5ff63e2991cbd$export$12a7349a29a6e3c2(object) {
    if (Object.keys(object).length === 0) // An empty baggage header is not spec compliant: We return undefined.
    return undefined;
    return Object.entries(object).reduce((baggageHeader, [objectKey, objectValue], currentIndex)=>{
        const baggageEntry = `${encodeURIComponent(objectKey)}=${encodeURIComponent(objectValue)}`;
        const newBaggageHeader = currentIndex === 0 ? baggageEntry : `${baggageHeader},${baggageEntry}`;
        if (newBaggageHeader.length > $dfa5ff63e2991cbd$export$bdd844ddb2def819) {
            (0, $6d193f2c2b007873$export$16a28057038b10ef) && (0, $6ed5aee3203eab87$export$1c9f709888824e05).warn(`Not adding key: ${objectKey} with val: ${objectValue} to baggage header due to exceeding baggage size limits.`);
            return baggageHeader;
        } else return newBaggageHeader;
    }, '');
}




/** Regular expression used to extract org ID from a DSN host. */ const $a6fcb45f188ebaa3$var$ORG_ID_REGEX = /^o(\d+)\./;
/** Regular expression used to parse a Dsn. */ const $a6fcb45f188ebaa3$var$DSN_REGEX = /^(?:(\w+):)\/\/(?:(\w+)(?::(\w+)?)?@)((?:\[[:.%\w]+\]|[\w.-]+))(?::(\d+))?\/(.+)/;
function $a6fcb45f188ebaa3$var$isValidProtocol(protocol) {
    return protocol === 'http' || protocol === 'https';
}
/**
 * Renders the string representation of this Dsn.
 *
 * By default, this will render the public representation without the password
 * component. To get the deprecated private representation, set `withPassword`
 * to true.
 *
 * @param withPassword When set to true, the password will be included.
 */ function $a6fcb45f188ebaa3$export$44d472fbb931a776(dsn, withPassword = false) {
    const { host: host, path: path, pass: pass, port: port, projectId: projectId, protocol: protocol, publicKey: publicKey } = dsn;
    return `${protocol}://${publicKey}${withPassword && pass ? `:${pass}` : ''}` + `@${host}${port ? `:${port}` : ''}/${path ? `${path}/` : path}${projectId}`;
}
/**
 * Parses a Dsn from a given string.
 *
 * @param str A Dsn as string
 * @returns Dsn as DsnComponents or undefined if @param str is not a valid DSN string
 */ function $a6fcb45f188ebaa3$export$b892860177f70a30(str) {
    const match = $a6fcb45f188ebaa3$var$DSN_REGEX.exec(str);
    if (!match) {
        // This should be logged to the console
        (0, $6ed5aee3203eab87$export$cda52e2a8927a2ca)(()=>{
            // eslint-disable-next-line no-console
            console.error(`Invalid Sentry Dsn: ${str}`);
        });
        return undefined;
    }
    const [protocol, publicKey, pass = '', host = '', port = '', lastPath = ''] = match.slice(1);
    let path = '';
    let projectId = lastPath;
    const split = projectId.split('/');
    if (split.length > 1) {
        path = split.slice(0, -1).join('/');
        projectId = split.pop();
    }
    if (projectId) {
        const projectMatch = projectId.match(/^\d+/);
        if (projectMatch) projectId = projectMatch[0];
    }
    return $a6fcb45f188ebaa3$var$dsnFromComponents({
        host: host,
        pass: pass,
        path: path,
        projectId: projectId,
        port: port,
        protocol: protocol,
        publicKey: publicKey
    });
}
function $a6fcb45f188ebaa3$var$dsnFromComponents(components) {
    return {
        protocol: components.protocol,
        publicKey: components.publicKey || '',
        pass: components.pass || '',
        host: components.host,
        port: components.port || '',
        path: components.path || '',
        projectId: components.projectId
    };
}
function $a6fcb45f188ebaa3$var$validateDsn(dsn) {
    if (!(0, $6d193f2c2b007873$export$16a28057038b10ef)) return true;
    const { port: port, projectId: projectId, protocol: protocol } = dsn;
    const requiredComponents = [
        'protocol',
        'publicKey',
        'host',
        'projectId'
    ];
    const hasMissingRequiredComponent = requiredComponents.find((component)=>{
        if (!dsn[component]) {
            (0, $6ed5aee3203eab87$export$1c9f709888824e05).error(`Invalid Sentry Dsn: ${component} missing`);
            return true;
        }
        return false;
    });
    if (hasMissingRequiredComponent) return false;
    if (!projectId.match(/^\d+$/)) {
        (0, $6ed5aee3203eab87$export$1c9f709888824e05).error(`Invalid Sentry Dsn: Invalid projectId ${projectId}`);
        return false;
    }
    if (!$a6fcb45f188ebaa3$var$isValidProtocol(protocol)) {
        (0, $6ed5aee3203eab87$export$1c9f709888824e05).error(`Invalid Sentry Dsn: Invalid protocol ${protocol}`);
        return false;
    }
    if (port && isNaN(parseInt(port, 10))) {
        (0, $6ed5aee3203eab87$export$1c9f709888824e05).error(`Invalid Sentry Dsn: Invalid port ${port}`);
        return false;
    }
    return true;
}
/**
 * Extract the org ID from a DSN host.
 *
 * @param host The host from a DSN
 * @returns The org ID if found, undefined otherwise
 */ function $a6fcb45f188ebaa3$export$5914f4e7748c29c9(host) {
    const match = host.match($a6fcb45f188ebaa3$var$ORG_ID_REGEX);
    return match?.[1];
}
/**
 *  Returns the organization ID of the client.
 *
 *  The organization ID is extracted from the DSN. If the client options include a `orgId`, this will always take precedence.
 */ function $a6fcb45f188ebaa3$export$b7ac9b8efa4bb595(client) {
    const options = client.getOptions();
    const { host: host } = client.getDsn() || {};
    let org_id;
    if (options.orgId) org_id = String(options.orgId);
    else if (host) org_id = $a6fcb45f188ebaa3$export$5914f4e7748c29c9(host);
    return org_id;
}
/**
 * Creates a valid Sentry Dsn object, identifying a Sentry instance and project.
 * @returns a valid DsnComponents object or `undefined` if @param from is an invalid DSN source
 */ function $a6fcb45f188ebaa3$export$128827c3562ec0cb(from) {
    const components = typeof from === 'string' ? $a6fcb45f188ebaa3$export$b892860177f70a30(from) : $a6fcb45f188ebaa3$var$dsnFromComponents(from);
    if (!components || !$a6fcb45f188ebaa3$var$validateDsn(components)) return undefined;
    return components;
}


/**
 * Parse a sample rate from a given value.
 * This will either return a boolean or number sample rate, if the sample rate is valid (between 0 and 1).
 * If a string is passed, we try to convert it to a number.
 *
 * Any invalid sample rate will return `undefined`.
 */ function $77c0cd7d06293a86$export$a5bd2d81656d9546(sampleRate) {
    if (typeof sampleRate === 'boolean') return Number(sampleRate);
    const rate = typeof sampleRate === 'string' ? parseFloat(sampleRate) : sampleRate;
    if (typeof rate !== 'number' || isNaN(rate) || rate < 0 || rate > 1) return undefined;
    return rate;
}




// oxlint-disable-next-line sdk/no-regexp-constructor -- RegExp is used for readability here
const $6a872401a977a16c$export$394a210812ba3012 = new RegExp("^[ \\t]*([0-9a-f]{32})?-?([0-9a-f]{16})?-?([01])?[ \\t]*$");
/**
 * Extract transaction context data from a `sentry-trace` header.
 *
 * This is terrible naming but the function has nothing to do with the W3C traceparent header.
 * It can only parse the `sentry-trace` header and extract the "trace parent" data.
 *
 * @param traceparent Traceparent string
 *
 * @returns Object containing data from the header, or undefined if traceparent string is malformed
 */ function $6a872401a977a16c$export$8e9a29865c0a1226(traceparent) {
    if (!traceparent) return undefined;
    const matches = traceparent.match($6a872401a977a16c$export$394a210812ba3012);
    if (!matches) return undefined;
    let parentSampled;
    if (matches[3] === '1') parentSampled = true;
    else if (matches[3] === '0') parentSampled = false;
    return {
        traceId: matches[1],
        parentSampled: parentSampled,
        parentSpanId: matches[2]
    };
}
/**
 * Create a propagation context from incoming headers or
 * creates a minimal new one if the headers are undefined.
 */ function $6a872401a977a16c$export$261f383d16a93e39(sentryTrace, baggage) {
    const traceparentData = $6a872401a977a16c$export$8e9a29865c0a1226(sentryTrace);
    const dynamicSamplingContext = (0, $dfa5ff63e2991cbd$export$5b96ee2c8421f107)(baggage);
    if (!traceparentData?.traceId) return {
        traceId: (0, $1eac0e3178cad4a9$export$dc6d7ea554bcce10)(),
        sampleRand: (0, $11bebf6401bbfdb9$export$9869d72de32a3917)()
    };
    const sampleRand = $6a872401a977a16c$var$getSampleRandFromTraceparentAndDsc(traceparentData, dynamicSamplingContext);
    // The sample_rand on the DSC needs to be generated based on traceparent + baggage.
    if (dynamicSamplingContext) dynamicSamplingContext.sample_rand = sampleRand.toString();
    const { traceId: traceId, parentSpanId: parentSpanId, parentSampled: parentSampled } = traceparentData;
    return {
        traceId: traceId,
        parentSpanId: parentSpanId,
        sampled: parentSampled,
        dsc: dynamicSamplingContext || {},
        sampleRand: sampleRand
    };
}
/**
 * Create sentry-trace header from span context values.
 */ function $6a872401a977a16c$export$f35d907436da45cf(traceId = (0, $1eac0e3178cad4a9$export$dc6d7ea554bcce10)(), spanId = (0, $1eac0e3178cad4a9$export$295213bc4d0c54ad)(), sampled) {
    let sampledString = '';
    if (sampled !== undefined) sampledString = sampled ? '-1' : '-0';
    return `${traceId}-${spanId}${sampledString}`;
}
/**
 * Creates a W3C traceparent header from the given trace and span ids.
 */ function $6a872401a977a16c$export$1aff3752542747dd(traceId = (0, $1eac0e3178cad4a9$export$dc6d7ea554bcce10)(), spanId = (0, $1eac0e3178cad4a9$export$295213bc4d0c54ad)(), sampled) {
    return `00-${traceId}-${spanId}-${sampled ? '01' : '00'}`;
}
/**
 * Given any combination of an incoming trace, generate a sample rand based on its defined semantics.
 *
 * Read more: https://develop.sentry.dev/sdk/telemetry/traces/#propagated-random-value
 */ function $6a872401a977a16c$var$getSampleRandFromTraceparentAndDsc(traceparentData, dsc) {
    // When there is an incoming sample rand use it.
    const parsedSampleRand = (0, $77c0cd7d06293a86$export$a5bd2d81656d9546)(dsc?.sample_rand);
    if (parsedSampleRand !== undefined) return parsedSampleRand;
    // Otherwise, if there is an incoming sampling decision + sample rate, generate a sample rand that would lead to the same sampling decision.
    const parsedSampleRate = (0, $77c0cd7d06293a86$export$a5bd2d81656d9546)(dsc?.sample_rate);
    if (parsedSampleRate && traceparentData?.parentSampled !== undefined) return traceparentData.parentSampled ? (0, $11bebf6401bbfdb9$export$9869d72de32a3917)() * parsedSampleRate : parsedSampleRate + (0, $11bebf6401bbfdb9$export$9869d72de32a3917)() * (1 - parsedSampleRate);
    else // If nothing applies, return a random sample rand.
    return (0, $11bebf6401bbfdb9$export$9869d72de32a3917)();
}
/**
 * Determines whether a new trace should be continued based on the provided baggage org ID and the client's `strictTraceContinuation` option.
 * If the trace should not be continued, a new trace will be started.
 *
 * The result is dependent on the `strictTraceContinuation` option in the client.
 * See https://develop.sentry.dev/sdk/telemetry/traces/#stricttracecontinuation
 */ function $6a872401a977a16c$export$18811bc99eefceaa(client, baggageOrgId) {
    const clientOrgId = (0, $a6fcb45f188ebaa3$export$b7ac9b8efa4bb595)(client);
    // Case: baggage orgID and Client orgID don't match - always start new trace
    if (baggageOrgId && clientOrgId && baggageOrgId !== clientOrgId) {
        (0, $6ed5aee3203eab87$export$1c9f709888824e05).log(`Won't continue trace because org IDs don't match (incoming baggage: ${baggageOrgId}, SDK options: ${clientOrgId})`);
        return false;
    }
    const strictTraceContinuation = client.getOptions().strictTraceContinuation || false; // default for `strictTraceContinuation` is `false`
    if (strictTraceContinuation) // With strict continuation enabled, don't continue trace if:
    // - Baggage has orgID, but Client doesn't have one
    // - Client has orgID, but baggage doesn't have one
    {
        if (baggageOrgId && !clientOrgId || !baggageOrgId && clientOrgId) {
            (0, $6ed5aee3203eab87$export$1c9f709888824e05).log(`Starting a new trace because strict trace continuation is enabled but one org ID is missing (incoming baggage: ${baggageOrgId}, Sentry client: ${clientOrgId})`);
            return false;
        }
    }
    return true;
}




// These are aligned with OpenTelemetry trace flags
const $cdd7dc1c144c1b85$export$208d5b368507fb8b = 0x0;
const $cdd7dc1c144c1b85$export$eb571cd9b5d98de8 = 0x1;
let $cdd7dc1c144c1b85$var$hasShownSpanDropWarning = false;
/**
 * Convert a span to a trace context, which can be sent as the `trace` context in an event.
 * By default, this will only include trace_id, span_id & parent_span_id.
 * If `includeAllData` is true, it will also include data, op, status & origin.
 */ function $cdd7dc1c144c1b85$export$4c3967a8a2f6bbd6(span) {
    const { spanId: span_id, traceId: trace_id } = span.spanContext();
    const { data: data, op: op, parent_span_id: parent_span_id, status: status, origin: origin, links: links } = $cdd7dc1c144c1b85$export$92d8c23565496537(span);
    return {
        parent_span_id: parent_span_id,
        span_id: span_id,
        trace_id: trace_id,
        data: data,
        op: op,
        status: status,
        origin: origin,
        links: links
    };
}
/**
 * Convert a span to a trace context, which can be sent as the `trace` context in a non-transaction event.
 */ function $cdd7dc1c144c1b85$export$46c6fbd1d265ebf0(span) {
    const { spanId: spanId, traceId: trace_id, isRemote: isRemote } = span.spanContext();
    // If the span is remote, we use a random/virtual span as span_id to the trace context,
    // and the remote span as parent_span_id
    const parent_span_id = isRemote ? spanId : $cdd7dc1c144c1b85$export$92d8c23565496537(span).parent_span_id;
    const scope = (0, $360fa73c77afb99d$export$c08fbc656a245d03)(span).scope;
    const span_id = isRemote ? scope?.getPropagationContext().propagationSpanId || (0, $1eac0e3178cad4a9$export$295213bc4d0c54ad)() : spanId;
    return {
        parent_span_id: parent_span_id,
        span_id: span_id,
        trace_id: trace_id
    };
}
/**
 * Convert a Span to a Sentry trace header.
 */ function $cdd7dc1c144c1b85$export$7e9f8ae9e4a328ab(span) {
    const { traceId: traceId, spanId: spanId } = span.spanContext();
    const sampled = $cdd7dc1c144c1b85$export$5caecac1caaf3a71(span);
    return (0, $6a872401a977a16c$export$f35d907436da45cf)(traceId, spanId, sampled);
}
/**
 * Convert a Span to a W3C traceparent header.
 */ function $cdd7dc1c144c1b85$export$cda58d87bc594e9f(span) {
    const { traceId: traceId, spanId: spanId } = span.spanContext();
    const sampled = $cdd7dc1c144c1b85$export$5caecac1caaf3a71(span);
    return (0, $6a872401a977a16c$export$1aff3752542747dd)(traceId, spanId, sampled);
}
/**
 *  Converts the span links array to a flattened version to be sent within an envelope.
 *
 *  If the links array is empty, it returns `undefined` so the empty value can be dropped before it's sent.
 */ function $cdd7dc1c144c1b85$export$cb3e3a12e0eec16c(links) {
    if (links && links.length > 0) return links.map(({ context: { spanId: spanId, traceId: traceId, traceFlags: traceFlags, ...restContext }, attributes: attributes })=>({
            span_id: spanId,
            trace_id: traceId,
            sampled: traceFlags === $cdd7dc1c144c1b85$export$eb571cd9b5d98de8,
            attributes: attributes,
            ...restContext
        }));
    else return undefined;
}
/**
 * Converts the span links array to a flattened version with serialized attributes for V2 spans.
 *
 * If the links array is empty, it returns `undefined` so the empty value can be dropped before it's sent.
 */ function $cdd7dc1c144c1b85$export$9015adcf158ef3a5(links) {
    if (links?.length) return links.map(({ context: { spanId: spanId, traceId: traceId, traceFlags: traceFlags }, attributes: attributes })=>({
            span_id: spanId,
            trace_id: traceId,
            sampled: traceFlags === $cdd7dc1c144c1b85$export$eb571cd9b5d98de8,
            attributes: attributes
        }));
    else return undefined;
}
/**
 * Convert a span time input into a timestamp in seconds.
 */ function $cdd7dc1c144c1b85$export$3f7581298f56c6d7(input) {
    if (typeof input === 'number') return $cdd7dc1c144c1b85$var$ensureTimestampInSeconds(input);
    if (Array.isArray(input)) // See {@link HrTime} for the array-based time format
    return input[0] + input[1] / 1e9;
    if (input instanceof Date) return $cdd7dc1c144c1b85$var$ensureTimestampInSeconds(input.getTime());
    return (0, $27fab3c4acc6cd95$export$ee52dced521e3e18)();
}
/**
 * Converts a timestamp to second, if it was in milliseconds, or keeps it as second.
 */ function $cdd7dc1c144c1b85$var$ensureTimestampInSeconds(timestamp) {
    const isMs = timestamp > 9999999999;
    return isMs ? timestamp / 1000 : timestamp;
}
/**
 * Convert a span to a JSON representation.
 */ // Note: Because of this, we currently have a circular type dependency (which we opted out of in package.json).
// This is not avoidable as we need `spanToJSON` in `spanUtils.ts`, which in turn is needed by `span.ts` for backwards compatibility.
// And `spanToJSON` needs the Span class from `span.ts` to check here.
function $cdd7dc1c144c1b85$export$92d8c23565496537(span) {
    if ($cdd7dc1c144c1b85$var$spanIsSentrySpan(span)) return span.getSpanJSON();
    const { spanId: span_id, traceId: trace_id } = span.spanContext();
    // Handle a span from @opentelemetry/sdk-base-trace's `Span` class
    if ($cdd7dc1c144c1b85$var$spanIsOpenTelemetrySdkTraceBaseSpan(span)) {
        const { attributes: attributes, startTime: startTime, name: name, endTime: endTime, status: status, links: links } = span;
        return {
            span_id: span_id,
            trace_id: trace_id,
            data: attributes,
            description: name,
            parent_span_id: $cdd7dc1c144c1b85$var$getOtelParentSpanId(span),
            start_timestamp: $cdd7dc1c144c1b85$export$3f7581298f56c6d7(startTime),
            // This is [0,0] by default in OTEL, in which case we want to interpret this as no end time
            timestamp: $cdd7dc1c144c1b85$export$3f7581298f56c6d7(endTime) || undefined,
            status: $cdd7dc1c144c1b85$export$e238a77ea3a8cd66(status),
            op: attributes[0, $0633c8eb02923c67$export$1a413bd9a88fdb09],
            origin: attributes[0, $0633c8eb02923c67$export$cca8dd30f57f805e],
            links: $cdd7dc1c144c1b85$export$cb3e3a12e0eec16c(links)
        };
    }
    // Finally, at least we have `spanContext()`....
    // This should not actually happen in reality, but we need to handle it for type safety.
    return {
        span_id: span_id,
        trace_id: trace_id,
        start_timestamp: 0,
        data: {}
    };
}
/**
 * Convert a span to the intermediate {@link StreamedSpanJSON} representation.
 */ function $cdd7dc1c144c1b85$export$db0cad9e44f67af8(span) {
    if ($cdd7dc1c144c1b85$var$spanIsSentrySpan(span)) return span.getStreamedSpanJSON();
    const { spanId: span_id, traceId: trace_id } = span.spanContext();
    // Handle a span from @opentelemetry/sdk-base-trace's `Span` class
    if ($cdd7dc1c144c1b85$var$spanIsOpenTelemetrySdkTraceBaseSpan(span)) {
        const { attributes: attributes, startTime: startTime, name: name, endTime: endTime, status: status, links: links } = span;
        return {
            name: name,
            span_id: span_id,
            trace_id: trace_id,
            parent_span_id: $cdd7dc1c144c1b85$var$getOtelParentSpanId(span),
            start_timestamp: $cdd7dc1c144c1b85$export$3f7581298f56c6d7(startTime),
            end_timestamp: $cdd7dc1c144c1b85$export$3f7581298f56c6d7(endTime),
            is_segment: span === $cdd7dc1c144c1b85$export$7a3106f345d83bb6(span),
            status: $cdd7dc1c144c1b85$export$457dcd3df4e9f5c6(status),
            attributes: attributes,
            links: $cdd7dc1c144c1b85$export$9015adcf158ef3a5(links)
        };
    }
    // Finally, as a fallback, at least we have `spanContext()`....
    // This should not actually happen in reality, but we need to handle it for type safety.
    return {
        span_id: span_id,
        trace_id: trace_id,
        start_timestamp: 0,
        name: '',
        end_timestamp: 0,
        status: 'ok',
        is_segment: span === $cdd7dc1c144c1b85$export$7a3106f345d83bb6(span)
    };
}
/**
 * In preparation for the next major of OpenTelemetry, we want to support
 * looking up the parent span id according to the new API
 * In OTel v1, the parent span id is accessed as `parentSpanId`
 * In OTel v2, the parent span id is accessed as `spanId` on the `parentSpanContext`
 */ function $cdd7dc1c144c1b85$var$getOtelParentSpanId(span) {
    return 'parentSpanId' in span ? span.parentSpanId : 'parentSpanContext' in span ? span.parentSpanContext?.spanId : undefined;
}
/**
 * Converts a {@link StreamedSpanJSON} to a {@link SerializedSpan}.
 * This is the final serialized span format that is sent to Sentry.
 * The returned serilaized spans must not be consumed by users or SDK integrations.
 */ function $cdd7dc1c144c1b85$export$5402aa553bcf35f3(spanJson) {
    return {
        ...spanJson,
        attributes: (0, $78177fa8d256e3ec$export$4954cae66e755861)(spanJson.attributes),
        links: spanJson.links?.map((link)=>({
                ...link,
                attributes: (0, $78177fa8d256e3ec$export$4954cae66e755861)(link.attributes)
            }))
    };
}
function $cdd7dc1c144c1b85$var$spanIsOpenTelemetrySdkTraceBaseSpan(span) {
    const castSpan = span;
    return !!castSpan.attributes && !!castSpan.startTime && !!castSpan.name && !!castSpan.endTime && !!castSpan.status;
}
/** Exported only for tests. */ /**
 * Sadly, due to circular dependency checks we cannot actually import the Span class here and check for instanceof.
 * :( So instead we approximate this by checking if it has the `getSpanJSON` method.
 */ function $cdd7dc1c144c1b85$var$spanIsSentrySpan(span) {
    return typeof span.getSpanJSON === 'function';
}
/**
 * Returns true if a span is sampled.
 * In most cases, you should just use `span.isRecording()` instead.
 * However, this has a slightly different semantic, as it also returns false if the span is finished.
 * So in the case where this distinction is important, use this method.
 */ function $cdd7dc1c144c1b85$export$5caecac1caaf3a71(span) {
    // We align our trace flags with the ones OpenTelemetry use
    // So we also check for sampled the same way they do.
    const { traceFlags: traceFlags } = span.spanContext();
    return traceFlags === $cdd7dc1c144c1b85$export$eb571cd9b5d98de8;
}
/** Get the status message to use for a JSON representation of a span. */ function $cdd7dc1c144c1b85$export$e238a77ea3a8cd66(status) {
    if (!status || status.code === (0, $7a6201d846b686cd$export$136e25984ba4a383)) return undefined;
    if (status.code === (0, $7a6201d846b686cd$export$58f7963109c806fc)) return 'ok';
    return status.message || 'internal_error';
}
/**
 * Convert the various statuses to the simple onces expected by Sentry for steamed spans ('ok' is default).
 */ function $cdd7dc1c144c1b85$export$457dcd3df4e9f5c6(status) {
    return !status || status.code === (0, $7a6201d846b686cd$export$58f7963109c806fc) || status.code === (0, $7a6201d846b686cd$export$136e25984ba4a383) || status.message === 'cancelled' ? 'ok' : 'error';
}
const $cdd7dc1c144c1b85$var$CHILD_SPANS_FIELD = '_sentryChildSpans';
const $cdd7dc1c144c1b85$var$ROOT_SPAN_FIELD = '_sentryRootSpan';
/**
 * Adds an opaque child span reference to a span.
 */ function $cdd7dc1c144c1b85$export$81397d924722cc65(span, childSpan) {
    // We store the root span reference on the child span
    // We need this for `getRootSpan()` to work
    const rootSpan = span[$cdd7dc1c144c1b85$var$ROOT_SPAN_FIELD] || span;
    (0, $10696cb2974e7335$export$e73679ffaf56810e)(childSpan, $cdd7dc1c144c1b85$var$ROOT_SPAN_FIELD, rootSpan);
    // We store a list of child spans on the parent span
    // We need this for `getSpanDescendants()` to work
    if (span[$cdd7dc1c144c1b85$var$CHILD_SPANS_FIELD]) span[$cdd7dc1c144c1b85$var$CHILD_SPANS_FIELD].add(childSpan);
    else (0, $10696cb2974e7335$export$e73679ffaf56810e)(span, $cdd7dc1c144c1b85$var$CHILD_SPANS_FIELD, new Set([
        childSpan
    ]));
}
/** This is only used internally by Idle Spans. */ function $cdd7dc1c144c1b85$export$c2a0c9438bb89d91(span, childSpan) {
    if (span[$cdd7dc1c144c1b85$var$CHILD_SPANS_FIELD]) span[$cdd7dc1c144c1b85$var$CHILD_SPANS_FIELD].delete(childSpan);
}
/**
 * Returns an array of the given span and all of its descendants.
 */ function $cdd7dc1c144c1b85$export$340c5c8a13ffc680(span) {
    const resultSet = new Set();
    function addSpanChildren(span) {
        // This exit condition is required to not infinitely loop in case of a circular dependency.
        if (resultSet.has(span)) return;
        else if ($cdd7dc1c144c1b85$export$5caecac1caaf3a71(span)) {
            resultSet.add(span);
            const childSpans = span[$cdd7dc1c144c1b85$var$CHILD_SPANS_FIELD] ? Array.from(span[$cdd7dc1c144c1b85$var$CHILD_SPANS_FIELD]) : [];
            for (const childSpan of childSpans)addSpanChildren(childSpan);
        }
    }
    addSpanChildren(span);
    return Array.from(resultSet);
}
/**
 * Returns the root span of a given span.
 */ const $cdd7dc1c144c1b85$export$c4c6a79b1260ca1b = $cdd7dc1c144c1b85$export$7a3106f345d83bb6;
/**
 * Returns the segment span of a given span.
 */ function $cdd7dc1c144c1b85$export$7a3106f345d83bb6(span) {
    return span[$cdd7dc1c144c1b85$var$ROOT_SPAN_FIELD] || span;
}
/**
 * Returns the currently active span.
 */ function $cdd7dc1c144c1b85$export$1be426a8e585c83e() {
    const carrier = (0, $b9fc213467403976$export$19eade501500c6c1)();
    const acs = (0, $22ac79c556bb203d$export$f639b0c2752203be)(carrier);
    if (acs.getActiveSpan) return acs.getActiveSpan();
    return (0, $18f1bf9c6bfa5b9e$export$91f063ebb8eff307)((0, $6c9d57d6c1e4fcbb$export$c7be4b0125a10cba)());
}
/**
 * Logs a warning once if `beforeSendSpan` is used to drop spans.
 */ function $cdd7dc1c144c1b85$export$d11691ff45a3e535() {
    if (!$cdd7dc1c144c1b85$var$hasShownSpanDropWarning) {
        (0, $6ed5aee3203eab87$export$cda52e2a8927a2ca)(()=>{
            // eslint-disable-next-line no-console
            console.warn('[Sentry] Returning null from `beforeSendSpan` is disallowed. To drop certain spans, configure the respective integrations directly or use `ignoreSpans`.');
        });
        $cdd7dc1c144c1b85$var$hasShownSpanDropWarning = true;
    }
}
/**
 * Updates the name of the given span and ensures that the span name is not
 * overwritten by the Sentry SDK.
 *
 * Use this function instead of `span.updateName()` if you want to make sure that
 * your name is kept. For some spans, for example root `http.server` spans the
 * Sentry SDK would otherwise overwrite the span name with a high-quality name
 * it infers when the span ends.
 *
 * Use this function in server code or when your span is started on the server
 * and on the client (browser). If you only update a span name on the client,
 * you can also use `span.updateName()` the SDK does not overwrite the name.
 *
 * @param span - The span to update the name of.
 * @param name - The name to set on the span.
 */ function $cdd7dc1c144c1b85$export$5b72d3169c1be715(span, name) {
    span.updateName(name);
    span.setAttributes({
        [(0, $0633c8eb02923c67$export$d7a7d984b0791405)]: 'custom',
        [(0, $0633c8eb02923c67$export$165ce9a229f6f050)]: name
    });
}


const $267edb3c0f764225$var$INTEGRATION_NAME = 'ConversationId';
const $267edb3c0f764225$var$_conversationIdIntegration = ()=>{
    return {
        name: $267edb3c0f764225$var$INTEGRATION_NAME,
        setup (client) {
            client.on('spanStart', (span)=>{
                const scopeData = (0, $6c9d57d6c1e4fcbb$export$c7be4b0125a10cba)().getScopeData();
                const isolationScopeData = (0, $6c9d57d6c1e4fcbb$export$68f3af03034c9e90)().getScopeData();
                const conversationId = scopeData.conversationId || isolationScopeData.conversationId;
                if (conversationId) {
                    const { op: op, data: attributes, description: name } = (0, $cdd7dc1c144c1b85$export$92d8c23565496537)(span);
                    // Only apply conversation ID to gen_ai spans.
                    // We also check for Vercel AI spans (ai.operationId attribute or ai.* span name)
                    // because the Vercel AI integration sets the gen_ai.* op in its own spanStart handler
                    // which fires after this, so the op is not yet available at this point.
                    if (!op?.startsWith('gen_ai.') && !attributes['ai.operationId'] && !name?.startsWith('ai.')) return;
                    span.setAttribute((0, $0633c8eb02923c67$export$71a4a707257f2774), conversationId);
                }
            });
        }
    };
};
/**
 * Automatically applies conversation ID from scope to spans.
 *
 * This integration reads the conversation ID from the current or isolation scope
 * and applies it to spans when they start. This ensures the conversation ID is
 * available for all AI-related operations.
 */ const $267edb3c0f764225$export$97457a453081a5b3 = (0, $305b4dfee0d746dc$export$2323046b9414659f)($267edb3c0f764225$var$_conversationIdIntegration);





const $57b98971d429d806$var$INTEGRATION_NAME = 'Dedupe';
const $57b98971d429d806$var$_dedupeIntegration = ()=>{
    let previousEvent;
    return {
        name: $57b98971d429d806$var$INTEGRATION_NAME,
        processEvent (currentEvent) {
            // We want to ignore any non-error type events, e.g. transactions or replays
            // These should never be deduped, and also not be compared against as _previousEvent.
            if (currentEvent.type) return currentEvent;
            // Juuust in case something goes wrong
            try {
                if ($57b98971d429d806$export$3c6361fddf6cd929(currentEvent, previousEvent)) {
                    (0, $6d193f2c2b007873$export$16a28057038b10ef) && (0, $6ed5aee3203eab87$export$1c9f709888824e05).warn('Event dropped due to being a duplicate of previously captured event.');
                    return null;
                }
            } catch  {} // eslint-disable-line no-empty
            return previousEvent = currentEvent;
        }
    };
};
/**
 * Deduplication filter.
 */ const $57b98971d429d806$export$6d39aa44cd0c7567 = (0, $305b4dfee0d746dc$export$2323046b9414659f)($57b98971d429d806$var$_dedupeIntegration);
/** only exported for tests. */ function $57b98971d429d806$export$3c6361fddf6cd929(currentEvent, previousEvent) {
    if (!previousEvent) return false;
    if ($57b98971d429d806$var$_isSameMessageEvent(currentEvent, previousEvent)) return true;
    if ($57b98971d429d806$var$_isSameExceptionEvent(currentEvent, previousEvent)) return true;
    return false;
}
function $57b98971d429d806$var$_isSameMessageEvent(currentEvent, previousEvent) {
    const currentMessage = currentEvent.message;
    const previousMessage = previousEvent.message;
    // If neither event has a message property, they were both exceptions, so bail out
    if (!currentMessage && !previousMessage) return false;
    // If only one event has a stacktrace, but not the other one, they are not the same
    if (currentMessage && !previousMessage || !currentMessage && previousMessage) return false;
    if (currentMessage !== previousMessage) return false;
    if (!$57b98971d429d806$var$_isSameFingerprint(currentEvent, previousEvent)) return false;
    if (!$57b98971d429d806$var$_isSameStacktrace(currentEvent, previousEvent)) return false;
    return true;
}
function $57b98971d429d806$var$_isSameExceptionEvent(currentEvent, previousEvent) {
    const previousException = $57b98971d429d806$var$_getExceptionFromEvent(previousEvent);
    const currentException = $57b98971d429d806$var$_getExceptionFromEvent(currentEvent);
    if (!previousException || !currentException) return false;
    if (previousException.type !== currentException.type || previousException.value !== currentException.value) return false;
    if (!$57b98971d429d806$var$_isSameFingerprint(currentEvent, previousEvent)) return false;
    if (!$57b98971d429d806$var$_isSameStacktrace(currentEvent, previousEvent)) return false;
    return true;
}
function $57b98971d429d806$var$_isSameStacktrace(currentEvent, previousEvent) {
    let currentFrames = (0, $d64dedd9c6b2e07c$export$91d8ca51bd9f6a47)(currentEvent);
    let previousFrames = (0, $d64dedd9c6b2e07c$export$91d8ca51bd9f6a47)(previousEvent);
    // If neither event has a stacktrace, they are assumed to be the same
    if (!currentFrames && !previousFrames) return true;
    // If only one event has a stacktrace, but not the other one, they are not the same
    if (currentFrames && !previousFrames || !currentFrames && previousFrames) return false;
    currentFrames;
    previousFrames;
    // If number of frames differ, they are not the same
    if (previousFrames.length !== currentFrames.length) return false;
    // Otherwise, compare the two
    for(let i = 0; i < previousFrames.length; i++){
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const frameA = previousFrames[i];
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const frameB = currentFrames[i];
        if (frameA.filename !== frameB.filename || frameA.lineno !== frameB.lineno || frameA.colno !== frameB.colno || frameA.function !== frameB.function) return false;
    }
    return true;
}
function $57b98971d429d806$var$_isSameFingerprint(currentEvent, previousEvent) {
    let currentFingerprint = currentEvent.fingerprint;
    let previousFingerprint = previousEvent.fingerprint;
    // If neither event has a fingerprint, they are assumed to be the same
    if (!currentFingerprint && !previousFingerprint) return true;
    // If only one event has a fingerprint, but not the other one, they are not the same
    if (currentFingerprint && !previousFingerprint || !currentFingerprint && previousFingerprint) return false;
    currentFingerprint;
    previousFingerprint;
    // Otherwise, compare the two
    try {
        return !!(currentFingerprint.join('') === previousFingerprint.join(''));
    } catch  {
        return false;
    }
}
function $57b98971d429d806$var$_getExceptionFromEvent(event) {
    return event.exception?.values?.[0];
}




let $9800c1484ce3b179$var$originalFunctionToString;
const $9800c1484ce3b179$var$INTEGRATION_NAME = 'FunctionToString';
const $9800c1484ce3b179$var$SETUP_CLIENTS = new WeakMap();
const $9800c1484ce3b179$var$_functionToStringIntegration = ()=>{
    return {
        name: $9800c1484ce3b179$var$INTEGRATION_NAME,
        setupOnce () {
            // eslint-disable-next-line @typescript-eslint/unbound-method
            $9800c1484ce3b179$var$originalFunctionToString = Function.prototype.toString;
            // intrinsics (like Function.prototype) might be immutable in some environments
            // e.g. Node with --frozen-intrinsics, XS (an embedded JavaScript engine) or SES (a JavaScript proposal)
            try {
                Function.prototype.toString = function(...args) {
                    const originalFunction = (0, $10696cb2974e7335$export$e6cc1e135e2092e5)(this);
                    const context = $9800c1484ce3b179$var$SETUP_CLIENTS.has((0, $6c9d57d6c1e4fcbb$export$6bb76d6eba7e258c)()) && originalFunction !== undefined ? originalFunction : this;
                    return $9800c1484ce3b179$var$originalFunctionToString.apply(context, args);
                };
            } catch  {
            // ignore errors here, just don't patch this
            }
        },
        setup (client) {
            $9800c1484ce3b179$var$SETUP_CLIENTS.set(client, true);
        }
    };
};
/**
 * Patch toString calls to return proper name for wrapped functions.
 *
 * ```js
 * Sentry.init({
 *   integrations: [
 *     functionToStringIntegration(),
 *   ],
 * });
 * ```
 */ const $9800c1484ce3b179$export$7918117e9202e4fb = (0, $305b4dfee0d746dc$export$2323046b9414659f)($9800c1484ce3b179$var$_functionToStringIntegration);




/**
 * Get a list of possible event messages from a Sentry event.
 */ function $609931b5fa93b35e$export$d55a97c329cacfcc(event) {
    const possibleMessages = [];
    if (event.message) possibleMessages.push(event.message);
    try {
        // @ts-expect-error Try catching to save bundle size
        const lastException = event.exception.values[event.exception.values.length - 1];
        if (lastException?.value) {
            possibleMessages.push(lastException.value);
            if (lastException.type) possibleMessages.push(`${lastException.type}: ${lastException.value}`);
        }
    } catch  {
    // ignore errors here
    }
    return possibleMessages;
}




// "Script error." is hard coded into browsers for errors that it can't read.
// this is the result of a script being pulled in from an external domain and CORS.
const $6fc6e13139469b0a$var$DEFAULT_IGNORE_ERRORS = [
    /^Script error\.?$/,
    /^Javascript error: Script error\.? on line 0$/,
    /^ResizeObserver loop completed with undelivered notifications.$/,
    /^Cannot redefine property: googletag$/,
    /^Can't find variable: gmo$/,
    /^undefined is not an object \(evaluating 'a\.[A-Z]'\)$/,
    /can't redefine non-configurable property "solana"/,
    /vv\(\)\.getRestrictions is not a function/,
    /Can't find variable: _AutofillCallbackHandler/,
    /Object Not Found Matching Id:\d+, MethodName:simulateEvent/,
    /^Java exception was raised during method invocation$/
];
/** Options for the EventFilters integration */ const $6fc6e13139469b0a$var$INTEGRATION_NAME = 'EventFilters';
/**
 * An integration that filters out events (errors and transactions) based on:
 *
 * - (Errors) A curated list of known low-value or irrelevant errors (see {@link DEFAULT_IGNORE_ERRORS})
 * - (Errors) A list of error messages or urls/filenames passed in via
 *   - Top level Sentry.init options (`ignoreErrors`, `denyUrls`, `allowUrls`)
 *   - The same options passed to the integration directly via @param options
 * - (Transactions/Spans) A list of root span (transaction) names passed in via
 *   - Top level Sentry.init option (`ignoreTransactions`)
 *   - The same option passed to the integration directly via @param options
 *
 * Events filtered by this integration will not be sent to Sentry.
 */ const $6fc6e13139469b0a$export$9a84f518c163c552 = (0, $305b4dfee0d746dc$export$2323046b9414659f)((options = {})=>{
    let mergedOptions;
    return {
        name: $6fc6e13139469b0a$var$INTEGRATION_NAME,
        setup (client) {
            const clientOptions = client.getOptions();
            mergedOptions = $6fc6e13139469b0a$var$_mergeOptions(options, clientOptions);
        },
        processEvent (event, _hint, client) {
            if (!mergedOptions) {
                const clientOptions = client.getOptions();
                mergedOptions = $6fc6e13139469b0a$var$_mergeOptions(options, clientOptions);
            }
            return $6fc6e13139469b0a$var$_shouldDropEvent(event, mergedOptions) ? null : event;
        }
    };
});
/**
 * An integration that filters out events (errors and transactions) based on:
 *
 * - (Errors) A curated list of known low-value or irrelevant errors (see {@link DEFAULT_IGNORE_ERRORS})
 * - (Errors) A list of error messages or urls/filenames passed in via
 *   - Top level Sentry.init options (`ignoreErrors`, `denyUrls`, `allowUrls`)
 *   - The same options passed to the integration directly via @param options
 * - (Transactions/Spans) A list of root span (transaction) names passed in via
 *   - Top level Sentry.init option (`ignoreTransactions`)
 *   - The same option passed to the integration directly via @param options
 *
 * Events filtered by this integration will not be sent to Sentry.
 *
 * @deprecated this integration was renamed and will be removed in a future major version.
 * Use `eventFiltersIntegration` instead.
 */ const $6fc6e13139469b0a$export$cb3c5c2ceb9818ba = (0, $305b4dfee0d746dc$export$2323046b9414659f)((options = {})=>{
    return {
        ...$6fc6e13139469b0a$export$9a84f518c163c552(options),
        name: 'InboundFilters'
    };
});
function $6fc6e13139469b0a$var$_mergeOptions(internalOptions = {}, clientOptions = {}) {
    return {
        allowUrls: [
            ...internalOptions.allowUrls || [],
            ...clientOptions.allowUrls || []
        ],
        denyUrls: [
            ...internalOptions.denyUrls || [],
            ...clientOptions.denyUrls || []
        ],
        ignoreErrors: [
            ...internalOptions.ignoreErrors || [],
            ...clientOptions.ignoreErrors || [],
            ...internalOptions.disableErrorDefaults ? [] : $6fc6e13139469b0a$var$DEFAULT_IGNORE_ERRORS
        ],
        ignoreTransactions: [
            ...internalOptions.ignoreTransactions || [],
            ...clientOptions.ignoreTransactions || []
        ]
    };
}
function $6fc6e13139469b0a$var$_shouldDropEvent(event, options) {
    if (!event.type) {
        // Filter errors
        if ($6fc6e13139469b0a$var$_isIgnoredError(event, options.ignoreErrors)) {
            (0, $6d193f2c2b007873$export$16a28057038b10ef) && (0, $6ed5aee3203eab87$export$1c9f709888824e05).warn(`Event dropped due to being matched by \`ignoreErrors\` option.\nEvent: ${(0, $76366c1ad7fe29b9$export$4157119e2b157127)(event)}`);
            return true;
        }
        if ($6fc6e13139469b0a$var$_isUselessError(event)) {
            (0, $6d193f2c2b007873$export$16a28057038b10ef) && (0, $6ed5aee3203eab87$export$1c9f709888824e05).warn(`Event dropped due to not having an error message, error type or stacktrace.\nEvent: ${(0, $76366c1ad7fe29b9$export$4157119e2b157127)(event)}`);
            return true;
        }
        if ($6fc6e13139469b0a$var$_isDeniedUrl(event, options.denyUrls)) {
            (0, $6d193f2c2b007873$export$16a28057038b10ef) && (0, $6ed5aee3203eab87$export$1c9f709888824e05).warn(`Event dropped due to being matched by \`denyUrls\` option.\nEvent: ${(0, $76366c1ad7fe29b9$export$4157119e2b157127)(event)}.\nUrl: ${$6fc6e13139469b0a$var$_getEventFilterUrl(event)}`);
            return true;
        }
        if (!$6fc6e13139469b0a$var$_isAllowedUrl(event, options.allowUrls)) {
            (0, $6d193f2c2b007873$export$16a28057038b10ef) && (0, $6ed5aee3203eab87$export$1c9f709888824e05).warn(`Event dropped due to not being matched by \`allowUrls\` option.\nEvent: ${(0, $76366c1ad7fe29b9$export$4157119e2b157127)(event)}.\nUrl: ${$6fc6e13139469b0a$var$_getEventFilterUrl(event)}`);
            return true;
        }
    } else if (event.type === 'transaction') // Filter transactions
    {
        if ($6fc6e13139469b0a$var$_isIgnoredTransaction(event, options.ignoreTransactions)) {
            (0, $6d193f2c2b007873$export$16a28057038b10ef) && (0, $6ed5aee3203eab87$export$1c9f709888824e05).warn(`Event dropped due to being matched by \`ignoreTransactions\` option.\nEvent: ${(0, $76366c1ad7fe29b9$export$4157119e2b157127)(event)}`);
            return true;
        }
    }
    return false;
}
function $6fc6e13139469b0a$var$_isIgnoredError(event, ignoreErrors) {
    if (!ignoreErrors?.length) return false;
    return (0, $609931b5fa93b35e$export$d55a97c329cacfcc)(event).some((message)=>(0, $5b085f0f99265e84$export$a7a5ec66062ea5d)(message, ignoreErrors));
}
function $6fc6e13139469b0a$var$_isIgnoredTransaction(event, ignoreTransactions) {
    if (!ignoreTransactions?.length) return false;
    const name = event.transaction;
    return name ? (0, $5b085f0f99265e84$export$a7a5ec66062ea5d)(name, ignoreTransactions) : false;
}
function $6fc6e13139469b0a$var$_isDeniedUrl(event, denyUrls) {
    if (!denyUrls?.length) return false;
    const url = $6fc6e13139469b0a$var$_getEventFilterUrl(event);
    return !url ? false : (0, $5b085f0f99265e84$export$a7a5ec66062ea5d)(url, denyUrls);
}
function $6fc6e13139469b0a$var$_isAllowedUrl(event, allowUrls) {
    if (!allowUrls?.length) return true;
    const url = $6fc6e13139469b0a$var$_getEventFilterUrl(event);
    return !url ? true : (0, $5b085f0f99265e84$export$a7a5ec66062ea5d)(url, allowUrls);
}
function $6fc6e13139469b0a$var$_getLastValidUrl(frames = []) {
    for(let i = frames.length - 1; i >= 0; i--){
        const frame = frames[i];
        if (frame && frame.filename !== '<anonymous>' && frame.filename !== '[native code]') return frame.filename || null;
    }
    return null;
}
function $6fc6e13139469b0a$var$_getEventFilterUrl(event) {
    try {
        // If there are linked exceptions or exception aggregates we only want to match against the top frame of the "root" (the main exception)
        // The root always comes last in linked exceptions
        const rootException = [
            ...event.exception?.values ?? []
        ].reverse().find((value)=>value.mechanism?.parent_id === undefined && value.stacktrace?.frames?.length);
        const frames = rootException?.stacktrace?.frames;
        return frames ? $6fc6e13139469b0a$var$_getLastValidUrl(frames) : null;
    } catch  {
        (0, $6d193f2c2b007873$export$16a28057038b10ef) && (0, $6ed5aee3203eab87$export$1c9f709888824e05).error(`Cannot extract url for event ${(0, $76366c1ad7fe29b9$export$4157119e2b157127)(event)}`);
        return null;
    }
}
function $6fc6e13139469b0a$var$_isUselessError(event) {
    // We only want to consider events for dropping that actually have recorded exception values.
    if (!event.exception?.values?.length) return false;
    return(// No top-level message
    !event.message && // There are no exception values that have a stacktrace, a non-generic-Error type or value
    !event.exception.values.some((value)=>value.stacktrace || value.type && value.type !== 'Error' || value.value));
}




/** A class object that can instantiate Client objects. */ /**
 * Internal function to create a new SDK client instance. The client is
 * installed and then bound to the current scope.
 *
 * @param clientClass The client class to instantiate.
 * @param options Options to pass to the client.
 */ function $850d57b0288699a1$export$5333c3f1c58d9bc1(clientClass, options) {
    if (options.debug === true) {
        if (0, $6d193f2c2b007873$export$16a28057038b10ef) (0, $6ed5aee3203eab87$export$1c9f709888824e05).enable();
        else // use `console.warn` rather than `debug.warn` since by non-debug bundles have all `debug.x` statements stripped
        (0, $6ed5aee3203eab87$export$cda52e2a8927a2ca)(()=>{
            // eslint-disable-next-line no-console
            console.warn('[Sentry] Cannot initialize SDK with `debug` option using a non-debug bundle.');
        });
    }
    const scope = (0, $6c9d57d6c1e4fcbb$export$c7be4b0125a10cba)();
    scope.update(options.initialScope);
    const client = new clientClass(options);
    $850d57b0288699a1$export$ecb76f41d43c0e43(client);
    client.init();
    return client;
}
/**
 * Make the given client the current client.
 */ function $850d57b0288699a1$export$ecb76f41d43c0e43(client) {
    (0, $6c9d57d6c1e4fcbb$export$c7be4b0125a10cba)().setClient(client);
}









const $66461bcaaa8dd39f$export$849dbeeeda01ae98 = 'production';
const $66461bcaaa8dd39f$export$6829f580e78306fa = 'development';







// Treeshakable guard to remove all code related to tracing
/**
 * Determines if span recording is currently enabled.
 *
 * Spans are recorded when at least one of `tracesSampleRate` and `tracesSampler`
 * is defined in the SDK config. This function does not make any assumption about
 * sampling decisions, it only checks if the SDK is configured to record spans.
 *
 * Important: This function only determines if span recording is enabled. Trace
 * continuation and propagation is separately controlled and not covered by this function.
 * If this function returns `false`, traces can still be propagated (which is what
 * we refer to by "Tracing without Performance")
 * @see https://develop.sentry.dev/sdk/telemetry/traces/tracing-without-performance/
 *
 * @param maybeOptions An SDK options object to be passed to this function.
 * If this option is not provided, the function will use the current client's options.
 */ function $3db87d4df304f81d$export$1f70765132c3c225(maybeOptions) {
    if (typeof __SENTRY_TRACING__ === 'boolean' && !__SENTRY_TRACING__) return false;
    const options = maybeOptions || (0, $6c9d57d6c1e4fcbb$export$6bb76d6eba7e258c)()?.getOptions();
    return !!options && // Note: This check is `!= null`, meaning "nullish". `0` is not "nullish", `undefined` and `null` are. (This comment was brought to you by 15 minutes of questioning life)
    (options.tracesSampleRate != null || !!options.tracesSampler);
}





/**
 * If you change this value, also update the terser plugin config to
 * avoid minification of the object property!
 */ const $e7797a74bdf55fda$var$FROZEN_DSC_FIELD = '_frozenDsc';
/**
 * Freeze the given DSC on the given span.
 */ function $e7797a74bdf55fda$export$7398c93e763ca9fd(span, dsc) {
    const spanWithMaybeDsc = span;
    (0, $10696cb2974e7335$export$e73679ffaf56810e)(spanWithMaybeDsc, $e7797a74bdf55fda$var$FROZEN_DSC_FIELD, dsc);
}
/**
 * Creates a dynamic sampling context from a client.
 *
 * Dispatches the `createDsc` lifecycle hook as a side effect.
 */ function $e7797a74bdf55fda$export$366bad00d6815eed(trace_id, client) {
    const options = client.getOptions();
    const { publicKey: public_key } = client.getDsn() || {};
    // Instead of conditionally adding non-undefined values, we add them and then remove them if needed
    // otherwise, the order of baggage entries changes, which "breaks" a bunch of tests etc.
    const dsc = {
        environment: options.environment || (0, $66461bcaaa8dd39f$export$849dbeeeda01ae98),
        release: options.release,
        public_key: public_key,
        trace_id: trace_id,
        org_id: (0, $a6fcb45f188ebaa3$export$b7ac9b8efa4bb595)(client)
    };
    client.emit('createDsc', dsc);
    return dsc;
}
/**
 * Get the dynamic sampling context for the currently active scopes.
 */ function $e7797a74bdf55fda$export$89ef1736f08c6b2b(client, scope) {
    const propagationContext = scope.getPropagationContext();
    return propagationContext.dsc || $e7797a74bdf55fda$export$366bad00d6815eed(propagationContext.traceId, client);
}
/**
 * Creates a dynamic sampling context from a span (and client and scope)
 *
 * @param span the span from which a few values like the root span name and sample rate are extracted.
 *
 * @returns a dynamic sampling context
 */ function $e7797a74bdf55fda$export$a117f995597e25df(span) {
    const client = (0, $6c9d57d6c1e4fcbb$export$6bb76d6eba7e258c)();
    if (!client) return {};
    const rootSpan = (0, $cdd7dc1c144c1b85$export$c4c6a79b1260ca1b)(span);
    const rootSpanJson = (0, $cdd7dc1c144c1b85$export$92d8c23565496537)(rootSpan);
    const rootSpanAttributes = rootSpanJson.data;
    const traceState = rootSpan.spanContext().traceState;
    // The span sample rate that was locally applied to the root span should also always be applied to the DSC, even if the DSC is frozen.
    // This is so that the downstream traces/services can use parentSampleRate in their `tracesSampler` to make consistent sampling decisions across the entire trace.
    const rootSpanSampleRate = traceState?.get('sentry.sample_rate') ?? rootSpanAttributes[0, $0633c8eb02923c67$export$ccfe0a40627cc34b] ?? rootSpanAttributes[0, $0633c8eb02923c67$export$889fb736668e1ecc];
    function applyLocalSampleRateToDsc(dsc) {
        if (typeof rootSpanSampleRate === 'number' || typeof rootSpanSampleRate === 'string') dsc.sample_rate = `${rootSpanSampleRate}`;
        return dsc;
    }
    // For core implementation, we freeze the DSC onto the span as a non-enumerable property
    const frozenDsc = rootSpan[$e7797a74bdf55fda$var$FROZEN_DSC_FIELD];
    if (frozenDsc) return applyLocalSampleRateToDsc(frozenDsc);
    // For OpenTelemetry, we freeze the DSC on the trace state
    const traceStateDsc = traceState?.get('sentry.dsc');
    // If the span has a DSC, we want it to take precedence
    const dscOnTraceState = traceStateDsc && (0, $dfa5ff63e2991cbd$export$5b96ee2c8421f107)(traceStateDsc);
    if (dscOnTraceState) return applyLocalSampleRateToDsc(dscOnTraceState);
    // Else, we generate it from the span
    const dsc = $e7797a74bdf55fda$export$366bad00d6815eed(span.spanContext().traceId, client);
    // We don't want to have a transaction name in the DSC if the source is "url" because URLs might contain PII
    // TODO(v11): Only read `SEMANTIC_ATTRIBUTE_SENTRY_SOURCE` again, once we renamed it to `sentry.span.source`
    const source = rootSpanAttributes[0, $0633c8eb02923c67$export$d7a7d984b0791405] ?? rootSpanAttributes['sentry.span.source'];
    // after JSON conversion, txn.name becomes jsonSpan.description
    const name = rootSpanJson.description;
    if (source !== 'url' && name) dsc.transaction = name;
    // How can we even land here with hasSpansEnabled() returning false?
    // Otel creates a Non-recording span in Tracing Without Performance mode when handling incoming requests
    // So we end up with an active span that is not sampled (neither positively nor negatively)
    if ((0, $3db87d4df304f81d$export$1f70765132c3c225)()) {
        dsc.sampled = String((0, $cdd7dc1c144c1b85$export$5caecac1caaf3a71)(rootSpan));
        dsc.sample_rand = // In OTEL we store the sample rand on the trace state because we cannot access scopes for NonRecordingSpans
        // The Sentry OTEL SpanSampler takes care of writing the sample rand on the root span
        traceState?.get('sentry.sample_rand') ?? // On all other platforms we can actually get the scopes from a root span (we use this as a fallback)
        (0, $360fa73c77afb99d$export$c08fbc656a245d03)(rootSpan).scope?.getPropagationContext().sampleRand.toString();
    }
    applyLocalSampleRateToDsc(dsc);
    client.emit('createDsc', dsc, rootSpan);
    return dsc;
}
/**
 * Convert a Span to a baggage header.
 */ function $e7797a74bdf55fda$export$95cf936fdacaff7b(span) {
    const dsc = $e7797a74bdf55fda$export$a117f995597e25df(span);
    return (0, $dfa5ff63e2991cbd$export$56766feef403f365)(dsc);
}




/**
 * Applies data from the scope to the event and runs all event processors on it.
 */ function $7e9d2fc46299f0a2$export$43988bc651a80216(event, data) {
    const { fingerprint: fingerprint, span: span, breadcrumbs: breadcrumbs, sdkProcessingMetadata: sdkProcessingMetadata } = data;
    // Apply general data
    $7e9d2fc46299f0a2$var$applyDataToEvent(event, data);
    // We want to set the trace context for normal events only if there isn't already
    // a trace context on the event. There is a product feature in place where we link
    // errors with transaction and it relies on that.
    if (span) $7e9d2fc46299f0a2$var$applySpanToEvent(event, span);
    $7e9d2fc46299f0a2$var$applyFingerprintToEvent(event, fingerprint);
    $7e9d2fc46299f0a2$var$applyBreadcrumbsToEvent(event, breadcrumbs);
    $7e9d2fc46299f0a2$var$applySdkMetadataToEvent(event, sdkProcessingMetadata);
}
/** Merge data of two scopes together. */ function $7e9d2fc46299f0a2$export$25ac7e259a513db4(data, mergeData) {
    const { extra: extra, tags: tags, attributes: attributes, user: user, contexts: contexts, level: level, sdkProcessingMetadata: sdkProcessingMetadata, breadcrumbs: breadcrumbs, fingerprint: fingerprint, eventProcessors: eventProcessors, attachments: attachments, propagationContext: propagationContext, transactionName: transactionName, span: span } = mergeData;
    $7e9d2fc46299f0a2$export$b1a120a2871faa46(data, 'extra', extra);
    $7e9d2fc46299f0a2$export$b1a120a2871faa46(data, 'tags', tags);
    $7e9d2fc46299f0a2$export$b1a120a2871faa46(data, 'attributes', attributes);
    $7e9d2fc46299f0a2$export$b1a120a2871faa46(data, 'user', user);
    $7e9d2fc46299f0a2$export$b1a120a2871faa46(data, 'contexts', contexts);
    data.sdkProcessingMetadata = (0, $cc0188753ac1c798$export$4950aa0f605343fb)(data.sdkProcessingMetadata, sdkProcessingMetadata, 2);
    if (level) data.level = level;
    if (transactionName) data.transactionName = transactionName;
    if (span) data.span = span;
    if (breadcrumbs.length) data.breadcrumbs = [
        ...data.breadcrumbs,
        ...breadcrumbs
    ];
    if (fingerprint.length) data.fingerprint = [
        ...data.fingerprint,
        ...fingerprint
    ];
    if (eventProcessors.length) data.eventProcessors = [
        ...data.eventProcessors,
        ...eventProcessors
    ];
    if (attachments.length) data.attachments = [
        ...data.attachments,
        ...attachments
    ];
    data.propagationContext = {
        ...data.propagationContext,
        ...propagationContext
    };
}
/**
 * Merges certain scope data. Undefined values will overwrite any existing values.
 * Exported only for tests.
 */ function $7e9d2fc46299f0a2$export$b1a120a2871faa46(data, prop, mergeVal) {
    data[prop] = (0, $cc0188753ac1c798$export$4950aa0f605343fb)(data[prop], mergeVal, 1);
}
/**
 * Get the scope data for the current scope after merging with the
 * global scope and isolation scope.
 *
 * @param currentScope - The current scope.
 * @returns The scope data.
 */ function $7e9d2fc46299f0a2$export$cc422922fcbb91c6(isolationScope, currentScope) {
    const scopeData = (0, $6c9d57d6c1e4fcbb$export$aa55d5ab8e05984f)().getScopeData();
    isolationScope && $7e9d2fc46299f0a2$export$25ac7e259a513db4(scopeData, isolationScope.getScopeData());
    currentScope && $7e9d2fc46299f0a2$export$25ac7e259a513db4(scopeData, currentScope.getScopeData());
    return scopeData;
}
function $7e9d2fc46299f0a2$var$applyDataToEvent(event, data) {
    const { extra: extra, tags: tags, user: user, contexts: contexts, level: level, transactionName: transactionName } = data;
    if (Object.keys(extra).length) event.extra = {
        ...extra,
        ...event.extra
    };
    if (Object.keys(tags).length) event.tags = {
        ...tags,
        ...event.tags
    };
    if (Object.keys(user).length) event.user = {
        ...user,
        ...event.user
    };
    if (Object.keys(contexts).length) event.contexts = {
        ...contexts,
        ...event.contexts
    };
    if (level) event.level = level;
    // transaction events get their `transaction` from the root span name
    if (transactionName && event.type !== 'transaction') event.transaction = transactionName;
}
function $7e9d2fc46299f0a2$var$applyBreadcrumbsToEvent(event, breadcrumbs) {
    const mergedBreadcrumbs = [
        ...event.breadcrumbs || [],
        ...breadcrumbs
    ];
    event.breadcrumbs = mergedBreadcrumbs.length ? mergedBreadcrumbs : undefined;
}
function $7e9d2fc46299f0a2$var$applySdkMetadataToEvent(event, sdkProcessingMetadata) {
    event.sdkProcessingMetadata = {
        ...event.sdkProcessingMetadata,
        ...sdkProcessingMetadata
    };
}
function $7e9d2fc46299f0a2$var$applySpanToEvent(event, span) {
    event.contexts = {
        trace: (0, $cdd7dc1c144c1b85$export$46c6fbd1d265ebf0)(span),
        ...event.contexts
    };
    event.sdkProcessingMetadata = {
        dynamicSamplingContext: (0, $e7797a74bdf55fda$export$a117f995597e25df)(span),
        ...event.sdkProcessingMetadata
    };
    const rootSpan = (0, $cdd7dc1c144c1b85$export$c4c6a79b1260ca1b)(span);
    const transactionName = (0, $cdd7dc1c144c1b85$export$92d8c23565496537)(rootSpan).description;
    if (transactionName && !event.transaction && event.type === 'transaction') event.transaction = transactionName;
}
/**
 * Applies fingerprint from the scope to the event if there's one,
 * uses message if there's one instead or get rid of empty fingerprint
 */ function $7e9d2fc46299f0a2$var$applyFingerprintToEvent(event, fingerprint) {
    // Make sure it's an array first and we actually have something in place
    event.fingerprint = event.fingerprint ? Array.isArray(event.fingerprint) ? event.fingerprint : [
        event.fingerprint
    ] : [];
    // If we have something on the scope, then merge it with event
    if (fingerprint) event.fingerprint = event.fingerprint.concat(fingerprint);
    // If we have no data at all, remove empty array default
    if (!event.fingerprint.length) delete event.fingerprint;
}




const $6d32bb94f5a13cd9$var$SEQUENCE_ATTR_KEY = 'sentry.timestamp.sequence';
let $6d32bb94f5a13cd9$var$_sequenceNumber = 0;
let $6d32bb94f5a13cd9$var$_previousTimestampMs;
/**
 * Returns the `sentry.timestamp.sequence` attribute entry for a serialized telemetry item.
 *
 * The sequence number starts at 0 and increments by 1 for each item captured.
 * It resets to 0 when the current item's integer millisecond timestamp differs
 * from the previous item's integer millisecond timestamp.
 *
 * @param timestampInSeconds - The timestamp of the telemetry item in seconds.
 */ function $6d32bb94f5a13cd9$export$63ada7b125d23ef9(timestampInSeconds) {
    const nowMs = Math.floor(timestampInSeconds * 1000);
    if ($6d32bb94f5a13cd9$var$_previousTimestampMs !== undefined && nowMs !== $6d32bb94f5a13cd9$var$_previousTimestampMs) $6d32bb94f5a13cd9$var$_sequenceNumber = 0;
    const value = $6d32bb94f5a13cd9$var$_sequenceNumber;
    $6d32bb94f5a13cd9$var$_sequenceNumber++;
    $6d32bb94f5a13cd9$var$_previousTimestampMs = nowMs;
    return {
        key: $6d32bb94f5a13cd9$var$SEQUENCE_ATTR_KEY,
        value: {
            value: value,
            type: 'integer'
        }
    };
}





/** Extract trace information from scope */ function $03b7d18806c57756$export$fb7d833b3fdedf5f(client, scope) {
    if (!scope) return [
        undefined,
        undefined
    ];
    return (0, $6c9d57d6c1e4fcbb$export$ec58d9285c204497)(scope, ()=>{
        const span = (0, $cdd7dc1c144c1b85$export$1be426a8e585c83e)();
        const traceContext = span ? (0, $cdd7dc1c144c1b85$export$46c6fbd1d265ebf0)(span) : (0, $6c9d57d6c1e4fcbb$export$1e83db7ee4876dc4)(scope);
        const dynamicSamplingContext = span ? (0, $e7797a74bdf55fda$export$a117f995597e25df)(span) : (0, $e7797a74bdf55fda$export$89ef1736f08c6b2b)(client, scope);
        return [
            dynamicSamplingContext,
            traceContext
        ];
    });
}


/**
 * Maps a log severity level to a log severity number.
 *
 * @see LogSeverityLevel
 */ const $0ce033684df78776$export$4fb50c0840d636d1 = {
    trace: 1,
    debug: 5,
    info: 9,
    warn: 13,
    error: 17,
    fatal: 21
};








/**
 * Recursively normalizes the given object.
 *
 * - Creates a copy to prevent original input mutation
 * - Skips non-enumerable properties
 * - When stringifying, calls `toJSON` if implemented
 * - Removes circular references
 * - Translates non-serializable values (`undefined`/`NaN`/functions) to serializable format
 * - Translates known global objects/classes to a string representations
 * - Takes care of `Error` object serialization
 * - Optionally limits depth of final output
 * - Optionally limits number of properties/elements included in any single object/array
 *
 * @param input The object to be normalized.
 * @param depth The max depth to which to normalize the object. (Anything deeper stringified whole.)
 * @param maxProperties The max number of elements or properties to be included in any single array or
 * object in the normalized output.
 * @returns A normalized version of the object, or `"**non-serializable**"` if any errors are thrown during normalization.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $a4ca5def21866c8a$export$a3295358bff77e(input, depth = 100, maxProperties = Infinity) {
    try {
        // since we're at the outermost level, we don't provide a key
        return $a4ca5def21866c8a$var$visit('', input, depth, maxProperties);
    } catch (err) {
        return {
            ERROR: `**non-serializable** (${err})`
        };
    }
}
/** JSDoc */ function $a4ca5def21866c8a$export$23fbbb20bed71033(// eslint-disable-next-line @typescript-eslint/no-explicit-any
object, // Default Node.js REPL depth
depth = 3, // 100kB, as 200kB is max payload size, so half sounds reasonable
maxSize = 102400) {
    const normalized = $a4ca5def21866c8a$export$a3295358bff77e(object, depth);
    if ($a4ca5def21866c8a$var$jsonSize(normalized) > maxSize) return $a4ca5def21866c8a$export$23fbbb20bed71033(object, depth - 1, maxSize);
    return normalized;
}
/**
 * Visits a node to perform normalization on it
 *
 * @param key The key corresponding to the given node
 * @param value The node to be visited
 * @param depth Optional number indicating the maximum recursion depth
 * @param maxProperties Optional maximum number of properties/elements included in any single object/array
 * @param memo Optional Memo class handling decycling
 */ function $a4ca5def21866c8a$var$visit(key, value, depth = Infinity, maxProperties = Infinity, memo = $a4ca5def21866c8a$var$memoBuilder()) {
    const [memoize, unmemoize] = memo;
    // Get the simple cases out of the way first
    if (value == null || // this matches null and undefined -> eqeq not eqeqeq
    [
        'boolean',
        'string'
    ].includes(typeof value) || typeof value === 'number' && Number.isFinite(value)) return value;
    const stringified = $a4ca5def21866c8a$var$stringifyValue(key, value);
    // Anything we could potentially dig into more (objects or arrays) will have come back as `"[object XXXX]"`.
    // Everything else will have already been serialized, so if we don't see that pattern, we're done.
    if (!stringified.startsWith('[object ')) return stringified;
    // From here on, we can assert that `value` is either an object or an array.
    // Do not normalize objects that we know have already been normalized. As a general rule, the
    // "__sentry_skip_normalization__" property should only be used sparingly and only should only be set on objects that
    // have already been normalized.
    if (value['__sentry_skip_normalization__']) return value;
    // We can set `__sentry_override_normalization_depth__` on an object to ensure that from there
    // We keep a certain amount of depth.
    // This should be used sparingly, e.g. we use it for the redux integration to ensure we get a certain amount of state.
    const remainingDepth = typeof value['__sentry_override_normalization_depth__'] === 'number' ? value['__sentry_override_normalization_depth__'] : depth;
    // We're also done if we've reached the max depth
    if (remainingDepth === 0) // At this point we know `serialized` is a string of the form `"[object XXXX]"`. Clean it up so it's just `"[XXXX]"`.
    return stringified.replace('object ', '');
    // If we've already visited this branch, bail out, as it's circular reference. If not, note that we're seeing it now.
    if (memoize(value)) return '[Circular ~]';
    // If the value has a `toJSON` method, we call it to extract more information
    const valueWithToJSON = value;
    if (valueWithToJSON && typeof valueWithToJSON.toJSON === 'function') try {
        const jsonValue = valueWithToJSON.toJSON();
        // We need to normalize the return value of `.toJSON()` in case it has circular references
        return $a4ca5def21866c8a$var$visit('', jsonValue, remainingDepth - 1, maxProperties, memo);
    } catch  {
    // pass (The built-in `toJSON` failed, but we can still try to do it ourselves)
    }
    // At this point we know we either have an object or an array, we haven't seen it before, and we're going to recurse
    // because we haven't yet reached the max depth. Create an accumulator to hold the results of visiting each
    // property/entry, and keep track of the number of items we add to it.
    const normalized = Array.isArray(value) ? [] : {};
    let numAdded = 0;
    // Before we begin, convert`Error` and`Event` instances into plain objects, since some of each of their relevant
    // properties are non-enumerable and otherwise would get missed.
    const visitable = (0, $10696cb2974e7335$export$62ff257738bf57f5)(value);
    for(const visitKey in visitable){
        // Avoid iterating over fields in the prototype if they've somehow been exposed to enumeration.
        if (!Object.prototype.hasOwnProperty.call(visitable, visitKey)) continue;
        if (numAdded >= maxProperties) {
            normalized[visitKey] = '[MaxProperties ~]';
            break;
        }
        // Recursively visit all the child nodes
        const visitValue = visitable[visitKey];
        normalized[visitKey] = $a4ca5def21866c8a$var$visit(visitKey, visitValue, remainingDepth - 1, maxProperties, memo);
        numAdded++;
    }
    // Once we've visited all the branches, remove the parent from memo storage
    unmemoize(value);
    // Return accumulated values
    return normalized;
}
/* eslint-disable complexity */ /**
 * Stringify the given value. Handles various known special values and types.
 *
 * Not meant to be used on simple primitives which already have a string representation, as it will, for example, turn
 * the number 1231 into "[Object Number]", nor on `null`, as it will throw.
 *
 * @param value The value to stringify
 * @returns A stringified representation of the given value
 */ function $a4ca5def21866c8a$var$stringifyValue(key, // this type is a tiny bit of a cheat, since this function does handle NaN (which is technically a number), but for
// our internal use, it'll do
value) {
    try {
        if (key === 'domain' && value && typeof value === 'object' && value._events) return '[Domain]';
        if (key === 'domainEmitter') return '[DomainEmitter]';
        // It's safe to use `global`, `window`, and `document` here in this manner, as we are asserting using `typeof` first
        // which won't throw if they are not present.
        if (typeof $parcel$global !== 'undefined' && value === $parcel$global) return '[Global]';
        // eslint-disable-next-line no-restricted-globals
        if (typeof window !== 'undefined' && value === window) return '[Window]';
        // eslint-disable-next-line no-restricted-globals
        if (typeof document !== 'undefined' && value === document) return '[Document]';
        if ((0, $d1f309ce92d0a600$export$7916fad0ebc23f48)(value)) return (0, $d64dedd9c6b2e07c$export$b6d9c5eb2330759f)(value);
        // React's SyntheticEvent thingy
        if ((0, $d1f309ce92d0a600$export$bc2894c7158efbac)(value)) return '[SyntheticEvent]';
        if (typeof value === 'number' && !Number.isFinite(value)) return `[${value}]`;
        if (typeof value === 'function') return `[Function: ${(0, $d64dedd9c6b2e07c$export$aad197c7121a6651)(value)}]`;
        if (typeof value === 'symbol') return `[${String(value)}]`;
        // stringified BigInts are indistinguishable from regular numbers, so we need to label them to avoid confusion
        if (typeof value === 'bigint') return `[BigInt: ${String(value)}]`;
        // Now that we've knocked out all the special cases and the primitives, all we have left are objects. Simply casting
        // them to strings means that instances of classes which haven't defined their `toStringTag` will just come out as
        // `"[object Object]"`. If we instead look at the constructor's name (which is the same as the name of the class),
        // we can make sure that only plain objects come out that way.
        const objName = $a4ca5def21866c8a$var$getConstructorName(value);
        // Handle HTML Elements
        if (/^HTML(\w*)Element$/.test(objName)) return `[HTMLElement: ${objName}]`;
        return `[object ${objName}]`;
    } catch (err) {
        return `**non-serializable** (${err})`;
    }
}
/* eslint-enable complexity */ function $a4ca5def21866c8a$var$getConstructorName(value) {
    const prototype = Object.getPrototypeOf(value);
    return prototype?.constructor ? prototype.constructor.name : 'null prototype';
}
/** Calculates bytes size of input string */ function $a4ca5def21866c8a$var$utf8Length(value) {
    // eslint-disable-next-line no-bitwise
    return ~-encodeURI(value).split(/%..|./).length;
}
/** Calculates bytes size of input object */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $a4ca5def21866c8a$var$jsonSize(value) {
    return $a4ca5def21866c8a$var$utf8Length(JSON.stringify(value));
}
/**
 * Normalizes URLs in exceptions and stacktraces to a base path so Sentry can fingerprint
 * across platforms and working directory.
 *
 * @param url The URL to be normalized.
 * @param basePath The application base path.
 * @returns The normalized URL.
 */ function $a4ca5def21866c8a$export$472b29734be05be3(url, basePath) {
    const escapedBase = basePath// Backslash to forward
    .replace(/\\/g, '/')// Escape RegExp special characters
    .replace(/[|\\{}()[\]^$+*?.]/g, '\\$&');
    let newUrl = url;
    try {
        newUrl = decodeURI(url);
    } catch  {
    // Sometime this breaks
    }
    return newUrl.replace(/\\/g, '/').replace(/webpack:\/?/g, '') // Remove intermediate base path
    // oxlint-disable-next-line sdk/no-regexp-constructor
    .replace(new RegExp(`(file://)?/*${escapedBase}/*`, 'ig'), 'app:///');
}
/**
 * Helper to decycle json objects
 */ function $a4ca5def21866c8a$var$memoBuilder() {
    const inner = new WeakSet();
    function memoize(obj) {
        if (inner.has(obj)) return true;
        inner.add(obj);
        return false;
    }
    function unmemoize(obj) {
        inner.delete(obj);
    }
    return [
        memoize,
        unmemoize
    ];
}



/**
 * Creates an envelope.
 * Make sure to always explicitly provide the generic to this function
 * so that the envelope types resolve correctly.
 */ function $5db434c4f7260fa2$export$f93f7f385160c44e(headers, items = []) {
    return [
        headers,
        items
    ];
}
/**
 * Add an item to an envelope.
 * Make sure to always explicitly provide the generic to this function
 * so that the envelope types resolve correctly.
 */ function $5db434c4f7260fa2$export$d650323442802f6f(envelope, newItem) {
    const [headers, items] = envelope;
    return [
        headers,
        [
            ...items,
            newItem
        ]
    ];
}
/**
 * Convenience function to loop through the items and item types of an envelope.
 * (This function was mostly created because working with envelope types is painful at the moment)
 *
 * If the callback returns true, the rest of the items will be skipped.
 */ function $5db434c4f7260fa2$export$c56c55acf0136fd3(envelope, callback) {
    const envelopeItems = envelope[1];
    for (const envelopeItem of envelopeItems){
        const envelopeItemType = envelopeItem[0].type;
        const result = callback(envelopeItem, envelopeItemType);
        if (result) return true;
    }
    return false;
}
/**
 * Returns true if the envelope contains any of the given envelope item types
 */ function $5db434c4f7260fa2$export$604a45d95a155e2b(envelope, types) {
    return $5db434c4f7260fa2$export$c56c55acf0136fd3(envelope, (_, type)=>types.includes(type));
}
/**
 * Encode a string to UTF8 array.
 */ function $5db434c4f7260fa2$var$encodeUTF8(input) {
    const carrier = (0, $b9fc213467403976$export$c8bfa33e4e8ae492)((0, $517c5b29f882562f$export$f1a6cdb1459e81d1));
    return carrier.encodePolyfill ? carrier.encodePolyfill(input) : new TextEncoder().encode(input);
}
/**
 * Decode a UTF8 array to string.
 */ function $5db434c4f7260fa2$var$decodeUTF8(input) {
    const carrier = (0, $b9fc213467403976$export$c8bfa33e4e8ae492)((0, $517c5b29f882562f$export$f1a6cdb1459e81d1));
    return carrier.decodePolyfill ? carrier.decodePolyfill(input) : new TextDecoder().decode(input);
}
/**
 * Serializes an envelope.
 */ function $5db434c4f7260fa2$export$32f9b428425aac85(envelope) {
    const [envHeaders, items] = envelope;
    // Initially we construct our envelope as a string and only convert to binary chunks if we encounter binary data
    let parts = JSON.stringify(envHeaders);
    function append(next) {
        if (typeof parts === 'string') parts = typeof next === 'string' ? parts + next : [
            $5db434c4f7260fa2$var$encodeUTF8(parts),
            next
        ];
        else parts.push(typeof next === 'string' ? $5db434c4f7260fa2$var$encodeUTF8(next) : next);
    }
    for (const item of items){
        const [itemHeaders, payload] = item;
        append(`\n${JSON.stringify(itemHeaders)}\n`);
        if (typeof payload === 'string' || payload instanceof Uint8Array) append(payload);
        else {
            let stringifiedPayload;
            try {
                stringifiedPayload = JSON.stringify(payload);
            } catch  {
                // In case, despite all our efforts to keep `payload` circular-dependency-free, `JSON.stringify()` still
                // fails, we try again after normalizing it again with infinite normalization depth. This of course has a
                // performance impact but in this case a performance hit is better than throwing.
                stringifiedPayload = JSON.stringify((0, $a4ca5def21866c8a$export$a3295358bff77e)(payload));
            }
            append(stringifiedPayload);
        }
    }
    return typeof parts === 'string' ? parts : $5db434c4f7260fa2$var$concatBuffers(parts);
}
function $5db434c4f7260fa2$var$concatBuffers(buffers) {
    const totalLength = buffers.reduce((acc, buf)=>acc + buf.length, 0);
    const merged = new Uint8Array(totalLength);
    let offset = 0;
    for (const buffer of buffers){
        merged.set(buffer, offset);
        offset += buffer.length;
    }
    return merged;
}
/**
 * Parses an envelope
 */ function $5db434c4f7260fa2$export$3338d0c7b6e17a2b(env) {
    let buffer = typeof env === 'string' ? $5db434c4f7260fa2$var$encodeUTF8(env) : env;
    function readBinary(length) {
        const bin = buffer.subarray(0, length);
        // Replace the buffer with the remaining data excluding trailing newline
        buffer = buffer.subarray(length + 1);
        return bin;
    }
    function readJson() {
        let i = buffer.indexOf(0xa);
        // If we couldn't find a newline, we must have found the end of the buffer
        if (i < 0) i = buffer.length;
        return JSON.parse($5db434c4f7260fa2$var$decodeUTF8(readBinary(i)));
    }
    const envelopeHeader = readJson();
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const items = [];
    while(buffer.length){
        const itemHeader = readJson();
        const binaryLength = typeof itemHeader.length === 'number' ? itemHeader.length : undefined;
        items.push([
            itemHeader,
            binaryLength ? readBinary(binaryLength) : readJson()
        ]);
    }
    return [
        envelopeHeader,
        items
    ];
}
/**
 * Creates envelope item for a single span
 */ function $5db434c4f7260fa2$export$655cf139bc8b8afd(spanJson) {
    const spanHeaders = {
        type: 'span'
    };
    return [
        spanHeaders,
        spanJson
    ];
}
/**
 * Creates attachment envelope items
 */ function $5db434c4f7260fa2$export$d8fc80952cc31fa4(attachment) {
    const buffer = typeof attachment.data === 'string' ? $5db434c4f7260fa2$var$encodeUTF8(attachment.data) : attachment.data;
    return [
        {
            type: 'attachment',
            length: buffer.length,
            filename: attachment.filename,
            content_type: attachment.contentType,
            attachment_type: attachment.attachmentType
        },
        buffer
    ];
}
// Map of envelope item types to data categories where the category differs from the type.
// Types that map to themselves (session, attachment, transaction, profile, feedback, span, metric) fall through.
const $5db434c4f7260fa2$var$DATA_CATEGORY_OVERRIDES = {
    sessions: 'session',
    event: 'error',
    client_report: 'internal',
    user_report: 'default',
    profile_chunk: 'profile',
    replay_event: 'replay',
    replay_recording: 'replay',
    check_in: 'monitor',
    raw_security: 'security',
    log: 'log_item',
    trace_metric: 'metric'
};
function $5db434c4f7260fa2$var$_isOverriddenType(type) {
    return type in $5db434c4f7260fa2$var$DATA_CATEGORY_OVERRIDES;
}
/**
 * Maps the type of an envelope item to a data category.
 */ function $5db434c4f7260fa2$export$b11169581eeaf237(type) {
    return $5db434c4f7260fa2$var$_isOverriddenType(type) ? $5db434c4f7260fa2$var$DATA_CATEGORY_OVERRIDES[type] : type;
}
/** Extracts the minimal SDK info from the metadata or an events */ function $5db434c4f7260fa2$export$d369f3b2758f6743(metadataOrEvent) {
    if (!metadataOrEvent?.sdk) return;
    const { name: name, version: version } = metadataOrEvent.sdk;
    return {
        name: name,
        version: version
    };
}
/**
 * Creates event envelope headers, based on event, sdk info and tunnel
 * Note: This function was extracted from the core package to make it available in Replay
 */ function $5db434c4f7260fa2$export$92b6093782fe661b(event, sdkInfo, tunnel, dsn) {
    const dynamicSamplingContext = event.sdkProcessingMetadata?.dynamicSamplingContext;
    return {
        event_id: event.event_id,
        sent_at: new Date().toISOString(),
        ...sdkInfo && {
            sdk: sdkInfo
        },
        ...!!tunnel && dsn && {
            dsn: (0, $a6fcb45f188ebaa3$export$44d472fbb931a776)(dsn)
        },
        ...dynamicSamplingContext && {
            trace: dynamicSamplingContext
        }
    };
}


/**
 * Creates a log container envelope item for a list of logs.
 *
 * @param items - The logs to include in the envelope.
 * @returns The created log container envelope item.
 */ function $10a8462dc3b338da$export$efdf3b13edb1118e(items) {
    return [
        {
            type: 'log',
            item_count: items.length,
            content_type: 'application/vnd.sentry.items.log+json'
        },
        {
            items: items
        }
    ];
}
/**
 * Creates an envelope for a list of logs.
 *
 * Logs from multiple traces can be included in the same envelope.
 *
 * @param logs - The logs to include in the envelope.
 * @param metadata - The metadata to include in the envelope.
 * @param tunnel - The tunnel to include in the envelope.
 * @param dsn - The DSN to include in the envelope.
 * @returns The created envelope.
 */ function $10a8462dc3b338da$export$cdcd668e6516443f(logs, metadata, tunnel, dsn) {
    const headers = {};
    if (metadata?.sdk) headers.sdk = {
        name: metadata.sdk.name,
        version: metadata.sdk.version
    };
    if (!!tunnel && !!dsn) headers.dsn = (0, $a6fcb45f188ebaa3$export$44d472fbb931a776)(dsn);
    return (0, $5db434c4f7260fa2$export$f93f7f385160c44e)(headers, [
        $10a8462dc3b338da$export$efdf3b13edb1118e(logs)
    ]);
}


const $1b5f53d516745d9f$var$MAX_LOG_BUFFER_SIZE = 100;
/**
 * Sets a log attribute if the value exists and the attribute key is not already present.
 *
 * @param logAttributes - The log attributes object to modify.
 * @param key - The attribute key to set.
 * @param value - The value to set (only sets if truthy and key not present).
 * @param setEvenIfPresent - Whether to set the attribute if it is present. Defaults to true.
 */ function $1b5f53d516745d9f$var$setLogAttribute(logAttributes, key, value, setEvenIfPresent = true) {
    if (value && (!logAttributes[key] || setEvenIfPresent)) logAttributes[key] = value;
}
/**
 * Captures a serialized log event and adds it to the log buffer for the given client.
 *
 * @param client - A client. Uses the current client if not provided.
 * @param serializedLog - The serialized log event to capture.
 *
 * @experimental This method will experience breaking changes. This is not yet part of
 * the stable Sentry SDK API and can be changed or removed without warning.
 */ function $1b5f53d516745d9f$export$743ba6f7ec19225f(client, serializedLog) {
    const bufferMap = $1b5f53d516745d9f$var$_getBufferMap();
    const logBuffer = $1b5f53d516745d9f$export$5365c9902fb9e770(client);
    if (logBuffer === undefined) bufferMap.set(client, [
        serializedLog
    ]);
    else if (logBuffer.length >= $1b5f53d516745d9f$var$MAX_LOG_BUFFER_SIZE) {
        $1b5f53d516745d9f$export$f8ed83d3b6a0b504(client, logBuffer);
        bufferMap.set(client, [
            serializedLog
        ]);
    } else bufferMap.set(client, [
        ...logBuffer,
        serializedLog
    ]);
}
/**
 * Captures a log event and sends it to Sentry.
 *
 * @param log - The log event to capture.
 * @param scope - A scope. Uses the current scope if not provided.
 * @param client - A client. Uses the current client if not provided.
 * @param captureSerializedLog - A function to capture the serialized log.
 *
 * @experimental This method will experience breaking changes. This is not yet part of
 * the stable Sentry SDK API and can be changed or removed without warning.
 */ function $1b5f53d516745d9f$export$3ab3d16b9eebd986(beforeLog, currentScope = (0, $6c9d57d6c1e4fcbb$export$c7be4b0125a10cba)(), captureSerializedLog = $1b5f53d516745d9f$export$743ba6f7ec19225f) {
    const client = currentScope?.getClient() ?? (0, $6c9d57d6c1e4fcbb$export$6bb76d6eba7e258c)();
    if (!client) {
        (0, $6d193f2c2b007873$export$16a28057038b10ef) && (0, $6ed5aee3203eab87$export$1c9f709888824e05).warn('No client available to capture log.');
        return;
    }
    const { release: release, environment: environment, enableLogs: enableLogs = false, beforeSendLog: beforeSendLog } = client.getOptions();
    if (!enableLogs) {
        (0, $6d193f2c2b007873$export$16a28057038b10ef) && (0, $6ed5aee3203eab87$export$1c9f709888824e05).warn('logging option not enabled, log will not be captured.');
        return;
    }
    const [, traceContext] = (0, $03b7d18806c57756$export$fb7d833b3fdedf5f)(client, currentScope);
    const processedLogAttributes = {
        ...beforeLog.attributes
    };
    const { user: { id: id, email: email, username: username }, attributes: scopeAttributes = {} } = (0, $7e9d2fc46299f0a2$export$cc422922fcbb91c6)((0, $6c9d57d6c1e4fcbb$export$68f3af03034c9e90)(), currentScope);
    $1b5f53d516745d9f$var$setLogAttribute(processedLogAttributes, 'user.id', id, false);
    $1b5f53d516745d9f$var$setLogAttribute(processedLogAttributes, 'user.email', email, false);
    $1b5f53d516745d9f$var$setLogAttribute(processedLogAttributes, 'user.name', username, false);
    $1b5f53d516745d9f$var$setLogAttribute(processedLogAttributes, 'sentry.release', release);
    $1b5f53d516745d9f$var$setLogAttribute(processedLogAttributes, 'sentry.environment', environment);
    const { name: name, version: version } = client.getSdkMetadata()?.sdk ?? {};
    $1b5f53d516745d9f$var$setLogAttribute(processedLogAttributes, 'sentry.sdk.name', name);
    $1b5f53d516745d9f$var$setLogAttribute(processedLogAttributes, 'sentry.sdk.version', version);
    const replay = client.getIntegrationByName('Replay');
    const replayId = replay?.getReplayId(true);
    $1b5f53d516745d9f$var$setLogAttribute(processedLogAttributes, 'sentry.replay_id', replayId);
    if (replayId && replay?.getRecordingMode() === 'buffer') // We send this so we can identify cases where the replayId is attached but the replay itself might not have been sent to Sentry
    $1b5f53d516745d9f$var$setLogAttribute(processedLogAttributes, 'sentry._internal.replay_is_buffering', true);
    const beforeLogMessage = beforeLog.message;
    if ((0, $d1f309ce92d0a600$export$dbcbffa59149b824)(beforeLogMessage)) {
        const { __sentry_template_string__: __sentry_template_string__, __sentry_template_values__: __sentry_template_values__ = [] } = beforeLogMessage;
        if (__sentry_template_values__?.length) processedLogAttributes['sentry.message.template'] = __sentry_template_string__;
        __sentry_template_values__.forEach((param, index)=>{
            processedLogAttributes[`sentry.message.parameter.${index}`] = param;
        });
    }
    const span = (0, $18f1bf9c6bfa5b9e$export$91f063ebb8eff307)(currentScope);
    // Add the parent span ID to the log attributes for trace context
    $1b5f53d516745d9f$var$setLogAttribute(processedLogAttributes, 'sentry.trace.parent_span_id', span?.spanContext().spanId);
    const processedLog = {
        ...beforeLog,
        attributes: processedLogAttributes
    };
    client.emit('beforeCaptureLog', processedLog);
    // We need to wrap this in `consoleSandbox` to avoid recursive calls to `beforeSendLog`
    const log = beforeSendLog ? (0, $6ed5aee3203eab87$export$cda52e2a8927a2ca)(()=>beforeSendLog(processedLog)) : processedLog;
    if (!log) {
        client.recordDroppedEvent('before_send', 'log_item', 1);
        (0, $6d193f2c2b007873$export$16a28057038b10ef) && (0, $6ed5aee3203eab87$export$1c9f709888824e05).warn('beforeSendLog returned null, log will not be captured.');
        return;
    }
    const { level: level, message: message, attributes: logAttributes = {}, severityNumber: severityNumber } = log;
    const timestamp = (0, $27fab3c4acc6cd95$export$ee52dced521e3e18)();
    const sequenceAttr = (0, $6d32bb94f5a13cd9$export$63ada7b125d23ef9)(timestamp);
    const serializedLog = {
        timestamp: timestamp,
        level: level,
        body: message,
        trace_id: traceContext?.trace_id,
        severity_number: severityNumber ?? (0, $0ce033684df78776$export$4fb50c0840d636d1)[level],
        attributes: {
            ...(0, $78177fa8d256e3ec$export$4954cae66e755861)(scopeAttributes),
            ...(0, $78177fa8d256e3ec$export$4954cae66e755861)(logAttributes, true),
            [sequenceAttr.key]: sequenceAttr.value
        }
    };
    captureSerializedLog(client, serializedLog);
    client.emit('afterCaptureLog', log);
}
/**
 * Flushes the logs buffer to Sentry.
 *
 * @param client - A client.
 * @param maybeLogBuffer - A log buffer. Uses the log buffer for the given client if not provided.
 *
 * @experimental This method will experience breaking changes. This is not yet part of
 * the stable Sentry SDK API and can be changed or removed without warning.
 */ function $1b5f53d516745d9f$export$f8ed83d3b6a0b504(client, maybeLogBuffer) {
    const logBuffer = maybeLogBuffer ?? $1b5f53d516745d9f$export$5365c9902fb9e770(client) ?? [];
    if (logBuffer.length === 0) return;
    const clientOptions = client.getOptions();
    const envelope = (0, $10a8462dc3b338da$export$cdcd668e6516443f)(logBuffer, clientOptions._metadata, clientOptions.tunnel, client.getDsn());
    // Clear the log buffer after envelopes have been constructed.
    $1b5f53d516745d9f$var$_getBufferMap().set(client, []);
    client.emit('flushLogs');
    // sendEnvelope should not throw
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    client.sendEnvelope(envelope);
}
/**
 * Returns the log buffer for a given client.
 *
 * Exported for testing purposes.
 *
 * @param client - The client to get the log buffer for.
 * @returns The log buffer for the given client.
 */ function $1b5f53d516745d9f$export$5365c9902fb9e770(client) {
    return $1b5f53d516745d9f$var$_getBufferMap().get(client);
}
function $1b5f53d516745d9f$var$_getBufferMap() {
    // The reference to the Client <> LogBuffer map is stored on the carrier to ensure it's always the same
    return (0, $b9fc213467403976$export$7e223ec222791509)('clientToLogBufferMap', ()=>new WeakMap());
}













/**
 * Creates a metric container envelope item for a list of metrics.
 *
 * @param items - The metrics to include in the envelope.
 * @returns The created metric container envelope item.
 */ function $af4761840f27252f$export$58e45eb52ad1077d(items) {
    return [
        {
            type: 'trace_metric',
            item_count: items.length,
            content_type: 'application/vnd.sentry.items.trace-metric+json'
        },
        {
            items: items
        }
    ];
}
/**
 * Creates an envelope for a list of metrics.
 *
 * Metrics from multiple traces can be included in the same envelope.
 *
 * @param metrics - The metrics to include in the envelope.
 * @param metadata - The metadata to include in the envelope.
 * @param tunnel - The tunnel to include in the envelope.
 * @param dsn - The DSN to include in the envelope.
 * @returns The created envelope.
 */ function $af4761840f27252f$export$f23eb96e33154901(metrics, metadata, tunnel, dsn) {
    const headers = {};
    if (metadata?.sdk) headers.sdk = {
        name: metadata.sdk.name,
        version: metadata.sdk.version
    };
    if (!!tunnel && !!dsn) headers.dsn = (0, $a6fcb45f188ebaa3$export$44d472fbb931a776)(dsn);
    return (0, $5db434c4f7260fa2$export$f93f7f385160c44e)(headers, [
        $af4761840f27252f$export$58e45eb52ad1077d(metrics)
    ]);
}


const $c7fd3bed22ef46d6$var$MAX_METRIC_BUFFER_SIZE = 1000;
/**
 * Sets a metric attribute if the value exists and the attribute key is not already present.
 *
 * @param metricAttributes - The metric attributes object to modify.
 * @param key - The attribute key to set.
 * @param value - The value to set (only sets if truthy and key not present).
 * @param setEvenIfPresent - Whether to set the attribute if it is present. Defaults to true.
 */ function $c7fd3bed22ef46d6$var$setMetricAttribute(metricAttributes, key, value, setEvenIfPresent = true) {
    if (value && (setEvenIfPresent || !(key in metricAttributes))) metricAttributes[key] = value;
}
/**
 * Captures a serialized metric event and adds it to the metric buffer for the given client.
 *
 * @param client - A client. Uses the current client if not provided.
 * @param serializedMetric - The serialized metric event to capture.
 *
 * @experimental This method will experience breaking changes. This is not yet part of
 * the stable Sentry SDK API and can be changed or removed without warning.
 */ function $c7fd3bed22ef46d6$export$84661fd26e6cac96(client, serializedMetric) {
    const bufferMap = $c7fd3bed22ef46d6$var$_getBufferMap();
    const metricBuffer = $c7fd3bed22ef46d6$export$49385134251b08ff(client);
    if (metricBuffer === undefined) bufferMap.set(client, [
        serializedMetric
    ]);
    else if (metricBuffer.length >= $c7fd3bed22ef46d6$var$MAX_METRIC_BUFFER_SIZE) {
        $c7fd3bed22ef46d6$export$91c9ef254b7d0f67(client, metricBuffer);
        bufferMap.set(client, [
            serializedMetric
        ]);
    } else bufferMap.set(client, [
        ...metricBuffer,
        serializedMetric
    ]);
}
/**
 * Options for capturing a metric internally.
 */ /**
 * Enriches metric with all contextual attributes (user, SDK metadata, replay, etc.)
 */ function $c7fd3bed22ef46d6$var$_enrichMetricAttributes(beforeMetric, client, user) {
    const { release: release, environment: environment } = client.getOptions();
    const processedMetricAttributes = {
        ...beforeMetric.attributes
    };
    // Add user attributes
    $c7fd3bed22ef46d6$var$setMetricAttribute(processedMetricAttributes, 'user.id', user.id, false);
    $c7fd3bed22ef46d6$var$setMetricAttribute(processedMetricAttributes, 'user.email', user.email, false);
    $c7fd3bed22ef46d6$var$setMetricAttribute(processedMetricAttributes, 'user.name', user.username, false);
    // Add Sentry metadata
    $c7fd3bed22ef46d6$var$setMetricAttribute(processedMetricAttributes, 'sentry.release', release);
    $c7fd3bed22ef46d6$var$setMetricAttribute(processedMetricAttributes, 'sentry.environment', environment);
    // Add SDK metadata
    const { name: name, version: version } = client.getSdkMetadata()?.sdk ?? {};
    $c7fd3bed22ef46d6$var$setMetricAttribute(processedMetricAttributes, 'sentry.sdk.name', name);
    $c7fd3bed22ef46d6$var$setMetricAttribute(processedMetricAttributes, 'sentry.sdk.version', version);
    // Add replay metadata
    const replay = client.getIntegrationByName('Replay');
    const replayId = replay?.getReplayId(true);
    $c7fd3bed22ef46d6$var$setMetricAttribute(processedMetricAttributes, 'sentry.replay_id', replayId);
    if (replayId && replay?.getRecordingMode() === 'buffer') $c7fd3bed22ef46d6$var$setMetricAttribute(processedMetricAttributes, 'sentry._internal.replay_is_buffering', true);
    return {
        ...beforeMetric,
        attributes: processedMetricAttributes
    };
}
/**
 * Creates a serialized metric ready to be sent to Sentry.
 */ function $c7fd3bed22ef46d6$var$_buildSerializedMetric(metric, client, currentScope, scopeAttributes) {
    // Get trace context
    const [, traceContext] = (0, $03b7d18806c57756$export$fb7d833b3fdedf5f)(client, currentScope);
    const span = (0, $18f1bf9c6bfa5b9e$export$91f063ebb8eff307)(currentScope);
    const traceId = span ? span.spanContext().traceId : traceContext?.trace_id;
    const spanId = span ? span.spanContext().spanId : undefined;
    const timestamp = (0, $27fab3c4acc6cd95$export$ee52dced521e3e18)();
    const sequenceAttr = (0, $6d32bb94f5a13cd9$export$63ada7b125d23ef9)(timestamp);
    return {
        timestamp: timestamp,
        trace_id: traceId ?? '',
        span_id: spanId,
        name: metric.name,
        type: metric.type,
        unit: metric.unit,
        value: metric.value,
        attributes: {
            ...(0, $78177fa8d256e3ec$export$4954cae66e755861)(scopeAttributes),
            ...(0, $78177fa8d256e3ec$export$4954cae66e755861)(metric.attributes, 'skip-undefined'),
            [sequenceAttr.key]: sequenceAttr.value
        }
    };
}
/**
 * Captures a metric event and sends it to Sentry.
 *
 * @param metric - The metric event to capture.
 * @param options - Options for capturing the metric.
 *
 * @experimental This method will experience breaking changes. This is not yet part of
 * the stable Sentry SDK API and can be changed or removed without warning.
 */ function $c7fd3bed22ef46d6$export$288d896e6652e0c4(beforeMetric, options) {
    const currentScope = options?.scope ?? (0, $6c9d57d6c1e4fcbb$export$c7be4b0125a10cba)();
    const captureSerializedMetric = options?.captureSerializedMetric ?? $c7fd3bed22ef46d6$export$84661fd26e6cac96;
    const client = currentScope?.getClient() ?? (0, $6c9d57d6c1e4fcbb$export$6bb76d6eba7e258c)();
    if (!client) {
        (0, $6d193f2c2b007873$export$16a28057038b10ef) && (0, $6ed5aee3203eab87$export$1c9f709888824e05).warn('No client available to capture metric.');
        return;
    }
    const { _experiments: _experiments, enableMetrics: enableMetrics, beforeSendMetric: beforeSendMetric } = client.getOptions();
    // todo(v11): Remove the experimental flag
    // eslint-disable-next-line deprecation/deprecation
    const metricsEnabled = enableMetrics ?? _experiments?.enableMetrics ?? true;
    if (!metricsEnabled) {
        (0, $6d193f2c2b007873$export$16a28057038b10ef) && (0, $6ed5aee3203eab87$export$1c9f709888824e05).warn('metrics option not enabled, metric will not be captured.');
        return;
    }
    // Enrich metric with contextual attributes
    const { user: user, attributes: scopeAttributes } = (0, $7e9d2fc46299f0a2$export$cc422922fcbb91c6)((0, $6c9d57d6c1e4fcbb$export$68f3af03034c9e90)(), currentScope);
    const enrichedMetric = $c7fd3bed22ef46d6$var$_enrichMetricAttributes(beforeMetric, client, user);
    client.emit('processMetric', enrichedMetric);
    // todo(v11): Remove the experimental `beforeSendMetric`
    // eslint-disable-next-line deprecation/deprecation
    const beforeSendCallback = beforeSendMetric || _experiments?.beforeSendMetric;
    const processedMetric = beforeSendCallback ? beforeSendCallback(enrichedMetric) : enrichedMetric;
    if (!processedMetric) {
        (0, $6d193f2c2b007873$export$16a28057038b10ef) && (0, $6ed5aee3203eab87$export$1c9f709888824e05).log('`beforeSendMetric` returned `null`, will not send metric.');
        return;
    }
    const serializedMetric = $c7fd3bed22ef46d6$var$_buildSerializedMetric(processedMetric, client, currentScope, scopeAttributes);
    (0, $6d193f2c2b007873$export$16a28057038b10ef) && (0, $6ed5aee3203eab87$export$1c9f709888824e05).log('[Metric]', serializedMetric);
    captureSerializedMetric(client, serializedMetric);
    client.emit('afterCaptureMetric', processedMetric);
}
/**
 * Flushes the metrics buffer to Sentry.
 *
 * @param client - A client.
 * @param maybeMetricBuffer - A metric buffer. Uses the metric buffer for the given client if not provided.
 *
 * @experimental This method will experience breaking changes. This is not yet part of
 * the stable Sentry SDK API and can be changed or removed without warning.
 */ function $c7fd3bed22ef46d6$export$91c9ef254b7d0f67(client, maybeMetricBuffer) {
    const metricBuffer = maybeMetricBuffer ?? $c7fd3bed22ef46d6$export$49385134251b08ff(client) ?? [];
    if (metricBuffer.length === 0) return;
    const clientOptions = client.getOptions();
    const envelope = (0, $af4761840f27252f$export$f23eb96e33154901)(metricBuffer, clientOptions._metadata, clientOptions.tunnel, client.getDsn());
    // Clear the metric buffer after envelopes have been constructed.
    $c7fd3bed22ef46d6$var$_getBufferMap().set(client, []);
    client.emit('flushMetrics');
    // sendEnvelope should not throw
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    client.sendEnvelope(envelope);
}
/**
 * Returns the metric buffer for a given client.
 *
 * Exported for testing purposes.
 *
 * @param client - The client to get the metric buffer for.
 * @returns The metric buffer for the given client.
 */ function $c7fd3bed22ef46d6$export$49385134251b08ff(client) {
    return $c7fd3bed22ef46d6$var$_getBufferMap().get(client);
}
function $c7fd3bed22ef46d6$var$_getBufferMap() {
    // The reference to the Client <> MetricBuffer map is stored on the carrier to ensure it's always the same
    return (0, $b9fc213467403976$export$7e223ec222791509)('clientToMetricBufferMap', ()=>new WeakMap());
}

// By default, we want to infer the IP address, unless this is explicitly set to `null`
// We do this after all other processing is done
// If `ip_address` is explicitly set to `null` or a value, we leave it as is
/**
 * @internal
 * @deprecated -- set ip inferral via via SDK metadata options on client instead.
 */ function $06a9701a51a9358a$export$3e12ad68afa434ac(objWithMaybeUser) {
    if (objWithMaybeUser.user?.ip_address === undefined) objWithMaybeUser.user = {
        ...objWithMaybeUser.user,
        ip_address: '{{auto}}'
    };
}
/**
 * @internal
 */ function $06a9701a51a9358a$export$e8e2d07ba63e2b6c(session) {
    if ('aggregates' in session) {
        if (session.attrs?.['ip_address'] === undefined) session.attrs = {
            ...session.attrs,
            ip_address: '{{auto}}'
        };
    } else if (session.ipAddress === undefined) session.ipAddress = '{{auto}}';
}


/**
 * A builder for the SDK metadata in the options for the SDK initialization.
 *
 * Note: This function is identical to `buildMetadata` in Remix and NextJS and SvelteKit.
 * We don't extract it for bundle size reasons.
 * @see https://github.com/getsentry/sentry-javascript/pull/7404
 * @see https://github.com/getsentry/sentry-javascript/pull/4196
 *
 * If you make changes to this function consider updating the others as well.
 *
 * @param options SDK options object that gets mutated
 * @param names list of package names
 */ function $fe6e91a50d880076$export$b9f95b027256052c(options, name, names = [
    name
], source = 'npm') {
    const sdk = (options._metadata = options._metadata || {}).sdk = options._metadata.sdk || {};
    if (!sdk.name) {
        sdk.name = `sentry.javascript.${name}`;
        sdk.packages = names.map((name)=>({
                name: `${source}:@sentry/${name}`,
                version: (0, $4726de1158d3534e$export$31499a9cd224b78c)
            }));
        sdk.version = (0, $4726de1158d3534e$export$31499a9cd224b78c);
    }
}


const $6cab12468635632a$export$9207631ea4ce5c48 = '7';
/** Returns the prefix to construct Sentry ingestion API endpoints. */ function $6cab12468635632a$var$getBaseApiEndpoint(dsn) {
    const protocol = dsn.protocol ? `${dsn.protocol}:` : '';
    const port = dsn.port ? `:${dsn.port}` : '';
    return `${protocol}//${dsn.host}${port}${dsn.path ? `/${dsn.path}` : ''}/api/`;
}
/** Returns the ingest API endpoint for target. */ function $6cab12468635632a$var$_getIngestEndpoint(dsn) {
    return `${$6cab12468635632a$var$getBaseApiEndpoint(dsn)}${dsn.projectId}/envelope/`;
}
/** Returns a URL-encoded string with auth config suitable for a query string. */ function $6cab12468635632a$var$_encodedAuth(dsn, sdkInfo) {
    const params = {
        sentry_version: $6cab12468635632a$export$9207631ea4ce5c48
    };
    if (dsn.publicKey) // We send only the minimum set of required information. See
    // https://github.com/getsentry/sentry-javascript/issues/2572.
    params.sentry_key = dsn.publicKey;
    if (sdkInfo) params.sentry_client = `${sdkInfo.name}/${sdkInfo.version}`;
    return new URLSearchParams(params).toString();
}
/**
 * Returns the envelope endpoint URL with auth in the query string.
 *
 * Sending auth as part of the query string and not as custom HTTP headers avoids CORS preflight requests.
 */ function $6cab12468635632a$export$9964600bfe84e6a3(dsn, tunnel, sdkInfo) {
    return tunnel ? tunnel : `${$6cab12468635632a$var$_getIngestEndpoint(dsn)}?${$6cab12468635632a$var$_encodedAuth(dsn, sdkInfo)}`;
}
/** Returns the url to the report dialog endpoint. */ function $6cab12468635632a$export$671c7ed8e40a7a57(dsnLike, dialogOptions) {
    const dsn = (0, $a6fcb45f188ebaa3$export$128827c3562ec0cb)(dsnLike);
    if (!dsn) return '';
    const endpoint = `${$6cab12468635632a$var$getBaseApiEndpoint(dsn)}embed/error-page/`;
    let encodedOptions = `dsn=${(0, $a6fcb45f188ebaa3$export$44d472fbb931a776)(dsn)}`;
    for(const key in dialogOptions){
        if (key === 'dsn') continue;
        if (key === 'onClose') continue;
        if (key === 'user') {
            const user = dialogOptions.user;
            if (!user) continue;
            if (user.name) encodedOptions += `&name=${encodeURIComponent(user.name)}`;
            if (user.email) encodedOptions += `&email=${encodeURIComponent(user.email)}`;
        } else encodedOptions += `&${encodeURIComponent(key)}=${encodeURIComponent(dialogOptions[key])}`;
    }
    return `${endpoint}?${encodedOptions}`;
}







/**
 * A wrapper to use the new span format in your `beforeSendSpan` callback.
 *
 * When using `traceLifecycle: 'stream'`, wrap your callback with this function
 * to receive and return {@link StreamedSpanJSON} instead of the standard {@link SpanJSON}.
 *
 * @example
 *
 * Sentry.init({
 *   traceLifecycle: 'stream',
 *   beforeSendSpan: withStreamedSpan((span) => {
 *     // span is of type StreamedSpanJSON
 *     return span;
 *   }),
 * });
 *
 * @param callback - The callback function that receives and returns a {@link StreamedSpanJSON}.
 * @returns A callback that is compatible with the `beforeSendSpan` option when using `traceLifecycle: 'stream'`.
 */ function $293b68f2928b71c3$export$d3f49b33a1f44720(callback) {
    (0, $10696cb2974e7335$export$e73679ffaf56810e)(callback, '_streamed', true);
    return callback;
}
/**
 * Typesafe check to identify if a `beforeSendSpan` callback expects the streamed span JSON format.
 *
 * @param callback - The `beforeSendSpan` callback to check.
 * @returns `true` if the callback was wrapped with {@link withStreamedSpan}.
 */ function $293b68f2928b71c3$export$ca3e1ec3cdcc76ac(callback) {
    return !!callback && typeof callback === 'function' && '_streamed' in callback && !!callback._streamed;
}







function $bdbac37f17ad9b0f$var$logIgnoredSpan(droppedSpan) {
    (0, $6ed5aee3203eab87$export$1c9f709888824e05).log(`Ignoring span ${droppedSpan.op} - ${droppedSpan.description} because it matches \`ignoreSpans\`.`);
}
/**
 * Check if a span should be ignored based on the ignoreSpans configuration.
 */ function $bdbac37f17ad9b0f$export$5d569ac97c389400(span, ignoreSpans) {
    if (!ignoreSpans?.length || !span.description) return false;
    for (const pattern of ignoreSpans){
        if ($bdbac37f17ad9b0f$var$isStringOrRegExp(pattern)) {
            if ((0, $5b085f0f99265e84$export$cdded5b28a5f8c6d)(span.description, pattern)) {
                (0, $6d193f2c2b007873$export$16a28057038b10ef) && $bdbac37f17ad9b0f$var$logIgnoredSpan(span);
                return true;
            }
            continue;
        }
        if (!pattern.name && !pattern.op) continue;
        const nameMatches = pattern.name ? (0, $5b085f0f99265e84$export$cdded5b28a5f8c6d)(span.description, pattern.name) : true;
        const opMatches = pattern.op ? span.op && (0, $5b085f0f99265e84$export$cdded5b28a5f8c6d)(span.op, pattern.op) : true;
        // This check here is only correct because we can guarantee that we ran `isMatchingPattern`
        // for at least one of `nameMatches` and `opMatches`. So in contrary to how this looks,
        // not both op and name actually have to match. This is the most efficient way to check
        // for all combinations of name and op patterns.
        if (nameMatches && opMatches) {
            (0, $6d193f2c2b007873$export$16a28057038b10ef) && $bdbac37f17ad9b0f$var$logIgnoredSpan(span);
            return true;
        }
    }
    return false;
}
/**
 * Takes a list of spans, and a span that was dropped, and re-parents the child spans of the dropped span to the parent of the dropped span, if possible.
 * This mutates the spans array in place!
 */ function $bdbac37f17ad9b0f$export$ddf57376e818b444(spans, dropSpan) {
    const droppedSpanParentId = dropSpan.parent_span_id;
    const droppedSpanId = dropSpan.span_id;
    // This should generally not happen, as we do not apply this on root spans
    // but to be safe, we just bail in this case
    if (!droppedSpanParentId) return;
    for (const span of spans)if (span.parent_span_id === droppedSpanId) span.parent_span_id = droppedSpanParentId;
}
function $bdbac37f17ad9b0f$var$isStringOrRegExp(value) {
    return typeof value === 'string' || value instanceof RegExp;
}



/**
 * Apply SdkInfo (name, version, packages, integrations) to the corresponding event key.
 * Merge with existing data if any.
 *
 * @internal, exported only for testing
 **/ function $a0dbcc7684e32930$export$8a6cdb6116a9fd2b(event, newSdkInfo) {
    if (!newSdkInfo) return event;
    const eventSdkInfo = event.sdk || {};
    event.sdk = {
        ...eventSdkInfo,
        name: eventSdkInfo.name || newSdkInfo.name,
        version: eventSdkInfo.version || newSdkInfo.version,
        integrations: [
            ...event.sdk?.integrations || [],
            ...newSdkInfo.integrations || []
        ],
        packages: [
            ...event.sdk?.packages || [],
            ...newSdkInfo.packages || []
        ],
        settings: event.sdk?.settings || newSdkInfo.settings ? {
            ...event.sdk?.settings,
            ...newSdkInfo.settings
        } : undefined
    };
    return event;
}
/** Creates an envelope from a Session */ function $a0dbcc7684e32930$export$124b03c077baa2f3(session, dsn, metadata, tunnel) {
    const sdkInfo = (0, $5db434c4f7260fa2$export$d369f3b2758f6743)(metadata);
    const envelopeHeaders = {
        sent_at: new Date().toISOString(),
        ...sdkInfo && {
            sdk: sdkInfo
        },
        ...!!tunnel && dsn && {
            dsn: (0, $a6fcb45f188ebaa3$export$44d472fbb931a776)(dsn)
        }
    };
    const envelopeItem = 'aggregates' in session ? [
        {
            type: 'sessions'
        },
        session
    ] : [
        {
            type: 'session'
        },
        session.toJSON()
    ];
    return (0, $5db434c4f7260fa2$export$f93f7f385160c44e)(envelopeHeaders, [
        envelopeItem
    ]);
}
/**
 * Create an Envelope from an event.
 */ function $a0dbcc7684e32930$export$c31057337a18010f(event, dsn, metadata, tunnel) {
    const sdkInfo = (0, $5db434c4f7260fa2$export$d369f3b2758f6743)(metadata);
    /*
    Note: Due to TS, event.type may be `replay_event`, theoretically.
    In practice, we never call `createEventEnvelope` with `replay_event` type,
    and we'd have to adjust a looot of types to make this work properly.
    We want to avoid casting this around, as that could lead to bugs (e.g. when we add another type)
    So the safe choice is to really guard against the replay_event type here.
  */ const eventType = event.type && event.type !== 'replay_event' ? event.type : 'event';
    $a0dbcc7684e32930$export$8a6cdb6116a9fd2b(event, metadata?.sdk);
    const envelopeHeaders = (0, $5db434c4f7260fa2$export$92b6093782fe661b)(event, sdkInfo, tunnel, dsn);
    // Prevent this data (which, if it exists, was used in earlier steps in the processing pipeline) from being sent to
    // sentry. (Note: Our use of this property comes and goes with whatever we might be debugging, whatever hacks we may
    // have temporarily added, etc. Even if we don't happen to be using it at some point in the future, let's not get rid
    // of this `delete`, lest we miss putting it back in the next time the property is in use.)
    delete event.sdkProcessingMetadata;
    const eventItem = [
        {
            type: eventType
        },
        event
    ];
    return (0, $5db434c4f7260fa2$export$f93f7f385160c44e)(envelopeHeaders, [
        eventItem
    ]);
}
/**
 * Create envelope from Span item.
 *
 * Takes an optional client and runs spans through `beforeSendSpan` if available.
 */ function $a0dbcc7684e32930$export$19a0081d4b39d77(spans, client) {
    function dscHasRequiredProps(dsc) {
        return !!dsc.trace_id && !!dsc.public_key;
    }
    // For the moment we'll obtain the DSC from the first span in the array
    // This might need to be changed if we permit sending multiple spans from
    // different segments in one envelope
    const dsc = (0, $e7797a74bdf55fda$export$a117f995597e25df)(spans[0]);
    const dsn = client?.getDsn();
    const tunnel = client?.getOptions().tunnel;
    const headers = {
        sent_at: new Date().toISOString(),
        ...dscHasRequiredProps(dsc) && {
            trace: dsc
        },
        ...!!tunnel && dsn && {
            dsn: (0, $a6fcb45f188ebaa3$export$44d472fbb931a776)(dsn)
        }
    };
    const { beforeSendSpan: beforeSendSpan, ignoreSpans: ignoreSpans } = client?.getOptions() || {};
    const filteredSpans = ignoreSpans?.length ? spans.filter((span)=>!(0, $bdbac37f17ad9b0f$export$5d569ac97c389400)((0, $cdd7dc1c144c1b85$export$92d8c23565496537)(span), ignoreSpans)) : spans;
    const droppedSpans = spans.length - filteredSpans.length;
    if (droppedSpans) client?.recordDroppedEvent('before_send', 'span', droppedSpans);
    const convertToSpanJSON = beforeSendSpan ? (span)=>{
        const spanJson = (0, $cdd7dc1c144c1b85$export$92d8c23565496537)(span);
        const processedSpan = !(0, $293b68f2928b71c3$export$ca3e1ec3cdcc76ac)(beforeSendSpan) ? beforeSendSpan(spanJson) : spanJson;
        if (!processedSpan) {
            (0, $cdd7dc1c144c1b85$export$d11691ff45a3e535)();
            return spanJson;
        }
        return processedSpan;
    } : (0, $cdd7dc1c144c1b85$export$92d8c23565496537);
    const items = [];
    for (const span of filteredSpans){
        const spanJson = convertToSpanJSON(span);
        if (spanJson) items.push((0, $5db434c4f7260fa2$export$655cf139bc8b8afd)(spanJson));
    }
    return (0, $5db434c4f7260fa2$export$f93f7f385160c44e)(headers, items);
}












/* eslint-disable @typescript-eslint/no-explicit-any */ /** SyncPromise internal states */ const $d656c4fbd69077c0$var$STATE_PENDING = 0;
const $d656c4fbd69077c0$var$STATE_RESOLVED = 1;
const $d656c4fbd69077c0$var$STATE_REJECTED = 2;
/**
 * Creates a resolved sync promise.
 *
 * @param value the value to resolve the promise with
 * @returns the resolved sync promise
 */ function $d656c4fbd69077c0$export$1fda8aa4d135f8aa(value) {
    return new $d656c4fbd69077c0$export$6f292d4960313241((resolve)=>{
        resolve(value);
    });
}
/**
 * Creates a rejected sync promise.
 *
 * @param value the value to reject the promise with
 * @returns the rejected sync promise
 */ function $d656c4fbd69077c0$export$78e43115b553f358(reason) {
    return new $d656c4fbd69077c0$export$6f292d4960313241((_, reject)=>{
        reject(reason);
    });
}
/**
 * Thenable class that behaves like a Promise and follows it's interface
 * but is not async internally
 */ class $d656c4fbd69077c0$export$6f292d4960313241 {
    constructor(executor){
        this._state = $d656c4fbd69077c0$var$STATE_PENDING;
        this._handlers = [];
        this._runExecutor(executor);
    }
    /** @inheritdoc */ then(onfulfilled, onrejected) {
        return new $d656c4fbd69077c0$export$6f292d4960313241((resolve, reject)=>{
            this._handlers.push([
                false,
                (result)=>{
                    if (!onfulfilled) // TODO: ¯\_(ツ)_/¯
                    // TODO: FIXME
                    resolve(result);
                    else try {
                        resolve(onfulfilled(result));
                    } catch (e) {
                        reject(e);
                    }
                },
                (reason)=>{
                    if (!onrejected) reject(reason);
                    else try {
                        resolve(onrejected(reason));
                    } catch (e) {
                        reject(e);
                    }
                }
            ]);
            this._executeHandlers();
        });
    }
    /** @inheritdoc */ catch(onrejected) {
        return this.then((val)=>val, onrejected);
    }
    /** @inheritdoc */ finally(onfinally) {
        return new $d656c4fbd69077c0$export$6f292d4960313241((resolve, reject)=>{
            let val;
            let isRejected;
            return this.then((value)=>{
                isRejected = false;
                val = value;
                if (onfinally) onfinally();
            }, (reason)=>{
                isRejected = true;
                val = reason;
                if (onfinally) onfinally();
            }).then(()=>{
                if (isRejected) {
                    reject(val);
                    return;
                }
                resolve(val);
            });
        });
    }
    /** Excute the resolve/reject handlers. */ _executeHandlers() {
        if (this._state === $d656c4fbd69077c0$var$STATE_PENDING) return;
        const cachedHandlers = this._handlers.slice();
        this._handlers = [];
        cachedHandlers.forEach((handler)=>{
            if (handler[0]) return;
            if (this._state === $d656c4fbd69077c0$var$STATE_RESOLVED) handler[1](this._value);
            if (this._state === $d656c4fbd69077c0$var$STATE_REJECTED) handler[2](this._value);
            handler[0] = true;
        });
    }
    /** Run the executor for the SyncPromise. */ _runExecutor(executor) {
        const setResult = (state, value)=>{
            if (this._state !== $d656c4fbd69077c0$var$STATE_PENDING) return;
            if ((0, $d1f309ce92d0a600$export$f5b060c2914b97c8)(value)) {
                value.then(resolve, reject);
                return;
            }
            this._state = state;
            this._value = value;
            this._executeHandlers();
        };
        const resolve = (value)=>{
            setResult($d656c4fbd69077c0$var$STATE_RESOLVED, value);
        };
        const reject = (reason)=>{
            setResult($d656c4fbd69077c0$var$STATE_REJECTED, reason);
        };
        try {
            executor(resolve, reject);
        } catch (e) {
            reject(e);
        }
    }
}


/**
 * Calls `unref` on a timer, if the method is available on @param timer.
 *
 * `unref()` is used to allow processes to exit immediately, even if the timer
 * is still running and hasn't resolved yet.
 *
 * Use this in places where code can run on browser or server, since browsers
 * do not support `unref`.
 */ function $15271e1a3212eadc$export$630056cb83d87863(timer) {
    if (typeof timer === 'object' && typeof timer.unref === 'function') timer.unref();
    return timer;
}


const $1c536e651ef5e7fd$export$c8667f1887a128dc = Symbol.for('SentryBufferFullError');
/**
 * Creates an new PromiseBuffer object with the specified limit
 * @param limit max number of promises that can be stored in the buffer
 */ function $1c536e651ef5e7fd$export$85a4f67f852183e6(limit = 100) {
    const buffer = new Set();
    function isReady() {
        return buffer.size < limit;
    }
    /**
   * Remove a promise from the queue.
   *
   * @param task Can be any PromiseLike<T>
   * @returns Removed promise.
   */ function remove(task) {
        buffer.delete(task);
    }
    /**
   * Add a promise (representing an in-flight action) to the queue, and set it to remove itself on fulfillment.
   *
   * @param taskProducer A function producing any PromiseLike<T>; In previous versions this used to be `task:
   *        PromiseLike<T>`, but under that model, Promises were instantly created on the call-site and their executor
   *        functions therefore ran immediately. Thus, even if the buffer was full, the action still happened. By
   *        requiring the promise to be wrapped in a function, we can defer promise creation until after the buffer
   *        limit check.
   * @returns The original promise.
   */ function add(taskProducer) {
        if (!isReady()) return (0, $d656c4fbd69077c0$export$78e43115b553f358)($1c536e651ef5e7fd$export$c8667f1887a128dc);
        // start the task and add its promise to the queue
        const task = taskProducer();
        buffer.add(task);
        task.then(()=>remove(task), ()=>remove(task));
        return task;
    }
    /**
   * Wait for all promises in the queue to resolve or for timeout to expire, whichever comes first.
   *
   * @param timeout The time, in ms, after which to resolve to `false` if the queue is still non-empty. Passing `0` (or
   * not passing anything) will make the promise wait as long as it takes for the queue to drain before resolving to
   * `true`.
   * @returns A promise which will resolve to `true` if the queue is already empty or drains before the timeout, and
   * `false` otherwise
   */ function drain(timeout) {
        if (!buffer.size) return (0, $d656c4fbd69077c0$export$1fda8aa4d135f8aa)(true);
        // We want to resolve even if one of the promises rejects
        const drainPromise = Promise.allSettled(Array.from(buffer)).then(()=>true);
        if (!timeout) return drainPromise;
        const promises = [
            drainPromise,
            new Promise((resolve)=>(0, $15271e1a3212eadc$export$630056cb83d87863)(setTimeout(()=>resolve(false), timeout)))
        ];
        return Promise.race(promises);
    }
    return {
        get $ () {
            return Array.from(buffer);
        },
        add: add,
        drain: drain
    };
}



// Intentionally keeping the key broad, as we don't know for sure what rate limit headers get returned from backend
const $5922364681981a78$export$b09ce39faaeb1e7c = 60000; // 60 seconds
/**
 * Extracts Retry-After value from the request header or returns default value
 * @param header string representation of 'Retry-After' header
 * @param now current unix timestamp
 *
 */ function $5922364681981a78$export$615352e17ed7741(header, now = (0, $11bebf6401bbfdb9$export$65b1bada40c91b34)()) {
    const headerDelay = parseInt(`${header}`, 10);
    if (!isNaN(headerDelay)) return headerDelay * 1000;
    const headerDate = Date.parse(`${header}`);
    if (!isNaN(headerDate)) return headerDate - now;
    return $5922364681981a78$export$b09ce39faaeb1e7c;
}
/**
 * Gets the time that the given category is disabled until for rate limiting.
 * In case no category-specific limit is set but a general rate limit across all categories is active,
 * that time is returned.
 *
 * @return the time in ms that the category is disabled until or 0 if there's no active rate limit.
 */ function $5922364681981a78$export$b89fc7b2e4c799e7(limits, dataCategory) {
    return limits[dataCategory] || limits.all || 0;
}
/**
 * Checks if a category is rate limited
 */ function $5922364681981a78$export$6c91fec22056810a(limits, dataCategory, now = (0, $11bebf6401bbfdb9$export$65b1bada40c91b34)()) {
    return $5922364681981a78$export$b89fc7b2e4c799e7(limits, dataCategory) > now;
}
/**
 * Update ratelimits from incoming headers.
 *
 * @return the updated RateLimits object.
 */ function $5922364681981a78$export$699aff705e0d49d4(limits, { statusCode: statusCode, headers: headers }, now = (0, $11bebf6401bbfdb9$export$65b1bada40c91b34)()) {
    const updatedRateLimits = {
        ...limits
    };
    // "The name is case-insensitive."
    // https://developer.mozilla.org/en-US/docs/Web/API/Headers/get
    const rateLimitHeader = headers?.['x-sentry-rate-limits'];
    const retryAfterHeader = headers?.['retry-after'];
    if (rateLimitHeader) /**
     * rate limit headers are of the form
     *     <header>,<header>,..
     * where each <header> is of the form
     *     <retry_after>: <categories>: <scope>: <reason_code>: <namespaces>
     * where
     *     <retry_after> is a delay in seconds
     *     <categories> is the event type(s) (error, transaction, etc) being rate limited and is of the form
     *         <category>;<category>;...
     *     <scope> is what's being limited (org, project, or key) - ignored by SDK
     *     <reason_code> is an arbitrary string like "org_quota" - ignored by SDK
     *     <namespaces> Semicolon-separated list of metric namespace identifiers. Defines which namespace(s) will be affected.
     *         Only present if rate limit applies to the metric_bucket data category.
     */ for (const limit of rateLimitHeader.trim().split(',')){
        const [retryAfter, categories, , , namespaces] = limit.split(':', 5);
        const headerDelay = parseInt(retryAfter, 10);
        const delay = (!isNaN(headerDelay) ? headerDelay : 60) * 1000; // 60sec default
        if (!categories) updatedRateLimits.all = now + delay;
        else for (const category of categories.split(';')){
            if (category === 'metric_bucket') // namespaces will be present when category === 'metric_bucket'
            {
                if (!namespaces || namespaces.split(';').includes('custom')) updatedRateLimits[category] = now + delay;
            } else updatedRateLimits[category] = now + delay;
        }
    }
    else if (retryAfterHeader) updatedRateLimits.all = now + $5922364681981a78$export$615352e17ed7741(retryAfterHeader, now);
    else if (statusCode === 429) updatedRateLimits.all = now + 60000;
    return updatedRateLimits;
}


const $443bfe748e541c55$export$e515cf6dfd2f98b8 = 64;
/**
 * Creates an instance of a Sentry `Transport`
 *
 * @param options
 * @param makeRequest
 */ function $443bfe748e541c55$export$d09f50d9ab7f7b69(options, makeRequest, buffer = (0, $1c536e651ef5e7fd$export$85a4f67f852183e6)(options.bufferSize || $443bfe748e541c55$export$e515cf6dfd2f98b8)) {
    let rateLimits = {};
    const flush = (timeout)=>buffer.drain(timeout);
    function send(envelope) {
        const filteredEnvelopeItems = [];
        // Drop rate limited items from envelope
        (0, $5db434c4f7260fa2$export$c56c55acf0136fd3)(envelope, (item, type)=>{
            const dataCategory = (0, $5db434c4f7260fa2$export$b11169581eeaf237)(type);
            if ((0, $5922364681981a78$export$6c91fec22056810a)(rateLimits, dataCategory)) options.recordDroppedEvent('ratelimit_backoff', dataCategory);
            else filteredEnvelopeItems.push(item);
        });
        // Skip sending if envelope is empty after filtering out rate limited events
        if (filteredEnvelopeItems.length === 0) return Promise.resolve({});
        const filteredEnvelope = (0, $5db434c4f7260fa2$export$f93f7f385160c44e)(envelope[0], filteredEnvelopeItems);
        // Creates client report for each item in an envelope
        const recordEnvelopeLoss = (reason)=>{
            // Don't record outcomes for client reports - we don't want to create a feedback loop if client reports themselves fail to send
            if ((0, $5db434c4f7260fa2$export$604a45d95a155e2b)(filteredEnvelope, [
                'client_report'
            ])) {
                (0, $6d193f2c2b007873$export$16a28057038b10ef) && (0, $6ed5aee3203eab87$export$1c9f709888824e05).warn(`Dropping client report. Will not send outcomes (reason: ${reason}).`);
                return;
            }
            (0, $5db434c4f7260fa2$export$c56c55acf0136fd3)(filteredEnvelope, (item, type)=>{
                options.recordDroppedEvent(reason, (0, $5db434c4f7260fa2$export$b11169581eeaf237)(type));
            });
        };
        const requestTask = ()=>makeRequest({
                body: (0, $5db434c4f7260fa2$export$32f9b428425aac85)(filteredEnvelope)
            }).then((response)=>{
                // Handle 413 Content Too Large
                // Loss of envelope content is expected so we record a send_error client report
                // https://develop.sentry.dev/sdk/expected-features/#dealing-with-network-failures
                if (response.statusCode === 413) {
                    (0, $6d193f2c2b007873$export$16a28057038b10ef) && (0, $6ed5aee3203eab87$export$1c9f709888824e05).error('Sentry responded with status code 413. Envelope was discarded due to exceeding size limits.');
                    recordEnvelopeLoss('send_error');
                    return response;
                }
                // We don't want to throw on NOK responses, but we want to at least log them
                if ((0, $6d193f2c2b007873$export$16a28057038b10ef) && response.statusCode !== undefined && (response.statusCode < 200 || response.statusCode >= 300)) (0, $6ed5aee3203eab87$export$1c9f709888824e05).warn(`Sentry responded with status code ${response.statusCode} to sent event.`);
                rateLimits = (0, $5922364681981a78$export$699aff705e0d49d4)(rateLimits, response);
                return response;
            }, (error)=>{
                recordEnvelopeLoss('network_error');
                (0, $6d193f2c2b007873$export$16a28057038b10ef) && (0, $6ed5aee3203eab87$export$1c9f709888824e05).error('Encountered error running transport request:', error);
                throw error;
            });
        return buffer.add(requestTask).then((result)=>result, (error)=>{
            if (error === (0, $1c536e651ef5e7fd$export$c8667f1887a128dc)) {
                (0, $6d193f2c2b007873$export$16a28057038b10ef) && (0, $6ed5aee3203eab87$export$1c9f709888824e05).error('Skipped sending event because buffer is full.');
                recordEnvelopeLoss('queue_overflow');
                return Promise.resolve({});
            } else throw error;
        });
    }
    return {
        send: send,
        flush: flush
    };
}




/**
 * Creates client report envelope
 * @param discarded_events An array of discard events
 * @param dsn A DSN that can be set on the header. Optional.
 */ function $625c2d2f599f2b16$export$f3b9ed77c03eeb00(discarded_events, dsn, timestamp) {
    const clientReportItem = [
        {
            type: 'client_report'
        },
        {
            timestamp: timestamp || (0, $27fab3c4acc6cd95$export$7740643b9eeaf0c4)(),
            discarded_events: discarded_events
        }
    ];
    return (0, $5db434c4f7260fa2$export$f93f7f385160c44e)(dsn ? {
        dsn: dsn
    } : {}, [
        clientReportItem
    ]);
}















/**
 * Process an array of event processors, returning the processed event (or `null` if the event was dropped).
 */ function $1d8b68946e9a2981$export$bf2a096c3e883e79(processors, event, hint, index = 0) {
    try {
        const result = $1d8b68946e9a2981$var$_notifyEventProcessors(event, hint, processors, index);
        return (0, $d1f309ce92d0a600$export$f5b060c2914b97c8)(result) ? result : (0, $d656c4fbd69077c0$export$1fda8aa4d135f8aa)(result);
    } catch (error) {
        return (0, $d656c4fbd69077c0$export$78e43115b553f358)(error);
    }
}
function $1d8b68946e9a2981$var$_notifyEventProcessors(event, hint, processors, index) {
    const processor = processors[index];
    if (!event || !processor) return event;
    const result = processor({
        ...event
    }, hint);
    (0, $6d193f2c2b007873$export$16a28057038b10ef) && result === null && (0, $6ed5aee3203eab87$export$1c9f709888824e05).log(`Event processor "${processor.id || '?'}" dropped event`);
    if ((0, $d1f309ce92d0a600$export$f5b060c2914b97c8)(result)) return result.then((final)=>$1d8b68946e9a2981$var$_notifyEventProcessors(final, hint, processors, index + 1));
    return $1d8b68946e9a2981$var$_notifyEventProcessors(result, hint, processors, index + 1);
}





let $9932b78f77655b00$var$parsedStackResults;
let $9932b78f77655b00$var$lastSentryKeysCount;
let $9932b78f77655b00$var$lastNativeKeysCount;
let $9932b78f77655b00$var$cachedFilenameDebugIds;
/**
 * Returns a map of filenames to debug identifiers.
 * Supports both proprietary _sentryDebugIds and native _debugIds (e.g., from Vercel) formats.
 */ function $9932b78f77655b00$export$e069fee9c632ed00(stackParser) {
    const sentryDebugIdMap = (0, $517c5b29f882562f$export$f1a6cdb1459e81d1)._sentryDebugIds;
    const nativeDebugIdMap = (0, $517c5b29f882562f$export$f1a6cdb1459e81d1)._debugIds;
    if (!sentryDebugIdMap && !nativeDebugIdMap) return {};
    const sentryDebugIdKeys = sentryDebugIdMap ? Object.keys(sentryDebugIdMap) : [];
    const nativeDebugIdKeys = nativeDebugIdMap ? Object.keys(nativeDebugIdMap) : [];
    // If the count of registered globals hasn't changed since the last call, we
    // can just return the cached result.
    if ($9932b78f77655b00$var$cachedFilenameDebugIds && sentryDebugIdKeys.length === $9932b78f77655b00$var$lastSentryKeysCount && nativeDebugIdKeys.length === $9932b78f77655b00$var$lastNativeKeysCount) return $9932b78f77655b00$var$cachedFilenameDebugIds;
    $9932b78f77655b00$var$lastSentryKeysCount = sentryDebugIdKeys.length;
    $9932b78f77655b00$var$lastNativeKeysCount = nativeDebugIdKeys.length;
    // Build a map of filename -> debug_id from both sources
    $9932b78f77655b00$var$cachedFilenameDebugIds = {};
    if (!$9932b78f77655b00$var$parsedStackResults) $9932b78f77655b00$var$parsedStackResults = {};
    const processDebugIds = (debugIdKeys, debugIdMap)=>{
        for (const key of debugIdKeys){
            const debugId = debugIdMap[key];
            const result = $9932b78f77655b00$var$parsedStackResults?.[key];
            if (result && $9932b78f77655b00$var$cachedFilenameDebugIds && debugId) {
                // Use cached filename but update with current debug ID
                $9932b78f77655b00$var$cachedFilenameDebugIds[result[0]] = debugId;
                // Update cached result with new debug ID
                if ($9932b78f77655b00$var$parsedStackResults) $9932b78f77655b00$var$parsedStackResults[key] = [
                    result[0],
                    debugId
                ];
            } else if (debugId) {
                const parsedStack = stackParser(key);
                for(let i = parsedStack.length - 1; i >= 0; i--){
                    const stackFrame = parsedStack[i];
                    const filename = stackFrame?.filename;
                    if (filename && $9932b78f77655b00$var$cachedFilenameDebugIds && $9932b78f77655b00$var$parsedStackResults) {
                        $9932b78f77655b00$var$cachedFilenameDebugIds[filename] = debugId;
                        $9932b78f77655b00$var$parsedStackResults[key] = [
                            filename,
                            debugId
                        ];
                        break;
                    }
                }
            }
        }
    };
    if (sentryDebugIdMap) processDebugIds(sentryDebugIdKeys, sentryDebugIdMap);
    // Native _debugIds will override _sentryDebugIds if same file
    if (nativeDebugIdMap) processDebugIds(nativeDebugIdKeys, nativeDebugIdMap);
    return $9932b78f77655b00$var$cachedFilenameDebugIds;
}
/**
 * Returns a list of debug images for the given resources.
 */ function $9932b78f77655b00$export$5a7368330d9ee6e3(stackParser, resource_paths) {
    const filenameDebugIdMap = $9932b78f77655b00$export$e069fee9c632ed00(stackParser);
    if (!filenameDebugIdMap) return [];
    const images = [];
    for (const path of resource_paths){
        const normalizedPath = (0, $d64dedd9c6b2e07c$export$60c0d6c8e038267a)(path);
        if (normalizedPath && filenameDebugIdMap[normalizedPath]) images.push({
            type: 'sourcemap',
            code_file: path,
            debug_id: filenameDebugIdMap[normalizedPath]
        });
    }
    return images;
}








/**
 * This type makes sure that we get either a CaptureContext, OR an EventHint.
 * It does not allow mixing them, which could lead to unexpected outcomes, e.g. this is disallowed:
 * { user: { id: '123' }, mechanism: { handled: false } }
 */ /**
 * Adds common information to events.
 *
 * The information includes release and environment from `options`,
 * breadcrumbs and context (extra, tags and user) from the scope.
 *
 * Information that is already present in the event is never overwritten. For
 * nested objects, such as the context, keys are merged.
 *
 * @param event The original event.
 * @param hint May contain additional information about the original exception.
 * @param scope A scope containing event metadata.
 * @returns A new event with more information.
 * @hidden
 */ function $483fc517c383af06$export$2d67fb380bd11267(options, event, hint, scope, client, isolationScope) {
    const { normalizeDepth: normalizeDepth = 3, normalizeMaxBreadth: normalizeMaxBreadth = 1000 } = options;
    const prepared = {
        ...event,
        event_id: event.event_id || hint.event_id || (0, $76366c1ad7fe29b9$export$19f53698e68b2496)(),
        timestamp: event.timestamp || (0, $27fab3c4acc6cd95$export$7740643b9eeaf0c4)()
    };
    const integrations = hint.integrations || options.integrations.map((i)=>i.name);
    $483fc517c383af06$export$d7e04067a6fbc882(prepared, options);
    $483fc517c383af06$var$applyIntegrationsMetadata(prepared, integrations);
    if (client) client.emit('applyFrameMetadata', event);
    // Only put debug IDs onto frames for error events.
    if (event.type === undefined) $483fc517c383af06$export$63042efc86f043e7(prepared, options.stackParser);
    // If we have scope given to us, use it as the base for further modifications.
    // This allows us to prevent unnecessary copying of data if `captureContext` is not provided.
    const finalScope = $483fc517c383af06$var$getFinalScope(scope, hint.captureContext);
    if (hint.mechanism) (0, $76366c1ad7fe29b9$export$c69a9a0313b03bb1)(prepared, hint.mechanism);
    const clientEventProcessors = client ? client.getEventProcessors() : [];
    // This should be the last thing called, since we want that
    // {@link Scope.addEventProcessor} gets the finished prepared event.
    // Merge scope data together
    const data = (0, $7e9d2fc46299f0a2$export$cc422922fcbb91c6)(isolationScope, finalScope);
    const attachments = [
        ...hint.attachments || [],
        ...data.attachments
    ];
    if (attachments.length) hint.attachments = attachments;
    (0, $7e9d2fc46299f0a2$export$43988bc651a80216)(prepared, data);
    const eventProcessors = [
        ...clientEventProcessors,
        // Run scope event processors _after_ all other processors
        ...data.eventProcessors
    ];
    // Skip event processors for internal exceptions to prevent recursion
    // oxlint-disable-next-line typescript/prefer-optional-chain
    const isInternalException = hint.data && hint.data.__sentry__ === true;
    const result = isInternalException ? (0, $d656c4fbd69077c0$export$1fda8aa4d135f8aa)(prepared) : (0, $1d8b68946e9a2981$export$bf2a096c3e883e79)(eventProcessors, prepared, hint);
    return result.then((evt)=>{
        if (evt) // We apply the debug_meta field only after all event processors have ran, so that if any event processors modified
        // file names (e.g.the RewriteFrames integration) the filename -> debug ID relationship isn't destroyed.
        // This should not cause any PII issues, since we're only moving data that is already on the event and not adding
        // any new data
        $483fc517c383af06$export$1be657ba8ef44ff0(evt);
        if (typeof normalizeDepth === 'number' && normalizeDepth > 0) return $483fc517c383af06$var$normalizeEvent(evt, normalizeDepth, normalizeMaxBreadth);
        return evt;
    });
}
/**
 * Enhances event using the client configuration.
 * It takes care of all "static" values like environment, release and `dist`,
 * as well as truncating overly long values.
 *
 * Only exported for tests.
 *
 * @param event event instance to be enhanced
 */ function $483fc517c383af06$export$d7e04067a6fbc882(event, options) {
    const { environment: environment, release: release, dist: dist, maxValueLength: maxValueLength } = options;
    // empty strings do not make sense for environment, release, and dist
    // so we handle them the same as if they were not provided
    event.environment = event.environment || environment || (0, $66461bcaaa8dd39f$export$849dbeeeda01ae98);
    if (!event.release && release) event.release = release;
    if (!event.dist && dist) event.dist = dist;
    const request = event.request;
    if (request?.url && maxValueLength) request.url = (0, $5b085f0f99265e84$export$6a506b36fdea397d)(request.url, maxValueLength);
    if (maxValueLength) event.exception?.values?.forEach((exception)=>{
        if (exception.value) // Truncates error messages
        exception.value = (0, $5b085f0f99265e84$export$6a506b36fdea397d)(exception.value, maxValueLength);
    });
}
/**
 * Puts debug IDs into the stack frames of an error event.
 */ function $483fc517c383af06$export$63042efc86f043e7(event, stackParser) {
    // Build a map of filename -> debug_id
    const filenameDebugIdMap = (0, $9932b78f77655b00$export$e069fee9c632ed00)(stackParser);
    event.exception?.values?.forEach((exception)=>{
        exception.stacktrace?.frames?.forEach((frame)=>{
            if (frame.filename) frame.debug_id = filenameDebugIdMap[frame.filename];
        });
    });
}
/**
 * Moves debug IDs from the stack frames of an error event into the debug_meta field.
 */ function $483fc517c383af06$export$1be657ba8ef44ff0(event) {
    // Extract debug IDs and filenames from the stack frames on the event.
    const filenameDebugIdMap = {};
    event.exception?.values?.forEach((exception)=>{
        exception.stacktrace?.frames?.forEach((frame)=>{
            if (frame.debug_id) {
                if (frame.abs_path) filenameDebugIdMap[frame.abs_path] = frame.debug_id;
                else if (frame.filename) filenameDebugIdMap[frame.filename] = frame.debug_id;
                delete frame.debug_id;
            }
        });
    });
    if (Object.keys(filenameDebugIdMap).length === 0) return;
    // Fill debug_meta information
    event.debug_meta = event.debug_meta || {};
    event.debug_meta.images = event.debug_meta.images || [];
    const images = event.debug_meta.images;
    Object.entries(filenameDebugIdMap).forEach(([filename, debug_id])=>{
        images.push({
            type: 'sourcemap',
            code_file: filename,
            debug_id: debug_id
        });
    });
}
/**
 * This function adds all used integrations to the SDK info in the event.
 * @param event The event that will be filled with all integrations.
 */ function $483fc517c383af06$var$applyIntegrationsMetadata(event, integrationNames) {
    if (integrationNames.length > 0) {
        event.sdk = event.sdk || {};
        event.sdk.integrations = [
            ...event.sdk.integrations || [],
            ...integrationNames
        ];
    }
}
/**
 * Applies `normalize` function on necessary `Event` attributes to make them safe for serialization.
 * Normalized keys:
 * - `breadcrumbs.data`
 * - `user`
 * - `contexts`
 * - `extra`
 * @param event Event
 * @returns Normalized event
 */ function $483fc517c383af06$var$normalizeEvent(event, depth, maxBreadth) {
    if (!event) return null;
    const normalized = {
        ...event,
        ...event.breadcrumbs && {
            breadcrumbs: event.breadcrumbs.map((b)=>({
                    ...b,
                    ...b.data && {
                        data: (0, $a4ca5def21866c8a$export$a3295358bff77e)(b.data, depth, maxBreadth)
                    }
                }))
        },
        ...event.user && {
            user: (0, $a4ca5def21866c8a$export$a3295358bff77e)(event.user, depth, maxBreadth)
        },
        ...event.contexts && {
            contexts: (0, $a4ca5def21866c8a$export$a3295358bff77e)(event.contexts, depth, maxBreadth)
        },
        ...event.extra && {
            extra: (0, $a4ca5def21866c8a$export$a3295358bff77e)(event.extra, depth, maxBreadth)
        }
    };
    // event.contexts.trace stores information about a Transaction. Similarly,
    // event.spans[] stores information about child Spans. Given that a
    // Transaction is conceptually a Span, normalization should apply to both
    // Transactions and Spans consistently.
    // For now the decision is to skip normalization of Transactions and Spans,
    // so this block overwrites the normalized event to add back the original
    // Transaction information prior to normalization.
    if (event.contexts?.trace && normalized.contexts) {
        normalized.contexts.trace = event.contexts.trace;
        // event.contexts.trace.data may contain circular/dangerous data so we need to normalize it
        if (event.contexts.trace.data) normalized.contexts.trace.data = (0, $a4ca5def21866c8a$export$a3295358bff77e)(event.contexts.trace.data, depth, maxBreadth);
    }
    // event.spans[].data may contain circular/dangerous data so we need to normalize it
    if (event.spans) normalized.spans = event.spans.map((span)=>{
        return {
            ...span,
            ...span.data && {
                data: (0, $a4ca5def21866c8a$export$a3295358bff77e)(span.data, depth, maxBreadth)
            }
        };
    });
    // event.contexts.flags (FeatureFlagContext) stores context for our feature
    // flag integrations. It has a greater nesting depth than our other typed
    // Contexts, so we re-normalize with a fixed depth of 3 here. We do not want
    // to skip this in case of conflicting, user-provided context.
    if (event.contexts?.flags && normalized.contexts) normalized.contexts.flags = (0, $a4ca5def21866c8a$export$a3295358bff77e)(event.contexts.flags, 3, maxBreadth);
    return normalized;
}
function $483fc517c383af06$var$getFinalScope(scope, captureContext) {
    if (!captureContext) return scope;
    const finalScope = scope ? scope.clone() : new (0, $b569c377336cf232$export$775b6bb06e53a214)();
    finalScope.update(captureContext);
    return finalScope;
}
/**
 * Parse either an `EventHint` directly, or convert a `CaptureContext` to an `EventHint`.
 * This is used to allow to update method signatures that used to accept a `CaptureContext` but should now accept an `EventHint`.
 */ function $483fc517c383af06$export$76b5f966996d1653(hint) {
    if (!hint) return undefined;
    // If you pass a Scope or `() => Scope` as CaptureContext, we just return this as captureContext
    if ($483fc517c383af06$var$hintIsScopeOrFunction(hint)) return {
        captureContext: hint
    };
    if ($483fc517c383af06$var$hintIsScopeContext(hint)) return {
        captureContext: hint
    };
    return hint;
}
function $483fc517c383af06$var$hintIsScopeOrFunction(hint) {
    return hint instanceof (0, $b569c377336cf232$export$775b6bb06e53a214) || typeof hint === 'function';
}
const $483fc517c383af06$var$captureContextKeys = [
    'user',
    'level',
    'extra',
    'contexts',
    'tags',
    'fingerprint',
    'propagationContext'
];
function $483fc517c383af06$var$hintIsScopeContext(hint) {
    return Object.keys(hint).some((key)=>$483fc517c383af06$var$captureContextKeys.includes(key));
}









/**
 * Converts a transaction event to a span JSON object.
 */ function $f087085480fe1273$export$d9c6b2464b0a687e(event) {
    const { trace_id: trace_id, parent_span_id: parent_span_id, span_id: span_id, status: status, origin: origin, data: data, op: op } = event.contexts?.trace ?? {};
    return {
        data: data ?? {},
        description: event.transaction,
        op: op,
        parent_span_id: parent_span_id,
        span_id: span_id ?? '',
        start_timestamp: event.start_timestamp ?? 0,
        status: status,
        timestamp: event.timestamp,
        trace_id: trace_id ?? '',
        origin: origin,
        profile_id: data?.[0, $0633c8eb02923c67$export$1efec95406bbe327],
        exclusive_time: data?.[0, $0633c8eb02923c67$export$fea48ba9f4550879],
        measurements: event.measurements,
        is_segment: true
    };
}
/**
 * Converts a span JSON object to a transaction event.
 */ function $f087085480fe1273$export$f2d8fce5ae150e92(span) {
    return {
        type: 'transaction',
        timestamp: span.timestamp,
        start_timestamp: span.start_timestamp,
        transaction: span.description,
        contexts: {
            trace: {
                trace_id: span.trace_id,
                span_id: span.span_id,
                parent_span_id: span.parent_span_id,
                op: span.op,
                status: span.status,
                origin: span.origin,
                data: {
                    ...span.data,
                    ...span.profile_id && {
                        [(0, $0633c8eb02923c67$export$1efec95406bbe327)]: span.profile_id
                    },
                    ...span.exclusive_time && {
                        [(0, $0633c8eb02923c67$export$fea48ba9f4550879)]: span.exclusive_time
                    }
                }
            }
        },
        measurements: span.measurements
    };
}


/* eslint-disable max-lines */ const $bcff9e27a91c274c$var$ALREADY_SEEN_ERROR = "Not capturing exception because it's already been captured.";
const $bcff9e27a91c274c$var$MISSING_RELEASE_FOR_SESSION_ERROR = 'Discarded session because of missing or non-string release';
const $bcff9e27a91c274c$var$INTERNAL_ERROR_SYMBOL = Symbol.for('SentryInternalError');
const $bcff9e27a91c274c$var$DO_NOT_SEND_EVENT_SYMBOL = Symbol.for('SentryDoNotSendEventError');
// Default interval for flushing logs and metrics (5 seconds)
const $bcff9e27a91c274c$var$DEFAULT_FLUSH_INTERVAL = 5000;
function $bcff9e27a91c274c$var$_makeInternalError(message) {
    return {
        message: message,
        [$bcff9e27a91c274c$var$INTERNAL_ERROR_SYMBOL]: true
    };
}
function $bcff9e27a91c274c$var$_makeDoNotSendEventError(message) {
    return {
        message: message,
        [$bcff9e27a91c274c$var$DO_NOT_SEND_EVENT_SYMBOL]: true
    };
}
function $bcff9e27a91c274c$var$_isInternalError(error) {
    return !!error && typeof error === 'object' && $bcff9e27a91c274c$var$INTERNAL_ERROR_SYMBOL in error;
}
function $bcff9e27a91c274c$var$_isDoNotSendEventError(error) {
    return !!error && typeof error === 'object' && $bcff9e27a91c274c$var$DO_NOT_SEND_EVENT_SYMBOL in error;
}
/**
 * Sets up weight-based flushing for logs or metrics.
 * This helper function encapsulates the common pattern of:
 * 1. Tracking accumulated weight of items
 * 2. Flushing when weight exceeds threshold (800KB)
 * 3. Flushing after timeout period from the first item
 *
 * Uses closure variables to track weight and timeout state.
 */ function $bcff9e27a91c274c$var$setupWeightBasedFlushing(client, afterCaptureHook, flushHook, estimateSizeFn, flushFn) {
    // Track weight and timeout in closure variables
    let weight = 0;
    let flushTimeout;
    let isTimerActive = false;
    // @ts-expect-error - TypeScript can't narrow generic hook types to match specific overloads, but we know this is type-safe
    client.on(flushHook, ()=>{
        weight = 0;
        clearTimeout(flushTimeout);
        isTimerActive = false;
    });
    // @ts-expect-error - TypeScript can't narrow generic hook types to match specific overloads, but we know this is type-safe
    client.on(afterCaptureHook, (item)=>{
        weight += estimateSizeFn(item);
        // We flush the buffer if it exceeds 0.8 MB
        // The weight is a rough estimate, so we flush way before the payload gets too big.
        if (weight >= 800000) flushFn(client);
        else if (!isTimerActive) {
            // Only start timer if one isn't already running.
            // This prevents flushing being delayed by items that arrive close to the timeout limit
            // and thus resetting the flushing timeout and delaying items being flushed.
            isTimerActive = true;
            // Use safeUnref so the timer doesn't prevent the process from exiting
            flushTimeout = (0, $15271e1a3212eadc$export$630056cb83d87863)(setTimeout(()=>{
                flushFn(client);
            // Note: isTimerActive is reset by the flushHook handler above, not here,
            // to avoid race conditions when new items arrive during the flush.
            }, $bcff9e27a91c274c$var$DEFAULT_FLUSH_INTERVAL));
        }
    });
    client.on('flush', ()=>{
        flushFn(client);
    });
}
/**
 * Base implementation for all JavaScript SDK clients.
 *
 * Call the constructor with the corresponding options
 * specific to the client subclass. To access these options later, use
 * {@link Client.getOptions}.
 *
 * If a Dsn is specified in the options, it will be parsed and stored. Use
 * {@link Client.getDsn} to retrieve the Dsn at any moment. In case the Dsn is
 * invalid, the constructor will throw a {@link SentryException}. Note that
 * without a valid Dsn, the SDK will not send any events to Sentry.
 *
 * Before sending an event, it is passed through
 * {@link Client._prepareEvent} to add SDK information and scope data
 * (breadcrumbs and context). To add more custom information, override this
 * method and extend the resulting prepared event.
 *
 * To issue automatically created events (e.g. via instrumentation), use
 * {@link Client.captureEvent}. It will prepare the event and pass it through
 * the callback lifecycle. To issue auto-breadcrumbs, use
 * {@link Client.addBreadcrumb}.
 *
 * @example
 * class NodeClient extends Client<NodeOptions> {
 *   public constructor(options: NodeOptions) {
 *     super(options);
 *   }
 *
 *   // ...
 * }
 */ class $bcff9e27a91c274c$export$1f2bb630327ac4b6 {
    /** Options passed to the SDK. */ /** The client Dsn, if specified in options. Without this Dsn, the SDK will be disabled. */ /** Array of set up integrations. */ /** Number of calls being processed */ /** Holds flushable  */ // eslint-disable-next-line @typescript-eslint/ban-types
    /**
   * Initializes this client instance.
   *
   * @param options Options for the client.
   */ constructor(options){
        this._options = options;
        this._integrations = {};
        this._numProcessing = 0;
        this._outcomes = {};
        this._hooks = {};
        this._eventProcessors = [];
        this._promiseBuffer = (0, $1c536e651ef5e7fd$export$85a4f67f852183e6)(options.transportOptions?.bufferSize ?? (0, $443bfe748e541c55$export$e515cf6dfd2f98b8));
        if (options.dsn) this._dsn = (0, $a6fcb45f188ebaa3$export$128827c3562ec0cb)(options.dsn);
        else (0, $6d193f2c2b007873$export$16a28057038b10ef) && (0, $6ed5aee3203eab87$export$1c9f709888824e05).warn('No DSN provided, client will not send events.');
        if (this._dsn) {
            const url = (0, $6cab12468635632a$export$9964600bfe84e6a3)(this._dsn, options.tunnel, options._metadata ? options._metadata.sdk : undefined);
            this._transport = options.transport({
                tunnel: this._options.tunnel,
                recordDroppedEvent: this.recordDroppedEvent.bind(this),
                ...options.transportOptions,
                url: url
            });
        }
        // Backfill enableLogs option from _experiments.enableLogs
        // TODO(v11): Remove or change default value
        // eslint-disable-next-line deprecation/deprecation
        this._options.enableLogs = this._options.enableLogs ?? this._options._experiments?.enableLogs;
        // Setup log flushing with weight and timeout tracking
        if (this._options.enableLogs) $bcff9e27a91c274c$var$setupWeightBasedFlushing(this, 'afterCaptureLog', 'flushLogs', $bcff9e27a91c274c$var$estimateLogSizeInBytes, (0, $1b5f53d516745d9f$export$f8ed83d3b6a0b504));
        // todo(v11): Remove the experimental flag
        // eslint-disable-next-line deprecation/deprecation
        const enableMetrics = this._options.enableMetrics ?? this._options._experiments?.enableMetrics ?? true;
        // Setup metric flushing with weight and timeout tracking
        if (enableMetrics) $bcff9e27a91c274c$var$setupWeightBasedFlushing(this, 'afterCaptureMetric', 'flushMetrics', $bcff9e27a91c274c$var$estimateMetricSizeInBytes, (0, $c7fd3bed22ef46d6$export$91c9ef254b7d0f67));
    }
    /**
   * Captures an exception event and sends it to Sentry.
   *
   * Unlike `captureException` exported from every SDK, this method requires that you pass it the current scope.
   */ captureException(exception, hint, scope) {
        const eventId = (0, $76366c1ad7fe29b9$export$19f53698e68b2496)();
        // ensure we haven't captured this very object before
        if ((0, $76366c1ad7fe29b9$export$6de4ffac6a2f1098)(exception)) {
            (0, $6d193f2c2b007873$export$16a28057038b10ef) && (0, $6ed5aee3203eab87$export$1c9f709888824e05).log($bcff9e27a91c274c$var$ALREADY_SEEN_ERROR);
            return eventId;
        }
        const hintWithEventId = {
            event_id: eventId,
            ...hint
        };
        this._process(()=>this.eventFromException(exception, hintWithEventId).then((event)=>this._captureEvent(event, hintWithEventId, scope)).then((res)=>res), 'error');
        return hintWithEventId.event_id;
    }
    /**
   * Captures a message event and sends it to Sentry.
   *
   * Unlike `captureMessage` exported from every SDK, this method requires that you pass it the current scope.
   */ captureMessage(message, level, hint, currentScope) {
        const hintWithEventId = {
            event_id: (0, $76366c1ad7fe29b9$export$19f53698e68b2496)(),
            ...hint
        };
        const eventMessage = (0, $d1f309ce92d0a600$export$dbcbffa59149b824)(message) ? message : String(message);
        const isMessage = (0, $d1f309ce92d0a600$export$c3825b437cbdea5c)(message);
        const promisedEvent = isMessage ? this.eventFromMessage(eventMessage, level, hintWithEventId) : this.eventFromException(message, hintWithEventId);
        this._process(()=>promisedEvent.then((event)=>this._captureEvent(event, hintWithEventId, currentScope)), isMessage ? 'unknown' : 'error');
        return hintWithEventId.event_id;
    }
    /**
   * Captures a manually created event and sends it to Sentry.
   *
   * Unlike `captureEvent` exported from every SDK, this method requires that you pass it the current scope.
   */ captureEvent(event, hint, currentScope) {
        const eventId = (0, $76366c1ad7fe29b9$export$19f53698e68b2496)();
        // ensure we haven't captured this very object before
        if (hint?.originalException && (0, $76366c1ad7fe29b9$export$6de4ffac6a2f1098)(hint.originalException)) {
            (0, $6d193f2c2b007873$export$16a28057038b10ef) && (0, $6ed5aee3203eab87$export$1c9f709888824e05).log($bcff9e27a91c274c$var$ALREADY_SEEN_ERROR);
            return eventId;
        }
        const hintWithEventId = {
            event_id: eventId,
            ...hint
        };
        const sdkProcessingMetadata = event.sdkProcessingMetadata || {};
        const capturedSpanScope = sdkProcessingMetadata.capturedSpanScope;
        const capturedSpanIsolationScope = sdkProcessingMetadata.capturedSpanIsolationScope;
        const dataCategory = $bcff9e27a91c274c$var$getDataCategoryByType(event.type);
        this._process(()=>this._captureEvent(event, hintWithEventId, capturedSpanScope || currentScope, capturedSpanIsolationScope), dataCategory);
        return hintWithEventId.event_id;
    }
    /**
   * Captures a session.
   */ captureSession(session) {
        this.sendSession(session);
        // After sending, we set init false to indicate it's not the first occurrence
        (0, $71bbb010c8615be2$export$531818e825e774db)(session, {
            init: false
        });
    }
    /**
   * Create a cron monitor check in and send it to Sentry. This method is not available on all clients.
   *
   * @param checkIn An object that describes a check in.
   * @param upsertMonitorConfig An optional object that describes a monitor config. Use this if you want
   * to create a monitor automatically when sending a check in.
   * @param scope An optional scope containing event metadata.
   * @returns A string representing the id of the check in.
   */ /**
   * Get the current Dsn.
   */ getDsn() {
        return this._dsn;
    }
    /**
   * Get the current options.
   */ getOptions() {
        return this._options;
    }
    /**
   * Get the SDK metadata.
   * @see SdkMetadata
   */ getSdkMetadata() {
        return this._options._metadata;
    }
    /**
   * Returns the transport that is used by the client.
   * Please note that the transport gets lazy initialized so it will only be there once the first event has been sent.
   */ getTransport() {
        return this._transport;
    }
    /**
   * Wait for all events to be sent or the timeout to expire, whichever comes first.
   *
   * @param timeout Maximum time in ms the client should wait for events to be flushed. Omitting this parameter will
   *   cause the client to wait until all events are sent before resolving the promise.
   * @returns A promise that will resolve with `true` if all events are sent before the timeout, or `false` if there are
   * still events in the queue when the timeout is reached.
   */ // @ts-expect-error - PromiseLike is a subset of Promise
    async flush(timeout) {
        const transport = this._transport;
        if (!transport) return true;
        this.emit('flush');
        const clientFinished = await this._isClientDoneProcessing(timeout);
        const transportFlushed = await transport.flush(timeout);
        return clientFinished && transportFlushed;
    }
    /**
   * Flush the event queue and set the client to `enabled = false`. See {@link Client.flush}.
   *
   * @param {number} timeout Maximum time in ms the client should wait before shutting down. Omitting this parameter will cause
   *   the client to wait until all events are sent before disabling itself.
   * @returns {Promise<boolean>} A promise which resolves to `true` if the flush completes successfully before the timeout, or `false` if
   * it doesn't.
   */ // @ts-expect-error - PromiseLike is a subset of Promise
    async close(timeout) {
        (0, $1b5f53d516745d9f$export$f8ed83d3b6a0b504)(this);
        const result = await this.flush(timeout);
        this.getOptions().enabled = false;
        this.emit('close');
        return result;
    }
    /**
   * Get all installed event processors.
   */ getEventProcessors() {
        return this._eventProcessors;
    }
    /**
   * Adds an event processor that applies to any event processed by this client.
   */ addEventProcessor(eventProcessor) {
        this._eventProcessors.push(eventProcessor);
    }
    /**
   * Initialize this client.
   * Call this after the client was set on a scope.
   */ init() {
        if (this._isEnabled() || // Force integrations to be setup even if no DSN was set when we have
        // Spotlight enabled. This is particularly important for browser as we
        // don't support the `spotlight` option there and rely on the users
        // adding the `spotlightBrowserIntegration()` to their integrations which
        // wouldn't get initialized with the check below when there's no DSN set.
        this._options.integrations.some(({ name: name })=>name.startsWith('Spotlight'))) this._setupIntegrations();
    }
    /**
   * Gets an installed integration by its name.
   *
   * @returns {Integration|undefined} The installed integration or `undefined` if no integration with that `name` was installed.
   */ getIntegrationByName(integrationName) {
        return this._integrations[integrationName];
    }
    /**
   * Add an integration to the client.
   * This can be used to e.g. lazy load integrations.
   * In most cases, this should not be necessary,
   * and you're better off just passing the integrations via `integrations: []` at initialization time.
   * However, if you find the need to conditionally load & add an integration, you can use `addIntegration` to do so.
   */ addIntegration(integration) {
        const isAlreadyInstalled = this._integrations[integration.name];
        if (!isAlreadyInstalled && integration.beforeSetup) integration.beforeSetup(this);
        // This hook takes care of only installing if not already installed
        (0, $305b4dfee0d746dc$export$e7390a03b70a6f2f)(this, integration, this._integrations);
        // Here we need to check manually to make sure to not run this multiple times
        if (!isAlreadyInstalled) (0, $305b4dfee0d746dc$export$35abcfd71227c6ca)(this, [
            integration
        ]);
    }
    /**
   * Send a fully prepared event to Sentry.
   */ sendEvent(event, hint = {}) {
        this.emit('beforeSendEvent', event, hint);
        let env = (0, $a0dbcc7684e32930$export$c31057337a18010f)(event, this._dsn, this._options._metadata, this._options.tunnel);
        for (const attachment of hint.attachments || [])env = (0, $5db434c4f7260fa2$export$d650323442802f6f)(env, (0, $5db434c4f7260fa2$export$d8fc80952cc31fa4)(attachment));
        // sendEnvelope should not throw
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this.sendEnvelope(env).then((sendResponse)=>this.emit('afterSendEvent', event, sendResponse));
    }
    /**
   * Send a session or session aggregrates to Sentry.
   */ sendSession(session) {
        // Backfill release and environment on session
        const { release: clientReleaseOption, environment: clientEnvironmentOption = (0, $66461bcaaa8dd39f$export$849dbeeeda01ae98) } = this._options;
        if ('aggregates' in session) {
            const sessionAttrs = session.attrs || {};
            if (!sessionAttrs.release && !clientReleaseOption) {
                (0, $6d193f2c2b007873$export$16a28057038b10ef) && (0, $6ed5aee3203eab87$export$1c9f709888824e05).warn($bcff9e27a91c274c$var$MISSING_RELEASE_FOR_SESSION_ERROR);
                return;
            }
            sessionAttrs.release = sessionAttrs.release || clientReleaseOption;
            sessionAttrs.environment = sessionAttrs.environment || clientEnvironmentOption;
            session.attrs = sessionAttrs;
        } else {
            if (!session.release && !clientReleaseOption) {
                (0, $6d193f2c2b007873$export$16a28057038b10ef) && (0, $6ed5aee3203eab87$export$1c9f709888824e05).warn($bcff9e27a91c274c$var$MISSING_RELEASE_FOR_SESSION_ERROR);
                return;
            }
            session.release = session.release || clientReleaseOption;
            session.environment = session.environment || clientEnvironmentOption;
        }
        this.emit('beforeSendSession', session);
        const env = (0, $a0dbcc7684e32930$export$124b03c077baa2f3)(session, this._dsn, this._options._metadata, this._options.tunnel);
        // sendEnvelope should not throw
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this.sendEnvelope(env);
    }
    /**
   * Record on the client that an event got dropped (ie, an event that will not be sent to Sentry).
   */ recordDroppedEvent(reason, category, count = 1) {
        if (this._options.sendClientReports) {
            // We want to track each category (error, transaction, session, replay_event) separately
            // but still keep the distinction between different type of outcomes.
            // We could use nested maps, but it's much easier to read and type this way.
            // A correct type for map-based implementation if we want to go that route
            // would be `Partial<Record<SentryRequestType, Partial<Record<Outcome, number>>>>`
            // With typescript 4.1 we could even use template literal types
            const key = `${reason}:${category}`;
            (0, $6d193f2c2b007873$export$16a28057038b10ef) && (0, $6ed5aee3203eab87$export$1c9f709888824e05).log(`Recording outcome: "${key}"${count > 1 ? ` (${count} times)` : ''}`);
            this._outcomes[key] = (this._outcomes[key] || 0) + count;
        }
    }
    /* eslint-disable @typescript-eslint/unified-signatures */ /**
   * Register a callback for whenever a span is started.
   * Receives the span as argument.
   * @returns {() => void} A function that, when executed, removes the registered callback.
   */ /**
   * Register a hook on this client.
   */ on(hook, callback) {
        const hookCallbacks = this._hooks[hook] = this._hooks[hook] || new Set();
        // Wrap the callback in a function so that registering the same callback instance multiple
        // times results in the callback being called multiple times.
        // @ts-expect-error - The `callback` type is correct and must be a function due to the
        // individual, specific overloads of this function.
        // eslint-disable-next-line @typescript-eslint/ban-types
        const uniqueCallback = (...args)=>callback(...args);
        hookCallbacks.add(uniqueCallback);
        // This function returns a callback execution handler that, when invoked,
        // deregisters a callback. This is crucial for managing instances where callbacks
        // need to be unregistered to prevent self-referencing in callback closures,
        // ensuring proper garbage collection.
        return ()=>{
            hookCallbacks.delete(uniqueCallback);
        };
    }
    /** Fire a hook whenever a span starts. */ /**
   * Emit a hook that was previously registered via `on()`.
   */ emit(hook, ...rest) {
        const callbacks = this._hooks[hook];
        if (callbacks) callbacks.forEach((callback)=>callback(...rest));
    }
    /**
   * Send an envelope to Sentry.
   */ // @ts-expect-error - PromiseLike is a subset of Promise
    async sendEnvelope(envelope) {
        this.emit('beforeEnvelope', envelope);
        if (this._isEnabled() && this._transport) try {
            return await this._transport.send(envelope);
        } catch (reason) {
            (0, $6d193f2c2b007873$export$16a28057038b10ef) && (0, $6ed5aee3203eab87$export$1c9f709888824e05).error('Error while sending envelope:', reason);
            return {};
        }
        (0, $6d193f2c2b007873$export$16a28057038b10ef) && (0, $6ed5aee3203eab87$export$1c9f709888824e05).error('Transport disabled');
        return {};
    }
    /**
   * Disposes of the client and releases all resources.
   *
   * Subclasses should override this method to clean up their own resources.
   * After calling dispose(), the client should not be used anymore.
   */ dispose() {
    // Base class has no cleanup logic - subclasses implement their own
    }
    /* eslint-enable @typescript-eslint/unified-signatures */ /** Setup integrations for this client. */ _setupIntegrations() {
        const { integrations: integrations } = this._options;
        this._integrations = (0, $305b4dfee0d746dc$export$51abed9797baa598)(this, integrations);
        (0, $305b4dfee0d746dc$export$35abcfd71227c6ca)(this, integrations);
    }
    /** Updates existing session based on the provided event */ _updateSessionFromEvent(session, event) {
        // initially, set `crashed` based on the event level and update from exceptions if there are any later on
        let crashed = event.level === 'fatal';
        let errored = false;
        const exceptions = event.exception?.values;
        if (exceptions) {
            errored = true;
            // reset crashed to false if there are exceptions, to ensure `mechanism.handled` is respected.
            crashed = false;
            for (const ex of exceptions)if (ex.mechanism?.handled === false) {
                crashed = true;
                break;
            }
        }
        // A session is updated and that session update is sent in only one of the two following scenarios:
        // 1. Session with non terminal status and 0 errors + an error occurred -> Will set error count to 1 and send update
        // 2. Session with non terminal status and 1 error + a crash occurred -> Will set status crashed and send update
        const sessionNonTerminal = session.status === 'ok';
        const shouldUpdateAndSend = sessionNonTerminal && session.errors === 0 || sessionNonTerminal && crashed;
        if (shouldUpdateAndSend) {
            (0, $71bbb010c8615be2$export$531818e825e774db)(session, {
                ...crashed && {
                    status: 'crashed'
                },
                errors: session.errors || Number(errored || crashed)
            });
            this.captureSession(session);
        }
    }
    /**
   * Determine if the client is finished processing. Returns a promise because it will wait `timeout` ms before saying
   * "no" (resolving to `false`) in order to give the client a chance to potentially finish first.
   *
   * @param timeout The time, in ms, after which to resolve to `false` if the client is still busy. Passing `0` (or not
   * passing anything) will make the promise wait as long as it takes for processing to finish before resolving to
   * `true`.
   * @returns A promise which will resolve to `true` if processing is already done or finishes before the timeout, and
   * `false` otherwise
   */ async _isClientDoneProcessing(timeout) {
        let ticked = 0;
        while(!timeout || ticked < timeout){
            await new Promise((resolve)=>setTimeout(resolve, 1));
            if (!this._numProcessing) return true;
            ticked++;
        }
        return false;
    }
    /** Determines whether this SDK is enabled and a transport is present. */ _isEnabled() {
        return this.getOptions().enabled !== false && this._transport !== undefined;
    }
    /**
   * Adds common information to events.
   *
   * The information includes release and environment from `options`,
   * breadcrumbs and context (extra, tags and user) from the scope.
   *
   * Information that is already present in the event is never overwritten. For
   * nested objects, such as the context, keys are merged.
   *
   * @param event The original event.
   * @param hint May contain additional information about the original exception.
   * @param currentScope A scope containing event metadata.
   * @returns A new event with more information.
   */ _prepareEvent(event, hint, currentScope, isolationScope) {
        const options = this.getOptions();
        const integrations = Object.keys(this._integrations);
        if (!hint.integrations && integrations?.length) hint.integrations = integrations;
        this.emit('preprocessEvent', event, hint);
        if (!event.type) isolationScope.setLastEventId(event.event_id || hint.event_id);
        return (0, $483fc517c383af06$export$2d67fb380bd11267)(options, event, hint, currentScope, this, isolationScope).then((evt)=>{
            if (evt === null) return evt;
            this.emit('postprocessEvent', evt, hint);
            evt.contexts = {
                trace: {
                    ...evt.contexts?.trace,
                    ...(0, $6c9d57d6c1e4fcbb$export$1e83db7ee4876dc4)(currentScope)
                },
                ...evt.contexts
            };
            const dynamicSamplingContext = (0, $e7797a74bdf55fda$export$89ef1736f08c6b2b)(this, currentScope);
            evt.sdkProcessingMetadata = {
                dynamicSamplingContext: dynamicSamplingContext,
                ...evt.sdkProcessingMetadata
            };
            return evt;
        });
    }
    /**
   * Processes the event and logs an error in case of rejection
   * @param event
   * @param hint
   * @param scope
   */ _captureEvent(event, hint = {}, currentScope = (0, $6c9d57d6c1e4fcbb$export$c7be4b0125a10cba)(), isolationScope = (0, $6c9d57d6c1e4fcbb$export$68f3af03034c9e90)()) {
        if ((0, $6d193f2c2b007873$export$16a28057038b10ef) && $bcff9e27a91c274c$var$isErrorEvent(event)) (0, $6ed5aee3203eab87$export$1c9f709888824e05).log(`Captured error event \`${(0, $609931b5fa93b35e$export$d55a97c329cacfcc)(event)[0] || '<unknown>'}\``);
        return this._processEvent(event, hint, currentScope, isolationScope).then((finalEvent)=>{
            return finalEvent.event_id;
        }, (reason)=>{
            if (0, $6d193f2c2b007873$export$16a28057038b10ef) {
                if ($bcff9e27a91c274c$var$_isDoNotSendEventError(reason)) (0, $6ed5aee3203eab87$export$1c9f709888824e05).log(reason.message);
                else if ($bcff9e27a91c274c$var$_isInternalError(reason)) (0, $6ed5aee3203eab87$export$1c9f709888824e05).warn(reason.message);
                else (0, $6ed5aee3203eab87$export$1c9f709888824e05).warn(reason);
            }
            return undefined;
        });
    }
    /**
   * Processes an event (either error or message) and sends it to Sentry.
   *
   * This also adds breadcrumbs and context information to the event. However,
   * platform specific meta data (such as the User's IP address) must be added
   * by the SDK implementor.
   *
   *
   * @param event The event to send to Sentry.
   * @param hint May contain additional information about the original exception.
   * @param currentScope A scope containing event metadata.
   * @returns A SyncPromise that resolves with the event or rejects in case event was/will not be send.
   */ _processEvent(event, hint, currentScope, isolationScope) {
        const options = this.getOptions();
        const { sampleRate: sampleRate } = options;
        const isTransaction = $bcff9e27a91c274c$var$isTransactionEvent(event);
        const isError = $bcff9e27a91c274c$var$isErrorEvent(event);
        const eventType = event.type || 'error';
        const beforeSendLabel = `before send for type \`${eventType}\``;
        // 1.0 === 100% events are sent
        // 0.0 === 0% events are sent
        // Sampling for transaction happens somewhere else
        const parsedSampleRate = typeof sampleRate === 'undefined' ? undefined : (0, $77c0cd7d06293a86$export$a5bd2d81656d9546)(sampleRate);
        if (isError && typeof parsedSampleRate === 'number' && (0, $11bebf6401bbfdb9$export$9869d72de32a3917)() > parsedSampleRate) {
            this.recordDroppedEvent('sample_rate', 'error');
            return (0, $d656c4fbd69077c0$export$78e43115b553f358)($bcff9e27a91c274c$var$_makeDoNotSendEventError(`Discarding event because it's not included in the random sample (sampling rate = ${sampleRate})`));
        }
        const dataCategory = $bcff9e27a91c274c$var$getDataCategoryByType(event.type);
        return this._prepareEvent(event, hint, currentScope, isolationScope).then((prepared)=>{
            if (prepared === null) {
                this.recordDroppedEvent('event_processor', dataCategory);
                throw $bcff9e27a91c274c$var$_makeDoNotSendEventError('An event processor returned `null`, will not send event.');
            }
            const isInternalException = hint.data?.__sentry__ === true;
            if (isInternalException) return prepared;
            const result = $bcff9e27a91c274c$var$processBeforeSend(this, options, prepared, hint);
            return $bcff9e27a91c274c$var$_validateBeforeSendResult(result, beforeSendLabel);
        }).then((processedEvent)=>{
            if (processedEvent === null) {
                this.recordDroppedEvent('before_send', dataCategory);
                if (isTransaction) {
                    const spans = event.spans || [];
                    // the transaction itself counts as one span, plus all the child spans that are added
                    const spanCount = 1 + spans.length;
                    this.recordDroppedEvent('before_send', 'span', spanCount);
                }
                throw $bcff9e27a91c274c$var$_makeDoNotSendEventError(`${beforeSendLabel} returned \`null\`, will not send event.`);
            }
            const session = currentScope.getSession() || isolationScope.getSession();
            if (isError && session) this._updateSessionFromEvent(session, processedEvent);
            if (isTransaction) {
                const spanCountBefore = processedEvent.sdkProcessingMetadata?.spanCountBeforeProcessing || 0;
                const spanCountAfter = processedEvent.spans ? processedEvent.spans.length : 0;
                const droppedSpanCount = spanCountBefore - spanCountAfter;
                if (droppedSpanCount > 0) this.recordDroppedEvent('before_send', 'span', droppedSpanCount);
            }
            // None of the Sentry built event processor will update transaction name,
            // so if the transaction name has been changed by an event processor, we know
            // it has to come from custom event processor added by a user
            const transactionInfo = processedEvent.transaction_info;
            if (isTransaction && transactionInfo && processedEvent.transaction !== event.transaction) {
                const source = 'custom';
                processedEvent.transaction_info = {
                    ...transactionInfo,
                    source: source
                };
            }
            this.sendEvent(processedEvent, hint);
            return processedEvent;
        }).then(null, (reason)=>{
            if ($bcff9e27a91c274c$var$_isDoNotSendEventError(reason) || $bcff9e27a91c274c$var$_isInternalError(reason)) throw reason;
            this.captureException(reason, {
                mechanism: {
                    handled: false,
                    type: 'internal'
                },
                data: {
                    __sentry__: true
                },
                originalException: reason
            });
            throw $bcff9e27a91c274c$var$_makeInternalError(`Event processing pipeline threw an error, original event will not be sent. Details have been sent as a new event.\nReason: ${reason}`);
        });
    }
    /**
   * Occupies the client with processing and event
   */ _process(taskProducer, dataCategory) {
        this._numProcessing++;
        this._promiseBuffer.add(taskProducer).then((value)=>{
            this._numProcessing--;
            return value;
        }, (reason)=>{
            this._numProcessing--;
            if (reason === (0, $1c536e651ef5e7fd$export$c8667f1887a128dc)) this.recordDroppedEvent('queue_overflow', dataCategory);
            return reason;
        });
    }
    /**
   * Clears outcomes on this client and returns them.
   */ _clearOutcomes() {
        const outcomes = this._outcomes;
        this._outcomes = {};
        return Object.entries(outcomes).map(([key, quantity])=>{
            const [reason, category] = key.split(':');
            return {
                reason: reason,
                category: category,
                quantity: quantity
            };
        });
    }
    /**
   * Sends client reports as an envelope.
   */ _flushOutcomes() {
        (0, $6d193f2c2b007873$export$16a28057038b10ef) && (0, $6ed5aee3203eab87$export$1c9f709888824e05).log('Flushing outcomes...');
        const outcomes = this._clearOutcomes();
        if (outcomes.length === 0) {
            (0, $6d193f2c2b007873$export$16a28057038b10ef) && (0, $6ed5aee3203eab87$export$1c9f709888824e05).log('No outcomes to send');
            return;
        }
        // This is really the only place where we want to check for a DSN and only send outcomes then
        if (!this._dsn) {
            (0, $6d193f2c2b007873$export$16a28057038b10ef) && (0, $6ed5aee3203eab87$export$1c9f709888824e05).log('No dsn provided, will not send outcomes');
            return;
        }
        (0, $6d193f2c2b007873$export$16a28057038b10ef) && (0, $6ed5aee3203eab87$export$1c9f709888824e05).log('Sending outcomes:', outcomes);
        const envelope = (0, $625c2d2f599f2b16$export$f3b9ed77c03eeb00)(outcomes, this._options.tunnel && (0, $a6fcb45f188ebaa3$export$44d472fbb931a776)(this._dsn));
        // sendEnvelope should not throw
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this.sendEnvelope(envelope);
    }
}
function $bcff9e27a91c274c$var$getDataCategoryByType(type) {
    return type === 'replay_event' ? 'replay' : type || 'error';
}
/**
 * Verifies that return value of configured `beforeSend` or `beforeSendTransaction` is of expected type, and returns the value if so.
 */ function $bcff9e27a91c274c$var$_validateBeforeSendResult(beforeSendResult, beforeSendLabel) {
    const invalidValueError = `${beforeSendLabel} must return \`null\` or a valid event.`;
    if ((0, $d1f309ce92d0a600$export$f5b060c2914b97c8)(beforeSendResult)) return beforeSendResult.then((event)=>{
        if (!(0, $d1f309ce92d0a600$export$53b83ca8eaab0383)(event) && event !== null) throw $bcff9e27a91c274c$var$_makeInternalError(invalidValueError);
        return event;
    }, (e)=>{
        throw $bcff9e27a91c274c$var$_makeInternalError(`${beforeSendLabel} rejected with ${e}`);
    });
    else if (!(0, $d1f309ce92d0a600$export$53b83ca8eaab0383)(beforeSendResult) && beforeSendResult !== null) throw $bcff9e27a91c274c$var$_makeInternalError(invalidValueError);
    return beforeSendResult;
}
/**
 * Process the matching `beforeSendXXX` callback.
 */ function $bcff9e27a91c274c$var$processBeforeSend(client, options, event, hint) {
    const { beforeSend: beforeSend, beforeSendTransaction: beforeSendTransaction, ignoreSpans: ignoreSpans } = options;
    const beforeSendSpan = !(0, $293b68f2928b71c3$export$ca3e1ec3cdcc76ac)(options.beforeSendSpan) && options.beforeSendSpan;
    let processedEvent = event;
    if ($bcff9e27a91c274c$var$isErrorEvent(processedEvent) && beforeSend) return beforeSend(processedEvent, hint);
    if ($bcff9e27a91c274c$var$isTransactionEvent(processedEvent)) {
        // Avoid processing if we don't have to
        if (beforeSendSpan || ignoreSpans) {
            // 1. Process root span
            const rootSpanJson = (0, $f087085480fe1273$export$d9c6b2464b0a687e)(processedEvent);
            // 1.1 If the root span should be ignored, drop the whole transaction
            if (ignoreSpans?.length && (0, $bdbac37f17ad9b0f$export$5d569ac97c389400)(rootSpanJson, ignoreSpans)) // dropping the whole transaction!
            return null;
            // 1.2 If a `beforeSendSpan` callback is defined, process the root span
            if (beforeSendSpan) {
                const processedRootSpanJson = beforeSendSpan(rootSpanJson);
                if (!processedRootSpanJson) (0, $cdd7dc1c144c1b85$export$d11691ff45a3e535)();
                else // update event with processed root span values
                processedEvent = (0, $cc0188753ac1c798$export$4950aa0f605343fb)(event, (0, $f087085480fe1273$export$f2d8fce5ae150e92)(processedRootSpanJson));
            }
            // 2. Process child spans
            if (processedEvent.spans) {
                const processedSpans = [];
                const initialSpans = processedEvent.spans;
                for (const span of initialSpans){
                    // 2.a If the child span should be ignored, reparent it to the root span
                    if (ignoreSpans?.length && (0, $bdbac37f17ad9b0f$export$5d569ac97c389400)(span, ignoreSpans)) {
                        (0, $bdbac37f17ad9b0f$export$ddf57376e818b444)(initialSpans, span);
                        continue;
                    }
                    // 2.b If a `beforeSendSpan` callback is defined, process the child span
                    if (beforeSendSpan) {
                        const processedSpan = beforeSendSpan(span);
                        if (!processedSpan) {
                            (0, $cdd7dc1c144c1b85$export$d11691ff45a3e535)();
                            processedSpans.push(span);
                        } else processedSpans.push(processedSpan);
                    } else processedSpans.push(span);
                }
                const droppedSpans = processedEvent.spans.length - processedSpans.length;
                if (droppedSpans) client.recordDroppedEvent('before_send', 'span', droppedSpans);
                processedEvent.spans = processedSpans;
            }
        }
        if (beforeSendTransaction) {
            if (processedEvent.spans) {
                // We store the # of spans before processing in SDK metadata,
                // so we can compare it afterwards to determine how many spans were dropped
                const spanCountBefore = processedEvent.spans.length;
                processedEvent.sdkProcessingMetadata = {
                    ...event.sdkProcessingMetadata,
                    spanCountBeforeProcessing: spanCountBefore
                };
            }
            return beforeSendTransaction(processedEvent, hint);
        }
    }
    return processedEvent;
}
function $bcff9e27a91c274c$var$isErrorEvent(event) {
    return event.type === undefined;
}
function $bcff9e27a91c274c$var$isTransactionEvent(event) {
    return event.type === 'transaction';
}
/**
 * Estimate the size of a metric in bytes.
 *
 * @param metric - The metric to estimate the size of.
 * @returns The estimated size of the metric in bytes.
 */ function $bcff9e27a91c274c$var$estimateMetricSizeInBytes(metric) {
    let weight = 0;
    // Estimate byte size of 2 bytes per character. This is a rough estimate JS strings are stored as UTF-16.
    if (metric.name) weight += metric.name.length * 2;
    // Add weight for number
    weight += 8;
    return weight + $bcff9e27a91c274c$var$estimateAttributesSizeInBytes(metric.attributes);
}
/**
 * Estimate the size of a log in bytes.
 *
 * @param log - The log to estimate the size of.
 * @returns The estimated size of the log in bytes.
 */ function $bcff9e27a91c274c$var$estimateLogSizeInBytes(log) {
    let weight = 0;
    // Estimate byte size of 2 bytes per character. This is a rough estimate JS strings are stored as UTF-16.
    if (log.message) weight += log.message.length * 2;
    return weight + $bcff9e27a91c274c$var$estimateAttributesSizeInBytes(log.attributes);
}
/**
 * Estimate the size of attributes in bytes.
 *
 * @param attributes - The attributes object to estimate the size of.
 * @returns The estimated size of the attributes in bytes.
 */ function $bcff9e27a91c274c$var$estimateAttributesSizeInBytes(attributes) {
    if (!attributes) return 0;
    let weight = 0;
    Object.values(attributes).forEach((value)=>{
        if (Array.isArray(value)) weight += value.length * $bcff9e27a91c274c$var$estimatePrimitiveSizeInBytes(value[0]);
        else if ((0, $d1f309ce92d0a600$export$c3825b437cbdea5c)(value)) weight += $bcff9e27a91c274c$var$estimatePrimitiveSizeInBytes(value);
        else // For objects values, we estimate the size of the object as 100 bytes
        weight += 100;
    });
    return weight;
}
function $bcff9e27a91c274c$var$estimatePrimitiveSizeInBytes(value) {
    if (typeof value === 'string') return value.length * 2;
    else if (typeof value === 'number') return 8;
    else if (typeof value === 'boolean') return 4;
    return 0;
}

/*
 * This module exists for optimizations in the build process through rollup and terser.  We define some global
 * constants, which can be overridden during build. By guarding certain pieces of code with functions that return these
 * constants, we can control whether or not they appear in the final bundle. (Any code guarded by a false condition will
 * never run, and will hence be dropped during treeshaking.) The two primary uses for this are stripping out calls to
 * `debug` and preventing node-related code from appearing in browser bundles.
 *
 * Attention:
 * This file should not be used to define constants/flags that are intended to be used for tree-shaking conducted by
 * users. These flags should live in their respective packages, as we identified user tooling (specifically webpack)
 * having issues tree-shaking these constants across package boundaries.
 * An example for this is the __SENTRY_DEBUG__ constant. It is declared in each package individually because we want
 * users to be able to shake away expressions that it guards.
 */ /**
 * Figures out if we're building a browser bundle.
 *
 * @returns true if this is a browser bundle build.
 */ function $90e01dff1743b442$export$2928c40372e623c0() {
    return typeof __SENTRY_BROWSER_BUNDLE__ !== 'undefined' && !!__SENTRY_BROWSER_BUNDLE__;
}
/**
 * Get source of SDK.
 */ function $90e01dff1743b442$export$8ad33f488b1ab046() {
    // This comment is used to identify this line in the CDN bundle build step and replace this with "return 'cdn';"
    /* __SENTRY_SDK_SOURCE__ */ return 'npm';
}






/**
 * Extracts stack frames from the error.stack string
 */ function $7d2e448d19f95de9$export$d478b2c12fbcfdda(stackParser, error) {
    return stackParser(error.stack || '', 1);
}
function $7d2e448d19f95de9$var$hasSentryFetchUrlHost(error) {
    return (0, $d1f309ce92d0a600$export$e6127cc7fe7395c3)(error) && '__sentry_fetch_url_host__' in error && typeof error.__sentry_fetch_url_host__ === 'string';
}
/**
 * Enhances the error message with the hostname for better Sentry error reporting.
 * This allows third-party packages to still match on the original error message,
 * while Sentry gets the enhanced version with context.
 *
 * Only used internally
 * @hidden
 */ function $7d2e448d19f95de9$export$35a730c8874c1024(error) {
    // If the error has a __sentry_fetch_url_host__ property (added by fetch instrumentation),
    // enhance the error message with the hostname.
    if ($7d2e448d19f95de9$var$hasSentryFetchUrlHost(error)) return `${error.message} (${error.__sentry_fetch_url_host__})`;
    return error.message;
}
/**
 * Extracts stack frames from the error and builds a Sentry Exception
 */ function $7d2e448d19f95de9$export$a6c2d27607295951(stackParser, error) {
    const exception = {
        type: error.name || error.constructor.name,
        value: $7d2e448d19f95de9$export$35a730c8874c1024(error)
    };
    const frames = $7d2e448d19f95de9$export$d478b2c12fbcfdda(stackParser, error);
    if (frames.length) exception.stacktrace = {
        frames: frames
    };
    return exception;
}
/** If a plain object has a property that is an `Error`, return this error. */ function $7d2e448d19f95de9$var$getErrorPropertyFromObject(obj) {
    for(const prop in obj)if (Object.prototype.hasOwnProperty.call(obj, prop)) {
        const value = obj[prop];
        if (value instanceof Error) return value;
    }
    return undefined;
}
function $7d2e448d19f95de9$var$getMessageForObject(exception) {
    if ('name' in exception && typeof exception.name === 'string') {
        let message = `'${exception.name}' captured as exception`;
        if ('message' in exception && typeof exception.message === 'string') message += ` with message '${exception.message}'`;
        return message;
    } else if ('message' in exception && typeof exception.message === 'string') return exception.message;
    const keys = (0, $10696cb2974e7335$export$b0244d5063c0b61b)(exception);
    // Some ErrorEvent instances do not have an `error` property, which is why they are not handled before
    // We still want to try to get a decent message for these cases
    if ((0, $d1f309ce92d0a600$export$9f9636d330b71954)(exception)) return `Event \`ErrorEvent\` captured as exception with message \`${exception.message}\``;
    const className = $7d2e448d19f95de9$var$getObjectClassName(exception);
    return `${className && className !== 'Object' ? `'${className}'` : 'Object'} captured as exception with keys: ${keys}`;
}
function $7d2e448d19f95de9$var$getObjectClassName(obj) {
    try {
        const prototype = Object.getPrototypeOf(obj);
        return prototype ? prototype.constructor.name : undefined;
    } catch  {
    // ignore errors here
    }
}
function $7d2e448d19f95de9$var$getException(client, mechanism, exception, hint) {
    if ((0, $d1f309ce92d0a600$export$e6127cc7fe7395c3)(exception)) return [
        exception,
        undefined
    ];
    // Mutate this!
    mechanism.synthetic = true;
    if ((0, $d1f309ce92d0a600$export$53b83ca8eaab0383)(exception)) {
        const normalizeDepth = client?.getOptions().normalizeDepth;
        const extras = {
            ['__serialized__']: (0, $a4ca5def21866c8a$export$23fbbb20bed71033)(exception, normalizeDepth)
        };
        const errorFromProp = $7d2e448d19f95de9$var$getErrorPropertyFromObject(exception);
        if (errorFromProp) return [
            errorFromProp,
            extras
        ];
        const message = $7d2e448d19f95de9$var$getMessageForObject(exception);
        const ex = hint?.syntheticException || new Error(message);
        ex.message = message;
        return [
            ex,
            extras
        ];
    }
    // This handles when someone does: `throw "something awesome";`
    // We use synthesized Error here so we can extract a (rough) stack trace.
    const ex = hint?.syntheticException || new Error(exception);
    ex.message = `${exception}`;
    return [
        ex,
        undefined
    ];
}
/**
 * Builds and Event from a Exception
 * @hidden
 */ function $7d2e448d19f95de9$export$9dd56ed1ef0c3420(client, stackParser, exception, hint) {
    const providedMechanism = hint?.data && hint.data.mechanism;
    const mechanism = providedMechanism || {
        handled: true,
        type: 'generic'
    };
    const [ex, extras] = $7d2e448d19f95de9$var$getException(client, mechanism, exception, hint);
    const event = {
        exception: {
            values: [
                $7d2e448d19f95de9$export$a6c2d27607295951(stackParser, ex)
            ]
        }
    };
    if (extras) event.extra = extras;
    (0, $76366c1ad7fe29b9$export$f26508487bf83ee7)(event, undefined, undefined);
    (0, $76366c1ad7fe29b9$export$c69a9a0313b03bb1)(event, mechanism);
    return {
        ...event,
        event_id: hint?.event_id
    };
}
/**
 * Builds and Event from a Message
 * @hidden
 */ function $7d2e448d19f95de9$export$5425b53185d13d6c(stackParser, message, level = 'info', hint, attachStacktrace) {
    const event = {
        event_id: hint?.event_id,
        level: level
    };
    if (attachStacktrace && hint?.syntheticException) {
        const frames = $7d2e448d19f95de9$export$d478b2c12fbcfdda(stackParser, hint.syntheticException);
        if (frames.length) {
            event.exception = {
                values: [
                    {
                        value: message,
                        stacktrace: {
                            frames: frames
                        }
                    }
                ]
            };
            (0, $76366c1ad7fe29b9$export$c69a9a0313b03bb1)(event, {
                synthetic: true
            });
        }
    }
    if ((0, $d1f309ce92d0a600$export$dbcbffa59149b824)(message)) {
        const { __sentry_template_string__: __sentry_template_string__, __sentry_template_values__: __sentry_template_values__ } = message;
        event.logentry = {
            message: __sentry_template_string__,
            params: __sentry_template_values__
        };
        return event;
    }
    event.message = message;
    return event;
}


/**
 * This function creates an exception from a JavaScript Error
 */ function $baf0df795659509d$export$a6c2d27607295951(stackParser, ex) {
    // Get the frames first since Opera can lose the stack if we touch anything else first
    const frames = $baf0df795659509d$var$parseStackFrames(stackParser, ex);
    const exception = {
        type: $baf0df795659509d$export$2e9ae379995d99e3(ex),
        value: $baf0df795659509d$export$86005d1b62804363(ex)
    };
    if (frames.length) exception.stacktrace = {
        frames: frames
    };
    if (exception.type === undefined && exception.value === '') exception.value = 'Unrecoverable error caught';
    return exception;
}
function $baf0df795659509d$var$eventFromPlainObject(stackParser, exception, syntheticException, isUnhandledRejection) {
    const client = (0, $6c9d57d6c1e4fcbb$export$6bb76d6eba7e258c)();
    const normalizeDepth = client?.getOptions().normalizeDepth;
    // If we can, we extract an exception from the object properties
    const errorFromProp = $baf0df795659509d$var$getErrorPropertyFromObject(exception);
    const extra = {
        __serialized__: (0, $a4ca5def21866c8a$export$23fbbb20bed71033)(exception, normalizeDepth)
    };
    if (errorFromProp) return {
        exception: {
            values: [
                $baf0df795659509d$export$a6c2d27607295951(stackParser, errorFromProp)
            ]
        },
        extra: extra
    };
    const event = {
        exception: {
            values: [
                {
                    type: (0, $d1f309ce92d0a600$export$9671ea99bd126ace)(exception) ? exception.constructor.name : isUnhandledRejection ? 'UnhandledRejection' : 'Error',
                    value: $baf0df795659509d$var$getNonErrorObjectExceptionValue(exception, {
                        isUnhandledRejection: isUnhandledRejection
                    })
                }
            ]
        },
        extra: extra
    };
    if (syntheticException) {
        const frames = $baf0df795659509d$var$parseStackFrames(stackParser, syntheticException);
        if (frames.length) // event.exception.values[0] has been set above
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        event.exception.values[0].stacktrace = {
            frames: frames
        };
    }
    return event;
}
function $baf0df795659509d$var$eventFromError(stackParser, ex) {
    return {
        exception: {
            values: [
                $baf0df795659509d$export$a6c2d27607295951(stackParser, ex)
            ]
        }
    };
}
/** Parses stack frames from an error */ function $baf0df795659509d$var$parseStackFrames(stackParser, ex) {
    // Access and store the stacktrace property before doing ANYTHING
    // else to it because Opera is not very good at providing it
    // reliably in other circumstances.
    const stacktrace = ex.stacktrace || ex.stack || '';
    const skipLines = $baf0df795659509d$var$getSkipFirstStackStringLines(ex);
    const framesToPop = $baf0df795659509d$var$getPopFirstTopFrames(ex);
    try {
        return stackParser(stacktrace, skipLines, framesToPop);
    } catch  {
    // no-empty
    }
    return [];
}
// Based on our own mapping pattern - https://github.com/getsentry/sentry/blob/9f08305e09866c8bd6d0c24f5b0aabdd7dd6c59c/src/sentry/lang/javascript/errormapping.py#L83-L108
const $baf0df795659509d$var$reactMinifiedRegexp = /Minified React error #\d+;/i;
/**
 * Certain known React errors contain links that would be falsely
 * parsed as frames. This function check for these errors and
 * returns number of the stack string lines to skip.
 */ function $baf0df795659509d$var$getSkipFirstStackStringLines(ex) {
    if (ex && $baf0df795659509d$var$reactMinifiedRegexp.test(ex.message)) return 1;
    return 0;
}
/**
 * If error has `framesToPop` property, it means that the
 * creator tells us the first x frames will be useless
 * and should be discarded. Typically error from wrapper function
 * which don't point to the actual location in the developer's code.
 *
 * Example: https://github.com/zertosh/invariant/blob/master/invariant.js#L46
 */ function $baf0df795659509d$var$getPopFirstTopFrames(ex) {
    if (typeof ex.framesToPop === 'number') return ex.framesToPop;
    return 0;
}
// https://developer.mozilla.org/en-US/docs/WebAssembly/JavaScript_interface/Exception
// @ts-expect-error - WebAssembly.Exception is a valid class
function $baf0df795659509d$var$isWebAssemblyException(exception) {
    // Check for support
    // @ts-expect-error - WebAssembly.Exception is a valid class
    // oxlint-disable-next-line typescript/prefer-optional-chain
    if (typeof WebAssembly !== 'undefined' && typeof WebAssembly.Exception !== 'undefined') // @ts-expect-error - WebAssembly.Exception is a valid class
    return exception instanceof WebAssembly.Exception;
    else return false;
}
/**
 * Extracts from errors what we use as the exception `type` in error events.
 *
 * Usually, this is the `name` property on Error objects but WASM errors need to be treated differently.
 */ function $baf0df795659509d$export$2e9ae379995d99e3(ex) {
    const name = ex?.name;
    // The name for WebAssembly.Exception Errors needs to be extracted differently.
    // Context: https://github.com/getsentry/sentry-javascript/issues/13787
    if (!name && $baf0df795659509d$var$isWebAssemblyException(ex)) {
        // Emscripten sets array[type, message] to the "message" property on the WebAssembly.Exception object
        const hasTypeInMessage = ex.message && Array.isArray(ex.message) && ex.message.length == 2;
        return hasTypeInMessage ? ex.message[0] : 'WebAssembly.Exception';
    }
    return name;
}
/**
 * There are cases where stacktrace.message is an Event object
 * https://github.com/getsentry/sentry-javascript/issues/1949
 * In this specific case we try to extract stacktrace.message.error.message
 */ function $baf0df795659509d$export$86005d1b62804363(ex) {
    const message = ex?.message;
    if ($baf0df795659509d$var$isWebAssemblyException(ex)) {
        // For Node 18, Emscripten sets array[type, message] to the "message" property on the WebAssembly.Exception object
        if (Array.isArray(ex.message) && ex.message.length == 2) return ex.message[1];
        return 'wasm exception';
    }
    if (!message) return 'No error message';
    if (message.error && typeof message.error.message === 'string') return (0, $7d2e448d19f95de9$export$35a730c8874c1024)(message.error);
    return (0, $7d2e448d19f95de9$export$35a730c8874c1024)(ex);
}
/**
 * Creates an {@link Event} from all inputs to `captureException` and non-primitive inputs to `captureMessage`.
 * @hidden
 */ function $baf0df795659509d$export$ea3ec7e569b823fc(stackParser, exception, hint, attachStacktrace) {
    const syntheticException = hint?.syntheticException || undefined;
    const event = $baf0df795659509d$export$9dd56ed1ef0c3420(stackParser, exception, syntheticException, attachStacktrace);
    (0, $76366c1ad7fe29b9$export$c69a9a0313b03bb1)(event); // defaults to { type: 'generic', handled: true }
    event.level = 'error';
    if (hint?.event_id) event.event_id = hint.event_id;
    return (0, $d656c4fbd69077c0$export$1fda8aa4d135f8aa)(event);
}
/**
 * Builds and Event from a Message
 * @hidden
 */ function $baf0df795659509d$export$5425b53185d13d6c(stackParser, message, level = 'info', hint, attachStacktrace) {
    const syntheticException = hint?.syntheticException || undefined;
    const event = $baf0df795659509d$var$eventFromString(stackParser, message, syntheticException, attachStacktrace);
    event.level = level;
    if (hint?.event_id) event.event_id = hint.event_id;
    return (0, $d656c4fbd69077c0$export$1fda8aa4d135f8aa)(event);
}
/**
 * @hidden
 */ function $baf0df795659509d$export$9dd56ed1ef0c3420(stackParser, exception, syntheticException, attachStacktrace, isUnhandledRejection) {
    let event;
    if ((0, $d1f309ce92d0a600$export$9f9636d330b71954)(exception) && exception.error) {
        // If it is an ErrorEvent with `error` property, extract it to get actual Error
        const errorEvent = exception;
        return $baf0df795659509d$var$eventFromError(stackParser, errorEvent.error);
    }
    // If it is a `DOMError` (which is a legacy API, but still supported in some browsers) then we just extract the name
    // and message, as it doesn't provide anything else. According to the spec, all `DOMExceptions` should also be
    // `Error`s, but that's not the case in IE11, so in that case we treat it the same as we do a `DOMError`.
    //
    // https://developer.mozilla.org/en-US/docs/Web/API/DOMError
    // https://developer.mozilla.org/en-US/docs/Web/API/DOMException
    // https://webidl.spec.whatwg.org/#es-DOMException-specialness
    if ((0, $d1f309ce92d0a600$export$ef9e2056653f0c8e)(exception) || (0, $d1f309ce92d0a600$export$12e869b2a583f783)(exception)) {
        const domException = exception;
        if ('stack' in exception) event = $baf0df795659509d$var$eventFromError(stackParser, exception);
        else {
            const name = domException.name || ((0, $d1f309ce92d0a600$export$ef9e2056653f0c8e)(domException) ? 'DOMError' : 'DOMException');
            const message = domException.message ? `${name}: ${domException.message}` : name;
            event = $baf0df795659509d$var$eventFromString(stackParser, message, syntheticException, attachStacktrace);
            (0, $76366c1ad7fe29b9$export$f26508487bf83ee7)(event, message);
        }
        if ('code' in domException) // eslint-disable-next-line deprecation/deprecation
        event.tags = {
            ...event.tags,
            'DOMException.code': `${domException.code}`
        };
        return event;
    }
    if ((0, $d1f309ce92d0a600$export$e6127cc7fe7395c3)(exception)) // we have a real Error object, do nothing
    return $baf0df795659509d$var$eventFromError(stackParser, exception);
    if ((0, $d1f309ce92d0a600$export$53b83ca8eaab0383)(exception) || (0, $d1f309ce92d0a600$export$9671ea99bd126ace)(exception)) {
        // If it's a plain object or an instance of `Event` (the built-in JS kind, not this SDK's `Event` type), serialize
        // it manually. This will allow us to group events based on top-level keys which is much better than creating a new
        // group on any key/value change.
        const objectException = exception;
        event = $baf0df795659509d$var$eventFromPlainObject(stackParser, objectException, syntheticException, isUnhandledRejection);
        (0, $76366c1ad7fe29b9$export$c69a9a0313b03bb1)(event, {
            synthetic: true
        });
        return event;
    }
    // If none of previous checks were valid, then it means that it's not:
    // - an instance of DOMError
    // - an instance of DOMException
    // - an instance of Event
    // - an instance of Error
    // - a valid ErrorEvent (one with an error property)
    // - a plain Object
    //
    // So bail out and capture it as a simple message:
    event = $baf0df795659509d$var$eventFromString(stackParser, exception, syntheticException, attachStacktrace);
    (0, $76366c1ad7fe29b9$export$f26508487bf83ee7)(event, `${exception}`, undefined);
    (0, $76366c1ad7fe29b9$export$c69a9a0313b03bb1)(event, {
        synthetic: true
    });
    return event;
}
function $baf0df795659509d$var$eventFromString(stackParser, message, syntheticException, attachStacktrace) {
    const event = {};
    if (attachStacktrace && syntheticException) {
        const frames = $baf0df795659509d$var$parseStackFrames(stackParser, syntheticException);
        if (frames.length) event.exception = {
            values: [
                {
                    value: message,
                    stacktrace: {
                        frames: frames
                    }
                }
            ]
        };
        (0, $76366c1ad7fe29b9$export$c69a9a0313b03bb1)(event, {
            synthetic: true
        });
    }
    if ((0, $d1f309ce92d0a600$export$dbcbffa59149b824)(message)) {
        const { __sentry_template_string__: __sentry_template_string__, __sentry_template_values__: __sentry_template_values__ } = message;
        event.logentry = {
            message: __sentry_template_string__,
            params: __sentry_template_values__
        };
        return event;
    }
    event.message = message;
    return event;
}
function $baf0df795659509d$var$getNonErrorObjectExceptionValue(exception, { isUnhandledRejection: isUnhandledRejection }) {
    const keys = (0, $10696cb2974e7335$export$b0244d5063c0b61b)(exception);
    const captureType = isUnhandledRejection ? 'promise rejection' : 'exception';
    // Some ErrorEvent instances do not have an `error` property, which is why they are not handled before
    // We still want to try to get a decent message for these cases
    if ((0, $d1f309ce92d0a600$export$9f9636d330b71954)(exception)) return `Event \`ErrorEvent\` captured as ${captureType} with message \`${exception.message}\``;
    if ((0, $d1f309ce92d0a600$export$9671ea99bd126ace)(exception)) {
        const className = $baf0df795659509d$var$getObjectClassName(exception);
        return `Event \`${className}\` (type=${exception.type}) captured as ${captureType}`;
    }
    return `Object captured as ${captureType} with keys: ${keys}`;
}
function $baf0df795659509d$var$getObjectClassName(obj) {
    try {
        const prototype = Object.getPrototypeOf(obj);
        return prototype ? prototype.constructor.name : undefined;
    } catch  {
    // ignore errors here
    }
}
/** If a plain object has a property that is an `Error`, return this error. */ function $baf0df795659509d$var$getErrorPropertyFromObject(obj) {
    return Object.values(obj).find((v)=>v instanceof Error);
}














/* eslint-disable */ // Vendor "Awaited" in to be TS 3.8 compatible
/**
 * Wrap a callback function with error handling.
 * If an error is thrown, it will be passed to the `onError` callback and re-thrown.
 *
 * If the return value of the function is a promise, it will be handled with `maybeHandlePromiseRejection`.
 *
 * If an `onFinally` callback is provided, this will be called when the callback has finished
 * - so if it returns a promise, once the promise resolved/rejected,
 * else once the callback has finished executing.
 * The `onFinally` callback will _always_ be called, no matter if an error was thrown or not.
 */ function $a0da8200e71b06d2$export$18ce21a8b7efd7e9(fn, onError, onFinally = ()=>{}, onSuccess = ()=>{}) {
    let maybePromiseResult;
    try {
        maybePromiseResult = fn();
    } catch (e) {
        onError(e);
        onFinally();
        throw e;
    }
    return $a0da8200e71b06d2$var$maybeHandlePromiseRejection(maybePromiseResult, onError, onFinally, onSuccess);
}
/**
 * Maybe handle a promise rejection.
 * This expects to be given a value that _may_ be a promise, or any other value.
 * If it is a promise, and it rejects, it will call the `onError` callback.
 *
 * For thenable objects with extra methods (like jQuery's jqXHR),
 * this function preserves those methods by wrapping the original thenable in a Proxy
 * that intercepts .then() calls to apply error handling while forwarding all other
 * properties to the original object.
 * This allows code like `startSpan(() => $.ajax(...)).abort()` to work correctly.
 */ function $a0da8200e71b06d2$var$maybeHandlePromiseRejection(value, onError, onFinally, onSuccess) {
    if ((0, $d1f309ce92d0a600$export$f5b060c2914b97c8)(value)) return (0, $cb384223cf1427f4$export$64da0f40b0f924ba)(value, (result)=>{
        onFinally();
        onSuccess(result);
    }, (err)=>{
        onError(err);
        onFinally();
    });
    // Non-thenable value - call callbacks immediately and return as-is
    onFinally();
    onSuccess(value);
    return value;
}




/**
 * Determines if span streaming is enabled for the given client
 */ function $fd377a3bf49bd1d2$export$6ea47215d699c04a(client) {
    return client.getOptions().traceLifecycle === 'stream';
}












/**
 * Print a log message for a started span.
 */ function $694f052c23ba49e0$export$2f3d84e767c9592b(span) {
    if (!(0, $6d193f2c2b007873$export$16a28057038b10ef)) return;
    const { description: description = '< unknown name >', op: op = '< unknown op >', parent_span_id: parentSpanId } = (0, $cdd7dc1c144c1b85$export$92d8c23565496537)(span);
    const { spanId: spanId } = span.spanContext();
    const sampled = (0, $cdd7dc1c144c1b85$export$5caecac1caaf3a71)(span);
    const rootSpan = (0, $cdd7dc1c144c1b85$export$c4c6a79b1260ca1b)(span);
    const isRootSpan = rootSpan === span;
    const header = `[Tracing] Starting ${sampled ? 'sampled' : 'unsampled'} ${isRootSpan ? 'root ' : ''}span`;
    const infoParts = [
        `op: ${op}`,
        `name: ${description}`,
        `ID: ${spanId}`
    ];
    if (parentSpanId) infoParts.push(`parent ID: ${parentSpanId}`);
    if (!isRootSpan) {
        const { op: op, description: description } = (0, $cdd7dc1c144c1b85$export$92d8c23565496537)(rootSpan);
        infoParts.push(`root ID: ${rootSpan.spanContext().spanId}`);
        if (op) infoParts.push(`root op: ${op}`);
        if (description) infoParts.push(`root description: ${description}`);
    }
    (0, $6ed5aee3203eab87$export$1c9f709888824e05).log(`${header}
  ${infoParts.join('\n  ')}`);
}
/**
 * Print a log message for an ended span.
 */ function $694f052c23ba49e0$export$b77c830667a4d630(span) {
    if (!(0, $6d193f2c2b007873$export$16a28057038b10ef)) return;
    const { description: description = '< unknown name >', op: op = '< unknown op >' } = (0, $cdd7dc1c144c1b85$export$92d8c23565496537)(span);
    const { spanId: spanId } = span.spanContext();
    const rootSpan = (0, $cdd7dc1c144c1b85$export$c4c6a79b1260ca1b)(span);
    const isRootSpan = rootSpan === span;
    const msg = `[Tracing] Finishing "${op}" ${isRootSpan ? 'root ' : ''}span "${description}" with ID ${spanId}`;
    (0, $6ed5aee3203eab87$export$1c9f709888824e05).log(msg);
}






/**
 * Makes a sampling decision for the given options.
 *
 * Called every time a root span is created. Only root spans which emerge with a `sampled` value of `true` will be
 * sent to Sentry.
 */ function $dc72326dd7c1f751$export$5f833db634b217bb(options, samplingContext, sampleRand) {
    // nothing to do if span recording is not enabled
    if (!(0, $3db87d4df304f81d$export$1f70765132c3c225)(options)) return [
        false
    ];
    let localSampleRateWasApplied = undefined;
    // we would have bailed already if neither `tracesSampler` nor `tracesSampleRate` were defined, so one of these should
    // work; prefer the hook if so
    let sampleRate;
    if (typeof options.tracesSampler === 'function') {
        sampleRate = options.tracesSampler({
            ...samplingContext,
            inheritOrSampleWith: (fallbackSampleRate)=>{
                // If we have an incoming parent sample rate, we'll just use that one.
                // The sampling decision will be inherited because of the sample_rand that was generated when the trace reached the incoming boundaries of the SDK.
                if (typeof samplingContext.parentSampleRate === 'number') return samplingContext.parentSampleRate;
                // Fallback if parent sample rate is not on the incoming trace (e.g. if there is no baggage)
                // This is to provide backwards compatibility if there are incoming traces from older SDKs that don't send a parent sample rate or a sample rand. In these cases we just want to force either a sampling decision on the downstream traces via the sample rate.
                if (typeof samplingContext.parentSampled === 'boolean') return Number(samplingContext.parentSampled);
                return fallbackSampleRate;
            }
        });
        localSampleRateWasApplied = true;
    } else if (samplingContext.parentSampled !== undefined) sampleRate = samplingContext.parentSampled;
    else if (typeof options.tracesSampleRate !== 'undefined') {
        sampleRate = options.tracesSampleRate;
        localSampleRateWasApplied = true;
    }
    // Since this is coming from the user (or from a function provided by the user), who knows what we might get.
    // (The only valid values are booleans or numbers between 0 and 1.)
    const parsedSampleRate = (0, $77c0cd7d06293a86$export$a5bd2d81656d9546)(sampleRate);
    if (parsedSampleRate === undefined) {
        (0, $6d193f2c2b007873$export$16a28057038b10ef) && (0, $6ed5aee3203eab87$export$1c9f709888824e05).warn(`[Tracing] Discarding root span because of invalid sample rate. Sample rate must be a boolean or a number between 0 and 1. Got ${JSON.stringify(sampleRate)} of type ${JSON.stringify(typeof sampleRate)}.`);
        return [
            false
        ];
    }
    // if the function returned 0 (or false), or if `tracesSampleRate` is 0, it's a sign the transaction should be dropped
    if (!parsedSampleRate) {
        (0, $6d193f2c2b007873$export$16a28057038b10ef) && (0, $6ed5aee3203eab87$export$1c9f709888824e05).log(`[Tracing] Discarding transaction because ${typeof options.tracesSampler === 'function' ? 'tracesSampler returned 0 or false' : 'a negative sampling decision was inherited or tracesSampleRate is set to 0'}`);
        return [
            false,
            parsedSampleRate,
            localSampleRateWasApplied
        ];
    }
    // We always compare the sample rand for the current execution context against the chosen sample rate.
    // Read more: https://develop.sentry.dev/sdk/telemetry/traces/#propagated-random-value
    const shouldSample = sampleRand < parsedSampleRate;
    // if we're not going to keep it, we're done
    if (!shouldSample) (0, $6d193f2c2b007873$export$16a28057038b10ef) && (0, $6ed5aee3203eab87$export$1c9f709888824e05).log(`[Tracing] Discarding transaction because it's not included in the random sample (sampling rate = ${Number(sampleRate)})`);
    return [
        shouldSample,
        parsedSampleRate,
        localSampleRateWasApplied
    ];
}




/**
 * A Sentry Span that is non-recording, meaning it will not be sent to Sentry.
 */ class $5837079298713d4b$export$d6636b700b76c516 {
    /**
   * Reason why this span was dropped, if applicable ('ignored' or 'sample_rate').
   * Used to propagate the correct client report outcome to descendant spans
   * when span streaming is enabled.
   */ constructor(spanContext = {}){
        this._traceId = spanContext.traceId || (0, $1eac0e3178cad4a9$export$dc6d7ea554bcce10)();
        this._spanId = spanContext.spanId || (0, $1eac0e3178cad4a9$export$295213bc4d0c54ad)();
        this.dropReason = spanContext.dropReason;
    }
    /** @inheritdoc */ spanContext() {
        return {
            spanId: this._spanId,
            traceId: this._traceId,
            traceFlags: (0, $cdd7dc1c144c1b85$export$208d5b368507fb8b)
        };
    }
    /** @inheritdoc */ end(_timestamp) {}
    /** @inheritdoc */ setAttribute(_key, _value) {
        return this;
    }
    /** @inheritdoc */ setAttributes(_values) {
        return this;
    }
    /** @inheritdoc */ setStatus(_status) {
        return this;
    }
    /** @inheritdoc */ updateName(_name) {
        return this;
    }
    /** @inheritdoc */ isRecording() {
        return false;
    }
    /** @inheritdoc */ addEvent(_name, _attributesOrStartTime, _startTime) {
        return this;
    }
    /** @inheritDoc */ addLink(_link) {
        return this;
    }
    /** @inheritDoc */ addLinks(_links) {
        return this;
    }
    /**
   * This should generally not be used,
   * but we need it for being compliant with the OTEL Span interface.
   *
   * @hidden
   * @internal
   */ recordException(_exception, _time) {
    // noop
    }
}
















/**
 * Adds a measurement to the active transaction on the current global scope. You can optionally pass in a different span
 * as the 4th parameter.
 */ function $c274d22f473f8327$export$7cc31b475d33a706(name, value, unit, activeSpan = (0, $cdd7dc1c144c1b85$export$1be426a8e585c83e)()) {
    const rootSpan = activeSpan && (0, $cdd7dc1c144c1b85$export$c4c6a79b1260ca1b)(activeSpan);
    if (rootSpan) {
        (0, $6d193f2c2b007873$export$16a28057038b10ef) && (0, $6ed5aee3203eab87$export$1c9f709888824e05).log(`[Measurement] Setting measurement on root span: ${name} = ${value} ${unit}`);
        rootSpan.addEvent(name, {
            [(0, $0633c8eb02923c67$export$69cd5c610c7bb96a)]: value,
            [(0, $0633c8eb02923c67$export$f5f95cff026507b5)]: unit
        });
    }
}
/**
 * Convert timed events to measurements.
 */ function $c274d22f473f8327$export$487db6fcdf36893e(events) {
    if (!events || events.length === 0) return undefined;
    const measurements = {};
    events.forEach((event)=>{
        const attributes = event.attributes || {};
        const unit = attributes[0, $0633c8eb02923c67$export$f5f95cff026507b5];
        const value = attributes[0, $0633c8eb02923c67$export$69cd5c610c7bb96a];
        if (typeof unit === 'string' && typeof value === 'number') measurements[event.name] = {
            value: value,
            unit: unit
        };
    });
    return measurements;
}




/* eslint-disable max-lines */ const $ccb59542cd39d078$var$MAX_SPAN_COUNT = 1000;
/**
 * Span contains all data about a span
 */ class $ccb59542cd39d078$export$a92149b045260d9f {
    /** Epoch timestamp in seconds when the span started. */ /** Epoch timestamp in seconds when the span ended. */ /** Internal keeper of the status */ /** The timed events added to this span. */ /** if true, treat span as a standalone span (not part of a transaction) */ /**
   * You should never call the constructor manually, always use `Sentry.startSpan()`
   * or other span methods.
   * @internal
   * @hideconstructor
   * @hidden
   */ constructor(spanContext = {}){
        this._traceId = spanContext.traceId || (0, $1eac0e3178cad4a9$export$dc6d7ea554bcce10)();
        this._spanId = spanContext.spanId || (0, $1eac0e3178cad4a9$export$295213bc4d0c54ad)();
        this._startTime = spanContext.startTimestamp || (0, $27fab3c4acc6cd95$export$ee52dced521e3e18)();
        this._links = spanContext.links;
        this._attributes = {};
        this.setAttributes({
            [(0, $0633c8eb02923c67$export$cca8dd30f57f805e)]: 'manual',
            [(0, $0633c8eb02923c67$export$1a413bd9a88fdb09)]: spanContext.op,
            ...spanContext.attributes
        });
        this._name = spanContext.name;
        if (spanContext.parentSpanId) this._parentSpanId = spanContext.parentSpanId;
        // We want to include booleans as well here
        if ('sampled' in spanContext) this._sampled = spanContext.sampled;
        if (spanContext.endTimestamp) this._endTime = spanContext.endTimestamp;
        this._events = [];
        this._isStandaloneSpan = spanContext.isStandalone;
        // If the span is already ended, ensure we finalize the span immediately
        if (this._endTime) this._onSpanEnded();
    }
    /** @inheritDoc */ addLink(link) {
        if (this._links) this._links.push(link);
        else this._links = [
            link
        ];
        return this;
    }
    /** @inheritDoc */ addLinks(links) {
        if (this._links) this._links.push(...links);
        else this._links = links;
        return this;
    }
    /**
   * This should generally not be used,
   * but it is needed for being compliant with the OTEL Span interface.
   *
   * @hidden
   * @internal
   */ recordException(_exception, _time) {
    // noop
    }
    /** @inheritdoc */ spanContext() {
        const { _spanId: spanId, _traceId: traceId, _sampled: sampled } = this;
        return {
            spanId: spanId,
            traceId: traceId,
            traceFlags: sampled ? (0, $cdd7dc1c144c1b85$export$eb571cd9b5d98de8) : (0, $cdd7dc1c144c1b85$export$208d5b368507fb8b)
        };
    }
    /** @inheritdoc */ setAttribute(key, value) {
        if (value === undefined) // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
        delete this._attributes[key];
        else this._attributes[key] = value;
        return this;
    }
    /** @inheritdoc */ setAttributes(attributes) {
        Object.keys(attributes).forEach((key)=>this.setAttribute(key, attributes[key]));
        return this;
    }
    /**
   * This should generally not be used,
   * but we need it for browser tracing where we want to adjust the start time afterwards.
   * USE THIS WITH CAUTION!
   *
   * @hidden
   * @internal
   */ updateStartTime(timeInput) {
        this._startTime = (0, $cdd7dc1c144c1b85$export$3f7581298f56c6d7)(timeInput);
    }
    /**
   * @inheritDoc
   */ setStatus(value) {
        this._status = value;
        return this;
    }
    /**
   * @inheritDoc
   */ updateName(name) {
        this._name = name;
        this.setAttribute((0, $0633c8eb02923c67$export$d7a7d984b0791405), 'custom');
        return this;
    }
    /** @inheritdoc */ end(endTimestamp) {
        // If already ended, skip
        if (this._endTime) return;
        this._endTime = (0, $cdd7dc1c144c1b85$export$3f7581298f56c6d7)(endTimestamp);
        (0, $694f052c23ba49e0$export$b77c830667a4d630)(this);
        this._onSpanEnded();
    }
    /**
   * Get JSON representation of this span.
   *
   * @hidden
   * @internal This method is purely for internal purposes and should not be used outside
   * of SDK code. If you need to get a JSON representation of a span,
   * use `spanToJSON(span)` instead.
   */ getSpanJSON() {
        return {
            data: this._attributes,
            description: this._name,
            op: this._attributes[0, $0633c8eb02923c67$export$1a413bd9a88fdb09],
            parent_span_id: this._parentSpanId,
            span_id: this._spanId,
            start_timestamp: this._startTime,
            status: (0, $cdd7dc1c144c1b85$export$e238a77ea3a8cd66)(this._status),
            timestamp: this._endTime,
            trace_id: this._traceId,
            origin: this._attributes[0, $0633c8eb02923c67$export$cca8dd30f57f805e],
            profile_id: this._attributes[0, $0633c8eb02923c67$export$1efec95406bbe327],
            exclusive_time: this._attributes[0, $0633c8eb02923c67$export$fea48ba9f4550879],
            measurements: (0, $c274d22f473f8327$export$487db6fcdf36893e)(this._events),
            is_segment: this._isStandaloneSpan && (0, $cdd7dc1c144c1b85$export$c4c6a79b1260ca1b)(this) === this || undefined,
            segment_id: this._isStandaloneSpan ? (0, $cdd7dc1c144c1b85$export$c4c6a79b1260ca1b)(this).spanContext().spanId : undefined,
            links: (0, $cdd7dc1c144c1b85$export$cb3e3a12e0eec16c)(this._links)
        };
    }
    /**
   * Get {@link StreamedSpanJSON} representation of this span.
   *
   * @hidden
   * @internal This method is purely for internal purposes and should not be used outside
   * of SDK code. If you need to get a JSON representation of a span,
   * use `spanToStreamedSpanJSON(span)` instead.
   */ getStreamedSpanJSON() {
        return {
            name: this._name ?? '',
            span_id: this._spanId,
            trace_id: this._traceId,
            parent_span_id: this._parentSpanId,
            start_timestamp: this._startTime,
            // just in case _endTime is not set, we use the start time (i.e. duration 0)
            end_timestamp: this._endTime ?? this._startTime,
            is_segment: this._isStandaloneSpan || this === (0, $cdd7dc1c144c1b85$export$c4c6a79b1260ca1b)(this),
            status: (0, $cdd7dc1c144c1b85$export$457dcd3df4e9f5c6)(this._status),
            attributes: this._attributes,
            links: (0, $cdd7dc1c144c1b85$export$9015adcf158ef3a5)(this._links)
        };
    }
    /** @inheritdoc */ isRecording() {
        return !this._endTime && !!this._sampled;
    }
    /**
   * @inheritdoc
   */ addEvent(name, attributesOrStartTime, startTime) {
        (0, $6d193f2c2b007873$export$16a28057038b10ef) && (0, $6ed5aee3203eab87$export$1c9f709888824e05).log('[Tracing] Adding an event to span:', name);
        const time = $ccb59542cd39d078$var$isSpanTimeInput(attributesOrStartTime) ? attributesOrStartTime : startTime || (0, $27fab3c4acc6cd95$export$ee52dced521e3e18)();
        const attributes = $ccb59542cd39d078$var$isSpanTimeInput(attributesOrStartTime) ? {} : attributesOrStartTime || {};
        const event = {
            name: name,
            time: (0, $cdd7dc1c144c1b85$export$3f7581298f56c6d7)(time),
            attributes: attributes
        };
        this._events.push(event);
        return this;
    }
    /**
   * This method should generally not be used,
   * but for now we need a way to publicly check if the `_isStandaloneSpan` flag is set.
   * USE THIS WITH CAUTION!
   * @internal
   * @hidden
   * @experimental
   */ isStandaloneSpan() {
        return !!this._isStandaloneSpan;
    }
    /** Emit `spanEnd` when the span is ended. */ _onSpanEnded() {
        const client = (0, $6c9d57d6c1e4fcbb$export$6bb76d6eba7e258c)();
        if (client) {
            client.emit('spanEnd', this);
            // Guarding sending standalone v1 spans as v2 streamed spans for now.
            // Otherwise they'd be sent once as v1 spans and again as streamed spans.
            // We'll migrate CLS and LCP spans to streamed spans in a later PR and
            // INP spans in the next major of the SDK. At that point, we can fully remove
            // standalone v1 spans <3
            if (!this._isStandaloneSpan) client.emit('afterSpanEnd', this);
        }
        // A segment span is basically the root span of a local span tree.
        // So for now, this is either what we previously refer to as the root span,
        // or a standalone span.
        const isSegmentSpan = this._isStandaloneSpan || this === (0, $cdd7dc1c144c1b85$export$c4c6a79b1260ca1b)(this);
        if (!isSegmentSpan) return;
        // if this is a standalone span, we send it immediately
        if (this._isStandaloneSpan) {
            if (this._sampled) $ccb59542cd39d078$var$sendSpanEnvelope((0, $a0dbcc7684e32930$export$19a0081d4b39d77)([
                this
            ], client));
            else {
                (0, $6d193f2c2b007873$export$16a28057038b10ef) && (0, $6ed5aee3203eab87$export$1c9f709888824e05).log('[Tracing] Discarding standalone span because its trace was not chosen to be sampled.');
                if (client) client.recordDroppedEvent('sample_rate', 'span');
            }
            return;
        } else if (client && (0, $fd377a3bf49bd1d2$export$6ea47215d699c04a)(client)) {
            // TODO (spans): Remove standalone span custom logic in favor of sending simple v2 web vital spans
            client.emit('afterSegmentSpanEnd', this);
            return;
        }
        const transactionEvent = this._convertSpanToTransaction();
        if (transactionEvent) {
            const scope = (0, $360fa73c77afb99d$export$c08fbc656a245d03)(this).scope || (0, $6c9d57d6c1e4fcbb$export$c7be4b0125a10cba)();
            scope.captureEvent(transactionEvent);
        }
    }
    /**
   * Finish the transaction & prepare the event to send to Sentry.
   */ _convertSpanToTransaction() {
        // We can only convert finished spans
        if (!$ccb59542cd39d078$var$isFullFinishedSpan((0, $cdd7dc1c144c1b85$export$92d8c23565496537)(this))) return undefined;
        if (!this._name) {
            (0, $6d193f2c2b007873$export$16a28057038b10ef) && (0, $6ed5aee3203eab87$export$1c9f709888824e05).warn('Transaction has no name, falling back to `<unlabeled transaction>`.');
            this._name = '<unlabeled transaction>';
        }
        const { scope: capturedSpanScope, isolationScope: capturedSpanIsolationScope } = (0, $360fa73c77afb99d$export$c08fbc656a245d03)(this);
        const normalizedRequest = capturedSpanScope?.getScopeData().sdkProcessingMetadata?.normalizedRequest;
        if (this._sampled !== true) return undefined;
        // The transaction span itself as well as any potential standalone spans should be filtered out
        const finishedSpans = (0, $cdd7dc1c144c1b85$export$340c5c8a13ffc680)(this).filter((span)=>span !== this && !$ccb59542cd39d078$var$isStandaloneSpan(span));
        const spans = finishedSpans.map((span)=>(0, $cdd7dc1c144c1b85$export$92d8c23565496537)(span)).filter($ccb59542cd39d078$var$isFullFinishedSpan);
        const source = this._attributes[0, $0633c8eb02923c67$export$d7a7d984b0791405];
        // remove internal root span attributes we don't need to send.
        /* eslint-disable @typescript-eslint/no-dynamic-delete */ delete this._attributes[0, $0633c8eb02923c67$export$165ce9a229f6f050];
        spans.forEach((span)=>{
            delete span.data[0, $0633c8eb02923c67$export$165ce9a229f6f050];
        });
        // eslint-enabled-next-line @typescript-eslint/no-dynamic-delete
        const transaction = {
            contexts: {
                trace: (0, $cdd7dc1c144c1b85$export$4c3967a8a2f6bbd6)(this)
            },
            spans: // spans.sort() mutates the array, but `spans` is already a copy so we can safely do this here
            // we do not use spans anymore after this point
            spans.length > $ccb59542cd39d078$var$MAX_SPAN_COUNT ? spans.sort((a, b)=>a.start_timestamp - b.start_timestamp).slice(0, $ccb59542cd39d078$var$MAX_SPAN_COUNT) : spans,
            start_timestamp: this._startTime,
            timestamp: this._endTime,
            transaction: this._name,
            type: 'transaction',
            sdkProcessingMetadata: {
                capturedSpanScope: capturedSpanScope,
                capturedSpanIsolationScope: capturedSpanIsolationScope,
                dynamicSamplingContext: (0, $e7797a74bdf55fda$export$a117f995597e25df)(this)
            },
            request: normalizedRequest,
            ...source && {
                transaction_info: {
                    source: source
                }
            }
        };
        const measurements = (0, $c274d22f473f8327$export$487db6fcdf36893e)(this._events);
        const hasMeasurements = measurements && Object.keys(measurements).length;
        if (hasMeasurements) {
            (0, $6d193f2c2b007873$export$16a28057038b10ef) && (0, $6ed5aee3203eab87$export$1c9f709888824e05).log('[Measurements] Adding measurements to transaction event', JSON.stringify(measurements, undefined, 2));
            transaction.measurements = measurements;
        }
        return transaction;
    }
}
function $ccb59542cd39d078$var$isSpanTimeInput(value) {
    return value && typeof value === 'number' || value instanceof Date || Array.isArray(value);
}
// We want to filter out any incomplete SpanJSON objects
function $ccb59542cd39d078$var$isFullFinishedSpan(input) {
    return !!input.start_timestamp && !!input.timestamp && !!input.span_id && !!input.trace_id;
}
/** `SentrySpan`s can be sent as a standalone span rather than belonging to a transaction */ function $ccb59542cd39d078$var$isStandaloneSpan(span) {
    return span instanceof $ccb59542cd39d078$export$a92149b045260d9f && span.isStandaloneSpan();
}
/**
 * Sends a `SpanEnvelope`.
 *
 * Note: If the envelope's spans are dropped, e.g. via `beforeSendSpan`,
 * the envelope will not be sent either.
 */ function $ccb59542cd39d078$var$sendSpanEnvelope(envelope) {
    const client = (0, $6c9d57d6c1e4fcbb$export$6bb76d6eba7e258c)();
    if (!client) return;
    const spanItems = envelope[1];
    if (!spanItems || spanItems.length === 0) {
        client.recordDroppedEvent('before_send', 'span');
        return;
    }
    // sendEnvelope should not throw
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    client.sendEnvelope(envelope);
}




/* eslint-disable max-lines */ const $d751480a8e5e2fdf$var$SUPPRESS_TRACING_KEY = '__SENTRY_SUPPRESS_TRACING__';
/**
 * Wraps a function with a transaction/span and finishes the span after the function is done.
 * The created span is the active span and will be used as parent by other spans created inside the function
 * and can be accessed via `Sentry.getActiveSpan()`, as long as the function is executed while the scope is active.
 *
 * If you want to create a span that is not set as active, use {@link startInactiveSpan}.
 *
 * You'll always get a span passed to the callback,
 * it may just be a non-recording span if the span is not sampled or if tracing is disabled.
 */ function $d751480a8e5e2fdf$export$a1bd95187356f372(options, callback) {
    const acs = $d751480a8e5e2fdf$var$getAcs();
    if (acs.startSpan) return acs.startSpan(options, callback);
    const spanArguments = $d751480a8e5e2fdf$var$parseSentrySpanArguments(options);
    const { forceTransaction: forceTransaction, parentSpan: customParentSpan, scope: customScope } = options;
    // We still need to fork a potentially passed scope, as we set the active span on it
    // and we need to ensure that it is cleaned up properly once the span ends.
    const customForkedScope = customScope?.clone();
    return (0, $6c9d57d6c1e4fcbb$export$ec58d9285c204497)(customForkedScope, ()=>{
        // If `options.parentSpan` is defined, we want to wrap the callback in `withActiveSpan`
        const wrapper = $d751480a8e5e2fdf$var$getActiveSpanWrapper(customParentSpan);
        return wrapper(()=>{
            const scope = (0, $6c9d57d6c1e4fcbb$export$c7be4b0125a10cba)();
            const parentSpan = $d751480a8e5e2fdf$var$getParentSpan(scope, customParentSpan);
            const client = (0, $6c9d57d6c1e4fcbb$export$6bb76d6eba7e258c)();
            const missingRequiredParent = options.onlyIfParent && !parentSpan;
            const activeSpan = missingRequiredParent ? new (0, $5837079298713d4b$export$d6636b700b76c516)() : $d751480a8e5e2fdf$var$createChildOrRootSpan({
                parentSpan: parentSpan,
                spanArguments: spanArguments,
                forceTransaction: forceTransaction,
                scope: scope
            });
            if (missingRequiredParent) client?.recordDroppedEvent('no_parent_span', 'span');
            // Ignored root spans still need to be set on scope so that `getActiveSpan()` returns them
            // and descendants are also non-recording. Ignored child spans don't need this because
            // the parent span is already on scope.
            if (!$d751480a8e5e2fdf$var$_isIgnoredSpan(activeSpan) || !parentSpan) (0, $18f1bf9c6bfa5b9e$export$3f25fa50c18e20ca)(scope, activeSpan);
            return (0, $a0da8200e71b06d2$export$18ce21a8b7efd7e9)(()=>callback(activeSpan), ()=>{
                // Only update the span status if it hasn't been changed yet, and the span is not yet finished
                const { status: status } = (0, $cdd7dc1c144c1b85$export$92d8c23565496537)(activeSpan);
                if (activeSpan.isRecording() && (!status || status === 'ok')) activeSpan.setStatus({
                    code: (0, $7a6201d846b686cd$export$f966a0446ece71e),
                    message: 'internal_error'
                });
            }, ()=>{
                activeSpan.end();
            });
        });
    });
}
/**
 * Similar to `Sentry.startSpan`. Wraps a function with a transaction/span, but does not finish the span
 * after the function is done automatically. Use `span.end()` to end the span.
 *
 * The created span is the active span and will be used as parent by other spans created inside the function
 * and can be accessed via `Sentry.getActiveSpan()`, as long as the function is executed while the scope is active.
 *
 * You'll always get a span passed to the callback,
 * it may just be a non-recording span if the span is not sampled or if tracing is disabled.
 */ function $d751480a8e5e2fdf$export$c10292ad04b92aea(options, callback) {
    const acs = $d751480a8e5e2fdf$var$getAcs();
    if (acs.startSpanManual) return acs.startSpanManual(options, callback);
    const spanArguments = $d751480a8e5e2fdf$var$parseSentrySpanArguments(options);
    const { forceTransaction: forceTransaction, parentSpan: customParentSpan, scope: customScope } = options;
    const customForkedScope = customScope?.clone();
    return (0, $6c9d57d6c1e4fcbb$export$ec58d9285c204497)(customForkedScope, ()=>{
        // If `options.parentSpan` is defined, we want to wrap the callback in `withActiveSpan`
        const wrapper = $d751480a8e5e2fdf$var$getActiveSpanWrapper(customParentSpan);
        return wrapper(()=>{
            const scope = (0, $6c9d57d6c1e4fcbb$export$c7be4b0125a10cba)();
            const parentSpan = $d751480a8e5e2fdf$var$getParentSpan(scope, customParentSpan);
            const missingRequiredParent = options.onlyIfParent && !parentSpan;
            const activeSpan = missingRequiredParent ? new (0, $5837079298713d4b$export$d6636b700b76c516)() : $d751480a8e5e2fdf$var$createChildOrRootSpan({
                parentSpan: parentSpan,
                spanArguments: spanArguments,
                forceTransaction: forceTransaction,
                scope: scope
            });
            if (missingRequiredParent) (0, $6c9d57d6c1e4fcbb$export$6bb76d6eba7e258c)()?.recordDroppedEvent('no_parent_span', 'span');
            // We don't set ignored child spans onto the scope because there likely is an active,
            // unignored span on the scope already.
            if (!$d751480a8e5e2fdf$var$_isIgnoredSpan(activeSpan) || !parentSpan) (0, $18f1bf9c6bfa5b9e$export$3f25fa50c18e20ca)(scope, activeSpan);
            return (0, $a0da8200e71b06d2$export$18ce21a8b7efd7e9)(// We pass the `finish` function to the callback, so the user can finish the span manually
            // this is mainly here for historic purposes because previously, we instructed users to call
            // `finish` instead of `span.end()` to also clean up the scope. Nowadays, calling `span.end()`
            // or `finish` has the same effect and we simply leave it here to avoid breaking user code.
            ()=>callback(activeSpan, ()=>activeSpan.end()), ()=>{
                // Only update the span status if it hasn't been changed yet, and the span is not yet finished
                const { status: status } = (0, $cdd7dc1c144c1b85$export$92d8c23565496537)(activeSpan);
                if (activeSpan.isRecording() && (!status || status === 'ok')) activeSpan.setStatus({
                    code: (0, $7a6201d846b686cd$export$f966a0446ece71e),
                    message: 'internal_error'
                });
            });
        });
    });
}
/**
 * Creates a span. This span is not set as active, so will not get automatic instrumentation spans
 * as children or be able to be accessed via `Sentry.getActiveSpan()`.
 *
 * If you want to create a span that is set as active, use {@link startSpan}.
 *
 * This function will always return a span,
 * it may just be a non-recording span if the span is not sampled or if tracing is disabled.
 */ function $d751480a8e5e2fdf$export$63dbba021a6b4047(options) {
    const acs = $d751480a8e5e2fdf$var$getAcs();
    if (acs.startInactiveSpan) return acs.startInactiveSpan(options);
    const spanArguments = $d751480a8e5e2fdf$var$parseSentrySpanArguments(options);
    const { forceTransaction: forceTransaction, parentSpan: customParentSpan } = options;
    // If `options.scope` is defined, we use this as as a wrapper,
    // If `options.parentSpan` is defined, we want to wrap the callback in `withActiveSpan`
    const wrapper = options.scope ? (callback)=>(0, $6c9d57d6c1e4fcbb$export$ec58d9285c204497)(options.scope, callback) : customParentSpan !== undefined ? (callback)=>$d751480a8e5e2fdf$export$e57ac09b143d92a2(customParentSpan, callback) : (callback)=>callback();
    return wrapper(()=>{
        const scope = (0, $6c9d57d6c1e4fcbb$export$c7be4b0125a10cba)();
        const parentSpan = $d751480a8e5e2fdf$var$getParentSpan(scope, customParentSpan);
        const client = (0, $6c9d57d6c1e4fcbb$export$6bb76d6eba7e258c)();
        const missingRequiredParent = options.onlyIfParent && !parentSpan;
        if (missingRequiredParent) {
            client?.recordDroppedEvent('no_parent_span', 'span');
            return new (0, $5837079298713d4b$export$d6636b700b76c516)();
        }
        return $d751480a8e5e2fdf$var$createChildOrRootSpan({
            parentSpan: parentSpan,
            spanArguments: spanArguments,
            forceTransaction: forceTransaction,
            scope: scope
        });
    });
}
/**
 * Continue a trace from `sentry-trace` and `baggage` values.
 * These values can be obtained from incoming request headers, or in the browser from `<meta name="sentry-trace">`
 * and `<meta name="baggage">` HTML tags.
 *
 * Spans started with `startSpan`, `startSpanManual` and `startInactiveSpan`, within the callback will automatically
 * be attached to the incoming trace.
 */ const $d751480a8e5e2fdf$export$d2ee9b39b25437b3 = (options, callback)=>{
    const carrier = (0, $b9fc213467403976$export$19eade501500c6c1)();
    const acs = (0, $22ac79c556bb203d$export$f639b0c2752203be)(carrier);
    if (acs.continueTrace) return acs.continueTrace(options, callback);
    const { sentryTrace: sentryTrace, baggage: baggage } = options;
    const client = (0, $6c9d57d6c1e4fcbb$export$6bb76d6eba7e258c)();
    const incomingDsc = (0, $dfa5ff63e2991cbd$export$5b96ee2c8421f107)(baggage);
    if (client && !(0, $6a872401a977a16c$export$18811bc99eefceaa)(client, incomingDsc?.org_id)) return $d751480a8e5e2fdf$export$f90b03291402f553(callback);
    return (0, $6c9d57d6c1e4fcbb$export$ec58d9285c204497)((scope)=>{
        const propagationContext = (0, $6a872401a977a16c$export$261f383d16a93e39)(sentryTrace, baggage);
        scope.setPropagationContext(propagationContext);
        (0, $18f1bf9c6bfa5b9e$export$3f25fa50c18e20ca)(scope, undefined);
        return callback();
    });
};
/**
 * Forks the current scope and sets the provided span as active span in the context of the provided callback. Can be
 * passed `null` to start an entirely new span tree.
 *
 * @param span Spans started in the context of the provided callback will be children of this span. If `null` is passed,
 * spans started within the callback will not be attached to a parent span.
 * @param callback Execution context in which the provided span will be active. Is passed the newly forked scope.
 * @returns the value returned from the provided callback function.
 */ function $d751480a8e5e2fdf$export$e57ac09b143d92a2(span, callback) {
    const acs = $d751480a8e5e2fdf$var$getAcs();
    if (acs.withActiveSpan) return acs.withActiveSpan(span, callback);
    return (0, $6c9d57d6c1e4fcbb$export$ec58d9285c204497)((scope)=>{
        (0, $18f1bf9c6bfa5b9e$export$3f25fa50c18e20ca)(scope, span || undefined);
        return callback(scope);
    });
}
/** Suppress tracing in the given callback, ensuring no spans are generated inside of it. */ function $d751480a8e5e2fdf$export$869298f9835abc68(callback) {
    const acs = $d751480a8e5e2fdf$var$getAcs();
    if (acs.suppressTracing) return acs.suppressTracing(callback);
    return (0, $6c9d57d6c1e4fcbb$export$ec58d9285c204497)((scope)=>{
        // Note: We do not wait for the callback to finish before we reset the metadata
        // the reason for this is that otherwise, in the browser this can lead to very weird behavior
        // as there is only a single top scope, if the callback takes longer to finish,
        // other, unrelated spans may also be suppressed, which we do not want
        // so instead, we only suppress tracing synchronoysly in the browser
        scope.setSDKProcessingMetadata({
            [$d751480a8e5e2fdf$var$SUPPRESS_TRACING_KEY]: true
        });
        const res = callback();
        scope.setSDKProcessingMetadata({
            [$d751480a8e5e2fdf$var$SUPPRESS_TRACING_KEY]: undefined
        });
        return res;
    });
}
/**
 * Starts a new trace for the duration of the provided callback. Spans started within the
 * callback will be part of the new trace instead of a potentially previously started trace.
 *
 * Important: Only use this function if you want to override the default trace lifetime and
 * propagation mechanism of the SDK for the duration and scope of the provided callback.
 * The newly created trace will also be the root of a new distributed trace, for example if
 * you make http requests within the callback.
 * This function might be useful if the operation you want to instrument should not be part
 * of a potentially ongoing trace.
 *
 * Default behavior:
 * - Server-side: A new trace is started for each incoming request.
 * - Browser: A new trace is started for each page our route. Navigating to a new route
 *            or page will automatically create a new trace.
 */ function $d751480a8e5e2fdf$export$f90b03291402f553(callback) {
    const acs = $d751480a8e5e2fdf$var$getAcs();
    if (acs.startNewTrace) return acs.startNewTrace(callback);
    return (0, $6c9d57d6c1e4fcbb$export$ec58d9285c204497)((scope)=>{
        scope.setPropagationContext({
            traceId: (0, $1eac0e3178cad4a9$export$dc6d7ea554bcce10)(),
            sampleRand: (0, $11bebf6401bbfdb9$export$9869d72de32a3917)()
        });
        (0, $6d193f2c2b007873$export$16a28057038b10ef) && (0, $6ed5aee3203eab87$export$1c9f709888824e05).log(`Starting a new trace with id ${scope.getPropagationContext().traceId}`);
        return $d751480a8e5e2fdf$export$e57ac09b143d92a2(null, callback);
    });
}
function $d751480a8e5e2fdf$var$createChildOrRootSpan({ parentSpan: parentSpan, spanArguments: spanArguments, forceTransaction: forceTransaction, scope: scope }) {
    if (!(0, $3db87d4df304f81d$export$1f70765132c3c225)()) {
        const span = new (0, $5837079298713d4b$export$d6636b700b76c516)();
        // If this is a root span, we ensure to freeze a DSC
        // So we can have at least partial data here
        if (forceTransaction || !parentSpan) {
            const dsc = {
                sampled: 'false',
                sample_rate: '0',
                transaction: spanArguments.name,
                ...(0, $e7797a74bdf55fda$export$a117f995597e25df)(span)
            };
            (0, $e7797a74bdf55fda$export$7398c93e763ca9fd)(span, dsc);
        }
        return span;
    }
    const client = (0, $6c9d57d6c1e4fcbb$export$6bb76d6eba7e258c)();
    if ($d751480a8e5e2fdf$var$_shouldIgnoreStreamedSpan(client, spanArguments)) {
        if (!$d751480a8e5e2fdf$var$_isTracingSuppressed(scope)) // if tracing is actively suppressed (Sentry.suppressTracing(...)),
        // we don't want to record a client outcome for the ignored span
        client?.recordDroppedEvent('ignored', 'span');
        return new (0, $5837079298713d4b$export$d6636b700b76c516)({
            dropReason: 'ignored',
            traceId: parentSpan?.spanContext().traceId ?? scope.getPropagationContext().traceId
        });
    }
    const isolationScope = (0, $6c9d57d6c1e4fcbb$export$68f3af03034c9e90)();
    let span;
    if (parentSpan && !forceTransaction) {
        span = $d751480a8e5e2fdf$var$_startChildSpan(parentSpan, scope, spanArguments);
        (0, $cdd7dc1c144c1b85$export$81397d924722cc65)(parentSpan, span);
    } else if (parentSpan) {
        // If we forced a transaction but have a parent span, make sure to continue from the parent span, not the scope
        const dsc = (0, $e7797a74bdf55fda$export$a117f995597e25df)(parentSpan);
        const { traceId: traceId, spanId: parentSpanId } = parentSpan.spanContext();
        const parentSampled = (0, $cdd7dc1c144c1b85$export$5caecac1caaf3a71)(parentSpan);
        span = $d751480a8e5e2fdf$var$_startRootSpan({
            traceId: traceId,
            parentSpanId: parentSpanId,
            ...spanArguments
        }, scope, parentSampled);
        (0, $e7797a74bdf55fda$export$7398c93e763ca9fd)(span, dsc);
    } else {
        const { traceId: traceId, dsc: dsc, parentSpanId: parentSpanId, sampled: parentSampled } = {
            ...isolationScope.getPropagationContext(),
            ...scope.getPropagationContext()
        };
        span = $d751480a8e5e2fdf$var$_startRootSpan({
            traceId: traceId,
            parentSpanId: parentSpanId,
            ...spanArguments
        }, scope, parentSampled);
        if (dsc) (0, $e7797a74bdf55fda$export$7398c93e763ca9fd)(span, dsc);
    }
    (0, $694f052c23ba49e0$export$2f3d84e767c9592b)(span);
    (0, $360fa73c77afb99d$export$cddb4027e3b0dd66)(span, scope, isolationScope);
    return span;
}
/**
 * This converts StartSpanOptions to SentrySpanArguments.
 * For the most part (for now) we accept the same options,
 * but some of them need to be transformed.
 */ function $d751480a8e5e2fdf$var$parseSentrySpanArguments(options) {
    const exp = options.experimental || {};
    const initialCtx = {
        isStandalone: exp.standalone,
        ...options
    };
    if (options.startTime) {
        const ctx = {
            ...initialCtx
        };
        ctx.startTimestamp = (0, $cdd7dc1c144c1b85$export$3f7581298f56c6d7)(options.startTime);
        delete ctx.startTime;
        return ctx;
    }
    return initialCtx;
}
function $d751480a8e5e2fdf$var$getAcs() {
    const carrier = (0, $b9fc213467403976$export$19eade501500c6c1)();
    return (0, $22ac79c556bb203d$export$f639b0c2752203be)(carrier);
}
function $d751480a8e5e2fdf$var$_startRootSpan(spanArguments, scope, parentSampled) {
    const client = (0, $6c9d57d6c1e4fcbb$export$6bb76d6eba7e258c)();
    const options = client?.getOptions() || {};
    const { name: name = '' } = spanArguments;
    const mutableSpanSamplingData = {
        spanAttributes: {
            ...spanArguments.attributes
        },
        spanName: name,
        parentSampled: parentSampled
    };
    // we don't care about the decision for the moment; this is just a placeholder
    client?.emit('beforeSampling', mutableSpanSamplingData, {
        decision: false
    });
    // If hook consumers override the parentSampled flag, we will use that value instead of the actual one
    const finalParentSampled = mutableSpanSamplingData.parentSampled ?? parentSampled;
    const finalAttributes = mutableSpanSamplingData.spanAttributes;
    const currentPropagationContext = scope.getPropagationContext();
    const isTracingSuppressed = $d751480a8e5e2fdf$var$_isTracingSuppressed(scope);
    const [sampled, sampleRate, localSampleRateWasApplied] = isTracingSuppressed ? [
        false
    ] : (0, $dc72326dd7c1f751$export$5f833db634b217bb)(options, {
        name: name,
        parentSampled: finalParentSampled,
        attributes: finalAttributes,
        parentSampleRate: (0, $77c0cd7d06293a86$export$a5bd2d81656d9546)(currentPropagationContext.dsc?.sample_rate)
    }, currentPropagationContext.sampleRand);
    const rootSpan = new (0, $ccb59542cd39d078$export$a92149b045260d9f)({
        ...spanArguments,
        attributes: {
            [(0, $0633c8eb02923c67$export$d7a7d984b0791405)]: 'custom',
            [(0, $0633c8eb02923c67$export$ccfe0a40627cc34b)]: sampleRate !== undefined && localSampleRateWasApplied ? sampleRate : undefined,
            ...finalAttributes
        },
        sampled: sampled
    });
    if (!sampled && client && !isTracingSuppressed) {
        (0, $6d193f2c2b007873$export$16a28057038b10ef) && (0, $6ed5aee3203eab87$export$1c9f709888824e05).log('[Tracing] Discarding root span because its trace was not chosen to be sampled.');
        client.recordDroppedEvent('sample_rate', (0, $fd377a3bf49bd1d2$export$6ea47215d699c04a)(client) ? 'span' : 'transaction');
    }
    if (client) client.emit('spanStart', rootSpan);
    return rootSpan;
}
/**
 * Creates a new `Span` while setting the current `Span.id` as `parentSpanId`.
 * This inherits the sampling decision from the parent span.
 */ function $d751480a8e5e2fdf$var$_startChildSpan(parentSpan, scope, spanArguments) {
    const { spanId: spanId, traceId: traceId } = parentSpan.spanContext();
    const isTracingSuppressed = $d751480a8e5e2fdf$var$_isTracingSuppressed(scope);
    const sampled = isTracingSuppressed ? false : (0, $cdd7dc1c144c1b85$export$5caecac1caaf3a71)(parentSpan);
    const childSpan = sampled ? new (0, $ccb59542cd39d078$export$a92149b045260d9f)({
        ...spanArguments,
        parentSpanId: spanId,
        traceId: traceId,
        sampled: sampled
    }) : new (0, $5837079298713d4b$export$d6636b700b76c516)({
        traceId: traceId
    });
    (0, $cdd7dc1c144c1b85$export$81397d924722cc65)(parentSpan, childSpan);
    const client = (0, $6c9d57d6c1e4fcbb$export$6bb76d6eba7e258c)();
    if (!client) return childSpan;
    if ((0, $fd377a3bf49bd1d2$export$6ea47215d699c04a)(client) && childSpan instanceof (0, $5837079298713d4b$export$d6636b700b76c516)) {
        if (parentSpan instanceof (0, $5837079298713d4b$export$d6636b700b76c516) && parentSpan.dropReason) {
            // We land here if the parent span was a segment span that was ignored (`ignoreSpans`).
            // In this case, the child was also ignored (see `sampled` above) but we need to
            // record a client outcome for the child.
            childSpan.dropReason = parentSpan.dropReason;
            client.recordDroppedEvent(parentSpan.dropReason, 'span');
        } else if (!isTracingSuppressed) {
            // Otherwise, the child is not sampled due to sampling of the parent span,
            // hence we record a sample_rate client outcome for the child.
            childSpan.dropReason = 'sample_rate';
            client.recordDroppedEvent('sample_rate', 'span');
        }
    }
    client.emit('spanStart', childSpan);
    // If it has an endTimestamp, it's already ended
    if (spanArguments.endTimestamp) {
        client.emit('spanEnd', childSpan);
        client.emit('afterSpanEnd', childSpan);
    }
    return childSpan;
}
function $d751480a8e5e2fdf$var$getParentSpan(scope, customParentSpan) {
    // always use the passed in span directly
    if (customParentSpan) return customParentSpan;
    // This is different from `undefined` as it means the user explicitly wants no parent span
    if (customParentSpan === null) return undefined;
    const span = (0, $18f1bf9c6bfa5b9e$export$91f063ebb8eff307)(scope);
    if (!span) return undefined;
    const client = (0, $6c9d57d6c1e4fcbb$export$6bb76d6eba7e258c)();
    const options = client ? client.getOptions() : {};
    if (options.parentSpanIsAlwaysRootSpan) return (0, $cdd7dc1c144c1b85$export$c4c6a79b1260ca1b)(span);
    return span;
}
function $d751480a8e5e2fdf$var$getActiveSpanWrapper(parentSpan) {
    return parentSpan !== undefined ? (callback)=>{
        return $d751480a8e5e2fdf$export$e57ac09b143d92a2(parentSpan, callback);
    } : (callback)=>callback();
}
/* Checks if `ignoreSpans` applies (extracted for bundle size)*/ function $d751480a8e5e2fdf$var$_shouldIgnoreStreamedSpan(client, spanArguments) {
    const ignoreSpans = client?.getOptions().ignoreSpans;
    if (!client || !(0, $fd377a3bf49bd1d2$export$6ea47215d699c04a)(client) || !ignoreSpans?.length) return false;
    return (0, $bdbac37f17ad9b0f$export$5d569ac97c389400)({
        description: spanArguments.name || '',
        op: spanArguments.attributes?.[0, $0633c8eb02923c67$export$1a413bd9a88fdb09] || spanArguments.op
    }, ignoreSpans);
}
function $d751480a8e5e2fdf$var$_isIgnoredSpan(span) {
    return span instanceof (0, $5837079298713d4b$export$d6636b700b76c516) && span.dropReason === 'ignored';
}
function $d751480a8e5e2fdf$var$_isTracingSuppressed(scope) {
    return scope.getScopeData().sdkProcessingMetadata[$d751480a8e5e2fdf$var$SUPPRESS_TRACING_KEY] === true;
}









/**
 * Captures an exception event and sends it to Sentry.
 *
 * @param exception The exception to capture.
 * @param hint Optional additional data to attach to the Sentry event.
 * @returns the id of the captured Sentry event.
 */ function $5125ad3d1e13a914$export$f5282963edea4a68(exception, hint) {
    return (0, $6c9d57d6c1e4fcbb$export$c7be4b0125a10cba)().captureException(exception, (0, $483fc517c383af06$export$76b5f966996d1653)(hint));
}
/**
 * Captures a message event and sends it to Sentry.
 *
 * @param message The message to send to Sentry.
 * @param captureContext Define the level of the message or pass in additional data to attach to the message.
 * @returns the id of the captured message.
 */ function $5125ad3d1e13a914$export$45654777c133ae80(message, captureContext) {
    // This is necessary to provide explicit scopes upgrade, without changing the original
    // arity of the `captureMessage(message, level)` method.
    const level = typeof captureContext === 'string' ? captureContext : undefined;
    const hint = typeof captureContext !== 'string' ? {
        captureContext: captureContext
    } : undefined;
    return (0, $6c9d57d6c1e4fcbb$export$c7be4b0125a10cba)().captureMessage(message, level, hint);
}
/**
 * Captures a manually created event and sends it to Sentry.
 *
 * @param event The event to send to Sentry.
 * @param hint Optional additional data to attach to the Sentry event.
 * @returns the id of the captured event.
 */ function $5125ad3d1e13a914$export$1462b974fdcf6ba2(event, hint) {
    return (0, $6c9d57d6c1e4fcbb$export$c7be4b0125a10cba)().captureEvent(event, hint);
}
/**
 * Sets context data with the given name.
 * @param name of the context
 * @param context Any kind of data. This data will be normalized.
 */ function $5125ad3d1e13a914$export$2f04de43fe27971a(name, context) {
    (0, $6c9d57d6c1e4fcbb$export$68f3af03034c9e90)().setContext(name, context);
}
/**
 * Set an object that will be merged sent as extra data with the event.
 * @param extras Extras object to merge into current context.
 */ function $5125ad3d1e13a914$export$bb4922da0dd51b92(extras) {
    (0, $6c9d57d6c1e4fcbb$export$68f3af03034c9e90)().setExtras(extras);
}
/**
 * Set key:value that will be sent as extra data with the event.
 * @param key String of extra
 * @param extra Any kind of data. This data will be normalized.
 */ function $5125ad3d1e13a914$export$8e8e7789d42ed61d(key, extra) {
    (0, $6c9d57d6c1e4fcbb$export$68f3af03034c9e90)().setExtra(key, extra);
}
/**
 * Set an object that will be merged sent as tags data with the event.
 * @param tags Tags context object to merge into current context.
 */ function $5125ad3d1e13a914$export$74a8fb34822092e6(tags) {
    (0, $6c9d57d6c1e4fcbb$export$68f3af03034c9e90)().setTags(tags);
}
/**
 * Set key:value that will be sent as tags data with the event.
 *
 * Can also be used to unset a tag, by passing `undefined`.
 *
 * @param key String key of tag
 * @param value Value of tag
 */ function $5125ad3d1e13a914$export$a37d07ee78eb4569(key, value) {
    (0, $6c9d57d6c1e4fcbb$export$68f3af03034c9e90)().setTag(key, value);
}
/**
 * Updates user context information for future events.
 *
 * @param user User context object to be set in the current context. Pass `null` to unset the user.
 */ function $5125ad3d1e13a914$export$8b6bb3dd62a01be2(user) {
    (0, $6c9d57d6c1e4fcbb$export$68f3af03034c9e90)().setUser(user);
}
/**
 * Sets the conversation ID for the current isolation scope.
 *
 * @param conversationId The conversation ID to set. Pass `null` or `undefined` to unset the conversation ID.
 */ function $5125ad3d1e13a914$export$58213391a19e392(conversationId) {
    (0, $6c9d57d6c1e4fcbb$export$68f3af03034c9e90)().setConversationId(conversationId);
}
/**
 * The last error event id of the isolation scope.
 *
 * Warning: This function really returns the last recorded error event id on the current
 * isolation scope. If you call this function after handling a certain error and another error
 * is captured in between, the last one is returned instead of the one you might expect.
 * Also, ids of events that were never sent to Sentry (for example because
 * they were dropped in `beforeSend`) could be returned.
 *
 * @returns The last event id of the isolation scope.
 */ function $5125ad3d1e13a914$export$5d4e9fd7fac8e617() {
    return (0, $6c9d57d6c1e4fcbb$export$68f3af03034c9e90)().lastEventId();
}
/**
 * Create a cron monitor check in and send it to Sentry.
 *
 * @param checkIn An object that describes a check in.
 * @param upsertMonitorConfig An optional object that describes a monitor config. Use this if you want
 * to create a monitor automatically when sending a check in.
 */ function $5125ad3d1e13a914$export$413528111fbc67c(checkIn, upsertMonitorConfig) {
    const scope = (0, $6c9d57d6c1e4fcbb$export$c7be4b0125a10cba)();
    const client = (0, $6c9d57d6c1e4fcbb$export$6bb76d6eba7e258c)();
    if (!client) (0, $6d193f2c2b007873$export$16a28057038b10ef) && (0, $6ed5aee3203eab87$export$1c9f709888824e05).warn('Cannot capture check-in. No client defined.');
    else if (!client.captureCheckIn) (0, $6d193f2c2b007873$export$16a28057038b10ef) && (0, $6ed5aee3203eab87$export$1c9f709888824e05).warn('Cannot capture check-in. Client does not support sending check-ins.');
    else return client.captureCheckIn(checkIn, upsertMonitorConfig, scope);
    return (0, $76366c1ad7fe29b9$export$19f53698e68b2496)();
}
/**
 * Wraps a callback with a cron monitor check in. The check in will be sent to Sentry when the callback finishes.
 *
 * @param monitorSlug The distinct slug of the monitor.
 * @param callback Callback to be monitored
 * @param upsertMonitorConfig An optional object that describes a monitor config. Use this if you want
 * to create a monitor automatically when sending a check in.
 */ function $5125ad3d1e13a914$export$553526fc5f03c0b1(monitorSlug, callback, upsertMonitorConfig) {
    function runCallback() {
        const checkInId = $5125ad3d1e13a914$export$413528111fbc67c({
            monitorSlug: monitorSlug,
            status: 'in_progress'
        }, upsertMonitorConfig);
        const now = (0, $27fab3c4acc6cd95$export$ee52dced521e3e18)();
        function finishCheckIn(status) {
            $5125ad3d1e13a914$export$413528111fbc67c({
                monitorSlug: monitorSlug,
                status: status,
                checkInId: checkInId,
                duration: (0, $27fab3c4acc6cd95$export$ee52dced521e3e18)() - now
            });
        }
        // Default behavior without isolateTrace
        let maybePromiseResult;
        try {
            maybePromiseResult = callback();
        } catch (e) {
            finishCheckIn('error');
            throw e;
        }
        if ((0, $d1f309ce92d0a600$export$f5b060c2914b97c8)(maybePromiseResult)) return maybePromiseResult.then((r)=>{
            finishCheckIn('ok');
            return r;
        }, (e)=>{
            finishCheckIn('error');
            throw e;
        });
        finishCheckIn('ok');
        return maybePromiseResult;
    }
    return (0, $6c9d57d6c1e4fcbb$export$9a4fed82c350c2bd)(()=>upsertMonitorConfig?.isolateTrace ? (0, $d751480a8e5e2fdf$export$f90b03291402f553)(runCallback) : runCallback());
}
/**
 * Call `flush()` on the current client, if there is one. See {@link Client.flush}.
 *
 * @param timeout Maximum time in ms the client should wait to flush its event queue. Omitting this parameter will cause
 * the client to wait until all events are sent before resolving the promise.
 * @returns A promise which resolves to `true` if the queue successfully drains before the timeout, or `false` if it
 * doesn't (or if there's no client defined).
 */ async function $5125ad3d1e13a914$export$4909b86c8034bf73(timeout) {
    const client = (0, $6c9d57d6c1e4fcbb$export$6bb76d6eba7e258c)();
    if (client) return client.flush(timeout);
    (0, $6d193f2c2b007873$export$16a28057038b10ef) && (0, $6ed5aee3203eab87$export$1c9f709888824e05).warn('Cannot flush events. No client defined.');
    return Promise.resolve(false);
}
/**
 * Call `close()` on the current client, if there is one. See {@link Client.close}.
 *
 * @param timeout Maximum time in ms the client should wait to flush its event queue before shutting down. Omitting this
 * parameter will cause the client to wait until all events are sent before disabling itself.
 * @returns A promise which resolves to `true` if the queue successfully drains before the timeout, or `false` if it
 * doesn't (or if there's no client defined).
 */ async function $5125ad3d1e13a914$export$8360e631d277ea4d(timeout) {
    const client = (0, $6c9d57d6c1e4fcbb$export$6bb76d6eba7e258c)();
    if (client) return client.close(timeout);
    (0, $6d193f2c2b007873$export$16a28057038b10ef) && (0, $6ed5aee3203eab87$export$1c9f709888824e05).warn('Cannot flush events and disable SDK. No client defined.');
    return Promise.resolve(false);
}
/**
 * Returns true if Sentry has been properly initialized.
 */ function $5125ad3d1e13a914$export$3f95c6f800b78024() {
    return !!(0, $6c9d57d6c1e4fcbb$export$6bb76d6eba7e258c)();
}
/** If the SDK is initialized & enabled. */ function $5125ad3d1e13a914$export$3b029eb57ac4d562() {
    const client = (0, $6c9d57d6c1e4fcbb$export$6bb76d6eba7e258c)();
    return client?.getOptions().enabled !== false && !!client?.getTransport();
}
/**
 * Add an event processor.
 * This will be added to the current isolation scope, ensuring any event that is processed in the current execution
 * context will have the processor applied.
 */ function $5125ad3d1e13a914$export$9aac0b9f77928fbf(callback) {
    (0, $6c9d57d6c1e4fcbb$export$68f3af03034c9e90)().addEventProcessor(callback);
}
/**
 * Start a session on the current isolation scope.
 *
 * @param context (optional) additional properties to be applied to the returned session object
 *
 * @returns the new active session
 */ function $5125ad3d1e13a914$export$c0d84948cecf78d8(context) {
    const isolationScope = (0, $6c9d57d6c1e4fcbb$export$68f3af03034c9e90)();
    const { user: user } = (0, $7e9d2fc46299f0a2$export$cc422922fcbb91c6)(isolationScope, (0, $6c9d57d6c1e4fcbb$export$c7be4b0125a10cba)());
    // Will fetch userAgent if called from browser sdk
    const { userAgent: userAgent } = (0, $517c5b29f882562f$export$f1a6cdb1459e81d1).navigator || {};
    const session = (0, $71bbb010c8615be2$export$14a186326edbb264)({
        user: user,
        ...userAgent && {
            userAgent: userAgent
        },
        ...context
    });
    // End existing session if there's one
    const currentSession = isolationScope.getSession();
    if (currentSession?.status === 'ok') (0, $71bbb010c8615be2$export$531818e825e774db)(currentSession, {
        status: 'exited'
    });
    $5125ad3d1e13a914$export$17a5be43989a0bc1();
    // Afterwards we set the new session on the scope
    isolationScope.setSession(session);
    return session;
}
/**
 * End the session on the current isolation scope.
 */ function $5125ad3d1e13a914$export$17a5be43989a0bc1() {
    const isolationScope = (0, $6c9d57d6c1e4fcbb$export$68f3af03034c9e90)();
    const currentScope = (0, $6c9d57d6c1e4fcbb$export$c7be4b0125a10cba)();
    const session = currentScope.getSession() || isolationScope.getSession();
    if (session) (0, $71bbb010c8615be2$export$56521d9ba90f62ee)(session);
    $5125ad3d1e13a914$var$_sendSessionUpdate();
    // the session is over; take it off of the scope
    isolationScope.setSession();
}
/**
 * Sends the current Session on the scope
 */ function $5125ad3d1e13a914$var$_sendSessionUpdate() {
    const isolationScope = (0, $6c9d57d6c1e4fcbb$export$68f3af03034c9e90)();
    const client = (0, $6c9d57d6c1e4fcbb$export$6bb76d6eba7e258c)();
    const session = isolationScope.getSession();
    if (session && client) client.captureSession(session);
}
/**
 * Sends the current session on the scope to Sentry
 *
 * @param end If set the session will be marked as exited and removed from the scope.
 *            Defaults to `false`.
 */ function $5125ad3d1e13a914$export$667e7b4d445d566b(end = false) {
    // both send the update and pull the session from the scope
    if (end) {
        $5125ad3d1e13a914$export$17a5be43989a0bc1();
        return;
    }
    // only send the update
    $5125ad3d1e13a914$var$_sendSessionUpdate();
}


const $c8759183c6206ea8$export$56d8a8a25bd48b81 = (0, $517c5b29f882562f$export$f1a6cdb1459e81d1);
let $c8759183c6206ea8$var$ignoreOnError = 0;
/**
 * @hidden
 */ function $c8759183c6206ea8$export$b79738ab10c590b2() {
    return $c8759183c6206ea8$var$ignoreOnError > 0;
}
/**
 * @hidden
 */ function $c8759183c6206ea8$export$1265a142ff5ba165() {
    // onerror should trigger before setTimeout
    $c8759183c6206ea8$var$ignoreOnError++;
    setTimeout(()=>{
        $c8759183c6206ea8$var$ignoreOnError--;
    });
}
// eslint-disable-next-line @typescript-eslint/ban-types
/**
 * Instruments the given function and sends an event to Sentry every time the
 * function throws an exception.
 *
 * @param fn A function to wrap. It is generally safe to pass an unbound function, because the returned wrapper always
 * has a correct `this` context.
 * @returns The wrapped function.
 * @hidden
 */ function $c8759183c6206ea8$export$4997ffc0176396a6(fn, options = {}) {
    // for future readers what this does is wrap a function and then create
    // a bi-directional wrapping between them.
    //
    // example: wrapped = wrap(original);
    //  original.__sentry_wrapped__ -> wrapped
    //  wrapped.__sentry_original__ -> original
    function isFunction(fn) {
        return typeof fn === 'function';
    }
    if (!isFunction(fn)) return fn;
    try {
        // if we're dealing with a function that was previously wrapped, return
        // the original wrapper.
        const wrapper = fn.__sentry_wrapped__;
        if (wrapper) {
            if (typeof wrapper === 'function') return wrapper;
            else // If we find that the `__sentry_wrapped__` function is not a function at the time of accessing it, it means
            // that something messed with it. In that case we want to return the originally passed function.
            return fn;
        }
        // We don't wanna wrap it twice
        if ((0, $10696cb2974e7335$export$e6cc1e135e2092e5)(fn)) return fn;
    } catch  {
        // Just accessing custom props in some Selenium environments
        // can cause a "Permission denied" exception (see raven-js#495).
        // Bail on wrapping and return the function as-is (defers to window.onerror).
        return fn;
    }
    // Wrap the function itself
    // It is important that `sentryWrapped` is not an arrow function to preserve the context of `this`
    const sentryWrapped = function(...args) {
        try {
            // Also wrap arguments that are themselves functions
            const wrappedArguments = args.map((arg)=>$c8759183c6206ea8$export$4997ffc0176396a6(arg, options));
            // Attempt to invoke user-land function
            // NOTE: If you are a Sentry user, and you are seeing this stack frame, it
            //       means the sentry.javascript SDK caught an error invoking your application code. This
            //       is expected behavior and NOT indicative of a bug with sentry.javascript.
            return fn.apply(this, wrappedArguments);
        } catch (ex) {
            $c8759183c6206ea8$export$1265a142ff5ba165();
            (0, $6c9d57d6c1e4fcbb$export$ec58d9285c204497)((scope)=>{
                scope.addEventProcessor((event)=>{
                    if (options.mechanism) {
                        (0, $76366c1ad7fe29b9$export$f26508487bf83ee7)(event, undefined, undefined);
                        (0, $76366c1ad7fe29b9$export$c69a9a0313b03bb1)(event, options.mechanism);
                    }
                    event.extra = {
                        ...event.extra,
                        arguments: args
                    };
                    return event;
                });
                // no need to add a mechanism here, we already add it via an event processor above
                (0, $5125ad3d1e13a914$export$f5282963edea4a68)(ex);
            });
            throw ex;
        }
    };
    // Wrap the wrapped function in a proxy, to ensure any other properties of the original function remain available
    try {
        for(const property in fn)if (Object.prototype.hasOwnProperty.call(fn, property)) sentryWrapped[property] = fn[property];
    } catch  {
    // Accessing some objects may throw
    // ref: https://github.com/getsentry/sentry-javascript/issues/1168
    }
    // Signal that this function has been wrapped/filled already
    // for both debugging and to prevent it to being wrapped/filled twice
    (0, $10696cb2974e7335$export$5c1499e2e5d010ae)(sentryWrapped, fn);
    (0, $10696cb2974e7335$export$e73679ffaf56810e)(fn, '__sentry_wrapped__', sentryWrapped);
    // Restore original function name (not all browsers allow that)
    try {
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const descriptor = Object.getOwnPropertyDescriptor(sentryWrapped, 'name');
        if (descriptor.configurable) Object.defineProperty(sentryWrapped, 'name', {
            get () {
                return fn.name;
            }
        });
    } catch  {
    // This may throw if e.g. the descriptor does not exist, or a browser does not allow redefining `name`.
    // to save some bytes we simply try-catch this
    }
    return sentryWrapped;
}
/**
 * Get HTTP request data from the current page.
 */ function $c8759183c6206ea8$export$a3c4a8453e8936f0() {
    // grab as much info as exists and add it to the event
    const url = (0, $c765cb3edc177c69$export$1cfafeee2987818b)();
    const { referrer: referrer } = $c8759183c6206ea8$export$56d8a8a25bd48b81.document || {};
    const { userAgent: userAgent } = $c8759183c6206ea8$export$56d8a8a25bd48b81.navigator || {};
    const headers = {
        ...referrer && {
            Referer: referrer
        },
        ...userAgent && {
            'User-Agent': userAgent
        }
    };
    const request = {
        url: url,
        headers: headers
    };
    return request;
}


/**
 * A magic string that build tooling can leverage in order to inject a release value into the SDK.
 */ /**
 * The Sentry Browser SDK Client.
 *
 * @see BrowserOptions for documentation on configuration options.
 * @see SentryClient for usage documentation.
 */ class $03c621aa5227985a$export$1df9218a526d318d extends (0, $bcff9e27a91c274c$export$1f2bb630327ac4b6) {
    /**
   * Creates a new Browser SDK instance.
   *
   * @param options Configuration options for this SDK.
   */ constructor(options){
        const opts = $03c621aa5227985a$export$4e107b20a7f977(options);
        const sdkSource = (0, $c8759183c6206ea8$export$56d8a8a25bd48b81).SENTRY_SDK_SOURCE || (0, $90e01dff1743b442$export$8ad33f488b1ab046)();
        (0, $fe6e91a50d880076$export$b9f95b027256052c)(opts, 'browser', [
            'browser'
        ], sdkSource);
        // Only allow IP inferral by Relay if sendDefaultPii is true
        if (opts._metadata?.sdk) opts._metadata.sdk.settings = {
            infer_ip: opts.sendDefaultPii ? 'auto' : 'never',
            // purposefully allowing already passed settings to override the default
            ...opts._metadata.sdk.settings
        };
        super(opts);
        const { sendDefaultPii: sendDefaultPii, sendClientReports: sendClientReports, enableLogs: enableLogs, _experiments: _experiments, enableMetrics: enableMetricsOption } = this._options;
        // todo(v11): Remove the experimental flag
        // eslint-disable-next-line deprecation/deprecation
        const enableMetrics = enableMetricsOption ?? _experiments?.enableMetrics ?? true;
        // Flush logs and metrics when page becomes hidden (e.g., tab switch, navigation)
        // todo(v11): Remove the experimental flag
        if ((0, $c8759183c6206ea8$export$56d8a8a25bd48b81).document && (sendClientReports || enableLogs || enableMetrics)) (0, $c8759183c6206ea8$export$56d8a8a25bd48b81).document.addEventListener('visibilitychange', ()=>{
            if ((0, $c8759183c6206ea8$export$56d8a8a25bd48b81).document.visibilityState === 'hidden') {
                if (sendClientReports) this._flushOutcomes();
                if (enableLogs) (0, $1b5f53d516745d9f$export$f8ed83d3b6a0b504)(this);
                if (enableMetrics) (0, $c7fd3bed22ef46d6$export$91c9ef254b7d0f67)(this);
            }
        });
        if (sendDefaultPii) this.on('beforeSendSession', (0, $06a9701a51a9358a$export$e8e2d07ba63e2b6c));
    }
    /**
   * @inheritDoc
   */ eventFromException(exception, hint) {
        return (0, $baf0df795659509d$export$ea3ec7e569b823fc)(this._options.stackParser, exception, hint, this._options.attachStacktrace);
    }
    /**
   * @inheritDoc
   */ eventFromMessage(message, level = 'info', hint) {
        return (0, $baf0df795659509d$export$5425b53185d13d6c)(this._options.stackParser, message, level, hint, this._options.attachStacktrace);
    }
    /**
   * @inheritDoc
   */ _prepareEvent(event, hint, currentScope, isolationScope) {
        event.platform = event.platform || 'javascript';
        return super._prepareEvent(event, hint, currentScope, isolationScope);
    }
}
/** Exported only for tests. */ function $03c621aa5227985a$export$4e107b20a7f977(optionsArg) {
    return {
        release: typeof __SENTRY_RELEASE__ === 'string' // This allows build tooling to find-and-replace __SENTRY_RELEASE__ to inject a release value
         ? __SENTRY_RELEASE__ : (0, $c8759183c6206ea8$export$56d8a8a25bd48b81).SENTRY_RELEASE?.id,
        sendClientReports: true,
        // We default this to true, as it is the safer scenario
        parentSpanIsAlwaysRootSpan: true,
        ...optionsArg
    };
}





/**
 * Default maximum number of breadcrumbs added to an event. Can be overwritten
 * with {@link Options.maxBreadcrumbs}.
 */ const $27643a6c5558aaba$var$DEFAULT_BREADCRUMBS = 100;
/**
 * Records a new breadcrumb which will be attached to future events.
 *
 * Breadcrumbs will be added to subsequent events to provide more context on
 * user's actions prior to an error or crash.
 */ function $27643a6c5558aaba$export$efda9a273d7a036d(breadcrumb, hint) {
    const client = (0, $6c9d57d6c1e4fcbb$export$6bb76d6eba7e258c)();
    const isolationScope = (0, $6c9d57d6c1e4fcbb$export$68f3af03034c9e90)();
    if (!client) return;
    const { beforeBreadcrumb: beforeBreadcrumb = null, maxBreadcrumbs: maxBreadcrumbs = $27643a6c5558aaba$var$DEFAULT_BREADCRUMBS } = client.getOptions();
    if (maxBreadcrumbs <= 0) return;
    const timestamp = (0, $27fab3c4acc6cd95$export$7740643b9eeaf0c4)();
    const mergedBreadcrumb = {
        timestamp: timestamp,
        ...breadcrumb
    };
    const finalBreadcrumb = beforeBreadcrumb ? (0, $6ed5aee3203eab87$export$cda52e2a8927a2ca)(()=>beforeBreadcrumb(mergedBreadcrumb, hint)) : mergedBreadcrumb;
    if (finalBreadcrumb === null) return;
    if (client.emit) client.emit('beforeAddBreadcrumb', finalBreadcrumb, hint);
    isolationScope.addBreadcrumb(finalBreadcrumb, maxBreadcrumbs);
}







// We keep the handlers globally
const $192fdbc9fd342c1a$var$handlers = {};
const $192fdbc9fd342c1a$var$instrumented = {};
/** Add a handler function. */ function $192fdbc9fd342c1a$export$a4e09611e30da72e(type, handler) {
    $192fdbc9fd342c1a$var$handlers[type] = $192fdbc9fd342c1a$var$handlers[type] || [];
    $192fdbc9fd342c1a$var$handlers[type].push(handler);
}
/**
 * Reset all instrumentation handlers.
 * This can be used by tests to ensure we have a clean slate of instrumentation handlers.
 */ function $192fdbc9fd342c1a$export$b17eab759a1cb5fe() {
    Object.keys($192fdbc9fd342c1a$var$handlers).forEach((key)=>{
        $192fdbc9fd342c1a$var$handlers[key] = undefined;
    });
}
/** Maybe run an instrumentation function, unless it was already called. */ function $192fdbc9fd342c1a$export$e18d6c5462c01368(type, instrumentFn) {
    if (!$192fdbc9fd342c1a$var$instrumented[type]) {
        $192fdbc9fd342c1a$var$instrumented[type] = true;
        try {
            instrumentFn();
        } catch (e) {
            (0, $6d193f2c2b007873$export$16a28057038b10ef) && (0, $6ed5aee3203eab87$export$1c9f709888824e05).error(`Error while instrumenting ${type}`, e);
        }
    }
}
/** Trigger handlers for a given instrumentation type. */ function $192fdbc9fd342c1a$export$b18c893e424d3127(type, data) {
    const typeHandlers = type && $192fdbc9fd342c1a$var$handlers[type];
    if (!typeHandlers) return;
    for (const handler of typeHandlers)try {
        handler(data);
    } catch (e) {
        (0, $6d193f2c2b007873$export$16a28057038b10ef) && (0, $6ed5aee3203eab87$export$1c9f709888824e05).error(`Error while triggering instrumentation handler.\nType: ${type}\nName: ${(0, $d64dedd9c6b2e07c$export$aad197c7121a6651)(handler)}\nError:`, e);
    }
}


/**
 * Add an instrumentation handler for when a console.xxx method is called.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $5f9623eb5d1d9bde$export$1d6e0d073f9e6723(handler) {
    const type = 'console';
    (0, $192fdbc9fd342c1a$export$a4e09611e30da72e)(type, handler);
    (0, $192fdbc9fd342c1a$export$e18d6c5462c01368)(type, $5f9623eb5d1d9bde$var$instrumentConsole);
}
function $5f9623eb5d1d9bde$var$instrumentConsole() {
    if (!('console' in (0, $517c5b29f882562f$export$f1a6cdb1459e81d1))) return;
    (0, $6ed5aee3203eab87$export$2a2b1d2252a69ecb).forEach(function(level) {
        if (!(level in (0, $517c5b29f882562f$export$f1a6cdb1459e81d1).console)) return;
        (0, $10696cb2974e7335$export$9563e054e6f787fb)((0, $517c5b29f882562f$export$f1a6cdb1459e81d1).console, level, function(originalConsoleMethod) {
            (0, $6ed5aee3203eab87$export$77c4ce905194557b)[level] = originalConsoleMethod;
            return function(...args) {
                (0, $192fdbc9fd342c1a$export$b18c893e424d3127)('console', {
                    args: args,
                    level: level
                });
                const log = (0, $6ed5aee3203eab87$export$77c4ce905194557b)[level];
                log?.apply((0, $517c5b29f882562f$export$f1a6cdb1459e81d1).console, args);
            };
        });
    });
}







const $f00e028ff406ea6f$var$WINDOW = (0, $517c5b29f882562f$export$f1a6cdb1459e81d1);
/**
 * Tells whether current environment supports ErrorEvent objects
 * {@link supportsErrorEvent}.
 *
 * @returns Answer to the given question.
 */ function $f00e028ff406ea6f$export$caa710b4d7f9cadf() {
    try {
        new ErrorEvent('');
        return true;
    } catch  {
        return false;
    }
}
/**
 * Tells whether current environment supports DOMError objects
 * {@link supportsDOMError}.
 *
 * @returns Answer to the given question.
 */ function $f00e028ff406ea6f$export$1c08bd1a7eb3c472() {
    try {
        // Chrome: VM89:1 Uncaught TypeError: Failed to construct 'DOMError':
        // 1 argument required, but only 0 present.
        // @ts-expect-error It really needs 1 argument, not 0.
        new DOMError('');
        return true;
    } catch  {
        return false;
    }
}
/**
 * Tells whether current environment supports DOMException objects
 * {@link supportsDOMException}.
 *
 * @returns Answer to the given question.
 */ function $f00e028ff406ea6f$export$ab12a5d056f1d3a() {
    try {
        new DOMException('');
        return true;
    } catch  {
        return false;
    }
}
/**
 * Tells whether current environment supports History API
 * {@link supportsHistory}.
 *
 * @returns Answer to the given question.
 */ function $f00e028ff406ea6f$export$67fc34576016d6ec() {
    return 'history' in $f00e028ff406ea6f$var$WINDOW && !!$f00e028ff406ea6f$var$WINDOW.history;
}
/**
 * Tells whether current environment supports Fetch API
 * {@link supportsFetch}.
 *
 * @returns Answer to the given question.
 * @deprecated This is no longer used and will be removed in a future major version.
 */ const $f00e028ff406ea6f$export$edf3cb81fd7d2a3e = $f00e028ff406ea6f$var$_isFetchSupported;
function $f00e028ff406ea6f$var$_isFetchSupported() {
    if (!('fetch' in $f00e028ff406ea6f$var$WINDOW)) return false;
    try {
        new Headers();
        // Deno requires a valid URL so '' cannot be used as an argument
        new Request('data:,');
        new Response();
        return true;
    } catch  {
        return false;
    }
}
/**
 * isNative checks if the given function is a native implementation
 */ // eslint-disable-next-line @typescript-eslint/ban-types
function $f00e028ff406ea6f$export$d5f608b368e73f38(func) {
    return func && /^function\s+\w+\(\)\s+\{\s+\[native code\]\s+\}$/.test(func.toString());
}
/**
 * Tells whether current environment supports Fetch API natively
 * {@link supportsNativeFetch}.
 *
 * @returns true if `window.fetch` is natively implemented, false otherwise
 */ function $f00e028ff406ea6f$export$c82d238e23c40b21() {
    if (typeof EdgeRuntime === 'string') return true;
    if (!$f00e028ff406ea6f$var$_isFetchSupported()) return false;
    // Fast path to avoid DOM I/O
    // eslint-disable-next-line @typescript-eslint/unbound-method
    if ($f00e028ff406ea6f$export$d5f608b368e73f38($f00e028ff406ea6f$var$WINDOW.fetch)) return true;
    // window.fetch is implemented, but is polyfilled or already wrapped (e.g: by a chrome extension)
    // so create a "pure" iframe to see if that has native fetch
    let result = false;
    const doc = $f00e028ff406ea6f$var$WINDOW.document;
    // eslint-disable-next-line deprecation/deprecation
    if (doc && typeof doc.createElement === 'function') try {
        const sandbox = doc.createElement('iframe');
        sandbox.hidden = true;
        doc.head.appendChild(sandbox);
        if (sandbox.contentWindow?.fetch) // eslint-disable-next-line @typescript-eslint/unbound-method
        result = $f00e028ff406ea6f$export$d5f608b368e73f38(sandbox.contentWindow.fetch);
        doc.head.removeChild(sandbox);
    } catch (err) {
        (0, $6d193f2c2b007873$export$16a28057038b10ef) && (0, $6ed5aee3203eab87$export$1c9f709888824e05).warn('Could not create sandbox iframe for pure fetch check, bailing to window.fetch: ', err);
    }
    return result;
}
/**
 * Tells whether current environment supports ReportingObserver API
 * {@link supportsReportingObserver}.
 *
 * @returns Answer to the given question.
 */ function $f00e028ff406ea6f$export$531055a6c684a70a() {
    return 'ReportingObserver' in $f00e028ff406ea6f$var$WINDOW;
}
/**
 * Tells whether current environment supports Referrer Policy API
 * {@link supportsReferrerPolicy}.
 *
 * @returns Answer to the given question.
 * @deprecated This is no longer used and will be removed in a future major version.
 */ function $f00e028ff406ea6f$export$2d308b428295192f() {
    // Despite all stars in the sky saying that Edge supports old draft syntax, aka 'never', 'always', 'origin' and 'default'
    // (see https://caniuse.com/#feat=referrer-policy),
    // it doesn't. And it throws an exception instead of ignoring this parameter...
    // REF: https://github.com/getsentry/raven-js/issues/1233
    if (!$f00e028ff406ea6f$var$_isFetchSupported()) return false;
    try {
        new Request('_', {
            referrerPolicy: 'origin'
        });
        return true;
    } catch  {
        return false;
    }
}





/* eslint-disable @typescript-eslint/no-explicit-any */ /**
 * Add an instrumentation handler for when a fetch request happens.
 * The handler function is called once when the request starts and once when it ends,
 * which can be identified by checking if it has an `endTimestamp`.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $85c711f8d6e08b60$export$f75d3c772c923df0(handler, skipNativeFetchCheck) {
    const type = 'fetch';
    (0, $192fdbc9fd342c1a$export$a4e09611e30da72e)(type, handler);
    (0, $192fdbc9fd342c1a$export$e18d6c5462c01368)(type, ()=>$85c711f8d6e08b60$var$instrumentFetch(undefined, skipNativeFetchCheck));
}
/**
 * Add an instrumentation handler for long-lived fetch requests, like consuming server-sent events (SSE) via fetch.
 * The handler will resolve the request body and emit the actual `endTimestamp`, so that the
 * span can be updated accordingly.
 *
 * Only used internally
 * @hidden
 */ function $85c711f8d6e08b60$export$1a79663eb318fe6a(handler) {
    const type = 'fetch-body-resolved';
    (0, $192fdbc9fd342c1a$export$a4e09611e30da72e)(type, handler);
    (0, $192fdbc9fd342c1a$export$e18d6c5462c01368)(type, ()=>$85c711f8d6e08b60$var$instrumentFetch($85c711f8d6e08b60$var$streamHandler));
}
function $85c711f8d6e08b60$var$instrumentFetch(onFetchResolved, skipNativeFetchCheck = false) {
    if (skipNativeFetchCheck && !(0, $f00e028ff406ea6f$export$c82d238e23c40b21)()) return;
    (0, $10696cb2974e7335$export$9563e054e6f787fb)((0, $517c5b29f882562f$export$f1a6cdb1459e81d1), 'fetch', function(originalFetch) {
        return function(...args) {
            // We capture the error right here and not in the Promise error callback because Safari (and probably other
            // browsers too) will wipe the stack trace up to this point, only leaving us with this file which is useless.
            // NOTE: If you are a Sentry user, and you are seeing this stack frame,
            //       it means the error, that was caused by your fetch call did not
            //       have a stack trace, so the SDK backfilled the stack trace so
            //       you can see which fetch call failed.
            const virtualError = new Error();
            const { method: method, url: url } = $85c711f8d6e08b60$export$f7a71163cc309d9a(args);
            const handlerData = {
                args: args,
                fetchData: {
                    method: method,
                    url: url
                },
                startTimestamp: (0, $27fab3c4acc6cd95$export$ee52dced521e3e18)() * 1000,
                virtualError: // // Adding the error to be able to fingerprint the failed fetch event in HttpClient instrumentation
                virtualError,
                headers: $85c711f8d6e08b60$var$getHeadersFromFetchArgs(args)
            };
            // if there is no callback, fetch is instrumented directly
            if (!onFetchResolved) (0, $192fdbc9fd342c1a$export$b18c893e424d3127)('fetch', {
                ...handlerData
            });
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            return originalFetch.apply((0, $517c5b29f882562f$export$f1a6cdb1459e81d1), args).then(async (response)=>{
                if (onFetchResolved) onFetchResolved(response);
                else (0, $192fdbc9fd342c1a$export$b18c893e424d3127)('fetch', {
                    ...handlerData,
                    endTimestamp: (0, $27fab3c4acc6cd95$export$ee52dced521e3e18)() * 1000,
                    response: response
                });
                return response;
            }, (error)=>{
                (0, $192fdbc9fd342c1a$export$b18c893e424d3127)('fetch', {
                    ...handlerData,
                    endTimestamp: (0, $27fab3c4acc6cd95$export$ee52dced521e3e18)() * 1000,
                    error: error
                });
                if ((0, $d1f309ce92d0a600$export$e6127cc7fe7395c3)(error) && error.stack === undefined) {
                    // NOTE: If you are a Sentry user, and you are seeing this stack frame,
                    //       it means the error, that was caused by your fetch call did not
                    //       have a stack trace, so the SDK backfilled the stack trace so
                    //       you can see which fetch call failed.
                    error.stack = virtualError.stack;
                    (0, $10696cb2974e7335$export$e73679ffaf56810e)(error, 'framesToPop', 1);
                }
                // We enhance fetch error messages with hostname information based on the configuration.
                // Possible messages we handle here:
                // * "Failed to fetch" (chromium)
                // * "Load failed" (webkit)
                // * "NetworkError when attempting to fetch resource." (firefox)
                const client = (0, $6c9d57d6c1e4fcbb$export$6bb76d6eba7e258c)();
                const enhanceOption = client?.getOptions().enhanceFetchErrorMessages ?? 'always';
                const shouldEnhance = enhanceOption !== false;
                if (shouldEnhance && error instanceof TypeError && (error.message === 'Failed to fetch' || error.message === 'Load failed' || error.message === 'NetworkError when attempting to fetch resource.')) try {
                    const url = new URL(handlerData.fetchData.url);
                    const hostname = url.host;
                    if (enhanceOption === 'always') // Modify the error message directly
                    error.message = `${error.message} (${hostname})`;
                    else // Store hostname as non-enumerable property for Sentry-only enhancement
                    // This preserves the original error message for third-party packages
                    (0, $10696cb2974e7335$export$e73679ffaf56810e)(error, '__sentry_fetch_url_host__', hostname);
                } catch  {
                // ignore it if errors happen here
                }
                // NOTE: If you are a Sentry user, and you are seeing this stack frame,
                //       it means the sentry.javascript SDK caught an error invoking your application code.
                //       This is expected behavior and NOT indicative of a bug with sentry.javascript.
                throw error;
            });
        };
    });
}
async function $85c711f8d6e08b60$var$resolveResponse(res, onFinishedResolving) {
    if (res?.body) {
        const body = res.body;
        const responseReader = body.getReader();
        // Define a maximum duration after which we just cancel
        const maxFetchDurationTimeout = setTimeout(()=>{
            body.cancel().then(null, ()=>{
            // noop
            });
        }, 90000);
        let readingActive = true;
        while(readingActive){
            let chunkTimeout;
            try {
                // abort reading if read op takes more than 5s
                chunkTimeout = setTimeout(()=>{
                    body.cancel().then(null, ()=>{
                    // noop on error
                    });
                }, 5000);
                // This .read() call will reject/throw when we abort due to timeouts through `body.cancel()`
                const { done: done } = await responseReader.read();
                clearTimeout(chunkTimeout);
                if (done) {
                    onFinishedResolving();
                    readingActive = false;
                }
            } catch  {
                readingActive = false;
            } finally{
                clearTimeout(chunkTimeout);
            }
        }
        clearTimeout(maxFetchDurationTimeout);
        responseReader.releaseLock();
        body.cancel().then(null, ()=>{
        // noop on error
        });
    }
}
function $85c711f8d6e08b60$var$streamHandler(response) {
    // clone response for awaiting stream
    let clonedResponseForResolving;
    try {
        clonedResponseForResolving = response.clone();
    } catch  {
        return;
    }
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    $85c711f8d6e08b60$var$resolveResponse(clonedResponseForResolving, ()=>{
        (0, $192fdbc9fd342c1a$export$b18c893e424d3127)('fetch-body-resolved', {
            endTimestamp: (0, $27fab3c4acc6cd95$export$ee52dced521e3e18)() * 1000,
            response: response
        });
    });
}
function $85c711f8d6e08b60$var$hasProp(obj, prop) {
    return !!obj && typeof obj === 'object' && !!obj[prop];
}
function $85c711f8d6e08b60$var$getUrlFromResource(resource) {
    if (typeof resource === 'string') return resource;
    if (!resource) return '';
    if ($85c711f8d6e08b60$var$hasProp(resource, 'url')) return resource.url;
    if (resource.toString) return resource.toString();
    return '';
}
/**
 * Parses the fetch arguments to find the used Http method and the url of the request.
 * Exported for tests only.
 */ function $85c711f8d6e08b60$export$f7a71163cc309d9a(fetchArgs) {
    if (fetchArgs.length === 0) return {
        method: 'GET',
        url: ''
    };
    if (fetchArgs.length === 2) {
        const [resource, options] = fetchArgs;
        return {
            url: $85c711f8d6e08b60$var$getUrlFromResource(resource),
            method: $85c711f8d6e08b60$var$hasProp(options, 'method') ? String(options.method).toUpperCase() : (0, $d1f309ce92d0a600$export$6d3d1f317d7cda57)(resource) && $85c711f8d6e08b60$var$hasProp(resource, 'method') ? String(resource.method).toUpperCase() : 'GET'
        };
    }
    const arg = fetchArgs[0];
    return {
        url: $85c711f8d6e08b60$var$getUrlFromResource(arg),
        method: $85c711f8d6e08b60$var$hasProp(arg, 'method') ? String(arg.method).toUpperCase() : 'GET'
    };
}
function $85c711f8d6e08b60$var$getHeadersFromFetchArgs(fetchArgs) {
    const [requestArgument, optionsArgument] = fetchArgs;
    try {
        if (typeof optionsArgument === 'object' && optionsArgument !== null && 'headers' in optionsArgument && optionsArgument.headers) return new Headers(optionsArgument.headers);
        if ((0, $d1f309ce92d0a600$export$6d3d1f317d7cda57)(requestArgument)) return new Headers(requestArgument.headers);
    } catch  {
    // noop
    }
    return;
}

/**
 * Determine a breadcrumb's log level (only `warning` or `error`) based on an HTTP status code.
 */ function $d6de347693128456$export$b8cfcc4175694bcc(statusCode) {
    // NOTE: undefined defaults to 'info' in Sentry
    if (statusCode === undefined) return undefined;
    else if (statusCode >= 400 && statusCode < 500) return 'warning';
    else if (statusCode >= 500) return 'error';
    else return undefined;
}


// Curious about `thismessage:/`? See: https://www.rfc-editor.org/rfc/rfc2557.html
//  > When the methods above do not yield an absolute URI, a base URL
//  > of "thismessage:/" MUST be employed. This base URL has been
//  > defined for the sole purpose of resolving relative references
//  > within a multipart/related structure when no other base URI is
//  > specified.
//
// We need to provide a base URL to `parseStringToURLObject` because the fetch API gives us a
// relative URL sometimes.
//
// This is the only case where we need to provide a base URL to `parseStringToURLObject`
// because the relative URL is not valid on its own.
const $1ea0c5ed41c20a4d$var$DEFAULT_BASE_URL = 'thismessage:/';
/**
 * Checks if the URL object is relative
 *
 * @param url - The URL object to check
 * @returns True if the URL object is relative, false otherwise
 */ function $1ea0c5ed41c20a4d$export$e258e13805402ba7(url) {
    return 'isRelative' in url;
}
/**
 * Parses string to a URL object
 *
 * @param url - The URL to parse
 * @returns The parsed URL object or undefined if the URL is invalid
 */ function $1ea0c5ed41c20a4d$export$2004d912a9ead694(url, urlBase) {
    const isRelative = url.indexOf('://') <= 0 && url.indexOf('//') !== 0;
    const base = urlBase ?? (isRelative ? $1ea0c5ed41c20a4d$var$DEFAULT_BASE_URL : undefined);
    try {
        // Use `canParse` to short-circuit the URL constructor if it's not a valid URL
        // This is faster than trying to construct the URL and catching the error
        // Node 20+, Chrome 120+, Firefox 115+, Safari 17+
        if ('canParse' in URL && !URL.canParse(url, base)) return undefined;
        const fullUrlObject = new URL(url, base);
        if (isRelative) // Because we used a fake base URL, we need to return a relative URL object.
        // We cannot return anything about the origin, host, etc. because it will refer to the fake base URL.
        return {
            isRelative: isRelative,
            pathname: fullUrlObject.pathname,
            search: fullUrlObject.search,
            hash: fullUrlObject.hash
        };
        return fullUrlObject;
    } catch  {
    // empty body
    }
    return undefined;
}
/**
 * Takes a URL object and returns a sanitized string which is safe to use as span name
 * see: https://develop.sentry.dev/sdk/data-handling/#structuring-data
 */ function $1ea0c5ed41c20a4d$export$5339fcdc8e2a427c(url) {
    if ($1ea0c5ed41c20a4d$export$e258e13805402ba7(url)) return url.pathname;
    const newUrl = new URL(url);
    newUrl.search = '';
    newUrl.hash = '';
    if ([
        '80',
        '443'
    ].includes(newUrl.port)) newUrl.port = '';
    if (newUrl.password) newUrl.password = '%filtered%';
    if (newUrl.username) newUrl.username = '%filtered%';
    return newUrl.toString();
}
function $1ea0c5ed41c20a4d$var$getHttpSpanNameFromUrlObject(urlObject, kind, request, routeName) {
    const method = request?.method?.toUpperCase() ?? 'GET';
    const route = routeName ? routeName : urlObject ? kind === 'client' ? $1ea0c5ed41c20a4d$export$5339fcdc8e2a427c(urlObject) : urlObject.pathname : '/';
    return `${method} ${route}`;
}
/**
 * Takes a parsed URL object and returns a set of attributes for the span
 * that represents the HTTP request for that url. This is used for both server
 * and client http spans.
 *
 * Follows https://opentelemetry.io/docs/specs/semconv/http/.
 *
 * @param urlObject - see {@link parseStringToURLObject}
 * @param kind - The type of HTTP operation (server or client)
 * @param spanOrigin - The origin of the span
 * @param request - The request object, see {@link PartialRequest}
 * @param routeName - The name of the route, must be low cardinality
 * @returns The span name and attributes for the HTTP operation
 */ function $1ea0c5ed41c20a4d$export$c37a41544f3c180c(urlObject, kind, spanOrigin, request, routeName) {
    const attributes = {
        [(0, $0633c8eb02923c67$export$cca8dd30f57f805e)]: spanOrigin,
        [(0, $0633c8eb02923c67$export$d7a7d984b0791405)]: 'url'
    };
    if (routeName) {
        // This is based on https://opentelemetry.io/docs/specs/semconv/http/http-spans/#name
        attributes[kind === 'server' ? 'http.route' : 'url.template'] = routeName;
        attributes[0, $0633c8eb02923c67$export$d7a7d984b0791405] = 'route';
    }
    if (request?.method) attributes[0, $0633c8eb02923c67$export$be7a251980e7e946] = request.method.toUpperCase();
    if (urlObject) {
        if (urlObject.search) attributes['url.query'] = urlObject.search;
        if (urlObject.hash) attributes['url.fragment'] = urlObject.hash;
        if (urlObject.pathname) {
            attributes['url.path'] = urlObject.pathname;
            if (urlObject.pathname === '/') attributes[0, $0633c8eb02923c67$export$d7a7d984b0791405] = 'route';
        }
        if (!$1ea0c5ed41c20a4d$export$e258e13805402ba7(urlObject)) {
            attributes[0, $0633c8eb02923c67$export$25dfd73e0e32c6e1] = urlObject.href;
            if (urlObject.port) attributes['url.port'] = urlObject.port;
            if (urlObject.protocol) attributes['url.scheme'] = urlObject.protocol;
            if (urlObject.hostname) attributes[kind === 'server' ? 'server.address' : 'url.domain'] = urlObject.hostname;
        }
    }
    return [
        $1ea0c5ed41c20a4d$var$getHttpSpanNameFromUrlObject(urlObject, kind, request, routeName),
        attributes
    ];
}
/**
 * Parses string form of URL into an object
 * // borrowed from https://tools.ietf.org/html/rfc3986#appendix-B
 * // intentionally using regex and not <a/> href parsing trick because React Native and other
 * // environments where DOM might not be available
 * @returns parsed URL object
 */ function $1ea0c5ed41c20a4d$export$7a5253c0f62e0150(url) {
    if (!url) return {};
    const match = url.match(/^(([^:/?#]+):)?(\/\/([^/?#]*))?([^?#]*)(\?([^#]*))?(#(.*))?$/);
    if (!match) return {};
    // coerce to undefined values to empty string so we don't get 'undefined'
    const query = match[6] || '';
    const fragment = match[8] || '';
    return {
        host: match[4],
        path: match[5],
        protocol: match[2],
        search: query,
        hash: fragment,
        relative: match[5] + query + fragment
    };
}
/**
 * Strip the query string and fragment off of a given URL or path (if present)
 *
 * @param urlPath Full URL or path, including possible query string and/or fragment
 * @returns URL or path without query string or fragment
 */ function $1ea0c5ed41c20a4d$export$ce084c78234bd35(urlPath) {
    return urlPath.split(/[?#]/, 1)[0];
}
/**
 * Takes a URL object and returns a sanitized string which is safe to use as span name
 * see: https://develop.sentry.dev/sdk/data-handling/#structuring-data
 */ function $1ea0c5ed41c20a4d$export$e0ba26c9e23e1fe0(url) {
    const { protocol: protocol, host: host, path: path } = url;
    const filteredHost = host?.replace(/^.*@/, '[filtered]:[filtered]@').replace(/(:80)$/, '').replace(/(:443)$/, '') || '';
    return `${protocol ? `${protocol}://` : ''}${filteredHost}${path}`;
}
/**
 * Strips the content from a data URL, returning a placeholder with the MIME type.
 *
 * Data URLs can be very long (e.g. base64 encoded scripts for Web Workers),
 * with little valuable information, often leading to envelopes getting dropped due
 * to size limit violations. Therefore, we strip data URLs and replace them with a
 * placeholder.
 *
 * @param url - The URL to process
 * @param includeDataPrefix - If true, includes the first 10 characters of the data stream
 *                            for debugging (e.g., to identify magic bytes like WASM's AGFzbQ).
 *                            Defaults to true.
 * @returns For data URLs, returns a short format like `data:text/javascript;base64,SGVsbG8gV2... [truncated]`.
 *          For non-data URLs, returns the original URL unchanged.
 */ function $1ea0c5ed41c20a4d$export$8abd806fcaf234fa(url, includeDataPrefix = true) {
    if (url.startsWith('data:')) {
        // Match the MIME type (everything after 'data:' until the first ';' or ',')
        const match = url.match(/^data:([^;,]+)/);
        const mimeType = match ? match[1] : 'text/plain';
        const isBase64 = url.includes(';base64,');
        // Find where the actual data starts (after the comma)
        const dataStart = url.indexOf(',');
        let dataPrefix = '';
        if (includeDataPrefix && dataStart !== -1) {
            const data = url.slice(dataStart + 1);
            // Include first 10 chars of data to help identify content (e.g., magic bytes)
            dataPrefix = data.length > 10 ? `${data.slice(0, 10)}... [truncated]` : data;
        }
        return `data:${mimeType}${isBase64 ? ',base64' : ''}${dataPrefix ? `,${dataPrefix}` : ''}`;
    }
    return url;
}

/**
 * Converts a string-based level into a `SeverityLevel`, normalizing it along the way.
 *
 * @param level String representation of desired `SeverityLevel`.
 * @returns The `SeverityLevel` corresponding to the given string, or 'log' if the string isn't a valid level.
 */ function $eeb82fc26d98a85e$export$d771ef054122c30a(level) {
    return level === 'warn' ? 'warning' : [
        'fatal',
        'error',
        'warning',
        'log',
        'info',
        'debug'
    ].includes(level) ? level : 'log';
}




const $0a7a9faa9b397042$export$56d8a8a25bd48b81 = (0, $517c5b29f882562f$export$f1a6cdb1459e81d1);


const $06b149b84ddb8746$var$DEBOUNCE_DURATION = 1000;
let $06b149b84ddb8746$var$debounceTimerID;
let $06b149b84ddb8746$var$lastCapturedEventType;
let $06b149b84ddb8746$var$lastCapturedEventTargetId;
/**
 * Add an instrumentation handler for when a click or a keypress happens.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $06b149b84ddb8746$export$5aeffd3db2cf9df7(handler) {
    const type = 'dom';
    (0, $192fdbc9fd342c1a$export$a4e09611e30da72e)(type, handler);
    (0, $192fdbc9fd342c1a$export$e18d6c5462c01368)(type, $06b149b84ddb8746$export$3014bbf0af0e1d4a);
}
/** Exported for tests only. */ function $06b149b84ddb8746$export$3014bbf0af0e1d4a() {
    if (!(0, $0a7a9faa9b397042$export$56d8a8a25bd48b81).document) return;
    // Make it so that any click or keypress that is unhandled / bubbled up all the way to the document triggers our dom
    // handlers. (Normally we have only one, which captures a breadcrumb for each click or keypress.) Do this before
    // we instrument `addEventListener` so that we don't end up attaching this handler twice.
    const triggerDOMHandler = (0, $192fdbc9fd342c1a$export$b18c893e424d3127).bind(null, 'dom');
    const globalDOMEventHandler = $06b149b84ddb8746$var$makeDOMEventHandler(triggerDOMHandler, true);
    (0, $0a7a9faa9b397042$export$56d8a8a25bd48b81).document.addEventListener('click', globalDOMEventHandler, false);
    (0, $0a7a9faa9b397042$export$56d8a8a25bd48b81).document.addEventListener('keypress', globalDOMEventHandler, false);
    // After hooking into click and keypress events bubbled up to `document`, we also hook into user-handled
    // clicks & keypresses, by adding an event listener of our own to any element to which they add a listener. That
    // way, whenever one of their handlers is triggered, ours will be, too. (This is needed because their handler
    // could potentially prevent the event from bubbling up to our global listeners. This way, our handler are still
    // guaranteed to fire at least once.)
    [
        'EventTarget',
        'Node'
    ].forEach((target)=>{
        const globalObject = (0, $0a7a9faa9b397042$export$56d8a8a25bd48b81);
        const proto = globalObject[target]?.prototype;
        // eslint-disable-next-line no-prototype-builtins
        if (!proto?.hasOwnProperty?.('addEventListener')) return;
        (0, $10696cb2974e7335$export$9563e054e6f787fb)(proto, 'addEventListener', function(originalAddEventListener) {
            return function(type, listener, options) {
                if (type === 'click' || type == 'keypress') try {
                    const handlers = this.__sentry_instrumentation_handlers__ = this.__sentry_instrumentation_handlers__ || {};
                    const handlerForType = handlers[type] = handlers[type] || {
                        refCount: 0
                    };
                    if (!handlerForType.handler) {
                        const handler = $06b149b84ddb8746$var$makeDOMEventHandler(triggerDOMHandler);
                        handlerForType.handler = handler;
                        originalAddEventListener.call(this, type, handler, options);
                    }
                    handlerForType.refCount++;
                } catch  {
                // Accessing dom properties is always fragile.
                // Also allows us to skip `addEventListeners` calls with no proper `this` context.
                }
                return originalAddEventListener.call(this, type, listener, options);
            };
        });
        (0, $10696cb2974e7335$export$9563e054e6f787fb)(proto, 'removeEventListener', function(originalRemoveEventListener) {
            return function(type, listener, options) {
                if (type === 'click' || type == 'keypress') try {
                    const handlers = this.__sentry_instrumentation_handlers__ || {};
                    const handlerForType = handlers[type];
                    if (handlerForType) {
                        handlerForType.refCount--;
                        // If there are no longer any custom handlers of the current type on this element, we can remove ours, too.
                        if (handlerForType.refCount <= 0) {
                            originalRemoveEventListener.call(this, type, handlerForType.handler, options);
                            handlerForType.handler = undefined;
                            delete handlers[type]; // eslint-disable-line @typescript-eslint/no-dynamic-delete
                        }
                        // If there are no longer any custom handlers of any type on this element, cleanup everything.
                        if (Object.keys(handlers).length === 0) delete this.__sentry_instrumentation_handlers__;
                    }
                } catch  {
                // Accessing dom properties is always fragile.
                // Also allows us to skip `addEventListeners` calls with no proper `this` context.
                }
                return originalRemoveEventListener.call(this, type, listener, options);
            };
        });
    });
}
/**
 * Check whether the event is similar to the last captured one. For example, two click events on the same button.
 */ function $06b149b84ddb8746$var$isSimilarToLastCapturedEvent(event) {
    // If both events have different type, then user definitely performed two separate actions. e.g. click + keypress.
    if (event.type !== $06b149b84ddb8746$var$lastCapturedEventType) return false;
    try {
        // If both events have the same type, it's still possible that actions were performed on different targets.
        // e.g. 2 clicks on different buttons.
        if (!event.target || event.target._sentryId !== $06b149b84ddb8746$var$lastCapturedEventTargetId) return false;
    } catch  {
    // just accessing `target` property can throw an exception in some rare circumstances
    // see: https://github.com/getsentry/sentry-javascript/issues/838
    }
    // If both events have the same type _and_ same `target` (an element which triggered an event, _not necessarily_
    // to which an event listener was attached), we treat them as the same action, as we want to capture
    // only one breadcrumb. e.g. multiple clicks on the same button, or typing inside a user input box.
    return true;
}
/**
 * Decide whether an event should be captured.
 * @param event event to be captured
 */ function $06b149b84ddb8746$var$shouldSkipDOMEvent(eventType, target) {
    // We are only interested in filtering `keypress` events for now.
    if (eventType !== 'keypress') return false;
    if (!target?.tagName) return true;
    // Only consider keypress events on actual input elements. This will disregard keypresses targeting body
    // e.g.tabbing through elements, hotkeys, etc.
    if (target.tagName === 'INPUT' || target.tagName === 'TEXTAREA' || target.isContentEditable) return false;
    return true;
}
/**
 * Wraps addEventListener to capture UI breadcrumbs
 */ function $06b149b84ddb8746$var$makeDOMEventHandler(handler, globalListener = false) {
    return (event)=>{
        // It's possible this handler might trigger multiple times for the same
        // event (e.g. event propagation through node ancestors).
        // Ignore if we've already captured that event.
        if (!event || event['_sentryCaptured']) return;
        const target = $06b149b84ddb8746$var$getEventTarget(event);
        // We always want to skip _some_ events.
        if ($06b149b84ddb8746$var$shouldSkipDOMEvent(event.type, target)) return;
        // Mark event as "seen"
        (0, $10696cb2974e7335$export$e73679ffaf56810e)(event, '_sentryCaptured', true);
        if (target && !target._sentryId) // Add UUID to event target so we can identify if
        (0, $10696cb2974e7335$export$e73679ffaf56810e)(target, '_sentryId', (0, $76366c1ad7fe29b9$export$19f53698e68b2496)());
        const name = event.type === 'keypress' ? 'input' : event.type;
        // If there is no last captured event, it means that we can safely capture the new event and store it for future comparisons.
        // If there is a last captured event, see if the new event is different enough to treat it as a unique one.
        // If that's the case, emit the previous event and store locally the newly-captured DOM event.
        if (!$06b149b84ddb8746$var$isSimilarToLastCapturedEvent(event)) {
            const handlerData = {
                event: event,
                name: name,
                global: globalListener
            };
            handler(handlerData);
            $06b149b84ddb8746$var$lastCapturedEventType = event.type;
            $06b149b84ddb8746$var$lastCapturedEventTargetId = target ? target._sentryId : undefined;
        }
        // Start a new debounce timer that will prevent us from capturing multiple events that should be grouped together.
        clearTimeout($06b149b84ddb8746$var$debounceTimerID);
        $06b149b84ddb8746$var$debounceTimerID = (0, $0a7a9faa9b397042$export$56d8a8a25bd48b81).setTimeout(()=>{
            $06b149b84ddb8746$var$lastCapturedEventTargetId = undefined;
            $06b149b84ddb8746$var$lastCapturedEventType = undefined;
        }, $06b149b84ddb8746$var$DEBOUNCE_DURATION);
    };
}
function $06b149b84ddb8746$var$getEventTarget(event) {
    try {
        return event.target;
    } catch  {
        // just accessing `target` property can throw an exception in some rare circumstances
        // see: https://github.com/getsentry/sentry-javascript/issues/838
        return null;
    }
}



let $b56cbd5d18686f38$var$lastHref;
/**
 * Add an instrumentation handler for when a fetch request happens.
 * The handler function is called once when the request starts and once when it ends,
 * which can be identified by checking if it has an `endTimestamp`.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $b56cbd5d18686f38$export$3f18c56c58114e75(handler) {
    const type = 'history';
    (0, $192fdbc9fd342c1a$export$a4e09611e30da72e)(type, handler);
    (0, $192fdbc9fd342c1a$export$e18d6c5462c01368)(type, $b56cbd5d18686f38$export$d9b613a6254a184e);
}
/**
 * Exported just for testing
 */ function $b56cbd5d18686f38$export$d9b613a6254a184e() {
    // The `popstate` event may also be triggered on `pushState`, but it may not always reliably be emitted by the browser
    // Which is why we also monkey-patch methods below, in addition to this
    (0, $0a7a9faa9b397042$export$56d8a8a25bd48b81).addEventListener('popstate', ()=>{
        const to = (0, $0a7a9faa9b397042$export$56d8a8a25bd48b81).location.href;
        // keep track of the current URL state, as we always receive only the updated state
        const from = $b56cbd5d18686f38$var$lastHref;
        $b56cbd5d18686f38$var$lastHref = to;
        if (from === to) return;
        const handlerData = {
            from: from,
            to: to
        };
        (0, $192fdbc9fd342c1a$export$b18c893e424d3127)('history', handlerData);
    });
    // Just guard against this not being available, in weird environments
    if (!(0, $f00e028ff406ea6f$export$67fc34576016d6ec)()) return;
    function historyReplacementFunction(originalHistoryFunction) {
        return function(...args) {
            const url = args.length > 2 ? args[2] : undefined;
            if (url) {
                const from = $b56cbd5d18686f38$var$lastHref;
                // Ensure the URL is absolute
                // this can be either a path, then it is relative to the current origin
                // or a full URL of the current origin - other origins are not allowed
                // See: https://developer.mozilla.org/en-US/docs/Web/API/History/pushState#url
                // coerce to string (this is what pushState does)
                const to = $b56cbd5d18686f38$var$getAbsoluteUrl(String(url));
                // keep track of the current URL state, as we always receive only the updated state
                $b56cbd5d18686f38$var$lastHref = to;
                if (from === to) return originalHistoryFunction.apply(this, args);
                const handlerData = {
                    from: from,
                    to: to
                };
                (0, $192fdbc9fd342c1a$export$b18c893e424d3127)('history', handlerData);
            }
            return originalHistoryFunction.apply(this, args);
        };
    }
    (0, $10696cb2974e7335$export$9563e054e6f787fb)((0, $0a7a9faa9b397042$export$56d8a8a25bd48b81).history, 'pushState', historyReplacementFunction);
    (0, $10696cb2974e7335$export$9563e054e6f787fb)((0, $0a7a9faa9b397042$export$56d8a8a25bd48b81).history, 'replaceState', historyReplacementFunction);
}
function $b56cbd5d18686f38$var$getAbsoluteUrl(urlOrPath) {
    try {
        const url = new URL(urlOrPath, (0, $0a7a9faa9b397042$export$56d8a8a25bd48b81).location.origin);
        return url.toString();
    } catch  {
        // fallback, just do nothing
        return urlOrPath;
    }
}



const $0b882197debcbce5$export$55b6bb1e45c6cf59 = '__sentry_xhr_v3__';
/**
 * Add an instrumentation handler for when an XHR request happens.
 * The handler function is called once when the request starts and once when it ends,
 * which can be identified by checking if it has an `endTimestamp`.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $0b882197debcbce5$export$26ace48dd54c9aea(handler) {
    const type = 'xhr';
    (0, $192fdbc9fd342c1a$export$a4e09611e30da72e)(type, handler);
    (0, $192fdbc9fd342c1a$export$e18d6c5462c01368)(type, $0b882197debcbce5$export$c67d533bf77cbf54);
}
/** Exported only for tests. */ function $0b882197debcbce5$export$c67d533bf77cbf54() {
    if (!(0, $0a7a9faa9b397042$export$56d8a8a25bd48b81).XMLHttpRequest) return;
    const xhrproto = XMLHttpRequest.prototype;
    // eslint-disable-next-line @typescript-eslint/unbound-method
    xhrproto.open = new Proxy(xhrproto.open, {
        apply (originalOpen, xhrOpenThisArg, xhrOpenArgArray) {
            // NOTE: If you are a Sentry user, and you are seeing this stack frame,
            //       it means the error, that was caused by your XHR call did not
            //       have a stack trace. If you are using HttpClient integration,
            //       this is the expected behavior, as we are using this virtual error to capture
            //       the location of your XHR call, and group your HttpClient events accordingly.
            const virtualError = new Error();
            const startTimestamp = (0, $27fab3c4acc6cd95$export$ee52dced521e3e18)() * 1000;
            // open() should always be called with two or more arguments
            // But to be on the safe side, we actually validate this and bail out if we don't have a method & url
            const method = (0, $d1f309ce92d0a600$export$844ec244b1367d54)(xhrOpenArgArray[0]) ? xhrOpenArgArray[0].toUpperCase() : undefined;
            const url = $0b882197debcbce5$var$parseXhrUrlArg(xhrOpenArgArray[1]);
            if (!method || !url) return originalOpen.apply(xhrOpenThisArg, xhrOpenArgArray);
            xhrOpenThisArg[$0b882197debcbce5$export$55b6bb1e45c6cf59] = {
                method: method,
                url: url,
                request_headers: {}
            };
            // if Sentry key appears in URL, don't capture it as a request
            if (method === 'POST' && url.match(/sentry_key/)) xhrOpenThisArg.__sentry_own_request__ = true;
            const onreadystatechangeHandler = ()=>{
                // For whatever reason, this is not the same instance here as from the outer method
                const xhrInfo = xhrOpenThisArg[$0b882197debcbce5$export$55b6bb1e45c6cf59];
                if (!xhrInfo) return;
                if (xhrOpenThisArg.readyState === 4) {
                    try {
                        // touching statusCode in some platforms throws
                        // an exception
                        xhrInfo.status_code = xhrOpenThisArg.status;
                    } catch  {
                    /* do nothing */ }
                    const handlerData = {
                        endTimestamp: (0, $27fab3c4acc6cd95$export$ee52dced521e3e18)() * 1000,
                        startTimestamp: startTimestamp,
                        xhr: xhrOpenThisArg,
                        virtualError: virtualError
                    };
                    (0, $192fdbc9fd342c1a$export$b18c893e424d3127)('xhr', handlerData);
                }
            };
            if ('onreadystatechange' in xhrOpenThisArg && typeof xhrOpenThisArg.onreadystatechange === 'function') xhrOpenThisArg.onreadystatechange = new Proxy(xhrOpenThisArg.onreadystatechange, {
                apply (originalOnreadystatechange, onreadystatechangeThisArg, onreadystatechangeArgArray) {
                    onreadystatechangeHandler();
                    return originalOnreadystatechange.apply(onreadystatechangeThisArg, onreadystatechangeArgArray);
                }
            });
            else xhrOpenThisArg.addEventListener('readystatechange', onreadystatechangeHandler);
            // Intercepting `setRequestHeader` to access the request headers of XHR instance.
            // This will only work for user/library defined headers, not for the default/browser-assigned headers.
            // Request cookies are also unavailable for XHR, as `Cookie` header can't be defined by `setRequestHeader`.
            xhrOpenThisArg.setRequestHeader = new Proxy(xhrOpenThisArg.setRequestHeader, {
                apply (originalSetRequestHeader, setRequestHeaderThisArg, setRequestHeaderArgArray) {
                    const [header, value] = setRequestHeaderArgArray;
                    const xhrInfo = setRequestHeaderThisArg[$0b882197debcbce5$export$55b6bb1e45c6cf59];
                    if (xhrInfo && (0, $d1f309ce92d0a600$export$844ec244b1367d54)(header) && (0, $d1f309ce92d0a600$export$844ec244b1367d54)(value)) xhrInfo.request_headers[header.toLowerCase()] = value;
                    return originalSetRequestHeader.apply(setRequestHeaderThisArg, setRequestHeaderArgArray);
                }
            });
            return originalOpen.apply(xhrOpenThisArg, xhrOpenArgArray);
        }
    });
    // eslint-disable-next-line @typescript-eslint/unbound-method
    xhrproto.send = new Proxy(xhrproto.send, {
        apply (originalSend, sendThisArg, sendArgArray) {
            const sentryXhrData = sendThisArg[$0b882197debcbce5$export$55b6bb1e45c6cf59];
            if (!sentryXhrData) return originalSend.apply(sendThisArg, sendArgArray);
            if (sendArgArray[0] !== undefined) sentryXhrData.body = sendArgArray[0];
            const handlerData = {
                startTimestamp: (0, $27fab3c4acc6cd95$export$ee52dced521e3e18)() * 1000,
                xhr: sendThisArg
            };
            (0, $192fdbc9fd342c1a$export$b18c893e424d3127)('xhr', handlerData);
            return originalSend.apply(sendThisArg, sendArgArray);
        }
    });
}
/**
 * Parses the URL argument of a XHR method to a string.
 *
 * See: https://developer.mozilla.org/en-US/docs/Web/API/XMLHttpRequest/open#url
 * url: A string or any other object with a stringifier — including a URL object — that provides the URL of the resource to send the request to.
 *
 * @param url - The URL argument of an XHR method
 * @returns The parsed URL string or undefined if the URL is invalid
 */ function $0b882197debcbce5$var$parseXhrUrlArg(url) {
    if ((0, $d1f309ce92d0a600$export$844ec244b1367d54)(url)) return url;
    try {
        // If the passed in argument is not a string, it should have a `toString` method as a stringifier.
        // If that fails, we just return undefined (like in IE11 where URL is not available)
        return url.toString();
    } catch  {} // eslint-disable-line no-empty
    return undefined;
}


/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */ const $ac5edc7981a81b87$export$16a28057038b10ef = typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__;



/** maxStringLength gets capped to prevent 100 breadcrumbs exceeding 1MB event payload size */ const $fef7c5073f0eda77$var$MAX_ALLOWED_STRING_LENGTH = 1024;
const $fef7c5073f0eda77$var$INTEGRATION_NAME = 'Breadcrumbs';
const $fef7c5073f0eda77$var$_breadcrumbsIntegration = (options = {})=>{
    const _options = {
        console: true,
        dom: true,
        fetch: true,
        history: true,
        sentry: true,
        xhr: true,
        ...options
    };
    return {
        name: $fef7c5073f0eda77$var$INTEGRATION_NAME,
        setup (client) {
            // TODO(v11): Remove this functionality and use `consoleIntegration` from @sentry/core instead.
            if (_options.console) (0, $5f9623eb5d1d9bde$export$1d6e0d073f9e6723)($fef7c5073f0eda77$var$_getConsoleBreadcrumbHandler(client));
            if (_options.dom) (0, $06b149b84ddb8746$export$5aeffd3db2cf9df7)($fef7c5073f0eda77$var$_getDomBreadcrumbHandler(client, _options.dom));
            if (_options.xhr) (0, $0b882197debcbce5$export$26ace48dd54c9aea)($fef7c5073f0eda77$var$_getXhrBreadcrumbHandler(client));
            if (_options.fetch) (0, $85c711f8d6e08b60$export$f75d3c772c923df0)($fef7c5073f0eda77$var$_getFetchBreadcrumbHandler(client));
            if (_options.history) (0, $b56cbd5d18686f38$export$3f18c56c58114e75)($fef7c5073f0eda77$var$_getHistoryBreadcrumbHandler(client));
            if (_options.sentry) client.on('beforeSendEvent', $fef7c5073f0eda77$var$_getSentryBreadcrumbHandler(client));
        }
    };
};
const $fef7c5073f0eda77$export$c079d904b326663a = (0, $305b4dfee0d746dc$export$2323046b9414659f)($fef7c5073f0eda77$var$_breadcrumbsIntegration);
/**
 * Adds a breadcrumb for Sentry events or transactions if this option is enabled.
 */ function $fef7c5073f0eda77$var$_getSentryBreadcrumbHandler(client) {
    return function addSentryBreadcrumb(event) {
        if ((0, $6c9d57d6c1e4fcbb$export$6bb76d6eba7e258c)() !== client) return;
        (0, $27643a6c5558aaba$export$efda9a273d7a036d)({
            category: `sentry.${event.type === 'transaction' ? 'transaction' : 'event'}`,
            event_id: event.event_id,
            level: event.level,
            message: (0, $76366c1ad7fe29b9$export$4157119e2b157127)(event)
        }, {
            event: event
        });
    };
}
/**
 * A HOC that creates a function that creates breadcrumbs from DOM API calls.
 * This is a HOC so that we get access to dom options in the closure.
 */ function $fef7c5073f0eda77$var$_getDomBreadcrumbHandler(client, dom) {
    return function _innerDomBreadcrumb(handlerData) {
        if ((0, $6c9d57d6c1e4fcbb$export$6bb76d6eba7e258c)() !== client) return;
        let target;
        let componentName;
        let keyAttrs = typeof dom === 'object' ? dom.serializeAttribute : undefined;
        let maxStringLength = typeof dom === 'object' && typeof dom.maxStringLength === 'number' ? dom.maxStringLength : undefined;
        if (maxStringLength && maxStringLength > $fef7c5073f0eda77$var$MAX_ALLOWED_STRING_LENGTH) {
            (0, $ac5edc7981a81b87$export$16a28057038b10ef) && (0, $6ed5aee3203eab87$export$1c9f709888824e05).warn(`\`dom.maxStringLength\` cannot exceed ${$fef7c5073f0eda77$var$MAX_ALLOWED_STRING_LENGTH}, but a value of ${maxStringLength} was configured. Sentry will use ${$fef7c5073f0eda77$var$MAX_ALLOWED_STRING_LENGTH} instead.`);
            maxStringLength = $fef7c5073f0eda77$var$MAX_ALLOWED_STRING_LENGTH;
        }
        if (typeof keyAttrs === 'string') keyAttrs = [
            keyAttrs
        ];
        // Accessing event.target can throw (see getsentry/raven-js#838, #768)
        try {
            const event = handlerData.event;
            const element = $fef7c5073f0eda77$var$_isEvent(event) ? event.target : event;
            target = (0, $c765cb3edc177c69$export$5647df6b7814ac86)(element, {
                keyAttrs: keyAttrs,
                maxStringLength: maxStringLength
            });
            componentName = (0, $c765cb3edc177c69$export$26727cfcc4d7e0fc)(element);
        } catch  {
            target = '<unknown>';
        }
        if (target.length === 0) return;
        const breadcrumb = {
            category: `ui.${handlerData.name}`,
            message: target
        };
        if (componentName) breadcrumb.data = {
            'ui.component_name': componentName
        };
        (0, $27643a6c5558aaba$export$efda9a273d7a036d)(breadcrumb, {
            event: handlerData.event,
            name: handlerData.name,
            global: handlerData.global
        });
    };
}
/**
 * Creates breadcrumbs from console API calls
 */ function $fef7c5073f0eda77$var$_getConsoleBreadcrumbHandler(client) {
    return function _consoleBreadcrumb(handlerData) {
        if ((0, $6c9d57d6c1e4fcbb$export$6bb76d6eba7e258c)() !== client) return;
        const breadcrumb = {
            category: 'console',
            data: {
                arguments: handlerData.args,
                logger: 'console'
            },
            level: (0, $eeb82fc26d98a85e$export$d771ef054122c30a)(handlerData.level),
            message: (0, $5b085f0f99265e84$export$465e9d514283d4fd)(handlerData.args, ' ')
        };
        if (handlerData.level === 'assert') {
            if (handlerData.args[0] === false) {
                breadcrumb.message = `Assertion failed: ${(0, $5b085f0f99265e84$export$465e9d514283d4fd)(handlerData.args.slice(1), ' ') || 'console.assert'}`;
                breadcrumb.data.arguments = handlerData.args.slice(1);
            } else // Don't capture a breadcrumb for passed assertions
            return;
        }
        (0, $27643a6c5558aaba$export$efda9a273d7a036d)(breadcrumb, {
            input: handlerData.args,
            level: handlerData.level
        });
    };
}
/**
 * Creates breadcrumbs from XHR API calls
 */ function $fef7c5073f0eda77$var$_getXhrBreadcrumbHandler(client) {
    return function _xhrBreadcrumb(handlerData) {
        if ((0, $6c9d57d6c1e4fcbb$export$6bb76d6eba7e258c)() !== client) return;
        const { startTimestamp: startTimestamp, endTimestamp: endTimestamp } = handlerData;
        const sentryXhrData = handlerData.xhr[0, $0b882197debcbce5$export$55b6bb1e45c6cf59];
        // We only capture complete, non-sentry requests
        if (!startTimestamp || !endTimestamp || !sentryXhrData) return;
        const { method: method, url: url, status_code: status_code, body: body } = sentryXhrData;
        const data = {
            method: method,
            url: url,
            status_code: status_code
        };
        const hint = {
            xhr: handlerData.xhr,
            input: body,
            startTimestamp: startTimestamp,
            endTimestamp: endTimestamp
        };
        const breadcrumb = {
            category: 'xhr',
            data: data,
            type: 'http',
            level: (0, $d6de347693128456$export$b8cfcc4175694bcc)(status_code)
        };
        client.emit('beforeOutgoingRequestBreadcrumb', breadcrumb, hint);
        (0, $27643a6c5558aaba$export$efda9a273d7a036d)(breadcrumb, hint);
    };
}
/**
 * Creates breadcrumbs from fetch API calls
 */ function $fef7c5073f0eda77$var$_getFetchBreadcrumbHandler(client) {
    return function _fetchBreadcrumb(handlerData) {
        if ((0, $6c9d57d6c1e4fcbb$export$6bb76d6eba7e258c)() !== client) return;
        const { startTimestamp: startTimestamp, endTimestamp: endTimestamp } = handlerData;
        // We only capture complete fetch requests
        if (!endTimestamp) return;
        if (handlerData.fetchData.url.match(/sentry_key/) && handlerData.fetchData.method === 'POST') // We will not create breadcrumbs for fetch requests that contain `sentry_key` (internal sentry requests)
        return;
        if (handlerData.error) {
            const hint = {
                data: handlerData.error,
                input: handlerData.args,
                startTimestamp: startTimestamp,
                endTimestamp: endTimestamp
            };
            const breadcrumb = {
                category: 'fetch',
                data: handlerData.fetchData,
                level: 'error',
                type: 'http'
            };
            client.emit('beforeOutgoingRequestBreadcrumb', breadcrumb, hint);
            (0, $27643a6c5558aaba$export$efda9a273d7a036d)(breadcrumb, hint);
        } else {
            const response = handlerData.response;
            const data = {
                ...handlerData.fetchData,
                status_code: response?.status
            };
            const hint = {
                input: handlerData.args,
                response: response,
                startTimestamp: startTimestamp,
                endTimestamp: endTimestamp
            };
            const breadcrumb = {
                category: 'fetch',
                data: data,
                type: 'http',
                level: (0, $d6de347693128456$export$b8cfcc4175694bcc)(data.status_code)
            };
            client.emit('beforeOutgoingRequestBreadcrumb', breadcrumb, hint);
            (0, $27643a6c5558aaba$export$efda9a273d7a036d)(breadcrumb, hint);
        }
    };
}
/**
 * Creates breadcrumbs from history API calls
 */ function $fef7c5073f0eda77$var$_getHistoryBreadcrumbHandler(client) {
    return function _historyBreadcrumb(handlerData) {
        if ((0, $6c9d57d6c1e4fcbb$export$6bb76d6eba7e258c)() !== client) return;
        let from = handlerData.from;
        let to = handlerData.to;
        const parsedLoc = (0, $1ea0c5ed41c20a4d$export$7a5253c0f62e0150)((0, $c8759183c6206ea8$export$56d8a8a25bd48b81).location.href);
        let parsedFrom = from ? (0, $1ea0c5ed41c20a4d$export$7a5253c0f62e0150)(from) : undefined;
        const parsedTo = (0, $1ea0c5ed41c20a4d$export$7a5253c0f62e0150)(to);
        // Initial pushState doesn't provide `from` information
        if (!parsedFrom?.path) parsedFrom = parsedLoc;
        // Use only the path component of the URL if the URL matches the current
        // document (almost all the time when using pushState)
        if (parsedLoc.protocol === parsedTo.protocol && parsedLoc.host === parsedTo.host) to = parsedTo.relative;
        if (parsedLoc.protocol === parsedFrom.protocol && parsedLoc.host === parsedFrom.host) from = parsedFrom.relative;
        (0, $27643a6c5558aaba$export$efda9a273d7a036d)({
            category: 'navigation',
            data: {
                from: from,
                to: to
            }
        });
    };
}
function $fef7c5073f0eda77$var$_isEvent(event) {
    return !!event && !!event.target;
}




// Using a comma-separated string and split for smaller bundle size vs an array literal
const $08a052590b704c62$var$DEFAULT_EVENT_TARGET = 'EventTarget,Window,Node,ApplicationCache,AudioTrackList,BroadcastChannel,ChannelMergerNode,CryptoOperation,EventSource,FileReader,HTMLUnknownElement,IDBDatabase,IDBRequest,IDBTransaction,KeyOperation,MediaController,MessagePort,ModalWindow,Notification,SVGElementInstance,Screen,SharedWorker,TextTrack,TextTrackCue,TextTrackList,WebSocket,WebSocketWorker,Worker,XMLHttpRequest,XMLHttpRequestEventTarget,XMLHttpRequestUpload'.split(',');
const $08a052590b704c62$var$INTEGRATION_NAME = 'BrowserApiErrors';
const $08a052590b704c62$var$_browserApiErrorsIntegration = (options = {})=>{
    const _options = {
        XMLHttpRequest: true,
        eventTarget: true,
        requestAnimationFrame: true,
        setInterval: true,
        setTimeout: true,
        unregisterOriginalCallbacks: false,
        ...options
    };
    return {
        name: $08a052590b704c62$var$INTEGRATION_NAME,
        // TODO: This currently only works for the first client this is setup
        // We may want to adjust this to check for client etc.
        setupOnce () {
            if (_options.setTimeout) (0, $10696cb2974e7335$export$9563e054e6f787fb)((0, $c8759183c6206ea8$export$56d8a8a25bd48b81), 'setTimeout', $08a052590b704c62$var$_wrapTimeFunction);
            if (_options.setInterval) (0, $10696cb2974e7335$export$9563e054e6f787fb)((0, $c8759183c6206ea8$export$56d8a8a25bd48b81), 'setInterval', $08a052590b704c62$var$_wrapTimeFunction);
            if (_options.requestAnimationFrame) (0, $10696cb2974e7335$export$9563e054e6f787fb)((0, $c8759183c6206ea8$export$56d8a8a25bd48b81), 'requestAnimationFrame', $08a052590b704c62$var$_wrapRAF);
            if (_options.XMLHttpRequest && 'XMLHttpRequest' in (0, $c8759183c6206ea8$export$56d8a8a25bd48b81)) (0, $10696cb2974e7335$export$9563e054e6f787fb)(XMLHttpRequest.prototype, 'send', $08a052590b704c62$var$_wrapXHR);
            const eventTargetOption = _options.eventTarget;
            if (eventTargetOption) {
                const eventTarget = Array.isArray(eventTargetOption) ? eventTargetOption : $08a052590b704c62$var$DEFAULT_EVENT_TARGET;
                eventTarget.forEach((target)=>$08a052590b704c62$var$_wrapEventTarget(target, _options));
            }
        }
    };
};
/**
 * Wrap timer functions and event targets to catch errors and provide better meta data.
 */ const $08a052590b704c62$export$59bfe9f1c76150e = (0, $305b4dfee0d746dc$export$2323046b9414659f)($08a052590b704c62$var$_browserApiErrorsIntegration);
function $08a052590b704c62$var$_wrapTimeFunction(original) {
    return function(...args) {
        const originalCallback = args[0];
        args[0] = (0, $c8759183c6206ea8$export$4997ffc0176396a6)(originalCallback, {
            mechanism: {
                handled: false,
                type: `auto.browser.browserapierrors.${(0, $d64dedd9c6b2e07c$export$aad197c7121a6651)(original)}`
            }
        });
        return original.apply(this, args);
    };
}
function $08a052590b704c62$var$_wrapRAF(original) {
    return function(callback) {
        return original.apply(this, [
            (0, $c8759183c6206ea8$export$4997ffc0176396a6)(callback, {
                mechanism: {
                    data: {
                        handler: (0, $d64dedd9c6b2e07c$export$aad197c7121a6651)(original)
                    },
                    handled: false,
                    type: 'auto.browser.browserapierrors.requestAnimationFrame'
                }
            })
        ]);
    };
}
function $08a052590b704c62$var$_wrapXHR(originalSend) {
    return function(...args) {
        // eslint-disable-next-line @typescript-eslint/no-this-alias
        const xhr = this;
        const xmlHttpRequestProps = [
            'onload',
            'onerror',
            'onprogress',
            'onreadystatechange'
        ];
        xmlHttpRequestProps.forEach((prop)=>{
            if (prop in xhr && typeof xhr[prop] === 'function') (0, $10696cb2974e7335$export$9563e054e6f787fb)(xhr, prop, function(original) {
                const wrapOptions = {
                    mechanism: {
                        data: {
                            handler: (0, $d64dedd9c6b2e07c$export$aad197c7121a6651)(original)
                        },
                        handled: false,
                        type: `auto.browser.browserapierrors.xhr.${prop}`
                    }
                };
                // If Instrument integration has been called before BrowserApiErrors, get the name of original function
                const originalFunction = (0, $10696cb2974e7335$export$e6cc1e135e2092e5)(original);
                if (originalFunction) wrapOptions.mechanism.data.handler = (0, $d64dedd9c6b2e07c$export$aad197c7121a6651)(originalFunction);
                // Otherwise wrap directly
                return (0, $c8759183c6206ea8$export$4997ffc0176396a6)(original, wrapOptions);
            });
        });
        return originalSend.apply(this, args);
    };
}
function $08a052590b704c62$var$_wrapEventTarget(target, integrationOptions) {
    const globalObject = (0, $c8759183c6206ea8$export$56d8a8a25bd48b81);
    const proto = globalObject[target]?.prototype;
    // eslint-disable-next-line no-prototype-builtins
    if (!proto?.hasOwnProperty?.('addEventListener')) return;
    (0, $10696cb2974e7335$export$9563e054e6f787fb)(proto, 'addEventListener', function(original) {
        return function(eventName, fn, options) {
            try {
                if ($08a052590b704c62$var$isEventListenerObject(fn)) // ESlint disable explanation:
                //  First, it is generally safe to call `wrap` with an unbound function. Furthermore, using `.bind()` would
                //  introduce a bug here, because bind returns a new function that doesn't have our
                //  flags(like __sentry_original__) attached. `wrap` checks for those flags to avoid unnecessary wrapping.
                //  Without those flags, every call to addEventListener wraps the function again, causing a memory leak.
                // eslint-disable-next-line @typescript-eslint/unbound-method
                fn.handleEvent = (0, $c8759183c6206ea8$export$4997ffc0176396a6)(fn.handleEvent, {
                    mechanism: {
                        data: {
                            handler: (0, $d64dedd9c6b2e07c$export$aad197c7121a6651)(fn),
                            target: target
                        },
                        handled: false,
                        type: 'auto.browser.browserapierrors.handleEvent'
                    }
                });
            } catch  {
            // can sometimes get 'Permission denied to access property "handle Event'
            }
            if (integrationOptions.unregisterOriginalCallbacks) $08a052590b704c62$var$unregisterOriginalCallback(this, eventName, fn);
            return original.apply(this, [
                eventName,
                (0, $c8759183c6206ea8$export$4997ffc0176396a6)(fn, {
                    mechanism: {
                        data: {
                            handler: (0, $d64dedd9c6b2e07c$export$aad197c7121a6651)(fn),
                            target: target
                        },
                        handled: false,
                        type: 'auto.browser.browserapierrors.addEventListener'
                    }
                }),
                options
            ]);
        };
    });
    (0, $10696cb2974e7335$export$9563e054e6f787fb)(proto, 'removeEventListener', function(originalRemoveEventListener) {
        return function(eventName, fn, options) {
            /**
       * There are 2 possible scenarios here:
       *
       * 1. Someone passes a callback, which was attached prior to Sentry initialization, or by using unmodified
       * method, eg. `document.addEventListener.call(el, name, handler). In this case, we treat this function
       * as a pass-through, and call original `removeEventListener` with it.
       *
       * 2. Someone passes a callback, which was attached after Sentry was initialized, which means that it was using
       * our wrapped version of `addEventListener`, which internally calls `wrap` helper.
       * This helper "wraps" whole callback inside a try/catch statement, and attached appropriate metadata to it,
       * in order for us to make a distinction between wrapped/non-wrapped functions possible.
       * If a function was wrapped, it has additional property of `__sentry_wrapped__`, holding the handler.
       *
       * When someone adds a handler prior to initialization, and then do it again, but after,
       * then we have to detach both of them. Otherwise, if we'd detach only wrapped one, it'd be impossible
       * to get rid of the initial handler and it'd stick there forever.
       */ try {
                const originalEventHandler = fn.__sentry_wrapped__;
                if (originalEventHandler) originalRemoveEventListener.call(this, eventName, originalEventHandler, options);
            } catch  {
            // ignore, accessing __sentry_wrapped__ will throw in some Selenium environments
            }
            return originalRemoveEventListener.call(this, eventName, fn, options);
        };
    });
}
function $08a052590b704c62$var$isEventListenerObject(obj) {
    return typeof obj.handleEvent === 'function';
}
function $08a052590b704c62$var$unregisterOriginalCallback(target, eventName, fn) {
    if (target && typeof target === 'object' && 'removeEventListener' in target && typeof target.removeEventListener === 'function') target.removeEventListener(eventName, fn);
}






/**
 * When added, automatically creates sessions which allow you to track adoption and crashes (crash free rate) in your Releases in Sentry.
 * More information: https://docs.sentry.io/product/releases/health/
 *
 * Note: In order for session tracking to work, you need to set up Releases: https://docs.sentry.io/product/releases/
 */ const $1a88b5716a17d60e$export$1baa7880e357371c = (0, $305b4dfee0d746dc$export$2323046b9414659f)((options = {})=>{
    const lifecycle = options.lifecycle ?? 'route';
    return {
        name: 'BrowserSession',
        setupOnce () {
            if (typeof (0, $c8759183c6206ea8$export$56d8a8a25bd48b81).document === 'undefined') {
                (0, $ac5edc7981a81b87$export$16a28057038b10ef) && (0, $6ed5aee3203eab87$export$1c9f709888824e05).warn('Using the `browserSessionIntegration` in non-browser environments is not supported.');
                return;
            }
            // The session duration for browser sessions does not track a meaningful
            // concept that can be used as a metric.
            // Automatically captured sessions are akin to page views, and thus we
            // discard their duration.
            (0, $5125ad3d1e13a914$export$c0d84948cecf78d8)({
                ignoreDuration: true
            });
            (0, $5125ad3d1e13a914$export$667e7b4d445d566b)();
            // User data can be set at any time, for example async after Sentry.init has run and the initial session
            // envelope was already sent, but still on the initial page.
            // Therefore, we have to update the ongoing session with the new user data if it exists, to send the `did`.
            // In theory, sessions, as well as user data is always put onto the isolation scope. So we listen to the
            // isolation scope for changes and update the session with the new user data if it exists.
            // This will not catch users set onto other scopes, like the current scope. For now, we'll accept this limitation.
            // The alternative is to update and capture the session from within the scope. This could be too costly or would not
            // play well with session aggregates on the server side. Since this happens in the scope class, we'd need change
            // scope behaviour in the browser.
            const isolationScope = (0, $6c9d57d6c1e4fcbb$export$68f3af03034c9e90)();
            let previousUser = isolationScope.getUser();
            isolationScope.addScopeListener((scope)=>{
                const maybeNewUser = scope.getUser();
                // sessions only care about user id and ip address, so we only need to capture the session if the user has changed
                if (previousUser?.id !== maybeNewUser?.id || previousUser?.ip_address !== maybeNewUser?.ip_address) {
                    // the scope class already writes the user to its session, so we only need to capture the session here
                    (0, $5125ad3d1e13a914$export$667e7b4d445d566b)();
                    previousUser = maybeNewUser;
                }
            });
            if (lifecycle === 'route') // We want to create a session for every navigation as well
            (0, $b56cbd5d18686f38$export$3f18c56c58114e75)(({ from: from, to: to })=>{
                // Don't create an additional session for the initial route or if the location did not change
                if (from !== to) {
                    (0, $5125ad3d1e13a914$export$c0d84948cecf78d8)({
                        ignoreDuration: true
                    });
                    (0, $5125ad3d1e13a914$export$667e7b4d445d566b)();
                }
            });
        }
    };
});




const $add40bb2a655743a$var$INTEGRATION_NAME = 'CultureContext';
const $add40bb2a655743a$var$_cultureContextIntegration = ()=>{
    return {
        name: $add40bb2a655743a$var$INTEGRATION_NAME,
        preprocessEvent (event) {
            const culture = $add40bb2a655743a$var$getCultureContext();
            if (culture) event.contexts = {
                ...event.contexts,
                culture: {
                    ...culture,
                    ...event.contexts?.culture
                }
            };
        },
        processSegmentSpan (span) {
            const culture = $add40bb2a655743a$var$getCultureContext();
            if (culture) span.attributes = {
                'culture.locale': culture.locale,
                'culture.timezone': culture.timezone,
                'culture.calendar': culture.calendar,
                ...span.attributes
            };
        }
    };
};
/**
 * Captures culture context from the browser.
 *
 * Enabled by default.
 *
 * @example
 * ```js
 * import * as Sentry from '@sentry/browser';
 *
 * Sentry.init({
 *   integrations: [Sentry.cultureContextIntegration()],
 * });
 * ```
 */ const $add40bb2a655743a$export$ec5976aacdc85985 = (0, $305b4dfee0d746dc$export$2323046b9414659f)($add40bb2a655743a$var$_cultureContextIntegration);
/**
 * Returns the culture context from the browser's Intl API.
 */ function $add40bb2a655743a$var$getCultureContext() {
    try {
        const intl = (0, $c8759183c6206ea8$export$56d8a8a25bd48b81).Intl;
        if (!intl) return undefined;
        const options = intl.DateTimeFormat().resolvedOptions();
        return {
            locale: options.locale,
            timezone: options.timeZone,
            calendar: options.calendar
        };
    } catch  {
        // Ignore errors
        return undefined;
    }
}




let $b079e0159b797a7c$var$_oldOnErrorHandler = null;
/**
 * Add an instrumentation handler for when an error is captured by the global error handler.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $b079e0159b797a7c$export$55b5c3ba2194f0c6(handler) {
    const type = 'error';
    (0, $192fdbc9fd342c1a$export$a4e09611e30da72e)(type, handler);
    (0, $192fdbc9fd342c1a$export$e18d6c5462c01368)(type, $b079e0159b797a7c$var$instrumentError);
}
function $b079e0159b797a7c$var$instrumentError() {
    $b079e0159b797a7c$var$_oldOnErrorHandler = (0, $517c5b29f882562f$export$f1a6cdb1459e81d1).onerror;
    // Note: The reason we are doing window.onerror instead of window.addEventListener('error')
    // is that we are using this handler in the Loader Script, to handle buffered errors consistently
    (0, $517c5b29f882562f$export$f1a6cdb1459e81d1).onerror = function(msg, url, line, column, error) {
        const handlerData = {
            column: column,
            error: error,
            line: line,
            msg: msg,
            url: url
        };
        (0, $192fdbc9fd342c1a$export$b18c893e424d3127)('error', handlerData);
        if ($b079e0159b797a7c$var$_oldOnErrorHandler) // eslint-disable-next-line prefer-rest-params
        return $b079e0159b797a7c$var$_oldOnErrorHandler.apply(this, arguments);
        return false;
    };
    (0, $517c5b29f882562f$export$f1a6cdb1459e81d1).onerror.__SENTRY_INSTRUMENTED__ = true;
}



let $6648bcf57830ad11$var$_oldOnUnhandledRejectionHandler = null;
/**
 * Add an instrumentation handler for when an unhandled promise rejection is captured.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $6648bcf57830ad11$export$8bf4fc6858821a4e(handler) {
    const type = 'unhandledrejection';
    (0, $192fdbc9fd342c1a$export$a4e09611e30da72e)(type, handler);
    (0, $192fdbc9fd342c1a$export$e18d6c5462c01368)(type, $6648bcf57830ad11$var$instrumentUnhandledRejection);
}
function $6648bcf57830ad11$var$instrumentUnhandledRejection() {
    $6648bcf57830ad11$var$_oldOnUnhandledRejectionHandler = (0, $517c5b29f882562f$export$f1a6cdb1459e81d1).onunhandledrejection;
    // Note: The reason we are doing window.onunhandledrejection instead of window.addEventListener('unhandledrejection')
    // is that we are using this handler in the Loader Script, to handle buffered rejections consistently
    (0, $517c5b29f882562f$export$f1a6cdb1459e81d1).onunhandledrejection = function(e) {
        const handlerData = e;
        (0, $192fdbc9fd342c1a$export$b18c893e424d3127)('unhandledrejection', handlerData);
        if ($6648bcf57830ad11$var$_oldOnUnhandledRejectionHandler) // eslint-disable-next-line prefer-rest-params
        return $6648bcf57830ad11$var$_oldOnUnhandledRejectionHandler.apply(this, arguments);
        return true;
    };
    (0, $517c5b29f882562f$export$f1a6cdb1459e81d1).onunhandledrejection.__SENTRY_INSTRUMENTED__ = true;
}





const $fb4c596e227627d1$var$INTEGRATION_NAME = 'GlobalHandlers';
const $fb4c596e227627d1$var$_globalHandlersIntegration = (options = {})=>{
    const _options = {
        onerror: true,
        onunhandledrejection: true,
        ...options
    };
    return {
        name: $fb4c596e227627d1$var$INTEGRATION_NAME,
        setupOnce () {
            Error.stackTraceLimit = 50;
        },
        setup (client) {
            if (_options.onerror) {
                $fb4c596e227627d1$var$_installGlobalOnErrorHandler(client);
                $fb4c596e227627d1$var$globalHandlerLog('onerror');
            }
            if (_options.onunhandledrejection) {
                $fb4c596e227627d1$var$_installGlobalOnUnhandledRejectionHandler(client);
                $fb4c596e227627d1$var$globalHandlerLog('onunhandledrejection');
            }
        }
    };
};
const $fb4c596e227627d1$export$66acc70e8cf2b71a = (0, $305b4dfee0d746dc$export$2323046b9414659f)($fb4c596e227627d1$var$_globalHandlersIntegration);
function $fb4c596e227627d1$var$_installGlobalOnErrorHandler(client) {
    (0, $b079e0159b797a7c$export$55b5c3ba2194f0c6)((data)=>{
        const { stackParser: stackParser, attachStacktrace: attachStacktrace } = $fb4c596e227627d1$var$getOptions();
        if ((0, $6c9d57d6c1e4fcbb$export$6bb76d6eba7e258c)() !== client || (0, $c8759183c6206ea8$export$b79738ab10c590b2)()) return;
        const { msg: msg, url: url, line: line, column: column, error: error } = data;
        const event = $fb4c596e227627d1$var$_enhanceEventWithInitialFrame((0, $baf0df795659509d$export$9dd56ed1ef0c3420)(stackParser, error || msg, undefined, attachStacktrace, false), url, line, column);
        event.level = 'error';
        (0, $5125ad3d1e13a914$export$1462b974fdcf6ba2)(event, {
            originalException: error,
            mechanism: {
                handled: false,
                type: 'auto.browser.global_handlers.onerror'
            }
        });
    });
}
function $fb4c596e227627d1$var$_installGlobalOnUnhandledRejectionHandler(client) {
    (0, $6648bcf57830ad11$export$8bf4fc6858821a4e)((e)=>{
        const { stackParser: stackParser, attachStacktrace: attachStacktrace } = $fb4c596e227627d1$var$getOptions();
        if ((0, $6c9d57d6c1e4fcbb$export$6bb76d6eba7e258c)() !== client || (0, $c8759183c6206ea8$export$b79738ab10c590b2)()) return;
        const error = $fb4c596e227627d1$export$b2cc40fa8241780(e);
        const event = (0, $d1f309ce92d0a600$export$c3825b437cbdea5c)(error) ? $fb4c596e227627d1$export$1353b5b36844a9ed(error) : (0, $baf0df795659509d$export$9dd56ed1ef0c3420)(stackParser, error, undefined, attachStacktrace, true);
        event.level = 'error';
        (0, $5125ad3d1e13a914$export$1462b974fdcf6ba2)(event, {
            originalException: error,
            mechanism: {
                handled: false,
                type: 'auto.browser.global_handlers.onunhandledrejection'
            }
        });
    });
}
/**
 *
 */ function $fb4c596e227627d1$export$b2cc40fa8241780(error) {
    if ((0, $d1f309ce92d0a600$export$c3825b437cbdea5c)(error)) return error;
    // dig the object of the rejection out of known event types
    try {
        // PromiseRejectionEvents store the object of the rejection under 'reason'
        // see https://developer.mozilla.org/en-US/docs/Web/API/PromiseRejectionEvent
        if ('reason' in error) return error.reason;
        // something, somewhere, (likely a browser extension) effectively casts PromiseRejectionEvents
        // to CustomEvents, moving the `promise` and `reason` attributes of the PRE into
        // the CustomEvent's `detail` attribute, since they're not part of CustomEvent's spec
        // see https://developer.mozilla.org/en-US/docs/Web/API/CustomEvent and
        // https://github.com/getsentry/sentry-javascript/issues/2380
        if ('detail' in error && 'reason' in error.detail) return error.detail.reason;
    } catch  {} // eslint-disable-line no-empty
    return error;
}
/**
 * Create an event from a promise rejection where the `reason` is a primitive.
 *
 * @param reason: The `reason` property of the promise rejection
 * @returns An Event object with an appropriate `exception` value
 */ function $fb4c596e227627d1$export$1353b5b36844a9ed(reason) {
    return {
        exception: {
            values: [
                {
                    type: 'UnhandledRejection',
                    // String() is needed because the Primitive type includes symbols (which can't be automatically stringified)
                    value: `Non-Error promise rejection captured with value: ${String(reason)}`
                }
            ]
        }
    };
}
function $fb4c596e227627d1$var$_enhanceEventWithInitialFrame(event, url, lineno, colno) {
    // event.exception
    const e = event.exception = event.exception || {};
    // event.exception.values
    const ev = e.values = e.values || [];
    // event.exception.values[0]
    const ev0 = ev[0] = ev[0] || {};
    // event.exception.values[0].stacktrace
    const ev0s = ev0.stacktrace = ev0.stacktrace || {};
    // event.exception.values[0].stacktrace.frames
    const ev0sf = ev0s.frames = ev0s.frames || [];
    if (ev0sf.length === 0) ev0sf.push({
        colno: colno,
        lineno: lineno,
        filename: $fb4c596e227627d1$var$getFilenameFromUrl(url) ?? (0, $c765cb3edc177c69$export$1cfafeee2987818b)(),
        function: (0, $d64dedd9c6b2e07c$export$27c7e15d453fc0ac),
        in_app: true
    });
    return event;
}
function $fb4c596e227627d1$var$globalHandlerLog(type) {
    (0, $ac5edc7981a81b87$export$16a28057038b10ef) && (0, $6ed5aee3203eab87$export$1c9f709888824e05).log(`Global Handler attached: ${type}`);
}
function $fb4c596e227627d1$var$getOptions() {
    const client = (0, $6c9d57d6c1e4fcbb$export$6bb76d6eba7e258c)();
    const options = client?.getOptions() || {
        stackParser: ()=>[],
        attachStacktrace: false
    };
    return options;
}
function $fb4c596e227627d1$var$getFilenameFromUrl(url) {
    if (!(0, $d1f309ce92d0a600$export$844ec244b1367d54)(url) || url.length === 0) return undefined;
    // Strip data URL content to avoid long base64 strings in stack frames
    // (e.g. when initializing a Worker with a base64 encoded script)
    // Don't include data prefix for filenames as it's not useful for stack traces
    // Wrap with < > to indicate it's a placeholder
    if (url.startsWith('data:')) return `<${(0, $1ea0c5ed41c20a4d$export$8abd806fcaf234fa)(url, false)}>`;
    return url;
}




/**
 * Collects information about HTTP request headers and
 * attaches them to the event.
 */ const $ec81f0d0cf410d60$export$1378794447170364 = (0, $305b4dfee0d746dc$export$2323046b9414659f)(()=>{
    return {
        name: 'HttpContext',
        preprocessEvent (event) {
            // if none of the information we want exists, don't bother
            if (!(0, $c8759183c6206ea8$export$56d8a8a25bd48b81).navigator && !(0, $c8759183c6206ea8$export$56d8a8a25bd48b81).location && !(0, $c8759183c6206ea8$export$56d8a8a25bd48b81).document) return;
            const reqData = (0, $c8759183c6206ea8$export$a3c4a8453e8936f0)();
            const headers = {
                ...reqData.headers,
                ...event.request?.headers
            };
            event.request = {
                ...reqData,
                ...event.request,
                headers: headers
            };
        }
    };
});



/**
 * Creates exceptions inside `event.exception.values` for errors that are nested on properties based on the `key` parameter.
 */ function $3af28bd4dc7210de$export$b91c38ed7d8ae9b2(exceptionFromErrorImplementation, parser, key, limit, event, hint) {
    if (!event.exception?.values || !hint || !(0, $d1f309ce92d0a600$export$49034edbe6b62415)(hint.originalException, Error)) return;
    // Generally speaking the last item in `event.exception.values` is the exception originating from the original Error
    const originalException = event.exception.values.length > 0 ? event.exception.values[event.exception.values.length - 1] : undefined;
    // We only create exception grouping if there is an exception in the event.
    if (originalException) event.exception.values = $3af28bd4dc7210de$var$aggregateExceptionsFromError(exceptionFromErrorImplementation, parser, limit, hint.originalException, key, event.exception.values, originalException, 0);
}
function $3af28bd4dc7210de$var$aggregateExceptionsFromError(exceptionFromErrorImplementation, parser, limit, error, key, prevExceptions, exception, exceptionId) {
    if (prevExceptions.length >= limit + 1) return prevExceptions;
    let newExceptions = [
        ...prevExceptions
    ];
    // Recursively call this function in order to walk down a chain of errors
    if ((0, $d1f309ce92d0a600$export$49034edbe6b62415)(error[key], Error)) {
        $3af28bd4dc7210de$var$applyExceptionGroupFieldsForParentException(exception, exceptionId, error);
        const newException = exceptionFromErrorImplementation(parser, error[key]);
        const newExceptionId = newExceptions.length;
        $3af28bd4dc7210de$var$applyExceptionGroupFieldsForChildException(newException, key, newExceptionId, exceptionId);
        newExceptions = $3af28bd4dc7210de$var$aggregateExceptionsFromError(exceptionFromErrorImplementation, parser, limit, error[key], key, [
            newException,
            ...newExceptions
        ], newException, newExceptionId);
    }
    // This will create exception grouping for AggregateErrors
    // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/AggregateError
    if ($3af28bd4dc7210de$var$isExceptionGroup(error)) error.errors.forEach((childError, i)=>{
        if ((0, $d1f309ce92d0a600$export$49034edbe6b62415)(childError, Error)) {
            $3af28bd4dc7210de$var$applyExceptionGroupFieldsForParentException(exception, exceptionId, error);
            const newException = exceptionFromErrorImplementation(parser, childError);
            const newExceptionId = newExceptions.length;
            $3af28bd4dc7210de$var$applyExceptionGroupFieldsForChildException(newException, `errors[${i}]`, newExceptionId, exceptionId);
            newExceptions = $3af28bd4dc7210de$var$aggregateExceptionsFromError(exceptionFromErrorImplementation, parser, limit, childError, key, [
                newException,
                ...newExceptions
            ], newException, newExceptionId);
        }
    });
    return newExceptions;
}
function $3af28bd4dc7210de$var$isExceptionGroup(error) {
    return Array.isArray(error.errors);
}
function $3af28bd4dc7210de$var$applyExceptionGroupFieldsForParentException(exception, exceptionId, error) {
    exception.mechanism = {
        handled: true,
        type: 'auto.core.linked_errors',
        ...$3af28bd4dc7210de$var$isExceptionGroup(error) && {
            is_exception_group: true
        },
        ...exception.mechanism,
        exception_id: exceptionId
    };
}
function $3af28bd4dc7210de$var$applyExceptionGroupFieldsForChildException(exception, source, exceptionId, parentId) {
    exception.mechanism = {
        handled: true,
        ...exception.mechanism,
        type: 'chained',
        source: source,
        exception_id: exceptionId,
        parent_id: parentId
    };
}



const $f88781cccdf014d1$var$DEFAULT_KEY = 'cause';
const $f88781cccdf014d1$var$DEFAULT_LIMIT = 5;
const $f88781cccdf014d1$var$INTEGRATION_NAME = 'LinkedErrors';
const $f88781cccdf014d1$var$_linkedErrorsIntegration = (options = {})=>{
    const limit = options.limit || $f88781cccdf014d1$var$DEFAULT_LIMIT;
    const key = options.key || $f88781cccdf014d1$var$DEFAULT_KEY;
    return {
        name: $f88781cccdf014d1$var$INTEGRATION_NAME,
        preprocessEvent (event, hint, client) {
            const options = client.getOptions();
            (0, $3af28bd4dc7210de$export$b91c38ed7d8ae9b2)(// This differs from the LinkedErrors integration in core by using a different exceptionFromError function
            (0, $baf0df795659509d$export$a6c2d27607295951), options.stackParser, key, limit, event, hint);
        }
    };
};
/**
 * Aggregrate linked errors in an event.
 */ const $f88781cccdf014d1$export$ebabb00eb7f3a395 = (0, $305b4dfee0d746dc$export$2323046b9414659f)($f88781cccdf014d1$var$_linkedErrorsIntegration);




const $77d49fe04195e473$var$OPERA10_PRIORITY = 10;
const $77d49fe04195e473$var$OPERA11_PRIORITY = 20;
const $77d49fe04195e473$var$CHROME_PRIORITY = 30;
const $77d49fe04195e473$var$WINJS_PRIORITY = 40;
const $77d49fe04195e473$var$GECKO_PRIORITY = 50;
function $77d49fe04195e473$var$createFrame(filename, func, lineno, colno) {
    const frame = {
        filename: filename,
        function: func === '<anonymous>' ? (0, $d64dedd9c6b2e07c$export$27c7e15d453fc0ac) : func,
        in_app: true
    };
    if (lineno !== undefined) frame.lineno = lineno;
    if (colno !== undefined) frame.colno = colno;
    return frame;
}
// This regex matches frames that have no function name (ie. are at the top level of a module).
// For example "at http://localhost:5000//script.js:1:126"
// Frames _with_ function names usually look as follows: "at commitLayoutEffects (react-dom.development.js:23426:1)"
const $77d49fe04195e473$var$chromeRegexNoFnName = /^\s*at (\S+?)(?::(\d+))(?::(\d+))\s*$/i;
// This regex matches all the frames that have a function name.
const $77d49fe04195e473$var$chromeRegex = /^\s*at (?:(.+?\)(?: \[.+\])?|.*?) ?\((?:address at )?)?(?:async )?((?:<anonymous>|[-a-z]+:|.*bundle|\/)?.*?)(?::(\d+))?(?::(\d+))?\)?\s*$/i;
const $77d49fe04195e473$var$chromeEvalRegex = /\((\S*)(?::(\d+))(?::(\d+))\)/;
// Matches stack frames with data URIs instead of filename so we can still get the function name
// Example: "at dynamicFn (data:application/javascript,export function dynamicFn() {..."
const $77d49fe04195e473$var$chromeDataUriRegex = /at (.+?) ?\(data:(.+?),/;
// Chromium based browsers: Chrome, Brave, new Opera, new Edge
// We cannot call this variable `chrome` because it can conflict with global `chrome` variable in certain environments
// See: https://github.com/getsentry/sentry-javascript/issues/6880
const $77d49fe04195e473$var$chromeStackParserFn = (line)=>{
    const dataUriMatch = line.match($77d49fe04195e473$var$chromeDataUriRegex);
    if (dataUriMatch) return {
        filename: `<data:${dataUriMatch[2]}>`,
        function: dataUriMatch[1]
    };
    // If the stack line has no function name, we need to parse it differently
    const noFnParts = $77d49fe04195e473$var$chromeRegexNoFnName.exec(line);
    if (noFnParts) {
        const [, filename, line, col] = noFnParts;
        return $77d49fe04195e473$var$createFrame(filename, (0, $d64dedd9c6b2e07c$export$27c7e15d453fc0ac), +line, +col);
    }
    const parts = $77d49fe04195e473$var$chromeRegex.exec(line);
    if (parts) {
        const isEval = parts[2]?.indexOf('eval') === 0; // start of line
        if (isEval) {
            const subMatch = $77d49fe04195e473$var$chromeEvalRegex.exec(parts[2]);
            if (subMatch) {
                // throw out eval line/column and use top-most line/column number
                parts[2] = subMatch[1]; // url
                parts[3] = subMatch[2]; // line
                parts[4] = subMatch[3]; // column
            }
        }
        // Kamil: One more hack won't hurt us right? Understanding and adding more rules on top of these regexps right now
        // would be way too time consuming. (TODO: Rewrite whole RegExp to be more readable)
        const [func, filename] = $77d49fe04195e473$var$extractSafariExtensionDetails(parts[1] || (0, $d64dedd9c6b2e07c$export$27c7e15d453fc0ac), parts[2]);
        return $77d49fe04195e473$var$createFrame(filename, func, parts[3] ? +parts[3] : undefined, parts[4] ? +parts[4] : undefined);
    }
    return;
};
const $77d49fe04195e473$export$263a749fff749872 = [
    $77d49fe04195e473$var$CHROME_PRIORITY,
    $77d49fe04195e473$var$chromeStackParserFn
];
// gecko regex: `(?:bundle|\d+\.js)`: `bundle` is for react native, `\d+\.js` also but specifically for ram bundles because it
// generates filenames without a prefix like `file://` the filenames in the stacktrace are just 42.js
// We need this specific case for now because we want no other regex to match.
const $77d49fe04195e473$var$geckoREgex = /^\s*(.*?)(?:\((.*?)\))?(?:^|@)?((?:[-a-z]+)?:\/.*?|\[native code\]|[^@]*(?:bundle|\d+\.js)|\/[\w\-. /=]+)(?::(\d+))?(?::(\d+))?\s*$/i;
const $77d49fe04195e473$var$geckoEvalRegex = /(\S+) line (\d+)(?: > eval line \d+)* > eval/i;
const $77d49fe04195e473$var$gecko = (line)=>{
    const parts = $77d49fe04195e473$var$geckoREgex.exec(line);
    if (parts) {
        const isEval = parts[3] && parts[3].indexOf(' > eval') > -1;
        if (isEval) {
            const subMatch = $77d49fe04195e473$var$geckoEvalRegex.exec(parts[3]);
            if (subMatch) {
                // throw out eval line/column and use top-most line number
                parts[1] = parts[1] || 'eval';
                parts[3] = subMatch[1];
                parts[4] = subMatch[2];
                parts[5] = ''; // no column when eval
            }
        }
        let filename = parts[3];
        let func = parts[1] || (0, $d64dedd9c6b2e07c$export$27c7e15d453fc0ac);
        [func, filename] = $77d49fe04195e473$var$extractSafariExtensionDetails(func, filename);
        return $77d49fe04195e473$var$createFrame(filename, func, parts[4] ? +parts[4] : undefined, parts[5] ? +parts[5] : undefined);
    }
    return;
};
const $77d49fe04195e473$export$cdba47a5dd2804d = [
    $77d49fe04195e473$var$GECKO_PRIORITY,
    $77d49fe04195e473$var$gecko
];
const $77d49fe04195e473$var$winjsRegex = /^\s*at (?:((?:\[object object\])?.+) )?\(?((?:[-a-z]+):.*?):(\d+)(?::(\d+))?\)?\s*$/i;
const $77d49fe04195e473$var$winjs = (line)=>{
    const parts = $77d49fe04195e473$var$winjsRegex.exec(line);
    return parts ? $77d49fe04195e473$var$createFrame(parts[2], parts[1] || (0, $d64dedd9c6b2e07c$export$27c7e15d453fc0ac), +parts[3], parts[4] ? +parts[4] : undefined) : undefined;
};
const $77d49fe04195e473$export$179460296da408e8 = [
    $77d49fe04195e473$var$WINJS_PRIORITY,
    $77d49fe04195e473$var$winjs
];
const $77d49fe04195e473$var$opera10Regex = / line (\d+).*script (?:in )?(\S+)(?:: in function (\S+))?$/i;
const $77d49fe04195e473$var$opera10 = (line)=>{
    const parts = $77d49fe04195e473$var$opera10Regex.exec(line);
    return parts ? $77d49fe04195e473$var$createFrame(parts[2], parts[3] || (0, $d64dedd9c6b2e07c$export$27c7e15d453fc0ac), +parts[1]) : undefined;
};
const $77d49fe04195e473$export$f892b52c880ffc7a = [
    $77d49fe04195e473$var$OPERA10_PRIORITY,
    $77d49fe04195e473$var$opera10
];
const $77d49fe04195e473$var$opera11Regex = / line (\d+), column (\d+)\s*(?:in (?:<anonymous function: ([^>]+)>|([^)]+))\(.*\))? in (.*):\s*$/i;
const $77d49fe04195e473$var$opera11 = (line)=>{
    const parts = $77d49fe04195e473$var$opera11Regex.exec(line);
    return parts ? $77d49fe04195e473$var$createFrame(parts[5], parts[3] || parts[4] || (0, $d64dedd9c6b2e07c$export$27c7e15d453fc0ac), +parts[1], +parts[2]) : undefined;
};
const $77d49fe04195e473$export$af11af13f09fb0dc = [
    $77d49fe04195e473$var$OPERA11_PRIORITY,
    $77d49fe04195e473$var$opera11
];
const $77d49fe04195e473$export$7197c0fe6554c079 = [
    $77d49fe04195e473$export$263a749fff749872,
    $77d49fe04195e473$export$cdba47a5dd2804d
];
const $77d49fe04195e473$export$2b2b997d81bf3907 = (0, $d64dedd9c6b2e07c$export$a5739666fb2d03d4)(...$77d49fe04195e473$export$7197c0fe6554c079);
/**
 * Safari web extensions, starting version unknown, can produce "frames-only" stacktraces.
 * What it means, is that instead of format like:
 *
 * Error: wat
 *   at function@url:row:col
 *   at function@url:row:col
 *   at function@url:row:col
 *
 * it produces something like:
 *
 *   function@url:row:col
 *   function@url:row:col
 *   function@url:row:col
 *
 * Because of that, it won't be captured by `chrome` RegExp and will fall into `Gecko` branch.
 * This function is extracted so that we can use it in both places without duplicating the logic.
 * Unfortunately "just" changing RegExp is too complicated now and making it pass all tests
 * and fix this case seems like an impossible, or at least way too time-consuming task.
 */ const $77d49fe04195e473$var$extractSafariExtensionDetails = (func, filename)=>{
    const isSafariExtension = func.indexOf('safari-extension') !== -1;
    const isSafariWebExtension = func.indexOf('safari-web-extension') !== -1;
    return isSafariExtension || isSafariWebExtension ? [
        func.indexOf('@') !== -1 ? func.split('@')[0] : (0, $d64dedd9c6b2e07c$export$27c7e15d453fc0ac),
        isSafariExtension ? `safari-extension:${filename}` : `safari-web-extension:${filename}`
    ] : [
        func,
        filename
    ];
};




/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */ const $aab55252de974fce$export$16a28057038b10ef = typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__;



/**
 * We generally want to use window.fetch / window.setTimeout.
 * However, in some cases this may be wrapped (e.g. by Zone.js for Angular),
 * so we try to get an unpatched version of this from a sandboxed iframe.
 */ const $1549552c21546300$var$cachedImplementations = {};
/**
 * Get the native implementation of a browser function.
 *
 * This can be used to ensure we get an unwrapped version of a function, in cases where a wrapped function can lead to problems.
 *
 * The following methods can be retrieved:
 * - `setTimeout`: This can be wrapped by e.g. Angular, causing change detection to be triggered.
 * - `fetch`: This can be wrapped by e.g. ad-blockers, causing an infinite loop when a request is blocked.
 */ function $1549552c21546300$export$e464f4a514ac28a8(name) {
    const cached = $1549552c21546300$var$cachedImplementations[name];
    if (cached) return cached;
    let impl = (0, $0a7a9faa9b397042$export$56d8a8a25bd48b81)[name];
    // Fast path to avoid DOM I/O
    if ((0, $f00e028ff406ea6f$export$d5f608b368e73f38)(impl)) return $1549552c21546300$var$cachedImplementations[name] = impl.bind((0, $0a7a9faa9b397042$export$56d8a8a25bd48b81));
    const document = (0, $0a7a9faa9b397042$export$56d8a8a25bd48b81).document;
    // eslint-disable-next-line deprecation/deprecation
    if (document && typeof document.createElement === 'function') try {
        const sandbox = document.createElement('iframe');
        sandbox.hidden = true;
        document.head.appendChild(sandbox);
        const contentWindow = sandbox.contentWindow;
        if (contentWindow?.[name]) impl = contentWindow[name];
        document.head.removeChild(sandbox);
    } catch (e) {
        // Could not create sandbox iframe, just use window.xxx
        (0, $aab55252de974fce$export$16a28057038b10ef) && (0, $6ed5aee3203eab87$export$1c9f709888824e05).warn(`Could not create sandbox iframe for ${name} check, bailing to window.${name}: `, e);
    }
    // Sanity check: This _should_ not happen, but if it does, we just skip caching...
    // This can happen e.g. in tests where fetch may not be available in the env, or similar.
    if (!impl) return impl;
    return $1549552c21546300$var$cachedImplementations[name] = impl.bind((0, $0a7a9faa9b397042$export$56d8a8a25bd48b81));
}
/** Clear a cached implementation. */ function $1549552c21546300$export$8aa36702e8c8978(name) {
    $1549552c21546300$var$cachedImplementations[name] = undefined;
}
/**
 * A special usecase for incorrectly wrapped Fetch APIs in conjunction with ad-blockers.
 * Whenever someone wraps the Fetch API and returns the wrong promise chain,
 * this chain becomes orphaned and there is no possible way to capture it's rejections
 * other than allowing it bubble up to this very handler. eg.
 *
 * const f = window.fetch;
 * window.fetch = function () {
 *   const p = f.apply(this, arguments);
 *
 *   p.then(function() {
 *     console.log('hi.');
 *   });
 *
 *   return p;
 * }
 *
 * `p.then(function () { ... })` is producing a completely separate promise chain,
 * however, what's returned is `p` - the result of original `fetch` call.
 *
 * This mean, that whenever we use the Fetch API to send our own requests, _and_
 * some ad-blocker blocks it, this orphaned chain will _always_ reject,
 * effectively causing another event to be captured.
 * This makes a whole process become an infinite loop, which we need to somehow
 * deal with, and break it in one way or another.
 *
 * To deal with this issue, we are making sure that we _always_ use the real
 * browser Fetch API, instead of relying on what `window.fetch` exposes.
 * The only downside to this would be missing our own requests as breadcrumbs,
 * but because we are already not doing this, it should be just fine.
 *
 * Possible failed fetch error messages per-browser:
 *
 * Chrome:  Failed to fetch
 * Edge:    Failed to Fetch
 * Firefox: NetworkError when attempting to fetch resource
 * Safari:  resource blocked by content blocker
 */ function $1549552c21546300$export$e7aa7bc5c1b3cfb3(...rest) {
    return $1549552c21546300$export$e464f4a514ac28a8('fetch')(...rest);
}
/**
 * Get an unwrapped `setTimeout` method.
 * This ensures that even if e.g. Angular wraps `setTimeout`, we get the native implementation,
 * avoiding triggering change detection.
 */ function $1549552c21546300$export$831dc9f2ab0a617b(...rest) {
    return $1549552c21546300$export$e464f4a514ac28a8('setTimeout')(...rest);
}


const $18805ea082ebd8ff$var$DEFAULT_BROWSER_TRANSPORT_BUFFER_SIZE = 40;
/**
 * Creates a Transport that uses the Fetch API to send events to Sentry.
 */ function $18805ea082ebd8ff$export$b2311068c46d7cc8(options, nativeFetch = (0, $1549552c21546300$export$e464f4a514ac28a8)('fetch')) {
    let pendingBodySize = 0;
    let pendingCount = 0;
    async function makeRequest(request) {
        const requestSize = request.body.length;
        pendingBodySize += requestSize;
        pendingCount++;
        const requestOptions = {
            body: request.body,
            method: 'POST',
            referrerPolicy: 'strict-origin',
            headers: options.headers,
            // Outgoing requests are usually cancelled when navigating to a different page, causing a "TypeError: Failed to
            // fetch" error and sending a "network_error" client-outcome - in Chrome, the request status shows "(cancelled)".
            // The `keepalive` flag keeps outgoing requests alive, even when switching pages. We want this since we're
            // frequently sending events right before the user is switching pages (eg. when finishing navigation transactions).
            // Gotchas:
            // - `keepalive` isn't supported by Firefox
            // - As per spec (https://fetch.spec.whatwg.org/#http-network-or-cache-fetch):
            //   If the sum of contentLength and inflightKeepaliveBytes is greater than 64 kibibytes, then return a network error.
            //   We will therefore only activate the flag when we're below that limit.
            // There is also a limit of requests that can be open at the same time, so we also limit this to 15
            // See https://github.com/getsentry/sentry-javascript/pull/7553 for details
            keepalive: pendingBodySize <= 60000 && pendingCount < 15,
            ...options.fetchOptions
        };
        try {
            // Note: We do not need to suppress tracing here, because we are using the native fetch, instead of our wrapped one.
            const response = await nativeFetch(options.url, requestOptions);
            return {
                statusCode: response.status,
                headers: {
                    'x-sentry-rate-limits': response.headers.get('X-Sentry-Rate-Limits'),
                    'retry-after': response.headers.get('Retry-After')
                }
            };
        } catch (e) {
            (0, $1549552c21546300$export$8aa36702e8c8978)('fetch');
            throw e;
        } finally{
            pendingBodySize -= requestSize;
            pendingCount--;
        }
    }
    return (0, $443bfe748e541c55$export$d09f50d9ab7f7b69)(options, makeRequest, (0, $1c536e651ef5e7fd$export$85a4f67f852183e6)(options.bufferSize || $18805ea082ebd8ff$var$DEFAULT_BROWSER_TRANSPORT_BUFFER_SIZE));
}





/**
 * Returns true if the SDK is running in an embedded browser extension.
 * Stand-alone browser extensions (which do not share the same data as the main browser page) are fine.
 */ function $611f0577f01590dc$export$dc236a86065879fc() {
    if ($611f0577f01590dc$var$_isEmbeddedBrowserExtension()) {
        if (0, $ac5edc7981a81b87$export$16a28057038b10ef) (0, $6ed5aee3203eab87$export$cda52e2a8927a2ca)(()=>{
            // eslint-disable-next-line no-console
            console.error('[Sentry] You cannot use Sentry.init() in a browser extension, see: https://docs.sentry.io/platforms/javascript/best-practices/browser-extensions/');
        });
        return true;
    }
    return false;
}
function $611f0577f01590dc$var$_isEmbeddedBrowserExtension() {
    if (typeof (0, $c8759183c6206ea8$export$56d8a8a25bd48b81).window === 'undefined') // No need to show the error if we're not in a browser window environment (e.g. service workers)
    return false;
    const _window = (0, $c8759183c6206ea8$export$56d8a8a25bd48b81);
    // Running the SDK in NW.js, which appears like a browser extension but isn't, is also fine
    // see: https://github.com/getsentry/sentry-javascript/issues/12668
    if (_window.nw) return false;
    const extensionObject = _window['chrome'] || _window['browser'];
    if (!extensionObject?.runtime?.id) return false;
    const href = (0, $c765cb3edc177c69$export$1cfafeee2987818b)();
    // Running the SDK in a dedicated extension page and calling Sentry.init is fine; no risk of data leakage
    const isDedicatedExtensionPage = (0, $c8759183c6206ea8$export$56d8a8a25bd48b81) === (0, $c8759183c6206ea8$export$56d8a8a25bd48b81).top && /^(?:chrome-extension|moz-extension|ms-browser-extension|safari-web-extension):\/\//.test(href);
    return !isDedicatedExtensionPage;
}


/** Get the default integrations for the browser SDK. */ function $776bdb0abf297828$export$5783b2920b1d62b9(_options) {
    /**
   * Note: Please make sure this stays in sync with Angular SDK, which re-exports
   * `getDefaultIntegrations` but with an adjusted set of integrations.
   */ return [
        // TODO(v11): Replace with `eventFiltersIntegration` once we remove the deprecated `inboundFiltersIntegration`
        // eslint-disable-next-line deprecation/deprecation
        (0, $6fc6e13139469b0a$export$cb3c5c2ceb9818ba)(),
        (0, $9800c1484ce3b179$export$7918117e9202e4fb)(),
        (0, $267edb3c0f764225$export$97457a453081a5b3)(),
        (0, $08a052590b704c62$export$59bfe9f1c76150e)(),
        (0, $fef7c5073f0eda77$export$c079d904b326663a)(),
        (0, $fb4c596e227627d1$export$66acc70e8cf2b71a)(),
        (0, $f88781cccdf014d1$export$ebabb00eb7f3a395)(),
        (0, $57b98971d429d806$export$6d39aa44cd0c7567)(),
        (0, $ec81f0d0cf410d60$export$1378794447170364)(),
        (0, $add40bb2a655743a$export$ec5976aacdc85985)(),
        (0, $1a88b5716a17d60e$export$1baa7880e357371c)()
    ];
}
/**
 * The Sentry Browser SDK Client.
 *
 * To use this SDK, call the {@link init} function as early as possible when
 * loading the web page. To set context information or send manual events, use
 * the provided methods.
 *
 * @example
 *
 * ```
 *
 * import { init } from '@sentry/browser';
 *
 * init({
 *   dsn: '__DSN__',
 *   // ...
 * });
 * ```
 *
 * @example
 * ```
 *
 * import { addBreadcrumb } from '@sentry/browser';
 * addBreadcrumb({
 *   message: 'My Breadcrumb',
 *   // ...
 * });
 * ```
 *
 * @example
 *
 * ```
 *
 * import * as Sentry from '@sentry/browser';
 * Sentry.captureMessage('Hello, world!');
 * Sentry.captureException(new Error('Good bye'));
 * Sentry.captureEvent({
 *   message: 'Manual',
 *   stacktrace: [
 *     // ...
 *   ],
 * });
 * ```
 *
 * @see {@link BrowserOptions} for documentation on configuration options.
 */ function $776bdb0abf297828$export$2cd8252107eb640b(options = {}) {
    const shouldDisableBecauseIsBrowserExtenstion = !options.skipBrowserExtensionCheck && (0, $611f0577f01590dc$export$dc236a86065879fc)();
    let defaultIntegrations = options.defaultIntegrations == null ? $776bdb0abf297828$export$5783b2920b1d62b9() : options.defaultIntegrations;
    const clientOptions = {
        ...options,
        enabled: shouldDisableBecauseIsBrowserExtenstion ? false : options.enabled,
        stackParser: (0, $d64dedd9c6b2e07c$export$1d5cf88b347146d4)(options.stackParser || (0, $77d49fe04195e473$export$2b2b997d81bf3907)),
        integrations: (0, $305b4dfee0d746dc$export$68bc4c01ab8ae766)({
            integrations: options.integrations,
            defaultIntegrations: defaultIntegrations
        }),
        transport: options.transport || (0, $18805ea082ebd8ff$export$b2311068c46d7cc8)
    };
    return (0, $850d57b0288699a1$export$5333c3f1c58d9bc1)((0, $03c621aa5227985a$export$1df9218a526d318d), clientOptions);
}
/**
 * This function is here to be API compatible with the loader.
 * @hidden
 */ function $776bdb0abf297828$export$a3f323d81eede727() {
// Noop
}
/**
 * This function is here to be API compatible with the loader.
 * @hidden
 */ function $776bdb0abf297828$export$4e4d8b287d028b6b(callback) {
    callback();
}


// Development: Parcel compiles Elm via @parcel/transformer-elm
var $b9e750d20bbc1f0f$exports = {};
!function(n) {
    "use strict";
    function r(n, r, t) {
        return t.a = n, t.f = r, t;
    }
    function F2(n) {
        return r(2, n, function(r) {
            return function(t) {
                return n(r, t);
            };
        });
    }
    function F3(n) {
        return r(3, n, function(r) {
            return function(t) {
                return function(e) {
                    return n(r, t, e);
                };
            };
        });
    }
    function F4(n) {
        return r(4, n, function(r) {
            return function(t) {
                return function(e) {
                    return function(u) {
                        return n(r, t, e, u);
                    };
                };
            };
        });
    }
    function F5(n) {
        return r(5, n, function(r) {
            return function(t) {
                return function(e) {
                    return function(u) {
                        return function(a) {
                            return n(r, t, e, u, a);
                        };
                    };
                };
            };
        });
    }
    function F6(n) {
        return r(6, n, function(r) {
            return function(t) {
                return function(e) {
                    return function(u) {
                        return function(a) {
                            return function(i) {
                                return n(r, t, e, u, a, i);
                            };
                        };
                    };
                };
            };
        });
    }
    function F7(n) {
        return r(7, n, function(r) {
            return function(t) {
                return function(e) {
                    return function(u) {
                        return function(a) {
                            return function(i) {
                                return function(c) {
                                    return n(r, t, e, u, a, i, c);
                                };
                            };
                        };
                    };
                };
            };
        });
    }
    function F8(n) {
        return r(8, n, function(r) {
            return function(t) {
                return function(e) {
                    return function(u) {
                        return function(a) {
                            return function(i) {
                                return function(c) {
                                    return function(o) {
                                        return n(r, t, e, u, a, i, c, o);
                                    };
                                };
                            };
                        };
                    };
                };
            };
        });
    }
    function F9(n) {
        return r(9, n, function(r) {
            return function(t) {
                return function(e) {
                    return function(u) {
                        return function(a) {
                            return function(i) {
                                return function(c) {
                                    return function(o) {
                                        return function(f) {
                                            return n(r, t, e, u, a, i, c, o, f);
                                        };
                                    };
                                };
                            };
                        };
                    };
                };
            };
        });
    }
    function A2(n, r, t) {
        return 2 === n.a ? n.f(r, t) : n(r)(t);
    }
    function A3(n, r, t, e) {
        return 3 === n.a ? n.f(r, t, e) : n(r)(t)(e);
    }
    function A4(n, r, t, e, u) {
        return 4 === n.a ? n.f(r, t, e, u) : n(r)(t)(e)(u);
    }
    function A5(n, r, t, e, u, a) {
        return 5 === n.a ? n.f(r, t, e, u, a) : n(r)(t)(e)(u)(a);
    }
    function A6(n, r, t, e, u, a, i) {
        return 6 === n.a ? n.f(r, t, e, u, a, i) : n(r)(t)(e)(u)(a)(i);
    }
    function A7(n, r, t, e, u, a, i, c) {
        return 7 === n.a ? n.f(r, t, e, u, a, i, c) : n(r)(t)(e)(u)(a)(i)(c);
    }
    function A8(n, r, t, e, u, a, i, c, o) {
        return 8 === n.a ? n.f(r, t, e, u, a, i, c, o) : n(r)(t)(e)(u)(a)(i)(c)(o);
    }
    function A9(n, r, t, e, u, a, i, c, o, f) {
        return 9 === n.a ? n.f(r, t, e, u, a, i, c, o, f) : n(r)(t)(e)(u)(a)(i)(c)(o)(f);
    }
    var t = F3(function(n, r, t) {
        for(var e = Array(n), u = 0; n > u; u++)e[u] = t(r + u);
        return e;
    }), e = F2(function(n, r) {
        for(var t = Array(n), e = 0; n > e && r.b; e++)t[e] = r.a, r = r.b;
        return t.length = e, b(t, r);
    }), u = F2(function(n, r) {
        return r[n];
    });
    function a(n) {
        throw Error("https://github.com/elm/core/blob/1.0.0/hints/" + n + ".md");
    }
    function i(n, r) {
        for(var t, e = [], u = c(n, r, 0, e); u && (t = e.pop()); u = c(t.a, t.b, 0, e));
        return u;
    }
    function c(n, r, t, e) {
        if (n === r) return !0;
        if ("object" != typeof n || null === n || null === r) return "function" == typeof n && a(5), !1;
        if (t > 100) return e.push(b(n, r)), !0;
        for(var u in 0 > n.$ && (n = It(n), r = It(r)), n)if (!c(n[u], r[u], t + 1, e)) return !1;
        return !0;
    }
    var o = F2(i), f = F2(function(n, r) {
        return !i(n, r);
    });
    function s(n, r, t) {
        if ("object" != typeof n) return n === r ? 0 : r > n ? -1 : 1;
        if (void 0 === n.$) return (t = s(n.a, r.a)) || (t = s(n.b, r.b)) ? t : s(n.c, r.c);
        for(; n.b && r.b && !(t = s(n.a, r.a)); n = n.b, r = r.b);
        return t || (n.b ? 1 : r.b ? -1 : 0);
    }
    var l = F2(function(n, r) {
        return 1 > s(n, r);
    }), d = F2(function(n, r) {
        var t = s(n, r);
        return 0 > t ? Zt : t ? Wt : Vt;
    });
    function b(n, r) {
        return {
            a: n,
            b: r
        };
    }
    function v(n, r, t) {
        return {
            a: n,
            b: r,
            c: t
        };
    }
    function m(n, r) {
        var t = {};
        for(var e in n)t[e] = n[e];
        for(var e in r)t[e] = r[e];
        return t;
    }
    var p = F2($);
    function $(n, r) {
        if ("string" == typeof n) return n + r;
        if (!n.b) return r;
        var t = g(n.a, r);
        n = n.b;
        for(var e = t; n.b; n = n.b)e = e.b = g(n.a, r);
        return t;
    }
    var h = {
        $: 0
    };
    function g(n, r) {
        return {
            $: 1,
            a: n,
            b: r
        };
    }
    var w = F2(g);
    function k(n) {
        for(var r = h, t = n.length; t--;)r = g(n[t], r);
        return r;
    }
    function x(n) {
        for(var r = []; n.b; n = n.b)r.push(n.a);
        return r;
    }
    var y = F3(function(n, r, t) {
        for(var e = []; r.b && t.b; r = r.b, t = t.b)e.push(A2(n, r.a, t.a));
        return k(e);
    }), _ = F2(function(n, r) {
        return k(x(r).sort(function(r, t) {
            return s(n(r), n(t));
        }));
    }), C = F2(function(n, r) {
        return k(x(r).sort(function(r, t) {
            var e = A2(n, r, t);
            return e === Vt ? 0 : e === Zt ? -1 : 1;
        }));
    }), D = F2(function(n, r) {
        return n * r;
    }), A = F2(Math.pow), q = F2(function(n, r) {
        var t = r % n;
        return 0 === n ? a(11) : t > 0 && 0 > n || 0 > t && n > 0 ? t + n : t;
    }), B = Math.ceil, j = Math.floor, S = Math.round, z = Math.log, U = isNaN, E = F2(function(n, r) {
        return n + r;
    }), P = F2(function(n, r) {
        return n + r;
    }), T = F2(function(n, r) {
        for(var t = r.length, e = Array(t), u = 0; t > u;){
            var a = r.charCodeAt(u);
            55296 > a || a > 56319 ? (e[u] = n(r[u]), u++) : (e[u] = n(r[u] + r[u + 1]), u += 2);
        }
        return e.join("");
    }), F = F2(function(n, r) {
        for(var t = [], e = r.length, u = 0; e > u;){
            var a = r[u], i = r.charCodeAt(u);
            u++, 55296 > i || i > 56319 || (a += r[u], u++), n(a) && t.push(a);
        }
        return t.join("");
    }), L = F3(function(n, r, t) {
        for(var e = t.length; e--;){
            var u = t[e], a = t.charCodeAt(e);
            56320 > a || a > 57343 || (u = t[--e] + u), r = A2(n, u, r);
        }
        return r;
    }), M = F2(function(n, r) {
        return r.split(n);
    }), H = F2(function(n, r) {
        return r.join(n);
    }), R = F3(function(n, r, t) {
        return t.slice(n, r);
    }), O = F2(function(n, r) {
        for(var t = r.length; t--;){
            var e = r[t], u = r.charCodeAt(t);
            if (56320 > u || u > 57343 || (e = r[--t] + e), !n(e)) return !1;
        }
        return !0;
    }), N = F2(function(n, r) {
        return r.indexOf(n) > -1;
    }), I = F2(function(n, r) {
        return 0 === r.indexOf(n);
    }), V = F2(function(n, r) {
        return r.length >= n.length && r.lastIndexOf(n) === r.length - n.length;
    }), W = F2(function(n, r) {
        var t = n.length;
        if (1 > t) return h;
        for(var e = 0, u = []; (e = r.indexOf(n, e)) > -1;)u.push(e), e += t;
        return k(u);
    });
    function Z(n) {
        return n + "";
    }
    function X(n) {
        return {
            $: 2,
            b: n
        };
    }
    var G = X(function(n) {
        return "number" != typeof n ? mn("an INT", n) : n > -2147483647 && 2147483647 > n && (0 | n) === n ? Qt(n) : !isFinite(n) || n % 1 ? mn("an INT", n) : Qt(n);
    }), J = X(function(n) {
        return "boolean" == typeof n ? Qt(n) : mn("a BOOL", n);
    }), Y = X(function(n) {
        return "number" == typeof n ? Qt(n) : mn("a FLOAT", n);
    }), Q = X(function(n) {
        return Qt(n);
    }), K = X(function(n) {
        return "string" == typeof n ? Qt(n) : n instanceof String ? Qt(n + "") : mn("a STRING", n);
    }), nn = F2(function(n, r) {
        return {
            $: 6,
            d: n,
            b: r
        };
    }), rn = F2(function(n, r) {
        return {
            $: 7,
            e: n,
            b: r
        };
    });
    function tn(n, r) {
        return {
            $: 9,
            f: n,
            g: r
        };
    }
    var en = F2(function(n, r) {
        return {
            $: 10,
            b: r,
            h: n
        };
    }), un = F2(function(n, r) {
        return tn(n, [
            r
        ]);
    }), an = F3(function(n, r, t) {
        return tn(n, [
            r,
            t
        ]);
    }), cn = F4(function(n, r, t, e) {
        return tn(n, [
            r,
            t,
            e
        ]);
    }), on = F6(function(n, r, t, e, u, a) {
        return tn(n, [
            r,
            t,
            e,
            u,
            a
        ]);
    }), fn = F2(function(n, r) {
        try {
            return ln(n, JSON.parse(r));
        } catch (n) {
            return Xt(A2(Gt, "This is not valid JSON! " + n.message, r));
        }
    }), sn = F2(function(n, r) {
        return ln(n, r);
    });
    function ln(n, r) {
        switch(n.$){
            case 2:
                return n.b(r);
            case 5:
                return null === r ? Qt(n.c) : mn("null", r);
            case 3:
                return bn(r) ? dn(n.b, r, k) : mn("a LIST", r);
            case 4:
                return bn(r) ? dn(n.b, r, vn) : mn("an ARRAY", r);
            case 6:
                var t = n.d;
                if ("object" != typeof r || null === r || !(t in r)) return mn("an OBJECT with a field named `" + t + "`", r);
                var e = ln(n.b, r[t]);
                return Xe(e) ? e : Xt(A2(Jt, t, e.a));
            case 7:
                var u = n.e;
                return bn(r) ? r.length > u ? (e = ln(n.b, r[u]), Xe(e) ? e : Xt(A2(Yt, u, e.a))) : mn("a LONGER array. Need index " + u + " but only see " + r.length + " entries", r) : mn("an ARRAY", r);
            case 8:
                if ("object" != typeof r || null === r || bn(r)) return mn("an OBJECT", r);
                var a = h;
                for(var i in r)if (r.hasOwnProperty(i)) {
                    if (e = ln(n.b, r[i]), !Xe(e)) return Xt(A2(Jt, i, e.a));
                    a = g(b(i, e.a), a);
                }
                return Qt(we(a));
            case 9:
                for(var c = n.f, o = n.g, f = 0; o.length > f; f++){
                    if (e = ln(o[f], r), !Xe(e)) return e;
                    c = c(e.a);
                }
                return Qt(c);
            case 10:
                return e = ln(n.b, r), Xe(e) ? ln(n.h(e.a), r) : e;
            case 11:
                for(var s = h, l = n.g; l.b; l = l.b){
                    if (e = ln(l.a, r), Xe(e)) return e;
                    s = g(e.a, s);
                }
                return Xt(Kt(we(s)));
            case 1:
                return Xt(A2(Gt, n.a, r));
            case 0:
                return Qt(n.a);
        }
    }
    function dn(n, r, t) {
        for(var e = r.length, u = Array(e), a = 0; e > a; a++){
            var i = ln(n, r[a]);
            if (!Xe(i)) return Xt(A2(Yt, a, i.a));
            u[a] = i.a;
        }
        return Qt(t(u));
    }
    function bn(n) {
        return Array.isArray(n) || "undefined" != typeof FileList && n instanceof FileList;
    }
    function vn(n) {
        return A2(Ze, n.length, function(r) {
            return n[r];
        });
    }
    function mn(n, r) {
        return Xt(A2(Gt, "Expecting " + n, r));
    }
    function pn(n, r) {
        if (n === r) return !0;
        if (n.$ !== r.$) return !1;
        switch(n.$){
            case 0:
            case 1:
                return n.a === r.a;
            case 2:
                return n.b === r.b;
            case 5:
                return n.c === r.c;
            case 3:
            case 4:
            case 8:
                return pn(n.b, r.b);
            case 6:
                return n.d === r.d && pn(n.b, r.b);
            case 7:
                return n.e === r.e && pn(n.b, r.b);
            case 9:
                return n.f === r.f && $n(n.g, r.g);
            case 10:
                return n.h === r.h && pn(n.b, r.b);
            case 11:
                return $n(n.g, r.g);
        }
    }
    function $n(n, r) {
        var t = n.length;
        if (t !== r.length) return !1;
        for(var e = 0; t > e; e++)if (!pn(n[e], r[e])) return !1;
        return !0;
    }
    var hn = F2(function(n, r) {
        return JSON.stringify(r, null, n) + "";
    });
    function gn(n) {
        return n;
    }
    var wn = F3(function(n, r, t) {
        return t[n] = r, t;
    });
    function kn(n) {
        return {
            $: 0,
            a: n
        };
    }
    function xn(n) {
        return {
            $: 1,
            a: n
        };
    }
    function yn(n) {
        return {
            $: 2,
            b: n,
            c: null
        };
    }
    var _n = F2(function(n, r) {
        return {
            $: 3,
            b: n,
            d: r
        };
    }), Cn = F2(function(n, r) {
        return {
            $: 4,
            b: n,
            d: r
        };
    }), Dn = 0;
    function An(n) {
        var r = {
            $: 0,
            e: Dn++,
            f: n,
            g: null,
            h: []
        };
        return Un(r), r;
    }
    function qn(n) {
        return yn(function(r) {
            r(kn(An(n)));
        });
    }
    function Bn(n, r) {
        n.h.push(r), Un(n);
    }
    var jn = F2(function(n, r) {
        return yn(function(t) {
            Bn(n, r), t(kn(0));
        });
    }), Sn = !1, zn = [];
    function Un(n) {
        if (zn.push(n), !Sn) {
            for(Sn = !0; n = zn.shift();)En(n);
            Sn = !1;
        }
    }
    function En(n) {
        for(; n.f;){
            var r = n.f.$;
            if (0 === r || 1 === r) {
                for(; n.g && n.g.$ !== r;)n.g = n.g.i;
                if (!n.g) return;
                n.f = n.g.b(n.f.a), n.g = n.g.i;
            } else {
                if (2 === r) return void (n.f.c = n.f.b(function(r) {
                    n.f = r, Un(n);
                }));
                if (5 === r) {
                    if (0 === n.h.length) return;
                    n.f = n.f.b(n.h.shift());
                } else n.g = {
                    $: 3 === r ? 0 : 1,
                    b: n.f.b,
                    i: n.g
                }, n.f = n.f.d;
            }
        }
    }
    function Pn(n) {
        return yn(function(r) {
            var t = setTimeout(function() {
                r(kn(0));
            }, n);
            return function() {
                clearTimeout(t);
            };
        });
    }
    var Tn = {};
    function Fn(n, r, t, e, u) {
        return {
            b: n,
            c: r,
            d: t,
            e: e,
            f: u
        };
    }
    function Ln(n, r) {
        var t = {
            g: r,
            h: void 0
        }, e = n.c, u = n.d, a = n.e, i = n.f;
        function c(n) {
            return A2(_n, c, {
                $: 5,
                b: function(r) {
                    var c = r.a;
                    return 0 === r.$ ? A3(u, t, c, n) : a && i ? A4(e, t, c.i, c.j, n) : A3(e, t, a ? c.i : c.j, n);
                }
            });
        }
        return t.h = An(A2(_n, c, n.b));
    }
    var Mn = F2(function(n, r) {
        return yn(function(t) {
            n.g(r), t(kn(0));
        });
    }), Hn = F2(function(n, r) {
        return A2(jn, n.h, {
            $: 0,
            a: r
        });
    });
    function Rn(n) {
        return function(r) {
            return {
                $: 1,
                k: n,
                l: r
            };
        };
    }
    function On(n) {
        return {
            $: 2,
            m: n
        };
    }
    var Nn = F2(function(n, r) {
        return {
            $: 3,
            n: n,
            o: r
        };
    }), In = [], Vn = !1;
    function Wn(n, r, t) {
        if (In.push({
            p: n,
            q: r,
            r: t
        }), !Vn) {
            Vn = !0;
            for(var e; e = In.shift();)Zn(e.p, e.q, e.r);
            Vn = !1;
        }
    }
    function Zn(n, r, t) {
        var e = {};
        for(var u in Xn(!0, r, e, null), Xn(!1, t, e, null), n)Bn(n[u], {
            $: "fx",
            a: e[u] || {
                i: h,
                j: h
            }
        });
    }
    function Xn(n, r, t, e) {
        switch(r.$){
            case 1:
                var u = r.k, a = function(n, r, t, e) {
                    function u(n) {
                        for(var r = t; r; r = r.t)n = r.s(n);
                        return n;
                    }
                    return A2(n ? Tn[r].e : Tn[r].f, u, e);
                }(n, u, e, r.l);
                return void (t[u] = function(n, r, t) {
                    return t = t || {
                        i: h,
                        j: h
                    }, n ? t.i = g(r, t.i) : t.j = g(r, t.j), t;
                }(n, a, t[u]));
            case 2:
                for(var i = r.m; i.b; i = i.b)Xn(n, i.a, t, e);
                return;
            case 3:
                return void Xn(n, r.o, t, {
                    s: r.n,
                    t: e
                });
        }
    }
    function Gn(n) {
        Tn[n] && a(3);
    }
    function Jn(n, r) {
        return Gn(n), Tn[n] = {
            e: Yn,
            u: r,
            a: Qn
        }, Rn(n);
    }
    var Yn = F2(function(n, r) {
        return r;
    });
    function Qn(n) {
        var r = [], t = Tn[n].u, e = Pn(0);
        return Tn[n].b = e, Tn[n].c = F3(function(n, u) {
            for(; u.b; u = u.b)for(var a = r, i = t(u.a), c = 0; a.length > c; c++)a[c](i);
            return e;
        }), {
            subscribe: function(n) {
                r.push(n);
            },
            unsubscribe: function(n) {
                var t = (r = r.slice()).indexOf(n);
                0 > t || r.splice(t, 1);
            }
        };
    }
    function Kn(n, r) {
        return Gn(n), Tn[n] = {
            f: nr,
            u: r,
            a: rr
        }, Rn(n);
    }
    var nr = F2(function(n, r) {
        return function(t) {
            return n(r(t));
        };
    });
    function rr(n, r) {
        var t = h, e = Tn[n].u, u = kn(null);
        return Tn[n].b = u, Tn[n].c = F3(function(n, r) {
            return t = r, u;
        }), {
            send: function(n) {
                var u = A2(sn, e, n);
                Xe(u) || a(4);
                for(var i = u.a, c = t; c.b; c = c.b)r(c.a(i));
            }
        };
    }
    var tr = "undefined" != typeof document ? document : {};
    function er(n, r) {
        n.appendChild(r);
    }
    function ur(n) {
        return {
            $: 0,
            a: n
        };
    }
    var ar = F2(function(n, r) {
        return F2(function(t, e) {
            for(var u = [], a = 0; e.b; e = e.b){
                var i = e.a;
                a += i.b || 0, u.push(i);
            }
            return a += u.length, {
                $: 1,
                c: r,
                d: wr(t),
                e: u,
                f: n,
                b: a
            };
        });
    }), ir = ar(void 0), cr = F2(function(n, r) {
        return F2(function(t, e) {
            for(var u = [], a = 0; e.b; e = e.b){
                var i = e.a;
                a += i.b.b || 0, u.push(i);
            }
            return a += u.length, {
                $: 2,
                c: r,
                d: wr(t),
                e: u,
                f: n,
                b: a
            };
        });
    }), or = cr(void 0), fr = F2(function(n, r) {
        return {
            $: 4,
            j: n,
            k: r,
            b: 1 + (r.b || 0)
        };
    }), sr = F2(function(n, r) {
        return {
            $: "a0",
            n: n,
            o: r
        };
    }), lr = F2(function(n, r) {
        return {
            $: "a1",
            n: n,
            o: r
        };
    }), dr = F2(function(n, r) {
        return {
            $: "a2",
            n: n,
            o: r
        };
    }), br = F2(function(n, r) {
        return {
            $: "a3",
            n: n,
            o: r
        };
    });
    function vr(n) {
        return "script" == n ? "p" : n;
    }
    function mr(n) {
        return /^\s*(javascript:|data:text\/html)/i.test(n) ? "" : n;
    }
    var pr, $r = F2(function(n, r) {
        return "a0" === r.$ ? A2(sr, r.n, function(n, r) {
            var t = nu(r);
            return {
                $: r.$,
                a: t ? A3(Qe, 3 > t ? hr : gr, Ke(n), r.a) : A2(Ye, n, r.a)
            };
        }(n, r.o)) : r;
    }), hr = F2(function(n, r) {
        return b(n(r.a), r.b);
    }), gr = F2(function(n, r) {
        return {
            se: n(r.se),
            wk: r.wk,
            us: r.us
        };
    });
    function wr(n) {
        for(var r = {}; n.b; n = n.b){
            var t = n.a, e = t.$, u = t.n, a = t.o;
            if ("a2" !== e) {
                var i = r[e] || (r[e] = {});
                "a3" === e && "class" === u ? kr(i, u, a) : i[u] = a;
            } else "className" === u ? kr(r, u, a) : r[u] = a;
        }
        return r;
    }
    function kr(n, r, t) {
        var e = n[r];
        n[r] = e ? e + " " + t : t;
    }
    function xr(n, r) {
        var t = n.$;
        if (5 === t) return xr(n.k || (n.k = n.m()), r);
        if (0 === t) return tr.createTextNode(n.a);
        if (4 === t) {
            for(var e = n.k, u = n.j; 4 === e.$;)"object" != typeof u ? u = [
                u,
                e.j
            ] : u.push(e.j), e = e.k;
            var a = {
                j: u,
                p: r
            };
            return (i = xr(e, a)).elm_event_node_ref = a, i;
        }
        if (3 === t) return yr(i = n.h(n.g), r, n.d), i;
        var i = n.f ? tr.createElementNS(n.f, n.c) : tr.createElement(n.c);
        yr(i, r, n.d);
        for(var c = n.e, o = 0; c.length > o; o++)er(i, xr(1 === t ? c[o] : c[o].b, r));
        return i;
    }
    function yr(n, r, t) {
        for(var e in t){
            var u = t[e];
            "a1" === e ? _r(n, u) : "a0" === e ? Ar(n, r, u) : "a3" === e ? Cr(n, u) : "a4" === e ? Dr(n, u) : ("value" !== e && "checked" !== e || n[e] !== u) && (n[e] = u);
        }
    }
    function _r(n, r) {
        var t = n.style;
        for(var e in r)t[e] = r[e];
    }
    function Cr(n, r) {
        for(var t in r){
            var e = r[t];
            void 0 !== e ? n.setAttribute(t, e) : n.removeAttribute(t);
        }
    }
    function Dr(n, r) {
        for(var t in r){
            var e = r[t], u = e.f, a = e.o;
            void 0 !== a ? n.setAttributeNS(u, t, a) : n.removeAttributeNS(u, t);
        }
    }
    function Ar(n, r, t) {
        var e = n.elmFs || (n.elmFs = {});
        for(var u in t){
            var a = t[u], i = e[u];
            if (a) {
                if (i) {
                    if (i.q.$ === a.$) {
                        i.q = a;
                        continue;
                    }
                    n.removeEventListener(u, i);
                }
                i = qr(r, a), n.addEventListener(u, i, pr && {
                    passive: 2 > nu(a)
                }), e[u] = i;
            } else n.removeEventListener(u, i), e[u] = void 0;
        }
    }
    try {
        window.addEventListener("t", null, Object.defineProperty({}, "passive", {
            get: function() {
                pr = !0;
            }
        }));
    } catch (n) {}
    function qr(n, r) {
        function t(r) {
            var e = t.q, u = ln(e.a, r);
            if (Xe(u)) {
                for(var a, i = nu(e), c = u.a, o = i ? 3 > i ? c.a : c.se : c, f = 1 == i ? c.b : 3 == i && c.wk, s = (f && r.stopPropagation(), (2 == i ? c.b : 3 == i && c.us) && r.preventDefault(), n); a = s.j;){
                    if ("function" == typeof a) o = a(o);
                    else for(var l = a.length; l--;)o = a[l](o);
                    s = s.p;
                }
                s(o, f);
            }
        }
        return t.q = r, t;
    }
    function Br(n, r) {
        return n.$ == r.$ && pn(n.a, r.a);
    }
    function jr(n, r, t, e) {
        var u = {
            $: r,
            r: t,
            s: e,
            t: void 0,
            u: void 0
        };
        return n.push(u), u;
    }
    function Sr(n, r, t, e) {
        if (n !== r) {
            var u = n.$, a = r.$;
            if (u !== a) {
                if (1 !== u || 2 !== a) return void jr(t, 0, e, r);
                r = function(n) {
                    for(var r = n.e, t = r.length, e = Array(t), u = 0; t > u; u++)e[u] = r[u].b;
                    return {
                        $: 1,
                        c: n.c,
                        d: n.d,
                        e: e,
                        f: n.f,
                        b: n.b
                    };
                }(r), a = 1;
            }
            switch(a){
                case 5:
                    for(var i = n.l, c = r.l, o = i.length, f = o === c.length; f && o--;)f = i[o] === c[o];
                    if (f) return void (r.k = n.k);
                    r.k = r.m();
                    var s = [];
                    return Sr(n.k, r.k, s, 0), void (s.length > 0 && jr(t, 1, e, s));
                case 4:
                    for(var l = n.j, d = r.j, b = !1, v = n.k; 4 === v.$;)b = !0, "object" != typeof l ? l = [
                        l,
                        v.j
                    ] : l.push(v.j), v = v.k;
                    for(var m = r.k; 4 === m.$;)b = !0, "object" != typeof d ? d = [
                        d,
                        m.j
                    ] : d.push(m.j), m = m.k;
                    return b && l.length !== d.length ? void jr(t, 0, e, r) : ((b ? function(n, r) {
                        for(var t = 0; n.length > t; t++)if (n[t] !== r[t]) return !1;
                        return !0;
                    }(l, d) : l === d) || jr(t, 2, e, d), void Sr(v, m, t, e + 1));
                case 0:
                    return void (n.a !== r.a && jr(t, 3, e, r.a));
                case 1:
                    return void zr(n, r, t, e, Er);
                case 2:
                    return void zr(n, r, t, e, Pr);
                case 3:
                    if (n.h !== r.h) return void jr(t, 0, e, r);
                    var p = Ur(n.d, r.d);
                    p && jr(t, 4, e, p);
                    var $ = r.i(n.g, r.g);
                    return void ($ && jr(t, 5, e, $));
            }
        }
    }
    function zr(n, r, t, e, u) {
        if (n.c === r.c && n.f === r.f) {
            var a = Ur(n.d, r.d);
            a && jr(t, 4, e, a), u(n, r, t, e);
        } else jr(t, 0, e, r);
    }
    function Ur(n, r, t) {
        var e;
        for(var u in n)if ("a1" !== u && "a0" !== u && "a3" !== u && "a4" !== u) {
            if (u in r) {
                var a = n[u], i = r[u];
                a === i && "value" !== u && "checked" !== u || "a0" === t && Br(a, i) || ((e = e || {})[u] = i);
            } else (e = e || {})[u] = t ? "a1" === t ? "" : "a0" === t || "a3" === t ? void 0 : {
                f: n[u].f,
                o: void 0
            } : "string" == typeof n[u] ? "" : null;
        } else {
            var c = Ur(n[u], r[u] || {}, u);
            c && ((e = e || {})[u] = c);
        }
        for(var o in r)o in n || ((e = e || {})[o] = r[o]);
        return e;
    }
    function Er(n, r, t, e) {
        var u = n.e, a = r.e, i = u.length, c = a.length;
        i > c ? jr(t, 6, e, {
            v: c,
            i: i - c
        }) : c > i && jr(t, 7, e, {
            v: i,
            e: a
        });
        for(var o = c > i ? i : c, f = 0; o > f; f++){
            var s = u[f];
            Sr(s, a[f], t, ++e), e += s.b || 0;
        }
    }
    function Pr(n, r, t, e) {
        for(var u = [], a = {}, i = [], c = n.e, o = r.e, f = c.length, s = o.length, l = 0, d = 0, b = e; f > l && s > d;){
            var v = (D = c[l]).a, m = (A = o[d]).a, p = D.b, $ = A.b, h = void 0, g = void 0;
            if (v !== m) {
                var w = c[l + 1], k = o[d + 1];
                if (w) {
                    var x = w.a, y = w.b;
                    g = m === x;
                }
                if (k) {
                    var _ = k.a, C = k.b;
                    h = v === _;
                }
                if (h && g) Sr(p, C, u, ++b), Fr(a, u, v, $, d, i), b += p.b || 0, Lr(a, u, v, y, ++b), b += y.b || 0, l += 2, d += 2;
                else if (h) b++, Fr(a, u, m, $, d, i), Sr(p, C, u, b), b += p.b || 0, l += 1, d += 2;
                else if (g) Lr(a, u, v, p, ++b), b += p.b || 0, Sr(y, $, u, ++b), b += y.b || 0, l += 2, d += 1;
                else {
                    if (!w || x !== _) break;
                    Lr(a, u, v, p, ++b), Fr(a, u, m, $, d, i), b += p.b || 0, Sr(y, C, u, ++b), b += y.b || 0, l += 2, d += 2;
                }
            } else Sr(p, $, u, ++b), b += p.b || 0, l++, d++;
        }
        for(; f > l;){
            var D;
            b++, Lr(a, u, (D = c[l]).a, p = D.b, b), b += p.b || 0, l++;
        }
        for(; s > d;){
            var A, q = q || [];
            Fr(a, u, (A = o[d]).a, A.b, void 0, q), d++;
        }
        (u.length > 0 || i.length > 0 || q) && jr(t, 8, e, {
            w: u,
            x: i,
            y: q
        });
    }
    var Tr = "_elmW6BL";
    function Fr(n, r, t, e, u, a) {
        var i = n[t];
        if (!i) return a.push({
            r: u,
            A: i = {
                c: 0,
                z: e,
                r: u,
                s: void 0
            }
        }), void (n[t] = i);
        if (1 === i.c) {
            a.push({
                r: u,
                A: i
            }), i.c = 2;
            var c = [];
            return Sr(i.z, e, c, i.r), i.r = u, void (i.s.s = {
                w: c,
                A: i
            });
        }
        Fr(n, r, t + Tr, e, u, a);
    }
    function Lr(n, r, t, e, u) {
        var a = n[t];
        if (a) {
            if (0 === a.c) {
                a.c = 2;
                var i = [];
                return Sr(e, a.z, i, u), void jr(r, 9, u, {
                    w: i,
                    A: a
                });
            }
            Lr(n, r, t + Tr, e, u);
        } else {
            var c = jr(r, 9, u, void 0);
            n[t] = {
                c: 1,
                z: e,
                r: u,
                s: c
            };
        }
    }
    function Mr(n, r, t, e) {
        Hr(n, r, t, 0, 0, r.b, e);
    }
    function Hr(n, r, t, e, u, a, i) {
        for(var c = t[e], o = c.r; o === u;){
            var f = c.$;
            if (1 === f) Mr(n, r.k, c.s, i);
            else if (8 === f) c.t = n, c.u = i, (s = c.s.w).length > 0 && Hr(n, r, s, 0, u, a, i);
            else if (9 === f) {
                c.t = n, c.u = i;
                var s, l = c.s;
                l && (l.A.s = n, (s = l.w).length > 0 && Hr(n, r, s, 0, u, a, i));
            } else c.t = n, c.u = i;
            if (!(c = t[++e]) || (o = c.r) > a) return e;
        }
        var d = r.$;
        if (4 === d) {
            for(var b = r.k; 4 === b.$;)b = b.k;
            return Hr(n, b, t, e, u + 1, a, n.elm_event_node_ref);
        }
        for(var v = r.e, m = n.childNodes, p = 0; v.length > p; p++){
            u++;
            var $ = 1 === d ? v[p] : v[p].b, h = u + ($.b || 0);
            if (!(u > o || o > h || (c = t[e = Hr(m[p], $, t, e, u, h, i)]) && (o = c.r) <= a)) return e;
            u = h;
        }
        return e;
    }
    function Rr(n, r) {
        for(var t = 0; r.length > t; t++){
            var e = r[t], u = e.t, a = Or(u, e);
            u === n && (n = a);
        }
        return n;
    }
    function Or(n, r) {
        switch(r.$){
            case 0:
                return function(n, r, t) {
                    var e = n.parentNode, u = xr(r, t);
                    return u.elm_event_node_ref || (u.elm_event_node_ref = n.elm_event_node_ref), e && u !== n && e.replaceChild(u, n), u;
                }(n, r.s, r.u);
            case 4:
                return yr(n, r.u, r.s), n;
            case 3:
                return n.replaceData(0, n.length, r.s), n;
            case 1:
                return Rr(n, r.s);
            case 2:
                return n.elm_event_node_ref ? n.elm_event_node_ref.j = r.s : n.elm_event_node_ref = {
                    j: r.s,
                    p: r.u
                }, n;
            case 6:
                for(var t = r.s, e = 0; t.i > e; e++)n.removeChild(n.childNodes[t.v]);
                return n;
            case 7:
                for(var u = (t = r.s).e, i = n.childNodes[e = t.v]; u.length > e; e++)n.insertBefore(xr(u[e], r.u), i);
                return n;
            case 9:
                if (!(t = r.s)) return n.parentNode.removeChild(n), n;
                var c = t.A;
                return void 0 !== c.r && n.parentNode.removeChild(n), c.s = Rr(n, t.w), n;
            case 8:
                return function(n, r) {
                    var t = r.s, e = function(n, r) {
                        if (n) {
                            for(var t = tr.createDocumentFragment(), e = 0; n.length > e; e++){
                                var u = n[e].A;
                                er(t, 2 === u.c ? u.s : xr(u.z, r.u));
                            }
                            return t;
                        }
                    }(t.y, r);
                    n = Rr(n, t.w);
                    for(var u = t.x, a = 0; u.length > a; a++){
                        var i = u[a], c = i.A, o = 2 === c.c ? c.s : xr(c.z, r.u);
                        n.insertBefore(o, n.childNodes[i.r]);
                    }
                    return e && er(n, e), n;
                }(n, r);
            case 5:
                return r.s(n);
            default:
                a(10);
        }
    }
    function Nr(n) {
        if (3 === n.nodeType) return ur(n.textContent);
        if (1 !== n.nodeType) return ur("");
        for(var r = h, t = n.attributes, e = t.length; e--;){
            var u = t[e];
            r = g(A2(br, u.name, u.value), r);
        }
        var a = n.tagName.toLowerCase(), i = h, c = n.childNodes;
        for(e = c.length; e--;)i = g(Nr(c[e]), i);
        return A3(ir, a, r, i);
    }
    var Ir = F4(function(n, r, t, e) {
        return function(n, r, t, e, u, i) {
            var c = A2(sn, n, r ? r.flags : void 0);
            Xe(c) || a(2);
            var o = {}, f = t(c.a), s = f.a, l = i(b, s), d = function(n, r) {
                var t;
                for(var e in Tn){
                    var u = Tn[e];
                    u.a && ((t = t || {})[e] = u.a(e, r)), n[e] = Ln(u, r);
                }
                return t;
            }(o, b);
            function b(n, r) {
                var t = A2(e, n, s);
                l(s = t.a, r), Wn(o, t.b, u(s));
            }
            return Wn(o, f.b, u(s)), d ? {
                ports: d
            } : {};
        }(r, e, n.zO, n.DB, n.Dd, function(r, t) {
            var u = n.DH, a = e.node, i = Nr(a);
            return function(n, r) {
                r(n);
                var t = 0;
                function e() {
                    t = 1 === t ? 0 : (Vr(e), r(n), 1);
                }
                return function(u, a) {
                    n = u, a ? (r(n), 2 === t && (t = 1)) : (0 === t && Vr(e), t = 2);
                };
            }(t, function(n) {
                var t = u(n), e = function(n, r) {
                    var t = [];
                    return Sr(n, r, t, 0), t;
                }(i, t);
                a = function(n, r, t, e) {
                    return 0 === t.length ? n : (Mr(n, r, t, e), Rr(n, t));
                }(a, i, e, r), i = t;
            });
        });
    }), Vr = ("undefined" != typeof cancelAnimationFrame && cancelAnimationFrame, "undefined" != typeof requestAnimationFrame ? requestAnimationFrame : function(n) {
        return setTimeout(n, 1e3 / 60);
    });
    var Wr = {
        addEventListener: function() {},
        removeEventListener: function() {}
    }, Zr = "undefined" != typeof document ? document : Wr, Xr = "undefined" != typeof window ? window : Wr, Gr = F3(function(n, r, t) {
        return qn(yn(function() {
            function e(n) {
                An(t(n));
            }
            return n.addEventListener(r, e, pr && {
                passive: !0
            }), function() {
                n.removeEventListener(r, e);
            };
        }));
    }), Jr = F2(function(n, r) {
        var t = ln(n, r);
        return Xe(t) ? Ht(t.a) : Rt;
    });
    function Yr(n, r) {
        return yn(function(t) {
            Vr(function() {
                var e = document.getElementById(n);
                t(e ? kn(r(e)) : xn(tu(n)));
            });
        });
    }
    function Qr(n) {
        return yn(function(r) {
            Vr(function() {
                r(kn(n()));
            });
        });
    }
    var Kr = F2(function(n, r) {
        return Yr(r, function(r) {
            return r[n](), 0;
        });
    });
    function nt() {
        var n = Zr.body, r = Zr.documentElement;
        return {
            cd: Math.max(n.scrollWidth, n.offsetWidth, r.scrollWidth, r.offsetWidth, r.clientWidth),
            qI: Math.max(n.scrollHeight, n.offsetHeight, r.scrollHeight, r.offsetHeight, r.clientHeight)
        };
    }
    var rt = F2(function(n, r) {
        return Qr(function() {
            return Xr.scroll(n, r), 0;
        });
    }), tt = F3(function(n, r, t) {
        return Yr(n, function(n) {
            return n.scrollLeft = r, n.scrollTop = t, 0;
        });
    }), et = F2(function(n, r) {
        return yn(function() {
            var t = setInterval(function() {
                An(r);
            }, n);
            return function() {
                clearInterval(t);
            };
        });
    }), ut = F2(function(n, r) {
        var t = "g";
        n.AC && (t += "m"), n.yf && (t += "i");
        try {
            return Ht(RegExp(r, t));
        } catch (n) {
            return Rt;
        }
    }), at = F2(function(n, r) {
        return null !== r.match(n);
    }), it = F3(function(n, r, t) {
        for(var e, u = [], a = 0, i = t, c = r.lastIndex, o = -1; a++ < n && (e = r.exec(i)) && o != r.lastIndex;){
            for(var f = e.length - 1, s = Array(f); f > 0;){
                var l = e[f];
                s[--f] = l ? Ht(l) : Rt;
            }
            u.push(A4(Nb, e[0], e.index, a, k(s))), o = r.lastIndex;
        }
        return r.lastIndex = c, k(u);
    }), ct = F4(function(n, r, t, e) {
        var u = 0;
        return e.replace(r, function(r) {
            if (u++ >= n) return r;
            for(var e = arguments.length - 3, a = Array(e); e > 0;){
                var i = arguments[e];
                a[--e] = i ? Ht(i) : Rt;
            }
            return t(A4(Nb, r, arguments[arguments.length - 2], u, k(a)));
        });
    }), ot = 1 / 0, ft = F5(function(n, r, t, e, u) {
        for(var a = n.length, i = u.length >= r + a, c = 0; i && a > c;){
            var o = u.charCodeAt(r);
            i = n[c++] === u[r++] && (10 === o ? (t++, e = 1) : (e++, 55296 == (63488 & o) ? n[c++] === u[r++] : 1));
        }
        return v(i ? r : -1, t, e);
    }), st = F3(function(n, r, t) {
        return t.length > r ? 55296 == (63488 & t.charCodeAt(r)) ? n(t.substr(r, 2)) ? r + 2 : -1 : n(t[r]) ? "\n" === t[r] ? -2 : r + 1 : -1 : -1;
    }), lt = F3(function(n, r, t) {
        return t.charCodeAt(r) === n;
    }), dt = F2(function(n, r) {
        for(; r.length > n; n++){
            var t = r.charCodeAt(n);
            if (48 > t || t > 57) return n;
        }
        return n;
    }), bt = F3(function(n, r, t) {
        for(var e = 0; t.length > r; r++){
            var u = t.charCodeAt(r) - 48;
            if (0 > u || u >= n) break;
            e = n * e + u;
        }
        return b(r, e);
    }), vt = F2(function(n, r) {
        for(var t = 0; r.length > n; n++){
            var e = r.charCodeAt(n);
            if (48 > e || e > 57) {
                if (65 > e || e > 70) {
                    if (97 > e || e > 102) break;
                    t = 16 * t + e - 87;
                } else t = 16 * t + e - 55;
            } else t = 16 * t + e - 48;
        }
        return b(n, t);
    }), mt = F5(function(n, r, t, e, u) {
        for(var a = u.indexOf(n, r), i = 0 > a ? u.length : a + n.length; i > r;){
            var c = u.charCodeAt(r++);
            10 === c ? (e = 1, t++) : (e++, 55296 == (63488 & c) && r++);
        }
        return v(a, t, e);
    });
    function pt(n) {
        return n.byteLength;
    }
    var $t = F3(function(n, r, t) {
        return n.setInt8(r, t), r + 1;
    }), ht = F4(function(n, r, t, e) {
        return n.setInt16(r, t, e), r + 2;
    }), gt = F4(function(n, r, t, e) {
        return n.setInt32(r, t, e), r + 4;
    }), wt = F3(function(n, r, t) {
        return n.setUint8(r, t), r + 1;
    }), kt = F4(function(n, r, t, e) {
        return n.setUint16(r, t, e), r + 2;
    }), xt = F4(function(n, r, t, e) {
        return n.setUint32(r, t, e), r + 4;
    }), yt = F4(function(n, r, t, e) {
        return n.setFloat32(r, t, e), r + 4;
    }), _t = F4(function(n, r, t, e) {
        return n.setFloat64(r, t, e), r + 8;
    }), Ct = F3(function(n, r, t) {
        for(var e = 0, u = t.byteLength, a = u - 4; a >= e; e += 4)n.setUint32(r + e, t.getUint32(e));
        for(; u > e; e++)n.setUint8(r + e, t.getUint8(e));
        return r + u;
    }), Dt = F3(function(n, r, t) {
        for(var e = 0; t.length > e; e++){
            var u = t.charCodeAt(e);
            r += 128 > u ? (n.setUint8(r, u), 1) : 2048 > u ? (n.setUint16(r, 49280 | (u >>> 6 & 31) << 8 | 63 & u), 2) : 55296 > u || u > 56319 ? (n.setUint16(r, 57472 | (u >>> 12 & 15) << 8 | u >>> 6 & 63), n.setUint8(r + 2, 128 | 63 & u), 3) : (u = 1024 * (u - 55296) + t.charCodeAt(++e) - 56320 + 65536, n.setUint32(r, 4034953344 | (u >>> 18 & 7) << 24 | (u >>> 12 & 63) << 16 | (u >>> 6 & 63) << 8 | 63 & u), 4);
        }
        return r;
    }), At = F2(function(n, r) {
        try {
            return Ht(A2(n, r, 0).b);
        } catch (n) {
            return Rt;
        }
    }), qt = F2(function(n, r) {
        return b(r + 1, n.getUint8(r));
    }), Bt = F3(function(n, r, t) {
        return b(t + 2, r.getUint16(t, n));
    }), jt = F3(function(n, r, t) {
        return b(t + 4, r.getUint32(t, n));
    }), St = F3(function(n, r, t) {
        for(var e = "", u = t + n; u > t;){
            var a = r.getUint8(t++);
            e += 128 > a ? String.fromCharCode(a) : 192 == (224 & a) ? String.fromCharCode((31 & a) << 6 | 63 & r.getUint8(t++)) : 224 == (240 & a) ? String.fromCharCode((15 & a) << 12 | (63 & r.getUint8(t++)) << 6 | 63 & r.getUint8(t++)) : (a = ((7 & a) << 18 | (63 & r.getUint8(t++)) << 12 | (63 & r.getUint8(t++)) << 6 | 63 & r.getUint8(t++)) - 65536, String.fromCharCode(Math.floor(a / 1024) + 55296, a % 1024 + 56320));
        }
        return b(t, e);
    }), zt = F3(function(n, r, t) {
        return yn(function(e) {
            function u(n) {
                e(r(t.zc.a(n)));
            }
            var a = new XMLHttpRequest;
            a.addEventListener("error", function() {
                u(r_);
            }), a.addEventListener("timeout", function() {
                u(u_);
            }), a.addEventListener("load", function() {
                u(function(n, r) {
                    return A2(r.status >= 200 && 300 > r.status ? n_ : Qy, function(n) {
                        return {
                            w_: n.responseURL,
                            C7: n.status,
                            C8: n.statusText,
                            hu: Ut(n.getAllResponseHeaders())
                        };
                    }(r), n(r.response));
                }(t.zc.b, a));
            }), a_(t.Dw) && function(n, r, t) {
                r.upload.addEventListener("progress", function(e) {
                    r.c || An(A2(i_, n, b(t, e_({
                        CE: e.loaded,
                        CY: e.total
                    }))));
                }), r.addEventListener("progress", function(e) {
                    r.c || An(A2(i_, n, b(t, t_({
                        Ca: e.loaded,
                        CY: e.lengthComputable ? Ht(e.total) : Rt
                    }))));
                });
            }(n, a, t.Dw.a);
            try {
                a.open(t.AA, t.w_, !0);
            } catch (n) {
                return u(Ky(t.w_));
            }
            return function(n, r) {
                for(var t = r.hu; t.b; t = t.b)n.setRequestHeader(t.a.a, t.a.b);
                n.timeout = r.Do.a || 0, n.responseType = r.zc.d, n.withCredentials = r.xN;
            }(a, t), t.gF.a && a.setRequestHeader("Content-Type", t.gF.a), a.send(t.gF.b), function() {
                a.c = !0, a.abort();
            };
        });
    });
    function Ut(n) {
        if (!n) return oa;
        for(var r = oa, t = n.split("\r\n"), e = t.length; e--;){
            var u = t[e], a = u.indexOf(": ");
            if (a > 0) {
                var i = u.substring(0, a), c = u.substring(a + 2);
                r = A3(ia, i, function(n) {
                    return Ht(a_(n) ? c + ", " + n.a : c);
                }, r);
            }
        }
        return r;
    }
    var Et = F3(function(n, r, t) {
        return {
            $: 0,
            d: n,
            b: r,
            a: t
        };
    }), Pt = F2(function(n, r) {
        return {
            $: 0,
            d: r.d,
            b: r.b,
            a: function(t) {
                return n(r.a(t));
            }
        };
    });
    function Tt(n) {
        return new DataView(n);
    }
    var Ft, Lt = F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    });
    X(function(n) {
        return "undefined" != typeof File && n instanceof File ? Qt(n) : mn("a FILE", n);
    });
    var Mt = F3(function(n, r, t) {
        return yn(function() {
            var e = new Blob([
                t
            ], {
                type: r
            });
            if (navigator.msSaveOrOpenBlob) navigator.msSaveOrOpenBlob(e, n);
            else {
                var u = Ft || (Ft = document.createElement("a")), a = URL.createObjectURL(e);
                u.href = a, u.download = n, function(n) {
                    if ("function" == typeof MouseEvent) n.dispatchEvent(new MouseEvent("click"));
                    else {
                        var r = document.createEvent("MouseEvents");
                        r.initMouseEvent("click", !0, !0, window, 0, 0, 0, 0, 0, !1, !1, !1, !1, 0, null), document.body.appendChild(n), n.dispatchEvent(r), document.body.removeChild(n);
                    }
                }(u), URL.revokeObjectURL(a);
            }
        });
    });
    var Ht = function(n) {
        return {
            $: 0,
            a: n
        };
    }, Rt = {
        $: 1
    }, Ot = w, Nt = F3(function(n, r, t) {
        for(;;){
            if (-2 === t.$) return r;
            var e = t.d, u = n, a = A3(n, t.b, t.c, A3(Nt, n, r, t.e));
            n = u, r = a, t = e;
        }
    }), It = function(n) {
        return A3(Nt, F3(function(n, r, t) {
            return A2(Ot, b(n, r), t);
        }), h, n);
    }, Vt = 1, Wt = 2, Zt = 0, Xt = function(n) {
        return {
            $: 1,
            a: n
        };
    }, Gt = F2(function(n, r) {
        return {
            $: 3,
            a: n,
            b: r
        };
    }), Jt = F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    }), Yt = F2(function(n, r) {
        return {
            $: 1,
            a: n,
            b: r
        };
    }), Qt = function(n) {
        return {
            $: 0,
            a: n
        };
    }, Kt = function(n) {
        return {
            $: 2,
            a: n
        };
    }, ne = O, re = p, te = hn, ee = Z, ue = F2(function(n, r) {
        return A2(H, n, x(r));
    }), ae = F2(function(n, r) {
        return k(A2(M, n, r));
    }), ie = function(n) {
        return A2(ue, "\n    ", A2(ae, "\n", n));
    }, ce = F3(function(n, r, t) {
        for(;;){
            if (!t.b) return r;
            var e = t.b, u = n, a = A2(n, t.a, r);
            n = u, r = a, t = e;
        }
    }), oe = function(n) {
        return A3(ce, F2(function(n, r) {
            return r + 1;
        }), 0, n);
    }, fe = y, se = l, le = F3(function(n, r, t) {
        for(;;){
            if (s(n, r) >= 1) return t;
            var e = n, u = r - 1, a = A2(Ot, r, t);
            n = e, r = u, t = a;
        }
    }), de = F2(function(n, r) {
        return A3(le, n, r, h);
    }), be = F2(function(n, r) {
        return A3(fe, n, A2(de, 0, oe(r) - 1), r);
    }), ve = function(n) {
        var r = n.charCodeAt(0);
        return 55296 > r || r > 56319 ? r : 1024 * (r - 55296) + n.charCodeAt(1) - 56320 + 65536;
    }, me = function(n) {
        var r = ve(n);
        return r >= 97 && 122 >= r;
    }, pe = function(n) {
        var r = ve(n);
        return 90 >= r && r >= 65;
    }, $e = function(n) {
        return me(n) || pe(n);
    }, he = function(n) {
        var r = ve(n);
        return 57 >= r && r >= 48;
    }, ge = function(n) {
        return me(n) || pe(n) || he(n);
    }, we = function(n) {
        return A3(ce, Ot, h, n);
    }, ke = function(n) {
        var r = n.charCodeAt(0);
        return isNaN(r) ? Rt : Ht(55296 > r || r > 56319 ? b(n[0], n.slice(1)) : b(n[0] + n[1], n.slice(2)));
    }, xe = F2(function(n, r) {
        return "\n\n(" + ee(n + 1) + ") " + ie(ye(r));
    }), ye = function(n) {
        return A2(_e, n, h);
    }, _e = F2(function(n, r) {
        n: for(;;)switch(n.$){
            case 0:
                var t = n.a, e = n.b, u = function() {
                    var n = ke(t);
                    if (1 === n.$) return !1;
                    var r = n.a, e = r.b;
                    return $e(r.a) && A2(ne, ge, e);
                }();
                n = e, r = A2(Ot, u ? "." + t : "['" + t + "']", r);
                continue n;
            case 1:
                e = n.b;
                var a = "[" + ee(n.a) + "]";
                n = e, r = A2(Ot, a, r);
                continue n;
            case 2:
                var i = n.a;
                if (i.b) {
                    if (i.b.b) {
                        var c = (r.b ? "The Json.Decode.oneOf at json" + A2(ue, "", we(r)) : "Json.Decode.oneOf") + " failed in the following " + ee(oe(i)) + " ways:";
                        return A2(ue, "\n\n", A2(Ot, c, A2(be, xe, i)));
                    }
                    n = e = i.a;
                    continue n;
                }
                return "Ran into a Json.Decode.oneOf with no possibilities" + (r.b ? " at json" + A2(ue, "", we(r)) : "!");
            default:
                var o = n.a, f = n.b;
                return (c = r.b ? "Problem with the value at json" + A2(ue, "", we(r)) + ":\n\n    " : "Problem with the given value:\n\n") + ie(A2(te, 4, f)) + "\n\n" + o;
        }
    }), Ce = 32, De = F4(function(n, r, t, e) {
        return {
            $: 0,
            a: n,
            b: r,
            c: t,
            d: e
        };
    }), Ae = [], qe = B, Be = F2(function(n, r) {
        return z(r) / z(n);
    }), je = qe(A2(Be, 2, Ce)), Se = A4(De, 0, je, Ae, Ae), ze = t, Ue = function(n) {
        return {
            $: 1,
            a: n
        };
    }, Ee = F2(function(n, r) {
        return n(r);
    }), Pe = F2(function(n, r) {
        return r(n);
    }), Te = o, Fe = j, Le = function(n) {
        return n.length;
    }, Me = F2(function(n, r) {
        return s(n, r) > 0 ? n : r;
    }), He = D, Re = e, Oe = F2(function(n, r) {
        for(;;){
            var t = A2(Re, Ce, n), e = t.b, u = A2(Ot, {
                $: 0,
                a: t.a
            }, r);
            if (!e.b) return we(u);
            n = e, r = u;
        }
    }), Ne = function(n) {
        return n.a;
    }, Ie = F2(function(n, r) {
        for(;;){
            var t = qe(r / Ce);
            if (1 === t) return A2(Re, Ce, n).a;
            n = A2(Oe, n, h), r = t;
        }
    }), Ve = F2(function(n, r) {
        if (r.C) {
            var t = r.C * Ce, e = Fe(A2(Be, Ce, t - 1)), u = n ? we(r.L) : r.L, a = A2(Ie, u, r.C);
            return A4(De, Le(r.H) + t, A2(Me, 5, e * je), a, r.H);
        }
        return A4(De, Le(r.H), je, Ae, r.H);
    }), We = F5(function(n, r, t, e, u) {
        for(;;){
            if (0 > r) return A2(Ve, !1, {
                L: e,
                C: t / Ce | 0,
                H: u
            });
            var a = Ue(A3(ze, Ce, r, n));
            r -= Ce, e = A2(Ot, a, e);
        }
    }), Ze = F2(function(n, r) {
        if (n > 0) {
            var t = n % Ce;
            return A5(We, r, n - t - Ce, n, h, A3(ze, t, n - t, r));
        }
        return Se;
    }), Xe = function(n) {
        return !n.$;
    }, Ge = en, Je = F3(function(n, r, t) {
        return r(n(t));
    }), Ye = un, Qe = an, Ke = function(n) {
        return {
            $: 0,
            a: n
        };
    }, nu = function(n) {
        switch(n.$){
            case 0:
                return 0;
            case 1:
                return 1;
            case 2:
                return 2;
            default:
                return 3;
        }
    }, ru = function(n) {
        return n;
    }, tu = ru, eu = F6(function(n, r, t, e, u, a) {
        return {
            zu: a,
            zG: r,
            BJ: e,
            uc: t,
            uD: n,
            iu: u
        };
    }), uu = N, au = function(n) {
        return n.length;
    }, iu = R, cu = F2(function(n, r) {
        return 1 > n ? r : A3(iu, n, au(r), r);
    }), ou = W, fu = function(n) {
        return "" === n;
    }, su = F2(function(n, r) {
        return 1 > n ? "" : A3(iu, 0, n, r);
    }), lu = function(n) {
        for(var r = 0, t = n.charCodeAt(0), e = 43 == t || 45 == t ? 1 : 0, u = e; n.length > u; ++u){
            var a = n.charCodeAt(u);
            if (48 > a || a > 57) return Rt;
            r = 10 * r + a - 48;
        }
        return u == e ? Rt : Ht(45 == t ? -r : r);
    }, du = F5(function(n, r, t, e, u) {
        if (fu(u) || A2(uu, "@", u)) return Rt;
        var a = A2(ou, ":", u);
        if (a.b) {
            if (a.b.b) return Rt;
            var i = a.a, c = lu(A2(cu, i + 1, u));
            if (1 === c.$) return Rt;
            var o = c;
            return Ht(A6(eu, n, A2(su, i, u), o, r, t, e));
        }
        return Ht(A6(eu, n, u, Rt, r, t, e));
    }), bu = F4(function(n, r, t, e) {
        if (fu(e)) return Rt;
        var u = A2(ou, "/", e);
        if (u.b) {
            var a = u.a;
            return A5(du, n, A2(cu, a, e), r, t, A2(su, a, e));
        }
        return A5(du, n, "/", r, t, e);
    }), vu = F3(function(n, r, t) {
        if (fu(t)) return Rt;
        var e = A2(ou, "?", t);
        if (e.b) {
            var u = e.a;
            return A4(bu, n, Ht(A2(cu, u + 1, t)), r, A2(su, u, t));
        }
        return A4(bu, n, Rt, r, t);
    }), mu = F2(function(n, r) {
        if (fu(r)) return Rt;
        var t = A2(ou, "#", r);
        if (t.b) {
            var e = t.a;
            return A3(vu, n, Ht(A2(cu, e + 1, r)), A2(su, e, r));
        }
        return A3(vu, n, Rt, r);
    }), pu = I, $u = function(n) {
        return A2(pu, "http://", n) ? A2(mu, 0, A2(cu, 7, n)) : A2(pu, "https://", n) ? A2(mu, 1, A2(cu, 8, n)) : Rt;
    }, hu = function() {
        for(;;);
    }, gu = kn, wu = gu(0), ku = F4(function(n, r, t, e) {
        if (e.b) {
            var u = e.a, a = e.b;
            if (a.b) {
                var i = a.a, c = a.b;
                if (c.b) {
                    var o = c.a, f = c.b;
                    if (f.b) {
                        var s = f.b;
                        return A2(n, u, A2(n, i, A2(n, o, A2(n, f.a, t > 500 ? A3(ce, n, r, we(s)) : A4(ku, n, r, t + 1, s)))));
                    }
                    return A2(n, u, A2(n, i, A2(n, o, r)));
                }
                return A2(n, u, A2(n, i, r));
            }
            return A2(n, u, r);
        }
        return r;
    }), xu = F3(function(n, r, t) {
        return A4(ku, n, r, 0, t);
    }), yu = F2(function(n, r) {
        return A3(xu, F2(function(r, t) {
            return A2(Ot, n(r), t);
        }), h, r);
    }), _u = _n, Cu = F2(function(n, r) {
        return A2(_u, function(r) {
            return gu(n(r));
        }, r);
    }), Du = F3(function(n, r, t) {
        return A2(_u, function(r) {
            return A2(_u, function(t) {
                return gu(A2(n, r, t));
            }, t);
        }, r);
    }), Au = function(n) {
        return A3(xu, Du(Ot), gu(h), n);
    }, qu = Mn, Bu = F2(function(n, r) {
        var t = r;
        return qn(A2(_u, qu(n), t));
    });
    Tn.Task = Fn(wu, F3(function(n, r) {
        return A2(Cu, function() {
            return 0;
        }, Au(A2(yu, Bu(n), r)));
    }), F3(function() {
        return gu(0);
    }), F2(function(n, r) {
        return A2(Cu, n, r);
    }));
    var ju, Su, zu, Uu = Rn("Task"), Eu = F2(function(n, r) {
        return Uu(A2(Cu, n, r));
    }), Pu = Ir, Tu = nn, Fu = F3(function(n, r, t) {
        return {
            eP: t,
            a3: r,
            CJ: n
        };
    }), Lu = function(n) {
        return {
            $: 3,
            a: n
        };
    }, Mu = function(n) {
        return {
            $: 2,
            a: n
        };
    }, Hu = On, Ru = {
        $: 2
    }, Ou = F5(function(n, r, t, e, u) {
        return {
            cx: e,
            BD: t,
            cc: r,
            w5: u,
            cX: n
        };
    }), Nu = function(n) {
        return n.b && ("" !== n.a || n.b.b) ? A2(Ot, n.a, Nu(n.b)) : h;
    }, Iu = F2(function(n, r) {
        return Ht(1 === r.$ ? k([
            n
        ]) : A2(Ot, n, r.a));
    }), Vu = function(n) {
        try {
            return Ht(decodeURIComponent(n));
        } catch (n) {
            return Rt;
        }
    }, Wu = d, Zu = F2(function(n, r) {
        n: for(;;){
            if (-2 === r.$) return Rt;
            var t = r.c, e = r.d, u = r.e;
            switch(A2(Wu, n, r.b)){
                case 0:
                    r = e;
                    continue n;
                case 1:
                    return Ht(t);
                default:
                    r = u;
                    continue n;
            }
        }
    }), Xu = F5(function(n, r, t, e, u) {
        return {
            $: -1,
            a: n,
            b: r,
            c: t,
            d: e,
            e: u
        };
    }), Gu = {
        $: -2
    }, Ju = F5(function(n, r, t, e, u) {
        if (-1 !== u.$ || u.a) {
            if (-1 !== e.$ || e.a || -1 !== e.d.$ || e.d.a) return A5(Xu, n, r, t, e, u);
            var a = e.d;
            return i = e.e, A5(Xu, 0, e.b, e.c, A5(Xu, 1, a.b, a.c, a.d, a.e), A5(Xu, 1, r, t, i, u));
        }
        var i, c = u.b, o = u.c, f = u.d, s = u.e;
        return -1 !== e.$ || e.a ? A5(Xu, n, c, o, A5(Xu, 0, r, t, e, f), s) : A5(Xu, 0, r, t, A5(Xu, 1, e.b, e.c, e.d, i = e.e), A5(Xu, 1, c, o, f, s));
    }), Yu = F3(function(n, r, t) {
        if (-2 === t.$) return A5(Xu, 0, n, r, Gu, Gu);
        var e = t.a, u = t.b, a = t.c, i = t.d, c = t.e;
        switch(A2(Wu, n, u)){
            case 0:
                return A5(Ju, e, u, a, A3(Yu, n, r, i), c);
            case 1:
                return A5(Xu, e, u, r, i, c);
            default:
                return A5(Ju, e, u, a, i, A3(Yu, n, r, c));
        }
    }), Qu = F3(function(n, r, t) {
        var e = A3(Yu, n, r, t);
        return -1 !== e.$ || e.a ? e : A5(Xu, 1, e.b, e.c, e.d, e.e);
    }), Ku = function(n) {
        if (-1 === n.$ && -1 === n.d.$ && -1 === n.e.$) {
            if (-1 !== n.e.d.$ || n.e.d.a) {
                var r = n.d, t = n.e;
                return i = t.b, c = t.c, e = t.d, s = t.e, A5(Xu, 1, n.b, n.c, A5(Xu, 0, r.b, r.c, r.d, r.e), A5(Xu, 0, i, c, e, s));
            }
            var e, u = n.d, a = n.e, i = a.b, c = a.c, o = (e = a.d).d, f = e.e, s = a.e;
            return A5(Xu, 0, e.b, e.c, A5(Xu, 1, n.b, n.c, A5(Xu, 0, u.b, u.c, u.d, u.e), o), A5(Xu, 1, i, c, f, s));
        }
        return n;
    }, na = function(n) {
        if (-1 === n.$ && -1 === n.d.$ && -1 === n.e.$) {
            if (-1 !== n.d.d.$ || n.d.d.a) {
                var r = n.d, t = n.e;
                return f = t.b, s = t.c, l = t.d, d = t.e, A5(Xu, 1, e = n.b, u = n.c, A5(Xu, 0, r.b, r.c, r.d, c = r.e), A5(Xu, 0, f, s, l, d));
            }
            var e = n.b, u = n.c, a = n.d, i = a.d, c = a.e, o = n.e, f = o.b, s = o.c, l = o.d, d = o.e;
            return A5(Xu, 0, a.b, a.c, A5(Xu, 1, i.b, i.c, i.d, i.e), A5(Xu, 1, e, u, c, A5(Xu, 0, f, s, l, d)));
        }
        return n;
    }, ra = F7(function(n, r, t, e, u, a, i) {
        if (-1 !== a.$ || a.a) {
            n: for(;;){
                if (-1 === i.$ && 1 === i.a) {
                    if (-1 === i.d.$) {
                        if (1 === i.d.a) return na(r);
                        break n;
                    }
                    return na(r);
                }
                break n;
            }
            return r;
        }
        return A5(Xu, t, a.b, a.c, a.d, A5(Xu, 0, e, u, a.e, i));
    }), ta = function(n) {
        if (-1 === n.$ && -1 === n.d.$) {
            var r = n.a, t = n.b, e = n.c, u = n.d, a = u.d, i = n.e;
            if (1 === u.a) {
                if (-1 !== a.$ || a.a) {
                    var c = Ku(n);
                    if (-1 === c.$) {
                        var o = c.e;
                        return A5(Ju, c.a, c.b, c.c, ta(c.d), o);
                    }
                    return Gu;
                }
                return A5(Xu, r, t, e, ta(u), i);
            }
            return A5(Xu, r, t, e, ta(u), i);
        }
        return Gu;
    }, ea = F2(function(n, r) {
        if (-2 === r.$) return Gu;
        var t = r.a, e = r.b, u = r.c, a = r.d, i = r.e;
        if (0 > s(n, e)) {
            if (-1 === a.$ && 1 === a.a) {
                var c = a.d;
                if (-1 !== c.$ || c.a) {
                    var o = Ku(r);
                    if (-1 === o.$) {
                        var f = o.e;
                        return A5(Ju, o.a, o.b, o.c, A2(ea, n, o.d), f);
                    }
                    return Gu;
                }
                return A5(Xu, t, e, u, A2(ea, n, a), i);
            }
            return A5(Xu, t, e, u, A2(ea, n, a), i);
        }
        return A2(ua, n, A7(ra, n, r, t, e, u, a, i));
    }), ua = F2(function(n, r) {
        if (-1 === r.$) {
            var t = r.a, e = r.b, u = r.c, a = r.d, c = r.e;
            if (i(n, e)) {
                var o = function(n) {
                    for(;;){
                        if (-1 !== n.$ || -1 !== n.d.$) return n;
                        n = n.d;
                    }
                }(c);
                return -1 === o.$ ? A5(Ju, t, o.b, o.c, a, ta(c)) : Gu;
            }
            return A5(Ju, t, e, u, a, A2(ea, n, c));
        }
        return Gu;
    }), aa = F2(function(n, r) {
        var t = A2(ea, n, r);
        return -1 !== t.$ || t.a ? t : A5(Xu, 1, t.b, t.c, t.d, t.e);
    }), ia = F3(function(n, r, t) {
        var e = r(A2(Zu, n, t));
        return e.$ ? A2(aa, n, t) : A3(Qu, n, e.a, t);
    }), ca = F2(function(n, r) {
        var t = A2(ae, "=", n);
        if (t.b && t.b.b && !t.b.b.b) {
            var e = t.b.a, u = Vu(t.a);
            if (1 === u.$) return r;
            var a = u.a, i = Vu(e);
            return 1 === i.$ ? r : A3(ia, a, Iu(i.a), r);
        }
        return r;
    }), oa = Gu, fa = F2(function(n, r) {
        var t;
        return function(n) {
            n: for(;;){
                if (n.b) {
                    var r = n.a, t = r.cc;
                    if (t.b) {
                        if ("" !== t.a || t.b.b) {
                            n = n.b;
                            continue n;
                        }
                        return Ht(r.w5);
                    }
                    return Ht(r.w5);
                }
                return Rt;
            }
        }(n(A5(Ou, h, function(n) {
            var r = A2(ae, "/", n);
            return Nu(r.b && "" === r.a ? r.b : r);
        }(r.BJ), 1 === (t = r.iu).$ ? oa : A3(xu, ca, oa, A2(ae, "&", t.a)), r.zu, ru)));
    }), sa = {
        $: 12
    }, la = function(n) {
        return {
            $: 76,
            a: n
        };
    }, da = function(n) {
        return {
            $: 77,
            a: n
        };
    }, ba = function(n) {
        return {
            $: 78,
            a: n
        };
    }, va = {
        $: 13
    }, ma = function(n) {
        return {
            $: 89,
            a: n
        };
    }, pa = function(n) {
        return {
            $: 90,
            a: n
        };
    }, $a = {
        $: 14
    }, ha = {
        $: 15
    }, ga = {
        $: 16
    }, wa = {
        $: 17
    }, ka = {
        $: 18
    }, xa = function(n) {
        return {
            $: 70,
            a: n
        };
    }, ya = {
        $: 19
    }, _a = function(n) {
        return {
            $: 71,
            a: n
        };
    }, Ca = function(n) {
        return {
            $: 79,
            a: n
        };
    }, Da = {
        $: 20
    }, Aa = function(n) {
        return {
            $: 72,
            a: n
        };
    }, qa = function(n) {
        return {
            $: 80,
            a: n
        };
    }, Ba = function(n) {
        return {
            $: 81,
            a: n
        };
    }, ja = {
        $: 21
    }, Sa = function(n) {
        return {
            $: 73,
            a: n
        };
    }, za = function(n) {
        return {
            $: 82,
            a: n
        };
    }, Ua = function(n) {
        return {
            $: 83,
            a: n
        };
    }, Ea = {
        $: 22
    }, Pa = {
        $: 59
    }, Ta = {
        $: 23
    }, Fa = function(n) {
        return {
            $: 74,
            a: n
        };
    }, La = function(n) {
        return {
            $: 84,
            a: n
        };
    }, Ma = {
        $: 24
    }, Ha = function(n) {
        return {
            $: 75,
            a: n
        };
    }, Ra = function(n) {
        return {
            $: 85,
            a: n
        };
    }, Oa = function(n) {
        return {
            $: 86,
            a: n
        };
    }, Na = {
        $: 25
    }, Ia = {
        $: 26
    }, Va = function(n) {
        return {
            $: 55,
            a: n
        };
    }, Wa = {
        $: 6
    }, Za = function(n) {
        return {
            $: 60,
            a: n
        };
    }, Xa = function(n) {
        return {
            $: 56,
            a: n
        };
    }, Ga = function(n) {
        return {
            $: 87,
            a: n
        };
    }, Ja = function(n) {
        return {
            $: 88,
            a: n
        };
    }, Ya = {
        $: 27
    }, Qa = {
        $: 7
    }, Ka = function(n) {
        return {
            $: 57,
            a: n
        };
    }, ni = {
        $: 8
    }, ri = {
        $: 1
    }, ti = {
        $: 9
    }, ei = {
        $: 28
    }, ui = {
        $: 29
    }, ai = {
        $: 30
    }, ii = {
        $: 3
    }, ci = function(n) {
        return {
            $: 61,
            a: n
        };
    }, oi = function(n) {
        return {
            $: 62,
            a: n
        };
    }, fi = function(n) {
        return {
            $: 63,
            a: n
        };
    }, si = function(n) {
        return {
            $: 64,
            a: n
        };
    }, li = function(n) {
        return {
            $: 65,
            a: n
        };
    }, di = function(n) {
        return {
            $: 66,
            a: n
        };
    }, bi = function(n) {
        return {
            $: 67,
            a: n
        };
    }, vi = function(n) {
        return {
            $: 68,
            a: n
        };
    }, mi = function(n) {
        return {
            $: 69,
            a: n
        };
    }, pi = function(n) {
        return {
            $: 58,
            a: n
        };
    }, $i = {
        $: 10
    }, hi = {
        $: 31
    }, gi = {
        $: 32
    }, wi = {
        $: 33
    }, ki = {
        $: 34
    }, xi = {
        $: 35
    }, yi = {
        $: 36
    }, _i = {
        $: 37
    }, Ci = {
        $: 38
    }, Di = {
        $: 39
    }, Ai = {
        $: 40
    }, qi = {
        $: 41
    }, Bi = {
        $: 42
    }, ji = {
        $: 43
    }, Si = {
        $: 44
    }, zi = {
        $: 45
    }, Ui = {
        $: 46
    }, Ei = {
        $: 47
    }, Pi = {
        $: 48
    }, Ti = {
        $: 49
    }, Fi = {
        $: 50
    }, Li = {
        $: 51
    }, Mi = {
        $: 52
    }, Hi = {
        $: 53
    }, Ri = {
        $: 11
    }, Oi = {
        $: 54
    }, Ni = {
        $: 4
    }, Ii = {
        $: 0
    }, Vi = {
        $: 5
    }, Wi = F2(function(n, r) {
        return A5(Ou, r.cX, r.cc, r.BD, r.cx, n(r.w5));
    }), Zi = F2(function(n, r) {
        var t = r;
        return function(r) {
            var e = r.cX, u = r.cc, a = r.BD, i = r.cx;
            return A2(yu, Wi(r.w5), t(A5(Ou, e, u, a, i, n)));
        };
    }), Xi = F2(function(n, r) {
        return r.b ? A3(xu, Ot, r, n) : n;
    }), Gi = function(n) {
        return A3(xu, Xi, h, n);
    }, Ji = F2(function(n, r) {
        return Gi(A2(yu, n, r));
    }), Yi = function(n) {
        return function(r) {
            var t = r.cX, e = r.cc, u = r.BD, a = r.cx, c = r.w5;
            if (e.b) {
                var o = e.a, f = e.b;
                return i(o, n) ? k([
                    A5(Ou, A2(Ot, o, t), f, u, a, c)
                ]) : h;
            }
            return h;
        };
    }, Qi = F2(function(n, r) {
        var t = n, e = r;
        return function(n) {
            return A2(Ji, e, t(n));
        };
    }), Ki = F2(function(n, r) {
        return function(n) {
            var t = n.cX, e = n.cc, u = n.BD, a = n.cx, i = n.w5;
            if (e.b) {
                var c = e.a, o = e.b, f = r(c);
                if (f.$) return h;
                var s = f.a;
                return k([
                    A5(Ou, A2(Ot, c, t), o, u, a, i(s))
                ]);
            }
            return h;
        };
    }), nc = A2(Ki, "STRING", Ht), rc = function(n) {
        return k([
            n
        ]);
    }, tc = (ju = k([
        A2(Zi, Ii, rc),
        A2(Zi, ri, Yi("enroll-thanks")),
        A2(Zi, Ru, Yi("not-found")),
        A2(Zi, ii, Yi("patient-documents")),
        A2(Zi, Ni, Yi("thanks")),
        A2(Zi, Vi, Yi("waitlist")),
        A2(Zi, Wa, Yi("account")),
        A2(Zi, Qa, Yi("booking")),
        A2(Zi, ni, Yi("checkout")),
        A2(Zi, ti, Yi("enroll")),
        A2(Zi, $i, Yi("signup")),
        A2(Zi, Ri, Yi("style-guide")),
        A2(Zi, sa, A2(Qi, Yi("account"), Yi("additional-services"))),
        A2(Zi, va, A2(Qi, Yi("account"), Yi("booking"))),
        A2(Zi, $a, A2(Qi, Yi("account"), Yi("cart"))),
        A2(Zi, ha, A2(Qi, Yi("account"), Yi("chat"))),
        A2(Zi, ga, A2(Qi, Yi("account"), Yi("documents"))),
        A2(Zi, wa, A2(Qi, Yi("account"), Yi("forbidden"))),
        A2(Zi, ka, A2(Qi, Yi("account"), Yi("health-information"))),
        A2(Zi, ya, A2(Qi, Yi("account"), Yi("invoices"))),
        A2(Zi, Da, A2(Qi, Yi("account"), Yi("members"))),
        A2(Zi, ja, A2(Qi, Yi("account"), Yi("memberships"))),
        A2(Zi, Ea, A2(Qi, Yi("account"), Yi("messaging"))),
        A2(Zi, Ta, A2(Qi, Yi("account"), Yi("not-found"))),
        A2(Zi, Ma, A2(Qi, Yi("account"), Yi("payment-sources"))),
        A2(Zi, Na, A2(Qi, Yi("account"), Yi("practitioner-location"))),
        A2(Zi, Ia, A2(Qi, Yi("account"), Yi("session-expired"))),
        A2(Zi, Ya, A2(Qi, Yi("booking"), Yi("empty"))),
        A2(Zi, ei, A2(Qi, Yi("login"), Yi("request"))),
        A2(Zi, ui, A2(Qi, Yi("login"), Yi("select-patient"))),
        A2(Zi, ai, A2(Qi, Yi("login"), Yi("verify-code"))),
        A2(Zi, hi, A2(Qi, Yi("style-guide"), Yi("activity-indicator"))),
        A2(Zi, gi, A2(Qi, Yi("style-guide"), Yi("address-input"))),
        A2(Zi, wi, A2(Qi, Yi("style-guide"), Yi("alerts"))),
        A2(Zi, ki, A2(Qi, Yi("style-guide"), Yi("api-select"))),
        A2(Zi, xi, A2(Qi, Yi("style-guide"), Yi("button"))),
        A2(Zi, yi, A2(Qi, Yi("style-guide"), Yi("card-example"))),
        A2(Zi, _i, A2(Qi, Yi("style-guide"), Yi("checkbox"))),
        A2(Zi, Ci, A2(Qi, Yi("style-guide"), Yi("filter-example"))),
        A2(Zi, Di, A2(Qi, Yi("style-guide"), Yi("form-example"))),
        A2(Zi, Ai, A2(Qi, Yi("style-guide"), Yi("grid"))),
        A2(Zi, qi, A2(Qi, Yi("style-guide"), Yi("input"))),
        A2(Zi, Bi, A2(Qi, Yi("style-guide"), Yi("insurance-info"))),
        A2(Zi, ji, A2(Qi, Yi("style-guide"), Yi("modal"))),
        A2(Zi, Si, A2(Qi, Yi("style-guide"), Yi("multi-form"))),
        A2(Zi, zi, A2(Qi, Yi("style-guide"), Yi("phone-input"))),
        A2(Zi, Ui, A2(Qi, Yi("style-guide"), Yi("radio"))),
        A2(Zi, Ei, A2(Qi, Yi("style-guide"), Yi("searchable-select"))),
        A2(Zi, Pi, A2(Qi, Yi("style-guide"), Yi("select"))),
        A2(Zi, Ti, A2(Qi, Yi("style-guide"), Yi("table"))),
        A2(Zi, Fi, A2(Qi, Yi("style-guide"), Yi("tabs"))),
        A2(Zi, Li, A2(Qi, Yi("style-guide"), Yi("tag"))),
        A2(Zi, Mi, A2(Qi, Yi("style-guide"), Yi("toggle"))),
        A2(Zi, Hi, A2(Qi, Yi("style-guide"), Yi("tooltip"))),
        A2(Zi, Oi, A2(Qi, Yi("style-guide"), Yi("typography"))),
        A2(Zi, Va, A2(Zi, function(n) {
            return {
                wL: n
            };
        }, A2(Qi, Yi("account"), nc))),
        A2(Zi, Xa, A2(Zi, function(n) {
            return {
                wL: n
            };
        }, A2(Qi, Yi("bills"), nc))),
        A2(Zi, Ka, A2(Zi, function(n) {
            return {
                v2: n
            };
        }, A2(Qi, Yi("checkout"), nc))),
        A2(Zi, pi, A2(Zi, function(n) {
            return {
                v2: n
            };
        }, A2(Qi, Yi("signup"), nc))),
        A2(Zi, Pa, A2(Qi, Yi("account"), A2(Qi, Yi("messaging"), Yi("chat")))),
        A2(Zi, Za, A2(Zi, function(n) {
            return {
                a9: n
            };
        }, A2(Qi, Yi("appointments"), A2(Qi, nc, Yi("cancellation-policy"))))),
        A2(Zi, ci, A2(Zi, function(n) {
            return {
                v2: n
            };
        }, A2(Qi, Yi("signup"), A2(Qi, nc, Yi("additional-details"))))),
        A2(Zi, oi, A2(Zi, function(n) {
            return {
                v2: n
            };
        }, A2(Qi, Yi("signup"), A2(Qi, nc, Yi("confirmation"))))),
        A2(Zi, fi, A2(Zi, function(n) {
            return {
                v2: n
            };
        }, A2(Qi, Yi("signup"), A2(Qi, nc, Yi("contacts"))))),
        A2(Zi, si, A2(Zi, function(n) {
            return {
                v2: n
            };
        }, A2(Qi, Yi("signup"), A2(Qi, nc, Yi("custom-details"))))),
        A2(Zi, li, A2(Zi, function(n) {
            return {
                v2: n
            };
        }, A2(Qi, Yi("signup"), A2(Qi, nc, Yi("location"))))),
        A2(Zi, di, A2(Zi, function(n) {
            return {
                v2: n
            };
        }, A2(Qi, Yi("signup"), A2(Qi, nc, Yi("members"))))),
        A2(Zi, bi, A2(Zi, function(n) {
            return {
                v2: n
            };
        }, A2(Qi, Yi("signup"), A2(Qi, nc, Yi("membership"))))),
        A2(Zi, vi, A2(Zi, function(n) {
            return {
                v2: n
            };
        }, A2(Qi, Yi("signup"), A2(Qi, nc, Yi("provider"))))),
        A2(Zi, mi, A2(Zi, function(n) {
            return {
                v2: n
            };
        }, A2(Qi, Yi("signup"), A2(Qi, nc, Yi("thanks"))))),
        A2(Zi, xa, A2(Zi, function(n) {
            return {
                qU: n
            };
        }, A2(Qi, Yi("account"), A2(Qi, Yi("health-information"), nc)))),
        A2(Zi, _a, A2(Zi, function(n) {
            return {
                qU: n
            };
        }, A2(Qi, Yi("account"), A2(Qi, Yi("invoices"), nc)))),
        A2(Zi, Aa, A2(Zi, function(n) {
            return {
                qU: n
            };
        }, A2(Qi, Yi("account"), A2(Qi, Yi("members"), nc)))),
        A2(Zi, Sa, A2(Zi, function(n) {
            return {
                qU: n
            };
        }, A2(Qi, Yi("account"), A2(Qi, Yi("memberships"), nc)))),
        A2(Zi, Fa, A2(Zi, function(n) {
            return {
                qU: n
            };
        }, A2(Qi, Yi("account"), A2(Qi, Yi("packages"), nc)))),
        A2(Zi, Ha, A2(Zi, function(n) {
            return {
                qU: n
            };
        }, A2(Qi, Yi("account"), A2(Qi, Yi("payment-sources"), nc)))),
        A2(Zi, la, A2(Zi, function(n) {
            return {
                a9: n
            };
        }, A2(Qi, Yi("account"), A2(Qi, Yi("appointments"), A2(Qi, nc, Yi("cancel")))))),
        A2(Zi, da, A2(Zi, function(n) {
            return {
                a9: n
            };
        }, A2(Qi, Yi("account"), A2(Qi, Yi("appointments"), A2(Qi, nc, Yi("cancel-appointment")))))),
        A2(Zi, ba, A2(Zi, function(n) {
            return {
                a9: n
            };
        }, A2(Qi, Yi("account"), A2(Qi, Yi("appointments"), A2(Qi, nc, Yi("reschedule")))))),
        A2(Zi, Ca, A2(Zi, function(n) {
            return {
                qU: n
            };
        }, A2(Qi, Yi("account"), A2(Qi, Yi("invoices"), A2(Qi, nc, Yi("payment")))))),
        A2(Zi, qa, A2(Zi, function(n) {
            return {
                qU: n
            };
        }, A2(Qi, Yi("account"), A2(Qi, Yi("members"), A2(Qi, nc, Yi("edit")))))),
        A2(Zi, Ba, A2(Zi, function(n) {
            return {
                qU: n
            };
        }, A2(Qi, Yi("account"), A2(Qi, Yi("members"), A2(Qi, nc, Yi("emergency-contact")))))),
        A2(Zi, za, A2(Zi, function(n) {
            return {
                qU: n
            };
        }, A2(Qi, Yi("account"), A2(Qi, Yi("memberships"), A2(Qi, nc, Yi("add-member")))))),
        A2(Zi, Ua, A2(Zi, function(n) {
            return {
                qU: n
            };
        }, A2(Qi, Yi("account"), A2(Qi, Yi("memberships"), A2(Qi, nc, Yi("renew")))))),
        A2(Zi, La, A2(Zi, function(n) {
            return {
                qU: n
            };
        }, A2(Qi, Yi("account"), A2(Qi, Yi("packages"), A2(Qi, nc, Yi("checkout")))))),
        A2(Zi, Ra, A2(Zi, function(n) {
            return {
                qU: n
            };
        }, A2(Qi, Yi("account"), A2(Qi, Yi("payment-sources"), A2(Qi, nc, Yi("edit")))))),
        A2(Zi, Oa, A2(Zi, function(n) {
            return {
                qU: n
            };
        }, A2(Qi, Yi("account"), A2(Qi, Yi("plans"), A2(Qi, nc, Yi("checkout")))))),
        A2(Zi, Ga, A2(Zi, F2(function(n, r) {
            return {
                mp: n,
                mY: r
            };
        }), A2(Qi, Yi("booking"), A2(Qi, nc, A2(Qi, Yi("location"), A2(Qi, nc, Yi("date"))))))),
        A2(Zi, Ja, A2(Zi, F2(function(n, r) {
            return {
                mp: n,
                mY: r
            };
        }), A2(Qi, Yi("booking"), A2(Qi, nc, A2(Qi, Yi("location"), A2(Qi, nc, Yi("enter-info"))))))),
        A2(Zi, ma, A2(Zi, F2(function(n, r) {
            return {
                mp: n,
                mY: r
            };
        }), A2(Qi, Yi("account"), A2(Qi, Yi("booking"), A2(Qi, nc, A2(Qi, Yi("location"), A2(Qi, nc, Yi("date")))))))),
        A2(Zi, pa, A2(Zi, F2(function(n, r) {
            return {
                mp: n,
                mY: r
            };
        }), A2(Qi, Yi("account"), A2(Qi, Yi("booking"), A2(Qi, nc, A2(Qi, Yi("location"), A2(Qi, nc, Yi("enter-info"))))))))
    ]), function(n) {
        return A2(Ji, function(r) {
            return r(n);
        }, ju);
    }), ec = fa(tc), uc = F2(function(n, r) {
        return r.$ ? n : r.a;
    }), ac = A2(Je, ec, uc(Ru)), ic = function(n) {
        return {
            $: 2,
            a: n
        };
    }, cc = {
        $: 0
    }, oc = {
        $: 0
    }, fc = function(n) {
        return {
            $: 13,
            a: n
        };
    }, sc = F3(function(n, r, t) {
        return n(r(t));
    }), lc = Cn, dc = F2(function(n, r) {
        return Uu(A2(lc, A2(sc, A2(sc, gu, n), Xt), A2(_u, A2(sc, A2(sc, gu, n), Qt), r)));
    }), bc = function(n) {
        return {
            $: 0,
            a: n
        };
    }, vc = F4(function(n, r, t, e) {
        return bc({
            i: e,
            a8: r,
            aE: !0,
            bG: t,
            hK: 0,
            bw: n
        });
    }), mc = function(n) {
        return {
            $: 1,
            a: n
        };
    }, pc = F4(function(n, r, t, e) {
        return mc({
            i: e,
            a8: r,
            aE: !0,
            bG: t,
            bw: n
        });
    }), $c = F4(function(n, r, t, e) {
        return mc({
            i: e,
            a8: r,
            aE: !0,
            bG: t,
            bw: n
        });
    }), hc = F4(function(n, r, t, e) {
        return mc({
            i: e,
            a8: r,
            aE: !0,
            bG: t,
            bw: n
        });
    }), gc = F4(function(n, r, t, e) {
        return mc({
            i: e,
            a8: r,
            aE: !1,
            bG: t,
            bw: n
        });
    }), wc = function(n) {
        return {
            $: 1,
            a: n
        };
    }, kc = F2(function(n, r) {
        return {
            ou: r,
            aJ: n
        };
    }), xc = F2(function(n, r) {
        return {
            ll: n,
            lx: r
        };
    }), yc = F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    }), _c = yc, Cc = 2037, Dc = F5(function(n, r, t, e, u) {
        return {
            bK: u,
            oH: t,
            sN: r,
            Dn: e,
            xm: n
        };
    }), Ac = function(n) {
        return n.b;
    }, qc = q, Bc = F2(function(n, r) {
        var t = A2(qc, 7, function(n) {
            return A2(qc, 7, n) || 7;
        }(r) + 7 - function(n) {
            switch(n){
                case 0:
                    return 1;
                case 1:
                    return 2;
                case 2:
                    return 3;
                case 3:
                    return 4;
                case 4:
                    return 5;
                case 5:
                    return 6;
                default:
                    return 7;
            }
        }(n));
        return r - t;
    }), jc = F2(function(n, r) {
        var t = A2(Bc, n, r);
        return i(r, t) ? r : t + 7;
    }), Sc = f, zc = function(n) {
        return !A2(qc, 4, n) && !!A2(qc, 100, n) || !A2(qc, 400, n);
    }, Uc = F2(function(n, r) {
        var t = zc(n) ? 1 : 0;
        switch(r){
            case 0:
                return 0;
            case 1:
                return 31;
            case 2:
                return 59 + t;
            case 3:
                return 90 + t;
            case 4:
                return 120 + t;
            case 5:
                return 151 + t;
            case 6:
                return 181 + t;
            case 7:
                return 212 + t;
            case 8:
                return 243 + t;
            case 9:
                return 273 + t;
            case 10:
                return 304 + t;
            default:
                return 334 + t;
        }
    }), Ec = function(n) {
        var r = n - 1;
        return 365 * r + ((r / 4 | 0) - (r / 100 | 0) + (r / 400 | 0));
    }, Pc = F3(function(n, r, t) {
        return Ec(n) + A2(Uc, n, r) + t;
    }), Tc = F2(function(n, r) {
        return A3(xu, F2(function(r, t) {
            return n(r) ? A2(Ot, r, t) : t;
        }), h, r);
    }), Fc = F2(function(n, r) {
        switch(r){
            case 0:
            case 2:
            case 4:
            case 6:
            case 7:
            case 9:
            default:
                return 31;
            case 1:
                return zc(n) ? 29 : 28;
            case 3:
            case 5:
            case 8:
            case 10:
                return 30;
        }
    }), Lc = F2(function(n, r) {
        return Ec(n) + A2(Uc, n, r) + A2(Fc, n, r);
    }), Mc = function(n) {
        return 1440 * (n - 719163);
    }, Hc = _, Rc = F2(function(n, r) {
        var t = r.cb, e = r.Ct;
        switch(n){
            case 0:
                return 0;
            case 1:
                return 0 - t;
            default:
                return 0 - (t + e);
        }
    }), Oc = F2(function(n, r) {
        var t, e;
        return e = (t = r).Dn, Mc(A3(Pc, t.xm, t.sN, t.oH)) + e + A2(Rc, r.bK, n);
    }), Nc = F5(function(n, r, t, e, u) {
        var a = A2(Ji, function(n) {
            return A2(Hc, function(n) {
                return n.wc;
            }, A2(yu, function(r) {
                return {
                    bK: r.bK,
                    Ct: r.Ct,
                    wc: Mc(function() {
                        var t = r.oH;
                        switch(t.$){
                            case 0:
                                return A3(Pc, n, r.sN, t.a);
                            case 1:
                                return A2(jc, t.a, A3(Pc, n, r.sN, t.b));
                            case 2:
                                return A2(Bc, t.a, A3(Pc, n, r.sN, t.b));
                            default:
                                return A2(Bc, t.a, A2(Lc, n, r.sN));
                        }
                    }()) + r.Dn
                };
            }, A2(Tc, function(r) {
                return 1 > s(r.qq, n) && 1 > s(n, r.wE);
            }, u)));
        }, A2(de, r.xm - 1, t.xm)), i = {
            Ct: 0,
            cb: e
        }, c = {
            h3: e,
            wc: A2(Oc, n, r)
        }, o = A3(ce, F2(function(r, u) {
            var a = u.a, i = u.b, o = {
                Ct: r.Ct,
                cb: e
            };
            return 1 > s(r.wc + A2(Rc, r.bK, n), c.wc) ? b(o, k([
                {
                    h3: e + r.Ct,
                    wc: c.wc
                }
            ])) : 0 > s(r.wc + A2(Rc, r.bK, a), A2(Oc, a, t)) ? b(o, A2(Ot, {
                h3: e + r.Ct,
                wc: r.wc + A2(Rc, r.bK, a)
            }, i)) : b(a, i);
        }), b(i, k([
            c
        ])), a), f = o.a;
        return b(we(o.b), f);
    }), Ic = F4(function(n, r, t, e) {
        var u = e.ll, a = e.lx;
        if (a.$) return A5(Nc, n, r, t, u, a.a);
        var i = a.a;
        return b(k([
            {
                h3: u + i,
                wc: A2(Oc, n, r)
            }
        ]), {
            Ct: i,
            cb: u
        });
    }), Vc = F4(function(n, r, t, e) {
        for(;;){
            if (!e.b) return we(t);
            var u = e.a, a = e.b, c = n(u), o = i(r, c) ? t : A2(Ot, u, t);
            r = c, t = o, e = a;
        }
    }), Wc = F3(function(n, r, t) {
        var e = A3(ce, F2(function(n, r) {
            var t = n.b, e = r.b;
            return b(t, A2(Ot, v(r.a, n.a, t), e));
        }), b(n, h), t.aJ), u = e.b;
        return we(A2(Ot, v(e.a, t.ou, r), u));
    }), Zc = F3(function(n, r, t) {
        var e, u, a = (e = t.aJ).b ? e.a.a : t.ou, i = {
            Ct: (u = a.lx, u.$ ? 0 : u.a),
            cb: a.ll
        }, c = A4(Vc, function(n) {
            return n.h3;
        }, i.cb + i.Ct, h, A3(ce, F2(function(n, r) {
            var t = r.b, e = A4(Ic, r.a, n.a, n.c, n.b);
            return b(e.b, $(t, e.a));
        }), b(i, h), A3(Wc, A5(Dc, n, 0, 1, 0, 0), A5(Dc, r + 1, 0, 1, 0, 0), t)).b), o = function(n) {
            for(;;){
                var r = n.a, t = n.b;
                if (!t.b) return b(r, h);
                var e = t.a, u = t.b;
                if (e.wc > 0) return b(r, t);
                n = b(e.h3, u);
            }
        }(b(i.cb + i.Ct, c)), f = o.a;
        return b(we(o.b), f);
    }), Xc = function(n) {
        var r = A3(Zc, 1970, Cc, n);
        return A2(_c, r.b, r.a);
    }, Gc = function(n) {
        return -n;
    }, Jc = function(n) {
        return {
            $: 0,
            a: n
        };
    }, Yc = function(n) {
        return {
            $: 3,
            a: n
        };
    }, Qc = F2(function(n, r) {
        return {
            $: 1,
            a: n,
            b: r
        };
    }), Kc = F7(function(n, r, t, e, u, a, i) {
        return {
            bK: a,
            oH: e,
            qq: n,
            sN: t,
            Ct: i,
            Dn: u,
            wE: r
        };
    }), no = k([
        A7(Kc, 1967, 2006, 9, Yc(6), 120, 2, 0),
        A7(Kc, 1967, 1973, 3, Yc(6), 120, 2, 60),
        A7(Kc, 1974, 1974, 0, Jc(6), 120, 2, 60),
        A7(Kc, 1975, 1975, 1, Yc(6), 120, 2, 60),
        A7(Kc, 1976, 1986, 3, Yc(6), 120, 2, 60),
        A7(Kc, 1987, 2006, 3, A2(Qc, 6, 1), 120, 2, 60),
        A7(Kc, 2007, Cc, 2, A2(Qc, 6, 8), 120, 2, 60),
        A7(Kc, 2007, Cc, 10, A2(Qc, 6, 1), 120, 2, 0)
    ]), ro = function() {
        return Xc(A2(kc, h, A2(xc, -480, wc(no))));
    }, to = ro(), eo = {
        $: 0
    }, uo = xn, ao = yn(function(n) {
        try {
            var r = function(n) {
                return {
                    $: 0,
                    a: n
                };
            }(Intl.DateTimeFormat().resolvedOptions().timeZone);
        } catch (n) {
            r = function(n) {
                return {
                    $: 1,
                    a: n
                };
            }((new Date).getTimezoneOffset());
        }
        n(kn(r));
    }), io = function(n) {
        return {
            $: 0,
            a: n
        };
    }, co = function() {
        return Xc(A2(kc, h, A2(xc, 0, io(0))));
    }, oo = function() {
        return Xc(A2(kc, h, A2(xc, 180, io(0))));
    }, fo = oo, so = k([
        A7(Kc, 1971, 1971, 3, Jc(25), 1380, 1, 60),
        A7(Kc, 1971, 1971, 8, Jc(26), 1380, 1, 0),
        A7(Kc, 1977, 1977, 4, Jc(6), 0, 2, 60),
        A7(Kc, 1977, 1977, 9, Jc(21), 0, 2, 0),
        A7(Kc, 1978, 1978, 2, Jc(24), 60, 2, 60),
        A7(Kc, 1978, 1978, 8, Jc(22), 180, 2, 0),
        A7(Kc, 1980, 1980, 3, Jc(25), 0, 2, 60),
        A7(Kc, 1980, 1980, 9, Jc(31), 120, 2, 0)
    ]), lo = oo, bo = co, vo = function() {
        return Xc(A2(kc, h, A2(xc, 60, io(0))));
    }, mo = vo, po = co, $o = function() {
        return Xc(A2(kc, h, A2(xc, 120, io(0))));
    }, ho = $o, go = vo, wo = $o, ko = k([
        A7(Kc, 1959, 1981, 4, Jc(1), 60, 2, 60),
        A7(Kc, 1966, 1994, 9, Jc(1), 180, 2, 0),
        A7(Kc, 1982, 1982, 6, Jc(25), 60, 2, 60),
        A7(Kc, 1983, 1983, 6, Jc(12), 60, 2, 60),
        A7(Kc, 1984, 1988, 4, Jc(1), 60, 2, 60),
        A7(Kc, 1989, 1989, 4, Jc(6), 60, 2, 60),
        A7(Kc, 1990, 1994, 4, Jc(1), 60, 2, 60),
        A7(Kc, 1995, 2010, 3, Yc(4), 0, 1, 60),
        A7(Kc, 1995, 2005, 8, Yc(3), 1440, 2, 0),
        A7(Kc, 2006, 2006, 8, Jc(21), 1440, 2, 0),
        A7(Kc, 2007, 2007, 8, A2(Qc, 3, 1), 1440, 2, 0),
        A7(Kc, 2008, 2008, 7, Yc(3), 1440, 2, 0),
        A7(Kc, 2009, 2009, 7, Jc(20), 1440, 2, 0),
        A7(Kc, 2010, 2010, 7, Jc(10), 1440, 2, 0),
        A7(Kc, 2010, 2010, 8, Jc(9), 1440, 2, 60),
        A7(Kc, 2010, 2010, 8, Yc(3), 1440, 2, 0),
        A7(Kc, 2014, 2014, 4, Jc(15), 1440, 2, 60),
        A7(Kc, 2014, 2014, 5, Jc(26), 1440, 2, 0),
        A7(Kc, 2014, 2014, 6, Jc(31), 1440, 2, 60),
        A7(Kc, 2014, 2014, 8, Yc(3), 1440, 2, 0)
    ]), xo = k([
        A7(Kc, 1974, 1974, 5, Jc(24), 0, 2, 60),
        A7(Kc, 1974, 1974, 8, Jc(1), 0, 2, 0),
        A7(Kc, 1976, 1977, 4, Jc(1), 0, 2, 60),
        A7(Kc, 1976, 1976, 7, Jc(1), 0, 2, 0),
        A7(Kc, 1977, 1977, 8, Jc(28), 0, 2, 0),
        A7(Kc, 1978, 1978, 5, Jc(1), 0, 2, 60),
        A7(Kc, 1978, 1978, 7, Jc(4), 0, 2, 0),
        A7(Kc, 2008, 2008, 5, Jc(1), 0, 2, 60),
        A7(Kc, 2008, 2008, 8, Jc(1), 0, 2, 0),
        A7(Kc, 2009, 2009, 5, Jc(1), 0, 2, 60),
        A7(Kc, 2009, 2009, 7, Jc(21), 0, 2, 0),
        A7(Kc, 2010, 2010, 4, Jc(2), 0, 2, 60),
        A7(Kc, 2010, 2010, 7, Jc(8), 0, 2, 0),
        A7(Kc, 2011, 2011, 3, Jc(3), 0, 2, 60),
        A7(Kc, 2011, 2011, 6, Jc(31), 0, 2, 0),
        A7(Kc, 2012, 2013, 3, Yc(6), 120, 2, 60),
        A7(Kc, 2012, 2012, 6, Jc(20), 180, 2, 0),
        A7(Kc, 2012, 2012, 7, Jc(20), 120, 2, 60),
        A7(Kc, 2012, 2012, 8, Jc(30), 180, 2, 0),
        A7(Kc, 2013, 2013, 6, Jc(7), 180, 2, 0),
        A7(Kc, 2013, 2013, 7, Jc(10), 120, 2, 60),
        A7(Kc, 2013, 2018, 9, Yc(6), 180, 2, 0),
        A7(Kc, 2014, 2018, 2, Yc(6), 120, 2, 60),
        A7(Kc, 2014, 2014, 5, Jc(28), 180, 2, 0),
        A7(Kc, 2014, 2014, 7, Jc(2), 120, 2, 60),
        A7(Kc, 2015, 2015, 5, Jc(14), 180, 2, 0),
        A7(Kc, 2015, 2015, 6, Jc(19), 120, 2, 60),
        A7(Kc, 2016, 2016, 5, Jc(5), 180, 2, 0),
        A7(Kc, 2016, 2016, 6, Jc(10), 120, 2, 60),
        A7(Kc, 2017, 2017, 4, Jc(21), 180, 2, 0),
        A7(Kc, 2017, 2017, 6, Jc(2), 120, 2, 60),
        A7(Kc, 2018, 2018, 4, Jc(13), 180, 2, 0),
        A7(Kc, 2018, 2018, 5, Jc(17), 120, 2, 60),
        A7(Kc, 2019, 2019, 4, Jc(5), 180, 2, -60),
        A7(Kc, 2019, 2019, 5, Jc(9), 120, 2, 0),
        A7(Kc, 2020, 2020, 3, Jc(19), 180, 2, -60),
        A7(Kc, 2020, 2020, 4, Jc(31), 120, 2, 0),
        A7(Kc, 2021, 2021, 3, Jc(11), 180, 2, -60),
        A7(Kc, 2021, 2021, 4, Jc(16), 120, 2, 0),
        A7(Kc, 2022, 2022, 2, Jc(27), 180, 2, -60),
        A7(Kc, 2022, 2022, 4, Jc(8), 120, 2, 0),
        A7(Kc, 2023, 2023, 2, Jc(19), 180, 2, -60),
        A7(Kc, 2023, 2023, 3, Jc(30), 120, 2, 0),
        A7(Kc, 2024, 2024, 2, Jc(10), 180, 2, -60),
        A7(Kc, 2024, 2024, 3, Jc(14), 120, 2, 0),
        A7(Kc, 2025, 2025, 1, Jc(23), 180, 2, -60),
        A7(Kc, 2025, 2025, 3, Jc(6), 120, 2, 0),
        A7(Kc, 2026, 2026, 1, Jc(15), 180, 2, -60),
        A7(Kc, 2026, 2026, 2, Jc(22), 120, 2, 0),
        A7(Kc, 2027, 2027, 1, Jc(7), 180, 2, -60),
        A7(Kc, 2027, 2027, 2, Jc(14), 120, 2, 0),
        A7(Kc, 2028, 2028, 0, Jc(23), 180, 2, -60),
        A7(Kc, 2028, 2028, 2, Jc(5), 120, 2, 0),
        A7(Kc, 2029, 2029, 0, Jc(14), 180, 2, -60),
        A7(Kc, 2029, 2029, 1, Jc(18), 120, 2, 0),
        A7(Kc, 2029, 2029, 11, Jc(30), 180, 2, -60),
        A7(Kc, 2030, 2030, 1, Jc(10), 120, 2, 0),
        A7(Kc, 2030, 2030, 11, Jc(22), 180, 2, -60),
        A7(Kc, 2031, 2031, 1, Jc(2), 120, 2, 0),
        A7(Kc, 2031, 2031, 11, Jc(14), 180, 2, -60),
        A7(Kc, 2032, 2032, 0, Jc(18), 120, 2, 0),
        A7(Kc, 2032, 2032, 10, Jc(28), 180, 2, -60),
        A7(Kc, 2033, 2033, 0, Jc(9), 120, 2, 0),
        A7(Kc, 2033, 2033, 10, Jc(20), 180, 2, -60),
        A7(Kc, 2033, 2033, 11, Jc(25), 120, 2, 0),
        A7(Kc, 2034, 2034, 10, Jc(5), 180, 2, -60),
        A7(Kc, 2034, 2034, 11, Jc(17), 120, 2, 0),
        A7(Kc, 2035, 2035, 9, Jc(28), 180, 2, -60),
        A7(Kc, 2035, 2035, 11, Jc(9), 120, 2, 0),
        A7(Kc, 2036, 2036, 9, Jc(19), 180, 2, -60),
        A7(Kc, 2036, 2036, 10, Jc(23), 120, 2, 0),
        A7(Kc, 2037, 2037, 9, Jc(4), 180, 2, -60),
        A7(Kc, 2037, 2037, 10, Jc(15), 120, 2, 0)
    ]), yo = k([
        A7(Kc, 1977, 1980, 3, A2(Qc, 6, 1), 60, 0, 60),
        A7(Kc, 1977, 1977, 8, Yc(6), 60, 0, 0),
        A7(Kc, 1978, 1978, 9, Jc(1), 60, 0, 0),
        A7(Kc, 1979, 1995, 8, Yc(6), 60, 0, 0),
        A7(Kc, 1981, Cc, 2, Yc(6), 60, 0, 60),
        A7(Kc, 1996, Cc, 9, Yc(6), 60, 0, 0)
    ]), _o = k([
        A7(Kc, 1974, 1974, 5, Jc(24), 0, 2, 60),
        A7(Kc, 1974, 1974, 8, Jc(1), 0, 2, 0),
        A7(Kc, 1976, 1977, 4, Jc(1), 0, 2, 60),
        A7(Kc, 1976, 1976, 7, Jc(1), 0, 2, 0),
        A7(Kc, 1977, 1977, 8, Jc(28), 0, 2, 0),
        A7(Kc, 1978, 1978, 5, Jc(1), 0, 2, 60),
        A7(Kc, 1978, 1978, 7, Jc(4), 0, 2, 0)
    ]), Co = co, Do = co, Ao = oo, qo = oo, Bo = vo, jo = co, So = $o, zo = $o, Uo = function() {
        return Xc(A2(kc, h, A2(xc, 120, io(0))));
    }, Eo = k([
        A7(Kc, 1970, 1970, 4, Jc(1), 0, 2, 60),
        A7(Kc, 1970, 1985, 9, Jc(15), 0, 2, 0),
        A7(Kc, 1971, 1971, 3, Jc(30), 0, 2, 60),
        A7(Kc, 1972, 1985, 3, Yc(6), 0, 2, 60)
    ]), Po = oo, To = $o, Fo = vo, Lo = vo, Mo = co, Ho = vo, Ro = $o, Oo = $o, No = vo, Io = Uo, Vo = Uo, Wo = oo, Zo = vo, Xo = co, Go = co, Jo = vo, Yo = k([
        A7(Kc, 1982, 1984, 3, Jc(1), 0, 2, 60),
        A7(Kc, 1982, 1985, 9, Jc(1), 0, 2, 0),
        A7(Kc, 1985, 1985, 3, Jc(6), 0, 2, 60),
        A7(Kc, 1986, 1986, 3, Jc(4), 0, 2, 60),
        A7(Kc, 1986, 1986, 9, Jc(3), 0, 2, 0),
        A7(Kc, 1987, 1989, 3, Jc(1), 0, 2, 60),
        A7(Kc, 1987, 1989, 9, Jc(1), 0, 2, 0),
        A7(Kc, 1997, 1997, 3, Jc(4), 0, 2, 60),
        A7(Kc, 1997, 1997, 9, Jc(4), 0, 2, 0),
        A7(Kc, 2013, 2013, 2, Yc(4), 60, 2, 60),
        A7(Kc, 2013, 2013, 9, Yc(4), 120, 2, 0)
    ]), Qo = k([
        A7(Kc, 1977, 1977, 3, Jc(30), 0, 1, 60),
        A7(Kc, 1977, 1977, 8, Jc(24), 0, 1, 0),
        A7(Kc, 1978, 1978, 4, Jc(1), 0, 1, 60),
        A7(Kc, 1978, 1978, 9, Jc(1), 0, 1, 0),
        A7(Kc, 1988, 1988, 5, Jc(1), 0, 1, 60),
        A7(Kc, 1988, 1990, 8, Yc(6), 0, 1, 0),
        A7(Kc, 1989, 1989, 2, Jc(26), 0, 1, 60),
        A7(Kc, 1990, 1990, 4, Jc(1), 0, 1, 60),
        A7(Kc, 2005, 2005, 4, Jc(1), 0, 1, 60),
        A7(Kc, 2005, 2005, 8, Jc(30), 60, 1, 0),
        A7(Kc, 2006, 2008, 2, Yc(6), 120, 1, 60),
        A7(Kc, 2006, 2008, 9, Yc(6), 120, 1, 0)
    ]), Ko = k([
        A7(Kc, 1994, 1994, 2, Jc(21), 0, 2, -60),
        A7(Kc, 1994, 2017, 8, A2(Qc, 6, 1), 120, 2, 0),
        A7(Kc, 1995, 2017, 3, A2(Qc, 6, 1), 120, 2, -60)
    ]), nf = function() {
        return Xc(A2(kc, h, A2(xc, -240, io(0))));
    }, rf = nf, tf = nf, ef = k([
        A7(Kc, 1985, 1985, 10, Jc(2), 0, 2, 60),
        A7(Kc, 1986, 1986, 2, Jc(15), 0, 2, 0),
        A7(Kc, 1986, 1986, 9, Jc(25), 0, 2, 60),
        A7(Kc, 1987, 1987, 1, Jc(14), 0, 2, 0),
        A7(Kc, 1987, 1987, 9, Jc(25), 0, 2, 60),
        A7(Kc, 1988, 1988, 1, Jc(7), 0, 2, 0),
        A7(Kc, 1988, 1988, 9, Jc(16), 0, 2, 60),
        A7(Kc, 1989, 1989, 0, Jc(29), 0, 2, 0),
        A7(Kc, 1989, 1989, 9, Jc(15), 0, 2, 60),
        A7(Kc, 1990, 1990, 1, Jc(11), 0, 2, 0),
        A7(Kc, 1990, 1990, 9, Jc(21), 0, 2, 60),
        A7(Kc, 1991, 1991, 1, Jc(17), 0, 2, 0),
        A7(Kc, 1991, 1991, 9, Jc(20), 0, 2, 60),
        A7(Kc, 1992, 1992, 1, Jc(9), 0, 2, 0),
        A7(Kc, 1992, 1992, 9, Jc(25), 0, 2, 60),
        A7(Kc, 1993, 1993, 0, Jc(31), 0, 2, 0),
        A7(Kc, 1993, 1995, 9, A2(Qc, 6, 11), 0, 2, 60),
        A7(Kc, 1994, 1995, 1, A2(Qc, 6, 15), 0, 2, 0),
        A7(Kc, 1996, 1996, 1, Jc(11), 0, 2, 0),
        A7(Kc, 1996, 1996, 9, Jc(6), 0, 2, 60),
        A7(Kc, 1997, 1997, 1, Jc(16), 0, 2, 0),
        A7(Kc, 1997, 1997, 9, Jc(6), 0, 2, 60),
        A7(Kc, 1998, 1998, 2, Jc(1), 0, 2, 0),
        A7(Kc, 1998, 1998, 9, Jc(11), 0, 2, 60),
        A7(Kc, 1999, 1999, 1, Jc(21), 0, 2, 0),
        A7(Kc, 1999, 1999, 9, Jc(3), 0, 2, 60),
        A7(Kc, 2e3, 2e3, 1, Jc(27), 0, 2, 0),
        A7(Kc, 2e3, 2001, 9, A2(Qc, 6, 8), 0, 2, 60),
        A7(Kc, 2001, 2006, 1, A2(Qc, 6, 15), 0, 2, 0),
        A7(Kc, 2002, 2002, 10, Jc(3), 0, 2, 60),
        A7(Kc, 2003, 2003, 9, Jc(19), 0, 2, 60),
        A7(Kc, 2004, 2004, 10, Jc(2), 0, 2, 60),
        A7(Kc, 2005, 2005, 9, Jc(16), 0, 2, 60),
        A7(Kc, 2006, 2006, 10, Jc(5), 0, 2, 60),
        A7(Kc, 2007, 2007, 1, Jc(25), 0, 2, 0),
        A7(Kc, 2007, 2007, 9, A2(Qc, 6, 8), 0, 2, 60),
        A7(Kc, 2008, 2017, 9, A2(Qc, 6, 15), 0, 2, 60),
        A7(Kc, 2008, 2011, 1, A2(Qc, 6, 15), 0, 2, 0),
        A7(Kc, 2012, 2012, 1, A2(Qc, 6, 22), 0, 2, 0),
        A7(Kc, 2013, 2014, 1, A2(Qc, 6, 15), 0, 2, 0),
        A7(Kc, 2015, 2015, 1, A2(Qc, 6, 22), 0, 2, 0),
        A7(Kc, 2016, 2019, 1, A2(Qc, 6, 15), 0, 2, 0),
        A7(Kc, 2018, 2018, 10, A2(Qc, 6, 1), 0, 2, 60)
    ]), uf = k([
        A7(Kc, 1968, 1969, 3, A2(Qc, 6, 1), 0, 2, 0),
        A7(Kc, 1974, 1974, 0, Jc(23), 0, 2, 60),
        A7(Kc, 1974, 1974, 4, Jc(1), 0, 2, 0),
        A7(Kc, 1988, 1988, 11, Jc(1), 0, 2, 60),
        A7(Kc, 1989, 1993, 2, A2(Qc, 6, 1), 0, 2, 0),
        A7(Kc, 1989, 1992, 9, A2(Qc, 6, 15), 0, 2, 60),
        A7(Kc, 1999, 1999, 9, A2(Qc, 6, 1), 0, 2, 60),
        A7(Kc, 2e3, 2e3, 2, Jc(3), 0, 2, 0),
        A7(Kc, 2007, 2007, 11, Jc(30), 0, 2, 60),
        A7(Kc, 2008, 2009, 2, A2(Qc, 6, 15), 0, 2, 0),
        A7(Kc, 2008, 2008, 9, A2(Qc, 6, 15), 0, 2, 60)
    ]), af = k([
        A7(Kc, 2008, 2009, 2, A2(Qc, 6, 8), 0, 2, 0),
        A7(Kc, 2007, 2008, 9, A2(Qc, 6, 8), 0, 2, 60)
    ]), cf = function() {
        return Xc(A2(kc, h, A2(xc, -240, io(0))));
    }, of = cf, ff = k([
        A7(Kc, 1975, 1988, 9, Jc(1), 0, 2, 60),
        A7(Kc, 1975, 1978, 2, Jc(1), 0, 2, 0),
        A7(Kc, 1979, 1991, 3, Jc(1), 0, 2, 0),
        A7(Kc, 1989, 1989, 9, Jc(22), 0, 2, 60),
        A7(Kc, 1990, 1990, 9, Jc(1), 0, 2, 60),
        A7(Kc, 1991, 1991, 9, Jc(6), 0, 2, 60),
        A7(Kc, 1992, 1992, 2, Jc(1), 0, 2, 0),
        A7(Kc, 1992, 1992, 9, Jc(5), 0, 2, 60),
        A7(Kc, 1993, 1993, 2, Jc(31), 0, 2, 0),
        A7(Kc, 1993, 1995, 9, Jc(1), 0, 2, 60),
        A7(Kc, 1994, 1995, 1, Yc(6), 0, 2, 0),
        A7(Kc, 1996, 1996, 2, Jc(1), 0, 2, 0),
        A7(Kc, 1996, 2001, 9, A2(Qc, 6, 1), 0, 2, 60),
        A7(Kc, 1997, 1997, 1, Yc(6), 0, 2, 0),
        A7(Kc, 1998, 2001, 2, A2(Qc, 6, 1), 0, 2, 0),
        A7(Kc, 2002, 2004, 3, A2(Qc, 6, 1), 0, 2, 0),
        A7(Kc, 2002, 2003, 8, A2(Qc, 6, 1), 0, 2, 60),
        A7(Kc, 2004, 2009, 9, A2(Qc, 6, 15), 0, 2, 60),
        A7(Kc, 2005, 2009, 2, A2(Qc, 6, 8), 0, 2, 0),
        A7(Kc, 2010, Cc, 9, A2(Qc, 6, 1), 0, 2, 60),
        A7(Kc, 2010, 2012, 3, A2(Qc, 6, 8), 0, 2, 0),
        A7(Kc, 2013, Cc, 2, A2(Qc, 6, 22), 0, 2, 0)
    ]), sf = k([
        A7(Kc, 1996, 2e3, 3, A2(Qc, 6, 1), 120, 2, 60),
        A7(Kc, 1996, 2e3, 9, Yc(6), 120, 2, 0),
        A7(Kc, 2001, 2001, 4, A2(Qc, 6, 1), 120, 2, 60),
        A7(Kc, 2001, 2001, 8, Yc(6), 120, 2, 0),
        A7(Kc, 2002, Cc, 3, A2(Qc, 6, 1), 120, 2, 60),
        A7(Kc, 2002, Cc, 9, Yc(6), 120, 2, 0)
    ]), lf = k([
        A7(Kc, 1977, 1977, 5, Jc(12), 120, 2, 60),
        A7(Kc, 1977, 1978, 9, A2(Qc, 6, 1), 120, 2, 0),
        A7(Kc, 1978, 1980, 3, A2(Qc, 6, 15), 120, 2, 60),
        A7(Kc, 1979, 1979, 8, Jc(30), 120, 2, 0),
        A7(Kc, 1980, 1980, 8, Jc(25), 120, 2, 0)
    ]), df = k([
        A7(Kc, 1973, 1973, 11, Jc(5), 0, 2, 60),
        A7(Kc, 1974, 1974, 1, Jc(9), 0, 2, 0),
        A7(Kc, 1982, 1982, 11, Jc(18), 0, 2, 60),
        A7(Kc, 1983, 1983, 1, Jc(12), 0, 2, 0)
    ]), bf = k([
        A7(Kc, 1974, 1986, 3, Yc(6), 120, 2, 60),
        A7(Kc, 1974, 2006, 9, Yc(6), 120, 2, 0),
        A7(Kc, 1987, 2006, 3, A2(Qc, 6, 1), 120, 2, 60),
        A7(Kc, 2007, Cc, 2, A2(Qc, 6, 8), 120, 2, 60),
        A7(Kc, 2007, Cc, 10, A2(Qc, 6, 1), 120, 2, 0)
    ]), vf = k([
        A7(Kc, 1992, 1992, 4, Jc(3), 0, 2, 60),
        A7(Kc, 1993, 1993, 3, Jc(4), 0, 2, 0)
    ]), mf = k([
        A7(Kc, 1980, 1986, 3, Yc(6), 120, 2, 60),
        A7(Kc, 1980, 2006, 9, Yc(6), 120, 2, 0),
        A7(Kc, 1987, 2006, 3, A2(Qc, 6, 1), 120, 2, 60)
    ]), pf = function() {
        return Xc(A2(kc, h, A2(xc, -300, io(0))));
    }, $f = pf, hf = k([
        A7(Kc, 1979, 1980, 1, Yc(6), 0, 2, 60),
        A7(Kc, 1979, 1980, 5, A2(Qc, 6, 1), 0, 2, 0),
        A7(Kc, 1991, 1992, 0, A2(Qc, 5, 15), 0, 2, 60),
        A7(Kc, 1991, 1991, 6, Jc(1), 0, 2, 0),
        A7(Kc, 1992, 1992, 2, Jc(15), 0, 2, 0)
    ]), gf = k([
        A7(Kc, 1946, 1986, 3, Yc(6), 120, 2, 60),
        A7(Kc, 1962, 2006, 9, Yc(6), 120, 2, 0)
    ]), wf = nf, kf = k([
        A7(Kc, 1972, 1986, 3, Yc(6), 120, 2, 60),
        A7(Kc, 1972, 2006, 9, Yc(6), 120, 2, 0)
    ]), xf = k([
        A7(Kc, 1987, 1988, 4, A2(Qc, 6, 1), 0, 2, 60),
        A7(Kc, 1987, 1988, 8, Yc(6), 0, 2, 0)
    ]), yf = k([
        A7(Kc, 1962, 1973, 3, Yc(6), 120, 2, 60),
        A7(Kc, 1962, 1973, 9, Yc(6), 120, 2, 0)
    ]), _f = k([
        A7(Kc, 1951, 1986, 3, Yc(6), 120, 2, 60),
        A7(Kc, 1960, 1986, 9, Yc(6), 120, 2, 0),
        A7(Kc, 1987, 1987, 3, A2(Qc, 6, 1), 1, 2, 60),
        A7(Kc, 1987, 2006, 9, Yc(6), 1, 2, 0),
        A7(Kc, 1988, 1988, 3, A2(Qc, 6, 1), 1, 2, 120),
        A7(Kc, 1989, 2006, 3, A2(Qc, 6, 1), 1, 2, 60),
        A7(Kc, 2007, 2011, 2, A2(Qc, 6, 8), 1, 2, 60),
        A7(Kc, 2007, 2010, 10, A2(Qc, 6, 1), 1, 2, 0)
    ]), Cf = nf, Df = nf, Af = k([
        A7(Kc, 1973, 1973, 10, Jc(25), 0, 2, 60),
        A7(Kc, 1974, 1974, 1, Jc(24), 0, 2, 0),
        A7(Kc, 1983, 1983, 4, Jc(21), 0, 2, 60),
        A7(Kc, 1983, 1983, 8, Jc(22), 0, 2, 0),
        A7(Kc, 1991, 1991, 2, Jc(23), 0, 2, 60),
        A7(Kc, 1991, 1991, 8, Jc(7), 0, 2, 0),
        A7(Kc, 2006, 2006, 3, Jc(30), 0, 2, 60),
        A7(Kc, 2006, 2006, 9, Jc(1), 0, 2, 0)
    ]), qf = k([
        A7(Kc, 1992, 1992, 10, Jc(28), 0, 2, 60),
        A7(Kc, 1993, 1993, 1, Jc(5), 0, 2, 0)
    ]), Bf = k([
        A7(Kc, 1969, 1977, 3, Yc(6), 0, 2, 60),
        A7(Kc, 1969, 1971, 9, Yc(6), 0, 2, 0),
        A7(Kc, 1972, 1974, 9, Jc(8), 0, 2, 0),
        A7(Kc, 1975, 1977, 9, Yc(6), 0, 2, 0),
        A7(Kc, 1978, 1978, 4, Jc(7), 0, 2, 60),
        A7(Kc, 1978, 1990, 9, A2(Qc, 6, 8), 0, 2, 0),
        A7(Kc, 1979, 1980, 2, A2(Qc, 6, 15), 0, 2, 60),
        A7(Kc, 1981, 1985, 4, A2(Qc, 6, 5), 0, 2, 60),
        A7(Kc, 1986, 1989, 2, A2(Qc, 6, 14), 0, 2, 60),
        A7(Kc, 1990, 1997, 3, A2(Qc, 6, 1), 0, 2, 60),
        A7(Kc, 1991, 1995, 9, A2(Qc, 6, 8), 0, 1, 0),
        A7(Kc, 1996, 1996, 9, Jc(6), 0, 1, 0),
        A7(Kc, 1997, 1997, 9, Jc(12), 0, 1, 0),
        A7(Kc, 1998, 1999, 2, Yc(6), 0, 1, 60),
        A7(Kc, 1998, 2003, 9, Yc(6), 0, 1, 0),
        A7(Kc, 2e3, 2003, 3, A2(Qc, 6, 1), 0, 1, 60),
        A7(Kc, 2004, 2004, 2, Yc(6), 0, 1, 60),
        A7(Kc, 2006, 2010, 9, Yc(6), 0, 1, 0),
        A7(Kc, 2007, 2007, 2, A2(Qc, 6, 8), 0, 1, 60),
        A7(Kc, 2008, 2008, 2, A2(Qc, 6, 15), 0, 1, 60),
        A7(Kc, 2009, 2010, 2, A2(Qc, 6, 8), 0, 1, 60),
        A7(Kc, 2011, 2011, 2, A2(Qc, 6, 15), 0, 1, 60),
        A7(Kc, 2011, 2011, 10, Jc(13), 0, 1, 0),
        A7(Kc, 2012, 2012, 3, Jc(1), 0, 1, 60),
        A7(Kc, 2012, Cc, 10, A2(Qc, 6, 1), 0, 1, 0),
        A7(Kc, 2013, Cc, 2, A2(Qc, 6, 8), 0, 1, 60)
    ]), jf = cf, Sf = k([
        A7(Kc, 1986, 1987, 0, Jc(1), 0, 2, 60),
        A7(Kc, 1986, 1987, 3, Jc(1), 0, 2, 0),
        A7(Kc, 1990, 1990, 0, Jc(1), 0, 2, 60),
        A7(Kc, 1990, 1990, 3, Jc(1), 0, 2, 0),
        A7(Kc, 1994, 1994, 0, Jc(1), 0, 2, 60),
        A7(Kc, 1994, 1994, 3, Jc(1), 0, 2, 0)
    ]), zf = cf, Uf = k([
        A7(Kc, 1979, 1980, 2, A2(Qc, 6, 16), 0, 2, 60),
        A7(Kc, 1979, 1980, 5, A2(Qc, 0, 23), 0, 2, 0),
        A7(Kc, 2005, 2005, 3, Jc(10), 0, 2, 60),
        A7(Kc, 2005, 2005, 9, A2(Qc, 6, 1), 0, 2, 0),
        A7(Kc, 2006, 2006, 3, Jc(30), 120, 2, 60),
        A7(Kc, 2006, 2006, 9, A2(Qc, 6, 1), 60, 2, 0)
    ]), Ef = nf, Pf = k([
        A7(Kc, 1946, 1972, 3, Yc(6), 120, 2, 60),
        A7(Kc, 1957, 1972, 9, Yc(6), 120, 2, 0),
        A7(Kc, 1993, 2006, 3, A2(Qc, 6, 1), 1, 2, 60),
        A7(Kc, 1993, 2006, 9, Yc(6), 1, 2, 0)
    ]), Tf = k([
        A7(Kc, 1970, 1970, 3, Jc(25), 0, 2, 60),
        A7(Kc, 1970, 1970, 5, Jc(14), 0, 2, 0),
        A7(Kc, 1972, 1972, 3, Jc(23), 0, 2, 60),
        A7(Kc, 1972, 1972, 6, Jc(16), 0, 2, 0),
        A7(Kc, 1974, 1974, 0, Jc(13), 0, 2, 90),
        A7(Kc, 1974, 1974, 2, Jc(10), 0, 2, 30),
        A7(Kc, 1974, 1974, 8, Jc(1), 0, 2, 0),
        A7(Kc, 1974, 1974, 11, Jc(22), 0, 2, 60),
        A7(Kc, 1975, 1975, 2, Jc(30), 0, 2, 0),
        A7(Kc, 1976, 1976, 11, Jc(19), 0, 2, 60),
        A7(Kc, 1977, 1977, 2, Jc(6), 0, 2, 0),
        A7(Kc, 1977, 1977, 11, Jc(4), 0, 2, 60),
        A7(Kc, 1978, 1979, 2, A2(Qc, 6, 1), 0, 2, 0),
        A7(Kc, 1978, 1978, 11, Jc(17), 0, 2, 60),
        A7(Kc, 1979, 1979, 3, Jc(29), 0, 2, 60),
        A7(Kc, 1980, 1980, 2, Jc(16), 0, 2, 0),
        A7(Kc, 1987, 1987, 11, Jc(14), 0, 2, 60),
        A7(Kc, 1988, 1988, 1, Jc(28), 0, 2, 0),
        A7(Kc, 1988, 1988, 11, Jc(11), 0, 2, 60),
        A7(Kc, 1989, 1989, 2, Jc(5), 0, 2, 0),
        A7(Kc, 1989, 1989, 9, Jc(29), 0, 2, 60),
        A7(Kc, 1990, 1990, 1, Jc(25), 0, 2, 0),
        A7(Kc, 1990, 1991, 9, A2(Qc, 6, 21), 0, 2, 60),
        A7(Kc, 1991, 1992, 2, A2(Qc, 6, 1), 0, 2, 0),
        A7(Kc, 1992, 1992, 9, Jc(18), 0, 2, 60),
        A7(Kc, 1993, 1993, 1, Jc(28), 0, 2, 0),
        A7(Kc, 2004, 2004, 8, Jc(19), 0, 2, 60),
        A7(Kc, 2005, 2005, 2, Jc(27), 120, 2, 0),
        A7(Kc, 2005, 2005, 9, Jc(9), 120, 2, 60),
        A7(Kc, 2006, 2015, 2, A2(Qc, 6, 8), 120, 2, 0),
        A7(Kc, 2006, 2014, 9, A2(Qc, 6, 1), 120, 2, 60)
    ]), Ff = nf, Lf = k([
        A7(Kc, 1964, 1975, 9, Yc(6), 120, 2, 0),
        A7(Kc, 1964, 1975, 3, Yc(6), 120, 2, 60)
    ]), Mf = k([
        A7(Kc, 1983, 1983, 4, Jc(8), 0, 2, 60),
        A7(Kc, 1984, 1987, 3, Yc(6), 0, 2, 60),
        A7(Kc, 1983, 1987, 9, Yc(6), 0, 2, 0),
        A7(Kc, 1988, 1997, 3, A2(Qc, 6, 1), 60, 1, 60),
        A7(Kc, 1988, 1997, 9, Yc(6), 60, 1, 0),
        A7(Kc, 2005, 2006, 3, A2(Qc, 6, 1), 0, 2, 60),
        A7(Kc, 2005, 2006, 9, Yc(6), 0, 2, 0),
        A7(Kc, 2012, 2015, 2, A2(Qc, 6, 8), 120, 2, 60),
        A7(Kc, 2012, 2015, 10, A2(Qc, 6, 1), 120, 2, 0),
        A7(Kc, 2017, Cc, 2, A2(Qc, 6, 8), 120, 2, 60),
        A7(Kc, 2017, Cc, 10, A2(Qc, 6, 1), 120, 2, 0)
    ]), Hf = k([
        A7(Kc, 1969, 1969, 2, Jc(30), 180, 0, 0),
        A7(Kc, 1969, 1969, 10, Jc(23), 240, 0, 60),
        A7(Kc, 1970, 1970, 2, Jc(29), 180, 0, 0),
        A7(Kc, 1971, 1971, 2, Jc(14), 180, 0, 0),
        A7(Kc, 1970, 1972, 9, A2(Qc, 6, 9), 240, 0, 60),
        A7(Kc, 1972, 1986, 2, A2(Qc, 6, 9), 180, 0, 0),
        A7(Kc, 1973, 1973, 8, Jc(30), 240, 0, 60),
        A7(Kc, 1974, 1987, 9, A2(Qc, 6, 9), 240, 0, 60),
        A7(Kc, 1987, 1987, 3, Jc(12), 180, 0, 0),
        A7(Kc, 1988, 1990, 2, A2(Qc, 6, 9), 180, 0, 0),
        A7(Kc, 1988, 1989, 9, A2(Qc, 6, 9), 240, 0, 60),
        A7(Kc, 1990, 1990, 8, Jc(16), 240, 0, 60),
        A7(Kc, 1991, 1996, 2, A2(Qc, 6, 9), 180, 0, 0),
        A7(Kc, 1991, 1997, 9, A2(Qc, 6, 9), 240, 0, 60),
        A7(Kc, 1997, 1997, 2, Jc(30), 180, 0, 0),
        A7(Kc, 1998, 1998, 2, A2(Qc, 6, 9), 180, 0, 0),
        A7(Kc, 1998, 1998, 8, Jc(27), 240, 0, 60),
        A7(Kc, 1999, 1999, 3, Jc(4), 180, 0, 0),
        A7(Kc, 1999, 2010, 9, A2(Qc, 6, 9), 240, 0, 60),
        A7(Kc, 2e3, 2007, 2, A2(Qc, 6, 9), 180, 0, 0),
        A7(Kc, 2008, 2008, 2, Jc(30), 180, 0, 0),
        A7(Kc, 2009, 2009, 2, A2(Qc, 6, 9), 180, 0, 0),
        A7(Kc, 2010, 2010, 3, A2(Qc, 6, 1), 180, 0, 0),
        A7(Kc, 2011, 2011, 4, A2(Qc, 6, 2), 180, 0, 0),
        A7(Kc, 2011, 2011, 7, A2(Qc, 6, 16), 240, 0, 60),
        A7(Kc, 2012, 2014, 3, A2(Qc, 6, 23), 180, 0, 0),
        A7(Kc, 2012, 2014, 8, A2(Qc, 6, 2), 240, 0, 60),
        A7(Kc, 2016, 2018, 4, A2(Qc, 6, 9), 180, 0, 0),
        A7(Kc, 2016, 2018, 7, A2(Qc, 6, 9), 240, 0, 60),
        A7(Kc, 2019, Cc, 3, A2(Qc, 6, 2), 180, 0, 0),
        A7(Kc, 2019, Cc, 8, A2(Qc, 6, 2), 240, 0, 60)
    ]), Rf = k([
        A7(Kc, 1969, 1973, 9, Yc(6), 0, 2, 30),
        A7(Kc, 1970, 1970, 1, Jc(21), 0, 2, 0),
        A7(Kc, 1971, 1971, 0, Jc(20), 0, 2, 0),
        A7(Kc, 1972, 1974, 0, Jc(21), 0, 2, 0)
    ]), Of = k([
        A7(Kc, 1977, 1980, 3, A2(Qc, 6, 1), 120, 1, 60),
        A7(Kc, 1977, 1977, 8, Yc(6), 120, 1, 0),
        A7(Kc, 1978, 1978, 9, Jc(1), 120, 1, 0),
        A7(Kc, 1979, 1995, 8, Yc(6), 120, 1, 0),
        A7(Kc, 1981, Cc, 2, Yc(6), 120, 1, 60),
        A7(Kc, 1996, Cc, 9, Yc(6), 120, 1, 0)
    ]), Nf = nf, If = nf, Vf = nf, Wf = nf, Zf = nf, Xf = k([
        A7(Kc, 1987, 1988, 4, A2(Qc, 6, 1), 0, 2, 60),
        A7(Kc, 1987, 1988, 8, Yc(6), 0, 2, 0),
        A7(Kc, 2006, 2006, 4, A2(Qc, 6, 1), 0, 2, 60),
        A7(Kc, 2006, 2006, 7, A2(Qc, 0, 1), 0, 2, 0)
    ]), Gf = k([
        A7(Kc, 1991, 1992, 2, Yc(6), 120, 2, 60),
        A7(Kc, 1991, 1992, 8, Yc(6), 120, 2, 0),
        A7(Kc, 1993, 2006, 3, A2(Qc, 6, 1), 120, 2, 60),
        A7(Kc, 1993, 2006, 9, Yc(6), 120, 2, 0),
        A7(Kc, 2007, Cc, 2, A2(Qc, 6, 8), 120, 2, 60),
        A7(Kc, 2007, Cc, 10, A2(Qc, 6, 1), 120, 2, 0)
    ]), Jf = k([
        A7(Kc, 1950, 1973, 3, Yc(6), 120, 2, 60),
        A7(Kc, 1957, 1973, 9, Yc(6), 120, 2, 0)
    ]), Yf = nf, Qf = k([
        A7(Kc, 1966, 1986, 3, Yc(6), 120, 1, 60),
        A7(Kc, 1966, 2005, 9, Yc(6), 120, 1, 0),
        A7(Kc, 1987, 2005, 3, A2(Qc, 6, 1), 120, 1, 60)
    ]), Kf = k([
        A7(Kc, 1968, 1985, 9, Yc(6), 120, 1, 60),
        A7(Kc, 1969, 1971, 2, A2(Qc, 6, 8), 120, 1, 0),
        A7(Kc, 1972, 1972, 1, Yc(6), 120, 1, 0),
        A7(Kc, 1973, 1981, 2, A2(Qc, 6, 1), 120, 1, 0),
        A7(Kc, 1982, 1983, 2, Yc(6), 120, 1, 0),
        A7(Kc, 1984, 1986, 2, A2(Qc, 6, 1), 120, 1, 0),
        A7(Kc, 1986, 1986, 9, A2(Qc, 6, 15), 120, 1, 60),
        A7(Kc, 1987, 1990, 2, A2(Qc, 6, 15), 120, 1, 0),
        A7(Kc, 1987, 1987, 9, A2(Qc, 6, 22), 120, 1, 60),
        A7(Kc, 1988, 1990, 9, Yc(6), 120, 1, 60),
        A7(Kc, 1991, 1999, 9, A2(Qc, 6, 1), 120, 1, 60),
        A7(Kc, 1991, 2005, 2, Yc(6), 120, 1, 0),
        A7(Kc, 2e3, 2e3, 7, Yc(6), 120, 1, 60),
        A7(Kc, 2001, Cc, 9, A2(Qc, 6, 1), 120, 1, 60),
        A7(Kc, 2006, 2006, 3, A2(Qc, 6, 1), 120, 1, 0),
        A7(Kc, 2007, 2007, 2, Yc(6), 120, 1, 0),
        A7(Kc, 2008, Cc, 3, A2(Qc, 6, 1), 120, 1, 0)
    ]), ns = k([
        A7(Kc, 1974, 1974, 10, A2(Qc, 6, 1), 120, 1, 60),
        A7(Kc, 1975, 1975, 1, Yc(6), 120, 1, 0),
        A7(Kc, 1975, 1988, 9, Yc(6), 120, 1, 60),
        A7(Kc, 1976, 1989, 2, A2(Qc, 6, 1), 120, 1, 0),
        A7(Kc, 1989, 1989, 9, A2(Qc, 6, 8), 120, 1, 60),
        A7(Kc, 1990, 2006, 9, A2(Qc, 6, 1), 120, 1, 60),
        A7(Kc, 1990, 2007, 2, A2(Qc, 6, 15), 120, 1, 0),
        A7(Kc, 2007, Cc, 8, Yc(6), 120, 1, 60),
        A7(Kc, 2008, Cc, 3, A2(Qc, 6, 1), 120, 1, 0)
    ]), rs = function() {
        return Xc(A2(kc, h, A2(xc, 720, wc(ns))));
    }, ts = rs, es = k([
        A7(Kc, 2005, Cc, 2, Yc(6), 60, 0, 120),
        A7(Kc, 2004, Cc, 9, Yc(6), 60, 0, 0)
    ]), us = function() {
        return Xc(A2(kc, k([
            b(A2(xc, 60, io(0)), A5(Dc, 1980, 0, 1, 0, 2))
        ]), A2(xc, 60, wc(yo))));
    }, as = us, is = function() {
        return Xc(A2(kc, h, A2(xc, 180, io(0))));
    }, cs = is, os = k([
        A7(Kc, 1981, 1984, 3, Jc(1), 0, 2, 60),
        A7(Kc, 1981, 1983, 9, Jc(1), 0, 2, 0),
        A7(Kc, 1984, 1995, 8, Yc(6), 120, 1, 0),
        A7(Kc, 1985, 2010, 2, Yc(6), 120, 1, 60),
        A7(Kc, 1996, 2010, 9, Yc(6), 120, 1, 0)
    ]), fs = k([
        A7(Kc, 1973, 1973, 5, Jc(6), 0, 2, 60),
        A7(Kc, 1973, 1975, 9, Jc(1), 0, 2, 0),
        A7(Kc, 1974, 1977, 4, Jc(1), 0, 2, 60),
        A7(Kc, 1976, 1976, 10, Jc(1), 0, 2, 0),
        A7(Kc, 1977, 1977, 9, Jc(1), 0, 2, 0),
        A7(Kc, 1978, 1978, 3, Jc(30), 0, 2, 60),
        A7(Kc, 1978, 1978, 8, Jc(30), 0, 2, 0),
        A7(Kc, 1985, 1985, 3, Jc(1), 0, 2, 60),
        A7(Kc, 1985, 1985, 9, Jc(1), 0, 2, 0),
        A7(Kc, 1986, 1988, 3, A2(Qc, 4, 1), 0, 2, 60),
        A7(Kc, 1986, 1990, 9, A2(Qc, 4, 1), 0, 2, 0),
        A7(Kc, 1989, 1989, 4, Jc(8), 0, 2, 60),
        A7(Kc, 1990, 1990, 3, Jc(27), 0, 2, 60),
        A7(Kc, 1991, 1991, 3, Jc(17), 0, 2, 60),
        A7(Kc, 1991, 1991, 8, Jc(27), 0, 2, 0),
        A7(Kc, 1992, 1992, 3, Jc(10), 0, 2, 60),
        A7(Kc, 1992, 1993, 9, A2(Qc, 4, 1), 0, 2, 0),
        A7(Kc, 1993, 1998, 3, A2(Qc, 4, 1), 0, 2, 60),
        A7(Kc, 1994, 1994, 8, A2(Qc, 4, 15), 0, 2, 0),
        A7(Kc, 1995, 1998, 8, A2(Qc, 4, 15), 0, 1, 0),
        A7(Kc, 1999, 1999, 6, Jc(1), 0, 1, 60),
        A7(Kc, 1999, 2002, 8, Yc(4), 0, 1, 0),
        A7(Kc, 2e3, 2001, 2, Yc(3), 0, 1, 60),
        A7(Kc, 2002, 2012, 2, Yc(3), 1440, 2, 60),
        A7(Kc, 2003, 2003, 9, Jc(24), 0, 1, 0),
        A7(Kc, 2004, 2004, 9, Jc(15), 0, 1, 0),
        A7(Kc, 2005, 2005, 8, Yc(4), 0, 1, 0),
        A7(Kc, 2006, 2011, 9, Yc(4), 0, 1, 0),
        A7(Kc, 2013, 2013, 11, Jc(20), 0, 2, 0),
        A7(Kc, 2014, Cc, 2, Yc(3), 1440, 2, 60),
        A7(Kc, 2014, Cc, 9, Yc(4), 0, 1, 0)
    ]), ss = k([
        A7(Kc, 1981, 1984, 3, Jc(1), 0, 2, 60),
        A7(Kc, 1981, 1983, 9, Jc(1), 0, 2, 0),
        A7(Kc, 1984, 1995, 8, Yc(6), 120, 1, 0),
        A7(Kc, 1985, 2010, 2, Yc(6), 120, 1, 60),
        A7(Kc, 1996, 2010, 9, Yc(6), 120, 1, 0)
    ]), ls = k([
        A7(Kc, 1982, 1982, 4, Jc(1), 0, 2, 60),
        A7(Kc, 1982, 1984, 9, Jc(1), 0, 2, 0),
        A7(Kc, 1983, 1983, 2, Jc(31), 0, 2, 60),
        A7(Kc, 1984, 1985, 3, Jc(1), 0, 2, 60),
        A7(Kc, 1985, 1990, 8, Yc(6), 60, 1, 0),
        A7(Kc, 1986, 1990, 2, Yc(6), 60, 1, 60),
        A7(Kc, 1991, 2007, 3, Jc(1), 180, 1, 60),
        A7(Kc, 1991, 2007, 9, Jc(1), 180, 1, 0)
    ]), ds = function() {
        return Xc(A2(kc, k([
            b(A2(xc, 240, io(0)), A5(Dc, 1972, 5, 1, 0, 2))
        ]), A2(xc, 180, io(0))));
    }, bs = ds, vs = k([
        A7(Kc, 1997, 2015, 2, Yc(6), 240, 2, 60),
        A7(Kc, 1997, 2015, 9, Yc(6), 300, 2, 0)
    ]), ms = k([
        A7(Kc, 1981, Cc, 2, Yc(6), 60, 0, 60),
        A7(Kc, 1979, 1995, 8, Yc(6), 60, 0, 0),
        A7(Kc, 1996, Cc, 9, Yc(6), 60, 0, 0)
    ]), ps = function() {
        return Xc(A2(kc, h, A2(xc, 420, io(0))));
    }, $s = k([
        A7(Kc, 1972, 1972, 5, Jc(22), 0, 2, 60),
        A7(Kc, 1972, 1977, 9, Jc(1), 0, 2, 0),
        A7(Kc, 1973, 1977, 4, Jc(1), 0, 2, 60),
        A7(Kc, 1978, 1978, 3, Jc(30), 0, 2, 60),
        A7(Kc, 1978, 1978, 8, Jc(30), 0, 2, 0),
        A7(Kc, 1984, 1987, 4, Jc(1), 0, 2, 60),
        A7(Kc, 1984, 1991, 9, Jc(16), 0, 2, 0),
        A7(Kc, 1988, 1988, 5, Jc(1), 0, 2, 60),
        A7(Kc, 1989, 1989, 4, Jc(10), 0, 2, 60),
        A7(Kc, 1990, 1992, 4, Jc(1), 0, 2, 60),
        A7(Kc, 1992, 1992, 9, Jc(4), 0, 2, 0),
        A7(Kc, 1993, Cc, 2, Yc(6), 0, 2, 60),
        A7(Kc, 1993, 1998, 8, Yc(6), 0, 2, 0),
        A7(Kc, 1999, Cc, 9, Yc(6), 0, 2, 0)
    ]), hs = k([
        A7(Kc, 1992, 1996, 3, A2(Qc, 6, 7), 0, 1, 60),
        A7(Kc, 1992, 1996, 8, Yc(6), 0, 2, 0),
        A7(Kc, 1997, 2005, 2, Yc(6), 150, 2, 60),
        A7(Kc, 1997, 2004, 9, Yc(6), 150, 2, 0)
    ]), gs = k([
        A7(Kc, 1983, 1984, 3, Jc(1), 0, 2, 60),
        A7(Kc, 1983, 1983, 9, Jc(1), 0, 2, 0),
        A7(Kc, 1985, 1998, 2, Yc(6), 0, 2, 60),
        A7(Kc, 1984, 1998, 8, Yc(6), 0, 2, 0),
        A7(Kc, 2001, 2001, 3, Yc(5), 120, 2, 60),
        A7(Kc, 2001, 2006, 8, Yc(5), 120, 2, 0),
        A7(Kc, 2002, 2006, 2, Yc(5), 120, 2, 60),
        A7(Kc, 2015, 2016, 2, Yc(5), 120, 2, 60),
        A7(Kc, 2015, 2016, 8, Yc(5), 0, 2, 0)
    ]), ws = k([
        A7(Kc, 1966, 1976, 9, Jc(1), 120, 2, 0),
        A7(Kc, 1967, 1978, 4, Jc(1), 120, 2, 60),
        A7(Kc, 1977, 1978, 8, Jc(1), 120, 2, 0),
        A7(Kc, 1983, 1984, 3, Jc(9), 120, 2, 60),
        A7(Kc, 1983, 1984, 9, Jc(1), 120, 2, 0),
        A7(Kc, 1986, 1986, 1, Jc(16), 120, 2, 60),
        A7(Kc, 1986, 1986, 9, Jc(9), 120, 2, 0),
        A7(Kc, 1987, 1987, 2, Jc(1), 120, 2, 60),
        A7(Kc, 1987, 1988, 9, Jc(31), 120, 2, 0),
        A7(Kc, 1988, 1988, 2, Jc(15), 120, 2, 60),
        A7(Kc, 1989, 1989, 2, Jc(31), 120, 2, 60),
        A7(Kc, 1989, 1989, 9, Jc(1), 120, 2, 0),
        A7(Kc, 1990, 1990, 3, Jc(1), 120, 2, 60),
        A7(Kc, 1990, 1990, 8, Jc(30), 120, 2, 0),
        A7(Kc, 1991, 1991, 3, Jc(1), 0, 2, 60),
        A7(Kc, 1991, 1992, 9, Jc(1), 0, 2, 0),
        A7(Kc, 1992, 1992, 3, Jc(8), 0, 2, 60),
        A7(Kc, 1993, 1993, 2, Jc(26), 0, 2, 60),
        A7(Kc, 1993, 1993, 8, Jc(25), 0, 2, 0),
        A7(Kc, 1994, 1996, 3, Jc(1), 0, 2, 60),
        A7(Kc, 1994, 2005, 9, Jc(1), 0, 2, 0),
        A7(Kc, 1997, 1998, 2, Yc(0), 0, 2, 60),
        A7(Kc, 1999, 2006, 3, Jc(1), 0, 2, 60),
        A7(Kc, 2006, 2006, 8, Jc(22), 0, 2, 0),
        A7(Kc, 2007, 2007, 2, Yc(4), 0, 2, 60),
        A7(Kc, 2007, 2007, 10, A2(Qc, 4, 1), 0, 2, 0),
        A7(Kc, 2008, 2008, 3, A2(Qc, 4, 1), 0, 2, 60),
        A7(Kc, 2008, 2008, 10, Jc(1), 0, 2, 0),
        A7(Kc, 2009, 2009, 2, Yc(4), 0, 2, 60),
        A7(Kc, 2010, 2011, 3, A2(Qc, 4, 1), 0, 2, 60),
        A7(Kc, 2012, Cc, 2, Yc(4), 0, 2, 60),
        A7(Kc, 2009, Cc, 9, Yc(4), 0, 2, 0)
    ]), ks = k([
        A7(Kc, 2009, 2009, 5, Jc(19), 1380, 2, 60),
        A7(Kc, 2009, 2009, 11, Jc(31), 1440, 2, 0)
    ]), xs = function() {
        return Xc(A2(kc, h, A2(xc, 240, io(0))));
    }, ys = k([
        A7(Kc, 1975, 1975, 3, Jc(13), 0, 2, 60),
        A7(Kc, 1975, 1975, 9, Jc(12), 0, 2, 0),
        A7(Kc, 1976, 1976, 4, Jc(15), 0, 2, 60),
        A7(Kc, 1976, 1976, 9, Jc(11), 0, 2, 0),
        A7(Kc, 1977, 1980, 3, A2(Qc, 6, 1), 0, 2, 60),
        A7(Kc, 1977, 1977, 8, Jc(25), 0, 2, 0),
        A7(Kc, 1978, 1978, 9, Jc(2), 0, 2, 0),
        A7(Kc, 1979, 1997, 8, Yc(6), 0, 2, 0),
        A7(Kc, 1981, 1998, 2, Yc(6), 0, 2, 60)
    ]), _s = k([
        A7(Kc, 1999, 2005, 3, A2(Qc, 4, 15), 0, 2, 60),
        A7(Kc, 1999, 2003, 9, A2(Qc, 4, 15), 0, 2, 0),
        A7(Kc, 2004, 2004, 9, Jc(1), 60, 2, 0),
        A7(Kc, 2005, 2005, 9, Jc(4), 120, 2, 0),
        A7(Kc, 2006, 2007, 3, Jc(1), 0, 2, 60),
        A7(Kc, 2006, 2006, 8, Jc(22), 0, 2, 0),
        A7(Kc, 2007, 2007, 8, Jc(13), 120, 2, 0),
        A7(Kc, 2008, 2009, 2, Yc(4), 0, 2, 60),
        A7(Kc, 2008, 2008, 8, Jc(1), 0, 2, 0),
        A7(Kc, 2009, 2009, 8, Jc(4), 60, 2, 0),
        A7(Kc, 2010, 2010, 2, Jc(26), 0, 2, 60),
        A7(Kc, 2010, 2010, 7, Jc(11), 0, 2, 0),
        A7(Kc, 2011, 2011, 3, Jc(1), 1, 2, 60),
        A7(Kc, 2011, 2011, 7, Jc(1), 0, 2, 0),
        A7(Kc, 2011, 2011, 7, Jc(30), 0, 2, 60),
        A7(Kc, 2011, 2011, 8, Jc(30), 0, 2, 0),
        A7(Kc, 2012, 2014, 2, Yc(3), 1440, 2, 60),
        A7(Kc, 2012, 2012, 8, Jc(21), 60, 2, 0),
        A7(Kc, 2013, 2013, 8, Jc(27), 0, 2, 0),
        A7(Kc, 2014, 2014, 9, Jc(24), 0, 2, 0),
        A7(Kc, 2015, 2015, 2, Jc(28), 0, 2, 60),
        A7(Kc, 2015, 2015, 9, Jc(23), 60, 2, 0),
        A7(Kc, 2016, 2018, 2, A2(Qc, 5, 24), 60, 2, 60),
        A7(Kc, 2016, 2018, 9, A2(Qc, 5, 24), 60, 2, 0),
        A7(Kc, 2019, 2019, 2, Jc(29), 0, 2, 60),
        A7(Kc, 2019, 2019, 9, A2(Qc, 5, 24), 0, 2, 0),
        A7(Kc, 2020, Cc, 2, A2(Qc, 5, 24), 0, 2, 60),
        A7(Kc, 2020, Cc, 9, A2(Qc, 5, 24), 60, 2, 0)
    ]), Cs = F2(function(n, r) {
        return {
            $: 2,
            a: n,
            b: r
        };
    }), Ds = k([
        A7(Kc, 1974, 1974, 6, Jc(7), 0, 2, 60),
        A7(Kc, 1974, 1974, 9, Jc(13), 0, 2, 0),
        A7(Kc, 1975, 1975, 3, Jc(20), 0, 2, 60),
        A7(Kc, 1975, 1975, 7, Jc(31), 0, 2, 0),
        A7(Kc, 1980, 1980, 7, Jc(2), 0, 2, 60),
        A7(Kc, 1980, 1980, 8, Jc(13), 60, 2, 0),
        A7(Kc, 1984, 1984, 4, Jc(5), 0, 2, 60),
        A7(Kc, 1984, 1984, 7, Jc(25), 60, 2, 0),
        A7(Kc, 1985, 1985, 3, Jc(14), 0, 2, 60),
        A7(Kc, 1985, 1985, 8, Jc(15), 0, 2, 0),
        A7(Kc, 1986, 1986, 4, Jc(18), 0, 2, 60),
        A7(Kc, 1986, 1986, 8, Jc(7), 0, 2, 0),
        A7(Kc, 1987, 1987, 3, Jc(15), 0, 2, 60),
        A7(Kc, 1987, 1987, 8, Jc(13), 0, 2, 0),
        A7(Kc, 1988, 1988, 3, Jc(10), 0, 2, 60),
        A7(Kc, 1988, 1988, 8, Jc(4), 0, 2, 0),
        A7(Kc, 1989, 1989, 3, Jc(30), 0, 2, 60),
        A7(Kc, 1989, 1989, 8, Jc(3), 0, 2, 0),
        A7(Kc, 1990, 1990, 2, Jc(25), 0, 2, 60),
        A7(Kc, 1990, 1990, 7, Jc(26), 0, 2, 0),
        A7(Kc, 1991, 1991, 2, Jc(24), 0, 2, 60),
        A7(Kc, 1991, 1991, 8, Jc(1), 0, 2, 0),
        A7(Kc, 1992, 1992, 2, Jc(29), 0, 2, 60),
        A7(Kc, 1992, 1992, 8, Jc(6), 0, 2, 0),
        A7(Kc, 1993, 1993, 3, Jc(2), 0, 2, 60),
        A7(Kc, 1993, 1993, 8, Jc(5), 0, 2, 0),
        A7(Kc, 1994, 1994, 3, Jc(1), 0, 2, 60),
        A7(Kc, 1994, 1994, 7, Jc(28), 0, 2, 0),
        A7(Kc, 1995, 1995, 2, Jc(31), 0, 2, 60),
        A7(Kc, 1995, 1995, 8, Jc(3), 0, 2, 0),
        A7(Kc, 1996, 1996, 2, Jc(15), 0, 2, 60),
        A7(Kc, 1996, 1996, 8, Jc(16), 0, 2, 0),
        A7(Kc, 1997, 1997, 2, Jc(21), 0, 2, 60),
        A7(Kc, 1997, 1997, 8, Jc(14), 0, 2, 0),
        A7(Kc, 1998, 1998, 2, Jc(20), 0, 2, 60),
        A7(Kc, 1998, 1998, 8, Jc(6), 0, 2, 0),
        A7(Kc, 1999, 1999, 3, Jc(2), 120, 2, 60),
        A7(Kc, 1999, 1999, 8, Jc(3), 120, 2, 0),
        A7(Kc, 2e3, 2e3, 3, Jc(14), 120, 2, 60),
        A7(Kc, 2e3, 2e3, 9, Jc(6), 60, 2, 0),
        A7(Kc, 2001, 2001, 3, Jc(9), 60, 2, 60),
        A7(Kc, 2001, 2001, 8, Jc(24), 60, 2, 0),
        A7(Kc, 2002, 2002, 2, Jc(29), 60, 2, 60),
        A7(Kc, 2002, 2002, 9, Jc(7), 60, 2, 0),
        A7(Kc, 2003, 2003, 2, Jc(28), 60, 2, 60),
        A7(Kc, 2003, 2003, 9, Jc(3), 60, 2, 0),
        A7(Kc, 2004, 2004, 3, Jc(7), 60, 2, 60),
        A7(Kc, 2004, 2004, 8, Jc(22), 60, 2, 0),
        A7(Kc, 2005, 2012, 3, A2(Cs, 4, 1), 120, 2, 60),
        A7(Kc, 2005, 2005, 9, Jc(9), 120, 2, 0),
        A7(Kc, 2006, 2006, 9, Jc(1), 120, 2, 0),
        A7(Kc, 2007, 2007, 8, Jc(16), 120, 2, 0),
        A7(Kc, 2008, 2008, 9, Jc(5), 120, 2, 0),
        A7(Kc, 2009, 2009, 8, Jc(27), 120, 2, 0),
        A7(Kc, 2010, 2010, 8, Jc(12), 120, 2, 0),
        A7(Kc, 2011, 2011, 9, Jc(2), 120, 2, 0),
        A7(Kc, 2012, 2012, 8, Jc(23), 120, 2, 0),
        A7(Kc, 2013, Cc, 2, A2(Qc, 4, 23), 120, 2, 60),
        A7(Kc, 2013, Cc, 9, Yc(6), 120, 2, 0)
    ]), As = k([
        A7(Kc, 1965, 1976, 3, A2(Qc, 6, 16), 210, 2, 60),
        A7(Kc, 1965, 1976, 9, A2(Qc, 6, 16), 210, 2, 0),
        A7(Kc, 1973, 1973, 11, Jc(30), 210, 2, 60),
        A7(Kc, 1979, 1979, 4, Jc(13), 210, 2, 60),
        A7(Kc, 1979, 1979, 9, Jc(21), 210, 2, 0)
    ]), qs = k([
        A7(Kc, 1973, 1973, 5, Jc(3), 60, 2, 60),
        A7(Kc, 1973, 1976, 9, A2(Qc, 6, 31), 120, 2, 0),
        A7(Kc, 1974, 1974, 2, Jc(31), 120, 2, 60),
        A7(Kc, 1975, 1975, 2, Jc(22), 120, 2, 60),
        A7(Kc, 1976, 1976, 2, Jc(21), 120, 2, 60),
        A7(Kc, 1977, 1978, 3, A2(Qc, 6, 1), 120, 2, 60),
        A7(Kc, 1977, 1978, 9, A2(Qc, 6, 15), 120, 2, 0),
        A7(Kc, 1978, 1978, 5, Jc(29), 0, 2, 0),
        A7(Kc, 1983, 1983, 6, Jc(31), 120, 2, 60),
        A7(Kc, 1983, 1983, 9, Jc(2), 120, 2, 0),
        A7(Kc, 1985, 1985, 3, Jc(20), 60, 1, 60),
        A7(Kc, 1985, 1985, 8, Jc(28), 60, 1, 0),
        A7(Kc, 1986, 1993, 2, Yc(6), 60, 1, 60),
        A7(Kc, 1986, 1995, 8, Yc(6), 60, 1, 0),
        A7(Kc, 1994, 1994, 2, Jc(20), 60, 1, 60),
        A7(Kc, 1995, 2006, 2, Yc(6), 60, 1, 60),
        A7(Kc, 1996, 2006, 9, Yc(6), 60, 1, 0)
    ]), Bs = function() {
        return Xc(A2(kc, k([
            b(A2(xc, 120, wc(qs)), A5(Dc, 1978, 5, 29, 0, 2)),
            b(A2(xc, 180, wc(qs)), A5(Dc, 1984, 10, 1, 120, 2)),
            b(A2(xc, 120, wc(qs)), A5(Dc, 2007, 0, 1, 0, 2)),
            b(A2(xc, 120, wc(yo)), A5(Dc, 2011, 2, 27, 60, 0)),
            b(A2(xc, 120, io(0)), A5(Dc, 2011, 2, 28, 60, 0)),
            b(A2(xc, 120, wc(yo)), A5(Dc, 2014, 2, 30, 60, 0)),
            b(A2(xc, 120, io(0)), A5(Dc, 2014, 2, 31, 60, 0)),
            b(A2(xc, 120, wc(yo)), A5(Dc, 2015, 9, 25, 60, 0)),
            b(A2(xc, 120, io(60)), A5(Dc, 2015, 10, 8, 60, 0)),
            b(A2(xc, 120, wc(yo)), A5(Dc, 2016, 8, 7, 0, 2))
        ]), A2(xc, 180, io(0))));
    }, js = Bs, Ss = k([
        A7(Kc, 2002, 2002, 3, A2(Qc, 6, 2), 0, 2, 60),
        A7(Kc, 2002, 2002, 9, A2(Qc, 6, 2), 0, 2, 0),
        A7(Kc, 2008, 2008, 5, Jc(1), 0, 2, 60),
        A7(Kc, 2008, 2009, 10, Jc(1), 0, 2, 0),
        A7(Kc, 2009, 2009, 3, Jc(15), 0, 2, 60)
    ]), zs = is, Us = k([
        A7(Kc, 1965, 1973, 3, A2(Qc, 6, 16), 210, 2, 60),
        A7(Kc, 1967, 1976, 9, A2(Qc, 6, 16), 210, 2, 0),
        A7(Kc, 1973, 1973, 11, Jc(30), 210, 2, 60),
        A7(Kc, 1975, 1976, 3, A2(Qc, 6, 16), 210, 2, 60),
        A7(Kc, 1979, 1979, 4, Jc(13), 210, 2, 60),
        A7(Kc, 1979, 1979, 9, A2(Qc, 6, 16), 210, 2, 0)
    ]), Es = k([
        A7(Kc, 1978, 1978, 2, Jc(22), 0, 2, 60),
        A7(Kc, 1978, 1978, 8, Jc(21), 0, 2, 0)
    ]), Ps = xs, Ts = function() {
        return Xc(A2(kc, k([
            b(A2(xc, 120, wc(ys)), A5(Dc, 1998, 8, 1, 0, 2))
        ]), A2(xc, 120, wc(ms))));
    }, Fs = ps, Ls = k([
        A7(Kc, 1987, 1988, 4, A2(Qc, 6, 8), 120, 2, 60),
        A7(Kc, 1987, 1988, 9, A2(Qc, 6, 8), 180, 2, 0)
    ]), Ms = k([
        A7(Kc, 1986, 1986, 4, Jc(4), 120, 2, 60),
        A7(Kc, 1986, 1991, 8, A2(Qc, 6, 11), 120, 2, 0),
        A7(Kc, 1987, 1991, 3, A2(Qc, 6, 11), 120, 2, 60)
    ]), Hs = k([
        A7(Kc, 1974, 1975, 3, Jc(1), 0, 2, 60),
        A7(Kc, 1974, 1975, 9, Jc(1), 0, 2, 0),
        A7(Kc, 1979, 1979, 6, Jc(1), 0, 2, 60),
        A7(Kc, 1979, 1979, 9, Jc(1), 0, 2, 0)
    ]), Rs = k([
        A7(Kc, 1981, Cc, 2, Yc(6), 0, 2, 60),
        A7(Kc, 1979, 1995, 8, Yc(6), 0, 2, 0),
        A7(Kc, 1996, Cc, 9, Yc(6), 0, 2, 0)
    ]), Os = k([
        A7(Kc, 1978, 1980, 2, Jc(20), 1440, 2, 60),
        A7(Kc, 1978, 1978, 9, Jc(20), 1440, 2, 0),
        A7(Kc, 1979, 1979, 8, Jc(18), 1440, 2, 0),
        A7(Kc, 1980, 1980, 8, Jc(22), 1440, 2, 0),
        A7(Kc, 1991, 1991, 4, Jc(2), 1440, 2, 60),
        A7(Kc, 1992, 1995, 2, Jc(21), 1440, 2, 60),
        A7(Kc, 1991, 1995, 8, Jc(21), 1440, 2, 0),
        A7(Kc, 1996, 1996, 2, Jc(20), 1440, 2, 60),
        A7(Kc, 1996, 1996, 8, Jc(20), 1440, 2, 0),
        A7(Kc, 1997, 1999, 2, Jc(21), 1440, 2, 60),
        A7(Kc, 1997, 1999, 8, Jc(21), 1440, 2, 0),
        A7(Kc, 2e3, 2e3, 2, Jc(20), 1440, 2, 60),
        A7(Kc, 2e3, 2e3, 8, Jc(20), 1440, 2, 0),
        A7(Kc, 2001, 2003, 2, Jc(21), 1440, 2, 60),
        A7(Kc, 2001, 2003, 8, Jc(21), 1440, 2, 0),
        A7(Kc, 2004, 2004, 2, Jc(20), 1440, 2, 60),
        A7(Kc, 2004, 2004, 8, Jc(20), 1440, 2, 0),
        A7(Kc, 2005, 2005, 2, Jc(21), 1440, 2, 60),
        A7(Kc, 2005, 2005, 8, Jc(21), 1440, 2, 0),
        A7(Kc, 2008, 2008, 2, Jc(20), 1440, 2, 60),
        A7(Kc, 2008, 2008, 8, Jc(20), 1440, 2, 0),
        A7(Kc, 2009, 2011, 2, Jc(21), 1440, 2, 60),
        A7(Kc, 2009, 2011, 8, Jc(21), 1440, 2, 0),
        A7(Kc, 2012, 2012, 2, Jc(20), 1440, 2, 60),
        A7(Kc, 2012, 2012, 8, Jc(20), 1440, 2, 0),
        A7(Kc, 2013, 2015, 2, Jc(21), 1440, 2, 60),
        A7(Kc, 2013, 2015, 8, Jc(21), 1440, 2, 0),
        A7(Kc, 2016, 2016, 2, Jc(20), 1440, 2, 60),
        A7(Kc, 2016, 2016, 8, Jc(20), 1440, 2, 0),
        A7(Kc, 2017, 2019, 2, Jc(21), 1440, 2, 60),
        A7(Kc, 2017, 2019, 8, Jc(21), 1440, 2, 0),
        A7(Kc, 2020, 2020, 2, Jc(20), 1440, 2, 60),
        A7(Kc, 2020, 2020, 8, Jc(20), 1440, 2, 0),
        A7(Kc, 2021, 2023, 2, Jc(21), 1440, 2, 60),
        A7(Kc, 2021, 2023, 8, Jc(21), 1440, 2, 0),
        A7(Kc, 2024, 2024, 2, Jc(20), 1440, 2, 60),
        A7(Kc, 2024, 2024, 8, Jc(20), 1440, 2, 0),
        A7(Kc, 2025, 2027, 2, Jc(21), 1440, 2, 60),
        A7(Kc, 2025, 2027, 8, Jc(21), 1440, 2, 0),
        A7(Kc, 2028, 2029, 2, Jc(20), 1440, 2, 60),
        A7(Kc, 2028, 2029, 8, Jc(20), 1440, 2, 0),
        A7(Kc, 2030, 2031, 2, Jc(21), 1440, 2, 60),
        A7(Kc, 2030, 2031, 8, Jc(21), 1440, 2, 0),
        A7(Kc, 2032, 2033, 2, Jc(20), 1440, 2, 60),
        A7(Kc, 2032, 2033, 8, Jc(20), 1440, 2, 0),
        A7(Kc, 2034, 2035, 2, Jc(21), 1440, 2, 60),
        A7(Kc, 2034, 2035, 8, Jc(21), 1440, 2, 0),
        A7(Kc, 2036, 2037, 2, Jc(20), 1440, 2, 60),
        A7(Kc, 2036, 2037, 8, Jc(20), 1440, 2, 0)
    ]), Ns = ps, Is = k([
        A7(Kc, 2011, 2011, 2, Yc(6), 120, 1, 60),
        A7(Kc, 2011, 2011, 9, Yc(6), 120, 1, 0)
    ]), Vs = k([
        A7(Kc, 1977, 1977, 2, Jc(27), 0, 1, 60),
        A7(Kc, 1977, 1977, 8, Jc(25), 0, 1, 0),
        A7(Kc, 1978, 1979, 3, A2(Qc, 6, 1), 0, 1, 60),
        A7(Kc, 1978, 1978, 9, Jc(1), 0, 1, 0),
        A7(Kc, 1979, 1982, 8, Yc(6), 60, 1, 0),
        A7(Kc, 1980, 1980, 2, Yc(6), 0, 1, 60),
        A7(Kc, 1981, 1982, 2, Yc(6), 60, 1, 60),
        A7(Kc, 1983, 1983, 2, Yc(6), 120, 1, 60)
    ]), Ws = k([
        A7(Kc, 1977, 1980, 3, A2(Qc, 6, 1), 60, 1, 60),
        A7(Kc, 1977, 1977, 8, Yc(6), 60, 1, 0),
        A7(Kc, 1978, 1978, 9, Jc(1), 60, 1, 0),
        A7(Kc, 1979, 1995, 8, Yc(6), 60, 1, 0),
        A7(Kc, 1981, Cc, 2, Yc(6), 60, 1, 60),
        A7(Kc, 1996, Cc, 9, Yc(6), 60, 1, 0)
    ]), Zs = co, Xs = k([
        A7(Kc, 1983, 1983, 8, Yc(6), 0, 2, 60),
        A7(Kc, 1984, 1985, 3, Yc(6), 0, 2, 0),
        A7(Kc, 1984, 1984, 8, Jc(16), 0, 2, 60),
        A7(Kc, 1985, 2e3, 8, A2(Qc, 6, 9), 0, 2, 60),
        A7(Kc, 1986, 2e3, 3, A2(Qc, 6, 16), 0, 2, 0),
        A7(Kc, 2001, 2010, 3, A2(Qc, 6, 15), 120, 2, 0),
        A7(Kc, 2001, 2010, 8, A2(Qc, 6, 1), 120, 2, 60)
    ]), Gs = k([
        A7(Kc, 1971, 1985, 9, Yc(6), 120, 1, 60),
        A7(Kc, 1986, 1986, 9, Jc(19), 120, 1, 60),
        A7(Kc, 1987, 2007, 9, Yc(6), 120, 1, 60),
        A7(Kc, 1972, 1972, 1, Jc(27), 120, 1, 0),
        A7(Kc, 1973, 1985, 2, A2(Qc, 6, 1), 120, 1, 0),
        A7(Kc, 1986, 1990, 2, A2(Qc, 6, 15), 120, 1, 0),
        A7(Kc, 1991, 1991, 2, Jc(3), 120, 1, 0),
        A7(Kc, 1992, 1992, 2, Jc(22), 120, 1, 0),
        A7(Kc, 1993, 1993, 2, Jc(7), 120, 1, 0),
        A7(Kc, 1994, 1994, 2, Jc(20), 120, 1, 0),
        A7(Kc, 1995, 2005, 2, Yc(6), 120, 1, 0),
        A7(Kc, 2006, 2006, 3, Jc(2), 120, 1, 0),
        A7(Kc, 2007, 2007, 2, Yc(6), 120, 1, 0),
        A7(Kc, 2008, Cc, 3, A2(Qc, 6, 1), 120, 1, 0),
        A7(Kc, 2008, Cc, 9, A2(Qc, 6, 1), 120, 1, 60)
    ]), Js = k([
        A7(Kc, 1971, 1971, 9, Yc(6), 120, 1, 60),
        A7(Kc, 1972, 1972, 1, Yc(6), 120, 1, 0),
        A7(Kc, 1989, 1991, 9, Yc(6), 120, 1, 60),
        A7(Kc, 1990, 1992, 2, A2(Qc, 6, 1), 120, 1, 0)
    ]), Ys = k([
        A7(Kc, 1971, 1985, 9, Yc(6), 120, 1, 60),
        A7(Kc, 1972, 1972, 1, Jc(27), 120, 1, 0),
        A7(Kc, 1973, 1981, 2, A2(Qc, 6, 1), 120, 1, 0),
        A7(Kc, 1982, 1982, 3, A2(Qc, 6, 1), 120, 1, 0),
        A7(Kc, 1983, 1985, 2, A2(Qc, 6, 1), 120, 1, 0),
        A7(Kc, 1986, 1989, 2, A2(Qc, 6, 15), 120, 1, 0),
        A7(Kc, 1986, 1986, 9, Jc(19), 120, 1, 60),
        A7(Kc, 1987, 1999, 9, Yc(6), 120, 1, 60),
        A7(Kc, 1990, 1995, 2, A2(Qc, 6, 1), 120, 1, 0),
        A7(Kc, 1996, 2005, 2, Yc(6), 120, 1, 0),
        A7(Kc, 2e3, 2e3, 7, Yc(6), 120, 1, 60),
        A7(Kc, 2001, 2007, 9, Yc(6), 120, 1, 60),
        A7(Kc, 2006, 2006, 3, A2(Qc, 6, 1), 120, 1, 0),
        A7(Kc, 2007, 2007, 2, Yc(6), 120, 1, 0),
        A7(Kc, 2008, Cc, 3, A2(Qc, 6, 1), 120, 1, 0),
        A7(Kc, 2008, Cc, 9, A2(Qc, 6, 1), 120, 1, 60)
    ]), Qs = k([
        A7(Kc, 1974, 1974, 9, Yc(6), 120, 1, 60),
        A7(Kc, 1975, 1975, 2, A2(Qc, 6, 1), 120, 1, 0),
        A7(Kc, 1983, 1983, 9, Yc(6), 120, 1, 60),
        A7(Kc, 1984, 1984, 2, A2(Qc, 6, 1), 120, 1, 0),
        A7(Kc, 1991, 1991, 10, Jc(17), 120, 1, 60),
        A7(Kc, 1992, 1992, 2, A2(Qc, 6, 1), 120, 1, 0),
        A7(Kc, 2006, 2006, 11, Jc(3), 120, 1, 60),
        A7(Kc, 2007, 2009, 2, Yc(6), 120, 1, 0),
        A7(Kc, 2007, 2008, 9, Yc(6), 120, 1, 60)
    ]), Ks = k([
        A7(Kc, 1992, 1993, 9, Yc(6), 120, 1, 60),
        A7(Kc, 1993, 1994, 2, A2(Qc, 6, 1), 120, 1, 0)
    ]), nl = k([
        A7(Kc, 1981, 1984, 9, Yc(6), 120, 2, 60),
        A7(Kc, 1982, 1985, 2, A2(Qc, 6, 1), 120, 2, 0),
        A7(Kc, 1985, 1985, 9, Yc(6), 120, 2, 30),
        A7(Kc, 1986, 1989, 2, A2(Qc, 6, 15), 120, 2, 0),
        A7(Kc, 1986, 1986, 9, Jc(19), 120, 2, 30),
        A7(Kc, 1987, 1999, 9, Yc(6), 120, 2, 30),
        A7(Kc, 1990, 1995, 2, A2(Qc, 6, 1), 120, 2, 0),
        A7(Kc, 1996, 2005, 2, Yc(6), 120, 2, 0),
        A7(Kc, 2e3, 2e3, 7, Yc(6), 120, 2, 30),
        A7(Kc, 2001, 2007, 9, Yc(6), 120, 2, 30),
        A7(Kc, 2006, 2006, 3, A2(Qc, 6, 1), 120, 2, 0),
        A7(Kc, 2007, 2007, 2, Yc(6), 120, 2, 0),
        A7(Kc, 2008, Cc, 3, A2(Qc, 6, 1), 120, 2, 0),
        A7(Kc, 2008, Cc, 9, A2(Qc, 6, 1), 120, 2, 30)
    ]), rl = k([
        A7(Kc, 1971, 1985, 9, Yc(6), 120, 1, 60),
        A7(Kc, 1972, 1972, 1, Yc(6), 120, 1, 0),
        A7(Kc, 1973, 1985, 2, A2(Qc, 6, 1), 120, 1, 0),
        A7(Kc, 1986, 1990, 2, A2(Qc, 6, 15), 120, 1, 0),
        A7(Kc, 1986, 1987, 9, A2(Qc, 6, 15), 120, 1, 60),
        A7(Kc, 1988, 1999, 9, Yc(6), 120, 1, 60),
        A7(Kc, 1991, 1994, 2, A2(Qc, 6, 1), 120, 1, 0),
        A7(Kc, 1995, 2005, 2, Yc(6), 120, 1, 0),
        A7(Kc, 2e3, 2e3, 7, Yc(6), 120, 1, 60),
        A7(Kc, 2001, 2007, 9, Yc(6), 120, 1, 60),
        A7(Kc, 2006, 2006, 3, A2(Qc, 6, 1), 120, 1, 0),
        A7(Kc, 2007, 2007, 2, Yc(6), 120, 1, 0),
        A7(Kc, 2008, Cc, 3, A2(Qc, 6, 1), 120, 1, 0),
        A7(Kc, 2008, Cc, 9, A2(Qc, 6, 1), 120, 1, 60)
    ]), tl = k([
        A7(Kc, 1975, 1975, 3, Jc(12), 0, 1, 60),
        A7(Kc, 1975, 1975, 10, Jc(26), 0, 1, 0),
        A7(Kc, 1976, 1976, 3, Jc(11), 120, 1, 60),
        A7(Kc, 1976, 1976, 9, Jc(10), 120, 1, 0),
        A7(Kc, 1977, 1978, 3, A2(Qc, 6, 1), 120, 1, 60),
        A7(Kc, 1977, 1977, 8, Jc(26), 120, 1, 0),
        A7(Kc, 1978, 1978, 8, Jc(24), 240, 2, 0),
        A7(Kc, 1979, 1979, 3, Jc(1), 540, 2, 60),
        A7(Kc, 1979, 1979, 8, Jc(29), 120, 2, 0),
        A7(Kc, 1980, 1980, 3, Jc(1), 0, 2, 60),
        A7(Kc, 1980, 1980, 8, Jc(28), 0, 2, 0)
    ]), el = function() {
        return Xc(A2(kc, k([
            b(A2(xc, 60, io(0)), A5(Dc, 1982, 10, 27, 0, 2))
        ]), A2(xc, 60, wc(yo))));
    }, ul = function() {
        return Xc(A2(kc, k([
            b(A2(xc, 60, io(0)), A5(Dc, 1979, 0, 1, 0, 2))
        ]), A2(xc, 60, wc(yo))));
    }, al = ul, il = k([
        A7(Kc, 1977, 1980, 3, A2(Qc, 6, 1), 0, 2, 60),
        A7(Kc, 1977, 1977, 8, Yc(6), 0, 2, 0),
        A7(Kc, 1978, 1978, 9, Jc(1), 0, 2, 0),
        A7(Kc, 1979, 1995, 8, Yc(6), 0, 2, 0),
        A7(Kc, 1981, Cc, 2, Yc(6), 0, 2, 60),
        A7(Kc, 1996, Cc, 9, Yc(6), 0, 2, 0)
    ]), cl = k([
        A7(Kc, 1979, 1979, 4, Jc(27), 0, 2, 60),
        A7(Kc, 1979, 1979, 8, Yc(6), 0, 2, 0),
        A7(Kc, 1980, 1980, 3, Jc(5), 1380, 2, 60),
        A7(Kc, 1980, 1980, 8, Yc(6), 60, 2, 0),
        A7(Kc, 1991, 1993, 2, Yc(6), 0, 1, 60),
        A7(Kc, 1991, 1993, 8, Yc(6), 0, 1, 0)
    ]), ol = k([
        A7(Kc, 1980, 1980, 3, Jc(6), 0, 2, 60),
        A7(Kc, 1980, 1980, 8, Jc(28), 60, 2, 0),
        A7(Kc, 1981, 1983, 2, Yc(6), 0, 2, 60),
        A7(Kc, 1981, 1983, 8, Yc(6), 60, 2, 0)
    ]), fl = function() {
        return Xc(A2(kc, k([
            b(A2(xc, 60, io(0)), A5(Dc, 1981, 0, 1, 0, 2))
        ]), A2(xc, 60, wc(yo))));
    }, sl = fl, ll = k([
        A7(Kc, 1997, Cc, 2, Yc(6), 120, 2, 60),
        A7(Kc, 1997, Cc, 9, Yc(6), 180, 2, 0)
    ]), dl = k([
        A7(Kc, 1971, 1971, 9, Jc(31), 120, 0, -60),
        A7(Kc, 1972, 1980, 2, A2(Qc, 6, 16), 120, 0, 0),
        A7(Kc, 1972, 1980, 9, A2(Qc, 6, 23), 120, 0, -60),
        A7(Kc, 1981, Cc, 2, Yc(6), 60, 0, 0),
        A7(Kc, 1981, 1989, 9, A2(Qc, 6, 23), 60, 0, -60),
        A7(Kc, 1990, 1995, 9, A2(Qc, 6, 22), 60, 0, -60),
        A7(Kc, 1996, Cc, 9, Yc(6), 60, 0, -60)
    ]), bl = k([
        A7(Kc, 1972, 1980, 2, A2(Qc, 6, 16), 120, 1, 60),
        A7(Kc, 1972, 1980, 9, A2(Qc, 6, 23), 120, 1, 0),
        A7(Kc, 1981, 1995, 2, Yc(6), 60, 0, 60),
        A7(Kc, 1981, 1989, 9, A2(Qc, 6, 23), 60, 0, 0),
        A7(Kc, 1990, 1995, 9, A2(Qc, 6, 22), 60, 0, 0)
    ]), vl = function() {
        return Xc(A2(kc, k([
            b(A2(xc, 60, io(0)), A5(Dc, 1971, 9, 31, 120, 0)),
            b(A2(xc, 0, wc(bl)), A5(Dc, 1996, 0, 1, 0, 2))
        ]), A2(xc, 0, wc(yo))));
    }, ml = vl, pl = k([
        A7(Kc, 1981, 1982, 2, Yc(6), 120, 2, 60),
        A7(Kc, 1981, 1982, 8, Yc(6), 180, 2, 0)
    ]), $l = function() {
        return Xc(A2(kc, k([
            b(A2(xc, 120, wc(pl)), A5(Dc, 1983, 0, 1, 0, 2))
        ]), A2(xc, 120, wc(yo))));
    }, hl = vl, gl = vl, wl = el, kl = k([
        A7(Kc, 1974, 1975, 3, A2(Qc, 5, 12), 1380, 2, 60),
        A7(Kc, 1974, 1975, 9, A2(Qc, 6, 1), 60, 2, 0),
        A7(Kc, 1976, 1976, 2, Jc(27), 1380, 2, 60),
        A7(Kc, 1976, 1977, 8, Yc(6), 60, 2, 0),
        A7(Kc, 1977, 1977, 3, Jc(2), 1380, 2, 60),
        A7(Kc, 1978, 1978, 3, Jc(2), 120, 1, 60),
        A7(Kc, 1978, 1978, 9, Jc(1), 120, 1, 0)
    ]), xl = k([
        A7(Kc, 1967, 1969, 8, A2(Qc, 6, 22), 0, 1, 0),
        A7(Kc, 1969, 1969, 5, Jc(1), 0, 1, 60),
        A7(Kc, 1970, 1970, 4, Jc(31), 0, 1, 60),
        A7(Kc, 1970, 1970, 8, Yc(6), 0, 1, 0),
        A7(Kc, 1971, 1972, 4, A2(Qc, 6, 22), 0, 1, 60),
        A7(Kc, 1971, 1971, 8, Yc(6), 0, 1, 0),
        A7(Kc, 1972, 1972, 9, Jc(1), 0, 1, 0),
        A7(Kc, 1973, 1973, 5, Jc(3), 0, 1, 60),
        A7(Kc, 1973, 1974, 8, Yc(6), 0, 1, 0),
        A7(Kc, 1974, 1974, 4, Jc(26), 0, 1, 60),
        A7(Kc, 1975, 1975, 5, Jc(1), 0, 1, 60),
        A7(Kc, 1975, 1977, 8, Yc(6), 0, 1, 0),
        A7(Kc, 1976, 1976, 4, Jc(30), 0, 1, 60),
        A7(Kc, 1977, 1979, 4, A2(Qc, 6, 22), 0, 1, 60),
        A7(Kc, 1978, 1978, 9, Jc(1), 0, 1, 0),
        A7(Kc, 1979, 1979, 8, Jc(30), 0, 1, 0)
    ]), yl = k([
        A7(Kc, 1973, 1973, 2, Jc(31), 0, 1, 60),
        A7(Kc, 1973, 1973, 8, Jc(29), 0, 1, 0),
        A7(Kc, 1974, 1974, 3, Jc(21), 0, 1, 60),
        A7(Kc, 1974, 1974, 8, Jc(16), 0, 1, 0),
        A7(Kc, 1975, 1979, 3, A2(Qc, 6, 15), 120, 2, 60),
        A7(Kc, 1975, 1980, 8, A2(Qc, 6, 15), 120, 2, 0),
        A7(Kc, 1980, 1980, 2, Jc(31), 120, 2, 60)
    ]), _l = $l, Cl = k([
        A7(Kc, 1976, 1976, 2, Jc(28), 60, 2, 60),
        A7(Kc, 1976, 1976, 8, Jc(26), 60, 2, 0)
    ]), Dl = Ts, Al = el, ql = k([
        A7(Kc, 1989, 1996, 2, Yc(6), 120, 1, 60),
        A7(Kc, 1989, 1996, 8, Yc(6), 120, 1, 0)
    ]), Bl = function() {
        return Xc(A2(kc, k([
            b(A2(xc, 60, wc(xl)), A5(Dc, 1980, 0, 1, 0, 2))
        ]), A2(xc, 60, wc(yo))));
    }, jl = Bl, Sl = el, zl = el, Ul = k([
        A7(Kc, 1979, 1979, 2, Jc(31), 1380, 2, 60),
        A7(Kc, 1979, 1979, 9, Jc(1), 60, 2, 0),
        A7(Kc, 1980, 1982, 3, A2(Qc, 5, 1), 1380, 2, 60),
        A7(Kc, 1980, 1980, 8, Jc(29), 60, 2, 0),
        A7(Kc, 1981, 1981, 8, Jc(27), 120, 2, 0)
    ]), El = k([
        A7(Kc, 1974, 1974, 4, Jc(4), 0, 2, 60),
        A7(Kc, 1974, 1974, 9, Jc(2), 0, 2, 0),
        A7(Kc, 1975, 1975, 4, Jc(1), 0, 2, 60),
        A7(Kc, 1975, 1975, 9, Jc(2), 0, 2, 0),
        A7(Kc, 1976, 1976, 4, Jc(2), 0, 2, 60),
        A7(Kc, 1976, 1976, 9, Jc(3), 0, 2, 0),
        A7(Kc, 1977, 1977, 4, Jc(8), 0, 2, 60),
        A7(Kc, 1977, 1977, 9, Jc(2), 0, 2, 0),
        A7(Kc, 1978, 1978, 4, Jc(6), 0, 2, 60),
        A7(Kc, 1978, 1978, 9, Jc(1), 0, 2, 0),
        A7(Kc, 1979, 1979, 4, Jc(5), 0, 2, 60),
        A7(Kc, 1979, 1979, 8, Jc(30), 0, 2, 0),
        A7(Kc, 1980, 1980, 4, Jc(3), 0, 2, 60),
        A7(Kc, 1980, 1980, 9, Jc(4), 0, 2, 0),
        A7(Kc, 1981, 1981, 3, Jc(26), 0, 2, 60),
        A7(Kc, 1981, 1981, 8, Jc(27), 0, 2, 0),
        A7(Kc, 1982, 1982, 4, Jc(2), 0, 2, 60),
        A7(Kc, 1982, 1982, 9, Jc(3), 0, 2, 0),
        A7(Kc, 1983, 1983, 3, Jc(18), 0, 2, 60),
        A7(Kc, 1983, 1983, 9, Jc(1), 0, 2, 0),
        A7(Kc, 1984, 1984, 3, Jc(1), 0, 2, 60)
    ]), Pl = fl, Tl = Bl, Fl = k([
        A7(Kc, 1980, 1980, 3, Jc(6), 0, 2, 60),
        A7(Kc, 1980, 1980, 8, Jc(28), 0, 2, 0)
    ]), Ll = el, Ml = function(n) {
        return A3(ce, F2(function(n, r) {
            return A3(Qu, n.a, n.b, r);
        }), oa, n);
    }, Hl = oo, Rl = oo, Ol = k([
        A7(Kc, 1982, 1982, 9, Jc(10), 0, 2, 60),
        A7(Kc, 1983, 1983, 2, Jc(21), 0, 2, 0),
        A7(Kc, 2008, 2008, 9, Yc(6), 120, 2, 60),
        A7(Kc, 2009, 2009, 2, Yc(6), 120, 2, 0)
    ]), Nl = oo, Il = k([
        A7(Kc, 2010, 2010, 8, Yc(6), 0, 2, 60),
        A7(Kc, 2011, 2011, 3, A2(Qc, 5, 1), 240, 2, 0),
        A7(Kc, 2011, 2011, 8, Yc(5), 180, 2, 60),
        A7(Kc, 2012, Cc, 3, A2(Qc, 6, 1), 240, 2, 0),
        A7(Kc, 2012, Cc, 8, Yc(6), 180, 2, 60)
    ]), Vl = k([
        A7(Kc, 1974, 1974, 10, A2(Qc, 6, 1), 165, 1, 60),
        A7(Kc, 1975, 1975, 1, Yc(6), 165, 1, 0),
        A7(Kc, 1975, 1988, 9, Yc(6), 165, 1, 60),
        A7(Kc, 1976, 1989, 2, A2(Qc, 6, 1), 165, 1, 0),
        A7(Kc, 1989, 1989, 9, A2(Qc, 6, 8), 165, 1, 60),
        A7(Kc, 1990, 2006, 9, A2(Qc, 6, 1), 165, 1, 60),
        A7(Kc, 1990, 2007, 2, A2(Qc, 6, 15), 165, 1, 0),
        A7(Kc, 2007, Cc, 8, Yc(6), 165, 1, 60),
        A7(Kc, 2008, Cc, 3, A2(Qc, 6, 1), 165, 1, 0)
    ]), Wl = k([
        A7(Kc, 1983, 1983, 8, Jc(25), 0, 2, 60),
        A7(Kc, 1984, 1991, 2, A2(Qc, 6, 23), 0, 2, 0),
        A7(Kc, 1984, 1984, 9, Jc(23), 0, 2, 60),
        A7(Kc, 1985, 1991, 8, A2(Qc, 6, 23), 0, 2, 60),
        A7(Kc, 1992, 1993, 0, A2(Qc, 6, 23), 0, 2, 0),
        A7(Kc, 1992, 1992, 9, A2(Qc, 6, 23), 0, 2, 60)
    ]), Zl = k([
        A7(Kc, 1998, 1999, 10, A2(Qc, 6, 1), 120, 2, 60),
        A7(Kc, 1999, 2e3, 1, Yc(6), 180, 2, 0),
        A7(Kc, 2009, 2009, 10, Jc(29), 120, 2, 60),
        A7(Kc, 2010, 2010, 2, Yc(6), 180, 2, 0),
        A7(Kc, 2010, 2013, 9, A2(Qc, 6, 21), 120, 2, 60),
        A7(Kc, 2011, 2011, 2, A2(Qc, 6, 1), 180, 2, 0),
        A7(Kc, 2012, 2013, 0, A2(Qc, 6, 18), 180, 2, 0),
        A7(Kc, 2014, 2014, 0, A2(Qc, 6, 18), 120, 2, 0),
        A7(Kc, 2014, 2018, 10, A2(Qc, 6, 1), 120, 2, 60),
        A7(Kc, 2015, Cc, 0, A2(Qc, 6, 12), 180, 2, 0),
        A7(Kc, 2019, 2019, 10, A2(Qc, 6, 8), 120, 2, 60),
        A7(Kc, 2020, 2020, 11, Jc(20), 120, 2, 60),
        A7(Kc, 2021, Cc, 10, A2(Qc, 6, 8), 120, 2, 60)
    ]), Xl = k([
        A7(Kc, 1969, 1969, 0, Jc(26), 1, 2, 0),
        A7(Kc, 1969, 1969, 5, Jc(22), 120, 2, 60),
        A7(Kc, 1969, 1969, 7, Jc(31), 120, 2, 0),
        A7(Kc, 1970, 1971, 3, Yc(6), 120, 2, 60),
        A7(Kc, 1970, 1971, 8, A2(Qc, 6, 1), 120, 2, 0),
        A7(Kc, 1973, 1973, 11, Jc(16), 120, 2, 60),
        A7(Kc, 1974, 1974, 1, Jc(24), 120, 2, 0),
        A7(Kc, 1976, 1976, 4, Jc(26), 120, 2, 60),
        A7(Kc, 1976, 1976, 7, Jc(22), 121, 2, 0),
        A7(Kc, 1977, 1977, 3, Jc(24), 120, 2, 60),
        A7(Kc, 1977, 1977, 7, Jc(28), 120, 2, 0)
    ]), Gl = function() {
        return Xc(A2(kc, k([
            b(A2(xc, 600, wc(Xl)), A5(Dc, 2e3, 11, 23, 0, 2))
        ]), A2(xc, 600, io(0))));
    }, Jl = function() {
        return Xc(A2(kc, h, A2(xc, -660, io(0))));
    }, Yl = Jl, Ql = k([
        A7(Kc, 1977, 1978, 11, A2(Qc, 6, 1), 0, 2, 60),
        A7(Kc, 1978, 1979, 1, Jc(27), 0, 2, 0),
        A7(Kc, 1996, 1996, 11, Jc(1), 120, 1, 60),
        A7(Kc, 1997, 1997, 2, Jc(2), 120, 1, 0)
    ]), Kl = k([
        A7(Kc, 1978, 1978, 10, Jc(12), 0, 2, 30),
        A7(Kc, 1979, 1991, 2, A2(Qc, 6, 1), 0, 2, 0),
        A7(Kc, 1979, 1990, 9, Yc(6), 0, 2, 30)
    ]), nd = Gl, rd = k([
        A7(Kc, 1999, 1999, 9, Jc(7), 120, 1, 60),
        A7(Kc, 2e3, 2e3, 2, Jc(19), 120, 1, 0),
        A7(Kc, 2e3, 2001, 10, A2(Qc, 6, 1), 120, 2, 60),
        A7(Kc, 2001, 2002, 0, Yc(6), 120, 2, 0),
        A7(Kc, 2016, 2016, 10, A2(Qc, 6, 1), 120, 2, 60),
        A7(Kc, 2017, 2017, 0, A2(Qc, 6, 15), 180, 2, 0)
    ]), td = Ml(k([
        b("Africa/Abidjan", co),
        b("Africa/Accra", function() {
            return Xc(A2(kc, h, A2(xc, 0, io(0))));
        }),
        b("Africa/Addis_Ababa", fo),
        b("Africa/Algiers", function() {
            return Xc(A2(kc, k([
                b(A2(xc, 0, wc(so)), A5(Dc, 1977, 9, 21, 0, 2)),
                b(A2(xc, 60, wc(so)), A5(Dc, 1979, 9, 26, 0, 2)),
                b(A2(xc, 0, wc(so)), A5(Dc, 1981, 4, 1, 0, 2))
            ]), A2(xc, 60, io(0))));
        }),
        b("Africa/Asmara", lo),
        b("Africa/Bamako", bo),
        b("Africa/Bangui", mo),
        b("Africa/Banjul", po),
        b("Africa/Bissau", function() {
            return Xc(A2(kc, k([
                b(A2(xc, -60, io(0)), A5(Dc, 1975, 0, 1, 0, 2))
            ]), A2(xc, 0, io(0))));
        }),
        b("Africa/Blantyre", ho),
        b("Africa/Brazzaville", go),
        b("Africa/Bujumbura", wo),
        b("Africa/Cairo", function() {
            return Xc(A2(kc, h, A2(xc, 120, wc(ko))));
        }),
        b("Africa/Casablanca", function() {
            return Xc(A2(kc, k([
                b(A2(xc, 0, wc(xo)), A5(Dc, 1984, 2, 16, 0, 2)),
                b(A2(xc, 60, io(0)), A5(Dc, 1986, 0, 1, 0, 2)),
                b(A2(xc, 0, wc(xo)), A5(Dc, 2018, 9, 28, 180, 2))
            ]), A2(xc, 60, wc(xo))));
        }),
        b("Africa/Ceuta", function() {
            return Xc(A2(kc, k([
                b(A2(xc, 0, wc(_o)), A5(Dc, 1984, 2, 16, 0, 2)),
                b(A2(xc, 60, io(0)), A5(Dc, 1986, 0, 1, 0, 2))
            ]), A2(xc, 60, wc(yo))));
        }),
        b("Africa/Conakry", Co),
        b("Africa/Dakar", Do),
        b("Africa/Dar_es_Salaam", Ao),
        b("Africa/Djibouti", qo),
        b("Africa/Douala", Bo),
        b("Africa/El_Aaiun", function() {
            return Xc(A2(kc, k([
                b(A2(xc, -60, io(0)), A5(Dc, 1976, 3, 14, 0, 2)),
                b(A2(xc, 0, wc(xo)), A5(Dc, 2018, 9, 28, 180, 2))
            ]), A2(xc, 60, wc(xo))));
        }),
        b("Africa/Freetown", jo),
        b("Africa/Gaborone", So),
        b("Africa/Harare", zo),
        b("Africa/Johannesburg", Uo),
        b("Africa/Juba", function() {
            return Xc(A2(kc, k([
                b(A2(xc, 120, wc(Eo)), A5(Dc, 2e3, 0, 15, 720, 2))
            ]), A2(xc, 180, io(0))));
        }),
        b("Africa/Kampala", Po),
        b("Africa/Khartoum", function() {
            return Xc(A2(kc, k([
                b(A2(xc, 120, wc(Eo)), A5(Dc, 2e3, 0, 15, 720, 2)),
                b(A2(xc, 180, io(0)), A5(Dc, 2017, 10, 1, 0, 2))
            ]), A2(xc, 120, io(0))));
        }),
        b("Africa/Kigali", To),
        b("Africa/Kinshasa", Fo),
        b("Africa/Lagos", vo),
        b("Africa/Libreville", Lo),
        b("Africa/Lome", Mo),
        b("Africa/Luanda", Ho),
        b("Africa/Lubumbashi", Ro),
        b("Africa/Lusaka", Oo),
        b("Africa/Malabo", No),
        b("Africa/Maputo", $o),
        b("Africa/Maseru", Io),
        b("Africa/Mbabane", Vo),
        b("Africa/Mogadishu", Wo),
        b("Africa/Monrovia", function() {
            return Xc(A2(kc, k([
                b(A2(xc, -45, io(0)), A5(Dc, 1972, 0, 7, 0, 2))
            ]), A2(xc, 0, io(0))));
        }),
        b("Africa/Nairobi", oo),
        b("Africa/Ndjamena", function() {
            return Xc(A2(kc, k([
                b(A2(xc, 60, io(0)), A5(Dc, 1979, 9, 14, 0, 2)),
                b(A2(xc, 60, io(60)), A5(Dc, 1980, 2, 8, 0, 2))
            ]), A2(xc, 60, io(0))));
        }),
        b("Africa/Niamey", Zo),
        b("Africa/Nouakchott", Xo),
        b("Africa/Ouagadougou", Go),
        b("Africa/Porto-Novo", Jo),
        b("Africa/Sao_Tome", function() {
            return Xc(A2(kc, k([
                b(A2(xc, 0, io(0)), A5(Dc, 2018, 0, 1, 60, 2)),
                b(A2(xc, 60, io(0)), A5(Dc, 2019, 0, 1, 120, 2))
            ]), A2(xc, 0, io(0))));
        }),
        b("Africa/Tripoli", function() {
            return Xc(A2(kc, k([
                b(A2(xc, 120, io(0)), A5(Dc, 1982, 0, 1, 0, 2)),
                b(A2(xc, 60, wc(Yo)), A5(Dc, 1990, 4, 4, 0, 2)),
                b(A2(xc, 120, io(0)), A5(Dc, 1996, 8, 30, 0, 2)),
                b(A2(xc, 60, wc(Yo)), A5(Dc, 1997, 9, 4, 0, 2)),
                b(A2(xc, 120, io(0)), A5(Dc, 2012, 10, 10, 120, 2)),
                b(A2(xc, 60, wc(Yo)), A5(Dc, 2013, 9, 25, 120, 2))
            ]), A2(xc, 120, io(0))));
        }),
        b("Africa/Tunis", function() {
            return Xc(A2(kc, h, A2(xc, 60, wc(Qo))));
        }),
        b("Africa/Windhoek", function() {
            return Xc(A2(kc, k([
                b(A2(xc, 120, io(0)), A5(Dc, 1990, 2, 21, 0, 2))
            ]), A2(xc, 120, wc(Ko))));
        }),
        b("America/Adak", function() {
            return Xc(A2(kc, k([
                b(A2(xc, -660, wc(no)), A5(Dc, 1983, 9, 30, 120, 2)),
                b(A2(xc, -600, wc(no)), A5(Dc, 1983, 10, 30, 0, 2))
            ]), A2(xc, -600, wc(no))));
        }),
        b("America/Anchorage", function() {
            return Xc(A2(kc, k([
                b(A2(xc, -600, wc(no)), A5(Dc, 1983, 9, 30, 120, 2)),
                b(A2(xc, -540, wc(no)), A5(Dc, 1983, 10, 30, 0, 2))
            ]), A2(xc, -540, wc(no))));
        }),
        b("America/Anguilla", rf),
        b("America/Antigua", tf),
        b("America/Araguaina", function() {
            return Xc(A2(kc, k([
                b(A2(xc, -180, wc(ef)), A5(Dc, 1990, 8, 17, 0, 2)),
                b(A2(xc, -180, io(0)), A5(Dc, 1995, 8, 14, 0, 2)),
                b(A2(xc, -180, wc(ef)), A5(Dc, 2003, 8, 24, 0, 2)),
                b(A2(xc, -180, io(0)), A5(Dc, 2012, 9, 21, 0, 2)),
                b(A2(xc, -180, wc(ef)), A5(Dc, 2013, 8, 1, 0, 2))
            ]), A2(xc, -180, io(0))));
        }),
        b("America/Argentina/Buenos_Aires", function() {
            return Xc(A2(kc, k([
                b(A2(xc, -180, wc(uf)), A5(Dc, 1999, 9, 3, 0, 2)),
                b(A2(xc, -240, wc(uf)), A5(Dc, 2e3, 2, 3, 0, 2))
            ]), A2(xc, -180, wc(uf))));
        }),
        b("America/Argentina/Catamarca", function() {
            return Xc(A2(kc, k([
                b(A2(xc, -180, wc(uf)), A5(Dc, 1991, 2, 3, 0, 2)),
                b(A2(xc, -240, io(0)), A5(Dc, 1991, 9, 20, 0, 2)),
                b(A2(xc, -180, wc(uf)), A5(Dc, 1999, 9, 3, 0, 2)),
                b(A2(xc, -240, wc(uf)), A5(Dc, 2e3, 2, 3, 0, 2)),
                b(A2(xc, -180, io(0)), A5(Dc, 2004, 5, 1, 0, 2)),
                b(A2(xc, -240, io(0)), A5(Dc, 2004, 5, 20, 0, 2)),
                b(A2(xc, -180, wc(uf)), A5(Dc, 2008, 9, 18, 0, 2))
            ]), A2(xc, -180, io(0))));
        }),
        b("America/Argentina/Cordoba", function() {
            return Xc(A2(kc, k([
                b(A2(xc, -180, wc(uf)), A5(Dc, 1991, 2, 3, 0, 2)),
                b(A2(xc, -240, io(0)), A5(Dc, 1991, 9, 20, 0, 2)),
                b(A2(xc, -180, wc(uf)), A5(Dc, 1999, 9, 3, 0, 2)),
                b(A2(xc, -240, wc(uf)), A5(Dc, 2e3, 2, 3, 0, 2))
            ]), A2(xc, -180, wc(uf))));
        }),
        b("America/Argentina/Jujuy", function() {
            return Xc(A2(kc, k([
                b(A2(xc, -180, wc(uf)), A5(Dc, 1990, 2, 4, 0, 2)),
                b(A2(xc, -240, io(0)), A5(Dc, 1990, 9, 28, 0, 2)),
                b(A2(xc, -240, io(60)), A5(Dc, 1991, 2, 17, 0, 2)),
                b(A2(xc, -240, io(0)), A5(Dc, 1991, 9, 6, 0, 2)),
                b(A2(xc, -180, io(60)), A5(Dc, 1992, 0, 1, 0, 2)),
                b(A2(xc, -180, wc(uf)), A5(Dc, 1999, 9, 3, 0, 2)),
                b(A2(xc, -240, wc(uf)), A5(Dc, 2e3, 2, 3, 0, 2)),
                b(A2(xc, -180, wc(uf)), A5(Dc, 2008, 9, 18, 0, 2))
            ]), A2(xc, -180, io(0))));
        }),
        b("America/Argentina/La_Rioja", function() {
            return Xc(A2(kc, k([
                b(A2(xc, -180, wc(uf)), A5(Dc, 1991, 2, 1, 0, 2)),
                b(A2(xc, -240, io(0)), A5(Dc, 1991, 4, 7, 0, 2)),
                b(A2(xc, -180, wc(uf)), A5(Dc, 1999, 9, 3, 0, 2)),
                b(A2(xc, -240, wc(uf)), A5(Dc, 2e3, 2, 3, 0, 2)),
                b(A2(xc, -180, io(0)), A5(Dc, 2004, 5, 1, 0, 2)),
                b(A2(xc, -240, io(0)), A5(Dc, 2004, 5, 20, 0, 2)),
                b(A2(xc, -180, wc(uf)), A5(Dc, 2008, 9, 18, 0, 2))
            ]), A2(xc, -180, io(0))));
        }),
        b("America/Argentina/Mendoza", function() {
            return Xc(A2(kc, k([
                b(A2(xc, -180, wc(uf)), A5(Dc, 1990, 2, 4, 0, 2)),
                b(A2(xc, -240, io(0)), A5(Dc, 1990, 9, 15, 0, 2)),
                b(A2(xc, -240, io(60)), A5(Dc, 1991, 2, 1, 0, 2)),
                b(A2(xc, -240, io(0)), A5(Dc, 1991, 9, 15, 0, 2)),
                b(A2(xc, -240, io(60)), A5(Dc, 1992, 2, 1, 0, 2)),
                b(A2(xc, -240, io(0)), A5(Dc, 1992, 9, 18, 0, 2)),
                b(A2(xc, -180, wc(uf)), A5(Dc, 1999, 9, 3, 0, 2)),
                b(A2(xc, -240, wc(uf)), A5(Dc, 2e3, 2, 3, 0, 2)),
                b(A2(xc, -180, io(0)), A5(Dc, 2004, 4, 23, 0, 2)),
                b(A2(xc, -240, io(0)), A5(Dc, 2004, 8, 26, 0, 2)),
                b(A2(xc, -180, wc(uf)), A5(Dc, 2008, 9, 18, 0, 2))
            ]), A2(xc, -180, io(0))));
        }),
        b("America/Argentina/Rio_Gallegos", function() {
            return Xc(A2(kc, k([
                b(A2(xc, -180, wc(uf)), A5(Dc, 1999, 9, 3, 0, 2)),
                b(A2(xc, -240, wc(uf)), A5(Dc, 2e3, 2, 3, 0, 2)),
                b(A2(xc, -180, io(0)), A5(Dc, 2004, 5, 1, 0, 2)),
                b(A2(xc, -240, io(0)), A5(Dc, 2004, 5, 20, 0, 2)),
                b(A2(xc, -180, wc(uf)), A5(Dc, 2008, 9, 18, 0, 2))
            ]), A2(xc, -180, io(0))));
        }),
        b("America/Argentina/Salta", function() {
            return Xc(A2(kc, k([
                b(A2(xc, -180, wc(uf)), A5(Dc, 1991, 2, 3, 0, 2)),
                b(A2(xc, -240, io(0)), A5(Dc, 1991, 9, 20, 0, 2)),
                b(A2(xc, -180, wc(uf)), A5(Dc, 1999, 9, 3, 0, 2)),
                b(A2(xc, -240, wc(uf)), A5(Dc, 2e3, 2, 3, 0, 2)),
                b(A2(xc, -180, wc(uf)), A5(Dc, 2008, 9, 18, 0, 2))
            ]), A2(xc, -180, io(0))));
        }),
        b("America/Argentina/San_Juan", function() {
            return Xc(A2(kc, k([
                b(A2(xc, -180, wc(uf)), A5(Dc, 1991, 2, 1, 0, 2)),
                b(A2(xc, -240, io(0)), A5(Dc, 1991, 4, 7, 0, 2)),
                b(A2(xc, -180, wc(uf)), A5(Dc, 1999, 9, 3, 0, 2)),
                b(A2(xc, -240, wc(uf)), A5(Dc, 2e3, 2, 3, 0, 2)),
                b(A2(xc, -180, io(0)), A5(Dc, 2004, 4, 31, 0, 2)),
                b(A2(xc, -240, io(0)), A5(Dc, 2004, 6, 25, 0, 2)),
                b(A2(xc, -180, wc(uf)), A5(Dc, 2008, 9, 18, 0, 2))
            ]), A2(xc, -180, io(0))));
        }),
        b("America/Argentina/San_Luis", function() {
            return Xc(A2(kc, k([
                b(A2(xc, -180, wc(uf)), A5(Dc, 1990, 0, 1, 0, 2)),
                b(A2(xc, -180, io(60)), A5(Dc, 1990, 2, 14, 0, 2)),
                b(A2(xc, -240, io(0)), A5(Dc, 1990, 9, 15, 0, 2)),
                b(A2(xc, -240, io(60)), A5(Dc, 1991, 2, 1, 0, 2)),
                b(A2(xc, -240, io(0)), A5(Dc, 1991, 5, 1, 0, 2)),
                b(A2(xc, -180, io(0)), A5(Dc, 1999, 9, 3, 0, 2)),
                b(A2(xc, -240, io(60)), A5(Dc, 2e3, 2, 3, 0, 2)),
                b(A2(xc, -180, io(0)), A5(Dc, 2004, 4, 31, 0, 2)),
                b(A2(xc, -240, io(0)), A5(Dc, 2004, 6, 25, 0, 2)),
                b(A2(xc, -180, wc(uf)), A5(Dc, 2008, 0, 21, 0, 2)),
                b(A2(xc, -240, wc(af)), A5(Dc, 2009, 9, 11, 0, 2))
            ]), A2(xc, -180, io(0))));
        }),
        b("America/Argentina/Tucuman", function() {
            return Xc(A2(kc, k([
                b(A2(xc, -180, wc(uf)), A5(Dc, 1991, 2, 3, 0, 2)),
                b(A2(xc, -240, io(0)), A5(Dc, 1991, 9, 20, 0, 2)),
                b(A2(xc, -180, wc(uf)), A5(Dc, 1999, 9, 3, 0, 2)),
                b(A2(xc, -240, wc(uf)), A5(Dc, 2e3, 2, 3, 0, 2)),
                b(A2(xc, -180, io(0)), A5(Dc, 2004, 5, 1, 0, 2)),
                b(A2(xc, -240, io(0)), A5(Dc, 2004, 5, 13, 0, 2))
            ]), A2(xc, -180, wc(uf))));
        }),
        b("America/Argentina/Ushuaia", function() {
            return Xc(A2(kc, k([
                b(A2(xc, -180, wc(uf)), A5(Dc, 1999, 9, 3, 0, 2)),
                b(A2(xc, -240, wc(uf)), A5(Dc, 2e3, 2, 3, 0, 2)),
                b(A2(xc, -180, io(0)), A5(Dc, 2004, 4, 30, 0, 2)),
                b(A2(xc, -240, io(0)), A5(Dc, 2004, 5, 20, 0, 2)),
                b(A2(xc, -180, wc(uf)), A5(Dc, 2008, 9, 18, 0, 2))
            ]), A2(xc, -180, io(0))));
        }),
        b("America/Aruba", of),
        b("America/Asuncion", function() {
            return Xc(A2(kc, k([
                b(A2(xc, -240, io(0)), A5(Dc, 1972, 9, 1, 0, 2)),
                b(A2(xc, -180, io(0)), A5(Dc, 1974, 3, 1, 0, 2))
            ]), A2(xc, -240, wc(ff))));
        }),
        b("America/Atikokan", function() {
            return Xc(A2(kc, h, A2(xc, -300, io(0))));
        }),
        b("America/Bahia", function() {
            return Xc(A2(kc, k([
                b(A2(xc, -180, wc(ef)), A5(Dc, 2003, 8, 24, 0, 2)),
                b(A2(xc, -180, io(0)), A5(Dc, 2011, 9, 16, 0, 2)),
                b(A2(xc, -180, wc(ef)), A5(Dc, 2012, 9, 21, 0, 2))
            ]), A2(xc, -180, io(0))));
        }),
        b("America/Bahia_Banderas", function() {
            return Xc(A2(kc, k([
                b(A2(xc, -480, io(0)), A5(Dc, 1970, 0, 1, 0, 2)),
                b(A2(xc, -420, wc(sf)), A5(Dc, 2010, 3, 4, 120, 2))
            ]), A2(xc, -360, wc(sf))));
        }),
        b("America/Barbados", function() {
            return Xc(A2(kc, h, A2(xc, -240, wc(lf))));
        }),
        b("America/Belem", function() {
            return Xc(A2(kc, k([
                b(A2(xc, -180, wc(ef)), A5(Dc, 1988, 8, 12, 0, 2))
            ]), A2(xc, -180, io(0))));
        }),
        b("America/Belize", function() {
            return Xc(A2(kc, h, A2(xc, -360, wc(df))));
        }),
        b("America/Blanc-Sablon", function() {
            return Xc(A2(kc, k([
                b(A2(xc, -240, wc(bf)), A5(Dc, 1970, 0, 1, 0, 2))
            ]), A2(xc, -240, io(0))));
        }),
        b("America/Boa_Vista", function() {
            return Xc(A2(kc, k([
                b(A2(xc, -240, wc(ef)), A5(Dc, 1988, 8, 12, 0, 2)),
                b(A2(xc, -240, io(0)), A5(Dc, 1999, 8, 30, 0, 2)),
                b(A2(xc, -240, wc(ef)), A5(Dc, 2e3, 9, 15, 0, 2))
            ]), A2(xc, -240, io(0))));
        }),
        b("America/Bogota", function() {
            return Xc(A2(kc, h, A2(xc, -300, wc(vf))));
        }),
        b("America/Boise", function() {
            return Xc(A2(kc, k([
                b(A2(xc, -420, wc(no)), A5(Dc, 1974, 0, 1, 0, 2)),
                b(A2(xc, -420, io(0)), A5(Dc, 1974, 1, 3, 120, 2))
            ]), A2(xc, -420, wc(no))));
        }),
        b("America/Cambridge_Bay", function() {
            return Xc(A2(kc, k([
                b(A2(xc, -420, wc(mf)), A5(Dc, 1999, 9, 31, 120, 2)),
                b(A2(xc, -360, wc(bf)), A5(Dc, 2e3, 9, 29, 120, 2)),
                b(A2(xc, -300, io(0)), A5(Dc, 2e3, 10, 5, 0, 2)),
                b(A2(xc, -360, io(0)), A5(Dc, 2001, 3, 1, 180, 2))
            ]), A2(xc, -420, wc(bf))));
        }),
        b("America/Campo_Grande", function() {
            return Xc(A2(kc, h, A2(xc, -240, wc(ef))));
        }),
        b("America/Cancun", function() {
            return Xc(A2(kc, k([
                b(A2(xc, -360, io(0)), A5(Dc, 1981, 11, 23, 0, 2)),
                b(A2(xc, -300, wc(sf)), A5(Dc, 1998, 7, 2, 120, 2)),
                b(A2(xc, -360, wc(sf)), A5(Dc, 2015, 1, 1, 120, 2))
            ]), A2(xc, -300, io(0))));
        }),
        b("America/Caracas", function() {
            return Xc(A2(kc, k([
                b(A2(xc, -240, io(0)), A5(Dc, 2007, 11, 9, 180, 2)),
                b(A2(xc, -270, io(0)), A5(Dc, 2016, 4, 1, 150, 2))
            ]), A2(xc, -240, io(0))));
        }),
        b("America/Cayenne", function() {
            return Xc(A2(kc, h, A2(xc, -180, io(0))));
        }),
        b("America/Cayman", $f),
        b("America/Chicago", function() {
            return Xc(A2(kc, h, A2(xc, -360, wc(no))));
        }),
        b("America/Chihuahua", function() {
            return Xc(A2(kc, k([
                b(A2(xc, -360, io(0)), A5(Dc, 1996, 0, 1, 0, 2)),
                b(A2(xc, -360, wc(sf)), A5(Dc, 1998, 0, 1, 0, 2)),
                b(A2(xc, -360, io(0)), A5(Dc, 1998, 3, 5, 180, 2))
            ]), A2(xc, -420, wc(sf))));
        }),
        b("America/Costa_Rica", function() {
            return Xc(A2(kc, h, A2(xc, -360, wc(hf))));
        }),
        b("America/Creston", function() {
            return Xc(A2(kc, h, A2(xc, -420, io(0))));
        }),
        b("America/Cuiaba", function() {
            return Xc(A2(kc, k([
                b(A2(xc, -240, wc(ef)), A5(Dc, 2003, 8, 24, 0, 2)),
                b(A2(xc, -240, io(0)), A5(Dc, 2004, 9, 1, 0, 2))
            ]), A2(xc, -240, wc(ef))));
        }),
        b("America/Curacao", cf),
        b("America/Danmarkshavn", function() {
            return Xc(A2(kc, k([
                b(A2(xc, -180, io(0)), A5(Dc, 1980, 3, 6, 120, 2)),
                b(A2(xc, -180, wc(yo)), A5(Dc, 1996, 0, 1, 0, 2))
            ]), A2(xc, 0, io(0))));
        }),
        b("America/Dawson", function() {
            return Xc(A2(kc, k([
                b(A2(xc, -540, wc(mf)), A5(Dc, 1973, 9, 28, 0, 2)),
                b(A2(xc, -480, wc(mf)), A5(Dc, 1980, 0, 1, 0, 2)),
                b(A2(xc, -480, wc(bf)), A5(Dc, 2020, 10, 1, 0, 2))
            ]), A2(xc, -420, io(0))));
        }),
        b("America/Dawson_Creek", function() {
            return Xc(A2(kc, k([
                b(A2(xc, -480, wc(gf)), A5(Dc, 1972, 7, 30, 120, 2))
            ]), A2(xc, -420, io(0))));
        }),
        b("America/Denver", function() {
            return Xc(A2(kc, h, A2(xc, -420, wc(no))));
        }),
        b("America/Detroit", function() {
            return Xc(A2(kc, k([
                b(A2(xc, -300, io(0)), A5(Dc, 1973, 0, 1, 0, 2)),
                b(A2(xc, -300, wc(no)), A5(Dc, 1975, 0, 1, 0, 2)),
                b(A2(xc, -300, io(0)), A5(Dc, 1975, 3, 27, 120, 2))
            ]), A2(xc, -300, wc(no))));
        }),
        b("America/Dominica", wf),
        b("America/Edmonton", function() {
            return Xc(A2(kc, k([
                b(A2(xc, -420, wc(kf)), A5(Dc, 1987, 0, 1, 0, 2))
            ]), A2(xc, -420, wc(bf))));
        }),
        b("America/Eirunepe", function() {
            return Xc(A2(kc, k([
                b(A2(xc, -300, wc(ef)), A5(Dc, 1988, 8, 12, 0, 2)),
                b(A2(xc, -300, io(0)), A5(Dc, 1993, 8, 28, 0, 2)),
                b(A2(xc, -300, wc(ef)), A5(Dc, 1994, 8, 22, 0, 2)),
                b(A2(xc, -300, io(0)), A5(Dc, 2008, 5, 24, 0, 2)),
                b(A2(xc, -240, io(0)), A5(Dc, 2013, 10, 10, 0, 2))
            ]), A2(xc, -300, io(0))));
        }),
        b("America/El_Salvador", function() {
            return Xc(A2(kc, h, A2(xc, -360, wc(xf))));
        }),
        b("America/Fort_Nelson", function() {
            return Xc(A2(kc, k([
                b(A2(xc, -480, wc(gf)), A5(Dc, 1987, 0, 1, 0, 2)),
                b(A2(xc, -480, wc(bf)), A5(Dc, 2015, 2, 8, 120, 2))
            ]), A2(xc, -420, io(0))));
        }),
        b("America/Fortaleza", function() {
            return Xc(A2(kc, k([
                b(A2(xc, -180, wc(ef)), A5(Dc, 1990, 8, 17, 0, 2)),
                b(A2(xc, -180, io(0)), A5(Dc, 1999, 8, 30, 0, 2)),
                b(A2(xc, -180, wc(ef)), A5(Dc, 2e3, 9, 22, 0, 2)),
                b(A2(xc, -180, io(0)), A5(Dc, 2001, 8, 13, 0, 2)),
                b(A2(xc, -180, wc(ef)), A5(Dc, 2002, 9, 1, 0, 2))
            ]), A2(xc, -180, io(0))));
        }),
        b("America/Glace_Bay", function() {
            return Xc(A2(kc, k([
                b(A2(xc, -240, io(0)), A5(Dc, 1972, 0, 1, 0, 2)),
                b(A2(xc, -240, wc(yf)), A5(Dc, 1974, 0, 1, 0, 2))
            ]), A2(xc, -240, wc(bf))));
        }),
        b("America/Goose_Bay", function() {
            return Xc(A2(kc, k([
                b(A2(xc, -240, wc(_f)), A5(Dc, 2011, 10, 1, 0, 2))
            ]), A2(xc, -240, wc(bf))));
        }),
        b("America/Grand_Turk", function() {
            return Xc(A2(kc, k([
                b(A2(xc, -300, io(0)), A5(Dc, 1979, 0, 1, 0, 2)),
                b(A2(xc, -300, wc(no)), A5(Dc, 2015, 10, 1, 120, 2)),
                b(A2(xc, -240, io(0)), A5(Dc, 2018, 2, 11, 180, 2))
            ]), A2(xc, -300, wc(no))));
        }),
        b("America/Grenada", Cf),
        b("America/Guadeloupe", Df),
        b("America/Guatemala", function() {
            return Xc(A2(kc, h, A2(xc, -360, wc(Af))));
        }),
        b("America/Guayaquil", function() {
            return Xc(A2(kc, h, A2(xc, -300, wc(qf))));
        }),
        b("America/Guyana", function() {
            return Xc(A2(kc, k([
                b(A2(xc, -225, io(0)), A5(Dc, 1975, 6, 31, 0, 2)),
                b(A2(xc, -180, io(0)), A5(Dc, 1991, 0, 1, 0, 2))
            ]), A2(xc, -240, io(0))));
        }),
        b("America/Halifax", function() {
            return Xc(A2(kc, k([
                b(A2(xc, -240, wc(yf)), A5(Dc, 1974, 0, 1, 0, 2))
            ]), A2(xc, -240, wc(bf))));
        }),
        b("America/Havana", function() {
            return Xc(A2(kc, h, A2(xc, -300, wc(Bf))));
        }),
        b("America/Hermosillo", function() {
            return Xc(A2(kc, k([
                b(A2(xc, -480, io(0)), A5(Dc, 1970, 0, 1, 0, 2)),
                b(A2(xc, -420, wc(sf)), A5(Dc, 1999, 0, 1, 0, 2))
            ]), A2(xc, -420, io(0))));
        }),
        b("America/Indiana/Indianapolis", function() {
            return Xc(A2(kc, k([
                b(A2(xc, -300, wc(no)), A5(Dc, 1971, 0, 1, 0, 2)),
                b(A2(xc, -300, io(0)), A5(Dc, 2006, 0, 1, 0, 2))
            ]), A2(xc, -300, wc(no))));
        }),
        b("America/Indiana/Knox", function() {
            return Xc(A2(kc, k([
                b(A2(xc, -360, wc(no)), A5(Dc, 1991, 9, 27, 120, 2)),
                b(A2(xc, -300, io(0)), A5(Dc, 2006, 3, 2, 120, 2))
            ]), A2(xc, -360, wc(no))));
        }),
        b("America/Indiana/Marengo", function() {
            return Xc(A2(kc, k([
                b(A2(xc, -300, wc(no)), A5(Dc, 1974, 0, 6, 120, 2)),
                b(A2(xc, -360, io(60)), A5(Dc, 1974, 9, 27, 120, 2)),
                b(A2(xc, -300, wc(no)), A5(Dc, 1976, 0, 1, 0, 2)),
                b(A2(xc, -300, io(0)), A5(Dc, 2006, 0, 1, 0, 2))
            ]), A2(xc, -300, wc(no))));
        }),
        b("America/Indiana/Petersburg", function() {
            return Xc(A2(kc, k([
                b(A2(xc, -360, wc(no)), A5(Dc, 1977, 9, 30, 120, 2)),
                b(A2(xc, -300, io(0)), A5(Dc, 2006, 3, 2, 120, 2)),
                b(A2(xc, -360, wc(no)), A5(Dc, 2007, 10, 4, 120, 2))
            ]), A2(xc, -300, wc(no))));
        }),
        b("America/Indiana/Tell_City", function() {
            return Xc(A2(kc, k([
                b(A2(xc, -300, wc(no)), A5(Dc, 1971, 0, 1, 0, 2)),
                b(A2(xc, -300, io(0)), A5(Dc, 2006, 3, 2, 120, 2))
            ]), A2(xc, -360, wc(no))));
        }),
        b("America/Indiana/Vevay", function() {
            return Xc(A2(kc, k([
                b(A2(xc, -300, wc(no)), A5(Dc, 1973, 0, 1, 0, 2)),
                b(A2(xc, -300, io(0)), A5(Dc, 2006, 0, 1, 0, 2))
            ]), A2(xc, -300, wc(no))));
        }),
        b("America/Indiana/Vincennes", function() {
            return Xc(A2(kc, k([
                b(A2(xc, -300, wc(no)), A5(Dc, 1971, 0, 1, 0, 2)),
                b(A2(xc, -300, io(0)), A5(Dc, 2006, 3, 2, 120, 2)),
                b(A2(xc, -360, wc(no)), A5(Dc, 2007, 10, 4, 120, 2))
            ]), A2(xc, -300, wc(no))));
        }),
        b("America/Indiana/Winamac", function() {
            return Xc(A2(kc, k([
                b(A2(xc, -300, wc(no)), A5(Dc, 1971, 0, 1, 0, 2)),
                b(A2(xc, -300, io(0)), A5(Dc, 2006, 3, 2, 120, 2)),
                b(A2(xc, -360, wc(no)), A5(Dc, 2007, 2, 11, 120, 2))
            ]), A2(xc, -300, wc(no))));
        }),
        b("America/Inuvik", function() {
            return Xc(A2(kc, k([
                b(A2(xc, -480, wc(mf)), A5(Dc, 1979, 3, 29, 120, 2)),
                b(A2(xc, -420, wc(mf)), A5(Dc, 1980, 0, 1, 0, 2))
            ]), A2(xc, -420, wc(bf))));
        }),
        b("America/Iqaluit", function() {
            return Xc(A2(kc, k([
                b(A2(xc, -300, wc(mf)), A5(Dc, 1999, 9, 31, 120, 2)),
                b(A2(xc, -360, wc(bf)), A5(Dc, 2e3, 9, 29, 120, 2))
            ]), A2(xc, -300, wc(bf))));
        }),
        b("America/Jamaica", function() {
            return Xc(A2(kc, k([
                b(A2(xc, -300, io(0)), A5(Dc, 1974, 0, 1, 0, 2)),
                b(A2(xc, -300, wc(no)), A5(Dc, 1984, 0, 1, 0, 2))
            ]), A2(xc, -300, io(0))));
        }),
        b("America/Juneau", function() {
            return Xc(A2(kc, k([
                b(A2(xc, -480, wc(no)), A5(Dc, 1980, 3, 27, 120, 2)),
                b(A2(xc, -540, wc(no)), A5(Dc, 1980, 9, 26, 120, 2)),
                b(A2(xc, -480, wc(no)), A5(Dc, 1983, 9, 30, 120, 2)),
                b(A2(xc, -540, wc(no)), A5(Dc, 1983, 10, 30, 0, 2))
            ]), A2(xc, -540, wc(no))));
        }),
        b("America/Kentucky/Louisville", function() {
            return Xc(A2(kc, k([
                b(A2(xc, -300, wc(no)), A5(Dc, 1974, 0, 6, 120, 2)),
                b(A2(xc, -360, io(60)), A5(Dc, 1974, 9, 27, 120, 2))
            ]), A2(xc, -300, wc(no))));
        }),
        b("America/Kentucky/Monticello", function() {
            return Xc(A2(kc, k([
                b(A2(xc, -360, wc(no)), A5(Dc, 2e3, 9, 29, 120, 2))
            ]), A2(xc, -300, wc(no))));
        }),
        b("America/Kralendijk", jf),
        b("America/La_Paz", function() {
            return Xc(A2(kc, h, A2(xc, -240, io(0))));
        }),
        b("America/Lima", function() {
            return Xc(A2(kc, h, A2(xc, -300, wc(Sf))));
        }),
        b("America/Los_Angeles", ro),
        b("America/Lower_Princes", zf),
        b("America/Maceio", function() {
            return Xc(A2(kc, k([
                b(A2(xc, -180, wc(ef)), A5(Dc, 1990, 8, 17, 0, 2)),
                b(A2(xc, -180, io(0)), A5(Dc, 1995, 9, 13, 0, 2)),
                b(A2(xc, -180, wc(ef)), A5(Dc, 1996, 8, 4, 0, 2)),
                b(A2(xc, -180, io(0)), A5(Dc, 1999, 8, 30, 0, 2)),
                b(A2(xc, -180, wc(ef)), A5(Dc, 2e3, 9, 22, 0, 2)),
                b(A2(xc, -180, io(0)), A5(Dc, 2001, 8, 13, 0, 2)),
                b(A2(xc, -180, wc(ef)), A5(Dc, 2002, 9, 1, 0, 2))
            ]), A2(xc, -180, io(0))));
        }),
        b("America/Managua", function() {
            return Xc(A2(kc, k([
                b(A2(xc, -360, io(0)), A5(Dc, 1973, 4, 1, 0, 2)),
                b(A2(xc, -300, io(0)), A5(Dc, 1975, 1, 16, 0, 2)),
                b(A2(xc, -360, wc(Uf)), A5(Dc, 1992, 0, 1, 240, 2)),
                b(A2(xc, -300, io(0)), A5(Dc, 1992, 8, 24, 0, 2)),
                b(A2(xc, -360, io(0)), A5(Dc, 1993, 0, 1, 0, 2)),
                b(A2(xc, -300, io(0)), A5(Dc, 1997, 0, 1, 0, 2))
            ]), A2(xc, -360, wc(Uf))));
        }),
        b("America/Manaus", function() {
            return Xc(A2(kc, k([
                b(A2(xc, -240, wc(ef)), A5(Dc, 1988, 8, 12, 0, 2)),
                b(A2(xc, -240, io(0)), A5(Dc, 1993, 8, 28, 0, 2)),
                b(A2(xc, -240, wc(ef)), A5(Dc, 1994, 8, 22, 0, 2))
            ]), A2(xc, -240, io(0))));
        }),
        b("America/Marigot", Ef),
        b("America/Martinique", function() {
            return Xc(A2(kc, k([
                b(A2(xc, -240, io(0)), A5(Dc, 1980, 3, 6, 0, 2)),
                b(A2(xc, -240, io(60)), A5(Dc, 1980, 8, 28, 0, 2))
            ]), A2(xc, -240, io(0))));
        }),
        b("America/Matamoros", function() {
            return Xc(A2(kc, k([
                b(A2(xc, -360, io(0)), A5(Dc, 1988, 0, 1, 0, 2)),
                b(A2(xc, -360, wc(no)), A5(Dc, 1989, 0, 1, 0, 2)),
                b(A2(xc, -360, wc(sf)), A5(Dc, 2010, 0, 1, 0, 2))
            ]), A2(xc, -360, wc(no))));
        }),
        b("America/Mazatlan", function() {
            return Xc(A2(kc, k([
                b(A2(xc, -480, io(0)), A5(Dc, 1970, 0, 1, 0, 2))
            ]), A2(xc, -420, wc(sf))));
        }),
        b("America/Menominee", function() {
            return Xc(A2(kc, k([
                b(A2(xc, -300, io(0)), A5(Dc, 1973, 3, 29, 120, 2))
            ]), A2(xc, -360, wc(no))));
        }),
        b("America/Merida", function() {
            return Xc(A2(kc, k([
                b(A2(xc, -360, io(0)), A5(Dc, 1981, 11, 23, 0, 2)),
                b(A2(xc, -300, io(0)), A5(Dc, 1982, 11, 2, 0, 2))
            ]), A2(xc, -360, wc(sf))));
        }),
        b("America/Metlakatla", function() {
            return Xc(A2(kc, k([
                b(A2(xc, -480, wc(no)), A5(Dc, 1983, 9, 30, 120, 2)),
                b(A2(xc, -480, io(0)), A5(Dc, 2015, 10, 1, 120, 2)),
                b(A2(xc, -540, wc(no)), A5(Dc, 2018, 10, 4, 120, 2)),
                b(A2(xc, -480, io(0)), A5(Dc, 2019, 0, 20, 120, 2))
            ]), A2(xc, -540, wc(no))));
        }),
        b("America/Mexico_City", function() {
            return Xc(A2(kc, k([
                b(A2(xc, -360, wc(sf)), A5(Dc, 2001, 8, 30, 120, 2)),
                b(A2(xc, -360, io(0)), A5(Dc, 2002, 1, 20, 0, 2))
            ]), A2(xc, -360, wc(sf))));
        }),
        b("America/Miquelon", function() {
            return Xc(A2(kc, k([
                b(A2(xc, -240, io(0)), A5(Dc, 1980, 4, 1, 0, 2)),
                b(A2(xc, -180, io(0)), A5(Dc, 1987, 0, 1, 0, 2))
            ]), A2(xc, -180, wc(bf))));
        }),
        b("America/Moncton", function() {
            return Xc(A2(kc, k([
                b(A2(xc, -240, wc(Pf)), A5(Dc, 1973, 0, 1, 0, 2)),
                b(A2(xc, -240, wc(bf)), A5(Dc, 1993, 0, 1, 0, 2)),
                b(A2(xc, -240, wc(Pf)), A5(Dc, 2007, 0, 1, 0, 2))
            ]), A2(xc, -240, wc(bf))));
        }),
        b("America/Monterrey", function() {
            return Xc(A2(kc, k([
                b(A2(xc, -360, io(0)), A5(Dc, 1988, 0, 1, 0, 2)),
                b(A2(xc, -360, wc(no)), A5(Dc, 1989, 0, 1, 0, 2))
            ]), A2(xc, -360, wc(sf))));
        }),
        b("America/Montevideo", function() {
            return Xc(A2(kc, k([
                b(A2(xc, -180, wc(Tf)), A5(Dc, 1970, 0, 1, 0, 2)),
                b(A2(xc, -180, wc(Tf)), A5(Dc, 1974, 0, 1, 0, 2)),
                b(A2(xc, -180, wc(Tf)), A5(Dc, 1974, 2, 10, 0, 2)),
                b(A2(xc, -180, wc(Tf)), A5(Dc, 1974, 11, 22, 0, 2))
            ]), A2(xc, -180, wc(Tf))));
        }),
        b("America/Montserrat", Ff),
        b("America/Nassau", function() {
            return Xc(A2(kc, k([
                b(A2(xc, -300, wc(Lf)), A5(Dc, 1976, 0, 1, 0, 2))
            ]), A2(xc, -300, wc(no))));
        }),
        b("America/New_York", function() {
            return Xc(A2(kc, h, A2(xc, -300, wc(no))));
        }),
        b("America/Nipigon", function() {
            return Xc(A2(kc, h, A2(xc, -300, wc(bf))));
        }),
        b("America/Nome", function() {
            return Xc(A2(kc, k([
                b(A2(xc, -660, wc(no)), A5(Dc, 1983, 9, 30, 120, 2)),
                b(A2(xc, -540, wc(no)), A5(Dc, 1983, 10, 30, 0, 2))
            ]), A2(xc, -540, wc(no))));
        }),
        b("America/Noronha", function() {
            return Xc(A2(kc, k([
                b(A2(xc, -120, wc(ef)), A5(Dc, 1990, 8, 17, 0, 2)),
                b(A2(xc, -120, io(0)), A5(Dc, 1999, 8, 30, 0, 2)),
                b(A2(xc, -120, wc(ef)), A5(Dc, 2e3, 9, 15, 0, 2)),
                b(A2(xc, -120, io(0)), A5(Dc, 2001, 8, 13, 0, 2)),
                b(A2(xc, -120, wc(ef)), A5(Dc, 2002, 9, 1, 0, 2))
            ]), A2(xc, -120, io(0))));
        }),
        b("America/North_Dakota/Beulah", function() {
            return Xc(A2(kc, k([
                b(A2(xc, -420, wc(no)), A5(Dc, 2010, 10, 7, 120, 2))
            ]), A2(xc, -360, wc(no))));
        }),
        b("America/North_Dakota/Center", function() {
            return Xc(A2(kc, k([
                b(A2(xc, -420, wc(no)), A5(Dc, 1992, 9, 25, 120, 2))
            ]), A2(xc, -360, wc(no))));
        }),
        b("America/North_Dakota/New_Salem", function() {
            return Xc(A2(kc, k([
                b(A2(xc, -420, wc(no)), A5(Dc, 2003, 9, 26, 120, 2))
            ]), A2(xc, -360, wc(no))));
        }),
        b("America/Nuuk", function() {
            return Xc(A2(kc, k([
                b(A2(xc, -180, io(0)), A5(Dc, 1980, 3, 6, 120, 2))
            ]), A2(xc, -180, wc(yo))));
        }),
        b("America/Ojinaga", function() {
            return Xc(A2(kc, k([
                b(A2(xc, -360, io(0)), A5(Dc, 1996, 0, 1, 0, 2)),
                b(A2(xc, -360, wc(sf)), A5(Dc, 1998, 0, 1, 0, 2)),
                b(A2(xc, -360, io(0)), A5(Dc, 1998, 3, 5, 180, 2)),
                b(A2(xc, -420, wc(sf)), A5(Dc, 2010, 0, 1, 0, 2))
            ]), A2(xc, -420, wc(no))));
        }),
        b("America/Panama", pf),
        b("America/Pangnirtung", function() {
            return Xc(A2(kc, k([
                b(A2(xc, -240, wc(mf)), A5(Dc, 1995, 3, 2, 120, 2)),
                b(A2(xc, -300, wc(bf)), A5(Dc, 1999, 9, 31, 120, 2)),
                b(A2(xc, -360, wc(bf)), A5(Dc, 2e3, 9, 29, 120, 2))
            ]), A2(xc, -300, wc(bf))));
        }),
        b("America/Paramaribo", function() {
            return Xc(A2(kc, k([
                b(A2(xc, -210, io(0)), A5(Dc, 1984, 9, 1, 0, 2))
            ]), A2(xc, -180, io(0))));
        }),
        b("America/Phoenix", function() {
            return Xc(A2(kc, h, A2(xc, -420, io(0))));
        }),
        b("America/Port-au-Prince", function() {
            return Xc(A2(kc, h, A2(xc, -300, wc(Mf))));
        }),
        b("America/Port_of_Spain", nf),
        b("America/Porto_Velho", function() {
            return Xc(A2(kc, k([
                b(A2(xc, -240, wc(ef)), A5(Dc, 1988, 8, 12, 0, 2))
            ]), A2(xc, -240, io(0))));
        }),
        b("America/Puerto_Rico", function() {
            return Xc(A2(kc, h, A2(xc, -240, io(0))));
        }),
        b("America/Punta_Arenas", function() {
            return Xc(A2(kc, k([
                b(A2(xc, -240, wc(Hf)), A5(Dc, 2016, 11, 4, 0, 2))
            ]), A2(xc, -180, io(0))));
        }),
        b("America/Rainy_River", function() {
            return Xc(A2(kc, h, A2(xc, -360, wc(bf))));
        }),
        b("America/Rankin_Inlet", function() {
            return Xc(A2(kc, k([
                b(A2(xc, -360, wc(mf)), A5(Dc, 2e3, 9, 29, 120, 2)),
                b(A2(xc, -300, io(0)), A5(Dc, 2001, 3, 1, 180, 2))
            ]), A2(xc, -360, wc(bf))));
        }),
        b("America/Recife", function() {
            return Xc(A2(kc, k([
                b(A2(xc, -180, wc(ef)), A5(Dc, 1990, 8, 17, 0, 2)),
                b(A2(xc, -180, io(0)), A5(Dc, 1999, 8, 30, 0, 2)),
                b(A2(xc, -180, wc(ef)), A5(Dc, 2e3, 9, 15, 0, 2)),
                b(A2(xc, -180, io(0)), A5(Dc, 2001, 8, 13, 0, 2)),
                b(A2(xc, -180, wc(ef)), A5(Dc, 2002, 9, 1, 0, 2))
            ]), A2(xc, -180, io(0))));
        }),
        b("America/Regina", function() {
            return Xc(A2(kc, h, A2(xc, -360, io(0))));
        }),
        b("America/Resolute", function() {
            return Xc(A2(kc, k([
                b(A2(xc, -360, wc(mf)), A5(Dc, 2e3, 9, 29, 120, 2)),
                b(A2(xc, -300, io(0)), A5(Dc, 2001, 3, 1, 180, 2)),
                b(A2(xc, -360, wc(bf)), A5(Dc, 2006, 9, 29, 120, 2)),
                b(A2(xc, -300, io(0)), A5(Dc, 2007, 2, 11, 180, 2))
            ]), A2(xc, -360, wc(bf))));
        }),
        b("America/Rio_Branco", function() {
            return Xc(A2(kc, k([
                b(A2(xc, -300, wc(ef)), A5(Dc, 1988, 8, 12, 0, 2)),
                b(A2(xc, -300, io(0)), A5(Dc, 2008, 5, 24, 0, 2)),
                b(A2(xc, -240, io(0)), A5(Dc, 2013, 10, 10, 0, 2))
            ]), A2(xc, -300, io(0))));
        }),
        b("America/Santarem", function() {
            return Xc(A2(kc, k([
                b(A2(xc, -240, wc(ef)), A5(Dc, 1988, 8, 12, 0, 2)),
                b(A2(xc, -240, io(0)), A5(Dc, 2008, 5, 24, 0, 2))
            ]), A2(xc, -180, io(0))));
        }),
        b("America/Santiago", function() {
            return Xc(A2(kc, h, A2(xc, -240, wc(Hf))));
        }),
        b("America/Santo_Domingo", function() {
            return Xc(A2(kc, k([
                b(A2(xc, -300, wc(Rf)), A5(Dc, 1974, 9, 27, 0, 2)),
                b(A2(xc, -240, io(0)), A5(Dc, 2e3, 9, 29, 120, 2)),
                b(A2(xc, -300, wc(no)), A5(Dc, 2e3, 11, 3, 60, 2))
            ]), A2(xc, -240, io(0))));
        }),
        b("America/Sao_Paulo", function() {
            return Xc(A2(kc, h, A2(xc, -180, wc(ef))));
        }),
        b("America/Scoresbysund", function() {
            return Xc(A2(kc, k([
                b(A2(xc, -120, io(0)), A5(Dc, 1980, 3, 6, 120, 2)),
                b(A2(xc, -120, wc(Of)), A5(Dc, 1981, 2, 29, 0, 2))
            ]), A2(xc, -60, wc(yo))));
        }),
        b("America/Sitka", function() {
            return Xc(A2(kc, k([
                b(A2(xc, -480, wc(no)), A5(Dc, 1983, 9, 30, 120, 2)),
                b(A2(xc, -540, wc(no)), A5(Dc, 1983, 10, 30, 0, 2))
            ]), A2(xc, -540, wc(no))));
        }),
        b("America/St_Barthelemy", Nf),
        b("America/St_Johns", function() {
            return Xc(A2(kc, k([
                b(A2(xc, -210, wc(_f)), A5(Dc, 2011, 10, 1, 0, 2))
            ]), A2(xc, -210, wc(bf))));
        }),
        b("America/St_Kitts", If),
        b("America/St_Lucia", Vf),
        b("America/St_Thomas", Wf),
        b("America/St_Vincent", Zf),
        b("America/Swift_Current", function() {
            return Xc(A2(kc, k([
                b(A2(xc, -420, io(0)), A5(Dc, 1972, 3, 30, 120, 2))
            ]), A2(xc, -360, io(0))));
        }),
        b("America/Tegucigalpa", function() {
            return Xc(A2(kc, h, A2(xc, -360, wc(Xf))));
        }),
        b("America/Thule", function() {
            return Xc(A2(kc, h, A2(xc, -240, wc(Gf))));
        }),
        b("America/Thunder_Bay", function() {
            return Xc(A2(kc, k([
                b(A2(xc, -300, wc(bf)), A5(Dc, 1970, 0, 1, 0, 2)),
                b(A2(xc, -300, wc(Jf)), A5(Dc, 1973, 0, 1, 0, 2)),
                b(A2(xc, -300, io(0)), A5(Dc, 1974, 0, 1, 0, 2))
            ]), A2(xc, -300, wc(bf))));
        }),
        b("America/Tijuana", function() {
            return Xc(A2(kc, k([
                b(A2(xc, -480, io(0)), A5(Dc, 1976, 0, 1, 0, 2)),
                b(A2(xc, -480, wc(no)), A5(Dc, 1996, 0, 1, 0, 2)),
                b(A2(xc, -480, wc(sf)), A5(Dc, 2001, 0, 1, 0, 2)),
                b(A2(xc, -480, wc(no)), A5(Dc, 2002, 1, 20, 0, 2)),
                b(A2(xc, -480, wc(sf)), A5(Dc, 2010, 0, 1, 0, 2))
            ]), A2(xc, -480, wc(no))));
        }),
        b("America/Toronto", function() {
            return Xc(A2(kc, k([
                b(A2(xc, -300, wc(Jf)), A5(Dc, 1974, 0, 1, 0, 2))
            ]), A2(xc, -300, wc(bf))));
        }),
        b("America/Tortola", Yf),
        b("America/Vancouver", function() {
            return Xc(A2(kc, k([
                b(A2(xc, -480, wc(gf)), A5(Dc, 1987, 0, 1, 0, 2))
            ]), A2(xc, -480, wc(bf))));
        }),
        b("America/Whitehorse", function() {
            return Xc(A2(kc, k([
                b(A2(xc, -480, wc(mf)), A5(Dc, 1980, 0, 1, 0, 2)),
                b(A2(xc, -480, wc(bf)), A5(Dc, 2020, 10, 1, 0, 2))
            ]), A2(xc, -420, io(0))));
        }),
        b("America/Winnipeg", function() {
            return Xc(A2(kc, k([
                b(A2(xc, -360, wc(Qf)), A5(Dc, 2006, 0, 1, 0, 2))
            ]), A2(xc, -360, wc(bf))));
        }),
        b("America/Yakutat", function() {
            return Xc(A2(kc, k([
                b(A2(xc, -540, wc(no)), A5(Dc, 1983, 10, 30, 0, 2))
            ]), A2(xc, -540, wc(no))));
        }),
        b("America/Yellowknife", function() {
            return Xc(A2(kc, k([
                b(A2(xc, -420, wc(mf)), A5(Dc, 1980, 0, 1, 0, 2))
            ]), A2(xc, -420, wc(bf))));
        }),
        b("Antarctica/Casey", function() {
            return Xc(A2(kc, k([
                b(A2(xc, 480, io(0)), A5(Dc, 2009, 9, 18, 120, 2)),
                b(A2(xc, 660, io(0)), A5(Dc, 2010, 2, 5, 120, 2)),
                b(A2(xc, 480, io(0)), A5(Dc, 2011, 9, 28, 120, 2)),
                b(A2(xc, 660, io(0)), A5(Dc, 2012, 1, 21, 1020, 0)),
                b(A2(xc, 480, io(0)), A5(Dc, 2016, 9, 22, 0, 2)),
                b(A2(xc, 660, io(0)), A5(Dc, 2018, 2, 11, 240, 2)),
                b(A2(xc, 480, io(0)), A5(Dc, 2018, 9, 7, 240, 2)),
                b(A2(xc, 660, io(0)), A5(Dc, 2019, 2, 17, 180, 2)),
                b(A2(xc, 480, io(0)), A5(Dc, 2019, 9, 4, 180, 2)),
                b(A2(xc, 660, io(0)), A5(Dc, 2020, 2, 8, 180, 2)),
                b(A2(xc, 480, io(0)), A5(Dc, 2020, 9, 4, 1, 2))
            ]), A2(xc, 660, io(0))));
        }),
        b("Antarctica/Davis", function() {
            return Xc(A2(kc, k([
                b(A2(xc, 420, io(0)), A5(Dc, 2009, 9, 18, 120, 2)),
                b(A2(xc, 300, io(0)), A5(Dc, 2010, 2, 10, 1200, 0)),
                b(A2(xc, 420, io(0)), A5(Dc, 2011, 9, 28, 120, 2)),
                b(A2(xc, 300, io(0)), A5(Dc, 2012, 1, 21, 1200, 0))
            ]), A2(xc, 420, io(0))));
        }),
        b("Antarctica/DumontDUrville", function() {
            return Xc(A2(kc, h, A2(xc, 600, io(0))));
        }),
        b("Antarctica/Macquarie", function() {
            return Xc(A2(kc, k([
                b(A2(xc, 600, wc(Kf)), A5(Dc, 2010, 0, 1, 0, 2)),
                b(A2(xc, 600, io(60)), A5(Dc, 2011, 0, 1, 0, 2))
            ]), A2(xc, 600, wc(Kf))));
        }),
        b("Antarctica/Mawson", function() {
            return Xc(A2(kc, k([
                b(A2(xc, 360, io(0)), A5(Dc, 2009, 9, 18, 120, 2))
            ]), A2(xc, 300, io(0))));
        }),
        b("Antarctica/McMurdo", ts),
        b("Antarctica/Palmer", function() {
            return Xc(A2(kc, k([
                b(A2(xc, -180, wc(uf)), A5(Dc, 1982, 4, 1, 0, 2)),
                b(A2(xc, -240, wc(Hf)), A5(Dc, 2016, 11, 4, 0, 2))
            ]), A2(xc, -180, io(0))));
        }),
        b("Antarctica/Rothera", function() {
            return Xc(A2(kc, k([
                b(A2(xc, 0, io(0)), A5(Dc, 1976, 11, 1, 0, 2))
            ]), A2(xc, -180, io(0))));
        }),
        b("Antarctica/Syowa", function() {
            return Xc(A2(kc, h, A2(xc, 180, io(0))));
        }),
        b("Antarctica/Troll", function() {
            return Xc(A2(kc, k([
                b(A2(xc, 0, io(0)), A5(Dc, 2005, 1, 12, 0, 2))
            ]), A2(xc, 0, wc(es))));
        }),
        b("Antarctica/Vostok", function() {
            return Xc(A2(kc, h, A2(xc, 360, io(0))));
        }),
        b("Arctic/Longyearbyen", as),
        b("Asia/Aden", cs),
        b("Asia/Almaty", function() {
            return Xc(A2(kc, k([
                b(A2(xc, 360, wc(os)), A5(Dc, 1991, 2, 31, 120, 1)),
                b(A2(xc, 300, wc(os)), A5(Dc, 1992, 0, 19, 120, 1)),
                b(A2(xc, 360, wc(os)), A5(Dc, 2004, 9, 31, 120, 1))
            ]), A2(xc, 360, io(0))));
        }),
        b("Asia/Amman", function() {
            return Xc(A2(kc, h, A2(xc, 120, wc(fs))));
        }),
        b("Asia/Anadyr", function() {
            return Xc(A2(kc, k([
                b(A2(xc, 780, wc(ss)), A5(Dc, 1982, 3, 1, 0, 1)),
                b(A2(xc, 720, wc(ss)), A5(Dc, 1991, 2, 31, 120, 1)),
                b(A2(xc, 660, wc(ss)), A5(Dc, 1992, 0, 19, 120, 1)),
                b(A2(xc, 720, wc(ss)), A5(Dc, 2010, 2, 28, 120, 1)),
                b(A2(xc, 660, wc(ss)), A5(Dc, 2011, 2, 27, 120, 1))
            ]), A2(xc, 720, io(0))));
        }),
        b("Asia/Aqtau", function() {
            return Xc(A2(kc, k([
                b(A2(xc, 300, io(0)), A5(Dc, 1981, 9, 1, 0, 2)),
                b(A2(xc, 360, io(0)), A5(Dc, 1982, 3, 1, 0, 2)),
                b(A2(xc, 300, wc(os)), A5(Dc, 1991, 2, 31, 120, 1)),
                b(A2(xc, 240, wc(os)), A5(Dc, 1992, 0, 19, 120, 1)),
                b(A2(xc, 300, wc(os)), A5(Dc, 1994, 8, 25, 120, 1)),
                b(A2(xc, 240, wc(os)), A5(Dc, 2004, 9, 31, 120, 1))
            ]), A2(xc, 300, io(0))));
        }),
        b("Asia/Aqtobe", function() {
            return Xc(A2(kc, k([
                b(A2(xc, 300, io(0)), A5(Dc, 1981, 3, 1, 0, 2)),
                b(A2(xc, 300, io(60)), A5(Dc, 1981, 9, 1, 0, 2)),
                b(A2(xc, 360, io(0)), A5(Dc, 1982, 3, 1, 0, 2)),
                b(A2(xc, 300, wc(os)), A5(Dc, 1991, 2, 31, 120, 1)),
                b(A2(xc, 240, wc(os)), A5(Dc, 1992, 0, 19, 120, 1)),
                b(A2(xc, 300, wc(os)), A5(Dc, 2004, 9, 31, 120, 1))
            ]), A2(xc, 300, io(0))));
        }),
        b("Asia/Ashgabat", function() {
            return Xc(A2(kc, k([
                b(A2(xc, 300, wc(os)), A5(Dc, 1991, 2, 31, 120, 2)),
                b(A2(xc, 240, wc(os)), A5(Dc, 1992, 0, 19, 120, 2))
            ]), A2(xc, 300, io(0))));
        }),
        b("Asia/Atyrau", function() {
            return Xc(A2(kc, k([
                b(A2(xc, 300, io(0)), A5(Dc, 1981, 9, 1, 0, 2)),
                b(A2(xc, 360, io(0)), A5(Dc, 1982, 3, 1, 0, 2)),
                b(A2(xc, 300, wc(os)), A5(Dc, 1991, 2, 31, 120, 1)),
                b(A2(xc, 240, wc(os)), A5(Dc, 1992, 0, 19, 120, 1)),
                b(A2(xc, 300, wc(os)), A5(Dc, 1999, 2, 28, 120, 1)),
                b(A2(xc, 240, wc(os)), A5(Dc, 2004, 9, 31, 120, 1))
            ]), A2(xc, 300, io(0))));
        }),
        b("Asia/Baghdad", function() {
            return Xc(A2(kc, k([
                b(A2(xc, 180, io(0)), A5(Dc, 1982, 4, 1, 0, 2))
            ]), A2(xc, 180, wc(ls))));
        }),
        b("Asia/Bahrain", bs),
        b("Asia/Baku", function() {
            return Xc(A2(kc, k([
                b(A2(xc, 240, wc(os)), A5(Dc, 1991, 2, 31, 120, 1)),
                b(A2(xc, 180, wc(os)), A5(Dc, 1992, 8, 27, 120, 1)),
                b(A2(xc, 240, io(0)), A5(Dc, 1996, 0, 1, 0, 2)),
                b(A2(xc, 240, wc(ms)), A5(Dc, 1997, 0, 1, 0, 2))
            ]), A2(xc, 240, wc(vs))));
        }),
        b("Asia/Bangkok", ps),
        b("Asia/Barnaul", function() {
            return Xc(A2(kc, k([
                b(A2(xc, 420, wc(ss)), A5(Dc, 1991, 2, 31, 120, 1)),
                b(A2(xc, 360, wc(ss)), A5(Dc, 1992, 0, 19, 120, 1)),
                b(A2(xc, 420, wc(ss)), A5(Dc, 1995, 4, 28, 0, 2)),
                b(A2(xc, 360, wc(ss)), A5(Dc, 2011, 2, 27, 120, 1)),
                b(A2(xc, 420, io(0)), A5(Dc, 2014, 9, 26, 120, 1)),
                b(A2(xc, 360, io(0)), A5(Dc, 2016, 2, 27, 120, 1))
            ]), A2(xc, 420, io(0))));
        }),
        b("Asia/Beirut", function() {
            return Xc(A2(kc, h, A2(xc, 120, wc($s))));
        }),
        b("Asia/Bishkek", function() {
            return Xc(A2(kc, k([
                b(A2(xc, 360, wc(os)), A5(Dc, 1991, 2, 31, 120, 1)),
                b(A2(xc, 300, wc(os)), A5(Dc, 1991, 7, 31, 120, 2)),
                b(A2(xc, 300, wc(hs)), A5(Dc, 2005, 7, 12, 0, 2))
            ]), A2(xc, 360, io(0))));
        }),
        b("Asia/Brunei", function() {
            return Xc(A2(kc, h, A2(xc, 480, io(0))));
        }),
        b("Asia/Chita", function() {
            return Xc(A2(kc, k([
                b(A2(xc, 540, wc(ss)), A5(Dc, 1991, 2, 31, 120, 1)),
                b(A2(xc, 480, wc(ss)), A5(Dc, 1992, 0, 19, 120, 1)),
                b(A2(xc, 540, wc(ss)), A5(Dc, 2011, 2, 27, 120, 1)),
                b(A2(xc, 600, io(0)), A5(Dc, 2014, 9, 26, 120, 1)),
                b(A2(xc, 480, io(0)), A5(Dc, 2016, 2, 27, 120, 2))
            ]), A2(xc, 540, io(0))));
        }),
        b("Asia/Choibalsan", function() {
            return Xc(A2(kc, k([
                b(A2(xc, 420, io(0)), A5(Dc, 1978, 0, 1, 0, 2)),
                b(A2(xc, 480, io(0)), A5(Dc, 1983, 3, 1, 0, 2)),
                b(A2(xc, 540, wc(gs)), A5(Dc, 2008, 2, 31, 0, 2))
            ]), A2(xc, 480, wc(gs))));
        }),
        b("Asia/Colombo", function() {
            return Xc(A2(kc, k([
                b(A2(xc, 330, io(0)), A5(Dc, 1996, 4, 25, 0, 2)),
                b(A2(xc, 390, io(0)), A5(Dc, 1996, 9, 26, 30, 2)),
                b(A2(xc, 360, io(0)), A5(Dc, 2006, 3, 15, 30, 2))
            ]), A2(xc, 330, io(0))));
        }),
        b("Asia/Damascus", function() {
            return Xc(A2(kc, h, A2(xc, 120, wc(ws))));
        }),
        b("Asia/Dhaka", function() {
            return Xc(A2(kc, k([
                b(A2(xc, 360, io(0)), A5(Dc, 2009, 0, 1, 0, 2))
            ]), A2(xc, 360, wc(ks))));
        }),
        b("Asia/Dili", function() {
            return Xc(A2(kc, k([
                b(A2(xc, 540, io(0)), A5(Dc, 1976, 4, 3, 0, 2)),
                b(A2(xc, 480, io(0)), A5(Dc, 2e3, 8, 17, 0, 2))
            ]), A2(xc, 540, io(0))));
        }),
        b("Asia/Dubai", xs),
        b("Asia/Dushanbe", function() {
            return Xc(A2(kc, k([
                b(A2(xc, 360, wc(os)), A5(Dc, 1991, 2, 31, 120, 1)),
                b(A2(xc, 300, io(60)), A5(Dc, 1991, 8, 9, 120, 1))
            ]), A2(xc, 300, io(0))));
        }),
        b("Asia/Famagusta", function() {
            return Xc(A2(kc, k([
                b(A2(xc, 120, wc(ys)), A5(Dc, 1998, 8, 1, 0, 2)),
                b(A2(xc, 120, wc(ms)), A5(Dc, 2016, 8, 8, 0, 2)),
                b(A2(xc, 180, io(0)), A5(Dc, 2017, 9, 29, 60, 0))
            ]), A2(xc, 120, wc(ms))));
        }),
        b("Asia/Gaza", function() {
            return Xc(A2(kc, k([
                b(A2(xc, 120, wc(Ds)), A5(Dc, 1996, 0, 1, 0, 2)),
                b(A2(xc, 120, wc(fs)), A5(Dc, 1999, 0, 1, 0, 2)),
                b(A2(xc, 120, wc(_s)), A5(Dc, 2008, 7, 29, 0, 2)),
                b(A2(xc, 120, io(0)), A5(Dc, 2008, 8, 1, 0, 2)),
                b(A2(xc, 120, wc(_s)), A5(Dc, 2010, 0, 1, 0, 2)),
                b(A2(xc, 120, io(0)), A5(Dc, 2010, 2, 27, 1, 2)),
                b(A2(xc, 120, wc(_s)), A5(Dc, 2011, 7, 1, 0, 2)),
                b(A2(xc, 120, io(0)), A5(Dc, 2012, 0, 1, 0, 2))
            ]), A2(xc, 120, wc(_s))));
        }),
        b("Asia/Hebron", function() {
            return Xc(A2(kc, k([
                b(A2(xc, 120, wc(Ds)), A5(Dc, 1996, 0, 1, 0, 2)),
                b(A2(xc, 120, wc(fs)), A5(Dc, 1999, 0, 1, 0, 2))
            ]), A2(xc, 120, wc(_s))));
        }),
        b("Asia/Ho_Chi_Minh", function() {
            return Xc(A2(kc, k([
                b(A2(xc, 480, io(0)), A5(Dc, 1975, 5, 13, 0, 2))
            ]), A2(xc, 420, io(0))));
        }),
        b("Asia/Hong_Kong", function() {
            return Xc(A2(kc, h, A2(xc, 480, wc(As))));
        }),
        b("Asia/Hovd", function() {
            return Xc(A2(kc, k([
                b(A2(xc, 360, io(0)), A5(Dc, 1978, 0, 1, 0, 2))
            ]), A2(xc, 420, wc(gs))));
        }),
        b("Asia/Irkutsk", function() {
            return Xc(A2(kc, k([
                b(A2(xc, 480, wc(ss)), A5(Dc, 1991, 2, 31, 120, 1)),
                b(A2(xc, 420, wc(ss)), A5(Dc, 1992, 0, 19, 120, 1)),
                b(A2(xc, 480, wc(ss)), A5(Dc, 2011, 2, 27, 120, 1)),
                b(A2(xc, 540, io(0)), A5(Dc, 2014, 9, 26, 120, 1))
            ]), A2(xc, 480, io(0))));
        }),
        b("Asia/Istanbul", js),
        b("Asia/Jakarta", function() {
            return Xc(A2(kc, h, A2(xc, 420, io(0))));
        }),
        b("Asia/Jayapura", function() {
            return Xc(A2(kc, h, A2(xc, 540, io(0))));
        }),
        b("Asia/Jerusalem", function() {
            return Xc(A2(kc, h, A2(xc, 120, wc(Ds))));
        }),
        b("Asia/Kabul", function() {
            return Xc(A2(kc, h, A2(xc, 270, io(0))));
        }),
        b("Asia/Kamchatka", function() {
            return Xc(A2(kc, k([
                b(A2(xc, 720, wc(ss)), A5(Dc, 1991, 2, 31, 120, 1)),
                b(A2(xc, 660, wc(ss)), A5(Dc, 1992, 0, 19, 120, 1)),
                b(A2(xc, 720, wc(ss)), A5(Dc, 2010, 2, 28, 120, 1)),
                b(A2(xc, 660, wc(ss)), A5(Dc, 2011, 2, 27, 120, 1))
            ]), A2(xc, 720, io(0))));
        }),
        b("Asia/Karachi", function() {
            return Xc(A2(kc, k([
                b(A2(xc, 300, io(0)), A5(Dc, 1971, 2, 26, 0, 2))
            ]), A2(xc, 300, wc(Ss))));
        }),
        b("Asia/Kathmandu", function() {
            return Xc(A2(kc, k([
                b(A2(xc, 330, io(0)), A5(Dc, 1986, 0, 1, 0, 2))
            ]), A2(xc, 345, io(0))));
        }),
        b("Asia/Khandyga", function() {
            return Xc(A2(kc, k([
                b(A2(xc, 540, wc(ss)), A5(Dc, 1991, 2, 31, 120, 1)),
                b(A2(xc, 480, wc(ss)), A5(Dc, 1992, 0, 19, 120, 1)),
                b(A2(xc, 540, wc(ss)), A5(Dc, 2004, 0, 1, 0, 2)),
                b(A2(xc, 600, wc(ss)), A5(Dc, 2011, 2, 27, 120, 1)),
                b(A2(xc, 660, io(0)), A5(Dc, 2011, 8, 13, 0, 1)),
                b(A2(xc, 600, io(0)), A5(Dc, 2014, 9, 26, 120, 1))
            ]), A2(xc, 540, io(0))));
        }),
        b("Asia/Kolkata", function() {
            return Xc(A2(kc, h, A2(xc, 330, io(0))));
        }),
        b("Asia/Krasnoyarsk", function() {
            return Xc(A2(kc, k([
                b(A2(xc, 420, wc(ss)), A5(Dc, 1991, 2, 31, 120, 1)),
                b(A2(xc, 360, wc(ss)), A5(Dc, 1992, 0, 19, 120, 1)),
                b(A2(xc, 420, wc(ss)), A5(Dc, 2011, 2, 27, 120, 1)),
                b(A2(xc, 480, io(0)), A5(Dc, 2014, 9, 26, 120, 1))
            ]), A2(xc, 420, io(0))));
        }),
        b("Asia/Kuala_Lumpur", function() {
            return Xc(A2(kc, k([
                b(A2(xc, 450, io(0)), A5(Dc, 1982, 0, 1, 0, 2))
            ]), A2(xc, 480, io(0))));
        }),
        b("Asia/Kuching", function() {
            return Xc(A2(kc, h, A2(xc, 480, io(0))));
        }),
        b("Asia/Kuwait", zs),
        b("Asia/Macau", function() {
            return Xc(A2(kc, h, A2(xc, 480, wc(Us))));
        }),
        b("Asia/Magadan", function() {
            return Xc(A2(kc, k([
                b(A2(xc, 660, wc(ss)), A5(Dc, 1991, 2, 31, 120, 1)),
                b(A2(xc, 600, wc(ss)), A5(Dc, 1992, 0, 19, 120, 1)),
                b(A2(xc, 660, wc(ss)), A5(Dc, 2011, 2, 27, 120, 1)),
                b(A2(xc, 720, io(0)), A5(Dc, 2014, 9, 26, 120, 1)),
                b(A2(xc, 600, io(0)), A5(Dc, 2016, 3, 24, 120, 1))
            ]), A2(xc, 660, io(0))));
        }),
        b("Asia/Makassar", function() {
            return Xc(A2(kc, h, A2(xc, 480, io(0))));
        }),
        b("Asia/Manila", function() {
            return Xc(A2(kc, h, A2(xc, 480, wc(Es))));
        }),
        b("Asia/Muscat", Ps),
        b("Asia/Nicosia", Ts),
        b("Asia/Novokuznetsk", function() {
            return Xc(A2(kc, k([
                b(A2(xc, 420, wc(ss)), A5(Dc, 1991, 2, 31, 120, 1)),
                b(A2(xc, 360, wc(ss)), A5(Dc, 1992, 0, 19, 120, 1)),
                b(A2(xc, 420, wc(ss)), A5(Dc, 2010, 2, 28, 120, 1)),
                b(A2(xc, 360, wc(ss)), A5(Dc, 2011, 2, 27, 120, 1))
            ]), A2(xc, 420, io(0))));
        }),
        b("Asia/Novosibirsk", function() {
            return Xc(A2(kc, k([
                b(A2(xc, 420, wc(ss)), A5(Dc, 1991, 2, 31, 120, 1)),
                b(A2(xc, 360, wc(ss)), A5(Dc, 1992, 0, 19, 120, 1)),
                b(A2(xc, 420, wc(ss)), A5(Dc, 1993, 4, 23, 0, 2)),
                b(A2(xc, 360, wc(ss)), A5(Dc, 2011, 2, 27, 120, 1)),
                b(A2(xc, 420, io(0)), A5(Dc, 2014, 9, 26, 120, 1)),
                b(A2(xc, 360, io(0)), A5(Dc, 2016, 6, 24, 120, 1))
            ]), A2(xc, 420, io(0))));
        }),
        b("Asia/Omsk", function() {
            return Xc(A2(kc, k([
                b(A2(xc, 360, wc(ss)), A5(Dc, 1991, 2, 31, 120, 1)),
                b(A2(xc, 300, wc(ss)), A5(Dc, 1992, 0, 19, 120, 1)),
                b(A2(xc, 360, wc(ss)), A5(Dc, 2011, 2, 27, 120, 1)),
                b(A2(xc, 420, io(0)), A5(Dc, 2014, 9, 26, 120, 1))
            ]), A2(xc, 360, io(0))));
        }),
        b("Asia/Oral", function() {
            return Xc(A2(kc, k([
                b(A2(xc, 300, io(0)), A5(Dc, 1981, 3, 1, 0, 2)),
                b(A2(xc, 300, io(60)), A5(Dc, 1981, 9, 1, 0, 2)),
                b(A2(xc, 360, io(0)), A5(Dc, 1982, 3, 1, 0, 2)),
                b(A2(xc, 300, wc(os)), A5(Dc, 1989, 2, 26, 120, 1)),
                b(A2(xc, 240, wc(os)), A5(Dc, 1992, 0, 19, 120, 1)),
                b(A2(xc, 300, wc(os)), A5(Dc, 1992, 2, 29, 120, 1)),
                b(A2(xc, 240, wc(os)), A5(Dc, 2004, 9, 31, 120, 1))
            ]), A2(xc, 300, io(0))));
        }),
        b("Asia/Phnom_Penh", Fs),
        b("Asia/Pontianak", function() {
            return Xc(A2(kc, k([
                b(A2(xc, 480, io(0)), A5(Dc, 1988, 0, 1, 0, 2))
            ]), A2(xc, 420, io(0))));
        }),
        b("Asia/Pyongyang", function() {
            return Xc(A2(kc, k([
                b(A2(xc, 540, io(0)), A5(Dc, 2015, 7, 15, 0, 2)),
                b(A2(xc, 510, io(0)), A5(Dc, 2018, 4, 4, 1410, 2))
            ]), A2(xc, 540, io(0))));
        }),
        b("Asia/Qatar", ds),
        b("Asia/Qostanay", function() {
            return Xc(A2(kc, k([
                b(A2(xc, 300, io(0)), A5(Dc, 1981, 3, 1, 0, 2)),
                b(A2(xc, 300, io(60)), A5(Dc, 1981, 9, 1, 0, 2)),
                b(A2(xc, 360, io(0)), A5(Dc, 1982, 3, 1, 0, 2)),
                b(A2(xc, 300, wc(os)), A5(Dc, 1991, 2, 31, 120, 1)),
                b(A2(xc, 240, wc(os)), A5(Dc, 1992, 0, 19, 120, 1)),
                b(A2(xc, 300, wc(os)), A5(Dc, 2004, 9, 31, 120, 1))
            ]), A2(xc, 360, io(0))));
        }),
        b("Asia/Qyzylorda", function() {
            return Xc(A2(kc, k([
                b(A2(xc, 300, io(0)), A5(Dc, 1981, 3, 1, 0, 2)),
                b(A2(xc, 300, io(60)), A5(Dc, 1981, 9, 1, 0, 2)),
                b(A2(xc, 360, io(0)), A5(Dc, 1982, 3, 1, 0, 2)),
                b(A2(xc, 300, wc(os)), A5(Dc, 1991, 2, 31, 120, 1)),
                b(A2(xc, 240, wc(os)), A5(Dc, 1991, 8, 29, 120, 1)),
                b(A2(xc, 300, wc(os)), A5(Dc, 1992, 0, 19, 120, 1)),
                b(A2(xc, 360, wc(os)), A5(Dc, 1992, 2, 29, 120, 1)),
                b(A2(xc, 300, wc(os)), A5(Dc, 2004, 9, 31, 120, 1)),
                b(A2(xc, 360, io(0)), A5(Dc, 2018, 11, 21, 0, 2))
            ]), A2(xc, 300, io(0))));
        }),
        b("Asia/Riyadh", is),
        b("Asia/Sakhalin", function() {
            return Xc(A2(kc, k([
                b(A2(xc, 660, wc(ss)), A5(Dc, 1991, 2, 31, 120, 1)),
                b(A2(xc, 600, wc(ss)), A5(Dc, 1992, 0, 19, 120, 1)),
                b(A2(xc, 660, wc(ss)), A5(Dc, 1997, 2, 30, 120, 1)),
                b(A2(xc, 600, wc(ss)), A5(Dc, 2011, 2, 27, 120, 1)),
                b(A2(xc, 660, io(0)), A5(Dc, 2014, 9, 26, 120, 1)),
                b(A2(xc, 600, io(0)), A5(Dc, 2016, 2, 27, 120, 1))
            ]), A2(xc, 660, io(0))));
        }),
        b("Asia/Samarkand", function() {
            return Xc(A2(kc, k([
                b(A2(xc, 300, io(0)), A5(Dc, 1981, 3, 1, 0, 2)),
                b(A2(xc, 300, io(60)), A5(Dc, 1981, 9, 1, 0, 2)),
                b(A2(xc, 360, io(0)), A5(Dc, 1982, 3, 1, 0, 2)),
                b(A2(xc, 300, wc(os)), A5(Dc, 1992, 0, 1, 0, 2))
            ]), A2(xc, 300, io(0))));
        }),
        b("Asia/Seoul", function() {
            return Xc(A2(kc, h, A2(xc, 540, wc(Ls))));
        }),
        b("Asia/Shanghai", function() {
            return Xc(A2(kc, h, A2(xc, 480, wc(Ms))));
        }),
        b("Asia/Singapore", function() {
            return Xc(A2(kc, k([
                b(A2(xc, 450, io(0)), A5(Dc, 1982, 0, 1, 0, 2))
            ]), A2(xc, 480, io(0))));
        }),
        b("Asia/Srednekolymsk", function() {
            return Xc(A2(kc, k([
                b(A2(xc, 660, wc(ss)), A5(Dc, 1991, 2, 31, 120, 1)),
                b(A2(xc, 600, wc(ss)), A5(Dc, 1992, 0, 19, 120, 1)),
                b(A2(xc, 660, wc(ss)), A5(Dc, 2011, 2, 27, 120, 1)),
                b(A2(xc, 720, io(0)), A5(Dc, 2014, 9, 26, 120, 1))
            ]), A2(xc, 660, io(0))));
        }),
        b("Asia/Taipei", function() {
            return Xc(A2(kc, h, A2(xc, 480, wc(Hs))));
        }),
        b("Asia/Tashkent", function() {
            return Xc(A2(kc, k([
                b(A2(xc, 360, wc(os)), A5(Dc, 1991, 2, 31, 120, 2)),
                b(A2(xc, 300, wc(os)), A5(Dc, 1992, 0, 1, 0, 2))
            ]), A2(xc, 300, io(0))));
        }),
        b("Asia/Tbilisi", function() {
            return Xc(A2(kc, k([
                b(A2(xc, 240, wc(os)), A5(Dc, 1991, 2, 31, 120, 1)),
                b(A2(xc, 180, wc(os)), A5(Dc, 1992, 0, 1, 0, 2)),
                b(A2(xc, 180, wc(Rs)), A5(Dc, 1994, 8, 25, 0, 2)),
                b(A2(xc, 240, wc(Rs)), A5(Dc, 1996, 9, 27, 0, 2)),
                b(A2(xc, 240, io(60)), A5(Dc, 1997, 2, 30, 0, 2)),
                b(A2(xc, 240, wc(Rs)), A5(Dc, 2004, 5, 27, 0, 2)),
                b(A2(xc, 180, wc(os)), A5(Dc, 2005, 2, 27, 120, 2))
            ]), A2(xc, 240, io(0))));
        }),
        b("Asia/Tehran", function() {
            return Xc(A2(kc, k([
                b(A2(xc, 210, io(0)), A5(Dc, 1977, 10, 1, 0, 2)),
                b(A2(xc, 240, wc(Os)), A5(Dc, 1979, 0, 1, 0, 2))
            ]), A2(xc, 210, wc(Os))));
        }),
        b("Asia/Thimphu", function() {
            return Xc(A2(kc, k([
                b(A2(xc, 330, io(0)), A5(Dc, 1987, 9, 1, 0, 2))
            ]), A2(xc, 360, io(0))));
        }),
        b("Asia/Tokyo", function() {
            return Xc(A2(kc, h, A2(xc, 540, io(0))));
        }),
        b("Asia/Tomsk", function() {
            return Xc(A2(kc, k([
                b(A2(xc, 420, wc(ss)), A5(Dc, 1991, 2, 31, 120, 1)),
                b(A2(xc, 360, wc(ss)), A5(Dc, 1992, 0, 19, 120, 1)),
                b(A2(xc, 420, wc(ss)), A5(Dc, 2002, 4, 1, 180, 2)),
                b(A2(xc, 360, wc(ss)), A5(Dc, 2011, 2, 27, 120, 1)),
                b(A2(xc, 420, io(0)), A5(Dc, 2014, 9, 26, 120, 1)),
                b(A2(xc, 360, io(0)), A5(Dc, 2016, 4, 29, 120, 1))
            ]), A2(xc, 420, io(0))));
        }),
        b("Asia/Ulaanbaatar", function() {
            return Xc(A2(kc, k([
                b(A2(xc, 420, io(0)), A5(Dc, 1978, 0, 1, 0, 2))
            ]), A2(xc, 480, wc(gs))));
        }),
        b("Asia/Urumqi", function() {
            return Xc(A2(kc, h, A2(xc, 360, io(0))));
        }),
        b("Asia/Ust-Nera", function() {
            return Xc(A2(kc, k([
                b(A2(xc, 540, wc(ss)), A5(Dc, 1981, 3, 1, 0, 2)),
                b(A2(xc, 660, wc(ss)), A5(Dc, 1991, 2, 31, 120, 1)),
                b(A2(xc, 600, wc(ss)), A5(Dc, 1992, 0, 19, 120, 1)),
                b(A2(xc, 660, wc(ss)), A5(Dc, 2011, 2, 27, 120, 1)),
                b(A2(xc, 720, io(0)), A5(Dc, 2011, 8, 13, 0, 1)),
                b(A2(xc, 660, io(0)), A5(Dc, 2014, 9, 26, 120, 1))
            ]), A2(xc, 600, io(0))));
        }),
        b("Asia/Vientiane", Ns),
        b("Asia/Vladivostok", function() {
            return Xc(A2(kc, k([
                b(A2(xc, 600, wc(ss)), A5(Dc, 1991, 2, 31, 120, 1)),
                b(A2(xc, 540, wc(ss)), A5(Dc, 1992, 0, 19, 120, 1)),
                b(A2(xc, 600, wc(ss)), A5(Dc, 2011, 2, 27, 120, 1)),
                b(A2(xc, 660, io(0)), A5(Dc, 2014, 9, 26, 120, 1))
            ]), A2(xc, 600, io(0))));
        }),
        b("Asia/Yakutsk", function() {
            return Xc(A2(kc, k([
                b(A2(xc, 540, wc(ss)), A5(Dc, 1991, 2, 31, 120, 1)),
                b(A2(xc, 480, wc(ss)), A5(Dc, 1992, 0, 19, 120, 1)),
                b(A2(xc, 540, wc(ss)), A5(Dc, 2011, 2, 27, 120, 1)),
                b(A2(xc, 600, io(0)), A5(Dc, 2014, 9, 26, 120, 1))
            ]), A2(xc, 540, io(0))));
        }),
        b("Asia/Yangon", function() {
            return Xc(A2(kc, h, A2(xc, 390, io(0))));
        }),
        b("Asia/Yekaterinburg", function() {
            return Xc(A2(kc, k([
                b(A2(xc, 300, wc(ss)), A5(Dc, 1991, 2, 31, 120, 1)),
                b(A2(xc, 240, wc(ss)), A5(Dc, 1992, 0, 19, 120, 1)),
                b(A2(xc, 300, wc(ss)), A5(Dc, 2011, 2, 27, 120, 1)),
                b(A2(xc, 360, io(0)), A5(Dc, 2014, 9, 26, 120, 1))
            ]), A2(xc, 300, io(0))));
        }),
        b("Asia/Yerevan", function() {
            return Xc(A2(kc, k([
                b(A2(xc, 240, wc(os)), A5(Dc, 1991, 2, 31, 120, 1)),
                b(A2(xc, 180, wc(os)), A5(Dc, 1995, 8, 24, 120, 1)),
                b(A2(xc, 240, io(0)), A5(Dc, 1997, 0, 1, 0, 2)),
                b(A2(xc, 240, wc(os)), A5(Dc, 2011, 0, 1, 0, 2))
            ]), A2(xc, 240, wc(Is))));
        }),
        b("Atlantic/Azores", function() {
            return Xc(A2(kc, k([
                b(A2(xc, -60, wc(Vs)), A5(Dc, 1983, 8, 25, 60, 1)),
                b(A2(xc, -60, wc(Ws)), A5(Dc, 1992, 8, 27, 60, 1)),
                b(A2(xc, 0, wc(yo)), A5(Dc, 1993, 2, 28, 60, 0))
            ]), A2(xc, -60, wc(yo))));
        }),
        b("Atlantic/Bermuda", function() {
            return Xc(A2(kc, k([
                b(A2(xc, -240, io(0)), A5(Dc, 1974, 3, 28, 120, 2)),
                b(A2(xc, -240, wc(bf)), A5(Dc, 1976, 0, 1, 0, 2))
            ]), A2(xc, -240, wc(no))));
        }),
        b("Atlantic/Canary", function() {
            return Xc(A2(kc, k([
                b(A2(xc, 0, io(0)), A5(Dc, 1980, 3, 6, 0, 1)),
                b(A2(xc, 0, io(60)), A5(Dc, 1980, 8, 28, 60, 0))
            ]), A2(xc, 0, wc(yo))));
        }),
        b("Atlantic/Cape_Verde", function() {
            return Xc(A2(kc, k([
                b(A2(xc, -120, io(0)), A5(Dc, 1975, 10, 25, 120, 2))
            ]), A2(xc, -60, io(0))));
        }),
        b("Atlantic/Faroe", function() {
            return Xc(A2(kc, k([
                b(A2(xc, 0, io(0)), A5(Dc, 1981, 0, 1, 0, 2))
            ]), A2(xc, 0, wc(yo))));
        }),
        b("Atlantic/Madeira", function() {
            return Xc(A2(kc, k([
                b(A2(xc, 0, wc(Vs)), A5(Dc, 1983, 8, 25, 60, 1))
            ]), A2(xc, 0, wc(yo))));
        }),
        b("Atlantic/Reykjavik", function() {
            return Xc(A2(kc, h, A2(xc, 0, io(0))));
        }),
        b("Atlantic/South_Georgia", function() {
            return Xc(A2(kc, h, A2(xc, -120, io(0))));
        }),
        b("Atlantic/St_Helena", Zs),
        b("Atlantic/Stanley", function() {
            return Xc(A2(kc, k([
                b(A2(xc, -240, wc(Xs)), A5(Dc, 1983, 4, 1, 0, 2)),
                b(A2(xc, -180, wc(Xs)), A5(Dc, 1985, 8, 15, 0, 2)),
                b(A2(xc, -240, wc(Xs)), A5(Dc, 2010, 8, 5, 120, 2))
            ]), A2(xc, -180, io(0))));
        }),
        b("Australia/Adelaide", function() {
            return Xc(A2(kc, k([
                b(A2(xc, 570, io(0)), A5(Dc, 1971, 0, 1, 0, 2))
            ]), A2(xc, 570, wc(Gs))));
        }),
        b("Australia/Brisbane", function() {
            return Xc(A2(kc, k([
                b(A2(xc, 600, io(0)), A5(Dc, 1971, 0, 1, 0, 2))
            ]), A2(xc, 600, wc(Js))));
        }),
        b("Australia/Broken_Hill", function() {
            return Xc(A2(kc, k([
                b(A2(xc, 570, io(0)), A5(Dc, 1971, 0, 1, 0, 2)),
                b(A2(xc, 570, wc(Ys)), A5(Dc, 2e3, 0, 1, 0, 2))
            ]), A2(xc, 570, wc(Gs))));
        }),
        b("Australia/Currie", function() {
            return Xc(A2(kc, k([
                b(A2(xc, 600, io(0)), A5(Dc, 1971, 6, 1, 0, 2))
            ]), A2(xc, 600, wc(Kf))));
        }),
        b("Australia/Darwin", function() {
            return Xc(A2(kc, h, A2(xc, 570, io(0))));
        }),
        b("Australia/Eucla", function() {
            return Xc(A2(kc, h, A2(xc, 525, wc(Qs))));
        }),
        b("Australia/Hobart", function() {
            return Xc(A2(kc, h, A2(xc, 600, wc(Kf))));
        }),
        b("Australia/Lindeman", function() {
            return Xc(A2(kc, k([
                b(A2(xc, 600, io(0)), A5(Dc, 1971, 0, 1, 0, 2)),
                b(A2(xc, 600, wc(Js)), A5(Dc, 1992, 6, 1, 0, 2))
            ]), A2(xc, 600, wc(Ks))));
        }),
        b("Australia/Lord_Howe", function() {
            return Xc(A2(kc, k([
                b(A2(xc, 600, io(0)), A5(Dc, 1981, 2, 1, 0, 2)),
                b(A2(xc, 630, wc(nl)), A5(Dc, 1985, 6, 1, 0, 2))
            ]), A2(xc, 630, wc(nl))));
        }),
        b("Australia/Melbourne", function() {
            return Xc(A2(kc, k([
                b(A2(xc, 600, io(0)), A5(Dc, 1971, 0, 1, 0, 2))
            ]), A2(xc, 600, wc(rl))));
        }),
        b("Australia/Perth", function() {
            return Xc(A2(kc, h, A2(xc, 480, wc(Qs))));
        }),
        b("Australia/Sydney", function() {
            return Xc(A2(kc, k([
                b(A2(xc, 600, io(0)), A5(Dc, 1971, 0, 1, 0, 2))
            ]), A2(xc, 600, wc(Ys))));
        }),
        b("Europe/Amsterdam", function() {
            return Xc(A2(kc, k([
                b(A2(xc, 60, io(0)), A5(Dc, 1977, 0, 1, 0, 2))
            ]), A2(xc, 60, wc(yo))));
        }),
        b("Europe/Andorra", function() {
            return Xc(A2(kc, k([
                b(A2(xc, 60, io(0)), A5(Dc, 1985, 2, 31, 120, 2))
            ]), A2(xc, 60, wc(yo))));
        }),
        b("Europe/Astrakhan", function() {
            return Xc(A2(kc, k([
                b(A2(xc, 240, wc(ss)), A5(Dc, 1989, 2, 26, 120, 1)),
                b(A2(xc, 180, wc(ss)), A5(Dc, 1991, 2, 31, 120, 1)),
                b(A2(xc, 240, io(0)), A5(Dc, 1992, 2, 29, 120, 1)),
                b(A2(xc, 180, wc(ss)), A5(Dc, 2011, 2, 27, 120, 1)),
                b(A2(xc, 240, io(0)), A5(Dc, 2014, 9, 26, 120, 1)),
                b(A2(xc, 180, io(0)), A5(Dc, 2016, 2, 27, 120, 1))
            ]), A2(xc, 240, io(0))));
        }),
        b("Europe/Athens", function() {
            return Xc(A2(kc, k([
                b(A2(xc, 120, wc(tl)), A5(Dc, 1981, 0, 1, 0, 2))
            ]), A2(xc, 120, wc(yo))));
        }),
        b("Europe/Belgrade", el),
        b("Europe/Berlin", function() {
            return Xc(A2(kc, k([
                b(A2(xc, 60, io(0)), A5(Dc, 1980, 0, 1, 0, 2))
            ]), A2(xc, 60, wc(yo))));
        }),
        b("Europe/Bratislava", al),
        b("Europe/Brussels", function() {
            return Xc(A2(kc, k([
                b(A2(xc, 60, io(0)), A5(Dc, 1977, 0, 1, 0, 2))
            ]), A2(xc, 60, wc(yo))));
        }),
        b("Europe/Bucharest", function() {
            return Xc(A2(kc, k([
                b(A2(xc, 120, wc(cl)), A5(Dc, 1981, 2, 29, 120, 1)),
                b(A2(xc, 120, wc(Of)), A5(Dc, 1991, 0, 1, 0, 2)),
                b(A2(xc, 120, wc(cl)), A5(Dc, 1994, 0, 1, 0, 2)),
                b(A2(xc, 120, wc(il)), A5(Dc, 1997, 0, 1, 0, 2))
            ]), A2(xc, 120, wc(yo))));
        }),
        b("Europe/Budapest", function() {
            return Xc(A2(kc, k([
                b(A2(xc, 60, wc(ol)), A5(Dc, 1984, 0, 1, 0, 2))
            ]), A2(xc, 60, wc(yo))));
        }),
        b("Europe/Busingen", sl),
        b("Europe/Chisinau", function() {
            return Xc(A2(kc, k([
                b(A2(xc, 180, wc(ss)), A5(Dc, 1990, 4, 6, 120, 2)),
                b(A2(xc, 120, wc(ss)), A5(Dc, 1992, 0, 1, 0, 2)),
                b(A2(xc, 120, wc(il)), A5(Dc, 1997, 0, 1, 0, 2))
            ]), A2(xc, 120, wc(ll))));
        }),
        b("Europe/Copenhagen", function() {
            return Xc(A2(kc, k([
                b(A2(xc, 60, io(0)), A5(Dc, 1980, 0, 1, 0, 2))
            ]), A2(xc, 60, wc(yo))));
        }),
        b("Europe/Dublin", function() {
            return Xc(A2(kc, h, A2(xc, 60, wc(dl))));
        }),
        b("Europe/Gibraltar", function() {
            return Xc(A2(kc, k([
                b(A2(xc, 60, io(0)), A5(Dc, 1982, 0, 1, 0, 2))
            ]), A2(xc, 60, wc(yo))));
        }),
        b("Europe/Guernsey", ml),
        b("Europe/Helsinki", $l),
        b("Europe/Isle_of_Man", hl),
        b("Europe/Istanbul", Bs),
        b("Europe/Jersey", gl),
        b("Europe/Kaliningrad", function() {
            return Xc(A2(kc, k([
                b(A2(xc, 180, wc(ss)), A5(Dc, 1989, 2, 26, 120, 1)),
                b(A2(xc, 120, wc(ss)), A5(Dc, 2011, 2, 27, 120, 1)),
                b(A2(xc, 180, io(0)), A5(Dc, 2014, 9, 26, 120, 1))
            ]), A2(xc, 120, io(0))));
        }),
        b("Europe/Kiev", function() {
            return Xc(A2(kc, k([
                b(A2(xc, 180, wc(ss)), A5(Dc, 1990, 6, 1, 120, 2)),
                b(A2(xc, 120, io(60)), A5(Dc, 1991, 8, 29, 180, 2)),
                b(A2(xc, 120, wc(il)), A5(Dc, 1995, 0, 1, 0, 2))
            ]), A2(xc, 120, wc(yo))));
        }),
        b("Europe/Kirov", function() {
            return Xc(A2(kc, k([
                b(A2(xc, 240, wc(ss)), A5(Dc, 1989, 2, 26, 120, 1)),
                b(A2(xc, 180, wc(ss)), A5(Dc, 1991, 2, 31, 120, 1)),
                b(A2(xc, 240, io(0)), A5(Dc, 1992, 2, 29, 120, 1)),
                b(A2(xc, 180, wc(ss)), A5(Dc, 2011, 2, 27, 120, 1)),
                b(A2(xc, 240, io(0)), A5(Dc, 2014, 9, 26, 120, 1))
            ]), A2(xc, 180, io(0))));
        }),
        b("Europe/Lisbon", function() {
            return Xc(A2(kc, k([
                b(A2(xc, 60, io(0)), A5(Dc, 1976, 8, 26, 60, 2)),
                b(A2(xc, 0, wc(Vs)), A5(Dc, 1983, 8, 25, 60, 1)),
                b(A2(xc, 0, wc(Ws)), A5(Dc, 1992, 8, 27, 60, 1)),
                b(A2(xc, 60, wc(yo)), A5(Dc, 1996, 2, 31, 60, 0))
            ]), A2(xc, 0, wc(yo))));
        }),
        b("Europe/Ljubljana", wl),
        b("Europe/London", vl),
        b("Europe/Luxembourg", function() {
            return Xc(A2(kc, k([
                b(A2(xc, 60, io(0)), A5(Dc, 1977, 0, 1, 0, 2))
            ]), A2(xc, 60, wc(yo))));
        }),
        b("Europe/Madrid", function() {
            return Xc(A2(kc, k([
                b(A2(xc, 60, wc(kl)), A5(Dc, 1979, 0, 1, 0, 2))
            ]), A2(xc, 60, wc(yo))));
        }),
        b("Europe/Malta", function() {
            return Xc(A2(kc, k([
                b(A2(xc, 60, wc(xl)), A5(Dc, 1973, 2, 31, 0, 2)),
                b(A2(xc, 60, wc(yl)), A5(Dc, 1981, 0, 1, 0, 2))
            ]), A2(xc, 60, wc(yo))));
        }),
        b("Europe/Mariehamn", _l),
        b("Europe/Minsk", function() {
            return Xc(A2(kc, k([
                b(A2(xc, 180, wc(ss)), A5(Dc, 1990, 0, 1, 0, 2)),
                b(A2(xc, 180, io(0)), A5(Dc, 1991, 2, 31, 120, 1)),
                b(A2(xc, 120, wc(ss)), A5(Dc, 2011, 2, 27, 120, 1))
            ]), A2(xc, 180, io(0))));
        }),
        b("Europe/Monaco", function() {
            return Xc(A2(kc, k([
                b(A2(xc, 60, wc(Cl)), A5(Dc, 1977, 0, 1, 0, 2))
            ]), A2(xc, 60, wc(yo))));
        }),
        b("Europe/Moscow", function() {
            return Xc(A2(kc, k([
                b(A2(xc, 180, wc(ss)), A5(Dc, 1991, 2, 31, 120, 1)),
                b(A2(xc, 120, wc(ss)), A5(Dc, 1992, 0, 19, 120, 1)),
                b(A2(xc, 180, wc(ss)), A5(Dc, 2011, 2, 27, 120, 1)),
                b(A2(xc, 240, io(0)), A5(Dc, 2014, 9, 26, 120, 1))
            ]), A2(xc, 180, io(0))));
        }),
        b("Europe/Nicosia", Dl),
        b("Europe/Oslo", us),
        b("Europe/Paris", function() {
            return Xc(A2(kc, k([
                b(A2(xc, 60, wc(Cl)), A5(Dc, 1977, 0, 1, 0, 2))
            ]), A2(xc, 60, wc(yo))));
        }),
        b("Europe/Podgorica", Al),
        b("Europe/Prague", ul),
        b("Europe/Riga", function() {
            return Xc(A2(kc, k([
                b(A2(xc, 180, wc(ss)), A5(Dc, 1989, 2, 26, 120, 1)),
                b(A2(xc, 120, io(60)), A5(Dc, 1989, 8, 24, 120, 1)),
                b(A2(xc, 120, wc(ql)), A5(Dc, 1997, 0, 21, 0, 2)),
                b(A2(xc, 120, wc(yo)), A5(Dc, 2e3, 1, 29, 0, 2)),
                b(A2(xc, 120, io(0)), A5(Dc, 2001, 0, 2, 0, 2))
            ]), A2(xc, 120, wc(yo))));
        }),
        b("Europe/Rome", Bl),
        b("Europe/Samara", function() {
            return Xc(A2(kc, k([
                b(A2(xc, 240, wc(ss)), A5(Dc, 1989, 2, 26, 120, 1)),
                b(A2(xc, 180, wc(ss)), A5(Dc, 1991, 2, 31, 120, 1)),
                b(A2(xc, 120, wc(ss)), A5(Dc, 1991, 8, 29, 120, 1)),
                b(A2(xc, 180, io(0)), A5(Dc, 1991, 9, 20, 180, 2)),
                b(A2(xc, 240, wc(ss)), A5(Dc, 2010, 2, 28, 120, 1)),
                b(A2(xc, 180, wc(ss)), A5(Dc, 2011, 2, 27, 120, 1))
            ]), A2(xc, 240, io(0))));
        }),
        b("Europe/San_Marino", jl),
        b("Europe/Sarajevo", Sl),
        b("Europe/Saratov", function() {
            return Xc(A2(kc, k([
                b(A2(xc, 240, wc(ss)), A5(Dc, 1988, 2, 27, 120, 1)),
                b(A2(xc, 180, wc(ss)), A5(Dc, 1991, 2, 31, 120, 1)),
                b(A2(xc, 240, io(0)), A5(Dc, 1992, 2, 29, 120, 1)),
                b(A2(xc, 180, wc(ss)), A5(Dc, 2011, 2, 27, 120, 1)),
                b(A2(xc, 240, io(0)), A5(Dc, 2014, 9, 26, 120, 1)),
                b(A2(xc, 180, io(0)), A5(Dc, 2016, 11, 4, 120, 1))
            ]), A2(xc, 240, io(0))));
        }),
        b("Europe/Simferopol", function() {
            return Xc(A2(kc, k([
                b(A2(xc, 180, wc(ss)), A5(Dc, 1990, 0, 1, 0, 2)),
                b(A2(xc, 180, io(0)), A5(Dc, 1990, 6, 1, 120, 2)),
                b(A2(xc, 120, io(0)), A5(Dc, 1992, 0, 1, 0, 2)),
                b(A2(xc, 120, wc(il)), A5(Dc, 1994, 4, 1, 0, 2)),
                b(A2(xc, 180, wc(il)), A5(Dc, 1996, 2, 31, 0, 1)),
                b(A2(xc, 180, io(60)), A5(Dc, 1996, 9, 27, 180, 1)),
                b(A2(xc, 180, wc(ss)), A5(Dc, 1997, 0, 1, 0, 2)),
                b(A2(xc, 180, io(0)), A5(Dc, 1997, 2, 30, 60, 0)),
                b(A2(xc, 120, wc(yo)), A5(Dc, 2014, 2, 30, 120, 2)),
                b(A2(xc, 240, io(0)), A5(Dc, 2014, 9, 26, 120, 1))
            ]), A2(xc, 180, io(0))));
        }),
        b("Europe/Skopje", zl),
        b("Europe/Sofia", function() {
            return Xc(A2(kc, k([
                b(A2(xc, 120, io(0)), A5(Dc, 1979, 2, 31, 1380, 2)),
                b(A2(xc, 120, wc(Ul)), A5(Dc, 1982, 8, 26, 180, 2)),
                b(A2(xc, 120, wc(Of)), A5(Dc, 1991, 0, 1, 0, 2)),
                b(A2(xc, 120, wc(il)), A5(Dc, 1997, 0, 1, 0, 2))
            ]), A2(xc, 120, wc(yo))));
        }),
        b("Europe/Stockholm", function() {
            return Xc(A2(kc, k([
                b(A2(xc, 60, io(0)), A5(Dc, 1980, 0, 1, 0, 2))
            ]), A2(xc, 60, wc(yo))));
        }),
        b("Europe/Tallinn", function() {
            return Xc(A2(kc, k([
                b(A2(xc, 180, wc(ss)), A5(Dc, 1989, 2, 26, 120, 1)),
                b(A2(xc, 120, io(60)), A5(Dc, 1989, 8, 24, 120, 1)),
                b(A2(xc, 120, wc(Of)), A5(Dc, 1998, 8, 22, 0, 2)),
                b(A2(xc, 120, wc(yo)), A5(Dc, 1999, 9, 31, 240, 2)),
                b(A2(xc, 120, io(0)), A5(Dc, 2002, 1, 21, 0, 2))
            ]), A2(xc, 120, wc(yo))));
        }),
        b("Europe/Tirane", function() {
            return Xc(A2(kc, k([
                b(A2(xc, 60, wc(El)), A5(Dc, 1984, 6, 1, 0, 2))
            ]), A2(xc, 60, wc(yo))));
        }),
        b("Europe/Ulyanovsk", function() {
            return Xc(A2(kc, k([
                b(A2(xc, 240, wc(ss)), A5(Dc, 1989, 2, 26, 120, 1)),
                b(A2(xc, 180, wc(ss)), A5(Dc, 1991, 2, 31, 120, 1)),
                b(A2(xc, 120, wc(ss)), A5(Dc, 1992, 0, 19, 120, 1)),
                b(A2(xc, 180, wc(ss)), A5(Dc, 2011, 2, 27, 120, 1)),
                b(A2(xc, 240, io(0)), A5(Dc, 2014, 9, 26, 120, 1)),
                b(A2(xc, 180, io(0)), A5(Dc, 2016, 2, 27, 120, 1))
            ]), A2(xc, 240, io(0))));
        }),
        b("Europe/Uzhgorod", function() {
            return Xc(A2(kc, k([
                b(A2(xc, 180, wc(ss)), A5(Dc, 1990, 0, 1, 0, 2)),
                b(A2(xc, 180, io(0)), A5(Dc, 1990, 6, 1, 120, 2)),
                b(A2(xc, 60, io(0)), A5(Dc, 1991, 2, 31, 180, 2)),
                b(A2(xc, 120, io(0)), A5(Dc, 1992, 0, 1, 0, 2)),
                b(A2(xc, 120, wc(il)), A5(Dc, 1995, 0, 1, 0, 2))
            ]), A2(xc, 120, wc(yo))));
        }),
        b("Europe/Vaduz", Pl),
        b("Europe/Vatican", Tl),
        b("Europe/Vienna", function() {
            return Xc(A2(kc, k([
                b(A2(xc, 60, wc(Fl)), A5(Dc, 1981, 0, 1, 0, 2))
            ]), A2(xc, 60, wc(yo))));
        }),
        b("Europe/Vilnius", function() {
            return Xc(A2(kc, k([
                b(A2(xc, 180, wc(ss)), A5(Dc, 1989, 2, 26, 120, 1)),
                b(A2(xc, 120, wc(ss)), A5(Dc, 1991, 8, 29, 120, 1)),
                b(A2(xc, 120, wc(Of)), A5(Dc, 1998, 0, 1, 0, 2)),
                b(A2(xc, 120, io(0)), A5(Dc, 1998, 2, 29, 60, 0)),
                b(A2(xc, 60, wc(yo)), A5(Dc, 1999, 9, 31, 60, 0)),
                b(A2(xc, 120, io(0)), A5(Dc, 2003, 0, 1, 0, 2))
            ]), A2(xc, 120, wc(yo))));
        }),
        b("Europe/Volgograd", function() {
            return Xc(A2(kc, k([
                b(A2(xc, 240, wc(ss)), A5(Dc, 1988, 2, 27, 120, 1)),
                b(A2(xc, 180, wc(ss)), A5(Dc, 1991, 2, 31, 120, 1)),
                b(A2(xc, 240, io(0)), A5(Dc, 1992, 2, 29, 120, 1)),
                b(A2(xc, 180, wc(ss)), A5(Dc, 2011, 2, 27, 120, 1)),
                b(A2(xc, 240, io(0)), A5(Dc, 2014, 9, 26, 120, 1)),
                b(A2(xc, 180, io(0)), A5(Dc, 2018, 9, 28, 120, 1))
            ]), A2(xc, 240, io(0))));
        }),
        b("Europe/Warsaw", function() {
            return Xc(A2(kc, k([
                b(A2(xc, 60, io(0)), A5(Dc, 1977, 0, 1, 0, 2)),
                b(A2(xc, 60, wc(Ws)), A5(Dc, 1988, 0, 1, 0, 2))
            ]), A2(xc, 60, wc(yo))));
        }),
        b("Europe/Zagreb", Ll),
        b("Europe/Zaporozhye", function() {
            return Xc(A2(kc, k([
                b(A2(xc, 180, wc(ss)), A5(Dc, 1991, 2, 31, 120, 2)),
                b(A2(xc, 120, wc(il)), A5(Dc, 1995, 0, 1, 0, 2))
            ]), A2(xc, 120, wc(yo))));
        }),
        b("Europe/Zurich", fl),
        b("Indian/Antananarivo", Hl),
        b("Indian/Chagos", function() {
            return Xc(A2(kc, k([
                b(A2(xc, 300, io(0)), A5(Dc, 1996, 0, 1, 0, 2))
            ]), A2(xc, 360, io(0))));
        }),
        b("Indian/Christmas", function() {
            return Xc(A2(kc, h, A2(xc, 420, io(0))));
        }),
        b("Indian/Cocos", function() {
            return Xc(A2(kc, h, A2(xc, 390, io(0))));
        }),
        b("Indian/Comoro", Rl),
        b("Indian/Kerguelen", function() {
            return Xc(A2(kc, h, A2(xc, 300, io(0))));
        }),
        b("Indian/Mahe", function() {
            return Xc(A2(kc, h, A2(xc, 240, io(0))));
        }),
        b("Indian/Maldives", function() {
            return Xc(A2(kc, h, A2(xc, 300, io(0))));
        }),
        b("Indian/Mauritius", function() {
            return Xc(A2(kc, h, A2(xc, 240, wc(Ol))));
        }),
        b("Indian/Mayotte", Nl),
        b("Indian/Reunion", function() {
            return Xc(A2(kc, h, A2(xc, 240, io(0))));
        }),
        b("Pacific/Apia", function() {
            return Xc(A2(kc, k([
                b(A2(xc, -660, wc(Il)), A5(Dc, 2011, 11, 29, 1440, 2))
            ]), A2(xc, 780, wc(Il))));
        }),
        b("Pacific/Auckland", rs),
        b("Pacific/Bougainville", function() {
            return Xc(A2(kc, k([
                b(A2(xc, 600, io(0)), A5(Dc, 2014, 11, 28, 120, 2))
            ]), A2(xc, 660, io(0))));
        }),
        b("Pacific/Chatham", function() {
            return Xc(A2(kc, h, A2(xc, 765, wc(Vl))));
        }),
        b("Pacific/Chuuk", function() {
            return Xc(A2(kc, h, A2(xc, 600, io(0))));
        }),
        b("Pacific/Easter", function() {
            return Xc(A2(kc, k([
                b(A2(xc, -420, wc(Hf)), A5(Dc, 1982, 2, 14, 180, 0))
            ]), A2(xc, -360, wc(Hf))));
        }),
        b("Pacific/Efate", function() {
            return Xc(A2(kc, h, A2(xc, 660, wc(Wl))));
        }),
        b("Pacific/Enderbury", function() {
            return Xc(A2(kc, k([
                b(A2(xc, -720, io(0)), A5(Dc, 1979, 9, 1, 0, 2)),
                b(A2(xc, -660, io(0)), A5(Dc, 1994, 11, 31, 0, 2))
            ]), A2(xc, 780, io(0))));
        }),
        b("Pacific/Fakaofo", function() {
            return Xc(A2(kc, k([
                b(A2(xc, -660, io(0)), A5(Dc, 2011, 11, 30, 0, 2))
            ]), A2(xc, 780, io(0))));
        }),
        b("Pacific/Fiji", function() {
            return Xc(A2(kc, h, A2(xc, 720, wc(Zl))));
        }),
        b("Pacific/Funafuti", function() {
            return Xc(A2(kc, h, A2(xc, 720, io(0))));
        }),
        b("Pacific/Galapagos", function() {
            return Xc(A2(kc, k([
                b(A2(xc, -300, io(0)), A5(Dc, 1986, 0, 1, 0, 2))
            ]), A2(xc, -360, wc(qf))));
        }),
        b("Pacific/Gambier", function() {
            return Xc(A2(kc, h, A2(xc, -540, io(0))));
        }),
        b("Pacific/Guadalcanal", function() {
            return Xc(A2(kc, h, A2(xc, 660, io(0))));
        }),
        b("Pacific/Guam", Gl),
        b("Pacific/Honolulu", function() {
            return Xc(A2(kc, h, A2(xc, -600, io(0))));
        }),
        b("Pacific/Kiritimati", function() {
            return Xc(A2(kc, k([
                b(A2(xc, -640, io(0)), A5(Dc, 1979, 9, 1, 0, 2)),
                b(A2(xc, -600, io(0)), A5(Dc, 1994, 11, 31, 0, 2))
            ]), A2(xc, 840, io(0))));
        }),
        b("Pacific/Kosrae", function() {
            return Xc(A2(kc, k([
                b(A2(xc, 720, io(0)), A5(Dc, 1999, 0, 1, 0, 2))
            ]), A2(xc, 660, io(0))));
        }),
        b("Pacific/Kwajalein", function() {
            return Xc(A2(kc, k([
                b(A2(xc, -720, io(0)), A5(Dc, 1993, 7, 20, 1440, 2))
            ]), A2(xc, 720, io(0))));
        }),
        b("Pacific/Majuro", function() {
            return Xc(A2(kc, h, A2(xc, 720, io(0))));
        }),
        b("Pacific/Marquesas", function() {
            return Xc(A2(kc, h, A2(xc, -570, io(0))));
        }),
        b("Pacific/Midway", Yl),
        b("Pacific/Nauru", function() {
            return Xc(A2(kc, k([
                b(A2(xc, 690, io(0)), A5(Dc, 1979, 1, 10, 120, 2))
            ]), A2(xc, 720, io(0))));
        }),
        b("Pacific/Niue", function() {
            return Xc(A2(kc, k([
                b(A2(xc, -690, io(0)), A5(Dc, 1978, 9, 1, 0, 2))
            ]), A2(xc, -660, io(0))));
        }),
        b("Pacific/Norfolk", function() {
            return Xc(A2(kc, k([
                b(A2(xc, 690, io(0)), A5(Dc, 1974, 9, 27, 120, 1)),
                b(A2(xc, 690, io(60)), A5(Dc, 1975, 2, 2, 120, 1)),
                b(A2(xc, 690, io(0)), A5(Dc, 2015, 9, 4, 120, 1)),
                b(A2(xc, 660, io(0)), A5(Dc, 2019, 6, 1, 0, 2))
            ]), A2(xc, 660, wc(Ys))));
        }),
        b("Pacific/Noumea", function() {
            return Xc(A2(kc, h, A2(xc, 660, wc(Ql))));
        }),
        b("Pacific/Pago_Pago", Jl),
        b("Pacific/Palau", function() {
            return Xc(A2(kc, h, A2(xc, 540, io(0))));
        }),
        b("Pacific/Pitcairn", function() {
            return Xc(A2(kc, k([
                b(A2(xc, -510, io(0)), A5(Dc, 1998, 3, 27, 0, 2))
            ]), A2(xc, -480, io(0))));
        }),
        b("Pacific/Pohnpei", function() {
            return Xc(A2(kc, h, A2(xc, 660, io(0))));
        }),
        b("Pacific/Port_Moresby", function() {
            return Xc(A2(kc, h, A2(xc, 600, io(0))));
        }),
        b("Pacific/Rarotonga", function() {
            return Xc(A2(kc, k([
                b(A2(xc, -630, io(0)), A5(Dc, 1978, 10, 12, 0, 2))
            ]), A2(xc, -600, wc(Kl))));
        }),
        b("Pacific/Saipan", nd),
        b("Pacific/Tahiti", function() {
            return Xc(A2(kc, h, A2(xc, -600, io(0))));
        }),
        b("Pacific/Tarawa", function() {
            return Xc(A2(kc, h, A2(xc, 720, io(0))));
        }),
        b("Pacific/Tongatapu", function() {
            return Xc(A2(kc, k([
                b(A2(xc, 780, io(0)), A5(Dc, 1999, 0, 1, 0, 2))
            ]), A2(xc, 780, wc(rd))));
        }),
        b("Pacific/Wake", function() {
            return Xc(A2(kc, h, A2(xc, 720, io(0))));
        }),
        b("Pacific/Wallis", function() {
            return Xc(A2(kc, h, A2(xc, 720, io(0))));
        })
    ])), ed = A2(_u, function(n) {
        if (n.$) return uo(eo);
        var r = n.a, t = A2(Zu, r, td);
        return t.$ ? uo({
            $: 1,
            a: r
        }) : gu(b(r, (0, t.a)(0)));
    }, ao), ud = ur, ad = ud, id = function(n) {
        var r = n.Dr;
        return {
            gY: Te,
            qU: n.qU,
            dj: function(n) {
                return A2(Je, r(n), ad);
            },
            kt: n.Dt,
            aN: !1
        };
    }, cd = function(n) {
        return n.sT;
    }, od = function(n) {
        return n.vV;
    }, fd = function(n) {
        return n.l_.wD;
    }, sd = function(n) {
        return n.gA.wD;
    }, ld = function(n) {
        return n.ac.wD;
    }, dd = function(n) {
        return n.hv.pz;
    }, bd = function(n) {
        return n.hv.pR;
    }, vd = function(n) {
        return n.hv.wD;
    }, md = function(n) {
        return n.g.xI;
    }, pd = function(n) {
        return n.g.mh;
    }, $d = function(n) {
        return n.g.nh;
    }, hd = function(n) {
        return n.g.om;
    }, gd = function(n) {
        return n.g.on;
    }, wd = function(n) {
        return n.g.oo;
    }, kd = function(n) {
        return n.g.yB;
    }, xd = function(n) {
        return n.g.op;
    }, yd = function(n) {
        return n.g.oq;
    }, _d = function(n) {
        return n.g.y_;
    }, Cd = function(n) {
        return n.g.pi;
    }, Dd = function(n) {
        return n.g.pj;
    }, Ad = function(n) {
        return n.g.pk;
    }, qd = function(n) {
        return n.g.rb;
    }, Bd = function(n) {
        return n.g.dm;
    }, jd = function(n) {
        return n.g.s9;
    }, Sd = function(n) {
        return n.g.BC;
    }, zd = function(n) {
        return n.g.tN;
    }, Ud = function(n) {
        return n.g.tY;
    }, Ed = function(n) {
        return n.g.tZ;
    }, Pd = function(n) {
        return n.g.ua;
    }, Td = function(n) {
        return n.g.wq;
    }, Fd = function(n) {
        return n.g.Df;
    }, Ld = function(n) {
        return n.g.wD;
    }, Md = function(n) {
        return n.g.Du;
    }, Hd = function(n) {
        return n.g.wO;
    }, Rd = function(n) {
        return n.g.wR;
    }, Od = function(n) {
        return n.g.xq;
    }, Nd = function(n) {
        return n.g.DS;
    }, Id = {
        lI: function(n) {
            return n.Av.lI;
        },
        lJ: function(n) {
            return n.Av.lJ;
        },
        lK: function(n) {
            return n.Av.lK;
        },
        lL: function(n) {
            return n.Av.lL;
        },
        lN: function(n) {
            return n.Av.lN;
        },
        lO: function(n) {
            return n.Av.lO;
        },
        lP: function(n) {
            return n.Av.lP;
        },
        lX: function(n) {
            return n.Av.lX;
        },
        yR: function(n) {
            return n.Av.yR;
        },
        pq: function(n) {
            return n.Av.pq;
        },
        py: function(n) {
            return n.Av.py;
        },
        qC: function(n) {
            return n.Av.qC;
        },
        qD: function(n) {
            return n.Av.qD;
        },
        qE: function(n) {
            return n.Av.qE;
        },
        qF: function(n) {
            return n.Av.qF;
        },
        qY: function(n) {
            return n.Av.qY;
        },
        qZ: function(n) {
            return n.Av.qZ;
        },
        dm: function(n) {
            return n.Av.dm;
        },
        rW: function(n) {
            return n.Av.rW;
        },
        Al: function(n) {
            return n.Av.Al;
        },
        s2: function(n) {
            return n.Av.s2;
        },
        wD: function(n) {
            return n.Av.wD;
        },
        DS: function(n) {
            return n.Av.DS;
        }
    }, Vd = {
        oa: function(n) {
            return n._.oa;
        },
        ou: function(n) {
            return n._.ou;
        },
        oz: function(n) {
            return n._.oz;
        },
        pE: function(n) {
            return n._.pE;
        },
        pF: function(n) {
            return n._.pF;
        },
        ij: function(n) {
            return n._.ij;
        },
        u9: function(n) {
            return n._.u9;
        },
        iI: function(n) {
            return n._.iI;
        },
        wD: function(n) {
            return n._.wD;
        },
        Dq: function(n) {
            return n._.Dq;
        },
        DS: function(n) {
            return n._.DS;
        },
        xw: function(n) {
            return n._.xw;
        }
    }, Wd = function(n) {
        return n.J.xG;
    }, Zd = function(n) {
        return n.J.yp;
    }, Xd = function(n) {
        return n.J.p_;
    }, Gd = function(n) {
        return n.J.zj;
    }, Jd = function(n) {
        return n.J.zk;
    }, Yd = function(n) {
        return n.J.p$;
    }, Qd = function(n) {
        return n.J.zl;
    }, Kd = function(n) {
        return n.J.sZ;
    }, nb = function(n) {
        return n.J.s_;
    }, rb = function(n) {
        return n.J.s$;
    }, tb = function(n) {
        return n.J.s0;
    }, eb = function(n) {
        return n.J.s1;
    }, ub = function(n) {
        return n.J.wD;
    }, ab = function(n) {
        return n.BP.lI;
    }, ib = function(n) {
        return n.BP.lQ;
    }, cb = function(n) {
        return n.BP.gL;
    }, ob = function(n) {
        return n.BP.ok;
    }, fb = function(n) {
        return n.BP.pb;
    }, sb = function(n) {
        return n.BP.pr;
    }, lb = function(n) {
        return n.BP.hj;
    }, db = function(n) {
        return n.BP.hk;
    }, bb = function(n) {
        return n.BP.re;
    }, vb = function(n) {
        return n.BP.dm;
    }, mb = function(n) {
        return n.BP.rV;
    }, pb = function(n) {
        return n.BP.tO;
    }, $b = function(n) {
        return n.BP.Ct;
    }, hb = function(n) {
        return n.BP.wD;
    }, gb = function(n) {
        return n.BP.wM;
    }, wb = function(n) {
        return n.BP.jD;
    }, kb = function(n) {
        return n.BP.DS;
    }, xb = function(n) {
        return n.BP.xy;
    }, yb = function(n) {
        return n.BP.xA;
    }, _b = function(n) {
        return n.k2.vD;
    }, Cb = function(n) {
        return n.k2.wD;
    }, Db = function(n) {
        switch(n){
            case 0:
                return Ld;
            case 1:
                return Id.wD;
            case 2:
                return Vd.wD;
            case 3:
                return hb;
            case 4:
                return ld;
            case 5:
                return fd;
            case 6:
                return Cb;
            case 7:
                return vd;
            case 8:
                return ub;
            default:
                return sd;
        }
    }, Ab = F3(function(n, r, t) {
        return r(t.$ ? n ? cd : od : Db(t.a));
    }), qb = function(n) {
        return n.$ ? "LogOut" : function(n) {
            switch(n){
                case 0:
                    return "Invoices";
                case 1:
                    return "Members";
                case 2:
                    return "Memberships";
                case 3:
                    return "PaymentSources";
                case 4:
                    return "Documents";
                case 5:
                    return "AdditionalServices";
                case 6:
                    return "ProviderLocation";
                case 7:
                    return "HealthInformation";
                case 8:
                    return "Chat";
                default:
                    return "Booking";
            }
        }(n.a);
    }, Bb = function(n) {
        return {
            bY: !1,
            dC: id({
                qU: "profile-menu",
                Dr: Ab(n),
                Dt: A2(Je, qb, Ht)
            })
        };
    }, jb = Bb(!1), Sb = function(n) {
        return n.pH;
    }, zb = function(n) {
        return n.v7;
    }, Ub = function(n) {
        return n ? zb : Sb;
    }, Eb = function(n) {
        return n ? "es" : "en";
    }, Pb = function(n) {
        return {
            qU: n,
            z6: 0,
            fw: id({
                qU: n + "-preferred-language-select",
                Dr: function(n) {
                    return A2(Je, Ub, n);
                },
                Dt: function(n) {
                    return Ht(Eb(n));
                }
            })
        };
    }, Tb = E, Fb = function(n) {
        return A2(Tb, n, "");
    }, Lb = F3(function(n, r, t) {
        return n > 0 ? A3(Lb, n >> 1, $(r, r), 1 & n ? $(t, r) : t) : t;
    }), Mb = F2(function(n, r) {
        return A3(Lb, n, r, "");
    }), Hb = F3(function(n, r, t) {
        return $(A2(Mb, n - au(t), Fb(r)), t);
    }), Rb = F2(function(n, r) {
        var t = function() {
            switch(r){
                case 1:
                    return "1st";
                case 21:
                    return "21st";
                case 2:
                    return "2nd";
                case 22:
                    return "22nd";
                case 3:
                    return "3rd";
                case 23:
                    return "23rd";
                case 31:
                    return "31st";
                default:
                    return ee(r) + "th";
            }
        }();
        return n ? A3(Hb, 4, " ", t) : t;
    }), Ob = {
        zs: {
            oD: "%-m/%-d/%Y",
            yK: "%-m/%-d/%Y %-I:%M %p",
            hp: 6,
            Af: "%A, %B %d, %Y",
            Ag: "%-I:%M:%S %p",
            Dn: "%-I:%M %p"
        },
        av: {
            oI: function(n) {
                switch(n){
                    case 0:
                        return "Monday";
                    case 1:
                        return "Tuesday";
                    case 2:
                        return "Wednesday";
                    case 3:
                        return "Thursday";
                    case 4:
                        return "Friday";
                    case 5:
                        return "Saturday";
                    default:
                        return "Sunday";
                }
            },
            oJ: Rb,
            oK: function(n) {
                switch(n){
                    case 0:
                        return "Mon";
                    case 1:
                        return "Tue";
                    case 2:
                        return "Wed";
                    case 3:
                        return "Thu";
                    case 4:
                        return "Fri";
                    case 5:
                        return "Sat";
                    default:
                        return "Sun";
                }
            },
            sO: function(n) {
                switch(n){
                    case 0:
                        return "January";
                    case 1:
                        return "February";
                    case 2:
                        return "March";
                    case 3:
                        return "April";
                    case 4:
                        return "May";
                    case 5:
                        return "June";
                    case 6:
                        return "July";
                    case 7:
                        return "August";
                    case 8:
                        return "September";
                    case 9:
                        return "October";
                    case 10:
                        return "November";
                    default:
                        return "December";
                }
            },
            sP: function(n) {
                switch(n){
                    case 0:
                        return "Jan";
                    case 1:
                        return "Feb";
                    case 2:
                        return "Mar";
                    case 3:
                        return "Apr";
                    case 4:
                        return "May";
                    case 5:
                        return "Jun";
                    case 6:
                        return "Jul";
                    case 7:
                        return "Aug";
                    case 8:
                        return "Sep";
                    case 9:
                        return "Oct";
                    case 10:
                        return "Nov";
                    default:
                        return "Dec";
                }
            },
            wU: function(n) {
                return n ? "PM" : "AM";
            }
        }
    }, Nb = F4(function(n, r, t, e) {
        return {
            kn: r,
            ky: n,
            s9: t,
            Dc: e
        };
    }), Ib = ut, Vb = function(n) {
        return A2(Ib, {
            yf: !1,
            AC: !1
        }, n);
    }, Wb = /.^/, Zb = A2(uc, Wb, Vb("%(y|Y|m|_m|-m|B|^B|b|^b|d|-d|-@d|e|@e|A|^A|a|^a|H|-H|k|I|-I|l|p|P|M|S|%|L)")), Xb = F2(function(n, r) {
        return r.$ ? Rt : n(r.a);
    }), Gb = function(n) {
        return n.b ? Ht(n.a) : Rt;
    }, Jb = function(n) {
        return A2(qc, 12, n) ? A2(qc, 12, n) : 12;
    }, Yb = function(n) {
        switch(n){
            case 0:
                return 1;
            case 1:
                return 2;
            case 2:
                return 3;
            case 3:
                return 4;
            case 4:
                return 5;
            case 5:
                return 6;
            case 6:
                return 7;
            case 7:
                return 8;
            case 8:
                return 9;
            case 9:
                return 10;
            case 10:
                return 11;
            default:
                return 12;
        }
    }, Qb = function(n) {
        return A2(sc, A2(Hb, 2, n), ee);
    }, Kb = F2(function(n, r) {
        return A2(sc, A2(Hb, n, r), ee);
    }), nv = F2(function(n, r) {
        return 1 > n ? "" : A3(iu, -n, au(r), r);
    }), rv = F2(function(n, r) {
        return Fe(n / r);
    }), tv = F3(function(n, r, t) {
        for(;;){
            if (!t.b) return r + n;
            var e = t.a, u = t.b;
            if (0 > s(e.wc, r)) return r + e.h3;
            t = u;
        }
    }), ev = F2(function(n, r) {
        var t = n.b;
        return A3(tv, n.a, A2(rv, r, 6e4), t);
    }), uv = function(n) {
        var r = A2(rv, n, 1440) + 719468, t = (0 > r ? r - 146096 : r) / 146097 | 0, e = r - 146097 * t, u = (e - (e / 1460 | 0) + (e / 36524 | 0) - (e / 146096 | 0)) / 365 | 0, a = e - (365 * u + (u / 4 | 0) - (u / 100 | 0)), i = (5 * a + 2) / 153 | 0, c = i + (10 > i ? 3 : -9);
        return {
            oH: a - ((153 * i + 2) / 5 | 0) + 1,
            sN: c,
            xm: u + 400 * t + (c > 2 ? 0 : 1)
        };
    }, av = F2(function(n, r) {
        return uv(A2(ev, n, r)).oH;
    }), iv = F2(function(n, r) {
        return A2(qc, 24, A2(rv, A2(ev, n, r), 60));
    }), cv = F2(function(n, r) {
        return A2(qc, 1e3, r);
    }), ov = F2(function(n, r) {
        return A2(qc, 60, A2(ev, n, r));
    }), fv = F2(function(n, r) {
        switch(uv(A2(ev, n, r)).sN){
            case 1:
                return 0;
            case 2:
                return 1;
            case 3:
                return 2;
            case 4:
                return 3;
            case 5:
                return 4;
            case 6:
                return 5;
            case 7:
                return 6;
            case 8:
                return 7;
            case 9:
                return 8;
            case 10:
                return 9;
            case 11:
                return 10;
            default:
                return 11;
        }
    }), sv = F2(function(n, r) {
        return A2(qc, 60, A2(rv, r, 1e3));
    }), lv = function(n) {
        return n.toUpperCase();
    }, dv = F2(function(n, r) {
        switch(A2(qc, 7, A2(rv, A2(ev, n, r), 1440))){
            case 0:
                return 3;
            case 1:
                return 4;
            case 2:
                return 5;
            case 3:
                return 6;
            case 4:
                return 0;
            case 5:
                return 1;
            default:
                return 2;
        }
    }), bv = F2(function(n, r) {
        return uv(A2(ev, n, r)).xm;
    }), vv = F2(function(n, r) {
        return 12 > A2(iv, n, r) ? 0 : 1;
    }), mv = F4(function(n, r, t, e) {
        var u = A2(uc, " ", function(n) {
            return A2(Xb, ru, n);
        }(Gb(e.Dc)));
        switch(u){
            case "Y":
                return A3(Kb, 4, "0", A2(bv, r, t));
            case "y":
                return A2(nv, 2, A3(Kb, 2, "0", A2(bv, r, t)));
            case "m":
                return A2(Qb, "0", Yb(A2(fv, r, t)));
            case "_m":
                return A2(Qb, " ", Yb(A2(fv, r, t)));
            case "-m":
                return ee(Yb(A2(fv, r, t)));
            case "B":
                return n.av.sO(A2(fv, r, t));
            case "^B":
                return lv(n.av.sO(A2(fv, r, t)));
            case "b":
                return n.av.sP(A2(fv, r, t));
            case "^b":
                return lv(n.av.sP(A2(fv, r, t)));
            case "d":
                return A2(Qb, "0", A2(av, r, t));
            case "-d":
                return ee(A2(av, r, t));
            case "-@d":
                return A2(n.av.oJ, !1, A2(av, r, t));
            case "e":
                return A2(Qb, " ", A2(av, r, t));
            case "@e":
                return A2(n.av.oJ, !0, A2(av, r, t));
            case "A":
                return n.av.oI(A2(dv, r, t));
            case "^A":
                return lv(n.av.oI(A2(dv, r, t)));
            case "a":
                return n.av.oK(A2(dv, r, t));
            case "^a":
                return lv(n.av.oK(A2(dv, r, t)));
            case "H":
                return A2(Qb, "0", A2(iv, r, t));
            case "-H":
                return ee(A2(iv, r, t));
            case "k":
                return A2(Qb, " ", A2(iv, r, t));
            case "I":
                return A2(Qb, "0", Jb(A2(iv, r, t)));
            case "-I":
                return ee(Jb(A2(iv, r, t)));
            case "l":
                return A2(Qb, " ", Jb(A2(iv, r, t)));
            case "p":
                return lv(n.av.wU(A2(vv, r, t)));
            case "P":
                return n.av.wU(A2(vv, r, t));
            case "M":
                return A2(Qb, "0", A2(ov, r, t));
            case "S":
                return A2(Qb, "0", A2(sv, r, t));
            case "L":
                return A3(Kb, 3, "0", A2(cv, r, t));
            case "%":
                return u;
            default:
                return "";
        }
    }), pv = ct(ot), $v = F4(function(n, r, t, e) {
        return A3(pv, Zb, A3(mv, n, t, e), r);
    }), hv = function(n) {
        switch(n){
            case 0:
                return 1;
            case 1:
                return 2;
            case 2:
                return 3;
            case 3:
                return 4;
            case 4:
                return 5;
            case 5:
                return 6;
            case 6:
                return 7;
            case 7:
                return 8;
            case 8:
                return 9;
            case 9:
                return 10;
            case 10:
                return 11;
            default:
                return 12;
        }
    }, gv = function(n) {
        return !A2(qc, 4, n) && !!A2(qc, 100, n) || !A2(qc, 400, n);
    }, wv = F2(function(n, r) {
        switch(r){
            case 0:
            case 2:
            case 4:
            case 6:
            case 7:
            case 9:
            default:
                return 31;
            case 1:
                return gv(n) ? 29 : 28;
            case 3:
            case 5:
            case 8:
            case 10:
                return 30;
        }
    }), kv = function(n) {
        switch(A2(Me, 1, n)){
            case 1:
                return 0;
            case 2:
                return 1;
            case 3:
                return 2;
            case 4:
                return 3;
            case 5:
                return 4;
            case 6:
                return 5;
            case 7:
                return 6;
            case 8:
                return 7;
            case 9:
                return 8;
            case 10:
                return 9;
            case 11:
                return 10;
            default:
                return 11;
        }
    }, xv = F3(function(n, r, t) {
        for(;;){
            var e = A2(wv, n, r), u = hv(r);
            if (u >= 12 || 0 >= s(t, e)) return {
                oH: t,
                sN: r,
                xm: n
            };
            r = kv(u + 1), t -= e;
        }
    }), yv = F2(function(n, r) {
        return Fe(n / r);
    }), _v = function(n) {
        var r = n - 1;
        return 365 * r + (A2(yv, r, 4) - A2(yv, r, 100) + A2(yv, r, 400));
    }, Cv = F2(function(n, r) {
        return b(A2(yv, n, r), A2(qc, r, n));
    }), Dv = function(n) {
        var r = A2(Cv, n, 146097), t = r.a, e = A2(Cv, r.b, 36524), u = e.a, a = A2(Cv, e.b, 1461), i = a.a, c = A2(Cv, a.b, 365);
        return 400 * t + 100 * u + 4 * i + c.a + (c.b ? 1 : 0);
    }, Av = function(n) {
        var r = n, t = Dv(r);
        return {
            kP: r - _v(t),
            xm: t
        };
    }, qv = function(n) {
        var r = Av(n);
        return A3(xv, r.xm, 0, r.kP);
    }, Bv = function(n) {
        var r = qv(n);
        return 12 * (r.xm - 1) + (hv(r.sN) - 1) + r.oH / 100;
    }, jv = F3(function(n, r, t) {
        var e = r, u = t;
        switch(n){
            case 0:
                return (Bv(u) - Bv(e) | 0) / 12 | 0;
            case 1:
                return Bv(u) - Bv(e) | 0;
            case 2:
                return (u - e) / 7 | 0;
            default:
                return u - e;
        }
    }), Sv = A2(Je, qv, function(n) {
        return n.oH;
    }), zv = A2(Je, qv, function(n) {
        return n.sN;
    }), Uv = A2(Je, zv, hv), Ev = A2(Je, Av, function(n) {
        return n.kP;
    }), Pv = function(n) {
        return 0 > n ? -n : n;
    }, Tv = F2(function(n, r) {
        return $(0 > r ? "-" : "", A3(Hb, n, "0", ee(Pv(r))));
    }), Fv = function(n) {
        return (hv(n) + 2) / 3 | 0;
    }, Lv = A2(Je, zv, Fv), Mv = function(n) {
        return A2(qc, 7, n) || 7;
    }, Hv = function(n) {
        var r = _v(n) + 4;
        return r - Mv(r);
    }, Rv = function(n) {
        switch(A2(Me, 1, n)){
            case 1:
                return 0;
            case 2:
                return 1;
            case 3:
                return 2;
            case 4:
                return 3;
            case 5:
                return 4;
            case 6:
                return 5;
            default:
                return 6;
        }
    }, Ov = function(n) {
        var r = n, t = Mv(r), e = Dv(r + (4 - t));
        return {
            xf: 1 + ((r - (Hv(e) + 1)) / 7 | 0),
            xg: e,
            DL: Rv(t)
        };
    }, Nv = A2(Je, Ov, function(n) {
        return n.xf;
    }), Iv = A2(Je, Ov, function(n) {
        return n.xg;
    }), Vv = A2(Je, Mv, Rv), Wv = F2(function(n, r) {
        return 0 > s(n, r) ? n : r;
    }), Zv = function(n) {
        return $(ee(n), function(n) {
            var r = A2(qc, 100, n);
            switch(A2(Wv, 20 > r ? r : A2(qc, 10, r), 4)){
                case 1:
                    return "st";
                case 2:
                    return "nd";
                case 3:
                    return "rd";
                default:
                    return "th";
            }
        }(n));
    }, Xv = F4(function(n, r, t, e) {
        switch(r){
            case "y":
                return 2 === t ? A2(nv, 2, A3(Hb, 2, "0", ee(Dv(e)))) : A2(Tv, t, Dv(e));
            case "Y":
                return 2 === t ? A2(nv, 2, A3(Hb, 2, "0", ee(Iv(e)))) : A2(Tv, t, Iv(e));
            case "Q":
                switch(t){
                    case 1:
                    case 2:
                    case 5:
                        return ee(Lv(e));
                    case 3:
                        return "Q" + ee(Lv(e));
                    case 4:
                        return Zv(Lv(e));
                    default:
                        return "";
                }
            case "M":
                switch(t){
                    case 1:
                        return ee(Uv(e));
                    case 2:
                        return A3(Hb, 2, "0", ee(Uv(e)));
                    case 3:
                        return n.hY(zv(e));
                    case 4:
                        return n.sO(zv(e));
                    case 5:
                        return A2(su, 1, n.hY(zv(e)));
                    default:
                        return "";
                }
            case "w":
                switch(t){
                    case 1:
                        return ee(Nv(e));
                    case 2:
                        return A3(Hb, 2, "0", ee(Nv(e)));
                    default:
                        return "";
                }
            case "d":
                switch(t){
                    case 1:
                        return ee(Sv(e));
                    case 2:
                        return A3(Hb, 2, "0", ee(Sv(e)));
                    case 3:
                        return n.j5(Sv(e));
                    default:
                        return "";
                }
            case "D":
                switch(t){
                    case 1:
                        return ee(Ev(e));
                    case 2:
                        return A3(Hb, 2, "0", ee(Ev(e)));
                    case 3:
                        return A3(Hb, 3, "0", ee(Ev(e)));
                    default:
                        return "";
                }
            case "E":
                switch(t){
                    case 1:
                    case 2:
                    case 3:
                        return n.c_(Vv(e));
                    case 4:
                        return n.lt(Vv(e));
                    case 5:
                        return A2(su, 1, n.c_(Vv(e)));
                    case 6:
                        return A2(su, 2, n.c_(Vv(e)));
                    default:
                        return "";
                }
            case "e":
                switch(t){
                    case 1:
                    case 2:
                        return ee(Mv(e));
                    default:
                        return A4(Xv, n, "E", t, e);
                }
            default:
                return "";
        }
    }), Gv = F3(function(n, r, t) {
        return A3(ce, F2(function(r, e) {
            return $(r.$ ? r.a : A4(Xv, n, r.a, r.b, t), e);
        }), "", r);
    }), Jv = function(n) {
        return {
            $: 1,
            a: n
        };
    }, Yv = F2(function(n, r) {
        return {
            $: 1,
            a: n,
            b: r
        };
    }), Qv = F3(function(n, r, t) {
        return {
            $: 0,
            a: n,
            b: r,
            c: t
        };
    }), Kv = F2(function(n, r) {
        var t = r;
        return function(r) {
            var e = t(r);
            if (1 === e.$) return A2(Yv, e.a, e.b);
            var u = e.a, a = e.c, i = n(e.b)(a);
            if (1 === i.$) {
                var c = i.a;
                return A2(Yv, u || c, i.b);
            }
            return c = i.a, A3(Qv, u || c, i.b, i.c);
        };
    }), nm = Kv, rm = F2(function(n) {
        return n;
    }), tm = F3(function(n, r, t) {
        var e = r, u = t;
        return function(r) {
            var t = e(r);
            if (1 === t.$) return A2(Yv, t.a, t.b);
            var a = t.a, i = t.b, c = u(t.c);
            if (1 === c.$) {
                var o = c.a;
                return A2(Yv, a || o, c.b);
            }
            o = c.a;
            var f = c.c;
            return A3(Qv, a || o, A2(n, i, c.b), f);
        };
    }), em = F2(function(n, r) {
        return A3(tm, rm, n, r);
    }), um = em, am = function(n) {
        return function(r) {
            return A3(Qv, !1, n, r);
        };
    }, im = F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    }), cm = function(n) {
        return A2(im, n, {
            $: 0,
            a: n
        });
    }, om = F2(function(n, r) {
        return {
            $: 1,
            a: n,
            b: r
        };
    }), fm = F4(function(n, r, t, e) {
        return {
            nx: r,
            yy: e,
            uw: t,
            vt: n
        };
    }), sm = {
        $: 0
    }, lm = F2(function(n, r) {
        return A2(om, sm, A4(fm, n.vt, n.nx, r, n.e));
    }), dm = ft, bm = function(n) {
        return !n;
    }, vm = function(n) {
        var r = n.a, t = n.b, e = !fu(r);
        return function(n) {
            var u = A5(dm, r, n.h3, n.vt, n.nx, n.d), a = u.a, c = u.b, o = u.c;
            return i(a, -1) ? A2(Yv, !1, A2(lm, n, t)) : A3(Qv, e, 0, {
                nx: o,
                e: n.e,
                m: n.m,
                h3: a,
                vt: c,
                d: n.d
            });
        };
    }, mm = function(n) {
        return vm(cm(n));
    }, pm = A2(um, am(Jv("'")), mm("''")), $m = {
        $: 11
    }, hm = st, gm = F2(function(n, r) {
        return function(t) {
            var e = A3(hm, n, t.h3, t.d);
            return i(e, -1) ? A2(Yv, !1, A2(lm, t, r)) : i(e, -2) ? A3(Qv, !0, 0, {
                nx: 1,
                e: t.e,
                m: t.m,
                h3: t.h3 + 1,
                vt: t.vt + 1,
                d: t.d
            }) : A3(Qv, !0, 0, {
                nx: t.nx + 1,
                e: t.e,
                m: t.m,
                h3: e,
                vt: t.vt,
                d: t.d
            });
        };
    }), wm = function(n) {
        return A2(gm, n, $m);
    }, km = F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    }), xm = F5(function(n, r, t, e, u) {
        for(;;){
            var a = A3(hm, n, r, u.d);
            if (i(a, -1)) return A3(Qv, 0 > s(u.h3, r), 0, {
                nx: e,
                e: u.e,
                m: u.m,
                h3: r,
                vt: t,
                d: u.d
            });
            i(a, -2) ? (r += 1, t += 1, e = 1) : (r = a, e += 1);
        }
    }), ym = function(n) {
        return function(r) {
            return A5(xm, n, r.h3, r.vt, r.nx, r);
        };
    }, _m = ym, Cm = function(n) {
        return A3(Qv, !1, n.h3, n);
    }, Dm = F2(function(n, r) {
        return A3(tm, Ee, n, r);
    }), Am = Dm, qm = function(n) {
        var r;
        return r = {
            $: 12,
            a: n
        }, function(n) {
            return A2(Yv, !1, A2(lm, n, r));
        };
    }, Bm = L, jm = function(n) {
        return A3(Bm, Ot, h, n);
    }, Sm = function(n) {
        var r = jm(n);
        if (r.b && !r.b.b) {
            var t = r.a;
            return A2(Am, A2(Am, am(F2(function(n, r) {
                return A2(km, t, r - n + 1);
            })), A2(um, Cm, _m(Te(t)))), Cm);
        }
        return qm("expected exactly one char");
    }, zm = F2(function(n, r) {
        var t = r;
        return function(r) {
            var e = t(r);
            if (1 === e.$) return A2(Yv, e.a, e.b);
            var u = e.b, a = e.c;
            return A3(Qv, e.a, A2(n, A3(iu, r.h3, a.h3, r.d), u), a);
        };
    }), Um = function(n) {
        return A2(zm, rm, n);
    }, Em = A2(nm, Sm, Um(wm($e))), Pm = A2(ce, F2(function(n, r) {
        var t = b(n, r);
        if (1 === t.a.$ && t.b.b && 1 === t.b.a.$) {
            var e = t.b, u = e.b;
            return A2(Ot, Jv($(t.a.a, e.a.a)), u);
        }
        return A2(Ot, n, r);
    }), h), Tm = function(n) {
        return "'" !== n && !$e(n);
    }, Fm = F2(function(n, r) {
        var t = r;
        return function(r) {
            var e = t(r);
            if (e.$) return A2(Yv, e.a, e.b);
            var u = e.c;
            return A3(Qv, e.a, n(e.b), u);
        };
    }), Lm = Fm, Mm = A2(Lm, Jv, Um(A2(um, A2(um, am(0), wm(Tm)), _m(Tm)))), Hm = F2(function(n, r) {
        return {
            $: 2,
            a: n,
            b: r
        };
    }), Rm = F3(function(n, r, t) {
        n: for(;;){
            if (t.b) {
                var e = t.b, u = (0, t.a)(n);
                if (u.$) {
                    var a;
                    if ((a = u).a) return a;
                    r = A2(Hm, r, a.b), t = e;
                    continue n;
                }
                return u;
            }
            return A2(Yv, !1, r);
        }
    }), Om = function(n) {
        return function(r) {
            return A3(Rm, r, sm, n);
        };
    }, Nm = (Su = {
        $: 10
    }, function(n) {
        return i(au(n.d), n.h3) ? A3(Qv, !1, 0, n) : A2(Yv, !1, A2(lm, n, Su));
    }), Im = function(n) {
        return Om(k([
            A2(nm, function(r) {
                return Im($(n, r));
            }, Um(A2(um, A2(um, am(0), wm(Sc("'"))), _m(Sc("'"))))),
            A2(nm, function() {
                return Im(n + "'");
            }, mm("''")),
            am(n)
        ]));
    }, Vm = A2(Am, A2(um, am(Jv), wm(Te("'"))), A2(um, Im(""), Om(k([
        wm(Te("'")),
        Nm
    ])))), Wm = function(n) {
        var r;
        return Om(k([
            A2(nm, function(r) {
                return Wm(A2(Ot, r, n));
            }, Om(k([
                Em,
                Mm,
                pm,
                Vm
            ]))),
            (r = function() {
                return am(Pm(n));
            }, function(n) {
                return r(0)(n);
            })
        ]));
    }, Zm = F3(function(n, r, t) {
        return {
            nx: r,
            uw: t,
            vt: n
        };
    }), Xm = function(n) {
        return A3(Zm, n.vt, n.nx, n.uw);
    }, Gm = F2(function(n, r) {
        n: for(;;)switch(n.$){
            case 0:
                return r;
            case 1:
                var t = n.b;
                n = n.a, r = A2(Ot, t, r);
                continue n;
            default:
                var e = n.b;
                n = n.a, r = A2(Gm, e, r);
                continue n;
        }
    }), Jm = F2(function(n, r) {
        var t = n({
            nx: 1,
            e: h,
            m: 1,
            h3: 0,
            vt: 1,
            d: r
        });
        return t.$ ? Xt(A2(Gm, t.b, h)) : Qt(t.b);
    }), Ym = F2(function(n, r) {
        var t = A2(Jm, n, r);
        return t.$ ? Xt(A2(yu, Xm, t.a)) : Qt(t.a);
    }), Qm = F2(function(n, r) {
        return r.$ ? n : r.a;
    }), Km = F2(function(n, r) {
        var t, e = we(A2(Qm, k([
            Jv(t = r)
        ]), A2(Ym, Wm(h), t)));
        return A2(Gv, n, e);
    }), np = function(n) {
        switch(n){
            case 0:
                return "January";
            case 1:
                return "February";
            case 2:
                return "March";
            case 3:
                return "April";
            case 4:
                return "May";
            case 5:
                return "June";
            case 6:
                return "July";
            case 7:
                return "August";
            case 8:
                return "September";
            case 9:
                return "October";
            case 10:
                return "November";
            default:
                return "December";
        }
    }, rp = function(n) {
        switch(n){
            case 0:
                return "Monday";
            case 1:
                return "Tuesday";
            case 2:
                return "Wednesday";
            case 3:
                return "Thursday";
            case 4:
                return "Friday";
            case 5:
                return "Saturday";
            default:
                return "Sunday";
        }
    }, tp = {
        j5: Zv,
        sO: np,
        hY: A2(Je, np, su(3)),
        lt: rp,
        c_: A2(Je, rp, su(3))
    }, ep = function(n) {
        return A2(Km, tp, n);
    }, up = F3(function(n, r, t) {
        return 0 > s(t, n) ? n : s(t, r) > 0 ? r : t;
    }), ap = F2(function(n, r) {
        var t = gv(n) ? 1 : 0;
        switch(r){
            case 0:
                return 0;
            case 1:
                return 31;
            case 2:
                return 59 + t;
            case 3:
                return 90 + t;
            case 4:
                return 120 + t;
            case 5:
                return 151 + t;
            case 6:
                return 181 + t;
            case 7:
                return 212 + t;
            case 8:
                return 243 + t;
            case 9:
                return 273 + t;
            case 10:
                return 304 + t;
            default:
                return 334 + t;
        }
    }), ip = F3(function(n, r, t) {
        return _v(n) + A2(ap, n, r) + A3(up, 1, A2(wv, n, r), t);
    }), cp = F2(function(n, r) {
        return A3(ip, A2(bv, n, r), A2(fv, n, r), A2(av, n, r));
    }), op = F3(function(n, r, t) {
        var e = A2(cp, n, t), u = A2(cp, n, r), a = A3(jv, 0, e, u), i = A3(jv, 3, e, u);
        return i ? 1 === i ? "Yesterday" : 2 > i || i > 6 ? A4($v, Ob, 1 > a ? "%d/%m" : "%d/%m/%y", n, t) : A2(ep, "EEEE", e) : A4($v, Ob, "%l:%M %p", n, t);
    }), fp = F3(function(n, r, t) {
        var e = A2(cp, n, t), u = A2(cp, n, r), a = A3(jv, 0, e, u), i = A3(jv, 3, e, u);
        return i ? 1 === i ? "Yesterday" : 2 > i || i > 6 ? A4($v, Ob, 1 > a ? "%d/%m" : "%d/%m/%y", n, t) : A2(ep, "EEEE", e) : "Today";
    }), sp = F3(function(n, r, t) {
        var e, u, a = n.DO, i = ee;
        return e = function() {
            switch(t.$){
                case 0:
                    return 1 === (n = t.a) ? "less than 1 second" : "less than " + i(n) + " seconds";
                case 1:
                    return "half a minute";
                case 2:
                    return 1 === (n = t.a) ? "less than a minute" : "less than " + i(n) + " minutes";
                case 3:
                    return 1 === (n = t.a) ? "1 minute" : i(n) + " minutes";
                case 4:
                    return 1 === (n = t.a) ? "about 1 hour" : "about " + i(n) + " hours";
                case 5:
                    return 1 === (n = t.a) ? "1 day" : i(n) + " days";
                case 6:
                    return 1 === (n = t.a) ? "about 1 month" : "about " + i(n) + " months";
                case 7:
                    return 1 === (n = t.a) ? "1 month" : i(n) + " months";
                case 8:
                    return 1 === (n = t.a) ? "about 1 year" : "about " + i(n) + " years";
                case 9:
                    return 1 === (n = t.a) ? "over 1 year" : "over " + i(n) + " years";
                default:
                    var n;
                    return 1 === (n = t.a) ? "almost 1 year" : "almost " + i(n) + " years";
            }
        }(), (u = b(a, r)).a ? u.b ? "in " + e : e + " ago" : e;
    }), lp = function(n) {
        return {
            $: 4,
            a: n
        };
    }, dp = function(n) {
        return {
            $: 2,
            a: n
        };
    }, bp = function(n) {
        return {
            $: 5,
            a: n
        };
    }, vp = function(n) {
        return {
            $: 3,
            a: n
        };
    }, mp = 43200, pp = S, $p = {
        $: 1
    }, hp = function(n) {
        return {
            $: 0,
            a: n
        };
    }, gp = F3(function(n, r, t) {
        var e = Pv(t - r) / 1e3 | 0, u = pp(e / 60);
        return n && 2 > u ? function(n) {
            return 5 > n ? hp(5) : 10 > n ? hp(10) : 20 > n ? hp(20) : 40 > n ? $p : 60 > n ? dp(1) : vp(1);
        }(e) : u ? 2 > u || 45 > u ? vp(u) : 90 > u ? lp(1) : 0 > s(u, 1440) ? function(n) {
            var r = pp(n / 60);
            return lp(r);
        }(u) : 0 > s(u, 2520) ? bp(1) : 0 > s(u, mp) ? function(n) {
            var r = pp(n / 1440);
            return bp(r);
        }(u) : 0 > s(u, 86400) ? function(n) {
            return {
                $: 6,
                a: pp(n / mp)
            };
        }(u) : function(n) {
            var r = n / mp | 0;
            if (12 > r) return function(n) {
                return {
                    $: 7,
                    a: pp(n / mp)
                };
            }(n);
            var t = Fe(r / 12), e = A2(qc, 12, r);
            return 3 > e ? {
                $: 8,
                a: t
            } : 9 > e ? function(n) {
                return {
                    $: 9,
                    a: n
                };
            }(t) : function(n) {
                return {
                    $: 10,
                    a: n
                };
            }(t + 1);
        }(u) : dp(1);
    }), wp = F4(function(n, r, t, e) {
        var u = t, a = e, i = A3(gp, !0, u, a);
        return A3(r, n, 2 === A2(Wu, a, u) ? 0 : 1, i);
    }), kp = F2(function(n, r) {
        return A4(wp, {
            DO: !0
        }, sp, n, r);
    }), xp = F4(function(n, r, t, e) {
        var u = function() {
            switch(t){
                case 0:
                    return "%m/%d/%Y";
                case 1:
                    return "%B %-d, %Y";
                case 4:
                    return "%l:%M %p";
                case 5:
                    return "%l:%M:%S %p";
                case 6:
                    return A2(kp, e, r);
                case 2:
                    return A3(op, n, r, e);
                default:
                    return A3(fp, n, r, e);
            }
        }();
        return A4($v, Ob, u, n, e);
    }), yp = F2(function(n, r) {
        return A2(xp, n, r);
    }), _p = {
        cg: h,
        e3: 0
    }, Cp = F2(function(n, r) {
        return r.$ ? Rt : Ht(n(r.a));
    }), Dp = Hu(h), Ap = {
        $: 1
    }, qp = Pn, Bp = A2(dc, function() {
        return Ap;
    }, qp(1e4)), jp = Nn, Sp = ru, zp = F2(function(n, r) {
        n: for(;;){
            if (n > 0) {
                if (r.b) {
                    n -= 1, r = r.b;
                    continue n;
                }
                return r;
            }
            return r;
        }
    }), Up = F3(function(n, r, t) {
        var e = n(r);
        return e.$ ? t : A2(Ot, e.a, t);
    }), Ep = F2(function(n, r) {
        return A3(xu, Up(n), h, r);
    }), Pp = F3(function(n, r, t) {
        var e = t.b;
        return b(n(t.a), r(e));
    }), Tp = function(n) {
        var r = A2(Je, zp(1), Gb), t = function(n) {
            return A2(Cp, function(t) {
                return b(t, A2(uc, "", r(n)));
            }, Gb(n));
        }, e = A2(Je, Vu, uc(""));
        return Ml(A2(yu, A2(Pp, e, e), A2(Ep, t, A2(yu, ae("="), A2(ae, "&", n)))));
    }, Fp = function(n) {
        return Tp(A2(uc, "", n));
    }, Lp = function(n) {
        return {
            $: 1,
            a: n
        };
    }, Mp = F2(function(n, r) {
        return r.$ ? Xt(r.a) : n(r.a);
    }), Hp = fn, Rp = {
        $: 2
    }, Op = function(n) {
        return {
            $: 0,
            a: n
        };
    }, Np = function(n) {
        return A2(ue, "", n);
    }, Ip = function(n) {
        switch(A2(qc, 4, au(n))){
            case 0:
                return Qt(n);
            case 2:
                return Qt(Np(k([
                    n,
                    "=="
                ])));
            case 3:
                return Qt(Np(k([
                    n,
                    "="
                ])));
            default:
                return Xt(Op("Wrong length"));
        }
    }, Vp = F2(function(n, r) {
        return r.$ ? Xt(n) : Qt(r.a);
    }), Wp = F2(function(n, r) {
        return r.$ ? Xt(r.a) : Qt(n(r.a));
    }), Zp = F3(function(n, r, t) {
        if (1 === r.$) return Xt(r.a);
        var e = r.a;
        return 1 === t.$ ? Xt(t.a) : Qt(A2(n, e, t.a));
    }), Xp = F2(function(n, r) {
        return r.$ ? Xt(n(r.a)) : Qt(r.a);
    }), Gp = function(n) {
        switch(n.$){
            case 0:
            case 3:
                return 1;
            case 1:
            case 4:
                return 2;
            case 2:
            case 5:
            case 6:
                return 4;
            case 7:
                return 8;
            case 8:
            case 9:
                return n.a;
            default:
                return pt(n.a);
        }
    }, Jp = F3(function(n, r, t) {
        switch(n.$){
            case 0:
                return A3($t, r, t, n.a);
            case 1:
                return A4(ht, r, t, n.b, !n.a);
            case 2:
                return A4(gt, r, t, n.b, !n.a);
            case 3:
                return A3(wt, r, t, n.a);
            case 4:
                return A4(kt, r, t, n.b, !n.a);
            case 5:
                return A4(xt, r, t, n.b, !n.a);
            case 6:
                return A4(yt, r, t, n.b, !n.a);
            case 7:
                return A4(_t, r, t, n.b, !n.a);
            case 8:
                return A3(Yp, n.b, r, t);
            case 9:
                return A3(Dt, r, t, n.b);
            default:
                return A3(Ct, r, t, n.a);
        }
    }), Yp = F3(function(n, r, t) {
        for(;;){
            if (!n.b) return t;
            var e = n.b, u = r, a = A3(Jp, n.a, r, t);
            n = e, r = u, t = a;
        }
    }), Qp = F2(function(n, r) {
        return A2(At, n, r);
    }), Kp = function(n) {
        var r = new DataView(new ArrayBuffer(Gp(n)));
        return Jp(n)(r)(0), r;
    }, n$ = function(n) {
        if (ge(n)) return !0;
        switch(n){
            case "+":
            case "/":
                return !0;
            default:
                return !1;
        }
    }, r$ = F2(function(n, r) {
        return {
            $: 8,
            a: n,
            b: r
        };
    }), t$ = F2(function(n, r) {
        for(;;){
            if (!r.b) return n;
            var t = r.b;
            n += Gp(r.a), r = t;
        }
    }), e$ = function(n) {
        return A2(r$, A2(t$, 0, n), n);
    }, u$ = function(n) {
        var r = ve(n);
        if (r >= 65 && 90 >= r) return r - 65;
        if (r >= 97 && 122 >= r) return r - 97 + 26;
        if (r >= 48 && 57 >= r) return r - 48 + 26 + 26;
        switch(n){
            case "+":
                return 62;
            case "/":
                return 63;
            default:
                return -1;
        }
    }, a$ = F2(function(n, r) {
        return {
            $: 4,
            a: n,
            b: r
        };
    }), i$ = a$, c$ = function(n) {
        return {
            $: 3,
            a: n
        };
    }, o$ = F4(function(n, r, t, e) {
        if (n$(n) && n$(r)) {
            var u = u$(r), a = u$(n);
            if ("=" === e) {
                if ("=" === t) return Ht(c$((c = a << 18 | u << 12) >> 16));
                if (n$(t)) {
                    var i = u$(t);
                    return Ht(A2(i$, 1, (c = a << 18 | u << 12 | i << 6) >> 8));
                }
                return Rt;
            }
            if (n$(t) && n$(e)) {
                var c, o = u$(e), f = c = a << 18 | u << 12 | (i = u$(t)) << 6 | o;
                return Ht(e$(k([
                    A2(i$, 1, c >> 8),
                    c$(f)
                ])));
            }
            return Rt;
        }
        return Rt;
    }), f$ = F2(function(n, r) {
        n: for(;;){
            var t = jm(A2(su, 4, n));
            r: for(;;){
                if (t.b) {
                    if (t.b.b) {
                        if (t.b.b.b) {
                            if (t.b.b.b.b) {
                                if (t.b.b.b.b.b) break r;
                                var e = t.b, u = e.b, a = A4(o$, t.a, e.a, u.a, u.b.a);
                                if (a.$) return Rt;
                                var i = a.a;
                                n = A2(cu, 4, n), r = A2(Ot, i, r);
                                continue n;
                            }
                            var c = t.b, o = A4(o$, t.a, c.a, c.b.a, "=");
                            return 1 === o.$ ? Rt : Ht(A2(Ot, i = o.a, r));
                        }
                        var f = A4(o$, t.a, t.b.a, "=", "=");
                        return 1 === f.$ ? Rt : Ht(A2(Ot, i = f.a, r));
                    }
                    break r;
                }
                return Ht(r);
            }
            return Rt;
        }
    }), s$ = pt, l$ = function(n) {
        var r = A2(Cp, Kp, function(n) {
            return A2(Cp, A2(Je, we, e$), A2(f$, n, h));
        }(n));
        if (1 === r.$) return Rt;
        var t, e = r.a;
        return A2(Qp, (t = s$(e), St(t)), e);
    }, d$ = T, b$ = d$(function(n) {
        switch(n){
            case "-":
                return "+";
            case "_":
                return "/";
            default:
                return n;
        }
    }), v$ = Q, m$ = F2(function(n, r) {
        return A2(Mp, A2(Je, Hp(n), Xp(Lp)), A2(Wp, Ac, function(n) {
            var r = F2(function(n, r) {
                return A2(Xp, n, A2(Wp, function() {
                    return r;
                }, A2(Hp, v$, r)));
            }), t = A2(Je, b$, A2(Je, ae("."), yu(Ip)))(n);
            n: for(;;){
                if (t.b && t.b.b && t.b.b.b && !t.b.b.b.b) {
                    if (t.a.$) {
                        if (1 === t.b.a.$) break n;
                        return Xt(t.a.a);
                    }
                    if (t.b.a.$) break n;
                    var e = t.a.a, u = t.b.a.a, a = A2(Mp, r(function() {
                        return Rp;
                    }), A2(Vp, Rp, l$(e))), i = A2(Mp, r(Lp), A2(Vp, Op("Invalid UTF-16"), l$(u)));
                    return A3(Zp, F2(function(n, r) {
                        return b(n, r);
                    }), a, i);
                }
                return Xt(Op("Token has invalid shape"));
            }
            return Xt(t.b.a.a);
        }(r)));
    }), p$ = at, $$ = F2(function(n, r) {
        var t = Vb(n);
        return 1 !== t.$ && A2(p$, t.a, r);
    }), h$ = function(n) {
        return A2($$, "^[\\w-]*\\.[\\w-]*\\.[\\w-]*$", n);
    }, g$ = function(n) {
        return A2(uu, "full_access", n) ? 0 : 1;
    }, w$ = K, k$ = function(n) {
        return n.$ ? Rt : Ht(n.a);
    }, x$ = function(n) {
        if (n.$) return 1;
        var r = n.a;
        return h$(r) ? A2(uc, 1, A2(Cp, g$, k$(A2(m$, A2(Tu, "scope", w$), r)))) : 1;
    }, y$ = function(n) {
        return !x$(n);
    }, _$ = Y, C$ = G, D$ = function(n) {
        return {
            $: 11,
            g: n
        };
    }, A$ = function(n) {
        var r = D$(k([
            C$,
            A2(Ye, pp, _$)
        ]));
        return A2(Wp, function(n) {
            return 1e3 * n;
        }, A2(m$, A2(Tu, "exp", r), n));
    }, q$ = F2(function(n, r) {
        return A2(Wp, function(r) {
            return s(n, r) > 0;
        }, A$(r));
    }), B$ = F2(function(n, r) {
        return !!n.$ || A2(uc, !0, k$(A2(q$, r, n.a)));
    }), j$ = function(n) {
        return Ht({
            $: 4,
            a: n
        });
    }, S$ = {
        $: 3
    }, z$ = F2(function(n, r) {
        return 1 === n.$ ? r : n;
    }), U$ = function(n) {
        return A2(uc, S$, A2(Xb, j$, A2(z$, A2(Zu, "account_token", n), A2(Zu, "exchange_token", n))));
    }, E$ = function(n) {
        return {
            $: 0,
            a: n
        };
    }, P$ = function(n) {
        return Ht(E$(n));
    }, T$ = F3(function(n, r, t) {
        var e = A2(Xb, P$, r);
        if (e.$) return U$(n);
        var u = e.a;
        return y$(u) && !A2(B$, u, t) ? u : U$(n);
    }), F$ = F2(function(n, r) {
        return m(r, {
            z6: n
        });
    }), L$ = F2(function(n, r) {
        var t = function(n) {
            switch(A2(su, 2, n)){
                case "es":
                    return Ht(1);
                case "en":
                    return Ht(0);
                default:
                    return Rt;
            }
        }(A2(uc, n.z6, A2(Zu, "language", Fp(r.iu)))), e = Fp(r.iu), u = Sp(n.bf), a = A3(T$, e, n.i, u), i = function(n) {
            return b({
                oy: A2(uc, "", n),
                h0: !1
            }, A2(uc, Dp, A2(Cp, rm(Bp), n)));
        }(n.Cf), c = i.a, o = i.b;
        return b({
            fV: cc,
            xD: n.xD,
            xE: Rt,
            cg: _p,
            gx: A4(vc, n.xT + "/api", n.a8, n.bG, a),
            ee: oc,
            bI: h,
            yl: !1,
            ys: {
                ya: A4(pc, n.y0, n.y1, n.bG, a),
                J: A4($c, n.y2, n.y3, n.bG, a),
                e5: A4(hc, n.y4, n.y5, n.bG, a),
                B6: A4(gc, n.y0, n.y1, n.bG, a)
            },
            bJ: !1,
            bf: u,
            g7: !1,
            eD: !1,
            hn: A4($c, n.y2, n.y3, n.bG, a),
            kj: 0,
            zE: n.zE,
            cA: A2(F$, A2(uc, 0, t), Pb("language-select")),
            hL: Rt,
            dr: jb,
            e6: cc,
            tE: oc,
            tL: oc,
            dw: oc,
            uh: oc,
            Cf: c,
            fF: oc,
            CX: oc,
            dU: h,
            dV: Rt,
            jx: A2(yp, to, u),
            fL: to,
            d_: Rt,
            w_: r,
            DE: t,
            an: oc
        }, Hu(k([
            A2(dc, ic, ed),
            A2(jp, fc, o)
        ])));
    }), M$ = function(n) {
        return {
            $: 12,
            a: n
        };
    }, H$ = function(n) {
        return {
            $: 12,
            a: n
        };
    }, R$ = function(n) {
        return {
            $: 77,
            a: n
        };
    }, O$ = function(n) {
        return {
            $: 77,
            a: n
        };
    }, N$ = function(n) {
        return {
            $: 76,
            a: n
        };
    }, I$ = function(n) {
        return {
            $: 76,
            a: n
        };
    }, V$ = function(n) {
        return {
            $: 78,
            a: n
        };
    }, W$ = function(n) {
        return {
            $: 78,
            a: n
        };
    }, Z$ = function(n) {
        return {
            $: 89,
            a: n
        };
    }, X$ = function(n) {
        return {
            $: 89,
            a: n
        };
    }, G$ = function(n) {
        return {
            $: 90,
            a: n
        };
    }, J$ = function(n) {
        return {
            $: 90,
            a: n
        };
    }, Y$ = function(n) {
        return {
            $: 13,
            a: n
        };
    }, Q$ = function(n) {
        return {
            $: 13,
            a: n
        };
    }, K$ = function(n) {
        return {
            $: 14,
            a: n
        };
    }, nh = function(n) {
        return {
            $: 14,
            a: n
        };
    }, rh = function(n) {
        return {
            $: 15,
            a: n
        };
    }, th = function(n) {
        return {
            $: 15,
            a: n
        };
    }, eh = function(n) {
        return {
            $: 16,
            a: n
        };
    }, uh = function(n) {
        return {
            $: 16,
            a: n
        };
    }, ah = function(n) {
        return {
            $: 17,
            a: n
        };
    }, ih = function(n) {
        return {
            $: 17,
            a: n
        };
    }, ch = function(n) {
        return {
            $: 70,
            a: n
        };
    }, oh = function(n) {
        return {
            $: 70,
            a: n
        };
    }, fh = function(n) {
        return {
            $: 18,
            a: n
        };
    }, sh = function(n) {
        return {
            $: 18,
            a: n
        };
    }, lh = function(n) {
        return {
            $: 71,
            a: n
        };
    }, dh = function(n) {
        return {
            $: 71,
            a: n
        };
    }, bh = function(n) {
        return {
            $: 79,
            a: n
        };
    }, vh = function(n) {
        return {
            $: 79,
            a: n
        };
    }, mh = function(n) {
        return {
            $: 19,
            a: n
        };
    }, ph = function(n) {
        return {
            $: 19,
            a: n
        };
    }, $h = function(n) {
        return {
            $: 80,
            a: n
        };
    }, hh = function(n) {
        return {
            $: 80,
            a: n
        };
    }, gh = function(n) {
        return {
            $: 81,
            a: n
        };
    }, wh = function(n) {
        return {
            $: 81,
            a: n
        };
    }, kh = function(n) {
        return {
            $: 72,
            a: n
        };
    }, xh = function(n) {
        return {
            $: 72,
            a: n
        };
    }, yh = function(n) {
        return {
            $: 20,
            a: n
        };
    }, _h = function(n) {
        return {
            $: 20,
            a: n
        };
    }, Ch = function(n) {
        return {
            $: 82,
            a: n
        };
    }, Dh = function(n) {
        return {
            $: 82,
            a: n
        };
    }, Ah = function(n) {
        return {
            $: 73,
            a: n
        };
    }, qh = function(n) {
        return {
            $: 73,
            a: n
        };
    }, Bh = function(n) {
        return {
            $: 83,
            a: n
        };
    }, jh = function(n) {
        return {
            $: 83,
            a: n
        };
    }, Sh = function(n) {
        return {
            $: 21,
            a: n
        };
    }, zh = function(n) {
        return {
            $: 21,
            a: n
        };
    }, Uh = function(n) {
        return {
            $: 59,
            a: n
        };
    }, Eh = function(n) {
        return {
            $: 59,
            a: n
        };
    }, Ph = function(n) {
        return {
            $: 22,
            a: n
        };
    }, Th = function(n) {
        return {
            $: 22,
            a: n
        };
    }, Fh = function(n) {
        return {
            $: 23,
            a: n
        };
    }, Lh = function(n) {
        return {
            $: 23,
            a: n
        };
    }, Mh = function(n) {
        return {
            $: 84,
            a: n
        };
    }, Hh = function(n) {
        return {
            $: 84,
            a: n
        };
    }, Rh = function(n) {
        return {
            $: 74,
            a: n
        };
    }, Oh = function(n) {
        return {
            $: 74,
            a: n
        };
    }, Nh = function(n) {
        return {
            $: 85,
            a: n
        };
    }, Ih = function(n) {
        return {
            $: 85,
            a: n
        };
    }, Vh = function(n) {
        return {
            $: 75,
            a: n
        };
    }, Wh = function(n) {
        return {
            $: 75,
            a: n
        };
    }, Zh = function(n) {
        return {
            $: 24,
            a: n
        };
    }, Xh = function(n) {
        return {
            $: 24,
            a: n
        };
    }, Gh = function(n) {
        return {
            $: 86,
            a: n
        };
    }, Jh = function(n) {
        return {
            $: 86,
            a: n
        };
    }, Yh = function(n) {
        return {
            $: 25,
            a: n
        };
    }, Qh = function(n) {
        return {
            $: 25,
            a: n
        };
    }, Kh = function(n) {
        return {
            $: 26,
            a: n
        };
    }, ng = function(n) {
        return {
            $: 26,
            a: n
        };
    }, rg = function(n) {
        return {
            $: 55,
            a: n
        };
    }, tg = function(n) {
        return {
            $: 55,
            a: n
        };
    }, eg = function(n) {
        return {
            $: 6,
            a: n
        };
    }, ug = function(n) {
        return {
            $: 6,
            a: n
        };
    }, ag = function(n) {
        return {
            $: 60,
            a: n
        };
    }, ig = function(n) {
        return {
            $: 60,
            a: n
        };
    }, cg = function(n) {
        return {
            $: 56,
            a: n
        };
    }, og = function(n) {
        return {
            $: 56,
            a: n
        };
    }, fg = function(n) {
        return {
            $: 87,
            a: n
        };
    }, sg = function(n) {
        return {
            $: 87,
            a: n
        };
    }, lg = function(n) {
        return {
            $: 88,
            a: n
        };
    }, dg = function(n) {
        return {
            $: 88,
            a: n
        };
    }, bg = function(n) {
        return {
            $: 27,
            a: n
        };
    }, vg = function(n) {
        return {
            $: 27,
            a: n
        };
    }, mg = function(n) {
        return {
            $: 7,
            a: n
        };
    }, pg = function(n) {
        return {
            $: 7,
            a: n
        };
    }, $g = function(n) {
        return {
            $: 57,
            a: n
        };
    }, hg = function(n) {
        return {
            $: 57,
            a: n
        };
    }, gg = function(n) {
        return {
            $: 8,
            a: n
        };
    }, wg = function(n) {
        return {
            $: 8,
            a: n
        };
    }, kg = function(n) {
        return {
            $: 1,
            a: n
        };
    }, xg = function(n) {
        return {
            $: 1,
            a: n
        };
    }, yg = function(n) {
        return {
            $: 9,
            a: n
        };
    }, _g = function(n) {
        return {
            $: 9,
            a: n
        };
    }, Cg = function(n) {
        return {
            $: 28,
            a: n
        };
    }, Dg = function(n) {
        return {
            $: 28,
            a: n
        };
    }, Ag = function(n) {
        return {
            $: 29,
            a: n
        };
    }, qg = function(n) {
        return {
            $: 29,
            a: n
        };
    }, Bg = function(n) {
        return {
            $: 30,
            a: n
        };
    }, jg = function(n) {
        return {
            $: 30,
            a: n
        };
    }, Sg = function(n) {
        return {
            $: 2,
            a: n
        };
    }, zg = function(n) {
        return {
            $: 2,
            a: n
        };
    }, Ug = function(n) {
        return {
            $: 3,
            a: n
        };
    }, Eg = function(n) {
        return {
            $: 3,
            a: n
        };
    }, Pg = function(n) {
        return {
            $: 61,
            a: n
        };
    }, Tg = function(n) {
        return {
            $: 61,
            a: n
        };
    }, Fg = function(n) {
        return {
            $: 62,
            a: n
        };
    }, Lg = function(n) {
        return {
            $: 62,
            a: n
        };
    }, Mg = function(n) {
        return {
            $: 63,
            a: n
        };
    }, Hg = function(n) {
        return {
            $: 63,
            a: n
        };
    }, Rg = function(n) {
        return {
            $: 64,
            a: n
        };
    }, Og = function(n) {
        return {
            $: 64,
            a: n
        };
    }, Ng = function(n) {
        return {
            $: 65,
            a: n
        };
    }, Ig = function(n) {
        return {
            $: 65,
            a: n
        };
    }, Vg = function(n) {
        return {
            $: 66,
            a: n
        };
    }, Wg = function(n) {
        return {
            $: 66,
            a: n
        };
    }, Zg = function(n) {
        return {
            $: 67,
            a: n
        };
    }, Xg = function(n) {
        return {
            $: 67,
            a: n
        };
    }, Gg = function(n) {
        return {
            $: 68,
            a: n
        };
    }, Jg = function(n) {
        return {
            $: 68,
            a: n
        };
    }, Yg = function(n) {
        return {
            $: 69,
            a: n
        };
    }, Qg = function(n) {
        return {
            $: 69,
            a: n
        };
    }, Kg = function(n) {
        return {
            $: 58,
            a: n
        };
    }, nw = function(n) {
        return {
            $: 58,
            a: n
        };
    }, rw = function(n) {
        return {
            $: 10,
            a: n
        };
    }, tw = function(n) {
        return {
            $: 10,
            a: n
        };
    }, ew = function(n) {
        return {
            $: 31,
            a: n
        };
    }, uw = function(n) {
        return {
            $: 31,
            a: n
        };
    }, aw = function(n) {
        return {
            $: 32,
            a: n
        };
    }, iw = function(n) {
        return {
            $: 32,
            a: n
        };
    }, cw = function(n) {
        return {
            $: 33,
            a: n
        };
    }, ow = function(n) {
        return {
            $: 33,
            a: n
        };
    }, fw = function(n) {
        return {
            $: 34,
            a: n
        };
    }, sw = function(n) {
        return {
            $: 34,
            a: n
        };
    }, lw = function(n) {
        return {
            $: 35,
            a: n
        };
    }, dw = function(n) {
        return {
            $: 35,
            a: n
        };
    }, bw = function(n) {
        return {
            $: 36,
            a: n
        };
    }, vw = function(n) {
        return {
            $: 36,
            a: n
        };
    }, mw = function(n) {
        return {
            $: 37,
            a: n
        };
    }, pw = function(n) {
        return {
            $: 37,
            a: n
        };
    }, $w = function(n) {
        return {
            $: 38,
            a: n
        };
    }, hw = function(n) {
        return {
            $: 38,
            a: n
        };
    }, gw = function(n) {
        return {
            $: 39,
            a: n
        };
    }, ww = function(n) {
        return {
            $: 39,
            a: n
        };
    }, kw = function(n) {
        return {
            $: 40,
            a: n
        };
    }, xw = function(n) {
        return {
            $: 40,
            a: n
        };
    }, yw = function(n) {
        return {
            $: 41,
            a: n
        };
    }, _w = function(n) {
        return {
            $: 41,
            a: n
        };
    }, Cw = function(n) {
        return {
            $: 42,
            a: n
        };
    }, Dw = function(n) {
        return {
            $: 42,
            a: n
        };
    }, Aw = function(n) {
        return {
            $: 43,
            a: n
        };
    }, qw = function(n) {
        return {
            $: 43,
            a: n
        };
    }, Bw = function(n) {
        return {
            $: 44,
            a: n
        };
    }, jw = function(n) {
        return {
            $: 44,
            a: n
        };
    }, Sw = function(n) {
        return {
            $: 45,
            a: n
        };
    }, zw = function(n) {
        return {
            $: 45,
            a: n
        };
    }, Uw = function(n) {
        return {
            $: 46,
            a: n
        };
    }, Ew = function(n) {
        return {
            $: 46,
            a: n
        };
    }, Pw = function(n) {
        return {
            $: 47,
            a: n
        };
    }, Tw = function(n) {
        return {
            $: 47,
            a: n
        };
    }, Fw = function(n) {
        return {
            $: 48,
            a: n
        };
    }, Lw = function(n) {
        return {
            $: 48,
            a: n
        };
    }, Mw = function(n) {
        return {
            $: 49,
            a: n
        };
    }, Hw = function(n) {
        return {
            $: 49,
            a: n
        };
    }, Rw = function(n) {
        return {
            $: 50,
            a: n
        };
    }, Ow = function(n) {
        return {
            $: 50,
            a: n
        };
    }, Nw = function(n) {
        return {
            $: 51,
            a: n
        };
    }, Iw = function(n) {
        return {
            $: 51,
            a: n
        };
    }, Vw = function(n) {
        return {
            $: 52,
            a: n
        };
    }, Ww = function(n) {
        return {
            $: 52,
            a: n
        };
    }, Zw = function(n) {
        return {
            $: 53,
            a: n
        };
    }, Xw = function(n) {
        return {
            $: 53,
            a: n
        };
    }, Gw = function(n) {
        return {
            $: 11,
            a: n
        };
    }, Jw = function(n) {
        return {
            $: 11,
            a: n
        };
    }, Yw = function(n) {
        return {
            $: 54,
            a: n
        };
    }, Qw = function(n) {
        return {
            $: 54,
            a: n
        };
    }, Kw = function(n) {
        return {
            $: 4,
            a: n
        };
    }, nk = function(n) {
        return {
            $: 4,
            a: n
        };
    }, rk = function(n) {
        return {
            $: 0,
            a: n
        };
    }, tk = function(n) {
        return {
            $: 0,
            a: n
        };
    }, ek = function(n) {
        return {
            $: 5,
            a: n
        };
    }, uk = function(n) {
        return {
            $: 5,
            a: n
        };
    }, ak = function(n) {
        return {
            $: 0,
            a: n
        };
    }, ik = {
        $: 2
    }, ck = function(n) {
        return {
            $: 1,
            a: n
        };
    }, ok = function(n) {
        return 4 === n.$;
    }, fk = function(n) {
        return ok(n.a.i);
    }, sk = F2(function(n, r) {
        return v(r.a, r.b, n);
    }), lk = function(n) {
        return n.b.pt;
    }, dk = F3(function(n, r, t) {
        return t.$ ? n : r(t.a);
    }), bk = null, vk = function(n) {
        return A3(ce, F2(function(n, r) {
            return A3(wn, n.a, n.b, r);
        }), {}, n);
    }, mk = gn, pk = Jn("fullStoryPortInit", function(n) {
        return vk(k([
            b("email", function(n) {
                return A3(dk, bk, mk, n);
            }(n.pt)),
            b("id", mk(n.qU)),
            b("name", mk(n.sS))
        ]));
    }), $k = function(n) {
        return function(n) {
            return n.qU;
        }(n.a);
    }, hk = function(n) {
        return function(n) {
            return n.sS;
        }(n.a);
    }, gk = function(n) {
        return function(n) {
            return pk({
                pt: lk(n),
                qU: $k(n),
                sS: hk(n)
            });
        }(n);
    }, wk = F2(function(n, r) {
        var t = r.b;
        return b(n(r.a), t);
    }), kk = F2(function(n, r) {
        var t = r.b, e = r.c;
        return v(n(r.a), t, e);
    }), xk = On, yk = xk(h), _k = ru, Ck = "Date", Dk = "doctor", Ak = "Select", qk = "Location", Bk = "Your membership has been renewed", jk = "Provider", Sk = "Start date", zk = _k({
        lE: F2(function(n, r) {
            return "Using a credit card will cost " + n + " an additional " + r + " in processing fees for your membership. Please consider using a bank account instead.";
        }),
        lF: function(n) {
            return "Using a credit card will cost " + n + " additional processing fees. Please consider using a bank account instead.";
        },
        lT: function(n) {
            return "Added " + n;
        },
        lY: "Additional Details",
        lZ: "Additional details for primary member",
        l_: {
            wD: "Additional Services"
        },
        D: {
            lR: "Add to Cart",
            lU: "has been added to your cart!",
            l9: "All",
            mP: "Billing",
            yi: "Change Member",
            nR: "Configure Membership Details",
            nS: "Configure Package Details",
            nV: "Contact practice for pricing",
            hf: "Enroll",
            Ar: "Member",
            Au: "Yourself",
            $7: "Membership Start Date",
            _: "Memberships",
            ia: "Packages",
            B8: "Purchase",
            xa: "View Cart",
            DS: "No additional services are available right now"
        },
        jN: {
            pt: "Email me details",
            hf: "Enroll now"
        },
        l0: {
            mF: "Billing Address",
            mO: "Billing address is the same",
            nr: "City",
            yz: "Country",
            rE: "Address Line 1",
            z9: "Street address, P. O. box, company name, c/o",
            rF: "Address Line 2",
            Aa: "Apartment, suite, unit, building, floor, etc.",
            rT: "Mailing Address",
            rU: "Mailing address is the same",
            sS: "Address",
            Cp: "Use primary member's address",
            wi: "State (abbv.)",
            C5: "Please use a 2 letter abbreviation.",
            C6: "[See USPS Abreviations] (https://pe.usps.com/text/pub28/28apb.htm)",
            xy: "ZIP code",
            xz: "We do not have coverage in your area",
            DT: "Please enter a valid US zip code."
        },
        l8: F2(function(n, r) {
            return "Minimum age for range for this plan is from " + n + " to " + r + " years old.";
        }),
        mg: "Amount",
        xR: F2(function(n, r) {
            return n + " and " + r;
        }),
        gA: {
            wD: "Appointments"
        },
        ms: "At least one dependent must be added to the plan.",
        mt: "At least one member must be added to the plan.",
        mw: function(n) {
            return "authored by " + n;
        },
        mB: "Bank Account",
        mQ: {
            mk: "Annually",
            sR: "Monthly",
            uQ: "Quarterly",
            vF: "Semi-Annually"
        },
        gK: {
            m$: "Broker",
            rr: "Who is your broker?",
            BU: "Select"
        },
        m0: "Cancel",
        N: {
            mD: "before appointment",
            N: "Cancel Appointment",
            m1: "Cancellation Contact",
            m3: "Cancellation Policy",
            n$: "Contact us at",
            qQ: "hours",
            qV: 'If you wish to reschedule your appointment, simply click the "Reschedule" button to book a new time.',
            sM: "Minimum Cancellation Notice",
            vl: "Reschedule",
            vm: "Reschedule Appointment",
            wF: "to cancel your appointment.",
            wG: "To cancel your appointment, contact us at",
            xr: "Your appointment has been cancelled"
        },
        ba: {
            x9: "End Membership",
            yb: "Cancellation Reason",
            Ax: "Ending Membership for:",
            Ch: "Remove Member",
            Ci: "Member has been removed from the membership",
            Ck: "Please enter a cancellation reason.",
            Cs: "We're sorry to see you go!",
            De: "Membership has been cancelled"
        },
        gL: "Card",
        jY: {
            n5: "Continue to Payment",
            wD: "Your Cart"
        },
        j_: {
            CR: "Show less",
            CT: "Show more"
        },
        yn: {
            wD: "Checkout"
        },
        nl: function(n) {
            return "This plan does not allow children over the age of " + n + " to enroll.";
        },
        cl: {
            qb: "Chosen First Name",
            zY: "Chosen name is different?",
            rt: "Chosen Last Name",
            sE: "Chosen Middle Name",
            wt: "Chosen Suffix",
            wD: "Chosen Title"
        },
        nt: "Close menu",
        nw: {
            q2: "Code format is invalid."
        },
        nT: "Confirm",
        yu: {
            lM: "Add Later",
            nc: "Change Your Payment Method",
            or: "Credit or Debit card",
            os: "Credit/debit card or bank",
            vJ: "Setup options"
        },
        nX: "Please contact the practice if you have any questions",
        nY: function(n) {
            return "Please contact the practice at " + n + " if you have any questions.";
        },
        nZ: function(n) {
            return "Please contact the practice at " + n + " if you have any questions.";
        },
        n_: F2(function(n, r) {
            return "Please contact the practice at " + n + " or " + r + " if you have any questions.";
        }),
        n2: "Continue to next step",
        n3: function(n) {
            return "Continue to " + n + " page";
        },
        n4: "Continue",
        oc: function(n) {
            return "Contract renews On #" + n;
        },
        oe: function(n) {
            return "Contract Terminates On " + n;
        },
        j3: {
            gA: "Appointments",
            xi: "Welcome back,"
        },
        oD: Ck,
        bg: Ck + " of Birth",
        oW: function(n) {
            return "Ending this membership will stop recurring charges for the selected patient(s), and remove access to membership benefits effective " + n + ".";
        },
        ha: {
            qB: "Have a discount code?",
            zU: "This is not a valid discount code.",
            rr: "Discount code"
        },
        ew: {
            xS: "Any distance",
            rr: "Distance",
            AH: "No Filter",
            BU: "Filter by distance"
        },
        o3: "Date of birth cannot be in the future.",
        o4: Dk,
        o5: Ak + " " + Dk,
        o7: function(n) {
            return n + " accepted!";
        },
        R: {
            xB: "Accept",
            yN: "No Thanks",
            j8: "Type your first name and last name",
            yP: "Member e-signature",
            zV: "Please type either name exactly as it appears above.",
            zW: "Please type your name exactly as it appears above.",
            At: "Member Name",
            kA: "Name",
            AE: "New Member name",
            B1: "Primary Member Name",
            B2: "Type the first and last name of either member",
            B3: "New or Primary Member e-signature",
            Cn: "Please sign this document.",
            vY: "E-signature",
            wY: "Signature does not match signee name."
        },
        o9: {
            y_: "Due",
            BC: "Paid",
            DJ: "Void"
        },
        ac: {
            wD: "Agreements"
        },
        pc: "Download",
        bk: {
            xM: "All Time",
            yD: "Current Year",
            yF: "Custom",
            pC: "End Date",
            zM: "In Progress",
            zN: "Your file is being processed and may take a few seconds.",
            z7: "Last Year",
            C3: "Start Date"
        },
        pe: "DPC Practice",
        cr: {
            rr: "DPC Practice",
            Ac: "Loading DPC practices...",
            Bw: "DPC Practice's name",
            Bx: "Your DPC Practice's name",
            BU: "Start typing to find your DPC Practice",
            DS: "No DPC practices found"
        },
        ph: function(n) {
            return "Due on " + n;
        },
        pl: "Membership patients can't be duplicated in the same membership.",
        pp: "Edit",
        pt: "Email",
        aG: {
            pt: "Email",
            qb: "First Name",
            rt: "Last Name",
            sS: "Full Name",
            t0: "Phone",
            u5: "Relationship",
            Cl: "Please enter phone or email.",
            Cm: "Please enter at least first name, last name or relationship.",
            CZ: "Use primary member as emergency contact",
            wD: "Emergency Contact"
        },
        aX: {
            yo: "Child",
            zw: "Grandparent",
            zz: "Guardian",
            AH: "None",
            Bw: "Other",
            BE: "Parent",
            fw: "Select a relationship",
            CW: "Sibling",
            C2: "Spouse"
        },
        pH: "English",
        eB: {
            mN: "Billing Frequency",
            B0: "Primary",
            wD: "Enrolled Members",
            DS: "No patients to show"
        },
        pL: function(n) {
            return "ended on " + n;
        },
        pM: function(n) {
            return "ending on " + n;
        },
        pN: function(n) {
            return "Enrolled on " + n;
        },
        pO: {
            o1: "Do not enroll me",
            pJ: "Enroll me",
            sS: "Enrollment Status",
            AO: "Paying for someone else and don\u2019t want to be enrolled as a patient? Select \u201CDo not enroll me\u201D."
        },
        pS: F2(function(n, r) {
            return n + ": " + r;
        }),
        pT: F3(function(n, r, t) {
            return n + " " + r + ": " + t;
        }),
        pZ: F2(function(n, r) {
            return "Expires " + n + "/" + r;
        }),
        qf: "for",
        eE: {
            ns: "click here",
            qJ: "You do not have authorization to view this page. Please use the link in your email, or",
            qK: "to go to your patient portal homepage.",
            wD: "Authorization Required"
        },
        de: {
            yJ: "Date Sent",
            oF: "Date Submitted",
            AJ: "# of Questions",
            CG: "Sent to",
            wj: "Status"
        },
        qh: {
            qX: "Please complete the form questions."
        },
        qv: {
            zm: "Female",
            rr: "Gender",
            Aj: "Male",
            Bw: "Other"
        },
        qw: {
            rr: "Gender Identity",
            Ak: "Man",
            AG: "Non-binary",
            AI: "Not Listed",
            BU: "Select",
            Dx: "Trans Man",
            Dy: "Trans Woman",
            DP: "Woman"
        },
        hv: {
            pz: "No data has been shared by the practice.",
            pR: "There was an error loading your health information",
            wD: "Health"
        },
        qG: "Healthcare Insurance",
        aw: {
            m8: "Insurance carrier",
            yd: "Start typing to find your carrier",
            na: "Carrier's name",
            ye: "Pick an item",
            Y: "Existing coverage",
            za: "Do you have either insurance or an insurance alternative?",
            qA: "Group ID",
            qO: "High deductible",
            zD: "Are you on a high-deductible plan?",
            r5: "Member ID",
            Cw: "Search to filter..."
        },
        q1: function(n) {
            return "Please enter a valid " + n + ".";
        },
        q4: function(n) {
            return "A valid " + n + " phone is required.";
        },
        q7: function(n) {
            return "Invoice " + n;
        },
        q8: function(n) {
            return "Due Date: " + n;
        },
        eK: {
            tQ: "Payment",
            v3: "Payment Source",
            jq: "Pay Invoice",
            wD: "Pay Invoice"
        },
        g: {
            xI: "additional fees",
            mh: "Amount Due",
            nh: "Charges",
            om: "Credit",
            on: "Credit Card Fee",
            oo: "To avoid transaction fees, consider using a bank account (ACH) or debit.",
            yB: "Using a credit card will incur transaction fees.",
            op: "Credit Card Fees",
            oq: "Credit Card Fees Paid",
            y_: "Due",
            pi: "due to the",
            pj: "due to your membership",
            pk: "due to your package",
            rb: "Invoice Total",
            dm: "There was an error loading your invoices",
            s9: "Invoice Number",
            BC: "Paid",
            tN: "Pay Invoice",
            tY: "Payment Total",
            tZ: "Payments",
            ua: "+ tax",
            wq: "Subtotal",
            Df: "Tax",
            wD: "Invoices",
            Du: "Total",
            wO: "Total Due",
            wR: "Transferred to Credit",
            xq: "You saved",
            DS: "No invoices to show"
        },
        rl: "Item",
        hN: {
            rr: "How did you hear about us?",
            ry: "Lead source",
            BU: "Select"
        },
        rA: "Learn more",
        ku: qk,
        bW: {
            xS: "Any location",
            oV: "Select location where you'd like to meet your provider.",
            zU: "Location is invalid, please select a different option.",
            rr: "Location",
            BU: "Filter by location",
            vd: "Location is required.",
            fw: "Select"
        },
        rL: function(n) {
            return "+ " + n + " other";
        },
        hR: {
            gW: "code",
            qg: "Sign into your patient portal",
            rS: "magic-link"
        },
        rM: function(n) {
            return "We don't like passwords any more than you do. Enter your email and we will send you a " + n + " to log in instantly.";
        },
        rN: "Enter your email to get a login code",
        rO: function(n) {
            return "Send " + n;
        },
        rY: function(n) {
            return "Maximum age for this plan is " + n + " years old.";
        },
        r3: function(n) {
            return "Age " + n;
        },
        r4: "Dependent",
        r7: "Primary",
        Av: {
            lI: "Add members",
            lJ: "Add another member",
            lK: "Demographics",
            lL: "Add Emergency Contact",
            lN: "Add Member",
            lO: "+ Add New Member",
            lP: "Member created successfully!",
            lX: "Are you adding members?",
            yR: "Please contact the practice to change these patient details.",
            pq: "Edit Emergency Contact",
            py: "Emergency Contact",
            qC: "Health Insurance",
            qD: "Insurance",
            qE: "Group ID",
            qF: "Member ID",
            qY: "Member Information",
            qZ: "Edit Member Information",
            dm: "There was an error loading members",
            rW: "Manage Member",
            Al: "Manage Members",
            s2: "No dependents are allowed on this membership",
            wD: "Members",
            DS: "No members to show"
        },
        r8: function(n) {
            return "This membership allows " + n + " dependents";
        },
        sa: function(n) {
            return "Your membership is ending on " + n;
        },
        e$: {
            g8: "Default",
            rr: "Payment Method",
            jD: "Payment method updated successfully",
            wZ: "Any upcoming payments for this membership will be charged to the new payment method."
        },
        sc: Bk,
        sd: function(n) {
            return Bk + " till " + n;
        },
        $7: {
            rr: "Membership start date"
        },
        _: {
            oa: "Contract Period",
            ou: "Current Memberships",
            oz: "Current",
            pE: "Ended Memberships",
            pF: "Ended",
            ij: "Pending Memberships",
            u9: "Renew Membership",
            iI: "View Membership Details",
            wD: "Memberships",
            Dq: "Memberships & Packages",
            DS: "No Memberships to Show",
            xw: "No Items To Display"
        },
        J: {
            xG: "Add Recipients",
            ni: "Chat for conversation",
            nj: "This is where the chat messages would appear.",
            yp: "Click to load providers",
            p_: "Failed to load conversations",
            zj: "Failed to load file",
            zk: "Failed to load image",
            p$: "Failed to load messages.",
            zl: "Failed to load providers.",
            sZ: "No conversation selected",
            s_: "See conversations on the left, or start a new message.",
            s$: "No conversations",
            s0: "No messages yet",
            s1: "See conversations on the left or start a new message.",
            wD: "Chat",
            wV: "Type a message..."
        },
        sf: "Pause",
        sg: "Play",
        sh: function(n) {
            return "Preview " + n;
        },
        si: "Tap to expand",
        sj: "Cannot preview this file",
        sk: "Loading CSV",
        sl: function(n) {
            return "CSV preview: " + n;
        },
        sm: "Loading document",
        sn: "Loading Word document",
        so: function(n) {
            return "Document preview: " + n;
        },
        sp: "Loading PDF",
        sq: "Loading PDF preview",
        sr: function(n) {
            return "Column " + n;
        },
        ss: "Loading spreadsheet",
        st: "No rows to display.",
        su: "To view this file, please download it and open it with the appropriate application on your device.",
        sv: "This workbook has no sheets to display.",
        sw: "Loading Excel workbook",
        sx: F2(function(n, r) {
            return "Excel preview: " + n + " \u2014 " + r;
        }),
        sy: function(n) {
            return "Excel preview: " + n;
        },
        sz: "Loading XML",
        sA: "Loading XML",
        sB: function(n) {
            return "XML preview: " + n;
        },
        sC: function(n) {
            return n + " joined conversation";
        },
        sD: function(n) {
            return n + " was removed from conversation";
        },
        sF: function(n) {
            return n + " miles away";
        },
        sH: function(n) {
            return "Minimum age for this plan is " + n + " years old.";
        },
        cE: {
            qb: "First Name",
            rt: "Last Name",
            sE: "Middle Name",
            wt: "Suffix",
            wD: "Title",
            Dp: "Select"
        },
        sT: "Logout",
        sU: "Next Bill",
        sW: "Next Step",
        sX: "No",
        sY: function(n) {
            return "At least one patient on the membership must be " + n + " years old.";
        },
        s5: {
            aF: "Document",
            po: "Prescription",
            p1: "Fax",
            kk: "form",
            qW: "Prescription",
            rq: "Lab Results",
            s3: "Note",
            xd: "Vitals"
        },
        td: function(n) {
            return "of " + n + " due";
        },
        tf: function(n) {
            return "on " + n;
        },
        tl: "Open menu",
        Bw: "Other",
        aA: {
            nQ: "Complete Purchase",
            hc: "Done",
            hd: "Due Today",
            Ar: "Member",
            h1: "No payment methods available",
            du: "Payment Method",
            uv: "Pricing Breakdown",
            uM: "Purchase completed successfully",
            js: "You're all set! The package is available immediately.",
            dT: "Purchase Successful!",
            wD: "Review & Pay"
        },
        ts: function(n) {
            return "Expires on " + n;
        },
        tt: function(n) {
            return n + " utilized";
        },
        ia: {
            iI: "View Package Details"
        },
        tE: "Patient",
        du: "Payment method",
        cG: {
            xQ: "American Express is not accepted.",
            qu: "Future expiration date",
            q3: "Please enter a valid payment method holder name.",
            rr: "Payment Source",
            Cn: "Please add a payment method.",
            Ct: "Save Payment Method"
        },
        tS: function(n) {
            return n + " is not configured to accept payments.";
        },
        bt: {
            x5: "Blocked",
            yv: "Confirmed",
            zd: "Expiring",
            zi: "Failed",
            zU: "Invalid",
            AD: "New",
            uA: "Processing",
            DK: "Warning"
        },
        tU: function(n) {
            return n + " is now the default source";
        },
        tV: function(n) {
            return n + " was successfully removed.";
        },
        BP: {
            lI: "+ Add Payment Method",
            lQ: "Add a Payment Method",
            gL: "Card",
            ok: "Your payment source was successfully created",
            pb: "Don't Save Payment Source",
            pr: "Edit Payment Source",
            hj: "Expiration Month",
            hk: "Expiration Year",
            re: "Selected as Default",
            dm: "There Was an Error Loading Your Sources",
            rV: "Make Default",
            tO: "Use This Payment Source to Pay Past Due Invoices",
            Ct: "Save Payment Method",
            wD: "Payment Sources",
            wM: "Link Already Used",
            jD: "Your payment information has successfully been updated",
            DS: "No Sources to Show",
            xy: "Zip",
            xA: "Zip Code"
        },
        tX: "Payment terms",
        tZ: {
            tR: "Payment failed!",
            tW: "Payment successful!"
        },
        fb: {
            AO: "On behalf of the new member:",
            te: "Terms and Conditions:",
            AP: "On behalf of each member in this membership:",
            ij: "Not Accepted"
        },
        fc: {
            mk: "/year",
            sR: "/month",
            uQ: "/quarter",
            vF: "/6 months"
        },
        t0: "Phone",
        cH: {
            lI: "Add another phone number",
            zF: "Home",
            rr: "Phone Number",
            AB: "Mobile",
            AK: "Office",
            Cg: "Remove phone"
        },
        t6: "Plan",
        G: {
            mj: "Annual",
            mR: "Billing Schedule",
            nP: "Complete Enrollment",
            hc: "Done",
            hd: "Due Today",
            pP: "Enrollment completed successfully",
            Ar: "Member",
            $7: "Membership Start Date",
            sR: "Monthly",
            h1: "No payment methods available",
            tj: "One time registration fee",
            du: "Payment Method",
            Cb: "Recurring",
            wh: "Starts Today",
            js: "You'll receive a confirmation email shortly with all the details.",
            dT: "You are Enrolled!",
            wD: "Review & Pay"
        },
        t9: "Please",
        ui: function(n) {
            return "Practice does not accept members under age " + n;
        },
        uo: "Preferred Language",
        aa: {
            yH: "Date Filled",
            j4: "Date Prescribed",
            j6: "# days of treatment",
            kk: "Form",
            qp: "Frequency",
            kq: "Instructions",
            Aq: "Medication",
            k$: "Prescriber",
            k0: "Price",
            uN: "Qty",
            Ce: "Refills",
            la: "Route of Administration",
            lm: "Strength",
            ls: "Use by Date"
        },
        uC: {
            zA: "He/Him/His",
            rr: "Pronouns",
            AI: "Not Listed",
            BU: "Select",
            CK: "She/Her/Hers",
            Dl: "They/Them/Theirs"
        },
        uE: jk,
        uF: Ak + " " + jk + " and " + qk,
        uG: jk + " is invalid, please select a different option.",
        k2: {
            vD: "Practitioner and location selected!",
            wD: "Select Provider & Location"
        },
        uI: jk + " is required.",
        uJ: {
            Cv: "Search by name"
        },
        uK: Ak + " " + jk,
        uL: "Provider selected!",
        B8: function(n) {
            return "Purchase " + n;
        },
        uO: "Qty",
        fl: {
            kc: "Due Now",
            qa: "First Bill",
            Bv: "One time registration fee",
            Cb: "Recurring",
            Cc: "Recurring Bills",
            Cy: "Second Bill",
            Dv: "Total Bill"
        },
        k4: {
            rr: "Rate & Schedule",
            BU: "Select"
        },
        fn: {
            xR: "and",
            z8: "This site is protected by reCAPTCHA and the Google",
            B4: "Privacy Policy",
            Dh: "Terms of service"
        },
        uX: ".",
        u5: {
            xL: "Adult",
            yo: "Child",
            rr: "Member Type",
            tq: "Owner"
        },
        Cg: "Remove",
        u8: "Removing",
        ve: "Please describe.",
        vf: function(n) {
            return "Please enter " + n + ".";
        },
        vg: function(n) {
            return "Please select " + n + ".";
        },
        vv: {
            yE: "Currently viewing sandbox data."
        },
        Ct: "Save",
        vA: function(n) {
            return "By submitting your account information, you authorize " + n + " to electronically debit and credit your account on a recurring basis as set forth in your membership agreement or as displayed to you during the signup process. You understand you can contact " + n + " to revoke this authorization at any time.";
        },
        vB: function(n) {
            return "By submitting your account information, you authorize " + n + " to electronically debit and credit your account for this service as displayed to you.";
        },
        dH: {
            yt: "security and compliance",
            zv: "frameworks",
            By: "Our",
            BV: "platform",
            Dg: "uses state-of-the-art data encryption technology and is regularly audited against comprehensive"
        },
        fw: Ak,
        lf: {
            oV: "Your session expired, please sign in again.",
            wD: "Session Expired"
        },
        vK: {
            zm: "Female",
            zT: "Intersex",
            rr: "Sex",
            Aj: "Male",
            BU: "Select"
        },
        vR: "Login",
        vS: function(n) {
            return "By clicking " + n + ", I hereby acknowledge that I meet the age";
        },
        vT: "requirements",
        vU: "allowing this platform to collect the information I have provided.",
        vV: "Sign Out",
        vW: function(n) {
            return "Don't have a membership with " + n + " ?";
        },
        vX: "Sign up today",
        v0: F2(function(n, r) {
            return "Sign up with " + n + " through " + r;
        }),
        v1: function(n) {
            return "Sign up with " + n;
        },
        v7: "Spanish",
        wb: "SSN",
        C3: Sk,
        we: function(n) {
            return Sk + " cannot be prior to " + n + ".";
        },
        a7: {
            xH: "Additional Details",
            yu: "Confirmation",
            yw: "Contact",
            yG: "Custom Details",
            ku: "Location",
            Av: "Members",
            Aw: "Demographics",
            Ay: "Membership",
            uE: "Provider"
        },
        wl: "Please enter a valid payment method or account holder name.",
        wm: function(n) {
            return n;
        },
        cU: {
            yn: "You will receive a purchase confirmation if you authorized us to send you emails. If you have any further questions, please reach out to us directly.",
            pw: "Failed to send email!",
            px: "Email sent!",
            B8: "Thank you for your purchase!",
            wD: "Thank You",
            DM: "We are thrilled to have you as a new member! Expect to receive an invoice once your membership is confirmed."
        },
        jy: {
            yY: "Does not use tobacco",
            wD: "Tobacco Use",
            w4: "Uses tobacco"
        },
        wN: "There are too many dependents on this membership.",
        wX: "An error occurred, please try again.",
        cW: {
            kg: "Patient cannot be verified",
            vn: "Resend code",
            jq: "Sign In",
            De: "Patient verified",
            wD: "Enter your code",
            xs: "Your code"
        },
        w6: "It may take a few seconds to arrive, and will be valid for 15 minutes.",
        w7: function(n) {
            return "Enter the code we just sent to " + n;
        },
        w8: function(n) {
            return "An email with a code has been sent to " + n + ". Please enter the code within 15 minutes.";
        },
        xc: function(n) {
            return "Go to " + n + " Website";
        },
        aR: {
            mW: "BMI (English)",
            oX: "Diastolic (mmHg)",
            qI: "Height (in)",
            B7: "Pulse (bpm)",
            vq: "Respiratory Rate (bpm)",
            v9: "SpO2 (%)",
            wu: "Systolic (mmHg)",
            wA: "Temp (\xb0F)",
            xh: "Weight (lbs)",
            DN: "When"
        },
        q: {
            lV: "You've been added to the waitlist!",
            lW: "We'll notify you when a spot opens up with",
            mA: "Full - Join Waitlist",
            pu: "Email",
            pv: "jane@example.com",
            pI: "# People to Enroll",
            qc: "First Name",
            qd: "Jane",
            q5: "Complete your signup below to join",
            q6: "You've been invited off the waitlist!",
            z5: "Join Waitlist",
            rn: "Joining",
            ro: "waitlist...",
            ru: "Last Name",
            rv: "Doe",
            tw: "Join the Waitlist",
            t1: "Phone",
            uH: "Provider",
            vC: "Select a provider",
            wn: "Something went wrong. Please try again.",
            ws: "We'll contact you when a spot opens up with",
            dT: "You're on the waitlist!"
        },
        xj: function(n) {
            return "Welcome to " + n;
        },
        xp: "Yes",
        xt: "Your contact details",
        xu: "Your Email"
    }), Uk = "Fecha", Ek = "doctor", Pk = "Seleccionar", Tk = "location", Fk = "Su membres\xeda ha sido renovada", Lk = "proveedor", Mk = "Fecha de inicio", Hk = _k({
        lE: F2(function(n, r) {
            return "Usar una tarjeta de cr\xe9dito le costar\xe1 a " + n + " un " + r + " adicional en tarifas de procesamiento para su membres\xeda. Por favor, considere usar una cuenta bancaria en su lugar.";
        }),
        lF: function(n) {
            return "Usar una tarjeta de cr\xe9dito le costar\xe1 a " + n + " gastos de procesamiento adicionales. Por favor, considere usar una cuenta bancaria en su lugar.";
        },
        lT: function(n) {
            return "Agregado " + n;
        },
        lY: "Datos adicionales",
        lZ: "Datos adicionales para el miembro principal",
        l_: {
            wD: "Servicios Adicionales"
        },
        D: {
            lR: "Agregar al carrito",
            lU: "ha sido agregado a tu carrito!",
            l9: "Todos",
            mP: "Facturaci\xf3n",
            yi: "Cambiar Miembro",
            nR: "Configurar detalles de la membres\xeda",
            nS: "Configurar detalles del paquete",
            nV: "Contacte a la pr\xe1ctica para obtener precios",
            hf: "Inscribirse",
            Ar: "Miembro",
            Au: "T\xfa mismo",
            $7: "Fecha de Inicio de Membres\xeda",
            _: "Membres\xedas",
            ia: "Paquetes",
            B8: "Comprar",
            xa: "Ver Carrito",
            DS: "No hay servicios adicionales disponibles en este momento"
        },
        jN: {
            pt: "Env\xedame los detalles por correo electr\xf3nico",
            hf: "Inscr\xedbete ahora"
        },
        l0: {
            mF: "Direcci\xf3n de facturaci\xf3n",
            mO: "Misma direcci\xf3n de facturaci\xf3n",
            nr: "Ciudad",
            yz: "Pa\xeds",
            rE: "Direcci\xf3n",
            z9: "Calle, apartado postal, nombre de empresa, a/c",
            rF: "Direcci\xf3n complementaria",
            Aa: "Apartamento, suite, unidad, edificio, piso, etc.",
            rT: "Direcci\xf3n Postal",
            rU: "Misma direcci\xf3n postal",
            sS: "Direcci\xf3n",
            Cp: "Usar la direcci\xf3n del miembro principal",
            wi: "Estado (abrev.)",
            C5: "Por favor use la abreviatura de dos letras.",
            C6: "[Abreviaturas de USPS] (https://pe.usps.com/text/pub28/28apb.htm)",
            xy: "C\xf3digo Postal",
            xz: "No tenemos cobertura en su \xe1rea",
            DT: "Por favor, ingrese un c\xf3digo postal v\xe1lido de EE.UU."
        },
        l8: F2(function(n, r) {
            return "El rango de edad para este plan es de " + n + " a " + r + " a\xf1os.";
        }),
        mg: "Monto",
        xR: F2(function(n, r) {
            return n + " y " + r;
        }),
        gA: {
            wD: "Citas"
        },
        ms: "Se debe agregar al menos un dependiente al plan.",
        mt: "Se debe agregar al menos un miembro al plan.",
        mw: function(n) {
            return "escrito por " + n;
        },
        mB: "Cuenta Bancaria",
        mQ: {
            mk: "Anual",
            sR: "Mensual",
            uQ: "Trimestral",
            vF: "Semestral"
        },
        gK: {
            m$: "Agente comercial",
            rr: "Qui\xe9n es tu agente comercial?",
            BU: "Seleccionar"
        },
        m0: "Cancelar",
        N: {
            mD: "antes de la cita",
            N: "Cancelar la Cita",
            m1: "Contacto para Cancelaciones",
            m3: "Pol\xedtica de Cancelaci\xf3n",
            n$: "Cont\xe1ctenos al",
            qQ: "horas",
            qV: "Si desea reprogramar su cita, haga click en el bot\xf3n Reprogramar para reservar un nuevo horario.",
            sM: "Plazo M\xednimo de Cancelaci\xf3n",
            vl: "Reprogramar",
            vm: "Reprogramar Cita",
            wF: "para cancelar su cita.",
            wG: "Para cancelar su cita, cont\xe1ctenos al",
            xr: "Su cita ha sido cancelada"
        },
        ba: {
            x9: "Cancelar la membres\xeda",
            yb: "Motivo de la cancelaci\xf3n",
            Ax: "Cancelando la membres\xeda para:",
            Ch: "Remover Miembro",
            Ci: "El miembro ha sido removido de la membres\xeda",
            Ck: "Por favor ingrese una raz\xf3n de cancelaci\xf3n.",
            Cs: "\xa1Lamentamos que se vaya!",
            De: "La membres\xeda ha sido cancelada"
        },
        gL: "Tarjeta",
        jY: {
            n5: "Continuar al Pago",
            wD: "Tu Carrito"
        },
        j_: {
            CR: "Ver menos",
            CT: "Ver m\xe1s"
        },
        yn: {
            wD: "Checkout"
        },
        nl: function(n) {
            return "Este plan no permite ni\xf1os de mas de " + n + " a\xf1os.";
        },
        cl: {
            qb: "Nombre Elegido",
            zY: "Nombre elegido es distinto?",
            rt: "Apellido Elegido",
            sE: "Segundo Nombre Elegido",
            wt: "Sufijo Elegido",
            wD: "T\xedtulo Elegido"
        },
        nt: "Cerrar men\xfa",
        nw: {
            q2: "El formato del c\xf3digo es inv\xe1lido."
        },
        nT: "Confirmar",
        yu: {
            lM: "Agregar luego",
            nc: "Cambia tu m\xe9todo de pago",
            or: "Tarjeta de Cr\xe9dito o D\xe9bito",
            os: "Tarjeta de Cr\xe9dito o D\xe9bito o Cuenta Bancaria",
            vJ: "Opciones"
        },
        nX: "Por favor, contacte a la pr\xe1ctica si tiene alguna pregunta.",
        nY: function(n) {
            return "Por favor, contacte a la pr\xe1ctica al " + n + " si tiene alguna pregunta.";
        },
        nZ: function(n) {
            return "Por favor, contacte a la pr\xe1ctica al " + n + " si tiene alguna pregunta.";
        },
        n_: F2(function(n, r) {
            return "Por favor, contacte a la pr\xe1ctica al " + n + " o al " + r + " si tiene alguna pregunta.";
        }),
        n2: "Continuar al siguiente paso",
        n3: function(n) {
            return "Continuar a " + n;
        },
        n4: "Continuar",
        oc: function(n) {
            return "Contrato Renueva en #" + n;
        },
        oe: function(n) {
            return "Contrato Termina en " + n;
        },
        j3: {
            gA: "Citas",
            xi: "Bienvenido/a de nuevo,"
        },
        oD: Uk,
        bg: Uk + " de nacimiento",
        oW: function(n) {
            return "La cancelaci\xf3n de esta membres\xeda detendr\xe1 los cargos recurrentes para los pacientes seleccionados y eliminar\xe1 el acceso a las ventajas de la membres\xeda a partir de " + n + ".";
        },
        ha: {
            qB: "\xbfTienes un c\xf3digo de descuento?",
            zU: "Este no es un c\xf3digo de descuento v\xe1lido.",
            rr: "C\xf3digo de descuento"
        },
        ew: {
            xS: "Cualquier distancia",
            rr: "Distancia",
            AH: "Sin filtro",
            BU: "Filtrar por distancia"
        },
        o3: "Fecha de nacimiento no puede ser en el futuro.",
        o4: Ek,
        o5: Pk + " " + Ek,
        o7: function(n) {
            return n + " aceptado!";
        },
        R: {
            xB: "Aceptar",
            yN: "No, gracias",
            j8: "Escribe tu nombre y apellido",
            yP: "Firma electr\xf3nica del miembro",
            zV: "Por favor, escribe cualquiera de los nombres exactamente como aparece arriba.",
            zW: "Por favor, escribe tu nombre exactamente como aparece arriba.",
            At: "Nombre del Miembro",
            kA: "Nombre",
            AE: "Nombre del Nuevo Miembro",
            B1: "Nombre del Miembro Principal",
            B2: "Escribe el nombre y apellido de cualquier miembro",
            B3: "Firma electr\xf3nica del nuevo o miembro principal",
            Cn: "Por favor, firme este documento.",
            vY: "Firma electr\xf3nica",
            wY: "La firma no coincide con el nombre del firmante."
        },
        o9: {
            y_: "Pendiente",
            BC: "Pagado",
            DJ: "Anulado"
        },
        ac: {
            wD: "Documentos"
        },
        pc: "Descargar",
        bk: {
            xM: "Desde el inicio",
            yD: "A\xf1o actual",
            yF: "Personalizado",
            pC: "Fecha de Fin",
            zM: "En Progreso",
            zN: "Su archivo est\xe1 siendo procesado y puede tardar unos segundos.",
            z7: "A\xf1o pasado",
            C3: "Fecha de Inicio"
        },
        pe: "Pr\xe1ctica DPC",
        cr: {
            rr: "Pr\xe1ctica DPC",
            Ac: "Cargando pr\xe1cticas DPC...",
            Bw: "Nombre de la Pr\xe1ctica DPC",
            Bx: "El nombre de tu Pr\xe1ctica DPC",
            BU: "Empieza a escribir para encontrar tu Pr\xe1ctica DPC",
            DS: "No se encontraron pr\xe1cticas DPC"
        },
        ph: function(n) {
            return "Vence el " + n;
        },
        pl: "Los pacientes de la membres\xeda no pueden duplicarse en la misma membres\xeda.",
        pp: "Editar",
        pt: "Email",
        aG: {
            pt: "Correo Electr\xf3nico",
            qb: "Nombre",
            rt: "Apellido",
            sS: "Nombre Completo",
            t0: "Tel\xe9fono",
            u5: "Relaci\xf3n",
            Cl: "Por favor ingrese tel\xe9fono o correo electr\xf3nico.",
            Cm: "Por favor, ingrese al menos nombre, apellido o relaci\xf3n.",
            CZ: "Usar miembro principal como contacto de emergencia",
            wD: "Contacto de emergencia"
        },
        aX: {
            yo: "Hijo/Hija",
            zw: "Abuelo/Abuela",
            zz: "Tutor/Tutora",
            AH: "Ninguno",
            Bw: "Otro",
            BE: "Padre/Madre",
            fw: "Selecciona una relaci\xf3n",
            CW: "Hermano/Hermana",
            C2: "C\xf3nyuge"
        },
        pH: "Ingl\xe9s",
        eB: {
            mN: "Frecuencia de Facturaci\xf3n",
            B0: "Principal",
            wD: "Miembros inscritos",
            DS: "No hay pacientes inscritos"
        },
        pL: function(n) {
            return "termin\xf3 el " + n;
        },
        pM: function(n) {
            return "termina el " + n;
        },
        pN: function(n) {
            return "Inscrito el " + n;
        },
        pO: {
            o1: "No me inscriba",
            pJ: "Inscr\xedbame",
            sS: "Estado de Inscripci\xf3n",
            AO: "\xbfEst\xe1 pagando por otra persona y no desea inscribirse como paciente? Seleccione \u201CNo me inscriba\u201D."
        },
        pS: F2(function(n, r) {
            return n + ": " + r;
        }),
        pT: F3(function(n, r, t) {
            return n + " " + r + ": " + t;
        }),
        pZ: F2(function(n, r) {
            return "Expira " + n + "/" + r;
        }),
        qf: "para",
        eE: {
            ns: "haz clic aqu\xed",
            qJ: "No tienes autorizaci\xf3n para ver esta p\xe1gina. Por favor, usa el enlace en tu correo electr\xf3nico, o",
            qK: "para ir a la p\xe1gina principal de tu portal de pacientes.",
            wD: "Autorizaci\xf3n Requerida"
        },
        de: {
            yJ: "Fecha de Env\xedo",
            oF: "Fecha de Env\xedo",
            AJ: "# de Preguntas",
            CG: "Enviado a",
            wj: "Estado"
        },
        qh: {
            qX: "Por favor, complete las preguntas del formulario."
        },
        qv: {
            zm: "Femenino",
            rr: "G\xe9nero",
            Aj: "Masculino",
            Bw: "Otro"
        },
        qw: {
            rr: "Identidad de g\xe9nero",
            Ak: "Hombre",
            AG: "No binario",
            AI: "No listado",
            BU: "Seleccionar",
            Dx: "Hombre trans",
            Dy: "Mujer trans",
            DP: "Mujer"
        },
        hv: {
            pz: "No se ha compartido informaci\xf3n de la pr\xe1ctica.",
            pR: "Hubo un error al cargar su informaci\xf3n de salud.",
            wD: "Salud"
        },
        qG: "Cobertura de salud",
        aw: {
            m8: "Aseguradora",
            yd: "Comience a escribir para encontrar su aseguradora",
            na: "Nombre de aseguradora",
            ye: "Elija una opci\xf3n",
            Y: "Cobertura existente",
            za: "\xbfTiene seguro o una alternativa de seguro?",
            qA: "ID de grupo",
            qO: "Deducible alto",
            zD: "\xbfEst\xe1 en un plan con deducible alto?",
            r5: "ID de miembro",
            Cw: "Busque para filtrar..."
        },
        q1: function(n) {
            return "Por favor, ingrese " + n + " v\xe1lido.";
        },
        q4: function(n) {
            return "Se requiere un t\xe9lefono " + n + " v\xe1lido.";
        },
        q7: function(n) {
            return "Factura " + n;
        },
        q8: function(n) {
            return "Fecha de Vencimiento: " + n;
        },
        eK: {
            tQ: "Pago",
            v3: "Fuente de Pago",
            jq: "Pagar Factura",
            wD: "Pagar Factura"
        },
        g: {
            xI: "cargos adiconales",
            mh: "Monto a Pagar",
            nh: "Cargos",
            om: "Cr\xe9dito",
            on: "Cargo por tarjeta",
            oo: "Para evitar cargos por transacci\xf3n, considere usar una cuenta bancaria (ACH) o d\xe9bito.",
            yB: "Usar una tarjeta de cr\xe9dito implicar\xe1 cargos por transacci\xf3n.",
            op: "Cargos por tarjeta",
            oq: "Cargos pagados por tarjeta",
            y_: "A pagar",
            pi: "gracias a",
            pj: "gracias a tu membres\xeda",
            pk: "gracias a tu paquete",
            rb: "Total de la Factura",
            dm: "Hubo un error al cargar sus facturas",
            s9: "N\xfamero de Factura",
            BC: "Pagado",
            tN: "Pagar Factura",
            tY: "Total a Pagar",
            tZ: "Pagos",
            ua: "+ impuestos",
            wq: "Subtotal",
            Df: "Impuesto",
            wD: "Facturas",
            Du: "Total",
            wO: "Total a Pagar",
            wR: "Transferido a Cr\xe9dito",
            xq: "Has ahorrado",
            DS: "No hay facturas para mostrar"
        },
        rl: "Art\xedculo",
        hN: {
            rr: "C\xf3mo escuchaste sobre nosotros?",
            ry: "Fuente de contacto",
            BU: "Seleccionar"
        },
        rA: "Saber m\xe1s",
        ku: Tk,
        bW: {
            xS: "Cualquier ubicaci\xf3n",
            oV: "Selecciona la ubicaci\xf3n donde te gustar\xeda reunirte con tu proveedor",
            zU: "La ubicaci\xf3n es inv\xe1lida, seleccione una opci\xf3n diferente.",
            rr: "Ubicaci\xf3n",
            BU: "Filtrar por ubicaci\xf3n",
            vd: "Ubicaci\xf3n es requerida.",
            fw: "Seleccionar"
        },
        rL: function(n) {
            return "+ " + n + " otros";
        },
        hR: {
            gW: "c\xf3digo",
            qg: "Iniciar sesi\xf3n en su portal del paciente",
            rS: "enlace m\xe1gico"
        },
        rM: function(n) {
            return "No nos gustan las contrase\xf1as m\xe1s que a ti. Ingresa tu correo electr\xf3nico y te enviaremos un " + n + " para iniciar sesi\xf3n al instante.";
        },
        rN: "Ingresa tu correo electr\xf3nico para obtener un c\xf3digo de inicio de sesi\xf3n",
        rO: function(n) {
            return "Enviar " + n;
        },
        rY: function(n) {
            return "La edad m\xe1xima para este plan es de " + n + " a\xf1os.";
        },
        r3: function(n) {
            return "Edad " + n;
        },
        r4: "Dependiente",
        r7: "Miembro principal",
        Av: {
            lI: "Agregar miembros",
            lJ: "Agregar otro miembro",
            lK: "Demograf\xeda",
            lL: "Agregar Contacto de Emergencia",
            lN: "Agregar Miembro",
            lO: "+ Agregar Nuevo Miembro",
            lP: "\xa1Miembro creado exitosamente!",
            lX: "Agregando miembros?",
            yR: "Por favor, contacte a la cl\xednica para cambiar estos detalles del paciente.",
            pq: "Editar Contacto de Emergencia",
            py: "Contacto de Emergencia",
            qC: "Seguro M\xe9dico",
            qD: "Seguro",
            qE: "N\xfamero de Grupo",
            qF: "N\xfamero de Miembro",
            qY: "Informaci\xf3n de Miembro",
            qZ: "Editar Informaci\xf3n de Miembro",
            dm: "Hubo un error cargando miembros",
            rW: "Gestionar Miembro",
            Al: "Gestionar Miembros",
            s2: "No se permiten m\xe1s miembros dependientes para esta membres\xeda",
            wD: "Miembros",
            DS: "No hay miembros para mostrar"
        },
        r8: function(n) {
            return "Se permiten " + n + " miembros dependientes para esta membres\xeda";
        },
        sa: function(n) {
            return "Su membres\xeda finaliza el " + n;
        },
        e$: {
            g8: "Predeterminado",
            rr: "M\xe9todo de Pago",
            jD: "M\xe9todo de pago actualizado exitosamente",
            wZ: "Cualquier pago pendiente de esta membres\xeda se cobrar\xe1 al nuevo m\xe9todo de pago."
        },
        sc: Fk,
        sd: function(n) {
            return Fk + " hasta " + n;
        },
        $7: {
            rr: "Fecha de inicio de la membres\xeda"
        },
        _: {
            oa: "Per\xedodo de contrato",
            ou: "Membres\xedas Actuales",
            oz: "Actual",
            pE: "Membres\xedas Finalizadas",
            pF: "Finalizada",
            ij: "Membres\xedas Pendientes",
            u9: "Renueva la Membres\xeda",
            iI: "Ver Detalles de la Membres\xeda",
            wD: "Membres\xedas",
            Dq: "Membres\xedas y paquetes",
            DS: "No Hay Membres\xedas Para Mostrar",
            xw: "No hay elementos para mostrar"
        },
        J: {
            xG: "Agregar Destinatarios",
            ni: "Chat para conversaci\xf3n",
            nj: "Aqu\xed es donde aparecer\xedan los mensajes del chat.",
            yp: "Haga clic para cargar proveedores",
            p_: "Error al cargar conversaciones",
            zj: "Error al cargar archivo",
            zk: "Error al cargar imagen",
            p$: "Error al cargar mensajes.",
            zl: "Error al cargar proveedores.",
            sZ: "Ninguna conversaci\xf3n seleccionada",
            s_: "Vea las conversaciones a la izquierda, o inicie un nuevo mensaje.",
            s$: "Sin conversaciones",
            s0: "A\xfan no hay mensajes",
            s1: "Vea las conversaciones a la izquierda o inicie un nuevo mensaje.",
            wD: "Chat",
            wV: "Escribir un mensaje..."
        },
        sf: "Pausa",
        sg: "Reproducir",
        sh: function(n) {
            return "Vista previa de " + n;
        },
        si: "Toca para ampliar",
        sj: "No se puede previsualizar este archivo",
        sk: "Cargando CSV",
        sl: function(n) {
            return "Vista previa de CSV: " + n;
        },
        sm: "Cargando documento",
        sn: "Cargando documento de Word",
        so: function(n) {
            return "Vista previa del documento: " + n;
        },
        sp: "Cargando PDF",
        sq: "Cargando vista previa del PDF",
        sr: function(n) {
            return "Columna " + n;
        },
        ss: "Cargando hoja de c\xe1lculo",
        st: "No hay filas para mostrar.",
        su: "Para ver este archivo, desc\xe1rgalo y \xe1brelo con la aplicaci\xf3n adecuada en tu dispositivo.",
        sv: "Este libro no tiene hojas para mostrar.",
        sw: "Cargando libro de Excel",
        sx: F2(function(n, r) {
            return "Vista previa de Excel: " + n + " \u2014 " + r;
        }),
        sy: function(n) {
            return "Vista previa de Excel: " + n;
        },
        sz: "Cargando XML",
        sA: "Cargando XML",
        sB: function(n) {
            return "Vista previa XML: " + n;
        },
        sC: function(n) {
            return n + " se uni\xf3 a la conversaci\xf3n";
        },
        sD: function(n) {
            return n + " fue eliminado de la conversaci\xf3n";
        },
        sF: function(n) {
            return "a " + n + "  millas";
        },
        sH: function(n) {
            return "La edad m\xednima para este plan es de " + n + " a\xf1os.";
        },
        cE: {
            qb: "Nombre",
            rt: "Apellido",
            sE: "Segundo Nombre",
            wt: "Sufijo",
            wD: "T\xedtulo",
            Dp: "Seleccionar"
        },
        sT: "Cerrar sesi\xf3n",
        sU: "Pr\xf3xima factura",
        sW: "Siguiente paso",
        sX: "No",
        sY: function(n) {
            return "Al menos un miembro de la membres\xeda debe tener " + n + " a\xf1os o m\xe1s.";
        },
        s5: {
            aF: "Documento",
            po: "Prescripci\xf3n",
            p1: "Fax",
            kk: "Formulario",
            qW: "Prescripci\xf3n",
            rq: "Resultados de Laboratorio",
            s3: "Nota",
            xd: "Signos Vitales"
        },
        td: function(n) {
            return "de " + n + " pendiente";
        },
        tf: function(n) {
            return "el " + n;
        },
        tl: "Abrir men\xfa",
        Bw: "Otro",
        aA: {
            nQ: "Completar Compra",
            hc: "Finalizar",
            hd: "Total a Pagar Hoy",
            Ar: "Miembro",
            h1: "No hay m\xe9todos de pago disponibles",
            du: "M\xe9todo de Pago",
            uv: "Desglose de Precios",
            uM: "Compra completada exitosamente",
            js: "\xa1Todo listo! El paquete est\xe1 disponible de inmediato.",
            dT: "\xa1Compra realizada con \xe9xito!",
            wD: "Revisar y Pagar"
        },
        ts: function(n) {
            return "Expira el " + n;
        },
        tt: function(n) {
            return n + " utilizados";
        },
        ia: {
            iI: "Ver Detalles del Paquete"
        },
        tE: "Paciente",
        du: "M\xe9todo de pago",
        cG: {
            xQ: "American Express no es aceptado.",
            qu: "Fecha de vencimiento futura",
            q3: "Por favor, ingrese un nombre v\xe1lido para el titular del m\xe9todo de pago.",
            rr: "Fuente de pago",
            Cn: "Por favor, agregue un m\xe9todo de pago.",
            Ct: "Guardar m\xe9todo de pago"
        },
        tS: function(n) {
            return n + " no tiene pagos configurados.";
        },
        bt: {
            x5: "Bloqueado",
            yv: "Confirmado",
            zd: "A punto de expirar",
            zi: "Fallido",
            zU: "Inv\xe1lido",
            AD: "Nuevo",
            uA: "Procesando",
            DK: "Advertencia"
        },
        tU: function(n) {
            return n + " es ahora la fuente predeterminada";
        },
        tV: function(n) {
            return n + " fue eliminado exitosamente.";
        },
        BP: {
            lI: "+ Agregar M\xe9todo de Pago",
            lQ: "Agrega un M\xe9todo de Pago",
            gL: "Tarjeta",
            ok: "Su fuente de pago se ha creado con \xe9xito",
            pb: "No guardar fuente de pago",
            pr: "Editar Fuente de Pago",
            hj: "Mes de Expiraci\xf3n",
            hk: "A\xf1o de Expiraci\xf3n",
            re: "Predeterminado",
            dm: "Hubo un Error Cargando Tus Fuentes de Pago",
            rV: "Hacer predeterminado",
            tO: "Usa esta fuente de pago para pagar facturas vencidas",
            Ct: "Guardar M\xe9todo de Pago",
            wD: "Fuentes de pago",
            wM: "Enlace ya utilizado",
            jD: "Su informaci\xf3n de pago se ha actualizado con \xe9xito",
            DS: "No Hay Fuentes de Pago Para Mostrar",
            xy: "C\xf3digo Postal",
            xA: "12345"
        },
        tX: "T\xe9rminos de pago",
        tZ: {
            tR: "Pago fallido!",
            tW: "Pago exitoso!"
        },
        fb: {
            AO: "En nombre del nuevo miembro:",
            te: "Condiciones generales:",
            AP: "En nombre de cada miembro de la membres\xeda:",
            ij: "No aceptados"
        },
        fc: {
            mk: "/a\xf1o",
            sR: "/mes",
            uQ: "/trimestre",
            vF: "/6 meses"
        },
        t0: "Tel\xe9fono",
        cH: {
            lI: "Agregar otro n\xfamero de tel\xe9fono",
            zF: "Casa",
            rr: "N\xfamero de tel\xe9fono",
            AB: "Movil",
            AK: "Oficina",
            Cg: "Borrar n\xfamero de tel\xe9fono"
        },
        t6: "Plan",
        G: {
            mj: "Anual",
            mR: "Frecuencia de Facturaci\xf3n",
            nP: "Completar Inscripci\xf3n",
            hc: "Finalizar",
            hd: "Total a Pagar Hoy",
            pP: "Inscripci\xf3n completada exitosamente",
            Ar: "Miembro",
            $7: "Fecha de Inicio de Membres\xeda",
            sR: "Mensual",
            h1: "No hay m\xe9todos de pago disponibles",
            tj: "Tarifa \xfanica de registro",
            du: "M\xe9todo de Pago",
            Cb: "Recurrente",
            wh: "Comienza Hoy",
            js: "Recibir\xe1 un correo electr\xf3nico de confirmaci\xf3n en breve con todos los detalles.",
            dT: "\xa1Est\xe1 inscrito!",
            wD: "Revisar y Pagar"
        },
        t9: "Por favor",
        ui: function(n) {
            return "La pr\xe1ctica no acepta miembros menores a " + n;
        },
        uo: "Idioma preferido",
        aa: {
            yH: "Fecha de Dispensaci\xf3n",
            j4: "Fecha de Prescripci\xf3n",
            j6: "# d\xedas de tratamiento",
            kk: "Forma",
            qp: "Frecuencia",
            kq: "Instrucciones",
            Aq: "Medicaci\xf3n",
            k$: "Prescriptor",
            k0: "Precio",
            uN: "Cant.",
            Ce: "Repeticiones",
            la: "V\xeda de Administraci\xf3n",
            lm: "Concentraci\xf3n",
            ls: "Fecha de Uso"
        },
        uC: {
            zA: "\xc9l",
            rr: "Pronombres",
            AI: "No listado",
            BU: "Seleccionar",
            CK: "Ella",
            Dl: "Ellos"
        },
        uE: Lk,
        uF: Pk + " " + Lk + " y " + Tk,
        uG: Lk + " inv\xe1lido, por favor seleccione una opci\xf3n v\xe1lida.",
        k2: {
            vD: "Proveedor y ubicaci\xf3n seleccionados!",
            wD: "Seleccionar Proveedor y Ubicaci\xf3n"
        },
        uI: Lk + " es requerido.",
        uJ: {
            Cv: "Buscar por nombre"
        },
        uK: Pk + " " + Lk,
        uL: "Proveedor seleccionado!",
        B8: function(n) {
            return "Compra " + n;
        },
        uO: "Cant.",
        fl: {
            kc: "Cobro inmediato",
            qa: "Primera Factura",
            Bv: "Tarifa \xfanica de registro",
            Cb: "Recurrente",
            Cc: "Facturas Recurrentes",
            Cy: "Segunda Factura",
            Dv: "Factura Total"
        },
        k4: {
            rr: "Tarifa y per\xedodo de pago",
            BU: "Seleccionar"
        },
        fn: {
            xR: "y los",
            z8: "Este sitio est\xe1 protegido por reCAPTCHA y se aplican la",
            B4: "Pol\xedtica de Privacidad",
            Dh: "T\xe9rminos de Servicio"
        },
        uX: " de Google.",
        u5: {
            xL: "Adulto/a",
            yo: "Hijo/a",
            rr: "Relaci\xf3n con usted",
            tq: "Titular"
        },
        Cg: "Eliminar",
        u8: "Eliminando",
        ve: "Por favor, describa.",
        vf: function(n) {
            return "Por favor, ingrese " + n + ".";
        },
        vg: function(n) {
            return "Por favor, seleccione " + n + ".";
        },
        vv: {
            yE: "Actualmente viendo datos de sandbox."
        },
        Ct: "Guardar",
        vA: function(n) {
            return "Al enviar la informaci\xf3n de su cuenta, usted autoriza a " + n + " a debitar y acreditar electr\xf3nicamente su cuenta de forma recurrente como se establece en su acuerdo de membres\xeda o como se le muestra durante el proceso de registro. Usted comprende que puede comunicarse con " + n + " para revocar esta autorizaci\xf3n en cualquier momento.";
        },
        vB: function(n) {
            return "Al enviar la informaci\xf3n de su cuenta, usted autoriza a " + n + " a debitar y acreditar electr\xf3nicamente su cuenta este servicio tal y como se le muestra.";
        },
        dH: {
            yt: "marcos integrales",
            zv: "de seguridad y cumplimiento",
            By: "Nuestra",
            BV: "plataforma",
            Dg: "utiliza tecnolog\xeda de cifrado de datos de \xfaltima generaci\xf3n y se audita peri\xf3dicamente seg\xfan"
        },
        fw: Pk,
        lf: {
            oV: "Tu sesi\xf3n expir\xf3, por favor inicia sesi\xf3n nuevamente.",
            wD: "Sesi\xf3n Expirada"
        },
        vK: {
            zm: "Femenino",
            zT: "Intersexual",
            rr: "Sexo",
            Aj: "Masculino",
            BU: "Seleccionar"
        },
        vR: "Iniciar sesi\xf3n",
        vS: function(n) {
            return "Al hacer clic en " + n + ", reconozco que cumplo con los";
        },
        vT: "requisitos",
        vU: "que permiten a esta plataforma recopilar la informaci\xf3n que he proporcionado.",
        vV: "Cerrar sesi\xf3n",
        vW: function(n) {
            return "\xbfNo tienes una membres\xeda con " + n + "?";
        },
        vX: "Reg\xedstrate hoy",
        v0: F2(function(n, r) {
            return "Reg\xedstrate con " + n + " a trav\xe9s de " + r;
        }),
        v1: function(n) {
            return "Reg\xedstrate con " + n;
        },
        v7: "Espa\xf1ol",
        wb: "SSN",
        C3: Mk,
        we: function(n) {
            return Mk + " no puede ser anterior a " + n + ".";
        },
        a7: {
            xH: "datos adicionales",
            yu: "confirmaci\xf3n",
            yw: "contacto",
            yG: "detalles personalizados",
            ku: "ubicaci\xf3n",
            Av: "miembros",
            Aw: "Demograf\xeda",
            Ay: "membres\xeda",
            uE: "proveedor"
        },
        wl: "Por favor, ingresa un m\xe9todo de pago o nombre del titular de la cuenta v\xe1lido.",
        wm: function(n) {
            return n;
        },
        cU: {
            yn: "Recibir\xe1s una confirmaci\xf3n de compra si nos autorizaste a enviarte correos electr\xf3nicos. Si tienes alguna otra pregunta, por favor cont\xe1ctanos directamente.",
            pw: "\xa1Error al enviar el correo!",
            px: "\xa1Correo enviado!",
            B8: "\xa1Gracias por tu compra!",
            wD: "Gracias",
            DM: "\xa1Estamos encantados de tenerte como nuevo miembro! Espera recibir una factura una vez que se confirme tu membres\xeda."
        },
        jy: {
            yY: "No usa tabaco",
            wD: "Uso de Tabaco",
            w4: "Usa tabaco"
        },
        wN: "Hay demasiados dependientes en esta membres\xeda.",
        wX: "Ocurri\xf3 un error, por favor int\xe9ntalo de nuevo.",
        cW: {
            kg: "El paciente no puede ser verificado",
            vn: "Reenviar c\xf3digo",
            jq: "Iniciar sesi\xf3n",
            De: "Paciente verificado",
            wD: "Ingresa tu c\xf3digo",
            xs: "Tu c\xf3digo"
        },
        w6: "Puede tardar unos segundos en llegar y ser\xe1 v\xe1lido por 15 minutos.",
        w7: function(n) {
            return "Ingresa el c\xf3digo que acabamos de enviar a " + n;
        },
        w8: function(n) {
            return "Se ha enviado un correo electr\xf3nico con un c\xf3digo a " + n + ". Por favor, ingresa el c\xf3digo dentro de los pr\xf3ximos 15 minutos.";
        },
        xc: function(n) {
            return "Ir al sitio web de " + n;
        },
        aR: {
            mW: "IMC (Ingl\xe9s)",
            oX: "Diast\xf3lica (mmHg)",
            qI: "Altura (pulg)",
            B7: "Pulso (ppm)",
            vq: "Frecuencia Respiratoria (ppm)",
            v9: "SpO2 (%)",
            wu: "Sist\xf3lica (mmHg)",
            wA: "Temp (\xb0F)",
            xh: "Peso (libras)",
            DN: "Cu\xe1ndo"
        },
        q: {
            lV: "\xa1Te has unido a la lista de espera!",
            lW: "Te notificaremos cuando haya un lugar disponible con",
            mA: "Lleno - Unirse a lista de espera",
            pu: "Correo electr\xf3nico",
            pv: "maria@ejemplo.com",
            pI: "# Personas a inscribir",
            qc: "Nombre",
            qd: "Mar\xeda",
            q5: "Completa tu registro a continuaci\xf3n para unirte a",
            q6: "\xa1Has sido invitado de la lista de espera!",
            z5: "Unirse a la lista de espera",
            rn: "Uni\xe9ndose a la",
            ro: "lista de espera...",
            ru: "Apellido",
            rv: "Garc\xeda",
            tw: "\xdanete a la lista de espera",
            t1: "Tel\xe9fono",
            uH: "Proveedor",
            vC: "Selecciona un proveedor",
            wn: "Algo sali\xf3 mal. Por favor, int\xe9ntalo de nuevo.",
            ws: "Te contactaremos cuando haya un lugar disponible con",
            dT: "\xa1Est\xe1s en la lista de espera!"
        },
        xj: function(n) {
            return "Bienvenido a " + n;
        },
        xp: "Si",
        xt: "Tus datos de contacto",
        xu: "Tu Email"
    }), Rk = F2(function(n, r) {
        return r(n ? Hk : zk);
    }), Ok = F2(function(n, r) {
        return A2(dr, n, mk(r));
    }), Nk = Ok("className"), Ik = ir("div"), Vk = function(n) {
        return {
            $: 0,
            a: n
        };
    }, Wk = Vk(3), Zk = $r, Xk = function(n) {
        if (1 === n.$) {
            var r = n.a;
            return A2(yu, Zk(hu), r);
        }
        switch(n.a){
            case 0:
                return k([
                    Nk("spinner--xs")
                ]);
            case 1:
                return k([
                    Nk("spinner--sm")
                ]);
            case 3:
                return k([
                    Nk("spinner--lg")
                ]);
            default:
                return h;
        }
    }, Gk = ir("span"), Jk = function(n) {
        return A2(Gk, A2(Ot, Nk("spinner"), A2(Ji, Xk, n)), k([
            A2(Gk, k([
                Nk("spinner__dot")
            ]), h),
            A2(Gk, k([
                Nk("spinner__dot")
            ]), h),
            A2(Gk, k([
                Nk("spinner__dot")
            ]), h),
            A2(Gk, k([
                Nk("spinner__dot")
            ]), h)
        ]));
    }, Yk = k([
        A2(Ik, k([
            Nk("flex justify-center")
        ]), k([
            Jk(k([
                Wk
            ]))
        ]))
    ]), Qk = function(n) {
        return {
            $: 3,
            a: n
        };
    }, Kk = ir("h2"), nx = function(n) {
        return {
            $: 0,
            a: n
        };
    }, rx = nx(3), tx = function(n) {
        switch(n){
            case 4:
                return "text-2xl sm:text-4xl";
            case 3:
                return "text-l";
            case 2:
                return "text-base";
            case 1:
                return "text-sm";
            default:
                return "text-xs";
        }
    }, ex = function(n) {
        switch(n){
            case 0:
                return "";
            case 1:
                return "sm:";
            case 2:
                return "md:";
            case 3:
                return "lg:";
            default:
                return "xl:";
        }
    }, ux = F2(function(n, r) {
        return k([
            Nk($(ex(n), tx(r)))
        ]);
    }), ax = function(n) {
        switch(n){
            case 0:
                return "start";
            case 1:
                return "center";
            case 2:
                return "end";
            default:
                return "between";
        }
    }, ix = function(n) {
        switch(n.$){
            case 0:
                var r = function(n) {
                    return "text-" + n;
                };
                switch(n.a){
                    case 0:
                        return r("left");
                    case 1:
                        return r("center");
                    case 2:
                        return r("right");
                    default:
                        return r("between");
                }
            case 2:
                return "justify-" + ax(n.a);
            case 1:
                return "items-" + ax(n.a);
            default:
                return "self-" + ax(n.a);
        }
    }, cx = function(n) {
        return k([
            Nk(ix(n))
        ]);
    }, ox = function(n) {
        var r = n.a, t = function(n) {
            if (1 === n.$) return "0";
            switch(n.a){
                case 0:
                    return "1";
                case 1:
                    return "2";
                case 2:
                    return "4";
                case 3:
                    return "8";
                default:
                    return "12";
            }
        }(n.b), e = function(n) {
            switch(n.$){
                case 0:
                    switch(n.a){
                        case 0:
                            return "t";
                        case 1:
                            return "r";
                        case 3:
                            return "b";
                        default:
                            return "l";
                    }
                case 2:
                    return "x";
                case 1:
                    return "y";
                default:
                    return "";
            }
        }(r);
        return A2(ue, "-", k([
            "m" + e,
            t
        ]));
    }, fx = function(n) {
        return k([
            Nk(ox(n))
        ]);
    }, sx = F2(function(n, r) {
        return k([
            Nk($(ex(n), ix(r)))
        ]);
    }), lx = F2(function(n, r) {
        return k([
            Nk($(ex(n), ox(r)))
        ]);
    }), dx = function(n) {
        switch(n){
            case 0:
                return "font-thin";
            case 1:
                return "font-normal";
            case 2:
                return "font-medium";
            case 3:
                return "font-semibold";
            case 4:
                return "font-bold";
            default:
                return "font-extrabold";
        }
    }, bx = function(n) {
        n: for(;;)switch(n.$){
            case 9:
                var r = n.a;
                if (r.a) {
                    n = r.b;
                    continue n;
                }
                return h;
            case 1:
                switch(n.a){
                    case 2:
                        return k([
                            Nk("text-danger")
                        ]);
                    case 0:
                        return k([
                            Nk("text-success")
                        ]);
                    case 3:
                        return k([
                            Nk("text-warning")
                        ]);
                    case 1:
                        return k([
                            Nk("text-support")
                        ]);
                    case 4:
                        return k([
                            Nk("text-primary")
                        ]);
                    case 5:
                        return k([
                            Nk("text-primary-500")
                        ]);
                    default:
                        return k([
                            Nk("text-light-gray")
                        ]);
                }
            case 0:
                return k([
                    Nk(tx(n.a))
                ]);
            case 2:
                return k([
                    Nk(dx(n.a))
                ]);
            case 4:
                return k(n.a ? [
                    Nk("line-through")
                ] : [
                    Nk("underline")
                ]);
            case 5:
                return fx(n.a);
            case 6:
                return A2(lx, n.a, n.b);
            case 7:
                return $(cx(t = n.a), t.$ ? k([
                    Nk("flex")
                ]) : h);
            case 8:
                var t;
                return A2(sx, n.a, t = n.b);
            case 3:
                return n.a;
            default:
                return A2(ux, n.a, n.b);
        }
    }, vx = function(n) {
        return A2(yu, Zk(hu), Gi(A2(yu, bx, n)));
    }, mx = F2(function(n, r) {
        return A2(Kk, vx(A2(Ot, rx, A2(Ot, Qk(k([
            Nk("text-primary-300")
        ])), n))), r);
    }), px = fr, $x = ir("p"), hx = F2(function(n, r) {
        return A2($x, vx(n), A2(yu, px(hu), r));
    }), gx = A2(ir("hr"), k([
        Nk("horizontal-rule")
    ]), h), wx = A2(Ik, k([
        Nk("panel w-full")
    ]), k([
        A2(mx, h, k([
            ad("Page Not Found")
        ])),
        gx,
        A2(hx, h, k([
            A2(hx, h, k([
                ad("This page doesn't exist anymore. Please check your URL for typos.")
            ])),
            A2(hx, h, k([
                ad("Feel free to contact us to let us know about any broken links.")
            ]))
        ]))
    ])), kx = function(n) {
        return {
            zO: F2(function(r, t) {
                var e = b(r.dw, fk(r.gx));
                switch(e.a.$){
                    case 3:
                        return e.b ? v(ak(t), Dp, h) : A2(kk, ck, A2(sk, h, A3(n.zO, e.a.a, r, t)));
                    case 1:
                    case 0:
                        return v(ak(t), Dp, h);
                    default:
                        return v(ik, Dp, h);
                }
            }),
            Ab: F2(function(r, t) {
                var e = b(r.dw, t);
                n: for(; !e.b.$;)switch(e.a.$){
                    case 3:
                        var u = e.a.a, a = e.b.a;
                        if (fk(r.gx)) return b(ak(a), Dp);
                        var c = A3(n.zO, u, r, a), o = c.b;
                        return b(ck(c.a), Hu(k([
                            o,
                            gk(u)
                        ])));
                    case 2:
                        return b(ik, Dp);
                    default:
                        break n;
                }
                if (1 === t.$) {
                    var f = t.a;
                    return A2(wk, ck, A2(n.Ab, r, m(f, {
                        kj: i(r.kj, f.kj) ? f.kj : r.kj
                    })));
                }
                return b(t, Dp);
            }),
            Ct: F2(function(r, t) {
                return 1 === r.$ ? A2(n.Ct, r.a, t) : t;
            }),
            Dd: function(r) {
                return 1 === r.$ ? n.Dd(r.a) : yk;
            },
            DB: F2(function(r, t) {
                return 1 === t.$ ? A2(kk, ck, A2(n.DB, r, t.a)) : v(t, Dp, h);
            }),
            DH: function(r) {
                switch(r.$){
                    case 1:
                        var t = r.a;
                        return A2(n.DH, Rk(t.kj), t);
                    case 2:
                        return {
                            gF: k([
                                wx
                            ]),
                            wD: "404"
                        };
                    default:
                        return {
                            gF: Yk,
                            wD: "Loading..."
                        };
                }
            }
        };
    }, xx = function(n) {
        return 1 === n.a.i.$;
    }, yx = function(n) {
        return !n.a.i.$;
    }, _x = Jn("pushUrl", mk), Cx = F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    }), Dx = function(n) {
        return encodeURIComponent(n);
    }, Ax = F2(function(n, r) {
        return A2(Cx, Dx(n), Dx(r));
    }), qx = function(n) {
        return n.a + "=" + n.b;
    }, Bx = function(n) {
        return n.b ? "?" + A2(ue, "&", A2(yu, qx, n)) : "";
    }, jx = P, Sx = function(n) {
        var r = function() {
            switch(n.$){
                case 0:
                    return h;
                case 1:
                    return k([
                        "enroll-thanks"
                    ]);
                case 2:
                    return k([
                        "not-found"
                    ]);
                case 3:
                    return k([
                        "patient-documents"
                    ]);
                case 4:
                    return k([
                        "thanks"
                    ]);
                case 5:
                    return k([
                        "waitlist"
                    ]);
                case 6:
                    return k([
                        "account"
                    ]);
                case 7:
                    return k([
                        "booking"
                    ]);
                case 8:
                    return k([
                        "checkout"
                    ]);
                case 9:
                    return k([
                        "enroll"
                    ]);
                case 10:
                    return k([
                        "signup"
                    ]);
                case 11:
                    return k([
                        "style-guide"
                    ]);
                case 12:
                    return k([
                        "account",
                        "additional-services"
                    ]);
                case 13:
                    return k([
                        "account",
                        "booking"
                    ]);
                case 14:
                    return k([
                        "account",
                        "cart"
                    ]);
                case 15:
                    return k([
                        "account",
                        "chat"
                    ]);
                case 16:
                    return k([
                        "account",
                        "documents"
                    ]);
                case 17:
                    return k([
                        "account",
                        "forbidden"
                    ]);
                case 18:
                    return k([
                        "account",
                        "health-information"
                    ]);
                case 19:
                    return k([
                        "account",
                        "invoices"
                    ]);
                case 20:
                    return k([
                        "account",
                        "members"
                    ]);
                case 21:
                    return k([
                        "account",
                        "memberships"
                    ]);
                case 22:
                    return k([
                        "account",
                        "messaging"
                    ]);
                case 23:
                    return k([
                        "account",
                        "not-found"
                    ]);
                case 24:
                    return k([
                        "account",
                        "payment-sources"
                    ]);
                case 25:
                    return k([
                        "account",
                        "practitioner-location"
                    ]);
                case 26:
                    return k([
                        "account",
                        "session-expired"
                    ]);
                case 27:
                    return k([
                        "booking",
                        "empty"
                    ]);
                case 28:
                    return k([
                        "login",
                        "request"
                    ]);
                case 29:
                    return k([
                        "login",
                        "select-patient"
                    ]);
                case 30:
                    return k([
                        "login",
                        "verify-code"
                    ]);
                case 31:
                    return k([
                        "style-guide",
                        "activity-indicator"
                    ]);
                case 32:
                    return k([
                        "style-guide",
                        "address-input"
                    ]);
                case 33:
                    return k([
                        "style-guide",
                        "alerts"
                    ]);
                case 34:
                    return k([
                        "style-guide",
                        "api-select"
                    ]);
                case 35:
                    return k([
                        "style-guide",
                        "button"
                    ]);
                case 36:
                    return k([
                        "style-guide",
                        "card-example"
                    ]);
                case 37:
                    return k([
                        "style-guide",
                        "checkbox"
                    ]);
                case 38:
                    return k([
                        "style-guide",
                        "filter-example"
                    ]);
                case 39:
                    return k([
                        "style-guide",
                        "form-example"
                    ]);
                case 40:
                    return k([
                        "style-guide",
                        "grid"
                    ]);
                case 41:
                    return k([
                        "style-guide",
                        "input"
                    ]);
                case 42:
                    return k([
                        "style-guide",
                        "insurance-info"
                    ]);
                case 43:
                    return k([
                        "style-guide",
                        "modal"
                    ]);
                case 44:
                    return k([
                        "style-guide",
                        "multi-form"
                    ]);
                case 45:
                    return k([
                        "style-guide",
                        "phone-input"
                    ]);
                case 46:
                    return k([
                        "style-guide",
                        "radio"
                    ]);
                case 47:
                    return k([
                        "style-guide",
                        "searchable-select"
                    ]);
                case 48:
                    return k([
                        "style-guide",
                        "select"
                    ]);
                case 49:
                    return k([
                        "style-guide",
                        "table"
                    ]);
                case 50:
                    return k([
                        "style-guide",
                        "tabs"
                    ]);
                case 51:
                    return k([
                        "style-guide",
                        "tag"
                    ]);
                case 52:
                    return k([
                        "style-guide",
                        "toggle"
                    ]);
                case 53:
                    return k([
                        "style-guide",
                        "tooltip"
                    ]);
                case 54:
                    return k([
                        "style-guide",
                        "typography"
                    ]);
                case 55:
                    return k([
                        "account",
                        n.a.wL
                    ]);
                case 56:
                    return k([
                        "bills",
                        n.a.wL
                    ]);
                case 57:
                    return k([
                        "checkout",
                        n.a.v2
                    ]);
                case 58:
                    return k([
                        "signup",
                        n.a.v2
                    ]);
                case 59:
                    return k([
                        "account",
                        "messaging",
                        "chat"
                    ]);
                case 60:
                    return k([
                        "appointments",
                        n.a.a9,
                        "cancellation-policy"
                    ]);
                case 61:
                    return k([
                        "signup",
                        n.a.v2,
                        "additional-details"
                    ]);
                case 62:
                    return k([
                        "signup",
                        n.a.v2,
                        "confirmation"
                    ]);
                case 63:
                    return k([
                        "signup",
                        n.a.v2,
                        "contacts"
                    ]);
                case 64:
                    return k([
                        "signup",
                        n.a.v2,
                        "custom-details"
                    ]);
                case 65:
                    return k([
                        "signup",
                        n.a.v2,
                        "location"
                    ]);
                case 66:
                    return k([
                        "signup",
                        n.a.v2,
                        "members"
                    ]);
                case 67:
                    return k([
                        "signup",
                        n.a.v2,
                        "membership"
                    ]);
                case 68:
                    return k([
                        "signup",
                        n.a.v2,
                        "provider"
                    ]);
                case 69:
                    return k([
                        "signup",
                        n.a.v2,
                        "thanks"
                    ]);
                case 70:
                    return k([
                        "account",
                        "health-information",
                        n.a.qU
                    ]);
                case 71:
                    return k([
                        "account",
                        "invoices",
                        n.a.qU
                    ]);
                case 72:
                    return k([
                        "account",
                        "members",
                        n.a.qU
                    ]);
                case 73:
                    return k([
                        "account",
                        "memberships",
                        n.a.qU
                    ]);
                case 74:
                    return k([
                        "account",
                        "packages",
                        n.a.qU
                    ]);
                case 75:
                    return k([
                        "account",
                        "payment-sources",
                        n.a.qU
                    ]);
                case 76:
                    return k([
                        "account",
                        "appointments",
                        n.a.a9,
                        "cancel"
                    ]);
                case 77:
                    return k([
                        "account",
                        "appointments",
                        n.a.a9,
                        "cancel-appointment"
                    ]);
                case 78:
                    return k([
                        "account",
                        "appointments",
                        n.a.a9,
                        "reschedule"
                    ]);
                case 79:
                    return k([
                        "account",
                        "invoices",
                        n.a.qU,
                        "payment"
                    ]);
                case 80:
                    return k([
                        "account",
                        "members",
                        n.a.qU,
                        "edit"
                    ]);
                case 81:
                    return k([
                        "account",
                        "members",
                        n.a.qU,
                        "emergency-contact"
                    ]);
                case 82:
                    return k([
                        "account",
                        "memberships",
                        n.a.qU,
                        "add-member"
                    ]);
                case 83:
                    return k([
                        "account",
                        "memberships",
                        n.a.qU,
                        "renew"
                    ]);
                case 84:
                    return k([
                        "account",
                        "packages",
                        n.a.qU,
                        "checkout"
                    ]);
                case 85:
                    return k([
                        "account",
                        "payment-sources",
                        n.a.qU,
                        "edit"
                    ]);
                case 86:
                    return k([
                        "account",
                        "plans",
                        n.a.qU,
                        "checkout"
                    ]);
                case 87:
                    return k([
                        "booking",
                        n.a.mp,
                        "location",
                        n.a.mY,
                        "date"
                    ]);
                case 88:
                    return k([
                        "booking",
                        n.a.mp,
                        "location",
                        n.a.mY,
                        "enter-info"
                    ]);
                case 89:
                    return k([
                        "account",
                        "booking",
                        n.a.mp,
                        "location",
                        n.a.mY,
                        "date"
                    ]);
                default:
                    return k([
                        "account",
                        "booking",
                        n.a.mp,
                        "location",
                        n.a.mY,
                        "enter-info"
                    ]);
            }
        }();
        return A2(jx, "/", A2(ue, "/", r));
    }, zx = F2(function(n, r) {
        var t = Bx(A2(yu, function(n) {
            return A2(Ax, n.a, n.b);
        }, It(n)));
        return _x($(Sx(r), t));
    }), Ux = function(n) {
        var r = function(n) {
            var r, t = It(A2(uc, oa, A2(Cp, Tp, n.B9.iu))), e = (r = n.B9.iu).$ ? n.B9.BJ : n.B9.BJ + "?" + r.a;
            return A2(zx, Ml(A2(Ot, b("redirectTo", e), t)), ei);
        }, t = function(n) {
            return yx(n) && !xx(n);
        }, e = kx(n);
        return m(e, {
            zO: F2(function(n, u) {
                var a = b(n.dw, fk(n.gx));
                return 3 !== a.a.$ || a.b || t(n.gx) ? A2(e.zO, n, u) : v(ak(u), r(u), h);
            }),
            Ab: F2(function(n, u) {
                var a = b(n.dw, u);
                if (3 !== a.a.$ || a.b.$) return A2(e.Ab, n, u);
                var i = a.b.a;
                return fk(n.gx) || 2 === n.gx.a.i.$ || t(n.gx) ? A2(e.Ab, n, u) : b(ak(i), r(i));
            })
        });
    }, Ex = {
        $: 12
    }, Px = function(n) {
        return {
            $: 15,
            a: n
        };
    }, Tx = function(n) {
        return {
            $: 2,
            a: n
        };
    }, Fx = function(n) {
        return {
            $: 0,
            a: n
        };
    }, Lx = function(n) {
        return {
            $: 1,
            a: n
        };
    }, Mx = {
        $: 1
    }, Hx = function(n) {
        return {
            $: 4,
            a: n
        };
    }, Rx = F2(function(n, r) {
        return m(r, {
            gY: n
        });
    }), Ox = function(n) {
        return n.a.qU;
    }, Nx = function(n) {
        return {
            gY: Te,
            qU: n.qU,
            dj: n.Dr,
            kt: n.Dt,
            aN: !1
        };
    }, Ix = function(n) {
        return n.a.sS;
    }, Vx = F2(function(n, r) {
        return A2(br, function(n) {
            return /^(on|formAction$)/i.test(n) ? "data-" + n : n;
        }(n), mr(r));
    }), Wx = Vx, Zx = Nk("fs-mask"), Xx = k([
        Zx,
        A2(Wx, "data-recording-sensitive", "")
    ]), Gx = function(n) {
        return A2(Gk, Xx, n);
    }, Jx = function(n) {
        return Gx(k([
            ad(n)
        ]));
    }, Yx = {
        rf: !1,
        fx: A2(Rx, F2(function(n, r) {
            return i(Ox(n), Ox(r));
        }), Nx({
            qU: "member-selector",
            Dr: F2(function(n, r) {
                return Jx(Ix(r));
            }),
            Dt: function(n) {
                return Ht(Ox(n));
            }
        }))
    }, Qx = "modal-scroll-content", Kx = Jn("setupElementScroll", mk), ny = F2(function(n, r) {
        var t = Kx(Qx);
        return b({
            AT: r,
            fr: Rt,
            iA: n,
            bC: 1
        }, t);
    }), ry = function(n) {
        return {
            $: 0,
            a: n
        };
    }, ty = function(n) {
        return {
            $: 1,
            a: n
        };
    }, ey = function(n) {
        return {
            $: 2,
            a: n
        };
    }, uy = function(n) {
        return Yr(n, function(n) {
            var r = n.getBoundingClientRect(), t = Xr.pageXOffset, e = Xr.pageYOffset;
            return {
                vx: nt(),
                jG: {
                    xl: t,
                    lw: e,
                    cd: Zr.documentElement.clientWidth,
                    qI: Zr.documentElement.clientHeight
                },
                ke: {
                    xl: t + r.left,
                    lw: e + r.top,
                    cd: r.width,
                    qI: r.height
                }
            };
        });
    }, ay = function(n) {
        return Yr(n, function(n) {
            return {
                vx: {
                    cd: n.scrollWidth,
                    qI: n.scrollHeight
                },
                jG: {
                    xl: n.scrollLeft,
                    lw: n.scrollTop,
                    cd: n.clientWidth,
                    qI: n.clientHeight
                }
            };
        });
    }, iy = F2(function(n, r) {
        return Hu(k([
            A2(dc, ry, uy(n + "-" + r)),
            A2(dc, ty, uy(n)),
            A2(dc, ey, ay(n))
        ]));
    }), cy = F2(function(n, r) {
        return b({
            c0: r,
            qU: n,
            hZ: 0,
            jt: 0,
            ju: 0,
            jA: 0,
            jB: 0
        }, A2(iy, n, r));
    }), oy = function(n) {
        return {
            $: 1,
            a: n
        };
    }, fy = function(n) {
        return {
            $: 0,
            a: n
        };
    }, sy = function(n) {
        return {
            $: 0,
            a: n
        };
    }, ly = A3(ip, 1992, 4, 31), dy = yn(function(n) {
        n(kn(A2(_c, -(new Date).getTimezoneOffset(), h)));
    }), by = (zu = Sp, yn(function(n) {
        n(kn(zu(Date.now())));
    })), vy = A3(Du, cp, dy, by), my = b({
        bR: Ht(ly),
        bS: !1,
        aK: Rt,
        aN: !1,
        fd: 0,
        wJ: ly
    }, A2(Eu, sy, vy)), py = function(n) {
        var r = my.b;
        return b({
            g0: Rt,
            oD: Rt,
            bN: my.a,
            j7: !1,
            qU: n,
            zZ: rm(!0)
        }, Hu(k([
            A2(jp, oy, r),
            A2(Eu, fy, vy)
        ])));
    }, $y = F2(function(n, r) {
        return $(r, n);
    }), hy = k([
        "member"
    ]), gy = function(n) {
        return A2($y, k([
            "practices",
            n
        ]), hy);
    }, wy = function(n) {
        return A2($y, k([
            "catalog"
        ]), gy(n));
    }, ky = F7(function(n, r, t, e, u, a, i) {
        return {
            re: t,
            t$: n,
            BS: r,
            k0: i,
            k5: e,
            k7: u,
            lr: a
        };
    }), xy = J, yy = function(n) {
        return {
            $: 1,
            a: n
        };
    }, _y = function(n) {
        switch(n){
            case "month":
                return Ht(0);
            case "quarter":
                return Ht(1);
            case "semi_annual":
                return Ht(2);
            case "annual":
                return Ht(3);
            default:
                return Rt;
        }
    }, Cy = function(n) {
        var r = _y(n);
        return r.$ ? yy("Unsupported period name: " + n) : Ke(r.a);
    }, Dy = function(n) {
        return {
            $: 5,
            c: n
        };
    }, Ay = function(n) {
        return D$(k([
            Dy(Rt),
            A2(Ye, Ht, n)
        ]));
    }, qy = Qe(Pe), By = sn, jy = F3(function(n, r, t) {
        return A2(Ge, function(e) {
            var u = A2(By, n, e);
            if (u.$) return Ke(t);
            var a = u.a, i = A2(By, D$(k([
                r,
                Dy(t)
            ])), a);
            return i.$ ? yy(ye(i.a)) : Ke(i.a);
        }, v$);
    }), Sy = F4(function(n, r, t, e) {
        return A2(qy, A3(jy, A2(Tu, n, v$), r, t), e);
    }), zy = F3(function(n, r, t) {
        return A2(qy, A2(Tu, n, r), t);
    }), Uy = A4(Sy, "price", Ay(C$), Rt, A3(zy, "total_in_cents", C$, A4(Sy, "registration_fee_in_cents", Ay(C$), Rt, A4(Sy, "recurring_amount_in_cents", Ay(C$), Rt, A3(zy, "is_default", xy, A3(zy, "period_in_months", C$, A3(zy, "period", A2(Ge, Cy, w$), Ke(ky)))))))), Ey = function(n) {
        return {
            $: 3,
            b: n
        };
    }, Py = D$(k([
        Ey(Uy),
        Dy(h)
    ])), Ty = Ay(A2(Ge, Cy, w$)), Fy = A2(Ge, function(n) {
        switch(n){
            case "plan":
                return Ke(0);
            case "package":
                return Ke(1);
            default:
                return yy("Unknown catalog type: " + n);
        }
    }, w$), Ly = A2(Ye, ru, A3(zy, "total_in_cents", C$, A3(zy, "tax_in_cents", C$, A4(Sy, "available_billing_periods", Py, h, A4(Sy, "expiration_copy", Ay(w$), Rt, A4(Sy, "billing_period", Ty, Rt, A4(Sy, "recurring_amount_in_cents", Ay(C$), Rt, A4(Sy, "registration_fee_in_cents", Ay(C$), Rt, A4(Sy, "default_period_in_months", Ay(C$), Rt, A3(zy, "price", Ay(C$), A4(Sy, "thumbnail_image_url", Ay(w$), Rt, A4(Sy, "cover_image_url", Ay(w$), Rt, A4(Sy, "description", Ay(w$), Rt, A4(Sy, "name", Ay(w$), Rt, A3(zy, "type", Fy, A3(zy, "id", w$, Ke(function(n) {
        return function(r) {
            return function(t) {
                return function(e) {
                    return function(u) {
                        return function(a) {
                            return function(i) {
                                return function(c) {
                                    return function(o) {
                                        return function(f) {
                                            return function(s) {
                                                return function(l) {
                                                    return function(d) {
                                                        return function(b) {
                                                            return function(v) {
                                                                return {
                                                                    mz: d,
                                                                    mQ: s,
                                                                    oj: u,
                                                                    oQ: c,
                                                                    oV: e,
                                                                    pX: l,
                                                                    qU: n,
                                                                    sS: t,
                                                                    k0: i,
                                                                    k5: f,
                                                                    k7: o,
                                                                    wx: b,
                                                                    wB: a,
                                                                    lr: v,
                                                                    wW: r
                                                                };
                                                            };
                                                        };
                                                    };
                                                };
                                            };
                                        };
                                    };
                                };
                            };
                        };
                    };
                };
            };
        };
    }))))))))))))))))), My = F2(function(n, r) {
        return {
            $: 5,
            a: n,
            b: r
        };
    }), Hy = {
        $: 1
    }, Ry = {
        $: 8
    }, Oy = {
        $: 4
    }, Ny = {
        $: 3
    }, Iy = {
        $: 9
    }, Vy = {
        $: 2
    }, Wy = {
        $: 0
    }, Zy = F2(function(n, r) {
        return A3(xu, Tu, r, n);
    }), Xy = F3(function(n, r, t) {
        return {
            $: 6,
            a: n,
            b: r,
            c: t
        };
    }), Gy = F3(function(n, r, t) {
        return A2(ue, r, A2(ae, n, t));
    }), Jy = function(n) {
        switch(n.$){
            case 0:
                return ye(n);
            case 1:
                var r = n.b;
                return ee(n.a) + " -> " + Jy(r);
            case 2:
                return A2(ue, "\n", A2(yu, Jy, n.a));
            default:
                var t = n.a;
                return t + "\n" + A3(Gy, t, "", A3(Gy, "  ", "", A3(Gy, "\n", "", A3(Gy, "Problem with the given value:", "", ye(n)))));
        }
    }, Yy = F3(function(n, r, t) {
        return Xt(A3(Xy, Jy(t), n, r));
    }), Qy = F2(function(n, r) {
        return {
            $: 3,
            a: n,
            b: r
        };
    }), Ky = function(n) {
        return {
            $: 0,
            a: n
        };
    }, n_ = F2(function(n, r) {
        return {
            $: 4,
            a: n,
            b: r
        };
    }), r_ = {
        $: 2
    }, t_ = function(n) {
        return {
            $: 1,
            a: n
        };
    }, e_ = function(n) {
        return {
            $: 0,
            a: n
        };
    }, u_ = {
        $: 1
    }, a_ = function(n) {
        return !n.$;
    }, i_ = Hn, c_ = F2(function(n, r) {
        return A3(Et, "", ru, A2(Je, r, n));
    }), o_ = function(n) {
        return {
            $: 2,
            a: n
        };
    }, f_ = F2(function(n, r) {
        return {
            $: 3,
            a: n,
            b: r
        };
    }), s_ = function(n) {
        if (n.$) return o_(n.a);
        var r = n.a;
        return A2(f_, r.a, r.b);
    }, l_ = function(n) {
        return D$(k([
            A2(Ye, Ht, n),
            Ke(Rt)
        ]));
    }, d_ = F3(function(n, r, t) {
        return A2(c_, A2(Je, s_, r), function(r) {
            switch(r.$){
                case 0:
                    return Xt(Hy);
                case 1:
                    return Xt(Vy);
                case 2:
                    return Xt(Ny);
                case 3:
                    var e = r.b;
                    switch((i = r.a).C7){
                        case 401:
                            return Xt(Wy);
                        case 403:
                            return Xt(Ry);
                        case 404:
                            return Xt(Iy);
                        case 500:
                        case 504:
                            return function(n) {
                                var r = A2(Hp, A2(Zy, k([
                                    "message"
                                ]), w$), n);
                                return Xt({
                                    $: 7,
                                    a: k$(r)
                                });
                            }(e);
                        case 502:
                            return Xt(Oy);
                        default:
                            var u = D$(k([
                                A2(Zy, k([
                                    "error"
                                ]), l_(w$)),
                                A2(Zy, k([
                                    "message"
                                ]), l_(w$))
                            ])), a = A2(Hp, u, e);
                            return a.$ ? A3(Yy, n, i, a.a) : Xt(A2(My, i.C7, A2(uc, "", a.a)));
                    }
                default:
                    var i = r.a, c = fu(e = r.b) ? "{}" : e, o = A2(Hp, t, c);
                    return o.$ ? A3(Yy, n, i, o.a) : Qt(b(o.a, i.hu));
            }
        });
    }), b_ = F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    }), v_ = b_, m_ = function(n) {
        return {
            $: 1,
            a: n
        };
    }, p_ = F2(function(n, r) {
        return {
            vb: n,
            wo: r
        };
    }), $_ = gu(A2(p_, oa, h)), h_ = function(n) {
        return yn(function(r) {
            var t = n.f;
            2 === t.$ && t.c && t.c(), n.f = null, r(kn(0));
        });
    }, g_ = qn, w_ = F3(function(n, r, t) {
        n: for(;;){
            if (r.b) {
                var e = r.a, u = r.b;
                if (e.$) {
                    var a = e.a;
                    return A2(_u, function(r) {
                        var e = a.Dw;
                        return A3(w_, n, u, 1 === e.$ ? t : A3(Qu, e.a, r, t));
                    }, g_(A3(zt, n, qu(n), a)));
                }
                var i = e.a, c = A2(Zu, i, t);
                if (1 === c.$) {
                    r = u;
                    continue n;
                }
                return A2(_u, function() {
                    return A3(w_, n, u, A2(aa, i, t));
                }, h_(c.a));
            }
            return gu(t);
        }
    }), k_ = F4(function(n, r, t, e) {
        return A2(_u, function(n) {
            return gu(A2(p_, n, t));
        }, A3(w_, n, r, e.vb));
    }), x_ = F4(function(n, r, t, e) {
        var u = e.b;
        return i(r, e.a) ? Ht(A2(qu, n, u(t))) : Rt;
    }), y_ = F3(function(n, r, t) {
        return A2(_u, function() {
            return gu(t);
        }, Au(A2(Ep, A3(x_, n, r.a, r.b), t.wo)));
    }), __ = F2(function(n, r) {
        if (r.$) {
            var t = r.a;
            return m_({
                xN: t.xN,
                gF: t.gF,
                zc: A2(Pt, n, t.zc),
                hu: t.hu,
                AA: t.AA,
                Do: t.Do,
                Dw: t.Dw,
                w_: t.w_
            });
        }
        return {
            $: 0,
            a: r.a
        };
    }), C_ = F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    });
    Tn.Http = Fn($_, k_, y_, __, F2(function(n, r) {
        return A2(C_, r.a, A2(Je, r.b, n));
    }));
    var D_ = Rn("Http"), A_ = (Rn("Http"), function(n) {
        return D_(m_({
            xN: !1,
            gF: n.gF,
            zc: n.zc,
            hu: n.hu,
            AA: n.AA,
            Do: n.Do,
            Dw: n.Dw,
            w_: n.w_
        }));
    }), q_ = {
        $: 0
    }, B_ = function(n) {
        return A2(Lt, "application/json", A2(te, 0, n));
    }, j_ = F4(function(n, r, t, e) {
        for(;;){
            var u = A2(r(n), t, e), a = u.a, i = u.b;
            if (i.$) return b(a, i.a);
            n = i.a, e = a;
        }
    }), S_ = F2(function(n, r) {
        return A2(j_, n, r);
    }), z_ = function(n) {
        return {
            $: 1,
            a: n
        };
    }, U_ = function(n) {
        return {
            $: 0,
            a: n
        };
    }, E_ = 63, P_ = function(n) {
        return 0 > n || n > 1114111 ? "\uFFFD" : n > 65535 ? String.fromCharCode(Math.floor((n -= 65536) / 1024) + 55296, n % 1024 + 56320) : String.fromCharCode(n);
    }, T_ = function(n) {
        if (25 >= n) return P_(65 + n);
        if (51 >= n) return P_(n - 26 + 97);
        if (61 >= n) return P_(n - 52 + 48);
        switch(n){
            case 62:
                return "+";
            case 63:
                return "/";
            default:
                return "\0";
        }
    }, F_ = F2(function(n, r) {
        var t = T_(n & E_), e = T_(n >>> 6 & E_), u = T_(n >>> 12 & E_), a = T_(n >>> 18);
        switch(r){
            case 0:
                return A2(Tb, a, A2(Tb, u, A2(Tb, e, Fb(t))));
            case 1:
                return A2(Tb, a, A2(Tb, u, A2(Tb, e, "=")));
            case 2:
                return A2(Tb, a, A2(Tb, u, "=="));
            default:
                return "";
        }
    }), L_ = F4(function(n, r, t, e) {
        var u = T_(t >>> 6 & E_), a = T_(t >>> 12 & E_), i = T_(t >>> 18), c = T_(t & E_), o = T_(n & E_), f = T_(n >>> 6 & E_), s = T_(n >>> 12 & E_), l = T_(n >>> 18), d = T_(r & E_), b = T_(r >>> 6 & E_), v = T_(r >>> 12 & E_), m = T_(r >>> 18);
        return A2(Tb, i, A2(Tb, a, A2(Tb, u, A2(Tb, c, A2(Tb, m, A2(Tb, v, A2(Tb, b, A2(Tb, d, A2(Tb, l, A2(Tb, s, A2(Tb, f, A2(Tb, o, e))))))))))));
    }), M_ = F5(function(n, r, t, e, u) {
        return A4(L_, (65535 & r) << 8 | t >>> 24, (255 & n) << 16 | r >>> 16, n >>> 8, A4(L_, (255 & e) << 16 | u, e >>> 8, 16777215 & t, ""));
    }), H_ = F6(function(n, r, t, e, u, a) {
        var i = r, c = t, o = e, f = u, s = a;
        return F2(function(r, t) {
            var e = A2(i, r, t), u = e.b, a = A2(c, r, e.a), l = a.b, d = A2(o, r, a.a), v = d.b, m = A2(f, r, d.a), p = m.b, $ = A2(s, r, m.a);
            return b($.a, A5(n, u, l, v, p, $.b));
        });
    }), R_ = Bt(!1), O_ = jt(!1), N_ = A6(H_, M_, O_, O_, O_, O_, R_), I_ = F2(function(n, r) {
        var t = r;
        return F2(function(r, e) {
            var u = A2(t, r, e);
            return b(u.a, n(u.b));
        });
    }), V_ = F3(function(n, r, t) {
        var e = r, u = t;
        return F2(function(r, t) {
            var a = A2(e, r, t), i = a.b, c = A2(u, r, a.a);
            return b(c.a, A2(n, i, c.b));
        });
    }), W_ = F4(function(n, r, t, e) {
        var u = r, a = t, i = e;
        return F2(function(r, t) {
            var e = A2(u, r, t), c = e.b, o = A2(a, r, e.a), f = o.b, s = A2(i, r, o.a);
            return b(s.a, A3(n, c, f, s.b));
        });
    }), Z_ = qt, X_ = function(n) {
        var r, t, e = n.iw, u = n.Db;
        return 18 > e ? 3 > e ? e ? 2 === e ? (t = F2(function(n, r) {
            return z_($(u, A2(F_, n << 16 | r << 8, 1)));
        }), A3(V_, t, Z_, Z_)) : A2(I_, function(n) {
            return z_($(u, A2(F_, n << 16, 2)));
        }, Z_) : (r = z_(u), F2(function(n, t) {
            return b(t, r);
        })) : A4(W_, t = F3(function(n, r, t) {
            return U_({
                iw: e - 3,
                Db: $(u, A2(F_, n << 16 | r << 8 | t, 0))
            });
        }), Z_, Z_, Z_) : A2(I_, function(n) {
            return U_({
                iw: e - 18,
                Db: $(u, n)
            });
        }, N_);
    }, G_ = F2(function(n, r) {
        return {
            $: 9,
            a: n,
            b: r
        };
    }), J_ = function(n) {
        var r, t, e;
        return r = Kp(A2(G_, function(n) {
            for(var r = 0, t = 0; n.length > t; t++){
                var e = n.charCodeAt(t);
                r += 128 > e ? 1 : 2048 > e ? 2 : 55296 > e || e > 56319 ? 3 : (t++, 4);
            }
            return r;
        }(e = n), e)), A2(Qp, (t = s$(r), A2(S_, {
            iw: t,
            Db: ""
        }, X_)), r);
    }, Y_ = function(n) {
        switch(n.$){
            case 0:
            case 4:
                return Ht(n.a);
            default:
                return Rt;
        }
    }, Q_ = function(n) {
        return n.a.i;
    }, K_ = function(n) {
        return n.a.a8;
    }, nC = F2(function(n, r) {
        return b(n, r);
    }), rC = Cp(nC("Hint-Version")), tC = function(n) {
        return n.a.aE;
    }, eC = F3(function(n, r, t) {
        for(;;){
            if (-2 === t.$) return r;
            var e = t.e, u = n, a = A3(n, t.b, t.c, A3(eC, n, r, t.d));
            n = u, r = a, t = e;
        }
    }), uC = F2(function(n, r) {
        return A3(eC, Qu, r, n);
    }), aC = F2(function(n, r) {
        return A2(uC, r.hu, function(n) {
            var r;
            return Ml(A2(Ep, ru, k([
                tC(n) ? (r = Q_(n), A2(Cp, function(n) {
                    return b("Authorization", n);
                }, function(n) {
                    return A2(Cp, function(n) {
                        return h$(n) ? "Bearer " + n : "Basic " + A2(uc, "", J_(A3(Gy, '"', "", n) + ":"));
                    }, Y_(n));
                }(r))) : Rt,
                rC(K_(n)),
                n.$ ? Rt : Ht(b("Hint-Lang", Eb(n.a.hK)))
            ])));
        }(n));
    }), iC = function(n) {
        return n.a.bw;
    }, cC = F3(function(n, r, t) {
        return n + "/" + (A2(ue, "/", r) + Bx(t));
    }), oC = Ax("_b"), fC = F2(function(n, r) {
        return $(r.iu, function(n) {
            return k([
                oC(n.bG)
            ]);
        }(n));
    }), sC = F2(function(n, r) {
        var t = r.wE;
        if (n.$) return e = n.a, A3(cC, iC(n), t, A2(fC, e, r));
        var e = n.a;
        return A3(cC, iC(n), t, A2(fC, e, r));
    }), lC = F5(function(n, r, t, e, u) {
        var a, i = A2(aC, r, u);
        return A_({
            gF: (a = u, A2(uc, q_, A2(Cp, B_, a.gF))),
            zc: A3(d_, i, e, t),
            hu: A2(yu, function(n) {
                return A2(v_, n.a, n.b);
            }, It(i)),
            AA: n,
            Do: Rt,
            Dw: Rt,
            w_: A2(sC, r, u)
        });
    }), dC = lC("get"), bC = function(n) {
        return {
            gF: Rt,
            hu: Ml(k([
                b("Accept", "application/json, text/plain, */*")
            ])),
            iu: h,
            wE: n
        };
    }, vC = F3(function(n, r, t) {
        return A4(dC, n, Ey(Ly), t, bC(wy(r)));
    }), mC = F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    }), pC = F8(function(n, r, t, e, u, a, i, c) {
        return {
            l7: t,
            o2: e,
            qU: n,
            ri: c,
            rp: u,
            kE: i,
            sS: r,
            w4: a
        };
    }), $C = F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    }), hC = function(n) {
        return {
            $: 2,
            a: n
        };
    }, gC = F2(function(n, r) {
        return {
            $: 1,
            a: n,
            b: r
        };
    }), wC = function(n) {
        var r = n;
        return function(n) {
            var t = r(n);
            return 1 === t.$ ? A2(Yv, !1, t.b) : A3(Qv, !1, t.b, t.c);
        };
    }, kC = function(n) {
        return function(r) {
            return A3(Qv, !0, n, r);
        };
    }, xC = zm, yC = A2(xC, F2(function(n) {
        return A2(uc, 0, lu(n));
    }), wm(he)), _C = A2(xC, F2(function(n) {
        return A2(uc, 0, lu(n));
    }), A2(um, A2(um, am(0), wm(he)), wm(he))), CC = A2(xC, F2(function(n) {
        return A2(uc, 0, lu(n));
    }), A2(um, A2(um, A2(um, am(0), wm(he)), wm(he)), wm(he))), DC = Om(k([
        A2(Am, A2(um, am(ru), mm("-")), Om(k([
            wC(A2(nm, kC, A2(Lm, hC, CC))),
            A2(Am, A2(Am, am($C), _C), Om(k([
                A2(Am, A2(um, am(ru), mm("-")), _C),
                am(1)
            ]))),
            A2(Am, A2(Am, A2(um, am(gC), mm("W")), _C), Om(k([
                A2(Am, A2(um, am(ru), mm("-")), yC),
                am(1)
            ])))
        ]))),
        wC(A2(nm, kC, A2(Am, A2(Am, am($C), _C), Om(k([
            _C,
            am(1)
        ]))))),
        A2(Lm, hC, CC),
        A2(Am, A2(Am, A2(um, am(gC), mm("W")), _C), Om(k([
            yC,
            am(1)
        ]))),
        am(hC(1))
    ])), AC = F3(function(n, r, t) {
        return 1 > s(n, t) && 1 > s(t, r);
    }), qC = F3(function(n, r, t) {
        return A3(AC, 1, 12, r) && A3(AC, 1, A2(wv, n, kv(r)), t) ? Qt(_v(n) + A2(ap, n, kv(r)) + t) : Xt("Invalid calendar date (" + ee(n) + ", " + ee(r) + ", " + ee(t) + ")");
    }), BC = F2(function(n, r) {
        return A3(AC, 1, 365, r) || 366 === r && gv(n) ? Qt(_v(n) + r) : Xt("Invalid ordinal date (" + ee(n) + ", " + ee(r) + ")");
    }), jC = function(n) {
        return _v(n) + 1;
    }, SC = F3(function(n, r, t) {
        var e, u;
        return A3(AC, 1, 7, t) && (A3(AC, 1, 52, r) || 53 === r && (4 === (u = Mv(jC(e = n))) || 3 === u && gv(e))) ? Qt(Hv(n) + 7 * (r - 1) + t) : Xt("Invalid week date (" + ee(n) + ", " + ee(r) + ", " + ee(t) + ")");
    }), zC = function(n) {
        var r = n.a, t = n.b;
        switch(t.$){
            case 0:
                return A3(qC, r, t.a, t.b);
            case 1:
                return A3(SC, r, t.a, t.b);
            default:
                return A2(BC, r, t.a);
        }
    }, UC = A2(xC, F2(function(n) {
        return A2(uc, 0, lu(n));
    }), A2(um, A2(um, A2(um, A2(um, A2(um, am(0), Om(k([
        wm(function(n) {
            return "-" === n;
        }),
        am(0)
    ]))), wm(he)), wm(he)), wm(he)), wm(he))), EC = function(n) {
        return n.$ ? qm(n.a) : am(n.a);
    }, PC = A2(nm, A2(Je, zC, EC), A2(Am, A2(Am, am(nC), UC), DC)), TC = A2(Je, Ym(A2(Am, am(ru), A2(um, PC, A2(nm, EC, Om(k([
        A2(Lm, Qt, Nm),
        A2(Lm, rm(Xt("Expected a date only, not a date and time")), wm(Te("T"))),
        am(Xt("Expected a date only"))
    ])))))), Xp(A2(Je, Gb, A2(Je, Cp(function(n) {
        var r = n.uw;
        return 12 === r.$ ? r.a : "Expected a date in ISO 8601 format";
    }), uc(""))))), FC = A2(Ge, A2(Je, TC, function(n) {
        return n.$ ? yy(n.a) : Ke(n.a);
    }), w$), LC = A3(zy, "name", w$, A3(zy, "id", w$, Ke(F2(function(n, r) {
        return {
            qU: n,
            sS: r
        };
    })))), MC = A2(qy, LC, Ke(ru)), HC = A3(zy, "requires_location_selection", xy, A3(zy, "requires_practitioner_selection", xy, Ke(F2(function(n, r) {
        return {
            vh: r,
            vk: n
        };
    })))), RC = A2(qy, HC, Ke(ru)), OC = function(n) {
        return n;
    }, NC = A3(zy, "member_type", A2(Ge, function(n) {
        return Ke(!n.$ && "Primary Member" === n.a);
    }, l_(w$)), A3(zy, "meta", RC, A3(zy, "uses_tobacco", l_(xy), A4(Sy, "known_practice", l_(MC), Rt, A3(zy, "dob", l_(FC), A3(zy, "age", l_(C$), A3(zy, "name", A2(Ye, OC, w$), A3(zy, "id", w$, Ke(pC))))))))), IC = A2(Je, Ke, qy), VC = A2(IC, 0, A2(qy, NC, Ke(mC))), WC = F3(function(n, r, t) {
        return A4(dC, n, Ey(VC), t, bC(function(n) {
            return A2($y, k([
                "patients"
            ]), gy(n));
        }(r)));
    }), ZC = function(n) {
        return n.qU;
    }, XC = function(n) {
        var r = n.tE;
        return 3 === r.$ ? Ht(ZC(r.a)) : Rt;
    }, GC = F6(function(n, r, t, e, u, a) {
        return {
            rm: t,
            sS: r,
            tq: e,
            BS: u,
            v4: n,
            C3: a
        };
    }), JC = A2(Ge, function(n) {
        switch(n){
            case "plan":
                return Ke(0);
            case "package":
                return Ke(1);
            default:
                return yy("Unknown catalog type: " + n);
        }
    }, w$), YC = A2(Ye, ru, A4(Sy, "start_date", Ay(w$), Rt, A4(Sy, "period_in_months", Ay(C$), Rt, A4(Sy, "owner", Ay(w$), Rt, A3(zy, "type", JC, A3(zy, "name", w$, A3(zy, "id", w$, Ke(GC)))))))), QC = A2(Tu, "items", Ey(YC)), KC = F3(function(n, r, t) {
        return A4(dC, n, QC, t, bC(A2($y, k([
            "cart"
        ]), gy(r))));
    }), nD = function(n) {
        switch(n){
            case 0:
                return "all";
            case 1:
                return "memberships";
            default:
                return "packages";
        }
    }, rD = F3(function(n, r) {
        var t = A2(cy, "additional-services-tabs", nD(0)), e = t.a, u = t.b, a = A2(ny, 0, Ex), i = a.a, c = a.b, o = py("configure-start-date"), f = o.b, s = m(o.a, {
            j7: !0
        });
        return b({
            d4: 0,
            gx: r.gx,
            bI: r.bI,
            bb: Mx,
            cn: s,
            kj: r.kj,
            dk: Rt,
            dn: Yx,
            Av: Mx,
            e1: i,
            dv: Rt,
            dw: n,
            W: Rt,
            dV: e,
            DI: XC(r)
        }, Hu(k([
            A3(vC, r.gx, $k(n), Fx),
            A3(WC, r.gx, $k(n), Lx),
            A3(KC, r.gx, $k(n), Tx),
            A2(jp, Hx, u),
            c,
            A2(jp, Px, f)
        ])));
    }), tD = F2(function(n, r) {
        return b(m(r, {
            bI: n.bI,
            DI: XC(n)
        }), Dp);
    }), eD = F2(function(n, r) {
        return m(r, {
            xE: Ht(5)
        });
    }), uD = function(n) {
        return {
            $: 13,
            a: n
        };
    }, aD = function(n) {
        return "Enter" === n ? 0 : "Escape" === n ? 1 : 2;
    }, iD = A2(Ge, function(n) {
        return "Escape" === n ? Ke(aD(n)) : yy("nothing");
    }, A2(Tu, "key", w$)), cD = function(n) {
        return A2(Ye, n, iD);
    }, oD = F3(function(n, r, t) {
        return {
            $: 0,
            a: n,
            b: r,
            c: t
        };
    }), fD = F2(function(n, r) {
        return {
            t4: r,
            wo: n
        };
    }), sD = gu(A2(fD, h, oa)), lD = function(n) {
        return b($(n.a ? "w_" : "d_", n.b), n);
    }, dD = F6(function(n, r, t, e, u, a) {
        var i = A3(eC, F3(function(e, u, a) {
            n: for(;;){
                var i = a.a, c = a.b;
                if (i.b) {
                    var o = i.a, f = o.a, l = o.b, d = i.b;
                    if (0 > s(f, e)) {
                        a = b(d, A3(n, f, l, c));
                        continue n;
                    }
                    return s(f, e) > 0 ? b(i, A3(t, e, u, c)) : b(d, A4(r, f, l, u, c));
                }
                return b(i, A3(t, e, u, c));
            }
        }), b(It(e), a), u), c = i.a, o = i.b;
        return A3(ce, F2(function(r, t) {
            return A3(n, r.a, r.b, t);
        }), o, c);
    }), bD = F2(function(n, r) {
        return {
            hi: r,
            hH: n
        };
    }), vD = F3(function(n, r, t) {
        return A2(Cu, function(n) {
            return b(r, n);
        }, A3(Gr, t.a ? Xr : Zr, t.b, function(t) {
            return A2(i_, n, A2(bD, r, t));
        }));
    }), mD = F3(function(n, r, t) {
        var e = F3(function(r, t, e) {
            var u = e.c;
            return v(e.a, e.b, A2(Ot, A3(vD, n, r, t), u));
        }), u = F3(function(n, r, t) {
            var e = t.b, u = t.c;
            return v(A2(Ot, r, t.a), e, u);
        }), a = F4(function(n, r, t, e) {
            var u = e.c;
            return v(e.a, A3(Qu, n, r, e.b), u);
        }), i = A2(yu, lD, r), c = A6(dD, u, a, e, t.t4, Ml(i), v(h, oa, h)), o = c.b, f = c.c;
        return A2(_u, function(n) {
            return gu(A2(fD, i, A2(uC, o, Ml(n))));
        }, A2(_u, function() {
            return Au(f);
        }, Au(A2(yu, h_, c.a))));
    }), pD = F3(function(n, r, t) {
        var e = r.hH, u = r.hi, a = A2(Ep, function(n) {
            var r = n.b.c;
            return i(n.a, e) ? A2(Jr, r, u) : Rt;
        }, t.wo);
        return A2(_u, function() {
            return gu(t);
        }, Au(A2(yu, qu(n), a)));
    });
    Tn["Browser.Events"] = Fn(sD, mD, pD, 0, F2(function(n, r) {
        return A3(oD, r.a, r.b, A2(Ye, n, r.c));
    }));
    var $D, hD = Rn("Browser.Events"), gD = F3(function(n, r, t) {
        return hD(A3(oD, n, r, t));
    }), wD = A2(gD, 0, "keydown"), kD = function(n) {
        return n.bC ? yk : wD(cD(function() {
            return n.AT;
        }));
    }, xD = Nn, yD = Kn("onElementScroll", A2(Ge, function(n) {
        return A2(Ge, function(r) {
            return A2(Ge, function(t) {
                return A2(Ge, function(e) {
                    return A2(Ge, function(u) {
                        return Ke({
                            mr: u,
                            mu: e,
                            yr: t,
                            Cu: r,
                            vy: n
                        });
                    }, A2(Tu, "atBottom", xy));
                }, A2(Tu, "atTop", xy));
            }, A2(Tu, "clientHeight", _$));
        }, A2(Tu, "scrollHeight", _$));
    }, A2(Tu, "scrollTop", _$))), _D = function() {
        return xk(k([
            yD(ru)
        ]));
    }, CD = function(n) {
        return {
            $: 1,
            a: n
        };
    }, DD = {
        $: 9
    }, AD = function(n) {
        return {
            $: 3,
            a: n
        };
    }, qD = function(n) {
        return {
            $: 11,
            a: n
        };
    }, BD = {
        $: 0
    }, jD = function(n) {
        return {
            $: 23,
            a: n
        };
    }, SD = function(n) {
        return {
            $: 3,
            a: n
        };
    }, zD = F2(function(n, r) {
        for(;;){
            if (!r.b) return Rt;
            var t = r.a, e = r.b;
            if (n(t)) return Ht(t);
            r = e;
        }
    }), UD = F2(function(n, r) {
        return A2(Cp, function(n) {
            return A2(Eu, ru, gu(SD(n)));
        }, A2(zD, function(r) {
            return i((0, r.b.dW)(r.a), n);
        }, r));
    }), ED = function(n) {
        return !n.b;
    }, PD = F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    }), TD = PD, FD = F2(function(n, r) {
        return ED(r) ? Dp : A2(uc, Dp, A2(Cp, jp(Hx), A2(UD, nD(n), k([
            A2(TD, 0, {
                dW: nD,
                dY: function() {
                    return ad("");
                }
            }),
            A2(TD, 1, {
                dW: nD,
                dY: function() {
                    return ad("");
                }
            }),
            A2(TD, 2, {
                dW: nD,
                dY: function() {
                    return ad("");
                }
            })
        ]))));
    }), LD = function(n) {
        return n.a.ri;
    }, MD = function(n) {
        return 3 === n.$ ? Ht(n.a) : Rt;
    }, HD = function(n) {
        return MD(n.Av);
    }, RD = F2(function(n, r) {
        return 1 === r.$ ? n(0) : r;
    }), OD = function(n) {
        return A2(Xb, function(r) {
            var t = function() {
                var t = n.DI;
                if (t.$) return Rt;
                var e = t.a;
                return Gb(A2(Tc, function(n) {
                    return i(Ox(n), e);
                }, r));
            }();
            return A2(RD, function() {
                return Gb(r);
            }, A2(RD, function() {
                return Gb(A2(Tc, LD, r));
            }, t));
        }, HD(n));
    }, ND = function(n) {
        return m(n, {
            bC: 1
        });
    }, ID = function(n) {
        return n.mz;
    }, VD = function(n) {
        return A2(Cp, function(n) {
            return n.t$;
        }, Gb(A2(Tc, function(n) {
            return n.re;
        }, ID(n))));
    }, WD = F3(function(n, r, t) {
        return {
            $: 0,
            a: n,
            b: r,
            c: t
        };
    }), ZD = {
        $: 20
    }, XD = {
        $: 17
    }, GD = {
        $: 16
    }, JD = {
        $: 14
    }, YD = function(n) {
        return n.wX;
    }, QD = YD, KD = function(n) {
        return function() {
            return n;
        };
    }, nA = F2(function(n, r) {
        return {
            $: 1,
            a: n,
            b: r
        };
    }), rA = function(n) {
        return A2(nA, 1, n);
    }, tA = function(n) {
        var r = function() {
            switch(n.$){
                case 7:
                    return A2(uc, QD, A2(Cp, KD, r = n.a));
                case 5:
                    var r = n.b;
                    return 500 > n.a ? KD(r) : QD;
                case 6:
                    return KD(n.a);
                default:
                    return QD;
            }
        }();
        return rA(r);
    }, eA = {
        $: 4
    }, uA = F2(function(n, r) {
        return n ? function(n) {
            if (2 !== n.$) return h;
            switch(n.a.$){
                case 6:
                    var r = n.a;
                    return k([
                        A3(WD, r.a, r.b, r.c)
                    ]);
                case 9:
                    return k([
                        eA
                    ]);
                default:
                    var t = n.a;
                    return k(4 === t.$ ? [
                        ZD,
                        tA(t)
                    ] : [
                        tA(t)
                    ]);
            }
        }(r) : function(n) {
            if (2 !== n.$) return h;
            switch(n.a.$){
                case 6:
                    var r = n.a;
                    return k([
                        A3(WD, r.a, r.b, r.c),
                        GD
                    ]);
                case 0:
                    return k([
                        JD
                    ]);
                case 8:
                    return k([
                        XD
                    ]);
                case 9:
                    return k([
                        GD
                    ]);
                default:
                    var t = n.a;
                    return k(4 === t.$ ? [
                        ZD,
                        tA(t)
                    ] : [
                        tA(t)
                    ]);
            }
        }(r);
    }), aA = function(n) {
        return n.qU;
    }, iA = F2(function(n, r) {
        return A2(Wu, n, r);
    }), cA = F2(function(n, r) {
        return !A2(iA, r, n);
    }), oA = function(n) {
        return n.sS;
    }, fA = function(n) {
        return m(n, {
            bC: 0
        });
    }, sA = F2(function(n, r) {
        for(;;){
            if (!r.b) return !1;
            var t = r.b;
            if (n(r.a)) return !0;
            r = t;
        }
    }), lA = F2(function(n, r) {
        return A2(sA, function(r) {
            return i(r, n);
        }, r);
    }), dA = F2(function(n, r) {
        return A2(lA, n, r.b.p3);
    }), bA = function(n) {
        return A2(dA, "self_buy_2", n);
    }, vA = ep("yyyy-MM-dd"), mA = function(n) {
        switch(n){
            case 0:
                return 1;
            case 1:
                return 3;
            case 2:
                return 6;
            default:
                return 12;
        }
    }, pA = function(n) {
        return n.wW;
    }, $A = {
        $: 1
    }, hA = F2(function(n, r) {
        return i(n.oD, r) ? Rt : Ht({
            $: 0,
            a: r
        });
    }), gA = {
        $: 0
    }, wA = gA, kA = gn, xA = F2(function(n, r) {
        return A2(dr, n, kA(r));
    }), yA = xA("required"), _A = {
        jZ: function(n) {
            return ad(n);
        },
        nb: wA,
        eq: "elm-datepicker--",
        j0: h,
        yI: ep("yyyy-MM-dd"),
        yL: function(n) {
            switch(n){
                case 0:
                    return "Mo";
                case 1:
                    return "Tu";
                case 2:
                    return "We";
                case 3:
                    return "Th";
                case 4:
                    return "Fr";
                case 5:
                    return "Sa";
                default:
                    return "Su";
            }
        },
        hp: 6,
        zQ: k([
            yA(!1)
        ]),
        zR: h,
        ko: Rt,
        kp: Rt,
        zZ: rm(!1),
        kG: function(n) {
            switch(n){
                case 0:
                    return "January";
                case 1:
                    return "February";
                case 2:
                    return "March";
                case 3:
                    return "April";
                case 4:
                    return "May";
                case 5:
                    return "June";
                case 6:
                    return "July";
                case 7:
                    return "August";
                case 8:
                    return "September";
                case 9:
                    return "October";
                case 10:
                    return "November";
                default:
                    return "December";
            }
        },
        BF: TC,
        BU: "Please pick a date...",
        xn: ee
    }, CA = function(n) {
        switch(n){
            case 0:
                return "Mon";
            case 1:
                return "Tue";
            case 2:
                return "Wed";
            case 3:
                return "Thu";
            case 4:
                return "Fri";
            case 5:
                return "Sat";
            default:
                return "Sun";
        }
    }, DA = F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    }), AA = function(n) {
        return A2(DA, 0, n);
    }, qA = {
        $: 1
    }, BA = {
        $: 2
    }, jA = F2(function(n, r) {
        var t = n.jT;
        return i(r, n.j9) ? BA : i(r, t) ? qA : {
            $: 0,
            a: r
        };
    }), SA = F2(function(n, r) {
        return A2(yu, jA(n), jm(r));
    }), zA = F2(function(n, r) {
        return A2(SA, n, r);
    })({
        jT: "*",
        j9: "#"
    }), UA = function(n) {
        var r = Fb(n.b);
        return A2(ue, r, k([
            "MM",
            "dd",
            "yyyy"
        ]));
    }, EA = function(n) {
        return lv(UA(n));
    }, PA = function(n) {
        var r = n.b;
        return zA(A2(d$, function(n) {
            return i(n, r) ? n : "#";
        }, EA(A2(DA, n.a, r))));
    }, TA = F2(function(n, r) {
        var t = b(n, r);
        if (!t.b.b) return "";
        if (!t.a.b) {
            var e = t.b;
            return f = e.b, (u = e.a).$ ? "" : $(Fb(u.a), A2(TA, n, f));
        }
        var u, a = t.a, i = a.a, c = a.b, o = t.b, f = o.b;
        switch((u = o.a).$){
            case 2:
                return A2(uc, "", A2(Cp, function(n) {
                    return $(ee(n), A2(TA, c, f));
                }, lu(Fb(i))));
            case 1:
                return $(Fb(i), A2(TA, c, f));
            default:
                return $(Fb(u.a), A2(TA, n, f));
        }
    }), FA = F2(function(n, r) {
        var t = n;
        return fu(r) ? "" : A2(TA, jm(r), t);
    }), LA = F3(function(n, r, t) {
        for(;;){
            var e = A2(Re, Ce, n), u = e.a, a = e.b;
            if (0 > s(Le(u), Ce)) return A2(Ve, !0, {
                L: r,
                C: t,
                H: u
            });
            n = a, r = A2(Ot, Ue(u), r), t += 1;
        }
    }), MA = 4294967295 >>> 32 - je, HA = u, RA = F3(function(n, r, t) {
        for(;;){
            var e = A2(HA, MA & r >>> n, t);
            if (e.$) return A2(HA, MA & r, e.a);
            n -= je, t = e.a;
        }
    }), OA = F2(function(n, r) {
        var t = r.a, e = r.b, u = r.c, a = r.d;
        return 0 > n || s(n, t) > -1 ? Rt : s(n, function(n) {
            return n >>> 5 << 5;
        }(t)) > -1 ? Ht(A2(HA, MA & n, a)) : Ht(A3(RA, e, n, u));
    }), NA = k([
        0,
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8,
        9,
        10,
        11
    ]), IA = function(n) {
        var r;
        return A2(OA, n - 1, (r = NA).b ? A3(LA, r, h, 0) : Se);
    }, VA = F3(function(n, r, t) {
        return {
            oH: r,
            sN: n,
            xm: t
        };
    }), WA = F2(function(n, r) {
        return i(au(r), n) ? am(r) : qm("Date part is invalid.");
    }), ZA = function(n) {
        return A2(nm, WA(n), Um(_m(he)));
    }, XA = vm, GA = function(n) {
        return XA(A2(im, n, {
            $: 8,
            a: n
        }));
    }, JA = F2(function(n, r) {
        var t, e = (t = Fb(n.b), A2(Am, A2(Am, A2(Am, am(VA), A2(um, ZA(2), GA(t))), A2(um, ZA(2), GA(t))), A2(um, ZA(4), Nm))), u = A2(Ym, e, r);
        if (u.$) return Xt("Invalid Date");
        var a = u.a;
        return function(n) {
            var r = n.sQ, t = n.oL, e = lu(n.xo), u = A2(Xb, IA, lu(r)), a = v(lu(t), u, e);
            return a.a.$ || a.b.$ || a.c.$ ? Xt("Invalid Date") : Qt(A3(ip, a.c.a, a.b.a, a.a.a));
        }({
            oL: a.oH,
            sQ: a.sN,
            xo: a.xm
        });
    }), YA = function(n) {
        var r = A2(FA, PA(AA("/")), n), t = A2(JA, AA("/"), n);
        return t.$ ? A2(JA, AA("/"), r) : Qt(t.a);
    }, QA = function(n) {
        return m(_A, {
            yI: ep("MM/dd/yyyy"),
            yL: CA,
            zQ: k([
                yA(!0)
            ]),
            zR: k([
                b("input", !0)
            ]),
            zZ: n,
            BF: YA,
            BU: "mm/dd/yyyy"
        });
    }, KA = {
        $: 1
    }, nq = function(n) {
        return {
            $: 1,
            a: n
        };
    }, rq = {
        $: 0
    }, tq = function(n) {
        return {
            $: 2,
            a: n
        };
    }, eq = F3(function(n, r, t) {
        var e = t, u = e.bS;
        switch(r.$){
            case 0:
                return b(m(e, {
                    bR: Ht(i = r.a),
                    wJ: i
                }), rq);
            case 1:
                return b(m(e, {
                    bR: Ht(i = r.a)
                }), rq);
            case 10:
                var a = r.b;
                return b(m(e, {
                    bR: Ht(i = r.a),
                    fd: a
                }), rq);
            case 9:
                return b(m(e, {
                    fd: a = r.a
                }), rq);
            case 2:
                var i = r.a;
                return b(m(e, {
                    bR: Rt,
                    aK: Rt,
                    aN: !1
                }), tq(i));
            case 3:
                var c = r.a, o = n.BF(c);
                return o.$ ? b(m(e, {
                    aK: Ht(c),
                    aN: !0
                }), rq) : b(m(e, {
                    bR: Ht(i = o.a),
                    aK: Ht(c),
                    aN: !0
                }), tq(i));
            case 4:
                if (u) return b(e, rq);
                var f = function() {
                    var r = e.aK;
                    if (1 === r.$) return nq(KA);
                    if ("" === r.a) return nq(KA);
                    var t = n.BF(r.a);
                    if (t.$) return nq(function(n) {
                        return {
                            $: 0,
                            a: n
                        };
                    }(t.a));
                    var u = t.a;
                    return n.zZ(u) ? nq({
                        $: 2,
                        a: u
                    }) : tq(u);
                }();
                return b(m(e, {
                    bR: 2 === f.$ ? Ht(f.a) : e.bR,
                    aK: 2 === f.$ ? Rt : e.aK
                }), f);
            case 5:
                return b(m(e, {
                    bS: !1,
                    aN: !0
                }), rq);
            case 6:
                return b(m(e, {
                    aN: u
                }), rq);
            case 7:
                return b(m(e, {
                    bS: !0
                }), rq);
            case 8:
                return b(m(e, {
                    bS: !1
                }), rq);
            default:
                return b(27 === r.a ? m(e, {
                    aN: !1
                }) : e, rq);
        }
    }), uq = F2(function(n, r) {
        switch(n.$){
            case 0:
                var t = n.a, e = m(r, {
                    g0: Ht(t)
                });
                return r.j7 ? v(m(e, {
                    oD: Ht(t)
                }), Dp, Ht({
                    $: 2,
                    a: t
                })) : v(e, Dp, Rt);
            case 1:
                var u = n.a, a = A3(eq, QA(r.zZ), u, r.bN), i = a.a, c = a.b, o = function() {
                    switch(c.$){
                        case 2:
                            return Ht(c.a);
                        case 1:
                            return 2 === c.a.$ ? Ht(c.a.a) : Rt;
                        default:
                            return r.oD;
                    }
                }();
                return v(m(r, {
                    oD: o,
                    bN: i
                }), Dp, A2(hA, r, o));
            case 2:
                return v(r, Dp, Ht($A));
            default:
                return v(r, Dp, Rt);
        }
    }), aq = function(n) {
        return {
            $: 1,
            a: n
        };
    }, iq = {
        $: 2
    }, cq = {
        $: 1
    }, oq = function(n) {
        return {
            $: 0,
            a: n
        };
    }, fq = function(n) {
        return m(n, {
            aN: !1
        });
    }, sq = F2(function(n, r) {
        return {
            $: 3,
            a: n,
            b: r
        };
    }), lq = Kr("focus"), dq = function(n) {
        return A2(dc, sq(n), lq(n));
    }, bq = F2(function(n, r) {
        switch(n.$){
            case 3:
                return v(r, 1 === (e = b(n.b, i(n.a, r.qU + "-item-active"))).a.$ && e.b ? dq(r.qU + "-item") : Dp, Rt);
            case 0:
                return v(m(r, {
                    aN: !r.aN
                }), dq(r.qU + "-input"), Ht(cq));
            case 1:
            case 5:
                return v(fq(r), Dp, Ht(iq));
            case 2:
                switch(n.a){
                    case 27:
                    case 38:
                        return v(fq(r), Dp, Rt);
                    case 40:
                        return v(function(n) {
                            return m(n, {
                                aN: !0
                            });
                        }(r), dq(r.qU + "-item-active"), Rt);
                    default:
                        return v(r, Dp, Rt);
                }
            case 6:
                var t = n.a;
                switch(n.b){
                    case 27:
                        return v(fq(r), dq(r.qU + "-input"), Rt);
                    case 13:
                        return v(fq(r), dq(r.qU + "-input"), Ht(oq(t)));
                    default:
                        return v(r, Dp, Rt);
                }
            default:
                return t = n.a, v(fq(r), dq(r.qU + "-input"), Ht(oq(t)));
        }
        var e;
    }), vq = F2(function(n, r) {
        var t = r;
        if (n.$) {
            var e = A2(bq, n.a, t.fx), u = e.a, a = e.b, i = e.c;
            if (i.$ || i.a.$ || i.a.a.$) return v(m(t, {
                fx: u
            }), A2(jp, aq, a), Rt);
            var c = i.a.a.a;
            return v(m(t, {
                rf: !1,
                fx: u
            }), A2(jp, aq, a), Ht(c));
        }
        return v(m(t, {
            rf: !0
        }), Dp, Rt);
    }), mq = F2(function(n, r) {
        return b(m(r, {
            fr: Ht(n)
        }), Dp);
    }), pq = F2(function(n, r) {
        var t = r;
        switch(n.$){
            case 2:
                return v((e = n.a).$ ? r : m(t, {
                    ju: e.a.jG.xl
                }), Dp, Rt);
            case 1:
                return v((e = n.a).$ ? r : m(t, {
                    jt: (u = e.a.ke).xl
                }), Dp, Rt);
            case 0:
                var e, u;
                return (e = n.a).$ ? v(r, Dp, Rt) : v(m(t, {
                    jA: (u = e.a.ke).xl,
                    jB: u.cd
                }), Dp, Ht({
                    $: 1,
                    a: t.c0
                }));
            case 3:
                var a = n.a, i = a.a, c = a.b.dW;
                return v(m(t, {
                    c0: c(i)
                }), A2(iy, t.qU, c(i)), Ht(function(n) {
                    return {
                        $: 0,
                        a: n
                    };
                }(i)));
            default:
                return v(r, Dp, Rt);
        }
    }), $q = F3(function(n, r, t) {
        return t.$ ? h : k([
            b(n, r(t.a))
        ]);
    }), hq = gn, gq = function(n) {
        var r = n;
        return vk(A2(Ot, b("id", mk(r.v4)), A2(Ot, b("type", mk(r.rm ? "package" : "plan")), A2(Ot, b("name", mk(r.sS)), $(A3($q, "owner", mk, r.tq), $(A3($q, "period_in_months", hq, r.BS), A3($q, "start_date", mk, r.C3)))))));
    }, wq = F2(function(n, r) {
        return A3(ce, function(n) {
            return F2(function(r, t) {
                return t.push(n(r)), t;
            });
        }(n), [], r);
    }), kq = lC("put"), xq = F2(function(n, r) {
        return m(r, {
            gF: Ht(n)
        });
    }), yq = F4(function(n, r, t, e) {
        var u = vk(k([
            b("items", A2(wq, gq, t))
        ]));
        return A4(kq, n, QC, e, A2(xq, u, bC(A2($y, k([
            "cart"
        ]), gy(r)))));
    }), _q = F2(function(n, r) {
        return m(r, {
            oD: Ht(n)
        });
    }), Cq = F2(function(n, r) {
        return m(r, {
            zZ: n
        });
    }), Dq = F2(function(n, r) {
        switch(n.$){
            case 0:
                switch((e = n.a).$){
                    case 3:
                        var t = e.a;
                        return v(m(r, {
                            bb: e
                        }), A2(FD, r.d4, t), h);
                    case 2:
                        switch(e.a.$){
                            case 9:
                            case 6:
                                return v(m(r, {
                                    bb: e
                                }), Dp, h);
                            default:
                                return v(m(r, {
                                    bb: e
                                }), Dp, A2(uA, 0, e));
                        }
                    default:
                        return v(m(r, {
                            bb: e
                        }), Dp, h);
                }
            case 1:
                var e = n.a, u = function() {
                    if (2 !== e.$) return h;
                    switch(e.a.$){
                        case 9:
                        case 6:
                            return h;
                        default:
                            return A2(uA, 0, e);
                    }
                }();
                return v(function(n) {
                    var r = n.W;
                    if (r.$ || 1 !== r.a.b.$) return n;
                    var t = r.a, e = t.b.a;
                    return 1 === e.cO.$ ? m(n, {
                        W: Ht(b(t.a, CD(m(e, {
                            cO: OD(n)
                        }))))
                    }) : n;
                }(m(r, {
                    Av: e
                })), Dp, u);
            case 2:
                return 3 === (e = n.a).$ ? v(m(r, {
                    bI: t = e.a
                }), Dp, k([
                    jD(t)
                ])) : v(r, Dp, h);
            case 3:
                return 3 === (e = n.a).$ ? v(m(r, {
                    bI: t = e.a,
                    dk: r.dv,
                    dv: Rt
                }), A2(Eu, function() {
                    return DD;
                }, qp(5e3)), k([
                    jD(t)
                ])) : v(m(r, {
                    dv: Rt
                }), Dp, A2(uA, 0, e));
            case 4:
                var a = A2(pq, n.a, r.dV), i = a.a, c = a.b, o = a.c;
                return v(m(r, o.$ || o.a.$ ? {
                    dV: i
                } : {
                    d4: o.a.a,
                    dV: i
                }), A2(jp, Hx, c), h);
            case 5:
                var f = n.a;
                return v(m(r, {
                    e1: fA(r.e1),
                    W: Ht(b(f, BD))
                }), Dp, h);
            case 6:
                if (f = n.a, bA(r.dw)) {
                    var s = {
                        cO: OD(r),
                        fA: VD(f)
                    }, l = py("configure-start-date"), d = l.b, p = m(l.a, {
                        j7: !0
                    });
                    return v(m(r, {
                        cn: p,
                        dn: Yx,
                        W: Ht(b(f, CD(s)))
                    }), A2(jp, Px, d), h);
                }
                var g = pA(f);
                return v(m(r, {
                    e1: ND(r.e1),
                    W: Rt
                }), A2(zx, oa, 1 === g ? La({
                    qU: aA(f)
                }) : Oa({
                    qU: aA(f)
                })), h);
            case 7:
                var w = n.a, x = r.W;
                if (x.$ || 1 !== x.a.b.$) return v(r, Dp, h);
                var y = x.a;
                return v(m(r, {
                    W: Ht(b(f = y.a, CD(m(D = y.b.a, {
                        fA: Ht(w)
                    }))))
                }), Dp, h);
            case 8:
                var _ = r.W;
                if (_.$ || 1 !== _.a.b.$) return v(r, Dp, h);
                var C = _.a, D = C.b.a, A = A2(uc, "", oA(f = C.a)), q = {
                    rm: pA(f),
                    sS: A,
                    tq: A2(Cp, Ox, D.cO),
                    BS: A2(Cp, mA, D.fA),
                    v4: aA(f),
                    C3: pA(f) ? Rt : A2(Cp, vA, r.cn.oD)
                };
                return v(m(r, {
                    e1: ND(r.e1),
                    dv: Ht(A),
                    W: Rt
                }), A4(yq, r.gx, $k(r.dw), $(r.bI, k([
                    q
                ])), AD), h);
            case 9:
                return v(m(r, {
                    dk: Rt
                }), Dp, h);
            case 10:
                return v(m(r, {
                    dk: Rt
                }), A2(zx, oa, $a), h);
            case 11:
                var B = A2(vq, n.a, r.dn), j = B.b, S = B.c, z = m(r, {
                    dn: B.a
                });
                return v(function() {
                    var n = b(S, r.W);
                    if (n.a.$ || n.b.$ || 1 !== n.b.a.b.$) return z;
                    var t = n.b.a;
                    return m(z, {
                        W: Ht(b(t.a, CD(m(t.b.a, {
                            cO: Ht(n.a.a)
                        }))))
                    });
                }(), A2(jp, qD, j), h);
            case 12:
                return v(m(r, {
                    e1: ND(r.e1),
                    W: Rt
                }), Dp, h);
            case 13:
                var U = A2(mq, n.a, r.e1), E = U.b;
                return v(m(r, {
                    e1: U.a
                }), A2(jp, uD, E), h);
            case 14:
                return v(r, Dp, h);
            default:
                var P = A2(uq, n.a, r.cn), T = P.a, F = P.b, L = P.c, M = function() {
                    if (L.$ || 2 !== L.a.$) return T;
                    var n = L.a.a;
                    return A2(Cq, cA(n), A2(_q, n, T));
                }();
                return v(m(r, {
                    cn: M
                }), A2(jp, Px, F), h);
        }
    }), Aq = function(n) {
        var r = n.bb;
        if (3 === r.$) {
            var t = r.a;
            return A2(sA, function(n) {
                return !pA(n);
            }, t) && A2(sA, function(n) {
                return 1 === pA(n);
            }, t);
        }
        return !1;
    }, qq = {
        $: 10
    }, Bq = {
        lR: function(n) {
            return n.D.lR;
        },
        lU: function(n) {
            return n.D.lU;
        },
        l9: function(n) {
            return n.D.l9;
        },
        mP: function(n) {
            return n.D.mP;
        },
        yi: function(n) {
            return n.D.yi;
        },
        nR: function(n) {
            return n.D.nR;
        },
        nS: function(n) {
            return n.D.nS;
        },
        nV: function(n) {
            return n.D.nV;
        },
        hf: function(n) {
            return n.D.hf;
        },
        Ar: function(n) {
            return n.D.Ar;
        },
        Au: function(n) {
            return n.D.Au;
        },
        $7: function(n) {
            return n.D.$7;
        },
        _: function(n) {
            return n.D._;
        },
        ia: function(n) {
            return n.D.ia;
        },
        B8: function(n) {
            return n.D.B8;
        },
        xa: function(n) {
            return n.D.xa;
        },
        DS: function(n) {
            return n.D.DS;
        }
    }, jq = ir("button"), Sq = ad(""), zq = sr, Uq = F2(function(n, r) {
        return A2(zq, n, {
            $: 0,
            a: r
        });
    }), Eq = function(n) {
        return A2(Uq, "click", Ke(n));
    }, Pq = F2(function(n, r) {
        var t = r.dk;
        if (t.$) return Sq;
        var e = t.a;
        return A2(Ik, k([
            Nk("cart-banner")
        ]), k([
            A2(Gk, h, k([
                ad(e + " " + n(Bq.lU))
            ])),
            A2(jq, k([
                Nk("cart-banner__action"),
                Eq(qq)
            ]), k([
                ad(n(Bq.xa))
            ]))
        ]));
    }), Tq = function(n) {
        return n.oV;
    }, Fq = function(n) {
        return n.wB;
    }, Lq = function(n) {
        return i(Fq(n), Rt) && i(Tq(n), Rt);
    }, Mq = function(n) {
        return Lq(n) ? "catalog-grid__item catalog-grid__item--compact" : "catalog-grid__item";
    }, Hq = F2(function(n, r) {
        switch(n){
            case 0:
                return r;
            case 1:
                return A2(Tc, function(n) {
                    return !pA(n);
                }, r);
            default:
                return A2(Tc, function(n) {
                    return 1 === pA(n);
                }, r);
        }
    }), Rq = ir("li"), Oq = ir("ul"), Nq = function(n) {
        return {
            $: 5,
            a: n
        };
    }, Iq = Ok("alt"), Vq = function(n) {
        return {
            $: 2,
            a: n
        };
    }, Wq = function(n) {
        return n.oQ;
    }, Zq = function(n) {
        return {
            $: 2,
            a: n
        };
    }, Xq = F5(function(n, r, t, e, u) {
        return {
            yM: t,
            q0: r,
            tn: n,
            is: e,
            wt: u
        };
    }), Gq = function(n) {
        return k([
            n
        ]);
    }, Jq = F, Yq = F2(function(n, r) {
        var t = au(r), e = 0 > s(t, n) ? Pv(n - t) : 0;
        return $(r, A2(Mb, e, "0"));
    }), Qq = F2(function(n, r) {
        return 1 > n ? r : A3(iu, 0, -n, r);
    }), Kq = function(n) {
        return "0" !== A2(nv, 1, n) ? n : Kq(A2(Qq, 1, n));
    }, nB = F2(function(n, r) {
        var t = n.yM;
        switch(t.$){
            case 1:
                return Kq(r);
            case 2:
                return r;
            default:
                return A2(Yq, t.a, r);
        }
    }), rB = Z, tB = F2(function(n, r) {
        var t = A2(sA, function(n) {
            return "0" !== n && "." !== n;
        }, jm(r));
        return $(n && t ? "-" : "", r);
    }), eB = function(n) {
        var r = n.a, t = n.b;
        if ("9" === r) {
            var e = ke(t);
            return 1 === e.$ ? "01" : A2(Tb, "0", eB(e.a));
        }
        var u = ve(r);
        return u >= 48 && 57 > u ? A2(Tb, P_(u + 1), t) : "0";
    }, uB = U, aB = F3(function(n, r, t) {
        return $(t, A2(Mb, n - au(t), Fb(r)));
    }), iB = function(n) {
        for(var r = n.length, t = Array(r), e = 0; r > e;){
            var u = n.charCodeAt(e);
            55296 > u || u > 56319 ? (t[r - e] = n[e], e++) : (t[r - e] = n[e + 1], t[r - ++e] = n[e - 1], e++);
        }
        return t.join("");
    }, cB = function(n) {
        var r = A2(ae, ".", n);
        return r.b ? b(r.a, r.b.b ? r.b.a : "0") : b("0", "0");
    }, oB = F3(function(n, r, t) {
        if ((e = t) === 1 / 0 || e === -1 / 0 || uB(t)) return rB(t);
        var e, u = 0 > t, a = cB(function(n) {
            var r = A2(ae, "e", rB(Pv(n)));
            if (r.b) {
                if (r.b.b) {
                    var t = r.a, e = r.b.a, u = A2(uc, 0, lu(A2(pu, "+", e) ? A2(cu, 1, e) : e)), a = cB(t), i = $(a.a, a.b), c = 0 > u ? A2(uc, "0", A2(Cp, function(n) {
                        return n.a + "." + n.b;
                    }, A2(Cp, wk(Fb), ke($(A2(Mb, Pv(u), "0"), i))))) : A3(aB, u + 1, "0", i);
                    return $(0 > n ? "-" : "", c);
                }
                return $(0 > n ? "-" : "", t = r.a);
            }
            return "";
        }(Pv(t))), i = a.a, c = a.b, o = au(i) + r, f = $(A2(Mb, 1 - o, "0"), A3(aB, o, "0", $(i, c))), l = au(f), d = A2(Me, 1, o), b = A2(n, u, A3(iu, d, l, f)), v = A3(iu, 0, d, f), m = b ? iB(A2(uc, "1", A2(Cp, eB, ke(iB(v))))) : v, p = au(m), h = "0" === m ? m : r > 0 ? 0 > s(r, au(c)) ? A3(iu, 0, p - r, m) + "." + A3(iu, p - r, p, m) : $(i + ".", A3(aB, r, "0", c)) : $(m, A2(Mb, Pv(r), "0"));
        return A2(tB, u, h);
    })(F2(function(n, r) {
        var t, e = ke(r);
        return 1 !== e.$ && ("5" === e.a.a ? "" !== e.a.b || !n : (t = ve(e.a.a)) > 53 && n || t >= 53 && !n);
    })), fB = function(n) {
        return n.b ? Ht(n.b) : Rt;
    }, sB = F2(function(n, r) {
        var t, e = function() {
            var r = n.yM;
            switch(r.$){
                case 1:
                default:
                    return oB(r.a);
                case 0:
                    return rB;
            }
        }(), u = A2(ae, ".", e(r)), a = (t = fB(u)).$ ? "" : A2(uc, "", Gb(t.a));
        return b(A2(uc, "", Gb(u)), a);
    }), lB = F2(function(n, r) {
        var t, e = A2(sB, n, r), u = function(n) {
            var r = function(n) {
                return au(n) > 3 ? A2(Ot, A2(nv, 3, n), r(A2(Qq, 3, n))) : k([
                    n
                ]);
            };
            return we(r(n));
        }(A2(Jq, he, e.a)), a = A5(Xq, r, u, A2(nB, n, e.b), "", "");
        switch(A2(ne, function(n) {
            return "0" === n;
        }, Np(A2(Xi, (t = a).q0, Gq(t.yM)))) ? 1 : 0 > t.tn ? 2 : 0){
            case 2:
                return m(a, {
                    is: n.h_,
                    wt: n.kH
                });
            case 0:
                return m(a, {
                    is: n.ud,
                    wt: n.ue
                });
            default:
                return m(a, {
                    is: n.xv,
                    wt: n.xx
                });
        }
    }), dB = F2(function(n, r) {
        return "" === r ? "" : $(n.co, r);
    }), bB = F2(function(n, r) {
        var t = dB(n), e = A2(ue, n.cV, r.q0), u = t(r.yM);
        return Np(k([
            r.is,
            e,
            u,
            r.wt
        ]));
    }), vB = F2(function(n, r) {
        return A2(bB, n, A2(lB, n, r));
    }), mB = m({
        co: ".",
        yM: {
            $: 0,
            a: 0
        },
        h_: "\u2212",
        kH: "",
        ud: "",
        ue: "",
        cV: "",
        xv: "",
        xx: ""
    }, {
        yM: Zq(2),
        cV: ","
    }), pB = F3(function(n, r, t) {
        var e = Pv(t), u = r ? "$" : "", a = 0 > t ? "-" : "", i = n ? m(mB, {
            yM: Zq(0)
        }) : mB;
        return $(a, $(u, A2(vB, i, e)));
    }), $B = F3(function(n, r, t) {
        return A3(pB, n, r, .01 * t);
    }), hB = function(n) {
        switch(n){
            case 1:
                return Ht(0);
            case 3:
                return Ht(1);
            case 6:
                return Ht(2);
            case 12:
                return Ht(3);
            default:
                return Rt;
        }
    }, gB = function(n) {
        return n.fc.mk;
    }, wB = function(n) {
        return n.fc.sR;
    }, kB = function(n) {
        return n.fc.uQ;
    }, xB = function(n) {
        return n.fc.vF;
    }, yB = F2(function(n, r) {
        return n(function() {
            switch(r){
                case 0:
                    return wB;
                case 1:
                    return kB;
                case 2:
                    return xB;
                default:
                    return gB;
            }
        }());
    }), _B = F2(function(n, r) {
        return A2(uc, n(wB), A2(Cp, yB(n), A2(Xb, hB, r)));
    }), CB = function(n) {
        return n.k0;
    }, DB = F2(function(n, r) {
        var t = CB(r);
        if (t.$) return n(Bq.nV);
        var e = A3($B, !1, !0, t.a);
        return pA(r) ? e : $(e, A2(_B, n, Wq(r)));
    }), AB = ir("img"), qB = function(n) {
        return {
            $: 1,
            a: n
        };
    }, BB = qB(1), jB = function(n) {
        return {
            $: 0,
            a: n
        };
    }, SB = jB(2), zB = function(n) {
        return {
            $: 2,
            a: n
        };
    }, UB = zB(1), EB = nx(1), PB = F2(function(n, r) {
        return A2(Gk, vx(n), A2(yu, px(hu), r));
    }), TB = function(n) {
        return A2(Ok, "src", mr(n));
    }, FB = ir("strong"), LB = F2(function(n, r) {
        return A2(FB, vx(n), A2(yu, px(hu), r));
    }), MB = F3(function(n, r, t) {
        return {
            $: 1,
            a: n,
            b: r,
            c: t
        };
    }), HB = function(n) {
        return A2(um, wm(n), _m(n));
    }, RB = function(n) {
        return " " === n || "\t" === n || "\n" === n || "\r" === n || "\f" === n || "\xa0" === n;
    }, OB = function(n) {
        return n.toLowerCase();
    }, NB = function(n) {
        return {
            $: 2,
            a: n
        };
    }, IB = mt, VB = F4(function(n, r, t, e) {
        return A2(om, sm, A4(fm, n, r, t, e));
    }), WB = function(n) {
        return function(n) {
            var r = n.a, t = n.b;
            return function(n) {
                var e = A5(IB, r, n.h3, n.vt, n.nx, n.d), u = e.a, a = e.b, c = e.c;
                return i(u, -1) ? A2(Yv, !1, A4(VB, a, c, t, n.e)) : A3(Qv, 0 > s(n.h3, u), 0, {
                    nx: c,
                    e: n.e,
                    m: n.m,
                    h3: u,
                    vt: a,
                    d: n.d
                });
            };
        }(cm(n));
    }, ZB = A2(Am, A2(um, A2(um, am(ru), mm("<!")), mm("--")), A2(um, Um(WB("--\x3e")), mm("--\x3e"))), XB = A2(Lm, NB, ZB), GB = k([
        "area",
        "base",
        "br",
        "col",
        "embed",
        "hr",
        "img",
        "input",
        "link",
        "meta",
        "param",
        "source",
        "track",
        "wbr"
    ]), JB = function(n) {
        return {
            $: 1,
            a: n
        };
    }, YB = function(n) {
        return {
            $: 0,
            a: n
        };
    }, QB = F4(function(n, r, t, e) {
        for(;;){
            var u = t(r)(e);
            if (u.$) return a = u.a, A2(Yv, n || a, u.b);
            var a = u.a, i = u.b, c = u.c;
            if (i.$) return A3(Qv, n || a, i.a, c);
            n = n || a, r = i.a, e = c;
        }
    }), KB = F2(function(n, r) {
        return function(t) {
            return A4(QB, !1, n, r, t);
        };
    }), nj = function(n) {
        return n.$ ? function(n) {
            return {
                $: 1,
                a: n
            };
        }(n.a) : function(n) {
            return {
                $: 0,
                a: n
            };
        }(n.a);
    }, rj = F2(function(n, r) {
        return A2(KB, n, function(n) {
            return A2(Lm, nj, r(n));
        });
    }), tj = function(n) {
        return A2(rj, h, function(r) {
            return Om(k([
                A2(Lm, function(n) {
                    return YB(A2(Ot, n, r));
                }, n),
                am(JB(we(r)))
            ]));
        });
    }, ej = A2(Lm, OB, Um(HB(function(n) {
        return !RB(n) && '"' !== n && "'" !== n && ">" !== n && "/" !== n && "=" !== n;
    }))), uj = wm(Te(";")), aj = Ml(k([
        b("Aacute", "\xc1"),
        b("aacute", "\xe1"),
        b("Abreve", "\u0102"),
        b("abreve", "\u0103"),
        b("ac", "\u223E"),
        b("acd", "\u223F"),
        b("acE", "\u223E\u0333"),
        b("Acirc", "\xc2"),
        b("acirc", "\xe2"),
        b("acute", "\xb4"),
        b("Acy", "\u0410"),
        b("acy", "\u0430"),
        b("AElig", "\xc6"),
        b("aelig", "\xe6"),
        b("af", "\u2061"),
        b("Afr", "\uD835\uDD04"),
        b("afr", "\uD835\uDD1E"),
        b("Agrave", "\xc0"),
        b("agrave", "\xe0"),
        b("alefsym", "\u2135"),
        b("aleph", "\u2135"),
        b("Alpha", "\u0391"),
        b("alpha", "\u03B1"),
        b("Amacr", "\u0100"),
        b("amacr", "\u0101"),
        b("amalg", "\u2A3F"),
        b("amp", "&"),
        b("AMP", "&"),
        b("andand", "\u2A55"),
        b("And", "\u2A53"),
        b("and", "\u2227"),
        b("andd", "\u2A5C"),
        b("andslope", "\u2A58"),
        b("andv", "\u2A5A"),
        b("ang", "\u2220"),
        b("ange", "\u29A4"),
        b("angle", "\u2220"),
        b("angmsdaa", "\u29A8"),
        b("angmsdab", "\u29A9"),
        b("angmsdac", "\u29AA"),
        b("angmsdad", "\u29AB"),
        b("angmsdae", "\u29AC"),
        b("angmsdaf", "\u29AD"),
        b("angmsdag", "\u29AE"),
        b("angmsdah", "\u29AF"),
        b("angmsd", "\u2221"),
        b("angrt", "\u221F"),
        b("angrtvb", "\u22BE"),
        b("angrtvbd", "\u299D"),
        b("angsph", "\u2222"),
        b("angst", "\xc5"),
        b("angzarr", "\u237C"),
        b("Aogon", "\u0104"),
        b("aogon", "\u0105"),
        b("Aopf", "\uD835\uDD38"),
        b("aopf", "\uD835\uDD52"),
        b("apacir", "\u2A6F"),
        b("ap", "\u2248"),
        b("apE", "\u2A70"),
        b("ape", "\u224A"),
        b("apid", "\u224B"),
        b("apos", "'"),
        b("ApplyFunction", "\u2061"),
        b("approx", "\u2248"),
        b("approxeq", "\u224A"),
        b("Aring", "\xc5"),
        b("aring", "\xe5"),
        b("Ascr", "\uD835\uDC9C"),
        b("ascr", "\uD835\uDCB6"),
        b("Assign", "\u2254"),
        b("ast", "*"),
        b("asymp", "\u2248"),
        b("asympeq", "\u224D"),
        b("Atilde", "\xc3"),
        b("atilde", "\xe3"),
        b("Auml", "\xc4"),
        b("auml", "\xe4"),
        b("awconint", "\u2233"),
        b("awint", "\u2A11"),
        b("backcong", "\u224C"),
        b("backepsilon", "\u03F6"),
        b("backprime", "\u2035"),
        b("backsim", "\u223D"),
        b("backsimeq", "\u22CD"),
        b("Backslash", "\u2216"),
        b("Barv", "\u2AE7"),
        b("barvee", "\u22BD"),
        b("barwed", "\u2305"),
        b("Barwed", "\u2306"),
        b("barwedge", "\u2305"),
        b("bbrk", "\u23B5"),
        b("bbrktbrk", "\u23B6"),
        b("bcong", "\u224C"),
        b("Bcy", "\u0411"),
        b("bcy", "\u0431"),
        b("bdquo", "\u201E"),
        b("becaus", "\u2235"),
        b("because", "\u2235"),
        b("Because", "\u2235"),
        b("bemptyv", "\u29B0"),
        b("bepsi", "\u03F6"),
        b("bernou", "\u212C"),
        b("Bernoullis", "\u212C"),
        b("Beta", "\u0392"),
        b("beta", "\u03B2"),
        b("beth", "\u2136"),
        b("between", "\u226C"),
        b("Bfr", "\uD835\uDD05"),
        b("bfr", "\uD835\uDD1F"),
        b("bigcap", "\u22C2"),
        b("bigcirc", "\u25EF"),
        b("bigcup", "\u22C3"),
        b("bigodot", "\u2A00"),
        b("bigoplus", "\u2A01"),
        b("bigotimes", "\u2A02"),
        b("bigsqcup", "\u2A06"),
        b("bigstar", "\u2605"),
        b("bigtriangledown", "\u25BD"),
        b("bigtriangleup", "\u25B3"),
        b("biguplus", "\u2A04"),
        b("bigvee", "\u22C1"),
        b("bigwedge", "\u22C0"),
        b("bkarow", "\u290D"),
        b("blacklozenge", "\u29EB"),
        b("blacksquare", "\u25AA"),
        b("blacktriangle", "\u25B4"),
        b("blacktriangledown", "\u25BE"),
        b("blacktriangleleft", "\u25C2"),
        b("blacktriangleright", "\u25B8"),
        b("blank", "\u2423"),
        b("blk12", "\u2592"),
        b("blk14", "\u2591"),
        b("blk34", "\u2593"),
        b("block", "\u2588"),
        b("bne", "=\u20E5"),
        b("bnequiv", "\u2261\u20E5"),
        b("bNot", "\u2AED"),
        b("bnot", "\u2310"),
        b("Bopf", "\uD835\uDD39"),
        b("bopf", "\uD835\uDD53"),
        b("bot", "\u22A5"),
        b("bottom", "\u22A5"),
        b("bowtie", "\u22C8"),
        b("boxbox", "\u29C9"),
        b("boxdl", "\u2510"),
        b("boxdL", "\u2555"),
        b("boxDl", "\u2556"),
        b("boxDL", "\u2557"),
        b("boxdr", "\u250C"),
        b("boxdR", "\u2552"),
        b("boxDr", "\u2553"),
        b("boxDR", "\u2554"),
        b("boxh", "\u2500"),
        b("boxH", "\u2550"),
        b("boxhd", "\u252C"),
        b("boxHd", "\u2564"),
        b("boxhD", "\u2565"),
        b("boxHD", "\u2566"),
        b("boxhu", "\u2534"),
        b("boxHu", "\u2567"),
        b("boxhU", "\u2568"),
        b("boxHU", "\u2569"),
        b("boxminus", "\u229F"),
        b("boxplus", "\u229E"),
        b("boxtimes", "\u22A0"),
        b("boxul", "\u2518"),
        b("boxuL", "\u255B"),
        b("boxUl", "\u255C"),
        b("boxUL", "\u255D"),
        b("boxur", "\u2514"),
        b("boxuR", "\u2558"),
        b("boxUr", "\u2559"),
        b("boxUR", "\u255A"),
        b("boxv", "\u2502"),
        b("boxV", "\u2551"),
        b("boxvh", "\u253C"),
        b("boxvH", "\u256A"),
        b("boxVh", "\u256B"),
        b("boxVH", "\u256C"),
        b("boxvl", "\u2524"),
        b("boxvL", "\u2561"),
        b("boxVl", "\u2562"),
        b("boxVL", "\u2563"),
        b("boxvr", "\u251C"),
        b("boxvR", "\u255E"),
        b("boxVr", "\u255F"),
        b("boxVR", "\u2560"),
        b("bprime", "\u2035"),
        b("breve", "\u02D8"),
        b("Breve", "\u02D8"),
        b("brvbar", "\xa6"),
        b("bscr", "\uD835\uDCB7"),
        b("Bscr", "\u212C"),
        b("bsemi", "\u204F"),
        b("bsim", "\u223D"),
        b("bsime", "\u22CD"),
        b("bsolb", "\u29C5"),
        b("bsol", "\\"),
        b("bsolhsub", "\u27C8"),
        b("bull", "\u2022"),
        b("bullet", "\u2022"),
        b("bump", "\u224E"),
        b("bumpE", "\u2AAE"),
        b("bumpe", "\u224F"),
        b("Bumpeq", "\u224E"),
        b("bumpeq", "\u224F"),
        b("Cacute", "\u0106"),
        b("cacute", "\u0107"),
        b("capand", "\u2A44"),
        b("capbrcup", "\u2A49"),
        b("capcap", "\u2A4B"),
        b("cap", "\u2229"),
        b("Cap", "\u22D2"),
        b("capcup", "\u2A47"),
        b("capdot", "\u2A40"),
        b("CapitalDifferentialD", "\u2145"),
        b("caps", "\u2229\uFE00"),
        b("caret", "\u2041"),
        b("caron", "\u02C7"),
        b("Cayleys", "\u212D"),
        b("ccaps", "\u2A4D"),
        b("Ccaron", "\u010C"),
        b("ccaron", "\u010D"),
        b("Ccedil", "\xc7"),
        b("ccedil", "\xe7"),
        b("Ccirc", "\u0108"),
        b("ccirc", "\u0109"),
        b("Cconint", "\u2230"),
        b("ccups", "\u2A4C"),
        b("ccupssm", "\u2A50"),
        b("Cdot", "\u010A"),
        b("cdot", "\u010B"),
        b("cedil", "\xb8"),
        b("Cedilla", "\xb8"),
        b("cemptyv", "\u29B2"),
        b("cent", "\xa2"),
        b("centerdot", "\xb7"),
        b("CenterDot", "\xb7"),
        b("cfr", "\uD835\uDD20"),
        b("Cfr", "\u212D"),
        b("CHcy", "\u0427"),
        b("chcy", "\u0447"),
        b("check", "\u2713"),
        b("checkmark", "\u2713"),
        b("Chi", "\u03A7"),
        b("chi", "\u03C7"),
        b("circ", "\u02C6"),
        b("circeq", "\u2257"),
        b("circlearrowleft", "\u21BA"),
        b("circlearrowright", "\u21BB"),
        b("circledast", "\u229B"),
        b("circledcirc", "\u229A"),
        b("circleddash", "\u229D"),
        b("CircleDot", "\u2299"),
        b("circledR", "\xae"),
        b("circledS", "\u24C8"),
        b("CircleMinus", "\u2296"),
        b("CirclePlus", "\u2295"),
        b("CircleTimes", "\u2297"),
        b("cir", "\u25CB"),
        b("cirE", "\u29C3"),
        b("cire", "\u2257"),
        b("cirfnint", "\u2A10"),
        b("cirmid", "\u2AEF"),
        b("cirscir", "\u29C2"),
        b("ClockwiseContourIntegral", "\u2232"),
        b("CloseCurlyDoubleQuote", "\u201D"),
        b("CloseCurlyQuote", "\u2019"),
        b("clubs", "\u2663"),
        b("clubsuit", "\u2663"),
        b("colon", ":"),
        b("Colon", "\u2237"),
        b("Colone", "\u2A74"),
        b("colone", "\u2254"),
        b("coloneq", "\u2254"),
        b("comma", ","),
        b("commat", "@"),
        b("comp", "\u2201"),
        b("compfn", "\u2218"),
        b("complement", "\u2201"),
        b("complexes", "\u2102"),
        b("cong", "\u2245"),
        b("congdot", "\u2A6D"),
        b("Congruent", "\u2261"),
        b("conint", "\u222E"),
        b("Conint", "\u222F"),
        b("ContourIntegral", "\u222E"),
        b("copf", "\uD835\uDD54"),
        b("Copf", "\u2102"),
        b("coprod", "\u2210"),
        b("Coproduct", "\u2210"),
        b("copy", "\xa9"),
        b("COPY", "\xa9"),
        b("copysr", "\u2117"),
        b("CounterClockwiseContourIntegral", "\u2233"),
        b("crarr", "\u21B5"),
        b("cross", "\u2717"),
        b("Cross", "\u2A2F"),
        b("Cscr", "\uD835\uDC9E"),
        b("cscr", "\uD835\uDCB8"),
        b("csub", "\u2ACF"),
        b("csube", "\u2AD1"),
        b("csup", "\u2AD0"),
        b("csupe", "\u2AD2"),
        b("ctdot", "\u22EF"),
        b("cudarrl", "\u2938"),
        b("cudarrr", "\u2935"),
        b("cuepr", "\u22DE"),
        b("cuesc", "\u22DF"),
        b("cularr", "\u21B6"),
        b("cularrp", "\u293D"),
        b("cupbrcap", "\u2A48"),
        b("cupcap", "\u2A46"),
        b("CupCap", "\u224D"),
        b("cup", "\u222A"),
        b("Cup", "\u22D3"),
        b("cupcup", "\u2A4A"),
        b("cupdot", "\u228D"),
        b("cupor", "\u2A45"),
        b("cups", "\u222A\uFE00"),
        b("curarr", "\u21B7"),
        b("curarrm", "\u293C"),
        b("curlyeqprec", "\u22DE"),
        b("curlyeqsucc", "\u22DF"),
        b("curlyvee", "\u22CE"),
        b("curlywedge", "\u22CF"),
        b("curren", "\xa4"),
        b("curvearrowleft", "\u21B6"),
        b("curvearrowright", "\u21B7"),
        b("cuvee", "\u22CE"),
        b("cuwed", "\u22CF"),
        b("cwconint", "\u2232"),
        b("cwint", "\u2231"),
        b("cylcty", "\u232D"),
        b("dagger", "\u2020"),
        b("Dagger", "\u2021"),
        b("daleth", "\u2138"),
        b("darr", "\u2193"),
        b("Darr", "\u21A1"),
        b("dArr", "\u21D3"),
        b("dash", "\u2010"),
        b("Dashv", "\u2AE4"),
        b("dashv", "\u22A3"),
        b("dbkarow", "\u290F"),
        b("dblac", "\u02DD"),
        b("Dcaron", "\u010E"),
        b("dcaron", "\u010F"),
        b("Dcy", "\u0414"),
        b("dcy", "\u0434"),
        b("ddagger", "\u2021"),
        b("ddarr", "\u21CA"),
        b("DD", "\u2145"),
        b("dd", "\u2146"),
        b("DDotrahd", "\u2911"),
        b("ddotseq", "\u2A77"),
        b("deg", "\xb0"),
        b("Del", "\u2207"),
        b("Delta", "\u0394"),
        b("delta", "\u03B4"),
        b("demptyv", "\u29B1"),
        b("dfisht", "\u297F"),
        b("Dfr", "\uD835\uDD07"),
        b("dfr", "\uD835\uDD21"),
        b("dHar", "\u2965"),
        b("dharl", "\u21C3"),
        b("dharr", "\u21C2"),
        b("DiacriticalAcute", "\xb4"),
        b("DiacriticalDot", "\u02D9"),
        b("DiacriticalDoubleAcute", "\u02DD"),
        b("DiacriticalGrave", "`"),
        b("DiacriticalTilde", "\u02DC"),
        b("diam", "\u22C4"),
        b("diamond", "\u22C4"),
        b("Diamond", "\u22C4"),
        b("diamondsuit", "\u2666"),
        b("diams", "\u2666"),
        b("die", "\xa8"),
        b("DifferentialD", "\u2146"),
        b("digamma", "\u03DD"),
        b("disin", "\u22F2"),
        b("div", "\xf7"),
        b("divide", "\xf7"),
        b("divideontimes", "\u22C7"),
        b("divonx", "\u22C7"),
        b("DJcy", "\u0402"),
        b("djcy", "\u0452"),
        b("dlcorn", "\u231E"),
        b("dlcrop", "\u230D"),
        b("dollar", "$"),
        b("Dopf", "\uD835\uDD3B"),
        b("dopf", "\uD835\uDD55"),
        b("Dot", "\xa8"),
        b("dot", "\u02D9"),
        b("DotDot", "\u20DC"),
        b("doteq", "\u2250"),
        b("doteqdot", "\u2251"),
        b("DotEqual", "\u2250"),
        b("dotminus", "\u2238"),
        b("dotplus", "\u2214"),
        b("dotsquare", "\u22A1"),
        b("doublebarwedge", "\u2306"),
        b("DoubleContourIntegral", "\u222F"),
        b("DoubleDot", "\xa8"),
        b("DoubleDownArrow", "\u21D3"),
        b("DoubleLeftArrow", "\u21D0"),
        b("DoubleLeftRightArrow", "\u21D4"),
        b("DoubleLeftTee", "\u2AE4"),
        b("DoubleLongLeftArrow", "\u27F8"),
        b("DoubleLongLeftRightArrow", "\u27FA"),
        b("DoubleLongRightArrow", "\u27F9"),
        b("DoubleRightArrow", "\u21D2"),
        b("DoubleRightTee", "\u22A8"),
        b("DoubleUpArrow", "\u21D1"),
        b("DoubleUpDownArrow", "\u21D5"),
        b("DoubleVerticalBar", "\u2225"),
        b("DownArrowBar", "\u2913"),
        b("downarrow", "\u2193"),
        b("DownArrow", "\u2193"),
        b("Downarrow", "\u21D3"),
        b("DownArrowUpArrow", "\u21F5"),
        b("DownBreve", "\u0311"),
        b("downdownarrows", "\u21CA"),
        b("downharpoonleft", "\u21C3"),
        b("downharpoonright", "\u21C2"),
        b("DownLeftRightVector", "\u2950"),
        b("DownLeftTeeVector", "\u295E"),
        b("DownLeftVectorBar", "\u2956"),
        b("DownLeftVector", "\u21BD"),
        b("DownRightTeeVector", "\u295F"),
        b("DownRightVectorBar", "\u2957"),
        b("DownRightVector", "\u21C1"),
        b("DownTeeArrow", "\u21A7"),
        b("DownTee", "\u22A4"),
        b("drbkarow", "\u2910"),
        b("drcorn", "\u231F"),
        b("drcrop", "\u230C"),
        b("Dscr", "\uD835\uDC9F"),
        b("dscr", "\uD835\uDCB9"),
        b("DScy", "\u0405"),
        b("dscy", "\u0455"),
        b("dsol", "\u29F6"),
        b("Dstrok", "\u0110"),
        b("dstrok", "\u0111"),
        b("dtdot", "\u22F1"),
        b("dtri", "\u25BF"),
        b("dtrif", "\u25BE"),
        b("duarr", "\u21F5"),
        b("duhar", "\u296F"),
        b("dwangle", "\u29A6"),
        b("DZcy", "\u040F"),
        b("dzcy", "\u045F"),
        b("dzigrarr", "\u27FF"),
        b("Eacute", "\xc9"),
        b("eacute", "\xe9"),
        b("easter", "\u2A6E"),
        b("Ecaron", "\u011A"),
        b("ecaron", "\u011B"),
        b("Ecirc", "\xca"),
        b("ecirc", "\xea"),
        b("ecir", "\u2256"),
        b("ecolon", "\u2255"),
        b("Ecy", "\u042D"),
        b("ecy", "\u044D"),
        b("eDDot", "\u2A77"),
        b("Edot", "\u0116"),
        b("edot", "\u0117"),
        b("eDot", "\u2251"),
        b("ee", "\u2147"),
        b("efDot", "\u2252"),
        b("Efr", "\uD835\uDD08"),
        b("efr", "\uD835\uDD22"),
        b("eg", "\u2A9A"),
        b("Egrave", "\xc8"),
        b("egrave", "\xe8"),
        b("egs", "\u2A96"),
        b("egsdot", "\u2A98"),
        b("el", "\u2A99"),
        b("Element", "\u2208"),
        b("elinters", "\u23E7"),
        b("ell", "\u2113"),
        b("els", "\u2A95"),
        b("elsdot", "\u2A97"),
        b("Emacr", "\u0112"),
        b("emacr", "\u0113"),
        b("empty", "\u2205"),
        b("emptyset", "\u2205"),
        b("EmptySmallSquare", "\u25FB"),
        b("emptyv", "\u2205"),
        b("EmptyVerySmallSquare", "\u25AB"),
        b("emsp13", "\u2004"),
        b("emsp14", "\u2005"),
        b("emsp", "\u2003"),
        b("ENG", "\u014A"),
        b("eng", "\u014B"),
        b("ensp", "\u2002"),
        b("Eogon", "\u0118"),
        b("eogon", "\u0119"),
        b("Eopf", "\uD835\uDD3C"),
        b("eopf", "\uD835\uDD56"),
        b("epar", "\u22D5"),
        b("eparsl", "\u29E3"),
        b("eplus", "\u2A71"),
        b("epsi", "\u03B5"),
        b("Epsilon", "\u0395"),
        b("epsilon", "\u03B5"),
        b("epsiv", "\u03F5"),
        b("eqcirc", "\u2256"),
        b("eqcolon", "\u2255"),
        b("eqsim", "\u2242"),
        b("eqslantgtr", "\u2A96"),
        b("eqslantless", "\u2A95"),
        b("Equal", "\u2A75"),
        b("equals", "="),
        b("EqualTilde", "\u2242"),
        b("equest", "\u225F"),
        b("Equilibrium", "\u21CC"),
        b("equiv", "\u2261"),
        b("equivDD", "\u2A78"),
        b("eqvparsl", "\u29E5"),
        b("erarr", "\u2971"),
        b("erDot", "\u2253"),
        b("escr", "\u212F"),
        b("Escr", "\u2130"),
        b("esdot", "\u2250"),
        b("Esim", "\u2A73"),
        b("esim", "\u2242"),
        b("Eta", "\u0397"),
        b("eta", "\u03B7"),
        b("ETH", "\xd0"),
        b("eth", "\xf0"),
        b("Euml", "\xcb"),
        b("euml", "\xeb"),
        b("euro", "\u20AC"),
        b("excl", "!"),
        b("exist", "\u2203"),
        b("Exists", "\u2203"),
        b("expectation", "\u2130"),
        b("exponentiale", "\u2147"),
        b("ExponentialE", "\u2147"),
        b("fallingdotseq", "\u2252"),
        b("Fcy", "\u0424"),
        b("fcy", "\u0444"),
        b("female", "\u2640"),
        b("ffilig", "\uFB03"),
        b("fflig", "\uFB00"),
        b("ffllig", "\uFB04"),
        b("Ffr", "\uD835\uDD09"),
        b("ffr", "\uD835\uDD23"),
        b("filig", "\uFB01"),
        b("FilledSmallSquare", "\u25FC"),
        b("FilledVerySmallSquare", "\u25AA"),
        b("fjlig", "fj"),
        b("flat", "\u266D"),
        b("fllig", "\uFB02"),
        b("fltns", "\u25B1"),
        b("fnof", "\u0192"),
        b("Fopf", "\uD835\uDD3D"),
        b("fopf", "\uD835\uDD57"),
        b("forall", "\u2200"),
        b("ForAll", "\u2200"),
        b("fork", "\u22D4"),
        b("forkv", "\u2AD9"),
        b("Fouriertrf", "\u2131"),
        b("fpartint", "\u2A0D"),
        b("frac12", "\xbd"),
        b("frac13", "\u2153"),
        b("frac14", "\xbc"),
        b("frac15", "\u2155"),
        b("frac16", "\u2159"),
        b("frac18", "\u215B"),
        b("frac23", "\u2154"),
        b("frac25", "\u2156"),
        b("frac34", "\xbe"),
        b("frac35", "\u2157"),
        b("frac38", "\u215C"),
        b("frac45", "\u2158"),
        b("frac56", "\u215A"),
        b("frac58", "\u215D"),
        b("frac78", "\u215E"),
        b("frasl", "\u2044"),
        b("frown", "\u2322"),
        b("fscr", "\uD835\uDCBB"),
        b("Fscr", "\u2131"),
        b("gacute", "\u01F5"),
        b("Gamma", "\u0393"),
        b("gamma", "\u03B3"),
        b("Gammad", "\u03DC"),
        b("gammad", "\u03DD"),
        b("gap", "\u2A86"),
        b("Gbreve", "\u011E"),
        b("gbreve", "\u011F"),
        b("Gcedil", "\u0122"),
        b("Gcirc", "\u011C"),
        b("gcirc", "\u011D"),
        b("Gcy", "\u0413"),
        b("gcy", "\u0433"),
        b("Gdot", "\u0120"),
        b("gdot", "\u0121"),
        b("ge", "\u2265"),
        b("gE", "\u2267"),
        b("gEl", "\u2A8C"),
        b("gel", "\u22DB"),
        b("geq", "\u2265"),
        b("geqq", "\u2267"),
        b("geqslant", "\u2A7E"),
        b("gescc", "\u2AA9"),
        b("ges", "\u2A7E"),
        b("gesdot", "\u2A80"),
        b("gesdoto", "\u2A82"),
        b("gesdotol", "\u2A84"),
        b("gesl", "\u22DB\uFE00"),
        b("gesles", "\u2A94"),
        b("Gfr", "\uD835\uDD0A"),
        b("gfr", "\uD835\uDD24"),
        b("gg", "\u226B"),
        b("Gg", "\u22D9"),
        b("ggg", "\u22D9"),
        b("gimel", "\u2137"),
        b("GJcy", "\u0403"),
        b("gjcy", "\u0453"),
        b("gla", "\u2AA5"),
        b("gl", "\u2277"),
        b("glE", "\u2A92"),
        b("glj", "\u2AA4"),
        b("gnap", "\u2A8A"),
        b("gnapprox", "\u2A8A"),
        b("gne", "\u2A88"),
        b("gnE", "\u2269"),
        b("gneq", "\u2A88"),
        b("gneqq", "\u2269"),
        b("gnsim", "\u22E7"),
        b("Gopf", "\uD835\uDD3E"),
        b("gopf", "\uD835\uDD58"),
        b("grave", "`"),
        b("GreaterEqual", "\u2265"),
        b("GreaterEqualLess", "\u22DB"),
        b("GreaterFullEqual", "\u2267"),
        b("GreaterGreater", "\u2AA2"),
        b("GreaterLess", "\u2277"),
        b("GreaterSlantEqual", "\u2A7E"),
        b("GreaterTilde", "\u2273"),
        b("Gscr", "\uD835\uDCA2"),
        b("gscr", "\u210A"),
        b("gsim", "\u2273"),
        b("gsime", "\u2A8E"),
        b("gsiml", "\u2A90"),
        b("gtcc", "\u2AA7"),
        b("gtcir", "\u2A7A"),
        b("gt", ">"),
        b("GT", ">"),
        b("Gt", "\u226B"),
        b("gtdot", "\u22D7"),
        b("gtlPar", "\u2995"),
        b("gtquest", "\u2A7C"),
        b("gtrapprox", "\u2A86"),
        b("gtrarr", "\u2978"),
        b("gtrdot", "\u22D7"),
        b("gtreqless", "\u22DB"),
        b("gtreqqless", "\u2A8C"),
        b("gtrless", "\u2277"),
        b("gtrsim", "\u2273"),
        b("gvertneqq", "\u2269\uFE00"),
        b("gvnE", "\u2269\uFE00"),
        b("Hacek", "\u02C7"),
        b("hairsp", "\u200A"),
        b("half", "\xbd"),
        b("hamilt", "\u210B"),
        b("HARDcy", "\u042A"),
        b("hardcy", "\u044A"),
        b("harrcir", "\u2948"),
        b("harr", "\u2194"),
        b("hArr", "\u21D4"),
        b("harrw", "\u21AD"),
        b("Hat", "^"),
        b("hbar", "\u210F"),
        b("Hcirc", "\u0124"),
        b("hcirc", "\u0125"),
        b("hearts", "\u2665"),
        b("heartsuit", "\u2665"),
        b("hellip", "\u2026"),
        b("hercon", "\u22B9"),
        b("hfr", "\uD835\uDD25"),
        b("Hfr", "\u210C"),
        b("HilbertSpace", "\u210B"),
        b("hksearow", "\u2925"),
        b("hkswarow", "\u2926"),
        b("hoarr", "\u21FF"),
        b("homtht", "\u223B"),
        b("hookleftarrow", "\u21A9"),
        b("hookrightarrow", "\u21AA"),
        b("hopf", "\uD835\uDD59"),
        b("Hopf", "\u210D"),
        b("horbar", "\u2015"),
        b("HorizontalLine", "\u2500"),
        b("hscr", "\uD835\uDCBD"),
        b("Hscr", "\u210B"),
        b("hslash", "\u210F"),
        b("Hstrok", "\u0126"),
        b("hstrok", "\u0127"),
        b("HumpDownHump", "\u224E"),
        b("HumpEqual", "\u224F"),
        b("hybull", "\u2043"),
        b("hyphen", "\u2010"),
        b("Iacute", "\xcd"),
        b("iacute", "\xed"),
        b("ic", "\u2063"),
        b("Icirc", "\xce"),
        b("icirc", "\xee"),
        b("Icy", "\u0418"),
        b("icy", "\u0438"),
        b("Idot", "\u0130"),
        b("IEcy", "\u0415"),
        b("iecy", "\u0435"),
        b("iexcl", "\xa1"),
        b("iff", "\u21D4"),
        b("ifr", "\uD835\uDD26"),
        b("Ifr", "\u2111"),
        b("Igrave", "\xcc"),
        b("igrave", "\xec"),
        b("ii", "\u2148"),
        b("iiiint", "\u2A0C"),
        b("iiint", "\u222D"),
        b("iinfin", "\u29DC"),
        b("iiota", "\u2129"),
        b("IJlig", "\u0132"),
        b("ijlig", "\u0133"),
        b("Imacr", "\u012A"),
        b("imacr", "\u012B"),
        b("image", "\u2111"),
        b("ImaginaryI", "\u2148"),
        b("imagline", "\u2110"),
        b("imagpart", "\u2111"),
        b("imath", "\u0131"),
        b("Im", "\u2111"),
        b("imof", "\u22B7"),
        b("imped", "\u01B5"),
        b("Implies", "\u21D2"),
        b("incare", "\u2105"),
        b("in", "\u2208"),
        b("infin", "\u221E"),
        b("infintie", "\u29DD"),
        b("inodot", "\u0131"),
        b("intcal", "\u22BA"),
        b("int", "\u222B"),
        b("Int", "\u222C"),
        b("integers", "\u2124"),
        b("Integral", "\u222B"),
        b("intercal", "\u22BA"),
        b("Intersection", "\u22C2"),
        b("intlarhk", "\u2A17"),
        b("intprod", "\u2A3C"),
        b("InvisibleComma", "\u2063"),
        b("InvisibleTimes", "\u2062"),
        b("IOcy", "\u0401"),
        b("iocy", "\u0451"),
        b("Iogon", "\u012E"),
        b("iogon", "\u012F"),
        b("Iopf", "\uD835\uDD40"),
        b("iopf", "\uD835\uDD5A"),
        b("Iota", "\u0399"),
        b("iota", "\u03B9"),
        b("iprod", "\u2A3C"),
        b("iquest", "\xbf"),
        b("iscr", "\uD835\uDCBE"),
        b("Iscr", "\u2110"),
        b("isin", "\u2208"),
        b("isindot", "\u22F5"),
        b("isinE", "\u22F9"),
        b("isins", "\u22F4"),
        b("isinsv", "\u22F3"),
        b("isinv", "\u2208"),
        b("it", "\u2062"),
        b("Itilde", "\u0128"),
        b("itilde", "\u0129"),
        b("Iukcy", "\u0406"),
        b("iukcy", "\u0456"),
        b("Iuml", "\xcf"),
        b("iuml", "\xef"),
        b("Jcirc", "\u0134"),
        b("jcirc", "\u0135"),
        b("Jcy", "\u0419"),
        b("jcy", "\u0439"),
        b("Jfr", "\uD835\uDD0D"),
        b("jfr", "\uD835\uDD27"),
        b("jmath", "\u0237"),
        b("Jopf", "\uD835\uDD41"),
        b("jopf", "\uD835\uDD5B"),
        b("Jscr", "\uD835\uDCA5"),
        b("jscr", "\uD835\uDCBF"),
        b("Jsercy", "\u0408"),
        b("jsercy", "\u0458"),
        b("Jukcy", "\u0404"),
        b("jukcy", "\u0454"),
        b("Kappa", "\u039A"),
        b("kappa", "\u03BA"),
        b("kappav", "\u03F0"),
        b("Kcedil", "\u0136"),
        b("kcedil", "\u0137"),
        b("Kcy", "\u041A"),
        b("kcy", "\u043A"),
        b("Kfr", "\uD835\uDD0E"),
        b("kfr", "\uD835\uDD28"),
        b("kgreen", "\u0138"),
        b("KHcy", "\u0425"),
        b("khcy", "\u0445"),
        b("KJcy", "\u040C"),
        b("kjcy", "\u045C"),
        b("Kopf", "\uD835\uDD42"),
        b("kopf", "\uD835\uDD5C"),
        b("Kscr", "\uD835\uDCA6"),
        b("kscr", "\uD835\uDCC0"),
        b("lAarr", "\u21DA"),
        b("Lacute", "\u0139"),
        b("lacute", "\u013A"),
        b("laemptyv", "\u29B4"),
        b("lagran", "\u2112"),
        b("Lambda", "\u039B"),
        b("lambda", "\u03BB"),
        b("lang", "\u27E8"),
        b("Lang", "\u27EA"),
        b("langd", "\u2991"),
        b("langle", "\u27E8"),
        b("lap", "\u2A85"),
        b("Laplacetrf", "\u2112"),
        b("laquo", "\xab"),
        b("larrb", "\u21E4"),
        b("larrbfs", "\u291F"),
        b("larr", "\u2190"),
        b("Larr", "\u219E"),
        b("lArr", "\u21D0"),
        b("larrfs", "\u291D"),
        b("larrhk", "\u21A9"),
        b("larrlp", "\u21AB"),
        b("larrpl", "\u2939"),
        b("larrsim", "\u2973"),
        b("larrtl", "\u21A2"),
        b("latail", "\u2919"),
        b("lAtail", "\u291B"),
        b("lat", "\u2AAB"),
        b("late", "\u2AAD"),
        b("lates", "\u2AAD\uFE00"),
        b("lbarr", "\u290C"),
        b("lBarr", "\u290E"),
        b("lbbrk", "\u2772"),
        b("lbrace", "{"),
        b("lbrack", "["),
        b("lbrke", "\u298B"),
        b("lbrksld", "\u298F"),
        b("lbrkslu", "\u298D"),
        b("Lcaron", "\u013D"),
        b("lcaron", "\u013E"),
        b("Lcedil", "\u013B"),
        b("lcedil", "\u013C"),
        b("lceil", "\u2308"),
        b("lcub", "{"),
        b("Lcy", "\u041B"),
        b("lcy", "\u043B"),
        b("ldca", "\u2936"),
        b("ldquo", "\u201C"),
        b("ldquor", "\u201E"),
        b("ldrdhar", "\u2967"),
        b("ldrushar", "\u294B"),
        b("ldsh", "\u21B2"),
        b("le", "\u2264"),
        b("lE", "\u2266"),
        b("LeftAngleBracket", "\u27E8"),
        b("LeftArrowBar", "\u21E4"),
        b("leftarrow", "\u2190"),
        b("LeftArrow", "\u2190"),
        b("Leftarrow", "\u21D0"),
        b("LeftArrowRightArrow", "\u21C6"),
        b("leftarrowtail", "\u21A2"),
        b("LeftCeiling", "\u2308"),
        b("LeftDoubleBracket", "\u27E6"),
        b("LeftDownTeeVector", "\u2961"),
        b("LeftDownVectorBar", "\u2959"),
        b("LeftDownVector", "\u21C3"),
        b("LeftFloor", "\u230A"),
        b("leftharpoondown", "\u21BD"),
        b("leftharpoonup", "\u21BC"),
        b("leftleftarrows", "\u21C7"),
        b("leftrightarrow", "\u2194"),
        b("LeftRightArrow", "\u2194"),
        b("Leftrightarrow", "\u21D4"),
        b("leftrightarrows", "\u21C6"),
        b("leftrightharpoons", "\u21CB"),
        b("leftrightsquigarrow", "\u21AD"),
        b("LeftRightVector", "\u294E"),
        b("LeftTeeArrow", "\u21A4"),
        b("LeftTee", "\u22A3"),
        b("LeftTeeVector", "\u295A"),
        b("leftthreetimes", "\u22CB"),
        b("LeftTriangleBar", "\u29CF"),
        b("LeftTriangle", "\u22B2"),
        b("LeftTriangleEqual", "\u22B4"),
        b("LeftUpDownVector", "\u2951"),
        b("LeftUpTeeVector", "\u2960"),
        b("LeftUpVectorBar", "\u2958"),
        b("LeftUpVector", "\u21BF"),
        b("LeftVectorBar", "\u2952"),
        b("LeftVector", "\u21BC"),
        b("lEg", "\u2A8B"),
        b("leg", "\u22DA"),
        b("leq", "\u2264"),
        b("leqq", "\u2266"),
        b("leqslant", "\u2A7D"),
        b("lescc", "\u2AA8"),
        b("les", "\u2A7D"),
        b("lesdot", "\u2A7F"),
        b("lesdoto", "\u2A81"),
        b("lesdotor", "\u2A83"),
        b("lesg", "\u22DA\uFE00"),
        b("lesges", "\u2A93"),
        b("lessapprox", "\u2A85"),
        b("lessdot", "\u22D6"),
        b("lesseqgtr", "\u22DA"),
        b("lesseqqgtr", "\u2A8B"),
        b("LessEqualGreater", "\u22DA"),
        b("LessFullEqual", "\u2266"),
        b("LessGreater", "\u2276"),
        b("lessgtr", "\u2276"),
        b("LessLess", "\u2AA1"),
        b("lesssim", "\u2272"),
        b("LessSlantEqual", "\u2A7D"),
        b("LessTilde", "\u2272"),
        b("lfisht", "\u297C"),
        b("lfloor", "\u230A"),
        b("Lfr", "\uD835\uDD0F"),
        b("lfr", "\uD835\uDD29"),
        b("lg", "\u2276"),
        b("lgE", "\u2A91"),
        b("lHar", "\u2962"),
        b("lhard", "\u21BD"),
        b("lharu", "\u21BC"),
        b("lharul", "\u296A"),
        b("lhblk", "\u2584"),
        b("LJcy", "\u0409"),
        b("ljcy", "\u0459"),
        b("llarr", "\u21C7"),
        b("ll", "\u226A"),
        b("Ll", "\u22D8"),
        b("llcorner", "\u231E"),
        b("Lleftarrow", "\u21DA"),
        b("llhard", "\u296B"),
        b("lltri", "\u25FA"),
        b("Lmidot", "\u013F"),
        b("lmidot", "\u0140"),
        b("lmoustache", "\u23B0"),
        b("lmoust", "\u23B0"),
        b("lnap", "\u2A89"),
        b("lnapprox", "\u2A89"),
        b("lne", "\u2A87"),
        b("lnE", "\u2268"),
        b("lneq", "\u2A87"),
        b("lneqq", "\u2268"),
        b("lnsim", "\u22E6"),
        b("loang", "\u27EC"),
        b("loarr", "\u21FD"),
        b("lobrk", "\u27E6"),
        b("longleftarrow", "\u27F5"),
        b("LongLeftArrow", "\u27F5"),
        b("Longleftarrow", "\u27F8"),
        b("longleftrightarrow", "\u27F7"),
        b("LongLeftRightArrow", "\u27F7"),
        b("Longleftrightarrow", "\u27FA"),
        b("longmapsto", "\u27FC"),
        b("longrightarrow", "\u27F6"),
        b("LongRightArrow", "\u27F6"),
        b("Longrightarrow", "\u27F9"),
        b("looparrowleft", "\u21AB"),
        b("looparrowright", "\u21AC"),
        b("lopar", "\u2985"),
        b("Lopf", "\uD835\uDD43"),
        b("lopf", "\uD835\uDD5D"),
        b("loplus", "\u2A2D"),
        b("lotimes", "\u2A34"),
        b("lowast", "\u2217"),
        b("lowbar", "_"),
        b("LowerLeftArrow", "\u2199"),
        b("LowerRightArrow", "\u2198"),
        b("loz", "\u25CA"),
        b("lozenge", "\u25CA"),
        b("lozf", "\u29EB"),
        b("lpar", "("),
        b("lparlt", "\u2993"),
        b("lrarr", "\u21C6"),
        b("lrcorner", "\u231F"),
        b("lrhar", "\u21CB"),
        b("lrhard", "\u296D"),
        b("lrm", "\u200E"),
        b("lrtri", "\u22BF"),
        b("lsaquo", "\u2039"),
        b("lscr", "\uD835\uDCC1"),
        b("Lscr", "\u2112"),
        b("lsh", "\u21B0"),
        b("Lsh", "\u21B0"),
        b("lsim", "\u2272"),
        b("lsime", "\u2A8D"),
        b("lsimg", "\u2A8F"),
        b("lsqb", "["),
        b("lsquo", "\u2018"),
        b("lsquor", "\u201A"),
        b("Lstrok", "\u0141"),
        b("lstrok", "\u0142"),
        b("ltcc", "\u2AA6"),
        b("ltcir", "\u2A79"),
        b("lt", "<"),
        b("LT", "<"),
        b("Lt", "\u226A"),
        b("ltdot", "\u22D6"),
        b("lthree", "\u22CB"),
        b("ltimes", "\u22C9"),
        b("ltlarr", "\u2976"),
        b("ltquest", "\u2A7B"),
        b("ltri", "\u25C3"),
        b("ltrie", "\u22B4"),
        b("ltrif", "\u25C2"),
        b("ltrPar", "\u2996"),
        b("lurdshar", "\u294A"),
        b("luruhar", "\u2966"),
        b("lvertneqq", "\u2268\uFE00"),
        b("lvnE", "\u2268\uFE00"),
        b("macr", "\xaf"),
        b("male", "\u2642"),
        b("malt", "\u2720"),
        b("maltese", "\u2720"),
        b("Map", "\u2905"),
        b("map", "\u21A6"),
        b("mapsto", "\u21A6"),
        b("mapstodown", "\u21A7"),
        b("mapstoleft", "\u21A4"),
        b("mapstoup", "\u21A5"),
        b("marker", "\u25AE"),
        b("mcomma", "\u2A29"),
        b("Mcy", "\u041C"),
        b("mcy", "\u043C"),
        b("mdash", "\u2014"),
        b("mDDot", "\u223A"),
        b("measuredangle", "\u2221"),
        b("MediumSpace", "\u205F"),
        b("Mellintrf", "\u2133"),
        b("Mfr", "\uD835\uDD10"),
        b("mfr", "\uD835\uDD2A"),
        b("mho", "\u2127"),
        b("micro", "\xb5"),
        b("midast", "*"),
        b("midcir", "\u2AF0"),
        b("mid", "\u2223"),
        b("middot", "\xb7"),
        b("minusb", "\u229F"),
        b("minus", "\u2212"),
        b("minusd", "\u2238"),
        b("minusdu", "\u2A2A"),
        b("MinusPlus", "\u2213"),
        b("mlcp", "\u2ADB"),
        b("mldr", "\u2026"),
        b("mnplus", "\u2213"),
        b("models", "\u22A7"),
        b("Mopf", "\uD835\uDD44"),
        b("mopf", "\uD835\uDD5E"),
        b("mp", "\u2213"),
        b("mscr", "\uD835\uDCC2"),
        b("Mscr", "\u2133"),
        b("mstpos", "\u223E"),
        b("Mu", "\u039C"),
        b("mu", "\u03BC"),
        b("multimap", "\u22B8"),
        b("mumap", "\u22B8"),
        b("nabla", "\u2207"),
        b("Nacute", "\u0143"),
        b("nacute", "\u0144"),
        b("nang", "\u2220\u20D2"),
        b("nap", "\u2249"),
        b("napE", "\u2A70\u0338"),
        b("napid", "\u224B\u0338"),
        b("napos", "\u0149"),
        b("napprox", "\u2249"),
        b("natural", "\u266E"),
        b("naturals", "\u2115"),
        b("natur", "\u266E"),
        b("nbsp", "\xa0"),
        b("nbump", "\u224E\u0338"),
        b("nbumpe", "\u224F\u0338"),
        b("ncap", "\u2A43"),
        b("Ncaron", "\u0147"),
        b("ncaron", "\u0148"),
        b("Ncedil", "\u0145"),
        b("ncedil", "\u0146"),
        b("ncong", "\u2247"),
        b("ncongdot", "\u2A6D\u0338"),
        b("ncup", "\u2A42"),
        b("Ncy", "\u041D"),
        b("ncy", "\u043D"),
        b("ndash", "\u2013"),
        b("nearhk", "\u2924"),
        b("nearr", "\u2197"),
        b("neArr", "\u21D7"),
        b("nearrow", "\u2197"),
        b("ne", "\u2260"),
        b("nedot", "\u2250\u0338"),
        b("NegativeMediumSpace", "\u200B"),
        b("NegativeThickSpace", "\u200B"),
        b("NegativeThinSpace", "\u200B"),
        b("NegativeVeryThinSpace", "\u200B"),
        b("nequiv", "\u2262"),
        b("nesear", "\u2928"),
        b("nesim", "\u2242\u0338"),
        b("NestedGreaterGreater", "\u226B"),
        b("NestedLessLess", "\u226A"),
        b("NewLine", "\n"),
        b("nexist", "\u2204"),
        b("nexists", "\u2204"),
        b("Nfr", "\uD835\uDD11"),
        b("nfr", "\uD835\uDD2B"),
        b("ngE", "\u2267\u0338"),
        b("nge", "\u2271"),
        b("ngeq", "\u2271"),
        b("ngeqq", "\u2267\u0338"),
        b("ngeqslant", "\u2A7E\u0338"),
        b("nges", "\u2A7E\u0338"),
        b("nGg", "\u22D9\u0338"),
        b("ngsim", "\u2275"),
        b("nGt", "\u226B\u20D2"),
        b("ngt", "\u226F"),
        b("ngtr", "\u226F"),
        b("nGtv", "\u226B\u0338"),
        b("nharr", "\u21AE"),
        b("nhArr", "\u21CE"),
        b("nhpar", "\u2AF2"),
        b("ni", "\u220B"),
        b("nis", "\u22FC"),
        b("nisd", "\u22FA"),
        b("niv", "\u220B"),
        b("NJcy", "\u040A"),
        b("njcy", "\u045A"),
        b("nlarr", "\u219A"),
        b("nlArr", "\u21CD"),
        b("nldr", "\u2025"),
        b("nlE", "\u2266\u0338"),
        b("nle", "\u2270"),
        b("nleftarrow", "\u219A"),
        b("nLeftarrow", "\u21CD"),
        b("nleftrightarrow", "\u21AE"),
        b("nLeftrightarrow", "\u21CE"),
        b("nleq", "\u2270"),
        b("nleqq", "\u2266\u0338"),
        b("nleqslant", "\u2A7D\u0338"),
        b("nles", "\u2A7D\u0338"),
        b("nless", "\u226E"),
        b("nLl", "\u22D8\u0338"),
        b("nlsim", "\u2274"),
        b("nLt", "\u226A\u20D2"),
        b("nlt", "\u226E"),
        b("nltri", "\u22EA"),
        b("nltrie", "\u22EC"),
        b("nLtv", "\u226A\u0338"),
        b("nmid", "\u2224"),
        b("NoBreak", "\u2060"),
        b("NonBreakingSpace", "\xa0"),
        b("nopf", "\uD835\uDD5F"),
        b("Nopf", "\u2115"),
        b("Not", "\u2AEC"),
        b("not", "\xac"),
        b("NotCongruent", "\u2262"),
        b("NotCupCap", "\u226D"),
        b("NotDoubleVerticalBar", "\u2226"),
        b("NotElement", "\u2209"),
        b("NotEqual", "\u2260"),
        b("NotEqualTilde", "\u2242\u0338"),
        b("NotExists", "\u2204"),
        b("NotGreater", "\u226F"),
        b("NotGreaterEqual", "\u2271"),
        b("NotGreaterFullEqual", "\u2267\u0338"),
        b("NotGreaterGreater", "\u226B\u0338"),
        b("NotGreaterLess", "\u2279"),
        b("NotGreaterSlantEqual", "\u2A7E\u0338"),
        b("NotGreaterTilde", "\u2275"),
        b("NotHumpDownHump", "\u224E\u0338"),
        b("NotHumpEqual", "\u224F\u0338"),
        b("notin", "\u2209"),
        b("notindot", "\u22F5\u0338"),
        b("notinE", "\u22F9\u0338"),
        b("notinva", "\u2209"),
        b("notinvb", "\u22F7"),
        b("notinvc", "\u22F6"),
        b("NotLeftTriangleBar", "\u29CF\u0338"),
        b("NotLeftTriangle", "\u22EA"),
        b("NotLeftTriangleEqual", "\u22EC"),
        b("NotLess", "\u226E"),
        b("NotLessEqual", "\u2270"),
        b("NotLessGreater", "\u2278"),
        b("NotLessLess", "\u226A\u0338"),
        b("NotLessSlantEqual", "\u2A7D\u0338"),
        b("NotLessTilde", "\u2274"),
        b("NotNestedGreaterGreater", "\u2AA2\u0338"),
        b("NotNestedLessLess", "\u2AA1\u0338"),
        b("notni", "\u220C"),
        b("notniva", "\u220C"),
        b("notnivb", "\u22FE"),
        b("notnivc", "\u22FD"),
        b("NotPrecedes", "\u2280"),
        b("NotPrecedesEqual", "\u2AAF\u0338"),
        b("NotPrecedesSlantEqual", "\u22E0"),
        b("NotReverseElement", "\u220C"),
        b("NotRightTriangleBar", "\u29D0\u0338"),
        b("NotRightTriangle", "\u22EB"),
        b("NotRightTriangleEqual", "\u22ED"),
        b("NotSquareSubset", "\u228F\u0338"),
        b("NotSquareSubsetEqual", "\u22E2"),
        b("NotSquareSuperset", "\u2290\u0338"),
        b("NotSquareSupersetEqual", "\u22E3"),
        b("NotSubset", "\u2282\u20D2"),
        b("NotSubsetEqual", "\u2288"),
        b("NotSucceeds", "\u2281"),
        b("NotSucceedsEqual", "\u2AB0\u0338"),
        b("NotSucceedsSlantEqual", "\u22E1"),
        b("NotSucceedsTilde", "\u227F\u0338"),
        b("NotSuperset", "\u2283\u20D2"),
        b("NotSupersetEqual", "\u2289"),
        b("NotTilde", "\u2241"),
        b("NotTildeEqual", "\u2244"),
        b("NotTildeFullEqual", "\u2247"),
        b("NotTildeTilde", "\u2249"),
        b("NotVerticalBar", "\u2224"),
        b("nparallel", "\u2226"),
        b("npar", "\u2226"),
        b("nparsl", "\u2AFD\u20E5"),
        b("npart", "\u2202\u0338"),
        b("npolint", "\u2A14"),
        b("npr", "\u2280"),
        b("nprcue", "\u22E0"),
        b("nprec", "\u2280"),
        b("npreceq", "\u2AAF\u0338"),
        b("npre", "\u2AAF\u0338"),
        b("nrarrc", "\u2933\u0338"),
        b("nrarr", "\u219B"),
        b("nrArr", "\u21CF"),
        b("nrarrw", "\u219D\u0338"),
        b("nrightarrow", "\u219B"),
        b("nRightarrow", "\u21CF"),
        b("nrtri", "\u22EB"),
        b("nrtrie", "\u22ED"),
        b("nsc", "\u2281"),
        b("nsccue", "\u22E1"),
        b("nsce", "\u2AB0\u0338"),
        b("Nscr", "\uD835\uDCA9"),
        b("nscr", "\uD835\uDCC3"),
        b("nshortmid", "\u2224"),
        b("nshortparallel", "\u2226"),
        b("nsim", "\u2241"),
        b("nsime", "\u2244"),
        b("nsimeq", "\u2244"),
        b("nsmid", "\u2224"),
        b("nspar", "\u2226"),
        b("nsqsube", "\u22E2"),
        b("nsqsupe", "\u22E3"),
        b("nsub", "\u2284"),
        b("nsubE", "\u2AC5\u0338"),
        b("nsube", "\u2288"),
        b("nsubset", "\u2282\u20D2"),
        b("nsubseteq", "\u2288"),
        b("nsubseteqq", "\u2AC5\u0338"),
        b("nsucc", "\u2281"),
        b("nsucceq", "\u2AB0\u0338"),
        b("nsup", "\u2285"),
        b("nsupE", "\u2AC6\u0338"),
        b("nsupe", "\u2289"),
        b("nsupset", "\u2283\u20D2"),
        b("nsupseteq", "\u2289"),
        b("nsupseteqq", "\u2AC6\u0338"),
        b("ntgl", "\u2279"),
        b("Ntilde", "\xd1"),
        b("ntilde", "\xf1"),
        b("ntlg", "\u2278"),
        b("ntriangleleft", "\u22EA"),
        b("ntrianglelefteq", "\u22EC"),
        b("ntriangleright", "\u22EB"),
        b("ntrianglerighteq", "\u22ED"),
        b("Nu", "\u039D"),
        b("nu", "\u03BD"),
        b("num", "#"),
        b("numero", "\u2116"),
        b("numsp", "\u2007"),
        b("nvap", "\u224D\u20D2"),
        b("nvdash", "\u22AC"),
        b("nvDash", "\u22AD"),
        b("nVdash", "\u22AE"),
        b("nVDash", "\u22AF"),
        b("nvge", "\u2265\u20D2"),
        b("nvgt", ">\u20D2"),
        b("nvHarr", "\u2904"),
        b("nvinfin", "\u29DE"),
        b("nvlArr", "\u2902"),
        b("nvle", "\u2264\u20D2"),
        b("nvlt", "<\u20D2"),
        b("nvltrie", "\u22B4\u20D2"),
        b("nvrArr", "\u2903"),
        b("nvrtrie", "\u22B5\u20D2"),
        b("nvsim", "\u223C\u20D2"),
        b("nwarhk", "\u2923"),
        b("nwarr", "\u2196"),
        b("nwArr", "\u21D6"),
        b("nwarrow", "\u2196"),
        b("nwnear", "\u2927"),
        b("Oacute", "\xd3"),
        b("oacute", "\xf3"),
        b("oast", "\u229B"),
        b("Ocirc", "\xd4"),
        b("ocirc", "\xf4"),
        b("ocir", "\u229A"),
        b("Ocy", "\u041E"),
        b("ocy", "\u043E"),
        b("odash", "\u229D"),
        b("Odblac", "\u0150"),
        b("odblac", "\u0151"),
        b("odiv", "\u2A38"),
        b("odot", "\u2299"),
        b("odsold", "\u29BC"),
        b("OElig", "\u0152"),
        b("oelig", "\u0153"),
        b("ofcir", "\u29BF"),
        b("Ofr", "\uD835\uDD12"),
        b("ofr", "\uD835\uDD2C"),
        b("ogon", "\u02DB"),
        b("Ograve", "\xd2"),
        b("ograve", "\xf2"),
        b("ogt", "\u29C1"),
        b("ohbar", "\u29B5"),
        b("ohm", "\u03A9"),
        b("oint", "\u222E"),
        b("olarr", "\u21BA"),
        b("olcir", "\u29BE"),
        b("olcross", "\u29BB"),
        b("oline", "\u203E"),
        b("olt", "\u29C0"),
        b("Omacr", "\u014C"),
        b("omacr", "\u014D"),
        b("Omega", "\u03A9"),
        b("omega", "\u03C9"),
        b("Omicron", "\u039F"),
        b("omicron", "\u03BF"),
        b("omid", "\u29B6"),
        b("ominus", "\u2296"),
        b("Oopf", "\uD835\uDD46"),
        b("oopf", "\uD835\uDD60"),
        b("opar", "\u29B7"),
        b("OpenCurlyDoubleQuote", "\u201C"),
        b("OpenCurlyQuote", "\u2018"),
        b("operp", "\u29B9"),
        b("oplus", "\u2295"),
        b("orarr", "\u21BB"),
        b("Or", "\u2A54"),
        b("or", "\u2228"),
        b("ord", "\u2A5D"),
        b("order", "\u2134"),
        b("orderof", "\u2134"),
        b("ordf", "\xaa"),
        b("ordm", "\xba"),
        b("origof", "\u22B6"),
        b("oror", "\u2A56"),
        b("orslope", "\u2A57"),
        b("orv", "\u2A5B"),
        b("oS", "\u24C8"),
        b("Oscr", "\uD835\uDCAA"),
        b("oscr", "\u2134"),
        b("Oslash", "\xd8"),
        b("oslash", "\xf8"),
        b("osol", "\u2298"),
        b("Otilde", "\xd5"),
        b("otilde", "\xf5"),
        b("otimesas", "\u2A36"),
        b("Otimes", "\u2A37"),
        b("otimes", "\u2297"),
        b("Ouml", "\xd6"),
        b("ouml", "\xf6"),
        b("ovbar", "\u233D"),
        b("OverBar", "\u203E"),
        b("OverBrace", "\u23DE"),
        b("OverBracket", "\u23B4"),
        b("OverParenthesis", "\u23DC"),
        b("para", "\xb6"),
        b("parallel", "\u2225"),
        b("par", "\u2225"),
        b("parsim", "\u2AF3"),
        b("parsl", "\u2AFD"),
        b("part", "\u2202"),
        b("PartialD", "\u2202"),
        b("Pcy", "\u041F"),
        b("pcy", "\u043F"),
        b("percnt", "%"),
        b("period", "."),
        b("permil", "\u2030"),
        b("perp", "\u22A5"),
        b("pertenk", "\u2031"),
        b("Pfr", "\uD835\uDD13"),
        b("pfr", "\uD835\uDD2D"),
        b("Phi", "\u03A6"),
        b("phi", "\u03C6"),
        b("phiv", "\u03D5"),
        b("phmmat", "\u2133"),
        b("phone", "\u260E"),
        b("Pi", "\u03A0"),
        b("pi", "\u03C0"),
        b("pitchfork", "\u22D4"),
        b("piv", "\u03D6"),
        b("planck", "\u210F"),
        b("planckh", "\u210E"),
        b("plankv", "\u210F"),
        b("plusacir", "\u2A23"),
        b("plusb", "\u229E"),
        b("pluscir", "\u2A22"),
        b("plus", "+"),
        b("plusdo", "\u2214"),
        b("plusdu", "\u2A25"),
        b("pluse", "\u2A72"),
        b("PlusMinus", "\xb1"),
        b("plusmn", "\xb1"),
        b("plussim", "\u2A26"),
        b("plustwo", "\u2A27"),
        b("pm", "\xb1"),
        b("Poincareplane", "\u210C"),
        b("pointint", "\u2A15"),
        b("popf", "\uD835\uDD61"),
        b("Popf", "\u2119"),
        b("pound", "\xa3"),
        b("prap", "\u2AB7"),
        b("Pr", "\u2ABB"),
        b("pr", "\u227A"),
        b("prcue", "\u227C"),
        b("precapprox", "\u2AB7"),
        b("prec", "\u227A"),
        b("preccurlyeq", "\u227C"),
        b("Precedes", "\u227A"),
        b("PrecedesEqual", "\u2AAF"),
        b("PrecedesSlantEqual", "\u227C"),
        b("PrecedesTilde", "\u227E"),
        b("preceq", "\u2AAF"),
        b("precnapprox", "\u2AB9"),
        b("precneqq", "\u2AB5"),
        b("precnsim", "\u22E8"),
        b("pre", "\u2AAF"),
        b("prE", "\u2AB3"),
        b("precsim", "\u227E"),
        b("prime", "\u2032"),
        b("Prime", "\u2033"),
        b("primes", "\u2119"),
        b("prnap", "\u2AB9"),
        b("prnE", "\u2AB5"),
        b("prnsim", "\u22E8"),
        b("prod", "\u220F"),
        b("Product", "\u220F"),
        b("profalar", "\u232E"),
        b("profline", "\u2312"),
        b("profsurf", "\u2313"),
        b("prop", "\u221D"),
        b("Proportional", "\u221D"),
        b("Proportion", "\u2237"),
        b("propto", "\u221D"),
        b("prsim", "\u227E"),
        b("prurel", "\u22B0"),
        b("Pscr", "\uD835\uDCAB"),
        b("pscr", "\uD835\uDCC5"),
        b("Psi", "\u03A8"),
        b("psi", "\u03C8"),
        b("puncsp", "\u2008"),
        b("Qfr", "\uD835\uDD14"),
        b("qfr", "\uD835\uDD2E"),
        b("qint", "\u2A0C"),
        b("qopf", "\uD835\uDD62"),
        b("Qopf", "\u211A"),
        b("qprime", "\u2057"),
        b("Qscr", "\uD835\uDCAC"),
        b("qscr", "\uD835\uDCC6"),
        b("quaternions", "\u210D"),
        b("quatint", "\u2A16"),
        b("quest", "?"),
        b("questeq", "\u225F"),
        b("quot", '"'),
        b("QUOT", '"'),
        b("rAarr", "\u21DB"),
        b("race", "\u223D\u0331"),
        b("Racute", "\u0154"),
        b("racute", "\u0155"),
        b("radic", "\u221A"),
        b("raemptyv", "\u29B3"),
        b("rang", "\u27E9"),
        b("Rang", "\u27EB"),
        b("rangd", "\u2992"),
        b("range", "\u29A5"),
        b("rangle", "\u27E9"),
        b("raquo", "\xbb"),
        b("rarrap", "\u2975"),
        b("rarrb", "\u21E5"),
        b("rarrbfs", "\u2920"),
        b("rarrc", "\u2933"),
        b("rarr", "\u2192"),
        b("Rarr", "\u21A0"),
        b("rArr", "\u21D2"),
        b("rarrfs", "\u291E"),
        b("rarrhk", "\u21AA"),
        b("rarrlp", "\u21AC"),
        b("rarrpl", "\u2945"),
        b("rarrsim", "\u2974"),
        b("Rarrtl", "\u2916"),
        b("rarrtl", "\u21A3"),
        b("rarrw", "\u219D"),
        b("ratail", "\u291A"),
        b("rAtail", "\u291C"),
        b("ratio", "\u2236"),
        b("rationals", "\u211A"),
        b("rbarr", "\u290D"),
        b("rBarr", "\u290F"),
        b("RBarr", "\u2910"),
        b("rbbrk", "\u2773"),
        b("rbrace", "}"),
        b("rbrack", "]"),
        b("rbrke", "\u298C"),
        b("rbrksld", "\u298E"),
        b("rbrkslu", "\u2990"),
        b("Rcaron", "\u0158"),
        b("rcaron", "\u0159"),
        b("Rcedil", "\u0156"),
        b("rcedil", "\u0157"),
        b("rceil", "\u2309"),
        b("rcub", "}"),
        b("Rcy", "\u0420"),
        b("rcy", "\u0440"),
        b("rdca", "\u2937"),
        b("rdldhar", "\u2969"),
        b("rdquo", "\u201D"),
        b("rdquor", "\u201D"),
        b("rdsh", "\u21B3"),
        b("real", "\u211C"),
        b("realine", "\u211B"),
        b("realpart", "\u211C"),
        b("reals", "\u211D"),
        b("Re", "\u211C"),
        b("rect", "\u25AD"),
        b("reg", "\xae"),
        b("REG", "\xae"),
        b("ReverseElement", "\u220B"),
        b("ReverseEquilibrium", "\u21CB"),
        b("ReverseUpEquilibrium", "\u296F"),
        b("rfisht", "\u297D"),
        b("rfloor", "\u230B"),
        b("rfr", "\uD835\uDD2F"),
        b("Rfr", "\u211C"),
        b("rHar", "\u2964"),
        b("rhard", "\u21C1"),
        b("rharu", "\u21C0"),
        b("rharul", "\u296C"),
        b("Rho", "\u03A1"),
        b("rho", "\u03C1"),
        b("rhov", "\u03F1"),
        b("RightAngleBracket", "\u27E9"),
        b("RightArrowBar", "\u21E5"),
        b("rightarrow", "\u2192"),
        b("RightArrow", "\u2192"),
        b("Rightarrow", "\u21D2"),
        b("RightArrowLeftArrow", "\u21C4"),
        b("rightarrowtail", "\u21A3"),
        b("RightCeiling", "\u2309"),
        b("RightDoubleBracket", "\u27E7"),
        b("RightDownTeeVector", "\u295D"),
        b("RightDownVectorBar", "\u2955"),
        b("RightDownVector", "\u21C2"),
        b("RightFloor", "\u230B"),
        b("rightharpoondown", "\u21C1"),
        b("rightharpoonup", "\u21C0"),
        b("rightleftarrows", "\u21C4"),
        b("rightleftharpoons", "\u21CC"),
        b("rightrightarrows", "\u21C9"),
        b("rightsquigarrow", "\u219D"),
        b("RightTeeArrow", "\u21A6"),
        b("RightTee", "\u22A2"),
        b("RightTeeVector", "\u295B"),
        b("rightthreetimes", "\u22CC"),
        b("RightTriangleBar", "\u29D0"),
        b("RightTriangle", "\u22B3"),
        b("RightTriangleEqual", "\u22B5"),
        b("RightUpDownVector", "\u294F"),
        b("RightUpTeeVector", "\u295C"),
        b("RightUpVectorBar", "\u2954"),
        b("RightUpVector", "\u21BE"),
        b("RightVectorBar", "\u2953"),
        b("RightVector", "\u21C0"),
        b("ring", "\u02DA"),
        b("risingdotseq", "\u2253"),
        b("rlarr", "\u21C4"),
        b("rlhar", "\u21CC"),
        b("rlm", "\u200F"),
        b("rmoustache", "\u23B1"),
        b("rmoust", "\u23B1"),
        b("rnmid", "\u2AEE"),
        b("roang", "\u27ED"),
        b("roarr", "\u21FE"),
        b("robrk", "\u27E7"),
        b("ropar", "\u2986"),
        b("ropf", "\uD835\uDD63"),
        b("Ropf", "\u211D"),
        b("roplus", "\u2A2E"),
        b("rotimes", "\u2A35"),
        b("RoundImplies", "\u2970"),
        b("rpar", ")"),
        b("rpargt", "\u2994"),
        b("rppolint", "\u2A12"),
        b("rrarr", "\u21C9"),
        b("Rrightarrow", "\u21DB"),
        b("rsaquo", "\u203A"),
        b("rscr", "\uD835\uDCC7"),
        b("Rscr", "\u211B"),
        b("rsh", "\u21B1"),
        b("Rsh", "\u21B1"),
        b("rsqb", "]"),
        b("rsquo", "\u2019"),
        b("rsquor", "\u2019"),
        b("rthree", "\u22CC"),
        b("rtimes", "\u22CA"),
        b("rtri", "\u25B9"),
        b("rtrie", "\u22B5"),
        b("rtrif", "\u25B8"),
        b("rtriltri", "\u29CE"),
        b("RuleDelayed", "\u29F4"),
        b("ruluhar", "\u2968"),
        b("rx", "\u211E"),
        b("Sacute", "\u015A"),
        b("sacute", "\u015B"),
        b("sbquo", "\u201A"),
        b("scap", "\u2AB8"),
        b("Scaron", "\u0160"),
        b("scaron", "\u0161"),
        b("Sc", "\u2ABC"),
        b("sc", "\u227B"),
        b("sccue", "\u227D"),
        b("sce", "\u2AB0"),
        b("scE", "\u2AB4"),
        b("Scedil", "\u015E"),
        b("scedil", "\u015F"),
        b("Scirc", "\u015C"),
        b("scirc", "\u015D"),
        b("scnap", "\u2ABA"),
        b("scnE", "\u2AB6"),
        b("scnsim", "\u22E9"),
        b("scpolint", "\u2A13"),
        b("scsim", "\u227F"),
        b("Scy", "\u0421"),
        b("scy", "\u0441"),
        b("sdotb", "\u22A1"),
        b("sdot", "\u22C5"),
        b("sdote", "\u2A66"),
        b("searhk", "\u2925"),
        b("searr", "\u2198"),
        b("seArr", "\u21D8"),
        b("searrow", "\u2198"),
        b("sect", "\xa7"),
        b("semi", ";"),
        b("seswar", "\u2929"),
        b("setminus", "\u2216"),
        b("setmn", "\u2216"),
        b("sext", "\u2736"),
        b("Sfr", "\uD835\uDD16"),
        b("sfr", "\uD835\uDD30"),
        b("sfrown", "\u2322"),
        b("sharp", "\u266F"),
        b("SHCHcy", "\u0429"),
        b("shchcy", "\u0449"),
        b("SHcy", "\u0428"),
        b("shcy", "\u0448"),
        b("ShortDownArrow", "\u2193"),
        b("ShortLeftArrow", "\u2190"),
        b("shortmid", "\u2223"),
        b("shortparallel", "\u2225"),
        b("ShortRightArrow", "\u2192"),
        b("ShortUpArrow", "\u2191"),
        b("shy", "\xad"),
        b("Sigma", "\u03A3"),
        b("sigma", "\u03C3"),
        b("sigmaf", "\u03C2"),
        b("sigmav", "\u03C2"),
        b("sim", "\u223C"),
        b("simdot", "\u2A6A"),
        b("sime", "\u2243"),
        b("simeq", "\u2243"),
        b("simg", "\u2A9E"),
        b("simgE", "\u2AA0"),
        b("siml", "\u2A9D"),
        b("simlE", "\u2A9F"),
        b("simne", "\u2246"),
        b("simplus", "\u2A24"),
        b("simrarr", "\u2972"),
        b("slarr", "\u2190"),
        b("SmallCircle", "\u2218"),
        b("smallsetminus", "\u2216"),
        b("smashp", "\u2A33"),
        b("smeparsl", "\u29E4"),
        b("smid", "\u2223"),
        b("smile", "\u2323"),
        b("smt", "\u2AAA"),
        b("smte", "\u2AAC"),
        b("smtes", "\u2AAC\uFE00"),
        b("SOFTcy", "\u042C"),
        b("softcy", "\u044C"),
        b("solbar", "\u233F"),
        b("solb", "\u29C4"),
        b("sol", "/"),
        b("Sopf", "\uD835\uDD4A"),
        b("sopf", "\uD835\uDD64"),
        b("spades", "\u2660"),
        b("spadesuit", "\u2660"),
        b("spar", "\u2225"),
        b("sqcap", "\u2293"),
        b("sqcaps", "\u2293\uFE00"),
        b("sqcup", "\u2294"),
        b("sqcups", "\u2294\uFE00"),
        b("Sqrt", "\u221A"),
        b("sqsub", "\u228F"),
        b("sqsube", "\u2291"),
        b("sqsubset", "\u228F"),
        b("sqsubseteq", "\u2291"),
        b("sqsup", "\u2290"),
        b("sqsupe", "\u2292"),
        b("sqsupset", "\u2290"),
        b("sqsupseteq", "\u2292"),
        b("square", "\u25A1"),
        b("Square", "\u25A1"),
        b("SquareIntersection", "\u2293"),
        b("SquareSubset", "\u228F"),
        b("SquareSubsetEqual", "\u2291"),
        b("SquareSuperset", "\u2290"),
        b("SquareSupersetEqual", "\u2292"),
        b("SquareUnion", "\u2294"),
        b("squarf", "\u25AA"),
        b("squ", "\u25A1"),
        b("squf", "\u25AA"),
        b("srarr", "\u2192"),
        b("Sscr", "\uD835\uDCAE"),
        b("sscr", "\uD835\uDCC8"),
        b("ssetmn", "\u2216"),
        b("ssmile", "\u2323"),
        b("sstarf", "\u22C6"),
        b("Star", "\u22C6"),
        b("star", "\u2606"),
        b("starf", "\u2605"),
        b("straightepsilon", "\u03F5"),
        b("straightphi", "\u03D5"),
        b("strns", "\xaf"),
        b("sub", "\u2282"),
        b("Sub", "\u22D0"),
        b("subdot", "\u2ABD"),
        b("subE", "\u2AC5"),
        b("sube", "\u2286"),
        b("subedot", "\u2AC3"),
        b("submult", "\u2AC1"),
        b("subnE", "\u2ACB"),
        b("subne", "\u228A"),
        b("subplus", "\u2ABF"),
        b("subrarr", "\u2979"),
        b("subset", "\u2282"),
        b("Subset", "\u22D0"),
        b("subseteq", "\u2286"),
        b("subseteqq", "\u2AC5"),
        b("SubsetEqual", "\u2286"),
        b("subsetneq", "\u228A"),
        b("subsetneqq", "\u2ACB"),
        b("subsim", "\u2AC7"),
        b("subsub", "\u2AD5"),
        b("subsup", "\u2AD3"),
        b("succapprox", "\u2AB8"),
        b("succ", "\u227B"),
        b("succcurlyeq", "\u227D"),
        b("Succeeds", "\u227B"),
        b("SucceedsEqual", "\u2AB0"),
        b("SucceedsSlantEqual", "\u227D"),
        b("SucceedsTilde", "\u227F"),
        b("succeq", "\u2AB0"),
        b("succnapprox", "\u2ABA"),
        b("succneqq", "\u2AB6"),
        b("succnsim", "\u22E9"),
        b("succsim", "\u227F"),
        b("SuchThat", "\u220B"),
        b("sum", "\u2211"),
        b("Sum", "\u2211"),
        b("sung", "\u266A"),
        b("sup1", "\xb9"),
        b("sup2", "\xb2"),
        b("sup3", "\xb3"),
        b("sup", "\u2283"),
        b("Sup", "\u22D1"),
        b("supdot", "\u2ABE"),
        b("supdsub", "\u2AD8"),
        b("supE", "\u2AC6"),
        b("supe", "\u2287"),
        b("supedot", "\u2AC4"),
        b("Superset", "\u2283"),
        b("SupersetEqual", "\u2287"),
        b("suphsol", "\u27C9"),
        b("suphsub", "\u2AD7"),
        b("suplarr", "\u297B"),
        b("supmult", "\u2AC2"),
        b("supnE", "\u2ACC"),
        b("supne", "\u228B"),
        b("supplus", "\u2AC0"),
        b("supset", "\u2283"),
        b("Supset", "\u22D1"),
        b("supseteq", "\u2287"),
        b("supseteqq", "\u2AC6"),
        b("supsetneq", "\u228B"),
        b("supsetneqq", "\u2ACC"),
        b("supsim", "\u2AC8"),
        b("supsub", "\u2AD4"),
        b("supsup", "\u2AD6"),
        b("swarhk", "\u2926"),
        b("swarr", "\u2199"),
        b("swArr", "\u21D9"),
        b("swarrow", "\u2199"),
        b("swnwar", "\u292A"),
        b("szlig", "\xdf"),
        b("Tab", "\t"),
        b("target", "\u2316"),
        b("Tau", "\u03A4"),
        b("tau", "\u03C4"),
        b("tbrk", "\u23B4"),
        b("Tcaron", "\u0164"),
        b("tcaron", "\u0165"),
        b("Tcedil", "\u0162"),
        b("tcedil", "\u0163"),
        b("Tcy", "\u0422"),
        b("tcy", "\u0442"),
        b("tdot", "\u20DB"),
        b("telrec", "\u2315"),
        b("Tfr", "\uD835\uDD17"),
        b("tfr", "\uD835\uDD31"),
        b("there4", "\u2234"),
        b("therefore", "\u2234"),
        b("Therefore", "\u2234"),
        b("Theta", "\u0398"),
        b("theta", "\u03B8"),
        b("thetasym", "\u03D1"),
        b("thetav", "\u03D1"),
        b("thickapprox", "\u2248"),
        b("thicksim", "\u223C"),
        b("ThickSpace", "\u205F\u200A"),
        b("ThinSpace", "\u2009"),
        b("thinsp", "\u2009"),
        b("thkap", "\u2248"),
        b("thksim", "\u223C"),
        b("THORN", "\xde"),
        b("thorn", "\xfe"),
        b("tilde", "\u02DC"),
        b("Tilde", "\u223C"),
        b("TildeEqual", "\u2243"),
        b("TildeFullEqual", "\u2245"),
        b("TildeTilde", "\u2248"),
        b("timesbar", "\u2A31"),
        b("timesb", "\u22A0"),
        b("times", "\xd7"),
        b("timesd", "\u2A30"),
        b("tint", "\u222D"),
        b("toea", "\u2928"),
        b("topbot", "\u2336"),
        b("topcir", "\u2AF1"),
        b("top", "\u22A4"),
        b("Topf", "\uD835\uDD4B"),
        b("topf", "\uD835\uDD65"),
        b("topfork", "\u2ADA"),
        b("tosa", "\u2929"),
        b("tprime", "\u2034"),
        b("trade", "\u2122"),
        b("TRADE", "\u2122"),
        b("triangle", "\u25B5"),
        b("triangledown", "\u25BF"),
        b("triangleleft", "\u25C3"),
        b("trianglelefteq", "\u22B4"),
        b("triangleq", "\u225C"),
        b("triangleright", "\u25B9"),
        b("trianglerighteq", "\u22B5"),
        b("tridot", "\u25EC"),
        b("trie", "\u225C"),
        b("triminus", "\u2A3A"),
        b("TripleDot", "\u20DB"),
        b("triplus", "\u2A39"),
        b("trisb", "\u29CD"),
        b("tritime", "\u2A3B"),
        b("trpezium", "\u23E2"),
        b("Tscr", "\uD835\uDCAF"),
        b("tscr", "\uD835\uDCC9"),
        b("TScy", "\u0426"),
        b("tscy", "\u0446"),
        b("TSHcy", "\u040B"),
        b("tshcy", "\u045B"),
        b("Tstrok", "\u0166"),
        b("tstrok", "\u0167"),
        b("twixt", "\u226C"),
        b("twoheadleftarrow", "\u219E"),
        b("twoheadrightarrow", "\u21A0"),
        b("Uacute", "\xda"),
        b("uacute", "\xfa"),
        b("uarr", "\u2191"),
        b("Uarr", "\u219F"),
        b("uArr", "\u21D1"),
        b("Uarrocir", "\u2949"),
        b("Ubrcy", "\u040E"),
        b("ubrcy", "\u045E"),
        b("Ubreve", "\u016C"),
        b("ubreve", "\u016D"),
        b("Ucirc", "\xdb"),
        b("ucirc", "\xfb"),
        b("Ucy", "\u0423"),
        b("ucy", "\u0443"),
        b("udarr", "\u21C5"),
        b("Udblac", "\u0170"),
        b("udblac", "\u0171"),
        b("udhar", "\u296E"),
        b("ufisht", "\u297E"),
        b("Ufr", "\uD835\uDD18"),
        b("ufr", "\uD835\uDD32"),
        b("Ugrave", "\xd9"),
        b("ugrave", "\xf9"),
        b("uHar", "\u2963"),
        b("uharl", "\u21BF"),
        b("uharr", "\u21BE"),
        b("uhblk", "\u2580"),
        b("ulcorn", "\u231C"),
        b("ulcorner", "\u231C"),
        b("ulcrop", "\u230F"),
        b("ultri", "\u25F8"),
        b("Umacr", "\u016A"),
        b("umacr", "\u016B"),
        b("uml", "\xa8"),
        b("UnderBar", "_"),
        b("UnderBrace", "\u23DF"),
        b("UnderBracket", "\u23B5"),
        b("UnderParenthesis", "\u23DD"),
        b("Union", "\u22C3"),
        b("UnionPlus", "\u228E"),
        b("Uogon", "\u0172"),
        b("uogon", "\u0173"),
        b("Uopf", "\uD835\uDD4C"),
        b("uopf", "\uD835\uDD66"),
        b("UpArrowBar", "\u2912"),
        b("uparrow", "\u2191"),
        b("UpArrow", "\u2191"),
        b("Uparrow", "\u21D1"),
        b("UpArrowDownArrow", "\u21C5"),
        b("updownarrow", "\u2195"),
        b("UpDownArrow", "\u2195"),
        b("Updownarrow", "\u21D5"),
        b("UpEquilibrium", "\u296E"),
        b("upharpoonleft", "\u21BF"),
        b("upharpoonright", "\u21BE"),
        b("uplus", "\u228E"),
        b("UpperLeftArrow", "\u2196"),
        b("UpperRightArrow", "\u2197"),
        b("upsi", "\u03C5"),
        b("Upsi", "\u03D2"),
        b("upsih", "\u03D2"),
        b("Upsilon", "\u03A5"),
        b("upsilon", "\u03C5"),
        b("UpTeeArrow", "\u21A5"),
        b("UpTee", "\u22A5"),
        b("upuparrows", "\u21C8"),
        b("urcorn", "\u231D"),
        b("urcorner", "\u231D"),
        b("urcrop", "\u230E"),
        b("Uring", "\u016E"),
        b("uring", "\u016F"),
        b("urtri", "\u25F9"),
        b("Uscr", "\uD835\uDCB0"),
        b("uscr", "\uD835\uDCCA"),
        b("utdot", "\u22F0"),
        b("Utilde", "\u0168"),
        b("utilde", "\u0169"),
        b("utri", "\u25B5"),
        b("utrif", "\u25B4"),
        b("uuarr", "\u21C8"),
        b("Uuml", "\xdc"),
        b("uuml", "\xfc"),
        b("uwangle", "\u29A7"),
        b("vangrt", "\u299C"),
        b("varepsilon", "\u03F5"),
        b("varkappa", "\u03F0"),
        b("varnothing", "\u2205"),
        b("varphi", "\u03D5"),
        b("varpi", "\u03D6"),
        b("varpropto", "\u221D"),
        b("varr", "\u2195"),
        b("vArr", "\u21D5"),
        b("varrho", "\u03F1"),
        b("varsigma", "\u03C2"),
        b("varsubsetneq", "\u228A\uFE00"),
        b("varsubsetneqq", "\u2ACB\uFE00"),
        b("varsupsetneq", "\u228B\uFE00"),
        b("varsupsetneqq", "\u2ACC\uFE00"),
        b("vartheta", "\u03D1"),
        b("vartriangleleft", "\u22B2"),
        b("vartriangleright", "\u22B3"),
        b("vBar", "\u2AE8"),
        b("Vbar", "\u2AEB"),
        b("vBarv", "\u2AE9"),
        b("Vcy", "\u0412"),
        b("vcy", "\u0432"),
        b("vdash", "\u22A2"),
        b("vDash", "\u22A8"),
        b("Vdash", "\u22A9"),
        b("VDash", "\u22AB"),
        b("Vdashl", "\u2AE6"),
        b("veebar", "\u22BB"),
        b("vee", "\u2228"),
        b("Vee", "\u22C1"),
        b("veeeq", "\u225A"),
        b("vellip", "\u22EE"),
        b("verbar", "|"),
        b("Verbar", "\u2016"),
        b("vert", "|"),
        b("Vert", "\u2016"),
        b("VerticalBar", "\u2223"),
        b("VerticalLine", "|"),
        b("VerticalSeparator", "\u2758"),
        b("VerticalTilde", "\u2240"),
        b("VeryThinSpace", "\u200A"),
        b("Vfr", "\uD835\uDD19"),
        b("vfr", "\uD835\uDD33"),
        b("vltri", "\u22B2"),
        b("vnsub", "\u2282\u20D2"),
        b("vnsup", "\u2283\u20D2"),
        b("Vopf", "\uD835\uDD4D"),
        b("vopf", "\uD835\uDD67"),
        b("vprop", "\u221D"),
        b("vrtri", "\u22B3"),
        b("Vscr", "\uD835\uDCB1"),
        b("vscr", "\uD835\uDCCB"),
        b("vsubnE", "\u2ACB\uFE00"),
        b("vsubne", "\u228A\uFE00"),
        b("vsupnE", "\u2ACC\uFE00"),
        b("vsupne", "\u228B\uFE00"),
        b("Vvdash", "\u22AA"),
        b("vzigzag", "\u299A"),
        b("Wcirc", "\u0174"),
        b("wcirc", "\u0175"),
        b("wedbar", "\u2A5F"),
        b("wedge", "\u2227"),
        b("Wedge", "\u22C0"),
        b("wedgeq", "\u2259"),
        b("weierp", "\u2118"),
        b("Wfr", "\uD835\uDD1A"),
        b("wfr", "\uD835\uDD34"),
        b("Wopf", "\uD835\uDD4E"),
        b("wopf", "\uD835\uDD68"),
        b("wp", "\u2118"),
        b("wr", "\u2240"),
        b("wreath", "\u2240"),
        b("Wscr", "\uD835\uDCB2"),
        b("wscr", "\uD835\uDCCC"),
        b("xcap", "\u22C2"),
        b("xcirc", "\u25EF"),
        b("xcup", "\u22C3"),
        b("xdtri", "\u25BD"),
        b("Xfr", "\uD835\uDD1B"),
        b("xfr", "\uD835\uDD35"),
        b("xharr", "\u27F7"),
        b("xhArr", "\u27FA"),
        b("Xi", "\u039E"),
        b("xi", "\u03BE"),
        b("xlarr", "\u27F5"),
        b("xlArr", "\u27F8"),
        b("xmap", "\u27FC"),
        b("xnis", "\u22FB"),
        b("xodot", "\u2A00"),
        b("Xopf", "\uD835\uDD4F"),
        b("xopf", "\uD835\uDD69"),
        b("xoplus", "\u2A01"),
        b("xotime", "\u2A02"),
        b("xrarr", "\u27F6"),
        b("xrArr", "\u27F9"),
        b("Xscr", "\uD835\uDCB3"),
        b("xscr", "\uD835\uDCCD"),
        b("xsqcup", "\u2A06"),
        b("xuplus", "\u2A04"),
        b("xutri", "\u25B3"),
        b("xvee", "\u22C1"),
        b("xwedge", "\u22C0"),
        b("Yacute", "\xdd"),
        b("yacute", "\xfd"),
        b("YAcy", "\u042F"),
        b("yacy", "\u044F"),
        b("Ycirc", "\u0176"),
        b("ycirc", "\u0177"),
        b("Ycy", "\u042B"),
        b("ycy", "\u044B"),
        b("yen", "\xa5"),
        b("Yfr", "\uD835\uDD1C"),
        b("yfr", "\uD835\uDD36"),
        b("YIcy", "\u0407"),
        b("yicy", "\u0457"),
        b("Yopf", "\uD835\uDD50"),
        b("yopf", "\uD835\uDD6A"),
        b("Yscr", "\uD835\uDCB4"),
        b("yscr", "\uD835\uDCCE"),
        b("YUcy", "\u042E"),
        b("yucy", "\u044E"),
        b("yuml", "\xff"),
        b("Yuml", "\u0178"),
        b("Zacute", "\u0179"),
        b("zacute", "\u017A"),
        b("Zcaron", "\u017D"),
        b("zcaron", "\u017E"),
        b("Zcy", "\u0417"),
        b("zcy", "\u0437"),
        b("Zdot", "\u017B"),
        b("zdot", "\u017C"),
        b("zeetrf", "\u2128"),
        b("ZeroWidthSpace", "\u200B"),
        b("Zeta", "\u0396"),
        b("zeta", "\u03B6"),
        b("zfr", "\uD835\uDD37"),
        b("Zfr", "\u2128"),
        b("ZHcy", "\u0416"),
        b("zhcy", "\u0436"),
        b("zigrarr", "\u21DD"),
        b("zopf", "\uD835\uDD6B"),
        b("Zopf", "\u2124"),
        b("Zscr", "\uD835\uDCB5"),
        b("zscr", "\uD835\uDCCF"),
        b("zwj", "\u200D"),
        b("zwnj", "\u200C")
    ])), ij = A2(Lm, function(n) {
        return A2(uc, "&" + n + ";", A2(Zu, n, aj));
    }, Um(HB($e))), cj = A, oj = F3(function(n, r, t) {
        n: for(;;){
            if (!r.b) return Qt(t);
            var e = r.a, u = r.b;
            switch(e){
                case "0":
                    n = a = n - 1, r = i = u, t = c = t;
                    continue n;
                case "1":
                    var a = n - 1, i = u, c = t + A2(cj, 16, n);
                    n = a, r = i, t = c;
                    continue n;
                case "2":
                    a = n - 1, i = u, c = t + 2 * A2(cj, 16, n), n = a, r = i, t = c;
                    continue n;
                case "3":
                    a = n - 1, i = u, c = t + 3 * A2(cj, 16, n), n = a, r = i, t = c;
                    continue n;
                case "4":
                    a = n - 1, i = u, c = t + 4 * A2(cj, 16, n), n = a, r = i, t = c;
                    continue n;
                case "5":
                    a = n - 1, i = u, c = t + 5 * A2(cj, 16, n), n = a, r = i, t = c;
                    continue n;
                case "6":
                    a = n - 1, i = u, c = t + 6 * A2(cj, 16, n), n = a, r = i, t = c;
                    continue n;
                case "7":
                    a = n - 1, i = u, c = t + 7 * A2(cj, 16, n), n = a, r = i, t = c;
                    continue n;
                case "8":
                    a = n - 1, i = u, c = t + 8 * A2(cj, 16, n), n = a, r = i, t = c;
                    continue n;
                case "9":
                    a = n - 1, i = u, c = t + 9 * A2(cj, 16, n), n = a, r = i, t = c;
                    continue n;
                case "a":
                    a = n - 1, i = u, c = t + 10 * A2(cj, 16, n), n = a, r = i, t = c;
                    continue n;
                case "b":
                    a = n - 1, i = u, c = t + 11 * A2(cj, 16, n), n = a, r = i, t = c;
                    continue n;
                case "c":
                    a = n - 1, i = u, c = t + 12 * A2(cj, 16, n), n = a, r = i, t = c;
                    continue n;
                case "d":
                    a = n - 1, i = u, c = t + 13 * A2(cj, 16, n), n = a, r = i, t = c;
                    continue n;
                case "e":
                    a = n - 1, i = u, c = t + 14 * A2(cj, 16, n), n = a, r = i, t = c;
                    continue n;
                case "f":
                    a = n - 1, i = u, c = t + 15 * A2(cj, 16, n), n = a, r = i, t = c;
                    continue n;
                default:
                    return Xt(Fb(e) + " is not a valid hexadecimal character.");
            }
        }
    }), fj = A2(nm, function(n) {
        var r = function(n) {
            if (fu(n)) return Xt("Empty strings are not valid hexadecimal strings.");
            var r = function() {
                if (A2(pu, "-", n)) {
                    var r = A2(uc, h, fB(jm(n)));
                    return A2(Wp, Gc, A3(oj, oe(r) - 1, r, 0));
                }
                return A3(oj, au(n) - 1, jm(n), 0);
            }();
            return A2(Xp, function(r) {
                return A2(ue, " ", k([
                    '"' + n + '"',
                    "is not a valid hexadecimal string because",
                    r
                ]));
            }, r);
        }(OB(n));
        return r.$ ? qm(r.a) : am(r.a);
    }, Um(HB(function(n) {
        var r = ve(n);
        return r >= 48 && 57 >= r || r >= 65 && 70 >= r || r >= 97 && 102 >= r;
    }))), sj = {
        $: 1
    }, lj = bt, dj = vt, bj = F2(function(n, r) {
        return {
            nx: r.nx + (n - r.h3),
            e: r.e,
            m: r.m,
            h3: n,
            vt: r.vt,
            d: r.d
        };
    }), vj = dt, mj = lt, pj = F2(function(n, r) {
        if (A3(mj, 101, n, r) || A3(mj, 69, n, r)) {
            var t = n + 1, e = A3(mj, 43, t, r) || A3(mj, 45, t, r) ? t + 1 : t, u = A2(vj, e, r);
            return i(e, u) ? -u : u;
        }
        return n;
    }), $j = F2(function(n, r) {
        return A2(pj, A3(mj, 46, n, r) ? A2(vj, n + 1, r) : n, r);
    }), hj = F5(function(n, r, t, e, u) {
        var a = e.a, c = e.b;
        if (1 === r.$) return A2(Yv, !0, A2(lm, u, r.a));
        var o = r.a;
        return i(t, a) ? A2(Yv, 0 > s(u.h3, t), A2(lm, u, n)) : A3(Qv, !0, o(c), A2(bj, a, u));
    }), gj = function(n) {
        if (0 === n.length || /[\sxbo]/.test(n)) return Rt;
        var r = +n;
        return r == r ? Ht(r) : Rt;
    }, wj = F6(function(n, r, t, e, u, a) {
        var c = u.a, o = A2($j, c, a.d);
        if (0 > o) return A2(Yv, !0, A4(VB, a.vt, a.nx - (o + a.h3), n, a.e));
        if (i(a.h3, o)) return A2(Yv, !1, A2(lm, a, r));
        if (i(c, o)) return A5(hj, n, t, a.h3, u, a);
        if (1 === e.$) return A2(Yv, !0, A2(lm, a, n));
        var f = e.a, s = gj(A3(iu, a.h3, o, a.d));
        return 1 === s.$ ? A2(Yv, !0, A2(lm, a, n)) : A3(Qv, !0, f(s.a), A2(bj, o, a));
    }), kj = A2(F2(function(n, r) {
        var t;
        return t = {
            mU: Xt(r),
            pW: n,
            qe: Xt(r),
            qM: Xt(r),
            q$: Qt(ru),
            zU: r,
            tc: Xt(r)
        }, function(n) {
            if (A3(mj, 48, n.h3, n.d)) {
                var r = n.h3 + 1, e = r + 1;
                return A3(mj, 120, r, n.d) ? A5(hj, t.zU, t.qM, e, A2(dj, e, n.d), n) : A3(mj, 111, r, n.d) ? A5(hj, t.zU, t.tc, e, A3(lj, 8, e, n.d), n) : A3(mj, 98, r, n.d) ? A5(hj, t.zU, t.mU, e, A3(lj, 2, e, n.d), n) : A6(wj, t.zU, t.pW, t.q$, t.qe, b(r, 0), n);
            }
            return A6(wj, t.zU, t.pW, t.q$, t.qe, A3(lj, 10, n.h3, n.d), n);
        };
    }), sj, sj), xj = ($D = Om(k([
        A2(Am, A2(um, am(ru), wm(function(n) {
            return "x" === n || "X" === n;
        })), fj),
        A2(Am, A2(um, am(ru), _m(Te("0"))), kj)
    ])), A2(Am, A2(um, am(ru), wm(Te("#"))), A2(Lm, A2(Je, P_, Fb), $D))), yj = A2(Am, A2(um, am(ru), wm(Te("&"))), Om(k([
        A2(um, wC(ij), uj),
        A2(um, wC(xj), uj),
        am("&")
    ]))), _j = function(n) {
        return A2(Am, A2(um, am(ru), wm(Te(n))), A2(um, A2(Lm, ue(""), tj(Om(k([
            Um(HB(function(r) {
                return !i(r, n) && "&" !== r;
            })),
            yj
        ])))), wm(Te(n))));
    }, Cj = F2(function(n, r) {
        return A2(rj, h, function(t) {
            return Om(k([
                A2(Lm, function(n) {
                    return YB(A2(Ot, n, t));
                }, r),
                ED(t) ? qm("expecting at least one " + n) : am(JB(we(t)))
            ]));
        });
    }), Dj = A2(Lm, ue(""), A2(Cj, "attribute value", Om(k([
        Um(HB(function(n) {
            return !RB(n) && '"' !== n && "'" !== n && "=" !== n && "<" !== n && ">" !== n && "`" !== n && "&" !== n;
        })),
        yj
    ])))), Aj = Om(k([
        A2(Am, A2(um, A2(um, am(ru), wm(Te("="))), _m(RB)), Om(k([
            Dj,
            _j('"'),
            _j("'")
        ]))),
        am("")
    ])), qj = A2(Am, A2(Am, am(nC), A2(um, ej, _m(RB))), A2(um, Aj, _m(RB))), Bj = tj(qj), jj = A2(Lm, OB, Um(A2(um, wm(ge), _m(function(n) {
        return ge(n) || "-" === n;
    })))), Sj = function(n) {
        return {
            $: 0,
            a: n
        };
    }, zj = A2(Lm, A2(Je, ue(""), Sj), A2(Cj, "text element", Om(k([
        Um(HB(function(n) {
            return "<" !== n && "&" !== n;
        })),
        yj
    ]))));
    function Uj() {
        return Om(k([
            zj,
            XB,
            Ej()
        ]));
    }
    function Ej() {
        return A2(nm, function(n) {
            var r = n.a, t = n.b;
            return function(n) {
                return A2(lA, n, GB);
            }(r) ? A2(um, A2(um, am(A3(MB, r, t, h)), Om(k([
                wm(Te("/")),
                am(0)
            ]))), wm(Te(">"))) : A2(Am, A2(um, am(A2(MB, r, t)), wm(Te(">"))), A2(um, tj(wC(Uj())), function(n) {
                var r = A2(nm, function(r) {
                    return i(OB(r), n) ? am(0) : qm("closing tag does not match opening tag: " + n);
                }, Um(HB(function(n) {
                    return !RB(n) && ">" !== n;
                })));
                return A2(um, A2(um, A2(um, A2(um, wm(Te("<")), wm(Te("/"))), r), _m(RB)), wm(Te(">")));
            }(r)));
        }, A2(Am, A2(Am, A2(um, am(nC), wm(Te("<"))), A2(um, jj, _m(RB))), Bj));
    }
    var Pj = Uj();
    Uj = function() {
        return Pj;
    };
    var Tj = Ej();
    Ej = function() {
        return Tj;
    };
    var Fj, Lj = function(n) {
        return fu(n) ? Qt(h) : A2(Ym, A2(Cj, "node", Pj), n);
    }, Mj = function(n) {
        return ir(vr(n));
    }, Hj = function(n) {
        return A2(Wx, n.a, n.b);
    }, Rj = function(n) {
        return A2(yu, Oj, n);
    }, Oj = function(n) {
        switch(n.$){
            case 1:
                var r = n.c;
                return A3(Mj, n.a, A2(yu, Hj, n.b), Rj(r));
            case 0:
                return ad(n.a);
            default:
                return ad("");
        }
    }, Nj = function(n) {
        var r = Lj(n);
        return r.$ ? h : Rj(r.a);
    }, Ij = br("class"), Vj = ar(vr("http://www.w3.org/2000/svg")), Wj = function(n) {
        return A3(Vj, "svg", $(k([
            A2(Vx, "viewBox", "0 0 17 16"),
            A2(Vx, "fill", "none"),
            A2(Vx, "xmlns", "http://www.w3.org/2000/svg")
        ]), n), k([
            A3(Vj, "path", k([
                A2(Vx, "d", "M11.8333 14.6673V12.6673H9.83333V11.334H11.8333V9.33398H13.1667V11.334H15.1667V12.6673H13.1667V14.6673H11.8333ZM3.83333 13.334C3.46667 13.334 3.15278 13.2034 2.89167 12.9423C2.63056 12.6812 2.5 12.3673 2.5 12.0007V4.00065C2.5 3.63398 2.63056 3.3201 2.89167 3.05898C3.15278 2.79787 3.46667 2.66732 3.83333 2.66732H4.5V1.33398H5.83333V2.66732H9.83333V1.33398H11.1667V2.66732H11.8333C12.2 2.66732 12.5139 2.79787 12.775 3.05898C13.0361 3.3201 13.1667 3.63398 13.1667 4.00065V8.06732C12.9444 8.03398 12.7222 8.01732 12.5 8.01732C12.2778 8.01732 12.0556 8.03398 11.8333 8.06732V6.66732H3.83333V12.0007H8.5C8.5 12.2229 8.51667 12.4451 8.55 12.6673C8.58333 12.8895 8.64444 13.1118 8.73333 13.334H3.83333ZM3.83333 5.33398H11.8333V4.00065H3.83333V5.33398Z")
            ]), h)
        ]));
    }, Zj = function(n) {
        return A3(Vj, "svg", $(k([
            A2(Vx, "width", "24"),
            A2(Vx, "height", "24"),
            A2(Vx, "viewBox", "0 0 24 24"),
            A2(Vx, "fill", "none"),
            A2(Vx, "xmlns", "http://www.w3.org/2000/svg")
        ]), n), k([
            A3(Vj, "g", k([
                A2(Vx, "id", "icon/navigation/cancel_24px")
            ]), k([
                A3(Vj, "path", k([
                    A2(Vx, "id", "icon/navigation/cancel_24px_2"),
                    A2(Vx, "fill-rule", "evenodd"),
                    A2(Vx, "clip-rule", "evenodd"),
                    A2(Vx, "d", "M12 2C6.47 2 2 6.47 2 12C2 17.53 6.47 22 12 22C17.53 22 22 17.53 22 12C22 6.47 17.53 2 12 2ZM12 20C7.59 20 4 16.41 4 12C4 7.59 7.59 4 12 4C16.41 4 20 7.59 20 12C20 16.41 16.41 20 12 20ZM12 10.59L15.59 7L17 8.41L13.41 12L17 15.59L15.59 17L12 13.41L8.41 17L7 15.59L10.59 12L7 8.41L8.41 7L12 10.59Z")
                ]), h)
            ]))
        ]));
    }, Xj = function(n) {
        return A3(Vj, "svg", $(k([
            A2(Vx, "width", "16"),
            A2(Vx, "height", "16"),
            A2(Vx, "viewBox", "0 0 16 16"),
            A2(Vx, "fill", "none"),
            A2(Vx, "xmlns", "http://www.w3.org/2000/svg")
        ]), n), k([
            A3(Vj, "path", k([
                A2(Vx, "fill-rule", "evenodd"),
                A2(Vx, "clip-rule", "evenodd"),
                A2(Vx, "d", "M14.7597 2.67373C14.4519 2.39656 13.9777 2.42142 13.7005 2.72924L5.29636 12.063L2.31029 8.74663C2.03313 8.43881 1.55891 8.41395 1.25109 8.69112C0.943267 8.96828 0.918414 9.4425 1.19558 9.75032L4.72872 13.6743C4.92781 13.8954 5.22858 13.9705 5.49632 13.8925C5.63593 13.8575 5.76699 13.782 5.87054 13.667L14.8152 3.73293C15.0924 3.42511 15.0675 2.95089 14.7597 2.67373Z")
            ]), h)
        ]));
    }, Gj = function(n) {
        return A3(Vj, "svg", $(k([
            A2(Vx, "xmlns", "http://www.w3.org/2000/svg"),
            A2(Vx, "viewBox", "0 0 64 64")
        ]), n), k([
            A3(Vj, "path", k([
                A2(Vx, "d", "M27.5663 46.5663L49.8913 24.2413L45.458 19.808L27.5663 37.6997L18.5413 28.6747L14.108 33.108L27.5663 46.5663ZM31.9997 63.6663C27.6191 63.6663 23.5025 62.8351 19.6497 61.1726C15.7969 59.5101 12.4455 57.2538 9.59551 54.4038C6.74551 51.5538 4.48926 48.2025 2.82676 44.3497C1.16426 40.4969 0.333008 36.3802 0.333008 31.9997C0.333008 27.6191 1.16426 23.5025 2.82676 19.6497C4.48926 15.7969 6.74551 12.4455 9.59551 9.59551C12.4455 6.74551 15.7969 4.48926 19.6497 2.82676C23.5025 1.16426 27.6191 0.333008 31.9997 0.333008C36.3802 0.333008 40.4969 1.16426 44.3497 2.82676C48.2025 4.48926 51.5538 6.74551 54.4038 9.59551C57.2538 12.4455 59.5101 15.7969 61.1726 19.6497C62.8351 23.5025 63.6663 27.6191 63.6663 31.9997C63.6663 36.3802 62.8351 40.4969 61.1726 44.3497C59.5101 48.2025 57.2538 51.5538 54.4038 54.4038C51.5538 57.2538 48.2025 59.5101 44.3497 61.1726C40.4969 62.8351 36.3802 63.6663 31.9997 63.6663ZM31.9997 57.333C39.0719 57.333 45.0622 54.8788 49.9705 49.9705C54.8788 45.0622 57.333 39.0719 57.333 31.9997C57.333 24.9275 54.8788 18.9372 49.9705 14.0288C45.0622 9.12051 39.0719 6.66634 31.9997 6.66634C24.9275 6.66634 18.9372 9.12051 14.0288 14.0288C9.12051 18.9372 6.66634 24.9275 6.66634 31.9997C6.66634 39.0719 9.12051 45.0622 14.0288 49.9705C18.9372 54.8788 24.9275 57.333 31.9997 57.333Z")
            ]), h)
        ]));
    }, Jj = function(n) {
        return A3(Vj, "svg", $(k([
            A2(Vx, "viewBox", "0 0 21 18"),
            A2(Vx, "fill", "none"),
            A2(Vx, "xmlns", "http://www.w3.org/2000/svg")
        ]), n), k([
            A3(Vj, "path", k([
                A2(Vx, "d", "M18 0H2C0.9 0 0.00999999 0.9 0.00999999 2L0 14C0 15.1 0.9 16 2 16H10V14H2V4L10 9L18 4V9H20V2C20 0.9 19.1 0 18 0ZM10 7L2 2H18L10 7ZM15.34 18L11.8 14.46L13.21 13.05L15.33 15.17L19.57 10.93L21 12.34L15.34 18Z"),
                A2(Vx, "fill", "#43749F")
            ]), h)
        ]));
    }, Yj = function(n) {
        return A3(Vj, "svg", $(k([
            A2(Vx, "xmlns", "http://www.w3.org/2000/svg"),
            A2(Vx, "viewBox", "0 0 24 24")
        ]), n), k([
            A3(Vj, "path", k([
                A2(Vx, "d", "M0 0h24v24H0V0z"),
                A2(Vx, "fill", "none")
            ]), h),
            A3(Vj, "path", k([
                A2(Vx, "d", "M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12 19 6.41z")
            ]), h)
        ]));
    }, Qj = function(n) {
        return A3(Vj, "svg", $(k([
            A2(Vx, "viewBox", "0 0 13 16"),
            A2(Vx, "xmlns", "http://www.w3.org/2000/svg")
        ]), n), k([
            A3(Vj, "path", k([
                A2(Vx, "d", "M1.21875 16C0.89375 16 0.609375 15.88 0.365625 15.64C0.121875 15.4 0 15.12 0 14.8V1.2C0 0.88 0.121875 0.6 0.365625 0.36C0.609375 0.12 0.89375 0 1.21875 0H8.55156L13 4.38V14.8C13 15.12 12.8781 15.4 12.6344 15.64C12.3906 15.88 12.1062 16 11.7812 16H1.21875ZM7.94219 4.92V1.2H1.21875V14.8H11.7812V4.92H7.94219Z")
            ]), h)
        ]));
    }, Kj = function(n) {
        return A3(Vj, "svg", $(k([
            A2(Vx, "xmlns", "http://www.w3.org/2000/svg"),
            A2(Vx, "viewBox", "0 0 24 24")
        ]), n), k([
            A3(Vj, "g", h, k([
                A3(Vj, "path", k([
                    A2(Vx, "d", "M8 18H16V16H8V18ZM8 14H16V12H8V14ZM6 22C5.45 22 4.97917 21.8042 4.5875 21.4125C4.19583 21.0208 4 20.55 4 20V4C4 3.45 4.19583 2.97917 4.5875 2.5875C4.97917 2.19583 5.45 2 6 2H14L20 8V20C20 20.55 19.8042 21.0208 19.4125 21.4125C19.0208 21.8042 18.55 22 18 22H6ZM13 9V4H6V20H18V9H13Z")
                ]), h)
            ]))
        ]));
    }, nS = function(n) {
        return A3(Vj, "svg", $(k([
            A2(Vx, "xmlns", "http://www.w3.org/2000/svg"),
            A2(Vx, "viewBox", "0 0 24 24")
        ]), n), k([
            A3(Vj, "path", k([
                A2(Vx, "d", "M0 0h24v24H0z"),
                A2(Vx, "fill", "none")
            ]), h),
            A3(Vj, "path", k([
                A2(Vx, "d", "M9 16.2L4.8 12l-1.4 1.4L9 19 21 7l-1.4-1.4L9 16.2z")
            ]), h)
        ]));
    }, rS = function(n) {
        return A3(Vj, "svg", $(k([
            A2(Vx, "width", "29"),
            A2(Vx, "height", "16"),
            A2(Vx, "viewBox", "0 0 29 16"),
            A2(Vx, "fill", "none"),
            A2(Vx, "xmlns", "http://www.w3.org/2000/svg")
        ]), n), k([
            A3(Vj, "path", k([
                A2(Vx, "d", "M21.0955 2.68835C21.5944 2.21659 21.5944 1.42258 21.0955 0.950811C20.6345 0.514858 19.9133 0.514858 19.4523 0.950811L13.3676 6.70512C12.8687 7.17688 12.8687 7.97089 13.3676 8.44266C13.8286 8.87861 14.5498 8.87861 15.0108 8.44266L21.0955 2.68835ZM28.0716 0.947913C27.6086 0.513167 26.8871 0.51444 26.4257 0.950816L14.6514 12.0857C14.392 12.3311 13.9862 12.3313 13.7265 12.0863L9.85215 8.4311C9.39079 7.99583 8.66991 7.99626 8.20907 8.43208C7.70993 8.90411 7.70993 9.69858 8.20907 10.1706L13.6305 15.2977C13.944 15.5941 14.4344 15.5941 14.7479 15.2977L28.0747 2.69452C28.5765 2.21993 28.5751 1.42073 28.0716 0.947913ZM1.23207 8.43004C0.728769 8.90266 0.72736 9.70153 1.22899 10.1759L6.38152 15.0487C6.84272 15.4848 7.56428 15.4848 8.02548 15.0487C8.52426 14.577 8.52462 13.7832 8.02626 13.311L2.87809 8.43368C2.41694 7.99679 1.69514 7.9952 1.23207 8.43004Z"),
                A2(Vx, "fill", "#2F88E7")
            ]), h)
        ]));
    }, tS = function(n) {
        return A3(Vj, "svg", $(k([
            A2(Vx, "viewBox", "0 0 16 17"),
            A2(Vx, "fill", "none"),
            A2(Vx, "xmlns", "http://www.w3.org/2000/svg")
        ]), n), k([
            A3(Vj, "path", k([
                A2(Vx, "d", "M8 12.675L3.175 7.85L4.25 6.775L7.25 9.775V0.5H8.75V9.775L11.75 6.775L12.825 7.85L8 12.675ZM1.5 16.5C1.1 16.5 0.75 16.35 0.45 16.05C0.15 15.75 0 15.4 0 15V11.425H1.5V15H14.5V11.425H16V15C16 15.4 15.85 15.75 15.55 16.05C15.25 16.35 14.9 16.5 14.5 16.5H1.5Z")
            ]), h)
        ]));
    }, eS = function(n) {
        return A3(Vj, "svg", $(k([
            A2(Vx, "viewBox", "0 0 48 48"),
            A2(Vx, "fill", "none"),
            A2(Vx, "xmlns", "http://www.w3.org/2000/svg")
        ]), n), k([
            A3(Vj, "mask", k([
                A2(Vx, "id", "mask0_641_312"),
                A2(Vx, "style", "mask-type:alpha"),
                A2(Vx, "maskUnits", "userSpaceOnUse"),
                A2(Vx, "x", "0"),
                A2(Vx, "y", "0"),
                A2(Vx, "width", "48"),
                A2(Vx, "height", "48")
            ]), k([
                A3(Vj, "rect", k([
                    A2(Vx, "width", "48"),
                    A2(Vx, "height", "48"),
                    A2(Vx, "fill", "#D9D9D9")
                ]), h)
            ])),
            A3(Vj, "g", k([
                A2(Vx, "mask", "url(#mask0_641_312)")
            ]), k([
                A3(Vj, "path", k([
                    A2(Vx, "d", "M26.0145 16.5C26.2715 16.5 26.5 16.5667 26.7 16.7C26.9 16.8333 27.0833 17 27.25 17.2L30.8 22.5H40.2065C40.4712 21.8523 40.6695 21.1952 40.8015 20.5285C40.9338 19.8618 41 19.1857 41 18.5C41 15.9333 40.1675 13.7083 38.5025 11.825C36.8378 9.94167 34.7568 9 32.2595 9C31.0865 9 29.9583 9.24167 28.875 9.725C27.7917 10.2083 26.85 10.8833 26.05 11.75L24.7 13.2C24.6 13.3 24.5 13.3833 24.4 13.45C24.3 13.5167 24.1667 13.55 24 13.55C23.8333 13.55 23.6893 13.5187 23.568 13.456C23.447 13.393 23.341 13.3077 23.25 13.2L21.9 11.75C21.091 10.8893 20.147 10.2158 19.068 9.7295C17.9893 9.24317 16.8667 9 15.7 9C13.2143 9 11.1428 9.94067 9.4855 11.822C7.8285 13.7033 7 15.9293 7 18.5C7 19.1907 7.06667 19.8717 7.2 20.543C7.33333 21.2143 7.5275 21.8667 7.7825 22.5H18C18.2527 22.5 18.4925 22.5602 18.7195 22.6805C18.9468 22.8008 19.1237 22.9573 19.25 23.15L21.55 26.65L24.55 17.55C24.6527 17.25 24.839 17 25.109 16.8C25.3787 16.6 25.6805 16.5 26.0145 16.5Z"),
                    A2(Vx, "fill", "white")
                ]), h),
                A3(Vj, "path", k([
                    A2(Vx, "d", "M24 42C23.4 42 22.825 41.8917 22.275 41.675C21.725 41.4583 21.2333 41.1333 20.8 40.7L7.4 27.25C6.23333 26.0833 5.375 24.75 4.825 23.25C4.275 21.75 4 20.1833 4 18.55C4 15.1167 5.11667 12.1667 7.35 9.7C9.58333 7.23333 12.3667 6 15.7 6C17.3 6 18.8083 6.31667 20.225 6.95C21.6417 7.58333 22.9 8.46667 24 9.6C25.0667 8.46667 26.3083 7.58333 27.725 6.95C29.1417 6.31667 30.65 6 32.25 6C35.5833 6 38.375 7.23333 40.625 9.7C42.875 12.1667 44 15.1 44 18.5C44 20.1333 43.7167 21.7 43.15 23.2C42.5833 24.7 41.7333 26.0333 40.6 27.2L27.15 40.7C26.7167 41.1333 26.2333 41.4583 25.7 41.675C25.1667 41.8917 24.6 42 24 42ZM26.0145 16.5C26.2715 16.5 26.5 16.5667 26.7 16.7C26.9 16.8333 27.0833 17 27.25 17.2L30.8 22.5H40.2065C40.4712 21.8523 40.6695 21.1952 40.8015 20.5285C40.9338 19.8618 41 19.1857 41 18.5C41 15.9333 40.1675 13.7083 38.5025 11.825C36.8378 9.94167 34.7568 9 32.2595 9C31.0865 9 29.9583 9.24167 28.875 9.725C27.7917 10.2083 26.85 10.8833 26.05 11.75L24.7 13.2C24.6 13.3 24.5 13.3833 24.4 13.45C24.3 13.5167 24.1667 13.55 24 13.55C23.8333 13.55 23.6893 13.5187 23.568 13.456C23.447 13.393 23.341 13.3077 23.25 13.2L21.9 11.75C21.091 10.8893 20.147 10.2158 19.068 9.7295C17.9893 9.24317 16.8667 9 15.7 9C13.2143 9 11.1428 9.94067 9.4855 11.822C7.8285 13.7033 7 15.9293 7 18.5C7 19.1907 7.06667 19.8717 7.2 20.543C7.33333 21.2143 7.5275 21.8667 7.7825 22.5H18C18.2527 22.5 18.4925 22.5602 18.7195 22.6805C18.9468 22.8008 19.1237 22.9573 19.25 23.15L21.55 26.65L24.55 17.55C24.6527 17.25 24.839 17 25.109 16.8C25.3787 16.6 25.6805 16.5 26.0145 16.5ZM26.45 21.35L23.4 30.45C23.301 30.75 23.1152 31 22.8425 31.2C22.5698 31.4 22.2723 31.5 21.95 31.5C21.6833 31.5 21.45 31.4333 21.25 31.3C21.05 31.1667 20.8833 31 20.75 30.8L17.2 25.5H9.9L22.95 38.55C23.1167 38.7167 23.28 38.8333 23.44 38.9C23.6 38.9667 23.7867 39 24 39C24.2133 39 24.4 38.9667 24.56 38.9C24.72 38.8333 24.8833 38.7167 25.05 38.55L38.05 25.5H30C29.7333 25.5 29.5 25.4333 29.3 25.3C29.1 25.1667 28.9167 25 28.75 24.8L26.45 21.35Z"),
                    A2(Vx, "fill", "currentColor")
                ]), h)
            ]))
        ]));
    }, uS = function(n) {
        return A3(Vj, "svg", $(k([
            A2(Vx, "xmlns", "http://www.w3.org/2000/svg"),
            A2(Vx, "height", "24px"),
            A2(Vx, "viewBox", "0 -960 960 960"),
            A2(Vx, "width", "24px"),
            A2(Vx, "fill", "#1f1f1f")
        ]), n), k([
            A3(Vj, "path", k([
                A2(Vx, "d", "M200-120q-33 0-56.5-23.5T120-200v-560q0-33 23.5-56.5T200-840h357l-80 80H200v560h560v-278l80-80v358q0 33-23.5 56.5T760-120H200Zm280-360ZM360-360v-170l367-367q12-12 27-18t30-6q16 0 30.5 6t26.5 18l56 57q11 12 17 26.5t6 29.5q0 15-5.5 29.5T897-728L530-360H360Zm481-424-56-56 56 56ZM440-440h56l232-232-28-28-29-28-231 231v57Zm260-260-29-28 29 28 28 28-28-28Z")
            ]), h)
        ]));
    }, aS = function(n) {
        return A3(Vj, "svg", $(k([
            A2(Vx, "viewBox", "0 0 48 48"),
            A2(Vx, "fill", "none"),
            A2(Vx, "xmlns", "http://www.w3.org/2000/svg")
        ]), n), k([
            A3(Vj, "mask", k([
                A2(Vx, "id", "mask0_641_316"),
                A2(Vx, "style", "mask-type:alpha"),
                A2(Vx, "maskUnits", "userSpaceOnUse"),
                A2(Vx, "x", "0"),
                A2(Vx, "y", "0"),
                A2(Vx, "width", "48"),
                A2(Vx, "height", "48")
            ]), k([
                A3(Vj, "rect", k([
                    A2(Vx, "width", "48"),
                    A2(Vx, "height", "48"),
                    A2(Vx, "fill", "#D9D9D9")
                ]), h)
            ])),
            A3(Vj, "g", k([
                A2(Vx, "mask", "url(#mask0_641_316)")
            ]), k([
                A3(Vj, "rect", k([
                    A2(Vx, "x", "8"),
                    A2(Vx, "y", "17"),
                    A2(Vx, "width", "32"),
                    A2(Vx, "height", "25"),
                    A2(Vx, "fill", "white")
                ]), h),
                A3(Vj, "path", k([
                    A2(Vx, "d", "M29.841 37C28.4803 37 27.3333 36.5303 26.4 35.591C25.4667 34.6513 25 33.5013 25 32.141C25 30.7803 25.4697 29.6333 26.409 28.7C27.3487 27.7667 28.4987 27.3 29.859 27.3C31.2197 27.3 32.3667 27.7697 33.3 28.709C34.2333 29.6487 34.7 30.7987 34.7 32.159C34.7 33.5197 34.2303 34.6667 33.291 35.6C32.3513 36.5333 31.2013 37 29.841 37ZM9 44C8.2 44 7.5 43.7 6.9 43.1C6.3 42.5 6 41.8 6 41V10C6 9.2 6.3 8.5 6.9 7.9C7.5 7.3 8.2 7 9 7H12.25V4H15.5V7H32.5V4H35.75V7H39C39.8 7 40.5 7.3 41.1 7.9C41.7 8.5 42 9.2 42 10V41C42 41.8 41.7 42.5 41.1 43.1C40.5 43.7 39.8 44 39 44H9ZM9 41H39V19.5H9V41ZM9 16.5H39V10H9V16.5Z"),
                    A2(Vx, "fill", "currentColor")
                ]), h)
            ]))
        ]));
    }, iS = function(n) {
        return A3(Vj, "svg", $(k([
            A2(Vx, "width", "24"),
            A2(Vx, "height", "24"),
            A2(Vx, "viewBox", "0 0 24 24"),
            A2(Vx, "fill", "none"),
            A2(Vx, "xmlns", "http://www.w3.org/2000/svg")
        ]), n), k([
            A3(Vj, "path", k([
                A2(Vx, "fill-rule", "evenodd"),
                A2(Vx, "clip-rule", "evenodd"),
                A2(Vx, "d", "M12 1.6875C13.3922 1.6875 14.7422 1.95938 16.0125 2.49609C17.2406 3.01641 18.3422 3.75937 19.2914 4.70625C20.2383 5.65312 20.9836 6.75703 21.5016 7.98516C22.0406 9.25781 22.3125 10.6078 22.3125 12C22.3125 13.3922 22.0406 14.7422 21.5039 16.0125C20.9836 17.2406 20.2406 18.3422 19.2938 19.2914C18.3469 20.2383 17.243 20.9836 16.0148 21.5016C14.7422 22.0406 13.3922 22.3125 12 22.3125C10.6078 22.3125 9.25781 22.0406 7.9875 21.5039C6.75938 20.9836 5.65781 20.2406 4.70859 19.2937C3.76172 18.3469 3.01641 17.243 2.49844 16.0148C1.95938 14.7422 1.6875 13.3922 1.6875 12C1.6875 10.6078 1.95938 9.25781 2.49609 7.9875C3.01641 6.75937 3.75938 5.65781 4.70625 4.70859C5.65312 3.76172 6.75703 3.01641 7.98516 2.49844C9.25781 1.95938 10.6078 1.6875 12 1.6875ZM12 0C5.37187 0 0 5.37188 0 12C0 18.6281 5.37187 24 12 24C18.6281 24 24 18.6281 24 12C24 5.37188 18.6281 0 12 0ZM12 15C11.482 15 11.0625 14.5805 11.0625 14.0625V5.41406C11.0625 4.89609 11.482 4.47656 12 4.47656C12.518 4.47656 12.9375 4.89609 12.9375 5.41406V14.0625C12.9375 14.5805 12.518 15 12 15ZM10.9453 17.5547C10.9453 16.9722 11.4175 16.5 12 16.5C12.5825 16.5 13.0547 16.9722 13.0547 17.5547C13.0547 18.1372 12.5825 18.6094 12 18.6094C11.4175 18.6094 10.9453 18.1372 10.9453 17.5547Z"),
                A2(Vx, "fill", "#FAAD14")
            ]), h)
        ]));
    }, cS = function(n) {
        return A3(Vj, "svg", $(k([
            A2(Vx, "width", "15"),
            A2(Vx, "height", "17"),
            A2(Vx, "viewBox", "0 0 15 17"),
            A2(Vx, "fill", "none"),
            A2(Vx, "xmlns", "http://www.w3.org/2000/svg")
        ]), n), k([
            A3(Vj, "path", k([
                A2(Vx, "d", "M9.4 2L9.16 0.8C9.07 0.34 8.66 0 8.18 0H1C0.45 0 0 0.45 0 1V16C0 16.55 0.45 17 1 17C1.55 17 2 16.55 2 16V10H7.6L7.84 11.2C7.93 11.67 8.34 12 8.82 12H14C14.55 12 15 11.55 15 11V3C15 2.45 14.55 2 14 2H9.4Z"),
                A2(Vx, "fill", "black")
            ]), h)
        ]));
    }, oS = function(n) {
        return A3(Vj, "svg", $(k([
            A2(Vx, "viewBox", "0 0 14 14"),
            A2(Vx, "xmlns", "http://www.w3.org/2000/svg")
        ]), n), k([
            A3(Vj, "path", k([
                A2(Vx, "d", "M13.7031 4.42188L13 5.125L10.875 3L11.5938 2.29688C11.7812 2.09896 12.013 2 12.2891 2C12.5651 2 12.8021 2.09896 13 2.29688L13.7031 3C13.901 3.19792 14 3.4349 14 3.71094C14 3.98698 13.901 4.22396 13.7031 4.42188ZM10.2656 3.60938L12.3906 5.73438L7.96875 10.1562L7.07812 11H5V8.92188L5.84375 8.03125L10.2656 3.60938ZM10.9688 5.73438L10.2656 5.03125L6.01562 9.26562L6.73438 9.98438L10.9688 5.73438ZM3 9H4V8H3V9ZM3 7H6V6H3V7ZM7 4H3V5H7V4ZM3 11H4V10H3V11ZM11 13H1V1H8V4L10.5 1.5L9 0H1C0.71875 0 0.481771 0.0963545 0.289062 0.289062C0.0963542 0.481771 0 0.71875 0 1V13C0 13.2812 0.0963542 13.5182 0.289062 13.7109C0.481771 13.9036 0.71875 14 1 14H11C11.2812 14 11.5182 13.9036 11.7109 13.7109C11.9036 13.5182 12 13.2812 12 13V7.53125L11 8.53125V13Z")
            ]), h)
        ]));
    }, fS = function(n) {
        return A3(Vj, "svg", $(k([
            A2(Vx, "viewBox", "0 0 48 48"),
            A2(Vx, "fill", "none"),
            A2(Vx, "xmlns", "http://www.w3.org/2000/svg")
        ]), n), k([
            A3(Vj, "mask", k([
                A2(Vx, "id", "mask0_641_308"),
                A2(Vx, "style", "mask-type:alpha"),
                A2(Vx, "maskUnits", "userSpaceOnUse"),
                A2(Vx, "x", "0"),
                A2(Vx, "y", "0"),
                A2(Vx, "width", "48"),
                A2(Vx, "height", "48")
            ]), k([
                A3(Vj, "rect", k([
                    A2(Vx, "width", "48"),
                    A2(Vx, "height", "48"),
                    A2(Vx, "fill", "#D9D9D9")
                ]), h)
            ])),
            A3(Vj, "g", k([
                A2(Vx, "mask", "url(#mask0_641_308)")
            ]), k([
                A3(Vj, "path", k([
                    A2(Vx, "d", "M6 6H32V24H11L6 29V6Z"),
                    A2(Vx, "fill", "white")
                ]), h),
                A3(Vj, "path", k([
                    A2(Vx, "d", "M44 43.95L36.05 36H15C14.175 36 13.4688 35.7062 12.8815 35.1185C12.2938 34.5312 12 33.825 12 33V29H34C34.825 29 35.5313 28.7062 36.119 28.1185C36.7063 27.5312 37 26.825 37 26V12H41C41.825 12 42.5313 12.2937 43.119 12.881C43.7063 13.4687 44 14.175 44 15V43.95ZM7 26.75L10.75 23H31V7H7V26.75ZM4 34V7C4 6.175 4.29383 5.46867 4.8815 4.881C5.46883 4.29367 6.175 4 7 4H31C31.825 4 32.5313 4.29367 33.119 4.881C33.7063 5.46867 34 6.175 34 7V23C34 23.825 33.7063 24.5312 33.119 25.1185C32.5313 25.7062 31.825 26 31 26H12L4 34Z"),
                    A2(Vx, "fill", "currentColor")
                ]), h)
            ]))
        ]));
    }, sS = function(n) {
        return A3(Vj, "svg", $(k([
            A2(Vx, "xmlns", "http://www.w3.org/2000/svg"),
            A2(Vx, "height", "24px"),
            A2(Vx, "viewBox", "0 -960 960 960"),
            A2(Vx, "width", "24px"),
            A2(Vx, "fill", "#1f1f1f")
        ]), n), k([
            A3(Vj, "path", k([
                A2(Vx, "d", "M40-160v-112q0-34 17.5-62.5T104-378q62-31 126-46.5T360-440q66 0 130 15.5T616-378q29 15 46.5 43.5T680-272v112H40Zm720 0v-120q0-44-24.5-84.5T666-434q51 6 96 20.5t84 35.5q36 20 55 44.5t19 53.5v120H760ZM360-480q-66 0-113-47t-47-113q0-66 47-113t113-47q66 0 113 47t47 113q0 66-47 113t-113 47Zm400-160q0 66-47 113t-113 47q-11 0-28-2.5t-28-5.5q27-32 41.5-71t14.5-81q0-42-14.5-81T544-792q14-5 28-6.5t28-1.5q66 0 113 47t47 113ZM120-240h480v-32q0-11-5.5-20T580-306q-54-27-109-40.5T360-360q-56 0-111 13.5T140-306q-9 5-14.5 14t-5.5 20v32Zm240-320q33 0 56.5-23.5T440-640q0-33-23.5-56.5T360-720q-33 0-56.5 23.5T280-640q0 33 23.5 56.5T360-560Zm0 320Zm0-400Z")
            ]), h)
        ]));
    }, lS = function(n) {
        return A3(Vj, "svg", $(k([
            A2(Vx, "xmlns", "http://www.w3.org/2000/svg"),
            A2(Vx, "viewBox", "0 0 24 24")
        ]), n), k([
            A3(Vj, "path", k([
                A2(Vx, "d", "M0 0h24v24H0z"),
                A2(Vx, "fill", "none")
            ]), h),
            A3(Vj, "path", k([
                A2(Vx, "d", "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-6h2v6zm0-8h-2V7h2v2z")
            ]), h)
        ]));
    }, dS = function(n) {
        return A3(Vj, "svg", $(k([
            A2(Vx, "viewBox", "0 0 16 16"),
            A2(Vx, "xmlns", "http://www.w3.org/2000/svg")
        ]), n), k([
            A3(Vj, "path", k([
                A2(Vx, "d", "M3.16942 16C2.5668 16 2.05458 15.7851 1.63275 15.3553C1.21092 14.9254 1 14.4035 1 13.7895V11.1579H3.62397V1C3.62397 0.447715 4.07168 0 4.62397 0H15C15.5523 0 16 0.447715 16 1V13.7895C16 14.4035 15.7891 14.9254 15.3673 15.3553C14.9454 15.7851 14.4332 16 13.8306 16H3.16942ZM13.8306 14.7368C14.1061 14.7368 14.3299 14.6491 14.5021 14.4737C14.6742 14.2982 14.7603 14.0702 14.7603 13.7895V1.26316H4.86364V11.1579H12.9008V13.7895C12.9008 14.0702 12.9869 14.2982 13.1591 14.4737C13.3313 14.6491 13.5551 14.7368 13.8306 14.7368ZM5.95868 4.58947V3.32632H10.9174V4.58947H5.95868ZM5.95868 7.41053V6.14737H10.9174V7.41053H5.95868ZM12.8388 4.58947C12.6736 4.58947 12.5289 4.52632 12.405 4.4C12.281 4.27368 12.219 4.12632 12.219 3.9579C12.219 3.78947 12.281 3.64211 12.405 3.51579C12.5289 3.38947 12.6736 3.32632 12.8388 3.32632C13.0041 3.32632 13.1488 3.38947 13.2727 3.51579C13.3967 3.64211 13.4587 3.78947 13.4587 3.9579C13.4587 4.12632 13.3967 4.27368 13.2727 4.4C13.1488 4.52632 13.0041 4.58947 12.8388 4.58947ZM12.8388 7.30526C12.6736 7.30526 12.5289 7.24211 12.405 7.11579C12.281 6.98947 12.219 6.8421 12.219 6.67368C12.219 6.50526 12.281 6.3579 12.405 6.23158C12.5289 6.10526 12.6736 6.04211 12.8388 6.04211C13.0041 6.04211 13.1488 6.10526 13.2727 6.23158C13.3967 6.3579 13.4587 6.50526 13.4587 6.67368C13.4587 6.8421 13.3967 6.98947 13.2727 7.11579C13.1488 7.24211 13.0041 7.30526 12.8388 7.30526ZM3.14876 14.7368H11.6612V12.4211H2.23967V13.7895C2.23967 14.0702 2.32679 14.2982 2.50103 14.4737C2.67528 14.6491 2.89118 14.7368 3.14876 14.7368Z")
            ]), h)
        ]));
    }, bS = function(n) {
        return A3(Vj, "svg", $(k([
            A2(Vx, "viewBox", "0 0 16 16"),
            A2(Vx, "xmlns", "http://www.w3.org/2000/svg")
        ]), n), k([
            A3(Vj, "path", k([
                A2(Vx, "fill-rule", "evenodd"),
                A2(Vx, "clip-rule", "evenodd"),
                A2(Vx, "d", "M0.142327 15.1333C0.393436 15.7111 0.816832 16 1.41251 16H14.5875C15.1832 16 15.6066 15.7111 15.8577 15.1333C16.1088 14.5556 16.0276 14.0296 15.6141 13.5556L10.3099 7.33333V1.33333H11.4221C11.6039 1.33333 11.7563 1.27037 11.8792 1.14444C12.0022 1.01852 12.0637 0.860555 12.0637 0.670555C12.0637 0.48057 12.0022 0.321311 11.8792 0.192778C11.7563 0.064259 11.6039 0 11.4221 0H4.57793C4.39613 0 4.24374 0.062963 4.12076 0.188889C3.99778 0.314815 3.93629 0.472778 3.93629 0.662778C3.93629 0.852763 3.99778 1.01202 4.12076 1.14056C4.24374 1.26907 4.39613 1.33333 4.57793 1.33333H5.6901V7.33333L0.385893 13.5556C-0.0276069 14.0296 -0.108796 14.5556 0.142327 15.1333ZM4.55571 10.6667H11.4443L9.02662 7.82222V1.33333H6.97338V7.82222L4.55571 10.6667Z")
            ]), h)
        ]));
    }, vS = function(n) {
        return A3(Vj, "svg", $(k([
            A2(Vx, "viewBox", "0 0 24 24"),
            A2(Vx, "xmlns", "http://www.w3.org/2000/svg")
        ]), n), k([
            A3(Vj, "path", k([
                A2(Vx, "fill-rule", "evenodd"),
                A2(Vx, "clip-rule", "evenodd"),
                A2(Vx, "d", "M15.7071 4.29289C16.0976 4.68342 16.0976 5.31658 15.7071 5.70711L9.41421 12L15.7071 18.2929C16.0976 18.6834 16.0976 19.3166 15.7071 19.7071C15.3166 20.0976 14.6834 20.0976 14.2929 19.7071L7.29289 12.7071C7.10536 12.5196 7 12.2652 7 12C7 11.7348 7.10536 11.4804 7.29289 11.2929L14.2929 4.29289C14.6834 3.90237 15.3166 3.90237 15.7071 4.29289Z")
            ]), h)
        ]));
    }, mS = function(n) {
        return A3(Vj, "svg", $(k([
            A2(Vx, "xmlns", "http://www.w3.org/2000/svg"),
            A2(Vx, "viewBox", "0 0 24 24")
        ]), n), k([
            A3(Vj, "path", k([
                A2(Vx, "d", "M0 0h24v24H0z"),
                A2(Vx, "fill", "none")
            ]), h),
            A3(Vj, "path", k([
                A2(Vx, "d", "M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z")
            ]), h)
        ]));
    }, pS = function(n) {
        return A3(Vj, "svg", $(k([
            A2(Vx, "version", "1.1"),
            A2(Vx, "id", "Layer_1"),
            A2(Vx, "xmlns", "http://www.w3.org/2000/svg"),
            A2(Vx, "x", "0px"),
            A2(Vx, "y", "0px"),
            A2(Vx, "viewBox", "0 -15 512 540"),
            A2(Vx, "style", "enable-background:new 0 -15 512 540;"),
            A2(Vx, "xml:space", "preserve")
        ]), n), k([
            A3(Vj, "path", k([
                A2(Vx, "d", "M87.084,192c-0.456-5.272-0.688-10.6-0.688-16C86.404,78.8,162.34,0,256.004,0s169.6,78.8,169.6,176\r\n\tc0,5.392-0.232,10.728-0.688,16h0.688c0,96.184-169.6,320-169.6,320s-169.6-223.288-169.6-320H87.084z M256.004,224\r\n\tc36.392,1.024,66.744-27.608,67.84-64c-1.096-36.392-31.448-65.024-67.84-64c-36.392-1.024-66.744,27.608-67.84,64\r\n\tC189.26,196.392,219.612,225.024,256.004,224z")
            ]), h)
        ]));
    }, $S = function(n) {
        return A3(Vj, "svg", $(k([
            A2(Vx, "viewBox", "0 0 13 16"),
            A2(Vx, "xmlns", "http://www.w3.org/2000/svg")
        ]), n), k([
            A3(Vj, "path", k([
                A2(Vx, "d", "M11.9167 1.06667H8.37891C8.18707 0.744444 7.92752 0.486111 7.60026 0.291666C7.273 0.0972214 6.90625 0 6.5 0C6.09375 0 5.727 0.0972214 5.39974 0.291666C5.07248 0.486111 4.81293 0.744444 4.62109 1.06667H1.08333C0.778646 1.06667 0.521918 1.16944 0.313151 1.375C0.104384 1.58055 0 1.83333 0 2.13333V14.9333C0 15.2333 0.104384 15.4861 0.313151 15.6917C0.521918 15.8972 0.778646 16 1.08333 16H11.9167C12.2214 16 12.4781 15.8972 12.6868 15.6917C12.8956 15.4861 13 15.2333 13 14.9333V2.13333C13 1.83333 12.8956 1.58055 12.6868 1.375C12.4781 1.16944 12.2214 1.06667 11.9167 1.06667ZM6.5 1.06667C6.80469 1.06667 7.06141 1.16944 7.27018 1.375C7.47895 1.58055 7.58333 1.83333 7.58333 2.13333H5.41667C5.41667 1.83333 5.52105 1.58055 5.72982 1.375C5.93858 1.16944 6.19531 1.06667 6.5 1.06667ZM11.9167 14.9333H1.08333V2.13333H3.25V4.26667H9.75V2.13333H11.9167V14.9333ZM10.8333 7.46667H2.16667V6.4H10.8333V7.46667ZM10.8333 9.6H2.16667V8.53333H10.8333V9.6ZM10.8333 11.7333H2.16667V10.6667H10.8333V11.7333ZM10.8333 13.8667H2.16667V12.8H10.8333V13.8667Z")
            ]), h)
        ]));
    }, hS = function(n) {
        return A3(Vj, "svg", $(k([
            A2(Vx, "viewBox", "0 0 10 18"),
            A2(Vx, "xmlns", "http://www.w3.org/2000/svg")
        ]), n), k([
            A3(Vj, "path", k([
                A2(Vx, "d", "M10 13.095C10 14.4625 9.51136 15.6218 8.53409 16.5731C7.55682 17.5244 6.37879 18 5 18C3.62121 18 2.44318 17.5312 1.46591 16.5938C0.488636 15.6562 0 14.505 0 13.14L0 3.465C0 2.51212 0.34503 1.6964 1.03509 1.01783C1.72517 0.339277 2.55471 0 3.52373 0C4.49276 0 5.32197 0.339277 6.01136 1.01783C6.70076 1.6964 7.04545 2.51212 7.04545 3.465L7.04545 12.3525C7.04545 12.9258 6.84742 13.4104 6.45134 13.8062C6.05527 14.2021 5.57042 14.4 4.9968 14.4C4.42317 14.4 3.93939 14.1937 3.54545 13.7812C3.15152 13.3687 2.95455 12.8775 2.95455 12.3075L2.95455 3.465H3.86364L3.86364 12.33C3.86364 12.645 3.97216 12.9187 4.18921 13.1512C4.40624 13.3837 4.67517 13.5 4.99602 13.5C5.31686 13.5 5.58712 13.3875 5.80682 13.1625C6.02652 12.9375 6.13636 12.6675 6.13636 12.3525L6.13636 3.465C6.13636 2.7468 5.88417 2.13975 5.3798 1.64385C4.87543 1.14795 4.25801 0.9 3.52752 0.9C2.79705 0.9 2.17803 1.14795 1.67045 1.64385C1.16288 2.13975 0.909091 2.7468 0.909091 3.465L0.909091 13.185C0.909091 14.28 1.30966 15.2062 2.1108 15.9637C2.91193 16.7212 3.875 17.1 5 17.1C6.13636 17.1 7.10227 16.7137 7.89773 15.9412C8.69318 15.1687 9.09091 14.2275 9.09091 13.1175L9.09091 3.465H10L10 13.095Z")
            ]), h)
        ]));
    }, gS = function(n) {
        return A3(Vj, "svg", $(k([
            A2(Vx, "xmlns", "http://www.w3.org/2000/svg"),
            A2(Vx, "viewBox", "0 0 16 16")
        ]), n), k([
            A3(Vj, "path", k([
                A2(Vx, "clip-rule", "evenodd"),
                A2(Vx, "d", "M6 0H0V16H6V0ZM16 0H10V16H16V0Z")
            ]), h)
        ]));
    }, wS = function(n) {
        return A3(Vj, "svg", $(k([
            A2(Vx, "viewBox", "0 0 48 48"),
            A2(Vx, "fill", "none"),
            A2(Vx, "xmlns", "http://www.w3.org/2000/svg")
        ]), n), k([
            A3(Vj, "path", k([
                A2(Vx, "d", "M24 23.95C21.65 23.95 19.6375 23.1125 17.9625 21.4375C16.2875 19.7625 15.45 17.75 15.45 15.4C15.45 13.05 16.2875 11.0375 17.9625 9.3625C19.6375 7.6875 21.65 6.85 24 6.85C26.35 6.85 28.3625 7.6875 30.0375 9.3625C31.7125 11.0375 32.55 13.05 32.55 15.4C32.55 17.75 31.7125 19.7625 30.0375 21.4375C28.3625 23.1125 26.35 23.95 24 23.95ZM7 41.15V35.95C7 34.6833 7.32083 33.5708 7.9625 32.6125C8.60417 31.6542 9.45 30.9333 10.5 30.45C12.8333 29.4167 15.1083 28.6417 17.325 28.125C19.5417 27.6083 21.7667 27.35 24 27.35C26.2333 27.35 28.4542 27.6125 30.6625 28.1375C32.8708 28.6625 35.1417 29.4333 37.475 30.45C38.5583 30.9333 39.4167 31.6542 40.05 32.6125C40.6833 33.5708 41 34.6833 41 35.95V41.15H7ZM10 38.15H38V35.95C38 35.4167 37.8458 34.9 37.5375 34.4C37.2292 33.9 36.8333 33.5333 36.35 33.3C34.1833 32.3 32.0833 31.5708 30.05 31.1125C28.0167 30.6542 26.0167 30.4 24 30.35C21.9833 30.3 19.9833 30.55 18 31.1125C16.0167 31.675 13.9167 32.4 11.7 33.3C11.2167 33.5333 10.8125 33.9 10.4875 34.4C10.1625 34.9 10 35.4167 10 35.95V38.15ZM24 20.95C25.5333 20.95 26.8333 20.4167 27.9 19.35C28.9667 18.2833 29.5 16.9833 29.5 15.45C29.5 13.9167 28.9667 12.6125 27.9 11.5375C26.8333 10.4625 25.5333 9.925 24 9.925C22.4667 9.925 21.1625 10.4625 20.0875 11.5375C19.0125 12.6125 18.475 13.9167 18.475 15.45C18.475 16.9833 19.0125 18.2833 20.0875 19.35C21.1625 20.4167 22.4667 20.95 24 20.95Z"),
                A2(Vx, "fill", "currentColor")
            ]), h)
        ]));
    }, kS = function(n) {
        return A3(Vj, "svg", $(k([
            A2(Vx, "xmlns", "http://www.w3.org/2000/svg"),
            A2(Vx, "viewBox", "0 0 14 16")
        ]), n), k([
            A3(Vj, "path", k([
                A2(Vx, "d", "M0 0L14 8L0 16V0Z")
            ]), h)
        ]));
    }, xS = function(n) {
        return A3(Vj, "svg", $(k([
            A2(Vx, "viewBox", "0 0 16 13"),
            A2(Vx, "xmlns", "http://www.w3.org/2000/svg")
        ]), n), k([
            A3(Vj, "path", k([
                A2(Vx, "d", "M11.424 8.39394V6.77273C11.424 6.69192 11.3973 6.62626 11.344 6.57576C11.2907 6.52525 11.2213 6.5 11.136 6.5H9.136V4.60606C9.136 4.52525 9.10933 4.4596 9.056 4.40909C9.00267 4.35859 8.93867 4.33333 8.864 4.33333H7.136C7.06133 4.33333 6.99733 4.35859 6.944 4.40909C6.89067 4.4596 6.864 4.52525 6.864 4.60606V6.5H4.864C4.77867 6.5 4.70933 6.52525 4.656 6.57576C4.60267 6.62626 4.576 6.69192 4.576 6.77273V8.39394C4.576 8.47475 4.60267 8.5404 4.656 8.59091C4.70933 8.64141 4.77867 8.66667 4.864 8.66667H6.864V10.5606C6.864 10.6414 6.89067 10.7071 6.944 10.7576C6.99733 10.8081 7.06133 10.8333 7.136 10.8333H8.864C8.93867 10.8333 9.00267 10.8081 9.056 10.7576C9.10933 10.7071 9.136 10.6414 9.136 10.5606V8.66667H11.136C11.2213 8.66667 11.2907 8.64141 11.344 8.59091C11.3973 8.5404 11.424 8.47475 11.424 8.39394ZM5.712 2.16667H10.288V1.09091H5.712V2.16667ZM2.288 2.16667V13H2C1.456 13 0.986667 12.8131 0.592 12.4394C0.197333 12.0657 0 11.6212 0 11.1061V4.06061C0 3.54545 0.197333 3.10101 0.592 2.72727C0.986667 2.35353 1.456 2.16667 2 2.16667H2.288ZM12.864 2.16667V13H3.136V2.16667H4.576V0.818181C4.576 0.59596 4.656 0.40404 4.816 0.242424C4.976 0.0808077 5.17867 0 5.424 0H10.576C10.8107 0 11.0133 0.0808077 11.184 0.242424C11.3547 0.40404 11.4347 0.59596 11.424 0.818181V2.16667H12.864ZM16 4.06061V11.1061C16 11.6212 15.8027 12.0657 15.408 12.4394C15.0133 12.8131 14.544 13 14 13H13.712V2.16667H14C14.544 2.16667 15.0133 2.35353 15.408 2.72727C15.8027 3.10101 16 3.54545 16 4.06061Z")
            ]), h)
        ]));
    }, yS = function(n) {
        return A3(Vj, "svg", $(k([
            A2(Vx, "xmlns", "http://www.w3.org/2000/svg"),
            A2(Vx, "viewBox", "0 0 24 24")
        ]), n), k([
            A3(Vj, "path", k([
                A2(Vx, "d", "M0 0h24v24H0V0z"),
                A2(Vx, "fill", "none")
            ]), h),
            A3(Vj, "circle", k([
                A2(Vx, "cx", "12"),
                A2(Vx, "cy", "19"),
                A2(Vx, "r", "2")
            ]), h),
            A3(Vj, "path", k([
                A2(Vx, "d", "M10 3h4v12h-4z")
            ]), h)
        ]));
    }, _S = function(n) {
        return A3(Vj, "svg", $(k([
            A2(Vx, "viewBox", "0 0 24 24"),
            A2(Vx, "fill", "none"),
            A2(Vx, "xmlns", "http://www.w3.org/2000/svg")
        ]), n), k([
            A3(Vj, "circle", k([
                A2(Vx, "cx", "12"),
                A2(Vx, "cy", "12"),
                A2(Vx, "r", "9"),
                A2(Vx, "stroke", "currentColor"),
                A2(Vx, "stroke-width", "2"),
                A2(Vx, "fill", "none")
            ]), h),
            A3(Vj, "circle", k([
                A2(Vx, "cx", "12"),
                A2(Vx, "cy", "12"),
                A2(Vx, "r", "5")
            ]), h)
        ]));
    }, CS = function(n) {
        return A3(Vj, "svg", $(k([
            A2(Vx, "viewBox", "0 0 48 48"),
            A2(Vx, "fill", "none"),
            A2(Vx, "xmlns", "http://www.w3.org/2000/svg")
        ]), n), k([
            A3(Vj, "mask", k([
                A2(Vx, "id", "mask0_641_320"),
                A2(Vx, "style", "mask-type:alpha"),
                A2(Vx, "maskUnits", "userSpaceOnUse"),
                A2(Vx, "x", "0"),
                A2(Vx, "y", "0"),
                A2(Vx, "width", "48"),
                A2(Vx, "height", "48")
            ]), k([
                A3(Vj, "rect", k([
                    A2(Vx, "width", "48"),
                    A2(Vx, "height", "48"),
                    A2(Vx, "fill", "#D9D9D9")
                ]), h)
            ])),
            A3(Vj, "g", k([
                A2(Vx, "mask", "url(#mask0_641_320)")
            ]), k([
                A3(Vj, "path", k([
                    A2(Vx, "d", "M36.9265 41.334C37.6001 41.334 38.1475 41.1235 38.5685 40.7025C38.9895 40.2815 39.2 39.7342 39.2 39.0605V9H15V32.7453H34.653V39.0605C34.653 39.7342 34.8635 40.2815 35.2846 40.7025C35.7056 41.1235 36.2529 41.334 36.9265 41.334Z"),
                    A2(Vx, "fill", "white")
                ]), h),
                A3(Vj, "path", k([
                    A2(Vx, "d", "M11.1001 44C9.64176 44 8.40226 43.4895 7.3816 42.4685C6.3606 41.4478 5.8501 40.2083 5.8501 38.75V32.5H12.2001V4L15.1901 7L18.1801 4L21.1701 7L24.1601 4L27.1501 7L30.1501 4L33.1501 7L36.1501 4L39.1501 7L42.1501 4V38.75C42.1501 40.2083 41.6398 41.4478 40.6191 42.4685C39.5981 43.4895 38.3584 44 36.9001 44H11.1001ZM36.9001 41C37.5668 41 38.1084 40.7917 38.5251 40.375C38.9418 39.9583 39.1501 39.4167 39.1501 38.75V9H15.2001V32.5H34.6501V38.75C34.6501 39.4167 34.8584 39.9583 35.2751 40.375C35.6918 40.7917 36.2334 41 36.9001 41ZM17.8501 16.9V13.9H29.8501V16.9H17.8501ZM17.8501 23.6V20.6H29.8501V23.6H17.8501ZM34.5001 16.9C34.1001 16.9 33.7501 16.75 33.4501 16.45C33.1501 16.15 33.0001 15.8 33.0001 15.4C33.0001 15 33.1501 14.65 33.4501 14.35C33.7501 14.05 34.1001 13.9 34.5001 13.9C34.9001 13.9 35.2501 14.05 35.5501 14.35C35.8501 14.65 36.0001 15 36.0001 15.4C36.0001 15.8 35.8501 16.15 35.5501 16.45C35.2501 16.75 34.9001 16.9 34.5001 16.9ZM34.5001 23.35C34.1001 23.35 33.7501 23.2 33.4501 22.9C33.1501 22.6 33.0001 22.25 33.0001 21.85C33.0001 21.45 33.1501 21.1 33.4501 20.8C33.7501 20.5 34.1001 20.35 34.5001 20.35C34.9001 20.35 35.2501 20.5 35.5501 20.8C35.8501 21.1 36.0001 21.45 36.0001 21.85C36.0001 22.25 35.8501 22.6 35.5501 22.9C35.2501 23.2 34.9001 23.35 34.5001 23.35ZM11.0501 41H31.6501V35.5H8.8501V38.75C8.8501 39.4167 9.06093 39.9583 9.4826 40.375C9.90426 40.7917 10.4268 41 11.0501 41Z"),
                    A2(Vx, "fill", "currentColor")
                ]), h)
            ]))
        ]));
    }, DS = function(n) {
        return A3(Vj, "svg", $(k([
            A2(Vx, "viewBox", "0 0 24 24"),
            A2(Vx, "xmlns", "http://www.w3.org/2000/svg")
        ]), n), k([
            A3(Vj, "path", k([
                A2(Vx, "fill-rule", "evenodd"),
                A2(Vx, "clip-rule", "evenodd"),
                A2(Vx, "d", "M8.29289 4.29289C8.68342 3.90237 9.31658 3.90237 9.70711 4.29289L16.7071 11.2929C17.0976 11.6834 17.0976 12.3166 16.7071 12.7071L9.70711 19.7071C9.31658 20.0976 8.68342 20.0976 8.29289 19.7071C7.90237 19.3166 7.90237 18.6834 8.29289 18.2929L14.5858 12L8.29289 5.70711C7.90237 5.31658 7.90237 4.68342 8.29289 4.29289Z")
            ]), h)
        ]));
    }, AS = function(n) {
        return A3(Vj, "svg", $(k([
            A2(Vx, "fill", "none"),
            A2(Vx, "xmlns", "http://www.w3.org/2000/svg")
        ]), n), k([
            A3(Vj, "path", k([
                A2(Vx, "fill-rule", "evenodd"),
                A2(Vx, "clip-rule", "evenodd"),
                A2(Vx, "d", "M5.60222 9.97513C3.15606 9.97513 1.17354 7.9902 1.17354 5.54106C1.17354 3.09193 3.15606 1.10699 5.60222 1.10699C8.04837 1.10699 10.0309 3.09193 10.0309 5.54106C10.0309 7.9902 8.04837 9.97513 5.60222 9.97513ZM9.88751 9.05021C10.6746 8.08719 11.1452 6.85569 11.1383 5.51335C11.1227 2.43721 8.62637 -0.0257772 5.55397 0.000203667C2.53347 0.0261845 0.0890486 2.47532 0.0665592 5.50122C0.0440698 8.57909 2.50406 11.0733 5.57992 11.0854C6.91718 11.0906 8.14371 10.6212 9.10384 9.83656V9.83483L13.1035 13.8376C13.3197 14.0541 13.6692 14.0541 13.8854 13.8376C14.1017 13.6211 14.1017 13.2712 13.8854 13.0547L9.88751 9.05021Z"),
                A2(Vx, "fill", "#C4DCF8")
            ]), h)
        ]));
    }, qS = function(n) {
        return A3(Vj, "svg", $(k([
            A2(Vx, "viewBox", "0 0 12 12"),
            A2(Vx, "xmlns", "http://www.w3.org/2000/svg")
        ]), n), k([
            A3(Vj, "path", k([
                A2(Vx, "d", "M5.99882 12C5.16604 12 4.38488 11.8428 3.65534 11.5283C2.92571 11.2138 2.29008 10.7854 1.74846 10.243C1.20675 9.70048 0.77993 9.06279 0.468017 8.32991C0.156006 7.59713 0 6.81435 0 5.98156C0 5.14622 0.156006 4.36565 0.468017 3.63985C0.77993 2.91396 1.20675 2.28059 1.74846 1.73976C2.29008 1.19893 2.92571 0.773784 3.65534 0.464329C4.38488 0.154776 5.16604 0 5.99882 0C6.83406 0 7.61586 0.154776 8.34422 0.464329C9.07257 0.773784 9.70756 1.19893 10.2492 1.73976C10.7909 2.28059 11.2181 2.91396 11.5308 3.63985C11.8436 4.36565 12 5.14622 12 5.98156C12 6.81435 11.8436 7.59713 11.5308 8.32991C11.2181 9.06279 10.7909 9.70048 10.2492 10.243C9.70756 10.7854 9.07257 11.2138 8.34422 11.5283C7.61586 11.8428 6.83406 12 5.99882 12ZM5.9941 10.896C6.3009 10.5451 6.56207 10.1543 6.77762 9.72363C6.99317 9.29293 7.17056 8.79645 7.3098 8.23418H4.6964C4.826 8.7702 4.99798 9.25847 5.21235 9.699C5.42672 10.1395 5.6873 10.5385 5.9941 10.896ZM4.65996 10.6993C4.4339 10.3467 4.2417 9.96799 4.08339 9.56315C3.92507 9.15841 3.79183 8.71542 3.68366 8.23418H1.64492C1.98358 8.86037 2.3867 9.3657 2.85427 9.75018C3.32194 10.1346 3.92384 10.451 4.65996 10.6993ZM7.3393 10.6895C7.99017 10.482 8.57441 10.1676 9.09204 9.74635C9.60957 9.32509 10.0286 8.82103 10.3492 8.23418H8.32268C8.20793 8.70884 8.07188 9.14858 7.91455 9.55342C7.75712 9.95816 7.56537 10.3368 7.3393 10.6895ZM1.28458 7.26142H3.49678C3.46728 7.01893 3.44845 6.79601 3.44029 6.59265C3.43203 6.3894 3.4279 6.1857 3.4279 5.98156C3.4279 5.74881 3.43365 5.53793 3.44515 5.34894C3.45666 5.15994 3.47716 4.95398 3.50666 4.73106H1.28458C1.22233 4.95319 1.17892 5.15733 1.15433 5.34348C1.12975 5.52952 1.11746 5.74222 1.11746 5.98156C1.11746 6.21845 1.12975 6.43547 1.15433 6.63263C1.17892 6.82979 1.22233 7.03938 1.28458 7.26142ZM4.49978 7.26142H7.50656C7.54098 6.99267 7.56315 6.76321 7.57309 6.57304C7.58302 6.38286 7.58798 6.1857 7.58798 5.98156C7.58798 5.78155 7.58302 5.59034 7.57309 5.40794C7.56315 5.22543 7.54098 4.9998 7.50656 4.73106H4.49978C4.46369 4.9998 4.43994 5.22543 4.42854 5.40794C4.41703 5.59034 4.41128 5.78155 4.41128 5.98156C4.41128 6.1857 4.41703 6.38286 4.42854 6.57304C4.43994 6.76321 4.46369 6.99267 4.49978 7.26142ZM8.4898 7.26142H10.7083C10.769 7.03938 10.812 6.82979 10.8374 6.63263C10.8628 6.43547 10.8755 6.21845 10.8755 5.98156C10.8755 5.74222 10.8628 5.52952 10.8374 5.34348C10.812 5.15733 10.769 4.95319 10.7083 4.73106H8.49968C8.52525 5.02763 8.54359 5.26678 8.5547 5.4485C8.56581 5.63012 8.57137 5.80781 8.57137 5.98156C8.57137 6.19219 8.56419 6.3926 8.54983 6.58277C8.53547 6.77305 8.51546 6.99926 8.4898 7.26142ZM8.3128 3.75476H10.3492C10.0417 3.14322 9.62919 2.62702 9.11166 2.20616C8.59413 1.78529 8.0001 1.48424 7.32956 1.30301C7.55553 1.65062 7.74724 2.02296 7.90467 2.42003C8.0621 2.8171 8.19814 3.26201 8.3128 3.75476ZM4.6964 3.75476H7.31968C7.21063 3.26781 7.03973 2.79856 6.80697 2.34702C6.57422 1.89547 6.30326 1.48852 5.9941 1.12616C5.70697 1.41801 5.46113 1.77088 5.2566 2.18477C5.05207 2.59865 4.86533 3.12198 4.6964 3.75476ZM1.64492 3.75476H3.6934C3.79507 3.28168 3.92178 2.84827 4.0735 2.45455C4.22533 2.06072 4.41752 1.68017 4.65008 1.3129C3.97797 1.49412 3.38886 1.79148 2.88274 2.20498C2.37652 2.61857 1.96391 3.13516 1.64492 3.75476Z"),
                A2(Vx, "fill", "currentColor")
            ]), h)
        ]));
    }, BS = function(n) {
        return A3(Vj, "svg", $(k([
            A2(Vx, "viewBox", "0 0 16 13"),
            A2(Vx, "xmlns", "http://www.w3.org/2000/svg")
        ]), n), k([
            A3(Vj, "path", k([
                A2(Vx, "d", "M11.424 7.57621H14.16C14.128 7.61661 14.096 7.64691 14.064 7.66711C14.032 7.68731 14.0053 7.70751 13.984 7.72771L13.952 7.77316L8.4 12.8485C8.29333 12.9495 8.16 13 8 13C7.84 13 7.70667 12.9495 7.6 12.8485L2.032 7.75801C2 7.73781 1.94133 7.67721 1.856 7.57621H5.136C5.27467 7.57621 5.39733 7.54086 5.504 7.47016C5.61067 7.39946 5.67467 7.3035 5.696 7.1823L6.32 4.80371L8.016 10.4396C8.05867 10.5507 8.128 10.6416 8.224 10.7123C8.32 10.783 8.43733 10.8234 8.576 10.8335C8.69333 10.8335 8.80533 10.7931 8.912 10.7123C9.01867 10.6315 9.088 10.5406 9.12 10.4396L10.416 6.33389L10.928 7.28835C11.0347 7.48026 11.2 7.57621 11.424 7.57621ZM16 3.97045C16 4.77846 15.696 5.62183 15.088 6.50054H11.792L10.8 4.63706C10.7467 4.53606 10.6667 4.46031 10.56 4.40981C10.4533 4.3593 10.3467 4.33405 10.24 4.33405C9.97333 4.36436 9.808 4.49566 9.744 4.72796L8.592 8.36402L6.848 2.56147C6.80533 2.45037 6.73067 2.35442 6.624 2.27362C6.51733 2.19282 6.4 2.15747 6.272 2.16757C6.144 2.17767 6.032 2.21807 5.936 2.28877C5.84 2.35947 5.77067 2.45542 5.728 2.57662L4.704 6.50054H0.928C0.309333 5.62183 0 4.77846 0 3.97045C0 2.72813 0.378667 1.75851 1.136 1.0616C1.89333 0.364688 2.93867 0.0111818 4.272 0.00108147C4.63467 0.00108147 5.008 0.0616827 5.392 0.182884C5.776 0.304087 6.13333 0.470739 6.464 0.682843C6.79467 0.894947 7.08267 1.08685 7.328 1.25855C7.57333 1.43026 7.79733 1.62216 8 1.83426C8.21333 1.63226 8.43733 1.44036 8.672 1.25855C8.90667 1.07675 9.19467 0.884847 9.536 0.682843C9.87733 0.48084 10.2347 0.314187 10.608 0.182884C10.9813 0.0515823 11.3547 -0.0090189 11.728 0.00108147C13.0613 0.00108147 14.1067 0.354588 14.864 1.0616C15.6213 1.76861 16 2.73823 16 3.97045Z")
            ]), h)
        ]));
    }, jS = function(n) {
        switch(n){
            case 1:
                return nS;
            case 0:
                return mS;
            case 2:
                return Yj;
            case 3:
                return yS;
            case 4:
                return lS;
            case 5:
                return vS;
            case 6:
                return DS;
            case 7:
                return Zj;
            case 8:
                return Gj;
            case 9:
                return iS;
            case 10:
                return pS;
            case 11:
                return Jj;
            case 12:
                return cS;
            case 13:
                return Xj;
            case 14:
                return rS;
            case 15:
                return AS;
            case 16:
                return tS;
            case 17:
                return dS;
            case 18:
                return hS;
            case 19:
                return Qj;
            case 20:
                return Kj;
            case 21:
                return $S;
            case 22:
                return BS;
            case 23:
                return bS;
            case 24:
                return xS;
            case 25:
                return oS;
            case 26:
                return _S;
            case 27:
                return Wj;
            case 28:
                return qS;
            case 29:
                return uS;
            case 30:
                return sS;
            case 31:
                return fS;
            case 32:
                return aS;
            case 33:
                return eS;
            case 34:
                return CS;
            case 35:
                return kS;
            case 36:
                return gS;
            default:
                return wS;
        }
    }, SS = function(n) {
        switch(n){
            case 0:
                return "icon--xs";
            case 1:
                return "icon--sm";
            case 2:
                return "icon--md";
            case 3:
                return "icon--lg";
            default:
                return "icon--xl";
        }
    }, zS = function(n) {
        switch(n.$){
            case 1:
                return k([
                    Ij(ox(n.a))
                ]);
            case 0:
                return k([
                    Ij(SS(n.a))
                ]);
            case 2:
                return k([
                    Ij(n.a)
                ]);
            default:
                return k([
                    Ij("icon--square")
                ]);
        }
    }, US = F2(function(n, r) {
        var t = A2(Ji, zS, n);
        return A2(jS, r, A2(Ot, Ij("icon"), t));
    }), ES = F2(function(n, r) {
        var t, e = function() {
            var n = oA(r);
            if (n.$) return Sq;
            var t = n.a;
            return A2(LB, k([
                Qk(k([
                    Nk("block text-current")
                ]))
            ]), k([
                ad(t)
            ]));
        }(), u = function() {
            var n = Tq(r);
            if (n.$) return Sq;
            var t = n.a;
            return A2(Ik, k([
                Nk("catalog-card__description rich-text")
            ]), A2(yu, px(hu), Nj(t)));
        }(), a = !i(Fq(r), Rt), c = Lq(r) ? " catalog-card--compact" : "", o = a ? "" : " catalog-card--no-image";
        return A2(Ik, k([
            Eq(Nq(r)),
            Nk("catalog-card block rounded-lg border border-primary-200 bg-white p-4 hover:bg-gray-50 sm:p-0 sm:overflow-hidden cursor-pointer h-full" + (o + c))
        ]), k([
            A2(Ik, k([
                Nk("catalog-card__content flex gap-4 items-start sm:flex-col sm:gap-0")
            ]), k([
                (t = Fq(r), t.$ ? Sq : A2(AB, k([
                    TB(t.a),
                    Iq(""),
                    Nk("w-24 h-24 object-cover rounded flex-shrink-0 order-1 sm:order-none sm:w-full sm:h-32 sm:rounded-none")
                ]), h)),
                A2(Ik, k([
                    Nk("catalog-card__body flex-1 min-w-0 sm:p-4 order-0 sm:order-none")
                ]), k([
                    e,
                    A2(PB, k([
                        EB,
                        BB,
                        UB,
                        Qk(k([
                            Nk("block mt-1")
                        ]))
                    ]), k([
                        ad(A2(DB, n, r))
                    ])),
                    u
                ])),
                A2(px, hu, A2(US, k([
                    SB,
                    Vq("flex-shrink-0 text-gray-400 self-center order-2 sm:hidden")
                ]), 6))
            ]))
        ]));
    }), PS = function(n) {
        return {
            $: 0,
            a: n
        };
    }, TS = F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    }), FS = A2(TS, PS(3), Ht(1)), LS = function(n) {
        return {
            $: 5,
            a: n
        };
    }, MS = function(n) {
        return k([
            A2(hx, k([
                LS(FS),
                BB
            ]), k([
                ad(n)
            ]))
        ]);
    }, HS = F2(function(n, r) {
        var t = r.bb;
        switch(t.$){
            case 1:
                return A2(Ik, h, Yk);
            case 3:
                var e = A2(Hq, r.d4, t.a);
                return ED(e) ? A2(Ik, k([
                    Nk("py-12 text-center")
                ]), MS(n(Bq.DS))) : A2(Oq, k([
                    Nk("catalog-grid")
                ]), A2(yu, function(r) {
                    return A2(Rq, k([
                        Nk(Mq(r))
                    ]), k([
                        A2(ES, n, r)
                    ]));
                }, e));
            default:
                return Sq;
        }
    }), RS = {
        $: 8
    }, OS = function(n) {
        return {
            $: 6,
            a: n
        };
    }, NS = F2(function(n, r) {
        return n(pA(r) ? Bq.B8 : Bq.hf);
    }), IS = function(n) {
        return function(n) {
            return {
                $: 0,
                a: n
            };
        }(n);
    }, VS = {
        $: 3
    }, WS = {
        $: 4
    }, ZS = function(n) {
        return {
            $: 1,
            a: n
        };
    }, XS = function(n) {
        return function(n) {
            return {
                $: 2,
                a: n
            };
        }(n);
    }, GS = function(n) {
        return {
            $: 2,
            a: n
        };
    }, JS = GS(k([
        Nk("w-full")
    ])), YS = function(n) {
        return 1 !== n.$;
    }, QS = function(n) {
        return function(n) {
            return {
                $: 4,
                a: n
            };
        }(n);
    }, KS = function(n) {
        return {
            $: 0,
            a: n
        };
    }, nz = KS(0), rz = function(n) {
        return Nk(A2(ue, " ", A2(yu, Ne, A2(Tc, Ac, n))));
    }, tz = xA("disabled"), ez = A2(Tu, "keyCode", C$), uz = function(n) {
        return A2(Uq, "keydown", A2(Ye, n, ez));
    }, az = function(n) {
        var r;
        return D$(k([
            A2(Ge, function(r) {
                return i(r, n) ? Ke(!0) : yy("continue");
            }, A2(Tu, "id", w$)),
            (r = function() {
                return A2(Tu, "parentNode", az(n));
            }, A2(Ge, r, Ke(0))),
            Ke(!1)
        ]));
    }, iz = F2(function(n, r) {
        return A2(Ge, function(r) {
            return r ? yy("blurred inside") : Ke(n);
        }, A2(Tu, "relatedTarget", az(r)));
    }), cz = F2(function(n, r) {
        return A2(Uq, "blur", A2(iz, n, r));
    }), oz = function(n) {
        switch(n.$){
            case 0:
                switch(n.a){
                    case 0:
                        return k([
                            Nk("button--primary")
                        ]);
                    case 1:
                        return k([
                            Nk("button--secondary")
                        ]);
                    case 2:
                        return k([
                            Nk("button--tonal")
                        ]);
                    case 7:
                        return k([
                            Nk("button--danger--filled")
                        ]);
                    case 8:
                        return k([
                            Nk("button--danger--outline")
                        ]);
                    case 3:
                        return k([
                            Nk("button--profile")
                        ]);
                    case 4:
                        return k([
                            Nk("button--link")
                        ]);
                    case 5:
                        return k([
                            Nk("button--round")
                        ]);
                    default:
                        return k([
                            Nk("button--none")
                        ]);
                }
            case 1:
                return k([
                    tz(n.a)
                ]);
            case 2:
                var r = n.a;
                return A2(yu, Zk(hu), r);
            case 3:
                return k([
                    rz(k([
                        b("button--loading", n.a)
                    ]))
                ]);
            case 4:
                return k([
                    Eq(n.a)
                ]);
            case 5:
                return k([
                    A2(Wx, "data-test", n.a)
                ]);
            case 6:
                return k([
                    rz(k([
                        b("button--nowrap", n.a)
                    ]))
                ]);
            case 7:
                return k([
                    A2(cz, n.a, n.b)
                ]);
            case 8:
                return k([
                    uz(n.a)
                ]);
            case 9:
                return k([
                    Nk(ex(n.a) + "hidden")
                ]);
            default:
                var t = A2(ue, " ", A2(yu, jx(ex(n.a)), k([
                    "pointer-events-none",
                    "pointer-none"
                ])));
                return k([
                    Nk(A2(ue, " ", k([
                        "cursor-auto pointer-events-auto",
                        t
                    ])))
                ]);
        }
    }, fz = F2(function(n, r) {
        return A2(jq, A2(Ot, Nk("button"), function(n) {
            return Gi(A2(yu, oz, n));
        }(n)), $(r, k([
            A2(Gk, k([
                Nk("button__spinner")
            ]), h)
        ])));
    }), sz = function(n) {
        return A2(sA, function(n) {
            return 3 === n.$;
        }, n);
    }, lz = F2(function(n, r) {
        return A2(Ik, vx(n), r);
    }), dz = Ok("type"), bz = function(n) {
        return {
            $: 7,
            a: n
        };
    }, vz = function(n) {
        return GS(n);
    }, mz = jB(3), pz = KS(6), $z = {
        $: 3
    }, hz = function(n) {
        return {
            $: 0,
            a: n
        };
    }, gz = hz(0), wz = function(n) {
        return {
            $: 1,
            a: n
        };
    }, kz = wz(1), xz = function(n) {
        return {
            $: 2,
            a: n
        };
    }, yz = xz(1), _z = lz(k([
        bz(kz),
        bz(yz)
    ])), Cz = F2(function(n, r) {
        switch(r.$){
            case 4:
                return Ht(A2(fz, k([
                    pz,
                    vz(k([
                        Nk("modal__close-full-viewport pointer-events-auto border-0 bg-transparent text-white shadow-none"),
                        dz("button"),
                        A2(Wx, "aria-label", "Close")
                    ])),
                    QS(n.AT)
                ]), k([
                    _z(k([
                        A2(px, hu, A2(US, k([
                            mz,
                            $z,
                            Vq("text-white")
                        ]), 2))
                    ]))
                ])));
            case 0:
                var t = r.a;
                return Ht(A2(lz, k([
                    Qk(k([
                        Nk("modal__body modal__body--full-viewport")
                    ])),
                    bz(gz)
                ]), t));
            default:
                return Rt;
        }
    }), Dz = F3(function(n, r, t) {
        return A2(lz, k([
            Qk(k([
                Nk(1 === n.$ ? "modal-wrap" : "modal-wrap " + n.a)
            ]))
        ]), k([
            A2(jq, k([
                dz("button"),
                Nk("modal__backdrop-dismiss"),
                Eq(r.AT)
            ]), h),
            A2(lz, k([
                Qk(k([
                    Nk("modal__full-viewport-foreground")
                ]))
            ]), k([
                A2(lz, k([
                    Qk(k([
                        Nk("modal__full-viewport-inner")
                    ]))
                ]), A2(Ep, Cz(r), t))
            ]))
        ]));
    }), Az = F2(function(n) {
        return "scroll-shadow-" + n;
    }), qz = F3(function(n, r, t) {
        return A2(Ik, k([
            Nk("scroll-shadow"),
            rz(k([
                b(A2(Az, n, t), r)
            ]))
        ]), h);
    }), Bz = F2(function(n, r) {
        var t = b(n, r);
        return t.a.$ ? Sq : A3(qz, "bottom", !t.a.a.mr, r);
    }), jz = Ok("id"), Sz = jB(1), zz = F2(function(n, r) {
        var t = b(n, r);
        return t.a.$ ? Sq : A3(qz, "top", !t.a.a.mu, r);
    }), Uz = F2(function(n, r) {
        switch(r.$){
            case 4:
                return Ht(A2(fz, k([
                    pz,
                    vz(k([
                        Nk("absolute top-4 right-6 z-10 h-8 w-8 cursor-pointer rounded-full border-0 bg-white p-0 shadow"),
                        dz("button"),
                        A2(Wx, "aria-label", "Close")
                    ])),
                    QS(n.AT)
                ]), k([
                    _z(k([
                        A2(px, hu, A2(US, k([
                            Sz
                        ]), 2))
                    ]))
                ])));
            case 1:
                var t = r.a;
                return Ht(A2(Ik, k([
                    Nk("modal__header flex flex-col")
                ]), k([
                    A2(Ik, k([
                        Nk("flex flex-row w-full")
                    ]), k([
                        A2(Ik, k([
                            Nk("w-full")
                        ]), t),
                        (e = n.AT, A2(Ik, k([
                            Nk("cursor-pointer"),
                            Eq(e)
                        ]), k([
                            A2(US, h, 2)
                        ])))
                    ])),
                    A2(Ik, k([
                        Nk("modal__section-divider flex w-full px-8 mt-6 sm:mt-8 border-b border-primary-200 h-1px")
                    ]), h)
                ])));
            case 0:
                return t = r.a, Ht(A2(Ik, k([
                    Nk("scroll-container")
                ]), k([
                    A2(zz, n.fr, n.iA),
                    A2(Ik, k([
                        Nk("modal__body"),
                        jz(Qx)
                    ]), t),
                    A2(Bz, n.fr, n.iA)
                ])));
            case 2:
                return t = r.a, Ht(A2(Ik, k([
                    Nk("modal__footer")
                ]), k([
                    A2(Ik, k([
                        Nk("flex flex-col w-full")
                    ]), k([
                        A2(Ik, k([
                            Nk("modal__section-divider flex w-full px-8 mb-6 sm:mb-8 border-b border-primary-200 h-1px")
                        ]), h),
                        A2(Ik, k([
                            Nk("w-full")
                        ]), t)
                    ]))
                ])));
            default:
                return Rt;
        }
        var e;
    }), Ez = F5(function(n, r, t, e, u) {
        var a = 1 === e.$ ? "modal__content" : "modal__content " + e.a, i = A2(lz, k([
            Qk(k([
                Nk(u ? a + " pointer-events-auto" : a)
            ]))
        ]), A2(Ep, Uz(n), r));
        return A2(lz, k([
            Qk(k([
                rz(k([
                    b("modal-wrap", !0),
                    b("modal--bottom-sheet", t)
                ]))
            ]))
        ]), k(u ? [
            A2(jq, k([
                dz("button"),
                Nk("modal__backdrop-dismiss"),
                Eq(n.AT)
            ]), h),
            A2(lz, k([
                Qk(k([
                    Nk("modal__standard-dismiss-foreground")
                ]))
            ]), k([
                A2(lz, k([
                    Qk(k([
                        Nk("modal pointer-events-none")
                    ]))
                ]), k([
                    i
                ]))
            ]))
        ] : [
            A2(lz, k([
                Qk(k([
                    Nk("modal")
                ]))
            ]), k([
                i
            ]))
        ]));
    }), Pz = F3(function(n, r, t) {
        return t.bC ? Sq : 1 === n ? A3(Dz, Rt, t, r) : A5(Ez, t, r, sz(r), Rt, !1);
    }), Tz = F2(function(n, r) {
        return A3(Pz, 0, n, r);
    }), Fz = F2(function(n, r) {
        return n(pA(r) ? Bq.nS : Bq.nR);
    }), Lz = qB(5), Mz = {
        $: 0
    }, Hz = zB(3), Rz = KS(2), Oz = F2(function(n, r) {
        if (n.$) return LD(r);
        var t = n.a;
        return i(Ox(r), t);
    }), Nz = function(n) {
        return n.r4;
    }, Iz = nx(0), Vz = F3(function(n, r, t) {
        var e = A2(Oz, r, t) ? Bq.Au : Nz;
        return A2(PB, k([
            Iz,
            Lz,
            UB,
            Qk(k([
                Nk("block")
            ]))
        ]), k([
            ad(n(e))
        ]));
    }), Wz = {
        $: 4
    }, Zz = F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    }), Xz = F2(function(n, r) {
        return A2(Zz, n, r);
    }), Gz = function(n) {
        return function(n) {
            return {
                $: 5,
                a: n
            };
        }(n);
    }, Jz = function(n) {
        return {
            $: 0,
            a: n
        };
    }, Yz = {
        $: 1
    }, Qz = {
        $: 0
    }, Kz = function(n) {
        return {
            $: 2,
            a: n
        };
    }, nU = {
        $: 5
    }, rU = function(n) {
        return {
            $: 4,
            a: n
        };
    }, tU = F2(function(n, r) {
        return {
            $: 6,
            a: n,
            b: r
        };
    }), eU = function(n) {
        return {
            $: 1,
            a: n
        };
    }, uU = F3(function(n, r, t) {
        return n ? $(t, k([
            r
        ])) : t;
    }), aU = A2(Gk, k([
        Nk("select__arrow")
    ]), h), iU = ir("label"), cU = Ok("value"), oU = F2(function(n, r) {
        return n.$ ? r : A2(Ot, cU(n.a), r);
    }), fU = ir("input"), sU = function(n) {
        return k([
            Nk("select__item__input"),
            dz("radio"),
            tz(n.yR)
        ]);
    }, lU = Ok("name"), dU = function(n) {
        return A2(Uq, "mousedown", Ke(n));
    }, bU = {
        yR: !1,
        hH: Rt
    }, vU = F2(function(n, r) {
        return m(r, {
            yR: n
        });
    }), mU = F2(function(n, r) {
        var t = n.Dt, e = n.Dr, u = n.iE, a = n.CB, c = n.AQ, o = n.Bf, f = n.A5, s = r.a, l = r.b, d = t(l), v = A3(ce, vU, bU, s), m = v.yR ? h : k([
            dU(o(Ht(l)))
        ]), p = A2(uc, A2(uc, "", d), v.hH), g = A2(uc, !1, A2(Cp, function(n) {
            return i(t(n), t(l));
        }, u)), w = $(a, g ? "-item-active" : "-item"), x = A2(oU, d, k([
            uz(f(Ht(l))),
            A2(cz, c, a),
            jz(w),
            lU(a)
        ]));
        return b(p, A2(iU, A2(Ot, Nk("select__item"), A2(Ot, A2(Wx, "role", "option"), A2(Ot, rz(k([
            b("select__item--active", g),
            b("select__item--disabled", v.yR)
        ])), m))), k([
            A2(fU, $(sU(v), x), h),
            A2(Gk, h, k([
                A2(px, hu, e(l))
            ]))
        ])));
    }), pU = F2(function(n, r) {
        if (1 === r.$) {
            var t = r.a;
            if (t.$) {
                var e = t.a;
                return b("0", A2(iU, k([
                    Nk("select__item select__item--disabled")
                ]), k([
                    ad(e)
                ])));
            }
            return b("0", A2(iU, k([
                Nk("select__item--divider")
            ]), h));
        }
        return A2(mU, n, b(r.a, r.b));
    }), $U = function(n) {
        return or(vr(n));
    }, hU = F2(function(n, r) {
        return {
            $: 7,
            a: n,
            b: r
        };
    }), gU = F2(function(n, r) {
        return A2(hU, n, r);
    }), wU = {
        $: 0
    }, kU = {
        jW: h,
        g9: 1,
        yR: !1,
        eF: !1,
        zU: !1,
        hF: !0,
        ik: !1,
        BU: "Pick an item",
        dR: wU,
        w5: Rt
    }, xU = F2(function(n, r) {
        switch(n.$){
            case 2:
                return m(r, {
                    yR: n.a
                });
            case 0:
                return m(r, {
                    w5: n.a
                });
            case 1:
                return m(r, {
                    BU: n.a
                });
            case 3:
                return m(r, {
                    zU: n.a
                });
            case 5:
                return m(r, {
                    ik: n.a
                });
            case 4:
                return m(r, {
                    eF: !0
                });
            case 6:
                return m(r, {
                    dR: n.a
                });
            case 7:
                return m(r, {
                    hF: n.a
                });
            default:
                return m(r, {
                    g9: n.a
                });
        }
    }), yU = KS(3), _U = KS(5), CU = KS(1), DU = function(n) {
        var r = i(n.dR, wU), t = YS(n.w5), e = i(n.dR, eU(1)) ? k([
            _U,
            yU
        ]) : k([
            CU
        ]);
        return A2(Ot, vz($(n.jW, k([
            rz(k([
                b("select--invalid", n.zU),
                b("select__input", r),
                b("select__input--selected", t && r)
            ]))
        ]))), A2(Ot, ZS(n.yR), e));
    }, AU = F4(function(n, r, t, e) {
        var u, a, c = A3(ce, xU, kU, r), o = A2(uc, ad(c.BU), A2(Cp, e.dj(n), c.w5)), f = {
            AQ: nU,
            A5: tU,
            Bf: rU,
            CB: e.qU,
            iE: c.w5,
            Dr: e.dj(n),
            Dt: e.kt
        }, s = i(c.dR, eU(1));
        return A2(Ik, $(c.ik ? Xx : h, k([
            Nk("select"),
            rz(k([
                b("select--open", e.aN),
                b("w-full", c.eF)
            ])),
            jz(e.qU)
        ])), k([
            A2(fz, A2(Ot, vz(k([
                rz(k([
                    b("w-full", !s)
                ])),
                jz(e.qU + "-input")
            ])), A2(Ot, QS(Qz), A2(Ot, A2(gU, Yz, e.qU), A2(Ot, (a = Kz, function(n) {
                return {
                    $: 8,
                    a: n
                };
            }(a)), A2(Ot, vz(k([
                dz("button")
            ])), DU(c)))))), A3(uU, !s, aU, k([
                A2(px, hu, o)
            ]))),
            !c.yR && e.aN ? A3($U, "div", k([
                Nk("select__items"),
                rz(k([
                    b("select__items--nowrap", !c.hF)
                ])),
                (u = c.g9, Nk(function() {
                    switch(u){
                        case 2:
                            return "select__items--right";
                        case 0:
                            return "select__items--top";
                        default:
                            return "";
                    }
                }()))
            ]), A2(yu, pU(f), t)) : Sq
        ]));
    }), qU = F2(function(n, r) {
        return A2(Ik, h, k([
            A2(PB, k([
                EB,
                Lz,
                UB,
                Qk(k([
                    Nk("block mb-2")
                ]))
            ]), k([
                ad(n.wT(Bq.Ar))
            ])),
            A2(px, aq, A4(AU, n.wT, k([
                Jz(n.iE),
                Wz,
                Gz(!0)
            ]), A2(yu, Xz(h), n.Av), r))
        ]));
    }), BU = F2(function(n, r) {
        return r.rf ? A2(qU, n, r.fx) : function(n) {
            var r = oe(n.Av) > 1, t = n.iE;
            if (1 === t.$) return ad("");
            var e = t.a;
            return A2(Ik, k([
                Nk("flex items-center justify-between gap-2")
            ]), k([
                A2(Ik, k([
                    Nk("flex items-center gap-2 min-w-0")
                ]), k([
                    A2(px, hu, A2(US, k([
                        SB,
                        Vq("flex-shrink-0 text-primary-500")
                    ]), 37)),
                    A2(Ik, k([
                        Nk("min-w-0")
                    ]), k([
                        A2(PB, k([
                            EB,
                            Hz,
                            Qk(k([
                                Nk("block text-current truncate")
                            ]))
                        ]), k([
                            Jx(Ix(e))
                        ])),
                        A3(Vz, n.wT, n.DI, e)
                    ]))
                ])),
                r ? A2(fz, k([
                    Rz,
                    QS(Mz)
                ]), k([
                    ad(n.wT(Bq.yi))
                ])) : ad("")
            ]));
        }(n);
    }), jU = F2(function(n, r) {
        return $(A3($B, !1, !0, A2(uc, r.lr, r.k5)), A2(yB, n, r.t$));
    }), SU = {
        $: 4
    }, zU = ir("fieldset"), UU = function(n) {
        return 2 === n.$ ? function(n) {
            return {
                $: 6,
                a: n
            };
        }(Te(n.a)) : n;
    }, EU = {
        gP: Rt,
        ic: Rt,
        w5: Rt
    }, PU = function(n) {
        return {
            $: 3,
            a: n
        };
    }, TU = F2(function(n, r) {
        return function(n) {
            var r = n.gP;
            if (r.$) {
                var t = b(n.w5, n.ic);
                return t.a.$ || t.b.$ ? h : k([
                    PU((0, t.b.a)(t.a.a))
                ]);
            }
            return k([
                PU(r.a)
            ]);
        }(A3(ce, F2(function(n, r) {
            switch(n.$){
                case 2:
                    return m(r, {
                        w5: Ht(n.a)
                    });
                case 3:
                    return m(r, {
                        gP: Ht(n.a)
                    });
                case 6:
                    return m(r, {
                        ic: Ht(n.a)
                    });
                default:
                    return r;
            }
        }), r, n));
    }), FU = xA("checked"), LU = function(n) {
        return b(n, !0);
    }, MU = F2(function(n, r) {
        return A2(zq, n, function(n) {
            return {
                $: 1,
                a: n
            };
        }(r));
    }), HU = A2(Zy, k([
        "target",
        "value"
    ]), w$), RU = function(n) {
        return A2(MU, "input", A2(Ye, LU, A2(Ye, n, HU)));
    }, OU = function(n) {
        switch(n.$){
            case 2:
                return k([
                    cU(n.a)
                ]);
            case 0:
                return k([
                    tz(n.a)
                ]);
            case 1:
                return k([
                    RU(n.a)
                ]);
            case 3:
                return k([
                    FU(n.a)
                ]);
            case 4:
            case 7:
            case 6:
            case 5:
            default:
                return h;
            case 8:
                return k([
                    A2(Wx, "data-test", n.a)
                ]);
        }
    }, NU = function(n) {
        switch(n.$){
            case 2:
            case 1:
            case 6:
            default:
                return h;
            case 0:
                return k([
                    rz(k([
                        b("radio--disabled", n.a)
                    ]))
                ]);
            case 3:
                return k([
                    rz(k([
                        b("radio--checked", n.a)
                    ]))
                ]);
            case 7:
                var r = n.a;
                return A2(yu, Zk(hu), r);
            case 4:
                return k([
                    Nk("radio--card")
                ]);
            case 5:
                return k([
                    Nk("radio--icon-hidden")
                ]);
            case 8:
                return k([
                    A2(Wx, "data-test", n.a)
                ]);
        }
    }, IU = F2(function(n, r) {
        var t = A2(TU, n, EU);
        return A2(iU, A2(Ot, Nk("flex items-center radio"), A2(Ji, NU, $(t, n))), k([
            A2(fU, A2(Ot, dz("radio"), A2(Ot, Nk("radio__input"), A2(Ji, OU, $(n, t)))), h),
            A2(Gk, k([
                Nk("radio__icon flex-none")
            ]), h),
            A2(Ik, k([
                Nk("radio__text flex-auto")
            ]), A2(yu, px(hu), r))
        ]));
    }), VU = F2(function(n, r) {
        var t = A2(yu, UU, A2(Tc, function(n) {
            return 9 !== n.$;
        }, n)), e = A2(sA, function(n) {
            return 9 === n.$;
        }, n);
        return A2(zU, k([
            rz(k([
                b("radio-group", !0),
                b("radio-group--spaced", e),
                b("radio-group--cards-" + ee(oe(r)), e)
            ]))
        ]), A2(yu, function(n) {
            var r = n.b;
            return A2(IU, $(n.a, t), r);
        }, r));
    }), WU = F2(function(n, r) {
        return b(n, r);
    }), ZU = function(n) {
        return function(n) {
            return {
                $: 1,
                a: n
            };
        }(n);
    }, XU = function(n) {
        return {
            $: 7,
            a: n
        };
    }, GU = {
        $: 14
    }, JU = function(n) {
        return A2(uc, GU, A2(Cp, XU, _y(n)));
    }, YU = {
        $: 9
    }, QU = function(n) {
        switch(n){
            case 0:
                return "month";
            case 1:
                return "quarter";
            case 2:
                return "semi_annual";
            default:
                return "annual";
        }
    }, KU = function(n) {
        return n.mQ.mk;
    }, nE = function(n) {
        return n.mQ.sR;
    }, rE = function(n) {
        return n.mQ.uQ;
    }, tE = function(n) {
        return n.mQ.vF;
    }, eE = F2(function(n, r) {
        return n(function() {
            switch(r){
                case 0:
                    return nE;
                case 1:
                    return rE;
                case 2:
                    return tE;
                default:
                    return KU;
            }
        }());
    }), uE = function(n) {
        return {
            $: 2,
            a: n
        };
    }, aE = F3(function(n, r, t) {
        var e = ID(r);
        if (e.b) {
            var u = e;
            return A2(Ik, h, k([
                A2(PB, k([
                    EB,
                    Lz,
                    UB,
                    Qk(k([
                        Nk("block mb-2")
                    ]))
                ]), k([
                    ad(n(Bq.mP))
                ])),
                A2(VU, k([
                    uE(A2(uc, "", A2(Cp, QU, t.fA))),
                    ZU(JU),
                    YU
                ]), A2(yu, function(r) {
                    return A2(WU, k([
                        SU,
                        uE(QU(r.t$))
                    ]), k([
                        A2(LB, k([
                            Qk(k([
                                Nk("block text-current")
                            ]))
                        ]), k([
                            ad(A2(eE, n, r.t$))
                        ])),
                        A2(PB, k([
                            EB,
                            UB,
                            Qk(k([
                                Nk("block mt-1")
                            ]))
                        ]), k([
                            ad(A2(jU, n, r))
                        ]))
                    ]));
                }, u))
            ]));
        }
        return Sq;
    }), iE = lr, cE = iE, oE = {
        $: 3
    }, fE = {
        $: 2
    }, sE = {
        yR: !1
    }, lE = F2(function(n, r) {
        return m(r, {
            yR: n
        });
    }), dE = function(n) {
        return A2(br, "tabIndex", ee(n));
    }, bE = {
        $: 6
    }, vE = {
        $: 5
    }, mE = function(n) {
        return {
            $: 11,
            a: n
        };
    }, pE = {
        $: 4
    }, $E = function(n) {
        return {
            $: 3,
            a: n
        };
    }, hE = function(n) {
        return {
            $: 1,
            a: n
        };
    }, gE = function(n) {
        return {
            $: 9,
            a: n
        };
    }, wE = {
        $: 7
    }, kE = {
        $: 8
    }, xE = F3(function(n, r, t) {
        var e = t;
        switch(n){
            case 0:
                return A3(xE, 1, 12 * r, e);
            case 1:
                var u = qv(e), a = 12 * (u.xm - 1) + (hv(u.sN) - 1) + r, i = kv(A2(qc, 12, a) + 1), c = A2(yv, a, 12) + 1;
                return _v(c) + A2(ap, c, i) + A2(Wv, u.oH, A2(wv, c, i));
            case 2:
                return e + 7 * r;
            default:
                return e + r;
        }
    }), yE = F2(function(n, r) {
        var t = lu(r);
        return t.$ ? n : A3(ip, t.a, zv(n), Sv(n));
    }), _E = F2(function(n, r) {
        return r.$ ? n : r;
    }), CE = F2(function(n, r) {
        return Nk($(n.eq, r));
    }), DE = F3(function(n, r, t) {
        n: for(;;){
            if (n > 0) {
                if (r.b) {
                    var e = r.a;
                    n -= 1, r = r.b, t = A2(Ot, e, t);
                    continue n;
                }
                return t;
            }
            return t;
        }
    }), AE = F2(function(n, r) {
        return we(A3(DE, n, r, h));
    }), qE = F3(function(n, r, t) {
        if (r > 0) {
            var e = b(r, t);
            n: for(;;){
                r: for(;;){
                    if (!e.b.b) return t;
                    if (!e.b.b.b) {
                        if (1 === e.a) break n;
                        break r;
                    }
                    switch(e.a){
                        case 1:
                            break n;
                        case 2:
                            var u = e.b;
                            return k([
                                u.a,
                                u.b.a
                            ]);
                        case 3:
                            if (e.b.b.b.b) {
                                var a = e.b, i = a.b;
                                return k([
                                    a.a,
                                    i.a,
                                    i.b.a
                                ]);
                            }
                            break r;
                        default:
                            if (e.b.b.b.b && e.b.b.b.b.b) {
                                var c = e.b, o = c.b, f = o.b, s = f.b, l = s.b;
                                return A2(Ot, c.a, A2(Ot, o.a, A2(Ot, f.a, A2(Ot, s.a, n > 1e3 ? A2(AE, r - 4, l) : A3(qE, n + 1, r - 4, l)))));
                            }
                            break r;
                    }
                }
                return t;
            }
            return k([
                e.b.a
            ]);
        }
        return h;
    }), BE = F2(function(n, r) {
        return A3(qE, 0, n, r);
    }), jE = F2(function(n, r) {
        var t = A2(BE, n, r);
        return t.b ? A2(Ot, t, A2(jE, n, A2(zp, n, r))) : h;
    }), SE = ir("tr"), zE = F2(function(n, r) {
        return {
            $: 10,
            a: n,
            b: r
        };
    }), UE = F2(function(n, r) {
        var t = n.eq;
        return rz(A2(yu, function(n) {
            var r = n.b;
            return b($(t, n.a), r);
        }, r));
    }), EE = ir("td"), PE = F3(function(n, r, t) {
        var e = Dv(n), u = Sv(n);
        return A2(EE, k([
            A2(UE, r, k([
                b("day", !0)
            ])),
            Eq(A2(zE, A3(ip, e, t, u), 0))
        ]), k([
            r.jZ(r.kG(t))
        ]));
    }), TE = F2(function(n, r) {
        var t = k([
            0,
            1,
            2,
            3,
            4,
            5,
            6,
            7,
            8,
            9,
            10,
            11
        ]);
        return A2(yu, function(t) {
            return A2(SE, h, A2(yu, A2(PE, n, r), t));
        }, A2(jE, 3, t));
    }), FE = ir("option"), LE = function(n) {
        switch(n){
            case 0:
                return 1;
            case 1:
                return 2;
            case 2:
                return 3;
            case 3:
                return 4;
            case 4:
                return 5;
            case 5:
                return 6;
            default:
                return 7;
        }
    }, ME = F2(function(n, r) {
        return A2(qc, 7, Mv(r) + 7 - LE(n));
    }), HE = F2(function(n, r) {
        return _v(n) + A2(ap, n, r) + 1;
    }), RE = F2(function(n, r) {
        var t, e = r;
        switch(n){
            case 0:
                return jC(Dv(r));
            case 1:
                return A2(HE, Dv(r), (t = Lv(r), kv(3 * t - 2)));
            case 2:
                return A2(HE, Dv(r), zv(r));
            case 3:
            case 4:
                return e - A2(ME, 0, r);
            case 5:
                return e - A2(ME, 1, r);
            case 6:
                return e - A2(ME, 2, r);
            case 7:
                return e - A2(ME, 3, r);
            case 8:
                return e - A2(ME, 4, r);
            case 9:
                return e - A2(ME, 5, r);
            case 10:
                return e - A2(ME, 6, r);
            default:
                return r;
        }
    }), OE = function(n) {
        switch(n){
            case 0:
                return b(1, 0);
            case 1:
                return b(3, 1);
            case 2:
                return b(1, 1);
            case 11:
                return b(1, 3);
            default:
                return b(1, 2);
        }
    }, NE = F2(function(n, r) {
        var t = A2(RE, n, r);
        if (i(r, t)) return r;
        var e = OE(n);
        return A3(xE, e.b, e.a, t);
    }), IE = F5(function(n, r, t, e, u) {
        for(;;){
            if (s(u, t) >= 0) return we(e);
            var a = A3(xE, n, r, u);
            e = A2(Ot, u, e), u = a;
        }
    }), VE = F4(function(n, r, t, e) {
        var u = t, a = e, i = OE(n), c = i.a, o = i.b, f = A2(NE, n, u);
        return 0 > s(f, a) ? A5(IE, o, A2(Me, 1, r) * c, a, h, f) : h;
    }), WE = F2(function(n, r) {
        var t = function(n) {
            switch(n){
                case 0:
                    return 4;
                case 1:
                    return 5;
                case 2:
                    return 6;
                case 3:
                    return 7;
                case 4:
                    return 8;
                case 5:
                    return 9;
                default:
                    return 10;
            }
        }(r), e = A2(RE, t, A3(ip, Dv(n), zv(n), 1)), u = A3(ip, Dv(n), zv(n), 1);
        return {
            ov: A4(VE, 11, 1, e, A2(NE, t, A3(xE, 1, 1, u))),
            ox: n
        };
    }), ZE = F3(function(n, r, t) {
        for(;;){
            if (0 >= r) return n;
            n = A2(Ot, t, n), r -= 1;
        }
    }), XE = F2(function(n, r) {
        return A3(ZE, h, n, r);
    }), GE = xA("selected"), JE = ir("table"), YE = ir("tbody"), QE = ir("thead"), KE = function(n) {
        return {
            $: 2,
            a: n
        };
    }, nP = F5(function(n, r, t, e, u) {
        var a = n.zZ(u), i = a ? h : k([
            Eq(KE(u))
        ]), c = UE(n);
        return A2(EE, A2(Ot, c(k([
            b("day", !0),
            b("disabled", a),
            b("picked", r(u)),
            b("today", e(u)),
            b("other-month", t(u))
        ])), i), k([
            n.jZ(ee(Sv(u)))
        ]));
    }), rP = F3(function(n, r, t) {
        var e = zv(n), u = Sv(n);
        return A2(EE, k([
            A2(UE, r, k([
                b("day", !0)
            ])),
            Eq(A2(zE, A3(ip, t, e, u), 1))
        ]), k([
            r.jZ(r.xn(t))
        ]));
    }), tP = F2(function(n, r) {
        var t = Dv(n);
        return A2(yu, function(t) {
            return A2(SE, h, A2(yu, A2(rP, n, r), t));
        }, A2(jE, 3, A2(de, t - 1, t + 10)));
    }), eP = F2(function(n, r) {
        var t = n.ox, e = n.wJ;
        switch(r.$){
            case 1:
                var u = r.a;
                return A2(de, Dv(t) - u, Dv(t) + u);
            case 2:
                return A2(de, r.a, r.b);
            case 3:
                return A2(de, a = r.a, Dv(e));
            case 4:
                var a = r.a;
                return A2(de, Dv(e), a);
            default:
                return h;
        }
    }), uP = function(n) {
        return !i(n, gA);
    }, aP = F3(function(n, r, t) {
        var e, u, a, c = t.bR, o = t.wJ, f = t.fd, s = function(r) {
            return A2(uc, !1, A2(Cp, function(n) {
                return i(n, r);
            }, n));
        }, l = function(n) {
            return i(n, o);
        }, d = LE(r.hp) - 1, v = CE(r), m = A2(uc, o, A2(_E, n, c)), p = function(n) {
            return !i(zv(m), zv(n));
        }, $ = F2(function(n, r) {
            return A2(jq, k([
                v(n),
                Eq(r),
                dE(-1),
                dz("button")
            ]), h);
        }), g = A2(WE, m, r.hp), w = g.ox, x = A2(yu, function(n) {
            return A2(SE, k([
                v("row")
            ]), A2(yu, A4(nP, r, s, p, l), n));
        }, (e = g.ov, u = F4(function(n, r, t, e) {
            for(;;){
                if (!r.b) return we(e);
                var u = r.a, a = r.b;
                if (6 !== n) n = i = n + 1, r = c = a, t = o = A2(Ot, u, t), e = f = e;
                else {
                    var i = 0, c = a, o = h, f = A2(Ot, we(A2(Ot, u, t)), e);
                    n = i, r = c, t = o, e = f;
                }
            }
        }), A4(u, 0, e, h, h))), y = function(n) {
            return i(Dv(w), n);
        }, _ = F2(function(n, r) {
            return b(ee(n), A2(FE, k([
                cU(ee(r)),
                GE(y(r))
            ]), k([
                ad(ee(r))
            ])));
        }), C = function() {
            var n = function(n) {
                return A2(de, Dv(w), n);
            }, t = function(n) {
                return A2(de, n, Dv(w));
            }, e = r.nb;
            switch(e.$){
                case 3:
                    return b(n(e.a - 1), t(Dv(o) + 1));
                case 4:
                    var u = e.a;
                    return b(n(Dv(o) - 1), t(u + 1));
                case 2:
                    return u = e.b, b(n(e.a - 1), t(u + 1));
                default:
                    return b(h, h);
            }
        }(), D = C.a, A = C.b, q = A3($U, "select", k([
            (a = A2(Je, yE(m), hE), A2(Uq, "change", A2(Ye, a, HU))),
            v("year-menu")
        ]), A2(be, _, Gi(k([
            D,
            A2(eP, {
                ox: w,
                wJ: o
            }, r.nb),
            A
        ]))));
        return A2(Ik, k([
            v("picker"),
            A2(MU, "mousedown", Ke(b(wE, !0))),
            A2(MU, "mouseup", Ke(b(kE, !0)))
        ]), function() {
            switch(f){
                case 0:
                    return k([
                        A2(Ik, k([
                            v("picker-header")
                        ]), k([
                            A2(Ik, k([
                                v("prev-container")
                            ]), k([
                                A2($, "prev", hE(A3(xE, 1, -1, m)))
                            ])),
                            A2(Ik, k([
                                v("month-container")
                            ]), k([
                                A2(jq, k([
                                    v("month"),
                                    dz("button"),
                                    Eq(gE(1))
                                ]), k([
                                    ad(r.kG(zv(w)))
                                ])),
                                A2(jq, k([
                                    v("year"),
                                    dz("button"),
                                    Eq(gE(2))
                                ]), k([
                                    uP(r.nb) ? A3($U, "span", h, k([
                                        b(ee(Dv(w)), q)
                                    ])) : ad(r.xn(Dv(w)))
                                ]))
                            ])),
                            A2(Ik, k([
                                v("next-container")
                            ]), k([
                                A2($, "next", hE(A3(xE, 1, 1, m)))
                            ]))
                        ])),
                        A2(JE, k([
                            v("table")
                        ]), k([
                            A2(QE, k([
                                v("weekdays")
                            ]), k([
                                A2(SE, h, A2(yu, function(n) {
                                    return A2(EE, k([
                                        v("dow")
                                    ]), k([
                                        ad(r.yL(n))
                                    ]));
                                }, A2(BE, 7, A2(zp, d, Gi(A2(XE, 2, k([
                                    0,
                                    1,
                                    2,
                                    3,
                                    4,
                                    5,
                                    6
                                ])))))))
                            ])),
                            A2(YE, k([
                                v("days")
                            ]), x)
                        ]))
                    ]);
                case 1:
                    return k([
                        A2(Ik, k([
                            v("picker-header")
                        ]), k([
                            A2(Ik, k([
                                v("prev-container")
                            ]), k([
                                A2($, "prev", hE(A3(xE, 0, -1, m)))
                            ])),
                            A2(Ik, k([
                                v("month-container")
                            ]), k([
                                A2(jq, k([
                                    v("year"),
                                    dz("button"),
                                    Eq(gE(2))
                                ]), k([
                                    uP(r.nb) ? A3($U, "span", h, k([
                                        b(ee(Dv(w)), q)
                                    ])) : ad(r.xn(Dv(w)))
                                ]))
                            ])),
                            A2(Ik, k([
                                v("next-container")
                            ]), k([
                                A2($, "next", hE(A3(xE, 0, 1, m)))
                            ]))
                        ])),
                        A2(JE, k([
                            v("table")
                        ]), k([
                            A2(YE, k([
                                v("months")
                            ]), A2(TE, m, r))
                        ]))
                    ]);
                default:
                    return k([
                        A2(Ik, k([
                            v("picker-header")
                        ]), k([
                            A2(Ik, k([
                                v("prev-container")
                            ]), k([
                                A2($, "prev", hE(A3(xE, 0, -12, m)))
                            ])),
                            A2(Ik, k([
                                v("month-container")
                            ]), k([
                                A2(Gk, k([
                                    v("year")
                                ]), k([
                                    uP(r.nb) ? A3($U, "span", h, k([
                                        b(ee(Dv(w)), q)
                                    ])) : ad(r.xn(Dv(w)))
                                ]))
                            ])),
                            A2(Ik, k([
                                v("next-container")
                            ]), k([
                                A2($, "next", hE(A3(xE, 0, 12, m)))
                            ]))
                        ])),
                        A2(JE, k([
                            v("table")
                        ]), k([
                            A2(YE, k([
                                v("years")
                            ]), A2(tP, m, r))
                        ]))
                    ]);
            }
        }());
    }), iP = function(n) {
        return A2(Uq, "blur", Ke(n));
    }, cP = function(n) {
        return A2(Uq, "focus", Ke(n));
    }, oP = Ok("placeholder"), fP = F3(function(n, r, t) {
        var e, u = t, a = A3(Je, Gq, Ep(ru), A2(Cp, jz, r.ko)), i = A2(Ot, b(r.eq + "input", !0), r.zR), c = (e = k([
            oP(r.BU),
            cU(A2(uc, A2(uc, "", A2(Cp, r.yI, n)), u.aK))
        ]), A2(fU, $(k([
            rz(i),
            lU(A2(uc, "", r.kp)),
            dz("text"),
            A2(Uq, "change", Ke(pE)),
            RU($E),
            iP(bE),
            Eq(vE),
            cP(vE),
            A2(Uq, "keydown", A2(Ye, mE, ez))
        ]), $(r.zQ, $(a, e))), h)), o = A2(Ot, b(r.eq + "container", !0), r.j0);
        return A2(Ik, k([
            rz(o)
        ]), k([
            c,
            u.aN ? A3(aP, n, r, u) : ad("")
        ]));
    }), sP = function(n) {
        return function(n) {
            return {
                $: 3,
                a: n
            };
        }(n);
    }, lP = function(n) {
        return function(n) {
            return {
                $: 0,
                a: n
            };
        }(n);
    }, dP = F2(function(n, r) {
        return A2(ep, UA(n), r);
    }), bP = function(n) {
        return function(n) {
            return {
                $: 2,
                a: n
            };
        }(n);
    }, vP = xA("autofocus"), mP = k([
        Zx,
        A2(Wx, "data-recording-ignore", "mask")
    ]), pP = F2(function(n, r) {
        return fu(r) ? cU("") : cU(A2(FA, n, r));
    }), $P = F2(function(n, r) {
        n: for(;;){
            var t = b(n, r);
            r: for(;;){
                if (!t.a.b) {
                    if (t.b.b) return "";
                    break r;
                }
                if (!t.b.b) break r;
                var e = t.a, u = e.a, a = e.b, c = t.b, o = c.a, f = c.b;
                switch(o.$){
                    case 2:
                        return A2(uc, "", A2(Cp, function(n) {
                            return $(ee(n), A2($P, a, f));
                        }, lu(Fb(u))));
                    case 1:
                        return $(Fb(u), A2($P, a, f));
                    default:
                        if (i(o.a, u)) {
                            n = a, r = f;
                            continue n;
                        }
                        return "";
                }
            }
            return "";
        }
    }), hP = F2(function(n, r) {
        var t = n;
        return fu(r) ? "" : A2($P, jm(r), t);
    }), gP = F3(function(n, r, t) {
        if (fu(t)) return "";
        if (fu(r)) return A2(hP, n, A2(FA, n, t));
        if (s(A2(FA, n, r), t) > 0) {
            var e = A2(hP, n, t);
            return s(r, e) > 0 ? e : A2(Qq, 1, r);
        }
        return A2(hP, n, t);
    }), wP = F3(function(n, r, t) {
        return RU(A2(Je, A2(gP, n, r), t));
    }), kP = function(n) {
        switch(n.$){
            case 0:
                return k([
                    oP(n.a)
                ]);
            case 1:
                return k([
                    RU(e = n.a)
                ]);
            case 11:
                return k([
                    iP(e = n.a)
                ]);
            case 12:
                return k([
                    Eq(e = n.a)
                ]);
            case 13:
                return k([
                    uz(e = n.a)
                ]);
            case 2:
                return k([
                    cU(n.a)
                ]);
            case 8:
                return k([
                    A2(pP, t = n.a, n.b)
                ]);
            case 9:
                return k([
                    A3(wP, t = n.a, n.b, e = n.c)
                ]);
            case 10:
                var r = n.a, t = n.b, e = n.c;
                return k([
                    RU(function(n) {
                        var u = r(n);
                        return fu(u) ? e("") : e(A2(hP, t, A2(FA, t, u)));
                    })
                ]);
            case 3:
                return k([
                    tz(n.a)
                ]);
            case 4:
                return k([
                    dz((i = n.a, i ? "tel" : "password"))
                ]);
            case 5:
                return k([
                    A2(Wx, "inputmode", (a = n.a, a ? "email" : "numeric"))
                ]);
            case 6:
                return k([
                    rz(k([
                        b("input--invalid", n.a)
                    ]))
                ]);
            case 7:
                return mP;
            case 14:
                return k([
                    jz(n.a)
                ]);
            case 15:
                return k([
                    A2(Wx, "data-test", n.a)
                ]);
            case 16:
                return k([
                    vP(n.a)
                ]);
            case 17:
                return k([
                    cP(e = n.a)
                ]);
            case 18:
                return k([
                    Nk("input-with-icon")
                ]);
            case 19:
                return k([
                    (u = n.a, A2(Ok, "autocomplete", u ? "on" : "off"))
                ]);
            case 20:
                return k([
                    A2(Wx, "autocomplete", n.a)
                ]);
            default:
                return k([
                    lU(n.a)
                ]);
        }
        var u, a, i;
    }, xP = function(n) {
        return A2(fU, A2(Ot, Nk("input"), A2(Ot, dz("text"), A2(Ji, kP, n))), h);
    }, yP = function(n) {
        var r = Gb(A2(Ep, function(n) {
            return 18 === n.$ ? Ht(n.a) : Rt;
        }, n));
        if (r.$) return xP(n);
        var t = r.a;
        return A2(Ik, h, k([
            xP(n),
            A2(US, k([
                Vq("input-icon")
            ]), t)
        ]));
    }, _P = F2(function(n, r) {
        return A3(ce, lE, sE, n).yR ? function(n) {
            var r = QA(n.zZ), t = function() {
                var r = n.oD;
                if (r.$) return "";
                var t = r.a;
                return A2(dP, AA("/"), t);
            }();
            return A2(Ik, h, k([
                yP(k([
                    bP(t),
                    sP(!0),
                    lP(r.BU)
                ]))
            ]));
        }(r) : A2(Ik, k([
            Eq(fE),
            jz(r.qU),
            dE(0),
            A2(cz, oE, r.qU)
        ]), k([
            A2(px, oy, A3(fP, r.oD, QA(r.zZ), r.bN))
        ]));
    }), CP = F2(function(n, r) {
        return A2(PB, k([
            EB,
            Lz,
            UB,
            Qk(k([
                Nk("block mb-2")
            ]))
        ]), k([
            ad(n(r))
        ]));
    }), DP = F2(function(n, r) {
        return A2(Ik, h, k([
            A2(CP, n, Bq.$7),
            A2(Ik, k([
                Nk("input-group")
            ]), k([
                A2(Gk, k([
                    Nk("input-addon"),
                    A2(cE, "border-right-width", "1px")
                ]), k([
                    A2(px, hu, A2(US, k([
                        Sz
                    ]), 27))
                ])),
                A2(Ik, k([
                    Nk("flex-1")
                ]), k([
                    A2(px, Px, A2(_P, h, r))
                ]))
            ]))
        ]));
    }), AP = F5(function(n, r, t, e, u) {
        return k([
            A2(LB, k([
                Qk(k([
                    Nk("block text-current")
                ]))
            ]), k([
                ad(A2(Fz, n, r))
            ])),
            A2(PB, k([
                EB,
                Lz,
                UB,
                Qk(k([
                    Nk("block mt-1")
                ]))
            ]), k([
                ad(A2(uc, "", oA(r)))
            ])),
            A2(Ik, k([
                Nk("mt-6 pb-80")
            ]), k([
                function() {
                    var r = HD(u);
                    if (r.$) return Sq;
                    var t = r.a;
                    return A2(Ik, k([
                        Nk("mb-6")
                    ]), k([
                        A2(px, qD, A2(BU, {
                            Av: t,
                            iE: e.cO,
                            wT: n,
                            DI: u.DI
                        }, u.dn))
                    ]));
                }(),
                pA(r) ? Sq : A2(DP, n, t),
                A2(Ik, k([
                    Nk("mt-6")
                ]), k([
                    A3(aE, n, r, e)
                ]))
            ]))
        ]);
    }), qP = function(n) {
        var r = b(pA(n), function(n) {
            return n.pX;
        }(n));
        if (1 !== r.a || r.b.$) return Sq;
        var t = r.b.a;
        return A2(PB, k([
            EB,
            BB,
            UB,
            Qk(k([
                Nk("block mt-1")
            ]))
        ]), k([
            ad(t)
        ]));
    }, BP = F2(function(n, r) {
        var t, e = CB(r).$ ? EB : rx;
        return k([
            A2(Ik, k([
                Nk("-mx-8 -mt-8 mb-4 relative")
            ]), k([
                (t = function(n) {
                    return n.oj;
                }(r), t.$ ? Sq : A2(AB, k([
                    TB(t.a),
                    Iq(""),
                    Nk("w-full object-cover rounded-t-md")
                ]), h))
            ])),
            function() {
                var n = oA(r);
                if (n.$) return Sq;
                var t = n.a;
                return A2(LB, k([
                    Qk(k([
                        Nk("block text-current")
                    ]))
                ]), k([
                    ad(t)
                ]));
            }(),
            A2(PB, k([
                e,
                Lz,
                UB,
                Qk(k([
                    Nk("block mt-1")
                ]))
            ]), k([
                ad(A2(DB, n, r))
            ])),
            qP(r),
            function() {
                var n = Tq(r);
                if (n.$) return Sq;
                var t = n.a;
                return A2(Ik, k([
                    Nk("mt-4 text-sm rich-text")
                ]), A2(yu, px(hu), Nj(t)));
            }()
        ]);
    }), jP = F2(function(n, r) {
        var t = r.W;
        if (t.$) return Sq;
        if (t.a.b.$) {
            var e = t.a;
            return A2(Tz, k([
                VS,
                WS,
                IS(A5(AP, n, u = e.a, r.cn, e.b.a, r)),
                XS(k([
                    A2(fz, k([
                        nz,
                        JS,
                        QS(RS)
                    ]), k([
                        ad(n(Bq.lR))
                    ]))
                ]))
            ]), r.e1);
        }
        var u = t.a.a, a = bA(r.dw) ? n(Bq.lR) : A2(NS, n, u), i = !YS(CB(u));
        return A2(Tz, k([
            VS,
            WS,
            IS(A2(BP, n, u)),
            XS(k([
                A2(fz, k([
                    nz,
                    JS,
                    QS(OS(u)),
                    ZS(i)
                ]), k([
                    ad(a)
                ]))
            ]))
        ]), r.e1);
    }), SP = F2(function(n, r) {
        switch(r){
            case 0:
                return n(Bq.l9);
            case 1:
                return n(Bq._);
            default:
                return n(Bq.ia);
        }
    }), zP = F3(function(n, r, t) {
        for(;;){
            if (!t.b) return Rt;
            var e = t.b;
            if (r(t.a)) return Ht(n);
            n += 1, t = e;
        }
    }), UP = zP(0), EP = {
        $: 4
    }, PP = F5(function(n, r, t, e, u) {
        var a, c = u.a, o = u.b.dY, f = n + "-" + (0, u.b.dW)(c), l = 1 !== (a = b(t, 0 > s(e, r))).a || a.b ? SD(u) : EP;
        return (i(e, r) ? jq(k([
            jz(f),
            Nk("tabs__item tabs__item--active")
        ])) : jq(k([
            Eq(l),
            jz(f),
            Nk("tabs__item"),
            rz(k([
                b("tabs__item--previous", !i(l, EP))
            ]))
        ])))(k([
            A2(px, hu, o(c))
        ]));
    }), TP = F2(function(n, r) {
        var t = n.qU, e = n.jB, u = n.c0, a = n.hZ, c = "translateX(" + rB(n.jA - n.jt + n.ju) + "px) scaleX(" + rB(e) + ")", o = A2(uc, -1, A2(UP, function(n) {
            return i((0, n.b.dW)(n.a), u);
        }, r));
        return A2(Ik, k([
            jz(t),
            Nk("tabs"),
            rz(k([
                b("tabs--interactive", !a)
            ]))
        ]), A2(Ot, A2(Gk, k([
            A2(cE, "transform", c),
            Nk("tabs__underline")
        ]), h), A2(be, A3(PP, t, o, a), r)));
    }), FP = F2(function(n, r) {
        var t = k([
            A2(TD, 0, {
                dW: nD,
                dY: function(r) {
                    return ad(A2(SP, n, r));
                }
            }),
            A2(TD, 1, {
                dW: nD,
                dY: function(r) {
                    return ad(A2(SP, n, r));
                }
            }),
            A2(TD, 2, {
                dW: nD,
                dY: function(r) {
                    return ad(A2(SP, n, r));
                }
            })
        ]);
        return A2(px, Hx, A2(TP, r.dV, t));
    }), LP = F2(function(n, r) {
        return {
            gF: k([
                A2(Ik, k([
                    Nk("panel")
                ]), Aq(r) ? k([
                    A2(FP, n, r),
                    A2(Pq, n, r),
                    A2(HS, n, r)
                ]) : k([
                    A2(HS, n, r)
                ])),
                A2(jP, n, r)
            ]),
            wD: n(fd)
        };
    }), MP = Ux({
        zO: rD,
        Ab: tD,
        Ct: eD,
        Dd: function(n) {
            return xk(k([
                A2(xD, uD, _D()),
                kD(n.e1)
            ]));
        },
        DB: Dq,
        DH: LP
    }), HP = F3(function(n, r, t) {
        return {
            mo: r,
            qU: n,
            rc: t
        };
    }), RP = A2(Ge, function(n) {
        switch(n){
            case "in_person":
                return Ke(0);
            case "virtual":
                return Ke(1);
            default:
                return yy("Invalid meeting type");
        }
    }, w$), OP = F5(function(n, r, t, e, u) {
        return {
            l0: t,
            me: u,
            qU: n,
            sS: r,
            wJ: e
        };
    }), NP = A4(Sy, "allow_online_booking", l_(xy), Rt, A4(Sy, "today", l_(FC), Rt, A4(Sy, "address", l_(w$), Rt, A3(zy, "name", w$, A3(zy, "id", w$, Ke(OP)))))), IP = A2(qy, NP, Ke(ru)), VP = A4(Sy, "contact_info_for_cancellation", l_(w$), Rt, A4(Sy, "latest_cancellation_notice_time_amount", l_(C$), Rt, A4(Sy, "latest_cancellation_notice_time_format", l_(w$), Rt, A4(Sy, "cancellation_policy", l_(w$), Rt, A4(Sy, "booking_locations", l_(Ey(IP)), Rt, A3(zy, "allow_instant_book", xy, A3(zy, "allow_non_member_to_book", xy, A3(zy, "meeting_type", RP, A3(zy, "duration", C$, A3(zy, "name", w$, A3(zy, "id", w$, Ke(function(n) {
        return function(r) {
            return function(t) {
                return function(e) {
                    return function(u) {
                        return function(a) {
                            return function(i) {
                                return function(c) {
                                    return function(o) {
                                        return function(f) {
                                            return function(s) {
                                                return {
                                                    mb: a,
                                                    md: u,
                                                    mZ: i,
                                                    m3: c,
                                                    nW: s,
                                                    pm: t,
                                                    qU: n,
                                                    rw: f,
                                                    rx: o,
                                                    r2: e,
                                                    sS: r
                                                };
                                            };
                                        };
                                    };
                                };
                            };
                        };
                    };
                };
            };
        };
    })))))))))))), WP = A2(qy, VP, Ke(ru)), ZP = A3(zy, "is_cancellable", xy, A3(zy, "appointment_type", l_(WP), A3(zy, "id", w$, Ke(HP)))), XP = A2(qy, ZP, Ke(ru)), GP = function(n) {
        return k([
            "v1",
            "public",
            n
        ]);
    }, JP = F2(function(n, r) {
        return A2($y, k([
            "appointments",
            r
        ]), GP(n));
    }), YP = F4(function(n, r, t, e) {
        return A4(dC, n, XP, e, bC(A2(JP, r, t)));
    }), QP = V, KP = function(n) {
        var r = A2(ae, ".", n);
        return oe(r) > 2 ? Gb(r) : Rt;
    }, nT = function(n) {
        var r = A2(Zu, "subdomain", Fp(n));
        return r.$ ? A2(Zu, "practice", Fp(n)) : Ht(r.a);
    }, rT = F3(function(n, r, t) {
        var e, u, a = {
            gz: oc,
            a9: t.BD.a9,
            j$: r.ys.B6,
            kj: r.kj,
            tE: Rt,
            dw: n,
            w_: t
        }, i = A2(uc, Dp, A2(Cp, function(n) {
            return A4(YP, a.j$, n, a.a9, ru);
        }, A2(z$, A2(QP, ".hint.com", e = (u = t.B9).zG) ? KP(e) : Rt, nT(u.iu))));
        return b(a, i);
    }), tT = F2(function(n, r) {
        return b(r, Dp);
    }), eT = F2(function(n, r) {
        return r;
    }), uT = F2(function(n, r) {
        var t = n;
        if (3 === t.$) {
            var e = t.a;
            return v(m(r, {
                gz: t
            }), A2(zx, r.w_.iu, e.rc ? da({
                a9: r.a9
            }) : Za({
                a9: r.a9
            })), h);
        }
        return v(m(r, {
            gz: oc
        }), Dp, A2(uA, 0, t));
    }), aT = function(n) {
        return n.N.mD;
    }, iT = function(n) {
        return n.N.N;
    }, cT = function(n) {
        return n.N.m1;
    }, oT = function(n) {
        return n.N.m3;
    }, fT = function(n) {
        return n.N.n$;
    }, sT = function(n) {
        return n.N.qQ;
    }, lT = function(n) {
        return n.N.qV;
    }, dT = function(n) {
        return n.N.sM;
    }, bT = function(n) {
        return n.N.vm;
    }, vT = function(n) {
        return n.N.wF;
    }, mT = function(n) {
        return n.N.wG;
    }, pT = function(n) {
        return n.N.xr;
    }, $T = F2(function(n) {
        return {
            gF: h,
            wD: n(iT)
        };
    }), hT = kx({
        zO: rT,
        Ab: tT,
        Ct: eT,
        Dd: function() {
            return yk;
        },
        DB: uT,
        DH: $T
    }), gT = function(n) {
        return {
            $: 0,
            a: n
        };
    }, wT = k([
        "v1",
        "member"
    ]), kT = function(n) {
        return A2($y, k([
            n
        ]), wT);
    }, xT = F2(function(n, r) {
        return A2($y, k([
            "appointments",
            r
        ]), kT(n));
    }), yT = F2(function(n, r) {
        return A2($y, k([
            "cancel"
        ]), A2(xT, n, r));
    }), _T = F5(function(n, r, t, e, u) {
        return {
            mo: t,
            mX: e,
            qU: n,
            uE: u,
            wf: r
        };
    }), CT = F2(function(n, r) {
        return {
            sS: n,
            w2: r
        };
    }), DT = A3(zy, "user_id", w$, A3(zy, "name", w$, Ke(CT))), AT = A2(qy, DT, Ke(ru)), qT = A3(zy, "provider", AT, A3(zy, "booking_location", l_(IP), A3(zy, "appointment_type", l_(WP), A3(zy, "start_display", l_(w$), A3(zy, "id", w$, Ke(_T)))))), BT = A2(qy, qT, Ke(ru)), jT = F4(function(n, r, t, e) {
        return A4(dC, n, BT, e, bC(A2(yT, r, t)));
    }), ST = function(n) {
        if (n.$) return Rt;
        var r = n.a;
        return h$(r) ? k$(A2(m$, A2(Tu, "sub", w$), r)) : Rt;
    }, zT = function(n) {
        return ST(Q_(n));
    }, UT = F3(function(n, r, t) {
        var e, u = {
            gz: oc,
            a9: t.BD.a9,
            c5: r.ys.ya,
            kj: r.kj,
            tE: MD(r.tE),
            dw: n,
            w_: t
        };
        return b(u, (e = zT(u.c5)).$ ? Dp : A4(jT, u.c5, e.a, u.a9, gT));
    }), ET = F2(function(n, r) {
        return b(r, Dp);
    }), PT = F2(function(n, r) {
        return r;
    }), TT = function(n) {
        return {
            $: 2,
            a: n
        };
    }, FT = function(n) {
        return n.me;
    }, LT = function(n) {
        return n.mo;
    }, MT = function(n) {
        return n.mX;
    }, HT = F4(function(n, r, t, e) {
        return A4(kq, n, BT, e, bC(A2(yT, r, t)));
    }), RT = function(n) {
        return n.qU;
    }, OT = F2(function(n, r) {
        switch(n.$){
            case 0:
                var t = n.a;
                n: for(;;)switch(t.$){
                    case 3:
                        return v(m(r, {
                            gz: t
                        }), Dp, h);
                    case 2:
                        if (8 === t.a.$) return v(m(r, {
                            gz: oc
                        }), A2(zx, r.w_.iu, Za({
                            a9: r.a9
                        })), h);
                        break n;
                    default:
                        break n;
                }
                return v(m(r, {
                    gz: oc
                }), Dp, A2(uA, 0, t));
            case 1:
                return v(r, (c = zT(r.c5)).$ ? Dp : A4(HT, r.c5, c.a, r.a9, TT), h);
            default:
                t = n.a;
                n: for(;;)switch(t.$){
                    case 3:
                        var e = t.a, u = LT(e), a = (i = b(A2(uc, !1, A2(Xb, FT, MT(e))), u)).a && !i.b.$ ? Ml(k([
                            b("appointment-type", RT(i.b.a))
                        ])) : oa;
                        return v(m(r, {
                            gz: t
                        }), A2(zx, a, ba({
                            a9: r.a9
                        })), h);
                    case 2:
                        if (8 === t.a.$) return v(m(r, {
                            gz: oc
                        }), A2(zx, r.w_.iu, Za({
                            a9: r.a9
                        })), h);
                        break n;
                    default:
                        break n;
                }
                return v(m(r, {
                    gz: oc
                }), Dp, A2(uA, 0, t));
        }
        var i, c;
    }), NT = {
        $: 1
    }, IT = function(n) {
        return n.l0;
    }, VT = function(n) {
        return n.pm;
    }, WT = ir("h1"), ZT = nx(4), XT = F2(function(n, r) {
        return A2(WT, vx(A2(Ot, ZT, n)), r);
    }), GT = function(n) {
        return n.r2;
    }, JT = function(n) {
        return n.sS;
    }, YT = function(n) {
        return n.sS;
    }, QT = function(n) {
        return n.sS;
    }, KT = function(n) {
        return n.wf;
    }, nF = function(n) {
        return n.m3;
    }, rF = function(n) {
        return n.nW;
    }, tF = function(n) {
        return n.rw;
    }, eF = function(n) {
        return n.rx;
    }, uF = function(n) {
        return n.trim();
    }, aF = function(n) {
        return fu(uF(n));
    }, iF = zB(5), cF = Fb("\xa0"), oF = A2(Gk, h, k([
        ad(cF)
    ])), fF = ir("a"), sF = "(###) ###-####", lF = zA(sF), dF = function(n) {
        return A2(FA, lF, n);
    }, bF = F2(function(n, r) {
        return n ? r : dF(r);
    }), vF = function(n) {
        var r;
        return A2(Ok, "href", /^javascript:/i.test((r = n).replace(/\s/g, "")) ? "" : r);
    }, mF = function(n) {
        var r = A2(Jq, he, n);
        return A2(fF, k([
            vF("tel:" + r)
        ]), k([
            A2(Gk, k([
                Nk("hover:underline cursor-pointer text-info-300")
            ]), k([
                ad(A2(bF, 0, r))
            ]))
        ]));
    }, pF = F2(function(n, r) {
        if (r.$) return Sq;
        var t = r.a;
        return A2(Ik, h, k([
            A2(hx, k([
                iF,
                bz(gz)
            ]), k([
                ad(n(cT))
            ])),
            A2(hx, k([
                bz(gz)
            ]), k([
                ad(n(mT)),
                oF,
                mF(t)
            ]))
        ]));
    }), $F = F2(function(n) {
        return n(sT);
    }), hF = F3(function(n, r, t) {
        var e = b(r, t);
        if (e.a.$ || e.b.$) return Sq;
        var u = e.a.a, a = e.b.a;
        return A2(Ik, h, k([
            A2(hx, k([
                iF,
                bz(gz)
            ]), k([
                ad(n(dT))
            ])),
            A2(hx, k([
                bz(gz)
            ]), k([
                ad(ee(u)),
                oF,
                ad(A2($F, n, a)),
                oF,
                ad(n(aT))
            ]))
        ]));
    }), gF = F2(function(n, r) {
        return A2(Ik, h, k([
            A2(hx, k([
                iF,
                bz(gz)
            ]), k([
                ad(n(oT))
            ])),
            A2(hx, k([
                bz(gz)
            ]), k([
                ad(r)
            ]))
        ]));
    }), wF = hz(1), kF = function(n) {
        return n.b.t0;
    }, xF = function(n) {
        var r = kF(n);
        return r.$ ? Sq : mF(r.a);
    }, yF = F2(function(n, r) {
        return A2(Ik, h, k([
            A2(hx, k([
                bz(wF)
            ]), k([
                ad(n(fT)),
                oF,
                xF(r),
                oF,
                ad(n(vT))
            ]))
        ]));
    }), _F = F6(function(n, r, t, e, u, a) {
        if (r.$) return A2(yF, n, a);
        var i = r.a;
        return aF(i) ? A2(yF, n, a) : A2(Ik, k([
            Nk("flex flex-col gap-4")
        ]), k([
            A2(gF, n, i),
            A3(hF, n, t, e),
            A2(pF, n, u)
        ]));
    }), CF = F3(function(n, r, t) {
        return A6(_F, n, nF(r), tF(r), eF(r), rF(r), t);
    }), DF = F2(function(n, r) {
        if (r.$) return Rt;
        var t = r.a;
        return Ht(A2(Ik, k([
            Nk("font-extrabold")
        ]), k([
            ad(t)
        ])));
    }), AF = function(n) {
        return k([
            A2(US, k([
                Sz,
                Vq("fill-none stroke-[32px] stroke-current")
            ]), 10),
            ad(n)
        ]);
    }, qF = function(n) {
        return n ? "Virtual" : "In-person";
    }, BF = function(n) {
        var r = k([
            1
        ]);
        return A2(lA, n, r) ? k([
            A2(Gk, k([
                Nk("mx-2")
            ]), k([
                ad("\u2022")
            ])),
            ad(qF(n))
        ]) : h;
    }, jF = F3(function(n, r, t) {
        var e = b(r, t);
        if (e.a.$ || e.b.$) return Rt;
        var u, a = e.a.a, i = e.b.a;
        return Ht(A2(Ik, h, k([
            A2(lz, k([
                iF
            ]), k([
                ad(a.jV)
            ])),
            A2(Ik, k([
                Nk("flex items-center")
            ]), A2(Ot, A2(Gk, h, k([
                ad((u = a.jU, A2(ue, " ", k([
                    ee(u),
                    " minutes"
                ]))))
            ])), BF(a.r2))),
            A2(Ik, k([
                Nk("flex items-center gap-1")
            ]), AF(i.kx)),
            function() {
                var n = i.kv;
                if (n.$) return Sq;
                var r = n.a;
                return A2(Ik, k([
                    Nk("ml-5")
                ]), k([
                    ad(r)
                ]));
            }()
        ])));
    }), SF = F2(function(n, r) {
        if (r.b) {
            var t = r.a, e = r.b, u = F2(function(r, t) {
                return A2(Ot, n, A2(Ot, r, t));
            });
            return A2(Ot, t, A3(xu, u, h, e));
        }
        return h;
    }), zF = function(n) {
        return n.o2;
    }, UF = function(n) {
        return n.sS;
    }, EF = F2(function(n, r) {
        return A2(Cp, function(n) {
            var r;
            return A2(Ik, k([
                Nk("font-extrabold")
            ]), k([
                ad("Book for "),
                Jx(UF(n)),
                Jx((r = zF(n), r.$ ? "" : Np(k([
                    " (",
                    A2(ep, "MM/dd/yyyy", r.a),
                    ")"
                ]))))
            ]));
        }, r);
    }), PF = F2(function(n, r) {
        if (r.$) return Rt;
        var t = r.a;
        return Ht(A2(Ik, k([
            Nk("font-extrabold")
        ]), k([
            ad(t)
        ])));
    }), TF = F2(function(n, r) {
        var t, e = r.mn, u = r.rK, a = r.fk, i = r.eb;
        return t = A2(Ep, ru, k([
            A2(EF, n, r.tE),
            A3(jF, n, e, u),
            A2(PF, n, a),
            A2(DF, n, i)
        ])), ED(t) ? Sq : A2(Ik, k([
            Nk("flex flex-col border border-info-200 bg-info-100 rounded p-4")
        ]), A2(SF, gx, t));
    }), FF = F4(function(n, r, t, e) {
        var u = b(r, t);
        if (3 !== u.a.$ || u.b.$) return A2(Ik, h, Yk);
        var a = u.a.a, i = u.b.a, c = function(n) {
            return n.uE;
        }(a), o = MT(a), f = b(LT(a), o);
        if (f.a.$ || f.b.$) return A2(Ik, h, Yk);
        var s = f.a.a, l = f.b.a;
        return A2(Ik, h, k([
            A2(Ik, k([
                Nk("text-center mb-8")
            ]), k([
                A2(XT, h, k([
                    ad(n(iT))
                ]))
            ])),
            A2(Ik, k([
                Nk("mb-6")
            ]), k([
                A2(TF, !1, {
                    eb: KT(a),
                    mn: Ht({
                        jU: VT(s),
                        jV: JT(s),
                        r2: GT(s)
                    }),
                    rK: Ht({
                        kv: IT(l),
                        kx: YT(l)
                    }),
                    tE: Ht(i),
                    fk: Ht(QT(c))
                })
            ])),
            A2(Ik, k([
                Nk("flex w-full mb-6")
            ]), k([
                A2(fz, k([
                    nz,
                    vz(k([
                        Nk("ml-auto mr-auto")
                    ])),
                    QS(NT)
                ]), k([
                    ad(n(iT))
                ]))
            ])),
            A3(CF, n, s, e)
        ]));
    }), LF = F2(function(n, r) {
        return {
            gF: k([
                A2(Ik, k([
                    Nk("panel w-full")
                ]), k([
                    A4(FF, n, r.gz, r.tE, r.dw)
                ]))
            ]),
            wD: n(iT)
        };
    }), MF = Ux({
        zO: UT,
        Ab: ET,
        Ct: PT,
        Dd: function() {
            return yk;
        },
        DB: OT,
        DH: LF
    }), HF = F3(function(n, r, t) {
        return b({
            a9: t.BD.a9,
            kj: r.kj,
            dw: n,
            w_: t
        }, Dp);
    }), RF = F2(function(n, r) {
        return b(r, Dp);
    }), OF = F2(function(n, r) {
        return r;
    }), NF = function(n) {
        return A2(Zu, "appointment-type", n);
    }, IF = F2(function(n, r) {
        var t, e = (t = NF(r.w_.iu)).$ ? oa : Ml(k([
            b("appointment-type", t.a)
        ]));
        return v(r, A2(zx, e, va), h);
    }), VF = F2(function(n) {
        return {
            gF: k([
                A2(Ik, k([
                    Nk("panel w-full")
                ]), k([
                    A2(Ik, k([
                        Nk("text-center mb-8")
                    ]), k([
                        A2(XT, h, k([
                            ad(n(pT))
                        ]))
                    ])),
                    A2(Ik, k([
                        Nk("mb-6")
                    ]), k([
                        ad(n(lT))
                    ])),
                    A2(Ik, k([
                        Nk("flex w-full mb-6")
                    ]), k([
                        A2(fz, k([
                            nz,
                            vz(k([
                                Nk("ml-auto mr-auto")
                            ])),
                            QS(0)
                        ]), k([
                            ad("Reschedule")
                        ]))
                    ]))
                ]))
            ]),
            wD: n(bT)
        };
    }), WF = Ux({
        zO: HF,
        Ab: RF,
        Ct: OF,
        Dd: function() {
            return yk;
        },
        DB: IF,
        DH: VF
    }), ZF = function(n) {
        return function(n) {
            return A2(dA, "clinical_calendar_migration", n);
        }(n) || function(n) {
            return A2(dA, "new_calendar", n);
        }(n);
    }, XF = function(n) {
        return {
            $: 0,
            a: n
        };
    }, GF = F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    }), JF = A3(zy, "appointment_types", Ey(WP), Ke(function(n) {
        return {
            mq: n
        };
    })), YF = A2(IC, 0, A2(qy, JF, Ke(GF))), QF = k([
        "v1",
        "booking"
    ]), KF = A2($y, k([
        "appointment-types"
    ]), QF), nL = KF, rL = F2(function(n, r) {
        return A4(dC, n, YF, r, bC(nL));
    }), tL = {
        $: 0
    }, eL = function(n) {
        return n.bW.xS;
    }, uL = function(n) {
        return n.bW.oV;
    }, aL = function(n) {
        return n.bW.zU;
    }, iL = function(n) {
        return n.bW.rr;
    }, cL = function(n) {
        return n.bW.BU;
    }, oL = function(n) {
        return n.bW.vd;
    }, fL = function(n) {
        return n.bW.fw;
    }, sL = F2(function(n, r) {
        return r.$ ? r.a.sS : n(eL);
    }), lL = {
        fw: id({
            qU: "booking-location-filter",
            Dr: sL,
            Dt: function(n) {
                return n.$ ? Ht(n.a.qU) : Rt;
            }
        }),
        dM: tL
    }, dL = A2(zx, oa, Ru), bL = F3(function(n, r, t) {
        var e = {
            ee: oc,
            c5: r.ys.ya,
            kj: r.kj,
            kw: lL,
            tE: MD(r.tE),
            dw: n,
            w_: t
        }, u = ZF(n) ? function(n) {
            return A2(rL, n.c5, XF);
        }(e) : dL;
        return b(e, u);
    }), vL = F2(function(n, r) {
        return b(r, Dp);
    }), mL = F2(function(n, r) {
        return m(r, {
            xE: Ht(9)
        });
    }), pL = function(n) {
        return {
            $: 2,
            a: n
        };
    }, $L = function(n) {
        return n.a.mq;
    }, hL = F2(function(n, r) {
        if (n.$) return r;
        var t = n.a;
        return A2(Tc, function(n) {
            return i(RT(n), t);
        }, r);
    }), gL = function(n) {
        return n.qU;
    }, wL = F2(function(n, r) {
        var t = A2(bq, n, r.fw), e = t.b, u = t.c;
        return b(m(r, {
            fw: t.a,
            dM: u.$ || u.a.$ || u.a.a.$ ? r.dM : u.a.a.a
        }), A2(jp, ru, e));
    }), kL = F2(function(n, r) {
        switch(n.$){
            case 0:
                var t = n.a, e = m(r, {
                    ee: t
                });
                if (3 === t.$) {
                    var u = t.a, a = A2(hL, NF(e.w_.iu), $L(u));
                    return v(e, ED(a) ? A2(zx, oa, Ya) : Dp, h);
                }
                return v(e, Dp, A2(uA, 0, t));
            case 1:
                var i = n.a, c = i.b;
                return v(r, A2(zx, r.w_.iu, ma({
                    mp: RT(i.a),
                    mY: gL(c)
                })), h);
            default:
                var o = A2(wL, n.a, r.kw), f = o.b;
                return v(m(r, {
                    kw: o.a
                }), A2(jp, pL, f), h);
        }
    }), xL = F4(function(n, r, t, e) {
        var u = t.$ ? "Please contact" : t.a + ", please contact", a = function() {
            var n = b(r, e);
            if (n.a.$) return ad(n.b.$ ? "" : u = n.b.a);
            if (n.b.$) return t = n.a.a, A2(Gk, h, k([
                ad("at "),
                A2(fF, k([
                    vF("tel:" + t)
                ]), k([
                    A2(Gk, k([
                        Nk("hover:underline cursor-pointer text-info-300")
                    ]), k([
                        ad(A2(bF, 0, t))
                    ]))
                ])),
                ad(".")
            ]));
            var t = n.a.a, u = n.b.a;
            return A2(Gk, h, k([
                ad("at "),
                A2(fF, k([
                    vF("tel:" + t)
                ]), k([
                    A2(Gk, k([
                        Nk("hover:underline cursor-pointer text-info-300")
                    ]), k([
                        ad(A2(bF, 0, t))
                    ]))
                ])),
                ad(" " + u)
            ]));
        }();
        return A2(Gk, h, k([
            ad(u),
            ad(" "),
            ad(n),
            ad(" "),
            a
        ]));
    }), yL = function(n) {
        return A2(Ik, k([
            Nk("flex flex-col")
        ]), k([
            A2(Ik, h, k([
                ad("Can't find a service that suits your needs?")
            ])),
            A2(Ik, h, k([
                A4(xL, hk(n), kF(n), Rt, Rt)
            ]))
        ]));
    }, _L = function(n) {
        return {
            $: 1,
            a: n
        };
    }, CL = function(n) {
        return n.md;
    }, DL = F2(function(n, r) {
        var t = F2(function(r, t) {
            var e = t.a, u = t.b;
            return n(r) ? b(A2(Ot, r, e), u) : b(e, A2(Ot, r, u));
        });
        return A3(xu, t, b(h, h), r);
    }), AL = function(n) {
        return n.mZ;
    }, qL = function(n) {
        return A2(uc, h, A2(Cp, yu(function(r) {
            return b(n, r);
        }), AL(n)));
    }, BL = F2(function(n, r) {
        var t = function(n) {
            var r = n.dM;
            return r.$ ? Ht(r.a.qU) : Rt;
        }(n);
        if (t.$) return r;
        var e = t.a;
        return A2(Tc, function(n) {
            return i(gL(n.b), e);
        }, r);
    }), jL = F2(function(n, r) {
        return A2(Wu, JT(n), JT(r));
    }), SL = F2(function(n, r) {
        return A2(Wu, YT(n), YT(r));
    }), zL = F2(function(n, r) {
        var t = n.a, e = r.a, u = A2(SL, n.b, r.b);
        return 1 === u ? A2(jL, t, e) : u;
    }), UL = C, EL = F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    }), PL = nx(2), TL = function(n) {
        return {
            $: 3,
            a: n
        };
    }, FL = TL(1), LL = function(n) {
        return !CL(n);
    }, ML = function(n) {
        return LL(n) ? A2(lz, k([
            EB,
            bz(FL),
            Qk(k([
                Nk("text-secondary")
            ]))
        ]), k([
            A2(Ik, k([
                Nk("px-3 py-1")
            ]), k([
                ad("Member-only")
            ]))
        ])) : Sq;
    }, HL = F2(function(n, r) {
        var t = GT(n);
        return A2(Ik, k([
            Nk("flex flex-row cursor-pointer border border-info-200 rounded px-4 py-2 text-primary-500 gap-1 justify-between"),
            Eq(A2(EL, n, r))
        ]), k([
            A2(Ik, k([
                Nk("flex flex-col gap-1")
            ]), k([
                A2(lz, k([
                    iF,
                    PL,
                    Qk(k([
                        Nk("text-black")
                    ]))
                ]), k([
                    ad(JT(n))
                ])),
                A2(Ik, k([
                    Nk("flex items-center")
                ]), A2(Ot, A2(Gk, h, k([
                    ad(ee(VT(n)) + " minutes")
                ])), BF(t))),
                A2(Ik, k([
                    Nk("flex items-center gap-1")
                ]), AF(YT(r)))
            ])),
            ML(n)
        ]));
    }), RL = F2(function(n, r) {
        return A2(Ik, k([
            Nk("flex flex-col gap-4")
        ]), A2(yu, function(n) {
            return A2(HL, n.a, n.b);
        }, A2(UL, zL, A2(BL, n, A2(Ji, qL, r)))));
    }), OL = zB(4), NL = function(n) {
        return {
            $: 1,
            a: n
        };
    }, IL = NL({
        $: 0
    }), VL = function(n) {
        return function(n) {
            return {
                $: 1,
                a: n
            };
        }({
            qU: gL(n),
            sS: YT(n)
        });
    }, WL = function(n) {
        return A2(Ot, A2(Xz, h, tL), A2(Ot, IL, A2(yu, A2(Je, VL, Xz(h)), n)));
    }, ZL = function(n) {
        return {
            $: 1,
            a: n
        };
    }, XL = function(n) {
        return A2(uc, h, AL(n));
    }, GL = oa, JL = F2(function(n, r) {
        return A3(Qu, n, 0, r);
    }), YL = F2(function(n, r) {
        return !A2(Zu, n, r).$;
    }), QL = F2(function(n, r) {
        return A2(YL, n, r);
    }), KL = F4(function(n, r, t, e) {
        for(;;){
            if (!t.b) return we(e);
            var u = t.a, a = t.b, i = n(u);
            A2(QL, i, r) ? t = a : (r = A2(JL, i, r), t = a, e = A2(Ot, u, e));
        }
    }), nM = F2(function(n, r) {
        return A4(KL, n, GL, r, h);
    }), rM = F3(function(n, r, t) {
        var e = function(n) {
            return A2(UL, SL, A2(nM, gL, A2(Ji, XL, n)));
        }(r);
        return oe(e) > 1 ? A2(Ik, k([
            Nk("flex flex-col gap-2")
        ]), k([
            A2(hx, k([
                OL
            ]), k([
                ad(n(iL))
            ])),
            A2(px, ru, A4(AU, n, k([
                Jz(Ht(t.dM)),
                Wz,
                ZL(n(cL))
            ]), WL(e), t.fw))
        ])) : Sq;
    }), tM = F4(function(n, r, t, e) {
        var u = A2(hL, NF(r.iu), $L(e)), a = A2(DL, CL, u), i = a.a, c = a.b;
        return k([
            A2(px, pL, A3(rM, n, u, t)),
            A2(px, _L, A2(RL, t, c)),
            A2(px, _L, A2(RL, t, i))
        ]);
    }), eM = function(n) {
        return n.a.r2;
    }, uM = function(n) {
        return n.a.sS;
    }, aM = function(n) {
        var r;
        return {
            jU: (r = n, r.a.pm),
            jV: uM(n),
            r2: eM(n)
        };
    }, iM = function(n) {
        return {
            kv: IT(n),
            kx: YT(n)
        };
    }, cM = F2(function(n, r) {
        var t = r.tE, e = r.mX, u = r.fk;
        return A2(TF, n, {
            eb: r.eb,
            mn: A2(Cp, aM, r.xU),
            rK: A2(Cp, iM, e),
            tE: t,
            fk: u
        });
    }), oM = F2(function(n, r) {
        var t = r.ee;
        if (3 === t.$) {
            var e = t.a;
            return A2(Ik, k([
                Nk("flex flex-col gap-4")
            ]), A2(Ot, A2(cM, !1, {
                eb: Rt,
                xU: Rt,
                mX: Rt,
                tE: r.tE,
                fk: Rt
            }), $(A4(tM, n, r.w_, r.kw, e), k([
                yL(r.dw)
            ]))));
        }
        return A2(Ik, h, Yk);
    }), fM = function(n) {
        return n.mb;
    }, sM = function(n) {
        var r;
        return r = function(n) {
            return n ? "Book an appointment" : "Request an appointment";
        }(n), A2(XT, k([
            bz(yz),
            UB
        ]), k([
            ad(r)
        ]));
    }, lM = F2(function(n, r) {
        if (3 === r.$) {
            var t = r.a, e = NF(n.iu);
            if (e.$) return sM(!0);
            var u = e.a, a = A2(zD, function(n) {
                return i(RT(n), u);
            }, $L(t));
            return sM(!!a.$ || fM(a.a));
        }
        return sM(!0);
    }), dM = F2(function(n, r) {
        return {
            gF: k([
                A2(Ik, k([
                    Nk("flex flex-col gap-4")
                ]), k([
                    A2(lM, r.w_, r.ee),
                    A2(oM, n, r)
                ]))
            ]),
            wD: "Booking"
        };
    }), bM = Ux({
        zO: bL,
        Ab: vL,
        Ct: mL,
        Dd: function() {
            return yk;
        },
        DB: kL,
        DH: dM
    }), vM = function(n) {
        return {
            $: 4,
            a: n
        };
    }, mM = function(n) {
        return {
            $: 0,
            a: n
        };
    }, pM = F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    }), $M = A4(Sy, "redirect_button_text", l_(w$), Rt, A4(Sy, "redirect_url", l_(w$), Rt, A4(Sy, "notes_custom_question", l_(w$), Rt, A4(Sy, "notes_required", xy, !1, A3(zy, "allow_instant_book", xy, A3(zy, "require_provider_selection", xy, A3(zy, "booking_location", IP, A3(zy, "meeting_type", RP, A3(zy, "duration", C$, A3(zy, "name", w$, A3(zy, "id", w$, Ke(function(n) {
        return function(r) {
            return function(t) {
                return function(e) {
                    return function(u) {
                        return function(a) {
                            return function(i) {
                                return function(c) {
                                    return function(o) {
                                        return function(f) {
                                            return function(s) {
                                                return {
                                                    mb: i,
                                                    mX: u,
                                                    pm: t,
                                                    qU: n,
                                                    r2: e,
                                                    sS: r,
                                                    s6: o,
                                                    s7: c,
                                                    uY: s,
                                                    uZ: f,
                                                    vc: a
                                                };
                                            };
                                        };
                                    };
                                };
                            };
                        };
                    };
                };
            };
        };
    })))))))))))), hM = A2(IC, 0, A2(qy, $M, Ke(pM))), gM = F2(function(n, r) {
        return A2($y, k([
            n,
            "location",
            r
        ]), KF);
    }), wM = F2(function(n, r) {
        return A2(gM, n, r);
    }), kM = F4(function(n, r, t, e) {
        return A4(dC, n, hM, e, bC(A2(wM, r, t)));
    }), xM = F3(function(n, r, t) {
        return A4(kM, n, r, t, mM);
    }), yM = function(n) {
        return {
            $: 1,
            a: n
        };
    }, _M = function(n) {
        return {
            $: 0,
            a: n
        };
    }, CM = A3(ip, 1992, 4, 31), DM = b({
        bR: Ht(CM),
        fd: 0,
        wJ: CM
    }, A2(Eu, _M, vy)), AM = b({
        mo: Rt,
        ci: Rt,
        bN: DM.a,
        am: Rt,
        aQ: Rt
    }, A2(jp, yM, DM.b)), qM = function(n) {
        return n.uj;
    }, BM = function(n) {
        return A2(Xb, qM, MD(n));
    }, jM = F3(function(n, r, t) {
        var e = AM.a, u = AM.b, a = {
            ch: oc,
            mp: t.BD.mp,
            bD: oc,
            cj: Rt,
            mY: t.BD.mY,
            c5: r.ys.ya,
            kj: r.kj,
            tE: MD(r.tE),
            ih: BM(r.tL),
            dw: n,
            ae: e,
            w_: t
        }, i = ZF(n) ? A3(xM, a.c5, a.mp, a.mY) : dL;
        return b(a, Hu(k([
            i,
            A2(jp, vM, u)
        ])));
    }), SM = F2(function(n, r) {
        return b(m(r, {
            ih: BM(n.tL)
        }), Dp);
    }), zM = F2(function(n, r) {
        return m(r, {
            xE: Ht(9)
        });
    }), UM = function(n) {
        return {
            $: 2,
            a: n
        };
    }, EM = function(n) {
        return {
            $: 3,
            a: n
        };
    }, PM = Kn("gotItemPort", A2(Ge, function(n) {
        return A2(Ge, function(r) {
            return A2(Ge, function(t) {
                return Ke({
                    xF: t,
                    rm: r,
                    w5: n
                });
            }, A2(Tu, "action", w$));
        }, A2(Tu, "itemType", w$));
    }, A2(Tu, "value", D$(k([
        Dy(Rt),
        A2(Ye, Ht, w$)
    ]))))), TM = F2(function(n, r) {
        return {
            $: 1,
            a: n,
            b: r
        };
    }), FM = F2(function(n, r) {
        return {
            $: 2,
            a: n,
            b: r
        };
    }), LM = function(n) {
        switch(n){
            case "OnlineEnrollment":
                return 0;
            case "PageAbandoned":
                return 1;
            case "Booking":
                return 4;
            default:
                return 2;
        }
    }, MM = F2(function(n, r) {
        var t = r.w5, e = r.rm, u = r.xF;
        switch(u){
            case "set":
                return n(Qt(function(n) {
                    return {
                        $: 0,
                        a: n
                    };
                }(LM(e))));
            case "get":
                return n(Qt(A2(TM, LM(e), t)));
            case "remove":
                return n(Qt(A2(FM, LM(e), !1)));
            case "removeAndRedirect":
                return n(Qt(A2(FM, LM(e), !0)));
            default:
                return n(Xt("Action " + u + " not supported"));
        }
    }), HM = function(n) {
        return PM(MM(n));
    }, RM = Kn("removedItemPort", A2(Ge, function(n) {
        return A2(Ge, function(r) {
            return A2(Ge, function(t) {
                return Ke({
                    xF: t,
                    rm: r,
                    w5: n
                });
            }, A2(Tu, "action", w$));
        }, A2(Tu, "itemType", w$));
    }, A2(Tu, "value", D$(k([
        Dy(Rt),
        A2(Ye, Ht, w$)
    ]))))), OM = function(n) {
        return RM(MM(n));
    }, NM = F2(function(n, r) {
        return {
            $: 1,
            a: n,
            b: r
        };
    }), IM = "bookingForm", VM = {
        ea: Rt,
        eb: Rt,
        ec: Rt,
        o2: Rt,
        pt: Rt,
        qb: Rt,
        rt: Rt,
        e5: Rt,
        t0: Rt,
        fj: Rt,
        fk: Rt
    }, WM = F2(function(n, r) {
        return {
            $: 1,
            a: n,
            b: r
        };
    }), ZM = F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    }), XM = F3(function(n, r, t) {
        return {
            my: r,
            oG: n,
            w3: t
        };
    }), GM = F2(function(n, r) {
        return {
            oD: n,
            wC: r
        };
    }), JM = F5(function(n, r, t, e, u) {
        return {
            pD: e,
            vM: u,
            wc: n,
            wg: t,
            w2: r
        };
    }), YM = A3(zy, "short_tz_display_text", w$, A3(zy, "end_display_text", w$, A3(zy, "start_display_text", w$, A3(zy, "user_id", w$, A3(zy, "start", w$, Ke(JM)))))), QM = A2(qy, YM, Ke(ru)), KM = A3(zy, "time_slots", Ey(QM), A3(zy, "date", FC, Ke(GM))), nH = A2(qy, KM, Ke(ru)), rH = A3(zy, "users", Ey(AT), A3(zy, "availabilities_date", FC, A3(zy, "availabilities", Ey(nH), Ke(XM)))), tH = A2(IC, 0, A2(qy, rH, Ke(ZM))), eH = {
        C3: Rt
    }, uH = function(n) {
        var r, t = n(eH);
        return Gi(k([
            (r = t.C3, r.$ ? h : k([
                A2(Ax, "startDate", r.a)
            ]))
        ]));
    }, aH = F2(function(n, r) {
        return A2($y, k([
            "availability"
        ]), A2(gM, n, r));
    }), iH = F2(function(n, r) {
        return m(r, {
            iu: $(r.iu, n)
        });
    }), cH = F5(function(n, r, t, e, u) {
        return A4(dC, n, tH, u, A2(iH, uH(r), bC(A2(aH, t, e))));
    }), oH = F5(function(n, r, t, e, u) {
        return A5(cH, n, function(n) {
            return m(n, {
                C3: Ht(e)
            });
        }, r, t, WM(u));
    }), fH = F2(function(n, r) {
        return A2(zD, function(n) {
            return i(QT(n), r);
        }, n);
    }), sH = function(n) {
        var r = Dv(n), t = zv(n);
        return A3(ip, r, t, 1);
    }, lH = function(n) {
        return n.ea;
    }, dH = function(n) {
        return n.a.mX;
    }, bH = F2(function(n, r) {
        return {
            bR: r,
            fd: 0,
            wJ: n
        };
    }), vH = function(n) {
        return A2(ep, "yyyy-MM-dd", n);
    }, mH = function(n) {
        return n.wJ;
    }, pH = F2(function(n, r) {
        var t = r.mo;
        if (t.$) return Rt;
        var e = mH(dH(t.a)), u = A2(Cp, vH, e), a = A2(z$, A2(Cp, vA, A2(Cp, sH, A2(Xb, k$, A2(Cp, TC, A2(Xb, lH, n))))), u);
        if (a.$) return Rt;
        var i = a.a, c = b(e, TC(i));
        return c.a.$ || c.b.$ ? Rt : Ht(b(m(r, {
            bN: A2(bH, c.a.a, Ht(c.b.a))
        }), i));
    }), $H = function(n) {
        return 1 === n.$;
    }, hH = function(n) {
        return n.sS;
    }, gH = Jn("getItemPort", function(n) {
        return vk(k([
            b("action", mk(n.xF)),
            b("itemType", mk(n.rm)),
            b("key", mk(n.hH)),
            b("value", mk(n.w5))
        ]));
    }), wH = function(n) {
        switch(n){
            case 0:
                return "OnlineEnrollment";
            case 1:
                return "PageAbandoned";
            case 2:
                return "Practice";
            case 3:
                return "Language";
            default:
                return "Booking";
        }
    }, kH = Jn("removeItemPort", function(n) {
        return vk(k([
            b("action", mk(n.xF)),
            b("itemType", mk(n.rm)),
            b("key", mk(n.hH)),
            b("value", mk(n.w5))
        ]));
    }), xH = Jn("setItemPort", function(n) {
        return vk(k([
            b("action", mk(n.xF)),
            b("itemType", mk(n.rm)),
            b("key", mk(n.hH)),
            b("value", mk(n.w5))
        ]));
    }), yH = function(n) {
        switch(n.$){
            case 0:
                var r = n.b, t = n.c;
                return xH({
                    xF: "set",
                    rm: wH(n.a),
                    hH: r,
                    w5: t
                });
            case 1:
                return r = n.b, gH({
                    xF: "get",
                    rm: wH(n.a),
                    hH: r,
                    w5: ""
                });
            case 2:
                return r = n.b, kH({
                    xF: "remove",
                    rm: wH(n.a),
                    hH: r,
                    w5: ""
                });
            default:
                return r = n.b, kH({
                    xF: "removeAndRedirect",
                    rm: wH(n.a),
                    hH: r,
                    w5: ""
                });
        }
    }, _H = function(n) {
        return n.a.vc;
    }, CH = function(n) {
        return n.am;
    }, DH = function(n) {
        return n.aQ;
    }, AH = function(n) {
        return n.vM;
    }, qH = function(n) {
        return n.wg;
    }, BH = F2(function(n, r) {
        return m(r, {
            eb: n
        });
    }), jH = F2(function(n, r) {
        return A2(BH, Ht(n), r);
    }), SH = F3(function(n, r, t) {
        var e, u = A2(ue, " ", k([
            qH(n),
            "-",
            (e = n, e.pD),
            AH(n)
        ])), a = A2(ue, ", ", k([
            A2(ep, "MMMM d, y", r),
            u
        ]));
        return A2(jH, a, t);
    }), zH = function(n) {
        return n.ec;
    }, UH = function(n) {
        return n.fj;
    }, EH = function(n) {
        return n.oD;
    }, PH = function(n) {
        return n.a.oG;
    }, TH = function(n) {
        return n.wC;
    }, FH = function(n) {
        return A2(Ji, function(n) {
            return A2(yu, function(r) {
                return b(EH(n), r);
            }, TH(n));
        }, PH(n));
    }, LH = function(n) {
        return n.w2;
    }, MH = function(n) {
        return n.w2;
    }, HH = F2(function(n, r) {
        return A2(Tc, function(r) {
            return i(LH(r.b), MH(n));
        }, FH(r));
    }), RH = function(n) {
        return A2(uc, !0, A2(Cp, _H, n));
    }, OH = function(n) {
        return n.a.w3;
    }, NH = function(n) {
        var r = n.ci;
        if (r.$) return n;
        var t = r.a, e = b(RH(n.mo), n.aQ);
        if (e.a && !e.b.$) return m(n, {
            am: A2(Cp, Ne, Gb(A2(HH, e.b.a, t)))
        });
        var u = Gb(FH(t));
        if (u.$) return m(n, {
            am: Rt,
            aQ: Rt
        });
        var a = u.a, c = a.a, o = a.b, f = A2(zD, function(n) {
            return i(MH(n), LH(o));
        }, OH(t));
        return m(n, {
            am: Ht(c),
            aQ: f
        });
    }, IH = function(n) {
        return n.wc;
    }, VH = F3(function(n, r, t) {
        var e = b(n, r);
        if (e.a.$ || e.b.$) return t;
        var u = e.a.a, a = e.b.a, c = A2(Tc, function(n) {
            var r = n.b;
            return i(n.a, u) && i(IH(r), a);
        }, t);
        return ED(c) ? t : c;
    }), WH = F2(function(n, r) {
        return A2(zD, function(n) {
            return i(MH(n), LH(r));
        }, n);
    }), ZH = F2(function(n, r) {
        return b(A2(Xb, WH(n), A2(Cp, Ac, r)), A2(Cp, Ne, r));
    }), XH = F4(function(n, r, t, e) {
        var u = e.ci;
        if (u.$) return e;
        var a = u.a, c = FH(a), o = A3(VH, r, n, c), f = function() {
            if (RH(e.mo)) {
                var n = OH(a), r = function() {
                    if (t.$) return Gb(o);
                    var n = t.a;
                    return A2(z$, A2(zD, function(r) {
                        return i(LH(r.b), n);
                    }, o), Gb(o));
                }();
                return A2(ZH, n, r);
            }
            var u = A2(Cp, Ne, Gb(o));
            return b(Rt, u);
        }();
        return m(e, {
            am: f.b,
            aQ: f.a
        });
    }), GH = F6(function(n, r, t, e, u, a) {
        var i = e.a.my, c = mH(dH(t)), o = c.$ ? a.bN : A2(bH, c.a, Ht(i)), f = m(a, {
            ci: Ht(e),
            bN: o
        });
        if (n) {
            var s = A2(Xb, UH, r);
            return A4(XH, A2(Xb, zH, r), A2(Xb, k$, A2(Cp, TC, A2(Xb, lH, r))), A2(z$, s, u), f);
        }
        return NH(f);
    }), JH = F2(function(n, r) {
        return m(r, {
            ea: n
        });
    }), YH = F2(function(n, r) {
        return A2(JH, Ht(n), r);
    }), QH = F2(function(n, r) {
        return m(r, {
            ec: n
        });
    }), KH = F2(function(n, r) {
        return A2(QH, Ht(n), r);
    }), nR = F3(function(n, r, t) {
        return A2(YH, vH(r), A2(KH, n, t));
    }), rR = F2(function(n, r) {
        return m(r, {
            fj: n
        });
    }), tR = F2(function(n, r) {
        return A2(rR, Ht(n), r);
    }), eR = F2(function(n, r) {
        return m(r, {
            fk: n
        });
    }), uR = F2(function(n, r) {
        return A2(eR, Ht(n), r);
    }), aR = F3(function(n, r, t) {
        var e = b(n, r);
        if (e.a && !e.b.$) {
            var u = e.b.a;
            return A2(uR, QT(u), A2(tR, MH(u), t));
        }
        return t;
    }), iR = "appointment_date", cR = "appointment_display", oR = "appointment_start", fR = "email", sR = F2(function(n, r) {
        return A2(Cp, function(r) {
            return b(n, mk(r));
        }, r);
    }), lR = "first_name", dR = "last_name", bR = "notes", vR = "phone", mR = "provider_id", pR = "provider_name", $R = F3(function(n, r, t) {
        return {
            $: 0,
            a: n,
            b: r,
            c: t
        };
    }), hR = function(n) {
        var r;
        return r = function(n) {
            var r;
            return A2(te, 2, vk(A2(Ep, ru, k([
                A2(sR, mR, (r = n).fj),
                A2(sR, pR, r.fk),
                A2(sR, iR, r.ea),
                A2(sR, oR, r.ec),
                A2(sR, cR, r.eb),
                A2(sR, lR, r.qb),
                A2(sR, dR, r.rt),
                A2(sR, "dob", r.o2),
                A2(sR, fR, r.pt),
                A2(sR, vR, r.t0),
                A2(sR, bR, r.e5)
            ]))));
        }(n), yH(A3($R, 4, IM, r));
    }, gR = A4(Sy, bR, l_(w$), Rt, A4(Sy, vR, l_(w$), Rt, A4(Sy, fR, l_(w$), Rt, A4(Sy, "dob", l_(w$), Rt, A4(Sy, dR, l_(w$), Rt, A4(Sy, lR, l_(w$), Rt, A4(Sy, cR, l_(w$), Rt, A4(Sy, oR, l_(w$), Rt, A4(Sy, iR, l_(w$), Rt, A4(Sy, pR, l_(w$), Rt, A4(Sy, mR, l_(w$), Rt, Ke(function(n) {
        return function(r) {
            return function(t) {
                return function(e) {
                    return function(u) {
                        return function(a) {
                            return function(i) {
                                return function(c) {
                                    return function(o) {
                                        return function(f) {
                                            return function(s) {
                                                return {
                                                    ea: t,
                                                    eb: u,
                                                    ec: e,
                                                    o2: c,
                                                    pt: o,
                                                    qb: a,
                                                    rt: i,
                                                    e5: s,
                                                    t0: f,
                                                    fj: n,
                                                    fk: r
                                                };
                                            };
                                        };
                                    };
                                };
                            };
                        };
                    };
                };
            };
        };
    })))))))))))), wR = A2(qy, gR, Ke(ru)), kR = function(n) {
        var r = A2(Hp, wR, n);
        return r.$ ? Rt : Ht(r.a);
    }, xR = {
        jZ: function(n) {
            return ad(n);
        },
        nb: {
            $: 0
        },
        eq: "calendar-datepicker--",
        j0: h,
        yL: function(n) {
            switch(n){
                case 0:
                    return "Mo";
                case 1:
                    return "Tu";
                case 2:
                    return "We";
                case 3:
                    return "Th";
                case 4:
                    return "Fr";
                case 5:
                    return "Sa";
                default:
                    return "Su";
            }
        },
        y$: Rt,
        hp: 6,
        zZ: rm(!1),
        kG: function(n) {
            switch(n){
                case 0:
                    return "January";
                case 1:
                    return "February";
                case 2:
                    return "March";
                case 3:
                    return "April";
                case 4:
                    return "May";
                case 5:
                    return "June";
                case 6:
                    return "July";
                case 7:
                    return "August";
                case 8:
                    return "September";
                case 9:
                    return "October";
                case 10:
                    return "November";
                default:
                    return "December";
            }
        },
        xn: ee
    }, yR = function(n) {
        switch(n){
            case 0:
                return "M";
            case 1:
            case 3:
                return "T";
            case 2:
                return "W";
            case 4:
                return "F";
            default:
                return "S";
        }
    }, _R = function(n) {
        return A2(uc, h, A2(Cp, PH, n.ci));
    }, CR = F3(function(n, r, t) {
        if (n) {
            if (r.$) return h;
            var e = r.a;
            return A2(Tc, function(n) {
                return i(LH(n), MH(e));
            }, t);
        }
        return t;
    }), DR = F2(function(n, r) {
        return Gb(A2(Tc, function(r) {
            return i(EH(r), n);
        }, r));
    }), AR = F2(function(n, r) {
        var t = _R(n), e = b(n.mo, ED(t));
        if (e.a.$ || e.b) return !0;
        var u = e.a.a, a = A2(DR, r, t);
        if (a.$) return !0;
        var i = TH(a.a), c = A3(CR, RH(Ht(u)), n.aQ, i);
        return ED(c);
    }), qR = function(n) {
        return m(xR, {
            yL: yR,
            y$: A2(Xb, mH, A2(Cp, dH, n.mo)),
            zZ: AR(n)
        });
    }, BR = {
        $: 0
    }, jR = F3(function(n, r, t) {
        var e = t;
        switch(r.$){
            case 0:
                return b(m(e, {
                    bR: Ht(u = r.a),
                    wJ: u
                }), BR);
            case 1:
                return b(m(e, {
                    bR: Ht(u = r.a)
                }), function(n) {
                    return {
                        $: 2,
                        a: n
                    };
                }(u));
            default:
                var u = r.a;
                return b(m(e, {
                    bR: Rt
                }), function(n) {
                    return {
                        $: 1,
                        a: n
                    };
                }(u));
        }
    }), SR = F2(function(n, r) {
        switch(n.$){
            case 0:
                var t = m(r, {
                    aQ: Ht(n.a)
                });
                return v(YS(r.am) ? t : NH(t), Dp, Rt);
            case 1:
                var e = n.a, u = A3(jR, qR(r), e, r.bN), a = u.b, i = m(r, {
                    bN: u.a
                });
                switch(a.$){
                    case 1:
                        return v(m(i, {
                            am: Ht(a.a)
                        }), Dp, Rt);
                    case 2:
                        var c = a.a;
                        return v(m(i, {
                            am: Rt
                        }), Dp, Ht(function(n) {
                            return {
                                $: 0,
                                a: n
                            };
                        }(c)));
                    default:
                        return v(i, Dp, Rt);
                }
            default:
                return v(r, Dp, Ht(function(n) {
                    return {
                        $: 1,
                        a: n
                    };
                }(n.a)));
        }
    }), zR = F2(function(n, r) {
        return m(r, {
            mo: Ht(n)
        });
    }), UR = F2(function(n, r) {
        switch(n.$){
            case 0:
                var t = n.a;
                return 3 === t.$ ? v(m(r, {
                    bD: t,
                    ae: A2(zR, i = t.a, r.ae)
                }), yH(A2(NM, 4, IM)), h) : v(m(r, {
                    bD: oc
                }), Dp, A2(uA, 0, t));
            case 1:
                var e = n.a, u = n.b, a = b(r.bD, u);
                if (3 === a.a.$ && 3 === a.b.$) {
                    var i = a.a.a, c = a.b.a, o = OH(c), f = _H(i), s = m(r, {
                        ch: u
                    });
                    if (f && ED(o)) return v(s, A2(zx, oa, Ya), h);
                    var l = A2(Cp, MH, A2(Xb, fH(o), A2(Cp, hH, r.ih)));
                    return v(m(s, {
                        ae: g = A6(GH, e, r.cj, i, c, l, r.ae)
                    }), Dp, h);
                }
                return v(m(r, {
                    ch: oc
                }), Dp, A2(uA, 0, u));
            case 2:
                if ((x = n.a).$) return v(m(r, {
                    cj: Rt
                }), Dp, h);
                if (1 === (y = x.a).$ && 4 === y.a) {
                    var d = A2(Xb, kR, y.b), p = A2(pH, d, r.ae);
                    if (p.$) return v(r, Dp, h);
                    var $ = p.a, g = $.a, w = A5(oH, r.c5, r.mp, r.mY, $.b, !0);
                    return v(m(r, {
                        cj: d,
                        ae: g
                    }), w, h);
                }
                return v(r, Dp, h);
            case 3:
                var x, y;
                return (x = n.a).$ ? v(r, Dp, h) : 2 === (y = x.a).$ && 4 === y.a ? v(m(r, {
                    cj: Rt
                }), Dp, h) : v(r, Dp, h);
            default:
                var _ = A2(SR, n.a, r.ae), C = _.b, D = _.c, A = m(r, {
                    ae: g = _.a
                }), q = A2(jp, vM, C);
                if (D.$) return v(A, q, h);
                var B = D.a;
                if (B.$) {
                    var j = B.a, S = b(A.bD, CH(r.ae));
                    if (3 !== S.a.$ || S.b.$) return v(A, q, h);
                    i = S.a.a;
                    var z = S.b.a, U = DH(r.ae);
                    if ((f = _H(i)) && $H(U)) return v(A, q, h);
                    var E = A3(SH, j, z, A3(aR, f, U, A3(nR, IH(j), z, A2(uc, VM, A.cj)))), P = A.w_.iu;
                    return v(A, Hu(k([
                        hR(E),
                        A2(zx, P, pa({
                            mp: r.mp,
                            mY: r.mY
                        }))
                    ])), h);
                }
                var T = sH(B.a);
                return v(m(A, {
                    ch: Mx
                }), Hu(k([
                    q,
                    A5(oH, r.c5, r.mp, r.mY, vH(T), !1)
                ])), h);
        }
    }), ER = function(n) {
        return A2(Ik, k([
            Nk("my-4")
        ]), k([
            yL(n)
        ]));
    }, PR = function(n) {
        return {
            $: 1,
            a: n
        };
    }, TR = F2(function(n, r) {
        return r.$ ? n : r;
    }), FR = F2(function(n, r) {
        return Nk($(n.eq, r));
    }), LR = F2(function(n, r) {
        var t = function(n) {
            switch(n){
                case 0:
                    return 4;
                case 1:
                    return 5;
                case 2:
                    return 6;
                case 3:
                    return 7;
                case 4:
                    return 8;
                case 5:
                    return 9;
                default:
                    return 10;
            }
        }(r), e = A2(RE, t, A3(ip, Dv(n), zv(n), 1)), u = A3(ip, Dv(n), zv(n), 1);
        return {
            ov: A4(VE, 11, 1, e, A2(NE, t, A3(xE, 1, 1, u))),
            ox: n
        };
    }), MR = function(n) {
        return {
            $: 2,
            a: n
        };
    }, HR = F2(function(n, r) {
        var t = n.eq;
        return rz(A2(yu, function(n) {
            var r = n.b;
            return b($(t, n.a), r);
        }, r));
    }), RR = F5(function(n, r, t, e, u) {
        var a = n.zZ(u), i = a ? h : k([
            Eq(MR(u))
        ]), c = HR(n);
        return A2(Ik, A2(Ot, c(k([
            b("day", !0),
            b("disabled", a),
            b("picked", r(u)),
            b("today", e(u)),
            b("other-month", t(u))
        ])), i), k([
            n.jZ(ee(Sv(u)))
        ]));
    }), OR = F3(function(n, r, t) {
        var e, u, a = t.bR, c = t.wJ, o = function(r) {
            return A2(uc, !1, A2(Cp, function(n) {
                return i(n, r);
            }, n));
        }, f = function(n) {
            return i(n, c);
        }, s = LE(r.hp) - 1, l = FR(r), d = A2(uc, c, A2(TR, n, a)), b = function(n) {
            return !i(zv(d), zv(n));
        }, v = F3(function(n, r, t) {
            if (r) return Sq;
            var e = function() {
                switch(n){
                    case "prev":
                    default:
                        return 5;
                    case "next":
                        return 6;
                }
            }();
            return A2(jq, k([
                l(n),
                Eq(t),
                dE(-1),
                dz("button")
            ]), k([
                A2(US, k([
                    SB,
                    Vq("fill-primary-300"),
                    Sz
                ]), e)
            ]));
        }), m = A2(LR, d, r.hp), p = m.ox, $ = m.ov, g = A2(yu, A4(RR, r, o, b, f), Gi((e = $, u = F4(function(n, r, t, e) {
            for(;;){
                if (!r.b) return we(e);
                var u = r.a, a = r.b;
                if (6 !== n) n = i = n + 1, r = c = a, t = o = A2(Ot, u, t), e = f = e;
                else {
                    var i = 0, c = a, o = h, f = A2(Ot, we(A2(Ot, u, t)), e);
                    n = i, r = c, t = o, e = f;
                }
            }
        }), A4(u, 0, e, h, h)))), w = function() {
            var n = r.y$;
            if (n.$) return !1;
            var t = n.a;
            return i(zv(t), zv(p)) && i(Dv(t), Dv(p));
        }();
        return A2(Ik, k([
            l("picker")
        ]), k([
            A2(Ik, k([
                l("picker-header")
            ]), k([
                A2(Ik, k([
                    l("month-container")
                ]), k([
                    ad(r.kG(zv(p)) + " " + ee(Dv(p)))
                ])),
                A2(Ik, k([
                    l("arrows-container")
                ]), k([
                    A3(v, "prev", w, PR(A3(xE, 1, -1, d))),
                    A3(v, "next", !1, PR(A3(xE, 1, 1, d)))
                ]))
            ])),
            A2(Ik, k([
                l("calendar-grid")
            ]), Gi(k([
                A2(yu, function(n) {
                    return A2(Ik, k([
                        l("dow")
                    ]), k([
                        ad(r.yL(n))
                    ]));
                }, A2(BE, 7, A2(zp, s, Gi(A2(XE, 2, k([
                    0,
                    1,
                    2,
                    3,
                    4,
                    5,
                    6
                ])))))),
                g
            ])))
        ]));
    }), NR = F3(function(n, r, t) {
        var e = t, u = A2(Ot, b(r.eq + "container", !0), r.j0);
        return A2(Ik, k([
            rz(u)
        ]), k([
            A3(OR, n, r, e)
        ]));
    }), IR = F2(function(n, r) {
        var t;
        return A2(Ik, k([
            Nk("grid gap-4")
        ]), k([
            A2(Ik, k([
                Nk("font-extrabold")
            ]), k([
                ad("Select a date & time")
            ])),
            A2(Ik, k([
                Nk("justify-items-left")
            ]), k([
                A2(px, yM, A3(NR, n, qR(r), r.bN))
            ])),
            A2(Ik, k([
                Nk("font-extrabold")
            ]), k([
                ad((t = n, A2(uc, "", A2(Cp, ep("EEEE, MMMM d"), t))))
            ]))
        ]));
    }), VR = F2(function(n, r) {
        return !n.$ && i(MH(n.a), MH(r));
    }), WR = F2(function(n, r) {
        return A2(Wu, QT(n), QT(r));
    }), ZR = function(n) {
        return {
            $: 0,
            a: n
        };
    }, XR = F2(function(n, r) {
        var t = n ? "text-info-300 fill-info-300" : "text-info-200 fill-transparent";
        return A2(Ik, k([
            Nk("flex items-center border border-info-200 rounded p-4 cursor-pointer gap-4"),
            Eq(ZR(r)),
            rz(k([
                b("bg-info-100 text-info-300", n)
            ]))
        ]), k([
            A2(US, k([
                Vq(t)
            ]), 26),
            ad(QT(r))
        ]));
    }), GR = function(n) {
        var r = A2(uc, h, A2(Cp, OH, n.ci));
        return RH(n.mo) && oe(r) > 1 ? A2(Ik, k([
            Nk("flex flex-col gap-2")
        ]), A2(Ot, A2(Ik, k([
            Nk("mb-2 font-extrabold")
        ]), k([
            ad("Select a provider")
        ])), A2(yu, function(r) {
            return A2(XR, A2(VR, n.aQ, r), r);
        }, A2(UL, WR, r)))) : Sq;
    }, JR = F2(function(n, r) {
        return n.$ ? h : A2(uc, h, A2(Cp, TH, A2(DR, n.a, r)));
    }), YR = function(n) {
        return {
            $: 2,
            a: n
        };
    }, QR = function(n) {
        return A2(Ik, k([
            Nk("border border-info-200 hover:border-primary-300 hover:text-primary-300 rounded p-4 cursor-pointer text-center"),
            Eq(YR(n))
        ]), k([
            ad(A2(ue, " ", k([
                qH(n),
                AH(n)
            ])))
        ]));
    }, KR = function(n) {
        var r = A2(JR, n.am, _R(n)), t = A3(CR, RH(n.mo), n.aQ, r);
        return A2(Ik, k([
            Nk("flex flex-col gap-2")
        ]), ED(r) ? k([
            ad("There are no available appointment times for the current month.")
        ]) : ED(t) ? k(n.am.$ ? [
            ad("Select a day to display available appointment times.")
        ] : [
            ad("There are no available appointment times for the selected day.")
        ]) : A2(yu, QR, t));
    }, nO = F2(function(n, r) {
        return A2(Ik, k([
            Nk("flex flex-col gap-4")
        ]), k([
            GR(r),
            A2(IR, r.am, r),
            KR(r),
            ER(n)
        ]));
    }), rO = function(n) {
        return 3 === n.ch.$ ? A2(px, vM, A2(nO, n.dw, n.ae)) : A2(Ik, h, Yk);
    }, tO = function(n) {
        var r, t = n.bD;
        if (3 === t.$) {
            var e = t.a, u = 3 === (r = n.ch).$ ? OH(r.a) : h, a = _H(e) && 1 === oe(u) ? A2(Cp, QT, DH(n.ae)) : Rt, i = dH(e);
            return A2(Ik, k([
                Nk("flex flex-col gap-4")
            ]), k([
                A2(cM, !1, {
                    eb: Rt,
                    xU: Ht(e),
                    mX: Ht(i),
                    tE: n.tE,
                    fk: a
                }),
                rO(n)
            ]));
        }
        return A2(Ik, h, Yk);
    }, eO = function(n) {
        return n.a.mb;
    }, uO = F2(function(n, r) {
        var t;
        return {
            gF: k([
                A2(Ik, k([
                    Nk("flex flex-col gap-4")
                ]), k([
                    (t = r.bD, 3 === t.$ ? sM(eO(t.a)) : Sq),
                    tO(r)
                ]))
            ]),
            wD: "Booking"
        };
    }), aO = Ux({
        zO: jM,
        Ab: SM,
        Ct: zM,
        Dd: function() {
            return xk(k([
                HM(UM),
                OM(EM)
            ]));
        },
        DB: UR,
        DH: uO
    }), iO = function(n) {
        return {
            $: 0,
            a: n
        };
    }, cO = function(n) {
        return 3 === n.a.i.$;
    }, oO = function(n) {
        return n.qP;
    }, fO = {
        $: 9
    }, sO = {
        $: 0
    }, lO = F6(function(n, r, t, e, u, a) {
        return {
            qU: r,
            BT: n,
            il: u,
            $9: t,
            CD: a,
            dL: e
        };
    }), dO = F2(function(n, r) {
        return r ? "Int'l" : "US";
    }), bO = function(n) {
        return Ht(n ? "International" : "US");
    }, vO = function(n) {
        return n.Bw;
    }, mO = function(n) {
        return n.cH.lI;
    }, pO = function(n) {
        return n.cH.zF;
    }, $O = function(n) {
        return n.cH.rr;
    }, hO = function(n) {
        return n.cH.AB;
    }, gO = function(n) {
        return n.cH.AK;
    }, wO = function(n) {
        return n.cH.Cg;
    }, kO = function(n) {
        switch(n.$){
            case 0:
                return hO;
            case 1:
                return pO;
            case 2:
                return gO;
            default:
                return vO;
        }
    }, xO = function(n) {
        switch(n.$){
            case 0:
                return Ht("mobile");
            case 1:
                return Ht("home");
            case 2:
                return Ht("office");
            default:
                return Ht(n.a);
        }
    }, yO = F2(function(n, r) {
        var t = id({
            qU: n + "-type",
            Dr: F2(function(n, r) {
                return n(kO(r));
            }),
            Dt: xO
        }), e = id({
            qU: n + "-region" + n,
            Dr: dO,
            Dt: bO
        });
        return A6(lO, r.BT, n, t, r.im, e, r.hE ? 0 : 1);
    }), _O = function(n) {
        return {
            bg: n,
            pt: "",
            qb: "",
            rt: "",
            e5: "",
            t0: A2(yO, "enter-info-phone", {
                hE: !0,
                BT: "",
                im: sO
            })
        };
    }, CO = function(n) {
        return {
            oD: Rt,
            cm: "",
            bi: AA("/"),
            eC: h,
            qU: n,
            di: !1,
            vd: !1,
            cZ: !1
        };
    }, DO = F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    }), AO = function(n) {
        return A2(DO, n, h);
    }, qO = {
        di: !1,
        cZ: !1
    }, BO = F2(function(n, r) {
        return b(r(n), qO);
    }), jO = F2(function(n, r) {
        return {
            wi: Ml(A2(yu, function(n) {
                return A2(BO, n, r);
            }, n)),
            dX: r
        };
    }), SO = k([
        0,
        1,
        2,
        3,
        4,
        5
    ]), zO = function(n) {
        switch(n){
            case 0:
                return "First Name";
            case 1:
                return "Last Name";
            case 2:
                return "Date of Birth";
            case 3:
                return "Email";
            case 4:
                return "Phone";
            default:
                return "Notes";
        }
    }, UO = F2(function(n, r) {
        return m(r, {
            vd: n
        });
    }), EO = F6(function(n, r, t, e, u, a) {
        var i = A2(UO, !0, CO("dob"));
        return {
            d6: !1,
            gx: n,
            g0: t,
            cu: !1,
            ai: A2(ny, 0, fO).a,
            aH: e,
            kk: AO(_O(i)),
            hs: a,
            hC: u,
            s7: !1,
            BW: r,
            x: A2(jO, SO, zO)
        };
    }), PO = F3(function(n, r, t) {
        var e = $k(n), u = A2(cp, r.fL, r.bf), a = !cO(r.gx), i = A2(uc, !1, A2(Cp, oO, MD(r.tE))), c = {
            mp: t.BD.mp,
            bD: oc,
            cj: Rt,
            mY: t.BD.mY,
            c5: r.ys.ya,
            g_: r.gx,
            kj: r.kj,
            tE: MD(r.tE),
            aO: A6(EO, r.gx, e, u, !0, a, i),
            dw: n,
            ln: oc,
            w_: t
        };
        return b(c, ZF(n) ? A4(kM, c.c5, c.mp, c.mY, iO) : dL);
    }), TO = F2(function(n, r) {
        return b(r, Dp);
    }), FO = F2(function(n, r) {
        return m(r, {
            xE: Ht(9)
        });
    }), LO = function(n) {
        return {
            $: 1,
            a: n
        };
    }, MO = function(n) {
        return {
            $: 3,
            a: n
        };
    }, HO = function(n) {
        return {
            $: 11,
            a: n
        };
    }, RO = function() {
        return A2(xD, HO, _D());
    }, OO = function(n) {
        return {
            $: 4,
            a: n
        };
    }, NO = function(n) {
        return {
            $: 2,
            a: n
        };
    }, IO = F2(function(n, r) {
        return {
            $: 2,
            a: n,
            b: r
        };
    }), VO = F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    }), WO = A2(nm, function(n) {
        if (au(n) > 9) return qm("Expected at most 9 digits, but got " + ee(au(n)));
        var r = gj("0." + n);
        return r.$ ? qm('Invalid float: "' + n + '"') : am(pp(1e3 * r.a));
    }, Um(_m(he))), ZO = F6(function(n, r, t, e, u, a) {
        return Sp(n + 60 * r * 60000 + 60 * (t - a) * 1e3 + 1e3 * e + u);
    }), XO = function(n) {
        return A2(rj, "", function(r) {
            if (i(au(r), n)) {
                var t = lu(r);
                return t.$ ? qm('Invalid integer: "' + r + '"') : A2(Lm, JB, am(t.a));
            }
            return A2(Lm, function(n) {
                return YB(A2(jx, r, n));
            }, Um(wm(he)));
        });
    }, GO = function(n) {
        return qm("Invalid day: " + ee(n));
    }, JO = function(n) {
        return !(A2(qc, 4, n) || !A2(qc, 100, n) && A2(qc, 400, n));
    }, YO = function(n) {
        var r = n - 1;
        return (r / 4 | 0) - (r / 100 | 0) + (r / 400 | 0);
    }, QO = function(n) {
        var r = n.a, t = n.b, e = n.c;
        if (0 > e) return GO(e);
        var u = function(n) {
            var u = 31536e6 * (r - 1970), a = 864e5 * ((3 > t || !JO(r) ? e - 1 : e) + (YO(r) - YO(1970)));
            return am(n + u + a);
        };
        switch(t){
            case 1:
                return e > 31 ? GO(e) : u(0);
            case 2:
                return e > 29 || 29 === e && !JO(r) ? GO(e) : u(26784e5);
            case 3:
                return e > 31 ? GO(e) : u(50976e5);
            case 4:
                return e > 30 ? GO(e) : u(7776e6);
            case 5:
                return e > 31 ? GO(e) : u(10368e6);
            case 6:
                return e > 30 ? GO(e) : u(130464e5);
            case 7:
                return e > 31 ? GO(e) : u(156384e5);
            case 8:
                return e > 31 ? GO(e) : u(183168e5);
            case 9:
                return e > 30 ? GO(e) : u(209952e5);
            case 10:
                return e > 31 ? GO(e) : u(235872e5);
            case 11:
                return e > 30 ? GO(e) : u(262656e5);
            case 12:
                return e > 31 ? GO(e) : u(288576e5);
            default:
                return qm('Invalid month: "' + ee(t) + '"');
        }
    }, KO = A2(nm, QO, A2(Am, A2(Am, A2(Am, am(F3(function(n, r, t) {
        return v(n, r, t);
    })), XO(4)), Om(k([
        A2(Am, A2(um, am(ru), GA("-")), XO(2)),
        XO(2)
    ]))), Om(k([
        A2(Am, A2(um, am(ru), GA("-")), XO(2)),
        XO(2)
    ])))), nN = (Fj = F3(function(n, r, t) {
        return n * (60 * r) + t;
    }), A2(Am, am(ru), Om(k([
        A2(Lm, function() {
            return 0;
        }, GA("Z")),
        A2(Am, A2(Am, A2(Am, am(Fj), Om(k([
            A2(Lm, function() {
                return 1;
            }, GA("+")),
            A2(Lm, function() {
                return -1;
            }, GA("-"))
        ]))), XO(2)), Om(k([
            A2(Am, A2(um, am(ru), GA(":")), XO(2)),
            XO(2),
            am(0)
        ]))),
        A2(um, am(0), Nm)
    ])))), rN = A2(nm, function(n) {
        return Om(k([
            A2(Am, A2(Am, A2(Am, A2(Am, A2(Am, A2(um, am(ZO(n)), GA("T")), XO(2)), Om(k([
                A2(Am, A2(um, am(ru), GA(":")), XO(2)),
                XO(2)
            ]))), Om(k([
                A2(Am, A2(um, am(ru), GA(":")), XO(2)),
                XO(2)
            ]))), Om(k([
                A2(Am, A2(um, am(ru), GA(".")), WO),
                am(0)
            ]))), A2(um, nN, Nm)),
            A2(um, am(A6(ZO, n, 0, 0, 0, 0, 0)), Nm)
        ]));
    }, KO), tN = A2(Ge, function(n) {
        var r = A2(Ym, rN, n);
        return r.$ ? yy("Expecting an ISO-8601 formatted date+time string") : Ke(r.a);
    }, w$), eN = function(n) {
        switch(n){
            case "accepted":
                return Ke(0);
            case "not_accepted":
                return Ke(1);
            case "accepted_and_outdated":
                return Ke(2);
            default:
                return yy("Unsupported patient document status: " + n);
        }
    }, uN = function(n) {
        switch(n){
            case "click_box":
                return Ke(0);
            case "type_name":
                return Ke(1);
            default:
                return yy("Unsupported patient document acceptance type: " + n);
        }
    }, aN = A3(zy, "name", A2(Ye, OC, w$), Ke(function(n) {
        return {
            sS: n
        };
    })), iN = A2(qy, aN, Ke(ru)), cN = F5(function(n, r, t, e, u) {
        return {
            n1: r,
            pa: t,
            qU: n,
            rH: e,
            w9: u
        };
    }), oN = function(n) {
        switch(n){
            case "text":
                return Ke(0);
            case "file":
                return Ke(1);
            case "link":
                return Ke(2);
            default:
                return yy("Unsupported document version type: " + n);
        }
    }, fN = A3(zy, "version_number", C$, A3(zy, "link_url", Ay(w$), A3(zy, "document_version_type", A2(Ge, oN, w$), A3(zy, "content", l_(w$), A3(zy, "id", w$, Ke(cN)))))), sN = A2(qy, A2(Ye, ru, fN), Ke(ru)), lN = A3(zy, "signed_document_version", l_(sN), A3(zy, "current_document_version", sN, A3(zy, "signed_at", l_(tN), A3(zy, "signee", iN, A3(zy, "status", A2(Ge, eN, w$), A3(zy, "required", xy, A3(zy, "name", w$, A3(zy, "document_type", w$, A3(zy, "active", xy, A3(zy, "acceptance_type", A2(Ge, uN, w$), A3(zy, "acceptance_text", w$, A3(zy, "document_id", w$, Ke(function(n) {
        return function(r) {
            return function(t) {
                return function(e) {
                    return function(u) {
                        return function(a) {
                            return function(i) {
                                return function(c) {
                                    return function(o) {
                                        return function(f) {
                                            return function(s) {
                                                return function(l) {
                                                    return {
                                                        ly: r,
                                                        lz: t,
                                                        lH: e,
                                                        ow: s,
                                                        o8: n,
                                                        yX: u,
                                                        sS: a,
                                                        vd: i,
                                                        vZ: f,
                                                        v_: l,
                                                        v$: o,
                                                        wj: c
                                                    };
                                                };
                                            };
                                        };
                                    };
                                };
                            };
                        };
                    };
                };
            };
        };
    }))))))))))))), dN = A2(IC, 0, A2(qy, lN, Ke(VO))), bN = function(n) {
        return A2($y, k([
            "patient_documents"
        ]), gy(n));
    }, vN = lC("post"), mN = F5(function(n, r, t, e, u) {
        var a = vk(k([
            b("document", e)
        ]));
        return A4(vN, n, dN, u, A2(xq, a, bC(A2($y, k([
            t,
            "accept"
        ]), bN(r)))));
    }), pN = function(n) {
        return n.eb;
    }, $N = F2(function(n, r) {
        if (n) {
            var t = UH(r), e = UH(r);
            return $H(e) || $H(t);
        }
        return !1;
    }), hN = F2(function(n, r) {
        if (r.$) return !0;
        var t = r.a;
        return A2($N, n, t) || function(n) {
            var r = zH(n), t = pN(n), e = lH(n);
            return $H(e) || $H(t) || $H(r);
        }(t);
    }), gN = F3(function(n, r, t) {
        return {
            qz: n,
            r1: t,
            tp: r
        };
    }), wN = A3(zy, "meet_url", w$, A3(zy, "outlook_link", w$, A3(zy, "google_link", w$, Ke(gN)))), kN = A2(qy, wN, Ke(ru)), xN = function(n) {
        return n.e5;
    }, yN = F2(function(n, r) {
        return A2(uc, bk, A2(Cp, n, r));
    }), _N = F2(function(n, r) {
        return k([
            b("provider_id", A2(yN, mk, UH(r))),
            b("booking_location_id", mk(n)),
            b("date", A2(yN, mk, zH(r))),
            b("notes", A2(yN, mk, xN(r)))
        ]);
    }), CN = F3(function(n, r, t) {
        return vk(A2(Ot, b("patient_id", mk(n)), A2(_N, r, t)));
    }), DN = F6(function(n, r, t, e, u, a) {
        return A4(vN, n, kN, a, A2(xq, A3(CN, r, e, u), bC(function(n) {
            return A2($y, k([
                n
            ]), KF);
        }(t))));
    }), AN = function(n) {
        return n.a.qU;
    }, qN = function(n) {
        return n.o2;
    }, BN = function(n) {
        return n.pt;
    }, jN = function(n) {
        return n.a;
    }, SN = function(n) {
        return n.qb;
    }, zN = function(n) {
        return n.rt;
    }, UN = function(n) {
        return n.t0;
    }, EN = F2(function(n, r) {
        var t = function() {
            if (n.$) return "";
            var t = n.a;
            return A2(hP, PA(r.bi), A2(dP, r.bi, t));
        }();
        return m(r, {
            oD: n,
            cm: t
        });
    }), PN = F2(function(n, r) {
        var t = A2(uc, "", xN(n)), e = m(jN(r.kk), {
            e5: t
        });
        if (r.aH) return e;
        var u = A2(uc, "", UN(n)), a = A2(Xb, k$, A2(Cp, TC, qN(n))), i = A2(EN, a, e.bg), c = A2(uc, "", zN(n)), o = A2(uc, "", SN(n));
        return m(e, {
            bg: i,
            pt: A2(uc, "", BN(n)),
            qb: o,
            rt: c,
            t0: A2(yO, "enter-info-phone", {
                hE: !0,
                BT: u,
                im: sO
            })
        });
    }), TN = F2(function(n, r) {
        return n.$ ? r : m(r, {
            kk: AO(A2(PN, n.a, r))
        });
    }), FN = function(n) {
        return n.a.s7;
    }, LN = F7(function(n, r, t, e, u, a, i) {
        var c = A2(UO, !0, CO("dob"));
        return {
            d6: !1,
            gx: n,
            g0: t,
            cu: !1,
            ai: A2(ny, 0, fO).a,
            aH: e,
            kk: AO(_O(c)),
            hs: a,
            hC: u,
            s7: FN(i),
            BW: r,
            x: A2(jO, SO, zO)
        };
    }), MN = function(n) {
        return {
            $: 2,
            a: n
        };
    }, HN = function(n) {
        return {
            $: 1,
            a: n
        };
    }, RN = function(n) {
        return {
            $: 0,
            a: n
        };
    }, ON = F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    }), NN = function(n) {
        return {
            $: 4,
            a: n
        };
    }, IN = function(n) {
        return {
            $: 4,
            a: n
        };
    }, VN = function(n) {
        return n.oD;
    }, WN = F2(function(n, r) {
        switch(n.$){
            case 0:
                return m(r, {
                    qb: n.a
                });
            case 1:
                return m(r, {
                    rt: n.a
                });
            case 2:
                return m(r, {
                    bg: n.a
                });
            case 3:
                return m(r, {
                    pt: n.a
                });
            case 4:
                return m(r, {
                    t0: n.a
                });
            default:
                return m(r, {
                    e5: n.a
                });
        }
    }), ZN = function(n) {
        return function(r) {
            return A3(ce, F2(function(n, t) {
                return $(t, n(r));
            }), h, n);
        };
    }, XN = F2(function(n, r) {
        return function(t) {
            var e;
            return e = r(t), A2(n, e, t);
        };
    }), GN = function(n) {
        return n.bg;
    }, JN = function(n) {
        return b(1, n);
    }, YN = F2(function(n, r) {
        return r.vf(n);
    }), QN = function(n) {
        return n.bg.oD.$ ? k([
            b(2, JN(A2(XN, YN, GN)))
        ]) : h;
    }, KN = function(n) {
        return n.pt;
    }, nI = F2(function(n, r) {
        return r.q1(n);
    }), rI = A2(Je, Vb, uc(Wb)), tI = function(n) {
        return A2(p$, rI("^\\s*$"), n);
    }, eI = A2(uc, Wb, A2(Ib, {
        yf: !0,
        AC: !1
    }, "^[a-zA-Z0-9.!#$%&'*+\\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)+$")), uI = function(n) {
        return A2(p$, eI, n);
    }, aI = function(n) {
        return b(0, n);
    }, iI = function(n) {
        var r = n.pt;
        return tI(r) ? k([
            b(3, JN(A2(XN, YN, KN)))
        ]) : uI(r) ? h : k([
            b(3, aI(A2(XN, nI, KN)))
        ]);
    }, cI = function(n) {
        return n.cE.qb;
    }, oI = function(n) {
        return n.cE.rt;
    }, fI = function(n) {
        return n.cE.sE;
    }, sI = function(n) {
        return n.cE.wt;
    }, lI = function(n) {
        return n.cE.wD;
    }, dI = function(n) {
        return n.cE.Dp;
    }, bI = function(n) {
        return tI(n.qb) ? k([
            b(0, JN(A2(XN, YN, cI)))
        ]) : h;
    }, vI = function(n) {
        return tI(n.rt) ? k([
            b(1, JN(A2(XN, YN, oI)))
        ]) : h;
    }, mI = F2(function(n, r) {
        return n && tI(r.e5) ? k([
            b(5, JN(KD("The above field is required")))
        ]) : h;
    }), pI = F2(function(n, r) {
        if (r) return !1;
        var t = dF(n);
        return au(t) > 0 && !i(au(sF), au(t));
    }), $I = function(n) {
        var r = n.t0;
        return tI(r.BT) || A2(pI, r.BT, r.CD) ? k([
            b(4, JN(A2(XN, YN, $O)))
        ]) : h;
    }, hI = F2(function(n, r) {
        return ZN(n ? r ? k([
            mI(r)
        ]) : h : k(r ? [
            bI,
            vI,
            QN,
            iI,
            $I,
            mI(r)
        ] : [
            bI,
            vI,
            QN,
            iI,
            $I
        ]));
    }), gI = F2(function(n, r) {
        var t = n(r);
        return t.b ? Xt(t) : Qt(r);
    }), wI = F2(function(n, r) {
        var t = r.a, e = A2(gI, n, t);
        if (e.$) return Xt(A2(DO, t, e.a));
        var u = e.a;
        return Qt(b(A2(DO, t, h), u));
    }), kI = function(n) {
        var r = A2(wI, A2(hI, n.aH, n.s7), n.kk);
        return r.$ ? b(r.a, !1) : b(r.a.a, !0);
    }, xI = function(n) {
        return kI(n).b;
    }, yI = F2(function(n, r) {
        var t = r.wi, e = A2(Zu, (0, r.dX)(n), t);
        return !e.$ && e.a.di;
    }), _I = F3(function(n, r, t) {
        var e, u = t.dX(r);
        return m(t, {
            wi: (e = A2(Zu, u, t.wi), e.$ ? t.wi : A3(Qu, u, {
                di: e.a.di,
                cZ: n
            }, t.wi))
        });
    }), CI = F2(function(n, r) {
        return {
            di: n,
            cZ: r
        };
    }), DI = F2(function(n, r) {
        if (-2 === r.$) return Gu;
        var t = r.b, e = r.d, u = r.e;
        return A5(Xu, r.a, t, A2(n, t, r.c), A2(DI, n, e), A2(DI, n, u));
    }), AI = function(n) {
        return m(n, {
            wi: A2(DI, rm(function() {
                return A2(CI, !0, !0);
            }), n.wi)
        });
    }, qI = F2(function(n, r) {
        var t = n ? AI(r.x) : r.x;
        return m(r, {
            kk: kI(r).a,
            x: t
        });
    }), BI = function(n) {
        switch(n.$){
            case 0:
                return Ht(0);
            case 1:
                return Ht(1);
            case 2:
                return Ht(2);
            case 3:
                return Ht(3);
            case 4:
                return Ht(4);
            default:
                return Ht(5);
        }
    }, jI = F2(function(n, r) {
        var t = BI(n);
        if (t.$) return r;
        var e = t.a;
        return A2(yI, e, r.x) ? m(A2(qI, !1, r), {
            x: A3(_I, !0, e, r.x)
        }) : r;
    }), SI = function(n) {
        return n.BT;
    }, zI = {
        $: 2
    }, UI = {
        $: 1
    }, EI = function(n) {
        return n.oD;
    }, PI = function(n) {
        return JN(A2(XN, YN, n));
    }, TI = function(n) {
        return aI(A2(XN, nI, n));
    }, FI = function(n) {
        return n.oD.$ && n.vd ? tI(n.cm) ? k([
            PI(EI)
        ]) : k([
            TI(EI)
        ]) : h;
    }, LI = F2(function(n, r) {
        return m(r, {
            eC: FI(r),
            di: r.di || n,
            cZ: r.cZ || n
        });
    }), MI = F2(function(n, r) {
        switch(n.$){
            case 0:
                var t = n.a, e = k$(A2(JA, r.bi, A2(FA, PA(r.bi), t))), u = function(n) {
                    return n.cZ ? A2(LI, !0, n) : m(n, {
                        di: !0
                    });
                }(m(r, {
                    oD: e,
                    cm: t
                })), a = A2(uc, "", A2(Cp, vA, e)), c = i(a, A2(uc, "", A2(Cp, vA, r.oD))) ? Rt : Ht(function(n) {
                    return {
                        $: 0,
                        a: n
                    };
                }(a));
                return v(u, Dp, c);
            case 1:
                return v(u = r.di ? A2(LI, !0, r) : r, Dp, Ht(zI));
            default:
                return v(r, Dp, Ht(UI));
        }
    }), HI = function(n) {
        return {
            $: 2,
            a: n
        };
    }, RI = function(n) {
        return {
            $: 1,
            a: n
        };
    }, OI = au(A2(Jq, function(n) {
        return "#" === n;
    }, sF)), NI = F2(function(n, r) {
        return !r && s(au(n), OI) > 0 ? A2(su, OI, n) : n;
    }), II = sO, VI = F2(function(n, r) {
        switch(n.$){
            case 0:
                return b(m(r, {
                    BT: n.a
                }), Dp);
            case 1:
                var t = A2(bq, n.a, r.$9), e = t.b;
                return b(m(r, {
                    $9: i = t.a,
                    dL: c = (u = t.c).$ || u.a.$ ? r.dL : A2(uc, II, u.a.a)
                }), A2(jp, RI, e));
            case 2:
                var u, a = A2(bq, n.a, r.il), i = a.a, c = (e = a.b, (u = a.c).$ || u.a.$ ? r.CD : A2(uc, 0, u.a.a));
                return b(m(r, {
                    BT: A2(NI, r.BT, r.CD),
                    il: i,
                    CD: c
                }), A2(jp, HI, e));
            default:
                return b(r, Dp);
        }
    }), WI = F3(function(n, r, t) {
        var e = t.b;
        return A2(DO, A2(n, r, t.a), e);
    }), ZI = F2(function(n, r) {
        var t = r.wi, e = A2(Zu, (0, r.dX)(n), t);
        return !e.$ && e.a.cZ;
    }), XI = F3(function(n, r, t) {
        var e, u = t.dX(r);
        return m(t, {
            wi: (e = A2(Zu, u, t.wi), e.$ ? t.wi : A3(Qu, u, {
                di: n,
                cZ: e.a.cZ
            }, t.wi))
        });
    }), GI = F2(function(n, r) {
        var t = BI(n);
        if (t.$) return r;
        var e = t.a, u = A3(XI, !0, e, r.x), a = m(r, {
            x: u
        });
        return A2(ZI, e, u) ? m(a, {
            kk: kI(r).a
        }) : a;
    }), JI = F2(function(n, r) {
        switch(n.$){
            case 0:
                return v(c = A2(GI, t = n.a, m(r, {
                    kk: A3(WI, WN, t, r.kk)
                })), Dp, Rt);
            case 1:
                var t;
                return v(A2(jI, t = n.a, r), Dp, Rt);
            case 2:
                return v(r, Dp, Rt);
            case 3:
                var e = n.a, u = jN(r.kk), a = A2(MI, e, u.bg), i = a.c, c = m(r, {
                    kk: A3(WI, WN, MN(a.a), r.kk)
                });
                return v($ = i.$ || 2 !== i.a.$ ? c : A2(qI, !1, c), Dp, Rt);
            case 4:
                var o = n.a, f = jN(r.kk), s = A2(VI, o, f.t0), l = s.a, d = s.b, b = (c = m(r, {
                    kk: A3(WI, WN, NN(l), r.kk)
                }), NN(l)), p = function() {
                    switch(o.$){
                        case 0:
                            return A2(Eu, ru, gu(RN(b)));
                        case 3:
                            return A2(Eu, ru, gu(HN(b)));
                        default:
                            return Dp;
                    }
                }();
                return v(c, Hu(k([
                    A2(jp, IN, d),
                    p
                ])), Rt);
            case 5:
                var $ = A2(qI, !0, r);
                return i = function() {
                    if (xI($)) {
                        var n = jN(r.kk), t = {
                            o2: Rt,
                            pt: Rt,
                            qb: Rt,
                            rt: Rt,
                            e5: Ht(n.e5),
                            t0: Rt
                        }, e = function() {
                            if (r.aH) return t;
                            var n = jN(r.kk), e = n.qb, u = n.rt, a = n.pt, i = n.t0, c = VN(n.bg), o = SI(i);
                            return m(t, {
                                o2: c,
                                pt: Ht(a),
                                qb: Ht(e),
                                rt: Ht(u),
                                t0: Ht(o)
                            });
                        }();
                        return Ht(A2(ON, e, r.cu));
                    }
                    return Rt;
                }(), v(r, Dp, i);
            case 6:
                return v(m(r, {
                    d6: n.a
                }), Dp, Rt);
            case 7:
                return v(m(r, {
                    cu: n.a
                }), Dp, Rt);
            case 8:
                return v(m(r, {
                    ai: fA(r.ai)
                }), Dp, Rt);
            case 9:
                return v(m(r, {
                    ai: ND(r.ai)
                }), Dp, Rt);
            case 10:
                return v(m(r, {
                    cu: !0,
                    ai: ND(r.ai)
                }), Dp, Rt);
            default:
                var h = A2(mq, n.a, r.ai), g = h.b;
                return v(m(r, {
                    ai: h.a
                }), A2(jp, HO, g), Rt);
        }
    }), YI = F2(function(n, r) {
        return m(r, {
            o2: n
        });
    }), QI = F2(function(n, r) {
        return m(r, {
            pt: n
        });
    }), KI = F2(function(n, r) {
        return m(r, {
            qb: n
        });
    }), nV = F2(function(n, r) {
        return m(r, {
            rt: n
        });
    }), rV = F2(function(n, r) {
        return m(r, {
            e5: n
        });
    }), tV = F2(function(n, r) {
        return m(r, {
            t0: n
        });
    }), eV = F2(function(n, r) {
        switch(n.$){
            case 0:
                var t = n.a, e = m(r, {
                    bD: t
                });
                return 3 === t.$ ? v(e, yH(A2(NM, 4, IM)), h) : v(r, Dp, A2(uA, 0, t));
            case 1:
                var u = n.a;
                if (u.$) return v(m(r, {
                    cj: Rt
                }), Dp, h);
                var a = u.a;
                if (1 === a.$ && 4 === a.a) {
                    var i = a.b, c = r.bD;
                    if (3 === c.$) {
                        var o = _H(A = c.a), f = A2(Xb, kR, i), s = A2(TN, f, A7(LN, r.g_, $k(r.dw), r.aO.g0, r.aO.aH, r.aO.hC, r.aO.hs, A)), l = function() {
                            if (A2(hN, o, f)) {
                                var n = gL(dH(A)), t = AN(A);
                                return A2(zx, r.w_.iu, Ga({
                                    mp: t,
                                    mY: n
                                }));
                            }
                            return Dp;
                        }();
                        return v(m(r, {
                            cj: f,
                            aO: s
                        }), l, h);
                    }
                    return v(r, Dp, h);
                }
                return v(r, Dp, h);
            case 3:
                var d = A2(JI, n.a, r.aO), p = d.b, $ = d.c, g = (e = m(r, {
                    aO: s = d.a
                }), A2(jp, MO, p));
                if ($.$) return v(e, g, h);
                var w = $.a, x = w.a, y = w.b, _ = Ht(A2(rV, x.e5, A2(tV, x.t0, A2(QI, x.pt, A2(YI, A2(Cp, vH, x.o2), A2(nV, x.rt, A2(KI, x.qb, A2(uc, VM, r.cj)))))))), C = v(_, r.bD, r.tE);
                if (C.a.$ || 3 !== C.b.$ || C.c.$) return v(e, g, h);
                var D = C.a.a, A = C.b.a, q = C.c.a, B = function() {
                    if (y) {
                        var n = vk(k([
                            b("signature", mk("")),
                            b("acceptance_type", mk("checkbox")),
                            b("accepted", kA(!0))
                        ]));
                        return A5(mN, r.g_, $k(r.dw), "ephi_waiver", n, OO);
                    }
                    return Dp;
                }(), j = gL(dH(A)), S = AN(A), z = A6(DN, r.c5, ZC(q), S, j, D, NO);
                return v(m(r, {
                    cj: _,
                    ln: Mx
                }), Hu(k([
                    g,
                    hR(D),
                    z,
                    B
                ])), h);
            case 2:
                var U = n.a;
                switch(e = m(r, {
                    ln: U
                }), U.$){
                    case 3:
                        return v(e, yH(A2(IO, 4, IM)), h);
                    case 2:
                        var E = U.a;
                        return v(e, Dp, 5 === E.$ && 400 === E.a ? h : k([
                            A2(nA, 1, YD)
                        ]));
                    default:
                        return v(e, Dp, h);
                }
            default:
                return v(r, Dp, h);
        }
    }), uV = function(n) {
        return {
            $: 6,
            a: n
        };
    }, aV = A2(TS, PS(3), Ht(2)), iV = F2(function(n, r) {
        return b(n, r);
    }), cV = function(n) {
        return n.qz;
    }, oV = function(n) {
        return n.tp;
    }, fV = function(n) {
        switch(n.$){
            case 0:
                return n.a;
            case 4:
                return fx(n.a);
            case 5:
                return A2(lx, r = n.a, n.b);
            case 6:
                return cx(n.a);
            case 7:
                return A2(sx, r = n.a, n.b);
            case 2:
                return k([
                    Nk("md:flex-1")
                ]);
            case 3:
                return k([
                    Nk("md:w-auto")
                ]);
            case 1:
                var r = n.a, t = n.b, e = "w-" + (12 === t ? "full" : ee(t) + "/12");
                return k([
                    Nk($(ex(r), e))
                ]);
            case 8:
                return k([
                    Nk("card")
                ]);
            case 11:
                return k([
                    Nk("card list-row")
                ]);
            case 9:
                return k([
                    Nk("card--success")
                ]);
            case 10:
                return k([
                    Nk("card--warning")
                ]);
            default:
                return k([
                    Nk("bg-primary-100")
                ]);
        }
    }, sV = function(n) {
        var r = n.a, t = n.b;
        return A2(Ik, A2(Ot, Nk("column"), function(n) {
            return A2(yu, Zk(hu), A2(Ji, fV, n));
        }(r)), t);
    }, lV = F2(function(n, r) {
        return A2(Ik, A2(Ot, Nk("row"), function(n) {
            return A2(yu, Zk(hu), A2(Ji, fV, n));
        }(n)), A2(yu, sV, r));
    }), dV = function(n) {
        return {
            $: 4,
            a: n
        };
    }, bV = {
        $: 4
    }, vV = function(n) {
        return {
            $: 0,
            a: n
        };
    }, mV = {
        $: 1
    }, pV = br("rel"), $V = Ok("target"), hV = function(n) {
        switch(n.$){
            case 0:
                return k([
                    vF(n.a)
                ]);
            case 1:
                return k([
                    $V("_blank"),
                    pV("noopener")
                ]);
            case 2:
                return k([
                    Nk("text-current")
                ]);
            case 3:
                return k([
                    Nk(n.a)
                ]);
            case 4:
                return k([
                    Nk("button button--secondary")
                ]);
            case 5:
                return k([
                    Nk("button button--primary text-white hover:text-white")
                ]);
            case 6:
                return k([
                    Nk("button button--profile")
                ]);
            case 7:
                return k([
                    Nk("button--round")
                ]);
            case 8:
                return k([
                    Nk("link--mobile-hidden")
                ]);
            case 9:
                return k([
                    dE(0)
                ]);
            case 10:
                return k([
                    Nk("w-full")
                ]);
            case 11:
                return k([
                    A2(Wx, "data-test", n.a)
                ]);
            default:
                return k([
                    Eq(n.a)
                ]);
        }
    }, gV = F2(function(n, r) {
        var t = A2(Ji, hV, n);
        return A2(fF, A2(Ot, Nk("link"), t), A2(yu, px(hu), r));
    }), wV = F2(function(n, r) {
        return fu(n) ? Sq : A2(gV, k([
            bV,
            vV(n),
            mV
        ]), k([
            A2(US, k([
                Sz,
                Vq("text-primary-500")
            ]), 27),
            A2(Gk, h, k([
                ad(r)
            ]))
        ]));
    }), kV = F4(function(n, r, t, e) {
        return $(A3(iu, 0, r, e), $(n, A3(iu, t, au(e), e)));
    }), xV = F2(function(n, r) {
        var t = A2(uc, !0, A2(Cp, fu, A2(Xb, function(n) {
            return n.iu;
        }, $u(n))));
        return $(n, A4(kV, t ? "?" : "&", 0, 1, Bx(r)));
    }), yV = function(n) {
        return A2(Ax, n.a, n.b);
    }, _V = function(n) {
        return A2(yu, yV, It(n));
    }, CV = F2(function(n, r) {
        return A2(xV, r, _V(n));
    }), DV = {
        $: 5
    }, AV = F3(function(n, r, t) {
        return A2(gV, k([
            DV,
            vV(A2(CV, n, r)),
            mV
        ]), k([
            ad(t)
        ]));
    }), qV = F3(function(n, r, t) {
        var e = A2(Cp, function(n) {
            return A2(pu, "http://", n) || A2(pu, "https://", n) ? n : "https://" + n;
        }, t.a.uZ), u = t.a.uY, a = function() {
            var r = b(e, u);
            if (r.a.$ || r.b.$) return h;
            var t = r.a.a, a = r.b.a;
            return k([
                A2(iV, k([
                    uV(wF),
                    dV(aV)
                ]), k([
                    A3(AV, n, t, a)
                ]))
            ]);
        }(), i = eO(t) ? k([
            A2(iV, k([
                uV(wF),
                dV(aV)
            ]), k([
                A2(wV, cV(r), "Add to Google Calendar")
            ])),
            A2(iV, k([
                uV(wF),
                dV(aV)
            ]), k([
                A2(wV, oV(r), "Add to Outlook Calendar")
            ]))
        ]) : h;
        return A2(lV, h, $(a, i));
    }), BV = function(n) {
        return {
            $: 0,
            a: n
        };
    }, jV = function(n) {
        return BV(n);
    }, SV = ir("h3"), zV = zB(2), UV = F2(function(n, r) {
        return A2(SV, vx(A2(Ot, PL, A2(Ot, zV, n))), r);
    }), EV = function(n) {
        var r = uM(n);
        return A2(lV, h, k([
            A2(iV, k([
                jV(k([
                    Nk("flex flex-col gap-2")
                ]))
            ]), k([
                A2(UV, h, k([
                    ad("Appointment")
                ])),
                A2(hx, h, k([
                    ad(r)
                ]))
            ]))
        ]));
    }, PV = function(n) {
        var r = A2(uc, "", pN(n));
        return A2(lV, h, k([
            A2(iV, k([
                jV(k([
                    Nk("flex flex-col gap-2")
                ]))
            ]), k([
                A2(UV, h, k([
                    ad("Date & Time")
                ])),
                A2(hx, h, k([
                    ad(r)
                ]))
            ]))
        ]));
    }, TV = {
        $: 2
    }, FV = A2(TS, TV, Rt), LV = function(n) {
        return {
            $: 1,
            a: n
        };
    }, MV = A2(lV, k([
        jV(k([
            Nk("mt-6")
        ]))
    ]), k([
        A2(iV, k([
            uV(wF)
        ]), k([
            A2(US, k([
                mz,
                Vq("fill-primary-300 scale-[2.66]"),
                LV(FV)
            ]), 8)
        ]))
    ])), HV = F2(function(n, r) {
        var t = n.r1;
        if (fu(t)) {
            var e = A2(uc, "", IT(dH(r)));
            return A2(hx, h, k([
                ad(e)
            ]));
        }
        return A2(gV, k([
            vV(t),
            mV
        ]), k([
            ad(t)
        ]));
    }), RV = F2(function(n, r) {
        return A2(lV, h, k([
            A2(iV, k([
                jV(k([
                    Nk("flex flex-col gap-2")
                ]))
            ]), k([
                A2(UV, h, k([
                    ad("Location")
                ])),
                A2(HV, n, r)
            ]))
        ]));
    }), OV = function(n) {
        var r = A2(uc, "", xN(n));
        return fu(r) ? Sq : A2(lV, h, k([
            A2(iV, k([
                jV(k([
                    Nk("flex flex-col gap-2")
                ]))
            ]), k([
                A2(UV, h, k([
                    ad("Notes")
                ])),
                A2(hx, h, k([
                    ad(r)
                ]))
            ]))
        ]));
    }, NV = function(n) {
        return n.fk;
    }, IV = F2(function(n, r) {
        var t = n ? A2(uc, "", NV(r)) : "A provider with availability will be assigned";
        return A2(lV, h, k([
            A2(iV, k([
                jV(k([
                    Nk("flex flex-col gap-2")
                ]))
            ]), k([
                A2(UV, h, k([
                    ad("Provider")
                ])),
                A2(hx, h, k([
                    ad(t)
                ]))
            ]))
        ]));
    }), VV = function(n) {
        return eO(n) ? "An email with appointment details has been sent to you." : "You\u2019ll receive an email when your appointment is confirmed.";
    }, WV = function(n) {
        return eO(n) ? "Your appointment is confirmed." : "Your request was submitted.";
    }, ZV = function(n) {
        return A2(lV, k([
            jV(k([
                Nk("flex flex-col gap-4 mb-1")
            ]))
        ]), k([
            A2(iV, k([
                uV(wF)
            ]), k([
                A2(hx, k([
                    rx
                ]), k([
                    ad(WV(n))
                ]))
            ])),
            A2(iV, h, k([
                A2(hx, k([
                    BB
                ]), k([
                    ad(VV(n))
                ]))
            ]))
        ]));
    }, XV = function(n) {
        if (n.$) return Sq;
        var r = UF(n.a);
        return A2(lV, h, k([
            A2(iV, k([
                jV(k([
                    Nk("flex flex-col gap-2")
                ]))
            ]), k([
                A2(UV, h, k([
                    ad("Member")
                ])),
                A2(hx, h, k([
                    Jx(r)
                ]))
            ]))
        ]));
    }, GV = F5(function(n, r, t, e, u) {
        var a = _H(n);
        return A2(Ik, k([
            Nk("flex flex-col gap-4")
        ]), k([
            MV,
            ZV(n),
            XV(e),
            PV(r),
            A2(RV, t, n),
            EV(n),
            A2(IV, a, r),
            OV(r),
            A3(qV, u, t, n)
        ]));
    }), JV = F2(function(n, r) {
        return A2(pu, n, Sx(r));
    }), YV = function(n) {
        return A2(JV, "/booking", n);
    }, QV = F2(function(n, r) {
        return $(A2(ue, "/", n), Bx(r));
    }), KV = F3(function(n, r, t) {
        var e = ac(r), u = gL(dH(n)), a = AN(n), i = YV(e) ? Ga({
            mp: a,
            mY: u
        }) : ma({
            mp: a,
            mY: u
        }), c = A2(QV, k([
            Sx(i)
        ]), _V(t));
        return A2(Ik, k([
            Nk("booking-appointment-not-available")
        ]), k([
            A2(Ik, k([
                Nk("relative bg-white rounded top-1/4 mx-8 p-5 opacity-100")
            ]), k([
                A2(lV, k([
                    uV(wF)
                ]), k([
                    A2(iV, h, k([
                        A2(XT, h, k([
                            ad("Time slot unavailable")
                        ])),
                        A2(hx, k([
                            PL,
                            LS(aV)
                        ]), k([
                            ad("The selected time slot is no longer available. Please choose a different time or check for the latest availability and try again.")
                        ])),
                        A2(gV, k([
                            bV,
                            vV(c)
                        ]), k([
                            ad("Select time")
                        ]))
                    ]))
                ]))
            ]))
        ]));
    }), nW = F3(function(n, r, t) {
        return 2 === n.$ && 5 === n.a.$ && 400 === n.a.a ? A3(KV, t, r.B9, r.iu) : Sq;
    }), rW = function(n) {
        return 1 === n.$;
    }, tW = function(n) {
        return {
            $: 2,
            a: n
        };
    }, eW = function(n) {
        return {
            $: 5,
            a: n
        };
    }, uW = function(n) {
        return {
            $: 8,
            a: n
        };
    }, aW = F2(function(n, r) {
        var t = r.b;
        return i(n, r.a) ? Ht(t) : Rt;
    }), iW = F2(function(n, r) {
        var t = r.b;
        return A2(Ep, aW(n), t);
    }), cW = F3(function(n, r, t) {
        return A2(ZI, t, r) ? A2(iW, t, n) : h;
    }), oW = "patient-details-form", fW = function(n) {
        return {
            $: 0,
            a: n
        };
    }, sW = function(n) {
        return {
            $: 6,
            a: n
        };
    }, lW = function(n) {
        return {
            $: 1,
            a: n
        };
    }, dW = function(n) {
        return {
            $: 0,
            a: n
        };
    }, bW = A2(Je, dW, lW), vW = function(n) {
        return {
            $: 3,
            a: n
        };
    }, mW = function(n) {
        return {
            $: 4,
            a: n
        };
    }, pW = function(n) {
        return {
            $: 2,
            a: n
        };
    }, $W = function(n) {
        return {
            $: 7,
            a: n
        };
    }, hW = function(n) {
        return {
            $: 2,
            a: n
        };
    }, gW = function(n) {
        return function(n) {
            return {
                $: 11,
                a: n
            };
        }(n);
    }, wW = function(n) {
        return {
            $: 1,
            a: n
        };
    }, kW = F2(function(n, r) {
        return !ED(A2(iW, n, r));
    }), xW = F3(function(n, r, t) {
        return A2(ZI, t, r) && A2(kW, t, n);
    }), yW = function(n) {
        return {
            $: 5,
            a: n
        };
    }, _W = Ok("htmlFor"), CW = F2(function(n, r) {
        return A2(iU, vx(A2(Ot, zV, n)), A2(yu, px(hu), r));
    }), DW = F3(function(n, r, t) {
        if (n.$) return Sq;
        var e = n.a, u = e.$ ? Jx(e.a) : ad(e.a), a = t.$ ? h : k([
            _W(t.a)
        ]);
        return A2(CW, k([
            Qk(A2(Ot, Nk("form-group__label"), A2(Ot, rz(k([
                b("form-group__label--required", r)
            ])), a)))
        ]), k([
            u
        ]));
    }), AW = F2(function(n, r) {
        var t = function(n) {
            var r = {
                er: h,
                oV: Rt,
                hq: Rt,
                rr: Rt,
                vd: !1
            };
            return A3(ce, F2(function(n, r) {
                switch(n.$){
                    case 0:
                        return m(r, {
                            oV: Ht(n.a)
                        });
                    case 1:
                        return m(r, {
                            rr: Ht(n.a)
                        });
                    case 2:
                        return m(r, {
                            vd: n.a
                        });
                    case 3:
                        return m(r, {
                            er: $(r.er, k([
                                "h-full"
                            ]))
                        });
                    default:
                        return m(r, {
                            hq: Ht(n.a)
                        });
                }
            }), r, n);
        }(n), e = A2(ue, " ", t.er);
        return A2(Ik, k([
            Nk("form-group"),
            Nk(e)
        ]), A2(Ot, A2(Ik, k([
            Nk("flex justify-between"),
            rz(k([
                b("mb-2 md:mb-3", YS(t.rr))
            ]))
        ]), k([
            A3(DW, t.rr, t.vd, t.hq)
        ])), A2(Ot, function(n) {
            if (n.$) return Sq;
            var r = n.a;
            return A2(hx, k([
                BB,
                Qk(k([
                    Nk("-mt-1 mb-2 md:mb-3")
                ]))
            ]), k([
                ad(r)
            ]));
        }(t.oV), r)));
    }), qW = {
        jW: k([
            A2(Wx, "data-gramm_editor", "false"),
            A2(Wx, "data-gramm", "false"),
            A2(Wx, "data-enable-grammarly", "false")
        ]),
        eC: h,
        zU: !1,
        lv: h
    }, BW = function(n) {
        switch(n){
            case 0:
                return "resize-none";
            case 1:
                return "resize-x";
            case 2:
                return "resize-y";
            default:
                return "resize";
        }
    }, jW = function(n) {
        return A2(br, "rows", ee(n));
    }, SW = ir("textarea"), zW = function(n) {
        var r = function(n) {
            return A3(ce, F2(function(n, r) {
                switch(n.$){
                    case 0:
                        return m(r, {
                            jW: A2(Ot, jz(n.a), r.jW)
                        });
                    case 1:
                        return m(r, {
                            jW: A2(Ot, jW(n.a), r.jW)
                        });
                    case 2:
                        return m(r, {
                            jW: A2(Ot, RU(n.a), r.jW)
                        });
                    case 3:
                        return m(r, {
                            jW: A2(Ot, iP(n.a), r.jW)
                        });
                    case 4:
                        return m(r, {
                            jW: A2(Ot, cP(n.a), r.jW)
                        });
                    case 5:
                        return m(r, {
                            jW: A2(Ot, cU(n.a), r.jW)
                        });
                    case 6:
                        return m(r, {
                            jW: A2(Ot, rz(k([
                                b("feedback-errored", t = n.a)
                            ])), r.jW),
                            zU: t
                        });
                    case 7:
                        return m(r, {
                            jW: A2(Ot, oP(n.a), r.jW)
                        });
                    case 8:
                        return m(r, {
                            jW: A2(Ot, tz(t = n.a), A2(Ot, rz(k([
                                b("disabled", t)
                            ])), r.jW))
                        });
                    case 9:
                        return m(r, {
                            jW: A2(Ot, A2(Wx, "data-test", n.a), r.jW)
                        });
                    case 10:
                        return m(r, {
                            jW: A2(Ot, A2(cE, "min-height", n.a), r.jW)
                        });
                    case 11:
                        return m(r, {
                            jW: A2(Ot, Nk(BW(n.a)), r.jW)
                        });
                    default:
                        var t;
                        return m(r, {
                            jW: $((t = n.a) ? mP : h, r.jW)
                        });
                }
            }), qW, n);
        }(n);
        return A2(Ik, r.lv, k([
            A2(SW, A2(Ot, Nk("textarea"), r.jW), h)
        ]));
    }, UW = F2(function(n, r) {
        return n(r.b);
    }), EW = A2(Am, A2(um, am(ru), _m(function(n) {
        return "[" !== n;
    })), A2(um, Um(_m(function(n) {
        return ")" !== n;
    })), GA(")"))), PW = F2(function(n, r) {
        return {
            Di: n,
            w_: r
        };
    }), TW = ym(function(n) {
        return " " === n || "\n" === n || "\r" === n;
    }), FW = A2(Am, A2(Am, A2(um, A2(um, am(PW), GA("[")), TW), A2(um, A2(um, A2(um, Um(_m(function(n) {
        return "]" !== n;
    })), GA("]")), TW), GA("("))), A2(um, Um(_m(function(n) {
        return ")" !== n;
    })), GA(")"))), LW = F5(function(n, r, t, e, u) {
        var a = e + au(t), i = A2(nv, au(n) - a, n), c = e > 0 ? $(r, k([
            ad(A2(su, e, n))
        ])) : r;
        return b(i, $(c, k([
            A2(gV, k([
                vV(u.w_),
                mV
            ]), k([
                ad(u.Di)
            ]))
        ])));
    }), MW = F2(function(n, r) {
        return A2(uc, $(r, k([
            ad(n)
        ])), A2(Cp, function(t) {
            var e = A5(LW, n, r, t.a, t.b, t.c);
            return A2(MW, e.a, e.b);
        }, function(n) {
            var r = A2(Ym, EW, n);
            if (r.$) return Rt;
            var t = r.a + ")", e = A2(Ym, FW, t);
            if (e.$) return Rt;
            var u = e.a;
            return A2(Xb, function(n) {
                return Ht(v(t, n, u));
            }, Gb(A2(ou, t, n)));
        }(n)));
    }), HW = function(n) {
        return A2(MW, n, h);
    }, RW = F2(function(n, r) {
        return A2(Rq, h, HW(A2(UW, n, r)));
    }), OW = F2(function(n, r) {
        return ED(r) ? Sq : A2(Oq, k([
            Nk("form-error")
        ]), A2(yu, RW(n), r));
    }), NW = F4(function(n, r, t, e) {
        var u = FN(n), a = n.a.s6, i = A2(uc, "Additional Notes", a), c = a.$ ? "Anything else you want to share to help prepare our meeting." : "", o = jN(e.kk).e5;
        return A2(lV, h, k([
            A2(iV, h, k([
                A2(AW, k([
                    bW(i),
                    hW(u)
                ]), k([
                    A2(lz, h, k([
                        zW(k([
                            fW(A2(ue, "-", k([
                                oW,
                                "additional-notes"
                            ]))),
                            yW(o),
                            pW(A2(sc, RN, eW)),
                            uW(r),
                            vW(HN(eW(o))),
                            mW(tW(eW(o))),
                            gW(0),
                            wW(3),
                            {
                                $: 12,
                                a: !0
                            },
                            $W(c),
                            sW(u && A3(xW, e.kk, e.x, 5))
                        ]))
                    ])),
                    u ? A2(OW, t, A3(cW, e.kk, e.x, 5)) : Sq
                ]))
            ]))
        ]));
    }), IW = function(n) {
        return {
            $: 6,
            a: n
        };
    }, VW = function(n) {
        return function(n) {
            return {
                $: 2,
                a: n
            };
        }(n);
    }, WW = function(n) {
        return function(n) {
            return {
                $: 1,
                a: n
            };
        }(n);
    }, ZW = function(n) {
        return function(n) {
            return {
                $: 0,
                a: n
            };
        }(n);
    }, XW = A2(Zy, k([
        "target",
        "checked"
    ]), xy), GW = function(n) {
        switch(n.$){
            case 0:
                return k([
                    FU(n.a)
                ]);
            case 2:
                return k([
                    tz(n.a)
                ]);
            case 1:
                return k([
                    (r = n.a, A2(Uq, "change", A2(Ye, r, XW)))
                ]);
            case 3:
                return k([
                    rz(k([
                        b("checkbox__input--indeterminate", n.a)
                    ]))
                ]);
            case 5:
                return k([
                    rz(k([
                        b("checkbox__input--invalid", n.a)
                    ]))
                ]);
            case 6:
                return k([
                    A2(Wx, "data-test", n.a)
                ]);
            default:
                return h;
        }
        var r;
    }, JW = function(n) {
        switch(n.$){
            case 0:
            case 1:
            default:
                return h;
            case 2:
                return k([
                    rz(k([
                        b("checkbox--disabled", n.a)
                    ]))
                ]);
            case 3:
                return k([
                    rz(k([
                        b("checkbox--ideterminate", n.a)
                    ]))
                ]);
            case 5:
                return k([
                    rz(k([
                        b("checkbox--invalid", n.a)
                    ]))
                ]);
            case 4:
                var r = n.a;
                return A2(yu, Zk(hu), r);
            case 6:
                return k([
                    A2(Wx, "data-test", "label-" + n.a)
                ]);
        }
    }, YW = function(n) {
        switch(n.$){
            case 0:
            case 2:
            case 1:
            case 3:
            case 5:
                return h;
            case 4:
                var r = n.a;
                return A2(yu, Zk(hu), r);
            case 6:
                return k([
                    A2(Wx, "data-test", "text-" + n.a)
                ]);
            default:
                return k([
                    rz(k([
                        b("checkbox__text--required", n.a)
                    ]))
                ]);
        }
    }, QW = F2(function(n, r) {
        return A2(iU, A2(Ot, Nk("checkbox"), A2(Ji, JW, n)), k([
            A2(Ik, k([
                Nk("flex")
            ]), k([
                A2(Ik, h, k([
                    A2(fU, A2(Ot, dz("checkbox"), A2(Ot, Nk("checkbox__input"), A2(Ji, GW, n))), h),
                    A2(Gk, k([
                        Nk("checkbox__icon")
                    ]), h)
                ])),
                A2(Ik, A2(Ot, Nk("checkbox__text flex-grow"), A2(Ji, YW, n)), r)
            ]))
        ]));
    }), KW = F4(function(n, r, t, e) {
        return A2(lV, h, k([
            A2(iV, h, k([
                A2(AW, k([
                    hW(!1)
                ]), k([
                    A2(lz, h, k([
                        A2(QW, k([
                            ZW(e.d6),
                            WW(IW),
                            {
                                $: 7,
                                a: !1
                            },
                            VW(r)
                        ]), k([
                            ad("By checking this box, you agree to receive SMS notifications about appointment confirmations, cancellations and reminders from " + hk(n) + " Powered by Hint. Message frequency varies. Message & data rates may apply. You can reply STOP to opt out at any time. Text HELP for help. View our "),
                            A2(fF, k([
                                vF("https://www.hint.com/privacy"),
                                $V("_blank")
                            ]), k([
                                ad("Privacy Policy")
                            ])),
                            ad(" and "),
                            A2(fF, k([
                                vF("https://www.hint.com/terms-feb-2025"),
                                $V("_blank")
                            ]), k([
                                ad("Terms and Conditions")
                            ])),
                            ad(".")
                        ]))
                    ]))
                ]))
            ]))
        ]));
    }), nZ = function(n) {
        return {
            $: 3,
            a: n
        };
    }, rZ = ru, tZ = {
        $: 1
    }, eZ = function(n) {
        return {
            $: 0,
            a: n
        };
    }, uZ = {
        $: 2
    }, aZ = function(n) {
        return n.cZ ? FI(n) : h;
    }, iZ = function(n) {
        return !ED(n.eC);
    }, cZ = function(n) {
        return function(n) {
            return {
                $: 5,
                a: n
            };
        }(n);
    }, oZ = function(n) {
        return function(n) {
            return {
                $: 6,
                a: n
            };
        }(n);
    }, fZ = F2(function(n, r) {
        return {
            $: 8,
            a: n,
            b: r
        };
    }), sZ = fZ, lZ = function(n) {
        return function(n) {
            return {
                $: 11,
                a: n
            };
        }(n);
    }, dZ = function(n) {
        return function(n) {
            return {
                $: 17,
                a: n
            };
        }(n);
    }, bZ = F3(function(n, r, t) {
        return {
            $: 9,
            a: n,
            b: r,
            c: t
        };
    }), vZ = bZ, mZ = {
        yR: !1
    }, pZ = F2(function(n, r) {
        return m(r, {
            yR: n
        });
    }), $Z = function(n) {
        return function(n) {
            return {
                $: 7,
                a: n
            };
        }(n);
    }, hZ = F3(function(n, r, t) {
        var e = A3(ce, pZ, mZ, r);
        return A2(Ik, k([
            Nk("date-input"),
            jz(t.qU)
        ]), k([
            yP(k([
                A2(sZ, PA(t.bi), t.cm),
                A3(vZ, PA(t.bi), t.cm, eZ),
                lP(EA(t.bi)),
                oZ(t.cZ && iZ(t)),
                sP(e.yR),
                $Z(!0),
                lZ(tZ),
                dZ(uZ),
                cZ(0)
            ])),
            A2(OW, n, aZ(t))
        ]));
    }), gZ = F3(function(n, r, t) {
        if (t.aH) return Sq;
        var e = jN(t.kk), u = A3(cW, t.kk, t.x, 2);
        return A2(lV, h, k([
            A2(iV, h, k([
                A2(AW, k([
                    bW(r(GN)),
                    hW(!0)
                ]), k([
                    A2(Ik, k([
                        Nk("enter-info-date-of-birth"),
                        rz(k([
                            b("field--invalid", !ED(u))
                        ]))
                    ]), k([
                        A2(px, nZ, A3(hZ, r, k([
                            rZ(n)
                        ]), e.bg))
                    ])),
                    A2(OW, r, u)
                ]))
            ]))
        ]));
    }), wZ = function(n) {
        return {
            $: 3,
            a: n
        };
    }, kZ = function(n) {
        return function(n) {
            return {
                $: 14,
                a: n
            };
        }(n);
    }, xZ = function(n) {
        return function(n) {
            return {
                $: 1,
                a: n
            };
        }(n);
    }, yZ = function(n) {
        switch(n){
            case 0:
                return oW + "-first-name";
            case 1:
                return oW + "-last-name";
            case 2:
                return oW + "-dob";
            case 3:
                return oW + "-email";
            case 4:
                return oW + "-phone";
            default:
                return oW + "-notes";
        }
    }, _Z = F3(function(n, r, t) {
        if (t.aH) return Sq;
        var e = jN(t.kk).pt;
        return A2(lV, h, k([
            A2(iV, h, k([
                A2(AW, k([
                    bW(r(KN)),
                    hW(!0)
                ]), k([
                    yP(k([
                        kZ(yZ(3)),
                        bP(e),
                        xZ(A2(sc, RN, wZ)),
                        oZ(A3(xW, t.kk, t.x, 3)),
                        sP(n),
                        $Z(!0),
                        lZ(HN(wZ(e))),
                        dZ(tW(wZ(e))),
                        cZ(1)
                    ])),
                    A2(OW, r, A3(cW, t.kk, t.x, 3))
                ]))
            ]))
        ]));
    }), CZ = function(n) {
        return {
            $: 7,
            a: n
        };
    }, DZ = {
        $: 8
    }, AZ = function(n) {
        return n.rA;
    }, qZ = F4(function(n, r, t, e) {
        return A2(lV, h, k([
            A2(iV, h, k([
                A2(AW, h, k([
                    A2(Ik, k([
                        Nk("flex items-start gap-2")
                    ]), k([
                        A2(QW, k([
                            ZW(e.cu),
                            WW(CZ),
                            VW(r)
                        ]), k([
                            ad("I authorize " + hk(n) + " to send email or text which may include unencrypted protected health information. "),
                            A2(Gk, k([
                                Eq(DZ),
                                Nk("cursor-pointer underline text-primary hover:text-primary-400")
                            ]), k([
                                ad(t(AZ))
                            ]))
                        ]))
                    ]))
                ]))
            ]))
        ]));
    }), BZ = {
        $: 10
    }, jZ = function(n) {
        return function(n) {
            return {
                $: 1,
                a: n
            };
        }(n);
    }, SZ = F2(function(n, r) {
        return A2(Tz, k([
            jZ(k([
                A2(PB, k([
                    PL,
                    BB
                ]), k([
                    ad("ePHI Waiver")
                ]))
            ])),
            IS(k([
                A2(Ik, k([
                    Nk("flex flex-col gap-4")
                ]), k([
                    A2(hx, h, k([
                        ad("Providing us with authorization to email and text you will allow "),
                        ad(hk(n)),
                        ad(" to exchange information with you more efficiently and will benefit you as a member. At the same time, we recognize that email and text messaging are not a completely secure means of communication.")
                    ])),
                    A2(hx, h, k([
                        ad("You are not required to authorize the use of email and text messages and a decision to not authorize electronic communication will not affect your health care in any way.")
                    ])),
                    A2(hx, h, k([
                        ad("We have taken considerable effort to protect the personal health information of our members, and recommend that all members provide us with this authorization so that we can more efficiently communicate with them.")
                    ]))
                ]))
            ])),
            XS(k([
                A2(fz, k([
                    CU,
                    QS(fO)
                ]), k([
                    ad("No Thanks")
                ])),
                A2(fz, k([
                    nz,
                    QS(BZ)
                ]), k([
                    ad("Accept")
                ]))
            ]))
        ]), r.ai);
    }), zZ = F2(function(n, r) {
        return {
            $: 1,
            a: n,
            b: r
        };
    }), UZ = function(n) {
        return A2(zZ, 0, n);
    }, EZ = function(n) {
        return {
            $: 0,
            a: n
        };
    }, PZ = F3(function(n, r, t) {
        var e = jN(t.kk).qb;
        return A2(AW, k([
            bW(r(cI)),
            hW(!0)
        ]), k([
            A2(lz, h, k([
                yP(k([
                    kZ(yZ(0)),
                    bP(e),
                    xZ(A2(sc, RN, EZ)),
                    oZ(A3(xW, t.kk, t.x, 0)),
                    sP(n),
                    lZ(HN(EZ(e))),
                    dZ(tW(EZ(e))),
                    $Z(!0)
                ]))
            ])),
            A2(OW, r, A3(cW, t.kk, t.x, 0))
        ]));
    }), TZ = function(n) {
        return {
            $: 1,
            a: n
        };
    }, FZ = F3(function(n, r, t) {
        var e = jN(t.kk).rt;
        return A2(AW, k([
            bW(r(oI)),
            hW(!0)
        ]), k([
            A2(lz, h, k([
                yP(k([
                    kZ(yZ(1)),
                    bP(e),
                    xZ(A2(sc, RN, TZ)),
                    oZ(A3(xW, t.kk, t.x, 1)),
                    sP(n),
                    lZ(HN(TZ(e))),
                    dZ(tW(TZ(e))),
                    $Z(!0)
                ]))
            ])),
            A2(OW, r, A3(cW, t.kk, t.x, 1))
        ]));
    }), LZ = F3(function(n, r, t) {
        return t.aH ? Sq : A2(lV, h, k([
            A2(iV, k([
                UZ(6)
            ]), k([
                A3(PZ, n, r, t)
            ])),
            A2(iV, k([
                UZ(6)
            ]), k([
                A3(FZ, n, r, t)
            ]))
        ]));
    }), MZ = function(n) {
        return {
            $: 0,
            a: n
        };
    }, HZ = function(n) {
        return {
            $: 2,
            a: n
        };
    }, RZ = function(n) {
        return {
            $: 3,
            a: n
        };
    }, OZ = function(n) {
        return {
            $: 1,
            a: n
        };
    }, NZ = A2(TS, PS(3), Rt), IZ = F2(function(n, r) {
        return n ? r : Sq;
    }), VZ = {
        yR: !1,
        dh: !1,
        hy: !1,
        zU: !1
    }, WZ = F2(function(n, r) {
        switch(n.$){
            case 0:
                return m(r, {
                    yR: n.a
                });
            case 1:
                return m(r, {
                    zU: n.a
                });
            case 2:
                return m(r, {
                    dh: n.a
                });
            default:
                return m(r, {
                    hy: n.a
                });
        }
    }), ZZ = F2(function(n, r) {
        return {
            $: 5,
            a: n,
            b: r
        };
    }), XZ = ZZ, GZ = function(n) {
        return A2(zZ, 1, n);
    }, JZ = {
        $: 3
    }, YZ = function(n) {
        return {
            $: 0,
            a: n
        };
    }, QZ = {
        $: 4
    }, KZ = function(n) {
        return {
            $: 20,
            a: n
        };
    }, nX = function(n) {
        return function(n) {
            return {
                $: 21,
                a: n
            };
        }(n);
    }, rX = F3(function(n, r, t) {
        return {
            $: 10,
            a: n,
            b: r,
            c: t
        };
    }), tX = rX, eX = A3(Gy, "#", "_", sF), uX = function(n) {
        var r = A2(Jq, he, n);
        return au(r) >= 11 && A2(pu, "1", r) ? A2(cu, 1, r) : r;
    }, aX = function(n) {
        return function(n) {
            return {
                $: 15,
                a: n
            };
        }(n);
    }, iX = F5(function(n, r, t, e, u) {
        return yP(k(r ? [
            kZ(u),
            bP(n),
            xZ(YZ),
            sP(t),
            oZ(e),
            lZ(JZ),
            aX(u),
            $Z(!0),
            nX("tel"),
            KZ("tel"),
            dZ(QZ)
        ] : [
            kZ(u),
            A2(sZ, lF, n),
            lP(eX),
            A3(tX, uX, lF, YZ),
            sP(t),
            oZ(e),
            lZ(JZ),
            aX(u),
            $Z(!0),
            dZ(QZ),
            cZ(0),
            nX("tel-national"),
            KZ("tel-national")
        ]));
    }), cX = function(n) {
        return {
            $: 2,
            a: n
        };
    }, oX = k([
        0,
        1
    ]), fX = F4(function(n, r, t, e) {
        return A2(px, HI, A4(AU, n, k([
            Jz(Ht(r)),
            cX(e)
        ]), A2(yu, function(n) {
            return A2(Xz, h, n);
        }, oX), t));
    }), sX = {
        $: 1
    }, lX = {
        $: 2
    }, dX = k([
        sO,
        sX,
        lX
    ]), bX = F4(function(n, r, t, e) {
        return A2(px, RI, A4(AU, n, k([
            Jz(Ht(r)),
            ZL("<Phone Type>"),
            cX(e)
        ]), A2(yu, function(n) {
            return A2(Xz, h, n);
        }, dX), t));
    }), vX = F3(function(n, r, t) {
        var e = A3(ce, WZ, VZ, r), u = e.dh ? 0 : 2, a = e.dh ? 0 : 3;
        return A2(Ik, k([
            Nk("phone-input"),
            jz(t.qU)
        ]), k([
            A2(lV, k([
                dV(NZ)
            ]), k([
                A2(iV, k([
                    UZ(12),
                    GZ(12 - u - a),
                    dV(FS),
                    A2(XZ, 1, NZ)
                ]), k([
                    A5(iX, t.BT, t.CD, e.yR, e.zU, t.qU)
                ])),
                A2(iV, k([
                    UZ(12),
                    GZ(u)
                ]), k([
                    A2(IZ, !e.dh, A4(fX, n, t.CD, t.il, e.yR))
                ])),
                A2(iV, k([
                    UZ(12),
                    GZ(a)
                ]), k([
                    A2(IZ, !e.hy, A4(bX, n, t.dL, t.$9, e.yR))
                ]))
            ]))
        ]));
    }), mX = F3(function(n, r, t) {
        if (t.aH) return Sq;
        var e = jN(t.kk).t0;
        return A2(lV, h, k([
            A2(iV, h, k([
                A2(AW, k([
                    bW(r($O)),
                    hW(!0)
                ]), k([
                    A2(Ik, k([
                        Nk("mx-1")
                    ]), k([
                        A2(px, IN, A3(vX, r, k([
                            OZ(A3(xW, t.kk, t.x, 4)),
                            HZ(!0),
                            RZ(!0),
                            MZ(n)
                        ]), e))
                    ])),
                    A2(OW, r, A3(cW, t.kk, t.x, 4))
                ]))
            ]))
        ]));
    }), pX = {
        $: 5
    }, $X = F4(function(n, r, t, e) {
        var u = !xI(e), a = eO(n) ? "Confirm" : "Request";
        return A2(lV, h, k([
            A2(iV, k([
                uV(wF)
            ]), k([
                A2(fz, k([
                    nz,
                    QS(pX),
                    ZS(u || r)
                ]), k([
                    ad(a)
                ]))
            ]))
        ]));
    }), hX = F5(function(n, r, t, e, u) {
        return A2(Ik, h, k([
            A2(SZ, r, u),
            A2(Ik, k([
                Nk("booking-enter-info-form")
            ]), k([
                u.aH ? Sq : A2(Ik, k([
                    Nk("text-base font-extrabold mb-4")
                ]), k([
                    ad("Attendee information")
                ])),
                A2(Ik, k([
                    Nk("ml-1")
                ]), k([
                    A3(LZ, t, e, u),
                    A3(gZ, t, e, u),
                    A3(_Z, t, e, u),
                    A3(mX, t, e, u),
                    A4(KW, r, t, e, u),
                    u.hC && !u.hs ? A4(qZ, r, t, e, u) : Sq,
                    A4(NW, n, t, e, u),
                    A4($X, n, t, e, u)
                ]))
            ]))
        ]));
    }), gX = F2(function(n, r) {
        var t = r.bD;
        if (3 === t.$) {
            var e = t.a, u = A2(Xb, NV, r.cj), a = A2(Xb, pN, r.cj), i = rW(r.ln), c = dH(e);
            return A2(Ik, k([
                Nk("flex flex-col gap-4")
            ]), k([
                A2(cM, i, {
                    eb: a,
                    xU: Ht(e),
                    mX: Ht(c),
                    tE: r.tE,
                    fk: u
                }),
                A2(px, MO, A5(hX, e, r.dw, i, n, r.aO))
            ]));
        }
        return A2(Ik, h, Yk);
    }), wX = Ux({
        zO: PO,
        Ab: TO,
        Ct: FO,
        Dd: function() {
            return xk(k([
                HM(LO),
                A2(xD, MO, RO())
            ]));
        },
        DB: eV,
        DH: F2(function(n, r) {
            return {
                gF: k([
                    function() {
                        var t, e, u = r.ln;
                        if (3 === u.$) {
                            var a = u.a, i = b(r.bD, r.cj);
                            if (3 !== i.a.$ || i.b.$) return Sq;
                            var c = i.a.a, o = i.b.a;
                            return A2(Ik, k([
                                Nk("mt-12")
                            ]), k([
                                A5(GV, c, o, a, r.tE, r.w_.iu)
                            ]));
                        }
                        return A2(Ik, k([
                            Nk("flex flex-col gap-4")
                        ]), 3 === (e = r.bD).$ ? k([
                            A3(nW, r.ln, r.w_, e.a),
                            (t = r.bD, 3 === t.$ ? sM(eO(t.a)) : Sq),
                            A2(gX, n, r)
                        ]) : Yk);
                    }()
                ]),
                wD: "Booking"
            };
        })
    }), kX = function(n) {
        return {
            $: 1,
            a: n
        };
    }, xX = F3(function(n, r) {
        return b({
            gx: r.gx,
            bI: r.bI,
            kj: r.kj,
            dw: n
        }, A3(KC, r.gx, $k(n), kX));
    }), yX = F2(function(n, r) {
        return b(m(r, {
            bI: n.bI
        }), Dp);
    }), _X = F2(function(n, r) {
        return m(r, {
            xE: Rt
        });
    }), CX = F2(function(n, r) {
        if (n.$) {
            var t = n.a;
            if (3 === t.$) {
                var e = t.a;
                return v(m(r, {
                    bI: e
                }), Dp, k([
                    jD(e)
                ]));
            }
            return v(r, Dp, h);
        }
        return v(r, A2(zx, oa, sa), h);
    }), DX = {
        $: 0
    }, AX = function(n) {
        return n.jY.n5;
    }, qX = function(n) {
        return n.jY.wD;
    }, BX = function(n) {
        return A2(Ik, k([
            Nk("flex flex-col"),
            A2(cE, "min-height", "calc(100vh - 12rem)")
        ]), k([
            A2(Ik, k([
                Nk("panel flex-1 flex flex-col")
            ]), n)
        ]));
    }, jX = zB(0), SX = function(n) {
        var r = n.wD, t = n.AT;
        return A2(Ik, k([
            Nk("flex justify-between items-center mb-4")
        ]), k([
            A2(XT, k([
                jX
            ]), k([
                ad(r)
            ])),
            A2(Ik, k([
                Nk("cursor-pointer"),
                Eq(t)
            ]), k([
                A2(px, hu, A2(US, k([
                    SB
                ]), 2))
            ]))
        ]));
    }, zX = function(n) {
        return A2(Ik, k([
            Nk("mt-auto pt-6")
        ]), k([
            A2(fz, k([
                nz,
                JS
            ]), k([
                ad(n(AX))
            ]))
        ]));
    }, UX = Ux({
        zO: xX,
        Ab: yX,
        Ct: _X,
        Dd: function() {
            return yk;
        },
        DB: CX,
        DH: F2(function(n) {
            return {
                gF: k([
                    BX(k([
                        SX({
                            AT: DX,
                            wD: n(qX)
                        }),
                        zX(n)
                    ]))
                ]),
                wD: n(qX)
            };
        })
    }), EX = function(n) {
        return {
            $: 8,
            a: n
        };
    }, PX = Qr(function() {
        return {
            vx: nt(),
            jG: {
                xl: Xr.pageXOffset,
                lw: Xr.pageYOffset,
                cd: Zr.documentElement.clientWidth,
                qI: Zr.documentElement.clientHeight
            }
        };
    }), TX = function(n) {
        return n.r6;
    }, FX = function(n) {
        return A2(dA, "member_messaging", n);
    }, LX = F3(function(n, r, t) {
        var e, u = {
            gv: !1,
            X: Rt,
            j: r.ys.J,
            Q: oc,
            c7: 0,
            bf: r.bf,
            kj: r.kj,
            bp: !1,
            bs: Rt,
            tE: r.tE,
            dw: n,
            a6: Rt,
            fL: r.fL,
            w_: t,
            d2: 0
        }, a = 3 === (e = r.uh).$ ? TX(e.a) : FX(n);
        return b(u, Hu(k([
            a ? Dp : A2(zx, t.iu, Wa),
            A2(Eu, function(n) {
                return EX(pp(n.jG.cd));
            }, PX)
        ])));
    }), MX = F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    }), HX = function(n) {
        return ST(Q_(n));
    }, RX = F2(function(n, r) {
        return {
            BD: n,
            iu: A2(uc, oa, A2(Cp, Tp, r.iu)),
            B9: r
        };
    }), OX = F4(function(n, r, t, e) {
        return {
            pQ: r,
            hP: t,
            h3: e,
            Du: n
        };
    }), NX = F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    }), IX = F8(function(n, r, t, e, u, a, i, c) {
        return {
            og: n,
            yA: i,
            zX: a,
            rk: u,
            rs: r,
            tz: t,
            BI: e,
            DC: c
        };
    }), VX = A3(zy, "sentAt", tN, A3(zy, "snippet", w$, A3(zy, "id", w$, Ke(F3(function(n, r, t) {
        return {
            qU: n,
            CF: t,
            C_: r
        };
    }))))), WX = F6(function(n, r, t, e, u, a) {
        return {
            yx: t,
            yT: r,
            qU: n,
            BK: e,
            BT: a,
            w2: u
        };
    }), ZX = A4(Sy, "phoneNumber", l_(w$), Rt, A4(Sy, "userId", l_(w$), Rt, A4(Sy, "patientId", l_(w$), Rt, A4(Sy, "contactId", l_(w$), Rt, A4(Sy, "displayName", l_(w$), Rt, A3(zy, "id", w$, Ke(WX))))))), XX = A3(zy, "updatedAt", tN, A3(zy, "createdAt", tN, A3(zy, "isArchived", xy, A3(zy, "isUnread", xy, A3(zy, "participantsCount", C$, A3(zy, "participants", Ey(ZX), A4(Sy, "lastMessage", l_(VX), Rt, A3(zy, "ident", w$, Ke(IX))))))))), GX = A2(IC, 0, A2(qy, XX, Ke(NX))), JX = A3(zy, "offset", C$, A3(zy, "limit", C$, A3(zy, "entities", Ey(GX), A3(zy, "total", C$, Ke(OX))))), YX = F2(function(n, r) {
        return A2(Cx, Dx(n), ee(r));
    }), QX = {
        hP: Ht(10),
        h3: 0,
        lk: Rt
    }, KX = F2(function(n, r) {
        return A3(Hb, n, "0", ee(r));
    }), nG = A2(yc, 0, h), rG = function(n) {
        var r;
        return A2(KX, 4, A2(bv, nG, r = n)) + "-" + A2(KX, 2, function(n) {
            switch(n){
                case 0:
                    return 1;
                case 1:
                    return 2;
                case 2:
                    return 3;
                case 3:
                    return 4;
                case 4:
                    return 5;
                case 5:
                    return 6;
                case 6:
                    return 7;
                case 7:
                    return 8;
                case 8:
                    return 9;
                case 9:
                    return 10;
                case 10:
                    return 11;
                default:
                    return 12;
            }
        }(A2(fv, nG, r))) + "-" + A2(KX, 2, A2(av, nG, r)) + "T" + A2(KX, 2, A2(iv, nG, r)) + ":" + A2(KX, 2, A2(ov, nG, r)) + ":" + A2(KX, 2, A2(sv, nG, r)) + "." + A2(KX, 3, A2(cv, nG, r)) + "Z";
    }, tG = F4(function(n, r, t, e) {
        return A4(dC, n, JX, e, A2(iH, function(n) {
            var r, t, e = n(QX), u = (r = e.lk).$ ? h : k([
                A2(Ax, "timestamp", rG(r.a))
            ]), a = (t = e.hP).$ ? h : k([
                A2(YX, "limit", t.a)
            ]);
            return A2(Ot, A2(YX, "offset", e.h3), $(a, u));
        }(t), bC(function(n) {
            return A2($y, k([
                "conversations"
            ]), kT(n));
        }(r))));
    }), eG = F2(function(n, r) {
        var t, e, u = m(r, {
            X: A2(Cp, function(r) {
                return m(r, {
                    g2: n.tE
                });
            }, r.X),
            j: n.ys.J,
            tE: n.tE,
            w_: A2(RX, 0, n.w_)
        }), a = 3 === (t = n.uh).$ ? TX(t.a) : FX(r.dw), i = a ? Dp : A2(zx, r.w_.iu, Wa);
        if (a) {
            if (0 === u.Q.$) {
                var c = (e = HX(n.ys.J)).$ ? Dp : A4(tG, n.ys.J, e.a, function(n) {
                    return m(n, {
                        hP: Ht(10),
                        h3: 0
                    });
                }, MX(0));
                return b(m(u, {
                    Q: Mx
                }), c);
            }
            return b(u, Dp);
        }
        return b(u, i);
    }), uG = F2(function(n, r) {
        return m(r, {
            xE: Ht(8)
        });
    }), aG = function(n) {
        return {
            $: 2,
            a: n
        };
    }, iG = function(n) {
        return {
            $: 3,
            a: n
        };
    }, cG = function(n) {
        return {
            $: 9,
            a: n
        };
    }, oG = F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    }), fG = F2(function(n, r) {
        return {
            uz: r,
            wv: n
        };
    }), sG = gu(A2(fG, oa, oa)), lG = F2(function(n, r) {
        var t = n.a, e = n.b, u = A2(Zu, t, r);
        return A3(Qu, t, 1 === u.$ ? k([
            e
        ]) : A2(Ot, e, u.a), r);
    }), dG = et, bG = F3(function(n, r, t) {
        if (r.b) {
            var e = r.a, u = r.b, a = g_(A2(dG, e, A2(i_, n, e)));
            return A2(_u, function(r) {
                return A3(bG, n, u, A3(Qu, e, r, t));
            }, a);
        }
        return gu(t);
    });
    Tn.Time = Fn(sG, F3(function(n, r, t) {
        var e = t.uz, u = F3(function(n, r, t) {
            var e = t.c;
            return v(t.a, t.b, A2(_u, function() {
                return e;
            }, h_(r)));
        }), a = A3(ce, lG, oa, r), i = A6(dD, F3(function(n, r, t) {
            var e = t.b, u = t.c;
            return v(A2(Ot, n, t.a), e, u);
        }), F4(function(n, r, t, e) {
            var u = e.c;
            return v(e.a, A3(Qu, n, t, e.b), u);
        }), u, a, e, v(h, oa, gu(0))), c = i.a, o = i.b;
        return A2(_u, function(n) {
            return gu(A2(fG, a, n));
        }, A2(_u, function() {
            return A3(bG, n, c, o);
        }, i.c));
    }), F3(function(n, r, t) {
        var e = A2(Zu, r, t.wv);
        if (1 === e.$) return gu(t);
        var u = e.a;
        return A2(_u, function() {
            return gu(t);
        }, A2(_u, function(r) {
            return Au(A2(yu, function(t) {
                return A2(qu, n, t(r));
            }, u));
        }, by));
    }), 0, F2(function(n, r) {
        return A2(oG, r.a, A2(sc, n, r.b));
    }));
    var vG, mG, pG, $G, hG, gG, wG, kG, xG, yG = Rn("Time"), _G = F2(function(n, r) {
        return yG(A2(oG, n, r));
    }), CG = function(n) {
        return A3(gD, 1, "resize", A2(Tu, "target", A3(Qe, n, A2(Tu, "innerWidth", C$), A2(Tu, "innerHeight", C$))));
    }, DG = Kn("onScroll", A2(Ge, function(n) {
        return A2(Ge, function(r) {
            return A2(Ge, function(t) {
                return A2(Ge, function(e) {
                    return A2(Ge, function(u) {
                        return Ke({
                            yr: u,
                            n0: e,
                            Cu: t,
                            xl: r,
                            lw: n
                        });
                    }, A2(Tu, "clientHeight", _$));
                }, A2(Tu, "containerId", w$));
            }, A2(Tu, "scrollHeight", _$));
        }, A2(Tu, "x", _$));
    }, A2(Tu, "y", _$))), AG = F2(function(n, r) {
        return {
            $: 22,
            a: n,
            b: r
        };
    }), qG = function(n) {
        return {
            $: 29,
            a: n
        };
    }, BG = function(n) {
        return {
            $: 30,
            a: n
        };
    }, jG = function(n) {
        return {
            $: 31,
            a: n
        };
    }, SG = function(n) {
        return {
            $: 24,
            a: n
        };
    }, zG = function(n) {
        return {
            $: 18,
            a: n
        };
    }, UG = {
        $: 2
    }, EG = function(n) {
        return {
            $: 4,
            a: n
        };
    }, PG = function(n) {
        return {
            $: 21,
            a: n
        };
    }, TG = function(n) {
        return {
            $: 27,
            a: n
        };
    }, FG = function(n) {
        return {
            $: 15,
            a: n
        };
    }, LG = Kn("fileUploadResult", v$), MG = F5(function(n, r, t, e, u) {
        return {
            kg: u,
            p7: n,
            p8: t,
            p9: e,
            De: r
        };
    }), HG = on, RG = A6(HG, MG, A2(Tu, "fileIndex", C$), A2(Tu, "success", xy), A2(Tu, "filePath", w$), A2(Tu, "filename", w$), l_(A2(Tu, "error", w$))), OG = Kn("heicPreviewResult", v$), NG = F3(function(n, r, t) {
        return {
            sS: n,
            CY: r,
            wW: t
        };
    }), IG = cn, VG = A4(IG, NG, A2(Tu, "name", w$), A2(Tu, "size", C$), A2(Tu, "type", w$)), WG = function(n) {
        var r = A2(By, Ey(VG), n);
        return r.$ ? h : r.a;
    }, ZG = Kn("onFileSelectedPort", v$), XG = Kn("previewLayoutSized", v$), GG = function(n) {
        return {
            $: 0,
            a: n
        };
    }, JG = function(n) {
        return {
            $: 0,
            a: n
        };
    }, YG = function(n) {
        return {
            $: 5,
            a: n
        };
    }, QG = function(n) {
        return {
            $: 8,
            a: n
        };
    }, KG = function(n) {
        return {
            $: 4,
            a: n
        };
    }, nJ = Kn("docxPreviewHtmlResult", v$), rJ = function(n) {
        return !n.bC;
    }, tJ = k([
        "pdf",
        "csv",
        "xlsx",
        "docx",
        "xml",
        "ics"
    ]), eJ = function(n) {
        var r;
        return r = OB(n), A2(pu, ".", r) ? A2(cu, 1, r) : r;
    }, uJ = function(n) {
        return b(OB(A2(uc, "", Gb(we(A2(ae, ".", n.af))))), function(n) {
            return eJ(n.zf);
        }(n));
    }, aJ = function(n) {
        var r = uJ(n), t = r.b, e = eJ(r.a);
        return function(n) {
            var r, t = A2(ae, ".", n);
            return oe(t) > 1 && !(r = Gb(we(t))).$ && "" !== r.a;
        }(n.af) && "" !== e || A2(lA, e, tJ) ? e : t;
    }, iJ = function(n) {
        return "docx" === aJ(n);
    }, cJ = function(n) {
        return iJ(n.c) && !n.h;
    }, oJ = function(n) {
        return rJ(n.b) && cJ(n) ? nJ(A2(Je, ru, KG)) : yk;
    }, fJ = function(n) {
        return "pdf" === aJ(n);
    }, sJ = A2(Ge, function(n) {
        switch(n){
            case "error":
                return A3(Qe, F2(function(n, r) {
                    return function(n) {
                        return {
                            $: 0,
                            a: n
                        };
                    }({
                        kg: r,
                        sS: n
                    });
                }), A2(Tu, "name", w$), A2(Tu, "error", w$));
            case "loaded":
                return A3(Qe, F2(function(n, r) {
                    return function(n) {
                        return {
                            $: 1,
                            a: n
                        };
                    }({
                        sS: n,
                        BB: r
                    });
                }), A2(Tu, "name", w$), A2(Tu, "pageCount", C$));
            default:
                return yy("unknown websocketmsg type: " + n);
        }
    }, A2(Tu, "msg", w$)), lJ = Kn("receivePdfMsg", v$), dJ = function(n) {
        var r;
        return lJ((r = n, function(n) {
            return r(A2(By, sJ, n));
        }));
    }, bJ = function(n) {
        return {
            $: 0,
            a: n
        };
    }, vJ = function(n) {
        return {
            $: 6,
            a: n
        };
    }, mJ = function(n) {
        return "csv" === aJ(n);
    }, pJ = function(n) {
        return "xlsx" === aJ(n);
    }, $J = Kn("spreadsheetPreviewResult", v$), hJ = function(n) {
        return rJ(n.b) && function(n) {
            return (mJ(n.c) || pJ(n.c)) && !n.h;
        }(n) ? $J(A2(Je, bJ, vJ)) : yk;
    }, gJ = function(n) {
        return n.dd > 0 && 1024 > n.dd;
    }, wJ = function(n) {
        return {
            $: 7,
            a: n
        };
    }, kJ = function(n) {
        return "xml" === aJ(n);
    }, xJ = Kn("xmlPreviewResult", v$), yJ = function(n) {
        return rJ(n.b) && kJ(n.c) && !n.h ? xJ(A2(Je, ru, wJ)) : yk;
    }, _J = Kn("onElementMeasured", A2(Ge, function(n) {
        return A2(Ge, function(r) {
            return A2(Ge, function(t) {
                return A2(Ge, function(e) {
                    return A2(Ge, function(u) {
                        return Ke({
                            yr: u,
                            bQ: e,
                            y9: t,
                            rG: r,
                            Cu: n
                        });
                    }, A2(Tu, "clientHeight", _$));
                }, A2(Tu, "elementId", w$));
            }, A2(Tu, "exceedsMaxLines", xy));
        }, A2(Tu, "lineHeight", _$));
    }, A2(Tu, "scrollHeight", _$))), CJ = _J(ru), DJ = {
        $: 3
    }, AJ = Kn("onDropdownEscapeKeyPressed", w$), qJ = function(n) {
        return AJ(rm(n));
    }, BJ = Kn("onDropdownOutsideClick", w$), jJ = function(n) {
        var r;
        return n.bz ? xk(k([
            (r = DJ, BJ(rm(r))),
            qJ(DJ)
        ])) : yk;
    }, SJ = F2(function(n, r) {
        return {
            $: 10,
            a: n,
            b: r
        };
    }), zJ = {
        $: 4
    }, UJ = F2(function(n, r) {
        return {
            $: 6,
            a: n,
            b: r
        };
    }), EJ = "conversation", PJ = F2(function(n, r) {
        var t = function() {
            if (n.$) return A2(aa, EJ, r);
            var t = n.a;
            return fu(t) ? A2(aa, EJ, r) : A3(Qu, EJ, t, r);
        }();
        return i(t, r) ? Dp : A2(zx, t, ha);
    }), TJ = function(n) {
        return n.a.og;
    }, FJ = function(n) {
        return A3(ce, JL, GL, n);
    }, LJ = function(n) {
        return {
            $: 5,
            a: n
        };
    }, MJ = F2(function(n, r) {
        return b(Hu(A2(yu, function(r) {
            switch(r.$){
                case 21:
                    var t = 3 === (e = n.tE).$ ? Ht(ZC(e.a)) : Rt;
                    return t.$ ? Dp : A4(tG, n.j, t.a, function(n) {
                        return m(n, {
                            hP: Ht(10),
                            h3: 0
                        });
                    }, MX(0));
                case 22:
                    return A2(Eu, LJ, gu(r.a));
                default:
                    return Dp;
            }
            var e;
        }, r)), h);
    }), HJ = function(n) {
        return {
            $: 0,
            a: n
        };
    }, RJ = F2(function(n, r) {
        return {
            sS: r,
            w2: n
        };
    }), OJ = A3(Qe, RJ, A2(Tu, "userId", w$), A2(Tu, "name", w$)), NJ = F3(function(n, r, t) {
        return A4(dC, n, A2(Tu, "users", Ey(OJ)), t, bC(A2($y, k([
            "practice-users"
        ]), kT(r))));
    }), IJ = {
        BX: oc,
        vE: h,
        bz: !1
    }, VJ = {
        bn: h,
        eX: !1
    }, WJ = F8(function(n, r, t, e, u, a, i, c) {
        var o = m(IJ, {
            BX: Mx
        }), f = ST(Q_(t));
        return b({
            d8: !0,
            I: oa,
            aT: oa,
            j: t,
            c6: oc,
            og: "",
            g$: t,
            c7: 0,
            g2: i,
            bf: a,
            dd: 0,
            kj: r,
            dg: !1,
            eJ: !0,
            T: "",
            bo: !1,
            bp: !1,
            cy: !0,
            bq: !1,
            cz: !1,
            bV: !1,
            ax: !1,
            br: !1,
            bs: Rt,
            dl: Rt,
            kD: "",
            aL: oc,
            bu: Rt,
            dw: n,
            dz: Rt,
            bx: o,
            cM: VJ,
            V: h,
            cQ: !1,
            fL: u,
            dZ: Ht(0),
            d0: h,
            w_: e,
            fR: c
        }, f.$ ? A2(Eu, function(n) {
            return jG(pp(n.jG.cd));
        }, PX) : Hu(k([
            A3(NJ, t, f.a, A2(Je, HJ, FG)),
            A2(Eu, function(n) {
                return jG(pp(n.jG.cd));
            }, PX)
        ])));
    }), ZJ = F2(function(n, r) {
        return {
            qU: n,
            rk: r
        };
    }), XJ = A3(Qe, ZJ, A2(Tu, "id", w$), A2(Tu, "isUnread", xy)), GJ = F4(function(n, r, t, e) {
        return A4(kq, n, XJ, e, bC(A2($y, k([
            "conversations",
            t,
            "mark-as-read"
        ]), kT(r))));
    }), JJ = function(n) {
        return {
            $: 0,
            a: n
        };
    }, YJ = function(n) {
        return {
            $: 1,
            a: n
        };
    }, QJ = {
        $: 11
    }, KJ = F9(function(n, r, t, e, u, a, i, c, o) {
        return {
            yA: c,
            zI: r,
            zX: i,
            rk: a,
            rs: t,
            tz: u,
            BI: e,
            BW: n,
            DC: o
        };
    }), nY = F3(function(n, r, t) {
        return {
            qU: n,
            CF: t,
            C_: r
        };
    }), rY = A3(zy, "sentAt", tN, A3(zy, "snippet", w$, A3(zy, "id", w$, Ke(nY)))), tY = A4(Sy, "phoneNumber", l_(w$), Rt, A4(Sy, "userId", l_(w$), Rt, A4(Sy, "patientId", l_(w$), Rt, A4(Sy, "contactId", l_(w$), Rt, A4(Sy, "displayName", l_(w$), Rt, A3(zy, "id", w$, Ke(F6(function(n, r, t, e, u, a) {
        return {
            yx: t,
            yT: r,
            qU: n,
            BK: e,
            BT: a,
            w2: u
        };
    })))))))), eY = A3(zy, "updatedAt", tN, A3(zy, "createdAt", tN, A3(zy, "isArchived", xy, A3(zy, "isUnread", xy, A3(zy, "participants", Ey(tY), A3(zy, "participantsCount", C$, A4(Sy, "lastMessage", l_(rY), Rt, A3(zy, "ident", w$, A3(zy, "practiceId", w$, Ke(KJ)))))))))), uY = F2(function(n, r) {
        return A2($y, k([
            "conversations",
            r
        ]), kT(n));
    }), aY = F4(function(n, r, t, e) {
        return A4(dC, n, eY, e, bC(A2(uY, r, t)));
    }), iY = F4(function(n, r, t, e) {
        return {
            pQ: r,
            hP: t,
            h3: e,
            Du: n
        };
    }), cY = F2(function(n, r) {
        return {
            xF: r,
            BG: n
        };
    }), oY = A2(Ge, function(n) {
        switch(n){
            case "ADDED":
                return Ke(0);
            case "REMOVED":
                return Ke(1);
            default:
                return yy("Unknown participantHistory.action: " + n);
        }
    }, w$), fY = A3(zy, "action", oY, A3(zy, "participant", tY, Ke(cY))), sY = A4(Sy, "participantHistory", Ay(fY), Rt, A4(Sy, "deletedAt", l_(tN), Rt, A3(zy, "updatedAt", tN, A3(zy, "createdAt", tN, A3(zy, "sentAt", tN, A3(zy, "author", tY, A4(Sy, "files", Ey(w$), h, A4(Sy, "richText", l_(w$), Rt, A4(Sy, "text", l_(w$), Rt, A3(zy, "id", w$, Ke(function(n) {
        return function(r) {
            return function(t) {
                return function(e) {
                    return function(u) {
                        return function(a) {
                            return function(i) {
                                return function(c) {
                                    return function(o) {
                                        return function(f) {
                                            return {
                                                x_: u,
                                                yA: i,
                                                yO: o,
                                                zq: e,
                                                qU: n,
                                                BH: f,
                                                Cq: t,
                                                CF: a,
                                                Di: r,
                                                DC: c
                                            };
                                        };
                                    };
                                };
                            };
                        };
                    };
                };
            };
        };
    }))))))))))), lY = A3(zy, "offset", C$, A3(zy, "limit", C$, A3(zy, "entities", Ey(sY), A3(zy, "total", C$, Ke(iY))))), dY = F3(function(n, r, t) {
        var e = t.$ ? h : k([
            A2(Ax, "timestamp", rG(t.a))
        ]), u = r.$ ? h : k([
            A2(YX, "limit", r.a)
        ]);
        return A2(Ot, A2(YX, "offset", n), $(u, e));
    }), bY = F2(function(n, r) {
        return A2($y, k([
            "conversations",
            r,
            "messages"
        ]), kT(n));
    }), vY = F7(function(n, r, t, e, u, a, i) {
        return A4(dC, n, lY, i, A2(iH, A3(dY, e, u, a), bC(A2(bY, r, t))));
    }), mY = function(n) {
        return ST(Q_(n));
    }, pY = F9(function(n, r, t, e, u, a, i, c, o) {
        var f, s;
        return b({
            d8: !1,
            I: oa,
            aT: oa,
            j: t,
            c6: Mx,
            og: u,
            g$: t,
            c7: 0,
            g2: c,
            bf: i,
            dd: 0,
            kj: r,
            dg: !1,
            eJ: !1,
            T: "",
            bo: !1,
            bp: !1,
            cy: !1,
            bq: !1,
            cz: !1,
            bV: !1,
            ax: !1,
            br: !1,
            bs: Rt,
            dl: Rt,
            kD: "",
            aL: Mx,
            bu: Rt,
            dw: n,
            dz: Rt,
            bx: IJ,
            cM: VJ,
            V: h,
            cQ: !1,
            fL: a,
            dZ: Rt,
            d0: h,
            w_: e,
            fR: o
        }, Hu(k([
            (s = mY(t), s.$ ? Dp : A4(aY, t, s.a, u, JJ)),
            (f = mY(t), f.$ ? Dp : A7(vY, t, f.a, u, 0, Ht(10), Rt, YJ)),
            A2(Eu, function() {
                return QJ;
            }, gu(0)),
            A2(Eu, function(n) {
                return jG(pp(n.jG.cd));
            }, PX)
        ])));
    }), $Y = F2(function(n, r) {
        var t = 0 > s(r.d2, 1024) ? 0 : 1, e = A9(pY, r.dw, r.kj, r.j, r.w_, n, r.fL, r.bf, r.tE, t), u = e.b;
        return v(m(r, {
            X: Ht(e.a),
            a6: Ht(n)
        }), Hu(k([
            A2(jp, aG, u),
            A2(Eu, LJ, gu(n))
        ])), h);
    }), hY = Jn("setupScrollDetection", function(n) {
        return vk(k([
            b("containerId", mk(n.n0))
        ]));
    }), gY = function(n) {
        return {
            $: 25,
            a: n
        };
    }, wY = {
        $: 26
    }, kY = F2(function(n, r) {
        return {
            $: 28,
            a: n,
            b: r
        };
    }), xY = function(n) {
        return {
            $: 1,
            a: n
        };
    }, yY = function(n) {
        return {
            $: 22,
            a: n
        };
    }, _Y = function(n) {
        return {
            $: 16,
            a: n
        };
    }, CY = function(n) {
        return {
            $: 23,
            a: n
        };
    }, DY = F2(function(n, r) {
        return {
            $: 11,
            a: n,
            b: r
        };
    }), AY = {
        $: 21
    }, qY = {
        $: 9
    }, BY = function(n) {
        return {
            $: 8,
            a: n
        };
    }, jY = {
        $: 12
    }, SY = function(n) {
        return {
            $: 7,
            a: n
        };
    }, zY = {
        $: 10
    }, UY = A2(ue, ",", k([
        ".jpeg",
        ".jpg",
        ".gif",
        ".png",
        ".mp4",
        ".mp3",
        ".oga",
        ".weba",
        ".mpeg",
        ".webm",
        ".bmp",
        ".tif",
        ".tiff",
        ".csv",
        ".ics",
        ".pdf",
        ".heic"
    ])), EY = Jn("autoResize", mk), PY = function(n) {
        return vk(k([
            b("userId", mk(n.w2))
        ]));
    }, TY = F4(function(n, r, t, e) {
        return A4(vN, n, eY, e, A2(xq, function(n) {
            return vk(k([
                b("participants", A2(wq, PY, n.tz))
            ]));
        }(t), bC(function(n) {
            return A2($y, k([
                "conversations"
            ]), kT(n));
        }(r))));
    }), FY = function(n) {
        return {
            $: 6,
            a: n
        };
    }, LY = function(n) {
        return A2(Eu, FY, gu(n));
    }, MY = {
        ke: {
            qI: 0,
            cd: 0,
            xl: 0,
            lw: 0
        },
        vx: {
            qI: 0,
            cd: 0
        },
        jG: {
            qI: 0,
            cd: 0,
            xl: 0,
            lw: 0
        }
    }, HY = A3(Qe, F2(function(n, r) {
        return {
            r$: r,
            ix: n
        };
    }), A2(Tu, "requestId", w$), A2(Tu, "url", Ay(w$))), RY = {
        $: 6
    }, OY = {
        $: 0
    }, NY = {
        $: 0
    }, IY = function(n) {
        return {
            $: 0,
            a: n
        };
    }, VY = {
        $: 0
    }, WY = {
        $: 0
    }, ZY = function(n) {
        var r = Gb(we(A2(ae, ".", n)));
        return 1 === r.$ ? "" : "." + r.a;
    }, XY = function(n) {
        var r, t = function(n) {
            var r = A2(ae, "_", n);
            if (r.b) {
                var t = r.a, e = r.b;
                return A2(ne, he, t) && au(t) >= 13 ? A2(ue, "_", e) : n;
            }
            return n;
        }(A2(uc, r = n, Gb(we(A2(ae, "/", r))))), e = ZY(t);
        if (A2(uu, "__keenhp-file__", t)) return A2(uc, t, Gb(A2(ae, "__keenhp-file__", t)));
        var u = A2(uu, ".", t) ? A2(ue, ".", we(A2(zp, 1, we(A2(ae, ".", t))))) : t, a = A2(ae, "_", u), i = function() {
            var n = we(a);
            if (n.b && n.b.b) {
                var r = n.a, t = n.b, e = t.b;
                return A2(ne, he, t.a) && A2(ne, he, r) ? we(e) : a;
            }
            return a;
        }();
        return $(A2(ue, "_", i), e);
    }, GY = F2(function(n, r) {
        return {
            yT: r,
            zf: ZY(r),
            af: n
        };
    }), JY = k([
        "wav",
        "mp3",
        "weba",
        "oga",
        "ogg",
        "m4a",
        "aac",
        "flac",
        "opus"
    ]), YY = k([
        "jpeg",
        "jpg",
        "gif",
        "png",
        "bmp",
        "webp",
        "tif",
        "tiff"
    ]), QY = k([
        "mp4",
        "webm",
        "mpeg",
        "mpg",
        "ogv"
    ]), KY = function(n) {
        var r, t = (r = OB(n), A2(pu, ".", r) ? A2(cu, 1, r) : r);
        return A2(lA, t, YY) || "heic" === t ? 0 : A2(lA, t, QY) ? 1 : A2(lA, t, JY) ? 2 : A2(lA, t, tJ) ? 3 : 4;
    }, nQ = function(n) {
        var r = uJ(n), t = r.a, e = KY(r.b), u = KY(t);
        return 4 !== u ? u : e;
    }, rQ = F2(function(n, r) {
        return A2($y, k([
            "conversations",
            r,
            "files"
        ]), kT(n));
    }), tQ = A3(zy, "fileUrl", w$, Ke(ru)), eQ = F5(function(n, r, t, e, u) {
        return A4(dC, n, tQ, u, A2(iH, k([
            A2(Ax, "filename", e)
        ]), bC(A2(rQ, r, t))));
    }), uQ = function(n) {
        switch(n){
            case 0:
            case 1:
            case 2:
                return !0;
            default:
                return !1;
        }
    }, aQ = F6(function(n, r, t, e, u, a) {
        var i, c, o = a.$ ? (c = ZY(i = u), {
            yT: XY(i),
            zf: c,
            af: i
        }) : A2(GY, u, a.a), f = nQ(o), s = uQ(f) ? Mx : oc, l = uQ(f) ? A5(eQ, n, r, t, o.af, A2(Je, IY, GG)) : Dp, d = A2(ny, 0, GG(RY));
        return b({
            c: o,
            k: e,
            l: {
                bf: 0,
                pm: 0,
                bU: !1,
                cD: !1,
                ca: 0
            },
            yq: n,
            og: t,
            dd: 0,
            f: {
                bm: !1,
                aI: Rt,
                K: Rt,
                F: Rt
            },
            ak: !1,
            BK: r,
            b3: {
                qI: Rt,
                cd: Rt
            },
            b: d.a,
            u: OY,
            B: NY,
            p: VY,
            h: !1,
            n: Rt,
            v: WY,
            r: 0,
            w: 0,
            cS: s,
            y: {
                bO: 0,
                K: Rt,
                F: Rt,
                b0: !1,
                dA: !1,
                fh: !1
            }
        }, Hu(k([
            l,
            d.b
        ])));
    }), iQ = F7(function(n, r, t, e, u, a, i) {
        var c = A2(yu, function(e) {
            var u, c = (u = Gb(A2(ou, "_", e))).$ ? e : A2(cu, u.a + 1, e), o = A6(aQ, n, r, t, e, c, A2(Xb, function(n) {
                return fu(n) ? Rt : Ht(n);
            }, A2(Zu, c, a))), f = o.b;
            return v(e, o.a, A2(jp, i(e), f));
        }, A2(Tc, function(n) {
            return !A2(YL, n, u);
        }, A2(Ji, function(n) {
            return A2(yu, function(r) {
                return n.qU + "_" + r;
            }, n.zq);
        }, e))), o = A2(yu, function(n) {
            return n.c;
        }, c);
        return b(A3(ce, F2(function(n, r) {
            return A3(Qu, n.a, n.b, r);
        }), u, c), o);
    }), cQ = tt, oQ = A2(dc, function() {
        return UG;
    }, A2(_u, function(n) {
        return A3(cQ, "messages-container", 0, n.vx.qI);
    }, ay("messages-container"))), fQ = Jn("measureElement", function(n) {
        return vk(k([
            b("elementId", mk(n.bQ)),
            b("maxLines", hq(n.Am))
        ]));
    }), sQ = fQ({
        bQ: "participant-header-text",
        Am: 2
    }), lQ = Jn("openFileDialogPort", mk), dQ = A4(IG, F3(function(n, r, t) {
        return {
            qI: t,
            ix: n,
            cd: r
        };
    }), A2(Tu, "requestId", w$), A2(Tu, "width", _$), A2(Tu, "height", _$)), bQ = function(n) {
        return {
            $: 1,
            a: n
        };
    }, vQ = F2(function(n, r) {
        return A2(Eu, function() {
            return r;
        }, qp(n));
    }), mQ = F3(function(n, r, t) {
        var e = t, u = m(e, {
            bn: A2(Ot, r, e.bn)
        }), a = function() {
            var r = n.Da;
            switch(r.$){
                case 0:
                    var t = r.a;
                    return e.eX ? Dp : A2(vQ, t, bQ(Rt));
                case 1:
                    t = r.a;
                    var a = r.b;
                    return e.eX ? Dp : A2(vQ, t, bQ(Ht(a)));
                default:
                    return A2(vQ, a = r.a, function(n) {
                        return {
                            $: 2,
                            a: n
                        };
                    }(function(n) {
                        return oe(n.bn);
                    }(u)));
            }
        }();
        return b(u, A2(jp, n.Dz, a));
    }), pQ = function(n) {
        return {
            $: 7,
            a: n
        };
    }, $Q = function(n) {
        return {
            $: 3,
            a: n
        };
    }, hQ = function(n) {
        return {
            $: 1,
            a: n
        };
    }, gQ = function(n) {
        var r = A2(Cu, function() {
            return 0;
        }, uy(n));
        return A2(dc, A2(Je, hQ, $Q), A2(lc, function() {
            return A2(_u, function() {
                return r;
            }, qp(64));
        }, A2(lc, function() {
            return A2(_u, function() {
                return r;
            }, qp(32));
        }, A2(lc, function() {
            return A2(_u, function() {
                return r;
            }, qp(16));
        }, r))));
    }, wQ = d$(function(n) {
        return ge(n) ? n : "_";
    }), kQ = function(n) {
        return "fp-audio-" + wQ(n);
    }, xQ = Jn("mediaPlay", function(n) {
        return vk(k([
            b("elementId", mk(n.bQ))
        ]));
    }), yQ = gn, _Q = Jn("mediaSetCurrentTime", function(n) {
        return vk(k([
            b("elementId", mk(n.bQ)),
            b("seconds", yQ(n.Cz))
        ]));
    }), CQ = Jn("mediaTogglePlayPause", function(n) {
        return vk(k([
            b("elementId", mk(n.bQ))
        ]));
    }), DQ = F2(function(n, r) {
        n: for(;;)switch(n.$){
            case 0:
                return r.l.cD ? b(r, CQ({
                    bQ: kQ(r.k)
                })) : b(m(r, {
                    l: m(u = r.l, {
                        cD: !0
                    })
                }), gQ(kQ(r.k)));
            case 1:
                return b(r, n.a.$ ? Dp : xQ({
                    bQ: kQ(r.k)
                }));
            case 2:
                return b(m(r, {
                    l: m(u = r.l, {
                        bU: !0
                    })
                }), Dp);
            case 3:
                return b(m(r, {
                    l: m(u = r.l, {
                        bU: !1
                    })
                }), Dp);
            case 4:
                return b(m(r, {
                    l: m(u = r.l, {
                        bf: n.a,
                        pm: t = n.b
                    })
                }), Dp);
            case 5:
                var t;
                return b(m(r, {
                    l: m(u = r.l, {
                        pm: t = n.a,
                        ca: t > 0 ? 0 : u.ca
                    })
                }), Dp);
            case 9:
                return 1 > (u = r.l).ca ? b(m(r, {
                    l: m(u, {
                        ca: u.ca + 1
                    })
                }), A5(eQ, r.yq, r.BK, r.og, r.c.af, A2(Je, IY, GG))) : b(m(r, {
                    ak: !0
                }), Dp);
            case 6:
                return b(m(r, {
                    l: m(u = r.l, {
                        bf: 0,
                        bU: !1
                    })
                }), Dp);
            case 7:
                var e = A2(Me, 0, A2(Wv, 1, n.a)) * (a = (u = r.l).pm);
                return a > 0 ? b(m(r, {
                    l: m(u, {
                        bf: e
                    })
                }), _Q({
                    bQ: kQ(r.k),
                    Cz: e
                })) : b(r, Dp);
            default:
                var u, a;
                n = pQ(((a = (u = r.l).pm) > 0 ? u.bf / a : 0) + n.a);
                continue n;
        }
    }), AQ = {
        $: 1
    }, qQ = {
        $: 1
    }, BQ = F2(function(n, r) {
        return {
            $: 5,
            a: n,
            b: r
        };
    }), jQ = function(n) {
        return {
            $: 3,
            a: n
        };
    }, SQ = function(n) {
        return {
            $: 4,
            a: n
        };
    }, zQ = function(n) {
        return {
            $: 2,
            a: n
        };
    }, UQ = {
        $: 4
    }, EQ = {
        $: 2
    }, PQ = {
        $: 1
    }, TQ = {
        $: 1
    }, FQ = {
        $: 1
    }, LQ = F3(function(n, r, t) {
        var e;
        return A2(Eu, hu, A3(Mt, n, r, (e = t, new Uint8Array(e.buffer, e.byteOffset, e.byteLength))));
    }), MQ = Jn("convertDocxFromUrl", function(n) {
        return vk(k([
            b("requestId", mk(n.ix)),
            b("url", mk(n.w_))
        ]));
    }), HQ = Jn("convertHeicFromUrl", function(n) {
        return vk(k([
            b("requestId", mk(n.ix)),
            b("url", mk(n.w_))
        ]));
    }), RQ = Jn("clearDocxMount", mk), OQ = function(n) {
        return "fp-docx-lightbox-" + wQ(n.k);
    }, NQ = function(n) {
        return iJ(n.c) ? RQ(OQ(n)) : Dp;
    }, IQ = function(n) {
        return {
            $: 3,
            a: n
        };
    }, VQ = function(n) {
        return {
            $: 0,
            a: n
        };
    }, WQ = {
        $: 2
    }, ZQ = {
        $: 1
    }, XQ = F2(function(n, r) {
        return A3(Et, "arraybuffer", Tt, A2(Je, r, n));
    }), GQ = function(n) {
        return A_({
            gF: q_,
            zc: n.zc,
            hu: h,
            AA: "GET",
            Do: Rt,
            Dw: Rt,
            w_: n.w_
        });
    }, JQ = F2(function(n, r) {
        return GQ({
            zc: A2(XQ, r, function(n) {
                switch(n.$){
                    case 0:
                        return Xt(VQ(n.a));
                    case 1:
                        return Xt(ZQ);
                    case 2:
                        return Xt(WQ);
                    case 3:
                        return Xt(IQ(n.a.C7));
                    default:
                        return Qt(n.b);
                }
            }),
            w_: n
        });
    }), YQ = function(n) {
        var r = uJ(n);
        return "heic" === r.a || "heic" === r.b;
    }, QQ = Jn("openInNewWindow", mk), KQ = function(n) {
        return "fp-pdf-lightbox-" + wQ(n.k);
    }, nK = "0.1.4", rK = F2(function(n, r) {
        return n(function(n) {
            switch(n.$){
                case 0:
                    var r = n.a;
                    return vk(k([
                        b("cmd", mk("openurl")),
                        b("name", mk(r.sS)),
                        b("url", mk(r.w_)),
                        b("version", mk(nK))
                    ]));
                case 1:
                    return r = n.a, vk(k([
                        b("cmd", mk("openstring")),
                        b("name", mk(r.sS)),
                        b("string", mk(r.Db)),
                        b("version", mk(nK))
                    ]));
                default:
                    return r = n.a, vk(k([
                        b("cmd", mk("close")),
                        b("name", mk(r.sS))
                    ]));
            }
        }(r));
    }), tK = Jn("sendPdfCommand", ru), eK = function(n) {
        return A2(rK, tK, function(n) {
            return {
                $: 2,
                a: n
            };
        }({
            sS: n
        }));
    }, uK = function(n) {
        return fJ(n.c) ? eK(KQ(n)) : Dp;
    }, aK = Jn("requestSpreadsheetPreview", function(n) {
        return vk(k([
            b("kind", mk(n.hI)),
            b("requestId", mk(n.ix)),
            b("url", mk(n.w_))
        ]));
    }), iK = Jn("requestXmlPreview", function(n) {
        return vk(k([
            b("elementId", mk(n.bQ)),
            b("requestId", mk(n.ix)),
            b("url", mk(n.w_))
        ]));
    }), cK = Jn("revokePreviewObjectUrl", mk), oK = function(n) {
        if (n.$) return Dp;
        var r = n.a;
        return A2(pu, "blob:", r) ? cK(r) : Dp;
    }, fK = F2(function(n, r) {
        return A2(rK, tK, function(n) {
            return {
                $: 0,
                a: n
            };
        }({
            sS: n,
            w_: r
        }));
    }), sK = Jn("clearXmlMount", mk), lK = function(n) {
        return "fp-xml-lightbox-" + wQ(n.k);
    }, dK = function(n) {
        return kJ(n.c) ? sK(lK(n)) : Dp;
    }, bK = F2(function(n, r) {
        switch(n.$){
            case 0:
                var t = n.a, e = function(n) {
                    var r = n.y;
                    return m(n, {
                        f: m(n.f, {
                            K: Rt,
                            F: Rt
                        }),
                        b3: {
                            qI: Rt,
                            cd: Rt
                        },
                        y: m(r, {
                            K: Rt,
                            F: Rt
                        })
                    });
                }(m(r, {
                    l: {
                        bf: 0,
                        pm: 0,
                        bU: !1,
                        cD: !1,
                        ca: 0
                    },
                    f: {
                        bm: !1,
                        aI: Rt,
                        K: r.f.K,
                        F: r.f.F
                    },
                    ak: !1,
                    b: ND(r.b),
                    u: OY,
                    B: NY,
                    p: VY,
                    h: !1,
                    n: Rt,
                    v: WY,
                    r: 0,
                    w: 0,
                    cS: t,
                    y: {
                        bO: 0,
                        K: Rt,
                        F: Rt,
                        b0: !1,
                        dA: !1,
                        fh: !1
                    }
                }));
                if (3 === t.$) {
                    var u = t.a, a = oK(r.f.aI), i = YQ(r.c), c = !(f = nQ(r.c)) && !i || 1 === f ? A2(Eu, function() {
                        return xY(TQ);
                    }, qp(50)) : Dp, o = i ? b(m(e, {
                        f: m(e.f, {
                            bm: !0,
                            aI: Rt,
                            K: Rt,
                            F: Rt
                        })
                    }), Hu(k([
                        a,
                        HQ({
                            ix: r.k,
                            w_: u
                        })
                    ]))) : b(e, a);
                    return b(o.a, Hu(k([
                        o.b,
                        c
                    ])));
                }
                return b(e, oK(r.f.aI));
            case 1:
                var f, s = m(r, {
                    dd: n.a
                });
                switch(f = nQ(s.c)){
                    case 0:
                        return YQ(s.c) ? b(m(s, {
                            b: fA(s.b),
                            u: OY,
                            B: NY,
                            p: VY,
                            h: !1,
                            v: WY,
                            r: 0,
                            w: 0
                        }), Dp) : b(m(s, {
                            u: OY,
                            B: NY,
                            p: VY,
                            h: !1,
                            v: WY,
                            r: 0,
                            w: 0
                        }), A5(eQ, s.yq, s.BK, s.og, s.c.af, A2(Je, zQ, GG)));
                    case 3:
                        return iJ(s.c) ? b(m(s, {
                            b: fA(s.b),
                            u: OY,
                            B: qQ,
                            p: VY,
                            h: !1,
                            n: Rt,
                            v: WY,
                            r: 0,
                            w: 0
                        }), Hu(k([
                            NQ(s),
                            uK(s),
                            A5(eQ, s.yq, s.BK, s.og, s.c.af, A2(Je, zQ, GG))
                        ]))) : fJ(s.c) ? b(m(s, {
                            b: fA(s.b),
                            u: OY,
                            B: NY,
                            p: PQ,
                            h: !1,
                            n: Rt,
                            v: WY,
                            r: 0,
                            w: 0
                        }), Hu(k([
                            uK(s),
                            A5(eQ, s.yq, s.BK, s.og, s.c.af, A2(Je, zQ, GG))
                        ]))) : mJ(s.c) ? b(m(s, {
                            b: fA(s.b),
                            u: AQ,
                            B: NY,
                            p: VY,
                            h: !1,
                            n: Rt,
                            v: WY,
                            r: 0,
                            w: 0
                        }), Hu(k([
                            NQ(s),
                            uK(s),
                            A5(eQ, s.yq, s.BK, s.og, s.c.af, A2(Je, zQ, GG))
                        ]))) : pJ(s.c) ? b(m(s, {
                            b: fA(s.b),
                            u: OY,
                            B: NY,
                            p: VY,
                            h: !1,
                            n: Rt,
                            v: FQ,
                            r: 0,
                            w: 0
                        }), Hu(k([
                            NQ(s),
                            uK(s),
                            A5(eQ, s.yq, s.BK, s.og, s.c.af, A2(Je, zQ, GG))
                        ]))) : kJ(s.c) ? b(m(s, {
                            b: fA(s.b),
                            u: OY,
                            B: NY,
                            p: VY,
                            h: !1,
                            n: Rt,
                            v: WY,
                            r: 0,
                            w: 1
                        }), Hu(k([
                            NQ(s),
                            uK(s),
                            A5(eQ, s.yq, s.BK, s.og, s.c.af, A2(Je, zQ, GG))
                        ]))) : b(m(s, {
                            b: fA(s.b),
                            u: OY,
                            B: NY,
                            p: VY,
                            h: !0,
                            n: Rt,
                            v: WY,
                            r: 0,
                            w: 0
                        }), A5(eQ, s.yq, s.BK, s.og, s.c.af, A2(Je, jQ, GG)));
                    default:
                        return b(m(s, {
                            b: fA(s.b),
                            u: OY,
                            B: NY,
                            p: VY,
                            h: !0,
                            n: Rt,
                            v: WY,
                            r: 0,
                            w: 0
                        }), A5(eQ, s.yq, s.BK, s.og, s.c.af, A2(Je, jQ, GG)));
                }
            case 3:
                return b(3 === (t = n.a).$ ? m(r, {
                    cS: A2(f_, u = t.a, t.b)
                }) : r, Dp);
            case 2:
                switch((t = n.a).$){
                    case 3:
                        if (u = t.a, YQ(r.c)) return b(r, Dp);
                        if (iJ(r.c)) return b(m(r, {
                            n: Ht(u)
                        }), MQ({
                            ix: r.k,
                            w_: u
                        }));
                        if (fJ(r.c)) {
                            var l = gJ(r) ? EQ : UQ, d = KQ(r), v = gJ(r) ? Hu(k([
                                eK(d),
                                A2(fK, d, u)
                            ])) : eK(d);
                            return b(m(r, {
                                b: fA(r.b),
                                p: l,
                                h: !1,
                                n: Ht(u)
                            }), v);
                        }
                        return mJ(r.c) ? b(m(r, {
                            b: fA(r.b),
                            h: !1,
                            n: Ht(u)
                        }), aK({
                            hI: "csv",
                            ix: r.k,
                            w_: u
                        })) : pJ(r.c) ? b(m(r, {
                            b: fA(r.b),
                            h: !1,
                            n: Ht(u)
                        }), aK({
                            hI: "xlsx",
                            ix: r.k,
                            w_: u
                        })) : kJ(r.c) ? b(m(r, {
                            b: fA(r.b),
                            h: !1,
                            n: Ht(u)
                        }), iK({
                            bQ: lK(r),
                            ix: r.k,
                            w_: u
                        })) : b(m(r, {
                            b: fA(r.b),
                            h: !1,
                            n: Ht(u)
                        }), Dp);
                    case 2:
                        return b(m(r, {
                            b: ND(r.b),
                            u: OY,
                            B: NY,
                            p: VY,
                            v: WY,
                            r: 0,
                            w: 0
                        }), Hu(k([
                            NQ(r),
                            uK(r),
                            dK(r)
                        ])));
                    default:
                        return b(r, Dp);
                }
            case 6:
                return b(m(r, {
                    b: ND(r.b),
                    u: OY,
                    B: NY,
                    p: VY,
                    h: !1,
                    n: Rt,
                    v: WY,
                    r: 0,
                    w: 0
                }), Hu(k([
                    NQ(r),
                    uK(r),
                    dK(r)
                ])));
            case 7:
                return b(r, A5(eQ, r.yq, r.BK, r.og, r.c.af, A2(Je, SQ, GG)));
            case 4:
                return 3 === (t = n.a).$ ? (u = t.a, b(m(r, {
                    b: ND(r.b),
                    u: OY,
                    B: NY,
                    p: VY,
                    h: !1,
                    n: Rt,
                    v: WY,
                    r: 0,
                    w: 0,
                    cS: oc
                }), Hu(k([
                    A2(JQ, u, A2(Je, BQ({
                        yT: r.c.yT,
                        p0: u
                    }), GG)),
                    NQ(r),
                    uK(r),
                    dK(r)
                ])))) : b(r, Dp);
            case 5:
                var p = n.a, $ = n.b;
                return b(r, $.$ ? QQ(p.p0) : A3(LQ, p.yT, "application/octet-stream", $.a));
            case 8:
                var h = A2(mq, n.a, r.b), g = h.b;
                return b(m(r, {
                    b: h.a
                }), A2(jp, A2(sc, GG, QG), g));
            case 10:
                var w = r.f;
                return b(m(r, {
                    f: m(w, {
                        aI: Rt
                    }),
                    ak: !0,
                    b: ND(r.b),
                    u: OY,
                    B: NY,
                    p: VY,
                    h: !1,
                    n: Rt,
                    v: WY,
                    r: 0,
                    w: 0
                }), Hu(k([
                    oK(w.aI),
                    NQ(r),
                    uK(r),
                    dK(r)
                ])));
            case 9:
                return b(m(r, {
                    dd: x = n.a
                }), Dp);
            default:
                var x = n.a;
                return b(m(r, {
                    b3: m(r.b3, {
                        qI: Ht(n.b),
                        cd: Ht(x)
                    })
                }), Dp);
        }
    }), vK = function(n) {
        return {
            $: 2,
            a: n
        };
    }, mK = Jn("mountDocxHtml", function(n) {
        return vk(k([
            b("elementId", mk(n.bQ)),
            b("html", mk(n.qS))
        ]));
    }), pK = F2(function(n, r) {
        return mK({
            bQ: OQ(n),
            qS: r
        });
    }), $K = {
        $: 3
    }, hK = function(n) {
        return b(m(n, {
            b: ND(n.b),
            u: OY,
            B: $K,
            p: VY,
            n: Rt,
            v: WY,
            r: 0,
            w: 0
        }), Hu(k([
            NQ(n),
            uK(n),
            dK(n)
        ])));
    }, gK = A4(IG, F3(function(n, r, t) {
        return {
            qS: t,
            kL: r,
            ix: n
        };
    }), A2(Tu, "requestId", w$), A2(Tu, "ok", xy), A2(Tu, "html", Ay(w$))), wK = F2(function(n, r) {
        var t = A2(By, gK, n);
        if (t.$) return hK(r);
        var e = t.a.kL, u = t.a.qS;
        if (i(t.a.ix, r.k) && rJ(r.b)) {
            if (e) {
                if (u.$) return hK(r);
                var a = u.a;
                return fu(a) ? hK(r) : b(m(r, {
                    B: vK(a)
                }), A2(pK, r, a));
            }
            return hK(r);
        }
        return b(r, Dp);
    }), kK = {
        $: 2
    }, xK = Jn("observePreviewLayout", function(n) {
        return vk(k([
            b("elementId", mk(n.bQ)),
            b("requestId", mk(n.ix))
        ]));
    }), yK = function(n) {
        return "fp-box-" + wQ(n);
    }, _K = F2(function(n, r) {
        switch(n.$){
            case 0:
                var t = n.a;
                return YQ(r.c) ? t.$ ? b(m(r, {
                    f: m(r.f, {
                        bm: !1
                    }),
                    ak: !0
                }), Dp) : b(m(r, {
                    f: m(r.f, {
                        bm: !1,
                        aI: Ht(t.a)
                    }),
                    ak: !1
                }), A2(Eu, function() {
                    return xY(TQ);
                }, qp(50))) : b(r, Dp);
            case 1:
                return b(r, A2(Eu, function() {
                    return xY(kK);
                }, qp(50)));
            case 2:
                return b(r, xK({
                    bQ: yK(r.k),
                    ix: r.k
                }));
            default:
                var e = n.a;
                return b(m(r, {
                    f: m(r.f, {
                        K: Ht(n.b),
                        F: Ht(e)
                    })
                }), Dp);
        }
    }), CK = {
        $: 5
    }, DK = function(n) {
        return {
            $: 3,
            a: n
        };
    }, AK = function(n) {
        return b(m(n, {
            b: ND(n.b),
            u: OY,
            p: VY,
            n: Rt,
            v: WY,
            r: 0,
            w: 0
        }), Hu(k([
            uK(n),
            dK(n)
        ])));
    }, qK = F2(function(n, r) {
        if (n.$) return fJ(r.c) && rJ(r.b) ? b(m(r, {
            p: CK
        }), Dp) : b(r, Dp);
        var t = n.a;
        if (t.$) return AK(r);
        if (1 === t.a.$) {
            var e = t.a.a.BB;
            return i(t.a.a.sS, KQ(r)) && rJ(r.b) && fJ(r.c) ? b(m(r, {
                p: DK(e)
            }), Dp) : b(r, Dp);
        }
        return AK(r);
    }), BK = function(n) {
        return {
            $: 2,
            a: n
        };
    }, jK = function(n) {
        return {
            $: 2,
            a: n
        };
    }, SK = {
        $: 3
    }, zK = {
        $: 3
    }, UK = function(n) {
        return b(m(n, {
            b: ND(n.b),
            u: SK,
            B: NY,
            p: VY,
            n: Rt,
            v: zK,
            r: 0,
            w: 3
        }), Hu(k([
            NQ(n),
            uK(n),
            dK(n)
        ])));
    }, EK = F5(function(n, r, t, e, u) {
        return {
            zx: e,
            hI: t,
            kL: r,
            ix: n,
            CM: u
        };
    }), PK = A3(Qe, F2(function(n, r) {
        return {
            hu: n,
            iz: r
        };
    }), A2(Tu, "headers", Ey(w$)), A2(Tu, "rows", Ey(Ey(w$)))), TK = A4(IG, F3(function(n, r, t) {
        return {
            hu: r,
            sS: n,
            iz: t
        };
    }), A2(Tu, "name", w$), A2(Tu, "headers", Ey(w$)), A2(Tu, "rows", Ey(Ey(w$)))), FK = A6(HG, EK, A2(Tu, "requestId", w$), A2(Tu, "ok", xy), A2(Tu, "kind", w$), l_(A2(Tu, "grid", PK)), l_(A2(Tu, "sheets", Ey(TK)))), LK = F2(function(n, r) {
        if (n.$) return b(m(r, {
            r: n.a
        }), Dp);
        var t = A2(By, FK, n.a);
        if (t.$) return UK(r);
        var e = t.a;
        if (i(e.ix, r.k) && rJ(r.b)) {
            if (e.kL) {
                if ("csv" === e.hI) {
                    var u = e.zx;
                    return u.$ ? UK(r) : b(m(r, {
                        u: BK(u.a)
                    }), Dp);
                }
                if ("xlsx" === e.hI) {
                    var a = e.CM;
                    return a.$ ? UK(r) : b(m(r, {
                        v: jK(a.a),
                        r: 0
                    }), Dp);
                }
                return UK(r);
            }
            return UK(r);
        }
        return b(r, Dp);
    }), MK = function(n) {
        return "fp-video-" + wQ(n);
    }, HK = Jn("videoSeekPreview", function(n) {
        return vk(k([
            b("videoElementId", mk(n.DF))
        ]));
    }), RK = F2(function(n, r) {
        switch(n.$){
            case 0:
                return b(m(r, {
                    y: m(t = r.y, {
                        b0: !t.b0
                    })
                }), CQ({
                    bQ: MK(r.k)
                }));
            case 1:
                return 1 > (t = r.y).bO ? b(m(r, {
                    y: m(t, {
                        bO: t.bO + 1
                    })
                }), A5(eQ, r.yq, r.BK, r.og, r.c.af, A2(Je, IY, GG))) : b(m(r, {
                    ak: !0
                }), Dp);
            case 2:
                return (t = r.y).b0 || t.fh ? b(m(r, {
                    y: m(t, {
                        bO: 0,
                        dA: !0
                    })
                }), Dp) : b(m(r, {
                    y: m(t, {
                        bO: 0,
                        dA: !0,
                        fh: !0
                    })
                }), HK({
                    DF: MK(r.k)
                }));
            default:
                var t, e = n.a;
                return b(m(r, {
                    y: m(t = r.y, {
                        K: Ht(n.b),
                        F: Ht(e)
                    })
                }), Dp);
        }
    }), OK = F2(function(n, r) {
        return {
            kL: r,
            ix: n
        };
    }), NK = A3(Qe, OK, A2(Tu, "requestId", w$), A2(Tu, "ok", xy)), IK = F2(function(n, r) {
        var t = A2(By, NK, n);
        if (t.$) return UK(r);
        var e = t.a;
        return i(e.ix, r.k) && rJ(r.b) ? e.kL ? b(m(r, {
            w: 2
        }), Dp) : UK(r) : b(r, Dp);
    }), VK = F2(function(n, r) {
        switch(n.$){
            case 0:
                return A2(bK, n.a, r);
            case 1:
                return A2(_K, n.a, r);
            case 2:
                return A2(RK, n.a, r);
            case 3:
                return A2(DQ, n.a, r);
            case 4:
                return A2(wK, n.a, r);
            case 5:
                return A2(qK, n.a, r);
            case 6:
                return A2(LK, n.a, r);
            default:
                return A2(IK, n.a, r);
        }
    }), WK = F3(function(n, r, t) {
        var e = A2(Zu, r, n.I);
        if (e.$) return v(n, Dp, h);
        var u = A2(VK, t, e.a), a = u.b;
        return v(m(n, {
            I: A3(Qu, r, u.a, n.I)
        }), A2(jp, AG(r), a), h);
    }), ZK = function(n) {
        return {
            $: 2,
            a: n
        };
    }, XK = {
        Da: ZK(200),
        Dz: function(n) {
            return {
                $: 5,
                a: n
            };
        }
    }, GK = F2(function(n, r) {
        return A2($y, k([
            "conversations",
            r,
            "messages"
        ]), kT(n));
    }), JK = F2(function(n, r) {
        return {
            qU: n,
            CF: r
        };
    }), YK = A3(zy, "sentAt", tN, A3(zy, "id", w$, Ke(JK))), QK = F5(function(n, r, t, e, u) {
        return A4(vN, n, YK, u, A2(xq, function(n) {
            var r, t = k([
                b("files", A2(wq, mk, n.zq))
            ]), e = (r = n.Di).$ ? t : A2(Ot, b("text", mk(r.a)), t);
            return vk(e);
        }(e), bC(A2(GK, r, t))));
    }), KK = F3(function(n, r) {
        return b(h, n(r));
    }), n1 = F2(function(n, r) {
        return b({
            rf: !!r.rg && r.rf,
            rg: !0,
            vO: n.y9
        }, Dp);
    }), r1 = F2(function(n, r) {
        switch(n.$){
            case 0:
                return b(m(r, {
                    BX: n.a
                }), Dp);
            case 1:
                return b(m(r, {
                    bz: !r.bz
                }), Dp);
            case 2:
                var t = n.a;
                return b(m(r, {
                    vE: A2(lA, t, r.vE) ? A2(Tc, function(n) {
                        return !i(n, t);
                    }, r.vE) : A2(Ot, t, r.vE)
                }), Dp);
            default:
                return b(m(r, {
                    bz: !1
                }), Dp);
        }
    }), t1 = F4(function(n, r, t, e) {
        var u = e;
        switch(t.$){
            case 0:
                return b(u, Dp);
            case 1:
                var a = t.a, i = u.bn;
                if (i.b) {
                    var c = i.a, o = i.b, f = function() {
                        if (a.$) return Dp;
                        var n = a.a;
                        return A2(vQ, n, bQ(Ht(n)));
                    }(), l = A2(r, c, o), d = l.b;
                    return b(m(u, {
                        bn: l.a,
                        eX: !0
                    }), Hu(k([
                        d,
                        A2(jp, n.Dz, f)
                    ])));
                }
                return b(m(u, {
                    eX: !1
                }), Dp);
            default:
                var v = t.a, p = b(1 > s(oe(u.bn), v), u.bn);
                if (p.a && p.b.b) {
                    var $ = p.b, h = A2(r, c = $.a, o = $.b), g = h.b;
                    return b(m(u, {
                        bn: h.a
                    }), g);
                }
                return b(u, Dp);
        }
    }), e1 = Jn("uploadFileToApi", function(n) {
        return vk(k([
            b("request", function(n) {
                return vk(k([
                    b("authToken", mk(n.xZ)),
                    b("conversationId", mk(n.og)),
                    b("fileIndex", hq(n.p7)),
                    b("patientId", mk(n.BK))
                ]));
            }(n.Cj)),
            b("url", mk(n.w_))
        ]));
    }), u1 = F2(function(n, r) {
        switch(n.$){
            case 0:
                var t = n.a;
                return v(m(r, {
                    c6: t,
                    og: 3 === t.$ ? t.a.zI : r.og
                }), sQ, h);
            case 3:
            case 2:
                return v(r, Dp, h);
            case 1:
                if (3 === (fn = n.a).$) {
                    var e = fn.a, u = e.h3 ? r.dZ : Ht(e.Du), a = function() {
                        if (e.h3) {
                            var n = r.aL;
                            if (3 === n.$) {
                                var t = m(e, {
                                    pQ: $(e.pQ, n.a.pQ),
                                    Du: e.Du
                                });
                                return A2(f_, t, oa);
                            }
                            return fn;
                        }
                        return fn;
                    }(), c = e.h3 ? A2(Eu, function() {
                        return qY;
                    }, gu(0)) : Hu(k([
                        A2(Eu, function() {
                            return QJ;
                        }, gu(0)),
                        oQ,
                        sQ
                    ])), o = e.h3 + e.hP, f = 3 === a.$ ? oe(a.a.pQ) : 0, l = function() {
                        if (u.$) return 0 > s(oe(e.pQ), e.hP);
                        var n = u.a;
                        return s(f, n) > -1 || s(o, n) > -1;
                    }(), d = (Bn = mY(r.j)).$ ? b(r.I, h) : A7(iQ, r.j, Bn.a, r.og, e.pQ, r.I, r.aT, AG), p = d.b;
                    return v(m(r, {
                        d8: l,
                        I: d.a,
                        c7: o,
                        dg: !1,
                        eJ: !0,
                        bp: !1,
                        bs: e.h3 ? r.bs : Ht(r.bf),
                        dl: Ht(e.h3),
                        aL: a,
                        dZ: u
                    }), Hu(A2(Ot, c, p)), h);
                }
                return v(m(r, {
                    dg: !0,
                    bp: !1,
                    dl: Rt,
                    aL: fn
                }), Dp, h);
            case 4:
                if ("messages-container" === n.a.n0) {
                    var g = rB(n.a.lw), w = A3(mQ, XK, g, r.cM), x = w.b;
                    return v(m(r, {
                        cM: w.a
                    }), x, h);
                }
                return v(r, Dp, h);
            case 5:
                var y = n.a, _ = A4(t1, XK, KK(LY), y, r.cM);
                return x = _.b, v(m(r, {
                    cM: _.a
                }), x, h);
            case 6:
                var C = A2(uc, 0, gj(g = n.a)), D = r.c7, A = 100 > C, q = !(qn = r.dl).$ && i(qn.a, D), B = !(An = r.dZ).$ && s(D, An.a) > -1;
                return !A || r.bp || r.d8 || r.dg || B || q || !r.eJ ? v(r, Dp, h) : v(m(r, {
                    bp: !0
                }), A2(dc, A2(Je, Qm(MY), SY), uy("messages-content")), h);
            case 7:
                return D = r.c7, v(m(r, {
                    bV: !0,
                    dz: Ht(n.a.ke.qI)
                }), (Dn = mY(r.j)).$ ? Dp : A7(vY, r.j, Dn.a, r.og, D, Ht(10), Rt, YJ), h);
            case 9:
                return v(r, A2(dc, A2(Je, Qm(MY), BY), uy("messages-content")), h);
            case 8:
                var j = n.a, S = r.dz;
                if (S.$) return v(m(r, {
                    bV: !1
                }), Dp, h);
                var z = j.ke.qI - S.a;
                return v(m(r, {
                    dz: Rt
                }), A2(dc, function() {
                    return zY;
                }, A3(cQ, "messages-container", 0, z)), h);
            case 10:
                return v(m(r, {
                    bV: !1
                }), Dp, h);
            case 11:
                return v(r, A2(dc, function(n) {
                    return n.$ ? QJ : jY;
                }, uy("messages-container")), h);
            case 12:
                return v(r, hY({
                    n0: "messages-container"
                }), h);
            case 13:
                return v(m(r, {
                    T: n.a
                }), EY("chat-input-textarea"), h);
            case 14:
                var U = !fu(uF(r.T)), E = !ED(r.V);
                if (U || E) {
                    if (E) return v(m(r, {
                        ax: !0,
                        br: !0
                    }), A2(Eu, CY, gu(r.V)), h);
                    if (r.cy && !ED(r.bx.vE)) {
                        var P = {
                            zq: h,
                            Di: fu(uF(r.T)) ? Rt : Ht(r.T)
                        };
                        return v(m(r, {
                            T: "",
                            bo: !0,
                            bu: Ht(P),
                            V: h
                        }), Hu(k([
                            A2(Eu, function() {
                                return wY;
                            }, gu(0)),
                            EY("chat-input-textarea")
                        ])), h);
                    }
                    var T = mY(r.j);
                    if (T.$) return v(r, Dp, h);
                    var F = T.a;
                    return P = {
                        zq: h,
                        Di: fu(uF(r.T)) ? Rt : Ht(r.T)
                    }, v(m(r, {
                        T: "",
                        ax: !0,
                        V: h
                    }), Hu(k([
                        A5(QK, r.j, F, r.og, P, _Y),
                        EY("chat-input-textarea")
                    ])), h);
                }
                return v(r, Dp, h);
            case 16:
                return 3 === (tn = n.a).$ ? v(m(r, {
                    bo: !1,
                    ax: !1
                }), (Cn = mY(r.j)).$ ? Dp : A7(vY, r.j, Cn.a, r.og, 0, Ht(10), Rt, YJ), k([
                    AY
                ])) : v(m(r, {
                    ax: !1
                }), Dp, h);
            case 17:
                return v(r, lQ(UY), h);
            case 18:
                return v(m(r, {
                    V: $(r.V, n.a)
                }), Dp, h);
            case 19:
                var L = n.a;
                return v(m(r, {
                    V: A2(yu, Ac, A2(Tc, function(n) {
                        return !i(n.a, L);
                    }, A2(be, F2(function(n, r) {
                        return b(n, r);
                    }), r.V)))
                }), Dp, h);
            case 15:
                var M = A2(r1, n.a, r.bx), H = M.b;
                return v(m(r, {
                    bx: M.a
                }), A2(jp, FG, H), h);
            case 20:
                return v(m(r, {
                    bq: !r.bq
                }), Dp, h);
            case 21:
                var R = A2(n1, n.a, {
                    rf: r.bq,
                    rg: r.cz,
                    vO: r.cQ
                }).a;
                return v(m(r, {
                    bq: R.rf,
                    cz: R.rg,
                    cQ: R.vO
                }), Dp, h);
            case 23:
                var O = n.a, N = v(mY(r.j), Y_(Q_(r.j)), Ht(iC(r.j)));
                if (N.a.$ || N.b.$ || N.c.$) return v(m(r, {
                    ax: !1,
                    br: !1
                }), Dp, h);
                F = N.a.a;
                var I = N.b.a, V = N.c.a, W = A2(be, F2(function(n) {
                    return e1({
                        Cj: {
                            xZ: I,
                            og: r.og,
                            p7: n,
                            BK: F
                        },
                        w_: V + "/v1/member/" + F + "/conversations/" + r.og + "/files"
                    });
                }), O);
                return v(r, Hu(W), h);
            case 24:
                if ((tn = n.a).De) {
                    var Z = $(r.d0, k([
                        tn.p8
                    ])), X = fu(tn.p9) ? A2(Xb, function(n) {
                        return fu(n) ? Rt : Ht(n);
                    }, A2(Cp, function(n) {
                        return n.sS;
                    }, Gb(A2(zp, tn.p7, r.V)))) : Ht(tn.p9), G = X.$ ? r.aT : A3(Qu, tn.p8, X.a, r.aT);
                    if (s(oe(Z), oe(r.V)) > -1) {
                        var J = mY(r.j);
                        return J.$ ? v(m(r, {
                            aT: G,
                            ax: !1,
                            br: !1
                        }), Dp, h) : (F = J.a, P = {
                            zq: Z,
                            Di: fu(uF(r.T)) ? Rt : Ht(r.T)
                        }, v(m(r, {
                            aT: G,
                            T: "",
                            br: !1,
                            V: h,
                            d0: h
                        }), A5(QK, r.j, F, r.og, P, _Y), h));
                    }
                    return v(m(r, {
                        aT: G,
                        d0: Z
                    }), Dp, h);
                }
                return v(m(r, {
                    ax: !1,
                    br: !1
                }), Dp, h);
            case 22:
                return A3(WK, r, n.a, n.b);
            case 29:
                var Y = A2(By, HY, n.a);
                return Y.$ ? v(r, Dp, h) : A3(WK, r, Y.a.ix, xY(function(n) {
                    return {
                        $: 0,
                        a: n
                    };
                }(Y.a.r$)));
            case 30:
                var Q = A2(By, dQ, n.a);
                return Q.$ ? v(r, Dp, h) : A3(WK, r, Q.a.ix, GG(A2(DY, Q.a.cd, Q.a.qI)));
            case 31:
                var K = n.a, nn = A2(DI, F2(function(n, r) {
                    return A2(VK, GG(function(n) {
                        return {
                            $: 9,
                            a: n
                        };
                    }(K)), r).a;
                }), r.I);
                return v(m(r, {
                    I: nn,
                    dd: K
                }), Dp, h);
            case 26:
                var rn = mY(r.j);
                return rn.$ ? v(m(r, {
                    bo: !1,
                    bu: Rt
                }), Dp, h) : v(r, A4(TY, r.j, F = rn.a, P = {
                    tz: A2(yu, function(n) {
                        return {
                            w2: n
                        };
                    }, r.bx.vE)
                }, gY), h);
            case 25:
                var tn;
                if (3 === (tn = n.a).$) {
                    var en = tn.a, un = r.bu;
                    if (un.$) return v(m(r, {
                        bo: !1,
                        bu: Rt
                    }), Dp, h);
                    var an = un.a;
                    return v(m(r, {
                        c6: A2(f_, en, oa),
                        og: en.zI,
                        cy: !1,
                        ax: !0,
                        bu: Rt
                    }), (_n = mY(r.j)).$ ? Dp : A5(QK, r.j, _n.a, en.zI, an, _Y), h);
                }
                return v(m(r, {
                    bo: !1,
                    bu: Rt
                }), Dp, h);
            case 27:
                var cn = n.a;
                if (3 === r.aL.$) {
                    var on = function() {
                        if (fu(r.og)) return Dp;
                        var n = mY(r.j);
                        return n.$ ? Dp : A7(vY, r.j, n.a, r.og, 0, Rt, r.bs, function(n) {
                            return A2(kY, n, h);
                        });
                    }();
                    return v(m(r, {
                        bf: cn
                    }), on, h);
                }
                return v(r, Dp, h);
            default:
                var fn;
                if (3 === (fn = n.a).$) {
                    var sn = fn.a, ln = $(n.b, sn.pQ), dn = oe(ln);
                    if (s(sn.Du, dn) > 0 && i(oe(sn.pQ), 20)) return D = dn, on = (yn = mY(r.j)).$ ? Dp : A7(vY, r.j, yn.a, r.og, D, Rt, r.bs, function(n) {
                        return A2(kY, n, ln);
                    }), v(r, on, h);
                    var bn = m(sn, {
                        pQ: ln
                    }), vn = r.aL;
                    if (3 === vn.$) {
                        var mn = vn.a, pn = FJ(A2(yu, function(n) {
                            return n.qU;
                        }, bn.pQ)), $n = $(bn.pQ, A2(Tc, function(n) {
                            return !A2(QL, n.qU, pn);
                        }, mn.pQ)), hn = (a = A2(f_, m(bn, {
                            pQ: $n,
                            Du: bn.Du
                        }), oa), FJ(A2(yu, function(n) {
                            return n.qU;
                        }, mn.pQ))), gn = A2(Tc, function(n) {
                            return !A2(QL, n.qU, hn);
                        }, bn.pQ), wn = ED(gn) || fu(r.og) ? h : k([
                            yY(r.og)
                        ]), kn = (xn = mY(r.j)).$ ? b(r.I, h) : A7(iQ, r.j, xn.a, r.og, gn, r.I, r.aT, AG);
                        return p = kn.b, v(m(r, {
                            I: kn.a,
                            bs: Ht(r.bf),
                            aL: a
                        }), Hu(A2(Ot, A2(Eu, function() {
                            return QJ;
                        }, gu(0)), p)), wn);
                    }
                    return v(m(r, {
                        bs: Ht(r.bf)
                    }), A2(Eu, function() {
                        return QJ;
                    }, gu(0)), h);
                }
                return v(r, Dp, h);
        }
        var xn, yn, _n, Cn, Dn, An, qn, Bn;
    }), a1 = F2(function(n, r) {
        switch(n.$){
            case 0:
                var t = n.a;
                if (3 === (H = n.b).$) {
                    var e = H.a;
                    if (t) {
                        var u = r.Q;
                        if (3 === u.$) {
                            var a = oe((Z = u.a).pQ) + oe(e.pQ), c = m(Z, {
                                pQ: $(Z.pQ, e.pQ)
                            }), o = A2(f_, c, oa), f = s(a, e.Du) > -1;
                            return v(m(r, {
                                gv: f,
                                Q: o,
                                c7: r.c7 + 10,
                                bp: !1
                            }), Dp, h);
                        }
                        return v(m(r, {
                            Q: H,
                            c7: 10
                        }), hY({
                            n0: "conversation-list-container"
                        }), h);
                    }
                    var l = function(n) {
                        var r = A2(Xb, function(n) {
                            return fu(n) ? Rt : Ht(n);
                        }, A2(Zu, EJ, n.w_.iu));
                        if (1 === r.$) return v(n, Dp, h);
                        var t = r.a;
                        return !i(n.X, Rt) || i(n.a6, Ht(t)) ? v(n, Dp, h) : A2($Y, t, n);
                    }(m(r, {
                        Q: H,
                        c7: 10,
                        bs: Ht(r.bf)
                    })), d = l.b, p = l.c;
                    return v(l.a, Hu(k([
                        hY({
                            n0: "conversation-list-container"
                        }),
                        d
                    ])), p);
                }
                return v(t ? m(r, {
                    bp: !1
                }) : r, Dp, A2(uA, 0, H));
            case 1:
                var g = A2(PJ, Ht(P = n.a), r.w_.iu), w = A2($Y, P, r), x = w.c;
                return v(w.a, Hu(k([
                    w.b,
                    g
                ])), x);
            case 2:
                var y = n.a;
                if (3 === y.$) return g = A2(PJ, Rt, r.w_.iu), v(m(r, {
                    X: Rt,
                    a6: Rt
                }), g, h);
                var _ = r.X;
                if (_.$) return v(r, Dp, h);
                var C = A2(u1, y, F = _.a), D = C.a, A = C.b, q = A2(MJ, r, x = C.c), B = q.a, j = q.b, S = 1 === r.a6.$ ? !F.cy || D.cy || fu(D.og) ? b(m(r, {
                    X: Ht(D)
                }), Dp) : b(m(r, {
                    X: Ht(D),
                    a6: Ht(D.og)
                }), A2(PJ, Ht(D.og), r.w_.iu)) : b(m(r, {
                    X: Ht(D)
                }), Dp), z = S.b;
                return v(S.a, Hu(k([
                    A2(jp, aG, A),
                    B,
                    z
                ])), j);
            case 3:
                return "conversation-list-container" !== n.a.n0 || .8 >= n.a.lw / (n.a.Cu - n.a.yr) || r.bp || r.gv ? v(r, Dp, h) : v(m(r, {
                    bp: !0
                }), A2(Eu, function() {
                    return zJ;
                }, gu(0)), h);
            case 4:
                var U = 3 === (Q = r.tE).$ ? Ht(ZC(Q.a)) : Rt, E = U.$ ? Dp : A4(tG, r.j, U.a, function(n) {
                    return m(n, {
                        hP: Ht(10),
                        h3: r.c7
                    });
                }, MX(r.c7));
                return v(r, E, h);
            case 5:
                var P = n.a;
                return E = (Y = HX(r.j)).$ ? Dp : A4(GJ, r.j, Y.a, P, UJ(P)), v(r, E, h);
            case 6:
                if (3 === n.b.$) {
                    var T = function() {
                        var n = b(HX(r.j), r.Q);
                        if (n.a.$ || 3 !== n.b.$) return Dp;
                        var t = n.a.a, e = oe(n.b.a.pQ);
                        return A4(tG, r.j, t, function(n) {
                            return m(n, {
                                hP: Ht(e),
                                h3: 0
                            });
                        }, MX(0));
                    }();
                    return v(r, T, h);
                }
                return v(r, Dp, h);
            case 7:
                var F, L = A8(WJ, r.dw, r.kj, r.j, r.w_, r.fL, r.bf, r.tE, 1024 > r.d2 ? 0 : 1);
                return A = L.b, v(m(r, {
                    X: Ht(F = L.a),
                    a6: Rt
                }), A2(jp, aG, A), h);
            case 8:
                return v(m(r, {
                    d2: n.a
                }), Dp, h);
            case 9:
                var M = n.a;
                return 3 === r.Q.$ ? (E = function() {
                    var n = r.tE;
                    if (3 === n.$) {
                        var t = n.a, e = r.bs;
                        if (e.$) return A4(tG, r.j, ZC(t), function(n) {
                            return m(n, {
                                hP: Rt,
                                h3: 0,
                                lk: Rt
                            });
                        }, function(n) {
                            return A2(SJ, n, h);
                        });
                        var u = e.a;
                        return A4(tG, r.j, ZC(t), function(n) {
                            return m(n, {
                                hP: Rt,
                                h3: 0,
                                lk: Ht(u)
                            });
                        }, function(n) {
                            return A2(SJ, n, h);
                        });
                    }
                    return Dp;
                }(), v(m(r, {
                    bf: M
                }), E, h)) : v(r, Dp, h);
            default:
                var H;
                if (3 === (H = n.a).$) {
                    var R = H.a, O = $(n.b, R.pQ), N = oe(O);
                    if (s(R.Du, N) > 0 && i(oe(R.pQ), 10)) {
                        var I = N;
                        return E = function() {
                            var n = r.tE;
                            if (3 === n.$) {
                                var t = n.a, e = r.bs;
                                if (e.$) return A4(tG, r.j, ZC(t), function(n) {
                                    return m(n, {
                                        hP: Rt,
                                        h3: I,
                                        lk: Rt
                                    });
                                }, function(n) {
                                    return A2(SJ, n, O);
                                });
                                var u = e.a;
                                return A4(tG, r.j, ZC(t), function(n) {
                                    return m(n, {
                                        hP: Rt,
                                        h3: I,
                                        lk: Ht(u)
                                    });
                                }, function(n) {
                                    return A2(SJ, n, O);
                                });
                            }
                            return Dp;
                        }(), v(r, E, h);
                    }
                    var V = m(R, {
                        pQ: O
                    }), W = r.Q;
                    if (3 === W.$) {
                        var Z, X = W.a, G = FJ(A2(yu, TJ, V.pQ)), J = m(V, {
                            pQ: $(V.pQ, Z = A2(Tc, function(n) {
                                return !A2(QL, TJ(n), G);
                            }, X.pQ))
                        });
                        return v(m(r, {
                            Q: A2(f_, J, oa),
                            bs: Ht(r.bf)
                        }), hY({
                            n0: "conversation-list-container"
                        }), h);
                    }
                    return v(m(r, {
                        Q: A2(f_, V, oa),
                        bs: Ht(r.bf)
                    }), hY({
                        n0: "conversation-list-container"
                    }), h);
                }
                return v(r, Dp, h);
        }
        var Y, Q;
    }), i1 = function(n) {
        return n.pQ;
    }, c1 = F2(function() {
        return ad("");
    }), o1 = {
        $: 3
    }, f1 = {
        $: 20
    }, s1 = {
        $: 17
    }, l1 = function(n) {
        return {
            $: 13,
            a: n
        };
    }, d1 = function(n) {
        return {
            $: 19,
            a: n
        };
    }, b1 = {
        $: 14
    }, v1 = F2(function(n, r) {
        return {
            yR: r.ax || r.br || r.bo,
            T: r.T,
            AM: s1,
            A1: UG,
            A3: l1,
            Bi: d1,
            Bm: b1,
            BU: "",
            V: r.V
        };
    }), m1 = function(n) {
        var r = n.g2;
        return 3 === r.$ ? Ht(ZC(r.a)) : mY(n.j);
    }, p1 = F2(function(n, r) {
        return {
            I: r.I,
            yq: r.g$,
            dd: r.dd,
            AN: AG,
            wT: n
        };
    }), $1 = function(n) {
        var r = n.c6;
        return 3 === r.$ ? r.a.tz : h;
    }, h1 = F2(function(n, r) {
        return A2(zq, n, function(n) {
            return {
                $: 3,
                a: n
            };
        }(r));
    }), g1 = F2(function(n, r) {
        return A2(Ge, function(t) {
            return "Enter" === t ? A2(Ye, function(t) {
                return t ? {
                    se: r,
                    us: !1,
                    wk: !1
                } : {
                    se: n,
                    us: !0,
                    wk: !1
                };
            }, A2(Tu, "shiftKey", xy)) : yy("not enter key");
        }, A2(Tu, "key", w$));
    }), w1 = function(n) {
        return A3(Vj, "svg", $(k([
            A2(Vx, "width", "19"),
            A2(Vx, "height", "16"),
            A2(Vx, "viewBox", "0 0 19 16"),
            A2(Vx, "fill", "none"),
            A2(Vx, "xmlns", "http://www.w3.org/2000/svg")
        ]), n), k([
            A3(Vj, "path", k([
                A2(Vx, "d", "M0 16V0L19 8L0 16ZM2 13L13.85 8L2 3V6.5L8 8L2 9.5V13Z"),
                A2(Vx, "fill", "currentColor")
            ]), h)
        ]));
    }, k1 = F3(function(n, r, t) {
        var e;
        return A2(Ik, k([
            Nk("flex items-center justify-between bg-gray-100 rounded-lg p-2")
        ]), k([
            A2(Ik, k([
                Nk("flex items-center space-x-2")
            ]), k([
                Qj(k([
                    Ij("w-4 h-4 text-gray-600")
                ])),
                A2(Ik, h, k([
                    A2(Ik, k([
                        Nk("text-sm font-medium text-gray-900")
                    ]), k([
                        ad(t.sS)
                    ])),
                    A2(Ik, k([
                        Nk("text-xs text-gray-500")
                    ]), k([
                        ad((e = t.CY, 1024 > e ? ee(e) + " B" : 0 > s(e, 1048576) ? rB(e / 1024) + " KB" : rB(e / 1048576) + " MB"))
                    ]))
                ]))
            ])),
            A2(fz, k([
                pz,
                vz(k([
                    Nk("text-gray-400 hover:text-gray-600")
                ])),
                QS(n(r))
            ]), k([
                Yj(k([
                    Ij("w-4 h-4")
                ]))
            ]))
        ]));
    }), x1 = function(n) {
        var r, t = "" === uF(n.T), e = !ED(n.V), u = ED(n.V) ? ad("") : A2(Ik, k([
            Nk("mb-2 px-2 space-y-2")
        ]), A2(be, k1(n.Bi), n.V)), a = !t || e, i = a ? "text-primary-300" : "text-primary-200";
        return A2(Ik, k([
            Nk("bg-white px-4 py-3")
        ]), k([
            u,
            A2(Ik, k([
                Nk("flex items-center space-x-2")
            ]), k([
                A2(fz, k([
                    pz,
                    vz(k([
                        Nk("text-primary-300 flex-shrink-0")
                    ])),
                    QS(n.AM)
                ]), k([
                    (r = k([
                        Ij("w-4 h-4")
                    ]), A3(Vj, "svg", $(k([
                        A2(Vx, "width", "19"),
                        A2(Vx, "height", "19"),
                        A2(Vx, "viewBox", "0 0 19 19"),
                        A2(Vx, "fill", "none"),
                        A2(Vx, "xmlns", "http://www.w3.org/2000/svg")
                    ]), r), k([
                        A3(Vj, "path", k([
                            A2(Vx, "d", "M8.01995 18.0449V10.0249H0V8.01995H8.01995V0H10.0249V8.01995H18.0449V10.0249H10.0249V18.0449H8.01995Z"),
                            A2(Vx, "fill", "#006CD1")
                        ]), h)
                    ])))
                ])),
                A2(SW, k([
                    jz("chat-input-textarea"),
                    Nk("flex-1 rounded-lg py-2 px-4 text-md bg-chat-gray resize-none overflow-y-auto min-h-0"),
                    oP(n.BU),
                    cU(n.T),
                    tz(n.yR),
                    jW(1),
                    RU(n.A3),
                    A2(h1, "keydown", A2(g1, n.Bm, n.A1))
                ]), h),
                A2(fz, k([
                    ZS(!a),
                    pz,
                    vz(k([
                        Nk(i + " flex-shrink-0")
                    ])),
                    QS(n.Bm)
                ]), k([
                    w1(k([
                        Ij("w-4 h-4")
                    ]))
                ]))
            ]))
        ]));
    }, y1 = wz(0), _1 = xz(3), C1 = qB(4), D1 = function(n) {
        return n.j_.CR;
    }, A1 = function(n) {
        return n.j_.CT;
    }, q1 = F2(function(n, r) {
        if (r.$) return n;
        var t = r.a;
        return A2(Tc, function(n) {
            return !i(n.BK, Ht(t));
        }, n);
    }), B1 = function(n) {
        var r = n.rf ? "w-full max-w-md" : "w-full max-w-md overflow-hidden", t = rz(k([
            b("text-primary-600", !0),
            b("leading-relaxed", !0),
            b("overflow-hidden", !n.rf && n.vO)
        ])), e = !n.rf && n.vO ? k([
            A2(cE, "display", "-webkit-box"),
            A2(cE, "-webkit-line-clamp", "2"),
            A2(cE, "-webkit-box-orient", "vertical"),
            A2(cE, "overflow", "hidden"),
            A2(cE, "word-break", "break-word"),
            A2(cE, "white-space", "normal")
        ]) : h, u = A2(q1, n.tz, n.yC), a = A2(yu, A2(Je, function(n) {
            return n.yT;
        }, uc("Unknown")), u), i = a.b ? a.b.b ? A2(ue, ", ", a) + " " : a.a : "", c = h;
        return A2(lz, k([
            bz(yz),
            bz(kz),
            Qk(k([
                Nk("flex-1 flex-col px-4")
            ]))
        ]), k([
            A2(Ik, A2(Ot, Nk(r), c), k([
                A2(lz, k([
                    PL,
                    Hz,
                    C1,
                    bz(wF),
                    Qk(A2(Ot, t, A2(Ot, jz("participant-header-text"), e)))
                ]), k([
                    ad(i)
                ]))
            ])),
            n.vO && n.rg ? A2(lz, k([
                bz(wF),
                Qk(k([
                    Nk("mt-1")
                ]))
            ]), k([
                A2(jq, k([
                    Nk("text-xs text-primary-400 bg-transparent"),
                    Eq(n.Bo)
                ]), k([
                    ad(n.wT(n.rf ? D1 : A1))
                ]))
            ])) : ad("")
        ]));
    }, j1 = {
        $: 1
    }, S1 = function(n) {
        return "border border-primary-200 rounded px-2 py-2 cursor-pointer " + (ED(n.vE) ? "bg-white" : "bg-info-300");
    }, z1 = F3(function(n, r, t) {
        return ED(r) ? n(Wd) : A2(ue, ", ", A2(yu, function(n) {
            return n.sS;
        }, A2(Tc, function(n) {
            return A2(lA, n.w2, r);
        }, t)));
    }), U1 = function(n) {
        return ED(n.vE) ? "text-primary-500" : "text-white";
    }, E1 = qB(2), P1 = function(n) {
        return {
            $: 2,
            a: n
        };
    }, T1 = F2(function(n, r) {
        var t = A2(lA, r.w2, n);
        return A2(Ik, A2(Ot, Nk("flex space-x-2 p-2 hover:bg-gray-50 cursor-pointer rounded"), $(cx(kz), k([
            Eq(P1(r.w2))
        ]))), k([
            A2(fU, k([
                Nk("rounded border border-gray-300"),
                dz("checkbox"),
                FU(t)
            ]), h),
            A2(hx, k([
                EB
            ]), k([
                ad(r.sS)
            ]))
        ]));
    }), F1 = F2(function(n, r) {
        return A2(lz, k([
            Qk(k([
                Nk("absolute top-full left-0 right-0 bg-white border border-primary-200 rounded mt-1 shadow-lg z-10 max-h-60 overflow-y-auto")
            ]))
        ]), k([
            function() {
                var t = r.BX;
                switch(t.$){
                    case 1:
                        return ad("");
                    case 3:
                        var e = t.a;
                        return A2(lz, k([
                            Qk(k([
                                Nk("p-2")
                            ]))
                        ]), A2(yu, T1(r.vE), e));
                    case 2:
                        return A2(lz, k([
                            Qk(k([
                                Nk("flex py-4")
                            ])),
                            Qk(cx(yz))
                        ]), k([
                            A2(hx, k([
                                EB,
                                E1,
                                Qk(k([
                                    Nk("text-danger-400")
                                ]))
                            ]), k([
                                ad(n(Qd))
                            ]))
                        ]));
                    default:
                        return A2(lz, k([
                            Qk(k([
                                Nk("flex py-4")
                            ])),
                            Qk(cx(yz))
                        ]), k([
                            A2(hx, k([
                                EB,
                                Qk(k([
                                    Nk("text-primary-300")
                                ]))
                            ]), k([
                                ad(n(Zd))
                            ]))
                        ]));
                }
            }()
        ]));
    }), L1 = F2(function(n, r) {
        var t, e;
        return A2(lz, k([
            Qk(k([
                Nk("flex-1 relative dropdown" + (r.bz ? " dropdown--open" : ""))
            ]))
        ]), k([
            A2(Ik, k([
                Nk(S1(r) + " dropdown-toggle"),
                Eq(j1)
            ]), k([
                A2(lz, k([
                    Qk(k([
                        Nk("flex max-w-full space-x-1")
                    ])),
                    Qk(cx(kz)),
                    Qk(cx(_1))
                ]), k([
                    A2(hx, k([
                        EB,
                        Qk(k([
                            Nk(U1(r) + " truncate w-0 flex-1")
                        ]))
                    ]), k([
                        ad(A3(z1, n, r.vE, (e = r.BX, 3 === e.$ ? e.a : h)))
                    ])),
                    A2(lz, k([
                        Qk(k([
                            Nk(U1(r))
                        ]))
                    ]), k([
                        ad((t = r.bz, t ? "\u25B2" : "\u25BC"))
                    ]))
                ]))
            ])),
            r.bz ? A2(F1, n, r) : ad("")
        ]));
    }), M1 = F2(function(n, r) {
        return n.cy ? A2(lz, k([
            Qk(k([
                Nk("bg-white border-b border-primary-200 px-4 py-3 flex relative")
            ])),
            Qk(cx(kz)),
            Qk(cx(_1))
        ]), k([
            A2(lz, k([
                Qk(k([
                    Nk("flex-1 mr-2")
                ]))
            ]), k([
                A2(px, n.Bh, A2(L1, n.wT, n.B5))
            ])),
            function() {
                var r = n.AU;
                if (r.$) return A2(lz, k([
                    C1,
                    Qk(k([
                        Nk("cursor-pointer")
                    ]))
                ]), k([
                    A2(US, k([
                        mz
                    ]), 2)
                ]));
                var t = r.a;
                return A2(Ik, k([
                    Nk("text-primary-300 cursor-pointer"),
                    Eq(t)
                ]), k([
                    A2(US, k([
                        mz
                    ]), 2)
                ]));
            }()
        ])) : A2(lz, k([
            Qk(k([
                Nk("bg-white border-b border-primary-200 py-3 flex min-h-[60px] flex-shrink-0")
            ])),
            Qk(cx(y1)),
            Qk(cx(_1))
        ]), k([
            B1({
                yC: n.yC,
                rf: n.bq,
                rg: n.cz,
                Bo: n.Bp,
                tz: n.tz,
                vO: n.cQ,
                wT: n.wT
            }),
            function() {
                var t = b(n.AU, r);
                if (t.a.$) return A2(lz, k(t.b ? [
                    C1,
                    Qk(k([
                        Nk("cursor-pointer")
                    ]))
                ] : [
                    C1,
                    ZT,
                    Qk(k([
                        Nk("cursor-pointer px-4")
                    ]))
                ]), k([
                    A2(US, k([
                        mz
                    ]), 2)
                ]));
                if (t.b) {
                    var e = t.a.a;
                    return A2(Ik, k([
                        Nk("text-primary-300 text-xl cursor-pointer px-4"),
                        Eq(e)
                    ]), k([
                        A2(US, k([
                            mz
                        ]), 2)
                    ]));
                }
                return e = t.a.a, A2(Ik, k([
                    Nk("text-primary-300 cursor-pointer"),
                    Eq(e)
                ]), k([
                    A2(US, k([
                        mz
                    ]), 2)
                ]));
            }()
        ]));
    }), H1 = F3(function(n, r, t) {
        return A2(A2(yp, n, r), 3, t);
    }), R1 = F3(function(n, r, t) {
        var e = A2(Hc, function(n) {
            return n.CF;
        }, t);
        return we(A3(ce, F2(function(t, e) {
            if (e.b) {
                var u = 1 !== A2(iA, A2(cp, n, e.a.se.CF), A2(cp, n, t.CF));
                return A2(Ot, {
                    se: t,
                    CH: u ? A3(H1, n, r, t.CF) : "",
                    CP: u
                }, e);
            }
            return k([
                {
                    se: t,
                    CH: A3(H1, n, r, t.CF),
                    CP: !0
                }
            ]);
        }), h, e));
    }), O1 = F2(function(n, r) {
        var t = A2(Hc, function(n) {
            return n.CF;
        }, r);
        return function(r) {
            if (r.b) {
                if (r.b.b) {
                    var t = r.a, e = r.b, u = A3(ce, F2(function(r, t) {
                        var e = t.a, u = t.b, a = i(e.se.x_.qU, r.se.x_.qU), c = A2(cp, n, e.se.CF), o = i(r.se.BH, Rt) && i(e.se.BH, Rt) && a && 1 === A2(iA, c, A2(cp, n, r.se.CF)) ? e : m(e, {
                            CO: !0
                        });
                        return b(r, A2(Ot, o, u));
                    }), b(t, h), e), a = u.b, c = m(u.a, {
                        CO: !0
                    });
                    return we(A2(Ot, c, a));
                }
                return k([
                    m(r.a, {
                        CO: !0
                    })
                ]);
            }
            return h;
        }(we(A3(ce, F2(function(r, t) {
            if (t.b) {
                var e = t.a, u = t.b, a = i(e.se.x_.qU, r.x_.qU), c = A2(cp, n, e.se.CF), o = !i(r.BH, Rt) || !i(e.se.BH, Rt);
                return A2(Ot, {
                    x0: r.x_.yT,
                    se: r,
                    CN: o || !a || !(1 === A2(iA, c, A2(cp, n, r.CF))),
                    CO: !1
                }, A2(Ot, e, u));
            }
            return k([
                {
                    x0: r.x_.yT,
                    se: r,
                    CN: !0,
                    CO: !1
                }
            ]);
        }), h, t)));
    }), N1 = F2(function(n, r) {
        if (n.$) return !1;
        var t = r.x_.BK;
        return !t.$ && i(t.a, n.a);
    }), I1 = F2(function(n, r) {
        return r.sC(n);
    }), V1 = F2(function(n, r) {
        return r.sD(n);
    }), W1 = qB(6), Z1 = function(n) {
        return A2(Ik, A2(Ot, Nk("flex py-4"), $(cx(kz), cx(yz))), k([
            A2(lz, k([
                EB,
                W1
            ]), k([
                ad(n)
            ]))
        ]));
    }, X1 = F2(function(n, r) {
        var t = r.BG.yT;
        if (1 === t.$) return h;
        var e = t.a, u = n(r.xF ? V1(e) : I1(e));
        return k([
            Z1(u)
        ]);
    }), G1 = xz(2), J1 = xz(0), Y1 = F2(function(n, r) {
        var t = r ? b(G1, "") : b(J1, "ml-12"), e = t.a;
        return A2(Ik, A2(Ot, Nk("flex my-1 " + t.b), cx(e)), k([
            A2(lz, k([
                Iz,
                W1
            ]), k([
                ad(n)
            ]))
        ]));
    }), Q1 = function(n) {
        return n ? "rounded-tl-[0.7em] rounded-tr-[0.7em] rounded-br-none rounded-bl-[0.7em]" : "rounded-tl-[0.7em] rounded-tr-[0.7em] rounded-br-[0.7em] rounded-bl-none";
    }, K1 = F3(function(n, r, t) {
        return A2(A2(yp, n, r), 4, t);
    }), n0 = {
        $: 2
    }, r0 = function(n) {
        return {
            $: 3,
            a: n
        };
    }, t0 = F2(function(n, r) {
        if (r.$) {
            var t = r.a;
            return A2(gV, k(n ? [
                vV(t.qR),
                mV
            ] : [
                vV(t.qR),
                mV,
                n0,
                r0("hover:text-white focus:text-white")
            ]), k([
                ad(t.o_)
            ]));
        }
        return A2(Gk, h, k([
            ad(r.a)
        ]));
    }), e0 = it(ot), u0 = function(n) {
        return {
            $: 0,
            a: n
        };
    }, a0 = F3(function(n, r, t) {
        if (r.b) {
            var e = r.a, u = r.b, a = function(n) {
                return {
                    $: 1,
                    a: n
                };
            }({
                o_: e.ky,
                qR: (f = e.ky, A2(pu, "http://", f) || A2(pu, "https://", f) ? f : "https://" + f)
            }), i = A3(iu, t, e.kn, n), c = fu(i) ? k([
                a
            ]) : k([
                u0(i),
                a
            ]), o = e.kn + au(e.ky);
            return $(c, A3(a0, n, u, o));
        }
        var f, s = A2(cu, t, n);
        return fu(s) ? h : k([
            u0(s)
        ]);
    }), i0 = A2(uc, Wb, Vb("(?:https?://)?(?:www\\.)?[-a-zA-Z0-9@:%._\\+~#=]{1,256}\\.[a-zA-Z0-9()]{1,6}\\b(?:[-a-zA-Z0-9()@:%_\\+.~#?&/=]*)|https?://[^\\s]+")), c0 = F2(function(n, r) {
        var t, e = A3(a0, t = r, A2(e0, i0, t), 0);
        return A2(yu, t0(n), e);
    }), o0 = F2(function(n, r) {
        return 1 === r.$ ? "" : "overflow-hidden " + Q1(n);
    }), f0 = {
        $: 0,
        a: 2
    }, s0 = {
        jW: h,
        io: 0
    }, l0 = F2(function(n, r) {
        if (n.$) {
            var t = n.a;
            return m(r, {
                jW: $(r.jW, A2(yu, Zk(hu), t))
            });
        }
        return m(r, {
            io: n.a
        });
    }), d0 = F2(function(n, r) {
        var t = A3(ce, l0, s0, n), e = function() {
            switch(t.io){
                case 0:
                case 1:
                    return "bg-gray-100";
                default:
                    return "bg-red-50";
            }
        }();
        return A2(Ik, A2(Ot, Nk("flex items-center space-x-2 p-2 rounded-lg " + e), t.jW), r);
    }), b0 = {
        $: 9
    }, v0 = {
        $: 6
    }, m0 = function(n) {
        return {
            $: 5,
            a: n
        };
    }, p0 = {
        $: 3
    }, $0 = {
        $: 2
    }, h0 = function(n) {
        return {
            $: 8,
            a: n
        };
    }, g0 = F2(function(n, r) {
        return {
            $: 4,
            a: n,
            b: r
        };
    }), w0 = {
        $: 0
    }, k0 = {
        $: 7
    }, x0 = F2(function(n, r) {
        return {
            $: 3,
            a: n,
            b: r
        };
    }), y0 = {
        $: 10
    }, _0 = function(n) {
        return {
            $: 1,
            a: n
        };
    }, C0 = {
        $: 1
    }, D0 = function(n) {
        return {
            $: 2,
            a: n
        };
    }, A0 = {
        $: 1
    }, q0 = {
        $: 2
    }, B0 = F2(function(n, r) {
        return {
            $: 3,
            a: n,
            b: r
        };
    }), j0 = {
        $: 0
    }, S0 = function(n) {
        return {
            $: 1,
            a: n
        };
    }, z0 = XY, U0 = F2(function(n, r) {
        var t = n.f.aI;
        return t.$ ? YQ(n.c) ? "" : r : t.a;
    }), E0 = F4(function(n, r, t, e) {
        if (n > 0 && r > 0 && t > 0) {
            var u = function(n) {
                return s(n, 1024) > -1 ? 400 : 320;
            }(e), a = r / n * t;
            return s(a, u) > 0 || 0 > s(a, 120);
        }
        return !1;
    }), P0 = F4(function(n, r, t, e) {
        var u = v(n, r, t);
        return !!(u.a.$ || u.b.$ || u.c.$) || A4(E0, u.a.a, u.b.a, u.c.a, e);
    }), T0 = F2(function(n, r) {
        return A4(P0, r.f.F, r.f.K, r.b3.cd, n);
    }), F0 = F3(function(n, r, t) {
        return 1 === r.$ || 1 === t.$ ? Rt : Ht(A2(n, r.a, t.a));
    }), L0 = F4(function(n, r, t, e) {
        var u = v(n, r, t);
        if (u.a.$ || u.b.$ || u.c.$) return !1;
        var a = u.a.a, i = u.b.a, c = u.c.a;
        return a > 0 && i > 0 && c > 0 && A4(E0, a, i, c, e);
    }), M0 = F2(function(n, r) {
        return YQ(n.c) ? A2(U0, n, r) : A2(uc, r, n.n);
    }), H0 = F2(function(n, r) {
        return A4(P0, r.y.F, r.y.K, r.b3.cd, n);
    }), R0 = wz(2), O0 = F2(function(n, r) {
        return r.sh(n);
    }), N0 = TL(0), I0 = TL(2), V0 = ir("audio"), W0 = function(n) {
        if (uB(n) || 0 >= n) return "0:00";
        var r = Fe(n), t = A2(qc, 60, r);
        return ee(r / 60 | 0) + ":" + A3(Hb, 2, "0", ee(t));
    }, Z0 = function(n) {
        return n.sf;
    }, X0 = function(n) {
        return n.sg;
    }, G0 = Qk(k([
        Nk("text-white")
    ])), J0 = Vk(0), Y0 = function(n) {
        var r, t = n.AW ? "flex h-2.5 w-full shrink-0 overflow-hidden rounded-full bg-white/25 pointer-events-none" : "flex h-2.5 w-full shrink-0 overflow-hidden rounded-full bg-divider pointer-events-none", e = k(n.AW ? [
            Iz,
            Qk(k([
                Nk("shrink-0 tabular-nums text-white/70")
            ]))
        ] : [
            Iz,
            W1,
            Qk(k([
                Nk("shrink-0 tabular-nums")
            ]))
        ]), u = n.pm > 0 && !uB(n.bf) ? A3(up, 0, 100, n.bf / A2(Me, n.pm, 1) * 100) : 0, a = n.pm > 0, i = A3(Qe, F2(function(r, t) {
            return n.Bk(r / A2(Me, t, 1));
        }), A2(Tu, "offsetX", _$), A2(Zy, k([
            "currentTarget",
            "clientWidth"
        ]), _$)), c = n.wT(n.bU ? Z0 : X0), o = n.AW ? "relative flex w-full flex-col gap-3 bg-white/10 py-2 px-1" : "relative flex w-full flex-col gap-3 bg-white py-2", f = k(n.AW ? [
            EB,
            zV,
            G0,
            Qk(k([
                Nk("truncate")
            ]))
        ] : [
            EB,
            zV,
            Qk(k([
                Nk("truncate text-primary-600")
            ]))
        ]), s = k(n.AW ? [
            Iz,
            Qk(k([
                Nk("text-white/70")
            ]))
        ] : [
            Iz,
            Qk(k([
                Nk("text-gray-500")
            ]))
        ]), l = A2(Ge, function(r) {
            switch(r){
                case "ArrowLeft":
                    return Ke(n.Bj(-0.05));
                case "ArrowRight":
                    return Ke(n.Bj(.05));
                case "Home":
                    return Ke(n.Bk(0));
                case "End":
                    return Ke(n.Bk(1));
                case " ":
                case "Enter":
                    return Ke(n.Bk(n.bf / A2(Me, n.pm, 1)));
                default:
                    return yy("ignore");
            }
        }, A2(Tu, "key", w$)), d = n.xY && !a, v = (r = "h-full min-h-0 rounded-full transition-all duration-100 pointer-events-none", n.AW ? r + " bg-white" : r + " bg-primary"), m = d;
        return A2(lz, k([
            Qk(k([
                Nk(o),
                A2(Wx, "aria-busy", m ? "true" : "false")
            ]))
        ]), k([
            A2(lz, k([
                Qk(A2(Ot, Nk("flex gap-3 px-1"), cx(kz)))
            ]), k([
                A2(lz, k([
                    Qk(A2(Ot, Nk("relative flex h-10 w-10 shrink-0"), $(cx(kz), cx(yz))))
                ]), k([
                    A2(fz, k([
                        nz,
                        _U,
                        QS(n.ti),
                        ZS(d),
                        vz(A2(Ot, dz("button"), A2(Ot, A2(Wx, "aria-label", c), A2(Ot, Nk("h-10 w-10 min-h-0 min-w-0 shrink-0 !p-0"), $(cx(kz), cx(yz))))))
                    ]), k([
                        d ? ad("") : A2(US, k([
                            Sz,
                            $z,
                            Vq("fill-white size-4")
                        ]), n.bU ? 36 : 35)
                    ])),
                    d ? A2(Gk, A2(Ot, Nk("pointer-events-none absolute inset-0 flex [&_.spinner__dot]:bg-white"), A2(Ot, A2(Wx, "aria-hidden", "true"), $(cx(kz), cx(yz)))), k([
                        Jk(k([
                            J0
                        ]))
                    ])) : ad("")
                ])),
                A2(lz, k([
                    Qk(k([
                        Nk("flex min-w-0 flex-1 flex-col")
                    ]))
                ]), k([
                    A2(PB, f, k([
                        ad(n.ki)
                    ])),
                    A2(PB, s, k([
                        ad(W0(n.pm))
                    ]))
                ]))
            ])),
            A2(lz, k([
                Qk(A2(Ot, Nk("flex w-full gap-2 px-1"), cx(kz)))
            ]), k([
                A2(PB, e, k([
                    ad(W0(n.bf))
                ])),
                A2(Ik, k([
                    Nk("min-w-0 flex-1 rounded-sm py-1 outline-none"),
                    rz(k([
                        b("cursor-pointer focus-visible:ring-2 focus-visible:ring-primary-200 focus-visible:ring-offset-2", a),
                        b("pointer-events-none opacity-50", !a)
                    ])),
                    dE(a ? 0 : -1),
                    A2(Wx, "role", "slider"),
                    A2(Wx, "aria-valuemin", "0"),
                    A2(Wx, "aria-valuemax", "100"),
                    A2(Wx, "aria-valuenow", ee(pp(u))),
                    A2(Uq, "click", i),
                    A2(Uq, "keydown", l)
                ]), k([
                    A2(lz, k([
                        Qk(k([
                            Nk(t)
                        ]))
                    ]), k([
                        A2(lz, k([
                            Qk(k([
                                Nk(v),
                                A2(cE, "width", rB(u) + "%")
                            ]))
                        ]), h)
                    ]))
                ])),
                A2(PB, e, k([
                    ad(W0(n.pm))
                ]))
            ])),
            n.xY ? A2(V0, k([
                jz(n.xX),
                TB(n.cS),
                A2(Wx, "preload", "none"),
                Nk("pointer-events-none absolute left-0 top-0 h-px w-px overflow-hidden border-0 p-0 opacity-0"),
                A2(Uq, "play", Ke(n.Bg)),
                A2(Uq, "pause", Ke(n.Bd)),
                A2(Uq, "ended", Ke(n.A0)),
                A2(Uq, "error", Ke(n.tg)),
                A2(Uq, "timeupdate", A3(Qe, n.Bn, A2(Zy, k([
                    "target",
                    "currentTime"
                ]), _$), A2(Zy, k([
                    "target",
                    "duration"
                ]), _$))),
                A2(Uq, "loadedmetadata", A2(Ye, n.A8, A2(Zy, k([
                    "target",
                    "duration"
                ]), _$)))
            ]), h) : ad("")
        ]));
    }, Q0 = function(n) {
        return {
            $: 0,
            a: n
        };
    }, K0 = function(n) {
        return n.si;
    }, n2 = function(n) {
        var r, t = (r = n.An).$ ? h : k([
            A2(Wx, "aria-label", r.a)
        ]), e = n.BA ? "pointer-events-none absolute inset-0 z-[5] min-h-0 min-w-full animate-opacity-pulse bg-black/30" : "block w-full min-w-full max-w-full animate-opacity-pulse bg-chat-gray", u = A2(ue, " ", A2(Tc, A2(sc, bm, fu), k([
            e,
            n.zh
        ])));
        return A2(lz, k([
            Qk(A2(Ot, A2(Wx, "role", "status"), A2(Ot, Nk(u), A2(Ot, A2(Wx, "aria-busy", n.xW ? "true" : "false"), t))))
        ]), h);
    }, r2 = function(n) {
        var r = 1 !== n.BY.$ && n.CU, t = 1 !== n.BY.$ && n.CQ, e = A3(Qe, n.th, A2(Zy, k([
            "target",
            "naturalWidth"
        ]), _$), A2(Zy, k([
            "target",
            "naturalHeight"
        ]), _$)), u = function() {
            var r = n.BY;
            if (1 === r.$) return b("object-contain", "");
            var t = r.a.ta;
            return b(t ? "object-cover" : "object-contain", t ? "" : r.a.z$ ? "object-right" : "object-left");
        }(), a = u.a, i = u.b;
        return A2(lz, k([
            Qk(k([
                Nk("relative flex min-h-0 w-full min-w-0 flex-1 flex-col overflow-hidden")
            ]))
        ]), k([
            n.bm ? n2({
                xW: !0,
                zh: "",
                An: Rt,
                BA: !0
            }) : A2(AB, k([
                TB(n.yU),
                Iq(n.ki),
                Nk(A2(ue, " ", A2(Tc, A2(sc, bm, fu), k([
                    "h-full w-full min-h-0 min-w-0",
                    a,
                    i
                ])))),
                A2(Uq, "error", Ke(n.A2)),
                A2(Uq, "load", e)
            ]), h),
            t && !n.bm ? n2({
                xW: !0,
                zh: "",
                An: Rt,
                BA: !0
            }) : ad(""),
            !r || n.bm || t ? ad("") : A2(lz, k([
                Qk(k([
                    Nk("pointer-events-none absolute inset-x-0 bottom-0 h-16 bg-gradient-to-t from-black/50 to-transparent")
                ]))
            ]), h),
            !r || n.bm || t ? ad("") : A2(lz, k([
                Qk(A2(Ot, Nk("pointer-events-none absolute inset-x-0 bottom-2 flex"), cx(yz)))
            ]), k([
                A2(lz, k([
                    Iz,
                    zV,
                    Qk(k([
                        Nk("rounded-full bg-black/40 px-3 py-1 text-white backdrop-blur-sm")
                    ]))
                ]), k([
                    ad(n.wT(K0))
                ]))
            ]))
        ]));
    }, t2 = ir("video"), e2 = function(n) {
        var r = n.DG ? "h-full min-h-0 w-full object-cover" : "max-h-full min-h-0 w-full object-contain", t = n.z3 ? ad("") : A2(jq, Gi(k([
            k([
                dz("button"),
                Nk("absolute inset-0 z-10 flex cursor-pointer border-none bg-black/30 p-0"),
                Eq(n.ti)
            ]),
            cx(kz),
            cx(yz)
        ])), k([
            A2(lz, k([
                Qk(A2(Ot, Nk("pointer-events-none flex h-12 w-12 shrink-0 rounded-full bg-white p-0 shadow-md ring-1 ring-white"), $(cx(kz), cx(yz))))
            ]), k([
                A2(US, k([
                    mz,
                    Vq("ml-0.5 fill-gray-800")
                ]), 35)
            ]))
        ])), e = A3(Qe, n.Bu, A2(Zy, k([
            "target",
            "videoWidth"
        ]), _$), A2(Zy, k([
            "target",
            "videoHeight"
        ]), _$)), u = n.z3 ? h : k([
            A2(Wx, "muted", "")
        ]), a = n.z3 ? k([
            A2(Wx, "controls", "")
        ]) : h;
        return A2(lz, k([
            Qk(k([
                Nk("relative flex min-h-0 w-full min-w-0 flex-1 flex-col overflow-hidden"),
                rz(k([
                    b("cursor-pointer", !n.z3)
                ]))
            ]))
        ]), k([
            A2(t2, Gi(k([
                k([
                    jz(n.DF),
                    TB(n.cS),
                    Nk("block min-h-0 w-full flex-1 " + r),
                    A2(Wx, "playsinline", ""),
                    A2(Wx, "preload", "metadata"),
                    A2(Uq, "loadedmetadata", e),
                    A2(Uq, "loadeddata", Ke(n.A7)),
                    A2(Uq, "error", Ke(n.Bt))
                ]),
                u,
                a
            ])), h),
            n.CV ? n2({
                xW: !0,
                zh: "",
                An: Rt,
                BA: !0
            }) : ad(""),
            t
        ]));
    }, u2 = function(n) {
        var r = n.CJ, t = $(cx(kz), cx(gz)), e = r.z$ ? "flex w-full cursor-pointer gap-3 border border-gray-200 bg-white px-3 py-2" : "flex w-full cursor-pointer gap-3 border border-white/30 bg-white/10 px-3 py-2 text-white", u = z0(r.zo), a = $(cx(r.z$ ? R0 : y1), cx(gz)), i = r.x2, c = r.ak && uQ(i) ? 4 : i, o = 3 === c || 4 === c, f = !c || 1 === c, s = function() {
            switch(c){
                case 0:
                    return function(n) {
                        var r = function() {
                            var r = n.o$;
                            if (r.$) return h;
                            var t = r.a, e = t.a, u = t.b;
                            return e > 0 && u > 0 ? k([
                                A2(cE, "aspect-ratio", rB(e) + " / " + rB(u))
                            ]) : h;
                        }();
                        return A2(lz, k([
                            Qk(Gi(k([
                                k([
                                    jz(n.ut),
                                    Nk("relative flex min-h-0 w-full min-w-0 max-w-full flex-col overflow-hidden bg-chat-gray min-h-file-preview-image max-h-file-preview-mobile md:max-h-file-preview-desktop")
                                ]),
                                r
                            ])))
                        ]), k([
                            A2(lz, k([
                                Qk(k([
                                    Nk("flex min-h-0 min-w-0 flex-1 flex-col")
                                ]))
                            ]), k([
                                r2({
                                    yU: n.yU,
                                    ki: n.ki,
                                    bm: n.bm,
                                    A2: n.A2,
                                    th: n.th,
                                    BY: Q0({
                                        z$: n.z$,
                                        ta: n.ta
                                    }),
                                    CQ: n.CQ,
                                    CU: n.CU,
                                    wT: n.wT
                                })
                            ]))
                        ]));
                    }({
                        o$: n.f.o$,
                        yU: n.f.yU,
                        ki: u,
                        bm: n.f.bm,
                        z$: r.z$,
                        ta: n.f.ta,
                        A2: r.A9,
                        th: n.f.Bb,
                        ut: r.Ap,
                        CQ: n.f.vQ,
                        CU: n.f.CU,
                        wT: r.wT
                    });
                case 1:
                    return function(n) {
                        var r = function() {
                            var r = n.o$;
                            if (r.$) return h;
                            var t = r.a, e = t.a, u = t.b;
                            return e > 0 && u > 0 ? k([
                                A2(cE, "aspect-ratio", rB(e) + " / " + rB(u))
                            ]) : h;
                        }();
                        return A2(lz, k([
                            Qk(Gi(k([
                                k([
                                    jz(n.ut),
                                    Nk("relative flex min-h-0 w-full min-w-0 max-w-full flex-col overflow-hidden bg-gray-100 min-h-file-preview-image max-h-file-preview-mobile md:max-h-file-preview-desktop")
                                ]),
                                r
                            ])))
                        ]), k([
                            A2(lz, k([
                                Qk(k([
                                    Nk("flex min-h-0 min-w-0 flex-1 flex-col")
                                ]))
                            ]), k([
                                e2({
                                    z3: n.z3,
                                    A7: n.A7,
                                    ti: n.ti,
                                    Bt: n.Bt,
                                    Bu: n.Bu,
                                    CV: n.CV,
                                    cS: n.cS,
                                    DF: n.DF,
                                    DG: n.DG
                                })
                            ]))
                        ]));
                    }({
                        o$: n.y.o$,
                        z3: n.y.b0,
                        A7: n.y.A7,
                        ti: n.y.ti,
                        Bt: n.y.tg,
                        Bu: n.y.th,
                        ut: r.Ap,
                        CV: n.y.vQ,
                        cS: r.cS,
                        DF: n.y.BZ,
                        DG: n.y.ta
                    });
                case 2:
                    return function(n) {
                        var r = cx(n.z$ ? I0 : N0);
                        return A2(lz, k([
                            Qk(A2(Ot, Nk("flex w-full min-w-0 max-w-full flex-col"), r))
                        ]), k([
                            Y0({
                                xX: n.xX,
                                xY: n.xY,
                                bf: n.bf,
                                pm: n.pm,
                                ki: n.ki,
                                bU: n.bU,
                                AW: n.AW,
                                tg: n.tg,
                                A0: n.A0,
                                A8: n.A8,
                                Bd: n.Bd,
                                Bg: n.Bg,
                                Bj: n.Bj,
                                Bk: n.Bk,
                                Bn: n.Bn,
                                ti: n.ti,
                                cS: n.cS,
                                wT: n.wT
                            })
                        ]));
                    }({
                        xX: n.l.bQ,
                        xY: n.l.cD,
                        bf: n.l.bf,
                        pm: n.l.pm,
                        ki: u,
                        z$: r.z$,
                        bU: n.l.bU,
                        AW: !1,
                        tg: n.l.tg,
                        A0: n.l.A0,
                        A8: n.l.A8,
                        Bd: n.l.Bd,
                        Bg: n.l.Bg,
                        Bj: n.l.Bj,
                        Bk: n.l.Bk,
                        Bn: n.l.Bn,
                        ti: n.l.ti,
                        cS: r.cS,
                        wT: r.wT
                    });
                default:
                    return function(n) {
                        return A2(lz, k([
                            Qk(A2(Ot, Nk("flex w-full min-w-0 gap-3 text-primary-600"), cx(kz)))
                        ]), k([
                            A2(lz, k([
                                Qk(A2(Ot, Nk("flex h-12 w-12 shrink-0 rounded-lg bg-primary-100"), $(cx(kz), cx(yz))))
                            ]), k([
                                A2(US, k([
                                    mz,
                                    $z,
                                    Vq("fill-primary-300")
                                ]), 20)
                            ])),
                            A2(lz, k([
                                Qk(A2(Ot, Nk("flex min-w-0 flex-1 flex-col"), $(cx(y1), cx(yz))))
                            ]), k([
                                A2(PB, k([
                                    EB,
                                    zV,
                                    Qk(k([
                                        Nk("w-full truncate text-primary-600")
                                    ])),
                                    Qk(cx(gz))
                                ]), k([
                                    ad(n.ki)
                                ]))
                            ]))
                        ]));
                    }({
                        ki: u
                    });
            }
        }(), l = f || 2 === c ? a : t, d = f ? "relative flex w-full min-w-[240px] max-w-full flex-col cursor-pointer overflow-hidden border-none bg-transparent p-0" : 2 === c ? "flex w-full min-w-[240px] max-w-full flex-col cursor-pointer bg-white px-3 py-2" : o ? "flex w-full min-w-[240px] max-w-full cursor-pointer gap-3 bg-white px-3 py-3 text-primary-600" : e, b = A2(ue, " ", A2(Tc, A2(sc, bm, fu), k([
            d,
            r.DR
        ]))), v = r.wT(O0(u));
        return 1 === c || 2 === c ? A2(lz, k([
            Qk(A2(Ot, Nk(b), l))
        ]), k([
            s
        ])) : A2(jq, A2(Ot, dz("button"), A2(Ot, Nk(b), A2(Ot, Eq(r.Bc(r.dd)), A2(Ot, A2(Wx, "aria-label", v), l)))), k([
            s
        ]));
    }, a2 = function(n) {
        return n.m0;
    }, i2 = function(n) {
        return n.pc;
    }, c2 = function(n) {
        return n.sj;
    }, o2 = function(n) {
        return n.su;
    }, f2 = qB(7), s2 = F3(function(n, r, t) {
        var e;
        return t.bC ? Sq : A5(Ez, t, r, sz(r), (e = uF(n), fu(e) ? Rt : Ht(e)), !0);
    }), l2 = F3(function(n, r, t) {
        return t.bC ? Sq : A3(Dz, Ht(n), t, r);
    }), d2 = {
        $: 1
    }, b2 = function(n) {
        return n.sk;
    }, v2 = F2(function(n, r) {
        return r.sl(n);
    }), m2 = function(n) {
        return n.ss;
    }, p2 = F2(function(n, r) {
        return b(n, r);
    }), $2 = F2(function(n, r) {
        return b(n, r);
    }), h2 = F2(function(n, r) {
        return r.sr(n);
    }), g2 = function(n) {
        return n.st;
    }, w2 = F3(function(n, r, t) {
        var e, u, a = (u = (e = A2(yu, oe, t)).b ? Ht(A3(ce, Me, e.a, e.b)) : Rt).$ ? 0 : u.a, i = A2(Me, A2(Me, oe(r), a), 0);
        if (i) {
            var c = function(n) {
                var r = A2(BE, i, n);
                return $(r, A2(XE, i - oe(r), ""));
            }, o = A2(BE, i, $(r, A2(XE, i, "")));
            return {
                hu: A2(be, F2(function(r, t) {
                    var e = uF(t);
                    return fu(e) ? n(r + 1) : e;
                }), o),
                iz: A2(yu, c, t)
            };
        }
        return {
            hu: h,
            iz: h
        };
    }), k2 = F2(function(n, r) {
        return b(n, r);
    }), x2 = ir("caption"), y2 = function(n) {
        return n.$ ? cx(n.a) : n.a;
    }, _2 = function(n) {
        return A2(yu, Zk(hu), A2(Ji, y2, n));
    }, C2 = ir("th"), D2 = function(n) {
        var r = n.a, t = n.b;
        return A2(C2, A2(Ot, Nk("c-table__header"), _2(r)), k([
            ad(t)
        ]));
    }, q2 = function(n) {
        var r = n.a, t = n.b;
        return A2(EE, A2(Ot, Nk("c-table__cell"), _2(r)), t);
    }, B2 = function(n) {
        var r = n.a, t = n.b;
        return A2(SE, A2(Ot, Nk("c-table__row"), _2(r)), A2(yu, q2, t));
    }, j2 = F3(function(n, r, t) {
        return A2(JE, k([
            Nk("c-table")
        ]), $(function() {
            if (n.$) return h;
            var r = n.a;
            return k([
                A2(x2, k([
                    Nk("sr-only")
                ]), k([
                    ad(r)
                ]))
            ]);
        }(), k([
            A2(QE, h, k([
                A2(SE, h, A2(yu, D2, r))
            ])),
            A2(YE, h, A2(yu, B2, t))
        ])));
    }), S2 = F3(function(n, r, t) {
        var e = A3(w2, function(r) {
            return n(h2(ee(r)));
        }, t.hu, t.iz), u = A2(lz, k([
            Qk(k([
                Nk("flex min-h-0 min-w-0 flex-1 items-center justify-center px-3 py-4 text-xs text-primary-500 sm:px-4 sm:py-8 sm:text-sm")
            ]))
        ]), k([
            ad(n(g2))
        ]));
        return ED(e.hu) && ED(e.iz) ? u : A2(lz, k([
            Qk(A2(Ot, Nk("flex min-h-0 min-w-0 flex-1 flex-col bg-white"), cx(gz)))
        ]), k([
            A2(lz, k([
                Qk(k([
                    Nk("relative max-h-full min-h-0 min-w-0 flex-1 overflow-auto")
                ]))
            ]), k([
                A3(j2, r, A2(yu, function(n) {
                    return A2($2, h, n);
                }, e.hu), A2(yu, function(n) {
                    return A2(k2, h, A2(yu, function(n) {
                        return A2(p2, h, k([
                            ad(n)
                        ]));
                    }, n));
                }, e.iz))
            ]))
        ]));
    }), z2 = F3(function(n, r, t) {
        return n ? k([
            A2(Wx, "aria-busy", "true"),
            A2(Wx, "aria-label", r(t))
        ]) : h;
    }), U2 = function(n) {
        return A2(lz, k([
            Qk(A2(Ot, Nk(n.Bz), A3(z2, n.CS, n.wT, n.Ad)))
        ]), k([
            n.n1,
            n.CS ? n2({
                xW: !0,
                zh: "",
                An: Ht(n.wT(n.Ae)),
                BA: !0
            }) : ad("")
        ]));
    }, E2 = function(n) {
        return n.sm;
    }, P2 = function(n) {
        return n.sn;
    }, T2 = F2(function(n, r) {
        return r.so(n);
    }), L2 = function(n) {
        return {
            $: 1,
            a: n
        };
    }, M2 = ir("iframe"), H2 = function(n) {
        return n.sp;
    }, R2 = function(n) {
        return n.sq;
    }, O2 = function(n) {
        switch(n.$){
            case 0:
                return k([
                    A2(Wx, "scale", rB(n.a))
                ]);
            case 1:
                return k([
                    A2(Wx, "width", ee(n.a))
                ]);
            case 2:
                return k([
                    A2(Wx, "height", ee(r = n.a))
                ]);
            default:
                var r = n.b;
                return k([
                    A2(Wx, "width", ee(n.a)),
                    A2(Wx, "height", ee(r))
                ]);
        }
    }, N2 = function(n) {
        switch(n.$){
            case 0:
                return "Scale" + rB(n.a);
            case 1:
                return "Width" + ee(n.a);
            case 2:
                return "Height" + ee(r = n.a);
            default:
                var r = n.b;
                return "WidthHeight" + ee(n.a) + "," + ee(r);
        }
    }, I2 = F3(function(n, r, t) {
        return A3($U, "span", h, k([
            b($(n, $(ee(r), N2(t))), A3(Mj, "pdf-element", $(k([
                A2(Wx, "name", n),
                A2(Wx, "page", ee(r))
            ]), O2(t)), h))
        ]));
    }), V2 = function(n) {
        return A2(hx, k([
            EB,
            f2,
            Qk(k([
                Nk("leading-5")
            ]))
        ]), k([
            ad(n.wT(o2))
        ]));
    }, W2 = function(n) {
        return n.sv;
    }, Z2 = function(n) {
        return n.sw;
    }, X2 = F3(function(n, r, t) {
        return A2(t.sx, n, r);
    }), G2 = F2(function(n, r) {
        return r.sy(n);
    }), J2 = F2(function(n, r) {
        return 1 > n ? 0 : A2(Wv, A2(Me, 0, r), n - 1);
    }), Y2 = function(n) {
        return n.sz;
    }, Q2 = function(n) {
        return n.sA;
    }, K2 = F2(function(n, r) {
        return r.sB(n);
    }), n3 = function(n) {
        var r = A2(lz, k([
            Qk(k([
                Nk("flex min-h-0 min-w-0 max-w-full flex-1 flex-col")
            ]))
        ]), k([
            V2({
                wT: n.wT
            })
        ]));
        switch(OB(n.yW.zf)){
            case "docx":
                return function(n) {
                    if (3 === n.n1.$) return ad("");
                    var r, t = function(n) {
                        switch(n.$){
                            case 2:
                                return fu(n.a);
                            case 1:
                            case 0:
                                return !0;
                            default:
                                return !1;
                        }
                    }(n.n1), e = 2 === (r = n.n1).$ ? fu(r.a) ? ad("") : A2(lz, k([
                        Qk(k([
                            jz(n.dq),
                            Nk("document-container"),
                            A2(Wx, "aria-label", n.wT(T2(n.ki)))
                        ]))
                    ]), h) : ad("");
                    return U2({
                        n1: A2(lz, k([
                            Qk(A2(Ot, Nk("min-h-0 flex-1"), cx(gz)))
                        ]), k([
                            e
                        ])),
                        Ad: E2,
                        Ae: P2,
                        Bz: "pg-viewer-wrapper relative flex h-full min-h-0 min-w-0 w-full max-h-full flex-1 flex-col overflow-y-auto overflow-x-hidden rounded-lg bg-white shadow-2xl pointer-events-auto",
                        CS: t,
                        wT: n.wT
                    });
                }({
                    n1: n.yW.ez,
                    ki: n.ki,
                    dq: n.yW.dq,
                    wT: n.wT
                });
            case "pdf":
                var t = n.yW.fa;
                return t.$ ? r : function(n) {
                    if (n.BQ.$) {
                        var r = i(n.B$, Rt) || function(n) {
                            switch(n.BQ.$){
                                case 0:
                                case 3:
                                case 5:
                                    return !1;
                                default:
                                    return !0;
                            }
                        }(n), t = function() {
                            var r = b(n.B$, n.BQ);
                            if (r.a.$ || 3 !== r.b.$) return A2(lz, k([
                                Qk(k([
                                    Nk("min-h-0 min-w-0 w-full flex-1 overflow-y-auto overflow-x-hidden bg-white")
                                ]))
                            ]), h);
                            var t = r.b.a;
                            return 1 > t || 1 > n.BR ? ad("") : A2(lz, k([
                                Qk(k([
                                    Nk("min-h-0 min-w-0 w-full flex-1 overflow-y-auto overflow-x-hidden bg-white")
                                ]))
                            ]), A2(yu, function(r) {
                                return A2(lz, k([
                                    Qk(k([
                                        Nk(A2(ue, " ", k([
                                            "flex w-full justify-center border-b border-primary-200 py-3",
                                            i(r, t) ? "last:border-b-0 last:pb-6" : ""
                                        ])))
                                    ]))
                                ]), k([
                                    A3(I2, n.yV, r, L2(n.BR))
                                ]));
                            }, A2(de, 1, t)));
                        }(), e = function() {
                            var r = n.B$;
                            if (r.$) return ad("");
                            var t = r.a, e = i(n.BQ, CK) ? "" : "opacity-0";
                            return A2(lz, k([
                                Qk(k([
                                    Nk("flex min-h-0 min-w-0 w-full flex-1 flex-col overflow-hidden")
                                ]))
                            ]), k([
                                A2(M2, k([
                                    TB(t + "#zoom=FitH"),
                                    Nk("h-full min-h-0 w-full min-w-0 flex-1 border-0 " + e),
                                    A2(Uq, "load", Ke(n.AY)),
                                    A2(Uq, "error", Ke(n.AX))
                                ]), h)
                            ]));
                        }();
                        return U2({
                            n1: A2(lz, k([
                                Qk(k([
                                    Nk("flex min-h-0 min-w-0 w-full flex-1 flex-col overflow-hidden")
                                ]))
                            ]), k([
                                n.DD ? t : e
                            ])),
                            Ad: R2,
                            Ae: H2,
                            Bz: "file-viewer-pdf-lightbox relative flex h-full min-h-0 min-w-0 w-full flex-1 flex-col overflow-hidden rounded-lg bg-white shadow-2xl pointer-events-auto",
                            CS: r,
                            wT: n.wT
                        });
                    }
                    return ad("");
                }(t.a);
            case "csv":
                var e = n.yW.ev;
                if (e.$) return r;
                var u = e.a;
                return function(n) {
                    switch(n.n1.$){
                        case 3:
                        case 0:
                            return ad("");
                        default:
                            var r = function() {
                                var r = n.n1;
                                if (2 === r.$) {
                                    var t = r.a;
                                    return A3(S2, n.wT, Ht(n.wT(v2(n.ki))), t);
                                }
                                return ad("");
                            }(), t = function(n) {
                                switch(n.$){
                                    case 2:
                                    case 3:
                                        return !1;
                                    default:
                                        return !0;
                                }
                            }(n.n1);
                            return U2({
                                n1: A2(lz, k([
                                    Qk(k([
                                        Nk("flex min-h-0 min-w-0 w-full flex-1 flex-col gap-2")
                                    ]))
                                ]), k([
                                    r
                                ])),
                                Ad: m2,
                                Ae: b2,
                                Bz: "relative flex h-full min-h-0 min-w-0 w-full max-h-full flex-1 flex-col gap-2 overflow-hidden rounded-lg bg-white shadow-2xl pointer-events-auto",
                                CS: t,
                                wT: n.wT
                            });
                    }
                }({
                    n1: u.n1,
                    ki: u.ki,
                    wT: n.wT
                });
            case "xlsx":
                var a = n.yW.fS;
                if (a.$) return r;
                var c = a.a;
                return function(n) {
                    switch(n.n1.$){
                        case 3:
                        case 0:
                            return ad("");
                        default:
                            var r = function(n) {
                                switch(n.$){
                                    case 2:
                                    case 3:
                                        return !1;
                                    default:
                                        return !0;
                                }
                            }(n.n1), t = function() {
                                var r = n.n1;
                                if (2 === r.$) {
                                    var t = r.a, e = A2(J2, oe(t), n.CL), u = oe(t) > 1 ? A2(lz, k([
                                        Qk(k([
                                            Nk("sheet-names flex w-full flex-col items-start gap-1 px-3 pt-2 sm:flex-row sm:flex-wrap sm:items-start")
                                        ]))
                                    ]), A2(be, F2(function(r, t) {
                                        return A2(fz, k([
                                            pz,
                                            QS(n.Bl(r)),
                                            vz(k([
                                                Nk("w-full justify-start text-left !ml-0 rounded-none sm:w-auto"),
                                                rz(k([
                                                    b("font-semibold", i(r, e)),
                                                    b("opacity-80 hover:bg-gray-50 hover:opacity-100", !i(r, e))
                                                ]))
                                            ]))
                                        ]), k([
                                            ad(t.sS)
                                        ]));
                                    }), t)) : ad(""), a = ED(t) ? A2(lz, k([
                                        Qk(k([
                                            Nk("flex items-center justify-center px-4 py-8 text-sm text-primary-500")
                                        ]))
                                    ]), k([
                                        ad(n.wT(W2))
                                    ])) : ad(""), c = Gb(A2(zp, e, t));
                                    return v(u, a, function() {
                                        if (c.$) return ad("");
                                        var r = c.a, t = {
                                            hu: r.hu,
                                            iz: r.iz
                                        }, e = fu(uF(r.sS)) ? n.wT(G2(n.ki)) : n.wT(A2(X2, n.ki, r.sS));
                                        return A3(S2, n.wT, Ht(e), t);
                                    }());
                                }
                                return v(ad(""), ad(""), ad(""));
                            }(), e = t.a, u = t.b, a = t.c;
                            return U2({
                                n1: A2(lz, k([
                                    Qk(k([
                                        Nk("flex min-h-0 min-w-0 w-full flex-1 flex-col gap-2")
                                    ]))
                                ]), k([
                                    e,
                                    u,
                                    A2(lz, k([
                                        Qk(k([
                                            Nk("min-h-0 min-w-0 w-full flex-1")
                                        ]))
                                    ]), k([
                                        a
                                    ]))
                                ])),
                                Ad: m2,
                                Ae: Z2,
                                Bz: A2(ue, " ", k([
                                    "spreadsheet-viewer relative flex h-full min-h-0 min-w-0 w-full max-h-full flex-1 flex-col gap-2 overflow-hidden rounded-lg shadow-2xl pointer-events-auto",
                                    r ? "" : "bg-white"
                                ])),
                                CS: r,
                                wT: n.wT
                            });
                    }
                }({
                    n1: c.n1,
                    ki: c.ki,
                    Bl: c.Bl,
                    CL: c.CL,
                    wT: n.wT
                });
            case "xml":
                var o = n.yW.fT;
                if (o.$) return r;
                var f = o.a;
                return function(n) {
                    switch(n.n1){
                        case 3:
                        case 0:
                            return ad("");
                        default:
                            var r = function(n) {
                                switch(n){
                                    case 2:
                                    case 3:
                                        return !1;
                                    default:
                                        return !0;
                                }
                            }(n.n1), t = n.wT(K2(n.ki)), e = Gi(k([
                                k([
                                    rz(k([
                                        b("xml-preview min-h-0 w-full flex-1 overflow-auto p-3 text-sm text-primary-dark", !0),
                                        b("bg-white", !r),
                                        b("px-4 py-8", r)
                                    ])),
                                    jz(n.dq)
                                ]),
                                r ? h : k([
                                    A2(Wx, "aria-label", t)
                                ])
                            ]));
                            return U2({
                                n1: A2(lz, k([
                                    Qk(k([
                                        Nk("flex min-h-0 min-w-0 w-full flex-1 flex-col")
                                    ])),
                                    bz(gz)
                                ]), k([
                                    A2(lz, k([
                                        Qk(e)
                                    ]), h)
                                ])),
                                Ad: Q2,
                                Ae: Y2,
                                Bz: "relative flex h-full min-h-0 min-w-0 w-full max-h-full flex-1 flex-col gap-2 overflow-hidden rounded-lg bg-white shadow-2xl pointer-events-auto",
                                CS: r,
                                wT: n.wT
                            });
                    }
                }({
                    n1: f.n1,
                    ki: f.ki,
                    dq: f.dq,
                    wT: n.wT
                });
            default:
                return r;
        }
    }, r3 = function(n) {
        switch(n.yg){
            case 0:
                return r2({
                    yU: n.zJ,
                    ki: n.ki,
                    bm: n.bm,
                    A2: n.A2,
                    th: n.th,
                    BY: d2,
                    CQ: !1,
                    CU: !1,
                    wT: n.wT
                });
            case 3:
                var r = n.yW;
                return r.$ ? V2({
                    wT: n.wT
                }) : n3({
                    yW: r.a,
                    ki: n.ki,
                    wT: n.wT
                });
            default:
                return V2({
                    wT: n.wT
                });
        }
    }, t3 = function(n) {
        if (n.h) return function(n) {
            return A3(s2, "modal__content--file-viewer-unsupported", k([
                jZ(k([
                    A2(lz, k([
                        OL,
                        PL,
                        Qk(k([
                            Nk("text-black pr-2 leading-6")
                        ]))
                    ]), k([
                        ad(n.wT(c2))
                    ]))
                ])),
                IS(k([
                    A2(hx, k([
                        EB,
                        f2,
                        Qk(k([
                            Nk("leading-5")
                        ]))
                    ]), k([
                        ad(n.wT(o2))
                    ]))
                ])),
                XS(k([
                    A2(lz, k([
                        Qk(k([
                            Nk("flex w-full flex-wrap gap-3 sm:flex-nowrap")
                        ])),
                        bz(G1)
                    ]), k([
                        A2(fz, k([
                            CU,
                            QS(n.AT)
                        ]), k([
                            ad(n.wT(a2))
                        ])),
                        A2(fz, k([
                            nz,
                            QS(n.A_)
                        ]), k([
                            ad(n.wT(i2))
                        ]))
                    ]))
                ]))
            ]), n.e1);
        }({
            e1: n.e1,
            AT: n.AT,
            A_: n.A$,
            wT: n.wT
        });
        var r, t = 3 === (r = b(n.yg, n.yW)).a && !r.b.$;
        return A2(t ? l2("modal-wrap--file-viewer") : Pz(1), k([
            WS,
            IS(k([
                A2(lz, k([
                    Qk(k([
                        Nk(t ? "p-5 sm:p-8 md:p-12 flex h-full min-h-0 w-full min-w-0 flex-1 flex-col items-stretch justify-start overflow-hidden pointer-events-none" : "flex h-full min-h-0 w-full min-w-0 flex-1 flex-col items-center justify-center pointer-events-none")
                    ]))
                ]), k([
                    r3({
                        yg: n.yg,
                        yW: n.yW,
                        ki: n.B_,
                        bm: n.bm,
                        zJ: n.zK,
                        A2: n.A2,
                        th: n.th,
                        wT: n.wT
                    })
                ]))
            ]))
        ]), n.e1);
    }, e3 = F6(function(n, r, t, e, u, a) {
        var c = A2(H0, e, a), o = z0(a.c.af), f = YQ(a.c), s = A4(L0, a.f.F, a.f.K, a.b3.cd, e), l = !a.ak && f && (a.f.bm || i(a.f.aI, Rt)), d = A2(T0, e, a), b = a.dd > 0 ? a.dd : e, v = A2(Me, 1, b - 32), m = b > 0 && 1024 > b, p = nQ(a.c), $ = !p && !a.ak && !l && i(a.f.F, Rt), g = 1 === p && !a.ak && !a.y.dA;
        return A2(lz, h, k([
            u2({
                l: {
                    bf: a.l.bf,
                    pm: a.l.pm,
                    bQ: kQ(a.k),
                    bU: a.l.bU,
                    cD: a.l.cD,
                    tg: $Q(b0),
                    A0: $Q(v0),
                    A8: A2(sc, $Q, m0),
                    Bd: $Q(p0),
                    Bg: $Q($0),
                    Bj: A2(sc, $Q, h0),
                    Bk: A2(sc, $Q, pQ),
                    Bn: F2(function(n, r) {
                        return $Q(A2(g0, n, r));
                    }),
                    ti: $Q(w0)
                },
                f: {
                    o$: A3(F0, nC, a.f.F, a.f.K),
                    yU: A2(U0, a, u),
                    bm: l,
                    ta: d,
                    Bb: F2(function(n, r) {
                        return xY(A2(x0, n, r));
                    }),
                    vQ: $,
                    CU: s && !p
                },
                CJ: {
                    k: a.k,
                    x2: p,
                    zo: a.c.af,
                    dd: e,
                    z$: r,
                    ak: a.ak,
                    Ap: yK(a.k),
                    A9: GG(y0),
                    Bc: A2(sc, GG, _0),
                    cS: u,
                    wT: n,
                    DR: A2(o0, r, t)
                },
                y: {
                    o$: A3(F0, nC, a.y.F, a.y.K),
                    ta: c,
                    tg: D0(A0),
                    A7: D0(q0),
                    th: F2(function(n, r) {
                        return D0(A2(B0, n, r));
                    }),
                    ti: D0(j0),
                    b0: a.y.b0,
                    BZ: MK(a.k),
                    vQ: g
                }
            }),
            t3({
                yg: p,
                yW: cJ(a) ? Ht({
                    ev: Rt,
                    ez: a.B,
                    zf: aJ(a.c),
                    dq: OQ(a),
                    fa: Rt,
                    fS: Rt,
                    fT: Rt
                }) : fJ(a.c) && !a.h ? Ht({
                    ev: Rt,
                    ez: NY,
                    zf: aJ(a.c),
                    dq: "",
                    fa: Ht({
                        yV: KQ(a),
                        AX: GG(y0),
                        AY: YG(C0),
                        BQ: a.p,
                        BR: v,
                        B$: a.n,
                        wT: n,
                        DD: m
                    }),
                    fS: Rt,
                    fT: Rt
                }) : mJ(a.c) && !a.h ? Ht({
                    ev: Ht({
                        n1: a.u,
                        ki: o
                    }),
                    ez: NY,
                    zf: aJ(a.c),
                    dq: "",
                    fa: Rt,
                    fS: Rt,
                    fT: Rt
                }) : pJ(a.c) && !a.h ? Ht({
                    ev: Rt,
                    ez: NY,
                    zf: aJ(a.c),
                    dq: "",
                    fa: Rt,
                    fS: Ht({
                        n1: a.v,
                        ki: o,
                        Bl: A2(sc, vJ, S0),
                        CL: a.r
                    }),
                    fT: Rt
                }) : kJ(a.c) && !a.h ? Ht({
                    ev: Rt,
                    ez: NY,
                    zf: aJ(a.c),
                    dq: "",
                    fa: Rt,
                    fS: Rt,
                    fT: Ht({
                        n1: a.w,
                        ki: o,
                        dq: lK(a)
                    })
                }) : Rt,
                bm: l,
                zK: A2(M0, a, u),
                e1: a.b,
                AT: GG(RY),
                A$: GG(k0),
                A2: GG(y0),
                th: F2(function(n, r) {
                    return xY(A2(x0, n, r));
                }),
                B_: o,
                h: a.h,
                wT: n
            })
        ]));
    }), u3 = F5(function(n, r, t, e, u) {
        var a = u.cS;
        switch(a.$){
            case 3:
                return A6(e3, n, r, t, e, a.a, u);
            case 0:
                return A6(e3, n, r, t, e, "", u);
            case 1:
                return A2(Ik, k([
                    Nk(A2(ue, " ", A2(Tc, A2(sc, bm, fu), k([
                        "h-24 w-full min-w-[240px] max-w-xs animate-opacity-pulse bg-chat-gray",
                        A2(o0, r, t)
                    ])))),
                    A2(Wx, "role", "status")
                ]), h);
            default:
                var i = nQ(u.c);
                return A2(Ik, k([
                    Nk(A2(ue, " ", A2(Tc, A2(sc, bm, fu), k([
                        "w-full",
                        A2(o0, r, t)
                    ]))))
                ]), k([
                    A2(d0, k([
                        f0
                    ]), k([
                        A2(US, k([
                            Sz,
                            Vq("text-red-600")
                        ]), 9),
                        A2(PB, k([
                            EB,
                            E1
                        ]), k([
                            ad(n(i ? Gd : Jd))
                        ]))
                    ]))
                ]));
        }
    }), a3 = F5(function(n, r, t, e, u) {
        var a = t + "_" + u, i = A2(Zu, a, n.I);
        if (i.$) return ad("");
        var c = i.a;
        return A2(px, n.AN(a), A5(u3, n.wT, r, e, n.dd, c));
    }), i3 = F5(function(n, r, t, e, u) {
        var a;
        return ED(u.zq) ? ad("") : A2(Ik, k([
            Nk(A2(ue, " ", A2(Tc, A2(sc, bm, fu), k([
                "w-full min-w-0 max-w-message-attachments",
                "bg-transparent",
                "space-y-2",
                r ? "ml-auto" : "",
                t && !e ? "mt-2" : ""
            ]))))
        ]), (a = oe(u.zq), A2(be, F2(function(t, e) {
            return A5(a3, n, r, u.qU, Ht({
                kn: t,
                Du: a
            }), e);
        }), u.zq)));
    }), c3 = F6(function(n, r, t, e, u, a) {
        var i, c = a.$ ? "" : "ml-12", o = A2(N1, e, u), f = o ? G1 : J1, s = function() {
            var n = u.Di;
            if (1 === n.$) return ad("");
            var r = n.a;
            return fu(uF(r)) ? ad("") : A2(lz, k([
                PL,
                Qk(k([
                    Nk("whitespace-pre-line")
                ]))
            ]), A2(c0, o, r));
        }(), l = o ? "bg-info-200 text-primary-600 " : "bg-primary-500 text-white ", d = o ? G1 : J1, b = A2(Ik, A2(Ot, Nk("flex opacity-70 mb-2 " + c), cx(d)), k([
            A2(lz, k([
                Iz,
                W1
            ]), k([
                ad(A3(K1, r, t, u.CF))
            ]))
        ])), v = 1 !== (i = u.Di).$ && !fu(uF(i.a)), m = !ED(u.zq), p = a.$ ? "flex mb-1" : "flex mb-1 items-end space-x-2", h = "w-fit max-w-lg flex flex-col overflow-hidden p-2 " + $(l, Q1(o)), g = function() {
            if (v && m) {
                var r = "flex w-full " + (o ? "justify-end" : "justify-start");
                return A2(Ik, k([
                    Nk(A2(ue, " ", A2(Tc, A2(sc, bm, fu), k([
                        "flex w-full min-w-0 max-w-lg flex-col gap-4",
                        o ? "ml-auto" : ""
                    ]))))
                ]), k([
                    A2(Ik, k([
                        Nk(r)
                    ]), k([
                        A2(Ik, k([
                            Nk(h)
                        ]), k([
                            s
                        ]))
                    ])),
                    A2(Ik, k([
                        Nk(r)
                    ]), k([
                        A5(i3, n, o, !1, !0, u)
                    ]))
                ]));
            }
            return A2(Ik, k([
                Nk(m ? "flex w-full min-w-0 max-w-lg flex-col bg-transparent p-0" : h)
            ]), k([
                s,
                A5(i3, n, o, v, !1, u)
            ]));
        }();
        return A2(Ik, k([
            Nk("flex flex-col")
        ]), k([
            A2(Ik, A2(Ot, Nk(p), cx(f)), k(a.$ ? [
                g
            ] : [
                a.a,
                g
            ])),
            b
        ]));
    }), o3 = F5(function(n, r, t, e, u) {
        return A6(c3, n, r, t, e, u, Rt);
    }), f3 = function(n) {
        return k(n.trim().split(/\s+/g));
    }, s3 = function(n) {
        var r, t = A2(uc, "text-primary-600", n.Dj), e = (r = n.x6).$ ? "" : "border " + r.a, u = A2(ue, " ", k([
            "w-10 h-10 rounded-full flex",
            A2(uc, "bg-info-200", n.x1),
            e
        ])), a = $(cx(kz), cx(yz));
        return A2(Ik, A2(Ot, Nk(u), a), k([
            n.z0 ? A2(US, k([
                Vq("text-white")
            ]), 30) : A2(lz, k([
                EB,
                zV,
                Qk(k([
                    Nk(t)
                ]))
            ]), k([
                ad(n.zP)
            ]))
        ]));
    }, l3 = F2(function(n, r) {
        var t = !A2(N1, n, r.se) && r.CO, e = function(n) {
            if (n.$) return "?";
            var r, t = n.a;
            return r = A2(ue, "", A2(yu, A2(Je, su(1), lv), A2(BE, 2, f3(t)))), fu(r) ? "?" : r;
        }(r.se.x_.yT);
        return A2(Ik, k([
            Nk("flex-shrink-0 w-10 flex items-end")
        ]), k([
            t ? s3({
                x1: Ht("bg-light-divider"),
                x6: Ht("border-light-divider"),
                zP: e,
                z0: !1,
                Dj: Ht("text-gray-600")
            }) : A2(Ik, k([
                Nk("w-10 h-10")
            ]), h)
        ]));
    }), d3 = F5(function(n, r, t, e, u) {
        var a = A2(N1, e, u.se) ? Rt : Ht(A2(l3, e, u));
        return A6(c3, n, r, t, e, u.se, a);
    }), b3 = F6(function(n, r, t, e, u, a) {
        var c = a.CP ? k([
            Z1(a.CH)
        ]) : h, o = a.se, f = o.BH;
        if (f.$) {
            var s = Gb(A2(Tc, function(n) {
                return i(n.se.qU, o.qU);
            }, u)), l = function() {
                if (s.$) return k([
                    A5(o3, n, r, t, e, o)
                ]);
                var u = s.a, a = k([
                    A5(d3, n, r, t, e, u)
                ]);
                return $(u.CN && !A2(N1, e, u.se) ? k([
                    A2(Y1, A2(uc, "", u.x0), A2(N1, e, u.se))
                ]) : h, a);
            }();
            return $(c, l);
        }
        return $(c, A2(X1, n.wT, f.a));
    }), v3 = F5(function(n, r, t, e, u) {
        var a = A3(R1, r, t, u.pQ), i = A2(O1, r, u.pQ);
        return A2(Ik, k([
            jz("messages-content"),
            Nk("flex flex-col")
        ]), A2(Ji, A5(b3, n, r, t, e, i), a));
    }), m3 = function(n) {
        var r = "relative flex-1 overflow-y-auto bg-chat-gray p-4 space-y-4 min-h-0";
        return A2(lz, k([
            Qk(k([
                Nk(n.bV ? r + " overflow-hidden invisible pointer-events-none " : r),
                jz("messages-container")
            ]))
        ]), k([
            function() {
                var r = n.aL;
                switch(r.$){
                    case 1:
                    default:
                        return ad("");
                    case 3:
                        return A5(v3, n.Az, n.fL, n.bf, n.yC, r.a);
                    case 2:
                        return A2(lz, k([
                            Qk(k([
                                Nk("flex justify-center py-2")
                            ]))
                        ]), k([
                            A2(hx, k([
                                EB,
                                E1
                            ]), k([
                                ad(n.wT(Yd))
                            ]))
                        ]));
                }
            }()
        ]));
    }, p3 = function(n) {
        var r = "relative flex-1 overflow-y-auto bg-chat-gray p-4 space-y-4 min-h-0";
        return A2(lz, k([
            Qk(k([
                Nk(n.bV ? r + " overflow-hidden invisible pointer-events-none " : r),
                jz("messages-container")
            ]))
        ]), k([
            function() {
                var r = n.aL;
                switch(r.$){
                    case 1:
                    default:
                        return ad("");
                    case 3:
                        return A5(v3, n.Az, n.fL, n.bf, n.yC, r.a);
                    case 2:
                        return A2(lz, k([
                            Qk(k([
                                Nk("flex py-2")
                            ])),
                            Qk(cx(yz))
                        ]), k([
                            A2(hx, k([
                                EB,
                                E1
                            ]), k([
                                ad(n.wT(Yd))
                            ]))
                        ]));
                }
            }()
        ]));
    }, $3 = F4(function(n, r, t, e) {
        var u;
        return (u = {
            ym: A2(v1, n, r),
            yC: m1(r),
            bf: r.bf,
            bp: r.bp,
            cy: r.cy,
            bq: r.bq,
            cz: r.cz,
            bV: r.bV,
            Az: A2(p1, n, r),
            aL: r.aL,
            AU: t,
            Bh: FG,
            Bp: f1,
            tz: $1(r),
            B5: r.bx,
            cQ: r.cQ,
            fL: r.fL,
            wT: n,
            fR: e
        }).fR ? function(n) {
            return A2(lz, k([
                Qk(k([
                    Nk("h-full bg-divider flex flex-col")
                ]))
            ]), k([
                A2(M1, n, !0),
                m3(n),
                x1(n.ym)
            ]));
        }(u) : function(n) {
            var r = !i(n.AU, Rt);
            return A2(lz, k([
                Qk(k([
                    Nk("w-full h-full flex flex-col relative")
                ]))
            ]), k([
                A2(lz, k([
                    Qk(k([
                        Nk("flex-shrink-0 z-10 bg-white")
                    ]))
                ]), k([
                    A2(M1, n, r)
                ])),
                p3(n),
                A2(lz, k([
                    Qk(k([
                        Nk("flex-shrink-0 z-10 bg-white border-t border-primary-200")
                    ]))
                ]), k([
                    x1(n.ym)
                ]))
            ]));
        }(u);
    }), h3 = F2(function(n, r) {
        return A2(lz, k([
            Qk(k([
                Nk("h-full bg-white flex flex-col")
            ]))
        ]), k([
            A4($3, n, r, Ht(o1), r.fR)
        ]));
    }), g3 = function(n) {
        return A2(lz, k([
            Qk(k([
                Nk("flex p-8")
            ])),
            Qk(cx(kz)),
            Qk(cx(yz))
        ]), k([
            A2(lz, k([
                Qk(k([
                    Nk("space-y-2")
                ])),
                Qk(cx(wF))
            ]), k([
                A2(hx, k([
                    PL,
                    Hz
                ]), k([
                    ad(n(tb))
                ])),
                A2(hx, k([
                    EB,
                    Lz
                ]), k([
                    ad(n(eb))
                ]))
            ]))
        ]));
    }, w3 = F2(function(n, r) {
        return A2(iV, k([
            UZ(8)
        ]), k([
            A2(lz, k([
                Qk(k([
                    Nk("bg-white rounded-md h-[60vh] min-h-96 overflow-hidden")
                ]))
            ]), k([
                function() {
                    var t = v(r.Q, r.a6, r.X);
                    if (3 === t.a.$) {
                        if (t.b.$) return t.c.$ ? (u = i1(t.a.a), ED(u) ? A2(lz, k([
                            Qk(k([
                                Nk("h-full flex")
                            ])),
                            Qk(cx(kz)),
                            Qk(cx(yz))
                        ]), k([
                            g3(n)
                        ])) : function(n) {
                            return A2(lz, k([
                                Qk(k([
                                    Nk("flex h-full p-8")
                                ])),
                                Qk(cx(kz)),
                                Qk(cx(yz))
                            ]), k([
                                A2(lz, k([
                                    Qk(k([
                                        Nk("space-y-2")
                                    ])),
                                    Qk(cx(wF))
                                ]), k([
                                    A2(hx, k([
                                        PL,
                                        Hz
                                    ]), k([
                                        ad(n(Kd))
                                    ])),
                                    A2(hx, k([
                                        EB,
                                        Lz
                                    ]), k([
                                        ad(n(nb))
                                    ]))
                                ]))
                            ]));
                        }(n)) : A2(px, aG, A2(h3, n, t.c.a));
                        if (t.c.$) {
                            var e = t.b.a, u = i1(t.a.a);
                            return ED(u) ? g3(n) : A2(c1, n, e);
                        }
                        return A2(px, aG, A2(h3, n, t.c.a));
                    }
                    return A2(lz, k([
                        Qk(k([
                            Nk("h-full flex")
                        ])),
                        Qk(cx(kz)),
                        Qk(cx(yz))
                    ]), k([
                        g3(n)
                    ]));
                }()
            ]))
        ]));
    }), k3 = {
        $: 7
    }, x3 = function(n) {
        return A2(lz, k([
            Qk(k([
                Nk("px-2 pb-8 flex w-full")
            ])),
            Qk(cx(kz)),
            Qk(cx(_1))
        ]), k([
            A2(lz, h, h),
            A2(XT, k([
                rx
            ]), k([
                ad(n(ub))
            ])),
            A2(Ik, k([
                Nk("text-primary-300 cursor-pointer"),
                Eq(k3)
            ]), k([
                A2(lz, k([
                    C1
                ]), k([
                    A2(US, k([
                        mz
                    ]), 29)
                ]))
            ]))
        ]));
    }, y3 = function(n) {
        return {
            $: 1,
            a: n
        };
    }, _3 = F3(function(n, r, t) {
        return A2(A2(yp, n, r), 2, t);
    }), C3 = F4(function(n, r, t, e) {
        var u = e.a.tz, a = e.a.rs, i = a.$ ? "" : a.a.C_, c = a.$ ? "" : A3(_3, n, r, a.a.CF), o = function(n) {
            return n.a.rk;
        }(e), f = 3 === t.$ ? Ht(ZC(t.a)) : Rt, s = A2(q1, u, f), l = A2(ue, ", ", A2(Ep, ru, A2(yu, function(n) {
            return n.yT;
        }, s))), d = oe(s) > 1, b = TJ(e), v = function() {
            if (d) return "";
            var n = Gb(s);
            if (n.$) return "?";
            var r = n.a.yT;
            return r.$ ? "?" : A2(su, 1, r.a);
        }();
        return A2(Ik, k([
            Nk("p-4 cursor-pointer bg-white md:bg-transparent"),
            Eq(y3(b))
        ]), k([
            A2(lz, k([
                Qk(k([
                    Nk("flex space-x-3")
                ])),
                Qk(cx(kz))
            ]), k([
                A2(lz, k([
                    Qk(k([
                        Nk("flex space-x-2")
                    ])),
                    Qk(cx(kz))
                ]), k([
                    A2(lz, k([
                        Qk(k([
                            Nk("w-3 flex-shrink-0")
                        ]))
                    ]), k([
                        o ? A2(lz, k([
                            Qk(k([
                                Nk("w-3 h-3 bg-primary-300 rounded-full")
                            ]))
                        ]), h) : ad("")
                    ])),
                    s3({
                        x1: Rt,
                        x6: Rt,
                        zP: v,
                        z0: d,
                        Dj: Rt
                    })
                ])),
                A2(lz, k([
                    Qk(k([
                        Nk("flex-1 min-w-0")
                    ]))
                ]), k([
                    A2(lz, k([
                        Qk(k([
                            Nk("flex mb-1")
                        ])),
                        Qk(cx(_1)),
                        Qk(cx(kz))
                    ]), k([
                        A2(lz, k([
                            EB,
                            Hz,
                            Qk(k([
                                Nk("truncate")
                            ]))
                        ]), k([
                            ad(l)
                        ])),
                        A2(lz, k([
                            Iz,
                            W1,
                            Qk(k([
                                Nk("ml-2 flex-shrink-0")
                            ]))
                        ]), k([
                            ad(c)
                        ]))
                    ])),
                    A2(lz, k([
                        EB,
                        W1,
                        Qk(k([
                            Nk("line-clamp-2")
                        ]))
                    ]), k([
                        ad(i)
                    ]))
                ]))
            ]))
        ]));
    }), D3 = function(n) {
        return A2(lz, k([
            Qk(k([
                Nk("text-center p-8")
            ]))
        ]), k([
            A2(hx, k([
                PL,
                Hz,
                Qk(k([
                    Nk("mb-2")
                ]))
            ]), k([
                ad(n(rb))
            ]))
        ]));
    }, q3 = A2(TS, PS(3), Ht(3)), B3 = function(n) {
        return k([
            A2(mx, k([
                LS(q3)
            ]), k([
                ad(n)
            ]))
        ]);
    }, j3 = function(n) {
        return A2(lz, k([
            Qk(k([
                Nk("flex py-8")
            ])),
            Qk(cx(yz))
        ]), B3(n(Xd)));
    }, S3 = F3(function(n, r, t) {
        var e = t.Q;
        switch(e.$){
            case 1:
                return ad("");
            case 3:
                var u = i1(e.a);
                return ED(u) ? A2(lz, k([
                    Qk(k([
                        Nk("h-full flex flex-col bg-white")
                    ])),
                    Qk(cx(kz)),
                    Qk(cx(yz))
                ]), k([
                    D3(n)
                ])) : A2(lz, A2(Ot, Qk(k([
                    Nk("h-full overflow-y-auto")
                ])), r ? k([
                    Qk(k([
                        jz("conversation-list-container")
                    ]))
                ]) : h), A2(yu, A3(C3, t.fL, t.bf, t.tE), u));
            case 2:
                return A2(lz, k([
                    Qk(k([
                        Nk("h-full flex flex-col")
                    ])),
                    Qk(cx(kz)),
                    Qk(cx(yz))
                ]), k([
                    j3(n)
                ]));
            default:
                return A2(lz, k([
                    Qk(k([
                        Nk("h-full flex flex-col")
                    ])),
                    Qk(cx(kz)),
                    Qk(cx(yz))
                ]), k([
                    ad("")
                ]));
        }
    }), z3 = F2(function(n, r) {
        return A2(iV, k([
            UZ(4)
        ]), k([
            A2(lz, k([
                Qk(k([
                    Nk("bg-white rounded-md h-[60vh] min-h-96 overflow-y-auto")
                ]))
            ]), k([
                A3(S3, n, !0, r)
            ]))
        ]));
    }), U3 = F2(function(n, r) {
        return A2(lz, k([
            Qk(k([
                Nk("flex flex-col max-h-[calc(100vh-12rem)] w-full")
            ]))
        ]), k([
            x3(n),
            A2(lz, k([
                Qk(k([
                    Nk("w-full flex-1 flex")
                ]))
            ]), k([
                A2(lV, k([
                    jV(k([
                        Nk("w-full")
                    ]))
                ]), k([
                    A2(z3, n, r),
                    A2(w3, n, r)
                ]))
            ]))
        ]));
    }), E3 = F2(function(n, r) {
        return A2(lz, k([
            Qk(k([
                Nk("fixed inset-0 z-50 bg-divider flex flex-col overflow-hidden")
            ]))
        ]), k([
            A2(lz, k([
                Qk(k([
                    Nk("flex-1 min-h-0")
                ]))
            ]), k([
                A2(px, aG, A2(h3, n, r))
            ]))
        ]));
    }), P3 = F2(function() {
        return ad("");
    }), T3 = function(n) {
        return A2(lz, k([
            Qk(k([
                Nk("px-4 pb-4 flex")
            ])),
            Qk(cx(kz)),
            Qk(cx(_1))
        ]), k([
            A2(lz, k([
                Qk(h)
            ]), h),
            A2(XT, k([
                rx
            ]), k([
                ad(n(ub))
            ])),
            A2(Ik, k([
                Nk("text-primary-300 cursor-pointer"),
                Eq(k3)
            ]), k([
                A2(lz, k([
                    C1
                ]), k([
                    A2(US, k([
                        mz
                    ]), 29)
                ]))
            ]))
        ]));
    }, L3 = F2(function(n, r) {
        var t;
        return 3 === (t = r.Q).$ && ED(i1(t.a)) ? A2(lz, k([
            Qk(k([
                Nk("w-full h-screen flex flex-col")
            ]))
        ]), k([
            T3(n),
            A2(lz, k([
                Qk(k([
                    Nk("flex-1 flex bg-white")
                ])),
                Qk(cx(kz)),
                Qk(cx(yz))
            ]), k([
                D3(n)
            ]))
        ])) : A2(lz, k([
            Qk(k([
                Nk("w-full h-full flex flex-col")
            ]))
        ]), k([
            T3(n),
            A2(lz, k([
                Qk(k([
                    Nk("max-h-[calc(100vh-12rem)] min-h-96 overflow-y-auto"),
                    jz("conversation-list-container")
                ]))
            ]), k([
                A3(S3, n, !1, r)
            ]))
        ]));
    }), M3 = F2(function(n, r) {
        var t;
        return A2(lz, h, k([
            (t = b(r.a6, r.X), 1 === t.a.$ ? 1 === t.b.$ ? A2(L3, n, r) : A2(E3, n, t.b.a) : t.b.$ ? A2(P3, n, t.a.a) : A2(E3, n, t.b.a))
        ]));
    }), H3 = F2(function(n, r) {
        var t = 1024 > r.d2;
        return {
            gF: k([
                A2(lz, k([
                    Qk(k([
                        Nk("bg-gray-100 w-full")
                    ]))
                ]), k([
                    A2(t ? M3 : U3, n, r)
                ]))
            ]),
            wD: n(ub)
        };
    }), R3 = Ux({
        zO: LX,
        Ab: eG,
        Ct: uG,
        Dd: function(n) {
            var r, t = CG(F2(function(n) {
                return EX(n);
            })), e = A2(_G, 1e4, cG), u = DG(iG), a = (r = n.X).$ ? yk : A2(xD, aG, function(n) {
                var r, t = A2(_G, 1e4, TG), e = xk(A2(yu, function(n) {
                    var r = n.b;
                    return A2(xD, AG(n.a), function(n) {
                        return xk(k([
                            A2(xD, A2(sc, GG, QG), _D()),
                            oJ(n),
                            hJ(n),
                            yJ(n),
                            rJ(n.b) && fJ(n.c) && !n.h && gJ(n) ? dJ(A2(Je, JG, YG)) : yk
                        ]));
                    }(r));
                }, It(n.I)));
                return xk(k([
                    DG(EG),
                    (r = zG, ZG(A2(Je, WG, r))),
                    A2(xD, PG, CJ),
                    LG(A2(Je, By(RG), A2(Je, Wp(SG), Qm(UG)))),
                    A2(xD, FG, jJ(n.bx)),
                    OG(qG),
                    XG(BG),
                    CG(F2(function(n) {
                        return jG(n);
                    })),
                    t,
                    e
                ]));
            }(r.a));
            return xk(k([
                u,
                a,
                t,
                e
            ]));
        },
        DB: a1,
        DH: H3
    }), O3 = function(n) {
        return {
            $: 0,
            a: n
        };
    }, N3 = function(n) {
        return {
            $: 2,
            a: n
        };
    }, I3 = {
        $: 0
    }, V3 = function(n) {
        return {
            $: 4,
            a: n
        };
    }, W3 = F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    }), Z3 = A2(W3, 1, h), X3 = F3(function(n, r, t) {
        return b({
            gx: r,
            g0: Rt,
            aq: I3,
            ac: Z3,
            rd: n,
            h$: !1,
            BW: t,
            wD: Rt
        }, A2(Eu, V3, vy));
    }), G3 = {
        $: 0
    }, J3 = F3(function(n, r, t) {
        return {
            gx: n,
            aB: G3,
            e9: h,
            BW: t,
            jx: r
        };
    }), Y3 = function(n) {
        return n.fb.AO;
    }, Q3 = function(n) {
        return n.fb.te;
    }, K3 = function(n) {
        return n.fb.AP;
    }, n9 = function(n) {
        return n.fb.ij;
    }, r9 = F2(function(n, r) {
        return m(r, {
            wD: Ht(n)
        });
    }), t9 = F4(function(n, r, t, e) {
        return {
            xC: A3(J3, r.gx, r.jx, $k(n)),
            gx: r.gx,
            g4: 0,
            kj: r.kj,
            b$: A2(r9, n9, e),
            dw: n,
            jx: r.jx,
            w_: t
        };
    }), e9 = A2(IC, 0, A2(qy, lN, Ke(VO))), u9 = F3(function(n, r, t) {
        return A4(dC, n, Ey(e9), t, bC(bN(r)));
    }), a9 = F3(function(n, r, t) {
        var e = A3(X3, !1, r.gx, $k(n)), u = e.b;
        return b(A4(t9, n, r, t, e.a), Hu(k([
            A3(u9, r.gx, $k(n), O3),
            A2(jp, N3, u)
        ])));
    }), i9 = F2(function(n, r) {
        return b(r, Dp);
    }), c9 = F2(function(n, r) {
        return m(r, {
            xE: Ht(4)
        });
    }), o9 = function(n) {
        return {
            $: 3,
            a: n
        };
    }, f9 = function(n) {
        return {
            $: 2,
            a: n
        };
    }, s9 = function(n) {
        return {
            $: 3,
            a: n
        };
    }, l9 = function(n) {
        return n.aB.$ ? xk(k([
            wD(cD(f9)),
            A2(xD, s9, _D())
        ])) : yk;
    }, d9 = F2(function(n, r) {
        return {
            $: 3,
            a: n,
            b: r
        };
    }), b9 = function(n) {
        return {
            $: 5,
            a: n
        };
    }, v9 = A2(Ge, function(n) {
        return "Enter" === n || "Escape" === n ? Ke(aD(n)) : yy("nothing");
    }, A2(Tu, "key", w$)), m9 = function(n) {
        return A2(Ye, n, v9);
    }, p9 = function(n) {
        var r = n.aq;
        if (r.$) {
            var t = r.b;
            return xk(k([
                wD(m9(d9(b(t.a, t.b)))),
                A2(xD, b9, _D())
            ]));
        }
        return yk;
    }, $9 = function(n) {
        return {
            $: 1,
            a: n
        };
    }, h9 = function(n) {
        return n.aF.o8;
    }, g9 = function(n) {
        return n.w9;
    }, w9 = F2(function(n, r) {
        var t = r.aF.ey, e = jN(r.kk), u = k([
            b("signature", mk(e.dP)),
            b("version_number", hq(g9(t)))
        ]);
        return vk(n ? A2(Ot, b("id", mk(h9(r))), u) : u);
    }), k9 = F3(function(n, r, t) {
        var e = $k(t), u = h9(r);
        return A5(mN, n, e, u, A2(w9, !1, r), $9);
    }), x9 = F2(function(n, r) {
        return r.o7(n);
    }), y9 = function(n) {
        return n.a.sS;
    }, _9 = function(n) {
        return {
            $: 4,
            a: n
        };
    }, C9 = {
        $: 0
    }, D9 = F3(function(n, r, t) {
        return {
            $: 1,
            a: n,
            b: r,
            c: t
        };
    }), q9 = function(n) {
        return n.a.o8;
    }, B9 = F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    }), j9 = function(n) {
        return n.pa;
    }, S9 = function(n) {
        return n.qU;
    }, z9 = function(n) {
        return 1 === n.$ ? mc(m(n.a, {
            aE: !1
        })) : bc(m(n.a, {
            aE: !1
        }));
    }, U9 = F2(function(n, r) {
        return A2($y, k([
            "documents",
            r
        ]), gy(n));
    }), E9 = F3(function(n, r, t) {
        return A2($y, k([
            "document_versions",
            t
        ]), A2(U9, n, r));
    }), P9 = A2(Tu, "url", w$), T9 = F5(function(n, r, t, e, u) {
        return A4(dC, z9(n), P9, u, bC(A2($y, k([
            "signed_file_url"
        ]), A3(E9, r, t, e))));
    }), L9 = F5(function(n, r, t, e, u) {
        return b({
            gx: n,
            ey: u,
            kT: t,
            ie: e,
            BW: r,
            iM: oc
        }, 1 === j9(u) ? A5(T9, n, r, t, S9(u), B9(!1)) : Dp);
    }), M9 = function(n) {
        return n.rH;
    }, H9 = function(n) {
        if (2 === n.$ && 6 === n.a.$) {
            var r = n.a;
            return k([
                A3(WD, r.a, r.b, r.c)
            ]);
        }
        return h;
    }, R9 = F2(function(n, r) {
        if (n.$) return v(r, function() {
            switch(j9(r.ey)){
                case 0:
                    return Dp;
                case 2:
                    return QQ(A2(uc, "", M9(r.ey)));
                default:
                    return A5(T9, r.gx, r.BW, r.kT, S9(r.ey), B9(!0));
            }
        }(), Rt);
        var t, e = n.a, u = n.b, a = MD(u);
        return v(m(r, {
            iM: u
        }), (t = b(e, a)).a && !t.b.$ ? QQ(t.b.a) : Dp, function() {
            if (2 === u.$) {
                var n = u.a;
                return Ht($(H9(u), k([
                    tA(n)
                ])));
            }
            return Rt;
        }());
    }), O9 = F2(function(n, r) {
        switch(n.$){
            case 0:
                return v(m(r, {
                    aB: G3
                }), Dp, Rt);
            case 1:
                var t = y9(d = n.a), e = q9(d), u = d.a.v_, a = A2(ny, 0, C9), i = a.a, c = a.b, o = u.$ ? b(Rt, Dp) : A2(wk, Ht, A5(L9, r.gx, r.BW, e, t, u.a)), f = o.b;
                return v(m(r, {
                    aB: A3(D9, i, d, x = o.a)
                }), Hu(k([
                    c,
                    A2(jp, _9, f)
                ])), Rt);
            case 2:
                return v(1 === n.a ? m(r, {
                    aB: G3
                }) : r, Dp, Rt);
            case 4:
                var s = n.a, l = r.aB;
                if (l.$) {
                    i = l.a;
                    var d = l.b, p = l.c;
                    if (p.$) return v(r, Dp, Rt);
                    var $ = A2(R9, s, x = p.a), h = $.b, g = $.c;
                    return v(m(r, {
                        aB: A3(D9, i, d, Ht($.a))
                    }), A2(jp, _9, h), A2(Xb, function(n) {
                        return Ht(n);
                    }, g));
                }
                return v(r, Dp, Rt);
            default:
                s = n.a;
                var w = r.aB;
                if (w.$) {
                    d = w.b;
                    var x = w.c, y = A2(mq, s, i = w.a);
                    return c = y.b, v(m(r, {
                        aB: A3(D9, y.a, d, x)
                    }), A2(jp, s9, c), Rt);
                }
                return v(r, Dp, Rt);
        }
    }), N9 = function(n) {
        return {
            $: 2,
            a: n
        };
    }, I9 = F2(function(n, r) {
        return {
            $: 2,
            a: n,
            b: r
        };
    }), V9 = F2(function(n, r) {
        return {
            $: 1,
            a: n,
            b: r
        };
    }), W9 = function(n) {
        return {
            $: 0,
            a: n
        };
    }, Z9 = {
        $: 1
    }, X9 = function(n) {
        return A2(ue, "-", k([
            "document-input",
            h9(n)
        ]));
    }, G9 = Jn("scrollIdToBottom", mk), J9 = F3(function(n, r, t) {
        return A2(yu, function(t) {
            return n(t) ? r(t) : t;
        }, t);
    }), Y9 = F3(function(n, r, t) {
        return A3(J9, n, rm(r), t);
    }), Q9 = F3(function(n, r, t) {
        var e = t.b;
        return A2(W3, t.a, A3(Y9, function(n) {
            return i(r, n.a);
        }, b(r, n), e));
    }), K9 = {
        $: 0
    }, n6 = {
        $: 1
    }, r6 = {
        $: 2
    }, t6 = function(n) {
        return {
            $: 3,
            a: n
        };
    }, e6 = function(n) {
        return i(n.eO, Ht(n6));
    }, u6 = F2(function(n, r) {
        return m(r, {
            dP: n
        });
    }), a6 = F2(function(n, r) {
        return A3(WI, u6, n, r);
    }), i6 = function(n) {
        return n.R.xB;
    }, c6 = function(n) {
        return n.R.yN;
    }, o6 = function(n) {
        return n.R.j8;
    }, f6 = function(n) {
        return n.R.yP;
    }, s6 = function(n) {
        return n.R.zV;
    }, l6 = function(n) {
        return n.R.zW;
    }, d6 = function(n) {
        return n.R.At;
    }, b6 = function(n) {
        return n.R.kA;
    }, v6 = function(n) {
        return n.R.AE;
    }, m6 = function(n) {
        return n.R.B1;
    }, p6 = function(n) {
        return n.R.B2;
    }, $6 = function(n) {
        return n.R.B3;
    }, h6 = function(n) {
        return n.R.Cn;
    }, g6 = function(n) {
        return n.R.vY;
    }, w6 = function(n) {
        return n.R.wY;
    }, k6 = function(n) {
        return n.$ ? l6 : s6;
    }, x6 = function(n) {
        return 1 === n;
    }, y6 = function(n) {
        return uF(A3(pv, rI("\\s\\s+"), rm(" "), n));
    }, _6 = F2(function(n, r) {
        var t = r;
        return i(OB(y6(n)), OB(y6(t)));
    }), C6 = F2(function(n, r) {
        return !r.$ && A2(_6, n, r.a);
    }), D6 = F2(function(n, r) {
        return A2(_6, n, r);
    }), q6 = F2(function(n, r) {
        var t = r.kU, e = r.dP;
        if (x6(r.lz)) {
            var u = e;
            return !(A2(D6, u, t) || A2(C6, u, n));
        }
        return !1;
    }), B6 = F2(function(n, r) {
        return A2(q6, n, r) ? k([
            b(0, aI(k6(n)))
        ]) : h;
    }), j6 = F2(function(n, r) {
        var t = A2(wI, function(n) {
            return ZN(k([
                B6(n)
            ]));
        }(n), r);
        return t.$ ? b(t.a, !1) : b(t.a.a, !0);
    }), S6 = F2(function(n, r) {
        switch(n.$){
            case 0:
                var t = (l = A2(a6, n.a, r.kk), e6(r) ? A2(j6, r.bh, l).a : l);
                return v(m(r, {
                    kk: t
                }), Dp, Rt);
            case 1:
                var e = A2(j6, r.bh, r.kk), u = (t = e.a, e.b ? b(1, K9) : b(0, n6)), a = u.b;
                return v(m(r, {
                    c$: u.a,
                    kk: t,
                    eO: Ht(a)
                }), Dp, Ht(a));
            case 2:
                return v(m(r, {
                    c$: 0,
                    kk: A2(a6, "", r.kk),
                    eO: Ht(r6)
                }), Dp, Ht(r6));
            default:
                var i = n.a, c = r.cq;
                if (c.$) return v(r, Dp, Rt);
                var o = A2(R9, i, c.a), f = o.b, s = o.c;
                return v(m(r, {
                    cq: Ht(o.a)
                }), A2(jp, t6, f), A2(Xb, function(n) {
                    return Ht(function(n) {
                        return {
                            $: 3,
                            a: n
                        };
                    }(n));
                }, s));
        }
        var l;
    }), z6 = F3(function(n, r, t) {
        var e = r.a, u = A2(S6, t, r.b), a = u.a, i = u.b, c = u.c, o = A2(ny, 0, W9(b(e, a))), f = o.b, s = m(n, {
            aq: A2(V9, o.a, b(e, a)),
            ac: A3(Q9, a, e, n.ac)
        });
        if (c.$) return v(s, Hu(k([
            G9(X9(a)),
            A2(jp, I9(b(e, a)), i)
        ])), Rt);
        switch(c.a.$){
            case 0:
                return v(m(s, {
                    aq: I3
                }), Hu(k([
                    f,
                    A2(jp, I9(b(e, a)), i)
                ])), Ht(function(n) {
                    return {
                        $: 0,
                        a: n
                    };
                }(b(e, a))));
            case 2:
                return v(m(s, {
                    aq: I3
                }), Dp, Ht(N9(b(e, a))));
            case 1:
                return v(s, Hu(k([
                    G9(X9(a)),
                    A2(jp, I9(b(e, a)), i)
                ])), Ht(function(n) {
                    return {
                        $: 3,
                        a: n
                    };
                }(b(e, a))));
            default:
                var l = c.a.a;
                return v(s, Hu(k([
                    G9(X9(a)),
                    A2(jp, I9(b(e, a)), i)
                ])), Ht(function(n) {
                    return {
                        $: 4,
                        a: n
                    };
                }(l)));
        }
    }), U6 = F2(function(n, r) {
        switch(n.$){
            case 0:
                var t = n.a, e = t.a, u = t.b;
                return v(m(r, {
                    aq: I3
                }), Dp, Ht(N9(b(e, u))));
            case 1:
                var a = n.a, i = (e = a.a, function(n) {
                    var r = A5(L9, n.gx, n.BW, n.aF.o8, n.aF.sS, n.aF.ey), t = r.b;
                    return b(m(n, {
                        cq: Ht(r.a)
                    }), A2(jp, t6, t));
                }(u = a.b)), c = i.a, o = i.b, f = A2(ny, 0, W9(b(e, c))), s = f.b;
                return v(m(r, {
                    aq: A2(V9, f.a, b(e, c))
                }), Hu(k([
                    s,
                    A2(jp, I9(b(e, c)), o)
                ])), Ht(function(n) {
                    return {
                        $: 1,
                        a: n
                    };
                }(b(e, u))));
            case 5:
                var l = n.a, d = r.aq;
                if (d.$) {
                    var p = d.b, $ = (e = p.a, u = p.b, A2(mq, l, d.a)), h = $.b;
                    return v(m(r, {
                        aq: A2(V9, $.a, b(e, u))
                    }), A2(jp, b9, h), Rt);
                }
                return v(r, Dp, Rt);
            case 3:
                var g = n.a;
                switch(e = g.a, u = g.b, n.b){
                    case 0:
                        return A3(z6, r, b(e, u), Z9);
                    case 1:
                        return v(m(r, {
                            aq: I3
                        }), Dp, Ht(N9(b(e, u))));
                    default:
                        return v(r, Dp, Rt);
                }
            case 2:
                var w = n.a;
                return l = n.b, A3(z6, r, b(e = w.a, u = w.b), l);
            default:
                return v(m(r, {
                    g0: Ht(n.a)
                }), Dp, Rt);
        }
    }), E6 = function(n) {
        return 1 !== n.a.wj;
    }, P6 = function(n) {
        var r = n.a;
        return !!r.lH && !!r.wj;
    }, T6 = F4(function(n, r, t, e) {
        return {
            gx: n,
            aB: G3,
            e9: r,
            BW: e,
            jx: t
        };
    }), L6 = F2(function(n, r) {
        var t = r.a;
        return A2(W3, t + 1, $(r.b, k([
            b(t, n)
        ])));
    }), M6 = function(n) {
        return A3(ce, F2(function(n, r) {
            return A2(L6, n, r);
        }), Z3, n);
    }, H6 = function(n) {
        return n.a.lz;
    }, R6 = function(n) {
        return n.a.ow;
    }, O6 = function(n) {
        return {
            lz: n.lz,
            kU: n.kU,
            dP: ""
        };
    }, N6 = F3(function(n, r, t) {
        return {
            c$: 0,
            gx: n,
            bh: Rt,
            aF: t,
            cq: Rt,
            kk: AO(O6(t)),
            eO: Rt,
            BW: r
        };
    }), I6 = function(n) {
        return n.a.vd;
    }, V6 = function(n) {
        return function(n) {
            return n.sS;
        }(n.a.v$);
    }, W6 = F3(function(n, r, t) {
        var e, u = {
            ly: (e = t, e.a.ly),
            lz: H6(t),
            o8: q9(t),
            ey: R6(t),
            eL: I6(t),
            sS: y9(t),
            kU: V6(t)
        };
        return A3(N6, n, r, u);
    }), Z6 = F2(function(n, r) {
        return m(r, {
            ac: M6(A2(yu, A2(W6, r.gx, r.BW), n))
        });
    }), X6 = F2(function(n, r) {
        var t = A2(Z6, function(n) {
            return A2(Tc, P6, n);
        }(n), r.b$), e = A4(T6, r.gx, function(n) {
            return A2(Tc, E6, n);
        }(n), r.jx, $k(r.dw));
        return m(r, {
            xC: e,
            g4: 1,
            b$: t
        });
    }), G6 = F2(function(n, r) {
        switch(n.$){
            case 0:
                var t = n.a;
                return 3 === t.$ ? v(A2(X6, t.a, r), Dp, h) : v(r, Dp, A2(uA, 0, t));
            case 1:
                var e = n.a;
                if (3 === e.$) {
                    var u = e.a;
                    return v(r, A3(u9, r.gx, $k(r.dw), O3), k([
                        A2(nA, 3, x9(y9(u)))
                    ]));
                }
                return v(r, Dp, A2(uA, 0, e));
            case 2:
                var a = A2(U6, n.a, r.b$), i = a.a, c = (s = a.c).$ || s.a.$ ? A2(jp, N3, a.b) : A3(k9, r.gx, s.a.a.b, r.dw);
                return v(m(r, {
                    b$: i
                }), c, h);
            default:
                var o = A2(O9, n.a, r.xC), f = o.b, s = o.c;
                return v(m(r, {
                    xC: o.a
                }), A2(jp, o9, f), A2(uc, h, A2(Cp, function(n) {
                    return n;
                }, s)));
        }
    }), J6 = function(n) {
        return ED(n.e9);
    }, Y6 = function(n) {
        return ED(n.b);
    }, Q6 = function(n) {
        return Y6(n.ac);
    }, K6 = {
        $: 0
    }, n4 = function(n) {
        return {
            $: 1,
            a: n
        };
    }, r4 = KS(4), t4 = function(n) {
        return n.a.vZ;
    }, e4 = F2(function(n, r) {
        var t = t4(r);
        return t.$ ? " " : A2(n, 1, t.a);
    }), u4 = F2(function(n, r) {
        var t = t4(r);
        return t.$ ? " " : A2(n, 4, t.a);
    }), a4 = F2(function(n, r) {
        return A2(lV, h, k([
            A2(iV, h, k([
                ad("Accepted "),
                A2(fz, k([
                    r4,
                    QS(n4(r))
                ]), k([
                    ad(y9(r))
                ])),
                ad(" on " + A2(e4, n, r) + " at " + A2(u4, n, r))
            ]))
        ]));
    }), i4 = F3(function(n, r, t) {
        return A2(lV, k([
            jV(k([
                Nk("panel")
            ]))
        ]), k([
            A2(iV, h, k([
                A2(mx, k([
                    LS(q3)
                ]), k([
                    ad(n)
                ])),
                A2(AW, h, A2(yu, a4(t), r))
            ]))
        ]));
    }), c4 = {
        $: 1
    }, o4 = ir("em"), f4 = function(n) {
        return n ? "embed-responsive--large" : "embed-responsive--small";
    }, s4 = F2(function(n, r) {
        return A2(dr, function(n) {
            return "innerHTML" == n || "formAction" == n ? "data-" + n : n;
        }(n), mr(r));
    }), l4 = s4, d4 = Ok("title"), b4 = F4(function(n, r, t, e) {
        return A2(Ik, h, k([
            function() {
                if (t.$) return A2(Ik, k([
                    Nk("flex justify-center my-12")
                ]), k([
                    Jk(h)
                ]));
                var u = t.a, a = e ? "https://docs.google.com/gview?url=" + Dx(u) + "&embedded=true" : u;
                return A2(Ik, k([
                    Nk("embed-responsive"),
                    Nk(f4(n))
                ]), k([
                    A2(M2, k([
                        TB(a),
                        d4(r),
                        A2(Wx, "sandbox", "allow-scripts allow-same-origin"),
                        A2(l4, "frameborder", mk("0")),
                        A2(l4, "allowfullscreen", mk("false")),
                        Nk("embed-responsive__item mb-2")
                    ]), h)
                ]));
            }(),
            A2(o4, h, k([
                ad("If you do not see the document above, please click "),
                A2(fz, k([
                    r4,
                    QS(c4)
                ]), k([
                    ad("here")
                ]))
            ]))
        ]));
    }), v4 = F2(function(n, r) {
        switch(j9(r.ey)){
            case 0:
                return A2(Ik, h, A2(yu, px(hu), Nj(A2(uc, "", r.ey.n1))));
            case 2:
                return A4(b4, n, r.ie, M9(r.ey), !1);
            default:
                return A4(b4, n, r.ie, MD(r.iM), !0);
        }
    }), m4 = function(n) {
        if (1 === n.$) {
            var r = n.a, t = n.c, e = y9(n.b);
            if (t.$) return Sq;
            var u = t.a;
            return A2(Tz, k([
                jZ(k([
                    A2(PB, k([
                        PL,
                        BB
                    ]), k([
                        ad(e)
                    ]))
                ])),
                IS(k([
                    A2(px, _9, A2(v4, 1, u))
                ])),
                XS(h)
            ]), fA(r));
        }
        return Sq;
    }, p4 = F2(function(n, r) {
        return J6(r) ? Sq : A2(Ik, h, k([
            m4(r.aB),
            A3(i4, n, r.e9, r.jx)
        ]));
    }), $4 = F2(function(n, r) {
        return A2(yu, n, r.b);
    }), h4 = {
        yR: !1,
        ib: !1,
        iL: !1
    }, g4 = F2(function(n, r) {
        switch(n.$){
            case 1:
                return m(r, {
                    yR: n.a
                });
            case 2:
                return m(r, {
                    iL: n.a
                });
            default:
                return m(r, {
                    ib: !0
                });
        }
    }), w4 = F2(function(n, r) {
        return {
            $: 1,
            a: n,
            b: r
        };
    }), k4 = function(n) {
        return function(n) {
            return {
                $: 5,
                a: n
            };
        }(n);
    }, x4 = function(n) {
        return 1 === n.c$;
    }, y4 = function(n) {
        return n.aF.eL;
    }, _4 = function(n) {
        return 1 === n.c$ || !n.aF.eL;
    }, C4 = function(n) {
        return ad(n.aF.sS);
    }, D4 = F2(function(n, r) {
        var t, e, u = r.a, a = r.b;
        return A2(Ik, k([
            Nk("px-1"),
            jz((e = u, "pending-document-" + ee(e)))
        ]), k([
            A2(lV, k([
                jV(k([
                    Nk("mb-2 md:mb-3")
                ]))
            ]), k([
                A2(iV, h, k([
                    A2(QW, k([
                        ZW(x4(a)),
                        WW(w4(b(u, a))),
                        k4(n.iL && !_4(a)),
                        VW(n.yR)
                    ]), k([
                        (t = a, ad(t.aF.ly)),
                        A2(Gk, k([
                            Nk("pl-2"),
                            rz(k([
                                b("-mr-1", y4(a))
                            ]))
                        ]), k([
                            A2(fz, k([
                                r4,
                                QS(A2(w4, b(u, a), !0))
                            ]), k([
                                C4(a)
                            ]))
                        ])),
                        A2(Gk, k([
                            Nk("form-group__label ml-1"),
                            rz(k([
                                b("form-group__label--required", y4(a))
                            ]))
                        ]), h)
                    ]))
                ]))
            ]))
        ]));
    }), q4 = F2(function(n, r) {
        var t = b(n, r);
        return t.a ? Q3 : t.b ? Y3 : K3;
    }), B4 = F3(function(n, r, t) {
        var e = t.wD, u = t.ac, a = t.h$, i = t.rd, c = A3(ce, g4, h4, r), o = function() {
            if (e.$) return Sq;
            var r = e.a;
            return A2(mx, k([
                LS(q3)
            ]), k([
                ad(n(r))
            ]));
        }();
        return A2(lV, k([
            jV(k([
                rz(k([
                    b("panel", c.ib)
                ]))
            ]))
        ]), k([
            A2(iV, h, k([
                o,
                A2(AW, k([
                    bW(n(A2(q4, i, a)))
                ]), k([
                    A2(Ik, k([
                        Nk("-mt-2 md:-mt-3")
                    ]), A2(Ot, gx, A2($4, D4(c), u)))
                ]))
            ]))
        ]));
    }), j4 = {
        $: 2
    }, S4 = function(n) {
        return A2(fz, k([
            CU,
            QS(j4)
        ]), k([
            ad(n(c6))
        ]));
    }, z4 = function(n) {
        return A2(fz, k([
            nz,
            QS(Z9)
        ]), k([
            ad(n(i6))
        ]));
    }, U4 = function(n) {
        return {
            $: 0,
            a: n
        };
    }, E4 = A2(TS, PS(3), Ht(0)), P4 = F2(function(n, r) {
        if (r.$) return Sq;
        var t = r.a;
        return A2(lV, k([
            dV(NZ),
            jV(k([
                Nk("-mx-1")
            ]))
        ]), k([
            A2(iV, h, k([
                A2(AW, k([
                    bW(n(EI))
                ]), k([
                    ad(A2(dP, AA("/"), t))
                ]))
            ]))
        ]));
    }), T4 = F3(function(n, r, t) {
        return A2(lV, k([
            jV(k([
                Nk("-mx-1 mb-6 md:mb-8")
            ]))
        ]), k([
            A2(iV, h, k([
                A2(AW, k([
                    bW(n(r))
                ]), k([
                    Jx(t)
                ]))
            ]))
        ]));
    }), L4 = F3(function(n, r, t) {
        var e = b(t, n);
        return e.a.$ ? Sq : A3(T4, r, e.b ? b6 : v6, e.a.a);
    }), M4 = F4(function(n, r, t, e) {
        var u, a = (u = b(t, n)).a.$ ? u.b ? b6 : d6 : u.b ? b6 : m6;
        return A3(T4, r, a, e);
    }), H4 = F3(function(n, r, t) {
        var e = A2(iW, 0, t);
        return ED(e) ? A2(Oq, k([
            Nk("mt-2 md:mt-3 text-sm text-info-400")
        ]), k([
            ad(n(k6(r)))
        ])) : A2(OW, n, e);
    }), R4 = F4(function(n, r, t, e) {
        var u, a = (u = b(e.bh, n)).a.$ ? b(u.b ? g6 : f6, o6) : u.b ? b(g6, o6) : b($6, p6), i = a.a, c = a.b, o = jN(e.kk), f = o.kU, s = o.dP;
        if (x6(o.lz)) return A2(Ik, k([
            jz(X9(e))
        ]), k([
            (l = e.cq, l.$ ? Sq : A2(px, t6, A2(v4, 0, l.a))),
            A2(Ik, k([
                A2(cE, "margin-left", "-1.5rem"),
                A2(cE, "margin-right", "-1.5rem")
            ]), k([
                gx
            ])),
            A2(lV, k([
                dV(E4),
                jV(k([
                    Nk("mt-5")
                ]))
            ]), k([
                A2(iV, h, k([
                    A3(L4, n, r, e.bh),
                    A4(M4, n, r, e.bh, f),
                    A2(lV, k([
                        jV(k([
                            Nk("-mx-1 mb-6 md:mb-8")
                        ]))
                    ]), k([
                        A2(iV, h, k([
                            A2(AW, k([
                                bW(r(i)),
                                hW(!0)
                            ]), k([
                                yP(k([
                                    bP(s),
                                    xZ(A2(sc, U4, ru)),
                                    $Z(!0),
                                    lP(r(c)),
                                    oZ(A2(kW, 0, e.kk))
                                ])),
                                A3(H4, r, e.bh, e.kk)
                            ]))
                        ]))
                    ])),
                    A2(P4, r, t)
                ]))
            ]))
        ]));
        var l, d = e.cq;
        return d.$ ? Sq : A2(px, t6, A2(v4, 0, d.a));
    }), O4 = F4(function(n, r, t, e) {
        if (1 === e.$) {
            var u = e.a, a = e.b, i = a.a, c = a.b;
            return A2(Tz, k([
                jZ(k([
                    A2(PB, k([
                        PL,
                        BB
                    ]), k([
                        A2(px, hu, C4(c))
                    ]))
                ])),
                IS(k([
                    A2(px, I9(b(i, c)), A4(R4, n, r, t, c))
                ])),
                XS(k([
                    A2(px, I9(b(i, c)), S4(r)),
                    A2(px, I9(b(i, c)), z4(r))
                ]))
            ]), fA(u));
        }
        return Sq;
    }), N4 = F3(function(n, r, t) {
        return Q6(t) ? Sq : A2(Ik, h, k([
            A4(O4, t.rd, n, t.g0, t.aq),
            A3(B4, n, r, t)
        ]));
    }), I4 = F3(function(n, r, t) {
        var e = Q6(r) ? "All Agreements Accepted" : "Already Accepted";
        return k([
            A2(px, N3, A3(N4, n, k([
                K6
            ]), r)),
            A2(px, o9, A2(p4, e, t))
        ]);
    }), V4 = F4(function(n, r, t, e) {
        return Q6(t) && J6(e) ? k([
            A2(lV, k([
                jV(k([
                    Nk("panel")
                ]))
            ]), k([
                A2(iV, h, k([
                    A2(mx, k([
                        LS(q3)
                    ]), k([
                        ad(hk(r) + " Agreements")
                    ])),
                    ad("You do not have any accepted or pending Agreement")
                ]))
            ]))
        ]) : A3(I4, n, t, e);
    }), W4 = F2(function(n, r) {
        return {
            gF: r.g4 ? A4(V4, n, r.dw, r.b$, r.xC) : Yk,
            wD: hk(r.dw)
        };
    }), Z4 = Ux({
        zO: a9,
        Ab: i9,
        Ct: c9,
        Dd: function(n) {
            return xk(k([
                A2(xD, N3, p9(n.b$)),
                A2(xD, o9, l9(n.xC))
            ]));
        },
        DB: G6,
        DH: W4
    }), X4 = F3(function(n, r, t) {
        return b({
            kj: r.kj,
            dw: n,
            w_: t.B9
        }, Dp);
    }), G4 = F2(function(n, r) {
        return b(r, Dp);
    }), J4 = F2(function(n, r) {
        return r;
    }), Y4 = F2(function(n, r) {
        return v(r, Dp, h);
    }), Q4 = ir("br"), K4 = function(n) {
        return n.eE.ns;
    }, n8 = function(n) {
        return n.eE.qJ;
    }, r8 = function(n) {
        return n.eE.qK;
    }, t8 = function(n) {
        return n.eE.wD;
    }, e8 = F2(function(n, r) {
        return {
            gF: k([
                A2(Ik, k([
                    Nk("panel")
                ]), k([
                    A2(lz, k([
                        rx,
                        bz(wF)
                    ]), k([
                        ad(n(t8))
                    ])),
                    A2(Q4, h, h),
                    A2(Gk, h, k([
                        ad(n(n8))
                    ])),
                    ad(" "),
                    A2(Gk, k([
                        Nk("text-support")
                    ]), k([
                        A2(fF, k([
                            Nk("link"),
                            vF(Sx(Wa))
                        ]), k([
                            ad(n(K4))
                        ]))
                    ])),
                    ad(" "),
                    A2(Gk, h, k([
                        ad(n(r8))
                    ])),
                    A2(Gk, h, k([
                        A4(xL, hk(r.dw), kF(r.dw), Ht("If you believe you received this message in error"), Rt)
                    ]))
                ]))
            ]),
            wD: n(t8)
        };
    }), u8 = kx({
        zO: X4,
        Ab: G4,
        Ct: J4,
        Dd: function() {
            return yk;
        },
        DB: Y4,
        DH: e8
    }), a8 = function(n) {
        return {
            $: 0,
            a: n
        };
    }, i8 = F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    }), c8 = F6(function(n, r, t, e, u, a) {
        return {
            x_: e,
            pU: t,
            p6: a,
            s4: n,
            s5: r,
            Di: u
        };
    }), o8 = function(n) {
        switch(n){
            case "DOCUMENT":
                return Ke(0);
            case "NOTE":
                return Ke(1);
            case "VITALS":
                return Ke(2);
            case "LAB":
                return Ke(3);
            case "RX":
                return Ke(4);
            case "RX_VERADIGM":
            case "RX_DOSESPOT":
                return Ke(5);
            case "FORM":
                return Ke(6);
            case "FAX":
                return Ke(7);
            default:
                return yy("Unsupported clinical note type: " + n);
        }
    }, f8 = A3(zy, "fileCount", C$, A3(zy, "text", w$, A3(zy, "author", l_(w$), A3(zy, "eventTimestamp", l_(tN), A3(zy, "noteType", A2(Ge, o8, w$), A3(zy, "noteId", w$, Ke(c8))))))), s8 = A2(IC, 0, A2(qy, f8, Ke(i8))), l8 = {
        g1: 1,
        hG: 10,
        lq: 0
    }, d8 = {
        kR: l8
    }, b8 = function(n) {
        return n.hG;
    }, v8 = function(n) {
        return (n.g1 - 1) * n.hG;
    }, m8 = function(n) {
        return Ml(k([
            b("offset", ee(v8(n))),
            b("limit", ee(b8(n)))
        ]));
    }, p8 = A2(Je, m8, _V), $8 = F4(function(n, r, t, e) {
        return A4(dC, n, Ey(s8), e, A2(iH, function(n) {
            var r = n(d8);
            return Gi(k([
                p8(r.kR)
            ]));
        }(t), bC(function(n) {
            return A2($y, k([
                "notes"
            ]), kT(n));
        }(r))));
    }), h8 = A2(zx, oa, wa), g8 = function(n) {
        var r = ST(Q_(n.gT));
        return r.$ ? h8 : A4($8, n.gT, r.a, function(r) {
            return m(r, {
                kR: n.kR
            });
        }, a8);
    }, w8 = F3(function(n, r) {
        var t = {
            es: oc,
            gT: r.ys.e5,
            kj: r.kj,
            kR: l8,
            jx: r.jx
        };
        return b(t, g8(t));
    }), k8 = F2(function(n, r) {
        return b(r, Dp);
    }), x8 = F2(function(n, r) {
        return m(r, {
            xE: Ht(7)
        });
    }), y8 = F2(function(n, r) {
        return m(r, {
            g1: n
        });
    }), _8 = F2(function(n, r) {
        return m(r, {
            lq: n
        });
    }), C8 = F2(function(n, r) {
        switch(n.$){
            case 0:
                var t = n.a;
                return 3 === t.$ ? v(m(r, {
                    es: t,
                    kR: A2(_8, A2(uc, 0, A2(Xb, lu, A2(Zu, "x-total-count", t.b))), r.kR)
                }), Dp, h) : v(m(r, {
                    es: oc
                }), Dp, A2(uA, 0, t));
            case 1:
                var e = m(r, {
                    kR: A2(y8, n.a, r.kR)
                });
                return v(e, g8(e), h);
            default:
                return v(r, A2(zx, oa, xa({
                    qU: n.a
                })), h);
        }
    }), D8 = function(n) {
        return {
            $: 2,
            a: n
        };
    }, q8 = F2(function(n, r) {
        return r.mw(n);
    }), B8 = function(n) {
        return tI(n) ? Rt : Ht(n);
    }, j8 = F4(function(n, r, t, e) {
        var u = A2(Cp, r(0), t);
        return B8(A2(ue, " - ", A2(Ep, ru, k([
            u,
            A2(Cp, n, A2(Cp, function(n) {
                return q8(n);
            }, e))
        ]))));
    }), S8 = function(n) {
        var r = k([
            Sz,
            $z
        ]);
        switch(n){
            case 0:
            default:
                return A2(US, r, 19);
            case 1:
                return A2(US, r, 21);
            case 2:
                return A2(US, r, 22);
            case 3:
                return A2(US, r, 23);
            case 4:
            case 5:
                return A2(US, r, 24);
            case 6:
                return A2(US, r, 25);
        }
    }, z8 = function(n) {
        return n.a.s4;
    }, U8 = function(n) {
        return n.a.s5;
    }, E8 = function(n) {
        return n.s5.aF;
    }, P8 = function(n) {
        return n.s5.po;
    }, T8 = function(n) {
        return n.s5.p1;
    }, L8 = function(n) {
        return n.s5.kk;
    }, M8 = function(n) {
        return n.s5.qW;
    }, H8 = function(n) {
        return n.s5.rq;
    }, R8 = function(n) {
        return n.s5.s3;
    }, O8 = function(n) {
        return n.s5.xd;
    }, N8 = function(n) {
        switch(n){
            case 0:
                return E8;
            case 1:
                return R8;
            case 2:
                return O8;
            case 3:
                return H8;
            case 4:
                return M8;
            case 5:
                return P8;
            case 6:
                return L8;
            default:
                return T8;
        }
    }, I8 = function(n) {
        return n.a.Di;
    }, V8 = F3(function(n, r, t) {
        return 1 === t ? "1 " + n : ee(t) + " " + r;
    }), W8 = F2(function(n, r) {
        var t = function() {
            switch(n){
                case "child":
                    return "children";
                case "category":
                    return "categories";
                default:
                    return n + "s";
            }
        }();
        return A3(V8, n, t, r);
    }), Z8 = A2(TS, PS(0), Ht(0)), X8 = function(n) {
        var r = n.a.p6;
        return r > 0 ? A2(Ik, k([
            Nk("flex flex-row")
        ]), k([
            A2(US, k([
                Sz,
                LV(Z8),
                Vq("text-primary-500")
            ]), 18),
            A2(Gk, k([
                Nk("ml-0.5")
            ]), k([
                ad(A2(W8, "attachment", r))
            ]))
        ])) : Sq;
    }, G8 = F3(function(n, r, t) {
        var e = A4(j8, n, r, t.a.pU, t.a.x_);
        return A2(Ik, k([
            Eq(D8(z8(t))),
            Nk("flex flex-row space-x-2 cursor-pointer w-full")
        ]), k([
            A2(Ik, k([
                Nk("flex flex-col mt-1")
            ]), k([
                S8(U8(t))
            ])),
            A2(Ik, k([
                Nk("flex flex-col grow gap-1 text-nowrap truncate")
            ]), k([
                A2(Ik, k([
                    Nk("flex flex-row")
                ]), k([
                    A2(hx, k([
                        OL
                    ]), k([
                        ad(n(N8(U8(t))))
                    ]))
                ])),
                function() {
                    if (e.$) return Sq;
                    var n = e.a;
                    return A2(Ik, k([
                        Nk("flex flex-row text-primary-500")
                    ]), k([
                        ad(n)
                    ]));
                }(),
                A2(Ik, k([
                    Nk("flex flex-row")
                ]), k([
                    ad(I8(t))
                ])),
                X8(t)
            ])),
            A2(Ik, k([
                Nk("flex flex-col justify-center text-primary-300 shrink-0")
            ]), k([
                A2(US, k([
                    Sz
                ]), 6)
            ]))
        ]));
    }), J8 = F3(function(n, r, t) {
        return A2(Ik, k([
            Nk("invoices-list")
        ]), A2(SF, gx, A2(yu, A2(G8, n, r), t)));
    }), Y8 = function(n) {
        return {
            $: 1,
            a: n
        };
    }, Q8 = {
        $: 7
    }, K8 = {
        g1: 1,
        hw: !1,
        hx: !1,
        hG: 0,
        Ac: !1,
        b_: Rt,
        CY: 0,
        lq: 0
    }, n5 = Vk(1), r5 = F3(function(n, r, t) {
        var e = r.$ ? h : k([
            Eq((0, r.a)(t))
        ]);
        return A2(Gk, A2(Ot, Nk("clickable"), e), k([
            ad(n)
        ]));
    }), t5 = F3(function(n, r, t) {
        return A2(Rq, k([
            rz(k([
                b("active", i(n, t))
            ]))
        ]), k([
            A3(r5, ee(t), r, t)
        ]));
    }), e5 = F2(function(n, r) {
        var t = r;
        return function(n) {
            var r = function(n) {
                return A3(ce, F2(function(n, r) {
                    switch(n.$){
                        case 0:
                            return m(r, {
                                lq: n.a
                            });
                        case 1:
                            return m(r, {
                                hG: n.a
                            });
                        case 2:
                            return m(r, {
                                hx: !0
                            });
                        case 3:
                            return m(r, {
                                g1: n.a
                            });
                        case 4:
                            return m(r, {
                                b_: Ht(n.a)
                            });
                        case 5:
                            return m(r, {
                                CY: n.a
                            });
                        case 6:
                            return m(r, {
                                Ac: n.a
                            });
                        default:
                            return m(r, {
                                hw: !0
                            });
                    }
                }), K8, n);
            }(n), t = !(1 > s(r.lq, r.hG) && r.hx || r.hw), e = qe(r.lq / r.hG), u = (r.g1 - 1) * r.hG, a = A2(Wv, r.g1 + 2, e), c = u + 1, o = A2(Me, r.g1 - 2, 1), f = A2(de, o, a), l = c - 1 + (s(r.hG * r.g1, r.lq) > 0 ? r.lq - r.hG * (r.g1 - 1) : r.hG);
            return A2(Ik, k([
                Nk("text-center")
            ]), r.Ac ? k([
                Jk(k([
                    n5
                ]))
            ]) : Gi(k([
                t && s(r.lq, r.hG) > 0 ? k([
                    A2(Ik, k([
                        Nk("pull-right")
                    ]), k([
                        ad("Showing " + ee(c) + " to " + ee(l) + " of " + ee(r.lq))
                    ]))
                ]) : h,
                r.lq && s(r.lq, r.hG) > 0 ? k([
                    A2(Oq, k([
                        Nk("pagination"),
                        Nk("")
                    ]), Gi(k([
                        k([
                            A2(Rq, k([
                                rz(k([
                                    b("disabled", 1 === r.g1)
                                ]))
                            ]), k([
                                A3(r5, "<", r.b_, r.g1 - 1)
                            ]))
                        ]),
                        o > 1 ? k([
                            A2(Rq, h, k([
                                A3(r5, "...", r.b_, o - 1)
                            ]))
                        ]) : h,
                        A2(yu, A2(t5, r.g1, r.b_), f),
                        0 > s(a, e) ? k([
                            A2(Rq, h, k([
                                A3(r5, "...", r.b_, a + 1)
                            ]))
                        ]) : h,
                        k([
                            A2(Rq, k([
                                rz(k([
                                    b("disabled", i(r.g1, e))
                                ]))
                            ]), k([
                                A3(r5, ">", r.b_, r.g1 + 1)
                            ]))
                        ])
                    ])))
                ]) : h
            ])));
        }(A2(Ot, function(n) {
            return {
                $: 0,
                a: n
            };
        }(t.lq), A2(Ot, function(n) {
            return {
                $: 1,
                a: n
            };
        }(t.hG), A2(Ot, function(n) {
            return {
                $: 3,
                a: n
            };
        }(t.g1), A2(Ot, function(n) {
            return {
                $: 4,
                a: n
            };
        }(ru), n)))));
    }), u5 = F2(function(n, r) {
        return {
            gF: k([
                A2(Ik, k([
                    Nk("panel")
                ]), function() {
                    var t, e = r.es;
                    switch(e.$){
                        case 3:
                            var u = e.a;
                            return k([
                                A2(Ik, h, ED(u) ? MS(n(dd)) : k([
                                    A3(J8, n, r.jx, u),
                                    (t = r.kR, A2(px, Y8, A2(e5, k([
                                        Q8
                                    ]), t)))
                                ]))
                            ]);
                        case 2:
                            return B3(n(bd));
                        default:
                            return Yk;
                    }
                }())
            ]),
            wD: n(Db(7))
        };
    }), a5 = Ux({
        zO: w8,
        Ab: k8,
        Ct: x8,
        Dd: function() {
            return yk;
        },
        DB: C8,
        DH: u5
    }), i5 = F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    }), c5 = F2(function(n, r) {
        return A2($y, k([
            r
        ]), function(n) {
            return A2($y, k([
                "notes"
            ]), kT(n));
        }(n));
    }), o5 = F7(function(n, r, t, e, u, a, i) {
        return {
            x_: u,
            oC: i,
            pU: e,
            zq: a,
            s4: n,
            s5: r,
            wj: t
        };
    }), f5 = F2(function(n, r) {
        return {
            qU: n,
            sS: r
        };
    }), s5 = A3(zy, "name", w$, A3(zy, "id", w$, Ke(f5))), l5 = A2(qy, s5, Ke(ru)), d5 = function(n) {
        return {
            $: 2,
            a: n
        };
    }, b5 = A3(zy, "formattedText", w$, Ke(function(n) {
        return {
            qn: n
        };
    })), v5 = A2(qy, b5, Ke(ru)), m5 = A2(qy, A2(Ye, d5, v5), Ke(ru)), p5 = function(n) {
        return {
            $: 6,
            a: n
        };
    }, $5 = A3(zy, "text", l_(w$), A3(zy, "address", l_(w$), A3(zy, "location", l_(w$), A3(zy, "daysOfTreatment", l_(C$), A3(zy, "numberOfRefills", l_(C$), A3(zy, "quantityPrescribed", l_(C$), A3(zy, "instructions", l_(w$), A3(zy, "medicationName", l_(w$), A3(zy, "prescriber", l_(w$), A3(zy, "useByDate", l_(tN), A3(zy, "datePrescribed", l_(tN), A3(zy, "routeOfAdministration", l_(w$), A3(zy, "form", l_(w$), A3(zy, "strength", l_(w$), Ke(function(n) {
        return function(r) {
            return function(t) {
                return function(e) {
                    return function(u) {
                        return function(a) {
                            return function(i) {
                                return function(c) {
                                    return function(o) {
                                        return function(f) {
                                            return function(s) {
                                                return function(l) {
                                                    return function(d) {
                                                        return function(b) {
                                                            return {
                                                                l0: d,
                                                                j4: e,
                                                                j6: s,
                                                                kk: r,
                                                                kq: c,
                                                                ku: l,
                                                                kz: i,
                                                                kK: f,
                                                                k$: a,
                                                                k3: o,
                                                                la: t,
                                                                lm: n,
                                                                Di: b,
                                                                ls: u
                                                            };
                                                        };
                                                    };
                                                };
                                            };
                                        };
                                    };
                                };
                            };
                        };
                    };
                };
            };
        };
    }))))))))))))))), h5 = A2(qy, $5, Ke(ru)), g5 = A2(qy, A2(Ye, p5, h5), Ke(ru)), w5 = function(n) {
        return {
            $: 7,
            a: n
        };
    }, k5 = A3(zy, "formattedText", w$, Ke(function(n) {
        return {
            qn: n
        };
    })), x5 = A2(qy, k5, Ke(ru)), y5 = A2(qy, A2(Ye, w5, x5), Ke(ru)), _5 = function(n) {
        return {
            $: 3,
            a: n
        };
    }, C5 = F4(function(n, r, t, e) {
        return {
            ol: r,
            qk: n,
            ln: e,
            wE: t
        };
    }), D5 = F2(function(n, r) {
        return {
            oF: n,
            uS: r
        };
    }), q5 = A3(zy, "questionCount", C$, A3(zy, "dateSubmitted", l_(tN), Ke(D5))), B5 = A3(zy, "submissionData", q5, A3(zy, "to", w$, A3(zy, "created", l_(tN), A3(zy, "formName", w$, Ke(C5))))), j5 = A2(qy, B5, Ke(ru)), S5 = A2(qy, A2(Ye, _5, j5), Ke(ru)), z5 = function(n) {
        return {
            $: 4,
            a: n
        };
    }, U5 = F2(function(n, r) {
        return {
            lG: n,
            tm: r
        };
    }), E5 = F3(function(n, r, t) {
        return {
            yj: t,
            o_: n,
            Cd: r
        };
    }), P5 = A4(Sy, "chargeId", l_(w$), Rt, A4(Sy, "reference", l_(w$), Rt, A3(zy, "display", l_(w$), Ke(E5)))), T5 = A3(zy, "orderedFrom", l_(w$), A3(zy, "actions", Ey(P5), Ke(U5))), L5 = A2(qy, T5, Ke(ru)), M5 = A2(qy, A2(Ye, z5, L5), Ke(ru)), H5 = function(n) {
        return {
            $: 1,
            a: n
        };
    }, R5 = A3(zy, "formattedText", w$, Ke(function(n) {
        return {
            qn: n
        };
    })), O5 = A2(qy, R5, Ke(ru)), N5 = A2(qy, A2(Ye, H5, O5), Ke(ru)), I5 = function(n) {
        return {
            $: 5,
            a: n
        };
    }, V5 = F8(function(n, r, t, e, u, a, i, c) {
        return {
            oE: r,
            j6: c,
            qp: n,
            kq: u,
            kz: e,
            kK: i,
            uu: t,
            k3: a
        };
    }), W5 = A3(zy, "daysOfTreatment", l_(C$), A3(zy, "numberOfRefills", l_(C$), A3(zy, "quantityPrescribed", l_(C$), A3(zy, "instructions", l_(w$), A3(zy, "medicationName", l_(w$), A3(zy, "priceForPatient", l_(_$), A3(zy, "dateFulfilled", l_(FC), A3(zy, "frequency", l_(w$), Ke(V5))))))))), Z5 = A2(qy, W5, Ke(ru)), X5 = A2(qy, A2(Ye, I5, Z5), Ke(ru)), G5 = function(n) {
        return {
            $: 0,
            a: n
        };
    }, J5 = F9(function(n, r, t, e, u, a, i, c, o) {
        return {
            mW: c,
            oX: t,
            qH: e,
            qI: o,
            vq: u,
            v9: a,
            wu: r,
            wA: n,
            xh: i
        };
    }), Y5 = A3(zy, "height", l_(_$), A3(zy, "bmi", l_(_$), A3(zy, "weight", l_(_$), A3(zy, "spo2", l_(_$), A3(zy, "respiratoryRate", l_(_$), A3(zy, "heartRate", l_(_$), A3(zy, "diastolic", l_(_$), A3(zy, "systolic", l_(_$), A3(zy, "temp", l_(_$), Ke(J5)))))))))), Q5 = A2(qy, Y5, Ke(ru)), K5 = A2(qy, A2(Ye, G5, Q5), Ke(ru)), n7 = D$(k([
        K5,
        N5,
        m5,
        S5,
        M5,
        X5,
        g5,
        y5
    ])), r7 = A3(zy, "data", n7, A3(zy, "files", Ey(l5), A3(zy, "author", l_(w$), A3(zy, "eventTimestamp", l_(tN), A3(zy, "status", w$, A3(zy, "noteType", A2(Ge, o8, w$), A3(zy, "noteId", w$, Ke(o5)))))))), t7 = A2(qy, r7, Ke(ru)), e7 = F4(function(n, r, t, e) {
        return A4(dC, n, t7, e, bC(A2(c5, r, t)));
    }), u7 = F3(function(n, r, t) {
        var e = {
            gT: r.ys.e5,
            kj: r.kj,
            qU: t.BD.qU,
            eU: Rt,
            s3: oc,
            dw: n,
            jx: r.jx,
            w_: t
        };
        return b(e, function(n) {
            var r = ST(Q_(n.gT));
            if (r.$) return Dp;
            var t = r.a;
            return A4(e7, n.gT, t, n.qU, i5(t));
        }(e));
    }), a7 = F2(function(n, r) {
        return b(r, Dp);
    }), i7 = F2(function(n, r) {
        return m(r, {
            xE: Ht(7)
        });
    }), c7 = function(n) {
        return {
            $: 2,
            a: n
        };
    }, o7 = F3(function(n, r, t) {
        return {
            qU: n,
            sS: r,
            w_: t
        };
    }), f7 = A3(zy, "url", w$, A3(zy, "name", w$, A3(zy, "id", w$, Ke(o7)))), s7 = A2(qy, f7, Ke(ru)), l7 = F3(function(n, r, t) {
        return A2($y, k([
            t
        ]), A2($y, k([
            "file"
        ]), A2(c5, n, r)));
    }), d7 = F5(function(n, r, t, e, u) {
        return A4(dC, n, s7, u, bC(A3(l7, r, t, e)));
    }), b7 = "Patient Portal", v7 = F3(function(n, r, t) {
        return A3(eC, F3(function(t, e, u) {
            return A3(wn, n(t), r(e), u);
        }), {}, t);
    }), m7 = F2(function(n, r) {
        return vk(k([
            b("type", mk(n)),
            b("payload", r)
        ]));
    }), p7 = F2(function(n, r) {
        return A2(m7, n, A3(v7, ru, mk, Ml(r)));
    }), $7 = Jn("fullStoryPortLogEvent", ru), h7 = F2(function(n, r) {
        return $7(A2(p7, n, r));
    }), g7 = function(n) {
        return b(n.a, n.b);
    }, w7 = F2(function(n, r) {
        return A2(h7, n, A2(yu, g7, r));
    }), k7 = F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    }), x7 = F2(function(n, r) {
        return A2(k7, n, r);
    }), y7 = function(n) {
        return A2(x7, "Patient ID", n);
    }, _7 = function(n) {
        return A2(x7, "User Flow", n);
    }, C7 = F3(function(n, r, t) {
        return A2(w7, "Clinical Data Opened", k([
            _7(b7),
            y7(n),
            A2(x7, "interaction ID", r),
            A2(x7, "interaction type", t)
        ]));
    }), D7 = function(n) {
        return n.s5;
    }, q7 = Jn("printWindow", function() {
        return bk;
    }), B7 = F2(function(n, r) {
        switch(n.$){
            case 0:
                var t = n.b;
                if (3 === t.$) {
                    var e = A3(C7, n.a, r.qU, A2(Rk, 0, N8(D7(t.a))));
                    return v(m(r, {
                        s3: t
                    }), Hu(k([
                        e
                    ])), h);
                }
                return v(m(r, {
                    s3: oc
                }), Dp, A2(uA, 0, t));
            case 1:
                var u = n.a, a = ST(Q_(r.gT)), i = a.$ ? Dp : A5(d7, r.gT, a.a, r.qU, u, c7);
                return v(m(r, {
                    eU: Ht(u)
                }), i, h);
            case 2:
                var c = n.a, o = m(r, {
                    eU: Rt
                });
                return 3 === c.$ ? v(o, QQ(c.a.w_), h) : v(o, Dp, A2(uA, 0, c));
            default:
                return v(r, 3 === r.s3.$ ? q7(0) : Dp, h);
        }
    }), j7 = function(n) {
        return n.pU;
    }, S7 = function(n) {
        return n.zq;
    }, z7 = {
        $: 3
    }, U7 = function(n) {
        return A2(Gk, k([
            Nk("text-support")
        ]), k([
            A2(gV, k([
                n0,
                vV(Sx(ka))
            ]), k([
                ad(n(Db(7)))
            ]))
        ]));
    }, E7 = function(n) {
        return y$(n.a.i);
    }, P7 = function(n) {
        return !E7(n);
    }, T7 = F3(function(n, r, t) {
        return P7(r) ? Sq : A2(Ik, k([
            Nk("note-breadcrumbs")
        ]), k([
            A2(lV, k([
                dV(NZ)
            ]), k([
                A2(iV, k([
                    uV(gz),
                    jV(k([
                        Nk("flex")
                    ]))
                ]), k([
                    U7(n),
                    A2(Gk, k([
                        Nk("mx-3 text-support")
                    ]), k([
                        ad("/")
                    ])),
                    ad(n(N8(D7(t)))),
                    A2(Gk, k([
                        Nk("text-primary-300 ml-auto text-right")
                    ]), k([
                        A2(Ik, k([
                            Nk("cursor-pointer"),
                            Eq(z7)
                        ]), k([
                            A2(US, h, 16)
                        ]))
                    ]))
                ]))
            ])),
            A2(lV, k([
                dV(NZ)
            ]), k([
                A2(iV, h, k([
                    gx
                ]))
            ]))
        ]));
    }), L7 = function(n) {
        return {
            $: 1,
            a: n
        };
    }, M7 = function(n) {
        return {
            $: 1,
            a: n
        };
    }, H7 = A2(TS, PS(1), Ht(1)), R7 = F2(function(n, r) {
        var t, e = r.qU, u = A2(Cp, function(n) {
            return i(n, e);
        }, n), a = !u.$ && u.a ? Jk(k([
            J0,
            M7(k([
                Nk("mr-3")
            ]))
        ])) : A2(US, k([
            LV(H7)
        ]), 19);
        return A2(Ik, k([
            Nk("file-button")
        ]), k([
            A2(fz, k([
                QS(L7(e)),
                ZS(YS(u))
            ]), k([
                A2(Gk, h, k([
                    a,
                    ad((t = r, t.sS))
                ]))
            ]))
        ]));
    }), O7 = F2(function(n, r) {
        return ED(r) ? Sq : A2(lV, k([
            dV(NZ)
        ]), k([
            A2(iV, h, k([
                A2(Ik, k([
                    Nk("clinical-note-files")
                ]), A2(yu, R7(n), r))
            ]))
        ]));
    }), N7 = F3(function(n, r, t) {
        var e = A4(j8, n, r, j7(t), t.x_);
        if (e.$) return Sq;
        var u = e.a;
        return A2(Ik, k([
            Nk("flex flex-row text-sm text-primary-500 mb-4")
        ]), k([
            ad(u)
        ]));
    }), I7 = function(n) {
        return n.de.yJ;
    }, V7 = function(n) {
        return n.de.oF;
    }, W7 = function(n) {
        return n.de.AJ;
    }, Z7 = function(n) {
        return n.de.CG;
    }, X7 = function(n) {
        return n.de.wj;
    }, G7 = function(n) {
        return n.qk;
    }, J7 = F2(function(n, r) {
        return b(n, r);
    }), Y7 = function(n) {
        return n.ln.uS;
    }, Q7 = function(n) {
        return n.wE;
    }, K7 = F2(function(n, r) {
        var t = r.a, e = r.b;
        return A2(SE, k([
            Nk("data-display__row")
        ]), k([
            A2(EE, k([
                Nk("data-display__label")
            ]), k([
                ad(n(t))
            ])),
            A2(EE, k([
                Nk("data-display__value")
            ]), k([
                ad(A2(uc, "no data", e))
            ]))
        ]));
    }), nnn = F2(function(n, r) {
        return A2(Ik, k([
            Nk("data-display")
        ]), k([
            A2(JE, k([
                Nk("data-display__table")
            ]), k([
                A2(YE, h, A2(yu, K7(n), r))
            ]))
        ]));
    }), rnn = F2(function(n, r) {
        return A2(Cp, function(r) {
            return A2(ue, " ", k([
                A2(n, 1, r),
                A2(n, 4, r),
                "(" + A2(n, 6, r) + ")"
            ]));
        }, r);
    }), tnn = F4(function(n, r, t, e) {
        var u = "FULFILLED" === t || "ADDENDED" === t ? "Completed" : "Pending Submission", a = A2(rnn, r, e.ln.oF), i = A2(rnn, r, e.ol);
        return A2(Ik, k([
            Nk("w-full md:w-1/2")
        ]), k([
            A2(Ik, k([
                Nk("mb-4")
            ]), k([
                ad(G7(e))
            ])),
            A2(nnn, n, k([
                A2(J7, X7, Ht(u)),
                A2(J7, I7, i),
                A2(J7, Z7, Ht(Q7(e))),
                A2(J7, V7, a),
                A2(J7, W7, Ht(ee(Y7(e))))
            ]))
        ]));
    }), enn = function(n) {
        return A2(Ep, ru, A2(yu, function(n) {
            return n.o_;
        }, n.lG));
    }, unn = function(n) {
        if (n.$) return Sq;
        var r = n.a;
        return A2(Ik, k([
            Nk("mb-4")
        ]), k([
            ad("Lab Facility: " + r)
        ]));
    }, ann = function(n) {
        return n.l0;
    }, inn = F2(function(n, r) {
        return A2(Ik, h, k([
            ad(A2(ue, ": ", k([
                n,
                A2(uc, "no data", r)
            ])))
        ]));
    }), cnn = function(n) {
        return n.j4;
    }, onn = function(n) {
        return n.j6;
    }, fnn = function(n) {
        return n.kk;
    }, snn = function(n) {
        return n.kq;
    }, lnn = function(n) {
        return n.kK;
    }, dnn = function(n) {
        return n.k$;
    }, bnn = function(n) {
        return n.aa.yH;
    }, vnn = function(n) {
        return n.aa.j4;
    }, mnn = function(n) {
        return n.aa.j6;
    }, pnn = function(n) {
        return n.aa.kk;
    }, $nn = function(n) {
        return n.aa.qp;
    }, hnn = function(n) {
        return n.aa.kq;
    }, gnn = function(n) {
        return n.aa.Aq;
    }, wnn = function(n) {
        return n.aa.k$;
    }, knn = function(n) {
        return n.aa.k0;
    }, xnn = function(n) {
        return n.aa.uN;
    }, ynn = function(n) {
        return n.aa.Ce;
    }, _nn = function(n) {
        return n.aa.la;
    }, Cnn = function(n) {
        return n.aa.lm;
    }, Dnn = function(n) {
        return n.aa.ls;
    }, Ann = function(n) {
        return n.k3;
    }, qnn = function(n) {
        return n.la;
    }, Bnn = function(n) {
        return n.lm;
    }, jnn = function(n) {
        return n.Di;
    }, Snn = function(n) {
        return n.ls;
    }, znn = F3(function(n, r, t) {
        var e, u;
        return A2(sA, ru, k([
            YS((u = t).lm),
            YS(u.kk),
            YS(u.la),
            YS(u.j4),
            YS(u.ls),
            YS(u.k$),
            YS(u.kz),
            YS(u.kq),
            YS(u.k3),
            YS(u.kK),
            YS(u.j6),
            YS(u.ku),
            YS(u.l0)
        ])) ? A2(nnn, n, k([
            A2(J7, gnn, (e = t, e.kz)),
            A2(J7, Cnn, Bnn(t)),
            A2(J7, pnn, fnn(t)),
            A2(J7, hnn, snn(t)),
            A2(J7, xnn, A2(Cp, ee, Ann(t))),
            A2(J7, _nn, qnn(t)),
            A2(J7, ynn, A2(Cp, ee, lnn(t))),
            A2(J7, mnn, A2(Cp, ee, onn(t))),
            A2(J7, vnn, A2(Cp, r(0), cnn(t))),
            A2(J7, Dnn, A2(Cp, r(0), Snn(t))),
            A2(J7, wnn, dnn(t))
        ])) : A2(Ik, h, k([
            ad(A2(uc, "Prescription details are missing.", jnn(t)))
        ]));
    }), Unn = F3(function(n, r, t) {
        var e;
        return A2(Ik, k([
            Nk("w-full md:w-1/2")
        ]), k([
            A2(Ik, k([
                Nk("mb-4")
            ]), k([
                A2(inn, "Location", (e = t, e.ku)),
                A2(inn, "Address", ann(t))
            ])),
            A3(znn, n, r, t)
        ]));
    }), Enn = function(n) {
        return n.b.l0;
    }, Pnn = function(n) {
        return n.nr;
    }, Tnn = A2(Gk, h, k([
        ad("," + cF)
    ])), Fnn = function(n) {
        return tI(n);
    }, Lnn = function(n) {
        return n.rE;
    }, Mnn = function(n) {
        return n.rF;
    }, Hnn = function(n) {
        return n.wi;
    }, Rnn = function(n) {
        return n.xy;
    }, Onn = function(n) {
        var r, t = Jx(Rnn(n)), e = fu(Hnn(n)) ? Rt : Ht(A2(Gk, h, k([
            ad(Hnn(n))
        ]))), u = Fnn(Mnn(n)) ? Rt : Ht(Jx(Mnn(n))), a = Fnn(Lnn(n)) ? Rt : Ht(Jx(Lnn(n))), i = fu(Pnn(n)) ? Rt : Ht(A2(Gk, h, k([
            ad(Pnn(n))
        ]))), c = A2(SF, Tnn, A2(Ep, ru, k([
            a,
            u,
            i,
            e
        ])));
        return $(c, k([
            (r = b(ED(c), Fnn(Rnn(n)))).a || r.b ? Sq : oF,
            t
        ]));
    }, Nnn = function(n) {
        var r = Enn(n);
        if (r.$) return Sq;
        var t = r.a;
        return A2(Ik, h, k([
            A2(Gk, h, k([
                ad("Address: ")
            ])),
            A2(Gk, h, Onn(t))
        ]));
    }, Inn = function(n) {
        return A2(Ik, h, k([
            ad("Location: " + hk(n))
        ]));
    }, Vnn = function(n) {
        return n.oE;
    }, Wnn = function(n) {
        return n.j6;
    }, Znn = function(n) {
        return n.qp;
    }, Xnn = function(n) {
        return n.kq;
    }, Gnn = function(n) {
        return n.kK;
    }, Jnn = function(n) {
        return n.uu;
    }, Ynn = function(n) {
        return n.k3;
    }, Qnn = F2(function(n, r) {
        var t;
        return A2(nnn, n, k([
            A2(J7, gnn, (t = r, t.kz)),
            A2(J7, hnn, Xnn(r)),
            A2(J7, $nn, Znn(r)),
            A2(J7, mnn, A2(Cp, ee, Wnn(r))),
            A2(J7, xnn, A2(Cp, ee, Ynn(r))),
            A2(J7, ynn, A2(Cp, ee, Gnn(r))),
            A2(J7, bnn, A2(Cp, dP(AA("/")), Vnn(r))),
            A2(J7, knn, A2(Cp, A2(pB, !1, !0), Jnn(r)))
        ]));
    }), Knn = F3(function(n, r, t) {
        return A2(Ik, k([
            Nk("w-full md:w-1/2")
        ]), k([
            A2(Ik, k([
                Nk("mb-4")
            ]), k([
                Inn(r),
                Nnn(r)
            ])),
            A2(Qnn, n, t)
        ]));
    }), nrn = function(n) {
        return n.mW;
    }, rrn = function(n) {
        return n.oX;
    }, trn = function(n) {
        return n.qH;
    }, ern = function(n) {
        return n.qI;
    }, urn = function(n) {
        return n.vq;
    }, arn = function(n) {
        return n.v9;
    }, irn = function(n) {
        return n.wA;
    }, crn = function(n) {
        return n.aR.mW;
    }, orn = function(n) {
        return n.aR.oX;
    }, frn = function(n) {
        return n.aR.qI;
    }, srn = function(n) {
        return n.aR.B7;
    }, lrn = function(n) {
        return n.aR.vq;
    }, drn = function(n) {
        return n.aR.v9;
    }, brn = function(n) {
        return n.aR.wu;
    }, vrn = function(n) {
        return n.aR.wA;
    }, mrn = function(n) {
        return n.aR.xh;
    }, prn = function(n) {
        return n.aR.DN;
    }, $rn = function(n) {
        return n.xh;
    }, hrn = F4(function(n, r, t, e) {
        var u, a = A2(Cp, function(n) {
            return A2(ue, ", ", k([
                A2(r, 0, n),
                A2(r, 5, n)
            ]));
        }, t);
        return A2(Ik, k([
            Nk("w-full md:w-1/2")
        ]), k([
            A2(nnn, n, k([
                A2(J7, prn, a),
                A2(J7, brn, A2(Cp, rB, (u = e, u.wu))),
                A2(J7, orn, A2(Cp, rB, rrn(e))),
                A2(J7, srn, A2(Cp, rB, trn(e))),
                A2(J7, drn, A2(Cp, rB, arn(e))),
                A2(J7, vrn, A2(Cp, rB, irn(e))),
                A2(J7, lrn, A2(Cp, rB, urn(e))),
                A2(J7, frn, A2(Cp, rB, ern(e))),
                A2(J7, mrn, A2(Cp, rB, $rn(e))),
                A2(J7, crn, A2(Cp, rB, nrn(e)))
            ]))
        ]));
    }), grn = F4(function(n, r, t, e) {
        var u = function(n) {
            return n.oC;
        }(e);
        switch(u.$){
            case 0:
                var a = u.a;
                return A4(hrn, n, t, j7(e), a);
            case 1:
                return function(n) {
                    var r = Lj(n.qn);
                    if (r.$) return Sq;
                    var t = r.a;
                    return A2(Ik, k([
                        Nk("formatted-text-data")
                    ]), Rj(t));
                }(u.a);
            case 2:
                return function(n) {
                    var r = Lj(n.qn);
                    if (r.$) return Sq;
                    var t = r.a;
                    return A2(Ik, k([
                        Nk("formatted-text-data")
                    ]), Rj(t));
                }(u.a);
            case 3:
                var i = u.a;
                return A4(tnn, n, t, function(n) {
                    return n.wj;
                }(e), i);
            case 4:
                return function(n) {
                    var r, t;
                    return A2(Ik, k([
                        Nk("w-full md:w-1/2")
                    ]), k([
                        unn((t = n, t.tm)),
                        (r = enn(n), A2(Ik, h, k([
                            ad("Ordered tests:"),
                            A2(Ik, k([
                                Nk("ml-4")
                            ]), k([
                                A2(Oq, k([
                                    Nk("list-disc ml-2")
                                ]), A2(yu, function(n) {
                                    return A2(Rq, h, k([
                                        ad(n)
                                    ]));
                                }, r))
                            ]))
                        ])))
                    ]));
                }(u.a);
            case 5:
                return A3(Knn, n, r, u.a);
            case 6:
                return A3(Unn, n, t, u.a);
            default:
                return function(n) {
                    var r = Lj(n.qn);
                    if (r.$) return Sq;
                    var t = r.a;
                    return A2(Ik, k([
                        Nk("formatted-text-data")
                    ]), Rj(t));
                }(u.a);
        }
    }), wrn = F4(function(n, r, t, e) {
        return A2(Ik, h, k([
            A2(lV, k([
                dV(NZ)
            ]), k([
                A2(iV, h, k([
                    A2(px, hu, A3(N7, n, t, e)),
                    A2(px, hu, A4(grn, n, r, t, e))
                ]))
            ]))
        ]));
    }), krn = F2(function(n, r) {
        var t = function() {
            var t = r.s3;
            if (3 === t.$) {
                var e = t.a, u = Ht(n(N8(D7(e)))), a = A2(Cp, r.jx(0), j7(e));
                return A2(ue, "_", A2(Ep, ru, k([
                    u,
                    a
                ])));
            }
            return n(Db(7));
        }();
        return {
            gF: k([
                A2(Ik, h, k([
                    A2(Ik, k([
                        Nk("panel clinical-note")
                    ]), function() {
                        var t = r.s3;
                        if (3 === t.$) {
                            var e = t.a;
                            return k([
                                A3(T7, n, r.gT, e),
                                A4(wrn, n, r.dw, r.jx, e),
                                A2(O7, r.eU, S7(e))
                            ]);
                        }
                        return Yk;
                    }())
                ]))
            ]),
            wD: t
        };
    }), xrn = Ux({
        zO: u7,
        Ab: a7,
        Ct: i7,
        Dd: function() {
            return yk;
        },
        DB: B7,
        DH: krn
    }), yrn = function(n) {
        return {
            $: 2,
            a: n
        };
    }, _rn = function(n) {
        return {
            $: 0,
            a: n
        };
    }, Crn = F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    }), Drn = F5(function(n, r, t, e, u) {
        return {
            oD: r,
            o9: t,
            pf: u,
            pg: e,
            qU: n
        };
    }), Arn = function(n) {
        switch(n){
            case "paid":
                return Ke(0);
            case "void":
                return Ke(1);
            case "due":
                return Ke(2);
            default:
                return yy("Unsupported document status: " + n);
        }
    }, qrn = A3(zy, "due_date", FC, A3(zy, "due_in_cents", C$, A3(zy, "document_status", A2(Ge, Arn, w$), A3(zy, "date", FC, A3(zy, "id", w$, Ke(Drn)))))), Brn = A2(IC, 0, A2(qy, qrn, Ke(Crn))), jrn = {
        kR: l8
    }, Srn = F4(function(n, r, t, e) {
        return A4(dC, n, Ey(Brn), e, A2(iH, function(n) {
            var r = n(jrn);
            return Gi(k([
                p8(r.kR)
            ]));
        }(t), bC(function(n) {
            return A2($y, k([
                "customer_invoices"
            ]), gy(n));
        }(r))));
    }), zrn = function(n) {
        var r = function(r) {
            return m(r, {
                kR: n.kR
            });
        };
        return A4(Srn, n.gx, $k(n.dw), r, _rn);
    }, Urn = function(n) {
        return {
            $: 8,
            a: n
        };
    }, Ern = function(n) {
        return {
            $: 1,
            a: n
        };
    }, Prn = {
        $: 3
    }, Trn = function(n) {
        return {
            $: 7,
            a: n
        };
    }, Frn = function(n) {
        return n.bk.xM;
    }, Lrn = function(n) {
        return n.bk.yD;
    }, Mrn = function(n) {
        return n.bk.yF;
    }, Hrn = function(n) {
        return n.bk.pC;
    }, Rrn = function(n) {
        return n.bk.zM;
    }, Orn = function(n) {
        return n.bk.zN;
    }, Nrn = function(n) {
        return n.bk.z7;
    }, Irn = function(n) {
        return n.bk.C3;
    }, Vrn = function(n) {
        switch(n){
            case 0:
                return Frn;
            case 1:
                return Lrn;
            case 2:
                return Nrn;
            default:
                return Mrn;
        }
    }, Wrn = function(n) {
        switch(n){
            case 0:
                return Ht("all_time");
            case 1:
                return Ht("current_year");
            case 2:
                return Ht("last_year");
            default:
                return Ht("custom");
        }
    }, Zrn = F4(function(n, r, t, e) {
        var u = py("statement-start-date"), a = u.a, i = u.b, c = A2(Cq, rm(!1), a), o = A2(ny, 0, Prn), f = o.a, s = o.b, l = py("statement-end-date"), d = l.a, v = l.b, m = A2(Cq, rm(!1), d);
        return b({
            gx: t,
            g0: Rt,
            ct: m,
            hm: oc,
            hD: !1,
            tE: r,
            dw: n,
            ab: f,
            fz: Rt,
            cT: c,
            fG: id({
                qU: "statement-download",
                Dr: function(n) {
                    return A2(sc, n, Vrn);
                },
                Dt: Wrn
            }),
            w_: e
        }, Hu(k([
            A2(Eu, Ern, vy),
            s,
            A2(jp, Trn, i),
            A2(jp, Urn, v)
        ])));
    }), Xrn = F3(function(n, r, t) {
        var e = A4(Zrn, n, r.tE, r.gx, t), u = e.b, a = {
            gx: r.gx,
            da: e.a,
            kj: r.kj,
            g: oc,
            kR: l8,
            tE: r.tE,
            dw: n
        };
        return b(a, Hu(k([
            zrn(a),
            A2(jp, yrn, u)
        ])));
    }), Grn = F2(function(n, r) {
        return b(r, Dp);
    }), Jrn = F2(function(n, r) {
        return m(r, {
            xE: Ht(0)
        });
    }), Yrn = function(n) {
        return {
            $: 4,
            a: n
        };
    }, Qrn = function(n) {
        return {
            $: 2,
            a: n
        };
    }, Krn = function(n) {
        return {
            $: 5,
            a: n
        };
    }, ntn = {
        $: 6
    }, rtn = function(n) {
        return {
            $: 0,
            a: n
        };
    }, ttn = function(n) {
        return mk(vA(n));
    }, etn = function(n) {
        return A2($y, k([
            "files"
        ]), gy(n));
    }, utn = F6(function(n, r, t, e, u, a) {
        return {
            zf: n,
            zp: r,
            uA: a,
            wL: e,
            wW: u,
            w_: t
        };
    }), atn = A2(Ge, function(n) {
        return Ke(n);
    }, w$), itn = A3(zy, "processing", xy, A3(zy, "type", w$, A3(zy, "token", atn, A3(zy, "url", Ay(w$), A3(zy, "file_name", w$, A3(zy, "extension", w$, Ke(utn))))))), ctn = A2(qy, A2(Ye, ru, itn), Ke(ru)), otn = F4(function(n, r, t, e) {
        return A4(vN, n, ctn, e, A2(xq, function(n) {
            return vk(k([
                b("type", mk("account_statement")),
                b("options", vk(k([
                    b("date", vk(function() {
                        var r = n.oD;
                        if (r.$) return h;
                        var t = r.a.Ah;
                        return k([
                            b("gte", ttn(r.a.zy)),
                            b("lte", ttn(t))
                        ]);
                    }()))
                ])))
            ]));
        }(t), bC(etn(r))));
    }), ftn = F2(function(n, r) {
        return A2($y, k([
            r
        ]), etn(n));
    }), stn = F4(function(n, r, t, e) {
        return A4(kq, n, ctn, e, bC(A2($y, k([
            "generate"
        ]), A2(ftn, r, t))));
    }), ltn = function(n) {
        return n.uA;
    }, dtn = function(n) {
        return A2(x7, "fromState", n);
    }, btn = F3(function(n, r, t) {
        var e = A2(uc, "", A2(Cp, ZC, MD(n))), u = A2(uc, Ru, ec(r.B9));
        return A2(w7, "Data Export Complete", k([
            dtn(Sx(u)),
            A2(x7, "Format", "PDF"),
            A2(x7, "Scope", A2(Rk, 0, Vrn(t))),
            y7(e)
        ]));
    }), vtn = F2(function(n, r) {
        var t = function(n) {
            return A3(ip, n, 11, 31);
        }, e = function(n) {
            return A3(ip, n, 0, 1);
        }, u = Dv(r);
        switch(n){
            case 0:
            default:
                return {
                    oD: Rt,
                    wW: 0
                };
            case 1:
                return {
                    oD: Ht({
                        zy: e(u),
                        Ah: t(u)
                    }),
                    wW: 0
                };
            case 2:
                return {
                    oD: Ht({
                        zy: e(u - 1),
                        Ah: t(u - 1)
                    }),
                    wW: 0
                };
        }
    }), mtn = function(n) {
        return n.wL;
    }, ptn = function(n) {
        return n.w_;
    }, $tn = F2(function(n, r) {
        switch(n.$){
            case 0:
                var t = A2(bq, n.a, r.fG), e = t.a, u = t.b, a = t.c, i = function() {
                    var n = b(a, r.g0);
                    if (n.a.$ || n.a.a.$ || n.a.a.a.$ || n.b.$) return b(r.fz, h);
                    var t = n.a.a.a.a, e = n.b.a;
                    return b(Ht(t), 3 === t ? h : k([
                        A4(otn, r.gx, $k(r.dw), A2(vtn, t, e), Qrn),
                        A3(btn, r.tE, r.w_, t)
                    ]));
                }(), c = i.b;
                return b(m(r, {
                    fz: i.a,
                    fG: e
                }), Hu(A2(Ot, A2(jp, rtn, u), c)));
            case 1:
                return b(m(r, {
                    g0: Ht(n.a)
                }), Dp);
            case 2:
                var o = n.a, f = function() {
                    if (3 === o.$) {
                        var n = o.a;
                        return b(A4(stn, r.gx, $k(r.dw), mtn(n), Krn), fA(r.ab));
                    }
                    return b(Dp, r.ab);
                }(), s = f.a;
                return b(m(r, {
                    hm: o,
                    ab: f.b
                }), s);
            case 3:
                return b(m(r, {
                    ab: ND(r.ab)
                }), Dp);
            case 4:
                var l = A2(mq, n.a, r.ab), d = l.b;
                return b(m(r, {
                    ab: l.a
                }), A2(jp, Yrn, d));
            case 5:
                var p = n.a, $ = function() {
                    if (3 === p.$) {
                        var n = p.a;
                        return ltn(n) ? v(r.ab, !0, A2(Eu, rm(ntn), qp(2e3))) : v(ND(r.ab), !1, A2(uc, Dp, A2(Cp, QQ, ptn(n))));
                    }
                    return v(r.ab, !1, Dp);
                }();
                return d = $.c, b(m(r, {
                    hD: $.b,
                    ab: $.a
                }), d);
            case 6:
                var g = function() {
                    var n = r.hm;
                    if (3 === n.$) {
                        var t = n.a;
                        return A4(stn, r.gx, $k(r.dw), mtn(t), Krn);
                    }
                    return Dp;
                }();
                return b(r, g);
            case 7:
                var w = A2(uq, n.a, r.cT);
                return g = w.b, b(m(r, {
                    cT: w.a
                }), A2(jp, Trn, g));
            case 8:
                var x = A2(uq, n.a, r.ct);
                return g = x.b, b(m(r, {
                    ct: x.a
                }), A2(jp, Urn, g));
            default:
                return c = function() {
                    var n = b(r.cT.oD, r.ct.oD);
                    if (n.a.$ || n.b.$) return h;
                    var t = n.a.a, e = n.b.a;
                    return k([
                        A4(otn, r.gx, $k(r.dw), {
                            oD: Ht({
                                zy: t,
                                Ah: e
                            }),
                            wW: 0
                        }, Qrn),
                        A3(btn, r.tE, r.w_, 3)
                    ]);
                }(), b(m(r, {
                    hD: !0
                }), Hu(c));
        }
    }), htn = F2(function(n, r) {
        switch(n.$){
            case 0:
                var t = n.a;
                return 3 === t.$ ? v(m(r, {
                    g: t,
                    kR: A2(_8, A2(uc, 0, A2(Xb, lu, A2(Zu, "x-total-count", t.b))), r.kR)
                }), Dp, h) : v(m(r, {
                    g: oc
                }), Dp, A2(uA, 0, t));
            case 1:
                var e = m(r, {
                    kR: A2(y8, n.a, r.kR)
                });
                return v(e, zrn(e), h);
            case 2:
                var u = A2($tn, n.a, r.da), a = u.b;
                return v(m(r, {
                    da: u.a
                }), A2(jp, yrn, a), h);
            default:
                return v(r, A2(zx, oa, _a({
                    qU: n.a
                })), h);
        }
    }), gtn = function(n) {
        return {
            $: 3,
            a: n
        };
    }, wtn = function(n) {
        return n.a.oD;
    }, ktn = function(n) {
        return A2(dP, AA("/"), n);
    }, xtn = function(n) {
        return n.a.o9;
    }, ytn = function(n) {
        return n.a.pf;
    }, _tn = function(n) {
        return n.a.pg;
    }, Ctn = F2(function(n, r) {
        return r.q7(n);
    }), Dtn = F2(function(n, r) {
        return r.q8(n);
    }), Atn = A2(TS, PS(1), Ht(0)), qtn = function(n) {
        return A3($B, !1, !0, n);
    }, Btn = function(n) {
        return n.o9.y_;
    }, jtn = function(n) {
        return n.o9.BC;
    }, Stn = function(n) {
        return n.o9.DJ;
    }, ztn = function(n) {
        switch(n){
            case 0:
                return k([
                    Nk("tag--success")
                ]);
            case 1:
                return k([
                    Nk("tag--info")
                ]);
            case 3:
                return k([
                    Nk("tag--warning")
                ]);
            case 2:
                return k([
                    Nk("tag--danger")
                ]);
            case 4:
                return k([
                    Nk("tag--primary")
                ]);
            case 5:
                return k([
                    Nk("tag--primary-500")
                ]);
            default:
                return k([
                    Nk("tag--light-gray")
                ]);
        }
    }, Utn = F2(function(n, r) {
        return A2(Gk, A2(Ot, Nk("tag"), function(n) {
            return Gi(A2(yu, ztn, n));
        }(n)), r);
    }), Etn = F2(function(n, r) {
        var t, e;
        return e = (t = function() {
            switch(r){
                case 2:
                    return b(2, Btn);
                case 1:
                    return b(1, Stn);
                default:
                    return b(0, jtn);
            }
        }()).b, A2(Utn, k([
            t.a
        ]), k([
            ad(n(e))
        ]));
    }), Ptn = F2(function(n, r) {
        var t, e;
        return A2(Ik, k([
            Eq(gtn((e = r, e.a.qU))),
            Nk("flex flex-row space-x-2 cursor-pointer")
        ]), k([
            A2(Ik, k([
                Nk("flex flex-col mt-2")
            ]), k([
                A2(US, k([
                    Sz
                ]), 17)
            ])),
            A2(Ik, k([
                Nk("flex flex-col grow")
            ]), k([
                A2(Ik, k([
                    Nk("flex flex-row items-center")
                ]), k([
                    A2(PB, k([
                        OL,
                        LS(H7)
                    ]), k([
                        ad(n(Ctn(ktn(wtn(r)))))
                    ])),
                    A2(px, hu, A2(Etn, n, xtn(r)))
                ])),
                A2(Ik, k([
                    Nk("flex flex-row text-primary-500")
                ]), k([
                    A2(PB, h, k([
                        ad(n(Dtn(ktn(ytn(r)))))
                    ]))
                ])),
                A2(Ik, k([
                    Nk("flex flex-row mt-1")
                ]), k([
                    A2(PB, k([
                        LS(Atn)
                    ]), k([
                        ad((t = n(pd), t + ":"))
                    ])),
                    A2(PB, k([
                        OL
                    ]), k([
                        ad(qtn(_tn(r)))
                    ]))
                ]))
            ])),
            A2(Ik, k([
                Nk("flex flex-col justify-center text-primary-300")
            ]), k([
                A2(US, k([
                    Sz
                ]), 6)
            ]))
        ]));
    }), Ttn = F2(function(n, r) {
        return A2(Ik, k([
            Nk("invoices-list")
        ]), A2(SF, gx, A2(yu, Ptn(n), r)));
    }), Ftn = {
        $: 9
    }, Ltn = function(n) {
        return {
            $: 6,
            a: n
        };
    }, Mtn = Ltn(eU(0)), Htn = A2(TS, PS(0), Ht(2)), Rtn = F2(function(n, r) {
        return A2(Tz, k([
            jZ(k([
                ad(n(Rrn))
            ])),
            IS(k([
                A2(Gk, h, k([
                    ad(n(Orn))
                ])),
                A2(Ik, k([
                    Nk("flex justify-center my-12")
                ]), k([
                    Jk(k([
                        n5
                    ]))
                ]))
            ]))
        ]), r);
    }), Otn = F2(function(n, r) {
        var t, e = A2(yu, function(n) {
            return A2(Xz, h, n);
        }, k([
            0,
            1,
            2,
            3
        ])), u = (t = r.fz).$ || 3 !== t.a ? h : k([
            A2(Ik, fx(Htn), k([
                A2(AW, k([
                    bW(n(Irn))
                ]), k([
                    A2(px, Trn, A2(_P, h, r.cT))
                ]))
            ])),
            A2(Ik, fx(Htn), k([
                A2(AW, k([
                    bW(n(Hrn))
                ]), k([
                    A2(px, Urn, A2(_P, h, r.ct))
                ]))
            ])),
            A2(Ik, fx(Htn), k([
                A2(fz, k([
                    nz,
                    QS(Ftn),
                    ZS(i(r.cT.oD, Rt) || i(r.ct.oD, Rt))
                ]), k([
                    ad(n(i2))
                ]))
            ]))
        ]);
        return A2(Ot, A2(px, rtn, A4(AU, n, k([
            Mtn,
            ZL(n(i2))
        ]), e, r.fG)), $(u, k([
            A2(Rtn, n, r.ab)
        ])));
    }), Ntn = F2(function(n, r) {
        return A2(px, yrn, A2(lV, h, k([
            A2(iV, k([
                UZ(4)
            ]), A2(Otn, n, r))
        ])));
    }), Itn = function(n) {
        return {
            $: 1,
            a: n
        };
    }, Vtn = F2(function(n, r) {
        return {
            gF: k([
                A2(Ik, k([
                    Nk("panel")
                ]), function() {
                    var t, e = r.g;
                    switch(e.$){
                        case 3:
                            var u = e.a;
                            return k([
                                A2(Ik, h, ED(u) ? MS(n(Nd)) : k([
                                    A2(Ntn, n, r.da),
                                    A2(Ttn, n, u),
                                    (t = r.kR, A2(px, Itn, A2(e5, k([
                                        Q8
                                    ]), t)))
                                ]))
                            ]);
                        case 2:
                            return B3(n(Bd));
                        default:
                            return Yk;
                    }
                }())
            ]),
            wD: n(Ld)
        };
    }), Wtn = Ux({
        zO: Xrn,
        Ab: Grn,
        Ct: Jrn,
        Dd: function() {
            return A2(xD, yrn, xk(k([
                A2(xD, Yrn, _D())
            ])));
        },
        DB: htn,
        DH: Vtn
    }), Ztn = function(n) {
        return {
            $: 0,
            a: n
        };
    }, Xtn = function(n) {
        return {
            $: 2,
            a: n
        };
    }, Gtn = function(n) {
        return {
            $: 1,
            a: n
        };
    }, Jtn = F9(function(n, r, t, e, u, a, i, c, o) {
        return {
            mC: t,
            yA: i,
            g8: c,
            pV: r,
            qU: n,
            hM: e,
            ds: o,
            C1: a,
            wj: u
        };
    }), Ytn = function(n) {
        switch(n){
            case "processing":
                return Ke(0);
            case "invalid":
                return Ke(1);
            case "new_payment_source":
                return Ke(2);
            case "confirmed":
                return Ke(3);
            case "expiring":
                return Ke(4);
            case "warning":
                return Ke(5);
            case "failed":
                return Ke(6);
            case "blocked":
                return Ke(7);
            default:
                return yy("Unsupported Payment Method status: " + n);
        }
    }, Qtn = A4(Sy, "one_time_use", l_(xy), Rt, A3(zy, "default", xy, A3(zy, "created_at", tN, A3(zy, "type", w$, A3(zy, "status", A2(Ge, Ytn, w$), A3(zy, "last_four", l_(w$), A3(zy, "bank_name", l_(w$), A3(zy, "expected_to_succeed", xy, A3(zy, "id", w$, Ke(Jtn)))))))))), Ktn = A2(qy, A2(Ye, Gtn, Qtn), Ke(ru)), nen = function(n) {
        return {
            $: 0,
            a: n
        };
    }, ren = A4(Sy, "one_time_use", l_(xy), Rt, A3(zy, "funding", l_(w$), A3(zy, "zip", l_(w$), A3(zy, "default", xy, A3(zy, "exp_year", l_(C$), A3(zy, "exp_month", l_(C$), A3(zy, "created_at", tN, A3(zy, "type", w$, A3(zy, "status", A2(Ge, Ytn, w$), A3(zy, "last_four", l_(w$), A3(zy, "card_type", l_(w$), A3(zy, "expected_to_succeed", xy, A3(zy, "id", w$, Ke(function(n) {
        return function(r) {
            return function(t) {
                return function(e) {
                    return function(u) {
                        return function(a) {
                            return function(i) {
                                return function(c) {
                                    return function(o) {
                                        return function(f) {
                                            return function(s) {
                                                return function(l) {
                                                    return function(d) {
                                                        return {
                                                            m7: t,
                                                            yA: i,
                                                            g8: f,
                                                            hj: c,
                                                            hk: o,
                                                            pV: r,
                                                            qt: l,
                                                            qU: n,
                                                            hM: e,
                                                            ds: d,
                                                            C1: a,
                                                            wj: u,
                                                            xy: s
                                                        };
                                                    };
                                                };
                                            };
                                        };
                                    };
                                };
                            };
                        };
                    };
                };
            };
        };
    })))))))))))))), ten = A2(qy, A2(Ye, nen, ren), Ke(ru)), een = D$(k([
        ten,
        Ktn
    ])), uen = function(n) {
        return A2($y, k([
            "payment_sources"
        ]), gy(n));
    }, aen = F3(function(n, r, t) {
        return A4(dC, n, Ey(een), t, bC(uen(r)));
    }), ien = function(n) {
        return A3(aen, n.gx, $k(n.dw), Xtn);
    }, cen = F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    }), oen = F6(function(n, r, t, e, u, a) {
        return {
            nr: t,
            qr: a,
            rE: n,
            rF: r,
            wi: e,
            xy: u
        };
    }), fen = A4(Sy, "full_address", w$, "", A3(zy, "zip", A2(Ye, OC, w$), A3(zy, "state", w$, A3(zy, "city", w$, A3(zy, "line2", D$(k([
        A2(Ye, OC, w$),
        Ke("")
    ])), A3(zy, "line1", A2(Ye, OC, w$), Ke(oen))))))), sen = A2(qy, fen, Ke(ru)), len = F7(function(n, r, t, e, u, a, i) {
        return {
            l0: r,
            o0: i,
            qs: t,
            qU: u,
            sS: e,
            BT: n,
            xb: a
        };
    }), den = A3(zy, "distance", l_(_$), A3(zy, "virtual", xy, A3(zy, "id", w$, A3(zy, "name", w$, A3(zy, "full_name", w$, A3(zy, "address", l_(sen), A3(zy, "phone_number", l_(w$), Ke(len)))))))), ben = A2(qy, den, Ke(ru)), ven = F4(function(n, r, t, e) {
        return {
            oT: t,
            sS: n,
            BT: r,
            v5: e
        };
    }), men = A3(zy, "sources", Ey(een), A3(zy, "default_source", l_(een), A3(zy, "phone_number", l_(A2(Ye, OC, w$)), A3(zy, "name", A2(Ye, OC, w$), Ke(ven))))), pen = A2(qy, men, Ke(ru)), $en = F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    }), hen = F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    }), gen = F2(function(n, r) {
        return {
            qU: n,
            sS: r
        };
    }), wen = A3(zy, "name", A2(Ye, OC, w$), A3(zy, "id", w$, Ke(gen))), ken = A2(qy, wen, Ke(ru)), xen = F2(function(n, r) {
        return {
            qU: n,
            sS: r
        };
    }), yen = A3(zy, "name", w$, A3(zy, "id", w$, Ke(xen))), _en = A2(qy, yen, Ke(ru)), Cen = A3(zy, "code", l_(w$), A3(zy, "code_type", l_(w$), A3(zy, "practitioner", l_(_en), A3(zy, "patient", l_(ken), A3(zy, "quantity", C$, A3(zy, "end_date", l_(FC), A3(zy, "date", FC, A3(zy, "taxable", xy, A3(zy, "discount_in_cents", l_(C$), A3(zy, "subtotal_in_cents", C$, A3(zy, "description", l_(A2(Ye, OC, w$)), A3(zy, "name", A2(Ye, OC, w$), Ke(function(n) {
        return function(r) {
            return function(t) {
                return function(e) {
                    return function(u) {
                        return function(a) {
                            return function(i) {
                                return function(c) {
                                    return function(o) {
                                        return function(f) {
                                            return function(s) {
                                                return function(l) {
                                                    return {
                                                        nu: s,
                                                        nv: l,
                                                        oD: a,
                                                        oV: r,
                                                        oZ: e,
                                                        pC: i,
                                                        sS: n,
                                                        tE: o,
                                                        uj: f,
                                                        uN: c,
                                                        wr: t,
                                                        wz: u
                                                    };
                                                };
                                            };
                                        };
                                    };
                                };
                            };
                        };
                    };
                };
            };
        };
    }))))))))))))), Den = A2(IC, 0, A2(qy, Cen, Ke(hen))), Aen = A3(zy, "rate_charge", Den, Ke(function(n) {
        return {
            uU: n
        };
    })), qen = F3(function(n, r, t) {
        return {
            mi: r,
            oV: t,
            sS: n
        };
    }), Ben = A3(zy, "description", l_(A2(Ye, OC, w$)), A3(zy, "amount_in_cents", C$, A3(zy, "name", A2(Ye, OC, w$), Ke(qen)))), jen = A2(qy, A2(Ye, ru, Aen), A2(qy, Ben, Ke($en))), Sen = F3(function(n, r, t) {
        return {
            mi: t,
            C0: r,
            C1: n
        };
    }), zen = A3(zy, "amount_in_cents", C$, A4(Sy, "source_name", l_(w$), Rt, A3(zy, "source_type", w$, Ke(Sen)))), Uen = F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    }), Een = F2(function(n, r) {
        return {
            sS: r,
            uT: n
        };
    }), Pen = A3(zy, "name", w$, A3(zy, "rate", _$, Ke(Een))), Ten = A2(IC, 0, A2(qy, Pen, Ke(Uen))), Fen = F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    }), Len = F5(function(n, r, t, e, u) {
        return {
            mi: t,
            mv: r,
            oD: n,
            v3: e,
            wj: u
        };
    }), Men = function(n) {
        return {
            $: 1,
            a: n
        };
    }, Hen = F2(function(n, r) {
        return {
            zg: r,
            sS: n
        };
    }), Ren = A3(zy, "external", xy, A3(zy, "name", w$, Ke(Hen))), Oen = A2(qy, A2(Ye, Men, Ren), Ke(ru)), Nen = function(n) {
        return {
            $: 0,
            a: n
        };
    }, Ien = F2(function(n, r) {
        return {
            hM: r,
            sS: n
        };
    }), Ven = A3(zy, "last_four", l_(w$), A3(zy, "name", w$, Ke(Ien))), Wen = A2(qy, A2(Ye, Nen, Ven), Ke(ru)), Zen = D$(k([
        Wen,
        Oen
    ])), Xen = A3(zy, "status", w$, A3(zy, "source", Zen, A3(zy, "amount_in_cents", C$, A3(zy, "attempted_in_cents", C$, A3(zy, "date", FC, Ke(Len)))))), Gen = A3(zy, "refunded_in_cents", C$, Ke(function(n) {
        return {
            u1: n
        };
    })), Jen = A2(qy, A2(Ye, ru, Gen), A2(qy, Xen, Ke(Fen))), Yen = A3(zy, "payments", Ey(Jen), A3(zy, "tax_profile", l_(Ten), A3(zy, "charge_group", l_(jen), A3(zy, "charges", Ey(Den), A3(zy, "billing_address", l_(sen), A3(zy, "location", l_(ben), A3(zy, "owner", pen, A3(zy, "secure_pdf_printable_token", l_(atn), A3(zy, "secure_pdf_inline_token", l_(atn), A4(Sy, "savings_items", Ey(zen), h, A3(zy, "discount_savings_in_cents", C$, A3(zy, "due_in_cents", C$, A4(Sy, "passthrough_fees_in_cents", C$, 0, A3(zy, "paid_in_cents", C$, A3(zy, "credit_in_cents", C$, A3(zy, "transferred_to_credit_in_cents", C$, A3(zy, "subtotal_in_cents", C$, A3(zy, "tax_in_cents", C$, A3(zy, "revision_number", C$, A3(zy, "invoice_number", C$, A3(zy, "total_in_cents", C$, A3(zy, "document_status", A2(Ge, Arn, w$), A3(zy, "date", FC, A3(zy, "id", w$, Ke(function(n) {
        return function(r) {
            return function(t) {
                return function(e) {
                    return function(u) {
                        return function(a) {
                            return function(i) {
                                return function(c) {
                                    return function(o) {
                                        return function(f) {
                                            return function(s) {
                                                return function(l) {
                                                    return function(d) {
                                                        return function(b) {
                                                            return function(v) {
                                                                return function(m) {
                                                                    return function(p) {
                                                                        return function($) {
                                                                            return function(h) {
                                                                                return function(g) {
                                                                                    return function(w) {
                                                                                        return function(k) {
                                                                                            return function(x) {
                                                                                                return function(y) {
                                                                                                    return {
                                                                                                        mG: g,
                                                                                                        ne: k,
                                                                                                        nh: w,
                                                                                                        ot: f,
                                                                                                        oD: r,
                                                                                                        yS: b,
                                                                                                        o9: t,
                                                                                                        pg: d,
                                                                                                        qU: n,
                                                                                                        ra: u,
                                                                                                        ku: h,
                                                                                                        tq: $,
                                                                                                        tx: s,
                                                                                                        tD: l,
                                                                                                        tZ: y,
                                                                                                        vs: a,
                                                                                                        vw: v,
                                                                                                        vz: m,
                                                                                                        CA: p,
                                                                                                        wr: c,
                                                                                                        wx: i,
                                                                                                        wy: x,
                                                                                                        lr: e,
                                                                                                        wS: o
                                                                                                    };
                                                                                                };
                                                                                            };
                                                                                        };
                                                                                    };
                                                                                };
                                                                            };
                                                                        };
                                                                    };
                                                                };
                                                            };
                                                        };
                                                    };
                                                };
                                            };
                                        };
                                    };
                                };
                            };
                        };
                    };
                };
            };
        };
    }))))))))))))))))))))))))), Qen = A2(IC, 0, A2(qy, Yen, Ke(cen))), Ken = F2(function(n, r) {
        return A2($y, k([
            "customer_invoices",
            r
        ]), gy(n));
    }), nun = F4(function(n, r, t, e) {
        return A4(dC, n, Qen, e, bC(A2(Ken, r, t)));
    }), run = F3(function(n, r, t) {
        var e = {
            gx: r.gx,
            yl: r.yl,
            c9: oc,
            dc: Rt,
            kj: r.kj,
            qU: t.BD.qU,
            e8: oc,
            tE: r.tL,
            dw: n,
            v5: oc,
            w_: t
        };
        return b(e, Hu(k([
            A4(nun, r.gx, $k(n), t.BD.qU, Ztn),
            ien(e)
        ])));
    }), tun = function(n) {
        return n.oT;
    }, eun = function(n) {
        return n.a.pg;
    }, uun = function(n) {
        return {
            $: 3,
            a: n
        };
    }, aun = F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    }), iun = F2(function(n, r) {
        return {
            tA: n,
            lr: r
        };
    }), cun = A3(zy, "total_in_cents", C$, A3(zy, "passthrough_fees_in_cents", C$, Ke(iun))), oun = A2(qy, cun, Ke(ru)), fun = Ke({}), sun = A2(qy, fun, A2(qy, oun, Ke(aun))), lun = F3(function(n, r, t) {
        return A2($y, k([
            "payment_methods",
            r,
            "passthroughs",
            ee(t)
        ]), gy(n));
    }), dun = F5(function(n, r, t, e, u) {
        return A4(dC, n, sun, u, bC(A3(lun, r, t, e)));
    }), bun = function(n) {
        return n.a.qU;
    }, vun = function(n) {
        return !n.$;
    }, mun = function(n) {
        return A2(uc, !1, A2(Cp, vun, n));
    }, pun = F3(function(n, r, t) {
        var e = n.dw, u = n.gx;
        if (n.yl && mun(t)) {
            var a = A2(Cp, bun, t);
            if (a.$) return Dp;
            var i = a.a;
            return A5(dun, u, $k(e), i, r, uun);
        }
        return Dp;
    }), $un = function(n) {
        return n.a.tq;
    }, hun = F2(function(n, r) {
        var t = m(r, {
            yl: n.yl,
            tE: n.tL
        }), e = b(r.c9, n.tL);
        if (3 === e.a.$ && 3 === e.b.$) {
            var u = e.a.a;
            return b(t, A3(pun, t, eun(u), tun($un(u))));
        }
        return b(t, Dp);
    }), gun = F2(function(n, r) {
        return m(r, {
            xE: Ht(0)
        });
    }), wun = function(n) {
        return {
            $: 1,
            a: n
        };
    }, kun = F3(function(n, r, t) {
        return {
            yq: n,
            BW: r,
            wL: t
        };
    }), xun = {
        $: 2
    }, yun = function(n) {
        return {
            $: 1,
            a: n
        };
    }, _un = F2(function(n, r) {
        switch(r.$){
            case 0:
            default:
                return v(n, function(n) {
                    return A4(stn, n.yq, n.BW, n.wL, yun);
                }(n), h);
            case 1:
                var t = r.a;
                if (3 === t.$) {
                    var e = t.a;
                    return ltn(e) ? v(n, A2(Eu, function() {
                        return xun;
                    }, qp(2e3)), h) : v(n, A2(uc, Dp, A2(Cp, QQ, ptn(e))), h);
                }
                return v(n, Dp, A2(uA, 0, t));
        }
    }), Cun = F2(function(n, r) {
        switch(n.$){
            case 0:
                var t = n.a;
                if (3 === t.$) {
                    var e = A2(Xb, function(n) {
                        return Ht(A3(kun, r.gx, $k(r.dw), n));
                    }, t.a.a.vz);
                    return v(m(r, {
                        c9: t,
                        dc: e
                    }), Dp, A2(uA, 0, t));
                }
                return v(m(r, {
                    c9: t
                }), Dp, A2(uA, 0, t));
            case 1:
                var u = n.a, a = r.dc;
                if (a.$) return v(r, Dp, h);
                var i = A2(_un, e = a.a, u), c = i.b, o = i.c;
                return v(m(r, {
                    dc: Ht(i.a)
                }), A2(jp, wun, c), o);
            case 2:
                var f = n.a;
                return 3 === f.$ ? v(m(r, {
                    v5: f
                }), Dp, h) : v(m(r, {
                    v5: oc
                }), Dp, A2(uA, 0, f));
            default:
                return v(m(r, {
                    e8: n.a
                }), Dp, h);
        }
    }), Dun = {
        $: 10
    }, Aun = function(n) {
        return n.a.oD;
    }, qun = function(n) {
        return A2(dP, AA("/"), n);
    }, Bun = function(n) {
        return A2(Gk, k([
            Nk("text-support")
        ]), k([
            A2(gV, k([
                n0,
                vV(Sx(ya))
            ]), k([
                ad(n(Ld))
            ]))
        ]));
    }, jun = {
        $: 0
    }, Sun = F3(function(n, r, t) {
        var e, u = r.gx, a = r.dc.$ ? Sq : A2(px, wun, (e = k([
            A2(US, h, 16)
        ]), A2(fz, k([
            r4,
            vz(k([
                Nk("mr-3")
            ])),
            QS(jun)
        ]), e))), i = P7(u) ? h : k([
            Bun(n),
            A2(Gk, k([
                Nk("mx-3 text-support")
            ]), k([
                ad("/")
            ])),
            ad(qun(Aun(t)))
        ]);
        return A2(Ik, h, k([
            A2(lV, k([
                dV(NZ)
            ]), k([
                A2(iV, k([
                    uV(gz),
                    jV(k([
                        Nk("flex")
                    ]))
                ]), $(i, k([
                    A2(Gk, k([
                        Nk("text-primary-300 grow text-right")
                    ]), k([
                        a
                    ]))
                ])))
            ])),
            A2(lV, k([
                dV(NZ)
            ]), k([
                A2(iV, h, k([
                    gx
                ]))
            ]))
        ]));
    }), zun = function(n) {
        return n.a.o9;
    }, Uun = A2(TS, TV, Ht(0)), Eun = function(n) {
        return n.a.vs;
    }, Pun = function(n) {
        return "#" + ee(n.a.ra) + (Eun(n) ? "(rev. " + ee(Eun(n)) + ")" : "");
    }, Tun = function(n) {
        return n.sS;
    }, Fun = function(n) {
        return A2(dA, "passthrough_credit_card_fees", n);
    }, Lun = function(n) {
        return function(n) {
            return n.lr;
        }(n.a);
    }, Mun = function(n) {
        return 3 === n.$ ? Lun(n.a) : 0;
    }, Hun = function(n) {
        return n.a.tZ;
    }, Run = function(n) {
        return n.a.vw;
    }, Oun = function(n) {
        return A2(zZ, 2, n);
    }, Nun = hz(2), Iun = A2(TS, PS(0), Ht(3)), Vun = A2(TS, PS(0), Rt), Wun = F2(function(n, r) {
        return Gx(k([
            ad(n(r))
        ]));
    }), Zun = function(n) {
        var r, t, e, u = (r = Rnn(n), t = function(n) {
            var r = Hnn(n), t = Pnn(n), e = b(tI(t), tI(r));
            return e.a && e.b ? "" : A2(ue, ", ", A2(Tc, function(n) {
                return !tI(n);
            }, k([
                t,
                r
            ])));
        }(n), (e = b(tI(t), Fnn(r))).a && e.b ? Rt : Ht(k([
            ad(t),
            Jx(r),
            A2(Q4, h, h)
        ]))), a = Fnn(Mnn(n)) ? Rt : Ht(k([
            Jx(Mnn(n)),
            A2(Q4, h, h)
        ])), i = Fnn(Lnn(n)) ? Rt : Ht(k([
            Jx(Lnn(n)),
            A2(Q4, h, h)
        ]));
        return A3(xu, re, h, A2(Ep, ru, k([
            i,
            a,
            u
        ])));
    }, Xun = function(n) {
        var r = function(n) {
            return n.BT;
        }($un(n)), t = function(n) {
            return n.a.mG;
        }(n), e = b(t, r);
        return e.a.$ ? e.b.$ ? h : k([
            A2(Wun, dF, e.b.a)
        ]) : Gi(k([
            Zun(e.a.a),
            A2(uc, h, A2(Cp, A2(Je, Wun(dF), Gq), r))
        ]));
    }, Gun = function(n) {
        return n.l0;
    }, Jun = function(n) {
        return n.BT;
    }, Yun = function(n) {
        return A2(uc, h, A2(Cp, A2(Je, ad, Gq), A2(Cp, dF, n)));
    }, Qun = F2(function(n, r) {
        var t, e = r.a.ku;
        return A2(hx, h, (t = b(A2(Xb, Gun, e), Enn(n))).a.$ ? t.b.$ ? h : Gi(k([
            Zun(t.b.a),
            Yun(kF(n))
        ])) : Gi(k([
            Zun(t.a.a),
            Yun(A2(Xb, Jun, e))
        ])));
    }), Kun = function(n) {
        return n.a.ne;
    }, nan = function(n) {
        return n.a.mi;
    }, ran = function(n) {
        return n.a.oD;
    }, tan = function(n) {
        return n.a.pC;
    }, ean = function(n) {
        return n.qU;
    }, uan = function(n) {
        return n.sS;
    }, aan = function(n) {
        return n.a.tE;
    }, ian = function(n) {
        return n.a.uN;
    }, can = function(n) {
        return n.a.wz;
    }, oan = F2(function(n, r) {
        var t = r.b.uU, e = r.a.sS;
        return Gi(k([
            k([
                ad("Charge group")
            ]),
            function() {
                var n = aan(t);
                if (n.$) return h;
                var r = n.a;
                return k([
                    A2(Ik, h, k([
                        Jx(uan(r)),
                        ad("(" + ean(r) + ")")
                    ]))
                ]);
            }(),
            k([
                A2(Ik, h, k([
                    ad(qun(ran(t)))
                ]))
            ]),
            k([
                ad(A2(uc, "", A2(Cp, qun, tan(t))))
            ]),
            ian(t) > 1 ? k([
                A2(Ik, h, k([
                    ad(ee(ian(t)) + " x "),
                    Jx(e)
                ]))
            ]) : k([
                A2(Ik, h, k([
                    Jx(e)
                ]))
            ]),
            function() {
                var n = function(n) {
                    return n.a.oV;
                }(r);
                if (n.$) return h;
                var t = n.a;
                return Fnn(t) ? h : k([
                    A2(Ik, h, k([
                        ad("Note: "),
                        Jx(t)
                    ]))
                ]);
            }(),
            k([
                A2(Ik, h, k([
                    ad(qtn(nan(r))),
                    can(t) ? ad(n(Pd)) : Sq
                ]))
            ])
        ]));
    }), fan = F2(function(n, r) {
        var t = Kun(r);
        return t.$ ? Sq : A2(Ik, h, A2(oan, n, t.a));
    }), san = function(n) {
        return n.mg;
    }, lan = function(n) {
        return n.a.nh;
    }, dan = function(n) {
        return n.sS;
    }, ban = function(n) {
        return n.a.wr;
    }, van = function(n) {
        var r, t = function() {
            var r = b(n.a.oZ, ban(n));
            if (r.a.$) return 0;
            var t = r.a.a;
            return t > 0 ? t + r.b : 0;
        }(), e = can(n), u = qtn(ban(n)), a = ee(ian(n)), i = A2(Cp, dan, n.a.uj), c = function(n) {
            var r = function() {
                var r = b(function(n) {
                    return n.a.nu;
                }(n), function(n) {
                    return n.a.nv;
                }(n));
                if (r.a.$ || r.b.$) return "";
                var t = r.b.a;
                return " (" + lv(r.a.a) + ": " + t + ")";
            }();
            return $(n.a.sS, r);
        }(n), o = A2(Cp, uan, aan(n)), f = A2(uc, Sq, A2(Cp, Jx, o)), s = (r = b(i, o)).a.$ || r.b.$ ? "" : " with " + r.a.a, l = A2(uc, Sq, A2(Cp, Jx, function(n) {
            return n.a.oV;
        }(n))), d = function(n) {
            var r = tan(n);
            if (r.$) return qun(ran(n));
            var t = r.a;
            return qun(ran(n)) + " - " + qun(t);
        }(n);
        return {
            oD: d,
            oV: l,
            sS: c,
            kU: f,
            dx: i,
            k_: s,
            uN: a,
            wq: u,
            wz: e,
            fO: t
        };
    }, man = function(n) {
        return n.rl;
    }, pan = function(n) {
        return n.tE;
    }, $an = function(n) {
        return n.uO;
    }, han = function(n) {
        return {
            $: 1,
            a: n
        };
    }(Nun), gan = F2(function(n, r) {
        return A3(j2, Rt, n, r);
    }), wan = {
        $: 4,
        a: 1
    }, kan = function(n) {
        return n.fO > 0 ? A2(hx, k([
            wan,
            BB
        ]), k([
            ad(qtn(n.fO))
        ])) : Sq;
    }, xan = F2(function(n, r) {
        return A2(k2, h, k([
            A2(p2, h, k([
                A2(Gk, h, k([
                    A2(LB, h, k([
                        r.kU
                    ])),
                    A2(PB, h, k([
                        ad(r.k_)
                    ]))
                ]))
            ])),
            A2(p2, h, k([
                ad(r.oD)
            ])),
            A2(p2, h, k([
                Jx(r.sS),
                A2(hx, h, k([
                    r.oV
                ]))
            ])),
            A2(p2, h, k([
                ad(r.uN)
            ])),
            A2(p2, k([
                han
            ]), k([
                A2(Gk, k([
                    Nk("inline-flex items-center gap-2")
                ]), k([
                    kan(r),
                    ad(r.wq)
                ])),
                r.wz ? ad(n(Pd)) : Sq
            ]))
        ]));
    }), yan = {
        $: 11
    }, _an = F2(function(n, r) {
        return r.tf(n);
    }), Can = F2(function(n, r) {
        var t = r.fO > 0, e = t ? 12 : 3, u = t ? 12 : 9;
        return A2(lV, k([
            yan,
            UZ(12)
        ]), k([
            A2(iV, k([
                UZ(u)
            ]), k([
                A2(LB, h, k([
                    r.kU
                ])),
                A2(hx, h, k([
                    Jx(r.sS)
                ])),
                A2(hx, k([
                    BB
                ]), k([
                    ad(r.uN + " x " + r.wq + " "),
                    ad(n(_an(r.oD)))
                ]))
            ])),
            A2(iV, k([
                jV(k([
                    Nk("mb-8 invoice-row-price")
                ])),
                UZ(e),
                uV(Nun)
            ]), k([
                A2(Gk, k([
                    Nk("inline-flex items-center gap-1")
                ]), k([
                    kan(r),
                    A2(LB, h, k([
                        ad(r.wq)
                    ]))
                ])),
                r.wz ? A2(hx, k([
                    BB
                ]), k([
                    ad(n(Pd))
                ])) : Sq
            ]))
        ]));
    }), Dan = F2(function(n, r) {
        return A2(lV, k([
            dV(NZ)
        ]), k([
            A2(iV, h, k([
                A2(hx, k([
                    BB,
                    LS(aV),
                    bz(gz)
                ]), k([
                    ad(n($d)),
                    ad(":")
                ])),
                A2(Ik, k([
                    Nk("hidden sm:block")
                ]), k([
                    A2(lV, h, k([
                        A2(iV, k([
                            UZ(12)
                        ]), k([
                            A2(gan, k([
                                A2($2, h, n(pan)),
                                A2($2, h, n(EI)),
                                A2($2, h, n(man)),
                                A2($2, h, n($an)),
                                A2($2, k([
                                    han
                                ]), n(san))
                            ]), A2(yu, xan(n), A2(yu, van, lan(r))))
                        ]))
                    ]))
                ])),
                A2(Ik, k([
                    Nk("sm:hidden mb-4")
                ]), A2(yu, Can(n), A2(yu, van, lan(r))))
            ]))
        ]));
    }), Aan = function(n) {
        return n.b.lA;
    }, qan = function(n) {
        return n.b.lC;
    }, Ban = F3(function(n, r, t) {
        var e = oe(t) > 0 || Aan(r) || qan(r);
        return eun(n) > 0 && e;
    }), jan = function(n) {
        return n.a.qU;
    }, San = F5(function(n, r, t, e, u) {
        var a = Sx(Ca({
            qU: jan(t)
        })), i = A2(Xi, k([
            DV,
            vV(a)
        ]), u);
        return A3(Ban, t, r, e) ? A2(gV, i, k([
            ad(n(zd))
        ])) : Sq;
    }), zan = {
        $: 2
    }, Uan = function(n) {
        return n.a.mi;
    }, Ean = function(n) {
        return n.a.oD;
    }, Pan = ru, Tan = A2(TS, PS(1), Ht(2)), Fan = function(n) {
        return n.a.sS;
    }, Lan = function(n) {
        return A2(LB, h, function() {
            var r = function(n) {
                return n.$ ? Rt : n.a.hM;
            }(n);
            if (r.$) return k([
                ad(Fan(n))
            ]);
            var t = r.a;
            return k([
                ad(Fan(n) + " *" + t)
            ]);
        }());
    }, Man = F2(function(n, r) {
        var t = r.a.v3, e = r.b.u1 > 0, u = e ? 12 : 8, a = function(n) {
            return n.a.mv;
        }(r), i = e ? 12 : 4;
        return Pan(k([
            A2(lV, k([
                dV(NZ)
            ]), k([
                A2(iV, k([
                    UZ(12),
                    GZ(2)
                ]), k([
                    Lan(t)
                ])),
                A2(iV, k([
                    UZ(u),
                    GZ(7)
                ]), k([
                    A2(hx, k([
                        BB
                    ]), k([
                        ad(n(_an(qun(Ean(r)))))
                    ]))
                ])),
                A2(iV, k([
                    UZ(i),
                    GZ(3),
                    uV(Nun),
                    jV(k([
                        Nk("invoice-row-price")
                    ]))
                ]), k([
                    e ? A2(PB, k([
                        wan,
                        LS(Tan)
                    ]), k([
                        ad(qtn(a))
                    ])) : Sq,
                    ad(qtn(Uan(r)))
                ]))
            ]))
        ]));
    }), Han = function(n) {
        return {
            $: 4,
            a: n
        };
    }, Ran = function(n) {
        return "w-1/" + ee(n);
    }, Oan = function(n) {
        switch(n.$){
            case 0:
                return k([
                    Nk(Ran(r = n.a))
                ]);
            case 1:
                var r = n.b;
                return k([
                    Nk($(ex(n.a), Ran(r)))
                ]);
            default:
                return h;
        }
    }, Nan = function(n) {
        switch(n.$){
            case 2:
                return k([
                    Nk("list--bordered")
                ]);
            case 3:
                return k([
                    Nk("list--bulleted")
                ]);
            case 4:
                return fx(n.a);
            default:
                return h;
        }
    }, Ian = F2(function(n, r) {
        var t = r;
        return A2(Rq, A2(Ot, Nk("list__item"), n), t);
    }), Van = F2(function(n, r) {
        var t = A2(Ji, Nan, n), e = A2(Ji, Oan, n);
        return A2(Oq, A2(Ot, Nk("list"), t), A2(yu, Ian(e), r));
    }), Wan = F2(function(n, r) {
        return ED(r) ? Sq : A2(Ik, h, k([
            A2(hx, k([
                BB,
                LS(aV),
                bz(gz)
            ]), k([
                ad(n(Ed)),
                ad(":")
            ])),
            A2(Van, k([
                zan,
                Han(q3)
            ]), A2(yu, Man(n), r))
        ]));
    }), Zan = F2(function(n, r) {
        var t = qtn(r.mi), e = n(Od) + " " + t, u = function() {
            var t = b(r.C1, r.C0);
            n: for(;;)if (t.b.$) switch(t.a){
                case "package":
                    return e + " " + n(Ad);
                case "membership":
                    return e + " " + n(Dd);
                default:
                    break n;
            }
            else switch(t.a){
                case "package":
                    var u = t.b.a;
                    return e + " " + n(Cd) + " " + u;
                case "membership":
                    return u = t.b.a, e + " " + n(Cd) + " " + u;
                default:
                    break n;
            }
            return e;
        }();
        return A2(lV, k([
            jV(k([
                Nk("mx-3")
            ]))
        ]), k([
            A2(iV, k([
                UZ(12),
                uV(Nun)
            ]), k([
                A2(Gk, k([
                    Nk("ribbon")
                ]), k([
                    ad(u)
                ]))
            ]))
        ]));
    }), Xan = function(n) {
        return n.a.ot;
    }, Gan = function(n) {
        return b(A2(Ot, BV(k([
            Nk("column--offset")
        ])), n), h);
    }, Jan = function(n) {
        return n.a.tx;
    }, Yan = function(n) {
        return n.a.tD;
    }, Qan = function(n) {
        return function(n) {
            return n.tA;
        }(n.a);
    }, Kan = function(n) {
        return n.a.wr;
    }, nin = function(n) {
        return n.a.wx;
    }, rin = function(n) {
        return n.a.sS;
    }, tin = function(n) {
        return n.a.wy;
    }, ein = function(n) {
        return n.$ ? "" : rB(n.a.a.uT) + "%";
    }, uin = function(n) {
        return n.a.lr;
    }, ain = function(n) {
        return n.a.wS;
    }, iin = F3(function(n, r, t) {
        return A2(lV, k([
            dV(FS)
        ]), k([
            A2(iV, k([
                UZ(8)
            ]), k([
                A2(hx, k([
                    BB
                ]), k([
                    ad(n)
                ]))
            ])),
            A2(iV, k([
                UZ(4),
                uV(Nun)
            ]), k(t ? [
                A2(LB, k([
                    PL
                ]), k([
                    ad(qtn(r))
                ]))
            ] : [
                A2(hx, h, k([
                    ad(qtn(r))
                ]))
            ]))
        ]));
    }), cin = F3(function(n, r, t) {
        return r > 0 ? A3(iin, n, r, t) : Sq;
    }), oin = F2(function(n, r) {
        return A2(lV, k([
            dV(FS)
        ]), k([
            A2(iV, k([
                UZ(6)
            ]), k([
                A2(hx, k([
                    BB
                ]), k([
                    ad(n)
                ]))
            ])),
            A2(iV, k([
                UZ(6),
                uV(Nun)
            ]), k([
                A2(LB, k([
                    rx
                ]), k([
                    ad(qtn(r))
                ]))
            ]))
        ]));
    }), fin = F5(function(n, r, t, e, u) {
        var a, i, c = tun($un(r)), o = e && mun(c) && eun(r) > 0;
        return Fun(t) ? A2(lV, k([
            jV(k([
                Nk("mx-3")
            ]))
        ]), k([
            Gan(k([
                UZ(3),
                GZ(7),
                Oun(6)
            ])),
            A2(iV, k([
                UZ(9),
                GZ(5),
                Oun(6)
            ]), k([
                nin(r) > 0 ? A3(iin, lv(n(Td)), Kan(r), !1) : Sq,
                A3(cin, lv(n(Fd)) + " (" + lv((i = tin(r), A2(uc, "", A2(Cp, rin, i)))) + " " + ein(tin(r)) + ")", nin(r), !1),
                A3(cin, lv(n(qd)), uin(r), !0),
                A3(cin, lv(n(Rd)), ain(r), !1),
                Xan(r) > 0 || Jan(r) > 0 ? gx : Sq,
                Xan(r) > 0 ? A3(iin, lv(n(hd)), -1 * Xan(r), !1) : Sq,
                Jan(r) > 0 ? A3(iin, lv(n(Sd)), -1 * Jan(r), !1) : Sq,
                Yan(r) > 0 ? A3(iin, lv(n(yd)), -1 * Yan(r), !1) : Sq,
                gx,
                o ? A3(cin, lv(n(gd)), (a = u, 3 === a.$ ? Qan(a.a) : 0), !1) : Sq,
                A2(oin, lv(n(_d)), o ? Mun(u) : eun(r))
            ]))
        ])) : A2(lV, k([
            jV(k([
                Nk("mx-3")
            ]))
        ]), k([
            Gan(k([
                UZ(3),
                GZ(7),
                Oun(8)
            ])),
            A2(iV, k([
                UZ(9),
                GZ(5),
                Oun(4),
                uV(Nun)
            ]), k([
                nin(r) > 0 ? A3(iin, n(Td), Kan(r), !1) : Sq,
                A3(cin, ein(tin(r)) + " " + n(Fd), nin(r), !1),
                A3(cin, n(Md) + ":", uin(r), !0),
                A3(cin, n(Rd), ain(r), !1),
                A3(cin, n(hd), Xan(r), !1),
                A3(cin, n(Sd), Jan(r), !1),
                gx,
                A3(iin, n(_d) + ":", eun(r), !1)
            ]))
        ]));
    }), sin = F4(function(n, r, t, e) {
        var u, a, i, c = r.dw, o = r.yl, f = r.e8;
        return A2(Ik, k([
            Nk("text-left")
        ]), k([
            A2(lV, k([
                uV(kz),
                uV(yz),
                dV(NZ)
            ]), k([
                A2(iV, k([
                    UZ(6),
                    Oun(4),
                    uV(kz),
                    jV(k([
                        Nk("flex")
                    ]))
                ]), k([
                    A2(UV, k([
                        Qk(k([
                            Nk("text-primary-300 sm:text-xl")
                        ])),
                        bz(kz)
                    ]), k([
                        ad(qun(Aun(t)))
                    ])),
                    A2(Gk, h, k([
                        A2(px, hu, A2(Etn, n, zun(t)))
                    ]))
                ])),
                A2(iV, k([
                    UZ(6),
                    Oun(8),
                    uV(Nun)
                ]), k([
                    A5(San, n, c, t, e, h)
                ]))
            ])),
            A2(lV, k([
                dV(Iun),
                dV(E4),
                A2(XZ, 2, aV)
            ]), k([
                A2(iV, k([
                    Oun(4)
                ]), k([
                    A2(LB, h, k([
                        ad(hk(c))
                    ])),
                    A2(Qun, c, t)
                ])),
                A2(iV, k([
                    jV(k([
                        Nk("hidden md:block")
                    ])),
                    Oun(4)
                ]), k([
                    A2(LB, h, k([
                        Jx(Tun($un(t)))
                    ])),
                    A2(Ik, h, Xun(t))
                ])),
                A2(iV, k([
                    Oun(4),
                    dV(Uun),
                    A2(XZ, 2, FV)
                ]), k([
                    A2(lV, k([
                        dV(FS),
                        dV(Htn),
                        A2(XZ, 2, Vun)
                    ]), k([
                        A2(iV, k([
                            UZ(6)
                        ]), k([
                            A2(hx, k([
                                BB
                            ]), k([
                                ad(n(jd)),
                                ad(": ")
                            ]))
                        ])),
                        A2(iV, k([
                            UZ(6)
                        ]), k([
                            A2(hx, k([
                                bz(Nun)
                            ]), k([
                                ad(Pun(t))
                            ]))
                        ]))
                    ])),
                    A2(lV, k([
                        dV(FS)
                    ]), k([
                        A2(iV, k([
                            UZ(6)
                        ]), k([
                            A2(hx, k([
                                BB
                            ]), k([
                                ad(n(Hd)),
                                ad(": ")
                            ]))
                        ])),
                        (u = tun($un(t)), a = o && mun(u), i = b(Fun(c), a), A2(iV, k([
                            UZ(6)
                        ]), k(i.a && i.b ? [
                            A2(hx, k([
                                bz(Nun)
                            ]), k([
                                ad(qtn(Mun(f)))
                            ]))
                        ] : [
                            A2(hx, k([
                                bz(Nun)
                            ]), k([
                                ad(qtn(eun(t)))
                            ]))
                        ])))
                    ]))
                ]))
            ])),
            A2(Wan, n, Hun(t)),
            A2(Dan, n, t),
            A2(fan, n, t),
            A5(fin, n, t, c, o, f),
            A2(Ik, k([
                Nk("flex flex-col gap-2")
            ]), A2(yu, Zan(n), Run(t)))
        ]));
    }), lin = F3(function(n, r, t) {
        var e, u = 3 === (e = r.v5).$ ? e.a : h;
        return k([
            A2(Ik, k([
                Nk("panel")
            ]), k([
                A3(Sun, n, r, t),
                A4(sin, n, r, t, u),
                A2(Ik, k([
                    Nk("md:hidden")
                ]), k([
                    A5(San, n, r.dw, t, u, k([
                        Dun
                    ]))
                ]))
            ]))
        ]);
    }), din = function(n) {
        return A2(gV, k([
            vV("mailto:" + n),
            n0
        ]), k([
            ad(n)
        ]));
    }, bin = function(n) {
        return A2(gV, k([
            vV("tel:" + n),
            n0
        ]), k([
            ad(n)
        ]));
    }, vin = function(n) {
        var r = b(kF(n), lk(n));
        if (r.a.$) return r.b.$ ? h : (e = r.b.a, k([
            ad(" at "),
            din(e)
        ]));
        if (r.b.$) return t = r.a.a, k([
            ad(" at "),
            bin(t)
        ]);
        var t = r.a.a, e = r.b.a;
        return k([
            ad(" at "),
            bin(t),
            ad(" or "),
            din(e)
        ]);
    }, min = function(n) {
        return A2(Ik, k([
            Nk("panel")
        ]), k([
            A2(mx, k([
                LS(q3)
            ]), k([
                ad("There was an error loading your bill")
            ])),
            A2(hx, k([
                BB
            ]), Gi(k([
                k([
                    ad("Please contact " + hk(n))
                ]),
                vin(n),
                k([
                    ad("to request an updated bill.")
                ])
            ])))
        ]));
    }, pin = F2(function(n, r) {
        return {
            gF: k([
                A2(Ik, h, function() {
                    var t = b(r.c9, r.tE);
                    n: for(;;)switch(t.a.$){
                        case 3:
                            if (3 === t.b.$) return A3(lin, n, r, t.a.a);
                            break n;
                        case 2:
                            return k([
                                A2(px, hu, min(r.dw))
                            ]);
                        default:
                            break n;
                    }
                    return Yk;
                }())
            ]),
            wD: hk(r.dw)
        };
    }), $in = Ux({
        zO: run,
        Ab: hun,
        Ct: gun,
        Dd: function() {
            return yk;
        },
        DB: Cun,
        DH: pin
    }), hin = function(n) {
        return {
            $: 0,
            a: n
        };
    }, gin = function(n) {
        return {
            $: 6,
            a: n
        };
    }, win = function(n) {
        return {
            $: 3,
            a: n
        };
    }, kin = {
        $: 0
    }, xin = {
        gM: ""
    }, yin = function(n) {
        return {
            $: 1,
            a: n
        };
    }, _in = F3(function(n, r, t) {
        return {
            xP: t,
            BL: r,
            CI: n
        };
    }), Cin = function(n) {
        return {
            $: 0,
            a: n
        };
    }, Din = D$(k([
        A2(Ge, function(n) {
            switch(n){
                case "stripe":
                    return A2(Ye, Cin, A2(Zy, k([
                        "stripe_client_secret"
                    ]), w$));
                case "rainforest":
                    return A2(Ye, yin, A4(IG, _in, A2(Zy, k([
                        "session_key"
                    ]), w$), A2(Zy, k([
                        "payment_method_config_id"
                    ]), w$), A2(Zy, k([
                        "allowed_methods"
                    ]), w$)));
                default:
                    return yy("Unsupported processor " + n);
            }
        }, A2(Zy, k([
            "payment_processor"
        ]), w$)),
        A2(Ye, Cin, A2(Zy, k([
            "stripe_client_secret"
        ]), w$))
    ])), Ain = F3(function(n, r, t) {
        return A4(vN, n, Din, t, bC(A2($y, k([
            "setup"
        ]), function(n) {
            return A2($y, k([
                "payment_methods"
            ]), gy(n));
        }(r))));
    }), qin = F6(function(n, r, t, e, u, a) {
        var i = A3(Ain, a, $k(t), win);
        return b({
            ck: !1,
            yl: e,
            kh: u,
            kj: r,
            kk: AO(xin),
            rd: n,
            dw: t,
            s: kin,
            dK: 1,
            jJ: !1
        }, i);
    }), Bin = function(n) {
        var r = n.tL;
        return 3 === r.$ && function(n) {
            return n.mx;
        }(r.a);
    }, jin = function(n) {
        return rB(n / 100);
    }, Sin = F2(function(n, r) {
        var t;
        return {
            mg: (t = n, A2(Cp, jin, t)),
            e4: !1,
            uy: !1,
            v3: r
        };
    }), zin = function(n) {
        return n.mB;
    }, Uin = function(n) {
        return n.gL;
    }, Ein = F2(function(n, r) {
        return A2(uc, "", A2(Cp, function(r) {
            var t = r.b;
            return A2(Tb, n(r.a), t);
        }, ke(r)));
    }), Pin = function(n) {
        return n.toUpperCase();
    }, Tin = function(n) {
        return A2(Ein, Pin, n);
    }, Fin = F2(function(n, r) {
        var t = r;
        if (t.$) {
            var e = t.a;
            return A2(uc, n(zin), e.mC) + " * " + A2(uc, "", e.hM);
        }
        var u = t.a;
        return Tin(A2(uc, n(Uin), u.m7)) + " *" + A2(uc, "", u.hM);
    }), Lin = function(n) {
        return n.a.wj;
    }, Min = function(n) {
        return n.bt.x5;
    }, Hin = function(n) {
        return n.bt.yv;
    }, Rin = function(n) {
        return n.bt.zd;
    }, Oin = function(n) {
        return n.bt.zi;
    }, Nin = function(n) {
        return n.bt.zU;
    }, Iin = function(n) {
        return n.bt.AD;
    }, Vin = function(n) {
        return n.bt.uA;
    }, Win = function(n) {
        return n.bt.DK;
    }, Zin = F2(function(n, r) {
        var t, e;
        return e = (t = function() {
            switch(r){
                case 1:
                    return b(2, Nin);
                case 6:
                    return b(2, Oin);
                case 5:
                    return b(3, Win);
                case 4:
                    return b(3, Rin);
                case 0:
                    return b(1, Vin);
                case 2:
                    return b(1, Iin);
                case 3:
                    return b(0, Hin);
                default:
                    return b(2, Min);
            }
        }()).b, A2(Utn, k([
            t.a
        ]), k([
            ad(n(e))
        ]));
    }), Xin = F2(function(n, r) {
        if (r.$) return A2(Gk, k([
            Nk("inline-block my-1")
        ]), k([
            ad(n(ab))
        ]));
        var t = r.a;
        return A2(Gk, h, k([
            A2(Gk, h, k([
                ad(A2(Fin, n, t))
            ])),
            A2(Zin, n, Lin(t))
        ]));
    }), Gin = function(n) {
        return n.$ ? Rt : Ht(bun(n.a));
    }, Jin = F3(function(n, r, t) {
        var e, u = AO(A2(Sin, Rt, Rt)), a = b((e = A6(qin, !1, r.kj, n, r.yl, Rt, r.gx)).a, A2(jp, gin, e.b)), i = a.b;
        return b({
            gx: r.gx,
            c1: h,
            yl: r.yl,
            c9: oc,
            kj: r.kj,
            qU: t.BD.qU,
            bZ: oc,
            a0: a.a,
            e8: oc,
            tE: r.tL,
            $8: Bin(r),
            tQ: oc,
            t: u,
            BO: Nx({
                qU: "payment-source-select",
                Dr: Xin,
                Dt: Gin
            }),
            dw: n,
            wq: 0,
            w_: t
        }, Hu(k([
            A4(nun, r.gx, $k(n), t.BD.qU, hin),
            i
        ])));
    }), Yin = F2(function(n, r) {
        return b(m(r, {
            yl: n.yl,
            $8: Bin(n)
        }), Dp);
    }), Qin = F2(function(n, r) {
        return m(r, {
            xE: Ht(0)
        });
    }), Kin = Kn("stripePortOnSetupIntentChange", w$), ncn = F3(function(n, r, t) {
        return {
            kg: t,
            du: r,
            fC: n
        };
    }), rcn = F2(function(n, r) {
        return {
            gL: r,
            qU: n
        };
    }), tcn = F4(function(n, r, t, e) {
        return {
            m7: r,
            hj: t,
            hk: e,
            hM: n
        };
    }), ecn = A3(zy, "exp_year", C$, A3(zy, "exp_month", C$, A3(zy, "brand", w$, A3(zy, "last4", w$, Ke(tcn))))), ucn = A4(Sy, "card", Ay(ecn), Rt, A3(zy, "payment_method", w$, Ke(rcn))), acn = A3(zy, "error", l_(w$), A3(zy, "setup_intent", Ay(ucn), A3(zy, "selector", w$, Ke(ncn)))), icn = F2(function(n, r) {
        var t = A2(By, acn, r);
        if (t.$) return n(Xt(Jy(t.a)));
        var e = t.a, u = e.du;
        if (1 === u.$) {
            var a = e.kg;
            return n(Xt(1 === a.$ ? "" : a.a));
        }
        return n(Qt(u.a));
    }), ccn = Kn("stripePortOnSetupIntentConfirmed", v$), ocn = xk(k([
        (mG = function(n) {
            return {
                $: 1,
                a: n
            };
        }, ccn(icn(mG))),
        (vG = function(n) {
            return {
                $: 2,
                a: n
            };
        }, Kin(vG))
    ])), fcn = function(n) {
        return {
            $: 0,
            a: n
        };
    }, scn = {
        $: 1
    }, lcn = {
        $: 5
    }, dcn = function(n) {
        var r = n;
        return A2(Cp, pp, A2(Cp, He(100), gj(r)));
    }, bcn = function(n) {
        return A2(uc, 0, dcn(A2(uc, "0", n.mg)));
    }, vcn = function(n) {
        return {
            $: 8,
            a: n
        };
    }, mcn = function(n) {
        return !n.$ && !n.a.$ && vun(n.a.a);
    }, pcn = F3(function(n, r, t) {
        var e, u = b(n.yl, mcn(t));
        if (u.a && u.b) {
            var a = (e = t).$ || e.a.$ ? Rt : Ht(bun(e.a.a));
            if (a.$) return Dp;
            var i = a.a;
            return A5(dun, n.gx, $k(n.dw), i, r, vcn);
        }
        return Dp;
    }), $cn = F2(function(n, r) {
        var t = dcn(r);
        if (t.$) return !1;
        var e = t.a, u = b(n.sG, n.rX);
        if (u.a.$) return !!u.b.$ || 1 > s(e, a = u.b.a);
        if (u.b.$) return s(e, u.a.a) > -1;
        var a = u.b.a;
        return !(0 > s(e, u.a.a) || s(e, a) > 0);
    }), hcn = F2(function(n, r) {
        return r.$ ? !n.xO : !A2($cn, {
            rX: n.rX,
            sG: n.sG
        }, r.a);
    }), gcn = ZN(k([
        function(n) {
            var r = n.mg;
            return A2(hcn, {
                xO: !0,
                rX: Rt,
                sG: Ht(50)
            }, r) ? k([
                b(0, aI(A2(XN, nI, san)))
            ]) : h;
        }
    ])), wcn = F2(function(n, r) {
        switch(n.$){
            case 0:
                var t = n.a;
                if (t.$) return m(r, {
                    mg: t
                });
                var e = t.a, u = A2($cn, {
                    rX: Rt,
                    sG: Ht(0)
                }, e), a = b(dcn(e), u);
                n: for(; !a.a.$;){
                    if (a.a.a) {
                        if (a.b) return m(r, {
                            mg: Ht(e)
                        });
                        break n;
                    }
                    return m(r, {
                        mg: Ht(e)
                    });
                }
                return r;
            case 1:
                return m(r, {
                    v3: n.a
                });
            case 2:
                var i = n.a;
                return m(r, {
                    e4: i,
                    uy: !i && r.uy
                });
            default:
                return m(r, {
                    uy: n.a
                });
        }
    }), kcn = function(n) {
        return n.tZ.tR;
    }, xcn = F2(function(n, r) {
        switch(r.$){
            case 2:
                return v(m(n, {
                    bZ: oc,
                    a0: n.a0,
                    tQ: oc
                }), Dp, h);
            case 3:
                var t = r.a, e = A2(Cp, fcn, Ht(t)), u = $(n.c1, k([
                    t
                ])), a = bcn(jN(n.t)), i = A3(pcn, n, a, e), c = AO(A2(Sin, Ht(a), e));
                return v(m(n, {
                    c1: u,
                    bZ: r,
                    tQ: oc,
                    t: c
                }), i, h);
            default:
                return v(m(n, {
                    bZ: r
                }), Dp, A2(uA, 0, r));
        }
    }), ycn = function(n) {
        return {
            $: 3,
            a: n
        };
    }, _cn = {
        $: 0
    }, Ccn = A2(Eu, ru, gu(_cn)), Dcn = A2(IC, 0, A2(qy, Xen, Ke(Fen))), Acn = F7(function(n, r, t, e, u, a, i) {
        var c, o = vk(k([
            b("payment", vk(k([
                b("amount_in_cents", hq(e)),
                b("source", vk(k([
                    b("id", mk(bun(u))),
                    b("type", mk((c = u, c.a.C1)))
                ])))
            ]))),
            b("process_outstanding", kA(a))
        ]));
        return A4(vN, n, Dcn, i, A2(xq, o, bC(A2($y, k([
            "payments"
        ]), A2(Ken, r, t)))));
    }), qcn = F4(function(n, r, t, e) {
        var u = e.v3, a = e.uy, i = A2(uc, 0, dcn(A2(uc, "0", e.mg)));
        return u.$ ? Dp : u.a.$ ? A2(jp, gin, Ccn) : A7(Acn, n, r, t, i, u.a.a, a, ycn);
    }), Bcn = function(n) {
        return {
            $: 7,
            a: n
        };
    }, jcn = F5(function(n, r, t, e, u) {
        return vk(k([
            b(n.$ ? "rainforest_id" : "stripe_id", mk(n.a)),
            b("shared", kA(!0)),
            b("one_time_use", kA(r)),
            b("replaces_payment_method_id", A2(yN, mk, e)),
            b("process_outstanding", kA(t)),
            b("set_as_default", kA(u))
        ]));
    }), Scn = A2($y, k([
        "payment_methods"
    ]), hy), zcn = F4(function(n, r, t, e) {
        var u = vk(k([
            b("payment_method", A5(jcn, r, t.ds, t.uy, t.va, t.vH))
        ]));
        return A4(vN, n, een, e, A2(xq, u, bC(Scn)));
    }), Ucn = function(n) {
        return {
            $: 1,
            a: n
        };
    }, Ecn = {
        $: 3
    }, Pcn = function(n) {
        return {
            $: 1,
            a: n
        };
    }, Tcn = {
        $: 2
    }, Fcn = function(n) {
        return {
            $: 2,
            a: n
        };
    }, Lcn = {
        $: 0
    }, Mcn = F2(function(n, r) {
        return {
            $: 1,
            a: n,
            b: r
        };
    }), Hcn = function(n) {
        return v(n, Dp, Rt);
    }, Rcn = F8(function(n, r, t, e, u, a, i, c) {
        return {
            m4: e,
            m5: t,
            m6: r,
            rI: c,
            kO: a,
            uf: u,
            fC: n,
            vI: i
        };
    }), Ocn = F2(function(n, r) {
        return {
            pA: r,
            u4: n
        };
    }), Ncn = Jn("stripePortBuildAndMountElementWithSetupIntent", function(n) {
        return vk(k([
            b("cardCvcSelector", mk(n.m4)),
            b("cardExpirySelector", mk(n.m5)),
            b("cardNumberSelector", mk(n.m6)),
            b("locale", mk(n.rI)),
            b("options", function(n) {
                return vk(k([
                    b("encourageAch", kA(n.pA)),
                    b("rejectAmex", kA(n.u4))
                ]));
            }(n.kO)),
            b("postalCodeSelector", mk(n.uf)),
            b("selector", mk(n.fC)),
            b("setupIntentSecret", mk(n.vI))
        ]));
    }), Icn = F9(function(n, r, t, e, u, a, i, c, o) {
        var f = A8(Rcn, r, t, e, u, a, A2(Ocn, i, c), o, Eb(n));
        return Ncn(f);
    }), Vcn = "card-element", Wcn = F4(function(n, r, t, e) {
        return A9(Icn, n, "#" + Vcn, "#card-number", "#card-expiry", "#card-cvc", "#postal-code", r, t, e);
    }), Zcn = Jn("stripePortConfirmSetupIntent", function(n) {
        return vk(k([
            b("options", function(n) {
                return vk(k([
                    b("billingOptions", function(n) {
                        return A3(dk, bk, function(n) {
                            return vk(k([
                                b("name", mk(n.sS))
                            ]));
                        }, n);
                    }(n.x3))
                ]));
            }(n.kO)),
            b("selector", mk(n.fC))
        ]));
    }), Xcn = F2(function(n, r) {
        return Zcn({
            kO: r,
            fC: n
        });
    }), Gcn = Jn("rainforestSubmitPaymentMethod", function() {
        return bk;
    }), Jcn = Gcn(0), Ycn = function(n) {
        return n.b.pA;
    }, Qcn = function(n) {
        return n.cG.xQ;
    }, Kcn = function(n) {
        return n.cG.qu;
    }, non = function(n) {
        return n.cG.rr;
    }, ron = function(n) {
        return n.cG.Cn;
    }, ton = function(n) {
        return n.cG.Ct;
    }, eon = F3(function(n, r, t) {
        var e = v(n, r, t.gM);
        return 2 === e.a.$ && e.b && "AMERICAN_EXPRESS" === e.c ? k([
            b(0, aI(Qcn))
        ]) : h;
    }), uon = F2(function(n) {
        return 2 === n.$ ? n.a.eM ? h : k([
            b(0, aI(ron))
        ]) : h;
    }), aon = F2(function(n, r) {
        return ZN(k([
            A2(eon, n, r),
            uon(n)
        ]));
    }), ion = function(n) {
        return !n.b.lB;
    }, con = function(n) {
        return n.wl;
    }, oon = F2(function(n, r) {
        return m(r, {
            gM: n
        });
    }), fon = F3(function(n, r, t) {
        switch(n.$){
            case 0:
                var e = Ht(Pcn(function(n) {
                    return {
                        $: 1,
                        a: n
                    };
                }(n.a)));
                return v(t, Dp, e);
            case 1:
                return v(m(t, {
                    s: Fcn(m(r, {
                        eM: n.a
                    }))
                }), Dp, Rt);
            case 2:
                return v(m(t, {
                    s: Fcn(m(r, {
                        z1: !1
                    }))
                }), Dp, Rt);
            case 3:
                return v(m(t, {
                    dK: "ACH" === n.a ? 0 : 1
                }), Dp, Rt);
            default:
                return v(m(t, {
                    kk: A3(WI, oon, n.a, t.kk)
                }), Dp, Rt);
        }
    }), son = F2(function(n, r) {
        switch(n.$){
            case 3:
                var t = n.a;
                if (3 === t.$) {
                    var e = t.a, u = e.$ ? Fcn({
                        xP: e.a.xP,
                        z1: !0,
                        eM: !1,
                        BL: e.a.BL,
                        CI: e.a.CI
                    }) : A2(Mcn, e.a, Lcn), a = function() {
                        if (e.$) return Dp;
                        var n = e.a;
                        return A4(Wcn, r.kj, ion(r.dw), Ycn(r.dw), n);
                    }();
                    return v(m(r, {
                        s: u
                    }), a, Rt);
                }
                return Hcn(m(r, {
                    s: Ecn
                }));
            case 4:
                var i = r.s;
                return 2 === i.$ ? A3(fon, n.a, i.a, r) : Hcn(r);
            case 2:
                return 1 === r.s.$ ? v(m(r, {
                    dK: "us_bank_account" === n.a ? 0 : 1
                }), Dp, Rt) : Hcn(r);
            case 0:
                u = 1 === (p = r.s).$ ? A2(Mcn, p.a, Lcn) : r.s;
                var c = A2(wI, A2(aon, r.s, ion(r.dw)), r.kk);
                return c.$ ? v(m(r, {
                    ck: !1,
                    kk: c.a,
                    s: u
                }), Dp, Rt) : v(m(r, {
                    ck: !0,
                    kk: c.a.a,
                    s: u
                }), function(n) {
                    switch(n.s.$){
                        case 1:
                            return A2(Xcn, "#" + Vcn, {
                                x3: Rt
                            });
                        case 2:
                            return Jcn;
                        default:
                            return Dp;
                    }
                }(r), Ht(Tcn));
            default:
                var o = n.a, f = r.s;
                if (1 === f.$) {
                    var s = f.a;
                    if (o.$) {
                        var l = o.a, d = A2(uu, "billing_details[name]", l) ? con : KD(A3(Gy, "postal code", "ZIP code", l));
                        return b = fu(l) ? Rt : Ht(function(n) {
                            return {
                                $: 0,
                                a: n
                            };
                        }(d)), v(m(r, {
                            ck: !1,
                            s: A2(Mcn, s, Ucn(d))
                        }), Dp, b);
                    }
                    var b = Ht(Pcn(function(n) {
                        return {
                            $: 0,
                            a: n
                        };
                    }(o.a.qU)));
                    return v(m(r, {
                        s: A2(Mcn, s, Lcn)
                    }), Dp, b);
                }
                return Hcn(r);
        }
        var p;
    }), lon = F2(function(n, r) {
        var t = A2(son, r, n.a0), e = t.b, u = t.c, a = m(n, {
            a0: t.a
        }), i = k([
            A2(jp, gin, e)
        ]);
        n: for(; !u.$;)switch(u.a.$){
            case 1:
                var c = u.a.a, o = jN(n.t), f = o.e4, s = o.uy, l = f ? "Payment Method Added" : "Default Payment Method Changed", d = f ? "True" : "False";
                return v(m(a, {
                    bZ: Mx
                }), Hu(A2(Ot, A4(zcn, n.gx, c, {
                    ds: f,
                    uy: s,
                    va: Rt,
                    vH: !f
                }, Bcn), $(i, k([
                    A2(w7, l, k([
                        A2(x7, "One-Time Payment Method", d)
                    ]))
                ])))), h);
            case 0:
                var b = u.a.a;
                return v(m(a, {
                    bZ: oc,
                    tQ: oc
                }), Hu(i), k([
                    rA(b)
                ]));
            default:
                break n;
        }
        return v(a, Hu(i), h);
    }), don = F2(function(n, r) {
        switch(n.$){
            case 0:
                var t = n.a;
                if (3 === t.$) {
                    var e = t.a, u = eun(e), a = tun($un(e)), c = A2(Cp, fcn, a), o = A3(pcn, r, u, c), f = AO(A2(Sin, Ht(u), c)), s = function(n) {
                        return A2(Tc, function(n) {
                            var r;
                            return !A2(uc, !1, (r = n, r.a.ds));
                        }, $un(n).v5);
                    }(e);
                    return v(m(r, {
                        c1: s,
                        c9: t,
                        t: f,
                        wq: u
                    }), o, h);
                }
                return v(m(r, {
                    c9: t
                }), Dp, A2(uA, 0, t));
            case 2:
                return v(m(r, {
                    t: A3(WI, wcn, n.a, r.t)
                }), Dp, h);
            case 4:
                var l = A2(bq, n.a, r.BO), d = l.a, p = l.c, g = function() {
                    if (p.$ || p.a.$) return b(r.t, Dp);
                    var n = p.a.a, t = Aan(r.dw) && !i(n, Ht(scn)) ? Dp : A2(Eu, ru, gu(lcn)), e = bcn(jN(r.t)), u = A3(pcn, r, e, n);
                    return b(A3(WI, wcn, function(n) {
                        return {
                            $: 1,
                            a: n
                        };
                    }(n), r.t), Hu(k([
                        t,
                        u
                    ])));
                }(), w = g.b;
                return v(m(r, {
                    t: g.a,
                    BO: d
                }), w, h);
            case 5:
                var x = A6(qin, !1, r.kj, r.dw, r.yl, Rt, r.gx), y = x.b;
                return v(m(r, {
                    a0: x.a
                }), A2(jp, gin, y), h);
            case 6:
                return A2(lon, r, n.a);
            case 7:
                return A2(xcn, r, n.a);
            case 1:
                var _ = A2(wI, gcn, r.t);
                if (_.$) return v(m(r, {
                    t: _.a
                }), Dp, h);
                var C = _.a, D = C.b;
                return v(m(r, {
                    tQ: Mx,
                    t: C.a
                }), A4(qcn, r.gx, $k(r.dw), r.qU, D), h);
            case 3:
                var A = n.a, q = function() {
                    var n = b(r.c9, A);
                    if (3 === n.a.$ && 3 === n.b.$) {
                        var t = n.a.a, e = n.b.a;
                        return b(Hu(k([
                            A2(w7, "Invoice Paid", h),
                            A2(zx, oa, _a({
                                qU: jan(t)
                            }))
                        ])), "failed" === e.a.wj ? k([
                            A2(nA, 1, kcn)
                        ]) : h);
                    }
                    return b(Dp, h);
                }(), B = q.a, j = q.b;
                return v(m(r, {
                    tQ: A
                }), B, $(j, A2(uA, 0, A)));
            case 8:
                return v(m(r, {
                    e8: n.a
                }), Dp, h);
            default:
                var S = bcn(jN(r.t)), z = (o = A3(pcn, r, S, jN(r.t).v3), A2(wI, gcn, r.t));
                return v(m(r, z.$ ? {
                    t: z.a,
                    wq: S
                } : {
                    t: z.a.a,
                    wq: S
                }), o, h);
        }
    }), bon = F2(function(n, r) {
        return {
            $: 7,
            a: n,
            b: r
        };
    }), von = bon, mon = function(n) {
        return n.eK.tQ;
    }, pon = function(n) {
        return n.eK.v3;
    }, $on = function(n) {
        return n.eK.jq;
    }, hon = function(n) {
        return n.eK.wD;
    }, gon = function(n) {
        return Sx(_a({
            qU: jan(n)
        }));
    }, won = function(n) {
        return A2(gV, k([
            vV(Sx(ya))
        ]), k([
            ad(n(Ld))
        ]));
    }, kon = F3(function(n, r, t) {
        return P7(r) ? Sq : A2(lV, k([
            uV(kz),
            dV(NZ)
        ]), k([
            A2(iV, k([
                Oun(8),
                A2(von, 2, gz)
            ]), k([
                won(n),
                ad(" / "),
                A2(gV, k([
                    vV(gon(t))
                ]), k([
                    ad(A2(dP, AA("/"), Aun(t)))
                ])),
                ad(" / "),
                ad(n(hon)),
                gx
            ]))
        ]));
    }), xon = {
        $: 1
    }, yon = function(n) {
        switch(n.$){
            case 0:
                return "Unauthorized";
            case 1:
                return "BadUrl";
            case 2:
                return "Timeout";
            case 3:
                return "Network";
            case 4:
                return "Server Error";
            case 7:
                return A2(uc, "Internal Server Error", n.a);
            case 5:
                return n.b;
            case 8:
                return "Forbidden";
            case 9:
                return "Not Found";
            default:
                return "Decoder error! " + n.a;
        }
    }, _on = function(n) {
        return 3 === n.$;
    }, Con = function(n) {
        var r = n.s;
        switch(r.$){
            case 3:
                return !1;
            case 2:
                return r.a.eM;
            default:
                return !0;
        }
    }, Don = function(n) {
        return {
            $: 3,
            a: n
        };
    }, Aon = F2(function(n, r) {
        return r.vA(n);
    }), qon = F2(function(n, r) {
        return r.vB(n);
    }), Bon = F3(function(n, r, t) {
        return A2(hx, k([
            EB,
            BB
        ]), k([
            ad(r(n ? qon(t) : Aon(t)))
        ]));
    }), jon = function(n) {
        return {
            $: 2,
            a: n
        };
    }, Son = function(n) {
        return {
            $: 2,
            a: n
        };
    }, zon = F3(function(n, r, t) {
        return A2(lV, k([
            dV(FV)
        ]), k([
            A2(iV, h, k([
                A2(QW, k([
                    ZW(r),
                    WW(A2(sc, Son, jon)),
                    VW(t)
                ]), k([
                    ad(n(fb))
                ]))
            ]))
        ]));
    }), Uon = function(n) {
        return {
            $: 0,
            a: n
        };
    }, Eon = function(n) {
        return {
            $: 4,
            a: n
        };
    }, Pon = {
        $: 2
    }, Ton = function(n) {
        return {
            $: 3,
            a: n
        };
    }, Fon = function(n) {
        return {
            $: 4,
            a: n
        };
    }, Lon = function(n) {
        return {
            $: 1,
            a: n
        };
    }, Mon = qB(3), Hon = F3(function(n, r, t) {
        var e = b(r, t);
        return e.a && e.b ? A2(lV, k([
            jV(k([
                Nk("ach-text-fade-in")
            ]))
        ]), k([
            A2(iV, k([
                UZ(12)
            ]), k([
                A2(lz, k([
                    Qk(k([
                        Nk("hidden sm:block")
                    ]))
                ]), k([
                    A2(hx, k([
                        Mon,
                        EB
                    ]), k([
                        ad(n(wd))
                    ]))
                ])),
                A2(lz, k([
                    Qk(k([
                        Nk("block sm:hidden")
                    ]))
                ]), k([
                    A2(hx, k([
                        Mon,
                        EB
                    ]), k([
                        ad(n(wd))
                    ]))
                ]))
            ]))
        ])) : Sq;
    }), Ron = F3(function(n, r, t) {
        return A2(t.lE, n, r);
    }), Oon = F2(function(n, r) {
        return r.lF(n);
    }), Non = F3(function(n, r, t) {
        var e = v(t, r, n);
        return !!e.a && !(e.b && !e.c);
    }), Ion = F7(function(n, r, t, e, u, a, i) {
        var c, o, f = (o = b(u, n), r(o.a.$ ? o.b ? Oon(e) : A2(Ron, e, "2%") : o.b ? Oon(e) : (c = qtn(o.a.a), A2(Ron, e, c))));
        return A3(Non, i, a, t) ? A2(lV, k([
            jV(k([
                Nk(a ? "ach-text-fade-in" : "")
            ]))
        ]), k([
            A2(iV, k([
                UZ(12)
            ]), k([
                A2(hx, k([
                    Mon,
                    EB
                ]), k([
                    ad(f)
                ]))
            ]))
        ])) : Sq;
    }), Von = F7(function(n, r, t, e, u, a, i) {
        return n ? A3(Hon, t, e, i) : A7(Ion, r, t, e, u, a, !0, i);
    }), Won = xA("hidden"), Zon = F2(function(n, r) {
        return r.tS(n);
    }), Xon = rn, Gon = A2(Zy, k([
        "detail"
    ]), A2(Xon, 0, A2(Zy, k([
        "data",
        "payment_method_id"
    ]), w$))), Jon = A2(Zy, k([
        "detail"
    ]), A2(Xon, 0, w$)), Yon = A2(Zy, k([
        "detail"
    ]), A2(Xon, 0, w$)), Qon = F2(function(n, r) {
        var t = n.AL, e = n.A4, u = n.Bs, a = n.A6, i = n.Ba, c = n.AS;
        return A3(Mj, "rainforest-payment", k([
            A2(Wx, "session-key", r.CI),
            A2(Wx, "payment-method-config-id", r.BL),
            A2(Wx, "allowed-methods", r.xP),
            r.zC ? A2(Wx, "hide-card-brand-logos", "true") : rz(h),
            A2(Wx, "hide-button", ""),
            A2(Uq, "approved", A2(Ye, t, Gon)),
            A2(Uq, "valid", Ke(u)),
            A2(Uq, "invalid", Ke(e)),
            A2(Uq, "loaded", Ke(a)),
            A2(Uq, "method-updated", A2(Ye, i, Yon)),
            A2(Uq, "card-brand-updated", A2(Ye, c, Jon)),
            Nk("mb-4")
        ]), h);
    }), Kon = F4(function(n, r, t, e) {
        return r ? A2(lV, h, k([
            A2(iV, k([
                UZ(5)
            ]), k([
                A2(fz, k([
                    nz,
                    QS(_cn),
                    Don(t),
                    ZS(t || !e)
                ]), k([
                    ad(n(ton))
                ]))
            ]))
        ])) : Sq;
    }), nfn = function(n) {
        var r = Rk(n.kj), t = function() {
            var r = n.s;
            switch(r.$){
                case 0:
                    return !0;
                case 1:
                default:
                    return !1;
                case 2:
                    return r.a.z1;
            }
        }(), e = Con(n), u = Ycn(n.dw), a = n.yl;
        return k([
            A2(Ik, h, k([
                A2(Ik, k([
                    Won(t),
                    Nk("stripe-card")
                ]), k([
                    Sq,
                    function() {
                        var t = n.s;
                        switch(t.$){
                            case 3:
                                return A2(Ik, k([
                                    Nk("mt-4 mb-4")
                                ]), k([
                                    A2(hx, k([
                                        E1
                                    ]), k([
                                        ad(r(Zon(hk(n.dw))))
                                    ]))
                                ]));
                            case 2:
                                var e = t.a, u = e.CI, a = e.BL, i = e.xP;
                                return A2(Ik, h, k([
                                    A2(Qon, {
                                        AL: A2(Je, Uon, Fon),
                                        AS: A2(Je, Eon, Fon),
                                        A4: Fon(Lon(!1)),
                                        A6: Fon(Pon),
                                        Ba: A2(Je, Ton, Fon),
                                        Bs: Fon(Lon(!0))
                                    }, {
                                        xP: i,
                                        zC: ion(n.dw),
                                        BL: a,
                                        CI: u
                                    }),
                                    A2(OW, r, A2(iW, 0, n.kk))
                                ]));
                            default:
                                return A2(Ik, k([
                                    jz(Vcn),
                                    Nk("mb-4")
                                ]), h);
                        }
                    }(),
                    A2(Ik, k([
                        Won(t)
                    ]), k([
                        A7(Von, a, n.rd, r, u, hk(n.dw), n.kh, n.dK)
                    ])),
                    A4(Kon, r, n.jJ, n.ck, e)
                ])),
                t ? A2(Ik, k([
                    Nk("flex justify-center my-12")
                ]), k([
                    Jk(k([
                        Wk
                    ]))
                ])) : Sq
            ]))
        ]);
    }, rfn = function(n) {
        return A2(lV, k([
            dV(FV),
            dV(NZ)
        ]), k([
            A2(iV, k([
                dV(NZ)
            ]), A2(yu, px(gin), nfn(n)))
        ]));
    }, tfn = function(n) {
        var r = b(h, k([
            rfn(n)
        ]));
        return A2(AW, r.a, r.b);
    }, efn = F2(function(n, r) {
        return r.td(n);
    }), ufn = {
        $: 9
    }, afn = function(n) {
        return {
            $: 0,
            a: n
        };
    }, ifn = function(n) {
        return {
            $: 9,
            a: n
        };
    }, cfn = function(n) {
        return A2(Gk, k([
            Nk("input-addon")
        ]), n);
    }, ofn = function(n) {
        return A2(Ik, k([
            Nk("input-group")
        ]), n);
    }, ffn = {
        eC: h,
        Z: h,
        zU: !1,
        iq: Rt,
        is: !0,
        w5: Rt
    }, sfn = ru, lfn = function(n) {
        return aF(n) ? Rt : Ht(n);
    }, dfn = function(n) {
        return A2(Je, lfn, A2(Je, Cp(sfn), n));
    }, bfn = function(n) {
        return n;
    }, vfn = function(n) {
        var r, t = function(n) {
            return A3(ce, F2(function(n, r) {
                switch(n.$){
                    case 0:
                        return m(r, {
                            Z: A2(Ot, xZ(dfn(n.a)), r.Z)
                        });
                    case 9:
                        return m(r, {
                            Z: A2(Ot, lZ(n.a), r.Z)
                        });
                    case 1:
                        var t = n.a;
                        return m(r, {
                            Z: A2(Ot, bP((e = t, A2(uc, "", A2(Cp, bfn, e)))), r.Z),
                            w5: t
                        });
                    case 2:
                        return m(r, {
                            zU: n.a
                        });
                    case 3:
                        return m(r, {
                            eC: n.a
                        });
                    case 4:
                        return m(r, {
                            Z: A2(Ot, lP(n.a), r.Z)
                        });
                    case 5:
                        return m(r, {
                            Z: A2(Ot, sP(n.a), r.Z)
                        });
                    case 6:
                        return m(r, {
                            iq: Ht(n.a)
                        });
                    case 7:
                        return m(r, {
                            is: !1
                        });
                    default:
                        return m(r, {
                            Z: A2(Ot, aX(n.a), r.Z)
                        });
                }
                var e;
            }), ffn, n);
        }(n), e = t.is ? cfn(k([
            ad("$")
        ])) : Sq;
        return ofn(A2(Ot, e, A2(Ot, yP(A2(Ot, oZ(t.zU), t.Z)), (r = t.iq).$ ? h : k([
            cfn(k([
                ad(r.a)
            ]))
        ]))));
    }, mfn = F2(function(n, r) {
        var t, e, u, a = jN(r);
        return k([
            vfn(k([
                (u = a.mg, function(n) {
                    return {
                        $: 1,
                        a: n
                    };
                }(u)),
                (e = A2(sc, Son, afn), function(n) {
                    return {
                        $: 0,
                        a: n
                    };
                }(e)),
                (t = A2(kW, 0, r), function(n) {
                    return {
                        $: 2,
                        a: n
                    };
                }(t)),
                ifn(ufn)
            ])),
            A2(OW, n, A2(iW, 0, r))
        ]);
    }), pfn = F5(function(n, r, t, e, u) {
        var a, i = !((a = b(t, u)).a.$ || !a.b) && Qan(a.a.a) > 0;
        return A2(AW, k([
            bW(n(mon)),
            hW(!0)
        ]), Gi(k([
            Kun(r).$ ? A2(mfn, n, e) : function(n) {
                return k([
                    A2(hx, k([
                        BB
                    ]), k([
                        ad(qtn(eun(n)))
                    ]))
                ]);
            }(r),
            k([
                A2(hx, k([
                    BB,
                    LS(Htn)
                ]), k([
                    ad(n(efn(qtn(eun(r))))),
                    ad(" "),
                    i ? ad("(+ " + OB(n(xd)) + " )") : Sq
                ]))
            ])
        ])));
    }), $fn = function(n) {
        return {
            $: 4,
            a: n
        };
    }, hfn = function(n) {
        return n.fw;
    }, gfn = F5(function(n, r, t, e, u) {
        var a = A2(yu, function(n) {
            return A2(Xz, h, fcn(n));
        }, t), i = Aan(r) || qan(r) ? ED(a) ? k([
            A2(Xz, h, scn)
        ]) : A2(Ot, A2(Xz, h, scn), A2(Ot, IL, a)) : a;
        return A2(AW, k([
            bW(n(pon))
        ]), k([
            A2(px, $fn, A4(AU, n, k([
                Jz(e),
                ZL(n(hfn)),
                Wz
            ]), i, u))
        ]));
    }), wfn = function(n) {
        return {
            $: 3,
            a: n
        };
    }, kfn = F5(function(n, r, t, e, u) {
        return u && r ? A2(lV, k([
            dV(FV)
        ]), k([
            A2(iV, h, k([
                A2(QW, k([
                    ZW(t),
                    WW(A2(sc, Son, wfn)),
                    VW(e)
                ]), k([
                    ad(n(pb))
                ]))
            ]))
        ])) : Sq;
    }), xfn = {
        $: 9
    }, yfn = function(n) {
        return n.dH.yt;
    }, _fn = function(n) {
        return n.dH.zv;
    }, Cfn = function(n) {
        return n.dH.By;
    }, Dfn = function(n) {
        return n.dH.BV;
    }, Afn = function(n) {
        return n.dH.Dg;
    }, qfn = function(n) {
        return A2(lV, k([
            jV(k([
                Nk("px-1")
            ])),
            dV(Htn)
        ]), k([
            A2(iV, k([
                Oun(9),
                GZ(8)
            ]), k([
                A2(hx, k([
                    EB,
                    BB
                ]), k([
                    ad(n(Cfn)),
                    ad(" "),
                    A2(gV, k([
                        vV("http://www.hint.com"),
                        mV,
                        xfn,
                        n0
                    ]), k([
                        ad(n(Dfn))
                    ])),
                    ad(" "),
                    ad(n(Afn)),
                    ad(" "),
                    A2(gV, k([
                        vV("http://www.hint.com/security"),
                        mV,
                        xfn,
                        n0
                    ]), k([
                        ad(n(yfn))
                    ])),
                    ad(" "),
                    ad(n(_fn))
                ]))
            ])),
            A2(iV, k([
                Oun(3),
                GZ(4),
                A2(von, 1, Nun),
                dV(Htn),
                A2(XZ, 1, Vun)
            ]), k([
                A2(AB, k([
                    Nk("inline"),
                    TB("https://cdn2.hubspot.net/hubfs/2562809/production-app/pci_dss_compliant.png")
                ]), h),
                A2(AB, k([
                    Nk("inline ml-6"),
                    TB("https://cdn2.hubspot.net/hubfs/2562809/production-app/hipaa_compliant.png")
                ]), h)
            ]))
        ]));
    }, Bfn = F3(function(n, r, t) {
        return A2(lV, k([
            dV(FS)
        ]), k([
            A2(iV, k([
                UZ(6)
            ]), k([
                A2(hx, k([
                    BB
                ]), k([
                    ad(n)
                ]))
            ])),
            A2(iV, k([
                UZ(6),
                uV(Nun)
            ]), k(t ? [
                A2(LB, k([
                    PL
                ]), k([
                    ad(qtn(r))
                ]))
            ] : [
                A2(hx, h, k([
                    ad(qtn(r))
                ]))
            ]))
        ]));
    }), jfn = F3(function(n, r, t) {
        return A2(Ik, h, k([
            A2(lV, h, k([
                A2(iV, k([
                    UZ(12),
                    uV(wF)
                ]), k([
                    A2(CW, k([
                        LS(FS),
                        UB,
                        rx
                    ]), k([
                        ad(n(Ud))
                    ]))
                ]))
            ])),
            A2(lV, h, k([
                A2(iV, k([
                    UZ(12),
                    uV(gz)
                ]), k([
                    A3(Bfn, lv(n(Td)), t, !1),
                    Qan(r) > 0 ? A3(Bfn, lv(n(gd)), Qan(r), !1) : Sq,
                    gx,
                    A3(Bfn, lv(n(Md)), Lun(r), !0)
                ]))
            ]))
        ]));
    }), Sfn = F4(function(n, r, t, e) {
        var u, a, c = e.dw, o = e.t, f = e.tQ, s = e.BO, l = e.a0, d = e.bZ, v = e.$8, m = e.wq, p = e.c1, $ = e.yl && mcn(jN(o).v3), g = !(a = jN(o).v3).$ && 1 === a.a.$, w = jN(o), x = w.v3, y = w.e4, _ = w.uy, C = n(x.$ || 1 !== x.a.$ ? $on : ab);
        return k([
            A2(lV, h, k([
                A2(iV, k([
                    UZ(12),
                    uV(gz)
                ]), k([
                    A2(mx, k([
                        LS(FS)
                    ]), k([
                        ad(n(hon))
                    ]))
                ]))
            ])),
            A2(lV, h, k([
                A2(iV, k([
                    UZ(12),
                    uV(gz)
                ]), k([
                    A5(gfn, n, c, p, x, s)
                ]))
            ])),
            A2(lV, h, k([
                A2(iV, k([
                    UZ(12),
                    uV(gz)
                ]), k([
                    A5(pfn, n, r, t, o, $)
                ]))
            ])),
            (u = b($, t), u.a && !u.b.$ ? A3(jfn, n, u.b.a, m) : A2(lV, h, h)),
            x.$ || 1 !== x.a.$ ? Sq : A2(lV, h, k([
                A2(iV, k([
                    UZ(12),
                    uV(gz)
                ]), k([
                    A3(zon, n, y, _on(d)),
                    A5(kfn, n, v, _, _on(d), !y),
                    tfn(l),
                    gx,
                    A3(Bon, !1, n, hk(c))
                ]))
            ])),
            qfn(n),
            gx,
            A2(lV, h, k([
                A2(iV, k([
                    UZ(12),
                    uV(gz)
                ]), k([
                    A2(gV, k([
                        bV,
                        vV(gon(r))
                    ]), k([
                        ad(n(a2))
                    ])),
                    A2(fz, k([
                        nz,
                        ZS(i(f, Mx) || !m),
                        Don(i(f, Mx)),
                        QS(xon),
                        ZS(g && !Con(l))
                    ]), k([
                        ad(C)
                    ]))
                ]))
            ])),
            function() {
                if (2 === f.$) {
                    var n = f.a;
                    return A2(Gk, k([
                        A2(cE, "color", "red")
                    ]), k([
                        ad(yon(n))
                    ]));
                }
                return Sq;
            }()
        ]);
    }), zfn = F4(function(n, r, t, e) {
        return A2(lV, h, k([
            A2(iV, k([
                UZ(12)
            ]), A4(Sfn, n, r, t, e))
        ]));
    }), Ufn = F4(function(n, r, t, e) {
        return k([
            A2(Ik, k([
                Nk("panel")
            ]), k([
                A3(kon, n, r.gx, t),
                A4(zfn, Rk(r.kj), t, e, r)
            ]))
        ]);
    }), Efn = F2(function(n, r) {
        return {
            gF: function() {
                var t = r.c9;
                switch(t.$){
                    case 3:
                        var e = t.a, u = r.e8;
                        switch(u.$){
                            case 3:
                                return A4(Ufn, n, r, e, Ht(u.a));
                            case 2:
                                return k([
                                    A2(px, hu, min(r.dw))
                                ]);
                            default:
                                return A4(Ufn, n, r, e, Rt);
                        }
                    case 2:
                        return k([
                            A2(px, hu, min(r.dw))
                        ]);
                    default:
                        return Yk;
                }
            }(),
            wD: "Account.Invoices.Payments.Create"
        };
    }), Pfn = Ux({
        zO: Jin,
        Ab: Yin,
        Ct: Qin,
        Dd: function() {
            return xk(k([
                A2(xD, gin, ocn),
                yk
            ]));
        },
        DB: don,
        DH: Efn
    }), Tfn = {
        $: 0
    }, Ffn = function(n) {
        return {
            $: 1,
            a: n
        };
    }, Lfn = function(n) {
        return {
            $: 0,
            a: n
        };
    }, Mfn = F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    }), Hfn = F8(function(n, r, t, e, u, a, i, c) {
        return {
            n6: a,
            pG: u,
            pO: r,
            qU: n,
            sV: i,
            BS: t,
            t8: e,
            wa: c
        };
    }), Rfn = function(n) {
        switch(n){
            case "active":
                return Ke(2);
            case "inactive":
                return Ke(3);
            case "unconfirmed":
                return Ke(0);
            case "pending":
                return Ke(1);
            default:
                return yy("Unsupported membership enrollment status: " + n);
        }
    }, Ofn = function(n) {
        var r = hB(n);
        return r.$ ? yy("Unsupported period code: " + ee(n)) : Ke(r.a);
    }, Nfn = F2(function(n, r) {
        return {
            mi: n,
            oD: r
        };
    }), Ifn = A3(zy, "date", FC, A3(zy, "amount_in_cents", C$, Ke(Nfn))), Vfn = A2(qy, Ifn, Ke(ru)), Wfn = A3(zy, "sponsored", xy, A3(zy, "next_future_unpaid_bill", Vfn, A3(zy, "contract_auto_renew", xy, A3(zy, "ending_contract_end_date", l_(tN), A3(zy, "plan_name", w$, A3(zy, "period_in_months", A2(Ge, Ofn, C$), A3(zy, "enrollment_status", A2(Ge, Rfn, w$), A3(zy, "id", w$, Ke(Hfn))))))))), Zfn = A2(IC, 0, A2(qy, Wfn, Ke(Mfn))), Xfn = F3(function(n, r, t) {
        return A4(dC, n, Ey(Zfn), t, bC(function(n) {
            return A2($y, k([
                "memberships"
            ]), gy(n));
        }(r)));
    }), Gfn = F3(function(n, r) {
        return b({
            gx: r.gx,
            kj: r.kj,
            ay: Tfn,
            _: h,
            kV: oc,
            dw: n
        }, Hu(k([
            A3(WC, r.gx, $k(n), Lfn),
            A3(Xfn, r.gx, $k(n), Ffn)
        ])));
    }), Jfn = F2(function(n, r) {
        return b(r, Dp);
    }), Yfn = F2(function(n, r) {
        return m(r, {
            xE: Ht(1)
        });
    }), Qfn = function(n) {
        return {
            $: 5,
            a: n
        };
    }, Kfn = function(n) {
        return {
            $: 4,
            a: n
        };
    }, nsn = F3(function(n, r, t) {
        return {
            $: 1,
            a: n,
            b: r,
            c: t
        };
    }), rsn = function(n) {
        return {
            $: 6,
            a: n
        };
    }, tsn = {
        $: 3
    }, esn = function(n) {
        return n.a.pO;
    }, usn = F2(function(n, r) {
        return A2(Tc, function(r) {
            return A2(lA, esn(r), n);
        }, r);
    }), asn = function(n) {
        return n.a.qU;
    }, isn = function(n) {
        return A2(zx, oa, za({
            qU: asn(n)
        }));
    }, csn = function(n) {
        return n.a.t8;
    }, osn = F2(function(n, r) {
        return $(csn(r), 1 === esn(r) ? " (Pending)" : "");
    }), fsn = function(n) {
        return n.a.wa;
    }, ssn = F2(function(n, r) {
        switch(n.$){
            case 0:
                var t = n.a;
                return 3 === t.$ ? v(m(r, {
                    kV: t
                }), Dp, h) : v(m(r, {
                    kV: oc
                }), Dp, A2(uA, 0, t));
            case 1:
                var e = n.a;
                if (3 === e.$) {
                    var u = e.a;
                    return v(m(r, {
                        _: A2(Tc, function(n) {
                            return !fsn(n);
                        }, A2(usn, k([
                            2,
                            1
                        ]), u))
                    }), Dp, h);
                }
                return v(r, Dp, A2(uA, 0, e));
            case 2:
                var a = Gb(r._);
                if (a.$) return v(r, Dp, h);
                var i = a.a, c = function() {
                    if (1 === oe(r._)) return b(r, isn(i));
                    var n = id({
                        qU: "membership-select",
                        Dr: osn,
                        Dt: function(n) {
                            return Ht(csn(n));
                        }
                    }), t = A2(ny, 0, tsn), e = t.b, u = A3(nsn, t.a, n, Ht(i));
                    return b(m(r, {
                        ay: u
                    }), e);
                }();
                return v(c.a, c.b, h);
            case 3:
                return v(m(r, {
                    ay: Tfn
                }), Dp, h);
            case 4:
                var o = r.ay;
                if (1 === o.$) {
                    var f = o.b, s = o.c, l = A2(mq, n.a, $ = o.a), d = l.b;
                    return v(m(r, {
                        ay: A3(nsn, l.a, f, s)
                    }), A2(jp, Kfn, d), h);
                }
                return v(r, Dp, h);
            case 5:
                return v(1 === n.a ? m(r, {
                    ay: Tfn
                }) : r, Dp, h);
            case 6:
                var p = r.ay;
                if (p.$) {
                    var $ = p.a, g = (s = p.c, A2(bq, n.a, f = p.b)), w = g.a, x = g.b;
                    return v(A2(uc, r, A2(Cp, function(n) {
                        return m(r, n.$ ? {
                            ay: A3(nsn, $, w, s)
                        } : {
                            ay: A3(nsn, $, w, n.a)
                        });
                    }, g.c)), A2(jp, rsn, x), h);
                }
                return v(r, Dp, h);
            default:
                return v(r, isn(s = n.a), h);
        }
    }), lsn = {
        $: 2
    }, dsn = F3(function(n, r, t) {
        return !ED(t) && function(n) {
            return A2(dA, "self_serve_add_member", n);
        }(r) ? A2(Ik, k([
            Nk("mt-8")
        ]), k([
            A2(fz, k([
                CU,
                QS(lsn)
            ]), k([
                ad(n(Id.lO))
            ]))
        ])) : Sq;
    }), bsn = function(n) {
        return n.a.l7;
    }, vsn = F2(function(n, r) {
        return r.r3(n);
    }), msn = function(n) {
        return n.r7;
    }, psn = F2(function(n, r) {
        return A2(gV, k([
            vV(Sx(Aa({
                qU: r
            })))
        ]), k([
            ad(n(Id.rW))
        ]));
    }), $sn = F2(function(n, r) {
        var t = LD(r) ? Ht(n(msn)) : Rt, e = A2(Cp, A2(Je, ee, A2(Je, vsn, n)), bsn(r)), u = A2(ue, ", ", A2(Ep, ru, k([
            t,
            e
        ])));
        return A2(lV, k([
            yan,
            UZ(12)
        ]), k([
            A2(iV, k([
                jV(k([
                    Nk("flex justify-between items-center")
                ]))
            ]), k([
                A2(Ik, k([
                    Nk("grid text-left ml-2")
                ]), k([
                    A2(LB, k([
                        Qk(k([
                            Nk("mb-1")
                        ]))
                    ]), k([
                        Jx(Ix(r))
                    ])),
                    A2(hx, k([
                        BB
                    ]), k([
                        ad(u)
                    ]))
                ])),
                A2(Ik, h, k([
                    A2(psn, n, Ox(r))
                ]))
            ]))
        ]));
    }), hsn = F2(function(n, r) {
        return A2(yu, $sn(n), r);
    }), gsn = function(n) {
        return {
            $: 7,
            a: n
        };
    }, wsn = function(n) {
        return n.nT;
    }, ksn = function(n) {
        return {
            $: 6,
            a: n
        };
    }, xsn = F4(function(n, r, t, e) {
        return A2(Ik, h, k([
            A2(hx, k([
                BB,
                LS(q3)
            ]), k([
                ad("You\u2019re about to add a new member to one of your membership plans. Please, select the membership plan\n                that you want to update.")
            ])),
            A2(Ik, k([
                Nk("mb-12")
            ]), k([
                A2(AW, k([
                    bW("Membership"),
                    hW(!0)
                ]), k([
                    A2(px, rsn, A4(AU, n, k([
                        Jz(e),
                        ZL("Select membership")
                    ]), A2(yu, function(n) {
                        return A2(Xz, h, n);
                    }, r), t))
                ]))
            ])),
            gx,
            A2(Ik, k([
                Nk("mt-4"),
                A2(cE, "text-align", "right")
            ]), k([
                A2(fz, k([
                    CU,
                    ksn(!0),
                    QS(tsn)
                ]), k([
                    ad(n(a2))
                ])),
                function() {
                    if (e.$) return Sq;
                    var r = e.a;
                    return A2(fz, k([
                        nz,
                        ksn(!0),
                        QS(gsn(r))
                    ]), k([
                        ad(n(wsn))
                    ]));
                }()
            ]))
        ]));
    }), ysn = A2(hx, h, k([
        ad("Select Membership Plan")
    ])), _sn = F3(function(n, r, t) {
        if (1 === t.$) {
            var e = t.a, u = t.b, a = t.c, i = k([
                jZ(k([
                    ysn
                ])),
                IS(k([
                    A4(xsn, n, r, u, a)
                ]))
            ]);
            return A2(Tz, i, fA(e));
        }
        return Sq;
    }), Csn = F5(function(n, r, t, e, u) {
        return A2(Ot, A3(_sn, n, e, u), $(A2(hsn, n, r), k([
            A3(dsn, n, t, e)
        ])));
    }), Dsn = F2(function(n, r) {
        return {
            gF: k([
                A2(Ik, k([
                    Nk("panel")
                ]), function() {
                    var t = r.kV;
                    switch(t.$){
                        case 3:
                            var e = t.a;
                            return ED(e) ? MS(n(Id.DS)) : A5(Csn, n, e, r.dw, r._, r.ay);
                        case 2:
                            return B3(n(Id.dm));
                        default:
                            return Yk;
                    }
                }())
            ]),
            wD: n(Id.wD)
        };
    }), Asn = Ux({
        zO: Gfn,
        Ab: Jfn,
        Ct: Yfn,
        Dd: function(n) {
            return n.ay.$ ? xk(k([
                wD(m9(Qfn)),
                A2(xD, Kfn, _D())
            ])) : yk;
        },
        DB: ssn,
        DH: Dsn
    }), qsn = function(n) {
        return {
            $: 0,
            a: n
        };
    }, Bsn = A2(Ge, function(n) {
        switch(n){
            case "en":
                return Ke(0);
            case "es":
                return Ke(1);
            default:
                return yy("Invalid language");
        }
    }, w$), jsn = function(n) {
        if (n.$) return Ke(Rt);
        var r = n.a;
        switch(r){
            case "female":
                return Ke(Ht(0));
            case "male":
                return Ke(Ht(1));
            case "other":
                return Ke(Ht(2));
            case "":
                return Ke(Rt);
            default:
                return yy("Unsupported Gender: " + r);
        }
    }, Ssn = function(n) {
        if (n.$) return Ke(Rt);
        var r = n.a;
        switch(r){
            case "man":
                return Ke(Ht(0));
            case "woman":
                return Ke(Ht(1));
            case "non-binary":
                return Ke(Ht(2));
            case "trans man":
                return Ke(Ht(3));
            case "trans woman":
                return Ke(Ht(4));
            case "not listed":
                return Ke(Ht(5));
            case "":
                return Ke(Rt);
            default:
                return yy("Unsupported Gender identity: " + r);
        }
    }, zsn = function(n) {
        if (n.$) return Ke(Rt);
        var r = n.a;
        switch(r){
            case "He/Him/His":
                return Ke(Ht(0));
            case "She/Her/Hers":
                return Ke(Ht(1));
            case "They/Them/Theirs":
                return Ke(Ht(2));
            case "Other":
                return Ke(Ht(3));
            case "":
                return Ke(Rt);
            default:
                return yy("Unsupported Pronouns: " + r);
        }
    }, Usn = function(n) {
        if (n.$) return Ke(Rt);
        var r = n.a;
        switch(r){
            case "female":
                return Ke(Ht(0));
            case "male":
                return Ke(Ht(1));
            case "intersex":
                return Ke(Ht(2));
            case "":
                return Ke(Rt);
            default:
                return yy("Unsupported Sex: " + r);
        }
    }, Esn = function(n) {
        if (n.$) return Ke(Rt);
        var r = n.a;
        switch(uF(r)){
            case "Ms.":
            case "Ms":
                return Ke(Ht(0));
            case "Mrs.":
            case "Mrs":
                return Ke(Ht(1));
            case "Miss.":
            case "Miss":
                return Ke(Ht(2));
            case "Mr.":
            case "Mr":
                return Ke(Ht(3));
            case "Dr.":
            case "Dr":
                return Ke(Ht(4));
            case "Mx.":
            case "Mx":
                return Ke(Ht(5));
            case "":
                return Ke(Rt);
            default:
                return yy("Unsupported Title: " + r);
        }
    }, Psn = A3(zy, "id", w$, Ke(function(n) {
        return {
            qU: n
        };
    })), Tsn = A2(qy, Psn, Ke(ru)), Fsn = F7(function(n, r, t, e, u, a, i) {
        return {
            pt: e,
            qb: u,
            qU: n,
            rt: a,
            sS: r,
            t0: i,
            u5: t
        };
    }), Lsn = F3(function(n, r, t) {
        return {
            hE: t,
            BT: n,
            im: r
        };
    }), Msn = A2(Ge, function(n) {
        switch(n){
            case "mobile":
                return Ke(sO);
            case "home":
                return Ke(sX);
            case "office":
                return Ke(lX);
            default:
                return Ke(function(n) {
                    return {
                        $: 3,
                        a: n
                    };
                }(n));
        }
    }, w$), Hsn = A3(zy, "us_formattable", xy, A3(zy, "type", Msn, A3(zy, "number", w$, Ke(Lsn)))), Rsn = A2(qy, A2(Ye, ru, Hsn), Ke(ru)), Osn = A3(zy, "phone", Ay(Rsn), A3(zy, "last_name", Ay(w$), A3(zy, "first_name", Ay(w$), A3(zy, "email", Ay(w$), A3(zy, "relationship", Ay(w$), A3(zy, "name", w$, A3(zy, "id", w$, Ke(Fsn)))))))), Nsn = A2(qy, Osn, Ke(ru)), Isn = F6(function(n, r, t, e, u, a) {
        return {
            m9: u,
            qA: r,
            qO: e,
            qU: n,
            r5: t,
            tP: a
        };
    }), Vsn = F2(function(n, r) {
        return {
            qD: r,
            sS: n
        };
    }), Wsn = F4(function(n, r, t, e) {
        return {
            nB: r,
            nC: e,
            nG: t,
            qU: n
        };
    }), Zsn = A3(zy, "collect_high_deductible", xy, A3(zy, "collect_member_id", xy, A3(zy, "collect_group_id", xy, A3(zy, "id", w$, Ke(Wsn))))), Xsn = A2(qy, Zsn, Ke(ru)), Gsn = A3(zy, "carrier", Xsn, A3(zy, "name", w$, Ke(Vsn))), Jsn = A2(qy, Gsn, Ke(ru)), Ysn = A3(zy, "payer_name", l_(w$), A3(zy, "carrier_alias", l_(Jsn), A3(zy, "high_deductible", l_(xy), A3(zy, "member_id", l_(w$), A3(zy, "group_id", l_(w$), A3(zy, "id", w$, Ke(Isn))))))), Qsn = A2(qy, Ysn, Ke(ru)), Ksn = function(n) {
        return A2(Xb, function(n) {
            return fu(n) ? Rt : Ht(n);
        }, n);
    }, nln = F2(function(n, r) {
        return {
            o0: r,
            qU: n
        };
    }), rln = A3(zy, "distance", l_(_$), A3(zy, "id", w$, Ke(nln))), tln = A2(qy, rln, Ke(ru)), eln = A3(zy, "status", w$, A3(zy, "panel_size", C$, A3(zy, "max_patient_age", Ay(C$), A3(zy, "min_patient_age", Ay(C$), A3(zy, "education", Ay(Ey(w$)), A3(zy, "specialties", Ey(w$), A3(zy, "locations", Ey(tln), A3(zy, "photo", A2(Ye, Ksn, Ay(w$)), A3(zy, "bio", Ay(w$), A3(zy, "name", w$, A3(zy, "id", w$, Ke(function(n) {
        return function(r) {
            return function(t) {
                return function(e) {
                    return function(u) {
                        return function(a) {
                            return function(i) {
                                return function(c) {
                                    return function(o) {
                                        return function(f) {
                                            return function(s) {
                                                return {
                                                    mV: t,
                                                    ps: i,
                                                    qU: n,
                                                    hQ: u,
                                                    rZ: o,
                                                    sJ: c,
                                                    sS: r,
                                                    ty: f,
                                                    t3: e,
                                                    v8: a,
                                                    wj: s
                                                };
                                            };
                                        };
                                    };
                                };
                            };
                        };
                    };
                };
            };
        };
    })))))))))))), uln = A2(qy, eln, Ke(ru)), aln = A3(zy, "number", w$, Ke(function(n) {
        return {
            s9: n
        };
    })), iln = A2(qy, A2(Ye, ru, aln), Ke(ru)), cln = A3(zy, "should_charge_credit_card_fees", xy, A3(zy, "emergency_contact", l_(Nsn), A3(zy, "autopay", xy, A3(zy, "preferred_language", Bsn, A3(zy, "location", l_(ben), A3(zy, "practitioner", l_(uln), A3(zy, "company", l_(Tsn), A3(zy, "title", A2(Ge, Esn, l_(w$)), A3(zy, "ssn", l_(iln), A3(zy, "sex", A2(Ge, Usn, l_(w$)), A3(zy, "pronoun_other", l_(w$), A3(zy, "pronouns", A2(Ge, zsn, l_(w$)), A3(zy, "phones", l_(Ey(Rsn)), A3(zy, "name", A2(Ye, OC, w$), A3(zy, "middle_name", l_(w$), A3(zy, "suffix", l_(w$), A3(zy, "last_name", w$, A3(zy, "id", w$, A3(zy, "health_insurance", l_(Qsn), A3(zy, "gender_identity", A2(Ge, Ssn, l_(w$)), A3(zy, "gender", A2(Ge, jsn, l_(w$)), A3(zy, "first_name", w$, A3(zy, "email", l_(w$), A3(zy, "dob", l_(FC), A3(zy, "chosen_suffix", l_(w$), A3(zy, "chosen_title", A2(Ge, Esn, l_(w$)), A3(zy, "chosen_middle_name", l_(w$), A3(zy, "chosen_last_name", l_(w$), A3(zy, "chosen_first_name", l_(w$), A3(zy, "address_zip", l_(w$), A3(zy, "address_state", l_(w$), A3(zy, "address_line2", l_(w$), A3(zy, "address_line1", l_(w$), A3(zy, "address_country", l_(w$), A3(zy, "address_city", l_(w$), Ke(function(n) {
        return function(r) {
            return function(t) {
                return function(e) {
                    return function(u) {
                        return function(a) {
                            return function(i) {
                                return function(c) {
                                    return function(o) {
                                        return function(f) {
                                            return function(s) {
                                                return function(l) {
                                                    return function(d) {
                                                        return function(b) {
                                                            return function(v) {
                                                                return function(m) {
                                                                    return function(p) {
                                                                        return function($) {
                                                                            return function(h) {
                                                                                return function(g) {
                                                                                    return function(w) {
                                                                                        return function(k) {
                                                                                            return function(x) {
                                                                                                return function(y) {
                                                                                                    return function(_) {
                                                                                                        return function(C) {
                                                                                                            return function(D) {
                                                                                                                return function(A) {
                                                                                                                    return function(q) {
                                                                                                                        return function(B) {
                                                                                                                            return function(j) {
                                                                                                                                return function(S) {
                                                                                                                                    return function(z) {
                                                                                                                                        return function(U) {
                                                                                                                                            return function(E) {
                                                                                                                                                return {
                                                                                                                                                    l1: n,
                                                                                                                                                    l2: r,
                                                                                                                                                    l3: t,
                                                                                                                                                    l4: e,
                                                                                                                                                    l5: u,
                                                                                                                                                    l6: a,
                                                                                                                                                    mx: z,
                                                                                                                                                    nm: i,
                                                                                                                                                    nn: c,
                                                                                                                                                    no: o,
                                                                                                                                                    np: s,
                                                                                                                                                    nq: f,
                                                                                                                                                    nN: q,
                                                                                                                                                    o2: l,
                                                                                                                                                    pt: d,
                                                                                                                                                    qb: b,
                                                                                                                                                    qv: v,
                                                                                                                                                    qw: m,
                                                                                                                                                    qC: p,
                                                                                                                                                    qU: $,
                                                                                                                                                    rt: h,
                                                                                                                                                    ku: j,
                                                                                                                                                    sE: w,
                                                                                                                                                    sS: k,
                                                                                                                                                    t2: x,
                                                                                                                                                    uj: B,
                                                                                                                                                    uo: S,
                                                                                                                                                    uB: _,
                                                                                                                                                    uC: y,
                                                                                                                                                    vK: C,
                                                                                                                                                    vN: E,
                                                                                                                                                    wb: D,
                                                                                                                                                    wt: g,
                                                                                                                                                    wD: A,
                                                                                                                                                    w1: U
                                                                                                                                                };
                                                                                                                                            };
                                                                                                                                        };
                                                                                                                                    };
                                                                                                                                };
                                                                                                                            };
                                                                                                                        };
                                                                                                                    };
                                                                                                                };
                                                                                                            };
                                                                                                        };
                                                                                                    };
                                                                                                };
                                                                                            };
                                                                                        };
                                                                                    };
                                                                                };
                                                                            };
                                                                        };
                                                                    };
                                                                };
                                                            };
                                                        };
                                                    };
                                                };
                                            };
                                        };
                                    };
                                };
                            };
                        };
                    };
                };
            };
        };
    })))))))))))))))))))))))))))))))))))), oln = A2(qy, cln, Ke(ru)), fln = F2(function(n, r) {
        return A2($y, k([
            "patients",
            r
        ]), gy(n));
    }), sln = F4(function(n, r, t, e) {
        return A4(dC, n, oln, e, bC(A2(fln, r, t)));
    }), lln = F3(function(n, r, t) {
        var e = t.BD;
        return b({
            gx: r.gx,
            kj: r.kj,
            tE: Rt,
            dw: n,
            bv: Rt
        }, A4(sln, r.gx, $k(n), e.qU, qsn));
    }), dln = F2(function(n, r) {
        return b(r, Dp);
    }), bln = F2(function(n, r) {
        return m(r, {
            xE: Ht(1),
            gx: n.gx
        });
    }), vln = function(n) {
        return {
            $: 3,
            a: n
        };
    }, mln = function(n) {
        return {
            $: 2,
            a: n
        };
    }, pln = {
        $: 1
    }, $ln = function(n) {
        var r = A2(ny, 0, pln);
        return b({
            e1: r.a,
            uj: n
        }, r.b);
    }, hln = F2(function(n, r) {
        return b(r.a, n(r.b));
    }), gln = function(n) {
        return {
            $: 0,
            a: n
        };
    }, wln = F2(function(n, r) {
        switch(n.$){
            case 0:
                var t = A2(mq, n.a, r.e1), e = t.b;
                return v(m(r, {
                    e1: t.a
                }), A2(jp, gln, e), 0);
            case 1:
                return v(r, Dp, 1);
            default:
                return v(r, Dp, 2);
        }
    }), kln = F2(function(n, r) {
        switch(n.$){
            case 0:
                var t = n.a;
                return v(m(r, {
                    tE: MD(t)
                }), Dp, A2(uA, 0, t));
            case 1:
                var e = A2(uc, b(Rt, Dp), A2(Cp, A2(Je, $ln, A2(Je, wk(Ht), hln(jp(mln)))), A2(Xb, qM, r.tE))), u = e.b;
                return v(m(r, {
                    bv: e.a
                }), u, h);
            case 2:
                var a = n.a, i = r.bv;
                if (i.$) return v(r, Dp, h);
                var c = A2(wln, a, i.a), o = c.a, f = c.b, s = c.c ? b(Rt, Dp) : b(Ht(o), f), l = s.b;
                return v(m(r, {
                    bv: s.a
                }), A2(jp, mln, l), h);
            default:
                return v(1 === n.a ? m(r, {
                    bv: Rt
                }) : r, Dp, h);
        }
    }), xln = function(n) {
        return n.sS;
    }, yln = F2(function(n, r) {
        return A2(Ik, h, k([
            A2(Gk, k([
                Nk("text-support")
            ]), k([
                A2(fF, k([
                    Nk("link text-current"),
                    vF(Sx(Da))
                ]), k([
                    ad(n(Id.wD))
                ]))
            ])),
            A2(Gk, k([
                Nk("mx-3 text-support")
            ]), k([
                ad("/")
            ])),
            r
        ]));
    }), _ln = function(n) {
        return n;
    }, Cln = A2(Je, _ln, function(n) {
        return n.pt;
    }), Dln = function(n) {
        return n.w1;
    }, Aln = function(n) {
        return n.qU;
    }, qln = A2(Je, _ln, function(n) {
        return n.sS;
    }), Bln = A2(Je, _ln, function(n) {
        return n.t0;
    }), jln = function(n) {
        return {
            hE: n.hE,
            BT: n.BT,
            im: n.im
        };
    }, Sln = A2(Je, _ln, function(n) {
        return n.u5;
    }), zln = F2(function(n, r) {
        return A2(Ik, k([
            Nk("mb-5")
        ]), k([
            A2(Ik, k([
                Nk("flex justify-between items-center")
            ]), k([
                A2(hx, k([
                    LS(aV),
                    PL,
                    OL
                ]), k([
                    ad(n(Id.py))
                ])),
                A2(PB, k([
                    LS(aV),
                    PL
                ]), k([
                    A2(gV, k([
                        vV(Sx(Ba({
                            qU: Aln(r)
                        })))
                    ]), k([
                        ad(n(1 === Dln(r).$ ? Id.lL : Id.pq))
                    ]))
                ]))
            ])),
            function() {
                var n = Dln(r);
                if (n.$) return ad("");
                var t, e, u, a, i, c = n.a;
                return A2(lV, k([
                    yan,
                    UZ(12)
                ]), k([
                    A2(iV, k([
                        UZ(12)
                    ]), k([
                        (i = qln(c), "" === i ? ad("") : A2(Ik, h, k([
                            ad(i)
                        ]))),
                        (a = Sln(c), 1 === a.$ ? ad("") : A2(Ik, h, k([
                            ad(a.a)
                        ]))),
                        A2(Q4, h, h),
                        (u = Cln(c), 1 === u.$ ? ad("") : A2(Ik, h, k([
                            ad(u.a)
                        ]))),
                        (e = Bln(c), 1 === e.$ ? ad("") : A2(Ik, h, k([
                            ad((t = jln(e.a), A2(bF, t.hE ? 0 : 1, t.BT)))
                        ])))
                    ]))
                ]));
            }()
        ]));
    }), Uln = function(n) {
        return n.sS;
    }, Eln = F2(function(n, r) {
        return {
            $: 10,
            a: n,
            b: r
        };
    }), Pln = Eln, Tln = function(n) {
        return n.o0;
    }, Fln = F2(function(n, r) {
        return r.sF(n);
    }), Lln = F2(function(n, r) {
        return n(Fln(A2(oB, 100 > r ? 1 : 0, r)));
    }), Mln = F3(function(n, r, t) {
        var e = k(r ? [
            PL
        ] : [
            EB,
            A2(Pln, 1, 2)
        ]), u = Tln(t);
        if (u.$) return Sq;
        var a = u.a;
        return A2(Ik, k([
            Nk("flex items-center")
        ]), k([
            A2(Gk, k([
                Nk("mr-1 -mt-1")
            ]), k([
                A2(US, k([
                    Sz,
                    Vq("fill-gray")
                ]), 10)
            ])),
            A2(hx, A2(Ot, BB, e), k([
                ad(A2(Lln, n, a))
            ]))
        ]));
    }), Hln = function(n) {
        return A2(ue, ", ", A2(ae, ",", n.qr));
    }, Rln = F2(function(n, r) {
        return n.$ ? r : A2(Ot, n.a, r);
    }), Oln = A2(xu, Rln, h), Nln = function(n) {
        var r = Oln(k([
            A2(Cp, dF, Jun(n)),
            A2(Cp, Hln, Gun(n))
        ]));
        return A2(Ik, k([
            Nk("flex flex-col flex-grow")
        ]), A2(yu, function(n) {
            return A2(Ik, k([
                Nk("signup__subtitle")
            ]), k([
                A2(PB, k([
                    EB,
                    A2(Pln, 1, 2),
                    BB
                ]), k([
                    ad(n)
                ]))
            ]));
        }, r));
    }, Iln = F2(function(n, r) {
        return k([
            A2(Ik, k([
                Nk("flex flex-row w-full")
            ]), k([
                A2(hx, k([
                    Hz,
                    EB,
                    A2(Pln, 1, 2)
                ]), k([
                    ad(Uln(r))
                ])),
                A3(Mln, n, !1, r)
            ])),
            Nln(r)
        ]);
    }), Vln = F2(function(n, r) {
        var t = function(n) {
            return n.ku;
        }(r);
        if (t.$) return Sq;
        var e = t.a;
        return A2(Ik, k([
            Nk("mb-5")
        ]), k([
            A2(hx, k([
                LS(aV),
                PL,
                OL
            ]), k([
                ad("Location")
            ])),
            A2(lV, k([
                yan,
                UZ(12)
            ]), k([
                A2(iV, k([
                    UZ(12)
                ]), A2(Iln, n, e))
            ]))
        ]));
    }), Wln = function(n) {
        return {
            xJ: n.l3,
            xK: n.l4,
            nr: n.l1,
            yz: n.l2,
            wi: n.l5,
            xy: n.l6
        };
    }, Zln = function(n) {
        return n.o2;
    }, Xln = function(n) {
        return n.pt;
    }, Gln = function(n) {
        return n.qA;
    }, Jln = function(n) {
        return n.qC;
    }, Yln = function(n) {
        return n.m9;
    }, Qln = function(n) {
        return n.r5;
    }, Kln = function(n) {
        return n.sS;
    }, ndn = function(n) {
        return n.tP;
    }, rdn = F2(function(n, r) {
        var t = Jln(r);
        if (1 === t.$) return h;
        var e, u = t.a, a = (e = Yln(u)).$ ? ndn(u) : Ht(Kln(e.a));
        return k([
            A2(Cp, function(r) {
                return n(Id.qD) + ": " + r;
            }, a),
            A2(Cp, function(r) {
                return n(Id.qE) + ": " + r;
            }, Gln(u)),
            A2(Cp, function(r) {
                return n(Id.qF) + ": " + r;
            }, Qln(u))
        ]);
    }), tdn = F2(function(n, r) {
        switch(r){
            case 0:
                return "Ms.";
            case 1:
                return "Mrs.";
            case 2:
                return "Miss";
            case 3:
                return "Mr.";
            case 4:
                return "Dr.";
            default:
                return "Mx.";
        }
    }), edn = function(n) {
        return n.wD;
    }, udn = F2(function(n, r) {
        return B8(A2(ue, " ", Oln(k([
            A2(Cp, tdn(n), edn(r)),
            Ht(xln(r))
        ]))));
    }), adn = function(n) {
        return n.t2;
    }, idn = function(n) {
        return n.qw;
    }, cdn = function(n) {
        return 3 === n;
    }, odn = {
        rr: function(n) {
            return n.qw.rr;
        },
        Ak: function(n) {
            return n.qw.Ak;
        },
        AG: function(n) {
            return n.qw.AG;
        },
        AI: function(n) {
            return n.qw.AI;
        },
        BU: function(n) {
            return n.qw.BU;
        },
        Dx: function(n) {
            return n.qw.Dx;
        },
        Dy: function(n) {
            return n.qw.Dy;
        },
        DP: function(n) {
            return n.qw.DP;
        }
    }, fdn = F2(function(n, r) {
        return n((function() {
            switch(r){
                case 0:
                    return function(n) {
                        return n.Ak;
                    };
                case 1:
                    return function(n) {
                        return n.DP;
                    };
                case 2:
                    return function(n) {
                        return n.AG;
                    };
                case 3:
                    return function(n) {
                        return n.Dx;
                    };
                case 4:
                    return function(n) {
                        return n.Dy;
                    };
                default:
                    return function(n) {
                        return n.AI;
                    };
            }
        })()(odn));
    }), sdn = {
        zA: function(n) {
            return n.uC.zA;
        },
        rr: function(n) {
            return n.uC.rr;
        },
        AI: function(n) {
            return n.uC.AI;
        },
        BU: function(n) {
            return n.uC.BU;
        },
        CK: function(n) {
            return n.uC.CK;
        },
        Dl: function(n) {
            return n.uC.Dl;
        }
    }, ldn = F2(function(n, r) {
        return n((function() {
            switch(r){
                case 0:
                    return function(n) {
                        return n.zA;
                    };
                case 1:
                    return function(n) {
                        return n.CK;
                    };
                case 2:
                    return function(n) {
                        return n.Dl;
                    };
                default:
                    return function(n) {
                        return n.AI;
                    };
            }
        })()(sdn));
    }), ddn = {
        zm: function(n) {
            return n.vK.zm;
        },
        zT: function(n) {
            return n.vK.zT;
        },
        rr: function(n) {
            return n.vK.rr;
        },
        Aj: function(n) {
            return n.vK.Aj;
        },
        BU: function(n) {
            return n.vK.BU;
        }
    }, bdn = F2(function(n, r) {
        return n((function() {
            switch(r){
                case 0:
                    return function(n) {
                        return n.zm;
                    };
                case 1:
                    return function(n) {
                        return n.Aj;
                    };
                default:
                    return function(n) {
                        return n.zT;
                    };
            }
        })()(ddn));
    }), vdn = function(n) {
        return n.uC;
    }, mdn = function(n) {
        return n.vK;
    }, pdn = F2(function(n, r) {
        return B8(A2(ue, ", ", Oln(k([
            A2(Cp, bdn(n), mdn(r)),
            A2(Cp, fdn(n), idn(r)),
            A2(Xb, function(t) {
                return cdn(t) ? r.uB : Ht(A2(ldn, n, t));
            }, vdn(r))
        ]))));
    }), $dn = F2(function(n, r) {
        var t = A2(rdn, n, r), e = A2(Ot, A2(udn, n, r), A2(Ot, A2(Cp, dP(AA("/")), Zln(r)), A2(Ot, A2(pdn, Rk(0), r), A2(yu, A2(Je, jln, A2(Je, function(n) {
            return n.BT;
        }, A2(Je, dF, Ht))), A2(uc, h, adn(r)))))), u = Wln(r), a = k([
            u.xJ,
            u.xK,
            B8(A2(ue, ", ", Oln(k([
                u.nr,
                u.wi,
                u.xy,
                u.yz
            ]))))
        ]), i = A2(Tc, A2(sc, bm, ED), A2(yu, Oln, k([
            e,
            k([
                Xln(r)
            ]),
            a,
            t
        ])));
        return A2(Ik, A2(Ot, Nk("flex flex-col flex-grow"), Xx), A2(yu, function(n) {
            return A2(Ik, k([
                Nk("mb-3")
            ]), A2(yu, function(n) {
                return A2(Ik, k([
                    Nk("mt-1")
                ]), k([
                    A2(PB, k([
                        EB,
                        A2(Pln, 1, 2)
                    ]), k([
                        ad(n)
                    ]))
                ]));
            }, n));
        }, i));
    }), hdn = F2(function(n, r) {
        return A2(Ik, k([
            Nk("mb-5")
        ]), k([
            A2(Ik, k([
                Nk("flex justify-between items-center")
            ]), k([
                A2(hx, k([
                    LS(aV),
                    PL,
                    OL
                ]), k([
                    ad(n(Id.qY))
                ])),
                A2(PB, k([
                    LS(aV),
                    PL
                ]), k([
                    A2(gV, k([
                        vV(Sx(qa({
                            qU: Aln(r)
                        })))
                    ]), k([
                        ad(n(Id.qZ))
                    ]))
                ]))
            ])),
            A2(lV, k([
                yan,
                UZ(12)
            ]), k([
                A2(iV, k([
                    UZ(12)
                ]), k([
                    A2($dn, n, r)
                ]))
            ]))
        ]));
    }), gdn = function(n) {
        return n.uE;
    }, wdn = {
        $: 1
    }, kdn = function(n) {
        return n.mV;
    }, xdn = function(n) {
        var r;
        return A2(uc, Sq, A2(Cp, function(n) {
            return A2(Ik, k([
                Nk("signup__subtitle text-ellipsis")
            ]), k([
                A2(PB, k([
                    EB,
                    A2(Pln, 1, 2)
                ]), k([
                    ad(n)
                ]))
            ]));
        }, (r = kdn(n), A2(Xb, B8, r))));
    }, ydn = function(n) {
        return A3(Vj, "svg", $(k([
            A2(Vx, "width", "109"),
            A2(Vx, "height", "109"),
            A2(Vx, "viewBox", "0 0 109 109"),
            A2(Vx, "fill", "none"),
            A2(Vx, "xmlns", "http://www.w3.org/2000/svg")
        ]), n), k([
            A3(Vj, "rect", k([
                A2(Vx, "x", "1.25"),
                A2(Vx, "y", "1.25"),
                A2(Vx, "width", "106.5"),
                A2(Vx, "height", "106.5"),
                A2(Vx, "rx", "1.75"),
                A2(Vx, "fill", "#F1F6FC"),
                A2(Vx, "stroke", "#C4DCF8"),
                A2(Vx, "stroke-width", "2.5")
            ]), h),
            A3(Vj, "path", k([
                A2(Vx, "d", "M17.3269 97C17.3269 77.8506 32.8506 62.3269 52 62.3269H58C77.1494 62.3269 92.6731 77.8506 92.6731 97V107.673H17.3269V97Z"),
                A2(Vx, "fill", "#F1F6FC"),
                A2(Vx, "stroke", "#C4DCF8"),
                A2(Vx, "stroke-width", "2.65385")
            ]), h),
            A3(Vj, "circle", k([
                A2(Vx, "cx", "38.5"),
                A2(Vx, "cy", "87.5"),
                A2(Vx, "r", "6.17308"),
                A2(Vx, "stroke", "#C4DCF8"),
                A2(Vx, "stroke-width", "2.65385")
            ]), h),
            A3(Vj, "path", k([
                A2(Vx, "d", "M59.2251 90.388L56.3816 87.6739L60.3789 83.4861C62.5996 81.1596 68.4627 77.8636 74.1497 83.2918C79.8366 88.7201 76.807 94.4243 74.5813 96.5979L70.2161 101.171L67.7833 98.8893"),
                A2(Vx, "stroke", "#C4DCF8"),
                A2(Vx, "stroke-width", "2.65385")
            ]), h),
            A3(Vj, "path", k([
                A2(Vx, "d", "M74.5 84.2308C76.5641 83.3461 80.3385 79.1885 82.4615 73.1731"),
                A2(Vx, "stroke", "#C4DCF8"),
                A2(Vx, "stroke-width", "2.65385")
            ]), h),
            A3(Vj, "path", k([
                A2(Vx, "d", "M34.6924 84.2308C32.6283 83.3461 28.8539 79.1885 26.7308 73.1731"),
                A2(Vx, "stroke", "#C4DCF8"),
                A2(Vx, "stroke-width", "2.65385")
            ]), h),
            A3(Vj, "mask", k([
                A2(Vx, "id", "path-7-inside-1"),
                A2(Vx, "fill", "white")
            ]), k([
                A3(Vj, "path", k([
                    A2(Vx, "d", "M75 44.0226C75 58.3171 68.6756 74.8824 55 74.8824C41.3244 74.8824 35 58.3171 35 44.0226C35 29.7282 44.0476 23.1176 55 23.1176C65.9524 23.1176 75 29.7282 75 44.0226Z")
                ]), h)
            ])),
            A3(Vj, "path", k([
                A2(Vx, "d", "M75 44.0226C75 58.3171 68.6756 74.8824 55 74.8824C41.3244 74.8824 35 58.3171 35 44.0226C35 29.7282 44.0476 23.1176 55 23.1176C65.9524 23.1176 75 29.7282 75 44.0226Z"),
                A2(Vx, "fill", "#F1F6FC")
            ]), h),
            A3(Vj, "path", k([
                A2(Vx, "d", "M72.3462 44.0226C72.3462 50.8382 70.8285 58.0833 67.808 63.5249C64.8092 68.9275 60.5583 72.2285 55 72.2285V77.5362C63.1173 77.5362 68.8665 72.5545 72.4487 66.1009C76.0093 59.6863 77.6538 51.5015 77.6538 44.0226H72.3462ZM55 72.2285C49.4417 72.2285 45.1908 68.9275 42.192 63.5249C39.1715 58.0833 37.6538 50.8382 37.6538 44.0226H32.3462C32.3462 51.5015 33.9907 59.6863 37.5513 66.1009C41.1335 72.5545 46.8827 77.5362 55 77.5362V72.2285ZM37.6538 44.0226C37.6538 37.4578 39.7137 32.9822 42.7179 30.1364C45.7514 27.263 50.0436 25.7715 55 25.7715V20.4638C49.004 20.4638 43.2963 22.2776 39.0678 26.283C34.8101 30.3162 32.3462 36.293 32.3462 44.0226H37.6538ZM55 25.7715C59.9564 25.7715 64.2486 27.263 67.2821 30.1364C70.2863 32.9822 72.3462 37.4578 72.3462 44.0226H77.6538C77.6538 36.293 75.1899 30.3162 70.9322 26.283C66.7037 22.2776 60.996 20.4638 55 20.4638V25.7715Z"),
                A2(Vx, "fill", "#C4DCF8"),
                A2(Vx, "mask", "url(#path-7-inside-1)")
            ]), h),
            A3(Vj, "path", k([
                A2(Vx, "d", "M72.4707 46.0588C65.4119 46.0588 62.4707 39 61.8825 35.4706C62.0785 39 57.2942 46.0588 36.5883 46.0588"),
                A2(Vx, "stroke", "#C4DCF8"),
                A2(Vx, "stroke-width", "2.65385")
            ]), h)
        ]));
    }, _dn = function() {
        return ydn;
    }, Cdn = function(n) {
        switch(n.$){
            case 0:
                return k([
                    Ij(ox(n.a))
                ]);
            case 1:
                return k([
                    A2(cE, "width", ee(n.a))
                ]);
            default:
                return k([
                    A2(cE, "height", ee(n.a))
                ]);
        }
    }, Ddn = F2(function(n, r) {
        var t = A2(Ji, Cdn, n);
        return A2(_dn, r, A2(Ot, Ij("inline-block"), t));
    }), Adn = F2(function(n, r) {
        var t = n ? k([
            b("image-portrait--modal", n)
        ]) : h, e = "flex items-center justify-center overflow-hidden image-portrait", u = function(n) {
            return n.t3;
        }(r);
        if (u.$) {
            var a = A2(Ddn, h, 0);
            return A2(Ik, h, k([
                A2(Ik, k([
                    Nk(e),
                    rz(t)
                ]), k([
                    a
                ]))
            ]));
        }
        var i = u.a;
        return A2(Ik, k([
            Nk(e),
            rz(t)
        ]), k([
            A2(AB, k([
                TB(i)
            ]), h)
        ]));
    }), qdn = F2(function(n, r) {
        return k([
            A2(Ik, k([
                Nk("flex flex-col mr-4")
            ]), k([
                A2(Adn, !1, r)
            ])),
            A2(Ik, k([
                Nk("flex flex-col flex-grow")
            ]), k([
                A2(hx, k([
                    Hz,
                    EB,
                    A2(Pln, 1, 2)
                ]), k([
                    ad(hH(r))
                ])),
                xdn(r)
            ])),
            A2(Ik, k([
                Nk("flex flex-col justify-center ml-4 mr-2")
            ]), k([
                A2(fz, k([
                    CU,
                    QS(wdn),
                    ksn(!0)
                ]), k([
                    ad(n(AZ))
                ]))
            ]))
        ]);
    }), Bdn = F2(function(n, r) {
        var t = qM(r);
        if (t.$) return Sq;
        var e, u, a = t.a;
        return A2(Ik, k([
            Nk("mb-5")
        ]), k([
            A2(hx, k([
                LS(aV),
                PL,
                OL
            ]), k([
                ad((e = n(gdn), u = A2(pv, rI("\\w+"), A2(Je, function(n) {
                    return n.ky;
                }, Tin)), A3(pv, rI("^([a-z])|\\s+([a-z])"), A2(Je, function(n) {
                    return n.ky;
                }, u), e)))
            ])),
            A2(lV, k([
                yan,
                UZ(12)
            ]), k([
                A2(iV, k([
                    UZ(12)
                ]), k([
                    A2(Ik, k([
                        Nk("flex flex-row w-full")
                    ]), A2(qdn, n, a))
                ]))
            ]))
        ]));
    }), jdn = F2(function(n, r) {
        var t = Jx(xln(r));
        return A2(Ik, k([
            Nk("text-left")
        ]), k([
            A2(yln, n, t),
            gx,
            A2(mx, k([
                Qk(k([
                    Nk("mt-8 mb-8")
                ]))
            ]), k([
                t
            ])),
            A2(hdn, n, r),
            A2(zln, n, r),
            A2(Bdn, n, r),
            A2(Vln, n, r)
        ]));
    }), Sdn = A2(TS, PS(0), Ht(1)), zdn = F2(function(n, r) {
        return ED(r) ? Sq : A2(Ik, k([
            Nk("mb-4")
        ]), k([
            A2(LB, k([
                PL
            ]), k([
                ad(n)
            ])),
            A2(hx, k([
                BB,
                PL,
                LS(Sdn)
            ]), k([
                ad(A2(ue, ", ", r))
            ]))
        ]));
    }), Udn = F3(function(n, r, t) {
        var e = ED(t) && ED(r) ? 12 : 7;
        return A2(lV, k([
            jV(k([
                Nk("row--tweak")
            ])),
            dV(NZ)
        ]), k([
            A2(iV, k([
                UZ(12),
                GZ(e),
                dV(aV),
                A2(XZ, 1, NZ)
            ]), k([
                function() {
                    if (n.$) return Sq;
                    var r = n.a;
                    return A2(Ik, k([
                        Nk("sm:pr-2")
                    ]), k([
                        ad(r)
                    ]));
                }()
            ])),
            A2(iV, k([
                UZ(12),
                GZ(5)
            ]), k([
                A2(zdn, "Specialties", t),
                A2(zdn, "Education", r)
            ]))
        ]));
    }), Edn = {
        $: 2
    }, Pdn = function(n) {
        return n.o5;
    }, Tdn = function(n) {
        return A2(fz, k([
            CU,
            JS,
            QS(Edn)
        ]), k([
            ad(n(Pdn))
        ]));
    }, Fdn = function(n) {
        return n.qs;
    }, Ldn = function(n) {
        return n.rZ;
    }, Mdn = function(n) {
        return n.sJ;
    }, Hdn = F3(function(n, r, t) {
        var e = n.$ ? "" : "from " + ee(n.a) + " ", u = r.$ ? "" : "to " + ee(r.a);
        return fu(e) && fu(u) ? "" : (t ? "Only treats" : "Treats") + " ages " + (e + u);
    }), Rdn = F3(function(n, r, t) {
        var e = r.ku;
        return A2(Ik, k([
            Nk("flex flex-col sm:flex-row w-full")
        ]), k([
            A2(Ik, k([
                Nk("flex flex-col mr-4")
            ]), k([
                A2(Adn, !0, t)
            ])),
            A2(Ik, k([
                Nk("flex flex-col")
            ]), k([
                A2(Ik, k([
                    Nk("mt-4 sm:mt-0")
                ]), k([
                    A2(PB, k([
                        rx
                    ]), k([
                        ad(hH(t))
                    ]))
                ])),
                A2(hx, k([
                    PL
                ]), k([
                    ad(A3(Hdn, Mdn(t), Ldn(t), !1))
                ])),
                function() {
                    if (e.$) return Sq;
                    var n = e.a;
                    return A2(Ik, k([
                        Nk("mt-1 sm:mt-0")
                    ]), k([
                        A2(hx, k([
                            BB,
                            PL
                        ]), k([
                            ad(Fdn(n))
                        ]))
                    ]));
                }(),
                A2(Ik, k([
                    Nk("mt-1")
                ]), Gq(A2(uc, Sq, A2(Cp, A2(Mln, n, !0), e))))
            ]))
        ]));
    }), Odn = F3(function(n, r, t) {
        var e, u = t.uj, a = t.e1, i = function(n) {
            return n.v8;
        }(u), c = function(n) {
            return A2(uc, h, n.ps);
        }(u), o = kdn(u), f = A2(Ep, ru, k([
            Ht(jZ(k([
                A3(Rdn, n, r, u)
            ]))),
            (e = v(o, ED(c), ED(i)), 1 === e.a.$ && e.b && e.c ? Rt : Ht(IS(k([
                A3(Udn, o, c, i)
            ])))),
            r.xk ? Ht(XS(k([
                Tdn(n)
            ]))) : Rt
        ]));
        return A2(Tz, f, fA(a));
    }), Ndn = F2(function(n, r) {
        return A2(px, mln, A2(uc, Sq, A2(Cp, A2(Odn, n, {
            ku: Rt,
            xk: !1
        }), r)));
    }), Idn = F2(function(n, r) {
        var t;
        return {
            gF: k([
                A2(Ndn, n, r.bv),
                A2(Ik, k([
                    Nk("panel")
                ]), (t = r.tE, t.$ ? Yk : k([
                    A2(jdn, n, t.a)
                ])))
            ]),
            wD: n(Id.wD)
        };
    }), Vdn = Ux({
        zO: lln,
        Ab: dln,
        Ct: bln,
        Dd: function() {
            return wD(m9(vln));
        },
        DB: kln,
        DH: Idn
    }), Wdn = function(n) {
        return {
            $: 17,
            a: n
        };
    }, Zdn = function(n) {
        switch(n){
            case "no":
                return Ke(0);
            case "yes":
                return Ke(1);
            case "optional":
                return Ke(2);
            case "require":
                return Ke(3);
            case "default":
                return Ke(4);
            default:
                return yy("Unsupported collection option: " + n);
        }
    }, Xdn = F2(function(n, r) {
        return {
            qj: r,
            qU: n
        };
    }), Gdn = F6(function(n, r, t, e, u, a) {
        return {
            oV: e,
            qL: u,
            qU: n,
            rm: t,
            vd: a,
            wD: r
        };
    }), Jdn = function(n) {
        switch(n){
            case "string":
                return Ke(0);
            case "multiple_strings":
                return Ke(1);
            case "boolean":
                return Ke(2);
            default:
                return yy("Unsupported item type: " + n);
        }
    }, Ydn = A3(zy, "required", xy, A3(zy, "help_text", l_(w$), A3(zy, "description", l_(w$), A3(zy, "item_type", A2(Ge, Jdn, w$), A3(zy, "title", w$, A3(zy, "id", w$, Ke(Gdn))))))), Qdn = A2(qy, Ydn, Ke(ru)), Kdn = A3(zy, "form_items", Ey(Qdn), A3(zy, "id", w$, Ke(Xdn))), nbn = A2(qy, Kdn, Ke(ru)), rbn = A3(zy, "allowed_zip_codes_on_signup", Ey(w$), A3(zy, "restrict_zip_codes_on_signup", xy, A3(zy, "forms", Ey(nbn), A3(zy, "collect_tobacco_use", xy, A3(zy, "post_signup_button_label", l_(w$), A3(zy, "show_post_signup_footer_button", xy, A3(zy, "post_signup_message", l_(w$), A3(zy, "post_signup_redirect_url", l_(w$), A3(zy, "collect_address_on_signup", A2(Ge, Zdn, w$), A3(zy, "collect_ssn_on_signup", A2(Ge, Zdn, w$), A3(zy, "collect_location_on_signup", A2(Ge, Zdn, w$), A3(zy, "collect_practitioner_on_signup", A2(Ge, Zdn, w$), Ke(function(n) {
        return function(r) {
            return function(t) {
                return function(e) {
                    return function(u) {
                        return function(a) {
                            return function(i) {
                                return function(c) {
                                    return function(o) {
                                        return function(f) {
                                            return function(s) {
                                                return function(l) {
                                                    return {
                                                        mf: l,
                                                        ny: e,
                                                        nF: r,
                                                        nI: n,
                                                        nK: t,
                                                        nM: o,
                                                        qo: f,
                                                        kX: c,
                                                        kY: a,
                                                        kZ: u,
                                                        vr: s,
                                                        li: i
                                                    };
                                                };
                                            };
                                        };
                                    };
                                };
                            };
                        };
                    };
                };
            };
        };
    }))))))))))))), tbn = A2(qy, rbn, Ke(ru)), ebn = F3(function(n, r, t) {
        return A4(dC, z9(n), tbn, t, bC(function(n) {
            return A2($y, k([
                "signup_setting"
            ]), gy(n));
        }(r)));
    }), ubn = F2(function(n, r) {
        return A3(ebn, n, $k(r), Wdn);
    }), abn = function(n) {
        return {
            $: 5,
            a: n
        };
    }, ibn = function(n) {
        return n.b.oP;
    }, cbn = {
        zm: function(n) {
            return n.qv.zm;
        },
        rr: function(n) {
            return n.qv.rr;
        },
        Aj: function(n) {
            return n.qv.Aj;
        },
        Bw: function(n) {
            return n.qv.Bw;
        }
    }, obn = {
        xJ: "",
        xK: "",
        nr: "",
        yz: "United States",
        wi: "",
        xy: ""
    }, fbn = {
        $: 0
    }, sbn = k([
        0,
        1,
        2,
        3,
        4
    ]), lbn = function(n) {
        switch(n){
            case 0:
                return "Address Line 1";
            case 1:
                return "City";
            case 2:
                return "State";
            case 3:
                return "Zip";
            default:
                return "Country";
        }
    }, dbn = F2(function(n, r) {
        return {
            cf: VJ,
            cs: fbn,
            kk: AO(r),
            qU: n,
            vd: !1,
            iF: Rt,
            b8: !1,
            bA: h,
            x: A2(jO, sbn, lbn)
        };
    }), bbn = function(n) {
        return A2(dbn, n, obn);
    }, vbn = F2(function(n, r) {
        return r.$ ? n(vO) : Kln(r.a);
    }), mbn = function(n) {
        return n.qD;
    }, pbn = function(n) {
        return n.qU;
    }, $bn = function(n) {
        return Ht(n.$ ? "other" : pbn(mbn(n.a)));
    }, hbn = function(n) {
        return {
            $: 2,
            a: n
        };
    }, gbn = {
        hP: 10,
        sS: Rt
    }, wbn = A2($y, k([
        "health_insurance_carrier_aliases"
    ]), hy), kbn = F3(function(n, r, t) {
        return A4(dC, z9(n), Ey(Jsn), t, A2(iH, function(n) {
            var r, t = n(gbn);
            return $((r = t.sS).$ ? h : k([
                A2(Ax, "name", r.a)
            ]), k([
                A2(YX, "limit", t.hP)
            ]));
        }(r), bC(wbn)));
    }), xbn = F2(function(n, r) {
        return A3(kbn, n, function(n) {
            return m(n, {
                sS: r
            });
        }, hbn);
    }), ybn = function(n) {
        return {
            ah: Rt,
            bH: "",
            Y: n,
            bT: "",
            qO: !0,
            bX: "",
            hW: !1
        };
    }, _bn = function(n) {
        return {
            g6: VJ,
            qU: n.qU,
            dj: n.Dr,
            kt: n.Dt,
            aN: !1,
            Di: ""
        };
    }, Cbn = k([
        0,
        1,
        2,
        3
    ]), Dbn = function(n) {
        switch(n){
            case 0:
                return "Carrier";
            case 1:
                return "CarrierAliasOther";
            case 2:
                return "GroupID";
            default:
                return "MemberID";
        }
    }, Abn = F2(function(n, r) {
        return b({
            gx: n,
            ej: _bn({
                qU: "carrier-select",
                Dr: vbn,
                Dt: $bn
            }),
            ek: Mx,
            kk: AO(ybn(r)),
            ft: !1,
            x: A2(jO, Cbn, Dbn)
        }, A2(xbn, n, Rt));
    }), qbn = function(n) {
        return A2(yO, n, {
            hE: !0,
            BT: "",
            im: II
        });
    }, Bbn = function(n) {
        return n.a;
    }, jbn = F2(function(n, r) {
        var t = r.$ ? 1 : Bbn(r.a);
        return n + "-phone-" + ee(t);
    }), Sbn = function(n) {
        return n.qU;
    }, zbn = function(n) {
        var r = qbn(A2(jbn, n, Rt));
        return {
            qU: n,
            t2: A2(L6, r, Z3),
            vd: !1,
            dG: Rt,
            M: A2(jO, k([
                r
            ]), Sbn)
        };
    }, Ubn = {
        vK: Rt
    }, Ebn = k([
        0
    ]), Pbn = function() {
        return "Sex";
    }, Tbn = function(n) {
        return Ht(OB(A2(bdn, Rk(0), n)));
    }, Fbn = function(n) {
        return {
            kk: AO(Ubn),
            qU: n,
            vd: !1,
            fD: id({
                qU: n + "-select",
                Dr: bdn,
                Dt: Tbn
            }),
            x: A2(jO, Ebn, Pbn)
        };
    }, Lbn = {
        wD: Rt
    }, Mbn = k([
        0
    ]), Hbn = function() {
        return "Title";
    }, Rbn = function(n) {
        return Ht(A2(tdn, Rk(0), n));
    }, Obn = function(n) {
        return {
            kk: AO(Lbn),
            qU: n,
            vd: !1,
            fN: id({
                qU: n + "-select",
                Dr: tdn,
                Dt: Rbn
            }),
            x: A2(jO, Mbn, Hbn)
        };
    }, Nbn = {
        dt: "",
        fz: Rt
    }, Ibn = k([
        0,
        1
    ]), Vbn = function(n) {
        return n ? "FieldOther" : "Field";
    }, Wbn = function(n) {
        var r = n.Dr, t = n.Dt, e = n.qU, u = n.z2;
        return {
            zn: n.zn,
            kk: AO(Nbn),
            qU: e,
            z2: u,
            vd: !1,
            lc: r,
            fP: id({
                qU: e + "-select",
                Dr: r,
                Dt: t
            }),
            x: A2(jO, Ibn, Vbn)
        };
    }, Zbn = function(n) {
        return 2 === n;
    }, Xbn = F2(function(n, r) {
        return n((function() {
            switch(r){
                case 0:
                    return function(n) {
                        return n.zm;
                    };
                case 1:
                    return function(n) {
                        return n.Aj;
                    };
                default:
                    return function(n) {
                        return n.Bw;
                    };
            }
        })()(cbn));
    }), Gbn = function(n) {
        return Ht(function() {
            switch(n){
                case 0:
                    return "female";
                case 1:
                    return "male";
                default:
                    return "other";
            }
        }());
    }, Jbn = F2(function(n, r) {
        return Wbn({
            zn: r,
            qU: n,
            z2: Zbn,
            Dr: Xbn,
            Dt: Gbn
        });
    }), Ybn = function(n) {
        return 5 === n;
    }, Qbn = function(n) {
        return Ht(OB(function() {
            switch(n){
                case 0:
                    return "Man";
                case 1:
                    return "Woman";
                case 2:
                    return "Non-binary";
                case 3:
                    return "Trans Man";
                case 4:
                    return "Trans Woman";
                default:
                    return "Not Listed";
            }
        }()));
    }, Kbn = F2(function(n, r) {
        return Wbn({
            zn: r,
            qU: n,
            z2: Ybn,
            Dr: fdn,
            Dt: Qbn
        });
    }), nvn = function(n) {
        switch(n){
            case 0:
                return Ht("He/Him/His");
            case 1:
                return Ht("She/Her/Hers");
            case 2:
                return Ht("They/Them/Theirs");
            default:
                return Ht("Not Listed");
        }
    }, rvn = F2(function(n, r) {
        return Wbn({
            zn: r,
            qU: n,
            z2: cdn,
            Dr: ldn,
            Dt: nvn
        });
    }), tvn = function(n) {
        return n.b.vj;
    }, evn = F2(function(n, r) {
        return m(r, {
            dG: Ht(n)
        });
    }), uvn = F2(function(n, r) {
        return tvn(n) ? A2(evn, sO, r) : r;
    }), avn = F2(function(n, r) {
        return m(r, {
            vd: n
        });
    }), ivn = F2(function(n, r) {
        return m(r, {
            vd: n
        });
    }), cvn = F2(function(n, r) {
        var t = A2(Abn, n, !1), e = t.a, u = t.b;
        return b({
            l0: A2(avn, !1, bbn("main-address")),
            nm: "",
            nn: "",
            no: "",
            np: "",
            nq: Obn("chosen-title"),
            bg: CO("dob"),
            pt: "",
            qb: "",
            qv: A2(Jbn, "gender", cbn.rr),
            qw: A2(Kbn, "gender-identity", odn.rr),
            aj: !1,
            a_: e,
            rt: "",
            sE: "",
            t2: A2(uvn, r, A2(ivn, !0, zbn("phones"))),
            uo: A2(F$, ibn(r), Pb("preferred-language")),
            uC: A2(rvn, "pronouns", sdn.rr),
            vK: Fbn("sex"),
            wb: "",
            wt: "",
            wD: Obn("title")
        }, A2(jp, abn, u));
    }), ovn = k([
        0,
        2
    ]), fvn = function(n) {
        switch(n){
            case 0:
                return "Email";
            case 1:
                return "Phone";
            default:
                return "Address";
        }
    }, svn = F3(function(n, r, t) {
        var e = t.BD, u = A2(cvn, r.gx, n), a = u.b, i = AO(u.a);
        return b({
            gx: r.gx,
            kj: r.kj,
            kk: i,
            tE: Rt,
            BK: e.qU,
            dw: n,
            fF: Rt,
            x: A2(jO, ovn, fvn)
        }, Hu(k([
            A2(ubn, r.gx, n),
            a
        ])));
    }), lvn = F2(function(n, r) {
        return b(r, Dp);
    }), dvn = F2(function(n, r) {
        return m(r, {
            xE: Ht(1),
            gx: n.gx
        });
    }), bvn = function(n) {
        return {
            $: 0,
            a: n
        };
    }, vvn = Kn("googlePlacesAddressDetails", A2(Ge, function(n) {
        return A2(Ge, function(r) {
            return Ke({
                l0: r,
                qU: n
            });
        }, A2(Tu, "address", w$));
    }, A2(Tu, "id", w$))), mvn = Kn("googlePlacesAddressSuggestions", A2(Ge, function(n) {
        return A2(Ge, function(r) {
            return Ke({
                qU: r,
                bA: n
            });
        }, A2(Tu, "id", w$));
    }, A2(Tu, "suggestions", v$))), pvn = xk(k([
        ($G = function(n) {
            return {
                $: 3,
                a: n
            };
        }, mvn($G)),
        (pG = function(n) {
            return {
                $: 4,
                a: n
            };
        }, vvn(pG))
    ])), $vn = function(n) {
        return {
            $: 0,
            a: n
        };
    }, hvn = function(n) {
        return {
            $: 16,
            a: n
        };
    }, gvn = function(n) {
        return {
            $: 3,
            a: n
        };
    }, wvn = function(n) {
        return {
            $: 2,
            a: n
        };
    }, kvn = function(n) {
        return {
            $: 6,
            a: n
        };
    }, xvn = function(n) {
        return n.ny;
    }, yvn = function(n) {
        return 3 === n;
    }, _vn = function(n) {
        return yvn(xvn(n));
    }, Cvn = function(n) {
        return n.nm;
    }, Dvn = function(n) {
        return n.nn;
    }, Avn = function(n) {
        return n.no;
    }, qvn = function(n) {
        return n.np;
    }, Bvn = function(n) {
        return n.nq;
    }, jvn = function(n) {
        return n.qb;
    }, Svn = function(n) {
        return n.qv;
    }, zvn = function(n) {
        return {
            xJ: A2(uc, "", n.xJ),
            xK: A2(uc, "", n.xK),
            nr: A2(uc, "", n.nr),
            yz: A2(uc, "United States", n.yz),
            wi: A2(uc, "", n.wi),
            xy: A2(uc, "", n.xy)
        };
    }, Uvn = F2(function(n, r) {
        return {
            cf: VJ,
            cs: fbn,
            kk: AO(zvn(r)),
            qU: n,
            vd: !1,
            iF: Rt,
            b8: !1,
            bA: h,
            x: A2(jO, sbn, lbn)
        };
    }), Evn = function(n) {
        var r = n.nn;
        return tI(n.nm) && tI(r);
    }, Pvn = function(n) {
        return n.rt;
    }, Tvn = function(n) {
        return n.sE;
    }, Fvn = function(n) {
        return n.s9;
    }, Lvn = function(n) {
        return n.uo;
    }, Mvn = function(n) {
        return {
            $: 0,
            a: n
        };
    }, Hvn = F2(function(n, r) {
        switch(n.$){
            case 0:
                return m(r, {
                    Y: n.a
                });
            case 1:
                return m(r, {
                    ah: n.a
                });
            case 2:
                return m(r, {
                    bH: n.a
                });
            case 3:
                return m(r, {
                    bT: n.a
                });
            case 4:
                return m(r, {
                    bX: n.a
                });
            default:
                return m(r, {
                    qO: n.a
                });
        }
    }), Rvn = F2(function(n, r) {
        return m(r, {
            kk: A3(WI, Hvn, Mvn(n), r.kk)
        });
    }), Ovn = function(n) {
        return n.wb;
    }, Nvn = function(n) {
        return n.wt;
    }, Ivn = function(n) {
        return {
            $: 0,
            a: n
        };
    }, Vvn = {
        $: 1
    }, Wvn = function(n) {
        return n.qO;
    }, Zvn = F2(function(n, r) {
        var t, e, u, a;
        return m(r, {
            kk: AO((t = n, e = ndn(t), u = Yln(t), a = u.$ ? b(Ht(Vvn), e) : b(A2(Cp, function(n) {
                return Ivn(n);
            }, u), Rt), {
                ah: a.a,
                bH: A2(uc, "", a.b),
                Y: !0,
                bT: A2(uc, "", Gln(t)),
                qO: A2(uc, !1, Wvn(t)),
                bX: A2(uc, "", Qln(t)),
                hW: $H(u)
            }))
        });
    }), Xvn = F3(function(n, r, t) {
        return m(t, {
            wi: A3(Qu, r(n), qO, t.wi)
        });
    }), Gvn = F2(function(n, r) {
        var t = A2(jbn, r.qU, Ht(r.t2)), e = n.$ ? qbn(t) : A2(yO, t, n.a);
        return b(t, m(r, {
            t2: A2(L6, e, r.t2),
            M: A3(Xvn, e, Sbn, r.M)
        }));
    }), Jvn = F2(function(n, r) {
        for(;;){
            if (!n.b) return r;
            var t = n.a;
            n = n.b, r = A2(Gvn, Ht(t), r).b;
        }
    }), Yvn = function(n) {
        return Gb(n.b);
    }, Qvn = function(n) {
        return A2(Xb, function(n) {
            return Ht(n.b);
        }, Yvn(n));
    }, Kvn = function(n) {
        return oe(n.b);
    }, nmn = F2(function(n, r) {
        return A2(W3, r.a, A2(Tc, function(r) {
            return !i(r.a, n);
        }, r.b));
    }), rmn = F3(function(n, r, t) {
        return m(t, {
            wi: A2(aa, r(n), t.wi)
        });
    }), tmn = F3(function(n, r, t) {
        var e = A3(rmn, t, Sbn, n.M);
        return m(n, {
            t2: A2(nmn, r, n.t2),
            M: e
        });
    }), emn = F2(function(n, r) {
        if (ED(n)) return r;
        var t = A2(Jvn, n, r);
        if (Kvn(t.t2) > 1) {
            var e = Qvn(t.t2);
            return e.$ ? t : A3(tmn, t, 1, e.a);
        }
        return t;
    }), umn = F2(function(n, r) {
        return n.$ ? r : A2(emn, A2(yu, jln, n.a), r);
    }), amn = function(n) {
        return {
            $: 0,
            a: n
        };
    }, imn = F2(function(n, r) {
        return m(r, n.$ ? {
            dt: n.a
        } : {
            fz: n.a
        });
    }), cmn = F2(function(n, r) {
        return m(r, {
            kk: A3(WI, imn, amn(Ht(n)), r.kk)
        });
    }), omn = F2(function(n, r) {
        return n.$ ? r : A2(cmn, n.a, r);
    }), fmn = F2(function(n, r) {
        return m(r, {
            vK: n
        });
    }), smn = F2(function(n, r) {
        return m(r, {
            kk: A3(WI, fmn, Ht(n), r.kk)
        });
    }), lmn = F2(function(n, r) {
        return n.$ ? r : A2(smn, n.a, r);
    }), dmn = F2(function(n, r) {
        return m(r, {
            wD: n
        });
    }), bmn = F2(function(n, r) {
        return m(r, {
            kk: A3(WI, dmn, Ht(n), r.kk)
        });
    }), vmn = F2(function(n, r) {
        return n.$ ? r : A2(bmn, n.a, r);
    }), mmn = F4(function(n, r, t, e) {
        var u, a = A2(uvn, r, A2(umn, adn(n), A2(ivn, !0, zbn("phones")))), i = (u = Jln(n)).$ ? A2(Rvn, !1, e.a_) : A2(Zvn, u.a, A2(Rvn, !0, e.a_)), c = A2(uc, "", Dvn(n)), o = A2(uc, "", Cvn(n));
        return {
            l0: A2(avn, _vn(t), A2(Uvn, "main-address", Wln(n))),
            nm: o,
            nn: c,
            no: A2(uc, "", Avn(n)),
            np: A2(uc, "", qvn(n)),
            nq: A2(vmn, Bvn(n), Obn("chosen-title")),
            bg: A2(EN, Zln(n), CO("date-of-birth")),
            pt: A2(uc, "", Xln(n)),
            qb: jvn(n),
            qv: A2(omn, Svn(n), A2(Jbn, "gender", cbn.rr)),
            qw: A2(omn, idn(n), A2(Kbn, "gender-identity", odn.rr)),
            aj: !Evn({
                nm: o,
                nn: c
            }),
            a_: i,
            rt: Pvn(n),
            sE: A2(uc, "", Tvn(n)),
            t2: a,
            uo: A2(F$, Lvn(n), Pb("preferred-language")),
            uC: A2(omn, vdn(n), A2(rvn, "pronouns", sdn.rr)),
            vK: A2(lmn, mdn(n), Fbn("sex")),
            wb: A2(uc, "", A2(Cp, Fvn, Ovn(n))),
            wt: A2(uc, "", Nvn(n)),
            wD: A2(vmn, edn(n), Obn("title"))
        };
    }), pmn = F2(function(n, r) {
        switch(n.$){
            case 1:
                return m(r, {
                    pt: n.a
                });
            case 2:
                return m(r, {
                    t2: n.a
                });
            case 0:
                return m(r, {
                    l0: n.a
                });
            default:
                return m(r, {
                    a_: n.a
                });
        }
    }), $mn = function(n) {
        return {
            $: 14,
            a: n
        };
    }, hmn = function(n) {
        return tI(n) ? bk : mk(uF(n));
    }, gmn = function(n) {
        var r = jN(n.kk);
        return k([
            b("address_city", hmn(r.nr)),
            b("address_country", hmn(r.yz)),
            b("address_line1", hmn(r.xJ)),
            b("address_line2", hmn(r.xK)),
            b("address_state", hmn(r.wi)),
            b("address_zip", hmn(r.xy))
        ]);
    }, wmn = function(n) {
        switch(n.$){
            case 0:
                return mk("mobile");
            case 1:
                return mk("home");
            case 2:
                return mk("office");
            default:
                return mk(n.a);
        }
    }, kmn = function(n) {
        return tI(n.BT) ? bk : vk(k([
            b("number", hmn(n.BT)),
            b("type", wmn(n.dL)),
            b("us_formattable", kA(!n.CD))
        ]));
    }, xmn = F2(function(n, r) {
        return A2(wq, n, r.b);
    }), ymn = function(n) {
        return A2(xmn, function(n) {
            return kmn(n.b);
        }, n);
    }, _mn = function(n) {
        var r = jN(n.kk), t = r.bH;
        return r.Y ? A2(Cp, function(n) {
            return n.$ ? t : Kln(n.a);
        }, r.ah) : Rt;
    }, Cmn = function(n) {
        return tI(n) ? bk : mk(n);
    }, Dmn = function(n) {
        return jN(n.kk).bT;
    }, Amn = function(n) {
        return jN(n.kk).Y;
    }, qmn = function(n) {
        return jN(n.kk).qO;
    }, Bmn = function(n) {
        return jN(n.kk).bX;
    }, jmn = F5(function(n, r, t, e, u) {
        return A4(kq, n, oln, u, A2(xq, vk(k([
            e
        ])), bC(A2(fln, r, t))));
    }), Smn = function(n) {
        var r, t, e = $k(n.dw), u = (r = n.tE).$ ? "" : Aln(r.a), a = (t = jN(n.kk), b("patient", vk(function(n) {
            var r, t, e, u;
            return A2(Ot, b("email", mk(n.pt)), A2(Ot, b("phones", ymn(n.t2.t2)), $(Amn(r = n.a_) ? k([
                b("health_insurance_payer_name", Cmn(A2(uc, "", _mn(r)))),
                b("health_insurance_carrier", A2(uc, bk, A2(Cp, function(n) {
                    return vk(k([
                        b("id", mk(n))
                    ]));
                }, (t = r, e = jN(t.kk), u = e.ah, e.Y ? u.$ || u.a.$ ? Rt : Ht(pbn(mbn(u.a.a))) : Rt)))),
                b("health_insurance_member_id", Cmn(Bmn(r))),
                b("health_insurance_group_id", Cmn(Dmn(r))),
                b("health_insurance_high_deductible", kA(qmn(r)))
            ]) : k([
                b("health_insurance_payer_name", bk),
                b("health_insurance_carrier", bk),
                b("health_insurance_member_id", bk),
                b("health_insurance_group_id", bk),
                b("health_insurance_high_deductible", bk)
            ]), gmn(n.l0))));
        }(t))));
        return A5(jmn, n.gx, e, u, a, $mn);
    }, zmn = F2(function(n, r) {
        return {
            l0: n,
            qU: r
        };
    }), Umn = function(n) {
        return {
            $: 0,
            a: n
        };
    }, Emn = function(n) {
        return m(n, {
            b8: !1
        });
    }, Pmn = function(n) {
        return {
            $: 7,
            a: n
        };
    }, Tmn = function(n) {
        return A2(Eu, Pmn, gu(n));
    }, Fmn = {
        Da: ZK(300),
        Dz: function(n) {
            return {
                $: 6,
                a: n
            };
        }
    }, Lmn = F3(function(n, r, t) {
        return {
            oV: n,
            t5: r,
            DA: t
        };
    }), Mmn = A3(zy, "types", Ey(w$), A3(zy, "place_id", w$, A3(zy, "description", w$, Ke(Lmn)))), Hmn = Ey(Mmn), Rmn = F5(function(n, r, t, e, u) {
        return {
            jO: n,
            zt: r,
            sS: t,
            t5: e,
            DA: u
        };
    }), Omn = F3(function(n, r, t) {
        return {
            rR: n,
            vL: r,
            DA: t
        };
    }), Nmn = k([
        b("street_address", 0),
        b("route", 1),
        b("intersection", 2),
        b("political", 3),
        b("country", 4),
        b("administrative_area_level_1", 5),
        b("administrative_area_level_2", 6),
        b("administrative_area_level_3", 7),
        b("administrative_area_level_4", 8),
        b("administrative_area_level_5", 9),
        b("colloquial_area", 10),
        b("locality", 11),
        b("sublocality", 12),
        b("sublocality_level_1", 13),
        b("sublocality_level_2", 14),
        b("sublocality_level_3", 15),
        b("sublocality_level_4", 16),
        b("sublocality_level_5", 17),
        b("neighborhood", 18),
        b("premise", 19),
        b("subpremise", 20),
        b("postal_code", 21),
        b("natural_feature", 22),
        b("airport", 23),
        b("park", 24),
        b("post_box", 25),
        b("street_number", 26),
        b("floor", 27),
        b("room", 28),
        b("establishment", 29),
        b("point_of_interest", 30),
        b("parking", 31),
        b("postal_town", 32),
        b("bus_station", 33),
        b("train_station", 34),
        b("transit_station", 35),
        b("postal_code_suffix", 36)
    ]), Imn = Ml(Nmn), Vmn = function(n) {
        return A2(uc, 37, A2(Zu, n, Imn));
    }, Wmn = A2(sc, Ke, Vmn), Zmn = A2(Ge, Wmn, w$), Xmn = Ey(Zmn), Gmn = A3(zy, "types", Xmn, A3(zy, "short_name", w$, A3(zy, "long_name", w$, Ke(Omn)))), Jmn = A3(zy, "types", Ey(w$), A3(zy, "place_id", w$, A3(zy, "name", w$, A3(zy, "formatted_address", w$, A3(zy, "address_components", Ey(Gmn), Ke(Rmn)))))), Ymn = function(n) {
        switch(n.$){
            case 0:
                return lbn(0);
            case 1:
                return "Address Line 2";
            case 2:
                return lbn(1);
            case 3:
                return lbn(2);
            case 4:
                return lbn(3);
            default:
                return lbn(4);
        }
    }, Qmn = F2(function(n, r) {
        switch(n.$){
            case 0:
                return m(r, {
                    xJ: n.a
                });
            case 1:
                return m(r, {
                    xK: n.a
                });
            case 2:
                return m(r, {
                    nr: n.a
                });
            case 3:
                return m(r, {
                    wi: n.a
                });
            case 4:
                return m(r, {
                    xy: n.a
                });
            default:
                return m(r, {
                    yz: n.a
                });
        }
    }), Kmn = function(n) {
        return m(n, {
            b8: !0
        });
    }, npn = Jn("googlePlacesPredictAddress", function(n) {
        return vk(k([
            b("address", mk(n.l0)),
            b("id", mk(n.qU))
        ]));
    }), rpn = F2(function(n, r) {
        return {
            qU: r,
            t5: n
        };
    }), tpn = function(n) {
        return n.t5;
    }, epn = Jn("googlePlacesPredictionDetails", function(n) {
        return vk(k([
            b("id", mk(n.qU)),
            b("placeId", mk(n.t5))
        ]));
    }), upn = F2(function(n, r) {
        var t, e = r.$ ? Dp : (t = A2(rpn, tpn(r.a), n.qU), epn(t));
        return b(m(n, {
            b8: !1
        }), e);
    }), apn = function(n) {
        return {
            $: 0,
            a: n
        };
    }, ipn = function(n) {
        return {
            $: 1,
            a: n
        };
    }, cpn = function(n) {
        return {
            $: 2,
            a: n
        };
    }, opn = function(n) {
        return {
            $: 5,
            a: n
        };
    }, fpn = function(n) {
        return {
            $: 3,
            a: n
        };
    }, spn = function(n) {
        return {
            $: 4,
            a: n
        };
    }, lpn = F2(function(n, r) {
        return A2(Cp, function(n) {
            return n.rR;
        }, Gb(A2(Tc, function(n) {
            return A2(lA, r, n.DA);
        }, n.jO)));
    }), dpn = F2(function(n, r) {
        return tI(r) ? n : r;
    }), bpn = F2(function(n, r) {
        return A2(Cp, function(n) {
            return n.vL;
        }, Gb(A2(Tc, function(n) {
            return A2(lA, r, n.DA);
        }, n.jO)));
    }), vpn = F2(function(n, r) {
        return A3(WI, Qmn, opn(function(n) {
            return A2(uc, "", A2(lpn, n, 4));
        }(n)), A3(WI, Qmn, spn(function(n) {
            return A2(uc, "", A2(lpn, n, 21));
        }(n)), A3(WI, Qmn, fpn(function(n) {
            return A2(uc, "", A2(bpn, n, 5));
        }(n)), A3(WI, Qmn, cpn(function(n) {
            return A2(dpn, A2(uc, "", A2(lpn, n, 12)), A2(uc, "", A2(lpn, n, 11)));
        }(n)), A3(WI, Qmn, ipn(""), A3(WI, Qmn, apn(n.sS), r))))));
    }), mpn = function(n) {
        return n.l0.mF;
    }, ppn = function(n) {
        return n.l0.mO;
    }, $pn = function(n) {
        return n.l0.nr;
    }, hpn = function(n) {
        return n.l0.yz;
    }, gpn = function(n) {
        return n.l0.rE;
    }, wpn = function(n) {
        return n.l0.z9;
    }, kpn = function(n) {
        return n.l0.rF;
    }, xpn = function(n) {
        return n.l0.Aa;
    }, ypn = function(n) {
        return n.l0.rT;
    }, _pn = function(n) {
        return n.l0.rU;
    }, Cpn = function(n) {
        return n.l0.sS;
    }, Dpn = function(n) {
        return n.l0.Cp;
    }, Apn = function(n) {
        return n.l0.wi;
    }, qpn = function(n) {
        return n.l0.C5;
    }, Bpn = function(n) {
        return n.l0.C6;
    }, jpn = function(n) {
        return n.l0.xy;
    }, Spn = function(n) {
        return n.l0.xz;
    }, zpn = function(n) {
        return n.l0.DT;
    }, Upn = F2(function(n, r) {
        return n && tI(r.xJ) ? k([
            b(0, JN(A2(XN, YN, Cpn)))
        ]) : h;
    }), Epn = F2(function(n, r) {
        return n && tI(r.nr) ? k([
            b(1, JN(A2(XN, YN, $pn)))
        ]) : h;
    }), Ppn = F2(function(n, r) {
        return n && tI(r.yz) ? k([
            b(4, JN(A2(XN, YN, hpn)))
        ]) : h;
    }), Tpn = function(n) {
        return 2 === au(n) ? am(n) : qm("State abbreviation is invalid.");
    }, Fpn = A2(um, A2(um, am(!0), A2(nm, Tpn, Um(_m($e)))), Nm), Lpn = F2(function(n, r) {
        var t = r.wi;
        return tI(t) ? n ? k([
            b(2, JN(A2(XN, YN, Apn)))
        ]) : h : function(n) {
            return !A2(Ym, Fpn, n).$;
        }(t) ? h : k([
            b(2, aI(qpn)),
            b(2, aI(Bpn))
        ]);
    }), Mpn = F2(function(n, r) {
        return i(au(r), n) ? am(r) : qm("ZIP code is invalid.");
    }), Hpn = function(n) {
        return A2(nm, Mpn(n), Um(_m(he)));
    }, Rpn = A2(um, A2(um, A2(um, A2(um, am(!0), Hpn(5)), GA("-")), Hpn(4)), Nm), Opn = A2(um, A2(um, am(!0), Hpn(5)), Nm), Npn = function(n) {
        return !A2(Ym, Opn, n).$ || !A2(Ym, Rpn, n).$;
    }, Ipn = F2(function(n, r) {
        return ED(r) || A2(lA, A2(su, 5, n), r);
    }), Vpn = F2(function(n, r) {
        return !fu(n) && Npn(n) && !A2(Ipn, n, r);
    }), Wpn = F3(function(n, r, t) {
        var e = t.xy;
        return tI(e) ? r ? k([
            b(3, JN(A2(XN, YN, jpn)))
        ]) : h : Npn(e) ? n.$ && A2(Vpn, e, n.a) ? k([
            b(3, aI(Spn))
        ]) : h : k([
            b(3, aI(zpn))
        ]);
    }), Zpn = F2(function(n, r) {
        return ZN(k([
            Upn(n),
            Epn(n),
            Lpn(n),
            A2(Wpn, r, n),
            Ppn(n)
        ]));
    }), Xpn = function(n) {
        var r = A2(wI, A2(Zpn, n.vd, n.cs), n.kk);
        return r.$ ? b(r.a, !1) : b(r.a.a, !0);
    }, Gpn = function(n) {
        switch(n.$){
            case 0:
                return Ht(0);
            case 1:
                return Rt;
            case 2:
                return Ht(1);
            case 3:
                return Ht(2);
            case 4:
                return Ht(3);
            default:
                return Ht(4);
        }
    }, Jpn = F2(function(n, r) {
        var t = Gpn(n);
        if (t.$) return r;
        var e = t.a, u = A3(XI, !0, e, r.x), a = m(r, {
            x: u
        });
        return A2(ZI, e, u) ? m(a, {
            kk: Xpn(r).a
        }) : a;
    }), Ypn = F2(function(n, r) {
        var t = n ? AI(r.x) : r.x;
        return m(r, {
            kk: Xpn(r).a,
            x: t
        });
    }), Qpn = F2(function(n, r) {
        var t = Gpn(n);
        if (t.$) return r;
        var e = t.a;
        if (A2(yI, e, r.x)) {
            var u = A3(_I, !0, e, r.x);
            return m(r, {
                kk: Xpn(r).a,
                x: u
            });
        }
        return r;
    }), Kpn = F2(function(n, r) {
        switch(n.$){
            case 0:
                var t = A2(Jpn, p = n.a, m(r, {
                    kk: A3(WI, Qmn, p, r.kk)
                })), e = Ht(Umn(Ymn(p))), u = function() {
                    switch(p.$){
                        case 0:
                            var n = p.a, r = tI(n) ? b(!1, h) : b(!0, t.bA), e = r.a, u = r.b, a = A3(mQ, Fmn, n, t.cf), i = a.b;
                            return b(m(t, {
                                cf: a.a,
                                b8: e,
                                bA: u
                            }), i);
                        case 4:
                            return b(A2(Qpn, p, t), Dp);
                        default:
                            return b(t, Dp);
                    }
                }();
                return v(o = u.a, k = u.b, e);
            case 2:
                return v(Kmn(r), Dp, Rt);
            case 4:
                var a = n.a.l0;
                if (i(n.a.qU, r.qU)) {
                    if ((f = A2(Hp, Jmn, a)).$) return v(r, Dp, Rt);
                    var c = f.a, o = A2(Ypn, !0, m(r, {
                        kk: A2(vpn, c, r.kk)
                    }));
                    return v(m(o, {
                        iF: Ht(c)
                    }), Dp, Rt);
                }
                return v(r, Dp, Rt);
            case 3:
                var f, s = n.a.bA;
                return i(n.a.qU, r.qU) ? v(m(r, (f = A2(By, Hmn, s)).$ ? {
                    bA: h
                } : {
                    bA: f.a
                }), Dp, Rt) : v(r, Dp, Rt);
            case 1:
                var l = n.a;
                return v(o = function() {
                    switch(l){
                        case 27:
                        case 38:
                        case 13:
                            return Emn(r);
                        case 40:
                            return Kmn(r);
                        default:
                            return r;
                    }
                }(), Dp, Rt);
            case 5:
                var d = A2(upn, r, n.a);
                return v(o = d.a, k = d.b, Ht(Umn("Address")));
            case 8:
                var p = n.a, $ = (o = Emn(r), Ht(function(n) {
                    return {
                        $: 2,
                        a: n
                    };
                }(Ymn(p))));
                return v(4 === p.$ ? A2(Qpn, p, o) : o, Dp, $);
            case 9:
                return v(r, Dp, Ht(function(n) {
                    return {
                        $: 1,
                        a: n
                    };
                }(Ymn(p = n.a))));
            case 6:
                var g = n.a, w = A4(t1, Fmn, KK(Tmn), g, r.cf), k = w.b;
                return v(m(r, {
                    cf: w.a
                }), k, Rt);
            default:
                return v(r, npn(A2(zmn, n.a, r.qU)), Rt);
        }
    }), n$n = function(n) {
        return {
            $: 1,
            a: n
        };
    }, r$n = function(n) {
        return {
            $: 2,
            a: n
        };
    }, t$n = function(n) {
        return {
            $: 0,
            a: n
        };
    }, e$n = function(n) {
        return {
            $: 1,
            a: n
        };
    }, u$n = function(n) {
        switch(n.$){
            case 0:
                return "Existing Coverage";
            case 1:
                return "Carrier";
            case 2:
                return "Carrier Alias Other";
            case 3:
                return "Group ID";
            case 4:
                return "Member ID";
            default:
                return "High Deductible";
        }
    }, a$n = function(n) {
        return n.aw.m8;
    }, i$n = function(n) {
        return n.aw.yd;
    }, c$n = function(n) {
        return n.aw.na;
    }, o$n = function(n) {
        return n.aw.ye;
    }, f$n = function(n) {
        return n.aw.Y;
    }, s$n = function(n) {
        return n.aw.za;
    }, l$n = function(n) {
        return n.aw.qA;
    }, d$n = function(n) {
        return n.aw.qO;
    }, b$n = function(n) {
        return n.aw.zD;
    }, v$n = function(n) {
        return n.aw.r5;
    }, m$n = function(n) {
        return n.aw.Cw;
    }, p$n = function(n) {
        return A2(Xb, function(n) {
            return n.$ ? Rt : Ht(mbn(n.a));
        }, n);
    }, $$n = function(n) {
        return n.nB;
    }, h$n = function(n) {
        return n.nG;
    }, g$n = ZN(k([
        function(n) {
            var r = n.hW;
            return n.Y && $H(n.ah) && !r ? k([
                b(0, PI(a$n))
            ]) : h;
        },
        function(n) {
            var r = n.bT, t = n.Y, e = p$n(n.ah);
            if (e.$) return t && fu(r) ? k([
                b(2, PI(l$n))
            ]) : h;
            var u = e.a;
            return t && fu(r) && $$n(u) ? k([
                b(2, PI(l$n))
            ]) : h;
        },
        function(n) {
            var r = n.bX, t = n.Y, e = p$n(n.ah);
            if (e.$) return t && fu(r) ? k([
                b(3, PI(v$n))
            ]) : h;
            var u = e.a;
            return t && fu(r) && h$n(u) ? k([
                b(3, PI(v$n))
            ]) : h;
        },
        function(n) {
            var r = n.bH, t = n.Y;
            return p$n(n.ah).$ && t && fu(r) ? k([
                b(1, PI(c$n))
            ]) : h;
        }
    ])), w$n = function(n) {
        var r = A2(wI, g$n, n);
        return r.$ ? b(r.a, !1) : b(r.a.a, !0);
    }, k$n = F2(function(n, r) {
        var t = n ? AI(r.x) : r.x, e = w$n(r.kk), u = e.b;
        return b(m(r, {
            kk: e.a,
            x: t
        }), u);
    }), x$n = function(n) {
        switch(n.$){
            case 0:
            default:
                return Rt;
            case 1:
                return Ht(0);
            case 2:
                return Ht(1);
            case 3:
                return Ht(2);
            case 4:
                return Ht(3);
        }
    }, y$n = F2(function(n, r) {
        var t = x$n(n);
        if (t.$) return r;
        var e = t.a;
        return A2(yI, e, r.x) ? m(A2(k$n, !1, r).a, {
            x: A3(_I, !0, e, r.x)
        }) : r;
    }), _$n = function(n) {
        return function(n) {
            return A2(lA, OB(n), k([
                "true",
                "t"
            ]));
        }(n) ? Ht(!0) : function(n) {
            return A2(lA, OB(n), k([
                "false",
                "f"
            ]));
        }(n) ? Ht(!1) : Rt;
    }, C$n = {
        Da: ZK(300),
        Dz: function(n) {
            return {
                $: 8,
                a: n
            };
        }
    }, D$n = function(n) {
        if (fu(n.Di)) return v(n, Dp, Rt);
        var r = A3(mQ, C$n, "", n.g6), t = r.b;
        return v(m(n, {
            g6: r.a,
            aN: !1,
            Di: ""
        }), t, Rt);
    }, A$n = function(n) {
        return {
            $: 9,
            a: n
        };
    }, q$n = function(n) {
        return A2(Eu, A$n, gu(n));
    }, B$n = F2(function(n, r) {
        return {
            $: 3,
            a: n,
            b: r
        };
    }), j$n = function(n) {
        return A2(dc, B$n(n), lq(n));
    }, S$n = F2(function(n, r) {
        var t = D$n(r), e = t.b;
        return v(m(t.a, {
            Di: A2(uc, "", A2(Cp, r.dj(Rk(0)), n))
        }), Hu(k([
            e,
            j$n(r.qU + "-input")
        ])), Ht(function(n) {
            return {
                $: 0,
                a: n
            };
        }(n)));
    }), z$n = F2(function(n, r) {
        switch(n.$){
            case 3:
                return v(r, 1 === (w = b(n.b, i(n.a, r.qU + "-item-active"))).a.$ && w.b ? j$n(r.qU + "-item") : Dp, Rt);
            case 0:
                return v(m(r, {
                    aN: !r.aN
                }), Dp, Rt);
            case 1:
            case 5:
                return D$n(r);
            case 2:
                switch(t = n.a){
                    case 27:
                    case 38:
                        return D$n(r);
                    case 40:
                        return v(function(n) {
                            return m(n, {
                                aN: !0
                            });
                        }(r), j$n(r.qU + "-item-active"), Rt);
                    default:
                        return v(r, Dp, Rt);
                }
            case 6:
                var t, e = n.a;
                switch(t = n.b){
                    case 27:
                        var u = D$n(r), a = u.c;
                        return v(u.a, Hu(k([
                            u.b,
                            j$n(r.qU + "-input")
                        ])), a);
                    case 13:
                        return A2(S$n, e, r);
                    default:
                        var c = P_(t);
                        return ge(c) ? v(m(r, {
                            Di: Fb((h = c, h.toLowerCase()))
                        }), j$n(r.qU + "-input"), Rt) : v(r, Dp, Rt);
                }
            case 4:
                return A2(S$n, e = n.a, r);
            case 7:
                var o = n.b, f = (g = b(n.a, r.aN)).a.$ || g.b ? o : s(au(g.a.a), au(o)) > 0 ? "" : A2(nv, 1, o), l = A3(mQ, C$n, f, r.g6), d = l.b;
                return v(m(r, {
                    g6: l.a,
                    aN: !0,
                    Di: f
                }), d, Rt);
            case 8:
                var p = n.a, $ = A4(t1, C$n, KK(q$n), p, r.g6);
                return d = $.b, v(m(r, {
                    g6: $.a
                }), d, Rt);
            default:
                return v(r, Dp, Ht(function(n) {
                    return {
                        $: 1,
                        a: n
                    };
                }(o = n.a)));
        }
        var h, g, w;
    }), U$n = F2(function(n, r) {
        switch(n.$){
            case 0:
                var t = _$n(n.a);
                if (t.$) return v(r, Dp, h);
                var e = Mvn(t.a);
                return v(m(r, {
                    kk: A3(WI, Hvn, e, r.kk)
                }), Dp, k([
                    t$n(u$n(e))
                ]));
            case 1:
                var u = A2(z$n, n.a, r.ej), a = u.a, i = u.b, c = u.c, o = function() {
                    if (c.$) return v(r, Dp, h);
                    if (c.a.$) {
                        var n = c.a.a;
                        return v(m(r, {
                            ft: !0
                        }), A2(xbn, r.gx, Ht(n)), h);
                    }
                    var t = function(n) {
                        return {
                            $: 1,
                            a: n
                        };
                    }(c.a.a);
                    return v(A2(k$n, !1, m(r, {
                        kk: A3(WI, Hvn, t, r.kk)
                    })).a, Dp, k([
                        t$n(u$n(t))
                    ]));
                }(), f = o.b, s = o.c;
                return v(m(o.a, {
                    ej: a
                }), Hu(k([
                    A2(jp, n$n, i),
                    f
                ])), s);
            case 2:
                return v(m(r, {
                    ek: n.a,
                    ft: !1
                }), Dp, h);
            case 3:
                var l = A3(WI, Hvn, w = n.a, r.kk), d = (c = t$n(u$n(w)), x$n(w));
                if (d.$) return v(m(r, {
                    kk: l
                }), Dp, k([
                    c
                ]));
                var b = d.a, p = A3(XI, !0, b, r.x), $ = A2(ZI, b, p) ? w$n(l).a : l;
                return v(m(r, {
                    kk: $,
                    x: p
                }), Dp, k([
                    c
                ]));
            case 4:
                var g = _$n(n.a);
                return g.$ ? v(r, Dp, h) : (e = function(n) {
                    return {
                        $: 5,
                        a: n
                    };
                }(g.a), v(m(r, {
                    kk: A3(WI, Hvn, e, r.kk)
                }), Dp, k([
                    t$n(u$n(e))
                ])));
            case 6:
                return v(A2(y$n, w = n.a, r), Dp, k([
                    r$n(u$n(w))
                ]));
            default:
                var w;
                return v(r, Dp, k([
                    e$n(u$n(w = n.a))
                ]));
        }
    }), E$n = function(n) {
        return {
            $: 3,
            a: n
        };
    }, P$n = function(n) {
        return {
            $: 4,
            a: n
        };
    }, T$n = F2(function(n, r) {
        return {
            $: 3,
            a: n,
            b: r
        };
    }), F$n = F2(function(n, r) {
        return {
            $: 4,
            a: n,
            b: r
        };
    }), L$n = function(n) {
        return n.qU;
    }, M$n = F3(function(n, r, t) {
        return {
            $: 0,
            a: n,
            b: r,
            c: t
        };
    }), H$n = F4(function(n, r, t, e) {
        var u = A2(VI, e, t), a = u.a, i = u.b;
        return b(m(n, {
            t2: A3(Q9, a, r, n.t2),
            M: A3(XI, !0, t, n.M)
        }), A2(jp, A2(M$n, r, a), i));
    }), R$n = F2(function(n, r) {
        switch(n.$){
            case 0:
                var t = n.a, e = n.c, u = L$n(f = n.b), a = function() {
                    switch(e.$){
                        case 0:
                            return b(A4(H$n, r, t, f, e), function(n) {
                                return {
                                    $: 0,
                                    a: n
                                };
                            }(u));
                        case 1:
                            return b(A4(H$n, r, t, f, e), function(n) {
                                return {
                                    $: 1,
                                    a: n
                                };
                            }(u));
                        case 2:
                            return b(A4(H$n, r, t, f, e), function(n) {
                                return {
                                    $: 2,
                                    a: n
                                };
                            }(u));
                        case 3:
                            return b(b(r, A2(Eu, ru, gu(A2(T$n, t, f)))), E$n(u));
                        default:
                            return b(b(r, A2(Eu, ru, gu(A2(F$n, t, f)))), P$n(u));
                    }
                }(), i = a.a;
                return v(i.a, i.b, Ht(o = a.b));
            case 1:
                var c = function(n) {
                    return A2(Gvn, Rt, n);
                }(r);
                return v(c.b, Dp, Ht(function(n) {
                    return {
                        $: 5,
                        a: n
                    };
                }(c.a)));
            case 2:
                return t = n.a, u = L$n(f = n.b), v(A3(tmn, r, t, f), Dp, Ht(function(n) {
                    return {
                        $: 6,
                        a: n
                    };
                }(u)));
            case 3:
                var o = Ht(E$n(L$n(f = n.b)));
                return v(A2(yI, f, r.M) ? m(r, {
                    M: A3(_I, !0, f, r.M)
                }) : r, Dp, o);
            default:
                var f;
                return v(r, Dp, Ht(P$n(L$n(f = n.b))));
        }
    }), O$n = F2(function(n, r) {
        return A2(Cp, function(n) {
            return b(lbn(r), n);
        }, Gb(A2(iW, r, n.kk)));
    }), N$n = function(n) {
        return A2(Ep, function(r) {
            return A2(O$n, n, r);
        }, sbn);
    }, I$n = function(n) {
        return A2(yu, function(n) {
            return b(2, n.b);
        }, N$n(n.l0));
    }, V$n = F2(function(n, r) {
        var t = r.pt;
        return tI(t) && n ? k([
            b(0, JN(A2(XN, YN, KN)))
        ]) : tI(t) || uI(t) ? h : k([
            b(0, aI(A2(XN, YN, KN)))
        ]);
    }), W$n = F2(function(n, r) {
        return !A2(sA, A2(sc, bm, n), r);
    }), Z$n = F2(function(n, r) {
        var t = Qvn(n);
        return !t.$ && i(t.a, r);
    }), X$n = F2(function(n, r) {
        return tI(r.BT) && n.vd && A2(Z$n, n.t2, r) ? k([
            PI($O)
        ]) : A2(pI, r.BT, r.CD) ? k([
            TI($O)
        ]) : h;
    }), G$n = F2(function(n, r) {
        return oe(A2(X$n, n, r)) > 0;
    }), J$n = F2(function(n, r) {
        return !A2(G$n, n, r.b);
    }), Y$n = F2(function(n, r) {
        return A2(W3, r.a, A2(Tc, n, r.b));
    }), Q$n = F2(function(n, r) {
        return !Y6(A2(Y$n, function(r) {
            return i(r.b.dL, n);
        }, r));
    }), K$n = F2(function(n, r) {
        return r.q4(n);
    }), nhn = function(n) {
        return A2(XN, K$n, kO(n));
    }, rhn = F2(function(n, r) {
        if (n.$) return h;
        var t = n.a;
        return A2(Q$n, t, r) ? h : k([
            JN(nhn(t))
        ]);
    }), thn = function(n) {
        return A2(Y$n, J$n(n), A2(Y$n, function(n) {
            return !tI(SI(n.b));
        }, n.t2));
    }, ehn = function(n) {
        return n.vd || YS(n.dG) ? Y6(n.t2) ? k([
            PI($O)
        ]) : A2(rhn, n.dG, thn(n)) : h;
    }, uhn = function(n) {
        var r = A2(Ot, function(n) {
            return ED(ehn(n));
        }(n), A2($4, J$n(n), n.t2));
        return A2(W$n, ru, r);
    }, ahn = function(n) {
        return uhn(n.t2) ? h : k([
            b(1, JN(A2(XN, YN, KN)))
        ]);
    }, ihn = function(n) {
        return n.b.vi;
    }, chn = F2(function(n, r) {
        var t = jN(r);
        return A3(WI, pmn, $vn(A2(Ypn, n, t.l0)), r);
    }), ohn = F2(function(n, r) {
        return m(r, {
            M: n ? AI(r.M) : r.M
        });
    }), fhn = F2(function(n, r) {
        var t = jN(r);
        return A3(WI, pmn, wvn(A2(ohn, n, t.t2)), r);
    }), shn = F2(function(n, r) {
        var t = A2(chn, n, A2(fhn, n, r.kk)), e = jN(t), u = A2(k$n, n, e.a_), a = u.b, i = A3(WI, pmn, gvn(u.a), t), c = A2(wI, function(n) {
            var r = ihn(n.dw);
            return ZN(k([
                V$n(r),
                I$n,
                ahn
            ]));
        }(r), i);
        return c.$ ? b(c.a, !1) : b(c.a.a, a);
    }), lhn = F2(function(n, r) {
        var t = function(n) {
            switch(n.$){
                case 1:
                    return Ht(0);
                case 2:
                    return Ht(1);
                case 0:
                    return Ht(2);
                default:
                    return Rt;
            }
        }(n);
        if (t.$) return r;
        var e = t.a, u = A3(XI, !0, e, r.x), a = m(r, {
            x: u
        });
        return A2(ZI, e, u) ? m(a, {
            kk: A2(shn, !1, r).a
        }) : a;
    }), dhn = F2(function(n, r) {
        return A2(lhn, n, m(r, {
            kk: A3(WI, pmn, n, r.kk)
        }));
    }), bhn = F2(function(n, r) {
        var t = n ? AI(r.x) : r.x, e = A2(shn, n, r), u = e.b;
        return b(m(r, {
            kk: e.a,
            x: t
        }), u);
    }), vhn = F2(function(n, r) {
        switch(n.$){
            case 17:
                var t = n.a;
                if (3 === t.$) {
                    var e = t.a, u = $k(r.dw);
                    return v(d = m(r, {
                        fF: Ht(e)
                    }), A4(sln, r.gx, u, r.BK, hvn), h);
                }
                return v(r, Dp, A2(uA, 0, t));
            case 16:
                var a = n.a, i = b(a, r.fF);
                if (3 !== i.a.$ || i.b.$) return v(r, Dp, A2(uA, 0, a));
                var c = i.a.a, o = (e = i.b.a, jN(r.kk));
                return v(d = m(r, {
                    kk: AO(A4(mmn, c, r.dw, e, o)),
                    tE: Ht(c)
                }), Dp, h);
            case 15:
                return v(A2(dhn, n.a, r), Dp, h);
            case 12:
                var f = A2(bhn, !0, r);
                return v(d = f.a, f.b ? Smn(d) : Dp, h);
            case 13:
                return v(r, A2(zx, oa, Da), h);
            case 14:
                var s = n.a;
                return 3 === s.$ ? v(m(r, {
                    tE: Ht(c = s.a)
                }), A2(zx, oa, Da), h) : v(r, Dp, A2(uA, 0, s));
            case 11:
                var l = n.a;
                if (A2(yI, l, r.x)) {
                    var d, p = A3(_I, !0, l, r.x);
                    return v(m(d = A2(bhn, !1, r).a, {
                        x: p
                    }), Dp, h);
                }
                return v(r, Dp, h);
            case 6:
                var $ = n.a, g = jN(r.kk), w = A2(R$n, $, g.t2), k = w.b;
                return v(m(r, {
                    kk: A3(WI, pmn, wvn(w.a), r.kk)
                }), A2(jp, kvn, k), h);
            case 0:
                var x = n.a, y = jN(r.kk), _ = A2(Kpn, x, y.l0), C = _.b;
                return v(m(r, {
                    kk: A3(WI, pmn, $vn(_.a), r.kk)
                }), A2(jp, bvn, C), h);
            case 5:
                x = n.a;
                var D = jN(r.kk), A = A2(U$n, x, D.a_), q = A.b;
                return v(m(r, {
                    kk: A3(WI, pmn, gvn(A.a), r.kk)
                }), A2(jp, abn, q), h);
            default:
                return v(r, Dp, h);
        }
    }), mhn = {
        $: 12
    }, phn = {
        $: 13
    }, $hn = function(n) {
        return n.Ct;
    }, hhn = F2(function(n, r) {
        var t = Jx(xln(r));
        return A2(Ik, h, k([
            A2(Gk, k([
                Nk("text-support")
            ]), k([
                A2(fF, k([
                    Nk("link text-current"),
                    vF(Sx(Da))
                ]), k([
                    ad(n(Id.wD))
                ]))
            ])),
            A2(Gk, k([
                Nk("mx-3 text-support")
            ]), k([
                ad("/")
            ])),
            A2(Gk, k([
                Nk("text-support")
            ]), k([
                A2(fF, k([
                    Nk("link text-current"),
                    vF(Sx(Aa({
                        qU: Aln(r)
                    })))
                ]), k([
                    t
                ]))
            ])),
            A2(Gk, k([
                Nk("mx-3 text-support")
            ]), k([
                ad("/")
            ])),
            ad(n(Id.qZ))
        ]));
    }), ghn = ru, whn = function(n) {
        return !n;
    }, khn = {
        $: 2
    }, xhn = function(n) {
        return {
            $: 1,
            a: n
        };
    }, yhn = function(n) {
        return {
            $: 8,
            a: n
        };
    }, _hn = function(n) {
        return {
            $: 0,
            a: n
        };
    }, Chn = function(n) {
        return {
            $: 9,
            a: n
        };
    }, Dhn = function(n) {
        return {
            $: 19,
            a: n
        };
    }, Ahn = function(n) {
        return {
            $: 0,
            a: n
        };
    }, qhn = F3(function(n, r, t) {
        return A2(ZI, t, r) ? A2(iW, t, n) : h;
    }), Bhn = function(n) {
        return function(n) {
            return {
                $: 12,
                a: n
            };
        }(n);
    }, jhn = function(n) {
        return function(n) {
            return {
                $: 13,
                a: n
            };
        }(n);
    }, Shn = {
        yR: !1
    }, zhn = F2(function(n, r) {
        return m(r, {
            yR: n
        });
    }), Uhn = F3(function(n, r, t) {
        return A2(ZI, t, r) && A2(kW, t, n);
    }), Ehn = F2(function(n, r) {
        switch(r){
            case 0:
                return n + "-address";
            case 1:
                return n + "-city";
            case 2:
                return n + "-state";
            case 3:
                return n + "-zip";
            default:
                return n + "-country";
        }
    }), Phn = function(n) {
        return {
            $: 0,
            a: n
        };
    }, Thn = F3(function(n, r, t) {
        return t + ", please contact " + n + (r.$ ? "." : " or " + r.a + ".");
    }), Fhn = A2(TS, PS(2), Rt), Lhn = function(n) {
        return n ? 4 : 7;
    }, Mhn = {
        ef: 0,
        AT: Rt
    }, Hhn = F2(function(n, r) {
        return m(r, n.$ ? {
            AT: Ht(n.a)
        } : {
            ef: n.a
        });
    }), Rhn = function(n) {
        return "[" + n + "](mailto:" + n + ")";
    }, Ohn = F2(function(n, r) {
        for(;;){
            var t = Gb(n);
            if (t.$) return r;
            var e = t.a, u = A3(Gy, e, Rhn(e), r), a = fB(n);
            if (a.$) return u;
            n = a.a, r = u;
        }
    }), Nhn = function(n) {
        if (n.$) return Sq;
        var r = n.a;
        return A2(fz, k([
            pz,
            vz(k([
                Nk("flex message-box__close")
            ])),
            QS(r)
        ]), k([
            A2(US, k([
                mz
            ]), 2)
        ]));
    }, Ihn = F3(function(n, r, t) {
        var e, u = A2(uc, k([
            Sq
        ]), A2(Cp, function(n) {
            var r, t;
            return HW((t = A2(Tc, uI, f3(r = n)), A2(Ohn, A4(KL, ru, GL, t, h), r)));
        }, r)), a = A3(ce, Hhn, Mhn, n);
        return A2(lz, k([
            Qk(k([
                Nk("message-box w-full flex mb-4 " + (e = a.ef, e ? "message-box--info" : "message-box--error"))
            ]))
        ]), k([
            A2(lz, k([
                Qk(k([
                    Nk("flex")
                ]))
            ]), k([
                A2(US, k([
                    mz,
                    LV(Fhn),
                    LV(Tan)
                ]), Lhn(a.ef))
            ])),
            A2(lz, k([
                Qk(k([
                    Nk("flex flex-shrink flex-col")
                ]))
            ]), k([
                A2(hx, k([
                    Qk(k([
                        Nk("message-box__title")
                    ]))
                ]), u),
                A2(lz, k([
                    Qk(k([
                        Nk("message-box__content")
                    ])),
                    BB
                ]), k([
                    t
                ]))
            ])),
            Nhn(a.AT)
        ]));
    }), Vhn = F3(function(n, r, t) {
        if (t.$) {
            var e = t.b, u = t.c;
            if (A2(Vpn, r, t.a)) {
                var a = n(Spn), i = k([
                    Phn(0)
                ]), c = A3(Thn, e, u, "We're sorry but we do not have coverage in your area yet. To get more information");
                return A2(lz, k([
                    LS(Htn)
                ]), k([
                    A3(Ihn, i, Ht(a), A2(lz, h, k([
                        ad(c)
                    ])))
                ]));
            }
            return Sq;
        }
        return Sq;
    }), Whn = function(n) {
        return {
            $: 5,
            a: n
        };
    }, Zhn = function(n) {
        return b(tpn(n), A2(iU, $(Xx, k([
            Nk("select__item"),
            A2(Wx, "role", "option"),
            dU(Whn(Ht(n)))
        ])), k([
            A2(US, k([
                Sz,
                Vq("fill-gray")
            ]), 10),
            ad(n.oV)
        ])));
    }, Xhn = F2(function(n, r) {
        return A2(IZ, n && !ED(r), A3($U, "div", k([
            Nk("select__items")
        ]), A2(yu, Zhn, r)));
    }), Ghn = F3(function(n, r, t) {
        var e = A3(ce, zhn, Shn, r), u = jN(t.kk), a = u.xJ, i = u.xK, c = u.nr, o = u.wi, f = u.xy, s = u.yz;
        return A2(lz, k([
            Qk(k([
                Nk("address-input"),
                jz(t.qU)
            ]))
        ]), k([
            A2(lV, k([
                jV(k([
                    Nk("-mx-1")
                ]))
            ]), k([
                A2(iV, k([
                    UZ(12)
                ]), k([
                    A2(AW, k([
                        bW(n(gpn)),
                        hW(t.vd),
                        Ahn(n(wpn))
                    ]), k([
                        A2(lz, k([
                            Qk(k([
                                Nk("select")
                            ]))
                        ]), k([
                            yP(k([
                                kZ(A2(Ehn, t.qU, 0)),
                                bP(a),
                                Dhn(!1),
                                xZ(A2(sc, _hn, apn)),
                                Bhn(khn),
                                oZ(A3(Uhn, t.kk, t.x, 0)),
                                sP(e.yR),
                                lZ(yhn(apn(a))),
                                dZ(Chn(apn(a))),
                                jhn(xhn),
                                $Z(!0)
                            ])),
                            A2(Xhn, t.b8, t.bA)
                        ])),
                        A2(OW, n, A3(qhn, t.kk, t.x, 0))
                    ]))
                ]))
            ])),
            A2(lV, k([
                jV(k([
                    Nk("-mx-1")
                ]))
            ]), k([
                A2(iV, k([
                    UZ(12)
                ]), k([
                    A2(AW, k([
                        bW(n(kpn)),
                        Ahn(n(xpn))
                    ]), k([
                        yP(k([
                            bP(i),
                            xZ(A2(sc, _hn, ipn)),
                            sP(e.yR),
                            $Z(!0),
                            lZ(yhn(ipn(i))),
                            dZ(Chn(ipn(i)))
                        ]))
                    ]))
                ]))
            ])),
            A2(lV, k([
                jV(k([
                    Nk("-mx-1")
                ])),
                dV(NZ)
            ]), k([
                A2(iV, k([
                    UZ(4),
                    jV(k([
                        Nk("flex")
                    ]))
                ]), k([
                    A2(AW, k([
                        bW(n($pn)),
                        hW(t.vd)
                    ]), h)
                ])),
                A2(iV, k([
                    UZ(4),
                    jV(k([
                        Nk("flex")
                    ]))
                ]), k([
                    A2(AW, k([
                        bW(n(Apn)),
                        hW(t.vd)
                    ]), h)
                ])),
                A2(iV, k([
                    UZ(4),
                    jV(k([
                        Nk("flex")
                    ]))
                ]), k([
                    A2(AW, k([
                        bW(n(jpn)),
                        hW(t.vd)
                    ]), h)
                ]))
            ])),
            A2(lV, k([
                jV(k([
                    Nk("-mx-1")
                ]))
            ]), k([
                A2(iV, k([
                    UZ(4)
                ]), k([
                    yP(k([
                        kZ(A2(Ehn, t.qU, 1)),
                        bP(c),
                        xZ(A2(sc, _hn, cpn)),
                        oZ(A3(Uhn, t.kk, t.x, 1)),
                        sP(e.yR),
                        $Z(!0),
                        lZ(yhn(cpn(c))),
                        dZ(Chn(cpn(c)))
                    ]))
                ])),
                A2(iV, k([
                    UZ(4)
                ]), k([
                    yP(k([
                        kZ(A2(Ehn, t.qU, 2)),
                        bP(o),
                        xZ(A2(sc, _hn, fpn)),
                        oZ(A3(Uhn, t.kk, t.x, 2)),
                        sP(e.yR),
                        $Z(!0),
                        lZ(yhn(fpn(o))),
                        dZ(Chn(fpn(o)))
                    ]))
                ])),
                A2(iV, k([
                    UZ(4)
                ]), k([
                    yP(k([
                        kZ(A2(Ehn, t.qU, 3)),
                        bP(f),
                        xZ(A2(sc, _hn, spn)),
                        oZ(A3(Uhn, t.kk, t.x, 3)),
                        sP(e.yR),
                        $Z(!0),
                        lZ(yhn(spn(f))),
                        dZ(Chn(spn(f)))
                    ]))
                ])),
                A2(iV, k([
                    UZ(4)
                ]), k([
                    A2(OW, n, A3(qhn, t.kk, t.x, 1))
                ])),
                A2(iV, k([
                    UZ(4)
                ]), k([
                    A2(OW, n, A3(qhn, t.kk, t.x, 2))
                ])),
                A2(iV, k([
                    UZ(4)
                ]), k([
                    A2(OW, n, A3(qhn, t.kk, t.x, 3))
                ]))
            ])),
            A2(lV, k([
                jV(k([
                    Nk("-mx-1")
                ])),
                dV(NZ)
            ]), k([
                A2(iV, k([
                    UZ(12)
                ]), k([
                    A2(AW, k([
                        bW(n(hpn)),
                        hW(t.vd)
                    ]), k([
                        yP(k([
                            kZ(A2(Ehn, t.qU, 4)),
                            bP(s),
                            xZ(A2(sc, _hn, opn)),
                            oZ(A3(Uhn, t.kk, t.x, 4)),
                            sP(e.yR),
                            $Z(!0),
                            lZ(yhn(opn(s))),
                            dZ(Chn(opn(s)))
                        ])),
                        A2(OW, n, A3(qhn, t.kk, t.x, 4)),
                        A3(Vhn, n, f, t.cs)
                    ]))
                ]))
            ]))
        ]));
    }), Jhn = F3(function(n, r, t) {
        var e = jN(t.kk).l0, u = t.fF;
        return u.$ || whn(xvn(u.a)) ? Sq : A2(Ik, k([
            Nk("mb-6")
        ]), k([
            A2(px, bvn, A3(Ghn, n, k([
                ghn(r)
            ]), e))
        ]));
    }), Yhn = function(n) {
        return {
            $: 1,
            a: n
        };
    }, Qhn = function(n) {
        return n.cl.qb;
    }, Khn = function(n) {
        return n.cl.zY;
    }, ngn = function(n) {
        return n.cl.rt;
    }, rgn = function(n) {
        return n.cl.sE;
    }, tgn = function(n) {
        return n.cl.wt;
    }, egn = function(n) {
        return n.cl.wD;
    }, ugn = ru, agn = Id.yR, ign = {
        $: 3
    }, cgn = F3(function(n, r, t) {
        return A2(ZI, t, r) ? A2(iW, t, n) : h;
    }), ogn = function(n) {
        return {
            $: 3,
            a: n
        };
    }, fgn = k([
        0,
        1,
        2,
        3,
        4,
        5
    ]), sgn = {
        yR: !1
    }, lgn = F2(function(n, r) {
        return m(r, {
            yR: n
        });
    }), dgn = F3(function(n, r, t) {
        return A2(ZI, t, r) && A2(kW, t, n);
    }), bgn = F3(function(n, r, t) {
        var e = A3(ce, lgn, sgn, r), u = jN(t.kk).wD;
        return A2(Ik, k([
            Nk("title-input"),
            jz(t.qU)
        ]), k([
            A2(Ik, k([
                Nk("select")
            ]), k([
                A2(px, ru, A4(AU, n, k([
                    Jz(u),
                    ZL(n(dI)),
                    Wz,
                    cX(e.yR),
                    ogn(A3(dgn, t.kk, t.x, 0))
                ]), A2(yu, function(n) {
                    return A2(Xz, h, n);
                }, fgn), t.fN))
            ])),
            A2(OW, n, A3(cgn, t.kk, t.x, 0))
        ]));
    }), vgn = F2(function(n, r) {
        return A2(Ik, k([
            Nk("tooltip")
        ]), k([
            A2(Gk, k([
                Nk("tooltip__text")
            ]), k([
                ad(n)
            ])),
            r
        ]));
    }), mgn = F3(function(n, r, t) {
        var e = jN(t.kk), u = e.aj, a = e.nq, i = e.nm, c = e.no, o = e.nn, f = e.np;
        return A2(Ik, h, k([
            A2(lV, k([
                dV(aV)
            ]), k([
                A2(iV, k([
                    UZ(12)
                ]), k([
                    A2(vgn, n(agn), A2(QW, k([
                        ZW(u),
                        VW(r)
                    ]), k([
                        ad(n(Khn))
                    ])))
                ]))
            ])),
            A2(IZ, u, A2(lV, h, k([
                A2(iV, k([
                    GZ(2),
                    jV(k([
                        Nk("mb-4 sm:mb-0")
                    ]))
                ]), k([
                    A2(AW, k([
                        bW(n(egn)),
                        ign
                    ]), k([
                        A2(vgn, n(agn), A2(px, Yhn, A3(bgn, n, k([
                            ugn(r)
                        ]), a)))
                    ]))
                ])),
                A2(iV, k([
                    UZ(3)
                ]), k([
                    A2(AW, k([
                        bW(n(Qhn)),
                        ign
                    ]), k([
                        A2(vgn, n(agn), yP(k([
                            bP(i),
                            sP(r),
                            $Z(!0)
                        ])))
                    ]))
                ])),
                A2(iV, k([
                    UZ(3),
                    GZ(2)
                ]), k([
                    A2(AW, k([
                        bW(n(rgn)),
                        ign
                    ]), k([
                        A2(vgn, n(agn), yP(k([
                            bP(c),
                            sP(r),
                            $Z(!0)
                        ])))
                    ]))
                ])),
                A2(iV, k([
                    UZ(3)
                ]), k([
                    A2(AW, k([
                        bW(n(ngn)),
                        ign
                    ]), k([
                        A2(vgn, n(agn), yP(k([
                            bP(o),
                            sP(r),
                            $Z(!0)
                        ])))
                    ]))
                ])),
                A2(iV, k([
                    UZ(3),
                    GZ(2)
                ]), k([
                    A2(AW, k([
                        bW(n(tgn)),
                        ign
                    ]), k([
                        A2(vgn, n(agn), yP(k([
                            bP(f),
                            sP(r),
                            $Z(!0)
                        ])))
                    ]))
                ]))
            ])))
        ]));
    }), pgn = function(n) {
        return {
            $: 2,
            a: n
        };
    }, $gn = F3(function(n, r, t) {
        var e = jN(t.kk).bg;
        return A2(Ik, h, k([
            A2(lV, h, k([
                A2(iV, k([
                    UZ(12)
                ]), k([
                    A2(AW, k([
                        bW(n(GN))
                    ]), k([
                        A2(vgn, n(agn), A2(px, pgn, A3(hZ, n, k([
                            rZ(r)
                        ]), e)))
                    ]))
                ]))
            ]))
        ]));
    }), hgn = function(n) {
        return {
            $: 1,
            a: n
        };
    }, ggn = function(n) {
        return {
            $: 11,
            a: n
        };
    }, wgn = function(n) {
        return {
            $: 15,
            a: n
        };
    }, kgn = F3(function(n, r, t) {
        return A2(ZI, t, r) ? A2(iW, t, n) : h;
    }), xgn = F3(function(n, r, t) {
        return A2(ZI, t, r) && A2(kW, t, n);
    }), ygn = F3(function(n, r, t) {
        var e = jN(t.kk).pt;
        return A2(lV, h, k([
            A2(iV, k([
                UZ(12)
            ]), k([
                A2(AW, k([
                    bW(n(KN)),
                    hW(ihn(t.dw))
                ]), k([
                    yP(k([
                        kZ("Email"),
                        bP(e),
                        xZ(A2(sc, wgn, hgn)),
                        oZ(A3(xgn, t.kk, t.x, 0)),
                        sP(r),
                        lZ(ggn(0)),
                        $Z(!0)
                    ])),
                    A2(OW, n, A3(kgn, t.kk, t.x, 0))
                ]))
            ]))
        ]));
    }), _gn = function(n) {
        return n.b.wQ;
    }, Cgn = function(n) {
        return {
            $: 4,
            a: n
        };
    }, Dgn = ru, Agn = k([
        0,
        1,
        2
    ]), qgn = {
        $: 2
    }, Bgn = {
        $: 3
    }, jgn = function(n) {
        return {
            $: 1,
            a: n
        };
    }, Sgn = function(n) {
        return {
            $: 0,
            a: n
        };
    }, zgn = F3(function(n, r, t) {
        return A2(ZI, t, r) ? A2(iW, t, n) : h;
    }), Ugn = F2(function(n, r) {
        return !r.$ && n(r.a);
    }), Egn = {
        yR: !1,
        BU: hfn
    }, Pgn = F2(function(n, r) {
        return m(r, {
            yR: n
        });
    }), Tgn = F3(function(n, r, t) {
        return A2(ZI, t, r) && A2(kW, t, n);
    }), Fgn = F4(function(n, r, t, e) {
        var u = A3(ce, Pgn, Egn, r), a = A2(yu, function(n) {
            return A2(Xz, h, n);
        }, t), i = jN(e.kk), c = i.fz, o = i.dt;
        return A2(Ik, k([
            Nk("gender-input"),
            jz(e.qU)
        ]), k([
            A2(Ik, k([
                Nk("select"),
                rz(k([
                    b("mb-4", A2(Ugn, e.z2, c))
                ]))
            ]), k([
                A2(px, Sgn, A4(AU, n, k([
                    Jz(c),
                    ZL(n(u.BU)),
                    Wz,
                    cX(u.yR),
                    ogn(A3(Tgn, e.kk, e.x, 0)),
                    Gz(!0)
                ]), a, e.fP)),
                A2(OW, n, A3(zgn, e.kk, e.x, 0))
            ])),
            A2(IZ, A2(Ugn, e.z2, c), A2(Ik, h, k([
                yP(k([
                    bP(o),
                    xZ(jgn),
                    oZ(A3(Tgn, e.kk, e.x, 1)),
                    sP(u.yR),
                    lZ(qgn),
                    dZ(Bgn),
                    $Z(!0)
                ])),
                A2(OW, n, A3(zgn, e.kk, e.x, 1))
            ])))
        ]));
    }), Lgn = F3(function(n, r, t) {
        var e = jN(t.kk).qv;
        return A2(lV, k([
            dV(NZ)
        ]), k([
            A2(iV, k([
                UZ(12)
            ]), k([
                A2(AW, k([
                    bW(n(cbn.rr))
                ]), k([
                    A2(px, Cgn, A4(Fgn, n, k([
                        Dgn(r)
                    ]), Agn, e))
                ]))
            ]))
        ]));
    }), Mgn = function(n) {
        return {
            $: 3,
            a: n
        };
    }, Hgn = function(n) {
        return {
            $: 7,
            a: n
        };
    }, Rgn = function(n) {
        return {
            $: 9,
            a: n
        };
    }, Ogn = ru, Ngn = k([
        1,
        0,
        2,
        3,
        4,
        5
    ]), Ign = k([
        1,
        0,
        2,
        3
    ]), Vgn = k([
        0,
        1,
        2
    ]), Wgn = {
        yR: !1
    }, Zgn = F2(function(n, r) {
        return m(r, {
            yR: n
        });
    }), Xgn = F3(function(n, r, t) {
        return A2(ZI, t, r) && A2(kW, t, n);
    }), Ggn = F3(function(n, r, t) {
        var e = A3(ce, Zgn, Wgn, r), u = jN(t.kk).vK;
        return A2(Ik, k([
            Nk("select")
        ]), k([
            A2(px, ru, A4(AU, n, k([
                Jz(u),
                ZL(n(hfn)),
                Wz,
                cX(e.yR),
                ogn(A3(Xgn, t.kk, t.x, 0)),
                Gz(!0)
            ]), A2(yu, function(n) {
                return A2(Xz, h, n);
            }, Vgn), t.fD))
        ]));
    }), Jgn = F3(function(n, r, t) {
        return A2(ZI, t, r) ? A2(iW, t, n) : h;
    }), Ygn = F2(function(n, r) {
        return A2(OW, n, A3(Jgn, r.kk, r.x, 0));
    }), Qgn = F3(function(n, r, t) {
        var e = jN(t.kk), u = e.vK, a = e.qw, i = e.uC;
        return A2(lV, k([
            dV(NZ)
        ]), k([
            A2(iV, k([
                UZ(4)
            ]), k([
                A2(AW, k([
                    bW(n(ddn.rr))
                ]), k([
                    A2(vgn, n(agn), A2(px, Rgn, A3(Ggn, n, k([
                        Ogn(r)
                    ]), u)))
                ])),
                A2(Ygn, n, u)
            ])),
            A2(iV, k([
                UZ(4)
            ]), k([
                A2(AW, k([
                    bW(n(odn.rr))
                ]), k([
                    A2(vgn, n(agn), A2(px, Mgn, A4(Fgn, n, k([
                        Dgn(r)
                    ]), Ngn, a)))
                ]))
            ])),
            A2(iV, k([
                UZ(4)
            ]), k([
                A2(AW, k([
                    bW(n(sdn.rr))
                ]), k([
                    A2(vgn, n(agn), A2(px, Hgn, A4(Fgn, n, k([
                        Dgn(r)
                    ]), Ign, i)))
                ]))
            ]))
        ]));
    }), Kgn = F3(function(n, r, t) {
        return A2(Ik, k([
            Nk("mb-6")
        ]), k([
            _gn(t.dw) ? A3(Qgn, n, r, t) : A3(Lgn, n, r, t)
        ]));
    }), nwn = function(n) {
        return {
            $: 0,
            a: n
        };
    }, rwn = function(n) {
        return PU(n);
    }, twn = function(n) {
        return function(n) {
            return {
                $: 0,
                a: n
            };
        }(n);
    }, ewn = function(n) {
        return n.sX;
    }, uwn = function(n) {
        return n ? "True" : "False";
    }, awn = function(n) {
        return {
            $: 3,
            a: n
        };
    }, iwn = function(n) {
        return {
            $: 4,
            a: n
        };
    }, cwn = function(n) {
        return {
            $: 1,
            a: n
        };
    }, own = function(n) {
        return {
            $: 1,
            a: n
        };
    }, fwn = A2(sc, NL, own), swn = F3(function(n, r, t) {
        return A2(ZI, t, r) && A2(kW, t, n);
    }), lwn = function(n) {
        return {
            $: 0,
            a: n
        };
    }, dwn = {
        $: 1
    }, bwn = F2(function(n, r) {
        return {
            $: 7,
            a: n,
            b: r
        };
    }), vwn = {
        $: 0
    }, mwn = function(n) {
        return {
            $: 2,
            a: n
        };
    }, pwn = {
        $: 5
    }, $wn = function(n) {
        return {
            $: 4,
            a: n
        };
    }, hwn = F2(function(n, r) {
        return {
            $: 6,
            a: n,
            b: r
        };
    }), gwn = A2(Gk, k([
        Nk("select__arrow")
    ]), h), wwn = function(n) {
        if (1 === n.$) {
            var r = n.a;
            return A2(PB, k([
                OL
            ]), k([
                ad(r)
            ]));
        }
        return A2(PB, h, k([
            ad(r = n.a)
        ]));
    }, kwn = function(n) {
        return {
            $: 0,
            a: n
        };
    }, xwn = F4(function(n, r, t, e) {
        if (r.b) {
            var u = r.a, a = r.b;
            return A2(Ot, kwn(A3(iu, n, u, e)), A2(Ot, function(n) {
                return {
                    $: 1,
                    a: n
                };
            }(A3(iu, u, u + t, e)), A4(xwn, u + t, a, t, e)));
        }
        return k([
            kwn(A3(iu, n, au(e), e))
        ]);
    }), ywn = F3(function(n, r, t) {
        return A2(Gk, h, A2(yu, wwn, A4(xwn, 0, r, au(n), t)));
    }), _wn = F2(function(n, r) {
        var t = A2(ou, OB(n), OB(r));
        return A3(ywn, n, t, r);
    }), Cwn = F3(function(n, r, t) {
        return A2(_wn, n, r(t));
    }), Dwn = {
        yR: !1,
        eF: !1,
        zU: !1,
        Ac: !1,
        BU: "Pick an item",
        w5: Rt
    }, Awn = F2(function(n, r) {
        switch(n.$){
            case 2:
                return m(r, {
                    yR: n.a
                });
            case 0:
                return m(r, {
                    w5: n.a
                });
            case 1:
                return m(r, {
                    BU: n.a
                });
            case 3:
                return m(r, {
                    zU: n.a
                });
            case 4:
                return m(r, {
                    Ac: n.a
                });
            default:
                return m(r, {
                    eF: !0
                });
        }
    }), qwn = function(n) {
        return k([
            tz(n.yR),
            rz(k([
                b("select--invalid", n.zU),
                b("w-full", n.eF)
            ]))
        ]);
    }, Bwn = F4(function(n, r, t, e) {
        var u, a = A3(ce, Awn, Dwn, r), i = A2(Cp, e.dj(n), a.w5), c = {
            AQ: pwn,
            A5: hwn,
            Bf: $wn,
            CB: e.qU,
            iE: a.w5,
            Dr: A2(Cwn, e.Di, e.dj(n)),
            Dt: e.kt
        };
        return A2(Ik, k([
            Nk("select select--searchable"),
            rz(k([
                b("select--open", e.aN),
                b("select--loading", a.Ac),
                b("w-full", a.eF)
            ])),
            jz(e.qU)
        ]), k([
            A2(fU, A2(Ot, Nk("select__input"), A2(Ot, Eq(vwn), A2(Ot, A2(cz, dwn, e.qU), A2(Ot, uz(mwn), A2(Ot, jz(e.qU + "-input"), A2(Ot, oP(A2(uc, a.BU, i)), A2(Ot, cU((u = b(a.w5, e.aN), u.a.$ || u.b ? e.Di : A2(e.dj, n, u.a.a))), A2(Ot, RU(bwn(i)), qwn(a))))))))), h),
            a.Ac ? A2(Gk, k([
                Nk("select__spinner")
            ]), h) : gwn,
            !a.yR && e.aN ? A3($U, "div", k([
                Nk("select__items")
            ]), A2(yu, pU(c), t)) : Sq
        ]));
    }), jwn = function(n) {
        return {
            $: 2,
            a: n
        };
    }, Swn = function(n) {
        return {
            $: 6,
            a: n
        };
    }, zwn = function(n) {
        return {
            $: 5,
            a: n
        };
    }, Uwn = function(n) {
        return {
            $: 3,
            a: n
        };
    }, Ewn = F3(function(n, r, t) {
        return A2(ZI, t, r) ? A2(iW, t, n) : h;
    }), Pwn = F2(function(n, r) {
        var t = jN(r.kk).bH;
        return A2(lV, k([
            jV(k([
                Nk("-mx-1")
            ]))
        ]), k([
            A2(iV, h, k([
                A2(AW, k([
                    bW(n(c$n)),
                    hW(!0)
                ]), k([
                    yP(k([
                        bP(t),
                        xZ(A2(sc, Uwn, jwn)),
                        oZ(A3(swn, r.kk, r.x, 1)),
                        lZ(Swn(jwn(t))),
                        dZ(zwn(jwn(t)))
                    ]))
                ])),
                A2(OW, n, A3(Ewn, r.kk, r.x, 1))
            ]))
        ]));
    }), Twn = F2(function(n, r) {
        return A3(Ewn, n.kk, n.x, r);
    }), Fwn = F2(function(n, r) {
        var t, e = jN(r.kk).ah, u = function() {
            var t = r.ek;
            if (3 === t.$) {
                var u = t.a, a = A2(Ot, lwn(e), A2(Ot, awn(A3(swn, r.kk, r.x, 0)), A2(Ot, cwn(n(o$n)), r.ft ? k([
                    iwn(!0)
                ]) : h))), i = $(A2(yu, function(n) {
                    return A2(Xz, h, Ivn(n));
                }, u), k([
                    A2(Xz, h, Vvn)
                ])), c = n(m$n);
                return b(a, $(i, k([
                    fwn(c)
                ])));
            }
            return b(k([
                cwn("Loading carriers..."),
                iwn(!0)
            ]), h);
        }(), a = u.a, i = u.b;
        return A2(Ik, h, k([
            A2(AW, k([
                bW(n(a$n)),
                hW(!0),
                bW(n(i$n))
            ]), k([
                A2(lV, k([
                    jV(k([
                        Nk("-mx-1")
                    ]))
                ]), k([
                    A2(iV, h, k([
                        A2(px, n$n, A4(Bwn, n, a, i, r.ej)),
                        A2(OW, n, A2(Twn, r, 0))
                    ]))
                ]))
            ])),
            A2(IZ, (t = e, !t.$ && !!t.a.$), A2(Pwn, n, r))
        ]));
    }), Lwn = function(n) {
        return n.nC;
    }, Mwn = function(n) {
        return {
            $: 3,
            a: n
        };
    }, Hwn = F3(function(n, r, t) {
        var e = jN(t.kk).bT;
        return A2(lV, k([
            jV(k([
                Nk("-mx-1")
            ]))
        ]), k([
            A2(iV, h, k([
                A2(AW, k([
                    bW(n(l$n)),
                    hW(!0)
                ]), k([
                    yP(k([
                        bP(e),
                        lP("321555 --- 000"),
                        xZ(A2(sc, Uwn, Mwn)),
                        oZ(A3(swn, t.kk, t.x, 2)),
                        sP(r),
                        dZ(zwn(Mwn(e))),
                        lZ(Swn(Mwn(e)))
                    ]))
                ])),
                A2(OW, n, A2(Twn, t, 2))
            ]))
        ]));
    }), Rwn = function(n) {
        return {
            $: 4,
            a: n
        };
    }, Own = function(n) {
        return n.xp;
    }, Nwn = F3(function(n, r, t) {
        var e = jN(t.kk).qO;
        return A2(Ik, h, k([
            A2(AW, k([
                bW(n(d$n)),
                hW(!0),
                Ahn(n(b$n))
            ]), k([
                A2(lV, k([
                    jV(k([
                        Nk("-mx-1")
                    ]))
                ]), k([
                    A2(iV, k([
                        UZ(6)
                    ]), k([
                        A2(IU, k([
                            SU,
                            rwn(e),
                            ZU(Rwn),
                            uE(uwn(!0)),
                            twn(r)
                        ]), k([
                            ad(n(Own))
                        ]))
                    ])),
                    A2(iV, k([
                        UZ(6)
                    ]), k([
                        A2(IU, k([
                            SU,
                            rwn(!e),
                            ZU(Rwn),
                            uE(uwn(!1)),
                            twn(r)
                        ]), k([
                            ad(n(ewn))
                        ]))
                    ]))
                ]))
            ]))
        ]));
    }), Iwn = function(n) {
        return {
            $: 4,
            a: n
        };
    }, Vwn = F3(function(n, r, t) {
        var e = jN(t.kk).bX;
        return A2(lV, k([
            jV(k([
                Nk("-mx-1")
            ]))
        ]), k([
            A2(iV, h, k([
                A2(AW, k([
                    bW(n(v$n)),
                    hW(!0)
                ]), k([
                    yP(k([
                        bP(e),
                        lP("EXF000099900"),
                        xZ(A2(sc, Uwn, Iwn)),
                        oZ(A3(swn, t.kk, t.x, 3)),
                        sP(r),
                        dZ(zwn(Iwn(e))),
                        lZ(Swn(Iwn(e)))
                    ]))
                ])),
                A2(OW, n, A2(Twn, t, 3))
            ]))
        ]));
    }), Wwn = F3(function(n, r, t) {
        var e = jN(t.kk).ah, u = p$n(e), a = function() {
            var n = b(e, u);
            n: for(; !n.a.$;){
                if (1 === n.a.a.$) return v(!0, !0, !0);
                if (n.b.$) break n;
                var r = n.b.a;
                return v($$n(r), h$n(r), Lwn(r));
            }
            return v(!1, !1, !1);
        }(), i = a.b, c = a.c;
        return A2(Ik, h, k([
            A2(IZ, a.a, A3(Hwn, n, r, t)),
            A2(IZ, i, A3(Vwn, n, r, t)),
            A2(IZ, c, A3(Nwn, n, r, t))
        ]));
    }), Zwn = F3(function(n, r, t) {
        return A2(Ik, h, 3 === t.ek.$ ? k([
            A2(Fwn, n, t),
            A3(Wwn, n, r, t)
        ]) : Yk);
    }), Xwn = F3(function(n, r, t) {
        var e = jN(t.kk).Y;
        return A2(Ik, h, k([
            A2(AW, k([
                bW(n(f$n)),
                hW(!0),
                Ahn(n(s$n))
            ]), k([
                A2(lV, k([
                    jV(k([
                        Nk("-mx-1")
                    ]))
                ]), k([
                    A2(iV, k([
                        UZ(6)
                    ]), k([
                        A2(IU, k([
                            SU,
                            rwn(e),
                            ZU(nwn),
                            uE(uwn(!0)),
                            twn(r)
                        ]), k([
                            ad(n(Own))
                        ]))
                    ])),
                    A2(iV, k([
                        UZ(6)
                    ]), k([
                        A2(IU, k([
                            SU,
                            rwn(!e),
                            ZU(nwn),
                            uE(uwn(!1)),
                            twn(r)
                        ]), k([
                            ad(n(ewn))
                        ]))
                    ]))
                ]))
            ])),
            A2(IZ, e, A3(Zwn, n, r, t))
        ]));
    }), Gwn = F3(function(n, r, t) {
        return A2(Ik, h, k([
            A3(Xwn, n, r, t)
        ]));
    }), Jwn = F3(function(n, r, t) {
        var e = jN(t.kk).a_;
        return A2(Ik, k([
            Nk("mb-6")
        ]), k([
            A2(hx, k([
                LS(aV),
                PL,
                OL
            ]), k([
                ad(n(Id.qC))
            ])),
            A2(px, abn, A3(Gwn, n, r, e))
        ]));
    }), Ywn = function(n) {
        return {
            $: 10,
            a: n
        };
    }, Qwn = F3(function(n, r, t) {
        var e = jN(t.kk), u = e.wD, a = e.qb, i = e.sE, c = e.rt, o = e.wt;
        return A2(lV, h, k([
            A2(iV, k([
                GZ(2),
                jV(k([
                    Nk("mb-4 sm:mb-0")
                ]))
            ]), k([
                A2(AW, k([
                    bW(n(lI))
                ]), k([
                    A2(vgn, n(agn), A2(px, Ywn, A3(bgn, n, k([
                        ugn(r)
                    ]), u)))
                ]))
            ])),
            A2(iV, k([
                UZ(3)
            ]), k([
                A2(AW, k([
                    bW(n(cI))
                ]), k([
                    A2(vgn, n(agn), yP(k([
                        bP(a),
                        sP(r),
                        $Z(!0)
                    ])))
                ]))
            ])),
            A2(iV, k([
                UZ(3),
                GZ(2)
            ]), k([
                A2(AW, k([
                    bW(n(fI))
                ]), k([
                    A2(vgn, n(agn), yP(k([
                        bP(i),
                        sP(r),
                        $Z(!0)
                    ])))
                ]))
            ])),
            A2(iV, k([
                UZ(3)
            ]), k([
                A2(AW, k([
                    bW(n(oI))
                ]), k([
                    A2(vgn, n(agn), yP(k([
                        bP(c),
                        sP(r),
                        $Z(!0)
                    ])))
                ]))
            ])),
            A2(iV, k([
                UZ(3),
                GZ(2)
            ]), k([
                A2(AW, k([
                    bW(n(sI)),
                    ign
                ]), k([
                    A2(vgn, n(agn), yP(k([
                        bP(o),
                        sP(r),
                        $Z(!0)
                    ])))
                ]))
            ]))
        ]));
    }), Kwn = function(n) {
        return {
            $: 0,
            a: n
        };
    }, nkn = {
        $: 1
    }, rkn = F2(function(n, r) {
        var t = A2(sA, ru, A2($4, function(n) {
            return A2(ZI, n.b, r.M);
        }, r.t2)), e = t ? ehn(r) : h;
        if (t && oe(e) > 0) return A2(Ik, k([
            Nk("mb-4 -mt-2 md:-mt-3")
        ]), k([
            A2(OW, n, e)
        ]));
        var u = b(t, r.dG);
        if (u.a || u.b.$) return Sq;
        var a = u.b.a;
        return A2(Ik, k([
            Nk("mb-4 -mt-2 md:-mt-3")
        ]), k([
            A2(hx, k([
                BB,
                EB
            ]), k([
                ad(n(nhn(a)))
            ]))
        ]));
    }), tkn = {
        yR: !1,
        i$: !1
    }, ekn = F2(function(n, r) {
        return m(r, n.$ ? {
            i$: n.a
        } : {
            yR: n.a
        });
    }), ukn = F2(function(n, r) {
        return {
            $: 2,
            a: n,
            b: r
        };
    }), akn = F2(function(n, r) {
        return A2(ZI, r, n.M) ? A2(X$n, n, r) : h;
    }), ikn = F2(function(n, r) {
        return A2(ZI, r, n.M) && A2(G$n, n, r);
    }), ckn = F4(function(n, r, t, e) {
        var u = e.a, a = e.b;
        return b(a.qU, A2(Ik, k([
            Nk("flex flex-col mb-4")
        ]), k([
            A2(px, A2(M$n, u, a), A3(vX, n, k([
                MZ(r),
                OZ(A2(ikn, t, a))
            ]), a)),
            A2(Ik, k([
                Nk("-mx-1")
            ]), k([
                A2(OW, n, A2(akn, t, a))
            ])),
            A2(IZ, !A2(Z$n, t.t2, a), A2(fz, k([
                pz,
                vz(k([
                    Nk("text-primary-300 text-left p-0")
                ])),
                QS(A2(ukn, u, a))
            ]), k([
                ad("- "),
                ad(n(wO))
            ])))
        ])));
    }), okn = F3(function(n, r, t) {
        var e = A3(ce, ekn, tkn, r);
        return A2(Ik, k([
            Nk("phones-input"),
            jz(t.qU)
        ]), k([
            A3($U, "div", h, A2($4, A3(ckn, n, e.yR, t), t.t2)),
            A2(lV, k([
                dV(NZ)
            ]), k([
                A2(iV, k([
                    UZ(12)
                ]), k([
                    A2(rkn, n, t)
                ]))
            ])),
            e.i$ ? Sq : A2(lV, k([
                dV(NZ)
            ]), k([
                A2(iV, k([
                    UZ(12)
                ]), k([
                    A2(fz, k([
                        CU,
                        ZS(e.yR),
                        Don(e.yR),
                        QS(nkn)
                    ]), k([
                        A2(Gk, h, k([
                            ad(n(mO))
                        ]))
                    ]))
                ]))
            ]))
        ]));
    }), fkn = F3(function(n, r, t) {
        var e = jN(t.kk).t2;
        return A2(lV, h, k([
            A2(iV, k([
                UZ(12)
            ]), k([
                A2(AW, k([
                    bW(n($O)),
                    hW(e.vd)
                ]), k([
                    A2(Ik, k([
                        Nk("mx-1")
                    ]), k([
                        A2(px, kvn, A3(okn, n, k([
                            Kwn(r)
                        ]), e))
                    ]))
                ]))
            ]))
        ]));
    }), skn = function(n) {
        return {
            $: 8,
            a: n
        };
    }, lkn = function(n) {
        return {
            $: 0,
            a: n
        };
    }, dkn = function(n) {
        return n.uo;
    }, bkn = function(n) {
        return {
            $: 8,
            a: n
        };
    }, vkn = bkn(0), mkn = F3(function(n, r, t) {
        var e = A3(ce, F2(function(n, r) {
            return m(r, n.$ ? {
                lp: !0
            } : {
                yR: n.a
            });
        }), {
            yR: !1,
            lp: !1
        }, r);
        return A2(Ik, k([
            jz(t.qU)
        ]), k([
            A2(px, ru, A4(AU, n, A2(Ot, Jz(Ht(t.z6)), A2(Ot, Wz, A2(Ot, cX(e.yR), e.lp ? k([
                vkn
            ]) : h))), A2(yu, Xz(h), k([
                0,
                1
            ])), t.fw))
        ]));
    }), pkn = F3(function(n, r, t) {
        var e = jN(t.kk).uo;
        return A2(lV, h, k([
            A2(iV, k([
                UZ(12)
            ]), k([
                A2(AW, k([
                    bW(n(dkn))
                ]), k([
                    A2(px, skn, A3(mkn, n, k([
                        lkn(r)
                    ]), e))
                ]))
            ]))
        ]));
    }), $kn = function(n) {
        return tI(n) ? "" : "***-**-" + A2(nv, 4, n);
    }, hkn = function(n) {
        return n.wb;
    }, gkn = F3(function(n, r, t) {
        var e = jN(t.kk).wb;
        return A2(lV, h, k([
            A2(iV, k([
                UZ(12)
            ]), k([
                A2(AW, k([
                    bW(n(hkn))
                ]), k([
                    A2(vgn, n(agn), yP(k([
                        bP($kn(e)),
                        sP(r)
                    ])))
                ]))
            ]))
        ]));
    }), wkn = F3(function(n, r, t) {
        return A2(Ik, h, k([
            A3(Qwn, n, !0, t),
            A3(mgn, n, !0, t),
            A3($gn, n, !0, t),
            A3(Kgn, n, !0, t),
            A3(pkn, n, !0, t),
            A3(gkn, n, !0, t),
            A3(ygn, n, r, t),
            A3(fkn, n, r, t),
            A3(Jhn, n, r, t),
            A3(Jwn, n, r, t)
        ]));
    }), kkn = F3(function(n, r, t) {
        return A2(Ik, k([
            Nk("text-left")
        ]), k([
            A2(hhn, n, t),
            gx,
            A2(mx, k([
                Qk(k([
                    Nk("mt-8 mb-8")
                ]))
            ]), k([
                ad(n(Id.qZ))
            ])),
            A3(wkn, n, !1, r),
            A2(Ik, h, k([
                A2(lV, h, k([
                    A2(iV, k([
                        UZ(12),
                        GZ(2),
                        jV(k([
                            Nk("mt-1")
                        ]))
                    ]), k([
                        A2(fz, k([
                            nz,
                            JS,
                            QS(mhn)
                        ]), k([
                            ad(n($hn))
                        ]))
                    ])),
                    A2(iV, k([
                        UZ(12),
                        GZ(2),
                        jV(k([
                            Nk("mt-1")
                        ]))
                    ]), k([
                        A2(fz, k([
                            CU,
                            JS,
                            QS(phn)
                        ]), k([
                            ad(n(a2))
                        ]))
                    ])),
                    Gan(k([
                        UZ(12),
                        GZ(8)
                    ]))
                ]))
            ]))
        ]));
    }), xkn = F2(function(n, r) {
        var t;
        return {
            gF: k([
                A2(Ik, k([
                    Nk("panel")
                ]), (t = r.tE, t.$ ? Yk : k([
                    A3(kkn, n, r, t.a)
                ])))
            ]),
            wD: n(Id.wD)
        };
    }), ykn = Ux({
        zO: svn,
        Ab: lvn,
        Ct: dvn,
        Dd: function() {
            return xk(k([
                A2(xD, bvn, pvn)
            ]));
        },
        DB: vhn,
        DH: xkn
    }), _kn = function(n) {
        return {
            $: 0,
            a: n
        };
    }, Ckn = F3(function(n, r, t) {
        var e = t.BD;
        return b({
            gx: r.gx,
            kj: r.kj,
            kk: Rt,
            tE: Rt,
            dw: n,
            bv: Rt
        }, A4(sln, r.gx, $k(n), e.qU, _kn));
    }), Dkn = F2(function(n, r) {
        return b(r, Dp);
    }), Akn = F2(function(n, r) {
        return r;
    }), qkn = function(n) {
        return {
            $: 1,
            a: n
        };
    }, Bkn = function(n) {
        return {
            py: n
        };
    }, jkn = function(n) {
        return {
            $: 0,
            a: n
        };
    }, Skn = F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    }), zkn = {
        yo: function(n) {
            return n.aX.yo;
        },
        zw: function(n) {
            return n.aX.zw;
        },
        zz: function(n) {
            return n.aX.zz;
        },
        AH: function(n) {
            return n.aX.AH;
        },
        Bw: function(n) {
            return n.aX.Bw;
        },
        BE: function(n) {
            return n.aX.BE;
        },
        fw: function(n) {
            return n.aX.fw;
        },
        CW: function(n) {
            return n.aX.CW;
        },
        C2: function(n) {
            return n.aX.C2;
        }
    }, Ukn = function(n) {
        switch(n.$){
            case 0:
                return "spouse";
            case 1:
                return "parent";
            case 2:
                return "child";
            case 3:
                return "sibling";
            case 4:
                return "grandparent";
            case 5:
                return "guardian";
            default:
                return "other";
        }
    }, Ekn = function(n) {
        return id({
            qU: "emergency_contact-" + n + "relationship",
            Dr: F2(function(n, r) {
                return n(function(n) {
                    return (function() {
                        if (1 === n.$) return function(n) {
                            return n.AH;
                        };
                        switch(n.a.$){
                            case 0:
                                return function(n) {
                                    return n.C2;
                                };
                            case 1:
                                return function(n) {
                                    return n.BE;
                                };
                            case 2:
                                return function(n) {
                                    return n.yo;
                                };
                            case 3:
                                return function(n) {
                                    return n.CW;
                                };
                            case 4:
                                return function(n) {
                                    return n.zw;
                                };
                            case 5:
                                return function(n) {
                                    return n.zz;
                                };
                            default:
                                return function(n) {
                                    return n.Bw;
                                };
                        }
                    })()(zkn);
                }(r));
            }),
            Dt: Cp(Ukn)
        });
    }, Pkn = function(n) {
        var r = qbn(n);
        return A2(Skn, n, jkn(AO({
            pt: "",
            qb: "",
            rt: "",
            sS: "",
            t0: r,
            u5: Rt,
            dE: Ekn(n)
        })));
    }, Tkn = A2(Je, _ln, function(n) {
        return n.qb;
    }), Fkn = A2(Je, _ln, function(n) {
        return n.rt;
    }), Lkn = {
        $: 2
    }, Mkn = {
        $: 4
    }, Hkn = {
        $: 5
    }, Rkn = function(n) {
        return {
            $: 6,
            a: n
        };
    }, Okn = {
        $: 1
    }, Nkn = {
        $: 3
    }, Ikn = {
        $: 0
    }, Vkn = function(n) {
        switch(n){
            case "spouse":
                return Ikn;
            case "parent":
                return Okn;
            case "child":
                return Lkn;
            case "sibling":
                return Nkn;
            case "grandparent":
                return Mkn;
            case "guardian":
                return Hkn;
            default:
                return Rkn(n);
        }
    }, Wkn = F2(function(n, r) {
        if (r.$) return Pkn(n);
        var t, e = r.a;
        return A2(Skn, n, jkn(AO({
            pt: A2(uc, "", Cln(e)),
            qb: A2(uc, "", Tkn(e)),
            rt: A2(uc, "", Fkn(e)),
            sS: qln(e),
            t0: (t = Bln(e), t.$ ? qbn(n) : A2(yO, n, jln(t.a))),
            u5: A2(Cp, Vkn, Sln(e)),
            dE: Ekn(n)
        })));
    }), Zkn = {
        $: 1
    }, Xkn = function(n) {
        return {
            $: 0,
            a: n
        };
    }, Gkn = function(n) {
        return {
            $: 5,
            a: n
        };
    }, Jkn = function(n) {
        return {
            $: 2,
            a: n
        };
    }, Ykn = F2(function(n, r) {
        switch(n.$){
            case 0:
                return A2(nC, m(r, {
                    qb: n.a
                }), Dp);
            case 1:
                return A2(nC, m(r, {
                    rt: n.a
                }), Dp);
            case 2:
                var t = A2(bq, n.a, r.dE), e = t.b, u = t.c;
                return A2(nC, m(r, {
                    u5: u.$ || u.a.$ || u.a.a.$ ? r.u5 : u.a.a.a,
                    dE: t.a
                }), A2(jp, A2(Je, Jkn, Xkn), e));
            case 3:
                return b(m(r, {
                    u5: Ht(Rkn(n.a))
                }), Dp);
            case 4:
                return A2(nC, m(r, {
                    pt: n.a
                }), Dp);
            default:
                var a = A2(VI, n.a, r.t0), i = a.b;
                return b(m(r, {
                    t0: a.a
                }), A2(jp, A2(sc, Xkn, Gkn), i));
        }
    }), Qkn = F3(function(n, r, t) {
        var e = t.b, u = A2(n, r, t.a), a = u.b;
        return b(A2(DO, u.a, e), a);
    }), Kkn = F2(function(n, r) {
        var t = r.a, e = r.b;
        if (1 === n.$) return b(n.a ? A2(Skn, t, Zkn) : Pkn(t), Dp);
        var u = n.a;
        if (e.$) return b(A2(Skn, t, e), Dp);
        var a = e.a;
        return A2(wk, A2(Je, jkn, Skn(t)), A3(Qkn, Ykn, u, a));
    }), nxn = F2(function(n, r) {
        return m(r, {
            py: n
        });
    }), rxn = function(n) {
        return {
            $: 2,
            a: n
        };
    }, txn = function(n) {
        var r = n.b;
        if (1 === r.$) return b("use_primary_member_as_emergency_contact", kA(!0));
        var t, e, u = function(n) {
            return A2(uc, bk, A2(Cp, mk, fu(n) ? Rt : Ht(n)));
        }, a = jN(r.a);
        return b("emergency_contact", vk(k([
            b("first_name", u(a.qb)),
            b("last_name", u(a.rt)),
            b("relationship", A2(uc, bk, A2(Cp, A2(Je, Ukn, mk), a.u5))),
            b("relationship_other", (e = a.u5, e.$ || 6 !== e.a.$ ? bk : mk(e.a.a))),
            b("email", A2(uc, bk, A2(Cp, mk, (t = a.pt, fu(t) ? Rt : Ht(t))))),
            b("phone", kmn(a.t0))
        ])));
    }, exn = F4(function(n, r, t, e) {
        var u = $k(r), a = jN(e), i = b("patient", vk(Gq(txn(a.py))));
        return A5(jmn, n, u, t, i, rxn);
    }), uxn = function(n) {
        var r = n.b;
        if (1 === r.$) return h;
        var t = r.a;
        return Gi(A2(yu, function(n) {
            return A2(iW, n, t);
        }, k([
            1,
            0,
            2,
            3
        ])));
    }, axn = ZN(k([
        function(n) {
            var r = n.py;
            return A2(yu, nC(0), uxn(r));
        }
    ])), ixn = function(n) {
        return n.aG.pt;
    }, cxn = function(n) {
        return n.aG.qb;
    }, oxn = function(n) {
        return n.aG.rt;
    }, fxn = function(n) {
        return n.aG.t0;
    }, sxn = function(n) {
        return n.aG.u5;
    }, lxn = function(n) {
        return n.aG.Cl;
    }, dxn = function(n) {
        return n.aG.Cm;
    }, bxn = function(n) {
        return n.aG.CZ;
    }, vxn = function(n) {
        return n.aG.wD;
    }, mxn = F2(function(n, r) {
        return function(t) {
            return n(t) ? h : k([
                r
            ]);
        };
    }), pxn = ZN(k([
        function(n) {
            var r, t = n.pt, e = n.t0, u = 1 === n.u5.$, a = A2(W$n, fu, k([
                n.qb,
                n.rt
            ])), i = "" === (r = b(SI(e), t)).a && "" === r.b, c = b(a && u, i);
            return c.a ? c.b ? h : k([
                b(3, JN(dxn))
            ]) : c.b ? k([
                b(2, JN(lxn))
            ]) : h;
        },
        function(n) {
            var r = n.t0;
            return A2(yu, nC(0), function(n) {
                return A2(pI, n.BT, n.CD) ? k([
                    TI($O)
                ]) : h;
            }(r));
        },
        function(n) {
            var r = n.pt;
            return fu(r) || uI(r) ? h : k([
                b(1, aI(A2(XN, nI, KN)))
            ]);
        },
        A2(mxn, function(n) {
            var r = n.u5;
            return !(!r.$ && 6 === r.a.$ && "" === r.a.a);
        }, b(4, JN(A2(XN, YN, sxn))))
    ])), $xn = function(n) {
        var r = n.b;
        return A2(Skn, n.a, 1 === r.$ ? r : jkn(function(n) {
            var r = A2(wI, pxn, n);
            return r.$ ? b(r.a, !1) : b(r.a.a, !0);
        }(r.a).a));
    }, hxn = F2(function(n, r) {
        switch(n.$){
            case 3:
                var t = b(r.tE, r.kk);
                if (t.a.$ || t.b.$) return v(r, Dp, h);
                var e = t.a.a, u = function(n) {
                    var r = A2(wI, axn, function(n) {
                        var r = jN(n), t = $xn(r.py);
                        return A3(WI, nxn, t, n);
                    }(n));
                    return r.$ ? b(!1, r.a) : b(!0, r.a.a);
                }(l = t.b.a), a = u.a, i = u.b;
                return v(m(r, {
                    kk: Ht(i)
                }), a ? A4(exn, r.gx, r.dw, Aln(e), i) : Dp, h);
            case 0:
                var c = n.a;
                return e = MD(c), v(m(r, {
                    kk: A2(Cp, AO, A2(Cp, Bkn, A2(Cp, Wkn("emergency-contact-input"), A2(Cp, Dln, e)))),
                    tE: e
                }), Dp, A2(uA, 0, c));
            case 2:
                var o = n.a;
                return 3 === o.$ ? v(m(r, {
                    tE: Ht(e = o.a)
                }), A2(zx, oa, Aa({
                    qU: Aln(e)
                })), h) : v(r, Dp, A2(uA, 0, o));
            default:
                var f = n.a, s = r.kk;
                if (s.$) return v(r, Dp, h);
                var l, d = jN(l = s.a), p = A2(Kkn, f, d.py), $ = p.b;
                return v(m(r, {
                    kk: Ht(A3(WI, nxn, p.a, l))
                }), A2(jp, qkn, $), h);
        }
    }), gxn = {
        $: 3
    }, wxn = ir("form"), kxn = function(n) {
        return b(n, !0);
    }, xxn = F2(function(n, r) {
        return A2(zq, n, function(n) {
            return {
                $: 2,
                a: n
            };
        }(r));
    }), yxn = function(n) {
        return A2(xxn, "submit", A2(Ye, kxn, Ke(n)));
    }, _xn = function(n) {
        return {
            $: 1,
            a: n
        };
    }, Cxn = function(n) {
        return {
            $: 4,
            a: n
        };
    }, Dxn = function(n) {
        return {
            $: 0,
            a: n
        };
    }, Axn = function(n) {
        return {
            $: 1,
            a: n
        };
    }, qxn = function(n) {
        return {
            $: 3,
            a: n
        };
    }, Bxn = function(n) {
        return {
            $: 1,
            a: n
        };
    }, jxn = F3(function(n, r, t) {
        var e = t.b, u = k([
            Rt,
            Ht(Ikn),
            Ht(Okn),
            Ht(Lkn),
            Ht(Mkn),
            Ht(Nkn),
            Ht(Hkn),
            Ht(Rkn(""))
        ]), a = A3(ce, F2(function(n, r) {
            return m(r, n.$ ? {
                vd: n.a
            } : {
                yR: n.a
            });
        }), {
            yR: !1,
            vd: !1
        }, r);
        return A2(Ik, h, k([
            function() {
                if (1 === e.$) return ad("");
                var r = e.a, t = jN(r);
                return A2(Ik, h, k([
                    gx,
                    A2(lV, k([
                        dV(NZ)
                    ]), k([
                        A2(iV, h, k([
                            A2(UV, k([
                                LS(aV),
                                C1
                            ]), k([
                                ad(n(vxn))
                            ]))
                        ]))
                    ])),
                    A2(lV, h, k([
                        A2(iV, k([
                            Oun(4)
                        ]), k([
                            A2(AW, k([
                                bW(n(cxn))
                            ]), k([
                                yP(k([
                                    xZ(A2(sc, Xkn, Dxn)),
                                    bP(t.qb),
                                    sP(a.yR)
                                ]))
                            ]))
                        ])),
                        A2(iV, k([
                            Oun(4)
                        ]), k([
                            A2(AW, k([
                                bW(n(oxn))
                            ]), k([
                                yP(k([
                                    xZ(A2(sc, Xkn, Axn)),
                                    bP(t.rt),
                                    sP(a.yR)
                                ]))
                            ]))
                        ])),
                        A2(iV, k([
                            Oun(4)
                        ]), k([
                            A2(AW, k([
                                bW(n(sxn)),
                                ign
                            ]), k([
                                A2(px, A2(sc, Xkn, Jkn), A4(AU, n, k([
                                    Jz(Ht(t.u5))
                                ]), A2(yu, function(n) {
                                    return A2(Xz, h, n);
                                }, u), t.dE))
                            ]))
                        ])),
                        A2(iV, k([
                            Oun(12)
                        ]), k([
                            A2(OW, n, A2(iW, 3, r))
                        ]))
                    ])),
                    function() {
                        var e = t.u5;
                        if (e.$ || 6 !== e.a.$) return ad("");
                        var u = e.a.a;
                        return A2(lV, h, k([
                            A2(iV, k([
                                Oun(12)
                            ]), k([
                                yP(k([
                                    lP(n(sxn)),
                                    xZ(A2(sc, Xkn, qxn)),
                                    bP(u),
                                    oZ(A2(kW, 4, r))
                                ])),
                                A2(OW, n, A2(iW, 4, r))
                            ]))
                        ]));
                    }(),
                    A2(lV, h, k([
                        A2(iV, k([
                            Oun(12)
                        ]), k([
                            A2(AW, k([
                                bW(n(fxn))
                            ]), k([
                                A2(px, A2(sc, Xkn, Gkn), A3(vX, n, k([
                                    MZ(a.yR),
                                    OZ(A2(kW, 0, r) || A2(kW, 2, r))
                                ]), t.t0))
                            ])),
                            A2(OW, n, A2(iW, 0, r))
                        ]))
                    ])),
                    A2(lV, h, k([
                        A2(iV, k([
                            Oun(12)
                        ]), k([
                            A2(AW, k([
                                bW(n(ixn))
                            ]), k([
                                yP(k([
                                    $Z(!0),
                                    bP(t.pt),
                                    xZ(A2(sc, Xkn, Cxn)),
                                    oZ(A2(kW, 2, r) || A2(kW, 1, r)),
                                    sP(a.yR)
                                ]))
                            ])),
                            A2(OW, n, A2(iW, 1, r))
                        ])),
                        A2(iV, k([
                            Oun(12)
                        ]), k([
                            A2(OW, n, A2(iW, 2, r))
                        ]))
                    ]))
                ]));
            }(),
            a.vd ? ad("") : A2(lV, h, k([
                A2(iV, h, k([
                    A2(QW, k([
                        WW(Bxn),
                        ZW(1 === e.$)
                    ]), k([
                        ad(n(bxn))
                    ]))
                ]))
            ]))
        ]));
    }), Sxn = F2(function(n, r) {
        var t = Jx(xln(r)), e = Aln(r);
        return A2(Ik, h, k([
            A2(Gk, k([
                Nk("text-support")
            ]), k([
                A2(fF, k([
                    Nk("link text-current"),
                    vF(Sx(Da))
                ]), k([
                    ad(n(Id.wD))
                ]))
            ])),
            A2(Gk, k([
                Nk("mx-3 text-support")
            ]), k([
                ad("/")
            ])),
            A2(fF, k([
                Nk("link text-current"),
                vF(Sx(Aa({
                    qU: e
                })))
            ]), k([
                t
            ])),
            A2(Gk, k([
                Nk("mx-3 text-support")
            ]), k([
                ad("/")
            ])),
            A2(Gk, h, k([
                ad(n(Id.py))
            ]))
        ]));
    }), zxn = F3(function(n, r, t) {
        return A2(Ik, k([
            Nk("text-left")
        ]), k([
            A2(Sxn, n, r),
            function() {
                if (t.$) return ad("");
                var e = jN(t.a).py;
                return A2(wxn, k([
                    yxn(gxn)
                ]), k([
                    A2(px, qkn, A3(jxn, n, k([
                        _xn(!0)
                    ]), e)),
                    A2(Ik, h, k([
                        A2(fz, k([
                            nz
                        ]), k([
                            ad(n($hn))
                        ])),
                        A2(gV, k([
                            vV(Sx(Aa({
                                qU: Aln(r)
                            }))),
                            bV
                        ]), k([
                            ad(n(a2))
                        ]))
                    ]))
                ]));
            }()
        ]));
    }), Uxn = F2(function(n, r) {
        var t;
        return {
            gF: k([
                A2(Ik, k([
                    Nk("panel")
                ]), (t = r.tE, t.$ ? Yk : k([
                    A3(zxn, n, t.a, r.kk)
                ])))
            ]),
            wD: n(Id.wD)
        };
    }), Exn = Ux({
        zO: Ckn,
        Ab: Dkn,
        Ct: Akn,
        Dd: function() {
            return yk;
        },
        DB: hxn,
        DH: Uxn
    }), Pxn = function(n) {
        return {
            $: 0,
            a: n
        };
    }, Txn = function(n) {
        return {
            $: 1,
            a: n
        };
    }, Fxn = F6(function(n, r, t, e, u, a) {
        return {
            pY: a,
            qU: n,
            tv: r,
            up: e,
            k1: u,
            wj: t
        };
    }), Lxn = F5(function(n, r, t, e, u) {
        return {
            nf: r,
            nU: u,
            qU: n,
            to: t,
            u6: e
        };
    }), Mxn = F4(function(n, r, t, e) {
        return {
            yk: t,
            q9: e,
            tb: n,
            uN: r
        };
    }), Hxn = A2(Ye, ru, A3(zy, "invoice_id", Ay(w$), A3(zy, "charge_item_name", w$, A3(zy, "quantity", C$, A3(zy, "occurred_at", FC, Ke(Mxn)))))), Rxn = F2(function(n, r) {
        return {
            qU: n,
            sS: r
        };
    }), Oxn = A3(zy, "name", w$, A3(zy, "id", w$, Ke(Rxn))), Nxn = A2(qy, Oxn, Ke(ru)), Ixn = A2(Ye, ru, A3(zy, "consumption_events", Ey(Hxn), A3(zy, "remaining_quantity", C$, A3(zy, "original_quantity", C$, A3(zy, "charge_item", Nxn, A3(zy, "id", w$, Ke(Lxn))))))), Vxn = A2(Ye, ru, A4(Sy, "expires_at", Ay(FC), Rt, A3(zy, "price_in_cents", Ay(_$), A3(zy, "prepaid_charges", Ey(Ixn), A3(zy, "status", w$, A3(zy, "package_name", w$, A3(zy, "id", w$, Ke(Fxn)))))))), Wxn = Ey(Vxn), Zxn = F3(function(n, r, t) {
        return A4(dC, n, Wxn, t, bC(function(n) {
            return A2($y, k([
                "patient_packages"
            ]), gy(n));
        }(r)));
    }), Xxn = F2(function(n, r) {
        return A2(zD, function(r) {
            return i(n, r.gW);
        }, r);
    }), Gxn = F2(function(n, r) {
        var t;
        return !A2(Xxn, n, (t = r, t.b.p2)).$;
    }), Jxn = function(n) {
        return A2(Gxn, 1, n);
    }, Yxn = F3(function(n, r, t) {
        var e = A2(Zu, "renewedMembershipId", t.iu), u = Jxn(n), a = u ? A3(Zxn, r.gx, $k(n), Txn) : Dp;
        return b({
            gx: r.gx,
            kj: r.kj,
            _: oc,
            ia: u ? Mx : oc,
            tE: r.tE,
            dw: n,
            k8: e,
            jx: r.jx
        }, Hu(k([
            A3(Xfn, r.gx, $k(n), Pxn),
            a
        ])));
    }), Qxn = F2(function(n, r) {
        return b(r, Dp);
    }), Kxn = F2(function(n, r) {
        return m(r, {
            xE: Ht(2)
        });
    }), nyn = F2(function(n, r) {
        if (n.$) {
            var t = n.a;
            switch(t.$){
                case 3:
                    return v(m(r, {
                        ia: t
                    }), Dp, h);
                case 2:
                    return v(m(r, {
                        ia: oc
                    }), Dp, A2(uA, 0, t));
                default:
                    return v(r, Dp, h);
            }
        } else {
            var e = n.a;
            switch(e.$){
                case 3:
                    return v(m(r, {
                        _: e
                    }), Dp, h);
                case 2:
                    return v(m(r, {
                        _: oc
                    }), Dp, A2(uA, 0, e));
                default:
                    return v(r, Dp, h);
            }
        }
    }), ryn = function(n) {
        return n.wj;
    }, tyn = function(n) {
        return n.mi;
    }, eyn = {
        $: 8
    }, uyn = function(n) {
        return n.a.pG;
    }, ayn = F2(function(n, r) {
        return r.sa(n);
    }), iyn = function(n) {
        return n.t9;
    }, cyn = {
        $: 10
    }, oyn = F3(function(n, r, t) {
        return A2(lV, k([
            cyn
        ]), k([
            A2(iV, k([
                UZ(1)
            ]), k([
                A2(hx, k([
                    bz(wF)
                ]), k([
                    A2(US, k([
                        mz
                    ]), 9)
                ]))
            ])),
            A2(iV, k([
                UZ(11)
            ]), k([
                ad(n(ayn(t))),
                A2(hx, k([
                    EB,
                    Qk(k([
                        Nk("mt-1")
                    ]))
                ]), k([
                    A2(PB, k([
                        EB,
                        BB
                    ]), k([
                        ad(n(iyn))
                    ])),
                    ad(" "),
                    A2(gV, k([
                        vV(Sx(Ua({
                            qU: r
                        })))
                    ]), k([
                        ad(n(Vd.u9))
                    ]))
                ]))
            ]))
        ]));
    }), fyn = function(n) {
        return n.sc;
    }, syn = F2(function(n, r) {
        return r.sd(n);
    }), lyn = {
        $: 9
    }, dyn = F2(function(n, r) {
        var t = fu(r) ? fyn : syn(r);
        return A2(lV, k([
            lyn
        ]), k([
            A2(iV, k([
                UZ(1)
            ]), k([
                A2(hx, k([
                    bz(wF)
                ]), k([
                    A2(US, k([
                        mz,
                        Vq("fill-success-300")
                    ]), 8)
                ]))
            ])),
            A2(iV, k([
                UZ(11)
            ]), k([
                A2(hx, k([
                    EB,
                    BB,
                    Qk(k([
                        Nk("mt-1")
                    ]))
                ]), k([
                    ad(n(t))
                ]))
            ]))
        ]));
    }), byn = F5(function(n, r, t, e, u) {
        var a = OB(A2(eE, n, u.a.BS)), c = qtn(tyn(u.a.sV)), o = csn(u), f = fsn(u) ? Sq : ad(c + "/" + a), s = asn(u), l = !t.$ && i(t.a, s);
        return A2(lV, k([
            eyn,
            UZ(12),
            jV(k([
                Nk("card")
            ]))
        ]), k([
            A2(iV, k([
                jV(k([
                    Nk("flex justify-between items-center")
                ]))
            ]), k([
                A2(Ik, k([
                    Nk("text-left ml-2")
                ]), k([
                    A2(PB, k([
                        Qk(k([
                            Nk("mr-3")
                        ]))
                    ]), k([
                        A2(LB, h, k([
                            ad(o)
                        ]))
                    ])),
                    A2(PB, k([
                        EB,
                        BB
                    ]), k([
                        f
                    ]))
                ])),
                A2(Ik, k([
                    Nk("text-right")
                ]), k([
                    A2(gV, k([
                        vV(Sx(Sa({
                            qU: s
                        })))
                    ]), k([
                        ad(n(Vd.iI))
                    ]))
                ]))
            ])),
            A2(iV, h, k([
                function() {
                    if (e) {
                        var t = b(uyn(u), function(n) {
                            return n.a.n6;
                        }(u));
                        return t.a.$ || t.b ? Sq : A3(oyn, n, s, A2(r, 0, t.a.a));
                    }
                    return Sq;
                }()
            ])),
            A2(iV, h, k([
                function() {
                    if (l) {
                        var t = uyn(u);
                        return A2(dyn, n, t.$ ? "" : A2(r, 0, t.a));
                    }
                    return Sq;
                }()
            ]))
        ]));
    }), vyn = F2(function(n, r) {
        return r.ts(n);
    }), myn = function(n) {
        return n.ia.iI;
    }, pyn = function(n) {
        return n.nf;
    }, $yn = function(n) {
        return n.sS;
    }, hyn = function(n) {
        return n.to;
    }, gyn = function(n) {
        return n.u6;
    }, wyn = function(n) {
        var r = gyn(n), t = hyn(n), e = $yn(pyn(n));
        return A2(Ik, k([
            Nk("text-support")
        ]), k([
            ad(ee(t) + " " + e + " "),
            A2(FB, h, k([
                ad("(" + ee(r) + " remaining)")
            ]))
        ]));
    }, kyn = F2(function(n, r) {
        var t = r.tv, e = r.qU, u = function() {
            var t = function(n) {
                return n.pY;
            }(r);
            return t.$ ? "" : n(vyn(A2(ep, "MM/dd/yyyy", t.a)));
        }(), a = function(n) {
            return n.up;
        }(r);
        return A2(lV, k([
            eyn,
            UZ(12),
            jV(k([
                Nk("card")
            ]))
        ]), k([
            A2(iV, k([
                jV(k([
                    Nk("text-left")
                ]))
            ]), k([
                A2(Ik, k([
                    Nk("flex justify-between items-center")
                ]), k([
                    A2(Ik, h, k([
                        A2(LB, h, k([
                            ad(t)
                        ])),
                        ad(" "),
                        A2(PB, k([
                            EB,
                            BB,
                            UB
                        ]), k([
                            ad(u)
                        ]))
                    ])),
                    A2(gV, k([
                        vV(Sx(Fa({
                            qU: e
                        })))
                    ]), k([
                        ad(n(myn))
                    ]))
                ])),
                ED(a) ? Sq : A2(Ik, k([
                    Nk("mt-4 space-y-4")
                ]), A2(yu, wyn, a))
            ]))
        ]));
    }), xyn = F2(function(n, r) {
        return ED(r) ? Sq : A2(Ik, k([
            Nk("mt-4 space-y-4")
        ]), A2(yu, kyn(n), r));
    }), yyn = F6(function(n, r, t, e, u, a) {
        var i = function(n) {
            return A2(usn, k([
                1
            ]), n);
        }(t), c = Jxn(r), o = c ? Vd.pF : Vd.pE, f = function(n) {
            return A2(usn, k([
                3
            ]), n);
        }(t), s = c ? Vd.oz : Vd.ou, l = c && 3 === e.$ ? e.a : h, d = A2(Tc, function(n) {
            return "ended" === ryn(n);
        }, l), b = A2(Tc, function(n) {
            return "active" === ryn(n);
        }, l), v = function(n) {
            return A2(usn, k([
                2
            ]), n);
        }(t);
        return k([
            A2(Ik, k([
                Nk("space-y-6")
            ]), k([
                ED(i) ? Sq : A2(Ik, h, k([
                    A2(mx, h, k([
                        ad(n(Vd.ij))
                    ])),
                    A2(Ik, k([
                        Nk("mt-4")
                    ]), A2(yu, A4(byn, n, u, a, !0), i))
                ])),
                ED(v) && ED(b) ? Sq : A2(Ik, h, k([
                    A2(mx, h, k([
                        ad(n(s))
                    ])),
                    A2(Ik, k([
                        Nk("mt-4")
                    ]), A2(yu, A4(byn, n, u, a, !0), v)),
                    A2(xyn, n, b)
                ])),
                ED(f) && ED(d) ? Sq : A2(Ik, h, k([
                    A2(mx, h, k([
                        ad(n(o))
                    ])),
                    A2(Ik, k([
                        Nk("mt-4")
                    ]), A2(yu, A4(byn, n, u, a, !1), f)),
                    A2(xyn, n, d)
                ]))
            ]))
        ]);
    }), _yn = F2(function(n, r) {
        var t = Jxn(r.dw), e = n(t ? Vd.Dq : Vd.wD), u = n(t ? Vd.xw : Vd.DS);
        return {
            gF: k([
                A2(Ik, k([
                    Nk("panel")
                ]), function() {
                    var t, e = r._;
                    if (3 === e.$) {
                        var a = e.a;
                        return ED(a) && (3 !== (t = r.ia).$ || ED(t.a)) ? MS(u) : A6(yyn, n, r.dw, a, r.ia, r.jx, r.k8);
                    }
                    return Yk;
                }())
            ]),
            wD: e
        };
    }), Cyn = Ux({
        zO: Yxn,
        Ab: Qxn,
        Ct: Kxn,
        Dd: function() {
            return yk;
        },
        DB: nyn,
        DH: _yn
    }), Dyn = function(n) {
        return {
            $: 2,
            a: n
        };
    }, Ayn = function(n) {
        return {
            $: 1,
            a: n
        };
    }, qyn = F2(function(n, r) {
        return {
            m2: n,
            tT: r
        };
    }), Byn = F2(function(n, r) {
        return {
            kd: n,
            w5: r
        };
    }), jyn = A3(zy, "value", Ay(FC), A3(zy, "editable", xy, Ke(Byn))), Syn = A3(zy, "editable", xy, Ke(function(n) {
        return {
            kd: n
        };
    })), zyn = A3(zy, "payment_source", Syn, A3(zy, "cancellation_date", jyn, Ke(qyn))), Uyn = A2(qy, zyn, Ke(ru)), Eyn = F6(function(n, r, t, e, u, a) {
        return {
            pK: t,
            pO: e,
            qU: n,
            tE: u,
            u5: a,
            C3: r
        };
    }), Pyn = function(n) {
        switch(n){
            case "owner":
                return Ke(0);
            case "spouse":
                return Ke(1);
            case "child":
                return Ke(2);
            case "other":
                return Ke(3);
            default:
                return yy("Unsupported relationship: " + n);
        }
    }, Tyn = A3(zy, "relationship", A2(Ge, Pyn, w$), A3(zy, "patient", VC, A3(zy, "enrollment_status", w$, A3(zy, "effective_end_date", l_(FC), A3(zy, "start_date", l_(FC), A3(zy, "id", w$, Ke(Eyn))))))), Fyn = A2(qy, Tyn, Ke(ru)), Lyn = A4(Sy, "source", Ay(een), Rt, A3(zy, "meta", Uyn, A3(zy, "tobacco_surcharge_enabled", xy, A3(zy, "owner", VC, A3(zy, "dpc_discount", xy, A3(zy, "sponsored", xy, A3(zy, "billed_through_date", l_(FC), A3(zy, "children_age_limit", l_(C$), A3(zy, "maximum_age", l_(C$), A3(zy, "minimum_age", l_(C$), A3(zy, "plan_name", w$, A3(zy, "plan_id", w$, A3(zy, "membership_patients", Ey(Fyn), A3(zy, "is_cancellable", xy, A3(zy, "enrollment_status", A2(Ge, Rfn, w$), A3(zy, "period_in_months", A2(Ge, Ofn, C$), A3(zy, "contract_period_in_months", l_(FC), A3(zy, "contract_end_date", l_(FC), A3(zy, "contract_start_date", l_(FC), A3(zy, "next_future_unpaid_bill", Vfn, A3(zy, "id", w$, Ke(function(n) {
        return function(r) {
            return function(t) {
                return function(e) {
                    return function(u) {
                        return function(a) {
                            return function(i) {
                                return function(c) {
                                    return function(o) {
                                        return function(f) {
                                            return function(s) {
                                                return function(l) {
                                                    return function(d) {
                                                        return function(b) {
                                                            return function(v) {
                                                                return function(m) {
                                                                    return function(p) {
                                                                        return function($) {
                                                                            return function(h) {
                                                                                return function(g) {
                                                                                    return function(w) {
                                                                                        return {
                                                                                            mE: v,
                                                                                            nk: b,
                                                                                            n7: e,
                                                                                            ob: u,
                                                                                            od: t,
                                                                                            pd: p,
                                                                                            pO: i,
                                                                                            qU: n,
                                                                                            rc: c,
                                                                                            r_: d,
                                                                                            sb: o,
                                                                                            kE: g,
                                                                                            sL: l,
                                                                                            sV: r,
                                                                                            tq: $,
                                                                                            BS: a,
                                                                                            t7: f,
                                                                                            t8: s,
                                                                                            v3: w,
                                                                                            wa: m,
                                                                                            wH: h
                                                                                        };
                                                                                    };
                                                                                };
                                                                            };
                                                                        };
                                                                    };
                                                                };
                                                            };
                                                        };
                                                    };
                                                };
                                            };
                                        };
                                    };
                                };
                            };
                        };
                    };
                };
            };
        };
    })))))))))))))))))))))), Myn = A2(qy, Lyn, Ke(ru)), Hyn = F2(function(n, r) {
        return A2($y, k([
            "memberships",
            r
        ]), gy(n));
    }), Ryn = F4(function(n, r, t, e) {
        return A4(dC, n, Myn, e, bC(A2(Hyn, r, t)));
    }), Oyn = function(n) {
        return A4(Ryn, n.gx, n.BW, n.hV, Ayn);
    }, Nyn = function(n) {
        return {
            $: 6,
            a: n
        };
    }, Iyn = function(n) {
        return A3(aen, n.gx, n.BW, Nyn);
    }, Vyn = {
        eY: !1
    }, Wyn = function(n) {
        return n.a.g8;
    }, Zyn = function(n) {
        return n.e$.g8;
    }, Xyn = function(n) {
        return n.e$.rr;
    }, Gyn = function(n) {
        return n.e$.jD;
    }, Jyn = function(n) {
        return n.e$.wZ;
    }, Yyn = F2(function(n, r) {
        return A2(Gk, h, k([
            ad(A2(Fin, n, r)),
            A2(Zin, n, Lin(r)),
            Wyn(r) ? A2(Utn, k([
                1
            ]), k([
                ad(n(Zyn))
            ])) : ad("")
        ]));
    }), Qyn = Nx({
        qU: "payment-source-select",
        Dr: Yyn,
        Dt: function(n) {
            return Ht(bun(n));
        }
    }), Kyn = F3(function(n, r, t) {
        var e = t.BD, u = $k(n), a = {
            gx: r.gx,
            c3: Rt,
            g0: Rt,
            kj: r.kj,
            e_: Vyn,
            Ay: Rt,
            hV: e.qU,
            BK: XC(r),
            BO: Qyn,
            BP: oc,
            dw: n,
            BW: u,
            d$: !1
        };
        return b(a, Hu(k([
            A2(Eu, Dyn, by),
            Oyn(a),
            Iyn(a)
        ])));
    }), n_n = F2(function(n, r) {
        return b(r, Dp);
    }), r_n = F2(function(n, r) {
        return m(r, {
            xE: Ht(2)
        });
    }), t_n = function(n) {
        return {
            $: 5,
            a: n
        };
    }, e_n = function(n) {
        return {
            $: 8,
            a: n
        };
    }, u_n = function(n) {
        return {
            $: 4,
            a: n
        };
    }, a_n = function(n) {
        return n.qU;
    }, i_n = {
        $: 0
    }, c_n = {
        yc: ""
    }, o_n = function(n) {
        return n.sb;
    }, f_n = k([
        0
    ]), s_n = function() {
        return "Cancellation Reason";
    }, l_n = F3(function(n, r, t) {
        var e = c_n, u = A2(ny, 0, i_n), a = u.a, i = u.b;
        return b({
            ei: oc,
            kk: AO(e),
            Ay: n,
            kC: t,
            sb: o_n(n),
            e1: a,
            dw: r,
            x: A2(jO, f_n, s_n)
        }, i);
    }), d_n = F2(function(n, r) {
        return b(n.$ ? r : m(r, {
            eY: n.a
        }), Dp);
    }), b_n = function(n) {
        return {
            $: 2,
            a: n
        };
    }, v_n = function(n) {
        return {
            $: 3,
            a: n
        };
    }, m_n = {
        $: 1
    }, p_n = function(n) {
        return {
            $: 4,
            a: n
        };
    }, $_n = function(n) {
        return {
            $: 3,
            a: n
        };
    }, h_n = {
        $: 0
    }, g_n = F5(function(n, r, t, e, u) {
        var a = vk(k([
            b("membership", vk(k([
                b("end_date", A2(yN, ttn, e.pC)),
                b("cancellation_reason_other", mk(e.yc)),
                b("ended_by", mk("Patient"))
            ])))
        ]));
        return A4(vN, n, Myn, u, A2(xq, a, bC(A2($y, k([
            "cancel"
        ]), A2(Hyn, r, t)))));
    }), w_n = F3(function(n, r, t) {
        return A2($y, k([
            "members",
            t
        ]), A2($y, k([
            "memberships",
            r
        ]), gy(n)));
    }), k_n = F6(function(n, r, t, e, u, a) {
        var i = vk(k([
            b("member", vk(k([
                b("end_date", A2(yN, ttn, u.pC)),
                b("cancellation_reason_other", mk(u.yc))
            ])))
        ]));
        return A4(vN, n, Fyn, a, A2(xq, i, bC(A2($y, k([
            "cancel"
        ]), A3(w_n, r, t, e)))));
    }), x_n = function(n) {
        return n.ba.x9;
    }, y_n = function(n) {
        return n.ba.yb;
    }, __n = function(n) {
        return n.ba.Ax;
    }, C_n = function(n) {
        return n.ba.Ch;
    }, D_n = function(n) {
        return n.ba.Ci;
    }, A_n = function(n) {
        return n.ba.Ck;
    }, q_n = function(n) {
        return n.ba.Cs;
    }, B_n = function(n) {
        return n.ba.De;
    }, j_n = F2(function(n, r) {
        return m(r, {
            yc: n
        });
    }), S_n = ZN(k([
        function(n) {
            return tI(n.yc) ? k([
                b(0, aI(A_n))
            ]) : h;
        }
    ])), z_n = function(n) {
        return n.kE;
    }, U_n = function(n) {
        return n.m2.w5;
    }, E_n = F3(function(n, r, t) {
        var e = t;
        switch(r.$){
            case 0:
                return {
                    gV: Dp,
                    hi: m_n,
                    hX: m(e, {
                        e1: ND(e.e1)
                    }),
                    h7: h
                };
            case 1:
                return {
                    gV: Dp,
                    hi: h_n,
                    hX: m(e, {
                        kk: i = A3(WI, j_n, r.a, e.kk)
                    }),
                    h7: h
                };
            case 2:
                var u = A2(wI, S_n, e.kk);
                if (u.$) return {
                    gV: Dp,
                    hi: h_n,
                    hX: m(e, {
                        kk: i = u.a
                    }),
                    h7: h
                };
                var a = u.a, i = a.a, c = {
                    yc: a.b.yc,
                    pC: U_n(z_n(e.Ay))
                }, o = function() {
                    var r = e.kC;
                    if (r.$) return A5(g_n, n, $k(e.dw), a_n(e.Ay), c, $_n);
                    var t = r.a;
                    return A6(k_n, n, $k(e.dw), a_n(e.Ay), function(n) {
                        return n.qU;
                    }(t), c, p_n);
                }();
                return {
                    gV: o,
                    hi: h_n,
                    hX: m(e, {
                        ei: Mx,
                        kk: i
                    }),
                    h7: h
                };
            case 3:
                if (3 === (s = r.a).$) {
                    var f = s.a;
                    return {
                        gV: Dp,
                        hi: b_n(f),
                        hX: m(e, {
                            Ay: f
                        }),
                        h7: k([
                            A2(nA, 3, B_n)
                        ])
                    };
                }
                return {
                    gV: Dp,
                    hi: h_n,
                    hX: m(e, {
                        ei: oc
                    }),
                    h7: A2(uA, 0, s)
                };
            default:
                var s;
                if (3 === (s = r.a).$) {
                    var l = s.a;
                    return {
                        gV: Dp,
                        hi: v_n(l),
                        hX: m(e, {
                            kC: Ht(l)
                        }),
                        h7: k([
                            A2(nA, 3, D_n)
                        ])
                    };
                }
                return {
                    gV: Dp,
                    hi: h_n,
                    hX: m(e, {
                        ei: oc
                    }),
                    h7: A2(uA, 0, s)
                };
        }
    }), P_n = F5(function(n, r, t, e, u) {
        var a = vk(k([
            b("membership", vk(k([
                b("payment_source", vk(k([
                    b("id", mk(e))
                ])))
            ])))
        ]));
        return A4(kq, n, Myn, u, A2(xq, a, bC(A2(Hyn, r, t))));
    }), T_n = F2(function(n, r) {
        switch(n.$){
            case 1:
                return 3 === (C = n.a).$ ? v(m(r, {
                    Ay: Ht(C.a)
                }), Dp, h) : v(r, Dp, A2(uA, 0, C));
            case 2:
                return v(m(r, {
                    g0: Ht(A2(cp, nG, n.a))
                }), Dp, h);
            case 3:
                var t = (D = r.Ay).$ ? Dp : A2(zx, oa, za({
                    qU: a_n(D.a)
                }));
                return v(r, t, h);
            case 4:
                var e = n.a, u = A2(uc, b(Rt, Dp), A2(Cp, function(n) {
                    return A2(hln, jp(t_n), A2(wk, Ht, A3(l_n, n, r.dw, e)));
                }, r.Ay)), a = u.b;
                return v(m(r, {
                    c3: u.a
                }), a, h);
            case 5:
                var i = n.a, c = r.c3;
                if (c.$) return v(r, Dp, h);
                var o = A3(E_n, r.gx, i, c.a), f = function() {
                    switch(o.hi.$){
                        case 0:
                            return v(Ht(o.hX), o.gV, h);
                        case 2:
                            return v(Ht(o.hX), A2(zx, oa, ja), o.h7);
                        default:
                            return v(Rt, o.gV, o.h7);
                    }
                }(), s = f.a, l = f.b, d = f.c;
                return t = 3 === o.hi.$ ? Hu(k([
                    A2(jp, t_n, l),
                    Oyn(r)
                ])) : A2(jp, t_n, l), v(m(r, {
                    c3: s
                }), t, d);
            case 0:
                var p = n.a;
                if (1 === p.$) {
                    var $ = A2(T_n, u_n(Ht(e = p.a)), r);
                    return v($.a, $.b, h);
                }
                return v(m(r, {
                    e_: A2(d_n, p, r.e_).a
                }), Dp, h);
            case 6:
                var g = n.a;
                return v(m(r, 3 === g.$ ? {
                    BP: A2(f_, g.a, oa)
                } : {
                    BP: g
                }), Dp, h);
            case 7:
                var w = A2(bq, n.a, r.BO), x = w.a, y = w.c, _ = function() {
                    if (y.$ || y.a.$ || y.a.a.$) return b(m(r, {
                        BO: x
                    }), Dp);
                    var n = y.a.a.a;
                    return b(m(r, {
                        BO: x,
                        d$: !0
                    }), A5(P_n, r.gx, r.BW, r.hV, bun(n), e_n));
                }();
                return v(_.a, t = _.b, h);
            default:
                var C;
                return 3 === (C = n.a).$ ? v(m(r, {
                    Ay: Ht(C.a),
                    d$: !1
                }), Dp, k([
                    A2(nA, 3, Gyn)
                ])) : v(m(r, {
                    d$: !1
                }), Dp, A2(uA, 0, C));
        }
        var D;
    }), F_n = function(n) {
        return {
            $: 0,
            a: n
        };
    }, L_n = function(n) {
        return n.oD;
    }, M_n = function(n) {
        return n.sV;
    }, H_n = function(n) {
        return n.BS;
    }, R_n = function(n) {
        return n.t8;
    }, O_n = function(n) {
        return A2(dP, AA("/"), n);
    }, N_n = F2(function(n, r) {
        return A2(Ik, k([
            Nk("text-left")
        ]), k([
            A2(LB, k([
                Qk(k([
                    Nk("mb-5")
                ]))
            ]), k([
                ad(n(Vd.oa))
            ])),
            A2(hx, k([
                BB,
                Qk(k([
                    Nk("mt-1 mb-8 mr-2")
                ]))
            ]), k([
                ad(r.j1)
            ]))
        ]));
    }), I_n = F2(function(n, r) {
        var t;
        return (t = r, t.ob).$ ? Sq : A2(N_n, n, function(n) {
            var r, t;
            return {
                j1: $((r = n.od).$ ? "" : O_n(r.a), (t = function(n) {
                    return n.n7;
                }(n)).$ ? "" : " - " + O_n(t.a))
            };
        }(r));
    }), V_n = function(n) {
        return n.wa;
    }, W_n = function(n) {
        return A2(ce, F2(function(r, t) {
            return n(r) ? t + 1 : t;
        }), 0);
    }, Z_n = function(n) {
        return n.eB.mN;
    }, X_n = function(n) {
        return n.eB.B0;
    }, G_n = function(n) {
        return n.eB.wD;
    }, J_n = function(n) {
        return n.eB.DS;
    }, Y_n = function(n) {
        return n.pK;
    }, Q_n = function(n) {
        return A2(dP, AA("/"), n);
    }, K_n = F2(function(n, r) {
        return r.pL(n);
    }), nCn = F2(function(n, r) {
        return r.pM(n);
    }), rCn = F2(function(n, r) {
        return r.pN(n);
    }), tCn = F2(function(n, r) {
        return !A2(iA, r, n);
    }), eCn = F5(function(n, r, t, e, u) {
        var a = b(t, e);
        if (a.a.$) return a.b.$ ? "" : Q_n(c = a.b.a);
        if (a.b.$) return A2(ue, ", ", k([
            n(rCn(Q_n(i = a.a.a))),
            u
        ]));
        var i = a.a.a, c = a.b.a, o = r.$ ? K_n(Q_n(c)) : A2(tCn, c, r.a) ? nCn(Q_n(c)) : K_n(Q_n(c));
        return A2(ue, ", ", k([
            n(rCn(Q_n(i))),
            n(o),
            u
        ]));
    }), uCn = function(n) {
        return n.tE;
    }, aCn = F3(function(n, r, t) {
        var e = t.C3, u = uCn(t), a = Jx(Ix(u)), i = LD(u) ? A2(Utn, k([
            1
        ]), k([
            ad(n(X_n))
        ])) : Sq, c = t.pO, o = Y_n(t), f = A5(eCn, n, r, e, o, c), s = function() {
            var r = bsn(u);
            return r.$ ? "" : n(vsn(ee(r.a)));
        }();
        return {
            l7: s,
            kf: f,
            pK: o,
            pO: c,
            kB: i,
            kC: t,
            kU: a
        };
    }), iCn = function(n) {
        return {
            $: 0,
            a: n
        };
    }, cCn = F3(function(n, r, t) {
        return t ? A2(fz, k([
            CU,
            QS(iCn(!0)),
            ZS(r)
        ]), k([
            ad(n(Id.Al))
        ])) : Sq;
    }), oCn = function(n) {
        return {
            $: 1,
            a: n
        };
    }, fCn = F4(function(n, r, t, e) {
        return r && i(e.pK, Rt) ? A2(Ik, k([
            Nk("grid text-right mr-2")
        ]), k([
            A2(fz, k([
                r4,
                QS(oCn(e.kC)),
                vz(k([
                    Nk("text-right")
                ])),
                ZS(t)
            ]), k([
                A2(US, h, 7),
                A2(PB, h, k([
                    ad(n(C_n))
                ]))
            ]))
        ])) : Sq;
    }), sCn = F4(function(n, r, t, e) {
        return A2(lV, k([
            yan,
            UZ(12)
        ]), k([
            A2(iV, k([
                UZ(8),
                jV(k([
                    Nk("flex justify-between items-center")
                ]))
            ]), k([
                A2(Ik, k([
                    Nk("text-left ml-2")
                ]), k([
                    A2(Ik, k([
                        Nk("flex items-center")
                    ]), k([
                        A2(LB, k([
                            Qk(k([
                                Nk("mr-1")
                            ]))
                        ]), k([
                            e.kU
                        ])),
                        e.kB
                    ])),
                    A2(hx, k([
                        BB
                    ]), k([
                        ad(e.kf)
                    ]))
                ]))
            ])),
            Gan(k([
                UZ(1)
            ])),
            A2(iV, k([
                UZ(3)
            ]), k([
                A2(Ik, k([
                    Nk("grid text-right mr-2")
                ]), k([
                    ad(e.l7)
                ])),
                A4(fCn, n, r, t, e)
            ]))
        ]));
    }), lCn = F5(function(n, r, t, e, u) {
        return A2(Ik, k([
            Nk("mb-5")
        ]), A2(Ot, A2(Ik, k([
            Nk("flex justify-between items-center mb-4")
        ]), k([
            A2(hx, h, k([
                A2(LB, h, k([
                    ad(t(G_n))
                ]))
            ])),
            A3(cCn, t, r.eY, n)
        ])), ED(e) ? MS(t(J_n)) : A2(yu, A3(sCn, t, r.eY, 1 === A2(W_n, function(n) {
            return i(n, Rt);
        }, A2(yu, Y_n, e))), A2(yu, A2(aCn, t, u), e))));
    }), dCn = F2(function(n, r) {
        return r.ph(n);
    }), bCn = function(n) {
        return n.sU;
    }, vCn = F3(function(n, r, t) {
        var e = qtn(t);
        if (r.$) return Sq;
        var u, a = r.a;
        return A2(Ik, k([
            Nk("mb-5")
        ]), k([
            A2(hx, k([
                LS(aV)
            ]), k([
                A2(LB, h, k([
                    ad(n(bCn))
                ]))
            ])),
            A2(lV, k([
                yan,
                UZ(12)
            ]), k([
                A2(iV, k([
                    UZ(6),
                    jV(k([
                        Nk("flex justify-between items-center")
                    ]))
                ]), k([
                    A2(Ik, k([
                        Nk("text-left ml-2")
                    ]), k([
                        A2(hx, k([
                            Qk(k([
                                Nk("mb-1 mr-2")
                            ]))
                        ]), k([
                            ad(n(dCn((u = a, A2(dP, AA("/"), u)))))
                        ]))
                    ]))
                ])),
                Gan(k([
                    UZ(3)
                ])),
                A2(iV, k([
                    UZ(3)
                ]), k([
                    A2(Ik, k([
                        Nk("grid text-right mr-2")
                    ]), k([
                        A2(hx, h, k([
                            ad(e)
                        ]))
                    ]))
                ]))
            ]))
        ]));
    }), mCn = {
        $: 3
    }, pCn = F2(function(n, r) {
        return A2(Ik, k([
            Nk("mb-4")
        ]), k([
            r ? A2(fz, k([
                CU,
                QS(mCn)
            ]), k([
                ad(n(Id.lO))
            ])) : Sq
        ]));
    }), $Cn = F3(function(n, r, t) {
        return V_n(t) ? Sq : A2(Ik, k([
            Nk("mb-4")
        ]), k([
            A2(hx, k([
                LS(FS)
            ]), k([
                A2(LB, h, k([
                    ad(n(Z_n))
                ]))
            ])),
            A2(hx, k([
                BB
            ]), k([
                ad(r)
            ]))
        ]));
    }), hCn = F2(function(n, r) {
        return A2(Ik, h, k([
            A2(Gk, k([
                Nk("text-support")
            ]), k([
                A2(fF, k([
                    Nk("link text-current"),
                    vF(Sx(ja))
                ]), k([
                    ad(n(Vd.Dq))
                ]))
            ])),
            A2(Gk, k([
                Nk("mx-3 text-support")
            ]), k([
                ad("/")
            ])),
            ad(r)
        ]));
    }), gCn = {
        $: 2
    }, wCn = KS(7), kCn = function(n) {
        return n.nX;
    }, xCn = F2(function(n, r) {
        return r.nY(n);
    }), yCn = F2(function(n, r) {
        return r.nZ(n);
    }), _Cn = F3(function(n, r, t) {
        return A2(t.n_, n, r);
    }), CCn = function(n) {
        var r = b(A2(Cp, bF(0), kF(n)), A2(Cp, Rhn, lk(n)));
        return r.a.$ ? r.b.$ ? kCn : xCn(r.b.a) : r.b.$ ? yCn(r.a.a) : A2(_Cn, r.a.a, r.b.a);
    }, DCn = function(n) {
        if (1 === n.$) return "today";
        var r = n.a;
        return A2(dP, AA("/"), r);
    }, ACn = F2(function(n, r) {
        return r.oW(n);
    }), qCn = function(n) {
        return {
            $: 1,
            a: n
        };
    }, BCn = F3(function(n, r, t) {
        return A2(ZI, t, r) || A2(kW, t, n);
    }), jCn = F3(function(n, r, t) {
        return A3(BCn, n, r, t) ? A2(iW, t, n) : h;
    }), SCn = F3(function(n, r, t) {
        var e = r, u = jN(e.kk).yc;
        return A2(AW, k([
            bW(n(y_n)),
            hW(!0)
        ]), k([
            zW(k([
                fW("cancel-membership-form-cancellation-reason"),
                gW(0),
                yW(u),
                pW(A2(sc, qCn, ru)),
                sW(t),
                wW(3)
            ])),
            A2(OW, n, A3(jCn, e.kk, e.x, 0))
        ]));
    }), zCn = {
        $: 3
    }, UCn = function(n) {
        return k([
            Jx(Ix(uCn(n)))
        ]);
    }, ECn = F3(function(n, r, t) {
        var e, u, a = (e = r.kC).$ ? r.sb : k([
            e.a
        ]);
        return k([
            A2(Ik, k([
                Nk("section")
            ]), k([
                A2(hx, h, k([
                    ad(n(q_n))
                ])),
                oF,
                A2(hx, h, k([
                    ad(n(ACn(DCn(U_n(z_n(r.Ay))))))
                ])),
                oF,
                A2(hx, h, k([
                    ad(n(CCn(r.dw)))
                ])),
                oF,
                A2(Ik, h, k([
                    A2(hx, k([
                        OL
                    ]), k([
                        ad(n(__n))
                    ]))
                ])),
                oF,
                A2(Ik, h, k([
                    (u = a, A2(Van, k([
                        zCn
                    ]), A2(yu, A2(sc, Pan, UCn), u)))
                ])),
                oF,
                A3(SCn, n, r, t)
            ]))
        ]);
    }), PCn = F2(function(n, r) {
        var t = r, e = n(A2(uc, x_n, A2(Cp, function() {
            return C_n;
        }, t.kC))), u = A2(kW, 0, t.kk);
        return A2(Tz, k([
            jZ(k([
                A2(PB, k([
                    rx
                ]), k([
                    ad(e)
                ]))
            ])),
            IS(A3(ECn, n, t, u)),
            XS(k([
                A2(fz, k([
                    wCn,
                    QS(gCn)
                ]), k([
                    ad(e)
                ]))
            ]))
        ]), fA(t.e1));
    }), TCn = F2(function(n, r) {
        return A2(px, t_n, A2(uc, Sq, A2(Cp, PCn(n), r)));
    }), FCn = KS(8), LCn = F2(function(n, r) {
        return A2(Ik, k([
            Nk("mt-4 mb-4")
        ]), k([
            r ? A2(fz, k([
                FCn,
                QS(u_n(Rt))
            ]), k([
                ad(n(x_n))
            ])) : A2(Ik, h, h)
        ]));
    }), MCn = function(n) {
        return {
            $: 7,
            a: n
        };
    }, HCn = function(n) {
        return n.pO;
    }, RCn = function(n) {
        return n.v3;
    }, OCn = F3(function(n, r, t) {
        if (V_n(r) || !function(n) {
            return function(n) {
                return n.tT.kd;
            }(n.kE);
        }(r)) return Sq;
        var e = 3 === HCn(r), u = t.d$ || e, a = t.BP;
        if (3 === a.$) {
            var i = a.a;
            return A2(Ik, k([
                Nk("mb-4")
            ]), k([
                A2(hx, k([
                    LS(FS)
                ]), k([
                    A2(LB, h, k([
                        ad(n(Xyn))
                    ]))
                ])),
                A2(px, MCn, A4(AU, n, k([
                    Jz(RCn(r)),
                    ZL(n(hfn)),
                    Wz,
                    cX(u)
                ]), A2(yu, function(n) {
                    return A2(Xz, h, n);
                }, i), t.BO)),
                A2(hx, k([
                    Mon,
                    EB,
                    LS(Sdn)
                ]), k([
                    ad(n(Jyn))
                ]))
            ]));
        }
        return Sq;
    }), NCn = F3(function(n, r, t) {
        var e = t.dw.b.r9, u = L_n(M_n(r)), a = tyn(M_n(r)), i = R_n(r), c = o_n(r), o = r.rc && !V_n(r) && e, f = t.e_, s = f.eY, l = A2(eE, n, H_n(r));
        return A2(Ik, k([
            Nk("text-left mb-5")
        ]), k([
            A2(hCn, n, i),
            gx,
            A2(mx, k([
                Qk(k([
                    Nk("mt-8 mb-8")
                ]))
            ]), k([
                ad(i)
            ])),
            A2(I_n, n, r),
            A2(px, F_n, A5(lCn, o, f, n, c, t.g0)),
            A2(pCn, n, s),
            V_n(r) ? Sq : A3(vCn, n, Ht(u), a),
            A3($Cn, n, l, r),
            A3(OCn, n, r, t),
            A2(LCn, n, s),
            A2(TCn, n, t.c3)
        ]));
    }), ICn = F2(function(n, r) {
        var t;
        return {
            gF: k([
                A2(Ik, k([
                    Nk("panel")
                ]), (t = r.Ay, t.$ ? Yk : k([
                    A3(NCn, n, t.a, r)
                ])))
            ]),
            wD: n(Vd.wD)
        };
    }), VCn = Ux({
        zO: Kyn,
        Ab: n_n,
        Ct: r_n,
        Dd: function() {
            return yk;
        },
        DB: T_n,
        DH: ICn
    }), WCn = function(n) {
        return {
            $: 13,
            a: n
        };
    }, ZCn = function(n) {
        return {
            $: 10,
            a: n
        };
    }, XCn = function(n) {
        return {
            $: 0,
            a: n
        };
    }, GCn = function(n) {
        return {
            $: 4,
            a: n
        };
    }, JCn = function() {
        return "Forms";
    }, YCn = {
        cw: h,
        x: A2(jO, k([
            0
        ]), JCn)
    }, QCn = function(n) {
        return {
            $: 0,
            a: n
        };
    }, KCn = {
        sS: Rt
    }, nDn = A2($y, k([
        "known_practices"
    ]), hy), rDn = F3(function(n, r, t) {
        return A4(dC, z9(n), Ey(MC), t, A2(iH, function(n) {
            var r = n(KCn).sS;
            return r.$ ? h : k([
                A2(Ax, "name", r.a)
            ]);
        }(r), bC(nDn)));
    }), tDn = F2(function(n, r) {
        return A3(rDn, n, function(n) {
            return m(n, {
                sS: r
            });
        }, QCn);
    }), eDn = {
        bP: Rt
    }, uDn = function(n) {
        return n.sS;
    }, aDn = F2(function(n, r) {
        return r.$ ? n(vO) : uDn(r.a);
    }), iDn = function(n) {
        return n.qU;
    }, cDn = function(n) {
        return Ht(n.$ ? "Other" : iDn(n.a));
    }, oDn = "known-practices", fDn = k([
        1,
        0
    ]), sDn = function(n) {
        return 1 === n ? "DpcPractice" : "DpcPracticeOther";
    }, lDn = function(n) {
        return b({
            gx: n.gx,
            kg: 0,
            kk: AO(eDn),
            eN: _bn({
                qU: oDn + "-select",
                Dr: aDn,
                Dt: cDn
            }),
            hJ: oc,
            fu: !1,
            x: A2(jO, fDn, sDn)
        }, A2(tDn, n.gx, Rt));
    }, dDn = {
        jP: !1,
        mf: h,
        ny: 0,
        nK: 0,
        g5: !0,
        kW: !1,
        iH: !1
    }, bDn = function(n) {
        return !n;
    }, vDn = function(n) {
        return n.u5;
    }, mDn = function(n) {
        return n.w0;
    }, pDn = F2(function(n, r) {
        switch(r){
            case 0:
                return n + "-first-name";
            case 1:
                return n + "-last-name";
            case 2:
                return n + "-relationship";
            case 3:
                return n + "-chosen-first-name";
            case 4:
                return n + "-chosen-last-name";
            case 5:
                return n + "-dob";
            case 6:
                return n + "-ssn";
            case 7:
                return n + "-email";
            case 8:
                return n + "-phones";
            case 9:
                return n + "-address";
            case 10:
                return n + "-gender";
            case 11:
                return n + "-gender-identity";
            case 12:
                return n + "-pronouns";
            case 13:
                return n + "-title";
            case 14:
                return n + "-chosen-title";
            case 15:
                return n + "-sex";
            default:
                return n + "-emergency-contact";
        }
    }), $Dn = F3(function(n, r, t) {
        return {
            $: 1,
            a: n,
            b: r,
            c: t
        };
    }), hDn = F4(function(n, r, t, e) {
        return ED(n) ? e : m(e, {
            cs: A3($Dn, n, r, t)
        });
    }), gDn = F4(function(n, r, t, e) {
        return A4(hDn, t.mf, hk(r), lk(r), A2(avn, t.jP, A2(uc, bbn(A2(pDn, n, 9)), A2(Cp, Uvn(A2(pDn, n, 9)), function(n) {
            return A2(Xb, function(n) {
                var r;
                return mDn(n) && !bDn(vDn(n)) ? Rt : Ht({
                    xJ: (r = n).l3,
                    xK: r.l4,
                    nr: r.l1,
                    yz: r.l2,
                    wi: r.l5,
                    xy: r.l6
                });
            }, n);
        }(e)))));
    }), wDn = function(n) {
        return n.nm;
    }, kDn = function(n) {
        return A2(uc, "", A2(Xb, wDn, n));
    }, xDn = function(n) {
        return n.nn;
    }, yDn = function(n) {
        return A2(uc, "", A2(Xb, xDn, n));
    }, _Dn = function(n) {
        return n.no;
    }, CDn = function(n) {
        return A2(uc, "", A2(Xb, _Dn, n));
    }, DDn = A2(Je, Xb(function(n) {
        return n.np;
    }), uc("")), ADn = function(n) {
        return n.nq;
    }, qDn = F2(function(n, r) {
        var t = !fu(A2(uc, "", A2(Xb, xDn, r)));
        return b(A2(vmn, A2(Xb, ADn, r), Obn(A2(pDn, n, 14))), t);
    }), BDn = function(n) {
        return n.o2;
    }, jDn = F3(function(n, r, t) {
        return A2(EN, A2(Xb, BDn, t), A2(UO, r.g5, CO(A2(pDn, n, 5))));
    }), SDn = function(n) {
        return n.pt;
    }, zDn = function(n) {
        return A2(uc, "", A2(Xb, SDn, n));
    }, UDn = function(n) {
        return A2(Skn, n, Zkn);
    }, EDn = F2(function(n, r) {
        if (r.$) return UDn(n);
        var t = r.a, e = bDn(vDn(t)), u = t.py;
        return u.$ ? e ? Pkn(n) : UDn(n) : t.w1 ? UDn(n) : A2(Wkn, n, u);
    }), PDn = function(n) {
        return n.qb;
    }, TDn = function(n) {
        return A2(uc, "", A2(Cp, PDn, n));
    }, FDn = function(n) {
        return n.qw;
    }, LDn = function(n) {
        return n.qx;
    }, MDn = function(n) {
        return {
            $: 1,
            a: n
        };
    }, HDn = F2(function(n, r) {
        return m(r, {
            kk: A3(WI, imn, MDn(n), r.kk)
        });
    }), RDn = F2(function(n, r) {
        return A2(HDn, A2(uc, "", A2(Xb, LDn, r)), A2(omn, A2(Xb, FDn, r), A2(Kbn, A2(pDn, n, 11), odn.rr)));
    }), ODn = function(n) {
        return n.qv;
    }, NDn = function(n) {
        return n.qy;
    }, IDn = F2(function(n, r) {
        return m(r, {
            vd: n
        });
    }), VDn = F3(function(n, r, t) {
        return A2(HDn, A2(uc, "", A2(Xb, NDn, t)), A2(omn, A2(Xb, ODn, t), A2(IDn, r.iH, A2(Jbn, A2(pDn, n, 10), cbn.rr))));
    }), WDn = function(n) {
        return n.rt;
    }, ZDn = function(n) {
        return A2(uc, "", A2(Cp, WDn, n));
    }, XDn = function(n) {
        return n.sE;
    }, GDn = function(n) {
        return A2(uc, "", A2(Xb, XDn, n));
    }, JDn = function(n) {
        return n.t2;
    }, YDn = F4(function(n, r, t, e) {
        var u = tvn(r), a = A2(Xb, JDn, e);
        return (u ? evn(sO) : ru)(A2(umn, a, A2(ivn, t.kW, zbn(A2(pDn, n, 8)))));
    }), QDn = F2(function(n, r) {
        var t;
        return t = Pb(n), r.$ ? t : A2(F$, r.a.uo, t);
    }), KDn = function(n) {
        return n.uB;
    }, nAn = function(n) {
        return n.uC;
    }, rAn = F2(function(n, r) {
        var t = A2(Xb, nAn, r);
        return A2(HDn, A2(uc, "", A2(Xb, KDn, r)), A2(omn, t, A2(rvn, A2(pDn, n, 12), sdn.rr)));
    }), tAn = function(n) {
        return A2(Cp, vDn, n);
    }, eAn = function(n) {
        return n.vK;
    }, uAn = F2(function(n, r) {
        return m(r, {
            vd: n
        });
    }), aAn = F3(function(n, r, t) {
        return A2(lmn, A2(Xb, eAn, t), A2(uAn, r.iH, Fbn(A2(pDn, n, 15))));
    }), iAn = function(n) {
        return n.wb;
    }, cAn = function(n) {
        return A2(uc, "", A2(Xb, iAn, n));
    }, oAn = A2(Je, Xb(function(n) {
        return n.wt;
    }), uc("")), fAn = function(n) {
        return n.wD;
    }, sAn = F2(function(n, r) {
        return A2(vmn, A2(Xb, fAn, r), Obn(A2(pDn, n, 13)));
    }), lAn = function(n) {
        return A2(uc, !0, A2(Cp, mDn, n));
    }, dAn = F4(function(n, r, t, e) {
        var u = A2(qDn, n, e), a = u.a, i = u.b;
        return {
            l0: A4(gDn, n, r, t, e),
            nm: kDn(e),
            nn: yDn(e),
            no: CDn(e),
            np: DDn(e),
            nq: a,
            bg: A3(jDn, n, t, e),
            pt: zDn(e),
            py: A2(EDn, n, e),
            qb: TDn(e),
            qv: A3(VDn, n, t, e),
            qw: A2(RDn, n, e),
            aj: i,
            rt: ZDn(e),
            sE: GDn(e),
            t2: A4(YDn, n, r, t, e),
            uo: A2(QDn, n, e),
            uC: A2(rAn, n, e),
            u5: tAn(e),
            vK: A3(aAn, n, t, e),
            wb: cAn(e),
            wt: oAn(e),
            wD: A2(sAn, n, e),
            w0: lAn(e)
        };
    }), bAn = k([
        13,
        0,
        1,
        2,
        14,
        3,
        4,
        5,
        15,
        10,
        11,
        12,
        6,
        7,
        8,
        9
    ]), vAn = function(n) {
        switch(n){
            case 0:
                return "First Name";
            case 1:
                return "Last Name";
            case 2:
                return "Relationship";
            case 3:
                return "Chosen First Name";
            case 4:
                return "Chosen Last Name";
            case 5:
                return "Date Of Birth";
            case 6:
                return "SSN";
            case 7:
                return "Email";
            case 8:
                return "Phone";
            case 9:
                return "Address";
            case 10:
                return "Gender";
            case 11:
                return "Gender Identity";
            case 12:
                return "Pronouns";
            case 13:
                return "Title";
            case 14:
                return "Chosen Title";
            case 15:
                return "Sex";
            default:
                return "Emergency Contact";
        }
    }, mAn = F3(function(n, r, t) {
        var e = t(dDn);
        return {
            nk: Rt,
            aY: e,
            kk: AO(A4(dAn, n, r, e, Rt)),
            qU: n,
            dw: r,
            dD: VJ,
            x: A2(jO, bAn, vAn)
        };
    }), pAn = function(n) {
        return {
            $: 2,
            a: n
        };
    }, $An = function(n) {
        return {
            $: 0,
            a: n
        };
    }, hAn = {
        $: 1
    }, gAn = {
        $: 2
    }, wAn = function(n) {
        return {
            $: 0,
            a: n
        };
    }, kAn = function(n) {
        return yvn(n);
    }, xAn = function(n) {
        return 2 === n;
    }, yAn = function(n) {
        var r = n;
        return xAn(r) || yvn(r);
    }, _An = function(n) {
        return n.ew.xS;
    }, CAn = function(n) {
        return n.ew.AH;
    }, DAn = function(n) {
        return n.ew.BU;
    }, AAn = F2(function(n, r) {
        if (1 === r.$) return n(DAn);
        var t = r.a;
        switch(t.$){
            case 0:
                return "< " + ee(t.a) + " mi";
            case 1:
                return n(_An);
            default:
                return n(CAn);
        }
    }), qAn = id({
        qU: "filter-select",
        Dr: AAn,
        Dt: function(n) {
            return Ht(function() {
                if (1 === n.$) return "Filter by distance";
                var r = n.a;
                switch(r.$){
                    case 0:
                        return "< " + ee(r.a) + " mi";
                    case 1:
                        return "Any distance";
                    default:
                        return "No Filter";
                }
            }());
        }
    }), BAn = {
        au: Rt,
        fx: qAn,
        xy: ""
    }, jAn = F3(function(n, r, t) {
        return 1 === t.$ ? r(t.a) : n(t.a);
    }), SAn = F2(function(n, r) {
        return 1 === r.$ ? Ht(n(r.a)) : Rt;
    }), zAn = id({
        qU: "locations-select",
        Dr: function(n) {
            return A2(jAn, n, function(n) {
                return n.sS;
            });
        },
        Dt: SAn(function(n) {
            return n.qU;
        })
    }), UAn = function(n) {
        return {
            $: 0,
            a: n
        };
    }, EAn = cL, PAn = UAn(EAn), TAn = function(n) {
        return {
            kb: BAn,
            eH: !1,
            eI: !1,
            ku: PAn,
            eW: zAn,
            dw: n,
            dx: ""
        };
    }, FAn = {
        $: 0
    }, LAn = function(n) {
        return n.qU;
    }, MAn = function(n) {
        var r = Hln(n);
        return tI(r) ? Rt : Ht(r);
    }, HAn = function(n) {
        return n.xb;
    }, RAn = F2(function(n, r) {
        var t = HAn(r) ? " (Virtual Location)" : "", e = Uln(r), u = A2(Xb, MAn, Gun(r));
        return u.$ ? $(e, t) : e + " (" + u.a + ")" + t;
    }), OAn = id({
        qU: "practitioner-locations-select",
        Dr: RAn,
        Dt: function(n) {
            return Ht(LAn(n));
        }
    }), NAn = F3(function(n, r, t) {
        return {
            jS: t,
            dw: n,
            bv: FAn,
            ff: OAn,
            w$: r
        };
    }), IAn = function(n) {
        return n.ld;
    }, VAn = function(n) {
        return n.$ ? Rt : Ht(n.a);
    }, WAn = F2(function(n, r) {
        return {
            $: 1,
            a: n,
            b: r
        };
    }), ZAn = {
        $: 0
    }, XAn = function(n) {
        return A2(uc, ZAn, A2(Cp, function(r) {
            return A2(WAn, r, n.xy);
        }, n.au));
    }, GAn = F4(function(n, r, t, e) {
        var u = function() {
            var n = XAn(t.kb);
            if (1 === n.$) {
                var r = n.a, e = n.b;
                return tI(e) ? b(Rt, Rt) : b(VAn(r), Ht(e));
            }
            return b(Rt, Rt);
        }();
        return m(e, {
            kb: u.a,
            hP: n,
            h3: 0,
            lj: r,
            xy: u.b
        });
    }), JAn = function(n) {
        return n.le;
    }, YAn = {
        hP: 250,
        lj: Rt,
        xy: Rt
    }, QAn = function(n) {
        return A2($y, k([
            "locations"
        ]), gy(n));
    }, KAn = F4(function(n, r, t, e) {
        return A4(dC, z9(n), Ey(ben), e, A2(iH, function(n) {
            var r, t, e = n(YAn);
            return Gi(k([
                (t = e.lj, t.$ ? h : k([
                    A2(Ax, "signup_page", t.a)
                ])),
                k([
                    A2(YX, "limit", e.hP)
                ]),
                (r = e.xy, r.$ ? h : k([
                    A2(Ax, "zip", r.a)
                ]))
            ]));
        }(t), bC(QAn(r))));
    }), nqn = function(n) {
        return A2(te, 0, kA(n));
    }, rqn = F2(function(n, r) {
        return vk(k([
            b("zip", mk(n)),
            b("distance", A2(uc, bk, A2(Cp, hq, r)))
        ]));
    }), tqn = {
        jK: Rt,
        jL: Rt,
        kb: Rt,
        hP: 10,
        kw: Rt,
        sS: Rt,
        h3: 0,
        kR: l8,
        lj: Rt,
        lu: Rt,
        xy: Rt
    }, eqn = function(n) {
        return A2($y, k([
            "practitioners"
        ]), gy(n));
    }, uqn = F4(function(n, r, t, e) {
        return A4(dC, z9(n), Ey(uln), e, A2(iH, function(n) {
            var r, t, e, u, a, i, c, o = n(tqn);
            return $((i = o.sS).$ ? h : k([
                A2(Ax, "name", i.a)
            ]), $((a = o.lj).$ ? h : k([
                A2(Ax, "signup_page", a.a)
            ]), $((u = o.jK).$ ? h : k([
                A2(Ax, "accepts_enrollments_from_employer", nqn(u.a))
            ]), $((e = o.jL).$ ? h : k([
                A2(Ax, "accepts_enrollments_from_retail", nqn(e.a))
            ]), $((c = b(o.xy, o.kb)).a.$ ? h : k(c.b.$ ? [
                A2(Ax, "near", A2(te, 0, A2(rqn, c.a.a, Rt)))
            ] : [
                A2(Ax, "near", A2(te, 0, A2(rqn, c.a.a, Ht(c.b.a))))
            ]), $((t = o.kw).$ ? h : k([
                A2(Ax, "location", t.a)
            ]), $(!(r = o.lu).$ && r.a ? k([
                A2(Ax, "with_waitlist", "true")
            ]) : h, k([
                A2(YX, "offset", o.h3),
                A2(YX, "limit", o.hP)
            ]))))))));
        }(t), bC(eqn(r))));
    }), aqn = F3(function(n, r, t) {
        return m(t, {
            lj: n,
            xy: r
        });
    }), iqn = {
        O: 0,
        P: 0,
        bl: Rt,
        ho: Rt,
        ld: Rt,
        le: Rt
    }, cqn = function(n) {
        return xAn(n);
    }, oqn = F2(function(n, r) {
        return m(r, {
            kb: n
        });
    }), fqn = F2(function(n, r) {
        return m(r, {
            eH: !n
        });
    }), sqn = F2(function(n, r) {
        return m(r, {
            eI: !n
        });
    }), lqn = {
        $: 1
    }, dqn = F2(function(n, r) {
        return m(r, {
            au: Ht(lqn),
            xy: n
        });
    }), bqn = F4(function(n, r, t, e) {
        var u, a = l8, i = e(iqn), c = ((u = i.ho).$ ? ru : dqn(u.a))(BAn), o = b8(a), f = b(A4(KAn, n, $k(t), A2(aqn, i.bl, i.ho), pAn), Mx), s = f.a, l = f.b, d = yAn(i.P) ? v(wAn(A3(NAn, t, !0, cqn(i.P))), !0, kAn(i.O)) : kAn(i.O) ? v(hAn, !1, !1) : v(gAn, !1, !1), m = d.a, p = A2(sqn, d.b, A2(fqn, d.c, A2(oqn, c, TAn(t)))), $ = yAn(i.P) ? b(A4(uqn, n, $k(t), A3(GAn, o, i.bl, p), $An), Mx) : b(Dp, oc), g = $.a;
        return b({
            gx: n,
            O: i.O,
            P: i.P,
            eC: h,
            au: p,
            bl: i.bl,
            hQ: l,
            kR: a,
            dw: t,
            cI: $.b,
            ld: IAn(i),
            le: JAn(i),
            fC: m,
            wT: r
        }, k([
            g,
            s
        ]));
    }), vqn = {
        w4: !1
    }, mqn = "member-input", pqn = F3(function(n, r, t) {
        var e, u = $k(n), a = A4(bqn, r.gx, Rk(r.kj), n, ru).a, i = lDn(r), c = i.a, o = i.b, f = A3(X3, !1, r.gx, $k(n)), s = f.a, l = f.b;
        return b({
            gx: r.gx,
            g0: Rt,
            j2: Rt,
            bM: AO(YCn),
            ac: Mx,
            aW: (e = s, m(e, {
                h$: !0
            })),
            ar: c,
            eC: h,
            kj: r.kj,
            ht: !1,
            hA: !1,
            hB: Rt,
            U: A3(mAn, mqn, n, ru),
            Ay: Rt,
            dw: n,
            aC: a,
            uA: !1,
            fl: Rt,
            fF: Rt,
            bB: vqn,
            wT: Rk(r.kj),
            w_: t
        }, Hu(k([
            A4(Ryn, r.gx, u, t.BD.qU, XCn),
            A2(Eu, GCn, by),
            A2(jp, ZCn, o),
            A2(jp, WCn, l)
        ])));
    }), $qn = F2(function(n, r) {
        return b(r, Dp);
    }), hqn = F2(function(n, r) {
        return m(r, {
            xE: Ht(2)
        });
    }), gqn = function(n) {
        return {
            $: 2,
            a: n
        };
    }, wqn = function(n) {
        return {
            $: 1,
            a: n
        };
    }, kqn = xk(k([
        A2(xD, wqn, pvn)
    ])), xqn = F2(function(n, r) {
        return {
            $: 14,
            a: n,
            b: r
        };
    }), yqn = function(n) {
        return {
            $: 6,
            a: n
        };
    }, _qn = function(n) {
        return {
            $: 9,
            a: n
        };
    }, Cqn = function(n) {
        return {
            $: 11,
            a: n
        };
    }, Dqn = F3(function(n, r, t) {
        return {
            qU: n,
            kn: r,
            rr: t
        };
    }), Aqn = function(n) {
        return UP(Te(n));
    }, qqn = function(n) {
        return n.qo;
    }, Bqn = function(n) {
        return !ED(qqn(n));
    }, jqn = function(n) {
        return n.rh;
    }, Sqn = function(n) {
        return jqn(n.a);
    }, zqn = F2(function(n, r) {
        if (r.$) return !1;
        var t = r.a;
        return Sqn(n) && t.pd;
    }), Uqn = function(n) {
        return n.nM;
    }, Eqn = F2(function(n, r) {
        if (r.$) return !1;
        var t = r.a;
        return Uqn(n) && t.wH;
    }), Pqn = F3(function(n, r, t) {
        return A2(zqn, n, r) || A2(Eqn, t, r) || Bqn(t);
    }), Tqn = F3(function(n, r, t) {
        return A3(Pqn, n, r, t) ? Ht(1) : Rt;
    }), Fqn = function(n) {
        return n.nF;
    }, Lqn = function(n) {
        return n.nI;
    }, Mqn = function(n) {
        return function(n) {
            return xAn(Lqn(n));
        }(n) || function(n) {
            return yvn(Lqn(n));
        }(n);
    }, Hqn = function(n) {
        return Mqn(n) || function(n) {
            return yvn(Fqn(n));
        }(n) ? Ht(2) : Rt;
    }, Rqn = F3(function(n, r, t) {
        if (n.$) return h;
        var e = n.a;
        return A2(Ep, ru, k([
            Ht(0),
            A3(Tqn, r, t, e),
            Hqn(e),
            Ht(3)
        ]));
    }), Oqn = F4(function(n, r, t, e) {
        return A2(uc, -1, A2(Aqn, e, A3(Rqn, n, r, t)));
    }), Nqn = F2(function(n, r) {
        if (n.$) return "";
        var t = n.a;
        switch(r){
            case 0:
                return "Member Information";
            case 1:
                return "Custom Details";
            case 2:
                return Mqn(t) ? "Provider" : "Location";
            default:
                return "Confirmation";
        }
    }), Iqn = F4(function(n, r, t, e) {
        return A3(Dqn, e, A4(Oqn, n, r, t, e), A2(Nqn, n, e));
    }), Vqn = F3(function(n, r, t) {
        return A2(yu, A3(Iqn, n, r, t), A3(Rqn, n, r, t));
    }), Wqn = function(n) {
        return {
            $: 12,
            a: n
        };
    }, Zqn = F3(function(n, r, t) {
        return ED(r) ? t : $(t, k([
            A2(Ax, n, A2(ue, ",", r))
        ]));
    }), Xqn = F3(function(n, r, t) {
        return r.$ ? t : $(t, k([
            A2(Ax, n, r.a)
        ]));
    }), Gqn = F3(function(n, r, t) {
        return A3(Zqn, "locations", t, A3(Xqn, "plan_id", r, k([
            A2(Ax, "owner_id", n)
        ])));
    }), Jqn = F7(function(n, r, t, e, u, a, i) {
        return {
            ly: r,
            lz: t,
            ow: e,
            qU: n,
            sS: u,
            tE: a,
            vd: i
        };
    }), Yqn = A3(zy, "required", xy, A3(zy, "patient", ken, A3(zy, "name", w$, A3(zy, "current_document_version", sN, A3(zy, "acceptance_type", A2(Ge, uN, w$), A3(zy, "acceptance_text", w$, A3(zy, "id", w$, Ke(Jqn)))))))), Qqn = A2(qy, Yqn, Ke(ru)), Kqn = F4(function(n, r, t, e) {
        return A4(dC, n, Ey(Qqn), e, A2(iH, t, bC(function(n) {
            return A2($y, k([
                "documents"
            ]), gy(n));
        }(r))));
    }), nBn = F7(function(n, r, t, e, u, a, i) {
        var c = a ? A3(Xqn, "only_signup", Ht("true"), A3(Gqn, e, t, u)) : A3(Gqn, e, t, u);
        return A4(Kqn, n, r, c, i);
    }), rBn = F5(function(n, r, t, e, u) {
        var a = A2(uc, h, A2(Cp, function(n) {
            return k([
                n
            ]);
        }, u));
        return A7(nBn, n, r, Ht(t), e, a, !1, Wqn);
    }), tBn = function(n) {
        var r, t, e = jN(n.kk);
        return !e.aj || (t = (r = {
            nm: e.nm,
            nn: e.nn
        }).nn, tI(r.nm) && tI(t)) ? A2(ue, " ", k([
            e.qb,
            e.sE,
            e.rt
        ])) : A2(ue, " ", k([
            e.nm,
            e.no,
            e.nn
        ]));
    }, eBn = function(n) {
        var r = jN(n.kk).bg;
        return !tI(tBn(n)) && YS(VN(r));
    }, uBn = {
        $: 0
    }, aBn = F2(function(n, r) {
        if (A2(iA, r, n)) return Rt;
        var t = Dv(n) - Dv(r);
        return Ht(2 === A2(iA, A3(xE, 0, t, r), n) ? t - 1 : t);
    }), iBn = F2(function(n, r) {
        var t = A2(aBn, n, r);
        return t.$ ? uBn : function(n) {
            return {
                $: 1,
                a: n
            };
        }(t.a);
    }), cBn = function(n) {
        var r = jN(n.kk);
        return VN(r.bg);
    }, oBn = F2(function(n, r) {
        return A2(Cp, iBn(n), cBn(r));
    }), fBn = function(n) {
        return 1 === n.$ ? Ht(n.a) : Rt;
    }, sBn = F2(function(n, r) {
        return r.nl(n);
    }), lBn = function(n) {
        return 2 === n;
    }, dBn = function(n) {
        return A2(uc, !1, A2(Cp, lBn, n));
    }, bBn = function(n) {
        var r = jN(n.kk);
        return dBn(r.u5);
    }, vBn = F2(function(n, r) {
        return function(t) {
            return A2(ue, Fb(n), A2(yu, function(n) {
                return n(t);
            }, r));
        };
    }), mBn = F2(function(n, r) {
        return n.$ ? r : A2(vBn, " ", k([
            r,
            CCn(n.a)
        ]));
    }), pBn = F3(function(n, r, t) {
        return bBn(t) ? A2(Xb, function(r) {
            return s(r, n) > 0 ? Ht(A2(mBn, Ht(t.dw), sBn(ee(n)))) : Rt;
        }, A2(Xb, fBn, A2(oBn, r, t))) : Rt;
    }), $Bn = function(n) {
        return n.o3;
    }, hBn = function(n) {
        return !n.$;
    }, gBn = F2(function(n, r) {
        return A2(Xb, function(n) {
            return n ? Ht($Bn) : Rt;
        }, A2(Cp, hBn, A2(oBn, n, r)));
    }), wBn = F2(function(n, r) {
        return r.rY(n);
    }), kBn = function(n) {
        return wBn(ee(n));
    }, xBn = F3(function(n, r, t) {
        return A2(Xb, function(r) {
            return s(r, n) > 0 ? Ht(A2(mBn, Ht(t.dw), kBn(n))) : Rt;
        }, A2(Xb, fBn, A2(oBn, r, t)));
    }), yBn = F2(function(n, r) {
        return r.sH(n);
    }), _Bn = function(n) {
        return yBn(ee(n));
    }, CBn = F3(function(n, r, t) {
        return A2(Xb, function(r) {
            return 0 > s(r, n) ? Ht(A2(mBn, Ht(t.dw), _Bn(n))) : Rt;
        }, A2(Xb, fBn, A2(oBn, r, t)));
    }), DBn = F3(function(n, r, t) {
        var e = b(n, r);
        if (e.a.$ || e.b.$) return h;
        var u = e.a.a, a = e.b.a, i = A2(Xb, function(n) {
            return A3(CBn, n, u, t);
        }, function(n) {
            return n.sL;
        }(a)), c = A2(Xb, function(n) {
            return A3(xBn, n, u, t);
        }, function(n) {
            return n.r_;
        }(a)), o = A2(gBn, u, t), f = A2(Xb, function(n) {
            return A3(pBn, n, u, t);
        }, function(n) {
            return n.nk;
        }(a));
        return A2(Ep, ru, k([
            o,
            i,
            c,
            f
        ]));
    }), ABn = F3(function(n, r, t) {
        var e = A3(DBn, n, r, t);
        return eBn(t) && ED(e);
    }), qBn = function(n) {
        switch(n){
            case 0:
                return hmn("owner");
            case 1:
                return hmn("spouse");
            case 2:
                return hmn("child");
            default:
                return hmn("other");
        }
    }, BBn = function(n) {
        return n.$ ? bk : hmn(n.a);
    }, jBn = function(n) {
        return BBn(A2(Cp, vH, n));
    }, SBn = F4(function(n, r, t, e) {
        var u = e.$ ? h : k([
            b("uses_tobacco", kA(e.a))
        ]);
        return A2(Ot, b("name", hmn(n)), A2(Ot, b("dob", jBn(r)), A2(Ot, b("relationship", qBn(t)), u)));
    }), zBn = function(n) {
        return n.w4;
    }, UBn = F5(function(n, r, t, e, u) {
        if (A3(ABn, n, r, t)) {
            var a = A2(Eqn, u, r) ? Ht(zBn(e)) : Rt, i = bBn(t) ? 2 : 1, c = tBn(t), o = cBn(t);
            return Ht(A4(SBn, c, o, i, a));
        }
        return Rt;
    }), EBn = F3(function(n, r, t) {
        var e = Ix(uCn(t)), u = uCn(t).a.o2;
        if (!tI(e) && YS(u)) {
            var a = A2(Eqn, n, Ht(r)) ? uCn(t).a.w4 : Rt, i = function(n) {
                return n.u5;
            }(t);
            return Ht(A4(SBn, e, u, i, a));
        }
        return Rt;
    }), PBn = function(n) {
        return n.t7;
    }, TBn = F6(function(n, r, t, e, u, a) {
        return {
            mi: u,
            gy: a,
            gW: r,
            pn: t,
            qU: n,
            t_: e
        };
    }), FBn = F5(function(n, r, t, e, u) {
        return {
            gy: e,
            gW: r,
            oY: u,
            pm: t,
            qU: n
        };
    }), LBn = {
        $: 0
    }, MBn = F2(function(n, r) {
        var t = b(n, r);
        return t.a.$ ? t.b.$ ? yy("Either percent_off or amount_off_in_cents is required") : Ke(function(n) {
            return {
                $: 1,
                a: n
            };
        }(t.b.a)) : Ke(function(n) {
            return {
                $: 0,
                a: n
            };
        }(t.a.a));
    }), HBn = {
        $: 1
    }, RBn = function(n) {
        return Ke(n > 1 ? function(n) {
            return {
                $: 2,
                a: n
            };
        }(n) : HBn);
    }, OBn = A2(Ge, function(n) {
        return A3(zy, "percent_off", A2(MBn, n.t_, n.mi), A2(IC, n.gy, A2(IC, n.pn, A2(IC, n.gW, A2(IC, n.qU, Ke(FBn))))));
    }, A3(zy, "apply_to_each_patient", xy, A3(zy, "amount_off_in_cents", l_(C$), A3(zy, "percent_off", l_(_$), A4(Sy, "duration_in_months", A2(Ge, RBn, C$), LBn, A3(zy, "code", w$, A3(zy, "id", w$, Ke(TBn)))))))), NBn = A2(qy, OBn, Ke(ru)), IBn = F3(function(n, r, t) {
        return {
            l7: t,
            sS: n,
            uV: r
        };
    }), VBn = A3(zy, "age", C$, A3(zy, "rate_in_cents", C$, A3(zy, "name", A2(Ye, OC, w$), Ke(IBn)))), WBn = A2(qy, A2(Ye, ru, VBn), Ke(ru)), ZBn = A3(zy, "mce", xy, A3(zy, "contract_final_billing_end_date", l_(FC), A3(zy, "coupon", l_(NBn), A3(zy, "start_date", FC, A3(zy, "coupon_discount_in_cents", l_(C$), A3(zy, "recurring_amount_in_cents", C$, A3(zy, "ongoing_amount_in_cents", C$, A3(zy, "registration_fee_in_cents", C$, A3(zy, "billing_period", A2(Ge, Cy, w$), A3(zy, "members", Ey(WBn), Ke(function(n) {
        return function(r) {
            return function(t) {
                return function(e) {
                    return function(u) {
                        return function(a) {
                            return function(i) {
                                return function(c) {
                                    return function(o) {
                                        return function(f) {
                                            return {
                                                mQ: r,
                                                n9: o,
                                                oh: c,
                                                oi: a,
                                                r0: f,
                                                Av: n,
                                                kN: e,
                                                k5: u,
                                                k7: t,
                                                C3: i
                                            };
                                        };
                                    };
                                };
                            };
                        };
                    };
                };
            };
        };
    }))))))))))), XBn = A2(qy, ZBn, Ke(ru)), GBn = F4(function(n, r, t, e) {
        return A4(vN, z9(n), XBn, e, A2(xq, vk(k([
            b("quote", t)
        ])), bC(function(n) {
            return A2($y, k([
                "quotes"
            ]), gy(n));
        }(r))));
    }), JBn = F8(function(n, r, t, e, u, a, i, c) {
        var o, f = b(YS(t), e);
        if (f.a && !f.b.$) {
            var s = f.b.a, l = b("plan", (o = Ht(PBn(s))).$ ? bk : vk(k([
                b("id", mk(o.a))
            ]))), d = A2(yu, A2(EBn, i, s), o_n(s)), v = b("period_in_months", hq(mA(H_n(s)))), m = A2(Ep, ru, $(d, k([
                A5(UBn, t, e, u, a, i)
            ]))), p = k([
                l,
                v,
                b("members", A2(wq, function(n) {
                    return vk(n);
                }, m))
            ]);
            return A4(GBn, n, $k(r), vk(p), c);
        }
        return Dp;
    }), YBn = function(n) {
        return {
            $: 1,
            a: n
        };
    }, QBn = function(n) {
        return n.qU;
    }, KBn = F2(function(n, r) {
        return {
            ag: r,
            S: h,
            qU: n
        };
    }), njn = function(n) {
        return A2(yu, function(n) {
            var r = QBn(n);
            return A2(KBn, "input-" + r, n);
        }, n);
    }, rjn = F2(function(n, r) {
        var t = m(r, {
            x: A3(XI, !0, 0, r.x)
        });
        return m(t, {
            cw: n
        });
    }), tjn = F2(function(n, r) {
        return 0 > n ? Rt : Gb(A2(zp, n, r));
    }), ejn = function(n) {
        return n.tq;
    }, ujn = function(n) {
        return n.qU;
    }, ajn = F2(function(n, r) {
        var t;
        return A2(w7, "Dependent Added", k([
            _7(b7),
            (t = n, A2(x7, "Membership ID", t)),
            y7(r)
        ]));
    }), ijn = function(n) {
        return n.nK;
    }, cjn = F2(function(n, r) {
        var t;
        return m(r, {
            mf: (t = n, t.vr ? t.mf : h),
            ny: xvn(n),
            nK: ijn(n)
        });
    }), ojn = function(n) {
        return A2(zx, oa, Sa({
            qU: a_n(n)
        }));
    }, fjn = function(n) {
        return {
            $: 5,
            a: n
        };
    }, sjn = A3(zy, "use_primary_member_as_emergency_contact", xy, A3(zy, "emergency_contact", l_(Nsn), A3(zy, "use_primary_address", xy, A3(zy, "title", A2(Ge, Esn, l_(w$)), A3(zy, "ssn", l_(w$), A3(zy, "sex", A2(Ge, Usn, l_(w$)), A3(zy, "relationship", A2(Ge, Pyn, w$), A3(zy, "pronoun_other", l_(w$), A3(zy, "pronouns", A2(Ge, zsn, l_(w$)), A3(zy, "phones", l_(Ey(Rsn)), A3(zy, "suffix", l_(w$), A3(zy, "middle_name", l_(w$), A3(zy, "last_name", w$, A3(zy, "preferred_language", Bsn, A3(zy, "gender_other", l_(w$), A3(zy, "gender_identity_other", l_(w$), A3(zy, "gender_identity", A2(Ge, Ssn, l_(w$)), A3(zy, "gender", A2(Ge, jsn, l_(w$)), A3(zy, "first_name", w$, A3(zy, "email", l_(w$), A3(zy, "dob", l_(FC), A3(zy, "chosen_suffix", l_(w$), A3(zy, "chosen_title", A2(Ge, Esn, l_(w$)), A3(zy, "chosen_middle_name", l_(w$), A3(zy, "chosen_last_name", l_(w$), A3(zy, "chosen_first_name", l_(w$), A3(zy, "address_zip", l_(w$), A3(zy, "address_state", l_(w$), A3(zy, "address_line2", l_(w$), A3(zy, "address_line1", l_(w$), A3(zy, "address_country", l_(w$), A3(zy, "address_city", l_(w$), A3(zy, "patient_id", l_(w$), A3(zy, "id", w$, Ke(function(n) {
        return function(r) {
            return function(t) {
                return function(e) {
                    return function(u) {
                        return function(a) {
                            return function(i) {
                                return function(c) {
                                    return function(o) {
                                        return function(f) {
                                            return function(s) {
                                                return function(l) {
                                                    return function(d) {
                                                        return function(b) {
                                                            return function(v) {
                                                                return function(m) {
                                                                    return function(p) {
                                                                        return function($) {
                                                                            return function(h) {
                                                                                return function(g) {
                                                                                    return function(w) {
                                                                                        return function(k) {
                                                                                            return function(x) {
                                                                                                return function(y) {
                                                                                                    return function(_) {
                                                                                                        return function(C) {
                                                                                                            return function(D) {
                                                                                                                return function(A) {
                                                                                                                    return function(q) {
                                                                                                                        return function(B) {
                                                                                                                            return function(j) {
                                                                                                                                return function(S) {
                                                                                                                                    return function(z) {
                                                                                                                                        return function(U) {
                                                                                                                                            return {
                                                                                                                                                l1: t,
                                                                                                                                                l2: e,
                                                                                                                                                l3: u,
                                                                                                                                                l4: a,
                                                                                                                                                l5: i,
                                                                                                                                                l6: c,
                                                                                                                                                nm: o,
                                                                                                                                                nn: f,
                                                                                                                                                no: s,
                                                                                                                                                np: d,
                                                                                                                                                nq: l,
                                                                                                                                                o2: b,
                                                                                                                                                pt: v,
                                                                                                                                                py: z,
                                                                                                                                                qb: m,
                                                                                                                                                qv: p,
                                                                                                                                                qw: $,
                                                                                                                                                qx: h,
                                                                                                                                                qy: g,
                                                                                                                                                qU: n,
                                                                                                                                                rt: k,
                                                                                                                                                sE: x,
                                                                                                                                                BK: r,
                                                                                                                                                t2: _,
                                                                                                                                                uo: w,
                                                                                                                                                uB: D,
                                                                                                                                                uC: C,
                                                                                                                                                u5: A,
                                                                                                                                                vK: q,
                                                                                                                                                wb: B,
                                                                                                                                                wt: y,
                                                                                                                                                wD: j,
                                                                                                                                                w0: S,
                                                                                                                                                w1: U
                                                                                                                                            };
                                                                                                                                        };
                                                                                                                                    };
                                                                                                                                };
                                                                                                                            };
                                                                                                                        };
                                                                                                                    };
                                                                                                                };
                                                                                                            };
                                                                                                        };
                                                                                                    };
                                                                                                };
                                                                                            };
                                                                                        };
                                                                                    };
                                                                                };
                                                                            };
                                                                        };
                                                                    };
                                                                };
                                                            };
                                                        };
                                                    };
                                                };
                                            };
                                        };
                                    };
                                };
                            };
                        };
                    };
                };
            };
        };
    }))))))))))))))))))))))))))))))))))), ljn = A2(qy, sjn, Ke(ru)), djn = function(n) {
        return vk(n);
    }, bjn = F2(function(n, r) {
        return A2($y, k([
            "memberships",
            r,
            "members"
        ]), gy(n));
    }), vjn = F5(function(n, r, t, e, u) {
        return A4(vN, n, ljn, u, A2(xq, function(n) {
            return vk(k([
                b("member", djn(n))
            ]));
        }(e), bC(A2(bjn, r, t))));
    }), mjn = F2(function(n, r) {
        var t, e, u = jN(r.kk);
        return b(n, (t = u.wD).$ ? bk : (e = t.a, hmn(A2(tdn, Rk(0), e))));
    }), pjn = dA("multi_language"), $jn = F3(function(n, r, t) {
        return pjn(n) ? A2(Ot, b("preferred_language", mk(Eb(r.z6))), t) : t;
    }), hjn = F2(function(n, r) {
        var t;
        return k([
            b("gender", (t = n, t.$ ? bk : function(n) {
                switch(n){
                    case 0:
                        return hmn("female");
                    case 1:
                        return hmn("male");
                    default:
                        return hmn("other");
                }
            }(t.a))),
            b("gender_other", hmn(r))
        ]);
    }), gjn = function(n) {
        var r = jN(n.kk);
        return b(r.fz, r.dt);
    }, wjn = F2(function(n, r) {
        var t;
        return k([
            b("gender_identity", (t = n, t.$ ? bk : function(n) {
                switch(n){
                    case 0:
                        return hmn("man");
                    case 1:
                        return hmn("woman");
                    case 2:
                        return hmn("non-binary");
                    case 3:
                        return hmn("trans man");
                    case 4:
                        return hmn("trans woman");
                    default:
                        return hmn("not listed");
                }
            }(t.a))),
            b("gender_identity_other", hmn(r))
        ]);
    }), kjn = F2(function(n, r) {
        var t;
        return k([
            b("pronouns", (t = n, t.$ ? bk : function(n) {
                switch(n){
                    case 0:
                        return hmn("He/Him/His");
                    case 1:
                        return hmn("She/Her/Hers");
                    case 2:
                        return hmn("They/Them/Theirs");
                    default:
                        return hmn("other");
                }
            }(t.a))),
            b("pronoun_other", hmn(r))
        ]);
    }), xjn = function(n) {
        return whn(n);
    }, yjn = F3(function(n, r, t) {
        var e = hmn(r.wb);
        return xjn(n) || i(e, bk) ? t : A2(Ot, b("ssn", vk(k([
            b("number", e)
        ]))), t);
    }), _jn = function(n) {
        return ymn(thn(n));
    }, Cjn = uc(1), Djn = function(n) {
        var r = jN(n.kk), t = A2(Ot, A2(mjn, "title", r.wD), A2(Ot, b("first_name", hmn(r.qb)), A2(Ot, b("middle_name", hmn(r.sE)), A2(Ot, b("last_name", hmn(r.rt)), A2(Ot, b("suffix", hmn(r.wt)), A2(Ot, b("email", hmn(r.pt)), A2(Ot, b("dob", jBn(VN(r.bg))), A2(Ot, b("relationship", qBn(Cjn(r.u5))), A2(Ot, b("use_primary_address", kA(r.w0)), A2(Ot, b("phones", _jn(r.t2)), A2(Ot, txn(r.py), A2(Ot, function(n) {
            var r, t = jN(n.kk);
            return b("sex", (r = t.vK).$ ? bk : function(n) {
                switch(n){
                    case 0:
                        return hmn("female");
                    case 1:
                        return hmn("male");
                    default:
                        return hmn("intersex");
                }
            }(r.a));
        }(r.vK), $(function(n) {
            var r = gjn(n);
            return A2(hjn, r.a, r.b);
        }(r.qv), $(function(n) {
            var r = gjn(n);
            return A2(wjn, r.a, r.b);
        }(r.qw), $(function(n) {
            var r = gjn(n);
            return A2(kjn, r.a, r.b);
        }(r.uC), $(gmn(r.l0), function(n) {
            return k(n.aj ? [
                A2(mjn, "chosen_title", n.wD),
                b("chosen_first_name", hmn(n.nm)),
                b("chosen_middle_name", hmn(n.no)),
                b("chosen_last_name", hmn(n.nn)),
                b("chosen_suffix", hmn(n.np))
            ] : [
                b("chosen_title", bk),
                b("chosen_first_name", bk),
                b("chosen_middle_name", bk),
                b("chosen_last_name", bk),
                b("chosen_suffix", bk)
            ]);
        }(r)))))))))))))))));
        return A3($jn, n.dw, r.uo, A3(yjn, n.aY.nK, r, t));
    }, Ajn = function(n) {
        return A2(xmn, function(n) {
            return A2(w9, !0, n.b);
        }, A2(Y$n, function(n) {
            return x4(n.b);
        }, n.ac));
    }, qjn = F2(function(n, r) {
        return A2(Ot, b("accepted_documents", Ajn(n)), r);
    }), Bjn = function(n) {
        return b("name", A2(uc, bk, A2(Cp, function(n) {
            return hmn(n);
        }, n)));
    }, jjn = F2(function(n, r) {
        var t, e = A2(Cp, uDn, n), u = e.$ ? r : Ht(e.a);
        return b("known_practice", vk(k([
            (t = A2(Cp, iDn, n), b("id", A2(uc, bk, A2(Cp, function(n) {
                return hmn(n);
            }, t)))),
            Bjn(u)
        ])));
    }), Sjn = function(n) {
        return jN(n.kk).bP;
    }, zjn = function(n) {
        var r = Sjn(n);
        if (r.$) return b("known_practice", bk);
        var t = r.a;
        return t.$ ? A2(jjn, Rt, Ht(t.a)) : A2(jjn, Ht(t.a), Rt);
    }, Ujn = F2(function(n, r) {
        return Sjn(n).$ ? r : A2(Ot, zjn(n), r);
    }), Ejn = function(n) {
        var r = n.b;
        return vk(k([
            b("form_item", vk(k([
                b("id", hmn(n.a))
            ]))),
            b("answer", mk(r))
        ]));
    }, Pjn = function(n) {
        return OB(uwn(n));
    }, Tjn = function(n) {
        var r = function() {
            var r = n.ml;
            switch(r.$){
                case 0:
                    return k([
                        Pjn(r.a)
                    ]);
                case 1:
                    return k([
                        r.a
                    ]);
                default:
                    return r.a;
            }
        }();
        return A2(yu, function(r) {
            return b(n.df, r);
        }, r);
    }, Fjn = function(n) {
        var r, t, e;
        return vk(k([
            (e = n.ag, b("form", vk(k([
                b("id", hmn(QBn(e)))
            ])))),
            (r = n.S, t = Gi(A2(yu, Tjn, r)), b("form_response_items", A2(wq, Ejn, t)))
        ]));
    }, Ljn = F2(function(n, r) {
        var t = n.fF;
        if (t.$) return r;
        if (Bqn(t.a)) {
            var e = jN(n.bM);
            return A2(Ot, b("form_responses", A2(wq, Fjn, e.cw)), r);
        }
        return r;
    }), Mjn = F2(function(n, r) {
        return n.$ ? r : A2(Ot, b("location", vk(k([
            b("id", hmn(LAn(n.a)))
        ]))), r);
    }), Hjn = function(n) {
        return n.qU;
    }, Rjn = F2(function(n, r) {
        return n.$ ? r : A2(Ot, b("practitioner", vk(k([
            b("id", hmn(Hjn(n.a)))
        ]))), r);
    }), Ojn = F4(function(n, r, t, e) {
        return r.$ ? e : A2(Eqn, r.a, t) ? A2(Ot, b("uses_tobacco", kA(n)), e) : e;
    }), Njn = function(n) {
        var r = b(n.hQ, n.ld);
        if (3 !== r.a.$ || r.b.$) return Rt;
        var t = r.b.a;
        return A2(zD, function(n) {
            return i(LAn(n), t);
        }, r.a.a);
    }, Ijn = F2(function(n, r) {
        return A2(zD, function(n) {
            return i(Hjn(n), r);
        }, n);
    }), Vjn = function(n) {
        var r = b(n.cI, n.le);
        return 3 !== r.a.$ || r.b.$ ? Rt : A2(Ijn, r.a.a, r.b.a);
    }, Wjn = Jn("scrollTopAndIntoView", mk), Zjn = F2(function(n, r) {
        return m(r, {
            O: Fqn(n),
            P: Lqn(n)
        });
    }), Xjn = "add-member-top", Gjn = function(n) {
        return {
            $: 1,
            a: n
        };
    }, Jjn = function(n) {
        return {
            $: 1,
            a: n
        };
    }, Yjn = F2(function(n, r) {
        return m(r, {
            bP: n
        });
    }), Qjn = function(n) {
        return n.cr.rr;
    }, Kjn = function(n) {
        return n.cr.Ac;
    }, nSn = function(n) {
        return n.cr.Bw;
    }, rSn = function(n) {
        return n.cr.Bx;
    }, tSn = function(n) {
        return n.cr.BU;
    }, eSn = function(n) {
        return n.cr.DS;
    }, uSn = ZN(k([
        function(n) {
            var r = n.bP;
            if (r.$) return h;
            var t = r.a;
            return t.$ && fu(t.a) ? k([
                b(0, JN(A2(XN, YN, nSn)))
            ]) : h;
        }
    ])), aSn = function(n) {
        var r = A2(wI, uSn, n);
        return r.$ ? b(r.a, !1) : b(r.a.a, !0);
    }, iSn = F2(function(n, r) {
        var t = n ? AI(r.x) : r.x, e = aSn(r.kk), u = e.b;
        return b(m(r, {
            kk: e.a,
            x: t
        }), u);
    }), cSn = function() {
        return Ht(1);
    }, oSn = F2(function(n, r) {
        var t = cSn();
        if (t.$) return r;
        var e = t.a;
        return A2(yI, e, r.x) ? m(A2(iSn, !1, r).a, {
            x: A3(_I, !0, e, r.x)
        }) : r;
    }), fSn = F2(function(n, r) {
        switch(n.$){
            case 1:
                var t = A2(z$n, n.a, r.eN), e = t.b, u = t.c, a = m(r, {
                    eN: t.a
                }), i = function() {
                    if (u.$) return v(a, Dp, Rt);
                    if (u.a.$) {
                        var n = u.a.a;
                        return v(m(a, {
                            fu: !0
                        }), A2(tDn, a.gx, Ht(n)), Rt);
                    }
                    return v(A2(iSn, !1, m(a, {
                        kg: 0,
                        kk: A3(WI, Yjn, u.a.a, a.kk)
                    })).a, Dp, Rt);
                }(), c = i.b, o = i.c;
                return v(i.a, Hu(k([
                    A2(jp, Gjn, e),
                    c
                ])), o);
            case 0:
                var f = n.a, s = m(r, {
                    hJ: f,
                    fu: !1
                });
                switch(f.$){
                    case 2:
                        return v(s, Dp, Ht(function(n) {
                            return {
                                $: 0,
                                a: n
                            };
                        }(tA(f.a))));
                    case 3:
                        return v(s, Dp, Rt);
                    default:
                        return v(r, Dp, Rt);
                }
            case 3:
                return v(A2(oSn, n.a, r), Dp, Ht({
                    $: 2,
                    a: "DPC Practice Option"
                }));
            case 2:
                return v(r, Dp, Ht({
                    $: 1,
                    a: "DPC Practice Option"
                }));
            default:
                var l = n.a, d = jN(r.kk).bP;
                if (d.$) return v(r, Dp, Rt);
                if (d.a.$) {
                    var b = Ht(Jjn(l)), p = A3(WI, Yjn, b, r.kk), $ = cSn();
                    if ($.$) return v(m(r, {
                        kk: p
                    }), Dp, Rt);
                    var h = $.a, g = A3(XI, !0, h, r.x);
                    return v(m(r, {
                        kk: A2(ZI, h, g) ? aSn(p).a : p,
                        x: g
                    }), Dp, Rt);
                }
                return v(r, Dp, Rt);
        }
    }), sSn = function(n) {
        return {
            $: 2,
            a: n
        };
    }, lSn = function(n) {
        return n.qU;
    }, dSn = F2(function(n, r) {
        return i(lSn(n), r.df);
    }), bSn = F2(function(n, r) {
        return Gb(A2(Tc, dSn(r), n));
    }), vSn = F4(function(n, r, t, e) {
        return A2(bSn, e, r).$ ? A2(Ot, {
            ml: t,
            kl: n,
            df: lSn(r),
            km: Rt
        }, e) : A3(J9, dSn(r), function(n) {
            return m(n, {
                ml: t
            });
        }, e);
    }), mSn = F3(function(n, r, t) {
        var e = function() {
            var n = A2(bSn, t, r);
            if (n.$) return k([
                ""
            ]);
            var e = n.a.ml;
            return 2 === e.$ ? $(e.a, k([
                ""
            ])) : k([
                ""
            ]);
        }();
        return A4(vSn, n, r, sSn(e), t);
    }), pSn = F3(function(n, r, t) {
        var e = function() {
            var n = A2(bSn, t, r);
            if (n.$) return k([
                ""
            ]);
            var e = n.a.ml;
            if (2 === e.$) {
                var u = e.a;
                return A2(BE, oe(u) - 1, u);
            }
            return k([
                ""
            ]);
        }();
        return A4(vSn, n, r, sSn(e), t);
    }), $Sn = function(n) {
        return {
            $: 0,
            a: n
        };
    }, hSn = F4(function(n, r, t, e) {
        return A4(vSn, n, r, $Sn(t), e);
    }), gSn = F3(function(n, r, t) {
        if (0 > n) return t;
        var e = A2(zp, n, t);
        if (e.b) {
            var u = e.b;
            return $(A2(BE, n, t), A2(Ot, r(e.a), u));
        }
        return t;
    }), wSn = F5(function(n, r, t, e, u) {
        var a = function() {
            var n = A2(bSn, u, r);
            if (n.$) return k([
                t
            ]);
            var a = n.a.ml;
            return 2 === a.$ ? A3(gSn, e, function() {
                return t;
            }, a.a) : k([
                t
            ]);
        }();
        return A4(vSn, n, r, sSn(a), u);
    }), kSn = function(n) {
        return {
            $: 1,
            a: n
        };
    }, xSn = F4(function(n, r, t, e) {
        return A4(vSn, n, r, kSn(t), e);
    }), ySn = F2(function(n, r) {
        switch(n.$){
            case 0:
                var t = n.a, e = n.b;
                return v(m(r, {
                    S: A4(xSn, QBn(r.ag), t, e, r.S)
                }), Dp, Ht(0));
            case 1:
                t = n.a;
                var u = n.b;
                return e = n.c, v(m(r, {
                    S: A5(wSn, QBn(r.ag), t, e, u, r.S)
                }), Dp, Ht(0));
            case 5:
                return t = n.a, v(m(r, {
                    S: A3(mSn, QBn(r.ag), t, r.S)
                }), Dp, Ht(0));
            case 6:
                return t = n.a, v(m(r, {
                    S: A3(pSn, QBn(r.ag), t, r.S)
                }), Dp, Ht(0));
            case 2:
                return v(r, Dp, Ht(2));
            case 3:
                return v(r, Dp, Ht(1));
            default:
                return t = n.a, e = n.b, v(m(r, {
                    S: A4(hSn, QBn(r.ag), t, e, r.S)
                }), Dp, Ht(0));
        }
    }), _Sn = function(n) {
        return {
            $: 22,
            a: n
        };
    }, CSn = function(n) {
        return {
            $: 2,
            a: n
        };
    }, DSn = function(n) {
        return {
            $: 0,
            a: n
        };
    }, ASn = function(n) {
        return {
            $: 6,
            a: n
        };
    }, qSn = function(n) {
        return {
            $: 7,
            a: n
        };
    }, BSn = function(n) {
        return {
            $: 11,
            a: n
        };
    }, jSn = function(n) {
        return {
            $: 8,
            a: n
        };
    }, SSn = function(n) {
        return {
            $: 23,
            a: n
        };
    }, zSn = function(n) {
        return {
            $: 18,
            a: n
        };
    }, USn = function(n) {
        return {
            $: 5,
            a: n
        };
    }, ESn = function(n) {
        return {
            $: 1,
            a: n
        };
    }, PSn = function(n) {
        return {
            $: 14,
            a: n
        };
    }, TSn = function(n) {
        return {
            $: 15,
            a: n
        };
    }, FSn = function(n) {
        return {
            $: 11,
            a: n
        };
    }, LSn = function(n) {
        return {
            $: 10,
            a: n
        };
    }, MSn = function(n) {
        return {
            $: 20,
            a: n
        };
    }, HSn = function(n) {
        return {
            $: 14,
            a: n
        };
    }, RSn = function(n) {
        return {
            $: 13,
            a: n
        };
    }, OSn = function(n) {
        return {
            $: 16,
            a: n
        };
    }, NSn = function(n) {
        return {
            $: 12,
            a: n
        };
    }, ISn = {
        $: 3
    }, VSn = function(n) {
        return {
            $: 13,
            a: n
        };
    }, WSn = function(n) {
        return {
            $: 9,
            a: n
        };
    }, ZSn = function(n) {
        return {
            $: 0,
            a: n
        };
    }, XSn = function(n) {
        return {
            $: 6,
            a: n
        };
    }, GSn = function(n) {
        return {
            $: 17,
            a: n
        };
    }, JSn = function(n) {
        return A2(Eu, GSn, gu(n));
    }, YSn = function(n) {
        switch(n.$){
            case 0:
                return "Title";
            case 1:
                return vAn(0);
            case 2:
                return "Middle Name";
            case 3:
                return vAn(1);
            case 4:
                return "Suffix";
            case 5:
                return "Has Chosen Name";
            case 6:
                return "Chosen Title";
            case 7:
                return vAn(3);
            case 8:
                return "Chosen Middle Name";
            case 9:
                return vAn(4);
            case 10:
                return "Chosen Suffix";
            case 11:
                return vAn(5);
            case 12:
                return "Relationship";
            case 13:
                return vAn(15);
            case 14:
                return vAn(10);
            case 15:
                return vAn(11);
            case 16:
                return vAn(12);
            case 17:
                return "Preferred Language";
            case 18:
                return vAn(6);
            case 19:
                return vAn(7);
            case 20:
                return vAn(8);
            case 21:
                return "Use Primary Address";
            case 22:
                return vAn(9);
            default:
                return vAn(16);
        }
    }, QSn = F2(function(n, r) {
        switch(n.$){
            case 0:
                return m(r, {
                    wD: n.a
                });
            case 1:
                return m(r, {
                    qb: n.a
                });
            case 2:
                return m(r, {
                    sE: n.a
                });
            case 3:
                return m(r, {
                    rt: n.a
                });
            case 4:
                return m(r, {
                    wt: n.a
                });
            case 5:
                return m(r, {
                    aj: n.a
                });
            case 6:
                return m(r, {
                    nq: n.a
                });
            case 7:
                return m(r, {
                    nm: n.a
                });
            case 8:
                return m(r, {
                    no: n.a
                });
            case 9:
                return m(r, {
                    nn: n.a
                });
            case 10:
                return m(r, {
                    np: n.a
                });
            case 11:
                return m(r, {
                    bg: n.a
                });
            case 12:
                return m(r, {
                    u5: Ht(n.a)
                });
            case 13:
                return m(r, {
                    vK: n.a
                });
            case 14:
                return m(r, {
                    qv: n.a
                });
            case 15:
                return m(r, {
                    qw: n.a
                });
            case 16:
                return m(r, {
                    uC: n.a
                });
            case 17:
                return m(r, {
                    uo: n.a
                });
            case 18:
                return m(r, {
                    wb: n.a
                });
            case 19:
                return m(r, {
                    pt: n.a
                });
            case 20:
                return m(r, {
                    t2: n.a
                });
            case 21:
                return m(r, {
                    w0: n.a
                });
            case 22:
                return m(r, {
                    l0: n.a
                });
            default:
                return m(r, {
                    py: n.a
                });
        }
    }), KSn = F3(function(n, r, t) {
        return A2(t.pS, n, r);
    }), nzn = F2(function(n, r) {
        return b(r.a, A2(XN, n, r.b));
    }), rzn = function(n) {
        return A2(uc, !1, A2(Cp, bDn, n));
    }, tzn = function(n) {
        var r = n.l0, t = n.w0;
        return rzn(n.u5) || t ? h : A2(yu, function(n) {
            var r = n.a;
            return b(9, A2(nzn, function(n) {
                return A2(KSn, r, n);
            }, n.b));
        }, N$n(r));
    }, ezn = function(n) {
        return n.aj && tI(n.nm) ? k([
            b(3, JN(A2(XN, YN, Qhn)))
        ]) : h;
    }, uzn = function(n) {
        return n.aj && tI(n.nn) ? k([
            b(4, JN(A2(XN, YN, ngn)))
        ]) : h;
    }, azn = function(n) {
        return A2(Ep, function(r) {
            return Gb(A2(iW, r, n.kk));
        }, Mbn);
    }, izn = function(n) {
        var r;
        return rzn(n.u5) || !n.aj ? h : Gi(k([
            (r = n, r.aj ? A2(yu, function(n) {
                return b(14, n);
            }, azn(r.nq)) : h),
            ezn(n),
            uzn(n)
        ]));
    }, czn = function(n) {
        return n.eC;
    }, ozn = function(n) {
        return A2(yu, function(n) {
            return b(5, n);
        }, czn(n.bg));
    }, fzn = F2(function(n, r) {
        var t = r.pt, e = !rzn(r.u5);
        return e && tI(t) && n ? k([
            b(7, JN(A2(XN, YN, KN)))
        ]) : !e || tI(t) || uI(t) ? h : k([
            b(7, aI(A2(XN, nI, KN)))
        ]);
    }), szn = function(n) {
        var r = n.py;
        return A2(yu, nC(16), uxn(r));
    }, lzn = function(n) {
        return A2(Ep, function(r) {
            return Gb(A2(iW, r, n.kk));
        }, Ibn);
    }, dzn = function(n) {
        return A2(yu, function(n) {
            return b(12, n);
        }, lzn(n.uC));
    }, bzn = function(n) {
        var r;
        return A2(yu, function(n) {
            return b(15, n);
        }, (r = n.vK, A2(Ep, function(n) {
            return Gb(A2(iW, n, r.kk));
        }, Ebn)));
    }, vzn = F2(function(n, r) {
        var t;
        return n ? Gi(k([
            bzn(r),
            (t = r, A2(yu, function(n) {
                return b(11, n);
            }, lzn(t.qw))),
            dzn(r)
        ])) : function(n) {
            return A2(yu, function(n) {
                return b(10, n);
            }, lzn(n.qv));
        }(r);
    }), mzn = function(n) {
        return tI(n.rt) ? k([
            b(1, JN(A2(XN, YN, oI)))
        ]) : h;
    }, pzn = function(n) {
        var r, t;
        return rzn(n.u5) ? h : Gi(k([
            (t = n, A2(yu, function(n) {
                return b(14, n);
            }, azn(t.wD))),
            (r = n, tI(r.qb) ? k([
                b(0, JN(A2(XN, YN, cI)))
            ]) : h),
            mzn(n)
        ]));
    }, $zn = F4(function(n, r, t, e) {
        return A3(e.pT, n, r, t);
    }), hzn = F2(function(n, r) {
        return A2(Aqn, r, A2(yu, Ac, n.b));
    }), gzn = function(n) {
        return n.t0;
    }, wzn = F2(function(n, r) {
        var t = 1 + A2(uc, 0, A2(hzn, n.t2, r));
        return A2(yu, function(r) {
            return Kvn(n.t2) > 1 ? A2(nzn, function(n) {
                return A2(XN, function(r) {
                    return A3($zn, r, ee(t), n);
                }, gzn);
            }, r) : r;
        }, A2(X$n, n, r));
    }), kzn = function(n) {
        return $(ehn(n), Gi(A2($4, function(r) {
            return A2(wzn, n, r.b);
        }, n.t2)));
    }, xzn = function(n) {
        var r = n.t2;
        return rzn(n.u5) ? h : A2(yu, function(n) {
            return b(8, n);
        }, kzn(r));
    }, yzn = function(n) {
        return n.u5.xL;
    }, _zn = function(n) {
        return n.u5.yo;
    }, Czn = function(n) {
        return n.u5.rr;
    }, Dzn = function(n) {
        return n.u5.tq;
    }, Azn = function(n) {
        var r = n.u5;
        return 1 === r.$ ? k([
            b(2, JN(A2(XN, YN, Czn)))
        ]) : (bDn(r.a), h);
    }, qzn = zA("###-##-####"), Bzn = A2(yu, function(n) {
        return A2(FA, qzn, n);
    }, k([
        "219099999",
        "078051120",
        "123456789"
    ])), jzn = function(n) {
        return {
            $: 1,
            a: n
        };
    }, Szn = {
        $: 0
    }, zzn = F3(function(n, r, t) {
        return {
            zr: n,
            Cx: r,
            Dm: t
        };
    }), Uzn = F2(function(n, r) {
        return s(r, n.sG) > -1 && 1 > s(r, n.rX);
    }), Ezn = F2(function(n, r) {
        return r.$ ? A2(Uzn, r.a, n) : function(n) {
            return !(!n || 666 === n || n >= 900 && 999 >= n);
        }(n);
    }), Pzn = F3(function(n, r, t) {
        if (i(au(t), n)) {
            var e = lu(t);
            return e.$ ? qm("Ssn part is not an integer.") : A2(Ezn, e.a, r) ? am(t) : qm("Ssn part is invalid.");
        }
        return qm("Ssn part is invalid.");
    }), Tzn = F2(function(n, r) {
        return A2(nm, A2(Pzn, n, r), Um(_m(he)));
    }), Fzn = A2(Am, A2(Am, A2(Am, am(zzn), A2(um, A2(Tzn, 3, Szn), GA("-"))), A2(um, A2(Tzn, 2, jzn({
        rX: 99,
        sG: 1
    })), GA("-"))), A2(um, A2(Tzn, 4, jzn({
        rX: 9999,
        sG: 1
    })), Nm)), Lzn = F2(function(n, r) {
        var t, e = r.wb;
        return tI(e) ? yvn(n) ? k([
            b(6, JN(A2(XN, YN, hkn)))
        ]) : h : !A2(Ym, Fzn, t = A2(FA, qzn, e)).$ && !A2(lA, t, Bzn) || whn(n) ? h : k([
            b(6, aI(A2(XN, nI, hkn)))
        ]);
    }), Mzn = F2(function(n, r) {
        var t = jN(r);
        return A3(WI, QSn, _Sn(A2(Ypn, n, t.l0)), r);
    }), Hzn = F2(function(n, r) {
        return r.vg(n);
    }), Rzn = F2(function(n, r) {
        return r.wD.$ && n ? k([
            b(0, JN(A2(XN, Hzn, lI)))
        ]) : h;
    }), Ozn = function(n) {
        var r = A2(wI, ZN(k([
            Rzn(n.vd)
        ])), n.kk);
        return r.$ ? b(r.a, !1) : b(r.a.a, !0);
    }, Nzn = F2(function(n, r) {
        var t = n ? AI(r.x) : r.x;
        return m(r, {
            kk: Ozn(r).a,
            x: t
        });
    }), Izn = F2(function(n, r) {
        var t = jN(r);
        return t.aj ? A3(WI, QSn, ASn(A2(Nzn, n, t.nq)), r) : r;
    }), Vzn = F2(function(n, r) {
        var t = jN(r);
        return A3(WI, QSn, BSn(A2(LI, n, t.bg)), r);
    }), Wzn = F2(function(n, r) {
        var t = jN(r), e = $xn(t.py);
        return A3(WI, QSn, SSn(e), r);
    }), Zzn = function(n) {
        return n.ve;
    }, Xzn = F2(function(n, r) {
        var t = r.fz, e = r.dt;
        return t.$ ? h : n(t.a) && tI(e) ? k([
            b(1, JN(Zzn))
        ]) : h;
    }), Gzn = F3(function(n, r, t) {
        return t.fz.$ && n ? k([
            b(0, JN(A2(XN, Hzn, r)))
        ]) : h;
    }), Jzn = F3(function(n, r, t) {
        return ZN(k([
            A2(Gzn, r, t),
            Xzn(n)
        ]));
    }), Yzn = function(n) {
        var r = A2(wI, A3(Jzn, n.z2, n.vd, n.zn), n.kk);
        return r.$ ? b(r.a, !1) : b(r.a.a, !0);
    }, Qzn = F2(function(n, r) {
        var t = n ? AI(r.x) : r.x;
        return m(r, {
            kk: Yzn(r).a,
            x: t
        });
    }), Kzn = F2(function(n, r) {
        var t = jN(r);
        return A3(WI, QSn, PSn(A2(Qzn, n, t.qv)), r);
    }), nUn = F2(function(n, r) {
        var t = jN(r);
        return A3(WI, QSn, TSn(A2(Qzn, n, t.qw)), r);
    }), rUn = F2(function(n, r) {
        var t = jN(r);
        return A3(WI, QSn, OSn(A2(Qzn, n, t.uC)), r);
    }), tUn = F2(function(n, r) {
        return r.vK.$ && n ? k([
            b(0, JN(A2(XN, Hzn, ddn.rr)))
        ]) : h;
    }), eUn = function(n) {
        var r = A2(wI, ZN(k([
            tUn(n.vd)
        ])), n.kk);
        return r.$ ? b(r.a, !1) : b(r.a.a, !0);
    }, uUn = F2(function(n, r) {
        var t = n ? AI(r.x) : r.x;
        return m(r, {
            kk: eUn(r).a,
            x: t
        });
    }), aUn = F2(function(n, r) {
        var t = jN(r);
        return A3(WI, QSn, VSn(A2(uUn, n, t.vK)), r);
    }), iUn = F3(function(n, r, t) {
        return r ? A2(rUn, n, A2(nUn, n, A2(aUn, n, t))) : A2(Kzn, n, t);
    }), cUn = F2(function(n, r) {
        var t = jN(r);
        return A3(WI, QSn, MSn(A2(ohn, n, t.t2)), r);
    }), oUn = F2(function(n, r) {
        var t = jN(r);
        return A3(WI, QSn, ZSn(A2(Nzn, n, t.wD)), r);
    }), fUn = F2(function(n, r) {
        var t = _gn(r.dw), e = A2(Wzn, n, A2(Vzn, n, A2(Mzn, n, A2(cUn, n, A3(iUn, n, t, A2(Izn, n, A2(oUn, n, r.kk))))))), u = A2(wI, function(n) {
            var r = _gn(n.dw), t = ihn(n.dw);
            return ZN(k([
                pzn,
                Azn,
                izn,
                ozn,
                vzn(r),
                Lzn(n.aY.nK),
                fzn(t),
                xzn,
                tzn,
                szn
            ]));
        }(r), e);
        return u.$ ? b(u.a, !1) : b(u.a.a, !0);
    }), sUn = F2(function(n, r) {
        var t = n ? AI(r.x) : r.x;
        return m(r, {
            kk: A2(fUn, n, r).a,
            x: t
        });
    }), lUn = function(n) {
        switch(n.$){
            case 0:
                return Ht(13);
            case 1:
                return Ht(0);
            case 2:
            case 4:
            case 5:
            case 8:
            case 10:
            case 17:
            case 21:
                return Rt;
            case 3:
                return Ht(1);
            case 6:
                return Ht(14);
            case 7:
                return Ht(3);
            case 9:
                return Ht(4);
            case 11:
                return Ht(5);
            case 12:
                return Ht(2);
            case 13:
                return Ht(15);
            case 14:
                return Ht(10);
            case 15:
                return Ht(11);
            case 16:
                return Ht(12);
            case 18:
                return Ht(6);
            case 19:
                return Ht(7);
            case 20:
                return Ht(8);
            case 22:
                return Ht(9);
            default:
                return Ht(16);
        }
    }, dUn = F2(function(n, r) {
        var t = lUn(n);
        if (t.$) return r;
        var e = t.a;
        return A2(yI, e, r.x) ? m(A2(sUn, !1, r), {
            x: A3(_I, !0, e, r.x)
        }) : r;
    }), bUn = {
        Da: ZK(1500),
        Dz: function(n) {
            return {
                $: 16,
                a: n
            };
        }
    }, vUn = {
        $: 2
    }, mUn = function(n) {
        return {
            $: 0,
            a: n
        };
    }, pUn = {
        $: 1
    }, $Un = F2(function(n, r) {
        var t = A2(bq, n, r.fw), e = t.a, u = t.b, a = t.c, i = function() {
            if (a.$) return b(r.z6, Rt);
            switch(a.a.$){
                case 0:
                    var n = a.a.a;
                    return b(A2(uc, r.z6, n), A2(Cp, mUn, n));
                case 1:
                    return b(r.z6, Ht(pUn));
                default:
                    return b(r.z6, Ht(vUn));
            }
        }(), c = i.b;
        return v(m(r, {
            z6: i.a,
            fw: e
        }), A2(jp, ru, u), c);
    }), hUn = {
        $: 2
    }, gUn = function(n) {
        return {
            $: 0,
            a: n
        };
    }, wUn = {
        $: 1
    }, kUn = function(n) {
        var r = jN(n.kk).fz;
        return A2(uc, "", A2(Cp, n.lc(Rk(0)), r));
    }, xUn = function(n) {
        var r = A3(XI, !0, 0, n.x), t = m(n, {
            x: r
        });
        return A2(ZI, 0, r) ? m(t, {
            kk: Yzn(n).a
        }) : t;
    }, yUn = F2(function(n, r) {
        switch(n.$){
            case 0:
                var t = A2(bq, n.a, r.fP), e = t.a, u = t.b, a = t.c, i = A2(uc, b(r, Rt), A2(Cp, function(n) {
                    switch(n.$){
                        case 0:
                            var t = A3(WI, imn, amn(n.a), r.kk), e = xUn(m(r, {
                                kk: t
                            }));
                            return b(e, Ht(gUn(kUn(e))));
                        case 1:
                            return b(r, Ht(wUn));
                        default:
                            return b(r, Ht(hUn));
                    }
                }, a)), c = i.b;
                return v(m(i.a, {
                    fP: e
                }), A2(jp, Sgn, u), c);
            case 1:
                var o = MDn(n.a);
                return v(f = xUn(m(r, {
                    kk: A3(WI, imn, o, r.kk)
                })), Dp, Ht(gUn(kUn(f))));
            case 2:
                var f;
                return v(f = function() {
                    if (A2(yI, 0, r.x)) {
                        var n = A3(_I, !0, 0, r.x), t = Yzn(r);
                        return m(r, {
                            kk: t.a,
                            x: n
                        });
                    }
                    return r;
                }(), Dp, Ht(hUn));
            default:
                return v(r, Dp, Ht(wUn));
        }
    }), _Un = {
        $: 2
    }, CUn = {
        $: 1
    }, DUn = F2(function(n, r) {
        var t = Ht(0);
        if (t.$) return r;
        var e = t.a, u = A3(XI, !0, e, r.x), a = m(r, {
            x: u
        });
        return A2(ZI, e, u) ? m(a, {
            kk: eUn(r).a
        }) : a;
    }), AUn = F2(function(n, r) {
        var t = A2(bq, n, r.fD), e = t.a, u = t.b, a = t.c, i = A2(uc, b(r, Rt), A2(Cp, function(n) {
            switch(n.$){
                case 0:
                    var t = n.a;
                    return b(A2(DUn, t, m(r, {
                        kk: A3(WI, fmn, t, r.kk)
                    })), A2(Xb, function(n) {
                        return Ht(function(n) {
                            return {
                                $: 0,
                                a: n
                            };
                        }(A2(uc, "", Tbn(n))));
                    }, t));
                case 1:
                    return b(r, Ht(CUn));
                default:
                    return b(r, Ht(_Un));
            }
        }, a)), c = i.b;
        return v(m(i.a, {
            fD: e
        }), A2(jp, ru, u), c);
    }), qUn = {
        $: 2
    }, BUn = {
        $: 1
    }, jUn = F2(function(n, r) {
        var t = Ht(0);
        if (t.$) return r;
        var e = t.a, u = A3(XI, !0, e, r.x), a = m(r, {
            x: u
        });
        return A2(ZI, e, u) ? m(a, {
            kk: Ozn(r).a
        }) : a;
    }), SUn = F2(function(n, r) {
        var t = n, e = jN(r.kk).wD, u = A2(bq, t, r.fN), a = u.a, i = u.b, c = u.c, o = function() {
            if (c.$) return b(e, Rt);
            switch(c.a.$){
                case 0:
                    var n = c.a.a, r = A2(Cp, function(n) {
                        return function(n) {
                            return {
                                $: 0,
                                a: n
                            };
                        }(A2(tdn, Rk(0), n));
                    }, n);
                    return b(n, r);
                case 1:
                    return b(e, Ht(BUn));
                default:
                    return b(e, Ht(qUn));
            }
        }(), f = o.a, s = o.b;
        return v(A2(jUn, f, m(r, {
            kk: A3(WI, dmn, f, r.kk),
            fN: a
        })), A2(jp, ru, i), s);
    }), zUn = F2(function(n, r) {
        var t = lUn(n);
        if (t.$) return r;
        var e = t.a, u = A3(XI, !0, e, r.x), a = m(r, {
            x: u
        });
        return A2(ZI, e, u) ? m(a, {
            kk: A2(fUn, !1, r).a
        }) : a;
    }), UUn = F2(function(n, r) {
        return A2(zUn, n, m(r, {
            kk: A3(WI, QSn, n, r.kk)
        }));
    }), EUn = F2(function(n, r) {
        switch(n.$){
            case 0:
                return v(A2(UUn, t = n.a, r), A2(Eu, ru, gu(USn(t))), Ht(DSn(YSn(t))));
            case 15:
                var t = function(n) {
                    return {
                        $: 21,
                        a: n
                    };
                }(n.a);
                return v(m(r, {
                    kk: A3(WI, QSn, t, r.kk)
                }), Dp, Ht(DSn(YSn(t))));
            case 1:
                var e = n.a, u = jN(r.kk), a = A2(Kpn, e, u.l0), i = a.b, c = a.c, o = _Sn(a.a), f = A2(uc, b(Rt, r), A2(Cp, function(n) {
                    switch(n.$){
                        case 0:
                            var t = n.a;
                            return b(Ht(DSn(YSn(o) + ": " + t)), r);
                        case 1:
                            return t = n.a, b(Ht(ESn(YSn(o) + ": " + t)), r);
                        default:
                            return t = n.a, b(Ht(CSn(YSn(o) + ": " + t)), A2(dUn, o, r));
                    }
                }, c)), s = f.a;
                return v(m(f.b, {
                    kk: A3(WI, QSn, o, r.kk)
                }), A2(jp, wqn, i), s);
            case 2:
                return t = function(n) {
                    return {
                        $: 5,
                        a: n
                    };
                }(n.a), v(m(r, {
                    kk: A3(WI, QSn, t, r.kk)
                }), Dp, Ht(DSn(YSn(t))));
            case 5:
                if (function(n) {
                    switch(n.$){
                        case 1:
                        case 2:
                        case 3:
                        case 7:
                        case 8:
                        case 9:
                        case 11:
                        case 12:
                            return !0;
                        default:
                            return !1;
                    }
                }(t = n.a)) {
                    var l = A3(mQ, bUn, t, r.dD), d = l.b;
                    return v(m(r, {
                        dD: l.a
                    }), d, Rt);
                }
                return v(r, Dp, Rt);
            case 3:
                return v(A2(dUn, t = n.a, r), Dp, Ht(CSn(YSn(t))));
            case 4:
                return v(r, Dp, Ht(ESn(YSn(t = n.a))));
            case 6:
                var p = n.a, $ = jN(r.kk), h = A2(SUn, p, $.wD), g = h.b, w = h.c, x = (o = ZSn(h.a), A2(uc, b(Rt, r), A2(Cp, function(n) {
                    switch(n.$){
                        case 0:
                            return b(Ht(DSn(YSn(o))), r);
                        case 1:
                            return b(Ht(ESn(YSn(o))), r);
                        default:
                            return b(Ht(CSn(YSn(o))), A2(dUn, o, r));
                    }
                }, w)));
                return s = x.a, v(m(x.b, {
                    kk: A3(WI, QSn, o, r.kk)
                }), A2(jp, XSn, g), s);
            case 7:
                var y = n.a, _ = jN(r.kk), C = A2(SUn, y, _.nq), D = C.b, A = C.c, q = (o = ASn(C.a), A2(uc, b(Rt, r), A2(Cp, function(n) {
                    switch(n.$){
                        case 0:
                            return b(Ht(DSn(YSn(o))), r);
                        case 1:
                            return b(Ht(ESn(YSn(o))), r);
                        default:
                            return b(Ht(CSn(YSn(o))), A2(dUn, o, r));
                    }
                }, A)));
                return s = q.a, v(m(q.b, {
                    kk: A3(WI, QSn, o, r.kk)
                }), A2(jp, qSn, D), s);
            case 8:
                var B = n.a, j = jN(r.kk), S = A2(MI, B, j.bg), z = S.b, U = S.c, E = (o = BSn(S.a), A2(uc, b(Rt, r), A2(Cp, function(n) {
                    switch(n.$){
                        case 0:
                            return b(Ht(DSn(YSn(o))), r);
                        case 1:
                            return b(Ht(ESn(YSn(o))), r);
                        default:
                            return b(Ht(CSn(YSn(o))), A2(dUn, o, r));
                    }
                }, U)));
                return s = E.a, v(m(E.b, {
                    kk: A3(WI, QSn, o, r.kk)
                }), Hu(k([
                    A2(jp, jSn, z),
                    A2(Eu, ru, gu(USn(o)))
                ])), s);
            case 9:
                var P = n.a, T = jN(r.kk), F = A2(AUn, P, T.vK), L = F.b, M = F.c, H = (o = VSn(F.a), A2(uc, b(Rt, r), A2(Cp, function(n) {
                    switch(n.$){
                        case 0:
                            return b(Ht(DSn(YSn(o))), r);
                        case 1:
                            return b(Ht(ESn(YSn(o))), r);
                        default:
                            return b(Ht(CSn(YSn(o))), A2(dUn, o, r));
                    }
                }, M)));
                return s = H.a, v(m(H.b, {
                    kk: A3(WI, QSn, o, r.kk)
                }), A2(jp, WSn, L), s);
            case 10:
                var R = n.a, O = jN(r.kk), N = A2(yUn, R, O.qv), I = N.b, V = N.c, W = (o = PSn(N.a), A2(uc, b(Rt, r), A2(Cp, function(n) {
                    switch(n.$){
                        case 0:
                            return b(Ht(DSn(YSn(o))), r);
                        case 1:
                            return b(Ht(ESn(YSn(o))), r);
                        default:
                            return b(Ht(CSn(YSn(o))), A2(dUn, o, r));
                    }
                }, V)));
                return s = W.a, v(m(W.b, {
                    kk: A3(WI, QSn, o, r.kk)
                }), A2(jp, LSn, I), s);
            case 11:
                var Z = n.a, X = jN(r.kk), G = A2(yUn, Z, X.qw), J = G.b, Y = G.c, Q = (o = TSn(G.a), A2(uc, b(Rt, r), A2(Cp, function(n) {
                    switch(n.$){
                        case 0:
                            return b(Ht(DSn(YSn(o))), r);
                        case 1:
                            return b(Ht(ESn(YSn(o))), r);
                        default:
                            return b(Ht(CSn(YSn(o))), A2(dUn, o, r));
                    }
                }, Y)));
                return s = Q.a, v(m(Q.b, {
                    kk: A3(WI, QSn, o, r.kk)
                }), A2(jp, FSn, J), s);
            case 12:
                var K = n.a, nn = jN(r.kk), rn = A2(yUn, K, nn.uC), tn = rn.b, en = rn.c, un = (o = OSn(rn.a), A2(uc, b(Rt, r), A2(Cp, function(n) {
                    switch(n.$){
                        case 0:
                            return b(Ht(DSn(YSn(o))), r);
                        case 1:
                            return b(Ht(ESn(YSn(o))), r);
                        default:
                            return b(Ht(CSn(YSn(o))), A2(dUn, o, r));
                    }
                }, en)));
                return s = un.a, v(m(un.b, {
                    kk: A3(WI, QSn, o, r.kk)
                }), A2(jp, NSn, tn), s);
            case 13:
                var an = n.a, cn = jN(r.kk), on = A2($Un, an, cn.uo), fn = on.b, sn = on.c, ln = (o = function(n) {
                    return {
                        $: 17,
                        a: n
                    };
                }(on.a), A2(uc, b(Rt, r), A2(Cp, function(n) {
                    switch(n.$){
                        case 0:
                            return b(Ht(DSn(YSn(o))), r);
                        case 1:
                            return b(Ht(ESn(YSn(o))), r);
                        default:
                            return b(Ht(CSn(YSn(o))), A2(dUn, o, r));
                    }
                }, sn)));
                return s = ln.a, v(m(ln.b, {
                    kk: A3(WI, QSn, o, r.kk)
                }), A2(jp, RSn, fn), s);
            case 14:
                var dn = n.a, bn = jN(r.kk), vn = A2(R$n, dn, bn.t2), mn = vn.a, pn = vn.b, $n = vn.c, hn = (o = MSn(mn), A2(uc, b(Rt, r), A2(Cp, function(n) {
                    switch(n.$){
                        case 3:
                            return b(Ht(CSn(YSn(o))), A2(dUn, o, r));
                        case 4:
                            return b(Ht(ESn(YSn(o))), r);
                        default:
                            return b(Ht(DSn(YSn(o))), r);
                    }
                }, $n)));
                return s = hn.a, v(m(hn.b, {
                    kk: A3(WI, QSn, MSn(mn), r.kk)
                }), A2(jp, HSn, pn), s);
            case 16:
                var gn = n.a, wn = A4(t1, bUn, KK(JSn), gn, r.dD);
                return d = wn.b, v(m(r, {
                    dD: wn.a
                }), d, Rt);
            case 17:
                return v(r, Dp, Ht(ISn));
            default:
                var kn = n.a, xn = jN(r.kk), yn = A2(Kkn, kn, xn.py), _n = yn.b;
                return v(m(r, {
                    kk: A3(WI, QSn, SSn(yn.a), r.kk)
                }), A2(jp, zSn, _n), Rt);
        }
    }), PUn = function(n) {
        return {
            $: 3,
            a: n
        };
    }, TUn = function(n) {
        return {
            $: 4,
            a: n
        };
    }, FUn = function(n) {
        return {
            $: 5,
            a: n
        };
    }, LUn = function(n) {
        return {
            $: 2,
            a: n
        };
    }, MUn = function(n) {
        return {
            $: 3,
            a: n
        };
    }, HUn = F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    }), RUn = function(n) {
        var r = n.hQ;
        return 3 === r.$ ? r.a : h;
    }, OUn = function(n) {
        return n.eI ? Rt : Ht(n.dx);
    }, NUn = function(n) {
        var r = n.ku;
        return 1 === r.$ ? Ht(r.a.qU) : Rt;
    }, IUn = F2(function(n, r) {
        var t = n.bl, e = v8(n.kR), u = b8(n.kR), a = n.au, i = NUn(a), c = OUn(a), o = function() {
            var n = XAn(a.kb);
            if (1 === n.$) {
                var r = n.a, t = n.b;
                return tI(t) ? b(Rt, Rt) : b(VAn(r), Ht(t));
            }
            return b(Rt, Rt);
        }();
        return m(r, {
            kb: o.a,
            hP: u,
            kw: i,
            sS: c,
            h3: e,
            lj: t,
            xy: o.b
        });
    }), VUn = function(n) {
        var r = IUn(n);
        return A4(uqn, n.gx, $k(n.dw), r, $An);
    }, WUn = F2(function(n, r) {
        var t = b(Tln(n), Tln(r));
        return 1 === t.a.$ ? t.b.$ ? 1 : 2 : 1 === t.b.$ ? 0 : A2(Wu, t.a.a, t.b.a);
    }), ZUn = F2(function(n, r) {
        return A2(uc, !0, A2(Cp, function(n) {
            return !!n.$ || s(n.a, r) > 0;
        }, n.au));
    }), XUn = F2(function(n, r) {
        var t = Tln(r);
        return !!t.$ || A2(ZUn, n, t.a);
    }), GUn = F2(function(n, r) {
        return A2(UL, WUn, A2(Tc, XUn(n.kb), r));
    }), JUn = F2(function(n, r) {
        return A2(zD, function(n) {
            return i(LAn(n), r);
        }, n);
    }), YUn = function(n) {
        var r = n.ku;
        return r.$ ? Ht(r.a.qU) : Rt;
    }, QUn = function(n) {
        var r = b(n.hQ, yvn(n.O));
        if (3 === r.a.$ && r.b) {
            var t = r.a.a, e = YUn(n.au);
            return e.$ ? A2(GUn, n.au, t) : A2(Ep, ru, k([
                A2(JUn, t, e.a)
            ]));
        }
        return h;
    }, KUn = function(n) {
        return n.qU;
    }, nEn = F2(function(n, r) {
        return A2(Tc, function(r) {
            return YS(A2(zD, function(n) {
                return i(KUn(n), LAn(r));
            }, n));
        }, r);
    }), rEn = function(n) {
        return n.hQ;
    }, tEn = F2(function(n, r) {
        return A2(uc, r, A2(Xb, function(n) {
            return ED(n) ? Rt : Ht(A2(nEn, n, r));
        }, A2(Cp, function(n) {
            return rEn(n.uj);
        }, n)));
    }), eEn = F2(function(n, r) {
        return {
            $: 2,
            a: n,
            b: r
        };
    }), uEn = function(n) {
        return {
            $: 1,
            a: n
        };
    }, aEn = F2(function(n, r) {
        return {
            $: 1,
            a: n,
            b: r
        };
    }), iEn = function(n) {
        return {
            $: 2,
            a: n
        };
    }, cEn = F2(function(n, r) {
        return {
            $: 3,
            a: n,
            b: r
        };
    }), oEn = function(n) {
        return m(n, {
            au: Rt
        });
    }, fEn = function(n) {
        return !!n.$ || 2 === n.a.$;
    }, sEn = function(n) {
        return !fEn(n.au);
    }, lEn = eL, dEn = F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    }), bEn = function(n) {
        return {
            $: 0,
            a: n
        };
    }, vEn = F2(function(n, r) {
        return !i(n, r);
    }), mEn = F2(function(n, r) {
        if (n.$) {
            var t = n.a;
            return r.au.$ ? v(r, Dp, Rt) : v(m(r, {
                xy: t
            }), Dp, Ht(function(n) {
                return {
                    $: 1,
                    a: n
                };
            }(t)));
        }
        var e = A2(bq, n.a, r.fx), u = e.b, a = e.c, i = m(r, {
            fx: e.a
        }), c = function() {
            if (a.$ || a.a.$ || a.a.a.$) return b(i, Rt);
            var n = a.a.a.a, r = A2(vEn, i.au, n), t = fEn(n) ? Rt : n, e = m(i, {
                au: t
            });
            return b(e, Ht(A2(dEn, XAn(e), r)));
        }(), o = c.b;
        return v(c.a, A2(jp, bEn, u), o);
    }), pEn = F2(function(n, r) {
        switch(n.$){
            case 0:
                var t = n.a;
                return v(m(r, {
                    dx: t
                }), Dp, Ht(function(n) {
                    return {
                        $: 0,
                        a: n
                    };
                }(t)));
            case 1:
                var e = A2(mEn, n.a, r.kb), u = e.b, a = e.c, c = m(r, {
                    kb: e.a
                }), o = function() {
                    if (a.$) return b(c, Rt);
                    if (a.a.$) {
                        var n = a.a.a;
                        return b(c, Ht(A2(cEn, n, Npn(n))));
                    }
                    var t = a.a, e = t.a, u = t.b, o = function() {
                        var n = r.ku;
                        if (1 === n.$) return !0;
                        var t = n.a, e = Rk(0);
                        return i(e(lEn), e(t));
                    }();
                    return b(m(c, {
                        ku: PAn
                    }), Ht(A2(eEn, e, u || o)));
                }(), f = o.b;
                return v(o.a, A2(jp, uEn, u), f);
            default:
                var s = A2(bq, n.a, r.eW), l = s.b, d = s.c, p = m(r, {
                    eW: s.a
                }), $ = function() {
                    if (d.$ || d.a.$ || d.a.a.$) return b(p, Rt);
                    var n = d.a.a.a, t = sEn(r.kb);
                    return b(m(p, {
                        kb: oEn(r.kb),
                        ku: n
                    }), Ht(A2(aEn, n, t)));
                }(), h = $.b;
                return v($.a, A2(jp, iEn, l), h);
        }
    }), $En = function(n) {
        return b(Dp, Ht(n));
    }, hEn = function(n) {
        return {
            $: 3,
            a: n
        };
    }, gEn = {
        $: 1
    }, wEn = F2(function(n, r) {
        return {
            $: 1,
            a: n,
            b: r
        };
    }), kEn = function(n) {
        return {
            $: 2,
            a: n
        };
    }, xEn = function(n) {
        return {
            $: 0,
            a: n
        };
    }, yEn = F2(function(n, r) {
        switch(n.$){
            case 0:
                var t = n.a, e = Ht(t.$ ? gEn : xEn(t.a));
                return v(m(r, {
                    bv: FAn
                }), Dp, e);
            case 1:
                var u = $ln((c = n.a).uj), a = u.b;
                return v(m(r, {
                    bv: A2(wEn, u.a, c)
                }), A2(jp, kEn, a), Rt);
            case 2:
                a = n.a;
                var i = r.bv;
                if (1 === i.$) {
                    var c = i.b, o = A2(wln, a, i.a), f = o.a, s = o.b, l = o.c, d = function() {
                        switch(l){
                            case 1:
                                return b(FAn, Rt);
                            case 2:
                                return b(FAn, Ht(xEn(c)));
                            default:
                                return b(A2(wEn, f, c), Rt);
                        }
                    }(), p = d.b;
                    return v(m(r, {
                        bv: d.a
                    }), A2(jp, kEn, s), p);
                }
                return v(r, Dp, Rt);
            case 3:
                var $ = A2(bq, n.a, r.ff), h = $.a, g = $.b, w = $.c;
                return e = w.$ || w.a.$ ? Rt : A2(Cp, function(n) {
                    return function(n) {
                        return {
                            $: 2,
                            a: n
                        };
                    }(n);
                }, w.a.a), v(m(r, {
                    ff: h
                }), A2(jp, hEn, g), e);
            case 4:
                return v(1 === n.a ? m(r, {
                    bv: FAn
                }) : r, Dp, Rt);
            default:
                return v(r, Dp, Ht(function(n) {
                    return {
                        $: 3,
                        a: n
                    };
                }(n.a)));
        }
    }), _En = function(n) {
        var r = $k(n.dw), t = n.au, e = function() {
            var n = XAn(t.kb);
            if (1 === n.$) {
                var r = n.b;
                return tI(r) ? Rt : Ht(r);
            }
            return Rt;
        }();
        return A4(KAn, n.gx, r, A2(aqn, n.bl, e), pAn);
    }, CEn = F2(function(n, r) {
        switch(n.$){
            case 0:
                var t = n.a, e = m(r, {
                    cI: t
                });
                switch(t.$){
                    case 3:
                        var u = t.a, a = A2(uc, 0, A2(Xb, lu, A2(Zu, "x-total-count", t.b))), i = yvn(r.P) && 1 === oe(u) && $H(r.le) ? A2(Cp, Hjn, Gb(u)) : r.le;
                        return v(m(r, {
                            kR: A2(_8, a, r.kR),
                            cI: t,
                            le: i
                        }), Dp, Rt);
                    case 2:
                        return v(e, Dp, Ht(PUn(tA(t.a))));
                    default:
                        return v(e, Dp, Rt);
                }
            case 1:
                return v(D = m(r, {
                    kR: A2(y8, f = n.a, r.kR)
                }), VUn(D), Rt);
            case 2:
                var c = n.a;
                switch(e = m(r, {
                    hQ: c
                }), c.$){
                    case 3:
                        var o = c.a;
                        return v(m(e, {
                            ld: kAn(r.O) && 1 === oe(o) && $H(r.ld) ? A2(Cp, LAn, Gb(o)) : r.ld
                        }), Dp, Rt);
                    case 2:
                        return v(e, Dp, Ht(PUn(tA(c.a))));
                    default:
                        return v(e, Dp, Rt);
                }
            case 3:
                var f = n.a, s = r.fC;
                if (s.$) return v(r, Dp, Rt);
                var l = A2(yEn, f, s.a), d = l.b, p = l.c, $ = m(r, {
                    eC: h,
                    fC: wAn(l.a)
                }), g = function() {
                    if (p.$) return b($, Rt);
                    switch(p.a.$){
                        case 0:
                            var n = p.a.a, t = function() {
                                if (yvn(r.O)) {
                                    var t = YUn(r.au);
                                    if (t.$) {
                                        var e = A2(tEn, Ht(n), QUn(r));
                                        return 1 === oe(e) ? Gb(e) : Rt;
                                    }
                                    var u = t.a;
                                    return A2(JUn, RUn(r), u);
                                }
                                return Rt;
                            }();
                            return b(m($, {
                                eC: h,
                                ld: A2(Cp, LAn, t),
                                le: Ht(Hjn(n.uj))
                            }), Ht(A2(HUn, n.uj, t)));
                        case 1:
                            return t = function() {
                                if (yvn(r.O)) {
                                    var n = QUn(r);
                                    return 1 === oe(n) ? Gb(n) : Rt;
                                }
                                return Rt;
                            }(), b(m($, {
                                eC: h,
                                ld: A2(Cp, LAn, t),
                                le: Rt
                            }), Ht(function(n) {
                                return {
                                    $: 1,
                                    a: n
                                };
                            }(t)));
                        case 2:
                            return b(m($, {
                                eC: h,
                                ld: Ht(LAn(t = p.a.a))
                            }), Ht(LUn(t)));
                        default:
                            return b($, Rt);
                    }
                }(), w = g.b;
                return v(g.a, A2(jp, MUn, d), w);
            case 5:
                var x = $En(f = n.a), y = x.a, _ = x.b, C = function() {
                    if (_.$) return b(r.ld, Rt);
                    var n = _.a;
                    return b(Ht(LAn(n)), Ht(LUn(n)));
                }();
                return w = C.b, v(m(r, {
                    eC: h,
                    ld: C.a
                }), A2(jp, FUn, y), w);
            default:
                var D, A = A2(pEn, f = n.a, r.au), q = A.b, B = A.c, j = m(r, {
                    au: A.a
                }), S = function() {
                    if (B.$) return b(j, Dp);
                    var n = B.a;
                    switch(n.$){
                        case 1:
                        default:
                            return b(r = m(j, {
                                kR: l8
                            }), VUn(r));
                        case 2:
                            return n.b ? b(r = m(j, {
                                kR: l8
                            }), VUn(r)) : b(j, Dp);
                        case 3:
                            var r;
                            return n.b ? b(r = m(j, {
                                kR: l8
                            }), Hu(k([
                                VUn(r),
                                _En(r)
                            ]))) : b(j, Dp);
                    }
                }(), z = S.b;
                return v(D = S.a, Hu(k([
                    A2(jp, TUn, q),
                    z
                ])), Rt);
        }
    }), DEn = F2(function(n, r) {
        var t = n;
        return v(m(r, {
            w4: t
        }), Dp, Ht(t));
    }), AEn = function(n) {
        return !Kvn(A2(Y$n, function(n) {
            return !_4(n.b);
        }, n.ac));
    }, qEn = Jn("scrollIdIntoView", mk), BEn = F2(function(n, r) {
        return oe(A2(iW, r, n)) > 0;
    }), jEn = F2(function(n, r) {
        return Ht(A2(pDn, n, r));
    }), SEn = function(n) {
        var r = A2(fUn, !1, n);
        if (r.b) return Rt;
        var t = r.a;
        return A2(Xb, jEn(n.qU), Gb(A2(Tc, BEn(t), bAn)));
    }, zEn = function(n) {
        return A2(fUn, !1, n).b;
    }, UEn = F3(function(n, r, t) {
        return A2(t.xR, n, r);
    }), EEn = F2(function(n, r) {
        return sEn(n) ? A2(Tc, function(r) {
            var t = A2(Xb, Tln, r.ku);
            return !!t.$ || A2(ZUn, n, t.a);
        }, r) : r;
    }), PEn = F2(function(n, r) {
        return A2(Wu, hH(n.uj), hH(r.uj));
    }), TEn = function(n) {
        return n.ty;
    }, FEn = function(n) {
        return n.wj;
    }, LEn = F2(function(n, r) {
        var t = function(n) {
            return "full_waitlisting" === n ? 1 : 0;
        }, e = A2(Wu, t(FEn(n.uj)), t(FEn(r.uj)));
        if (1 === e) {
            var u = A2(Wu, TEn(n.uj), TEn(r.uj));
            return 1 === u ? A2(PEn, n, r) : u;
        }
        return e;
    }), MEn = F3(function(n, r, t) {
        var e = rEn(t), u = ED(e) ? A2(yu, LAn, r) : A2(yu, KUn, e);
        return YS(A2(zD, function(r) {
            return i(r, n);
        }, u));
    }), HEn = F3(function(n, r, t) {
        if (1 === r.$) {
            var e = r.a;
            return A2(UL, LEn, A2(Tc, function(r) {
                return A3(MEn, e.qU, n, r.uj);
            }, t));
        }
        return t;
    }), REn = F2(function(n, r) {
        return A2(uu, OB(n), OB(r));
    }), OEn = F2(function(n, r) {
        return tI(n) ? r : A2(Tc, function(r) {
            return A2(REn, n, hH(r));
        }, r);
    }), NEn = F2(function(n, r) {
        return ED(n) ? r : A2(Tc, function(r) {
            var t = rEn(r);
            return 0 >= oe(t) || !ED(A2(nEn, t, n));
        }, r);
    }), IEn = F2(function(n, r) {
        return Gb(A2(UL, WUn, A2(Tc, function(t) {
            return A3(MEn, LAn(t), n, r);
        }, n)));
    }), VEn = F3(function(n, r, t) {
        return {
            ku: function() {
                if (sEn(n.kb)) return A2(IEn, r, t);
                var e = n.ku;
                if (1 === e.$) {
                    var u = e.a;
                    return A2(zD, function(n) {
                        return i(LAn(n), u.qU);
                    }, r);
                }
                return Rt;
            }(),
            uj: t
        };
    }), WEn = F3(function(n, r, t) {
        return A3(HEn, r, n.ku, A2(EEn, n.kb, A2(yu, A2(VEn, n, r), A2(OEn, n.dx, A2(NEn, r, t)))));
    }), ZEn = function(n) {
        var r, t = n.cI;
        if (3 === t.$) {
            var e = t.a, u = n.P;
            if (xAn(u) || yvn(u)) {
                var a = 3 === (r = n.hQ).$ ? r.a : h;
                return A3(WEn, n.au, a, e);
            }
            return h;
        }
        return h;
    }, XEn = F2(function(n, r) {
        return A2(zD, function(n) {
            return i(Hjn(n.uj), r);
        }, n);
    }), GEn = F2(function(n, r) {
        switch(r.qU){
            case 0:
                return function(n) {
                    var r, t = A2(sUn, !0, n.U), e = m(n, {
                        eC: A3(DBn, n.g0, n.Ay, n.U),
                        ht: !0,
                        U: t
                    });
                    return zEn(t) && ED(e.eC) ? v(e, Dp, !0) : v(e, (r = SEn(t)).$ ? Dp : qEn(r.a), !1);
                }(n);
            case 1:
                return function(n) {
                    var r = A2(zqn, n.dw, n.Ay) ? A2(iSn, !0, n.ar) : b(n.ar, !0), t = r.b;
                    return v(m(n, {
                        ar: r.a
                    }), Dp, t);
                }(n);
            case 2:
                return function(n) {
                    var r = function(n) {
                        var r, t, e = m(n, {
                            ld: (r = v(cqn(n.P), $H(n.le), YUn(n.au))).a && r.b && !r.c.$ ? Ht(r.c.a) : n.ld
                        }), u = (t = b(function(n) {
                            if (yAn(n.P)) {
                                var r = n.le;
                                if (r.$) return cqn(n.P);
                                var t = r.a;
                                return YS(A2(XEn, ZEn(n), t));
                            }
                            return !0;
                        }(e), function(n) {
                            if (kAn(n.O)) {
                                var r = n.ld;
                                if (r.$) return !1;
                                var t = r.a;
                                return YS(A2(JUn, QUn(n), t));
                            }
                            return !0;
                        }(e)), t.a ? t.b ? h : k([
                            A2(XN, YN, iL)
                        ]) : k(t.b ? [
                            A2(XN, YN, gdn)
                        ] : [
                            A2(XN, function(n) {
                                return A2(XN, function(r) {
                                    return A2(XN, YN, A2(UEn, n, r));
                                }, iL);
                            }, gdn)
                        ]));
                        return b(m(e, {
                            eC: u
                        }), u);
                    }(n.aC), t = r.b;
                    return v(m(n, {
                        eC: t,
                        aC: r.a
                    }), Dp, ED(t));
                }(n);
            default:
                return function(n) {
                    return v(m(n, {
                        hA: !0
                    }), Dp, AEn(n.aW));
                }(n);
        }
    }), JEn = F2(function(n, r) {
        return A2(W3, r.a, A2(yu, function(r) {
            return b(r.a, n(r.b));
        }, r.b));
    }), YEn = F2(function(n, r) {
        return m(r, {
            bh: Ht(n)
        });
    }), QEn = F2(function(n, r) {
        var t = n;
        return m(r, {
            ac: A2(JEn, function(n) {
                return A2(YEn, t, n);
            }, r.ac)
        });
    }), KEn = function(n) {
        return {
            $: 0,
            a: n
        };
    }, nPn = F2(function(n, r) {
        var t = Ht(KEn(r));
        return m(n, {
            kk: A3(WI, Yjn, t, n.kk)
        });
    }), rPn = function(n) {
        return n.lz;
    }, tPn = function(n) {
        return n.ow;
    }, ePn = function(n) {
        return n.qU;
    }, uPn = function(n) {
        return n.sS;
    }, aPn = function(n) {
        return n.vd;
    }, iPn = F3(function(n, r, t) {
        var e, u = uan(t.tE), a = {
            ly: (e = t, e.ly),
            lz: rPn(t),
            o8: ePn(t),
            ey: tPn(t),
            eL: aPn(t),
            sS: uPn(t),
            kU: u
        };
        return A3(N6, n, r, a);
    }), cPn = F2(function(n, r) {
        return m(r, {
            ac: M6(A2(yu, A2(iPn, r.gx, r.BW), n))
        });
    }), oPn = F2(function(n, r) {
        switch(n.$){
            case 0:
                var t = n.a;
                if (3 === t.$) {
                    var e = t.a;
                    if (function(n) {
                        return (function(n) {
                            return 2 === HCn(n);
                        }(n) || function(n) {
                            return 1 === HCn(n);
                        }(n)) && !V_n(n);
                    }(e)) {
                        var u = (tn = function(n) {
                            return ejn(n).a.rp;
                        }(e), tn.$ ? r.ar : A2(nPn, r.ar, tn.a));
                        return v(l = m(r, {
                            ar: u,
                            Ay: Ht(e)
                        }), function(n) {
                            return A3(ebn, n.gx, $k(n.dw), YBn);
                        }(l), h);
                    }
                    return v(r, ojn(e), h);
                }
                return v(r, Dp, A2(uA, 0, t));
            case 1:
                var a = n.a;
                if (3 === a.$) {
                    var c = function(n) {
                        return {
                            cw: njn(n),
                            x: A2(jO, k([
                                0
                            ]), JCn)
                        };
                    }(qqn(F = a.a)), o = A4(bqn, r.gx, Rk(r.kj), r.dw, Zjn(F)), f = o.a, s = o.b, l = m(r, {
                        j2: Ht(A4(Iqn, Ht(F), r.dw, r.Ay, 0)),
                        bM: AO(c),
                        U: A3(mAn, mqn, r.dw, cjn(F)),
                        aC: f,
                        fF: Ht(F),
                        bB: vqn
                    }), d = A8(JBn, l.gx, l.dw, l.g0, l.Ay, l.U, l.bB, F, yqn);
                    return v(l, Hu($(A2(yu, jp(_qn), s), k([
                        d
                    ]))), h);
                }
                return v(r, Dp, A2(uA, 0, a));
            case 2:
                var p = A2(EUn, n.a, r.U), g = p.a, w = p.b, x = (K = b(r.ht, p.c)).a && !K.b.$ && 3 === K.b.a.$ ? A3(DBn, r.g0, r.Ay, r.U) : r.eC;
                return v(l = m(r, {
                    eC: x,
                    U: g
                }), A2(jp, gqn, w), h);
            case 9:
                var y = A2(CEn, n.a, r.aC), _ = y.b;
                return v(m(r, {
                    aC: y.a
                }), A2(jp, _qn, _), h);
            case 3:
                var C = (rn = r.Ay).$ ? Dp : ojn(rn.a);
                return v(r, C, h);
            case 4:
                return v(l = m(r, {
                    g0: Ht(A2(cp, nG, n.a))
                }), Dp, h);
            case 5:
                var D = n.a;
                if (3 === D.$) {
                    var A = D.a, q = k([
                        A2(nA, 3, Id.lP)
                    ]), B = A2(uc, "", A.BK), j = A2(zx, oa, (nn = r.Ay).$ ? ja : Sa({
                        qU: a_n(nn.a)
                    }));
                    return v(r, Hu(k([
                        j,
                        A2(ajn, A2(uc, "", A2(Cp, a_n, r.Ay)), B)
                    ])), q);
                }
                return v(m(r, {
                    uA: !1
                }), Dp, A2(uA, 0, D));
            case 6:
                var S = n.a;
                return 3 === S.$ ? v(m(r, {
                    hB: Ht(S.a)
                }), Dp, h) : v(r, Dp, A2(uA, 0, S));
            case 7:
                var z = A2(tjn, n.a.kn, A3(Vqn, r.fF, r.dw, r.Ay));
                return v(z.$ ? r : m(r, {
                    j2: Ht(z.a),
                    eC: h
                }), Dp, h);
            case 8:
                var U = function(n) {
                    var r = n.j2;
                    return r.$ ? v(n, Dp, !1) : A2(GEn, n, r.a);
                }(r), E = U.a, P = U.b, T = v(U.c, E.fF, E.j2);
                if (!T.a || T.b.$ || T.c.$) return v(E, P, h);
                var F = T.b.a, L = T.c.a.kn + 1;
                if (i(L, oe(A3(Rqn, E.fF, E.dw, E.Ay)))) return function(n) {
                    var r = n.Ay;
                    if (r.$) return v(n, Dp, h);
                    var t = r.a, e = $k(n.dw), u = a_n(t), a = A2(Ljn, n, A2(qjn, n.aW, A4(Ojn, zBn(n.bB), n.fF, n.Ay, A2(Ujn, n.ar, A2(Rjn, Vjn(n.aC), A2(Mjn, Njn(n.aC), Djn(n.U)))))));
                    return v(m(n, {
                        uA: !0
                    }), A5(vjn, n.gx, e, u, a, fjn), h);
                }(E);
                var M = A2(tjn, L, A3(Vqn, E.fF, E.dw, E.Ay));
                if (M.$) return v(E, Dp, h);
                var H = M.a, R = (l = m(E, {
                    j2: Ht(H),
                    eC: h
                }), function() {
                    var n = b(H.qU, r.Ay);
                    if (3 !== n.a || n.b.$) return Dp;
                    var t = n.b.a, e = Ox(ejn(t)), u = A2(Cp, LAn, Njn(r.aC));
                    return A5(rBn, l.gx, $k(l.dw), PBn(t), e, u);
                }());
                return v(l, Hu(k([
                    Wjn(Xjn),
                    A8(JBn, l.gx, l.dw, l.g0, l.Ay, l.U, l.bB, F, yqn),
                    R
                ])), h);
            case 10:
                var O = A2(fSn, n.a, r.ar);
                return _ = O.b, v(m(r, {
                    ar: O.a
                }), A2(jp, ZCn, _), h);
            case 11:
                var N = A2(DEn, n.a, r.bB);
                return _ = N.b, v(m(r, {
                    bB: N.a
                }), A2(jp, Cqn, _), h);
            case 12:
                var I = n.a;
                if (l = m(r, {
                    ac: I
                }), 3 === I.$) {
                    var V = I.a;
                    return v(m(l, {
                        aW: A2(QEn, tBn(r.U), A2(cPn, V, l.aW))
                    }), Dp, h);
                }
                return v(l, Dp, A2(uA, 0, I));
            case 13:
                var W = A2(U6, n.a, r.aW);
                return R = W.b, v(m(r, {
                    aW: W.a
                }), A2(jp, WCn, R), h);
            default:
                var Z = n.a, X = n.b, G = jN(r.bM).cw, J = A2(ySn, X, Z), Y = J.a, Q = J.b;
                return v(l = m(r, {
                    bM: A3(WI, rjn, A3(J9, function(n) {
                        return i(ujn(n), ujn(Y));
                    }, function() {
                        return Y;
                    }, G), r.bM)
                }), A2(jp, xqn(Y), Q), h);
        }
        var K, nn, rn, tn;
    }), fPn = F2(function(n, r) {
        return A2(Ik, h, k([
            A2(Gk, k([
                Nk("text-support")
            ]), k([
                A2(fF, k([
                    Nk("link"),
                    vF(Sx(ja))
                ]), k([
                    ad(n(Vd.Dq))
                ]))
            ])),
            A2(Gk, k([
                Nk("mx-3 text-support")
            ]), k([
                ad("/")
            ])),
            A2(Gk, k([
                Nk("text-support")
            ]), k([
                A2(fF, k([
                    Nk("link text-current"),
                    vF(Sx(Sa({
                        qU: a_n(r)
                    })))
                ]), k([
                    ad(R_n(r))
                ]))
            ])),
            A2(Gk, k([
                Nk("mx-3 text-support")
            ]), k([
                ad("/")
            ])),
            ad(n(Id.lN))
        ]));
    }), sPn = {
        $: 3
    }, lPn = {
        $: 8
    }, dPn = function(n) {
        return {
            $: 1,
            a: n
        };
    }, bPn = function(n) {
        return {
            $: 2,
            a: n
        };
    }, vPn = F2(function(n, r) {
        return A2(Ik, k([
            Nk("mx-1 mt-8")
        ]), k([
            A2(px, WCn, A3(N4, n, k([
                dPn(r.uA),
                bPn(r.hA)
            ]), r.aW))
        ]));
    }), mPn = function(n) {
        return n.mQ;
    }, pPn = function(n) {
        return n.kN;
    }, $Pn = A2(TS, PS(1), Ht(4)), hPn = TL(2), gPn = TL(0), wPn = jB(0), kPn = F7(function(n, r, t, e, u, a, i) {
        var c = t ? mx : hx, o = a ? k([
            wan
        ]) : h, f = t && a ? k([
            Nk("text-primary-500")
        ]) : h, s = i ? A2(Ik, h, k([
            A2(vgn, n(kd), A2(Ik, h, k([
                ad(" + " + n(md)),
                A2(US, k([
                    wPn
                ]), 4)
            ])))
        ])) : Sq;
        return A2(Ik, A2(Ot, Nk("flex "), cx(u)), function() {
            var t, u = (t = A2(ae, ".", A3($B, !1, !1, r))).b && t.b.b && !t.b.b.b ? Ht(b(t.a, t.b.a)) : Rt;
            if (u.$) return k([
                Sq
            ]);
            var a = u.a, i = a.a, l = a.b;
            return k([
                A2(c, k([
                    bz(gPn),
                    Qk(A2(Ot, Nk("quote-info__rate--sign"), f)),
                    jX
                ]), k([
                    ad("$")
                ])),
                A2(c, A2(Ot, Qk(A2(Ot, Nk("quote-info__rate--dollars"), f)), A2(Ot, jX, o)), k([
                    ad(i)
                ])),
                A2(c, k([
                    bz(gPn),
                    Qk(A2(Ot, Nk("quote-info__rate--cents"), f)),
                    jX
                ]), k([
                    ad("." + l)
                ])),
                function() {
                    if (e.$) return Sq;
                    var r = e.a;
                    return A2(hx, k([
                        bz(hPn),
                        Qk(k([
                            Nk("quote-info__rate--period")
                        ])),
                        jX
                    ]), k([
                        ad(A2(yB, n, r)),
                        s
                    ]));
                }()
            ]);
        }());
    }), xPn = F2(function(n, r) {
        if (r.$) return Sq;
        var t = r.a, e = Ht(mPn(t)), u = pPn(t);
        return A2(Ik, A2(Ot, Nk("flex flex-col"), fx($Pn)), k([
            A2(hx, k([
                zV,
                LS(FS)
            ]), k([
                ad("Current recurring bill")
            ])),
            A7(kPn, n, u, !0, e, J1, !0, !1)
        ]));
    }), yPn = F5(function(n, r, t, e, u) {
        var a = b(r, A3(ABn, t, e, u));
        if (!a.a.$ && a.b) {
            var i = a.a.a, c = Ht(mPn(i)), o = pPn(i);
            return A2(Ik, A2(Ot, Nk("flex flex-col"), fx($Pn)), k([
                A2(hx, k([
                    zV,
                    LS(FS)
                ]), k([
                    ad("New recurring bill")
                ])),
                A7(kPn, n, o, !1, c, J1, !1, !1)
            ]));
        }
        return Sq;
    }), _Pn = function(n) {
        return n.mE;
    }, CPn = function(n) {
        var r = A2(Xb, _Pn, n);
        if (r.$) return Sq;
        var t = r.a;
        return A2(vgn, "Please contact the practice to start this patient sooner", A2(Ik, A2(Ot, Nk("flex flex-col"), fx($Pn)), k([
            A2(hx, k([
                zV,
                LS(FS)
            ]), k([
                ad("Start Date")
            ])),
            ad(A2(dP, AA("/"), t))
        ])));
    }, DPn = F2(function(n, r) {
        return A2(Ik, A2(Ot, Nk("flex"), fx(Htn)), k([
            A2(xPn, n, r.hB),
            A5(yPn, n, r.fl, r.g0, r.Ay, r.U),
            CPn(r.Ay)
        ]));
    }), APn = F2(function(n, r) {
        return A2(Ik, h, 3 === r.ac.$ ? k([
            A2(px, hu, A2(DPn, n, r)),
            A2(vPn, n, r),
            A2(Ik, k([
                Nk("text-right mt-6")
            ]), k([
                A2(fz, k([
                    CU,
                    ksn(!0),
                    QS(sPn),
                    ZS(r.uA)
                ]), k([
                    ad(n(a2))
                ])),
                A2(fz, k([
                    nz,
                    ksn(!0),
                    QS(lPn),
                    ZS(r.uA)
                ]), k([
                    ad(n(Id.lN))
                ]))
            ]))
        ]) : Yk);
    }), qPn = function(n) {
        return {
            $: 1,
            a: n
        };
    }, BPn = function(n) {
        return n.qj;
    }, jPn = {
        yR: !1,
        iL: !1
    }, SPn = F2(function(n, r) {
        return m(r, n.$ ? {
            iL: n.a
        } : {
            yR: n.a
        });
    }), zPn = function(n) {
        return n.vd;
    }, UPn = function(n) {
        return n.rm;
    }, EPn = function(n) {
        return A2(uc, h, A2(Xb, function(n) {
            return 2 === n.$ ? Ht(n.a) : Rt;
        }, n));
    }, PPn = function(n) {
        return n.wD;
    }, TPn = function(n) {
        return JN(YN(PPn(n)));
    }, FPn = function(n) {
        return A2(uc, "", A2(Xb, function(n) {
            return 1 === n.$ ? Ht(n.a) : Rt;
        }, n));
    }, LPn = F2(function(n, r) {
        if (!zPn(r)) return Rt;
        var t = A2(bSn, n, r);
        switch(UPn(r)){
            case 2:
                return Rt;
            case 0:
                return t.$ || fu(FPn(Ht(t.a.ml))) ? Ht(TPn(r)) : Rt;
            default:
                if (t.$) return Ht(TPn(r));
                var e = EPn(Ht(t.a.ml)), u = A2(W$n, function(n) {
                    return tI(n);
                }, e);
                return ED(e) || u ? Ht(TPn(r)) : Rt;
        }
    }), MPn = function(n) {
        var r = function(n) {
            return n.oV;
        }(n);
        if (r.$) return Sq;
        var t = r.a;
        return A2(hx, k([
            LS(FS)
        ]), k([
            ad(t)
        ]));
    }, HPn = function(n) {
        var r = function(n) {
            return n.qL;
        }(n);
        if (r.$) return Sq;
        var t = r.a;
        return A2(hx, k([
            EB,
            BB,
            LS(Sdn)
        ]), k([
            ad(t)
        ]));
    }, RPn = F2(function(n, r) {
        return {
            $: 4,
            a: n,
            b: r
        };
    }), OPn = F3(function(n, r, t) {
        var e = function(n) {
            return A2(uc, !1, A2(Xb, function(n) {
                return n.$ ? Rt : Ht(n.a);
            }, n));
        }(r);
        return A2(lV, k([
            dV(NZ),
            jV(k([
                Nk("row--tweak")
            ]))
        ]), k([
            A2(iV, k([
                UZ(6),
                dV(Fhn)
            ]), k([
                A2(IU, k([
                    SU,
                    ZU(A2(sc, RPn(t), rm(!1))),
                    rwn(!e),
                    uE(Pjn(!e)),
                    twn(n)
                ]), k([
                    ad("No")
                ]))
            ])),
            A2(iV, k([
                UZ(6)
            ]), k([
                A2(IU, k([
                    SU,
                    ZU(A2(sc, RPn(t), rm(!0))),
                    rwn(e),
                    uE(Pjn(e)),
                    twn(n)
                ]), k([
                    ad("Yes")
                ]))
            ]))
        ]));
    }), NPn = function(n) {
        return {
            $: 5,
            a: n
        };
    }, IPn = function(n) {
        return {
            $: 6,
            a: n
        };
    }, VPn = function(n) {
        return {
            $: 2,
            a: n
        };
    }, WPn = function(n) {
        return {
            $: 3,
            a: n
        };
    }, ZPn = F3(function(n, r, t) {
        return {
            $: 1,
            a: n,
            b: r,
            c: t
        };
    }), XPn = F4(function(n, r, t, e) {
        var u = lSn(e) + "-" + ee(t);
        return A2(Ik, k([
            Nk("mb-2 sm:mb-3")
        ]), k([
            yP(k([
                kZ(u),
                bP(r),
                xZ(A2(ZPn, e, t)),
                sP(n),
                lZ(VPn(e)),
                dZ(WPn(e))
            ]))
        ]));
    }), GPn = F3(function(n, r, t) {
        var e = EPn(r);
        return A2(Ik, h, $(A2(be, F2(function(r, e) {
            return A4(XPn, n, e, r, t);
        }), e), k([
            A2(fz, k([
                nz,
                QS(NPn(t))
            ]), k([
                ad("Add condition")
            ])),
            A2(fz, k([
                CU,
                QS(IPn(t))
            ]), k([
                ad("Remove condition")
            ]))
        ])));
    }), JPn = F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    }), YPn = F3(function(n, r, t) {
        return yP(k([
            kZ(lSn(t)),
            bP(FPn(r)),
            xZ(JPn(t)),
            sP(n),
            lZ(VPn(t)),
            dZ(WPn(t))
        ]));
    }), QPn = F3(function(n, r, t) {
        var e = A2(Cp, function(n) {
            return n.ml;
        }, Gb(A2(Tc, function(n) {
            return i(n.df, lSn(t));
        }, r)));
        switch(UPn(t)){
            case 2:
                return A3(OPn, n, e, t);
            case 0:
                return A3(YPn, n, e, t);
            default:
                return A3(GPn, n, e, t);
        }
    }), KPn = F5(function(n, r, t, e, u) {
        var a, i = (a = b(t, A2(LPn, e, u))).a && !a.b.$ ? k([
            a.b.a
        ]) : h;
        return A2(Ik, k([
            Nk("mb-6")
        ]), k([
            A2(AW, k([
                bW(PPn(u)),
                hW(zPn(u))
            ]), k([
                MPn(u),
                A3(QPn, r, e, u),
                HPn(u),
                A2(OW, n, i)
            ]))
        ]));
    }), nTn = F3(function(n, r, t) {
        var e = A3(ce, SPn, jPn, r);
        return A2(Ik, k([
            jz(QBn(t.ag)),
            Nk("form-input w-full mb-4 md:mb-6")
        ]), k([
            A2(Ik, h, A2(yu, A4(KPn, n, e.yR, e.iL, t.S), BPn(t.ag)))
        ]));
    }), rTn = F3(function(n, r, t) {
        return b(ujn(t), A2(px, xqn(t), A3(nTn, n, k([
            qPn(r)
        ]), t)));
    }), tTn = F2(function(n, r) {
        var t = r.fF;
        if (t.$) return Sq;
        if (Bqn(t.a)) {
            var e = jN(r.bM), u = e.cw, a = A2(ZI, 0, e.x);
            return A3($U, "div", k([
                jz("custom-forms"),
                Nk("mt-6")
            ]), A2(yu, A2(rTn, n, a), u));
        }
        return Sq;
    }), eTn = function(n) {
        return {
            $: 3,
            a: n
        };
    }, uTn = function(n) {
        return {
            $: 2,
            a: n
        };
    }, aTn = function(n) {
        return {
            $: 4,
            a: n
        };
    }, iTn = F3(function(n, r, t) {
        return A2(ZI, t, r) ? A2(iW, t, n) : h;
    }), cTn = F3(function(n, r, t) {
        return A2(ZI, t, r) && A2(kW, t, n);
    }), oTn = F2(function(n, r) {
        var t = jN(r.kk).bP;
        if (t.$) return Sq;
        var e = t.a;
        if (e.$) {
            var u = e.a;
            return A2(lV, k([
                jV(k([
                    Nk("-mx-1")
                ]))
            ]), k([
                A2(iV, h, k([
                    A2(AW, k([
                        bW(n(rSn))
                    ]), k([
                        yP(k([
                            bP(u),
                            xZ(aTn),
                            oZ(A3(cTn, r.kk, r.x, 0)),
                            lZ(eTn(t)),
                            dZ(uTn(t))
                        ]))
                    ])),
                    A2(OW, n, A3(iTn, r.kk, r.x, 0))
                ]))
            ]));
        }
        return Sq;
    }), fTn = F2(function(n, r) {
        return A3(iTn, n.kk, n.x, r);
    }), sTn = F2(function(n, r) {
        var t = function() {
            var t = r.hJ;
            if (3 === t.$) {
                var e = $(A2(yu, function(n) {
                    return A2(Xz, h, KEn(n));
                }, t.a), k([
                    A2(Xz, h, Jjn(""))
                ])), u = n(tSn), a = A2(Ot, lwn(Sjn(r)), A2(Ot, awn(A3(cTn, r.kk, r.x, 1)), A2(Ot, function(n) {
                    return {
                        $: 2,
                        a: n
                    };
                }(!1), A2(Ot, cwn(u), r.fu ? k([
                    iwn(!0)
                ]) : h)))), i = ED(e) ? n(eSn) : u;
                return b(a, $(e, k([
                    fwn(i)
                ])));
            }
            return b(k([
                cwn(n(Kjn)),
                iwn(!0)
            ]), h);
        }(), e = t.a, u = t.b;
        return A2(Ik, k([
            Nk("mb-6")
        ]), k([
            A2(px, Gjn, A4(Bwn, n, e, u, r.eN)),
            A2(OW, n, A2(fTn, r, 1))
        ]));
    }), lTn = F2(function(n, r) {
        var t, e = jN(r.kk).bP;
        return A2(Ik, k([
            jz(oDn)
        ]), k([
            A2(AW, k([
                bW(n(Qjn))
            ]), k([
                A2(hx, k([
                    LS(FS),
                    BB
                ]), k([
                    ad(n(tSn))
                ])),
                A2(sTn, n, r),
                A2(IZ, (t = e, !t.$ && !!t.a.$), A2(oTn, n, r))
            ]))
        ]));
    }), dTn = F2(function(n, r) {
        return A2(zqn, r.dw, r.Ay) ? A2(Ik, k([
            Nk("mt-6")
        ]), k([
            A2(px, ZCn, A2(lTn, n, r.ar))
        ])) : Sq;
    }), bTn = function(n) {
        return n.sW;
    }, vTn = F2(function(n, r) {
        return A2(Ik, k([
            Nk("text-right mt-6")
        ]), k([
            A2(fz, k([
                CU,
                ksn(!0),
                QS(sPn),
                ZS(r.uA)
            ]), k([
                ad(n(a2))
            ])),
            A2(fz, k([
                nz,
                ksn(!0),
                QS(lPn),
                ZS(r.uA)
            ]), k([
                ad(n(bTn))
            ]))
        ]));
    }), mTn = function(n) {
        return n.jy.yY;
    }, pTn = function(n) {
        return n.jy.wD;
    }, $Tn = function(n) {
        return n.jy.w4;
    }, hTn = F3(function(n, r, t) {
        return A2(Ik, k([
            jz("tobacco-use")
        ]), k([
            A2(AW, k([
                bW(n(pTn)),
                hW(!0)
            ]), k([
                A2(lV, k([
                    dV(NZ),
                    jV(k([
                        Nk("row--tweak")
                    ]))
                ]), k([
                    A2(iV, k([
                        UZ(6),
                        dV(Fhn)
                    ]), k([
                        A2(IU, k([
                            SU,
                            ZU(A2(sc, ru, rm(!1))),
                            rwn(!t.w4),
                            uE(Pjn(!t.w4)),
                            twn(r)
                        ]), k([
                            ad(n(mTn))
                        ]))
                    ])),
                    A2(iV, k([
                        UZ(6)
                    ]), k([
                        A2(IU, k([
                            SU,
                            ZU(A2(sc, ru, rm(!0))),
                            rwn(t.w4),
                            uE(Pjn(t.w4)),
                            twn(r)
                        ]), k([
                            ad(n($Tn))
                        ]))
                    ]))
                ]))
            ]))
        ]));
    }), gTn = F2(function(n, r) {
        var t = r.fF;
        return t.$ ? Sq : Uqn(t.a) ? A2(Ik, h, k([
            A2(Ik, h, k([
                A2(px, Cqn, A3(hTn, n, r.uA, r.bB))
            ]))
        ])) : Sq;
    }), wTn = F2(function(n, r) {
        return A2(Ik, k([
            Nk("custom-details")
        ]), k([
            A2(dTn, n, r),
            A2(gTn, n, r),
            A2(tTn, n, r),
            A2(vTn, n, r)
        ]));
    }), kTn = F2(function(n, r) {
        return ED(r.eC) ? Sq : A2(Ik, fx(Htn), k([
            A2(OW, n, A2(yu, function(n) {
                return JN(n);
            }, r.eC))
        ]));
    }), xTn = function(n) {
        return {
            $: 0,
            a: n
        };
    }, yTn = {
        yR: !1,
        u$: !1
    }, _Tn = F2(function(n, r) {
        return m(r, n.$ ? {
            u$: n.a
        } : {
            yR: n.a
        });
    }), CTn = function(n) {
        return {
            $: 15,
            a: n
        };
    }, DTn = function(n) {
        return !whn(n);
    }, ATn = F3(function(n, r, t) {
        var e = jN(t.kk);
        if (rzn(e.u5) || !DTn(t.aY.ny)) return Sq;
        var u = jN(t.kk), a = u.l0, i = u.w0;
        return A2(Ik, h, k([
            A2(lV, k([
                dV(NZ)
            ]), k([
                A2(iV, k([
                    UZ(12)
                ]), k([
                    A2(QW, k([
                        ZW(i),
                        WW(CTn),
                        VW(r)
                    ]), k([
                        ad(n(Dpn))
                    ]))
                ]))
            ])),
            A2(IZ, !i, A2(Ik, k([
                Nk("mt-4")
            ]), k([
                A2(px, wqn, A3(Ghn, n, k([
                    ghn(r)
                ]), a))
            ])))
        ]));
    }), qTn = F4(function(n, r, t, e) {
        var u = jN(e.kk).bg;
        return A2(lV, h, k([
            A2(iV, k([
                UZ(12)
            ]), k([
                A2(AW, k([
                    bW(n(GN)),
                    hW(e.aY.g5)
                ]), k([
                    A2(px, jSn, A3(hZ, n, k([
                        rZ(r || t)
                    ]), u))
                ]))
            ]))
        ]));
    }), BTn = function(n) {
        return {
            $: 19,
            a: n
        };
    }, jTn = function(n) {
        return {
            $: 3,
            a: n
        };
    }, STn = function(n) {
        return {
            $: 4,
            a: n
        };
    }, zTn = function(n) {
        return {
            $: 0,
            a: n
        };
    }, UTn = function(n) {
        return {
            $: 4,
            a: n
        };
    }, ETn = F3(function(n, r, t) {
        return A2(ZI, t, r) && A2(kW, t, n);
    }), PTn = F3(function(n, r, t) {
        return A2(ZI, t, r) ? A2(iW, t, n) : h;
    }), TTn = F3(function(n, r, t) {
        var e = jN(t.kk), u = e.pt, a = e.u5;
        return rzn(a) ? Sq : A2(lV, h, k([
            A2(iV, k([
                UZ(12)
            ]), k([
                A2(AW, k([
                    bW("Email"),
                    hW(rzn(a) || ihn(t.dw)),
                    UTn(A2(pDn, t.qU, 7))
                ]), k([
                    yP(k([
                        kZ(A2(pDn, t.qU, 7)),
                        bP(u),
                        lP("me@example.com"),
                        xZ(A2(sc, zTn, BTn)),
                        oZ(A3(ETn, t.kk, t.x, 7)),
                        sP(r),
                        $Z(!0),
                        nX("email"),
                        KZ("email"),
                        lZ(jTn(BTn(u))),
                        dZ(STn(BTn(u))),
                        cZ(1)
                    ])),
                    A2(OW, n, A3(PTn, t.kk, t.x, 7))
                ]))
            ]))
        ]));
    }), FTn = function(n) {
        return {
            $: 0,
            a: n
        };
    }, LTn = F3(function(n, r, t) {
        var e = jN(t.kk), u = e.py, a = rzn(e.u5);
        return A2(px, zSn, A3(jxn, n, k([
            FTn(r),
            _xn(a)
        ]), u));
    }), MTn = function(n) {
        return n.vd;
    }, HTn = F3(function(n, r, t) {
        var e = jN(t.kk).qv;
        return k([
            A2(iV, k([
                UZ(12)
            ]), k([
                A2(AW, k([
                    bW(n(cbn.rr)),
                    hW(MTn(e))
                ]), k([
                    A2(px, LSn, A4(Fgn, n, k([
                        Dgn(r)
                    ]), Agn, e))
                ]))
            ]))
        ]);
    }), RTn = function(n) {
        return n.vd;
    }, OTn = F3(function(n, r, t) {
        var e = jN(t.kk), u = e.vK, a = e.qw, i = e.uC;
        return k([
            A2(iV, k([
                UZ(12),
                dV(aV),
                Oun(4),
                A2(XZ, 2, NZ)
            ]), k([
                A2(AW, k([
                    bW(n(ddn.rr)),
                    hW(RTn(u))
                ]), k([
                    A2(px, WSn, A3(Ggn, n, k([
                        Ogn(r)
                    ]), u))
                ])),
                A2(Ygn, n, u)
            ])),
            A2(iV, k([
                UZ(12),
                dV(aV),
                Oun(4),
                A2(XZ, 2, NZ)
            ]), k([
                A2(AW, k([
                    bW(n(odn.rr)),
                    hW(MTn(a))
                ]), k([
                    A2(px, FSn, A4(Fgn, n, k([
                        Dgn(r)
                    ]), Ngn, a))
                ]))
            ])),
            A2(iV, k([
                UZ(12),
                Oun(4)
            ]), k([
                A2(AW, k([
                    bW(n(sdn.rr)),
                    hW(MTn(i))
                ]), k([
                    A2(px, NSn, A4(Fgn, n, k([
                        Dgn(r)
                    ]), Ign, i))
                ]))
            ]))
        ]);
    }), NTn = F3(function(n, r, t) {
        return A2(lV, h, _gn(t.dw) ? A3(OTn, n, r, t) : A3(HTn, n, r, t));
    }), ITn = function(n) {
        return {
            $: 1,
            a: n
        };
    }, VTn = function(n) {
        return {
            $: 3,
            a: n
        };
    }, WTn = function(n) {
        return {
            $: 2,
            a: n
        };
    }, ZTn = function(n) {
        return {
            $: 4,
            a: n
        };
    }, XTn = function(n) {
        return n.vd;
    }, GTn = F4(function(n, r, t, e) {
        var u = jN(e.kk);
        return A2(lV, h, k([
            A2(iV, k([
                GZ(2),
                dV(aV),
                A2(XZ, 1, NZ)
            ]), k([
                A2(AW, k([
                    bW(n(lI)),
                    hW(XTn(u.wD)),
                    ign
                ]), k([
                    A2(px, XSn, A3(bgn, n, k([
                        ugn(r)
                    ]), u.wD))
                ]))
            ])),
            A2(iV, k([
                UZ(3)
            ]), k([
                A2(AW, k([
                    bW(n(cI)),
                    hW(!0),
                    ign,
                    UTn(A2(pDn, e.qU, 0))
                ]), k([
                    yP(k([
                        kZ(A2(pDn, e.qU, 0)),
                        bP(u.qb),
                        lP("First"),
                        xZ(A2(sc, zTn, ITn)),
                        oZ(A3(ETn, e.kk, e.x, 0)),
                        sP(r || t),
                        aX("additional-first-name"),
                        $Z(!0),
                        nX("given-name"),
                        KZ("given-name"),
                        lZ(jTn(ITn(u.qb))),
                        dZ(STn(ITn(u.qb)))
                    ]))
                ]))
            ])),
            A2(iV, k([
                UZ(3),
                GZ(2)
            ]), k([
                A2(AW, k([
                    bW(n(fI)),
                    ign,
                    UTn(e.qU + "-middle-name")
                ]), k([
                    yP(k([
                        kZ(e.qU + "-middle-name"),
                        bP(u.sE),
                        lP("Middle"),
                        xZ(A2(sc, zTn, WTn)),
                        sP(r),
                        aX("additional-middle-name"),
                        nX("additional-name"),
                        KZ("additional-name"),
                        $Z(!0),
                        lZ(jTn(WTn(u.sE))),
                        dZ(STn(WTn(u.sE)))
                    ]))
                ]))
            ])),
            A2(iV, k([
                UZ(3)
            ]), k([
                A2(AW, k([
                    bW(n(oI)),
                    hW(!0),
                    ign,
                    UTn(A2(pDn, e.qU, 1))
                ]), k([
                    yP(k([
                        kZ(A2(pDn, e.qU, 1)),
                        bP(u.rt),
                        lP("Last"),
                        xZ(A2(sc, zTn, VTn)),
                        oZ(A3(ETn, e.kk, e.x, 1)),
                        sP(r || t),
                        aX("additional-last-name"),
                        $Z(!0),
                        nX("family-name"),
                        KZ("family-name"),
                        lZ(jTn(VTn(u.rt))),
                        dZ(STn(VTn(u.rt)))
                    ]))
                ]))
            ])),
            A2(iV, k([
                UZ(3),
                GZ(2)
            ]), k([
                A2(AW, k([
                    bW(n(sI)),
                    ign,
                    UTn(e.qU + "-suffix")
                ]), k([
                    yP(k([
                        kZ(e.qU + "-suffix"),
                        bP(u.wt),
                        xZ(A2(sc, zTn, ZTn)),
                        sP(r),
                        aX("additional-suffix-name"),
                        nX("honorific-suffix"),
                        KZ("honorific-suffix"),
                        $Z(!0),
                        lZ(jTn(ZTn(u.wt))),
                        dZ(STn(ZTn(u.wt)))
                    ]))
                ]))
            ])),
            A2(iV, k([
                GZ(2)
            ]), h),
            A2(iV, k([
                UZ(3)
            ]), k([
                A2(OW, n, A3(PTn, e.kk, e.x, 0))
            ])),
            A2(iV, k([
                UZ(3),
                GZ(2)
            ]), h),
            A2(iV, k([
                UZ(3)
            ]), k([
                A2(OW, n, A3(PTn, e.kk, e.x, 1))
            ])),
            A2(iV, k([
                UZ(3),
                GZ(2)
            ]), h)
        ]));
    }), JTn = function(n) {
        return {
            $: 7,
            a: n
        };
    }, YTn = function(n) {
        return {
            $: 9,
            a: n
        };
    }, QTn = function(n) {
        return {
            $: 8,
            a: n
        };
    }, KTn = function(n) {
        return {
            $: 10,
            a: n
        };
    }, nFn = function(n) {
        return {
            $: 2,
            a: n
        };
    }, rFn = F3(function(n, r, t) {
        var e = jN(t.kk), u = e.aj, a = e.nq, i = e.nm, c = e.no, o = e.nn, f = e.np;
        return A2(Ik, h, k([
            A2(lV, k([
                dV(aV)
            ]), k([
                A2(iV, k([
                    UZ(12)
                ]), k([
                    A2(QW, k([
                        ZW(u),
                        WW(nFn),
                        VW(r)
                    ]), k([
                        ad(n(Khn))
                    ]))
                ]))
            ])),
            A2(IZ, u, A2(lV, h, k([
                A2(iV, k([
                    GZ(2),
                    dV(aV),
                    A2(XZ, 2, NZ)
                ]), k([
                    A2(AW, k([
                        bW(n(egn)),
                        hW(XTn(a)),
                        ign
                    ]), k([
                        A2(px, qSn, A3(bgn, n, k([
                            ugn(r)
                        ]), a))
                    ]))
                ])),
                A2(iV, k([
                    UZ(3)
                ]), k([
                    A2(AW, k([
                        bW(n(Qhn)),
                        hW(!0),
                        ign,
                        UTn(A2(pDn, t.qU, 3))
                    ]), k([
                        yP(k([
                            kZ(A2(pDn, t.qU, 3)),
                            bP(i),
                            lP("First"),
                            xZ(A2(sc, zTn, JTn)),
                            oZ(A3(ETn, t.kk, t.x, 3)),
                            sP(r),
                            aX("choosen-first-name"),
                            $Z(!0),
                            nX("given-name"),
                            KZ("given-name"),
                            lZ(jTn(JTn(i))),
                            dZ(STn(JTn(i)))
                        ]))
                    ]))
                ])),
                A2(iV, k([
                    UZ(3),
                    GZ(2)
                ]), k([
                    A2(AW, k([
                        bW(n(rgn)),
                        ign,
                        UTn(t.qU + "-chosen-middle-name")
                    ]), k([
                        yP(k([
                            kZ(t.qU + "-chosen-middle-name"),
                            bP(c),
                            lP("Middle"),
                            xZ(A2(sc, zTn, QTn)),
                            sP(r),
                            aX("choosen-middle-name"),
                            $Z(!0),
                            nX("additional-name"),
                            KZ("additional-name"),
                            lZ(jTn(QTn(c))),
                            dZ(STn(QTn(c)))
                        ]))
                    ]))
                ])),
                A2(iV, k([
                    UZ(3)
                ]), k([
                    A2(AW, k([
                        bW(n(ngn)),
                        hW(!0),
                        ign,
                        UTn(A2(pDn, t.qU, 4))
                    ]), k([
                        yP(k([
                            kZ(A2(pDn, t.qU, 4)),
                            bP(o),
                            lP("Last"),
                            xZ(A2(sc, zTn, YTn)),
                            oZ(A3(ETn, t.kk, t.x, 4)),
                            sP(r),
                            aX("choosen-last-name"),
                            $Z(!0),
                            nX("family-name"),
                            KZ("family-name"),
                            lZ(jTn(YTn(o))),
                            dZ(STn(YTn(o)))
                        ]))
                    ]))
                ])),
                A2(iV, k([
                    UZ(3),
                    GZ(2)
                ]), k([
                    A2(AW, k([
                        bW(n(tgn)),
                        ign,
                        UTn(t.qU + "-chosen-suffix")
                    ]), k([
                        yP(k([
                            kZ(t.qU + "-chosen-suffix"),
                            bP(f),
                            xZ(A2(sc, zTn, KTn)),
                            sP(r),
                            aX("choosen-suffix"),
                            nX("honorific-suffix"),
                            KZ("honorific-suffix"),
                            $Z(!0),
                            lZ(jTn(KTn(f))),
                            dZ(STn(KTn(f)))
                        ]))
                    ]))
                ])),
                A2(iV, k([
                    UZ(12),
                    GZ(3)
                ]), h),
                A2(iV, k([
                    UZ(4),
                    GZ(3)
                ]), k([
                    A2(OW, n, A3(PTn, t.kk, t.x, 3))
                ])),
                A2(iV, k([
                    UZ(4),
                    GZ(3)
                ]), h),
                A2(iV, k([
                    UZ(4),
                    GZ(3)
                ]), k([
                    A2(OW, n, A3(PTn, t.kk, t.x, 4))
                ]))
            ])))
        ]));
    }), tFn = F4(function(n, r, t, e) {
        return A2(Ik, h, k([
            A4(GTn, n, r, t, e),
            A3(rFn, n, r, e)
        ]));
    }), eFn = F4(function(n, r, t, e) {
        var u = jN(e.kk);
        return rzn(u.u5) ? Sq : A4(tFn, n, r, t, e);
    }), uFn = F3(function(n, r, t) {
        var e = DTn(t.aY.ny) ? h : k([
            dV(NZ)
        ]), u = tvn(t.dw), a = jN(t.kk), i = a.t2;
        return rzn(a.u5) ? Sq : A2(lV, e, k([
            A2(iV, k([
                UZ(12)
            ]), k([
                A2(AW, k([
                    bW(n($O)),
                    hW(i.vd || u)
                ]), k([
                    A2(Ik, k([
                        Nk("mx-1")
                    ]), k([
                        A2(px, HSn, A3(okn, n, k([
                            Kwn(r)
                        ]), i))
                    ]))
                ]))
            ]))
        ]));
    }), aFn = F3(function(n, r, t) {
        if (pjn(t.dw)) {
            var e = jN(t.kk);
            return A2(lV, h, k([
                A2(iV, k([
                    UZ(12)
                ]), k([
                    A2(AW, k([
                        bW(n(dkn))
                    ]), k([
                        A2(px, RSn, A3(mkn, n, k([
                            lkn(r)
                        ]), e.uo))
                    ]))
                ]))
            ]));
        }
        return Sq;
    }), iFn = function(n) {
        return {
            $: 12,
            a: n
        };
    }, cFn = F2(function(n, r) {
        switch(r){
            case 0:
                return n(Dzn);
            case 1:
                return n(yzn);
            case 2:
                return n(_zn);
            default:
                return n(vO);
        }
    }), oFn = function(n) {
        return 1 === n;
    }, fFn = function(n) {
        switch(n){
            case 0:
                return "owner";
            case 1:
                return "spouse";
            case 2:
                return "child";
            default:
                return "other";
        }
    }, sFn = F3(function(n, r, t) {
        var e, u = jN(t.kk).u5;
        return rzn(u) ? Sq : A2(lV, h, k([
            A2(iV, k([
                UZ(12)
            ]), k([
                A2(AW, k([
                    bW(n(Czn)),
                    hW(!0)
                ]), k([
                    A2(lV, k([
                        dV(NZ),
                        jV(k([
                            Nk("row--tweak")
                        ]))
                    ]), k([
                        A2(iV, k([
                            UZ(6),
                            dV(Fhn)
                        ]), k([
                            A2(IU, k([
                                SU,
                                ZU(A2(sc, A2(sc, zTn, iFn), rm(1))),
                                rwn((e = u, A2(uc, !1, A2(Cp, oFn, e)))),
                                uE(fFn(1)),
                                twn(r)
                            ]), k([
                                ad(A2(cFn, n, 1))
                            ]))
                        ])),
                        A2(iV, k([
                            UZ(6)
                        ]), k([
                            A2(IU, k([
                                SU,
                                ZU(A2(sc, A2(sc, zTn, iFn), rm(2))),
                                rwn(dBn(u)),
                                uE(fFn(2)),
                                twn(r)
                            ]), k([
                                ad(A2(cFn, n, 2))
                            ]))
                        ]))
                    ])),
                    A2(OW, n, A3(PTn, t.kk, t.x, 2))
                ]))
            ]))
        ]));
    }), lFn = function(n) {
        return {
            $: 18,
            a: n
        };
    }, dFn = zA("###-##-####"), bFn = F3(function(n, r, t) {
        if (xjn(t.aY.nK)) return Sq;
        var e, u = jN(t.kk).wb;
        return A2(lV, h, k([
            A2(iV, k([
                UZ(12)
            ]), k([
                A2(AW, k([
                    bW("SSN"),
                    hW((e = t.aY.nK, yvn(e)))
                ]), k([
                    yP(k([
                        kZ(A2(pDn, t.qU, 6)),
                        A2(sZ, dFn, u),
                        A3(vZ, dFn, u, A2(sc, zTn, lFn)),
                        lP("123-12-1234"),
                        oZ(A3(ETn, t.kk, t.x, 6)),
                        sP(r),
                        lZ(jTn(lFn(u))),
                        dZ(STn(lFn(u))),
                        $Z(!0),
                        cZ(0)
                    ])),
                    A2(OW, n, A3(PTn, t.kk, t.x, 6))
                ]))
            ]))
        ]));
    }), vFn = F3(function(n, r, t) {
        var e = A3(ce, _Tn, yTn, r), u = e.yR, a = e.u$;
        return A2(Ik, k([
            Nk("member-input w-full space-y-6")
        ]), k([
            A4(eFn, n, u, a, t),
            A4(qTn, n, u, a, t),
            A3(sFn, n, u, t),
            A3(NTn, n, u, t),
            A3(aFn, n, u, t),
            A3(bFn, n, u, t),
            A3(TTn, n, u, t),
            A3(uFn, n, u, t),
            A3(ATn, n, u, t),
            A3(LTn, n, u, t)
        ]));
    }), mFn = F2(function(n, r) {
        return A2(Ik, k([
            Nk("mx-1")
        ]), k([
            A2(px, gqn, A3(vFn, n, k([
                xTn(r.uA)
            ]), r.U))
        ]));
    }), pFn = F2(function(n, r) {
        return A2(Ik, h, k([
            A2(mFn, n, r),
            A2(kTn, n, r),
            A2(vTn, n, r)
        ]));
    }), $Fn = function(n) {
        return {
            $: 0,
            a: n
        };
    }, hFn = function(n) {
        return {
            $: 1,
            a: n
        };
    }, gFn = function(n) {
        var r = yAn(n.P) && !_on(n.cI), t = kAn(n.O) && !_on(n.hQ);
        return !(r || t);
    }, wFn = F2(function(n, r) {
        return {
            ku: r,
            uj: n
        };
    }), kFn = function(n) {
        return {
            $: 0,
            a: n
        };
    }, xFn = function(n) {
        return {
            $: 0,
            a: n
        };
    }, yFn = function(n) {
        return {
            $: 7,
            a: n
        };
    }, _Fn = function(n) {
        return {
            $: 6,
            a: n
        };
    }, CFn = function(n) {
        return {
            $: 2,
            a: n
        };
    }, DFn = function(n) {
        return {
            $: 5,
            a: n
        };
    }, AFn = {
        yR: !1,
        ka: !1,
        zU: !1,
        id: Rt
    }, qFn = F2(function(n, r) {
        return m(r, n.$ ? {
            id: n.a
        } : {
            yR: n.a
        });
    }), BFn = function(n) {
        return {
            $: 8,
            a: n
        };
    }, jFn = function(n) {
        return {
            $: 2,
            a: n
        };
    }, SFn = function(n) {
        return {
            $: 3,
            a: n
        };
    }, zFn = function(n) {
        return {
            $: 4,
            a: n
        };
    }, UFn = function(n) {
        return {
            $: 1,
            a: n
        };
    }, EFn = function(n) {
        return {
            $: 1,
            a: n
        };
    }, PFn = {
        yR: !1,
        hQ: h,
        w5: Rt
    }, TFn = F2(function(n, r) {
        switch(n.$){
            case 0:
                return m(r, {
                    yR: n.a
                });
            case 1:
                return m(r, {
                    w5: n.a
                });
            default:
                return m(r, {
                    hQ: n.a
                });
        }
    }), FFn = function(n) {
        var r, t, e, u, a = (t = Rnn(n), e = Pnn(n) + ", " + Hnn(n), u = (r = b(fu(e), Fnn(t))).a || r.b ? Sq : oF, A2(Ik, h, k([
            A2(Gk, h, k([
                ad(e)
            ])),
            u,
            Jx(t)
        ]))), i = Fnn(Mnn(n)) ? Sq : A2(Ik, h, k([
            Jx(Mnn(n))
        ])), c = Fnn(Lnn(n)) ? Sq : A2(Ik, h, k([
            Jx(Lnn(n))
        ]));
        return k([
            A2(Ik, h, k([
                c,
                i,
                a
            ]))
        ]);
    }, LFn = function(n) {
        if (HAn(n)) return A2(Ik, k([
            Nk("radio-card__row signup__subtitle")
        ]), k([
            A2(hx, k([
                BB,
                EB,
                A2(Pln, 1, 2)
            ]), k([
                ad("Virtual Location")
            ]))
        ]));
        var r = Gun(n);
        if (r.$) return Sq;
        var t = r.a;
        return A2(Ik, k([
            Nk("radio-card__row signup__subtitle")
        ]), k([
            A2(hx, k([
                BB,
                EB,
                A2(Pln, 1, 2)
            ]), k([
                A2(Ik, k([
                    Nk("lg:hidden")
                ]), FFn(t)),
                A2(Ik, k([
                    Nk("hidden lg:flex")
                ]), k([
                    ad(Hln(t))
                ]))
            ]))
        ]));
    }, MFn = F2(function(n, r) {
        var t = Tln(r);
        if (t.$) return Sq;
        var e = t.a;
        return A2(Ik, k([
            Nk("flex items-center")
        ]), k([
            A2(US, k([
                Sz,
                Vq("fill-gray")
            ]), 10),
            A2(hx, k([
                BB,
                UB
            ]), k([
                ad(A2(Lln, n, e))
            ]))
        ]));
    }), HFn = F2(function(n, r) {
        return A2(Ik, k([
            Nk("radio-card__row")
        ]), k([
            A2(Ik, k([
                Nk("lg:flex")
            ]), k([
                A2(hx, k([
                    Hz,
                    EB,
                    A2(Pln, 1, 2)
                ]), k([
                    ad(Uln(r))
                ])),
                A2(Ik, k([
                    Nk("lg:ml-2")
                ]), k([
                    A2(MFn, n, r)
                ]))
            ]))
        ]));
    }), RFn = F3(function(n, r, t) {
        var e, u = !(e = r.w5).$ && i(LAn(e.a), LAn(t));
        return A2(Ik, k([
            Nk("radio-card"),
            rz(k([
                b("radio-card--selected", u),
                b("radio-card--disabled", r.yR)
            ])),
            Eq(t)
        ]), k([
            A2(Ik, k([
                Nk("radio-card__radio")
            ]), k([
                A2(IU, k([
                    rwn(u),
                    ZU(A2(sc, ru, rm(t))),
                    twn(r.yR)
                ]), h)
            ])),
            A2(Ik, k([
                Nk("radio-card__content")
            ]), k([
                A2(HFn, n, t),
                LFn(t)
            ]))
        ]));
    }), OFn = F2(function(n, r) {
        var t = A3(ce, TFn, PFn, r);
        return A2(Ik, h, A2(yu, A2(RFn, n, t), t.hQ));
    }), NFn = {
        yR: !1,
        ka: !1,
        hz: !1,
        zU: !1,
        hQ: h,
        id: Rt,
        cI: h,
        dJ: Rt,
        ld: Rt,
        cP: Rt
    }, IFn = F2(function(n, r) {
        switch(n.$){
            case 0:
                return m(r, {
                    yR: n.a
                });
            case 1:
                return m(r, {
                    cP: n.a
                });
            case 2:
                return m(r, {
                    cI: n.a
                });
            case 3:
                return m(r, {
                    dJ: n.a
                });
            case 4:
                return m(r, {
                    ld: n.a
                });
            case 5:
                return m(r, {
                    hQ: n.a
                });
            case 6:
                return m(r, {
                    zU: n.a
                });
            case 7:
                return m(r, {
                    ka: n.a
                });
            case 8:
                return m(r, {
                    id: n.a
                });
            default:
                return m(r, {
                    hz: n.a
                });
        }
    }), VFn = F2(function(n, r) {
        var t = b(n, r);
        n: for(;;){
            if (t.a.$) {
                if (1 === t.b.$) return !0;
                break n;
            }
            if (t.b.$) break n;
            var e = t.b.a;
            return i(Hjn(t.a.a.uj), Hjn(e.uj));
        }
        return !1;
    }), WFn = function(n) {
        n: for(;;){
            if (n.b) {
                if (1 === n.a.$) {
                    n = n.b;
                    continue n;
                }
                return Ht(n.a.a);
            }
            return Rt;
        }
    }, ZFn = F2(function(n, r) {
        return A2(Xb, Gb, A2(Cp, function(r) {
            return A2(Tc, function(n) {
                return i(LAn(n), r);
            }, n);
        }, A2(Cp, KUn, Gb(r.uj.hQ))));
    }), XFn = F4(function(n, r, t, e) {
        return WFn(k([
            n ? r : Rt,
            e.ku,
            Gb(t),
            A2(ZFn, t, e)
        ]));
    }), GFn = F3(function(n, r, t) {
        if (1 === t.$) {
            var e = t.a, u = t.b, a = A2(tEn, Ht(u), r.hQ), i = A2(VFn, r.cP, Ht(u));
            return A2(px, kEn, A3(Odn, n, {
                ku: A4(XFn, i, r.dJ, a, u),
                xk: !0
            }, e));
        }
        return Sq;
    }), JFn = function(n) {
        return {
            $: 0,
            a: n
        };
    }, YFn = function(n) {
        var r = n.$ ? "no-preference" : Hjn(n.a);
        return A2(ue, "-", k([
            "practitioner-card",
            r
        ]));
    }, QFn = F2(function(n, r) {
        var t = b(n, r);
        if (t.a.$ || t.b.$) return !1;
        var e, u, a = t.a.a, i = t.b.a, c = !(u = Mdn(a)).$ && 0 > s(i, u.a), o = !(e = Ldn(a)).$ && s(i, e.a) > 0;
        return c || o;
    }), KFn = F4(function(n, r, t, e) {
        var u = A2(yu, function(n) {
            return A2(Xz, h, n);
        }, A2(tEn, e, r.hQ));
        return oe(u) > 1 ? A2(Ik, k([
            Nk("card card--selected card--slide-down flex -mt-4 mb-4 py-6 rounded-t-none border-t-0")
        ]), k([
            A2(Ik, k([
                Nk("flex flex-col flex-grow ml-8 mr-2")
            ]), k([
                A2(AW, k([
                    bW(n(iL)),
                    hW(!0),
                    Ahn(n(uL))
                ]), k([
                    A2(px, hEn, A4(AU, n, k([
                        Jz(r.dJ),
                        ZL(n(fL)),
                        cX(r.yR),
                        ogn(r.zU)
                    ]), u, t))
                ]))
            ]))
        ])) : Sq;
    }), nLn = function(n) {
        return {
            $: 5,
            a: n
        };
    }, rLn = function(n) {
        return {
            $: 1,
            a: n
        };
    }, tLn = F2(function(n, r) {
        return r.rL(n);
    }), eLn = F2(function(n, r) {
        return r > 1 ? A2(Ik, k([
            Nk("tag tag--subdued tag--small")
        ]), k([
            A2(hx, k([
                BB,
                EB,
                A2(Pln, 1, 2)
            ]), k([
                ad(n(tLn(ee(r - 1))))
            ]))
        ])) : Sq;
    }), uLn = F5(function(n, r, t, e, u) {
        return A2(uc, Sq, A2(Cp, function(e) {
            return A2(Ik, k([
                Nk("radio-card__row signup__subtitle")
            ]), k([
                A2(Ik, k([
                    Nk("flex")
                ]), k([
                    A2(Ik, k([
                        Nk("flex flex-grow")
                    ]), k([
                        A2(hx, k([
                            BB,
                            EB,
                            A2(Pln, 1, 2)
                        ]), k([
                            ad(A2(RAn, n, e))
                        ]))
                    ])),
                    A2(Ik, k([
                        rz(k([
                            b("hidden", r)
                        ]))
                    ]), k([
                        A2(eLn, n, oe(t))
                    ]))
                ]))
            ]));
        }, WFn(k([
            e,
            u.ku,
            A2(ZFn, t, u)
        ]))));
    }), aLn = function(n) {
        return n.o0;
    }, iLn = F2(function(n, r) {
        var t = b(aLn(n), aLn(r));
        return 1 === t.a.$ ? t.b.$ ? 1 : 2 : 1 === t.b.$ ? 0 : A2(Wu, t.a.a, t.b.a);
    }), cLn = F2(function(n, r) {
        if (r.$) return function(n) {
            return A2(uc, Rt, A2(Cp, aLn, Gb(A2(UL, iLn, rEn(n)))));
        }(n);
        var t = r.a;
        return A2(uc, Rt, A2(Cp, aLn, Gb(A2(Tc, function(n) {
            return i(KUn(n), t);
        }, rEn(n)))));
    }), oLn = F4(function(n, r, t, e) {
        var u = k(r ? [
            PL
        ] : [
            EB,
            A2(Pln, 1, 2)
        ]), a = A2(cLn, e, t);
        if (a.$) return Sq;
        var i = a.a;
        return A2(Ik, k([
            Nk("flex items-center")
        ]), k([
            A2(Gk, k([
                Nk("mr-1 -mt-1")
            ]), k([
                A2(US, k([
                    Sz,
                    Vq("fill-gray")
                ]), 10)
            ])),
            A2(hx, A2(Ot, BB, u), k([
                ad(A2(Lln, n, i))
            ]))
        ]));
    }), fLn = F5(function(n, r, t, e, u) {
        var a = A2(Cp, function(n) {
            return n.uj;
        }, e), i = A2(uc, "No preference", A2(Cp, hH, a)), c = A2(Cp, A3(oLn, n, !1, r ? t.ld : Rt), a);
        return A2(Ik, h, k([
            A2(Ik, k([
                Nk("radio-card__row")
            ]), k([
                A2(Ik, k([
                    Nk("lg:flex")
                ]), k([
                    A2(hx, k([
                        Hz,
                        EB,
                        A2(Pln, 1, 2)
                    ]), k([
                        ad(i)
                    ])),
                    A2(Ik, k([
                        Nk("lg:ml-2")
                    ]), k([
                        A2(uc, Sq, c)
                    ]))
                ]))
            ])),
            function() {
                var n = b(a, u);
                if (!n.a.$ && n.b) {
                    var r = n.a.a;
                    return A2(hx, k([
                        BB,
                        EB
                    ]), k([
                        ad(A3(Hdn, Mdn(r), Ldn(r), !0))
                    ]));
                }
                return Sq;
            }()
        ]));
    }), sLn = F5(function(n, r, t, e, u) {
        return A2(Ik, k([
            Eq(u)
        ]), k([
            A5(fLn, n, r, t, e, !1),
            A2(Ik, k([
                Nk("radio-card__row signup__subtitle")
            ]), k([
                A2(hx, k([
                    BB,
                    EB,
                    A2(Pln, 1, 2)
                ]), k([
                    ad("No provider will be assigned at this time")
                ]))
            ]))
        ]));
    }), lLn = function(n) {
        return n.q.lV;
    }, dLn = function(n) {
        return n.q.lW;
    }, bLn = function(n) {
        return n.q.pu;
    }, vLn = function(n) {
        return n.q.pv;
    }, mLn = function(n) {
        return n.q.pI;
    }, pLn = function(n) {
        return n.q.qc;
    }, $Ln = function(n) {
        return n.q.qd;
    }, hLn = function(n) {
        return n.q.q5;
    }, gLn = function(n) {
        return n.q.q6;
    }, wLn = function(n) {
        return n.q.z5;
    }, kLn = function(n) {
        return n.q.rn;
    }, xLn = function(n) {
        return n.q.ro;
    }, yLn = function(n) {
        return n.q.ru;
    }, _Ln = function(n) {
        return n.q.rv;
    }, CLn = function(n) {
        return n.q.tw;
    }, DLn = function(n) {
        return n.q.t1;
    }, ALn = function(n) {
        return n.q.uH;
    }, qLn = function(n) {
        return n.q.vC;
    }, BLn = function(n) {
        return n.q.wn;
    }, jLn = function(n) {
        return n.q.ws;
    }, SLn = function(n) {
        return n.q.dT;
    }, zLn = F7(function(n, r, t, e, u, a, i) {
        var c = JFn(a);
        if (a.$) return A5(sLn, n, t, r, a, c);
        var o = a.a;
        return A2(Ik, k([
            Nk("flex flex-row w-full")
        ]), k([
            A2(Ik, k([
                Nk("flex flex-col mr-4"),
                Eq(c)
            ]), k([
                A2(Adn, !1, o.uj)
            ])),
            A2(Ik, k([
                Nk("flex flex-col flex-grow"),
                Eq(c)
            ]), k([
                A5(fLn, n, t, r, a, i),
                xdn(o.uj),
                A5(uLn, n, t, e, u, o)
            ])),
            i ? Sq : A2(Ik, k([
                Nk("flex flex-col justify-center ml-4 mr-2 gap-2")
            ]), A2(Ot, A2(fz, k([
                CU,
                QS(rLn(o)),
                ksn(!0)
            ]), k([
                ad(n(AZ))
            ])), r.hz || "full_waitlisting" !== FEn(o.uj) ? h : k([
                A2(fz, k([
                    nz,
                    QS(nLn(o.uj)),
                    ksn(!0)
                ]), k([
                    ad(n(wLn))
                ]))
            ])))
        ]));
    }), ULn = F7(function(n, r, t, e, u, a, i) {
        var c = JFn(a);
        if (a.$) return A5(sLn, n, t, r, a, c);
        var o = a.a;
        return A2(Ik, h, k([
            A2(Ik, k([
                Nk("flex flex-row mb-6"),
                Eq(c)
            ]), k([
                A2(Ik, k([
                    Nk("flex flex-shrink-0 mr-4")
                ]), k([
                    A2(Adn, !1, o.uj)
                ])),
                A2(Ik, k([
                    Nk("flex flex-col flex-grow")
                ]), k([
                    A5(fLn, n, t, r, a, i)
                ]))
            ])),
            A2(Ik, k([
                Nk("mb-4")
            ]), k([
                gx
            ])),
            A2(Ik, k([
                Nk("flex flex-col pr-2"),
                Eq(c)
            ]), k([
                xdn(o.uj),
                A5(uLn, n, t, e, u, o)
            ])),
            A2(Ik, k([
                Nk("mt-4")
            ]), k([
                A2(fz, k([
                    CU,
                    QS(rLn(o))
                ]), k([
                    ad(n(AZ))
                ]))
            ]))
        ]));
    }), ELn = F7(function(n, r, t, e, u, a, i) {
        return A2(Ik, k([
            Nk("radio-card__content")
        ]), k([
            A2(Ik, k([
                Nk("lg:hidden")
            ]), k([
                A7(ULn, n, r, t, e, u, a, i)
            ])),
            A2(Ik, k([
                Nk("hidden lg:flex")
            ]), k([
                A7(zLn, n, r, t, e, u, a, i)
            ]))
        ]));
    }), PLn = F4(function(n, r, t, e) {
        var u = t.ff, a = A2(Cp, function(n) {
            return n.uj;
        }, e), i = A2(tEn, e, r.hQ), c = A2(VFn, r.cP, e), o = oe(i) > 1 && c, f = A2(Xb, A3(XFn, c, r.dJ, i), e), s = A2(QFn, a, r.id);
        return A2(Ik, k([
            jz(YFn(a))
        ]), k([
            A2(Ik, k([
                Nk("radio-card"),
                rz(k([
                    b("radio-card--selected", c),
                    b("radio-card--disabled", r.yR || s),
                    b("radio-card--top", o)
                ]))
            ]), k([
                A2(Ik, k([
                    Nk("radio-card__radio")
                ]), k([
                    A2(IU, k([
                        rwn(c),
                        ZU(A2(sc, JFn, rm(e))),
                        twn(r.yR || s)
                    ]), h)
                ])),
                A7(ELn, n, r, c, i, f, e, s)
            ])),
            o && !s ? A4(KFn, n, r, u, e) : Sq
        ]));
    }), TLn = F3(function(n, r, t) {
        var e = function() {
            var n = b(r.ka, r.cP);
            if (n.a && !n.b.$) {
                var t = n.b.a;
                return b(A2(Tc, function(n) {
                    return !i(Hjn(n.uj), Hjn(t.uj));
                }, r.cI), k([
                    r.cP
                ]));
            }
            return b(r.cI, h);
        }(), u = e.a, a = e.b, c = $(t.jS ? k([
            Rt
        ]) : h, A2(yu, function(n) {
            return Ht(n);
        }, u));
        return A2(yu, A3(PLn, n, r, t), $(a, c));
    }), FLn = F3(function(n, r, t) {
        var e = A3(ce, IFn, NFn, r);
        return A2(Ik, h, A2(Ot, A3(GFn, n, e, t.bv), A3(TLn, n, e, t)));
    }), LLn = function(n) {
        return {
            $: 0,
            a: n
        };
    }, MLn = {
        $: 12
    }, HLn = function(n) {
        return {
            $: 18,
            a: n
        };
    }, RLn = function(n) {
        return n.uJ.Cv;
    }, OLn = {
        $: 2
    }, NLn = function(n) {
        return {
            $: 1,
            a: n
        };
    }, ILn = function(n) {
        return {
            $: 0,
            a: n
        };
    }, VLn = k([
        ILn(1),
        ILn(5),
        ILn(10),
        ILn(20)
    ]), WLn = A2(Ot, A2(Xz, h, Ht({
        $: 2
    })), A2(Ot, A2(Xz, h, Ht(lqn)), A2(Ot, IL, A2(yu, function(n) {
        return A2(Xz, h, Ht(n));
    }, VLn)))), ZLn = F4(function(n, r, t, e) {
        return A2(lV, k([
            dV(NZ),
            jV(k([
                Nk("row--tweak")
            ]))
        ]), k([
            A2(iV, k([
                GZ(6)
            ]), k([
                A2(px, bEn, A4(AU, n, k([
                    Jz(Ht(e.au)),
                    Wz,
                    ZL("Filter by distance"),
                    cX(t)
                ]), WLn, e.fx))
            ])),
            A2(iV, k([
                GZ(6)
            ]), k([
                function() {
                    if (e.au.$) return Sq;
                    var n = r || !Npn(e.xy);
                    return A2(Ik, k([
                        Nk("sm:mt-0 mt-2")
                    ]), k([
                        ofn(k([
                            cfn(k([
                                ad("ZIP:")
                            ])),
                            yP(k([
                                bP(e.xy),
                                xZ(NLn),
                                oZ(n)
                            ]))
                        ]))
                    ]));
                }()
            ]))
        ]));
    }), XLn = F4(function(n, r, t, e) {
        var u = A2(Ot, A2(Xz, h, UAn(lEn)), A2(Ot, IL, A2(yu, Xz(h), A2(yu, function(n) {
            return function(n) {
                return {
                    $: 1,
                    a: n
                };
            }({
                qU: LAn(n),
                sS: Uln(n)
            });
        }, r))));
        return A2(px, iEn, A4(AU, n, k([
            Jz(Ht(t)),
            Wz,
            ZL(n(EAn))
        ]), u, e));
    }), GLn = F4(function(n, r, t, e) {
        var u = e.eW, a = e.ku, i = e.kb, c = e.dx, o = e.eH, f = e.eI, s = oe(t) > 1, l = !o && s, d = l || s ? aV : NZ, v = l ? 8 : 12;
        return A2(lV, k([
            eyn,
            MLn,
            jV(k([
                Nk("mx-0")
            ]))
        ]), k([
            A2(iV, k([
                UZ(12)
            ]), k([
                A2(lV, k([
                    dV(NZ)
                ]), k([
                    A2(iV, k([
                        OLn
                    ]), k([
                        A2(lV, k([
                            dV(d),
                            jV(k([
                                rz(k([
                                    b("hidden", f)
                                ]))
                            ]))
                        ]), k([
                            A2(iV, k([
                                UZ(12)
                            ]), k([
                                yP(k([
                                    lP(n(RLn)),
                                    bP(c),
                                    xZ(LLn),
                                    HLn(15)
                                ]))
                            ]))
                        ])),
                        A2(lV, k([
                            dV(NZ)
                        ]), k([
                            A2(iV, k([
                                Oun(4),
                                dV(aV),
                                A2(XZ, 2, NZ),
                                jV(k([
                                    rz(k([
                                        b("hidden", !l)
                                    ]))
                                ]))
                            ]), k([
                                A4(XLn, n, t, a, u)
                            ])),
                            A2(iV, k([
                                Oun(v),
                                jV(k([
                                    rz(k([
                                        b("hidden", !s)
                                    ]))
                                ]))
                            ]), k([
                                A2(px, uEn, A4(ZLn, n, !1, r, i))
                            ]))
                        ]))
                    ]))
                ]))
            ]))
        ]));
    }), JLn = F4(function(n, r, t, e) {
        return A2(px, TUn, A4(GLn, n, r, t, e));
    }), YLn = function(n) {
        return {
            $: 1,
            a: n
        };
    }, QLn = F3(function(n, r, t) {
        if (gFn(t)) {
            var e = ZEn(t), u = Vjn(t), a = A3(ce, qFn, AFn, r), i = QUn(t), c = Njn(t), o = a.yR || !gFn(t);
            return A2(Ik, h, k([
                A4(JLn, n, o, RUn(t), t.au),
                function() {
                    var r, f = t.fC;
                    switch(f.$){
                        case 0:
                            var s = f.a;
                            if (ED(e) && !cqn(t.P)) return A2(hx, h, k([
                                ad("No providers found")
                            ]));
                            var l = A2(Cp, function(n) {
                                return A2(wFn, n, Rt);
                            }, u);
                            return A2(Ik, h, k([
                                A2(px, MUn, A3(FLn, n, k([
                                    xFn(o),
                                    UFn(l),
                                    jFn(e),
                                    SFn(c),
                                    zFn(t.ld),
                                    DFn(i),
                                    _Fn(a.zU || !ED(t.eC)),
                                    yFn(a.ka),
                                    BFn(a.id)
                                ]), s)),
                                (r = t.kR, A2(px, YLn, A2(e5, h, r)))
                            ]));
                        case 1:
                            return ED(i) && kAn(t.O) ? A2(hx, h, k([
                                ad("No locations found")
                            ])) : A2(px, FUn, A2(OFn, n, k([
                                kFn(o),
                                CFn(i),
                                EFn(c)
                            ])));
                        default:
                            return Sq;
                    }
                }()
            ]));
        }
        return A2(Ik, h, Yk);
    }), KLn = F2(function(n, r) {
        var t = A2(Xb, fBn, A2(Xb, function(n) {
            return A2(oBn, n, r.U);
        }, r.g0));
        return gFn(r.aC) ? A2(Ik, k([
            Nk("mt-6")
        ]), k([
            A2(px, _qn, A3(QLn, n, k([
                $Fn(r.uA),
                hFn(t)
            ]), r.aC)),
            A2(kTn, n, r),
            A2(vTn, n, r)
        ])) : A2(Ik, h, Yk);
    }), nMn = F2(function(n, r) {
        var t = A2(Cp, function(n) {
            return n.qU;
        }, r.j2);
        if (t.$) return A2(Ik, h, Yk);
        switch(t.a){
            case 0:
                return A2(pFn, n, r);
            case 1:
                return A2(wTn, n, r);
            case 2:
                return A2(KLn, n, r);
            default:
                return A2(APn, n, r);
        }
    }), rMn = function(n) {
        var r = n.j2;
        if (r.$) return Sq;
        var t = r.a;
        return A2(mx, k([
            LS(q3),
            LS(Iun)
        ]), k([
            ad(A2(Nqn, n.fF, t.qU))
        ]));
    }, tMn = function(n) {
        return {
            $: 7,
            a: n
        };
    }, eMn = F3(function(n, r, t) {
        return {
            yR: t,
            kn: r,
            rr: n
        };
    }), uMn = F3(function(n, r, t) {
        return A2(yu, function(n) {
            return A3(eMn, n.rr, n.kn, !1);
        }, A3(Vqn, n, r, t));
    }), aMn = F3(function(n, r, t) {
        var e = n.aU, u = n.a2, a = ee(t.kn + 1), c = t.yR ? {
            ep: A2(Gk, k([
                Nk("stepper__circle")
            ]), k([
                ad(a)
            ])),
            fH: "disabled",
            fI: ad(t.rr)
        } : i(t.kn, e) ? {
            ep: A2(Gk, k([
                Nk("stepper__circle")
            ]), k([
                ad(a)
            ])),
            fH: "current",
            fI: ad(t.rr)
        } : 0 > s(t.kn, e) ? {
            ep: A2(fF, k([
                Nk("stepper__circle"),
                r
            ]), k([
                A2(US, h, 13)
            ])),
            fH: "previous",
            fI: A2(fF, k([
                r
            ]), k([
                ad(t.rr)
            ]))
        } : {
            ep: A2(Gk, k([
                Nk("stepper__circle")
            ]), k([
                ad(a)
            ])),
            fH: "next",
            fI: ad(t.rr)
        };
        return A2(Ik, k([
            Nk("stepper__step stepper__step--" + c.fH)
        ]), k([
            c.ep,
            A2(Gk, k([
                Nk("stepper__text")
            ]), k([
                c.fI
            ])),
            A2(IZ, 0 > s(t.kn + 1, u), A2(Gk, k([
                Nk("stepper__line")
            ]), k([
                gx
            ])))
        ]));
    }), iMn = F3(function(n, r, t) {
        return A3(aMn, {
            aU: n.aU,
            a2: n.a2
        }, Eq(r(t)), t);
    }), cMn = F2(function(n, r) {
        var t = n.Ao, e = n.C9;
        if (ED(e)) return Sq;
        if (t.$) return Sq;
        var u = t.a;
        return A2(Ik, k([
            Nk("stepper")
        ]), A2(yu, A2(iMn, {
            aU: u,
            a2: oe(e)
        }, r), e));
    }), oMn = F4(function(n, r, t, e) {
        return n.$ ? Sq : A2(cMn, {
            Ao: Ht(n.a.kn),
            C9: A3(uMn, r, t, e)
        }, tMn);
    }), fMn = F3(function(n, r, t) {
        return A2(Ik, k([
            Nk("text-left"),
            jz(Xjn)
        ]), k([
            A2(fPn, n, t),
            gx,
            A4(oMn, r.j2, r.fF, r.dw, r.Ay),
            A2(px, hu, rMn(r)),
            A2(nMn, n, r)
        ]));
    }), sMn = F2(function(n, r) {
        var t;
        return {
            gF: k([
                A2(Ik, k([
                    Nk("panel")
                ]), (t = r.Ay, t.$ ? Yk : k([
                    A3(fMn, n, r, t.a)
                ])))
            ]),
            wD: n(Id.wD)
        };
    }), lMn = Ux({
        zO: pqn,
        Ab: $qn,
        Ct: hqn,
        Dd: function(n) {
            return xk(k([
                A2(xD, gqn, kqn),
                A2(xD, WCn, p9(n.aW))
            ]));
        },
        DB: oPn,
        DH: sMn
    }), dMn = function(n) {
        return {
            $: 0,
            a: n
        };
    }, bMn = function(n) {
        return {
            $: 3,
            a: n
        };
    }, vMn = F5(function(n, r, t, e, u) {
        return {
            n7: n,
            qa: t,
            sb: e,
            sV: u,
            t6: r
        };
    }), mMn = A3(zy, "name", w$, Ke(function(n) {
        return {
            sS: n
        };
    })), pMn = A2(qy, mMn, Ke(ru)), $Mn = A3(zy, "next_future_unpaid_bill", Vfn, A3(zy, "membership_patients", Ey(Fyn), A3(zy, "first_bill", Vfn, A3(zy, "plan", pMn, A3(zy, "contract_end_date", l_(FC), Ke(vMn)))))), hMn = A2(qy, $Mn, Ke(ru)), gMn = F2(function(n, r) {
        return A2($y, k([
            "contracts",
            r
        ]), gy(n));
    }), wMn = F4(function(n, r, t, e) {
        return A4(dC, n, hMn, e, bC(A2(gMn, r, t)));
    }), kMn = F3(function(n, r, t) {
        return b({
            gx: r.gx,
            eu: oc,
            g0: Rt,
            kj: r.kj,
            e_: Vyn,
            dw: n,
            wL: t.BD.qU,
            w_: t
        }, Hu(k([
            A2(Eu, bMn, by),
            A4(wMn, r.gx, $k(n), t.BD.qU, dMn)
        ])));
    }), xMn = F2(function(n, r) {
        return b(r, Dp);
    }), yMn = F2(function(n, r) {
        return m(r, {
            xE: Ht(2),
            gx: n.gx
        });
    }), _Mn = function(n) {
        return {
            $: 2,
            a: n
        };
    }, CMn = F4(function(n, r, t, e) {
        return A4(vN, n, hMn, e, bC(A2($y, k([
            "renew"
        ]), A2(gMn, r, t))));
    }), DMn = F2(function(n, r) {
        switch(n.$){
            case 0:
                var t = n.a;
                return 2 === t.$ && 5 === t.a.$ && 400 === t.a.a ? v(r, A2(zx, oa, ja), h) : v(m(r, {
                    eu: t
                }), Dp, A2(uA, 0, t));
            case 1:
                return v(r, 3 === r.eu.$ ? A4(CMn, r.gx, $k(r.dw), r.wL, _Mn) : Dp, h);
            case 2:
                var e = n.a, u = Ml(k([
                    b("renewedMembershipId", r.wL)
                ]));
                return v(r, A2(zx, u, ja), A2(uA, 0, e));
            case 3:
                return v(m(r, {
                    g0: Ht(A2(cp, nG, n.a))
                }), Dp, h);
            default:
                return v(r, Dp, h);
        }
    }), AMn = {
        $: 1
    }, qMn = function(n) {
        return {
            $: 4,
            a: n
        };
    }, BMn = function(n) {
        return n.n7;
    }, jMn = function(n) {
        return A2(dP, AA("/"), n);
    }, SMn = function(n) {
        return n.sS;
    }, zMn = function(n) {
        return n.t6;
    }, UMn = function(n) {
        return A2(Ik, h, k([
            A2(Gk, k([
                Nk("text-support")
            ]), k([
                A2(fF, k([
                    Nk("link text-current"),
                    vF(Sx(ja))
                ]), k([
                    ad(n(Vd.Dq))
                ]))
            ])),
            A2(Gk, k([
                Nk("mx-3 text-support")
            ]), k([
                ad("/")
            ])),
            ad("Renew membership")
        ]));
    }, EMn = F3(function(n, r, t) {
        var e = L_n(t.sV), u = t.sb, a = tyn(function(n) {
            return n.qa;
        }(t));
        return A2(Ik, k([
            Nk("text-left mb-5")
        ]), k([
            UMn(r),
            gx,
            A2(mx, k([
                LS(q3)
            ]), k([
                ad("Renew your membership")
            ])),
            A2(lV, h, k([
                A2(iV, k([
                    UZ(12)
                ]), k([
                    A2(hx, k([
                        LS(E4)
                    ]), k([
                        A2(LB, h, k([
                            ad("Plan Name")
                        ]))
                    ])),
                    A2(hx, k([
                        BB
                    ]), k([
                        ad(SMn(zMn(t)))
                    ]))
                ]))
            ])),
            A2(lV, h, k([
                A2(iV, k([
                    UZ(12)
                ]), k([
                    A2(hx, k([
                        LS(E4)
                    ]), k([
                        A2(LB, h, k([
                            ad("Membership ending")
                        ]))
                    ])),
                    A2(hx, k([
                        BB
                    ]), k([
                        ad(A2(uc, "N/A", A2(Cp, jMn, BMn(t))))
                    ]))
                ]))
            ])),
            A2(px, qMn, A5(lCn, !1, n.e_, r, u, n.g0)),
            A3(vCn, r, Ht(e), a),
            A2(fz, k([
                nz,
                QS(AMn)
            ]), k([
                ad(r(Vd.u9))
            ]))
        ]));
    }), PMn = F2(function(n, r) {
        return {
            gF: function() {
                var t = r.eu;
                if (3 === t.$) {
                    var e = t.a;
                    return k([
                        A2(Ik, k([
                            Nk("panel")
                        ]), k([
                            A3(EMn, r, n, e)
                        ]))
                    ]);
                }
                return Yk;
            }(),
            wD: hk(r.dw)
        };
    }), TMn = Ux({
        zO: kMn,
        Ab: xMn,
        Ct: yMn,
        Dd: function() {
            return yk;
        },
        DB: DMn,
        DH: PMn
    }), FMn = F3(function(n, r, t) {
        var e, u = 3 === (e = r.uh).$ ? TX(e.a) : FX(n);
        return A2(zx, t.iu, u ? ha : Wa);
    }), LMn = F3(function(n, r, t) {
        return b({
            kj: r.kj,
            tE: r.tE,
            dw: n,
            w_: t.B9
        }, A3(FMn, n, r, t));
    }), MMn = F2(function(n, r) {
        return b(r, Dp);
    }), HMn = F2(function(n, r) {
        return r;
    }), RMn = F2(function(n, r) {
        return v(r, Dp, h);
    }), OMn = F2(function(n, r) {
        return {
            gF: Yk,
            wD: hk(r.dw)
        };
    }), NMn = Ux({
        zO: LMn,
        Ab: MMn,
        Ct: HMn,
        Dd: function() {
            return yk;
        },
        DB: RMn,
        DH: OMn
    }), IMn = F3(function(n, r, t) {
        var e, u = 3 === (e = r.uh).$ ? TX(e.a) : FX(n);
        return A2(zx, t.iu, u ? ha : Wa);
    }), VMn = F3(function(n, r, t) {
        return b({
            kj: r.kj,
            tE: r.tE,
            dw: n,
            w_: t.B9
        }, A3(IMn, n, r, t));
    }), WMn = F2(function(n, r) {
        return b(r, Dp);
    }), ZMn = F2(function(n, r) {
        return r;
    }), XMn = F2(function(n, r) {
        return v(r, Dp, h);
    }), GMn = F2(function(n, r) {
        return {
            gF: Yk,
            wD: hk(r.dw)
        };
    }), JMn = Ux({
        zO: VMn,
        Ab: WMn,
        Ct: ZMn,
        Dd: function() {
            return yk;
        },
        DB: XMn,
        DH: GMn
    }), YMn = function(n) {
        return b(n, Dp);
    }, QMn = function(n) {
        return {
            zO: F2(function(n, r) {
                return v(r, Dp, h);
            }),
            Ab: rm(A2(Je, ru, YMn)),
            Ct: rm(ru),
            Dd: function() {
                return yk;
            },
            DB: F2(function(n, r) {
                return v(r, Dp, h);
            }),
            DH: n.DH
        };
    }, KMn = QMn({
        DH: function() {
            return {
                gF: k([
                    A2(Ik, k([
                        Nk("panel")
                    ]), k([
                        A2(mx, k([
                            LS(q3)
                        ]), k([
                            ad("Page Not Found")
                        ])),
                        A2(Gk, k([
                            Nk("text-support")
                        ]), k([
                            A2(fF, k([
                                Nk("link"),
                                vF(Sx(Wa))
                            ]), k([
                                ad("Click here")
                            ]))
                        ])),
                        A2(Gk, h, k([
                            ad(" to go to your member portal home page.")
                        ]))
                    ]))
                ]),
                wD: "404"
            };
        }
    }), nHn = function(n) {
        return {
            $: 0,
            a: n
        };
    }, rHn = F5(function(n, r, t, e, u) {
        return {
            pY: u,
            tv: n,
            tE: t,
            up: e,
            wj: r
        };
    }), tHn = A2(Ye, ru, A3(zy, "name", w$, Ke(function(n) {
        return {
            sS: n
        };
    }))), eHn = A2(Ye, ru, A4(Sy, "expires_at", Ay(FC), Rt, A3(zy, "prepaid_charges", Ey(Ixn), A3(zy, "patient", tHn, A3(zy, "status", w$, A3(zy, "package_name", w$, Ke(rHn))))))), uHn = F2(function(n, r) {
        return A2($y, k([
            "patient_packages",
            r
        ]), gy(n));
    }), aHn = F4(function(n, r, t, e) {
        return A4(dC, n, eHn, e, bC(A2(uHn, r, t)));
    }), iHn = F3(function(n, r, t) {
        var e = t.BD, u = $k(n), a = {
            gx: r.gx,
            cv: GL,
            kj: r.kj,
            kQ: e.qU,
            ig: Rt,
            dw: n,
            BW: u
        };
        return b(a, function(n) {
            return A4(aHn, n.gx, n.BW, n.kQ, nHn);
        }(a));
    }), cHn = F2(function(n, r) {
        return b(r, Dp);
    }), oHn = F2(function(n, r) {
        return m(r, {
            xE: Ht(2)
        });
    }), fHn = F2(function(n, r) {
        return A2(aa, n, r);
    }), sHn = F2(function(n, r) {
        if (n.$) {
            var t = n.a;
            return v(m(r, {
                cv: A2(A2(QL, t, r.cv) ? fHn : JL, t, r.cv)
            }), Dp, h);
        }
        var e = n.a;
        return 3 === e.$ ? v(m(r, {
            ig: Ht(e.a)
        }), Dp, h) : v(r, Dp, A2(uA, 0, e));
    }), lHn = F2(function(n, r) {
        return A2(Ik, h, k([
            A2(Gk, k([
                Nk("text-support")
            ]), k([
                A2(fF, k([
                    Nk("link text-current"),
                    vF(Sx(ja))
                ]), k([
                    ad(n(Vd.Dq))
                ]))
            ])),
            A2(Gk, k([
                Nk("mx-3 text-support")
            ]), k([
                ad("/")
            ])),
            ad(r)
        ]));
    }), dHn = function(n) {
        return {
            $: 1,
            a: n
        };
    }, bHn = F2(function(n, r) {
        return r.tt(n);
    }), vHn = F3(function(n, r, t) {
        var e = ee(t.uN), u = "  " + n(bHn(e)), a = t.q9, i = A2(ep, "MM/dd/yyyy", function(n) {
            return n.tb;
        }(t));
        return A2(Ik, k([
            Nk("text-support mt-2"),
            A2(cE, "display", "flex"),
            A2(cE, "align-items", "flex-start")
        ]), k([
            A2(Ik, k([
                A2(cE, "display", "flex"),
                A2(cE, "flex-direction", "column"),
                A2(cE, "align-items", "center"),
                A2(cE, "margin-right", "10px"),
                A2(cE, "padding-top", "6px")
            ]), k([
                A2(Ik, k([
                    A2(cE, "width", "6px"),
                    A2(cE, "height", "6px"),
                    A2(cE, "border-radius", "50%"),
                    A2(cE, "background-color", "currentColor"),
                    A2(cE, "opacity", "0.4"),
                    A2(cE, "flex-shrink", "0")
                ]), h),
                r ? A2(Ik, k([
                    A2(cE, "width", "1px"),
                    A2(cE, "flex", "1"),
                    A2(cE, "background-color", "currentColor"),
                    A2(cE, "opacity", "0.3"),
                    A2(cE, "margin-bottom", "-30px")
                ]), h) : Sq
            ])),
            A2(Gk, h, k([
                a.$ ? ad(i) : A2(fF, k([
                    vF(Sx(_a({
                        qU: a.a
                    }))),
                    Nk("link"),
                    A2(cE, "text-decoration", "underline")
                ]), k([
                    ad(i)
                ])),
                ad(u)
            ]))
        ]));
    }), mHn = F2(function(n, r) {
        var t = oe(r), e = A2(be, F2(function(n, r) {
            return b(n, r);
        }), r);
        return A2(Ik, k([
            A2(cE, "padding-left", "16px")
        ]), A2(yu, function(r) {
            var e = r.b;
            return A3(vHn, n, 0 > s(r.a, t - 1), e);
        }, e));
    }), pHn = F3(function(n, r, t) {
        var e = gyn(t), u = hyn(t), a = $yn(pyn(t)), i = t.nU, c = !ED(i), o = t.qU, f = A2(QL, o, r);
        return A2(Ik, h, k([
            A2(Ik, k([
                Nk("text-support")
            ]), k([
                ad(ee(u) + " " + a + " "),
                c ? A2(Gk, k([
                    Eq(dHn(o)),
                    A2(Wx, "role", "button"),
                    dE(0),
                    A2(Wx, "aria-expanded", f ? "true" : "false"),
                    A2(cE, "cursor", "pointer"),
                    Nk("link text-primary"),
                    A2(cE, "text-decoration", "none")
                ]), k([
                    A2(FB, h, k([
                        ad("(" + ee(e) + " remaining)")
                    ])),
                    f ? A2(Gk, k([
                        Nk("text-support"),
                        A2(cE, "font-size", "30px"),
                        A2(cE, "margin-left", "4px"),
                        A2(cE, "display", "inline-flex"),
                        A2(cE, "align-items", "center"),
                        A2(cE, "vertical-align", "middle")
                    ]), k([
                        ad("\u25B4")
                    ])) : Sq
                ])) : A2(FB, h, k([
                    ad("(" + ee(e) + " remaining)")
                ]))
            ])),
            f && c ? A2(mHn, n, i) : Sq
        ]));
    }), $Hn = F3(function(n, r, t) {
        return A2(Ik, k([
            Nk("mb-5")
        ]), k([
            A2(hx, k([
                Qk(k([
                    Nk("mb-4")
                ]))
            ]), k([
                A2(LB, h, k([
                    ad("Includes")
                ]))
            ])),
            A2(lV, k([
                yan,
                UZ(12)
            ]), k([
                A2(iV, k([
                    UZ(12)
                ]), k([
                    A2(Ik, k([
                        Nk("space-y-4")
                    ]), A2(yu, A2(pHn, n, r), t))
                ]))
            ]))
        ]));
    }), hHn = F4(function(n, r, t, e) {
        var u = r.sS, a = $(t.$ ? "" : n(vyn(A2(ep, "MM/dd/yyyy", t.a))) + ", ", function(n) {
            var r = ke(n);
            if (r.$) return n;
            var t = r.a, e = t.b;
            return $(Fb(Pin(t.a)), e);
        }(e));
        return A2(Ik, k([
            Nk("mb-5")
        ]), k([
            A2(hx, k([
                Qk(k([
                    Nk("mb-4")
                ]))
            ]), k([
                A2(LB, h, k([
                    ad("Patient")
                ]))
            ])),
            A2(lV, k([
                yan,
                UZ(12)
            ]), k([
                A2(iV, k([
                    UZ(12)
                ]), k([
                    A2(LB, h, k([
                        ad(u)
                    ])),
                    A2(hx, k([
                        BB
                    ]), k([
                        ad(a)
                    ]))
                ]))
            ]))
        ]));
    }), gHn = F3(function(n, r, t) {
        var e = t.wj, u = t.tE, a = function(n) {
            return n.up;
        }(t), i = function(n) {
            return n.tv;
        }(t), c = function(n) {
            return n.pY;
        }(t);
        return A2(Ik, k([
            Nk("text-left mb-5")
        ]), k([
            A2(lHn, n, i),
            gx,
            A2(mx, k([
                Qk(k([
                    Nk("mt-8 mb-8")
                ]))
            ]), k([
                ad(i)
            ])),
            A4(hHn, n, u, c, e),
            ED(a) ? Sq : A3($Hn, n, r.cv, a)
        ]));
    }), wHn = F2(function(n, r) {
        var t;
        return {
            gF: k([
                A2(Ik, k([
                    Nk("panel")
                ]), (t = r.ig, t.$ ? Yk : k([
                    A3(gHn, n, r, t.a)
                ])))
            ]),
            wD: n(Vd.Dq)
        };
    }), kHn = Ux({
        zO: iHn,
        Ab: cHn,
        Ct: oHn,
        Dd: function() {
            return yk;
        },
        DB: sHn,
        DH: wHn
    }), xHn = function(n) {
        return {
            $: 0,
            a: n
        };
    }, yHn = function(n) {
        return {
            $: 1,
            a: n
        };
    }, _Hn = F4(function(n, r, t, e) {
        return A4(dC, n, Ly, e, bC(A2($y, k([
            t
        ]), wy(r))));
    }), CHn = F2(function(n, r) {
        if (r.$) return A2(Gk, k([
            Nk("inline-block my-1")
        ]), k([
            ad(n(ab))
        ]));
        var t = r.a;
        return A2(Gk, h, k([
            ad(A2(Fin, n, t)),
            A2(Zin, n, Lin(t)),
            Wyn(t) ? A2(Utn, k([
                1
            ]), k([
                ad(n(Zyn))
            ])) : ad("")
        ]));
    }), DHn = function(n) {
        return Nx({
            qU: n,
            Dr: CHn,
            Dt: function(n) {
                return n.$ ? Rt : Ht(bun(n.a));
            }
        });
    }, AHn = F3(function(n, r, t) {
        var e = t.BD, u = $k(n), a = function() {
            var n = r.tE;
            if (3 === n.$) {
                var t = n.a;
                return b(Ht(ZC(t)), UF(t));
            }
            return b(Rt, "");
        }();
        return b({
            gx: r.gx,
            el: Rt,
            yl: r.yl,
            bd: !1,
            gQ: !1,
            kj: r.kj,
            ks: e.qU,
            bZ: oc,
            a0: Rt,
            e8: oc,
            BK: a.a,
            kU: a.b,
            BO: DHn("checkout-payment-source-select"),
            BP: Mx,
            dw: n,
            BW: u,
            dB: !1,
            CC: Rt
        }, Hu(k([
            A4(_Hn, r.gx, u, e.qU, xHn),
            A3(aen, r.gx, u, yHn)
        ])));
    }), qHn = function(n) {
        return {
            $: 2,
            a: n
        };
    }, BHn = A2(Je, Cp(vun), uc(!1)), jHn = F3(function(n, r, t) {
        return n && BHn(t) && r > 0;
    }), SHn = function(n) {
        var r = n.gx, t = n.BW, e = n.C$, u = n.mi, a = n.Ds;
        if (A3(jHn, n.yl, u, e)) {
            var i = A2(Cp, bun, e);
            return i.$ ? Dp : A5(dun, r, t, i.a, u, a);
        }
        return Dp;
    }, zHn = function(n) {
        return n.lr;
    }, UHn = function(n) {
        return A2(uc, 0, A2(Cp, zHn, n.el));
    }, EHn = F2(function(n, r) {
        return SHn({
            mi: UHn(n),
            gx: n.gx,
            yl: n.yl,
            BW: $k(n.dw),
            C$: r,
            Ds: qHn
        });
    }), PHn = F2(function(n, r) {
        var t = !i(n.yl, r.yl), e = m(r, {
            yl: n.yl,
            e8: t ? oc : r.e8
        });
        return b(e, t ? A2(EHn, e, r.CC) : Dp);
    }), THn = F2(function(n, r) {
        return m(r, {
            xE: Rt
        });
    }), FHn = function(n) {
        return {
            $: 4,
            a: n
        };
    }, LHn = function(n) {
        return {
            $: 0,
            a: n
        };
    }, MHn = function(n) {
        return {
            $: 9,
            a: n
        };
    }, HHn = function(n) {
        return {
            $: 5,
            a: n
        };
    }, RHn = Ke(0), OHn = F4(function(n, r, t, e) {
        return A4(vN, n, RHn, e, A2(xq, t, bC(A2($y, k([
            "cart",
            "checkout"
        ]), gy(r)))));
    }), NHn = function(n) {
        if (n.$) {
            var r = n.a;
            return vk(k([
                b("id", mk(r.qU)),
                b("type", mk("plan")),
                b("owner", mk(r.tq)),
                b("members", A2(wq, mk, r.Av)),
                b("period_in_months", hq(r.BS)),
                b("start_date", mk(r.C3)),
                b("accepted_documents", r.xC)
            ]));
        }
        var t = n.a;
        return vk(k([
            b("id", mk(t.qU)),
            b("type", mk("package")),
            b("owner", mk(t.tq))
        ]));
    }, IHn = F4(function(n, r, t, e) {
        var u = vk(k([
            b("cart", A2(wq, NHn, t.z4)),
            b("payment_method", mk(t.BM))
        ]));
        return A4(OHn, n, r, u, e);
    }), VHn = F2(function(n, r) {
        return 1 === r.$ ? n : r;
    }), WHn = function(n) {
        return A2(VHn, Gb(n), Gb(A2(Tc, Wyn, n)));
    }, ZHn = F3(function(n, r, t) {
        var e = A2(bq, n, r), u = e.a, a = e.c;
        return a.$ || a.a.$ || a.a.a.$ ? v(u, t, !1) : a.a.a.a.$ ? v(u, Rt, !0) : v(u, Ht(a.a.a.a.a), !1);
    }), XHn = F2(function(n, r) {
        switch(n.$){
            case 0:
                return 3 === (q = n.a).$ ? v(l = m(r, {
                    el: Ht(q.a)
                }), A2(EHn, l, l.CC), h) : v(r, Dp, A2(uA, 0, q));
            case 1:
                if (3 === (q = n.a).$) {
                    var t = WHn(q.a);
                    return v(l = m(r, {
                        BP: q,
                        CC: t
                    }), A2(EHn, l, t), h);
                }
                return v(m(r, {
                    BP: q
                }), Dp, A2(uA, 0, q));
            case 2:
                return v(m(r, {
                    e8: n.a
                }), Dp, h);
            case 3:
                var e = A3(ZHn, n.a, r.BO, r.CC), u = e.a, a = e.b, c = e.c, o = !i(A2(Cp, bun, a), A2(Cp, bun, r.CC)), f = function() {
                    if (c) {
                        var n = A6(qin, !1, r.kj, r.dw, r.yl, Rt, r.gx), t = n.b;
                        return b(Ht(n.a), A2(jp, FHn, t));
                    }
                    return b(o ? Rt : r.a0, Dp);
                }(), s = f.b, l = m(r, {
                    bZ: oc,
                    a0: f.a,
                    BO: u,
                    CC: a
                });
                return c ? v(l, s, h) : o ? v(m(l, {
                    e8: oc
                }), A2(EHn, l, a), h) : v(l, Dp, h);
            case 4:
                var d = n.a, p = r.a0;
                if (1 === p.$) return v(r, Dp, h);
                var g = A2(son, d, p.a), w = g.b, x = g.c, y = m(r, {
                    a0: Ht(g.a)
                }), _ = k([
                    A2(jp, FHn, w)
                ]);
                n: for(; !x.$;)switch(x.a.$){
                    case 1:
                        var C = x.a.a, D = 3 !== (P = r.BP).$ || !ED(P.a);
                        return v(m(y, {
                            bZ: Mx
                        }), Hu(A2(Ot, A4(zcn, r.gx, C, {
                            ds: !1,
                            uy: !1,
                            va: Rt,
                            vH: !D
                        }, HHn), _)), h);
                    case 0:
                        var A = x.a.a;
                        return v(m(y, {
                            bZ: oc
                        }), Hu(_), k([
                            rA(A)
                        ]));
                    default:
                        break n;
                }
                return v(y, Hu(_), h);
            case 5:
                var q;
                if (3 === (q = n.a).$) {
                    var B = q.a, j = function() {
                        var n = r.BP;
                        if (3 === n.$) {
                            var t = n.b;
                            return A2(f_, $(n.a, k([
                                B
                            ])), t);
                        }
                        return n;
                    }();
                    return v(l = m(r, {
                        bZ: q,
                        a0: Rt,
                        e8: oc,
                        BP: j,
                        CC: Ht(B)
                    }), A2(EHn, l, Ht(B)), h);
                }
                return v(m(r, {
                    bZ: q
                }), Dp, A2(uA, 0, q));
            case 6:
                return v(m(r, {
                    bZ: oc,
                    a0: Rt
                }), Dp, h);
            case 7:
                return v(r, 1 === r.a0.$ ? Dp : A2(jp, FHn, Ccn), h);
            case 8:
                var S = b(r.BK, r.CC);
                if (S.a.$ || S.b.$) return v(r, Dp, h);
                var z = S.a.a, U = S.b.a;
                return v(m(r, {
                    bd: !0
                }), A4(IHn, r.gx, r.BW, {
                    z4: k([
                        LHn({
                            qU: r.ks,
                            tq: z
                        })
                    ]),
                    BM: bun(U)
                }, MHn), h);
            case 9:
                var E = n.a;
                return 3 === E.$ ? v(m(r, {
                    bd: !1,
                    gQ: !0
                }), Dp, h) : v(m(r, {
                    bd: !1
                }), Dp, A2(uA, 0, E));
            case 10:
                return v(m(r, {
                    dB: !r.dB
                }), Dp, h);
            default:
                return v(r, A2(zx, oa, sa), h);
        }
        var P;
    }), GHn = {
        $: 11
    }, JHn = function(n) {
        return n.aA.nQ;
    }, YHn = function(n) {
        return n.aA.hc;
    }, QHn = function(n) {
        return n.aA.hd;
    }, KHn = function(n) {
        return n.aA.Ar;
    }, nRn = function(n) {
        return n.aA.h1;
    }, rRn = function(n) {
        return n.aA.du;
    }, tRn = function(n) {
        return n.aA.uv;
    }, eRn = function(n) {
        return n.aA.js;
    }, uRn = function(n) {
        return n.aA.dT;
    }, aRn = function(n) {
        return n.aA.wD;
    }, iRn = function(n) {
        return A2(Ik, k([
            Nk("flex flex-col items-center justify-center px-6"),
            A2(cE, "min-height", "calc(100vh - 12rem)")
        ]), k([
            A2(Ik, k([
                Nk("flex flex-col items-center")
            ]), k([
                A2(US, k([
                    mz,
                    Vq("fill-primary-300 scale-[2.66]"),
                    LV(FV)
                ]), 8),
                A2(Ik, k([
                    Nk("mt-14")
                ]), k([
                    A2(XT, k([
                        jX,
                        bz(wF),
                        LS(FS)
                    ]), k([
                        ad(n.wD)
                    ])),
                    A2(Ik, k([
                        Nk("max-w-[14rem] mx-auto")
                    ]), k([
                        A2(hx, k([
                            BB,
                            bz(wF)
                        ]), k([
                            ad(n.gF)
                        ]))
                    ]))
                ]))
            ])),
            A2(Ik, k([
                Nk("w-64 mt-16 [&_.button]:py-3")
            ]), k([
                A2(fz, k([
                    nz,
                    JS,
                    QS(n.AZ)
                ]), k([
                    ad(n.x8)
                ]))
            ]))
        ]));
    }, cRn = {
        $: 6
    }, oRn = {
        $: 12
    }, fRn = {
        $: 7
    }, sRn = function(n) {
        return {
            $: 0,
            a: n
        };
    }, lRn = {
        $: 1
    }, dRn = function(n) {
        return {
            $: 3,
            a: n
        };
    }, bRn = function(n) {
        var r = n.Ai, t = n.yQ;
        return A2(Ik, k([
            Nk("flex w-full")
        ]), k([
            A2(Ik, k([
                Nk("flex-1")
            ]), r),
            A2(Ik, k([
                Nk("hidden md:block")
            ]), k([
                t
            ]))
        ]));
    }, vRn = function(n) {
        return A2(Ik, k([
            Nk("md:hidden mt-auto")
        ]), k([
            n
        ]));
    }, mRn = {
        $: 8
    }, pRn = function(n) {
        return n.wx;
    }, $Rn = function(n) {
        var r = A2(uc, 0, A2(Cp, Qan, n));
        return r > 0 ? A2(Ik, h, k([
            A2(hx, k([
                BB
            ]), k([
                A2(Ik, k([
                    Nk("flex justify-between w-full")
                ]), k([
                    A2(Ik, k([
                        Nk("flex")
                    ]), k([
                        ad("Credit card fee")
                    ])),
                    A2(Ik, k([
                        Nk("flex")
                    ]), k([
                        ad(qtn(r))
                    ]))
                ]))
            ]))
        ])) : Sq;
    }, hRn = {
        $: 10
    }, gRn = F2(function(n, r) {
        return A2(Ik, k([
            Nk("flex justify-between w-full mt-2 text-sm md:text-base")
        ]), k([
            A2(Ik, k([
                Nk("flex")
            ]), k([
                A2(hx, h, k([
                    ad(n)
                ]))
            ])),
            A2(Ik, h, k([
                A2(hx, k([
                    BB
                ]), k([
                    ad(qtn(r))
                ]))
            ]))
        ]));
    }), wRn = F3(function(n, r, t) {
        var e = r.dB ? "text-gray-400 transform rotate-90" : "text-gray-400";
        return A2(Ik, k([
            Nk("mb-4")
        ]), k([
            A2(Ik, k([
                Nk("flex justify-between items-center cursor-pointer py-2"),
                Eq(hRn)
            ]), k([
                A2(hx, k([
                    BB
                ]), k([
                    ad(n(tRn))
                ])),
                A2(px, hu, A2(US, k([
                    Sz,
                    Vq(e)
                ]), 6))
            ])),
            r.dB ? A2(Ik, k([
                Nk("mt-2")
            ]), k([
                A2(px, hu, A2(gRn, A2(uc, "", oA(t)), A2(uc, 0, CB(t))))
            ])) : Sq
        ]));
    }), kRn = F2(function(n, r) {
        return r > 0 ? A2(Ik, h, k([
            A2(hx, k([
                BB
            ]), k([
                A2(Ik, k([
                    Nk("flex justify-between w-full")
                ]), k([
                    A2(Ik, k([
                        Nk("flex")
                    ]), k([
                        ad(n(Fd))
                    ])),
                    A2(Ik, k([
                        Nk("flex")
                    ]), k([
                        ad(qtn(r))
                    ]))
                ]))
            ]))
        ])) : Sq;
    }), xRn = F3(function(n, r, t) {
        var e = MD(r.e8), u = zHn(t), a = A2(uc, u, A2(Cp, Lun, e)), c = !i(r.CC, Rt) && !r.bd;
        return A2(Ik, k([
            Nk("sidebar-wrap -mx-6 sm:-mx-8 sm:px-8")
        ]), k([
            A2(Ik, k([
                Nk("flex justify-between items-center mb-2")
            ]), k([
                A2(hx, k([
                    Hz
                ]), k([
                    ad(n(QHn))
                ])),
                A2(px, hu, A7(kPn, n, a, !1, Rt, yz, !1, !1))
            ])),
            gx,
            A2(px, hu, A2(kRn, n, pRn(t))),
            A2(px, hu, $Rn(e)),
            A3(wRn, n, r, t),
            A2(fz, k([
                nz,
                JS,
                QS(mRn),
                ZS(!c),
                Don(r.bd)
            ]), k([
                ad(n(JHn))
            ]))
        ]));
    }), yRn = F2(function(n, r) {
        return A2(Ik, k([
            Nk("mb-6 mt-4")
        ]), k([
            A2(hx, k([
                LS(FS)
            ]), k([
                A2(LB, h, k([
                    ad(n)
                ]))
            ])),
            A2(hx, k([
                BB
            ]), k([
                ad(r)
            ]))
        ]));
    }), _Rn = function(n) {
        var r, t = n.BP;
        switch(t.$){
            case 3:
                var e = t.a;
                return A2(Ik, k([
                    Nk("mb-6")
                ]), k([
                    A2(hx, k([
                        LS(FS)
                    ]), k([
                        A2(LB, h, k([
                            ad(n.BN)
                        ])),
                        A2(Gk, k([
                            Nk("text-danger")
                        ]), k([
                            ad(" *")
                        ]))
                    ])),
                    A2(px, n.Be, A4(AU, n.wT, k([
                        Jz(n.CC),
                        ZL(n.wT(hfn)),
                        Wz
                    ]), (r = A2(yu, function(n) {
                        return A2(Xz, h, sRn(n));
                    }, e), ED(r) ? k([
                        A2(Xz, h, lRn)
                    ]) : A2(Ot, A2(Xz, h, lRn), A2(Ot, IL, r))), n.BO))
                ]));
            case 1:
                return A2(Ik, k([
                    Nk("mb-6")
                ]), Yk);
            default:
                return A2(Ik, k([
                    Nk("mb-6")
                ]), k([
                    A2(hx, k([
                        BB
                    ]), k([
                        ad(n.AF)
                    ]))
                ]));
        }
    }, CRn = function(n) {
        return A2(Ik, h, k([
            A2(yRn, n.As, n.kU),
            _Rn(n)
        ]));
    }, DRn = function(n) {
        var r = n.wT, t = n.z_, e = n.z1, u = n.AR, a = n.AV;
        return A2(Ik, k([
            Nk("flex gap-2 mt-4")
        ]), k([
            A2(fz, k([
                CU,
                QS(u)
            ]), k([
                ad(r(a2))
            ])),
            A2(fz, k([
                nz,
                QS(a),
                ZS(!t),
                Don(e)
            ]), k([
                ad(r(ab))
            ]))
        ]));
    }, ARn = F3(function(n, r, t) {
        var e = MD(r.e8), u = zHn(t), a = A2(uc, u, A2(Cp, Lun, e)), c = !i(r.CC, Rt) && !r.bd;
        return A2(Ik, k([
            Nk("sidebar-wrap")
        ]), k([
            A2(Ik, k([
                Nk("flex justify-between items-center mb-2")
            ]), k([
                A2(hx, k([
                    Hz
                ]), k([
                    ad(n(QHn))
                ])),
                A2(px, hu, A7(kPn, n, a, !1, Rt, yz, !1, !1))
            ])),
            A2(px, hu, A2(kRn, n, pRn(t))),
            A2(px, hu, $Rn(e)),
            A3(wRn, n, r, t),
            A2(fz, k([
                nz,
                JS,
                QS(mRn),
                ZS(!c),
                Don(r.bd)
            ]), k([
                ad(n(JHn))
            ]))
        ]));
    }), qRn = F3(function(n, r, t) {
        return BX(k([
            SX({
                AT: oRn,
                wD: n(aRn)
            }),
            gx,
            bRn({
                yQ: A3(ARn, n, r, t),
                Ai: k([
                    CRn({
                        As: n(KHn),
                        AF: n(nRn),
                        Be: dRn,
                        kU: r.kU,
                        BN: n(rRn),
                        BO: r.BO,
                        BP: r.BP,
                        CC: i(r.a0, Rt) ? A2(Cp, sRn, r.CC) : Ht(lRn),
                        wT: n
                    }),
                    function() {
                        var t = r.a0;
                        if (t.$) return Sq;
                        var e = t.a, u = 1 === r.bZ.$;
                        return A2(Ik, k([
                            Nk("mb-6")
                        ]), $(A2(yu, px(FHn), nfn(e)), k([
                            DRn({
                                z_: Con(e),
                                z1: u,
                                AR: cRn,
                                AV: fRn,
                                wT: n
                            })
                        ])));
                    }()
                ])
            }),
            vRn(A3(xRn, n, r, t))
        ]));
    }), BRn = F2(function(n, r) {
        return {
            gF: k([
                function() {
                    if (r.gQ) return iRn({
                        gF: n(eRn),
                        x8: n(YHn),
                        AZ: GHn,
                        wD: n(uRn)
                    });
                    var t = r.el;
                    return t.$ ? A2(Ik, k([
                        Nk("panel")
                    ]), Yk) : A3(qRn, n, r, t.a);
                }()
            ]),
            wD: n(aRn)
        };
    }), jRn = Ux({
        zO: AHn,
        Ab: PHn,
        Ct: THn,
        Dd: function(n) {
            return n.a0.$ ? yk : A2(xD, FHn, ocn);
        },
        DB: XHn,
        DH: BRn
    }), SRn = {
        $: 0
    }, zRn = function(n) {
        return {
            $: 0,
            a: n
        };
    }, URn = function(n) {
        return A3(aen, n.gx, $k(n.dw), zRn);
    }, ERn = F3(function(n, r) {
        var t = {
            ce: SRn,
            gx: r.gx,
            kj: r.kj,
            dw: n,
            v5: oc,
            jx: r.jx
        };
        return b(t, URn(t));
    }), PRn = F2(function(n, r) {
        return b(r, Dp);
    }), TRn = F2(function(n, r) {
        return m(r, {
            xE: Ht(3)
        });
    }), FRn = F2(function(n, r) {
        return {
            $: 4,
            a: n,
            b: r
        };
    }), LRn = function(n) {
        return {
            $: 1,
            a: n
        };
    }, MRn = function(n) {
        return {
            $: 2,
            a: n
        };
    }, HRn = F2(function(n, r) {
        return {
            $: 2,
            a: n,
            b: r
        };
    }), RRn = F4(function(n, r, t, e) {
        return A4(kq, n, RHn, e, bC(A2($y, k([
            bun(t),
            "default"
        ]), uen(r))));
    }), ORn = F2(function(n, r) {
        return r.tU(n);
    }), NRn = F2(function(n, r) {
        return r.tV(n);
    }), IRn = lC("delete"), VRn = F4(function(n, r, t, e) {
        return A4(IRn, n, RHn, e, bC(A2($y, k([
            bun(t)
        ]), uen(r))));
    }), WRn = F6(function(n, r, t, e, u, a) {
        return 3 === e.$ ? v(m(n, {
            v5: Mx
        }), Hu(k([
            URn(n),
            A2(w7, a, h)
        ])), k([
            A2(nA, 3, u(A2(Fin, r, t)))
        ])) : v(n, Dp, A2(uA, 0, e));
    }), ZRn = F2(function(n, r) {
        switch(n.$){
            case 0:
                var t = n.a;
                return 3 === t.$ ? v(m(r, {
                    ce: SRn,
                    v5: t
                }), Dp, h) : v(m(r, {
                    ce: SRn,
                    v5: oc
                }), Dp, A2(uA, 0, t));
            case 1:
                return v(m(r, {
                    ce: MRn(bun(e = n.a))
                }), A4(VRn, r.gx, $k(r.dw), e, HRn(e)), h);
            case 2:
                var e = n.a, u = n.b;
                return A6(WRn, r, Rk(r.kj), e, u, NRn, "Payment Method Removed");
            case 3:
                return v(m(r, {
                    ce: LRn(bun(e = n.a))
                }), A4(RRn, r.gx, $k(r.dw), e, FRn(e)), h);
            default:
                return e = n.a, u = n.b, A6(WRn, r, Rk(r.kj), e, u, ORn, "Default Payment Method Changed");
        }
    }), XRn = function(n) {
        return function(n) {
            return {
                $: 11,
                a: n
            };
        }(n);
    }, GRn = function(n) {
        return {
            $: 3,
            a: n
        };
    }, JRn = function(n) {
        return {
            $: 1,
            a: n
        };
    }, YRn = function(n) {
        return n.Cg;
    }, QRn = function(n) {
        return n.pp;
    }, KRn = function(n) {
        return Sx(Ha({
            qU: bun(n) + "/edit"
        }));
    }, nOn = F2(function(n, r) {
        return vun(r) ? A2(Gk, k([
            Nk("button button--link ml-4 mr-4")
        ]), k([
            A2(gV, k([
                vV(KRn(r)),
                XRn("editPaymentMethod")
            ]), k([
                ad(n(QRn))
            ]))
        ])) : Sq;
    }), rOn = F3(function(n, r, t) {
        return Wyn(t) ? A2(Ik, k([
            Nk("float-right mt-3 ml-0 md:ml-8")
        ]), k([
            A2(Gk, h, k([
                A2(US, k([
                    Sz
                ]), 12),
                A2(PB, k([
                    EB
                ]), k([
                    ad(n(bb))
                ]))
            ])),
            A2(nOn, n, t)
        ])) : A2(Ik, k([
            Nk("float-right mt-3")
        ]), k([
            A2(fz, k([
                r4,
                QS(GRn(t)),
                vz(k([
                    Nk("ml-0 mr-4 md:ml-6")
                ])),
                Don(i(r, LRn(bun(t)))),
                ZS(!i(r, SRn))
            ]), k([
                ad(n(mb))
            ])),
            A2(nOn, n, t),
            A2(fz, k([
                r4,
                QS(JRn(t)),
                Don(i(r, MRn(bun(t)))),
                ZS(!i(r, SRn))
            ]), k([
                ad(n(YRn))
            ]))
        ]));
    }), tOn = F2(function(n, r) {
        return r.lT(n);
    }), eOn = F3(function(n, r, t) {
        return A2(t.pZ, n, r);
    }), uOn = F2(function(n, r) {
        return A2(Cp, function(t) {
            var e = t.a, u = t.b;
            return A2(PB, 4 === Lin(r) ? k([
                E1
            ]) : h, A3(Je, ad, Gq, n(A2(eOn, ee(e), ee(u)))));
        }, function(n) {
            if (n.$) return Rt;
            var r = n.a;
            return A3(F0, nC, r.hj, r.hk);
        }(r));
    }), aOn = function(n) {
        return n.$ ? Rt : n.a.xy;
    }, iOn = F2(function(n, r) {
        return A2(Cp, function(r) {
            return ad(n(xb) + " " + r);
        }, aOn(r));
    }), cOn = F3(function(n, r, t) {
        var e;
        return A2(Ik, h, k([
            A2(Ik, k([
                Nk("text-left")
            ]), k([
                A2(PB, h, k([
                    ad(A2(Fin, n, t))
                ])),
                A2(px, hu, A2(Zin, n, Lin(t)))
            ])),
            A2(Ik, k([
                Nk("text-left")
            ]), A2(SF, ad(", "), A2(Ep, ru, k([
                Ht(ad(n(tOn(A2(r, 0, (e = t, e.a.yA)))))),
                A2(uOn, n, t),
                A2(iOn, n, t)
            ]))))
        ]));
    }), oOn = F4(function(n, r, t, e) {
        return A2(lV, k([
            eyn,
            dV(NZ)
        ]), k([
            A2(iV, k([
                UZ(12),
                GZ(7)
            ]), k([
                A3(cOn, n, r, e)
            ])),
            Gan(k([
                UZ(12),
                GZ(1)
            ])),
            A2(iV, k([
                UZ(12),
                GZ(4)
            ]), k([
                A3(rOn, n, t, e)
            ]))
        ]));
    }), fOn = F4(function(n, r, t, e) {
        return A2(yu, A3(oOn, n, r, t), e);
    }), sOn = F2(function(n, r) {
        return {
            gF: k([
                A2(Ik, k([
                    Nk("panel")
                ]), function() {
                    var t = r.v5;
                    switch(t.$){
                        case 3:
                            var e = t.a;
                            return k([
                                A2(lV, h, k([
                                    A2(iV, k([
                                        UZ(12)
                                    ]), ED(e) ? MS(n(kb)) : A4(fOn, n, r.jx, r.ce, e))
                                ])),
                                A2(lV, h, k([
                                    A2(iV, k([
                                        UZ(12),
                                        GZ(4)
                                    ]), k([
                                        A2(gV, k([
                                            vV(Sx(Ha({
                                                qU: "new"
                                            }))),
                                            XRn("addPaymentMethod"),
                                            bV,
                                            Dun
                                        ]), k([
                                            ad(n(ab))
                                        ]))
                                    ]))
                                ]))
                            ]);
                        case 2:
                            return B3(n(vb));
                        default:
                            return Yk;
                    }
                }())
            ]),
            wD: n(hb)
        };
    }), lOn = Ux({
        zO: ERn,
        Ab: PRn,
        Ct: TRn,
        Dd: function() {
            return yk;
        },
        DB: ZRn,
        DH: sOn
    }), dOn = function(n) {
        return {
            $: 2,
            a: n
        };
    }, bOn = F3(function(n, r, t) {
        var e = t.B9, u = A2(Zu, "replaces_payment_method", t.iu), a = A6(qin, !1, r.kj, n, r.yl, Rt, r.gx), i = b(a.a, A2(jp, dOn, a.b)), c = i.a, o = i.b;
        return b({
            gx: r.gx,
            yl: r.yl,
            kj: r.kj,
            az: oc,
            tF: r.tL,
            $8: Bin(r),
            cG: c,
            dw: n,
            uy: !1,
            va: u,
            w_: e
        }, o);
    }), vOn = F2(function(n, r) {
        return b(m(r, {
            yl: n.yl,
            $8: Bin(n)
        }), Dp);
    }), mOn = F2(function(n, r) {
        return m(r, {
            xE: Ht(3)
        });
    }), pOn = function(n) {
        return {
            $: 0,
            a: n
        };
    }, $On = F2(function(n, r) {
        switch(n.$){
            case 0:
                var t = n.a;
                switch(t.$){
                    case 2:
                        var e = A6(qin, !1, r.kj, r.dw, r.yl, Rt, r.gx), u = e.b;
                        return v(m(r, {
                            az: t,
                            cG: e.a
                        }), A2(jp, dOn, u), A2(uA, 0, t));
                    case 3:
                        var a = t.a;
                        return v(m(r, {
                            az: t
                        }), Hu(k([
                            A2(zx, oa, Ma),
                            A2(w7, "Payment Method Added", h),
                            Wyn(a) ? A2(w7, "Default Payment Method Changed", h) : Dp
                        ])), k([
                            A2(nA, 3, ob)
                        ]));
                    default:
                        return v(m(r, {
                            az: t
                        }), Dp, A2(uA, 0, t));
                }
            case 2:
                var i = A2(son, n.a, r.cG), c = i.b, o = i.c, f = m(r, {
                    cG: i.a
                }), s = k([
                    A2(jp, dOn, c)
                ]);
                n: for(; !o.$;)switch(o.a.$){
                    case 1:
                        var l = o.a.a;
                        return v(m(f, {
                            az: Mx
                        }), Hu(A2(Ot, A4(zcn, r.gx, l, {
                            ds: !1,
                            uy: r.uy,
                            va: r.va,
                            vH: !0
                        }, pOn), s)), h);
                    case 0:
                        var d = o.a.a;
                        return v(m(f, {
                            az: oc
                        }), Hu(s), k([
                            rA(d)
                        ]));
                    default:
                        break n;
                }
                return v(f, Hu(s), h);
            case 1:
                return v(m(r, {
                    az: Mx
                }), A2(jp, dOn, Ccn), h);
            default:
                return v(m(r, {
                    uy: n.a
                }), Dp, h);
        }
    }), hOn = F2(function(n, r) {
        return k([
            A2(Ik, k([
                Nk("panel")
            ]), k([
                A2(mx, k([
                    LS(q3)
                ]), k([
                    ad(n(gb))
                ])),
                A2(hx, k([
                    BB
                ]), k([
                    A4(xL, hk(r), kF(r), Ht("This link is invalid, you may have already used it. If you need to update your payment information again"), Ht("to request a new link."))
                ]))
            ]))
        ]);
    }), gOn = qB(0), wOn = function(n) {
        return A2(zZ, 3, n);
    }, kOn = {
        $: 1
    }, xOn = F2(function(n, r) {
        return A2(fz, k([
            nz,
            JS,
            Don(i(r.az, Mx)),
            ZS(i(r.az, Mx) || !Con(r.cG)),
            QS(kOn)
        ]), k([
            ad(n($b))
        ]));
    }), yOn = F3(function(n, r, t) {
        return A2(Ik, h, k([
            A3(Bon, n, r, t),
            qfn(r)
        ]));
    }), _On = function(n) {
        return {
            $: 3,
            a: n
        };
    }, COn = F4(function(n, r, t, e) {
        return r ? A2(lV, k([
            dV(FV)
        ]), k([
            A2(iV, h, k([
                A2(QW, k([
                    ZW(t),
                    WW(_On),
                    VW(e)
                ]), k([
                    ad(n(pb))
                ]))
            ]))
        ])) : Sq;
    }), DOn = F2(function(n, r) {
        return k([
            A2(Ik, h, k([
                A2(mx, k([
                    LS(q3)
                ]), k([
                    ad(n(ib))
                ]))
            ])),
            A2(lV, k([
                dV(Htn),
                dV(NZ)
            ]), k([
                A2(iV, k([
                    dV(NZ)
                ]), A2(yu, px(dOn), nfn(r.cG)))
            ])),
            A4(COn, n, r.$8, r.uy, i(r.az, Mx)),
            gx,
            A3(yOn, !1, n, hk(r.dw)),
            gx,
            A2(lV, k([
                dV(Htn),
                dV(NZ)
            ]), k([
                Gan(k([
                    UZ(0),
                    Oun(3),
                    wOn(4)
                ])),
                A2(iV, k([
                    Oun(6),
                    wOn(4)
                ]), k([
                    A2(xOn, n, r)
                ]))
            ]))
        ]);
    }), AOn = F2(function(n, r) {
        return k([
            A2(Ik, k([
                Nk("panel panel-success")
            ]), 3 === r.az.$ ? k([
                A2(lV, k([
                    uV(wF)
                ]), k([
                    A2(iV, k([
                        UZ(12)
                    ]), k([
                        A2(UV, k([
                            gOn
                        ]), k([
                            ad(n(wb))
                        ]))
                    ]))
                ]))
            ]) : A2(DOn, n, r))
        ]);
    }), qOn = F2(function(n, r) {
        return {
            gF: yx(r.gx) ? A2(AOn, n, r) : A2(hOn, n, r.dw),
            wD: hk(r.dw)
        };
    }), BOn = Ux({
        zO: bOn,
        Ab: vOn,
        Ct: mOn,
        Dd: function() {
            return xk(k([
                A2(xD, dOn, ocn),
                yk
            ]));
        },
        DB: $On,
        DH: qOn
    }), jOn = function(n) {
        return {
            $: 3,
            a: n
        };
    }, SOn = {
        $: 0
    }, zOn = function(n) {
        return {
            $: 4,
            a: n
        };
    }, UOn = {
        hj: Rt,
        hk: Rt,
        xy: ""
    }, EOn = function(n) {
        return A2($y, k([
            "cards"
        ]), gy(n));
    }, POn = F4(function(n, r, t, e) {
        return A4(dC, n, een, e, bC(A2($y, k([
            t
        ]), EOn(r))));
    }), TOn = function(n) {
        return A2(uc, "", A2(tjn, 2, A2(Tc, function(n) {
            return "" !== n;
        }, A2(ae, "/", n.BJ))));
    }, FOn = k([
        0,
        1
    ]), LOn = function(n) {
        return n ? "ExpDate" : "Zip";
    }, MOn = F3(function(n, r, t) {
        var e = t.B9;
        return b({
            gx: r.gx,
            gL: oc,
            g0: Rt,
            kj: r.kj,
            kk: AO(UOn),
            e2: id({
                qU: "month",
                Dr: F2(function(n, r) {
                    return r;
                }),
                Dt: function(n) {
                    return Ht(n);
                }
            }),
            az: oc,
            dw: n,
            wj: SOn,
            w_: e,
            x: A2(jO, FOn, LOn),
            fU: id({
                qU: "year",
                Dr: F2(function(n, r) {
                    return ee(r);
                }),
                Dt: function(n) {
                    return Ht(ee(n));
                }
            })
        }, Hu(k([
            A2(Eu, zOn, vy),
            A4(POn, r.gx, $k(n), TOn(e), jOn)
        ])));
    }), HOn = F2(function(n, r) {
        return b(r, Dp);
    }), ROn = F2(function(n, r) {
        return m(r, {
            xE: Ht(3)
        });
    }), OOn = function(n) {
        return {
            $: 2,
            a: n
        };
    }, NOn = function(n) {
        return {
            $: 2,
            a: n
        };
    }, IOn = {
        $: 1
    }, VOn = function(n) {
        return {
            $: 0,
            a: n
        };
    }, WOn = function(n) {
        return {
            $: 1,
            a: n
        };
    }, ZOn = F2(function(n, r) {
        return {
            $: 6,
            a: n,
            b: r
        };
    }), XOn = F5(function(n, r, t, e, u) {
        return A4(kq, n, RHn, u, A2(xq, function(n) {
            return vk(k([
                b("card", vk(k([
                    b("exp_month", A2(yN, hq, n.hj)),
                    b("exp_year", A2(yN, hq, n.hk)),
                    b("zip", A2(yN, mk, n.xy))
                ])))
            ]));
        }(e), bC(A2($y, k([
            t
        ]), EOn(r)))));
    }), GOn = F4(function(n, r, t, e) {
        var u = jN(n.kk), a = {
            hj: u.hj,
            hk: u.hk,
            xy: Ht(u.xy)
        };
        return A5(XOn, n.gx, r, TOn(t), a, ZOn(e));
    }), JOn = F2(function(n, r) {
        switch(n.$){
            case 0:
                return m(r, {
                    xy: n.a
                });
            case 1:
                return m(r, {
                    hj: lu(n.a)
                });
            default:
                return m(r, {
                    hk: lu(n.a)
                });
        }
    }), YOn = F2(function(n, r) {
        var t = b(1, JN(A2(XN, YN, Kcn))), e = b(r.hk, r.hj);
        if (e.a.$ || e.b.$) return k([
            t
        ]);
        var u = e.a.a, a = e.b.a, c = A2(uc, 0, A2(Cp, Dv, n)), o = A2(uc, 0, A2(Cp, Uv, n));
        return i(c, u) && 0 > s(a, o) ? k([
            t
        ]) : h;
    }), QOn = function(n) {
        var r = n.xy;
        return tI(r) ? k([
            b(0, JN(A2(XN, YN, jpn)))
        ]) : Npn(r) ? h : k([
            b(0, aI(zpn))
        ]);
    }, KOn = F2(function(n, r) {
        var t = n.kk, e = A2(uc, "", aOn(r)), u = jN(t), a = function(n) {
            return n.$ ? Rt : n.a.hk;
        }(r), i = function(n) {
            return n.$ ? Rt : n.a.hj;
        }(r);
        return m(u, {
            hj: i,
            hk: a,
            xy: e
        });
    }), nNn = F2(function(n, r) {
        return A2(DO, n, r.b);
    }), rNn = F3(function(n, r, t) {
        switch(r.$){
            case 3:
                return v(m(n, {
                    gL: Mx
                }), A2(zx, oa, Ma), k([
                    A2(nA, 3, t)
                ]));
            case 2:
                return v(m(n, {
                    wj: NOn(yon(r.a))
                }), Dp, A2(uA, 0, r));
            default:
                return v(n, Dp, A2(uA, 0, r));
        }
    }), tNn = F2(function(n, r) {
        switch(n.$){
            case 4:
                var t = n.a, e = Dv(t);
                return v(m(r, {
                    g0: Ht(t),
                    kk: A3(WI, JOn, OOn(ee(e)), r.kk)
                }), Dp, h);
            case 3:
                switch((x = n.a).$){
                    case 3:
                        return v(m(r, {
                            gL: x,
                            kk: s = A2(nNn, A2(KOn, r, x.a), r.kk),
                            wj: IOn
                        }), Dp, h);
                    case 2:
                        return v(m(r, {
                            gL: oc,
                            wj: NOn(yon(g = x.a))
                        }), Dp, A2(uA, 0, x));
                    default:
                        return v(m(r, {
                            gL: oc
                        }), Dp, A2(uA, 0, x));
                }
            case 0:
                var u = n.a, a = jN(r.kk).hj, i = A2(bq, u, r.e2), c = i.a, o = i.b, f = (l = i.c).$ || l.a.$ ? ee(A2(uc, 1, a)) : A2(uc, "1", l.a.a), s = A3(WI, JOn, function(n) {
                    return {
                        $: 1,
                        a: n
                    };
                }(f), r.kk);
                return v(m(r, {
                    kk: s,
                    e2: c
                }), A2(jp, VOn, o), h);
            case 1:
                u = n.a;
                var l, d = jN(r.kk).hk, b = A2(bq, u, r.fU);
                return c = b.a, o = b.b, v(m(r, {
                    kk: s = A3(WI, JOn, OOn(ee(A2(uc, 0, f = (l = b.c).$ || l.a.$ ? d : l.a.a))), r.kk),
                    fU: c
                }), A2(jp, WOn, o), h);
            case 2:
                var p = n.a, $ = r.wj;
                switch($.$){
                    case 1:
                        return v(m(r, {
                            kk: A3(WI, JOn, p, r.kk)
                        }), Dp, h);
                    case 2:
                        var g = $.a;
                        return v(m(r, {
                            kk: A3(WI, JOn, p, r.kk),
                            wj: NOn(g)
                        }), Dp, h);
                    default:
                        return v(r, Dp, h);
                }
            case 5:
                var w = n.a;
                if (3 === w.$) {
                    var x = w.a, y = ZN(k([
                        YOn(r.g0),
                        QOn
                    ])), _ = A2(wI, y, r.kk);
                    return _.$ ? v(m(r, {
                        kk: _.a
                    }), Dp, h) : v(r, A4(GOn, r, $k(r.dw), r.w_, x), h);
                }
                return v(r, Dp, h);
            default:
                return A3(rNn, r, n.b, wb);
        }
    }), eNn = F2(function(n, r) {
        return k([
            A2(Ik, k([
                Nk("panel")
            ]), k([
                A2(mx, k([
                    LS(q3)
                ]), k([
                    ad(n(gb))
                ])),
                A2(hx, k([
                    BB
                ]), k([
                    A4(xL, hk(r), kF(r), Ht("This link is invalid, you may have already used it. If you need to update your payment information again"), Ht("to request a new link."))
                ]))
            ]))
        ]);
    }), uNn = function(n) {
        return {
            $: 2,
            a: n
        };
    }, aNn = function(n) {
        return {
            $: 0,
            a: n
        };
    }, iNn = F2(function(n, r) {
        return !ED(A2(iW, r, n.kk));
    }), cNn = k([
        "1",
        "2",
        "3",
        "4",
        "5",
        "6",
        "7",
        "8",
        "9",
        "10",
        "11",
        "12"
    ]), oNn = function(n) {
        return A2(gV, k([
            bV,
            Dun,
            vV(Sx(Ma))
        ]), k([
            ad(n(a2))
        ]));
    }, fNn = function(n) {
        return {
            $: 5,
            a: n
        };
    }, sNn = F2(function(n, r) {
        return A2(fz, k([
            nz,
            JS,
            Don(i(r.az, Mx)),
            ZS(i(r.az, Mx)),
            QS(fNn(r.gL))
        ]), k([
            ad(n($hn))
        ]));
    }), lNn = function(n) {
        var r = n.g0, t = function() {
            if (r.$) return h;
            var n = Dv(r.a);
            return A2(de, n, n + 10);
        }();
        return A2(yu, function(n) {
            return A2(Xz, h, n);
        }, t);
    }, dNn = F2(function(n, r) {
        var t = jN(r.kk), e = t.xy, u = t.hj, a = t.hk;
        return k([
            A2(Ik, h, k([
                A2(mx, k([
                    LS(q3)
                ]), k([
                    ad(n(sb))
                ]))
            ])),
            A2(Ik, h, k([
                function() {
                    var t = r.gL;
                    if (3 === t.$) {
                        var i = t.a;
                        return A2(Ik, h, k([
                            A2(lV, h, k([
                                A2(iV, k([
                                    UZ(12)
                                ]), k([
                                    A2(AW, k([
                                        bW(n(cb))
                                    ]), k([
                                        ad(A2(Fin, n, i))
                                    ]))
                                ]))
                            ])),
                            A2(lV, h, k([
                                A2(iV, k([
                                    Oun(6)
                                ]), k([
                                    A2(AW, k([
                                        bW(n(lb)),
                                        hW(!0)
                                    ]), k([
                                        A2(px, VOn, A4(AU, n, k([
                                            Jz(A2(Cp, ee, u))
                                        ]), A2(yu, function(n) {
                                            return A2(Xz, h, n);
                                        }, cNn), r.e2))
                                    ])),
                                    A2(OW, n, A2(iW, 1, r.kk))
                                ])),
                                A2(iV, k([
                                    Oun(6)
                                ]), k([
                                    A2(AW, k([
                                        bW(n(db)),
                                        hW(!0)
                                    ]), k([
                                        A2(px, WOn, A4(AU, n, k([
                                            Jz(a)
                                        ]), lNn(r), r.fU))
                                    ]))
                                ]))
                            ])),
                            A2(lV, h, k([
                                A2(iV, k([
                                    UZ(12)
                                ]), k([
                                    A2(AW, k([
                                        bW(n(xb)),
                                        hW(!0)
                                    ]), k([
                                        yP(k([
                                            bP(e),
                                            lP(n(yb)),
                                            xZ(A2(sc, uNn, aNn)),
                                            oZ(A2(iNn, r, 0)),
                                            aX("zipCode")
                                        ])),
                                        A2(OW, n, A2(iW, 0, r.kk))
                                    ]))
                                ]))
                            ])),
                            A2(lV, k([
                                dV(Htn),
                                dV(NZ)
                            ]), k([
                                A2(iV, k([
                                    GZ(2)
                                ]), k([
                                    A2(sNn, n, r)
                                ])),
                                A2(iV, k([
                                    GZ(2)
                                ]), k([
                                    oNn(n)
                                ]))
                            ]))
                        ]));
                    }
                    return Sq;
                }()
            ]))
        ]);
    }), bNn = F2(function(n, r) {
        return k([
            A2(Ik, k([
                Nk("panel panel-success")
            ]), 3 === r.az.$ ? k([
                A2(lV, k([
                    uV(wF)
                ]), k([
                    A2(iV, k([
                        UZ(12)
                    ]), k([
                        A2(UV, k([
                            gOn
                        ]), k([
                            ad(n(wb))
                        ]))
                    ]))
                ]))
            ]) : A2(dNn, n, r))
        ]);
    }), vNn = F2(function(n, r) {
        return {
            gF: yx(r.gx) ? A2(bNn, n, r) : A2(eNn, n, r.dw),
            wD: n(sb)
        };
    }), mNn = Ux({
        zO: MOn,
        Ab: HOn,
        Ct: ROn,
        Dd: function() {
            return yk;
        },
        DB: tNn,
        DH: vNn
    }), pNn = function(n) {
        return {
            $: 2,
            a: n
        };
    }, $Nn = function(n) {
        return {
            $: 0,
            a: n
        };
    }, hNn = function(n) {
        return {
            $: 1,
            a: n
        };
    }, gNn = function(n) {
        return {
            $: 3,
            a: n
        };
    }, wNn = F3(function(n, r, t) {
        var e = t.BD, u = vA(A2(cp, r.fL, r.bf)), a = $k(n), i = function() {
            var n = r.tE;
            if (3 === n.$) {
                var t = n.a;
                return b(Ht(ZC(t)), UF(t));
            }
            return b(Rt, "");
        }(), c = i.a, o = i.b, f = function() {
            if (c.$) return Dp;
            var n = c.a;
            return A7(nBn, r.gx, a, Ht(e.qU), n, h, !1, hNn);
        }(), s = A2(wk, r9(ld), A3(X3, !0, r.gx, a)), l = s.b;
        return b({
            gx: r.gx,
            el: Rt,
            yl: r.yl,
            bd: !1,
            gQ: !1,
            hb: Mx,
            aW: s.a,
            kj: r.kj,
            bZ: oc,
            a0: Rt,
            e8: oc,
            BK: c,
            kU: o,
            BO: DHn("plan-checkout-payment-source-select"),
            BP: Mx,
            t7: e.qU,
            dw: n,
            CC: Rt,
            b7: !1,
            lo: u
        }, Hu(k([
            A4(_Hn, r.gx, a, e.qU, $Nn),
            f,
            A2(jp, pNn, l),
            A3(aen, r.gx, a, gNn)
        ])));
    }), kNn = function(n) {
        return {
            $: 4,
            a: n
        };
    }, xNn = function(n) {
        return n.k5;
    }, yNn = function(n) {
        return n.k7;
    }, _Nn = function(n) {
        var r = n.el;
        if (r.$) return 0;
        var t = r.a;
        return A2(uc, 0, yNn(t)) + A2(uc, 0, A2(VHn, CB(t), xNn(t))) + pRn(t);
    }, CNn = F2(function(n, r) {
        return SHn({
            mi: _Nn(n),
            gx: n.gx,
            yl: n.yl,
            BW: $k(n.dw),
            C$: r,
            Ds: kNn
        });
    }), DNn = F2(function(n, r) {
        var t = !i(n.yl, r.yl), e = m(r, {
            yl: n.yl,
            e8: t ? oc : r.e8
        });
        return b(e, t ? A2(CNn, e, r.CC) : Dp);
    }), ANn = F2(function(n, r) {
        return m(r, {
            xE: Rt
        });
    }), qNn = function(n) {
        return {
            $: 6,
            a: n
        };
    }, BNn = function(n) {
        return {
            $: 11,
            a: n
        };
    }, jNn = function(n) {
        return {
            $: 7,
            a: n
        };
    }, SNn = function(n) {
        return {
            $: 1,
            a: n
        };
    }, zNn = function(n) {
        return n.mQ;
    }, UNn = F2(function(n, r) {
        switch(n.$){
            case 0:
                return 3 === (U = n.a).$ ? v(x = m(r, {
                    el: Ht(F = U.a)
                }), A2(CNn, x, x.CC), h) : v(r, Dp, A2(uA, 0, U));
            case 1:
                return 3 === (U = n.a).$ ? v(m(r, {
                    hb: U,
                    aW: e = A2(cPn, U.a, r.aW)
                }), Dp, h) : v(m(r, {
                    hb: U
                }), Dp, A2(uA, 0, U));
            case 2:
                var t = A2(U6, y = n.a, r.aW), e = t.a, u = t.b, a = t.c, c = a.$ || a.a.$ ? r.b7 : r.b7 && !AEn(e);
                return v(m(r, {
                    aW: e,
                    b7: c
                }), A2(jp, pNn, u), h);
            case 3:
                if (3 === (U = n.a).$) {
                    var o = WHn(U.a);
                    return v(x = m(r, {
                        BP: U,
                        CC: o
                    }), A2(CNn, x, o), h);
                }
                return v(m(r, {
                    BP: U
                }), Dp, A2(uA, 0, U));
            case 4:
                return v(m(r, {
                    e8: n.a
                }), Dp, h);
            case 5:
                var f = A3(ZHn, n.a, r.BO, r.CC), s = f.a, l = f.b, d = f.c, p = !i(A2(Cp, bun, l), A2(Cp, bun, r.CC)), g = function() {
                    if (d) {
                        var n = A6(qin, !1, r.kj, r.dw, r.yl, Rt, r.gx), t = n.b;
                        return b(Ht(n.a), A2(jp, qNn, t));
                    }
                    return b(p ? Rt : r.a0, Dp);
                }(), w = g.b, x = m(r, {
                    bZ: oc,
                    a0: g.a,
                    BO: s,
                    CC: l
                });
                return d ? v(x, w, h) : p ? v(m(x, {
                    e8: oc
                }), A2(CNn, x, l), h) : v(x, Dp, h);
            case 6:
                var y = n.a, _ = r.a0;
                if (1 === _.$) return v(r, Dp, h);
                var C = A2(son, y, _.a), D = C.b, A = C.c, q = m(r, {
                    a0: Ht(C.a)
                }), B = k([
                    A2(jp, qNn, D)
                ]);
                n: for(; !A.$;)switch(A.a.$){
                    case 1:
                        var j = A.a.a, S = 3 !== (O = r.BP).$ || !ED(O.a);
                        return v(m(q, {
                            bZ: Mx
                        }), Hu(A2(Ot, A4(zcn, r.gx, j, {
                            ds: !1,
                            uy: !1,
                            va: Rt,
                            vH: !S
                        }, jNn), B)), h);
                    case 0:
                        var z = A.a.a;
                        return v(m(q, {
                            bZ: oc
                        }), Hu(B), k([
                            rA(z)
                        ]));
                    default:
                        break n;
                }
                return v(q, Hu(B), h);
            case 7:
                var U;
                if (3 === (U = n.a).$) {
                    var E = U.a, P = function() {
                        var n = r.BP;
                        if (3 === n.$) {
                            var t = n.b;
                            return A2(f_, $(n.a, k([
                                E
                            ])), t);
                        }
                        return n;
                    }();
                    return v(x = m(r, {
                        bZ: U,
                        a0: Rt,
                        e8: oc,
                        BP: P,
                        CC: Ht(E)
                    }), A2(CNn, x, Ht(E)), h);
                }
                return v(m(r, {
                    bZ: U
                }), Dp, A2(uA, 0, U));
            case 8:
                return v(m(r, {
                    bZ: oc,
                    a0: Rt
                }), Dp, h);
            case 9:
                return v(r, 1 === r.a0.$ ? Dp : A2(jp, qNn, Ccn), h);
            case 10:
                if (AEn(r.aW)) {
                    var T = v(r.BK, r.CC, r.el);
                    if (T.a.$ || T.b.$ || T.c.$) return v(r, Dp, h);
                    var F, L = T.a.a, M = T.b.a, H = A2(uc, 1, A2(VHn, Wq(F = T.c.a), A2(Cp, mA, zNn(F))));
                    return v(m(r, {
                        bd: !0,
                        b7: !1
                    }), A4(IHn, r.gx, $k(r.dw), {
                        z4: k([
                            SNn({
                                xC: Ajn(r.aW),
                                qU: r.t7,
                                Av: k([
                                    L
                                ]),
                                tq: L,
                                BS: H,
                                C3: r.lo
                            })
                        ]),
                        BM: bun(M)
                    }, BNn), h);
                }
                return v(m(r, {
                    b7: !0
                }), Dp, h);
            case 11:
                var R = n.a;
                return 3 === R.$ ? v(m(r, {
                    bd: !1,
                    gQ: !0
                }), Dp, h) : v(m(r, {
                    bd: !1
                }), Dp, A2(uA, 0, R));
            default:
                return v(r, A2(zx, oa, sa), h);
        }
        var O;
    }), ENn = {
        $: 12
    }, PNn = function(n) {
        return n.G.nP;
    }, TNn = function(n) {
        return n.G.hc;
    }, FNn = function(n) {
        return n.G.hd;
    }, LNn = function(n) {
        return n.G.Ar;
    }, MNn = function(n) {
        return n.G.$7;
    }, HNn = function(n) {
        return n.G.h1;
    }, RNn = function(n) {
        return n.G.tj;
    }, ONn = function(n) {
        return n.G.du;
    }, NNn = function(n) {
        return n.G.Cb;
    }, INn = function(n) {
        return n.G.wh;
    }, VNn = function(n) {
        return n.G.js;
    }, WNn = function(n) {
        return n.G.dT;
    }, ZNn = function(n) {
        return n.G.wD;
    }, XNn = {
        $: 8
    }, GNn = {
        $: 13
    }, JNn = {
        $: 9
    }, YNn = function(n) {
        return {
            $: 5,
            a: n
        };
    }, QNn = F2(function(n, r) {
        return A2(px, pNn, A3(N4, n, k([
            bPn(r.b7),
            dPn(r.bd)
        ]), r.aW));
    }), KNn = {
        $: 10
    }, nIn = F2(function(n, r) {
        var t = r.el;
        if (t.$) return Sq;
        var e = t.a, u = pRn(e), a = A2(uc, 0, yNn(e)), i = A2(uc, 0, A2(VHn, CB(e), xNn(e))), c = A2(VHn, A2(Xb, hB, Wq(e)), zNn(e)), o = MD(r.e8), f = A2(uc, a + i + u, A2(Cp, Lun, o));
        return A2(lz, k([
            LS(aV)
        ]), k([
            a > 0 ? A2(lz, k([
                LS(FS),
                bz(_1),
                bz(kz)
            ]), k([
                A2(hx, k([
                    BB
                ]), k([
                    ad(n(RNn))
                ])),
                A2(px, hu, A7(kPn, n, a, !1, Rt, yz, !1, !1))
            ])) : Sq,
            A2(lz, k([
                LS(FS),
                bz(_1),
                bz(kz)
            ]), k([
                A2(hx, k([
                    BB
                ]), k([
                    ad(n(NNn))
                ])),
                A2(px, hu, A7(kPn, n, i, !1, c, yz, !1, !1))
            ])),
            A2(px, hu, A2(kRn, n, u)),
            A2(px, hu, $Rn(o)),
            gx,
            A2(lz, k([
                LS(aV),
                bz(_1),
                bz(kz)
            ]), k([
                A2(hx, k([
                    Hz
                ]), k([
                    ad(n(FNn))
                ])),
                A2(px, hu, A7(kPn, n, f, !1, Rt, yz, !1, !1))
            ]))
        ]));
    }), rIn = F2(function(n, r) {
        var t = !i(r.CC, Rt) && AEn(r.aW) && !r.bd;
        return A2(Ik, k([
            Nk("sidebar-wrap -mx-6 sm:-mx-8 sm:px-8")
        ]), k([
            A2(nIn, n, r),
            A2(fz, k([
                nz,
                JS,
                QS(KNn),
                ZS(!t),
                Don(r.bd)
            ]), k([
                ad(n(PNn))
            ]))
        ]));
    }), tIn = F2(function(n, r) {
        var t = !i(r.CC, Rt) && AEn(r.aW) && !r.bd;
        return A2(Ik, k([
            Nk("sidebar-wrap")
        ]), k([
            A2(nIn, n, r),
            A2(fz, k([
                nz,
                JS,
                QS(KNn),
                ZS(!t),
                Don(r.bd)
            ]), k([
                ad(n(PNn))
            ]))
        ]));
    }), eIn = function(n) {
        return A2(Ik, k([
            Nk("mb-6")
        ]), k([
            A2(hx, k([
                LS(FS)
            ]), k([
                A2(LB, h, k([
                    ad(n(MNn))
                ]))
            ])),
            A2(hx, k([
                BB
            ]), k([
                ad(n(INn))
            ]))
        ]));
    }, uIn = F2(function(n, r) {
        return BX(k([
            SX({
                AT: GNn,
                wD: n(ZNn)
            }),
            gx,
            bRn({
                yQ: A2(tIn, n, r),
                Ai: k([
                    CRn({
                        As: n(LNn),
                        AF: n(HNn),
                        Be: YNn,
                        kU: r.kU,
                        BN: n(ONn),
                        BO: r.BO,
                        BP: r.BP,
                        CC: i(r.a0, Rt) ? A2(Cp, sRn, r.CC) : Ht(lRn),
                        wT: n
                    }),
                    function() {
                        var t = r.a0;
                        if (t.$) return Sq;
                        var e = t.a, u = 1 === r.bZ.$;
                        return A2(Ik, k([
                            Nk("mb-6")
                        ]), $(A2(yu, px(qNn), nfn(e)), k([
                            DRn({
                                z_: Con(e),
                                z1: u,
                                AR: XNn,
                                AV: JNn,
                                wT: n
                            })
                        ])));
                    }(),
                    eIn(n),
                    A2(QNn, n, r)
                ])
            }),
            vRn(A2(rIn, n, r))
        ]));
    }), aIn = F2(function(n, r) {
        return {
            gF: k([
                r.gQ ? iRn({
                    gF: n(VNn),
                    x8: n(TNn),
                    AZ: ENn,
                    wD: n(WNn)
                }) : r.el.$ ? A2(Ik, k([
                    Nk("panel")
                ]), Yk) : A2(uIn, n, r)
            ]),
            wD: n(ZNn)
        };
    }), iIn = Ux({
        zO: wNn,
        Ab: DNn,
        Ct: ANn,
        Dd: function(n) {
            var r = n.a0.$ ? yk : A2(xD, qNn, ocn);
            return xk(k([
                A2(xD, pNn, p9(n.aW)),
                r
            ]));
        },
        DB: UNn,
        DH: aIn
    }), cIn = function(n) {
        return {
            $: 5,
            a: n
        };
    }, oIn = F3(function(n, r) {
        var t = {
            gx: r.gx,
            g0: A2(cp, r.fL, r.bf),
            c8: 0,
            kj: r.kj,
            h3: 0,
            tE: Rt,
            kS: r.tE,
            ii: Rt,
            kV: h,
            dw: n,
            fo: "content-container",
            fq: !1,
            fw: Rt,
            fB: Rt,
            fF: oc,
            i0: Rt,
            jx: r.jx
        };
        return b(t, function(n) {
            return A3(WC, n.gx, $k(n.dw), cIn);
        }(t));
    }), fIn = F2(function(n, r) {
        return b(r, Dp);
    }), sIn = F2(function(n, r) {
        return m(r, {
            xE: Ht(6)
        });
    }), lIn = F2(function(n, r) {
        return {
            $: 7,
            a: n,
            b: r
        };
    }), dIn = function(n) {
        return {
            $: 6,
            a: n
        };
    }, bIn = Kn("onWindowScroll", A2(Ge, function(n) {
        return A2(Ge, function(r) {
            return Ke({
                xl: r,
                lw: n
            });
        }, A2(Tu, "x", _$));
    }, A2(Tu, "y", _$))), vIn = function(n) {
        return {
            $: 0,
            a: n
        };
    }, mIn = function(n) {
        return {
            $: 4,
            a: n
        };
    }, pIn = function(n) {
        return n.vh;
    }, $In = function(n) {
        return n.vk;
    }, hIn = function(n) {
        var r = n.a.kE;
        return $In(r) || pIn(r);
    }, gIn = F2(function(n, r) {
        var t, e = n.kS;
        if (3 === e.$) {
            var u = e.a;
            return $In(t = u.kE) || pIn(t) ? Ht(ZC(u)) : function(n) {
                return A2(Cp, Ox, Gb(A2(Tc, hIn, n)));
            }(r);
        }
        return Rt;
    }), wIn = function(n) {
        return {
            $: 1,
            a: n
        };
    }, kIn = F2(function(n, r) {
        return A4(sln, n.gx, $k(n.dw), r, wIn);
    }), xIn = F2(function(n, r) {
        return A2(Cp, Ox, A2(tjn, n, r));
    }), yIn = function(n) {
        return LD(n);
    }, _In = function(n) {
        var r = b(A2(xIn, n.c8, n.kV), function(n) {
            return A2(Cp, Ox, Gb(A2(Tc, yIn, n.kV)));
        }(n));
        return r.a.$ ? r.b.$ ? "" : r.b.a : r.b.$ ? r.a.a : r.b.a;
    }, CIn = F2(function(n, r) {
        var t = A2(Tc, hIn, n.kV), e = oe(t);
        return 1 === r.hi ? b(e > 1 && !i(n.c8 + 1, e) ? A2(kIn, n, A2(uc, "", A2(xIn, n.c8 + 1, t))) : A2(zx, oa, Aa({
            qU: _In(n)
        })), k([
            A2(nA, 3, _b)
        ])) : b(Dp, r.h7);
    }), DIn = function(n) {
        return {
            $: 2,
            a: n
        };
    }, AIn = A3(zy, "id", w$, Ke(function(n) {
        return {
            qU: n
        };
    })), qIn = A2(qy, AIn, Ke(ru)), BIn = F9(function(n, r, t, e, u, a, i, c, o) {
        return {
            nO: o,
            qU: n,
            rd: c,
            rj: i,
            rB: a,
            rC: e,
            rD: u,
            v2: r,
            w_: t
        };
    }), jIn = A3(zy, "company_name", l_(w$), A3(zy, "is_checkout_page", xy, A3(zy, "is_retail_page", xy, A3(zy, "limit_available_location_groups", xy, A3(zy, "limit_available_practitioners", xy, A3(zy, "limit_available_locations", xy, A3(zy, "url", l_(w$), A3(zy, "slug", w$, A3(zy, "id", w$, Ke(BIn)))))))))), SIn = A2(Ye, ru, jIn), zIn = A3(zy, "prepay_first_payment_on_signup", xy, A3(zy, "dependent_limit", l_(C$), A3(zy, "collect_rate_schedule_on_signup", xy, A3(zy, "collect_start_date_on_signup", xy, A3(zy, "allow_coupons", xy, A3(zy, "accepts_new_signup", xy, A3(zy, "default_location", l_(qIn), A3(zy, "default_practitioner", l_(_en), A3(zy, "allowed_zip_codes_on_signup", Ey(w$), A3(zy, "restrict_zip_codes_on_signup", xy, A3(zy, "collect_tobacco_use", xy, A3(zy, "allows_payer_on_behalf_on_signup", A2(Ge, Zdn, w$), A3(zy, "signup_page", SIn, A3(zy, "post_signup_button_label", l_(w$), A3(zy, "show_post_signup_footer_button", xy, A3(zy, "post_signup_message", l_(w$), A3(zy, "post_signup_redirect_url", l_(w$), A3(zy, "redirects_post_signup", xy, A3(zy, "min_enroll_age", l_(C$), A3(zy, "collect_ssn_on_signup", A2(Ge, Zdn, w$), A3(zy, "collect_broker_on_signup", A2(Ge, Zdn, w$), A3(zy, "collect_lead_source_on_signup", A2(Ge, Zdn, w$), A3(zy, "collect_payment_source_on_signup", A2(Ge, Zdn, w$), A3(zy, "collect_insurance_on_signup", A2(Ge, Zdn, w$), A3(zy, "collect_location_on_signup", A2(Ge, Zdn, w$), A3(zy, "collect_practitioner_on_signup", A2(Ge, Zdn, w$), A3(zy, "collect_address_on_signup", A2(Ge, Zdn, w$), A3(zy, "collect_billing_address_on_signup", A2(Ge, Zdn, w$), Ke(function(n) {
        return function(r) {
            return function(t) {
                return function(e) {
                    return function(u) {
                        return function(a) {
                            return function(i) {
                                return function(c) {
                                    return function(o) {
                                        return function(f) {
                                            return function(s) {
                                                return function(l) {
                                                    return function(d) {
                                                        return function(b) {
                                                            return function(v) {
                                                                return function(m) {
                                                                    return function(p) {
                                                                        return function($) {
                                                                            return function(h) {
                                                                                return function(g) {
                                                                                    return function(w) {
                                                                                        return function(k) {
                                                                                            return function(x) {
                                                                                                return function(y) {
                                                                                                    return function(_) {
                                                                                                        return function(C) {
                                                                                                            return function(D) {
                                                                                                                return function(A) {
                                                                                                                    return {
                                                                                                                        lD: x,
                                                                                                                        ma: y,
                                                                                                                        mc: p,
                                                                                                                        mf: g,
                                                                                                                        ny: r,
                                                                                                                        nz: n,
                                                                                                                        nA: c,
                                                                                                                        nD: u,
                                                                                                                        nE: i,
                                                                                                                        nF: e,
                                                                                                                        nH: a,
                                                                                                                        nI: t,
                                                                                                                        nJ: C,
                                                                                                                        nK: o,
                                                                                                                        nL: _,
                                                                                                                        nM: $,
                                                                                                                        oN: k,
                                                                                                                        oR: w,
                                                                                                                        oU: D,
                                                                                                                        sI: f,
                                                                                                                        kX: v,
                                                                                                                        kY: d,
                                                                                                                        kZ: l,
                                                                                                                        uq: A,
                                                                                                                        u_: s,
                                                                                                                        vr: h,
                                                                                                                        li: b,
                                                                                                                        lj: m
                                                                                                                    };
                                                                                                                };
                                                                                                            };
                                                                                                        };
                                                                                                    };
                                                                                                };
                                                                                            };
                                                                                        };
                                                                                    };
                                                                                };
                                                                            };
                                                                        };
                                                                    };
                                                                };
                                                            };
                                                        };
                                                    };
                                                };
                                            };
                                        };
                                    };
                                };
                            };
                        };
                    };
                };
            };
        };
    }))))))))))))))))))))))))))))), UIn = A2(qy, zIn, Ke(ru)), EIn = F4(function(n, r, t, e) {
        return A4(dC, z9(n), UIn, t, A2(iH, function(n) {
            return fu(n) ? h : k([
                A2(Ax, "signup_page_id", n)
            ]);
        }(r), bC(e)));
    }), PIn = F4(function(n, r, t, e) {
        return A4(EIn, n, t, e, A2($y, k([
            "signup_page_setting"
        ]), gy(r)));
    }), TIn = F5(function(n, r, t, e, u) {
        return A4(EIn, n, e, u, A2($y, k([
            "signup_setting"
        ]), A2($y, k([
            "companies",
            t
        ]), gy(r))));
    }), FIn = F2(function(n, r) {
        return {
            $: 8,
            a: n,
            b: r
        };
    }), LIn = F3(function(n, r, t) {
        return {
            qU: n,
            kn: r,
            rr: t
        };
    }), MIn = function(n) {
        return A2(uc, "", Ht(Ix(n)));
    }, HIn = F2(function(n, r) {
        return A2(uc, "", A2(tjn, n, function(n) {
            return A2(yu, MIn, n);
        }(r)));
    }), RIn = function(n) {
        return A2(yu, Ox, n);
    }, OIn = F2(function(n, r) {
        return A2(uc, -1, A2(Aqn, n, r));
    }), NIn = F2(function(n, r) {
        var t = A2(OIn, r, RIn(n));
        return A3(LIn, r, t, A2(HIn, t, n));
    }), IIn = F2(function(n, r) {
        return {
            j2: A2(NIn, n, r),
            kV: n
        };
    }), VIn = F5(function(n, r, t, e, u) {
        return b({
            gx: u,
            tE: t,
            dw: e,
            fq: !1,
            ld: r,
            le: n
        }, Dp);
    }), WIn = function(n) {
        return n.nF;
    }, ZIn = function(n) {
        return n.nI;
    }, XIn = function(n) {
        return n.qU;
    }, GIn = function(n) {
        return n.lj;
    }, JIn = F3(function(n, r, t) {
        return m(t, {
            O: WIn(r),
            P: ZIn(r),
            bl: Ht(XIn(GIn(r))),
            ho: n.ii
        });
    }), YIn = function(n) {
        return {
            $: 0,
            a: n
        };
    }, QIn = function(n) {
        return vk(k([
            b("id", mk(n))
        ]));
    }, KIn = function(n) {
        var r, t = $k(n.dw), e = (r = n.tE).$ ? "" : Aln(r.a), u = k([
            b("practitioner", A2(yN, QIn, n.le)),
            b("location", A2(yN, QIn, n.ld))
        ]), a = b("patient", vk(u));
        return A5(jmn, n.gx, t, e, a, YIn);
    }, nVn = F2(function(n, r) {
        if (1 === n.$) return {
            gV: KIn(r),
            hi: 0,
            hX: m(r, {
                fq: !0
            }),
            h7: h
        };
        var t = n.a;
        return 3 === t.$ ? {
            gV: Dp,
            hi: 1,
            hX: m(r, {
                tE: Ht(t.a),
                fq: !1
            }),
            h7: h
        } : {
            gV: Dp,
            hi: 0,
            hX: m(r, {
                fq: !1
            }),
            h7: A2(uA, 0, t)
        };
    }), rVn = F2(function(n, r) {
        switch(n.$){
            case 0:
                var t = n.a, e = r.fw;
                if (e.$) return v(r, Dp, h);
                var u = A2(CEn, t, e.a), a = u.a, c = u.b, o = A5(VIn, a.le, a.ld, r.tE, r.dw, r.gx), f = o.b;
                return v(m(r, {
                    fq: (l = o.a).fq,
                    fw: Ht(a),
                    fB: Ht(l)
                }), Hu(k([
                    A2(jp, vIn, c),
                    A2(jp, mIn, f)
                ])), h);
            case 3:
                return v(r, A2(Eu, ru, gu(mIn(t = n.a))), h);
            case 4:
                t = n.a;
                var s = r.fB;
                if (s.$) return v(r, Dp, h);
                var l, d = A2(nVn, t, l = s.a), p = A2(CIn, r, d), $ = p.a, g = p.b;
                return v(m(r, {
                    fq: d.hX.fq,
                    fB: Ht(d.hX)
                }), Hu(k([
                    $,
                    A2(jp, mIn, d.gV)
                ])), g);
            case 1:
                var w = n.a;
                if (3 === w.$) {
                    var x = w.a, y = A2(Tc, hIn, r.kV), _ = function() {
                        if (oe(y) > 1) {
                            var n = A2(IIn, y, Aln(x));
                            return m(r, {
                                c8: n.j2.kn,
                                tE: Ht(x),
                                i0: Ht(n)
                            });
                        }
                        var t = Wln(x).xy;
                        return m(r, {
                            tE: Ht(x),
                            ii: t
                        });
                    }();
                    return v(_, function(n) {
                        var r = n.tE;
                        if (r.$) return Dp;
                        var t = function(n) {
                            return n.nN;
                        }(r.a);
                        if (t.$) return A4(PIn, n.gx, $k(n.dw), "", DIn);
                        var e = t.a;
                        return A5(TIn, n.gx, $k(n.dw), function(n) {
                            return n.qU;
                        }(e), "", DIn);
                    }(_), h);
                }
                return v(r, Dp, A2(uA, 0, w));
            case 2:
                var C = n.a;
                if (3 === C.$) {
                    var D = C.a, A = (T = r.fw).$ ? A4(bqn, r.gx, Rk(r.kj), r.dw, A2(JIn, r, D)) : b(T.a, h), q = A.b;
                    return v(m(r, {
                        fw: Ht(A.a),
                        fF: C
                    }), Hu(A2(yu, jp(vIn), q)), h);
                }
                return v(r, Dp, A2(uA, 0, C));
            case 5:
                var B = n.a;
                if (3 === B.$) {
                    var j = B.a, S = (P = A2(gIn, r, j)).$ ? A2(zx, oa, Wa) : A2(kIn, r, P.a);
                    return v(m(r, {
                        kV: j
                    }), S, h);
                }
                return v(m(r, {
                    kV: h
                }), Dp, A2(uA, 0, B));
            case 6:
            case 7:
                return v(r, function(n) {
                    return A2(dc, FIn(n), uy(n));
                }(r.fo), h);
            default:
                var z = n.a, U = n.b;
                if (U.$) return v(r, Dp, h);
                var E = U.a;
                return i(z, r.fo) ? v(m(r, {
                    h3: A2(Me, 0, 24 - (E.ke.lw - E.jG.lw))
                }), Dp, h) : v(r, Dp, h);
        }
        var P, T;
    }), tVn = F2(function(n, r) {
        return A3(aMn, {
            aU: n.aU,
            a2: n.a2
        }, Nk("label"), r);
    }), eVn = F2(function(n, r) {
        if (ED(r)) return Sq;
        if (n.$) return Sq;
        var t = n.a;
        return A2(Ik, k([
            Nk("provider-selection-stepper")
        ]), A2(yu, function(n) {
            return A2(tVn, {
                aU: t,
                a2: oe(r)
            }, n);
        }, r));
    }), uVn = function(n) {
        return A2(eVn, Ht(n.j2.kn), A2(yu, function(n) {
            return A3(eMn, n.rr, n.kn, !1);
        }, function(n) {
            return A2(yu, NIn(n), RIn(n));
        }(n.kV)));
    }, aVn = function(n) {
        return {
            $: 3,
            a: n
        };
    }, iVn = {
        $: 1
    }, cVn = F3(function(n, r, t) {
        return k([
            A2(hx, k([
                bz(wF),
                LS(FS)
            ]), k([
                t
            ])),
            A2(fz, k([
                nz,
                JS,
                Don(n),
                ZS(!r),
                QS(aVn(iVn))
            ]), k([
                ad("Save")
            ]))
        ]);
    }), oVn = F3(function(n, r, t) {
        return A2(Ik, k([
            Nk("hidden md:block sidebar-wrap"),
            A2(cE, "margin-top", rB(n.h3) + "px"),
            jz("sidebar-element")
        ]), A3(cVn, n.fq, r, t));
    }), fVn = F3(function(n, r, t) {
        return A2(Ik, k([
            Nk("md:hidden sidebar-mobile")
        ]), k([
            A2(Ik, k([
                Nk("sidebar-wrap")
            ]), A3(cVn, n.fq, r, t))
        ]));
    }), sVn = F2(function(n, r) {
        return {
            gF: function() {
                var t = r.fw;
                if (t.$) return k([
                    Sq
                ]);
                var e = t.a;
                if (gFn(e)) {
                    var u = function(n) {
                        return !n.le.$;
                    }(e), a = function() {
                        var n = r.tE;
                        if (n.$) return Sq;
                        var t = n.a;
                        return A2(Ik, h, k([
                            ad("Are you done selecting provider & location for "),
                            Jx(xln(t)),
                            ad("?")
                        ]));
                    }(), i = function(n) {
                        return A2(Xb, fBn, A2(Cp, iBn(n.g0), A2(Xb, Zln, n.tE)));
                    }(r);
                    return k([
                        A2(lV, k([
                            dV(NZ)
                        ]), k([
                            A2(iV, k([
                                UZ(12),
                                GZ(8)
                            ]), k([
                                A2(Ik, k([
                                    jz("content-container"),
                                    Nk("panel")
                                ]), k([
                                    function() {
                                        var n = r.i0;
                                        if (n.$) return Sq;
                                        var t = n.a;
                                        return A2(Ik, k([
                                            Nk("mb-6")
                                        ]), k([
                                            uVn(t)
                                        ]));
                                    }(),
                                    A2(px, vIn, A3(QLn, n, k([
                                        hFn(i)
                                    ]), e))
                                ]))
                            ])),
                            A2(iV, k([
                                GZ(4),
                                jV(k([
                                    Nk("hidden md:block")
                                ]))
                            ]), k([
                                A3(oVn, r, u, a)
                            ]))
                        ])),
                        A3(fVn, r, u, a)
                    ]);
                }
                return k([
                    A2(Ik, h, Yk)
                ]);
            }(),
            wD: "Select Provider & Location"
        };
    }), lVn = Ux({
        zO: oIn,
        Ab: fIn,
        Ct: sIn,
        Dd: function() {
            return xk(k([
                bIn(dIn),
                CG(lIn)
            ]));
        },
        DB: rVn,
        DH: sVn
    }), dVn = F3(function(n, r, t) {
        return b({
            kj: r.kj,
            dw: n,
            w_: t.B9
        }, Dp);
    }), bVn = F2(function(n, r) {
        return b(r, Dp);
    }), vVn = F2(function(n, r) {
        return r;
    }), mVn = F2(function(n, r) {
        return v(r, Dp, h);
    }), pVn = function(n) {
        return n.lf.oV;
    }, $Vn = function(n) {
        return n.lf.wD;
    }, hVn = F2(function(n, r) {
        return {
            gF: k([
                A2(Ik, k([
                    Nk("panel")
                ]), k([
                    A2(lz, k([
                        rx,
                        bz(wF)
                    ]), k([
                        ad("Session expired")
                    ])),
                    A2(Q4, h, h),
                    A2(Gk, h, k([
                        ad("The link you used expired after 30 days and is no longer valid. ")
                    ])),
                    A2(Gk, h, k([
                        ad("For continued access to this data, please sign in to our ")
                    ])),
                    A2(Gk, k([
                        Nk("text-support")
                    ]), k([
                        A2(fF, k([
                            Nk("link"),
                            vF(Sx(ei))
                        ]), k([
                            ad("patient portal")
                        ]))
                    ])),
                    A2(Gk, h, k([
                        A4(xL, hk(r.dw), kF(r.dw), Ht(". If you have any questions or concerns"), Rt)
                    ]))
                ]))
            ]),
            wD: n($Vn)
        };
    }), gVn = kx({
        zO: dVn,
        Ab: bVn,
        Ct: vVn,
        Dd: function() {
            return yk;
        },
        DB: mVn,
        DH: hVn
    }), wVn = F2(function(n, r) {
        return {
            uR: r,
            Cr: n
        };
    }), kVn = function(n) {
        return {
            zO: F2(function(r, t) {
                var e = n.zO(t);
                return v(e, A2(zx, e.uR, e.Cr), h);
            }),
            Ab: rm(A2(Je, ru, YMn)),
            Ct: rm(ru),
            Dd: function() {
                return yk;
            },
            DB: F2(function(n, r) {
                return v(r, Dp, h);
            }),
            DH: function() {
                return {
                    gF: Yk,
                    wD: "Loading..."
                };
            }
        };
    }, xVn = kVn({
        zO: function(n) {
            var r = Ha({
                qU: n.BD.wL
            });
            return A2(wVn, r, oa);
        }
    }), yVn = function(n) {
        return A2(dA, "joint_product", n);
    }, _Vn = function(n) {
        return A2(dA, "patient_portal_polish", n);
    }, CVn = F3(function(n, r, t) {
        var e = function(n) {
            return yVn(n) && FX(n) && _Vn(n);
        }(n);
        return b({
            kj: r.kj,
            tE: r.tE,
            tL: r.tL,
            dw: n,
            lh: e,
            w_: t.B9
        }, e ? Dp : function(n) {
            return A2(zx, oa, n.bJ ? ka : ya);
        }(r));
    }), DVn = F2(function(n, r) {
        return b(m(r, {
            tE: n.tE,
            tL: n.tL
        }), Dp);
    }), AVn = F2(function(n, r) {
        return m(r, {
            xE: Rt
        });
    }), qVn = F2(function(n, r) {
        return v(r, Dp, h);
    }), BVn = function(n) {
        return n.j3.gA;
    }, jVn = function(n) {
        return n.j3.xi;
    }, SVn = F2(function(n, r) {
        return A2(Ik, k([
            Nk("dashboard__hero")
        ]), k([
            A2(lz, k([
                PL,
                f2
            ]), k([
                ad(n(jVn))
            ])),
            A2(lz, k([
                rx
            ]), k([
                ad(r)
            ]))
        ]));
    }), zVn = jB(4), UVn = F3(function(n, r, t) {
        return A2(fF, k([
            Nk("dashboard__widget"),
            vF(n)
        ]), k([
            A2(Ik, k([
                Nk("dashboard__widget-icon")
            ]), k([
                A2(US, k([
                    zVn
                ]), r)
            ])),
            A2(lz, k([
                OL,
                PL
            ]), k([
                ad(t)
            ]))
        ]));
    }), EVn = function(n) {
        return A2(Ik, k([
            Nk("dashboard__grid")
        ]), k([
            A3(UVn, Sx(Ea), 31, n(ub)),
            A3(UVn, Sx(va), 32, n(BVn)),
            A3(UVn, Sx(ka), 33, n(vd)),
            A3(UVn, Sx(ya), 34, n(Ld))
        ]));
    }, PVn = F2(function(n, r) {
        var t, e = 3 === (t = r.tL).$ ? jvn(t.a) : "";
        return k([
            A2(Ik, k([
                Nk("dashboard")
            ]), k([
                A2(SVn, n, e),
                EVn(n)
            ]))
        ]);
    }), TVn = F2(function(n, r) {
        return r.lh ? {
            gF: A2(PVn, n, r),
            wD: hk(r.dw)
        } : {
            gF: Yk,
            wD: hk(r.dw)
        };
    }), FVn = Ux({
        zO: CVn,
        Ab: DVn,
        Ct: AVn,
        Dd: function() {
            return yk;
        },
        DB: qVn,
        DH: TVn
    }), LVn = F3(function(n, r, t) {
        var e = $k(n), u = {
            gz: oc,
            a9: t.BD.a9,
            j$: r.ys.B6,
            kj: r.kj,
            dw: n,
            w_: t
        };
        return b(u, A4(YP, u.j$, e, u.a9, ru));
    }), MVn = F2(function(n, r) {
        return b(r, Dp);
    }), HVn = F2(function(n, r) {
        return r;
    }), RVn = F2(function(n, r) {
        var t = n;
        return 3 === t.$ ? v(m(r, {
            gz: t
        }), Dp, h) : v(m(r, {
            gz: oc
        }), Dp, A2(uA, 0, t));
    }), OVn = function(n) {
        return n.mo;
    }, NVn = F3(function(n, r, t) {
        return A2(uc, Sq, A2(Cp, function(r) {
            return A6(_F, n, nF(r), tF(r), eF(r), rF(r), t);
        }, A2(Xb, OVn, MD(r))));
    }), IVn = F2(function(n, r) {
        return {
            gF: k([
                A2(Ik, k([
                    Nk("panel w-full")
                ]), k([
                    A2(Ik, k([
                        Nk("text-center mb-6")
                    ]), k([
                        A2(XT, h, k([
                            ad(n(oT))
                        ]))
                    ])),
                    A3(NVn, n, r.gz, r.dw)
                ]))
            ]),
            wD: n(oT)
        };
    }), VVn = kx({
        zO: LVn,
        Ab: MVn,
        Ct: HVn,
        Dd: function() {
            return yk;
        },
        DB: RVn,
        DH: IVn
    }), WVn = kVn({
        zO: function(n) {
            var r = _a({
                qU: n.BD.wL
            });
            return A2(wVn, r, n.iu);
        }
    }), ZVn = function(n) {
        return {
            $: 4,
            a: n
        };
    }, XVn = function(n) {
        return {
            $: 0,
            a: n
        };
    }, GVn = function(n) {
        return A2($y, k([
            "appointment-types"
        ]), function(n) {
            return A2($y, k([
                "booking"
            ]), GP(n));
        }(n));
    }, JVn = F3(function(n, r, t) {
        return A2($y, k([
            r,
            "location",
            t
        ]), GVn(n));
    }), YVn = F3(function(n, r, t) {
        return A3(JVn, n, r, t);
    }), QVn = F5(function(n, r, t, e, u) {
        return A4(dC, n, hM, u, bC(A3(YVn, r, t, e)));
    }), KVn = F4(function(n, r, t, e) {
        return A5(QVn, n, r, t, e, XVn);
    }), nWn = F3(function(n, r, t) {
        var e = $k(n), u = AM.b, a = {
            ch: oc,
            mp: t.BD.mp,
            bD: oc,
            cj: Rt,
            mY: t.BD.mY,
            j$: r.ys.B6,
            kj: r.kj,
            dw: n,
            ae: AM.a,
            w_: t
        }, i = ZF(n) ? A4(KVn, a.j$, e, a.mp, a.mY) : dL;
        return b(a, Hu(k([
            i,
            A2(jp, ZVn, u)
        ])));
    }), rWn = F2(function(n, r) {
        return b(r, Dp);
    }), tWn = F2(function(n, r) {
        return r;
    }), eWn = function(n) {
        return {
            $: 2,
            a: n
        };
    }, uWn = function(n) {
        return {
            $: 3,
            a: n
        };
    }, aWn = F2(function(n, r) {
        return {
            $: 1,
            a: n,
            b: r
        };
    }), iWn = F3(function(n, r, t) {
        return A2($y, k([
            "availability"
        ]), A3(JVn, n, r, t));
    }), cWn = F6(function(n, r, t, e, u, a) {
        return A4(dC, n, tH, a, A2(iH, uH(r), bC(A3(iWn, t, e, u))));
    }), oWn = F6(function(n, r, t, e, u, a) {
        return A6(cWn, n, function(n) {
            return m(n, {
                C3: Ht(u)
            });
        }, r, t, e, aWn(a));
    }), fWn = F2(function(n, r) {
        switch(n.$){
            case 0:
                var t = n.a;
                return 3 === t.$ ? v(m(r, {
                    bD: t,
                    ae: A2(zR, i = t.a, r.ae)
                }), yH(A2(NM, 4, IM)), h) : v(m(r, {
                    bD: oc
                }), Dp, A2(uA, 0, t));
            case 1:
                var e = n.a, u = n.b, a = b(r.bD, u);
                if (3 === a.a.$ && 3 === a.b.$) {
                    var i = a.a.a, c = a.b.a, o = OH(c), f = _H(i), s = m(r, {
                        ch: u
                    });
                    return f && ED(o) ? v(s, A2(zx, oa, Ya), h) : v(m(s, {
                        ae: $ = A6(GH, e, r.cj, i, c, Rt, r.ae)
                    }), Dp, h);
                }
                return v(m(r, {
                    ch: oc
                }), Dp, A2(uA, 0, u));
            case 2:
                if ((y = n.a).$) return v(m(r, {
                    cj: Rt
                }), Dp, h);
                if (1 === (_ = y.a).$ && 4 === _.a) {
                    var l = A2(Xb, kR, _.b), d = A2(pH, l, r.ae);
                    if (d.$) return v(r, Dp, h);
                    var p = d.a, $ = p.a, g = p.b, w = $k(r.dw), x = A6(oWn, r.j$, w, r.mp, r.mY, g, !0);
                    return v(m(r, {
                        cj: l,
                        ae: $
                    }), x, h);
                }
                return v(r, Dp, h);
            case 3:
                var y, _;
                return (y = n.a).$ ? v(r, Dp, h) : 2 === (_ = y.a).$ && 4 === _.a ? v(m(r, {
                    cj: Rt
                }), Dp, h) : v(r, Dp, h);
            default:
                var C = A2(SR, n.a, r.ae), D = C.b, A = C.c, q = m(r, {
                    ae: $ = C.a
                }), B = A2(jp, ZVn, D);
                if (A.$) return v(q, B, h);
                var j = A.a;
                if (j.$) {
                    var S = j.a, z = b(q.bD, CH(r.ae));
                    if (3 !== z.a.$ || z.b.$) return v(q, B, h);
                    i = z.a.a;
                    var U = z.b.a, E = DH(r.ae);
                    if ((f = _H(i)) && $H(E)) return v(q, B, h);
                    var P = A3(SH, S, U, A3(aR, f, E, A3(nR, IH(S), U, A2(uc, VM, q.cj)))), T = q.w_.iu;
                    return v(q, Hu(k([
                        hR(P),
                        A2(zx, T, Ja({
                            mp: r.mp,
                            mY: r.mY
                        }))
                    ])), h);
                }
                var F = sH(j.a);
                return w = $k(r.dw), v(m(q, {
                    ch: Mx
                }), Hu(k([
                    B,
                    A6(oWn, r.j$, w, r.mp, r.mY, vH(F), !1)
                ])), h);
        }
    }), sWn = function(n) {
        return 3 === n.ch.$ ? A2(px, ZVn, A2(nO, n.dw, n.ae)) : A2(Ik, h, Yk);
    }, lWn = function(n) {
        var r, t = n.bD;
        if (3 === t.$) {
            var e = t.a, u = 3 === (r = n.ch).$ ? OH(r.a) : h, a = _H(e) && 1 === oe(u) ? A2(Cp, QT, DH(n.ae)) : Rt, i = dH(e);
            return A2(Ik, k([
                Nk("flex flex-col gap-4")
            ]), k([
                A2(cM, !1, {
                    eb: Rt,
                    xU: Ht(e),
                    mX: Ht(i),
                    tE: Rt,
                    fk: a
                }),
                sWn(n)
            ]));
        }
        return A2(Ik, h, Yk);
    }, dWn = F2(function(n, r) {
        var t;
        return {
            gF: k([
                A2(Ik, k([
                    Nk("flex flex-col gap-4")
                ]), k([
                    (t = r.bD, 3 === t.$ ? sM(eO(t.a)) : Sq),
                    lWn(r)
                ]))
            ]),
            wD: "Booking"
        };
    }), bWn = kx({
        zO: nWn,
        Ab: rWn,
        Ct: tWn,
        Dd: function() {
            return xk(k([
                HM(eWn),
                OM(uWn)
            ]));
        },
        DB: fWn,
        DH: dWn
    }), vWn = function(n) {
        return {
            $: 0,
            a: n
        };
    }, mWn = F3(function(n, r, t) {
        var e = $k(n), u = $k(n), a = A2(cp, r.fL, r.bf), i = !cO(r.gx), c = {
            mp: t.BD.mp,
            bD: oc,
            cj: Rt,
            mY: t.BD.mY,
            j$: r.ys.B6,
            g_: r.gx,
            kj: r.kj,
            aO: A6(EO, r.gx, u, a, !1, i, !1),
            dw: n,
            ln: oc,
            w_: t
        };
        return b(c, ZF(n) ? A5(QVn, c.j$, e, c.mp, c.mY, vWn) : dL);
    }), pWn = F2(function(n, r) {
        return b(r, Dp);
    }), $Wn = F2(function(n, r) {
        return r;
    }), hWn = function(n) {
        return {
            $: 1,
            a: n
        };
    }, gWn = function(n) {
        return {
            $: 3,
            a: n
        };
    }, wWn = function(n) {
        return {
            $: 4,
            a: n
        };
    }, kWn = function(n) {
        return {
            $: 2,
            a: n
        };
    }, xWn = F2(function(n, r) {
        if (n) {
            var t = UH(r), e = UH(r);
            return $H(e) || $H(t);
        }
        return !1;
    }), yWn = F2(function(n, r) {
        if (r.$) return !0;
        var t = r.a;
        return A2(xWn, n, t) || function(n) {
            var r = zH(n), t = pN(n), e = lH(n);
            return $H(e) || $H(t) || $H(r);
        }(t);
    }), _Wn = F2(function(n, r) {
        return vk($(A2(_N, n, r), k([
            b("first_name", A2(yN, mk, SN(r))),
            b("last_name", A2(yN, mk, zN(r))),
            b("dob", A2(yN, mk, qN(r))),
            b("email", A2(yN, mk, BN(r))),
            b("phone", A2(yN, mk, UN(r)))
        ])));
    }), CWn = F2(function(n, r) {
        return A2($y, k([
            r
        ]), GVn(n));
    }), DWn = F6(function(n, r, t, e, u, a) {
        return A4(vN, n, kN, a, A2(xq, A2(_Wn, e, u), bC(A2(CWn, r, t))));
    }), AWn = F2(function(n, r) {
        switch(n.$){
            case 0:
                var t = n.a;
                return 3 === t.$ ? v(m(r, {
                    bD: t
                }), yH(A2(NM, 4, IM)), h) : v(m(r, {
                    bD: oc
                }), Dp, A2(uA, 0, t));
            case 1:
                var e = n.a;
                if (e.$) return v(m(r, {
                    cj: Rt
                }), Dp, h);
                var u = e.a;
                if (1 === u.$ && 4 === u.a) {
                    var a = u.b, i = r.bD;
                    if (3 === i.$) {
                        var c = _H(A = i.a), o = A2(Xb, kR, a), f = A2(TN, o, A7(LN, r.g_, $k(r.dw), r.aO.g0, r.aO.aH, r.aO.hC, r.aO.hs, A)), s = function() {
                            if (A2(yWn, c, o)) {
                                var n = gL(dH(A)), t = AN(A);
                                return A2(zx, r.w_.iu, Ga({
                                    mp: t,
                                    mY: n
                                }));
                            }
                            return Dp;
                        }();
                        return v(m(r, {
                            cj: o,
                            aO: f
                        }), s, h);
                    }
                    return v(r, Dp, h);
                }
                return v(r, Dp, h);
            case 3:
                var l = A2(JI, n.a, r.aO), d = l.b, p = l.c, $ = m(r, {
                    aO: f = l.a
                }), g = A2(jp, gWn, d);
                if (p.$) return v($, g, h);
                var w = p.a, x = w.a, y = w.b, _ = Ht(A2(rV, x.e5, A2(tV, x.t0, A2(QI, x.pt, A2(YI, A2(Cp, vH, x.o2), A2(nV, x.rt, A2(KI, x.qb, A2(uc, VM, r.cj)))))))), C = b(_, r.bD);
                if (C.a.$ || 3 !== C.b.$) return v($, g, h);
                var D = C.a.a, A = C.b.a, q = $k(r.dw), B = function() {
                    if (y) {
                        var n = vk(k([
                            b("signature", mk("")),
                            b("acceptance_type", mk("checkbox")),
                            b("accepted", kA(!0))
                        ]));
                        return A5(mN, r.g_, q, "ephi_waiver", n, wWn);
                    }
                    return Dp;
                }(), j = gL(dH(A)), S = AN(A), z = A6(DWn, r.j$, q, S, j, D, kWn);
                return v(m(r, {
                    cj: _,
                    ln: Mx
                }), Hu(k([
                    g,
                    hR(D),
                    z,
                    B
                ])), h);
            case 2:
                var U = n.a;
                switch($ = m(r, {
                    ln: U
                }), U.$){
                    case 3:
                        return v($, yH(A2(IO, 4, IM)), h);
                    case 2:
                        var E = U.a;
                        return v($, Dp, 5 === E.$ && 400 === E.a ? h : k([
                            A2(nA, 1, YD)
                        ]));
                    default:
                        return v($, Dp, h);
                }
            default:
                return v(r, Dp, h);
        }
    }), qWn = F3(function(n, r, t) {
        return 2 === n.$ && 5 === n.a.$ && 400 === n.a.a ? A3(KV, t, r.B9, r.iu) : Sq;
    }), BWn = F2(function(n, r) {
        var t = r.bD;
        if (3 === t.$) {
            var e = t.a, u = A2(Xb, NV, r.cj), a = A2(Xb, pN, r.cj), i = rW(r.ln), c = dH(e);
            return A2(Ik, k([
                Nk("flex flex-col gap-4")
            ]), k([
                A2(cM, i, {
                    eb: a,
                    xU: Ht(e),
                    mX: Ht(c),
                    tE: Rt,
                    fk: u
                }),
                A2(px, gWn, A5(hX, e, r.dw, i, n, r.aO))
            ]));
        }
        return A2(Ik, h, Yk);
    }), jWn = F2(function(n, r) {
        return {
            gF: k([
                function() {
                    var t, e, u = r.ln;
                    if (3 === u.$) {
                        var a = u.a, i = b(r.bD, r.cj);
                        if (3 !== i.a.$ || i.b.$) return Sq;
                        var c = i.a.a, o = i.b.a;
                        return A2(Ik, k([
                            Nk("mt-12")
                        ]), k([
                            A5(GV, c, o, a, Rt, r.w_.iu)
                        ]));
                    }
                    return A2(Ik, k([
                        Nk("flex flex-col gap-4")
                    ]), 3 === (e = r.bD).$ ? k([
                        A3(qWn, r.ln, r.w_, e.a),
                        (t = r.bD, 3 === t.$ ? sM(eO(t.a)) : Sq),
                        A2(BWn, n, r)
                    ]) : Yk);
                }()
            ]),
            wD: "Booking"
        };
    }), SWn = kx({
        zO: mWn,
        Ab: pWn,
        Ct: $Wn,
        Dd: function() {
            return xk(k([
                HM(hWn),
                A2(xD, gWn, RO())
            ]));
        },
        DB: AWn,
        DH: jWn
    }), zWn = F3(function(n, r, t) {
        var e = ZF(n) ? Dp : dL;
        return b({
            kj: r.kj,
            dw: n,
            w_: t
        }, e);
    }), UWn = F2(function(n, r) {
        return b(r, Dp);
    }), EWn = F2(function(n, r) {
        return r;
    }), PWn = F2(function(n, r) {
        return v(r, Dp, h);
    }), TWn = function(n) {
        return A4(xL, hk(n), kF(n), Ht("For new patients"), Ht("for information on how to sign up."));
    }, FWn = F2(function(n, r) {
        var t = r.dw;
        return {
            gF: k([
                A2(Ik, h, k([
                    A2(XT, k([
                        bz(yz),
                        UB
                    ]), k([
                        ad("Book an appointment")
                    ])),
                    A2(lz, k([
                        bz(yz),
                        LS(Htn)
                    ]), k([
                        TWn(t)
                    ]))
                ]))
            ]),
            wD: "Booking"
        };
    }), LWn = kx({
        zO: zWn,
        Ab: UWn,
        Ct: EWn,
        Dd: function() {
            return yk;
        },
        DB: PWn,
        DH: FWn
    }), MWn = function(n) {
        return {
            $: 0,
            a: n
        };
    }, HWn = F3(function(n, r, t) {
        return A4(dC, n, YF, t, bC(function(n) {
            return GVn(n);
        }(r)));
    }), RWn = F2(function(n, r) {
        return A3(HWn, n.j$, r, MWn);
    }), OWn = F3(function(n, r, t) {
        var e = {
            ee: oc,
            j$: r.ys.B6,
            kj: r.kj,
            kw: lL,
            dw: n,
            w_: t
        };
        return b(e, ZF(n) ? A2(RWn, e, $k(n)) : dL);
    }), NWn = F2(function(n, r) {
        return b(r, Dp);
    }), IWn = F2(function(n, r) {
        return r;
    }), VWn = function(n) {
        return {
            $: 2,
            a: n
        };
    }, WWn = F2(function(n, r) {
        switch(n.$){
            case 0:
                var t = n.a;
                if (3 === t.$) {
                    var e = t.a, u = A2(hL, NF(r.w_.iu), $L(e)), a = ED(u) ? A2(zx, oa, Ya) : Dp;
                    return v(m(r, {
                        ee: t
                    }), a, h);
                }
                return v(m(r, {
                    ee: oc
                }), Dp, A2(uA, 0, t));
            case 1:
                var i = n.a, c = i.a, o = i.b, f = r.w_.iu;
                return LL(c) ? v(r, A2(zx, f, ma({
                    mp: RT(c),
                    mY: gL(o)
                })), h) : v(r, A2(zx, f, Ga({
                    mp: RT(c),
                    mY: gL(o)
                })), h);
            default:
                var s = A2(wL, n.a, r.kw), l = s.b;
                return v(m(r, {
                    kw: s.a
                }), A2(jp, VWn, l), h);
        }
    }), ZWn = function(n) {
        return {
            $: 1,
            a: n
        };
    }, XWn = F4(function(n, r, t, e) {
        var u, a = r.B9, i = A2(hL, NF(r.iu), $L(e)), c = A2(DL, CL, i), o = c.a, f = c.b;
        return A2(Ot, A2(px, VWn, A3(rM, n, i, t)), A2(Ot, A2(px, ZWn, A2(RL, t, f)), ED(o) ? h : k([
            A2(Ik, k([
                Nk("flex flex-col gap-2")
            ]), k([
                (u = a, YV(ac(u)) ? A2(hx, k([
                    OL
                ]), k([
                    ad("Continue as guest")
                ])) : Sq),
                A2(px, ZWn, A2(RL, t, o))
            ]))
        ])));
    }), GWn = F2(function(n, r) {
        var t = r.ee;
        if (3 === t.$) {
            var e = t.a;
            return A2(Ik, k([
                Nk("flex flex-col gap-4")
            ]), $(A4(XWn, n, r.w_, r.kw, e), k([
                yL(r.dw)
            ])));
        }
        return A2(Ik, h, Yk);
    }), JWn = F2(function(n, r) {
        if (3 === r.$) {
            var t = r.a, e = NF(n.iu);
            if (e.$) return sM(!0);
            var u = e.a, a = A2(zD, function(n) {
                return i(RT(n), u);
            }, $L(t));
            return sM(!!a.$ || fM(a.a));
        }
        return sM(!0);
    }), YWn = F2(function(n, r) {
        return {
            gF: k([
                A2(Ik, k([
                    Nk("flex flex-col gap-4")
                ]), k([
                    A2(JWn, r.w_, r.ee),
                    A2(GWn, n, r)
                ]))
            ]),
            wD: "Booking"
        };
    }), QWn = kx({
        zO: OWn,
        Ab: NWn,
        Ct: IWn,
        Dd: function() {
            return yk;
        },
        DB: WWn,
        DH: YWn
    }), KWn = function(n) {
        return {
            $: 1,
            a: n
        };
    }, nZn = function(n) {
        return {
            $: 0,
            a: n
        };
    }, rZn = function(n) {
        return {
            $: 4,
            a: n
        };
    }, tZn = {
        $: 2
    }, eZn = function(n) {
        return {
            $: 3,
            a: n
        };
    }, uZn = function(n) {
        return n.lD;
    }, aZn = Jn("fullStoryPortIdentifySignup", mk), iZn = function(n) {
        return function(n) {
            return aZn(n);
        }(n);
    }, cZn = F2(function(n, r) {
        if (n.$) return Sq;
        var t = n.a, e = A2(gV, k([
            mV,
            vV("mailto:" + t)
        ]), k([
            ad(t)
        ]));
        return r.$ ? e : A2(PB, h, k([
            ad(" or "),
            e
        ]));
    }), oZn = function(n) {
        if (n.$) return Sq;
        var r = n.a;
        return A2(gV, k([
            mV,
            vV("tel:" + r)
        ]), k([
            ad(dF(r))
        ]));
    }, fZn = function(n) {
        return A2(Ik, k([
            Nk("panel w-full")
        ]), k([
            A2(mx, h, k([
                ad("The practice is not currently accepting new members")
            ])),
            gx,
            A2(hx, h, k([
                ad("Please contact us and let us know the plan you would like to sign up for at "),
                oZn(kF(n)),
                A2(cZn, lk(n), kF(n))
            ]))
        ]));
    }, sZn = function(n) {
        return {
            zO: F2(function(r, t) {
                var e = v(r.dw, r.fF, r.e6);
                n: for(;;)switch(e.a.$){
                    case 2:
                        return v(tZn, Dp, h);
                    case 3:
                        switch(e.b.$){
                            case 3:
                                if (!e.c.$) {
                                    var u = e.a.a;
                                    return uZn(a = e.b.a) ? v(nZn(t), Dp, h) : v(rZn(u), Dp, h);
                                }
                                var a;
                                if (u = e.a.a, !uZn(a = e.b.a)) return v(rZn(u), Dp, h);
                                switch(r.CX.$){
                                    case 3:
                                        return A2(kk, KWn, A2(sk, h, A4(n.zO, u, a, r, t)));
                                    case 2:
                                        return v(eZn(u), Dp, h);
                                    default:
                                        return v(nZn(t), Dp, h);
                                }
                            case 2:
                                return v(eZn(u = e.a.a), Dp, h);
                            default:
                                break n;
                        }
                    default:
                        break n;
                }
                return v(nZn(t), Dp, h);
            }),
            Ab: F2(function(r, t) {
                var e = v(r.dw, r.fF, t);
                n: for(; !e.c.$;)switch(e.a.$){
                    case 2:
                        return b(tZn, Dp);
                    case 3:
                        switch(e.b.$){
                            case 3:
                                var u = e.b.a, a = e.c.a, c = A4(n.zO, d = e.a.a, u, r, a), o = c.a, f = c.b;
                                if (uZn(u)) {
                                    var s = b(r.e6, r.CX);
                                    r: for(;;)switch(s.b.$){
                                        case 3:
                                            switch(s.a.$){
                                                case 2:
                                                    var l = s.a.a;
                                                    return b(KWn(o), Hu(k([
                                                        f,
                                                        iZn(l)
                                                    ])));
                                                case 1:
                                                    return b(KWn(o), Hu(k([
                                                        f,
                                                        gk(d)
                                                    ])));
                                                default:
                                                    break r;
                                            }
                                        case 2:
                                            return b(eZn(d), Dp);
                                        default:
                                            break r;
                                    }
                                    return b(nZn(a), Dp);
                                }
                                return b(rZn(d), Dp);
                            case 2:
                                var d;
                                return b(eZn(d = e.a.a), Dp);
                            default:
                                break n;
                        }
                    default:
                        break n;
                }
                if (1 === t.$) {
                    var p = t.a;
                    return A2(wk, KWn, A2(n.Ab, r, m(p, {
                        kj: i(r.kj, p.kj) ? p.kj : r.kj
                    })));
                }
                return b(t, Dp);
            }),
            Ct: F2(function(r, t) {
                return 1 === r.$ ? A2(n.Ct, r.a, t) : t;
            }),
            Dd: function(r) {
                return 1 === r.$ ? n.Dd(r.a) : yk;
            },
            DB: F2(function(r, t) {
                return 1 === t.$ ? A2(kk, KWn, A2(n.DB, r, t.a)) : v(t, Dp, h);
            }),
            DH: function(r) {
                switch(r.$){
                    case 1:
                        var t = r.a;
                        return A2(n.DH, Rk(t.kj), t);
                    case 2:
                        return {
                            gF: k([
                                wx
                            ]),
                            wD: "404"
                        };
                    case 3:
                        return {
                            gF: k([
                                (e = r.a, A2(Ik, k([
                                    Nk("panel w-full")
                                ]), k([
                                    A2(mx, h, k([
                                        ad("We can't find the signup page you were looking for")
                                    ])),
                                    gx,
                                    A2(hx, h, k([
                                        ad("Please contact us and let us know the plan you would like to sign up for at "),
                                        oZn(kF(e)),
                                        A2(cZn, lk(e), kF(e))
                                    ]))
                                ])))
                            ]),
                            wD: "404"
                        };
                    case 4:
                        return {
                            gF: k([
                                fZn(r.a)
                            ]),
                            wD: "404"
                        };
                    default:
                        return {
                            gF: Yk,
                            wD: "Loading..."
                        };
                }
                var e;
            }
        };
    }, lZn = F4(function(n, r, t, e) {
        return {
            kj: e,
            dw: n,
            lj: r,
            w_: t
        };
    }), dZn = function(n) {
        return n.lH;
    }, bZn = F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    }), vZn = function(n) {
        return A2(be, F2(function(n, r) {
            return A2(bZn, r, n);
        }), n);
    }, mZn = function(n) {
        return vZn(A2(Tc, function(n) {
            return dZn(n);
        }, n));
    }, pZn = function(n) {
        return n.v2;
    }, $Zn = F2(function(n, r) {
        var t = n, e = pZn(r);
        switch(t.sS){
            case 0:
                return fi({
                    v2: e
                });
            case 1:
                return ci({
                    v2: e
                });
            case 2:
                return di({
                    v2: e
                });
            case 3:
                return bi({
                    v2: e
                });
            case 4:
                return si({
                    v2: e
                });
            case 5:
                return li({
                    v2: e
                });
            case 6:
                return vi({
                    v2: e
                });
            default:
                return oi({
                    v2: e
                });
        }
    }), hZn = F3(function(n, r, t) {
        var e = Gb(mZn(r));
        return e.$ ? dL : A2(zx, t, A2($Zn, e.a.a, n));
    }), gZn = F4(function(n, r, t, e) {
        var u, a = 3 === (u = t.CX).$ ? u.a : h, i = GIn(r);
        return b(A4(lZn, n, i, e, t.kj), A3(hZn, i, a, e.iu));
    }), wZn = F2(function(n, r) {
        return b(r, Dp);
    }), kZn = F2(function(n, r) {
        return r;
    }), xZn = F2(function(n, r) {
        return v(r, Dp, h);
    }), yZn = F2(function(n, r) {
        var t = r.dw;
        return {
            gF: k([
                Sq
            ]),
            wD: hk(t)
        };
    }), _Zn = sZn({
        zO: gZn,
        Ab: wZn,
        Ct: kZn,
        Dd: function() {
            return yk;
        },
        DB: xZn,
        DH: yZn
    }), CZn = F3(function(n, r, t) {
        return b({
            kj: r.kj,
            dw: n,
            fF: Mx,
            w_: t
        }, A2(zx, t.iu, $i));
    }), DZn = F2(function(n, r) {
        return b(r, Dp);
    }), AZn = F2(function(n, r) {
        return r;
    }), qZn = F2(function(n, r) {
        return v(r, Dp, h);
    }), BZn = function(n) {
        return n.yn.wD;
    }, jZn = F2(function(n) {
        return {
            gF: k([
                Sq
            ]),
            wD: n(BZn)
        };
    }), SZn = kx({
        zO: CZn,
        Ab: DZn,
        Ct: AZn,
        Dd: function() {
            return yk;
        },
        DB: qZn,
        DH: jZn
    }), zZn = F3(function(n, r, t) {
        var e = A2(Zu, "company", t.iu), u = function() {
            if (e.$) return b(A2(zx, t.iu, $i), t);
            var n = e.a, r = A2(aa, "company", t.iu);
            return b(A2(zx, r, pi({
                v2: OB(n)
            })), m(t, {
                iu: r
            }));
        }();
        return b({
            kj: r.kj,
            dw: n,
            fF: Mx,
            w_: u.b
        }, u.a);
    }), UZn = F2(function(n, r) {
        return b(r, Dp);
    }), EZn = F2(function(n, r) {
        return r;
    }), PZn = F2(function(n, r) {
        return v(r, Dp, h);
    }), TZn = F2(function() {
        return {
            gF: k([
                Sq
            ]),
            wD: "Enroll"
        };
    }), FZn = kx({
        zO: zZn,
        Ab: UZn,
        Ct: EZn,
        Dd: function() {
            return yk;
        },
        DB: PZn,
        DH: TZn
    }), LZn = F3(function(n, r, t) {
        return b({
            kj: r.kj,
            dw: n,
            fF: Mx,
            w_: t
        }, A2(zx, t.iu, Ni));
    }), MZn = F2(function(n, r) {
        return b(r, Dp);
    }), HZn = F2(function(n, r) {
        return r;
    }), RZn = F2(function(n, r) {
        return v(r, Dp, h);
    }), OZn = function(n) {
        return n.cU.pw;
    }, NZn = function(n) {
        return n.cU.px;
    }, IZn = function(n) {
        return n.cU.B8;
    }, VZn = function(n) {
        return n.cU.wD;
    }, WZn = F2(function(n) {
        return {
            gF: k([
                Sq
            ]),
            wD: n(VZn)
        };
    }), ZZn = kx({
        zO: LZn,
        Ab: MZn,
        Ct: HZn,
        Dd: function() {
            return yk;
        },
        DB: RZn,
        DH: WZn
    }), XZn = Jn("initializeRecaptchaPort", function() {
        return bk;
    }), GZn = function(n) {
        return A2(w7, n, h);
    }, JZn = Jn("removeTokenPort", function(n) {
        return vk(k([
            b("key", mk(n.hH))
        ]));
    }), YZn = JZn({
        hH: "accountToken"
    }), QZn = k([
        0
    ]), KZn = function() {
        return "Email";
    }, nXn = F3(function(n, r, t) {
        var e, u, a = A2(Zu, "patient", t.iu), i = A2(Zu, "email", t.iu), c = YS(i) ? "automatic" : "manual", o = GZn("Authentication - Email Prompted"), f = (e = b(yx(r.gx), YS(i))).a ? P7(r.gx) ? b(YZn, !1) : b(A2(zx, oa, Wa), !1) : b(Dp, !!e.b), s = f.a, l = f.b;
        return b({
            gw: c,
            gx: r.gx,
            z: AO((u = A2(uc, "", i), {
                pt: u
            })),
            he: l,
            kj: r.kj,
            BK: a,
            dw: n,
            uA: l,
            iG: !1,
            w_: t,
            x: A2(jO, QZn, KZn)
        }, Hu(k([
            s,
            o,
            XZn(0)
        ])));
    }), rXn = F2(function(n, r) {
        return b(r, Dp);
    }), tXn = F2(function(n, r) {
        return r;
    }), eXn = function(n) {
        return {
            $: 2,
            a: n
        };
    }, uXn = {
        $: 1
    }, aXn = Kn("gotRecaptchaInitializedPort", w$), iXn = F2(function(n) {
        return n;
    }), cXn = function(n) {
        return aXn(iXn(n));
    }, oXn = Kn("gotRecaptchaTokenPort", A2(Ge, function(n) {
        return A2(Ge, function(r) {
            return Ke({
                k9: r,
                wL: n
            });
        }, A2(Tu, "result", w$));
    }, A2(Tu, "token", w$))), fXn = F2(function(n, r) {
        var t = r.wL;
        switch(r.k9){
            case "ok":
                return n(Qt(t));
            case "recaptcha-not-defined":
                return n(Xt(0));
            default:
                return n(Xt(1));
        }
    }), sXn = function(n) {
        return oXn(fXn(n));
    }, lXn = function(n) {
        return {
            $: 3,
            a: n
        };
    }, dXn = {
        $: 0
    }, bXn = function(n) {
        for(;;){
            var r = ke(n);
            if (r.$) return !0;
            var t = r.a;
            if (" " !== (e = t.a) && "\n" !== e && "\t" !== e && "\r" !== e) return !1;
            n = t.b;
        }
        var e;
    }, vXn = ZN(k([
        function(n) {
            var r = A3(Gy, " ", "", n.pt);
            return bXn(r) || uI(r) ? h : k([
                b(0, JN(A2(XN, YN, KN)))
            ]);
        }
    ])), mXn = Jn("getRecaptchaTokenPort", mk), pXn = function(n) {
        return mXn(function(n) {
            return n ? "selfserve" : "signup";
        }(n));
    }, $Xn = F2(function(n, r) {
        return A2(k7, n, function(n) {
            return n ? "True" : "False";
        }(r));
    }), hXn = F3(function(n, r, t) {
        return A2(w7, r, A2(Ot, A2($Xn, "input_valid", n), t));
    }), gXn = F2(function(n, r) {
        return A3(hXn, r, "Authentication - Email Submitted", k([
            A2(x7, "method", n)
        ]));
    }), wXn = function(n) {
        var r = A2(wI, vXn, n.z);
        return r.$ ? b(r.a, !1) : b(r.a.a, !0);
    }, kXn = F2(function(n, r) {
        var t = n ? AI(r.x) : r.x;
        return m(r, {
            z: wXn(r).a,
            x: t
        });
    }), xXn = function() {
        return Ht(0);
    }, yXn = F2(function(n, r) {
        var t = xXn();
        if (t.$) return r;
        var e = t.a;
        return A2(yI, e, r.x) ? m(A2(kXn, !1, r), {
            x: A3(_I, !0, e, r.x)
        }) : r;
    }), _Xn = A2(Tu, "salt", w$), CXn = F5(function(n, r, t, e, u) {
        var a = vk(k([
            b("email", mk(r)),
            b("practice_id", mk(t)),
            b("google_recaptcha_token", A2(yN, mk, e))
        ]));
        return A4(vN, z9(n), _Xn, u, A2(xq, a, bC(A2($y, k([
            "auth",
            "request_code"
        ]), gy(t)))));
    }), DXn = F2(function(n, r) {
        return m(r, {
            pt: n
        });
    }), AXn = F2(function(n, r) {
        var t = xXn();
        return t.$ ? r : m(r, {
            x: A3(XI, !0, t.a, r.x)
        });
    }), qXn = F2(function(n, r) {
        return A2(AXn, n, m(r, {
            z: A3(WI, DXn, n, r.z)
        }));
    }), BXn = F2(function(n, r) {
        switch(n.$){
            case 5:
                return v(A2(qXn, n.a, r), Dp, h);
            case 0:
                return v(m(r, {
                    uA: !0
                }), pXn(1), h);
            case 4:
                var t = jN(r.z);
                return v(A2(yXn, t.pt, r), Dp, h);
            case 1:
                var e = r.he ? A2(Eu, ru, gu(dXn)) : Dp;
                return v(m(r, {
                    he: !1
                }), e, h);
            case 2:
                var u = k$(n.a), a = jN(r.z), i = (e = A5(CXn, r.gx, a.pt, $k(r.dw), u, lXn), A2(wI, vXn, r.z));
                return i.$ ? v(m(r, {
                    z: i.a,
                    uA: !1
                }), Dp, h) : v(m(r, {
                    z: i.a.a
                }), e, h);
            default:
                var c = n.a, o = m(r, {
                    uA: !1
                });
                if (3 === c.$) {
                    var f = c.a, s = (p = A2(Zu, "redirectTo", r.w_.iu)).$ ? h : k([
                        b("redirectTo", p.a)
                    ]), l = $(k([
                        b("email", jN(r.z).pt),
                        b("salt", f)
                    ]), (d = r.BK).$ ? s : $(s, k([
                        b("patient", d.a)
                    ])));
                    return v(o, Hu(k([
                        A2(zx, Ml(l), ai),
                        A2(gXn, r.gw, !0)
                    ])), h);
                }
                return v(o, A2(gXn, r.gw, !1), A2(uA, 0, c));
        }
        var d, p;
    }), jXn = function(n) {
        return n.oB;
    }, SXn = function(n) {
        return jXn(n.a);
    }, zXn = function(n) {
        var r = A2(uc, "", SXn(n));
        return A2(AB, k([
            TB(r),
            Iq(hk(n)),
            Nk("mx-auto w-3/12 mb-10")
        ]), h);
    }, UXn = function(n) {
        return n.hR.gW;
    }, EXn = function(n) {
        return n.hR.qg;
    }, PXn = F2(function(n, r) {
        return r.rM(n);
    }), TXn = function(n) {
        return A2(lV, k([
            jV(k([
                Nk("email-result")
            ]))
        ]), k([
            A2(iV, k([
                UZ(12)
            ]), k([
                A2(Ik, k([
                    Nk("email-result__logo")
                ]), k([
                    A2(PB, k([
                        BB
                    ]), k([
                        A2(US, k([
                            mz
                        ]), 11)
                    ]))
                ]))
            ])),
            A2(iV, k([
                UZ(12)
            ]), k([
                A2(Q4, h, h),
                A2(hx, k([
                    rx,
                    bz(wF),
                    zV
                ]), k([
                    ad("Check your email")
                ])),
                A2(Q4, h, h),
                A2(hx, k([
                    BB,
                    bz(wF)
                ]), k([
                    ad("We sent an email to you at " + n + ". It has a magic link that will grant you access. If you don't see it, check your spam folder.")
                ]))
            ]))
        ]));
    }, FXn = {
        $: 4
    }, LXn = function(n) {
        return {
            $: 5,
            a: n
        };
    }, MXn = "https://www.ftc.gov/enforcement/rules/rulemaking-regulatory-reform-proceedings/childrens-online-privacy-protection-rule", HXn = F2(function(n, r) {
        return r.rO(n);
    }), RXn = F3(function(n, r, t) {
        return A2(ZI, t, r) && A2(kW, t, n);
    }), OXn = F2(function(n, r) {
        return r.vS(n);
    }), NXn = function(n) {
        return n.vT;
    }, IXn = function(n) {
        return n.vU;
    }, VXn = F3(function(n, r, t) {
        return A2(ZI, t, r) ? A2(iW, t, n) : h;
    }), WXn = function(n) {
        return n.xu;
    }, ZXn = F2(function(n, r) {
        var t = A3(RXn, r.z, r.x, 0), e = UXn, u = jN(r.z).pt;
        return A2(wxn, k([
            yxn(dXn)
        ]), k([
            A2(AW, k([
                bW(n(WXn)),
                hW(!0)
            ]), k([
                yP(k([
                    lP("e.g. name@example.com"),
                    xZ(A2(sc, LXn, ru)),
                    oZ(t),
                    bP(u),
                    lZ(FXn)
                ])),
                A2(OW, n, A3(VXn, r.z, r.x, 0))
            ])),
            A2(Q4, h, h),
            A2(fz, k([
                nz,
                JS,
                ZS(t || r.uA),
                Don(r.uA)
            ]), k([
                ad(n(A2(XN, HXn, e)))
            ])),
            A2(Q4, h, h),
            A2(Q4, h, h),
            A2(hx, k([
                EB,
                bz(wF)
            ]), k([
                A2(Gk, h, k([
                    ad(n(A2(XN, OXn, A2(XN, HXn, e)))),
                    ad(" ")
                ])),
                A2(gV, k([
                    vV(MXn),
                    mV
                ]), k([
                    ad(n(NXn))
                ])),
                A2(Gk, h, k([
                    ad(" "),
                    ad(n(IXn))
                ]))
            ]))
        ]));
    }), XXn = F2(function(n, r) {
        var t = k([
            Phn(1)
        ]), e = pVn;
        return xx(r) ? A3(Ihn, t, Rt, ad(n(e))) : Sq;
    }), GXn = F2(function(n, r) {
        var t = UXn, e = jN(r.z).pt;
        return A2(lV, k([
            jV(k([
                Nk("panel")
            ]))
        ]), k([
            A2(iV, h, k([
                A2(XT, k([
                    LS(E4),
                    bz(wF)
                ]), k([
                    ad(n(EXn))
                ])),
                A2(hx, k([
                    bz(wF)
                ]), k([
                    ad(n(A2(XN, PXn, t)))
                ])),
                A2(Q4, h, h),
                A2(XXn, n, r.gx),
                r.iG ? TXn(e) : A2(ZXn, n, r)
            ]))
        ]));
    }), JXn = F2(function(n, r) {
        return {
            gF: k([
                A2(lV, h, k([
                    Gan(k([
                        Oun(2),
                        GZ(0)
                    ])),
                    A2(iV, k([
                        Oun(8),
                        GZ(12)
                    ]), k([
                        zXn(r.dw),
                        A2(GXn, n, r)
                    ]))
                ]))
            ]),
            wD: hk(r.dw)
        };
    }), YXn = function(n) {
        var r, t = hk(n);
        return A2(Ik, k([
            Nk("mx-auto mb-6 flex items-center justify-center border border-primary-600 rounded p-6 w-8/12 sm:w-5/12")
        ]), k([
            (r = SXn(n), r.$ ? ad(t) : A2(AB, k([
                TB(r.a),
                Iq(t),
                Nk("max-w-full")
            ]), h))
        ]));
    }, QXn = function(n) {
        return n.rN;
    }, KXn = F2(function(n, r) {
        var t = A3(RXn, r.z, r.x, 0), e = UXn, u = jN(r.z).pt;
        return A2(wxn, k([
            yxn(dXn)
        ]), k([
            A2(hx, k([
                zV,
                bz(wF)
            ]), k([
                ad(n(QXn))
            ])),
            A2(Q4, h, h),
            A2(iU, h, k([
                A2(Gk, k([
                    Nk("sr-only")
                ]), k([
                    ad(n(WXn))
                ])),
                yP(k([
                    lP("name@example.com"),
                    xZ(A2(sc, LXn, ru)),
                    oZ(t),
                    bP(u),
                    lZ(FXn)
                ]))
            ])),
            A2(OW, n, A3(VXn, r.z, r.x, 0)),
            A2(Ik, k([
                Nk("mt-4")
            ]), k([
                A2(fz, k([
                    nz,
                    JS,
                    ZS(t || r.uA),
                    Don(r.uA)
                ]), k([
                    ad(n(A2(XN, HXn, e)))
                ]))
            ])),
            A2(Q4, h, h),
            A2(Q4, h, h),
            A2(hx, k([
                EB,
                BB,
                bz(wF)
            ]), k([
                A2(Gk, h, k([
                    ad(n(A2(XN, OXn, A2(XN, HXn, e)))),
                    ad(" ")
                ])),
                A2(gV, k([
                    vV(MXn),
                    mV
                ]), k([
                    ad(n(NXn))
                ])),
                A2(Gk, h, k([
                    ad(" "),
                    ad(n(IXn))
                ]))
            ]))
        ]));
    }), nGn = F2(function(n, r) {
        var t = jN(r.z).pt;
        return A2(Ik, h, k([
            A2(XT, k([
                LS(E4),
                bz(wF)
            ]), k([
                ad(hk(r.dw))
            ])),
            A2(XXn, n, r.gx),
            r.iG ? TXn(t) : A2(KXn, n, r)
        ]));
    }), rGn = F2(function(n, r) {
        return {
            gF: k([
                A2(lV, k([
                    jV(k([
                        Nk("px-4 sm:px-0")
                    ]))
                ]), k([
                    Gan(k([
                        Oun(2),
                        GZ(0)
                    ])),
                    A2(iV, k([
                        Oun(8),
                        GZ(12)
                    ]), k([
                        YXn(r.dw),
                        A2(nGn, n, r)
                    ]))
                ]))
            ]),
            wD: hk(r.dw)
        };
    }), tGn = F2(function(n, r) {
        return _Vn(r.dw) ? A2(rGn, n, r) : A2(JXn, n, r);
    }), eGn = kx({
        zO: nXn,
        Ab: rXn,
        Ct: tXn,
        Dd: function() {
            return xk(k([
                sXn(eXn),
                cXn(uXn)
            ]));
        },
        DB: BXn,
        DH: tGn
    }), uGn = function() {
        return "DateOfBirth";
    }, aGn = F3(function(n, r, t) {
        var e = AO({
            bg: CO("dob")
        });
        return b({
            gx: r.gx,
            g4: 0,
            cp: 0,
            kj: r.kj,
            kk: e,
            tE: oc,
            dw: n,
            w_: t.B9,
            x: A2(jO, k([
                0
            ]), uGn),
            jE: !1
        }, GZn("Authentication - DOB Requested"));
    }), iGn = F2(function(n, r) {
        return b(r, Dp);
    }), cGn = F2(function(n, r) {
        return m(r, {
            gx: n.gx,
            tE: n.tE
        });
    }), oGn = function(n) {
        return {
            $: 13,
            a: n
        };
    }, fGn = function(n) {
        return {
            $: 2,
            a: n
        };
    }, sGn = F2(function(n, r) {
        return m(r, {
            bg: n
        });
    }), lGn = F2(function(n, r) {
        return A2(k7, n, ee(r));
    }), dGn = F2(function(n, r) {
        return A3(hXn, r, "Authentication - DOB Submitted", k([
            A2(lGn, "attempts", n)
        ]));
    }), bGn = function(n) {
        return {
            $: 0,
            a: n
        };
    }, vGn = F2(function(n, r) {
        return b(n, jBn(r.oD));
    }), mGn = function(n) {
        return Ke(E$(n));
    }, pGn = A2(Ge, mGn, A2(Tu, "token", w$)), $Gn = F4(function(n, r, t, e) {
        var u = vk(k([
            t
        ]));
        return A4(vN, n, pGn, e, A2(xq, u, bC(A2($y, k([
            "auth",
            "switch_patient"
        ]), gy(r)))));
    }), hGn = F2(function(n, r) {
        return b(r.a, n);
    }), gGn = ZN(k([
        function(n) {
            var r = Gb(czn(n.bg));
            if (r.$) return h;
            var t, e = r.a;
            return k([
                b(0, (t = A2(XN, YN, GN), A2(hGn, t, e)))
            ]);
        }
    ])), wGn = F2(function(n, r) {
        var t = jN(r);
        return A3(WI, sGn, A2(LI, n, t.bg), r);
    }), kGn = F2(function(n, r) {
        var t = A2(wI, gGn, A2(wGn, n, r.kk));
        return t.$ ? b(t.a, !1) : b(t.a.a, !0);
    }), xGn = F2(function(n, r) {
        var t = n ? AI(r.x) : r.x, e = A2(kGn, n, r), u = e.b;
        return b(m(r, {
            kk: e.a,
            x: t
        }), u);
    }), yGn = function(n) {
        return n.cW.kg;
    }, _Gn = function(n) {
        return n.cW.vn;
    }, CGn = function(n) {
        return n.cW.jq;
    }, DGn = function(n) {
        return n.cW.De;
    }, AGn = function(n) {
        return n.cW.wD;
    }, qGn = function(n) {
        return n.cW.xs;
    }, BGn = F2(function(n, r) {
        switch(n.$){
            case 1:
                var t = A2(xGn, !0, r), e = t.a;
                return t.b ? v(m(e, {
                    cp: r.cp + 1
                }), function(n) {
                    var r = $k(n.dw), t = jN(n.kk);
                    return A4($Gn, n.gx, r, A2(vGn, "dob", t.bg), bGn);
                }(e), h) : v(e, Dp, h);
            case 0:
                var u = n.a;
                switch(u.$){
                    case 3:
                        var a = u.a;
                        return v(m(r, {
                            g4: 3,
                            jE: !0
                        }), A2(dGn, r.cp, !0), k([
                            A2(nA, 3, DGn),
                            oGn(a)
                        ]));
                    case 2:
                        return u.a.$ ? v(m(r, {
                            g4: 2
                        }), A2(dGn, r.cp, !1), A2(Ot, A2(nA, 1, yGn), A2(uA, 0, u))) : v(m(r, {
                            g4: 1
                        }), A2(dGn, r.cp, !1), h);
                    default:
                        return v(r, Dp, h);
                }
            default:
                var i = n.a, c = jN(r.kk), o = A2(MI, i, c.bg), f = o.b;
                return v(m(r, {
                    kk: A3(WI, sGn, o.a, r.kk)
                }), A2(jp, fGn, f), h);
        }
    }), jGn = {
        $: 1
    }, SGn = F2(function(n, r) {
        return A2(uc, "", r) + "Please contact " + n + " for more information";
    }), zGn = A3(Ihn, k([
        Phn(0)
    ]), Ht("No matching date of birth found."), Sq), UGn = F3(function(n, r, t) {
        var e = jN(t.kk).bg;
        return A2(lV, h, k([
            A2(iV, k([
                Oun(12)
            ]), k([
                A2(AW, k([
                    bW("Date of birth"),
                    hW(!0)
                ]), k([
                    A2(px, fGn, A3(hZ, n, k([
                        rZ(r)
                    ]), e))
                ])),
                A2(Q4, h, h),
                function() {
                    var n;
                    switch(t.g4){
                        case 1:
                            return zGn;
                        case 2:
                            return n = t.dw, A3(Ihn, k([
                                Phn(0)
                            ]), Ht(A2(SGn, hk(n), Rt)), Sq);
                        default:
                            return A2(Ik, h, h);
                    }
                }(),
                A2(Q4, h, h),
                A2(fz, k([
                    nz,
                    JS,
                    ZS(r),
                    QS(jGn)
                ]), k([
                    ad("Sign in")
                ])),
                A2(Q4, h, h),
                A2(Q4, h, h)
            ]))
        ]));
    }), EGn = A2(lV, k([
        jV(h)
    ]), k([
        A2(iV, k([
            UZ(12)
        ]), k([
            A2(Ik, k([
                Nk("text-center")
            ]), k([
                Jk(k([
                    n5
                ]))
            ]))
        ]))
    ])), PGn = F2(function(n, r) {
        return A2(lV, k([
            jV(k([
                Nk("panel")
            ]))
        ]), k([
            A2(iV, h, k([
                A2(XT, k([
                    LS(E4),
                    bz(wF)
                ]), k([
                    ad("Provide date of birth")
                ])),
                A2(hx, k([
                    bz(wF)
                ]), k([
                    ad("To ensure you access the correct account, please provide the date of birth as your email is linked to multiple members.")
                ])),
                A2(Q4, h, h),
                r.jE ? EGn : A3(UGn, n, !1, r)
            ]))
        ]));
    }), TGn = F2(function(n, r) {
        return {
            gF: k([
                A2(lV, h, k([
                    Gan(k([
                        Oun(2),
                        GZ(0)
                    ])),
                    A2(iV, k([
                        Oun(8),
                        GZ(12)
                    ]), k([
                        zXn(r.dw),
                        A2(PGn, n, r)
                    ]))
                ]))
            ]),
            wD: "Provide date of birth"
        };
    }), FGn = kx({
        zO: aGn,
        Ab: iGn,
        Ct: cGn,
        Dd: function() {
            return yk;
        },
        DB: BGn,
        DH: TGn
    }), LGn = {
        gW: ""
    }, MGn = Jn("replaceUrl", mk), HGn = k([
        0
    ]), RGn = function() {
        return "Code";
    }, OGn = F3(function(n, r, t) {
        var e, u = A2(Zu, "salt", t.iu), a = A2(Zu, "patient", t.iu), i = (e = b(yx(r.gx), $H(u))).a ? A2(zx, oa, Wa) : e.b ? A2(zx, oa, ei) : MGn(A2(QV, k([
            t.B9.BJ
        ]), h)), c = GZn("Authentication - Code Prompted");
        return b({
            gx: r.gx,
            gW: "",
            E: AO(LGn),
            et: 0,
            bL: 0,
            pt: A2(Zu, "email", t.iu),
            kj: r.kj,
            BK: a,
            dw: n,
            uA: !1,
            k6: A2(Zu, "redirectTo", t.iu),
            fp: u,
            b5: Rt,
            dO: !1,
            w_: t,
            x: A2(jO, HGn, RGn)
        }, Hu(k([
            i,
            c
        ])));
    }), NGn = F2(function(n, r) {
        return b(r, Dp);
    }), IGn = F2(function(n, r) {
        return r;
    }), VGn = function(n) {
        return {
            $: 19,
            a: n
        };
    }, WGn = function(n) {
        return {
            aL: n,
            wD: Rt
        };
    }, ZGn = F2(function(n, r) {
        return A3(hXn, r, "Authentication - Code Submitted", k([
            A2(lGn, "attempts", n)
        ]));
    }), XGn = function(n) {
        return n.nw.q2;
    }, GGn = ZN(k([
        function(n) {
            var r = n.gW;
            return 1 === lu(r).$ || 6 !== au(r) ? k([
                b(0, JN(XGn))
            ]) : h;
        }
    ])), JGn = function(n) {
        var r = A2(wI, GGn, n.E);
        return r.$ ? b(r.a, !1) : b(r.a.a, !0);
    }, YGn = F2(function(n, r) {
        var t = n ? AI(r.x) : r.x;
        return m(r, {
            E: JGn(r).a,
            x: t
        });
    }), QGn = function() {
        return Ht(0);
    }, KGn = F2(function(n, r) {
        var t = QGn();
        if (t.$) return r;
        var e = t.a;
        return A2(yI, e, r.x) ? m(A2(YGn, !1, r), {
            x: A3(_I, !0, e, r.x)
        }) : r;
    }), nJn = function(n) {
        return {
            $: 3,
            a: n
        };
    }, rJn = F2(function(n, r) {
        var t = n.pt;
        return t.$ ? Dp : A5(CXn, n.gx, t.a, $k(n.dw), r, nJn);
    }), tJn = F2(function(n, r) {
        return $H(r) && function(n) {
            if (n.$) return !1;
            var r = n.a;
            if (h$(r)) {
                var t = Ey(w$);
                return A2(uc, !1, A2(Cp, function(n) {
                    return n > 1;
                }, k$(A2(Wp, function(n) {
                    return oe(n);
                }, A2(m$, A2(Tu, "patients", t), r)))));
            }
            return !1;
        }(n);
    }), eJn = function(n) {
        return {
            $: 2,
            a: n
        };
    }, uJn = F8(function(n, r, t, e, u, a, i, c) {
        var o = vk(k([
            b("email", mk(r)),
            b("code", mk(e)),
            b("salt", mk(t)),
            b("practice_id", mk(u)),
            b("google_recaptcha_token", A2(yN, mk, a)),
            b("patient_id", A2(yN, mk, i))
        ]));
        return A4(vN, z9(n), pGn, c, A2(xq, o, bC(A2($y, k([
            "auth"
        ]), gy(u)))));
    }), aJn = F2(function(n, r) {
        var t = jN(n.E).gW, e = b(n.pt, n.fp);
        return e.a.$ || e.b.$ ? Dp : A8(uJn, n.gx, e.a.a, e.b.a, t, $k(n.dw), r, n.BK, eJn);
    }), iJn = function(n) {
        var r = A2(wI, GGn, n.E);
        return r.$ ? v(m(n, {
            E: r.a,
            uA: !1,
            x: AI(n.x)
        }), Dp, h) : v(m(n, {
            E: r.a.a,
            bL: n.bL + 1,
            uA: !0,
            b5: Rt
        }), A2(aJn, n, Rt), h);
    }, cJn = F2(function(n, r) {
        return m(r, {
            gW: n
        });
    }), oJn = F2(function(n, r) {
        var t = QGn();
        return t.$ ? r : m(r, {
            x: A3(XI, !0, t.a, r.x)
        });
    }), fJn = F2(function(n, r) {
        return A2(oJn, n, m(r, {
            E: A3(WI, cJn, n, r.E)
        }));
    }), sJn = F2(function(n, r) {
        switch(n.$){
            case 6:
                var t = jN((a = A2(fJn, n.a, r)).E).gW;
                return _Vn(r.dw) && 6 === au(t) && !r.uA ? iJn(a) : v(a, Dp, h);
            case 0:
                return iJn(r);
            case 5:
                var e = jN(r.E);
                return v(A2(KGn, t = e.gW, r), Dp, h);
            case 1:
                return v(m(r, {
                    gW: "",
                    E: AO(LGn),
                    et: r.et + 1,
                    bL: 0,
                    uA: !0,
                    b5: Rt
                }), A2(rJn, r, Rt), h);
            case 2:
                var u = n.a, a = m(r, {
                    uA: !1
                });
                n: for(;;)switch(u.$){
                    case 3:
                        var i = u.a, c = function() {
                            if (A2(tJn, i, r.BK)) {
                                var n = (t = r.k6).$ ? oa : Ml(k([
                                    b("redirectTo", t.a)
                                ]));
                                return b(A2(zx, n, ui), k([
                                    VGn(i)
                                ]));
                            }
                            var t;
                            return b(Dp, k([
                                oGn(i)
                            ]));
                        }(), o = c.b;
                        return v(r, Hu(k([
                            c.a,
                            A2(ZGn, r.bL, !0)
                        ])), o);
                    case 2:
                        if (5 === u.a.$) {
                            var f = u.a.b;
                            return v(m(a, {
                                b5: au(f) > 0 ? Ht(WGn(k([
                                    KD(f)
                                ]))) : Rt
                            }), A2(ZGn, r.bL, !1), h);
                        }
                        break n;
                    default:
                        break n;
                }
                return v(a, A2(ZGn, r.bL, !1), A2(uA, 0, u));
            case 3:
                var s = n.a;
                return a = m(r, {
                    uA: !1,
                    b5: Rt,
                    dO: !0
                }), 3 === s.$ ? v(m(a, {
                    fp: Ht(s.a)
                }), A2(w7, "Authentication - Code Resent", k([
                    A2(lGn, "quantity", r.et)
                ])), h) : v(a, Dp, A2(uA, 0, s));
            default:
                return v(m(r, {
                    dO: !1
                }), Dp, h);
        }
    }), lJn = {
        $: 1
    }, dJn = F2(function(n, r) {
        return r.w8(n);
    }), bJn = {
        $: 5
    }, vJn = function(n) {
        return {
            $: 6,
            a: n
        };
    }, mJn = {
        $: 0
    }, pJn = function(n) {
        return function(n) {
            return {
                $: 4,
                a: n
            };
        }(n);
    }, $Jn = F3(function(n, r, t) {
        return A2(ZI, t, r) && A2(kW, t, n);
    }), hJn = F3(function(n, r, t) {
        return A2(ZI, t, r) ? A2(iW, t, n) : h;
    }), gJn = function(n) {
        return n.aL;
    }, wJn = F2(function(n, r) {
        return {
            $: 1,
            a: n,
            b: r
        };
    }), kJn = wJn, xJn = F2(function(n, r) {
        return oe(r) ? A2(Van, k([
            A2(kJn, 2, 1),
            A2(kJn, 3, 1)
        ]), A2(yu, function(r) {
            return Pan(HW(n(r)));
        }, r)) : Sq;
    }), yJn = function(n) {
        return n.wD;
    }, _Jn = F2(function(n, r) {
        var t = k([
            Phn(0)
        ]);
        if (r.$) return Sq;
        var e = r.a;
        return A3(Ihn, t, yJn(e), A2(xJn, n, gJn(e)));
    }), CJn = F2(function(n, r) {
        var t = A3($Jn, r.E, r.x, 0), e = jN(r.E).gW;
        return A2(wxn, k([
            yxn(mJn)
        ]), k([
            A2(AW, k([
                bW(n(qGn)),
                hW(!0)
            ]), k([
                yP(k([
                    lP("e.g. 123456"),
                    xZ(A2(sc, vJn, ru)),
                    oZ(t),
                    lZ(bJn),
                    bP(e),
                    pJn(1),
                    KZ("one-time-code")
                ])),
                A2(OW, n, A3(hJn, r.E, r.x, 0))
            ])),
            A2(Q4, h, h),
            A2(fz, k([
                nz,
                JS,
                ZS(t || r.uA)
            ]), k([
                ad(n(CGn))
            ])),
            A2(Q4, h, h),
            A2(Q4, h, h),
            A2(_Jn, n, r.b5),
            A2(hx, k([
                EB,
                bz(wF)
            ]), k([
                A2(Gk, h, k([
                    ad(n(A2(XN, OXn, CGn))),
                    ad(" ")
                ])),
                A2(gV, k([
                    vV("https://www.ftc.gov/enforcement/rules/rulemaking-regulatory-reform-proceedings/childrens-online-privacy-protection-rule"),
                    mV
                ]), k([
                    ad(n(NXn))
                ])),
                A2(Gk, h, k([
                    ad(" "),
                    ad(n(IXn))
                ]))
            ]))
        ]));
    }), DJn = {
        $: 4
    }, AJn = function(n) {
        return {
            $: 1,
            a: n
        };
    }, qJn = F2(function(n, r) {
        var t = Ht("Code has been resent"), e = k([
            Phn(1),
            AJn(DJn)
        ]);
        return n ? A3(Ihn, e, t, A4(xL, hk(r), kF(r), Ht("If we have an account matching your email address, you will receive an email with the code. If you do not receive an email"), Rt)) : Sq;
    }), BJn = F2(function(n, r) {
        return A2(lV, k([
            jV(k([
                Nk("panel")
            ]))
        ]), k([
            A2(iV, h, k([
                A2(XT, k([
                    LS(E4),
                    bz(wF)
                ]), k([
                    ad(n(AGn))
                ])),
                A2(hx, k([
                    bz(wF)
                ]), k([
                    ad(n(dJn(A2(uc, "", r.pt))))
                ])),
                A2(lz, k([
                    bz(wF),
                    LS(Sdn)
                ]), k([
                    A2(fz, k([
                        r4,
                        QS(lJn)
                    ]), k([
                        ad(n(_Gn))
                    ]))
                ])),
                A2(Q4, h, h),
                A2(qJn, r.dO, r.dw),
                A2(Q4, h, h),
                A2(CJn, n, r)
            ]))
        ]));
    }), jJn = F2(function(n, r) {
        return k([
            A2(lV, h, k([
                Gan(k([
                    Oun(2),
                    GZ(0)
                ])),
                A2(iV, k([
                    Oun(8),
                    GZ(12)
                ]), k([
                    zXn(r.dw),
                    A2(BJn, n, r)
                ]))
            ]))
        ]);
    }), SJn = function(n) {
        return function(n) {
            return {
                $: 4,
                a: n
            };
        }(n);
    }, zJn = function(n) {
        return function(n) {
            return {
                $: 1,
                a: n
            };
        }(n);
    }, UJn = function(n) {
        return n.w6;
    }, EJn = F2(function(n, r) {
        return r.w7(n);
    }), PJn = F2(function(n, r) {
        switch(n.$){
            case 0:
                return m(r, {
                    eS: n.a
                });
            case 1:
                return m(r, {
                    h4: Ht(n.a)
                });
            case 2:
                return m(r, {
                    w5: n.a
                });
            case 3:
                return m(r, {
                    yR: n.a
                });
            default:
                return m(r, {
                    ed: n.a
                });
        }
    }), TJn = {
        ed: "",
        yR: !1,
        eS: 6,
        h4: Rt,
        w5: ""
    }, FJn = F2(function(n, r) {
        var t = i(au(n), r), e = A3(iu, r, r + 1, n), u = !fu(e);
        return A2(Ik, k([
            rz(k([
                b("code-input__box", !0),
                b("code-input__box--active", t),
                b("code-input__box--empty", !t && !u),
                b("code-input__box--filled", u && !t)
            ]))
        ]), k([
            ad(e)
        ]));
    }), LJn = function(n) {
        var r, t, e = A3(ce, PJn, TJn, n), u = (r = e.h4).$ ? h : k([
            RU(r.a)
        ]), a = fu(e.ed) ? h : k([
            A2(Wx, "aria-label", e.ed)
        ]), i = Gi(k([
            k([
                Nk("code-input__field"),
                dz("tel"),
                (t = e.eS, A2(br, "maxlength", ee(t))),
                A2(Wx, "autocomplete", "one-time-code"),
                A2(Wx, "inputmode", "numeric"),
                cU(e.w5),
                tz(e.yR),
                vP(!0)
            ]),
            a,
            u
        ]));
        return A2(Ik, k([
            Nk("code-input")
        ]), k([
            A2(fU, i, h),
            A2(Ik, k([
                Nk("code-input__boxes")
            ]), A2(yu, FJn(e.w5), A2(de, 0, e.eS - 1)))
        ]));
    }, MJn = F2(function(n, r) {
        var t, e, u = A2(uc, "", r.pt), a = jN(r.E).gW;
        return A2(wxn, k([
            yxn(mJn)
        ]), k([
            A2(hx, k([
                OL,
                LS(FS),
                bz(wF)
            ]), k([
                ad(n(EJn(u)))
            ])),
            A2(hx, h, k([
                ad(n(UJn))
            ])),
            A2(Ik, k([
                Nk("mt-8")
            ]), k([
                LJn(k([
                    {
                        $: 0,
                        a: 6
                    },
                    (e = a, function(n) {
                        return {
                            $: 2,
                            a: n
                        };
                    }(e)),
                    zJn(A2(sc, vJn, ru)),
                    (t = r.uA, function(n) {
                        return {
                            $: 3,
                            a: n
                        };
                    }(t)),
                    SJn(n(qGn))
                ]))
            ])),
            A2(_Jn, n, r.b5),
            A2(qJn, r.dO, r.dw),
            A2(Ik, k([
                Nk("mt-4")
            ]), k([
                A2(fz, k([
                    r4,
                    QS(lJn),
                    ZS(r.uA)
                ]), k([
                    ad(n(_Gn))
                ]))
            ])),
            A2(OW, n, A3(hJn, r.E, r.x, 0))
        ]));
    }), HJn = F2(function(n, r) {
        return k([
            A2(lV, k([
                jV(k([
                    Nk("px-4 sm:px-0")
                ]))
            ]), k([
                Gan(k([
                    Oun(3),
                    GZ(0)
                ])),
                A2(iV, k([
                    Oun(6),
                    GZ(12)
                ]), k([
                    YXn(r.dw),
                    A2(XT, k([
                        LS(E4),
                        bz(wF)
                    ]), k([
                        ad(hk(r.dw))
                    ])),
                    A2(MJn, n, r)
                ]))
            ]))
        ]);
    }), RJn = F2(function(n, r) {
        var t;
        return {
            gF: (t = b(r.pt, r.fp), t.a.$ || t.b.$ ? Yk : _Vn(r.dw) ? A2(HJn, n, r) : A2(jJn, n, r)),
            wD: hk(r.dw)
        };
    }), OJn = kx({
        zO: OGn,
        Ab: NGn,
        Ct: IGn,
        Dd: function() {
            return yk;
        },
        DB: sJn,
        DH: RJn
    }), NJn = QMn({
        DH: function() {
            return {
                gF: k([
                    wx
                ]),
                wD: "404"
            };
        }
    }), IJn = kVn({
        zO: function(n) {
            return A2(wVn, ga, n.iu);
        }
    }), VJn = function(n) {
        return {
            $: 2,
            a: n
        };
    }, WJn = function(n) {
        return 2 === n.$ ? Ht(n.a) : Rt;
    }, ZJn = function(n) {
        return WJn(n.fV);
    }, XJn = function(n) {
        return {
            $: 4,
            a: n
        };
    }, GJn = function(n) {
        return n.ny;
    }, JJn = function(n) {
        return yvn(GJn(n));
    }, YJn = function(n) {
        return n.vr ? n.mf : h;
    }, QJn = function(n) {
        return n.nz;
    }, KJn = function(n) {
        return yvn(QJn(n));
    }, nYn = function(n) {
        switch(n){
            case 0:
                return "Mailing Address";
            case 1:
                return "Billing Address";
            case 2:
                return "Addresses Are The Same";
            case 3:
                return "Insurance";
            default:
                return "Enrollment Status";
        }
    }, rYn = function(n) {
        return "field-" + nYn(n);
    }, tYn = F3(function(n, r, t) {
        return A4(hDn, YJn(r), hk(n), lk(n), t ? A2(avn, KJn(r), bbn(rYn(1))) : A2(avn, JJn(r), bbn(rYn(0))));
    }), eYn = F4(function(n, r, t, e) {
        var u = A2(Abn, n, r), a = u.a, i = u.b;
        return b({
            l0: A3(tYn, t, e, 0),
            aS: !0,
            mG: A3(tYn, t, e, 1),
            pJ: !0,
            a_: a
        }, k([
            A2(jp, XJn, i)
        ]));
    }), uYn = A3(zy, "billing_address_zip", l_(w$), A3(zy, "billing_address_state", l_(w$), A3(zy, "billing_address_line2", l_(w$), A3(zy, "billing_address_line1", l_(w$), A3(zy, "billing_address_country", l_(w$), A3(zy, "billing_address_city", l_(w$), A3(zy, "owner_pays_on_behalf", l_(xy), A3(zy, "health_insurance", l_(Qsn), A3(zy, "address_zip", l_(w$), A3(zy, "address_state", l_(w$), A3(zy, "address_line2", l_(w$), A3(zy, "address_line1", l_(w$), A3(zy, "address_country", l_(w$), A3(zy, "address_city", l_(w$), Ke(function(n) {
        return function(r) {
            return function(t) {
                return function(e) {
                    return function(u) {
                        return function(a) {
                            return function(i) {
                                return function(c) {
                                    return function(o) {
                                        return function(f) {
                                            return function(s) {
                                                return function(l) {
                                                    return function(d) {
                                                        return function(b) {
                                                            return {
                                                                l1: n,
                                                                l2: r,
                                                                l3: t,
                                                                l4: e,
                                                                l5: u,
                                                                l6: a,
                                                                mH: o,
                                                                mI: f,
                                                                mJ: s,
                                                                mK: l,
                                                                mL: d,
                                                                mM: b,
                                                                qC: i,
                                                                tr: c
                                                            };
                                                        };
                                                    };
                                                };
                                            };
                                        };
                                    };
                                };
                            };
                        };
                    };
                };
            };
        };
    }))))))))))))))), aYn = A2(qy, uYn, Ke(ru)), iYn = F2(function(n, r) {
        return A2($y, k([
            "online_enrollments",
            r,
            "additional_details"
        ]), gy(n));
    }), cYn = F4(function(n, r, t, e) {
        return A4(dC, z9(n), aYn, e, bC(A2(iYn, r, t)));
    }), oYn = function(n) {
        return WJn(n.e6);
    }, fYn = k([
        0,
        1,
        3,
        4
    ]), sYn = F4(function(n, r, t, e) {
        var u = A4(eYn, t.gx, !1, n, r), a = u.a, i = u.b, c = function() {
            var r = b(oYn(t), t.CX);
            if (3 === r.b.$) {
                if (r.a.$) return v(i, oc, u = r.b.a);
                var e = r.a.a, u = r.b.a;
                return v(A2(Ot, A4(cYn, t.gx, $k(n), e, VJn), i), Mx, u);
            }
            return v(i, oc, h);
        }(), o = c.a, f = c.b, s = c.c;
        return b({
            fV: ZJn(t),
            xH: Rt,
            gx: t.gx,
            gE: VJ,
            g7: t.g7,
            kj: t.kj,
            kk: AO(a),
            e6: t.e6,
            h5: f,
            dw: n,
            uA: !1,
            cL: f,
            cM: VJ,
            iN: Rt,
            lj: GIn(r),
            fF: r,
            CX: s,
            w_: e,
            x: A2(jO, fYn, nYn)
        }, Hu(o));
    }), lYn = F2(function(n, r) {
        return b(r, Dp);
    }), dYn = F2(function(n, r) {
        return r;
    }), bYn = F2(function(n, r) {
        return {
            $: 3,
            a: n,
            b: r
        };
    }), vYn = function(n) {
        return {
            $: 10,
            a: n
        };
    }, mYn = Kn("onUrlChange", w$), pYn = function(n) {
        return {
            $: 0,
            a: n
        };
    }, $Yn = function(n) {
        return {
            $: 2,
            a: n
        };
    }, hYn = function(n) {
        return {
            $: 1,
            a: n
        };
    }, gYn = {
        $: 8
    }, wYn = {
        $: 7
    }, kYn = function(n) {
        return {
            $: 4,
            a: n
        };
    }, xYn = function(n) {
        return {
            $: 9,
            a: n
        };
    }, yYn = function(n) {
        return {
            $: 3,
            a: n
        };
    }, _Yn = {
        $: 15
    }, CYn = function(n) {
        return {
            $: 11,
            a: n
        };
    }, DYn = function(n) {
        return {
            $: 5,
            a: n
        };
    }, AYn = function(n) {
        return n.mc;
    }, qYn = F2(function(n, r) {
        return A2(iW, r, n);
    }), BYn = F2(function(n, r) {
        return A2(yu, function(n) {
            return b(r, n);
        }, A2(qYn, n, r));
    }), jYn = function(n) {
        return A2(x7, "Error Description", n);
    }, SYn = function(n) {
        return A2(x7, "Error Name", n);
    }, zYn = function(n) {
        return A2(x7, "Field Name", n);
    }, UYn = function(n) {
        return n.a ? "required" : "validation";
    }, EYn = function(n) {
        return A2(uc, " ", A2(Cp, UYn, n));
    }, PYn = F2(function(n, r) {
        var t = r.p5, e = r.eC;
        return A2(w7, "Form Field Errored", k([
            _7(n),
            zYn(t),
            SYn(EYn(Gb(e))),
            jYn(A2(ue, ", ", A2(yu, UW(Rk(0)), e)))
        ]));
    }), TYn = "Member Signup 2.0", FYn = function(n) {
        return A2(PYn, TYn, n);
    }, LYn = F2(function(n, r) {
        var t = Gb(A2(ou, n, r));
        if (t.$) return b("", r);
        var e = t.a;
        return b(A2(su, e, r), A2(nv, au(r) - e - au(n), r));
    }), MYn = F2(function(n, r) {
        var t = A2(LYn, ": ", r), e = t.a, u = t.b;
        return au(e) > 0 ? b($(nYn(n), $(": ", e)), u) : b(nYn(n), r);
    }), HYn = function(n) {
        return A2(yu, function(n) {
            var r = n.a, t = n.b, e = A2(UW, Rk(0), t), u = function() {
                switch(r){
                    case 0:
                    case 1:
                        return A2(MYn, 0, e);
                    default:
                        return b(nYn(r), e);
                }
            }().a;
            return FYn({
                eC: k([
                    t
                ]),
                p5: u
            });
        }, function(n) {
            return Gi(A2(yu, BYn(n), fYn));
        }(n));
    }, RYn = {
        Da: ZK(100),
        Dz: function(n) {
            return {
                $: 5,
                a: n
            };
        }
    }, OYn = function(n) {
        return n.nD;
    }, NYn = function(n) {
        return {
            $: 6,
            a: n
        };
    }, IYn = function(n) {
        return A2(Eu, NYn, gu(n));
    }, VYn = function(n) {
        return {
            $: 8,
            a: n
        };
    }, WYn = function(n) {
        return A2(Eu, VYn, gu(n));
    }, ZYn = function(n) {
        return function(n) {
            return n.oM;
        }(n.fE);
    }, XYn = function(n) {
        return !whn(QJn(n));
    }, GYn = function(n) {
        return function(n) {
            return xAn(GJn(n));
        }(n) && KJn(n) ? 1 : function(n) {
            return !whn(GJn(n));
        }(n) ? XYn(n) ? 0 : 2 : XYn(n) ? 3 : 4;
    }, JYn = F2(function(n, r) {
        switch(GYn(n)){
            case 0:
            case 2:
                return !0;
            case 1:
                return !r.aS;
            default:
                return !1;
        }
    }), YYn = F2(function(n, r) {
        return A2(JYn, n, r) ? A2(yu, function(n) {
            var r = n.b;
            return b(0, A2(nzn, KSn(n.a), r));
        }, N$n(r.l0)) : h;
    }), QYn = F2(function(n, r) {
        switch(GYn(n)){
            case 0:
                return !r.aS;
            case 1:
            case 3:
                return !0;
            default:
                return !1;
        }
    }), KYn = F2(function(n, r) {
        return A2(QYn, n, r) ? A2(yu, function(n) {
            var r = n.b;
            return b(1, A2(nzn, KSn(n.a), r));
        }, N$n(r.mG)) : h;
    }), nQn = function(n) {
        return !whn(OYn(n));
    }, rQn = F2(function(n, r) {
        return A2(Cp, function(n) {
            return b(Dbn(r), n);
        }, Gb(A2(iW, r, n.kk)));
    }), tQn = F2(function(n, r) {
        var t, e = r.a_;
        return nQn(n) ? A2(yu, function(n) {
            var r = n.b;
            return b(3, A2(nzn, KSn(n.a), r));
        }, (t = e, A2(Ep, function(n) {
            return A2(rQn, t, n);
        }, Cbn))) : h;
    }), eQn = F2(function(n, r) {
        switch(n.$){
            case 0:
                return m(r, {
                    l0: n.a
                });
            case 1:
                return m(r, {
                    mG: n.a
                });
            case 2:
                return m(r, {
                    aS: n.a
                });
            case 3:
                return m(r, {
                    a_: n.a
                });
            default:
                return m(r, {
                    pJ: n.a
                });
        }
    }), uQn = F3(function(n, r, t) {
        if (A2(JYn, n, jN(t))) {
            var e = jN(t);
            return A3(WI, eQn, pYn(A2(Ypn, r, e.l0)), t);
        }
        return t;
    }), aQn = F3(function(n, r, t) {
        if (A2(QYn, n, jN(t))) {
            var e = jN(t);
            return A3(WI, eQn, hYn(A2(Ypn, r, e.mG)), t);
        }
        return t;
    }), iQn = F2(function(n, r) {
        var t = jN(r);
        return A3(WI, eQn, yYn(A2(k$n, n, t.a_).a), r);
    }), cQn = F3(function(n, r, t) {
        var e = A2(iQn, r, A3(aQn, n, r, A3(uQn, n, r, t))), u = A2(wI, function(n) {
            return ZN(k([
                YYn(n),
                KYn(n),
                tQn(n)
            ]));
        }(n), e);
        return u.$ ? b(u.a, !1) : b(u.a.a, !0);
    }), oQn = F2(function(n, r) {
        return !ED(A2(qYn, n, r));
    }), fQn = F2(function(n, r) {
        var t = A3(cQn, n, !1, r);
        return t.b ? Rt : A2(Xb, function(n) {
            return Ht(rYn(n));
        }, Gb(A2(Tc, oQn(t.a), fYn)));
    }), sQn = F2(function(n, r) {
        var t = jN(n.kk), e = jN(r.kk);
        return i(e.nr, t.nr) && i(e.yz, t.yz) && i(e.xJ, t.xJ) && i(e.xK, t.xK) && i(e.wi, t.wi) && i(e.xy, t.xy);
    }), lQn = F6(function(n, r, t, e, u, a) {
        var i, c, o = A4(hDn, YJn(e), hk(t), lk(t), A2(avn, KJn(e), A2(Uvn, rYn(1), {
            xJ: (c = a).mJ,
            xK: c.mK,
            nr: c.mH,
            yz: c.mI,
            wi: c.mL,
            xy: c.mM
        }))), f = A4(hDn, YJn(e), hk(t), lk(t), A2(avn, JJn(e), A2(Uvn, rYn(0), function(n) {
            return {
                xJ: n.l3,
                xK: n.l4,
                nr: n.l1,
                yz: n.l2,
                wi: n.l5,
                xy: n.l6
            };
        }(a)))), s = jN(u).a_, l = (i = function(n) {
            return n.qC;
        }(a), i.$ ? A2(Rvn, n, s) : A2(Zvn, i.a, s));
        return {
            l0: f,
            aS: A2(sQn, o, f),
            mG: o,
            pJ: r,
            a_: l
        };
    }), dQn = F9(function(n, r, t, e, u, a, i, c, o) {
        return {
            mS: o,
            qU: n,
            hQ: c,
            Av: a,
            tq: i,
            tr: e,
            u$: u,
            fE: t,
            iP: r
        };
    }), bQn = F5(function(n, r, t, e, u) {
        return {
            rm: e,
            sS: n,
            tu: u,
            k1: r,
            uP: t
        };
    }), vQn = F3(function(n, r, t) {
        return {
            yk: t,
            k1: r,
            uN: n
        };
    }), mQn = A3(zy, "charge_item", A2(Tu, "name", w$), A3(zy, "price_in_cents", C$, A3(zy, "quantity", C$, Ke(vQn)))), pQn = A4(Sy, "package_items", Ey(mQn), h, A4(Sy, "item_type", w$, "", A4(Sy, "quantity_in_stock", l_(C$), Rt, A3(zy, "price_in_cents", C$, A3(zy, "name", w$, Ke(bQn)))))), $Qn = A2(qy, pQn, Ke(ru)), hQn = F6(function(n, r, t, e, u, a) {
        return {
            l7: a,
            o2: r,
            qU: n,
            sS: t,
            u5: e,
            w4: u
        };
    }), gQn = A3(zy, "age", l_(C$), A3(zy, "uses_tobacco", xy, A3(zy, "relationship", A2(Ge, Pyn, w$), A3(zy, "name", w$, A3(zy, "dob", l_(FC), A3(zy, "id", w$, Ke(hQn))))))), wQn = A2(qy, gQn, Ke(ru)), kQn = function(n) {
        return {
            $: 0,
            a: n
        };
    }, xQn = F2(function(n, r) {
        var t = b(n, r);
        return t.a.$ ? t.b.$ ? yy("Either Plan or Charge item is required.") : Ke(function(n) {
            return {
                $: 1,
                a: n
            };
        }(t.b.a)) : Ke(kQn(t.a.a));
    }), yQn = function(n) {
        if (n.$) return Ke(Rt);
        var r = n.a;
        switch(r){
            case "terminate":
                return Ke(Ht(0));
            case "auto-renew":
                return Ke(Ht(1));
            default:
                return yy("Unsupported Contract type: " + r);
        }
    }, _Qn = A4(Sy, "description", l_(w$), Rt, A3(zy, "registration_fee_name", w$, A3(zy, "tobacco_surcharge_type", l_(w$), A3(zy, "dpc_discount", xy, A3(zy, "contract_type", A2(Ge, yQn, l_(w$)), A3(zy, "contract_period_in_months", l_(A2(Ge, Ofn, C$)), A3(zy, "contract_expires", xy, A3(zy, "bills_at_end_of_period", xy, A3(zy, "children_age_limit", l_(C$), A3(zy, "maximum_age", l_(C$), A3(zy, "minimum_age", l_(C$), A3(zy, "name", w$, A3(zy, "id", w$, Ke(function(n) {
        return function(r) {
            return function(t) {
                return function(e) {
                    return function(u) {
                        return function(a) {
                            return function(i) {
                                return function(c) {
                                    return function(o) {
                                        return function(f) {
                                            return function(s) {
                                                return function(l) {
                                                    return function(d) {
                                                        return {
                                                            mT: a,
                                                            nk: u,
                                                            n8: i,
                                                            ob: c,
                                                            of: o,
                                                            oV: d,
                                                            pd: f,
                                                            qU: n,
                                                            r_: e,
                                                            sL: t,
                                                            sS: r,
                                                            u2: l,
                                                            wI: s
                                                        };
                                                    };
                                                };
                                            };
                                        };
                                    };
                                };
                            };
                        };
                    };
                };
            };
        };
    })))))))))))))), CQn = A2(qy, _Qn, Ke(ru)), DQn = F2(function(n, r) {
        return {
            oM: r,
            qU: n
        };
    }), AQn = A3(zy, "debug", xy, A3(zy, "id", w$, Ke(DQn))), qQn = A2(qy, AQn, Ke(ru)), BQn = F3(function(n, r, t) {
        return {
            lH: r,
            sS: n,
            wK: t
        };
    }), jQn = function(n) {
        switch(n){
            case "owner_info":
                return Ke(0);
            case "additional_details":
                return Ke(1);
            case "members":
                return Ke(2);
            case "plan":
                return Ke(3);
            case "custom_details":
                return Ke(4);
            case "location":
                return Ke(5);
            case "practitioner":
                return Ke(6);
            case "confirmation":
                return Ke(7);
            default:
                return yy("Unsupported Signup step name: " + n);
        }
    }, SQn = A3(zy, "toggleable", xy, A3(zy, "active", xy, A3(zy, "name", A2(Ge, jQn, w$), Ke(BQn)))), zQn = A2(qy, SQn, Ke(ru)), UQn = A2(Ge, function(n) {
        return A2(qy, A2(xQn, n.t6, n.nf), A2(IC, n.hQ, A2(IC, n.tq, A2(IC, n.Av, A2(IC, n.u$, A2(IC, n.tr, A2(IC, n.fE, A2(IC, n.iP, A2(IC, n.qU, Ke(dQn))))))))));
    }, A3(zy, "charge_item", l_($Qn), A3(zy, "locations", Ey(qIn), A3(zy, "owner", ken, A3(zy, "members", Ey(wQn), A3(zy, "referred", xy, A3(zy, "owner_pays_on_behalf", xy, A3(zy, "signup_attempt", qQn, A3(zy, "plan", l_(CQn), A3(zy, "signup_step", zQn, A3(zy, "id", w$, Ke(function(n) {
        return function(r) {
            return function(t) {
                return function(e) {
                    return function(u) {
                        return function(a) {
                            return function(i) {
                                return function(c) {
                                    return function(o) {
                                        return function(f) {
                                            return {
                                                nf: f,
                                                qU: n,
                                                hQ: o,
                                                Av: i,
                                                tq: c,
                                                tr: u,
                                                t6: t,
                                                u$: a,
                                                fE: e,
                                                iP: r
                                            };
                                        };
                                    };
                                };
                            };
                        };
                    };
                };
            };
        };
    })))))))))))), EQn = A2(qy, UQn, Ke(ru)), PQn = F2(function(n, r) {
        return A2($y, k([
            "signup_pages",
            r
        ]), gy(n));
    }), TQn = F2(function(n, r) {
        return A2($y, k([
            "online_enrollments"
        ]), A2(PQn, n, r));
    }), FQn = F5(function(n, r, t, e, u) {
        return A4(dC, z9(n), EQn, u, bC(A2($y, k([
            e,
            "step"
        ]), A2(TQn, r, t))));
    }), LQn = function(n) {
        return 4 === n;
    }, MQn = F3(function(n, r, t) {
        var e = mZn(r);
        return A2(zD, function(r) {
            return i(A2($Zn, r.a, n), t);
        }, e);
    }), HQn = F4(function(n, r, t, e) {
        var u = b(A3(MQn, n, r, t), A3(MQn, n, r, e));
        return !u.a.$ && !u.b.$ && 0 > s(u.b.a.b, u.a.a.b);
    }), RQn = function(n) {
        return 1 === n;
    }, OQn = function(n) {
        return {
            $: 6,
            a: n
        };
    }, NQn = F2(function(n, r) {
        var t = A2(Ypn, !1, r);
        return A2(Xb, function(n) {
            return Gb(A2(iW, n, t.kk));
        }, Gb(A2(Tc, function(r) {
            return i(lbn(r), n);
        }, sbn)));
    }), IQn = F2(function(n, r) {
        var t = A2(k$n, !1, r).a;
        return A2(Xb, function(n) {
            return Gb(A2(iW, n, t.kk));
        }, Gb(A2(Tc, function(r) {
            return i(Dbn(r), n);
        }, Cbn)));
    }), VQn = F2(function(n, r) {
        switch(r.$){
            case 0:
            case 1:
                return A2(NQn, n, r.a);
            case 2:
            default:
                return Rt;
            case 3:
                return A2(IQn, n, r.a);
        }
    }), WQn = function(n) {
        switch(n.$){
            case 0:
                return 0;
            case 1:
                return 1;
            case 2:
                return 2;
            case 3:
                return 3;
            default:
                return 4;
        }
    }, ZQn = function(n) {
        return nYn(WQn(n));
    }, XQn = F2(function(n, r) {
        return Gb(A2(qYn, n.kk, WQn(r)));
    }), GQn = F2(function(n, r) {
        var t = n ? AI(r.x) : r.x, e = A3(cQn, r.fF, n, r.kk), u = e.b;
        return b(m(r, {
            kk: e.a,
            x: t
        }), u);
    }), JQn = F3(function(n, r, t) {
        var e = ac(n.w_.B9), u = A2(GQn, !1, n).a, a = function() {
            if (t.$) return b(ZQn(r), A2(XQn, u, r));
            var n = t.a;
            return b(ZQn(r) + ": " + n, A2(VQn, n, r));
        }(), i = a.a;
        return OQn(Ht({
            eC: A2(uc, h, A2(Cp, Gq, a.b)),
            p5: i,
            Cr: e
        }));
    }), YQn = F2(function(n, r) {
        return A2(k7, n, function(n) {
            return n ? "Yes" : "No";
        }(r));
    }), QQn = function(n) {
        return A2(YQn, "Existing Coverage", n);
    }, KQn = function(n) {
        return n.rd;
    }, nKn = function(n) {
        return n.rj;
    }, rKn = function(n) {
        return A2(x7, "Signup Flow", nKn(n) ? KQn(n) ? "Checkout" : "Retail" : "Employee");
    }, tKn = function(n) {
        return n.ma;
    }, eKn = function(n) {
        return n.nA;
    }, uKn = function(n) {
        return n.nE;
    }, aKn = F2(function(n, r) {
        return A2(k7, n, function(n) {
            switch(n){
                case 0:
                    return "No";
                case 1:
                    return "Yes";
                case 2:
                    return "Optional";
                case 3:
                    return "Require";
                default:
                    return "Default";
            }
        }(r));
    }), iKn = function(n) {
        return n.nH;
    }, cKn = function(n) {
        return n.nJ;
    }, oKn = function(n) {
        return n.nK;
    }, fKn = function(n) {
        return n.nL;
    }, sKn = function(n) {
        return n.nM;
    }, lKn = function(n) {
        return n.qU;
    }, dKn = function(n) {
        return A2(Xb, function(n) {
            return Ht(lKn(n));
        }, n.oN);
    }, bKn = function(n) {
        return n.qU;
    }, vKn = function(n) {
        return A2(Xb, function(n) {
            return Ht(bKn(n));
        }, n.oR);
    }, mKn = function(n) {
        return n.oU;
    }, pKn = function(n) {
        return n.sI;
    }, $Kn = function(n) {
        return A2(Xb, B8, n.kZ);
    }, hKn = function(n) {
        return n.u_;
    }, gKn = F2(function(n, r) {
        var t = function(n) {
            switch(n){
                case 0:
                    return "Collect Billing Address";
                case 1:
                    return "Collect Address";
                case 2:
                    return "Collect Practitioner";
                case 3:
                    return "Collect Location";
                case 4:
                    return "Collect Insurance";
                case 5:
                    return "Collect Payment Source";
                case 6:
                    return "Collect Lead Source";
                case 7:
                    return "Collect Broker";
                case 8:
                    return "Collect SSN";
                case 9:
                    return "Minimum Enroll Age";
                case 10:
                    return "Redirects Post Signup";
                case 11:
                    return "Post Signup Redirect Url";
                case 12:
                    return "Post Signup Message";
                case 13:
                    return "Show Post Signup Footer Button";
                case 14:
                    return "Signup Page";
                case 15:
                    return "Allow Non-Member Payer";
                case 16:
                    return "Collect Tobacco Use";
                case 17:
                    return "Restrict Zip Codes";
                case 18:
                    return "Allowed Zip Codes";
                case 19:
                    return "Default Practitioner";
                case 20:
                    return "Default Location";
                case 21:
                    return "Accepts New Signup";
                case 22:
                    return "Allow Coupons";
                case 23:
                    return "Collect Start Date";
                case 24:
                    return "Collect Rate Schedule";
                default:
                    return "Dependent Limit";
            }
        }(r);
        switch(r){
            case 0:
                return A2(aKn, t, QJn(n));
            case 1:
                return A2(aKn, t, GJn(n));
            case 2:
                return A2(aKn, t, ZIn(n));
            case 3:
                return A2(aKn, t, WIn(n));
            case 4:
                return A2(aKn, t, OYn(n));
            case 5:
                return A2(aKn, t, iKn(n));
            case 6:
                return A2(aKn, t, uKn(n));
            case 7:
                return A2(aKn, t, eKn(n));
            case 8:
                return A2(aKn, t, oKn(n));
            case 9:
                return A2(x7, t, A2(uc, "", A2(Cp, ee, pKn(n))));
            case 10:
                return A2($Xn, t, hKn(n));
            case 11:
                return A2(x7, t, A2(uc, "", $Kn(n)));
            case 12:
                return A2(x7, t, A2(uc, "", A2(Xb, B8, n.kY)));
            case 13:
                return A2($Xn, t, n.li);
            case 14:
                return A2(x7, t, XIn(GIn(n)));
            case 15:
                return A2(aKn, t, AYn(n));
            case 16:
                return A2($Xn, t, sKn(n));
            case 17:
                return A2($Xn, t, function(n) {
                    return n.vr;
                }(n));
            case 18:
                return A2(x7, t, A2(ue, ", ", YJn(n)));
            case 19:
                return A2(x7, t, A2(uc, "", vKn(n)));
            case 20:
                return A2(x7, t, A2(uc, "", dKn(n)));
            case 21:
                return A2($Xn, t, uZn(n));
            case 22:
                return A2($Xn, t, tKn(n));
            case 23:
                return A2($Xn, t, fKn(n));
            case 24:
                return A2($Xn, t, cKn(n));
            default:
                return A2(x7, t, A2(uc, "", A2(Cp, ee, mKn(n))));
        }
    }), wKn = k([
        0,
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8,
        9,
        10,
        11,
        12,
        13,
        14,
        15,
        16,
        17,
        18,
        19,
        20,
        21,
        22,
        23,
        24,
        25
    ]), kKn = function(n) {
        return A2(yu, gKn(n), wKn);
    }, xKn = function(n) {
        return n.sS;
    }, yKn = function(n) {
        return n.a;
    }, _Kn = function(n) {
        return A2(lGn, "Step Count", oe(n));
    }, CKn = function(n) {
        return n.b;
    }, DKn = function(n) {
        return A2(x7, "Step Index", A2(uc, "", A2(Cp, ee, A2(Cp, function(n) {
            return n + 1;
        }, A2(Cp, CKn, n)))));
    }, AKn = {
        xH: function(n) {
            return n.a7.xH;
        },
        yu: function(n) {
            return n.a7.yu;
        },
        yw: function(n) {
            return n.a7.yw;
        },
        yG: function(n) {
            return n.a7.yG;
        },
        ku: function(n) {
            return n.a7.ku;
        },
        Av: function(n) {
            return n.a7.Av;
        },
        Aw: function(n) {
            return n.a7.Aw;
        },
        Ay: function(n) {
            return n.a7.Ay;
        },
        uE: function(n) {
            return n.a7.uE;
        }
    }, qKn = F3(function(n, r, t) {
        return r((function() {
            switch(t){
                case 0:
                    return function(n) {
                        return n.yw;
                    };
                case 1:
                    return function(n) {
                        return n.xH;
                    };
                case 2:
                    return n ? function(n) {
                        return n.Aw;
                    } : function(n) {
                        return n.Av;
                    };
                case 3:
                    return function(n) {
                        return n.Ay;
                    };
                case 4:
                    return function(n) {
                        return n.yG;
                    };
                case 5:
                    return function(n) {
                        return n.ku;
                    };
                case 6:
                    return function(n) {
                        return n.uE;
                    };
                default:
                    return function(n) {
                        return n.yu;
                    };
            }
        })()(AKn));
    }), BKn = F3(function(n, r, t) {
        return A3(qKn, n, r, t.sS);
    }), jKn = function(n) {
        var r = A2(ue, ", ", A2(yu, A2(BKn, !1, Rk(0)), A2(yu, yKn, n)));
        return A2(x7, "Steps", r);
    }, SKn = function(n) {
        return n.wK;
    }, zKn = function(n) {
        return vZn(A2(Tc, function(n) {
            return dZn(n) || SKn(n);
        }, n));
    }, UKn = F2(function(n, r) {
        var t, e, u = zKn(r), a = A2(zD, function(r) {
            return i(n, xKn(yKn(r)));
        }, u);
        return k([
            (t = a, e = A2(uc, "", A2(Cp, A2(BKn, !1, Rk(0)), A2(Cp, yKn, t))), A2(x7, "Step Name", e)),
            DKn(a),
            _Kn(u),
            jKn(u)
        ]);
    }), EKn = F4(function(n, r, t, e) {
        return A2(w7, "Signup Page Completed", A2(Ot, rKn(GIn(t)), $(A2(UKn, n, r), $(kKn(t), e))));
    }), PKn = F3(function(n, r, t) {
        return A4(EKn, 1, n, r, k([
            QQn(t.Y),
            A2(x7, "Insurance Carrier", t.zS)
        ]));
    }), TKn = F4(function(n, r, t, e) {
        return A2(w7, "Signup Page Loaded", A2(Ot, rKn(GIn(t)), $(A2(UKn, n, r), $(kKn(t), e))));
    }), FKn = F3(function(n, r, t) {
        return A4(TKn, 1, n, r, k([
            QQn(t.Y)
        ]));
    }), LKn = function(n) {
        return A2(x7, "toState", n);
    }, MKn = function(n) {
        return A2(w7, "Signup Step Resumed", k([
            _7(TYn),
            LKn(n)
        ]));
    }, HKn = F2(function(n, r) {
        return A2(w7, "Signup Step Repeated", k([
            _7(TYn),
            LKn(Sx(r)),
            dtn(Sx(n))
        ]));
    }), RKn = F2(function(n, r) {
        return A2(uc, n, r.tr);
    }), OKn = F3(function(n, r, t) {
        return A2($y, k([
            "attempts",
            t
        ]), A2($y, k([
            "signup_pages",
            r
        ]), gy(n)));
    }), NKn = F6(function(n, r, t, e, u, a) {
        return A4(kq, z9(n), qQn, a, A2(xq, function(n) {
            return vk(k([
                b("attempt", vk(k([
                    b("zip_ineligible", kA(n))
                ])))
            ]));
        }(u), bC(A3(OKn, r, t, e))));
    }), IKn = F2(function(n, r) {
        var t = mZn(n);
        return A2(zD, function(n) {
            return i(n.a, r);
        }, t);
    }), VKn = F3(function(n, r, t) {
        return A2(Xb, function(r) {
            var e = yKn(r), u = b(A2(IKn, n, e), A2(IKn, n, t));
            return u.a.$ || u.b.$ ? Rt : Ht(u.b.a.b - u.a.a.b);
        }, r);
    }), WKn = F3(function(n, r, t) {
        return A3(MQn, n, r, ac(t));
    }), ZKn = F4(function(n, r, t, e) {
        var u = A3(VKn, r, A3(WKn, n, r, e), t);
        return !u.$ && u.a >= 0;
    }), XKn = {
        Da: ZK(300),
        Dz: function(n) {
            return {
                $: 7,
                a: n
            };
        }
    }, GKn = function(n) {
        return n.iP;
    }, JKn = function(n) {
        return {
            $: 1,
            a: n
        };
    }, YKn = function(n) {
        return n.$ ? bk : vk(k([
            b("id", mk(pbn(n.a)))
        ]));
    }, QKn = F2(function(n, r) {
        var t = A2(Xb, function(n) {
            return n.$ ? Rt : Ht(n.a);
        }, n), e = A2(Cp, mbn, t);
        return b("carrier_alias", r ? t.$ ? bk : vk(k([
            b("name", mk(Kln(t.a))),
            b("carrier", YKn(e))
        ])) : bk);
    }), KKn = F3(function(n, r, t) {
        if (r) {
            if (t.$) return bk;
            if (1 === t.a.$) return hmn(n);
            var e = mbn(t.a.a);
            return $$n(e) ? hmn(n) : bk;
        }
        return bk;
    }), n1n = F3(function(n, r, t) {
        if (r) {
            if (t.$) return bk;
            if (1 === t.a.$) return kA(n);
            var e = mbn(t.a.a);
            return Lwn(e) ? kA(n) : bk;
        }
        return bk;
    }), r1n = F3(function(n, r, t) {
        if (r) {
            if (t.$) return bk;
            if (1 === t.a.$) return hmn(n);
            var e = mbn(t.a.a);
            return h$n(e) ? hmn(n) : bk;
        }
        return bk;
    }), t1n = F3(function(n, r, t) {
        return r ? t.$ ? bk : hmn(1 === t.a.$ ? n : Kln(t.a.a)) : bk;
    }), e1n = function(n) {
        var r = n.ah, t = n.Y, e = n.bX, u = n.bH;
        return vk(k([
            b("group_id", A3(KKn, n.bT, t, r)),
            b("member_id", A3(r1n, e, t, r)),
            b("high_deductible", A3(n1n, n.qO, t, r)),
            A2(QKn, r, t),
            b("payer_name", A3(t1n, u, t, r))
        ]));
    }, u1n = k([
        b("address_city", bk),
        b("address_country", bk),
        b("address_line1", bk),
        b("address_line2", bk),
        b("address_state", bk),
        b("address_zip", bk)
    ]), a1n = F2(function(n, r) {
        return (tI(n) ? ru : yu(function(r) {
            var t = r.a, e = r.b;
            return b(A2(ue, "_", k([
                uF(n),
                t
            ])), e);
        }))(r);
    }), i1n = F2(function(n, r) {
        return A2(a1n, n, gmn(r));
    }), c1n = function(n) {
        return Xpn(n).b;
    }, o1n = F2(function(n, r) {
        var t = function() {
            switch(GYn(n)){
                case 0:
                    var t = r.aS ? r.l0 : r.mG;
                    return v(Ht(r.l0), Ht(t), r.aS || c1n(r.mG));
                case 1:
                    return v(Ht(r.aS ? r.mG : r.l0), Ht(r.mG), !0);
                case 2:
                    return v(Ht(r.l0), Rt, !1);
                case 3:
                    return v(Rt, Ht(r.mG), c1n(r.mG));
                default:
                    return v(Rt, Rt, !1);
            }
        }(), e = t.a, u = t.b, a = t.c, i = A2(uc, A2(a1n, "billing", u1n), A2(Cp, i1n("billing"), u)), c = A2(uc, u1n, A2(Cp, gmn, e));
        return $(function(n) {
            var r = jN(n.kk);
            return k([
                b("health_insurance", e1n(r)),
                b("existing_coverage", kA(r.Y))
            ]);
        }(r.a_), $(c, $(i, k([
            b("uses_billing_address", kA(a)),
            b("owner_pays_on_behalf", kA(!r.pJ))
        ]))));
    }), f1n = F5(function(n, r, t, e, u) {
        return A4(kq, z9(n), aYn, u, A2(xq, function(n) {
            return vk(k([
                b("online_enrollment", vk(n))
            ]));
        }(e), bC(A2(iYn, r, t))));
    }), s1n = F2(function(n, r) {
        switch(n.$){
            case 9:
                var t = n.a, e = m(r, {
                    h5: t
                });
                if (3 === t.$) {
                    var u = t.a, a = (nn = r.fV).$ ? Dp : MKn(nn.a), i = function() {
                        var n = r.xH;
                        if (n.$) return r.kk;
                        var t, e = n.a, a = A4(ZKn, r.lj, r.CX, GKn(u), r.w_.B9), i = !((t = b(a, !whn(OYn(r.fF)))).a || !t.b), c = AYn(r.fF), o = jN(r.kk), f = a ? o.pJ : !yvn(c) && !LQn(c);
                        return AO(A6(lQn, i, f, r.dw, r.fF, r.kk, e));
                    }(), c = ZYn(u), o = k(c ? [
                        wYn,
                        DYn(GKn(u)),
                        gYn
                    ] : [
                        DYn(GKn(u)),
                        gYn
                    ]), f = jN(i), s = A3(FKn, e.CX, e.fF, {
                        Y: Amn(F = f.a_)
                    });
                    return v(m(e, {
                        fV: Rt,
                        g7: c,
                        kk: i,
                        iN: Ht((K = u, function(n) {
                            return n.qU;
                        }(K.fE)))
                    }), Hu(k([
                        a,
                        s
                    ])), o);
                }
                return v(e, Dp, A2(uA, 1, t));
            case 2:
                var l = n.a;
                n: for(;;)switch(l.$){
                    case 2:
                        if (9 === l.a.$) return v(m(r, {
                            cL: oc
                        }), Dp, A2(uA, 1, l));
                        break n;
                    case 3:
                        var d = l.a, p = function() {
                            var n = r.e6;
                            if (2 === n.$) {
                                var t = n.a;
                                return A5(FQn, r.gx, $k(r.dw), pZn(r.lj), t, xYn);
                            }
                            return Dp;
                        }(), $ = AYn(r.fF), g = !(yvn($) || (RQn($) ? A2(RKn, !1, d) : LQn($) && A2(RKn, !0, d)));
                        return i = A3(WI, eQn, kYn(g), r.kk), v(m(r, {
                            xH: Ht(d),
                            kk: i,
                            cL: l
                        }), p, h);
                    default:
                        break n;
                }
                return v(m(r, {
                    cL: l
                }), Dp, A2(uA, 1, l));
            case 0:
                var w = A2(GQn, !0, r);
                if (e = w.a, w.b) return v(m(e, {
                    uA: !0
                }), function(n) {
                    var r = $k(n.dw), t = jN(n.kk), e = n.e6;
                    return 2 === e.$ ? A5(f1n, n.gx, r, e.a, A2(o1n, n.fF, t), JKn) : Dp;
                }(e), h);
                var x = A2(fQn, e.fF, e.kk);
                if (x.$) return v(e, Hu(HYn(e.kk)), h);
                var y = A3(mQ, XKn, x.a, e.cM), _ = y.b;
                return v(m(e, {
                    cM: y.a
                }), Hu(A2(Ot, _, HYn(e.kk))), h);
            case 1:
                if (l = n.a, e = m(r, {
                    uA: !1
                }), 3 === l.$) {
                    var C = jN(e.kk), D = A3(PKn, e.CX, e.fF, {
                        Y: Amn(F = C.a_),
                        zS: A2(uc, "", _mn(F))
                    });
                    return v(e, D, k([
                        _Yn
                    ]));
                }
                return v(e, Dp, A2(uA, 1, l));
            case 3:
                var A = n.a, q = n.b, B = jN(r.kk), j = A ? B.mG : B.l0, S = A2(Kpn, q, j), z = S.a, U = S.b, E = S.c, P = A ? hYn(z) : pYn(z), T = (e = m(r, {
                    kk: A3(WI, eQn, P, r.kk)
                }), A2(uc, b(h, Dp), A2(Cp, function(n) {
                    switch(n.$){
                        case 1:
                            return b(k([
                                A3(JQn, e, P, Ht(n.a))
                            ]), Dp);
                        case 2:
                            if ("Zip" === n.a) {
                                var t = r.iN;
                                if (t.$) return b(h, Dp);
                                var u = t.a;
                                return b(h, A6(NKn, r.gx, $k(r.dw), pZn(r.lj), u, function(n) {
                                    var r = n.cs;
                                    if (r.$) {
                                        var t = r.a, e = function(n) {
                                            return jN(n.kk).xy;
                                        }(n);
                                        return A2(Vpn, e, t);
                                    }
                                    return !1;
                                }(j), CYn));
                            }
                            return b(h, Dp);
                        default:
                            return b(h, Dp);
                    }
                }, E)));
                return o = T.a, _ = T.b, v(e, Hu(k([
                    A2(jp, bYn(A), U),
                    _
                ])), o);
            case 4:
                q = n.a;
                var F, L = jN(r.kk), M = A2(U$n, q, F = L.a_), H = M.b, R = M.c, O = yYn(M.a);
                return e = m(r, {
                    kk: A3(WI, eQn, O, r.kk)
                }), o = A2(yu, function(n) {
                    return A3(JQn, e, O, Ht(n.a));
                }, R), v(e, A2(jp, XJn, H), o);
            case 5:
                var N = n.a, I = A4(t1, RYn, KK(IYn), N, r.gE), V = I.b;
                return v(m(r, {
                    gE: I.a
                }), V, h);
            case 6:
                var W = n.a;
                if (A2(yI, W, r.x)) {
                    var Z = A3(_I, !0, W, r.x);
                    return v(m(e = A2(GQn, !1, r).a, {
                        x: Z
                    }), Dp, h);
                }
                return v(r, Dp, h);
            case 7:
                N = n.a;
                var X = A4(t1, XKn, KK(WYn), N, r.cM);
                return V = X.b, v(m(r, {
                    cM: X.a
                }), V, h);
            case 8:
                return v(r, qEn(n.a), h);
            case 10:
                var G = A2(uc, Ru, A2(Xb, function(n) {
                    return ec(n);
                }, $u(n.a))), J = A2(uc, Ru, ec(r.w_.B9));
                return v(r, A4(HQn, r.lj, r.CX, J, G) ? A2(HKn, J, G) : Dp, h);
            case 11:
                return v(r, Dp, h);
            case 12:
                var Y = _$n(n.a);
                if (Y.$) return v(r, Dp, h);
                var Q = kYn(Y.a);
                return v(m(r, {
                    kk: i = A3(WI, eQn, Q, r.kk)
                }), Dp, h);
            default:
                return v(m(r, {
                    kk: A3(WI, eQn, $Yn(n.a), r.kk)
                }), Dp, h);
        }
        var K, nn;
    }), l1n = {
        $: 0
    }, d1n = function(n) {
        return n.lY;
    }, b1n = function(n) {
        return n.lZ;
    }, v1n = F2(function(n, r) {
        return {
            $: 8,
            a: n,
            b: r
        };
    }), m1n = v1n, p1n = A2(TS, PS(3), Ht(4)), $1n = function(n) {
        return n.n2;
    }, h1n = F2(function(n, r) {
        return r.n3(n);
    }), g1n = function(n) {
        return n.n4;
    }, w1n = F3(function(n, r, t) {
        var e = mZn(A2(Tc, function(n) {
            return dZn(n);
        }, r));
        return A2(Xb, function(n) {
            return A2(tjn, n.b + 1, e);
        }, A3(WKn, n, r, t));
    }), k1n = XN(F2(function(n) {
        return Tin(n);
    })), x1n = F4(function(n, r, t, e) {
        var u = KQn(r);
        return n(function() {
            var a = b(A3(w1n, r, t, e), u);
            if (a.b) return k1n(g1n);
            if (a.a.$) return $1n;
            var i = yKn(a.a.a);
            return k1n(h1n(A3(BKn, u, n, i)));
        }());
    }), y1n = F2(function(n, r) {
        return {
            $: 6,
            a: n,
            b: r
        };
    }), _1n = y1n, C1n = function(n) {
        return {
            $: 13,
            a: n
        };
    }, D1n = function(n) {
        return function(n) {
            return {
                $: 6,
                a: n
            };
        }(n);
    }, A1n = F5(function(n, r, t, e, u) {
        var a = jN(t), i = a.l0, c = a.mG, o = a.aS, f = !YS(u) || !o, s = e ? b(c, n(mpn)) : b(i, n(ypn)), l = s.a, d = s.b;
        return A2(Ik, k([
            Nk("mb-6")
        ]), k([
            function() {
                if (u.$) return Sq;
                var n = u.a;
                return A2(Ik, k([
                    Nk("mt-2 sm:mt-3")
                ]), k([
                    A2(QW, k([
                        ZW(o),
                        WW(C1n),
                        VW(r),
                        D1n("addresses-are-the-same-checkbox")
                    ]), k([
                        ad(n)
                    ]))
                ]));
            }(),
            A2(IZ, f, A2(mx, k([
                LS(Htn),
                LS(aV)
            ]), k([
                ad(d)
            ]))),
            A2(IZ, f, A2(px, bYn(e), A3(Ghn, n, k([
                ghn(r)
            ]), l)))
        ]));
    }), q1n = F4(function(n, r, t, e) {
        var u = function() {
            switch(GYn(e)){
                case 0:
                    return b(A5(A1n, n, r, t, 0, Rt), A5(A1n, n, r, t, 1, A3(Je, n, Ht, ppn)));
                case 1:
                    return b(A5(A1n, n, r, t, 1, Rt), A5(A1n, n, r, t, 0, A3(Je, n, Ht, _pn)));
                case 2:
                    return b(A5(A1n, n, r, t, 0, Rt), Sq);
                case 3:
                    return b(A5(A1n, n, r, t, 1, Rt), Sq);
                default:
                    return b(Sq, Sq);
            }
        }(), a = u.a, i = u.b;
        return A2(Ik, k([
            Nk("addresses")
        ]), k([
            a,
            i
        ]));
    }), B1n = function(n) {
        return {
            $: 12,
            a: n
        };
    }, j1n = function(n) {
        return n.pO.o1;
    }, S1n = function(n) {
        return n.pO.pJ;
    }, z1n = function(n) {
        return n.pO.sS;
    }, U1n = function(n) {
        return n.pO.AO;
    }, E1n = F5(function(n, r, t, e, u) {
        var a = jN(t).pJ, i = b(RQn(e) || LQn(e), _on(u));
        return i.a && i.b ? A2(Ik, h, k([
            A2(AW, k([
                bW(n(z1n)),
                hW(!0),
                Ahn(n(U1n))
            ]), k([
                A2(lV, k([
                    jV(k([
                        Nk("-mx-1")
                    ]))
                ]), k([
                    A2(iV, k([
                        UZ(6)
                    ]), k([
                        A2(IU, k([
                            SU,
                            rwn(a),
                            ZU(B1n),
                            uE(uwn(!0)),
                            twn(r)
                        ]), k([
                            ad(n(S1n))
                        ]))
                    ])),
                    A2(iV, k([
                        UZ(6)
                    ]), k([
                        A2(IU, k([
                            SU,
                            rwn(!a),
                            ZU(B1n),
                            uE(uwn(!1)),
                            twn(r)
                        ]), k([
                            ad(n(j1n))
                        ]))
                    ]))
                ]))
            ]))
        ])) : Sq;
    }), P1n = function(n) {
        return n.qG;
    }, T1n = F4(function(n, r, t, e) {
        var u = jN(t).a_;
        return nQn(e) ? A2(Ik, k([
            Nk("mb-6")
        ]), k([
            A2(mx, k([
                LS(aV)
            ]), k([
                ad(n(P1n))
            ])),
            A2(px, XJn, A3(Gwn, n, r, u))
        ])) : Sq;
    }), F1n = function(n) {
        var r = n.uA, t = n.kk, e = n.fF, u = Rk(n.kj);
        return A2(Ik, k([
            Nk("mx-1 sm:mx-0")
        ]), k([
            A4(q1n, u, r, t, e),
            A4(T1n, u, r, t, e),
            A5(E1n, u, r, t, AYn(e), n.cL)
        ]));
    }, L1n = A2(TS, PS(2), Ht(1)), M1n = function(n) {
        return {
            $: 5,
            a: n
        };
    }, H1n = F4(function(n, r, t, e) {
        return A2(fz, k([
            nz,
            ZS(t || r),
            Don(r),
            QS(e),
            JS,
            M1n("next-step-button"),
            vz(k([
                dz("button")
            ]))
        ]), k([
            A2(Gk, h, k([
                ad(n),
                A2(US, k([
                    wPn,
                    LV(L1n)
                ]), 6)
            ]))
        ]));
    }), R1n = F2(function(n, r) {
        var t = A4(x1n, n, r.lj, r.CX, r.w_.B9);
        return k([
            A2(Ik, k([
                Nk("flex justify-center w-full")
            ]), k([
                A2(Ik, k([
                    Nk("flex-col w-full sm:w-4/5 lg:w-3/5")
                ]), k([
                    A2(XT, k([
                        jX,
                        LS(q3),
                        A2(_1n, 1, p1n),
                        bz(gz),
                        A2(m1n, 1, wF)
                    ]), k([
                        KQn(r.lj) ? ad(n(k1n(d1n))) : ad(n(k1n(b1n)))
                    ])),
                    F1n(r),
                    A4(H1n, t, r.uA, !1, l1n)
                ]))
            ]))
        ]);
    }), O1n = F2(function(n, r) {
        var t;
        return {
            gF: (t = b(r.cL, r.h5), 2 === t.a.$ ? A2(R1n, n, r) : 1 === t.b.$ ? Yk : A2(R1n, n, r)),
            wD: hk(r.dw)
        };
    }), N1n = sZn({
        zO: sYn,
        Ab: lYn,
        Ct: dYn,
        Dd: function() {
            return xk(k([
                A2(xD, bYn(0), pvn),
                A2(xD, bYn(1), pvn),
                mYn(vYn)
            ]));
        },
        DB: s1n,
        DH: O1n
    }), I1n = function(n) {
        return {
            $: 7,
            a: n
        };
    }, V1n = {
        $: 10
    }, W1n = function(n) {
        return {
            $: 13,
            a: n
        };
    }, Z1n = function(n) {
        return {
            $: 14,
            a: n
        };
    }, X1n = function(n) {
        return {
            $: 23,
            a: n
        };
    }, G1n = "content-container", J1n = function(n) {
        return {
            $: 15,
            a: n
        };
    }, Y1n = function(n) {
        var r = iKn(n);
        return !whn(r);
    }, Q1n = function(n) {
        return m(n, {
            jJ: !0
        });
    }, K1n = F6(function(n, r, t, e, u, a) {
        var i = A6(qin, n, r, t, u, Rt, a), c = i.b, o = Q1n(i.a);
        return Y1n(e) ? b(Ht(o), A2(jp, J1n, c)) : b(Rt, Dp);
    }), n0n = F2(function(n, r) {
        return A2(Zu, n, r);
    }), r0n = function(n) {
        return A2(n0n, "coupon", n);
    }, t0n = F4(function(n, r, t, e) {
        return {
            ap: b(A2(uc, "", e), !0),
            ac: t,
            al: r,
            b2: Rt,
            C3: n
        };
    }), e0n = F2(function(n, r) {
        return A2($y, k([
            "payment_source"
        ]), A2($y, k([
            r
        ]), A2($y, k([
            "online_enrollments"
        ]), gy(n))));
    }), u0n = F4(function(n, r, t, e) {
        return A4(dC, z9(n), een, e, bC(A2(e0n, r, t)));
    }), a0n = py("date-picker-input"), i0n = F3(function(n, r, t) {
        return {
            h3: 0,
            aD: !0,
            u3: t,
            fo: r,
            wT: n
        };
    }), c0n = function(n) {
        return n.ob;
    }, o0n = F2(function(n, r) {
        return n + " - " + qtn(r);
    }), f0n = F3(function(n, r, t) {
        var e = t, u = A2(o0n, A2(eE, r, e.BS), e.kN), a = n.$ ? u : i(n.a, e.BS) ? A2(o0n, "All upfront", e.kN) : u, c = A2(o0n, A2(eE, r, e.oQ), e.uW);
        return i(e.BS, e.oQ) ? a : a + " (Equal to " + c + ")";
    }), s0n = function(n) {
        var r = n;
        return A2(eE, Rk(0), r.BS);
    }, l0n = function(n) {
        return id({
            qU: "rate-schedule-select",
            Dr: f0n(A2(Xb, c0n, n)),
            Dt: function(n) {
                return Ht(s0n(n));
            }
        });
    }, d0n = function(n) {
        return A2(dA, "custom_registration_fee_name", n);
    }, b0n = k([
        3,
        0,
        2,
        1,
        4
    ]), v0n = function(n) {
        switch(n){
            case 0:
                return "Prepay Option";
            case 1:
                return "Start Date";
            case 2:
                return "Discount Code";
            case 3:
                return "Payment Source";
            default:
                return "Documents";
        }
    }, m0n = F4(function(n, r, t, e) {
        var u = GIn(r), a = KQn(u), i = r0n(e.iu), c = YS(i), o = c ? A2(Eu, ru, gu(V1n)) : Dp, f = A6(K1n, a, t.kj, n, r, t.yl, t.gx), s = f.a, l = f.b, d = A3(X3, a, t.gx, $k(n)), v = d.a, m = d.b, p = function() {
            var r = b(oYn(t), t.CX);
            if (3 === r.b.$) {
                if (r.a.$) return b(h, a = r.b.a);
                var e = r.a.a, a = r.b.a;
                return b(k([
                    A5(FQn, t.gx, $k(n), pZn(u), e, Z1n),
                    A2(jp, W1n, m),
                    l,
                    o,
                    A4(u0n, t.gx, $k(n), e, X1n)
                ]), a);
            }
            return b(h, h);
        }(), $ = p.a, g = p.b, w = a0n.b, x = a0n.a;
        return b({
            fV: ZJn(t),
            gx: t.gx,
            mS: Rt,
            yl: t.yl,
            oh: oc,
            g0: Rt,
            g7: t.g7,
            ac: Mx,
            kj: t.kj,
            kk: AO(A4(t0n, x, s, v, i)),
            hr: Rt,
            Av: oc,
            tk: Mx,
            e6: t.e6,
            aM: Mx,
            e8: oc,
            du: Mx,
            dw: n,
            cJ: l0n(Rt),
            uA: !1,
            aP: !1,
            fl: Rt,
            b6: Rt,
            iK: c,
            dN: !1,
            cR: A3(i0n, Rk(t.kj), G1n, d0n(n)),
            lj: u,
            fF: r,
            CX: g,
            w_: e,
            x: A2(jO, b0n, v0n)
        }, Hu(A2(Ot, A2(jp, I1n, w), $)));
    }), p0n = function(n) {
        return {
            $: 4,
            a: n
        };
    }, $0n = F2(function(n, r) {
        if (i(r.kj, n)) return b(r, Dp);
        var t = r.s;
        if (1 === t.$) {
            var e = t.a;
            return b(m(r, {
                kj: n
            }), A4(Wcn, n, ion(r.dw), Ycn(r.dw), e));
        }
        return b(r, Dp);
    }), h0n = F2(function(n, r) {
        switch(n.$){
            case 0:
                return m(r, {
                    b2: n.a
                });
            case 1:
                return m(r, {
                    C3: n.a
                });
            case 2:
                return m(r, {
                    ap: b(n.b, n.a)
                });
            case 3:
                return m(r, {
                    ac: n.a
                });
            default:
                return m(r, {
                    al: n.a
                });
        }
    }), g0n = F2(function(n, r) {
        return m(r, {
            kk: A3(WI, h0n, n, r.kk)
        });
    }), w0n = F2(function(n, r) {
        var t = A2(cp, n.fL, n.bf), e = jN(r.kk).al, u = function() {
            if (e.$) return b(Rt, Dp);
            var r = e.a;
            return A2(hln, jp(J1n), A2(wk, Ht, A2($0n, n.kj, r)));
        }(), a = u.b;
        return b(A2(g0n, p0n(u.a), m(r, {
            yl: n.yl,
            g0: Ht(t)
        })), a);
    }), k0n = F2(function(n, r) {
        return r;
    }), x0n = function(n) {
        return {
            $: 19,
            a: n
        };
    }, y0n = function(n) {
        return {
            $: 18,
            a: n
        };
    }, _0n = function(n) {
        return {
            $: 20,
            a: n
        };
    }, C0n = F2(function(n, r) {
        return {
            $: 4,
            a: n,
            b: r
        };
    }), D0n = function(n) {
        return {
            $: 3,
            a: n
        };
    }, A0n = function() {
        return xk(k([
            bIn(D0n),
            CG(C0n)
        ]));
    }, q0n = {
        $: 0
    }, B0n = F2(function(n, r) {
        return {
            $: 2,
            a: n,
            b: r
        };
    }), j0n = function(n) {
        return {
            $: 12,
            a: n
        };
    }, S0n = function(n) {
        return {
            $: 3,
            a: n
        };
    }, z0n = function(n) {
        return {
            $: 3,
            a: n
        };
    }, U0n = function(n) {
        return {
            $: 5,
            a: n
        };
    }, E0n = {
        $: 3
    }, P0n = function(n) {
        return {
            $: 17,
            a: n
        };
    }, T0n = function(n) {
        return {
            $: 8,
            a: n
        };
    }, F0n = function(n) {
        return n.mS;
    }, L0n = function(n) {
        return n.k7;
    }, M0n = function(n) {
        if (n.$) return Rt;
        var r = n.a, t = mA(mPn(r));
        if (t > 0) {
            var e = L0n(r), u = 12 * pPn(r) / t | 0;
            return Ht(pp(.02 * (u + e)));
        }
        return Rt;
    }, H0n = function(n) {
        return {
            $: 21,
            a: n
        };
    }, R0n = F2(function(n, r) {
        return A2($y, k([
            "payment_methods"
        ]), A2($y, k([
            r
        ]), A2($y, k([
            "online_enrollments"
        ]), gy(n))));
    }), O0n = F5(function(n, r, t, e, u) {
        return A4(vN, z9(n), een, u, A2(xq, e, bC(A2(R0n, r, t))));
    }), N0n = F5(function(n, r, t, e, u) {
        return b("payment_method", A5(jcn, n, r, t, e, u));
    }), I0n = F5(function(n, r, t, e, u) {
        var a = vk(k([
            A5(N0n, e, !1, !1, Rt, !0)
        ]));
        return A5(O0n, n, r, t, a, u);
    }), V0n = F4(function(n, r, t, e) {
        if (2 === t.$) {
            var u = t.a;
            return A5(I0n, n, $k(r), u, e, H0n);
        }
        return Dp;
    }), W0n = F2(function(n, r) {
        return function(t) {
            return n(t) ? k([
                r
            ]) : h;
        };
    }), Z0n = F2(function(n, r) {
        return A2(W0n, function(r) {
            return i(n(r), Rt);
        }, r);
    }), X0n = function(n) {
        return n.k4.rr;
    }, G0n = function(n) {
        return n.k4.BU;
    }, J0n = function(n) {
        return n.ha.qB;
    }, Y0n = function(n) {
        return n.ha.zU;
    }, Q0n = function(n) {
        return n.ha.rr;
    }, K0n = function(n) {
        return n.ap.b ? h : k([
            b(2, aI(Y0n))
        ]);
    }, n2n = function(n) {
        return e6(n) ? aI(w6) : aI(h6);
    }, r2n = function(n) {
        return A2(Y$n, function(n) {
            return !_4(n.b);
        }, n.ac);
    }, t2n = function(n) {
        return A2($4, function(n) {
            return b(4, n2n(n.b));
        }, r2n(n.ac));
    }, e2n = function(n) {
        var r, t = n.s;
        if (1 === t.$) {
            var e = t.b;
            return 1 === e.$ ? (r = k([
                e.a
            ]), A2(yu, aI, r)) : h;
        }
        return h;
    }, u2n = F2(function(n, r) {
        var t = b(n, r.al);
        if (3 === t.a.$) return h;
        if (t.b.$) return h;
        var e = Gb(e2n(t.b.a));
        return k(e.$ ? [
            b(3, JN(ron))
        ] : [
            b(3, e.a)
        ]);
    }), a2n = F2(function(n, r) {
        return !A2(iA, r, n);
    }), i2n = function(n) {
        return n.C3;
    }, c2n = F2(function(n, r) {
        return r.we(n);
    }), o2n = F2(function(n, r) {
        var t = r.C3.oD;
        if (t.$) return k([
            b(1, JN(A2(XN, YN, i2n)))
        ]);
        var e = t.a;
        if (n.$) return h;
        var u = n.a, a = A2(dP, AA("/"), u);
        return A2(a2n, u, e) ? k([
            b(1, aI(c2n(a)))
        ]) : h;
    }), f2n = F4(function(n, r, t, e) {
        var u = KQn(r) ? h : k([
            o2n(t),
            K0n,
            A2(Z0n, function(n) {
                return n.b2;
            }, b(0, JN(A2(XN, YN, X0n))))
        ]);
        return ZN(A3(uU, !n, t2n, A3(uU, !n, u2n(e), u)));
    }), s2n = function(n) {
        return n.sK;
    }, l2n = F5(function(n, r, t, e, u) {
        var a = 3 === t.$ ? Ht(s2n(t.a)) : Rt, i = A2(wI, A4(f2n, n, r, a, e), u);
        return i.$ ? b(i.a, !1) : b(i.a.a, !0);
    }), d2n = function(n) {
        switch(n.$){
            case 0:
                return Ht(0);
            case 1:
                return Ht(1);
            case 2:
                return Ht(2);
            case 3:
                return Ht(4);
            default:
                return Ht(3);
        }
    }, b2n = F2(function(n, r) {
        var t = d2n(n);
        if (t.$) return r;
        var e = t.a, u = A3(XI, !0, e, r.x), a = m(r, {
            x: u
        });
        return A2(ZI, e, u) ? m(a, {
            kk: A5(l2n, !1, r.lj, r.aM, r.du, r.kk).a
        }) : a;
    }), v2n = function(n) {
        switch(n.$){
            case 0:
                return v0n(0);
            case 1:
                return v0n(1);
            case 2:
                return v0n(2);
            case 3:
                return v0n(4);
            default:
                return v0n(3);
        }
    }, m2n = F3(function(n, r, t) {
        var e = A2(ue, ": ", k([
            v2n(r),
            t
        ])), u = jN(n.kk).ac, a = A2(Xb, ru, A2(Cp, function(r) {
            return A2(ZI, r, n.x) ? Qvn(A2(Y$n, function(n) {
                return i(h9(n.b), t);
            }, r2n(u))) : Rt;
        }, d2n(r))), c = Qvn(A2(Y$n, function(n) {
            return i(h9(n.b), t);
        }, function(n) {
            return A2(Y$n, function(n) {
                return e6(n.b);
            }, n.ac);
        }(u)));
        return b(e, A2(Cp, n2n, A2(z$, a, c)));
    }), p2n = F3(function(n, r, t) {
        var e = ac(n);
        return OQn(Ht({
            eC: A2(uc, h, A2(Cp, Gq, t)),
            p5: r,
            Cr: e
        }));
    }), $2n = function(n) {
        var r = A5(l2n, !1, n.lj, n.aM, n.du, n.kk), t = r.b;
        return b(m(n, {
            kk: r.a
        }), t);
    }, h2n = F3(function(n, r, t) {
        var e = $2n(n).a, u = A3(m2n, n, r, t);
        return A3(p2n, e.w_.B9, u.a, u.b);
    }), g2n = function(n) {
        return {
            $: 25,
            a: n
        };
    }, w2n = F4(function(n, r, t, e) {
        return A2($y, k([
            "passthroughs",
            ee(e)
        ]), A2($y, k([
            "payment_sources",
            t
        ]), A2($y, k([
            "online_enrollments",
            r
        ]), gy(n))));
    }), k2n = F6(function(n, r, t, e, u, a) {
        return A4(dC, z9(n), sun, a, bC(A4(w2n, r, t, e, u)));
    }), x2n = function(n) {
        return n.qU;
    }, y2n = function(n) {
        return n.k1;
    }, _2n = function(n) {
        return n.k5;
    }, C2n = function(n) {
        var r = function() {
            var r = b(n.fl, n.mS);
            if (r.a.$) return r.b.$ || 1 !== r.b.a.$ ? Rt : Ht(y2n(r.b.a.a));
            var t = r.a.a;
            return Ht(_2n(t) + L0n(t));
        }(), t = v(n.tk, n.du, r);
        if (3 !== t.a.$ || 3 !== t.b.$ || t.c.$) return Dp;
        var e = t.a.a, u = t.b.a, a = t.c.a;
        return n.yl && vun(u) ? A6(k2n, n.gx, $k(n.dw), x2n(e), bun(u), a, g2n) : Dp;
    }, D2n = function(n) {
        return A3(Gy, "-", "_", OB(s0n(n)));
    }, A2n = F4(function(n, r, t, e) {
        var u = A2(n0n, n, r);
        if (u.$) return Rt;
        var a = u.a;
        return Gb(A2(Tc, function(n) {
            return i(e(n), a);
        }, t));
    }), q2n = F2(function(n, r) {
        return A4(A2n, "billing_period", r, n, D2n);
    }), B2n = function(n) {
        return n.ur;
    }, j2n = F3(function(n, r, t) {
        var e = B2n(r), u = A2(z$, A2(q2n, e, t), Gb(B2n(r))), a = s2n(r), i = n.C3;
        return m(n, {
            b2: u,
            C3: A2(Cq, a2n(a), A2(_q, a, i))
        });
    }), S2n = F2(function(n, r) {
        return m(n, {
            ac: A2(cPn, r, n.ac)
        });
    }), z2n = F2(function(n, r) {
        return A2($y, k([
            "coupons",
            r
        ]), gy(n));
    }), U2n = F4(function(n, r, t, e) {
        return A4(dC, z9(n), NBn, e, bC(A2(z2n, r, t)));
    }), E2n = F3(function(n, r, t) {
        return A2(xV, t, _V(A2(aa, "practice", r.$ ? n : A3(Qu, "hint_membership_id", r.a.qU, n))));
    }), P2n = F2(function(n, r) {
        return n.$ ? r : A3(Qu, "referred_token", n.a.u0, r);
    }), T2n = function(n) {
        return A2(Eu, hu, yn(function() {
            try {
                Xr.location = n;
            } catch (n) {
                tr.location.reload(!1);
            }
        }));
    }, F2n = F4(function(n, r, t, e) {
        if (hKn(r)) {
            var u = $Kn(r);
            return u.$ ? dL : T2n(A3(E2n, e.iu, n, u.a));
        }
        var a = pZn(t);
        return A2(zx, A2(P2n, n, e.iu), mi({
            v2: a
        }));
    }), L2n = F2(function(n, r) {
        return A2(w7, "Form Submission Errored", k([
            _7(n),
            jYn(r)
        ]));
    }), M2n = function(n) {
        return A2(L2n, TYn, n);
    }, H2n = F2(function(n, r) {
        return v(m(r, {
            b6: ED(n) ? Rt : Ht(WGn(n))
        }), M2n(A2(ue, ", ", A2(yu, Rk(0), n))), h);
    }), R2n = F2(function(n, r) {
        return A2(iW, r, n);
    }), O2n = F2(function(n, r) {
        return Gb(A2(ZI, r, n.x) ? A2(R2n, n.kk, r) : h);
    }), N2n = F2(function(n, r) {
        return A2(Xb, O2n(n), d2n(r));
    }), I2n = F2(function(n, r) {
        return A2(ue, ": ", A2(Ot, v2n(r), n));
    }), V2n = F3(function(n, r, t) {
        var e = A2(I2n, t, r), u = $2n(n).a;
        return A3(p2n, u.w_.B9, e, A2(N2n, u, r));
    }), W2n = (hG = TYn, A2(w7, "Form Submission Completed", k([
        _7(hG)
    ]))), Z2n = F2(function(n, r) {
        var t = A2(O2n, r, n);
        if (t.$) return h;
        var e = t.a;
        return k([
            b(v0n(n), e)
        ]);
    }), X2n = "discount-code", G2n = "pending-documents", J2n = "payment-source", Y2n = "start-date", Q2n = F2(function(n, r) {
        return ED(A2(iW, r, n.kk)) ? Rt : Ht(function() {
            switch(r){
                case 0:
                    return "rate-schedule";
                case 1:
                    return Y2n;
                case 2:
                    return X2n;
                case 3:
                    return J2n;
                default:
                    return G2n;
            }
        }());
    }), K2n = function(n) {
        var r = function(n) {
            var r = A2(Ep, Q2n(n), b0n), t = Gb(r);
            return t.$ ? Dp : qEn(t.a);
        }(n);
        return Hu(A2(Ot, r, function(n) {
            var r = $2n(n).a;
            return A2(yu, function(n) {
                var r = n.a;
                return FYn({
                    eC: k([
                        n.b
                    ]),
                    p5: r
                });
            }, Gi(A2(yu, function(n) {
                switch(n){
                    case 3:
                        return function(n) {
                            var r = jN(n.kk).al;
                            return r.$ ? h : A2(yu, function(n) {
                                return b("Payment Method", n);
                            }, e2n(r.a));
                        }(r);
                    case 4:
                        return function(n) {
                            var r = jN(n.kk).ac, t = S0n(r);
                            return A2(Ep, function(n) {
                                var r = n.a;
                                return A2(Cp, function(n) {
                                    return b(r, n);
                                }, n.b);
                            }, A2($4, function(r) {
                                return A3(m2n, n, t, h9(r.b));
                            }, r2n(r)));
                        }(r);
                    default:
                        return A2(Z2n, n, r);
                }
            }, b0n)));
        }(n)));
    }, n3n = function(n) {
        return A2(uu, "dob", n) ? "All Membership members must have date of birth" : n;
    }, r3n = F2(function(n, r) {
        return 4 === r.$ ? r.a.$ ? b(v2n(r), Rt) : b("Payment", A2(N2n, n, r)) : b(v2n(r), Rt);
    }), t3n = F2(function(n, r) {
        var t = $2n(n).a, e = A2(r3n, n, r);
        return A3(p2n, t.w_.B9, e.a, e.b);
    }), e3n = function(n) {
        return n.$ ? Rt : Ht(n.a);
    }, u3n = function(n) {
        return n.qU;
    }, a3n = function(n) {
        return n.$ ? Rt : Ht(u3n(n.a));
    }, i3n = function(n) {
        return {
            $: 2,
            a: n
        };
    }, c3n = function(n) {
        return {
            $: 1,
            a: n
        };
    }, o3n = F2(function(n, r) {
        return A2($y, k([
            "online_enrollments",
            r,
            "confirm"
        ]), gy(n));
    }), f3n = F2(function(n, r) {
        return {
            qU: n,
            u0: r
        };
    }), s3n = A3(zy, "referred_token", w$, A3(zy, "id", w$, Ke(f3n))), l3n = A2(qy, s3n, Ke(ru)), d3n = function(n) {
        return vk(k([
            b("online_enrollment", n)
        ]));
    }, b3n = F5(function(n, r, t, e, u) {
        return A4(vN, z9(n), l3n, u, A2(xq, d3n(e), bC(A2(o3n, r, t))));
    }), v3n = F5(function(n, r, t, e, u) {
        return A4(vN, z9(n), RHn, u, A2(xq, d3n(e), bC(A2($y, k([
            "checkout"
        ]), A2(o3n, r, t)))));
    }), m3n = F5(function(n, r, t, e, u) {
        return A4(vN, z9(n), RHn, u, A2(xq, d3n(e), bC(A2($y, k([
            "sponsor"
        ]), A2(o3n, r, t)))));
    }), p3n = F3(function(n, r, t) {
        return tKn(n) ? A2(Ot, b("coupon_code", hmn(r)), t) : t;
    }), $3n = function(n) {
        return b("period_in_months", n.$ ? bk : hq(mA(n.a.BS)));
    }, h3n = function(n) {
        var r = n.oD;
        return b("start_date", r.$ ? bk : hmn(vH(r.a)));
    }, g3n = F2(function(n, r) {
        return {
            qU: n,
            s8: r
        };
    }), w3n = Um(WB("_")), k3n = function(n) {
        return 1 === n || 2 === n || 3 === n ? am(n) : qm("Notification number is invalid.");
    }, x3n = A2(nm, k3n, kj), y3n = A2(Am, A2(Am, am(g3n), A2(um, w3n, GA("_"))), A2(um, x3n, Nm)), _3n = function(n) {
        var r = $k(n.dw), t = nKn(n.lj), e = KQn(n.lj), u = b("google_recaptcha_token", BBn(n.hr)), a = function(n) {
            if (n.$) return b("follow_up_attempt", bk);
            var r = n.a;
            return b("follow_up_attempt", vk(k([
                b("id", mk(r.qU)),
                b("notification_number", hq(r.s8))
            ])));
        }(function(n) {
            if (n.$) return Xt("Param missing");
            var r = A2(Ym, y3n, n.a);
            return r.$ ? Xt("Invalid FollowUp param") : Qt(r.a);
        }(A2(n0n, "link_source", n.w_.iu))), i = jN(n.kk), c = i.C3, o = i.b2, f = i.ap, s = b("accepted_documents", Ajn(i.ac)), l = $3n(o), d = h3n(c), v = t ? A3(p3n, n.fF, f.a, k([
            d,
            l,
            s,
            a,
            u
        ])) : k([
            s,
            u
        ]), m = b(n.e6, n.uA);
        if (2 === m.a.$ && m.b) {
            var p = m.a.a;
            return e ? A5(v3n, n.gx, r, p, vk(v), i3n) : t ? A5(b3n, n.gx, r, p, vk(v), c3n) : A5(m3n, n.gx, r, p, vk(v), i3n);
        }
        return Dp;
    }, C3n = F4(function(n, r, t, e) {
        return A4(IRn, z9(n), RHn, e, bC(A2(e0n, r, t)));
    }), D3n = F3(function(n, r, t) {
        return {
            sK: n,
            ur: t,
            wd: r
        };
    }), A3n = F4(function(n, r, t, e) {
        return {
            oQ: e,
            kN: n,
            BS: t,
            uW: r
        };
    }), q3n = A3(zy, "default_period_in_months", A2(Ge, Ofn, C$), A3(zy, "period_in_months", A2(Ge, Ofn, C$), A3(zy, "rate_in_cents_per_default_period", C$, A3(zy, "ongoing_amount_in_cents", C$, Ke(A3n))))), B3n = A2(qy, q3n, Ke(ru)), j3n = A3(zy, "prepay_options", Ey(B3n), A3(zy, "start_date_editable", xy, A3(zy, "min_start_date", FC, Ke(D3n)))), S3n = A2(qy, j3n, Ke(ru)), z3n = F2(function(n, r) {
        return A2($y, k([
            "online_enrollments",
            r,
            "setting"
        ]), gy(n));
    }), U3n = F4(function(n, r, t, e) {
        return A4(dC, z9(n), S3n, e, bC(A2(z3n, r, t)));
    }), E3n = function(n) {
        return A2(yu, KD, A2(yu, uF, A2(ae, ",", n)));
    }, P3n = function(n) {
        return m(n, {
            wi: A2(DI, function() {
                return function(n) {
                    return A2(CI, n.di, !0);
                };
            }, n.wi)
        });
    }, T3n = F2(function(n, r) {
        var t = d2n(n);
        if (t.$) return r;
        var e = t.a;
        return A2(yI, e, r.x) ? m($2n(r).a, {
            x: A3(_I, !0, e, r.x)
        }) : r;
    }), F3n = function(n) {
        return m(n, {
            ck: !1
        });
    }, L3n = F2(function(n, r) {
        return {
            $: 5,
            a: n,
            b: r
        };
    }), M3n = F2(function(n, r) {
        switch(n.$){
            case 0:
                return v(m(r, {
                    aD: n.a
                }), Dp, Rt);
            case 1:
                return v(r, Dp, Ht(0));
            case 2:
                return v(r, Dp, Ht(1));
            case 3:
            case 4:
                return v(r, function(n) {
                    return A2(dc, L3n(n), uy(n));
                }(r.fo), Rt);
            default:
                var t = n.a, e = n.b;
                if (e.$) return v(r, Dp, Rt);
                var u = e.a;
                return i(t, r.fo) ? v(m(r, {
                    h3: A2(Me, 0, 24 - (u.ke.lw - u.jG.lw))
                }), Dp, Rt) : v(r, Dp, Rt);
        }
    }), H3n = F2(function(n, r) {
        var t = jN(r.kk), e = A2(B0n, n, t.ap.a);
        return A2(T3n, e, A2(b2n, e, A2(g0n, e, r)));
    }), R3n = function(n) {
        return {
            $: 24,
            a: n
        };
    }, O3n = function(n) {
        return nKn(n) && !KQn(n);
    }, N3n = F2(function(n, r) {
        return A2($y, k([
            "online_enrollments",
            r,
            "members",
            "min"
        ]), gy(n));
    }), I3n = F4(function(n, r, t, e) {
        return A4(dC, z9(n), Ey(wQn), e, bC(A2(N3n, r, t)));
    }), V3n = function(n) {
        return {
            $: 4,
            a: n
        };
    }, W3n = function(n) {
        return b("plan", n.$ ? bk : QIn(u3n(n.a)));
    }, Z3n = F3(function(n, r, t) {
        var e = A2(zD, function(r) {
            return i(r.a, n);
        }, t);
        return e.$ ? b(n, r) : e.a;
    }), X3n = F3(function(n, r, t) {
        var e = n;
        return vk(A2(Ot, A3(Z3n, "name", hmn(e.sS), r), A2(Ot, A3(Z3n, "dob", jBn(e.o2), r), A2(Ot, A3(Z3n, "relationship", qBn(e.u5), r), A2(Ot, A3(Z3n, "uses_tobacco", kA(e.w4), r), t)))));
    }), G3n = function(n) {
        return n.u5;
    }, J3n = function(n) {
        var r = n;
        return r.tr ? A2(Tc, function(n) {
            return !bDn(G3n(n));
        }, r.Av) : r.Av;
    }, Y3n = F2(function(n, r) {
        var t = r.mS;
        if (t.$) return Dp;
        var e = W3n(t.a), u = jN(r.kk), a = u.C3, i = u.ap, c = $3n(u.b2), o = h3n(a), f = b("members", A2(wq, function(n) {
            return A3(X3n, n, h, k([
                o
            ]));
        }, J3n(n))), s = A3(p3n, r.fF, i.a, k([
            o,
            c,
            e,
            f
        ])), l = vk(s);
        return function(n) {
            var r = A5(l2n, !0, n.lj, n.aM, n.du, n.kk), t = r.b;
            return b(m(n, {
                kk: r.a
            }), t);
        }(r).b ? A4(GBn, r.gx, $k(r.dw), l, V3n) : Dp;
    }), Q3n = function(n) {
        var r = n.tk;
        if (3 === r.$) {
            var t = r.a;
            return O3n(n.lj) ? A2(Y3n, t, n) : n.Av.$ ? Dp : A4(I3n, n.gx, $k(n.dw), x2n(t), R3n);
        }
        return Dp;
    }, K3n = F2(function(n, r) {
        switch(n.$){
            case 14:
                var t = n.a, e = m(r, {
                    tk: t
                });
                if (3 === t.$) {
                    var u = t.a, a = (Nn = e.fV).$ ? Dp : MKn(Nn.a), i = ZYn(u), c = k(i ? [
                        DYn(GKn(u)),
                        wYn,
                        gYn
                    ] : [
                        DYn(GKn(u)),
                        gYn
                    ]), o = A7(nBn, r.gx, $k(e.dw), a3n(F0n(u)), ean(u.tq), A2(yu, lKn, u.hQ), !0, z0n), f = F0n(u), s = KQn(r.lj) ? b(Dp, oc) : b(A4(U3n, r.gx, $k(r.dw), x2n(u), U0n), Mx), l = s.a, d = s.b;
                    return v(g = m(e, {
                        fV: Rt,
                        mS: Ht(f),
                        g7: i,
                        aM: d,
                        cJ: l0n(e3n(f))
                    }), Hu(k([
                        l,
                        a,
                        o,
                        A4(TKn, 7, g.CX, g.fF, h),
                        C2n(g)
                    ])), c);
                }
                return v(e, Dp, A2(uA, 1, t));
            case 19:
                var p = n.a, g = p.$ ? r : m(r, {
                    hr: Ht(p.a)
                });
                return r.g7 ? v(g, A4(F2n, Rt, r.fF, r.lj, r.w_), k([
                    E0n
                ])) : v(g, _3n(g), h);
            case 0:
                if (r.g7) return v(r, A4(F2n, Rt, r.fF, r.lj, r.w_), k([
                    E0n
                ]));
                var w = jN(r.kk), x = p0n(Un = w.al);
                if (g = function(n) {
                    return m(n, {
                        x: P3n(n.x)
                    });
                }(A2(T3n, x, A2(b2n, x, A2(g0n, x, m(r, {
                    uA: !0,
                    b6: Rt,
                    dN: !0
                }))))), 1 === Un.$) {
                    var y = $2n(g), _ = y.a;
                    return (rn = y.b) ? v(_, pXn(0), h) : v(m(_, {
                        uA: !1
                    }), K2n(_), h);
                }
                if (_on(r.du)) {
                    var C = $2n(g);
                    return _ = C.a, (rn = C.b) ? v(_, pXn(0), h) : v(Tn = m(_, {
                        uA: !1
                    }), K2n(Tn), h);
                }
                return v(g, A2(jp, J1n, Ccn), h);
            case 1:
                var D = n.a;
                g = m(r, {
                    uA: !1,
                    aP: !1,
                    dN: !1
                });
                n: for(;;)switch(D.$){
                    case 3:
                        var A = D.a, q = k([
                            OQn(Rt),
                            E0n
                        ]);
                        return v(g, Hu(k([
                            A4(F2n, Ht(A), r.fF, r.lj, r.w_),
                            W2n,
                            A4(EKn, 7, r.CX, r.fF, h)
                        ])), q);
                    case 2:
                        if (5 === D.a.$) return A2(H2n, E3n(Hn = D.a.b), g);
                        break n;
                    default:
                        break n;
                }
                return v(g, Dp, A2(uA, 1, D));
            case 2:
                D = n.a, g = m(r, {
                    uA: !1,
                    aP: !1,
                    dN: !1
                });
                n: for(;;)switch(D.$){
                    case 3:
                        return c = k([
                            OQn(Rt),
                            E0n
                        ]), v(g, Hu(k([
                            A4(F2n, Rt, r.fF, r.lj, r.w_),
                            W2n
                        ])), c);
                    case 2:
                        if (5 === D.a.$) return A2(H2n, E3n(Hn = D.a.b), g);
                        break n;
                    default:
                        break n;
                }
                return v(g, Dp, A2(uA, 1, D));
            case 3:
                var B = n.a, j = (g = m(r, {
                    ac: B
                }), jN(g.kk));
                return 3 === B.$ ? v(m(g, {
                    kk: AO(A2(S2n, j, B.a))
                }), Dp, h) : v(g, Dp, A2(uA, 1, B));
            case 4:
                var S = n.a;
                n: for(;;)switch(S.$){
                    case 3:
                        g = m(r, {
                            fl: Ht(S.a)
                        });
                        var z = C2n(g);
                        return v(g, z, h);
                    case 2:
                        if (5 === S.a.$) {
                            var U = Ht(WGn(k([
                                KD(n3n(Hn = S.a.b))
                            ])));
                            return v(m(r, {
                                b6: U
                            }), M2n(Hn), A2(uA, 1, S));
                        }
                        break n;
                    default:
                        break n;
                }
                return v(r, Dp, A2(uA, 1, S));
            case 5:
                var E = n.a, P = m(r, {
                    aM: E
                }), T = OQn(Rt);
                return 3 === E.$ ? (d = E.a, 2 === r.e6.$ ? (j = jN(P.kk), v(g = m(P, {
                    kk: AO(A3(j2n, j, d, P.w_.iu))
                }), Q3n(g), h)) : v(P, Dp, h)) : v(P, Dp, A2(Ot, T, A2(uA, 1, E)));
            case 6:
                return v(A2(b2n, on = n.a, A2(g0n, on, r)), Dp, h);
            case 8:
                var F = A2(bq, n.a, r.cJ), L = F.a, M = F.b, H = F.c;
                if (H.$ || H.a.$) return v(m(r, {
                    cJ: L
                }), A2(jp, T0n, M), h);
                var R = H.a.a, O = 1 === (On = A2(Cp, s0n, R)).$ ? h : k([
                    On.a
                ]), N = function(n) {
                    return {
                        $: 0,
                        a: n
                    };
                }(R), I = (g = A2(T3n, N, A2(b2n, N, A2(g0n, N, m(r, {
                    cJ: L
                })))), A3(V2n, g, N, O));
                return v(g, Hu(k([
                    A2(jp, T0n, M),
                    Q3n(g)
                ])), k([
                    I
                ]));
            case 7:
                var V = n.a, W = jN(r.kk).C3, Z = A2(uq, V, W), X = Z.a, G = Z.c, J = A2(jp, I1n, Z.b), Y = function(n) {
                    return {
                        $: 1,
                        a: n
                    };
                }(function() {
                    if (G.$ || 2 !== G.a.$) return X;
                    var n = G.a.a;
                    return A2(Cq, a2n(n), A2(_q, n, X));
                }()), Q = (g = A2(g0n, Y, r), function() {
                    n: for(; !G.$;)switch(G.a.$){
                        case 0:
                            return v(A2(T3n, Y, A2(b2n, Y, g)), h, Q3n(g));
                        case 1:
                            return v(g, k([
                                A3(V2n, g, Y, h)
                            ]), Dp);
                        default:
                            break n;
                    }
                    var n = YS(W.oD) ? h : k([
                        A3(V2n, g, Y, h)
                    ]);
                    return v(g, n, Dp);
                }());
                return q = Q.b, v(_ = Q.a, Hu(k([
                    J,
                    Q.c
                ])), q);
            case 9:
                g = m(r, {
                    iK: !0
                });
                var K = jN(r.kk);
                return v(g, Dp, k([
                    A3(V2n, r, on = A2(B0n, (un = K.ap).b, un.a), k([
                        "Show"
                    ]))
                ]));
            case 10:
                var nn = (un = jN(r.kk).ap).a, rn = un.b, tn = (g = (tI(nn) ? H3n(!0) : H3n(rn))(m(r, {
                    oh: oc
                })), tI(nn) ? Q3n(g) : A4(U2n, r.gx, $k(r.dw), nn, j0n));
                return v(g, tn, k([
                    A3(V2n, g, on = A2(B0n, un.b, un.a), h)
                ]));
            case 11:
                var en = jN(r.kk);
                return v(r, Dp, k([
                    A3(V2n, r, on = A2(B0n, (un = en.ap).b, un.a), h)
                ]));
            case 12:
                var un, an = n.a, cn = (g = m(r, {
                    oh: an
                }), jN(r.kk)), on = A2(B0n, (un = cn.ap).b, un.a);
                switch(an.$){
                    case 3:
                        return v(fn = A2(H3n, !0, g), Q3n(fn), k([
                            A3(V2n, fn, on, h)
                        ]));
                    case 2:
                        switch(an.a.$){
                            case 5:
                                return v(fn = A2(H3n, !1, g), Dp, k([
                                    A3(V2n, fn, on, h)
                                ]));
                            case 9:
                                var fn;
                                return v(fn = A2(H3n, !1, g), Dp, k([
                                    A3(V2n, fn, on, h)
                                ]));
                            default:
                                return v(m(r, {
                                    oh: oc
                                }), Dp, A2(uA, 1, an));
                        }
                    default:
                        return v(g, Dp, A2(uA, 1, an));
                }
            case 13:
                var sn = n.a, ln = jN(r.kk), dn = A2(U6, sn, ln.ac), bn = (o = dn.b, dn.c), vn = S0n(dn.a), mn = A2(uc, b(g = A2(g0n, vn, r), h), A2(Cp, function(n) {
                    switch(n.$){
                        case 1:
                        case 2:
                            return b(g, k([
                                A3(h2n, g, vn, h9(r = n.a.b))
                            ]));
                        case 0:
                            var r = n.a.b, t = A2(T3n, vn, A2(b2n, vn, g));
                            return b(t, k([
                                A3(h2n, t, vn, h9(r))
                            ]));
                        case 3:
                            return b(g, h);
                        default:
                            return b(g, n.a);
                    }
                }, bn));
                return q = mn.b, v(_ = mn.a, wn = A2(uc, A2(jp, W1n, o), A2(Cp, function(n) {
                    if (3 === n.$) {
                        var r = A3(m2n, g, vn, h9(n.a.b)), t = r.a;
                        return Hu(k([
                            FYn({
                                eC: A2(uc, h, A2(Cp, Gq, r.b)),
                                p5: t
                            }),
                            A2(jp, W1n, o)
                        ]));
                    }
                    return A2(jp, W1n, o);
                }, bn)), q);
            case 15:
                if (sn = n.a, (Un = jN(r.kk).al).$) return v(r, Dp, h);
                var pn = A2(son, sn, Un.a), $n = pn.b, hn = pn.c, gn = (x = p0n(Ht(pn.a)), A2(g0n, x, r)), wn = k([
                    A2(jp, J1n, $n)
                ]);
                if (hn.$) return v(g = A2(b2n, x, gn), Hu(wn), k([
                    A2(t3n, g, x)
                ]));
                switch(hn.a.$){
                    case 2:
                        return v(m(gn, {
                            aP: !0
                        }), Hu(wn), h);
                    case 1:
                        return v(gn, Hu(A2(Ot, A4(V0n, r.gx, r.dw, r.e6, hn.a.a), wn)), k([
                            A2(t3n, gn, x)
                        ]));
                    default:
                        return g = A2(H2n, k([
                            hn.a.a
                        ]), A2(T3n, x, A2(b2n, x, m(gn, {
                            uA: !1,
                            aP: !1
                        }))));
                }
            case 16:
                var kn = n.a, xn = function() {
                    if (kn) return v(Rt, Dp, "Skip Payment");
                    var n = KQn(r.lj), t = A6(qin, n, r.kj, r.dw, r.yl, M0n(r.fl), r.gx), e = t.b, u = Q1n(t.a), a = A2(jp, J1n, e);
                    return v(Ht(u), a, "Payment Method");
                }(), yn = ($n = xn.b, xn.c);
                return x = p0n(xn.a), v(g = A2(g0n, x, r), $n, k([
                    A3(V2n, g, x, k([
                        yn
                    ]))
                ]));
            case 17:
                var _n = n.a;
                g = m(r, {
                    e8: oc,
                    du: oc,
                    aP: !1
                });
                n: for(;;)switch(_n.$){
                    case 3:
                        var Cn = KQn(r.lj), Dn = A6(K1n, Cn, r.kj, r.dw, r.fF, r.yl, r.gx);
                        return tn = Dn.b, x = p0n(Un = Dn.a), v(gn = A2(g0n, x, g), tn, A2(uA, 1, _n));
                    case 2:
                        if (5 === _n.a.$) return A2(H2n, E3n(Hn = _n.a.b), g);
                        break n;
                    default:
                        break n;
                }
                return v(g, Dp, A2(uA, 1, _n));
            case 18:
                var An = A2(M3n, sn = n.a, r.cR), qn = An.a, Bn = An.b, jn = An.c;
                return tn = jn.$ || jn.a ? Dp : A2(Eu, ru, gu(q0n)), v(m(r, {
                    cR: qn
                }), Hu(k([
                    A2(jp, y0n, Bn),
                    tn
                ])), h);
            case 20:
                var Sn = A2(uc, Ru, A2(Xb, function(n) {
                    return ec(n);
                }, $u(n.a))), zn = A2(uc, Ru, ec(r.w_.B9));
                return v(r, A4(HQn, r.lj, r.CX, zn, Sn) ? A2(HKn, zn, Sn) : Dp, h);
            case 21:
                g = m(r, {
                    du: _n = n.a
                });
                n: for(;;)switch(_n.$){
                    case 3:
                        z = C2n(g);
                        var Un, En = jN(r.kk), Pn = (x = p0n(A2(Xb, function(n) {
                            return Ht(F3n(n));
                        }, Un = En.al)), $2n(A2(g0n, x, g)));
                        if (_ = Pn.a, (rn = Pn.b) && r.uA) return v(m(_, {
                            b6: Rt
                        }), Hu(k([
                            pXn(0),
                            z
                        ])), h);
                        var Tn = m(g, {
                            uA: !1,
                            aP: !1
                        });
                        return v(m(Tn, {
                            b6: Rt
                        }), z, h);
                    case 2:
                        if (5 === _n.a.$) return A2(H2n, E3n(Hn = _n.a.b), m(g, {
                            uA: !1,
                            aP: !1
                        }));
                        break n;
                    default:
                        break n;
                }
                return v(m(g, {
                    uA: !1,
                    aP: !1
                }), Dp, A2(uA, 1, _n));
            case 22:
                var Fn = b(r.du, r.e6);
                if (3 === Fn.a.$ && 2 === Fn.b.$) {
                    var Ln = Fn.b.a;
                    return v(m(r, {
                        aP: !0
                    }), A4(C3n, r.gx, $k(r.dw), Ln, P0n), h);
                }
                return v(r, Dp, h);
            case 23:
                switch((_n = n.a).$){
                    case 3:
                        var Mn = function() {
                            var n = KQn(r.lj), t = A6(qin, n, r.kj, r.dw, r.yl, M0n(r.fl), r.gx), e = t.b, u = Q1n(t.a);
                            return b(Ht(u), A2(jp, J1n, e));
                        }();
                        return $n = Mn.b, v(g = A2(g0n, p0n(Mn.a), m(r, {
                            du: _n
                        })), Hu(k([
                            $n,
                            C2n(g)
                        ])), h);
                    case 2:
                        switch(_n.a.$){
                            case 9:
                                return v(m(r, {
                                    du: oc
                                }), Dp, h);
                            case 5:
                                var Hn = _n.a.b;
                                return g = m(r, {
                                    du: oc
                                }), A2(H2n, E3n(Hn), g);
                            default:
                                var Rn = _n.a;
                                return v(m(r, {
                                    du: oc
                                }), Dp, $(H9(_n), k([
                                    tA(Rn)
                                ])));
                        }
                    default:
                        return v(m(r, {
                            du: oc
                        }), Dp, A2(uA, 1, _n));
                }
            case 24:
                return v(m(r, {
                    Av: n.a
                }), Dp, h);
            default:
                return v(m(r, {
                    e8: n.a
                }), Dp, h);
        }
        var On, Nn;
    }), n9n = F2(function(n, r) {
        var t = jN(r.kk).ac;
        return A2(Ik, k([
            jz(G2n),
            Nk("mx-1")
        ]), k([
            A2(px, W1n, A3(N4, n, k([
                dPn(r.uA),
                bPn(r.dN)
            ]), t))
        ]));
    }), r9n = F4(function(n, r, t, e) {
        return Y1n(e) ? A2(Ik, h, k([
            gx,
            A3(yOn, n, r, hk(t))
        ])) : Sq;
    }), t9n = F2(function(n, r) {
        if (3 === r.$) {
            var t = A2(uc, "", A2(Cp, function(n) {
                return " (" + OB(n) + ")";
            }, (e = r.a).$ ? Rt : e.a.qt));
            return $(n(non), t);
        }
        var e;
        return n(non);
    }), e9n = function(n) {
        return n.du;
    }, u9n = function(n) {
        return n.yu.lM;
    }, a9n = function(n) {
        return n.yu.nc;
    }, i9n = function(n) {
        return n.yu.or;
    }, c9n = function(n) {
        return n.yu.os;
    }, o9n = function(n) {
        return n.yu.vJ;
    }, f9n = function(n) {
        var r = iKn(n);
        return xAn(r);
    }, s9n = function(n) {
        return {
            $: 16,
            a: n
        };
    }, l9n = function(n) {
        return {
            $: 7,
            a: n
        };
    }, d9n = F5(function(n, r, t, e, u) {
        if (t) return A2(IU, k([
            SU,
            uE("skip"),
            rwn($H(r)),
            ZU(rm(s9n(1))),
            twn(e),
            l9n(k([
                Nk("h-full")
            ]))
        ]), k([
            ad(n(u9n))
        ]));
        var a = n(u ? c9n : i9n);
        return A2(IU, k([
            SU,
            uE("card"),
            rwn(YS(r)),
            ZU(rm(s9n(0))),
            twn(e),
            l9n(k([
                Nk("h-full")
            ]))
        ]), k([
            ad(a)
        ]));
    }), b9n = F6(function(n, r, t, e, u, a) {
        return A2(lV, k([
            jV(k([
                Nk("px-1")
            ]))
        ]), A2(yu, function(e) {
            return A2(iV, k([
                Oun(r),
                jV(k([
                    Nk("column--topSpaceMd")
                ]))
            ]), k([
                A5(d9n, n, t, e, u, a)
            ]));
        }, e));
    }), v9n = F7(function(n, r, t, e, u, a, i) {
        var c, o = f9n(t) && !KQn(e), f = (c = b(Aan(u) || qan(u), o)).a && c.b ? b(k([
            0,
            1
        ]), 4) : b(h, 12), s = f.a, l = f.b;
        if (!oe(s)) return Sq;
        switch(r.$){
            case 3:
            case 1:
                return Sq;
            default:
                var d = Aan(u);
                return A2(AW, k([
                    bW(n(o9n))
                ]), k([
                    A6(b9n, n, l, a, s, i, d)
                ]));
        }
    }), m9n = {
        $: 22
    }, p9n = F3(function(n, r, t) {
        return A2(lV, k([
            jV(k([
                Nk("px-1")
            ]))
        ]), k([
            A2(iV, k([
                UZ(6)
            ]), k([
                A2(PB, k([
                    OL
                ]), k([
                    ad(A2(Fin, n, r))
                ]))
            ])),
            A2(iV, k([
                UZ(6),
                uV(Nun)
            ]), k([
                A2(IZ, !t, A2(fz, k([
                    r4,
                    QS(m9n)
                ]), k([
                    ad(n(a9n))
                ])))
            ]))
        ]));
    }), $9n = F4(function(n, r, t, e) {
        switch(t.$){
            case 3:
                return A3(p9n, n, t.a, e);
            case 1:
                return A2(Ik, h, Yk);
            default:
                return function(n) {
                    var r = jN(n).al;
                    return A2(Ik, k([
                        jz(J2n)
                    ]), function() {
                        if (r.$) return h;
                        var n = r.a;
                        return A2(yu, px(J1n), nfn(n));
                    }());
                }(r);
        }
    }), h9n = F2(function(n, r) {
        if (Y1n(r.fF)) {
            var t = jN(r.kk).al;
            return A2(Ik, h, k([
                A2(mx, k([
                    LS(aV)
                ]), k([
                    ad(n(e9n))
                ])),
                A7(v9n, n, r.du, r.fF, r.lj, r.dw, t, r.uA),
                t.$ ? Sq : A2(hx, k([
                    LS(FS)
                ]), k([
                    A2(LB, h, k([
                        ad(A2(t9n, n, r.du))
                    ]))
                ])),
                A4($9n, n, r.kk, r.du, r.uA)
            ]));
        }
        return Sq;
    }), g9n = function(n) {
        return n.tX;
    }, w9n = {
        $: 9
    }, k9n = {
        $: 11
    }, x9n = function(n) {
        return {
            $: 6,
            a: n
        };
    }, y9n = F3(function(n, r, t) {
        return A2(ZI, t, r) ? A2(iW, t, n) : h;
    }), _9n = F3(function(n, r, t) {
        return A2(ZI, t, r) && A2(kW, t, n);
    }), C9n = function(n) {
        return n.oY;
    }, D9n = function(n) {
        return n.pm;
    }, A9n = function(n) {
        return function(n) {
            var r = C9n(n);
            return r.$ ? qtn(r.a) : rB(r.a) + "%";
        }(n) + " off " + (function(n) {
            var r = D9n(n);
            switch(r.$){
                case 0:
                    return "for unlimited time";
                case 1:
                    return "for one month";
                default:
                    return "for " + ee(r.a) + " months";
            }
        }(n) + function(n) {
            var r = b(C9n(n), function(n) {
                return n.gy;
            }(n));
            return 1 === r.a.$ && r.b ? " on each member" : "";
        }(n));
    }, q9n = function(n) {
        if (3 === n.$) {
            var r = n.a;
            return A2(PB, k([
                BB,
                EB
            ]), k([
                ad(A9n(r))
            ]));
        }
        return ad("");
    }, B9n = F2(function(n, r) {
        var t, e = jN(r.kk).ap, u = e.a, a = e.b;
        return A2(Ik, k([
            Nk("mb-4 md:mb-6"),
            jz(X2n)
        ]), k([
            A2(AW, k([
                bW(n(Q0n))
            ]), k([
                yP(k([
                    bP(u),
                    xZ(A2(sc, x9n, B0n(a))),
                    oZ(A3(_9n, r.kk, r.x, 2)),
                    sP(r.uA || (t = r.w_, YS(r0n(t.iu)))),
                    lZ(V1n),
                    dZ(k9n)
                ])),
                A2(OW, n, A3(y9n, r.kk, r.x, 2)),
                q9n(r.oh)
            ]))
        ]));
    }), j9n = F2(function(n, r) {
        return tKn(r.fF) ? r.iK ? A2(B9n, n, r) : A2(Ik, k([
            Nk("mb-4 md:mb-6 -mt-2 md:-mt-4")
        ]), k([
            A2(fz, k([
                r4,
                QS(w9n)
            ]), k([
                ad(n(J0n))
            ]))
        ])) : Sq;
    }), S9n = F2(function(n, r) {
        if (3 === n.$) {
            var t = B2n(n.a);
            return YS(A2(q2n, t, r));
        }
        return !1;
    }), z9n = F2(function(n, r) {
        var t, e = 3 === (t = r.aM).$ ? B2n(t.a) : h, u = cKn(r.fF), a = jN(r.kk).b2;
        return ED(e) || !u ? Sq : A2(Ik, k([
            Nk("mb-4 md:mb-6")
        ]), k([
            A2(AW, k([
                bW(n(X0n)),
                hW(!0)
            ]), k([
                A2(px, T0n, A4(AU, n, k([
                    Jz(a),
                    ZL(n(G0n)),
                    Wz,
                    cX(r.uA || A2(S9n, r.aM, r.w_.iu)),
                    ogn(A3(_9n, r.kk, r.x, 0))
                ]), A2(yu, function(n) {
                    return A2(Xz, h, n);
                }, e), r.cJ))
            ])),
            A2(OW, n, A3(y9n, r.kk, r.x, 0))
        ]));
    }), U9n = ru, E9n = function(n) {
        return n.$7.rr;
    }, P9n = F2(function(n, r) {
        return r.oc(n);
    }), T9n = F2(function(n, r) {
        return r.oe(n);
    }), F9n = F3(function(n, r, t) {
        var e = A2(dP, AA("/"), t);
        return function(n) {
            return 1 === n;
        }(r) ? A2(PB, k([
            BB,
            EB
        ]), k([
            ad(n(P9n(e)))
        ])) : A2(PB, k([
            BB,
            EB
        ]), k([
            ad(n(T9n(e)))
        ]));
    }), L9n = F3(function(n, r, t) {
        var e = b(r, t);
        if (e.a.$ || e.b.$) return Sq;
        var u = e.a.a, a = e.b.a, i = v(function(n) {
            return n.n8;
        }(u), function(n) {
            return n.of;
        }(u), function(n) {
            return n.n9;
        }(a));
        return !i.a || i.b.$ || i.c.$ ? Sq : A3(F9n, n, i.b.a, i.c.a);
    }), M9n = F3(function(n, r, t) {
        var e = jN(t.kk).C3;
        return A2(Ik, k([
            Nk("mb-4 md:mb-6"),
            jz(Y2n)
        ]), k([
            A2(AW, k([
                bW(n(E9n)),
                hW(!0)
            ]), k([
                A2(px, I1n, A2(_P, k([
                    U9n(r)
                ]), e)),
                A3(L9n, n, A2(Xb, e3n, t.mS), t.fl),
                A2(OW, n, A3(y9n, t.kk, t.x, 1))
            ]))
        ]));
    }), H9n = F2(function(n, r) {
        if (fKn(r.fF)) {
            var t = r.aM;
            return 3 === t.$ ? A3(M9n, n, r.uA || !function(n) {
                return n.wd;
            }(t.a), r) : Sq;
        }
        return Sq;
    }), R9n = F2(function(n, r) {
        var t;
        return cKn(t = r.fF) || tKn(t) || fKn(t) ? A2(lV, k([
            jV(k([
                Nk("px-1"),
                Nk("-my-1")
            ]))
        ]), k([
            A2(iV, k([
                UZ(12)
            ]), k([
                A2(mx, k([
                    LS(aV)
                ]), k([
                    ad(n(g9n))
                ])),
                A2(z9n, n, r),
                A2(j9n, n, r),
                A2(H9n, n, r)
            ]))
        ])) : Sq;
    }), O9n = F2(function(n, r) {
        var t = KQn(r.lj);
        return A2(Ik, k([
            jz(G1n)
        ]), k([
            A2(h9n, n, r),
            A2(R9n, n, r),
            A2(n9n, n, r),
            A4(r9n, t, n, r.dw, r.fF)
        ]));
    }), N9n = F2(function(n, r) {
        return A2(Ot, function(n) {
            return {
                $: 12,
                a: n
            };
        }(n), r);
    }), I9n = function(n) {
        var r = n.du;
        if (3 === r.$) {
            var t = b(vun(r.a), MD(n.e8));
            return !t.a || !t.b.$;
        }
        return !1;
    }, V9n = function(n) {
        return n.sS;
    }, W9n = function(n) {
        return A2(yu, function(n) {
            return function(n) {
                var r;
                return {
                    l7: (r = n, r.l7),
                    kr: bDn(G3n(n)),
                    sS: V9n(n)
                };
            }(n);
        }, n);
    }, Z9n = function(n) {
        return 3 === n.$ ? n.a : h;
    }, X9n = F2(function(n, r) {
        return A2(Ot, function(n) {
            return {
                $: 10,
                a: n
            };
        }(n), r);
    }), G9n = F2(function(n, r) {
        return A2(Ot, function(n) {
            return {
                $: 1,
                a: n
            };
        }(n), r);
    }), J9n = F2(function(n, r) {
        return n.$ ? r : A2(Ot, function(n) {
            return {
                $: 6,
                a: n
            };
        }(n.a), r);
    }), Y9n = function(n) {
        return {
            $: 5,
            a: n
        };
    }, Q9n = F2(function(n, r) {
        return A2(Ot, Y9n(function(n) {
            return {
                $: 1,
                a: n
            };
        }(n)), r);
    }), K9n = F2(function(n, r) {
        return A2(Ot, function(n) {
            return {
                $: 11,
                a: n
            };
        }(n), r);
    }), n6n = F2(function(n, r) {
        return A2(Ot, function(n) {
            return {
                $: 0,
                a: n
            };
        }(n), r);
    }), r6n = F2(function(n, r) {
        return n.$ ? r : A2(Ot, function(n) {
            return {
                $: 9,
                a: n
            };
        }(n.a), r);
    }), t6n = F2(function(n, r) {
        return n.$ ? r : A2(Ot, Y9n(function(n) {
            return {
                $: 0,
                a: n
            };
        }(n.a)), r);
    }), e6n = F2(function(n, r) {
        return A2(Ot, function(n) {
            return {
                $: 7,
                a: n
            };
        }(n), r);
    }), u6n = F2(function(n, r) {
        var t, e = (t = v(r.e8, r.yl, function(n) {
            var r, t = 3 === (r = n.du).$ && vun(r.a), e = jN(n.kk).al, u = !e.$ && function(n) {
                return 1 === n.dK;
            }(e.a);
            return u || t;
        }(r)), !(3 !== t.a.$ || !t.b || !t.c) && Qan(t.a.a) > 0);
        return A2(N9n, function(n) {
            return n.uq;
        }(r.fF), A2(K9n, MD(r.e8), A3(Ee, X9n, e, (nKn(r.lj) ? t6n(r.fl) : Q9n(W9n(Z9n(r.Av))))(A2(G9n, r.uA || function(n) {
            if (n.yl) {
                if (t = iKn(n.fF), whn(t)) return !1;
                if (f9n(n.fF)) {
                    var r = jN(n.kk);
                    return !!YS(r.al) && !I9n(n);
                }
                return !I9n(n);
            }
            var t;
            return !1;
        }(r), A2(e6n, !0, A2(J9n, r.b6, A2(r6n, r.mS, A2(n6n, n(wsn), h)))))))));
    }), a6n = {
        mS: Rt,
        c2: Rt,
        gX: !1,
        gZ: {
            $: 2
        },
        yR: !1,
        kg: Rt,
        Ac: !1,
        AB: !1,
        e8: Rt,
        it: "Continue to next step",
        iB: Rt,
        iJ: !1,
        jF: !1
    }, i6n = F2(function(n, r) {
        switch(n.$){
            case 0:
                return m(r, {
                    it: n.a
                });
            case 1:
                return m(r, {
                    yR: n.a
                });
            case 2:
                return m(r, {
                    Ac: n.a
                });
            case 3:
                return m(r, {
                    c2: Ht(n.a)
                });
            case 4:
                return m(r, {
                    iB: Ht(n.a)
                });
            case 9:
                return m(r, {
                    mS: Ht(n.a)
                });
            case 5:
                return m(r, {
                    gZ: n.a
                });
            case 6:
                return m(r, {
                    kg: Ht(n.a)
                });
            case 7:
                return m(r, {
                    jF: n.a
                });
            case 8:
                return m(r, {
                    AB: n.a
                });
            case 10:
                return m(r, {
                    iJ: n.a
                });
            case 11:
                return m(r, {
                    e8: n.a
                });
            default:
                return m(r, {
                    gX: n.a
                });
        }
    }), c6n = {
        $: 1
    }, o6n = {
        $: 2
    }, f6n = F4(function(n, r, t, e) {
        return A2(fz, k([
            CU,
            ZS(t || r),
            Don(r),
            QS(e),
            vz(k([
                Nk("w-full mb-2")
            ]))
        ]), k([
            A2(Gk, h, k([
                ad(n)
            ]))
        ]));
    }), s6n = function(n) {
        var r;
        return A2(Ik, h, k([
            function() {
                var r = n.c2;
                if (r.$) return Sq;
                var t = r.a;
                return A2(hx, k([
                    BB,
                    bz(wF),
                    LS(aV)
                ]), k([
                    ad(t)
                ]));
            }(),
            (r = n.iB, r.$ ? Sq : A2(Ik, h, k([
                A4(f6n, r.a, n.Ac, n.yR, o6n)
            ]))),
            A2(Ik, h, k([
                A4(H1n, n.it, n.Ac, n.yR, c6n)
            ]))
        ]));
    }, l6n = F3(function(n, r, t) {
        return 1 === t.$ ? n : r(t.a);
    }), d6n = function(n) {
        return n.sS;
    }, b6n = F3(function(n, r, t) {
        var e = y2n(t), u = A2(uc, 0, A2(Cp, Qan, r)), a = e + u;
        return A2(Ik, k([
            Nk("quote-info")
        ]), k([
            A2(Ik, k([
                Nk("w-full text-center")
            ]), k([
                A2(Ik, k([
                    Nk("hidden md:inline-flex md:flex-col")
                ]), k([
                    A2(px, hu, A7(kPn, n, a, !1, Rt, J1, !1, !1)),
                    u > 0 ? A2(Ik, k([
                        Nk("quote-info__bill")
                    ]), k([
                        A2(hx, k([
                            zV,
                            bz(yz)
                        ]), k([
                            ad("Total amount")
                        ]))
                    ])) : Sq
                ])),
                gx
            ])),
            A2(px, hu, A2(gRn, d6n(t), e)),
            A2(IZ, YS(r), gx),
            A2(px, hu, $Rn(r))
        ]));
    }), v6n = function(n) {
        return n.sS;
    }, m6n = function(n) {
        return {
            $: 0,
            a: n
        };
    }, p6n = function(n) {
        return n.aD ? "collapser-closed" : "collapser-open";
    }, $6n = function(n) {
        var r = n.kr ? "primary" : "dependent", t = A2(ue, ", ", A2(Ep, ru, k([
            A2(Cp, function(n) {
                return ee(n) + " y/o";
            }, n.l7),
            Ht(r)
        ])));
        return A2(Ik, k([
            Nk("flex justify-between w-full mt-2 text-sm md:text-base")
        ]), k([
            A2(Ik, k([
                Nk("flex")
            ]), k([
                A2(hx, h, k([
                    ad(n.sS)
                ]))
            ])),
            A2(Ik, k([
                Nk("flex")
            ]), k([
                A2(hx, k([
                    BB
                ]), k([
                    ad(t)
                ]))
            ]))
        ]));
    }, h6n = function(n) {
        return A2(Ik, k([
            Nk("mt-2 md:mt-6")
        ]), A2(yu, $6n, n));
    }, g6n = function(n) {
        return au(n) > 0 ? A2(hx, k([
            Hz,
            LS(NZ),
            LS(Vun),
            A2(_1n, 2, aV),
            A2(_1n, 2, Htn),
            bz(wF)
        ]), k([
            ad(n)
        ])) : Sq;
    }, w6n = F3(function(n, r, t) {
        return A2(Ik, h, k([
            A2(Ik, k([
                Nk("flex w-full")
            ]), k([
                A2(Ik, k([
                    Nk("flex-grow")
                ]), k([
                    g6n(v6n(n))
                ])),
                A2(Ik, k([
                    Nk("flex-shrink flex -mt-1"),
                    rz(k([
                        b("mb-2", !t.aD)
                    ]))
                ]), k([
                    A2(Ik, k([
                        Nk("collapser")
                    ]), k([
                        A2(Ik, k([
                            Nk(p6n(t))
                        ]), k([
                            A2(fz, k([
                                pz,
                                QS(m6n(!t.aD))
                            ]), k([
                                A2(US, h, 6)
                            ]))
                        ]))
                    ]))
                ]))
            ])),
            A2(px, hu, A2(IZ, !t.aD, A2(Ik, h, k([
                h6n(r)
            ]))))
        ]));
    }), k6n = F5(function(n, r, t, e, u) {
        var a = oe(r) > 0;
        return e ? A2(Ik, k([
            Nk("quote-info")
        ]), k([
            A2(IZ, a, A3(w6n, n, r, u)),
            A2(IZ, YS(t) && !u.aD, gx)
        ])) : A2(px, hu, A2(Ik, k([
            Nk("quote-info")
        ]), k([
            A2(IZ, a, g6n(v6n(n))),
            A2(IZ, a, gx),
            h6n(r),
            A2(IZ, a && YS(t), gx)
        ])));
    }), x6n = function(n) {
        return n.u2;
    }, y6n = function(n) {
        return n.Av;
    }, _6n = function(n) {
        return n.sS;
    }, C6n = F2(function(n, r) {
        var t;
        return A2(Ik, k([
            Nk("flex justify-between w-full mt-2 text-sm md:text-base")
        ]), k([
            A2(Ik, k([
                Nk("flex")
            ]), k([
                A2(hx, h, k([
                    Jx(_6n(r))
                ]))
            ])),
            A2(IZ, !n, A2(Ik, k([
                Nk("flex")
            ]), k([
                A2(hx, k([
                    BB
                ]), k([
                    ad(qtn((t = r, t.uV)))
                ]))
            ])))
        ]));
    }), D6n = function(n) {
        var r = y6n(n), t = n.r0;
        return A2(Ik, k([
            Nk("mt-2 md:mt-6")
        ]), A2(yu, C6n(t), r));
    }, A6n = function(n) {
        return n.fl.kc;
    }, q6n = function(n) {
        return n.fl.qa;
    }, B6n = function(n) {
        return n.fl.Bv;
    }, j6n = function(n) {
        return n.fl.Cb;
    }, S6n = function(n) {
        return n.fl.Cc;
    }, z6n = function(n) {
        return n.fl.Cy;
    }, U6n = function(n) {
        return n.fl.Dv;
    }, E6n = F3(function(n, r, t) {
        if (L0n(r) > 0) {
            var e = "Registration Fee" === t ? n(B6n) : t;
            return A2(Ik, h, k([
                A2(hx, k([
                    BB
                ]), k([
                    A2(Ik, k([
                        Nk("flex justify-between w-full")
                    ]), k([
                        A2(Ik, k([
                            Nk("flex pr-8")
                        ]), k([
                            ad(e)
                        ])),
                        A2(Ik, k([
                            Nk("flex")
                        ]), k([
                            ad(qtn(L0n(r)))
                        ]))
                    ]))
                ]))
            ]));
        }
        return Sq;
    }), P6n = F4(function(n, r, t, e) {
        return A2(Ik, h, k([
            A2(Ik, k([
                Nk("flex w-full")
            ]), k([
                A2(Ik, k([
                    Nk("flex-grow")
                ]), k([
                    A2(hx, k([
                        BB
                    ]), k([
                        ad("Pricing Breakdown")
                    ]))
                ])),
                A2(Ik, k([
                    Nk("flex-shrink flex -mt-1"),
                    rz(k([
                        b("mb-2", !e.aD)
                    ]))
                ]), k([
                    A2(Ik, k([
                        Nk("collapser")
                    ]), k([
                        A2(Ik, k([
                            Nk(p6n(e))
                        ]), k([
                            A2(fz, k([
                                pz,
                                QS(m6n(!e.aD))
                            ]), k([
                                A2(US, h, 6)
                            ]))
                        ]))
                    ]))
                ]))
            ])),
            A2(px, hu, A2(IZ, !e.aD, A2(Ik, h, k([
                D6n(r),
                A2(Ik, k([
                    Nk("mb-2")
                ]), h),
                A3(E6n, n, r, x6n(t))
            ]))))
        ]));
    }), T6n = function(n) {
        return "with " + qtn(n) + " discount";
    }, F6n = F2(function(n, r) {
        var t = C9n(n);
        return t.$ ? A2(Cp, T6n, r) : Ht("with " + rB(t.a) + "% discount");
    }), L6n = F4(function(n, r, t, e) {
        var u = b(t, D9n(n));
        if (!u.a) return A2(F6n, n, e);
        switch(u.b.$){
            case 1:
                return Rt;
            case 0:
                return A2(F6n, n, e);
            default:
                return s(u.b.a, mA(r)) > 0 ? A2(F6n, n, e) : Rt;
        }
    }), M6n = F2(function(n, r) {
        var t = function(n) {
            return n.oh;
        }(n);
        if (t.$) return Sq;
        var e = t.a, u = function(n) {
            return n.oi;
        }(n), a = mPn(n), i = A4(L6n, e, a, r, u);
        if (i.$) return Sq;
        var c = i.a;
        return A2(PB, k([
            BB,
            Iz,
            Qk(k([
                Nk("badge")
            ]))
        ]), k([
            ad(c)
        ]));
    }), H6n = F4(function(n, r, t, e) {
        var u = Ht(mPn(t)), a = pPn(t);
        return A2(Ik, k([
            Nk("w-full text-center")
        ]), k([
            A2(Ik, k([
                Nk("hidden md:inline-flex md:flex-col")
            ]), k([
                A7(kPn, n, a, e, u, yz, !1, !1),
                A2(M6n, t, !0),
                g6n(r)
            ])),
            gx,
            A2(Ik, k([
                Nk("md:hidden")
            ]), k([
                A2(Ik, k([
                    Nk("flex justify-between")
                ]), k([
                    g6n(r),
                    A2(M6n, t, !0),
                    A2(Ik, h, k([
                        A7(kPn, n, a, e, u, yz, !1, !1)
                    ]))
                ])),
                gx
            ]))
        ]));
    }), R6n = F2(function(n, r) {
        var t = c0n(n);
        return !t.$ && i(t.a, mPn(r));
    }), O6n = function(n) {
        return n.mT;
    }, N6n = function(n) {
        return n.C3;
    }, I6n = F2(function(n, r) {
        if (O6n(r)) {
            var t = mA(mPn(n));
            return {
                mi: pPn(n),
                oD: A3(xE, 1, t, N6n(n))
            };
        }
        return {
            mi: pPn(n) + L0n(n),
            oD: N6n(n)
        };
    }), V6n = F2(function(n, r) {
        var t = mA(mPn(n)), e = A3(xE, 1, t, N6n(n));
        return O6n(r) ? {
            mi: _2n(n),
            oD: A3(xE, 1, t, e)
        } : {
            mi: _2n(n),
            oD: e
        };
    }), W6n = F2(function(n, r) {
        var t = A2(V6n, r, n);
        return i(A2(I6n, r, n).mi, t.mi);
    }), Z6n = F2(function(n, r) {
        var t = A2(V6n, r, n), e = A2(I6n, r, n);
        return A2(W6n, n, r) ? A2(R6n, n, r) ? b(Ht(e), Rt) : b(Rt, Ht(t)) : b(Ht(e), Ht(t));
    }), X6n = F2(function(n, r) {
        var t = b(O6n(r), L0n(n) > 0);
        if (t.a && t.b) {
            var e = {
                mi: L0n(n),
                oD: N6n(n)
            };
            return Ht(e);
        }
        return Rt;
    }), G6n = F3(function(n, r, t) {
        return 1 === A2(X6n, t, r).$ ? A2(R6n, r, t) ? b(Ht(n(U6n)), Rt) : b(Ht(n(q6n)), Ht(n(S6n))) : b(Ht(n(z6n)), Ht(n(j6n)));
    }), J6n = F2(function(n, r) {
        var t = A2(V6n, r, n), e = A2(I6n, r, n);
        return A2(W6n, n, r) && !A2(R6n, n, r) ? e.oD : t.oD;
    }), Y6n = function(n) {
        return A2(dP, AA("/"), n);
    }, Q6n = F6(function(n, r, t, e, u, a) {
        var i = b(r, t);
        if (i.a.$ || i.b.$) return Sq;
        var c = i.a.a, o = i.b.a, f = a ? n(A6n) : Y6n(c.oD), s = A2(uc, c.mi, A2(Cp, Lun, u));
        return A2(Ik, h, k([
            A2(Ik, k([
                Nk("flex-auto hidden md:block text-center")
            ]), k([
                A7(kPn, n, s, !1, Rt, yz, !1, !1),
                A2(Ik, k([
                    Nk("quote-info__bill")
                ]), k([
                    A2(hx, k([
                        zV,
                        bz(yz)
                    ]), k([
                        ad(o)
                    ])),
                    A2(PB, k([
                        BB,
                        bz(yz)
                    ]), k([
                        ad(f)
                    ]))
                ])),
                A2(M6n, e, !1)
            ])),
            A2(Ik, k([
                Nk("md:hidden")
            ]), k([
                A2(Ik, k([
                    Nk("flex")
                ]), k([
                    A2(Ik, k([
                        Nk("flex quote-info__bill")
                    ]), k([
                        A2(hx, k([
                            zV,
                            bz(FL),
                            EB
                        ]), k([
                            ad(o)
                        ])),
                        A2(PB, k([
                            BB,
                            bz(FL),
                            LS(L1n)
                        ]), k([
                            ad(f)
                        ]))
                    ])),
                    A2(Ik, k([
                        Nk("ml-auto")
                    ]), k([
                        A7(kPn, n, s, !1, Rt, yz, !1, !1)
                    ]))
                ])),
                A2(M6n, e, !1),
                gx
            ]))
        ]));
    }), K6n = F7(function(n, r, t, e, u, a, i) {
        var c = b(r, t);
        if (c.a.$ || c.b.$) return Sq;
        var o = c.a.a, f = c.b.a, s = i ? n(A6n) : Y6n(e);
        return A2(Ik, h, k([
            A2(Ik, k([
                Nk("flex-auto hidden md:block text-center")
            ]), k([
                A2(Ik, k([
                    Nk("flex justify-center")
                ]), k([
                    A7(kPn, n, o.mi, !0, Ht(mPn(u)), yz, !1, a)
                ])),
                A2(Ik, k([
                    Nk("quote-info__bill")
                ]), k([
                    A2(hx, k([
                        zV,
                        bz(yz)
                    ]), k([
                        ad(f)
                    ])),
                    A2(PB, k([
                        BB,
                        bz(yz)
                    ]), k([
                        ad(s)
                    ]))
                ])),
                A2(M6n, u, !0)
            ])),
            A2(Ik, k([
                Nk("md:hidden")
            ]), k([
                A2(Ik, k([
                    Nk("flex")
                ]), k([
                    A2(Ik, k([
                        Nk("flex quote-info__bill")
                    ]), k([
                        A2(hx, k([
                            zV,
                            bz(FL),
                            EB
                        ]), k([
                            ad(f)
                        ])),
                        A2(PB, k([
                            BB,
                            bz(FL),
                            LS(L1n)
                        ]), k([
                            ad(s)
                        ]))
                    ])),
                    A2(Ik, k([
                        Nk("ml-auto")
                    ]), k([
                        A7(kPn, n, o.mi, !0, Ht(mPn(u)), yz, !1, a)
                    ]))
                ])),
                A2(M6n, u, !0),
                gx
            ]))
        ]));
    }), n4n = F3(function(n, r, t) {
        if (r.$) return Sq;
        var e = r.a, u = t ? n(A6n) : Y6n(e.oD);
        return A2(Ik, h, k([
            A2(Ik, k([
                Nk("flex-auto hidden md:block text-center")
            ]), k([
                A7(kPn, n, e.mi, !1, Rt, yz, !1, !1),
                A2(Ik, k([
                    Nk("quote-info__bill")
                ]), k([
                    A2(hx, k([
                        zV,
                        bz(yz)
                    ]), k([
                        ad("First bill")
                    ])),
                    A2(PB, k([
                        BB,
                        bz(yz)
                    ]), k([
                        ad(u)
                    ]))
                ]))
            ])),
            A2(Ik, k([
                Nk("md:hidden")
            ]), k([
                A2(Ik, k([
                    Nk("flex")
                ]), k([
                    A2(Ik, k([
                        Nk("flex quote-info__bill")
                    ]), k([
                        A2(hx, k([
                            zV,
                            bz(FL),
                            EB
                        ]), k([
                            ad("First bill")
                        ])),
                        A2(PB, k([
                            BB,
                            bz(FL),
                            LS(L1n)
                        ]), k([
                            ad(u)
                        ]))
                    ])),
                    A2(Ik, k([
                        Nk("ml-auto")
                    ]), k([
                        A7(kPn, n, e.mi, !1, Rt, yz, !1, !1)
                    ]))
                ])),
                gx
            ]))
        ]));
    }), r4n = F6(function(n, r, t, e, u, a) {
        var i, c = A2(J6n, r, t), o = A2(X6n, t, r), f = A3(G6n, n, r, t), s = f.a, l = f.b, d = A2(Z6n, r, t), v = d.a, m = d.b, p = !!(i = b(v, a)).a.$ && !!i.b;
        return A2(Ik, k([
            Nk("w-full")
        ]), k([
            A2(Ik, k([
                Nk("hidden md:block")
            ]), k([
                A2(Ik, k([
                    Nk("flex justify-evenly space-x-4")
                ]), k([
                    A3(n4n, n, o, a),
                    A6(Q6n, n, v, s, t, e, a),
                    A7(K6n, n, m, l, c, t, u, p)
                ])),
                g6n(v6n(r)),
                gx
            ])),
            A2(Ik, k([
                Nk("md:hidden")
            ]), k([
                A3(n4n, n, o, a),
                A6(Q6n, n, v, s, t, e, a),
                A7(K6n, n, m, l, c, t, u, p),
                g6n(v6n(r))
            ]))
        ]));
    }), t4n = F3(function(n, r, t) {
        return A3(l6n, Sq, function(e) {
            var u = b(e, r.gZ);
            if (u.a.$) return A3(b6n, n, r.e8, u.a.a);
            switch(u.b.$){
                case 0:
                    var a = u.a.a, i = u.b.a;
                    return (function(n) {
                        return function(r) {
                            return function(t) {
                                return function(e) {
                                    return function(u) {
                                        return function(a) {
                                            return function(i) {
                                                return function(c) {
                                                    return function(o) {
                                                        return function(f) {
                                                            return i ? A2(Ik, k([
                                                                Nk("quote-info")
                                                            ]), k([
                                                                A2(px, hu, a ? A6(r4n, n, r, t, u, c, o) : A4(H6n, n, v6n(r), t, !0)),
                                                                A4(P6n, n, t, r, f),
                                                                A2(IZ, YS(e) && !f.aD, gx)
                                                            ])) : A2(px, hu, A2(Ik, k([
                                                                Nk("quote-info")
                                                            ]), k([
                                                                a ? A6(r4n, n, r, t, u, c, o) : A4(H6n, n, v6n(r), t, !0),
                                                                D6n(t),
                                                                A2(IZ, L0n(t) > 0, gx),
                                                                A3(E6n, n, t, x6n(r)),
                                                                $Rn(u),
                                                                A2(IZ, YS(e), gx)
                                                            ])));
                                                        };
                                                    };
                                                };
                                            };
                                        };
                                    };
                                };
                            };
                        };
                    })(n)(a)(i)(r.c2)(r.e8)(r.jF)(r.AB)(r.iJ)(r.gX)(t);
                case 1:
                    return A5(k6n, a = u.a.a, u.b.a, r.c2, r.AB, t);
                default:
                    return Sq;
            }
        }, r.mS);
    }), e4n = F2(function(n, r) {
        var t = k([
            Phn(0)
        ]);
        if (r.$) return Sq;
        var e = r.a;
        return A3(Ihn, t, yJn(e), A2(xJn, n, gJn(e)));
    }), u4n = F2(function(n, r) {
        return A2(Ik, k([
            Nk("md:hidden sidebar-mobile")
        ]), k([
            A2(Ik, k([
                Nk("sidebar-wrap")
            ]), r)
        ]));
    }), a4n = F2(function(n, r) {
        return A2(Ik, k([
            Nk("sidebar-wrap"),
            A2(cE, "margin-top", rB(n.h3) + "px"),
            jz("sidebar-element")
        ]), r);
    }), i4n = F3(function(n, r, t) {
        var e = A3(ce, i6n, a6n, r);
        return (e.AB ? u4n(t) : a4n(t))(k([
            A3(t4n, n, e, t),
            A2(e4n, n, e.kg),
            s6n(e)
        ]));
    }), c4n = F2(function(n, r) {
        return A2(Ik, k([
            Nk("hidden md:block")
        ]), k([
            A2(px, y0n, A3(i4n, n, A2(u6n, n, r), r.cR))
        ]));
    }), o4n = function(n) {
        return A2(Ot, function(n) {
            return {
                $: 8,
                a: n
            };
        }(!0), n);
    }, f4n = F2(function(n, r) {
        return A2(px, y0n, A3(i4n, n, o4n(A2(u6n, n, r)), r.cR));
    }), s4n = F2(function(n, r) {
        return k([
            A2(Ik, k([
                Nk("signup__body--contents")
            ]), k([
                A2(XT, k([
                    jX,
                    LS(q3),
                    A2(_1n, 1, p1n),
                    bz(gz)
                ]), k([
                    ad(n(wsn))
                ])),
                A2(Ik, k([
                    Nk("flex w-full")
                ]), k([
                    A2(O9n, n, r),
                    A2(c4n, n, r)
                ])),
                A2(f4n, n, r)
            ]))
        ]);
    }), l4n = function(n) {
        return A2(Ik, k([
            Nk("panel w-full")
        ]), k([
            A2(mx, h, k([
                ad("There was a problem!")
            ])),
            gx,
            A2(hx, h, k([
                ad("An error has been registered. Please contact us to complete enrollment at "),
                oZn(kF(n)),
                A2(cZn, lk(n), kF(n)),
                ad(". Or try again tomorrow.")
            ]))
        ]));
    }, d4n = F2(function(n, r) {
        return {
            gF: function() {
                var t = b(r.aM, r.tk);
                n: for(;;){
                    r: for(;;)switch(t.a.$){
                        case 1:
                            return Yk;
                        case 2:
                            if (1 === t.b.$) break n;
                            break r;
                        default:
                            switch(t.b.$){
                                case 1:
                                    break n;
                                case 2:
                                    return k([
                                        l4n(r.dw)
                                    ]);
                                default:
                                    return A2(s4n, n, r);
                            }
                    }
                    return k([
                        l4n(r.dw)
                    ]);
                }
                return Yk;
            }(),
            wD: hk(r.dw)
        };
    }), b4n = sZn({
        zO: m0n,
        Ab: w0n,
        Ct: k0n,
        Dd: function(n) {
            var r = jN(n.kk).ac;
            return xk(k([
                A2(xD, J1n, ocn),
                A2(xD, W1n, p9(r)),
                A2(xD, y0n, A0n()),
                sXn(x0n),
                mYn(_0n)
            ]));
        },
        DB: K3n,
        DH: d4n
    }), v4n = function(n) {
        return {
            $: 14,
            a: n
        };
    }, m4n = function(n) {
        return {
            $: 26,
            a: n
        };
    }, p4n = function(n) {
        return {
            $: 13,
            a: n
        };
    }, $4n = function(n) {
        return {
            $: 27,
            a: n
        };
    }, h4n = function(n) {
        return {
            $: 5,
            a: n
        };
    }, g4n = function(n) {
        return {
            $: 4,
            a: n
        };
    }, w4n = function(n) {
        return {
            $: 7,
            a: n
        };
    }, k4n = F2(function(n, r) {
        return function(n) {
            return n.a.sS;
        }(r);
    }), x4n = function(n) {
        return Ht(A2(k4n, Rk(0), n));
    }, y4n = F2(function(n, r) {
        return tvn(n) ? A2(evn, sO, r) : r;
    }), _4n = function(n) {
        switch(n){
            case 0:
                return "field-first-name";
            case 1:
                return "field-last-name";
            case 2:
                return "field-chosen-first-name";
            case 3:
                return "field-chosen-last-name";
            case 4:
                return "field-email";
            case 5:
                return "field-phone";
            case 6:
                return "field-lead-source";
            case 7:
                return "field-lead-source-other";
            default:
                return "field-broker";
        }
    }, C4n = function(n) {
        return {
            m$: Rt,
            nm: "",
            nn: "",
            no: "",
            np: "",
            nq: Obn("chosen-title"),
            pt: "",
            qb: "",
            aj: !1,
            rt: "",
            ry: Rt,
            rz: "",
            sE: "",
            t2: A2(y4n, n, A2(ivn, !0, zbn(_4n(5)))),
            wt: "",
            wD: Obn("title")
        };
    }, D4n = F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    }), A4n = F2(function(n, r) {
        return {
            qU: n,
            sS: r
        };
    }), q4n = A3(zy, "name", w$, A3(zy, "id", w$, Ke(A4n))), B4n = A2(IC, 0, A2(qy, q4n, Ke(D4n))), j4n = F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    }), S4n = F2(function(n, r) {
        return {
            qU: n,
            sS: r
        };
    }), z4n = A3(zy, "name", w$, A3(zy, "id", w$, Ke(S4n))), U4n = A2(IC, 0, A2(qy, z4n, Ke(j4n))), E4n = A3(zy, "debug", xy, A3(zy, "referred", xy, A3(zy, "broker", l_(B4n), A3(zy, "lead_source", l_(U4n), A3(zy, "title", A2(Ge, Esn, l_(w$)), A3(zy, "phones", l_(Ey(Rsn)), A3(zy, "lead_source_other", l_(w$), A3(zy, "middle_name", l_(w$), A3(zy, "suffix", l_(w$), A3(zy, "last_name", w$, A3(zy, "first_name", w$, A3(zy, "email", l_(w$), A3(zy, "chosen_suffix", l_(w$), A3(zy, "chosen_title", A2(Ge, Esn, l_(w$)), A3(zy, "chosen_middle_name", l_(w$), A3(zy, "chosen_last_name", l_(w$), A3(zy, "chosen_first_name", l_(w$), A3(zy, "id", w$, Ke(function(n) {
        return function(r) {
            return function(t) {
                return function(e) {
                    return function(u) {
                        return function(a) {
                            return function(i) {
                                return function(c) {
                                    return function(o) {
                                        return function(f) {
                                            return function(s) {
                                                return function(l) {
                                                    return function(d) {
                                                        return function(b) {
                                                            return function(v) {
                                                                return function(m) {
                                                                    return function(p) {
                                                                        return function($) {
                                                                            return {
                                                                                m$: m,
                                                                                nm: r,
                                                                                nn: t,
                                                                                no: e,
                                                                                np: a,
                                                                                nq: u,
                                                                                oM: $,
                                                                                pt: i,
                                                                                qb: c,
                                                                                qU: n,
                                                                                rt: o,
                                                                                ry: v,
                                                                                rz: l,
                                                                                sE: s,
                                                                                t2: d,
                                                                                u$: p,
                                                                                wt: f,
                                                                                wD: b
                                                                            };
                                                                        };
                                                                    };
                                                                };
                                                            };
                                                        };
                                                    };
                                                };
                                            };
                                        };
                                    };
                                };
                            };
                        };
                    };
                };
            };
        };
    }))))))))))))))))))), P4n = A2(qy, E4n, Ke(ru)), T4n = F2(function(n, r) {
        return A2($y, k([
            "online_enrollments"
        ]), A2(PQn, n, r));
    }), F4n = F5(function(n, r, t, e, u) {
        var a = vk(k([
            b("referred_token", mk(e))
        ]));
        return A4(vN, z9(n), P4n, u, A2(xq, a, bC(A2($y, k([
            "from_referred_token"
        ]), A2(T4n, r, t)))));
    }), L4n = F5(function(n, r, t, e, u) {
        return A4(dC, z9(n), P4n, u, bC(A2($y, k([
            e
        ]), A2(T4n, r, t))));
    }), M4n = A3(zy, "id", w$, Ke(function(n) {
        return {
            qU: n
        };
    })), H4n = A2(qy, M4n, Ke(ru)), R4n = F2(function(n, r) {
        return A2($y, k([
            "new"
        ]), A2($y, k([
            "online_enrollments"
        ]), A2(PQn, n, r)));
    }), O4n = F4(function(n, r, t, e) {
        return A4(dC, z9(n), H4n, e, bC(A2(R4n, r, t)));
    }), N4n = function(n) {
        return n.a.sS;
    }, I4n = F2(function(n, r) {
        return N4n(r);
    }), V4n = function(n) {
        return Ht(A2(I4n, Rk(0), n));
    }, W4n = F3(function(n, r, t) {
        return A4(dC, z9(n), Ey(B4n), t, bC(function(n) {
            return A2($y, k([
                "brokers"
            ]), gy(n));
        }(r)));
    }), Z4n = F3(function(n, r, t) {
        return A4(dC, z9(n), Ey(U4n), t, bC(function(n) {
            return A2($y, k([
                "lead_sources"
            ]), gy(n));
        }(r)));
    }), X4n = A2(w7, "Member Onboarding: Start", k([
        _7(TYn)
    ])), G4n = F2(function(n, r) {
        return A2($y, k([
            "signup_pages",
            r,
            "charge_item"
        ]), gy(n));
    }), J4n = F4(function(n, r, t, e) {
        return A4(dC, z9(n), $Qn, e, bC(A2(G4n, r, t)));
    }), Y4n = F6(function(n, r, t, e, u, a) {
        return {
            pt: t,
            qb: n,
            rt: r,
            tk: a,
            t0: e,
            uj: u
        };
    }), Q4n = A3(zy, "id", w$, Ke(function(n) {
        return {
            qU: n
        };
    })), K4n = A2(qy, Q4n, Ke(ru)), n8n = A3(zy, "online_enrollment", Ay(K4n), A3(zy, "practitioner", _en, A3(zy, "phone", w$, A3(zy, "email", w$, A3(zy, "last_name", w$, A3(zy, "first_name", w$, Ke(Y4n))))))), r8n = A2(qy, n8n, Ke(ru)), t8n = F4(function(n, r, t, e) {
        return A4(dC, z9(n), r8n, e, bC(A2($y, k([
            "waitlist_tokens",
            t
        ]), gy(r))));
    }), e8n = k([
        0,
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8
    ]), u8n = function(n) {
        switch(n){
            case 0:
                return "First Name";
            case 1:
                return "Last Name";
            case 2:
                return "Chosen First Name";
            case 3:
                return "Chosen Last Name";
            case 4:
                return "Email";
            case 5:
                return "Phone";
            case 6:
                return "Lead Source";
            case 7:
                return "Lead Source Other";
            default:
                return "Broker";
        }
    }, a8n = function(n) {
        return A2(n0n, "waitlist_token", n);
    }, i8n = F4(function(n, r, t, e) {
        var u, a = 3 === (u = t.CX).$ ? u.a : h, i = GIn(r), c = KQn(i) ? A4(J4n, t.gx, $k(n), pZn(i), m4n) : Dp, o = function() {
            var r = oYn(t);
            if (r.$) {
                var u = A2(n0n, "token", e.iu);
                if (u.$) {
                    var a = function() {
                        var r = a8n(e.iu);
                        if (r.$) return Dp;
                        var u = r.a;
                        return A4(t8n, t.gx, $k(n), u, $4n);
                    }();
                    return v(Hu(k([
                        A4(O4n, t.gx, $k(n), pZn(i), w4n),
                        X4n,
                        a
                    ])), oc, Mx);
                }
                var c = u.a;
                return v(Hu(k([
                    A5(F4n, t.gx, $k(n), pZn(i), c, h4n),
                    X4n
                ])), Mx, oc);
            }
            var o = r.a;
            return v(A5(L4n, t.gx, $k(n), pZn(i), o, g4n), Mx, oc);
        }(), f = o.a, s = o.b, l = o.c;
        return b({
            fV: ZJn(t),
            gx: t.gx,
            gE: VJ,
            eg: id({
                qU: "broker-select",
                Dr: k4n,
                Dt: x4n
            }),
            bF: oc,
            c4: VJ,
            nf: Rt,
            g7: t.g7,
            kj: t.kj,
            kk: AO(C4n(n)),
            hr: Rt,
            eQ: id({
                qU: "lead-source-select",
                Dr: I4n,
                Dt: V4n
            }),
            eR: oc,
            cF: l,
            e6: t.e6,
            dw: n,
            uA: !1,
            fi: !1,
            u$: !1,
            cL: s,
            cM: VJ,
            lj: i,
            fF: r,
            CX: a,
            w_: e,
            x: A2(jO, e8n, u8n)
        }, Hu(k([
            f,
            A4(TKn, 0, a, r, h),
            A3(Z4n, t.gx, $k(n), p4n),
            A3(W4n, t.gx, $k(n), v4n),
            c
        ])));
    }), c8n = F2(function(n, r) {
        return b(r, Dp);
    }), o8n = F2(function(n, r) {
        return r;
    }), f8n = function(n) {
        return {
            $: 25,
            a: n
        };
    }, s8n = function(n) {
        return {
            $: 15,
            a: n
        };
    }, l8n = function(n) {
        return {
            $: 12,
            a: n
        };
    }, d8n = function(n) {
        return {
            $: 6,
            a: n
        };
    }, b8n = function(n) {
        return {
            $: 10,
            a: n
        };
    }, v8n = function(n) {
        return {
            $: 2,
            a: n
        };
    }, m8n = function(n) {
        return {
            $: 16,
            a: n
        };
    }, p8n = function(n) {
        return {
            $: 15,
            a: n
        };
    }, $8n = function(n) {
        return {
            $: 17,
            a: n
        };
    }, h8n = function(n) {
        return {
            $: 5,
            a: n
        };
    }, g8n = function(n) {
        return {
            $: 13,
            a: n
        };
    }, w8n = function(n) {
        return {
            $: 11,
            a: n
        };
    }, k8n = function(n) {
        return {
            $: 14,
            a: n
        };
    }, x8n = function(n) {
        return {
            $: 2,
            a: n
        };
    }, y8n = function(n) {
        return {
            $: 3,
            a: n
        };
    }, _8n = function(n) {
        return {
            $: 12,
            a: n
        };
    }, C8n = function(n) {
        return {
            $: 18,
            a: n
        };
    }, D8n = function(n) {
        return {
            $: 0,
            a: n
        };
    }, A8n = function(n) {
        return {
            $: 8,
            a: n
        };
    }, q8n = function(n) {
        return {
            $: 12,
            a: n
        };
    }, B8n = F2(function(n, r) {
        return Gb(A2(iW, r, n));
    }), j8n = F2(function(n, r) {
        return A2(Xb, function(n) {
            return Ht(b(r, n));
        }, A2(B8n, n, r));
    }), S8n = function(n) {
        return A2(yu, function(n) {
            var r = n.a;
            return FYn({
                eC: k([
                    n.b
                ]),
                p5: u8n(r)
            });
        }, function(n) {
            return A2(Ep, j8n(n), e8n);
        }(n));
    }, z8n = {
        Da: ZK(100),
        Dz: function(n) {
            return {
                $: 19,
                a: n
            };
        }
    }, U8n = function(n) {
        return n.a.qU;
    }, E8n = F2(function(n, r) {
        return A4(A2n, "broker", r, n, U8n);
    }), P8n = {
        Da: ZK(1500),
        Dz: function(n) {
            return {
                $: 23,
                a: n
            };
        }
    }, T8n = function(n) {
        return {
            $: 20,
            a: n
        };
    }, F8n = function(n) {
        return A2(Eu, T8n, gu(n));
    }, L8n = function(n) {
        return {
            $: 24,
            a: n
        };
    }, M8n = function(n) {
        return A2(Eu, L8n, gu(n));
    }, H8n = function(n) {
        return {
            $: 22,
            a: n
        };
    }, R8n = function(n) {
        return A2(Eu, H8n, gu(n));
    }, O8n = function(n) {
        return n.a.qU;
    }, N8n = function(n) {
        return A2(Xb, function(n) {
            return fu(n) ? Rt : Ht(n);
        }, A2(n0n, "lead", n));
    }, I8n = F2(function(n, r) {
        var t = N8n(r);
        return b("lead_source", t.$ ? n.$ ? bk : vk(k([
            b("id", hmn(O8n(n.a)))
        ])) : vk(k([
            b("id", hmn(t.a))
        ])));
    }), V8n = F3(function(n, r, t) {
        var e;
        return A2(Ot, A2(mjn, "title", n.wD), A2(Ot, b("first_name", hmn(n.qb)), A2(Ot, b("middle_name", hmn(n.sE)), A2(Ot, b("last_name", hmn(n.rt)), A2(Ot, b("suffix", hmn(n.wt)), A2(Ot, b("email", hmn(n.pt)), A2(Ot, b("phones", _jn(n.t2)), A2(Ot, b("lead_source_other", hmn(n.rz)), A2(Ot, b("google_recaptcha_token", BBn(r)), A2(Ot, A2(I8n, n.ry, t), A2(Ot, b("broker", (e = n.m$).$ ? bk : vk(k([
            b("id", hmn(U8n(e.a)))
        ]))), function(n) {
            return k(n.aj ? [
                A2(mjn, "chosen_title", n.wD),
                b("chosen_first_name", hmn(n.nm)),
                b("chosen_middle_name", hmn(n.no)),
                b("chosen_last_name", hmn(n.nn)),
                b("chosen_suffix", hmn(n.np))
            ] : [
                b("chosen_title", bk),
                b("chosen_first_name", bk),
                b("chosen_middle_name", bk),
                b("chosen_last_name", bk),
                b("chosen_suffix", bk)
            ]);
        }(n))))))))))));
    }), W8n = function(n) {
        return n.gK.m$;
    }, Z8n = function(n) {
        return n.gK.rr;
    }, X8n = function(n) {
        return n.gK.BU;
    }, G8n = function(n) {
        return 3 === n.$ ? n.a : h;
    }, J8n = function(n) {
        return ED(G8n(n));
    }, Y8n = function(n) {
        return JN(A2(XN, Hzn, n));
    }, Q8n = F3(function(n, r, t) {
        var e = t.m$;
        return yvn(eKn(n)) && i(e, Rt) && !J8n(r) ? k([
            b(8, Y8n(W8n))
        ]) : h;
    }), K8n = F2(function(n, r) {
        return A2(Q8n, n, r);
    }), n5n = function(n) {
        return n.aj && fu(n.nm) ? k([
            b(2, PI(Qhn))
        ]) : h;
    }, r5n = function(n) {
        return n.aj && fu(n.nn) ? k([
            b(3, PI(ngn))
        ]) : h;
    }, t5n = function(n) {
        return Gi(k([
            n5n(n),
            r5n(n)
        ]));
    }, e5n = F2(function(n, r) {
        for(;;){
            if (!n.b) return h;
            var t = n.b, e = (0, n.a)(r);
            if (e.b) return e;
            n = t;
        }
    }), u5n = F2(function(n, r) {
        return A2(W0n, function(r) {
            return bXn(n(r));
        }, r);
    }), a5n = F2(function(n, r) {
        return function(t) {
            var e = n(t);
            return uI(e) ? h : k([
                r(e)
            ]);
        };
    }), i5n = (gG = k([
        A2(u5n, function(n) {
            return n.pt;
        }, b(4, PI(KN))),
        A2(a5n, function(n) {
            return n.pt;
        }, function() {
            return b(4, TI(KN));
        })
    ]), function(n) {
        return A2(e5n, gG, n);
    }), c5n = A2(u5n, function(n) {
        return n.qb;
    }, b(0, JN(A2(XN, Hzn, cI)))), o5n = A2(u5n, function(n) {
        return n.rt;
    }, b(1, JN(A2(XN, YN, oI)))), f5n = function(n) {
        return !n.$ && "Other" === N4n(n.a);
    }, s5n = function(n) {
        return n.hN.rr;
    }, l5n = function(n) {
        return n.hN.ry;
    }, d5n = function(n) {
        return n.hN.BU;
    }, b5n = F2(function(n, r) {
        var t = r.ry, e = r.rz;
        return !whn(uKn(n)) && f5n(t) && tI(e) ? k([
            b(7, PI(l5n))
        ]) : h;
    }), v5n = function(n) {
        return b5n(n);
    }, m5n = F3(function(n, r, t) {
        var e, u = t.ry, a = 1 === (e = b(N8n(r), u)).a.$ && 1 === e.b.$;
        return yvn(uKn(n)) && a ? k([
            b(6, Y8n(l5n))
        ]) : h;
    }), p5n = F2(function(n, r) {
        return A2(m5n, n, r);
    }), $5n = function(n) {
        return A2(yu, function(n) {
            return b(5, n);
        }, kzn(n.t2));
    }, h5n = F3(function(n, r, t) {
        return ZN(k([
            c5n,
            o5n,
            t5n,
            i5n,
            $5n,
            A2(K8n, n, r),
            A2(p5n, n, t),
            v5n(n)
        ]));
    }), g5n = F2(function(n, r) {
        switch(n.$){
            case 0:
                return m(r, {
                    wD: n.a
                });
            case 1:
                return m(r, {
                    qb: n.a
                });
            case 2:
                return m(r, {
                    sE: n.a
                });
            case 3:
                return m(r, {
                    rt: n.a
                });
            case 4:
                return m(r, {
                    wt: n.a
                });
            case 5:
                return m(r, {
                    aj: n.a
                });
            case 6:
                return m(r, {
                    nq: n.a
                });
            case 7:
                return m(r, {
                    nm: n.a
                });
            case 8:
                return m(r, {
                    no: n.a
                });
            case 9:
                return m(r, {
                    nn: n.a
                });
            case 10:
                return m(r, {
                    np: n.a
                });
            case 11:
                return m(r, {
                    pt: n.a
                });
            case 12:
                return m(r, {
                    t2: n.a
                });
            case 13:
                return m(r, {
                    ry: n.a
                });
            case 14:
                return m(r, {
                    rz: n.a
                });
            default:
                return m(r, {
                    m$: n.a
                });
        }
    }), w5n = F2(function(n, r) {
        var t = jN(r);
        return A3(WI, g5n, d8n(A2(Nzn, n, t.nq)), r);
    }), k5n = F2(function(n, r) {
        var t = jN(r);
        return A3(WI, g5n, _8n(A2(ohn, n, t.t2)), r);
    }), x5n = F2(function(n, r) {
        var t = jN(r);
        return A3(WI, g5n, D8n(A2(Nzn, n, t.wD)), r);
    }), y5n = F5(function(n, r, t, e, u) {
        var a = A2(k5n, n, A2(w5n, n, A2(x5n, n, u))), i = A2(wI, A3(h5n, r, t, e), a);
        return i.$ ? b(i.a, !1) : b(i.a.a, !0);
    }), _5n = F2(function(n, r) {
        return YS(A2(B8n, n, r));
    }), C5n = F4(function(n, r, t, e) {
        var u = A5(y5n, !1, n, r, t, e);
        return u.b ? Rt : A2(Xb, function(n) {
            return Ht(_4n(n));
        }, Gb(A2(Tc, _5n(u.a), e8n)));
    }), D5n = function(n) {
        return n.qb;
    }, A5n = function(n) {
        return n.nm;
    }, q5n = function(n) {
        return n.nn;
    }, B5n = function(n) {
        return n.no;
    }, j5n = function(n) {
        return n.np;
    }, S5n = function(n) {
        return n.pt;
    }, z5n = function(n) {
        return n.qb;
    }, U5n = function(n) {
        return n.rt;
    }, E5n = function(n) {
        return n.sE;
    }, P5n = function(n) {
        return n.wt;
    }, T5n = F3(function(n, r, t) {
        var e, u = 1 !== (e = q5n(r)).$ && !fu(e.a), a = A2(vmn, function(n) {
            return n.wD;
        }(r), Obn("title")), i = A2(y4n, n, A2(umn, function(n) {
            return n.t2;
        }(r), A2(ivn, !0, zbn(_4n(5))))), c = A2(vmn, function(n) {
            return n.nq;
        }(r), Obn("chosen-title")), o = jN(t), f = o.ry, s = o.rz, l = o.m$, d = l.$ ? function(n) {
            return n.m$;
        }(r) : l, v = f.$ ? b(function(n) {
            return n.ry;
        }(r), A2(uc, "", function(n) {
            return n.rz;
        }(r))) : b(f, s), m = v.a, p = v.b;
        return {
            m$: d,
            nm: A2(uc, "", A5n(r)),
            nn: A2(uc, "", q5n(r)),
            no: A2(uc, "", B5n(r)),
            np: A2(uc, "", j5n(r)),
            nq: c,
            pt: A2(uc, "", S5n(r)),
            qb: z5n(r),
            aj: u,
            rt: U5n(r),
            ry: m,
            rz: p,
            sE: A2(uc, "", E5n(r)),
            t2: i,
            wt: A2(uc, "", P5n(r)),
            wD: a
        };
    }), F5n = function(n) {
        return n.qU;
    }, L5n = function(n) {
        return n.qU;
    }, M5n = function(n) {
        return n.qU;
    }, H5n = F2(function(n, r) {
        var t = n ? AI(r.x) : r.x, e = A5(y5n, n, r.fF, r.bF, r.w_.iu, r.kk), u = e.b;
        return b(m(r, {
            kk: e.a,
            x: t
        }), u);
    }), R5n = function(n) {
        switch(n.$){
            case 0:
            case 2:
            case 4:
            case 5:
            case 6:
            case 8:
            case 10:
                return Rt;
            case 1:
                return Ht(0);
            case 3:
                return Ht(1);
            case 7:
                return Ht(2);
            case 9:
                return Ht(3);
            case 11:
                return Ht(4);
            case 12:
                return Ht(5);
            case 13:
                return Ht(6);
            case 14:
                return Ht(7);
            default:
                return Ht(8);
        }
    }, O5n = F2(function(n, r) {
        var t = ac(n.w_.B9), e = function(n) {
            switch(n.$){
                case 0:
                    return "Title";
                case 1:
                    return u8n(0);
                case 2:
                    return "Middle Name";
                case 3:
                    return u8n(1);
                case 4:
                    return "Suffix";
                case 5:
                    return "Has Chosen Name";
                case 6:
                    return "Chosen Title";
                case 7:
                    return u8n(2);
                case 8:
                    return "Chosen Middle Name";
                case 9:
                    return u8n(3);
                case 10:
                    return "Chosen Suffix";
                case 11:
                    return u8n(4);
                case 12:
                    return u8n(5);
                case 13:
                    return u8n(6);
                case 14:
                    return u8n(7);
                default:
                    return u8n(8);
            }
        }(r), u = A2(H5n, !1, n).a, a = A2(Xb, function(n) {
            return A2(B8n, u.kk, n);
        }, A2(Xb, R5n, Ht(r)));
        return OQn(Ht({
            eC: A2(uc, h, A2(Cp, Gq, a)),
            p5: e,
            Cr: t
        }));
    }), N5n = function(n) {
        return n.rt;
    }, I5n = function(n) {
        return n.tk;
    }, V5n = function(n) {
        return n.u$;
    }, W5n = A2(Eu, hu, yn(function() {
        tr.location.reload(false);
    })), Z5n = {
        Da: ZK(300),
        Dz: function(n) {
            return {
                $: 21,
                a: n
            };
        }
    }, X5n = function(n) {
        return {
            $: 2,
            a: n
        };
    }, G5n = function(n) {
        return vk(k([
            b("online_enrollment", vk(n))
        ]));
    }, J5n = F6(function(n, r, t, e, u, a) {
        return A4(vN, z9(n), P4n, a, A2(xq, G5n(u), bC(A2($y, k([
            "confirm"
        ]), A2($y, k([
            e
        ]), A2(T4n, r, t))))));
    }), Y5n = function(n) {
        var r, t = 2 === (r = b(n.e6, n.cF)).a.$ ? Ht(r.a.a) : 3 === r.b.$ ? Ht(M5n(r.b.a)) : Rt;
        if (t.$) return Dp;
        var e = t.a, u = pZn(n.lj), a = $k(n.dw), i = jN(n.kk);
        return A6(J5n, n.gx, a, u, e, A3(V8n, i, n.hr, n.w_.iu), X5n);
    }, Q5n = F6(function(n, r, t, e, u, a) {
        return A4(kq, z9(n), P4n, a, A2(xq, G5n(u), bC(A2($y, k([
            e
        ]), A2(T4n, r, t)))));
    }), K5n = function(n) {
        return {
            $: 6,
            a: n
        };
    }, n7n = F4(function(n, r, t, e) {
        return A4(vN, z9(n), P4n, e, bC(A2($y, k([
            "create_debug"
        ]), A2(T4n, r, t))));
    }), r7n = F2(function(n, r) {
        return 2 === n.$ && i(n.a, "hintos") ? b(m(r, {
            g7: !0,
            uA: !0
        }), A4(n7n, r.gx, $k(r.dw), pZn(r.lj), K5n)) : b(r, Dp);
    }), t7n = F2(function(n, r) {
        switch(n.$){
            case 4:
                var t = n.a;
                n: for(;;)switch(t.$){
                    case 2:
                        if (9 === t.a.$) return v(m(r, {
                            cL: oc
                        }), Dp, A2(uA, 1, t));
                        break n;
                    case 3:
                        var e = t.a, u = (Sn = r.fV).$ ? Dp : MKn(Sn.a), a = e.oM, i = k(a ? [
                            wYn,
                            gYn
                        ] : [
                            gYn
                        ]);
                        return v(m(r, {
                            fV: Rt,
                            g7: a,
                            kk: AO(A3(T5n, r.dw, e, r.kk)),
                            u$: V5n(e),
                            cL: t
                        }), u, i);
                    default:
                        break n;
                }
                return v(m(r, {
                    cL: t
                }), Dp, A2(uA, 1, t));
            case 5:
                t = n.a;
                n: for(;;)switch(t.$){
                    case 2:
                        if (t.a.$) break n;
                        return v(m(r, {
                            cF: Mx,
                            cL: oc
                        }), A4(O4n, r.gx, $k(r.dw), pZn(r.lj), w4n), A2(uA, 1, t));
                    case 3:
                        var c = F5n(e = t.a);
                        return v(m(r, {
                            kk: AO(A3(T5n, r.dw, e, r.kk)),
                            e6: v8n(c),
                            u$: V5n(e),
                            cL: t
                        }), iZn(c), k([
                            q8n(c)
                        ]));
                    default:
                        break n;
                }
                return v(m(r, {
                    cL: t
                }), Dp, A2(uA, 1, t));
            case 0:
                return v(m(r, {
                    kk: A3(WI, g5n, gn = n.a, r.kk)
                }), A2(Eu, ru, gu(p8n(gn))), h);
            case 25:
                var o = n.a;
                return v(w = o.$ ? r : m(r, {
                    hr: Ht(o.a)
                }), Hu(k([
                    Y5n(w),
                    A4(EKn, 0, w.CX, w.fF, h)
                ])), h);
            case 26:
                var f = n.a;
                return v(3 === f.$ ? m(r, {
                    nf: Ht(f.a)
                }) : r, Dp, h);
            case 27:
                var s = n.a;
                if (3 === s.$) {
                    var l = s.a, d = A2(Cp, L5n, I5n(l));
                    if (d.$) {
                        var p = m(Cn = jN(r.kk), {
                            pt: (Bn = l, Bn.pt),
                            qb: D5n(l),
                            rt: N5n(l)
                        });
                        return v(m(r, {
                            kk: AO(p)
                        }), Dp, h);
                    }
                    var $ = d.a;
                    return v(m(r, {
                        e6: v8n($),
                        cL: Mx
                    }), A5(L4n, r.gx, $k(r.dw), pZn(r.lj), $, g4n), k([
                        q8n($)
                    ]));
                }
                return v(r, Dp, h);
            case 1:
                var g = A2(H5n, !0, r), w = g.a;
                if (g.b) return v(m(w, {
                    uA: !0
                }), pXn(0), h);
                var x = A4(C5n, w.fF, w.bF, w.w_.iu, w.kk);
                if (x.$) return v(w, Hu(S8n(w.kk)), h);
                var y = A3(mQ, Z5n, x.a, w.cM), _ = y.b, C = m(w, {
                    cM: y.a
                });
                return v(C, Hu(A2(Ot, _, S8n(C.kk))), h);
            case 2:
                t = n.a, w = m(r, {
                    uA: !1
                });
                n: for(;;)switch(t.$){
                    case 3:
                        return v(w, Dp, k([
                            x8n(F5n(t.a))
                        ]));
                    case 2:
                        if (9 === t.a.$) return v(w, W5n, A2(uA, 1, t));
                        break n;
                    default:
                        break n;
                }
                return v(w, Dp, A2(uA, 1, t));
            case 3:
                if (t = n.a, w = m(r, {
                    fi: !1
                }), 3 === t.$) {
                    var D = function() {
                        var n = b(w.cF, w.e6);
                        if (3 === n.a.$ && 1 === n.b.$) {
                            var r = M5n(n.a.a);
                            return b(m(w, {
                                e6: v8n(r)
                            }), k([
                                q8n(r)
                            ]));
                        }
                        return b(w, h);
                    }();
                    return v(D.a, Dp, E = D.b);
                }
                return v(w, Dp, A2(uA, 1, t));
            case 6:
                return 3 === (t = n.a).$ ? (c = F5n(e = t.a), v(m(r, {
                    kk: AO(A3(T5n, r.dw, e, r.kk)),
                    e6: v8n(c),
                    uA: !1,
                    u$: V5n(e),
                    cL: t
                }), Dp, k([
                    x8n(c),
                    wYn
                ]))) : v(m(r, {
                    cL: t
                }), Dp, A2(uA, 1, t));
            case 18:
                var A = n.a, q = jN(r.kk), B = A2(R$n, A, q.t2), j = B.b, S = B.c, z = _8n(B.a), U = (w = m(r, {
                    kk: A3(WI, g5n, z, r.kk)
                }), A2(uc, b(Dp, h), A2(Cp, function(n) {
                    switch(n.$){
                        case 3:
                            return b(A2(Eu, ru, gu(m8n(z))), k([
                                A2(O5n, w, z)
                            ]));
                        case 4:
                            return b(A2(Eu, ru, gu($8n(z))), k([
                                A2(O5n, w, z)
                            ]));
                        default:
                            return b(A2(Eu, ru, gu(p8n(z))), h);
                    }
                }, S))), E = (_ = U.a, U.b);
                return v(w, Hu(k([
                    A2(jp, C8n, j),
                    _
                ])), E);
            case 8:
                var P = n.a, T = jN(r.kk), F = A2(SUn, P, T.wD), L = F.b, M = F.c, H = D8n(F.a);
                return _ = function() {
                    if (M.$) return Dp;
                    switch(M.a.$){
                        case 0:
                            return A2(Eu, ru, gu(p8n(H)));
                        case 1:
                            return A2(Eu, ru, gu($8n(H)));
                        default:
                            return A2(Eu, ru, gu(m8n(H)));
                    }
                }(), v(w = m(r, {
                    kk: A3(WI, g5n, H, r.kk)
                }), Hu(k([
                    A2(jp, A8n, L),
                    _
                ])), k([
                    A2(O5n, w, H)
                ]));
            case 9:
                return v(m(r, {
                    kk: A3(WI, g5n, h8n(n.a), r.kk)
                }), Dp, h);
            case 10:
                var R = n.a, O = jN(r.kk), N = A2(SUn, R, O.nq), I = N.b, V = N.c, W = d8n(N.a);
                return _ = function() {
                    if (V.$) return Dp;
                    switch(V.a.$){
                        case 0:
                            return A2(Eu, ru, gu(p8n(W)));
                        case 1:
                            return A2(Eu, ru, gu($8n(W)));
                        default:
                            return A2(Eu, ru, gu(m8n(W)));
                    }
                }(), v(w = m(r, {
                    kk: A3(WI, g5n, W, r.kk)
                }), Hu(k([
                    A2(jp, b8n, I),
                    _
                ])), k([
                    A2(O5n, w, W)
                ]));
            case 11:
                var Z = A2(bq, n.a, r.eQ), X = Z.a, G = Z.b, J = Z.c, Y = jN(r.kk).ry, Q = A2(uc, v(r, Dp, h), A2(Cp, function(n) {
                    switch(n.$){
                        case 0:
                            var t = g8n(n.a), e = A3(WI, g5n, k8n(""), A3(WI, g5n, t, r.kk)), u = m(r, {
                                kk: e
                            });
                            return v(u, A2(Eu, ru, gu(p8n(t))), k([
                                A2(O5n, u, t)
                            ]));
                        case 1:
                            return t = g8n(Y), v(r, A2(Eu, ru, gu($8n(t))), k([
                                A2(O5n, r, t)
                            ]));
                        default:
                            return t = g8n(Y), v(r, A2(Eu, ru, gu(m8n(t))), k([
                                A2(O5n, r, t)
                            ]));
                    }
                }, J));
                return _ = Q.b, E = Q.c, v(m(w = Q.a, {
                    eQ: X
                }), Hu(k([
                    A2(jp, w8n, G),
                    _
                ])), E);
            case 12:
                var K = A2(bq, n.a, r.eg), nn = (X = K.a, G = K.b, J = K.c, jN(r.kk).m$), rn = A2(uc, v(r, Dp, h), A2(Cp, function(n) {
                    switch(n.$){
                        case 0:
                            var t = s8n(n.a), e = m(r, {
                                kk: A3(WI, g5n, t, r.kk)
                            });
                            return v(e, A2(Eu, ru, gu(p8n(t))), k([
                                A2(O5n, e, t)
                            ]));
                        case 1:
                            return t = s8n(nn), v(r, A2(Eu, ru, gu($8n(t))), k([
                                A2(O5n, r, t)
                            ]));
                        default:
                            return t = s8n(nn), v(r, A2(Eu, ru, gu(m8n(t))), k([
                                A2(O5n, r, t)
                            ]));
                    }
                }, J));
                return _ = rn.b, E = rn.c, v(m(w = rn.a, {
                    eg: X
                }), Hu(k([
                    A2(jp, l8n, G),
                    _
                ])), E);
            case 13:
                var tn = n.a;
                return v(m(r, {
                    eR: tn
                }), Dp, A2(uA, 1, tn));
            case 14:
                var en = n.a, un = 3 === en.$ ? A2(E8n, en.a, r.w_.iu) : Rt, an = un.$ ? r.kk : A3(WI, g5n, s8n(un), r.kk);
                return v(m(r, {
                    bF: en,
                    kk: an
                }), Dp, A2(uA, 1, en));
            case 15:
                var cn = A3(mQ, P8n, gn = n.a, r.c4), on = cn.b, fn = m(r, {
                    c4: cn.a
                });
                return v(w = (jn = R5n(gn)).$ ? fn : m(fn, {
                    x: A3(XI, !0, jn.a, fn.x)
                }), on, h);
            case 16:
                var sn = A3(mQ, z8n, gn = n.a, r.gE), ln = (_ = sn.b, A2(r7n, gn, m(r, {
                    gE: sn.a
                })));
                return v(w = ln.a, Hu(k([
                    ln.b,
                    _
                ])), k([
                    A2(O5n, r, gn)
                ]));
            case 17:
                return v(r, Dp, k([
                    A2(O5n, r, gn = n.a)
                ]));
            case 19:
                var dn = n.a, bn = A4(t1, z8n, KK(F8n), dn, r.gE);
                return on = bn.b, v(m(r, {
                    gE: bn.a
                }), on, h);
            case 20:
                var vn = R5n(gn = n.a);
                if (vn.$) return v(r, Dp, h);
                var mn = vn.a;
                if (A2(yI, mn, r.x)) {
                    var pn = A3(_I, !0, mn, r.x);
                    return v(m(w = A2(H5n, !1, r).a, {
                        x: pn
                    }), Dp, h);
                }
                return v(r, Dp, h);
            case 21:
                dn = n.a;
                var $n = A4(t1, Z5n, KK(R8n), dn, r.cM);
                return on = $n.b, v(m(r, {
                    cM: $n.a
                }), on, h);
            case 22:
                return v(r, qEn(n.a), h);
            case 23:
                dn = n.a;
                var hn = A4(t1, P8n, KK(M8n), dn, r.c4);
                return on = hn.b, v(m(r, {
                    c4: hn.a
                }), on, h);
            case 24:
                var gn = n.a, wn = function() {
                    var n = b(r.e6, r.cF);
                    n: for(;;)switch(n.a.$){
                        case 2:
                            return n.a.a;
                        case 1:
                            if (3 === n.b.$) return M5n(n.b.a);
                            break n;
                        default:
                            break n;
                    }
                    return "";
                }(), kn = !fu(wn) && function(n) {
                    var r = jN(n), t = !A2(gI, i5n, r).$, e = !A2(gI, c5n, r).$, u = !A2(gI, o5n, r).$, a = !Y6(thn(r.t2));
                    return e && u && (a || t);
                }(r.kk) && !r.uA, xn = b(kn, r.fi);
                if (xn.a) {
                    if (xn.b) return v(r, A2(Eu, ru, gu(p8n(gn))), h);
                    var yn = pZn(r.lj), _n = $k(r.dw), Cn = jN(r.kk), Dn = A3(V8n, Cn, r.hr, r.w_.iu);
                    return v(m(r, {
                        fi: !0
                    }), A6(Q5n, r.gx, _n, yn, wn, Dn, y8n), h);
                }
                return v(r, Dp, h);
            default:
                var An = n.a;
                if (3 === An.$) {
                    var qn = An.a;
                    return v(m(r, {
                        cF: An
                    }), iZn(M5n(qn)), h);
                }
                return v(r, Dp, A2(uA, 1, An));
        }
        var Bn, jn, Sn;
    }), e7n = function(n) {
        return n.uP;
    }, u7n = function(n) {
        return KQn(n.lj) && A2(uc, !1, A3(F0, se, A2(Xb, e7n, n.nf), Ht(0)));
    }, a7n = function(n) {
        if (KQn(n.lj)) {
            var r = n.nf;
            if (1 === r.$) return Sq;
            var t = r.a;
            return A2(Ik, k([
                Nk("checkout-item-wrap")
            ]), A2(Ot, A2(Ik, k([
                Nk("flex justify-between")
            ]), k([
                A2(PB, k([
                    bz(y1),
                    rx,
                    OL
                ]), k([
                    ad(d6n(t))
                ])),
                A2(PB, k([
                    bz(R0),
                    rx
                ]), k([
                    ad(qtn(y2n(t)))
                ]))
            ])), function(n) {
                if ("package" === n.rm) {
                    var r = A2(ue, ", ", A2(yu, function(n) {
                        return ee(n.uN) + " " + n.yk;
                    }, function(n) {
                        return n.tu;
                    }(n)));
                    return k([
                        A2(Ik, k([
                            Nk("package-item")
                        ]), k([
                            A2(PB, k([
                                bz(y1)
                            ]), k([
                                ad("Includes: " + r)
                            ]))
                        ]))
                    ]);
                }
                return h;
            }(t)));
        }
        return Sq;
    }, i7n = {
        $: 1
    }, c7n = xA("noValidate"), o7n = F3(function(n, r, t) {
        return A2(ZI, t, r) ? A2(iW, t, n) : h;
    }), f7n = F2(function(n, r) {
        return 3 === n.$ && YS(A2(E8n, n.a, r));
    }), s7n = F2(function(n, r) {
        if (whn(eKn(r.fF)) || J8n(r.bF) || A2(f7n, r.bF, r.w_.iu)) return Sq;
        var t, e = jN(r.kk).m$;
        return A2(lV, h, k([
            A2(iV, k([
                UZ(12)
            ]), k([
                A2(AW, k([
                    bW(n(Z8n)),
                    hW((t = r.fF, yvn(eKn(t))))
                ]), k([
                    A2(px, l8n, A4(AU, n, k([
                        Jz(e),
                        ZL(n(X8n)),
                        cX(r.uA)
                    ]), A2(yu, function(n) {
                        return A2(Xz, h, n);
                    }, G8n(r.bF)), r.eg))
                ])),
                A2(OW, n, A3(o7n, r.kk, r.x, 8))
            ]))
        ]));
    }), l7n = function(n) {
        return {
            $: 7,
            a: n
        };
    }, d7n = function(n) {
        return {
            $: 9,
            a: n
        };
    }, b7n = function(n) {
        return {
            $: 8,
            a: n
        };
    }, v7n = function(n) {
        return {
            $: 10,
            a: n
        };
    }, m7n = function(n) {
        return {
            $: 0,
            a: n
        };
    }, p7n = function(n) {
        return {
            $: 9,
            a: n
        };
    }, $7n = F3(function(n, r, t) {
        return A2(ZI, t, r) && A2(kW, t, n);
    }), h7n = F4(function(n, r, t, e) {
        var u = jN(t), a = u.aj, i = u.nq, c = u.nm, o = u.no, f = u.nn, s = u.np;
        return A2(Ik, k([
            Nk("mb-5 md:mb-6")
        ]), k([
            A2(lV, k([
                dV(aV)
            ]), k([
                A2(iV, k([
                    UZ(12)
                ]), k([
                    A2(QW, k([
                        ZW(a),
                        WW(p7n),
                        VW(r),
                        D1n("chosen-name-checkbox")
                    ]), k([
                        ad(n(Khn))
                    ]))
                ]))
            ])),
            A2(IZ, a, A2(lV, h, k([
                A2(iV, k([
                    GZ(2),
                    jV(k([
                        Nk("mb-4 sm:mb-0")
                    ]))
                ]), k([
                    A2(AW, k([
                        bW(n(egn)),
                        hW(XTn(i)),
                        ign
                    ]), k([
                        A2(px, b8n, A3(bgn, n, k([
                            ugn(r)
                        ]), i))
                    ]))
                ])),
                A2(iV, k([
                    UZ(3)
                ]), k([
                    A2(AW, k([
                        bW(n(Qhn)),
                        hW(!0),
                        ign,
                        UTn(_4n(2))
                    ]), k([
                        yP(k([
                            kZ(_4n(2)),
                            bP(c),
                            xZ(A2(sc, m7n, l7n)),
                            oZ(A3($7n, t, e, 2)),
                            sP(r),
                            aX("choosen-first-name"),
                            $Z(!0),
                            nX("given-name"),
                            KZ("given-name"),
                            lZ(m8n(l7n(c))),
                            dZ($8n(l7n(c)))
                        ]))
                    ]))
                ])),
                A2(iV, k([
                    UZ(3),
                    GZ(2)
                ]), k([
                    A2(AW, k([
                        bW(n(rgn)),
                        ign,
                        UTn("field-chosen-middle-name")
                    ]), k([
                        yP(k([
                            kZ("field-chosen-middle-name"),
                            bP(o),
                            xZ(A2(sc, m7n, b7n)),
                            sP(r),
                            aX("choosen-middle-name"),
                            $Z(!0),
                            nX("additional-name"),
                            KZ("additional-name"),
                            lZ(m8n(b7n(o))),
                            dZ($8n(b7n(o)))
                        ]))
                    ]))
                ])),
                A2(iV, k([
                    UZ(3)
                ]), k([
                    A2(AW, k([
                        bW(n(ngn)),
                        hW(!0),
                        ign,
                        UTn(_4n(3))
                    ]), k([
                        yP(k([
                            kZ(_4n(3)),
                            bP(f),
                            xZ(A2(sc, m7n, d7n)),
                            oZ(A3($7n, t, e, 3)),
                            sP(r),
                            aX("choosen-last-name"),
                            $Z(!0),
                            nX("family-name"),
                            KZ("family-name"),
                            lZ(m8n(d7n(f))),
                            dZ($8n(d7n(f)))
                        ]))
                    ]))
                ])),
                A2(iV, k([
                    UZ(3),
                    GZ(2)
                ]), k([
                    A2(AW, k([
                        bW(n(tgn)),
                        ign,
                        UTn("field-chosen-suffix")
                    ]), k([
                        yP(k([
                            kZ("field-chosen-suffix"),
                            bP(s),
                            xZ(A2(sc, m7n, v7n)),
                            sP(r),
                            aX("chosen-suffix"),
                            $Z(!0),
                            nX("honorific-suffix"),
                            KZ("honorific-suffix"),
                            lZ(m8n(v7n(s))),
                            dZ($8n(v7n(s)))
                        ]))
                    ]))
                ])),
                A2(iV, k([
                    GZ(3)
                ]), h),
                A2(iV, k([
                    UZ(3)
                ]), k([
                    A2(OW, n, A3(o7n, t, e, 2))
                ])),
                A2(iV, k([
                    UZ(3),
                    GZ(2)
                ]), h),
                A2(iV, k([
                    UZ(3)
                ]), k([
                    A2(OW, n, A3(o7n, t, e, 3))
                ])),
                A2(iV, k([
                    UZ(3),
                    GZ(2)
                ]), h)
            ])))
        ]));
    }), g7n = function(n) {
        return {
            $: 11,
            a: n
        };
    }, w7n = F4(function(n, r, t, e) {
        var u = jN(t).pt;
        return A2(lV, h, k([
            A2(iV, k([
                UZ(12)
            ]), k([
                A2(AW, k([
                    bW("Email"),
                    hW(!0),
                    UTn(_4n(4))
                ]), k([
                    yP(k([
                        kZ(_4n(4)),
                        bP(u),
                        lP("me@example.com"),
                        xZ(A2(sc, m7n, g7n)),
                        oZ(A3($7n, t, e, 4)),
                        sP(r),
                        aX("email"),
                        $Z(!0),
                        nX("email"),
                        KZ("email"),
                        lZ(m8n(g7n(u))),
                        dZ($8n(g7n(u))),
                        cZ(1)
                    ])),
                    A2(OW, n, A3(o7n, t, e, 4))
                ]))
            ]))
        ]));
    }), k7n = function(n) {
        return 3 === n.$ ? n.a : h;
    }, x7n = F2(function(n, r) {
        var t = jN(r.kk), e = t.ry, u = t.rz, a = f5n(e);
        if (whn(uKn(r.fF)) || ED(k7n(r.eR)) || YS(N8n(r.w_.iu))) return Sq;
        var i, c = a ? k([
            dV(aV)
        ]) : h;
        return A2(Ik, h, k([
            A2(lV, c, k([
                A2(iV, k([
                    UZ(12)
                ]), k([
                    A2(AW, k([
                        bW(n(s5n)),
                        hW((i = r.fF, yvn(uKn(i))))
                    ]), k([
                        A2(px, w8n, A4(AU, n, k([
                            Jz(e),
                            ZL(n(d5n)),
                            cX(r.uA)
                        ]), A2(yu, function(n) {
                            return A2(Xz, h, n);
                        }, k7n(r.eR)), r.eQ))
                    ])),
                    A2(OW, n, A3(o7n, r.kk, r.x, 6))
                ]))
            ])),
            A2(IZ, a, A2(lV, h, k([
                A2(iV, k([
                    UZ(12)
                ]), k([
                    yP(k([
                        kZ(_4n(7)),
                        bP(u),
                        xZ(A2(sc, m7n, k8n)),
                        oZ(A3($7n, r.kk, r.x, 7)),
                        sP(r.uA),
                        $Z(!0),
                        lZ(m8n(k8n(u))),
                        dZ($8n(k8n(u)))
                    ])),
                    A2(OW, n, A3(o7n, r.kk, r.x, 7))
                ]))
            ])))
        ]));
    }), y7n = function(n) {
        return {
            $: 1,
            a: n
        };
    }, _7n = function(n) {
        return {
            $: 3,
            a: n
        };
    }, C7n = function(n) {
        return {
            $: 2,
            a: n
        };
    }, D7n = function(n) {
        return {
            $: 4,
            a: n
        };
    }, A7n = F5(function(n, r, t, e, u) {
        var a = jN(e), i = a.wD, c = a.qb, o = a.sE, f = a.rt, s = a.wt;
        return A2(lV, k([
            jV(k([
                Nk("mb-3 md:mb-4")
            ]))
        ]), k([
            A2(iV, k([
                GZ(2),
                jV(k([
                    Nk("mb-4 sm:mb-0")
                ]))
            ]), k([
                A2(AW, k([
                    bW(n(lI)),
                    hW(XTn(i)),
                    ign
                ]), k([
                    A2(px, A8n, A3(bgn, n, k([
                        ugn(r)
                    ]), i))
                ]))
            ])),
            A2(iV, k([
                UZ(3)
            ]), k([
                A2(AW, k([
                    bW(n(cI)),
                    hW(!0),
                    ign,
                    UTn(_4n(0))
                ]), k([
                    yP(k([
                        kZ(_4n(0)),
                        bP(c),
                        xZ(A2(sc, m7n, y7n)),
                        oZ(A3($7n, e, u, 0)),
                        sP(r || t),
                        aX("first-name"),
                        $Z(!0),
                        {
                            $: 16,
                            a: !0
                        },
                        nX("given-name"),
                        KZ("given-name"),
                        lZ(m8n(y7n(c))),
                        dZ($8n(y7n(c)))
                    ]))
                ]))
            ])),
            A2(iV, k([
                UZ(3),
                GZ(2)
            ]), k([
                A2(AW, k([
                    bW(n(fI)),
                    ign,
                    UTn("field-middle-name")
                ]), k([
                    yP(k([
                        kZ("field-middle-name"),
                        bP(o),
                        xZ(A2(sc, m7n, C7n)),
                        sP(r),
                        aX("middle-name"),
                        $Z(!0),
                        nX("additional-name"),
                        KZ("additional-name"),
                        lZ(m8n(C7n(o))),
                        dZ($8n(C7n(o)))
                    ]))
                ]))
            ])),
            A2(iV, k([
                UZ(3)
            ]), k([
                A2(AW, k([
                    bW(n(oI)),
                    hW(!0),
                    ign,
                    UTn(_4n(1))
                ]), k([
                    yP(k([
                        kZ(_4n(1)),
                        bP(f),
                        xZ(A2(sc, m7n, _7n)),
                        oZ(A3($7n, e, u, 1)),
                        sP(r || t),
                        aX("last-name"),
                        $Z(!0),
                        nX("family-name"),
                        KZ("family-name"),
                        lZ(m8n(_7n(f))),
                        dZ($8n(_7n(f)))
                    ]))
                ]))
            ])),
            A2(iV, k([
                UZ(3),
                GZ(2)
            ]), k([
                A2(AW, k([
                    bW(n(sI)),
                    ign,
                    UTn("field-suffix")
                ]), k([
                    yP(k([
                        kZ("field-suffix"),
                        bP(s),
                        xZ(A2(sc, m7n, D7n)),
                        sP(r || t),
                        aX("suffix"),
                        $Z(!0),
                        nX("honorific-suffix"),
                        KZ("honorific-suffix"),
                        lZ(m8n(D7n(s))),
                        dZ($8n(D7n(s)))
                    ]))
                ]))
            ])),
            A2(iV, k([
                GZ(2)
            ]), h),
            A2(iV, k([
                UZ(3)
            ]), k([
                A2(OW, n, A3(o7n, e, u, 0))
            ])),
            A2(iV, k([
                UZ(3),
                GZ(2)
            ]), h),
            A2(iV, k([
                UZ(3)
            ]), k([
                A2(OW, n, A3(o7n, e, u, 1))
            ])),
            A2(iV, k([
                UZ(3),
                GZ(2)
            ]), h)
        ]));
    }), q7n = F3(function(n, r, t) {
        var e = jN(t).t2;
        return A2(lV, h, k([
            A2(iV, k([
                UZ(12)
            ]), k([
                A2(AW, k([
                    bW(n($O)),
                    hW(e.vd)
                ]), k([
                    A2(px, C8n, A3(okn, n, k([
                        Kwn(r)
                    ]), e))
                ]))
            ]))
        ]));
    }), B7n = F2(function(n, r) {
        var t = A4(x1n, n, r.lj, r.CX, r.w_.B9), e = 2 !== r.e6.$;
        return A2(wxn, k([
            Nk("mx-1"),
            c7n(!0),
            yxn(i7n)
        ]), k([
            A5(A7n, n, r.uA, r.u$, r.kk, r.x),
            A4(h7n, n, r.uA, r.kk, r.x),
            A4(w7n, n, r.uA, r.kk, r.x),
            A3(q7n, n, r.uA, r.kk),
            A2(x7n, n, r),
            A2(s7n, n, r),
            A4(H1n, t, r.uA, e, i7n)
        ]));
    }), j7n = function(n) {
        return n.xt;
    }, S7n = F2(function(n, r) {
        return KQn(r.lj) ? A2(mx, k([
            LS(Iun),
            LS(aV)
        ]), k([
            ad(n(j7n))
        ])) : Sq;
    }), z7n = F2(function(n, r) {
        return r.B8(n);
    }), U7n = F3(function(n, r, t) {
        return A2(t.v0, n, r);
    }), E7n = F2(function(n, r) {
        return r.v1(n);
    }), P7n = F2(function(n, r) {
        if (KQn(r.lj)) {
            var t = r.nf;
            return 1 === t.$ ? Sq : ad(n(z7n(d6n(t.a))));
        }
        return ad(n(function() {
            var n = function(n) {
                return n.nO;
            }(r.lj);
            if (n.$) return E7n(hk(r.dw));
            var t = n.a;
            return A2(U7n, hk(r.dw), t);
        }()));
    }), T7n = F2(function(n, r) {
        return k([
            A2(Ik, k([
                Nk("flex justify-center w-full")
            ]), k([
                A2(Ik, k([
                    Nk("flex-col w-full md:w-4/5 lg:w-3/5")
                ]), k([
                    A2(XT, k([
                        jX,
                        LS(q3),
                        A2(_1n, 1, p1n),
                        bz(gz),
                        A2(m1n, 1, wF)
                    ]), k([
                        A2(P7n, n, r)
                    ])),
                    a7n(r),
                    A2(S7n, n, r),
                    A2(B7n, n, r)
                ]))
            ]))
        ]);
    }), F7n = F2(function(n, r) {
        return {
            gF: function() {
                var t;
                switch(r.cL.$){
                    case 1:
                        return Yk;
                    case 2:
                        return k([
                            l4n(r.dw)
                        ]);
                    default:
                        return u7n(r) ? k([
                            (t = r.dw, A2(Ik, k([
                                Nk("panel w-full signup-out-of-stock-error")
                            ]), k([
                                A2(mx, h, k([
                                    ad("This item is not currently available for sale")
                                ])),
                                gx,
                                A2(hx, h, k([
                                    ad("Please contact us and let us know the item you would like to purchase at "),
                                    oZn(kF(t)),
                                    A2(cZn, lk(t), kF(t))
                                ]))
                            ])))
                        ]) : A2(T7n, n, r);
                }
            }(),
            wD: u7n(r) ? "Out of Stock" : hk(r.dw)
        };
    }), L7n = sZn({
        zO: i8n,
        Ab: c8n,
        Ct: o8n,
        Dd: function() {
            return sXn(f8n);
        },
        DB: t7n,
        DH: F7n
    }), M7n = function(n) {
        return {
            $: 13,
            a: n
        };
    }, H7n = function(n) {
        return {
            $: 14,
            a: n
        };
    }, R7n = function(n) {
        return {
            $: 7,
            a: n
        };
    }, O7n = "custom-details-container", N7n = k([
        0,
        1
    ]), I7n = function(n) {
        return n ? "Uses Tobacco" : "Forms";
    }, V7n = {
        l7: Rt,
        cw: h,
        r5: Rt,
        sS: Rt,
        w4: !1,
        x: A2(jO, N7n, I7n)
    }, W7n = F4(function(n, r, t, e) {
        var u = GIn(r), a = oYn(t), i = function() {
            var r = r0n(e.iu);
            if (r.$) return Dp;
            var u = r.a;
            return A4(U2n, t.gx, $k(n), u, M7n);
        }(), c = lDn(t), o = c.a, f = c.b, s = function() {
            var r = b(a, t.CX);
            if (3 === r.b.$) {
                if (r.a.$) return v(h, oc, c = r.b.a);
                var e = r.a.a, c = r.b.a;
                return v(k([
                    A5(FQn, t.gx, $k(n), pZn(u), e, R7n),
                    i,
                    A2(jp, H7n, f)
                ]), Mx, c);
            }
            return v(h, oc, h);
        }(), l = s.a, d = s.b, m = s.c;
        return b({
            fV: ZJn(t),
            gx: t.gx,
            mS: Rt,
            oh: Rt,
            g6: VJ,
            g7: t.g7,
            ar: o,
            kj: t.kj,
            kk: AO(V7n),
            Av: Mx,
            e6: a,
            h5: Mx,
            dw: n,
            uA: !1,
            fl: Rt,
            fm: Rt,
            cL: d,
            cR: A3(i0n, Rk(t.kj), O7n, d0n(n)),
            lj: u,
            b9: oc,
            fF: r,
            CX: m,
            bB: vqn,
            w_: e
        }, Hu(l));
    }), Z7n = F2(function(n, r) {
        return b(r, Dp);
    }), X7n = F2(function(n, r) {
        return r;
    }), G7n = function(n) {
        return {
            $: 8,
            a: n
        };
    }, J7n = function(n) {
        return {
            $: 10,
            a: n
        };
    }, Y7n = function(n) {
        return {
            $: 9,
            a: n
        };
    }, Q7n = Kn("onTabSelected", w$), K7n = {
        $: 10
    }, nnr = function(n) {
        return {
            $: 3,
            a: n
        };
    }, rnr = F2(function(n, r) {
        return {
            $: 1,
            a: n,
            b: r
        };
    }), tnr = F2(function(n, r) {
        return {
            $: 12,
            a: n,
            b: r
        };
    }), enr = function(n) {
        return {
            $: 11,
            a: n
        };
    }, unr = function(n) {
        return {
            $: 2,
            a: n
        };
    }, anr = F3(function(n, r, t) {
        return {
            $: 9,
            a: n,
            b: r,
            c: t
        };
    }), inr = {
        $: 0
    }, cnr = function(n) {
        return {
            $: 11,
            a: n
        };
    }, onr = function(n) {
        return {
            $: 15,
            a: n
        };
    }, fnr = {
        Da: ZK(300),
        Dz: function(n) {
            return {
                $: 4,
                a: n
            };
        }
    }, snr = function(n) {
        return {
            $: 5,
            a: n
        };
    }, lnr = function(n) {
        return A2(Eu, snr, gu(n));
    }, dnr = function(n) {
        return n.qU;
    }, bnr = F2(function(n, r) {
        var t = n.cL;
        return 3 === t.$ ? Gb(A2(Tc, function(n) {
            return i(dnr(n), r);
        }, t.a)) : Rt;
    }), vnr = function(n) {
        var r = b(Sqn(n.dw), A2(Xb, e3n, n.mS));
        return !(!r.a || r.b.$) && function(n) {
            return n.pd;
        }(r.b.a);
    }, mnr = function(n) {
        return n.rp;
    }, pnr = function(n) {
        var r = n.b9;
        return 3 === r.$ && !ED(r.a);
    }, $nr = function(n) {
        return function(n) {
            return n.qU;
        }(n.kk);
    }, hnr = function(n) {
        return n.qm;
    }, gnr = F2(function(n, r) {
        return Gb(A2(Tc, function(n) {
            return i($nr(n), QBn(r));
        }, hnr(n)));
    }), wnr = function(n) {
        return function(n) {
            return n.qU;
        }(n.qi);
    }, knr = function(n) {
        return n.ql;
    }, xnr = F2(function(n, r) {
        return A2(Tc, function(r) {
            return i(wnr(r), lSn(n));
        }, knr(r));
    }), ynr = F3(function(n, r, t) {
        var e = A2(uc, h, A2(Cp, xnr(t), A2(gnr, n, r)));
        return zPn(t) && ED(e);
    }), _nr = F2(function(n, r) {
        return A2(Tc, A2(ynr, n, r), BPn(r));
    }), Cnr = F2(function(n, r) {
        var t = n.b9;
        if (3 === t.$) {
            var e = t.a;
            return pnr(n) && !ED(Gi(A2(yu, _nr(r), e)));
        }
        return !1;
    }), Dnr = F2(function(n, r) {
        return A2(UP, function(n) {
            return i(dnr(n), r);
        }, n);
    }), Anr = F2(function(n, r) {
        return 3 === n.$ && i(A2(Dnr, n.a, r), Ht(0));
    }), qnr = function(n) {
        return n.tr;
    }, Bnr = function(n) {
        var r = n.h5;
        return 3 === r.$ && qnr(r.a);
    }, jnr = F2(function(n, r) {
        if (Bnr(n) && A2(Anr, n.cL, dnr(r))) return !1;
        var t = mnr(r);
        return vnr(n) && function(n) {
            return $H(n);
        }(t) || A2(Cnr, n, r);
    }), Snr = F2(function(n, r) {
        return Gb(A2(Tc, jnr(n), r));
    }), znr = function(n) {
        return n.l7;
    }, Unr = function(n) {
        return n.ml;
    }, Enr = function(n) {
        return n.m_;
    }, Pnr = function(n) {
        return n.qU;
    }, Tnr = F2(function(n, r) {
        return A2(yu, function(t) {
            var e = A2(Cp, Pnr, r), u = lSn(t), a = A2(Tc, function(n) {
                return i(wnr(n), u);
            }, A2(uc, h, A2(Cp, knr, r))), c = QBn(n);
            return {
                ml: function() {
                    var n;
                    switch(UPn(t)){
                        case 2:
                            return n = A2(uc, !1, A2(Xb, Enr, Gb(a))), $Sn(n);
                        case 0:
                            return function(n) {
                                return kSn(n);
                            }(A2(uc, "", A2(Xb, Unr, Gb(a))));
                        default:
                            return sSn(A2(Ep, Unr, a));
                    }
                }(),
                kl: c,
                df: u,
                km: e
            };
        }, BPn(n));
    }), Fnr = F2(function(n, r) {
        var t = Gb(A2(Tc, function(n) {
            return i($nr(n), QBn(r.ag));
        }, n));
        return m(r, {
            S: A2(Tnr, r.ag, t)
        });
    }), Lnr = F2(function(n, r) {
        return A2(yu, function(n) {
            var t = "input-" + QBn(n);
            return A2(Fnr, hnr(r), A2(KBn, t, n));
        }, n);
    }), Mnr = function(n) {
        return n.sS;
    }, Hnr = function(n) {
        return n.w4;
    }, Rnr = F2(function(n, r) {
        return {
            l7: znr(r),
            cw: A2(Lnr, n, r),
            r5: Ht(dnr(r)),
            sS: Mnr(r),
            w4: Hnr(r),
            x: A2(jO, N7n, I7n)
        };
    }), Onr = F2(function(n, r) {
        return A2(uc, V7n, A2(Cp, Rnr(n), r));
    }), Nnr = function(n) {
        return n.$ ? 1 : 0;
    }, Inr = F2(function(n, r) {
        var t = Nnr(n), e = m(r, {
            x: A3(XI, !0, t, r.x)
        });
        return m(e, n.$ ? {
            w4: n.a
        } : {
            cw: n.a
        });
    }), Vnr = F2(function(n, r) {
        var t = Gb(we(n));
        return !t.$ && i(dnr(t.a), r);
    }), Wnr = F3(function(n, r, t) {
        return A2(Xb, function(t) {
            return A2(tjn, t + r, n);
        }, A2(Dnr, n, t));
    }), Znr = F2(function(n, r) {
        return A3(Wnr, n, 1, r);
    }), Xnr = F2(function(n, r) {
        var t = A2(bnr, r, n);
        if (t.$) return v(r, Dp, h);
        var e, u = t.a, a = 3 === (e = r.b9).$ ? e.a : h;
        return v(m(r, {
            kk: AO(A2(Rnr, a, u))
        }), Wjn(dnr(u)), h);
    }), Gnr = F3(function(n, r, t) {
        return A2(ZI, t, r) ? A2(iW, t, n) : h;
    }), Jnr = F3(function(n, r, t) {
        return A2(yu, function(n) {
            return b(t, n);
        }, A3(Gnr, n, r, t));
    }), Ynr = function(n) {
        var r = jN(n);
        return Gi(A2(yu, A2(Jnr, n, r.x), N7n));
    }, Qnr = F3(function(n, r, t) {
        return A2(Xb, function(n) {
            return Ht(A2(ue, ": ", k([
                n ? "Dependent " + ee(n) : "Owner",
                r
            ])));
        }, A2(Dnr, t, n));
    }), Knr = F2(function(n, r) {
        var t = jN(n.kk), e = b(n.cL, t.r5);
        if (3 !== e.a.$ || e.b.$) return h;
        var u = e.a.a;
        return A2(uc, h, A2(Cp, function(r) {
            var t = ac(n.w_.B9), e = A2(Cp, Ac, Gb(Ynr(n.kk)));
            return k([
                OQn(Ht({
                    eC: A2(uc, h, A2(Cp, Gq, e)),
                    p5: r,
                    Cr: t
                }))
            ]);
        }, A3(Qnr, e.b.a, function(n) {
            return I7n(Nnr(n));
        }(r), u)));
    }), nrr = F2(function(n, r) {
        return A2($y, k([
            "online_enrollments",
            r,
            "forms"
        ]), gy(n));
    }), rrr = F4(function(n, r, t, e) {
        return A4(dC, z9(n), Ey(nbn), e, bC(A2(nrr, r, t)));
    }), trr = F6(function(n, r, t, e, u, a) {
        return {
            l7: t,
            qm: u,
            qU: n,
            rp: e,
            sS: r,
            w4: a
        };
    }), err = F3(function(n, r, t) {
        return {
            kk: r,
            ql: t,
            qU: n
        };
    }), urr = F3(function(n, r, t) {
        return {
            ml: r,
            m_: t,
            qi: n
        };
    }), arr = A3(zy, "id", w$, Ke(function(n) {
        return {
            qU: n
        };
    })), irr = A2(qy, arr, Ke(ru)), crr = A3(zy, "boolean_answer", l_(xy), A3(zy, "answer", l_(w$), A3(zy, "form_item", irr, Ke(urr)))), orr = A2(qy, crr, Ke(ru)), frr = A3(zy, "id", w$, Ke(function(n) {
        return {
            qU: n
        };
    })), srr = A2(qy, frr, Ke(ru)), lrr = A3(zy, "form_response_items", Ey(orr), A3(zy, "form", srr, A3(zy, "id", w$, Ke(err)))), drr = A2(qy, lrr, Ke(ru)), brr = A3(zy, "uses_tobacco", xy, A3(zy, "form_responses", Ey(drr), A3(zy, "known_practice", l_(MC), A3(zy, "age", l_(C$), A3(zy, "name", l_(w$), A3(zy, "id", w$, Ke(trr))))))), vrr = A2(qy, brr, Ke(ru)), mrr = F2(function(n, r) {
        return A2($y, k([
            "online_enrollments",
            r,
            "custom_details"
        ]), gy(n));
    }), prr = F4(function(n, r, t, e) {
        return A4(dC, z9(n), Ey(vrr), e, bC(A2(mrr, r, t)));
    }), $rr = F2(function(n, r) {
        return {
            n1: r,
            qU: n
        };
    }), hrr = function(n) {
        return A2(uc, Sq, A2(Cp, function(n) {
            return A2(PB, k([
                Qk(k([
                    Nk("tabs-member-age")
                ]))
            ]), k([
                ad(" (" + ee(n) + "y/o)")
            ]));
        }, n));
    }, grr = function(n) {
        return A2(uc, Sq, A2(Cp, function(n) {
            return A2(PB, k([
                Qk(k([
                    Nk("tabs-member-name")
                ]))
            ]), k([
                ad(n)
            ]));
        }, n));
    }, wrr = F2(function(n, r) {
        return A2(Ik, h, k([
            grr(n),
            hrr(r)
        ]));
    }), krr = F3(function(n, r, t) {
        return A2(TD, A2($rr, n, A2(wrr, r, t)), {
            dW: function(n) {
                return n.qU;
            },
            dY: function(n) {
                return n.n1;
            }
        });
    }), xrr = function(n) {
        return A3(krr, dnr(n), Mnr(n), znr(n));
    }, yrr = function(n) {
        var r = A2(Xb, e3n, n.mS);
        if (r.$) return !1;
        var t = r.a;
        return sKn(n.fF) && YS(function(n) {
            return n.wI;
        }(t));
    }, _rr = function(n) {
        if (pnr(n)) {
            var r = jN(n.kk);
            return k([
                b("form_responses", A2(wq, Fjn, r.cw))
            ]);
        }
        return h;
    }, Crr = function(n) {
        return vnr(n) ? k([
            zjn(n.ar)
        ]) : h;
    }, Drr = function(n) {
        if (yrr(n)) {
            var r = zBn(n.bB);
            return k([
                b("uses_tobacco", kA(r))
            ]);
        }
        return h;
    }, Arr = function(n) {
        return Gi(k([
            Crr(n),
            _rr(n),
            Drr(n)
        ]));
    }, qrr = "custom-forms", Brr = function(n) {
        return qEn(n ? "tobacco-use" : qrr);
    }, jrr = F6(function(n, r, t, e, u, a) {
        return A4(kq, z9(n), vrr, a, A2(xq, function(n) {
            return vk(k([
                b("member", vk(n))
            ]));
        }(u), bC(A2($y, k([
            e
        ]), A2(mrr, r, t)))));
    }), Srr = function(n) {
        return n.qh.qX;
    }, zrr = F2(function(n, r) {
        var t = A2(W$n, function(n) {
            return function(n) {
                return ED(function(n) {
                    return A2(Ep, LPn(n.S), BPn(n.ag));
                }(n));
            }(n);
        }, r.cw);
        return pnr(n) && !t ? k([
            b(0, JN(Srr))
        ]) : h;
    }), Urr = F2(function(n, r) {
        if (vnr(r)) {
            var t = A2(iSn, n, r.ar);
            return b(t.a, t.b);
        }
        return b(r.ar, !0);
    }), Err = F2(function(n, r) {
        var t = jN(r.kk), e = function() {
            if (n) {
                var e = m(t, {
                    x: n ? AI(t.x) : t.x
                });
                return m(r, {
                    kk: A2(nNn, e, r.kk)
                });
            }
            return r;
        }(), u = function(n) {
            var r = A2(wI, function(n) {
                return ZN(k([
                    zrr(n)
                ]));
            }(n), n.kk);
            return r.$ ? b(r.a, !1) : b(r.a.a, !0);
        }(e), a = u.a, i = u.b, c = A2(Urr, n, r), o = c.b;
        return b(m(e, {
            ar: c.a,
            kk: a
        }), i && o);
    }), Prr = F5(function(n, r, t, e, u) {
        if (Bnr(u) && A2(Anr, u.cL, r)) return v(!1, u, k([
            A2(Eu, ru, gu(unr(e)))
        ]));
        if (c = jN(u.kk).x, A2(sA, function(n) {
            return A2(yI, n, c);
        }, N7n) || $H(e)) {
            var a = A2(Err, !0, u), i = a.a;
            return a.b ? v(!1, m(i, {
                uA: !0
            }), k([
                A6(jrr, i.gx, $k(i.dw), n, r, Arr(i), t(e))
            ])) : v(!0, i, A2(Ot, A2(uc, Dp, A2(Cp, Brr, function(n) {
                return A2(Cp, Ne, Gb(Ynr(n)));
            }(i.kk))), function(n) {
                var r = b(jN(n.kk).r5, n.cL);
                if (r.a.$ || 3 !== r.b.$) return h;
                var t = r.a.a, e = r.b.a;
                return A2(yu, function(n) {
                    var r = n.b, u = A3(Qnr, t, I7n(n.a), e);
                    if (u.$) return Dp;
                    var a = u.a;
                    return FYn({
                        eC: k([
                            r
                        ]),
                        p5: a
                    });
                }, Ynr(n.kk));
            }(i)));
        }
        var c;
        return v(!1, u, k([
            A2(Eu, ru, gu(unr(e)))
        ]));
    }), Trr = function(n) {
        return {
            $: 16,
            a: n
        };
    }, Frr = function(n) {
        return {
            $: 6,
            a: n
        };
    }, Lrr = function(n) {
        return A2(n0n, "billing_period", n);
    }, Mrr = function(n) {
        return n.gW;
    }, Hrr = F3(function(n, r, t) {
        return t.$ ? h : k([
            b(n, r(t.a))
        ]);
    }), Rrr = function(n) {
        var r = A2(Ot, b("members", n.y6), A2(uc, h, A2(Cp, function(n) {
            return k([
                W3n(n)
            ]);
        }, n.mS))), t = A2(Xb, function(n) {
            var r = A2(Hp, function(n) {
                switch(n){
                    case "monthly":
                        return Ke(0);
                    case "quarterly":
                        return Ke(1);
                    case "semi_annually":
                        return Ke(2);
                    case "annually":
                        return Ke(3);
                    default:
                        return yy("Unsupported period name: " + n);
                }
            }(n), "{}");
            return r.$ ? Rt : Ht(r.a);
        }, n.x4), e = $(A3(Hrr, "coupon_code", function(n) {
            return hmn(Mrr(n));
        }, n.oh), A3(Hrr, "period_in_months", function(n) {
            return hq(mA(n));
        }, t));
        return vk($(r, e));
    }, Orr = function(n) {
        var r = n;
        return vk(k([
            b("name", hmn(r.sS)),
            b("dob", jBn(r.o2)),
            b("relationship", qBn(r.u5)),
            b("uses_tobacco", kA(r.w4))
        ]));
    }, Nrr = function(n) {
        return n.qU;
    }, Irr = F3(function(n, r, t) {
        var e = zBn(t.bB), u = jN(t.kk).r5;
        if (i(Ht(Nrr(n)), u)) return A3(X3n, n, k([
            b("uses_tobacco", kA(e))
        ]), h);
        var a = A2(zD, function(r) {
            return i(dnr(r), Nrr(n));
        }, r);
        return a.$ ? Orr(n) : A3(X3n, n, k([
            b("uses_tobacco", kA(Hnr(a.a)))
        ]), h);
    }), Vrr = F2(function(n, r) {
        var t = v(r.cL, r.mS, O3n(r.lj));
        if (3 === t.a.$ && !t.b.$ && t.c) {
            var e = t.a.a, u = t.b.a, a = A2(wq, function(n) {
                return A3(Irr, n, e, r);
            }, J3n(n)), i = Rrr({
                x4: Lrr(r.w_.iu),
                mS: Ht(u),
                oh: r.oh,
                y6: a
            });
            return A4(GBn, r.gx, $k(r.dw), i, Frr);
        }
        return Dp;
    }), Wrr = function(n) {
        var r = n.h5;
        if (3 === r.$) {
            var t = r.a;
            return nKn(n.lj) ? A2(Vrr, t, n) : A4(I3n, n.gx, $k(n.dw), x2n(t), Trr);
        }
        return Dp;
    }, Zrr = F2(function(n, r) {
        return m(n, {
            w4: r
        });
    }), Xrr = F2(function(n, r) {
        switch(n.$){
            case 7:
                var t = n.a, e = m(r, {
                    h5: t
                });
                if (3 === t.$) {
                    var u = t.a, a = (hn = r.fV).$ ? Dp : MKn(hn.a), c = $k(r.dw), o = x2n(u), f = ZYn(u), s = k(f ? [
                        DYn(GKn(u)),
                        wYn,
                        gYn
                    ] : [
                        DYn(GKn(u)),
                        gYn
                    ]);
                    return v(m(e, {
                        fV: Rt,
                        mS: Ht(F0n(u)),
                        g7: f
                    }), Hu(k([
                        A4(prr, r.gx, c, o, nnr),
                        A4(rrr, r.gx, c, o, enr),
                        a
                    ])), s);
                }
                return v(e, Dp, A2(uA, 1, t));
            case 3:
                if (e = m(r, {
                    cL: C = n.a
                }), 3 === C.$) {
                    var l = C.a, d = A2(Zrr, r.bB, function(n) {
                        var r = b(yrr(n), n.cL);
                        if (r.a && 3 === r.b.$) {
                            var t = Gb(r.b.a);
                            return !t.$ && Hnr(t.a);
                        }
                        return !1;
                    }(e)), p = function(n) {
                        var r = b(vnr(n), n.cL);
                        return r.a && 3 === r.b.$ ? A2(Xb, mnr, Gb(r.b.a)) : Rt;
                    }(e), $ = p.$ ? r.ar : A2(nPn, r.ar, p.a), g = 3 === ($n = r.h5).$ && A4(ZKn, r.lj, r.CX, GKn($n.a), r.w_.B9), w = 3 === (pn = e.b9).$ ? pn.a : h, x = g ? A2(z$, A2(Snr, e, l), function(n) {
                        return Gb(we(n));
                    }(l)) : Gb(l), y = oe(l) > 1 ? k([
                        A3(anr, A2(yu, xrr, l), A2(uc, "", A2(Cp, dnr, x)), !0)
                    ]) : h;
                    return v(m(e, {
                        ar: $,
                        kk: AO(A2(Onr, w, x)),
                        bB: d
                    }), Hu(k([
                        Wrr(e),
                        A4(TKn, 4, e.CX, e.fF, h)
                    ])), y);
                }
                return v(r, Dp, A2(uA, 1, C));
            case 1:
                var _ = n.a, C = n.b;
                if (e = m(r, {
                    uA: !1
                }), 3 === C.$) {
                    var D = C.a, A = function() {
                        var n = r.cL;
                        if (3 === n.$) {
                            var t = n.b;
                            return A2(f_, A2(yu, function(n) {
                                return i(dnr(n), dnr(D)) ? D : n;
                            }, n.a), t);
                        }
                        return r.cL;
                    }();
                    return v(m(e, {
                        cL: A
                    }), A2(Eu, ru, gu(unr(_))), h);
                }
                return v(e, Dp, A2(uA, 1, C));
            case 0:
                var q = jN(r.kk), B = b(r.e6, q.r5);
                if (B.a.$ || B.b.$) return v(r, Dp, h);
                var j = A5(Prr, o = B.a.a, W = B.b.a, rnr, Rt, r);
                return v(X = j.b, Hu(G = j.c), h);
            case 4:
                var S = n.a, z = A4(t1, fnr, KK(lnr), S, r.g6), U = z.b;
                return v(m(r, {
                    g6: z.a
                }), U, h);
            case 5:
                return v(r, qEn(n.a), h);
            case 6:
                var E = n.a;
                n: for(;;)switch(E.$){
                    case 3:
                        return v(m(r, {
                            fl: Ht(E.a),
                            fm: Rt
                        }), Dp, h);
                    case 2:
                        if (5 === E.a.$) {
                            var P = Ht(WGn(k([
                                KD(n3n(E.a.b))
                            ])));
                            return v(m(r, {
                                fm: P
                            }), Dp, h);
                        }
                        break n;
                    default:
                        break n;
                }
                return v(r, Dp, A2(uA, 1, E));
            case 8:
                var T = A2(M3n, n.a, r.cR), F = T.a, L = T.b, M = T.c, H = M.$ || M.a ? Dp : A2(Eu, ru, gu(inr));
                return v(m(r, {
                    cR: F
                }), Hu(k([
                    A2(jp, G7n, L),
                    H
                ])), h);
            case 9:
                var R = A2(uc, Ru, A2(Xb, function(n) {
                    return ec(n);
                }, $u(n.a))), O = A2(uc, Ru, ec(r.w_.B9));
                return v(r, A4(HQn, r.lj, r.CX, O, R) ? A2(HKn, O, R) : Dp, k([
                    K7n
                ]));
            case 10:
                var N = n.a, I = jN(r.kk), V = b(r.e6, I.r5);
                if (V.a.$ || V.b.$) return v(r, Dp, h);
                var W, Z = A5(Prr, o = V.a.a, W = V.b.a, rnr, Ht(N), r), X = Z.b, G = Z.c;
                return y = Z.a ? k([
                    cnr(W)
                ]) : h, v(X, Hu(G), y);
            case 11:
                var J = n.a;
                if (e = m(r, {
                    b9: J
                }), 3 === J.$) {
                    var Y = J.a, Q = jN(r.kk);
                    return v(m(e, {
                        kk: AO(A2(Onr, Y, x = A2(bnr, r, A2(uc, "", Q.r5))))
                    }), Dp, h);
                }
                return v(r, Dp, A2(uA, 1, J));
            case 12:
                var K = n.a, nn = n.b, rn = jN(r.kk).cw, tn = A2(ySn, nn, K), en = tn.a, un = tn.b, an = function(n) {
                    return {
                        $: 0,
                        a: n
                    };
                }(A3(J9, function(n) {
                    return i(ujn(n), ujn(en));
                }, function() {
                    return en;
                }, rn));
                return v(e = m(r, {
                    kk: A3(WI, Inr, an, r.kk)
                }), A2(jp, tnr(en), un), A2(Knr, e, an));
            case 2:
                var cn = n.a;
                return cn.$ ? function(n) {
                    var r = v(jN(n.kk).r5, n.cL, n.b9);
                    if (r.a.$ || 3 !== r.b.$ || 3 !== r.c.$) return v(n, Dp, h);
                    var t = r.a.a, e = r.b.a, u = r.c.a;
                    if (A2(Vnr, e, t)) return v(n, A4(EKn, 4, n.CX, n.fF, h), k([
                        _Yn
                    ]));
                    var a = A2(Znr, e, t);
                    if (a.$) return v(n, Dp, h);
                    var i = a.a;
                    return v(m(n, {
                        kk: AO(A2(Rnr, u, i))
                    }), Wjn(dnr(i)), k([
                        cnr(dnr(i))
                    ]));
                }(r) : A2(Xnr, cn.a, r);
            case 13:
                var on = n.a;
                return 3 === on.$ ? v(e = m(r, {
                    oh: Ht(on.a)
                }), Wrr(e), h) : v(r, Dp, A2(uA, 1, on));
            case 14:
                var fn = A2(fSn, n.a, r.ar), sn = fn.b;
                return v(m(r, {
                    ar: fn.a
                }), A2(jp, H7n, sn), h);
            case 15:
                var ln = A2(DEn, n.a, r.bB), dn = (sn = ln.b, ln.c), bn = (e = m(r, {
                    bB: ln.a
                }), function() {
                    if (dn.$) return b(Dp, h);
                    var n = dn.a;
                    return b(Wrr(e), A2(Knr, e, function(n) {
                        return {
                            $: 1,
                            a: n
                        };
                    }(n)));
                }()), vn = bn.a, mn = bn.b;
                return v(e, Hu(k([
                    A2(jp, onr, sn),
                    vn
                ])), mn);
            default:
                return v(m(r, {
                    Av: n.a
                }), Dp, h);
        }
        var pn, $n, hn;
    }), Grr = function(n) {
        return {
            $: 0,
            a: n
        };
    }, Jrr = F4(function(n, r, t, e) {
        return b(ujn(e), A2(px, tnr(e), A3(nTn, n, k([
            Grr(r),
            qPn(t)
        ]), e)));
    }), Yrr = F3(function(n, r, t) {
        if (pnr(t)) {
            var e = jN(t.kk), u = e.cw, a = A2(ZI, 0, e.x);
            return A3($U, "div", k([
                jz(qrr)
            ]), A2(yu, A3(Jrr, n, r, a), u));
        }
        return Sq;
    }), Qrr = F2(function(n, r) {
        return vnr(r) ? A2(Ik, h, k([
            A2(px, H7n, A2(lTn, n, r.ar))
        ])) : Sq;
    }), Krr = F3(function(n, r, t) {
        return yrr(t) ? A2(Ik, h, k([
            A2(Ik, h, k([
                A2(px, onr, A3(hTn, n, r, t.bB))
            ]))
        ])) : Sq;
    }), ntr = F3(function(n, r, t) {
        if (Bnr(t) && function(n) {
            var r = jN(n.kk).r5;
            return !r.$ && A2(Anr, n.cL, r.a);
        }(t)) {
            var e = jN(t.kk).sS;
            return A2(hx, h, k([
                ad("No details need to be completed" + (e.$ ? "" : " for " + e.a) + ".")
            ]));
        }
        return A2(Ik, k([
            Nk("custom-details")
        ]), k([
            A2(Qrr, n, t),
            A3(Yrr, n, r, t),
            A3(Krr, n, r, t)
        ]));
    }), rtr = F3(function(n, r, t) {
        return A2(Ik, k([
            jz(O7n),
            Nk("flex-grow")
        ]), k([
            A3(ntr, n, r, t)
        ]));
    }), ttr = F5(function(n, r, t, e, u) {
        return r ? A4(x1n, n, t, e, u) : "Update next member";
    }), etr = F3(function(n, r, t) {
        var e = b(jN(r.kk).r5, r.cL);
        if (e.a.$ || 3 !== e.b.$) return t;
        var u = e.a.a, a = A2(uc, !1, A2(Cp, function(n) {
            return i(dnr(n), u);
        }, Gb(we(e.b.a))));
        return A2(n6n, A5(ttr, n, a, r.lj, r.CX, r.w_.B9), t);
    }), utr = F2(function(n, r) {
        return A2(Ot, function(n) {
            return {
                $: 2,
                a: n
            };
        }(n), r);
    }), atr = F2(function(n, r) {
        return (O3n(r.lj) ? t6n(r.fl) : Q9n(W9n(Z9n(r.Av))))(A2(J9n, r.fm, A2(r6n, r.mS, A2(G9n, r.uA, A2(utr, r.uA, A3(etr, n, r, h))))));
    }), itr = F2(function(n, r) {
        return A2(Ik, k([
            Nk("hidden md:block")
        ]), k([
            A2(px, G7n, A3(i4n, n, A2(atr, n, r), r.cR))
        ]));
    }), ctr = F2(function(n, r) {
        return A2(px, G7n, A3(i4n, n, o4n(A2(atr, n, r)), r.cR));
    }), otr = F2(function(n, r) {
        return k([
            A2(Ik, k([
                Nk("signup__body--contents")
            ]), k([
                A2(XT, k([
                    jX,
                    LS(q3),
                    A2(_1n, 1, p1n),
                    bz(gz)
                ]), k([
                    ad("Custom details")
                ])),
                A2(Ik, k([
                    Nk("flex flex-grow w-full")
                ]), k([
                    A3(rtr, n, r.uA, r),
                    A2(itr, n, r)
                ])),
                A2(ctr, n, r)
            ]))
        ]);
    }), ftr = F2(function(n, r) {
        return {
            gF: function() {
                var t = b(r.cL, r.h5);
                n: for(;;){
                    r: for(;;){
                        t: for(;;){
                            e: for(;;)switch(t.b.$){
                                case 1:
                                    if (1 === t.a.$) break n;
                                    break r;
                                case 0:
                                    if (1 === t.a.$) break n;
                                    break t;
                                case 2:
                                    switch(t.a.$){
                                        case 1:
                                            break n;
                                        case 2:
                                            break e;
                                        default:
                                            return k([
                                                l4n(r.dw)
                                            ]);
                                    }
                                default:
                                    switch(t.a.$){
                                        case 1:
                                            break n;
                                        case 2:
                                            break e;
                                        default:
                                            return A2(otr, n, r);
                                    }
                            }
                            return k([
                                l4n(r.dw)
                            ]);
                        }
                        return Yk;
                    }
                    return Yk;
                }
                return Yk;
            }(),
            wD: hk(r.dw)
        };
    }), str = sZn({
        zO: W7n,
        Ab: Z7n,
        Ct: X7n,
        Dd: function() {
            return xk(k([
                A2(xD, G7n, A0n()),
                mYn(Y7n),
                Q7n(J7n)
            ]));
        },
        DB: Xrr,
        DH: ftr
    }), ltr = function(n) {
        return {
            $: 13,
            a: n
        };
    }, dtr = function(n) {
        return {
            $: 1,
            a: n
        };
    }, btr = function(n) {
        return {
            $: 11,
            a: n
        };
    }, vtr = function(n) {
        return {
            $: 9,
            a: n
        };
    }, mtr = function(n) {
        return {
            $: 4,
            a: n
        };
    }, ptr = "content-container", $tr = F4(function(n, r, t, e) {
        return A4(dC, z9(n), ben, e, bC(A2($y, k([
            t
        ]), QAn(r))));
    }), htr = function(n) {
        return n.rC;
    }, gtr = function(n) {
        return A2(n0n, "location", n);
    }, wtr = F3(function(n, r, t) {
        return m(t, {
            lj: A2(Cp, XIn, n),
            xy: r
        });
    }), ktr = F2(function(n, r) {
        return A2(Eu, function() {
            return r(A2(f_, n, oa));
        }, qp(500));
    }), xtr = F2(function(n, r) {
        return A2(ktr, n, r);
    }), ytr = {
        l7: Rt,
        qU: "mock-ident",
        ku: Rt,
        sS: Ht("John Doe"),
        uj: Rt,
        xy: Ht("94103")
    }, _tr = F4(function(n, r, t, e) {
        var u = GIn(r), a = htr(u) ? Ht(u) : Rt, i = oYn(t), c = function() {
            var r = r0n(e.iu);
            if (r.$) return Dp;
            var u = r.a;
            return A4(U2n, t.gx, $k(n), u, ltr);
        }(), o = function() {
            var r = gtr(e.iu);
            if (r.$) return b(Dp, oc);
            var u = r.a;
            return fu(u) ? b(Dp, oc) : b(A4($tr, t.gx, $k(n), u, btr), Mx);
        }(), f = o.a, s = o.b, l = function() {
            var r, e = v(i, t.g7, t.CX);
            n: for(;;){
                if (e.b) {
                    if (3 === e.c.$) return s = e.c.a, v(k([
                        f,
                        (r = mtr, A2(xtr, k([
                            ytr
                        ]), r)),
                        c
                    ]), Mx, s);
                    break n;
                }
                if (e.a.$ || 3 !== e.c.$) break n;
                var o = e.a.a, s = e.c.a;
                return v(k([
                    A5(FQn, t.gx, $k(n), pZn(u), o, dtr),
                    f,
                    A4(KAn, t.gx, $k(n), A2(wtr, a, Rt), vtr),
                    c
                ]), Mx, s);
            }
            return v(h, oc, h);
        }(), d = l.a, m = l.b, p = l.c;
        return b({
            fV: ZJn(t),
            ao: Rt,
            gx: t.gx,
            mS: Rt,
            oh: Rt,
            g7: t.g7,
            bj: !1,
            kb: BAn,
            kg: Rt,
            kj: t.kj,
            cB: s,
            hQ: m,
            a$: h,
            eZ: m,
            Av: m,
            e6: i,
            h5: m,
            dw: n,
            uA: !1,
            fl: Rt,
            fm: Rt,
            dJ: Rt,
            cR: A3(i0n, Rk(t.kj), ptr, d0n(n)),
            lj: u,
            fF: r,
            CX: p,
            w_: e
        }, Hu(d));
    }), Ctr = F2(function(n, r) {
        return b(r, Dp);
    }), Dtr = F2(function(n, r) {
        return r;
    }), Atr = function(n) {
        return {
            $: 2,
            a: n
        };
    }, qtr = function(n) {
        return {
            $: 6,
            a: n
        };
    }, Btr = function(n) {
        return {
            $: 3,
            a: n
        };
    }, jtr = function(n) {
        return {
            $: 12,
            a: n
        };
    }, Str = function(n) {
        return {
            $: 7,
            a: n
        };
    }, ztr = function(n) {
        return {
            $: 8,
            a: n
        };
    }, Utr = {
        $: 0
    }, Etr = function(n) {
        return m(n, {
            kg: Rt
        });
    }, Ptr = F2(function(n, r) {
        var t = n.cB;
        return 3 === t.$ ? k([
            t.a
        ]) : r;
    }), Ttr = function(n) {
        var r = n.hQ;
        if (3 === r.$) {
            var t = r.a;
            return A2(UL, WUn, A2(Tc, XUn(n.kb), A2(Ptr, n, t)));
        }
        return h;
    }, Ftr = F2(function(n, r) {
        return YS(A2(zD, function(r) {
            return i(LAn(r), LAn(n));
        }, r));
    }), Ltr = F2(function(n, r) {
        return A2(Ftr, r, Ttr(n));
    }), Mtr = F2(function(n, r) {
        return m(r, {
            o0: n
        });
    }), Htr = function(n) {
        return A2(yu, function(n) {
            return A2(Mtr, Rt, n);
        }, n);
    }, Rtr = F2(function(n, r) {
        var t = r.$ ? bk : hmn(r.a);
        return b(n, vk(k([
            b("id", t)
        ])));
    }), Otr = function(n) {
        return A2(Rtr, "location", A2(Cp, LAn, n));
    }, Ntr = function(n) {
        return n.qU;
    }, Itr = F2(function(n, r) {
        return i(Ht(r), Gb(we(n)));
    }), Vtr = function(n) {
        return n.ku;
    }, Wtr = function(n) {
        return A2(x7, "Filtering by Distance", A2(uc, "", A2(Cp, function(n) {
            return A2(ue, " from zip ", k([
                n.a,
                n.b
            ]));
        }, n)));
    }, Ztr = F2(function(n, r) {
        return function(r) {
            if (1 === r.$) {
                var t = r.b;
                return Ht(b(A2(AAn, n, Ht(r.a)), t));
            }
            return Rt;
        }(XAn(r));
    }), Xtr = F4(function(n, r, t, e) {
        return A2(w7, "Member Preference Saved", A2(Ot, function(n) {
            return A2(x7, "Member ID", n);
        }(n), $(A2(UKn, r, t), e)));
    }), Gtr = function(n) {
        return A2(x7, "Location", A2(uc, "", A2(Cp, Uln, n)));
    }, Jtr = F3(function(n, r, t) {
        return A4(Xtr, Ntr(n), 5, r, k([
            Gtr(Vtr(n)),
            Wtr(A2(Ztr, Rk(0), t))
        ]));
    }), Ytr = F2(function(n, r) {
        return A2(UP, function(n) {
            return i(n, r);
        }, n);
    }), Qtr = F3(function(n, r, t) {
        return A2(Xb, function(t) {
            return A2(tjn, t + r, n);
        }, A2(Ytr, n, t));
    }), Ktr = F2(function(n, r) {
        return A3(Qtr, n, 1, r);
    }), ner = F2(function(n, r) {
        var t = b(n, Vtr(r));
        if (3 !== t.a.$ || t.b.$) return !0;
        var e = t.b.a;
        return $H(A2(zD, function(n) {
            return i(LAn(n), LAn(e));
        }, t.a.a));
    }), rer = F6(function(n, r, t, e, u, a) {
        return {
            l7: t,
            qU: n,
            ku: u,
            sS: r,
            uj: a,
            xy: e
        };
    }), ter = A3(zy, "practitioner", l_(uln), A3(zy, "location", l_(ben), A3(zy, "zip", l_(w$), A3(zy, "age", l_(C$), A3(zy, "name", l_(w$), A3(zy, "id", w$, Ke(rer))))))), eer = A2(qy, ter, Ke(ru)), uer = F2(function(n, r) {
        return A2($y, k([
            "online_enrollments",
            r,
            "member_providers"
        ]), gy(n));
    }), aer = F4(function(n, r, t, e) {
        return A4(dC, z9(n), Ey(eer), e, bC(A2(uer, r, t)));
    }), ier = F2(function(n, r) {
        return A2(zD, function(n) {
            return i(LAn(n), r);
        }, n);
    }), cer = F2(function(n, r) {
        return A2(Xb, ier(n), r);
    }), oer = "Location", fer = aL, ser = function(n) {
        var r = n.ao;
        if (r.$) return v(n, Dp, h);
        var t = r.a, e = A2(uc, oer, A2(Cp, function(n) {
            return A2(ue, ": ", k([
                n ? "Dependent " + ee(n) : "Owner",
                oer
            ]));
        }, A2(UP, function(n) {
            return i(n, t);
        }, n.a$)));
        return v(m(n, {
            kg: Ht(fer)
        }), FYn({
            eC: k([
                JN(fer)
            ]),
            p5: e
        }), h);
    }, ler = function(n) {
        return n.l7;
    }, der = function(n) {
        return n.sS;
    }, ber = function(n) {
        return A3(krr, Ntr(n), der(n), ler(n));
    }, ver = F2(function(n, r) {
        return 1 === n.$ ? r(0) : n;
    }), mer = F2(function(n, r) {
        return A3(Qtr, n, -1, r);
    }), per = F6(function(n, r, t, e, u, a) {
        return A4(kq, z9(n), eer, a, A2(xq, u, bC(A2($y, k([
            e
        ]), A2(uer, r, t)))));
    }), $er = F2(function(n, r) {
        var t = Gb(A2(Tc, function(n) {
            return i(KUn(n), LAn(r));
        }, n));
        return t.$ ? r : A2(Mtr, aLn(t.a), r);
    }), her = function(n) {
        return {
            $: 10,
            a: n
        };
    }, ger = {
        hP: 250,
        lj: Rt,
        xy: Rt
    }, wer = F4(function(n, r, t, e) {
        return A4(dC, z9(n), Ey(tln), e, A2(iH, function(n) {
            var r, t, e = n(ger);
            return Gi(k([
                (t = e.lj, t.$ ? h : k([
                    A2(Ax, "signup_page", t.a)
                ])),
                k([
                    A2(YX, "limit", e.hP)
                ]),
                (r = e.xy, r.$ ? h : k([
                    A2(Ax, "zip", r.a)
                ]))
            ]));
        }(t), bC(function(n) {
            return A2($y, k([
                "location_distances"
            ]), gy(n));
        }(r))));
    }), ker = function(n) {
        var r, t = 1 === (r = XAn(n.kb)).$ ? Ht(r.b) : Rt, e = $k(n.dw), u = htr(n.lj) ? Ht(n.lj) : Rt;
        return b(n, A4(wer, n.gx, e, A2(wtr, u, t), her));
    }, xer = function(n) {
        return {
            $: 14,
            a: n
        };
    }, yer = function(n) {
        return {
            $: 5,
            a: n
        };
    }, _er = function(n) {
        var r = b(n.h5, n.mS);
        if (3 !== r.a.$ || r.b.$) return Dp;
        var t = r.a.a, e = r.b.a, u = A2(wq, function(n) {
            return Orr(n);
        }, J3n(t)), a = Rrr({
            x4: Lrr(n.w_.iu),
            mS: Ht(e),
            oh: n.oh,
            y6: u
        });
        return O3n(n.lj) ? A4(GBn, n.gx, $k(n.dw), a, yer) : A4(I3n, n.gx, $k(n.dw), x2n(t), xer);
    }, Cer = function(n) {
        return n.xy;
    }, Der = F2(function(n, r) {
        switch(n.$){
            case 1:
                var t = n.a, e = m(r, {
                    h5: t
                });
                if (3 === t.$) {
                    var u = t.a, a = (ln = r.fV).$ ? Dp : MKn(ln.a), c = k([
                        DYn(GKn(u)),
                        gYn
                    ]), o = m(e, {
                        fV: Rt,
                        mS: Ht(F0n(u))
                    });
                    return v(o, Hu(k([
                        a,
                        _er(o)
                    ])), c);
                }
                return v(e, Dp, A2(uA, 1, t));
            case 0:
                var f = v(r.ao, r.e6, r.g7);
                if (f.c) return v(r, Dp, k([
                    _Yn
                ]));
                if (f.a.$ || f.b.$) return v(r, Dp, h);
                var s = f.a.a, l = f.b.a, d = r.dJ;
                return d.$ ? ser(r) : A2(Ltr, r, S = d.a) ? v(e = Etr(m(r, {
                    bj: !1,
                    uA: !0
                })), A6(per, r.gx, $k(e.dw), l, Ntr(s), vk(k([
                    Otr(Ht(S))
                ])), ztr), h) : ser(r);
            case 2:
                var p = A2(M3n, n.a, r.cR), $ = p.a, g = p.b, w = p.c, x = w.$ || w.a ? Dp : A2(Eu, ru, gu(Utr));
                return v(m(r, {
                    cR: $
                }), Hu(k([
                    A2(jp, Atr, g),
                    x
                ])), h);
            case 3:
                var y = A2(uc, Ru, A2(Xb, function(n) {
                    return ec(n);
                }, $u(n.a))), _ = A2(uc, Ru, ec(r.w_.B9));
                return v(r, A4(HQn, r.lj, r.CX, _, y) ? A2(HKn, _, y) : Dp, k([
                    K7n
                ]));
            case 4:
                var C = n.a, D = m(r, {
                    eZ: C
                });
                if (3 === C.$) {
                    var A = C.a, q = A2(uc, "", A2(Xb, Cer, Gb(A))), B = fu(q) ? r.kb : A2(dqn, q, BAn), j = A2(VHn, Gb(we(A)), Gb(A2(Tc, ner(r.hQ), A))), S = D.cB.$ ? MD(D.cB) : A2(VHn, D.dJ, A2(Xb, Vtr, A2(Xb, function(n) {
                        return A2(ner, r.hQ, n) ? A2(mer, A, n) : Ht(n);
                    }, j))), z = oe(A) > 1 ? k([
                        A3(anr, A2(yu, ber, A), A2(uc, "", A2(Cp, Ntr, j)), !0)
                    ]) : h, U = m(D, {
                        ao: j,
                        bj: 3 === (sn = r.h5).$ && A4(ZKn, r.lj, r.CX, GKn(sn.a), r.w_.B9),
                        kb: B,
                        a$: A,
                        dJ: S
                    }), E = ker(U);
                    return v(N = E.a, Hu(k([
                        E.b,
                        A4(TKn, 5, N.CX, N.fF, h)
                    ])), z);
                }
                return v(D, Dp, A2(uA, 1, C));
            case 5:
                var P = n.a;
                n: for(;;)switch(P.$){
                    case 3:
                        return v(m(r, {
                            fl: Ht(P.a),
                            fm: Rt
                        }), Dp, h);
                    case 2:
                        if (5 === P.a.$) {
                            var T = Ht(WGn(k([
                                KD(n3n(P.a.b))
                            ])));
                            return v(m(r, {
                                fm: T
                            }), Dp, h);
                        }
                        break n;
                    default:
                        break n;
                }
                return v(r, Dp, A2(uA, 1, P));
            case 6:
                var F = n.a;
                return oe(r.a$) > 0 ? (s = Gb(A2(Tc, function(n) {
                    return i(Ntr(n), F);
                }, r.a$)), v(m(r, {
                    ao: s,
                    bj: YS(S = A2(Xb, Vtr, s)),
                    kg: Rt,
                    dJ: S
                }), Dp, h)) : v(r, Dp, h);
            case 7:
                var L = $En(n.a), M = L.a, H = L.b, R = H.$ ? b(r.dJ, r.bj) : b(Ht(H.a), !1);
                return v(m(r, {
                    bj: R.b,
                    kg: Rt,
                    dJ: S = R.a
                }), A2(jp, Str, M), h);
            case 8:
                var O = n.a;
                if (e = m(r, {
                    uA: !1
                }), 3 === O.$) {
                    var N, I = O.a, V = A2(yu, function(n) {
                        return i(Ntr(n), Ntr(I)) ? I : n;
                    }, e.a$), W = function(n) {
                        var r = n.ao;
                        if (r.$) return v(n, Dp, h);
                        var t = r.a;
                        if (A2(Itr, n.a$, t)) return v(n, Hu(k([
                            A4(EKn, 5, n.CX, n.fF, h),
                            A3(Jtr, t, n.CX, n.kb)
                        ])), k([
                            _Yn
                        ]));
                        var e = A2(Ktr, n.a$, t);
                        if (e.$) return v(n, Dp, h);
                        var u = e.a, a = A2(z$, Vtr(u), Vtr(t));
                        return v(m(n, {
                            ao: Ht(u),
                            bj: YS(a),
                            dJ: a
                        }), Hu(k([
                            Wjn(Ntr(u)),
                            A3(Jtr, t, n.CX, n.kb)
                        ])), k([
                            cnr(Ntr(u))
                        ]));
                    }(m(e, {
                        ao: Ht(I),
                        a$: V
                    }));
                    return v(N = W.a, W.b, W.c);
                }
                return v(e, Dp, A2(uA, 1, O));
            case 9:
                var Z = n.a;
                if (e = m(r, {
                    hQ: Z
                }), 3 === Z.$) {
                    var X = Z.a, G = (S = A2(ver, r.dJ, function() {
                        return A2(cer, X, dKn(r.fF));
                    }), function() {
                        var n = r.e6;
                        if (n.$) return Dp;
                        var t = n.a;
                        return A4(aer, r.gx, $k(r.dw), t, mtr);
                    }());
                    return v(m(e, {
                        dJ: S
                    }), G, h);
                }
                return v(e, Dp, A2(uA, 1, Z));
            case 10:
                var J = n.a, Y = b(r.hQ, J);
                n: for(;;)switch(Y.b.$){
                    case 3:
                        if (3 === Y.a.$) {
                            var Q = Y.a, K = (X = Q.a, Q.b), nn = A2(yu, $er(Y.b.a), X);
                            return v(m(r, {
                                hQ: A2(f_, nn, K)
                            }), Dp, A2(uA, 1, J));
                        }
                        break n;
                    case 2:
                        if (9 === Y.b.a.$) return v(r, Dp, h);
                        break n;
                    default:
                        break n;
                }
                return v(r, Dp, A2(uA, 1, J));
            case 11:
                var rn = n.a;
                return e = m(r, {
                    cB: rn
                }), 3 === rn.$ ? v(m(e, {
                    dJ: Ht(rn.a)
                }), Dp, h) : v(e, Dp, A2(uA, 1, rn));
            case 12:
                var tn = A2(mEn, n.a, r.kb), en = tn.a, un = tn.b, an = tn.c, cn = m(r, {
                    kb: en
                }), on = function() {
                    if (an.$) return b(cn, Dp);
                    if (an.a.$) {
                        var n = Npn(an.a.a) ? ker(cn) : b(cn, Dp);
                        return b(n.a, n.b);
                    }
                    var r = an.a.b ? sEn(en) ? ker(cn) : b(function(n) {
                        var r = n.hQ;
                        if (3 === r.$) {
                            var t = r.b;
                            return m(n, {
                                hQ: A2(f_, Htr(r.a), t)
                            });
                        }
                        return n;
                    }(cn), Dp) : b(cn, Dp), t = r.b;
                    return b(function(n) {
                        var r = n.dJ;
                        return r.$ ? n : A2(Ltr, n, r.a) ? Etr(n) : n;
                    }(r.a), t);
                }();
                return x = on.b, v(e = on.a, Hu(k([
                    A2(jp, jtr, un),
                    x
                ])), h);
            case 13:
                var fn = n.a;
                return 3 === fn.$ ? v(e = m(r, {
                    oh: Ht(fn.a)
                }), _er(e), h) : v(r, Dp, A2(uA, 1, fn));
            default:
                return v(m(r, {
                    Av: n.a
                }), Dp, h);
        }
        var sn, ln;
    }), Aer = function(n) {
        return A2(Tc, function(n) {
            return YS(Tln(n));
        }, n);
    }, qer = F2(function(n, r) {
        var t = XAn(r);
        if (1 === t.$) {
            var e = t.b;
            return ED(Aer(n)) && Npn(e);
        }
        return !1;
    }), Ber = F2(function(n, r) {
        var t = b(r.cB, r.hQ);
        if (t.a.$ || 3 !== t.b.$) return Sq;
        var e = A2(qer, t.b.a, r.kb);
        return A2(lV, k([
            eyn,
            MLn,
            dV(FV)
        ]), k([
            A2(iV, k([
                UZ(12)
            ]), k([
                A2(px, jtr, A4(ZLn, n, e, r.uA, r.kb))
            ]))
        ]));
    }), jer = function(n) {
        if (n.$) return Sq;
        var r = n.a;
        return A2(Ik, k([
            Nk("form-error mb-3 mt-0")
        ]), k([
            ad(r)
        ]));
    }, Ser = F2(function(n, r) {
        var t = b(A2(Xb, Vtr, n.ao), n.bj);
        if (!t.a.$ && t.b) {
            var e = t.a.a, u = A2(Ftr, e, r) ? h : k([
                e
            ]);
            return A2(Ot, e, A2(Tc, function(n) {
                return !i(LAn(n), LAn(e));
            }, $(u, r)));
        }
        return r;
    }), zer = F2(function(n, r) {
        var t = A2(Ser, r, Ttr(r));
        return A2(Ik, k([
            Nk("mb-8")
        ]), k([
            ED(t) ? A2(hx, h, k([
                ad("No locations found")
            ])) : A2(px, Str, A2(OFn, n, k([
                kFn(r.uA),
                CFn(t),
                EFn(r.dJ)
            ])))
        ]));
    }), Uer = F2(function(n, r) {
        return A2(Ik, k([
            jz(ptr)
        ]), k([
            A2(Ber, n, r),
            jer(A2(Cp, n, r.kg)),
            A2(zer, n, r)
        ]));
    }), Eer = F3(function(n, r, t) {
        var e = b(r.eZ, r.ao);
        return 3 !== e.a.$ || e.b.$ ? t : A2(n6n, A5(ttr, n, A2(Itr, e.a.a, e.b.a), r.lj, r.CX, r.w_.B9), t);
    }), Per = F2(function(n, r) {
        return (function() {
            if (O3n(r.lj)) return t6n(r.fl);
            var n, t = 3 === (n = r.Av).$ ? n.a : h;
            return Q9n(W9n(t));
        })()(A2(J9n, r.fm, A2(r6n, r.mS, A2(G9n, r.uA, A2(utr, r.uA, A3(Eer, n, r, h))))));
    }), Ter = F2(function(n, r) {
        return A2(Ik, k([
            Nk("hidden md:block")
        ]), k([
            A2(px, Atr, A3(i4n, n, A2(Per, n, r), r.cR))
        ]));
    }), Fer = F2(function(n, r) {
        return A2(px, Atr, A3(i4n, n, o4n(A2(Per, n, r)), r.cR));
    }), Ler = F2(function(n, r) {
        var t, e;
        return k([
            A2(Ik, k([
                Nk("signup__body--contents")
            ]), k([
                A2(XT, k([
                    jX,
                    LS(p1n),
                    bz(gz)
                ]), (t = r.ao, e = "Select location", A2(uc, k([
                    ad(e)
                ]), A2(Cp, function(n) {
                    return k([
                        ad(e + " for "),
                        Jx(n)
                    ]);
                }, A2(Xb, der, t))))),
                A2(lV, k([
                    dV(NZ)
                ]), k([
                    A2(iV, k([
                        UZ(12),
                        GZ(8)
                    ]), k([
                        A2(Uer, n, r)
                    ])),
                    A2(iV, k([
                        GZ(4),
                        jV(k([
                            Nk("hidden md:block")
                        ]))
                    ]), k([
                        A2(Ter, n, r)
                    ]))
                ])),
                A2(Fer, n, r)
            ]))
        ]);
    }), Mer = F2(function(n, r) {
        return {
            gF: function() {
                var t = v(r.h5, r.hQ, r.eZ);
                n: for(;;){
                    r: for(;;){
                        t: for(;;){
                            e: for(;;){
                                u: for(;;)switch(t.a.$){
                                    case 1:
                                        return Yk;
                                    case 0:
                                        if (1 === t.b.$) break n;
                                        if (1 === t.c.$) break r;
                                        break t;
                                    case 2:
                                        if (1 === t.b.$) break n;
                                        if (1 === t.c.$) break r;
                                        break e;
                                    default:
                                        switch(t.b.$){
                                            case 1:
                                                break n;
                                            case 2:
                                                if (1 === t.c.$) break r;
                                                break u;
                                            default:
                                                switch(t.c.$){
                                                    case 1:
                                                        break r;
                                                    case 2:
                                                        return k([
                                                            l4n(r.dw)
                                                        ]);
                                                    default:
                                                        return A2(Ler, n, r);
                                                }
                                        }
                                }
                                return k([
                                    l4n(r.dw)
                                ]);
                            }
                            return k([
                                l4n(r.dw)
                            ]);
                        }
                        return Yk;
                    }
                    return Yk;
                }
                return Yk;
            }(),
            wD: hk(r.dw)
        };
    }), Her = sZn({
        zO: _tr,
        Ab: Ctr,
        Ct: Dtr,
        Dd: function() {
            return xk(k([
                A2(xD, Atr, A0n()),
                mYn(Btr),
                Q7n(qtr)
            ]));
        },
        DB: Der,
        DH: Mer
    }), Rer = function(n) {
        return {
            $: 18,
            a: n
        };
    }, Oer = function(n) {
        return {
            $: 15,
            a: n
        };
    }, Ner = function(n) {
        return {
            $: 13,
            a: n
        };
    }, Ier = F3(function(n, r, t) {
        return m(t, {
            mf: YJn(n),
            ny: GJn(n),
            nK: oKn(n),
            g5: !0,
            kW: r,
            iH: !0
        });
    }), Ver = F2(function(n, r) {
        return m(r, {
            nk: n
        });
    }), Wer = F5(function(n, r, t, e, u) {
        return A2(Ver, u, A3(mAn, n, r, A2(Ier, t, e)));
    }), Zer = "members-container", Xer = function(n) {
        return "member-" + ee(n);
    }, Ger = function(n) {
        var r = n.$ ? 1 : Bbn(n.a);
        return Xer(r);
    }, Jer = F2(function(n, r) {
        var t = jN(r.kk);
        return m(r, {
            kk: AO(m(t, {
                uo: A2(F$, n, t.uo)
            }))
        });
    }), Yer = F4(function(n, r, t, e) {
        var u, a, i, c, o = GIn(r), f = A2(Jer, A2(uc, ibn(n), t.DE), (u = A5(Wer, Ger(Rt), n, r, !0, Rt), a = jN(u.kk), i = AO(m(a, {
            u5: Ht(0)
        })), m(u, {
            kk: i
        }))), s = $k(n), l = (c = r0n(e.iu)).$ ? Dp : A4(U2n, t.gx, s, c.a, Rer), d = function() {
            var n = b(oYn(t), t.CX);
            if (3 === n.b.$) {
                if (n.a.$) return e = n.b.a, v(k([
                    l
                ]), oc, e);
                var r = n.a.a, e = n.b.a;
                return v(k([
                    A5(FQn, t.gx, s, pZn(o), r, Oer),
                    l
                ]), Mx, e);
            }
            return v(k([
                l
            ]), oc, h);
        }(), p = d.a, $ = d.b, g = d.c;
        return b({
            fV: ZJn(t),
            gx: t.gx,
            mS: Rt,
            oh: Rt,
            g0: Rt,
            g6: VJ,
            g7: t.g7,
            kj: t.kj,
            Av: A2(L6, {
                o: h,
                be: !1,
                di: !0,
                cC: Rt,
                hX: f,
                u8: !1,
                a5: tBn(f)
            }, Z3),
            e0: pKn(r),
            e6: t.e6,
            h5: Mx,
            h9: Rt,
            e7: h,
            dw: n,
            uA: !1,
            fl: Rt,
            fm: Rt,
            u$: !1,
            cL: $,
            cR: A3(i0n, Rk(t.kj), Zer, d0n(n)),
            lj: o,
            fF: r,
            CX: g,
            w_: e
        }, Hu(A2(Ot, A2(Eu, Ner, by), p)));
    }), Qer = F2(function(n, r) {
        var t = n.kj;
        return i(t, r.kj) ? b(r, Dp) : b(m(r, {
            kj: t
        }), Dp);
    }), Ker = F2(function(n, r) {
        return r;
    }), nur = function(n) {
        return {
            $: 16,
            a: n
        };
    }, rur = function(n) {
        return {
            $: 17,
            a: n
        };
    }, tur = F2(function(n, r) {
        return {
            $: 2,
            a: n,
            b: r
        };
    }), eur = function(n) {
        return A2(xD, tur(n.a), kqn);
    }, uur = {
        $: 3
    }, aur = {
        $: 0
    }, iur = function(n) {
        return {
            $: 10,
            a: n
        };
    }, cur = function(n) {
        return zEn(n.hX) && ED(n.o);
    }, our = F2(function(n, r) {
        return m(r, {
            be: n
        });
    }), fur = function(n) {
        return A2(JEn, function(n) {
            return cur(n) ? A2(our, !0, n) : n;
        }, n);
    }, sur = function(n) {
        return A2(JEn, function(n) {
            return cur(n) ? n : A2(our, !1, n);
        }, n);
    }, lur = function(n) {
        return Qvn(A2(Y$n, function(n) {
            var r = n.b;
            return !ED(r.o) || !cur(r);
        }, n));
    }, dur = function(n) {
        return !lur(n).$;
    }, bur = function(n) {
        var r = jN(n.kk);
        return r.aj ? r.nn : r.rt;
    }, vur = F2(function(n, r) {
        var t = jN(r.kk);
        return m(r, {
            kk: AO(m(t, {
                rt: n
            }))
        });
    }), mur = F5(function(n, r, t, e, u) {
        return (function() {
            if (r.$) return ru;
            var n = r.a, t = jN(n.hX.kk).uo.z6, e = bur(n.hX);
            return A2(Je, vur(e), Jer(t));
        })()(A5(Wer, n, t, e, !1, u));
    }), pur = F5(function(n, r, t, e, u) {
        return {
            o: h,
            be: !1,
            di: !0,
            cC: Rt,
            hX: A5(mur, n, r, t, e, u),
            u8: !1,
            a5: ""
        };
    }), $ur = F4(function(n, r, t, e) {
        if (dur(e)) return b(sur(e), !1);
        var u = Ger(Ht(e));
        return b(A2(L6, A5(pur, u, Qvn(e), n, r, t), fur(e)), !0);
    }), hur = F3(function(n, r, t) {
        return A2(Xb, function(n) {
            return Ht(A2(ue, ": ", k([
                n ? "Dependent " + ee(n) : "Owner",
                r
            ])));
        }, A2(hzn, t, n));
    }), gur = F2(function(n, r) {
        var t = b(A3(hur, n, "Date Of Birth", r), oe(n.o) > 0);
        if (!t.a.$ && t.b) {
            var e = t.a.a;
            return FYn({
                eC: A2(yu, aI, n.o),
                p5: e
            });
        }
        return Dp;
    }), wur = function(n) {
        return A2($4, function(r) {
            return A2(gur, r.b, n);
        }, n);
    }, kur = F2(function(n, r) {
        return r.wm(n);
    }), xur = F2(function(n, r) {
        if (9 === n) {
            var t = A2(UW, Rk(0), r), e = A2(LYn, ": ", t), u = e.a, a = e.b, i = au(u) > 0 ? b($(vAn(n), $(": ", u)), a) : b(vAn(n), t);
            return b(i.a, A2(hGn, kur(i.b), r));
        }
        return b(vAn(n), r);
    }), yur = function(n) {
        return A2(yu, function(r) {
            var t = r.c, e = A3(hur, r.a, r.b, n);
            if (e.$) return Dp;
            var u = e.a;
            return FYn({
                eC: k([
                    t
                ]),
                p5: u
            });
        }, function(n) {
            return Gi(A2($4, function(n) {
                var r, t = n.b;
                return A2(yu, function(n) {
                    return v(t, n.a, n.b);
                }, (r = A2(sUn, !1, t.hX), Gi(A2(yu, function(n) {
                    return A2(yu, xur(n), A2(iW, n, r.kk));
                }, bAn))));
            }, n));
        }(n));
    }, _ur = function(n) {
        return n.nk;
    }, Cur = F6(function(n, r, t, e, u, a) {
        var i = b(t, _on(e));
        if (3 === i.a.$ && i.b) {
            var c = GKn(i.a.a);
            return A4(ZKn, n, r, c, u.B9) ? fur(a) : a;
        }
        return a;
    }), Dur = {
        Da: ZK(300),
        Dz: function(n) {
            return {
                $: 11,
                a: n
            };
        }
    }, Aur = function(n) {
        return {
            $: 12,
            a: n
        };
    }, qur = function(n) {
        return A2(Eu, Aur, gu(n));
    }, Bur = function(n) {
        return n.qU;
    }, jur = function(n) {
        return Bur(n.hX) + "-age-errors";
    }, Sur = function(n) {
        return Ht(A2(uc, jur(n), SEn(n.hX)));
    }, zur = function(n) {
        var r = function(n) {
            return A2(Xb, Sur, lur(n));
        }(n);
        return r.$ ? Dp : qEn(r.a);
    }, Uur = F2(function(n, r) {
        var t = Gb(A2(Tc, function(r) {
            return i(n, r.a);
        }, r.b));
        return t.$ ? Rt : Ht(t.a.b);
    }), Eur = function(n) {
        return n.qU;
    }, Pur = F2(function(n, r) {
        return m(r, {
            kk: AO(A4(dAn, r.qU, r.dw, r.aY, Ht(n)))
        });
    }), Tur = F5(function(n, r, t, e, u) {
        var a = bDn(vDn(u)), i = A2(Ver, e, A2(Pur, u, A5(Wer, Xer(n + 1), r, t, a, e)));
        return {
            o: h,
            be: !1,
            di: !1,
            cC: Ht(Eur(u)),
            hX: i,
            u8: !1,
            a5: tBn(i)
        };
    }), Fur = F4(function(n, r, t, e) {
        return M6(A2(be, F2(function(n, u) {
            return A5(Tur, n, r, t, e, u);
        }), n));
    }), Lur = function(n) {
        return i(vAn(5), n);
    }, Mur = function(n) {
        var r = jN(n.kk);
        return rzn(r.u5);
    }, Hur = F3(function(n, r, t) {
        var e, u = A2(sUn, !1, t);
        return A2(uc, h, A2(Cp, function(n) {
            var e = b(n, r);
            if (9 !== e.a || e.b.$) return A2(iW, n, u.kk);
            var a = e.b.a, i = jN(t.kk), c = A2(NQn, a, i.l0);
            return c.$ ? h : k([
                c.a
            ]);
        }, (e = n, Gb(A2(Tc, function(n) {
            return i(vAn(n), e);
        }, bAn)))));
    }), Rur = F3(function(n, r, t) {
        var e = A2(LYn, ": ", t), u = e.a, a = e.b, i = au(u) > 0 ? b(u, Ht(a)) : b(a, Rt), c = i.a, o = i.b;
        return A2(uc, h, A2(Cp, function(e) {
            var u, a = ac(n.w_.B9), i = (u = b(Lur(t), ED(r.o))).a && !u.b ? A2(yu, aI, r.o) : A3(Hur, c, o, r.hX);
            return k([
                OQn(Ht({
                    eC: i,
                    p5: e,
                    Cr: a
                }))
            ]);
        }, A3(hur, r, t, n.Av)));
    }), Our = F2(function(n, r) {
        return A2($y, k([
            "online_enrollments",
            r,
            "members"
        ]), gy(n));
    }), Nur = F4(function(n, r, t, e) {
        return A4(dC, z9(n), Ey(ljn), e, bC(A2(Our, r, t)));
    }), Iur = F2(function(n, r) {
        return A2(Xb, hzn(n), A2(Uur, r, n));
    }), Vur = F2(function(n, r) {
        var t, e = A2(Iur, n, r);
        return e.$ ? Dp : (t = ee(e.a), A2(w7, "Dependent Removed", k([
            _7(TYn),
            y7(t)
        ])));
    }), Wur = {
        $: 1
    }, Zur = F2(function(n, r) {
        return !function(n) {
            var r = function(n) {
                return Qvn(A2(Y$n, function(n) {
                    return n.b.di;
                }, n));
            }(n);
            return !r.$;
        }(n) && r ? A2(Eu, ru, gu(Wur)) : Dp;
    }), Xur = F2(function(n, r) {
        var t = b(n, _on(r));
        return !(3 !== t.a.$ || !t.b) && qnr(t.a.a);
    }), Gur = function(n) {
        var r = jN(n.kk);
        return r.aj ? r.nm : r.qb;
    }, Jur = F2(function(n, r) {
        var t = OB(bur(n)), e = OB(Gur(n)), u = cBn(n), a = OB(bur(r)), c = OB(Gur(r)), o = cBn(r);
        return i(c, e) && i(a, t) && i(o, u);
    }), Yur = F2(function(n, r) {
        var t = r.b;
        return A2(lA, !0, A2($4, function(n) {
            var r = n.b;
            return !i(r, t) && A2(Jur, r.hX, t.hX);
        }, n));
    }), Qur = function(n) {
        return n.ms;
    }, Kur = function(n) {
        return n.mt;
    }, nar = function(n) {
        return n.pl;
    }, rar = function(n) {
        return Kvn(A2(Y$n, function(n) {
            return !Mur(n.b.hX);
        }, n));
    }, tar = F2(function(n, r) {
        if (n.$) return !1;
        var t = n.a;
        return s(rar(r), t) > 0;
    }), ear = function(n) {
        return n.wN;
    }, uar = F5(function(n, r, t, e, u) {
        return Y6(u) && r ? k([
            A2(Xur, t, e) ? Qur : Kur
        ]) : A2(tar, n, u) ? k([
            ear
        ]) : function(n) {
            return A2(lA, !0, A2($4, Yur(n), n));
        }(u) ? k([
            nar
        ]) : h;
    }), aar = F2(function(n, r) {
        return {
            $: 8,
            a: n,
            b: r
        };
    }), iar = F2(function(n, r) {
        return {
            $: 9,
            a: n,
            b: r
        };
    }), car = function(n) {
        return vk(k([
            b("member", djn(n))
        ]));
    }, oar = F5(function(n, r, t, e, u) {
        return A4(vN, z9(n), ljn, u, A2(xq, car(e), bC(A2(Our, r, t))));
    }), far = F6(function(n, r, t, e, u, a) {
        return A4(kq, z9(n), ljn, a, A2(xq, car(u), bC(A2($y, k([
            e
        ]), A2(Our, r, t)))));
    }), sar = F4(function(n, r, t, e) {
        var u = e.a, a = e.b, i = Djn(a.hX);
        if (cur(a) && a.di) {
            var c = a.cC;
            return c.$ ? A5(oar, n, t, r, i, aar(u)) : A6(far, n, t, r, c.a, i, iar(u));
        }
        return Dp;
    }), lar = function(n) {
        var r = n.e6;
        return 2 === r.$ ? Hu(A2($4, A3(sar, n.gx, r.a, $k(n.dw)), n.Av)) : Dp;
    }, dar = F2(function(n, r) {
        return {
            $: 5,
            a: n,
            b: r
        };
    }), bar = F5(function(n, r, t, e, u) {
        return A4(IRn, z9(n), RHn, u, bC(A2($y, k([
            e
        ]), A2(Our, r, t))));
    }), mar = F5(function(n, r, t, e, u) {
        if (2 === e.$) {
            var a = e.a;
            return A5(bar, n, $k(u), a, t, dar(r));
        }
        return Dp;
    }), par = function(n) {
        return m(n, {
            di: !1
        });
    }, $ar = F2(function(n, r) {
        return m(r, {
            u8: n
        });
    }), har = function(n) {
        var r = Gb(n);
        return r.$ ? h : k([
            A2(nA, 1, r.a)
        ]);
    }, gar = F3(function(n, r, t) {
        return A2(W3, t.a, A2(yu, function(t) {
            var e = t.a, u = t.b;
            return b(e, i(e, r) ? n(u) : u);
        }, t.b));
    }), war = F2(function(n, r) {
        return m(r, {
            cC: Ht(n)
        });
    }), kar = function(n) {
        return m(n, {
            a5: tBn(n.hX)
        });
    }, xar = F2(function(n, r) {
        return A2(uc, !1, A2(Cp, dZn, A2(zD, function(r) {
            return i(xKn(r), n);
        }, r)));
    }), yar = function(n) {
        return A2(xar, 3, n);
    }, _ar = F3(function(n, r, t) {
        if (n.$) return t;
        var e = A3(pBn, n.a, r, t.hX);
        return e.$ ? t : m(t, {
            o: A2(Ot, e.a, t.o)
        });
    }), Car = F2(function(n, r) {
        return r.sY(n);
    }), Dar = function(n) {
        return Car(ee(n));
    }, Aar = F3(function(n, r, t) {
        if (n.$) return !0;
        var e = n.a;
        return !Y6(A2(Y$n, function(n) {
            var t = n.b, u = A3(CBn, e, r, t.hX);
            return zEn(t.hX) && $H(u);
        }, t));
    }), qar = F3(function(n, r, t) {
        var e = b(n, A3(Aar, n, r, t));
        if (e.a.$ || e.b) return t;
        var u = e.a.a;
        return A2(JEn, function(n) {
            return zEn(n.hX) ? m(n, {
                o: $(n.o, k([
                    Dar(u)
                ]))
            }) : n;
        }, t);
    }), Bar = F2(function(n, r) {
        var t = A2(gBn, n, r.hX);
        return t.$ ? r : m(r, {
            o: $(r.o, k([
                t.a
            ]))
        });
    }), jar = function(n) {
        return n.r_;
    }, Sar = function(n) {
        return n.sL;
    }, zar = F3(function(n, r, t) {
        return m(t, {
            o: $(t.o, A2(uc, h, A2(Cp, function(n) {
                return A2(Ot, n, t.o);
            }, A2(Xb, function(n) {
                return A3(xBn, n, r, t.hX);
            }, n))))
        });
    }), Uar = F3(function(n, r, t) {
        return m(t, {
            o: A2(uc, h, A2(Cp, function(n) {
                return A2(Ot, n, t.o);
            }, A2(Xb, function(n) {
                return A3(CBn, n, r, t.hX);
            }, n)))
        });
    }), Ear = F3(function(n, r, t) {
        return Ht(A3(zar, jar(t), r, A3(Uar, Sar(t), r, n)));
    }), Par = F3(function(n, r, t) {
        return n.$ ? t : A2(uc, t, A3(Ear, t, r, n.a));
    }), Tar = F6(function(n, r, t, e, u, a) {
        var i = A2(JEn, function(n) {
            return m(n, {
                o: h
            });
        }, a);
        if (r.$) return i;
        var c = r.a;
        return A3(qar, t, c, A2(JEn, A2(_ar, e, c), (yar(n) ? ru : JEn(A2(Par, u, c)))(A2(JEn, Bar(c), i))));
    }), Far = F4(function(n, r, t, e) {
        var u = (function() {
            var r = b(n, Fnn(t.a5));
            if (r.a.$ || r.a.a.$ || r.b) return ru;
            if (Lur(r.a.a.a)) {
                var u = A2(Xb, e3n, e.mS);
                return A5(Tar, e.CX, e.g0, e.e0, A2(Xb, _ur, u), u);
            }
            return ru;
        })()(A3(Q9, t, r, e.Av));
        return m(e, {
            Av: u
        });
    }), Lar = function(n) {
        return {
            $: 14,
            a: n
        };
    }, Mar = F4(function(n, r, t, e) {
        var u = yar(n) ? k([
            A2(Xb, function(n) {
                return A3(CBn, n, r, e.hX);
            }, Sar(t)),
            A2(Xb, function(n) {
                return A3(xBn, n, r, e.hX);
            }, jar(t)),
            A2(Xb, function(n) {
                return A3(pBn, n, r, e.hX);
            }, _ur(t))
        ]) : h;
        return A2(Ep, ru, A2(Ot, A2(gBn, r, e.hX), u));
    }), Har = function(n) {
        return O3n(n.lj) ? function(n) {
            var r = v(i(Kvn(n.Av), Kvn(A2(Y$n, function(n) {
                return eBn(n.b.hX);
            }, n.Av))), n.mS, O3n(n.lj));
            if (r.a && !r.b.$ && r.c) {
                var t = r.b.a, e = e3n(t), u = function() {
                    var r = b(n.g0, e);
                    if (r.a.$ || r.b.$) return n.Av;
                    var t = r.a.a, u = r.b.a;
                    return A2(Y$n, function(r) {
                        return ED(A4(Mar, n.CX, t, u, r.b));
                    }, n.Av);
                }(), a = A2(xmn, function(n) {
                    return vk(function(n) {
                        var r = jN(n.kk);
                        return k([
                            b("name", hmn(tBn(n))),
                            b("dob", jBn(VN(r.bg))),
                            b("relationship", qBn(Cjn(r.u5)))
                        ]);
                    }(n.b.hX));
                }, u), c = Rrr({
                    x4: Lrr(n.w_.iu),
                    mS: Ht(t),
                    oh: n.oh,
                    y6: a
                });
                return A4(GBn, n.gx, $k(n.dw), c, Lar);
            }
            return Dp;
        }(n) : Dp;
    }, Rar = function(n) {
        var r = A2(sUn, !0, n.hX);
        return m(n, {
            hX: r,
            a5: zEn(r) ? tBn(r) : n.a5
        });
    }, Oar = F2(function(n, r) {
        switch(n.$){
            case 15:
                var t = n.a, e = m(r, {
                    h5: t
                });
                if (3 === t.$) {
                    var u = t.a, a = (fn = r.fV).$ ? Dp : MKn(fn.a), c = u.u$, o = $k(r.dw), f = x2n(u), s = ZYn(u), l = k(s ? [
                        DYn(GKn(u)),
                        wYn,
                        gYn
                    ] : [
                        DYn(GKn(u)),
                        gYn
                    ]);
                    return v(m(e, {
                        fV: Rt,
                        mS: Ht(F0n(u)),
                        g7: s,
                        u$: c
                    }), Hu(k([
                        A4(Nur, r.gx, o, f, iur),
                        a
                    ])), l);
                }
                return v(e, Dp, A2(uA, 1, t));
            case 10:
                var d = n.a;
                if (3 === d.$) {
                    var p = A4(Fur, d.a, r.dw, r.fF, L = A2(Xb, _ur, A2(Xb, e3n, r.mS))), g = yvn(AYn(r.fF)) || A2(Xur, r.h5, d), w = function() {
                        if (g) {
                            var n = A2(Cp, function(n) {
                                return b(n.a, A2(our, !0, n.b));
                            }, Yvn(A2(Y$n, function(n) {
                                return Mur(n.b.hX);
                            }, p)));
                            return b(n, function(t) {
                                if (Y6(t)) {
                                    var e = A2(Cp, function(n) {
                                        return n.b;
                                    }, n), u = Ger(Ht(p));
                                    return A2(L6, A5(pur, u, e, r.dw, r.fF, L), t);
                                }
                                return A6(Cur, r.lj, r.CX, r.h5, d, r.w_, t);
                            }(A2(Y$n, function(n) {
                                return !Mur(n.b.hX);
                            }, p)));
                        }
                        return b(Rt, A6(Cur, r.lj, r.CX, r.h5, d, r.w_, p));
                    }();
                    return v(e = m(r, {
                        Av: w.b,
                        h9: w.a,
                        cL: d
                    }), Hu(k([
                        Har(e),
                        A4(TKn, 2, e.CX, e.fF, h)
                    ])), h);
                }
                return v(m(r, {
                    cL: d
                }), Dp, A2(uA, 1, d));
            case 9:
                var x = n.a, y = n.b;
                if (e = m(r, {
                    uA: !1
                }), 3 === y.$) {
                    var _ = A3(gar, par, x, A3(gar, kar, x, fur(r.Av)));
                    return v(m(e, {
                        Av: _
                    }), Hu(k([
                        A2(Zur, _, r.uA)
                    ])), h);
                }
                return v(e, Dp, A2(uA, 1, y));
            case 8:
                x = n.a;
                var C = n.b;
                if (3 === C.$) {
                    var D = Eur(C.a);
                    return _ = A3(gar, par, x, A3(gar, kar, x, A3(gar, war(D), x, fur(r.Av)))), v(m(r, {
                        Av: _
                    }), A2(Zur, _, r.uA), h);
                }
                return v(m(r, {
                    uA: !1
                }), Dp, A2(uA, 1, C));
            case 0:
                var A = A2(Xb, e3n, r.mS), q = (_ = fur(sur(A6(Tar, r.CX, r.g0, r.e0, L = A2(Xb, _ur, A2(Xb, e3n, r.mS)), A, A2(JEn, Rar, r.Av)))), A5(uar, mKn(r.fF), nKn(r.lj), r.h5, r.cL, _));
                return e = m(r, {
                    Av: _,
                    e7: q
                }), dur(_) || !ED(q) ? v(e, Hu(A2(Xi, wur(_), A2(Ot, zur(_), yur(_)))), har(q)) : v(m(e, {
                    uA: !0
                }), Hu(k([
                    lar(e),
                    A2(Zur, _, !0)
                ])), har(q));
            case 1:
                return v(m(r, {
                    uA: !1
                }), A4(EKn, 2, r.CX, r.fF, h), k([
                    _Yn
                ]));
            case 2:
                var B = n.b, j = A2(Uur, x = n.a, r.Av);
                if (j.$) return v(r, Dp, h);
                var S = A2(EUn, B, (G = j.a).hX), z = S.a, U = S.b, E = S.c, P = A2(uc, Dp, A2(Cp, function(n) {
                    return 2 === n.$ && Lur(n.a) ? A2(gur, G, r.Av) : Dp;
                }, E)), T = m(G, {
                    di: !0,
                    hX: z
                }), F = (e = A4(Far, E, x, T, r), function() {
                    if (i(E, Ht(ISn))) return Har(e);
                    if (E.$) return Dp;
                    var n = E.a;
                    return 2 === n.$ && Lur(n.a) ? Har(e) : Dp;
                }());
                return l = A2(uc, h, A2(Cp, function(n) {
                    return 1 === n.$ ? A3(Rur, e, T, n.a) : h;
                }, E)), v(e, Hu(k([
                    A2(jp, tur(x), U),
                    P,
                    F
                ])), l);
            case 3:
                var L, M = A4($ur, r.dw, r.fF, L = A2(Xb, _ur, A = A2(Xb, e3n, r.mS)), A6(Tar, r.CX, r.g0, r.e0, L, A, A2(JEn, Rar, r.Av))), H = (_ = M.a, M.b), R = (q = A5(uar, mKn(r.fF), nKn(r.lj), r.h5, r.cL, _), e = m(r, {
                    Av: _,
                    e7: q
                }), b(H, A2(Cp, function(n) {
                    return Bur(n.hX);
                }, A2(Xb, function(n) {
                    return Ht(n.b);
                }, Gb(we(_.b))))));
                if (R.a && !R.b.$) {
                    var O = A3(mQ, Dur, R.b.a, e.g6), N = O.b, I = m(e, {
                        g6: O.a
                    });
                    return v(I, Hu(k([
                        N,
                        lar(I),
                        (cn = Kvn(_) - 1, on = ee(cn), A2(w7, "Dependent Added", k([
                            _7(TYn),
                            y7(on)
                        ]))),
                        Har(I)
                    ])), har(q));
                }
                return v(e, Hu(A2(Xi, wur(_), A2(Ot, zur(_), $(yur(_), k([
                    Har(e)
                ]))))), har(q));
            case 11:
                var V = n.a, W = A4(t1, Dur, KK(qur), V, r.g6);
                return N = W.b, v(m(r, {
                    g6: W.a
                }), N, h);
            case 12:
                return v(r, qEn(n.a), h);
            case 4:
                x = n.a;
                var Z = n.b;
                return v(e = m(r, {
                    Av: A3(gar, $ar(!0), x, r.Av)
                }), Hu(k([
                    A2(Vur, r.Av, x),
                    A5(mar, r.gx, x, Z, r.e6, r.dw)
                ])), h);
            case 5:
                x = n.a;
                var X = n.b;
                return 3 === X.$ ? v(e = m(r, {
                    Av: A2(nmn, x, r.Av)
                }), Har(e), h) : v(m(r, {
                    Av: A3(gar, $ar(!1), x, r.Av)
                }), Dp, A2(uA, 1, X));
            case 6:
                return v(m(r, {
                    Av: A2(nmn, x = n.a, r.Av)
                }), A2(Vur, r.Av, x), h);
            case 7:
                var G;
                return x = n.a, v(e = m(r, {
                    Av: A3(gar, our(!(G = n.b).be), x, fur(r.Av))
                }), lar(e), h);
            case 13:
                return v(m(r, {
                    g0: Ht(A2(cp, nG, n.a))
                }), Dp, h);
            case 14:
                var J = n.a;
                n: for(;;)switch(J.$){
                    case 3:
                        return v(m(r, {
                            fl: Ht(J.a),
                            fm: Rt
                        }), Dp, h);
                    case 2:
                        if (5 === J.a.$) {
                            var Y = Ht(WGn(k([
                                KD(n3n(J.a.b))
                            ])));
                            return v(m(r, {
                                fm: Y
                            }), Dp, h);
                        }
                        break n;
                    default:
                        break n;
                }
                return v(r, Dp, A2(uA, 1, J));
            case 16:
                var Q = A2(M3n, B = n.a, r.cR), K = Q.a, nn = Q.b, rn = Q.c, tn = rn.$ ? Dp : A2(Eu, ru, gu(rn.a ? uur : aur));
                return v(m(r, {
                    cR: K
                }), Hu(k([
                    A2(jp, nur, nn),
                    tn
                ])), h);
            case 17:
                var en = A2(uc, Ru, A2(Xb, function(n) {
                    return ec(n);
                }, $u(n.a))), un = A2(uc, Ru, ec(r.w_.B9));
                return v(r, A4(HQn, r.lj, r.CX, un, en) ? A2(HKn, un, en) : Dp, h);
            default:
                var an = n.a;
                return 3 === an.$ ? v(e = m(r, {
                    oh: Ht(an.a)
                }), Har(e), h) : v(r, Dp, A2(uA, 1, an));
        }
        var cn, on, fn;
    }), Nar = F2(function(n, r) {
        var t = r.b;
        return A2(W3, r.a + 1, A2(Ot, b(n.a, n.b), t));
    }), Iar = function(n) {
        return {
            $: 1,
            a: n
        };
    }, Var = F2(function(n, r) {
        return {
            $: 7,
            a: n,
            b: r
        };
    }), War = function(n) {
        return n.be ? "collapser-closed" : "collapser-open";
    }, Zar = F2(function(n, r) {
        return n ? KD(" ") : Mur(r) ? msn : Nz;
    }), Xar = F2(function(n, r) {
        return {
            $: 4,
            a: n,
            b: r
        };
    }), Gar = function(n) {
        return n.u8;
    }, Jar = F3(function(n, r, t) {
        var e, u = t.a, a = t.b, i = (e = a.cC).$ ? function(n) {
            return {
                $: 6,
                a: n
            };
        }(u) : A2(Xar, u, e.a);
        return A2(Ik, k([
            Nk("member-wrap--remove")
        ]), k(a.u8 ? [
            A2(fz, k([
                r4,
                ZS(!0),
                Don(!0)
            ]), k([
                ad(n(Gar))
            ]))
        ] : [
            A2(fz, k([
                vz(k([
                    Nk("w-8 text-primary-500")
                ])),
                ZS(r),
                QS(i)
            ]), k([
                A2(US, k([
                    LV(L1n)
                ]), 7)
            ])),
            A2(fz, k([
                r4,
                ZS(r),
                QS(i),
                vz(k([
                    Nk("ml-2 hidden md:inline-block")
                ]))
            ]), k([
                ad(n(YRn))
            ]))
        ]));
    }), Yar = F6(function(n, r, t, e, u, a) {
        var i = a.a, c = a.b, o = A2(yu, aI, c.o);
        return A2(Ik, k([
            Nk("member-title")
        ]), k([
            A2(Ik, k([
                Nk("flex")
            ]), k([
                A2(Ik, k([
                    Nk("flex flex-grow items-center flex-wrap md:flex-nowrap")
                ]), k([
                    A2(Ik, k([
                        Nk("flex w-full md:w-auto")
                    ]), k([
                        A2(Gk, k([
                            Nk("member-label")
                        ]), k([
                            A2(mx, h, k([
                                ad(r(A2(Zar, n, c.hX)))
                            ]))
                        ]))
                    ])),
                    A2(Ik, k([
                        Nk("flex flex-grow-0 md:flex-grow")
                    ]), k([
                        A2(IZ, !Fnn(c.a5), A2(Gk, k([
                            Nk("member-name md:ml-4")
                        ]), k([
                            Jx(c.a5)
                        ])))
                    ]))
                ])),
                A2(Ik, k([
                    Nk("flex items-center")
                ]), k([
                    A2(Ik, k([
                        Nk("flex")
                    ]), k([
                        A2(IZ, !Mur(c.hX) && !u, A3(Jar, r, e, b(i, c)))
                    ])),
                    A2(IZ, !t, A2(Ik, k([
                        Nk("flex")
                    ]), k([
                        A2(Ik, k([
                            Nk("collapser")
                        ]), k([
                            A2(Ik, k([
                                Nk(War(c))
                            ]), k([
                                A2(fz, k([
                                    pz,
                                    ZS(e || !cur(c) && !c.be),
                                    QS(A2(Var, i, c))
                                ]), k([
                                    A2(US, h, 6)
                                ]))
                            ]))
                        ]))
                    ])))
                ]))
            ])),
            A2(Ik, k([
                jz(jur(c))
            ]), k([
                A2(OW, r, o)
            ]))
        ]));
    }), Qar = F6(function(n, r, t, e, u, a) {
        var i = a.a, c = a.b, o = t && Mur(c.hX);
        return b(c.hX.qU, A2(Ik, k([
            Nk("member-wrap"),
            jz(c.hX.qU)
        ]), k([
            A6(Yar, n, r, o, e, u, b(i, c)),
            A2(IZ, !c.be, A2(Ik, h, k([
                gx,
                A2(lV, k([
                    dV(NZ)
                ]), k([
                    A2(iV, k([
                        UZ(12),
                        jV(k([
                            Nk("p-3")
                        ]))
                    ]), k([
                        A2(px, tur(i), A3(vFn, r, k([
                            xTn(e),
                            Iar(u)
                        ]), c.hX))
                    ]))
                ]))
            ])))
        ])));
    }), Kar = F2(function(n, r) {
        var t, e = (t = r.h9).$ ? r.Av : A2(Nar, t.a, r.Av), u = KQn(r.lj);
        return A2(Ik, k([
            jz(Zer)
        ]), k([
            A3($U, "div", h, A2($4, A5(Qar, u, n, A2(Xur, r.h5, r.cL), r.uA, r.u$), e))
        ]));
    }), nir = F2(function(n, r) {
        return ED(r) ? Sq : A2(Ik, k([
            Nk("mt-4")
        ]), k([
            A2(OW, n, A2(yu, function(n) {
                return JN(n);
            }, r))
        ]));
    }), rir = F2(function(n, r) {
        return A2(Ik, k([
            Nk("flex-grow")
        ]), k([
            A2(Kar, n, r),
            A2(nir, n, r.e7)
        ]));
    }), tir = F2(function(n, r) {
        return r.r8(n);
    }), eir = F2(function(n, r) {
        return A2(Ot, function(n) {
            return {
                $: 3,
                a: n
            };
        }(n), r);
    }), uir = F3(function(n, r, t) {
        if (KQn(GIn(r))) return t;
        var e = function() {
            var n = mKn(r);
            if (n.$) return Id.lX;
            var t = n.a;
            return t > 0 ? tir(ee(t)) : Id.s2;
        }();
        return A2(eir, n(e), t);
    }), air = F2(function(n, r) {
        if (n.$) return !0;
        var t = n.a;
        return 0 > s(rar(r), t);
    }), iir = F2(function(n, r) {
        return A2(Ot, function(n) {
            return {
                $: 4,
                a: n
            };
        }(n), r);
    }), cir = F5(function(n, r, t, e, u) {
        return (e || !A2(air, r, t) ? ru : iir(n(Id.lJ)))(u);
    }), oir = F2(function(n, r) {
        var t = A2(xar, 3, r.CX);
        return (nKn(r.lj) && !t ? t6n(r.fl) : Q9n(h))(A2(J9n, r.fm, A2(r6n, r.mS, A5(cir, n, mKn(r.fF), r.Av, r.u$, A3(uir, n, r.fF, A2(G9n, r.uA, A2(utr, r.uA, A2(n6n, A4(x1n, n, r.lj, r.CX, r.w_.B9), h))))))));
    }), fir = F2(function(n, r) {
        return A2(Ik, k([
            Nk("hidden md:block")
        ]), k([
            A2(px, nur, A3(i4n, n, A2(oir, n, r), r.cR))
        ]));
    }), sir = F2(function(n, r) {
        return A2(px, nur, A3(i4n, n, o4n(A2(oir, n, r)), r.cR));
    }), lir = F2(function(n, r) {
        return k([
            A2(Ik, k([
                Nk("signup__body--contents")
            ]), k([
                A2(XT, k([
                    jX,
                    LS(q3),
                    A2(_1n, 1, p1n),
                    bz(gz)
                ]), k([
                    KQn(r.lj) ? ad(n(Id.lK)) : ad(n(Id.lI))
                ])),
                A2(Ik, k([
                    Nk("flex flex-grow w-full")
                ]), k([
                    A2(rir, n, r),
                    A2(fir, n, r)
                ])),
                A2(sir, n, r)
            ]))
        ]);
    }), dir = F2(function(n, r) {
        return {
            gF: function() {
                var t = b(r.cL, r.h5);
                n: for(;;){
                    r: for(;;){
                        t: for(;;){
                            e: for(;;)switch(t.b.$){
                                case 1:
                                    if (1 === t.a.$) break n;
                                    break r;
                                case 0:
                                    if (1 === t.a.$) break n;
                                    break t;
                                case 2:
                                    switch(t.a.$){
                                        case 1:
                                            break n;
                                        case 2:
                                            break e;
                                        default:
                                            return k([
                                                l4n(r.dw)
                                            ]);
                                    }
                                default:
                                    switch(t.a.$){
                                        case 1:
                                            break n;
                                        case 2:
                                            break e;
                                        default:
                                            return A2(lir, n, r);
                                    }
                            }
                            return k([
                                l4n(r.dw)
                            ]);
                        }
                        return Yk;
                    }
                    return Yk;
                }
                return Yk;
            }(),
            wD: hk(r.dw)
        };
    }), bir = sZn({
        zO: Yer,
        Ab: Qer,
        Ct: Ker,
        Dd: function(n) {
            return xk(A2(Ot, A2(xD, nur, A0n()), A2(Ot, mYn(rur), A2($4, eur, n.Av))));
        },
        DB: Oar,
        DH: dir
    }), vir = function(n) {
        return {
            $: 9,
            a: n
        };
    }, mir = function(n) {
        return {
            $: 1,
            a: n
        };
    }, pir = function(n) {
        return {
            $: 6,
            a: n
        };
    }, $ir = "content-container", hir = F4(function(n, r, t, e) {
        var u = GIn(r), a = function() {
            var r = r0n(e.iu);
            if (r.$) return Dp;
            var u = r.a;
            return A4(U2n, t.gx, $k(n), u, vir);
        }(), i = function() {
            var r = b(oYn(t), t.CX);
            if (3 === r.b.$) {
                if (r.a.$) return v(h, oc, i = r.b.a);
                var e = r.a.a, i = r.b.a;
                return v(k([
                    A5(FQn, t.gx, $k(n), pZn(u), e, mir),
                    a
                ]), Mx, i);
            }
            return v(h, oc, h);
        }(), c = i.a, o = i.b, f = i.c;
        return b({
            fV: ZJn(t),
            gx: t.gx,
            oh: Rt,
            g0: Rt,
            g7: t.g7,
            hl: GL,
            kj: t.kj,
            Av: o,
            e6: t.e6,
            h5: o,
            h8: GL,
            ad: h,
            dw: n,
            uA: !1,
            fm: Rt,
            by: Rt,
            cR: A3(i0n, Rk(t.kj), $ir, d0n(n)),
            lj: u,
            iO: Mx,
            fF: r,
            CX: f,
            w_: e
        }, Hu(A2(Ot, A2(Eu, pir, by), c)));
    }), gir = function(n) {
        return {
            $: 8,
            a: n
        };
    }, wir = A3(zy, "plan", l_(CQn), Ke(function(n) {
        return {
            t6: n
        };
    })), kir = A2(qy, wir, Ke(ru)), xir = F2(function(n, r) {
        return A2($y, k([
            "signup_page_plans"
        ]), A2(PQn, n, r));
    }), yir = F4(function(n, r, t, e) {
        return A4(dC, z9(n), Ey(kir), e, bC(A2(xir, r, t)));
    }), _ir = F2(function(n, r) {
        return i(r.gx, n.gx) ? b(r, Dp) : b(m(r, {
            gx: n.gx,
            kj: n.kj,
            iO: Mx
        }), A4(yir, n.gx, $k(r.dw), pZn(r.lj), gir));
    }), Cir = F2(function(n, r) {
        return r;
    }), Dir = function(n) {
        return {
            $: 2,
            a: n
        };
    }, Air = function(n) {
        return {
            $: 3,
            a: n
        };
    }, qir = {
        $: 0
    }, Bir = function(n) {
        return {
            $: 7,
            a: n
        };
    }, jir = F2(function(n, r) {
        return {
            t6: n,
            fl: r
        };
    }), Sir = function(n) {
        return {
            $: 5,
            a: n
        };
    }, zir = function(n) {
        return n.l7;
    }, Uir = F2(function(n, r) {
        var t = A2(DL, function(r) {
            return 0 > s(zir(r), n);
        }, y6n(r)), e = t.a;
        return oe(t.b) > 0 ? h : e;
    }), Eir = F2(function(n, r) {
        var t, e, u = !(t = Sar(r)).$ && 0 > s(n, t.a), a = !(e = jar(r)).$ && s(n, e.a) > 0;
        return !(u || a);
    }), Pir = function(n) {
        return A2(uc, h, A2(Cp, function(r) {
            return A2(Tc, function(r) {
                return !A2(Eir, zir(r), n.t6);
            }, y6n(r));
        }, n.fl));
    }, Tir = F2(function(n, r) {
        var t, e = !ED(Pir(r));
        return !(t = b(n, r.fl)).a.$ && !t.b.$ && !ED(A2(Uir, t.a.a, t.b.a)) || e;
    }), Fir = F2(function(n, r) {
        var t = pKn(n);
        return A2(W$n, Tir(t), r);
    }), Lir = function(n) {
        return oe(A2(Tc, function(n) {
            return $H(n.fl);
        }, n));
    }, Mir = F2(function(n, r) {
        return {
            $: 3,
            a: n,
            b: r
        };
    }), Hir = function(n) {
        var r = "plan-description-" + n;
        return A2(dc, Mir(n), ay(r));
    }, Rir = function(n) {
        return n.t6;
    }, Oir = F2(function(n, r) {
        return A2(Tir, n, r) ? Rt : Ht(r);
    }), Nir = function(n) {
        var r = pKn(n.fF), t = function() {
            var t = n.h5;
            if (3 === t.$) {
                var e = t.a, u = GKn(e), a = a3n(F0n(e));
                return A4(ZKn, n.lj, n.CX, u, n.w_.B9) ? A2(Xb, Oir(r), Gb(A2(Tc, function(n) {
                    return i(u3n(n.t6), A2(uc, "", a));
                }, n.ad))) : Rt;
            }
            return Rt;
        }(), e = Gb(A2(Ep, Oir(r), n.ad));
        return m(n, {
            by: WFn(k([
                t,
                e
            ]))
        });
    }, Iir = F2(function(n, r) {
        var t = r.p5, e = r.y8, u = r.y7;
        return A2(w7, "Form Field Errored", k([
            _7(n),
            zYn(t),
            SYn(e),
            jYn(u)
        ]));
    }), Vir = (wG = {
        y7: "One or more members violate the age validation for every plan option.",
        y8: "Signup Disqualified",
        p5: "Invalid Plan Options"
    }, A2(Iir, TYn, wG)), Wir = F2(function(n, r) {
        return A2($y, k([
            "online_enrollments",
            r,
            "plan"
        ]), gy(n));
    }), Zir = F5(function(n, r, t, e, u) {
        return A4(kq, z9(n), CQn, u, A2(xq, function(n) {
            var r;
            return vk(k([
                (r = Ht(n), b("plan", r.$ ? bk : vk(k([
                    b("id", mk(r.a))
                ]))))
            ]));
        }(e), bC(A2(Wir, r, t))));
    }), Xir = F2(function(n, r) {
        return {
            $: 2,
            a: n,
            b: r
        };
    }), Gir = F3(function(n, r, t) {
        return A2(yu, function(t) {
            return i(u3n(t.t6), u3n(n)) ? A2(jir, t.t6, Ht(r)) : t;
        }, t);
    }), Jir = function(n) {
        return {
            $: 10,
            a: n
        };
    }, Yir = F2(function(n, r) {
        return {
            $: 4,
            a: n,
            b: r
        };
    }), Qir = F4(function(n, r, t, e) {
        var u, a = vk((u = e, A2(Ot, b("plan", QIn(u3n(t))), u)));
        return A4(GBn, n, r, a, Yir(t));
    }), Kir = function(n) {
        var r, t = n.h5;
        if (3 === t.$) {
            var e = t.a;
            if (nKn(n.lj)) {
                var u = $k(n.dw), a = A2(wq, function(n) {
                    return Orr(n);
                }, J3n(e)), i = (r = A3(Hrr, "coupon_code", function(n) {
                    return hmn(Mrr(n));
                }, n.oh), A2(Ot, b("members", a), r));
                return Hu(A2(yu, function(r) {
                    return A4(Qir, n.gx, u, r.t6, i);
                }, n.ad));
            }
            return A4(I3n, n.gx, $k(n.dw), x2n(e), Jir);
        }
        return Dp;
    }, ncr = F2(function(n, r) {
        switch(n.$){
            case 1:
                var t = n.a, e = m(r, {
                    h5: t
                });
                if (3 === t.$) {
                    var u = t.a, a = (H = r.fV).$ ? Dp : MKn(H.a), i = ZYn(u), c = k(i ? [
                        DYn(GKn(u)),
                        wYn,
                        gYn
                    ] : [
                        DYn(GKn(u)),
                        gYn
                    ]);
                    return v(m(e, {
                        fV: Rt,
                        g7: i
                    }), Hu(k([
                        a,
                        A4(yir, r.gx, $k(r.dw), pZn(r.lj), gir)
                    ])), c);
                }
                return v(e, Dp, A2(uA, 1, t));
            case 8:
                var o = n.a;
                if (e = m(r, {
                    iO: o
                }), 3 === o.$) {
                    var f = m(e, {
                        ad: A2(yu, function(n) {
                            return A2(jir, n, Rt);
                        }, Oln(A2(yu, function(n) {
                            return n.t6;
                        }, o.a)))
                    });
                    return v(f, Kir(f), h);
                }
                return v(e, Dp, A2(uA, 1, o));
            case 0:
                var l = r.h5;
                if (3 === l.$) {
                    u = l.a;
                    var d = r.by;
                    if (d.$) return v(r, Dp, k([
                        A2(nA, 1, A2(XN, Hzn, Rir))
                    ]));
                    var p = d.a, $ = $k(r.dw), g = u3n(p.t6), w = x2n(u);
                    return v(m(r, {
                        uA: !0
                    }), A5(Zir, r.gx, $, w, g, Bir), h);
                }
                return v(r, Dp, h);
            case 7:
                var x = n.a;
                return e = m(r, {
                    uA: !1
                }), 3 === x.$ ? v(e, A4(EKn, 3, r.CX, r.fF, h), k([
                    _Yn
                ])) : v(e, Dp, A2(uA, 1, x));
            case 2:
                var y = A2(M3n, n.a, r.cR), _ = y.a, C = y.b, D = y.c, A = D.$ || D.a ? Dp : A2(Eu, ru, gu(qir));
                return v(m(r, {
                    cR: _
                }), Hu(k([
                    A2(jp, Dir, C),
                    A
                ])), h);
            case 3:
                var q = A2(uc, Ru, A2(Xb, function(n) {
                    return ec(n);
                }, $u(n.a))), B = A2(uc, Ru, ec(r.w_.B9));
                return v(r, A4(HQn, r.lj, r.CX, B, q) ? A2(HKn, B, q) : Dp, h);
            case 4:
                var j = n.a, S = n.b;
                n: for(;;)switch(S.$){
                    case 3:
                        var z = m(r, {
                            ad: A3(Gir, j, S.a, r.ad),
                            fm: Rt
                        }), U = function() {
                            if (!Lir(z.ad)) {
                                var n = Hu(A2(yu, jp(Sir), A2(yu, Hir, A2(yu, function(n) {
                                    return u3n(n.t6);
                                }, z.ad))));
                                return v(Nir(z), Hu(k([
                                    A4(TKn, 3, z.CX, z.fF, h),
                                    n
                                ])), A2(Fir, z.fF, z.ad) ? Vir : Dp);
                            }
                            return v(z, Dp, Dp);
                        }();
                        return v(U.a, Hu(k([
                            U.c,
                            U.b
                        ])), h);
                    case 2:
                        if (5 === S.a.$) {
                            var E = Ht(WGn(k([
                                KD(n3n(S.a.b))
                            ])));
                            return v(m(r, {
                                fm: E
                            }), Dp, h);
                        }
                        break n;
                    default:
                        break n;
                }
                return v(r, Dp, A2(uA, 1, S));
            case 5:
                var P = function(n) {
                    switch(n.$){
                        case 0:
                        case 1:
                            return b(Dp, Ht(function(n) {
                                return {
                                    $: 0,
                                    a: n
                                };
                            }(n.a)));
                        case 2:
                            return b(Dp, Ht(function(n) {
                                return {
                                    $: 1,
                                    a: n
                                };
                            }(r = n.a)));
                        case 3:
                            var r = n.a, t = n.b;
                            if (t.$) return b(Dp, Rt);
                            var e = t.a, u = s(e.vx.qI, e.jG.qI + 1) > 0;
                            return b(Dp, Ht(A2(Xir, r, u)));
                        default:
                            return b(Dp, Rt);
                    }
                }(n.a), T = P.a, F = P.b, L = function() {
                    if (F.$) return b(r, Dp);
                    switch(F.a.$){
                        case 0:
                            return b(m(r, {
                                by: Ht(F.a.a)
                            }), Dp);
                        case 1:
                            return b(m(r, {
                                hl: A2(A2(QL, n = F.a.a, r.hl) ? fHn : JL, n, r.hl)
                            }), Dp);
                        default:
                            var n, t = F.a, e = t.b, u = A2(e ? JL : fHn, n = t.a, r.h8);
                            return b(m(r, {
                                hl: e ? r.hl : A2(JL, n, r.hl),
                                h8: u
                            }), Dp);
                    }
                }();
                return A = L.b, v(e = L.a, Hu(k([
                    A2(jp, Sir, T),
                    A
                ])), h);
            case 6:
                return v(m(r, {
                    g0: Ht(A2(cp, nG, n.a))
                }), Dp, h);
            case 9:
                var M = n.a;
                return 3 === M.$ ? v(e = m(r, {
                    oh: Ht(M.a)
                }), Kir(e), h) : v(r, Dp, A2(uA, 1, M));
            default:
                return v(m(r, {
                    Av: n.a
                }), Dp, h);
        }
        var H;
    }), rcr = function(n) {
        var r = A2(Ep, ru, A2(yu, B8, A2(ae, "=", n)));
        return r.b && r.b.b && !r.b.b.b ? Ht(A2(Ax, r.a, r.b.a)) : Rt;
    }, tcr = function(n) {
        var r = n.iu;
        return r.$ ? h : A2(Ep, rcr, A2(ae, "&", r.a));
    }, ecr = function(n) {
        return {
            $: 3,
            a: n
        };
    }, ucr = {
        yR: !1,
        hl: GL,
        e0: Rt,
        h8: GL,
        ip: h,
        dw: Rt,
        jC: Rt,
        w5: Rt
    }, acr = F2(function(n, r) {
        switch(n.$){
            case 0:
                return m(r, {
                    yR: n.a
                });
            case 1:
                return m(r, {
                    ip: n.a
                });
            case 2:
                return m(r, {
                    w5: n.a
                });
            case 3:
                return m(r, {
                    e0: Ht(n.a)
                });
            case 4:
                return m(r, {
                    jC: Ht(n.a)
                });
            case 5:
                return m(r, {
                    dw: Ht(n.a)
                });
            case 6:
                return m(r, {
                    hl: n.a
                });
            default:
                return m(r, {
                    h8: n.a
                });
        }
    }), icr = {
        $: 4
    }, ccr = function(n) {
        return {
            $: 1,
            a: n
        };
    }, ocr = function(n) {
        return n.oV;
    }, fcr = function(n) {
        return {
            $: 2,
            a: n
        };
    }, scr = F4(function(n, r, t, e) {
        var u = A2(QL, n, r), a = !u, i = A2(QL, n, t), c = "plan-description-" + n;
        if (e.$) return Sq;
        var o = e.a;
        return A2(Ik, k([
            Nk("plan-quote__description-wrapper")
        ]), k([
            A2(Ik, k([
                jz(c),
                Nk("plan-quote__description rich-text"),
                rz(k([
                    b("plan-quote__description--collapsed", a)
                ]))
            ]), A2(yu, px(hu), Nj(o))),
            i ? A2(iU, k([
                Nk("plan-quote__description-toggle"),
                Eq(fcr(n))
            ]), k([
                A2(Gk, k([
                    Nk("plan-quote__description-toggle-text")
                ]), k(u ? [
                    ad("See Less "),
                    A2(US, k([
                        Sz,
                        Vq("plan-quote__description-toggle-icon plan-quote__description-toggle-icon--up")
                    ]), 6)
                ] : [
                    ad("See More "),
                    A2(US, k([
                        Sz,
                        Vq("plan-quote__description-toggle-icon plan-quote__description-toggle-icon--down")
                    ]), 6)
                ]))
            ])) : Sq
        ]));
    }), lcr = F2(function(n, r) {
        var t = n.$ ? Sq : A2(gV, k([
            vV(n.a)
        ]), k([
            ad("Update added members")
        ]));
        return A2(Ik, h, k([
            A2(PB, k([
                BB,
                Qk(k([
                    Nk("message-box__content mr-1")
                ]))
            ]), k([
                Jx(_6n(r)),
                ad(" cannot be enrolled.")
            ])),
            t
        ]));
    }), dcr = F2(function(n, r) {
        return r.ui(n);
    }), bcr = F3(function(n, r, t) {
        var e = A2(Uir, r, t);
        return oe(e) > 0 ? Ht(b(dcr(ee(r)), A2(Ik, h, A2(yu, function(r) {
            return A2(lcr, n, r);
        }, e)))) : Rt;
    }), vcr = F3(function(n, r, t) {
        return A2(t.l8, n, r);
    }), mcr = F2(function(n, r) {
        return A2(vcr, ee(n), ee(r));
    }), pcr = F3(function(n, r, t) {
        var e = b(A2(Xb, function(n) {
            return 1 > n ? Rt : Ht(n);
        }, r), t);
        return e.a.$ ? e.b.$ ? Rt : Ht(A2(mBn, n, kBn(e.b.a))) : Ht(A2(mBn, n, e.b.$ ? _Bn(e.a.a) : A2(mcr, e.a.a, e.b.a)));
    }), $cr = F3(function(n, r, t) {
        var e = Pir(t);
        return oe(e) > 0 ? A2(Cp, function(n) {
            return b(n, A2(Ik, h, A2(yu, function(n) {
                return A2(lcr, r, n);
            }, e)));
        }, A3(pcr, n, Sar(t.t6), jar(t.t6))) : Rt;
    }), hcr = F5(function(n, r, t, e, u) {
        var a, i = k([
            Phn(0)
        ]), c = A3($cr, r, e, u), o = (a = b(t, u.fl)).a.$ || a.b.$ ? Rt : A3(bcr, e, a.a.a, a.b.a), f = A2(z$, o, c);
        if (f.$) return Sq;
        var s = f.a, l = s.a, d = s.b;
        return A2(Ik, k([
            Nk("radio-card__row")
        ]), k([
            A2(px, hu, A3(Ihn, i, Ht(n(l)), d))
        ]));
    }), gcr = F2(function(n, r) {
        var t = r.fl;
        if (t.$) return Sq;
        var e = t.a, u = Ht(mPn(e)), a = pPn(e);
        return A2(Ik, k([
            Nk("plan-quote__amount")
        ]), k([
            A2(px, hu, A7(kPn, n, a, !1, u, yz, !1, !1))
        ]));
    }), wcr = F3(function(n, r, t) {
        var e, u = !A2(Tir, r.e0, t), a = !(e = r.w5).$ && i(u3n(e.a.t6), u3n(t.t6)), c = u ? function(n) {
            return {
                $: 0,
                a: n
            };
        }(t) : icr;
        return A2(Ik, k([
            Nk("radio-card plan-quote"),
            rz(k([
                b("radio-card--selected", a),
                b("radio-card--disabled", !u)
            ])),
            Eq(c)
        ]), k([
            A2(Ik, k([
                Nk("radio-card__radio")
            ]), k([
                A2(IU, k([
                    rwn(a),
                    ZU(A2(sc, ccr, rm(t))),
                    twn(r.yR || !u)
                ]), h)
            ])),
            A2(Ik, k([
                Nk("radio-card__content")
            ]), k([
                A2(Ik, k([
                    Nk("radio-card__row")
                ]), k([
                    A2(Ik, k([
                        Nk("plan-quote__name")
                    ]), k([
                        A2(PB, k([
                            zV
                        ]), k([
                            ad(v6n(t.t6))
                        ]))
                    ])),
                    A2(gcr, n, t)
                ])),
                A4(scr, u3n(t.t6), r.hl, r.h8, ocr(t.t6)),
                A5(hcr, n, r.dw, r.e0, r.jC, t)
            ]))
        ]));
    }), kcr = F2(function(n, r) {
        var t = A3(ce, acr, ucr, r);
        return A2(Ik, k([
            Nk("mb-4")
        ]), A2(yu, A2(wcr, n, t), t.ip));
    }), xcr = F2(function(n, r) {
        var t, e = A2(QV, k([
            Sx(di({
                v2: pZn(r.lj)
            }))
        ]), tcr(r.w_.B9)), u = A2(Ot, function(n) {
            return {
                $: 1,
                a: n
            };
        }(r.ad), A2(Ot, function(n) {
            return {
                $: 2,
                a: n
            };
        }(r.by), A2(Ot, function(n) {
            return {
                $: 0,
                a: n
            };
        }(r.uA), A2(Ot, function(n) {
            return {
                $: 4,
                a: n
            };
        }(e), A2(Ot, function(n) {
            return {
                $: 5,
                a: n
            };
        }(r.dw), A2(Ot, function(n) {
            return {
                $: 6,
                a: n
            };
        }(r.hl), A2(Ot, function(n) {
            return {
                $: 7,
                a: n
            };
        }(r.h8), (t = pKn(r.fF)).$ ? h : k([
            ecr(t.a)
        ]))))))));
        return A2(Ik, k([
            Nk("flex flex-col flex-grow w-full"),
            jz($ir)
        ]), k([
            A2(px, Sir, A2(kcr, n, u))
        ]));
    }), ycr = function(n) {
        return kQn(n);
    }, _cr = F2(function(n, r) {
        var t = nKn(r.lj) && (1 >= oe(r.ad) || YS(r.by)), e = A2(Cp, ycr, A2(Cp, function(n) {
            return n.t6;
        }, r.by));
        return (t ? t6n(A2(Xb, function(n) {
            return n.fl;
        }, r.by)) : Q9n(W9n(Z9n(r.Av))))(A2(J9n, r.fm, A2(r6n, e, A2(G9n, r.uA, A2(utr, r.uA, A2(n6n, A4(x1n, n, r.lj, r.CX, r.w_.B9), h))))));
    }), Ccr = F2(function(n, r) {
        return A2(Ik, k([
            Nk("hidden md:block")
        ]), k([
            A2(px, Dir, A3(i4n, n, A2(_cr, n, r), r.cR))
        ]));
    }), Dcr = F2(function(n, r) {
        return A2(px, Dir, A3(i4n, n, o4n(A2(_cr, n, r)), r.cR));
    }), Acr = F2(function(n, r) {
        return k([
            A2(Ik, k([
                Nk("signup__body--contents")
            ]), k([
                A2(XT, k([
                    jX,
                    LS(p1n),
                    bz(gz)
                ]), k([
                    ad("Select your membership")
                ])),
                A2(lV, k([
                    dV(NZ)
                ]), k([
                    A2(iV, k([
                        UZ(12),
                        GZ(8)
                    ]), k([
                        A2(xcr, n, r)
                    ])),
                    A2(iV, k([
                        GZ(4),
                        jV(k([
                            Nk("hidden md:block")
                        ]))
                    ]), k([
                        A2(Ccr, n, r)
                    ]))
                ])),
                A2(Dcr, n, r)
            ]))
        ]);
    }), qcr = F2(function(n, r) {
        return {
            gF: function() {
                var t = b(r.h5, Lir(r.ad));
                switch(t.a.$){
                    case 1:
                    default:
                        return Yk;
                    case 2:
                        return k([
                            l4n(r.dw)
                        ]);
                    case 3:
                        return t.b ? r.fm.$ ? A2(Acr, n, r) : Yk : A2(Acr, n, r);
                }
            }(),
            wD: hk(r.dw)
        };
    }), Bcr = sZn({
        zO: hir,
        Ab: _ir,
        Ct: Cir,
        Dd: function() {
            return xk(k([
                A2(xD, Dir, A0n()),
                mYn(Air)
            ]));
        },
        DB: ncr,
        DH: qcr
    }), jcr = function(n) {
        return {
            $: 14,
            a: n
        };
    }, Scr = function(n) {
        return {
            $: 5,
            a: n
        };
    }, zcr = function(n) {
        return {
            $: 4,
            a: n
        };
    }, Ucr = function(n) {
        return {
            $: 3,
            a: n
        };
    }, Ecr = function(n) {
        return {
            $: 2,
            a: n
        };
    }, Pcr = function(n) {
        return {
            $: 18,
            a: n
        };
    }, Tcr = function(n) {
        return xAn(ZIn(n));
    }, Fcr = F2(function(n, r) {
        return Tcr(n) && !r.$;
    }), Lcr = "content-container", Mcr = function(n) {
        return {
            $: 0,
            a: n
        };
    }, Hcr = function(n) {
        return n.rB;
    }, Rcr = F2(function(n, r) {
        var t = n.lj, e = function(n) {
            return n.rD;
        }(t) || Hcr(t) || htr(t) ? Ht(XIn(t)) : Rt, u = v8(n.kR), a = b8(n.kR), i = n.A, c = NUn(i), o = OUn(i), f = function() {
            var n = XAn(i.kb);
            if (1 === n.$) {
                var r = n.a, t = n.b;
                return tI(t) ? b(Rt, Rt) : b(VAn(r), Ht(t));
            }
            return b(Rt, Rt);
        }(), s = f.a, l = f.b, d = nKn(t) ? b(Rt, Ht(!0)) : b(Ht(!0), Rt);
        return m(r, {
            jK: d.a,
            jL: d.b,
            kb: s,
            hP: a,
            kw: c,
            sS: o,
            h3: u,
            lj: e,
            xy: l
        });
    }), Ocr = function(n) {
        var r = Rcr(n);
        return A4(uqn, n.gx, $k(n.dw), r, Mcr);
    }, Ncr = F4(function(n, r, t, e) {
        return A4(dC, z9(n), uln, e, bC(A2($y, k([
            t
        ]), eqn(r))));
    }), Icr = F3(function(n, r, t) {
        return m(t, {
            lj: A2(Cp, XIn, n),
            xy: r
        });
    }), Vcr = function(n) {
        return A2(n0n, "practitioner", n);
    }, Wcr = F4(function(n, r, t, e) {
        var u = a8n(e.iu), a = function() {
            if (u.$) return Dp;
            var r = u.a;
            return A4(t8n, t.gx, $k(n), r, Pcr);
        }(), c = GIn(r), o = l8, f = oYn(t), s = A4(KAn, t.gx, $k(n), A2(Icr, Ht(c), Rt), Ucr), l = function() {
            var r = r0n(e.iu);
            if (r.$) return Dp;
            var u = r.a;
            return A4(U2n, t.gx, $k(n), u, jcr);
        }(), d = function() {
            if (i(u, Rt)) {
                var r = Vcr(e.iu);
                if (r.$) return b(Dp, oc);
                var a = r.a;
                return fu(a) ? b(Dp, oc) : b(A4(Ncr, t.gx, $k(n), a, Ecr), Mx);
            }
            return b(Dp, Mx);
        }(), m = d.a, p = d.b, g = function() {
            var r = gtr(e.iu);
            if (r.$) return b(Dp, oc);
            var u = r.a;
            return fu(u) ? b(Dp, oc) : b(A4($tr, t.gx, $k(n), u, zcr), Mx);
        }(), w = g.b, x = k([
            m,
            g.a,
            l,
            a
        ]), y = function() {
            var r = b(f, t.CX);
            if (3 === r.b.$) {
                if (r.a.$) return v(h, oc, u = r.b.a);
                var e = r.a.a, u = r.b.a;
                return v(A2(Ot, A5(FQn, t.gx, $k(n), pZn(c), e, Scr), x), Mx, u);
            }
            return v(h, oc, h);
        }(), _ = y.a, C = y.b, D = y.c, A = {
            fV: ZJn(t),
            ao: Rt,
            gx: t.gx,
            mS: Rt,
            oh: Rt,
            g7: t.g7,
            aV: !1,
            kg: Rt,
            A: A2(fqn, i(w, oc) && yvn(WIn(r)), TAn(n)),
            kj: t.kj,
            cB: w,
            hQ: C,
            a$: h,
            eZ: C,
            Av: C,
            e6: f,
            h5: C,
            kR: o,
            dw: n,
            a4: p,
            dy: A3(NAn, n, !0, A2(Fcr, r, p)),
            cI: C,
            ul: 0,
            uA: !1,
            fl: Rt,
            fm: Rt,
            dJ: Rt,
            ld: Rt,
            cP: Rt,
            cR: A3(i0n, Rk(t.kj), Lcr, d0n(n)),
            lj: c,
            fF: r,
            CX: D,
            w_: e,
            cY: Rt,
            jI: !1,
            d3: !1,
            xe: u
        };
        return b(A, Hu(A2(Ot, Ocr(A), $(_, k([
            s
        ])))));
    }), Zcr = F2(function(n, r) {
        return b(r, Dp);
    }), Xcr = F2(function(n, r) {
        return r;
    }), Gcr = function(n) {
        return {
            $: 12,
            a: n
        };
    }, Jcr = function(n) {
        return {
            $: 6,
            a: n
        };
    }, Ycr = function(n) {
        return {
            $: 9,
            a: n
        };
    }, Qcr = function(n) {
        return {
            $: 7,
            a: n
        };
    }, Kcr = function(n) {
        return {
            $: 4,
            a: n
        };
    }, nor = function(n) {
        return n.bv.$ ? xk(k([
            wD(m9(Kcr)),
            A2(xD, kEn, xk(k([
                A2(xD, gln, _D())
            ])))
        ])) : yk;
    }, ror = function(n) {
        return {
            $: 11,
            a: n
        };
    }, tor = function(n) {
        return {
            $: 8,
            a: n
        };
    }, eor = function(n) {
        return {
            $: 15,
            a: n
        };
    }, uor = {
        $: 10
    }, aor = function(n) {
        return A2(Rtr, "practitioner", A2(Cp, Hjn, n));
    }, ior = F2(function(n, r) {
        return vk(k([
            aor(n),
            Otr(r)
        ]));
    }), cor = F2(function(n, r) {
        return function(n) {
            return yvn(WIn(n));
        }(n) || _on(r);
    }), oor = F4(function(n, r, t, e) {
        if (A2(cor, n, t)) {
            var u = b(A2(Xb, function(n) {
                return A2(zD, function(r) {
                    return i(LAn(r), n);
                }, e);
            }, NUn(r)), t);
            return 3 === u.b.$ ? k([
                u.b.a
            ]) : u.a.$ ? e : k([
                u.a.a
            ]);
        }
        return h;
    }), sor = F2(function(n, r) {
        if (n.$) return !1;
        var t = n.a;
        return YS(A2(zD, function(n) {
            return i(LAn(n), LAn(t));
        }, r));
    }), lor = F2(function(n, r) {
        return A2(sor, r, A4(oor, n.fF, n.A, n.cB, Z9n(n.hQ)));
    }), dor = function(n) {
        return n.uj;
    }, bor = F2(function(n, r) {
        var t = A2(nEn, rEn(n), r);
        return ED(t) ? r : t;
    }), vor = F2(function(n, r) {
        var t = b(n.cB, n.hQ);
        if (3 === t.a.$ && 3 === t.b.$) {
            var e = t.a.a, u = t.b.a;
            return A2(Tc, function(n) {
                return YS(A2(zD, function(n) {
                    return i(LAn(e), LAn(n));
                }, A2(bor, n, u)));
            }, r);
        }
        return r;
    }), mor = F2(function(n, r) {
        var t = n.a4;
        return 3 === t.$ ? k([
            t.a
        ]) : r;
    }), por = F2(function(n, r) {
        var t, e = 3 === (t = n.hQ).$ ? t.a : h;
        return A3(WEn, n.A, e, A2(vor, n, A2(mor, n, r)));
    }), $or = F2(function(n, r) {
        if (n.$) return !1;
        var t = n.a;
        return YS(A2(zD, function(n) {
            return i(Hjn(n), Hjn(t));
        }, r));
    }), hor = F2(function(n, r) {
        return A2($or, r, A2(yu, function(n) {
            return n.uj;
        }, A2(por, n, Z9n(n.cI))));
    }), gor = function(n) {
        return n.uG;
    }, wor = function(n) {
        return n.uI;
    }, kor = F2(function(n, r) {
        return i(Ht(r), Gb(we(n)));
    }), xor = F2(function(n, r) {
        return A2(Ztr, n, r.kb);
    }), yor = function(n) {
        if (n.eH) return Rt;
        var r = n.ku;
        return 1 === r.$ ? Ht(r.a.sS) : Rt;
    }, _or = F3(function(n, r, t) {
        var e, u, a, i;
        return A4(Xtr, Ntr(n), 6, r, A2(Ot, (i = dor(n), A2(x7, "Practitioner", A2(uc, "No Preference", A2(Cp, hH, i)))), A2(Ot, Gtr(Vtr(n)), k([
            (a = OUn(e = t), A2(x7, "Filtering by Name", A2(uc, "", a))),
            (u = yor(e), A2(x7, "Filtering by Location", A2(uc, "", u))),
            Wtr(A2(xor, Rk(0), e))
        ]))));
    }), Cor = F2(function(n, r) {
        return A2(UP, function(n) {
            return i(n, r);
        }, n);
    }), Dor = F3(function(n, r, t) {
        return A2(Xb, function(t) {
            return A2(tjn, t + r, n);
        }, A2(Cor, n, t));
    }), Aor = F2(function(n, r) {
        return A3(Dor, n, 1, r);
    }), qor = F6(function(n, r, t, e, u, a) {
        if (3 === n.$) {
            var c = n.a, o = dor(a);
            if (o.$) {
                if (3 === e.$) {
                    var f = e.a;
                    return !A4(ZKn, GIn(r), t, GKn(f), u.B9) || yvn(ZIn(r));
                }
                return !0;
            }
            var s = o.a;
            return $H(A2(zD, function(n) {
                return i(Hjn(n), Hjn(s));
            }, c));
        }
        return !0;
    }), Bor = function(n) {
        return {
            $: 17,
            a: n
        };
    }, jor = F2(function(n, r) {
        var t = n.e6;
        if (t.$) return Dp;
        var e = t.a, u = vk(k([
            b("online_enrollment_id", mk(e)),
            b("practitioner_id", mk(Hjn(r)))
        ]));
        return A4(vN, z9(n.gx), v$, Bor, A2(xq, u, bC(A2($y, k([
            "signup_pages",
            pZn(n.lj),
            "online_enrollments",
            e,
            "join_waitlist"
        ]), gy($k(n.dw))))));
    }), Sor = F3(function(n, r, t) {
        if (n.$) return Dp;
        var e = n.a, u = Rk(0), a = A2(uu, "provider", u(e)) ? "Provider" : "Location", c = A2(uc, a, A2(Cp, function(n) {
            return A2(ue, ": ", k([
                n ? "Dependent " + ee(n) : "Owner",
                a
            ]));
        }, A2(UP, function(n) {
            return i(n, r);
        }, t)));
        return FYn({
            eC: k([
                JN(e)
            ]),
            p5: c
        });
    }), zor = function(n) {
        return A3(krr, Ntr(n), der(n), ler(n));
    }, Uor = function(n) {
        return n.uj;
    }, Eor = F2(function(n, r) {
        return A2(Xb, function(n) {
            return A2(zD, function(r) {
                return i(Hjn(r), n);
            }, r);
        }, n);
    }), Por = F2(function(n, r) {
        return A3(Dor, n, -1, r);
    }), Tor = F3(function(n, r, t) {
        return A2(cor, n, r) && 1 === oe(t) ? Gb(t) : Rt;
    }), For = function(n) {
        var r, t = $k(n.dw), e = htr(n.lj) || Hcr(n.lj) ? Ht(n.lj) : Rt, u = 1 === (r = XAn(n.A.kb)).$ ? Ht(r.b) : Rt;
        return A4(KAn, n.gx, t, A2(Icr, e, u), Ucr);
    }, Lor = function(n) {
        return {
            $: 16,
            a: n
        };
    }, Mor = function(n) {
        return {
            $: 13,
            a: n
        };
    }, Hor = function(n) {
        var r = b(n.h5, n.mS);
        if (3 !== r.a.$ || r.b.$) return Dp;
        var t = r.a.a, e = r.b.a, u = A2(wq, function(n) {
            return Orr(n);
        }, J3n(t)), a = Rrr({
            x4: Lrr(n.w_.iu),
            mS: Ht(e),
            oh: n.oh,
            y6: u
        });
        return O3n(n.lj) ? A4(GBn, n.gx, $k(n.dw), a, Mor) : A4(I3n, n.gx, $k(n.dw), x2n(t), Lor);
    }, Ror = F2(function(n, r) {
        switch(n.$){
            case 5:
                var t = n.a, e = m(r, {
                    h5: t
                });
                if (3 === t.$) {
                    var u = t.a, a = (_n = r.fV).$ ? Dp : MKn(_n.a), c = ZYn(u), o = m(e, {
                        fV: Rt,
                        mS: Ht(F0n(u)),
                        g7: c
                    }), f = k(c ? [
                        DYn(GKn(u)),
                        wYn,
                        gYn
                    ] : [
                        DYn(GKn(u)),
                        gYn
                    ]);
                    return v(o, Hu(k([
                        a,
                        Hor(o)
                    ])), f);
                }
                return v(e, Dp, A2(uA, 1, t));
            case 0:
                var s = n.a;
                if (3 === s.$) {
                    var l = A2(uc, 0, A2(Xb, lu, A2(Zu, "x-total-count", s.b))), d = A2(ver, r.cP, function() {
                        return A2(Eor, vKn(r.fF), Z9n(s));
                    }), p = A2(_8, l, r.kR), $ = function() {
                        var n = b(r.e6, r.cI);
                        if (n.a.$ || 1 !== n.b.$) return Dp;
                        var t = n.a.a;
                        return A4(aer, r.gx, $k(r.dw), t, tor);
                    }();
                    return v(m(r, {
                        kR: p,
                        cI: s,
                        cP: d
                    }), $, h);
                }
                return v(r, Dp, A2(uA, 1, s));
            case 1:
                return v(e = m(r, {
                    kR: p = A2(y8, n.a, r.kR)
                }), Ocr(e), h);
            case 2:
                var g = n.a;
                return e = m(r, {
                    a4: g
                }), 3 === g.$ ? v(m(e, {
                    cP: Ht(g.a)
                }), Dp, h) : v(e, Dp, A2(uA, 1, g));
            case 3:
                var w = n.a;
                if (e = m(r, {
                    hQ: w
                }), 3 === w.$) {
                    var x = Aer(w.a);
                    return v(m(e, {
                        dJ: J = A2(ver, r.dJ, function() {
                            return A2(cer, x, dKn(r.fF));
                        }),
                        ld: A2(Cp, LAn, J)
                    }), Dp, h);
                }
                return v(e, Dp, A2(uA, 1, w));
            case 4:
                var y = n.a;
                if (e = m(r, {
                    cB: y
                }), 3 === y.$) {
                    var _ = y.a;
                    return v(m(e, {
                        dJ: Ht(_),
                        ld: Ht(LAn(_))
                    }), Dp, h);
                }
                return v(e, Dp, A2(uA, 1, y));
            case 6:
                var C = A2(M3n, n.a, r.cR), D = C.a, A = C.b, q = C.c, B = q.$ || q.a ? Dp : A2(Eu, ru, gu(uor));
                return v(m(r, {
                    cR: D
                }), Hu(k([
                    A2(jp, Jcr, A),
                    B
                ])), h);
            case 10:
                var j = b(r.ao, r.e6);
                if (j.a.$ || j.b.$) return v(r, Dp, h);
                var S = j.a.a, z = j.b.a, U = 3 === (yn = r.hQ).$ ? m(r, {
                    dJ: A2(z$, r.dJ, A3(Tor, r.fF, r.cB, A4(oor, r.fF, r.A, r.cB, yn.a)))
                }) : r, E = function(n) {
                    var r = A2(Xb, dor, n.ao), t = function() {
                        var t = v(r, n.cP, n.cI);
                        if (t.a.$ || t.b.$ || 3 !== t.c.$) return !1;
                        var e = t.b.a, u = t.c.a;
                        return i(Hjn(t.a.a), Hjn(e)) && A2($or, r, u);
                    }(), e = $H(n.cP) ? Tcr(n.fF) ? Rt : Ht(wor) : A2(hor, n, n.cP) || t || _on(n.a4) && _on(n.cB) ? Rt : Ht(gor), u = A2(Xb, Vtr, n.ao), a = function() {
                        var r = v(u, n.dJ, n.hQ);
                        if (r.a.$ || r.b.$ || 3 !== r.c.$) return !1;
                        var t = r.b.a, e = r.c.a;
                        return i(LAn(r.a.a), LAn(t)) && A2(sor, u, e);
                    }(), c = A2(cor, n.fF, n.cB) ? $H(n.dJ) ? Ht(oL) : A2(lor, n, n.dJ) || a ? Rt : Ht(aL) : Rt;
                    return A2(z$, e, c);
                }(U);
                if ($H(E)) return v(e = m(U, {
                    aV: !1,
                    kg: E,
                    uA: !0
                }), A6(per, r.gx, $k(e.dw), z, Ntr(S), A2(ior, e.cP, e.dJ), ror), h);
                var P = qEn(A2(uc, Lcr, Ht(YFn(r.cP))));
                return v(m(r, {
                    kg: E
                }), Hu(k([
                    P,
                    A3(Sor, E, S, r.a$)
                ])), h);
            case 11:
                var T = n.a;
                if (e = m(r, {
                    uA: !1
                }), 3 === T.$) {
                    var F = T.a, L = A2(yu, function(n) {
                        return i(Ntr(n), Ntr(F)) ? F : n;
                    }, e.a$), M = function(n) {
                        var r = n.ao;
                        if (r.$) return v(n, Dp, h);
                        var t = r.a;
                        if (A2(kor, n.a$, t)) return v(n, Hu(k([
                            A4(EKn, 6, n.CX, n.fF, h),
                            A3(_or, t, n.CX, n.A)
                        ])), k([
                            _Yn
                        ]));
                        var e = A2(Aor, n.a$, t);
                        if (e.$) return v(n, Dp, h);
                        var u = e.a, a = function() {
                            var r = n.h5;
                            if (3 === r.$) {
                                var e = A4(ZKn, n.lj, n.CX, GKn(r.a), n.w_.B9);
                                return b(e && Tcr(n.fF) ? dor(u) : A2(z$, dor(u), dor(t)), A2(cor, n.fF, n.cB) ? e ? Vtr(u) : A2(z$, Vtr(u), Vtr(t)) : Rt);
                            }
                            return b(Rt, Rt);
                        }(), i = a.a, c = a.b;
                        return v(m(n, {
                            ao: Ht(u),
                            aV: YS(dor(u)),
                            dJ: c,
                            ld: A2(Cp, LAn, c),
                            cP: i
                        }), Hu(k([
                            Wjn(Ntr(u)),
                            A3(_or, t, n.CX, n.A)
                        ])), k([
                            cnr(Ntr(u))
                        ]));
                    }(m(e, {
                        ao: Ht(F),
                        a$: L
                    }));
                    return v(cn = M.a, M.b, f = M.c);
                }
                return v(e, Dp, A2(uA, 1, T));
            case 7:
                var H = A2(uc, Ru, A2(Xb, function(n) {
                    return ec(n);
                }, $u(n.a))), R = A2(uc, Ru, ec(r.w_.B9));
                return v(r, A4(HQn, r.lj, r.CX, R, H) ? A2(HKn, R, H) : Dp, k([
                    K7n
                ]));
            case 8:
                var O = n.a, N = m(r, {
                    eZ: O
                });
                if (3 === O.$) {
                    var I = O.a, V = A2(Xb, Cer, Gb(I)), W = A5(qor, r.cI, r.fF, r.CX, r.h5, r.w_), Z = htr(r.lj) || Hcr(r.lj) ? Ht(r.lj) : Rt, X = (kn = v(r.cB, r.a4, V)).a.$ || kn.b.$ || kn.c.$ ? r.A : A2(oqn, A2(dqn, kn.c.a, BAn), r.A), G = A2(VHn, Gb(we(I)), Gb(A2(Tc, W, I))), J = A2(cor, r.fF, r.cB) ? N.cB.$ ? MD(N.cB) : A2(VHn, N.dJ, A2(Xb, Vtr, A2(Xb, function(n) {
                        return W(n) ? A2(Por, I, n) : Ht(n);
                    }, G))) : Rt, Y = (d = N.a4.$ ? MD(N.a4) : A2(VHn, N.cP, A2(Xb, dor, A2(Xb, function(n) {
                        return W(n) ? A2(Por, I, n) : Ht(n);
                    }, G))), A4(KAn, r.gx, $k(r.dw), A2(Icr, Z, V), Ucr)), Q = oe(I) > 1 ? k([
                        A3(anr, A2(yu, zor, I), A2(uc, "", A2(Cp, Ntr, G)), !0)
                    ]) : h, K = m(N, {
                        ao: G,
                        aV: 3 === (xn = r.h5).$ && A4(ZKn, r.lj, r.CX, GKn(xn.a), r.w_.B9),
                        A: X,
                        a$: I,
                        dJ: J,
                        ld: A2(Cp, LAn, J),
                        cP: d
                    }), nn = Ocr(K);
                    return v(K, Hu(k([
                        A4(TKn, 6, K.CX, K.fF, h),
                        Y,
                        nn
                    ])), Q);
                }
                return v(N, Dp, A2(uA, 1, O));
            case 9:
                var rn = n.a;
                return oe(r.a$) > 0 ? (S = Gb(A2(Tc, function(n) {
                    return i(Ntr(n), rn);
                }, r.a$)), J = A2(cor, r.fF, r.cB) ? A2(Xb, Vtr, S) : Rt, v(m(r, {
                    ao: S,
                    aV: YS(d = A2(Xb, dor, S)),
                    kg: Rt,
                    dJ: J,
                    ld: A2(Cp, LAn, J),
                    cP: d
                }), Dp, h)) : v(r, Dp, h);
            case 12:
                var tn = A2(yEn, n.a, r.dy), en = tn.b, un = tn.c, an = m(r, {
                    kg: Rt,
                    dy: tn.a
                }), cn = function() {
                    if (un.$) return an;
                    switch(un.a.$){
                        case 0:
                            var n = un.a.a, t = function() {
                                var t = b(r.hQ, A2(cor, r.fF, r.cB));
                                if (3 === t.a.$ && t.b) {
                                    var e = t.a.a, u = A2(tEn, Ht(n), A4(oor, r.fF, r.A, r.cB, e)), a = sEn(r.A.kb) ? n.ku : Rt;
                                    return A2(z$, a, A3(Tor, r.fF, r.cB, u));
                                }
                                return Rt;
                            }();
                            return m(an, {
                                aV: !1,
                                dJ: t,
                                ld: A2(Cp, LAn, t),
                                cP: Ht(n.uj)
                            });
                        case 1:
                            return t = 3 === (u = b(r.hQ, A2(cor, r.fF, r.cB))).a.$ && u.b ? A3(Tor, r.fF, r.cB, A4(oor, r.fF, r.A, r.cB, u.a.a)) : Rt, m(an, {
                                aV: !1,
                                dJ: t,
                                ld: A2(Cp, LAn, t),
                                cP: Rt
                            });
                        case 2:
                            var e = un.a.a;
                            return m(an, {
                                dJ: Ht(e),
                                ld: Ht(LAn(e))
                            });
                        default:
                            return m(an, {
                                d3: !0
                            });
                    }
                    var u;
                }(), on = un.$ || 3 !== un.a.$ ? Dp : A2(jor, cn, un.a.a);
                return v(cn, Hu(k([
                    A2(jp, Gcr, en),
                    on
                ])), h);
            case 13:
                var fn = n.a;
                n: for(;;)switch(fn.$){
                    case 3:
                        return v(m(r, {
                            fl: Ht(fn.a),
                            fm: Rt
                        }), Dp, A2(uA, 1, fn));
                    case 2:
                        if (5 === fn.a.$) {
                            var sn = Ht(WGn(k([
                                KD(n3n(fn.a.b))
                            ])));
                            return v(m(r, {
                                fm: sn
                            }), Dp, h);
                        }
                        break n;
                    default:
                        break n;
                }
                return v(r, Dp, A2(uA, 1, fn));
            case 14:
                var ln = n.a;
                return 3 === ln.$ ? v(e = m(r, {
                    oh: Ht(ln.a)
                }), Hor(e), h) : v(r, Dp, A2(uA, 1, ln));
            case 15:
                var dn = A2(pEn, n.a, r.A), bn = dn.b, vn = dn.c, mn = m(r, {
                    A: dn.a
                }), pn = function() {
                    if (vn.$) return b(mn, Dp);
                    var n = vn.a, r = m(mn, {
                        aV: !1
                    });
                    switch(n.$){
                        case 1:
                            var t = n.b, e = m(r, {
                                kR: l8
                            });
                            return b(t ? function(n) {
                                var r = n.hQ;
                                if (3 === r.$) {
                                    var t = r.b;
                                    return m(n, {
                                        hQ: A2(f_, Htr(r.a), t)
                                    });
                                }
                                return n;
                            }(r) : r, Ocr(e));
                        case 2:
                            return (t = n.b) ? b(e = m(r, {
                                kR: l8
                            }), Ocr(e)) : b(r, Dp);
                        case 3:
                            return n.b ? b(e = m(r, {
                                kR: l8
                            }), Hu(k([
                                Ocr(e),
                                For(e)
                            ]))) : b(r, Dp);
                        default:
                            return b(e = m(r, {
                                kR: l8
                            }), Ocr(e));
                    }
                }();
                return B = pn.b, v(e = pn.a, Hu(k([
                    A2(jp, eor, bn),
                    B
                ])), h);
            case 16:
                return v(m(r, {
                    Av: n.a
                }), Dp, h);
            case 17:
                return v(m(r, 3 === ($n = n.a).$ ? {
                    jI: !0,
                    d3: !1
                } : {
                    d3: !1
                }), Dp, h);
            default:
                var $n;
                if (3 === ($n = n.a).$) {
                    var hn = $n.a, gn = A2(Cp, L5n, I5n(hn));
                    if (gn.$) return v(m(r, {
                        cY: Ht(hn)
                    }), A4(Ncr, r.gx, $k(r.dw), bKn(Uor(hn)), Ecr), h);
                    var wn = gn.a;
                    return v(m(r, {
                        cY: Ht(hn)
                    }), Hu(k([
                        A4(Ncr, r.gx, $k(r.dw), bKn(Uor(hn)), Ecr),
                        A5(FQn, r.gx, $k(r.dw), pZn(r.lj), wn, Scr)
                    ])), k([
                        q8n(wn)
                    ]));
                }
                return v(m(r, {
                    a4: oc
                }), Dp, h);
        }
        var kn, xn, yn, _n;
    }), Oor = function(n) {
        return n.qf;
    }, Nor = function(n) {
        return n.uF;
    }, Ior = function(n) {
        return n.uK;
    }, Vor = F3(function(n, r, t) {
        var e = yvn(WIn(r)) ? n(Nor) : n(Ior);
        return A2(uc, k([
            ad(e)
        ]), A2(Cp, function(r) {
            return k([
                ad(e + " " + n(Oor) + " "),
                Jx(r)
            ]);
        }, A2(Xb, der, t)));
    }), Wor = F2(function(n, r) {
        if (r.$) return Sq;
        var t = r.a;
        return A2(Ik, k([
            Nk("form-error mb-3 mt-0")
        ]), k([
            ad(n(t))
        ]));
    }), Zor = F2(function(n, r) {
        var t = r.uA, e = r.cB, u = r.A;
        if (r.a4.$) return Sq;
        var a = function() {
            var n = r.hQ;
            if (3 === n.$) {
                var t = n.a;
                return 3 === e.$ ? k([
                    e.a
                ]) : t;
            }
            return h;
        }();
        return A2(px, eor, A4(GLn, n, t, a, u));
    }), Xor = function(n) {
        return {
            $: 9,
            a: n
        };
    }, Gor = F4(function(n, r, t, e) {
        var u = A2(Cp, A2(VEn, e.A, t), e.cP), a = A2(por, e, r), c = A4(oor, e.fF, e.A, e.cB, t), o = ED(c) ? Rt : e.dJ;
        return A2(Ik, k([
            Nk("mb-8")
        ]), k([
            ED(a) && !Tcr(e.fF) ? A2(hx, h, k([
                ad("No providers found")
            ])) : A2(px, Gcr, A3(FLn, n, k([
                xFn(e.uA),
                UFn(u),
                jFn(a),
                SFn(o),
                zFn(e.ld),
                DFn(c),
                _Fn(YS(e.kg)),
                yFn(e.aV),
                BFn(A2(Xb, ler, e.ao)),
                Xor(!i(e.cY, Rt))
            ]), e.dy))
        ]));
    }), Jor = function(n) {
        var r = Rk(n.kj), t = A2(uc, "this provider", A2(Cp, hH, n.cP)), e = n.cY;
        if (e.$) return n.d3 ? A2(Ik, k([
            Nk("bg-blue-50 border border-blue-200 text-blue-800 rounded-md p-4 mb-4")
        ]), k([
            A2(hx, h, k([
                ad(r(kLn) + " " + t + " " + r(xLn))
            ]))
        ])) : n.jI ? A2(Ik, k([
            Nk("bg-green-50 border border-green-200 text-green-800 rounded-md p-4 mb-4")
        ]), k([
            A2(hx, k([
                Hz
            ]), k([
                ad(r(lLn))
            ])),
            A2(hx, h, k([
                ad(r(dLn) + " " + t + ".")
            ]))
        ])) : Sq;
        var u = e.a;
        return A2(Ik, k([
            Nk("bg-green-50 border border-green-200 text-green-800 rounded-md p-4 mb-4")
        ]), k([
            A2(hx, k([
                Hz
            ]), k([
                ad(r(gLn))
            ])),
            A2(hx, h, k([
                ad(r(hLn) + " " + dan(Uor(u)) + ".")
            ]))
        ]));
    }, Yor = F2(function(n, r) {
        var t = b(r.cI, r.hQ);
        if (3 === t.a.$ && 3 === t.b.$) {
            var e = t.a.a, u = t.b.a;
            return A2(Ik, k([
                jz(Lcr)
            ]), k([
                A2(Zor, n, r),
                A2(Wor, n, r.kg),
                Jor(r),
                A4(Gor, n, e, u, r)
            ]));
        }
        return A2(Ik, h, Yk);
    }), Qor = function(n) {
        return {
            $: 1,
            a: n
        };
    }, Kor = F3(function(n, r, t) {
        var e = b(r.eZ, r.ao);
        return 3 !== e.a.$ || e.b.$ ? t : A2(n6n, A5(ttr, n, A2(kor, e.a.a, e.b.a), r.lj, r.CX, r.w_.B9), t);
    }), nfr = F2(function(n, r) {
        return (function() {
            if (O3n(r.lj)) return t6n(r.fl);
            var n, t = 3 === (n = r.Av).$ ? n.a : h;
            return Q9n(W9n(t));
        })()(A2(J9n, r.fm, A2(r6n, r.mS, A2(G9n, r.uA || function(n) {
            return !!i(n.cY, Rt) && A2(uc, !1, A2(Cp, function(n) {
                return "full_waitlisting" === FEn(n);
            }, n.cP));
        }(r), A2(utr, r.uA, A3(Kor, n, r, h))))));
    }), rfr = F2(function(n, r) {
        return A2(Ik, k([
            Nk("hidden md:block")
        ]), k([
            A2(px, Jcr, A3(i4n, n, A2(nfr, n, r), r.cR))
        ]));
    }), tfr = F2(function(n, r) {
        return A2(px, Jcr, A3(i4n, n, o4n(A2(nfr, n, r)), r.cR));
    }), efr = F2(function(n, r) {
        var t;
        return k([
            A2(Ik, k([
                Nk("signup__body--contents")
            ]), k([
                A2(XT, k([
                    jX,
                    LS(p1n),
                    bz(gz)
                ]), A3(Vor, n, r.fF, r.ao)),
                A2(lV, k([
                    dV(NZ)
                ]), k([
                    A2(iV, k([
                        UZ(12),
                        GZ(8)
                    ]), k([
                        A2(Yor, n, r),
                        (t = r.kR, A2(px, Qor, A2(e5, h, t)))
                    ])),
                    A2(iV, k([
                        GZ(4),
                        jV(k([
                            Nk("hidden md:block")
                        ]))
                    ]), k([
                        A2(rfr, n, r)
                    ]))
                ])),
                A2(tfr, n, r)
            ]))
        ]);
    }), ufr = F2(function(n, r) {
        return {
            gF: function() {
                var t = b(r.cI, r.h5);
                n: for(;;){
                    r: for(;;){
                        t: for(;;){
                            e: for(;;)switch(t.b.$){
                                case 1:
                                    if (1 === t.a.$) break n;
                                    break r;
                                case 0:
                                    if (1 === t.a.$) break n;
                                    break t;
                                case 2:
                                    switch(t.a.$){
                                        case 1:
                                            break n;
                                        case 2:
                                            break e;
                                        default:
                                            return k([
                                                l4n(r.dw)
                                            ]);
                                    }
                                default:
                                    switch(t.a.$){
                                        case 1:
                                            break n;
                                        case 2:
                                            break e;
                                        default:
                                            return A2(efr, n, r);
                                    }
                            }
                            return k([
                                l4n(r.dw)
                            ]);
                        }
                        return Yk;
                    }
                    return Yk;
                }
                return Yk;
            }(),
            wD: hk(r.dw)
        };
    }), afr = sZn({
        zO: Wcr,
        Ab: Zcr,
        Ct: Xcr,
        Dd: function(n) {
            return xk(k([
                A2(xD, Jcr, A0n()),
                mYn(Qcr),
                Q7n(Ycr),
                A2(xD, Gcr, nor(n.dy))
            ]));
        },
        DB: Ror,
        DH: ufr
    }), ifr = function(n) {
        return {
            $: 6,
            a: n
        };
    }, cfr = F2(function(n, r) {
        return {
            fe: r,
            dw: n,
            uA: !1
        };
    }), ofr = F6(function(n, r, t, e, u, a) {
        return {
            l$: a,
            oV: t,
            qU: n,
            sS: r,
            wp: u,
            wD: e
        };
    }), ffr = F6(function(n, r, t, e, u, a) {
        return {
            jM: a,
            qU: n,
            sS: r,
            vP: t,
            ww: e,
            w_: u
        };
    }), sfr = function(n) {
        return {
            $: 1,
            a: n
        };
    }, lfr = function(n) {
        return {
            $: 0,
            a: n
        };
    }, dfr = F6(function(n, r, t, e, u, a) {
        return {
            oB: u,
            oO: a,
            qU: n,
            rh: t,
            sS: r,
            vu: e
        };
    }), bfr = F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    }), vfr = A3(zy, "url", w$, Ke(function(n) {
        return {
            w_: n
        };
    })), mfr = A2(IC, 0, A2(qy, vfr, Ke(bfr))), pfr = A3(zy, "default_mce_signup_page", l_(mfr), A3(zy, "custom_logo_url", l_(w$), A3(zy, "sandbox", xy, A3(zy, "is_mce", xy, A3(zy, "name", w$, A3(zy, "id", w$, Ke(dfr))))))), $fr = A2(qy, pfr, Ke(ru)), hfr = F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    }), gfr = A3(zy, "logo_url", l_(w$), Ke(function(n) {
        return {
            rQ: n
        };
    })), wfr = A2(IC, 0, A2(qy, gfr, Ke(hfr))), kfr = D$(k([
        A2(Ye, lfr, $fr),
        A2(Ye, sfr, wfr)
    ])), xfr = A2(qy, kfr, Ke(ru)), yfr = A3(zy, "addable", xfr, A3(zy, "url", l_(w$), A3(zy, "tagline", l_(w$), A3(zy, "show_email_button", xy, A3(zy, "name", w$, A3(zy, "id", w$, Ke(ffr))))))), _fr = A2(qy, yfr, Ke(ru)), Cfr = A3(zy, "addons", Ey(_fr), A3(zy, "subtitle", w$, A3(zy, "title", w$, A3(zy, "description", w$, A3(zy, "name", w$, A3(zy, "id", w$, Ke(ofr))))))), Dfr = A2(qy, Cfr, Ke(ru)), Afr = F2(function(n, r) {
        return A2($y, k([
            "addon_categories"
        ]), A2(PQn, n, r));
    }), qfr = F4(function(n, r, t, e) {
        return A4(dC, z9(n), Ey(Dfr), e, bC(A2(Afr, r, t)));
    }), Bfr = F4(function(n, r, t, e) {
        var u, a, i = GIn(r);
        return b({
            d5: Mx,
            gx: t.gx,
            kj: t.kj,
            e6: t.e6,
            dw: n,
            uA: !1,
            u0: (a = e.iu, A2(n0n, "referred_token", a)),
            cN: Rt,
            lj: i,
            fF: r,
            fK: A2(cfr, n, (u = r, {
                kX: u.kX,
                kY: u.kY,
                kZ: u.kZ,
                li: u.li
            })),
            w_: e
        }, A4(qfr, t.gx, $k(n), pZn(i), ifr));
    }), jfr = F2(function(n, r) {
        return b(r, Dp);
    }), Sfr = F2(function(n, r) {
        return r;
    }), zfr = function(n) {
        return {
            $: 2,
            a: n
        };
    }, Ufr = function(n) {
        return {
            $: 5,
            a: n
        };
    }, Efr = F2(function(n, r) {
        return $(function(n) {
            return A2(uu, "authorization is required", n) ? "Email cannot be sent because you did not accept the ePHI waiver. Please contact practice at " : "Email cannot be sent. Please contact practice at ";
        }(r), $(function(n) {
            var r = kF(n);
            return r.$ ? "" : dF(r.a);
        }(n), function(n) {
            var r = lk(n);
            if (r.$) return "";
            var t = r.a;
            return kF(n).$ ? t : " or " + t;
        }(n)));
    }), Pfr = function(n) {
        return n.oO;
    }, Tfr = F3(function(n, r, t) {
        return A2($y, k([
            "online_enrollments",
            r,
            "addons",
            t,
            "notify"
        ]), gy(n));
    }), Ffr = F5(function(n, r, t, e, u) {
        return A4(vN, z9(n), RHn, u, bC(A3(Tfr, r, t, e)));
    }), Lfr = A2(nA, 1, OZn), Mfr = A2(nA, 3, NZn), Hfr = function(n) {
        return A2(Xb, B8, n.b.w_);
    }, Rfr = F2(function(n, r) {
        if (r.$) {
            var t = Hfr(n);
            return t.$ ? dL : T2n(t.a);
        }
        return T2n(r.a);
    }), Ofr = F2(function(n, r) {
        return A2(Rfr, n, r.kZ);
    }), Nfr = F2(function(n, r) {
        return b(m(r, {
            uA: !0
        }), A2(Ofr, r.dw, r.fe));
    }), Ifr = function(n) {
        return n.a.w_;
    }, Vfr = F2(function(n, r) {
        switch(n.$){
            case 0:
                var t = (a = n.a).w_, e = a.jM, u = function(n) {
                    return !n.$ && jqn(n.a);
                }(e) && $H(t) ? A2(Cp, function(n) {
                    var t = r.u0;
                    return t.$ ? n : A2(xV, n, k([
                        A2(Ax, "token", t.a)
                    ]));
                }, A2(Cp, Ifr, A2(Xb, Pfr, function(n) {
                    return n.$ ? Rt : Ht(n.a);
                }(e)))) : t;
                return v(r, u.$ ? Dp : T2n(u.a), h);
            case 1:
                var a = n.a, i = function() {
                    var n = r.e6;
                    if (2 === n.$) {
                        var t = n.a;
                        return A5(Ffr, r.gx, $k(r.dw), t, function(n) {
                            return n.qU;
                        }(a), zfr);
                    }
                    return Dp;
                }();
                return v(r, i, h);
            case 2:
                var c = n.a;
                switch(c.$){
                    case 3:
                        return v(r, Dp, k([
                            Mfr
                        ]));
                    case 2:
                        return v(r, Dp, k(5 === c.a.$ ? [
                            A2(nA, 1, KD(A2(Efr, r.dw, c.a.b)))
                        ] : [
                            Lfr
                        ]));
                    default:
                        return v(r, Dp, A2(uA, 1, c));
                }
            case 3:
                return v(m(r, {
                    cN: Ht(n.a)
                }), Dp, h);
            case 4:
                return v(r, Dp, h);
            case 5:
                var o = A2(Nfr, n.a, r.fK);
                return i = o.b, v(m(r, {
                    fK: o.a
                }), A2(jp, Ufr, i), h);
            default:
                var f = n.a, s = m(r, {
                    d5: f
                });
                return 3 === f.$ ? v(m(s, {
                    cN: Gb(f.a)
                }), Dp, h) : v(s, Dp, A2(uA, 1, f));
        }
    }), Wfr = function(n) {
        return n.cU.yn;
    }, Zfr = function(n) {
        return n.cU.DM;
    }, Xfr = F2(function(n, r) {
        return A2(dpn, n, A2(uc, n, r));
    }), Gfr = F3(function(n, r, t) {
        return A2(Xfr, n(t ? Wfr : Zfr), r.kY);
    }), Jfr = F3(function(n, r, t) {
        var e;
        return e = A3(Gfr, n, r, t), A2(hx, k([
            bz(wF),
            LS(q3)
        ]), k([
            ad(e)
        ]));
    }), Yfr = F2(function(n, r) {
        return r.xc(n);
    }), Qfr = F3(function(n, r, t) {
        return A2(Xfr, n(function(n) {
            return Yfr(hk(n));
        }(r)), t.kX);
    }), Kfr = F2(function(n, r) {
        return A2(fz, k([
            nz,
            ZS(r),
            Don(r),
            QS(0)
        ]), k([
            A2(Gk, h, k([
                ad(n)
            ]))
        ]));
    }), nsr = F4(function(n, r, t, e) {
        return A2(IZ, t.li, A2(Kfr, A3(Qfr, n, r, t), e));
    }), rsr = F2(function(n, r) {
        return r.xj(n);
    }), tsr = F3(function(n, r, t) {
        return A2(Ik, h, k([
            A2(XT, k([
                jX,
                LS(FS),
                LS(Iun),
                bz(wF)
            ]), k([
                ad(n(rsr(hk(r))))
            ])),
            A2(IZ, t, A2(mx, k([
                LS(FS),
                bz(wF)
            ]), k([
                ad(n(IZn))
            ])))
        ]));
    }), esr = F3(function(n, r, t) {
        var e = !t.$ && KQn(t.a);
        return A2(lV, h, k([
            Gan(k([
                Oun(2),
                GZ(1),
                UZ(0)
            ])),
            A2(iV, k([
                uV(wF),
                Oun(8),
                GZ(10),
                UZ(12)
            ]), k([
                A2(Ik, k([
                    Nk("white-circle")
                ]), k([
                    A2(US, h, 14)
                ])),
                A3(tsr, n, r.dw, e),
                A3(Jfr, n, r.fe, e),
                A4(nsr, n, r.dw, r.fe, r.uA)
            ]))
        ]));
    }), usr = {
        $: 4
    }, asr = function(n) {
        return n.oV;
    }, isr = F2(function(n, r) {
        var t, e = !n.$ && i(n.a, r), u = e ? usr : function(n) {
            return {
                $: 3,
                a: n
            };
        }(r);
        return A2(Ik, k([
            Nk("addon-category"),
            rz(k([
                b("addon-category--selected", e)
            ])),
            Eq(u)
        ]), k([
            A2(hx, k([
                LS(E4),
                zV
            ]), k([
                ad((t = r, t.sS))
            ])),
            A2(hx, k([
                EB
            ]), k([
                ad(asr(r))
            ]))
        ]));
    }), csr = F2(function(n, r) {
        if (3 === n.$) {
            var t = n.a;
            return oe(t) > 1 ? A2(Ik, k([
                Nk("flex flex-col relative")
            ]), A2(yu, isr(r), t)) : Sq;
        }
        return Sq;
    }), osr = function(n) {
        return n.sS;
    }, fsr = function(n) {
        return {
            $: 1,
            a: n
        };
    }, ssr = function(n) {
        return n.jN.pt;
    }, lsr = function(n) {
        return n.jN.hf;
    }, dsr = F3(function(n, r, t) {
        return t.vP ? A2(Ik, h, k([
            A2(fz, k([
                r4,
                ZS(r),
                QS(fsr(t)),
                vz(k([
                    Nk("mt-3")
                ]))
            ]), k([
                ad(n(ssr))
            ]))
        ])) : Sq;
    }), bsr = function(n) {
        return {
            $: 0,
            a: n
        };
    }, vsr = F3(function(n, r, t) {
        return A2(fz, k([
            CU,
            ZS(r),
            QS(bsr(t))
        ]), k([
            ad(n(lsr))
        ]));
    }), msr = F3(function(n, r, t) {
        var e, u = A2(uc, "", t.ww);
        return A2(Ik, k([
            Nk("addon-category__addon")
        ]), k([
            A2(lV, k([
                dV(NZ),
                uV(kz)
            ]), k([
                A2(iV, k([
                    UZ(3),
                    jV(k([
                        Nk("pr-8")
                    ]))
                ]), k([
                    A2(AB, k([
                        Nk("inline"),
                        TB((e = t, function(n) {
                            var r = n;
                            if (r.$) {
                                var t = function(n) {
                                    return n.a.rQ;
                                }(r.a);
                                return t.$ ? "" : t.a;
                            }
                            var e = jXn(r.a);
                            return e.$ ? "" : e.a;
                        }(e.jM)))
                    ]), h)
                ])),
                A2(iV, k([
                    UZ(5)
                ]), k([
                    A2(hx, k([
                        LS(E4),
                        Hz
                    ]), k([
                        ad(osr(t))
                    ])),
                    A2(hx, k([
                        EB,
                        BB
                    ]), k([
                        ad(u)
                    ]))
                ])),
                A2(iV, k([
                    UZ(4),
                    jV(k([
                        Nk("pl-8 flex flex-col items-center")
                    ]))
                ]), k([
                    A3(vsr, n, r, t),
                    A3(dsr, n, r, t)
                ]))
            ]))
        ]));
    }), psr = F2(function(n, r) {
        var t = r.cN;
        if (t.$) return Sq;
        var e = function(n) {
            return n.l$;
        }(t.a);
        return A2(Ik, k([
            Nk("flex w-full flex-col")
        ]), A2(yu, A2(msr, n, r.uA), e));
    }), $sr = function(n) {
        return n.wp;
    }, hsr = function(n) {
        var r;
        return A2(Ik, h, k([
            A2(mx, k([
                jX,
                LS(E4),
                bz(wF)
            ]), k([
                ad((r = n, r.wD))
            ])),
            A2(hx, k([
                Qk(k([
                    Nk("addon-category__description")
                ])),
                jX,
                BB,
                LS(q3),
                bz(wF)
            ]), k([
                ad($sr(n))
            ]))
        ]));
    }, gsr = F2(function(n, r) {
        var t = r.cN;
        if (t.$) return Sq;
        var e = t.a;
        return A2(Ik, k([
            Nk("addons-container")
        ]), k([
            hsr(e),
            A2(Ik, k([
                Nk("flex w-full")
            ]), k([
                A2(csr, r.d5, r.cN),
                A2(psr, n, r)
            ]))
        ]));
    }), wsr = F2(function(n, r) {
        return k([
            A2(Ik, k([
                Nk("signup__body--contents")
            ]), k([
                A2(px, Ufr, A3(esr, n, r.fK, Ht(r.lj))),
                A2(gsr, n, r)
            ]))
        ]);
    }), ksr = F2(function(n, r) {
        return {
            gF: 1 === r.d5.$ ? Yk : A2(wsr, n, r),
            wD: n(VZn)
        };
    }), xsr = sZn({
        zO: Bfr,
        Ab: jfr,
        Ct: Sfr,
        Dd: function() {
            return yk;
        },
        DB: Vfr,
        DH: ksr
    }), ysr = F4(function(n, r, t, e) {
        return {
            kj: e,
            dw: n,
            lj: r,
            w_: t
        };
    }), _sr = F4(function(n, r, t, e) {
        var u, a = 3 === (u = t.CX).$ ? u.a : h, i = GIn(r);
        return b(A4(ysr, n, i, e, t.kj), A3(hZn, i, a, e.iu));
    }), Csr = F2(function(n, r) {
        return b(r, Dp);
    }), Dsr = F2(function(n, r) {
        return r;
    }), Asr = F2(function(n, r) {
        return v(r, Dp, h);
    }), qsr = F2(function(n, r) {
        var t = r.dw;
        return {
            gF: k([
                Sq
            ]),
            wD: hk(t)
        };
    }), Bsr = sZn({
        zO: _sr,
        Ab: Csr,
        Ct: Dsr,
        Dd: function() {
            return yk;
        },
        DB: Asr,
        DH: qsr
    }), jsr = F4(function(n, r, t, e) {
        return {
            kj: e,
            dw: n,
            lj: r,
            w_: t
        };
    }), Ssr = F4(function(n, r, t, e) {
        var u, a = 3 === (u = t.CX).$ ? u.a : h, i = GIn(r);
        return b(A4(jsr, n, i, e, t.kj), A3(hZn, i, a, e.iu));
    }), zsr = F2(function(n, r) {
        return b(r, Dp);
    }), Usr = F2(function(n, r) {
        return r;
    }), Esr = F2(function(n, r) {
        return v(r, Dp, h);
    }), Psr = F2(function() {
        return {
            gF: k([
                Sq
            ]),
            wD: "Signup"
        };
    }), Tsr = sZn({
        zO: Ssr,
        Ab: zsr,
        Ct: Usr,
        Dd: function() {
            return yk;
        },
        DB: Esr,
        DH: Psr
    }), Fsr = k([
        A2(Ik, h, k([
            Jk(k([
                n5,
                M7(k([
                    Nk("mr-8")
                ]))
            ])),
            Jk(k([
                M7(k([
                    Nk("mr-8")
                ]))
            ])),
            Jk(k([
                Wk,
                M7(k([
                    Nk("mr-8")
                ]))
            ]))
        ]))
    ]), Lsr = QMn({
        DH: function() {
            return {
                gF: Fsr,
                wD: "Spinner"
            };
        }
    }), Msr = function(n) {
        return {
            zO: F2(function(r, t) {
                var e = n.zO(t);
                return v(e.a, e.b, h);
            }),
            Ab: rm(A2(Je, ru, YMn)),
            Ct: rm(ru),
            Dd: n.Dd,
            DB: F2(function(r, t) {
                var e = A2(n.DB, r, t);
                return v(e.a, e.b, h);
            }),
            DH: n.DH
        };
    }, Hsr = F2(function(n, r) {
        var t = A2(Kpn, n, r.l0), e = t.b;
        return b(m(r, {
            l0: t.a
        }), A2(jp, ru, e));
    }), Rsr = Msr({
        zO: function() {
            return b({
                l0: bbn("main-address")
            }, Dp);
        },
        Dd: function() {
            return xk(k([
                A2(xD, ru, pvn)
            ]));
        },
        DB: Hsr,
        DH: function(n) {
            var r, t;
            return {
                gF: (r = n, t = r.l0, k([
                    A2(Ik, k([
                        Nk("section")
                    ]), k([
                        A2(mx, k([
                            Qk(k([
                                Nk("underline mb-2")
                            ]))
                        ]), k([
                            ad("Address Input")
                        ])),
                        A2(px, ru, A3(Ghn, Rk(0), h, t))
                    ]))
                ])),
                wD: "Address Input"
            };
        }
    }), Osr = F2(function() {
        return v({}, Dp, h);
    }), Nsr = F2(function(n, r) {
        return b(r, Dp);
    }), Isr = F2(function(n, r) {
        return r;
    }), Vsr = F2(function(n, r) {
        return v(r, Dp, k([
            A2(nA, n.a, KD(n.b))
        ]));
    }), Wsr = F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    }), Zsr = k([
        A2(Ik, k([
            Nk("mb-4")
        ]), k([
            A2(fz, k([
                nz,
                QS(A2(Wsr, 0, "Lots of info"))
            ]), k([
                ad("Info")
            ]))
        ])),
        A2(Ik, k([
            Nk("mb-4")
        ]), k([
            A2(fz, k([
                CU,
                QS(A2(Wsr, 3, "Wohoo"))
            ]), k([
                ad("Success")
            ]))
        ])),
        A2(Ik, k([
            Nk("mb-4")
        ]), k([
            A2(fz, k([
                CU,
                QS(A2(Wsr, 1, "Oopsie Daisy!"))
            ]), k([
                ad("Error")
            ]))
        ])),
        A2(Ik, k([
            Nk("mb-4")
        ]), k([
            A2(fz, k([
                CU,
                QS(A2(Wsr, 2, "Halt!"))
            ]), k([
                ad("Warning")
            ]))
        ]))
    ]), Xsr = {
        zO: Osr,
        Ab: Nsr,
        Ct: Isr,
        Dd: function() {
            return yk;
        },
        DB: Vsr,
        DH: function() {
            return {
                gF: Zsr,
                wD: "Alerts"
            };
        }
    }, Gsr = {
        $: 2
    }, Jsr = F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    }), Ysr = k([
        A2(Jsr, {
            qU: "pct-FDrfQFrCr9Ev-1",
            sS: "Affiliate Doctor"
        }, 0),
        A2(Jsr, {
            qU: "pct-B3cB7yLItKyF",
            sS: "Alek Rabiner2"
        }, 0),
        A2(Jsr, {
            qU: "pct-Y94f3tsrFmA2-1",
            sS: "Allison Gapinski, FNP-C"
        }, 0),
        A2(Jsr, {
            qU: "pct-pL6TRfjALmTV-1",
            sS: "Amanda Hayes, FNP-C"
        }, 0),
        A2(Jsr, {
            qU: "pct-KhfOqVFSKPWi-1",
            sS: "Amanda Thompson, FNP-C"
        }, 0),
        A2(Jsr, {
            qU: "pct-rg3CPavMEcR4-1",
            sS: "Anais Lauren K. Joines, FNP-C"
        }, 0),
        A2(Jsr, {
            qU: "pct-mR0b2TFfodQQ-1",
            sS: "Ayesha Nasir, MD"
        }, 0),
        A2(Jsr, {
            qU: "pct-raXYk919T8Nf",
            sS: "Bailee Aff Demo"
        }, 0),
        A2(Jsr, {
            qU: "pct-gkfcJ545oFdG-1",
            sS: "Beena Patel, DO"
        }, 0),
        A2(Jsr, {
            qU: "pct-byZhy2hrTf7k-1",
            sS: "Beth Bethany"
        }, 0),
        A2(Jsr, {
            qU: "pct-3wEr5WuC6CoW-1",
            sS: "Daniel McKearney, PA-C"
        }, 0),
        A2(Jsr, {
            qU: "pct-zVBTNmQYmXyZ-1",
            sS: "Dr Ashley Doctor"
        }, 0),
        A2(Jsr, {
            qU: "pct-rtJiHD8xo3c7",
            sS: "Dr Bart II"
        }, 0),
        A2(Jsr, {
            qU: "pct-2PREw4FNWDRR",
            sS: "Dr Lisa Affiliate at DPC"
        }, 0),
        A2(Jsr, {
            qU: "pct-j89hrSCDZAgt-1",
            sS: "Dr Lovely Affiliate"
        }, 0),
        A2(Jsr, {
            qU: "pct-0e6lXqNGgVeI-1",
            sS: "Dr Maicol"
        }, 0),
        A2(Jsr, {
            qU: "pct-RRo6HPhQI1H8",
            sS: "Dr Nina Affiliate at Nina's Affiliate"
        }, 0),
        A2(Jsr, {
            qU: "pct-RFA6H9L7QaE3",
            sS: "Dr Nina Doc"
        }, 0),
        A2(Jsr, {
            qU: "pct-G81Otf86rzCw-1",
            sS: "Dr Nina Mae"
        }, 0),
        A2(Jsr, {
            qU: "pct-hB2EvKS9u9T3",
            sS: "Dr Steve at DPC"
        }, 0),
        A2(Jsr, {
            qU: "pct-M9DdDRA6Xak5-1",
            sS: "Dr Tasha"
        }, 0),
        A2(Jsr, {
            qU: "pct-IDkC9B4DBojo",
            sS: "Dr Unlinked to Affiliate For Now"
        }, 0),
        A2(Jsr, {
            qU: "pct-4H0vTuTD9qT2",
            sS: "Dr. Aaron Cho"
        }, 0),
        A2(Jsr, {
            qU: "pct-ad0cH9Cu7p51-1",
            sS: "Dr. Brave"
        }, 0)
    ]), Qsr = function(n) {
        return n.a.sS;
    }, Ksr = {
        hP: 10,
        sS: Rt
    }, nlr = F2(function(n, r) {
        var t = n(Ksr);
        return A2(Eu, function() {
            var n, e;
            return r((n = t.sS, e = function() {
                if (n.$) return Ysr;
                var r = n.a;
                return A2(Tc, function(n) {
                    return A2(uu, OB(r), OB(Qsr(n)));
                }, Ysr);
            }(), A2(f_, e, oa)));
        }, qp(500));
    }), rlr = F3(function(n, r, t) {
        return A2(nlr, function(r) {
            return m(r, {
                hP: n,
                sS: t
            });
        }, r);
    }), tlr = function(n) {
        return n.a.qU;
    }, elr = function(n) {
        return {
            $: 1,
            a: n
        };
    }, ulr = F4(function(n, r, t, e) {
        switch(e.$){
            case 1:
                return n;
            case 2:
                return r;
            default:
                return t(e.a);
        }
    }), alr = F4(function(n, r, t, e) {
        switch(e.$){
            case 1:
                return n;
            case 2:
                return r;
            default:
                return Ht(t(e.a));
        }
    }), ilr = {
        jQ: "All",
        jR: Ht(""),
        hP: 10,
        kI: "None",
        kJ: Rt
    }, clr = F2(function(n, r) {
        var t = n.qU, e = n.p4, u = n.Dt, a = n.Dr, i = r(ilr), c = A2(e, i.hP, elr);
        return b({
            g3: Mx,
            kO: i,
            lb: c,
            fs: !1,
            fw: _bn({
                qU: t,
                Dr: function() {
                    return A3(ulr, i.jQ, i.kI, a);
                },
                Dt: A3(alr, i.jR, i.kJ, u)
            }),
            iE: Ht(Gsr)
        }, c(Rt));
    }), olr = function(n) {
        return {
            $: 0,
            a: n
        };
    }, flr = F2(function(n, r) {
        if (n.$) return v(m(r, {
            g3: n.a,
            fs: !1
        }), Dp, Rt);
        var t = A2(z$n, n.a, r.fw), e = t.a, u = t.b, a = t.c, i = function() {
            if (a.$) return v(r, Dp, Rt);
            if (a.a.$) {
                var n = a.a.a;
                return v(m(r, {
                    fs: !0
                }), r.lb(Ht(n)), Rt);
            }
            var t = a.a.a;
            return v(m(r, {
                iE: t
            }), Dp, Ht(A2(uc, Gsr, t)));
        }(), c = i.b, o = i.c;
        return v(m(i.a, {
            fw: e
        }), Hu(k([
            A2(jp, olr, u),
            c
        ])), o);
    }), slr = F2(function(n, r) {
        var t = A2(flr, n, r.d9), e = t.a, u = t.b, a = t.c, i = a.$ ? r : m(r, {
            cP: a.a
        });
        return b(m(i, {
            d9: e
        }), A2(jp, ru, u));
    }), llr = {
        $: 1
    }, dlr = F3(function(n, r, t) {
        if (ED(n)) return k([
            fwn("No results found")
        ]);
        var e = function(n) {
            return A2(uc, Rt, A2(Cp, lu, A2(Zu, "x-total-count", n)));
        }(r);
        if (e.$) return h;
        var u = e.a;
        return s(u, t) > 0 ? k([
            fwn("Search for " + ee(u - t) + " more results")
        ]) : h;
    }), blr = F2(function(n, r) {
        var t = function() {
            var n = r.g3;
            if (3 === n.$) {
                var t = n.a, e = n.b, u = A2(Ot, lwn(r.iE), r.fs ? k([
                    iwn(!0)
                ]) : h), a = A2(yu, function(n) {
                    return A2(Xz, h, function(n) {
                        return {
                            $: 0,
                            a: n
                        };
                    }(n));
                }, t), i = $(A2(yu, function(n) {
                    return A2(Xz, h, n);
                }, k([
                    llr,
                    Gsr
                ])), k([
                    IL
                ]));
                return b(u, $(i, $(a, A3(dlr, t, e, r.kO.hP))));
            }
            return b(k([
                cwn("Loading..."),
                iwn(!0)
            ]), h);
        }();
        return A2(px, olr, A4(Bwn, n, t.a, t.b, r.fw));
    }), vlr = function(n) {
        return k([
            A2(Ik, k([
                Nk("section")
            ]), k([
                A2(mx, k([
                    Qk(k([
                        Nk("underline mb-2")
                    ]))
                ]), k([
                    ad("Api Select")
                ])),
                A2(Ik, k([
                    Nk("mt-4")
                ]), k([
                    A2(px, ru, A2(blr, Rk(0), n.d9))
                ])),
                A2(Ik, k([
                    Nk("mt-4")
                ]), k([
                    A2(AW, k([
                        bW("Selected")
                    ]), k([
                        A2(hx, k([
                            BB
                        ]), k([
                            function() {
                                var r = n.cP;
                                switch(r.$){
                                    case 0:
                                        return ad(Qsr(r.a));
                                    case 1:
                                        return ad("All");
                                    default:
                                        return ad("None");
                                }
                            }()
                        ]))
                    ]))
                ]))
            ]))
        ]);
    }, mlr = Msr({
        zO: function() {
            var n = A2(clr, {
                p4: rlr,
                qU: "practitioners",
                Dr: Qsr,
                Dt: tlr
            }, function(n) {
                return m(n, {
                    jQ: "All Practitioners",
                    hP: 5
                });
            });
            return b({
                d9: n.a,
                cP: Gsr
            }, A2(jp, ru, n.b));
        },
        Dd: function() {
            return yk;
        },
        DB: slr,
        DH: function(n) {
            return {
                gF: vlr(n),
                wD: "Api Select"
            };
        }
    }), plr = function(n) {
        return {
            zO: F2(function(r, t) {
                return v(n.zO(t), Dp, h);
            }),
            Ab: rm(A2(Je, ru, YMn)),
            Ct: rm(ru),
            Dd: function() {
                return yk;
            },
            DB: F2(function(r, t) {
                return v(A2(n.DB, r, t), Dp, h);
            }),
            DH: n.DH
        };
    }, $lr = F2(function(n, r) {
        return m(r, {
            eh: !r.eh
        });
    }), hlr = plr({
        zO: function() {
            return {
                eh: !1
            };
        },
        DB: $lr,
        DH: function(n) {
            var r, t;
            return {
                gF: (r = n, t = r.eh, k([
                    A2(Ik, k([
                        Nk("section")
                    ]), k([
                        A2(mx, k([
                            Qk(k([
                                Nk("underline mb-2")
                            ]))
                        ]), k([
                            ad("Buttons")
                        ])),
                        A2(Ik, h, k([
                            A2(fz, k([
                                nz
                            ]), k([
                                ad("Primary")
                            ])),
                            A2(fz, k([
                                CU
                            ]), k([
                                ad("Secondary")
                            ])),
                            A2(fz, k([
                                Rz
                            ]), k([
                                ad("Tonal")
                            ])),
                            A2(fz, k([
                                r4
                            ]), k([
                                ad("This is a link")
                            ]))
                        ])),
                        A2(Ik, k([
                            Nk("mt-4")
                        ]), k([
                            A2(fz, k([
                                nz,
                                ZS(!0)
                            ]), k([
                                ad("Primary Disabled")
                            ])),
                            A2(fz, k([
                                CU,
                                ZS(!0)
                            ]), k([
                                ad("Secondary Disabled")
                            ])),
                            A2(fz, k([
                                Rz,
                                ZS(!0)
                            ]), k([
                                ad("Tonal Disabled")
                            ]))
                        ])),
                        A2(Ik, k([
                            Nk("mt-4")
                        ]), k([
                            A2(fz, k([
                                nz,
                                Don(t),
                                QS(0)
                            ]), k([
                                ad("Primary Loading")
                            ])),
                            A2(fz, k([
                                CU,
                                Don(t),
                                QS(0)
                            ]), k([
                                ad("Secondary Loading")
                            ])),
                            A2(fz, k([
                                Rz,
                                Don(t),
                                QS(0)
                            ]), k([
                                ad("Tonal Loading")
                            ]))
                        ])),
                        A2(Ik, k([
                            Nk("mt-4")
                        ]), k([
                            A2(fz, k([
                                nz
                            ]), k([
                                A2(US, h, 1),
                                A2(Gk, h, k([
                                    ad("with Icon")
                                ]))
                            ])),
                            A2(fz, k([
                                nz
                            ]), k([
                                A2(Gk, h, k([
                                    ad("with Icon")
                                ])),
                                A2(US, h, 0)
                            ])),
                            A2(fz, k([
                                nz
                            ]), k([
                                A2(Gk, h, k([
                                    ad("Play icon")
                                ])),
                                A2(US, h, 35)
                            ]))
                        ]))
                    ])),
                    A2(Ik, k([
                        Nk("section mt-4")
                    ]), k([
                        A2(mx, k([
                            Qk(k([
                                Nk("underline mb-2")
                            ]))
                        ]), k([
                            ad("Links")
                        ])),
                        A2(Ik, h, k([
                            A2(gV, h, k([
                                ad("Regular link")
                            ]))
                        ])),
                        A2(Ik, k([
                            Nk("mt-4")
                        ]), k([
                            A2(gV, k([
                                bV
                            ]), k([
                                ad("Link in disguise")
                            ]))
                        ]))
                    ]))
                ])),
                wD: "Button"
            };
        }
    }), glr = F2(function(n, r) {
        return r;
    }), wlr = k([
        "Unlimited telemedicine 24/7",
        "Unrushed visits",
        "Wholesale pricing on supplies",
        "And more"
    ]), klr = function(n) {
        return k([
            A2(US, k([
                LV(Tan)
            ]), 1),
            ad(n)
        ]);
    }, xlr = k([
        A2(lV, k([
            eyn
        ]), k([
            A2(iV, k([
                UZ(12)
            ]), k([
                A2(lV, k([
                    uV(kz),
                    dV(NZ)
                ]), k([
                    A2(iV, k([
                        Oun(8)
                    ]), k([
                        A2(UV, h, k([
                            ad("Virtual DPC")
                        ])),
                        A2(hx, k([
                            BB
                        ]), k([
                            ad("Basic plan that enables direct primary care for its members")
                        ]))
                    ])),
                    A2(iV, k([
                        Oun(4),
                        A2(von, 2, Nun)
                    ]), k([
                        A2(PB, k([
                            rx
                        ]), k([
                            ad("$30")
                        ])),
                        A2(PB, k([
                            BB
                        ]), k([
                            ad("/m")
                        ]))
                    ]))
                ])),
                gx,
                A2(Van, k([
                    A2(kJn, 2, 2),
                    A2(kJn, 3, 3)
                ]), A2(yu, A2(sc, Pan, klr), wlr))
            ]))
        ]))
    ]), ylr = plr({
        zO: function() {
            return {};
        },
        DB: glr,
        DH: function() {
            return {
                gF: xlr,
                wD: "Card Example"
            };
        }
    }), _lr = F2(function(n, r) {
        switch(n.$){
            case 0:
                return m(r, {
                    gN: t = n.a
                });
            case 1:
                return m(r, {
                    gO: t = n.a
                });
            case 2:
                return m(r, {
                    em: t = n.a
                });
            case 3:
                return m(r, {
                    en: t = n.a
                });
            case 4:
                return m(r, {
                    eo: t = n.a
                });
            default:
                var t;
                return m(r, {
                    em: t = n.a,
                    en: t,
                    eo: t
                });
        }
    }), Clr = function(n) {
        return {
            $: 0,
            a: n
        };
    }, Dlr = function(n) {
        return {
            $: 1,
            a: n
        };
    }, Alr = function(n) {
        return {
            $: 2,
            a: n
        };
    }, qlr = function(n) {
        return {
            $: 3,
            a: n
        };
    }, Blr = function(n) {
        return {
            $: 4,
            a: n
        };
    }, jlr = function(n) {
        return {
            $: 5,
            a: n
        };
    }, Slr = plr({
        zO: function() {
            return {
                gN: !1,
                gO: !0,
                em: !1,
                en: !1,
                eo: !1
            };
        },
        DB: _lr,
        DH: function(n) {
            var r, t, e, u, a, c, o, f, s;
            return {
                gF: k([
                    (r = n, e = r.gN, u = r.gO, a = r.em, c = r.en, o = r.eo, f = !(i(a, c) && i(c, o)), s = a && c && o, A2(Ik, k([
                        Nk("section")
                    ]), k([
                        A2(mx, k([
                            Qk(k([
                                Nk("underline mb-2")
                            ]))
                        ]), k([
                            ad("Checkboxes")
                        ])),
                        A2(Ik, k([
                            Nk("mb-4")
                        ]), k([
                            A2(QW, k([
                                ZW(e),
                                WW(Clr)
                            ]), k([
                                ad("Checkbox")
                            ]))
                        ])),
                        A2(Ik, k([
                            Nk("mb-4")
                        ]), k([
                            A2(QW, k([
                                ZW(u),
                                WW(Dlr)
                            ]), k([
                                A2($x, h, k([
                                    ad("Checkbox")
                                ])),
                                A2($x, h, k([
                                    ad("With multiple lines")
                                ]))
                            ]))
                        ])),
                        A2(Ik, k([
                            Nk("mb-4")
                        ]), k([
                            A2(QW, k([
                                ZW(!1),
                                VW(!0)
                            ]), k([
                                ad("Disabled Checkbox")
                            ])),
                            A2(QW, k([
                                ZW(!0),
                                VW(!0)
                            ]), k([
                                ad("Disabled Checkbox")
                            ]))
                        ])),
                        A2(Ik, k([
                            Nk("mb-4")
                        ]), k([
                            A2(QW, k([
                                ZW(!1),
                                k4(!0)
                            ]), k([
                                ad("Invalid Checkbox")
                            ]))
                        ])),
                        A2(Ik, k([
                            Nk("mb-4")
                        ]), k([
                            A2(QW, k([
                                ZW(s),
                                (t = f, function(n) {
                                    return {
                                        $: 3,
                                        a: n
                                    };
                                }(t)),
                                WW(jlr)
                            ]), k([
                                ad("Check All")
                            ])),
                            A2(QW, k([
                                ZW(a),
                                WW(Alr)
                            ]), k([
                                ad("A")
                            ])),
                            A2(QW, k([
                                ZW(c),
                                WW(qlr)
                            ]), k([
                                ad("B")
                            ])),
                            A2(QW, k([
                                ZW(o),
                                WW(Blr)
                            ]), k([
                                ad("C")
                            ]))
                        ]))
                    ])))
                ]),
                wD: "Checkbox"
            };
        }
    }), zlr = {
        $: 0
    }, Ulr = F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    }), Elr = F2(function(n, r) {
        return {
            qU: n,
            sS: r
        };
    }), Plr = k([
        A2(Elr, "loc-1234", "Tatooine"),
        A2(Elr, "loc-2345", "Kashyyyk"),
        A2(Elr, "loc-3456", "Mandalore")
    ]), Tlr = function(n) {
        return A2(Eu, function() {
            return function(n) {
                return {
                    $: 1,
                    a: n
                };
            }(function(n) {
                return {
                    $: 1,
                    a: n
                };
            }(A2(Tc, function(r) {
                return A2(uu, n, r.sS);
            }, Plr)));
        }, qp(3e3));
    }, Flr = F2(function(n, r) {
        return 1 === r.$ ? n(r.a) : r.a;
    }), Llr = F2(function(n, r) {
        return 1 === r.$ ? Ht(n(r.a)) : r.b;
    }), Mlr = function(n) {
        return {
            $: 3,
            a: n
        };
    }, Hlr = function(n) {
        return {
            $: 2,
            a: n
        };
    }, Rlr = F2(function(n, r) {
        switch(n.$){
            case 1:
                return b(m(r, {
                    eV: n.a
                }), Dp);
            case 0:
                return b(m(r, {
                    jH: n.a
                }), Dp);
            case 3:
                var t = A2(bq, n.a, r.ex), e = t.b;
                return b(m(r, {
                    ex: a = t.a,
                    dI: (i = t.c).$ || i.a.$ || i.a.a.$ ? r.dI : i.a.a.a
                }), A2(jp, Mlr, e));
            default:
                var u = A2(z$n, n.a, r.eW), a = u.a, i = (e = u.b, u.c), c = function() {
                    n: for(; !i.$;){
                        if (i.a.$) {
                            var n = i.a.a;
                            return b(m(r, {
                                eV: zlr
                            }), Tlr(n));
                        }
                        if (i.a.a.$) break n;
                        return b(m(r, {
                            dJ: i.a.a.a
                        }), Dp);
                    }
                    return b(r, Dp);
                }(), o = c.b;
                return b(m(c.a, {
                    eW: a
                }), Hu(k([
                    o,
                    A2(jp, Hlr, e)
                ])));
        }
    }), Olr = F3(function(n, r, t) {
        return 1 === t.$ ? k([
            A2(r, n, t.a)
        ]) : 1 === t.b.$ ? h : k([
            A2(Ax, n, t.b.a)
        ]);
    }), Nlr = function(n) {
        var r = n.dI, t = n.dJ;
        return Bx(A2(Xi, A3(Olr, "location", F2(function(n, r) {
            return A2(Ax, n, r.qU);
        }), t), A3(Olr, "distance", YX, r)));
    }, Ilr = {
        $: 3
    }, Vlr = function(n) {
        return {
            $: 1,
            a: n
        };
    }, Wlr = k([
        5,
        10,
        20
    ]), Zlr = F2(function(n, r) {
        var t = A2(yu, Xz(h), A2(Ot, A2(Ulr, "Any Distance", Rt), A2(yu, Vlr, Wlr)));
        return k([
            A2(px, Mlr, A4(AU, Rk(0), k([
                Jz(Ht(n)),
                Wz,
                ZL("Any Distance")
            ]), t, r))
        ]);
    }), Xlr = {
        $: 5
    }, Glr = F3(function(n, r, t) {
        var e, u = 1 === (e = n).$ ? Ht(e.a) : Rt, a = A2(uc, !0, A2(Cp, rm(!1), u)), i = function() {
            if (1 === u.$) return h;
            var n = u.a;
            return A2(yu, Xz(h), A2(Ot, A2(Ulr, "Any Location", Rt), A2(yu, Vlr, n)));
        }();
        return k([
            A2(px, Hlr, A4(Bwn, Rk(0), k([
                lwn(Ht(r)),
                iwn(a),
                Xlr,
                cwn("Any Location")
            ]), i, t))
        ]);
    }), Jlr = function(n) {
        return {
            $: 0,
            a: n
        };
    }, Ylr = {
        $: 5
    }, Qlr = function(n) {
        return n ? "map" : "list";
    }, Klr = function(n) {
        return k([
            A2(VU, k([
                uE(Qlr(n))
            ]), k([
                A2(WU, k([
                    SU,
                    Ylr,
                    ZU(A2(sc, Jlr, rm(0))),
                    uE(Qlr(0))
                ]), k([
                    ad("List")
                ])),
                A2(WU, k([
                    SU,
                    Ylr,
                    ZU(A2(sc, Jlr, rm(1))),
                    uE(Qlr(1))
                ]), k([
                    ad("Map")
                ]))
            ]))
        ]);
    }, ndr = function(n) {
        var r = n.eV, t = n.eW, e = n.dJ, u = n.jH, a = n.dI, i = n.ex;
        return k([
            A2(lV, k([
                eyn,
                MLn
            ]), k([
                A2(iV, k([
                    UZ(12)
                ]), k([
                    A2(lV, k([
                        dV(NZ)
                    ]), k([
                        A2(iV, k([
                            OLn
                        ]), k([
                            A2(lV, k([
                                dV(aV)
                            ]), k([
                                A2(iV, k([
                                    UZ(12)
                                ]), k([
                                    yP(k([
                                        lP("Search by name")
                                    ]))
                                ]))
                            ])),
                            A2(lV, k([
                                dV(NZ)
                            ]), k([
                                A2(iV, k([
                                    Oun(4)
                                ]), A3(Glr, r, e, t)),
                                A2(iV, k([
                                    Oun(4)
                                ]), k([
                                    yP(h)
                                ])),
                                A2(iV, k([
                                    Oun(4)
                                ]), A2(Zlr, a, i))
                            ]))
                        ])),
                        A2(iV, k([
                            Ilr
                        ]), k([
                            A2(lV, k([
                                dV(aV)
                            ]), k([
                                A2(iV, h, Klr(u))
                            ])),
                            A2(lV, k([
                                dV(NZ)
                            ]), k([
                                A2(iV, h, k([
                                    yP(h)
                                ]))
                            ]))
                        ]))
                    ]))
                ]))
            ])),
            ad("Query: " + Nlr(n))
        ]);
    }, rdr = Msr({
        zO: function() {
            return b({
                ex: id({
                    qU: "distances-select",
                    Dr: function() {
                        return Flr(function(n) {
                            return ee(n) + " miles";
                        });
                    },
                    Dt: Llr(ee)
                }),
                eV: zlr,
                eW: _bn({
                    qU: "locations-select",
                    Dr: function() {
                        return Flr(function(n) {
                            return n.sS;
                        });
                    },
                    Dt: Llr(function(n) {
                        return n.qU;
                    })
                }),
                dI: A2(Ulr, "Distance", Rt),
                dJ: A2(Ulr, "Location", Rt),
                jH: 0
            }, Tlr(""));
        },
        Dd: function() {
            return yk;
        },
        DB: Rlr,
        DH: function(n) {
            return {
                gF: ndr(n),
                wD: "Filters"
            };
        }
    }), tdr = {
        l7: Rt,
        qb: "",
        qv: 1,
        rt: "",
        t0: A2(yO, "cool-phone", {
            hE: !0,
            BT: "6668675309",
            im: lX
        }),
        jy: !1
    }, edr = function(n) {
        return {
            $: 3,
            a: n
        };
    }, udr = F2(function(n, r) {
        switch(n.$){
            case 2:
                return m(r, {
                    qb: n.a
                });
            case 3:
                return m(r, {
                    rt: n.a
                });
            case 0:
                return m(r, {
                    qv: n.a
                });
            case 1:
                return m(r, {
                    l7: n.a
                });
            default:
                return m(r, {
                    t0: n.a
                });
        }
    }), adr = ZN(k([
        A2(u5n, function(n) {
            return n.qb;
        }, b(0, PI(cI))),
        A2(u5n, function(n) {
            return n.rt;
        }, b(1, PI(oI))),
        function() {
            return h;
        },
        function(n) {
            var r = n.t0;
            return A2(pI, r.BT, r.CD) || fu(r.BT), h;
        }
    ])), idr = {
        $: 2
    }, cdr = F2(function(n, r) {
        switch(n.$){
            case 0:
                return b(m(r, {
                    kk: A3(WI, udr, n.a, r.kk)
                }), Dp);
            case 1:
                var t = A2(wI, adr, r.kk);
                return t.$ ? b(m(r, {
                    kk: t.a
                }), Dp) : b(m(r, {
                    kk: t.a.a,
                    uA: !0
                }), A2(Eu, function() {
                    return idr;
                }, qp(3e3)));
            case 2:
                return b(m(r, {
                    uA: !1
                }), Dp);
            default:
                var e = n.a, u = jN(r.kk), a = A2(VI, e, u.t0), i = a.b, c = A3(WI, udr, function(n) {
                    return {
                        $: 4,
                        a: n
                    };
                }(a.a), r.kk);
                return b(m(r, {
                    kk: c
                }), A2(jp, edr, i));
        }
    }), odr = function(n) {
        return {
            $: 1,
            a: n
        };
    }, fdr = {
        $: 1
    }, sdr = function(n) {
        return {
            $: 2,
            a: n
        };
    }, ldr = function(n) {
        return {
            $: 0,
            a: n
        };
    }, ddr = function(n) {
        return {
            $: 0,
            a: n
        };
    }, bdr = function(n) {
        return {
            $: 3,
            a: n
        };
    }, vdr = function(n) {
        return n ? "female" : "male";
    }, mdr = F2(function(n, r) {
        var t = lu(r);
        return 1 === t.$ ? "" === r ? Rt : n : Ht(t.a);
    }), pdr = F2(function(n, r) {
        var t, e = Rk(0), u = jN(r), a = u.qb, i = u.rt, c = u.l7, o = u.qv, f = u.t0;
        return A2(Ik, h, k([
            A2(lV, h, k([
                A2(iV, k([
                    UZ(6)
                ]), k([
                    A2(AW, k([
                        bW("First Name"),
                        hW(!0)
                    ]), k([
                        yP(k([
                            bP(a),
                            lP("Jane"),
                            xZ(A2(sc, ldr, sdr)),
                            oZ(A2(kW, 0, r))
                        ])),
                        A2(OW, e, A2(iW, 0, r))
                    ]))
                ])),
                A2(iV, k([
                    UZ(6)
                ]), k([
                    A2(AW, k([
                        bW("Last Name"),
                        hW(!0)
                    ]), k([
                        yP(k([
                            bP(i),
                            lP("Doe"),
                            xZ(A2(sc, ldr, bdr)),
                            oZ(A2(kW, 1, r))
                        ])),
                        A2(OW, e, A2(iW, 1, r))
                    ]))
                ]))
            ])),
            A2(AW, k([
                bW("Gender"),
                hW(!0)
            ]), k([
                A2(lV, h, k([
                    A2(iV, k([
                        UZ(6)
                    ]), k([
                        A2(IU, k([
                            SU,
                            ZU(A2(sc, A2(sc, ldr, ddr), rm(0))),
                            rwn(!o),
                            uE(vdr(0))
                        ]), k([
                            ad("Male")
                        ]))
                    ])),
                    A2(iV, k([
                        UZ(6)
                    ]), k([
                        A2(IU, k([
                            SU,
                            ZU(A2(sc, A2(sc, ldr, ddr), rm(1))),
                            rwn(1 === o),
                            uE(vdr(1))
                        ]), k([
                            ad("Female")
                        ]))
                    ]))
                ]))
            ])),
            A2(AW, k([
                bW("Age")
            ]), k([
                A2(lV, h, k([
                    A2(iV, k([
                        UZ(12)
                    ]), k([
                        yP(k([
                            bP((t = c, A2(uc, "", A2(Cp, ee, t)))),
                            lP("e.g 30"),
                            xZ(A2(sc, A2(sc, ldr, odr), mdr(c))),
                            oZ(A2(kW, 2, r))
                        ])),
                        A2(OW, e, A2(iW, 2, r))
                    ]))
                ]))
            ])),
            A2(AW, k([
                bW("Phone Number"),
                hW(!0)
            ]), k([
                A2(lV, h, k([
                    A2(iV, k([
                        UZ(12)
                    ]), k([
                        A2(px, edr, A3(vX, e, k([
                            OZ(A2(kW, 3, r))
                        ]), f)),
                        A2(OW, e, A2(iW, 3, r))
                    ]))
                ]))
            ])),
            A2(AW, k([
                bW("Tobacco use"),
                Ahn("Do you currently use, or have used tobacco products in the last twelve months?")
            ]), k([
                A2(lV, h, h)
            ])),
            A2(fz, k([
                nz,
                ZS(n),
                Don(n),
                QS(fdr)
            ]), k([
                ad("Submit")
            ]))
        ]));
    }), $dr = Msr({
        zO: function() {
            return b({
                kk: AO(tdr),
                uA: !1
            }, Dp);
        },
        Dd: function() {
            return yk;
        },
        DB: cdr,
        DH: function(n) {
            return {
                gF: k([
                    A2(pdr, n.uA, n.kk)
                ]),
                wD: "Form Example"
            };
        }
    }), hdr = k([
        A2(Ik, k([
            Nk("section")
        ]), k([
            A2(mx, k([
                Qk(k([
                    Nk("underline mb-2")
                ]))
            ]), k([
                ad("Grid")
            ])),
            A2(lV, h, k([
                A2(iV, k([
                    Oun(3)
                ]), k([
                    A2(Ik, k([
                        Nk("bg-primary-100 h-12 flex items-center justify-center")
                    ]), k([
                        ad("Col 3")
                    ]))
                ])),
                A2(iV, k([
                    Oun(3)
                ]), k([
                    A2(Ik, k([
                        Nk("bg-primary-200 h-12 flex items-center justify-center")
                    ]), k([
                        ad("Col 3")
                    ]))
                ])),
                A2(iV, k([
                    Oun(3)
                ]), k([
                    A2(Ik, k([
                        Nk("bg-primary-300 h-12 flex items-center justify-center")
                    ]), k([
                        ad("Col 3")
                    ]))
                ])),
                A2(iV, k([
                    Oun(3)
                ]), k([
                    A2(Ik, k([
                        Nk("bg-primary-400 h-12 flex items-center justify-center")
                    ]), k([
                        ad("Col 3")
                    ]))
                ]))
            ])),
            A2(lV, h, k([
                A2(iV, k([
                    Oun(6)
                ]), k([
                    A2(Ik, k([
                        Nk("bg-primary-200 h-12 flex items-center justify-center")
                    ]), k([
                        ad("Col 6")
                    ]))
                ])),
                A2(iV, k([
                    UZ(6),
                    Oun(3)
                ]), k([
                    A2(Ik, k([
                        Nk("bg-primary-300 h-12 flex items-center justify-center")
                    ]), k([
                        ad("Col 3")
                    ]))
                ])),
                A2(iV, k([
                    UZ(6),
                    Oun(3)
                ]), k([
                    A2(Ik, k([
                        Nk("bg-primary-200 h-12 flex items-center justify-center")
                    ]), k([
                        ad("Col 3")
                    ]))
                ]))
            ])),
            A2(lV, h, k([
                A2(iV, k([
                    Oun(2),
                    UZ(4)
                ]), k([
                    A2(Ik, k([
                        Nk("bg-primary-200 h-12 flex items-center justify-center")
                    ]), k([
                        ad("Col 2")
                    ]))
                ])),
                A2(iV, k([
                    Oun(2),
                    UZ(4)
                ]), k([
                    A2(Ik, k([
                        Nk("bg-primary-300 h-12 flex items-center justify-center")
                    ]), k([
                        ad("Col 2")
                    ]))
                ])),
                A2(iV, k([
                    Oun(2),
                    UZ(4)
                ]), k([
                    A2(Ik, k([
                        Nk("bg-primary-200 h-12 flex items-center justify-center")
                    ]), k([
                        ad("Col 2")
                    ]))
                ])),
                A2(iV, k([
                    Oun(6)
                ]), k([
                    A2(Ik, k([
                        Nk("bg-primary-300 h-12 flex items-center justify-center")
                    ]), k([
                        ad("Col 6")
                    ]))
                ]))
            ])),
            A2(lV, h, k([
                A2(iV, k([
                    UZ(6)
                ]), k([
                    A2(Ik, k([
                        Nk("bg-primary-200 h-12 flex items-center justify-center")
                    ]), k([
                        ad("Row.noGutter Col 6")
                    ]))
                ])),
                A2(iV, k([
                    UZ(3)
                ]), k([
                    A2(Ik, k([
                        Nk("bg-primary-300 h-12 flex items-center justify-center")
                    ]), k([
                        ad("Row.noGutter Col 3")
                    ]))
                ])),
                A2(iV, k([
                    UZ(3)
                ]), k([
                    A2(Ik, k([
                        Nk("bg-primary-200 h-12 flex items-center justify-center")
                    ]), k([
                        ad("Row.noGutter Col 3")
                    ]))
                ]))
            ])),
            A2(lV, h, k([
                Gan(k([
                    UZ(6)
                ])),
                A2(iV, k([
                    UZ(3)
                ]), k([
                    A2(Ik, k([
                        Nk("bg-primary-300 h-12 flex items-center justify-center")
                    ]), k([
                        ad("Col 3")
                    ]))
                ])),
                A2(iV, k([
                    UZ(3)
                ]), k([
                    A2(Ik, k([
                        Nk("bg-primary-200 h-12 flex items-center justify-center")
                    ]), k([
                        ad("Col 3")
                    ]))
                ]))
            ])),
            A2(lV, h, k([
                Gan(k([
                    UZ(3)
                ])),
                A2(iV, k([
                    UZ(3)
                ]), k([
                    A2(Ik, k([
                        Nk("bg-primary-300 h-12 flex items-center justify-center")
                    ]), k([
                        ad("Col 3")
                    ]))
                ])),
                A2(iV, k([
                    UZ(3)
                ]), k([
                    A2(Ik, k([
                        Nk("bg-primary-200 h-12 flex items-center justify-center")
                    ]), k([
                        ad("Col 3")
                    ]))
                ])),
                Gan(k([
                    UZ(3)
                ]))
            ]))
        ]))
    ]), gdr = QMn({
        DH: function() {
            return {
                gF: hdr,
                wD: "Grid"
            };
        }
    }), wdr = F2(function(n, r) {
        switch(n.$){
            case 0:
                return m(r, {
                    gC: n.a
                });
            case 1:
                return m(r, {
                    iC: n.a
                });
            default:
                return m(r, {
                    iy: n.a
                });
        }
    }), kdr = function(n) {
        return {
            $: 0,
            a: n
        };
    }, xdr = function(n) {
        return {
            $: 2,
            a: n
        };
    }, ydr = function(n) {
        return {
            $: 1,
            a: n
        };
    }, _dr = plr({
        zO: function() {
            return {
                gC: "Some initial text",
                iy: "",
                iC: ""
            };
        },
        DB: wdr,
        DH: function(n) {
            var r, t, e, u;
            return {
                gF: (r = n, t = r.gC, e = r.iC, u = r.iy, k([
                    A2(Ik, k([
                        Nk("section")
                    ]), k([
                        A2(mx, k([
                            Qk(k([
                                Nk("underline mb-2")
                            ]))
                        ]), k([
                            ad("Inputs")
                        ])),
                        A2(Ik, k([
                            Nk("mb-4")
                        ]), k([
                            yP(k([
                                bP(t),
                                xZ(kdr)
                            ]))
                        ])),
                        A2(Ik, k([
                            Nk("mb-4")
                        ]), k([
                            yP(k([
                                lP("Disabled"),
                                sP(!0)
                            ]))
                        ])),
                        A2(Ik, k([
                            Nk("mb-4")
                        ]), k([
                            yP(k([
                                lP("Secret"),
                                pJn(0),
                                xZ(ydr),
                                bP(e)
                            ]))
                        ])),
                        A2(Ik, k([
                            Nk("mb-4")
                        ]), k([
                            yP(k([
                                lP("This is required"),
                                bP(u),
                                oZ(fu(u)),
                                xZ(xdr)
                            ]))
                        ])),
                        A2(Ik, k([
                            Nk("mb-4")
                        ]), k([
                            ofn(k([
                                cfn(k([
                                    ad("$")
                                ])),
                                yP(k([
                                    bP("1.000,00")
                                ]))
                            ]))
                        ]))
                    ]))
                ])),
                wD: "Input"
            };
        }
    }), Cdr = function(n) {
        return {
            $: 0,
            a: n
        };
    }, Ddr = F2(function(n) {
        var r = A2(Abn, n.gx, !0);
        return v({
            aw: r.a
        }, A2(jp, Cdr, r.b), h);
    }), Adr = F2(function(n, r) {
        return b(r, Dp);
    }), qdr = F2(function(n, r) {
        return r;
    }), Bdr = F2(function(n, r) {
        if (n.$) {
            var t = A2(k$n, !0, r.aw), e = (u = t.a, k(t.b ? [
                A2(nA, 3, KD("Insurance info is valid!"))
            ] : [
                A2(nA, 1, KD("Insurance info is invalid!"))
            ]));
            return v(m(r, {
                aw: u
            }), Dp, e);
        }
        var u, a = A2(U$n, n.a, r.aw), i = a.b;
        return v(m(r, {
            aw: u = a.a
        }), A2(jp, Cdr, i), h);
    }), jdr = {
        $: 1
    }, Sdr = {
        zO: Ddr,
        Ab: Adr,
        Ct: qdr,
        Dd: function() {
            return yk;
        },
        DB: Bdr,
        DH: function(n) {
            var r, t;
            return {
                gF: (r = n, t = r.aw, k([
                    A2(Ik, k([
                        Nk("section")
                    ]), k([
                        A2(mx, k([
                            Qk(k([
                                Nk("underline mb-2")
                            ]))
                        ]), k([
                            ad("Phone Input")
                        ])),
                        A2(px, Cdr, A3(Gwn, Rk(0), !1, t)),
                        A2(fz, k([
                            nz,
                            QS(jdr),
                            vz(k([
                                Nk("mt-6")
                            ]))
                        ]), k([
                            A2(Gk, h, k([
                                ad("Validate")
                            ]))
                        ]))
                    ]))
                ])),
                wD: "Phone Input"
            };
        }
    }, zdr = {
        $: 3
    }, Udr = {
        $: 2
    }, Edr = function(n) {
        return {
            $: 6,
            a: n
        };
    }, Pdr = function(n) {
        return {
            $: 5,
            a: n
        };
    }, Tdr = F2(function(n, r) {
        switch(n.$){
            case 2:
                return b(m(r, {
                    e1: ND(r.e1),
                    dp: !1
                }), Dp);
            case 3:
                return b(m(r, {
                    aZ: ND(r.aZ)
                }), Dp);
            case 0:
                return b(m(r, {
                    e1: fA(r.e1),
                    dp: !1
                }), Dp);
            case 1:
                return b(m(r, {
                    aZ: fA(r.aZ)
                }), Dp);
            case 4:
                return b(m(r, {
                    e1: ND(r.e1),
                    dp: !0
                }), Dp);
            case 5:
                var t = A2(mq, n.a, r.e1), e = t.b;
                return b(m(r, {
                    e1: t.a
                }), A2(jp, Pdr, e));
            default:
                var u = A2(mq, n.a, r.aZ);
                return e = u.b, b(m(r, {
                    aZ: u.a
                }), A2(jp, Edr, e));
        }
    }), Fdr = {
        $: 0
    }, Ldr = {
        $: 1
    }, Mdr = {
        $: 4
    }, Hdr = k([
        A2(Ik, k([
            Nk("section")
        ]), k([
            A2(mx, k([
                Qk(k([
                    Nk("underline mb-2")
                ]))
            ]), k([
                ad("Modal Content!")
            ])),
            A2(lV, h, k([
                A2(iV, k([
                    Oun(3)
                ]), k([
                    A2(Ik, k([
                        Nk("bg-primary-200 h-12 flex items-center justify-center")
                    ]), k([
                        ad("Col 3")
                    ]))
                ])),
                A2(iV, k([
                    Oun(3)
                ]), k([
                    A2(Ik, k([
                        Nk("bg-primary-300 h-12 flex items-center justify-center")
                    ]), k([
                        ad("Col 3")
                    ]))
                ])),
                A2(iV, k([
                    Oun(3)
                ]), k([
                    A2(Ik, k([
                        Nk("bg-primary-200 h-12 flex items-center justify-center")
                    ]), k([
                        ad("Col 3")
                    ]))
                ])),
                A2(iV, k([
                    Oun(3)
                ]), k([
                    A2(Ik, k([
                        Nk("bg-primary-300 h-12 flex items-center justify-center")
                    ]), k([
                        ad("Col 3")
                    ]))
                ]))
            ])),
            A2(lV, h, k([
                A2(iV, k([
                    Oun(6)
                ]), k([
                    A2(Ik, k([
                        Nk("bg-primary-200 h-12 flex items-center justify-center")
                    ]), k([
                        ad("Col 6")
                    ]))
                ])),
                A2(iV, k([
                    UZ(6),
                    Oun(3)
                ]), k([
                    A2(Ik, k([
                        Nk("bg-primary-300 h-12 flex items-center justify-center")
                    ]), k([
                        ad("Col 3")
                    ]))
                ])),
                A2(iV, k([
                    UZ(6),
                    Oun(3)
                ]), k([
                    A2(Ik, k([
                        Nk("bg-primary-200 h-12 flex items-center justify-center")
                    ]), k([
                        ad("Col 3")
                    ]))
                ]))
            ]))
        ]))
    ]), Rdr = function(n) {
        return A2(Ik, h, n.dp ? k([
            A2(XT, h, k([
                ad("Modal Submitted")
            ]))
        ]) : h);
    }, Odr = function(n) {
        return k([
            A2(Ik, k([
                Nk("section")
            ]), k([
                A2(mx, k([
                    Qk(k([
                        Nk("underline mb-2")
                    ]))
                ]), k([
                    ad("Modal")
                ])),
                A2(Ik, k([
                    Nk("mt-4 flex flex-wrap gap-3")
                ]), k([
                    A2(fz, k([
                        nz,
                        QS(Fdr)
                    ]), k([
                        ad("Show Modal")
                    ])),
                    A2(fz, k([
                        nz,
                        QS(Ldr)
                    ]), k([
                        ad("Show full-viewport modal")
                    ]))
                ])),
                A2(Tz, k([
                    jZ(k([
                        ad("This is a Title for the Modal")
                    ])),
                    IS(Hdr),
                    XS(k([
                        A2(fz, k([
                            CU,
                            QS(Udr)
                        ]), k([
                            ad("Cancel")
                        ])),
                        A2(fz, k([
                            nz,
                            QS(Mdr)
                        ]), k([
                            ad("Submit")
                        ]))
                    ]))
                ]), n.e1),
                A3(Pz, 1, k([
                    WS,
                    IS(k([
                        A2(Ik, k([
                            Nk("flex h-full min-h-0 w-full flex-1 items-center justify-center rounded-md bg-primary-100")
                        ]), k([
                            ad("Content fills available space (e.g. image preview).")
                        ]))
                    ]))
                ]), n.aZ),
                Rdr(n)
            ]))
        ]);
    }, Ndr = Msr({
        zO: function() {
            var n = A2(ny, 0, Udr), r = n.a, t = n.b, e = A2(ny, 0, zdr);
            return b({
                aZ: e.a,
                e1: r,
                dp: !1
            }, Hu(k([
                t,
                e.b
            ])));
        },
        Dd: function() {
            return xk(k([
                A2(xD, Pdr, _D()),
                A2(xD, Edr, _D())
            ]));
        },
        DB: Tdr,
        DH: function(n) {
            return {
                gF: Odr(n),
                wD: "StyleGuide.Modal"
            };
        }
    }), Idr = {
        sS: "",
        k1: 0,
        uN: Ht(1)
    }, Vdr = F2(function(n, r) {
        switch(n.$){
            case 0:
                return m(r, {
                    sS: n.a
                });
            case 1:
                return m(r, {
                    k1: n.a
                });
            default:
                return m(r, {
                    uN: n.a
                });
        }
    }), Wdr = F2(function(n, r) {
        switch(n.$){
            case 0:
                var t = n.a;
                return b(m(r, {
                    bc: A3(gar, Vdr(n.b), t, r.bc)
                }), Dp);
            case 1:
                return b(m(r, {
                    bc: A2(L6, Idr, r.bc)
                }), Dp);
            default:
                return b(m(r, {
                    bc: A2(nmn, t = n.a, r.bc)
                }), Dp);
        }
    }), Zdr = {
        $: 1
    }, Xdr = F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    }), Gdr = function(n) {
        return {
            $: 0,
            a: n
        };
    }, Jdr = function(n) {
        return {
            $: 1,
            a: n
        };
    }, Ydr = function(n) {
        return {
            $: 2,
            a: n
        };
    }, Qdr = function(n) {
        return {
            $: 2,
            a: n
        };
    }, Kdr = F2(function(n, r) {
        return A2(uc, n, lu(r));
    }), nbr = F2(function(n, r) {
        var t = lu(r);
        return 1 === t.$ ? "" === r ? Rt : n : Ht(t.a);
    }), rbr = function(n) {
        var r, t = n.a, e = n.b.sS, u = n.b.k1, a = n.b.uN;
        return b(ee(t), A2(lV, h, k([
            A2(iV, k([
                Oun(6)
            ]), k([
                A2(AW, k([
                    bW("Item")
                ]), k([
                    yP(k([
                        bP(e),
                        xZ(A2(sc, Xdr(t), Gdr))
                    ]))
                ]))
            ])),
            A2(iV, k([
                Oun(3),
                UZ(6)
            ]), k([
                A2(AW, k([
                    bW("Quantiy")
                ]), k([
                    yP(k([
                        bP((r = a, A2(uc, "", A2(Cp, ee, r)))),
                        xZ(A2(sc, A2(sc, Xdr(t), Ydr), nbr(a)))
                    ]))
                ]))
            ])),
            A2(iV, k([
                Oun(3),
                UZ(6)
            ]), k([
                A2(AW, k([
                    bW("Price")
                ]), k([
                    yP(k([
                        bP(ee(u)),
                        xZ(A2(sc, A2(sc, Xdr(t), Jdr), Kdr(u)))
                    ])),
                    A2(fz, k([
                        r4,
                        QS(Qdr(t))
                    ]), k([
                        ad("Remove")
                    ]))
                ]))
            ]))
        ])));
    }, tbr = Msr({
        zO: function() {
            return b({
                bc: A2(L6, Idr, Z3)
            }, Dp);
        },
        Dd: function() {
            return yk;
        },
        DB: Wdr,
        DH: function(n) {
            return {
                gF: k([
                    A2(Ik, h, k([
                        A3($U, "div", h, A2($4, rbr, n.bc)),
                        A2(fz, k([
                            nz,
                            QS(Zdr)
                        ]), k([
                            ad("Add charge")
                        ]))
                    ]))
                ]),
                wD: "MultiForm"
            };
        }
    }), ebr = F2(function(n, r) {
        var t = A2(VI, n, r.t0), e = t.b;
        return b(m(r, {
            t0: t.a
        }), A2(jp, ru, e));
    }), ubr = Msr({
        zO: function() {
            return b({
                t0: qbn("cool-phone")
            }, Dp);
        },
        Dd: function() {
            return yk;
        },
        DB: ebr,
        DH: function(n) {
            var r, t;
            return {
                gF: (r = n, t = r.t0, k([
                    A2(Ik, k([
                        Nk("section")
                    ]), k([
                        A2(mx, k([
                            Qk(k([
                                Nk("underline mb-2")
                            ]))
                        ]), k([
                            ad("Phone Input")
                        ])),
                        A2(px, ru, A3(vX, Rk(0), h, t))
                    ]))
                ])),
                wD: "Phone Input"
            };
        }
    }), abr = F2(function(n, r) {
        return m(r, n.$ ? {
            h6: n.a
        } : {
            iv: n.a
        });
    }), ibr = function(n) {
        return {
            $: 0,
            a: n
        };
    }, cbr = k([
        0,
        1,
        2
    ]), obr = function(n) {
        return {
            $: 1,
            a: n
        };
    }, fbr = function(n) {
        switch(n){
            case 0:
                return "Kripton";
            case 1:
                return "Gotham";
            default:
                return "Central City";
        }
    }, sbr = function(n) {
        switch(n){
            case 0:
                return "kripton";
            case 1:
                return "gotham";
            default:
                return "central-city";
        }
    }, lbr = F2(function(n, r) {
        return A2(IU, k([
            SU,
            ZU(A2(sc, obr, rm(r))),
            rwn(i(n, r)),
            uE(sbr(r)),
            l9n(k([
                Nk("mr-2")
            ]))
        ]), k([
            A3(sc, ad, fbr, r)
        ]));
    }), dbr = plr({
        zO: function() {
            return {
                h6: 1,
                iv: "batman"
            };
        },
        DB: abr,
        DH: function(n) {
            var r, t, e;
            return {
                gF: (r = n, t = r.iv, e = r.h6, k([
                    A2(Ik, k([
                        Nk("section")
                    ]), k([
                        A2(mx, k([
                            Qk(k([
                                Nk("underline mb-2")
                            ]))
                        ]), k([
                            ad("Radio Buttons")
                        ])),
                        A2(Ik, k([
                            Nk("mb-4")
                        ]), k([
                            A2(IU, k([
                                uE("batman"),
                                rwn("batman" === t),
                                ZU(ibr)
                            ]), k([
                                ad("Batman")
                            ])),
                            A2(IU, k([
                                uE("flash"),
                                rwn("flash" === t),
                                ZU(ibr)
                            ]), k([
                                ad("The Flash")
                            ])),
                            A2(IU, k([
                                uE("superman"),
                                rwn("superman" === t),
                                ZU(ibr),
                                twn(!0)
                            ]), k([
                                ad("Superman")
                            ]))
                        ])),
                        A2(Ik, k([
                            Nk("mb-4")
                        ]), k([
                            A2(IU, k([
                                SU,
                                uE("batman"),
                                rwn("batman" === t),
                                ZU(ibr),
                                l9n(k([
                                    Nk("mr-2")
                                ]))
                            ]), k([
                                ad("Batman")
                            ])),
                            A2(IU, k([
                                SU,
                                uE("flash"),
                                rwn("flash" === t),
                                ZU(ibr),
                                l9n(k([
                                    Nk("mr-2")
                                ]))
                            ]), k([
                                ad("The Flash")
                            ])),
                            A2(IU, k([
                                SU,
                                uE("superman"),
                                rwn("superman" === t),
                                ZU(ibr),
                                l9n(k([
                                    Nk("mr-2")
                                ])),
                                twn(!0)
                            ]), k([
                                ad("Superman")
                            ]))
                        ])),
                        A2(Ik, h, k([
                            A2(VU, k([
                                uE(t),
                                ZU(ibr)
                            ]), k([
                                A2(WU, k([
                                    SU,
                                    uE("batman")
                                ]), k([
                                    ad("Batman")
                                ])),
                                A2(WU, k([
                                    SU,
                                    uE("flash")
                                ]), k([
                                    ad("The Flash")
                                ])),
                                A2(WU, k([
                                    SU,
                                    uE("superman"),
                                    twn(!0)
                                ]), k([
                                    ad("Superman")
                                ]))
                            ]))
                        ])),
                        A2(Ik, k([
                            Nk("mt-4")
                        ]), k([
                            A2(VU, k([
                                uE(t),
                                ZU(ibr),
                                YU
                            ]), k([
                                A2(WU, k([
                                    SU,
                                    uE("batman")
                                ]), k([
                                    ad("Batman")
                                ])),
                                A2(WU, k([
                                    SU,
                                    uE("flash")
                                ]), k([
                                    ad("The Flash")
                                ])),
                                A2(WU, k([
                                    SU,
                                    uE("superman")
                                ]), k([
                                    ad("Superman")
                                ])),
                                A2(WU, k([
                                    SU,
                                    uE("wonder-woman")
                                ]), k([
                                    ad("Wonder Woman")
                                ]))
                            ]))
                        ]))
                    ])),
                    A2(Ik, k([
                        Nk("section mt-4")
                    ]), k([
                        A2(mx, k([
                            Qk(k([
                                Nk("underline mb-2")
                            ]))
                        ]), k([
                            ad("With an elm type")
                        ])),
                        A2(Ik, k([
                            Nk("mt-4")
                        ]), A2(yu, lbr(e), cbr))
                    ]))
                ])),
                wD: "Radio"
            };
        }
    }), bbr = {
        $: 2
    }, vbr = function(n) {
        return {
            $: 1,
            a: n
        };
    }, mbr = F2(function(n, r) {
        return A4(uqn, n, "dpc-network", function(n) {
            return m(n, {
                sS: r
            });
        }, vbr);
    }), pbr = function(n) {
        switch(n.$){
            case 1:
                return "All Practitioners";
            case 2:
                return "None";
            default:
                return hH(n.a);
        }
    }, $br = function(n) {
        switch(n.$){
            case 1:
                return Ht("");
            case 2:
                return Rt;
            default:
                return Ht(Hjn(n.a));
        }
    }, hbr = F2(function(n) {
        return v({
            gx: n.gx,
            uj: Ht(bbr),
            uk: "",
            cI: Mx,
            fg: _bn({
                qU: "practitioners",
                Dr: function() {
                    return pbr;
                },
                Dt: $br
            }),
            fv: !1
        }, A2(mbr, n.gx, Rt), h);
    }), gbr = F2(function(n, r) {
        return b(r, Dp);
    }), wbr = F2(function(n, r) {
        return r;
    }), kbr = function(n) {
        return {
            $: 0,
            a: n
        };
    }, xbr = F2(function(n, r) {
        if (n.$) return v(m(r, {
            cI: n.a,
            fv: !1
        }), Dp, h);
        var t = A2(z$n, n.a, r.fg), e = t.a, u = t.b, a = t.c, i = function() {
            if (a.$) return b(r, Dp);
            if (a.a.$) {
                var n = a.a.a;
                return b(m(r, {
                    fv: !0
                }), A2(mbr, r.gx, Ht(n)));
            }
            return b(m(r, {
                uj: a.a.a
            }), Dp);
        }(), c = i.b;
        return v(m(i.a, {
            fg: e
        }), Hu(k([
            A2(jp, kbr, u),
            c
        ])), h);
    }), ybr = {
        $: 1
    }, _br = F4(function(n, r, t, e) {
        var u = function() {
            if (3 === n.$) {
                var e = A2(yu, function(n) {
                    return A2(Xz, h, function(n) {
                        return {
                            $: 0,
                            a: n
                        };
                    }(n));
                }, n.a), u = A2(Ot, lwn(t), r ? k([
                    iwn(!0)
                ]) : h), a = ED(e) ? "No providers found" : "Search to filter...", i = $(A2(yu, function(n) {
                    return A2(Xz, h, n);
                }, k([
                    ybr,
                    bbr
                ])), k([
                    IL
                ]));
                return b(u, $(i, $(e, k([
                    fwn(a)
                ]))));
            }
            return b(k([
                cwn("Loading practitioners..."),
                iwn(!0)
            ]), h);
        }(), a = u.a, i = u.b;
        return A2(Ik, k([
            Nk("mb-4")
        ]), k([
            A2(px, kbr, A4(Bwn, Rk(0), a, i, e))
        ]));
    }), Cbr = function(n) {
        return k([
            A2(Ik, k([
                Nk("section")
            ]), k([
                A2(mx, k([
                    Qk(k([
                        Nk("underline mb-2")
                    ]))
                ]), k([
                    ad("Searchable Select")
                ])),
                A2(Ik, k([
                    Nk("mt-4")
                ]), k([
                    A4(_br, n.cI, n.fv, n.uj, n.fg)
                ]))
            ]))
        ]);
    }, Dbr = {
        zO: hbr,
        Ab: gbr,
        Ct: wbr,
        Dd: function() {
            return yk;
        },
        DB: xbr,
        DH: function(n) {
            return {
                gF: Cbr(n),
                wD: "SearchableSelect"
            };
        }
    }, Abr = function(n) {
        switch(n.$){
            case 0:
                return n.a.sS;
            case 1:
                return "All :)";
            default:
                return "None :(";
        }
    }, qbr = function(n) {
        switch(n.$){
            case 0:
                return Ht(n.a.qU);
            case 1:
                return Ht("");
            default:
                return Rt;
        }
    }, Bbr = F2(function(n, r) {
        var t = A2(bq, n, r.eG), e = t.b, u = t.c;
        return b(m(r, {
            eG: t.a,
            fy: u.$ || u.a.$ ? r.fy : u.a.a
        }), A2(jp, ru, e));
    }), jbr = function(n) {
        return {
            $: 0,
            a: n
        };
    }, Sbr = k([
        {
            $: 1
        },
        {
            $: 2
        },
        jbr({
            qU: "1",
            sS: "Batman"
        }),
        jbr({
            qU: "spidey",
            sS: "Spiderman"
        }),
        jbr({
            qU: "drstrange",
            sS: "Dr Strange"
        }),
        jbr({
            qU: "2",
            sS: "The Flash"
        })
    ]), zbr = function(n) {
        return k([
            A2(Ik, k([
                Nk("section")
            ]), k([
                A2(mx, k([
                    Qk(k([
                        Nk("underline mb-2")
                    ]))
                ]), k([
                    ad("Select")
                ])),
                A2(Ik, k([
                    Nk("mt-4")
                ]), k([
                    A2(px, ru, A4(AU, Rk(0), k([
                        Jz(n.fy),
                        ZL("Pick your favorite hero")
                    ]), A2(yu, function(n) {
                        return A2(Xz, h, n);
                    }, Sbr), n.eG))
                ]))
            ]))
        ]);
    }, Ubr = Msr({
        zO: function() {
            return b({
                eG: id({
                    qU: "heroes",
                    Dr: function() {
                        return Abr;
                    },
                    Dt: qbr
                }),
                fy: Rt
            }, Dp);
        },
        Dd: function() {
            return yk;
        },
        DB: Bbr,
        DH: function(n) {
            return {
                gF: zbr(n),
                wD: "Select"
            };
        }
    }), Ebr = k([
        A2(gan, k([
            A2($2, h, "First Name"),
            A2($2, h, "Last Name"),
            A2($2, h, "Gender")
        ]), k([
            A2(k2, h, k([
                A2(p2, h, k([
                    A2(CW, h, k([
                        ad("Jhon")
                    ]))
                ])),
                A2(p2, h, k([
                    ad("Doe")
                ])),
                A2(p2, h, k([
                    ad("Male")
                ]))
            ])),
            A2(k2, h, k([
                A2(p2, h, k([
                    A2(CW, h, k([
                        ad("Jane")
                    ]))
                ])),
                A2(p2, h, k([
                    ad("Doe")
                ])),
                A2(p2, h, k([
                    ad("Female")
                ]))
            ]))
        ])),
        A3(j2, Ht("Example roster for screen readers"), k([
            A2($2, h, "Role"),
            A2($2, h, "Name")
        ]), k([
            A2(k2, h, k([
                A2(p2, h, k([
                    ad("Admin")
                ])),
                A2(p2, h, k([
                    ad("Alex")
                ]))
            ]))
        ]))
    ]), Pbr = QMn({
        DH: function() {
            return {
                gF: Ebr,
                wD: "Table"
            };
        }
    }), Tbr = F2(function(n, r) {
        var t = A2(pq, n, r.dV), e = t.b;
        return b(m(r, {
            dV: t.a
        }), A2(jp, ru, e));
    }), Fbr = F3(function(n, r, t) {
        var e = r.c0;
        return A2(uc, ad("Tab NotFound"), A2(Cp, function(r) {
            return n(r.a);
        }, Gb(A2(Tc, function(n) {
            return i((0, n.b.dW)(n.a), e);
        }, t))));
    }), Lbr = function(n) {
        var r = n.sS, t = n.l7;
        return A2(Ik, h, k([
            A2(Gk, k([
                Nk("text-current"),
                Nk("mr-2")
            ]), k([
                ad(r)
            ])),
            A2(Gk, k([
                Nk("text-black")
            ]), k([
                ad("(" + ee(t) + " y/o)")
            ]))
        ]));
    }, Mbr = function(n) {
        return A2(TD, n, {
            dW: function(n) {
                return n.qU;
            },
            dY: Lbr
        });
    }, Hbr = k([
        {
            l7: 30,
            qU: "pat-1",
            sS: "Brandon"
        },
        {
            l7: 31,
            qU: "pat-2",
            sS: "Jessy"
        },
        {
            l7: 10,
            qU: "pat-3",
            sS: "Philip"
        },
        {
            l7: 7,
            qU: "pat-4",
            sS: "Sofia"
        }
    ]), Rbr = function(n) {
        var r = n.sS, t = n.l7;
        return A2(Ik, h, k([
            A2(Ik, h, k([
                ad("id: " + n.qU)
            ])),
            A2(Ik, h, k([
                ad("name: " + r)
            ])),
            A2(Ik, h, k([
                ad("age: " + ee(t))
            ]))
        ]));
    }, Obr = Msr({
        zO: function() {
            var n = A2(cy, "tabs", "pat-1");
            return b({
                dV: n.a
            }, A2(jp, ru, n.b));
        },
        Dd: function() {
            return yk;
        },
        DB: Tbr,
        DH: function(n) {
            var r, t, e;
            return {
                gF: (r = n, t = r.dV, e = A2(yu, Mbr, Hbr), k([
                    A2(px, ru, A2(TP, t, e)),
                    A3(Fbr, Rbr, t, e)
                ])),
                wD: "Tabs"
            };
        }
    }), Nbr = k([
        A2(Ik, k([
            Nk("section")
        ]), k([
            A2(mx, k([
                Qk(k([
                    Nk("underline mb-2")
                ]))
            ]), k([
                ad("Tags")
            ])),
            A2(Ik, h, k([
                A2(Utn, h, k([
                    ad("Default Tag")
                ])),
                A2(Utn, k([
                    0
                ]), k([
                    ad("Success Tag")
                ])),
                A2(Utn, k([
                    1
                ]), k([
                    ad("Info Tag")
                ])),
                A2(Utn, k([
                    3
                ]), k([
                    ad("Warning Tag")
                ])),
                A2(Utn, k([
                    2
                ]), k([
                    ad("Danger Tag")
                ]))
            ]))
        ]))
    ]), Ibr = QMn({
        DH: function() {
            return {
                gF: Nbr,
                wD: "Tag"
            };
        }
    }), Vbr = F2(function(n, r) {
        return m(r, {
            jz: n
        });
    }), Wbr = {
        $: 3
    }, Zbr = function(n) {
        return function(n) {
            return {
                $: 2,
                a: n
            };
        }(n);
    }, Xbr = function(n) {
        return function(n) {
            return {
                $: 0,
                a: n
            };
        }(n);
    }, Gbr = function(n) {
        return function(n) {
            return {
                $: 1,
                a: n
            };
        }(n);
    }, Jbr = function(n) {
        switch(n.$){
            case 1:
                return k([
                    cU(n.a)
                ]);
            case 0:
                return k([
                    RU(n.a)
                ]);
            case 2:
                return k([
                    FU(n.a)
                ]);
            default:
                return h;
        }
    }, Ybr = function(n) {
        return Gi(A2(yu, Jbr, n));
    }, Qbr = function(n) {
        switch(n.$){
            case 1:
            case 0:
                return h;
            case 2:
                return k([
                    rz(k([
                        b("toggle--checked", n.a)
                    ]))
                ]);
            case 4:
                var r = n.a;
                return A2(yu, Zk(hu), r);
            default:
                return k([
                    Nk("toggle--card")
                ]);
        }
    }, Kbr = F2(function(n, r) {
        return A2(iU, A2(Ot, Nk("toggle"), function(n) {
            return Gi(A2(yu, Qbr, n));
        }(n)), k([
            A2(fU, A2(Ot, dz("radio"), A2(Ot, Nk("toggle__input"), Ybr(n))), h),
            A2(Ik, k([
                Nk("toggle__text")
            ]), A2(yu, px(hu), r))
        ]));
    }), nvr = plr({
        zO: function() {
            return {
                jz: "yes"
            };
        },
        DB: Vbr,
        DH: function(n) {
            var r, t;
            return {
                gF: (r = n, t = r.jz, k([
                    A2(Ik, k([
                        Nk("section")
                    ]), k([
                        A2(mx, k([
                            Qk(k([
                                Nk("underline mb-2")
                            ]))
                        ]), k([
                            ad("Yes No Toggle")
                        ])),
                        A2(Ik, k([
                            Nk("mb-4")
                        ]), k([
                            A2(Kbr, k([
                                Wbr,
                                Gbr("yes"),
                                Zbr("yes" === t),
                                Xbr(ru)
                            ]), k([
                                ad("Yes")
                            ])),
                            A2(Kbr, k([
                                Wbr,
                                Gbr("no"),
                                Zbr("no" === t),
                                Xbr(ru)
                            ]), k([
                                ad("No")
                            ]))
                        ]))
                    ]))
                ])),
                wD: "Toggle"
            };
        }
    }), rvr = A2(lV, h, k([
        A2(iV, k([
            UZ(3)
        ]), k([
            A2(AW, k([
                bW("First Name")
            ]), k([
                A2(vgn, "Showing over disabled input!", yP(k([
                    bP("Hover me!"),
                    sP(!0)
                ])))
            ]))
        ]))
    ])), tvr = A2(lV, h, k([
        A2(iV, k([
            UZ(3)
        ]), k([
            A2(AW, k([
                bW("First Name")
            ]), k([
                A2(vgn, "Showing over input!", yP(k([
                    bP("Hover me!")
                ])))
            ]))
        ]))
    ])), evr = A2(vgn, "Showing over text!", A2(Gk, h, k([
        ad("Hover me!")
    ]))), uvr = A2(Ik, k([
        Nk("flex flex-col space-y-6")
    ]), k([
        evr,
        tvr,
        rvr
    ])), avr = QMn({
        DH: function() {
            return {
                gF: k([
                    uvr
                ]),
                wD: "StyleGuide.Tooltip"
            };
        }
    }), ivr = QMn({
        DH: function() {
            return {
                gF: k([
                    ad("Homepage")
                ]),
                wD: "Homepage"
            };
        }
    }), cvr = k([
        A2(Ik, k([
            Nk("section")
        ]), k([
            A2(mx, k([
                Qk(k([
                    Nk("underline mb-2")
                ]))
            ]), k([
                ad("Titles")
            ])),
            A2(Ik, h, k([
                A2(XT, h, k([
                    ad("Huge Title")
                ])),
                A2(mx, h, k([
                    ad("Big Title")
                ])),
                A2(UV, h, k([
                    ad("Base Title")
                ]))
            ]))
        ])),
        A2(Ik, k([
            Nk("section")
        ]), k([
            A2(mx, k([
                Qk(k([
                    Nk("underline mb-2")
                ]))
            ]), k([
                ad("Type")
            ])),
            A2(Ik, k([
                Nk("mt-4")
            ]), k([
                A2(hx, h, k([
                    ad("Normal text")
                ])),
                A2(hx, k([
                    BB
                ]), k([
                    ad("Support text")
                ])),
                A2(hx, k([
                    E1
                ]), k([
                    ad("Danger text")
                ])),
                A2(hx, k([
                    gOn
                ]), k([
                    ad("Success text")
                ])),
                A2(hx, k([
                    Mon
                ]), k([
                    ad("Warning text")
                ])),
                A2(hx, k([
                    W1
                ]), k([
                    ad("Light gray text")
                ])),
                A2(hx, k([
                    ZT
                ]), k([
                    ad("Huge text")
                ])),
                A2(hx, k([
                    rx
                ]), k([
                    ad("Big text")
                ])),
                A2(hx, k([
                    PL
                ]), k([
                    ad("Medium text")
                ])),
                A2(hx, k([
                    EB
                ]), k([
                    ad("Small text")
                ])),
                A2(hx, k([
                    Iz
                ]), k([
                    ad("Extra small text")
                ]))
            ]))
        ]))
    ]), ovr = QMn({
        DH: function() {
            return {
                gF: cvr,
                wD: "Typography"
            };
        }
    }), fvr = function(n) {
        return {
            $: 0,
            a: n
        };
    }, svr = F3(function(n, r, t) {
        return b({
            kj: r.kj,
            dw: n,
            fF: Mx,
            fK: Rt,
            w_: t
        }, A3(ebn, r.gx, $k(n), fvr));
    }), lvr = F2(function(n, r) {
        return b(r, Dp);
    }), dvr = F2(function(n, r) {
        return r;
    }), bvr = function(n) {
        return {
            $: 1,
            a: n
        };
    }, vvr = F2(function(n, r) {
        if (n.$) {
            var t = n.a, e = r.fK;
            if (e.$) return v(r, Dp, h);
            var u = A2(Nfr, t, e.a), a = u.b;
            return v(m(r, {
                fK: Ht(u.a)
            }), A2(jp, bvr, a), h);
        }
        var i, c = n.a, o = m(r, {
            fF: c
        });
        switch(c.$){
            case 2:
                return v(o, Dp, k([
                    tA(c.a)
                ]));
            case 3:
                return v(m(o, {
                    fK: Ht(A2(cfr, r.dw, (i = c.a, {
                        kX: i.kX,
                        kY: i.kY,
                        kZ: i.kZ,
                        li: i.li
                    })))
                }), Dp, h);
            default:
                return v(o, Dp, h);
        }
    }), mvr = F2(function(n, r) {
        return k([
            A2(Ik, k([
                Nk("signup__body--contents")
            ]), k([
                A2(px, bvr, A3(esr, n, r, Rt))
            ]))
        ]);
    }), pvr = F2(function(n, r) {
        return {
            gF: function() {
                var t = b(r.fF, r.fK);
                n: for(;;)switch(t.a.$){
                    case 3:
                        if (t.b.$) break n;
                        return A2(mvr, n, t.b.a);
                    case 2:
                        return k([
                            l4n(r.dw)
                        ]);
                    default:
                        break n;
                }
                return Yk;
            }(),
            wD: n(VZn)
        };
    }), $vr = kx({
        zO: svr,
        Ab: lvr,
        Ct: dvr,
        Dd: function() {
            return yk;
        },
        DB: vvr,
        DH: pvr
    }), hvr = Jn("fullStoryPortStopCapturing", function() {
        return bk;
    }), gvr = hvr(0), wvr = gvr, kvr = F2(function() {
        return v({}, wvr, h);
    }), xvr = F2(function(n, r) {
        return b(r, Dp);
    }), yvr = F2(function(n, r) {
        return r;
    }), _vr = F2(function(n, r) {
        return v(r, Dp, h);
    }), Cvr = {
        zO: kvr,
        Ab: xvr,
        Ct: yvr,
        Dd: function() {
            return yk;
        },
        DB: _vr,
        DH: function() {
            return {
                gF: k([
                    ad("Homepage")
                ]),
                wD: "Homepage"
            };
        }
    }, Dvr = function(n) {
        return {
            $: 0,
            a: n
        };
    }, Avr = {
        pt: "",
        eA: 1,
        qb: "",
        rt: ""
    }, qvr = function(n) {
        switch(n){
            case 0:
                return "firstName";
            case 1:
                return "lastName";
            case 2:
                return "email";
            default:
                return "provider";
        }
    }, Bvr = F3(function(n, r, t) {
        var e = A2(Zu, "practitioner", t.iu);
        return b({
            gx: r.gx,
            kj: r.kj,
            kk: AO(Avr),
            t2: zbn("waitlist-phone"),
            dw: n,
            a4: !i(e, Rt),
            cI: Mx,
            b4: !1,
            cP: e,
            wn: Rt,
            jr: !1,
            dS: !1,
            x: A2(jO, k([
                0,
                1,
                2,
                3
            ]), qvr)
        }, A4(uqn, r.gx, $k(n), function(n) {
            return m(n, {
                hP: 100,
                lu: Ht(!0)
            });
        }, Dvr));
    }), jvr = F2(function(n, r) {
        return b(r, Dp);
    }), Svr = F2(function(n, r) {
        return r;
    }), zvr = function(n) {
        return {
            $: 4,
            a: n
        };
    }, Uvr = F2(function(n, r) {
        switch(n.$){
            case 0:
                return m(r, {
                    qb: n.a
                });
            case 1:
                return m(r, {
                    rt: n.a
                });
            case 2:
                return m(r, {
                    pt: n.a
                });
            default:
                return m(r, {
                    eA: A2(uc, 1, lu(n.a))
                });
        }
    }), Evr = ZN(k([
        A2(u5n, function(n) {
            return n.qb;
        }, b(0, JN(YN("First Name")))),
        A2(u5n, function(n) {
            return n.rt;
        }, b(1, JN(YN("Last Name"))))
    ])), Pvr = function(n) {
        return {
            $: 6,
            a: n
        };
    }, Tvr = F2(function(n, r) {
        var t = jN(n.kk), e = vk(k([
            b("waitlist_entry", vk(Gi(k([
                k([
                    b("practitioner_id", mk(r)),
                    b("first_name", mk(t.qb)),
                    b("last_name", mk(t.rt)),
                    b("enroll_count", hq(t.eA))
                ]),
                fu(t.pt) ? h : k([
                    b("email", mk(t.pt))
                ]),
                k([
                    b("phone", _jn(n.t2))
                ])
            ]))))
        ]));
        return A4(vN, z9(n.gx), v$, Pvr, A2(xq, e, bC(A2($y, k([
            "waitlist_entries"
        ]), gy($k(n.dw))))));
    }), Fvr = F2(function(n, r) {
        switch(n.$){
            case 0:
                var t = n.a, e = F2(function(n, r) {
                    return A2(sA, function(r) {
                        return i(Hjn(r), n);
                    }, r);
                }), u = function() {
                    if (r.a4) {
                        var n = b(r.cP, t);
                        if (n.a.$ || 3 !== n.b.$) return b(r.cP, !1);
                        var u = n.a.a;
                        return A2(e, u, n.b.a) ? b(Ht(u), !1) : b(Rt, !0);
                    }
                    return b(3 === t.$ && t.a.b && !t.a.b.b ? Ht(Hjn(t.a.a)) : r.cP, !1);
                }();
                return v(m(r, {
                    a4: r.a4 && !u.b,
                    cI: t,
                    cP: u.a
                }), Dp, h);
            case 1:
                var a = n.a;
                return v(m(r, {
                    b4: !1,
                    cP: fu(a) ? Rt : Ht(a)
                }), Dp, h);
            case 2:
                return v(m(r, {
                    kk: A3(WI, Uvr, c = n.a, r.kk)
                }), Dp, h);
            case 3:
                var c, o = function(n) {
                    switch(n.$){
                        case 0:
                            return 0;
                        case 1:
                            return 1;
                        default:
                            return 2;
                    }
                }(c = n.a), f = A3(_I, !0, o, r.x), s = (C = A2(wI, Evr, A3(WI, Uvr, c, r.kk))).$ ? C.a : C.a.a;
                return v(m(r, {
                    kk: s,
                    x: f
                }), Dp, h);
            case 4:
                var l = A2(R$n, n.a, r.t2), d = l.b;
                return v(m(r, {
                    t2: l.a
                }), A2(jp, zvr, d), h);
            case 5:
                var p = A2(ohn, !0, r.t2), $ = A2(wI, Evr, r.kk), g = uhn(p), w = i(r.cP, Rt) && !r.a4, k = P3n(r.x), x = $.$ ? $.a : $.a.a;
                if (!$.$ && !w && g) {
                    var y = r.cP;
                    if (y.$) return v(m(r, {
                        kk: x,
                        t2: p,
                        b4: !0,
                        x: k
                    }), Dp, h);
                    var _ = y.a;
                    return v(m(r, {
                        kk: x,
                        t2: p,
                        b4: !1,
                        wn: Rt,
                        dS: !0,
                        x: k
                    }), A2(Tvr, r, _), h);
                }
                return v(m(r, {
                    kk: x,
                    t2: p,
                    b4: w,
                    x: k
                }), Dp, h);
            default:
                return v(m(r, 3 === (t = n.a).$ ? {
                    jr: !0,
                    dS: !1
                } : {
                    wn: Ht(A2(Rk, r.kj, BLn)),
                    dS: !1
                }), Dp, h);
        }
        var C;
    }), Lvr = function(n) {
        return {
            $: 2,
            a: n
        };
    }, Mvr = function(n) {
        return {
            $: 3,
            a: n
        };
    }, Hvr = function(n) {
        return {
            $: 3,
            a: n
        };
    }, Rvr = function(n) {
        return {
            $: 0,
            a: n
        };
    }, Ovr = function(n) {
        return {
            $: 2,
            a: n
        };
    }, Nvr = function(n) {
        return {
            $: 1,
            a: n
        };
    }, Ivr = function(n) {
        return {
            $: 1,
            a: n
        };
    }, Vvr = {
        $: 5
    }, Wvr = ir("select"), Zvr = F3(function(n, r, t) {
        return A2(ZI, t, r) && A2(kW, t, n);
    }), Xvr = function(n) {
        return {
            $: 1,
            a: n
        };
    }, Gvr = F3(function(n, r, t) {
        return A2(ZI, t, r) ? A2(iW, t, n) : h;
    }), Jvr = F2(function(n, r) {
        var t, e = 3 === (t = r.cI).$ ? t.a : h, u = jN(r.kk);
        return A2(Ik, h, k([
            function() {
                var n = r.wn;
                if (n.$) return Sq;
                var t = n.a;
                return A2(Ik, k([
                    Nk("message-box message-box--error mb-4")
                ]), k([
                    ad(t)
                ]));
            }(),
            r.a4 || ED(e) ? Sq : A2(Ik, h, k([
                A2(AW, k([
                    bW(n(ALn)),
                    hW(!0)
                ]), k([
                    A2(Wvr, k([
                        Nk(r.b4 ? "input input--invalid" : "input"),
                        RU(Ivr)
                    ]), A2(Ot, A2(FE, k([
                        cU("")
                    ]), k([
                        ad(n(qLn))
                    ])), A2(yu, function(n) {
                        return A2(FE, k([
                            cU(Hjn(n)),
                            GE(i(r.cP, Ht(Hjn(n))))
                        ]), k([
                            ad(hH(n))
                        ]));
                    }, e)))
                ])),
                r.b4 ? A2(OW, n, k([
                    JN(Hzn("Provider"))
                ])) : Sq
            ])),
            A2(AW, k([
                bW(n(pLn)),
                hW(!0)
            ]), k([
                yP(k([
                    bP(u.qb),
                    xZ(A2(sc, Ovr, Rvr)),
                    lZ(Hvr(Rvr(u.qb))),
                    oZ(A3(Zvr, r.kk, r.x, 0)),
                    lP(n($Ln))
                ])),
                A2(OW, n, A3(Gvr, r.kk, r.x, 0))
            ])),
            A2(AW, k([
                bW(n(yLn)),
                hW(!0)
            ]), k([
                yP(k([
                    bP(u.rt),
                    xZ(A2(sc, Ovr, Nvr)),
                    lZ(Hvr(Nvr(u.rt))),
                    oZ(A3(Zvr, r.kk, r.x, 1)),
                    lP(n(_Ln))
                ])),
                A2(OW, n, A3(Gvr, r.kk, r.x, 1))
            ])),
            A2(AW, k([
                bW(n(bLn))
            ]), k([
                yP(k([
                    bP(u.pt),
                    xZ(A2(sc, Ovr, Lvr)),
                    lZ(Hvr(Lvr(u.pt))),
                    lP(n(vLn))
                ]))
            ])),
            A2(AW, k([
                bW(n(DLn))
            ]), k([
                A2(px, zvr, A3(okn, n, k([
                    Xvr(!0)
                ]), r.t2))
            ])),
            A2(AW, k([
                bW(n(mLn))
            ]), k([
                yP(k([
                    bP(ee(u.eA)),
                    cZ(0),
                    xZ(A2(sc, Ovr, Mvr))
                ]))
            ])),
            A2(Ik, k([
                Nk("mt-6 flex justify-center")
            ]), k([
                A2(fz, k([
                    nz,
                    Don(r.dS),
                    QS(Vvr)
                ]), k([
                    ad(n(wLn))
                ]))
            ]))
        ]));
    }), Yvr = function(n) {
        var r = function() {
            var r = b(n.cP, n.cI);
            if (r.a.$ || 3 !== r.b.$) return hk(n.dw);
            var t = r.a.a, e = r.b.a;
            return A2(uc, hk(n.dw), A2(Cp, hH, Gb(A2(Tc, function(n) {
                return i(Hjn(n), t);
            }, e))));
        }();
        return A2(Ik, k([
            Nk("text-center py-8")
        ]), k([
            A2(mx, k([
                LS(q3)
            ]), k([
                ad(A2(Rk, n.kj, SLn))
            ])),
            A2(hx, h, k([
                ad(A2(Rk, n.kj, jLn) + " " + r + ".")
            ]))
        ]));
    }, Qvr = F2(function(n, r) {
        return {
            gF: k([
                A2(Ik, k([
                    Nk("signup__body bg-white")
                ]), k([
                    A2(Ik, k([
                        Nk("signup__page-border")
                    ]), h),
                    A2(Ik, k([
                        Nk("signup__page-center")
                    ]), k([
                        A2(Ik, k([
                            Nk("flex-col w-full")
                        ]), k([
                            A2(XT, k([
                                jX,
                                LS(q3),
                                A2(_1n, 1, p1n),
                                bz(gz),
                                A2(m1n, 1, wF)
                            ]), k([
                                ad(n(CLn) + " \u2014 " + hk(r.dw))
                            ])),
                            r.jr ? Yvr(r) : A2(Jvr, n, r)
                        ]))
                    ])),
                    A2(Ik, k([
                        Nk("signup__page-border")
                    ]), h)
                ]))
            ]),
            wD: n(CLn) + " \u2014 " + hk(r.dw)
        };
    }), Kvr = kx({
        zO: Bvr,
        Ab: jvr,
        Ct: Svr,
        Dd: function() {
            return yk;
        },
        DB: Fvr,
        DH: Qvr
    }), nmr = F2(function(n, r) {
        return {
            gF: A2(yu, px(n), r.gF),
            wD: r.wD
        };
    }), rmr = F3(function(n, r, t) {
        var e = t.b, u = t.c;
        return v(n(t.a), r(e), u);
    }), tmr = F3(function(n, r, t) {
        var e = F2(function(e, u) {
            return A3(rmr, n, jp(r), A2(t.DB, e, u));
        }), u = F2(function(e, u) {
            return A3(Pp, n, jp(r), A2(t.Ab, u, e));
        }), a = F2(function(e, u) {
            return A3(rmr, n, jp(r), A2(t.zO, u, A2(RX, e, u.w_)));
        });
        return {
            a: function(n) {
                return {
                    Ab: function() {
                        return u(n);
                    },
                    Ct: function() {
                        return t.Ct(n);
                    },
                    Dd: function() {
                        return A2(xD, r, t.Dd(n));
                    },
                    DH: function() {
                        return A2(nmr, r, t.DH(n));
                    }
                };
            },
            zO: a,
            DB: e
        };
    }), emr = {
        fW: A3(tmr, M$, H$, MP),
        fX: A3(tmr, N$, I$, hT),
        fY: A3(tmr, R$, O$, MF),
        fZ: A3(tmr, V$, W$, WF),
        f_: A3(tmr, Y$, Q$, bM),
        f$: A3(tmr, Z$, X$, aO),
        f0: A3(tmr, G$, J$, wX),
        f1: A3(tmr, K$, nh, UX),
        f2: A3(tmr, rh, th, R3),
        f3: A3(tmr, eh, uh, Z4),
        f4: A3(tmr, ah, ih, u8),
        f5: A3(tmr, fh, sh, a5),
        f6: A3(tmr, ch, oh, xrn),
        f7: A3(tmr, mh, ph, Wtn),
        f8: A3(tmr, lh, dh, $in),
        f9: A3(tmr, bh, vh, Pfn),
        ga: A3(tmr, yh, _h, Asn),
        gb: A3(tmr, kh, xh, Vdn),
        gc: A3(tmr, $h, hh, ykn),
        gd: A3(tmr, gh, wh, Exn),
        ge: A3(tmr, Sh, zh, Cyn),
        gf: A3(tmr, Ah, qh, VCn),
        gg: A3(tmr, Ch, Dh, lMn),
        gh: A3(tmr, Bh, jh, TMn),
        gi: A3(tmr, Ph, Th, NMn),
        gj: A3(tmr, Uh, Eh, JMn),
        gk: A3(tmr, Fh, Lh, KMn),
        gl: A3(tmr, Rh, Oh, kHn),
        gm: A3(tmr, Mh, Hh, jRn),
        gn: A3(tmr, Zh, Xh, lOn),
        go: A3(tmr, Vh, Wh, BOn),
        gp: A3(tmr, Nh, Ih, mNn),
        gq: A3(tmr, Gh, Jh, iIn),
        gr: A3(tmr, Yh, Qh, lVn),
        gs: A3(tmr, Kh, ng, gVn),
        gt: A3(tmr, rg, tg, xVn),
        gu: A3(tmr, eg, ug, FVn),
        gB: A3(tmr, ag, ig, VVn),
        gD: A3(tmr, cg, og, WVn),
        gG: A3(tmr, fg, sg, bWn),
        gH: A3(tmr, lg, dg, SWn),
        gI: A3(tmr, bg, vg, LWn),
        gJ: A3(tmr, mg, pg, QWn),
        gR: A3(tmr, $g, hg, _Zn),
        gS: A3(tmr, gg, wg, SZn),
        hg: A3(tmr, kg, xg, ZZn),
        hh: A3(tmr, yg, _g, FZn),
        hS: A3(tmr, Cg, Dg, eGn),
        hT: A3(tmr, Ag, qg, FGn),
        hU: A3(tmr, Bg, jg, OJn),
        h2: A3(tmr, Sg, zg, NJn),
        e9: A3(tmr, Ug, Eg, IJn),
        iQ: A3(tmr, Pg, Tg, N1n),
        iR: A3(tmr, Fg, Lg, b4n),
        iS: A3(tmr, Mg, Hg, L7n),
        iT: A3(tmr, Rg, Og, str),
        iU: A3(tmr, Ng, Ig, Her),
        iV: A3(tmr, Vg, Wg, bir),
        iW: A3(tmr, Zg, Xg, Bcr),
        iX: A3(tmr, Gg, Jg, afr),
        iY: A3(tmr, Yg, Qg, xsr),
        iZ: A3(tmr, Kg, nw, Bsr),
        i_: A3(tmr, rw, tw, Tsr),
        i1: A3(tmr, ew, uw, Lsr),
        i2: A3(tmr, aw, iw, Rsr),
        i3: A3(tmr, cw, ow, Xsr),
        i4: A3(tmr, fw, sw, mlr),
        i5: A3(tmr, lw, dw, hlr),
        i6: A3(tmr, bw, vw, ylr),
        i7: A3(tmr, mw, pw, Slr),
        i8: A3(tmr, $w, hw, rdr),
        i9: A3(tmr, gw, ww, $dr),
        ja: A3(tmr, kw, xw, gdr),
        jb: A3(tmr, yw, _w, _dr),
        jc: A3(tmr, Cw, Dw, Sdr),
        jd: A3(tmr, Aw, qw, Ndr),
        je: A3(tmr, Bw, jw, tbr),
        jf: A3(tmr, Sw, zw, ubr),
        jg: A3(tmr, Uw, Ew, dbr),
        jh: A3(tmr, Pw, Tw, Dbr),
        ji: A3(tmr, Fw, Lw, Ubr),
        jj: A3(tmr, Mw, Hw, Pbr),
        jk: A3(tmr, Rw, Ow, Obr),
        jl: A3(tmr, Nw, Iw, Ibr),
        jm: A3(tmr, Vw, Ww, nvr),
        jn: A3(tmr, Zw, Xw, avr),
        jo: A3(tmr, Gw, Jw, ivr),
        jp: A3(tmr, Yw, Qw, ovr),
        jw: A3(tmr, Kw, nk, $vr),
        lp: A3(tmr, rk, tk, Cvr),
        q: A3(tmr, ek, uk, Kvr)
    }, umr = function(n) {
        switch(n.$){
            case 0:
                return emr.lp.zO(0);
            case 1:
                return emr.hg.zO(0);
            case 2:
                return emr.h2.zO(0);
            case 3:
                return emr.e9.zO(0);
            case 4:
                return emr.jw.zO(0);
            case 5:
                return emr.q.zO(0);
            case 6:
                return emr.gu.zO(0);
            case 7:
                return emr.gJ.zO(0);
            case 8:
                return emr.gS.zO(0);
            case 9:
                return emr.hh.zO(0);
            case 10:
                return emr.i_.zO(0);
            case 11:
                return emr.jo.zO(0);
            case 12:
                return emr.fW.zO(0);
            case 13:
                return emr.f_.zO(0);
            case 14:
                return emr.f1.zO(0);
            case 15:
                return emr.f2.zO(0);
            case 16:
                return emr.f3.zO(0);
            case 17:
                return emr.f4.zO(0);
            case 18:
                return emr.f5.zO(0);
            case 19:
                return emr.f7.zO(0);
            case 20:
                return emr.ga.zO(0);
            case 21:
                return emr.ge.zO(0);
            case 22:
                return emr.gi.zO(0);
            case 23:
                return emr.gk.zO(0);
            case 24:
                return emr.gn.zO(0);
            case 25:
                return emr.gr.zO(0);
            case 26:
                return emr.gs.zO(0);
            case 27:
                return emr.gI.zO(0);
            case 28:
                return emr.hS.zO(0);
            case 29:
                return emr.hT.zO(0);
            case 30:
                return emr.hU.zO(0);
            case 31:
                return emr.i1.zO(0);
            case 32:
                return emr.i2.zO(0);
            case 33:
                return emr.i3.zO(0);
            case 34:
                return emr.i4.zO(0);
            case 35:
                return emr.i5.zO(0);
            case 36:
                return emr.i6.zO(0);
            case 37:
                return emr.i7.zO(0);
            case 38:
                return emr.i8.zO(0);
            case 39:
                return emr.i9.zO(0);
            case 40:
                return emr.ja.zO(0);
            case 41:
                return emr.jb.zO(0);
            case 42:
                return emr.jc.zO(0);
            case 43:
                return emr.jd.zO(0);
            case 44:
                return emr.je.zO(0);
            case 45:
                return emr.jf.zO(0);
            case 46:
                return emr.jg.zO(0);
            case 47:
                return emr.jh.zO(0);
            case 48:
                return emr.ji.zO(0);
            case 49:
                return emr.jj.zO(0);
            case 50:
                return emr.jk.zO(0);
            case 51:
                return emr.jl.zO(0);
            case 52:
                return emr.jm.zO(0);
            case 53:
                return emr.jn.zO(0);
            case 54:
                return emr.jp.zO(0);
            case 55:
                return emr.gt.zO(n.a);
            case 56:
                return emr.gD.zO(n.a);
            case 57:
                return emr.gR.zO(n.a);
            case 58:
                return emr.iZ.zO(n.a);
            case 59:
                return emr.gj.zO(0);
            case 60:
                return emr.gB.zO(n.a);
            case 61:
                return emr.iQ.zO(n.a);
            case 62:
                return emr.iR.zO(n.a);
            case 63:
                return emr.iS.zO(n.a);
            case 64:
                return emr.iT.zO(n.a);
            case 65:
                return emr.iU.zO(n.a);
            case 66:
                return emr.iV.zO(n.a);
            case 67:
                return emr.iW.zO(n.a);
            case 68:
                return emr.iX.zO(n.a);
            case 69:
                return emr.iY.zO(n.a);
            case 70:
                return emr.f6.zO(n.a);
            case 71:
                return emr.f8.zO(n.a);
            case 72:
                return emr.gb.zO(n.a);
            case 73:
                return emr.gf.zO(n.a);
            case 74:
                return emr.gl.zO(n.a);
            case 75:
                return emr.go.zO(n.a);
            case 76:
                return emr.fX.zO(n.a);
            case 77:
                return emr.fY.zO(n.a);
            case 78:
                return emr.fZ.zO(n.a);
            case 79:
                return emr.f9.zO(n.a);
            case 80:
                return emr.gc.zO(n.a);
            case 81:
                return emr.gd.zO(n.a);
            case 82:
                return emr.gg.zO(n.a);
            case 83:
                return emr.gh.zO(n.a);
            case 84:
                return emr.gm.zO(n.a);
            case 85:
                return emr.gp.zO(n.a);
            case 86:
                return emr.gq.zO(n.a);
            case 87:
                return emr.gG.zO(n.a);
            case 88:
                return emr.gH.zO(n.a);
            case 89:
                return emr.f$.zO(n.a);
            default:
                return emr.f0.zO(n.a);
        }
    }, amr = function(n) {
        return A2(JV, "/account/messaging", n) || A2(JV, "/account/chat", n);
    }, imr = function(n) {
        return A2(JV, "/account", n);
    }, cmr = function(n) {
        return A2(JV, "/login", n);
    }, omr = function(n) {
        return A2(JV, "/appointments", n);
    }, fmr = function(n) {
        return A2(JV, "/signup", n) || A2(JV, "/enroll", n) || A2(JV, "/checkout", n);
    }, smr = function(n) {
        return function(n) {
            return A2(JV, "/style-guide", n);
        }(n) ? 1 : fmr(n) ? 0 : cmr(n) ? 2 : YV(n) || function(n) {
            return A2(JV, "/account/booking", n);
        }(n) ? 4 : omr(n) || function(n) {
            return A2(JV, "/account/appointments", n);
        }(n) ? 5 : amr(n) ? 6 : imr(n) ? 3 : 7;
    }, lmr = function(n) {
        return smr(n);
    }, dmr = Jn("sentryPortCaptureErrorMessage", function(n) {
        var r = n.b;
        return A2(wq, ru, k([
            mk(n.a),
            r
        ]));
    }), bmr = F2(function(n, r) {
        return dmr(b(n, A3(v7, ru, ru, r)));
    }), vmr = A6(eu, 0, "localhost", Rt, "", Rt, Rt), mmr = function(n) {
        var r = $u(n);
        return r.$ ? b(vmr, A2(bmr, "Url.fromString Failed: " + n, oa)) : b(r.a, Dp);
    }, pmr = function(n) {
        return {
            $: 0,
            a: n
        };
    }, $mr = {
        $: 29
    }, hmr = function(n) {
        return {
            $: 18,
            a: n
        };
    }, gmr = function(n) {
        return {
            $: 22,
            a: n
        };
    }, wmr = function(n) {
        return {
            $: 24,
            a: n
        };
    }, kmr = function(n) {
        return {
            $: 4,
            a: n
        };
    }, xmr = function(n) {
        return {
            $: 5,
            a: n
        };
    }, ymr = function(n) {
        return {
            $: 8,
            a: n
        };
    }, _mr = {
        $: 23
    }, Cmr = function(n) {
        return {
            $: 28,
            a: n
        };
    }, Dmr = Kn("accountTokenRemovedPort", Dy(0)), Amr = Dmr, qmr = Kn("idleUser", xy), Bmr = Kn("onBeforeUnload", xy), jmr = function(n) {
        switch(n.$){
            case 0:
                return emr.lp.a(n.a);
            case 1:
                return emr.hg.a(n.a);
            case 2:
                return emr.h2.a(n.a);
            case 3:
                return emr.e9.a(n.a);
            case 4:
                return emr.jw.a(n.a);
            case 5:
                return emr.q.a(n.a);
            case 6:
                return emr.gu.a(n.a);
            case 7:
                return emr.gJ.a(n.a);
            case 8:
                return emr.gS.a(n.a);
            case 9:
                return emr.hh.a(n.a);
            case 10:
                return emr.i_.a(n.a);
            case 11:
                return emr.jo.a(n.a);
            case 12:
                return emr.fW.a(n.a);
            case 13:
                return emr.f_.a(n.a);
            case 14:
                return emr.f1.a(n.a);
            case 15:
                return emr.f2.a(n.a);
            case 16:
                return emr.f3.a(n.a);
            case 17:
                return emr.f4.a(n.a);
            case 18:
                return emr.f5.a(n.a);
            case 19:
                return emr.f7.a(n.a);
            case 20:
                return emr.ga.a(n.a);
            case 21:
                return emr.ge.a(n.a);
            case 22:
                return emr.gi.a(n.a);
            case 23:
                return emr.gk.a(n.a);
            case 24:
                return emr.gn.a(n.a);
            case 25:
                return emr.gr.a(n.a);
            case 26:
                return emr.gs.a(n.a);
            case 27:
                return emr.gI.a(n.a);
            case 28:
                return emr.hS.a(n.a);
            case 29:
                return emr.hT.a(n.a);
            case 30:
                return emr.hU.a(n.a);
            case 31:
                return emr.i1.a(n.a);
            case 32:
                return emr.i2.a(n.a);
            case 33:
                return emr.i3.a(n.a);
            case 34:
                return emr.i4.a(n.a);
            case 35:
                return emr.i5.a(n.a);
            case 36:
                return emr.i6.a(n.a);
            case 37:
                return emr.i7.a(n.a);
            case 38:
                return emr.i8.a(n.a);
            case 39:
                return emr.i9.a(n.a);
            case 40:
                return emr.ja.a(n.a);
            case 41:
                return emr.jb.a(n.a);
            case 42:
                return emr.jc.a(n.a);
            case 43:
                return emr.jd.a(n.a);
            case 44:
                return emr.je.a(n.a);
            case 45:
                return emr.jf.a(n.a);
            case 46:
                return emr.jg.a(n.a);
            case 47:
                return emr.jh.a(n.a);
            case 48:
                return emr.ji.a(n.a);
            case 49:
                return emr.jj.a(n.a);
            case 50:
                return emr.jk.a(n.a);
            case 51:
                return emr.jl.a(n.a);
            case 52:
                return emr.jm.a(n.a);
            case 53:
                return emr.jn.a(n.a);
            case 54:
                return emr.jp.a(n.a);
            case 55:
                return emr.gt.a(n.a);
            case 56:
                return emr.gD.a(n.a);
            case 57:
                return emr.gR.a(n.a);
            case 58:
                return emr.iZ.a(n.a);
            case 59:
                return emr.gj.a(n.a);
            case 60:
                return emr.gB.a(n.a);
            case 61:
                return emr.iQ.a(n.a);
            case 62:
                return emr.iR.a(n.a);
            case 63:
                return emr.iS.a(n.a);
            case 64:
                return emr.iT.a(n.a);
            case 65:
                return emr.iU.a(n.a);
            case 66:
                return emr.iV.a(n.a);
            case 67:
                return emr.iW.a(n.a);
            case 68:
                return emr.iX.a(n.a);
            case 69:
                return emr.iY.a(n.a);
            case 70:
                return emr.f6.a(n.a);
            case 71:
                return emr.f8.a(n.a);
            case 72:
                return emr.gb.a(n.a);
            case 73:
                return emr.gf.a(n.a);
            case 74:
                return emr.gl.a(n.a);
            case 75:
                return emr.go.a(n.a);
            case 76:
                return emr.fX.a(n.a);
            case 77:
                return emr.fY.a(n.a);
            case 78:
                return emr.fZ.a(n.a);
            case 79:
                return emr.f9.a(n.a);
            case 80:
                return emr.gc.a(n.a);
            case 81:
                return emr.gd.a(n.a);
            case 82:
                return emr.gg.a(n.a);
            case 83:
                return emr.gh.a(n.a);
            case 84:
                return emr.gm.a(n.a);
            case 85:
                return emr.gp.a(n.a);
            case 86:
                return emr.gq.a(n.a);
            case 87:
                return emr.gG.a(n.a);
            case 88:
                return emr.gH.a(n.a);
            case 89:
                return emr.f$.a(n.a);
            default:
                return emr.f0.a(n.a);
        }
    }, Smr = function(n) {
        return jmr(n).Dd(0);
    }, zmr = function(n) {
        return A2(Ik, h, n.gF);
    }, Umr = {
        $: 1
    }, Emr = function(n) {
        return jmr(n).Ab(0);
    }, Pmr = function(n) {
        return jmr(n).Ct(0);
    }, Tmr = rt, Fmr = function(n) {
        return {
            $: 1,
            a: n
        };
    }, Lmr = {
        $: 1
    }, Mmr = function(n) {
        return {
            $: 21,
            a: n
        };
    }, Hmr = function(n) {
        return {
            $: 17,
            a: n
        };
    }, Rmr = function(n) {
        return {
            $: 25,
            a: n
        };
    }, Omr = function(n) {
        return {
            $: 30,
            a: n
        };
    }, Nmr = function(n) {
        return {
            $: 19,
            a: n
        };
    }, Imr = F2(function(n, r) {
        return {
            $: 3,
            a: n,
            b: r
        };
    }), Vmr = F2(function(n, r) {
        return {
            $: 12,
            a: n,
            b: r
        };
    }), Wmr = Jn("fullStoryPortIdentifyPatientPortal", ru), Zmr = F2(function(n, r) {
        return Wmr(vk(k([
            b("scope", A2(uc, bk, A2(Cp, mk, n))),
            b("userId", A2(uc, bk, A2(Cp, mk, r)))
        ])));
    }), Xmr = F2(function(n, r) {
        return A2(Zmr, n, r);
    }), Gmr = F2(function(n, r) {
        return A2(Xmr, n, r);
    }), Jmr = F2(function(n, r) {
        return r.$ ? r : bc(m(r.a, {
            hK: n
        }));
    }), Ymr = ru, Qmr = function(n) {
        var r = n.a, t = n.b, e = r.dw;
        if (3 === e.$) {
            var u = pjn(e.a) ? A2(uc, r.kj, A2(Cp, Ymr, r.DE)) : r.kj;
            return b(m(r, {
                gx: A2(Jmr, u, r.gx),
                kj: u,
                cA: A2(F$, u, r.cA)
            }), t);
        }
        return b(r, t);
    }, Kmr = function(n) {
        return n.b.ng;
    }, npr = F2(function(n, r) {
        return !!A2(iA, r, n);
    }), rpr = F3(function(n, r, t) {
        switch(n.$){
            case 3:
                return n.a.vN;
            case 0:
                if (Kmr(r)) {
                    var e = r.b.tC, u = function(n) {
                        return n.b.tB;
                    }(r), a = b(e, u);
                    return a.a && !a.b.$ ? A2(npr, a.b.a, t) : Kmr(r);
                }
                return !1;
            default:
                return !1;
        }
    }), tpr = F4(function(n, r, t, e) {
        return 3 === n.$ && A3(rpr, r, n.a, A2(cp, t, e));
    }), epr = function(n) {
        return 1 === n.$ ? mc(m(n.a, {
            i: S$
        })) : bc(m(n.a, {
            i: S$
        }));
    }, upr = function(n) {
        return x$(n.a.i) ? "limited_access" : "full_access";
    }, apr = function(n) {
        return A2(dA, "member_clinical_data_share", n);
    }, ipr = F3(function(n, r, t) {
        var e = vk(k([
            b("statusCode", hq(t.C7)),
            b("headers", A3(v7, ru, mk, t.hu))
        ])), u = vk(k([
            b("url", mk(t.w_)),
            b("headers", A3(v7, ru, mk, r))
        ])), a = Ml(k([
            b("request", u),
            b("response", e)
        ]));
        return A2(bmr, "Decoder Failed: " + n, a);
    }), cpr = F3(function(n, r, t) {
        return A4(IRn, n, RHn, t, bC(A2($y, k([
            "auth"
        ]), gy(r))));
    }), opr = F4(function(n, r, t, e) {
        var u = vk(k([
            b("google_recaptcha_token", A2(yN, mk, t))
        ]));
        return A4(vN, n, pGn, e, A2(xq, u, bC(A2($y, k([
            "auth",
            "exchange_token"
        ]), gy(r)))));
    }), fpr = Jn("fetchCustomJsFile", mk), spr = function(n) {
        return A2(uc, "", A2(tjn, 1, A2(Tc, function(n) {
            return "" !== n;
        }, A2(ae, "/", n.BJ))));
    }, lpr = F2(function(n, r) {
        if (3 === n.$) {
            var t = n.a, e = spr(r), u = $k(t);
            return Ht(r.zG + "-" + u + "-" + e);
        }
        return Rt;
    }), dpr = function(n) {
        var r = A2(lpr, n.dw, n.w_);
        return r.$ ? Dp : yH(A2(NM, 0, r.a));
    }, bpr = "pageAbandoned", vpr = yH(A2(NM, 1, bpr)), mpr = function(n) {
        var r, t = n.dw;
        if (3 === t.$) {
            var e = (r = function(n) {
                return n.b.oA;
            }(t.a), r.$ ? Dp : fpr(r.a));
            return fmr(ac(n.w_)) ? b(n, Hu(k([
                vpr,
                dpr(n),
                e
            ]))) : b(n, e);
        }
        return b(n, Dp);
    }, ppr = F2(function(n, r) {
        return {
            $: 6,
            a: n,
            b: r
        };
    }), $pr = F5(function(n, r, t, e, u) {
        return {
            o2: u,
            qP: r,
            qU: n,
            kE: t,
            sS: e
        };
    }), hpr = A3(zy, "dob", l_(FC), A3(zy, "name", w$, A3(zy, "meta", RC, A3(zy, "hipaa_authorization_accepted", xy, A3(zy, "id", w$, Ke($pr)))))), gpr = A2(qy, hpr, Ke(ru)), wpr = A2($y, k([
        "account"
    ]), hy), kpr = F2(function(n, r) {
        return A4(dC, n, gpr, r, bC(wpr));
    }), xpr = F2(function(n, r) {
        var t = yx(n), e = ac(r);
        return t && (imr(e) || cmr(e)) ? A2(kpr, n, ppr(n)) : Dp;
    }), ypr = function(n) {
        return {
            $: 7,
            a: n
        };
    }, _pr = F3(function(n, r, t) {
        var e = b(r, t);
        if (3 === e.a.$ && 3 === e.b.$) {
            var u = e.b.a;
            return A4(sln, n, $k(e.a.a), ZC(u), ypr);
        }
        return Dp;
    }), Cpr = function(n) {
        return {
            $: 0,
            a: n
        };
    }, Dpr = function(n) {
        return {
            $: 20,
            a: n
        };
    }, Apr = F2(function(n, r) {
        var t = r.xD;
        return t.$ ? KP(n.zG) : Ht(t.a);
    }), qpr = F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    }), Bpr = F2(function(n, r) {
        return {
            gW: n,
            C4: r
        };
    }), jpr = function(n) {
        switch(n){
            case "patient_portal":
                return Ke(0);
            case "packages":
                return Ke(1);
            default:
                return Ke(2);
        }
    }, Spr = function(n) {
        switch(n){
            case "startup":
                return Ke(0);
            case "growth":
                return Ke(1);
            case "enterprise":
                return Ke(2);
            case "call_us":
                return Ke(3);
            default:
                return Ke(4);
        }
    }, zpr = A3(zy, "starting_tier", A2(Ge, Spr, w$), A3(zy, "code", A2(Ge, jpr, w$), Ke(Bpr))), Upr = A2(qy, A2(Ye, ru, zpr), Ke(ru)), Epr = A3(zy, "passthrough_fees_cutoff_enabled", xy, A3(zy, "passthrough_fees_cutoff_date", Ay(FC), A3(zy, "membership_cancellation_enabled", xy, A3(zy, "charge_patients_credit_card_fees", xy, A3(zy, "default_patients_preferred_language", Bsn, A3(zy, "features", Ey(w$), A3(zy, "feature_gates", Ey(Upr), A3(zy, "address", l_(sen), A3(zy, "phone", l_(w$), A3(zy, "custom_javascript", l_(w$), A3(zy, "encourage_ach", xy, A3(zy, "accepts_cards", xy, A3(zy, "accepts_ach", xy, A3(zy, "accepts_amex", xy, A3(zy, "requires_patient_mobile", xy, A3(zy, "requires_patient_email", xy, A3(zy, "trans_inclusivity", xy, A3(zy, "default_signup_page", l_(mfr), A3(zy, "email", l_(w$), A3(zy, "url", l_(w$), Ke(function(n) {
        return function(r) {
            return function(t) {
                return function(e) {
                    return function(u) {
                        return function(a) {
                            return function(i) {
                                return function(c) {
                                    return function(o) {
                                        return function(f) {
                                            return function(s) {
                                                return function(l) {
                                                    return function(d) {
                                                        return function(b) {
                                                            return function(v) {
                                                                return function(m) {
                                                                    return function(p) {
                                                                        return function($) {
                                                                            return function(h) {
                                                                                return function(g) {
                                                                                    return {
                                                                                        lA: c,
                                                                                        lB: i,
                                                                                        lC: o,
                                                                                        l0: d,
                                                                                        ng: p,
                                                                                        oA: s,
                                                                                        oP: m,
                                                                                        oS: t,
                                                                                        pt: r,
                                                                                        pA: f,
                                                                                        p2: b,
                                                                                        p3: v,
                                                                                        r9: $,
                                                                                        tB: h,
                                                                                        tC: g,
                                                                                        t0: l,
                                                                                        vi: u,
                                                                                        vj: a,
                                                                                        wQ: e,
                                                                                        w_: n
                                                                                    };
                                                                                };
                                                                            };
                                                                        };
                                                                    };
                                                                };
                                                            };
                                                        };
                                                    };
                                                };
                                            };
                                        };
                                    };
                                };
                            };
                        };
                    };
                };
            };
        };
    }))))))))))))))))))))), Ppr = A2(qy, Epr, A2(qy, $fr, Ke(qpr))), Tpr = F3(function(n, r, t) {
        return A4(dC, z9(n), Ppr, t, bC(gy(r)));
    }), Fpr = F7(function(n, r, t, e, u, a, i) {
        return {
            x7: n,
            qN: i,
            tG: a,
            tH: e,
            tI: u,
            tJ: t,
            tK: r
        };
    }), Lpr = A3(zy, "hide_powered_by_hint", xy, A3(zy, "patient_facing_favicon_apple_url", Ay(w$), A3(zy, "patient_facing_favicon_png_url", Ay(w$), A3(zy, "patient_facing_favicon_ico_url", Ay(w$), A3(zy, "patient_facing_logo_alt_text", w$, A3(zy, "patient_facing_logo_url", Ay(w$), A3(zy, "brand_name", w$, Ke(Fpr)))))))), Mpr = A2(qy, Lpr, Ke(ru)), Hpr = F3(function(n, r, t) {
        return A4(dC, z9(n), Mpr, t, bC(function(n) {
            return A2($y, k([
                "whitelabel_settings"
            ]), gy(n));
        }(r)));
    }), Rpr = F2(function(n, r) {
        var t = nT(n.iu);
        if (t.$) {
            var e = A2(Apr, n, r);
            if (e.$) return b(m(r, {
                dw: o_(Hy)
            }), Dp);
            var u = e.a;
            return b(m(r, {
                dw: Mx
            }), Hu(k([
                A3(Tpr, r.gx, u, Cpr),
                A3(Hpr, r.gx, u, Dpr)
            ])));
        }
        var a = t.a;
        return b(m(r, {
            dw: Mx
        }), Hu(k([
            A3(Tpr, r.gx, a, Cpr),
            yH(A3($R, 2, "accountPracticeId", a)),
            A3(Hpr, r.gx, a, Dpr)
        ])));
    }), Opr = function(n) {
        return {
            $: 27,
            a: n
        };
    }, Npr = A2(Ye, ru, A3(zy, "memberMessagingEnabled", xy, Ke(function(n) {
        return {
            r6: n
        };
    }))), Ipr = F3(function(n, r, t) {
        return A4(dC, n, Npr, t, bC(A2($y, k([
            "practice-conversations-settings"
        ]), kT(r))));
    }), Vpr = function(n) {
        return {
            $: 10,
            a: n
        };
    }, Wpr = Jn("start", function() {
        return bk;
    }), Zpr = function(n) {
        var r = n.dw;
        if (3 === r.$) {
            var t = r.a, e = Wpr(0);
            if (fmr(ac(n.w_))) {
                var u = spr(n.w_), a = A2(uc, "", A2(Zu, "company", Fp(n.w_.iu)));
                return fu(a) ? Hu(k([
                    A4(PIn, n.gx, $k(t), u, Vpr),
                    e
                ])) : Hu(k([
                    A5(TIn, n.gx, $k(t), a, u, Vpr),
                    e
                ]));
            }
            return e;
        }
        return Dp;
    }, Xpr = F2(function(n, r) {
        return {
            $: 11,
            a: n,
            b: r
        };
    }), Gpr = F2(function(n, r) {
        return A2($y, k([
            "signup_steps"
        ]), A2(PQn, n, r));
    }), Jpr = F7(function(n, r, t, e, u, a, i) {
        var c = fu(u) ? h : k([
            A2(Ax, "practitioner_id", u)
        ]), o = $(fu(e) ? h : k([
            A2(Ax, "online_enrollment_id", e)
        ]), $(c, fu(a) ? h : k([
            A2(Ax, "location_id", a)
        ])));
        return A4(dC, z9(n), Ey(zQn), i, A2(iH, o, bC(A2(Gpr, r, t))));
    }), Ypr = F2(function(n, r) {
        var t, e, u, a, i = r.dw;
        if (3 === i.$) {
            var c = i.a, o = 2 === (a = r.e6).$ ? a.a : "", f = 3 === (u = r.fF).$ ? pZn(GIn(u.a)) : "", s = (e = Vcr(Fp(r.w_.iu))).$ ? "" : e.a, l = (t = gtr(Fp(r.w_.iu))).$ ? "" : t.a, d = b(fmr(ac(r.w_)), fu(f));
            return b(r, d.a ? d.b ? dL : A7(Jpr, r.gx, $k(c), f, o, s, l, Xpr(n)) : Dp);
        }
        return b(r, Dp);
    }), Qpr = F3(function(n, r, t) {
        return A2(Xb, function(r) {
            return Ht(A2($Zn, r.a, n));
        }, A3(w1n, n, r, t));
    }), Kpr = F4(function(n, r, t, e) {
        var u = A3(Qpr, n, r, t);
        return u.$ ? dL : A2(zx, e, u.a);
    }), n$r = {
        $: 1
    }, r$r = {
        $: 2
    }, t$r = function(n) {
        var r = ok(Q_(n)) ? r$r : n$r;
        return 1 === n.$ ? mc(m(n.a, {
            i: r
        })) : bc(m(n.a, {
            i: r
        }));
    }, e$r = F2(function(n, r) {
        return A2(w7, n, k([
            A2(x7, "scope", r)
        ]));
    }), u$r = A2(zx, oa, Ia), a$r = function(n) {
        return A2(zx, A2(uc, oa, n), ei);
    }, i$r = function(n) {
        return a$r(Ht(A3(Qu, "redirectTo", n.BJ, A2(uc, oa, A2(Cp, Tp, n.iu)))));
    }, c$r = Hu(k([
        YZn,
        A2(Eu, ru, gu($mr))
    ])), o$r = F2(function(n, r) {
        var t = r || !cO(n.gx) && !E7(n.gx) ? u$r : i$r(n.w_), e = A2(e$r, "Authentication - Session Not Valid", upr(n.gx));
        return b(m(n, {
            gx: t$r(n.gx),
            ys: {
                ya: t$r(n.ys.ya),
                J: t$r(n.ys.J),
                e5: t$r(n.ys.e5),
                B6: t$r(n.ys.B6)
            },
            d_: Ht(n.w_)
        }), Hu(k([
            t,
            c$r,
            e
        ])));
    }), f$r = F2(function(n, r) {
        return 1 === r.$ ? mc(m(r.a, {
            i: n
        })) : bc(m(r.a, {
            i: n
        }));
    }), s$r = function(n) {
        if (n.$) return Rt;
        var r = n.a;
        return h$(r) ? k$(A$(r)) : Rt;
    }, l$r = {
        $: 15
    }, d$r = function(n) {
        return {
            $: 16,
            a: n
        };
    }, b$r = F3(function(n, r, t) {
        return A4(vN, n, pGn, t, bC(A2($y, k([
            "auth",
            "refresh"
        ]), gy(r))));
    }), v$r = F2(function(n, r) {
        return 3 === r.$ ? A3(b$r, n, $k(r.a), d$r) : Dp;
    }), m$r = F4(function(n, r, t, e) {
        var u = 12e4, a = b(n, r);
        if (a.a.$ || a.b.$) return Dp;
        var i = a.a.a, c = a.b.a;
        return s(c - i, u) > 0 ? A2(Eu, function() {
            return l$r;
        }, qp(c - i - u)) : A2(v$r, t, e);
    }), p$r = Jn("setTokenPort", function(n) {
        return vk(k([
            b("key", mk(n.hH)),
            b("value", mk(n.w5))
        ]));
    }), $$r = function(n) {
        return p$r({
            hH: "accountToken",
            w5: n
        });
    }, h$r = function(n) {
        return A2(uc, Dp, A2(Cp, $$r, Y_(Q_(n))));
    }, g$r = F2(function(n, r) {
        var t = A2(f$r, n, r.hn), e = {
            ya: A2(f$r, n, r.ys.ya),
            J: A2(f$r, n, r.ys.J),
            e5: A2(f$r, n, r.ys.e5),
            B6: r.ys.B6
        }, u = A2(Jmr, A2(uc, 0, r.DE), A2(f$r, n, r.gx)), a = function(n) {
            if (n.$) return Rt;
            var r = n.a;
            if (h$(r)) {
                var t = D$(k([
                    C$,
                    A2(Ye, pp, _$)
                ]));
                return k$(A2(Wp, function(n) {
                    return 1e3 * n;
                }, A2(m$, A2(Tu, "iat", t), r)));
            }
            return Rt;
        }(n), i = s$r(n);
        return b(m(r, {
            gx: u,
            ys: e,
            hn: t
        }), Hu(k([
            h$r(u),
            A4(m$r, a, i, r.gx, r.dw)
        ])));
    }), w$r = F2(function(n, r) {
        switch(r.$){
            case 3:
                var t = A2(g$r, r.a, n);
                return b(t.a, t.b);
            case 2:
                return r.a.$ ? b(m(n, {
                    tE: oc
                }), Dp) : A2(o$r, n, !1);
            default:
                return b(n, Dp);
        }
    }), k$r = F2(function(n, r) {
        return 3 === n.$ ? TX(n.a) : FX(r);
    }), x$r = function(n) {
        return {
            $: 26,
            a: n
        };
    }, y$r = F2(function(n) {
        var r = b(n.ee, n.dw);
        if (r.a.$ || 3 !== r.b.$) return Dp;
        var t = r.b.a;
        return yVn(t) && ZF(t) ? A3(HWn, n.ys.B6, $k(t), x$r) : Dp;
    }), _$r = F2(function(n, r) {
        if (amr(r)) {
            var t = n.dw;
            return 3 === t.$ ? A2(k$r, n.uh, t.a) ? A2(y$r, n, r) : A2(zx, oa, Wa) : A2(y$r, n, r);
        }
        return imr(r) ? A2(y$r, n, r) : Dp;
    }), C$r = function(n) {
        return Bb(_Vn(n));
    }, D$r = Jn("rainforestPortLoad", mk), A$r = A2(Je, function(n) {
        return n ? "sandbox" : "production";
    }, D$r), q$r = function(n) {
        return function(n) {
            switch(n.$){
                case 0:
                    return "top";
                case 1:
                    return "enroll-thanks";
                case 2:
                    return "not-found";
                case 3:
                    return "patient-documents";
                case 4:
                    return "thanks";
                case 5:
                    return "waitlist";
                case 6:
                    return "account.top";
                case 7:
                    return "booking.top";
                case 8:
                    return "checkout.top";
                case 9:
                    return "enroll.top";
                case 10:
                    return "signup.top";
                case 11:
                    return "style-guide.top";
                case 12:
                    return "account.additional-services";
                case 13:
                    return "account.booking";
                case 14:
                    return "account.cart";
                case 15:
                    return "account.chat";
                case 16:
                    return "account.documents";
                case 17:
                    return "account.forbidden";
                case 18:
                    return "account.health-information";
                case 19:
                    return "account.invoices";
                case 20:
                    return "account.members";
                case 21:
                    return "account.memberships";
                case 22:
                    return "account.messaging";
                case 23:
                    return "account.not-found";
                case 24:
                    return "account.payment-sources";
                case 25:
                    return "account.practitioner-location";
                case 26:
                    return "account.session-expired";
                case 27:
                    return "booking.empty";
                case 28:
                    return "login.request";
                case 29:
                    return "login.select-patient";
                case 30:
                    return "login.verify-code";
                case 31:
                    return "style-guide.activity-indicator";
                case 32:
                    return "style-guide.address-input";
                case 33:
                    return "style-guide.alerts";
                case 34:
                    return "style-guide.api-select";
                case 35:
                    return "style-guide.button";
                case 36:
                    return "style-guide.card-example";
                case 37:
                    return "style-guide.checkbox";
                case 38:
                    return "style-guide.filter-example";
                case 39:
                    return "style-guide.form-example";
                case 40:
                    return "style-guide.grid";
                case 41:
                    return "style-guide.input";
                case 42:
                    return "style-guide.insurance-info";
                case 43:
                    return "style-guide.modal";
                case 44:
                    return "style-guide.multi-form";
                case 45:
                    return "style-guide.phone-input";
                case 46:
                    return "style-guide.radio";
                case 47:
                    return "style-guide.searchable-select";
                case 48:
                    return "style-guide.select";
                case 49:
                    return "style-guide.table";
                case 50:
                    return "style-guide.tabs";
                case 51:
                    return "style-guide.tag";
                case 52:
                    return "style-guide.toggle";
                case 53:
                    return "style-guide.tooltip";
                case 54:
                    return "style-guide.typography";
                case 55:
                    return "account.token_-string";
                case 56:
                    return "bills.token_-string";
                case 57:
                    return "checkout.slug_-string.top";
                case 58:
                    return "signup.slug_-string.top";
                case 59:
                    return "account.messaging.chat";
                case 60:
                    return "appointments.appointment-id_-string.cancellation-policy";
                case 61:
                    return "signup.slug_-string.additional-details";
                case 62:
                    return "signup.slug_-string.confirmation";
                case 63:
                    return "signup.slug_-string.contacts";
                case 64:
                    return "signup.slug_-string.custom-details";
                case 65:
                    return "signup.slug_-string.location";
                case 66:
                    return "signup.slug_-string.members";
                case 67:
                    return "signup.slug_-string.membership";
                case 68:
                    return "signup.slug_-string.provider";
                case 69:
                    return "signup.slug_-string.thanks";
                case 70:
                    return "account.health-information.id_-string";
                case 71:
                    return "account.invoices.id_-string";
                case 72:
                    return "account.members.id_-string";
                case 73:
                    return "account.memberships.id_-string";
                case 74:
                    return "account.packages.id_-string";
                case 75:
                    return "account.payment-sources.id_-string";
                case 76:
                    return "account.appointments.appointment-id_-string.cancel";
                case 77:
                    return "account.appointments.appointment-id_-string.cancel-appointment";
                case 78:
                    return "account.appointments.appointment-id_-string.reschedule";
                case 79:
                    return "account.invoices.id_-string.payment";
                case 80:
                    return "account.members.id_-string.edit";
                case 81:
                    return "account.members.id_-string.emergency-contact";
                case 82:
                    return "account.memberships.id_-string.add-member";
                case 83:
                    return "account.memberships.id_-string.renew";
                case 84:
                    return "account.packages.id_-string.checkout";
                case 85:
                    return "account.payment-sources.id_-string.edit";
                case 86:
                    return "account.plans.id_-string.checkout";
                case 87:
                    return "booking.appointment-type-id_-string.location.booking-location-id_-string.date";
                case 88:
                    return "booking.appointment-type-id_-string.location.booking-location-id_-string.enter-info";
                case 89:
                    return "account.booking.appointment-type-id_-string.location.booking-location-id_-string.date";
                default:
                    return "account.booking.appointment-type-id_-string.location.booking-location-id_-string.enter-info";
            }
        }(n);
    }, B$r = F2(function(n, r) {
        var t = r.p5, e = r.eC, u = r.wi;
        return A2(w7, "Final Form Field Visited", k([
            _7(n),
            zYn(t),
            SYn(EYn(Gb(e))),
            jYn(A2(ue, ", ", A2(yu, UW(Rk(0)), e))),
            LKn(u)
        ]));
    }), j$r = function(n) {
        var r = n.Cr, t = n.p5, e = n.eC;
        return A2(B$r, function(n) {
            switch(smr(n)){
                case 1:
                    return "Style Guide";
                case 0:
                    return TYn;
                case 2:
                    return "Login";
                case 4:
                    return "Booking";
                case 5:
                    return "Appointments";
                case 3:
                    return b7;
                case 6:
                    return "Chat";
                default:
                    return "App";
            }
        }(r), {
            eC: e,
            p5: t,
            wi: q$r(r)
        });
    }, S$r = F3(function(n, r, t) {
        var e = b(r, t);
        return 3 === e.a.$ && 3 === e.b.$ ? cmr(ac(n)) ? A2(zx, oa, Wa) : A2(zx, A2(uc, oa, A2(Cp, Tp, n.iu)), ac(n)) : Dp;
    }), z$r = F3(function(n, r, t) {
        var e = Gb(mZn(r));
        return !e.$ && i(t, A2($Zn, e.a.a, n));
    }), U$r = F3(function(n, r, t) {
        var e = b(r, t);
        if (3 === e.a.$ && 3 === e.b.$) {
            var u = e.a.a, a = e.b.a, i = ec(n);
            if (i.$) return Dp;
            var c = i.a, o = GIn(u);
            return A3(z$r, o, a, c) ? Dp : A3(hZn, o, a, Fp(n.iu));
        }
        return Dp;
    }), E$r = function(n) {
        return function(n) {
            return n.vu;
        }(n.a);
    }, P$r = Jn("setFaviconPort", function(n) {
        return vk(k([
            b("appleUrl", mk(n.mm)),
            b("icoUrl", mk(n.qT)),
            b("pngUrl", mk(n.ub))
        ]));
    }), T$r = function(n) {
        var r = A2(uc, "", n.tI), t = A2(uc, "", n.tH), e = A2(uc, "", function(n) {
            return n.tG;
        }(n));
        return P$r({
            mm: e,
            qT: t,
            ub: r
        });
    }, F$r = Jn("setTheme", mk), L$r = Jn("tabSelected", mk), M$r = {
        $: 18
    }, H$r = function(n) {
        return {
            $: 5,
            a: n
        };
    }, R$r = function(n) {
        return {
            $: 0,
            a: n
        };
    }, O$r = function(n) {
        switch(n){
            case 0:
            case 6:
                return ya;
            case 1:
                return Da;
            case 2:
                return ja;
            case 3:
                return Ma;
            case 4:
                return ga;
            case 5:
                return sa;
            case 7:
                return ka;
            case 8:
                return ha;
            default:
                return va;
        }
    }, N$r = F2(function(n, r) {
        switch(n.$){
            case 0:
                var t = A2(bq, n.a, r.dC), e = t.a, u = t.b, a = t.c, i = function() {
                    if (a.$ || a.a.$) return b(Dp, h);
                    var n = a.a.a;
                    return n.$ ? b(Dp, h) : 1 === n.a.$ ? b(Dp, k([
                        M$r
                    ])) : b(A2(zx, oa, O$r(n.a.a)), h);
                }(), c = i.a, o = i.b;
                return v(m(r, {
                    dC: e
                }), Hu(k([
                    A2(jp, R$r, u),
                    c
                ])), o);
            case 1:
                return v(r, Dp, k([
                    M$r
                ]));
            case 2:
                return v(r, a$r(Rt), h);
            case 3:
                return v(m(r, {
                    bY: !0
                }), A2(dc, H$r, lq("sidebar-polish-close")), h);
            case 4:
                return v(m(r, {
                    bY: !1
                }), A2(dc, H$r, lq("sidebar-polish-open")), h);
            default:
                return v(r, Dp, h);
        }
    }), I$r = F3(function(n, r, t) {
        var e = {
            gU: !1,
            qU: n.e3 + 1,
            hO: r,
            se: t
        };
        return b(m(n, {
            cg: A2(Ot, e, n.cg),
            e3: n.e3 + 1
        }), e);
    }), V$r = function(n) {
        return {
            $: 0,
            a: n
        };
    }, W$r = F2(function(n, r) {
        return m(n, {
            cg: A2(yu, function(n) {
                return i(n.qU, r.qU) ? m(n, {
                    gU: !0
                }) : n;
            }, n.cg)
        });
    }), Z$r = F2(function(n, r) {
        return m(n, {
            cg: A2(Tc, function(n) {
                return !i(n.qU, r.qU);
            }, n.cg)
        });
    }), X$r = F2(function(n, r) {
        switch(n.$){
            case 0:
                return b(A2(W$r, r, t = n.a), function(n) {
                    return A2(Eu, function() {
                        return function(n) {
                            return {
                                $: 2,
                                a: n
                            };
                        }(n);
                    }, qp(300));
                }(t));
            case 2:
                var t;
                return b(A2(Z$r, r, t = n.a), Dp);
            default:
                var e = A3(I$r, r, n.a, n.b);
                return b(e.a, function(n) {
                    return A2(Eu, function() {
                        return V$r(n);
                    }, qp(5e3));
                }(e.b));
        }
    }), G$r = function(n) {
        return {
            $: 4,
            a: n
        };
    }, J$r = F2(function(n, r) {
        switch(r.$){
            case 0:
                return Xt(VQ(r.a));
            case 1:
                return Xt(ZQ);
            case 2:
                return Xt(WQ);
            case 3:
                return Xt(IQ(r.a.C7));
            default:
                return A2(Xp, G$r, n(r.b));
        }
    }), Y$r = GQ({
        zc: (kG = function(n) {
            return {
                $: 0,
                a: n
            };
        }, A2(c_, kG, J$r(Qt))),
        w_: "/RELEASE"
    }), Q$r = A2(uc, Wb, Vb("[a-f0-9]{40}")), K$r = F2(function(n, r) {
        var t = r;
        return A2(wk, ru, function() {
            if (n.$) return b(t, Hu(k([
                Y$r,
                t.h0 ? Dp : Bp
            ])));
            if (n.a.$) return b(t, Dp);
            var r = n.a.a;
            return A2(p$, Q$r, r) ? b(m(t, {
                h0: !i(uF(r), t.oy)
            }), Dp) : b(t, A2(bmr, "Fetching RELEASE Failed", oa));
        }());
    }), nhr = {
        $: 14
    }, rhr = function(n) {
        return vZn(n);
    }, thr = function(n) {
        return A2(Xb, function(r) {
            var t = r.a, e = r.b;
            return dZn(t) ? Ht(A2(bZn, t, e)) : A2(Xb, thr, fB(n));
        }, Gb(n));
    }, ehr = F2(function(n, r) {
        var t = rhr(n);
        return A2(zD, function(n) {
            return i(n.a, r);
        }, t);
    }), uhr = F5(function(n, r, t, e, u) {
        if (A2(uc, !1, A2(Cp, function(n) {
            return dZn(n.a);
        }, A3(WKn, n, r, e)))) return Dp;
        var a = A2(ehr, r, t);
        if (a.$) return A3(hZn, n, r, u);
        var i = thr(we(A2(BE, a.a.b + 1, rhr(r))));
        return i.$ ? A3(hZn, n, r, u) : A2(zx, u, A2($Zn, i.a.a, n));
    }), ahr = A2(zx, oa, Ta), ihr = F2(function(n, r) {
        return {
            $: 1,
            a: n,
            b: r
        };
    }), chr = F2(function(n, r) {
        return A2(ihr, n, r);
    }), ohr = F2(function(n, r) {
        return A2(Xb, function(t) {
            var e = m(r, {
                e6: v8n(n)
            });
            return Ht(b(e, yH(A3($R, 0, t, n))));
        }, A2(lpr, r.dw, r.w_));
    }), fhr = F2(function(n, r) {
        var t = r.a, e = r.b;
        switch(n.$){
            case 0:
                return b(t, Hu(k([
                    e,
                    A3(ipr, n.a, n.b, n.c)
                ])));
            case 1:
                var u = n.a, a = n.b, i = Rk(t.kj), c = A2(X$r, A2(chr, u, i(a)), t.cg), o = c.b;
                return b(m(t, {
                    cg: c.a
                }), Hu(k([
                    e,
                    A2(jp, Fmr, o)
                ])));
            case 2:
                var f = A2(ohr, n.a, t);
                if (f.$) return b(t, e);
                var s = f.a, l = s.b, d = A2(Ypr, !0, H = s.a);
                return b(d.a, Hu(k([
                    e,
                    d.b,
                    l
                ])));
            case 3:
                var v = A2(lpr, t.dw, t.w_);
                return b(t, v.$ ? e : Hu(k([
                    e,
                    yH(A2(IO, 0, v.a))
                ])));
            case 4:
                var p = A2(lpr, t.dw, t.w_);
                return b(t, Hu(k(p.$ ? [
                    e,
                    A3(U$r, t.w_, t.fF, t.CX)
                ] : [
                    e,
                    yH(A2(Imr, 0, p.a))
                ])));
            case 5:
                var $ = n.a, g = b(t.fF, t.CX);
                if (3 === g.a.$ && 3 === g.b.$) {
                    var w = g.b.a, x = GIn(g.a.a), y = Fp(t.w_.iu);
                    return b(t, Hu(k([
                        e,
                        A5(uhr, x, w, $, t.w_, y)
                    ])));
                }
                return b(t, e);
            case 6:
                return b(m(t, {
                    hL: n.a
                }), e);
            case 7:
                return b(m(t, {
                    g7: !0
                }), e);
            case 8:
                return b(m(t, {
                    fV: Lmr
                }), e);
            case 9:
                var _ = n.a, C = n.b, D = n.c;
                if (ED(_)) return b(t, e);
                var A = A2(cy, "tabs", C), q = A.a, B = A.b, j = D ? function(n) {
                    return m(n, {
                        hZ: 1
                    });
                }(q) : q;
                return b(m(t, {
                    dU: _,
                    dV: Ht(j)
                }), Hu(k([
                    e,
                    A2(jp, Vmr(!0), B)
                ])));
            case 10:
                return b(m(t, {
                    dU: h,
                    dV: Rt
                }), e);
            case 11:
                var S = n.a, z = function() {
                    var n = b(t.dV, A2(UD, S, t.dU));
                    if (n.a.$ || n.b.$) return Dp;
                    var r = n.b.a;
                    return A2(jp, Vmr(!1), r);
                }();
                return b(t, Hu(k([
                    e,
                    z
                ])));
            case 15:
                if (3 === t.fF.$) {
                    var U = A2(Ypr, !0, t);
                    return b(H = U.a, Hu(k([
                        e,
                        U.b
                    ])));
                }
                return b(t, e);
            case 12:
                var E = A2(ohr, n.a, t);
                if (E.$) return b(t, e);
                var P = E.a;
                return b(H = P.a, Hu(k([
                    e,
                    l = P.b
                ])));
            case 13:
                var T = n.a, F = A2(Gmr, Ht(upr(t.gx)), ST(T)), L = A2(e$r, "Authentication - Sign In Complete", upr(t.gx)), M = A2(g$r, T, t), H = M.a, R = M.b, O = function() {
                    var n = A2(Zu, "redirectTo", Fp(t.w_.iu));
                    if (n.$) return H;
                    var r = function(n) {
                        var r = A2(ae, "?", n);
                        if (r.b && r.b.b && !r.b.b.b) {
                            var t = r.a, e = A2(aa, "patient", A2(aa, "email", Tp(r.b.a)));
                            return b(t, -2 === e.$ ? Rt : Ht(A2(ue, "&", A2(yu, function(n) {
                                return n.a + "=" + n.b;
                            }, It(e)))));
                        }
                        return b(n, Rt);
                    }(n.a);
                    return m(H, {
                        d_: Ht({
                            zu: Rt,
                            zG: t.w_.zG,
                            BJ: r.a,
                            uc: t.w_.uc,
                            uD: t.w_.uD,
                            iu: r.b
                        })
                    });
                }();
                return b(O, Hu(k([
                    R,
                    e,
                    A2(xpr, O.gx, t.w_),
                    F,
                    L
                ])));
            case 16:
                return b(t, ahr);
            case 14:
                return A2(o$r, t, !1);
            case 17:
                return b(m(t, {
                    gx: t$r(t.gx),
                    ys: {
                        ya: t$r(t.ys.ya),
                        J: t$r(t.ys.J),
                        e5: t$r(t.ys.e5),
                        B6: t$r(t.ys.B6)
                    }
                }), h8);
            case 18:
                return b(t, A2(Eu, ru, gu(nhr)));
            case 19:
                return b(m(t, {
                    gx: A2(f$r, T = n.a, t.gx),
                    ys: {
                        ya: A2(f$r, T, t.ys.ya),
                        J: A2(f$r, T, t.ys.J),
                        e5: A2(f$r, T, t.ys.e5),
                        B6: A2(f$r, T, t.ys.B6)
                    }
                }), Dp);
            case 21:
            case 22:
                return b(t, Dp);
            case 20:
                return b(t, A2(bmr, "Bad Gateway error", oa));
            default:
                return b(m(t, {
                    bI: n.a
                }), e);
        }
    }), shr = F2(function(n, r) {
        return A3(ce, fhr, b(r, Dp), n);
    }), lhr = F2(function(n, r) {
        switch(n.$){
            case 0:
                var t = n.a;
                n: for(;;)switch(t.$){
                    case 2:
                        if (6 === t.a.$) {
                            var e = t.a, u = e.a, a = e.b, c = e.c;
                            return b(m(r, {
                                dw: t
                            }), A3(ipr, u, a, c));
                        }
                        break n;
                    case 3:
                        var o = t.a, f = i(r.zE, Ht("production")) && !E$r(o) ? 0 : 1, s = yVn(o) && apr(o), l = m(r, {
                            yl: A4(tpr, t, r.tL, r.fL, r.bf),
                            bJ: s,
                            dr: C$r(o),
                            dw: t
                        }), d = fk(r.gx) ? XZn(0) : A2(xpr, r.gx, r.w_);
                        return Qmr(b(l, Hu(k([
                            Zpr(l),
                            A2(Eu, Hmr, by),
                            d,
                            A$r(f)
                        ]))));
                    default:
                        break n;
                }
                return b(r, Dp);
            case 1:
                var p = A2(X$r, n.a, r.cg), $ = p.b;
                return b(m(r, {
                    cg: p.a
                }), A2(jp, Fmr, $));
            case 3:
                return b(r, F$r(n.a));
            case 2:
                var h = n.a;
                return A2(Rpr, r.w_, function() {
                    if (h.$) return r;
                    var n = h.a.b;
                    return m(r, {
                        jx: A2(yp, n, r.bf),
                        fL: n
                    });
                }());
            case 10:
                var g = n.a;
                l = m(r, {
                    fF: g
                });
                n: for(;;)switch(g.$){
                    case 2:
                        if (6 === g.a.$) {
                            var w = g.a;
                            return b(l, A3(ipr, u = w.a, a = w.b, c = w.c));
                        }
                        break n;
                    case 3:
                        return mpr(l);
                    default:
                        break n;
                }
                return b(l, Dp);
            case 11:
                var x = n.a, y = n.b;
                switch(l = m(r, {
                    CX: y
                }), y.$){
                    case 3:
                        var _ = y.a;
                        return d = function() {
                            var n = v(r.e6, x, r.fF);
                            n: for(;;){
                                if (2 === n.a.$) {
                                    if (n.b) {
                                        if (3 === n.c.$) return A4(Kpr, GIn(n.c.a), _, r.w_, Fp(r.w_.iu));
                                        break n;
                                    }
                                    return Dp;
                                }
                                break n;
                            }
                            return A3(U$r, l.w_, l.fF, y);
                        }(), b(l, d);
                    case 2:
                        if (6 === y.a.$) {
                            var C = y.a;
                            return b(l, A3(ipr, u = C.a, a = C.b, c = C.c));
                        }
                        var D = function() {
                            var n = r.fF;
                            if (3 === n.$) {
                                var t = GIn(n.a).w_;
                                if (t.$) return b(l, Dp);
                                var e = t.a;
                                return b(m(l, {
                                    CX: Mx
                                }), T2n(e));
                            }
                            return b(l, Dp);
                        }();
                        return b(D.a, D.b);
                    default:
                        return b(l, Dp);
                }
            case 4:
                if ((h = n.a).$) return b(m(r, {
                    fV: Lmr,
                    e6: Lmr
                }), A3(U$r, r.w_, r.fF, r.CX));
                var A = h.a;
                n: for(; 1 === A.$;)switch(A.a){
                    case 0:
                        return l = m(r, (q = A.b).$ ? {
                            e6: Lmr
                        } : {
                            e6: v8n(q.a)
                        }), A2(Ypr, !1, l);
                    case 1:
                        var q = A.b, B = yH(A2(IO, 1, bpr));
                        return b(m(r, q.$ ? {
                            fV: Lmr
                        } : {
                            fV: v8n(q.a)
                        }), B);
                    default:
                        break n;
                }
                return b(r, Dp);
            case 5:
                if ((h = n.a).$) return b(r, Dp);
                if (2 !== (A = h.a).$ || A.a) return b(r, Dp);
                var j = A.b;
                return b(l = m(r, {
                    e6: Lmr
                }), j ? A3(U$r, l.w_, l.fF, l.CX) : Dp);
            case 6:
                var S = n.a, z = n.b;
                n: for(;;){
                    if (2 !== z.$) {
                        var U = (jn = r.d_).$ ? r.w_ : jn.a, E = 3 === z.$ ? Ht(ZC(z.a)) : Rt;
                        return b(m(r, {
                            tE: z
                        }), Hu(k([
                            h$r(S),
                            A3(S$r, U, z, r.dw),
                            A3(_pr, S, r.dw, z),
                            (qn = r.ys.J, Bn = zT(qn), Bn.$ ? Dp : A3(Ipr, qn, Bn.a, Opr)),
                            A2(Gmr, Ht(upr(S)), E)
                        ])));
                    }
                    switch(z.a.$){
                        case 6:
                            var P = z.a;
                            return u = P.a, a = P.b, c = P.c, b(m(r, {
                                tE: oc
                            }), Hu(k([
                                A3(ipr, u, a, c),
                                c$r
                            ])));
                        case 0:
                            return A2(o$r, m(r, {
                                tE: oc
                            }), !1);
                        case 5:
                            if (409 === z.a.a) return d = imr(ac(r.w_)) ? Hu(k([
                                h$r(S),
                                a$r(A2(Cp, Tp, r.w_.iu))
                            ])) : Dp, b(m(r, {
                                tE: oc,
                                d_: Ht(r.w_)
                            }), d);
                            break n;
                        default:
                            break n;
                    }
                }
                return b(m(r, {
                    tE: oc
                }), Dp);
            case 7:
                var T = n.a;
                return Qmr(b(m(r, {
                    yl: A4(tpr, r.dw, T, r.fL, r.bf),
                    tL: T,
                    DE: 3 === T.$ ? Ht(Lvn(T.a)) : Rt
                }), Dp));
            case 27:
                var F = n.a, L = function() {
                    var n = b(F, ac(r.w_));
                    if (3 === n.a.$) {
                        var t = n.a.a;
                        return amr(n.b) && !TX(t) ? A2(zx, oa, Wa) : Dp;
                    }
                    return Dp;
                }();
                return b(l = m(r, {
                    uh: F
                }), L);
            case 8:
                var M = (An = ac(r.w_), yH(A3($R, 1, bpr, Sx(An))));
                return b(r, Hu(k([
                    A2(uc, Dp, A2(Cp, j$r, r.hL)),
                    M
                ])));
            case 9:
                var H = (Dn = A2(lpr, r.dw, r.w_)).$ ? Dp : yH(A2(Imr, 0, Dn.a));
                return b(m(r, {
                    g7: !1
                }), H);
            case 12:
                var R = n.a, O = n.b, N = r.dV;
                if (N.$) return b(r, Dp);
                var I = A2(pq, O, N.a), V = I.a, W = I.b, Z = I.c, X = Z.$ ? Dp : Z.a.$ ? Wjn(Z.a.a) : R ? L$r(Z.a.a.qU) : Dp;
                return b(m(r, {
                    dV: Ht(V)
                }), Hu(k([
                    A2(jp, Vmr(R), W),
                    X
                ])));
            case 13:
                var G = A2(K$r, n.a, r.Cf), J = G.b;
                return b(m(r, {
                    Cf: G.a
                }), A2(jp, fc, J));
            case 14:
                var Y = 3 === (Cn = r.dw).$ ? A3(cpr, r.gx, $k(Cn.a), Omr) : Dp;
                return b(m(r, {
                    gx: A2(Jmr, A2(uc, 0, r.DE), epr(r.gx)),
                    ys: {
                        ya: epr(r.ys.ya),
                        J: epr(r.ys.J),
                        e5: epr(r.ys.e5),
                        B6: epr(r.ys.B6)
                    }
                }), Hu(k([
                    Y,
                    c$r,
                    a$r(Rt)
                ])));
            case 17:
                var Q = n.a, K = s$r(Q_(r.gx)), nn = fmr(ac(r.w_)) ? Dp : A4(m$r, Ht(Q), K, r.gx, r.dw);
                return b(r, nn);
            case 15:
                return b(r, A2(v$r, r.gx, r.dw));
            case 16:
                var rn = n.a, tn = A2(e$r, "Authentication - Session Refreshed", upr(r.gx)), en = A2(w$r, r, rn);
                return b(l = en.a, Hu(k([
                    d = en.b,
                    tn
                ])));
            case 21:
                var un = A2(w$r, r, rn = n.a);
                return d = un.b, b(m(l = un.a, {
                    eD: !1
                }), Hu(k([
                    d,
                    A2(xpr, l.gx, r.w_)
                ])));
            case 19:
                var an = A2(N$r, n.a, r.dr), cn = an.a, on = an.b, fn = A2(shr, an.c, r), sn = fn.b;
                return b(m(l = fn.a, {
                    dr: cn
                }), Hu(k([
                    A2(jp, Nmr, on),
                    sn
                ])));
            case 20:
                var ln = n.a;
                n: for(;;)switch(ln.$){
                    case 3:
                        var dn = ln.a;
                        return b(m(r, {
                            an: ln
                        }), T$r(dn));
                    case 2:
                        if (6 === ln.a.$) {
                            var bn = ln.a;
                            return u = bn.a, a = bn.b, c = bn.c, b(m(r, {
                                an: ln
                            }), A3(ipr, u, a, c));
                        }
                        break n;
                    default:
                        break n;
                }
                return b(m(r, {
                    an: ln
                }), Dp);
            case 24:
                return imr(ac(r.w_)) ? A2(o$r, r, !0) : b(r, Dp);
            case 18:
                return b(m(r, {
                    bf: Q = n.a,
                    jx: A2(yp, r.fL, Q)
                }), Dp);
            case 25:
                var vn = A2($Un, n.a, r.cA), mn = vn.a, pn = vn.b, $n = vn.c, hn = function() {
                    if ($n.$ || $n.a.$) return b(r, Dp);
                    var n = $n.a.a;
                    return b(m(r, {
                        gx: A2(Jmr, n, r.gx),
                        kj: Ymr(n),
                        DE: Ht(n)
                    }), yH(A3($R, 3, "hint-language", Eb(n))));
                }(), gn = hn.b;
                return b(m(hn.a, {
                    cA: mn
                }), Hu(k([
                    gn,
                    A2(jp, Rmr, pn)
                ])));
            case 26:
                return b(m(r, {
                    ee: n.a
                }), Dp);
            case 28:
                var wn = (_n = U = n.a, A3(Je, Cp(ac), uc(Ru), $u(_n)));
                return b(r, A2(_$r, r, wn));
            case 29:
                var kn = ac(r.w_);
                return d = cmr(kn) || function(n) {
                    return i(n, Ia) || i(n, wa) || i(n, Ta);
                }(kn) ? Dp : i$r(r.w_), b(m(r, {
                    gx: epr(r.gx),
                    ys: {
                        ya: epr(r.ys.ya),
                        J: epr(r.ys.J),
                        e5: epr(r.ys.e5),
                        B6: epr(r.ys.B6)
                    }
                }), d);
            case 30:
                return b(r, Dp);
            case 22:
                if (h = n.a, fk(r.gx) && !r.eD) {
                    if (h.$) return b(r, Dp);
                    var xn = h.a, yn = r.dw;
                    return 3 === yn.$ ? (o = yn.a, b(m(r, {
                        eD: !0
                    }), A4(opr, r.gx, $k(o), Ht(xn), Mmr))) : b(r, Dp);
                }
                return b(r, Dp);
            default:
                return fk(r.gx) ? b(r, pXn(1)) : b(r, Dp);
        }
        var _n, Cn, Dn, An, qn, Bn, jn;
    }), dhr = F2(function(n, r) {
        var t = b(n, r);
        n: for(;;)switch(t.a.$){
            case 0:
                if (t.b.$) break n;
                return A2(emr.lp.DB, t.a.a, t.b.a);
            case 1:
                if (1 === t.b.$) return A2(emr.hg.DB, t.a.a, t.b.a);
                break n;
            case 2:
                if (2 === t.b.$) return A2(emr.h2.DB, t.a.a, t.b.a);
                break n;
            case 3:
                if (3 === t.b.$) return A2(emr.e9.DB, t.a.a, t.b.a);
                break n;
            case 4:
                if (4 === t.b.$) return A2(emr.jw.DB, t.a.a, t.b.a);
                break n;
            case 5:
                if (5 === t.b.$) return A2(emr.q.DB, t.a.a, t.b.a);
                break n;
            case 6:
                if (6 === t.b.$) return A2(emr.gu.DB, t.a.a, t.b.a);
                break n;
            case 7:
                if (7 === t.b.$) return A2(emr.gJ.DB, t.a.a, t.b.a);
                break n;
            case 8:
                if (8 === t.b.$) return A2(emr.gS.DB, t.a.a, t.b.a);
                break n;
            case 9:
                if (9 === t.b.$) return A2(emr.hh.DB, t.a.a, t.b.a);
                break n;
            case 10:
                if (10 === t.b.$) return A2(emr.i_.DB, t.a.a, t.b.a);
                break n;
            case 11:
                if (11 === t.b.$) return A2(emr.jo.DB, t.a.a, t.b.a);
                break n;
            case 12:
                if (12 === t.b.$) return A2(emr.fW.DB, t.a.a, t.b.a);
                break n;
            case 13:
                if (13 === t.b.$) return A2(emr.f_.DB, t.a.a, t.b.a);
                break n;
            case 14:
                if (14 === t.b.$) return A2(emr.f1.DB, t.a.a, t.b.a);
                break n;
            case 15:
                if (15 === t.b.$) return A2(emr.f2.DB, t.a.a, t.b.a);
                break n;
            case 16:
                if (16 === t.b.$) return A2(emr.f3.DB, t.a.a, t.b.a);
                break n;
            case 17:
                if (17 === t.b.$) return A2(emr.f4.DB, t.a.a, t.b.a);
                break n;
            case 18:
                if (18 === t.b.$) return A2(emr.f5.DB, t.a.a, t.b.a);
                break n;
            case 19:
                if (19 === t.b.$) return A2(emr.f7.DB, t.a.a, t.b.a);
                break n;
            case 20:
                if (20 === t.b.$) return A2(emr.ga.DB, t.a.a, t.b.a);
                break n;
            case 21:
                if (21 === t.b.$) return A2(emr.ge.DB, t.a.a, t.b.a);
                break n;
            case 22:
                if (22 === t.b.$) return A2(emr.gi.DB, t.a.a, t.b.a);
                break n;
            case 23:
                if (23 === t.b.$) return A2(emr.gk.DB, t.a.a, t.b.a);
                break n;
            case 24:
                if (24 === t.b.$) return A2(emr.gn.DB, t.a.a, t.b.a);
                break n;
            case 25:
                if (25 === t.b.$) return A2(emr.gr.DB, t.a.a, t.b.a);
                break n;
            case 26:
                if (26 === t.b.$) return A2(emr.gs.DB, t.a.a, t.b.a);
                break n;
            case 27:
                if (27 === t.b.$) return A2(emr.gI.DB, t.a.a, t.b.a);
                break n;
            case 28:
                if (28 === t.b.$) return A2(emr.hS.DB, t.a.a, t.b.a);
                break n;
            case 29:
                if (29 === t.b.$) return A2(emr.hT.DB, t.a.a, t.b.a);
                break n;
            case 30:
                if (30 === t.b.$) return A2(emr.hU.DB, t.a.a, t.b.a);
                break n;
            case 31:
                if (31 === t.b.$) return A2(emr.i1.DB, t.a.a, t.b.a);
                break n;
            case 32:
                if (32 === t.b.$) return A2(emr.i2.DB, t.a.a, t.b.a);
                break n;
            case 33:
                if (33 === t.b.$) return A2(emr.i3.DB, t.a.a, t.b.a);
                break n;
            case 34:
                if (34 === t.b.$) return A2(emr.i4.DB, t.a.a, t.b.a);
                break n;
            case 35:
                if (35 === t.b.$) return A2(emr.i5.DB, t.a.a, t.b.a);
                break n;
            case 36:
                if (36 === t.b.$) return A2(emr.i6.DB, t.a.a, t.b.a);
                break n;
            case 37:
                if (37 === t.b.$) return A2(emr.i7.DB, t.a.a, t.b.a);
                break n;
            case 38:
                if (38 === t.b.$) return A2(emr.i8.DB, t.a.a, t.b.a);
                break n;
            case 39:
                if (39 === t.b.$) return A2(emr.i9.DB, t.a.a, t.b.a);
                break n;
            case 40:
                if (40 === t.b.$) return A2(emr.ja.DB, t.a.a, t.b.a);
                break n;
            case 41:
                if (41 === t.b.$) return A2(emr.jb.DB, t.a.a, t.b.a);
                break n;
            case 42:
                if (42 === t.b.$) return A2(emr.jc.DB, t.a.a, t.b.a);
                break n;
            case 43:
                if (43 === t.b.$) return A2(emr.jd.DB, t.a.a, t.b.a);
                break n;
            case 44:
                if (44 === t.b.$) return A2(emr.je.DB, t.a.a, t.b.a);
                break n;
            case 45:
                if (45 === t.b.$) return A2(emr.jf.DB, t.a.a, t.b.a);
                break n;
            case 46:
                if (46 === t.b.$) return A2(emr.jg.DB, t.a.a, t.b.a);
                break n;
            case 47:
                if (47 === t.b.$) return A2(emr.jh.DB, t.a.a, t.b.a);
                break n;
            case 48:
                if (48 === t.b.$) return A2(emr.ji.DB, t.a.a, t.b.a);
                break n;
            case 49:
                if (49 === t.b.$) return A2(emr.jj.DB, t.a.a, t.b.a);
                break n;
            case 50:
                if (50 === t.b.$) return A2(emr.jk.DB, t.a.a, t.b.a);
                break n;
            case 51:
                if (51 === t.b.$) return A2(emr.jl.DB, t.a.a, t.b.a);
                break n;
            case 52:
                if (52 === t.b.$) return A2(emr.jm.DB, t.a.a, t.b.a);
                break n;
            case 53:
                if (53 === t.b.$) return A2(emr.jn.DB, t.a.a, t.b.a);
                break n;
            case 54:
                if (54 === t.b.$) return A2(emr.jp.DB, t.a.a, t.b.a);
                break n;
            case 55:
                if (55 === t.b.$) return A2(emr.gt.DB, t.a.a, t.b.a);
                break n;
            case 56:
                if (56 === t.b.$) return A2(emr.gD.DB, t.a.a, t.b.a);
                break n;
            case 57:
                if (57 === t.b.$) return A2(emr.gR.DB, t.a.a, t.b.a);
                break n;
            case 58:
                if (58 === t.b.$) return A2(emr.iZ.DB, t.a.a, t.b.a);
                break n;
            case 59:
                if (59 === t.b.$) return A2(emr.gj.DB, t.a.a, t.b.a);
                break n;
            case 60:
                if (60 === t.b.$) return A2(emr.gB.DB, t.a.a, t.b.a);
                break n;
            case 61:
                if (61 === t.b.$) return A2(emr.iQ.DB, t.a.a, t.b.a);
                break n;
            case 62:
                if (62 === t.b.$) return A2(emr.iR.DB, t.a.a, t.b.a);
                break n;
            case 63:
                if (63 === t.b.$) return A2(emr.iS.DB, t.a.a, t.b.a);
                break n;
            case 64:
                if (64 === t.b.$) return A2(emr.iT.DB, t.a.a, t.b.a);
                break n;
            case 65:
                if (65 === t.b.$) return A2(emr.iU.DB, t.a.a, t.b.a);
                break n;
            case 66:
                if (66 === t.b.$) return A2(emr.iV.DB, t.a.a, t.b.a);
                break n;
            case 67:
                if (67 === t.b.$) return A2(emr.iW.DB, t.a.a, t.b.a);
                break n;
            case 68:
                if (68 === t.b.$) return A2(emr.iX.DB, t.a.a, t.b.a);
                break n;
            case 69:
                if (69 === t.b.$) return A2(emr.iY.DB, t.a.a, t.b.a);
                break n;
            case 70:
                if (70 === t.b.$) return A2(emr.f6.DB, t.a.a, t.b.a);
                break n;
            case 71:
                if (71 === t.b.$) return A2(emr.f8.DB, t.a.a, t.b.a);
                break n;
            case 72:
                if (72 === t.b.$) return A2(emr.gb.DB, t.a.a, t.b.a);
                break n;
            case 73:
                if (73 === t.b.$) return A2(emr.gf.DB, t.a.a, t.b.a);
                break n;
            case 74:
                if (74 === t.b.$) return A2(emr.gl.DB, t.a.a, t.b.a);
                break n;
            case 75:
                if (75 === t.b.$) return A2(emr.go.DB, t.a.a, t.b.a);
                break n;
            case 76:
                if (76 === t.b.$) return A2(emr.fX.DB, t.a.a, t.b.a);
                break n;
            case 77:
                if (77 === t.b.$) return A2(emr.fY.DB, t.a.a, t.b.a);
                break n;
            case 78:
                if (78 === t.b.$) return A2(emr.fZ.DB, t.a.a, t.b.a);
                break n;
            case 79:
                if (79 === t.b.$) return A2(emr.f9.DB, t.a.a, t.b.a);
                break n;
            case 80:
                if (80 === t.b.$) return A2(emr.gc.DB, t.a.a, t.b.a);
                break n;
            case 81:
                if (81 === t.b.$) return A2(emr.gd.DB, t.a.a, t.b.a);
                break n;
            case 82:
                if (82 === t.b.$) return A2(emr.gg.DB, t.a.a, t.b.a);
                break n;
            case 83:
                if (83 === t.b.$) return A2(emr.gh.DB, t.a.a, t.b.a);
                break n;
            case 84:
                if (84 === t.b.$) return A2(emr.gm.DB, t.a.a, t.b.a);
                break n;
            case 85:
                if (85 === t.b.$) return A2(emr.gp.DB, t.a.a, t.b.a);
                break n;
            case 86:
                if (86 === t.b.$) return A2(emr.gq.DB, t.a.a, t.b.a);
                break n;
            case 87:
                if (87 === t.b.$) return A2(emr.gG.DB, t.a.a, t.b.a);
                break n;
            case 88:
                if (88 === t.b.$) return A2(emr.gH.DB, t.a.a, t.b.a);
                break n;
            case 89:
                if (89 === t.b.$) return A2(emr.f$.DB, t.a.a, t.b.a);
                break n;
            default:
                if (90 === t.b.$) return A2(emr.f0.DB, t.a.a, t.b.a);
                break n;
        }
        return v(r, Dp, h);
    }), bhr = Jn("updateTitle", mk), vhr = F2(function(n, r) {
        var t;
        return b(m(r, {
            w_: n
        }), Hu(k([
            (t = r.Cf, t.h0 ? W5n : Dp)
        ])));
    }), mhr = function(n) {
        return jmr(n).DH(0);
    }, phr = F2(function(n, r) {
        switch(n.$){
            case 0:
                var t = n.a, e = r.CJ, u = ac(e.w_), a = mmr(t), c = a.a, o = a.b, f = A2(vhr, c, e), s = f.a, l = f.b, d = ac(c), p = i(d, u), $ = function() {
                    if (p) return v(A2(Emr, r.a3, s), r.eP, Dp);
                    var n = A2(umr, d, s);
                    return v(b(n.a, n.b), lmr(d), A2(Eu, function() {
                        return Umr;
                    }, A2(Tmr, 0, 0)));
                }(), h = $.a, g = h.b, w = $.b, x = $.c, y = mhr(D = h.a).wD;
                return b(m(r, {
                    eP: w,
                    a3: D,
                    CJ: A2(Pmr, D, s)
                }), Hu(k([
                    A2(jp, Mu, l),
                    A2(jp, Lu, g),
                    o,
                    bhr(y),
                    x
                ])));
            case 2:
                var _ = A2(lhr, n.a, r.CJ), C = (l = _.b, A2(Emr, r.a3, s = _.a));
                return g = C.b, b(m(r, {
                    a3: D = C.a,
                    CJ: s
                }), Hu(k([
                    A2(jp, Mu, l),
                    A2(jp, Lu, g)
                ])));
            case 3:
                var D, A = A2(dhr, n.a, r.a3), q = (g = A.b, A2(shr, A.c, A2(Pmr, D = A.a, r.CJ)));
                return s = q.a, l = q.b, y = mhr(D).wD, b(m(r, {
                    a3: D,
                    CJ: s
                }), Hu(k([
                    A2(jp, Lu, g),
                    A2(jp, Mu, l),
                    bhr(y)
                ])));
            default:
                return b(r, Dp);
        }
    }), $hr = function(n) {
        switch(n){
            case 0:
                return "alert--info";
            case 1:
                return "alert--error";
            case 2:
                return "alert--warning";
            default:
                return "alert--success";
        }
    }, hhr = function(n) {
        switch(n){
            case 0:
                return 4;
            case 1:
            case 2:
                return 3;
            default:
                return 1;
        }
    }, ghr = function(n) {
        return b(ee(n.qU), A2(Ik, k([
            Nk("alert"),
            Nk($hr(n.hO)),
            rz(k([
                b("alert--closing", n.gU)
            ]))
        ]), k([
            A2(Ik, h, k([
                A2(Gk, k([
                    Nk("mr-3")
                ]), k([
                    A2(US, h, hhr(n.hO))
                ])),
                ad(n.se)
            ])),
            A2(jq, k([
                Eq(V$r(n))
            ]), k([
                A2(US, h, 2)
            ]))
        ])));
    }, whr = function(n) {
        var r;
        return A2(px, Fmr, (r = n, A3($U, "div", k([
            Nk("alerts-wrapper")
        ]), A2(yu, ghr, r.cg))));
    }, khr = function(n) {
        return {
            $: 3,
            a: n
        };
    }, xhr = F2(function(n, r) {
        return {
            $: 1,
            a: n,
            b: r
        };
    }), yhr = xhr, _hr = {
        $: 6
    }, Chr = function(n) {
        var r = A2(Tc, function(n) {
            return !i(n, _hr);
        }, n);
        return r.b ? r.b.b ? function(n) {
            return {
                $: 4,
                a: n
            };
        }(r) : r.a : _hr;
    }, Dhr = function(n) {
        return n.qN;
    }, Ahr = function(n) {
        return {
            $: 3,
            a: n
        };
    }, qhr = Ahr, Bhr = function(n) {
        return Ahr(A2(Ik, k([
            Nk("footer-language-portal min-w-0")
        ]), k([
            n
        ])));
    }, jhr = function(n) {
        return n.vv.yE;
    }, Shr = F2(function(n, r) {
        return 3 === r.$ && E$r(r.a) ? A2(Ik, k([
            Nk("sandbox-alert")
        ]), k([
            ad(n(jhr))
        ])) : ad("");
    }), zhr = A2(ce, F2(function(n, r) {
        return m(r, {
            jv: n
        });
    }), {
        jv: 0
    }), Uhr = F2(function(n, r) {
        var t = "https://www.hint.com/?utm_campaign=" + r + "&utm_source=" + n + "&utm_medium=application";
        return A2(Ik, h, k([
            A2(AB, k([
                TB("https://cdn2.hubspot.net/hubfs/2562809/production-app/web/logo-mark.svg"),
                Nk("icon -mt-1")
            ]), h),
            A2(PB, k([
                BB,
                EB
            ]), k([
                ad("Powered by "),
                A2(gV, k([
                    n0,
                    vV(t),
                    mV
                ]), k([
                    ad("Hint")
                ]))
            ]))
        ]));
    }), Ehr = A2(PB, k([
        BB,
        EB
    ]), k([
        A2(gV, k([
            n0,
            vV("https://www.hint.com/privacy"),
            mV
        ]), k([
            ad("Privacy Policy")
        ]))
    ])), Phr = F2(function(n, r) {
        return function(t) {
            return $(r(t), Fb(n));
        };
    }), Thr = F2(function(n, r) {
        return function(t) {
            return $(Fb(n), r(t));
        };
    }), Fhr = function(n) {
        return n.fn.xR;
    }, Lhr = function(n) {
        return n.fn.z8;
    }, Mhr = function(n) {
        return n.fn.B4;
    }, Hhr = function(n) {
        return n.fn.Dh;
    }, Rhr = function(n) {
        return n.uX;
    }, Ohr = F2(function(n, r) {
        return r.vW(n);
    }), Nhr = function(n) {
        return n.vX;
    }, Ihr = function(n) {
        var r = function(n) {
            return n.b.oS;
        }(n);
        return r.$ ? "" : Ifr(r.a);
    }, Vhr = F2(function(n, r) {
        return A2(hx, k([
            EB,
            bz(wF),
            BB
        ]), k([
            A2(Gk, h, k([
                ad(n(Ohr(hk(r)))),
                ad(" ")
            ])),
            A2(gV, k([
                vV(Ihr(r)),
                mV,
                n0
            ]), k([
                ad(n(Nhr))
            ]))
        ]));
    }), Whr = F2(function(n, r) {
        switch(r.$){
            case 0:
                return function(n) {
                    return A2(Ik, h, Gq(A2(hx, k([
                        BB,
                        EB
                    ]), k([
                        A2(PB, h, k([
                            ad(n(A2(Phr, " ", Lhr)))
                        ])),
                        A2(PB, h, k([
                            A2(gV, k([
                                n0,
                                vV("https://policies.google.com/privacy"),
                                mV
                            ]), k([
                                ad(n(Mhr))
                            ]))
                        ])),
                        A2(PB, h, k([
                            ad(n(A2(Phr, " ", A2(Thr, " ", Fhr))))
                        ])),
                        A2(PB, k([
                            Qk(k([
                                Nk("inline-block")
                            ]))
                        ]), k([
                            A2(gV, k([
                                n0,
                                vV("https://policies.google.com/terms"),
                                mV
                            ]), k([
                                ad(n(Hhr))
                            ]))
                        ])),
                        A2(PB, h, k([
                            ad(n(Rhr))
                        ]))
                    ]))));
                }(n);
            case 1:
                return A2(Uhr, r.a, r.b);
            case 2:
                return A2(Vhr, n, r.a);
            case 3:
                return r.a;
            case 4:
                var t = r.a;
                return A2(Ik, k([
                    Nk("flex items-center justify-between space-x-4")
                ]), A2(yu, Whr(n), t));
            case 5:
                return Ehr;
            default:
                return ad("");
        }
    }), Zhr = F3(function(n, r, t) {
        var e = zhr(r);
        return A2(Ik, k([
            Nk("footer"),
            Nk(1 === e.jv ? "text-center items-center" : "text-left")
        ]), A2(yu, Whr(n), t));
    }), Xhr = {
        $: 7
    }, Ghr = F2(function(n, r) {
        var t = b(n, r);
        if (3 === t.a.$ && 3 === t.b.$) {
            var e = t.b.a;
            return _Vn(t.a.a) || ED($L(e)) ? Sq : A2(Ik, k([
                Nk("fixed right-6 bottom-24 md:bottom-8")
            ]), k([
                A2(gV, k([
                    vV(Sx(va)),
                    DV,
                    Xhr
                ]), k([
                    A2(US, k([
                        zVn
                    ]), 27)
                ]))
            ]));
        }
        return Sq;
    }), Jhr = ir("header"), Yhr = F3(function(n, r, t) {
        return 3 === n.$ ? A2(Jhr, k([
            Nk(1 === t ? "header header--app h-24" : "header h-24")
        ]), k([
            A2(Ik, k([
                Nk("header__container app-container app-account-container justify-between")
            ]), k([
                r
            ]))
        ])) : Sq;
    }), Qhr = F4(function(n, r, t, e) {
        var u = b(n, r);
        if (1 === u.a.$) {
            if (u.b.$) return A2(Ik, k([
                Nk("header__logo")
            ]), k([
                ad(t)
            ]));
            var a = u.b.a;
            return A2(Ik, k([
                Nk("header__logo")
            ]), k([
                A2(AB, k([
                    TB(a),
                    Iq(e)
                ]), h)
            ]));
        }
        return u.b.$ ? A2(fF, k([
            vF(u.a.a),
            Nk("header__logo")
        ]), k([
            ad(t)
        ])) : (a = u.b.a, A2(fF, k([
            vF(u.a.a),
            Nk("header__logo")
        ]), k([
            A2(AB, k([
                TB(a),
                Iq(e)
            ]), h)
        ])));
    }), Khr = function(n) {
        return n.tJ;
    }, ngr = function(n) {
        return n.tK;
    }, rgr = F2(function(n, r) {
        var t = b(n, r);
        n: for(;;){
            r: for(;;)switch(t.a.$){
                case 3:
                    switch(t.b.$){
                        case 3:
                            var e = t.a.a, u = t.b.a;
                            return A4(Qhr, Hfr(e), ngr(u), hk(e), Khr(u));
                        case 1:
                            break n;
                        default:
                            break r;
                    }
                case 1:
                    return Jk(k([
                        n5
                    ]));
                default:
                    if (1 === t.b.$) break n;
                    break r;
            }
            return A4(Qhr, Ht("http://www.hint.com"), Ht("https://cdn2.hubspot.net/hubfs/2562809/production-app/web/logo-mark.svg"), "Hint Health", "Hint Health logo");
        }
        return Jk(k([
            n5
        ]));
    }), tgr = F2(function(n, r) {
        return A2(Jhr, k([
            Nk("header")
        ]), k([
            A2(Ik, k([
                Nk("header__container app-container")
            ]), k([
                A2(rgr, n, r)
            ]))
        ]));
    }), egr = F5(function(n, r, t, e, u) {
        var a = 3 === r.$ ? $k(r.a) : "", i = 3 === t.$ && Dhr(t.a);
        return k([
            A2(Ik, k([
                Nk("layout layout--app")
            ]), k([
                A2(Shr, n, r),
                A2(tgr, r, t),
                A2(Ik, k([
                    Nk("main main--app")
                ]), k([
                    A2(Ik, k([
                        Nk("app-container my-8")
                    ]), u)
                ])),
                A3(Zhr, n, k([
                    1
                ]), k([
                    i ? _hr : A2(yhr, a, "member_app_portal")
                ]))
            ]))
        ]);
    }), ugr = {
        $: 5
    }, agr = F5(function(n, r, t, e, u) {
        var a = ac(t);
        return omr(a) ? A2(Jhr, k([
            Nk("header bg-primary-100 border-b-0")
        ]), k([
            A2(Ik, k([
                Nk("header__container app-container md:px-12")
            ]), k([
                A2(lV, k([
                    dV(NZ)
                ]), k([
                    A2(iV, k([
                        UZ(3)
                    ]), h),
                    A2(iV, k([
                        UZ(6)
                    ]), k([
                        A2(Ik, k([
                            Nk("flex justify-center")
                        ]), k([
                            A2(rgr, n, r)
                        ]))
                    ]))
                ]))
            ]))
        ])) : A2(Jhr, k([
            Nk(1 === u ? "header header--app h-24 flex justify-center" : "header flex justify-center")
        ]), k([
            A2(Ik, k([
                Nk("booking-navbar")
            ]), k([
                e
            ]))
        ]));
    }), igr = F8(function(n, r, t, e, u, a, i, c) {
        var o = 3 === t.$ ? $k(t.a) : "", f = 3 === e.$ && Dhr(e.a);
        return k([
            A2(Ik, k([
                Nk("layout")
            ]), k([
                A2(Shr, n, t),
                A5(agr, t, e, u, i, c),
                A2(Ik, k([
                    Nk("main main--app")
                ]), k([
                    A2(Ik, k([
                        Nk("app-container my-4 md:my-8 px-6 md:px-12")
                    ]), a)
                ])),
                A3(Zhr, n, k([
                    1
                ]), k([
                    Chr(k([
                        f ? _hr : A2(yhr, o, "member_app_portal"),
                        f ? _hr : ugr,
                        1 === c ? Bhr(r) : qhr(r)
                    ]))
                ]))
            ]))
        ]);
    }), cgr = F2(function(n, r) {
        return ED(A2(Tc, function(n) {
            return A2(pu, Np(k([
                n,
                "="
            ])), r);
        }, n));
    }), ogr = F2(function(n, r) {
        return A2(Ep, rcr, A2(Tc, cgr(n), A2(ae, "&", r)));
    }), fgr = function(n) {
        return YV(ac(n));
    }, sgr = function(n) {
        switch(n.$){
            case 88:
                return pa({
                    mp: n.a.mp,
                    mY: n.a.mY
                });
            case 87:
                return ma({
                    mp: n.a.mp,
                    mY: n.a.mY
                });
            default:
                return va;
        }
    }, lgr = F5(function(n, r, t, e, u) {
        var a = ac(t);
        if (YV(a)) {
            var i = A2(uc, h, A2(Cp, ogr(k([
                "practice"
            ])), t.iu));
            return A2(Jhr, k([
                Nk("header bg-primary-100 border-b-0")
            ]), k([
                A2(Ik, k([
                    Nk("header__container app-container md:px-12")
                ]), k([
                    A2(lV, k([
                        dV(NZ)
                    ]), k([
                        A2(iV, k([
                            UZ(3)
                        ]), h),
                        A2(iV, k([
                            UZ(6)
                        ]), k([
                            A2(Ik, k([
                                Nk("flex justify-center")
                            ]), k([
                                A2(rgr, n, r)
                            ]))
                        ])),
                        A2(iV, k([
                            UZ(3)
                        ]), k([
                            A2(Ik, k([
                                Nk("flex justify-end items-center h-full mr-1"),
                                rz(k([
                                    b("hidden", !fgr(t))
                                ]))
                            ]), k([
                                A2(gV, k([
                                    vV(A2(QV, k([
                                        Sx(sgr(a))
                                    ]), i)),
                                    DV
                                ]), k([
                                    ad("Sign In")
                                ]))
                            ]))
                        ]))
                    ]))
                ]))
            ]));
        }
        return A2(Jhr, k([
            Nk(1 === u ? "header header--app h-24 flex justify-center" : "header flex justify-center")
        ]), k([
            A2(Ik, k([
                Nk("booking-navbar")
            ]), k([
                e
            ]))
        ]));
    }), dgr = F8(function(n, r, t, e, u, a, i, c) {
        var o = 3 === t.$ ? $k(t.a) : "", f = 3 === e.$ && Dhr(e.a);
        return k([
            A2(Ik, k([
                Nk("layout")
            ]), k([
                A2(Shr, n, t),
                A5(lgr, t, e, u, i, c),
                A2(Ik, k([
                    Nk("main main--app")
                ]), k([
                    A2(Ik, k([
                        Nk("app-container my-4 md:my-8 px-6 md:px-12")
                    ]), a)
                ])),
                A3(Zhr, n, k([
                    1
                ]), k([
                    Chr(k([
                        f ? _hr : A2(yhr, o, "member_app_portal"),
                        f ? _hr : ugr,
                        1 === c ? Bhr(r) : qhr(r)
                    ]))
                ]))
            ]))
        ]);
    }), bgr = {
        $: 0
    }, vgr = function(n) {
        return {
            $: 2,
            a: n
        };
    }, mgr = F6(function(n, r, t, e, u, a) {
        var i, c = 1 === a ? "layout bg-white" : "layout layout--app", o = 3 === t.$ && Dhr(t.a);
        return k([
            A2(Ik, k([
                Nk(c)
            ]), k([
                A2(Shr, n, u),
                A2(Ik, k([
                    Nk("main main--app")
                ]), k([
                    A2(Ik, k([
                        Nk("app-container my-8")
                    ]), e)
                ])),
                A3(Zhr, n, k([
                    1
                ]), k([
                    1 === a ? _hr : 3 === u.$ ? vgr(u.a) : _hr,
                    bgr,
                    Chr(k([
                        (i = b(u, o), 3 !== i.a.$ || i.b ? _hr : A2(yhr, $k(i.a.a), "member_app_portal")),
                        1 === a ? Bhr(r) : qhr(r)
                    ]))
                ]))
            ]))
        ]);
    }), pgr = F2(function(n, r) {
        return A2(lz, k([
            Qk(k([
                Nk(1 === r ? "header header--app h-24" : "header h-24")
            ]))
        ]), k([
            A2(lz, k([
                Qk(k([
                    Nk("header__container app-container app-account-container")
                ])),
                Qk(cx(_1))
            ]), k([
                n
            ]))
        ]));
    }), $gr = F7(function(n, r, t, e, u, a, i) {
        var c = 3 === r.$ ? $k(r.a) : "", o = 3 === t.$ && Dhr(t.a);
        return k([
            A2(lz, k([
                Qk(k([
                    Nk("layout layout--app")
                ]))
            ]), k([
                A2(Shr, n, r),
                A2(pgr, a, i),
                A2(lz, k([
                    Qk(k([
                        Nk("main main--app")
                    ]))
                ]), k([
                    A2(lz, k([
                        Qk(k([
                            Nk("app-container app-account-container md:my-8 mt-4")
                        ]))
                    ]), u)
                ])),
                A2(lz, k([
                    Qk(k([
                        Nk("hidden md:block")
                    ]))
                ]), k([
                    A3(Zhr, n, k([
                        1
                    ]), k([
                        o ? _hr : A2(yhr, c, "member_app_portal")
                    ]))
                ]))
            ]))
        ]);
    }), hgr = F3(function(n, r, t) {
        var e = zKn(r);
        return A2(zD, function(r) {
            return i(A2($Zn, r.a, n), t);
        }, e);
    }), ggr = F3(function(n, r, t) {
        return A3(hgr, n, r, ac(t));
    }), wgr = F3(function(n, r, t) {
        return A2(Cp, function(n) {
            return n.b;
        }, A3(ggr, n, r, t));
    }), kgr = function(n) {
        return A2(Ik, k([
            Nk("signup__body")
        ]), k([
            A2(Ik, k([
                Nk("signup__page-border")
            ]), h),
            A2(Ik, k([
                Nk("signup__page-center")
            ]), n),
            A2(Ik, k([
                Nk("signup__page-border")
            ]), h)
        ]));
    }, xgr = F5(function(n, r, t, e, u) {
        var a = v(t, e, u);
        if (3 === a.a.$ && 3 === a.b.$ && 3 === a.c.$) {
            var i = a.c.a, c = $k(a.a.a), o = Dhr(i);
            return A2(Ik, h, k([
                A3(Zhr, n, k([
                    1
                ]), k([
                    Chr(k([
                        o ? _hr : A2(yhr, c, "member_app_signup"),
                        o ? _hr : ugr,
                        qhr(r)
                    ])),
                    bgr
                ]))
            ]));
        }
        return Sq;
    }), ygr = F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    }), _gr = F2(function(n, r) {
        return A2(ygr, n, r);
    }), Cgr = F4(function(n, r, t, e) {
        var u = CKn(e), a = yKn(e), i = A2(QV, k([
            Sx(A2($Zn, a, r))
        ]), t), c = KQn(r), o = SKn(a) && !dZn(a);
        return A2(_gr, {
            yR: o,
            kn: u,
            rr: A3(BKn, c, n, a)
        }, i);
    }), Dgr = F3(function(n, r, t) {
        return A3(aMn, {
            aU: n.aU,
            a2: n.a2
        }, vF(r), t);
    }), Agr = F2(function(n, r) {
        if (ED(r)) return Sq;
        if (n.$) return Sq;
        var t = n.a;
        return A2(Ik, k([
            Nk("stepper")
        ]), A2(yu, function(n) {
            var e = n.a, u = n.b;
            return A3(Dgr, {
                aU: t,
                a2: oe(r)
            }, u, e);
        }, r));
    }), qgr = F5(function(n, r, t, e, u) {
        var a = zKn(t), i = b(oe(a) > 0, YS(e));
        if (i.a && i.b) {
            var c = GIn(r);
            return A2(Agr, e, A2(yu, A3(Cgr, n, c, u), a));
        }
        return Sq;
    }), Bgr = F8(function(n, r, t, e, u, a, i, c) {
        if (3 === e.$) {
            var o = e.a;
            return A2(Jhr, k([
                Nk("header")
            ]), k([
                A2(Ik, k([
                    Nk("header__container")
                ]), k([
                    A2(Ik, k([
                        Nk("signup__page-border")
                    ]), h),
                    A2(Ik, k([
                        Nk("signup__page-center")
                    ]), k([
                        A2(Ik, k([
                            Nk("flex items-center flex-wrap w-full")
                        ]), k([
                            A2(Ik, k([
                                Nk("flex flex-shrink-0 mr-2 md:mr-8")
                            ]), k([
                                A2(rgr, r, t)
                            ])),
                            A2(Ik, k([
                                Nk("flex justify-self-end overflow-hidden")
                            ]), k([
                                A5(qgr, n, o, u, a, tcr(i))
                            ]))
                        ]))
                    ])),
                    A2(Ik, k([
                        Nk("signup__page-border")
                    ]), h)
                ])),
                function() {
                    if (c.$) return Sq;
                    var n = c.a;
                    return A2(Ik, k([
                        Nk("header__container header__container--shaded")
                    ]), k([
                        A2(Ik, k([
                            Nk("signup__page-border")
                        ]), h),
                        A2(Ik, k([
                            Nk("signup__page-center")
                        ]), k([
                            n
                        ])),
                        A2(Ik, k([
                            Nk("signup__page-border")
                        ]), h)
                    ]));
                }()
            ]));
        }
        return Sq;
    }), jgr = F9(function(n, r, t, e, u, a, i, c, o) {
        var f = ED(a) ? Rt : 3 === u.$ ? A3(wgr, GIn(u.a), a, i) : Rt;
        return k([
            A2(Ik, k([
                Nk("layout"),
                rz(k([
                    b("signup--thanks", $H(f))
                ]))
            ]), k([
                A2(Shr, n, t),
                A8(Bgr, n, t, e, u, a, f, i, c),
                A2(Ik, k([
                    Nk("main main--signup")
                ]), k([
                    kgr(o)
                ])),
                A5(xgr, n, r, t, u, e)
            ]))
        ]);
    }), Sgr = function(n) {
        return A2(zZ, 4, n);
    }, zgr = F2(function(n, r) {
        return 1 === n.$ ? r : r + ":" + ee(n.a);
    }), Ugr = F3(function(n, r, t) {
        return 1 === r.$ ? t : $(t, $(n, r.a));
    }), Egr = function(n) {
        return A3(Ugr, "#", n.zu, A3(Ugr, "?", n.iu, $(A2(zgr, n.uc, $(n.uD ? "https://" : "http://", n.zG)), n.BJ)));
    }, Pgr = function(n) {
        return A2(Ik, k([
            Nk("flex items-center")
        ]), k([
            A2(fU, k([
                Nk("input-color"),
                RU(n),
                dz("color")
            ]), h)
        ]));
    }, Tgr = function(n) {
        return A2(Jhr, k([
            Nk("header")
        ]), k([
            A2(Ik, k([
                Nk("header__container justify-between px-6")
            ]), k([
                A2(fF, k([
                    vF(Sx(Oi))
                ]), k([
                    ad("Hint Legos")
                ])),
                Pgr(n)
            ]))
        ]));
    }, Fgr = F2(function(n, r) {
        var t = r.b, e = Sx(r.a);
        return A2(fF, k([
            Nk("menu__item"),
            rz(k([
                b("menu__item--active", A2(uu, e, n))
            ])),
            vF(e)
        ]), k([
            ad(t)
        ]));
    }), Lgr = F3(function(n, r, t) {
        var e = n.Dk;
        return k([
            A2(Ik, k([
                Nk("layout")
            ]), k([
                Tgr(e),
                A2(Ik, k([
                    Nk("main")
                ]), k([
                    A2(lV, k([
                        jV(k([
                            Nk("mx-0")
                        ]))
                    ]), k([
                        A2(iV, k([
                            UZ(12),
                            GZ(4),
                            Oun(3),
                            Sgr(2)
                        ]), k([
                            A2(Ik, k([
                                Nk("menu")
                            ]), A2(yu, Fgr(Egr(r)), k([
                                b(Oi, "Typography"),
                                b(Ai, "Grid"),
                                b(xi, "Button"),
                                b(_i, "Checkbox"),
                                b(Ui, "Radio"),
                                b(Pi, "Select"),
                                b(Ei, "Searchable Select"),
                                b(qi, "Input"),
                                b(Li, "Tag"),
                                b(wi, "Alerts"),
                                b(Hi, "Tooltip"),
                                b(Ti, "Table"),
                                b(Fi, "Tabs"),
                                b(hi, "Activity Indicator"),
                                b(ji, "Modal"),
                                b(ki, "Api Select"),
                                b(Di, "Form Example"),
                                b(yi, "Card Example"),
                                b(Ci, "Filter Example"),
                                b(zi, "Phone Input"),
                                b(gi, "Address Input"),
                                b(Bi, "Insurance Info")
                            ])))
                        ])),
                        A2(iV, k([
                            UZ(12),
                            GZ(8),
                            Oun(9),
                            Sgr(10)
                        ]), k([
                            A2(Ik, k([
                                Nk("pt-2 px-6")
                            ]), t)
                        ]))
                    ]))
                ]))
            ]))
        ]);
    }), Mgr = {
        $: 9
    }, Hgr = {
        $: 1
    }, Rgr = F3(function(n, r, t) {
        var e = b(n, r);
        n: for(;;){
            r: for(;;)switch(e.a.$){
                case 3:
                    switch(e.b.$){
                        case 3:
                            var u = e.a.a, a = e.b.a;
                            return A4(Qhr, t, ngr(a), hk(u), Khr(a));
                        case 1:
                            break n;
                        default:
                            break r;
                    }
                case 1:
                    return Jk(k([
                        n5
                    ]));
                default:
                    if (1 === e.b.$) break n;
                    break r;
            }
            return A4(Qhr, t, Ht("https://cdn2.hubspot.net/hubfs/2562809/production-app/web/logo-mark.svg"), "Hint Health", "Hint Health logo");
        }
        return Jk(k([
            n5
        ]));
    }), Ogr = {
        $: 2
    }, Ngr = function(n) {
        return n.vR;
    }, Igr = function(n) {
        return A2(lz, k([
            Qk(k([
                Nk("column")
            ])),
            Qk(cx(Nun))
        ]), k([
            A2(fz, k([
                CU,
                QS(Ogr)
            ]), k([
                ad(n(Ngr))
            ]))
        ]));
    }, Vgr = {
        $: 1
    }, Wgr = F3(function(n, r, t) {
        return r ? A2(fF, k([
            vF(""),
            Nk("account-menu__item"),
            Eq(Vgr)
        ]), k([
            ad(n(t ? cd : od))
        ])) : Sq;
    }), Zgr = function(n) {
        return b(O$r(n), n);
    }, Xgr = function(n) {
        return A2(dA, "self_buy", n);
    }, Ggr = function(n) {
        var r = Aan(n) || qan(n) ? k([
            0,
            1,
            2,
            3,
            4
        ]) : k([
            0,
            1,
            2,
            4
        ]);
        return A3(uU, Xgr(n), 5, r);
    }, Jgr = F3(function(n, r, t) {
        var e, u;
        return A2(yu, Zgr, (e = Ggr(t), u = n ? A2(Ot, 7, e) : e, r ? A2(Ot, 8, u) : u));
    }), Ygr = F2(function(n, r) {
        return 2 === r ? Jxn(n) ? Vd.Dq : Vd.wD : Db(r);
    }), Qgr = F4(function(n, r, t, e) {
        var u = e.a, a = e.b;
        return A2(fF, k([
            Nk("account-menu__item"),
            rz(k([
                b("account-menu__item--active", i(t, Ht(a)))
            ])),
            vF(Sx(u))
        ]), k([
            ad(n(A2(Ygr, r, a)))
        ]));
    }), Kgr = F5(function(n, r, t, e, u) {
        return A2(yu, A3(Qgr, n, u, e), A3(Jgr, r, t, u));
    }), nwr = F2(function(n, r) {
        var t = r.bJ, e = r.r6, u = r.iD, a = r.dF, i = r.dw;
        return A2(lz, k([
            Qk(k([
                Nk("sidebar")
            ]))
        ]), k([
            A2(lz, k([
                Qk(k([
                    Nk("sidebar__burger"),
                    dE(0)
                ]))
            ]), h),
            A2(PB, h, h),
            A2(PB, h, h),
            A2(PB, h, h),
            A2(lz, k([
                Qk(k([
                    Nk("sidebar__links")
                ]))
            ]), A2(Xi, A5(Kgr, n, t, e, u, i), k([
                A3(Wgr, n, a, !1)
            ])))
        ]));
    }), rwr = {
        $: 1
    }, twr = function(n) {
        return {
            $: 0,
            a: n
        };
    }, ewr = F2(function(n, r) {
        var t = A2(uc, n, r);
        return au(t) > 0 ? Ht(lv(A2(su, 1, t))) : Rt;
    }), uwr = function(n) {
        return A2(ue, "", A2(Ep, ru, k([
            A2(ewr, jvn(n), Cvn(n)),
            A2(ewr, Pvn(n), Dvn(n))
        ])));
    }, awr = function(n) {
        return function(n) {
            return {
                $: 7,
                a: n
            };
        }(n);
    }, iwr = Ltn(eU(1)), cwr = function(n) {
        return function(n) {
            return {
                $: 9,
                a: n
            };
        }(n);
    }, owr = function(n) {
        return function(n) {
            return {
                $: 10,
                a: n
            };
        }(n);
    }, fwr = bkn(2), swr = F3(function(n, r, t) {
        if (r.bJ) {
            var e = k([
                twr(1),
                twr(2)
            ]), u = Aan(r.dw) || qan(r.dw), a = A2(yu, function(n) {
                return A2(Xz, h, n);
            }, A3(uU, r.dF, rwr, A3(uU, r.r6, twr(8), A3(uU, Xgr(r.dw), twr(5), $(A3(uU, u, twr(3), e), k([
                twr(4)
            ]))))));
            return k([
                A2(lz, k([
                    Qk(k([
                        Nk("hidden md:inline-flex")
                    ]))
                ]), k([
                    A2(px, R$r, A4(AU, n, k([
                        iwr,
                        ZL(uwr(r.tE)),
                        fwr,
                        awr(!1)
                    ]), a, t.dC))
                ])),
                A2(px, hu, A2(fz, k([
                    _U,
                    yU,
                    cwr(2),
                    owr(2)
                ]), k([
                    ad(uwr(r.tE))
                ])))
            ]);
        }
        return k([
            Sq
        ]);
    }), lwr = F3(function(n, r, t) {
        return n ? A2(yu, Zgr, k([
            7,
            0
        ])) : A3(Jgr, !1, r, t);
    }), dwr = F5(function(n, r, t, e, u) {
        return A2(yu, A3(Qgr, n, u, e), A3(lwr, r, t, u));
    }), bwr = F3(function(n, r, t) {
        return A2(lz, k([
            Qk(k([
                Nk("flex w-full gap-4")
            ])),
            Qk(cx(kz)),
            Qk(r.bJ ? cx(yz) : h)
        ]), k([
            A2(lz, k([
                Qk(k([
                    Nk("flex")
                ]))
            ]), k([
                A2(px, hu, r.ir)
            ])),
            A2(lz, k([
                Qk(k([
                    Nk("flex-grow hidden md:flex h-full gap-4")
                ])),
                Qk(cx(yz))
            ]), A3(uU, !r.bJ, A3(Wgr, n, r.dF, !1), A5(dwr, n, r.bJ, r.r6, r.iD, r.dw))),
            A2(lz, k([
                Qk(k([
                    Nk("flex absolute left-6 md:relative md:left-0")
                ]))
            ]), A3(swr, n, r, t))
        ]));
    }), vwr = F4(function(n, r, t, e) {
        var u, a = Aan(e) || qan(e);
        return A3(uU, t, rwr, A3(uU, Xgr(e), twr(5), (u = A3(uU, a, twr(3), $(A3(uU, r, twr(9), n ? k([
            twr(8)
        ]) : h), k([
            twr(7),
            twr(0),
            twr(1),
            twr(2)
        ]))), $(u, k([
            twr(4)
        ])))));
    }), mwr = F3(function(n, r, t) {
        if (r.bJ) {
            var e = A2(yu, function(n) {
                return A2(Xz, h, n);
            }, A4(vwr, r.r6, r.jX, r.dF, r.dw));
            return k([
                A2(lz, k([
                    Qk(k([
                        Nk("hidden md:inline-flex")
                    ]))
                ]), k([
                    A2(px, R$r, A4(AU, n, k([
                        iwr,
                        ZL(uwr(r.tE)),
                        fwr,
                        awr(!1)
                    ]), e, t.dC))
                ])),
                A2(px, hu, A2(fz, k([
                    _U,
                    yU,
                    cwr(2),
                    owr(2),
                    vz(k([
                        Nk("navbar-app__avatar")
                    ]))
                ]), k([
                    ad(uwr(r.tE))
                ])))
            ]);
        }
        return k([
            Sq
        ]);
    }), pwr = {
        $: 4
    }, $wr = {
        $: 3
    }, hwr = function(n) {
        return n.nt;
    }, gwr = function(n) {
        return n.tl;
    }, wwr = F4(function(n, r, t, e) {
        var u = r ? k([
            8
        ]) : h, a = t ? $(u, k([
            9
        ])) : u, i = n ? $(a, k([
            7
        ])) : a;
        return A2(yu, Zgr, $(i, Ggr(e)));
    }), kwr = F2(function(n, r) {
        return r ? A2(fF, k([
            vF(""),
            Nk("sidebar__link sidebar__link--logout"),
            Eq(Vgr)
        ]), k([
            ad(n(cd))
        ])) : Sq;
    }), xwr = F4(function(n, r, t, e) {
        var u = e.a, a = e.b;
        return A2(fF, k([
            Nk("sidebar__link"),
            rz(k([
                b("sidebar__link--active", i(t, Ht(a)))
            ])),
            vF(Sx(u)),
            Eq(pwr)
        ]), k([
            ad(n(A2(Ygr, r, a)))
        ]));
    }), ywr = F3(function(n, r, t) {
        var e = r.iD, u = r.dF, a = r.dw, i = A4(wwr, r.bJ, r.r6, r.jX, a), c = A2(yu, A3(xwr, n, a, e), i), o = A2(kwr, n, u);
        return A2(lz, k([
            Qk(k([
                Nk("sidebar sidebar--polish")
            ]))
        ]), k([
            A2(jq, k([
                dz("button"),
                jz("sidebar-polish-open"),
                Nk("sidebar__polish-open"),
                Eq($wr),
                A2(Wx, "aria-label", n(gwr)),
                A2(Wx, "aria-expanded", t.bY ? "true" : "false")
            ]), k([
                A2(Gk, k([
                    Nk("sidebar__polish-dehaze")
                ]), k([
                    A2(Gk, k([
                        Nk("sidebar__polish-dehaze-bar")
                    ]), h),
                    A2(Gk, k([
                        Nk("sidebar__polish-dehaze-bar")
                    ]), h),
                    A2(Gk, k([
                        Nk("sidebar__polish-dehaze-bar")
                    ]), h)
                ]))
            ])),
            A2(Ik, A2(Ot, rz(k([
                b("sidebar__polish-layer", !0),
                b("sidebar__polish-layer--is-open", t.bY)
            ])), A2(Ot, A2(Wx, "aria-hidden", t.bY ? "false" : "true"), k(t.bY ? [
                A2(Uq, "keydown", cD(rm(pwr)))
            ] : [
                A2(Wx, "inert", "")
            ]))), k([
                A2(Ik, k([
                    Nk("sidebar__polish-scrim"),
                    Eq(pwr)
                ]), h),
                A2(Ik, k([
                    Nk("sidebar__polish-panel"),
                    A2(Wx, "role", "dialog"),
                    A2(Wx, "aria-modal", "true")
                ]), k([
                    A2(jq, k([
                        dz("button"),
                        jz("sidebar-polish-close"),
                        Nk("sidebar__polish-close"),
                        Eq(pwr),
                        A2(Wx, "aria-label", n(hwr))
                    ]), k([
                        A2(US, k([
                            SB
                        ]), 2)
                    ])),
                    A2(Ik, k([
                        Nk("sidebar__polish-links")
                    ]), A2(Xi, c, k([
                        o
                    ])))
                ]))
            ]))
        ]));
    }), _wr = F3(function(n, r, t) {
        return A2(lz, k([
            Qk(k([
                Nk("navbar-app__top")
            ])),
            Qk(cx(kz))
        ]), k([
            A2(lz, k([
                Qk(k([
                    Nk("navbar-app__start")
                ]))
            ]), k([
                A2(lz, k([
                    Qk(k([
                        Nk("navbar-app__burger")
                    ]))
                ]), k([
                    A3(ywr, n, r, t)
                ]))
            ])),
            A2(lz, k([
                Qk(k([
                    Nk("navbar-app__logo min-w-0")
                ]))
            ]), k([
                A2(px, hu, r.ir)
            ])),
            A2(lz, k([
                Qk(k([
                    Nk("navbar-app__end")
                ]))
            ]), k([
                A2(lz, k([
                    Qk(k([
                        Nk("navbar-app__profile")
                    ]))
                ]), A3(mwr, n, r, t))
            ]))
        ]));
    }), Cwr = F3(function(n, r, t) {
        return r.rP ? A2(lz, k([
            Qk(k([
                Nk("flex w-full items-center justify-between gap-4")
            ]))
        ]), k([
            A2(lz, k([
                Qk(k([
                    Nk("flex")
                ]))
            ]), k([
                A2(px, hu, r.ir)
            ])),
            Igr(n)
        ])) : r.tM ? A2(lz, k([
            Qk(k([
                Nk("navbar-app w-full")
            ]))
        ]), k([
            A3(_wr, n, r, t)
        ])) : A2(lz, k([
            Qk(k([
                Nk("flex w-full")
            ]))
        ]), k([
            A3(bwr, n, r, t),
            A2(nwr, n, r)
        ]));
    }), Dwr = F2(function(n, r) {
        var t, e = b(r.dw, r.tL);
        if (3 === e.a.$ && 3 === e.b.$) {
            var u = e.a.a, a = e.b.a, i = P7(r.gx) || !A2(Gxn, 0, u), c = yVn(u) && FX(u) && _Vn(u), o = i ? Rt : Ht(Sx(c ? Wa : r.bJ ? ka : ya)), f = 3 === (t = r.ee).$ && !ED($L(t.a));
            return A2(px, n, A2(px, Nmr, A3(Cwr, Rk(r.kj), {
                jX: f,
                bJ: r.bJ,
                rP: i,
                r6: A2(k$r, r.uh, u),
                tE: a,
                tM: _Vn(u),
                dw: u,
                ir: A3(Rgr, r.dw, r.an, o),
                dF: !0,
                iD: r.xE
            }, r.dr)));
        }
        return Sq;
    }), Awr = F2(function(n, r) {
        return A2(Cp, function(t) {
            return A2(px, n, A2(px, Vmr(!0), A2(TP, t, r.dU)));
        }, r.dV);
    }), qwr = F4(function(n, r, t, e) {
        var u, a, i = Rk(t.kj), c = 3 === (u = t.dw).$ && _Vn(u.a) ? 1 : 0, o = A2(px, n, function(n) {
            var r = n.dw, t = n.kj, e = n.cA;
            return 3 === r.$ && pjn(r.a) ? A2(lz, k([
                Qk(k([
                    Nk("w-40 flex")
                ])),
                Qk(cx(kz))
            ]), k([
                A2(PB, k([
                    C1,
                    Qk(k([
                        Nk("mr-2")
                    ]))
                ]), k([
                    A2(US, k([
                        Sz
                    ]), 28)
                ])),
                A2(Gk, k([
                    Nk("flex-1")
                ]), k([
                    A2(px, Rmr, A3(mkn, Rk(t), k([
                        Hgr
                    ]), e))
                ]))
            ])) : Sq;
        }(t));
        switch(r){
            case 0:
                var f = A2(Awr, n, t), s = 3 === (a = t.CX).$ ? a.a : h;
                return A2(Ot, A2(px, n, t.g7 ? A2(lz, k([
                    Qk(k([
                        Nk("debug__box")
                    ]))
                ]), k([
                    A2(lz, k([
                        Qk(k([
                            Nk("alert alert--success")
                        ]))
                    ]), k([
                        A2(PB, k([
                            Qk(k([
                                Nk("debug__text")
                            ]))
                        ]), k([
                            ad("Debug mode")
                        ])),
                        A2(fz, k([
                            QS(Mgr)
                        ]), k([
                            A2(US, h, 2)
                        ]))
                    ]))
                ])) : Sq), A9(jgr, i, o, t.dw, t.an, t.fF, s, t.w_, f, e));
            case 1:
                return A3(Lgr, {
                    Dk: A2(sc, n, khr)
                }, t.w_, e);
            case 4:
                return A8(dgr, i, o, t.dw, t.an, t.w_, e, l = A2(Dwr, n, t), c);
            case 5:
                return A8(igr, i, o, t.dw, t.an, t.w_, e, l = A2(Dwr, n, t), c);
            case 3:
                var l = A2(Dwr, n, t);
                return (function(n) {
                    return function(r) {
                        return function(t) {
                            return function(e) {
                                return function(u) {
                                    return function(a) {
                                        return function(i) {
                                            return function(c) {
                                                return function(o) {
                                                    return function(f) {
                                                        var s = 3 === t.$ ? $k(t.a) : "", l = a.$ ? "" : 2 === a.a ? 3 === t.$ && Jxn(t.a) ? n(Vd.Dq) : n(Vd.wD) : n(Db(a.a)), d = 3 === e.$ && Dhr(e.a);
                                                        return k([
                                                            A2(Ik, k([
                                                                Nk(A2(ue, " ", k([
                                                                    "layout layout--app",
                                                                    a.$ || 7 !== a.a ? "" : "layout--healthInformation"
                                                                ])))
                                                            ]), k([
                                                                A2(Shr, n, t),
                                                                A3(Yhr, t, o, f),
                                                                A2(Ik, k([
                                                                    Nk("main main--app")
                                                                ]), k([
                                                                    A2(Ik, k([
                                                                        Nk(1 === f ? "app-container app-account-container mt-0 px-4 md:my-8 md:mt-8 md:px-0" : "app-container app-account-container md:my-8 mt-4")
                                                                    ]), k(1 === f ? [
                                                                        A2(Ik, k([
                                                                            Nk("account-page__title-band py-4 text-center md:py-6")
                                                                        ]), 3 === u.$ ? k([
                                                                            A2(XT, k([
                                                                                Qk(k([
                                                                                    Nk("text-2xl")
                                                                                ]))
                                                                            ]), k([
                                                                                ad(l)
                                                                            ]))
                                                                        ]) : h),
                                                                        A2(Ik, k([
                                                                            Nk("account-page__content rounded bg-white p-4 shadow-sm md:p-8")
                                                                        ]), c)
                                                                    ] : 3 === u.$ ? [
                                                                        A2(Ik, k([
                                                                            Nk("text-center mb-6")
                                                                        ]), k([
                                                                            A2(XT, h, k([
                                                                                ad(l)
                                                                            ]))
                                                                        ])),
                                                                        A2(Ik, h, c)
                                                                    ] : [
                                                                        A2(Ik, k([
                                                                            Nk("text-center")
                                                                        ]), c)
                                                                    ])),
                                                                    A2(Ghr, t, i)
                                                                ])),
                                                                A3(Zhr, n, k([
                                                                    1
                                                                ]), k([
                                                                    Chr(k([
                                                                        d ? _hr : A2(yhr, s, "member_app_portal"),
                                                                        1 === f ? Bhr(r) : qhr(r)
                                                                    ]))
                                                                ]))
                                                            ]))
                                                        ]);
                                                    };
                                                };
                                            };
                                        };
                                    };
                                };
                            };
                        };
                    };
                })(i)(o)(t.dw)(t.an)(t.tE)(t.xE)(t.ee)(e)(l)(c);
            case 6:
                return A7($gr, i, t.dw, t.an, t.tE, e, l = A2(Dwr, n, t), c);
            case 7:
                return A5(egr, i, t.dw, t.an, t.w_, e);
            default:
                return A6(mgr, i, o, t.an, e, t.dw, c);
        }
    }), Bwr = F2(function(n, r) {
        var t = n.a3, e = n.eP, u = n.Ds;
        return {
            gF: $(A2(Ot, A2(px, u, whr(r.cg)), A4(qwr, u, e, r, t.gF)), h),
            wD: t.wD
        };
    });
    xG = {
        Main: {
            init: Pu({
                zO: function(n) {
                    var r = mmr(n.rJ), t = r.a, e = r.b, u = A2(L$, n, t), a = u.a, i = u.b, c = ac(t), o = A2(umr, c, a), f = o.a, s = o.b, l = lmr(c);
                    return b(A3(Fu, a, f, l), Hu(k([
                        A2(jp, Mu, i),
                        A2(jp, Lu, s),
                        e
                    ])));
                },
                Dd: function(n) {
                    return xk(k([
                        mYn(pmr),
                        A2(xD, Mu, xk(k([
                            HM(kmr),
                            Bmr(ymr),
                            OM(xmr),
                            Amr(function() {
                                return $mr;
                            }),
                            qmr(wmr),
                            A2(_G, 1e3, hmr),
                            mYn(Cmr),
                            sXn(gmr),
                            cXn(_mr)
                        ]))),
                        A2(xD, Lu, Smr(n.a3))
                    ]));
                },
                DB: phr,
                DH: A2(Je, function(n) {
                    return A2(Bwr, {
                        eP: n.eP,
                        a3: A2(nmr, Lu, mhr(n.a3)),
                        Ds: Mu
                    }, n.CJ);
                }, zmr)
            })(A2(Ge, function(n) {
                return A2(Ge, function(r) {
                    return A2(Ge, function(t) {
                        return A2(Ge, function(e) {
                            return A2(Ge, function(u) {
                                return A2(Ge, function(a) {
                                    return A2(Ge, function(i) {
                                        return A2(Ge, function(c) {
                                            return A2(Ge, function(o) {
                                                return A2(Ge, function(f) {
                                                    return A2(Ge, function(s) {
                                                        return A2(Ge, function(l) {
                                                            return A2(Ge, function(d) {
                                                                return A2(Ge, function(b) {
                                                                    return A2(Ge, function(v) {
                                                                        return A2(Ge, function(m) {
                                                                            return Ke({
                                                                                xD: m,
                                                                                i: v,
                                                                                xT: b,
                                                                                a8: d,
                                                                                bG: l,
                                                                                bf: s,
                                                                                y0: f,
                                                                                y1: o,
                                                                                y2: c,
                                                                                y3: i,
                                                                                y4: a,
                                                                                y5: u,
                                                                                zE: e,
                                                                                z6: t,
                                                                                rJ: r,
                                                                                Cf: n
                                                                            });
                                                                        }, A2(Tu, "accountPracticeId", D$(k([
                                                                            Dy(Rt),
                                                                            A2(Ye, Ht, w$)
                                                                        ]))));
                                                                    }, A2(Tu, "accountToken", D$(k([
                                                                        Dy(Rt),
                                                                        A2(Ye, Ht, w$)
                                                                    ]))));
                                                                }, A2(Tu, "apiUrl", w$));
                                                            }, A2(Tu, "apiVersion", D$(k([
                                                                Dy(Rt),
                                                                A2(Ye, Ht, w$)
                                                            ]))));
                                                        }, A2(Tu, "bustCacheRandom", w$));
                                                    }, A2(Tu, "currentTime", C$));
                                                }, A2(Tu, "emrCalendarsUrl", w$));
                                            }, A2(Tu, "emrCalendarsVersion", D$(k([
                                                Dy(Rt),
                                                A2(Ye, Ht, w$)
                                            ]))));
                                        }, A2(Tu, "emrMessagingUrl", w$));
                                    }, A2(Tu, "emrMessagingVersion", D$(k([
                                        Dy(Rt),
                                        A2(Ye, Ht, w$)
                                    ]))));
                                }, A2(Tu, "emrNotesUrl", w$));
                            }, A2(Tu, "emrNotesVersion", D$(k([
                                Dy(Rt),
                                A2(Ye, Ht, w$)
                            ]))));
                        }, A2(Tu, "hintEnv", D$(k([
                            Dy(Rt),
                            A2(Ye, Ht, w$)
                        ]))));
                    }, A2(Tu, "language", w$));
                }, A2(Tu, "locationHref", w$));
            }, A2(Tu, "release", D$(k([
                Dy(Rt),
                A2(Ye, Ht, w$)
            ])))))(0)
        }
    }, n.Elm ? function n(r, t) {
        for(var e in t)e in r ? "init" == e ? a(6) : n(r[e], t[e]) : r[e] = t[e];
    }(n.Elm, xG) : n.Elm = xG;
}($b9e750d20bbc1f0f$exports);




/**
 * @licstart The following is the entire license notice for the
 * JavaScript code in this page
 *
 * Copyright 2024 Mozilla Foundation
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * @licend The above is the entire license notice for the
 * JavaScript code in this page
 */ /**
 * pdfjsVersion = 5.6.205
 * pdfjsBuild = ada343803
 */ /******/ // The require scope
/******/ 
var $4TZ3D = parcelRequire("4TZ3D");
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $13b630ad92b827c2$export$a143d493d941bafc;
var $13b630ad92b827c2$export$e4cf37d7f6fb9e0a;
var $13b630ad92b827c2$export$f99ded8fe4b79145;
var $13b630ad92b827c2$export$599f31c3813fae4d;
'use strict';
var $441c3b20dbacff63$export$a48f0734ac7c2329;
var $441c3b20dbacff63$export$d622b2ad8d90c771;
var $441c3b20dbacff63$export$6100ba28696e12de;
'use strict';
$441c3b20dbacff63$export$a48f0734ac7c2329 = $441c3b20dbacff63$var$byteLength;
$441c3b20dbacff63$export$d622b2ad8d90c771 = $441c3b20dbacff63$var$toByteArray;
$441c3b20dbacff63$export$6100ba28696e12de = $441c3b20dbacff63$var$fromByteArray;
var $441c3b20dbacff63$var$lookup = [];
var $441c3b20dbacff63$var$revLookup = [];
var $441c3b20dbacff63$var$Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array;
var $441c3b20dbacff63$var$code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
for(var $441c3b20dbacff63$var$i = 0, $441c3b20dbacff63$var$len = $441c3b20dbacff63$var$code.length; $441c3b20dbacff63$var$i < $441c3b20dbacff63$var$len; ++$441c3b20dbacff63$var$i){
    $441c3b20dbacff63$var$lookup[$441c3b20dbacff63$var$i] = $441c3b20dbacff63$var$code[$441c3b20dbacff63$var$i];
    $441c3b20dbacff63$var$revLookup[$441c3b20dbacff63$var$code.charCodeAt($441c3b20dbacff63$var$i)] = $441c3b20dbacff63$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$441c3b20dbacff63$var$revLookup['-'.charCodeAt(0)] = 62;
$441c3b20dbacff63$var$revLookup['_'.charCodeAt(0)] = 63;
function $441c3b20dbacff63$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error('Invalid string. Length must be a multiple of 4');
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf('=');
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $441c3b20dbacff63$var$byteLength(b64) {
    var lens = $441c3b20dbacff63$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $441c3b20dbacff63$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $441c3b20dbacff63$var$toByteArray(b64) {
    var tmp;
    var lens = $441c3b20dbacff63$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $441c3b20dbacff63$var$Arr($441c3b20dbacff63$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $441c3b20dbacff63$var$revLookup[b64.charCodeAt(i)] << 18 | $441c3b20dbacff63$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $441c3b20dbacff63$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $441c3b20dbacff63$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $441c3b20dbacff63$var$revLookup[b64.charCodeAt(i)] << 2 | $441c3b20dbacff63$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $441c3b20dbacff63$var$revLookup[b64.charCodeAt(i)] << 10 | $441c3b20dbacff63$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $441c3b20dbacff63$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $441c3b20dbacff63$var$tripletToBase64(num) {
    return $441c3b20dbacff63$var$lookup[num >> 18 & 0x3F] + $441c3b20dbacff63$var$lookup[num >> 12 & 0x3F] + $441c3b20dbacff63$var$lookup[num >> 6 & 0x3F] + $441c3b20dbacff63$var$lookup[num & 0x3F];
}
function $441c3b20dbacff63$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($441c3b20dbacff63$var$tripletToBase64(tmp));
    }
    return output.join('');
}
function $441c3b20dbacff63$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($441c3b20dbacff63$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($441c3b20dbacff63$var$lookup[tmp >> 2] + $441c3b20dbacff63$var$lookup[tmp << 4 & 0x3F] + '==');
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($441c3b20dbacff63$var$lookup[tmp >> 10] + $441c3b20dbacff63$var$lookup[tmp >> 4 & 0x3F] + $441c3b20dbacff63$var$lookup[tmp << 2 & 0x3F] + '=');
    }
    return parts.join('');
}


/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $973b14a6d4579a4e$export$aafa59e2e03f2942;
var $973b14a6d4579a4e$export$68d8715fc104d294;
$973b14a6d4579a4e$export$aafa59e2e03f2942 = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$973b14a6d4579a4e$export$68d8715fc104d294 = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};


var $13b630ad92b827c2$var$customInspectSymbol = typeof Symbol === 'function' && typeof Symbol['for'] === 'function' // eslint-disable-line dot-notation
 ? Symbol['for']('nodejs.util.inspect.custom') // eslint-disable-line dot-notation
 : null;
$13b630ad92b827c2$export$a143d493d941bafc = $13b630ad92b827c2$var$Buffer;
$13b630ad92b827c2$export$e4cf37d7f6fb9e0a = $13b630ad92b827c2$var$SlowBuffer;
$13b630ad92b827c2$export$f99ded8fe4b79145 = 50;
var $13b630ad92b827c2$var$K_MAX_LENGTH = 0x7fffffff;
$13b630ad92b827c2$export$599f31c3813fae4d = $13b630ad92b827c2$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $13b630ad92b827c2$var$Buffer.TYPED_ARRAY_SUPPORT = $13b630ad92b827c2$var$typedArraySupport();
if (!$13b630ad92b827c2$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== 'undefined' && typeof console.error === 'function') console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $13b630ad92b827c2$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        var arr = new Uint8Array(1);
        var proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($13b630ad92b827c2$var$Buffer.prototype, 'parent', {
    enumerable: true,
    get: function() {
        if (!$13b630ad92b827c2$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($13b630ad92b827c2$var$Buffer.prototype, 'offset', {
    enumerable: true,
    get: function() {
        if (!$13b630ad92b827c2$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $13b630ad92b827c2$var$createBuffer(length) {
    if (length > $13b630ad92b827c2$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    var buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $13b630ad92b827c2$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $13b630ad92b827c2$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === 'number') {
        if (typeof encodingOrOffset === 'string') throw new TypeError('The "string" argument must be of type string. Received type number');
        return $13b630ad92b827c2$var$allocUnsafe(arg);
    }
    return $13b630ad92b827c2$var$from(arg, encodingOrOffset, length);
}
$13b630ad92b827c2$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $13b630ad92b827c2$var$from(value, encodingOrOffset, length) {
    if (typeof value === 'string') return $13b630ad92b827c2$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $13b630ad92b827c2$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($13b630ad92b827c2$var$isInstance(value, ArrayBuffer) || value && $13b630ad92b827c2$var$isInstance(value.buffer, ArrayBuffer)) return $13b630ad92b827c2$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== 'undefined' && ($13b630ad92b827c2$var$isInstance(value, SharedArrayBuffer) || value && $13b630ad92b827c2$var$isInstance(value.buffer, SharedArrayBuffer))) return $13b630ad92b827c2$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === 'number') throw new TypeError('The "value" argument must not be of type number. Received type number');
    var valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $13b630ad92b827c2$var$Buffer.from(valueOf, encodingOrOffset, length);
    var b = $13b630ad92b827c2$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== 'undefined' && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === 'function') return $13b630ad92b827c2$var$Buffer.from(value[Symbol.toPrimitive]('string'), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $13b630ad92b827c2$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $13b630ad92b827c2$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($13b630ad92b827c2$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($13b630ad92b827c2$var$Buffer, Uint8Array);
function $13b630ad92b827c2$var$assertSize(size) {
    if (typeof size !== 'number') throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $13b630ad92b827c2$var$alloc(size, fill, encoding) {
    $13b630ad92b827c2$var$assertSize(size);
    if (size <= 0) return $13b630ad92b827c2$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === 'string' ? $13b630ad92b827c2$var$createBuffer(size).fill(fill, encoding) : $13b630ad92b827c2$var$createBuffer(size).fill(fill);
    return $13b630ad92b827c2$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $13b630ad92b827c2$var$Buffer.alloc = function(size, fill, encoding) {
    return $13b630ad92b827c2$var$alloc(size, fill, encoding);
};
function $13b630ad92b827c2$var$allocUnsafe(size) {
    $13b630ad92b827c2$var$assertSize(size);
    return $13b630ad92b827c2$var$createBuffer(size < 0 ? 0 : $13b630ad92b827c2$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $13b630ad92b827c2$var$Buffer.allocUnsafe = function(size) {
    return $13b630ad92b827c2$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $13b630ad92b827c2$var$Buffer.allocUnsafeSlow = function(size) {
    return $13b630ad92b827c2$var$allocUnsafe(size);
};
function $13b630ad92b827c2$var$fromString(string, encoding) {
    if (typeof encoding !== 'string' || encoding === '') encoding = 'utf8';
    if (!$13b630ad92b827c2$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
    var length = $13b630ad92b827c2$var$byteLength(string, encoding) | 0;
    var buf = $13b630ad92b827c2$var$createBuffer(length);
    var actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $13b630ad92b827c2$var$fromArrayLike(array) {
    var length = array.length < 0 ? 0 : $13b630ad92b827c2$var$checked(array.length) | 0;
    var buf = $13b630ad92b827c2$var$createBuffer(length);
    for(var i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $13b630ad92b827c2$var$fromArrayView(arrayView) {
    if ($13b630ad92b827c2$var$isInstance(arrayView, Uint8Array)) {
        var copy = new Uint8Array(arrayView);
        return $13b630ad92b827c2$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $13b630ad92b827c2$var$fromArrayLike(arrayView);
}
function $13b630ad92b827c2$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    var buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $13b630ad92b827c2$var$Buffer.prototype);
    return buf;
}
function $13b630ad92b827c2$var$fromObject(obj) {
    if ($13b630ad92b827c2$var$Buffer.isBuffer(obj)) {
        var len = $13b630ad92b827c2$var$checked(obj.length) | 0;
        var buf = $13b630ad92b827c2$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== 'number' || $13b630ad92b827c2$var$numberIsNaN(obj.length)) return $13b630ad92b827c2$var$createBuffer(0);
        return $13b630ad92b827c2$var$fromArrayLike(obj);
    }
    if (obj.type === 'Buffer' && Array.isArray(obj.data)) return $13b630ad92b827c2$var$fromArrayLike(obj.data);
}
function $13b630ad92b827c2$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $13b630ad92b827c2$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $13b630ad92b827c2$var$K_MAX_LENGTH.toString(16) + ' bytes');
    return length | 0;
}
function $13b630ad92b827c2$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $13b630ad92b827c2$var$Buffer.alloc(+length);
}
$13b630ad92b827c2$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $13b630ad92b827c2$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$13b630ad92b827c2$var$Buffer.compare = function compare(a, b) {
    if ($13b630ad92b827c2$var$isInstance(a, Uint8Array)) a = $13b630ad92b827c2$var$Buffer.from(a, a.offset, a.byteLength);
    if ($13b630ad92b827c2$var$isInstance(b, Uint8Array)) b = $13b630ad92b827c2$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$13b630ad92b827c2$var$Buffer.isBuffer(a) || !$13b630ad92b827c2$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    var x = a.length;
    var y = b.length;
    for(var i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$13b630ad92b827c2$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case 'hex':
        case 'utf8':
        case 'utf-8':
        case 'ascii':
        case 'latin1':
        case 'binary':
        case 'base64':
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return true;
        default:
            return false;
    }
};
$13b630ad92b827c2$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $13b630ad92b827c2$var$Buffer.alloc(0);
    var i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    var buffer = $13b630ad92b827c2$var$Buffer.allocUnsafe(length);
    var pos = 0;
    for(i = 0; i < list.length; ++i){
        var buf = list[i];
        if ($13b630ad92b827c2$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) $13b630ad92b827c2$var$Buffer.from(buf).copy(buffer, pos);
            else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$13b630ad92b827c2$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $13b630ad92b827c2$var$byteLength(string, encoding) {
    if ($13b630ad92b827c2$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $13b630ad92b827c2$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== 'string') throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    var len = string.length;
    var mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    var loweredCase = false;
    for(;;)switch(encoding){
        case 'ascii':
        case 'latin1':
        case 'binary':
            return len;
        case 'utf8':
        case 'utf-8':
            return $13b630ad92b827c2$var$utf8ToBytes(string).length;
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return len * 2;
        case 'hex':
            return len >>> 1;
        case 'base64':
            return $13b630ad92b827c2$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $13b630ad92b827c2$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
}
$13b630ad92b827c2$var$Buffer.byteLength = $13b630ad92b827c2$var$byteLength;
function $13b630ad92b827c2$var$slowToString(encoding, start, end) {
    var loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return '';
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return '';
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return '';
    if (!encoding) encoding = 'utf8';
    while(true)switch(encoding){
        case 'hex':
            return $13b630ad92b827c2$var$hexSlice(this, start, end);
        case 'utf8':
        case 'utf-8':
            return $13b630ad92b827c2$var$utf8Slice(this, start, end);
        case 'ascii':
            return $13b630ad92b827c2$var$asciiSlice(this, start, end);
        case 'latin1':
        case 'binary':
            return $13b630ad92b827c2$var$latin1Slice(this, start, end);
        case 'base64':
            return $13b630ad92b827c2$var$base64Slice(this, start, end);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $13b630ad92b827c2$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = (encoding + '').toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$13b630ad92b827c2$var$Buffer.prototype._isBuffer = true;
function $13b630ad92b827c2$var$swap(b, n, m) {
    var i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$13b630ad92b827c2$var$Buffer.prototype.swap16 = function swap16() {
    var len = this.length;
    if (len % 2 !== 0) throw new RangeError('Buffer size must be a multiple of 16-bits');
    for(var i = 0; i < len; i += 2)$13b630ad92b827c2$var$swap(this, i, i + 1);
    return this;
};
$13b630ad92b827c2$var$Buffer.prototype.swap32 = function swap32() {
    var len = this.length;
    if (len % 4 !== 0) throw new RangeError('Buffer size must be a multiple of 32-bits');
    for(var i = 0; i < len; i += 4){
        $13b630ad92b827c2$var$swap(this, i, i + 3);
        $13b630ad92b827c2$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$13b630ad92b827c2$var$Buffer.prototype.swap64 = function swap64() {
    var len = this.length;
    if (len % 8 !== 0) throw new RangeError('Buffer size must be a multiple of 64-bits');
    for(var i = 0; i < len; i += 8){
        $13b630ad92b827c2$var$swap(this, i, i + 7);
        $13b630ad92b827c2$var$swap(this, i + 1, i + 6);
        $13b630ad92b827c2$var$swap(this, i + 2, i + 5);
        $13b630ad92b827c2$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$13b630ad92b827c2$var$Buffer.prototype.toString = function toString() {
    var length = this.length;
    if (length === 0) return '';
    if (arguments.length === 0) return $13b630ad92b827c2$var$utf8Slice(this, 0, length);
    return $13b630ad92b827c2$var$slowToString.apply(this, arguments);
};
$13b630ad92b827c2$var$Buffer.prototype.toLocaleString = $13b630ad92b827c2$var$Buffer.prototype.toString;
$13b630ad92b827c2$var$Buffer.prototype.equals = function equals(b) {
    if (!$13b630ad92b827c2$var$Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer');
    if (this === b) return true;
    return $13b630ad92b827c2$var$Buffer.compare(this, b) === 0;
};
$13b630ad92b827c2$var$Buffer.prototype.inspect = function inspect() {
    var str = '';
    var max = $13b630ad92b827c2$export$f99ded8fe4b79145;
    str = this.toString('hex', 0, max).replace(/(.{2})/g, '$1 ').trim();
    if (this.length > max) str += ' ... ';
    return '<Buffer ' + str + '>';
};
if ($13b630ad92b827c2$var$customInspectSymbol) $13b630ad92b827c2$var$Buffer.prototype[$13b630ad92b827c2$var$customInspectSymbol] = $13b630ad92b827c2$var$Buffer.prototype.inspect;
$13b630ad92b827c2$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($13b630ad92b827c2$var$isInstance(target, Uint8Array)) target = $13b630ad92b827c2$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$13b630ad92b827c2$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError('out of range index');
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    var x = thisEnd - thisStart;
    var y = end - start;
    var len = Math.min(x, y);
    var thisCopy = this.slice(thisStart, thisEnd);
    var targetCopy = target.slice(start, end);
    for(var i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $13b630ad92b827c2$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === 'string') {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($13b630ad92b827c2$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === 'string') val = $13b630ad92b827c2$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($13b630ad92b827c2$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $13b630ad92b827c2$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === 'number') {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === 'function') {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $13b630ad92b827c2$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError('val must be string, number or Buffer');
}
function $13b630ad92b827c2$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    var indexSize = 1;
    var arrLength = arr.length;
    var valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === 'ucs2' || encoding === 'ucs-2' || encoding === 'utf16le' || encoding === 'utf-16le') {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    var i;
    if (dir) {
        var foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            var found = true;
            for(var j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$13b630ad92b827c2$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$13b630ad92b827c2$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $13b630ad92b827c2$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$13b630ad92b827c2$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $13b630ad92b827c2$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $13b630ad92b827c2$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    var remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    var strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    for(var i = 0; i < length; ++i){
        var parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($13b630ad92b827c2$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $13b630ad92b827c2$var$utf8Write(buf, string, offset, length) {
    return $13b630ad92b827c2$var$blitBuffer($13b630ad92b827c2$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $13b630ad92b827c2$var$asciiWrite(buf, string, offset, length) {
    return $13b630ad92b827c2$var$blitBuffer($13b630ad92b827c2$var$asciiToBytes(string), buf, offset, length);
}
function $13b630ad92b827c2$var$base64Write(buf, string, offset, length) {
    return $13b630ad92b827c2$var$blitBuffer($13b630ad92b827c2$var$base64ToBytes(string), buf, offset, length);
}
function $13b630ad92b827c2$var$ucs2Write(buf, string, offset, length) {
    return $13b630ad92b827c2$var$blitBuffer($13b630ad92b827c2$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$13b630ad92b827c2$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = 'utf8';
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === 'string') {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = 'utf8';
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error('Buffer.write(string, encoding, offset[, length]) is no longer supported');
    var remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError('Attempt to write outside buffer bounds');
    if (!encoding) encoding = 'utf8';
    var loweredCase = false;
    for(;;)switch(encoding){
        case 'hex':
            return $13b630ad92b827c2$var$hexWrite(this, string, offset, length);
        case 'utf8':
        case 'utf-8':
            return $13b630ad92b827c2$var$utf8Write(this, string, offset, length);
        case 'ascii':
        case 'latin1':
        case 'binary':
            return $13b630ad92b827c2$var$asciiWrite(this, string, offset, length);
        case 'base64':
            // Warning: maxLength not taken into account in base64Write
            return $13b630ad92b827c2$var$base64Write(this, string, offset, length);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $13b630ad92b827c2$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
};
$13b630ad92b827c2$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: 'Buffer',
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $13b630ad92b827c2$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $441c3b20dbacff63$export$6100ba28696e12de(buf);
    else return $441c3b20dbacff63$export$6100ba28696e12de(buf.slice(start, end));
}
function $13b630ad92b827c2$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    var res = [];
    var i = start;
    while(i < end){
        var firstByte = buf[i];
        var codePoint = null;
        var bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            var secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $13b630ad92b827c2$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
var $13b630ad92b827c2$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $13b630ad92b827c2$var$decodeCodePointsArray(codePoints) {
    var len = codePoints.length;
    if (len <= $13b630ad92b827c2$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    var res = '';
    var i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $13b630ad92b827c2$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $13b630ad92b827c2$var$asciiSlice(buf, start, end) {
    var ret = '';
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $13b630ad92b827c2$var$latin1Slice(buf, start, end) {
    var ret = '';
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $13b630ad92b827c2$var$hexSlice(buf, start, end) {
    var len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    var out = '';
    for(var i = start; i < end; ++i)out += $13b630ad92b827c2$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $13b630ad92b827c2$var$utf16leSlice(buf, start, end) {
    var bytes = buf.slice(start, end);
    var res = '';
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(var i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$13b630ad92b827c2$var$Buffer.prototype.slice = function slice(start, end) {
    var len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    var newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $13b630ad92b827c2$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $13b630ad92b827c2$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError('offset is not uint');
    if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length');
}
$13b630ad92b827c2$var$Buffer.prototype.readUintLE = $13b630ad92b827c2$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $13b630ad92b827c2$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$13b630ad92b827c2$var$Buffer.prototype.readUintBE = $13b630ad92b827c2$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $13b630ad92b827c2$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset + --byteLength];
    var mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$13b630ad92b827c2$var$Buffer.prototype.readUint8 = $13b630ad92b827c2$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $13b630ad92b827c2$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$13b630ad92b827c2$var$Buffer.prototype.readUint16LE = $13b630ad92b827c2$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $13b630ad92b827c2$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$13b630ad92b827c2$var$Buffer.prototype.readUint16BE = $13b630ad92b827c2$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $13b630ad92b827c2$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$13b630ad92b827c2$var$Buffer.prototype.readUint32LE = $13b630ad92b827c2$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $13b630ad92b827c2$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$13b630ad92b827c2$var$Buffer.prototype.readUint32BE = $13b630ad92b827c2$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $13b630ad92b827c2$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$13b630ad92b827c2$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $13b630ad92b827c2$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$13b630ad92b827c2$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $13b630ad92b827c2$var$checkOffset(offset, byteLength, this.length);
    var i = byteLength;
    var mul = 1;
    var val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$13b630ad92b827c2$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $13b630ad92b827c2$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$13b630ad92b827c2$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $13b630ad92b827c2$var$checkOffset(offset, 2, this.length);
    var val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$13b630ad92b827c2$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $13b630ad92b827c2$var$checkOffset(offset, 2, this.length);
    var val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$13b630ad92b827c2$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $13b630ad92b827c2$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$13b630ad92b827c2$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $13b630ad92b827c2$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$13b630ad92b827c2$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $13b630ad92b827c2$var$checkOffset(offset, 4, this.length);
    return $973b14a6d4579a4e$export$aafa59e2e03f2942(this, offset, true, 23, 4);
};
$13b630ad92b827c2$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $13b630ad92b827c2$var$checkOffset(offset, 4, this.length);
    return $973b14a6d4579a4e$export$aafa59e2e03f2942(this, offset, false, 23, 4);
};
$13b630ad92b827c2$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $13b630ad92b827c2$var$checkOffset(offset, 8, this.length);
    return $973b14a6d4579a4e$export$aafa59e2e03f2942(this, offset, true, 52, 8);
};
$13b630ad92b827c2$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $13b630ad92b827c2$var$checkOffset(offset, 8, this.length);
    return $973b14a6d4579a4e$export$aafa59e2e03f2942(this, offset, false, 52, 8);
};
function $13b630ad92b827c2$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$13b630ad92b827c2$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
}
$13b630ad92b827c2$var$Buffer.prototype.writeUintLE = $13b630ad92b827c2$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $13b630ad92b827c2$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var mul = 1;
    var i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$13b630ad92b827c2$var$Buffer.prototype.writeUintBE = $13b630ad92b827c2$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $13b630ad92b827c2$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var i = byteLength - 1;
    var mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$13b630ad92b827c2$var$Buffer.prototype.writeUint8 = $13b630ad92b827c2$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $13b630ad92b827c2$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$13b630ad92b827c2$var$Buffer.prototype.writeUint16LE = $13b630ad92b827c2$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $13b630ad92b827c2$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$13b630ad92b827c2$var$Buffer.prototype.writeUint16BE = $13b630ad92b827c2$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $13b630ad92b827c2$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$13b630ad92b827c2$var$Buffer.prototype.writeUint32LE = $13b630ad92b827c2$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $13b630ad92b827c2$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$13b630ad92b827c2$var$Buffer.prototype.writeUint32BE = $13b630ad92b827c2$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $13b630ad92b827c2$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$13b630ad92b827c2$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        $13b630ad92b827c2$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = 0;
    var mul = 1;
    var sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$13b630ad92b827c2$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        $13b630ad92b827c2$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = byteLength - 1;
    var mul = 1;
    var sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$13b630ad92b827c2$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $13b630ad92b827c2$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$13b630ad92b827c2$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $13b630ad92b827c2$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$13b630ad92b827c2$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $13b630ad92b827c2$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$13b630ad92b827c2$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $13b630ad92b827c2$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$13b630ad92b827c2$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $13b630ad92b827c2$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $13b630ad92b827c2$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
    if (offset < 0) throw new RangeError('Index out of range');
}
function $13b630ad92b827c2$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $13b630ad92b827c2$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $973b14a6d4579a4e$export$68d8715fc104d294(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$13b630ad92b827c2$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $13b630ad92b827c2$var$writeFloat(this, value, offset, true, noAssert);
};
$13b630ad92b827c2$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $13b630ad92b827c2$var$writeFloat(this, value, offset, false, noAssert);
};
function $13b630ad92b827c2$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $13b630ad92b827c2$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $973b14a6d4579a4e$export$68d8715fc104d294(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$13b630ad92b827c2$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $13b630ad92b827c2$var$writeDouble(this, value, offset, true, noAssert);
};
$13b630ad92b827c2$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $13b630ad92b827c2$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$13b630ad92b827c2$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$13b630ad92b827c2$var$Buffer.isBuffer(target)) throw new TypeError('argument should be a Buffer');
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError('targetStart out of bounds');
    if (start < 0 || start >= this.length) throw new RangeError('Index out of range');
    if (end < 0) throw new RangeError('sourceEnd out of bounds');
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    var len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === 'function') // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$13b630ad92b827c2$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === 'string') {
        if (typeof start === 'string') {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === 'string') {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== 'string') throw new TypeError('encoding must be a string');
        if (typeof encoding === 'string' && !$13b630ad92b827c2$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
        if (val.length === 1) {
            var code = val.charCodeAt(0);
            if (encoding === 'utf8' && code < 128 || encoding === 'latin1') // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === 'number') val = val & 255;
    else if (typeof val === 'boolean') val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError('Out of range index');
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    var i;
    if (typeof val === 'number') for(i = start; i < end; ++i)this[i] = val;
    else {
        var bytes = $13b630ad92b827c2$var$Buffer.isBuffer(val) ? val : $13b630ad92b827c2$var$Buffer.from(val, encoding);
        var len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// HELPER FUNCTIONS
// ================
var $13b630ad92b827c2$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $13b630ad92b827c2$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split('=')[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($13b630ad92b827c2$var$INVALID_BASE64_RE, '');
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return '';
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + '=';
    return str;
}
function $13b630ad92b827c2$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    var codePoint;
    var length = string.length;
    var leadSurrogate = null;
    var bytes = [];
    for(var i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error('Invalid code point');
    }
    return bytes;
}
function $13b630ad92b827c2$var$asciiToBytes(str) {
    var byteArray = [];
    for(var i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $13b630ad92b827c2$var$utf16leToBytes(str, units) {
    var c, hi, lo;
    var byteArray = [];
    for(var i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $13b630ad92b827c2$var$base64ToBytes(str) {
    return $441c3b20dbacff63$export$d622b2ad8d90c771($13b630ad92b827c2$var$base64clean(str));
}
function $13b630ad92b827c2$var$blitBuffer(src, dst, offset, length) {
    for(var i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $13b630ad92b827c2$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $13b630ad92b827c2$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
var $13b630ad92b827c2$var$hexSliceLookupTable = function() {
    var alphabet = '0123456789abcdef';
    var table = new Array(256);
    for(var i = 0; i < 16; ++i){
        var i16 = i * 16;
        for(var j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();


var $b3a01b20dd2ade98$require$Buffer = $13b630ad92b827c2$export$a143d493d941bafc;
var $b3a01b20dd2ade98$var$__webpack_require__ = {};
/******/ /************************************************************************/ /******/ /* webpack/runtime/define property getters */ /******/ (()=>{
    /******/ // define getter functions for harmony exports
    /******/ $b3a01b20dd2ade98$var$__webpack_require__.d = (exports, definition)=>{
        /******/ for(var key in definition)/******/ if ($b3a01b20dd2ade98$var$__webpack_require__.o(definition, key) && !$b3a01b20dd2ade98$var$__webpack_require__.o(exports, key)) /******/ Object.defineProperty(exports, key, {
            enumerable: true,
            get: definition[key]
        });
    /******/ };
/******/ })();
/******/ /******/ /* webpack/runtime/hasOwnProperty shorthand */ /******/ (()=>{
    /******/ $b3a01b20dd2ade98$var$__webpack_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
/******/ })();
/******/ /************************************************************************/ var $b3a01b20dd2ade98$var$__webpack_exports__ = {};
const $b3a01b20dd2ade98$var$isNodeJS = false;
const $b3a01b20dd2ade98$var$FONT_IDENTITY_MATRIX = [
    0.001,
    0,
    0,
    0.001,
    0,
    0
];
const $b3a01b20dd2ade98$var$LINE_FACTOR = 1.35;
const $b3a01b20dd2ade98$var$LINE_DESCENT_FACTOR = 0.35;
const $b3a01b20dd2ade98$var$BASELINE_FACTOR = $b3a01b20dd2ade98$var$LINE_DESCENT_FACTOR / $b3a01b20dd2ade98$var$LINE_FACTOR;
const $b3a01b20dd2ade98$var$RenderingIntentFlag = {
    ANY: 0x01,
    DISPLAY: 0x02,
    PRINT: 0x04,
    SAVE: 0x08,
    ANNOTATIONS_FORMS: 0x10,
    ANNOTATIONS_STORAGE: 0x20,
    ANNOTATIONS_DISABLE: 0x40,
    IS_EDITING: 0x80,
    OPLIST: 0x100
};
const $b3a01b20dd2ade98$export$5a7af0c07e33392e = {
    DISABLE: 0,
    ENABLE: 1,
    ENABLE_FORMS: 2,
    ENABLE_STORAGE: 3
};
const $b3a01b20dd2ade98$var$AnnotationEditorPrefix = "pdfjs_internal_editor_";
const $b3a01b20dd2ade98$export$72ea3bfdd9a725bf = {
    DISABLE: -1,
    NONE: 0,
    FREETEXT: 3,
    HIGHLIGHT: 9,
    STAMP: 13,
    INK: 15,
    POPUP: 16,
    SIGNATURE: 101,
    COMMENT: 102
};
const $b3a01b20dd2ade98$export$cf3df2a6ecc26692 = {
    RESIZE: 1,
    CREATE: 2,
    FREETEXT_SIZE: 11,
    FREETEXT_COLOR: 12,
    FREETEXT_OPACITY: 13,
    INK_COLOR: 21,
    INK_THICKNESS: 22,
    INK_OPACITY: 23,
    HIGHLIGHT_COLOR: 31,
    HIGHLIGHT_THICKNESS: 32,
    HIGHLIGHT_FREE: 33,
    HIGHLIGHT_SHOW_ALL: 34,
    DRAW_STEP: 41
};
const $b3a01b20dd2ade98$export$bb99a5b8411e07d8 = {
    PRINT: 0x04,
    MODIFY_CONTENTS: 0x08,
    COPY: 0x10,
    MODIFY_ANNOTATIONS: 0x20,
    FILL_INTERACTIVE_FORMS: 0x100,
    COPY_FOR_ACCESSIBILITY: 0x200,
    ASSEMBLE: 0x400,
    PRINT_HIGH_QUALITY: 0x800
};
const $b3a01b20dd2ade98$var$MeshFigureType = {
    TRIANGLES: 1,
    LATTICE: 2,
    PATCH: 3
};
const $b3a01b20dd2ade98$var$TextRenderingMode = {
    FILL: 0,
    STROKE: 1,
    FILL_STROKE: 2,
    INVISIBLE: 3,
    FILL_ADD_TO_PATH: 4,
    STROKE_ADD_TO_PATH: 5,
    FILL_STROKE_ADD_TO_PATH: 6,
    ADD_TO_PATH: 7,
    FILL_STROKE_MASK: 3,
    ADD_TO_PATH_FLAG: 4
};
const $b3a01b20dd2ade98$export$b890e9c15247e0b3 = {
    GRAYSCALE_1BPP: 1,
    RGB_24BPP: 2,
    RGBA_32BPP: 3
};
const $b3a01b20dd2ade98$export$f50c3066a53a6f2c = {
    TEXT: 1,
    LINK: 2,
    FREETEXT: 3,
    LINE: 4,
    SQUARE: 5,
    CIRCLE: 6,
    POLYGON: 7,
    POLYLINE: 8,
    HIGHLIGHT: 9,
    UNDERLINE: 10,
    SQUIGGLY: 11,
    STRIKEOUT: 12,
    STAMP: 13,
    CARET: 14,
    INK: 15,
    POPUP: 16,
    FILEATTACHMENT: 17,
    SOUND: 18,
    MOVIE: 19,
    WIDGET: 20,
    SCREEN: 21,
    PRINTERMARK: 22,
    TRAPNET: 23,
    WATERMARK: 24,
    THREED: 25,
    REDACT: 26
};
const $b3a01b20dd2ade98$var$AnnotationReplyType = {
    GROUP: "Group",
    REPLY: "R"
};
const $b3a01b20dd2ade98$var$AnnotationFlag = {
    INVISIBLE: 0x01,
    HIDDEN: 0x02,
    PRINT: 0x04,
    NOZOOM: 0x08,
    NOROTATE: 0x10,
    NOVIEW: 0x20,
    READONLY: 0x40,
    LOCKED: 0x80,
    TOGGLENOVIEW: 0x100,
    LOCKEDCONTENTS: 0x200
};
const $b3a01b20dd2ade98$var$AnnotationFieldFlag = {
    READONLY: 0x0000001,
    REQUIRED: 0x0000002,
    NOEXPORT: 0x0000004,
    MULTILINE: 0x0001000,
    PASSWORD: 0x0002000,
    NOTOGGLETOOFF: 0x0004000,
    RADIO: 0x0008000,
    PUSHBUTTON: 0x0010000,
    COMBO: 0x0020000,
    EDIT: 0x0040000,
    SORT: 0x0080000,
    FILESELECT: 0x0100000,
    MULTISELECT: 0x0200000,
    DONOTSPELLCHECK: 0x0400000,
    DONOTSCROLL: 0x0800000,
    COMB: 0x1000000,
    RICHTEXT: 0x2000000,
    RADIOSINUNISON: 0x2000000,
    COMMITONSELCHANGE: 0x4000000
};
const $b3a01b20dd2ade98$var$AnnotationBorderStyleType = {
    SOLID: 1,
    DASHED: 2,
    BEVELED: 3,
    INSET: 4,
    UNDERLINE: 5
};
const $b3a01b20dd2ade98$var$AnnotationActionEventType = {
    E: "Mouse Enter",
    X: "Mouse Exit",
    D: "Mouse Down",
    U: "Mouse Up",
    Fo: "Focus",
    Bl: "Blur",
    PO: "PageOpen",
    PC: "PageClose",
    PV: "PageVisible",
    PI: "PageInvisible",
    K: "Keystroke",
    F: "Format",
    V: "Validate",
    C: "Calculate"
};
const $b3a01b20dd2ade98$var$DocumentActionEventType = {
    WC: "WillClose",
    WS: "WillSave",
    DS: "DidSave",
    WP: "WillPrint",
    DP: "DidPrint"
};
const $b3a01b20dd2ade98$var$PageActionEventType = {
    O: "PageOpen",
    C: "PageClose"
};
const $b3a01b20dd2ade98$export$b18df09d23c244c4 = {
    ERRORS: 0,
    WARNINGS: 1,
    INFOS: 5
};
const $b3a01b20dd2ade98$export$3a0f7f7a8a0b306b = {
    dependency: 1,
    setLineWidth: 2,
    setLineCap: 3,
    setLineJoin: 4,
    setMiterLimit: 5,
    setDash: 6,
    setRenderingIntent: 7,
    setFlatness: 8,
    setGState: 9,
    save: 10,
    restore: 11,
    transform: 12,
    moveTo: 13,
    lineTo: 14,
    curveTo: 15,
    curveTo2: 16,
    curveTo3: 17,
    closePath: 18,
    rectangle: 19,
    stroke: 20,
    closeStroke: 21,
    fill: 22,
    eoFill: 23,
    fillStroke: 24,
    eoFillStroke: 25,
    closeFillStroke: 26,
    closeEOFillStroke: 27,
    endPath: 28,
    clip: 29,
    eoClip: 30,
    beginText: 31,
    endText: 32,
    setCharSpacing: 33,
    setWordSpacing: 34,
    setHScale: 35,
    setLeading: 36,
    setFont: 37,
    setTextRenderingMode: 38,
    setTextRise: 39,
    moveText: 40,
    setLeadingMoveText: 41,
    setTextMatrix: 42,
    nextLine: 43,
    showText: 44,
    showSpacedText: 45,
    nextLineShowText: 46,
    nextLineSetSpacingShowText: 47,
    setCharWidth: 48,
    setCharWidthAndBounds: 49,
    setStrokeColorSpace: 50,
    setFillColorSpace: 51,
    setStrokeColor: 52,
    setStrokeColorN: 53,
    setFillColor: 54,
    setFillColorN: 55,
    setStrokeGray: 56,
    setFillGray: 57,
    setStrokeRGBColor: 58,
    setFillRGBColor: 59,
    setStrokeCMYKColor: 60,
    setFillCMYKColor: 61,
    shadingFill: 62,
    beginInlineImage: 63,
    beginImageData: 64,
    endInlineImage: 65,
    paintXObject: 66,
    markPoint: 67,
    markPointProps: 68,
    beginMarkedContent: 69,
    beginMarkedContentProps: 70,
    endMarkedContent: 71,
    beginCompat: 72,
    endCompat: 73,
    paintFormXObjectBegin: 74,
    paintFormXObjectEnd: 75,
    beginGroup: 76,
    endGroup: 77,
    beginAnnotation: 80,
    endAnnotation: 81,
    paintImageMaskXObject: 83,
    paintImageMaskXObjectGroup: 84,
    paintImageXObject: 85,
    paintInlineImageXObject: 86,
    paintInlineImageXObjectGroup: 87,
    paintImageXObjectRepeat: 88,
    paintImageMaskXObjectRepeat: 89,
    paintSolidColorImageMask: 90,
    constructPath: 91,
    setStrokeTransparent: 92,
    setFillTransparent: 93,
    rawFillPath: 94
};
const $b3a01b20dd2ade98$var$DrawOPS = {
    moveTo: 0,
    lineTo: 1,
    curveTo: 2,
    quadraticCurveTo: 3,
    closePath: 4
};
const $b3a01b20dd2ade98$export$5e72215208e4d9ad = {
    NEED_PASSWORD: 1,
    INCORRECT_PASSWORD: 2
};
let $b3a01b20dd2ade98$var$verbosity = $b3a01b20dd2ade98$export$b18df09d23c244c4.WARNINGS;
function $b3a01b20dd2ade98$var$setVerbosityLevel(level) {
    if (Number.isInteger(level)) $b3a01b20dd2ade98$var$verbosity = level;
}
function $b3a01b20dd2ade98$var$getVerbosityLevel() {
    return $b3a01b20dd2ade98$var$verbosity;
}
function $b3a01b20dd2ade98$var$info(msg) {
    if ($b3a01b20dd2ade98$var$verbosity >= $b3a01b20dd2ade98$export$b18df09d23c244c4.INFOS) console.info(`Info: ${msg}`);
}
function $b3a01b20dd2ade98$var$warn(msg) {
    if ($b3a01b20dd2ade98$var$verbosity >= $b3a01b20dd2ade98$export$b18df09d23c244c4.WARNINGS) console.warn(`Warning: ${msg}`);
}
function $b3a01b20dd2ade98$var$unreachable(msg) {
    throw new Error(msg);
}
function $b3a01b20dd2ade98$var$assert(cond, msg) {
    if (!cond) $b3a01b20dd2ade98$var$unreachable(msg);
}
function $b3a01b20dd2ade98$var$_isValidProtocol(url) {
    switch(url?.protocol){
        case "http:":
        case "https:":
        case "ftp:":
        case "mailto:":
        case "tel:":
            return true;
        default:
            return false;
    }
}
function $b3a01b20dd2ade98$export$e076b47f5805ca0b(url, baseUrl = null, options = null) {
    if (!url) return null;
    if (options && typeof url === "string") {
        if (options.addDefaultProtocol && url.startsWith("www.")) {
            const dots = url.match(/\./g);
            if (dots?.length >= 2) url = `http://${url}`;
        }
        if (options.tryConvertEncoding) try {
            url = $b3a01b20dd2ade98$var$stringToUTF8String(url);
        } catch  {}
    }
    const absoluteUrl = baseUrl ? URL.parse(url, baseUrl) : URL.parse(url);
    return $b3a01b20dd2ade98$var$_isValidProtocol(absoluteUrl) ? absoluteUrl : null;
}
function $b3a01b20dd2ade98$export$e1e4297c21ab9d13(url, hash, allowRel = false) {
    const res = URL.parse(url);
    if (res) {
        res.hash = hash;
        return res.href;
    }
    if (allowRel && $b3a01b20dd2ade98$export$e076b47f5805ca0b(url, "http://example.com")) return url.split("#", 1)[0] + `${hash ? `#${hash}` : ""}`;
    return "";
}
function $b3a01b20dd2ade98$var$stripPath(str) {
    return str.substring(str.lastIndexOf("/") + 1);
}
function $b3a01b20dd2ade98$export$b8972b998723d602(obj, prop, value, nonSerializable = false) {
    Object.defineProperty(obj, prop, {
        value: value,
        enumerable: !nonSerializable,
        configurable: true,
        writable: false
    });
    return value;
}
const $b3a01b20dd2ade98$var$BaseException = function BaseExceptionClosure() {
    function BaseException(message, name) {
        this.message = message;
        this.name = name;
    }
    BaseException.prototype = new Error();
    BaseException.constructor = BaseException;
    return BaseException;
}();
class $b3a01b20dd2ade98$var$PasswordException extends $b3a01b20dd2ade98$var$BaseException {
    constructor(msg, code){
        super(msg, "PasswordException");
        this.code = code;
    }
}
class $b3a01b20dd2ade98$var$UnknownErrorException extends $b3a01b20dd2ade98$var$BaseException {
    constructor(msg, details){
        super(msg, "UnknownErrorException");
        this.details = details;
    }
}
class $b3a01b20dd2ade98$export$e3d0f4ce5b91e9f1 extends $b3a01b20dd2ade98$var$BaseException {
    constructor(msg){
        super(msg, "InvalidPDFException");
    }
}
class $b3a01b20dd2ade98$export$ea8e9c34f66e603 extends $b3a01b20dd2ade98$var$BaseException {
    constructor(msg, status, missing){
        super(msg, "ResponseException");
        this.status = status;
        this.missing = missing;
    }
}
class $b3a01b20dd2ade98$var$FormatError extends $b3a01b20dd2ade98$var$BaseException {
    constructor(msg){
        super(msg, "FormatError");
    }
}
class $b3a01b20dd2ade98$export$d0e978393d193d1a extends $b3a01b20dd2ade98$var$BaseException {
    constructor(msg){
        super(msg, "AbortException");
    }
}
function $b3a01b20dd2ade98$var$bytesToString(bytes) {
    if (typeof bytes !== "object" || bytes?.length === undefined) $b3a01b20dd2ade98$var$unreachable("Invalid argument for bytesToString");
    const length = bytes.length;
    const MAX_ARGUMENT_COUNT = 8192;
    if (length < MAX_ARGUMENT_COUNT) return String.fromCharCode.apply(null, bytes);
    const strBuf = [];
    for(let i = 0; i < length; i += MAX_ARGUMENT_COUNT){
        const chunkEnd = Math.min(i + MAX_ARGUMENT_COUNT, length);
        const chunk = bytes.subarray(i, chunkEnd);
        strBuf.push(String.fromCharCode.apply(null, chunk));
    }
    return strBuf.join("");
}
function $b3a01b20dd2ade98$var$stringToBytes(str) {
    if (typeof str !== "string") $b3a01b20dd2ade98$var$unreachable("Invalid argument for stringToBytes");
    const length = str.length;
    const bytes = new Uint8Array(length);
    for(let i = 0; i < length; ++i)bytes[i] = str.charCodeAt(i) & 0xff;
    return bytes;
}
function $b3a01b20dd2ade98$var$string32(value) {
    return String.fromCharCode(value >> 24 & 0xff, value >> 16 & 0xff, value >> 8 & 0xff, value & 0xff);
}
function $b3a01b20dd2ade98$var$objectSize(obj) {
    return Object.keys(obj).length;
}
function $b3a01b20dd2ade98$var$isLittleEndian() {
    const buffer8 = new Uint8Array(4);
    buffer8[0] = 1;
    const view32 = new Uint32Array(buffer8.buffer, 0, 1);
    return view32[0] === 1;
}
function $b3a01b20dd2ade98$var$isEvalSupported() {
    try {
        new Function("");
        return true;
    } catch  {
        return false;
    }
}
class $b3a01b20dd2ade98$export$5fb8891d35c36978 {
    static get isLittleEndian() {
        return $b3a01b20dd2ade98$export$b8972b998723d602(this, "isLittleEndian", $b3a01b20dd2ade98$var$isLittleEndian());
    }
    static get isEvalSupported() {
        return $b3a01b20dd2ade98$export$b8972b998723d602(this, "isEvalSupported", $b3a01b20dd2ade98$var$isEvalSupported());
    }
    static get isOffscreenCanvasSupported() {
        return $b3a01b20dd2ade98$export$b8972b998723d602(this, "isOffscreenCanvasSupported", typeof OffscreenCanvas !== "undefined");
    }
    static get isImageDecoderSupported() {
        return $b3a01b20dd2ade98$export$b8972b998723d602(this, "isImageDecoderSupported", typeof ImageDecoder !== "undefined");
    }
    static get isFloat16ArraySupported() {
        return $b3a01b20dd2ade98$export$b8972b998723d602(this, "isFloat16ArraySupported", typeof Float16Array !== "undefined");
    }
    static get isSanitizerSupported() {
        return $b3a01b20dd2ade98$export$b8972b998723d602(this, "isSanitizerSupported", typeof Sanitizer !== "undefined");
    }
    static get platform() {
        const { platform: platform, userAgent: userAgent } = navigator;
        return $b3a01b20dd2ade98$export$b8972b998723d602(this, "platform", {
            isAndroid: userAgent.includes("Android"),
            isLinux: platform.includes("Linux"),
            isMac: platform.includes("Mac"),
            isWindows: platform.includes("Win"),
            isFirefox: userAgent.includes("Firefox")
        });
    }
    static get isCSSRoundSupported() {
        return $b3a01b20dd2ade98$export$b8972b998723d602(this, "isCSSRoundSupported", globalThis.CSS?.supports?.("width: round(1.5px, 1px)"));
    }
}
const $b3a01b20dd2ade98$var$hexNumbers = Array.from(Array(256).keys(), (n)=>n.toString(16).padStart(2, "0"));
class $b3a01b20dd2ade98$export$f8f26dd395d7e1bd {
    static makeHexColor(r, g, b) {
        return `#${$b3a01b20dd2ade98$var$hexNumbers[r]}${$b3a01b20dd2ade98$var$hexNumbers[g]}${$b3a01b20dd2ade98$var$hexNumbers[b]}`;
    }
    static domMatrixToTransform(dm) {
        return [
            dm.a,
            dm.b,
            dm.c,
            dm.d,
            dm.e,
            dm.f
        ];
    }
    static scaleMinMax(transform, minMax) {
        let temp;
        if (transform[0]) {
            if (transform[0] < 0) {
                temp = minMax[0];
                minMax[0] = minMax[2];
                minMax[2] = temp;
            }
            minMax[0] *= transform[0];
            minMax[2] *= transform[0];
            if (transform[3] < 0) {
                temp = minMax[1];
                minMax[1] = minMax[3];
                minMax[3] = temp;
            }
            minMax[1] *= transform[3];
            minMax[3] *= transform[3];
        } else {
            temp = minMax[0];
            minMax[0] = minMax[1];
            minMax[1] = temp;
            temp = minMax[2];
            minMax[2] = minMax[3];
            minMax[3] = temp;
            if (transform[1] < 0) {
                temp = minMax[1];
                minMax[1] = minMax[3];
                minMax[3] = temp;
            }
            minMax[1] *= transform[1];
            minMax[3] *= transform[1];
            if (transform[2] < 0) {
                temp = minMax[0];
                minMax[0] = minMax[2];
                minMax[2] = temp;
            }
            minMax[0] *= transform[2];
            minMax[2] *= transform[2];
        }
        minMax[0] += transform[4];
        minMax[1] += transform[5];
        minMax[2] += transform[4];
        minMax[3] += transform[5];
    }
    static transform(m1, m2) {
        return [
            m1[0] * m2[0] + m1[2] * m2[1],
            m1[1] * m2[0] + m1[3] * m2[1],
            m1[0] * m2[2] + m1[2] * m2[3],
            m1[1] * m2[2] + m1[3] * m2[3],
            m1[0] * m2[4] + m1[2] * m2[5] + m1[4],
            m1[1] * m2[4] + m1[3] * m2[5] + m1[5]
        ];
    }
    static multiplyByDOMMatrix(m, md) {
        return [
            m[0] * md.a + m[2] * md.b,
            m[1] * md.a + m[3] * md.b,
            m[0] * md.c + m[2] * md.d,
            m[1] * md.c + m[3] * md.d,
            m[0] * md.e + m[2] * md.f + m[4],
            m[1] * md.e + m[3] * md.f + m[5]
        ];
    }
    static applyTransform(p, m, pos = 0) {
        const p0 = p[pos];
        const p1 = p[pos + 1];
        p[pos] = p0 * m[0] + p1 * m[2] + m[4];
        p[pos + 1] = p0 * m[1] + p1 * m[3] + m[5];
    }
    static applyTransformToBezier(p, transform, pos = 0) {
        const m0 = transform[0];
        const m1 = transform[1];
        const m2 = transform[2];
        const m3 = transform[3];
        const m4 = transform[4];
        const m5 = transform[5];
        for(let i = 0; i < 6; i += 2){
            const pI = p[pos + i];
            const pI1 = p[pos + i + 1];
            p[pos + i] = pI * m0 + pI1 * m2 + m4;
            p[pos + i + 1] = pI * m1 + pI1 * m3 + m5;
        }
    }
    static applyInverseTransform(p, m) {
        const p0 = p[0];
        const p1 = p[1];
        const d = m[0] * m[3] - m[1] * m[2];
        p[0] = (p0 * m[3] - p1 * m[2] + m[2] * m[5] - m[4] * m[3]) / d;
        p[1] = (-p0 * m[1] + p1 * m[0] + m[4] * m[1] - m[5] * m[0]) / d;
    }
    static axialAlignedBoundingBox(rect, transform, output) {
        const m0 = transform[0];
        const m1 = transform[1];
        const m2 = transform[2];
        const m3 = transform[3];
        const m4 = transform[4];
        const m5 = transform[5];
        const r0 = rect[0];
        const r1 = rect[1];
        const r2 = rect[2];
        const r3 = rect[3];
        let a0 = m0 * r0 + m4;
        let a2 = a0;
        let a1 = m0 * r2 + m4;
        let a3 = a1;
        let b0 = m3 * r1 + m5;
        let b2 = b0;
        let b1 = m3 * r3 + m5;
        let b3 = b1;
        if (m1 !== 0 || m2 !== 0) {
            const m1r0 = m1 * r0;
            const m1r2 = m1 * r2;
            const m2r1 = m2 * r1;
            const m2r3 = m2 * r3;
            a0 += m2r1;
            a3 += m2r1;
            a1 += m2r3;
            a2 += m2r3;
            b0 += m1r0;
            b3 += m1r0;
            b1 += m1r2;
            b2 += m1r2;
        }
        output[0] = Math.min(output[0], a0, a1, a2, a3);
        output[1] = Math.min(output[1], b0, b1, b2, b3);
        output[2] = Math.max(output[2], a0, a1, a2, a3);
        output[3] = Math.max(output[3], b0, b1, b2, b3);
    }
    static inverseTransform(m) {
        const d = m[0] * m[3] - m[1] * m[2];
        return [
            m[3] / d,
            -m[1] / d,
            -m[2] / d,
            m[0] / d,
            (m[2] * m[5] - m[4] * m[3]) / d,
            (m[4] * m[1] - m[5] * m[0]) / d
        ];
    }
    static singularValueDecompose2dScale(matrix, output) {
        const m0 = matrix[0];
        const m1 = matrix[1];
        const m2 = matrix[2];
        const m3 = matrix[3];
        const a = m0 ** 2 + m1 ** 2;
        const b = m0 * m2 + m1 * m3;
        const c = m2 ** 2 + m3 ** 2;
        const first = (a + c) / 2;
        const second = Math.sqrt(first ** 2 - (a * c - b ** 2));
        output[0] = Math.sqrt(first + second || 1);
        output[1] = Math.sqrt(first - second || 1);
    }
    static normalizeRect(rect) {
        const r = rect.slice(0);
        if (rect[0] > rect[2]) {
            r[0] = rect[2];
            r[2] = rect[0];
        }
        if (rect[1] > rect[3]) {
            r[1] = rect[3];
            r[3] = rect[1];
        }
        return r;
    }
    static intersect(rect1, rect2) {
        const xLow = Math.max(Math.min(rect1[0], rect1[2]), Math.min(rect2[0], rect2[2]));
        const xHigh = Math.min(Math.max(rect1[0], rect1[2]), Math.max(rect2[0], rect2[2]));
        if (xLow > xHigh) return null;
        const yLow = Math.max(Math.min(rect1[1], rect1[3]), Math.min(rect2[1], rect2[3]));
        const yHigh = Math.min(Math.max(rect1[1], rect1[3]), Math.max(rect2[1], rect2[3]));
        if (yLow > yHigh) return null;
        return [
            xLow,
            yLow,
            xHigh,
            yHigh
        ];
    }
    static pointBoundingBox(x, y, minMax) {
        minMax[0] = Math.min(minMax[0], x);
        minMax[1] = Math.min(minMax[1], y);
        minMax[2] = Math.max(minMax[2], x);
        minMax[3] = Math.max(minMax[3], y);
    }
    static rectBoundingBox(x0, y0, x1, y1, minMax) {
        minMax[0] = Math.min(minMax[0], x0, x1);
        minMax[1] = Math.min(minMax[1], y0, y1);
        minMax[2] = Math.max(minMax[2], x0, x1);
        minMax[3] = Math.max(minMax[3], y0, y1);
    }
    static #getExtremumOnCurve(x0, x1, x2, x3, y0, y1, y2, y3, t, minMax) {
        if (t <= 0 || t >= 1) return;
        const mt = 1 - t;
        const tt = t * t;
        const ttt = tt * t;
        const x = mt * (mt * (mt * x0 + 3 * t * x1) + 3 * tt * x2) + ttt * x3;
        const y = mt * (mt * (mt * y0 + 3 * t * y1) + 3 * tt * y2) + ttt * y3;
        minMax[0] = Math.min(minMax[0], x);
        minMax[1] = Math.min(minMax[1], y);
        minMax[2] = Math.max(minMax[2], x);
        minMax[3] = Math.max(minMax[3], y);
    }
    static #getExtremum(x0, x1, x2, x3, y0, y1, y2, y3, a, b, c, minMax) {
        if (Math.abs(a) < 1e-12) {
            if (Math.abs(b) >= 1e-12) this.#getExtremumOnCurve(x0, x1, x2, x3, y0, y1, y2, y3, -c / b, minMax);
            return;
        }
        const delta = b ** 2 - 4 * c * a;
        if (delta < 0) return;
        const sqrtDelta = Math.sqrt(delta);
        const a2 = 2 * a;
        this.#getExtremumOnCurve(x0, x1, x2, x3, y0, y1, y2, y3, (-b + sqrtDelta) / a2, minMax);
        this.#getExtremumOnCurve(x0, x1, x2, x3, y0, y1, y2, y3, (-b - sqrtDelta) / a2, minMax);
    }
    static bezierBoundingBox(x0, y0, x1, y1, x2, y2, x3, y3, minMax) {
        minMax[0] = Math.min(minMax[0], x0, x3);
        minMax[1] = Math.min(minMax[1], y0, y3);
        minMax[2] = Math.max(minMax[2], x0, x3);
        minMax[3] = Math.max(minMax[3], y0, y3);
        this.#getExtremum(x0, x1, x2, x3, y0, y1, y2, y3, 3 * (-x0 + 3 * (x1 - x2) + x3), 6 * (x0 - 2 * x1 + x2), 3 * (x1 - x0), minMax);
        this.#getExtremum(x0, x1, x2, x3, y0, y1, y2, y3, 3 * (-y0 + 3 * (y1 - y2) + y3), 6 * (y0 - 2 * y1 + y2), 3 * (y1 - y0), minMax);
    }
}
const $b3a01b20dd2ade98$var$PDFStringTranslateTable = /* unused pure expression or super */ null;
function $b3a01b20dd2ade98$var$stringToPDFString(str, keepEscapeSequence = false) {
    if (str[0] >= "\xEF") {
        let encoding;
        if (str[0] === "\xFE" && str[1] === "\xFF") {
            encoding = "utf-16be";
            if (str.length % 2 === 1) str = str.slice(0, -1);
        } else if (str[0] === "\xFF" && str[1] === "\xFE") {
            encoding = "utf-16le";
            if (str.length % 2 === 1) str = str.slice(0, -1);
        } else if (str[0] === "\xEF" && str[1] === "\xBB" && str[2] === "\xBF") encoding = "utf-8";
        if (encoding) try {
            const decoder = new TextDecoder(encoding, {
                fatal: true
            });
            const buffer = $b3a01b20dd2ade98$var$stringToBytes(str);
            const decoded = decoder.decode(buffer);
            if (keepEscapeSequence || !decoded.includes("\x1b")) return decoded;
            return decoded.replaceAll(/\x1b[^\x1b]*(?:\x1b|$)/g, "");
        } catch (ex) {
            $b3a01b20dd2ade98$var$warn(`stringToPDFString: "${ex}".`);
        }
    }
    const strBuf = [];
    for(let i = 0, ii = str.length; i < ii; i++){
        const charCode = str.charCodeAt(i);
        if (!keepEscapeSequence && charCode === 0x1b) {
            while(++i < ii && str.charCodeAt(i) !== 0x1b);
            continue;
        }
        const code = $b3a01b20dd2ade98$var$PDFStringTranslateTable[charCode];
        strBuf.push(code ? String.fromCharCode(code) : str.charAt(i));
    }
    return strBuf.join("");
}
function $b3a01b20dd2ade98$var$stringToUTF8String(str) {
    return decodeURIComponent(escape(str));
}
function $b3a01b20dd2ade98$var$utf8StringToString(str) {
    return unescape(encodeURIComponent(str));
}
function $b3a01b20dd2ade98$var$isArrayEqual(arr1, arr2) {
    if (arr1.length !== arr2.length) return false;
    for(let i = 0, ii = arr1.length; i < ii; i++){
        if (arr1[i] !== arr2[i]) return false;
    }
    return true;
}
function $b3a01b20dd2ade98$var$getModificationDate(date = new Date()) {
    if (!(date instanceof Date)) date = new Date(date);
    const buffer = [
        date.getUTCFullYear().toString(),
        (date.getUTCMonth() + 1).toString().padStart(2, "0"),
        date.getUTCDate().toString().padStart(2, "0"),
        date.getUTCHours().toString().padStart(2, "0"),
        date.getUTCMinutes().toString().padStart(2, "0"),
        date.getUTCSeconds().toString().padStart(2, "0")
    ];
    return buffer.join("");
}
let $b3a01b20dd2ade98$var$NormalizeRegex = null;
let $b3a01b20dd2ade98$var$NormalizationMap = null;
function $b3a01b20dd2ade98$export$1fa1e6b1a06bd7fa(str) {
    if (!$b3a01b20dd2ade98$var$NormalizeRegex) {
        $b3a01b20dd2ade98$var$NormalizeRegex = /([\u00a0\u00b5\u037e\u0eb3\u2000-\u200a\u202f\u2126\ufb00-\ufb04\ufb06\ufb20-\ufb36\ufb38-\ufb3c\ufb3e\ufb40-\ufb41\ufb43-\ufb44\ufb46-\ufba1\ufba4-\ufba9\ufbae-\ufbb1\ufbd3-\ufbdc\ufbde-\ufbe7\ufbea-\ufbf8\ufbfc-\ufbfd\ufc00-\ufc5d\ufc64-\ufcf1\ufcf5-\ufd3d\ufd88\ufdf4\ufdfa-\ufdfb\ufe71\ufe77\ufe79\ufe7b\ufe7d]+)|(\ufb05+)/gu;
        $b3a01b20dd2ade98$var$NormalizationMap = new Map([
            [
                "\uFB05",
                "\u017Ft"
            ]
        ]);
    }
    return str.replaceAll($b3a01b20dd2ade98$var$NormalizeRegex, (_, p1, p2)=>p1 ? p1.normalize("NFKC") : $b3a01b20dd2ade98$var$NormalizationMap.get(p2));
}
function $b3a01b20dd2ade98$export$75f13a91ebdf8eb3() {
    if (typeof crypto.randomUUID === "function") return crypto.randomUUID();
    const buf = new Uint8Array(32);
    crypto.getRandomValues(buf);
    return $b3a01b20dd2ade98$var$bytesToString(buf);
}
const $b3a01b20dd2ade98$var$AnnotationPrefix = "pdfjs_internal_id_";
function $b3a01b20dd2ade98$var$_isValidExplicitDest(validRef, validName, dest) {
    if (!Array.isArray(dest) || dest.length < 2) return false;
    const [page, zoom, ...args] = dest;
    if (!validRef(page) && !Number.isInteger(page)) return false;
    if (!validName(zoom)) return false;
    const argsLen = args.length;
    let allowNull = true;
    switch(zoom.name){
        case "XYZ":
            if (argsLen < 2 || argsLen > 3) return false;
            break;
        case "Fit":
        case "FitB":
            return argsLen === 0;
        case "FitH":
        case "FitBH":
        case "FitV":
        case "FitBV":
            if (argsLen > 1) return false;
            break;
        case "FitR":
            if (argsLen !== 4) return false;
            allowNull = false;
            break;
        default:
            return false;
    }
    for (const arg of args){
        if (typeof arg === "number" || allowNull && arg === null) continue;
        return false;
    }
    return true;
}
const $b3a01b20dd2ade98$export$be9af9a47496243a = ()=>[];
const $b3a01b20dd2ade98$export$b41394a5437791c8 = ()=>new Map();
const $b3a01b20dd2ade98$export$5b3b706fb9845c88 = ()=>Object.create(null);
function $b3a01b20dd2ade98$export$b8106b171181a554(v, min, max) {
    return Math.min(Math.max(v, min), max);
}
if (typeof Math.sumPrecise !== "function") Math.sumPrecise = function(numbers) {
    return numbers.reduce((a, b)=>a + b, 0);
};
class $b3a01b20dd2ade98$var$XfaText {
    static textContent(xfa) {
        const items = [];
        const output = {
            items: items,
            styles: Object.create(null)
        };
        function walk(node) {
            if (!node) return;
            let str = null;
            const name = node.name;
            if (name === "#text") str = node.value;
            else if (!$b3a01b20dd2ade98$var$XfaText.shouldBuildText(name)) return;
            else if (node?.attributes?.textContent) str = node.attributes.textContent;
            else if (node.value) str = node.value;
            if (str !== null) items.push({
                str: str
            });
            if (!node.children) return;
            for (const child of node.children)walk(child);
        }
        walk(xfa);
        return output;
    }
    static shouldBuildText(name) {
        return !(name === "textarea" || name === "input" || name === "option" || name === "select");
    }
}
class $b3a01b20dd2ade98$export$f6af20c312d4b9a2 {
    static setupStorage(html, id, element, storage, intent) {
        const storedData = storage.getValue(id, {
            value: null
        });
        switch(element.name){
            case "textarea":
                if (storedData.value !== null) html.textContent = storedData.value;
                if (intent === "print") break;
                html.addEventListener("input", (event)=>{
                    storage.setValue(id, {
                        value: event.target.value
                    });
                });
                break;
            case "input":
                if (element.attributes.type === "radio" || element.attributes.type === "checkbox") {
                    if (storedData.value === element.attributes.xfaOn) html.setAttribute("checked", true);
                    else if (storedData.value === element.attributes.xfaOff) html.removeAttribute("checked");
                    if (intent === "print") break;
                    html.addEventListener("change", (event)=>{
                        storage.setValue(id, {
                            value: event.target.checked ? event.target.getAttribute("xfaOn") : event.target.getAttribute("xfaOff")
                        });
                    });
                } else {
                    if (storedData.value !== null) html.setAttribute("value", storedData.value);
                    if (intent === "print") break;
                    html.addEventListener("input", (event)=>{
                        storage.setValue(id, {
                            value: event.target.value
                        });
                    });
                }
                break;
            case "select":
                if (storedData.value !== null) {
                    html.setAttribute("value", storedData.value);
                    for (const option of element.children){
                        if (option.attributes.value === storedData.value) option.attributes.selected = true;
                        else if (option.attributes.hasOwnProperty("selected")) delete option.attributes.selected;
                    }
                }
                html.addEventListener("input", (event)=>{
                    const options = event.target.options;
                    const value = options.selectedIndex === -1 ? "" : options[options.selectedIndex].value;
                    storage.setValue(id, {
                        value: value
                    });
                });
                break;
        }
    }
    static setAttributes({ html: html, element: element, storage: storage = null, intent: intent, linkService: linkService }) {
        const { attributes: attributes } = element;
        const isHTMLAnchorElement = html instanceof HTMLAnchorElement;
        if (attributes.type === "radio") attributes.name = `${attributes.name}-${intent}`;
        for (const [key, value] of Object.entries(attributes)){
            if (value === null || value === undefined) continue;
            switch(key){
                case "class":
                    if (value.length) html.setAttribute(key, value.join(" "));
                    break;
                case "dataId":
                    break;
                case "id":
                    html.setAttribute("data-element-id", value);
                    break;
                case "style":
                    Object.assign(html.style, value);
                    break;
                case "textContent":
                    html.textContent = value;
                    break;
                default:
                    if (!isHTMLAnchorElement || key !== "href" && key !== "newWindow") html.setAttribute(key, value);
            }
        }
        if (isHTMLAnchorElement) linkService.addLinkAttributes(html, attributes.href, attributes.newWindow);
        if (storage && attributes.dataId) this.setupStorage(html, attributes.dataId, element, storage);
    }
    static render(parameters) {
        const storage = parameters.annotationStorage;
        const linkService = parameters.linkService;
        const root = parameters.xfaHtml;
        const intent = parameters.intent || "display";
        const rootHtml = document.createElement(root.name);
        if (root.attributes) this.setAttributes({
            html: rootHtml,
            element: root,
            intent: intent,
            linkService: linkService
        });
        const isNotForRichText = intent !== "richText";
        const rootDiv = parameters.div;
        rootDiv.append(rootHtml);
        if (parameters.viewport) {
            const transform = `matrix(${parameters.viewport.transform.join(",")})`;
            rootDiv.style.transform = transform;
        }
        if (isNotForRichText) rootDiv.setAttribute("class", "xfaLayer xfaFont");
        const textDivs = [];
        if (root.children.length === 0) {
            if (root.value) {
                const node = document.createTextNode(root.value);
                rootHtml.append(node);
                if (isNotForRichText && $b3a01b20dd2ade98$var$XfaText.shouldBuildText(root.name)) textDivs.push(node);
            }
            return {
                textDivs: textDivs
            };
        }
        const stack = [
            [
                root,
                -1,
                rootHtml
            ]
        ];
        while(stack.length > 0){
            const [parent, i, html] = stack.at(-1);
            if (i + 1 === parent.children.length) {
                stack.pop();
                continue;
            }
            const child = parent.children[++stack.at(-1)[1]];
            if (child === null) continue;
            const { name: name } = child;
            if (name === "#text") {
                const node = document.createTextNode(child.value);
                textDivs.push(node);
                html.append(node);
                continue;
            }
            const childHtml = child?.attributes?.xmlns ? document.createElementNS(child.attributes.xmlns, name) : document.createElement(name);
            html.append(childHtml);
            if (child.attributes) this.setAttributes({
                html: childHtml,
                element: child,
                storage: storage,
                intent: intent,
                linkService: linkService
            });
            if (child.children?.length > 0) stack.push([
                child,
                -1,
                childHtml
            ]);
            else if (child.value) {
                const node = document.createTextNode(child.value);
                if (isNotForRichText && $b3a01b20dd2ade98$var$XfaText.shouldBuildText(name)) textDivs.push(node);
                childHtml.append(node);
            }
        }
        for (const el of rootDiv.querySelectorAll(".xfaNonInteractive input, .xfaNonInteractive textarea"))el.setAttribute("readOnly", true);
        return {
            textDivs: textDivs
        };
    }
    static update(parameters) {
        const transform = `matrix(${parameters.viewport.transform.join(",")})`;
        parameters.div.style.transform = transform;
        parameters.div.hidden = false;
    }
}
const $b3a01b20dd2ade98$var$SVG_NS = "http://www.w3.org/2000/svg";
class $b3a01b20dd2ade98$export$6ef3b6b69e65342c {
    static CSS = 96.0;
    static PDF = 72.0;
    static PDF_TO_CSS_UNITS = this.CSS / this.PDF;
}
async function $b3a01b20dd2ade98$export$8134c072fddab6a5(url, type = "text") {
    if ($b3a01b20dd2ade98$var$isValidFetchUrl(url, document.baseURI)) {
        const response = await fetch(url);
        if (!response.ok) throw new Error(response.statusText);
        switch(type){
            case "blob":
                return response.blob();
            case "bytes":
                return response.bytes();
            case "json":
                return response.json();
        }
        return response.text();
    }
    return new Promise((resolve, reject)=>{
        const request = new XMLHttpRequest();
        request.open("GET", url, true);
        request.responseType = type === "bytes" ? "arraybuffer" : type;
        request.onreadystatechange = ()=>{
            if (request.readyState !== XMLHttpRequest.DONE) return;
            if (request.status === 200 || request.status === 0) {
                switch(type){
                    case "bytes":
                        resolve(new Uint8Array(request.response));
                        return;
                    case "blob":
                    case "json":
                        resolve(request.response);
                        return;
                }
                resolve(request.responseText);
                return;
            }
            reject(new Error(request.statusText));
        };
        request.send(null);
    });
}
class $b3a01b20dd2ade98$var$PageViewport {
    constructor({ viewBox: viewBox, userUnit: userUnit, scale: scale, rotation: rotation, offsetX: offsetX = 0, offsetY: offsetY = 0, dontFlip: dontFlip = false }){
        this.viewBox = viewBox;
        this.userUnit = userUnit;
        this.scale = scale;
        this.rotation = rotation;
        this.offsetX = offsetX;
        this.offsetY = offsetY;
        scale *= userUnit;
        const centerX = (viewBox[2] + viewBox[0]) / 2;
        const centerY = (viewBox[3] + viewBox[1]) / 2;
        let rotateA, rotateB, rotateC, rotateD;
        rotation %= 360;
        if (rotation < 0) rotation += 360;
        switch(rotation){
            case 180:
                rotateA = -1;
                rotateB = 0;
                rotateC = 0;
                rotateD = 1;
                break;
            case 90:
                rotateA = 0;
                rotateB = 1;
                rotateC = 1;
                rotateD = 0;
                break;
            case 270:
                rotateA = 0;
                rotateB = -1;
                rotateC = -1;
                rotateD = 0;
                break;
            case 0:
                rotateA = 1;
                rotateB = 0;
                rotateC = 0;
                rotateD = -1;
                break;
            default:
                throw new Error("PageViewport: Invalid rotation, must be a multiple of 90 degrees.");
        }
        if (dontFlip) {
            rotateC = -rotateC;
            rotateD = -rotateD;
        }
        let offsetCanvasX, offsetCanvasY;
        let width, height;
        if (rotateA === 0) {
            offsetCanvasX = Math.abs(centerY - viewBox[1]) * scale + offsetX;
            offsetCanvasY = Math.abs(centerX - viewBox[0]) * scale + offsetY;
            width = (viewBox[3] - viewBox[1]) * scale;
            height = (viewBox[2] - viewBox[0]) * scale;
        } else {
            offsetCanvasX = Math.abs(centerX - viewBox[0]) * scale + offsetX;
            offsetCanvasY = Math.abs(centerY - viewBox[1]) * scale + offsetY;
            width = (viewBox[2] - viewBox[0]) * scale;
            height = (viewBox[3] - viewBox[1]) * scale;
        }
        this.transform = [
            rotateA * scale,
            rotateB * scale,
            rotateC * scale,
            rotateD * scale,
            offsetCanvasX - rotateA * scale * centerX - rotateC * scale * centerY,
            offsetCanvasY - rotateB * scale * centerX - rotateD * scale * centerY
        ];
        this.width = width;
        this.height = height;
    }
    get rawDims() {
        const dims = this.viewBox;
        return $b3a01b20dd2ade98$export$b8972b998723d602(this, "rawDims", {
            pageWidth: dims[2] - dims[0],
            pageHeight: dims[3] - dims[1],
            pageX: dims[0],
            pageY: dims[1]
        });
    }
    clone({ scale: scale = this.scale, rotation: rotation = this.rotation, offsetX: offsetX = this.offsetX, offsetY: offsetY = this.offsetY, dontFlip: dontFlip = false } = {}) {
        return new $b3a01b20dd2ade98$var$PageViewport({
            viewBox: this.viewBox.slice(),
            userUnit: this.userUnit,
            scale: scale,
            rotation: rotation,
            offsetX: offsetX,
            offsetY: offsetY,
            dontFlip: dontFlip
        });
    }
    convertToViewportPoint(x, y) {
        const p = [
            x,
            y
        ];
        $b3a01b20dd2ade98$export$f8f26dd395d7e1bd.applyTransform(p, this.transform);
        return p;
    }
    convertToViewportRectangle(rect) {
        const topLeft = [
            rect[0],
            rect[1]
        ];
        $b3a01b20dd2ade98$export$f8f26dd395d7e1bd.applyTransform(topLeft, this.transform);
        const bottomRight = [
            rect[2],
            rect[3]
        ];
        $b3a01b20dd2ade98$export$f8f26dd395d7e1bd.applyTransform(bottomRight, this.transform);
        return [
            topLeft[0],
            topLeft[1],
            bottomRight[0],
            bottomRight[1]
        ];
    }
    convertToPdfPoint(x, y) {
        const p = [
            x,
            y
        ];
        $b3a01b20dd2ade98$export$f8f26dd395d7e1bd.applyInverseTransform(p, this.transform);
        return p;
    }
}
class $b3a01b20dd2ade98$export$245847d31c09154f extends $b3a01b20dd2ade98$var$BaseException {
    constructor(msg, extraDelay = 0){
        super(msg, "RenderingCancelledException");
        this.extraDelay = extraDelay;
    }
}
function $b3a01b20dd2ade98$export$f67aae4532d8295b(url) {
    const ii = url.length;
    let i = 0;
    while(i < ii && url[i].trim() === "")i++;
    return url.substring(i, i + 5).toLowerCase() === "data:";
}
function $b3a01b20dd2ade98$export$61b52d3570d24719(filename) {
    return typeof filename === "string" && /\.pdf$/i.test(filename);
}
function $b3a01b20dd2ade98$export$b1c11df0696253ae(url) {
    [url] = url.split(/[#?]/, 1);
    return $b3a01b20dd2ade98$var$stripPath(url);
}
function $b3a01b20dd2ade98$export$9de51790aa4bc73a(url, defaultFilename = "document.pdf") {
    if (typeof url !== "string") return defaultFilename;
    if ($b3a01b20dd2ade98$export$f67aae4532d8295b(url)) {
        $b3a01b20dd2ade98$var$warn('getPdfFilenameFromUrl: ignore "data:"-URL for performance reasons.');
        return defaultFilename;
    }
    const getURL = (urlString)=>{
        try {
            return new URL(urlString);
        } catch  {
            try {
                return new URL(decodeURIComponent(urlString));
            } catch  {
                try {
                    return new URL(urlString, "https://foo.bar");
                } catch  {
                    try {
                        return new URL(decodeURIComponent(urlString), "https://foo.bar");
                    } catch  {
                        return null;
                    }
                }
            }
        }
    };
    const newURL = getURL(url);
    if (!newURL) return defaultFilename;
    const decode = (name)=>{
        try {
            let decoded = decodeURIComponent(name);
            if (decoded.includes("/")) {
                decoded = $b3a01b20dd2ade98$var$stripPath(decoded);
                if (/^\.pdf$/i.test(decoded)) return name;
            }
            return decoded;
        } catch  {
            return name;
        }
    };
    const pdfRegex = /\.pdf$/i;
    const filename = $b3a01b20dd2ade98$var$stripPath(newURL.pathname);
    if (pdfRegex.test(filename)) return decode(filename);
    if (newURL.searchParams.size > 0) {
        const getLast = (iterator)=>[
                ...iterator
            ].findLast((v)=>pdfRegex.test(v));
        const name = getLast(newURL.searchParams.values()) ?? getLast(newURL.searchParams.keys());
        if (name) return decode(name);
    }
    if (newURL.hash) {
        const reFilename = /[^/?#=]+\.pdf\b(?!.*\.pdf\b)/i;
        const hashFilename = reFilename.exec(newURL.hash);
        if (hashFilename) return decode(hashFilename[0]);
    }
    return defaultFilename;
}
class $b3a01b20dd2ade98$var$StatTimer {
    #started = new Map();
    times = [];
    time(name) {
        if (this.#started.has(name)) $b3a01b20dd2ade98$var$warn(`Timer is already running for ${name}`);
        this.#started.set(name, Date.now());
    }
    timeEnd(name) {
        if (!this.#started.has(name)) $b3a01b20dd2ade98$var$warn(`Timer has not been started for ${name}`);
        this.times.push({
            name: name,
            start: this.#started.get(name),
            end: Date.now()
        });
        this.#started.delete(name);
    }
    toString() {
        const longest = Math.max(...this.times.map((t)=>t.name.length));
        return this.times.map((t)=>`${t.name.padEnd(longest)} ${t.end - t.start}ms\n`).join("");
    }
}
function $b3a01b20dd2ade98$var$isValidFetchUrl(url, baseUrl) {
    const res = baseUrl ? URL.parse(url, baseUrl) : URL.parse(url);
    return /https?:/.test(res?.protocol ?? "");
}
function $b3a01b20dd2ade98$export$455b7811f904cadc(e) {
    e.preventDefault();
}
function $b3a01b20dd2ade98$export$7ae4cd3a66c1e050(e) {
    e.preventDefault();
    e.stopPropagation();
}
function $b3a01b20dd2ade98$var$deprecated(details) {
    console.log("Deprecated API usage: " + details);
}
class $b3a01b20dd2ade98$export$66cbc314498fffc {
    static #regex;
    static toDateObject(input) {
        if (input instanceof Date) return input;
        if (!input || typeof input !== "string") return null;
        this.#regex ||= new RegExp("^D:(\\d{4})(\\d{2})?(\\d{2})?(\\d{2})?(\\d{2})?(\\d{2})?([Z|+|-])?(\\d{2})?'?(\\d{2})?'?");
        const matches = this.#regex.exec(input);
        if (!matches) return null;
        const year = parseInt(matches[1], 10);
        let month = parseInt(matches[2], 10);
        month = month >= 1 && month <= 12 ? month - 1 : 0;
        let day = parseInt(matches[3], 10);
        day = day >= 1 && day <= 31 ? day : 1;
        let hour = parseInt(matches[4], 10);
        hour = hour >= 0 && hour <= 23 ? hour : 0;
        let minute = parseInt(matches[5], 10);
        minute = minute >= 0 && minute <= 59 ? minute : 0;
        let second = parseInt(matches[6], 10);
        second = second >= 0 && second <= 59 ? second : 0;
        const universalTimeRelation = matches[7] || "Z";
        let offsetHour = parseInt(matches[8], 10);
        offsetHour = offsetHour >= 0 && offsetHour <= 23 ? offsetHour : 0;
        let offsetMinute = parseInt(matches[9], 10) || 0;
        offsetMinute = offsetMinute >= 0 && offsetMinute <= 59 ? offsetMinute : 0;
        if (universalTimeRelation === "-") {
            hour += offsetHour;
            minute += offsetMinute;
        } else if (universalTimeRelation === "+") {
            hour -= offsetHour;
            minute -= offsetMinute;
        }
        return new Date(Date.UTC(year, month, day, hour, minute, second));
    }
}
function $b3a01b20dd2ade98$export$dd5d6edf3fc80aae(xfaPage, { scale: scale = 1, rotation: rotation = 0 }) {
    const { width: width, height: height } = xfaPage.attributes.style;
    const viewBox = [
        0,
        0,
        parseInt(width),
        parseInt(height)
    ];
    return new $b3a01b20dd2ade98$var$PageViewport({
        viewBox: viewBox,
        userUnit: 1,
        scale: scale,
        rotation: rotation
    });
}
function $b3a01b20dd2ade98$export$2a2e9b507863ddda(color) {
    if (color.startsWith("#")) {
        const colorRGB = parseInt(color.slice(1), 16);
        return [
            (colorRGB & 0xff0000) >> 16,
            (colorRGB & 0x00ff00) >> 8,
            colorRGB & 0x0000ff
        ];
    }
    if (color.startsWith("rgb(")) return color.slice(4, -1).split(",").map((x)=>parseInt(x));
    if (color.startsWith("rgba(")) return color.slice(5, -1).split(",", 3).map((x)=>parseInt(x));
    $b3a01b20dd2ade98$var$warn(`Not a valid color format: "${color}"`);
    return [
        0,
        0,
        0
    ];
}
function $b3a01b20dd2ade98$var$getColorValues(colors) {
    const span = document.createElement("span");
    span.style.visibility = "hidden";
    span.style.colorScheme = "only light";
    document.body.append(span);
    for (const name of colors.keys()){
        span.style.color = name;
        const computedColor = window.getComputedStyle(span).color;
        colors.set(name, $b3a01b20dd2ade98$export$2a2e9b507863ddda(computedColor));
    }
    span.remove();
}
function $b3a01b20dd2ade98$var$getCurrentTransform(ctx) {
    const { a: a, b: b, c: c, d: d, e: e, f: f } = ctx.getTransform();
    return [
        a,
        b,
        c,
        d,
        e,
        f
    ];
}
function $b3a01b20dd2ade98$var$getCurrentTransformInverse(ctx) {
    const { a: a, b: b, c: c, d: d, e: e, f: f } = ctx.getTransform().invertSelf();
    return [
        a,
        b,
        c,
        d,
        e,
        f
    ];
}
function $b3a01b20dd2ade98$export$af0a15a86e590226(div, viewport, mustFlip = false, mustRotate = true) {
    if (viewport instanceof $b3a01b20dd2ade98$var$PageViewport) {
        const { pageWidth: pageWidth, pageHeight: pageHeight } = viewport.rawDims;
        const { style: style } = div;
        const useRound = $b3a01b20dd2ade98$export$5fb8891d35c36978.isCSSRoundSupported;
        const w = `var(--total-scale-factor) * ${pageWidth}px`, h = `var(--total-scale-factor) * ${pageHeight}px`;
        const widthStr = useRound ? `round(down, ${w}, var(--scale-round-x))` : `calc(${w})`, heightStr = useRound ? `round(down, ${h}, var(--scale-round-y))` : `calc(${h})`;
        if (!mustFlip || viewport.rotation % 180 === 0) {
            style.width = widthStr;
            style.height = heightStr;
        } else {
            style.width = heightStr;
            style.height = widthStr;
        }
    }
    if (mustRotate) div.setAttribute("data-main-rotation", viewport.rotation);
}
class $b3a01b20dd2ade98$export$f16a99f63bccd50b {
    constructor(){
        const { pixelRatio: pixelRatio } = $b3a01b20dd2ade98$export$f16a99f63bccd50b;
        this.sx = pixelRatio;
        this.sy = pixelRatio;
    }
    get scaled() {
        return this.sx !== 1 || this.sy !== 1;
    }
    get symmetric() {
        return this.sx === this.sy;
    }
    limitCanvas(width, height, maxPixels, maxDim, capAreaFactor = -1) {
        let maxAreaScale = Infinity, maxWidthScale = Infinity, maxHeightScale = Infinity;
        maxPixels = $b3a01b20dd2ade98$export$f16a99f63bccd50b.capPixels(maxPixels, capAreaFactor);
        if (maxPixels > 0) maxAreaScale = Math.sqrt(maxPixels / (width * height));
        if (maxDim !== -1) {
            maxWidthScale = maxDim / width;
            maxHeightScale = maxDim / height;
        }
        const maxScale = Math.min(maxAreaScale, maxWidthScale, maxHeightScale);
        if (this.sx > maxScale || this.sy > maxScale) {
            this.sx = maxScale;
            this.sy = maxScale;
            return true;
        }
        return false;
    }
    static get pixelRatio() {
        return globalThis.devicePixelRatio || 1;
    }
    static capPixels(maxPixels, capAreaFactor) {
        if (capAreaFactor >= 0) {
            const winPixels = Math.ceil(window.screen.availWidth * window.screen.availHeight * this.pixelRatio ** 2 * (1 + capAreaFactor / 100));
            return maxPixels > 0 ? Math.min(maxPixels, winPixels) : winPixels;
        }
        return maxPixels;
    }
}
const $b3a01b20dd2ade98$export$3234c88e9de64a88 = [
    "image/apng",
    "image/avif",
    "image/bmp",
    "image/gif",
    "image/jpeg",
    "image/png",
    "image/svg+xml",
    "image/webp",
    "image/x-icon"
];
class $b3a01b20dd2ade98$var$ColorScheme {
    static get isDarkMode() {
        return $b3a01b20dd2ade98$export$b8972b998723d602(this, "isDarkMode", !!window?.matchMedia?.("(prefers-color-scheme: dark)").matches);
    }
}
class $b3a01b20dd2ade98$export$cec677744f6a5015 {
    static get commentForegroundColor() {
        const element = document.createElement("span");
        element.classList.add("comment", "sidebar");
        const { style: style } = element;
        style.width = style.height = "0";
        style.display = "none";
        style.color = "var(--comment-fg-color)";
        document.body.append(element);
        const { color: color } = window.getComputedStyle(element);
        element.remove();
        return $b3a01b20dd2ade98$export$b8972b998723d602(this, "commentForegroundColor", $b3a01b20dd2ade98$export$2a2e9b507863ddda(color));
    }
}
function $b3a01b20dd2ade98$export$f8d1472813e87bf9(color, opacity) {
    opacity = $b3a01b20dd2ade98$export$b8106b171181a554(opacity ?? 1, 0, 1);
    const white = 255 * (1 - opacity);
    return color.map((c)=>Math.round(c * opacity + white));
}
function $b3a01b20dd2ade98$var$RGBToHSL(rgb, output) {
    const r = rgb[0] / 255;
    const g = rgb[1] / 255;
    const b = rgb[2] / 255;
    const max = Math.max(r, g, b);
    const min = Math.min(r, g, b);
    const l = (max + min) / 2;
    if (max === min) output[0] = output[1] = 0;
    else {
        const d = max - min;
        output[1] = l < 0.5 ? d / (max + min) : d / (2 - max - min);
        switch(max){
            case r:
                output[0] = ((g - b) / d + (g < b ? 6 : 0)) * 60;
                break;
            case g:
                output[0] = ((b - r) / d + 2) * 60;
                break;
            case b:
                output[0] = ((r - g) / d + 4) * 60;
                break;
        }
    }
    output[2] = l;
}
function $b3a01b20dd2ade98$var$HSLToRGB(hsl, output) {
    const h = hsl[0];
    const s = hsl[1];
    const l = hsl[2];
    const c = (1 - Math.abs(2 * l - 1)) * s;
    const x = c * (1 - Math.abs(h / 60 % 2 - 1));
    const m = l - c / 2;
    switch(Math.floor(h / 60)){
        case 0:
            output[0] = c + m;
            output[1] = x + m;
            output[2] = m;
            break;
        case 1:
            output[0] = x + m;
            output[1] = c + m;
            output[2] = m;
            break;
        case 2:
            output[0] = m;
            output[1] = c + m;
            output[2] = x + m;
            break;
        case 3:
            output[0] = m;
            output[1] = x + m;
            output[2] = c + m;
            break;
        case 4:
            output[0] = x + m;
            output[1] = m;
            output[2] = c + m;
            break;
        case 5:
        case 6:
            output[0] = c + m;
            output[1] = m;
            output[2] = x + m;
            break;
    }
}
function $b3a01b20dd2ade98$var$computeLuminance(x) {
    return x <= 0.03928 ? x / 12.92 : ((x + 0.055) / 1.055) ** 2.4;
}
function $b3a01b20dd2ade98$var$contrastRatio(hsl1, hsl2, output) {
    $b3a01b20dd2ade98$var$HSLToRGB(hsl1, output);
    output.map($b3a01b20dd2ade98$var$computeLuminance);
    const lum1 = 0.2126 * output[0] + 0.7152 * output[1] + 0.0722 * output[2];
    $b3a01b20dd2ade98$var$HSLToRGB(hsl2, output);
    output.map($b3a01b20dd2ade98$var$computeLuminance);
    const lum2 = 0.2126 * output[0] + 0.7152 * output[1] + 0.0722 * output[2];
    return lum1 > lum2 ? (lum1 + 0.05) / (lum2 + 0.05) : (lum2 + 0.05) / (lum1 + 0.05);
}
const $b3a01b20dd2ade98$var$contrastCache = new Map();
function $b3a01b20dd2ade98$export$7a96203b1fdebe8d(baseColor, fixedColor) {
    const key = baseColor[0] + baseColor[1] * 0x100 + baseColor[2] * 0x10000 + fixedColor[0] * 0x1000000 + fixedColor[1] * 0x100000000 + fixedColor[2] * 0x10000000000;
    let cachedValue = $b3a01b20dd2ade98$var$contrastCache.get(key);
    if (cachedValue) return cachedValue;
    const array = new Float32Array(9);
    const output = array.subarray(0, 3);
    const baseHSL = array.subarray(3, 6);
    $b3a01b20dd2ade98$var$RGBToHSL(baseColor, baseHSL);
    const fixedHSL = array.subarray(6, 9);
    $b3a01b20dd2ade98$var$RGBToHSL(fixedColor, fixedHSL);
    const isFixedColorDark = fixedHSL[2] < 0.5;
    const minContrast = isFixedColorDark ? 12 : 4.5;
    baseHSL[2] = isFixedColorDark ? Math.sqrt(baseHSL[2]) : 1 - Math.sqrt(1 - baseHSL[2]);
    if ($b3a01b20dd2ade98$var$contrastRatio(baseHSL, fixedHSL, output) < minContrast) {
        let start, end;
        if (isFixedColorDark) {
            start = baseHSL[2];
            end = 1;
        } else {
            start = 0;
            end = baseHSL[2];
        }
        const PRECISION = 0.005;
        while(end - start > PRECISION){
            const mid = baseHSL[2] = (start + end) / 2;
            if (isFixedColorDark === $b3a01b20dd2ade98$var$contrastRatio(baseHSL, fixedHSL, output) < minContrast) start = mid;
            else end = mid;
        }
        baseHSL[2] = isFixedColorDark ? end : start;
    }
    $b3a01b20dd2ade98$var$HSLToRGB(baseHSL, output);
    cachedValue = $b3a01b20dd2ade98$export$f8f26dd395d7e1bd.makeHexColor(Math.round(output[0] * 255), Math.round(output[1] * 255), Math.round(output[2] * 255));
    $b3a01b20dd2ade98$var$contrastCache.set(key, cachedValue);
    return cachedValue;
}
function $b3a01b20dd2ade98$export$611c480766035c4({ html: html, dir: dir, className: className }, container) {
    const fragment = document.createDocumentFragment();
    if (typeof html === "string") {
        const p = document.createElement("p");
        p.dir = dir || "auto";
        const lines = html.split(/(?:\r\n?|\n)/);
        for(let i = 0, ii = lines.length; i < ii; ++i){
            const line = lines[i];
            p.append(document.createTextNode(line));
            if (i < ii - 1) p.append(document.createElement("br"));
        }
        fragment.append(p);
    } else $b3a01b20dd2ade98$export$f6af20c312d4b9a2.render({
        xfaHtml: html,
        div: fragment,
        intent: "richText"
    });
    fragment.firstElementChild.classList.add("richText", className);
    container.append(fragment);
}
function $b3a01b20dd2ade98$var$makePathFromDrawOPS(data) {
    const path = new Path2D();
    if (!data) return path;
    for(let i = 0, ii = data.length; i < ii;)switch(data[i++]){
        case $b3a01b20dd2ade98$var$DrawOPS.moveTo:
            path.moveTo(data[i++], data[i++]);
            break;
        case $b3a01b20dd2ade98$var$DrawOPS.lineTo:
            path.lineTo(data[i++], data[i++]);
            break;
        case $b3a01b20dd2ade98$var$DrawOPS.curveTo:
            path.bezierCurveTo(data[i++], data[i++], data[i++], data[i++], data[i++], data[i++]);
            break;
        case $b3a01b20dd2ade98$var$DrawOPS.quadraticCurveTo:
            path.quadraticCurveTo(data[i++], data[i++], data[i++], data[i++]);
            break;
        case $b3a01b20dd2ade98$var$DrawOPS.closePath:
            path.closePath();
            break;
        default:
            $b3a01b20dd2ade98$var$warn(`Unrecognized drawing path operator: ${data[i - 1]}`);
            break;
    }
    return path;
}
class $b3a01b20dd2ade98$var$EditorToolbar {
    #toolbar = null;
    #colorPicker = null;
    #editor;
    #buttons = null;
    #altText = null;
    #comment = null;
    #commentButtonDivider = null;
    #signatureDescriptionButton = null;
    static #l10nRemove = null;
    constructor(editor){
        this.#editor = editor;
        $b3a01b20dd2ade98$var$EditorToolbar.#l10nRemove ||= Object.freeze({
            freetext: "pdfjs-editor-remove-freetext-button",
            highlight: "pdfjs-editor-remove-highlight-button",
            ink: "pdfjs-editor-remove-ink-button",
            stamp: "pdfjs-editor-remove-stamp-button",
            signature: "pdfjs-editor-remove-signature-button"
        });
    }
    render() {
        const editToolbar = this.#toolbar = document.createElement("div");
        editToolbar.classList.add("editToolbar", "hidden");
        editToolbar.setAttribute("role", "toolbar");
        const signal = this.#editor._uiManager._signal;
        if (signal instanceof AbortSignal && !signal.aborted) {
            editToolbar.addEventListener("contextmenu", $b3a01b20dd2ade98$export$455b7811f904cadc, {
                signal: signal
            });
            editToolbar.addEventListener("pointerdown", $b3a01b20dd2ade98$var$EditorToolbar.#pointerDown, {
                signal: signal
            });
        }
        const buttons = this.#buttons = document.createElement("div");
        buttons.className = "buttons";
        editToolbar.append(buttons);
        const position = this.#editor.toolbarPosition;
        if (position) {
            const { style: style } = editToolbar;
            const x = this.#editor._uiManager.direction === "ltr" ? 1 - position[0] : position[0];
            style.insetInlineEnd = `${100 * x}%`;
            style.top = `calc(${100 * position[1]}% + var(--editor-toolbar-vert-offset))`;
        }
        return editToolbar;
    }
    get div() {
        return this.#toolbar;
    }
    static #pointerDown(e) {
        e.stopPropagation();
    }
    #focusIn(e) {
        this.#editor._focusEventsAllowed = false;
        $b3a01b20dd2ade98$export$7ae4cd3a66c1e050(e);
    }
    #focusOut(e) {
        this.#editor._focusEventsAllowed = true;
        $b3a01b20dd2ade98$export$7ae4cd3a66c1e050(e);
    }
    #addListenersToElement(element) {
        const signal = this.#editor._uiManager._signal;
        if (!(signal instanceof AbortSignal) || signal.aborted) return false;
        element.addEventListener("focusin", this.#focusIn.bind(this), {
            capture: true,
            signal: signal
        });
        element.addEventListener("focusout", this.#focusOut.bind(this), {
            capture: true,
            signal: signal
        });
        element.addEventListener("contextmenu", $b3a01b20dd2ade98$export$455b7811f904cadc, {
            signal: signal
        });
        return true;
    }
    hide() {
        this.#toolbar.classList.add("hidden");
        this.#colorPicker?.hideDropdown();
    }
    show() {
        this.#toolbar.classList.remove("hidden");
        this.#altText?.shown();
        this.#comment?.shown();
    }
    addDeleteButton() {
        const { editorType: editorType, _uiManager: _uiManager } = this.#editor;
        const button = document.createElement("button");
        button.classList.add("basic", "deleteButton");
        button.tabIndex = 0;
        button.setAttribute("data-l10n-id", $b3a01b20dd2ade98$var$EditorToolbar.#l10nRemove[editorType]);
        if (this.#addListenersToElement(button)) button.addEventListener("click", (e)=>{
            _uiManager.delete();
        }, {
            signal: _uiManager._signal
        });
        this.#buttons.append(button);
    }
    get #divider() {
        const divider = document.createElement("div");
        divider.className = "divider";
        return divider;
    }
    async addAltText(altText) {
        const button = await altText.render();
        this.#addListenersToElement(button);
        this.#buttons.append(button, this.#divider);
        this.#altText = altText;
    }
    addComment(comment, beforeElement = null) {
        if (this.#comment) return;
        const button = comment.renderForToolbar();
        if (!button) return;
        this.#addListenersToElement(button);
        const divider = this.#commentButtonDivider = this.#divider;
        if (!beforeElement) this.#buttons.append(button, divider);
        else {
            this.#buttons.insertBefore(button, beforeElement);
            this.#buttons.insertBefore(divider, beforeElement);
        }
        this.#comment = comment;
        comment.toolbar = this;
    }
    addColorPicker(colorPicker) {
        if (this.#colorPicker) return;
        this.#colorPicker = colorPicker;
        const button = colorPicker.renderButton();
        this.#addListenersToElement(button);
        this.#buttons.append(button, this.#divider);
    }
    async addEditSignatureButton(signatureManager) {
        const button = this.#signatureDescriptionButton = await signatureManager.renderEditButton(this.#editor);
        this.#addListenersToElement(button);
        this.#buttons.append(button, this.#divider);
    }
    removeButton(name) {
        switch(name){
            case "comment":
                this.#comment?.removeToolbarCommentButton();
                this.#comment = null;
                this.#commentButtonDivider?.remove();
                this.#commentButtonDivider = null;
                break;
        }
    }
    async addButton(name, tool) {
        switch(name){
            case "colorPicker":
                if (tool) this.addColorPicker(tool);
                break;
            case "altText":
                if (tool) await this.addAltText(tool);
                break;
            case "editSignature":
                if (tool) await this.addEditSignatureButton(tool);
                break;
            case "delete":
                this.addDeleteButton();
                break;
            case "comment":
                if (tool) this.addComment(tool);
                break;
        }
    }
    async addButtonBefore(name, tool, beforeSelector) {
        if (!tool && name === "comment") return;
        const beforeElement = this.#buttons.querySelector(beforeSelector);
        if (!beforeElement) return;
        if (name === "comment") this.addComment(tool, beforeElement);
    }
    updateEditSignatureButton(description) {
        if (this.#signatureDescriptionButton) this.#signatureDescriptionButton.title = description;
    }
    remove() {
        this.#toolbar.remove();
        this.#colorPicker?.destroy();
        this.#colorPicker = null;
    }
}
class $b3a01b20dd2ade98$var$FloatingToolbar {
    #buttons = null;
    #toolbar = null;
    #uiManager;
    constructor(uiManager){
        this.#uiManager = uiManager;
    }
    #render() {
        const editToolbar = this.#toolbar = document.createElement("div");
        editToolbar.className = "editToolbar";
        editToolbar.setAttribute("role", "toolbar");
        const signal = this.#uiManager._signal;
        if (signal instanceof AbortSignal && !signal.aborted) editToolbar.addEventListener("contextmenu", $b3a01b20dd2ade98$export$455b7811f904cadc, {
            signal: signal
        });
        const buttons = this.#buttons = document.createElement("div");
        buttons.className = "buttons";
        editToolbar.append(buttons);
        if (this.#uiManager.hasCommentManager()) this.#makeButton("commentButton", `pdfjs-comment-floating-button`, "pdfjs-comment-floating-button-label", ()=>{
            this.#uiManager.commentSelection("floating_button");
        });
        this.#makeButton("highlightButton", `pdfjs-highlight-floating-button1`, "pdfjs-highlight-floating-button-label", ()=>{
            this.#uiManager.highlightSelection("floating_button");
        });
        return editToolbar;
    }
    #getLastPoint(boxes, isLTR) {
        let lastY = 0;
        let lastX = 0;
        for (const box of boxes){
            const y = box.y + box.height;
            if (y < lastY) continue;
            const x = box.x + (isLTR ? box.width : 0);
            if (y > lastY) {
                lastX = x;
                lastY = y;
                continue;
            }
            if (isLTR) {
                if (x > lastX) lastX = x;
            } else if (x < lastX) lastX = x;
        }
        return [
            isLTR ? 1 - lastX : lastX,
            lastY
        ];
    }
    show(parent, boxes, isLTR) {
        const [x, y] = this.#getLastPoint(boxes, isLTR);
        const { style: style } = this.#toolbar ||= this.#render();
        parent.append(this.#toolbar);
        style.insetInlineEnd = `${100 * x}%`;
        style.top = `calc(${100 * y}% + var(--editor-toolbar-vert-offset))`;
    }
    hide() {
        this.#toolbar.remove();
    }
    #makeButton(buttonClass, l10nId, labelL10nId, clickHandler) {
        const button = document.createElement("button");
        button.classList.add("basic", buttonClass);
        button.tabIndex = 0;
        button.setAttribute("data-l10n-id", l10nId);
        const span = document.createElement("span");
        button.append(span);
        span.className = "visuallyHidden";
        span.setAttribute("data-l10n-id", labelL10nId);
        const signal = this.#uiManager._signal;
        if (signal instanceof AbortSignal && !signal.aborted) {
            button.addEventListener("contextmenu", $b3a01b20dd2ade98$export$455b7811f904cadc, {
                signal: signal
            });
            button.addEventListener("click", clickHandler, {
                signal: signal
            });
        }
        this.#buttons.append(button);
    }
}
function $b3a01b20dd2ade98$var$bindEvents(obj, element, names) {
    for (const name of names)element.addEventListener(name, obj[name].bind(obj));
}
class $b3a01b20dd2ade98$var$CurrentPointers {
    static #pointerId = NaN;
    static #pointerIds = null;
    static #moveTimestamp = NaN;
    static #pointerType = null;
    static initializeAndAddPointerId(pointerId) {
        ($b3a01b20dd2ade98$var$CurrentPointers.#pointerIds ||= new Set()).add(pointerId);
    }
    static setPointer(pointerType, pointerId) {
        $b3a01b20dd2ade98$var$CurrentPointers.#pointerId ||= pointerId;
        $b3a01b20dd2ade98$var$CurrentPointers.#pointerType ??= pointerType;
    }
    static setTimeStamp(timeStamp) {
        $b3a01b20dd2ade98$var$CurrentPointers.#moveTimestamp = timeStamp;
    }
    static isSamePointerId(pointerId) {
        return $b3a01b20dd2ade98$var$CurrentPointers.#pointerId === pointerId;
    }
    static isSamePointerIdOrRemove(pointerId) {
        if ($b3a01b20dd2ade98$var$CurrentPointers.#pointerId === pointerId) return true;
        $b3a01b20dd2ade98$var$CurrentPointers.#pointerIds?.delete(pointerId);
        return false;
    }
    static isSamePointerType(pointerType) {
        return $b3a01b20dd2ade98$var$CurrentPointers.#pointerType === pointerType;
    }
    static isInitializedAndDifferentPointerType(pointerType) {
        return $b3a01b20dd2ade98$var$CurrentPointers.#pointerType !== null && !$b3a01b20dd2ade98$var$CurrentPointers.isSamePointerType(pointerType);
    }
    static isSameTimeStamp(timeStamp) {
        return $b3a01b20dd2ade98$var$CurrentPointers.#moveTimestamp === timeStamp;
    }
    static isUsingMultiplePointers() {
        return $b3a01b20dd2ade98$var$CurrentPointers.#pointerIds?.size >= 1;
    }
    static clearPointerType() {
        $b3a01b20dd2ade98$var$CurrentPointers.#pointerType = null;
    }
    static clearPointerIds() {
        $b3a01b20dd2ade98$var$CurrentPointers.#pointerId = NaN;
        $b3a01b20dd2ade98$var$CurrentPointers.#pointerIds = null;
    }
    static clearTimeStamp() {
        $b3a01b20dd2ade98$var$CurrentPointers.#moveTimestamp = NaN;
    }
}
class $b3a01b20dd2ade98$var$IdManager {
    #id = 0;
    get id() {
        return `${$b3a01b20dd2ade98$var$AnnotationEditorPrefix}${this.#id++}`;
    }
}
class $b3a01b20dd2ade98$var$ImageManager {
    #baseId = $b3a01b20dd2ade98$export$75f13a91ebdf8eb3();
    #id = 0;
    #cache = null;
    static get _isSVGFittingCanvas() {
        const svg = `data:image/svg+xml;charset=UTF-8,<svg viewBox="0 0 1 1" width="1" height="1" xmlns="http://www.w3.org/2000/svg"><rect width="1" height="1" style="fill:red;"/></svg>`;
        const canvas = new OffscreenCanvas(1, 3);
        const ctx = canvas.getContext("2d", {
            willReadFrequently: true
        });
        const image = new Image();
        image.src = svg;
        const promise = image.decode().then(()=>{
            ctx.drawImage(image, 0, 0, 1, 1, 0, 0, 1, 3);
            return new Uint32Array(ctx.getImageData(0, 0, 1, 1).data.buffer)[0] === 0;
        });
        return $b3a01b20dd2ade98$export$b8972b998723d602(this, "_isSVGFittingCanvas", promise);
    }
    async #get(key, rawData) {
        this.#cache ||= new Map();
        let data = this.#cache.get(key);
        if (data === null) return null;
        if (data?.bitmap) {
            data.refCounter += 1;
            return data;
        }
        try {
            data ||= {
                bitmap: null,
                id: `image_${this.#baseId}_${this.#id++}`,
                refCounter: 0,
                isSvg: false
            };
            let image;
            if (typeof rawData === "string") {
                data.url = rawData;
                image = await $b3a01b20dd2ade98$export$8134c072fddab6a5(rawData, "blob");
            } else if (rawData instanceof File) image = data.file = rawData;
            else if (rawData instanceof Blob) image = rawData;
            if (image.type === "image/svg+xml") {
                const mustRemoveAspectRatioPromise = $b3a01b20dd2ade98$var$ImageManager._isSVGFittingCanvas;
                const fileReader = new FileReader();
                const imageElement = new Image();
                const imagePromise = new Promise((resolve, reject)=>{
                    imageElement.onload = ()=>{
                        data.bitmap = imageElement;
                        data.isSvg = true;
                        resolve();
                    };
                    fileReader.onload = async ()=>{
                        const url = data.svgUrl = fileReader.result;
                        imageElement.src = await mustRemoveAspectRatioPromise ? `${url}#svgView(preserveAspectRatio(none))` : url;
                    };
                    imageElement.onerror = fileReader.onerror = reject;
                });
                fileReader.readAsDataURL(image);
                await imagePromise;
            } else data.bitmap = await createImageBitmap(image);
            data.refCounter = 1;
        } catch (e) {
            $b3a01b20dd2ade98$var$warn(e);
            data = null;
        }
        this.#cache.set(key, data);
        if (data) this.#cache.set(data.id, data);
        return data;
    }
    async getFromFile(file) {
        const { lastModified: lastModified, name: name, size: size, type: type } = file;
        return this.#get(`${lastModified}_${name}_${size}_${type}`, file);
    }
    async getFromUrl(url) {
        return this.#get(url, url);
    }
    async getFromBlob(id, blobPromise) {
        const blob = await blobPromise;
        return this.#get(id, blob);
    }
    async getFromId(id) {
        this.#cache ||= new Map();
        const data = this.#cache.get(id);
        if (!data) return null;
        if (data.bitmap) {
            data.refCounter += 1;
            return data;
        }
        if (data.file) return this.getFromFile(data.file);
        if (data.blobPromise) {
            const { blobPromise: blobPromise } = data;
            delete data.blobPromise;
            return this.getFromBlob(data.id, blobPromise);
        }
        return this.getFromUrl(data.url);
    }
    getFromCanvas(id, canvas) {
        this.#cache ||= new Map();
        let data = this.#cache.get(id);
        if (data?.bitmap) {
            data.refCounter += 1;
            return data;
        }
        const offscreen = new OffscreenCanvas(canvas.width, canvas.height);
        const ctx = offscreen.getContext("2d");
        ctx.drawImage(canvas, 0, 0);
        data = {
            bitmap: offscreen.transferToImageBitmap(),
            id: `image_${this.#baseId}_${this.#id++}`,
            refCounter: 1,
            isSvg: false
        };
        this.#cache.set(id, data);
        this.#cache.set(data.id, data);
        return data;
    }
    getSvgUrl(id) {
        const data = this.#cache.get(id);
        if (!data?.isSvg) return null;
        return data.svgUrl;
    }
    deleteId(id) {
        this.#cache ||= new Map();
        const data = this.#cache.get(id);
        if (!data) return;
        data.refCounter -= 1;
        if (data.refCounter !== 0) return;
        const { bitmap: bitmap } = data;
        if (!data.url && !data.file) {
            const canvas = new OffscreenCanvas(bitmap.width, bitmap.height);
            const ctx = canvas.getContext("bitmaprenderer");
            ctx.transferFromImageBitmap(bitmap);
            data.blobPromise = canvas.convertToBlob();
        }
        bitmap.close?.();
        data.bitmap = null;
    }
    isValidId(id) {
        return id.startsWith(`image_${this.#baseId}_`);
    }
}
class $b3a01b20dd2ade98$var$CommandManager {
    #commands = [];
    #locked = false;
    #maxSize;
    #position = -1;
    constructor(maxSize = 128){
        this.#maxSize = maxSize;
    }
    add({ cmd: cmd, undo: undo, post: post, mustExec: mustExec, type: type = NaN, overwriteIfSameType: overwriteIfSameType = false, keepUndo: keepUndo = false }) {
        if (mustExec) cmd();
        if (this.#locked) return;
        const save = {
            cmd: cmd,
            undo: undo,
            post: post,
            type: type
        };
        if (this.#position === -1) {
            if (this.#commands.length > 0) this.#commands.length = 0;
            this.#position = 0;
            this.#commands.push(save);
            return;
        }
        if (overwriteIfSameType && this.#commands[this.#position].type === type) {
            if (keepUndo) save.undo = this.#commands[this.#position].undo;
            this.#commands[this.#position] = save;
            return;
        }
        const next = this.#position + 1;
        if (next === this.#maxSize) this.#commands.splice(0, 1);
        else {
            this.#position = next;
            if (next < this.#commands.length) this.#commands.splice(next);
        }
        this.#commands.push(save);
    }
    undo() {
        if (this.#position === -1) return;
        this.#locked = true;
        const { undo: undo, post: post } = this.#commands[this.#position];
        undo();
        post?.();
        this.#locked = false;
        this.#position -= 1;
    }
    redo() {
        if (this.#position < this.#commands.length - 1) {
            this.#position += 1;
            this.#locked = true;
            const { cmd: cmd, post: post } = this.#commands[this.#position];
            cmd();
            post?.();
            this.#locked = false;
        }
    }
    hasSomethingToUndo() {
        return this.#position !== -1;
    }
    hasSomethingToRedo() {
        return this.#position < this.#commands.length - 1;
    }
    cleanType(type) {
        if (this.#position === -1) return;
        for(let i = this.#position; i >= 0; i--)if (this.#commands[i].type !== type) {
            this.#commands.splice(i + 1, this.#position - i);
            this.#position = i;
            return;
        }
        this.#commands.length = 0;
        this.#position = -1;
    }
    destroy() {
        this.#commands = null;
    }
}
class $b3a01b20dd2ade98$var$KeyboardManager {
    constructor(callbacks){
        this.buffer = [];
        this.callbacks = new Map();
        this.allKeys = new Set();
        const { isMac: isMac } = $b3a01b20dd2ade98$export$5fb8891d35c36978.platform;
        for (const [keys, callback, options = {}] of callbacks)for (const key of keys){
            const isMacKey = key.startsWith("mac+");
            if (isMac && isMacKey) {
                this.callbacks.set(key.slice(4), {
                    callback: callback,
                    options: options
                });
                this.allKeys.add(key.split("+").at(-1));
            } else if (!isMac && !isMacKey) {
                this.callbacks.set(key, {
                    callback: callback,
                    options: options
                });
                this.allKeys.add(key.split("+").at(-1));
            }
        }
    }
    #serialize(event) {
        if (event.altKey) this.buffer.push("alt");
        if (event.ctrlKey) this.buffer.push("ctrl");
        if (event.metaKey) this.buffer.push("meta");
        if (event.shiftKey) this.buffer.push("shift");
        this.buffer.push(event.key);
        const str = this.buffer.join("+");
        this.buffer.length = 0;
        return str;
    }
    exec(self, event) {
        if (!this.allKeys.has(event.key)) return;
        const info = this.callbacks.get(this.#serialize(event));
        if (!info) return;
        const { callback: callback, options: { bubbles: bubbles = false, args: args = [], checker: checker = null } } = info;
        if (checker && !checker(self, event)) return;
        callback.bind(self, ...args, event)();
        if (!bubbles) $b3a01b20dd2ade98$export$7ae4cd3a66c1e050(event);
    }
}
class $b3a01b20dd2ade98$var$ColorManager {
    static _colorsMapping = new Map([
        [
            "CanvasText",
            [
                0,
                0,
                0
            ]
        ],
        [
            "Canvas",
            [
                255,
                255,
                255
            ]
        ]
    ]);
    get _colors() {
        const colors = new Map([
            [
                "CanvasText",
                null
            ],
            [
                "Canvas",
                null
            ]
        ]);
        $b3a01b20dd2ade98$var$getColorValues(colors);
        return $b3a01b20dd2ade98$export$b8972b998723d602(this, "_colors", colors);
    }
    convert(color) {
        const rgb = $b3a01b20dd2ade98$export$2a2e9b507863ddda(color);
        if (!window.matchMedia("(forced-colors: active)").matches) return rgb;
        for (const [name, RGB] of this._colors){
            if (RGB.every((x, i)=>x === rgb[i])) return $b3a01b20dd2ade98$var$ColorManager._colorsMapping.get(name);
        }
        return rgb;
    }
    getHexCode(name) {
        const rgb = this._colors.get(name);
        if (!rgb) return name;
        return $b3a01b20dd2ade98$export$f8f26dd395d7e1bd.makeHexColor(...rgb);
    }
}
class $b3a01b20dd2ade98$export$26cb16552a82cf63 {
    #abortController = new AbortController();
    #activeEditor = null;
    #allEditableAnnotations = null;
    #allEditors = new Map();
    #allLayers = new Map();
    #savedAllLayers = null;
    #altTextManager = null;
    #annotationStorage = null;
    #changedExistingAnnotations = null;
    #commandManager = new $b3a01b20dd2ade98$var$CommandManager();
    #commentManager = null;
    #copyPasteAC = null;
    #currentDrawingSession = null;
    #currentPageIndex = 0;
    #deletedAnnotationsElementIds = new Set();
    #draggingEditors = null;
    #editorTypes = null;
    #editorsToRescale = new Set();
    _editorUndoBar = null;
    #enableHighlightFloatingButton = false;
    #enableUpdatedAddImage = false;
    #enableNewAltTextWhenAddingImage = false;
    #filterFactory = null;
    #focusMainContainerTimeoutId = null;
    #focusManagerAC = null;
    #highlightColors = null;
    #highlightWhenShiftUp = false;
    #floatingToolbar = null;
    #idManager = new $b3a01b20dd2ade98$var$IdManager();
    #isEnabled = false;
    #isPointerDown = false;
    #isWaiting = false;
    #keyboardManagerAC = null;
    #lastActiveElement = null;
    #mainHighlightColorPicker = null;
    #missingCanvases = null;
    #mlManager = null;
    #mode = $b3a01b20dd2ade98$export$72ea3bfdd9a725bf.NONE;
    #selectedEditors = new Set();
    #selectedTextNode = null;
    #signatureManager = null;
    #pageColors = null;
    #showAllStates = null;
    #pdfDocument = null;
    #previousStates = {
        isEditing: false,
        isEmpty: true,
        hasSomethingToUndo: false,
        hasSomethingToRedo: false,
        hasSelectedEditor: false,
        hasSelectedText: false
    };
    #translation = [
        0,
        0
    ];
    #translationTimeoutId = null;
    #container = null;
    #viewer = null;
    #viewerAlert = null;
    #updateModeCapability = null;
    static TRANSLATE_SMALL = 1;
    static TRANSLATE_BIG = 10;
    static get _keyboardManager() {
        const proto = $b3a01b20dd2ade98$export$26cb16552a82cf63.prototype;
        const arrowChecker = (self)=>self.#container.contains(document.activeElement) && document.activeElement.tagName !== "BUTTON" && self.hasSomethingToControl();
        const textInputChecker = (_self, { target: el })=>{
            if (el instanceof HTMLInputElement) {
                const { type: type } = el;
                return type !== "text" && type !== "number";
            }
            return true;
        };
        const small = this.TRANSLATE_SMALL;
        const big = this.TRANSLATE_BIG;
        return $b3a01b20dd2ade98$export$b8972b998723d602(this, "_keyboardManager", new $b3a01b20dd2ade98$var$KeyboardManager([
            [
                [
                    "ctrl+a",
                    "mac+meta+a"
                ],
                proto.selectAll,
                {
                    checker: textInputChecker
                }
            ],
            [
                [
                    "ctrl+z",
                    "mac+meta+z"
                ],
                proto.undo,
                {
                    checker: textInputChecker
                }
            ],
            [
                [
                    "ctrl+y",
                    "ctrl+shift+z",
                    "mac+meta+shift+z",
                    "ctrl+shift+Z",
                    "mac+meta+shift+Z"
                ],
                proto.redo,
                {
                    checker: textInputChecker
                }
            ],
            [
                [
                    "Backspace",
                    "alt+Backspace",
                    "ctrl+Backspace",
                    "shift+Backspace",
                    "mac+Backspace",
                    "mac+alt+Backspace",
                    "mac+ctrl+Backspace",
                    "Delete",
                    "ctrl+Delete",
                    "shift+Delete",
                    "mac+Delete"
                ],
                proto.delete,
                {
                    checker: textInputChecker
                }
            ],
            [
                [
                    "Enter",
                    "mac+Enter"
                ],
                proto.addNewEditorFromKeyboard,
                {
                    checker: (self, { target: el })=>!(el instanceof HTMLButtonElement) && self.#container.contains(el) && !self.isEnterHandled
                }
            ],
            [
                [
                    " ",
                    "mac+ "
                ],
                proto.addNewEditorFromKeyboard,
                {
                    checker: (self, { target: el })=>!(el instanceof HTMLButtonElement) && self.#container.contains(document.activeElement)
                }
            ],
            [
                [
                    "Escape",
                    "mac+Escape"
                ],
                proto.unselectAll
            ],
            [
                [
                    "ArrowLeft",
                    "mac+ArrowLeft"
                ],
                proto.translateSelectedEditors,
                {
                    args: [
                        -small,
                        0
                    ],
                    checker: arrowChecker
                }
            ],
            [
                [
                    "ctrl+ArrowLeft",
                    "mac+shift+ArrowLeft"
                ],
                proto.translateSelectedEditors,
                {
                    args: [
                        -big,
                        0
                    ],
                    checker: arrowChecker
                }
            ],
            [
                [
                    "ArrowRight",
                    "mac+ArrowRight"
                ],
                proto.translateSelectedEditors,
                {
                    args: [
                        small,
                        0
                    ],
                    checker: arrowChecker
                }
            ],
            [
                [
                    "ctrl+ArrowRight",
                    "mac+shift+ArrowRight"
                ],
                proto.translateSelectedEditors,
                {
                    args: [
                        big,
                        0
                    ],
                    checker: arrowChecker
                }
            ],
            [
                [
                    "ArrowUp",
                    "mac+ArrowUp"
                ],
                proto.translateSelectedEditors,
                {
                    args: [
                        0,
                        -small
                    ],
                    checker: arrowChecker
                }
            ],
            [
                [
                    "ctrl+ArrowUp",
                    "mac+shift+ArrowUp"
                ],
                proto.translateSelectedEditors,
                {
                    args: [
                        0,
                        -big
                    ],
                    checker: arrowChecker
                }
            ],
            [
                [
                    "ArrowDown",
                    "mac+ArrowDown"
                ],
                proto.translateSelectedEditors,
                {
                    args: [
                        0,
                        small
                    ],
                    checker: arrowChecker
                }
            ],
            [
                [
                    "ctrl+ArrowDown",
                    "mac+shift+ArrowDown"
                ],
                proto.translateSelectedEditors,
                {
                    args: [
                        0,
                        big
                    ],
                    checker: arrowChecker
                }
            ]
        ]));
    }
    constructor(container, viewer, viewerAlert, altTextManager, commentManager, signatureManager, eventBus, pdfDocument, pageColors, highlightColors, enableHighlightFloatingButton, enableUpdatedAddImage, enableNewAltTextWhenAddingImage, mlManager, editorUndoBar, supportsPinchToZoom){
        const signal = this._signal = this.#abortController.signal;
        this.#container = container;
        this.#viewer = viewer;
        this.#viewerAlert = viewerAlert;
        this.#altTextManager = altTextManager;
        this.#commentManager = commentManager;
        this.#signatureManager = signatureManager;
        this.#pdfDocument = pdfDocument;
        this._eventBus = eventBus;
        eventBus._on("editingaction", this.onEditingAction.bind(this), {
            signal: signal
        });
        eventBus._on("pagechanging", this.onPageChanging.bind(this), {
            signal: signal
        });
        eventBus._on("scalechanging", this.onScaleChanging.bind(this), {
            signal: signal
        });
        eventBus._on("rotationchanging", this.onRotationChanging.bind(this), {
            signal: signal
        });
        eventBus._on("setpreference", this.onSetPreference.bind(this), {
            signal: signal
        });
        eventBus._on("switchannotationeditorparams", (evt)=>this.updateParams(evt.type, evt.value), {
            signal: signal
        });
        window.addEventListener("pointerdown", ()=>{
            this.#isPointerDown = true;
        }, {
            capture: true,
            signal: signal
        });
        window.addEventListener("pointerup", ()=>{
            this.#isPointerDown = false;
        }, {
            capture: true,
            signal: signal
        });
        window.addEventListener("beforeunload", this.#beforeUnload.bind(this), {
            capture: true,
            signal: signal
        });
        this.#addSelectionListener();
        this.#addDragAndDropListeners();
        this.#addKeyboardManager();
        this.#annotationStorage = pdfDocument.annotationStorage;
        this.#filterFactory = pdfDocument.filterFactory;
        this.#pageColors = pageColors;
        this.#highlightColors = highlightColors || null;
        this.#enableHighlightFloatingButton = enableHighlightFloatingButton;
        this.#enableUpdatedAddImage = enableUpdatedAddImage;
        this.#enableNewAltTextWhenAddingImage = enableNewAltTextWhenAddingImage;
        this.#mlManager = mlManager || null;
        this.viewParameters = {
            realScale: $b3a01b20dd2ade98$export$6ef3b6b69e65342c.PDF_TO_CSS_UNITS,
            rotation: 0
        };
        this.isShiftKeyDown = false;
        this._editorUndoBar = editorUndoBar || null;
        this._supportsPinchToZoom = supportsPinchToZoom !== false;
        commentManager?.setSidebarUiManager(this);
    }
    destroy() {
        this.#updateModeCapability?.resolve();
        this.#updateModeCapability = null;
        this.#abortController?.abort();
        this.#abortController = null;
        this._signal = null;
        for (const layer of this.#allLayers.values())layer.destroy();
        this.#allLayers.clear();
        this.#allEditors.clear();
        this.#editorsToRescale.clear();
        this.#missingCanvases?.clear();
        this.#activeEditor = null;
        this.#selectedEditors.clear();
        this.#commandManager.destroy();
        this.#altTextManager?.destroy();
        this.#commentManager?.destroy();
        this.#signatureManager?.destroy();
        this.#floatingToolbar?.hide();
        this.#floatingToolbar = null;
        this.#mainHighlightColorPicker?.destroy();
        this.#mainHighlightColorPicker = null;
        this.#allEditableAnnotations = null;
        if (this.#focusMainContainerTimeoutId) {
            clearTimeout(this.#focusMainContainerTimeoutId);
            this.#focusMainContainerTimeoutId = null;
        }
        if (this.#translationTimeoutId) {
            clearTimeout(this.#translationTimeoutId);
            this.#translationTimeoutId = null;
        }
        this._editorUndoBar?.destroy();
        this.#pdfDocument = null;
    }
    combinedSignal(ac) {
        return AbortSignal.any([
            this._signal,
            ac.signal
        ]);
    }
    get mlManager() {
        return this.#mlManager;
    }
    get useNewAltTextFlow() {
        return this.#enableUpdatedAddImage;
    }
    get useNewAltTextWhenAddingImage() {
        return this.#enableNewAltTextWhenAddingImage;
    }
    get hcmFilter() {
        return $b3a01b20dd2ade98$export$b8972b998723d602(this, "hcmFilter", this.#pageColors ? this.#filterFactory.addHCMFilter(this.#pageColors.foreground, this.#pageColors.background) : "none");
    }
    get direction() {
        return $b3a01b20dd2ade98$export$b8972b998723d602(this, "direction", getComputedStyle(this.#container).direction);
    }
    get _highlightColors() {
        return $b3a01b20dd2ade98$export$b8972b998723d602(this, "_highlightColors", this.#highlightColors ? new Map(this.#highlightColors.split(",").map((pair)=>{
            pair = pair.split("=").map((x)=>x.trim());
            pair[1] = pair[1].toUpperCase();
            return pair;
        })) : null);
    }
    get highlightColors() {
        const { _highlightColors: _highlightColors } = this;
        if (!_highlightColors) return $b3a01b20dd2ade98$export$b8972b998723d602(this, "highlightColors", null);
        const map = new Map();
        const hasHCM = !!this.#pageColors;
        for (const [name, color] of _highlightColors){
            const isNameForHCM = name.endsWith("_HCM");
            if (hasHCM && isNameForHCM) {
                map.set(name.replace("_HCM", ""), color);
                continue;
            }
            if (!hasHCM && !isNameForHCM) map.set(name, color);
        }
        return $b3a01b20dd2ade98$export$b8972b998723d602(this, "highlightColors", map);
    }
    get highlightColorNames() {
        return $b3a01b20dd2ade98$export$b8972b998723d602(this, "highlightColorNames", this.highlightColors ? new Map(Array.from(this.highlightColors, (e)=>e.reverse())) : null);
    }
    getNonHCMColor(color) {
        if (!this._highlightColors) return color;
        const colorName = this.highlightColorNames.get(color);
        return this._highlightColors.get(colorName) || color;
    }
    getNonHCMColorName(color) {
        return this.highlightColorNames.get(color) || color;
    }
    setCurrentDrawingSession(layer) {
        if (layer) {
            this.unselectAll();
            this.disableUserSelect(true);
        } else this.disableUserSelect(false);
        this.#currentDrawingSession = layer;
    }
    setMainHighlightColorPicker(colorPicker) {
        this.#mainHighlightColorPicker = colorPicker;
    }
    editAltText(editor, firstTime = false) {
        this.#altTextManager?.editAltText(this, editor, firstTime);
    }
    hasCommentManager() {
        return !!this.#commentManager;
    }
    editComment(editor, posX, posY, options) {
        this.#commentManager?.showDialog(this, editor, posX, posY, options);
    }
    selectComment(pageIndex, uid) {
        const layer = this.#allLayers.get(pageIndex);
        const editor = layer?.getEditorByUID(uid);
        editor?.toggleComment(true, true);
    }
    updateComment(editor) {
        this.#commentManager?.updateComment(editor.getData());
    }
    updatePopupColor(editor) {
        this.#commentManager?.updatePopupColor(editor);
    }
    removeComment(editor) {
        this.#commentManager?.removeComments([
            editor.uid
        ]);
    }
    deleteComment(editor, savedData) {
        const undo = ()=>{
            editor.comment = savedData;
        };
        const cmd = ()=>{
            this._editorUndoBar?.show(undo, "comment");
            this.toggleComment(null);
            editor.comment = null;
        };
        this.addCommands({
            cmd: cmd,
            undo: undo,
            mustExec: true
        });
    }
    toggleComment(editor, isSelected, visibility) {
        this.#commentManager?.toggleCommentPopup(editor, isSelected, visibility);
    }
    makeCommentColor(color, opacity) {
        return color && this.#commentManager?.makeCommentColor(color, opacity) || null;
    }
    getCommentDialogElement() {
        return this.#commentManager?.dialogElement || null;
    }
    async waitForEditorsRendered(pageNumber) {
        if (this.#allLayers.has(pageNumber - 1)) return;
        const { resolve: resolve, promise: promise } = Promise.withResolvers();
        const onEditorsRendered = (evt)=>{
            if (evt.pageNumber === pageNumber) {
                this._eventBus._off("editorsrendered", onEditorsRendered);
                resolve();
            }
        };
        this._eventBus.on("editorsrendered", onEditorsRendered);
        await promise;
    }
    getSignature(editor) {
        this.#signatureManager?.getSignature({
            uiManager: this,
            editor: editor
        });
    }
    get signatureManager() {
        return this.#signatureManager;
    }
    switchToMode(mode, callback) {
        this._eventBus.on("annotationeditormodechanged", callback, {
            once: true,
            signal: this._signal
        });
        this._eventBus.dispatch("showannotationeditorui", {
            source: this,
            mode: mode
        });
    }
    setPreference(name, value) {
        this._eventBus.dispatch("setpreference", {
            source: this,
            name: name,
            value: value
        });
    }
    onSetPreference({ name: name, value: value }) {
        switch(name){
            case "enableNewAltTextWhenAddingImage":
                this.#enableNewAltTextWhenAddingImage = value;
                break;
        }
    }
    onPageChanging({ pageNumber: pageNumber }) {
        this.#currentPageIndex = pageNumber - 1;
    }
    deletePage(id) {
        for (const editor of this.getEditors(id))editor.remove();
        this.#allLayers.delete(id);
        if (this.#currentPageIndex === id) this.#currentPageIndex = 0;
    }
    focusMainContainer() {
        this.#container.focus();
    }
    findParent(x, y) {
        for (const layer of this.#allLayers.values()){
            const { x: layerX, y: layerY, width: width, height: height } = layer.div.getBoundingClientRect();
            if (x >= layerX && x <= layerX + width && y >= layerY && y <= layerY + height) return layer;
        }
        return null;
    }
    disableUserSelect(value = false) {
        this.#viewer.classList.toggle("noUserSelect", value);
    }
    addShouldRescale(editor) {
        this.#editorsToRescale.add(editor);
    }
    removeShouldRescale(editor) {
        this.#editorsToRescale.delete(editor);
    }
    onScaleChanging({ scale: scale }) {
        this.commitOrRemove();
        this.viewParameters.realScale = scale * $b3a01b20dd2ade98$export$6ef3b6b69e65342c.PDF_TO_CSS_UNITS;
        for (const editor of this.#editorsToRescale)editor.onScaleChanging();
        this.#currentDrawingSession?.onScaleChanging();
    }
    onRotationChanging({ pagesRotation: pagesRotation }) {
        this.commitOrRemove();
        this.viewParameters.rotation = pagesRotation;
    }
    #getAnchorElementForSelection({ anchorNode: anchorNode }) {
        return anchorNode.nodeType === Node.TEXT_NODE ? anchorNode.parentElement : anchorNode;
    }
    #getLayerForTextLayer(textLayer) {
        const { currentLayer: currentLayer } = this;
        if (currentLayer.hasTextLayer(textLayer)) return currentLayer;
        for (const layer of this.#allLayers.values()){
            if (layer.hasTextLayer(textLayer)) return layer;
        }
        return null;
    }
    highlightSelection(methodOfCreation = "", comment = false) {
        const selection = document.getSelection();
        if (!selection || selection.isCollapsed) return;
        const { anchorNode: anchorNode, anchorOffset: anchorOffset, focusNode: focusNode, focusOffset: focusOffset } = selection;
        const text = selection.toString();
        const anchorElement = this.#getAnchorElementForSelection(selection);
        const textLayer = anchorElement.closest(".textLayer");
        const boxes = this.getSelectionBoxes(textLayer);
        if (!boxes) return;
        selection.empty();
        const layer = this.#getLayerForTextLayer(textLayer);
        const isNoneMode = this.#mode === $b3a01b20dd2ade98$export$72ea3bfdd9a725bf.NONE;
        const callback = ()=>{
            const editor = layer?.createAndAddNewEditor({
                x: 0,
                y: 0
            }, false, {
                methodOfCreation: methodOfCreation,
                boxes: boxes,
                anchorNode: anchorNode,
                anchorOffset: anchorOffset,
                focusNode: focusNode,
                focusOffset: focusOffset,
                text: text
            });
            if (isNoneMode) this.showAllEditors("highlight", true, true);
            if (comment) editor?.editComment();
        };
        if (isNoneMode) {
            this.switchToMode($b3a01b20dd2ade98$export$72ea3bfdd9a725bf.HIGHLIGHT, callback);
            return;
        }
        callback();
    }
    commentSelection(methodOfCreation = "") {
        this.highlightSelection(methodOfCreation, true);
    }
    #beforeUnload(e) {
        this.commitOrRemove();
        this.currentLayer?.endDrawingSession(false);
    }
    #displayFloatingToolbar() {
        const selection = document.getSelection();
        if (!selection || selection.isCollapsed) return;
        const anchorElement = this.#getAnchorElementForSelection(selection);
        const textLayer = anchorElement.closest(".textLayer");
        const boxes = this.getSelectionBoxes(textLayer);
        if (!boxes) return;
        this.#floatingToolbar ||= new $b3a01b20dd2ade98$var$FloatingToolbar(this);
        this.#floatingToolbar.show(textLayer, boxes, this.direction === "ltr");
    }
    getAndRemoveDataFromAnnotationStorage(annotationId) {
        if (!this.#annotationStorage) return null;
        const key = `${$b3a01b20dd2ade98$var$AnnotationEditorPrefix}${annotationId}`;
        const storedValue = this.#annotationStorage.getRawValue(key);
        if (storedValue) this.#annotationStorage.remove(key);
        return storedValue;
    }
    addToAnnotationStorage(editor) {
        if (!editor.isEmpty() && this.#annotationStorage && !this.#annotationStorage.has(editor.id)) this.#annotationStorage.setValue(editor.id, editor);
    }
    a11yAlert(messageId, args = null) {
        const viewerAlert = this.#viewerAlert;
        if (!viewerAlert) return;
        viewerAlert.setAttribute("data-l10n-id", messageId);
        if (args) viewerAlert.setAttribute("data-l10n-args", JSON.stringify(args));
        else viewerAlert.removeAttribute("data-l10n-args");
    }
    #selectionChange() {
        const selection = document.getSelection();
        if (!selection || selection.isCollapsed) {
            if (this.#selectedTextNode) {
                this.#floatingToolbar?.hide();
                this.#selectedTextNode = null;
                this.#dispatchUpdateStates({
                    hasSelectedText: false
                });
            }
            return;
        }
        const { anchorNode: anchorNode } = selection;
        if (anchorNode === this.#selectedTextNode) return;
        const anchorElement = this.#getAnchorElementForSelection(selection);
        const textLayer = anchorElement.closest(".textLayer");
        if (!textLayer) {
            if (this.#selectedTextNode) {
                this.#floatingToolbar?.hide();
                this.#selectedTextNode = null;
                this.#dispatchUpdateStates({
                    hasSelectedText: false
                });
            }
            return;
        }
        this.#floatingToolbar?.hide();
        this.#selectedTextNode = anchorNode;
        this.#dispatchUpdateStates({
            hasSelectedText: true
        });
        if (this.#mode !== $b3a01b20dd2ade98$export$72ea3bfdd9a725bf.HIGHLIGHT && this.#mode !== $b3a01b20dd2ade98$export$72ea3bfdd9a725bf.NONE) return;
        if (this.#mode === $b3a01b20dd2ade98$export$72ea3bfdd9a725bf.HIGHLIGHT) this.showAllEditors("highlight", true, true);
        this.#highlightWhenShiftUp = this.isShiftKeyDown;
        if (!this.isShiftKeyDown) {
            const activeLayer = this.#mode === $b3a01b20dd2ade98$export$72ea3bfdd9a725bf.HIGHLIGHT ? this.#getLayerForTextLayer(textLayer) : null;
            activeLayer?.toggleDrawing();
            if (this.#isPointerDown) {
                const ac = new AbortController();
                const signal = this.combinedSignal(ac);
                const pointerup = (e)=>{
                    if (e.type === "pointerup" && e.button !== 0) return;
                    ac.abort();
                    activeLayer?.toggleDrawing(true);
                    if (e.type === "pointerup") this.#onSelectEnd("main_toolbar");
                };
                window.addEventListener("pointerup", pointerup, {
                    signal: signal
                });
                window.addEventListener("blur", pointerup, {
                    signal: signal
                });
            } else {
                activeLayer?.toggleDrawing(true);
                this.#onSelectEnd("main_toolbar");
            }
        }
    }
    #onSelectEnd(methodOfCreation = "") {
        if (this.#mode === $b3a01b20dd2ade98$export$72ea3bfdd9a725bf.HIGHLIGHT) this.highlightSelection(methodOfCreation);
        else if (this.#enableHighlightFloatingButton) this.#displayFloatingToolbar();
    }
    #addSelectionListener() {
        document.addEventListener("selectionchange", this.#selectionChange.bind(this), {
            signal: this._signal
        });
    }
    #addFocusManager() {
        if (this.#focusManagerAC) return;
        this.#focusManagerAC = new AbortController();
        const signal = this.combinedSignal(this.#focusManagerAC);
        window.addEventListener("focus", this.focus.bind(this), {
            signal: signal
        });
        window.addEventListener("blur", this.blur.bind(this), {
            signal: signal
        });
    }
    #removeFocusManager() {
        this.#focusManagerAC?.abort();
        this.#focusManagerAC = null;
    }
    blur() {
        this.isShiftKeyDown = false;
        if (this.#highlightWhenShiftUp) {
            this.#highlightWhenShiftUp = false;
            this.#onSelectEnd("main_toolbar");
        }
        if (!this.hasSelection) return;
        const { activeElement: activeElement } = document;
        for (const editor of this.#selectedEditors)if (editor.div.contains(activeElement)) {
            this.#lastActiveElement = [
                editor,
                activeElement
            ];
            editor._focusEventsAllowed = false;
            break;
        }
    }
    focus() {
        if (!this.#lastActiveElement) return;
        const [lastEditor, lastActiveElement] = this.#lastActiveElement;
        this.#lastActiveElement = null;
        lastActiveElement.addEventListener("focusin", ()=>{
            lastEditor._focusEventsAllowed = true;
        }, {
            once: true,
            signal: this._signal
        });
        lastActiveElement.focus();
    }
    #addKeyboardManager() {
        if (this.#keyboardManagerAC) return;
        this.#keyboardManagerAC = new AbortController();
        const signal = this.combinedSignal(this.#keyboardManagerAC);
        window.addEventListener("keydown", this.keydown.bind(this), {
            signal: signal
        });
        window.addEventListener("keyup", this.keyup.bind(this), {
            signal: signal
        });
    }
    #removeKeyboardManager() {
        this.#keyboardManagerAC?.abort();
        this.#keyboardManagerAC = null;
    }
    #addCopyPasteListeners() {
        if (this.#copyPasteAC) return;
        this.#copyPasteAC = new AbortController();
        const signal = this.combinedSignal(this.#copyPasteAC);
        document.addEventListener("copy", this.copy.bind(this), {
            signal: signal
        });
        document.addEventListener("cut", this.cut.bind(this), {
            signal: signal
        });
        document.addEventListener("paste", this.paste.bind(this), {
            signal: signal
        });
    }
    #removeCopyPasteListeners() {
        this.#copyPasteAC?.abort();
        this.#copyPasteAC = null;
    }
    #addDragAndDropListeners() {
        const signal = this._signal;
        document.addEventListener("dragover", this.dragOver.bind(this), {
            signal: signal
        });
        document.addEventListener("drop", this.drop.bind(this), {
            signal: signal
        });
    }
    addEditListeners() {
        this.#addKeyboardManager();
        this.setEditingState(true);
    }
    removeEditListeners() {
        this.#removeKeyboardManager();
        this.setEditingState(false);
    }
    dragOver(event) {
        for (const { type: type } of event.dataTransfer.items){
            for (const editorType of this.#editorTypes)if (editorType.isHandlingMimeForPasting(type)) {
                event.dataTransfer.dropEffect = "copy";
                event.preventDefault();
                return;
            }
        }
    }
    drop(event) {
        for (const item of event.dataTransfer.items){
            for (const editorType of this.#editorTypes)if (editorType.isHandlingMimeForPasting(item.type)) {
                editorType.paste(item, this.currentLayer);
                event.preventDefault();
                return;
            }
        }
    }
    copy(event) {
        event.preventDefault();
        this.#activeEditor?.commitOrRemove();
        if (!this.hasSelection) return;
        const editors = [];
        for (const editor of this.#selectedEditors){
            const serialized = editor.serialize(true);
            if (serialized) editors.push(serialized);
        }
        if (editors.length === 0) return;
        event.clipboardData.setData("application/pdfjs", JSON.stringify(editors));
    }
    cut(event) {
        this.copy(event);
        this.delete();
    }
    async paste(event) {
        event.preventDefault();
        const { clipboardData: clipboardData } = event;
        for (const item of clipboardData.items){
            for (const editorType of this.#editorTypes)if (editorType.isHandlingMimeForPasting(item.type)) {
                editorType.paste(item, this.currentLayer);
                return;
            }
        }
        let data = clipboardData.getData("application/pdfjs");
        if (!data) return;
        try {
            data = JSON.parse(data);
        } catch (ex) {
            $b3a01b20dd2ade98$var$warn(`paste: "${ex.message}".`);
            return;
        }
        if (!Array.isArray(data)) return;
        this.unselectAll();
        const layer = this.currentLayer;
        try {
            const newEditors = [];
            for (const editor of data){
                const deserializedEditor = await layer.deserialize(editor);
                if (!deserializedEditor) return;
                newEditors.push(deserializedEditor);
            }
            const cmd = ()=>{
                for (const editor of newEditors)this.#addEditorToLayer(editor);
                this.#selectEditors(newEditors);
            };
            const undo = ()=>{
                for (const editor of newEditors)editor.remove();
            };
            this.addCommands({
                cmd: cmd,
                undo: undo,
                mustExec: true
            });
        } catch (ex) {
            $b3a01b20dd2ade98$var$warn(`paste: "${ex.message}".`);
        }
    }
    keydown(event) {
        if (!this.isShiftKeyDown && event.key === "Shift") this.isShiftKeyDown = true;
        if (this.#mode !== $b3a01b20dd2ade98$export$72ea3bfdd9a725bf.NONE && !this.isEditorHandlingKeyboard) $b3a01b20dd2ade98$export$26cb16552a82cf63._keyboardManager.exec(this, event);
    }
    keyup(event) {
        if (this.isShiftKeyDown && event.key === "Shift") {
            this.isShiftKeyDown = false;
            if (this.#highlightWhenShiftUp) {
                this.#highlightWhenShiftUp = false;
                this.#onSelectEnd("main_toolbar");
            }
        }
    }
    onEditingAction({ name: name }) {
        switch(name){
            case "undo":
            case "redo":
            case "delete":
            case "selectAll":
                this[name]();
                break;
            case "highlightSelection":
                this.highlightSelection("context_menu");
                break;
            case "commentSelection":
                this.commentSelection("context_menu");
                break;
        }
    }
    updatePageIndex(oldPageIndex, newPageIndex) {
        for (const editor of this.getEditors(oldPageIndex))editor.pageIndex = newPageIndex;
        const layer = this.#savedAllLayers.get(oldPageIndex);
        if (layer) {
            layer.pageIndex = newPageIndex;
            this.#allLayers.set(newPageIndex, layer);
            if (this.#isEnabled) layer.enable();
            else layer.disable();
        }
    }
    startUpdatePages() {
        this.#savedAllLayers = new Map(this.#allLayers);
        this.#allLayers.clear();
    }
    endUpdatePages() {
        this.#savedAllLayers = null;
    }
    clonePage(pageIndex, newPageIndex) {
        for (const editor of this.getEditors(pageIndex)){
            const serialized = editor.serialize(editor.mode !== $b3a01b20dd2ade98$export$72ea3bfdd9a725bf.HIGHLIGHT);
            if (!serialized) continue;
            serialized.pageIndex = newPageIndex;
            serialized.id = this.getId();
            serialized.isClone = true;
            delete serialized.popupRef;
            this.#annotationStorage.setValue(serialized.id, serialized);
        }
    }
    findClonesForPage(layer) {
        const promises = [];
        const { pageIndex: pageIndex } = layer;
        for (const [id, editor] of this.#annotationStorage)if (editor.pageIndex === pageIndex && editor.isClone) {
            this.#annotationStorage.remove(id);
            promises.push(layer.deserialize(editor).then((deserializedEditor)=>{
                if (deserializedEditor) {
                    deserializedEditor.isClone = true;
                    layer.addOrRebuild(deserializedEditor);
                }
            }));
        }
        return Promise.all(promises);
    }
    #dispatchUpdateStates(details) {
        const hasChanged = Object.entries(details).some(([key, value])=>this.#previousStates[key] !== value);
        if (hasChanged) {
            this._eventBus.dispatch("editingstateschanged", {
                source: this,
                details: Object.assign(this.#previousStates, details)
            });
            if (this.#mode === $b3a01b20dd2ade98$export$72ea3bfdd9a725bf.HIGHLIGHT && details.hasSelectedEditor === false) this.#dispatchUpdateUI([
                [
                    $b3a01b20dd2ade98$export$cf3df2a6ecc26692.HIGHLIGHT_FREE,
                    true
                ]
            ]);
        }
    }
    #dispatchUpdateUI(details) {
        this._eventBus.dispatch("annotationeditorparamschanged", {
            source: this,
            details: details
        });
    }
    setEditingState(isEditing) {
        if (isEditing) {
            this.#addFocusManager();
            this.#addCopyPasteListeners();
            this.#dispatchUpdateStates({
                isEditing: this.#mode !== $b3a01b20dd2ade98$export$72ea3bfdd9a725bf.NONE,
                isEmpty: this.#isEmpty(),
                hasSomethingToUndo: this.#commandManager.hasSomethingToUndo(),
                hasSomethingToRedo: this.#commandManager.hasSomethingToRedo(),
                hasSelectedEditor: false
            });
        } else {
            this.#removeFocusManager();
            this.#removeCopyPasteListeners();
            this.#dispatchUpdateStates({
                isEditing: false
            });
            this.disableUserSelect(false);
        }
    }
    registerEditorTypes(types) {
        if (this.#editorTypes) return;
        this.#editorTypes = types;
        for (const editorType of this.#editorTypes)this.#dispatchUpdateUI(editorType.defaultPropertiesToUpdate);
    }
    getId() {
        return this.#idManager.id;
    }
    get currentLayer() {
        return this.#allLayers.get(this.#currentPageIndex);
    }
    getLayer(pageIndex) {
        return this.#allLayers.get(pageIndex);
    }
    get currentPageIndex() {
        return this.#currentPageIndex;
    }
    addLayer(layer) {
        this.#allLayers.set(layer.pageIndex, layer);
        if (this.#isEnabled) layer.enable();
        else layer.disable();
    }
    removeLayer(layer) {
        this.#allLayers.delete(layer.pageIndex);
    }
    async updateMode(mode, editId = null, isFromUser = false, isFromKeyboard = false, mustEnterInEditMode = false, editComment = false) {
        if (this.#mode === mode) return;
        if (this.#updateModeCapability) {
            await this.#updateModeCapability.promise;
            if (!this.#updateModeCapability) return;
        }
        this.#updateModeCapability = Promise.withResolvers();
        this.#currentDrawingSession?.commitOrRemove();
        if (this.#mode === $b3a01b20dd2ade98$export$72ea3bfdd9a725bf.POPUP) this.#commentManager?.hideSidebar();
        this.#commentManager?.destroyPopup();
        this.#mode = mode;
        if (mode === $b3a01b20dd2ade98$export$72ea3bfdd9a725bf.NONE) {
            this.setEditingState(false);
            this.#disableAll();
            for (const editor of this.#allEditors.values())editor.hideStandaloneCommentButton();
            this._editorUndoBar?.hide();
            this.toggleComment(null);
            this.#updateModeCapability.resolve();
            return;
        }
        for (const editor of this.#allEditors.values())editor.addStandaloneCommentButton();
        if (mode === $b3a01b20dd2ade98$export$72ea3bfdd9a725bf.SIGNATURE) await this.#signatureManager?.loadSignatures();
        if (isFromUser) $b3a01b20dd2ade98$var$CurrentPointers.clearPointerType();
        this.setEditingState(true);
        await this.#enableAll();
        this.unselectAll();
        for (const layer of this.#allLayers.values())layer.updateMode(mode);
        if (mode === $b3a01b20dd2ade98$export$72ea3bfdd9a725bf.POPUP) {
            this.#allEditableAnnotations ||= await this.#pdfDocument.getAnnotationsByType(new Set(this.#editorTypes.map((editorClass)=>editorClass._editorType)));
            const elementIds = new Set();
            const allComments = [];
            for (const editor of this.#allEditors.values()){
                const { annotationElementId: annotationElementId, hasComment: hasComment, deleted: deleted } = editor;
                if (annotationElementId) elementIds.add(annotationElementId);
                if (hasComment && !deleted) allComments.push(editor.getData());
            }
            for (const annotation of this.#allEditableAnnotations){
                const { id: id, popupRef: popupRef, contentsObj: contentsObj } = annotation;
                if (popupRef && contentsObj?.str && !elementIds.has(id) && !this.#deletedAnnotationsElementIds.has(id)) allComments.push(annotation);
            }
            this.#commentManager?.showSidebar(allComments);
        }
        if (!editId) {
            if (isFromKeyboard) this.addNewEditorFromKeyboard();
            this.#updateModeCapability.resolve();
            return;
        }
        for (const editor of this.#allEditors.values())if (editor.uid === editId) {
            this.setSelected(editor);
            if (editComment) editor.editComment();
            else if (mustEnterInEditMode) editor.enterInEditMode();
            else editor.focus();
        } else editor.unselect();
        this.#updateModeCapability.resolve();
    }
    addNewEditorFromKeyboard() {
        if (this.currentLayer.canCreateNewEmptyEditor()) this.currentLayer.addNewEditor();
    }
    updateToolbar(options) {
        if (options.mode === this.#mode) return;
        this._eventBus.dispatch("switchannotationeditormode", {
            source: this,
            ...options
        });
    }
    updateParams(type, value) {
        if (!this.#editorTypes) return;
        switch(type){
            case $b3a01b20dd2ade98$export$cf3df2a6ecc26692.CREATE:
                this.currentLayer.addNewEditor(value);
                return;
            case $b3a01b20dd2ade98$export$cf3df2a6ecc26692.HIGHLIGHT_SHOW_ALL:
                this._eventBus.dispatch("reporttelemetry", {
                    source: this,
                    details: {
                        type: "editing",
                        data: {
                            type: "highlight",
                            action: "toggle_visibility"
                        }
                    }
                });
                (this.#showAllStates ||= new Map()).set(type, value);
                this.showAllEditors("highlight", value);
                break;
        }
        if (this.hasSelection) for (const editor of this.#selectedEditors)editor.updateParams(type, value);
        else for (const editorType of this.#editorTypes)editorType.updateDefaultParams(type, value);
    }
    showAllEditors(type, visible, updateButton = false) {
        for (const editor of this.#allEditors.values())if (editor.editorType === type) editor.show(visible);
        const state = this.#showAllStates?.get($b3a01b20dd2ade98$export$cf3df2a6ecc26692.HIGHLIGHT_SHOW_ALL) ?? true;
        if (state !== visible) this.#dispatchUpdateUI([
            [
                $b3a01b20dd2ade98$export$cf3df2a6ecc26692.HIGHLIGHT_SHOW_ALL,
                visible
            ]
        ]);
    }
    enableWaiting(mustWait = false) {
        if (this.#isWaiting === mustWait) return;
        this.#isWaiting = mustWait;
        for (const layer of this.#allLayers.values()){
            if (mustWait) layer.disableClick();
            else layer.enableClick();
            layer.div.classList.toggle("waiting", mustWait);
        }
    }
    async #enableAll() {
        if (!this.#isEnabled) {
            this.#isEnabled = true;
            const promises = [];
            for (const layer of this.#allLayers.values())promises.push(layer.enable());
            await Promise.all(promises);
            for (const editor of this.#allEditors.values())editor.enable();
        }
    }
    #disableAll() {
        this.unselectAll();
        if (this.#isEnabled) {
            this.#isEnabled = false;
            for (const layer of this.#allLayers.values())layer.disable();
            for (const editor of this.#allEditors.values())editor.disable();
        }
    }
    *getEditors(pageIndex) {
        for (const editor of this.#allEditors.values())if (editor.pageIndex === pageIndex) yield editor;
    }
    getEditor(id) {
        return this.#allEditors.get(id);
    }
    addEditor(editor) {
        this.#allEditors.set(editor.id, editor);
    }
    removeEditor(editor) {
        if (editor.div.contains(document.activeElement)) {
            if (this.#focusMainContainerTimeoutId) clearTimeout(this.#focusMainContainerTimeoutId);
            this.#focusMainContainerTimeoutId = setTimeout(()=>{
                this.focusMainContainer();
                this.#focusMainContainerTimeoutId = null;
            }, 0);
        }
        this.#allEditors.delete(editor.id);
        if (editor.annotationElementId) this.#missingCanvases?.delete(editor.annotationElementId);
        this.unselect(editor);
        if (!editor.annotationElementId || !this.#deletedAnnotationsElementIds.has(editor.annotationElementId)) this.#annotationStorage?.remove(editor.id);
    }
    addDeletedAnnotationElement(editor) {
        this.#deletedAnnotationsElementIds.add(editor.annotationElementId);
        this.addChangedExistingAnnotation(editor);
        editor.deleted = true;
    }
    isDeletedAnnotationElement(annotationElementId) {
        return this.#deletedAnnotationsElementIds.has(annotationElementId);
    }
    removeDeletedAnnotationElement(editor) {
        this.#deletedAnnotationsElementIds.delete(editor.annotationElementId);
        this.removeChangedExistingAnnotation(editor);
        editor.deleted = false;
    }
    #addEditorToLayer(editor) {
        const layer = this.#allLayers.get(editor.pageIndex);
        if (layer) layer.addOrRebuild(editor);
        else {
            this.addEditor(editor);
            this.addToAnnotationStorage(editor);
        }
    }
    setActiveEditor(editor) {
        if (this.#activeEditor === editor) return;
        this.#activeEditor = editor;
        if (editor) this.#dispatchUpdateUI(editor.propertiesToUpdate);
    }
    get #lastSelectedEditor() {
        let ed = null;
        for (ed of this.#selectedEditors);
        return ed;
    }
    updateUI(editor) {
        if (this.#lastSelectedEditor === editor) this.#dispatchUpdateUI(editor.propertiesToUpdate);
    }
    updateUIForDefaultProperties(editorType) {
        this.#dispatchUpdateUI(editorType.defaultPropertiesToUpdate);
    }
    toggleSelected(editor) {
        if (this.#selectedEditors.has(editor)) {
            this.#selectedEditors.delete(editor);
            editor.unselect();
            this.#dispatchUpdateStates({
                hasSelectedEditor: this.hasSelection
            });
            return;
        }
        this.#selectedEditors.add(editor);
        editor.select();
        this.#dispatchUpdateUI(editor.propertiesToUpdate);
        this.#dispatchUpdateStates({
            hasSelectedEditor: true
        });
    }
    setSelected(editor) {
        this.updateToolbar({
            mode: editor.mode,
            editId: editor.uid
        });
        this.#currentDrawingSession?.commitOrRemove();
        for (const ed of this.#selectedEditors)if (ed !== editor) ed.unselect();
        this.#commentManager?.destroyPopup();
        this.#selectedEditors.clear();
        this.#selectedEditors.add(editor);
        editor.select();
        this.#dispatchUpdateUI(editor.propertiesToUpdate);
        this.#dispatchUpdateStates({
            hasSelectedEditor: true
        });
    }
    isSelected(editor) {
        return this.#selectedEditors.has(editor);
    }
    get firstSelectedEditor() {
        return this.#selectedEditors.values().next().value;
    }
    unselect(editor) {
        editor.unselect();
        this.#selectedEditors.delete(editor);
        this.#dispatchUpdateStates({
            hasSelectedEditor: this.hasSelection
        });
    }
    get hasSelection() {
        return this.#selectedEditors.size !== 0;
    }
    get isEnterHandled() {
        return this.#selectedEditors.size === 1 && this.firstSelectedEditor.isEnterHandled;
    }
    undo() {
        this.#commandManager.undo();
        this.#dispatchUpdateStates({
            hasSomethingToUndo: this.#commandManager.hasSomethingToUndo(),
            hasSomethingToRedo: true,
            isEmpty: this.#isEmpty()
        });
        this._editorUndoBar?.hide();
    }
    redo() {
        this.#commandManager.redo();
        this.#dispatchUpdateStates({
            hasSomethingToUndo: true,
            hasSomethingToRedo: this.#commandManager.hasSomethingToRedo(),
            isEmpty: this.#isEmpty()
        });
    }
    addCommands(params) {
        this.#commandManager.add(params);
        this.#dispatchUpdateStates({
            hasSomethingToUndo: true,
            hasSomethingToRedo: false,
            isEmpty: this.#isEmpty()
        });
    }
    cleanUndoStack(type) {
        this.#commandManager.cleanType(type);
    }
    #isEmpty() {
        if (this.#allEditors.size === 0) return true;
        if (this.#allEditors.size === 1) {
            for (const editor of this.#allEditors.values())return editor.isEmpty();
        }
        return false;
    }
    delete() {
        this.commitOrRemove();
        const drawingEditor = this.currentLayer?.endDrawingSession(true);
        if (!this.hasSelection && !drawingEditor) return;
        const editors = drawingEditor ? [
            drawingEditor
        ] : [
            ...this.#selectedEditors
        ];
        const cmd = ()=>{
            this._editorUndoBar?.show(undo, editors.length === 1 ? editors[0].editorType : editors.length);
            for (const editor of editors)editor.remove();
        };
        const undo = ()=>{
            for (const editor of editors)this.#addEditorToLayer(editor);
        };
        this.addCommands({
            cmd: cmd,
            undo: undo,
            mustExec: true
        });
    }
    commitOrRemove() {
        this.#activeEditor?.commitOrRemove();
    }
    hasSomethingToControl() {
        return this.#activeEditor || this.hasSelection;
    }
    #selectEditors(editors) {
        for (const editor of this.#selectedEditors)editor.unselect();
        this.#selectedEditors.clear();
        for (const editor of editors){
            if (editor.isEmpty()) continue;
            this.#selectedEditors.add(editor);
            editor.select();
        }
        this.#dispatchUpdateStates({
            hasSelectedEditor: this.hasSelection
        });
    }
    selectAll() {
        for (const editor of this.#selectedEditors)editor.commit();
        this.#selectEditors(this.#allEditors.values());
    }
    unselectAll() {
        if (this.#activeEditor) {
            this.#activeEditor.commitOrRemove();
            if (this.#mode !== $b3a01b20dd2ade98$export$72ea3bfdd9a725bf.NONE) return;
        }
        if (this.#currentDrawingSession?.commitOrRemove()) return;
        this.#commentManager?.destroyPopup();
        if (!this.hasSelection) return;
        for (const editor of this.#selectedEditors)editor.unselect();
        this.#selectedEditors.clear();
        this.#dispatchUpdateStates({
            hasSelectedEditor: false
        });
    }
    translateSelectedEditors(x, y, noCommit = false) {
        if (!noCommit) this.commitOrRemove();
        if (!this.hasSelection) return;
        this.#translation[0] += x;
        this.#translation[1] += y;
        const [totalX, totalY] = this.#translation;
        const editors = [
            ...this.#selectedEditors
        ];
        const TIME_TO_WAIT = 1000;
        if (this.#translationTimeoutId) clearTimeout(this.#translationTimeoutId);
        this.#translationTimeoutId = setTimeout(()=>{
            this.#translationTimeoutId = null;
            this.#translation[0] = this.#translation[1] = 0;
            this.addCommands({
                cmd: ()=>{
                    for (const editor of editors)if (this.#allEditors.has(editor.id)) {
                        editor.translateInPage(totalX, totalY);
                        editor.translationDone();
                    }
                },
                undo: ()=>{
                    for (const editor of editors)if (this.#allEditors.has(editor.id)) {
                        editor.translateInPage(-totalX, -totalY);
                        editor.translationDone();
                    }
                },
                mustExec: false
            });
        }, TIME_TO_WAIT);
        for (const editor of editors){
            editor.translateInPage(x, y);
            editor.translationDone();
        }
    }
    setUpDragSession() {
        if (!this.hasSelection) return;
        this.disableUserSelect(true);
        this.#draggingEditors = new Map();
        for (const editor of this.#selectedEditors)this.#draggingEditors.set(editor, {
            savedX: editor.x,
            savedY: editor.y,
            savedPageIndex: editor.pageIndex,
            newX: 0,
            newY: 0,
            newPageIndex: -1
        });
    }
    endDragSession() {
        if (!this.#draggingEditors) return false;
        this.disableUserSelect(false);
        const map = this.#draggingEditors;
        this.#draggingEditors = null;
        let mustBeAddedInUndoStack = false;
        for (const [{ x: x, y: y, pageIndex: pageIndex }, value] of map){
            value.newX = x;
            value.newY = y;
            value.newPageIndex = pageIndex;
            mustBeAddedInUndoStack ||= x !== value.savedX || y !== value.savedY || pageIndex !== value.savedPageIndex;
        }
        if (!mustBeAddedInUndoStack) return false;
        const move = (editor, x, y, pageIndex)=>{
            if (this.#allEditors.has(editor.id)) {
                const parent = this.#allLayers.get(pageIndex);
                if (parent) editor._setParentAndPosition(parent, x, y);
                else {
                    editor.pageIndex = pageIndex;
                    editor.x = x;
                    editor.y = y;
                }
            }
        };
        this.addCommands({
            cmd: ()=>{
                for (const [editor, { newX: newX, newY: newY, newPageIndex: newPageIndex }] of map)move(editor, newX, newY, newPageIndex);
            },
            undo: ()=>{
                for (const [editor, { savedX: savedX, savedY: savedY, savedPageIndex: savedPageIndex }] of map)move(editor, savedX, savedY, savedPageIndex);
            },
            mustExec: true
        });
        return true;
    }
    dragSelectedEditors(tx, ty) {
        if (!this.#draggingEditors) return;
        for (const editor of this.#draggingEditors.keys())editor.drag(tx, ty);
    }
    rebuild(editor) {
        if (editor.parent === null) {
            const parent = this.getLayer(editor.pageIndex);
            if (parent) {
                parent.changeParent(editor);
                parent.addOrRebuild(editor);
            } else {
                this.addEditor(editor);
                this.addToAnnotationStorage(editor);
                editor.rebuild();
            }
        } else editor.parent.addOrRebuild(editor);
    }
    get isEditorHandlingKeyboard() {
        return this.getActive()?.shouldGetKeyboardEvents() || this.#selectedEditors.size === 1 && this.firstSelectedEditor.shouldGetKeyboardEvents();
    }
    isActive(editor) {
        return this.#activeEditor === editor;
    }
    getActive() {
        return this.#activeEditor;
    }
    getMode() {
        return this.#mode;
    }
    isEditingMode() {
        return this.#mode !== $b3a01b20dd2ade98$export$72ea3bfdd9a725bf.NONE;
    }
    get imageManager() {
        return $b3a01b20dd2ade98$export$b8972b998723d602(this, "imageManager", new $b3a01b20dd2ade98$var$ImageManager());
    }
    getSelectionBoxes(textLayer) {
        if (!textLayer) return null;
        const selection = document.getSelection();
        for(let i = 0, ii = selection.rangeCount; i < ii; i++){
            if (!textLayer.contains(selection.getRangeAt(i).commonAncestorContainer)) return null;
        }
        const { x: layerX, y: layerY, width: parentWidth, height: parentHeight } = textLayer.getBoundingClientRect();
        let rotator;
        switch(textLayer.getAttribute("data-main-rotation")){
            case "90":
                rotator = (x, y, w, h)=>({
                        x: (y - layerY) / parentHeight,
                        y: 1 - (x + w - layerX) / parentWidth,
                        width: h / parentHeight,
                        height: w / parentWidth
                    });
                break;
            case "180":
                rotator = (x, y, w, h)=>({
                        x: 1 - (x + w - layerX) / parentWidth,
                        y: 1 - (y + h - layerY) / parentHeight,
                        width: w / parentWidth,
                        height: h / parentHeight
                    });
                break;
            case "270":
                rotator = (x, y, w, h)=>({
                        x: 1 - (y + h - layerY) / parentHeight,
                        y: (x - layerX) / parentWidth,
                        width: h / parentHeight,
                        height: w / parentWidth
                    });
                break;
            default:
                rotator = (x, y, w, h)=>({
                        x: (x - layerX) / parentWidth,
                        y: (y - layerY) / parentHeight,
                        width: w / parentWidth,
                        height: h / parentHeight
                    });
                break;
        }
        const boxes = [];
        for(let i = 0, ii = selection.rangeCount; i < ii; i++){
            const range = selection.getRangeAt(i);
            if (range.collapsed) continue;
            for (const { x: x, y: y, width: width, height: height } of range.getClientRects()){
                if (width === 0 || height === 0) continue;
                boxes.push(rotator(x, y, width, height));
            }
        }
        return boxes.length === 0 ? null : boxes;
    }
    addChangedExistingAnnotation({ annotationElementId: annotationElementId, id: id }) {
        (this.#changedExistingAnnotations ||= new Map()).set(annotationElementId, id);
    }
    removeChangedExistingAnnotation({ annotationElementId: annotationElementId }) {
        this.#changedExistingAnnotations?.delete(annotationElementId);
    }
    renderAnnotationElement(annotation) {
        const editorId = this.#changedExistingAnnotations?.get(annotation.data.id);
        if (!editorId) return;
        const editor = this.#annotationStorage.getRawValue(editorId);
        if (!editor) return;
        if (this.#mode === $b3a01b20dd2ade98$export$72ea3bfdd9a725bf.NONE && !editor.hasBeenModified) return;
        editor.renderAnnotationElement(annotation);
    }
    setMissingCanvas(annotationId, annotationElementId, canvas) {
        const editor = this.#missingCanvases?.get(annotationId);
        if (!editor) return;
        editor.setCanvas(annotationElementId, canvas);
        this.#missingCanvases.delete(annotationId);
    }
    addMissingCanvas(annotationId, editor) {
        (this.#missingCanvases ||= new Map()).set(annotationId, editor);
    }
}
class $b3a01b20dd2ade98$var$AltText {
    #altText = null;
    #altTextDecorative = false;
    #altTextButton = null;
    #altTextButtonLabel = null;
    #altTextTooltip = null;
    #altTextTooltipTimeout = null;
    #altTextWasFromKeyBoard = false;
    #badge = null;
    #editor = null;
    #guessedText = null;
    #textWithDisclaimer = null;
    #useNewAltTextFlow = false;
    static #l10nNewButton = null;
    static _l10n = null;
    constructor(editor){
        this.#editor = editor;
        this.#useNewAltTextFlow = editor._uiManager.useNewAltTextFlow;
        $b3a01b20dd2ade98$var$AltText.#l10nNewButton ||= Object.freeze({
            added: "pdfjs-editor-new-alt-text-added-button",
            "added-label": "pdfjs-editor-new-alt-text-added-button-label",
            missing: "pdfjs-editor-new-alt-text-missing-button",
            "missing-label": "pdfjs-editor-new-alt-text-missing-button-label",
            review: "pdfjs-editor-new-alt-text-to-review-button",
            "review-label": "pdfjs-editor-new-alt-text-to-review-button-label"
        });
    }
    static initialize(l10n) {
        $b3a01b20dd2ade98$var$AltText._l10n ??= l10n;
    }
    async render() {
        const altText = this.#altTextButton = document.createElement("button");
        altText.className = "altText";
        altText.tabIndex = "0";
        const label = this.#altTextButtonLabel = document.createElement("span");
        altText.append(label);
        if (this.#useNewAltTextFlow) {
            altText.classList.add("new");
            altText.setAttribute("data-l10n-id", $b3a01b20dd2ade98$var$AltText.#l10nNewButton.missing);
            label.setAttribute("data-l10n-id", $b3a01b20dd2ade98$var$AltText.#l10nNewButton["missing-label"]);
        } else {
            altText.setAttribute("data-l10n-id", "pdfjs-editor-alt-text-button");
            label.setAttribute("data-l10n-id", "pdfjs-editor-alt-text-button-label");
        }
        const signal = this.#editor._uiManager._signal;
        altText.addEventListener("contextmenu", $b3a01b20dd2ade98$export$455b7811f904cadc, {
            signal: signal
        });
        altText.addEventListener("pointerdown", (event)=>event.stopPropagation(), {
            signal: signal
        });
        const onClick = (event)=>{
            event.preventDefault();
            this.#editor._uiManager.editAltText(this.#editor);
            if (this.#useNewAltTextFlow) this.#editor._reportTelemetry({
                action: "pdfjs.image.alt_text.image_status_label_clicked",
                data: {
                    label: this.#label
                }
            });
        };
        altText.addEventListener("click", onClick, {
            capture: true,
            signal: signal
        });
        altText.addEventListener("keydown", (event)=>{
            if (event.target === altText && event.key === "Enter") {
                this.#altTextWasFromKeyBoard = true;
                onClick(event);
            }
        }, {
            signal: signal
        });
        await this.#setState();
        return altText;
    }
    get #label() {
        return this.#altText && "added" || this.#altText === null && this.guessedText && "review" || "missing";
    }
    finish() {
        if (!this.#altTextButton) return;
        this.#altTextButton.focus({
            focusVisible: this.#altTextWasFromKeyBoard
        });
        this.#altTextWasFromKeyBoard = false;
    }
    isEmpty() {
        if (this.#useNewAltTextFlow) return this.#altText === null;
        return !this.#altText && !this.#altTextDecorative;
    }
    hasData() {
        if (this.#useNewAltTextFlow) return this.#altText !== null || !!this.#guessedText;
        return this.isEmpty();
    }
    get guessedText() {
        return this.#guessedText;
    }
    async setGuessedText(guessedText) {
        if (this.#altText !== null) return;
        this.#guessedText = guessedText;
        this.#textWithDisclaimer = await $b3a01b20dd2ade98$var$AltText._l10n.get("pdfjs-editor-new-alt-text-generated-alt-text-with-disclaimer", {
            generatedAltText: guessedText
        });
        this.#setState();
    }
    toggleAltTextBadge(visibility = false) {
        if (!this.#useNewAltTextFlow || this.#altText) {
            this.#badge?.remove();
            this.#badge = null;
            return;
        }
        if (!this.#badge) {
            const badge = this.#badge = document.createElement("div");
            badge.className = "noAltTextBadge";
            this.#editor.div.append(badge);
        }
        this.#badge.classList.toggle("hidden", !visibility);
    }
    serialize(isForCopying) {
        let altText = this.#altText;
        if (!isForCopying && this.#guessedText === altText) altText = this.#textWithDisclaimer;
        return {
            altText: altText,
            decorative: this.#altTextDecorative,
            guessedText: this.#guessedText,
            textWithDisclaimer: this.#textWithDisclaimer
        };
    }
    get data() {
        return {
            altText: this.#altText,
            decorative: this.#altTextDecorative
        };
    }
    set data({ altText: altText, decorative: decorative, guessedText: guessedText, textWithDisclaimer: textWithDisclaimer, cancel: cancel = false }) {
        if (guessedText) {
            this.#guessedText = guessedText;
            this.#textWithDisclaimer = textWithDisclaimer;
        }
        if (this.#altText === altText && this.#altTextDecorative === decorative) return;
        if (!cancel) {
            this.#altText = altText;
            this.#altTextDecorative = decorative;
        }
        this.#setState();
    }
    toggle(enabled = false) {
        if (!this.#altTextButton) return;
        if (!enabled && this.#altTextTooltipTimeout) {
            clearTimeout(this.#altTextTooltipTimeout);
            this.#altTextTooltipTimeout = null;
        }
        this.#altTextButton.disabled = !enabled;
    }
    shown() {
        this.#editor._reportTelemetry({
            action: "pdfjs.image.alt_text.image_status_label_displayed",
            data: {
                label: this.#label
            }
        });
    }
    destroy() {
        this.#altTextButton?.remove();
        this.#altTextButton = null;
        this.#altTextButtonLabel = null;
        this.#altTextTooltip = null;
        this.#badge?.remove();
        this.#badge = null;
    }
    async #setState() {
        const button = this.#altTextButton;
        if (!button) return;
        if (this.#useNewAltTextFlow) {
            button.classList.toggle("done", !!this.#altText);
            button.setAttribute("data-l10n-id", $b3a01b20dd2ade98$var$AltText.#l10nNewButton[this.#label]);
            this.#altTextButtonLabel?.setAttribute("data-l10n-id", $b3a01b20dd2ade98$var$AltText.#l10nNewButton[`${this.#label}-label`]);
            if (!this.#altText) {
                this.#altTextTooltip?.remove();
                return;
            }
        } else {
            if (!this.#altText && !this.#altTextDecorative) {
                button.classList.remove("done");
                this.#altTextTooltip?.remove();
                return;
            }
            button.classList.add("done");
            button.setAttribute("data-l10n-id", "pdfjs-editor-alt-text-edit-button");
        }
        let tooltip = this.#altTextTooltip;
        if (!tooltip) {
            this.#altTextTooltip = tooltip = document.createElement("span");
            tooltip.className = "tooltip";
            tooltip.setAttribute("role", "tooltip");
            tooltip.id = `alt-text-tooltip-${this.#editor.id}`;
            const DELAY_TO_SHOW_TOOLTIP = 100;
            const signal = this.#editor._uiManager._signal;
            signal.addEventListener("abort", ()=>{
                clearTimeout(this.#altTextTooltipTimeout);
                this.#altTextTooltipTimeout = null;
            }, {
                once: true
            });
            button.addEventListener("mouseenter", ()=>{
                this.#altTextTooltipTimeout = setTimeout(()=>{
                    this.#altTextTooltipTimeout = null;
                    this.#altTextTooltip.classList.add("show");
                    this.#editor._reportTelemetry({
                        action: "alt_text_tooltip"
                    });
                }, DELAY_TO_SHOW_TOOLTIP);
            }, {
                signal: signal
            });
            button.addEventListener("mouseleave", ()=>{
                if (this.#altTextTooltipTimeout) {
                    clearTimeout(this.#altTextTooltipTimeout);
                    this.#altTextTooltipTimeout = null;
                }
                this.#altTextTooltip?.classList.remove("show");
            }, {
                signal: signal
            });
        }
        if (this.#altTextDecorative) tooltip.setAttribute("data-l10n-id", "pdfjs-editor-alt-text-decorative-tooltip");
        else {
            tooltip.removeAttribute("data-l10n-id");
            tooltip.textContent = this.#altText;
        }
        if (!tooltip.parentNode) button.append(tooltip);
        const element = this.#editor.getElementForAltText();
        element?.setAttribute("aria-describedby", tooltip.id);
    }
}
class $b3a01b20dd2ade98$var$Comment {
    #commentStandaloneButton = null;
    #commentToolbarButton = null;
    #commentWasFromKeyBoard = false;
    #editor = null;
    #initialText = null;
    #richText = null;
    #text = null;
    #date = null;
    #deleted = false;
    #popupPosition = null;
    constructor(editor){
        this.#editor = editor;
    }
    renderForToolbar() {
        const button = this.#commentToolbarButton = document.createElement("button");
        button.className = "comment";
        return this.#render(button, false);
    }
    renderForStandalone() {
        const button = this.#commentStandaloneButton = document.createElement("button");
        button.className = "annotationCommentButton";
        const position = this.#editor.commentButtonPosition;
        if (position) {
            const { style: style } = button;
            style.insetInlineEnd = `calc(${100 * (this.#editor._uiManager.direction === "ltr" ? 1 - position[0] : position[0])}% - var(--comment-button-dim))`;
            style.top = `calc(${100 * position[1]}% - var(--comment-button-dim))`;
            const color = this.#editor.commentButtonColor;
            if (color) style.backgroundColor = color;
        }
        return this.#render(button, true);
    }
    focusButton() {
        setTimeout(()=>{
            (this.#commentStandaloneButton ?? this.#commentToolbarButton)?.focus();
        }, 0);
    }
    onUpdatedColor() {
        if (!this.#commentStandaloneButton) return;
        const color = this.#editor.commentButtonColor;
        if (color) this.#commentStandaloneButton.style.backgroundColor = color;
        this.#editor._uiManager.updatePopupColor(this.#editor);
    }
    get commentButtonWidth() {
        return (this.#commentStandaloneButton?.getBoundingClientRect().width ?? 0) / this.#editor.parent.boundingClientRect.width;
    }
    get commentPopupPositionInLayer() {
        if (this.#popupPosition) return this.#popupPosition;
        if (!this.#commentStandaloneButton) return null;
        const { x: x, y: y, height: height } = this.#commentStandaloneButton.getBoundingClientRect();
        const { x: parentX, y: parentY, width: parentWidth, height: parentHeight } = this.#editor.parent.boundingClientRect;
        return [
            (x - parentX) / parentWidth,
            (y + height - parentY) / parentHeight
        ];
    }
    set commentPopupPositionInLayer(pos) {
        this.#popupPosition = pos;
    }
    hasDefaultPopupPosition() {
        return this.#popupPosition === null;
    }
    removeStandaloneCommentButton() {
        this.#commentStandaloneButton?.remove();
        this.#commentStandaloneButton = null;
    }
    removeToolbarCommentButton() {
        this.#commentToolbarButton?.remove();
        this.#commentToolbarButton = null;
    }
    setCommentButtonStates({ selected: selected, hasPopup: hasPopup }) {
        if (!this.#commentStandaloneButton) return;
        this.#commentStandaloneButton.classList.toggle("selected", selected);
        this.#commentStandaloneButton.ariaExpanded = hasPopup;
    }
    #render(comment, isStandalone) {
        if (!this.#editor._uiManager.hasCommentManager()) return null;
        comment.tabIndex = "0";
        comment.ariaHasPopup = "dialog";
        if (isStandalone) {
            comment.ariaControls = "commentPopup";
            comment.setAttribute("data-l10n-id", "pdfjs-show-comment-button");
        } else {
            comment.ariaControlsElements = [
                this.#editor._uiManager.getCommentDialogElement()
            ];
            comment.setAttribute("data-l10n-id", "pdfjs-editor-add-comment-button");
        }
        const signal = this.#editor._uiManager._signal;
        if (!(signal instanceof AbortSignal) || signal.aborted) return comment;
        comment.addEventListener("contextmenu", $b3a01b20dd2ade98$export$455b7811f904cadc, {
            signal: signal
        });
        if (isStandalone) {
            comment.addEventListener("focusin", (e)=>{
                this.#editor._focusEventsAllowed = false;
                $b3a01b20dd2ade98$export$7ae4cd3a66c1e050(e);
            }, {
                capture: true,
                signal: signal
            });
            comment.addEventListener("focusout", (e)=>{
                this.#editor._focusEventsAllowed = true;
                $b3a01b20dd2ade98$export$7ae4cd3a66c1e050(e);
            }, {
                capture: true,
                signal: signal
            });
        }
        comment.addEventListener("pointerdown", (event)=>event.stopPropagation(), {
            signal: signal
        });
        const onClick = (event)=>{
            event.preventDefault();
            if (comment === this.#commentToolbarButton) this.edit();
            else this.#editor.toggleComment(true);
        };
        comment.addEventListener("click", onClick, {
            capture: true,
            signal: signal
        });
        comment.addEventListener("keydown", (event)=>{
            if (event.target === comment && event.key === "Enter") {
                this.#commentWasFromKeyBoard = true;
                onClick(event);
            }
        }, {
            signal: signal
        });
        comment.addEventListener("pointerenter", ()=>{
            this.#editor.toggleComment(false, true);
        }, {
            signal: signal
        });
        comment.addEventListener("pointerleave", ()=>{
            this.#editor.toggleComment(false, false);
        }, {
            signal: signal
        });
        return comment;
    }
    edit(options) {
        const position = this.commentPopupPositionInLayer;
        let posX, posY;
        if (position) [posX, posY] = position;
        else {
            [posX, posY] = this.#editor.commentButtonPosition;
            const { width: width, height: height, x: x, y: y } = this.#editor;
            posX = x + posX * width;
            posY = y + posY * height;
        }
        const parentDimensions = this.#editor.parent.boundingClientRect;
        const { x: parentX, y: parentY, width: parentWidth, height: parentHeight } = parentDimensions;
        this.#editor._uiManager.editComment(this.#editor, parentX + posX * parentWidth, parentY + posY * parentHeight, {
            ...options,
            parentDimensions: parentDimensions
        });
    }
    finish() {
        if (!this.#commentToolbarButton) return;
        this.#commentToolbarButton.focus({
            focusVisible: this.#commentWasFromKeyBoard
        });
        this.#commentWasFromKeyBoard = false;
    }
    isDeleted() {
        return this.#deleted || this.#text === "";
    }
    isEmpty() {
        return this.#text === null;
    }
    hasBeenEdited() {
        return this.isDeleted() || this.#text !== this.#initialText;
    }
    serialize() {
        return this.data;
    }
    get data() {
        return {
            text: this.#text,
            richText: this.#richText,
            date: this.#date,
            deleted: this.isDeleted()
        };
    }
    set data(text) {
        if (text !== this.#text) this.#richText = null;
        if (text === null) {
            this.#text = "";
            this.#deleted = true;
            return;
        }
        this.#text = text;
        this.#date = new Date();
        this.#deleted = false;
    }
    restoreData({ text: text, richText: richText, date: date }) {
        this.#text = text;
        this.#richText = richText;
        this.#date = date;
        this.#deleted = false;
    }
    setInitialText(text, richText = null) {
        this.#initialText = text;
        this.data = text;
        this.#date = null;
        this.#richText = richText;
    }
    shown() {}
    destroy() {
        this.#commentToolbarButton?.remove();
        this.#commentToolbarButton = null;
        this.#commentStandaloneButton?.remove();
        this.#commentStandaloneButton = null;
        this.#text = "";
        this.#richText = null;
        this.#date = null;
        this.#editor = null;
        this.#commentWasFromKeyBoard = false;
        this.#deleted = false;
    }
}
class $b3a01b20dd2ade98$export$9ae7542b430d543e {
    #container;
    #isPinching = false;
    #isPinchingStopped = null;
    #isPinchingDisabled;
    #onPinchStart;
    #onPinching;
    #onPinchEnd;
    #pointerDownAC = null;
    #signal;
    #touchInfo = null;
    #touchManagerAC;
    #touchMoveAC = null;
    constructor({ container: container, isPinchingDisabled: isPinchingDisabled = null, isPinchingStopped: isPinchingStopped = null, onPinchStart: onPinchStart = null, onPinching: onPinching = null, onPinchEnd: onPinchEnd = null, signal: signal }){
        this.#container = container;
        this.#isPinchingStopped = isPinchingStopped;
        this.#isPinchingDisabled = isPinchingDisabled;
        this.#onPinchStart = onPinchStart;
        this.#onPinching = onPinching;
        this.#onPinchEnd = onPinchEnd;
        this.#touchManagerAC = new AbortController();
        this.#signal = AbortSignal.any([
            signal,
            this.#touchManagerAC.signal
        ]);
        container.addEventListener("touchstart", this.#onTouchStart.bind(this), {
            passive: false,
            signal: this.#signal
        });
    }
    get MIN_TOUCH_DISTANCE_TO_PINCH() {
        return 35 / $b3a01b20dd2ade98$export$f16a99f63bccd50b.pixelRatio;
    }
    #onTouchStart(evt) {
        if (this.#isPinchingDisabled?.()) return;
        if (evt.touches.length === 1) {
            if (this.#pointerDownAC) return;
            const pointerDownAC = this.#pointerDownAC = new AbortController();
            const signal = AbortSignal.any([
                this.#signal,
                pointerDownAC.signal
            ]);
            const container = this.#container;
            const opts = {
                capture: true,
                signal: signal,
                passive: false
            };
            const cancelPointerDown = (e)=>{
                if (e.pointerType === "touch") {
                    this.#pointerDownAC?.abort();
                    this.#pointerDownAC = null;
                }
            };
            container.addEventListener("pointerdown", (e)=>{
                if (e.pointerType === "touch") {
                    $b3a01b20dd2ade98$export$7ae4cd3a66c1e050(e);
                    cancelPointerDown(e);
                }
            }, opts);
            container.addEventListener("pointerup", cancelPointerDown, opts);
            container.addEventListener("pointercancel", cancelPointerDown, opts);
            return;
        }
        if (!this.#touchMoveAC) {
            this.#touchMoveAC = new AbortController();
            const signal = AbortSignal.any([
                this.#signal,
                this.#touchMoveAC.signal
            ]);
            const container = this.#container;
            const opt = {
                signal: signal,
                capture: false,
                passive: false
            };
            container.addEventListener("touchmove", this.#onTouchMove.bind(this), opt);
            const onTouchEnd = this.#onTouchEnd.bind(this);
            container.addEventListener("touchend", onTouchEnd, opt);
            container.addEventListener("touchcancel", onTouchEnd, opt);
            opt.capture = true;
            container.addEventListener("pointerdown", $b3a01b20dd2ade98$export$7ae4cd3a66c1e050, opt);
            container.addEventListener("pointermove", $b3a01b20dd2ade98$export$7ae4cd3a66c1e050, opt);
            container.addEventListener("pointercancel", $b3a01b20dd2ade98$export$7ae4cd3a66c1e050, opt);
            container.addEventListener("pointerup", $b3a01b20dd2ade98$export$7ae4cd3a66c1e050, opt);
            this.#onPinchStart?.();
        }
        $b3a01b20dd2ade98$export$7ae4cd3a66c1e050(evt);
        if (evt.touches.length !== 2 || this.#isPinchingStopped?.()) {
            this.#touchInfo = null;
            return;
        }
        let [touch0, touch1] = evt.touches;
        if (touch0.identifier > touch1.identifier) [touch0, touch1] = [
            touch1,
            touch0
        ];
        this.#touchInfo = {
            touch0X: touch0.screenX,
            touch0Y: touch0.screenY,
            touch1X: touch1.screenX,
            touch1Y: touch1.screenY
        };
    }
    #onTouchMove(evt) {
        if (!this.#touchInfo || evt.touches.length !== 2) return;
        $b3a01b20dd2ade98$export$7ae4cd3a66c1e050(evt);
        let [touch0, touch1] = evt.touches;
        if (touch0.identifier > touch1.identifier) [touch0, touch1] = [
            touch1,
            touch0
        ];
        const { screenX: screen0X, screenY: screen0Y } = touch0;
        const { screenX: screen1X, screenY: screen1Y } = touch1;
        const touchInfo = this.#touchInfo;
        const { touch0X: pTouch0X, touch0Y: pTouch0Y, touch1X: pTouch1X, touch1Y: pTouch1Y } = touchInfo;
        const prevGapX = pTouch1X - pTouch0X;
        const prevGapY = pTouch1Y - pTouch0Y;
        const currGapX = screen1X - screen0X;
        const currGapY = screen1Y - screen0Y;
        const distance = Math.hypot(currGapX, currGapY) || 1;
        const pDistance = Math.hypot(prevGapX, prevGapY) || 1;
        if (!this.#isPinching && Math.abs(pDistance - distance) <= $b3a01b20dd2ade98$export$9ae7542b430d543e.MIN_TOUCH_DISTANCE_TO_PINCH) return;
        touchInfo.touch0X = screen0X;
        touchInfo.touch0Y = screen0Y;
        touchInfo.touch1X = screen1X;
        touchInfo.touch1Y = screen1Y;
        if (!this.#isPinching) {
            this.#isPinching = true;
            return;
        }
        const origin = [
            (screen0X + screen1X) / 2,
            (screen0Y + screen1Y) / 2
        ];
        this.#onPinching?.(origin, pDistance, distance);
    }
    #onTouchEnd(evt) {
        if (evt.touches.length >= 2) return;
        if (this.#touchMoveAC) {
            this.#touchMoveAC.abort();
            this.#touchMoveAC = null;
            this.#onPinchEnd?.();
        }
        if (!this.#touchInfo) return;
        $b3a01b20dd2ade98$export$7ae4cd3a66c1e050(evt);
        this.#touchInfo = null;
        this.#isPinching = false;
    }
    destroy() {
        this.#touchManagerAC?.abort();
        this.#touchManagerAC = null;
        this.#pointerDownAC?.abort();
        this.#pointerDownAC = null;
    }
}
class $b3a01b20dd2ade98$var$AnnotationEditor {
    #accessibilityData = null;
    #allResizerDivs = null;
    #altText = null;
    #comment = null;
    #commentStandaloneButton = null;
    #disabled = false;
    #dragPointerId = null;
    #dragPointerType = "";
    #resizersDiv = null;
    #lastPointerCoords = null;
    #savedDimensions = null;
    #fakeAnnotation = null;
    #focusAC = null;
    #focusedResizerName = "";
    #hasBeenClicked = false;
    #initialRect = null;
    #isEditing = false;
    #isInEditMode = false;
    #isResizerEnabledForKeyboard = false;
    #moveInDOMTimeout = null;
    #prevDragX = 0;
    #prevDragY = 0;
    #telemetryTimeouts = null;
    #touchManager = null;
    isSelected = false;
    _isCopy = false;
    _editToolbar = null;
    _initialOptions = Object.create(null);
    _initialData = null;
    _isVisible = true;
    _uiManager = null;
    _focusEventsAllowed = true;
    static _l10n = null;
    static _l10nResizer = null;
    #isDraggable = false;
    #zIndex = $b3a01b20dd2ade98$var$AnnotationEditor._zIndex++;
    static _borderLineWidth = -1;
    static _colorManager = new $b3a01b20dd2ade98$var$ColorManager();
    static _zIndex = 1;
    static _telemetryTimeout = 1000;
    static get _resizerKeyboardManager() {
        const resize = $b3a01b20dd2ade98$var$AnnotationEditor.prototype._resizeWithKeyboard;
        const small = $b3a01b20dd2ade98$export$26cb16552a82cf63.TRANSLATE_SMALL;
        const big = $b3a01b20dd2ade98$export$26cb16552a82cf63.TRANSLATE_BIG;
        return $b3a01b20dd2ade98$export$b8972b998723d602(this, "_resizerKeyboardManager", new $b3a01b20dd2ade98$var$KeyboardManager([
            [
                [
                    "ArrowLeft",
                    "mac+ArrowLeft"
                ],
                resize,
                {
                    args: [
                        -small,
                        0
                    ]
                }
            ],
            [
                [
                    "ctrl+ArrowLeft",
                    "mac+shift+ArrowLeft"
                ],
                resize,
                {
                    args: [
                        -big,
                        0
                    ]
                }
            ],
            [
                [
                    "ArrowRight",
                    "mac+ArrowRight"
                ],
                resize,
                {
                    args: [
                        small,
                        0
                    ]
                }
            ],
            [
                [
                    "ctrl+ArrowRight",
                    "mac+shift+ArrowRight"
                ],
                resize,
                {
                    args: [
                        big,
                        0
                    ]
                }
            ],
            [
                [
                    "ArrowUp",
                    "mac+ArrowUp"
                ],
                resize,
                {
                    args: [
                        0,
                        -small
                    ]
                }
            ],
            [
                [
                    "ctrl+ArrowUp",
                    "mac+shift+ArrowUp"
                ],
                resize,
                {
                    args: [
                        0,
                        -big
                    ]
                }
            ],
            [
                [
                    "ArrowDown",
                    "mac+ArrowDown"
                ],
                resize,
                {
                    args: [
                        0,
                        small
                    ]
                }
            ],
            [
                [
                    "ctrl+ArrowDown",
                    "mac+shift+ArrowDown"
                ],
                resize,
                {
                    args: [
                        0,
                        big
                    ]
                }
            ],
            [
                [
                    "Escape",
                    "mac+Escape"
                ],
                $b3a01b20dd2ade98$var$AnnotationEditor.prototype._stopResizingWithKeyboard
            ]
        ]));
    }
    constructor(parameters){
        this.parent = parameters.parent;
        this.id = parameters.id;
        this.width = this.height = null;
        this.pageIndex = parameters.parent.pageIndex;
        this.name = parameters.name;
        this.div = null;
        this._uiManager = parameters.uiManager;
        this.annotationElementId = null;
        this._willKeepAspectRatio = false;
        this._initialOptions.isCentered = parameters.isCentered;
        this._structTreeParentId = null;
        this.annotationElementId = parameters.annotationElementId || null;
        this.creationDate = parameters.creationDate || new Date();
        this.modificationDate = parameters.modificationDate || null;
        this.canAddComment = true;
        const { rotation: rotation, rawDims: { pageWidth: pageWidth, pageHeight: pageHeight, pageX: pageX, pageY: pageY } } = this.parent.viewport;
        this.rotation = rotation;
        this.pageRotation = (360 + rotation - this._uiManager.viewParameters.rotation) % 360;
        this.pageDimensions = [
            pageWidth,
            pageHeight
        ];
        this.pageTranslation = [
            pageX,
            pageY
        ];
        const [width, height] = this.parentDimensions;
        this.x = parameters.x / width;
        this.y = parameters.y / height;
        this.isAttachedToDOM = false;
        this.deleted = false;
    }
    updatePageIndex(newPageIndex) {
        this.pageIndex = newPageIndex;
    }
    get editorType() {
        return Object.getPrototypeOf(this).constructor._type;
    }
    get mode() {
        return Object.getPrototypeOf(this).constructor._editorType;
    }
    static get isDrawer() {
        return false;
    }
    static get _defaultLineColor() {
        return $b3a01b20dd2ade98$export$b8972b998723d602(this, "_defaultLineColor", this._colorManager.getHexCode("CanvasText"));
    }
    static deleteAnnotationElement(editor) {
        const fakeEditor = new $b3a01b20dd2ade98$var$FakeEditor({
            id: editor._uiManager.getId(),
            parent: editor.parent,
            uiManager: editor._uiManager
        });
        fakeEditor.annotationElementId = editor.annotationElementId;
        fakeEditor.deleted = true;
        fakeEditor._uiManager.addToAnnotationStorage(fakeEditor);
    }
    static initialize(l10n, _uiManager) {
        $b3a01b20dd2ade98$var$AnnotationEditor._l10n ??= l10n;
        $b3a01b20dd2ade98$var$AnnotationEditor._l10nResizer ||= Object.freeze({
            topLeft: "pdfjs-editor-resizer-top-left",
            topMiddle: "pdfjs-editor-resizer-top-middle",
            topRight: "pdfjs-editor-resizer-top-right",
            middleRight: "pdfjs-editor-resizer-middle-right",
            bottomRight: "pdfjs-editor-resizer-bottom-right",
            bottomMiddle: "pdfjs-editor-resizer-bottom-middle",
            bottomLeft: "pdfjs-editor-resizer-bottom-left",
            middleLeft: "pdfjs-editor-resizer-middle-left"
        });
        if ($b3a01b20dd2ade98$var$AnnotationEditor._borderLineWidth !== -1) return;
        const style = getComputedStyle(document.documentElement);
        $b3a01b20dd2ade98$var$AnnotationEditor._borderLineWidth = parseFloat(style.getPropertyValue("--outline-width")) || 0;
    }
    static updateDefaultParams(_type, _value) {}
    static get defaultPropertiesToUpdate() {
        return [];
    }
    static isHandlingMimeForPasting(mime) {
        return false;
    }
    static paste(item, parent) {
        $b3a01b20dd2ade98$var$unreachable("Not implemented");
    }
    get propertiesToUpdate() {
        return [];
    }
    get _isDraggable() {
        return this.#isDraggable;
    }
    set _isDraggable(value) {
        this.#isDraggable = value;
        this.div?.classList.toggle("draggable", value);
    }
    get uid() {
        return this.annotationElementId || this.id;
    }
    get isEnterHandled() {
        return true;
    }
    center() {
        const [pageWidth, pageHeight] = this.pageDimensions;
        switch(this.parentRotation){
            case 90:
                this.x -= this.height * pageHeight / (pageWidth * 2);
                this.y += this.width * pageWidth / (pageHeight * 2);
                break;
            case 180:
                this.x += this.width / 2;
                this.y += this.height / 2;
                break;
            case 270:
                this.x += this.height * pageHeight / (pageWidth * 2);
                this.y -= this.width * pageWidth / (pageHeight * 2);
                break;
            default:
                this.x -= this.width / 2;
                this.y -= this.height / 2;
                break;
        }
        this.fixAndSetPosition();
    }
    addCommands(params) {
        this._uiManager.addCommands(params);
    }
    get currentLayer() {
        return this._uiManager.currentLayer;
    }
    setInBackground() {
        this.div.style.zIndex = 0;
    }
    setInForeground() {
        this.div.style.zIndex = this.#zIndex;
    }
    setParent(parent) {
        if (parent !== null) {
            this.pageIndex = parent.pageIndex;
            this.pageDimensions = parent.pageDimensions;
        } else {
            this.#stopResizing();
            this.#fakeAnnotation?.remove();
            this.#fakeAnnotation = null;
        }
        this.parent = parent;
    }
    focusin(event) {
        if (!this._focusEventsAllowed) return;
        if (!this.#hasBeenClicked) this.parent.setSelected(this);
        else this.#hasBeenClicked = false;
    }
    focusout(event) {
        if (!this._focusEventsAllowed) return;
        if (!this.isAttachedToDOM) return;
        const target = event.relatedTarget;
        if (target?.closest(`#${this.id}`)) return;
        event.preventDefault();
        if (!this.parent?.isMultipleSelection) this.commitOrRemove();
    }
    commitOrRemove() {
        if (this.isEmpty()) this.remove();
        else this.commit();
    }
    commit() {
        if (!this.isInEditMode()) return;
        this.addToAnnotationStorage();
    }
    addToAnnotationStorage() {
        this._uiManager.addToAnnotationStorage(this);
    }
    setAt(x, y, tx, ty) {
        const [width, height] = this.parentDimensions;
        [tx, ty] = this.screenToPageTranslation(tx, ty);
        this.x = (x + tx) / width;
        this.y = (y + ty) / height;
        this.fixAndSetPosition();
    }
    _moveAfterPaste(baseX, baseY) {
        if (this.isClone) {
            delete this.isClone;
            return;
        }
        const [parentWidth, parentHeight] = this.parentDimensions;
        this.setAt(baseX * parentWidth, baseY * parentHeight, this.width * parentWidth, this.height * parentHeight);
        this._onTranslated();
    }
    #translate([width, height], x, y) {
        [x, y] = this.screenToPageTranslation(x, y);
        this.x += x / width;
        this.y += y / height;
        this._onTranslating(this.x, this.y);
        this.fixAndSetPosition();
    }
    translate(x, y) {
        this.#translate(this.parentDimensions, x, y);
    }
    translateInPage(x, y) {
        this.#initialRect ||= [
            this.x,
            this.y,
            this.width,
            this.height
        ];
        this.#translate(this.pageDimensions, x, y);
        this.div.scrollIntoView({
            block: "nearest"
        });
    }
    translationDone() {
        this._onTranslated(this.x, this.y);
    }
    drag(tx, ty) {
        this.#initialRect ||= [
            this.x,
            this.y,
            this.width,
            this.height
        ];
        const { div: div, parentDimensions: [parentWidth, parentHeight] } = this;
        this.x += tx / parentWidth;
        this.y += ty / parentHeight;
        if (this.parent && (this.x < 0 || this.x > 1 || this.y < 0 || this.y > 1)) {
            const { x: x, y: y } = this.div.getBoundingClientRect();
            if (this.parent.findNewParent(this, x, y)) {
                this.x -= Math.floor(this.x);
                this.y -= Math.floor(this.y);
            }
        }
        let { x: x, y: y } = this;
        const [bx, by] = this.getBaseTranslation();
        x += bx;
        y += by;
        const { style: style } = div;
        style.left = `${(100 * x).toFixed(2)}%`;
        style.top = `${(100 * y).toFixed(2)}%`;
        this._onTranslating(x, y);
        div.scrollIntoView({
            block: "nearest"
        });
    }
    _onTranslating(x, y) {}
    _onTranslated(x, y) {}
    get _hasBeenMoved() {
        return !!this.#initialRect && (this.#initialRect[0] !== this.x || this.#initialRect[1] !== this.y);
    }
    get _hasBeenResized() {
        return !!this.#initialRect && (this.#initialRect[2] !== this.width || this.#initialRect[3] !== this.height);
    }
    getBaseTranslation() {
        const [parentWidth, parentHeight] = this.parentDimensions;
        const { _borderLineWidth: _borderLineWidth } = $b3a01b20dd2ade98$var$AnnotationEditor;
        const x = _borderLineWidth / parentWidth;
        const y = _borderLineWidth / parentHeight;
        switch(this.rotation){
            case 90:
                return [
                    -x,
                    y
                ];
            case 180:
                return [
                    x,
                    y
                ];
            case 270:
                return [
                    x,
                    -y
                ];
            default:
                return [
                    -x,
                    -y
                ];
        }
    }
    get _mustFixPosition() {
        return true;
    }
    fixAndSetPosition(rotation = this.rotation) {
        const { div: { style: style }, pageDimensions: [pageWidth, pageHeight] } = this;
        let { x: x, y: y, width: width, height: height } = this;
        width *= pageWidth;
        height *= pageHeight;
        x *= pageWidth;
        y *= pageHeight;
        if (this._mustFixPosition) switch(rotation){
            case 0:
                x = $b3a01b20dd2ade98$export$b8106b171181a554(x, 0, pageWidth - width);
                y = $b3a01b20dd2ade98$export$b8106b171181a554(y, 0, pageHeight - height);
                break;
            case 90:
                x = $b3a01b20dd2ade98$export$b8106b171181a554(x, 0, pageWidth - height);
                y = $b3a01b20dd2ade98$export$b8106b171181a554(y, width, pageHeight);
                break;
            case 180:
                x = $b3a01b20dd2ade98$export$b8106b171181a554(x, width, pageWidth);
                y = $b3a01b20dd2ade98$export$b8106b171181a554(y, height, pageHeight);
                break;
            case 270:
                x = $b3a01b20dd2ade98$export$b8106b171181a554(x, height, pageWidth);
                y = $b3a01b20dd2ade98$export$b8106b171181a554(y, 0, pageHeight - width);
                break;
        }
        this.x = x /= pageWidth;
        this.y = y /= pageHeight;
        const [bx, by] = this.getBaseTranslation();
        x += bx;
        y += by;
        style.left = `${(100 * x).toFixed(2)}%`;
        style.top = `${(100 * y).toFixed(2)}%`;
        this.moveInDOM();
    }
    static #rotatePoint(x, y, angle) {
        switch(angle){
            case 90:
                return [
                    y,
                    -x
                ];
            case 180:
                return [
                    -x,
                    -y
                ];
            case 270:
                return [
                    -y,
                    x
                ];
            default:
                return [
                    x,
                    y
                ];
        }
    }
    screenToPageTranslation(x, y) {
        return $b3a01b20dd2ade98$var$AnnotationEditor.#rotatePoint(x, y, this.parentRotation);
    }
    pageTranslationToScreen(x, y) {
        return $b3a01b20dd2ade98$var$AnnotationEditor.#rotatePoint(x, y, 360 - this.parentRotation);
    }
    #getRotationMatrix(rotation) {
        switch(rotation){
            case 90:
                {
                    const [pageWidth, pageHeight] = this.pageDimensions;
                    return [
                        0,
                        -pageWidth / pageHeight,
                        pageHeight / pageWidth,
                        0
                    ];
                }
            case 180:
                return [
                    -1,
                    0,
                    0,
                    -1
                ];
            case 270:
                {
                    const [pageWidth, pageHeight] = this.pageDimensions;
                    return [
                        0,
                        pageWidth / pageHeight,
                        -pageHeight / pageWidth,
                        0
                    ];
                }
            default:
                return [
                    1,
                    0,
                    0,
                    1
                ];
        }
    }
    get parentScale() {
        return this._uiManager.viewParameters.realScale;
    }
    get parentRotation() {
        return (this._uiManager.viewParameters.rotation + this.pageRotation) % 360;
    }
    get parentDimensions() {
        const { parentScale: parentScale, pageDimensions: [pageWidth, pageHeight] } = this;
        return [
            pageWidth * parentScale,
            pageHeight * parentScale
        ];
    }
    setDims() {
        const { div: { style: style }, width: width, height: height } = this;
        style.width = `${(100 * width).toFixed(2)}%`;
        style.height = `${(100 * height).toFixed(2)}%`;
    }
    getInitialTranslation() {
        return [
            0,
            0
        ];
    }
    #createResizers() {
        if (this.#resizersDiv) return;
        this.#resizersDiv = document.createElement("div");
        this.#resizersDiv.classList.add("resizers");
        const classes = this._willKeepAspectRatio ? [
            "topLeft",
            "topRight",
            "bottomRight",
            "bottomLeft"
        ] : [
            "topLeft",
            "topMiddle",
            "topRight",
            "middleRight",
            "bottomRight",
            "bottomMiddle",
            "bottomLeft",
            "middleLeft"
        ];
        const signal = this._uiManager._signal;
        for (const name of classes){
            const div = document.createElement("div");
            this.#resizersDiv.append(div);
            div.classList.add("resizer", name);
            div.setAttribute("data-resizer-name", name);
            div.addEventListener("pointerdown", this.#resizerPointerdown.bind(this, name), {
                signal: signal
            });
            div.addEventListener("contextmenu", $b3a01b20dd2ade98$export$455b7811f904cadc, {
                signal: signal
            });
            div.tabIndex = -1;
        }
        this.div.prepend(this.#resizersDiv);
    }
    #resizerPointerdown(name, event) {
        event.preventDefault();
        const { isMac: isMac } = $b3a01b20dd2ade98$export$5fb8891d35c36978.platform;
        if (event.button !== 0 || event.ctrlKey && isMac) return;
        this.#altText?.toggle(false);
        const savedDraggable = this._isDraggable;
        this._isDraggable = false;
        this.#lastPointerCoords = [
            event.screenX,
            event.screenY
        ];
        const ac = new AbortController();
        const signal = this._uiManager.combinedSignal(ac);
        this.parent.togglePointerEvents(false);
        window.addEventListener("pointermove", this.#resizerPointermove.bind(this, name), {
            passive: true,
            capture: true,
            signal: signal
        });
        window.addEventListener("touchmove", $b3a01b20dd2ade98$export$7ae4cd3a66c1e050, {
            passive: false,
            signal: signal
        });
        window.addEventListener("contextmenu", $b3a01b20dd2ade98$export$455b7811f904cadc, {
            signal: signal
        });
        this.#savedDimensions = {
            savedX: this.x,
            savedY: this.y,
            savedWidth: this.width,
            savedHeight: this.height
        };
        const savedParentCursor = this.parent.div.style.cursor;
        const savedCursor = this.div.style.cursor;
        this.div.style.cursor = this.parent.div.style.cursor = window.getComputedStyle(event.target).cursor;
        const pointerUpCallback = ()=>{
            ac.abort();
            this.parent.togglePointerEvents(true);
            this.#altText?.toggle(true);
            this._isDraggable = savedDraggable;
            this.parent.div.style.cursor = savedParentCursor;
            this.div.style.cursor = savedCursor;
            this.#addResizeToUndoStack();
        };
        window.addEventListener("pointerup", pointerUpCallback, {
            signal: signal
        });
        window.addEventListener("blur", pointerUpCallback, {
            signal: signal
        });
    }
    #resize(x, y, width, height) {
        this.width = width;
        this.height = height;
        this.x = x;
        this.y = y;
        this.setDims();
        this.fixAndSetPosition();
        this._onResized();
    }
    _onResized() {}
    #addResizeToUndoStack() {
        if (!this.#savedDimensions) return;
        const { savedX: savedX, savedY: savedY, savedWidth: savedWidth, savedHeight: savedHeight } = this.#savedDimensions;
        this.#savedDimensions = null;
        const newX = this.x;
        const newY = this.y;
        const newWidth = this.width;
        const newHeight = this.height;
        if (newX === savedX && newY === savedY && newWidth === savedWidth && newHeight === savedHeight) return;
        this.addCommands({
            cmd: this.#resize.bind(this, newX, newY, newWidth, newHeight),
            undo: this.#resize.bind(this, savedX, savedY, savedWidth, savedHeight),
            mustExec: true
        });
    }
    static _round(x) {
        return Math.round(x * 10000) / 10000;
    }
    #resizerPointermove(name, event) {
        const [parentWidth, parentHeight] = this.parentDimensions;
        const savedX = this.x;
        const savedY = this.y;
        const savedWidth = this.width;
        const savedHeight = this.height;
        const minWidth = $b3a01b20dd2ade98$var$AnnotationEditor.MIN_SIZE / parentWidth;
        const minHeight = $b3a01b20dd2ade98$var$AnnotationEditor.MIN_SIZE / parentHeight;
        const rotationMatrix = this.#getRotationMatrix(this.rotation);
        const transf = (x, y)=>[
                rotationMatrix[0] * x + rotationMatrix[2] * y,
                rotationMatrix[1] * x + rotationMatrix[3] * y
            ];
        const invRotationMatrix = this.#getRotationMatrix(360 - this.rotation);
        const invTransf = (x, y)=>[
                invRotationMatrix[0] * x + invRotationMatrix[2] * y,
                invRotationMatrix[1] * x + invRotationMatrix[3] * y
            ];
        let getPoint;
        let getOpposite;
        let isDiagonal = false;
        let isHorizontal = false;
        switch(name){
            case "topLeft":
                isDiagonal = true;
                getPoint = (w, h)=>[
                        0,
                        0
                    ];
                getOpposite = (w, h)=>[
                        w,
                        h
                    ];
                break;
            case "topMiddle":
                getPoint = (w, h)=>[
                        w / 2,
                        0
                    ];
                getOpposite = (w, h)=>[
                        w / 2,
                        h
                    ];
                break;
            case "topRight":
                isDiagonal = true;
                getPoint = (w, h)=>[
                        w,
                        0
                    ];
                getOpposite = (w, h)=>[
                        0,
                        h
                    ];
                break;
            case "middleRight":
                isHorizontal = true;
                getPoint = (w, h)=>[
                        w,
                        h / 2
                    ];
                getOpposite = (w, h)=>[
                        0,
                        h / 2
                    ];
                break;
            case "bottomRight":
                isDiagonal = true;
                getPoint = (w, h)=>[
                        w,
                        h
                    ];
                getOpposite = (w, h)=>[
                        0,
                        0
                    ];
                break;
            case "bottomMiddle":
                getPoint = (w, h)=>[
                        w / 2,
                        h
                    ];
                getOpposite = (w, h)=>[
                        w / 2,
                        0
                    ];
                break;
            case "bottomLeft":
                isDiagonal = true;
                getPoint = (w, h)=>[
                        0,
                        h
                    ];
                getOpposite = (w, h)=>[
                        w,
                        0
                    ];
                break;
            case "middleLeft":
                isHorizontal = true;
                getPoint = (w, h)=>[
                        0,
                        h / 2
                    ];
                getOpposite = (w, h)=>[
                        w,
                        h / 2
                    ];
                break;
        }
        const point = getPoint(savedWidth, savedHeight);
        const oppositePoint = getOpposite(savedWidth, savedHeight);
        let transfOppositePoint = transf(...oppositePoint);
        const oppositeX = $b3a01b20dd2ade98$var$AnnotationEditor._round(savedX + transfOppositePoint[0]);
        const oppositeY = $b3a01b20dd2ade98$var$AnnotationEditor._round(savedY + transfOppositePoint[1]);
        let ratioX = 1;
        let ratioY = 1;
        let deltaX, deltaY;
        if (!event.fromKeyboard) {
            const { screenX: screenX, screenY: screenY } = event;
            const [lastScreenX, lastScreenY] = this.#lastPointerCoords;
            [deltaX, deltaY] = this.screenToPageTranslation(screenX - lastScreenX, screenY - lastScreenY);
            this.#lastPointerCoords[0] = screenX;
            this.#lastPointerCoords[1] = screenY;
        } else ({ deltaX: deltaX, deltaY: deltaY } = event);
        [deltaX, deltaY] = invTransf(deltaX / parentWidth, deltaY / parentHeight);
        if (isDiagonal) {
            const oldDiag = Math.hypot(savedWidth, savedHeight);
            ratioX = ratioY = Math.max(Math.min(Math.hypot(oppositePoint[0] - point[0] - deltaX, oppositePoint[1] - point[1] - deltaY) / oldDiag, 1 / savedWidth, 1 / savedHeight), minWidth / savedWidth, minHeight / savedHeight);
        } else if (isHorizontal) ratioX = $b3a01b20dd2ade98$export$b8106b171181a554(Math.abs(oppositePoint[0] - point[0] - deltaX), minWidth, 1) / savedWidth;
        else ratioY = $b3a01b20dd2ade98$export$b8106b171181a554(Math.abs(oppositePoint[1] - point[1] - deltaY), minHeight, 1) / savedHeight;
        const newWidth = $b3a01b20dd2ade98$var$AnnotationEditor._round(savedWidth * ratioX);
        const newHeight = $b3a01b20dd2ade98$var$AnnotationEditor._round(savedHeight * ratioY);
        transfOppositePoint = transf(...getOpposite(newWidth, newHeight));
        const newX = oppositeX - transfOppositePoint[0];
        const newY = oppositeY - transfOppositePoint[1];
        this.#initialRect ||= [
            this.x,
            this.y,
            this.width,
            this.height
        ];
        this.width = newWidth;
        this.height = newHeight;
        this.x = newX;
        this.y = newY;
        this.setDims();
        this.fixAndSetPosition();
        this._onResizing();
    }
    _onResizing() {}
    altTextFinish() {
        this.#altText?.finish();
    }
    get toolbarButtons() {
        return null;
    }
    async addEditToolbar() {
        if (this._editToolbar || this.#isInEditMode) return this._editToolbar;
        this._editToolbar = new $b3a01b20dd2ade98$var$EditorToolbar(this);
        this.div.append(this._editToolbar.render());
        const { toolbarButtons: toolbarButtons } = this;
        if (toolbarButtons) for (const [name, tool] of toolbarButtons)await this._editToolbar.addButton(name, tool);
        if (!this.hasComment) this._editToolbar.addButton("comment", this.addCommentButton());
        this._editToolbar.addButton("delete");
        return this._editToolbar;
    }
    addCommentButtonInToolbar() {
        this._editToolbar?.addButtonBefore("comment", this.addCommentButton(), ".deleteButton");
    }
    removeCommentButtonFromToolbar() {
        this._editToolbar?.removeButton("comment");
    }
    removeEditToolbar() {
        this._editToolbar?.remove();
        this._editToolbar = null;
        this.#altText?.destroy();
    }
    addContainer(container) {
        const editToolbarDiv = this._editToolbar?.div;
        if (editToolbarDiv) editToolbarDiv.before(container);
        else this.div.append(container);
    }
    getClientDimensions() {
        return this.div.getBoundingClientRect();
    }
    createAltText() {
        if (!this.#altText) {
            $b3a01b20dd2ade98$var$AltText.initialize($b3a01b20dd2ade98$var$AnnotationEditor._l10n);
            this.#altText = new $b3a01b20dd2ade98$var$AltText(this);
            if (this.#accessibilityData) {
                this.#altText.data = this.#accessibilityData;
                this.#accessibilityData = null;
            }
        }
        return this.#altText;
    }
    get altTextData() {
        return this.#altText?.data;
    }
    set altTextData(data) {
        if (!this.#altText) return;
        this.#altText.data = data;
    }
    get guessedAltText() {
        return this.#altText?.guessedText;
    }
    async setGuessedAltText(text) {
        await this.#altText?.setGuessedText(text);
    }
    serializeAltText(isForCopying) {
        return this.#altText?.serialize(isForCopying);
    }
    hasAltText() {
        return !!this.#altText && !this.#altText.isEmpty();
    }
    hasAltTextData() {
        return this.#altText?.hasData() ?? false;
    }
    focusCommentButton() {
        this.#comment?.focusButton();
    }
    addCommentButton() {
        return this.canAddComment ? this.#comment ||= new $b3a01b20dd2ade98$var$Comment(this) : null;
    }
    addStandaloneCommentButton() {
        if (!this._uiManager.hasCommentManager()) return;
        if (this.#commentStandaloneButton) {
            if (this._uiManager.isEditingMode()) this.#commentStandaloneButton.classList.remove("hidden");
            return;
        }
        if (!this.hasComment) return;
        this.#commentStandaloneButton = this.#comment.renderForStandalone();
        this.div.append(this.#commentStandaloneButton);
    }
    removeStandaloneCommentButton() {
        this.#comment.removeStandaloneCommentButton();
        this.#commentStandaloneButton = null;
    }
    hideStandaloneCommentButton() {
        this.#commentStandaloneButton?.classList.add("hidden");
    }
    get comment() {
        if (!this.#comment) return null;
        const { data: { richText: richText, text: text, date: date, deleted: deleted } } = this.#comment;
        return {
            text: text,
            richText: richText,
            date: date,
            deleted: deleted,
            color: this.getNonHCMColor(),
            opacity: this.opacity ?? 1
        };
    }
    set comment(value) {
        this.#comment ||= new $b3a01b20dd2ade98$var$Comment(this);
        if (typeof value === "object" && value !== null) this.#comment.restoreData(value);
        else this.#comment.data = value;
        if (this.hasComment) {
            this.removeCommentButtonFromToolbar();
            this.addStandaloneCommentButton();
            this._uiManager.updateComment(this);
        } else {
            this.addCommentButtonInToolbar();
            this.removeStandaloneCommentButton();
            this._uiManager.removeComment(this);
        }
    }
    setCommentData({ comment: comment, popupRef: popupRef, richText: richText }) {
        if (!popupRef) return;
        this.#comment ||= new $b3a01b20dd2ade98$var$Comment(this);
        this.#comment.setInitialText(comment, richText);
        if (!this.annotationElementId) return;
        const storedData = this._uiManager.getAndRemoveDataFromAnnotationStorage(this.annotationElementId);
        if (storedData) this.updateFromAnnotationLayer(storedData);
    }
    get hasEditedComment() {
        return this.#comment?.hasBeenEdited();
    }
    get hasDeletedComment() {
        return this.#comment?.isDeleted();
    }
    get hasComment() {
        return !!this.#comment && !this.#comment.isEmpty() && !this.#comment.isDeleted();
    }
    async editComment(options) {
        this.#comment ||= new $b3a01b20dd2ade98$var$Comment(this);
        this.#comment.edit(options);
    }
    toggleComment(isSelected, visibility) {
        if (this.hasComment) this._uiManager.toggleComment(this, isSelected, visibility);
    }
    setSelectedCommentButton(selected) {
        this.#comment.setSelectedButton(selected);
    }
    addComment(serialized) {
        if (this.hasEditedComment) {
            const DEFAULT_POPUP_WIDTH = 180;
            const DEFAULT_POPUP_HEIGHT = 100;
            const [, , , trY] = serialized.rect;
            const [pageWidth] = this.pageDimensions;
            const [pageX] = this.pageTranslation;
            const blX = pageX + pageWidth + 1;
            const blY = trY - DEFAULT_POPUP_HEIGHT;
            const trX = blX + DEFAULT_POPUP_WIDTH;
            serialized.popup = {
                contents: this.comment.text,
                deleted: this.comment.deleted,
                rect: [
                    blX,
                    blY,
                    trX,
                    trY
                ]
            };
        }
    }
    updateFromAnnotationLayer({ popup: { contents: contents, deleted: deleted } }) {
        this.#comment.data = deleted ? null : contents;
    }
    get parentBoundingClientRect() {
        return this.parent.boundingClientRect;
    }
    render() {
        const div = this.div = document.createElement("div");
        div.setAttribute("data-editor-rotation", (360 - this.rotation) % 360);
        div.className = this.name;
        div.setAttribute("id", this.id);
        div.tabIndex = this.#disabled ? -1 : 0;
        div.setAttribute("role", "application");
        if (this.defaultL10nId) div.setAttribute("data-l10n-id", this.defaultL10nId);
        if (!this._isVisible) div.classList.add("hidden");
        this.setInForeground();
        this.#addFocusListeners();
        const [parentWidth, parentHeight] = this.parentDimensions;
        if (this.parentRotation % 180 !== 0) {
            div.style.maxWidth = `${(100 * parentHeight / parentWidth).toFixed(2)}%`;
            div.style.maxHeight = `${(100 * parentWidth / parentHeight).toFixed(2)}%`;
        }
        const [tx, ty] = this.getInitialTranslation();
        this.translate(tx, ty);
        $b3a01b20dd2ade98$var$bindEvents(this, div, [
            "keydown",
            "pointerdown",
            "dblclick"
        ]);
        if (this.isResizable && this._uiManager._supportsPinchToZoom) this.#touchManager ||= new $b3a01b20dd2ade98$export$9ae7542b430d543e({
            container: div,
            isPinchingDisabled: ()=>!this.isSelected,
            onPinchStart: this.#touchPinchStartCallback.bind(this),
            onPinching: this.#touchPinchCallback.bind(this),
            onPinchEnd: this.#touchPinchEndCallback.bind(this),
            signal: this._uiManager._signal
        });
        this.addStandaloneCommentButton();
        this._uiManager._editorUndoBar?.hide();
        return div;
    }
    #touchPinchStartCallback() {
        this.#savedDimensions = {
            savedX: this.x,
            savedY: this.y,
            savedWidth: this.width,
            savedHeight: this.height
        };
        this.#altText?.toggle(false);
        this.parent.togglePointerEvents(false);
    }
    #touchPinchCallback(_origin, prevDistance, distance) {
        const slowDownFactor = 0.7;
        let factor = slowDownFactor * (distance / prevDistance) + 1 - slowDownFactor;
        if (factor === 1) return;
        const rotationMatrix = this.#getRotationMatrix(this.rotation);
        const transf = (x, y)=>[
                rotationMatrix[0] * x + rotationMatrix[2] * y,
                rotationMatrix[1] * x + rotationMatrix[3] * y
            ];
        const [parentWidth, parentHeight] = this.parentDimensions;
        const savedX = this.x;
        const savedY = this.y;
        const savedWidth = this.width;
        const savedHeight = this.height;
        const minWidth = $b3a01b20dd2ade98$var$AnnotationEditor.MIN_SIZE / parentWidth;
        const minHeight = $b3a01b20dd2ade98$var$AnnotationEditor.MIN_SIZE / parentHeight;
        factor = Math.max(Math.min(factor, 1 / savedWidth, 1 / savedHeight), minWidth / savedWidth, minHeight / savedHeight);
        const newWidth = $b3a01b20dd2ade98$var$AnnotationEditor._round(savedWidth * factor);
        const newHeight = $b3a01b20dd2ade98$var$AnnotationEditor._round(savedHeight * factor);
        if (newWidth === savedWidth && newHeight === savedHeight) return;
        this.#initialRect ||= [
            savedX,
            savedY,
            savedWidth,
            savedHeight
        ];
        const transfCenterPoint = transf(savedWidth / 2, savedHeight / 2);
        const centerX = $b3a01b20dd2ade98$var$AnnotationEditor._round(savedX + transfCenterPoint[0]);
        const centerY = $b3a01b20dd2ade98$var$AnnotationEditor._round(savedY + transfCenterPoint[1]);
        const newTransfCenterPoint = transf(newWidth / 2, newHeight / 2);
        this.x = centerX - newTransfCenterPoint[0];
        this.y = centerY - newTransfCenterPoint[1];
        this.width = newWidth;
        this.height = newHeight;
        this.setDims();
        this.fixAndSetPosition();
        this._onResizing();
    }
    #touchPinchEndCallback() {
        this.#altText?.toggle(true);
        this.parent.togglePointerEvents(true);
        this.#addResizeToUndoStack();
    }
    pointerdown(event) {
        const { isMac: isMac } = $b3a01b20dd2ade98$export$5fb8891d35c36978.platform;
        if (event.button !== 0 || event.ctrlKey && isMac) {
            event.preventDefault();
            return;
        }
        this.#hasBeenClicked = true;
        if (this._isDraggable) {
            this.#setUpDragSession(event);
            return;
        }
        this.#selectOnPointerEvent(event);
    }
    #selectOnPointerEvent(event) {
        const { isMac: isMac } = $b3a01b20dd2ade98$export$5fb8891d35c36978.platform;
        if (event.ctrlKey && !isMac || event.shiftKey || event.metaKey && isMac) this.parent.toggleSelected(this);
        else this.parent.setSelected(this);
    }
    #setUpDragSession(event) {
        const { isSelected: isSelected } = this;
        this._uiManager.setUpDragSession();
        let hasDraggingStarted = false;
        const ac = new AbortController();
        const signal = this._uiManager.combinedSignal(ac);
        const opts = {
            capture: true,
            passive: false,
            signal: signal
        };
        const cancelDrag = (e)=>{
            ac.abort();
            this.#dragPointerId = null;
            this.#hasBeenClicked = false;
            if (!this._uiManager.endDragSession()) this.#selectOnPointerEvent(e);
            if (hasDraggingStarted) this._onStopDragging();
        };
        if (isSelected) {
            this.#prevDragX = event.clientX;
            this.#prevDragY = event.clientY;
            this.#dragPointerId = event.pointerId;
            this.#dragPointerType = event.pointerType;
            window.addEventListener("pointermove", (e)=>{
                if (!hasDraggingStarted) {
                    hasDraggingStarted = true;
                    this._uiManager.toggleComment(this, true, false);
                    this._onStartDragging();
                }
                const { clientX: x, clientY: y, pointerId: pointerId } = e;
                if (pointerId !== this.#dragPointerId) {
                    $b3a01b20dd2ade98$export$7ae4cd3a66c1e050(e);
                    return;
                }
                const [tx, ty] = this.screenToPageTranslation(x - this.#prevDragX, y - this.#prevDragY);
                this.#prevDragX = x;
                this.#prevDragY = y;
                this._uiManager.dragSelectedEditors(tx, ty);
            }, opts);
            window.addEventListener("touchmove", $b3a01b20dd2ade98$export$7ae4cd3a66c1e050, opts);
            window.addEventListener("pointerdown", (e)=>{
                if (e.pointerType === this.#dragPointerType) {
                    if (this.#touchManager || e.isPrimary) cancelDrag(e);
                }
                $b3a01b20dd2ade98$export$7ae4cd3a66c1e050(e);
            }, opts);
        }
        const pointerUpCallback = (e)=>{
            if (!this.#dragPointerId || this.#dragPointerId === e.pointerId) {
                cancelDrag(e);
                return;
            }
            $b3a01b20dd2ade98$export$7ae4cd3a66c1e050(e);
        };
        window.addEventListener("pointerup", pointerUpCallback, {
            signal: signal
        });
        window.addEventListener("blur", pointerUpCallback, {
            signal: signal
        });
    }
    _onStartDragging() {}
    _onStopDragging() {}
    moveInDOM() {
        if (this.#moveInDOMTimeout) clearTimeout(this.#moveInDOMTimeout);
        this.#moveInDOMTimeout = setTimeout(()=>{
            this.#moveInDOMTimeout = null;
            this.parent?.moveEditorInDOM(this);
        }, 0);
    }
    _setParentAndPosition(parent, x, y) {
        parent.changeParent(this);
        this.x = x;
        this.y = y;
        this.fixAndSetPosition();
        this._onTranslated();
    }
    getRect(tx, ty, rotation = this.rotation) {
        const scale = this.parentScale;
        const [pageWidth, pageHeight] = this.pageDimensions;
        const [pageX, pageY] = this.pageTranslation;
        const shiftX = tx / scale;
        const shiftY = ty / scale;
        const x = this.x * pageWidth;
        const y = this.y * pageHeight;
        const width = this.width * pageWidth;
        const height = this.height * pageHeight;
        switch(rotation){
            case 0:
                return [
                    x + shiftX + pageX,
                    pageHeight - y - shiftY - height + pageY,
                    x + shiftX + width + pageX,
                    pageHeight - y - shiftY + pageY
                ];
            case 90:
                return [
                    x + shiftY + pageX,
                    pageHeight - y + shiftX + pageY,
                    x + shiftY + height + pageX,
                    pageHeight - y + shiftX + width + pageY
                ];
            case 180:
                return [
                    x - shiftX - width + pageX,
                    pageHeight - y + shiftY + pageY,
                    x - shiftX + pageX,
                    pageHeight - y + shiftY + height + pageY
                ];
            case 270:
                return [
                    x - shiftY - height + pageX,
                    pageHeight - y - shiftX - width + pageY,
                    x - shiftY + pageX,
                    pageHeight - y - shiftX + pageY
                ];
            default:
                throw new Error("Invalid rotation");
        }
    }
    getRectInCurrentCoords(rect, pageHeight) {
        const [x1, y1, x2, y2] = rect;
        const width = x2 - x1;
        const height = y2 - y1;
        switch(this.rotation){
            case 0:
                return [
                    x1,
                    pageHeight - y2,
                    width,
                    height
                ];
            case 90:
                return [
                    x1,
                    pageHeight - y1,
                    height,
                    width
                ];
            case 180:
                return [
                    x2,
                    pageHeight - y1,
                    width,
                    height
                ];
            case 270:
                return [
                    x2,
                    pageHeight - y2,
                    height,
                    width
                ];
            default:
                throw new Error("Invalid rotation");
        }
    }
    getPDFRect() {
        return this.getRect(0, 0);
    }
    getNonHCMColor() {
        return this.color && $b3a01b20dd2ade98$var$AnnotationEditor._colorManager.convert(this._uiManager.getNonHCMColor(this.color));
    }
    onUpdatedColor() {
        this.#comment?.onUpdatedColor();
    }
    getData() {
        const { comment: { text: str, color: color, date: date, opacity: opacity, deleted: deleted, richText: richText }, uid: id, pageIndex: pageIndex, creationDate: creationDate, modificationDate: modificationDate } = this;
        return {
            id: id,
            pageIndex: pageIndex,
            rect: this.getPDFRect(),
            richText: richText,
            contentsObj: {
                str: str
            },
            creationDate: creationDate,
            modificationDate: date || modificationDate,
            popupRef: !deleted,
            color: color,
            opacity: opacity
        };
    }
    onceAdded(focus) {}
    isEmpty() {
        return false;
    }
    enableEditMode() {
        if (this.isInEditMode()) return false;
        this.parent.setEditingState(false);
        this.#isInEditMode = true;
        return true;
    }
    disableEditMode() {
        if (!this.isInEditMode()) return false;
        this.parent.setEditingState(true);
        this.#isInEditMode = false;
        return true;
    }
    isInEditMode() {
        return this.#isInEditMode;
    }
    shouldGetKeyboardEvents() {
        return this.#isResizerEnabledForKeyboard;
    }
    needsToBeRebuilt() {
        return this.div && !this.isAttachedToDOM;
    }
    get isOnScreen() {
        const { top: top, left: left, bottom: bottom, right: right } = this.getClientDimensions();
        const { innerHeight: innerHeight, innerWidth: innerWidth } = window;
        return left < innerWidth && right > 0 && top < innerHeight && bottom > 0;
    }
    #addFocusListeners() {
        if (this.#focusAC || !this.div) return;
        this.#focusAC = new AbortController();
        const signal = this._uiManager.combinedSignal(this.#focusAC);
        this.div.addEventListener("focusin", this.focusin.bind(this), {
            signal: signal
        });
        this.div.addEventListener("focusout", this.focusout.bind(this), {
            signal: signal
        });
    }
    rebuild() {
        this.#addFocusListeners();
    }
    rotate(_angle) {}
    resize() {}
    serializeDeleted() {
        return {
            id: this.annotationElementId,
            deleted: true,
            pageIndex: this.pageIndex,
            popupRef: this._initialData?.popupRef || ""
        };
    }
    serialize(isForCopying = false, context = null) {
        return {
            annotationType: this.mode,
            pageIndex: this.pageIndex,
            rect: this.getPDFRect(),
            rotation: this.rotation,
            structTreeParentId: this._structTreeParentId,
            popupRef: this._initialData?.popupRef || ""
        };
    }
    static async deserialize(data, parent, uiManager) {
        const editor = new this.prototype.constructor({
            parent: parent,
            id: uiManager.getId(),
            uiManager: uiManager,
            annotationElementId: data.annotationElementId,
            creationDate: data.creationDate,
            modificationDate: data.modificationDate
        });
        editor.rotation = data.rotation;
        editor.#accessibilityData = data.accessibilityData;
        editor._isCopy = data.isCopy || false;
        const [pageWidth, pageHeight] = editor.pageDimensions;
        const [x, y, width, height] = editor.getRectInCurrentCoords(data.rect, pageHeight);
        editor.x = x / pageWidth;
        editor.y = y / pageHeight;
        editor.width = width / pageWidth;
        editor.height = height / pageHeight;
        return editor;
    }
    get hasBeenModified() {
        return !!this.annotationElementId && (this.deleted || this.serialize() !== null);
    }
    remove() {
        this.#focusAC?.abort();
        this.#focusAC = null;
        if (!this.isEmpty()) this.commit();
        if (this.parent) this.parent.remove(this);
        else this._uiManager.removeEditor(this);
        this.hideCommentPopup();
        if (this.#moveInDOMTimeout) {
            clearTimeout(this.#moveInDOMTimeout);
            this.#moveInDOMTimeout = null;
        }
        this.#stopResizing();
        this.removeEditToolbar();
        if (this.#telemetryTimeouts) {
            for (const timeout of this.#telemetryTimeouts.values())clearTimeout(timeout);
            this.#telemetryTimeouts = null;
        }
        this.parent = null;
        this.#touchManager?.destroy();
        this.#touchManager = null;
        this.#fakeAnnotation?.remove();
        this.#fakeAnnotation = null;
    }
    get isResizable() {
        return false;
    }
    makeResizable() {
        if (this.isResizable) {
            this.#createResizers();
            this.#resizersDiv.classList.remove("hidden");
        }
    }
    get toolbarPosition() {
        return null;
    }
    get commentButtonPosition() {
        return this._uiManager.direction === "ltr" ? [
            1,
            0
        ] : [
            0,
            0
        ];
    }
    get commentButtonPositionInPage() {
        const { commentButtonPosition: [posX, posY] } = this;
        const [blX, blY, trX, trY] = this.getPDFRect();
        return [
            $b3a01b20dd2ade98$var$AnnotationEditor._round(blX + (trX - blX) * posX),
            $b3a01b20dd2ade98$var$AnnotationEditor._round(blY + (trY - blY) * (1 - posY))
        ];
    }
    get commentButtonColor() {
        return this._uiManager.makeCommentColor(this.getNonHCMColor(), this.opacity);
    }
    get commentPopupPosition() {
        return this.#comment.commentPopupPositionInLayer;
    }
    set commentPopupPosition(pos) {
        this.#comment.commentPopupPositionInLayer = pos;
    }
    hasDefaultPopupPosition() {
        return this.#comment.hasDefaultPopupPosition();
    }
    get commentButtonWidth() {
        return this.#comment.commentButtonWidth;
    }
    get elementBeforePopup() {
        return this.div;
    }
    setCommentButtonStates(options) {
        this.#comment?.setCommentButtonStates(options);
    }
    keydown(event) {
        if (!this.isResizable || event.target !== this.div || event.key !== "Enter") return;
        this._uiManager.setSelected(this);
        this.#savedDimensions = {
            savedX: this.x,
            savedY: this.y,
            savedWidth: this.width,
            savedHeight: this.height
        };
        const children = this.#resizersDiv.children;
        if (!this.#allResizerDivs) {
            this.#allResizerDivs = Array.from(children);
            const boundResizerKeydown = this.#resizerKeydown.bind(this);
            const boundResizerBlur = this.#resizerBlur.bind(this);
            const signal = this._uiManager._signal;
            for (const div of this.#allResizerDivs){
                const name = div.getAttribute("data-resizer-name");
                div.setAttribute("role", "spinbutton");
                div.addEventListener("keydown", boundResizerKeydown, {
                    signal: signal
                });
                div.addEventListener("blur", boundResizerBlur, {
                    signal: signal
                });
                div.addEventListener("focus", this.#resizerFocus.bind(this, name), {
                    signal: signal
                });
                div.setAttribute("data-l10n-id", $b3a01b20dd2ade98$var$AnnotationEditor._l10nResizer[name]);
            }
        }
        const first = this.#allResizerDivs[0];
        let firstPosition = 0;
        for (const div of children){
            if (div === first) break;
            firstPosition++;
        }
        const nextFirstPosition = (360 - this.rotation + this.parentRotation) % 360 / 90 * (this.#allResizerDivs.length / 4);
        if (nextFirstPosition !== firstPosition) {
            if (nextFirstPosition < firstPosition) for(let i = 0; i < firstPosition - nextFirstPosition; i++)this.#resizersDiv.append(this.#resizersDiv.firstElementChild);
            else if (nextFirstPosition > firstPosition) for(let i = 0; i < nextFirstPosition - firstPosition; i++)this.#resizersDiv.firstElementChild.before(this.#resizersDiv.lastElementChild);
            let i = 0;
            for (const child of children){
                const div = this.#allResizerDivs[i++];
                const name = div.getAttribute("data-resizer-name");
                child.setAttribute("data-l10n-id", $b3a01b20dd2ade98$var$AnnotationEditor._l10nResizer[name]);
            }
        }
        this.#setResizerTabIndex(0);
        this.#isResizerEnabledForKeyboard = true;
        this.#resizersDiv.firstElementChild.focus({
            focusVisible: true
        });
        event.preventDefault();
        event.stopImmediatePropagation();
    }
    #resizerKeydown(event) {
        $b3a01b20dd2ade98$var$AnnotationEditor._resizerKeyboardManager.exec(this, event);
    }
    #resizerBlur(event) {
        if (this.#isResizerEnabledForKeyboard && event.relatedTarget?.parentNode !== this.#resizersDiv) this.#stopResizing();
    }
    #resizerFocus(name) {
        this.#focusedResizerName = this.#isResizerEnabledForKeyboard ? name : "";
    }
    #setResizerTabIndex(value) {
        if (!this.#allResizerDivs) return;
        for (const div of this.#allResizerDivs)div.tabIndex = value;
    }
    _resizeWithKeyboard(x, y) {
        if (!this.#isResizerEnabledForKeyboard) return;
        this.#resizerPointermove(this.#focusedResizerName, {
            deltaX: x,
            deltaY: y,
            fromKeyboard: true
        });
    }
    #stopResizing() {
        this.#isResizerEnabledForKeyboard = false;
        this.#setResizerTabIndex(-1);
        this.#addResizeToUndoStack();
    }
    _stopResizingWithKeyboard() {
        this.#stopResizing();
        this.div.focus();
    }
    select() {
        if (this.isSelected && this._editToolbar) {
            this._editToolbar.show();
            return;
        }
        this.isSelected = true;
        this.makeResizable();
        this.div?.classList.add("selectedEditor");
        if (!this._editToolbar) {
            this.addEditToolbar().then(()=>{
                if (this.div?.classList.contains("selectedEditor")) this._editToolbar?.show();
            });
            return;
        }
        this._editToolbar?.show();
        this.#altText?.toggleAltTextBadge(false);
    }
    focus() {
        if (this.div && !this.div.contains(document.activeElement)) setTimeout(()=>this.div?.focus({
                preventScroll: true
            }), 0);
    }
    unselect() {
        if (!this.isSelected) return;
        this.isSelected = false;
        this.#resizersDiv?.classList.add("hidden");
        this.div?.classList.remove("selectedEditor");
        if (this.div?.contains(document.activeElement)) this._uiManager.currentLayer.div.focus({
            preventScroll: true
        });
        this._editToolbar?.hide();
        this.#altText?.toggleAltTextBadge(true);
        this.hideCommentPopup();
    }
    hideCommentPopup() {
        if (this.hasComment) this._uiManager.toggleComment(null);
    }
    updateParams(type, value) {}
    disableEditing() {}
    enableEditing() {}
    get canChangeContent() {
        return false;
    }
    enterInEditMode() {
        if (!this.canChangeContent) return;
        this.enableEditMode();
        this.div.focus();
    }
    dblclick(event) {
        if (event.target.nodeName === "BUTTON") return;
        this.enterInEditMode();
        this.parent.updateToolbar({
            mode: this.constructor._editorType,
            editId: this.uid
        });
    }
    getElementForAltText() {
        return this.div;
    }
    get contentDiv() {
        return this.div;
    }
    get isEditing() {
        return this.#isEditing;
    }
    set isEditing(value) {
        this.#isEditing = value;
        if (!this.parent) return;
        if (value) {
            this.parent.setSelected(this);
            this.parent.setActiveEditor(this);
        } else this.parent.setActiveEditor(null);
    }
    static get MIN_SIZE() {
        return 16;
    }
    static canCreateNewEmptyEditor() {
        return true;
    }
    get telemetryInitialData() {
        return {
            action: "added"
        };
    }
    get telemetryFinalData() {
        return null;
    }
    _reportTelemetry(data, mustWait = false) {
        if (mustWait) {
            this.#telemetryTimeouts ||= new Map();
            const { action: action } = data;
            let timeout = this.#telemetryTimeouts.get(action);
            if (timeout) clearTimeout(timeout);
            timeout = setTimeout(()=>{
                this._reportTelemetry(data);
                this.#telemetryTimeouts.delete(action);
                if (this.#telemetryTimeouts.size === 0) this.#telemetryTimeouts = null;
            }, $b3a01b20dd2ade98$var$AnnotationEditor._telemetryTimeout);
            this.#telemetryTimeouts.set(action, timeout);
            return;
        }
        data.type ||= this.editorType;
        this._uiManager._eventBus.dispatch("reporttelemetry", {
            source: this,
            details: {
                type: "editing",
                data: data
            }
        });
    }
    show(visible = this._isVisible) {
        this.div.classList.toggle("hidden", !visible);
        this._isVisible = visible;
    }
    enable() {
        if (this.div) this.div.tabIndex = 0;
        this.#disabled = false;
    }
    disable() {
        if (this.div) this.div.tabIndex = -1;
        this.#disabled = true;
    }
    updateFakeAnnotationElement(annotationLayer) {
        if (!this.#fakeAnnotation && !this.deleted) {
            this.#fakeAnnotation = annotationLayer.addFakeAnnotation(this);
            return;
        }
        if (this.deleted) {
            this.#fakeAnnotation.remove();
            this.#fakeAnnotation = null;
            return;
        }
        if (this.hasEditedComment || this._hasBeenMoved || this._hasBeenResized) this.#fakeAnnotation.updateEdited({
            rect: this.getPDFRect(),
            popup: this.comment
        });
    }
    renderAnnotationElement(annotation) {
        if (this.deleted) {
            annotation.hide();
            return null;
        }
        let content = annotation.container.querySelector(".annotationContent");
        if (!content) {
            content = document.createElement("div");
            content.classList.add("annotationContent", this.editorType);
            annotation.container.prepend(content);
        } else if (content.nodeName === "CANVAS") {
            const canvas = content;
            content = document.createElement("div");
            content.classList.add("annotationContent", this.editorType);
            canvas.before(content);
        }
        return content;
    }
    resetAnnotationElement(annotation) {
        const { firstElementChild: firstElementChild } = annotation.container;
        if (firstElementChild?.nodeName === "DIV" && firstElementChild.classList.contains("annotationContent")) firstElementChild.remove();
    }
}
class $b3a01b20dd2ade98$var$FakeEditor extends $b3a01b20dd2ade98$var$AnnotationEditor {
    constructor(params){
        super(params);
        this.annotationElementId = params.annotationElementId;
        this.deleted = true;
    }
    serialize() {
        return this.serializeDeleted();
    }
}
const $b3a01b20dd2ade98$var$SEED = 0xc3d2e1f0;
const $b3a01b20dd2ade98$var$MASK_HIGH = 0xffff0000;
const $b3a01b20dd2ade98$var$MASK_LOW = 0xffff;
class $b3a01b20dd2ade98$var$MurmurHash3_64 {
    constructor(seed){
        this.h1 = seed ? seed & 0xffffffff : $b3a01b20dd2ade98$var$SEED;
        this.h2 = seed ? seed & 0xffffffff : $b3a01b20dd2ade98$var$SEED;
    }
    update(input) {
        let data, length;
        if (typeof input === "string") {
            data = new Uint8Array(input.length * 2);
            length = 0;
            for(let i = 0, ii = input.length; i < ii; i++){
                const code = input.charCodeAt(i);
                if (code <= 0xff) data[length++] = code;
                else {
                    data[length++] = code >>> 8;
                    data[length++] = code & 0xff;
                }
            }
        } else if (ArrayBuffer.isView(input)) {
            data = input.slice();
            length = data.byteLength;
        } else throw new Error("Invalid data format, must be a string or TypedArray.");
        const blockCounts = length >> 2;
        const tailLength = length - blockCounts * 4;
        const dataUint32 = new Uint32Array(data.buffer, 0, blockCounts);
        let k1 = 0, k2 = 0;
        let h1 = this.h1, h2 = this.h2;
        const C1 = 0xcc9e2d51, C2 = 0x1b873593;
        const C1_LOW = C1 & $b3a01b20dd2ade98$var$MASK_LOW, C2_LOW = C2 & $b3a01b20dd2ade98$var$MASK_LOW;
        for(let i = 0; i < blockCounts; i++)if (i & 1) {
            k1 = dataUint32[i];
            k1 = k1 * C1 & $b3a01b20dd2ade98$var$MASK_HIGH | k1 * C1_LOW & $b3a01b20dd2ade98$var$MASK_LOW;
            k1 = k1 << 15 | k1 >>> 17;
            k1 = k1 * C2 & $b3a01b20dd2ade98$var$MASK_HIGH | k1 * C2_LOW & $b3a01b20dd2ade98$var$MASK_LOW;
            h1 ^= k1;
            h1 = h1 << 13 | h1 >>> 19;
            h1 = h1 * 5 + 0xe6546b64;
        } else {
            k2 = dataUint32[i];
            k2 = k2 * C1 & $b3a01b20dd2ade98$var$MASK_HIGH | k2 * C1_LOW & $b3a01b20dd2ade98$var$MASK_LOW;
            k2 = k2 << 15 | k2 >>> 17;
            k2 = k2 * C2 & $b3a01b20dd2ade98$var$MASK_HIGH | k2 * C2_LOW & $b3a01b20dd2ade98$var$MASK_LOW;
            h2 ^= k2;
            h2 = h2 << 13 | h2 >>> 19;
            h2 = h2 * 5 + 0xe6546b64;
        }
        k1 = 0;
        switch(tailLength){
            case 3:
                k1 ^= data[blockCounts * 4 + 2] << 16;
            case 2:
                k1 ^= data[blockCounts * 4 + 1] << 8;
            case 1:
                k1 ^= data[blockCounts * 4];
                k1 = k1 * C1 & $b3a01b20dd2ade98$var$MASK_HIGH | k1 * C1_LOW & $b3a01b20dd2ade98$var$MASK_LOW;
                k1 = k1 << 15 | k1 >>> 17;
                k1 = k1 * C2 & $b3a01b20dd2ade98$var$MASK_HIGH | k1 * C2_LOW & $b3a01b20dd2ade98$var$MASK_LOW;
                if (blockCounts & 1) h1 ^= k1;
                else h2 ^= k1;
        }
        this.h1 = h1;
        this.h2 = h2;
    }
    hexdigest() {
        let h1 = this.h1, h2 = this.h2;
        h1 ^= h2 >>> 1;
        h1 = h1 * 0xed558ccd & $b3a01b20dd2ade98$var$MASK_HIGH | h1 * 0x8ccd & $b3a01b20dd2ade98$var$MASK_LOW;
        h2 = h2 * 0xff51afd7 & $b3a01b20dd2ade98$var$MASK_HIGH | ((h2 << 16 | h1 >>> 16) * 0xafd7ed55 & $b3a01b20dd2ade98$var$MASK_HIGH) >>> 16;
        h1 ^= h2 >>> 1;
        h1 = h1 * 0x1a85ec53 & $b3a01b20dd2ade98$var$MASK_HIGH | h1 * 0xec53 & $b3a01b20dd2ade98$var$MASK_LOW;
        h2 = h2 * 0xc4ceb9fe & $b3a01b20dd2ade98$var$MASK_HIGH | ((h2 << 16 | h1 >>> 16) * 0xb9fe1a85 & $b3a01b20dd2ade98$var$MASK_HIGH) >>> 16;
        h1 ^= h2 >>> 1;
        return (h1 >>> 0).toString(16).padStart(8, "0") + (h2 >>> 0).toString(16).padStart(8, "0");
    }
}
const $b3a01b20dd2ade98$var$SerializableEmpty = Object.freeze({
    map: null,
    hash: "",
    transfer: undefined
});
class $b3a01b20dd2ade98$var$AnnotationStorage {
    #modified = false;
    #modifiedIds = null;
    #editorsMap = null;
    #storage = new Map();
    onSetModified = null;
    onResetModified = null;
    onAnnotationEditor = null;
    getValue(key, defaultValue) {
        const value = this.#storage.get(key);
        if (value === undefined) return defaultValue;
        return Object.assign(defaultValue, value);
    }
    getRawValue(key) {
        return this.#storage.get(key);
    }
    remove(key) {
        const storedValue = this.#storage.get(key);
        if (storedValue === undefined) return;
        if (storedValue instanceof $b3a01b20dd2ade98$var$AnnotationEditor) this.#editorsMap.delete(storedValue.annotationElementId);
        this.#storage.delete(key);
        if (this.#storage.size === 0) this.resetModified();
        if (this.#storage.values().some((v)=>v instanceof $b3a01b20dd2ade98$var$AnnotationEditor)) return;
        this.onAnnotationEditor?.(null);
    }
    setValue(key, value) {
        const obj = this.#storage.get(key);
        let modified = false;
        if (obj !== undefined) {
            for (const [entry, val] of Object.entries(value))if (obj[entry] !== val) {
                modified = true;
                obj[entry] = val;
            }
        } else {
            modified = true;
            this.#storage.set(key, value);
        }
        if (modified) this.#setModified();
        if (value instanceof $b3a01b20dd2ade98$var$AnnotationEditor) {
            (this.#editorsMap ||= new Map()).set(value.annotationElementId, value);
            this.onAnnotationEditor?.(value.constructor._type);
        }
    }
    has(key) {
        return this.#storage.has(key);
    }
    get size() {
        return this.#storage.size;
    }
    #setModified() {
        if (!this.#modified) {
            this.#modified = true;
            this.onSetModified?.();
        }
    }
    resetModified() {
        if (this.#modified) {
            this.#modified = false;
            this.onResetModified?.();
        }
    }
    get print() {
        return new $b3a01b20dd2ade98$var$PrintAnnotationStorage(this);
    }
    get serializable() {
        if (this.#storage.size === 0) return $b3a01b20dd2ade98$var$SerializableEmpty;
        const map = new Map(), hash = new $b3a01b20dd2ade98$var$MurmurHash3_64(), transfer = [];
        const context = Object.create(null);
        let hasBitmap = false;
        for (const [key, val] of this.#storage){
            const serialized = val instanceof $b3a01b20dd2ade98$var$AnnotationEditor ? val.serialize(false, context) : val;
            if (val.page) {
                val.pageIndex = val.page._pageIndex;
                delete val.page;
            }
            if (serialized) {
                map.set(key, serialized);
                hash.update(`${key}:${JSON.stringify(serialized)}`);
                hasBitmap ||= !!serialized.bitmap;
            }
        }
        if (hasBitmap) {
            for (const value of map.values())if (value.bitmap) transfer.push(value.bitmap);
        }
        return map.size > 0 ? {
            map: map,
            hash: hash.hexdigest(),
            transfer: transfer
        } : $b3a01b20dd2ade98$var$SerializableEmpty;
    }
    get editorStats() {
        let stats = null;
        const typeToEditor = new Map();
        let numberOfEditedComments = 0;
        let numberOfDeletedComments = 0;
        for (const value of this.#storage.values()){
            if (!(value instanceof $b3a01b20dd2ade98$var$AnnotationEditor)) {
                if (value.popup) {
                    if (value.popup.deleted) numberOfDeletedComments += 1;
                    else numberOfEditedComments += 1;
                }
                continue;
            }
            if (value.isCommentDeleted) numberOfDeletedComments += 1;
            else if (value.hasEditedComment) numberOfEditedComments += 1;
            const editorStats = value.telemetryFinalData;
            if (!editorStats) continue;
            const { type: type } = editorStats;
            if (!typeToEditor.has(type)) typeToEditor.set(type, Object.getPrototypeOf(value).constructor);
            stats ||= Object.create(null);
            const map = stats[type] ||= new Map();
            for (const [key, val] of Object.entries(editorStats)){
                if (key === "type") continue;
                const counters = map.getOrInsertComputed(key, $b3a01b20dd2ade98$export$b41394a5437791c8);
                counters.set(val, (counters.get(val) ?? 0) + 1);
            }
        }
        if (numberOfDeletedComments > 0 || numberOfEditedComments > 0) {
            stats ||= Object.create(null);
            stats.comments = {
                deleted: numberOfDeletedComments,
                edited: numberOfEditedComments
            };
        }
        if (!stats) return null;
        for (const [type, editor] of typeToEditor)stats[type] = editor.computeTelemetryFinalData(stats[type]);
        return stats;
    }
    resetModifiedIds() {
        this.#modifiedIds = null;
    }
    updateEditor(annotationId, data) {
        const value = this.#editorsMap?.get(annotationId);
        if (value) {
            value.updateFromAnnotationLayer(data);
            return true;
        }
        return false;
    }
    getEditor(annotationId) {
        return this.#editorsMap?.get(annotationId) || null;
    }
    get modifiedIds() {
        if (this.#modifiedIds) return this.#modifiedIds;
        const ids = [];
        if (this.#editorsMap) for (const value of this.#editorsMap.values()){
            if (!value.serialize()) continue;
            ids.push(value.annotationElementId);
        }
        return this.#modifiedIds = {
            ids: new Set(ids),
            hash: ids.join(",")
        };
    }
    [Symbol.iterator]() {
        return this.#storage.entries();
    }
}
class $b3a01b20dd2ade98$var$PrintAnnotationStorage extends $b3a01b20dd2ade98$var$AnnotationStorage {
    #serializable = $b3a01b20dd2ade98$var$SerializableEmpty;
    constructor(parent){
        super();
        const { serializable: serializable } = parent;
        if (serializable === $b3a01b20dd2ade98$var$SerializableEmpty) return;
        const { map: map, hash: hash, transfer: transfer } = serializable;
        const clone = structuredClone(map, transfer ? {
            transfer: transfer
        } : null);
        this.#serializable = {
            map: clone,
            hash: hash,
            transfer: []
        };
    }
    get print() {
        $b3a01b20dd2ade98$var$unreachable("Should not call PrintAnnotationStorage.print");
    }
    get serializable() {
        return this.#serializable;
    }
    get modifiedIds() {
        return $b3a01b20dd2ade98$export$b8972b998723d602(this, "modifiedIds", {
            ids: new Set(),
            hash: ""
        });
    }
}
const $b3a01b20dd2ade98$var$FORCED_DEPENDENCY_LABEL = "__forcedDependency";
const { floor: $b3a01b20dd2ade98$var$floor, ceil: $b3a01b20dd2ade98$var$ceil } = Math;
function $b3a01b20dd2ade98$var$expandBBox(array, index, minX, minY, maxX, maxY) {
    array[index * 4 + 0] = Math.min(array[index * 4 + 0], minX);
    array[index * 4 + 1] = Math.min(array[index * 4 + 1], minY);
    array[index * 4 + 2] = Math.max(array[index * 4 + 2], maxX);
    array[index * 4 + 3] = Math.max(array[index * 4 + 3], maxY);
}
const $b3a01b20dd2ade98$var$EMPTY_BBOX = new Uint32Array(new Uint8Array([
    255,
    255,
    0,
    0
]).buffer)[0];
class $b3a01b20dd2ade98$var$BBoxReader {
    #bboxes;
    #coords;
    constructor(bboxes, coords){
        this.#bboxes = bboxes;
        this.#coords = coords;
    }
    get length() {
        return this.#bboxes.length;
    }
    isEmpty(i) {
        return this.#bboxes[i] === $b3a01b20dd2ade98$var$EMPTY_BBOX;
    }
    minX(i) {
        return this.#coords[i * 4 + 0] / 256;
    }
    minY(i) {
        return this.#coords[i * 4 + 1] / 256;
    }
    maxX(i) {
        return (this.#coords[i * 4 + 2] + 1) / 256;
    }
    maxY(i) {
        return (this.#coords[i * 4 + 3] + 1) / 256;
    }
}
const $b3a01b20dd2ade98$var$ensureDebugMetadata = (map, key)=>map?.getOrInsertComputed(key, ()=>({
            dependencies: new Set(),
            isRenderingOperation: false
        }));
class $b3a01b20dd2ade98$var$CanvasBBoxTracker {
    #baseTransformStack = [
        [
            1,
            0,
            0,
            1,
            0,
            0
        ]
    ];
    #clipBox = [
        -Infinity,
        -Infinity,
        Infinity,
        Infinity
    ];
    #pendingBBox = new Float64Array([
        Infinity,
        Infinity,
        -Infinity,
        -Infinity
    ]);
    _pendingBBoxIdx = -1;
    #canvasWidth;
    #canvasHeight;
    #bboxesCoords;
    #bboxes;
    _savesStack = [];
    _markedContentStack = [];
    constructor(canvas, operationsCount){
        this.#canvasWidth = canvas.width;
        this.#canvasHeight = canvas.height;
        this.#initializeBBoxes(operationsCount);
    }
    growOperationsCount(operationsCount) {
        if (operationsCount >= this.#bboxes.length) this.#initializeBBoxes(operationsCount, this.#bboxes);
    }
    #initializeBBoxes(operationsCount, oldBBoxes) {
        const buffer = new ArrayBuffer(operationsCount * 4);
        this.#bboxesCoords = new Uint8ClampedArray(buffer);
        this.#bboxes = new Uint32Array(buffer);
        if (oldBBoxes && oldBBoxes.length > 0) {
            this.#bboxes.set(oldBBoxes);
            this.#bboxes.fill($b3a01b20dd2ade98$var$EMPTY_BBOX, oldBBoxes.length);
        } else this.#bboxes.fill($b3a01b20dd2ade98$var$EMPTY_BBOX);
    }
    get clipBox() {
        return this.#clipBox;
    }
    save(opIdx) {
        this.#clipBox = {
            __proto__: this.#clipBox
        };
        this._savesStack.push(opIdx);
        return this;
    }
    restore(opIdx, onSavePopped) {
        const previous = Object.getPrototypeOf(this.#clipBox);
        if (previous === null) return this;
        this.#clipBox = previous;
        const lastSave = this._savesStack.pop();
        if (lastSave !== undefined) {
            onSavePopped?.(lastSave, opIdx);
            this.#bboxes[opIdx] = this.#bboxes[lastSave];
        }
        return this;
    }
    recordOpenMarker(idx) {
        this._savesStack.push(idx);
        return this;
    }
    getOpenMarker() {
        if (this._savesStack.length === 0) return null;
        return this._savesStack.at(-1);
    }
    recordCloseMarker(opIdx, onSavePopped) {
        const lastSave = this._savesStack.pop();
        if (lastSave !== undefined) {
            onSavePopped?.(lastSave, opIdx);
            this.#bboxes[opIdx] = this.#bboxes[lastSave];
        }
        return this;
    }
    beginMarkedContent(opIdx) {
        this._markedContentStack.push(opIdx);
        return this;
    }
    endMarkedContent(opIdx, onSavePopped) {
        const lastSave = this._markedContentStack.pop();
        if (lastSave !== undefined) {
            onSavePopped?.(lastSave, opIdx);
            this.#bboxes[opIdx] = this.#bboxes[lastSave];
        }
        return this;
    }
    pushBaseTransform(ctx) {
        this.#baseTransformStack.push($b3a01b20dd2ade98$export$f8f26dd395d7e1bd.multiplyByDOMMatrix(this.#baseTransformStack.at(-1), ctx.getTransform()));
        return this;
    }
    popBaseTransform() {
        if (this.#baseTransformStack.length > 1) this.#baseTransformStack.pop();
        return this;
    }
    resetBBox(idx) {
        if (this._pendingBBoxIdx !== idx) {
            this._pendingBBoxIdx = idx;
            this.#pendingBBox[0] = Infinity;
            this.#pendingBBox[1] = Infinity;
            this.#pendingBBox[2] = -Infinity;
            this.#pendingBBox[3] = -Infinity;
        }
        return this;
    }
    recordClipBox(idx, ctx, minX, maxX, minY, maxY) {
        const transform = $b3a01b20dd2ade98$export$f8f26dd395d7e1bd.multiplyByDOMMatrix(this.#baseTransformStack.at(-1), ctx.getTransform());
        const clipBox = [
            Infinity,
            Infinity,
            -Infinity,
            -Infinity
        ];
        $b3a01b20dd2ade98$export$f8f26dd395d7e1bd.axialAlignedBoundingBox([
            minX,
            minY,
            maxX,
            maxY
        ], transform, clipBox);
        const intersection = $b3a01b20dd2ade98$export$f8f26dd395d7e1bd.intersect(this.#clipBox, clipBox);
        if (intersection) {
            this.#clipBox[0] = intersection[0];
            this.#clipBox[1] = intersection[1];
            this.#clipBox[2] = intersection[2];
            this.#clipBox[3] = intersection[3];
        } else {
            this.#clipBox[0] = this.#clipBox[1] = Infinity;
            this.#clipBox[2] = this.#clipBox[3] = -Infinity;
        }
        return this;
    }
    recordBBox(idx, ctx, minX, maxX, minY, maxY) {
        const clipBox = this.#clipBox;
        if (clipBox[0] === Infinity) return this;
        const transform = $b3a01b20dd2ade98$export$f8f26dd395d7e1bd.multiplyByDOMMatrix(this.#baseTransformStack.at(-1), ctx.getTransform());
        if (clipBox[0] === -Infinity) {
            $b3a01b20dd2ade98$export$f8f26dd395d7e1bd.axialAlignedBoundingBox([
                minX,
                minY,
                maxX,
                maxY
            ], transform, this.#pendingBBox);
            return this;
        }
        const bbox = [
            Infinity,
            Infinity,
            -Infinity,
            -Infinity
        ];
        $b3a01b20dd2ade98$export$f8f26dd395d7e1bd.axialAlignedBoundingBox([
            minX,
            minY,
            maxX,
            maxY
        ], transform, bbox);
        this.#pendingBBox[0] = Math.min(this.#pendingBBox[0], Math.max(bbox[0], clipBox[0]));
        this.#pendingBBox[1] = Math.min(this.#pendingBBox[1], Math.max(bbox[1], clipBox[1]));
        this.#pendingBBox[2] = Math.max(this.#pendingBBox[2], Math.min(bbox[2], clipBox[2]));
        this.#pendingBBox[3] = Math.max(this.#pendingBBox[3], Math.min(bbox[3], clipBox[3]));
        return this;
    }
    recordFullPageBBox(idx) {
        this.#pendingBBox[0] = Math.max(0, this.#clipBox[0]);
        this.#pendingBBox[1] = Math.max(0, this.#clipBox[1]);
        this.#pendingBBox[2] = Math.min(this.#canvasWidth, this.#clipBox[2]);
        this.#pendingBBox[3] = Math.min(this.#canvasHeight, this.#clipBox[3]);
        return this;
    }
    recordOperation(idx, preserve = false, dependencyLists) {
        if (this._pendingBBoxIdx !== idx) return this;
        const minX = $b3a01b20dd2ade98$var$floor(this.#pendingBBox[0] * 256 / this.#canvasWidth);
        const minY = $b3a01b20dd2ade98$var$floor(this.#pendingBBox[1] * 256 / this.#canvasHeight);
        const maxX = $b3a01b20dd2ade98$var$ceil(this.#pendingBBox[2] * 256 / this.#canvasWidth);
        const maxY = $b3a01b20dd2ade98$var$ceil(this.#pendingBBox[3] * 256 / this.#canvasHeight);
        $b3a01b20dd2ade98$var$expandBBox(this.#bboxesCoords, idx, minX, minY, maxX, maxY);
        if (dependencyLists) for (const dependencies of dependencyLists){
            for (const depIdx of dependencies)if (depIdx !== idx) $b3a01b20dd2ade98$var$expandBBox(this.#bboxesCoords, depIdx, minX, minY, maxX, maxY);
        }
        if (!preserve) this._pendingBBoxIdx = -1;
        return this;
    }
    bboxToClipBoxDropOperation(idx) {
        if (this._pendingBBoxIdx === idx) {
            this._pendingBBoxIdx = -1;
            this.#clipBox[0] = Math.max(this.#clipBox[0], this.#pendingBBox[0]);
            this.#clipBox[1] = Math.max(this.#clipBox[1], this.#pendingBBox[1]);
            this.#clipBox[2] = Math.min(this.#clipBox[2], this.#pendingBBox[2]);
            this.#clipBox[3] = Math.min(this.#clipBox[3], this.#pendingBBox[3]);
        }
        return this;
    }
    take() {
        return new $b3a01b20dd2ade98$var$BBoxReader(this.#bboxes, this.#bboxesCoords);
    }
    takeDebugMetadata() {
        throw new Error("Unreachable");
    }
    recordSimpleData(name, idx) {
        return this;
    }
    recordIncrementalData(name, idx) {
        return this;
    }
    resetIncrementalData(name, idx) {
        return this;
    }
    recordNamedData(name, idx) {
        return this;
    }
    recordSimpleDataFromNamed(name, depName, fallbackIdx) {
        return this;
    }
    recordFutureForcedDependency(name, idx) {
        return this;
    }
    inheritSimpleDataAsFutureForcedDependencies(names) {
        return this;
    }
    inheritPendingDependenciesAsFutureForcedDependencies() {
        return this;
    }
    recordCharacterBBox(idx, ctx, font, scale = 1, x = 0, y = 0, getMeasure) {
        return this;
    }
    getSimpleIndex(dependencyName) {
        return undefined;
    }
    recordDependencies(idx, dependencyNames) {
        return this;
    }
    recordNamedDependency(idx, name) {
        return this;
    }
    recordShowTextOperation(idx, preserve = false) {
        return this;
    }
}
class $b3a01b20dd2ade98$var$CanvasDependencyTracker {
    #simple = {
        __proto__: null
    };
    #incremental = {
        __proto__: null,
        transform: [],
        moveText: [],
        sameLineText: [],
        [$b3a01b20dd2ade98$var$FORCED_DEPENDENCY_LABEL]: []
    };
    #namedDependencies = new Map();
    #pendingDependencies = new Set();
    #fontBBoxTrustworthy = new Map();
    #debugMetadata;
    #recordDebugMetadataDepenencyAfterRestore;
    #bboxTracker;
    constructor(bboxTracker, recordDebugMetadata = false){
        this.#bboxTracker = bboxTracker;
        if (recordDebugMetadata) {
            this.#debugMetadata = new Map();
            this.#recordDebugMetadataDepenencyAfterRestore = (lastSave, opIdx)=>{
                $b3a01b20dd2ade98$var$ensureDebugMetadata(this.#debugMetadata, opIdx).dependencies.add(lastSave);
            };
        }
    }
    get clipBox() {
        return this.#bboxTracker.clipBox;
    }
    growOperationsCount(operationsCount) {
        this.#bboxTracker.growOperationsCount(operationsCount);
    }
    save(opIdx) {
        this.#simple = {
            __proto__: this.#simple
        };
        this.#incremental = {
            __proto__: this.#incremental,
            transform: {
                __proto__: this.#incremental.transform
            },
            moveText: {
                __proto__: this.#incremental.moveText
            },
            sameLineText: {
                __proto__: this.#incremental.sameLineText
            },
            [$b3a01b20dd2ade98$var$FORCED_DEPENDENCY_LABEL]: {
                __proto__: this.#incremental[$b3a01b20dd2ade98$var$FORCED_DEPENDENCY_LABEL]
            }
        };
        this.#bboxTracker.save(opIdx);
        return this;
    }
    restore(opIdx) {
        this.#bboxTracker.restore(opIdx, this.#recordDebugMetadataDepenencyAfterRestore);
        const previous = Object.getPrototypeOf(this.#simple);
        if (previous === null) return this;
        this.#simple = previous;
        this.#incremental = Object.getPrototypeOf(this.#incremental);
        return this;
    }
    recordOpenMarker(opIdx) {
        this.#bboxTracker.recordOpenMarker(opIdx, this.#recordDebugMetadataDepenencyAfterRestore);
        return this;
    }
    getOpenMarker() {
        return this.#bboxTracker.getOpenMarker();
    }
    recordCloseMarker(opIdx) {
        this.#bboxTracker.recordCloseMarker(opIdx, this.#recordDebugMetadataDepenencyAfterRestore);
        return this;
    }
    beginMarkedContent(opIdx) {
        this.#bboxTracker.beginMarkedContent(opIdx);
        return this;
    }
    endMarkedContent(opIdx) {
        this.#bboxTracker.endMarkedContent(opIdx, this.#recordDebugMetadataDepenencyAfterRestore);
        return this;
    }
    pushBaseTransform(ctx) {
        this.#bboxTracker.pushBaseTransform(ctx);
        return this;
    }
    popBaseTransform() {
        this.#bboxTracker.popBaseTransform();
        return this;
    }
    recordSimpleData(name, idx) {
        this.#simple[name] = idx;
        return this;
    }
    recordIncrementalData(name, idx) {
        this.#incremental[name].push(idx);
        return this;
    }
    resetIncrementalData(name, idx) {
        this.#incremental[name].length = 0;
        return this;
    }
    recordNamedData(name, idx) {
        this.#namedDependencies.set(name, idx);
        return this;
    }
    recordSimpleDataFromNamed(name, depName, fallbackIdx) {
        this.#simple[name] = this.#namedDependencies.get(depName) ?? fallbackIdx;
    }
    recordFutureForcedDependency(name, idx) {
        this.recordIncrementalData($b3a01b20dd2ade98$var$FORCED_DEPENDENCY_LABEL, idx);
        return this;
    }
    inheritSimpleDataAsFutureForcedDependencies(names) {
        for (const name of names)if (name in this.#simple) this.recordFutureForcedDependency(name, this.#simple[name]);
        return this;
    }
    inheritPendingDependenciesAsFutureForcedDependencies() {
        for (const dep of this.#pendingDependencies)this.recordFutureForcedDependency($b3a01b20dd2ade98$var$FORCED_DEPENDENCY_LABEL, dep);
        return this;
    }
    resetBBox(idx) {
        this.#bboxTracker.resetBBox(idx);
        return this;
    }
    recordClipBox(idx, ctx, minX, maxX, minY, maxY) {
        this.#bboxTracker.recordClipBox(idx, ctx, minX, maxX, minY, maxY);
        return this;
    }
    recordBBox(idx, ctx, minX, maxX, minY, maxY) {
        this.#bboxTracker.recordBBox(idx, ctx, minX, maxX, minY, maxY);
        return this;
    }
    recordCharacterBBox(idx, ctx, font, scale = 1, x = 0, y = 0, getMeasure) {
        const fontBBox = font.bbox;
        let isBBoxTrustworthy;
        let computedBBox;
        if (fontBBox) {
            isBBoxTrustworthy = fontBBox[2] !== fontBBox[0] && fontBBox[3] !== fontBBox[1] && this.#fontBBoxTrustworthy.get(font);
            if (isBBoxTrustworthy !== false) {
                computedBBox = [
                    0,
                    0,
                    0,
                    0
                ];
                $b3a01b20dd2ade98$export$f8f26dd395d7e1bd.axialAlignedBoundingBox(fontBBox, font.fontMatrix, computedBBox);
                if (scale !== 1 || x !== 0 || y !== 0) $b3a01b20dd2ade98$export$f8f26dd395d7e1bd.scaleMinMax([
                    scale,
                    0,
                    0,
                    -scale,
                    x,
                    y
                ], computedBBox);
                if (isBBoxTrustworthy) return this.recordBBox(idx, ctx, computedBBox[0], computedBBox[2], computedBBox[1], computedBBox[3]);
            }
        }
        if (!getMeasure) return this.recordFullPageBBox(idx);
        const measure = getMeasure();
        if (fontBBox && computedBBox && isBBoxTrustworthy === undefined) {
            isBBoxTrustworthy = computedBBox[0] <= x - measure.actualBoundingBoxLeft && computedBBox[2] >= x + measure.actualBoundingBoxRight && computedBBox[1] <= y - measure.actualBoundingBoxAscent && computedBBox[3] >= y + measure.actualBoundingBoxDescent;
            this.#fontBBoxTrustworthy.set(font, isBBoxTrustworthy);
            if (isBBoxTrustworthy) return this.recordBBox(idx, ctx, computedBBox[0], computedBBox[2], computedBBox[1], computedBBox[3]);
        }
        return this.recordBBox(idx, ctx, x - measure.actualBoundingBoxLeft, x + measure.actualBoundingBoxRight, y - measure.actualBoundingBoxAscent, y + measure.actualBoundingBoxDescent);
    }
    recordFullPageBBox(idx) {
        this.#bboxTracker.recordFullPageBBox(idx);
        return this;
    }
    getSimpleIndex(dependencyName) {
        return this.#simple[dependencyName];
    }
    recordDependencies(idx, dependencyNames) {
        const pendingDependencies = this.#pendingDependencies;
        const simple = this.#simple;
        const incremental = this.#incremental;
        for (const name of dependencyNames){
            if (name in this.#simple) pendingDependencies.add(simple[name]);
            else if (name in incremental) incremental[name].forEach(pendingDependencies.add, pendingDependencies);
        }
        return this;
    }
    recordNamedDependency(idx, name) {
        if (this.#namedDependencies.has(name)) this.#pendingDependencies.add(this.#namedDependencies.get(name));
        return this;
    }
    recordOperation(idx, preserve = false) {
        this.recordDependencies(idx, [
            $b3a01b20dd2ade98$var$FORCED_DEPENDENCY_LABEL
        ]);
        if (this.#debugMetadata) {
            const metadata = $b3a01b20dd2ade98$var$ensureDebugMetadata(this.#debugMetadata, idx);
            const { dependencies: dependencies } = metadata;
            this.#pendingDependencies.forEach(dependencies.add, dependencies);
            this.#bboxTracker._savesStack.forEach(dependencies.add, dependencies);
            this.#bboxTracker._markedContentStack.forEach(dependencies.add, dependencies);
            dependencies.delete(idx);
            metadata.isRenderingOperation = true;
        }
        const needsCleanup = !preserve && idx === this.#bboxTracker._pendingBBoxIdx;
        this.#bboxTracker.recordOperation(idx, preserve, [
            this.#pendingDependencies,
            this.#bboxTracker._savesStack,
            this.#bboxTracker._markedContentStack
        ]);
        if (needsCleanup) this.#pendingDependencies.clear();
        return this;
    }
    recordShowTextOperation(idx, preserve = false) {
        const deps = Array.from(this.#pendingDependencies);
        this.recordOperation(idx, preserve);
        this.recordIncrementalData("sameLineText", idx);
        for (const dep of deps)this.recordIncrementalData("sameLineText", dep);
        return this;
    }
    bboxToClipBoxDropOperation(idx, preserve = false) {
        const needsCleanup = !preserve && idx === this.#bboxTracker._pendingBBoxIdx;
        this.#bboxTracker.bboxToClipBoxDropOperation(idx);
        if (needsCleanup) this.#pendingDependencies.clear();
        return this;
    }
    take() {
        this.#fontBBoxTrustworthy.clear();
        return this.#bboxTracker.take();
    }
    takeDebugMetadata() {
        return this.#debugMetadata;
    }
}
class $b3a01b20dd2ade98$var$CanvasNestedDependencyTracker {
    #dependencyTracker;
    #opIdx;
    #ignoreBBoxes;
    #nestingLevel = 0;
    #savesLevel = 0;
    constructor(dependencyTracker, opIdx, ignoreBBoxes){
        if (dependencyTracker instanceof $b3a01b20dd2ade98$var$CanvasNestedDependencyTracker && dependencyTracker.#ignoreBBoxes === !!ignoreBBoxes) return dependencyTracker;
        this.#dependencyTracker = dependencyTracker;
        this.#opIdx = opIdx;
        this.#ignoreBBoxes = !!ignoreBBoxes;
    }
    get clipBox() {
        return this.#dependencyTracker.clipBox;
    }
    growOperationsCount() {
        throw new Error("Unreachable");
    }
    save(opIdx) {
        this.#savesLevel++;
        this.#dependencyTracker.save(this.#opIdx);
        return this;
    }
    restore(opIdx) {
        if (this.#savesLevel > 0) {
            this.#dependencyTracker.restore(this.#opIdx);
            this.#savesLevel--;
        }
        return this;
    }
    recordOpenMarker(idx) {
        this.#nestingLevel++;
        return this;
    }
    getOpenMarker() {
        return this.#nestingLevel > 0 ? this.#opIdx : this.#dependencyTracker.getOpenMarker();
    }
    recordCloseMarker(idx) {
        this.#nestingLevel--;
        return this;
    }
    beginMarkedContent(opIdx) {
        return this;
    }
    endMarkedContent(opIdx) {
        return this;
    }
    pushBaseTransform(ctx) {
        this.#dependencyTracker.pushBaseTransform(ctx);
        return this;
    }
    popBaseTransform() {
        this.#dependencyTracker.popBaseTransform();
        return this;
    }
    recordSimpleData(name, idx) {
        this.#dependencyTracker.recordSimpleData(name, this.#opIdx);
        return this;
    }
    recordIncrementalData(name, idx) {
        this.#dependencyTracker.recordIncrementalData(name, this.#opIdx);
        return this;
    }
    resetIncrementalData(name, idx) {
        this.#dependencyTracker.resetIncrementalData(name, this.#opIdx);
        return this;
    }
    recordNamedData(name, idx) {
        return this;
    }
    recordSimpleDataFromNamed(name, depName, fallbackIdx) {
        this.#dependencyTracker.recordSimpleDataFromNamed(name, depName, this.#opIdx);
        return this;
    }
    recordFutureForcedDependency(name, idx) {
        this.#dependencyTracker.recordFutureForcedDependency(name, this.#opIdx);
        return this;
    }
    inheritSimpleDataAsFutureForcedDependencies(names) {
        this.#dependencyTracker.inheritSimpleDataAsFutureForcedDependencies(names);
        return this;
    }
    inheritPendingDependenciesAsFutureForcedDependencies() {
        this.#dependencyTracker.inheritPendingDependenciesAsFutureForcedDependencies();
        return this;
    }
    resetBBox(idx) {
        if (!this.#ignoreBBoxes) this.#dependencyTracker.resetBBox(this.#opIdx);
        return this;
    }
    recordClipBox(idx, ctx, minX, maxX, minY, maxY) {
        if (!this.#ignoreBBoxes) this.#dependencyTracker.recordClipBox(this.#opIdx, ctx, minX, maxX, minY, maxY);
        return this;
    }
    recordBBox(idx, ctx, minX, maxX, minY, maxY) {
        if (!this.#ignoreBBoxes) this.#dependencyTracker.recordBBox(this.#opIdx, ctx, minX, maxX, minY, maxY);
        return this;
    }
    recordCharacterBBox(idx, ctx, font, scale, x, y, getMeasure) {
        if (!this.#ignoreBBoxes) this.#dependencyTracker.recordCharacterBBox(this.#opIdx, ctx, font, scale, x, y, getMeasure);
        return this;
    }
    recordFullPageBBox(idx) {
        if (!this.#ignoreBBoxes) this.#dependencyTracker.recordFullPageBBox(this.#opIdx);
        return this;
    }
    getSimpleIndex(dependencyName) {
        return this.#dependencyTracker.getSimpleIndex(dependencyName);
    }
    recordDependencies(idx, dependencyNames) {
        this.#dependencyTracker.recordDependencies(this.#opIdx, dependencyNames);
        return this;
    }
    recordNamedDependency(idx, name) {
        this.#dependencyTracker.recordNamedDependency(this.#opIdx, name);
        return this;
    }
    recordOperation(idx) {
        this.#dependencyTracker.recordOperation(this.#opIdx, true);
        return this;
    }
    recordShowTextOperation(idx) {
        this.#dependencyTracker.recordShowTextOperation(this.#opIdx, true);
        return this;
    }
    bboxToClipBoxDropOperation(idx) {
        if (!this.#ignoreBBoxes) this.#dependencyTracker.bboxToClipBoxDropOperation(this.#opIdx, true);
        return this;
    }
    take() {
        throw new Error("Unreachable");
    }
    takeDebugMetadata() {
        throw new Error("Unreachable");
    }
}
const $b3a01b20dd2ade98$var$Dependencies = {
    stroke: [
        "path",
        "transform",
        "filter",
        "strokeColor",
        "strokeAlpha",
        "lineWidth",
        "lineCap",
        "lineJoin",
        "miterLimit",
        "dash"
    ],
    fill: [
        "path",
        "transform",
        "filter",
        "fillColor",
        "fillAlpha",
        "globalCompositeOperation",
        "SMask"
    ],
    imageXObject: [
        "transform",
        "SMask",
        "filter",
        "fillAlpha",
        "strokeAlpha",
        "globalCompositeOperation"
    ],
    rawFillPath: [
        "filter",
        "fillColor",
        "fillAlpha"
    ],
    showText: [
        "transform",
        "leading",
        "charSpacing",
        "wordSpacing",
        "hScale",
        "textRise",
        "moveText",
        "textMatrix",
        "font",
        "fontObj",
        "filter",
        "fillColor",
        "textRenderingMode",
        "SMask",
        "fillAlpha",
        "strokeAlpha",
        "globalCompositeOperation",
        "sameLineText"
    ],
    transform: [
        "transform"
    ],
    transformAndFill: [
        "transform",
        "fillColor"
    ]
};
class $b3a01b20dd2ade98$var$CanvasImagesTracker {
    #canvasWidth;
    #canvasHeight;
    #capacity = 4;
    #count = 0;
    #coords = new $b3a01b20dd2ade98$var$CanvasImagesTracker.#CoordsArray(this.#capacity * 6);
    static #CoordsArray = $b3a01b20dd2ade98$export$5fb8891d35c36978.isFloat16ArraySupported ? Float16Array : Float32Array;
    constructor(canvas){
        this.#canvasWidth = canvas.width;
        this.#canvasHeight = canvas.height;
    }
    record(ctx, width, height, clipBox) {
        if (this.#count === this.#capacity) {
            this.#capacity *= 2;
            const newCoords = new $b3a01b20dd2ade98$var$CanvasImagesTracker.#CoordsArray(this.#capacity * 6);
            newCoords.set(this.#coords);
            this.#coords = newCoords;
        }
        const transform = $b3a01b20dd2ade98$export$f8f26dd395d7e1bd.domMatrixToTransform(ctx.getTransform());
        let coords;
        if (clipBox[0] !== Infinity) {
            const bbox = [
                Infinity,
                Infinity,
                -Infinity,
                -Infinity
            ];
            $b3a01b20dd2ade98$export$f8f26dd395d7e1bd.axialAlignedBoundingBox([
                0,
                -height,
                width,
                0
            ], transform, bbox);
            const finalBBox = $b3a01b20dd2ade98$export$f8f26dd395d7e1bd.intersect(clipBox, bbox);
            if (!finalBBox) return;
            const [minX, minY, maxX, maxY] = finalBBox;
            if (minX !== bbox[0] || minY !== bbox[1] || maxX !== bbox[2] || maxY !== bbox[3]) {
                const rotationAngle = Math.atan2(transform[1], transform[0]);
                const sin = Math.abs(Math.sin(rotationAngle));
                const cos = Math.abs(Math.cos(rotationAngle));
                if (sin < 1e-6 || cos < 1e-6 || Math.abs(sin - cos) < 1e-6) coords = [
                    minX,
                    minY,
                    minX,
                    maxY,
                    maxX,
                    minY
                ];
                else {
                    const finalBBoxWidth = maxX - minX;
                    const finalBBoxHeight = maxY - minY;
                    const sin2 = sin * sin;
                    const cos2 = cos * cos;
                    const cosSin = cos * sin;
                    const denom = cos2 - sin2;
                    const a = (finalBBoxHeight * cos2 - finalBBoxWidth * cosSin) / denom;
                    const b = (finalBBoxHeight * cosSin - finalBBoxWidth * sin2) / denom;
                    coords = [
                        minX + b,
                        minY,
                        minX,
                        minY + a,
                        maxX,
                        maxY - a
                    ];
                }
            }
        }
        if (!coords) {
            coords = [
                0,
                -height,
                0,
                0,
                width,
                -height
            ];
            $b3a01b20dd2ade98$export$f8f26dd395d7e1bd.applyTransform(coords, transform, 0);
            $b3a01b20dd2ade98$export$f8f26dd395d7e1bd.applyTransform(coords, transform, 2);
            $b3a01b20dd2ade98$export$f8f26dd395d7e1bd.applyTransform(coords, transform, 4);
        }
        coords[0] /= this.#canvasWidth;
        coords[1] /= this.#canvasHeight;
        coords[2] /= this.#canvasWidth;
        coords[3] /= this.#canvasHeight;
        coords[4] /= this.#canvasWidth;
        coords[5] /= this.#canvasHeight;
        this.#coords.set(coords, this.#count * 6);
        this.#count++;
    }
    take() {
        return this.#coords.subarray(0, this.#count * 6);
    }
}
class $b3a01b20dd2ade98$var$FontLoader {
    #systemFonts = new Set();
    constructor({ ownerDocument: ownerDocument = globalThis.document, styleElement: styleElement = null }){
        this._document = ownerDocument;
        this.nativeFontFaces = new Set();
        this.styleElement = null;
        this.loadingRequests = [];
        this.loadTestFontId = 0;
    }
    addNativeFontFace(nativeFontFace) {
        this.nativeFontFaces.add(nativeFontFace);
        this._document.fonts.add(nativeFontFace);
    }
    removeNativeFontFace(nativeFontFace) {
        this.nativeFontFaces.delete(nativeFontFace);
        this._document.fonts.delete(nativeFontFace);
    }
    insertRule(rule) {
        if (!this.styleElement) {
            this.styleElement = this._document.createElement("style");
            this._document.documentElement.getElementsByTagName("head")[0].append(this.styleElement);
        }
        const styleSheet = this.styleElement.sheet;
        styleSheet.insertRule(rule, styleSheet.cssRules.length);
    }
    clear() {
        for (const nativeFontFace of this.nativeFontFaces)this._document.fonts.delete(nativeFontFace);
        this.nativeFontFaces.clear();
        this.#systemFonts.clear();
        if (this.styleElement) {
            this.styleElement.remove();
            this.styleElement = null;
        }
    }
    async loadSystemFont({ systemFontInfo: info, disableFontFace: disableFontFace, _inspectFont: _inspectFont }) {
        if (!info || this.#systemFonts.has(info.loadedName)) return;
        $b3a01b20dd2ade98$var$assert(!disableFontFace, "loadSystemFont shouldn't be called when `disableFontFace` is set.");
        if (this.isFontLoadingAPISupported) {
            const { loadedName: loadedName, src: src, style: style } = info;
            const fontFace = new FontFace(loadedName, src, style);
            this.addNativeFontFace(fontFace);
            try {
                await fontFace.load();
                this.#systemFonts.add(loadedName);
                _inspectFont?.(info);
            } catch  {
                $b3a01b20dd2ade98$var$warn(`Cannot load system font: ${info.baseFontName}, installing it could help to improve PDF rendering.`);
                this.removeNativeFontFace(fontFace);
            }
            return;
        }
        $b3a01b20dd2ade98$var$unreachable("Not implemented: loadSystemFont without the Font Loading API.");
    }
    async bind(font) {
        if (font.attached || font.missingFile && !font.systemFontInfo) return;
        font.attached = true;
        if (font.systemFontInfo) {
            await this.loadSystemFont(font);
            return;
        }
        if (this.isFontLoadingAPISupported) {
            const nativeFontFace = font.createNativeFontFace();
            if (nativeFontFace) {
                this.addNativeFontFace(nativeFontFace);
                try {
                    await nativeFontFace.loaded;
                } catch (ex) {
                    $b3a01b20dd2ade98$var$warn(`Failed to load font '${nativeFontFace.family}': '${ex}'.`);
                    font.disableFontFace = true;
                    throw ex;
                }
            }
            return;
        }
        const rule = font.createFontFaceRule();
        if (rule) {
            this.insertRule(rule);
            if (this.isSyncFontLoadingSupported) return;
            await new Promise((resolve)=>{
                const request = this._queueLoadingCallback(resolve);
                this._prepareFontLoadEvent(font, request);
            });
        }
    }
    get isFontLoadingAPISupported() {
        const hasFonts = !!this._document?.fonts;
        return $b3a01b20dd2ade98$export$b8972b998723d602(this, "isFontLoadingAPISupported", hasFonts);
    }
    get isSyncFontLoadingSupported() {
        return $b3a01b20dd2ade98$export$b8972b998723d602(this, "isSyncFontLoadingSupported", $b3a01b20dd2ade98$var$isNodeJS || $b3a01b20dd2ade98$export$5fb8891d35c36978.platform.isFirefox);
    }
    _queueLoadingCallback(callback) {
        function completeRequest() {
            $b3a01b20dd2ade98$var$assert(!request.done, "completeRequest() cannot be called twice.");
            request.done = true;
            while(loadingRequests.length > 0 && loadingRequests[0].done){
                const otherRequest = loadingRequests.shift();
                setTimeout(otherRequest.callback, 0);
            }
        }
        const { loadingRequests: loadingRequests } = this;
        const request = {
            done: false,
            complete: completeRequest,
            callback: callback
        };
        loadingRequests.push(request);
        return request;
    }
    get _loadTestFont() {
        const testFont = atob("T1RUTwALAIAAAwAwQ0ZGIDHtZg4AAAOYAAAAgUZGVE1lkzZwAAAEHAAAABxHREVGABQAFQAABDgAAAAeT1MvMlYNYwkAAAEgAAAAYGNtYXABDQLUAAACNAAAAUJoZWFk/xVFDQAAALwAAAA2aGhlYQdkA+oAAAD0AAAAJGhtdHgD6AAAAAAEWAAAAAZtYXhwAAJQAAAAARgAAAAGbmFtZVjmdH4AAAGAAAAAsXBvc3T/hgAzAAADeAAAACAAAQAAAAEAALZRFsRfDzz1AAsD6AAAAADOBOTLAAAAAM4KHDwAAAAAA+gDIQAAAAgAAgAAAAAAAAABAAADIQAAAFoD6AAAAAAD6AABAAAAAAAAAAAAAAAAAAAAAQAAUAAAAgAAAAQD6AH0AAUAAAKKArwAAACMAooCvAAAAeAAMQECAAACAAYJAAAAAAAAAAAAAQAAAAAAAAAAAAAAAFBmRWQAwAAuAC4DIP84AFoDIQAAAAAAAQAAAAAAAAAAACAAIAABAAAADgCuAAEAAAAAAAAAAQAAAAEAAAAAAAEAAQAAAAEAAAAAAAIAAQAAAAEAAAAAAAMAAQAAAAEAAAAAAAQAAQAAAAEAAAAAAAUAAQAAAAEAAAAAAAYAAQAAAAMAAQQJAAAAAgABAAMAAQQJAAEAAgABAAMAAQQJAAIAAgABAAMAAQQJAAMAAgABAAMAAQQJAAQAAgABAAMAAQQJAAUAAgABAAMAAQQJAAYAAgABWABYAAAAAAAAAwAAAAMAAAAcAAEAAAAAADwAAwABAAAAHAAEACAAAAAEAAQAAQAAAC7//wAAAC7////TAAEAAAAAAAABBgAAAQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAAAAAAAD/gwAyAAAAAQAAAAAAAAAAAAAAAAAAAAABAAQEAAEBAQJYAAEBASH4DwD4GwHEAvgcA/gXBIwMAYuL+nz5tQXkD5j3CBLnEQACAQEBIVhYWFhYWFhYWFhYWFhYWFhYWFhYWFhYWFhYWFhYWFhYAAABAQAADwACAQEEE/t3Dov6fAH6fAT+fPp8+nwHDosMCvm1Cvm1DAz6fBQAAAAAAAABAAAAAMmJbzEAAAAAzgTjFQAAAADOBOQpAAEAAAAAAAAADAAUAAQAAAABAAAAAgABAAAAAAAAAAAD6AAAAAAAAA==");
        return $b3a01b20dd2ade98$export$b8972b998723d602(this, "_loadTestFont", testFont);
    }
    _prepareFontLoadEvent(font, request) {
        function int32(data, offset) {
            return data.charCodeAt(offset) << 24 | data.charCodeAt(offset + 1) << 16 | data.charCodeAt(offset + 2) << 8 | data.charCodeAt(offset + 3) & 0xff;
        }
        function spliceString(s, offset, remove, insert) {
            const chunk1 = s.substring(0, offset);
            const chunk2 = s.substring(offset + remove);
            return chunk1 + insert + chunk2;
        }
        let i, ii;
        const canvas = this._document.createElement("canvas");
        canvas.width = 1;
        canvas.height = 1;
        const ctx = canvas.getContext("2d");
        let called = 0;
        function isFontReady(name, callback) {
            if (++called > 30) {
                $b3a01b20dd2ade98$var$warn("Load test font never loaded.");
                callback();
                return;
            }
            ctx.font = "30px " + name;
            ctx.fillText(".", 0, 20);
            const imageData = ctx.getImageData(0, 0, 1, 1);
            if (imageData.data[3] > 0) {
                callback();
                return;
            }
            setTimeout(isFontReady.bind(null, name, callback));
        }
        const loadTestFontId = `lt${Date.now()}${this.loadTestFontId++}`;
        let data = this._loadTestFont;
        const COMMENT_OFFSET = 976;
        data = spliceString(data, COMMENT_OFFSET, loadTestFontId.length, loadTestFontId);
        const CFF_CHECKSUM_OFFSET = 16;
        const XXXX_VALUE = 0x58585858;
        let checksum = int32(data, CFF_CHECKSUM_OFFSET);
        for(i = 0, ii = loadTestFontId.length - 3; i < ii; i += 4)checksum = checksum - XXXX_VALUE + int32(loadTestFontId, i) | 0;
        if (i < loadTestFontId.length) checksum = checksum - XXXX_VALUE + int32(loadTestFontId + "XXX", i) | 0;
        data = spliceString(data, CFF_CHECKSUM_OFFSET, 4, $b3a01b20dd2ade98$var$string32(checksum));
        const url = `url(data:font/opentype;base64,${btoa(data)});`;
        const rule = `@font-face {font-family:"${loadTestFontId}";src:${url}}`;
        this.insertRule(rule);
        const div = this._document.createElement("div");
        div.style.visibility = "hidden";
        div.style.width = div.style.height = "10px";
        div.style.position = "absolute";
        div.style.top = div.style.left = "0px";
        for (const name of [
            font.loadedName,
            loadTestFontId
        ]){
            const span = this._document.createElement("span");
            span.textContent = "Hi";
            span.style.fontFamily = name;
            div.append(span);
        }
        this._document.body.append(div);
        isFontReady(loadTestFontId, ()=>{
            div.remove();
            request.complete();
        });
    }
}
class $b3a01b20dd2ade98$var$FontFaceObject {
    compiledGlyphs = Object.create(null);
    #fontData;
    constructor(translatedData, inspectFont = null, charProcOperatorList, extra){
        this.#fontData = translatedData;
        this._inspectFont = inspectFont;
        if (charProcOperatorList) this.charProcOperatorList = charProcOperatorList;
        if (extra) Object.assign(this, extra);
    }
    createNativeFontFace() {
        if (!this.data || this.disableFontFace) return null;
        let nativeFontFace;
        if (!this.cssFontInfo) nativeFontFace = new FontFace(this.loadedName, this.data, {});
        else {
            const css = {
                weight: this.cssFontInfo.fontWeight
            };
            if (this.cssFontInfo.italicAngle) css.style = `oblique ${this.cssFontInfo.italicAngle}deg`;
            nativeFontFace = new FontFace(this.cssFontInfo.fontFamily, this.data, css);
        }
        this._inspectFont?.(this);
        return nativeFontFace;
    }
    createFontFaceRule() {
        if (!this.data || this.disableFontFace) return null;
        const url = `url(data:${this.mimetype};base64,${this.data.toBase64()});`;
        let rule;
        if (!this.cssFontInfo) rule = `@font-face {font-family:"${this.loadedName}";src:${url}}`;
        else {
            let css = `font-weight: ${this.cssFontInfo.fontWeight};`;
            if (this.cssFontInfo.italicAngle) css += `font-style: oblique ${this.cssFontInfo.italicAngle}deg;`;
            rule = `@font-face {font-family:"${this.cssFontInfo.fontFamily}";${css}src:${url}}`;
        }
        this._inspectFont?.(this, url);
        return rule;
    }
    getPathGenerator(objs, character) {
        if (this.compiledGlyphs[character] !== undefined) return this.compiledGlyphs[character];
        const objId = this.loadedName + "_path_" + character;
        let cmds;
        try {
            cmds = objs.get(objId);
        } catch (ex) {
            $b3a01b20dd2ade98$var$warn(`getPathGenerator - ignoring character: "${ex}".`);
        }
        const path = $b3a01b20dd2ade98$var$makePathFromDrawOPS(cmds?.path);
        if (!this.fontExtraProperties) objs.delete(objId);
        return this.compiledGlyphs[character] = path;
    }
    get black() {
        return this.#fontData.black;
    }
    get bold() {
        return this.#fontData.bold;
    }
    get disableFontFace() {
        return this.#fontData.disableFontFace;
    }
    set disableFontFace(value) {
        $b3a01b20dd2ade98$export$b8972b998723d602(this, "disableFontFace", !!value);
    }
    get fontExtraProperties() {
        return this.#fontData.fontExtraProperties;
    }
    get isInvalidPDFjsFont() {
        return this.#fontData.isInvalidPDFjsFont;
    }
    get isType3Font() {
        return this.#fontData.isType3Font;
    }
    get italic() {
        return this.#fontData.italic;
    }
    get missingFile() {
        return this.#fontData.missingFile;
    }
    get remeasure() {
        return this.#fontData.remeasure;
    }
    get vertical() {
        return this.#fontData.vertical;
    }
    get ascent() {
        return this.#fontData.ascent;
    }
    get defaultWidth() {
        return this.#fontData.defaultWidth;
    }
    get descent() {
        return this.#fontData.descent;
    }
    get bbox() {
        return this.#fontData.bbox;
    }
    get fontMatrix() {
        return this.#fontData.fontMatrix;
    }
    get fallbackName() {
        return this.#fontData.fallbackName;
    }
    get loadedName() {
        return this.#fontData.loadedName;
    }
    get mimetype() {
        return this.#fontData.mimetype;
    }
    get name() {
        return this.#fontData.name;
    }
    get data() {
        return this.#fontData.data;
    }
    clearData() {
        this.#fontData.clearData();
    }
    get cssFontInfo() {
        return this.#fontData.cssFontInfo;
    }
    get systemFontInfo() {
        return this.#fontData.systemFontInfo;
    }
    get defaultVMetrics() {
        return this.#fontData.defaultVMetrics;
    }
}
class $b3a01b20dd2ade98$var$CSS_FONT_INFO {
    static strings = [
        "fontFamily",
        "fontWeight",
        "italicAngle"
    ];
}
class $b3a01b20dd2ade98$var$SYSTEM_FONT_INFO {
    static strings = [
        "css",
        "loadedName",
        "baseFontName",
        "src"
    ];
}
class $b3a01b20dd2ade98$var$FONT_INFO {
    static bools = [
        "black",
        "bold",
        "disableFontFace",
        "fontExtraProperties",
        "isInvalidPDFjsFont",
        "isType3Font",
        "italic",
        "missingFile",
        "remeasure",
        "vertical"
    ];
    static numbers = [
        "ascent",
        "defaultWidth",
        "descent"
    ];
    static strings = [
        "fallbackName",
        "loadedName",
        "mimetype",
        "name"
    ];
    static OFFSET_NUMBERS = Math.ceil(this.bools.length * 2 / 8);
    static OFFSET_BBOX = this.OFFSET_NUMBERS + this.numbers.length * 8;
    static OFFSET_FONT_MATRIX = this.OFFSET_BBOX + 1 + 8;
    static OFFSET_DEFAULT_VMETRICS = this.OFFSET_FONT_MATRIX + 1 + 48;
    static OFFSET_STRINGS = this.OFFSET_DEFAULT_VMETRICS + 1 + 6;
}
class $b3a01b20dd2ade98$var$PATTERN_INFO {
    static KIND = 0;
    static HAS_BBOX = 1;
    static HAS_BACKGROUND = 2;
    static SHADING_TYPE = 3;
    static N_COORD = 4;
    static N_COLOR = 8;
    static N_STOP = 12;
    static N_FIGURES = 16;
}
class $b3a01b20dd2ade98$var$CssFontInfo {
    #buffer;
    #decoder = new TextDecoder();
    #view;
    constructor(buffer){
        this.#buffer = buffer;
        this.#view = new DataView(buffer);
    }
    #readString(index) {
        $b3a01b20dd2ade98$var$assert(index < $b3a01b20dd2ade98$var$CSS_FONT_INFO.strings.length, "Invalid string index");
        let offset = 0;
        for(let i = 0; i < index; i++)offset += this.#view.getUint32(offset) + 4;
        const length = this.#view.getUint32(offset);
        return this.#decoder.decode(new Uint8Array(this.#buffer, offset + 4, length));
    }
    get fontFamily() {
        return this.#readString(0);
    }
    get fontWeight() {
        return this.#readString(1);
    }
    get italicAngle() {
        return this.#readString(2);
    }
}
class $b3a01b20dd2ade98$var$SystemFontInfo {
    #buffer;
    #decoder = new TextDecoder();
    #view;
    constructor(buffer){
        this.#buffer = buffer;
        this.#view = new DataView(buffer);
    }
    get guessFallback() {
        return this.#view.getUint8(0) !== 0;
    }
    #readString(index) {
        $b3a01b20dd2ade98$var$assert(index < $b3a01b20dd2ade98$var$SYSTEM_FONT_INFO.strings.length, "Invalid string index");
        let offset = 5;
        for(let i = 0; i < index; i++)offset += this.#view.getUint32(offset) + 4;
        const length = this.#view.getUint32(offset);
        return this.#decoder.decode(new Uint8Array(this.#buffer, offset + 4, length));
    }
    get css() {
        return this.#readString(0);
    }
    get loadedName() {
        return this.#readString(1);
    }
    get baseFontName() {
        return this.#readString(2);
    }
    get src() {
        return this.#readString(3);
    }
    get style() {
        let offset = 1;
        offset += 4 + this.#view.getUint32(offset);
        const styleLength = this.#view.getUint32(offset);
        const style = this.#decoder.decode(new Uint8Array(this.#buffer, offset + 4, styleLength));
        offset += 4 + styleLength;
        const weightLength = this.#view.getUint32(offset);
        const weight = this.#decoder.decode(new Uint8Array(this.#buffer, offset + 4, weightLength));
        return {
            style: style,
            weight: weight
        };
    }
}
class $b3a01b20dd2ade98$var$FontInfo {
    #buffer;
    #decoder = new TextDecoder();
    #view;
    constructor({ buffer: buffer, extra: extra }){
        this.#buffer = buffer;
        this.#view = new DataView(buffer);
        if (extra) Object.assign(this, extra);
    }
    #readBoolean(index) {
        $b3a01b20dd2ade98$var$assert(index < $b3a01b20dd2ade98$var$FONT_INFO.bools.length, "Invalid boolean index");
        const byteOffset = Math.floor(index / 4);
        const bitOffset = index * 2 % 8;
        const value = this.#view.getUint8(byteOffset) >> bitOffset & 0x03;
        return value === 0x00 ? undefined : value === 0x02;
    }
    get black() {
        return this.#readBoolean(0);
    }
    get bold() {
        return this.#readBoolean(1);
    }
    get disableFontFace() {
        return this.#readBoolean(2);
    }
    get fontExtraProperties() {
        return this.#readBoolean(3);
    }
    get isInvalidPDFjsFont() {
        return this.#readBoolean(4);
    }
    get isType3Font() {
        return this.#readBoolean(5);
    }
    get italic() {
        return this.#readBoolean(6);
    }
    get missingFile() {
        return this.#readBoolean(7);
    }
    get remeasure() {
        return this.#readBoolean(8);
    }
    get vertical() {
        return this.#readBoolean(9);
    }
    #readNumber(index) {
        $b3a01b20dd2ade98$var$assert(index < $b3a01b20dd2ade98$var$FONT_INFO.numbers.length, "Invalid number index");
        return this.#view.getFloat64($b3a01b20dd2ade98$var$FONT_INFO.OFFSET_NUMBERS + index * 8);
    }
    get ascent() {
        return this.#readNumber(0);
    }
    get defaultWidth() {
        return this.#readNumber(1);
    }
    get descent() {
        return this.#readNumber(2);
    }
    #readArray(offset, arrLen, lookupName, increment) {
        const len = this.#view.getUint8(offset);
        if (len === 0) return undefined;
        $b3a01b20dd2ade98$var$assert(len === arrLen, "Invalid array length.");
        offset += 1;
        const arr = new Array(len);
        for(let i = 0; i < len; i++){
            arr[i] = this.#view[lookupName](offset, true);
            offset += increment;
        }
        return arr;
    }
    get bbox() {
        return this.#readArray($b3a01b20dd2ade98$var$FONT_INFO.OFFSET_BBOX, 4, "getInt16", 2);
    }
    get fontMatrix() {
        return this.#readArray($b3a01b20dd2ade98$var$FONT_INFO.OFFSET_FONT_MATRIX, 6, "getFloat64", 8);
    }
    get defaultVMetrics() {
        return this.#readArray($b3a01b20dd2ade98$var$FONT_INFO.OFFSET_DEFAULT_VMETRICS, 3, "getInt16", 2);
    }
    #readString(index) {
        $b3a01b20dd2ade98$var$assert(index < $b3a01b20dd2ade98$var$FONT_INFO.strings.length, "Invalid string index");
        let offset = $b3a01b20dd2ade98$var$FONT_INFO.OFFSET_STRINGS + 4;
        for(let i = 0; i < index; i++)offset += this.#view.getUint32(offset) + 4;
        const length = this.#view.getUint32(offset);
        return this.#decoder.decode(new Uint8Array(this.#buffer, offset + 4, length));
    }
    get fallbackName() {
        return this.#readString(0);
    }
    get loadedName() {
        return this.#readString(1);
    }
    get mimetype() {
        return this.#readString(2);
    }
    get name() {
        return this.#readString(3);
    }
    #getDataOffsets() {
        let offset = $b3a01b20dd2ade98$var$FONT_INFO.OFFSET_STRINGS;
        const stringsLength = this.#view.getUint32(offset);
        offset += 4 + stringsLength;
        const systemFontInfoLength = this.#view.getUint32(offset);
        offset += 4 + systemFontInfoLength;
        const cssFontInfoLength = this.#view.getUint32(offset);
        offset += 4 + cssFontInfoLength;
        const length = this.#view.getUint32(offset);
        return {
            offset: offset,
            length: length
        };
    }
    get data() {
        const { offset: offset, length: length } = this.#getDataOffsets();
        return length === 0 ? undefined : new Uint8Array(this.#buffer, offset + 4, length);
    }
    clearData() {
        const { offset: offset, length: length } = this.#getDataOffsets();
        if (length === 0) return;
        this.#view.setUint32(offset, 0);
        this.#buffer = new Uint8Array(this.#buffer, 0, offset + 4).slice().buffer;
        this.#view = new DataView(this.#buffer);
    }
    get cssFontInfo() {
        let offset = $b3a01b20dd2ade98$var$FONT_INFO.OFFSET_STRINGS;
        const stringsLength = this.#view.getUint32(offset);
        offset += 4 + stringsLength;
        const systemFontInfoLength = this.#view.getUint32(offset);
        offset += 4 + systemFontInfoLength;
        const cssFontInfoLength = this.#view.getUint32(offset);
        if (cssFontInfoLength === 0) return null;
        const cssFontInfoData = new Uint8Array(cssFontInfoLength);
        cssFontInfoData.set(new Uint8Array(this.#buffer, offset + 4, cssFontInfoLength));
        return new $b3a01b20dd2ade98$var$CssFontInfo(cssFontInfoData.buffer);
    }
    get systemFontInfo() {
        let offset = $b3a01b20dd2ade98$var$FONT_INFO.OFFSET_STRINGS;
        const stringsLength = this.#view.getUint32(offset);
        offset += 4 + stringsLength;
        const systemFontInfoLength = this.#view.getUint32(offset);
        if (systemFontInfoLength === 0) return null;
        const systemFontInfoData = new Uint8Array(systemFontInfoLength);
        systemFontInfoData.set(new Uint8Array(this.#buffer, offset + 4, systemFontInfoLength));
        return new $b3a01b20dd2ade98$var$SystemFontInfo(systemFontInfoData.buffer);
    }
}
class $b3a01b20dd2ade98$var$PatternInfo {
    constructor(buffer){
        this.buffer = buffer;
        this.view = new DataView(buffer);
        this.data = new Uint8Array(buffer);
    }
    getIR() {
        const dataView = this.view;
        const kind = this.data[$b3a01b20dd2ade98$var$PATTERN_INFO.KIND];
        const hasBBox = !!this.data[$b3a01b20dd2ade98$var$PATTERN_INFO.HAS_BBOX];
        const hasBackground = !!this.data[$b3a01b20dd2ade98$var$PATTERN_INFO.HAS_BACKGROUND];
        const nCoord = dataView.getUint32($b3a01b20dd2ade98$var$PATTERN_INFO.N_COORD, true);
        const nColor = dataView.getUint32($b3a01b20dd2ade98$var$PATTERN_INFO.N_COLOR, true);
        const nStop = dataView.getUint32($b3a01b20dd2ade98$var$PATTERN_INFO.N_STOP, true);
        const nFigures = dataView.getUint32($b3a01b20dd2ade98$var$PATTERN_INFO.N_FIGURES, true);
        let offset = 20;
        const coords = new Float32Array(this.buffer, offset, nCoord * 2);
        offset += nCoord * 8;
        const colors = new Uint8Array(this.buffer, offset, nColor * 3);
        offset += nColor * 3;
        const stops = [];
        for(let i = 0; i < nStop; ++i){
            const p = dataView.getFloat32(offset, true);
            offset += 4;
            const rgb = dataView.getUint32(offset, true);
            offset += 4;
            stops.push([
                p,
                `#${rgb.toString(16).padStart(6, "0")}`
            ]);
        }
        let bbox = null;
        if (hasBBox) {
            bbox = [];
            for(let i = 0; i < 4; ++i){
                bbox.push(dataView.getFloat32(offset, true));
                offset += 4;
            }
        }
        let background = null;
        if (hasBackground) {
            background = new Uint8Array(this.buffer, offset, 3);
            offset += 3;
        }
        const figures = [];
        for(let i = 0; i < nFigures; ++i){
            const type = dataView.getUint8(offset);
            offset += 1;
            offset = Math.ceil(offset / 4) * 4;
            const coordsLength = dataView.getUint32(offset, true);
            offset += 4;
            const figureCoords = new Int32Array(this.buffer, offset, coordsLength);
            offset += coordsLength * 4;
            const colorsLength = dataView.getUint32(offset, true);
            offset += 4;
            const figureColors = new Int32Array(this.buffer, offset, colorsLength);
            offset += colorsLength * 4;
            const figure = {
                type: type,
                coords: figureCoords,
                colors: figureColors
            };
            if (type === $b3a01b20dd2ade98$var$MeshFigureType.LATTICE) {
                figure.verticesPerRow = dataView.getUint32(offset, true);
                offset += 4;
            }
            figures.push(figure);
        }
        if (kind === 1) return [
            "RadialAxial",
            "axial",
            bbox,
            stops,
            Array.from(coords.slice(0, 2)),
            Array.from(coords.slice(2, 4)),
            null,
            null
        ];
        if (kind === 2) return [
            "RadialAxial",
            "radial",
            bbox,
            stops,
            [
                coords[0],
                coords[1]
            ],
            [
                coords[3],
                coords[4]
            ],
            coords[2],
            coords[5]
        ];
        if (kind === 3) {
            const shadingType = this.data[$b3a01b20dd2ade98$var$PATTERN_INFO.SHADING_TYPE];
            let bounds = null;
            if (coords.length > 0) {
                bounds = [
                    Infinity,
                    Infinity,
                    -Infinity,
                    -Infinity
                ];
                for(let i = 0, ii = coords.length; i < ii; i += 2)$b3a01b20dd2ade98$export$f8f26dd395d7e1bd.pointBoundingBox(coords[i], coords[i + 1], bounds);
            }
            return [
                "Mesh",
                shadingType,
                coords,
                colors,
                figures,
                bounds,
                bbox,
                background
            ];
        }
        throw new Error(`Unsupported pattern kind: ${kind}`);
    }
}
class $b3a01b20dd2ade98$var$FontPathInfo {
    #buffer;
    constructor(buffer){
        this.#buffer = buffer;
    }
    get path() {
        if ($b3a01b20dd2ade98$export$5fb8891d35c36978.isFloat16ArraySupported) return new Float16Array(this.#buffer);
        return new Float32Array(this.#buffer);
    }
}
function $b3a01b20dd2ade98$var$getUrlProp(val) {
    if (val instanceof URL) return val;
    if (typeof val === "string") {
        if ($b3a01b20dd2ade98$var$isNodeJS) {
            if (/^[a-z][a-z0-9\-+.]+:/i.test(val)) return new URL(val);
            const url = $4TZ3D.getBuiltinModule("url");
            return new URL(url.pathToFileURL(val));
        }
        const url = URL.parse(val, window.location);
        if (url) return url;
    }
    throw new Error("Invalid PDF url data: either string or URL-object is expected in the url property.");
}
function $b3a01b20dd2ade98$var$getDataProp(val) {
    if ($b3a01b20dd2ade98$var$isNodeJS && typeof $b3a01b20dd2ade98$require$Buffer !== "undefined" && val instanceof $b3a01b20dd2ade98$require$Buffer) throw new Error("Please provide binary data as `Uint8Array`, rather than `Buffer`.");
    if (val instanceof Uint8Array && val.byteLength === val.buffer.byteLength) return val;
    if (typeof val === "string") return $b3a01b20dd2ade98$var$stringToBytes(val);
    if (val instanceof ArrayBuffer || ArrayBuffer.isView(val) || typeof val === "object" && !isNaN(val?.length)) return new Uint8Array(val);
    throw new Error("Invalid PDF binary data: either TypedArray, string, or array-like object is expected in the data property.");
}
function $b3a01b20dd2ade98$var$getFactoryUrlProp(val) {
    if (typeof val !== "string") return null;
    if (val.endsWith("/")) return val;
    throw new Error(`Invalid factory url: "${val}" must include trailing slash.`);
}
const $b3a01b20dd2ade98$var$isRefProxy = (v)=>typeof v === "object" && Number.isInteger(v?.num) && v.num >= 0 && Number.isInteger(v?.gen) && v.gen >= 0;
const $b3a01b20dd2ade98$var$isNameProxy = (v)=>typeof v === "object" && typeof v?.name === "string";
const $b3a01b20dd2ade98$export$b5acece0a447dcdc = $b3a01b20dd2ade98$var$_isValidExplicitDest.bind(null, $b3a01b20dd2ade98$var$isRefProxy, $b3a01b20dd2ade98$var$isNameProxy);
class $b3a01b20dd2ade98$var$LoopbackPort {
    #listeners = new Map();
    #deferred = Promise.resolve();
    postMessage(obj, transfer) {
        const event = {
            data: structuredClone(obj, transfer ? {
                transfer: transfer
            } : null)
        };
        this.#deferred.then(()=>{
            for (const [listener] of this.#listeners)listener.call(this, event);
        });
    }
    addEventListener(name, listener, options = null) {
        let rmAbort = null;
        if (options?.signal instanceof AbortSignal) {
            const { signal: signal } = options;
            if (signal.aborted) {
                $b3a01b20dd2ade98$var$warn("LoopbackPort - cannot use an `aborted` signal.");
                return;
            }
            const onAbort = ()=>this.removeEventListener(name, listener);
            rmAbort = ()=>signal.removeEventListener("abort", onAbort);
            signal.addEventListener("abort", onAbort);
        }
        this.#listeners.set(listener, rmAbort);
    }
    removeEventListener(name, listener) {
        const rmAbort = this.#listeners.get(listener);
        rmAbort?.();
        this.#listeners.delete(listener);
    }
    terminate() {
        for (const [, rmAbort] of this.#listeners)rmAbort?.();
        this.#listeners.clear();
    }
}
const $b3a01b20dd2ade98$var$CallbackKind = {
    DATA: 1,
    ERROR: 2
};
const $b3a01b20dd2ade98$var$StreamKind = {
    CANCEL: 1,
    CANCEL_COMPLETE: 2,
    CLOSE: 3,
    ENQUEUE: 4,
    ERROR: 5,
    PULL: 6,
    PULL_COMPLETE: 7,
    START_COMPLETE: 8
};
function $b3a01b20dd2ade98$var$onFn() {}
function $b3a01b20dd2ade98$var$wrapReason(ex) {
    if (ex instanceof $b3a01b20dd2ade98$export$d0e978393d193d1a || ex instanceof $b3a01b20dd2ade98$export$e3d0f4ce5b91e9f1 || ex instanceof $b3a01b20dd2ade98$var$PasswordException || ex instanceof $b3a01b20dd2ade98$export$ea8e9c34f66e603 || ex instanceof $b3a01b20dd2ade98$var$UnknownErrorException) return ex;
    if (!(ex instanceof Error || typeof ex === "object" && ex !== null)) $b3a01b20dd2ade98$var$unreachable('wrapReason: Expected "reason" to be a (possibly cloned) Error.');
    switch(ex.name){
        case "AbortException":
            return new $b3a01b20dd2ade98$export$d0e978393d193d1a(ex.message);
        case "InvalidPDFException":
            return new $b3a01b20dd2ade98$export$e3d0f4ce5b91e9f1(ex.message);
        case "PasswordException":
            return new $b3a01b20dd2ade98$var$PasswordException(ex.message, ex.code);
        case "ResponseException":
            return new $b3a01b20dd2ade98$export$ea8e9c34f66e603(ex.message, ex.status, ex.missing);
        case "UnknownErrorException":
            return new $b3a01b20dd2ade98$var$UnknownErrorException(ex.message, ex.details);
    }
    return new $b3a01b20dd2ade98$var$UnknownErrorException(ex.message, ex.toString());
}
class $b3a01b20dd2ade98$var$MessageHandler {
    #messageAC = new AbortController();
    constructor(sourceName, targetName, comObj){
        this.sourceName = sourceName;
        this.targetName = targetName;
        this.comObj = comObj;
        this.callbackId = 1;
        this.streamId = 1;
        this.streamSinks = Object.create(null);
        this.streamControllers = Object.create(null);
        this.callbackCapabilities = Object.create(null);
        this.actionHandler = Object.create(null);
        comObj.addEventListener("message", this.#onMessage.bind(this), {
            signal: this.#messageAC.signal
        });
    }
    #onMessage({ data: data }) {
        if (data.targetName !== this.sourceName) return;
        if (data.stream) {
            this.#processStreamMessage(data);
            return;
        }
        if (data.callback) {
            const callbackId = data.callbackId;
            const capability = this.callbackCapabilities[callbackId];
            if (!capability) throw new Error(`Cannot resolve callback ${callbackId}`);
            delete this.callbackCapabilities[callbackId];
            if (data.callback === $b3a01b20dd2ade98$var$CallbackKind.DATA) capability.resolve(data.data);
            else if (data.callback === $b3a01b20dd2ade98$var$CallbackKind.ERROR) capability.reject($b3a01b20dd2ade98$var$wrapReason(data.reason));
            else throw new Error("Unexpected callback case");
            return;
        }
        const action = this.actionHandler[data.action];
        if (!action) throw new Error(`Unknown action from worker: ${data.action}`);
        if (data.callbackId) {
            const sourceName = this.sourceName, targetName = data.sourceName, comObj = this.comObj;
            Promise.try(action, data.data).then(function(result) {
                comObj.postMessage({
                    sourceName: sourceName,
                    targetName: targetName,
                    callback: $b3a01b20dd2ade98$var$CallbackKind.DATA,
                    callbackId: data.callbackId,
                    data: result
                });
            }, function(reason) {
                comObj.postMessage({
                    sourceName: sourceName,
                    targetName: targetName,
                    callback: $b3a01b20dd2ade98$var$CallbackKind.ERROR,
                    callbackId: data.callbackId,
                    reason: $b3a01b20dd2ade98$var$wrapReason(reason)
                });
            });
            return;
        }
        if (data.streamId) {
            this.#createStreamSink(data);
            return;
        }
        action(data.data);
    }
    on(actionName, handler) {
        const ah = this.actionHandler;
        if (ah[actionName]) throw new Error(`There is already an actionName called "${actionName}"`);
        ah[actionName] = handler;
    }
    send(actionName, data, transfers) {
        this.comObj.postMessage({
            sourceName: this.sourceName,
            targetName: this.targetName,
            action: actionName,
            data: data
        }, transfers);
    }
    sendWithPromise(actionName, data, transfers) {
        const callbackId = this.callbackId++;
        const capability = Promise.withResolvers();
        this.callbackCapabilities[callbackId] = capability;
        try {
            this.comObj.postMessage({
                sourceName: this.sourceName,
                targetName: this.targetName,
                action: actionName,
                callbackId: callbackId,
                data: data
            }, transfers);
        } catch (ex) {
            capability.reject(ex);
        }
        return capability.promise;
    }
    sendWithStream(actionName, data, queueingStrategy, transfers) {
        const streamId = this.streamId++, sourceName = this.sourceName, targetName = this.targetName, comObj = this.comObj;
        return new ReadableStream({
            start: (controller)=>{
                const startCapability = Promise.withResolvers();
                this.streamControllers[streamId] = {
                    controller: controller,
                    startCall: startCapability,
                    pullCall: null,
                    cancelCall: null,
                    isClosed: false
                };
                comObj.postMessage({
                    sourceName: sourceName,
                    targetName: targetName,
                    action: actionName,
                    streamId: streamId,
                    data: data,
                    desiredSize: controller.desiredSize
                }, transfers);
                return startCapability.promise;
            },
            pull: (controller)=>{
                const pullCapability = Promise.withResolvers();
                this.streamControllers[streamId].pullCall = pullCapability;
                comObj.postMessage({
                    sourceName: sourceName,
                    targetName: targetName,
                    stream: $b3a01b20dd2ade98$var$StreamKind.PULL,
                    streamId: streamId,
                    desiredSize: controller.desiredSize
                });
                return pullCapability.promise;
            },
            cancel: (reason)=>{
                $b3a01b20dd2ade98$var$assert(reason instanceof Error, "cancel must have a valid reason");
                const cancelCapability = Promise.withResolvers();
                this.streamControllers[streamId].cancelCall = cancelCapability;
                this.streamControllers[streamId].isClosed = true;
                comObj.postMessage({
                    sourceName: sourceName,
                    targetName: targetName,
                    stream: $b3a01b20dd2ade98$var$StreamKind.CANCEL,
                    streamId: streamId,
                    reason: $b3a01b20dd2ade98$var$wrapReason(reason)
                });
                return cancelCapability.promise;
            }
        }, queueingStrategy);
    }
    #createStreamSink(data) {
        const streamId = data.streamId, sourceName = this.sourceName, targetName = data.sourceName, comObj = this.comObj;
        const self = this, action = this.actionHandler[data.action];
        const streamSink = {
            enqueue (chunk, size = 1, transfers) {
                if (this.isCancelled) return;
                const lastDesiredSize = this.desiredSize;
                this.desiredSize -= size;
                if (lastDesiredSize > 0 && this.desiredSize <= 0) {
                    this.sinkCapability = Promise.withResolvers();
                    this.ready = this.sinkCapability.promise;
                }
                comObj.postMessage({
                    sourceName: sourceName,
                    targetName: targetName,
                    stream: $b3a01b20dd2ade98$var$StreamKind.ENQUEUE,
                    streamId: streamId,
                    chunk: chunk
                }, transfers);
            },
            close () {
                if (this.isCancelled) return;
                this.isCancelled = true;
                comObj.postMessage({
                    sourceName: sourceName,
                    targetName: targetName,
                    stream: $b3a01b20dd2ade98$var$StreamKind.CLOSE,
                    streamId: streamId
                });
                delete self.streamSinks[streamId];
            },
            error (reason) {
                $b3a01b20dd2ade98$var$assert(reason instanceof Error, "error must have a valid reason");
                if (this.isCancelled) return;
                this.isCancelled = true;
                comObj.postMessage({
                    sourceName: sourceName,
                    targetName: targetName,
                    stream: $b3a01b20dd2ade98$var$StreamKind.ERROR,
                    streamId: streamId,
                    reason: $b3a01b20dd2ade98$var$wrapReason(reason)
                });
            },
            sinkCapability: Promise.withResolvers(),
            onPull: null,
            onCancel: null,
            isCancelled: false,
            desiredSize: data.desiredSize,
            ready: null
        };
        streamSink.sinkCapability.resolve();
        streamSink.ready = streamSink.sinkCapability.promise;
        this.streamSinks[streamId] = streamSink;
        Promise.try(action, data.data, streamSink).then(function() {
            comObj.postMessage({
                sourceName: sourceName,
                targetName: targetName,
                stream: $b3a01b20dd2ade98$var$StreamKind.START_COMPLETE,
                streamId: streamId,
                success: true
            });
        }, function(reason) {
            comObj.postMessage({
                sourceName: sourceName,
                targetName: targetName,
                stream: $b3a01b20dd2ade98$var$StreamKind.START_COMPLETE,
                streamId: streamId,
                reason: $b3a01b20dd2ade98$var$wrapReason(reason)
            });
        });
    }
    #processStreamMessage(data) {
        const streamId = data.streamId, sourceName = this.sourceName, targetName = data.sourceName, comObj = this.comObj;
        const streamController = this.streamControllers[streamId], streamSink = this.streamSinks[streamId];
        switch(data.stream){
            case $b3a01b20dd2ade98$var$StreamKind.START_COMPLETE:
                if (data.success) streamController.startCall.resolve();
                else streamController.startCall.reject($b3a01b20dd2ade98$var$wrapReason(data.reason));
                break;
            case $b3a01b20dd2ade98$var$StreamKind.PULL_COMPLETE:
                if (data.success) streamController.pullCall.resolve();
                else streamController.pullCall.reject($b3a01b20dd2ade98$var$wrapReason(data.reason));
                break;
            case $b3a01b20dd2ade98$var$StreamKind.PULL:
                if (!streamSink) {
                    comObj.postMessage({
                        sourceName: sourceName,
                        targetName: targetName,
                        stream: $b3a01b20dd2ade98$var$StreamKind.PULL_COMPLETE,
                        streamId: streamId,
                        success: true
                    });
                    break;
                }
                if (streamSink.desiredSize <= 0 && data.desiredSize > 0) streamSink.sinkCapability.resolve();
                streamSink.desiredSize = data.desiredSize;
                Promise.try(streamSink.onPull || $b3a01b20dd2ade98$var$onFn).then(function() {
                    comObj.postMessage({
                        sourceName: sourceName,
                        targetName: targetName,
                        stream: $b3a01b20dd2ade98$var$StreamKind.PULL_COMPLETE,
                        streamId: streamId,
                        success: true
                    });
                }, function(reason) {
                    comObj.postMessage({
                        sourceName: sourceName,
                        targetName: targetName,
                        stream: $b3a01b20dd2ade98$var$StreamKind.PULL_COMPLETE,
                        streamId: streamId,
                        reason: $b3a01b20dd2ade98$var$wrapReason(reason)
                    });
                });
                break;
            case $b3a01b20dd2ade98$var$StreamKind.ENQUEUE:
                $b3a01b20dd2ade98$var$assert(streamController, "enqueue should have stream controller");
                if (streamController.isClosed) break;
                streamController.controller.enqueue(data.chunk);
                break;
            case $b3a01b20dd2ade98$var$StreamKind.CLOSE:
                $b3a01b20dd2ade98$var$assert(streamController, "close should have stream controller");
                if (streamController.isClosed) break;
                streamController.isClosed = true;
                streamController.controller.close();
                this.#deleteStreamController(streamController, streamId);
                break;
            case $b3a01b20dd2ade98$var$StreamKind.ERROR:
                $b3a01b20dd2ade98$var$assert(streamController, "error should have stream controller");
                streamController.controller.error($b3a01b20dd2ade98$var$wrapReason(data.reason));
                this.#deleteStreamController(streamController, streamId);
                break;
            case $b3a01b20dd2ade98$var$StreamKind.CANCEL_COMPLETE:
                if (data.success) streamController.cancelCall.resolve();
                else streamController.cancelCall.reject($b3a01b20dd2ade98$var$wrapReason(data.reason));
                this.#deleteStreamController(streamController, streamId);
                break;
            case $b3a01b20dd2ade98$var$StreamKind.CANCEL:
                if (!streamSink) break;
                const dataReason = $b3a01b20dd2ade98$var$wrapReason(data.reason);
                Promise.try(streamSink.onCancel || $b3a01b20dd2ade98$var$onFn, dataReason).then(function() {
                    comObj.postMessage({
                        sourceName: sourceName,
                        targetName: targetName,
                        stream: $b3a01b20dd2ade98$var$StreamKind.CANCEL_COMPLETE,
                        streamId: streamId,
                        success: true
                    });
                }, function(reason) {
                    comObj.postMessage({
                        sourceName: sourceName,
                        targetName: targetName,
                        stream: $b3a01b20dd2ade98$var$StreamKind.CANCEL_COMPLETE,
                        streamId: streamId,
                        reason: $b3a01b20dd2ade98$var$wrapReason(reason)
                    });
                });
                streamSink.sinkCapability.reject(dataReason);
                streamSink.isCancelled = true;
                delete this.streamSinks[streamId];
                break;
            default:
                throw new Error("Unexpected stream case");
        }
    }
    async #deleteStreamController(streamController, streamId) {
        await Promise.allSettled([
            streamController.startCall?.promise,
            streamController.pullCall?.promise,
            streamController.cancelCall?.promise
        ]);
        delete this.streamControllers[streamId];
    }
    destroy() {
        this.#messageAC?.abort();
        this.#messageAC = null;
    }
}
class $b3a01b20dd2ade98$var$BaseBinaryDataFactory {
    #errorStr = Object.freeze({
        cMapUrl: "CMap",
        standardFontDataUrl: "font",
        wasmUrl: "wasm"
    });
    constructor({ cMapUrl: cMapUrl = null, standardFontDataUrl: standardFontDataUrl = null, wasmUrl: wasmUrl = null }){
        this.cMapUrl = cMapUrl;
        this.standardFontDataUrl = standardFontDataUrl;
        this.wasmUrl = wasmUrl;
    }
    async fetch({ kind: kind, filename: filename }) {
        switch(kind){
            case "cMapUrl":
            case "standardFontDataUrl":
            case "wasmUrl":
                break;
            default:
                $b3a01b20dd2ade98$var$unreachable(`Not implemented: ${kind}`);
        }
        const baseUrl = this[kind];
        if (!baseUrl) throw new Error(`Ensure that the \`${kind}\` API parameter is provided.`);
        const url = `${baseUrl}${filename}`;
        return this._fetch(url, kind).catch((reason)=>{
            throw new Error(`Unable to load ${this.#errorStr[kind]} data at: ${url}`);
        });
    }
    async _fetch(url, kind) {
        $b3a01b20dd2ade98$var$unreachable("Abstract method `_fetch` called.");
    }
}
class $b3a01b20dd2ade98$var$DOMBinaryDataFactory extends $b3a01b20dd2ade98$var$BaseBinaryDataFactory {
    async _fetch(url, kind) {
        const type = kind === "cMapUrl" && !url.endsWith(".bcmap") ? "text" : "bytes";
        const data = await $b3a01b20dd2ade98$export$8134c072fddab6a5(url, type);
        return data instanceof Uint8Array ? data : $b3a01b20dd2ade98$var$stringToBytes(data);
    }
}
class $b3a01b20dd2ade98$var$BaseCanvasFactory {
    #enableHWA = false;
    constructor({ enableHWA: enableHWA = false }){
        this.#enableHWA = enableHWA;
    }
    create(width, height) {
        if (width <= 0 || height <= 0) throw new Error("Invalid canvas size");
        const canvas = this._createCanvas(width, height);
        return {
            canvas: canvas,
            context: canvas.getContext("2d", {
                willReadFrequently: !this.#enableHWA
            })
        };
    }
    reset({ canvas: canvas }, width, height) {
        if (!canvas) throw new Error("Canvas is not specified");
        if (width <= 0 || height <= 0) throw new Error("Invalid canvas size");
        canvas.width = width;
        canvas.height = height;
    }
    destroy(canvasAndContext) {
        const { canvas: canvas } = canvasAndContext;
        if (!canvas) throw new Error("Canvas is not specified");
        canvas.width = canvas.height = 0;
        canvasAndContext.canvas = null;
        canvasAndContext.context = null;
    }
    _createCanvas(width, height) {
        $b3a01b20dd2ade98$var$unreachable("Abstract method `_createCanvas` called.");
    }
}
class $b3a01b20dd2ade98$var$DOMCanvasFactory extends $b3a01b20dd2ade98$var$BaseCanvasFactory {
    constructor({ ownerDocument: ownerDocument = globalThis.document, enableHWA: enableHWA = false }){
        super({
            enableHWA: enableHWA
        });
        this._document = ownerDocument;
    }
    _createCanvas(width, height) {
        const canvas = this._document.createElement("canvas");
        canvas.width = width;
        canvas.height = height;
        return canvas;
    }
}
class $b3a01b20dd2ade98$var$BaseFilterFactory {
    addFilter(maps) {
        return "none";
    }
    addHCMFilter(fgColor, bgColor) {
        return "none";
    }
    addAlphaFilter(map) {
        return "none";
    }
    addLuminosityFilter(map) {
        return "none";
    }
    addHighlightHCMFilter(filterName, fgColor, bgColor, newFgColor, newBgColor) {
        return "none";
    }
    destroy(keepHCM = false) {}
}
class $b3a01b20dd2ade98$var$DOMFilterFactory extends $b3a01b20dd2ade98$var$BaseFilterFactory {
    #baseUrl;
    #_cache;
    #_defs;
    #docId;
    #document;
    #_hcmCache;
    #id = 0;
    constructor({ docId: docId, ownerDocument: ownerDocument = globalThis.document }){
        super();
        this.#docId = docId;
        this.#document = ownerDocument;
    }
    get #cache() {
        return this.#_cache ||= new Map();
    }
    get #hcmCache() {
        return this.#_hcmCache ||= new Map();
    }
    get #defs() {
        if (!this.#_defs) {
            const div = this.#document.createElement("div");
            const { style: style } = div;
            style.visibility = "hidden";
            style.contain = "strict";
            style.width = style.height = 0;
            style.position = "absolute";
            style.top = style.left = 0;
            style.zIndex = -1;
            const svg = this.#document.createElementNS($b3a01b20dd2ade98$var$SVG_NS, "svg");
            svg.setAttribute("width", 0);
            svg.setAttribute("height", 0);
            this.#_defs = this.#document.createElementNS($b3a01b20dd2ade98$var$SVG_NS, "defs");
            div.append(svg);
            svg.append(this.#_defs);
            this.#document.body.append(div);
        }
        return this.#_defs;
    }
    #createTables(maps) {
        if (maps.length === 1) {
            const mapR = maps[0];
            const buffer = new Array(256);
            for(let i = 0; i < 256; i++)buffer[i] = mapR[i] / 255;
            const table = buffer.join(",");
            return [
                table,
                table,
                table
            ];
        }
        const [mapR, mapG, mapB] = maps;
        const bufferR = new Array(256);
        const bufferG = new Array(256);
        const bufferB = new Array(256);
        for(let i = 0; i < 256; i++){
            bufferR[i] = mapR[i] / 255;
            bufferG[i] = mapG[i] / 255;
            bufferB[i] = mapB[i] / 255;
        }
        return [
            bufferR.join(","),
            bufferG.join(","),
            bufferB.join(",")
        ];
    }
    #createUrl(id) {
        if (this.#baseUrl === undefined) {
            this.#baseUrl = "";
            const url = this.#document.URL;
            if (url !== this.#document.baseURI) {
                if ($b3a01b20dd2ade98$export$f67aae4532d8295b(url)) $b3a01b20dd2ade98$var$warn('#createUrl: ignore "data:"-URL for performance reasons.');
                else this.#baseUrl = $b3a01b20dd2ade98$export$e1e4297c21ab9d13(url, "");
            }
        }
        return `url(${this.#baseUrl}#${id})`;
    }
    addFilter(maps) {
        if (!maps) return "none";
        let value = this.#cache.get(maps);
        if (value) return value;
        const [tableR, tableG, tableB] = this.#createTables(maps);
        const key = maps.length === 1 ? tableR : `${tableR}${tableG}${tableB}`;
        value = this.#cache.get(key);
        if (value) {
            this.#cache.set(maps, value);
            return value;
        }
        const id = `g_${this.#docId}_transfer_map_${this.#id++}`;
        const url = this.#createUrl(id);
        this.#cache.set(maps, url);
        this.#cache.set(key, url);
        const filter = this.#createFilter(id);
        this.#addTransferMapConversion(tableR, tableG, tableB, filter);
        return url;
    }
    addHCMFilter(fgColor, bgColor) {
        const key = `${fgColor}-${bgColor}`;
        const filterName = "base";
        let info = this.#hcmCache.get(filterName);
        if (info?.key === key) return info.url;
        if (info) {
            info.filter?.remove();
            info.key = key;
            info.url = "none";
            info.filter = null;
        } else {
            info = {
                key: key,
                url: "none",
                filter: null
            };
            this.#hcmCache.set(filterName, info);
        }
        if (!fgColor || !bgColor) return info.url;
        const fgRGB = this.#getRGB(fgColor);
        fgColor = $b3a01b20dd2ade98$export$f8f26dd395d7e1bd.makeHexColor(...fgRGB);
        const bgRGB = this.#getRGB(bgColor);
        bgColor = $b3a01b20dd2ade98$export$f8f26dd395d7e1bd.makeHexColor(...bgRGB);
        this.#defs.style.color = "";
        if (fgColor === "#000000" && bgColor === "#ffffff" || fgColor === bgColor) return info.url;
        const map = new Array(256);
        for(let i = 0; i <= 255; i++){
            const x = i / 255;
            map[i] = x <= 0.03928 ? x / 12.92 : ((x + 0.055) / 1.055) ** 2.4;
        }
        const table = map.join(",");
        const id = `g_${this.#docId}_hcm_filter`;
        const filter = info.filter = this.#createFilter(id);
        this.#addTransferMapConversion(table, table, table, filter);
        this.#addGrayConversion(filter);
        const getSteps = (c, n)=>{
            const start = fgRGB[c] / 255;
            const end = bgRGB[c] / 255;
            const arr = new Array(n + 1);
            for(let i = 0; i <= n; i++)arr[i] = start + i / n * (end - start);
            return arr.join(",");
        };
        this.#addTransferMapConversion(getSteps(0, 5), getSteps(1, 5), getSteps(2, 5), filter);
        info.url = this.#createUrl(id);
        return info.url;
    }
    addAlphaFilter(map) {
        let value = this.#cache.get(map);
        if (value) return value;
        const [tableA] = this.#createTables([
            map
        ]);
        const key = `alpha_${tableA}`;
        value = this.#cache.get(key);
        if (value) {
            this.#cache.set(map, value);
            return value;
        }
        const id = `g_${this.#docId}_alpha_map_${this.#id++}`;
        const url = this.#createUrl(id);
        this.#cache.set(map, url);
        this.#cache.set(key, url);
        const filter = this.#createFilter(id);
        this.#addTransferMapAlphaConversion(tableA, filter);
        return url;
    }
    addLuminosityFilter(map) {
        let value = this.#cache.get(map || "luminosity");
        if (value) return value;
        let tableA, key;
        if (map) {
            [tableA] = this.#createTables([
                map
            ]);
            key = `luminosity_${tableA}`;
        } else key = "luminosity";
        value = this.#cache.get(key);
        if (value) {
            this.#cache.set(map, value);
            return value;
        }
        const id = `g_${this.#docId}_luminosity_map_${this.#id++}`;
        const url = this.#createUrl(id);
        this.#cache.set(map, url);
        this.#cache.set(key, url);
        const filter = this.#createFilter(id);
        this.#addLuminosityConversion(filter);
        if (map) this.#addTransferMapAlphaConversion(tableA, filter);
        return url;
    }
    addHighlightHCMFilter(filterName, fgColor, bgColor, newFgColor, newBgColor) {
        const key = `${fgColor}-${bgColor}-${newFgColor}-${newBgColor}`;
        let info = this.#hcmCache.get(filterName);
        if (info?.key === key) return info.url;
        if (info) {
            info.filter?.remove();
            info.key = key;
            info.url = "none";
            info.filter = null;
        } else {
            info = {
                key: key,
                url: "none",
                filter: null
            };
            this.#hcmCache.set(filterName, info);
        }
        if (!fgColor || !bgColor) return info.url;
        const [fgRGB, bgRGB] = [
            fgColor,
            bgColor
        ].map(this.#getRGB.bind(this));
        let fgGray = Math.round(0.2126 * fgRGB[0] + 0.7152 * fgRGB[1] + 0.0722 * fgRGB[2]);
        let bgGray = Math.round(0.2126 * bgRGB[0] + 0.7152 * bgRGB[1] + 0.0722 * bgRGB[2]);
        let [newFgRGB, newBgRGB] = [
            newFgColor,
            newBgColor
        ].map(this.#getRGB.bind(this));
        if (bgGray < fgGray) [fgGray, bgGray, newFgRGB, newBgRGB] = [
            bgGray,
            fgGray,
            newBgRGB,
            newFgRGB
        ];
        this.#defs.style.color = "";
        const getSteps = (fg, bg, n)=>{
            const arr = new Array(256);
            const step = (bgGray - fgGray) / n;
            const newStart = fg / 255;
            const newStep = (bg - fg) / (255 * n);
            let prev = 0;
            for(let i = 0; i <= n; i++){
                const k = Math.round(fgGray + i * step);
                const value = newStart + i * newStep;
                for(let j = prev; j <= k; j++)arr[j] = value;
                prev = k + 1;
            }
            for(let i = prev; i < 256; i++)arr[i] = arr[prev - 1];
            return arr.join(",");
        };
        const id = `g_${this.#docId}_hcm_${filterName}_filter`;
        const filter = info.filter = this.#createFilter(id);
        this.#addGrayConversion(filter);
        this.#addTransferMapConversion(getSteps(newFgRGB[0], newBgRGB[0], 5), getSteps(newFgRGB[1], newBgRGB[1], 5), getSteps(newFgRGB[2], newBgRGB[2], 5), filter);
        info.url = this.#createUrl(id);
        return info.url;
    }
    destroy(keepHCM = false) {
        if (keepHCM && this.#_hcmCache?.size) return;
        this.#_defs?.parentNode.parentNode.remove();
        this.#_defs = null;
        this.#_cache?.clear();
        this.#_cache = null;
        this.#_hcmCache?.clear();
        this.#_hcmCache = null;
        this.#id = 0;
    }
    #addLuminosityConversion(filter) {
        const feColorMatrix = this.#document.createElementNS($b3a01b20dd2ade98$var$SVG_NS, "feColorMatrix");
        feColorMatrix.setAttribute("type", "matrix");
        feColorMatrix.setAttribute("values", "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0.59 0.11 0 0");
        filter.append(feColorMatrix);
    }
    #addGrayConversion(filter) {
        const feColorMatrix = this.#document.createElementNS($b3a01b20dd2ade98$var$SVG_NS, "feColorMatrix");
        feColorMatrix.setAttribute("type", "matrix");
        feColorMatrix.setAttribute("values", "0.2126 0.7152 0.0722 0 0 0.2126 0.7152 0.0722 0 0 0.2126 0.7152 0.0722 0 0 0 0 0 1 0");
        filter.append(feColorMatrix);
    }
    #createFilter(id) {
        const filter = this.#document.createElementNS($b3a01b20dd2ade98$var$SVG_NS, "filter");
        filter.setAttribute("color-interpolation-filters", "sRGB");
        filter.setAttribute("id", id);
        this.#defs.append(filter);
        return filter;
    }
    #appendFeFunc(feComponentTransfer, func, table) {
        const feFunc = this.#document.createElementNS($b3a01b20dd2ade98$var$SVG_NS, func);
        feFunc.setAttribute("type", "discrete");
        feFunc.setAttribute("tableValues", table);
        feComponentTransfer.append(feFunc);
    }
    #addTransferMapConversion(rTable, gTable, bTable, filter) {
        const feComponentTransfer = this.#document.createElementNS($b3a01b20dd2ade98$var$SVG_NS, "feComponentTransfer");
        filter.append(feComponentTransfer);
        this.#appendFeFunc(feComponentTransfer, "feFuncR", rTable);
        this.#appendFeFunc(feComponentTransfer, "feFuncG", gTable);
        this.#appendFeFunc(feComponentTransfer, "feFuncB", bTable);
    }
    #addTransferMapAlphaConversion(aTable, filter) {
        const feComponentTransfer = this.#document.createElementNS($b3a01b20dd2ade98$var$SVG_NS, "feComponentTransfer");
        filter.append(feComponentTransfer);
        this.#appendFeFunc(feComponentTransfer, "feFuncA", aTable);
    }
    #getRGB(color) {
        this.#defs.style.color = color;
        return $b3a01b20dd2ade98$export$2a2e9b507863ddda(getComputedStyle(this.#defs).getPropertyValue("color"));
    }
}
if ($b3a01b20dd2ade98$var$isNodeJS) $b3a01b20dd2ade98$var$warn("Please use the `legacy` build in Node.js environments.");
async function $b3a01b20dd2ade98$var$node_utils_fetchData(url) {
    const fs = $4TZ3D.getBuiltinModule("fs");
    const data = await fs.promises.readFile(url);
    return new Uint8Array(data);
}
class $b3a01b20dd2ade98$var$NodeFilterFactory extends $b3a01b20dd2ade98$var$BaseFilterFactory {
}
class $b3a01b20dd2ade98$var$NodeCanvasFactory extends $b3a01b20dd2ade98$var$BaseCanvasFactory {
    _createCanvas(width, height) {
        const require1 = $4TZ3D.getBuiltinModule("module").createRequire("file:///node_modules/pdfjs-dist/build/pdf.mjs");
        const canvas = require1("@napi-rs/canvas");
        return canvas.createCanvas(width, height);
    }
}
class $b3a01b20dd2ade98$var$NodeBinaryDataFactory extends $b3a01b20dd2ade98$var$BaseBinaryDataFactory {
    async _fetch(url, kind) {
        return $b3a01b20dd2ade98$var$node_utils_fetchData(url);
    }
}
const $b3a01b20dd2ade98$var$WGSL = `
struct Uniforms {
  offsetX      : f32,
  offsetY      : f32,
  scaleX       : f32,
  scaleY       : f32,
  paddedWidth  : f32,
  paddedHeight : f32,
  borderSize   : f32,
  _pad         : f32,
};

@group(0) @binding(0) var<uniform> u : Uniforms;

struct VertexInput {
  @location(0) position : vec2<f32>,
  @location(1) color    : vec4<f32>,
};

struct VertexOutput {
  @builtin(position) position : vec4<f32>,
  @location(0)       color    : vec3<f32>,
};

@vertex
fn vs_main(in : VertexInput) -> VertexOutput {
  var out : VertexOutput;
  let cx = (in.position.x + u.offsetX) * u.scaleX;
  let cy = (in.position.y + u.offsetY) * u.scaleY;
  out.position = vec4<f32>(
    ((cx + u.borderSize) / u.paddedWidth) * 2.0 - 1.0,
    1.0 - ((cy + u.borderSize) / u.paddedHeight) * 2.0,
    0.0,
    1.0
  );
  out.color = in.color.rgb;
  return out;
}

@fragment
fn fs_main(in : VertexOutput) -> @location(0) vec4<f32> {
  return vec4<f32>(in.color, 1.0);
}
`;
class $b3a01b20dd2ade98$var$WebGPUMesh {
    #initPromise = null;
    #device = null;
    #pipeline = null;
    #preferredFormat = null;
    async #initGPU() {
        if (!globalThis.navigator?.gpu) return false;
        try {
            const adapter = await navigator.gpu.requestAdapter();
            if (!adapter) return false;
            this.#preferredFormat = navigator.gpu.getPreferredCanvasFormat();
            const device = this.#device = await adapter.requestDevice();
            const shaderModule = device.createShaderModule({
                code: $b3a01b20dd2ade98$var$WGSL
            });
            this.#pipeline = device.createRenderPipeline({
                layout: "auto",
                vertex: {
                    module: shaderModule,
                    entryPoint: "vs_main",
                    buffers: [
                        {
                            arrayStride: 8,
                            attributes: [
                                {
                                    shaderLocation: 0,
                                    offset: 0,
                                    format: "float32x2"
                                }
                            ]
                        },
                        {
                            arrayStride: 4,
                            attributes: [
                                {
                                    shaderLocation: 1,
                                    offset: 0,
                                    format: "unorm8x4"
                                }
                            ]
                        }
                    ]
                },
                fragment: {
                    module: shaderModule,
                    entryPoint: "fs_main",
                    targets: [
                        {
                            format: this.#preferredFormat
                        }
                    ]
                },
                primitive: {
                    topology: "triangle-list"
                }
            });
            return true;
        } catch  {
            return false;
        }
    }
    init() {
        if (this.#initPromise === null) this.#initPromise = this.#initGPU();
    }
    get isReady() {
        return this.#device !== null;
    }
    #buildVertexStreams(figures, context) {
        const { coords: coords, colors: colors } = context;
        let vertexCount = 0;
        for (const figure of figures){
            const ps = figure.coords;
            if (figure.type === $b3a01b20dd2ade98$var$MeshFigureType.TRIANGLES) vertexCount += ps.length;
            else if (figure.type === $b3a01b20dd2ade98$var$MeshFigureType.LATTICE) {
                const vpr = figure.verticesPerRow;
                vertexCount += (Math.floor(ps.length / vpr) - 1) * (vpr - 1) * 6;
            }
        }
        const posData = new Float32Array(vertexCount * 2);
        const colData = new Uint8Array(vertexCount * 4);
        let pOff = 0, cOff = 0;
        const addVertex = (pi, ci)=>{
            posData[pOff++] = coords[pi * 2];
            posData[pOff++] = coords[pi * 2 + 1];
            colData[cOff++] = colors[ci * 4];
            colData[cOff++] = colors[ci * 4 + 1];
            colData[cOff++] = colors[ci * 4 + 2];
            cOff++;
        };
        for (const figure of figures){
            const ps = figure.coords;
            const cs = figure.colors;
            if (figure.type === $b3a01b20dd2ade98$var$MeshFigureType.TRIANGLES) for(let i = 0, ii = ps.length; i < ii; i += 3){
                addVertex(ps[i], cs[i]);
                addVertex(ps[i + 1], cs[i + 1]);
                addVertex(ps[i + 2], cs[i + 2]);
            }
            else if (figure.type === $b3a01b20dd2ade98$var$MeshFigureType.LATTICE) {
                const vpr = figure.verticesPerRow;
                const rows = Math.floor(ps.length / vpr) - 1;
                const cols = vpr - 1;
                for(let i = 0; i < rows; i++){
                    let q = i * vpr;
                    for(let j = 0; j < cols; j++, q++){
                        addVertex(ps[q], cs[q]);
                        addVertex(ps[q + 1], cs[q + 1]);
                        addVertex(ps[q + vpr], cs[q + vpr]);
                        addVertex(ps[q + vpr + 1], cs[q + vpr + 1]);
                        addVertex(ps[q + 1], cs[q + 1]);
                        addVertex(ps[q + vpr], cs[q + vpr]);
                    }
                }
            }
        }
        return {
            posData: posData,
            colData: colData,
            vertexCount: vertexCount
        };
    }
    draw(figures, context, backgroundColor, paddedWidth, paddedHeight, borderSize) {
        const device = this.#device;
        const { offsetX: offsetX, offsetY: offsetY, scaleX: scaleX, scaleY: scaleY } = context;
        const { posData: posData, colData: colData, vertexCount: vertexCount } = this.#buildVertexStreams(figures, context);
        const posBuffer = device.createBuffer({
            size: Math.max(posData.byteLength, 4),
            usage: GPUBufferUsage.VERTEX | GPUBufferUsage.COPY_DST
        });
        if (posData.byteLength > 0) device.queue.writeBuffer(posBuffer, 0, posData);
        const colBuffer = device.createBuffer({
            size: Math.max(colData.byteLength, 4),
            usage: GPUBufferUsage.VERTEX | GPUBufferUsage.COPY_DST
        });
        if (colData.byteLength > 0) device.queue.writeBuffer(colBuffer, 0, colData);
        const uniformBuffer = device.createBuffer({
            size: 32,
            usage: GPUBufferUsage.UNIFORM | GPUBufferUsage.COPY_DST
        });
        device.queue.writeBuffer(uniformBuffer, 0, new Float32Array([
            offsetX,
            offsetY,
            scaleX,
            scaleY,
            paddedWidth,
            paddedHeight,
            borderSize,
            0
        ]));
        const bindGroup = device.createBindGroup({
            layout: this.#pipeline.getBindGroupLayout(0),
            entries: [
                {
                    binding: 0,
                    resource: {
                        buffer: uniformBuffer
                    }
                }
            ]
        });
        const offscreen = new OffscreenCanvas(paddedWidth, paddedHeight);
        const gpuCtx = offscreen.getContext("webgpu");
        gpuCtx.configure({
            device: device,
            format: this.#preferredFormat,
            alphaMode: backgroundColor ? "opaque" : "premultiplied"
        });
        const clearValue = backgroundColor ? {
            r: backgroundColor[0] / 255,
            g: backgroundColor[1] / 255,
            b: backgroundColor[2] / 255,
            a: 1
        } : {
            r: 0,
            g: 0,
            b: 0,
            a: 0
        };
        const commandEncoder = device.createCommandEncoder();
        const renderPass = commandEncoder.beginRenderPass({
            colorAttachments: [
                {
                    view: gpuCtx.getCurrentTexture().createView(),
                    clearValue: clearValue,
                    loadOp: "clear",
                    storeOp: "store"
                }
            ]
        });
        if (vertexCount > 0) {
            renderPass.setPipeline(this.#pipeline);
            renderPass.setBindGroup(0, bindGroup);
            renderPass.setVertexBuffer(0, posBuffer);
            renderPass.setVertexBuffer(1, colBuffer);
            renderPass.draw(vertexCount);
        }
        renderPass.end();
        device.queue.submit([
            commandEncoder.finish()
        ]);
        posBuffer.destroy();
        colBuffer.destroy();
        uniformBuffer.destroy();
        return offscreen.transferToImageBitmap();
    }
}
const $b3a01b20dd2ade98$var$_webGPUMesh = new $b3a01b20dd2ade98$var$WebGPUMesh();
function $b3a01b20dd2ade98$var$initWebGPUMesh() {
    $b3a01b20dd2ade98$var$_webGPUMesh.init();
}
function $b3a01b20dd2ade98$var$isWebGPUMeshReady() {
    return $b3a01b20dd2ade98$var$_webGPUMesh.isReady;
}
function $b3a01b20dd2ade98$var$drawMeshWithGPU(figures, context, backgroundColor, paddedWidth, paddedHeight, borderSize) {
    return $b3a01b20dd2ade98$var$_webGPUMesh.draw(figures, context, backgroundColor, paddedWidth, paddedHeight, borderSize);
}
const $b3a01b20dd2ade98$var$PathType = {
    FILL: "Fill",
    STROKE: "Stroke",
    SHADING: "Shading"
};
function $b3a01b20dd2ade98$var$applyBoundingBox(ctx, bbox) {
    if (!bbox) return;
    const width = bbox[2] - bbox[0];
    const height = bbox[3] - bbox[1];
    const region = new Path2D();
    region.rect(bbox[0], bbox[1], width, height);
    ctx.clip(region);
}
class $b3a01b20dd2ade98$var$BaseShadingPattern {
    isModifyingCurrentTransform() {
        return false;
    }
    getPattern() {
        $b3a01b20dd2ade98$var$unreachable("Abstract method `getPattern` called.");
    }
}
class $b3a01b20dd2ade98$var$RadialAxialShadingPattern extends $b3a01b20dd2ade98$var$BaseShadingPattern {
    constructor(IR){
        super();
        this._type = IR[1];
        this._bbox = IR[2];
        this._colorStops = IR[3];
        this._p0 = IR[4];
        this._p1 = IR[5];
        this._r0 = IR[6];
        this._r1 = IR[7];
        this.matrix = null;
    }
    isOriginBased() {
        return this._p0[0] === 0 && this._p0[1] === 0 && (!this.isRadial() || this._p1[0] === 0 && this._p1[1] === 0);
    }
    isRadial() {
        return this._type === "radial";
    }
    _isCircleCenterOutside() {
        if (!this.isRadial() || this._r0 > this._r1) return false;
        const dist = Math.hypot(this._p0[0] - this._p1[0], this._p0[1] - this._p1[1]);
        return dist > this._r1;
    }
    _createGradient(ctx, transform = null) {
        let grad;
        let firstPoint = this._p0;
        let secondPoint = this._p1;
        if (transform) {
            firstPoint = firstPoint.slice();
            secondPoint = secondPoint.slice();
            $b3a01b20dd2ade98$export$f8f26dd395d7e1bd.applyTransform(firstPoint, transform);
            $b3a01b20dd2ade98$export$f8f26dd395d7e1bd.applyTransform(secondPoint, transform);
        }
        if (this._type === "axial") grad = ctx.createLinearGradient(firstPoint[0], firstPoint[1], secondPoint[0], secondPoint[1]);
        else if (this._type === "radial") {
            let r0 = this._r0;
            let r1 = this._r1;
            if (transform) {
                const scale = new Float32Array(2);
                $b3a01b20dd2ade98$export$f8f26dd395d7e1bd.singularValueDecompose2dScale(transform, scale);
                r0 *= scale[0];
                r1 *= scale[0];
            }
            grad = ctx.createRadialGradient(firstPoint[0], firstPoint[1], r0, secondPoint[0], secondPoint[1], r1);
        }
        for (const colorStop of this._colorStops)grad.addColorStop(colorStop[0], colorStop[1]);
        return grad;
    }
    _createReversedGradient(ctx, transform = null) {
        let firstPoint = this._p1;
        let secondPoint = this._p0;
        if (transform) {
            firstPoint = firstPoint.slice();
            secondPoint = secondPoint.slice();
            $b3a01b20dd2ade98$export$f8f26dd395d7e1bd.applyTransform(firstPoint, transform);
            $b3a01b20dd2ade98$export$f8f26dd395d7e1bd.applyTransform(secondPoint, transform);
        }
        let r0 = this._r1;
        let r1 = this._r0;
        if (transform) {
            const scale = new Float32Array(2);
            $b3a01b20dd2ade98$export$f8f26dd395d7e1bd.singularValueDecompose2dScale(transform, scale);
            r0 *= scale[0];
            r1 *= scale[0];
        }
        const grad = ctx.createRadialGradient(firstPoint[0], firstPoint[1], r0, secondPoint[0], secondPoint[1], r1);
        const reversedStops = this._colorStops.map(([t, c])=>[
                1 - t,
                c
            ]).reverse();
        for (const [t, c] of reversedStops)grad.addColorStop(t, c);
        return grad;
    }
    getPattern(ctx, owner, inverse, pathType) {
        let pattern;
        if (pathType === $b3a01b20dd2ade98$var$PathType.STROKE || pathType === $b3a01b20dd2ade98$var$PathType.FILL) {
            if (this.isOriginBased()) {
                let transf = $b3a01b20dd2ade98$export$f8f26dd395d7e1bd.transform(inverse, owner.baseTransform);
                if (this.matrix) transf = $b3a01b20dd2ade98$export$f8f26dd395d7e1bd.transform(transf, this.matrix);
                const precision = 1e-3;
                const n1 = Math.hypot(transf[0], transf[1]);
                const n2 = Math.hypot(transf[2], transf[3]);
                const ps = (transf[0] * transf[2] + transf[1] * transf[3]) / (n1 * n2);
                if (Math.abs(ps) < precision) {
                    if (this.isRadial()) {
                        if (Math.abs(n1 - n2) < precision) return this._createGradient(ctx, transf);
                    } else return this._createGradient(ctx, transf);
                }
            }
            const ownerBBox = owner.current.getClippedPathBoundingBox(pathType, $b3a01b20dd2ade98$var$getCurrentTransform(ctx)) || [
                0,
                0,
                0,
                0
            ];
            const width = Math.ceil(ownerBBox[2] - ownerBBox[0]) || 1;
            const height = Math.ceil(ownerBBox[3] - ownerBBox[1]) || 1;
            const tmpCanvas = owner.canvasFactory.create(width, height);
            const tmpCtx = tmpCanvas.context;
            tmpCtx.clearRect(0, 0, tmpCtx.canvas.width, tmpCtx.canvas.height);
            tmpCtx.beginPath();
            tmpCtx.rect(0, 0, tmpCtx.canvas.width, tmpCtx.canvas.height);
            tmpCtx.translate(-ownerBBox[0], -ownerBBox[1]);
            inverse = $b3a01b20dd2ade98$export$f8f26dd395d7e1bd.transform(inverse, [
                1,
                0,
                0,
                1,
                ownerBBox[0],
                ownerBBox[1]
            ]);
            tmpCtx.transform(...owner.baseTransform);
            if (this.matrix) tmpCtx.transform(...this.matrix);
            $b3a01b20dd2ade98$var$applyBoundingBox(tmpCtx, this._bbox);
            if (this._isCircleCenterOutside()) {
                tmpCtx.fillStyle = this._createReversedGradient(tmpCtx);
                tmpCtx.fill();
            }
            tmpCtx.fillStyle = this._createGradient(tmpCtx);
            tmpCtx.fill();
            pattern = ctx.createPattern(tmpCanvas.canvas, "no-repeat");
            owner.canvasFactory.destroy(tmpCanvas);
            const domMatrix = new DOMMatrix(inverse);
            pattern.setTransform(domMatrix);
        } else {
            if (this._isCircleCenterOutside()) {
                ctx.save();
                $b3a01b20dd2ade98$var$applyBoundingBox(ctx, this._bbox);
                ctx.fillStyle = this._createReversedGradient(ctx);
                ctx.fillRect(-10000000000, -10000000000, 2e10, 2e10);
                ctx.restore();
            }
            $b3a01b20dd2ade98$var$applyBoundingBox(ctx, this._bbox);
            pattern = this._createGradient(ctx);
        }
        return pattern;
    }
}
function $b3a01b20dd2ade98$var$drawTriangle(data, context, p1, p2, p3, c1, c2, c3) {
    const coords = context.coords, colors = context.colors;
    const bytes = data.data, rowSize = data.width * 4;
    let tmp;
    if (coords[p1 * 2 + 1] > coords[p2 * 2 + 1]) {
        tmp = p1;
        p1 = p2;
        p2 = tmp;
        tmp = c1;
        c1 = c2;
        c2 = tmp;
    }
    if (coords[p2 * 2 + 1] > coords[p3 * 2 + 1]) {
        tmp = p2;
        p2 = p3;
        p3 = tmp;
        tmp = c2;
        c2 = c3;
        c3 = tmp;
    }
    if (coords[p1 * 2 + 1] > coords[p2 * 2 + 1]) {
        tmp = p1;
        p1 = p2;
        p2 = tmp;
        tmp = c1;
        c1 = c2;
        c2 = tmp;
    }
    const x1 = (coords[p1 * 2] + context.offsetX) * context.scaleX;
    const y1 = (coords[p1 * 2 + 1] + context.offsetY) * context.scaleY;
    const x2 = (coords[p2 * 2] + context.offsetX) * context.scaleX;
    const y2 = (coords[p2 * 2 + 1] + context.offsetY) * context.scaleY;
    const x3 = (coords[p3 * 2] + context.offsetX) * context.scaleX;
    const y3 = (coords[p3 * 2 + 1] + context.offsetY) * context.scaleY;
    if (y1 >= y3) return;
    const c1r = colors[c1 * 4], c1g = colors[c1 * 4 + 1], c1b = colors[c1 * 4 + 2];
    const c2r = colors[c2 * 4], c2g = colors[c2 * 4 + 1], c2b = colors[c2 * 4 + 2];
    const c3r = colors[c3 * 4], c3g = colors[c3 * 4 + 1], c3b = colors[c3 * 4 + 2];
    const minY = Math.round(y1), maxY = Math.round(y3);
    let xa, car, cag, cab;
    let xb, cbr, cbg, cbb;
    for(let y = minY; y <= maxY; y++){
        if (y < y2) {
            const k = y < y1 ? 0 : (y1 - y) / (y1 - y2);
            xa = x1 - (x1 - x2) * k;
            car = c1r - (c1r - c2r) * k;
            cag = c1g - (c1g - c2g) * k;
            cab = c1b - (c1b - c2b) * k;
        } else {
            let k;
            if (y > y3) k = 1;
            else if (y2 === y3) k = 0;
            else k = (y2 - y) / (y2 - y3);
            xa = x2 - (x2 - x3) * k;
            car = c2r - (c2r - c3r) * k;
            cag = c2g - (c2g - c3g) * k;
            cab = c2b - (c2b - c3b) * k;
        }
        let k;
        if (y < y1) k = 0;
        else if (y > y3) k = 1;
        else k = (y1 - y) / (y1 - y3);
        xb = x1 - (x1 - x3) * k;
        cbr = c1r - (c1r - c3r) * k;
        cbg = c1g - (c1g - c3g) * k;
        cbb = c1b - (c1b - c3b) * k;
        const x1_ = Math.round(Math.min(xa, xb));
        const x2_ = Math.round(Math.max(xa, xb));
        let j = rowSize * y + x1_ * 4;
        for(let x = x1_; x <= x2_; x++){
            k = (xa - x) / (xa - xb);
            if (k < 0) k = 0;
            else if (k > 1) k = 1;
            bytes[j++] = car - (car - cbr) * k | 0;
            bytes[j++] = cag - (cag - cbg) * k | 0;
            bytes[j++] = cab - (cab - cbb) * k | 0;
            bytes[j++] = 255;
        }
    }
}
function $b3a01b20dd2ade98$var$drawFigure(data, figure, context) {
    const ps = figure.coords;
    const cs = figure.colors;
    let i, ii;
    switch(figure.type){
        case $b3a01b20dd2ade98$var$MeshFigureType.LATTICE:
            const verticesPerRow = figure.verticesPerRow;
            const rows = Math.floor(ps.length / verticesPerRow) - 1;
            const cols = verticesPerRow - 1;
            for(i = 0; i < rows; i++){
                let q = i * verticesPerRow;
                for(let j = 0; j < cols; j++, q++){
                    $b3a01b20dd2ade98$var$drawTriangle(data, context, ps[q], ps[q + 1], ps[q + verticesPerRow], cs[q], cs[q + 1], cs[q + verticesPerRow]);
                    $b3a01b20dd2ade98$var$drawTriangle(data, context, ps[q + verticesPerRow + 1], ps[q + 1], ps[q + verticesPerRow], cs[q + verticesPerRow + 1], cs[q + 1], cs[q + verticesPerRow]);
                }
            }
            break;
        case $b3a01b20dd2ade98$var$MeshFigureType.TRIANGLES:
            for(i = 0, ii = ps.length; i < ii; i += 3)$b3a01b20dd2ade98$var$drawTriangle(data, context, ps[i], ps[i + 1], ps[i + 2], cs[i], cs[i + 1], cs[i + 2]);
            break;
        default:
            throw new Error("illegal figure");
    }
}
class $b3a01b20dd2ade98$var$MeshShadingPattern extends $b3a01b20dd2ade98$var$BaseShadingPattern {
    constructor(IR){
        super();
        this._coords = IR[2];
        this._colors = IR[3];
        this._figures = IR[4];
        this._bounds = IR[5];
        this._bbox = IR[6];
        this._background = IR[7];
        this.matrix = null;
    }
    _createMeshCanvas(combinedScale, backgroundColor, canvasFactory) {
        const EXPECTED_SCALE = 1.1;
        const MAX_PATTERN_SIZE = 3000;
        const BORDER_SIZE = 2;
        const offsetX = Math.floor(this._bounds[0]);
        const offsetY = Math.floor(this._bounds[1]);
        const boundsWidth = Math.ceil(this._bounds[2]) - offsetX;
        const boundsHeight = Math.ceil(this._bounds[3]) - offsetY;
        const width = Math.min(Math.ceil(Math.abs(boundsWidth * combinedScale[0] * EXPECTED_SCALE)), MAX_PATTERN_SIZE) || 1;
        const height = Math.min(Math.ceil(Math.abs(boundsHeight * combinedScale[1] * EXPECTED_SCALE)), MAX_PATTERN_SIZE) || 1;
        const scaleX = boundsWidth ? boundsWidth / width : 1;
        const scaleY = boundsHeight ? boundsHeight / height : 1;
        const context = {
            coords: this._coords,
            colors: this._colors,
            offsetX: -offsetX,
            offsetY: -offsetY,
            scaleX: 1 / scaleX,
            scaleY: 1 / scaleY
        };
        const paddedWidth = width + BORDER_SIZE * 2;
        const paddedHeight = height + BORDER_SIZE * 2;
        const tmpCanvas = canvasFactory.create(paddedWidth, paddedHeight);
        if ($b3a01b20dd2ade98$var$isWebGPUMeshReady()) tmpCanvas.context.drawImage($b3a01b20dd2ade98$var$drawMeshWithGPU(this._figures, context, backgroundColor, paddedWidth, paddedHeight, BORDER_SIZE), 0, 0);
        else {
            const data = tmpCanvas.context.createImageData(width, height);
            if (backgroundColor) {
                const bytes = data.data;
                for(let i = 0, ii = bytes.length; i < ii; i += 4){
                    bytes[i] = backgroundColor[0];
                    bytes[i + 1] = backgroundColor[1];
                    bytes[i + 2] = backgroundColor[2];
                    bytes[i + 3] = 255;
                }
            }
            for (const figure of this._figures)$b3a01b20dd2ade98$var$drawFigure(data, figure, context);
            tmpCanvas.context.putImageData(data, BORDER_SIZE, BORDER_SIZE);
        }
        return {
            canvas: tmpCanvas.canvas,
            offsetX: offsetX - BORDER_SIZE * scaleX,
            offsetY: offsetY - BORDER_SIZE * scaleY,
            scaleX: scaleX,
            scaleY: scaleY
        };
    }
    isModifyingCurrentTransform() {
        return true;
    }
    getPattern(ctx, owner, inverse, pathType) {
        $b3a01b20dd2ade98$var$applyBoundingBox(ctx, this._bbox);
        const scale = new Float32Array(2);
        if (pathType === $b3a01b20dd2ade98$var$PathType.SHADING) $b3a01b20dd2ade98$export$f8f26dd395d7e1bd.singularValueDecompose2dScale($b3a01b20dd2ade98$var$getCurrentTransform(ctx), scale);
        else if (this.matrix) {
            $b3a01b20dd2ade98$export$f8f26dd395d7e1bd.singularValueDecompose2dScale(this.matrix, scale);
            const [matrixScaleX, matrixScaleY] = scale;
            $b3a01b20dd2ade98$export$f8f26dd395d7e1bd.singularValueDecompose2dScale(owner.baseTransform, scale);
            scale[0] *= matrixScaleX;
            scale[1] *= matrixScaleY;
        } else $b3a01b20dd2ade98$export$f8f26dd395d7e1bd.singularValueDecompose2dScale(owner.baseTransform, scale);
        const temporaryPatternCanvas = this._createMeshCanvas(scale, pathType === $b3a01b20dd2ade98$var$PathType.SHADING ? null : this._background, owner.canvasFactory);
        if (pathType !== $b3a01b20dd2ade98$var$PathType.SHADING) {
            ctx.setTransform(...owner.baseTransform);
            if (this.matrix) ctx.transform(...this.matrix);
        }
        ctx.translate(temporaryPatternCanvas.offsetX, temporaryPatternCanvas.offsetY);
        ctx.scale(temporaryPatternCanvas.scaleX, temporaryPatternCanvas.scaleY);
        const pattern = ctx.createPattern(temporaryPatternCanvas.canvas, "no-repeat");
        owner.canvasFactory.destroy(temporaryPatternCanvas);
        return pattern;
    }
}
class $b3a01b20dd2ade98$var$DummyShadingPattern extends $b3a01b20dd2ade98$var$BaseShadingPattern {
    getPattern() {
        return "hotpink";
    }
}
function $b3a01b20dd2ade98$var$getShadingPattern(IR) {
    switch(IR[0]){
        case "RadialAxial":
            return new $b3a01b20dd2ade98$var$RadialAxialShadingPattern(IR);
        case "Mesh":
            return new $b3a01b20dd2ade98$var$MeshShadingPattern(IR);
        case "Dummy":
            return new $b3a01b20dd2ade98$var$DummyShadingPattern();
    }
    throw new Error(`Unknown IR type: ${IR[0]}`);
}
const $b3a01b20dd2ade98$var$PaintType = {
    COLORED: 1,
    UNCOLORED: 2
};
class $b3a01b20dd2ade98$var$TilingPattern {
    static MAX_PATTERN_SIZE = 3000;
    constructor(IR, ctx, canvasGraphicsFactory, baseTransform){
        this.color = IR[1];
        this.operatorList = IR[2];
        this.matrix = IR[3];
        this.bbox = IR[4];
        this.xstep = IR[5];
        this.ystep = IR[6];
        this.paintType = IR[7];
        this.tilingType = IR[8];
        this.ctx = ctx;
        this.canvasGraphicsFactory = canvasGraphicsFactory;
        this.baseTransform = baseTransform;
    }
    createPatternCanvas(owner, opIdx) {
        const { bbox: bbox, operatorList: operatorList, paintType: paintType, tilingType: tilingType, color: color, canvasGraphicsFactory: canvasGraphicsFactory } = this;
        let { xstep: xstep, ystep: ystep } = this;
        xstep = Math.abs(xstep);
        ystep = Math.abs(ystep);
        $b3a01b20dd2ade98$var$info("TilingType: " + tilingType);
        const x0 = bbox[0], y0 = bbox[1], x1 = bbox[2], y1 = bbox[3];
        const width = x1 - x0;
        const height = y1 - y0;
        const scale = new Float32Array(2);
        $b3a01b20dd2ade98$export$f8f26dd395d7e1bd.singularValueDecompose2dScale(this.matrix, scale);
        const [matrixScaleX, matrixScaleY] = scale;
        $b3a01b20dd2ade98$export$f8f26dd395d7e1bd.singularValueDecompose2dScale(this.baseTransform, scale);
        const combinedScaleX = matrixScaleX * scale[0];
        const combinedScaleY = matrixScaleY * scale[1];
        let canvasWidth = width, canvasHeight = height, redrawHorizontally = false, redrawVertically = false;
        const xScaledStep = Math.ceil(xstep * combinedScaleX);
        const yScaledStep = Math.ceil(ystep * combinedScaleY);
        const xScaledWidth = Math.ceil(width * combinedScaleX);
        const yScaledHeight = Math.ceil(height * combinedScaleY);
        if (xScaledStep >= xScaledWidth) canvasWidth = xstep;
        else redrawHorizontally = true;
        if (yScaledStep >= yScaledHeight) canvasHeight = ystep;
        else redrawVertically = true;
        const dimx = this.getSizeAndScale(canvasWidth, this.ctx.canvas.width, combinedScaleX);
        const dimy = this.getSizeAndScale(canvasHeight, this.ctx.canvas.height, combinedScaleY);
        const tmpCanvas = owner.canvasFactory.create(dimx.size, dimy.size);
        const tmpCtx = tmpCanvas.context;
        const graphics = canvasGraphicsFactory.createCanvasGraphics(tmpCtx, opIdx);
        graphics.groupLevel = owner.groupLevel;
        this.setFillAndStrokeStyleToContext(graphics, paintType, color);
        tmpCtx.translate(-dimx.scale * x0, -dimy.scale * y0);
        graphics.transform(0, dimx.scale, 0, 0, dimy.scale, 0, 0);
        tmpCtx.save();
        graphics.dependencyTracker?.save();
        this.clipBbox(graphics, x0, y0, x1, y1);
        graphics.baseTransform = $b3a01b20dd2ade98$var$getCurrentTransform(graphics.ctx);
        graphics.executeOperatorList(operatorList);
        graphics.endDrawing();
        graphics.dependencyTracker?.restore();
        tmpCtx.restore();
        if (redrawHorizontally || redrawVertically) {
            const image = tmpCanvas.canvas;
            if (redrawHorizontally) canvasWidth = xstep;
            if (redrawVertically) canvasHeight = ystep;
            const dimx2 = this.getSizeAndScale(canvasWidth, this.ctx.canvas.width, combinedScaleX);
            const dimy2 = this.getSizeAndScale(canvasHeight, this.ctx.canvas.height, combinedScaleY);
            const xSize = dimx2.size;
            const ySize = dimy2.size;
            const tmpCanvas2 = owner.canvasFactory.create(xSize, ySize);
            const tmpCtx2 = tmpCanvas2.context;
            const ii = redrawHorizontally ? Math.floor(width / xstep) : 0;
            const jj = redrawVertically ? Math.floor(height / ystep) : 0;
            for(let i = 0; i <= ii; i++)for(let j = 0; j <= jj; j++)tmpCtx2.drawImage(image, xSize * i, ySize * j, xSize, ySize, 0, 0, xSize, ySize);
            owner.canvasFactory.destroy(tmpCanvas);
            return {
                canvas: tmpCanvas2.canvas,
                canvasEntry: tmpCanvas2,
                scaleX: dimx2.scale,
                scaleY: dimy2.scale,
                offsetX: x0,
                offsetY: y0
            };
        }
        return {
            canvas: tmpCanvas.canvas,
            canvasEntry: tmpCanvas,
            scaleX: dimx.scale,
            scaleY: dimy.scale,
            offsetX: x0,
            offsetY: y0
        };
    }
    getSizeAndScale(step, realOutputSize, scale) {
        const maxSize = Math.max($b3a01b20dd2ade98$var$TilingPattern.MAX_PATTERN_SIZE, realOutputSize);
        let size = Math.ceil(step * scale);
        if (size >= maxSize) size = maxSize;
        else scale = size / step;
        return {
            scale: scale,
            size: size
        };
    }
    clipBbox(graphics, x0, y0, x1, y1) {
        const bboxWidth = x1 - x0;
        const bboxHeight = y1 - y0;
        graphics.ctx.rect(x0, y0, bboxWidth, bboxHeight);
        $b3a01b20dd2ade98$export$f8f26dd395d7e1bd.axialAlignedBoundingBox([
            x0,
            y0,
            x1,
            y1
        ], $b3a01b20dd2ade98$var$getCurrentTransform(graphics.ctx), graphics.current.minMax);
        graphics.clip();
        graphics.endPath();
    }
    setFillAndStrokeStyleToContext(graphics, paintType, color) {
        const context = graphics.ctx, current = graphics.current;
        switch(paintType){
            case $b3a01b20dd2ade98$var$PaintType.COLORED:
                const { fillStyle: fillStyle, strokeStyle: strokeStyle } = this.ctx;
                context.fillStyle = current.fillColor = fillStyle;
                context.strokeStyle = current.strokeColor = strokeStyle;
                break;
            case $b3a01b20dd2ade98$var$PaintType.UNCOLORED:
                context.fillStyle = context.strokeStyle = color;
                current.fillColor = current.strokeColor = color;
                break;
            default:
                throw new $b3a01b20dd2ade98$var$FormatError(`Unsupported paint type: ${paintType}`);
        }
    }
    isModifyingCurrentTransform() {
        return false;
    }
    getPattern(ctx, owner, inverse, pathType, opIdx) {
        let matrix = inverse;
        if (pathType !== $b3a01b20dd2ade98$var$PathType.SHADING) {
            matrix = $b3a01b20dd2ade98$export$f8f26dd395d7e1bd.transform(matrix, owner.baseTransform);
            if (this.matrix) matrix = $b3a01b20dd2ade98$export$f8f26dd395d7e1bd.transform(matrix, this.matrix);
        }
        const temporaryPatternCanvas = this.createPatternCanvas(owner, opIdx);
        let domMatrix = new DOMMatrix(matrix);
        domMatrix = domMatrix.translate(temporaryPatternCanvas.offsetX, temporaryPatternCanvas.offsetY);
        domMatrix = domMatrix.scale(1 / temporaryPatternCanvas.scaleX, 1 / temporaryPatternCanvas.scaleY);
        const pattern = ctx.createPattern(temporaryPatternCanvas.canvas, "repeat");
        owner.canvasFactory.destroy(temporaryPatternCanvas.canvasEntry);
        pattern.setTransform(domMatrix);
        return pattern;
    }
}
/* unused harmony import specifier */ var $b3a01b20dd2ade98$var$image_utils_ImageKind;
/* unused harmony import specifier */ var $b3a01b20dd2ade98$var$image_utils_FeatureTest;
function $b3a01b20dd2ade98$var$convertToRGBA(params) {
    switch(params.kind){
        case $b3a01b20dd2ade98$var$image_utils_ImageKind.GRAYSCALE_1BPP:
            return $b3a01b20dd2ade98$var$convertBlackAndWhiteToRGBA(params);
        case $b3a01b20dd2ade98$var$image_utils_ImageKind.RGB_24BPP:
            return $b3a01b20dd2ade98$var$convertRGBToRGBA(params);
    }
    return null;
}
function $b3a01b20dd2ade98$var$convertBlackAndWhiteToRGBA({ src: src, srcPos: srcPos = 0, dest: dest, width: width, height: height, nonBlackColor: nonBlackColor = 0xffffffff, inverseDecode: inverseDecode = false }) {
    const black = $b3a01b20dd2ade98$export$5fb8891d35c36978.isLittleEndian ? 0xff000000 : 0x000000ff;
    const [zeroMapping, oneMapping] = inverseDecode ? [
        nonBlackColor,
        black
    ] : [
        black,
        nonBlackColor
    ];
    const widthInSource = width >> 3;
    const widthRemainder = width & 7;
    const xorMask = zeroMapping ^ oneMapping;
    const srcLength = src.length;
    dest = new Uint32Array(dest.buffer);
    let destPos = 0;
    for(let i = 0; i < height; ++i){
        for(const max = srcPos + widthInSource; srcPos < max; ++srcPos, destPos += 8){
            const elem = src[srcPos];
            dest[destPos] = zeroMapping ^ -(elem >> 7 & 1) & xorMask;
            dest[destPos + 1] = zeroMapping ^ -(elem >> 6 & 1) & xorMask;
            dest[destPos + 2] = zeroMapping ^ -(elem >> 5 & 1) & xorMask;
            dest[destPos + 3] = zeroMapping ^ -(elem >> 4 & 1) & xorMask;
            dest[destPos + 4] = zeroMapping ^ -(elem >> 3 & 1) & xorMask;
            dest[destPos + 5] = zeroMapping ^ -(elem >> 2 & 1) & xorMask;
            dest[destPos + 6] = zeroMapping ^ -(elem >> 1 & 1) & xorMask;
            dest[destPos + 7] = zeroMapping ^ -(elem & 1) & xorMask;
        }
        if (widthRemainder === 0) continue;
        const elem = srcPos < srcLength ? src[srcPos++] : 255;
        for(let j = 0; j < widthRemainder; ++j, ++destPos)dest[destPos] = zeroMapping ^ -(elem >> 7 - j & 1) & xorMask;
    }
    return {
        srcPos: srcPos,
        destPos: destPos
    };
}
function $b3a01b20dd2ade98$var$convertRGBToRGBA({ src: src, srcPos: srcPos = 0, dest: dest, destPos: destPos = 0, width: width, height: height }) {
    let i = 0;
    const len = width * height * 3;
    const len32 = len >> 2;
    const src32 = new Uint32Array(src.buffer, srcPos, len32);
    const alphaMask = $b3a01b20dd2ade98$var$image_utils_FeatureTest.isLittleEndian ? 0xff000000 : 0xff;
    if ($b3a01b20dd2ade98$var$image_utils_FeatureTest.isLittleEndian) {
        for(; i < len32 - 2; i += 3, destPos += 4){
            const s1 = src32[i], s2 = src32[i + 1], s3 = src32[i + 2];
            dest[destPos] = s1 | alphaMask;
            dest[destPos + 1] = s1 >>> 24 | s2 << 8 | alphaMask;
            dest[destPos + 2] = s2 >>> 16 | s3 << 16 | alphaMask;
            dest[destPos + 3] = s3 >>> 8 | alphaMask;
        }
        for(let j = i * 4, jj = srcPos + len; j < jj; j += 3)dest[destPos++] = src[j] | src[j + 1] << 8 | src[j + 2] << 16 | alphaMask;
    } else {
        for(; i < len32 - 2; i += 3, destPos += 4){
            const s1 = src32[i], s2 = src32[i + 1], s3 = src32[i + 2];
            dest[destPos] = s1 | alphaMask;
            dest[destPos + 1] = s1 << 24 | s2 >>> 8 | alphaMask;
            dest[destPos + 2] = s2 << 16 | s3 >>> 16 | alphaMask;
            dest[destPos + 3] = s3 << 8 | alphaMask;
        }
        for(let j = i * 4, jj = srcPos + len; j < jj; j += 3)dest[destPos++] = src[j] << 24 | src[j + 1] << 16 | src[j + 2] << 8 | alphaMask;
    }
    return {
        srcPos: srcPos + len,
        destPos: destPos
    };
}
function $b3a01b20dd2ade98$var$grayToRGBA(src, dest) {
    if ($b3a01b20dd2ade98$var$image_utils_FeatureTest.isLittleEndian) for(let i = 0, ii = src.length; i < ii; i++)dest[i] = src[i] * 0x10101 | 0xff000000;
    else for(let i = 0, ii = src.length; i < ii; i++)dest[i] = src[i] * 0x1010100 | 0x000000ff;
}
const $b3a01b20dd2ade98$var$MIN_FONT_SIZE = 16;
const $b3a01b20dd2ade98$var$MAX_FONT_SIZE = 100;
const $b3a01b20dd2ade98$var$EXECUTION_TIME = 15;
const $b3a01b20dd2ade98$var$EXECUTION_STEPS = 10;
const $b3a01b20dd2ade98$var$FULL_CHUNK_HEIGHT = 16;
const $b3a01b20dd2ade98$var$SCALE_MATRIX = new DOMMatrix();
const $b3a01b20dd2ade98$var$XY = new Float32Array(2);
const $b3a01b20dd2ade98$var$MIN_MAX_INIT = new Float32Array([
    Infinity,
    Infinity,
    -Infinity,
    -Infinity
]);
function $b3a01b20dd2ade98$var$mirrorContextOperations(ctx, destCtx) {
    if (ctx._removeMirroring) throw new Error("Context is already forwarding operations.");
    ctx.__originalSave = ctx.save;
    ctx.__originalRestore = ctx.restore;
    ctx.__originalRotate = ctx.rotate;
    ctx.__originalScale = ctx.scale;
    ctx.__originalTranslate = ctx.translate;
    ctx.__originalTransform = ctx.transform;
    ctx.__originalSetTransform = ctx.setTransform;
    ctx.__originalResetTransform = ctx.resetTransform;
    ctx.__originalClip = ctx.clip;
    ctx.__originalMoveTo = ctx.moveTo;
    ctx.__originalLineTo = ctx.lineTo;
    ctx.__originalBezierCurveTo = ctx.bezierCurveTo;
    ctx.__originalRect = ctx.rect;
    ctx.__originalClosePath = ctx.closePath;
    ctx.__originalBeginPath = ctx.beginPath;
    ctx._removeMirroring = ()=>{
        ctx.save = ctx.__originalSave;
        ctx.restore = ctx.__originalRestore;
        ctx.rotate = ctx.__originalRotate;
        ctx.scale = ctx.__originalScale;
        ctx.translate = ctx.__originalTranslate;
        ctx.transform = ctx.__originalTransform;
        ctx.setTransform = ctx.__originalSetTransform;
        ctx.resetTransform = ctx.__originalResetTransform;
        ctx.clip = ctx.__originalClip;
        ctx.moveTo = ctx.__originalMoveTo;
        ctx.lineTo = ctx.__originalLineTo;
        ctx.bezierCurveTo = ctx.__originalBezierCurveTo;
        ctx.rect = ctx.__originalRect;
        ctx.closePath = ctx.__originalClosePath;
        ctx.beginPath = ctx.__originalBeginPath;
        delete ctx._removeMirroring;
    };
    ctx.save = function() {
        destCtx.save();
        this.__originalSave();
    };
    ctx.restore = function() {
        destCtx.restore();
        this.__originalRestore();
    };
    ctx.translate = function(x, y) {
        destCtx.translate(x, y);
        this.__originalTranslate(x, y);
    };
    ctx.scale = function(x, y) {
        destCtx.scale(x, y);
        this.__originalScale(x, y);
    };
    ctx.transform = function(a, b, c, d, e, f) {
        destCtx.transform(a, b, c, d, e, f);
        this.__originalTransform(a, b, c, d, e, f);
    };
    ctx.setTransform = function(a, b, c, d, e, f) {
        destCtx.setTransform(a, b, c, d, e, f);
        this.__originalSetTransform(a, b, c, d, e, f);
    };
    ctx.resetTransform = function() {
        destCtx.resetTransform();
        this.__originalResetTransform();
    };
    ctx.rotate = function(angle) {
        destCtx.rotate(angle);
        this.__originalRotate(angle);
    };
    ctx.clip = function(rule) {
        destCtx.clip(rule);
        this.__originalClip(rule);
    };
    ctx.moveTo = function(x, y) {
        destCtx.moveTo(x, y);
        this.__originalMoveTo(x, y);
    };
    ctx.lineTo = function(x, y) {
        destCtx.lineTo(x, y);
        this.__originalLineTo(x, y);
    };
    ctx.bezierCurveTo = function(cp1x, cp1y, cp2x, cp2y, x, y) {
        destCtx.bezierCurveTo(cp1x, cp1y, cp2x, cp2y, x, y);
        this.__originalBezierCurveTo(cp1x, cp1y, cp2x, cp2y, x, y);
    };
    ctx.rect = function(x, y, width, height) {
        destCtx.rect(x, y, width, height);
        this.__originalRect(x, y, width, height);
    };
    ctx.closePath = function() {
        destCtx.closePath();
        this.__originalClosePath();
    };
    ctx.beginPath = function() {
        destCtx.beginPath();
        this.__originalBeginPath();
    };
}
function $b3a01b20dd2ade98$var$drawImageAtIntegerCoords(ctx, srcImg, srcX, srcY, srcW, srcH, destX, destY, destW, destH) {
    const [a, b, c, d, tx, ty] = $b3a01b20dd2ade98$var$getCurrentTransform(ctx);
    if (b === 0 && c === 0) {
        const tlX = destX * a + tx;
        const rTlX = Math.round(tlX);
        const tlY = destY * d + ty;
        const rTlY = Math.round(tlY);
        const brX = (destX + destW) * a + tx;
        const rWidth = Math.abs(Math.round(brX) - rTlX) || 1;
        const brY = (destY + destH) * d + ty;
        const rHeight = Math.abs(Math.round(brY) - rTlY) || 1;
        ctx.setTransform(Math.sign(a), 0, 0, Math.sign(d), rTlX, rTlY);
        ctx.drawImage(srcImg, srcX, srcY, srcW, srcH, 0, 0, rWidth, rHeight);
        ctx.setTransform(a, b, c, d, tx, ty);
        return [
            rWidth,
            rHeight
        ];
    }
    if (a === 0 && d === 0) {
        const tlX = destY * c + tx;
        const rTlX = Math.round(tlX);
        const tlY = destX * b + ty;
        const rTlY = Math.round(tlY);
        const brX = (destY + destH) * c + tx;
        const rWidth = Math.abs(Math.round(brX) - rTlX) || 1;
        const brY = (destX + destW) * b + ty;
        const rHeight = Math.abs(Math.round(brY) - rTlY) || 1;
        ctx.setTransform(0, Math.sign(b), Math.sign(c), 0, rTlX, rTlY);
        ctx.drawImage(srcImg, srcX, srcY, srcW, srcH, 0, 0, rHeight, rWidth);
        ctx.setTransform(a, b, c, d, tx, ty);
        return [
            rHeight,
            rWidth
        ];
    }
    ctx.drawImage(srcImg, srcX, srcY, srcW, srcH, destX, destY, destW, destH);
    const scaleX = Math.hypot(a, b);
    const scaleY = Math.hypot(c, d);
    return [
        scaleX * destW,
        scaleY * destH
    ];
}
class $b3a01b20dd2ade98$var$CanvasExtraState {
    alphaIsShape = false;
    fontSize = 0;
    fontSizeScale = 1;
    textMatrix = null;
    textMatrixScale = 1;
    fontMatrix = $b3a01b20dd2ade98$var$FONT_IDENTITY_MATRIX;
    leading = 0;
    x = 0;
    y = 0;
    lineX = 0;
    lineY = 0;
    charSpacing = 0;
    wordSpacing = 0;
    textHScale = 1;
    textRenderingMode = $b3a01b20dd2ade98$var$TextRenderingMode.FILL;
    textRise = 0;
    fillColor = "#000000";
    strokeColor = "#000000";
    patternFill = false;
    patternStroke = false;
    fillAlpha = 1;
    strokeAlpha = 1;
    lineWidth = 1;
    activeSMask = null;
    transferMaps = "none";
    minMax = $b3a01b20dd2ade98$var$MIN_MAX_INIT.slice();
    constructor(width, height){
        this.clipBox = new Float32Array([
            0,
            0,
            width,
            height
        ]);
    }
    clone() {
        const clone = Object.create(this);
        clone.clipBox = this.clipBox.slice();
        clone.minMax = this.minMax.slice();
        return clone;
    }
    getPathBoundingBox(pathType = $b3a01b20dd2ade98$var$PathType.FILL, transform = null) {
        const box = this.minMax.slice();
        if (pathType === $b3a01b20dd2ade98$var$PathType.STROKE) {
            if (!transform) $b3a01b20dd2ade98$var$unreachable("Stroke bounding box must include transform.");
            $b3a01b20dd2ade98$export$f8f26dd395d7e1bd.singularValueDecompose2dScale(transform, $b3a01b20dd2ade98$var$XY);
            const xStrokePad = $b3a01b20dd2ade98$var$XY[0] * this.lineWidth / 2;
            const yStrokePad = $b3a01b20dd2ade98$var$XY[1] * this.lineWidth / 2;
            box[0] -= xStrokePad;
            box[1] -= yStrokePad;
            box[2] += xStrokePad;
            box[3] += yStrokePad;
        }
        return box;
    }
    updateClipFromPath() {
        const intersect = $b3a01b20dd2ade98$export$f8f26dd395d7e1bd.intersect(this.clipBox, this.getPathBoundingBox());
        this.startNewPathAndClipBox(intersect || [
            0,
            0,
            0,
            0
        ]);
    }
    isEmptyClip() {
        return this.minMax[0] === Infinity;
    }
    startNewPathAndClipBox(box) {
        this.clipBox.set(box, 0);
        this.minMax.set($b3a01b20dd2ade98$var$MIN_MAX_INIT, 0);
    }
    getClippedPathBoundingBox(pathType = $b3a01b20dd2ade98$var$PathType.FILL, transform = null) {
        return $b3a01b20dd2ade98$export$f8f26dd395d7e1bd.intersect(this.clipBox, this.getPathBoundingBox(pathType, transform));
    }
}
function $b3a01b20dd2ade98$var$putBinaryImageData(ctx, imgData) {
    if (imgData instanceof ImageData) {
        ctx.putImageData(imgData, 0, 0);
        return;
    }
    const height = imgData.height, width = imgData.width;
    const partialChunkHeight = height % $b3a01b20dd2ade98$var$FULL_CHUNK_HEIGHT;
    const fullChunks = (height - partialChunkHeight) / $b3a01b20dd2ade98$var$FULL_CHUNK_HEIGHT;
    const totalChunks = partialChunkHeight === 0 ? fullChunks : fullChunks + 1;
    const chunkImgData = ctx.createImageData(width, $b3a01b20dd2ade98$var$FULL_CHUNK_HEIGHT);
    let srcPos = 0, destPos;
    const src = imgData.data;
    const dest = chunkImgData.data;
    let i, j, thisChunkHeight, elemsInThisChunk;
    if (imgData.kind === $b3a01b20dd2ade98$export$b890e9c15247e0b3.GRAYSCALE_1BPP) {
        const srcLength = src.byteLength;
        const dest32 = new Uint32Array(dest.buffer, 0, dest.byteLength >> 2);
        const dest32DataLength = dest32.length;
        const fullSrcDiff = width + 7 >> 3;
        const white = 0xffffffff;
        const black = $b3a01b20dd2ade98$export$5fb8891d35c36978.isLittleEndian ? 0xff000000 : 0x000000ff;
        for(i = 0; i < totalChunks; i++){
            thisChunkHeight = i < fullChunks ? $b3a01b20dd2ade98$var$FULL_CHUNK_HEIGHT : partialChunkHeight;
            destPos = 0;
            for(j = 0; j < thisChunkHeight; j++){
                const srcDiff = srcLength - srcPos;
                let k = 0;
                const kEnd = srcDiff > fullSrcDiff ? width : srcDiff * 8 - 7;
                const kEndUnrolled = kEnd & -8;
                let mask = 0;
                let srcByte = 0;
                for(; k < kEndUnrolled; k += 8){
                    srcByte = src[srcPos++];
                    dest32[destPos++] = srcByte & 128 ? white : black;
                    dest32[destPos++] = srcByte & 64 ? white : black;
                    dest32[destPos++] = srcByte & 32 ? white : black;
                    dest32[destPos++] = srcByte & 16 ? white : black;
                    dest32[destPos++] = srcByte & 8 ? white : black;
                    dest32[destPos++] = srcByte & 4 ? white : black;
                    dest32[destPos++] = srcByte & 2 ? white : black;
                    dest32[destPos++] = srcByte & 1 ? white : black;
                }
                for(; k < kEnd; k++){
                    if (mask === 0) {
                        srcByte = src[srcPos++];
                        mask = 128;
                    }
                    dest32[destPos++] = srcByte & mask ? white : black;
                    mask >>= 1;
                }
            }
            while(destPos < dest32DataLength)dest32[destPos++] = 0;
            ctx.putImageData(chunkImgData, 0, i * $b3a01b20dd2ade98$var$FULL_CHUNK_HEIGHT);
        }
    } else if (imgData.kind === $b3a01b20dd2ade98$export$b890e9c15247e0b3.RGBA_32BPP) {
        j = 0;
        elemsInThisChunk = width * $b3a01b20dd2ade98$var$FULL_CHUNK_HEIGHT * 4;
        for(i = 0; i < fullChunks; i++){
            dest.set(src.subarray(srcPos, srcPos + elemsInThisChunk));
            srcPos += elemsInThisChunk;
            ctx.putImageData(chunkImgData, 0, j);
            j += $b3a01b20dd2ade98$var$FULL_CHUNK_HEIGHT;
        }
        if (i < totalChunks) {
            elemsInThisChunk = width * partialChunkHeight * 4;
            dest.set(src.subarray(srcPos, srcPos + elemsInThisChunk));
            ctx.putImageData(chunkImgData, 0, j);
        }
    } else if (imgData.kind === $b3a01b20dd2ade98$export$b890e9c15247e0b3.RGB_24BPP) {
        thisChunkHeight = $b3a01b20dd2ade98$var$FULL_CHUNK_HEIGHT;
        elemsInThisChunk = width * thisChunkHeight;
        for(i = 0; i < totalChunks; i++){
            if (i >= fullChunks) {
                thisChunkHeight = partialChunkHeight;
                elemsInThisChunk = width * thisChunkHeight;
            }
            destPos = 0;
            for(j = elemsInThisChunk; j--;){
                dest[destPos++] = src[srcPos++];
                dest[destPos++] = src[srcPos++];
                dest[destPos++] = src[srcPos++];
                dest[destPos++] = 255;
            }
            ctx.putImageData(chunkImgData, 0, i * $b3a01b20dd2ade98$var$FULL_CHUNK_HEIGHT);
        }
    } else throw new Error(`bad image kind: ${imgData.kind}`);
}
function $b3a01b20dd2ade98$var$putBinaryImageMask(ctx, imgData) {
    if (imgData.bitmap) {
        ctx.drawImage(imgData.bitmap, 0, 0);
        return;
    }
    const height = imgData.height, width = imgData.width;
    const partialChunkHeight = height % $b3a01b20dd2ade98$var$FULL_CHUNK_HEIGHT;
    const fullChunks = (height - partialChunkHeight) / $b3a01b20dd2ade98$var$FULL_CHUNK_HEIGHT;
    const totalChunks = partialChunkHeight === 0 ? fullChunks : fullChunks + 1;
    const chunkImgData = ctx.createImageData(width, $b3a01b20dd2ade98$var$FULL_CHUNK_HEIGHT);
    let srcPos = 0;
    const src = imgData.data;
    const dest = chunkImgData.data;
    for(let i = 0; i < totalChunks; i++){
        const thisChunkHeight = i < fullChunks ? $b3a01b20dd2ade98$var$FULL_CHUNK_HEIGHT : partialChunkHeight;
        ({ srcPos: srcPos } = $b3a01b20dd2ade98$var$convertBlackAndWhiteToRGBA({
            src: src,
            srcPos: srcPos,
            dest: dest,
            width: width,
            height: thisChunkHeight,
            nonBlackColor: 0
        }));
        ctx.putImageData(chunkImgData, 0, i * $b3a01b20dd2ade98$var$FULL_CHUNK_HEIGHT);
    }
}
function $b3a01b20dd2ade98$var$copyCtxState(sourceCtx, destCtx) {
    const properties = [
        "strokeStyle",
        "fillStyle",
        "fillRule",
        "globalAlpha",
        "lineWidth",
        "lineCap",
        "lineJoin",
        "miterLimit",
        "globalCompositeOperation",
        "font",
        "filter"
    ];
    for (const property of properties)if (sourceCtx[property] !== undefined) destCtx[property] = sourceCtx[property];
    if (sourceCtx.setLineDash !== undefined) {
        destCtx.setLineDash(sourceCtx.getLineDash());
        destCtx.lineDashOffset = sourceCtx.lineDashOffset;
    }
}
function $b3a01b20dd2ade98$var$resetCtxToDefault(ctx) {
    ctx.strokeStyle = ctx.fillStyle = "#000000";
    ctx.fillRule = "nonzero";
    ctx.globalAlpha = 1;
    ctx.lineWidth = 1;
    ctx.lineCap = "butt";
    ctx.lineJoin = "miter";
    ctx.miterLimit = 10;
    ctx.globalCompositeOperation = "source-over";
    ctx.font = "10px sans-serif";
    if (ctx.setLineDash !== undefined) {
        ctx.setLineDash([]);
        ctx.lineDashOffset = 0;
    }
    const { filter: filter } = ctx;
    if (filter !== "none" && filter !== "") ctx.filter = "none";
}
function $b3a01b20dd2ade98$var$getImageSmoothingEnabled(transform, interpolate) {
    if (interpolate) return true;
    $b3a01b20dd2ade98$export$f8f26dd395d7e1bd.singularValueDecompose2dScale(transform, $b3a01b20dd2ade98$var$XY);
    const actualScale = Math.fround($b3a01b20dd2ade98$export$f16a99f63bccd50b.pixelRatio * $b3a01b20dd2ade98$export$6ef3b6b69e65342c.PDF_TO_CSS_UNITS);
    return $b3a01b20dd2ade98$var$XY[0] <= actualScale && $b3a01b20dd2ade98$var$XY[1] <= actualScale;
}
const $b3a01b20dd2ade98$var$LINE_CAP_STYLES = [
    "butt",
    "round",
    "square"
];
const $b3a01b20dd2ade98$var$LINE_JOIN_STYLES = [
    "miter",
    "round",
    "bevel"
];
const $b3a01b20dd2ade98$var$NORMAL_CLIP = {};
const $b3a01b20dd2ade98$var$EO_CLIP = {};
class $b3a01b20dd2ade98$var$CanvasGraphics {
    constructor(canvasCtx, commonObjs, objs, canvasFactory, filterFactory, { optionalContentConfig: optionalContentConfig, markedContentStack: markedContentStack = null }, annotationCanvasMap, pageColors, dependencyTracker, imagesTracker){
        this.ctx = canvasCtx;
        this.current = new $b3a01b20dd2ade98$var$CanvasExtraState(this.ctx.canvas.width, this.ctx.canvas.height);
        this.stateStack = [];
        this.pendingClip = null;
        this.pendingEOFill = false;
        this.commonObjs = commonObjs;
        this.objs = objs;
        this.canvasFactory = canvasFactory;
        this.filterFactory = filterFactory;
        this.groupStack = [];
        this.baseTransform = null;
        this.baseTransformStack = [];
        this.groupLevel = 0;
        this.smaskStack = [];
        this.smaskCounter = 0;
        this.tempSMask = null;
        this.smaskGroupCanvases = [];
        this.suspendedCtx = null;
        this.contentVisible = true;
        this.markedContentStack = markedContentStack || [];
        this.optionalContentConfig = optionalContentConfig;
        this.cachedPatterns = new Map();
        this.annotationCanvasMap = annotationCanvasMap;
        this.viewportScale = 1;
        this.outputScaleX = 1;
        this.outputScaleY = 1;
        this.pageColors = pageColors;
        this._cachedScaleForStroking = [
            -1,
            0
        ];
        this._cachedGetSinglePixelWidth = null;
        this._cachedBitmapsMap = new Map();
        this.dependencyTracker = dependencyTracker ?? null;
        this.imagesTracker = imagesTracker ?? null;
    }
    getObject(opIdx, data, fallback = null) {
        if (typeof data === "string") {
            this.dependencyTracker?.recordNamedDependency(opIdx, data);
            return data.startsWith("g_") ? this.commonObjs.get(data) : this.objs.get(data);
        }
        return fallback;
    }
    beginDrawing({ transform: transform, viewport: viewport, transparency: transparency = false, background: background = null }) {
        const width = this.ctx.canvas.width;
        const height = this.ctx.canvas.height;
        const savedFillStyle = this.ctx.fillStyle;
        this.ctx.fillStyle = background || "#ffffff";
        this.ctx.fillRect(0, 0, width, height);
        this.ctx.fillStyle = savedFillStyle;
        if (transparency) {
            const transparentCanvas = this.transparentCanvasEntry = this.canvasFactory.create(width, height);
            this.compositeCtx = this.ctx;
            ({ canvas: this.transparentCanvas, context: this.ctx } = transparentCanvas);
            this.ctx.save();
            this.ctx.transform(...$b3a01b20dd2ade98$var$getCurrentTransform(this.compositeCtx));
        }
        this.ctx.save();
        $b3a01b20dd2ade98$var$resetCtxToDefault(this.ctx);
        if (transform) {
            this.ctx.transform(...transform);
            this.outputScaleX = transform[0];
            this.outputScaleY = transform[0];
        }
        this.ctx.transform(...viewport.transform);
        this.viewportScale = viewport.scale;
        this.baseTransform = $b3a01b20dd2ade98$var$getCurrentTransform(this.ctx);
    }
    executeOperatorList(operatorList, executionStartIdx, continueCallback, stepper, operationsFilter) {
        const argsArray = operatorList.argsArray;
        const fnArray = operatorList.fnArray;
        let i = executionStartIdx || 0;
        const argsArrayLen = argsArray.length;
        if (argsArrayLen === i) return i;
        const chunkOperations = argsArrayLen - i > $b3a01b20dd2ade98$var$EXECUTION_STEPS && typeof continueCallback === "function";
        const endTime = chunkOperations ? Date.now() + $b3a01b20dd2ade98$var$EXECUTION_TIME : 0;
        let steps = 0;
        const commonObjs = this.commonObjs;
        const objs = this.objs;
        let fnId, fnArgs;
        while(true){
            if (stepper !== undefined) {
                if (i === stepper.nextBreakPoint) {
                    stepper.breakIt(i, continueCallback);
                    return i;
                }
                if (stepper.shouldSkip(i)) {
                    if (++i === argsArrayLen) return i;
                    continue;
                }
            }
            if (!operationsFilter || operationsFilter(i)) {
                fnId = fnArray[i];
                fnArgs = argsArray[i] ?? null;
                if (fnId !== $b3a01b20dd2ade98$export$3a0f7f7a8a0b306b.dependency) {
                    if (fnArgs === null) this[fnId](i);
                    else this[fnId](i, ...fnArgs);
                } else for (const depObjId of fnArgs){
                    this.dependencyTracker?.recordNamedData(depObjId, i);
                    const objsPool = depObjId.startsWith("g_") ? commonObjs : objs;
                    if (!objsPool.has(depObjId)) {
                        objsPool.get(depObjId, continueCallback);
                        return i;
                    }
                }
            }
            i++;
            if (i === argsArrayLen) return i;
            if (chunkOperations && ++steps > $b3a01b20dd2ade98$var$EXECUTION_STEPS) {
                if (Date.now() > endTime) {
                    continueCallback();
                    return i;
                }
                steps = 0;
            }
        }
    }
    #restoreInitialState() {
        while(this.stateStack.length || this.inSMaskMode)this.restore();
        this.current.activeSMask = null;
        this.ctx.restore();
        if (this.transparentCanvas) {
            this.ctx = this.compositeCtx;
            this.ctx.save();
            this.ctx.setTransform(1, 0, 0, 1, 0, 0);
            this.ctx.drawImage(this.transparentCanvas, 0, 0);
            this.ctx.restore();
            this.canvasFactory.destroy(this.transparentCanvasEntry);
            this.transparentCanvas = null;
            this.transparentCanvasEntry = null;
        }
    }
    endDrawing() {
        this.#restoreInitialState();
        for (const canvas of this.smaskGroupCanvases)this.canvasFactory.destroy(canvas);
        this.smaskGroupCanvases.length = 0;
        this.tempSMask = null;
        this.smaskStack.length = 0;
        this.cachedPatterns.clear();
        for (const cache of this._cachedBitmapsMap.values()){
            for (const canvas of cache.values())if (typeof HTMLCanvasElement !== "undefined" && canvas instanceof HTMLCanvasElement) canvas.width = canvas.height = 0;
            cache.clear();
        }
        this._cachedBitmapsMap.clear();
        this.#drawFilter();
    }
    #drawFilter() {
        if (this.pageColors) {
            const hcmFilterId = this.filterFactory.addHCMFilter(this.pageColors.foreground, this.pageColors.background);
            if (hcmFilterId !== "none") {
                const savedFilter = this.ctx.filter;
                this.ctx.filter = hcmFilterId;
                this.ctx.drawImage(this.ctx.canvas, 0, 0);
                this.ctx.filter = savedFilter;
            }
        }
    }
    _scaleImage(img, inverseTransform) {
        const width = img.width ?? img.displayWidth;
        const height = img.height ?? img.displayHeight;
        const widthScale = Math.max(Math.hypot(inverseTransform[0], inverseTransform[1]), 1);
        const heightScale = Math.max(Math.hypot(inverseTransform[2], inverseTransform[3]), 1);
        const scaleSteps = [];
        let ws = widthScale, hs = heightScale, pw = width, ph = height;
        while(ws > 2 && pw > 1 || hs > 2 && ph > 1){
            let nw = pw, nh = ph;
            if (ws > 2 && pw > 1) {
                nw = pw >= 16384 ? Math.floor(pw / 2) - 1 || 1 : Math.ceil(pw / 2);
                ws /= pw / nw;
            }
            if (hs > 2 && ph > 1) {
                nh = ph >= 16384 ? Math.floor(ph / 2) - 1 || 1 : Math.ceil(ph) / 2;
                hs /= ph / nh;
            }
            scaleSteps.push({
                newWidth: nw,
                newHeight: nh
            });
            pw = nw;
            ph = nh;
        }
        if (scaleSteps.length === 0) return {
            img: img,
            paintWidth: width,
            paintHeight: height,
            tmpCanvas: null
        };
        if (scaleSteps.length === 1) {
            const { newWidth: newWidth, newHeight: newHeight } = scaleSteps[0];
            const tmpCanvas = this.canvasFactory.create(newWidth, newHeight);
            tmpCanvas.context.drawImage(img, 0, 0, width, height, 0, 0, newWidth, newHeight);
            return {
                img: tmpCanvas.canvas,
                paintWidth: newWidth,
                paintHeight: newHeight,
                tmpCanvas: tmpCanvas
            };
        }
        let readEntry = this.canvasFactory.create(1, 1);
        let writeEntry = this.canvasFactory.create(1, 1);
        let paintWidth = width, paintHeight = height;
        let source = img;
        for (const { newWidth: newWidth, newHeight: newHeight } of scaleSteps){
            this.canvasFactory.reset(writeEntry, newWidth, newHeight);
            writeEntry.context.drawImage(source, 0, 0, paintWidth, paintHeight, 0, 0, newWidth, newHeight);
            [readEntry, writeEntry] = [
                writeEntry,
                readEntry
            ];
            source = readEntry.canvas;
            paintWidth = newWidth;
            paintHeight = newHeight;
        }
        this.canvasFactory.destroy(writeEntry);
        return {
            img: readEntry.canvas,
            paintWidth: paintWidth,
            paintHeight: paintHeight,
            tmpCanvas: readEntry
        };
    }
    _createMaskCanvas(opIdx, img) {
        const ctx = this.ctx;
        const { width: width, height: height } = img;
        const fillColor = this.current.fillColor;
        const isPatternFill = this.current.patternFill;
        const currentTransform = $b3a01b20dd2ade98$var$getCurrentTransform(ctx);
        let cache, cacheKey, scaled, maskCanvas;
        if ((img.bitmap || img.data) && img.count > 1) {
            const mainKey = img.bitmap || img.data.buffer;
            cacheKey = JSON.stringify(isPatternFill ? currentTransform : [
                currentTransform.slice(0, 4),
                fillColor
            ]);
            cache = this._cachedBitmapsMap.getOrInsertComputed(mainKey, $b3a01b20dd2ade98$export$b41394a5437791c8);
            const cachedImage = cache.get(cacheKey);
            if (cachedImage && !isPatternFill) {
                const offsetX = Math.round(Math.min(currentTransform[0], currentTransform[2]) + currentTransform[4]);
                const offsetY = Math.round(Math.min(currentTransform[1], currentTransform[3]) + currentTransform[5]);
                this.dependencyTracker?.recordDependencies(opIdx, $b3a01b20dd2ade98$var$Dependencies.transformAndFill);
                return {
                    canvas: cachedImage,
                    offsetX: offsetX,
                    offsetY: offsetY
                };
            }
            scaled = cachedImage;
        }
        if (!scaled) {
            maskCanvas = this.canvasFactory.create(width, height);
            $b3a01b20dd2ade98$var$putBinaryImageMask(maskCanvas.context, img);
        }
        let maskToCanvas = $b3a01b20dd2ade98$export$f8f26dd395d7e1bd.transform(currentTransform, [
            1 / width,
            0,
            0,
            -1 / height,
            0,
            0
        ]);
        maskToCanvas = $b3a01b20dd2ade98$export$f8f26dd395d7e1bd.transform(maskToCanvas, [
            1,
            0,
            0,
            1,
            0,
            -height
        ]);
        const minMax = $b3a01b20dd2ade98$var$MIN_MAX_INIT.slice();
        $b3a01b20dd2ade98$export$f8f26dd395d7e1bd.axialAlignedBoundingBox([
            0,
            0,
            width,
            height
        ], maskToCanvas, minMax);
        const [minX, minY, maxX, maxY] = minMax;
        const drawnWidth = Math.round(maxX - minX) || 1;
        const drawnHeight = Math.round(maxY - minY) || 1;
        const fillCanvas = this.canvasFactory.create(drawnWidth, drawnHeight);
        const fillCtx = fillCanvas.context;
        const offsetX = minX;
        const offsetY = minY;
        fillCtx.translate(-offsetX, -offsetY);
        fillCtx.transform(...maskToCanvas);
        let scaledEntry = null;
        if (!scaled) {
            const scaleResult = this._scaleImage(maskCanvas.canvas, $b3a01b20dd2ade98$var$getCurrentTransformInverse(fillCtx));
            scaled = scaleResult.img;
            scaledEntry = scaleResult.tmpCanvas;
            if (scaled !== maskCanvas.canvas) {
                this.canvasFactory.destroy(maskCanvas);
                maskCanvas = null;
            }
            if (cache && isPatternFill) {
                cache.set(cacheKey, scaled);
                scaledEntry = null;
                maskCanvas = null;
            }
        }
        fillCtx.imageSmoothingEnabled = $b3a01b20dd2ade98$var$getImageSmoothingEnabled($b3a01b20dd2ade98$var$getCurrentTransform(fillCtx), img.interpolate);
        $b3a01b20dd2ade98$var$drawImageAtIntegerCoords(fillCtx, scaled, 0, 0, scaled.width, scaled.height, 0, 0, width, height);
        if (scaledEntry) this.canvasFactory.destroy(scaledEntry);
        if (maskCanvas) this.canvasFactory.destroy(maskCanvas);
        fillCtx.globalCompositeOperation = "source-in";
        const inverse = $b3a01b20dd2ade98$export$f8f26dd395d7e1bd.transform($b3a01b20dd2ade98$var$getCurrentTransformInverse(fillCtx), [
            1,
            0,
            0,
            1,
            -offsetX,
            -offsetY
        ]);
        fillCtx.fillStyle = isPatternFill ? fillColor.getPattern(ctx, this, inverse, $b3a01b20dd2ade98$var$PathType.FILL, opIdx) : fillColor;
        fillCtx.fillRect(0, 0, width, height);
        if (cache && !isPatternFill) cache.set(cacheKey, fillCanvas.canvas);
        this.dependencyTracker?.recordDependencies(opIdx, $b3a01b20dd2ade98$var$Dependencies.transformAndFill);
        return {
            canvas: fillCanvas.canvas,
            canvasEntry: cache && !isPatternFill ? null : fillCanvas,
            offsetX: Math.round(offsetX),
            offsetY: Math.round(offsetY)
        };
    }
    setLineWidth(opIdx, width) {
        this.dependencyTracker?.recordSimpleData("lineWidth", opIdx);
        if (width !== this.current.lineWidth) this._cachedScaleForStroking[0] = -1;
        this.current.lineWidth = width;
        this.ctx.lineWidth = width;
    }
    setLineCap(opIdx, style) {
        this.dependencyTracker?.recordSimpleData("lineCap", opIdx);
        this.ctx.lineCap = $b3a01b20dd2ade98$var$LINE_CAP_STYLES[style];
    }
    setLineJoin(opIdx, style) {
        this.dependencyTracker?.recordSimpleData("lineJoin", opIdx);
        this.ctx.lineJoin = $b3a01b20dd2ade98$var$LINE_JOIN_STYLES[style];
    }
    setMiterLimit(opIdx, limit) {
        this.dependencyTracker?.recordSimpleData("miterLimit", opIdx);
        this.ctx.miterLimit = limit;
    }
    setDash(opIdx, dashArray, dashPhase) {
        this.dependencyTracker?.recordSimpleData("dash", opIdx);
        const ctx = this.ctx;
        if (ctx.setLineDash !== undefined) {
            ctx.setLineDash(dashArray);
            ctx.lineDashOffset = dashPhase;
        }
    }
    setRenderingIntent(opIdx, intent) {}
    setFlatness(opIdx, flatness) {}
    setGState(opIdx, states) {
        for (const [key, value] of states)switch(key){
            case "LW":
                this.setLineWidth(opIdx, value);
                break;
            case "LC":
                this.setLineCap(opIdx, value);
                break;
            case "LJ":
                this.setLineJoin(opIdx, value);
                break;
            case "ML":
                this.setMiterLimit(opIdx, value);
                break;
            case "D":
                this.setDash(opIdx, value[0], value[1]);
                break;
            case "RI":
                this.setRenderingIntent(opIdx, value);
                break;
            case "FL":
                this.setFlatness(opIdx, value);
                break;
            case "Font":
                this.setFont(opIdx, value[0], value[1]);
                break;
            case "CA":
                this.dependencyTracker?.recordSimpleData("strokeAlpha", opIdx);
                this.current.strokeAlpha = value;
                break;
            case "ca":
                this.dependencyTracker?.recordSimpleData("fillAlpha", opIdx);
                this.ctx.globalAlpha = this.current.fillAlpha = value;
                break;
            case "BM":
                this.dependencyTracker?.recordSimpleData("globalCompositeOperation", opIdx);
                this.ctx.globalCompositeOperation = value;
                break;
            case "SMask":
                this.dependencyTracker?.recordSimpleData("SMask", opIdx);
                this.current.activeSMask = value ? this.tempSMask : null;
                this.tempSMask = null;
                this.checkSMaskState();
                break;
            case "TR":
                this.dependencyTracker?.recordSimpleData("filter", opIdx);
                this.ctx.filter = this.current.transferMaps = this.filterFactory.addFilter(value);
                break;
        }
    }
    get inSMaskMode() {
        return !!this.suspendedCtx;
    }
    checkSMaskState() {
        const inSMaskMode = this.inSMaskMode;
        if (this.current.activeSMask && !inSMaskMode) this.beginSMaskMode();
        else if (!this.current.activeSMask && inSMaskMode) this.endSMaskMode();
    }
    beginSMaskMode(opIdx) {
        if (this.inSMaskMode) throw new Error("beginSMaskMode called while already in smask mode");
        const drawnWidth = this.ctx.canvas.width;
        const drawnHeight = this.ctx.canvas.height;
        const scratchCanvas = this.canvasFactory.create(drawnWidth, drawnHeight);
        this.smaskScratchCanvas = scratchCanvas;
        this.suspendedCtx = this.ctx;
        const ctx = this.ctx = scratchCanvas.context;
        ctx.setTransform(this.suspendedCtx.getTransform());
        $b3a01b20dd2ade98$var$copyCtxState(this.suspendedCtx, ctx);
        $b3a01b20dd2ade98$var$mirrorContextOperations(ctx, this.suspendedCtx);
        this.setGState(opIdx, [
            [
                "BM",
                "source-over"
            ]
        ]);
    }
    endSMaskMode() {
        if (!this.inSMaskMode) throw new Error("endSMaskMode called while not in smask mode");
        this.ctx._removeMirroring();
        $b3a01b20dd2ade98$var$copyCtxState(this.ctx, this.suspendedCtx);
        this.ctx = this.suspendedCtx;
        this.suspendedCtx = null;
        this.canvasFactory.destroy(this.smaskScratchCanvas);
        this.smaskScratchCanvas = null;
    }
    compose(dirtyBox) {
        if (!this.current.activeSMask) return;
        if (!dirtyBox) dirtyBox = [
            0,
            0,
            this.ctx.canvas.width,
            this.ctx.canvas.height
        ];
        else {
            dirtyBox[0] = Math.floor(dirtyBox[0]);
            dirtyBox[1] = Math.floor(dirtyBox[1]);
            dirtyBox[2] = Math.ceil(dirtyBox[2]);
            dirtyBox[3] = Math.ceil(dirtyBox[3]);
        }
        const smask = this.current.activeSMask;
        const suspendedCtx = this.suspendedCtx;
        this.composeSMask(suspendedCtx, smask, this.ctx, dirtyBox);
        this.ctx.save();
        this.ctx.setTransform(1, 0, 0, 1, 0, 0);
        this.ctx.clearRect(0, 0, this.ctx.canvas.width, this.ctx.canvas.height);
        this.ctx.restore();
    }
    composeSMask(ctx, smask, layerCtx, layerBox) {
        const layerOffsetX = layerBox[0];
        const layerOffsetY = layerBox[1];
        const layerWidth = layerBox[2] - layerOffsetX;
        const layerHeight = layerBox[3] - layerOffsetY;
        if (layerWidth === 0 || layerHeight === 0) return;
        this.genericComposeSMask(smask.context, layerCtx, layerWidth, layerHeight, smask.subtype, smask.backdrop, smask.transferMap, layerOffsetX, layerOffsetY, smask.offsetX, smask.offsetY);
        ctx.save();
        ctx.globalAlpha = 1;
        ctx.globalCompositeOperation = "source-over";
        ctx.setTransform(1, 0, 0, 1, 0, 0);
        ctx.drawImage(layerCtx.canvas, 0, 0);
        ctx.restore();
    }
    genericComposeSMask(maskCtx, layerCtx, width, height, subtype, backdrop, transferMap, layerOffsetX, layerOffsetY, maskOffsetX, maskOffsetY) {
        let maskCanvas = maskCtx.canvas;
        let maskX = layerOffsetX - maskOffsetX;
        let maskY = layerOffsetY - maskOffsetY;
        let maskExtensionEntry = null;
        if (backdrop) {
            if (maskX < 0 || maskY < 0 || maskX + width > maskCanvas.width || maskY + height > maskCanvas.height) {
                maskExtensionEntry = this.canvasFactory.create(width, height);
                const ctx = maskExtensionEntry.context;
                ctx.drawImage(maskCanvas, -maskX, -maskY);
                ctx.globalCompositeOperation = "destination-atop";
                ctx.fillStyle = backdrop;
                ctx.fillRect(0, 0, width, height);
                ctx.globalCompositeOperation = "source-over";
                maskCanvas = maskExtensionEntry.canvas;
                maskX = maskY = 0;
            } else {
                maskCtx.save();
                maskCtx.globalAlpha = 1;
                maskCtx.setTransform(1, 0, 0, 1, 0, 0);
                const clip = new Path2D();
                clip.rect(maskX, maskY, width, height);
                maskCtx.clip(clip);
                maskCtx.globalCompositeOperation = "destination-atop";
                maskCtx.fillStyle = backdrop;
                maskCtx.fillRect(maskX, maskY, width, height);
                maskCtx.restore();
            }
        }
        layerCtx.save();
        layerCtx.globalAlpha = 1;
        layerCtx.setTransform(1, 0, 0, 1, 0, 0);
        if (subtype === "Alpha" && transferMap) layerCtx.filter = this.filterFactory.addAlphaFilter(transferMap);
        else if (subtype === "Luminosity") layerCtx.filter = this.filterFactory.addLuminosityFilter(transferMap);
        const clip = new Path2D();
        clip.rect(layerOffsetX, layerOffsetY, width, height);
        layerCtx.clip(clip);
        layerCtx.globalCompositeOperation = "destination-in";
        layerCtx.drawImage(maskCanvas, maskX, maskY, width, height, layerOffsetX, layerOffsetY, width, height);
        layerCtx.restore();
        if (maskExtensionEntry) this.canvasFactory.destroy(maskExtensionEntry);
    }
    save(opIdx) {
        if (this.inSMaskMode) $b3a01b20dd2ade98$var$copyCtxState(this.ctx, this.suspendedCtx);
        this.ctx.save();
        const old = this.current;
        this.stateStack.push(old);
        this.current = old.clone();
        this.dependencyTracker?.save(opIdx);
    }
    restore(opIdx) {
        this.dependencyTracker?.restore(opIdx);
        if (this.stateStack.length === 0) {
            if (this.inSMaskMode) this.endSMaskMode();
            return;
        }
        this.current = this.stateStack.pop();
        this.ctx.restore();
        if (this.inSMaskMode) $b3a01b20dd2ade98$var$copyCtxState(this.suspendedCtx, this.ctx);
        this.checkSMaskState();
        this.pendingClip = null;
        this._cachedScaleForStroking[0] = -1;
        this._cachedGetSinglePixelWidth = null;
    }
    transform(opIdx, a, b, c, d, e, f) {
        this.dependencyTracker?.recordIncrementalData("transform", opIdx);
        this.ctx.transform(a, b, c, d, e, f);
        this._cachedScaleForStroking[0] = -1;
        this._cachedGetSinglePixelWidth = null;
    }
    constructPath(opIdx, op, data, minMax) {
        let [path] = data;
        if (!minMax) {
            path ||= data[0] = new Path2D();
            this[op](opIdx, path);
            return;
        }
        if (this.dependencyTracker !== null) {
            const outerExtraSize = op === $b3a01b20dd2ade98$export$3a0f7f7a8a0b306b.stroke ? this.current.lineWidth / 2 : 0;
            this.dependencyTracker.resetBBox(opIdx).recordBBox(opIdx, this.ctx, minMax[0] - outerExtraSize, minMax[2] + outerExtraSize, minMax[1] - outerExtraSize, minMax[3] + outerExtraSize).recordDependencies(opIdx, [
                "transform"
            ]);
        }
        if (!(path instanceof Path2D)) path = data[0] = $b3a01b20dd2ade98$var$makePathFromDrawOPS(path);
        $b3a01b20dd2ade98$export$f8f26dd395d7e1bd.axialAlignedBoundingBox(minMax, $b3a01b20dd2ade98$var$getCurrentTransform(this.ctx), this.current.minMax);
        this[op](opIdx, path);
        this._pathStartIdx = opIdx;
    }
    closePath(opIdx) {
        this.ctx.closePath();
    }
    stroke(opIdx, path, consumePath = true) {
        const ctx = this.ctx;
        const strokeColor = this.current.strokeColor;
        ctx.globalAlpha = this.current.strokeAlpha;
        if (this.contentVisible) {
            if (typeof strokeColor === "object" && strokeColor?.getPattern) {
                const baseTransform = strokeColor.isModifyingCurrentTransform() ? ctx.getTransform() : null;
                ctx.save();
                ctx.strokeStyle = strokeColor.getPattern(ctx, this, $b3a01b20dd2ade98$var$getCurrentTransformInverse(ctx), $b3a01b20dd2ade98$var$PathType.STROKE, opIdx);
                if (baseTransform) {
                    const newPath = new Path2D();
                    newPath.addPath(path, ctx.getTransform().invertSelf().multiplySelf(baseTransform));
                    path = newPath;
                }
                this.rescaleAndStroke(path, false);
                ctx.restore();
            } else this.rescaleAndStroke(path, true);
        }
        this.dependencyTracker?.recordDependencies(opIdx, $b3a01b20dd2ade98$var$Dependencies.stroke);
        if (consumePath) this.consumePath(opIdx, path, this.current.getClippedPathBoundingBox($b3a01b20dd2ade98$var$PathType.STROKE, $b3a01b20dd2ade98$var$getCurrentTransform(this.ctx)));
        ctx.globalAlpha = this.current.fillAlpha;
    }
    closeStroke(opIdx, path) {
        this.stroke(opIdx, path);
    }
    fill(opIdx, path, consumePath = true) {
        const ctx = this.ctx;
        const fillColor = this.current.fillColor;
        const isPatternFill = this.current.patternFill;
        let needRestore = false;
        if (isPatternFill) {
            const baseTransform = fillColor.isModifyingCurrentTransform() ? ctx.getTransform() : null;
            this.dependencyTracker?.save(opIdx);
            ctx.save();
            ctx.fillStyle = fillColor.getPattern(ctx, this, $b3a01b20dd2ade98$var$getCurrentTransformInverse(ctx), $b3a01b20dd2ade98$var$PathType.FILL, opIdx);
            if (baseTransform) {
                const newPath = new Path2D();
                newPath.addPath(path, ctx.getTransform().invertSelf().multiplySelf(baseTransform));
                path = newPath;
            }
            needRestore = true;
        }
        const intersect = this.current.getClippedPathBoundingBox();
        if (this.contentVisible && intersect !== null) {
            if (this.pendingEOFill) {
                ctx.fill(path, "evenodd");
                this.pendingEOFill = false;
            } else ctx.fill(path);
        }
        this.dependencyTracker?.recordDependencies(opIdx, $b3a01b20dd2ade98$var$Dependencies.fill);
        if (needRestore) {
            ctx.restore();
            this.dependencyTracker?.restore(opIdx);
        }
        if (consumePath) this.consumePath(opIdx, path, intersect);
    }
    eoFill(opIdx, path) {
        this.pendingEOFill = true;
        this.fill(opIdx, path);
    }
    fillStroke(opIdx, path) {
        this.fill(opIdx, path, false);
        this.stroke(opIdx, path, false);
        this.consumePath(opIdx, path);
    }
    eoFillStroke(opIdx, path) {
        this.pendingEOFill = true;
        this.fillStroke(opIdx, path);
    }
    closeFillStroke(opIdx, path) {
        this.fillStroke(opIdx, path);
    }
    closeEOFillStroke(opIdx, path) {
        this.pendingEOFill = true;
        this.fillStroke(opIdx, path);
    }
    endPath(opIdx, path) {
        this.consumePath(opIdx, path);
    }
    rawFillPath(opIdx, path) {
        this.ctx.fill(path);
        this.dependencyTracker?.recordDependencies(opIdx, $b3a01b20dd2ade98$var$Dependencies.rawFillPath).recordOperation(opIdx);
    }
    clip(opIdx) {
        this.dependencyTracker?.recordFutureForcedDependency("clipMode", opIdx);
        this.pendingClip = $b3a01b20dd2ade98$var$NORMAL_CLIP;
    }
    eoClip(opIdx) {
        this.dependencyTracker?.recordFutureForcedDependency("clipMode", opIdx);
        this.pendingClip = $b3a01b20dd2ade98$var$EO_CLIP;
    }
    beginText(opIdx) {
        this.current.textMatrix = null;
        this.current.textMatrixScale = 1;
        this.current.x = this.current.lineX = 0;
        this.current.y = this.current.lineY = 0;
        this.dependencyTracker?.recordOpenMarker(opIdx).resetIncrementalData("sameLineText").resetIncrementalData("moveText", opIdx);
    }
    endText(opIdx) {
        const paths = this.pendingTextPaths;
        const ctx = this.ctx;
        if (this.dependencyTracker) {
            const { dependencyTracker: dependencyTracker } = this;
            if (paths !== undefined) dependencyTracker.recordFutureForcedDependency("textClip", dependencyTracker.getOpenMarker()).recordFutureForcedDependency("textClip", opIdx);
            dependencyTracker.recordCloseMarker(opIdx);
        }
        if (paths !== undefined) {
            const newPath = new Path2D();
            const invTransf = ctx.getTransform().invertSelf();
            for (const { transform: transform, x: x, y: y, fontSize: fontSize, path: path } of paths){
                if (!path) continue;
                newPath.addPath(path, new DOMMatrix(transform).preMultiplySelf(invTransf).translate(x, y).scale(fontSize, -fontSize));
            }
            ctx.clip(newPath);
        }
        delete this.pendingTextPaths;
    }
    setCharSpacing(opIdx, spacing) {
        this.dependencyTracker?.recordSimpleData("charSpacing", opIdx);
        this.current.charSpacing = spacing;
    }
    setWordSpacing(opIdx, spacing) {
        this.dependencyTracker?.recordSimpleData("wordSpacing", opIdx);
        this.current.wordSpacing = spacing;
    }
    setHScale(opIdx, scale) {
        this.dependencyTracker?.recordSimpleData("hScale", opIdx);
        this.current.textHScale = scale / 100;
    }
    setLeading(opIdx, leading) {
        this.dependencyTracker?.recordSimpleData("leading", opIdx);
        this.current.leading = -leading;
    }
    setFont(opIdx, fontRefName, size) {
        this.dependencyTracker?.recordSimpleData("font", opIdx).recordSimpleDataFromNamed("fontObj", fontRefName, opIdx);
        const fontObj = this.commonObjs.get(fontRefName);
        const current = this.current;
        if (!fontObj) throw new Error(`Can't find font for ${fontRefName}`);
        current.fontMatrix = fontObj.fontMatrix || $b3a01b20dd2ade98$var$FONT_IDENTITY_MATRIX;
        if (current.fontMatrix[0] === 0 || current.fontMatrix[3] === 0) $b3a01b20dd2ade98$var$warn("Invalid font matrix for font " + fontRefName);
        if (size < 0) {
            size = -size;
            current.fontDirection = -1;
        } else current.fontDirection = 1;
        this.current.font = fontObj;
        this.current.fontSize = size;
        if (fontObj.isType3Font) return;
        const name = fontObj.loadedName || "sans-serif";
        const typeface = fontObj.systemFontInfo?.css || `"${name}", ${fontObj.fallbackName}`;
        let bold = "normal";
        if (fontObj.black) bold = "900";
        else if (fontObj.bold) bold = "bold";
        const italic = fontObj.italic ? "italic" : "normal";
        let browserFontSize = size;
        if (size < $b3a01b20dd2ade98$var$MIN_FONT_SIZE) browserFontSize = $b3a01b20dd2ade98$var$MIN_FONT_SIZE;
        else if (size > $b3a01b20dd2ade98$var$MAX_FONT_SIZE) browserFontSize = $b3a01b20dd2ade98$var$MAX_FONT_SIZE;
        this.current.fontSizeScale = size / browserFontSize;
        this.ctx.font = `${italic} ${bold} ${browserFontSize}px ${typeface}`;
    }
    setTextRenderingMode(opIdx, mode) {
        this.dependencyTracker?.recordSimpleData("textRenderingMode", opIdx);
        this.current.textRenderingMode = mode;
    }
    setTextRise(opIdx, rise) {
        this.dependencyTracker?.recordSimpleData("textRise", opIdx);
        this.current.textRise = rise;
    }
    moveText(opIdx, x, y) {
        this.dependencyTracker?.resetIncrementalData("sameLineText").recordIncrementalData("moveText", opIdx);
        this.current.x = this.current.lineX += x;
        this.current.y = this.current.lineY += y;
    }
    setLeadingMoveText(opIdx, x, y) {
        this.setLeading(opIdx, -y);
        this.moveText(opIdx, x, y);
    }
    setTextMatrix(opIdx, matrix) {
        this.dependencyTracker?.resetIncrementalData("sameLineText").recordSimpleData("textMatrix", opIdx);
        const { current: current } = this;
        current.textMatrix = matrix;
        current.textMatrixScale = Math.hypot(matrix[0], matrix[1]);
        current.x = current.lineX = 0;
        current.y = current.lineY = 0;
    }
    nextLine(opIdx) {
        this.moveText(opIdx, 0, this.current.leading);
        this.dependencyTracker?.recordIncrementalData("moveText", this.dependencyTracker.getSimpleIndex("leading") ?? opIdx);
    }
    #getScaledPath(path, currentTransform, transform) {
        const newPath = new Path2D();
        newPath.addPath(path, new DOMMatrix(transform).invertSelf().multiplySelf(currentTransform));
        return newPath;
    }
    paintChar(opIdx, character, x, y, patternFillTransform, patternStrokeTransform) {
        const ctx = this.ctx;
        const current = this.current;
        const font = current.font;
        const textRenderingMode = current.textRenderingMode;
        const fontSize = current.fontSize / current.fontSizeScale;
        const fillStrokeMode = textRenderingMode & $b3a01b20dd2ade98$var$TextRenderingMode.FILL_STROKE_MASK;
        const isAddToPathSet = !!(textRenderingMode & $b3a01b20dd2ade98$var$TextRenderingMode.ADD_TO_PATH_FLAG);
        const patternFill = current.patternFill && !font.missingFile;
        const patternStroke = current.patternStroke && !font.missingFile;
        let path;
        if ((font.disableFontFace || isAddToPathSet || patternFill || patternStroke) && !font.missingFile) path = font.getPathGenerator(this.commonObjs, character);
        if (path && (font.disableFontFace || patternFill || patternStroke)) {
            ctx.save();
            ctx.translate(x, y);
            ctx.scale(fontSize, -fontSize);
            this.dependencyTracker?.recordCharacterBBox(opIdx, ctx, font);
            let currentTransform;
            if (fillStrokeMode === $b3a01b20dd2ade98$var$TextRenderingMode.FILL || fillStrokeMode === $b3a01b20dd2ade98$var$TextRenderingMode.FILL_STROKE) {
                if (patternFillTransform) {
                    currentTransform = ctx.getTransform();
                    ctx.setTransform(...patternFillTransform);
                    const scaledPath = this.#getScaledPath(path, currentTransform, patternFillTransform);
                    ctx.fill(scaledPath);
                } else ctx.fill(path);
            }
            if (fillStrokeMode === $b3a01b20dd2ade98$var$TextRenderingMode.STROKE || fillStrokeMode === $b3a01b20dd2ade98$var$TextRenderingMode.FILL_STROKE) {
                if (patternStrokeTransform) {
                    currentTransform ||= ctx.getTransform();
                    ctx.setTransform(...patternStrokeTransform);
                    const { a: a, b: b, c: c, d: d } = currentTransform;
                    const invPatternTransform = $b3a01b20dd2ade98$export$f8f26dd395d7e1bd.inverseTransform(patternStrokeTransform);
                    const transf = $b3a01b20dd2ade98$export$f8f26dd395d7e1bd.transform([
                        a,
                        b,
                        c,
                        d,
                        0,
                        0
                    ], invPatternTransform);
                    $b3a01b20dd2ade98$export$f8f26dd395d7e1bd.singularValueDecompose2dScale(transf, $b3a01b20dd2ade98$var$XY);
                    ctx.lineWidth *= Math.max($b3a01b20dd2ade98$var$XY[0], $b3a01b20dd2ade98$var$XY[1]) / fontSize;
                    ctx.stroke(this.#getScaledPath(path, currentTransform, patternStrokeTransform));
                } else {
                    ctx.lineWidth /= fontSize;
                    ctx.stroke(path);
                }
            }
            ctx.restore();
        } else {
            if (fillStrokeMode === $b3a01b20dd2ade98$var$TextRenderingMode.FILL || fillStrokeMode === $b3a01b20dd2ade98$var$TextRenderingMode.FILL_STROKE) {
                ctx.fillText(character, x, y);
                this.dependencyTracker?.recordCharacterBBox(opIdx, ctx, font, fontSize, x, y, ()=>ctx.measureText(character));
            }
            if (fillStrokeMode === $b3a01b20dd2ade98$var$TextRenderingMode.STROKE || fillStrokeMode === $b3a01b20dd2ade98$var$TextRenderingMode.FILL_STROKE) {
                if (this.dependencyTracker) this.dependencyTracker?.recordCharacterBBox(opIdx, ctx, font, fontSize, x, y, ()=>ctx.measureText(character)).recordDependencies(opIdx, $b3a01b20dd2ade98$var$Dependencies.stroke);
                ctx.strokeText(character, x, y);
            }
        }
        if (isAddToPathSet) {
            const paths = this.pendingTextPaths ||= [];
            paths.push({
                transform: $b3a01b20dd2ade98$var$getCurrentTransform(ctx),
                x: x,
                y: y,
                fontSize: fontSize,
                path: path
            });
            this.dependencyTracker?.recordCharacterBBox(opIdx, ctx, font, fontSize, x, y);
        }
    }
    get isFontSubpixelAAEnabled() {
        const tmpCanvas = this.canvasFactory.create(10, 10);
        const ctx = tmpCanvas.context;
        ctx.scale(1.5, 1);
        ctx.fillText("I", 0, 10);
        const data = ctx.getImageData(0, 0, 10, 10).data;
        this.canvasFactory.destroy(tmpCanvas);
        let enabled = false;
        for(let i = 3; i < data.length; i += 4)if (data[i] > 0 && data[i] < 255) {
            enabled = true;
            break;
        }
        return $b3a01b20dd2ade98$export$b8972b998723d602(this, "isFontSubpixelAAEnabled", enabled);
    }
    showText(opIdx, glyphs) {
        if (this.dependencyTracker) {
            this.dependencyTracker.recordDependencies(opIdx, $b3a01b20dd2ade98$var$Dependencies.showText).resetBBox(opIdx);
            if (this.current.textRenderingMode & $b3a01b20dd2ade98$var$TextRenderingMode.ADD_TO_PATH_FLAG) this.dependencyTracker.recordFutureForcedDependency("textClip", opIdx).inheritPendingDependenciesAsFutureForcedDependencies();
        }
        const current = this.current;
        const font = current.font;
        if (font.isType3Font) {
            this.showType3Text(opIdx, glyphs);
            this.dependencyTracker?.recordShowTextOperation(opIdx);
            return undefined;
        }
        const fontSize = current.fontSize;
        if (fontSize === 0) {
            this.dependencyTracker?.recordOperation(opIdx);
            return undefined;
        }
        const ctx = this.ctx;
        const fontSizeScale = current.fontSizeScale;
        const charSpacing = current.charSpacing;
        const wordSpacing = current.wordSpacing;
        const fontDirection = current.fontDirection;
        const textHScale = current.textHScale * fontDirection;
        const glyphsLength = glyphs.length;
        const vertical = font.vertical;
        const spacingDir = vertical ? 1 : -1;
        const defaultVMetrics = font.defaultVMetrics;
        const widthAdvanceScale = fontSize * current.fontMatrix[0];
        const simpleFillText = current.textRenderingMode === $b3a01b20dd2ade98$var$TextRenderingMode.FILL && !font.disableFontFace && !current.patternFill;
        ctx.save();
        if (current.textMatrix) ctx.transform(...current.textMatrix);
        ctx.translate(current.x, current.y + current.textRise);
        if (fontDirection > 0) ctx.scale(textHScale, -1);
        else ctx.scale(textHScale, 1);
        let patternFillTransform, patternStrokeTransform;
        const fillStrokeMode = current.textRenderingMode & $b3a01b20dd2ade98$var$TextRenderingMode.FILL_STROKE_MASK;
        const needsFill = fillStrokeMode === $b3a01b20dd2ade98$var$TextRenderingMode.FILL || fillStrokeMode === $b3a01b20dd2ade98$var$TextRenderingMode.FILL_STROKE;
        const needsStroke = fillStrokeMode === $b3a01b20dd2ade98$var$TextRenderingMode.STROKE || fillStrokeMode === $b3a01b20dd2ade98$var$TextRenderingMode.FILL_STROKE;
        if (needsFill && current.patternFill) {
            ctx.save();
            const pattern = current.fillColor.getPattern(ctx, this, $b3a01b20dd2ade98$var$getCurrentTransformInverse(ctx), $b3a01b20dd2ade98$var$PathType.FILL, opIdx);
            patternFillTransform = $b3a01b20dd2ade98$var$getCurrentTransform(ctx);
            ctx.restore();
            ctx.fillStyle = pattern;
        }
        if (needsStroke && current.patternStroke) {
            ctx.save();
            const pattern = current.strokeColor.getPattern(ctx, this, $b3a01b20dd2ade98$var$getCurrentTransformInverse(ctx), $b3a01b20dd2ade98$var$PathType.STROKE, opIdx);
            patternStrokeTransform = $b3a01b20dd2ade98$var$getCurrentTransform(ctx);
            ctx.restore();
            ctx.strokeStyle = pattern;
        }
        let lineWidth = current.lineWidth;
        const scale = current.textMatrixScale;
        if (scale === 0 || lineWidth === 0) {
            if (needsStroke) lineWidth = this.getSinglePixelWidth();
        } else lineWidth /= scale;
        if (fontSizeScale !== 1.0) {
            ctx.scale(fontSizeScale, fontSizeScale);
            lineWidth /= fontSizeScale;
        }
        ctx.lineWidth = lineWidth;
        if (font.isInvalidPDFjsFont) {
            const chars = [];
            let width = 0;
            for (const glyph of glyphs){
                chars.push(glyph.unicode);
                width += glyph.width;
            }
            const joinedChars = chars.join("");
            ctx.fillText(joinedChars, 0, 0);
            if (this.dependencyTracker !== null) {
                const measure = ctx.measureText(joinedChars);
                this.dependencyTracker.recordBBox(opIdx, this.ctx, -measure.actualBoundingBoxLeft, measure.actualBoundingBoxRight, -measure.actualBoundingBoxAscent, measure.actualBoundingBoxDescent).recordShowTextOperation(opIdx);
            }
            current.x += width * widthAdvanceScale * textHScale;
            ctx.restore();
            this.compose();
            return undefined;
        }
        let x = 0, i;
        for(i = 0; i < glyphsLength; ++i){
            const glyph = glyphs[i];
            if (typeof glyph === "number") {
                x += spacingDir * glyph * fontSize / 1000;
                continue;
            }
            let restoreNeeded = false;
            const spacing = (glyph.isSpace ? wordSpacing : 0) + charSpacing;
            const character = glyph.fontChar;
            const accent = glyph.accent;
            let scaledX, scaledY;
            let width = glyph.width;
            if (vertical) {
                const vmetric = glyph.vmetric || defaultVMetrics;
                const vx = -(glyph.vmetric ? vmetric[1] : width * 0.5) * widthAdvanceScale;
                const vy = vmetric[2] * widthAdvanceScale;
                width = vmetric ? -vmetric[0] : width;
                scaledX = vx / fontSizeScale;
                scaledY = (x + vy) / fontSizeScale;
            } else {
                scaledX = x / fontSizeScale;
                scaledY = 0;
            }
            let measure;
            if (font.remeasure && width > 0) {
                measure = ctx.measureText(character);
                const measuredWidth = measure.width * 1000 / fontSize * fontSizeScale;
                if (width < measuredWidth && this.isFontSubpixelAAEnabled) {
                    const characterScaleX = width / measuredWidth;
                    restoreNeeded = true;
                    ctx.save();
                    ctx.scale(characterScaleX, 1);
                    scaledX /= characterScaleX;
                } else if (width !== measuredWidth) scaledX += (width - measuredWidth) / 2000 * fontSize / fontSizeScale;
            }
            if (this.contentVisible && (glyph.isInFont || font.missingFile)) {
                if (simpleFillText && !accent) {
                    ctx.fillText(character, scaledX, scaledY);
                    this.dependencyTracker?.recordCharacterBBox(opIdx, ctx, measure ? {
                        bbox: null
                    } : font, fontSize / fontSizeScale, scaledX, scaledY, ()=>measure ?? ctx.measureText(character));
                } else {
                    this.paintChar(opIdx, character, scaledX, scaledY, patternFillTransform, patternStrokeTransform);
                    if (accent) {
                        const scaledAccentX = scaledX + fontSize * accent.offset.x / fontSizeScale;
                        const scaledAccentY = scaledY - fontSize * accent.offset.y / fontSizeScale;
                        this.paintChar(opIdx, accent.fontChar, scaledAccentX, scaledAccentY, patternFillTransform, patternStrokeTransform);
                    }
                }
            }
            const charWidth = vertical ? width * widthAdvanceScale - spacing * fontDirection : width * widthAdvanceScale + spacing * fontDirection;
            x += charWidth;
            if (restoreNeeded) ctx.restore();
        }
        if (vertical) current.y -= x;
        else current.x += x * textHScale;
        ctx.restore();
        this.compose();
        this.dependencyTracker?.recordShowTextOperation(opIdx);
        return undefined;
    }
    showType3Text(opIdx, glyphs) {
        const ctx = this.ctx;
        const current = this.current;
        const font = current.font;
        const fontSize = current.fontSize;
        const fontDirection = current.fontDirection;
        const spacingDir = font.vertical ? 1 : -1;
        const charSpacing = current.charSpacing;
        const wordSpacing = current.wordSpacing;
        const textHScale = current.textHScale * fontDirection;
        const fontMatrix = current.fontMatrix || $b3a01b20dd2ade98$var$FONT_IDENTITY_MATRIX;
        const glyphsLength = glyphs.length;
        const isTextInvisible = current.textRenderingMode === $b3a01b20dd2ade98$var$TextRenderingMode.INVISIBLE;
        let i, glyph, width, spacingLength;
        if (isTextInvisible || fontSize === 0) return;
        this._cachedScaleForStroking[0] = -1;
        this._cachedGetSinglePixelWidth = null;
        ctx.save();
        if (current.textMatrix) ctx.transform(...current.textMatrix);
        ctx.translate(current.x, current.y + current.textRise);
        ctx.scale(textHScale, fontDirection);
        const dependencyTracker = this.dependencyTracker;
        this.dependencyTracker = dependencyTracker ? new $b3a01b20dd2ade98$var$CanvasNestedDependencyTracker(dependencyTracker, opIdx) : null;
        for(i = 0; i < glyphsLength; ++i){
            glyph = glyphs[i];
            if (typeof glyph === "number") {
                spacingLength = spacingDir * glyph * fontSize / 1000;
                this.ctx.translate(spacingLength, 0);
                current.x += spacingLength * textHScale;
                continue;
            }
            const spacing = (glyph.isSpace ? wordSpacing : 0) + charSpacing;
            const operatorList = font.charProcOperatorList[glyph.operatorListId];
            if (!operatorList) $b3a01b20dd2ade98$var$warn(`Type3 character "${glyph.operatorListId}" is not available.`);
            else if (this.contentVisible) {
                this.save();
                ctx.scale(fontSize, fontSize);
                ctx.transform(...fontMatrix);
                this.executeOperatorList(operatorList);
                this.restore();
            }
            const p = [
                glyph.width,
                0
            ];
            $b3a01b20dd2ade98$export$f8f26dd395d7e1bd.applyTransform(p, fontMatrix);
            width = p[0] * fontSize + spacing;
            ctx.translate(width, 0);
            current.x += width * textHScale;
        }
        ctx.restore();
        if (dependencyTracker) this.dependencyTracker = dependencyTracker;
    }
    setCharWidth(opIdx, xWidth, yWidth) {}
    setCharWidthAndBounds(opIdx, xWidth, yWidth, llx, lly, urx, ury) {
        const clip = new Path2D();
        clip.rect(llx, lly, urx - llx, ury - lly);
        this.ctx.clip(clip);
        this.dependencyTracker?.recordBBox(opIdx, this.ctx, llx, urx, lly, ury).recordClipBox(opIdx, this.ctx, llx, urx, lly, ury);
        this.endPath(opIdx);
    }
    getColorN_Pattern(opIdx, IR) {
        let pattern;
        if (IR[0] === "TilingPattern") {
            const baseTransform = this.baseTransform || $b3a01b20dd2ade98$var$getCurrentTransform(this.ctx);
            const canvasGraphicsFactory = {
                createCanvasGraphics: (ctx, renderingOpIdx)=>new $b3a01b20dd2ade98$var$CanvasGraphics(ctx, this.commonObjs, this.objs, this.canvasFactory, this.filterFactory, {
                        optionalContentConfig: this.optionalContentConfig,
                        markedContentStack: this.markedContentStack
                    }, undefined, undefined, this.dependencyTracker ? new $b3a01b20dd2ade98$var$CanvasNestedDependencyTracker(this.dependencyTracker, renderingOpIdx, true) : null)
            };
            pattern = new $b3a01b20dd2ade98$var$TilingPattern(IR, this.ctx, canvasGraphicsFactory, baseTransform);
        } else pattern = this._getPattern(opIdx, IR[1], IR[2]);
        return pattern;
    }
    setStrokeColorN(opIdx, ...args) {
        this.dependencyTracker?.recordSimpleData("strokeColor", opIdx);
        this.current.strokeColor = this.getColorN_Pattern(opIdx, args);
        this.current.patternStroke = true;
    }
    setFillColorN(opIdx, ...args) {
        this.dependencyTracker?.recordSimpleData("fillColor", opIdx);
        this.current.fillColor = this.getColorN_Pattern(opIdx, args);
        this.current.patternFill = true;
    }
    setStrokeRGBColor(opIdx, color) {
        this.dependencyTracker?.recordSimpleData("strokeColor", opIdx);
        this.ctx.strokeStyle = this.current.strokeColor = color;
        this.current.patternStroke = false;
    }
    setStrokeTransparent(opIdx) {
        this.dependencyTracker?.recordSimpleData("strokeColor", opIdx);
        this.ctx.strokeStyle = this.current.strokeColor = "transparent";
        this.current.patternStroke = false;
    }
    setFillRGBColor(opIdx, color) {
        this.dependencyTracker?.recordSimpleData("fillColor", opIdx);
        this.ctx.fillStyle = this.current.fillColor = color;
        this.current.patternFill = false;
    }
    setFillTransparent(opIdx) {
        this.dependencyTracker?.recordSimpleData("fillColor", opIdx);
        this.ctx.fillStyle = this.current.fillColor = "transparent";
        this.current.patternFill = false;
    }
    _getPattern(opIdx, objId, matrix = null) {
        let pattern;
        if (this.cachedPatterns.has(objId)) pattern = this.cachedPatterns.get(objId);
        else {
            pattern = $b3a01b20dd2ade98$var$getShadingPattern(this.getObject(opIdx, objId));
            this.cachedPatterns.set(objId, pattern);
        }
        if (matrix) pattern.matrix = matrix;
        return pattern;
    }
    shadingFill(opIdx, objId) {
        if (!this.contentVisible) return;
        const ctx = this.ctx;
        this.save(opIdx);
        const pattern = this._getPattern(opIdx, objId);
        ctx.fillStyle = pattern.getPattern(ctx, this, $b3a01b20dd2ade98$var$getCurrentTransformInverse(ctx), $b3a01b20dd2ade98$var$PathType.SHADING, opIdx);
        const inv = $b3a01b20dd2ade98$var$getCurrentTransformInverse(ctx);
        if (inv) {
            const { width: width, height: height } = ctx.canvas;
            const minMax = $b3a01b20dd2ade98$var$MIN_MAX_INIT.slice();
            $b3a01b20dd2ade98$export$f8f26dd395d7e1bd.axialAlignedBoundingBox([
                0,
                0,
                width,
                height
            ], inv, minMax);
            const [x0, y0, x1, y1] = minMax;
            this.ctx.fillRect(x0, y0, x1 - x0, y1 - y0);
        } else this.ctx.fillRect(-10000000000, -10000000000, 2e10, 2e10);
        this.dependencyTracker?.resetBBox(opIdx).recordFullPageBBox(opIdx).recordDependencies(opIdx, $b3a01b20dd2ade98$var$Dependencies.transform).recordDependencies(opIdx, $b3a01b20dd2ade98$var$Dependencies.fill).recordOperation(opIdx);
        this.compose(this.current.getClippedPathBoundingBox());
        this.restore(opIdx);
    }
    beginInlineImage() {
        $b3a01b20dd2ade98$var$unreachable("Should not call beginInlineImage");
    }
    beginImageData() {
        $b3a01b20dd2ade98$var$unreachable("Should not call beginImageData");
    }
    paintFormXObjectBegin(opIdx, matrix, bbox) {
        if (!this.contentVisible) return;
        this.save(opIdx);
        this.baseTransformStack.push(this.baseTransform);
        if (matrix) this.transform(opIdx, ...matrix);
        this.baseTransform = $b3a01b20dd2ade98$var$getCurrentTransform(this.ctx);
        if (bbox) {
            $b3a01b20dd2ade98$export$f8f26dd395d7e1bd.axialAlignedBoundingBox(bbox, this.baseTransform, this.current.minMax);
            const [x0, y0, x1, y1] = bbox;
            const clip = new Path2D();
            clip.rect(x0, y0, x1 - x0, y1 - y0);
            this.ctx.clip(clip);
            this.dependencyTracker?.recordClipBox(opIdx, this.ctx, x0, x1, y0, y1);
            this.endPath(opIdx);
        }
    }
    paintFormXObjectEnd(opIdx) {
        if (!this.contentVisible) return;
        this.restore(opIdx);
        this.baseTransform = this.baseTransformStack.pop();
    }
    beginGroup(opIdx, group) {
        if (!this.contentVisible) return;
        this.save(opIdx);
        if (this.inSMaskMode) {
            this.endSMaskMode();
            this.current.activeSMask = null;
        }
        const currentCtx = this.ctx;
        if (!group.isolated) $b3a01b20dd2ade98$var$info("TODO: Support non-isolated groups.");
        if (group.knockout) $b3a01b20dd2ade98$var$warn("Knockout groups not supported.");
        const currentTransform = $b3a01b20dd2ade98$var$getCurrentTransform(currentCtx);
        if (group.matrix) currentCtx.transform(...group.matrix);
        const canvasBounds = [
            0,
            0,
            currentCtx.canvas.width,
            currentCtx.canvas.height
        ];
        let bounds;
        if (group.bbox) {
            bounds = $b3a01b20dd2ade98$var$MIN_MAX_INIT.slice();
            $b3a01b20dd2ade98$export$f8f26dd395d7e1bd.axialAlignedBoundingBox(group.bbox, $b3a01b20dd2ade98$var$getCurrentTransform(currentCtx), bounds);
            bounds = $b3a01b20dd2ade98$export$f8f26dd395d7e1bd.intersect(bounds, canvasBounds) || [
                0,
                0,
                0,
                0
            ];
        } else bounds = canvasBounds;
        const offsetX = Math.floor(bounds[0]);
        const offsetY = Math.floor(bounds[1]);
        const drawnWidth = Math.max(Math.ceil(bounds[2]) - offsetX, 1);
        const drawnHeight = Math.max(Math.ceil(bounds[3]) - offsetY, 1);
        this.current.startNewPathAndClipBox([
            0,
            0,
            drawnWidth,
            drawnHeight
        ]);
        if (group.smask) this.smaskCounter++;
        const scratchCanvas = this.canvasFactory.create(drawnWidth, drawnHeight);
        if (group.smask) this.smaskGroupCanvases.push(scratchCanvas);
        const groupCtx = scratchCanvas.context;
        groupCtx.translate(-offsetX, -offsetY);
        groupCtx.transform(...currentTransform);
        if (group.bbox) {
            let clip = new Path2D();
            const [x0, y0, x1, y1] = group.bbox;
            clip.rect(x0, y0, x1 - x0, y1 - y0);
            if (group.matrix) {
                const path = new Path2D();
                path.addPath(clip, new DOMMatrix(group.matrix));
                clip = path;
            }
            groupCtx.clip(clip);
        }
        if (group.smask) this.smaskStack.push({
            canvas: scratchCanvas.canvas,
            context: groupCtx,
            offsetX: offsetX,
            offsetY: offsetY,
            subtype: group.smask.subtype,
            backdrop: group.smask.backdrop,
            transferMap: group.smask.transferMap || null,
            startTransformInverse: null
        });
        if (!group.smask || this.dependencyTracker) {
            currentCtx.setTransform(1, 0, 0, 1, 0, 0);
            currentCtx.translate(offsetX, offsetY);
            currentCtx.save();
        }
        $b3a01b20dd2ade98$var$copyCtxState(currentCtx, groupCtx);
        this.ctx = groupCtx;
        this.dependencyTracker?.inheritSimpleDataAsFutureForcedDependencies([
            "fillAlpha",
            "strokeAlpha",
            "globalCompositeOperation"
        ]).pushBaseTransform(currentCtx);
        this.setGState(opIdx, [
            [
                "BM",
                "source-over"
            ],
            [
                "ca",
                1
            ],
            [
                "CA",
                1
            ],
            [
                "TR",
                null
            ]
        ]);
        this.groupStack.push(currentCtx);
        this.groupLevel++;
    }
    endGroup(opIdx, group) {
        if (!this.contentVisible) return;
        this.groupLevel--;
        const groupCtx = this.ctx;
        const ctx = this.groupStack.pop();
        this.ctx = ctx;
        this.ctx.imageSmoothingEnabled = false;
        this.dependencyTracker?.popBaseTransform();
        if (group.smask) {
            this.tempSMask = this.smaskStack.pop();
            this.restore(opIdx);
            if (this.dependencyTracker) this.ctx.restore();
        } else {
            this.ctx.restore();
            const currentMtx = $b3a01b20dd2ade98$var$getCurrentTransform(this.ctx);
            this.restore(opIdx);
            this.ctx.save();
            this.ctx.setTransform(...currentMtx);
            const dirtyBox = $b3a01b20dd2ade98$var$MIN_MAX_INIT.slice();
            $b3a01b20dd2ade98$export$f8f26dd395d7e1bd.axialAlignedBoundingBox([
                0,
                0,
                groupCtx.canvas.width,
                groupCtx.canvas.height
            ], currentMtx, dirtyBox);
            this.ctx.drawImage(groupCtx.canvas, 0, 0);
            this.ctx.restore();
            this.canvasFactory.destroy({
                canvas: groupCtx.canvas,
                context: groupCtx
            });
            this.compose(dirtyBox);
        }
    }
    beginAnnotation(opIdx, id, rect, transform, matrix, hasOwnCanvas) {
        this.#restoreInitialState();
        $b3a01b20dd2ade98$var$resetCtxToDefault(this.ctx);
        this.ctx.save();
        this.save(opIdx);
        if (this.baseTransform) this.ctx.setTransform(...this.baseTransform);
        if (rect) {
            const width = rect[2] - rect[0];
            const height = rect[3] - rect[1];
            if (hasOwnCanvas && this.annotationCanvasMap) {
                transform = transform.slice();
                transform[4] -= rect[0];
                transform[5] -= rect[1];
                rect = rect.slice();
                rect[0] = rect[1] = 0;
                rect[2] = width;
                rect[3] = height;
                $b3a01b20dd2ade98$export$f8f26dd395d7e1bd.singularValueDecompose2dScale($b3a01b20dd2ade98$var$getCurrentTransform(this.ctx), $b3a01b20dd2ade98$var$XY);
                const { viewportScale: viewportScale } = this;
                const canvasWidth = Math.ceil(width * this.outputScaleX * viewportScale);
                const canvasHeight = Math.ceil(height * this.outputScaleY * viewportScale);
                this.annotationCanvas = this.canvasFactory.create(canvasWidth, canvasHeight);
                const { canvas: canvas, context: context } = this.annotationCanvas;
                this.annotationCanvasMap.set(id, canvas);
                this.annotationCanvas.savedCtx = this.ctx;
                this.ctx = context;
                this.ctx.save();
                this.ctx.setTransform($b3a01b20dd2ade98$var$XY[0], 0, 0, -$b3a01b20dd2ade98$var$XY[1], 0, height * $b3a01b20dd2ade98$var$XY[1]);
                $b3a01b20dd2ade98$var$resetCtxToDefault(this.ctx);
            } else {
                $b3a01b20dd2ade98$var$resetCtxToDefault(this.ctx);
                this.endPath(opIdx);
                const clip = new Path2D();
                clip.rect(rect[0], rect[1], width, height);
                this.ctx.clip(clip);
            }
        }
        this.current = new $b3a01b20dd2ade98$var$CanvasExtraState(this.ctx.canvas.width, this.ctx.canvas.height);
        this.transform(opIdx, ...transform);
        this.transform(opIdx, ...matrix);
    }
    endAnnotation(opIdx) {
        if (this.annotationCanvas) {
            this.ctx.restore();
            this.#drawFilter();
            this.ctx = this.annotationCanvas.savedCtx;
            delete this.annotationCanvas.savedCtx;
            delete this.annotationCanvas;
        }
    }
    paintImageMaskXObject(opIdx, img) {
        if (!this.contentVisible) return;
        const count = img.count;
        img = this.getObject(opIdx, img.data, img);
        img.count = count;
        const ctx = this.ctx;
        const mask = this._createMaskCanvas(opIdx, img);
        const maskCanvas = mask.canvas;
        ctx.save();
        ctx.setTransform(1, 0, 0, 1, 0, 0);
        ctx.drawImage(maskCanvas, mask.offsetX, mask.offsetY);
        this.dependencyTracker?.resetBBox(opIdx).recordBBox(opIdx, this.ctx, mask.offsetX, mask.offsetX + maskCanvas.width, mask.offsetY, mask.offsetY + maskCanvas.height).recordOperation(opIdx);
        ctx.restore();
        if (mask.canvasEntry) this.canvasFactory.destroy(mask.canvasEntry);
        this.compose();
    }
    paintImageMaskXObjectRepeat(opIdx, img, scaleX, skewX = 0, skewY = 0, scaleY, positions) {
        if (!this.contentVisible) return;
        img = this.getObject(opIdx, img.data, img);
        const ctx = this.ctx;
        ctx.save();
        const currentTransform = $b3a01b20dd2ade98$var$getCurrentTransform(ctx);
        ctx.transform(scaleX, skewX, skewY, scaleY, 0, 0);
        const mask = this._createMaskCanvas(opIdx, img);
        ctx.setTransform(1, 0, 0, 1, mask.offsetX - currentTransform[4], mask.offsetY - currentTransform[5]);
        this.dependencyTracker?.resetBBox(opIdx);
        for(let i = 0, ii = positions.length; i < ii; i += 2){
            const trans = $b3a01b20dd2ade98$export$f8f26dd395d7e1bd.transform(currentTransform, [
                scaleX,
                skewX,
                skewY,
                scaleY,
                positions[i],
                positions[i + 1]
            ]);
            ctx.drawImage(mask.canvas, trans[4], trans[5]);
            this.dependencyTracker?.recordBBox(opIdx, this.ctx, trans[4], trans[4] + mask.canvas.width, trans[5], trans[5] + mask.canvas.height);
        }
        ctx.restore();
        if (mask.canvasEntry) this.canvasFactory.destroy(mask.canvasEntry);
        this.compose();
        this.dependencyTracker?.recordOperation(opIdx);
    }
    paintImageMaskXObjectGroup(opIdx, images) {
        if (!this.contentVisible) return;
        const ctx = this.ctx;
        const fillColor = this.current.fillColor;
        const isPatternFill = this.current.patternFill;
        this.dependencyTracker?.resetBBox(opIdx).recordDependencies(opIdx, $b3a01b20dd2ade98$var$Dependencies.transformAndFill);
        for (const image of images){
            const { data: data, width: width, height: height, transform: transform } = image;
            const maskCanvas = this.canvasFactory.create(width, height);
            const maskCtx = maskCanvas.context;
            maskCtx.save();
            const img = this.getObject(opIdx, data, image);
            $b3a01b20dd2ade98$var$putBinaryImageMask(maskCtx, img);
            maskCtx.globalCompositeOperation = "source-in";
            maskCtx.fillStyle = isPatternFill ? fillColor.getPattern(maskCtx, this, $b3a01b20dd2ade98$var$getCurrentTransformInverse(ctx), $b3a01b20dd2ade98$var$PathType.FILL, opIdx) : fillColor;
            maskCtx.fillRect(0, 0, width, height);
            maskCtx.restore();
            ctx.save();
            ctx.transform(...transform);
            ctx.scale(1, -1);
            $b3a01b20dd2ade98$var$drawImageAtIntegerCoords(ctx, maskCanvas.canvas, 0, 0, width, height, 0, -1, 1, 1);
            this.canvasFactory.destroy(maskCanvas);
            this.dependencyTracker?.recordBBox(opIdx, ctx, 0, width, 0, height);
            ctx.restore();
        }
        this.compose();
        this.dependencyTracker?.recordOperation(opIdx);
    }
    paintImageXObject(opIdx, objId) {
        if (!this.contentVisible) return;
        const imgData = this.getObject(opIdx, objId);
        if (!imgData) {
            $b3a01b20dd2ade98$var$warn("Dependent image isn't ready yet");
            return;
        }
        this.paintInlineImageXObject(opIdx, imgData);
    }
    paintImageXObjectRepeat(opIdx, objId, scaleX, scaleY, positions) {
        if (!this.contentVisible) return;
        const imgData = this.getObject(opIdx, objId);
        if (!imgData) {
            $b3a01b20dd2ade98$var$warn("Dependent image isn't ready yet");
            return;
        }
        const width = imgData.width;
        const height = imgData.height;
        const map = [];
        for(let i = 0, ii = positions.length; i < ii; i += 2)map.push({
            transform: [
                scaleX,
                0,
                0,
                scaleY,
                positions[i],
                positions[i + 1]
            ],
            x: 0,
            y: 0,
            w: width,
            h: height
        });
        this.paintInlineImageXObjectGroup(opIdx, imgData, map);
    }
    applyTransferMapsToCanvas(ctx) {
        if (this.current.transferMaps !== "none") {
            ctx.filter = this.current.transferMaps;
            ctx.drawImage(ctx.canvas, 0, 0);
            ctx.filter = "none";
        }
        return ctx.canvas;
    }
    applyTransferMapsToBitmap(imgData) {
        if (this.current.transferMaps === "none") return {
            img: imgData.bitmap,
            canvasEntry: null
        };
        const { bitmap: bitmap, width: width, height: height } = imgData;
        const tmpCanvas = this.canvasFactory.create(width, height);
        const tmpCtx = tmpCanvas.context;
        tmpCtx.filter = this.current.transferMaps;
        tmpCtx.drawImage(bitmap, 0, 0);
        tmpCtx.filter = "none";
        return {
            img: tmpCanvas.canvas,
            canvasEntry: tmpCanvas
        };
    }
    paintInlineImageXObject(opIdx, imgData) {
        if (!this.contentVisible) return;
        const width = imgData.width;
        const height = imgData.height;
        const ctx = this.ctx;
        this.save(opIdx);
        const { filter: filter } = ctx;
        if (filter !== "none" && filter !== "") ctx.filter = "none";
        ctx.scale(1 / width, -1 / height);
        let imgToPaint;
        let inlineImgCanvas = null;
        if (imgData.bitmap) {
            const result = this.applyTransferMapsToBitmap(imgData);
            imgToPaint = result.img;
            inlineImgCanvas = result.canvasEntry;
        } else if (typeof HTMLElement === "function" && imgData instanceof HTMLElement || !imgData.data) imgToPaint = imgData;
        else {
            const tmpCanvas = this.canvasFactory.create(width, height);
            $b3a01b20dd2ade98$var$putBinaryImageData(tmpCanvas.context, imgData);
            imgToPaint = this.applyTransferMapsToCanvas(tmpCanvas.context);
            inlineImgCanvas = tmpCanvas;
        }
        const scaled = this._scaleImage(imgToPaint, $b3a01b20dd2ade98$var$getCurrentTransformInverse(ctx));
        ctx.imageSmoothingEnabled = $b3a01b20dd2ade98$var$getImageSmoothingEnabled($b3a01b20dd2ade98$var$getCurrentTransform(ctx), imgData.interpolate);
        if (this.dependencyTracker) {
            this.dependencyTracker.resetBBox(opIdx).recordBBox(opIdx, ctx, 0, width, -height, 0).recordDependencies(opIdx, $b3a01b20dd2ade98$var$Dependencies.imageXObject).recordOperation(opIdx);
            this.imagesTracker?.record(ctx, width, height, this.dependencyTracker.clipBox);
        }
        $b3a01b20dd2ade98$var$drawImageAtIntegerCoords(ctx, scaled.img, 0, 0, scaled.paintWidth, scaled.paintHeight, 0, -height, width, height);
        if (scaled.tmpCanvas) this.canvasFactory.destroy(scaled.tmpCanvas);
        if (inlineImgCanvas) this.canvasFactory.destroy(inlineImgCanvas);
        this.compose();
        this.restore(opIdx);
    }
    paintInlineImageXObjectGroup(opIdx, imgData, map) {
        if (!this.contentVisible) return;
        const ctx = this.ctx;
        let imgToPaint;
        let inlineImgCanvas = null;
        if (imgData.bitmap) imgToPaint = imgData.bitmap;
        else {
            const w = imgData.width;
            const h = imgData.height;
            const tmpCanvas = this.canvasFactory.create(w, h);
            $b3a01b20dd2ade98$var$putBinaryImageData(tmpCanvas.context, imgData);
            imgToPaint = this.applyTransferMapsToCanvas(tmpCanvas.context);
            inlineImgCanvas = tmpCanvas;
        }
        this.dependencyTracker?.resetBBox(opIdx);
        for (const entry of map){
            ctx.save();
            ctx.transform(...entry.transform);
            ctx.scale(1, -1);
            $b3a01b20dd2ade98$var$drawImageAtIntegerCoords(ctx, imgToPaint, entry.x, entry.y, entry.w, entry.h, 0, -1, 1, 1);
            this.dependencyTracker?.recordBBox(opIdx, ctx, 0, 1, -1, 0);
            ctx.restore();
        }
        if (inlineImgCanvas) this.canvasFactory.destroy(inlineImgCanvas);
        this.dependencyTracker?.recordOperation(opIdx);
        this.compose();
    }
    paintSolidColorImageMask(opIdx) {
        if (!this.contentVisible) return;
        this.dependencyTracker?.resetBBox(opIdx).recordBBox(opIdx, this.ctx, 0, 1, 0, 1).recordDependencies(opIdx, $b3a01b20dd2ade98$var$Dependencies.fill).recordOperation(opIdx);
        this.ctx.fillRect(0, 0, 1, 1);
        this.compose();
    }
    markPoint(opIdx, tag) {}
    markPointProps(opIdx, tag, properties) {}
    beginMarkedContent(opIdx, tag) {
        this.dependencyTracker?.beginMarkedContent(opIdx);
        this.markedContentStack.push({
            visible: true
        });
    }
    beginMarkedContentProps(opIdx, tag, properties) {
        this.dependencyTracker?.beginMarkedContent(opIdx);
        if (tag === "OC") this.markedContentStack.push({
            visible: this.optionalContentConfig.isVisible(properties)
        });
        else this.markedContentStack.push({
            visible: true
        });
        this.contentVisible = this.isContentVisible();
    }
    endMarkedContent(opIdx) {
        this.dependencyTracker?.endMarkedContent(opIdx);
        this.markedContentStack.pop();
        this.contentVisible = this.isContentVisible();
    }
    beginCompat(opIdx) {}
    endCompat(opIdx) {}
    consumePath(opIdx, path, clipBox) {
        const isEmpty = this.current.isEmptyClip();
        if (this.pendingClip) this.current.updateClipFromPath();
        if (!this.pendingClip) this.compose(clipBox);
        const ctx = this.ctx;
        if (this.pendingClip) {
            if (!isEmpty) {
                if (this.pendingClip === $b3a01b20dd2ade98$var$EO_CLIP) ctx.clip(path, "evenodd");
                else ctx.clip(path);
            }
            this.pendingClip = null;
            this.dependencyTracker?.bboxToClipBoxDropOperation(opIdx).recordFutureForcedDependency("clipPath", opIdx);
        } else this.dependencyTracker?.recordOperation(opIdx);
        this.current.startNewPathAndClipBox(this.current.clipBox);
    }
    getSinglePixelWidth() {
        if (!this._cachedGetSinglePixelWidth) {
            const m = $b3a01b20dd2ade98$var$getCurrentTransform(this.ctx);
            if (m[1] === 0 && m[2] === 0) this._cachedGetSinglePixelWidth = 1 / Math.min(Math.abs(m[0]), Math.abs(m[3]));
            else {
                const absDet = Math.abs(m[0] * m[3] - m[2] * m[1]);
                const normX = Math.hypot(m[0], m[2]);
                const normY = Math.hypot(m[1], m[3]);
                this._cachedGetSinglePixelWidth = Math.max(normX, normY) / absDet;
            }
        }
        return this._cachedGetSinglePixelWidth;
    }
    getScaleForStroking() {
        if (this._cachedScaleForStroking[0] === -1) {
            const { lineWidth: lineWidth } = this.current;
            const { a: a, b: b, c: c, d: d } = this.ctx.getTransform();
            let scaleX, scaleY;
            if (b === 0 && c === 0) {
                const normX = Math.abs(a);
                const normY = Math.abs(d);
                if (normX === normY) {
                    if (lineWidth === 0) scaleX = scaleY = 1 / normX;
                    else {
                        const scaledLineWidth = normX * lineWidth;
                        scaleX = scaleY = scaledLineWidth < 1 ? 1 / scaledLineWidth : 1;
                    }
                } else if (lineWidth === 0) {
                    scaleX = 1 / normX;
                    scaleY = 1 / normY;
                } else {
                    const scaledXLineWidth = normX * lineWidth;
                    const scaledYLineWidth = normY * lineWidth;
                    scaleX = scaledXLineWidth < 1 ? 1 / scaledXLineWidth : 1;
                    scaleY = scaledYLineWidth < 1 ? 1 / scaledYLineWidth : 1;
                }
            } else {
                const absDet = Math.abs(a * d - b * c);
                const normX = Math.hypot(a, b);
                const normY = Math.hypot(c, d);
                if (lineWidth === 0) {
                    scaleX = normY / absDet;
                    scaleY = normX / absDet;
                } else {
                    const baseArea = lineWidth * absDet;
                    scaleX = normY > baseArea ? normY / baseArea : 1;
                    scaleY = normX > baseArea ? normX / baseArea : 1;
                }
            }
            this._cachedScaleForStroking[0] = scaleX;
            this._cachedScaleForStroking[1] = scaleY;
        }
        return this._cachedScaleForStroking;
    }
    rescaleAndStroke(path, saveRestore) {
        const { ctx: ctx, current: { lineWidth: lineWidth } } = this;
        const [scaleX, scaleY] = this.getScaleForStroking();
        if (scaleX === scaleY) {
            ctx.lineWidth = (lineWidth || 1) * scaleX;
            ctx.stroke(path);
            return;
        }
        const dashes = ctx.getLineDash();
        if (saveRestore) ctx.save();
        ctx.scale(scaleX, scaleY);
        $b3a01b20dd2ade98$var$SCALE_MATRIX.a = 1 / scaleX;
        $b3a01b20dd2ade98$var$SCALE_MATRIX.d = 1 / scaleY;
        const newPath = new Path2D();
        newPath.addPath(path, $b3a01b20dd2ade98$var$SCALE_MATRIX);
        if (dashes.length > 0) {
            const scale = Math.max(scaleX, scaleY);
            ctx.setLineDash(dashes.map((x)=>x / scale));
            ctx.lineDashOffset /= scale;
        }
        ctx.lineWidth = lineWidth || 1;
        ctx.stroke(newPath);
        if (saveRestore) ctx.restore();
    }
    isContentVisible() {
        for(let i = this.markedContentStack.length - 1; i >= 0; i--){
            if (!this.markedContentStack[i].visible) return false;
        }
        return true;
    }
}
for(const op in $b3a01b20dd2ade98$export$3a0f7f7a8a0b306b)if ($b3a01b20dd2ade98$var$CanvasGraphics.prototype[op] !== undefined) $b3a01b20dd2ade98$var$CanvasGraphics.prototype[$b3a01b20dd2ade98$export$3a0f7f7a8a0b306b[op]] = $b3a01b20dd2ade98$var$CanvasGraphics.prototype[op];
class $b3a01b20dd2ade98$var$BasePDFStream {
    #PDFStreamReader = null;
    #PDFStreamRangeReader = null;
    _fullReader = null;
    _rangeReaders = new Set();
    _source = null;
    constructor(source, PDFStreamReader, PDFStreamRangeReader){
        this._source = source;
        this.#PDFStreamReader = PDFStreamReader;
        this.#PDFStreamRangeReader = PDFStreamRangeReader;
    }
    get _progressiveDataLength() {
        return this._fullReader?._loaded ?? 0;
    }
    getFullReader() {
        $b3a01b20dd2ade98$var$assert(!this._fullReader, "BasePDFStream.getFullReader can only be called once.");
        return this._fullReader = new this.#PDFStreamReader(this);
    }
    getRangeReader(begin, end) {
        if (end <= this._progressiveDataLength) return null;
        const reader = new this.#PDFStreamRangeReader(this, begin, end);
        this._rangeReaders.add(reader);
        return reader;
    }
    cancelAllRequests(reason) {
        this._fullReader?.cancel(reason);
        for (const reader of new Set(this._rangeReaders))reader.cancel(reason);
    }
}
class $b3a01b20dd2ade98$var$BasePDFStreamReader {
    onProgress = null;
    _contentLength = 0;
    _filename = null;
    _headersCapability = Promise.withResolvers();
    _isRangeSupported = false;
    _isStreamingSupported = false;
    _loaded = 0;
    _stream = null;
    constructor(stream){
        this._stream = stream;
    }
    _callOnProgress() {
        this.onProgress?.({
            loaded: this._loaded,
            total: this._contentLength
        });
    }
    get headersReady() {
        return this._headersCapability.promise;
    }
    get filename() {
        return this._filename;
    }
    get contentLength() {
        return this._contentLength;
    }
    get isRangeSupported() {
        return this._isRangeSupported;
    }
    get isStreamingSupported() {
        return this._isStreamingSupported;
    }
    async read() {
        $b3a01b20dd2ade98$var$unreachable("Abstract method `read` called");
    }
    cancel(reason) {
        $b3a01b20dd2ade98$var$unreachable("Abstract method `cancel` called");
    }
}
class $b3a01b20dd2ade98$var$BasePDFStreamRangeReader {
    _stream = null;
    constructor(stream, begin, end){
        this._stream = stream;
    }
    async read() {
        $b3a01b20dd2ade98$var$unreachable("Abstract method `read` called");
    }
    cancel(reason) {
        $b3a01b20dd2ade98$var$unreachable("Abstract method `cancel` called");
    }
}
function $b3a01b20dd2ade98$var$getFilenameFromContentDispositionHeader(contentDisposition) {
    let needsEncodingFixup = true;
    let tmp = toParamRegExp("filename\\*", "i").exec(contentDisposition);
    if (tmp) {
        tmp = tmp[1];
        let filename = rfc2616unquote(tmp);
        filename = unescape(filename);
        filename = rfc5987decode(filename);
        filename = rfc2047decode(filename);
        return fixupEncoding(filename);
    }
    tmp = rfc2231getparam(contentDisposition);
    if (tmp) {
        const filename = rfc2047decode(tmp);
        return fixupEncoding(filename);
    }
    tmp = toParamRegExp("filename", "i").exec(contentDisposition);
    if (tmp) {
        tmp = tmp[1];
        let filename = rfc2616unquote(tmp);
        filename = rfc2047decode(filename);
        return fixupEncoding(filename);
    }
    function toParamRegExp(attributePattern, flags) {
        return new RegExp("(?:^|;)\\s*" + attributePattern + "\\s*=\\s*" + "(" + '[^";\\s][^;\\s]*' + "|" + '"(?:[^"\\\\]|\\\\"?)+"?' + ")", flags);
    }
    function textdecode(encoding, value) {
        if (encoding) {
            if (!/^[\x00-\xFF]+$/.test(value)) return value;
            try {
                const decoder = new TextDecoder(encoding, {
                    fatal: true
                });
                const buffer = $b3a01b20dd2ade98$var$stringToBytes(value);
                value = decoder.decode(buffer);
                needsEncodingFixup = false;
            } catch  {}
        }
        return value;
    }
    function fixupEncoding(value) {
        if (needsEncodingFixup && /[\x80-\xff]/.test(value)) {
            value = textdecode("utf-8", value);
            if (needsEncodingFixup) value = textdecode("iso-8859-1", value);
        }
        return value;
    }
    function rfc2231getparam(contentDispositionStr) {
        const matches = [];
        let match;
        const iter = toParamRegExp("filename\\*((?!0\\d)\\d+)(\\*?)", "ig");
        while((match = iter.exec(contentDispositionStr)) !== null){
            let [, n, quot, part] = match;
            n = parseInt(n, 10);
            if (n in matches) {
                if (n === 0) break;
                continue;
            }
            matches[n] = [
                quot,
                part
            ];
        }
        const parts = [];
        for(let n = 0; n < matches.length; ++n){
            if (!(n in matches)) break;
            let [quot, part] = matches[n];
            part = rfc2616unquote(part);
            if (quot) {
                part = unescape(part);
                if (n === 0) part = rfc5987decode(part);
            }
            parts.push(part);
        }
        return parts.join("");
    }
    function rfc2616unquote(value) {
        if (value.startsWith('"')) {
            const parts = value.slice(1).split('\\"');
            for(let i = 0; i < parts.length; ++i){
                const quotindex = parts[i].indexOf('"');
                if (quotindex !== -1) {
                    parts[i] = parts[i].slice(0, quotindex);
                    parts.length = i + 1;
                }
                parts[i] = parts[i].replaceAll(/\\(.)/g, "$1");
            }
            value = parts.join('"');
        }
        return value;
    }
    function rfc5987decode(extvalue) {
        const encodingend = extvalue.indexOf("'");
        if (encodingend === -1) return extvalue;
        const encoding = extvalue.slice(0, encodingend);
        const langvalue = extvalue.slice(encodingend + 1);
        const value = langvalue.replace(/^[^']*'/, "");
        return textdecode(encoding, value);
    }
    function rfc2047decode(value) {
        if (!value.startsWith("=?") || /[\x00-\x19\x80-\xff]/.test(value)) return value;
        return value.replaceAll(/=\?([\w-]*)\?([QqBb])\?((?:[^?]|\?(?!=))*)\?=/g, function(matches, charset, encoding, text) {
            if (encoding === "q" || encoding === "Q") {
                text = text.replaceAll("_", " ");
                text = text.replaceAll(/=([0-9a-fA-F]{2})/g, function(match, hex) {
                    return String.fromCharCode(parseInt(hex, 16));
                });
                return textdecode(charset, text);
            }
            try {
                text = atob(text);
            } catch  {}
            return textdecode(charset, text);
        });
    }
    return "";
}
function $b3a01b20dd2ade98$var$createHeaders(isHttp, httpHeaders) {
    const headers = new Headers();
    if (!isHttp || !httpHeaders || typeof httpHeaders !== "object") return headers;
    for(const key in httpHeaders){
        const val = httpHeaders[key];
        if (val !== undefined) headers.append(key, val);
    }
    return headers;
}
function $b3a01b20dd2ade98$var$getResponseOrigin(url) {
    return URL.parse(url)?.origin ?? null;
}
function $b3a01b20dd2ade98$var$validateRangeRequestCapabilities({ responseHeaders: responseHeaders, isHttp: isHttp, rangeChunkSize: rangeChunkSize, disableRange: disableRange }) {
    const rv = {
        contentLength: 0,
        isRangeSupported: false
    };
    const length = parseInt(responseHeaders.get("Content-Length"), 10);
    if (!Number.isInteger(length)) return rv;
    rv.contentLength = length;
    if (length <= 2 * rangeChunkSize) return rv;
    if (disableRange || !isHttp) return rv;
    if (responseHeaders.get("Accept-Ranges") !== "bytes") return rv;
    const contentEncoding = responseHeaders.get("Content-Encoding") || "identity";
    if (contentEncoding === "identity") rv.isRangeSupported = true;
    return rv;
}
function $b3a01b20dd2ade98$var$extractFilenameFromHeader(responseHeaders) {
    const contentDisposition = responseHeaders.get("Content-Disposition");
    if (contentDisposition) {
        let filename = $b3a01b20dd2ade98$var$getFilenameFromContentDispositionHeader(contentDisposition);
        if (filename.includes("%")) try {
            filename = decodeURIComponent(filename);
        } catch  {}
        if ($b3a01b20dd2ade98$export$61b52d3570d24719(filename)) return filename;
    }
    return null;
}
function $b3a01b20dd2ade98$var$createResponseError(status, url) {
    return new $b3a01b20dd2ade98$export$ea8e9c34f66e603(`Unexpected server response (${status}) while retrieving PDF "${url.href}".`, status, status === 404 || status === 0 && url.protocol === "file:");
}
function $b3a01b20dd2ade98$var$ensureResponseOrigin(rangeOrigin, origin) {
    if (rangeOrigin !== origin) throw new Error(`Expected range response-origin "${rangeOrigin}" to match "${origin}".`);
}
function $b3a01b20dd2ade98$var$fetchUrl(url, headers, withCredentials, abortController) {
    return fetch(url, {
        method: "GET",
        headers: headers,
        signal: abortController.signal,
        mode: "cors",
        credentials: withCredentials ? "include" : "same-origin",
        redirect: "follow"
    });
}
function $b3a01b20dd2ade98$var$ensureResponseStatus(status, url) {
    if (status !== 200 && status !== 206) throw $b3a01b20dd2ade98$var$createResponseError(status, url);
}
function $b3a01b20dd2ade98$var$getArrayBuffer(val) {
    if (val instanceof Uint8Array) return val.buffer;
    if (val instanceof ArrayBuffer) return val;
    throw new Error(`getArrayBuffer - unexpected data: ${val}`);
}
class $b3a01b20dd2ade98$var$PDFFetchStream extends $b3a01b20dd2ade98$var$BasePDFStream {
    _responseOrigin = null;
    constructor(source){
        super(source, $b3a01b20dd2ade98$var$PDFFetchStreamReader, $b3a01b20dd2ade98$var$PDFFetchStreamRangeReader);
        const { httpHeaders: httpHeaders, url: url } = source;
        $b3a01b20dd2ade98$var$assert(/https?:/.test(url.protocol), "PDFFetchStream only supports http(s):// URLs.");
        this.headers = $b3a01b20dd2ade98$var$createHeaders(true, httpHeaders);
    }
}
class $b3a01b20dd2ade98$var$PDFFetchStreamReader extends $b3a01b20dd2ade98$var$BasePDFStreamReader {
    _abortController = new AbortController();
    _reader = null;
    constructor(stream){
        super(stream);
        const { disableRange: disableRange, disableStream: disableStream, rangeChunkSize: rangeChunkSize, url: url, withCredentials: withCredentials } = stream._source;
        this._isStreamingSupported = !disableStream;
        const headers = new Headers(stream.headers);
        $b3a01b20dd2ade98$var$fetchUrl(url, headers, withCredentials, this._abortController).then((response)=>{
            stream._responseOrigin = $b3a01b20dd2ade98$var$getResponseOrigin(response.url);
            $b3a01b20dd2ade98$var$ensureResponseStatus(response.status, url);
            this._reader = response.body.getReader();
            const responseHeaders = response.headers;
            const { contentLength: contentLength, isRangeSupported: isRangeSupported } = $b3a01b20dd2ade98$var$validateRangeRequestCapabilities({
                responseHeaders: responseHeaders,
                isHttp: true,
                rangeChunkSize: rangeChunkSize,
                disableRange: disableRange
            });
            this._contentLength = contentLength;
            this._isRangeSupported = isRangeSupported;
            this._filename = $b3a01b20dd2ade98$var$extractFilenameFromHeader(responseHeaders);
            if (!this._isStreamingSupported && this._isRangeSupported) this.cancel(new $b3a01b20dd2ade98$export$d0e978393d193d1a("Streaming is disabled."));
            this._headersCapability.resolve();
        }).catch(this._headersCapability.reject);
    }
    async read() {
        await this._headersCapability.promise;
        const { value: value, done: done } = await this._reader.read();
        if (done) return {
            value: value,
            done: done
        };
        this._loaded += value.byteLength;
        this._callOnProgress();
        return {
            value: $b3a01b20dd2ade98$var$getArrayBuffer(value),
            done: false
        };
    }
    cancel(reason) {
        this._reader?.cancel(reason);
        this._abortController.abort();
    }
}
class $b3a01b20dd2ade98$var$PDFFetchStreamRangeReader extends $b3a01b20dd2ade98$var$BasePDFStreamRangeReader {
    _abortController = new AbortController();
    _readCapability = Promise.withResolvers();
    _reader = null;
    constructor(stream, begin, end){
        super(stream, begin, end);
        const { url: url, withCredentials: withCredentials } = stream._source;
        const headers = new Headers(stream.headers);
        headers.append("Range", `bytes=${begin}-${end - 1}`);
        $b3a01b20dd2ade98$var$fetchUrl(url, headers, withCredentials, this._abortController).then((response)=>{
            const responseOrigin = $b3a01b20dd2ade98$var$getResponseOrigin(response.url);
            $b3a01b20dd2ade98$var$ensureResponseOrigin(responseOrigin, stream._responseOrigin);
            $b3a01b20dd2ade98$var$ensureResponseStatus(response.status, url);
            this._reader = response.body.getReader();
            this._readCapability.resolve();
        }).catch(this._readCapability.reject);
    }
    async read() {
        await this._readCapability.promise;
        const { value: value, done: done } = await this._reader.read();
        if (done) return {
            value: value,
            done: done
        };
        return {
            value: $b3a01b20dd2ade98$var$getArrayBuffer(value),
            done: false
        };
    }
    cancel(reason) {
        this._reader?.cancel(reason);
        this._abortController.abort();
    }
}
function $b3a01b20dd2ade98$var$transport_stream_getArrayBuffer(val) {
    return val instanceof Uint8Array && val.byteLength === val.buffer.byteLength ? val.buffer : new Uint8Array(val).buffer;
}
function $b3a01b20dd2ade98$var$endRequests() {
    for (const capability of this._requests)capability.resolve({
        value: undefined,
        done: true
    });
    this._requests.length = 0;
}
class $b3a01b20dd2ade98$var$PDFDataTransportStream extends $b3a01b20dd2ade98$var$BasePDFStream {
    _progressiveDone = false;
    _queuedChunks = [];
    constructor(source){
        super(source, $b3a01b20dd2ade98$var$PDFDataTransportStreamReader, $b3a01b20dd2ade98$var$PDFDataTransportStreamRangeReader);
        const { pdfDataRangeTransport: pdfDataRangeTransport } = source;
        const { initialData: initialData, progressiveDone: progressiveDone } = pdfDataRangeTransport;
        if (initialData?.length > 0) {
            const buffer = $b3a01b20dd2ade98$var$transport_stream_getArrayBuffer(initialData);
            this._queuedChunks.push(buffer);
        }
        this._progressiveDone = progressiveDone;
        pdfDataRangeTransport.addRangeListener((begin, chunk)=>{
            this.#onReceiveData(begin, chunk);
        });
        pdfDataRangeTransport.addProgressiveReadListener((chunk)=>{
            this.#onReceiveData(undefined, chunk);
        });
        pdfDataRangeTransport.addProgressiveDoneListener(()=>{
            this._fullReader?.progressiveDone();
            this._progressiveDone = true;
        });
        pdfDataRangeTransport.transportReady();
    }
    #onReceiveData(begin, chunk) {
        const buffer = $b3a01b20dd2ade98$var$transport_stream_getArrayBuffer(chunk);
        if (begin === undefined) {
            if (this._fullReader) this._fullReader._enqueue(buffer);
            else this._queuedChunks.push(buffer);
        } else {
            const rangeReader = this._rangeReaders.keys().find((r)=>r._begin === begin);
            $b3a01b20dd2ade98$var$assert(rangeReader, "#onReceiveData - no `PDFDataTransportStreamRangeReader` instance found.");
            rangeReader._enqueue(buffer);
        }
    }
    getFullReader() {
        const reader = super.getFullReader();
        this._queuedChunks = null;
        return reader;
    }
    getRangeReader(begin, end) {
        const reader = super.getRangeReader(begin, end);
        if (reader) {
            reader.onDone = ()=>this._rangeReaders.delete(reader);
            this._source.pdfDataRangeTransport.requestDataRange(begin, end);
        }
        return reader;
    }
    cancelAllRequests(reason) {
        super.cancelAllRequests(reason);
        this._source.pdfDataRangeTransport.abort();
    }
}
class $b3a01b20dd2ade98$var$PDFDataTransportStreamReader extends $b3a01b20dd2ade98$var$BasePDFStreamReader {
    #endRequests = $b3a01b20dd2ade98$var$endRequests.bind(this);
    _done = false;
    _queuedChunks = null;
    _requests = [];
    constructor(stream){
        super(stream);
        const { pdfDataRangeTransport: pdfDataRangeTransport, disableRange: disableRange, disableStream: disableStream } = stream._source;
        const { length: length, contentDispositionFilename: contentDispositionFilename } = pdfDataRangeTransport;
        this._queuedChunks = stream._queuedChunks || [];
        for (const chunk of this._queuedChunks)this._loaded += chunk.byteLength;
        this._done = stream._progressiveDone;
        this._contentLength = length;
        this._isStreamingSupported = !disableStream;
        this._isRangeSupported = !disableRange;
        if ($b3a01b20dd2ade98$export$61b52d3570d24719(contentDispositionFilename)) this._filename = contentDispositionFilename;
        this._headersCapability.resolve();
        const loaded = this._loaded;
        Promise.resolve().then(()=>{
            if (loaded > 0 && this._loaded === loaded) this._callOnProgress();
        });
    }
    _enqueue(chunk) {
        if (this._done) return;
        if (this._requests.length > 0) {
            const capability = this._requests.shift();
            capability.resolve({
                value: chunk,
                done: false
            });
        } else this._queuedChunks.push(chunk);
        this._loaded += chunk.byteLength;
        this._callOnProgress();
    }
    async read() {
        if (this._queuedChunks.length > 0) {
            const chunk = this._queuedChunks.shift();
            return {
                value: chunk,
                done: false
            };
        }
        if (this._done) return {
            value: undefined,
            done: true
        };
        const capability = Promise.withResolvers();
        this._requests.push(capability);
        return capability.promise;
    }
    cancel(reason) {
        this._done = true;
        this.#endRequests();
    }
    progressiveDone() {
        this._done ||= true;
        if (this._queuedChunks.length === 0) this.#endRequests();
    }
}
class $b3a01b20dd2ade98$var$PDFDataTransportStreamRangeReader extends $b3a01b20dd2ade98$var$BasePDFStreamRangeReader {
    #endRequests = $b3a01b20dd2ade98$var$endRequests.bind(this);
    onDone = null;
    _begin = -1;
    _done = false;
    _queuedChunk = null;
    _requests = [];
    constructor(stream, begin, end){
        super(stream, begin, end);
        this._begin = begin;
    }
    _enqueue(chunk) {
        if (this._done) return;
        if (this._requests.length === 0) this._queuedChunk = chunk;
        else {
            const capability = this._requests.shift();
            capability.resolve({
                value: chunk,
                done: false
            });
            this.#endRequests();
        }
        this._done = true;
        this.onDone?.();
    }
    async read() {
        if (this._queuedChunk) {
            const chunk = this._queuedChunk;
            this._queuedChunk = null;
            return {
                value: chunk,
                done: false
            };
        }
        if (this._done) return {
            value: undefined,
            done: true
        };
        const capability = Promise.withResolvers();
        this._requests.push(capability);
        return capability.promise;
    }
    cancel(reason) {
        this._done = true;
        this.#endRequests();
        this.onDone?.();
    }
}
const $b3a01b20dd2ade98$var$OK_RESPONSE = 200;
const $b3a01b20dd2ade98$var$PARTIAL_CONTENT_RESPONSE = 206;
function $b3a01b20dd2ade98$var$network_getArrayBuffer(val) {
    return typeof val !== "string" ? val : $b3a01b20dd2ade98$var$stringToBytes(val).buffer;
}
class $b3a01b20dd2ade98$var$PDFNetworkStream extends $b3a01b20dd2ade98$var$BasePDFStream {
    #pendingRequests = new WeakMap();
    _responseOrigin = null;
    constructor(source){
        super(source, $b3a01b20dd2ade98$var$PDFNetworkStreamReader, $b3a01b20dd2ade98$var$PDFNetworkStreamRangeReader);
        const { httpHeaders: httpHeaders, url: url } = source;
        this.url = url;
        this.isHttp = /https?:/.test(url.protocol);
        this.headers = $b3a01b20dd2ade98$var$createHeaders(this.isHttp, httpHeaders);
    }
    _request(args) {
        const xhr = new XMLHttpRequest();
        const pendingRequest = {
            validateStatus: null,
            onHeadersReceived: args.onHeadersReceived,
            onDone: args.onDone,
            onError: args.onError,
            onProgress: args.onProgress
        };
        this.#pendingRequests.set(xhr, pendingRequest);
        xhr.open("GET", this.url);
        xhr.withCredentials = this._source.withCredentials;
        for (const [key, val] of this.headers)xhr.setRequestHeader(key, val);
        if (this.isHttp && "begin" in args && "end" in args) {
            xhr.setRequestHeader("Range", `bytes=${args.begin}-${args.end - 1}`);
            pendingRequest.validateStatus = (status)=>status === $b3a01b20dd2ade98$var$PARTIAL_CONTENT_RESPONSE || status === $b3a01b20dd2ade98$var$OK_RESPONSE;
        } else pendingRequest.validateStatus = (status)=>status === $b3a01b20dd2ade98$var$OK_RESPONSE;
        xhr.responseType = "arraybuffer";
        $b3a01b20dd2ade98$var$assert(args.onError, "Expected `onError` callback to be provided.");
        xhr.onerror = ()=>args.onError(xhr.status);
        xhr.onreadystatechange = this.#onStateChange.bind(this, xhr);
        xhr.onprogress = this.#onProgress.bind(this, xhr);
        xhr.send(null);
        return xhr;
    }
    #onProgress(xhr, evt) {
        const pendingRequest = this.#pendingRequests.get(xhr);
        pendingRequest?.onProgress?.(evt);
    }
    #onStateChange(xhr, evt) {
        const pendingRequest = this.#pendingRequests.get(xhr);
        if (!pendingRequest) return;
        if (xhr.readyState >= 2 && pendingRequest.onHeadersReceived) {
            pendingRequest.onHeadersReceived();
            delete pendingRequest.onHeadersReceived;
        }
        if (xhr.readyState !== 4) return;
        if (!this.#pendingRequests.has(xhr)) return;
        this.#pendingRequests.delete(xhr);
        if (xhr.status === 0 && this.isHttp) {
            pendingRequest.onError(xhr.status);
            return;
        }
        const xhrStatus = xhr.status || $b3a01b20dd2ade98$var$OK_RESPONSE;
        if (!pendingRequest.validateStatus(xhrStatus)) {
            pendingRequest.onError(xhr.status);
            return;
        }
        const chunk = $b3a01b20dd2ade98$var$network_getArrayBuffer(xhr.response);
        if (xhrStatus === $b3a01b20dd2ade98$var$PARTIAL_CONTENT_RESPONSE) {
            const rangeHeader = xhr.getResponseHeader("Content-Range");
            if (/bytes (\d+)-(\d+)\/(\d+)/.test(rangeHeader)) pendingRequest.onDone(chunk);
            else {
                $b3a01b20dd2ade98$var$warn(`Missing or invalid "Content-Range" header.`);
                pendingRequest.onError(0);
            }
        } else if (chunk) pendingRequest.onDone(chunk);
        else pendingRequest.onError(xhr.status);
    }
    _abortRequest(xhr) {
        if (this.#pendingRequests.has(xhr)) {
            this.#pendingRequests.delete(xhr);
            xhr.abort();
        }
    }
    getRangeReader(begin, end) {
        const reader = super.getRangeReader(begin, end);
        if (reader) reader.onClosed = ()=>this._rangeReaders.delete(reader);
        return reader;
    }
}
class $b3a01b20dd2ade98$var$PDFNetworkStreamReader extends $b3a01b20dd2ade98$var$BasePDFStreamReader {
    #endRequests = $b3a01b20dd2ade98$var$endRequests.bind(this);
    _cachedChunks = [];
    _done = false;
    _requests = [];
    _storedError = null;
    constructor(stream){
        super(stream);
        this._fullRequestXhr = stream._request({
            onHeadersReceived: this.#onHeadersReceived.bind(this),
            onDone: this.#onDone.bind(this),
            onError: this.#onError.bind(this),
            onProgress: this.#onProgress.bind(this)
        });
    }
    #onHeadersReceived() {
        const stream = this._stream;
        const { disableRange: disableRange, rangeChunkSize: rangeChunkSize } = stream._source;
        const fullRequestXhr = this._fullRequestXhr;
        stream._responseOrigin = $b3a01b20dd2ade98$var$getResponseOrigin(fullRequestXhr.responseURL);
        const rawResponseHeaders = fullRequestXhr.getAllResponseHeaders();
        const responseHeaders = new Headers(rawResponseHeaders ? rawResponseHeaders.trimStart().replace(/[^\S ]+$/, "").split(/[\r\n]+/).map((x)=>{
            const [key, ...val] = x.split(": ");
            return [
                key,
                val.join(": ")
            ];
        }) : []);
        const { contentLength: contentLength, isRangeSupported: isRangeSupported } = $b3a01b20dd2ade98$var$validateRangeRequestCapabilities({
            responseHeaders: responseHeaders,
            isHttp: stream.isHttp,
            rangeChunkSize: rangeChunkSize,
            disableRange: disableRange
        });
        this._contentLength = contentLength;
        this._isRangeSupported = isRangeSupported;
        this._filename = $b3a01b20dd2ade98$var$extractFilenameFromHeader(responseHeaders);
        if (this._isRangeSupported) stream._abortRequest(fullRequestXhr);
        this._headersCapability.resolve();
    }
    #onDone(chunk) {
        if (this._requests.length > 0) {
            const capability = this._requests.shift();
            capability.resolve({
                value: chunk,
                done: false
            });
        } else this._cachedChunks.push(chunk);
        this._done = true;
        if (this._cachedChunks.length === 0) this.#endRequests();
    }
    #onError(status) {
        this._storedError = $b3a01b20dd2ade98$var$createResponseError(status, this._stream.url);
        this._headersCapability.reject(this._storedError);
        for (const capability of this._requests)capability.reject(this._storedError);
        this._requests.length = 0;
        this._cachedChunks.length = 0;
    }
    #onProgress(evt) {
        this.onProgress?.({
            loaded: evt.loaded,
            total: evt.lengthComputable ? evt.total : this._contentLength
        });
    }
    async read() {
        await this._headersCapability.promise;
        if (this._storedError) throw this._storedError;
        if (this._cachedChunks.length > 0) {
            const chunk = this._cachedChunks.shift();
            return {
                value: chunk,
                done: false
            };
        }
        if (this._done) return {
            value: undefined,
            done: true
        };
        const capability = Promise.withResolvers();
        this._requests.push(capability);
        return capability.promise;
    }
    cancel(reason) {
        this._done = true;
        this._headersCapability.reject(reason);
        this.#endRequests();
        this._stream._abortRequest(this._fullRequestXhr);
        this._fullRequestXhr = null;
    }
}
class $b3a01b20dd2ade98$var$PDFNetworkStreamRangeReader extends $b3a01b20dd2ade98$var$BasePDFStreamRangeReader {
    #endRequests = $b3a01b20dd2ade98$var$endRequests.bind(this);
    onClosed = null;
    _done = false;
    _queuedChunk = null;
    _requests = [];
    _storedError = null;
    constructor(stream, begin, end){
        super(stream, begin, end);
        this._requestXhr = stream._request({
            begin: begin,
            end: end,
            onHeadersReceived: this.#onHeadersReceived.bind(this),
            onDone: this.#onDone.bind(this),
            onError: this.#onError.bind(this),
            onProgress: null
        });
    }
    #onHeadersReceived() {
        const responseOrigin = $b3a01b20dd2ade98$var$getResponseOrigin(this._requestXhr?.responseURL);
        try {
            $b3a01b20dd2ade98$var$ensureResponseOrigin(responseOrigin, this._stream._responseOrigin);
        } catch (ex) {
            this._storedError = ex;
            this.#onError(0);
        }
    }
    #onDone(chunk) {
        if (this._requests.length > 0) {
            const capability = this._requests.shift();
            capability.resolve({
                value: chunk,
                done: false
            });
        } else this._queuedChunk = chunk;
        this._done = true;
        this.#endRequests();
        this.onClosed?.();
    }
    #onError(status) {
        this._storedError ??= $b3a01b20dd2ade98$var$createResponseError(status, this._stream.url);
        for (const capability of this._requests)capability.reject(this._storedError);
        this._requests.length = 0;
        this._queuedChunk = null;
    }
    async read() {
        if (this._storedError) throw this._storedError;
        if (this._queuedChunk !== null) {
            const chunk = this._queuedChunk;
            this._queuedChunk = null;
            return {
                value: chunk,
                done: false
            };
        }
        if (this._done) return {
            value: undefined,
            done: true
        };
        const capability = Promise.withResolvers();
        this._requests.push(capability);
        return capability.promise;
    }
    cancel(reason) {
        this._done = true;
        this.#endRequests();
        this._stream._abortRequest(this._requestXhr);
        this.onClosed?.();
    }
}
function $b3a01b20dd2ade98$var$getReadableStream(readStream) {
    const { Readable: Readable } = $4TZ3D.getBuiltinModule("stream");
    if (typeof Readable.toWeb === "function") return Readable.toWeb(readStream);
    const require1 = $4TZ3D.getBuiltinModule("module").createRequire("file:///node_modules/pdfjs-dist/build/pdf.mjs");
    const polyfill = require1("node-readable-to-web-readable-stream");
    return polyfill.makeDefaultReadableStreamFromNodeReadable(readStream);
}
class $b3a01b20dd2ade98$var$PDFNodeStream extends $b3a01b20dd2ade98$var$BasePDFStream {
    constructor(source){
        super(source, $b3a01b20dd2ade98$var$PDFNodeStreamReader, $b3a01b20dd2ade98$var$PDFNodeStreamRangeReader);
        const { url: url } = source;
        $b3a01b20dd2ade98$var$assert(url.protocol === "file:", "PDFNodeStream only supports file:// URLs.");
    }
}
class $b3a01b20dd2ade98$var$PDFNodeStreamReader extends $b3a01b20dd2ade98$var$BasePDFStreamReader {
    _reader = null;
    constructor(stream){
        super(stream);
        const { disableRange: disableRange, disableStream: disableStream, rangeChunkSize: rangeChunkSize, url: url } = stream._source;
        this._isStreamingSupported = !disableStream;
        const fs = $4TZ3D.getBuiltinModule("fs");
        fs.promises.lstat(url).then((stat)=>{
            const readStream = fs.createReadStream(url);
            const readableStream = $b3a01b20dd2ade98$var$getReadableStream(readStream);
            this._reader = readableStream.getReader();
            const { size: size } = stat;
            this._contentLength = size;
            this._isRangeSupported = !disableRange && size > 2 * rangeChunkSize;
            if (!this._isStreamingSupported && this._isRangeSupported) this.cancel(new $b3a01b20dd2ade98$export$d0e978393d193d1a("Streaming is disabled."));
            this._headersCapability.resolve();
        }).catch((error)=>{
            if (error.code === "ENOENT") error = $b3a01b20dd2ade98$var$createResponseError(0, url);
            this._headersCapability.reject(error);
        });
    }
    async read() {
        await this._headersCapability.promise;
        const { value: value, done: done } = await this._reader.read();
        if (done) return {
            value: value,
            done: done
        };
        this._loaded += value.byteLength;
        this._callOnProgress();
        return {
            value: $b3a01b20dd2ade98$var$getArrayBuffer(value),
            done: false
        };
    }
    cancel(reason) {
        this._reader?.cancel(reason);
    }
}
class $b3a01b20dd2ade98$var$PDFNodeStreamRangeReader extends $b3a01b20dd2ade98$var$BasePDFStreamRangeReader {
    _readCapability = Promise.withResolvers();
    _reader = null;
    constructor(stream, begin, end){
        super(stream, begin, end);
        const { url: url } = stream._source;
        const fs = $4TZ3D.getBuiltinModule("fs");
        try {
            const readStream = fs.createReadStream(url, {
                start: begin,
                end: end - 1
            });
            const readableStream = $b3a01b20dd2ade98$var$getReadableStream(readStream);
            this._reader = readableStream.getReader();
            this._readCapability.resolve();
        } catch (error) {
            this._readCapability.reject(error);
        }
    }
    async read() {
        await this._readCapability.promise;
        const { value: value, done: done } = await this._reader.read();
        if (done) return {
            value: value,
            done: done
        };
        return {
            value: $b3a01b20dd2ade98$var$getArrayBuffer(value),
            done: false
        };
    }
    cancel(reason) {
        this._reader?.cancel(reason);
    }
}
function $b3a01b20dd2ade98$var$getNetworkStream(url) {
    return $b3a01b20dd2ade98$var$isValidFetchUrl(url) ? $b3a01b20dd2ade98$var$PDFFetchStream : $b3a01b20dd2ade98$var$isNodeJS ? $b3a01b20dd2ade98$var$PDFNodeStream : $b3a01b20dd2ade98$var$PDFNetworkStream;
}
class $b3a01b20dd2ade98$export$edf38ba293eb934 {
    static #port = null;
    static #src = "";
    static get workerPort() {
        return this.#port;
    }
    static set workerPort(val) {
        if (!(typeof Worker !== "undefined" && val instanceof Worker) && val !== null) throw new Error("Invalid `workerPort` type.");
        this.#port = val;
    }
    static get workerSrc() {
        return this.#src;
    }
    static set workerSrc(val) {
        if (typeof val !== "string") throw new Error("Invalid `workerSrc` type.");
        this.#src = val;
    }
}
class $b3a01b20dd2ade98$var$Metadata {
    #map;
    #data;
    constructor({ parsedData: parsedData, rawData: rawData }){
        this.#map = parsedData;
        this.#data = rawData;
    }
    getRaw() {
        return this.#data;
    }
    get(name) {
        return this.#map.get(name) ?? null;
    }
    [Symbol.iterator]() {
        return this.#map.entries();
    }
}
const $b3a01b20dd2ade98$var$INTERNAL = Symbol("INTERNAL");
class $b3a01b20dd2ade98$var$OptionalContentGroup {
    #isDisplay = false;
    #isPrint = false;
    #userSet = false;
    #visible = true;
    constructor(renderingIntent, { name: name, intent: intent, usage: usage, rbGroups: rbGroups }){
        this.#isDisplay = !!(renderingIntent & $b3a01b20dd2ade98$var$RenderingIntentFlag.DISPLAY);
        this.#isPrint = !!(renderingIntent & $b3a01b20dd2ade98$var$RenderingIntentFlag.PRINT);
        this.name = name;
        this.intent = intent;
        this.usage = usage;
        this.rbGroups = rbGroups;
    }
    get visible() {
        if (this.#userSet) return this.#visible;
        if (!this.#visible) return false;
        const { print: print, view: view } = this.usage;
        if (this.#isDisplay) return view?.viewState !== "OFF";
        else if (this.#isPrint) return print?.printState !== "OFF";
        return true;
    }
    _setVisible(internal, visible, userSet = false) {
        if (internal !== $b3a01b20dd2ade98$var$INTERNAL) $b3a01b20dd2ade98$var$unreachable("Internal method `_setVisible` called.");
        this.#userSet = userSet;
        this.#visible = visible;
    }
}
class $b3a01b20dd2ade98$var$OptionalContentConfig {
    #cachedGetHash = null;
    #groups = new Map();
    #initialHash = null;
    #order = null;
    constructor(data, renderingIntent = $b3a01b20dd2ade98$var$RenderingIntentFlag.DISPLAY){
        this.renderingIntent = renderingIntent;
        this.name = null;
        this.creator = null;
        if (data === null) return;
        this.name = data.name;
        this.creator = data.creator;
        this.#order = data.order;
        for (const group of data.groups)this.#groups.set(group.id, new $b3a01b20dd2ade98$var$OptionalContentGroup(renderingIntent, group));
        if (data.baseState === "OFF") for (const group of this.#groups.values())group._setVisible($b3a01b20dd2ade98$var$INTERNAL, false);
        for (const on of data.on)this.#groups.get(on)._setVisible($b3a01b20dd2ade98$var$INTERNAL, true);
        for (const off of data.off)this.#groups.get(off)._setVisible($b3a01b20dd2ade98$var$INTERNAL, false);
        this.#initialHash = this.getHash();
    }
    #evaluateVisibilityExpression(array) {
        const length = array.length;
        if (length < 2) return true;
        const operator = array[0];
        for(let i = 1; i < length; i++){
            const element = array[i];
            let state;
            if (Array.isArray(element)) state = this.#evaluateVisibilityExpression(element);
            else if (this.#groups.has(element)) state = this.#groups.get(element).visible;
            else {
                $b3a01b20dd2ade98$var$warn(`Optional content group not found: ${element}`);
                return true;
            }
            switch(operator){
                case "And":
                    if (!state) return false;
                    break;
                case "Or":
                    if (state) return true;
                    break;
                case "Not":
                    return !state;
                default:
                    return true;
            }
        }
        return operator === "And";
    }
    isVisible(group) {
        if (this.#groups.size === 0) return true;
        if (!group) {
            $b3a01b20dd2ade98$var$info("Optional content group not defined.");
            return true;
        }
        if (group.type === "OCG") {
            if (!this.#groups.has(group.id)) {
                $b3a01b20dd2ade98$var$warn(`Optional content group not found: ${group.id}`);
                return true;
            }
            return this.#groups.get(group.id).visible;
        } else if (group.type === "OCMD") {
            if (group.expression) return this.#evaluateVisibilityExpression(group.expression);
            if (!group.policy || group.policy === "AnyOn") {
                for (const id of group.ids){
                    if (!this.#groups.has(id)) {
                        $b3a01b20dd2ade98$var$warn(`Optional content group not found: ${id}`);
                        return true;
                    }
                    if (this.#groups.get(id).visible) return true;
                }
                return false;
            } else if (group.policy === "AllOn") {
                for (const id of group.ids){
                    if (!this.#groups.has(id)) {
                        $b3a01b20dd2ade98$var$warn(`Optional content group not found: ${id}`);
                        return true;
                    }
                    if (!this.#groups.get(id).visible) return false;
                }
                return true;
            } else if (group.policy === "AnyOff") {
                for (const id of group.ids){
                    if (!this.#groups.has(id)) {
                        $b3a01b20dd2ade98$var$warn(`Optional content group not found: ${id}`);
                        return true;
                    }
                    if (!this.#groups.get(id).visible) return true;
                }
                return false;
            } else if (group.policy === "AllOff") {
                for (const id of group.ids){
                    if (!this.#groups.has(id)) {
                        $b3a01b20dd2ade98$var$warn(`Optional content group not found: ${id}`);
                        return true;
                    }
                    if (this.#groups.get(id).visible) return false;
                }
                return true;
            }
            $b3a01b20dd2ade98$var$warn(`Unknown optional content policy ${group.policy}.`);
            return true;
        }
        $b3a01b20dd2ade98$var$warn(`Unknown group type ${group.type}.`);
        return true;
    }
    setVisibility(id, visible = true, preserveRB = true) {
        const group = this.#groups.get(id);
        if (!group) {
            $b3a01b20dd2ade98$var$warn(`Optional content group not found: ${id}`);
            return;
        }
        if (preserveRB && visible && group.rbGroups.length) for (const rbGroup of group.rbGroups){
            for (const otherId of rbGroup)if (otherId !== id) this.#groups.get(otherId)?._setVisible($b3a01b20dd2ade98$var$INTERNAL, false, true);
        }
        group._setVisible($b3a01b20dd2ade98$var$INTERNAL, !!visible, true);
        this.#cachedGetHash = null;
    }
    setOCGState({ state: state, preserveRB: preserveRB }) {
        let operator;
        for (const elem of state){
            switch(elem){
                case "ON":
                case "OFF":
                case "Toggle":
                    operator = elem;
                    continue;
            }
            const group = this.#groups.get(elem);
            if (!group) continue;
            switch(operator){
                case "ON":
                    this.setVisibility(elem, true, preserveRB);
                    break;
                case "OFF":
                    this.setVisibility(elem, false, preserveRB);
                    break;
                case "Toggle":
                    this.setVisibility(elem, !group.visible, preserveRB);
                    break;
            }
        }
        this.#cachedGetHash = null;
    }
    get hasInitialVisibility() {
        return this.#initialHash === null || this.getHash() === this.#initialHash;
    }
    getOrder() {
        if (!this.#groups.size) return null;
        if (this.#order) return this.#order.slice();
        return [
            ...this.#groups.keys()
        ];
    }
    getGroup(id) {
        return this.#groups.get(id) || null;
    }
    getHash() {
        if (this.#cachedGetHash !== null) return this.#cachedGetHash;
        const hash = new $b3a01b20dd2ade98$var$MurmurHash3_64();
        for (const [id, group] of this.#groups)hash.update(`${id}:${group.visible}`);
        return this.#cachedGetHash = hash.hexdigest();
    }
    [Symbol.iterator]() {
        return this.#groups.entries();
    }
}
class $b3a01b20dd2ade98$var$PagesMapper {
    #pageNumberToId = null;
    #prevPageNumbers = null;
    #pagesNumber = 0;
    #clipboard = null;
    #savedData = null;
    get pagesNumber() {
        return this.#pagesNumber;
    }
    set pagesNumber(n) {
        if (this.#pagesNumber === n) return;
        this.#pagesNumber = n;
        this.#pageNumberToId = null;
        this.#prevPageNumbers = null;
    }
    #ensureInit() {
        if (this.#pageNumberToId) return;
        const n = this.#pagesNumber;
        const pageNumberToId = this.#pageNumberToId = new Uint32Array(n);
        for(let i = 0; i < n; i++)pageNumberToId[i] = i + 1;
        this.#prevPageNumbers = new Int32Array(pageNumberToId);
    }
    #buildIdToPageNumber() {
        const idToPageNumber = new Map();
        const pageNumberToId = this.#pageNumberToId;
        for(let i = 0, ii = this.#pagesNumber; i < ii; i++){
            const id = pageNumberToId[i];
            const pageNumbers = idToPageNumber.get(id);
            if (pageNumbers) pageNumbers.push(i + 1);
            else idToPageNumber.set(id, [
                i + 1
            ]);
        }
        return idToPageNumber;
    }
    movePages(selectedPages, pagesToMove, index) {
        this.#ensureInit();
        const pageNumberToId = this.#pageNumberToId;
        const prevIdToPageNumber = this.#buildIdToPageNumber();
        const movedCount = pagesToMove.length;
        const mappedPagesToMove = new Uint32Array(movedCount);
        let removedBeforeTarget = 0;
        for(let i = 0; i < movedCount; i++){
            const pageIndex = pagesToMove[i] - 1;
            mappedPagesToMove[i] = pageNumberToId[pageIndex];
            if (pageIndex < index) removedBeforeTarget++;
        }
        const pagesNumber = this.#pagesNumber;
        const remainingLen = pagesNumber - movedCount;
        const adjustedTarget = $b3a01b20dd2ade98$export$b8106b171181a554(index - removedBeforeTarget, 0, remainingLen);
        for(let i = 0, r = 0; i < pagesNumber; i++)if (!selectedPages.has(i + 1)) pageNumberToId[r++] = pageNumberToId[i];
        pageNumberToId.copyWithin(adjustedTarget + movedCount, adjustedTarget, remainingLen);
        pageNumberToId.set(mappedPagesToMove, adjustedTarget);
        this.#updatePrevPageNumbers(prevIdToPageNumber);
        if (pageNumberToId.every((id, i)=>id === i + 1)) this.#pageNumberToId = null;
    }
    deletePages(pagesToDelete) {
        this.#ensureInit();
        const pageNumberToId = this.#pageNumberToId;
        const prevIdToPageNumber = this.#buildIdToPageNumber();
        this.#savedData = {
            pageNumberToId: pageNumberToId.slice(),
            pagesNumber: this.#pagesNumber,
            prevPageNumbers: this.#prevPageNumbers.slice()
        };
        const newN = this.#pagesNumber - pagesToDelete.length;
        this.#pagesNumber = newN;
        const newPageNumberToId = this.#pageNumberToId = new Uint32Array(newN);
        this.#prevPageNumbers = new Int32Array(newN);
        let sourceIndex = 0;
        let destIndex = 0;
        for (const pageNumber of pagesToDelete){
            const pageIndex = pageNumber - 1;
            if (pageIndex !== sourceIndex) {
                newPageNumberToId.set(pageNumberToId.subarray(sourceIndex, pageIndex), destIndex);
                destIndex += pageIndex - sourceIndex;
            }
            sourceIndex = pageIndex + 1;
        }
        if (sourceIndex < pageNumberToId.length) newPageNumberToId.set(pageNumberToId.subarray(sourceIndex), destIndex);
        this.#updatePrevPageNumbers(prevIdToPageNumber, new Set(pagesToDelete));
    }
    cancelDelete() {
        if (this.#savedData) {
            this.#pageNumberToId = this.#savedData.pageNumberToId;
            this.#pagesNumber = this.#savedData.pagesNumber;
            this.#prevPageNumbers = this.#savedData.prevPageNumbers;
            this.#savedData = null;
        }
    }
    cleanSavedData() {
        this.#savedData = null;
    }
    copyPages(pagesToCopy) {
        this.#ensureInit();
        this.#clipboard = {
            pageNumbers: pagesToCopy,
            pageIds: pagesToCopy.map((n)=>this.#pageNumberToId[n - 1])
        };
    }
    cancelCopy() {
        this.#clipboard = null;
    }
    pastePages(index) {
        this.#ensureInit();
        const pageNumberToId = this.#pageNumberToId;
        const prevIdToPageNumber = this.#buildIdToPageNumber();
        const { pageNumbers: copiedPageNumbers, pageIds: copiedPageIds } = this.#clipboard;
        const newN = this.#pagesNumber + copiedPageNumbers.length;
        this.#pagesNumber = newN;
        const newPageNumberToId = this.#pageNumberToId = new Uint32Array(newN);
        this.#prevPageNumbers = new Int32Array(newN);
        newPageNumberToId.set(pageNumberToId.subarray(0, index), 0);
        newPageNumberToId.set(copiedPageIds, index);
        newPageNumberToId.set(pageNumberToId.subarray(index), index + copiedPageNumbers.length);
        this.#updatePrevPageNumbers(prevIdToPageNumber, null, index, copiedPageNumbers);
        this.#clipboard = null;
    }
    #updatePrevPageNumbers(prevIdToPageNumber, deletedPageNumbers = null, pasteIndex = -1, copiedPageNumbers = null) {
        const prevPageNumbers = this.#prevPageNumbers;
        const newPageNumberToId = this.#pageNumberToId;
        const pasteEnd = pasteIndex + (copiedPageNumbers?.length ?? 0);
        const idsIndices = new Map();
        for(let i = 0, ii = this.#pagesNumber; i < ii; i++){
            if (i >= pasteIndex && i < pasteEnd) {
                prevPageNumbers[i] = -copiedPageNumbers[i - pasteIndex];
                continue;
            }
            const id = newPageNumberToId[i];
            const oldPositions = prevIdToPageNumber.get(id);
            let j = idsIndices.get(id) || 0;
            if (deletedPageNumbers && oldPositions) while(j < oldPositions.length && deletedPageNumbers.has(oldPositions[j]))j++;
            prevPageNumbers[i] = oldPositions?.[j];
            idsIndices.set(id, j + 1);
        }
    }
    hasBeenAltered() {
        return this.#pageNumberToId !== null;
    }
    getPageMappingForSaving(idToPageNumber = null) {
        idToPageNumber ??= this.#buildIdToPageNumber();
        let nCopy = 0;
        for (const pageNumbers of idToPageNumber.values())nCopy = Math.max(nCopy, pageNumbers.length);
        const extractParams = new Array(nCopy);
        for(let i = 0; i < nCopy; i++)extractParams[i] = {
            document: null,
            pageIndices: [],
            includePages: []
        };
        for (const [id, pageNumbers] of idToPageNumber)for(let i = 0, ii = pageNumbers.length; i < ii; i++)extractParams[i].includePages.push([
            id - 1,
            pageNumbers[i] - 1
        ]);
        for (const { includePages: includePages, pageIndices: pageIndices } of extractParams){
            includePages.sort((a, b)=>a[0] - b[0]);
            for(let i = 0, ii = includePages.length; i < ii; i++){
                pageIndices.push(includePages[i][1]);
                includePages[i] = includePages[i][0];
            }
        }
        return extractParams;
    }
    extractPages(extractedPageNumbers) {
        extractedPageNumbers = Array.from(extractedPageNumbers).sort((a, b)=>a - b);
        const usedIds = new Map();
        for(let i = 0, ii = extractedPageNumbers.length; i < ii; i++){
            const id = this.getPageId(extractedPageNumbers[i]);
            const usedPageNumbers = usedIds.getOrInsertComputed(id, $b3a01b20dd2ade98$export$be9af9a47496243a);
            usedPageNumbers.push(i + 1);
        }
        return this.getPageMappingForSaving(usedIds);
    }
    getPrevPageNumber(pageNumber) {
        return this.#prevPageNumbers?.[pageNumber - 1] ?? 0;
    }
    getPageNumber(id) {
        if (!this.#pageNumberToId) return id;
        const pageNumberToId = this.#pageNumberToId;
        for(let i = 0, ii = this.#pagesNumber; i < ii; i++){
            if (pageNumberToId[i] === id) return i + 1;
        }
        return 0;
    }
    getPageId(pageNumber) {
        return this.#pageNumberToId?.[pageNumber - 1] ?? pageNumber;
    }
    getMapping() {
        return this.#pageNumberToId?.subarray(0, this.pagesNumber);
    }
}
const $b3a01b20dd2ade98$var$INITIAL_DATA = Symbol("INITIAL_DATA");
const $b3a01b20dd2ade98$var$dataObj = ()=>({
        ...Promise.withResolvers(),
        data: $b3a01b20dd2ade98$var$INITIAL_DATA
    });
class $b3a01b20dd2ade98$var$PDFObjects {
    #objs = new Map();
    get(objId, callback = null) {
        if (callback) {
            const obj = this.#objs.getOrInsertComputed(objId, $b3a01b20dd2ade98$var$dataObj);
            obj.promise.then(()=>callback(obj.data));
            return null;
        }
        const obj = this.#objs.get(objId);
        if (!obj || obj.data === $b3a01b20dd2ade98$var$INITIAL_DATA) throw new Error(`Requesting object that isn't resolved yet ${objId}.`);
        return obj.data;
    }
    has(objId) {
        const obj = this.#objs.get(objId);
        return !!obj && obj.data !== $b3a01b20dd2ade98$var$INITIAL_DATA;
    }
    delete(objId) {
        const obj = this.#objs.get(objId);
        if (!obj || obj.data === $b3a01b20dd2ade98$var$INITIAL_DATA) return false;
        this.#objs.delete(objId);
        return true;
    }
    resolve(objId, data = null) {
        const obj = this.#objs.getOrInsertComputed(objId, $b3a01b20dd2ade98$var$dataObj);
        if (obj.data !== $b3a01b20dd2ade98$var$INITIAL_DATA) throw new Error(`Object already resolved ${objId}.`);
        obj.data = data;
        obj.resolve();
    }
    clear() {
        for (const { data: data } of this.#objs.values())data?.bitmap?.close();
        this.#objs.clear();
    }
    *[Symbol.iterator]() {
        for (const [objId, { data: data }] of this.#objs)if (data !== $b3a01b20dd2ade98$var$INITIAL_DATA) yield [
            objId,
            data
        ];
    }
}
const $b3a01b20dd2ade98$var$MAX_TEXT_DIVS_TO_RENDER = 100000;
const $b3a01b20dd2ade98$var$DEFAULT_FONT_SIZE = 30;
class $b3a01b20dd2ade98$export$fdbdc423a78c5262 {
    #capability = Promise.withResolvers();
    #container = null;
    #disableProcessItems = false;
    #fontInspectorEnabled = !!globalThis.FontInspector?.enabled;
    #imagesHandler = null;
    #lang = null;
    #layoutTextParams = null;
    #pageHeight = 0;
    #pageWidth = 0;
    #reader = null;
    #rootContainer = null;
    #rotation = 0;
    #scale = 0;
    #styleCache = Object.create(null);
    #textContentItemsStr = [];
    #textContentSource = null;
    #textDivs = [];
    #textDivProperties = new WeakMap();
    #transform = null;
    static #ascentCache = new Map();
    static #canvasContexts = new Map();
    static #canvasCtxFonts = new WeakMap();
    static #minFontSize = null;
    static #pendingTextLayers = new Set();
    constructor({ textContentSource: textContentSource, images: images, container: container, viewport: viewport }){
        if (textContentSource instanceof ReadableStream) this.#textContentSource = textContentSource;
        else if (typeof textContentSource === "object") this.#textContentSource = new ReadableStream({
            start (controller) {
                controller.enqueue(textContentSource);
                controller.close();
            }
        });
        else throw new Error('No "textContentSource" parameter specified.');
        this.#container = this.#rootContainer = container;
        this.#imagesHandler = images;
        this.#scale = viewport.scale * $b3a01b20dd2ade98$export$f16a99f63bccd50b.pixelRatio;
        this.#rotation = viewport.rotation;
        this.#layoutTextParams = {
            div: null,
            properties: null,
            ctx: null
        };
        const { pageWidth: pageWidth, pageHeight: pageHeight, pageX: pageX, pageY: pageY } = viewport.rawDims;
        this.#transform = [
            1,
            0,
            0,
            -1,
            -pageX,
            pageY + pageHeight
        ];
        this.#pageWidth = pageWidth;
        this.#pageHeight = pageHeight;
        $b3a01b20dd2ade98$export$fdbdc423a78c5262.#ensureMinFontSizeComputed();
        container.style.setProperty("--min-font-size", $b3a01b20dd2ade98$export$fdbdc423a78c5262.#minFontSize);
        $b3a01b20dd2ade98$export$af0a15a86e590226(container, viewport);
        this.#capability.promise.finally(()=>{
            $b3a01b20dd2ade98$export$fdbdc423a78c5262.#pendingTextLayers.delete(this);
            this.#layoutTextParams = null;
            this.#styleCache = null;
        }).catch(()=>{});
    }
    static get fontFamilyMap() {
        const { isWindows: isWindows, isFirefox: isFirefox } = $b3a01b20dd2ade98$export$5fb8891d35c36978.platform;
        return $b3a01b20dd2ade98$export$b8972b998723d602(this, "fontFamilyMap", new Map([
            [
                "sans-serif",
                `${isWindows && isFirefox ? "Calibri, " : ""}sans-serif`
            ],
            [
                "monospace",
                `${isWindows && isFirefox ? "Lucida Console, " : ""}monospace`
            ]
        ]));
    }
    render() {
        if (this.#imagesHandler) this.#container.append(this.#imagesHandler.render());
        const pump = ()=>{
            this.#reader.read().then(({ value: value, done: done })=>{
                if (done) {
                    this.#capability.resolve();
                    return;
                }
                this.#lang ??= value.lang;
                Object.assign(this.#styleCache, value.styles);
                this.#processItems(value.items);
                pump();
            }, this.#capability.reject);
        };
        this.#reader = this.#textContentSource.getReader();
        $b3a01b20dd2ade98$export$fdbdc423a78c5262.#pendingTextLayers.add(this);
        pump();
        return this.#capability.promise;
    }
    update({ viewport: viewport, onBefore: onBefore = null }) {
        const scale = viewport.scale * $b3a01b20dd2ade98$export$f16a99f63bccd50b.pixelRatio;
        const rotation = viewport.rotation;
        if (rotation !== this.#rotation) {
            onBefore?.();
            this.#rotation = rotation;
            $b3a01b20dd2ade98$export$af0a15a86e590226(this.#rootContainer, {
                rotation: rotation
            });
        }
        if (scale !== this.#scale) {
            onBefore?.();
            this.#scale = scale;
            const params = {
                div: null,
                properties: null,
                ctx: $b3a01b20dd2ade98$export$fdbdc423a78c5262.#getCtx(this.#lang)
            };
            for (const div of this.#textDivs){
                params.properties = this.#textDivProperties.get(div);
                params.div = div;
                this.#layout(params);
            }
        }
    }
    cancel() {
        const abortEx = new $b3a01b20dd2ade98$export$d0e978393d193d1a("TextLayer task cancelled.");
        this.#reader?.cancel(abortEx).catch(()=>{});
        this.#reader = null;
        this.#capability.reject(abortEx);
    }
    get textDivs() {
        return this.#textDivs;
    }
    get textContentItemsStr() {
        return this.#textContentItemsStr;
    }
    #processItems(items) {
        if (this.#disableProcessItems) return;
        this.#layoutTextParams.ctx ??= $b3a01b20dd2ade98$export$fdbdc423a78c5262.#getCtx(this.#lang);
        const textDivs = this.#textDivs, textContentItemsStr = this.#textContentItemsStr;
        for (const item of items){
            if (textDivs.length > $b3a01b20dd2ade98$var$MAX_TEXT_DIVS_TO_RENDER) {
                $b3a01b20dd2ade98$var$warn("Ignoring additional textDivs for performance reasons.");
                this.#disableProcessItems = true;
                return;
            }
            if (item.str === undefined) {
                if (item.type === "beginMarkedContentProps" || item.type === "beginMarkedContent") {
                    const parent = this.#container;
                    this.#container = document.createElement("span");
                    this.#container.classList.add("markedContent");
                    if (item.id) this.#container.setAttribute("id", `${item.id}`);
                    if (item.tag === "Artifact") this.#container.ariaHidden = true;
                    parent.append(this.#container);
                } else if (item.type === "endMarkedContent") this.#container = this.#container.parentNode;
                continue;
            }
            textContentItemsStr.push(item.str);
            this.#appendText(item);
        }
    }
    #appendText(geom) {
        const textDiv = document.createElement("span");
        const textDivProperties = {
            angle: 0,
            canvasWidth: 0,
            hasText: geom.str !== "",
            hasEOL: geom.hasEOL,
            fontSize: 0
        };
        this.#textDivs.push(textDiv);
        const tx = $b3a01b20dd2ade98$export$f8f26dd395d7e1bd.transform(this.#transform, geom.transform);
        let angle = Math.atan2(tx[1], tx[0]);
        const style = this.#styleCache[geom.fontName];
        if (style.vertical) angle += Math.PI / 2;
        let fontFamily = this.#fontInspectorEnabled && style.fontSubstitution || style.fontFamily;
        fontFamily = $b3a01b20dd2ade98$export$fdbdc423a78c5262.fontFamilyMap.get(fontFamily) || fontFamily;
        const fontHeight = Math.hypot(tx[2], tx[3]);
        const fontAscent = fontHeight * $b3a01b20dd2ade98$export$fdbdc423a78c5262.#getAscent(fontFamily, style, this.#lang);
        let left, top;
        if (angle === 0) {
            left = tx[4];
            top = tx[5] - fontAscent;
        } else {
            left = tx[4] + fontAscent * Math.sin(angle);
            top = tx[5] - fontAscent * Math.cos(angle);
        }
        const divStyle = textDiv.style;
        divStyle.left = `${(100 * left / this.#pageWidth).toFixed(2)}%`;
        divStyle.top = `${(100 * top / this.#pageHeight).toFixed(2)}%`;
        divStyle.setProperty("--font-height", `${fontHeight.toFixed(2)}px`);
        divStyle.fontFamily = fontFamily;
        textDivProperties.fontSize = fontHeight;
        textDiv.setAttribute("role", "presentation");
        textDiv.textContent = geom.str;
        textDiv.dir = geom.dir;
        if (this.#fontInspectorEnabled) textDiv.dataset.fontName = style.fontSubstitutionLoadedName || geom.fontName;
        if (angle !== 0) textDivProperties.angle = angle * (180 / Math.PI);
        let shouldScaleText = false;
        if (geom.str.length > 1) shouldScaleText = true;
        else if (geom.str !== " " && geom.transform[0] !== geom.transform[3]) {
            const absScaleX = Math.abs(geom.transform[0]), absScaleY = Math.abs(geom.transform[3]);
            if (absScaleX !== absScaleY && Math.max(absScaleX, absScaleY) / Math.min(absScaleX, absScaleY) > 1.5) shouldScaleText = true;
        }
        if (shouldScaleText) textDivProperties.canvasWidth = style.vertical ? geom.height : geom.width;
        this.#textDivProperties.set(textDiv, textDivProperties);
        this.#layoutTextParams.div = textDiv;
        this.#layoutTextParams.properties = textDivProperties;
        this.#layout(this.#layoutTextParams);
        if (textDivProperties.hasText) this.#container.append(textDiv);
        if (textDivProperties.hasEOL) {
            const br = document.createElement("br");
            br.setAttribute("role", "presentation");
            this.#container.append(br);
        }
    }
    #layout(params) {
        const { div: div, properties: properties, ctx: ctx } = params;
        const { style: style } = div;
        if (properties.canvasWidth !== 0 && properties.hasText) {
            const { fontFamily: fontFamily } = style;
            const { canvasWidth: canvasWidth, fontSize: fontSize } = properties;
            $b3a01b20dd2ade98$export$fdbdc423a78c5262.#ensureCtxFont(ctx, fontSize * this.#scale, fontFamily);
            const { width: width } = ctx.measureText(div.textContent);
            if (width > 0) style.setProperty("--scale-x", canvasWidth * this.#scale / width);
        }
        if (properties.angle !== 0) style.setProperty("--rotate", `${properties.angle}deg`);
    }
    static cleanup() {
        if (this.#pendingTextLayers.size > 0) return;
        this.#ascentCache.clear();
        for (const { canvas: canvas } of this.#canvasContexts.values())canvas.remove();
        this.#canvasContexts.clear();
    }
    static #getCtx(lang = null) {
        let ctx = this.#canvasContexts.get(lang ||= "");
        if (!ctx) {
            const canvas = document.createElement("canvas");
            canvas.className = "hiddenCanvasElement";
            canvas.lang = lang;
            document.body.append(canvas);
            ctx = canvas.getContext("2d", {
                alpha: false,
                willReadFrequently: true
            });
            this.#canvasContexts.set(lang, ctx);
            this.#canvasCtxFonts.set(ctx, {
                size: 0,
                family: ""
            });
        }
        return ctx;
    }
    static #ensureCtxFont(ctx, size, family) {
        const cached = this.#canvasCtxFonts.get(ctx);
        if (size === cached.size && family === cached.family) return;
        ctx.font = `${size}px ${family}`;
        cached.size = size;
        cached.family = family;
    }
    static #ensureMinFontSizeComputed() {
        if (this.#minFontSize !== null) return;
        const div = document.createElement("div");
        div.style.opacity = 0;
        div.style.lineHeight = 1;
        div.style.fontSize = "1px";
        div.style.position = "absolute";
        div.textContent = "X";
        document.body.append(div);
        this.#minFontSize = div.getBoundingClientRect().height;
        div.remove();
    }
    static #getAscent(fontFamily, style, lang) {
        const cachedAscent = this.#ascentCache.get(fontFamily);
        if (cachedAscent) return cachedAscent;
        const ctx = this.#getCtx(lang);
        ctx.canvas.width = ctx.canvas.height = $b3a01b20dd2ade98$var$DEFAULT_FONT_SIZE;
        this.#ensureCtxFont(ctx, $b3a01b20dd2ade98$var$DEFAULT_FONT_SIZE, fontFamily);
        const metrics = ctx.measureText("");
        const ascent = metrics.fontBoundingBoxAscent;
        const descent = Math.abs(metrics.fontBoundingBoxDescent);
        ctx.canvas.width = ctx.canvas.height = 0;
        let ratio = 0.8;
        if (ascent) ratio = ascent / (ascent + descent);
        else {
            if ($b3a01b20dd2ade98$export$5fb8891d35c36978.platform.isFirefox) $b3a01b20dd2ade98$var$warn("Enable the `dom.textMetrics.fontBoundingBox.enabled` preference in `about:config` to improve TextLayer rendering.");
            if (style.ascent) ratio = style.ascent;
            else if (style.descent) ratio = 1 + style.descent;
        }
        this.#ascentCache.set(fontFamily, ratio);
        return ratio;
    }
}
const $b3a01b20dd2ade98$var$RENDERING_CANCELLED_TIMEOUT = 100;
function $b3a01b20dd2ade98$export$f65ca476c09acec0(src = {}) {
    if (typeof src === "string" || src instanceof URL) src = {
        url: src
    };
    else if (src instanceof ArrayBuffer || ArrayBuffer.isView(src)) src = {
        data: src
    };
    const task = new $b3a01b20dd2ade98$var$PDFDocumentLoadingTask();
    const { docId: docId } = task;
    const url = src.url ? $b3a01b20dd2ade98$var$getUrlProp(src.url) : null;
    const data = src.data ? $b3a01b20dd2ade98$var$getDataProp(src.data) : null;
    const httpHeaders = src.httpHeaders || null;
    const withCredentials = src.withCredentials === true;
    const password = src.password ?? null;
    const rangeTransport = src.range instanceof $b3a01b20dd2ade98$export$c06899d9d7bce9ab ? src.range : null;
    const rangeChunkSize = Number.isInteger(src.rangeChunkSize) && src.rangeChunkSize > 0 ? src.rangeChunkSize : 2 ** 16;
    let worker = src.worker instanceof $b3a01b20dd2ade98$export$84e2e9f37426b265 ? src.worker : null;
    const verbosity = src.verbosity;
    const docBaseUrl = typeof src.docBaseUrl === "string" && !$b3a01b20dd2ade98$export$f67aae4532d8295b(src.docBaseUrl) ? src.docBaseUrl : null;
    const cMapUrl = $b3a01b20dd2ade98$var$getFactoryUrlProp(src.cMapUrl);
    const cMapPacked = src.cMapPacked !== false;
    const iccUrl = $b3a01b20dd2ade98$var$getFactoryUrlProp(src.iccUrl);
    const standardFontDataUrl = $b3a01b20dd2ade98$var$getFactoryUrlProp(src.standardFontDataUrl);
    const wasmUrl = $b3a01b20dd2ade98$var$getFactoryUrlProp(src.wasmUrl);
    const ignoreErrors = src.stopAtErrors !== true;
    const maxImageSize = Number.isInteger(src.maxImageSize) && src.maxImageSize > -1 ? src.maxImageSize : -1;
    const isEvalSupported = src.isEvalSupported !== false;
    const isOffscreenCanvasSupported = typeof src.isOffscreenCanvasSupported === "boolean" ? src.isOffscreenCanvasSupported : !$b3a01b20dd2ade98$var$isNodeJS;
    const isImageDecoderSupported = typeof src.isImageDecoderSupported === "boolean" ? src.isImageDecoderSupported : !$b3a01b20dd2ade98$var$isNodeJS && ($b3a01b20dd2ade98$export$5fb8891d35c36978.platform.isFirefox || !globalThis.chrome);
    const canvasMaxAreaInBytes = Number.isInteger(src.canvasMaxAreaInBytes) ? src.canvasMaxAreaInBytes : -1;
    const disableFontFace = typeof src.disableFontFace === "boolean" ? src.disableFontFace : $b3a01b20dd2ade98$var$isNodeJS;
    const fontExtraProperties = src.fontExtraProperties === true;
    const enableXfa = src.enableXfa === true;
    const ownerDocument = src.ownerDocument || globalThis.document;
    const disableRange = src.disableRange === true;
    const disableStream = src.disableStream === true;
    const disableAutoFetch = src.disableAutoFetch === true;
    const pdfBug = src.pdfBug === true;
    const CanvasFactory = src.CanvasFactory || ($b3a01b20dd2ade98$var$isNodeJS ? $b3a01b20dd2ade98$var$NodeCanvasFactory : $b3a01b20dd2ade98$var$DOMCanvasFactory);
    const FilterFactory = src.FilterFactory || ($b3a01b20dd2ade98$var$isNodeJS ? $b3a01b20dd2ade98$var$NodeFilterFactory : $b3a01b20dd2ade98$var$DOMFilterFactory);
    const BinaryDataFactory = src.BinaryDataFactory || ($b3a01b20dd2ade98$var$isNodeJS ? $b3a01b20dd2ade98$var$NodeBinaryDataFactory : $b3a01b20dd2ade98$var$DOMBinaryDataFactory);
    const enableHWA = src.enableHWA === true;
    const enableWebGPU = src.enableWebGPU === true;
    const useWasm = src.useWasm !== false;
    const pagesMapper = src.pagesMapper || new $b3a01b20dd2ade98$var$PagesMapper();
    const useSystemFonts = typeof src.useSystemFonts === "boolean" ? src.useSystemFonts : !$b3a01b20dd2ade98$var$isNodeJS && !disableFontFace;
    const useWorkerFetch = typeof src.useWorkerFetch === "boolean" ? src.useWorkerFetch : !!(BinaryDataFactory === $b3a01b20dd2ade98$var$DOMBinaryDataFactory && cMapUrl && cMapPacked && standardFontDataUrl && wasmUrl && $b3a01b20dd2ade98$var$isValidFetchUrl(cMapUrl, document.baseURI) && $b3a01b20dd2ade98$var$isValidFetchUrl(standardFontDataUrl, document.baseURI) && $b3a01b20dd2ade98$var$isValidFetchUrl(wasmUrl, document.baseURI));
    const styleElement = null;
    $b3a01b20dd2ade98$var$setVerbosityLevel(verbosity);
    const transportFactory = {
        canvasFactory: new CanvasFactory({
            ownerDocument: ownerDocument,
            enableHWA: enableHWA
        }),
        filterFactory: new FilterFactory({
            docId: docId,
            ownerDocument: ownerDocument
        }),
        binaryDataFactory: useWorkerFetch ? null : new BinaryDataFactory({
            cMapUrl: cMapUrl,
            standardFontDataUrl: standardFontDataUrl,
            wasmUrl: wasmUrl
        })
    };
    if (!worker) {
        worker = $b3a01b20dd2ade98$export$84e2e9f37426b265.create({
            verbosity: verbosity,
            port: $b3a01b20dd2ade98$export$edf38ba293eb934.workerPort
        });
        task._worker = worker;
    }
    const docParams = {
        docId: docId,
        apiVersion: "5.6.205",
        data: data,
        password: password,
        disableAutoFetch: disableAutoFetch,
        rangeChunkSize: rangeChunkSize,
        docBaseUrl: docBaseUrl,
        enableXfa: enableXfa,
        evaluatorOptions: {
            maxImageSize: maxImageSize,
            disableFontFace: disableFontFace,
            ignoreErrors: ignoreErrors,
            isEvalSupported: isEvalSupported,
            isOffscreenCanvasSupported: isOffscreenCanvasSupported,
            isImageDecoderSupported: isImageDecoderSupported,
            canvasMaxAreaInBytes: canvasMaxAreaInBytes,
            fontExtraProperties: fontExtraProperties,
            useSystemFonts: useSystemFonts,
            useWasm: useWasm,
            useWorkerFetch: useWorkerFetch,
            cMapUrl: cMapUrl,
            cMapPacked: cMapPacked,
            iccUrl: iccUrl,
            standardFontDataUrl: standardFontDataUrl,
            wasmUrl: wasmUrl,
            enableWebGPU: enableWebGPU
        }
    };
    const transportParams = {
        ownerDocument: ownerDocument,
        pdfBug: pdfBug,
        styleElement: styleElement,
        enableHWA: enableHWA,
        loadingParams: {
            disableAutoFetch: disableAutoFetch,
            enableXfa: enableXfa
        }
    };
    worker.promise.then(function() {
        if (task.destroyed) throw new Error("Loading aborted");
        if (worker.destroyed) throw new Error("Worker was destroyed");
        const workerIdPromise = worker.messageHandler.sendWithPromise("GetDocRequest", docParams, data ? [
            data.buffer
        ] : null);
        let networkStream;
        if (data) ;
        else if (rangeTransport) networkStream = new $b3a01b20dd2ade98$var$PDFDataTransportStream({
            pdfDataRangeTransport: rangeTransport,
            disableRange: disableRange,
            disableStream: disableStream
        });
        else if (url) {
            const NetworkStream = $b3a01b20dd2ade98$var$getNetworkStream(url);
            networkStream = new NetworkStream({
                url: url,
                httpHeaders: httpHeaders,
                withCredentials: withCredentials,
                rangeChunkSize: rangeChunkSize,
                disableRange: disableRange,
                disableStream: disableStream
            });
        } else throw new Error("getDocument - expected either `data`, `range`, or `url` parameter.");
        return workerIdPromise.then((workerId)=>{
            if (task.destroyed) throw new Error("Loading aborted");
            if (worker.destroyed) throw new Error("Worker was destroyed");
            const messageHandler = new $b3a01b20dd2ade98$var$MessageHandler(docId, workerId, worker.port);
            const transport = new $b3a01b20dd2ade98$var$WorkerTransport(messageHandler, task, networkStream, transportParams, transportFactory, pagesMapper);
            task._transport = transport;
            messageHandler.send("Ready", null);
        });
    }).catch(task._capability.reject);
    return task;
}
class $b3a01b20dd2ade98$var$PDFDocumentLoadingTask {
    static #docId = 0;
    _capability = Promise.withResolvers();
    _transport = null;
    _worker = null;
    docId = `d${$b3a01b20dd2ade98$var$PDFDocumentLoadingTask.#docId++}`;
    destroyed = false;
    onPassword = null;
    onProgress = null;
    get promise() {
        return this._capability.promise;
    }
    async destroy() {
        this.destroyed = true;
        try {
            if (this._worker?.port) this._worker._pendingDestroy = true;
            await this._transport?.destroy();
        } catch (ex) {
            if (this._worker?.port) delete this._worker._pendingDestroy;
            throw ex;
        }
        this._transport = null;
        this._worker?.destroy();
        this._worker = null;
    }
    async getData() {
        return this._transport.getData();
    }
}
class $b3a01b20dd2ade98$export$c06899d9d7bce9ab {
    #capability = Promise.withResolvers();
    #progressiveDoneListeners = [];
    #progressiveReadListeners = [];
    #rangeListeners = [];
    constructor(length, initialData, progressiveDone = false, contentDispositionFilename = null){
        this.length = length;
        this.initialData = initialData;
        this.progressiveDone = progressiveDone;
        this.contentDispositionFilename = contentDispositionFilename;
        Object.defineProperty(this, "onDataProgress", {
            value: ()=>{
                $b3a01b20dd2ade98$var$deprecated("`PDFDataRangeTransport.prototype.onDataProgress` - method was removed, since loading progress is now reported automatically through the `PDFDataTransportStream` class (and related code).");
            }
        });
    }
    addRangeListener(listener) {
        this.#rangeListeners.push(listener);
    }
    addProgressiveReadListener(listener) {
        this.#progressiveReadListeners.push(listener);
    }
    addProgressiveDoneListener(listener) {
        this.#progressiveDoneListeners.push(listener);
    }
    onDataRange(begin, chunk) {
        for (const listener of this.#rangeListeners)listener(begin, chunk);
    }
    onDataProgressiveRead(chunk) {
        this.#capability.promise.then(()=>{
            for (const listener of this.#progressiveReadListeners)listener(chunk);
        });
    }
    onDataProgressiveDone() {
        this.#capability.promise.then(()=>{
            for (const listener of this.#progressiveDoneListeners)listener();
        });
    }
    transportReady() {
        this.#capability.resolve();
    }
    requestDataRange(begin, end) {
        $b3a01b20dd2ade98$var$unreachable("Abstract method PDFDataRangeTransport.requestDataRange");
    }
    abort() {}
}
class $b3a01b20dd2ade98$var$PDFDocumentProxy {
    constructor(pdfInfo, transport){
        this._pdfInfo = pdfInfo;
        this._transport = transport;
    }
    get pagesMapper() {
        return this._transport.pagesMapper;
    }
    get annotationStorage() {
        return this._transport.annotationStorage;
    }
    get canvasFactory() {
        return this._transport.canvasFactory;
    }
    get filterFactory() {
        return this._transport.filterFactory;
    }
    get numPages() {
        return this._pdfInfo.numPages;
    }
    get fingerprints() {
        return this._pdfInfo.fingerprints;
    }
    get isPureXfa() {
        return $b3a01b20dd2ade98$export$b8972b998723d602(this, "isPureXfa", !!this._transport._htmlForXfa);
    }
    get allXfaHtml() {
        return this._transport._htmlForXfa;
    }
    getPage(pageNumber) {
        return this._transport.getPage(pageNumber);
    }
    getPageIndex(ref) {
        return this._transport.getPageIndex(ref);
    }
    getDestinations() {
        return this._transport.getDestinations();
    }
    getDestination(id) {
        return this._transport.getDestination(id);
    }
    getPageLabels() {
        return this._transport.getPageLabels();
    }
    getPageLayout() {
        return this._transport.getPageLayout();
    }
    getPageMode() {
        return this._transport.getPageMode();
    }
    getViewerPreferences() {
        return this._transport.getViewerPreferences();
    }
    getOpenAction() {
        return this._transport.getOpenAction();
    }
    getAttachments() {
        return this._transport.getAttachments();
    }
    getAnnotationsByType(types, pageIndexesToSkip) {
        return this._transport.getAnnotationsByType(types, pageIndexesToSkip);
    }
    getJSActions() {
        return this._transport.getDocJSActions();
    }
    getOutline() {
        return this._transport.getOutline();
    }
    getOptionalContentConfig({ intent: intent = "display" } = {}) {
        const { renderingIntent: renderingIntent } = this._transport.getRenderingIntent(intent);
        return this._transport.getOptionalContentConfig(renderingIntent);
    }
    getPermissions() {
        return this._transport.getPermissions();
    }
    getMetadata() {
        return this._transport.getMetadata();
    }
    getMarkInfo() {
        return this._transport.getMarkInfo();
    }
    getData() {
        return this._transport.getData();
    }
    saveDocument() {
        return this._transport.saveDocument();
    }
    extractPages(pageInfos) {
        return this._transport.extractPages(pageInfos);
    }
    getDownloadInfo() {
        return this._transport.downloadInfoCapability.promise;
    }
    getRawData(data) {
        return this._transport.getRawData(data);
    }
    cleanup(keepLoadedFonts = false) {
        return this._transport.startCleanup(keepLoadedFonts || this.isPureXfa);
    }
    destroy() {
        return this.loadingTask.destroy();
    }
    cachedPageNumber(ref) {
        return this._transport.cachedPageNumber(ref);
    }
    get loadingParams() {
        return this._transport.loadingParams;
    }
    get loadingTask() {
        return this._transport.loadingTask;
    }
    getFieldObjects() {
        return this._transport.getFieldObjects();
    }
    hasJSActions() {
        return this._transport.hasJSActions();
    }
    getCalculationOrderIds() {
        return this._transport.getCalculationOrderIds();
    }
}
class $b3a01b20dd2ade98$var$PDFPageProxy {
    #pendingCleanup = false;
    #pagesMapper = null;
    constructor(pageIndex, pageInfo, transport, pagesMapper, pdfBug = false){
        this._pageIndex = pageIndex;
        this._pageInfo = pageInfo;
        this._transport = transport;
        this._stats = pdfBug ? new $b3a01b20dd2ade98$var$StatTimer() : null;
        this._pdfBug = pdfBug;
        this.commonObjs = transport.commonObjs;
        this.objs = new $b3a01b20dd2ade98$var$PDFObjects();
        this._intentStates = new Map();
        this.destroyed = false;
        this.recordedBBoxes = null;
        this.#pagesMapper = pagesMapper;
        this.imageCoordinates = null;
    }
    clone(id) {
        const clone = new $b3a01b20dd2ade98$var$PDFPageProxy(id, this._pageInfo, this._transport, this.#pagesMapper, this._pdfBug);
        clone.clonedFromIndex = this.clonedFromIndex ?? this._pageIndex;
        this._transport.updatePage(clone);
        return clone;
    }
    get pageNumber() {
        return this._pageIndex + 1;
    }
    set pageNumber(value) {
        this._pageIndex = value - 1;
        this._transport.updatePage(this);
    }
    get rotate() {
        return this._pageInfo.rotate;
    }
    get ref() {
        return this._pageInfo.ref;
    }
    get userUnit() {
        return this._pageInfo.userUnit;
    }
    get view() {
        return this._pageInfo.view;
    }
    getViewport({ scale: scale, rotation: rotation = this.rotate, offsetX: offsetX = 0, offsetY: offsetY = 0, dontFlip: dontFlip = false } = {}) {
        return new $b3a01b20dd2ade98$var$PageViewport({
            viewBox: this.view,
            userUnit: this.userUnit,
            scale: scale,
            rotation: rotation,
            offsetX: offsetX,
            offsetY: offsetY,
            dontFlip: dontFlip
        });
    }
    getAnnotations({ intent: intent = "display" } = {}) {
        const { renderingIntent: renderingIntent } = this._transport.getRenderingIntent(intent);
        return this._transport.getAnnotations(this._pageIndex, renderingIntent);
    }
    getJSActions() {
        return this._transport.getPageJSActions(this._pageIndex);
    }
    get filterFactory() {
        return this._transport.filterFactory;
    }
    get isPureXfa() {
        return $b3a01b20dd2ade98$export$b8972b998723d602(this, "isPureXfa", !!this._transport._htmlForXfa);
    }
    async getXfa() {
        return this._transport._htmlForXfa?.children[this._pageIndex] || null;
    }
    render({ canvasContext: canvasContext, canvas: canvas = canvasContext.canvas, viewport: viewport, intent: intent = "display", annotationMode: annotationMode = $b3a01b20dd2ade98$export$5a7af0c07e33392e.ENABLE, transform: transform = null, background: background = null, optionalContentConfigPromise: optionalContentConfigPromise = null, annotationCanvasMap: annotationCanvasMap = null, pageColors: pageColors = null, printAnnotationStorage: printAnnotationStorage = null, isEditing: isEditing = false, recordImages: recordImages = false, recordOperations: recordOperations = false, operationsFilter: operationsFilter = null }) {
        this._stats?.time("Overall");
        const intentArgs = this._transport.getRenderingIntent(intent, annotationMode, printAnnotationStorage, isEditing);
        const { renderingIntent: renderingIntent, cacheKey: cacheKey } = intentArgs;
        this.#pendingCleanup = false;
        optionalContentConfigPromise ||= this._transport.getOptionalContentConfig(renderingIntent);
        const intentState = this._intentStates.getOrInsertComputed(cacheKey, $b3a01b20dd2ade98$export$5b3b706fb9845c88);
        if (intentState.streamReaderCancelTimeout) {
            clearTimeout(intentState.streamReaderCancelTimeout);
            intentState.streamReaderCancelTimeout = null;
        }
        const intentPrint = !!(renderingIntent & $b3a01b20dd2ade98$var$RenderingIntentFlag.PRINT);
        if (!intentState.displayReadyCapability) {
            intentState.displayReadyCapability = Promise.withResolvers();
            intentState.operatorList = {
                fnArray: [],
                argsArray: [],
                lastChunk: false,
                separateAnnots: null
            };
            this._stats?.time("Page Request");
            this._pumpOperatorList(intentArgs);
        }
        const recordForDebugger = !!(this._pdfBug && globalThis.StepperManager?.enabled);
        const shouldRecordOperations = !!canvas && !this.recordedBBoxes && (recordOperations || recordForDebugger);
        const shouldRecordImages = !!canvas && !this.imageCoordinates && recordImages;
        const complete = (error)=>{
            intentState.renderTasks.delete(internalRenderTask);
            if (shouldRecordOperations) {
                const recordedBBoxes = internalRenderTask.gfx?.dependencyTracker.take();
                if (recordedBBoxes) {
                    internalRenderTask.stepper?.setOperatorBBoxes(recordedBBoxes, internalRenderTask.gfx.dependencyTracker.takeDebugMetadata());
                    if (recordOperations) this.recordedBBoxes = recordedBBoxes;
                }
            }
            if (shouldRecordImages && !error) this.imageCoordinates = internalRenderTask.gfx?.imagesTracker.take();
            if (intentPrint) this.#pendingCleanup = true;
            this.#tryCleanup();
            if (error) {
                internalRenderTask.capability.reject(error);
                this._abortOperatorList({
                    intentState: intentState,
                    reason: error instanceof Error ? error : new Error(error)
                });
            } else internalRenderTask.capability.resolve();
            if (this._stats) {
                this._stats.timeEnd("Rendering");
                this._stats.timeEnd("Overall");
                if (globalThis.Stats?.enabled) globalThis.Stats.add(this.pageNumber, this._stats);
            }
        };
        let dependencyTracker = null;
        let bboxTracker = null;
        if (shouldRecordOperations || shouldRecordImages) bboxTracker = new $b3a01b20dd2ade98$var$CanvasBBoxTracker(canvas, intentState.operatorList.length);
        if (shouldRecordOperations) dependencyTracker = new $b3a01b20dd2ade98$var$CanvasDependencyTracker(bboxTracker, recordForDebugger);
        const internalRenderTask = new $b3a01b20dd2ade98$var$InternalRenderTask({
            callback: complete,
            params: {
                canvas: canvas,
                canvasContext: canvasContext,
                dependencyTracker: dependencyTracker ?? bboxTracker,
                imagesTracker: shouldRecordImages ? new $b3a01b20dd2ade98$var$CanvasImagesTracker(canvas) : null,
                viewport: viewport,
                transform: transform,
                background: background
            },
            objs: this.objs,
            commonObjs: this.commonObjs,
            annotationCanvasMap: annotationCanvasMap,
            operatorList: intentState.operatorList,
            pageIndex: this._pageIndex,
            canvasFactory: this._transport.canvasFactory,
            filterFactory: this._transport.filterFactory,
            useRequestAnimationFrame: !intentPrint,
            pdfBug: this._pdfBug,
            pageColors: pageColors,
            enableHWA: this._transport.enableHWA,
            operationsFilter: operationsFilter
        });
        (intentState.renderTasks ||= new Set()).add(internalRenderTask);
        const renderTask = internalRenderTask.task;
        Promise.all([
            intentState.displayReadyCapability.promise,
            optionalContentConfigPromise
        ]).then(([transparency, optionalContentConfig])=>{
            if (this.destroyed) {
                complete();
                return;
            }
            this._stats?.time("Rendering");
            if (!(optionalContentConfig.renderingIntent & renderingIntent)) throw new Error("Must use the same `intent`-argument when calling the `PDFPageProxy.render` and `PDFDocumentProxy.getOptionalContentConfig` methods.");
            internalRenderTask.initializeGraphics({
                transparency: transparency,
                optionalContentConfig: optionalContentConfig
            });
            internalRenderTask.operatorListChanged();
        }).catch(complete);
        return renderTask;
    }
    getOperatorList({ intent: intent = "display", annotationMode: annotationMode = $b3a01b20dd2ade98$export$5a7af0c07e33392e.ENABLE, printAnnotationStorage: printAnnotationStorage = null, isEditing: isEditing = false } = {}) {
        function operatorListChanged() {
            if (intentState.operatorList.lastChunk) {
                intentState.opListReadCapability.resolve(intentState.operatorList);
                intentState.renderTasks.delete(opListTask);
            }
        }
        const intentArgs = this._transport.getRenderingIntent(intent, annotationMode, printAnnotationStorage, isEditing, true);
        const intentState = this._intentStates.getOrInsertComputed(intentArgs.cacheKey, $b3a01b20dd2ade98$export$5b3b706fb9845c88);
        let opListTask;
        if (!intentState.opListReadCapability) {
            opListTask = Object.create(null);
            opListTask.operatorListChanged = operatorListChanged;
            intentState.opListReadCapability = Promise.withResolvers();
            (intentState.renderTasks ||= new Set()).add(opListTask);
            intentState.operatorList = {
                fnArray: [],
                argsArray: [],
                lastChunk: false,
                separateAnnots: null
            };
            this._stats?.time("Page Request");
            this._pumpOperatorList(intentArgs);
        }
        return intentState.opListReadCapability.promise;
    }
    streamTextContent({ includeMarkedContent: includeMarkedContent = false, disableNormalization: disableNormalization = false } = {}) {
        const TEXT_CONTENT_CHUNK_SIZE = 100;
        return this._transport.messageHandler.sendWithStream("GetTextContent", {
            pageId: this.#pagesMapper.getPageId(this._pageIndex + 1) - 1,
            pageIndex: this._pageIndex,
            includeMarkedContent: includeMarkedContent === true,
            disableNormalization: disableNormalization === true
        }, {
            highWaterMark: TEXT_CONTENT_CHUNK_SIZE,
            size (textContent) {
                return textContent.items.length;
            }
        });
    }
    async getTextContent(params = {}) {
        if (this._transport._htmlForXfa) return this.getXfa().then((xfa)=>$b3a01b20dd2ade98$var$XfaText.textContent(xfa));
        const readableStream = this.streamTextContent(params);
        const textContent = {
            items: [],
            styles: Object.create(null),
            lang: null
        };
        for await (const value of readableStream){
            textContent.lang ??= value.lang;
            Object.assign(textContent.styles, value.styles);
            textContent.items.push(...value.items);
        }
        return textContent;
    }
    getStructTree() {
        return this._transport.getStructTree(this._pageIndex);
    }
    _destroy() {
        this.destroyed = true;
        const waitOn = [];
        for (const intentState of this._intentStates.values()){
            this._abortOperatorList({
                intentState: intentState,
                reason: new Error("Page was destroyed."),
                force: true
            });
            if (intentState.opListReadCapability) continue;
            for (const internalRenderTask of intentState.renderTasks){
                waitOn.push(internalRenderTask.completed);
                internalRenderTask.cancel();
            }
        }
        this.objs.clear();
        this.#pendingCleanup = false;
        return Promise.all(waitOn);
    }
    cleanup(resetStats = false) {
        this.#pendingCleanup = true;
        const success = this.#tryCleanup();
        if (resetStats && success) this._stats &&= new $b3a01b20dd2ade98$var$StatTimer();
        return success;
    }
    #tryCleanup() {
        if (!this.#pendingCleanup || this.destroyed) return false;
        for (const { renderTasks: renderTasks, operatorList: operatorList } of this._intentStates.values()){
            if (renderTasks.size > 0 || !operatorList.lastChunk) return false;
        }
        this._intentStates.clear();
        this.objs.clear();
        this.#pendingCleanup = false;
        return true;
    }
    _startRenderPage(transparency, cacheKey) {
        const intentState = this._intentStates.get(cacheKey);
        if (!intentState) return;
        this._stats?.timeEnd("Page Request");
        intentState.displayReadyCapability?.resolve(transparency);
    }
    _renderPageChunk(operatorListChunk, intentState) {
        for(let i = 0, ii = operatorListChunk.length; i < ii; i++){
            intentState.operatorList.fnArray.push(operatorListChunk.fnArray[i]);
            intentState.operatorList.argsArray.push(operatorListChunk.argsArray[i]);
        }
        intentState.operatorList.lastChunk = operatorListChunk.lastChunk;
        intentState.operatorList.separateAnnots = operatorListChunk.separateAnnots;
        for (const internalRenderTask of intentState.renderTasks)internalRenderTask.operatorListChanged();
        if (operatorListChunk.lastChunk) this.#tryCleanup();
    }
    _pumpOperatorList({ renderingIntent: renderingIntent, cacheKey: cacheKey, annotationStorageSerializable: annotationStorageSerializable, modifiedIds: modifiedIds }) {
        const { map: map, transfer: transfer } = annotationStorageSerializable;
        const readableStream = this._transport.messageHandler.sendWithStream("GetOperatorList", {
            pageId: this.#pagesMapper.getPageId(this._pageIndex + 1) - 1,
            pageIndex: this._pageIndex,
            intent: renderingIntent,
            cacheKey: cacheKey,
            annotationStorage: map,
            modifiedIds: modifiedIds
        }, undefined, transfer);
        const reader = readableStream.getReader();
        const intentState = this._intentStates.get(cacheKey);
        intentState.streamReader = reader;
        const pump = ()=>{
            reader.read().then(({ value: value, done: done })=>{
                if (done) {
                    intentState.streamReader = null;
                    return;
                }
                if (this._transport.destroyed) return;
                this._renderPageChunk(value, intentState);
                pump();
            }, (reason)=>{
                intentState.streamReader = null;
                if (this._transport.destroyed) return;
                if (intentState.operatorList) {
                    intentState.operatorList.lastChunk = true;
                    for (const internalRenderTask of intentState.renderTasks)internalRenderTask.operatorListChanged();
                    this.#tryCleanup();
                }
                if (intentState.displayReadyCapability) intentState.displayReadyCapability.reject(reason);
                else if (intentState.opListReadCapability) intentState.opListReadCapability.reject(reason);
                else throw reason;
            });
        };
        pump();
    }
    _abortOperatorList({ intentState: intentState, reason: reason, force: force = false }) {
        if (!intentState.streamReader) return;
        if (intentState.streamReaderCancelTimeout) {
            clearTimeout(intentState.streamReaderCancelTimeout);
            intentState.streamReaderCancelTimeout = null;
        }
        if (!force) {
            if (intentState.renderTasks.size > 0) return;
            if (reason instanceof $b3a01b20dd2ade98$export$245847d31c09154f) {
                let delay = $b3a01b20dd2ade98$var$RENDERING_CANCELLED_TIMEOUT;
                if (reason.extraDelay > 0 && reason.extraDelay < 1000) delay += reason.extraDelay;
                intentState.streamReaderCancelTimeout = setTimeout(()=>{
                    intentState.streamReaderCancelTimeout = null;
                    this._abortOperatorList({
                        intentState: intentState,
                        reason: reason,
                        force: true
                    });
                }, delay);
                return;
            }
        }
        intentState.streamReader.cancel(new $b3a01b20dd2ade98$export$d0e978393d193d1a(reason.message)).catch(()=>{});
        intentState.streamReader = null;
        if (this._transport.destroyed) return;
        for (const [curCacheKey, curIntentState] of this._intentStates)if (curIntentState === intentState) {
            this._intentStates.delete(curCacheKey);
            break;
        }
        this.cleanup();
    }
    get stats() {
        return this._stats;
    }
}
class $b3a01b20dd2ade98$export$84e2e9f37426b265 {
    #capability = Promise.withResolvers();
    #messageHandler = null;
    #port = null;
    #webWorker = null;
    static #fakeWorkerId = 0;
    static #isWorkerDisabled = false;
    static #workerPorts = new WeakMap();
    static{
        if ($b3a01b20dd2ade98$var$isNodeJS) {
            this.#isWorkerDisabled = true;
            $b3a01b20dd2ade98$export$edf38ba293eb934.workerSrc ||= "./pdf.worker.mjs";
        }
        this._isSameOrigin = (baseUrl, otherUrl)=>{
            const base = URL.parse(baseUrl);
            if (!base?.origin || base.origin === "null") return false;
            const other = new URL(otherUrl, base);
            return base.origin === other.origin;
        };
        this._createCDNWrapper = (url)=>{
            const wrapper = `await import("${url}");`;
            return URL.createObjectURL(new Blob([
                wrapper
            ], {
                type: "text/javascript"
            }));
        };
    }
    constructor({ name: name = null, port: port = null, verbosity: verbosity = $b3a01b20dd2ade98$var$getVerbosityLevel() } = {}){
        this.name = name;
        this.destroyed = false;
        this.verbosity = verbosity;
        if (port) {
            if ($b3a01b20dd2ade98$export$84e2e9f37426b265.#workerPorts.has(port)) throw new Error("Cannot use more than one PDFWorker per port.");
            $b3a01b20dd2ade98$export$84e2e9f37426b265.#workerPorts.set(port, this);
            this.#initializeFromPort(port);
        } else this.#initialize();
    }
    get promise() {
        return this.#capability.promise;
    }
    #resolve() {
        this.#capability.resolve();
        this.#messageHandler.send("configure", {
            verbosity: this.verbosity
        });
    }
    get port() {
        return this.#port;
    }
    get messageHandler() {
        return this.#messageHandler;
    }
    #initializeFromPort(port) {
        this.#port = port;
        this.#messageHandler = new $b3a01b20dd2ade98$var$MessageHandler("main", "worker", port);
        this.#messageHandler.on("ready", ()=>{});
        this.#resolve();
    }
    #initialize() {
        if ($b3a01b20dd2ade98$export$84e2e9f37426b265.#isWorkerDisabled || $b3a01b20dd2ade98$export$84e2e9f37426b265.#mainThreadWorkerMessageHandler) {
            this.#setupFakeWorker();
            return;
        }
        let { workerSrc: workerSrc } = $b3a01b20dd2ade98$export$84e2e9f37426b265;
        try {
            if (!$b3a01b20dd2ade98$export$84e2e9f37426b265._isSameOrigin(window.location, workerSrc)) workerSrc = $b3a01b20dd2ade98$export$84e2e9f37426b265._createCDNWrapper(new URL(workerSrc, window.location).href);
            const worker = new Worker(workerSrc, {
                type: "module"
            });
            const messageHandler = new $b3a01b20dd2ade98$var$MessageHandler("main", "worker", worker);
            const terminateEarly = ()=>{
                ac.abort();
                messageHandler.destroy();
                worker.terminate();
                if (this.destroyed) this.#capability.reject(new Error("Worker was destroyed"));
                else this.#setupFakeWorker();
            };
            const ac = new AbortController();
            worker.addEventListener("error", ()=>{
                if (!this.#webWorker) terminateEarly();
            }, {
                signal: ac.signal
            });
            messageHandler.on("test", (data)=>{
                ac.abort();
                if (this.destroyed || !data) {
                    terminateEarly();
                    return;
                }
                this.#messageHandler = messageHandler;
                this.#port = worker;
                this.#webWorker = worker;
                this.#resolve();
            });
            messageHandler.on("ready", (data)=>{
                ac.abort();
                if (this.destroyed) {
                    terminateEarly();
                    return;
                }
                try {
                    sendTest();
                } catch  {
                    this.#setupFakeWorker();
                }
            });
            const sendTest = ()=>{
                const testObj = new Uint8Array();
                messageHandler.send("test", testObj, [
                    testObj.buffer
                ]);
            };
            sendTest();
            return;
        } catch  {
            $b3a01b20dd2ade98$var$info("The worker has been disabled.");
        }
        this.#setupFakeWorker();
    }
    #setupFakeWorker() {
        if (!$b3a01b20dd2ade98$export$84e2e9f37426b265.#isWorkerDisabled) {
            $b3a01b20dd2ade98$var$warn("Setting up fake worker.");
            $b3a01b20dd2ade98$export$84e2e9f37426b265.#isWorkerDisabled = true;
        }
        $b3a01b20dd2ade98$export$84e2e9f37426b265._setupFakeWorkerGlobal.then((WorkerMessageHandler)=>{
            if (this.destroyed) {
                this.#capability.reject(new Error("Worker was destroyed"));
                return;
            }
            const port = new $b3a01b20dd2ade98$var$LoopbackPort();
            this.#port = port;
            const id = `fake${$b3a01b20dd2ade98$export$84e2e9f37426b265.#fakeWorkerId++}`;
            const workerHandler = new $b3a01b20dd2ade98$var$MessageHandler(id + "_worker", id, port);
            WorkerMessageHandler.setup(workerHandler, port);
            this.#messageHandler = new $b3a01b20dd2ade98$var$MessageHandler(id, id + "_worker", port);
            this.#resolve();
        }).catch((reason)=>{
            this.#capability.reject(new Error(`Setting up fake worker failed: "${reason.message}".`));
        });
    }
    destroy() {
        this.destroyed = true;
        this.#webWorker?.terminate();
        this.#webWorker = null;
        $b3a01b20dd2ade98$export$84e2e9f37426b265.#workerPorts.delete(this.#port);
        this.#port = null;
        this.#messageHandler?.destroy();
        this.#messageHandler = null;
    }
    static create(params) {
        const cachedPort = this.#workerPorts.get(params?.port);
        if (cachedPort) {
            if (cachedPort._pendingDestroy) throw new Error("PDFWorker.create - the worker is being destroyed.\nPlease remember to await `PDFDocumentLoadingTask.destroy()`-calls.");
            return cachedPort;
        }
        return new $b3a01b20dd2ade98$export$84e2e9f37426b265(params);
    }
    static get workerSrc() {
        if ($b3a01b20dd2ade98$export$edf38ba293eb934.workerSrc) return $b3a01b20dd2ade98$export$edf38ba293eb934.workerSrc;
        throw new Error('No "GlobalWorkerOptions.workerSrc" specified.');
    }
    static get #mainThreadWorkerMessageHandler() {
        try {
            return globalThis.pdfjsWorker?.WorkerMessageHandler || null;
        } catch  {
            return null;
        }
    }
    static get _setupFakeWorkerGlobal() {
        const loader = async ()=>{
            if (this.#mainThreadWorkerMessageHandler) return this.#mainThreadWorkerMessageHandler;
            const worker = await import(/*webpackIgnore: true*/ /*@vite-ignore*/ this.workerSrc);
            return worker.WorkerMessageHandler;
        };
        return $b3a01b20dd2ade98$export$b8972b998723d602(this, "_setupFakeWorkerGlobal", loader());
    }
}
class $b3a01b20dd2ade98$var$WorkerTransport {
    downloadInfoCapability = Promise.withResolvers();
    #fullReader = null;
    #methodPromises = new Map();
    #networkStream = null;
    #pageCache = new Map();
    #pagePromises = new Map();
    #pageRefCache = new Map();
    #passwordCapability = null;
    constructor(messageHandler, loadingTask, networkStream, params, factory, pagesMapper){
        this.messageHandler = messageHandler;
        this.loadingTask = loadingTask;
        this.#networkStream = networkStream;
        this.commonObjs = new $b3a01b20dd2ade98$var$PDFObjects();
        this.fontLoader = new $b3a01b20dd2ade98$var$FontLoader({
            ownerDocument: params.ownerDocument,
            styleElement: params.styleElement
        });
        this.enableHWA = params.enableHWA;
        this.loadingParams = params.loadingParams;
        this._params = params;
        this.canvasFactory = factory.canvasFactory;
        this.filterFactory = factory.filterFactory;
        this.binaryDataFactory = factory.binaryDataFactory;
        this.pagesMapper = pagesMapper;
        this.destroyed = false;
        this.destroyCapability = null;
        this.setupMessageHandler();
    }
    updatePage(page) {
        const { _pageIndex: _pageIndex } = page;
        this.#pageCache.set(_pageIndex, page);
        this.#pagePromises.set(_pageIndex, Promise.resolve(page));
    }
    #cacheSimpleMethod(name, data = null) {
        return this.#methodPromises.getOrInsertComputed(name, ()=>this.messageHandler.sendWithPromise(name, data));
    }
    #onProgress({ loaded: loaded, total: total }) {
        this.loadingTask.onProgress?.({
            loaded: loaded,
            total: total,
            percent: total ? $b3a01b20dd2ade98$export$b8106b171181a554(Math.round(loaded / total * 100), 0, 100) : NaN
        });
    }
    get annotationStorage() {
        return $b3a01b20dd2ade98$export$b8972b998723d602(this, "annotationStorage", new $b3a01b20dd2ade98$var$AnnotationStorage());
    }
    getRenderingIntent(intent, annotationMode = $b3a01b20dd2ade98$export$5a7af0c07e33392e.ENABLE, printAnnotationStorage = null, isEditing = false, isOpList = false) {
        let renderingIntent = $b3a01b20dd2ade98$var$RenderingIntentFlag.DISPLAY;
        let annotationStorageSerializable = $b3a01b20dd2ade98$var$SerializableEmpty;
        switch(intent){
            case "any":
                renderingIntent = $b3a01b20dd2ade98$var$RenderingIntentFlag.ANY;
                break;
            case "display":
                break;
            case "print":
                renderingIntent = $b3a01b20dd2ade98$var$RenderingIntentFlag.PRINT;
                break;
            default:
                $b3a01b20dd2ade98$var$warn(`getRenderingIntent - invalid intent: ${intent}`);
        }
        const annotationStorage = renderingIntent & $b3a01b20dd2ade98$var$RenderingIntentFlag.PRINT && printAnnotationStorage instanceof $b3a01b20dd2ade98$var$PrintAnnotationStorage ? printAnnotationStorage : this.annotationStorage;
        switch(annotationMode){
            case $b3a01b20dd2ade98$export$5a7af0c07e33392e.DISABLE:
                renderingIntent += $b3a01b20dd2ade98$var$RenderingIntentFlag.ANNOTATIONS_DISABLE;
                break;
            case $b3a01b20dd2ade98$export$5a7af0c07e33392e.ENABLE:
                break;
            case $b3a01b20dd2ade98$export$5a7af0c07e33392e.ENABLE_FORMS:
                renderingIntent += $b3a01b20dd2ade98$var$RenderingIntentFlag.ANNOTATIONS_FORMS;
                break;
            case $b3a01b20dd2ade98$export$5a7af0c07e33392e.ENABLE_STORAGE:
                renderingIntent += $b3a01b20dd2ade98$var$RenderingIntentFlag.ANNOTATIONS_STORAGE;
                annotationStorageSerializable = annotationStorage.serializable;
                break;
            default:
                $b3a01b20dd2ade98$var$warn(`getRenderingIntent - invalid annotationMode: ${annotationMode}`);
        }
        if (isEditing) renderingIntent += $b3a01b20dd2ade98$var$RenderingIntentFlag.IS_EDITING;
        if (isOpList) renderingIntent += $b3a01b20dd2ade98$var$RenderingIntentFlag.OPLIST;
        const { ids: modifiedIds, hash: modifiedIdsHash } = annotationStorage.modifiedIds;
        const cacheKeyBuf = [
            renderingIntent,
            annotationStorageSerializable.hash,
            modifiedIdsHash
        ];
        return {
            renderingIntent: renderingIntent,
            cacheKey: cacheKeyBuf.join("_"),
            annotationStorageSerializable: annotationStorageSerializable,
            modifiedIds: modifiedIds
        };
    }
    destroy() {
        if (this.destroyCapability) return this.destroyCapability.promise;
        this.destroyed = true;
        this.destroyCapability = Promise.withResolvers();
        this.#passwordCapability?.reject(new Error("Worker was destroyed during onPassword callback"));
        const waitOn = [];
        for (const page of this.#pageCache.values())waitOn.push(page._destroy());
        this.#pageCache.clear();
        this.#pagePromises.clear();
        this.#pageRefCache.clear();
        if (this.hasOwnProperty("annotationStorage")) this.annotationStorage.resetModified();
        const terminated = this.messageHandler.sendWithPromise("Terminate", null);
        waitOn.push(terminated);
        Promise.all(waitOn).then(()=>{
            this.commonObjs.clear();
            this.fontLoader.clear();
            this.#methodPromises.clear();
            this.filterFactory.destroy();
            $b3a01b20dd2ade98$export$fdbdc423a78c5262.cleanup();
            this.#networkStream?.cancelAllRequests(new $b3a01b20dd2ade98$export$d0e978393d193d1a("Worker was terminated."));
            this.messageHandler?.destroy();
            this.messageHandler = null;
            this.destroyCapability.resolve();
        }, this.destroyCapability.reject);
        return this.destroyCapability.promise;
    }
    setupMessageHandler() {
        const { messageHandler: messageHandler, loadingTask: loadingTask } = this;
        messageHandler.on("GetReader", (data, sink)=>{
            $b3a01b20dd2ade98$var$assert(this.#networkStream, "GetReader - no `BasePDFStream` instance available.");
            this.#fullReader = this.#networkStream.getFullReader();
            this.#fullReader.onProgress = (evt)=>this.#onProgress(evt);
            sink.onPull = ()=>{
                this.#fullReader.read().then(function({ value: value, done: done }) {
                    if (done) {
                        sink.close();
                        return;
                    }
                    $b3a01b20dd2ade98$var$assert(value instanceof ArrayBuffer, "GetReader - expected an ArrayBuffer.");
                    sink.enqueue(new Uint8Array(value), 1, [
                        value
                    ]);
                }).catch((reason)=>{
                    sink.error(reason);
                });
            };
            sink.onCancel = (reason)=>{
                this.#fullReader.cancel(reason);
                sink.ready.catch((readyReason)=>{
                    if (this.destroyed) return;
                    throw readyReason;
                });
            };
        });
        messageHandler.on("ReaderHeadersReady", async (data)=>{
            await this.#fullReader.headersReady;
            const { isStreamingSupported: isStreamingSupported, isRangeSupported: isRangeSupported, contentLength: contentLength } = this.#fullReader;
            if (isStreamingSupported && isRangeSupported) this.#fullReader.onProgress = null;
            return {
                isStreamingSupported: isStreamingSupported,
                isRangeSupported: isRangeSupported,
                contentLength: contentLength
            };
        });
        messageHandler.on("GetRangeReader", (data, sink)=>{
            $b3a01b20dd2ade98$var$assert(this.#networkStream, "GetRangeReader - no `BasePDFStream` instance available.");
            const rangeReader = this.#networkStream.getRangeReader(data.begin, data.end);
            if (!rangeReader) {
                sink.close();
                return;
            }
            sink.onPull = ()=>{
                rangeReader.read().then(function({ value: value, done: done }) {
                    if (done) {
                        sink.close();
                        return;
                    }
                    $b3a01b20dd2ade98$var$assert(value instanceof ArrayBuffer, "GetRangeReader - expected an ArrayBuffer.");
                    sink.enqueue(new Uint8Array(value), 1, [
                        value
                    ]);
                }).catch((reason)=>{
                    sink.error(reason);
                });
            };
            sink.onCancel = (reason)=>{
                rangeReader.cancel(reason);
                sink.ready.catch((readyReason)=>{
                    if (this.destroyed) return;
                    throw readyReason;
                });
            };
        });
        messageHandler.on("GetDoc", ({ pdfInfo: pdfInfo })=>{
            this.pagesMapper.pagesNumber = pdfInfo.numPages;
            this._numPages = pdfInfo.numPages;
            this._htmlForXfa = pdfInfo.htmlForXfa;
            delete pdfInfo.htmlForXfa;
            loadingTask._capability.resolve(new $b3a01b20dd2ade98$var$PDFDocumentProxy(pdfInfo, this));
        });
        messageHandler.on("DocException", (ex)=>{
            loadingTask._capability.reject($b3a01b20dd2ade98$var$wrapReason(ex));
        });
        messageHandler.on("PasswordRequest", (ex)=>{
            this.#passwordCapability = Promise.withResolvers();
            try {
                if (!loadingTask.onPassword) throw $b3a01b20dd2ade98$var$wrapReason(ex);
                const updatePassword = (password)=>{
                    if (password instanceof Error) this.#passwordCapability.reject(password);
                    else this.#passwordCapability.resolve({
                        password: password
                    });
                };
                loadingTask.onPassword(updatePassword, ex.code);
            } catch (err) {
                this.#passwordCapability.reject(err);
            }
            return this.#passwordCapability.promise;
        });
        messageHandler.on("DataLoaded", (data)=>{
            this.#onProgress({
                loaded: data.length,
                total: data.length
            });
            this.downloadInfoCapability.resolve(data);
        });
        messageHandler.on("StartRenderPage", (data)=>{
            if (this.destroyed) return;
            const page = this.#pageCache.get(data.pageIndex);
            page._startRenderPage(data.transparency, data.cacheKey);
        });
        messageHandler.on("commonobj", ([id, type, exportedData])=>{
            if (this.destroyed) return null;
            if (this.commonObjs.has(id)) return null;
            switch(type){
                case "Font":
                    if ("error" in exportedData) {
                        const exportedError = exportedData.error;
                        $b3a01b20dd2ade98$var$warn(`Error during font loading: ${exportedError}`);
                        this.commonObjs.resolve(id, exportedError);
                        break;
                    }
                    const fontData = new $b3a01b20dd2ade98$var$FontInfo(exportedData);
                    const inspectFont = this._params.pdfBug && globalThis.FontInspector?.enabled ? (font, url)=>globalThis.FontInspector.fontAdded(font, url) : null;
                    const font = new $b3a01b20dd2ade98$var$FontFaceObject(fontData, inspectFont, exportedData.charProcOperatorList, exportedData.extra);
                    this.fontLoader.bind(font).catch(()=>messageHandler.sendWithPromise("FontFallback", {
                            id: id
                        })).finally(()=>{
                        if (!font.fontExtraProperties) font.clearData();
                        this.commonObjs.resolve(id, font);
                    });
                    break;
                case "CopyLocalImage":
                    const { imageRef: imageRef } = exportedData;
                    $b3a01b20dd2ade98$var$assert(imageRef, "The imageRef must be defined.");
                    for (const pageProxy of this.#pageCache.values())for (const [, data] of pageProxy.objs){
                        if (data?.ref !== imageRef) continue;
                        if (!data.dataLen) return null;
                        this.commonObjs.resolve(id, structuredClone(data));
                        return data.dataLen;
                    }
                    break;
                case "FontPath":
                    this.commonObjs.resolve(id, new $b3a01b20dd2ade98$var$FontPathInfo(exportedData));
                    break;
                case "Image":
                    this.commonObjs.resolve(id, exportedData);
                    break;
                case "Pattern":
                    const pattern = new $b3a01b20dd2ade98$var$PatternInfo(exportedData);
                    this.commonObjs.resolve(id, pattern.getIR());
                    break;
                default:
                    throw new Error(`Got unknown common object type ${type}`);
            }
            return null;
        });
        messageHandler.on("obj", ([id, pageIndex, type, imageData])=>{
            if (this.destroyed) return;
            const pageProxy = this.#pageCache.get(pageIndex);
            if (pageProxy.objs.has(id)) return;
            if (pageProxy._intentStates.size === 0) {
                imageData?.bitmap?.close();
                return;
            }
            switch(type){
                case "Image":
                case "Pattern":
                    pageProxy.objs.resolve(id, imageData);
                    break;
                default:
                    throw new Error(`Got unknown object type ${type}`);
            }
        });
        messageHandler.on("DocProgress", (data)=>{
            if (this.destroyed) return;
            this.#onProgress(data);
        });
        messageHandler.on("PrepareWebGPU", ()=>{
            if (this.destroyed) return;
            $b3a01b20dd2ade98$var$initWebGPUMesh();
        });
        messageHandler.on("FetchBinaryData", async (data)=>{
            if (this.destroyed) throw new Error("Worker was destroyed.");
            if (!this.binaryDataFactory) throw new Error("`BinaryDataFactory` not initialized, see the `useWorkerFetch` parameter.");
            return this.binaryDataFactory.fetch(data);
        });
    }
    getData() {
        return this.messageHandler.sendWithPromise("GetData", null);
    }
    saveDocument() {
        if (this.annotationStorage.size <= 0) $b3a01b20dd2ade98$var$warn("saveDocument called while `annotationStorage` is empty, please use the getData-method instead.");
        const { map: map, transfer: transfer } = this.annotationStorage.serializable;
        return this.messageHandler.sendWithPromise("SaveDocument", {
            isPureXfa: !!this._htmlForXfa,
            numPages: this._numPages,
            annotationStorage: map,
            filename: this.#fullReader?.filename ?? null
        }, transfer).finally(()=>{
            this.annotationStorage.resetModified();
        });
    }
    extractPages(pageInfos) {
        const params = {
            pageInfos: pageInfos
        };
        let transfer;
        if (this.annotationStorage.size > 0) {
            const { map: map, transfer: t } = this.annotationStorage.serializable;
            params.annotationStorage = map;
            transfer = t;
        }
        return this.messageHandler.sendWithPromise("ExtractPages", params, transfer).finally(()=>{
            this.annotationStorage.resetModified();
        });
    }
    getPage(pageNumber) {
        if (!Number.isInteger(pageNumber) || pageNumber <= 0 || pageNumber > this.pagesMapper.pagesNumber) return Promise.reject(new Error("Invalid page request."));
        const pageIndex = pageNumber - 1;
        const newPageIndex = this.pagesMapper.getPageId(pageNumber) - 1;
        const cachedPromise = this.#pagePromises.get(pageIndex);
        if (cachedPromise) return cachedPromise;
        const promise = this.messageHandler.sendWithPromise("GetPage", {
            pageIndex: newPageIndex
        }).then((pageInfo)=>{
            if (this.destroyed) throw new Error("Transport destroyed");
            if (pageInfo.refStr) this.#pageRefCache.set(pageInfo.refStr, newPageIndex);
            const page = new $b3a01b20dd2ade98$var$PDFPageProxy(pageIndex, pageInfo, this, this.pagesMapper, this._params.pdfBug);
            this.#pageCache.set(pageIndex, page);
            return page;
        });
        this.#pagePromises.set(pageIndex, promise);
        return promise;
    }
    async getPageIndex(ref) {
        if (!$b3a01b20dd2ade98$var$isRefProxy(ref)) throw new Error("Invalid pageIndex request.");
        const index = await this.messageHandler.sendWithPromise("GetPageIndex", {
            num: ref.num,
            gen: ref.gen
        });
        const pageNumber = this.pagesMapper.getPageNumber(index + 1);
        if (pageNumber === 0) throw new Error("GetPageIndex: page has been removed.");
        return pageNumber - 1;
    }
    getAnnotations(pageIndex, intent) {
        return this.messageHandler.sendWithPromise("GetAnnotations", {
            pageIndex: this.pagesMapper.getPageId(pageIndex + 1) - 1,
            intent: intent
        });
    }
    getFieldObjects() {
        return this.#cacheSimpleMethod("GetFieldObjects");
    }
    hasJSActions() {
        return this.#cacheSimpleMethod("HasJSActions");
    }
    getCalculationOrderIds() {
        return this.messageHandler.sendWithPromise("GetCalculationOrderIds", null);
    }
    getDestinations() {
        return this.messageHandler.sendWithPromise("GetDestinations", null);
    }
    getDestination(id) {
        if (typeof id !== "string") return Promise.reject(new Error("Invalid destination request."));
        return this.messageHandler.sendWithPromise("GetDestination", {
            id: id
        });
    }
    getPageLabels() {
        return this.messageHandler.sendWithPromise("GetPageLabels", null);
    }
    getPageLayout() {
        return this.messageHandler.sendWithPromise("GetPageLayout", null);
    }
    getPageMode() {
        return this.messageHandler.sendWithPromise("GetPageMode", null);
    }
    getViewerPreferences() {
        return this.messageHandler.sendWithPromise("GetViewerPreferences", null);
    }
    getOpenAction() {
        return this.messageHandler.sendWithPromise("GetOpenAction", null);
    }
    getAttachments() {
        return this.messageHandler.sendWithPromise("GetAttachments", null);
    }
    getAnnotationsByType(types, pageIndexesToSkip) {
        return this.messageHandler.sendWithPromise("GetAnnotationsByType", {
            types: types,
            pageIndexesToSkip: pageIndexesToSkip
        });
    }
    getDocJSActions() {
        return this.#cacheSimpleMethod("GetDocJSActions");
    }
    getPageJSActions(pageIndex) {
        return this.messageHandler.sendWithPromise("GetPageJSActions", {
            pageIndex: this.pagesMapper.getPageId(pageIndex + 1) - 1
        });
    }
    getStructTree(pageIndex) {
        return this.messageHandler.sendWithPromise("GetStructTree", {
            pageIndex: this.pagesMapper.getPageId(pageIndex + 1) - 1
        });
    }
    getOutline() {
        return this.messageHandler.sendWithPromise("GetOutline", null);
    }
    getOptionalContentConfig(renderingIntent) {
        return this.#cacheSimpleMethod("GetOptionalContentConfig").then((data)=>new $b3a01b20dd2ade98$var$OptionalContentConfig(data, renderingIntent));
    }
    getPermissions() {
        return this.messageHandler.sendWithPromise("GetPermissions", null);
    }
    getMetadata() {
        const name = "GetMetadata";
        return this.#methodPromises.getOrInsertComputed(name, ()=>this.messageHandler.sendWithPromise(name, null).then((results)=>({
                    info: results[0],
                    metadata: results[1] ? new $b3a01b20dd2ade98$var$Metadata(results[1]) : null,
                    contentDispositionFilename: this.#fullReader?.filename ?? null,
                    contentLength: this.#fullReader?.contentLength ?? null,
                    hasStructTree: results[2]
                })));
    }
    getMarkInfo() {
        return this.messageHandler.sendWithPromise("GetMarkInfo", null);
    }
    getRawData(data) {
        return this.messageHandler.sendWithPromise("GetRawData", data);
    }
    async startCleanup(keepLoadedFonts = false) {
        if (this.destroyed) return;
        await this.messageHandler.sendWithPromise("Cleanup", null);
        for (const page of this.#pageCache.values()){
            const cleanupSuccessful = page.cleanup();
            if (!cleanupSuccessful) throw new Error(`startCleanup: Page ${page.pageNumber} is currently rendering.`);
        }
        this.commonObjs.clear();
        if (!keepLoadedFonts) this.fontLoader.clear();
        this.#methodPromises.clear();
        this.filterFactory.destroy(true);
        $b3a01b20dd2ade98$export$fdbdc423a78c5262.cleanup();
    }
    cachedPageNumber(ref) {
        if (!$b3a01b20dd2ade98$var$isRefProxy(ref)) return null;
        const refStr = ref.gen === 0 ? `${ref.num}R` : `${ref.num}R${ref.gen}`;
        const pageIndex = this.#pageRefCache.get(refStr);
        if (pageIndex >= 0) {
            const pageNumber = this.pagesMapper.getPageNumber(pageIndex + 1);
            if (pageNumber !== 0) return pageNumber;
        }
        return null;
    }
}
class $b3a01b20dd2ade98$var$RenderTask {
    _internalRenderTask = null;
    onContinue = null;
    onError = null;
    constructor(internalRenderTask){
        this._internalRenderTask = internalRenderTask;
    }
    get promise() {
        return this._internalRenderTask.capability.promise;
    }
    cancel(extraDelay = 0) {
        this._internalRenderTask.cancel(null, extraDelay);
    }
    get separateAnnots() {
        const { separateAnnots: separateAnnots } = this._internalRenderTask.operatorList;
        if (!separateAnnots) return false;
        const { annotationCanvasMap: annotationCanvasMap } = this._internalRenderTask;
        return separateAnnots.form || separateAnnots.canvas && annotationCanvasMap?.size > 0;
    }
    get imageCoordinates() {
        return this._internalRenderTask.imageCoordinates || null;
    }
}
class $b3a01b20dd2ade98$var$InternalRenderTask {
    #rAF = null;
    static #canvasInUse = new WeakSet();
    constructor({ callback: callback, params: params, objs: objs, commonObjs: commonObjs, annotationCanvasMap: annotationCanvasMap, operatorList: operatorList, pageIndex: pageIndex, canvasFactory: canvasFactory, filterFactory: filterFactory, useRequestAnimationFrame: useRequestAnimationFrame = false, pdfBug: pdfBug = false, pageColors: pageColors = null, enableHWA: enableHWA = false, operationsFilter: operationsFilter = null }){
        this.callback = callback;
        this.params = params;
        this.objs = objs;
        this.commonObjs = commonObjs;
        this.annotationCanvasMap = annotationCanvasMap;
        this.operatorListIdx = null;
        this.operatorList = operatorList;
        this._pageIndex = pageIndex;
        this.canvasFactory = canvasFactory;
        this.filterFactory = filterFactory;
        this._pdfBug = pdfBug;
        this.pageColors = pageColors;
        this.running = false;
        this.graphicsReadyCallback = null;
        this.graphicsReady = false;
        this._useRequestAnimationFrame = useRequestAnimationFrame === true && typeof window !== "undefined";
        this.cancelled = false;
        this.capability = Promise.withResolvers();
        this.task = new $b3a01b20dd2ade98$var$RenderTask(this);
        this._cancelBound = this.cancel.bind(this);
        this._continueBound = this._continue.bind(this);
        this._scheduleNextBound = this._scheduleNext.bind(this);
        this._nextBound = this._next.bind(this);
        this._canvas = params.canvas;
        this._canvasContext = params.canvas ? null : params.canvasContext;
        this._enableHWA = enableHWA;
        this._dependencyTracker = params.dependencyTracker;
        this._imagesTracker = params.imagesTracker;
        this._operationsFilter = operationsFilter;
    }
    get completed() {
        return this.capability.promise.catch(function() {});
    }
    initializeGraphics({ transparency: transparency = false, optionalContentConfig: optionalContentConfig }) {
        if (this.cancelled) return;
        if (this._canvas) {
            if ($b3a01b20dd2ade98$var$InternalRenderTask.#canvasInUse.has(this._canvas)) throw new Error("Cannot use the same canvas during multiple render() operations. Use different canvas or ensure previous operations were cancelled or completed.");
            $b3a01b20dd2ade98$var$InternalRenderTask.#canvasInUse.add(this._canvas);
        }
        if (this._pdfBug && globalThis.StepperManager?.enabled) {
            this.stepper = globalThis.StepperManager.create(this._pageIndex);
            this.stepper.init(this.operatorList);
            this.stepper.nextBreakPoint = this.stepper.getNextBreakPoint();
        }
        const { viewport: viewport, transform: transform, background: background, dependencyTracker: dependencyTracker, imagesTracker: imagesTracker } = this.params;
        const canvasContext = this._canvasContext || this._canvas.getContext("2d", {
            alpha: false,
            willReadFrequently: !this._enableHWA
        });
        this.gfx = new $b3a01b20dd2ade98$var$CanvasGraphics(canvasContext, this.commonObjs, this.objs, this.canvasFactory, this.filterFactory, {
            optionalContentConfig: optionalContentConfig
        }, this.annotationCanvasMap, this.pageColors, dependencyTracker, imagesTracker);
        this.gfx.beginDrawing({
            transform: transform,
            viewport: viewport,
            transparency: transparency,
            background: background
        });
        this.operatorListIdx = 0;
        this.graphicsReady = true;
        this.graphicsReadyCallback?.();
    }
    cancel(error = null, extraDelay = 0) {
        this.running = false;
        this.cancelled = true;
        this.gfx?.endDrawing();
        if (this.#rAF) {
            window.cancelAnimationFrame(this.#rAF);
            this.#rAF = null;
        }
        $b3a01b20dd2ade98$var$InternalRenderTask.#canvasInUse.delete(this._canvas);
        error ||= new $b3a01b20dd2ade98$export$245847d31c09154f(`Rendering cancelled, page ${this._pageIndex + 1}`, extraDelay);
        this.callback(error);
        this.task.onError?.(error);
    }
    operatorListChanged() {
        if (!this.graphicsReady) {
            this.graphicsReadyCallback ||= this._continueBound;
            return;
        }
        this.gfx.dependencyTracker?.growOperationsCount(this.operatorList.fnArray.length);
        this.stepper?.updateOperatorList(this.operatorList);
        if (this.running) return;
        this._continue();
    }
    _continue() {
        this.running = true;
        if (this.cancelled) return;
        if (this.task.onContinue) this.task.onContinue(this._scheduleNextBound);
        else this._scheduleNext();
    }
    _scheduleNext() {
        if (this._useRequestAnimationFrame) this.#rAF = window.requestAnimationFrame(()=>{
            this.#rAF = null;
            this._nextBound().catch(this._cancelBound);
        });
        else Promise.resolve().then(this._nextBound).catch(this._cancelBound);
    }
    async _next() {
        if (this.cancelled) return;
        this.operatorListIdx = this.gfx.executeOperatorList(this.operatorList, this.operatorListIdx, this._continueBound, this.stepper, this._operationsFilter);
        if (this.operatorListIdx === this.operatorList.argsArray.length) {
            this.running = false;
            if (this.operatorList.lastChunk) {
                this.gfx.endDrawing();
                $b3a01b20dd2ade98$var$InternalRenderTask.#canvasInUse.delete(this._canvas);
                this.callback();
            }
        }
    }
}
const $b3a01b20dd2ade98$export$83d89fbfd8236492 = "5.6.205";
const $b3a01b20dd2ade98$export$3f8fe6489e95757d = "ada343803";
class $b3a01b20dd2ade98$export$9feb1bc2e5f1ccb3 {
    #button = null;
    #buttonSwatch = null;
    #defaultColor;
    #dropdown = null;
    #dropdownWasFromKeyboard = false;
    #isMainColorPicker = false;
    #editor = null;
    #eventBus;
    #openDropdownAC = null;
    #uiManager = null;
    static #l10nColor = null;
    static get _keyboardManager() {
        return $b3a01b20dd2ade98$export$b8972b998723d602(this, "_keyboardManager", new $b3a01b20dd2ade98$var$KeyboardManager([
            [
                [
                    "Escape",
                    "mac+Escape"
                ],
                $b3a01b20dd2ade98$export$9feb1bc2e5f1ccb3.prototype._hideDropdownFromKeyboard
            ],
            [
                [
                    " ",
                    "mac+ "
                ],
                $b3a01b20dd2ade98$export$9feb1bc2e5f1ccb3.prototype._colorSelectFromKeyboard
            ],
            [
                [
                    "ArrowDown",
                    "ArrowRight",
                    "mac+ArrowDown",
                    "mac+ArrowRight"
                ],
                $b3a01b20dd2ade98$export$9feb1bc2e5f1ccb3.prototype._moveToNext
            ],
            [
                [
                    "ArrowUp",
                    "ArrowLeft",
                    "mac+ArrowUp",
                    "mac+ArrowLeft"
                ],
                $b3a01b20dd2ade98$export$9feb1bc2e5f1ccb3.prototype._moveToPrevious
            ],
            [
                [
                    "Home",
                    "mac+Home"
                ],
                $b3a01b20dd2ade98$export$9feb1bc2e5f1ccb3.prototype._moveToBeginning
            ],
            [
                [
                    "End",
                    "mac+End"
                ],
                $b3a01b20dd2ade98$export$9feb1bc2e5f1ccb3.prototype._moveToEnd
            ]
        ]));
    }
    constructor({ editor: editor = null, uiManager: uiManager = null }){
        if (editor) {
            this.#isMainColorPicker = false;
            this.#editor = editor;
        } else this.#isMainColorPicker = true;
        this.#uiManager = editor?._uiManager || uiManager;
        this.#eventBus = this.#uiManager._eventBus;
        this.#defaultColor = editor?.color?.toUpperCase() || this.#uiManager?.highlightColors.values().next().value || "#FFFF98";
        $b3a01b20dd2ade98$export$9feb1bc2e5f1ccb3.#l10nColor ||= Object.freeze({
            blue: "pdfjs-editor-colorpicker-blue",
            green: "pdfjs-editor-colorpicker-green",
            pink: "pdfjs-editor-colorpicker-pink",
            red: "pdfjs-editor-colorpicker-red",
            yellow: "pdfjs-editor-colorpicker-yellow"
        });
    }
    renderButton() {
        const button = this.#button = document.createElement("button");
        button.className = "colorPicker";
        button.tabIndex = "0";
        button.setAttribute("data-l10n-id", "pdfjs-editor-colorpicker-button");
        button.ariaHasPopup = "true";
        if (this.#editor) button.ariaControls = `${this.#editor.id}_colorpicker_dropdown`;
        const signal = this.#uiManager._signal;
        button.addEventListener("click", this.#openDropdown.bind(this), {
            signal: signal
        });
        button.addEventListener("keydown", this.#keyDown.bind(this), {
            signal: signal
        });
        const swatch = this.#buttonSwatch = document.createElement("span");
        swatch.className = "swatch";
        swatch.ariaHidden = "true";
        swatch.style.backgroundColor = this.#defaultColor;
        button.append(swatch);
        return button;
    }
    renderMainDropdown() {
        const dropdown = this.#dropdown = this.#getDropdownRoot();
        dropdown.ariaOrientation = "horizontal";
        dropdown.ariaLabelledBy = "highlightColorPickerLabel";
        return dropdown;
    }
    #getDropdownRoot() {
        const div = document.createElement("div");
        const signal = this.#uiManager._signal;
        div.addEventListener("contextmenu", $b3a01b20dd2ade98$export$455b7811f904cadc, {
            signal: signal
        });
        div.className = "dropdown";
        div.role = "listbox";
        div.ariaMultiSelectable = "false";
        div.ariaOrientation = "vertical";
        div.setAttribute("data-l10n-id", "pdfjs-editor-colorpicker-dropdown");
        if (this.#editor) div.id = `${this.#editor.id}_colorpicker_dropdown`;
        for (const [name, color] of this.#uiManager.highlightColors){
            const button = document.createElement("button");
            button.tabIndex = "0";
            button.role = "option";
            button.setAttribute("data-color", color);
            button.title = name;
            button.setAttribute("data-l10n-id", $b3a01b20dd2ade98$export$9feb1bc2e5f1ccb3.#l10nColor[name]);
            const swatch = document.createElement("span");
            button.append(swatch);
            swatch.className = "swatch";
            swatch.style.backgroundColor = color;
            button.ariaSelected = color === this.#defaultColor;
            button.addEventListener("click", this.#colorSelect.bind(this, color), {
                signal: signal
            });
            div.append(button);
        }
        div.addEventListener("keydown", this.#keyDown.bind(this), {
            signal: signal
        });
        return div;
    }
    #colorSelect(color, event) {
        event.stopPropagation();
        this.#eventBus.dispatch("switchannotationeditorparams", {
            source: this,
            type: $b3a01b20dd2ade98$export$cf3df2a6ecc26692.HIGHLIGHT_COLOR,
            value: color
        });
        this.updateColor(color);
    }
    _colorSelectFromKeyboard(event) {
        if (event.target === this.#button) {
            this.#openDropdown(event);
            return;
        }
        const color = event.target.getAttribute("data-color");
        if (!color) return;
        this.#colorSelect(color, event);
    }
    _moveToNext(event) {
        if (!this.#isDropdownVisible) {
            this.#openDropdown(event);
            return;
        }
        if (event.target === this.#button) {
            this.#dropdown.firstElementChild?.focus();
            return;
        }
        event.target.nextSibling?.focus();
    }
    _moveToPrevious(event) {
        if (event.target === this.#dropdown?.firstElementChild || event.target === this.#button) {
            if (this.#isDropdownVisible) this._hideDropdownFromKeyboard();
            return;
        }
        if (!this.#isDropdownVisible) this.#openDropdown(event);
        event.target.previousSibling?.focus();
    }
    _moveToBeginning(event) {
        if (!this.#isDropdownVisible) {
            this.#openDropdown(event);
            return;
        }
        this.#dropdown.firstElementChild?.focus();
    }
    _moveToEnd(event) {
        if (!this.#isDropdownVisible) {
            this.#openDropdown(event);
            return;
        }
        this.#dropdown.lastElementChild?.focus();
    }
    #keyDown(event) {
        $b3a01b20dd2ade98$export$9feb1bc2e5f1ccb3._keyboardManager.exec(this, event);
    }
    #openDropdown(event) {
        if (this.#isDropdownVisible) {
            this.hideDropdown();
            return;
        }
        this.#dropdownWasFromKeyboard = event.detail === 0;
        if (!this.#openDropdownAC) {
            this.#openDropdownAC = new AbortController();
            window.addEventListener("pointerdown", this.#pointerDown.bind(this), {
                signal: this.#uiManager.combinedSignal(this.#openDropdownAC)
            });
        }
        this.#button.ariaExpanded = "true";
        if (this.#dropdown) {
            this.#dropdown.classList.remove("hidden");
            return;
        }
        const root = this.#dropdown = this.#getDropdownRoot();
        this.#button.append(root);
    }
    #pointerDown(event) {
        if (this.#dropdown?.contains(event.target)) return;
        this.hideDropdown();
    }
    hideDropdown() {
        this.#dropdown?.classList.add("hidden");
        this.#button.ariaExpanded = "false";
        this.#openDropdownAC?.abort();
        this.#openDropdownAC = null;
    }
    get #isDropdownVisible() {
        return this.#dropdown && !this.#dropdown.classList.contains("hidden");
    }
    _hideDropdownFromKeyboard() {
        if (this.#isMainColorPicker) return;
        if (!this.#isDropdownVisible) {
            this.#editor?.unselect();
            return;
        }
        this.hideDropdown();
        this.#button.focus({
            preventScroll: true,
            focusVisible: this.#dropdownWasFromKeyboard
        });
    }
    updateColor(color) {
        if (this.#buttonSwatch) this.#buttonSwatch.style.backgroundColor = color;
        if (!this.#dropdown) return;
        const i = this.#uiManager.highlightColors.values();
        for (const child of this.#dropdown.children)child.ariaSelected = i.next().value === color.toUpperCase();
    }
    destroy() {
        this.#button?.remove();
        this.#button = null;
        this.#buttonSwatch = null;
        this.#dropdown?.remove();
        this.#dropdown = null;
    }
}
class $b3a01b20dd2ade98$var$BasicColorPicker {
    #input = null;
    #editor = null;
    #uiManager = null;
    static #l10nColor = null;
    constructor(editor){
        this.#editor = editor;
        this.#uiManager = editor._uiManager;
        $b3a01b20dd2ade98$var$BasicColorPicker.#l10nColor ||= Object.freeze({
            freetext: "pdfjs-editor-color-picker-free-text-input",
            ink: "pdfjs-editor-color-picker-ink-input"
        });
    }
    renderButton() {
        if (this.#input) return this.#input;
        const { editorType: editorType, colorType: colorType, color: color } = this.#editor;
        const input = this.#input = document.createElement("input");
        input.type = "color";
        input.value = color || "#000000";
        input.className = "basicColorPicker";
        input.tabIndex = 0;
        input.setAttribute("data-l10n-id", $b3a01b20dd2ade98$var$BasicColorPicker.#l10nColor[editorType]);
        input.addEventListener("input", ()=>{
            this.#uiManager.updateParams(colorType, input.value);
        }, {
            signal: this.#uiManager._signal
        });
        return input;
    }
    update(value) {
        if (!this.#input) return;
        this.#input.value = value;
    }
    destroy() {
        this.#input?.remove();
        this.#input = null;
    }
    hideDropdown() {}
}
function $b3a01b20dd2ade98$var$makeColorComp(n) {
    return Math.floor(Math.max(0, Math.min(1, n)) * 255).toString(16).padStart(2, "0");
}
function $b3a01b20dd2ade98$var$scaleAndClamp(x) {
    return Math.max(0, Math.min(255, 255 * x));
}
class $b3a01b20dd2ade98$var$ColorConverters {
    static CMYK_G([c, y, m, k]) {
        return [
            "G",
            1 - Math.min(1, 0.3 * c + 0.59 * m + 0.11 * y + k)
        ];
    }
    static G_CMYK([g]) {
        return [
            "CMYK",
            0,
            0,
            0,
            1 - g
        ];
    }
    static G_RGB([g]) {
        return [
            "RGB",
            g,
            g,
            g
        ];
    }
    static G_rgb([g]) {
        g = $b3a01b20dd2ade98$var$scaleAndClamp(g);
        return [
            g,
            g,
            g
        ];
    }
    static G_HTML([g]) {
        const G = $b3a01b20dd2ade98$var$makeColorComp(g);
        return `#${G}${G}${G}`;
    }
    static RGB_G([r, g, b]) {
        return [
            "G",
            0.3 * r + 0.59 * g + 0.11 * b
        ];
    }
    static RGB_rgb(color) {
        return color.map($b3a01b20dd2ade98$var$scaleAndClamp);
    }
    static RGB_HTML(color) {
        return `#${color.map($b3a01b20dd2ade98$var$makeColorComp).join("")}`;
    }
    static T_HTML() {
        return "#00000000";
    }
    static T_rgb() {
        return [
            null
        ];
    }
    static CMYK_RGB([c, y, m, k]) {
        return [
            "RGB",
            1 - Math.min(1, c + k),
            1 - Math.min(1, m + k),
            1 - Math.min(1, y + k)
        ];
    }
    static CMYK_rgb([c, y, m, k]) {
        return [
            $b3a01b20dd2ade98$var$scaleAndClamp(1 - Math.min(1, c + k)),
            $b3a01b20dd2ade98$var$scaleAndClamp(1 - Math.min(1, m + k)),
            $b3a01b20dd2ade98$var$scaleAndClamp(1 - Math.min(1, y + k))
        ];
    }
    static CMYK_HTML(components) {
        const rgb = this.CMYK_RGB(components).slice(1);
        return this.RGB_HTML(rgb);
    }
    static RGB_CMYK([r, g, b]) {
        const c = 1 - r;
        const m = 1 - g;
        const y = 1 - b;
        const k = Math.min(c, m, y);
        return [
            "CMYK",
            c,
            m,
            y,
            k
        ];
    }
}
const $b3a01b20dd2ade98$var$DateFormats = /* unused pure expression or super */ null;
const $b3a01b20dd2ade98$var$TimeFormats = /* unused pure expression or super */ null;
class $b3a01b20dd2ade98$var$BaseSVGFactory {
    create(width, height, skipDimensions = false) {
        if (width <= 0 || height <= 0) throw new Error("Invalid SVG dimensions");
        const svg = this._createSVG("svg:svg");
        svg.setAttribute("version", "1.1");
        if (!skipDimensions) {
            svg.setAttribute("width", `${width}px`);
            svg.setAttribute("height", `${height}px`);
        }
        svg.setAttribute("preserveAspectRatio", "none");
        svg.setAttribute("viewBox", `0 0 ${width} ${height}`);
        return svg;
    }
    createElement(type) {
        if (typeof type !== "string") throw new Error("Invalid SVG element type");
        return this._createSVG(type);
    }
    _createSVG(type) {
        $b3a01b20dd2ade98$var$unreachable("Abstract method `_createSVG` called.");
    }
}
class $b3a01b20dd2ade98$export$425e69f00724e63a extends $b3a01b20dd2ade98$var$BaseSVGFactory {
    _createSVG(type) {
        return document.createElementNS($b3a01b20dd2ade98$var$SVG_NS, type);
    }
}
const $b3a01b20dd2ade98$var$annotation_layer_DEFAULT_FONT_SIZE = 9;
const $b3a01b20dd2ade98$var$GetElementsByNameSet = new WeakSet();
const $b3a01b20dd2ade98$var$TIMEZONE_OFFSET = new Date().getTimezoneOffset() * 60000;
class $b3a01b20dd2ade98$var$AnnotationElementFactory {
    static create(parameters) {
        const subtype = parameters.data.annotationType;
        switch(subtype){
            case $b3a01b20dd2ade98$export$f50c3066a53a6f2c.LINK:
                return new $b3a01b20dd2ade98$var$LinkAnnotationElement(parameters);
            case $b3a01b20dd2ade98$export$f50c3066a53a6f2c.TEXT:
                return new $b3a01b20dd2ade98$var$TextAnnotationElement(parameters);
            case $b3a01b20dd2ade98$export$f50c3066a53a6f2c.WIDGET:
                const fieldType = parameters.data.fieldType;
                switch(fieldType){
                    case "Tx":
                        return new $b3a01b20dd2ade98$var$TextWidgetAnnotationElement(parameters);
                    case "Btn":
                        if (parameters.data.radioButton) return new $b3a01b20dd2ade98$var$RadioButtonWidgetAnnotationElement(parameters);
                        else if (parameters.data.checkBox) return new $b3a01b20dd2ade98$var$CheckboxWidgetAnnotationElement(parameters);
                        return new $b3a01b20dd2ade98$var$PushButtonWidgetAnnotationElement(parameters);
                    case "Ch":
                        return new $b3a01b20dd2ade98$var$ChoiceWidgetAnnotationElement(parameters);
                    case "Sig":
                        return new $b3a01b20dd2ade98$var$SignatureWidgetAnnotationElement(parameters);
                }
                return new $b3a01b20dd2ade98$var$WidgetAnnotationElement(parameters);
            case $b3a01b20dd2ade98$export$f50c3066a53a6f2c.POPUP:
                return new $b3a01b20dd2ade98$var$PopupAnnotationElement(parameters);
            case $b3a01b20dd2ade98$export$f50c3066a53a6f2c.FREETEXT:
                return new $b3a01b20dd2ade98$var$FreeTextAnnotationElement(parameters);
            case $b3a01b20dd2ade98$export$f50c3066a53a6f2c.LINE:
                return new $b3a01b20dd2ade98$var$LineAnnotationElement(parameters);
            case $b3a01b20dd2ade98$export$f50c3066a53a6f2c.SQUARE:
                return new $b3a01b20dd2ade98$var$SquareAnnotationElement(parameters);
            case $b3a01b20dd2ade98$export$f50c3066a53a6f2c.CIRCLE:
                return new $b3a01b20dd2ade98$var$CircleAnnotationElement(parameters);
            case $b3a01b20dd2ade98$export$f50c3066a53a6f2c.POLYLINE:
                return new $b3a01b20dd2ade98$var$PolylineAnnotationElement(parameters);
            case $b3a01b20dd2ade98$export$f50c3066a53a6f2c.CARET:
                return new $b3a01b20dd2ade98$var$CaretAnnotationElement(parameters);
            case $b3a01b20dd2ade98$export$f50c3066a53a6f2c.INK:
                return new $b3a01b20dd2ade98$var$InkAnnotationElement(parameters);
            case $b3a01b20dd2ade98$export$f50c3066a53a6f2c.POLYGON:
                return new $b3a01b20dd2ade98$var$PolygonAnnotationElement(parameters);
            case $b3a01b20dd2ade98$export$f50c3066a53a6f2c.HIGHLIGHT:
                return new $b3a01b20dd2ade98$var$HighlightAnnotationElement(parameters);
            case $b3a01b20dd2ade98$export$f50c3066a53a6f2c.UNDERLINE:
                return new $b3a01b20dd2ade98$var$UnderlineAnnotationElement(parameters);
            case $b3a01b20dd2ade98$export$f50c3066a53a6f2c.SQUIGGLY:
                return new $b3a01b20dd2ade98$var$SquigglyAnnotationElement(parameters);
            case $b3a01b20dd2ade98$export$f50c3066a53a6f2c.STRIKEOUT:
                return new $b3a01b20dd2ade98$var$StrikeOutAnnotationElement(parameters);
            case $b3a01b20dd2ade98$export$f50c3066a53a6f2c.STAMP:
                return new $b3a01b20dd2ade98$var$StampAnnotationElement(parameters);
            case $b3a01b20dd2ade98$export$f50c3066a53a6f2c.FILEATTACHMENT:
                return new $b3a01b20dd2ade98$var$FileAttachmentAnnotationElement(parameters);
            default:
                return new $b3a01b20dd2ade98$var$AnnotationElement(parameters);
        }
    }
}
class $b3a01b20dd2ade98$var$AnnotationElement {
    #updates = null;
    #hasBorder = false;
    #popupElement = null;
    constructor(parameters, { isRenderable: isRenderable = false, ignoreBorder: ignoreBorder = false, createQuadrilaterals: createQuadrilaterals = false } = {}){
        this.isRenderable = isRenderable;
        this.data = parameters.data;
        this.layer = parameters.layer;
        this.linkService = parameters.linkService;
        this.downloadManager = parameters.downloadManager;
        this.imageResourcesPath = parameters.imageResourcesPath;
        this.renderForms = parameters.renderForms;
        this.svgFactory = parameters.svgFactory;
        this.annotationStorage = parameters.annotationStorage;
        this.enableComment = parameters.enableComment;
        this.enableScripting = parameters.enableScripting;
        this.hasJSActions = parameters.hasJSActions;
        this._fieldObjects = parameters.fieldObjects;
        this.parent = parameters.parent;
        this.hasOwnCommentButton = false;
        if (isRenderable) this.contentElement = this.container = this._createContainer(ignoreBorder);
        if (createQuadrilaterals) this._createQuadrilaterals();
    }
    static _hasPopupData({ contentsObj: contentsObj, richText: richText }) {
        return !!(contentsObj?.str || richText?.str);
    }
    get _isEditable() {
        return this.data.isEditable;
    }
    get hasPopupData() {
        return $b3a01b20dd2ade98$var$AnnotationElement._hasPopupData(this.data) || this.enableComment && !!this.commentText;
    }
    get commentData() {
        const { data: data } = this;
        const editor = this.annotationStorage?.getEditor(data.id);
        if (editor) return editor.getData();
        return data;
    }
    get hasCommentButton() {
        return this.enableComment && this.hasPopupElement;
    }
    get commentButtonPosition() {
        const editor = this.annotationStorage?.getEditor(this.data.id);
        if (editor) return editor.commentButtonPositionInPage;
        const { quadPoints: quadPoints, inkLists: inkLists, rect: rect } = this.data;
        let maxX = -Infinity;
        let maxY = -Infinity;
        if (quadPoints?.length >= 8) {
            for(let i = 0; i < quadPoints.length; i += 8){
                if (quadPoints[i + 1] > maxY) {
                    maxY = quadPoints[i + 1];
                    maxX = quadPoints[i + 2];
                } else if (quadPoints[i + 1] === maxY) maxX = Math.max(maxX, quadPoints[i + 2]);
            }
            return [
                maxX,
                maxY
            ];
        }
        if (inkLists?.length >= 1) {
            for (const inkList of inkLists)for(let i = 0, ii = inkList.length; i < ii; i += 2){
                if (inkList[i + 1] > maxY) {
                    maxY = inkList[i + 1];
                    maxX = inkList[i];
                } else if (inkList[i + 1] === maxY) maxX = Math.max(maxX, inkList[i]);
            }
            if (maxX !== Infinity) return [
                maxX,
                maxY
            ];
        }
        if (rect) return [
            rect[2],
            rect[3]
        ];
        return null;
    }
    _normalizePoint(point) {
        const { page: { view: view }, viewport: { rawDims: { pageWidth: pageWidth, pageHeight: pageHeight, pageX: pageX, pageY: pageY } } } = this.parent;
        point[1] = view[3] - point[1] + view[1];
        point[0] = 100 * (point[0] - pageX) / pageWidth;
        point[1] = 100 * (point[1] - pageY) / pageHeight;
        return point;
    }
    get commentText() {
        const { data: data } = this;
        return this.annotationStorage.getRawValue(`${$b3a01b20dd2ade98$var$AnnotationEditorPrefix}${data.id}`)?.popup?.contents || data.contentsObj?.str || "";
    }
    set commentText(text) {
        const { data: data } = this;
        const popup = {
            deleted: !text,
            contents: text || ""
        };
        if (!this.annotationStorage.updateEditor(data.id, {
            popup: popup
        })) this.annotationStorage.setValue(`${$b3a01b20dd2ade98$var$AnnotationEditorPrefix}${data.id}`, {
            id: data.id,
            annotationType: data.annotationType,
            page: this.parent.page,
            popup: popup,
            popupRef: data.popupRef,
            modificationDate: new Date()
        });
        if (!text) this.removePopup();
    }
    removePopup() {
        (this.#popupElement?.popup || this.popup)?.remove();
        this.#popupElement = this.popup = null;
    }
    updateEdited(params) {
        if (!this.container) return;
        if (params.rect) this.#updates ||= {
            rect: this.data.rect.slice(0)
        };
        const { rect: rect, popup: newPopup } = params;
        if (rect) this.#setRectEdited(rect);
        let popup = this.#popupElement?.popup || this.popup;
        if (!popup && newPopup?.text) {
            this._createPopup(newPopup);
            popup = this.#popupElement.popup;
        }
        if (!popup) return;
        popup.updateEdited(params);
        if (newPopup?.deleted) {
            popup.remove();
            this.#popupElement = null;
            this.popup = null;
        }
    }
    resetEdited() {
        if (!this.#updates) return;
        this.#setRectEdited(this.#updates.rect);
        this.#popupElement?.popup.resetEdited();
        this.#updates = null;
    }
    #setRectEdited(rect) {
        const { container: { style: style }, data: { rect: currentRect, rotation: rotation }, parent: { viewport: { rawDims: { pageWidth: pageWidth, pageHeight: pageHeight, pageX: pageX, pageY: pageY } } } } = this;
        currentRect?.splice(0, 4, ...rect);
        style.left = `${100 * (rect[0] - pageX) / pageWidth}%`;
        style.top = `${100 * (pageHeight - rect[3] + pageY) / pageHeight}%`;
        if (rotation === 0) {
            style.width = `${100 * (rect[2] - rect[0]) / pageWidth}%`;
            style.height = `${100 * (rect[3] - rect[1]) / pageHeight}%`;
        } else this.setRotation(rotation);
    }
    _createContainer(ignoreBorder) {
        const { data: data, parent: { page: page, viewport: viewport } } = this;
        const container = document.createElement("section");
        container.setAttribute("data-annotation-id", data.id);
        if (!(this instanceof $b3a01b20dd2ade98$var$WidgetAnnotationElement) && !(this instanceof $b3a01b20dd2ade98$var$LinkAnnotationElement)) container.tabIndex = 0;
        const { style: style } = container;
        style.zIndex = this.parent.zIndex;
        this.parent.zIndex += 2;
        if (data.alternativeText) container.title = data.alternativeText;
        if (data.noRotate) container.classList.add("norotate");
        if (!data.rect || this instanceof $b3a01b20dd2ade98$var$PopupAnnotationElement) {
            const { rotation: rotation } = data;
            if (!data.hasOwnCanvas && rotation !== 0) this.setRotation(rotation, container);
            return container;
        }
        const { width: width, height: height } = this;
        if (!ignoreBorder && data.borderStyle.width > 0) {
            style.borderWidth = `${data.borderStyle.width}px`;
            const horizontalRadius = data.borderStyle.horizontalCornerRadius;
            const verticalRadius = data.borderStyle.verticalCornerRadius;
            if (horizontalRadius > 0 || verticalRadius > 0) {
                const radius = `calc(${horizontalRadius}px * var(--total-scale-factor)) / calc(${verticalRadius}px * var(--total-scale-factor))`;
                style.borderRadius = radius;
            } else if (this instanceof $b3a01b20dd2ade98$var$RadioButtonWidgetAnnotationElement) {
                const radius = `calc(${width}px * var(--total-scale-factor)) / calc(${height}px * var(--total-scale-factor))`;
                style.borderRadius = radius;
            }
            switch(data.borderStyle.style){
                case $b3a01b20dd2ade98$var$AnnotationBorderStyleType.SOLID:
                    style.borderStyle = "solid";
                    break;
                case $b3a01b20dd2ade98$var$AnnotationBorderStyleType.DASHED:
                    style.borderStyle = "dashed";
                    break;
                case $b3a01b20dd2ade98$var$AnnotationBorderStyleType.BEVELED:
                    $b3a01b20dd2ade98$var$warn("Unimplemented border style: beveled");
                    break;
                case $b3a01b20dd2ade98$var$AnnotationBorderStyleType.INSET:
                    $b3a01b20dd2ade98$var$warn("Unimplemented border style: inset");
                    break;
                case $b3a01b20dd2ade98$var$AnnotationBorderStyleType.UNDERLINE:
                    style.borderBottomStyle = "solid";
                    break;
                default:
                    break;
            }
            const borderColor = data.borderColor || null;
            if (borderColor) {
                this.#hasBorder = true;
                style.borderColor = $b3a01b20dd2ade98$export$f8f26dd395d7e1bd.makeHexColor(borderColor[0] | 0, borderColor[1] | 0, borderColor[2] | 0);
            } else style.borderWidth = 0;
        }
        const rect = $b3a01b20dd2ade98$export$f8f26dd395d7e1bd.normalizeRect([
            data.rect[0],
            page.view[3] - data.rect[1] + page.view[1],
            data.rect[2],
            page.view[3] - data.rect[3] + page.view[1]
        ]);
        const { pageWidth: pageWidth, pageHeight: pageHeight, pageX: pageX, pageY: pageY } = viewport.rawDims;
        style.left = `${100 * (rect[0] - pageX) / pageWidth}%`;
        style.top = `${100 * (rect[1] - pageY) / pageHeight}%`;
        const { rotation: rotation } = data;
        if (data.hasOwnCanvas || rotation === 0) {
            style.width = `${100 * width / pageWidth}%`;
            style.height = `${100 * height / pageHeight}%`;
        } else this.setRotation(rotation, container);
        return container;
    }
    setRotation(angle, container = this.container) {
        if (!this.data.rect) return;
        const { pageWidth: pageWidth, pageHeight: pageHeight } = this.parent.viewport.rawDims;
        let { width: width, height: height } = this;
        if (angle % 180 !== 0) [width, height] = [
            height,
            width
        ];
        container.style.width = `${100 * width / pageWidth}%`;
        container.style.height = `${100 * height / pageHeight}%`;
        container.setAttribute("data-main-rotation", (360 - angle) % 360);
    }
    get _commonActions() {
        const setColor = (jsName, styleName, event)=>{
            const color = event.detail[jsName];
            const colorType = color[0];
            const colorArray = color.slice(1);
            event.target.style[styleName] = $b3a01b20dd2ade98$var$ColorConverters[`${colorType}_HTML`](colorArray);
            this.annotationStorage.setValue(this.data.id, {
                [styleName]: $b3a01b20dd2ade98$var$ColorConverters[`${colorType}_rgb`](colorArray)
            });
        };
        return $b3a01b20dd2ade98$export$b8972b998723d602(this, "_commonActions", {
            display: (event)=>{
                const { display: display } = event.detail;
                const hidden = display % 2 === 1;
                this.container.style.visibility = hidden ? "hidden" : "visible";
                this.annotationStorage.setValue(this.data.id, {
                    noView: hidden,
                    noPrint: display === 1 || display === 2
                });
            },
            print: (event)=>{
                this.annotationStorage.setValue(this.data.id, {
                    noPrint: !event.detail.print
                });
            },
            hidden: (event)=>{
                const { hidden: hidden } = event.detail;
                this.container.style.visibility = hidden ? "hidden" : "visible";
                this.annotationStorage.setValue(this.data.id, {
                    noPrint: hidden,
                    noView: hidden
                });
            },
            focus: (event)=>{
                setTimeout(()=>event.target.focus({
                        preventScroll: false
                    }), 0);
            },
            userName: (event)=>{
                event.target.title = event.detail.userName;
            },
            readonly: (event)=>{
                event.target.disabled = event.detail.readonly;
            },
            required: (event)=>{
                this._setRequired(event.target, event.detail.required);
            },
            bgColor: (event)=>{
                setColor("bgColor", "backgroundColor", event);
            },
            fillColor: (event)=>{
                setColor("fillColor", "backgroundColor", event);
            },
            fgColor: (event)=>{
                setColor("fgColor", "color", event);
            },
            textColor: (event)=>{
                setColor("textColor", "color", event);
            },
            borderColor: (event)=>{
                setColor("borderColor", "borderColor", event);
            },
            strokeColor: (event)=>{
                setColor("strokeColor", "borderColor", event);
            },
            rotation: (event)=>{
                const angle = event.detail.rotation;
                this.setRotation(angle);
                this.annotationStorage.setValue(this.data.id, {
                    rotation: angle
                });
            }
        });
    }
    _dispatchEventFromSandbox(actions, jsEvent) {
        const commonActions = this._commonActions;
        for (const name of Object.keys(jsEvent.detail)){
            const action = actions[name] || commonActions[name];
            action?.(jsEvent);
        }
    }
    _setDefaultPropertiesFromJS(element) {
        if (!this.enableScripting) return;
        const storedData = this.annotationStorage.getRawValue(this.data.id);
        if (!storedData) return;
        const commonActions = this._commonActions;
        for (const [actionName, detail] of Object.entries(storedData)){
            const action = commonActions[actionName];
            if (action) {
                const eventProxy = {
                    detail: {
                        [actionName]: detail
                    },
                    target: element
                };
                action(eventProxy);
                delete storedData[actionName];
            }
        }
    }
    _createQuadrilaterals() {
        if (!this.container) return;
        const { quadPoints: quadPoints } = this.data;
        if (!quadPoints) return;
        const [rectBlX, rectBlY, rectTrX, rectTrY] = this.data.rect.map((x)=>Math.fround(x));
        if (quadPoints.length === 8) {
            const [trX, trY, blX, blY] = quadPoints.subarray(2, 6);
            if (rectTrX === trX && rectTrY === trY && rectBlX === blX && rectBlY === blY) return;
        }
        const { style: style } = this.container;
        let svgBuffer;
        if (this.#hasBorder) {
            const { borderColor: borderColor, borderWidth: borderWidth } = style;
            style.borderWidth = 0;
            svgBuffer = [
                "url('data:image/svg+xml;utf8,",
                `<svg xmlns="http://www.w3.org/2000/svg"`,
                ` preserveAspectRatio="none" viewBox="0 0 1 1">`,
                `<g fill="transparent" stroke="${borderColor}" stroke-width="${borderWidth}">`
            ];
            this.container.classList.add("hasBorder");
        }
        const width = rectTrX - rectBlX;
        const height = rectTrY - rectBlY;
        const { svgFactory: svgFactory } = this;
        const svg = svgFactory.createElement("svg");
        svg.classList.add("quadrilateralsContainer");
        svg.setAttribute("width", 0);
        svg.setAttribute("height", 0);
        svg.role = "none";
        const defs = svgFactory.createElement("defs");
        svg.append(defs);
        const clipPath = svgFactory.createElement("clipPath");
        const id = `clippath_${this.data.id}`;
        clipPath.setAttribute("id", id);
        clipPath.setAttribute("clipPathUnits", "objectBoundingBox");
        defs.append(clipPath);
        for(let i = 2, ii = quadPoints.length; i < ii; i += 8){
            const trX = quadPoints[i];
            const trY = quadPoints[i + 1];
            const blX = quadPoints[i + 2];
            const blY = quadPoints[i + 3];
            const rect = svgFactory.createElement("rect");
            const x = (blX - rectBlX) / width;
            const y = (rectTrY - trY) / height;
            const rectWidth = (trX - blX) / width;
            const rectHeight = (trY - blY) / height;
            rect.setAttribute("x", x);
            rect.setAttribute("y", y);
            rect.setAttribute("width", rectWidth);
            rect.setAttribute("height", rectHeight);
            clipPath.append(rect);
            svgBuffer?.push(`<rect vector-effect="non-scaling-stroke" x="${x}" y="${y}" width="${rectWidth}" height="${rectHeight}"/>`);
        }
        if (this.#hasBorder) {
            svgBuffer.push(`</g></svg>')`);
            style.backgroundImage = svgBuffer.join("");
        }
        this.container.append(svg);
        this.container.style.clipPath = `url(#${id})`;
    }
    _createPopup(popupData = null) {
        const { data: data } = this;
        let contentsObj, modificationDate;
        if (popupData) {
            contentsObj = {
                str: popupData.text
            };
            modificationDate = popupData.date;
        } else {
            contentsObj = data.contentsObj;
            modificationDate = data.modificationDate;
        }
        this.#popupElement = new $b3a01b20dd2ade98$var$PopupAnnotationElement({
            data: {
                color: data.color,
                titleObj: data.titleObj,
                modificationDate: modificationDate,
                contentsObj: contentsObj,
                richText: data.richText,
                parentRect: data.rect,
                borderStyle: 0,
                id: `popup_${data.id}`,
                rotation: data.rotation,
                noRotate: true
            },
            linkService: this.linkService,
            parent: this.parent,
            elements: [
                this
            ]
        });
    }
    get hasPopupElement() {
        return !!(this.#popupElement || this.popup || this.data.popupRef);
    }
    get extraPopupElement() {
        return this.#popupElement;
    }
    render() {
        $b3a01b20dd2ade98$var$unreachable("Abstract method `AnnotationElement.render` called");
    }
    _getElementsByName(name, skipId = null) {
        const fields = [];
        if (this._fieldObjects) {
            const fieldObj = this._fieldObjects[name];
            if (fieldObj) for (const { page: page, id: id, exportValues: exportValues } of fieldObj){
                if (page === -1) continue;
                if (id === skipId) continue;
                const exportValue = typeof exportValues === "string" ? exportValues : null;
                const domElement = document.querySelector(`[data-element-id="${id}"]`);
                if (domElement && !$b3a01b20dd2ade98$var$GetElementsByNameSet.has(domElement)) {
                    $b3a01b20dd2ade98$var$warn(`_getElementsByName - element not allowed: ${id}`);
                    continue;
                }
                fields.push({
                    id: id,
                    exportValue: exportValue,
                    domElement: domElement
                });
            }
            return fields;
        }
        for (const domElement of document.getElementsByName(name)){
            const { exportValue: exportValue } = domElement;
            const id = domElement.getAttribute("data-element-id");
            if (id === skipId) continue;
            if (!$b3a01b20dd2ade98$var$GetElementsByNameSet.has(domElement)) continue;
            fields.push({
                id: id,
                exportValue: exportValue,
                domElement: domElement
            });
        }
        return fields;
    }
    show() {
        if (this.container) this.container.hidden = false;
        this.popup?.maybeShow();
    }
    hide() {
        if (this.container) this.container.hidden = true;
        this.popup?.forceHide();
    }
    getElementsToTriggerPopup() {
        return this.container;
    }
    addHighlightArea() {
        const triggers = this.getElementsToTriggerPopup();
        if (Array.isArray(triggers)) for (const element of triggers)element.classList.add("highlightArea");
        else triggers.classList.add("highlightArea");
    }
    _editOnDoubleClick() {
        if (!this._isEditable) return;
        const { annotationEditorType: mode, data: { id: editId } } = this;
        this.container.addEventListener("dblclick", ()=>{
            this.linkService.eventBus?.dispatch("switchannotationeditormode", {
                source: this,
                mode: mode,
                editId: editId,
                mustEnterInEditMode: true
            });
        });
    }
    get width() {
        return this.data.rect[2] - this.data.rect[0];
    }
    get height() {
        return this.data.rect[3] - this.data.rect[1];
    }
}
class $b3a01b20dd2ade98$var$EditorAnnotationElement extends $b3a01b20dd2ade98$var$AnnotationElement {
    constructor(parameters){
        super(parameters, {
            isRenderable: true,
            ignoreBorder: true
        });
        this.editor = parameters.editor;
    }
    render() {
        this.container.className = "editorAnnotation";
        return this.container;
    }
    createOrUpdatePopup() {
        const { editor: editor } = this;
        if (!editor.hasComment) return;
        this._createPopup(editor.comment);
    }
    get hasCommentButton() {
        return this.enableComment && this.editor.hasComment;
    }
    get commentButtonPosition() {
        return this.editor.commentButtonPositionInPage;
    }
    get commentText() {
        return this.editor.comment.text;
    }
    set commentText(text) {
        this.editor.comment = text;
        if (!text) this.removePopup();
    }
    get commentData() {
        return this.editor.getData();
    }
    remove() {
        this.parent.removeAnnotation(this.data.id);
        this.container.remove();
        this.container = null;
        this.removePopup();
    }
}
class $b3a01b20dd2ade98$var$LinkAnnotationElement extends $b3a01b20dd2ade98$var$AnnotationElement {
    constructor(parameters, options = null){
        super(parameters, {
            isRenderable: true,
            ignoreBorder: !!options?.ignoreBorder,
            createQuadrilaterals: true
        });
        this.isTooltipOnly = parameters.data.isTooltipOnly;
    }
    render() {
        const { data: data, linkService: linkService } = this;
        const link = document.createElement("a");
        link.setAttribute("data-element-id", data.id);
        let isBound = false;
        if (data.url) {
            linkService.addLinkAttributes(link, data.url, data.newWindow);
            isBound = true;
        } else if (data.action) {
            this._bindNamedAction(link, data.action, data.overlaidText);
            isBound = true;
        } else if (data.attachment) {
            this.#bindAttachment(link, data.attachment, data.overlaidText, data.attachmentDest);
            isBound = true;
        } else if (data.setOCGState) {
            this.#bindSetOCGState(link, data.setOCGState, data.overlaidText);
            isBound = true;
        } else if (data.dest) {
            this._bindLink(link, data.dest, data.overlaidText);
            isBound = true;
        } else {
            if (data.actions && (data.actions.Action || data.actions["Mouse Up"] || data.actions["Mouse Down"]) && this.enableScripting && this.hasJSActions) {
                this._bindJSAction(link, data);
                isBound = true;
            }
            if (data.resetForm) {
                this._bindResetFormAction(link, data.resetForm);
                isBound = true;
            } else if (this.isTooltipOnly && !isBound) {
                this._bindLink(link, "");
                isBound = true;
            }
        }
        this.container.classList.add("linkAnnotation");
        if (isBound) {
            this.contentElement = link;
            this.container.append(link);
        }
        return this.container;
    }
    #setInternalLink() {
        this.container.setAttribute("data-internal-link", "");
    }
    _bindLink(link, destination, overlaidText = "") {
        link.href = this.linkService.getDestinationHash(destination);
        link.onclick = ()=>{
            if (destination) this.linkService.goToDestination(destination);
            return false;
        };
        if (destination || destination === "") this.#setInternalLink();
        if (overlaidText) link.title = overlaidText;
    }
    _bindNamedAction(link, action, overlaidText = "") {
        link.href = this.linkService.getAnchorUrl("");
        link.onclick = ()=>{
            this.linkService.executeNamedAction(action);
            return false;
        };
        if (overlaidText) link.title = overlaidText;
        this.#setInternalLink();
    }
    #bindAttachment(link, attachment, overlaidText = "", dest = null) {
        link.href = this.linkService.getAnchorUrl("");
        if (attachment.description) link.title = attachment.description;
        else if (overlaidText) link.title = overlaidText;
        link.onclick = ()=>{
            this.downloadManager?.openOrDownloadData(attachment.content, attachment.filename, dest);
            return false;
        };
        this.#setInternalLink();
    }
    #bindSetOCGState(link, action, overlaidText = "") {
        link.href = this.linkService.getAnchorUrl("");
        link.onclick = ()=>{
            this.linkService.executeSetOCGState(action);
            return false;
        };
        if (overlaidText) link.title = overlaidText;
        this.#setInternalLink();
    }
    _bindJSAction(link, data) {
        link.href = this.linkService.getAnchorUrl("");
        const map = new Map([
            [
                "Action",
                "onclick"
            ],
            [
                "Mouse Up",
                "onmouseup"
            ],
            [
                "Mouse Down",
                "onmousedown"
            ]
        ]);
        for (const name of Object.keys(data.actions)){
            const jsName = map.get(name);
            if (!jsName) continue;
            link[jsName] = ()=>{
                this.linkService.eventBus?.dispatch("dispatcheventinsandbox", {
                    source: this,
                    detail: {
                        id: data.id,
                        name: name
                    }
                });
                return false;
            };
        }
        if (data.overlaidText) link.title = data.overlaidText;
        if (!link.onclick) link.onclick = ()=>false;
        this.#setInternalLink();
    }
    _bindResetFormAction(link, resetForm) {
        const otherClickAction = link.onclick;
        if (!otherClickAction) link.href = this.linkService.getAnchorUrl("");
        this.#setInternalLink();
        if (!this._fieldObjects) {
            $b3a01b20dd2ade98$var$warn(`_bindResetFormAction - "resetForm" action not supported, ` + "ensure that the `fieldObjects` parameter is provided.");
            if (!otherClickAction) link.onclick = ()=>false;
            return;
        }
        link.onclick = ()=>{
            otherClickAction?.();
            const { fields: resetFormFields, refs: resetFormRefs, include: include } = resetForm;
            const allFields = [];
            if (resetFormFields.length !== 0 || resetFormRefs.length !== 0) {
                const fieldIds = new Set(resetFormRefs);
                for (const fieldName of resetFormFields){
                    const fields = this._fieldObjects[fieldName] || [];
                    for (const { id: id } of fields)fieldIds.add(id);
                }
                for (const fields of Object.values(this._fieldObjects)){
                    for (const field of fields)if (fieldIds.has(field.id) === include) allFields.push(field);
                }
            } else for (const fields of Object.values(this._fieldObjects))allFields.push(...fields);
            const storage = this.annotationStorage;
            const allIds = [];
            for (const field of allFields){
                const { id: id } = field;
                allIds.push(id);
                switch(field.type){
                    case "text":
                        {
                            const value = field.defaultValue || "";
                            storage.setValue(id, {
                                value: value
                            });
                            break;
                        }
                    case "checkbox":
                    case "radiobutton":
                        {
                            const value = field.defaultValue === field.exportValues;
                            storage.setValue(id, {
                                value: value
                            });
                            break;
                        }
                    case "combobox":
                    case "listbox":
                        {
                            const value = field.defaultValue || "";
                            storage.setValue(id, {
                                value: value
                            });
                            break;
                        }
                    default:
                        continue;
                }
                const domElement = document.querySelector(`[data-element-id="${id}"]`);
                if (!domElement) continue;
                else if (!$b3a01b20dd2ade98$var$GetElementsByNameSet.has(domElement)) {
                    $b3a01b20dd2ade98$var$warn(`_bindResetFormAction - element not allowed: ${id}`);
                    continue;
                }
                domElement.dispatchEvent(new Event("resetform"));
            }
            if (this.enableScripting) this.linkService.eventBus?.dispatch("dispatcheventinsandbox", {
                source: this,
                detail: {
                    id: "app",
                    ids: allIds,
                    name: "ResetForm"
                }
            });
            return false;
        };
    }
}
class $b3a01b20dd2ade98$var$TextAnnotationElement extends $b3a01b20dd2ade98$var$AnnotationElement {
    constructor(parameters){
        super(parameters, {
            isRenderable: true
        });
    }
    render() {
        this.container.classList.add("textAnnotation");
        const image = document.createElement("img");
        image.src = this.imageResourcesPath + "annotation-" + this.data.name.toLowerCase() + ".svg";
        image.setAttribute("data-l10n-id", "pdfjs-text-annotation-type");
        image.setAttribute("data-l10n-args", JSON.stringify({
            type: this.data.name
        }));
        if (!this.data.popupRef && this.hasPopupData) {
            this.hasOwnCommentButton = true;
            this._createPopup();
        }
        this.container.append(image);
        return this.container;
    }
}
class $b3a01b20dd2ade98$var$WidgetAnnotationElement extends $b3a01b20dd2ade98$var$AnnotationElement {
    render() {
        return this.container;
    }
    showElementAndHideCanvas(element) {
        if (this.data.hasOwnCanvas) {
            if (element.previousSibling?.nodeName === "CANVAS") element.previousSibling.hidden = true;
            element.hidden = false;
        }
    }
    _getKeyModifier(event) {
        return $b3a01b20dd2ade98$export$5fb8891d35c36978.platform.isMac ? event.metaKey : event.ctrlKey;
    }
    _setEventListener(element, elementData, baseName, eventName, valueGetter) {
        if (baseName.includes("mouse")) element.addEventListener(baseName, (event)=>{
            this.linkService.eventBus?.dispatch("dispatcheventinsandbox", {
                source: this,
                detail: {
                    id: this.data.id,
                    name: eventName,
                    value: valueGetter(event),
                    shift: event.shiftKey,
                    modifier: this._getKeyModifier(event)
                }
            });
        });
        else element.addEventListener(baseName, (event)=>{
            if (baseName === "blur") {
                if (!elementData.focused || !event.relatedTarget) return;
                elementData.focused = false;
            } else if (baseName === "focus") {
                if (elementData.focused) return;
                elementData.focused = true;
            }
            if (!valueGetter) return;
            this.linkService.eventBus?.dispatch("dispatcheventinsandbox", {
                source: this,
                detail: {
                    id: this.data.id,
                    name: eventName,
                    value: valueGetter(event)
                }
            });
        });
    }
    _setEventListeners(element, elementData, names, getter) {
        for (const [baseName, eventName] of names)if (eventName === "Action" || this.data.actions?.[eventName]) {
            if (eventName === "Focus" || eventName === "Blur") elementData ||= {
                focused: false
            };
            this._setEventListener(element, elementData, baseName, eventName, getter);
            if (eventName === "Focus" && !this.data.actions?.Blur) this._setEventListener(element, elementData, "blur", "Blur", null);
            else if (eventName === "Blur" && !this.data.actions?.Focus) this._setEventListener(element, elementData, "focus", "Focus", null);
        }
    }
    _setBackgroundColor(element) {
        const color = this.data.backgroundColor || null;
        element.style.backgroundColor = color === null ? "transparent" : $b3a01b20dd2ade98$export$f8f26dd395d7e1bd.makeHexColor(color[0], color[1], color[2]);
    }
    _setTextStyle(element) {
        const TEXT_ALIGNMENT = [
            "left",
            "center",
            "right"
        ];
        const { fontColor: fontColor } = this.data.defaultAppearanceData;
        const fontSize = this.data.defaultAppearanceData.fontSize || $b3a01b20dd2ade98$var$annotation_layer_DEFAULT_FONT_SIZE;
        const style = element.style;
        let computedFontSize;
        const BORDER_SIZE = 2;
        const roundToOneDecimal = (x)=>Math.round(10 * x) / 10;
        if (this.data.multiLine) {
            const height = Math.abs(this.data.rect[3] - this.data.rect[1] - BORDER_SIZE);
            const numberOfLines = Math.round(height / ($b3a01b20dd2ade98$var$LINE_FACTOR * fontSize)) || 1;
            const lineHeight = height / numberOfLines;
            computedFontSize = Math.min(fontSize, roundToOneDecimal(lineHeight / $b3a01b20dd2ade98$var$LINE_FACTOR));
        } else {
            const height = Math.abs(this.data.rect[3] - this.data.rect[1] - BORDER_SIZE);
            computedFontSize = Math.min(fontSize, roundToOneDecimal(height / $b3a01b20dd2ade98$var$LINE_FACTOR));
        }
        style.fontSize = `calc(${computedFontSize}px * var(--total-scale-factor))`;
        style.color = $b3a01b20dd2ade98$export$f8f26dd395d7e1bd.makeHexColor(fontColor[0], fontColor[1], fontColor[2]);
        if (this.data.textAlignment !== null) style.textAlign = TEXT_ALIGNMENT[this.data.textAlignment];
    }
    _setRequired(element, isRequired) {
        if (isRequired) element.setAttribute("required", true);
        else element.removeAttribute("required");
        element.setAttribute("aria-required", isRequired);
    }
}
class $b3a01b20dd2ade98$var$TextWidgetAnnotationElement extends $b3a01b20dd2ade98$var$WidgetAnnotationElement {
    constructor(parameters){
        const isRenderable = parameters.renderForms || parameters.data.hasOwnCanvas || !parameters.data.hasAppearance && !!parameters.data.fieldValue;
        super(parameters, {
            isRenderable: isRenderable
        });
    }
    setPropertyOnSiblings(base, key, value, keyInStorage) {
        const storage = this.annotationStorage;
        for (const element of this._getElementsByName(base.name, base.id)){
            if (element.domElement) element.domElement[key] = value;
            storage.setValue(element.id, {
                [keyInStorage]: value
            });
        }
    }
    render() {
        const storage = this.annotationStorage;
        const id = this.data.id;
        this.container.classList.add("textWidgetAnnotation");
        let element = null;
        if (this.renderForms) {
            const storedData = storage.getValue(id, {
                value: this.data.fieldValue
            });
            let textContent = storedData.value || "";
            const maxLen = storage.getValue(id, {
                charLimit: this.data.maxLen
            }).charLimit;
            if (maxLen && textContent.length > maxLen) textContent = textContent.slice(0, maxLen);
            let fieldFormattedValues = storedData.formattedValue || this.data.textContent?.join("\n") || null;
            if (fieldFormattedValues && this.data.comb) fieldFormattedValues = fieldFormattedValues.replaceAll(/\s+/g, "");
            const elementData = {
                userValue: textContent,
                formattedValue: fieldFormattedValues,
                lastCommittedValue: null,
                commitKey: 1,
                focused: false
            };
            if (this.data.multiLine) {
                element = document.createElement("textarea");
                element.textContent = fieldFormattedValues ?? textContent;
                if (this.data.doNotScroll) element.style.overflowY = "hidden";
            } else {
                element = document.createElement("input");
                element.type = this.data.password ? "password" : "text";
                element.setAttribute("value", fieldFormattedValues ?? textContent);
                if (this.data.doNotScroll) element.style.overflowX = "hidden";
            }
            if (this.data.hasOwnCanvas) element.hidden = true;
            $b3a01b20dd2ade98$var$GetElementsByNameSet.add(element);
            this.contentElement = element;
            element.setAttribute("data-element-id", id);
            element.disabled = this.data.readOnly;
            element.name = this.data.fieldName;
            element.tabIndex = 0;
            const { datetimeFormat: datetimeFormat, datetimeType: datetimeType, timeStep: timeStep } = this.data;
            const hasDateOrTime = !!datetimeType && this.enableScripting;
            if (datetimeFormat) element.title = datetimeFormat;
            this._setRequired(element, this.data.required);
            if (maxLen) element.maxLength = maxLen;
            element.addEventListener("input", (event)=>{
                storage.setValue(id, {
                    value: event.target.value
                });
                this.setPropertyOnSiblings(element, "value", event.target.value, "value");
                elementData.formattedValue = null;
            });
            element.addEventListener("resetform", (event)=>{
                const defaultValue = this.data.defaultFieldValue ?? "";
                element.value = elementData.userValue = defaultValue;
                elementData.formattedValue = null;
            });
            let blurListener = (event)=>{
                const { formattedValue: formattedValue } = elementData;
                if (formattedValue !== null && formattedValue !== undefined) event.target.value = formattedValue;
                event.target.scrollLeft = 0;
            };
            if (this.enableScripting && this.hasJSActions) {
                element.addEventListener("focus", (event)=>{
                    if (elementData.focused) return;
                    const { target: target } = event;
                    if (hasDateOrTime) {
                        target.type = datetimeType;
                        if (timeStep) target.step = timeStep;
                    }
                    if (elementData.userValue) {
                        const value = elementData.userValue;
                        if (hasDateOrTime) {
                            if (datetimeType === "time") {
                                const date = new Date(value);
                                const parts = [
                                    date.getHours(),
                                    date.getMinutes(),
                                    date.getSeconds()
                                ];
                                target.value = parts.map((v)=>v.toString().padStart(2, "0")).join(":");
                            } else target.value = new Date(value - $b3a01b20dd2ade98$var$TIMEZONE_OFFSET).toISOString().split(datetimeType === "date" ? "T" : ".", 1)[0];
                        } else target.value = value;
                    }
                    elementData.lastCommittedValue = target.value;
                    elementData.commitKey = 1;
                    if (!this.data.actions?.Focus) elementData.focused = true;
                });
                element.addEventListener("updatefromsandbox", (jsEvent)=>{
                    this.showElementAndHideCanvas(jsEvent.target);
                    const actions = {
                        value (event) {
                            elementData.userValue = event.detail.value ?? "";
                            if (!hasDateOrTime) storage.setValue(id, {
                                value: elementData.userValue.toString()
                            });
                            event.target.value = elementData.userValue;
                        },
                        formattedValue (event) {
                            const { formattedValue: formattedValue } = event.detail;
                            elementData.formattedValue = formattedValue;
                            if (formattedValue !== null && formattedValue !== undefined && event.target !== document.activeElement) event.target.value = formattedValue;
                            const data = {
                                formattedValue: formattedValue
                            };
                            if (hasDateOrTime) data.value = formattedValue;
                            storage.setValue(id, data);
                        },
                        selRange (event) {
                            event.target.setSelectionRange(...event.detail.selRange);
                        },
                        charLimit: (event)=>{
                            const { charLimit: charLimit } = event.detail;
                            const { target: target } = event;
                            if (charLimit === 0) {
                                target.removeAttribute("maxLength");
                                return;
                            }
                            target.setAttribute("maxLength", charLimit);
                            let value = elementData.userValue;
                            if (!value || value.length <= charLimit) return;
                            value = value.slice(0, charLimit);
                            target.value = elementData.userValue = value;
                            storage.setValue(id, {
                                value: value
                            });
                            this.linkService.eventBus?.dispatch("dispatcheventinsandbox", {
                                source: this,
                                detail: {
                                    id: id,
                                    name: "Keystroke",
                                    value: value,
                                    willCommit: true,
                                    commitKey: 1,
                                    selStart: target.selectionStart,
                                    selEnd: target.selectionEnd
                                }
                            });
                        }
                    };
                    this._dispatchEventFromSandbox(actions, jsEvent);
                });
                element.addEventListener("keydown", (event)=>{
                    elementData.commitKey = 1;
                    let commitKey = -1;
                    if (event.key === "Escape") commitKey = 0;
                    else if (event.key === "Enter" && !this.data.multiLine) commitKey = 2;
                    else if (event.key === "Tab") elementData.commitKey = 3;
                    if (commitKey === -1) return;
                    const { value: value } = event.target;
                    if (elementData.lastCommittedValue === value) return;
                    elementData.lastCommittedValue = value;
                    elementData.userValue = value;
                    this.linkService.eventBus?.dispatch("dispatcheventinsandbox", {
                        source: this,
                        detail: {
                            id: id,
                            name: "Keystroke",
                            value: value,
                            willCommit: true,
                            commitKey: commitKey,
                            selStart: event.target.selectionStart,
                            selEnd: event.target.selectionEnd
                        }
                    });
                });
                const _blurListener = blurListener;
                blurListener = null;
                element.addEventListener("blur", (event)=>{
                    if (!elementData.focused || !event.relatedTarget) return;
                    if (!this.data.actions?.Blur) elementData.focused = false;
                    const { target: target } = event;
                    let { value: value } = target;
                    if (hasDateOrTime) {
                        if (value && datetimeType === "time") {
                            const parts = value.split(":").map((v)=>parseInt(v, 10));
                            value = new Date(2000, 0, 1, parts[0], parts[1], parts[2] || 0).valueOf();
                            target.step = "";
                        } else {
                            if (!value.includes("T")) value = `${value}T00:00`;
                            value = new Date(value).valueOf();
                        }
                        target.type = "text";
                    }
                    elementData.userValue = value;
                    if (elementData.lastCommittedValue !== value) this.linkService.eventBus?.dispatch("dispatcheventinsandbox", {
                        source: this,
                        detail: {
                            id: id,
                            name: "Keystroke",
                            value: value,
                            willCommit: true,
                            commitKey: elementData.commitKey,
                            selStart: event.target.selectionStart,
                            selEnd: event.target.selectionEnd
                        }
                    });
                    _blurListener(event);
                });
                if (this.data.actions?.Keystroke) element.addEventListener("beforeinput", (event)=>{
                    elementData.lastCommittedValue = null;
                    const { data: data, target: target } = event;
                    const { value: value, selectionStart: selectionStart, selectionEnd: selectionEnd } = target;
                    let selStart = selectionStart, selEnd = selectionEnd;
                    switch(event.inputType){
                        case "deleteWordBackward":
                            {
                                const match = value.substring(0, selectionStart).match(/\w*[^\w]*$/);
                                if (match) selStart -= match[0].length;
                                break;
                            }
                        case "deleteWordForward":
                            {
                                const match = value.substring(selectionStart).match(/^[^\w]*\w*/);
                                if (match) selEnd += match[0].length;
                                break;
                            }
                        case "deleteContentBackward":
                            if (selectionStart === selectionEnd) selStart -= 1;
                            break;
                        case "deleteContentForward":
                            if (selectionStart === selectionEnd) selEnd += 1;
                            break;
                    }
                    event.preventDefault();
                    this.linkService.eventBus?.dispatch("dispatcheventinsandbox", {
                        source: this,
                        detail: {
                            id: id,
                            name: "Keystroke",
                            value: value,
                            change: data || "",
                            willCommit: false,
                            selStart: selStart,
                            selEnd: selEnd
                        }
                    });
                });
                this._setEventListeners(element, elementData, [
                    [
                        "focus",
                        "Focus"
                    ],
                    [
                        "blur",
                        "Blur"
                    ],
                    [
                        "mousedown",
                        "Mouse Down"
                    ],
                    [
                        "mouseenter",
                        "Mouse Enter"
                    ],
                    [
                        "mouseleave",
                        "Mouse Exit"
                    ],
                    [
                        "mouseup",
                        "Mouse Up"
                    ]
                ], (event)=>event.target.value);
            }
            if (blurListener) element.addEventListener("blur", blurListener);
            if (this.data.comb) {
                const fieldWidth = this.data.rect[2] - this.data.rect[0];
                const combWidth = fieldWidth / maxLen;
                element.classList.add("comb");
                element.style.letterSpacing = `calc(${combWidth}px * var(--total-scale-factor) - 1ch)`;
            }
        } else {
            element = document.createElement("div");
            element.textContent = this.data.fieldValue;
            element.style.verticalAlign = "middle";
            element.style.display = "table-cell";
            if (this.data.hasOwnCanvas) element.hidden = true;
        }
        this._setTextStyle(element);
        this._setBackgroundColor(element);
        this._setDefaultPropertiesFromJS(element);
        this.container.append(element);
        return this.container;
    }
}
class $b3a01b20dd2ade98$var$SignatureWidgetAnnotationElement extends $b3a01b20dd2ade98$var$WidgetAnnotationElement {
    constructor(parameters){
        super(parameters, {
            isRenderable: !!parameters.data.hasOwnCanvas
        });
    }
}
class $b3a01b20dd2ade98$var$CheckboxWidgetAnnotationElement extends $b3a01b20dd2ade98$var$WidgetAnnotationElement {
    constructor(parameters){
        super(parameters, {
            isRenderable: parameters.renderForms
        });
    }
    render() {
        const storage = this.annotationStorage;
        const data = this.data;
        const id = data.id;
        let value = storage.getValue(id, {
            value: data.exportValue === data.fieldValue
        }).value;
        if (typeof value === "string") {
            value = value !== "Off";
            storage.setValue(id, {
                value: value
            });
        }
        this.container.classList.add("buttonWidgetAnnotation", "checkBox");
        const element = document.createElement("input");
        $b3a01b20dd2ade98$var$GetElementsByNameSet.add(element);
        element.setAttribute("data-element-id", id);
        element.disabled = data.readOnly;
        this._setRequired(element, this.data.required);
        element.type = "checkbox";
        element.name = data.fieldName;
        if (value) element.setAttribute("checked", true);
        element.setAttribute("exportValue", data.exportValue);
        element.tabIndex = 0;
        element.addEventListener("change", (event)=>{
            const { name: name, checked: checked } = event.target;
            for (const checkbox of this._getElementsByName(name, id)){
                const curChecked = checked && checkbox.exportValue === data.exportValue;
                if (checkbox.domElement) checkbox.domElement.checked = curChecked;
                storage.setValue(checkbox.id, {
                    value: curChecked
                });
            }
            storage.setValue(id, {
                value: checked
            });
        });
        element.addEventListener("resetform", (event)=>{
            const defaultValue = data.defaultFieldValue || "Off";
            event.target.checked = defaultValue === data.exportValue;
        });
        if (this.enableScripting && this.hasJSActions) {
            element.addEventListener("updatefromsandbox", (jsEvent)=>{
                const actions = {
                    value (event) {
                        event.target.checked = event.detail.value !== "Off";
                        storage.setValue(id, {
                            value: event.target.checked
                        });
                    }
                };
                this._dispatchEventFromSandbox(actions, jsEvent);
            });
            this._setEventListeners(element, null, [
                [
                    "change",
                    "Validate"
                ],
                [
                    "change",
                    "Action"
                ],
                [
                    "focus",
                    "Focus"
                ],
                [
                    "blur",
                    "Blur"
                ],
                [
                    "mousedown",
                    "Mouse Down"
                ],
                [
                    "mouseenter",
                    "Mouse Enter"
                ],
                [
                    "mouseleave",
                    "Mouse Exit"
                ],
                [
                    "mouseup",
                    "Mouse Up"
                ]
            ], (event)=>event.target.checked);
        }
        this._setBackgroundColor(element);
        this._setDefaultPropertiesFromJS(element);
        this.container.append(element);
        return this.container;
    }
}
class $b3a01b20dd2ade98$var$RadioButtonWidgetAnnotationElement extends $b3a01b20dd2ade98$var$WidgetAnnotationElement {
    constructor(parameters){
        super(parameters, {
            isRenderable: parameters.renderForms
        });
    }
    render() {
        this.container.classList.add("buttonWidgetAnnotation", "radioButton");
        const storage = this.annotationStorage;
        const data = this.data;
        const id = data.id;
        let value = storage.getValue(id, {
            value: data.fieldValue === data.buttonValue
        }).value;
        if (typeof value === "string") {
            value = value !== data.buttonValue;
            storage.setValue(id, {
                value: value
            });
        }
        if (value) for (const radio of this._getElementsByName(data.fieldName, id))storage.setValue(radio.id, {
            value: false
        });
        const element = document.createElement("input");
        $b3a01b20dd2ade98$var$GetElementsByNameSet.add(element);
        element.setAttribute("data-element-id", id);
        element.disabled = data.readOnly;
        this._setRequired(element, this.data.required);
        element.type = "radio";
        element.name = data.fieldName;
        if (value) element.setAttribute("checked", true);
        element.tabIndex = 0;
        element.addEventListener("change", (event)=>{
            const { name: name, checked: checked } = event.target;
            for (const radio of this._getElementsByName(name, id))storage.setValue(radio.id, {
                value: false
            });
            storage.setValue(id, {
                value: checked
            });
        });
        element.addEventListener("resetform", (event)=>{
            const defaultValue = data.defaultFieldValue;
            event.target.checked = defaultValue !== null && defaultValue !== undefined && defaultValue === data.buttonValue;
        });
        if (this.enableScripting && this.hasJSActions) {
            const pdfButtonValue = data.buttonValue;
            element.addEventListener("updatefromsandbox", (jsEvent)=>{
                const actions = {
                    value: (event)=>{
                        const checked = pdfButtonValue === event.detail.value;
                        for (const radio of this._getElementsByName(event.target.name)){
                            const curChecked = checked && radio.id === id;
                            if (radio.domElement) radio.domElement.checked = curChecked;
                            storage.setValue(radio.id, {
                                value: curChecked
                            });
                        }
                    }
                };
                this._dispatchEventFromSandbox(actions, jsEvent);
            });
            this._setEventListeners(element, null, [
                [
                    "change",
                    "Validate"
                ],
                [
                    "change",
                    "Action"
                ],
                [
                    "focus",
                    "Focus"
                ],
                [
                    "blur",
                    "Blur"
                ],
                [
                    "mousedown",
                    "Mouse Down"
                ],
                [
                    "mouseenter",
                    "Mouse Enter"
                ],
                [
                    "mouseleave",
                    "Mouse Exit"
                ],
                [
                    "mouseup",
                    "Mouse Up"
                ]
            ], (event)=>event.target.checked);
        }
        this._setBackgroundColor(element);
        this._setDefaultPropertiesFromJS(element);
        this.container.append(element);
        return this.container;
    }
}
class $b3a01b20dd2ade98$var$PushButtonWidgetAnnotationElement extends $b3a01b20dd2ade98$var$LinkAnnotationElement {
    constructor(parameters){
        super(parameters, {
            ignoreBorder: parameters.data.hasAppearance
        });
    }
    render() {
        const container = super.render();
        container.classList.add("buttonWidgetAnnotation", "pushButton");
        const linkElement = container.lastChild;
        if (this.enableScripting && this.hasJSActions && linkElement) {
            this._setDefaultPropertiesFromJS(linkElement);
            linkElement.addEventListener("updatefromsandbox", (jsEvent)=>{
                this._dispatchEventFromSandbox({}, jsEvent);
            });
        }
        return container;
    }
}
class $b3a01b20dd2ade98$var$ChoiceWidgetAnnotationElement extends $b3a01b20dd2ade98$var$WidgetAnnotationElement {
    constructor(parameters){
        super(parameters, {
            isRenderable: parameters.renderForms
        });
    }
    render() {
        this.container.classList.add("choiceWidgetAnnotation");
        const storage = this.annotationStorage;
        const id = this.data.id;
        const storedData = storage.getValue(id, {
            value: this.data.fieldValue
        });
        const selectElement = document.createElement("select");
        $b3a01b20dd2ade98$var$GetElementsByNameSet.add(selectElement);
        selectElement.setAttribute("data-element-id", id);
        selectElement.disabled = this.data.readOnly;
        this._setRequired(selectElement, this.data.required);
        selectElement.name = this.data.fieldName;
        selectElement.tabIndex = 0;
        let addAnEmptyEntry = this.data.combo && this.data.options.length > 0;
        if (!this.data.combo) {
            selectElement.size = this.data.options.length;
            if (this.data.multiSelect) selectElement.multiple = true;
        }
        selectElement.addEventListener("resetform", (event)=>{
            const defaultValue = this.data.defaultFieldValue;
            for (const option of selectElement.options)option.selected = option.value === defaultValue;
        });
        const fixDisplayValue = (option, value)=>{
            const newValue = value.replaceAll(" ", "\u00A0");
            option.textContent = newValue;
            if (newValue !== value) option.setAttribute("display-value", value);
        };
        for (const option of this.data.options){
            const optionElement = document.createElement("option");
            fixDisplayValue(optionElement, option.displayValue);
            optionElement.value = option.exportValue;
            if (storedData.value.includes(option.exportValue)) {
                optionElement.setAttribute("selected", true);
                addAnEmptyEntry = false;
            }
            selectElement.append(optionElement);
        }
        let removeEmptyEntry = null;
        if (addAnEmptyEntry) {
            const noneOptionElement = document.createElement("option");
            noneOptionElement.value = " ";
            noneOptionElement.setAttribute("hidden", true);
            noneOptionElement.setAttribute("selected", true);
            selectElement.prepend(noneOptionElement);
            removeEmptyEntry = ()=>{
                noneOptionElement.remove();
                selectElement.removeEventListener("input", removeEmptyEntry);
                removeEmptyEntry = null;
            };
            selectElement.addEventListener("input", removeEmptyEntry);
        }
        const getValue = (isExport)=>{
            const name = isExport ? "value" : "textContent";
            const { options: options, multiple: multiple } = selectElement;
            if (!multiple) return options.selectedIndex === -1 ? null : options[options.selectedIndex][name];
            return Array.prototype.filter.call(options, (option)=>option.selected).map((option)=>option[name]);
        };
        let selectedValues = getValue(false);
        const getItems = (event)=>{
            const options = event.target.options;
            return Array.prototype.map.call(options, (option)=>({
                    displayValue: option.getAttribute("display-value") || option.textContent,
                    exportValue: option.value
                }));
        };
        if (this.enableScripting && this.hasJSActions) {
            selectElement.addEventListener("updatefromsandbox", (jsEvent)=>{
                const actions = {
                    value (event) {
                        removeEmptyEntry?.();
                        const value = event.detail.value;
                        const values = new Set(Array.isArray(value) ? value : [
                            value
                        ]);
                        for (const option of selectElement.options)option.selected = values.has(option.value);
                        storage.setValue(id, {
                            value: getValue(true)
                        });
                        selectedValues = getValue(false);
                    },
                    multipleSelection (event) {
                        selectElement.multiple = true;
                    },
                    remove (event) {
                        const options = selectElement.options;
                        const index = event.detail.remove;
                        options[index].selected = false;
                        selectElement.remove(index);
                        if (options.length > 0) {
                            const i = Array.prototype.findIndex.call(options, (option)=>option.selected);
                            if (i === -1) options[0].selected = true;
                        }
                        storage.setValue(id, {
                            value: getValue(true),
                            items: getItems(event)
                        });
                        selectedValues = getValue(false);
                    },
                    clear (event) {
                        while(selectElement.length !== 0)selectElement.remove(0);
                        storage.setValue(id, {
                            value: null,
                            items: []
                        });
                        selectedValues = getValue(false);
                    },
                    insert (event) {
                        const { index: index, displayValue: displayValue, exportValue: exportValue } = event.detail.insert;
                        const selectChild = selectElement.children[index];
                        const optionElement = document.createElement("option");
                        fixDisplayValue(optionElement, displayValue);
                        optionElement.value = exportValue;
                        if (selectChild) selectChild.before(optionElement);
                        else selectElement.append(optionElement);
                        storage.setValue(id, {
                            value: getValue(true),
                            items: getItems(event)
                        });
                        selectedValues = getValue(false);
                    },
                    items (event) {
                        const { items: items } = event.detail;
                        while(selectElement.length !== 0)selectElement.remove(0);
                        for (const item of items){
                            const { displayValue: displayValue, exportValue: exportValue } = item;
                            const optionElement = document.createElement("option");
                            fixDisplayValue(optionElement, displayValue);
                            optionElement.value = exportValue;
                            selectElement.append(optionElement);
                        }
                        if (selectElement.options.length > 0) selectElement.options[0].selected = true;
                        storage.setValue(id, {
                            value: getValue(true),
                            items: getItems(event)
                        });
                        selectedValues = getValue(false);
                    },
                    indices (event) {
                        const indices = new Set(event.detail.indices);
                        for (const option of event.target.options)option.selected = indices.has(option.index);
                        storage.setValue(id, {
                            value: getValue(true)
                        });
                        selectedValues = getValue(false);
                    },
                    editable (event) {
                        event.target.disabled = !event.detail.editable;
                    }
                };
                this._dispatchEventFromSandbox(actions, jsEvent);
            });
            selectElement.addEventListener("input", (event)=>{
                const exportValue = getValue(true);
                const change = getValue(false);
                storage.setValue(id, {
                    value: exportValue
                });
                event.preventDefault();
                this.linkService.eventBus?.dispatch("dispatcheventinsandbox", {
                    source: this,
                    detail: {
                        id: id,
                        name: "Keystroke",
                        value: selectedValues,
                        change: change,
                        changeEx: exportValue,
                        willCommit: false,
                        commitKey: 1,
                        keyDown: false
                    }
                });
            });
            this._setEventListeners(selectElement, null, [
                [
                    "focus",
                    "Focus"
                ],
                [
                    "blur",
                    "Blur"
                ],
                [
                    "mousedown",
                    "Mouse Down"
                ],
                [
                    "mouseenter",
                    "Mouse Enter"
                ],
                [
                    "mouseleave",
                    "Mouse Exit"
                ],
                [
                    "mouseup",
                    "Mouse Up"
                ],
                [
                    "input",
                    "Action"
                ],
                [
                    "input",
                    "Validate"
                ]
            ], (event)=>event.target.value);
        } else selectElement.addEventListener("input", function(event) {
            storage.setValue(id, {
                value: getValue(true)
            });
        });
        if (this.data.combo) this._setTextStyle(selectElement);
        this._setBackgroundColor(selectElement);
        this._setDefaultPropertiesFromJS(selectElement);
        this.container.append(selectElement);
        return this.container;
    }
}
class $b3a01b20dd2ade98$var$PopupAnnotationElement extends $b3a01b20dd2ade98$var$AnnotationElement {
    constructor(parameters){
        const { data: data, elements: elements, parent: parent } = parameters;
        const hasCommentManager = !!parent._commentManager;
        super(parameters, {
            isRenderable: !hasCommentManager && $b3a01b20dd2ade98$var$AnnotationElement._hasPopupData(data)
        });
        this.elements = elements;
        if (hasCommentManager && $b3a01b20dd2ade98$var$AnnotationElement._hasPopupData(data)) {
            const popup = this.popup = this.#createPopup();
            for (const element of elements)element.popup = popup;
        } else this.popup = null;
    }
    #createPopup() {
        return new $b3a01b20dd2ade98$var$PopupElement({
            container: this.container,
            color: this.data.color,
            titleObj: this.data.titleObj,
            modificationDate: this.data.modificationDate || this.data.creationDate,
            contentsObj: this.data.contentsObj,
            richText: this.data.richText,
            rect: this.data.rect,
            parentRect: this.data.parentRect || null,
            parent: this.parent,
            elements: this.elements,
            open: this.data.open,
            commentManager: this.parent._commentManager
        });
    }
    render() {
        const { container: container } = this;
        container.classList.add("popupAnnotation");
        container.role = "comment";
        const popup = this.popup = this.#createPopup();
        const elementIds = [];
        for (const element of this.elements){
            element.popup = popup;
            element.container.ariaHasPopup = "dialog";
            elementIds.push(element.data.id);
            element.addHighlightArea();
        }
        this.container.setAttribute("aria-controls", elementIds.map((id)=>`${$b3a01b20dd2ade98$var$AnnotationPrefix}${id}`).join(","));
        return this.container;
    }
}
class $b3a01b20dd2ade98$var$PopupElement {
    #commentManager = null;
    #boundKeyDown = this.#keyDown.bind(this);
    #boundHide = this.#hide.bind(this);
    #boundShow = this.#show.bind(this);
    #boundToggle = this.#toggle.bind(this);
    #color = null;
    #container = null;
    #contentsObj = null;
    #dateObj = null;
    #elements = null;
    #parent = null;
    #parentRect = null;
    #pinned = false;
    #popup = null;
    #popupAbortController = null;
    #position = null;
    #commentButton = null;
    #commentButtonPosition = null;
    #popupPosition = null;
    #rect = null;
    #richText = null;
    #titleObj = null;
    #updates = null;
    #wasVisible = false;
    #firstElement = null;
    #commentText = null;
    constructor({ container: container, color: color, elements: elements, titleObj: titleObj, modificationDate: modificationDate, contentsObj: contentsObj, richText: richText, parent: parent, rect: rect, parentRect: parentRect, open: open, commentManager: commentManager = null }){
        this.#container = container;
        this.#titleObj = titleObj;
        this.#contentsObj = contentsObj;
        this.#richText = richText;
        this.#parent = parent;
        this.#color = color;
        this.#rect = rect;
        this.#parentRect = parentRect;
        this.#elements = elements;
        this.#commentManager = commentManager;
        this.#firstElement = elements[0];
        this.#dateObj = $b3a01b20dd2ade98$export$66cbc314498fffc.toDateObject(modificationDate);
        this.trigger = elements.flatMap((e)=>e.getElementsToTriggerPopup());
        if (!commentManager) {
            this.#addEventListeners();
            this.#container.hidden = true;
            if (open) this.#toggle();
        }
    }
    #addEventListeners() {
        if (this.#popupAbortController) return;
        this.#popupAbortController = new AbortController();
        const { signal: signal } = this.#popupAbortController;
        for (const element of this.trigger){
            element.addEventListener("click", this.#boundToggle, {
                signal: signal
            });
            element.addEventListener("pointerenter", this.#boundShow, {
                signal: signal
            });
            element.addEventListener("pointerleave", this.#boundHide, {
                signal: signal
            });
            element.classList.add("popupTriggerArea");
        }
        for (const element of this.#elements)element.container?.addEventListener("keydown", this.#boundKeyDown, {
            signal: signal
        });
    }
    #setCommentButtonPosition() {
        const element = this.#elements.find((e)=>e.hasCommentButton);
        if (!element) return;
        this.#commentButtonPosition = element._normalizePoint(element.commentButtonPosition);
    }
    renderCommentButton() {
        if (this.#commentButton) {
            if (!this.#commentButton.parentNode) this.#firstElement.container.after(this.#commentButton);
            return;
        }
        if (!this.#commentButtonPosition) this.#setCommentButtonPosition();
        if (!this.#commentButtonPosition) return;
        const { signal: signal } = this.#popupAbortController = new AbortController();
        const hasOwnButton = this.#firstElement.hasOwnCommentButton;
        const togglePopup = ()=>{
            this.#commentManager.toggleCommentPopup(this, true, undefined, !hasOwnButton);
        };
        const showPopup = ()=>{
            this.#commentManager.toggleCommentPopup(this, false, true, !hasOwnButton);
        };
        const hidePopup = ()=>{
            this.#commentManager.toggleCommentPopup(this, false, false);
        };
        if (!hasOwnButton) {
            const button = this.#commentButton = document.createElement("button");
            button.className = "annotationCommentButton";
            const parentContainer = this.#firstElement.container;
            button.style.zIndex = parentContainer.style.zIndex + 1;
            button.tabIndex = 0;
            button.ariaHasPopup = "dialog";
            button.ariaControls = "commentPopup";
            button.setAttribute("data-l10n-id", "pdfjs-show-comment-button");
            this.#updateColor();
            this.#updateCommentButtonPosition();
            button.addEventListener("keydown", this.#boundKeyDown, {
                signal: signal
            });
            button.addEventListener("click", togglePopup, {
                signal: signal
            });
            button.addEventListener("pointerenter", showPopup, {
                signal: signal
            });
            button.addEventListener("pointerleave", hidePopup, {
                signal: signal
            });
            parentContainer.after(button);
        } else {
            this.#commentButton = this.#firstElement.container;
            for (const element of this.trigger){
                element.ariaHasPopup = "dialog";
                element.ariaControls = "commentPopup";
                element.addEventListener("keydown", this.#boundKeyDown, {
                    signal: signal
                });
                element.addEventListener("click", togglePopup, {
                    signal: signal
                });
                element.addEventListener("pointerenter", showPopup, {
                    signal: signal
                });
                element.addEventListener("pointerleave", hidePopup, {
                    signal: signal
                });
                element.classList.add("popupTriggerArea");
            }
        }
    }
    #updateCommentButtonPosition() {
        if (this.#firstElement.extraPopupElement && !this.#firstElement.editor) return;
        if (!this.#commentButton) this.renderCommentButton();
        const [x, y] = this.#commentButtonPosition;
        const { style: style } = this.#commentButton;
        style.left = `calc(${x}%)`;
        style.top = `calc(${y}% - var(--comment-button-dim))`;
    }
    #updateColor() {
        if (this.#firstElement.extraPopupElement) return;
        if (!this.#commentButton) this.renderCommentButton();
        this.#commentButton.style.backgroundColor = this.commentButtonColor || "";
    }
    get commentButtonColor() {
        const { color: color, opacity: opacity } = this.#firstElement.commentData;
        if (!color) return null;
        return this.#parent._commentManager.makeCommentColor(color, opacity);
    }
    focusCommentButton() {
        setTimeout(()=>{
            this.#commentButton?.focus();
        }, 0);
    }
    getData() {
        const { richText: richText, color: color, opacity: opacity, creationDate: creationDate, modificationDate: modificationDate } = this.#firstElement.commentData;
        return {
            contentsObj: {
                str: this.comment
            },
            richText: richText,
            color: color,
            opacity: opacity,
            creationDate: creationDate,
            modificationDate: modificationDate
        };
    }
    get elementBeforePopup() {
        return this.#commentButton;
    }
    get comment() {
        this.#commentText ||= this.#firstElement.commentText;
        return this.#commentText;
    }
    set comment(text) {
        if (text === this.comment) return;
        this.#firstElement.commentText = this.#commentText = text;
    }
    focus() {
        this.#firstElement.container?.focus();
    }
    get parentBoundingClientRect() {
        return this.#firstElement.layer.getBoundingClientRect();
    }
    setCommentButtonStates({ selected: selected, hasPopup: hasPopup }) {
        if (!this.#commentButton) return;
        this.#commentButton.classList.toggle("selected", selected);
        this.#commentButton.ariaExpanded = hasPopup;
    }
    setSelectedCommentButton(selected) {
        this.#commentButton.classList.toggle("selected", selected);
    }
    get commentPopupPosition() {
        if (this.#popupPosition) return this.#popupPosition;
        const { x: x, y: y, height: height } = this.#commentButton.getBoundingClientRect();
        const { x: parentX, y: parentY, width: parentWidth, height: parentHeight } = this.#firstElement.layer.getBoundingClientRect();
        return [
            (x - parentX) / parentWidth,
            (y + height - parentY) / parentHeight
        ];
    }
    set commentPopupPosition(pos) {
        this.#popupPosition = pos;
    }
    hasDefaultPopupPosition() {
        return this.#popupPosition === null;
    }
    get commentButtonPosition() {
        return this.#commentButtonPosition;
    }
    get commentButtonWidth() {
        return this.#commentButton.getBoundingClientRect().width / this.parentBoundingClientRect.width;
    }
    editComment(options) {
        const [posX, posY] = this.#popupPosition || this.commentButtonPosition.map((x)=>x / 100);
        const parentDimensions = this.parentBoundingClientRect;
        const { x: parentX, y: parentY, width: parentWidth, height: parentHeight } = parentDimensions;
        this.#commentManager.showDialog(null, this, parentX + posX * parentWidth, parentY + posY * parentHeight, {
            ...options,
            parentDimensions: parentDimensions
        });
    }
    render() {
        if (this.#popup) return;
        const popup = this.#popup = document.createElement("div");
        popup.className = "popup";
        if (this.#color) {
            const baseColor = popup.style.outlineColor = $b3a01b20dd2ade98$export$f8f26dd395d7e1bd.makeHexColor(...this.#color);
            popup.style.backgroundColor = `color-mix(in srgb, ${baseColor} 30%, white)`;
        }
        const header = document.createElement("span");
        header.className = "header";
        if (this.#titleObj?.str) {
            const title = document.createElement("span");
            title.className = "title";
            header.append(title);
            ({ dir: title.dir, str: title.textContent } = this.#titleObj);
        }
        popup.append(header);
        if (this.#dateObj) {
            const modificationDate = document.createElement("time");
            modificationDate.className = "popupDate";
            modificationDate.setAttribute("data-l10n-id", "pdfjs-annotation-date-time-string");
            modificationDate.setAttribute("data-l10n-args", JSON.stringify({
                dateObj: this.#dateObj.valueOf()
            }));
            modificationDate.dateTime = this.#dateObj.toISOString();
            header.append(modificationDate);
        }
        $b3a01b20dd2ade98$export$611c480766035c4({
            html: this.#html || this.#contentsObj.str,
            dir: this.#contentsObj?.dir,
            className: "popupContent"
        }, popup);
        this.#container.append(popup);
    }
    get #html() {
        const richText = this.#richText;
        const contentsObj = this.#contentsObj;
        if (richText?.str && (!contentsObj?.str || contentsObj.str === richText.str)) return this.#richText.html || null;
        return null;
    }
    get #fontSize() {
        return this.#html?.attributes?.style?.fontSize || 0;
    }
    get #fontColor() {
        return this.#html?.attributes?.style?.color || null;
    }
    #makePopupContent(text) {
        const popupLines = [];
        const popupContent = {
            str: text,
            html: {
                name: "div",
                attributes: {
                    dir: "auto"
                },
                children: [
                    {
                        name: "p",
                        children: popupLines
                    }
                ]
            }
        };
        const lineAttributes = {
            style: {
                color: this.#fontColor,
                fontSize: this.#fontSize ? `calc(${this.#fontSize}px * var(--total-scale-factor))` : ""
            }
        };
        for (const line of text.split("\n"))popupLines.push({
            name: "span",
            value: line,
            attributes: lineAttributes
        });
        return popupContent;
    }
    #keyDown(event) {
        if (event.altKey || event.shiftKey || event.ctrlKey || event.metaKey) return;
        if (event.key === "Enter" || event.key === "Escape" && this.#pinned) this.#toggle();
    }
    updateEdited({ rect: rect, popup: popup, deleted: deleted }) {
        if (this.#commentManager) {
            if (deleted) {
                this.remove();
                this.#commentText = null;
            } else if (popup) {
                if (popup.deleted) this.remove();
                else {
                    this.#updateColor();
                    this.#commentText = popup.text;
                }
            }
            if (rect) {
                this.#commentButtonPosition = null;
                this.#setCommentButtonPosition();
                this.#updateCommentButtonPosition();
            }
            return;
        }
        if (deleted || popup?.deleted) {
            this.remove();
            return;
        }
        this.#addEventListeners();
        this.#updates ||= {
            contentsObj: this.#contentsObj,
            richText: this.#richText
        };
        if (rect) this.#position = null;
        if (popup && popup.text) {
            this.#richText = this.#makePopupContent(popup.text);
            this.#dateObj = $b3a01b20dd2ade98$export$66cbc314498fffc.toDateObject(popup.date);
            this.#contentsObj = null;
        }
        this.#popup?.remove();
        this.#popup = null;
    }
    resetEdited() {
        if (!this.#updates) return;
        ({ contentsObj: this.#contentsObj, richText: this.#richText } = this.#updates);
        this.#updates = null;
        this.#popup?.remove();
        this.#popup = null;
        this.#position = null;
    }
    remove() {
        this.#popupAbortController?.abort();
        this.#popupAbortController = null;
        this.#popup?.remove();
        this.#popup = null;
        this.#wasVisible = false;
        this.#pinned = false;
        this.#commentButton?.remove();
        this.#commentButton = null;
        if (this.trigger) for (const element of this.trigger)element.classList.remove("popupTriggerArea");
    }
    #setPosition() {
        if (this.#position !== null) return;
        const { page: { view: view }, viewport: { rawDims: { pageWidth: pageWidth, pageHeight: pageHeight, pageX: pageX, pageY: pageY } } } = this.#parent;
        let useParentRect = !!this.#parentRect;
        let rect = useParentRect ? this.#parentRect : this.#rect;
        for (const element of this.#elements)if (!rect || $b3a01b20dd2ade98$export$f8f26dd395d7e1bd.intersect(element.data.rect, rect) !== null) {
            rect = element.data.rect;
            useParentRect = true;
            break;
        }
        const normalizedRect = $b3a01b20dd2ade98$export$f8f26dd395d7e1bd.normalizeRect([
            rect[0],
            view[3] - rect[1] + view[1],
            rect[2],
            view[3] - rect[3] + view[1]
        ]);
        const HORIZONTAL_SPACE_AFTER_ANNOTATION = 5;
        const parentWidth = useParentRect ? rect[2] - rect[0] + HORIZONTAL_SPACE_AFTER_ANNOTATION : 0;
        const popupLeft = normalizedRect[0] + parentWidth;
        const popupTop = normalizedRect[1];
        this.#position = [
            100 * (popupLeft - pageX) / pageWidth,
            100 * (popupTop - pageY) / pageHeight
        ];
        const { style: style } = this.#container;
        style.left = `${this.#position[0]}%`;
        style.top = `${this.#position[1]}%`;
    }
    #toggle() {
        if (this.#commentManager) {
            this.#commentManager.toggleCommentPopup(this, false);
            return;
        }
        this.#pinned = !this.#pinned;
        if (this.#pinned) {
            this.#show();
            this.#container.addEventListener("click", this.#boundToggle);
            this.#container.addEventListener("keydown", this.#boundKeyDown);
        } else {
            this.#hide();
            this.#container.removeEventListener("click", this.#boundToggle);
            this.#container.removeEventListener("keydown", this.#boundKeyDown);
        }
    }
    #show() {
        if (!this.#popup) this.render();
        if (!this.isVisible) {
            this.#setPosition();
            this.#container.hidden = false;
            this.#container.style.zIndex = parseInt(this.#container.style.zIndex) + 1000;
        } else if (this.#pinned) this.#container.classList.add("focused");
    }
    #hide() {
        this.#container.classList.remove("focused");
        if (this.#pinned || !this.isVisible) return;
        this.#container.hidden = true;
        this.#container.style.zIndex = parseInt(this.#container.style.zIndex) - 1000;
    }
    forceHide() {
        this.#wasVisible = this.isVisible;
        if (!this.#wasVisible) return;
        this.#container.hidden = true;
    }
    maybeShow() {
        if (this.#commentManager) return;
        this.#addEventListeners();
        if (!this.#wasVisible) return;
        if (!this.#popup) this.#show();
        this.#wasVisible = false;
        this.#container.hidden = false;
    }
    get isVisible() {
        if (this.#commentManager) return false;
        return this.#container.hidden === false;
    }
}
class $b3a01b20dd2ade98$var$FreeTextAnnotationElement extends $b3a01b20dd2ade98$var$AnnotationElement {
    constructor(parameters){
        super(parameters, {
            isRenderable: true,
            ignoreBorder: true
        });
        this.textContent = parameters.data.textContent;
        this.textPosition = parameters.data.textPosition;
        this.annotationEditorType = $b3a01b20dd2ade98$export$72ea3bfdd9a725bf.FREETEXT;
    }
    render() {
        this.container.classList.add("freeTextAnnotation");
        if (this.textContent) {
            const content = this.contentElement = document.createElement("div");
            content.classList.add("annotationTextContent");
            content.setAttribute("role", "comment");
            for (const line of this.textContent){
                const lineSpan = document.createElement("span");
                lineSpan.textContent = line;
                content.append(lineSpan);
            }
            this.container.append(content);
        }
        if (!this.data.popupRef && this.hasPopupData) {
            this.hasOwnCommentButton = true;
            this._createPopup();
        }
        this._editOnDoubleClick();
        return this.container;
    }
}
class $b3a01b20dd2ade98$var$LineAnnotationElement extends $b3a01b20dd2ade98$var$AnnotationElement {
    #line = null;
    constructor(parameters){
        super(parameters, {
            isRenderable: true,
            ignoreBorder: true
        });
    }
    render() {
        this.container.classList.add("lineAnnotation");
        const { data: data, width: width, height: height } = this;
        const svg = this.svgFactory.create(width, height, true);
        const line = this.#line = this.svgFactory.createElement("svg:line");
        line.setAttribute("x1", data.rect[2] - data.lineCoordinates[0]);
        line.setAttribute("y1", data.rect[3] - data.lineCoordinates[1]);
        line.setAttribute("x2", data.rect[2] - data.lineCoordinates[2]);
        line.setAttribute("y2", data.rect[3] - data.lineCoordinates[3]);
        line.setAttribute("stroke-width", data.borderStyle.width || 1);
        line.setAttribute("stroke", "transparent");
        line.setAttribute("fill", "transparent");
        svg.append(line);
        this.container.append(svg);
        if (!data.popupRef && this.hasPopupData) {
            this.hasOwnCommentButton = true;
            this._createPopup();
        }
        return this.container;
    }
    getElementsToTriggerPopup() {
        return this.#line;
    }
    addHighlightArea() {
        this.container.classList.add("highlightArea");
    }
}
class $b3a01b20dd2ade98$var$SquareAnnotationElement extends $b3a01b20dd2ade98$var$AnnotationElement {
    #square = null;
    constructor(parameters){
        super(parameters, {
            isRenderable: true,
            ignoreBorder: true
        });
    }
    render() {
        this.container.classList.add("squareAnnotation");
        const { data: data, width: width, height: height } = this;
        const svg = this.svgFactory.create(width, height, true);
        const borderWidth = data.borderStyle.width;
        const square = this.#square = this.svgFactory.createElement("svg:rect");
        square.setAttribute("x", borderWidth / 2);
        square.setAttribute("y", borderWidth / 2);
        square.setAttribute("width", width - borderWidth);
        square.setAttribute("height", height - borderWidth);
        square.setAttribute("stroke-width", borderWidth || 1);
        square.setAttribute("stroke", "transparent");
        square.setAttribute("fill", "transparent");
        svg.append(square);
        this.container.append(svg);
        if (!data.popupRef && this.hasPopupData) {
            this.hasOwnCommentButton = true;
            this._createPopup();
        }
        return this.container;
    }
    getElementsToTriggerPopup() {
        return this.#square;
    }
    addHighlightArea() {
        this.container.classList.add("highlightArea");
    }
}
class $b3a01b20dd2ade98$var$CircleAnnotationElement extends $b3a01b20dd2ade98$var$AnnotationElement {
    #circle = null;
    constructor(parameters){
        super(parameters, {
            isRenderable: true,
            ignoreBorder: true
        });
    }
    render() {
        this.container.classList.add("circleAnnotation");
        const { data: data, width: width, height: height } = this;
        const svg = this.svgFactory.create(width, height, true);
        const borderWidth = data.borderStyle.width;
        const circle = this.#circle = this.svgFactory.createElement("svg:ellipse");
        circle.setAttribute("cx", width / 2);
        circle.setAttribute("cy", height / 2);
        circle.setAttribute("rx", width / 2 - borderWidth / 2);
        circle.setAttribute("ry", height / 2 - borderWidth / 2);
        circle.setAttribute("stroke-width", borderWidth || 1);
        circle.setAttribute("stroke", "transparent");
        circle.setAttribute("fill", "transparent");
        svg.append(circle);
        this.container.append(svg);
        if (!data.popupRef && this.hasPopupData) {
            this.hasOwnCommentButton = true;
            this._createPopup();
        }
        return this.container;
    }
    getElementsToTriggerPopup() {
        return this.#circle;
    }
    addHighlightArea() {
        this.container.classList.add("highlightArea");
    }
}
class $b3a01b20dd2ade98$var$PolylineAnnotationElement extends $b3a01b20dd2ade98$var$AnnotationElement {
    #polyline = null;
    constructor(parameters){
        super(parameters, {
            isRenderable: true,
            ignoreBorder: true
        });
        this.containerClassName = "polylineAnnotation";
        this.svgElementName = "svg:polyline";
    }
    render() {
        this.container.classList.add(this.containerClassName);
        const { data: { rect: rect, vertices: vertices, borderStyle: borderStyle, popupRef: popupRef }, width: width, height: height } = this;
        if (!vertices) return this.container;
        const svg = this.svgFactory.create(width, height, true);
        let points = [];
        for(let i = 0, ii = vertices.length; i < ii; i += 2){
            const x = vertices[i] - rect[0];
            const y = rect[3] - vertices[i + 1];
            points.push(`${x},${y}`);
        }
        points = points.join(" ");
        const polyline = this.#polyline = this.svgFactory.createElement(this.svgElementName);
        polyline.setAttribute("points", points);
        polyline.setAttribute("stroke-width", borderStyle.width || 1);
        polyline.setAttribute("stroke", "transparent");
        polyline.setAttribute("fill", "transparent");
        svg.append(polyline);
        this.container.append(svg);
        if (!popupRef && this.hasPopupData) {
            this.hasOwnCommentButton = true;
            this._createPopup();
        }
        return this.container;
    }
    getElementsToTriggerPopup() {
        return this.#polyline;
    }
    addHighlightArea() {
        this.container.classList.add("highlightArea");
    }
}
class $b3a01b20dd2ade98$var$PolygonAnnotationElement extends $b3a01b20dd2ade98$var$PolylineAnnotationElement {
    constructor(parameters){
        super(parameters);
        this.containerClassName = "polygonAnnotation";
        this.svgElementName = "svg:polygon";
    }
}
class $b3a01b20dd2ade98$var$CaretAnnotationElement extends $b3a01b20dd2ade98$var$AnnotationElement {
    constructor(parameters){
        super(parameters, {
            isRenderable: true,
            ignoreBorder: true
        });
    }
    render() {
        this.container.classList.add("caretAnnotation");
        if (!this.data.popupRef && this.hasPopupData) {
            this.hasOwnCommentButton = true;
            this._createPopup();
        }
        return this.container;
    }
}
class $b3a01b20dd2ade98$var$InkAnnotationElement extends $b3a01b20dd2ade98$var$AnnotationElement {
    #polylinesGroupElement = null;
    #polylines = [];
    constructor(parameters){
        super(parameters, {
            isRenderable: true,
            ignoreBorder: true
        });
        this.containerClassName = "inkAnnotation";
        this.svgElementName = "svg:polyline";
        this.annotationEditorType = this.data.it === "InkHighlight" ? $b3a01b20dd2ade98$export$72ea3bfdd9a725bf.HIGHLIGHT : $b3a01b20dd2ade98$export$72ea3bfdd9a725bf.INK;
    }
    #getTransform(rotation, rect) {
        switch(rotation){
            case 90:
                return {
                    transform: `rotate(90) translate(${-rect[0]},${rect[1]}) scale(1,-1)`,
                    width: rect[3] - rect[1],
                    height: rect[2] - rect[0]
                };
            case 180:
                return {
                    transform: `rotate(180) translate(${-rect[2]},${rect[1]}) scale(1,-1)`,
                    width: rect[2] - rect[0],
                    height: rect[3] - rect[1]
                };
            case 270:
                return {
                    transform: `rotate(270) translate(${-rect[2]},${rect[3]}) scale(1,-1)`,
                    width: rect[3] - rect[1],
                    height: rect[2] - rect[0]
                };
            default:
                return {
                    transform: `translate(${-rect[0]},${rect[3]}) scale(1,-1)`,
                    width: rect[2] - rect[0],
                    height: rect[3] - rect[1]
                };
        }
    }
    render() {
        this.container.classList.add(this.containerClassName);
        const { data: { rect: rect, rotation: rotation, inkLists: inkLists, borderStyle: borderStyle, popupRef: popupRef } } = this;
        const { transform: transform, width: width, height: height } = this.#getTransform(rotation, rect);
        const svg = this.svgFactory.create(width, height, true);
        const g = this.#polylinesGroupElement = this.svgFactory.createElement("svg:g");
        svg.append(g);
        g.setAttribute("stroke-width", borderStyle.width || 1);
        g.setAttribute("stroke-linecap", "round");
        g.setAttribute("stroke-linejoin", "round");
        g.setAttribute("stroke-miterlimit", 10);
        g.setAttribute("stroke", "transparent");
        g.setAttribute("fill", "transparent");
        g.setAttribute("transform", transform);
        for(let i = 0, ii = inkLists.length; i < ii; i++){
            const polyline = this.svgFactory.createElement(this.svgElementName);
            this.#polylines.push(polyline);
            polyline.setAttribute("points", inkLists[i].join(","));
            g.append(polyline);
        }
        if (!popupRef && this.hasPopupData) {
            this.hasOwnCommentButton = true;
            this._createPopup();
        }
        this.container.append(svg);
        this._editOnDoubleClick();
        return this.container;
    }
    updateEdited(params) {
        super.updateEdited(params);
        const { thickness: thickness, points: points, rect: rect } = params;
        const g = this.#polylinesGroupElement;
        if (thickness >= 0) g.setAttribute("stroke-width", thickness || 1);
        if (points) for(let i = 0, ii = this.#polylines.length; i < ii; i++)this.#polylines[i].setAttribute("points", points[i].join(","));
        if (rect) {
            const { transform: transform, width: width, height: height } = this.#getTransform(this.data.rotation, rect);
            const root = g.parentElement;
            root.setAttribute("viewBox", `0 0 ${width} ${height}`);
            g.setAttribute("transform", transform);
        }
    }
    getElementsToTriggerPopup() {
        return this.#polylines;
    }
    addHighlightArea() {
        this.container.classList.add("highlightArea");
    }
}
class $b3a01b20dd2ade98$var$HighlightAnnotationElement extends $b3a01b20dd2ade98$var$AnnotationElement {
    constructor(parameters){
        super(parameters, {
            isRenderable: true,
            ignoreBorder: true,
            createQuadrilaterals: true
        });
        this.annotationEditorType = $b3a01b20dd2ade98$export$72ea3bfdd9a725bf.HIGHLIGHT;
    }
    render() {
        const { data: { overlaidText: overlaidText, popupRef: popupRef } } = this;
        if (!popupRef && this.hasPopupData) {
            this.hasOwnCommentButton = true;
            this._createPopup();
        }
        this.container.classList.add("highlightAnnotation");
        this._editOnDoubleClick();
        if (overlaidText) {
            const mark = document.createElement("mark");
            mark.classList.add("overlaidText");
            mark.textContent = overlaidText;
            this.container.append(mark);
        }
        return this.container;
    }
}
class $b3a01b20dd2ade98$var$UnderlineAnnotationElement extends $b3a01b20dd2ade98$var$AnnotationElement {
    constructor(parameters){
        super(parameters, {
            isRenderable: true,
            ignoreBorder: true,
            createQuadrilaterals: true
        });
    }
    render() {
        const { data: { overlaidText: overlaidText, popupRef: popupRef } } = this;
        if (!popupRef && this.hasPopupData) {
            this.hasOwnCommentButton = true;
            this._createPopup();
        }
        this.container.classList.add("underlineAnnotation");
        if (overlaidText) {
            const underline = document.createElement("u");
            underline.classList.add("overlaidText");
            underline.textContent = overlaidText;
            this.container.append(underline);
        }
        return this.container;
    }
}
class $b3a01b20dd2ade98$var$SquigglyAnnotationElement extends $b3a01b20dd2ade98$var$AnnotationElement {
    constructor(parameters){
        super(parameters, {
            isRenderable: true,
            ignoreBorder: true,
            createQuadrilaterals: true
        });
    }
    render() {
        const { data: { overlaidText: overlaidText, popupRef: popupRef } } = this;
        if (!popupRef && this.hasPopupData) {
            this.hasOwnCommentButton = true;
            this._createPopup();
        }
        this.container.classList.add("squigglyAnnotation");
        if (overlaidText) {
            const underline = document.createElement("u");
            underline.classList.add("overlaidText");
            underline.textContent = overlaidText;
            this.container.append(underline);
        }
        return this.container;
    }
}
class $b3a01b20dd2ade98$var$StrikeOutAnnotationElement extends $b3a01b20dd2ade98$var$AnnotationElement {
    constructor(parameters){
        super(parameters, {
            isRenderable: true,
            ignoreBorder: true,
            createQuadrilaterals: true
        });
    }
    render() {
        const { data: { overlaidText: overlaidText, popupRef: popupRef } } = this;
        if (!popupRef && this.hasPopupData) {
            this.hasOwnCommentButton = true;
            this._createPopup();
        }
        this.container.classList.add("strikeoutAnnotation");
        if (overlaidText) {
            const strikeout = document.createElement("s");
            strikeout.classList.add("overlaidText");
            strikeout.textContent = overlaidText;
            this.container.append(strikeout);
        }
        return this.container;
    }
}
class $b3a01b20dd2ade98$var$StampAnnotationElement extends $b3a01b20dd2ade98$var$AnnotationElement {
    constructor(parameters){
        super(parameters, {
            isRenderable: true,
            ignoreBorder: true
        });
        this.annotationEditorType = $b3a01b20dd2ade98$export$72ea3bfdd9a725bf.STAMP;
    }
    render() {
        this.container.classList.add("stampAnnotation");
        this.container.setAttribute("role", "img");
        if (!this.data.popupRef && this.hasPopupData) {
            this.hasOwnCommentButton = true;
            this._createPopup();
        }
        this._editOnDoubleClick();
        return this.container;
    }
}
class $b3a01b20dd2ade98$var$FileAttachmentAnnotationElement extends $b3a01b20dd2ade98$var$AnnotationElement {
    #trigger = null;
    constructor(parameters){
        super(parameters, {
            isRenderable: true
        });
        const { file: file } = this.data;
        this.filename = file.filename;
        this.content = file.content;
        this.linkService.eventBus?.dispatch("fileattachmentannotation", {
            source: this,
            ...file
        });
    }
    render() {
        this.container.classList.add("fileAttachmentAnnotation");
        const { container: container, data: data } = this;
        let trigger;
        if (data.hasAppearance || data.fillAlpha === 0) trigger = document.createElement("div");
        else {
            trigger = document.createElement("img");
            trigger.src = `${this.imageResourcesPath}annotation-${/paperclip/i.test(data.name) ? "paperclip" : "pushpin"}.svg`;
            if (data.fillAlpha && data.fillAlpha < 1) trigger.style = `filter: opacity(${Math.round(data.fillAlpha * 100)}%);`;
        }
        trigger.addEventListener("dblclick", this.#download.bind(this));
        this.#trigger = trigger;
        const { isMac: isMac } = $b3a01b20dd2ade98$export$5fb8891d35c36978.platform;
        container.addEventListener("keydown", (evt)=>{
            if (evt.key === "Enter" && (isMac ? evt.metaKey : evt.ctrlKey)) this.#download();
        });
        if (!data.popupRef && this.hasPopupData) {
            this.hasOwnCommentButton = true;
            this._createPopup();
        } else trigger.classList.add("popupTriggerArea");
        container.append(trigger);
        return container;
    }
    getElementsToTriggerPopup() {
        return this.#trigger;
    }
    addHighlightArea() {
        this.container.classList.add("highlightArea");
    }
    #download() {
        this.downloadManager?.openOrDownloadData(this.content, this.filename);
    }
}
class $b3a01b20dd2ade98$export$3e7f45c326d9366c {
    #accessibilityManager = null;
    #annotationCanvasMap = null;
    #annotationStorage = null;
    #editableAnnotations = new Map();
    #structTreeLayer = null;
    #linkService = null;
    #elements = [];
    #hasAriaAttributesFromStructTree = false;
    constructor({ div: div, accessibilityManager: accessibilityManager, annotationCanvasMap: annotationCanvasMap, annotationEditorUIManager: annotationEditorUIManager, page: page, viewport: viewport, structTreeLayer: structTreeLayer, commentManager: commentManager, linkService: linkService, annotationStorage: annotationStorage }){
        this.div = div;
        this.#accessibilityManager = accessibilityManager;
        this.#annotationCanvasMap = annotationCanvasMap;
        this.#structTreeLayer = structTreeLayer || null;
        this.#linkService = linkService || null;
        this.#annotationStorage = annotationStorage || new $b3a01b20dd2ade98$var$AnnotationStorage();
        this.page = page;
        this.viewport = viewport;
        this.zIndex = 0;
        this._annotationEditorUIManager = annotationEditorUIManager;
        this._commentManager = commentManager || null;
    }
    hasEditableAnnotations() {
        return this.#editableAnnotations.size > 0;
    }
    async render(params) {
        const { annotations: annotations } = params;
        const layer = this.div;
        $b3a01b20dd2ade98$export$af0a15a86e590226(layer, this.viewport);
        const popupToElements = new Map();
        const popupAnnotations = [];
        const elementParams = {
            data: null,
            layer: layer,
            linkService: this.#linkService,
            downloadManager: params.downloadManager,
            imageResourcesPath: params.imageResourcesPath || "",
            renderForms: params.renderForms !== false,
            svgFactory: new $b3a01b20dd2ade98$export$425e69f00724e63a(),
            annotationStorage: this.#annotationStorage,
            enableComment: params.enableComment === true,
            enableScripting: params.enableScripting === true,
            hasJSActions: params.hasJSActions,
            fieldObjects: params.fieldObjects,
            parent: this,
            elements: null
        };
        for (const data of annotations){
            if (data.noHTML) continue;
            const isPopupAnnotation = data.annotationType === $b3a01b20dd2ade98$export$f50c3066a53a6f2c.POPUP;
            if (!isPopupAnnotation) {
                if (data.rect[2] === data.rect[0] || data.rect[3] === data.rect[1]) continue;
            } else {
                const elements = popupToElements.get(data.id);
                if (!elements) continue;
                if (!this._commentManager) {
                    popupAnnotations.push(data);
                    continue;
                }
                elementParams.elements = elements;
            }
            elementParams.data = data;
            const element = $b3a01b20dd2ade98$var$AnnotationElementFactory.create(elementParams);
            if (!element.isRenderable) continue;
            if (!isPopupAnnotation) {
                this.#elements.push(element);
                if (data.popupRef) popupToElements.getOrInsertComputed(data.popupRef, $b3a01b20dd2ade98$export$be9af9a47496243a).push(element);
            }
            const rendered = element.render();
            if (data.hidden) rendered.style.visibility = "hidden";
            if (element._isEditable) {
                this.#editableAnnotations.set(element.data.id, element);
                this._annotationEditorUIManager?.renderAnnotationElement(element);
            }
        }
        await this.#addElementsToDOM();
        for (const data of popupAnnotations){
            const elements = elementParams.elements = popupToElements.get(data.id);
            elementParams.data = data;
            const element = $b3a01b20dd2ade98$var$AnnotationElementFactory.create(elementParams);
            if (!element.isRenderable) continue;
            const rendered = element.render();
            element.contentElement.id = `${$b3a01b20dd2ade98$var$AnnotationPrefix}${data.id}`;
            if (data.hidden) rendered.style.visibility = "hidden";
            elements.at(-1).container.after(rendered);
        }
        this.#setAnnotationCanvasMap();
    }
    async #addElementsToDOM() {
        if (this.#elements.length === 0) return;
        this.div.replaceChildren();
        const promises = [];
        if (!this.#hasAriaAttributesFromStructTree) {
            this.#hasAriaAttributesFromStructTree = true;
            for (const { contentElement: contentElement, data: { id: id } } of this.#elements){
                const annotationId = contentElement.id = `${$b3a01b20dd2ade98$var$AnnotationPrefix}${id}`;
                promises.push(this.#structTreeLayer?.getAriaAttributes(annotationId).then((ariaAttributes)=>{
                    if (ariaAttributes) for (const [key, value] of ariaAttributes)contentElement.setAttribute(key, value);
                }));
            }
        }
        this.#elements.sort(({ data: { rect: [a0, a1, a2, a3] } }, { data: { rect: [b0, b1, b2, b3] } })=>{
            if (a0 === a2 && a1 === a3) return 1;
            if (b0 === b2 && b1 === b3) return -1;
            const top1 = a3;
            const bot1 = a1;
            const mid1 = (a1 + a3) / 2;
            const top2 = b3;
            const bot2 = b1;
            const mid2 = (b1 + b3) / 2;
            if (mid1 >= top2 && mid2 <= bot1) return -1;
            if (mid2 >= top1 && mid1 <= bot2) return 1;
            const centerX1 = (a0 + a2) / 2;
            const centerX2 = (b0 + b2) / 2;
            return centerX1 - centerX2;
        });
        const fragment = document.createDocumentFragment();
        for (const element of this.#elements){
            fragment.append(element.container);
            if (this._commentManager) (element.extraPopupElement?.popup || element.popup)?.renderCommentButton();
            else if (element.extraPopupElement) fragment.append(element.extraPopupElement.render());
        }
        this.div.append(fragment);
        await Promise.all(promises);
        if (this.#accessibilityManager) for (const element of this.#elements)this.#accessibilityManager.addPointerInTextLayer(element.contentElement, false);
    }
    async addLinkAnnotations(annotations) {
        const elementParams = {
            data: null,
            layer: this.div,
            linkService: this.#linkService,
            svgFactory: new $b3a01b20dd2ade98$export$425e69f00724e63a(),
            parent: this
        };
        for (const data of annotations){
            data.borderStyle ||= $b3a01b20dd2ade98$export$3e7f45c326d9366c._defaultBorderStyle;
            elementParams.data = data;
            const element = $b3a01b20dd2ade98$var$AnnotationElementFactory.create(elementParams);
            if (!element.isRenderable) continue;
            element.render();
            element.contentElement.id = `${$b3a01b20dd2ade98$var$AnnotationPrefix}${data.id}`;
            this.#elements.push(element);
        }
        await this.#addElementsToDOM();
    }
    update({ viewport: viewport }) {
        const layer = this.div;
        this.viewport = viewport;
        $b3a01b20dd2ade98$export$af0a15a86e590226(layer, {
            rotation: viewport.rotation
        });
        this.#setAnnotationCanvasMap();
        layer.hidden = false;
    }
    #setAnnotationCanvasMap() {
        if (!this.#annotationCanvasMap) return;
        const layer = this.div;
        for (const [id, canvas] of this.#annotationCanvasMap){
            const element = layer.querySelector(`[data-annotation-id="${id}"]`);
            if (!element) continue;
            canvas.className = "annotationContent";
            const { firstChild: firstChild } = element;
            if (!firstChild) element.append(canvas);
            else if (firstChild.nodeName === "CANVAS") firstChild.replaceWith(canvas);
            else if (!firstChild.classList.contains("annotationContent")) firstChild.before(canvas);
            else firstChild.after(canvas);
            const editableAnnotation = this.#editableAnnotations.get(id);
            if (!editableAnnotation) continue;
            if (editableAnnotation._hasNoCanvas) {
                this._annotationEditorUIManager?.setMissingCanvas(id, element.id, canvas);
                editableAnnotation._hasNoCanvas = false;
            } else editableAnnotation.canvas = canvas;
        }
        this.#annotationCanvasMap.clear();
    }
    getEditableAnnotations() {
        return this.#editableAnnotations.values();
    }
    getEditableAnnotation(id) {
        return this.#editableAnnotations.get(id);
    }
    addFakeAnnotation(editor) {
        const { div: div } = this;
        const { id: id, rotation: rotation } = editor;
        const element = new $b3a01b20dd2ade98$var$EditorAnnotationElement({
            data: {
                id: id,
                rect: editor.getPDFRect(),
                rotation: rotation
            },
            editor: editor,
            layer: div,
            parent: this,
            enableComment: !!this._commentManager,
            linkService: this.#linkService,
            annotationStorage: this.#annotationStorage
        });
        element.render();
        element.contentElement.id = `${$b3a01b20dd2ade98$var$AnnotationPrefix}${id}`;
        element.createOrUpdatePopup();
        this.#elements.push(element);
        return element;
    }
    removeAnnotation(id) {
        const index = this.#elements.findIndex((el)=>el.data.id === id);
        if (index < 0) return;
        const [element] = this.#elements.splice(index, 1);
        this.#accessibilityManager?.removePointerInTextLayer(element.contentElement);
    }
    updateFakeAnnotations(editors) {
        if (editors.length === 0) return;
        for (const editor of editors)editor.updateFakeAnnotationElement(this);
        this.#addElementsToDOM();
    }
    togglePointerEvents(enabled = false) {
        this.div.classList.toggle("disabled", !enabled);
    }
    static get _defaultBorderStyle() {
        return $b3a01b20dd2ade98$export$b8972b998723d602(this, "_defaultBorderStyle", Object.freeze({
            width: 1,
            rawWidth: 1,
            style: $b3a01b20dd2ade98$var$AnnotationBorderStyleType.SOLID,
            dashArray: [
                3
            ],
            horizontalCornerRadius: 0,
            verticalCornerRadius: 0
        }));
    }
}
const $b3a01b20dd2ade98$var$EOL_PATTERN = /\r\n?|\n/g;
class $b3a01b20dd2ade98$var$FreeTextEditor extends $b3a01b20dd2ade98$var$AnnotationEditor {
    #content = "";
    #editorDivId = `${this.id}-editor`;
    #editModeAC = null;
    #fontSize;
    _colorPicker = null;
    static _freeTextDefaultContent = "";
    static _internalPadding = 0;
    static _defaultColor = null;
    static _defaultFontSize = 10;
    static get _keyboardManager() {
        const proto = $b3a01b20dd2ade98$var$FreeTextEditor.prototype;
        const arrowChecker = (self)=>self.isEmpty();
        const small = $b3a01b20dd2ade98$export$26cb16552a82cf63.TRANSLATE_SMALL;
        const big = $b3a01b20dd2ade98$export$26cb16552a82cf63.TRANSLATE_BIG;
        return $b3a01b20dd2ade98$export$b8972b998723d602(this, "_keyboardManager", new $b3a01b20dd2ade98$var$KeyboardManager([
            [
                [
                    "ctrl+s",
                    "mac+meta+s",
                    "ctrl+p",
                    "mac+meta+p"
                ],
                proto.commitOrRemove,
                {
                    bubbles: true
                }
            ],
            [
                [
                    "ctrl+Enter",
                    "mac+meta+Enter",
                    "Escape",
                    "mac+Escape"
                ],
                proto.commitOrRemove
            ],
            [
                [
                    "ArrowLeft",
                    "mac+ArrowLeft"
                ],
                proto._translateEmpty,
                {
                    args: [
                        -small,
                        0
                    ],
                    checker: arrowChecker
                }
            ],
            [
                [
                    "ctrl+ArrowLeft",
                    "mac+shift+ArrowLeft"
                ],
                proto._translateEmpty,
                {
                    args: [
                        -big,
                        0
                    ],
                    checker: arrowChecker
                }
            ],
            [
                [
                    "ArrowRight",
                    "mac+ArrowRight"
                ],
                proto._translateEmpty,
                {
                    args: [
                        small,
                        0
                    ],
                    checker: arrowChecker
                }
            ],
            [
                [
                    "ctrl+ArrowRight",
                    "mac+shift+ArrowRight"
                ],
                proto._translateEmpty,
                {
                    args: [
                        big,
                        0
                    ],
                    checker: arrowChecker
                }
            ],
            [
                [
                    "ArrowUp",
                    "mac+ArrowUp"
                ],
                proto._translateEmpty,
                {
                    args: [
                        0,
                        -small
                    ],
                    checker: arrowChecker
                }
            ],
            [
                [
                    "ctrl+ArrowUp",
                    "mac+shift+ArrowUp"
                ],
                proto._translateEmpty,
                {
                    args: [
                        0,
                        -big
                    ],
                    checker: arrowChecker
                }
            ],
            [
                [
                    "ArrowDown",
                    "mac+ArrowDown"
                ],
                proto._translateEmpty,
                {
                    args: [
                        0,
                        small
                    ],
                    checker: arrowChecker
                }
            ],
            [
                [
                    "ctrl+ArrowDown",
                    "mac+shift+ArrowDown"
                ],
                proto._translateEmpty,
                {
                    args: [
                        0,
                        big
                    ],
                    checker: arrowChecker
                }
            ]
        ]));
    }
    static _type = "freetext";
    static _editorType = $b3a01b20dd2ade98$export$72ea3bfdd9a725bf.FREETEXT;
    constructor(params){
        super({
            ...params,
            name: "freeTextEditor"
        });
        this.color = params.color || $b3a01b20dd2ade98$var$FreeTextEditor._defaultColor || $b3a01b20dd2ade98$var$AnnotationEditor._defaultLineColor;
        this.#fontSize = params.fontSize || $b3a01b20dd2ade98$var$FreeTextEditor._defaultFontSize;
        if (!this.annotationElementId) this._uiManager.a11yAlert("pdfjs-editor-freetext-added-alert");
        this.canAddComment = false;
    }
    static initialize(l10n, uiManager) {
        $b3a01b20dd2ade98$var$AnnotationEditor.initialize(l10n, uiManager);
        const style = getComputedStyle(document.documentElement);
        this._internalPadding = parseFloat(style.getPropertyValue("--freetext-padding"));
    }
    static updateDefaultParams(type, value) {
        switch(type){
            case $b3a01b20dd2ade98$export$cf3df2a6ecc26692.FREETEXT_SIZE:
                $b3a01b20dd2ade98$var$FreeTextEditor._defaultFontSize = value;
                break;
            case $b3a01b20dd2ade98$export$cf3df2a6ecc26692.FREETEXT_COLOR:
                $b3a01b20dd2ade98$var$FreeTextEditor._defaultColor = value;
                break;
        }
    }
    updateParams(type, value) {
        switch(type){
            case $b3a01b20dd2ade98$export$cf3df2a6ecc26692.FREETEXT_SIZE:
                this.#updateFontSize(value);
                break;
            case $b3a01b20dd2ade98$export$cf3df2a6ecc26692.FREETEXT_COLOR:
                this.#updateColor(value);
                break;
        }
    }
    static get defaultPropertiesToUpdate() {
        return [
            [
                $b3a01b20dd2ade98$export$cf3df2a6ecc26692.FREETEXT_SIZE,
                $b3a01b20dd2ade98$var$FreeTextEditor._defaultFontSize
            ],
            [
                $b3a01b20dd2ade98$export$cf3df2a6ecc26692.FREETEXT_COLOR,
                $b3a01b20dd2ade98$var$FreeTextEditor._defaultColor || $b3a01b20dd2ade98$var$AnnotationEditor._defaultLineColor
            ]
        ];
    }
    get propertiesToUpdate() {
        return [
            [
                $b3a01b20dd2ade98$export$cf3df2a6ecc26692.FREETEXT_SIZE,
                this.#fontSize
            ],
            [
                $b3a01b20dd2ade98$export$cf3df2a6ecc26692.FREETEXT_COLOR,
                this.color
            ]
        ];
    }
    get toolbarButtons() {
        this._colorPicker ||= new $b3a01b20dd2ade98$var$BasicColorPicker(this);
        return [
            [
                "colorPicker",
                this._colorPicker
            ]
        ];
    }
    get colorType() {
        return $b3a01b20dd2ade98$export$cf3df2a6ecc26692.FREETEXT_COLOR;
    }
    #updateFontSize(fontSize) {
        const setFontsize = (size)=>{
            this.editorDiv.style.fontSize = `calc(${size}px * var(--total-scale-factor))`;
            this.translate(0, -(size - this.#fontSize) * this.parentScale);
            this.#fontSize = size;
            this.#setEditorDimensions();
        };
        const savedFontsize = this.#fontSize;
        this.addCommands({
            cmd: setFontsize.bind(this, fontSize),
            undo: setFontsize.bind(this, savedFontsize),
            post: this._uiManager.updateUI.bind(this._uiManager, this),
            mustExec: true,
            type: $b3a01b20dd2ade98$export$cf3df2a6ecc26692.FREETEXT_SIZE,
            overwriteIfSameType: true,
            keepUndo: true
        });
    }
    onUpdatedColor() {
        this.editorDiv.style.color = this.color;
        this._colorPicker?.update(this.color);
        super.onUpdatedColor();
    }
    #updateColor(color) {
        const setColor = (col)=>{
            this.color = col;
            this.onUpdatedColor();
        };
        const savedColor = this.color;
        this.addCommands({
            cmd: setColor.bind(this, color),
            undo: setColor.bind(this, savedColor),
            post: this._uiManager.updateUI.bind(this._uiManager, this),
            mustExec: true,
            type: $b3a01b20dd2ade98$export$cf3df2a6ecc26692.FREETEXT_COLOR,
            overwriteIfSameType: true,
            keepUndo: true
        });
    }
    _translateEmpty(x, y) {
        this._uiManager.translateSelectedEditors(x, y, true);
    }
    getInitialTranslation() {
        const scale = this.parentScale;
        return [
            -$b3a01b20dd2ade98$var$FreeTextEditor._internalPadding * scale,
            -($b3a01b20dd2ade98$var$FreeTextEditor._internalPadding + this.#fontSize) * scale
        ];
    }
    rebuild() {
        if (!this.parent) return;
        super.rebuild();
        if (this.div === null) return;
        if (!this.isAttachedToDOM) this.parent.add(this);
    }
    enableEditMode() {
        if (!super.enableEditMode()) return false;
        this.overlayDiv.classList.remove("enabled");
        this.editorDiv.contentEditable = true;
        this._isDraggable = false;
        this.div.removeAttribute("aria-activedescendant");
        this.#editModeAC = new AbortController();
        const signal = this._uiManager.combinedSignal(this.#editModeAC);
        this.editorDiv.addEventListener("keydown", this.editorDivKeydown.bind(this), {
            signal: signal
        });
        this.editorDiv.addEventListener("focus", this.editorDivFocus.bind(this), {
            signal: signal
        });
        this.editorDiv.addEventListener("blur", this.editorDivBlur.bind(this), {
            signal: signal
        });
        this.editorDiv.addEventListener("input", this.editorDivInput.bind(this), {
            signal: signal
        });
        this.editorDiv.addEventListener("paste", this.editorDivPaste.bind(this), {
            signal: signal
        });
        return true;
    }
    disableEditMode() {
        if (!super.disableEditMode()) return false;
        this.overlayDiv.classList.add("enabled");
        this.editorDiv.contentEditable = false;
        this.div.setAttribute("aria-activedescendant", this.#editorDivId);
        this._isDraggable = true;
        this.#editModeAC?.abort();
        this.#editModeAC = null;
        this.div.focus({
            preventScroll: true
        });
        this.isEditing = false;
        this.parent.div.classList.add("freetextEditing");
        return true;
    }
    focusin(event) {
        if (!this._focusEventsAllowed) return;
        super.focusin(event);
        if (event.target !== this.editorDiv) this.editorDiv.focus();
    }
    onceAdded(focus) {
        if (this.width) return;
        this.enableEditMode();
        if (focus) this.editorDiv.focus();
        if (this._initialOptions?.isCentered) this.center();
        this._initialOptions = null;
    }
    isEmpty() {
        return !this.editorDiv || this.editorDiv.innerText.trim() === "";
    }
    remove() {
        this.isEditing = false;
        if (this.parent) {
            this.parent.setEditingState(true);
            this.parent.div.classList.add("freetextEditing");
        }
        super.remove();
    }
    #extractText() {
        const buffer = [];
        this.editorDiv.normalize();
        let prevChild = null;
        for (const child of this.editorDiv.childNodes){
            if (prevChild?.nodeType === Node.TEXT_NODE && child.nodeName === "BR") continue;
            buffer.push($b3a01b20dd2ade98$var$FreeTextEditor.#getNodeContent(child));
            prevChild = child;
        }
        return buffer.join("\n");
    }
    #setEditorDimensions() {
        const [parentWidth, parentHeight] = this.parentDimensions;
        let rect;
        if (this.isAttachedToDOM) rect = this.div.getBoundingClientRect();
        else {
            const { currentLayer: currentLayer, div: div } = this;
            const savedDisplay = div.style.display;
            const savedVisibility = div.classList.contains("hidden");
            div.classList.remove("hidden");
            div.style.display = "hidden";
            currentLayer.div.append(this.div);
            rect = div.getBoundingClientRect();
            div.remove();
            div.style.display = savedDisplay;
            div.classList.toggle("hidden", savedVisibility);
        }
        if (this.rotation % 180 === this.parentRotation % 180) {
            this.width = rect.width / parentWidth;
            this.height = rect.height / parentHeight;
        } else {
            this.width = rect.height / parentWidth;
            this.height = rect.width / parentHeight;
        }
        this.fixAndSetPosition();
    }
    commit() {
        if (!this.isInEditMode()) return;
        super.commit();
        this.disableEditMode();
        const savedText = this.#content;
        const newText = this.#content = this.#extractText().trimEnd();
        if (savedText === newText) return;
        const setText = (text)=>{
            this.#content = text;
            if (!text) {
                this.remove();
                return;
            }
            this.#setContent();
            this._uiManager.rebuild(this);
            this.#setEditorDimensions();
        };
        this.addCommands({
            cmd: ()=>{
                setText(newText);
            },
            undo: ()=>{
                setText(savedText);
            },
            mustExec: false
        });
        this.#setEditorDimensions();
    }
    shouldGetKeyboardEvents() {
        return this.isInEditMode();
    }
    enterInEditMode() {
        this.enableEditMode();
        this.editorDiv.focus();
    }
    keydown(event) {
        if (event.target === this.div && event.key === "Enter") {
            this.enterInEditMode();
            event.preventDefault();
        }
    }
    editorDivKeydown(event) {
        $b3a01b20dd2ade98$var$FreeTextEditor._keyboardManager.exec(this, event);
    }
    editorDivFocus(event) {
        this.isEditing = true;
    }
    editorDivBlur(event) {
        this.isEditing = false;
    }
    editorDivInput(event) {
        this.parent.div.classList.toggle("freetextEditing", this.isEmpty());
    }
    disableEditing() {
        this.editorDiv.setAttribute("role", "comment");
        this.editorDiv.removeAttribute("aria-multiline");
    }
    enableEditing() {
        this.editorDiv.setAttribute("role", "textbox");
        this.editorDiv.setAttribute("aria-multiline", true);
    }
    get canChangeContent() {
        return true;
    }
    render() {
        if (this.div) return this.div;
        let baseX, baseY;
        if (this._isCopy || this.annotationElementId) {
            baseX = this.x;
            baseY = this.y;
        }
        super.render();
        this.editorDiv = document.createElement("div");
        this.editorDiv.className = "internal";
        this.editorDiv.setAttribute("id", this.#editorDivId);
        this.editorDiv.setAttribute("data-l10n-id", "pdfjs-free-text2");
        this.editorDiv.setAttribute("data-l10n-attrs", "default-content");
        this.enableEditing();
        this.editorDiv.contentEditable = true;
        const { style: style } = this.editorDiv;
        style.fontSize = `calc(${this.#fontSize}px * var(--total-scale-factor))`;
        style.color = this.color;
        this.div.append(this.editorDiv);
        this.overlayDiv = document.createElement("div");
        this.overlayDiv.classList.add("overlay", "enabled");
        this.div.append(this.overlayDiv);
        if (this._isCopy || this.annotationElementId) {
            const [parentWidth, parentHeight] = this.parentDimensions;
            if (this.annotationElementId) {
                const { position: position } = this._initialData;
                let [tx, ty] = this.getInitialTranslation();
                [tx, ty] = this.pageTranslationToScreen(tx, ty);
                const [pageWidth, pageHeight] = this.pageDimensions;
                const [pageX, pageY] = this.pageTranslation;
                let posX, posY;
                switch(this.rotation){
                    case 0:
                        posX = baseX + (position[0] - pageX) / pageWidth;
                        posY = baseY + this.height - (position[1] - pageY) / pageHeight;
                        break;
                    case 90:
                        posX = baseX + (position[0] - pageX) / pageWidth;
                        posY = baseY - (position[1] - pageY) / pageHeight;
                        [tx, ty] = [
                            ty,
                            -tx
                        ];
                        break;
                    case 180:
                        posX = baseX - this.width + (position[0] - pageX) / pageWidth;
                        posY = baseY - (position[1] - pageY) / pageHeight;
                        [tx, ty] = [
                            -tx,
                            -ty
                        ];
                        break;
                    case 270:
                        posX = baseX + (position[0] - pageX - this.height * pageHeight) / pageWidth;
                        posY = baseY + (position[1] - pageY - this.width * pageWidth) / pageHeight;
                        [tx, ty] = [
                            -ty,
                            tx
                        ];
                        break;
                }
                this.setAt(posX * parentWidth, posY * parentHeight, tx, ty);
            } else this._moveAfterPaste(baseX, baseY);
            this.#setContent();
            this._isDraggable = true;
            this.editorDiv.contentEditable = false;
        } else {
            this._isDraggable = false;
            this.editorDiv.contentEditable = true;
        }
        return this.div;
    }
    static #getNodeContent(node) {
        return (node.nodeType === Node.TEXT_NODE ? node.nodeValue : node.innerText).replaceAll($b3a01b20dd2ade98$var$EOL_PATTERN, "");
    }
    editorDivPaste(event) {
        const clipboardData = event.clipboardData || window.clipboardData;
        const { types: types } = clipboardData;
        if (types.length === 1 && types[0] === "text/plain") return;
        event.preventDefault();
        const paste = $b3a01b20dd2ade98$var$FreeTextEditor.#deserializeContent(clipboardData.getData("text") || "").replaceAll($b3a01b20dd2ade98$var$EOL_PATTERN, "\n");
        if (!paste) return;
        const selection = window.getSelection();
        if (!selection.rangeCount) return;
        this.editorDiv.normalize();
        selection.deleteFromDocument();
        const range = selection.getRangeAt(0);
        if (!paste.includes("\n")) {
            range.insertNode(document.createTextNode(paste));
            this.editorDiv.normalize();
            selection.collapseToStart();
            return;
        }
        const { startContainer: startContainer, startOffset: startOffset } = range;
        const bufferBefore = [];
        const bufferAfter = [];
        if (startContainer.nodeType === Node.TEXT_NODE) {
            const parent = startContainer.parentElement;
            bufferAfter.push(startContainer.nodeValue.slice(startOffset).replaceAll($b3a01b20dd2ade98$var$EOL_PATTERN, ""));
            if (parent !== this.editorDiv) {
                let buffer = bufferBefore;
                for (const child of this.editorDiv.childNodes){
                    if (child === parent) {
                        buffer = bufferAfter;
                        continue;
                    }
                    buffer.push($b3a01b20dd2ade98$var$FreeTextEditor.#getNodeContent(child));
                }
            }
            bufferBefore.push(startContainer.nodeValue.slice(0, startOffset).replaceAll($b3a01b20dd2ade98$var$EOL_PATTERN, ""));
        } else if (startContainer === this.editorDiv) {
            let buffer = bufferBefore;
            let i = 0;
            for (const child of this.editorDiv.childNodes){
                if (i++ === startOffset) buffer = bufferAfter;
                buffer.push($b3a01b20dd2ade98$var$FreeTextEditor.#getNodeContent(child));
            }
        }
        this.#content = `${bufferBefore.join("\n")}${paste}${bufferAfter.join("\n")}`;
        this.#setContent();
        const newRange = new Range();
        let beforeLength = Math.sumPrecise(bufferBefore.map((line)=>line.length));
        for (const { firstChild: firstChild } of this.editorDiv.childNodes)if (firstChild.nodeType === Node.TEXT_NODE) {
            const length = firstChild.nodeValue.length;
            if (beforeLength <= length) {
                newRange.setStart(firstChild, beforeLength);
                newRange.setEnd(firstChild, beforeLength);
                break;
            }
            beforeLength -= length;
        }
        selection.removeAllRanges();
        selection.addRange(newRange);
    }
    #setContent() {
        this.editorDiv.replaceChildren();
        if (!this.#content) return;
        for (const line of this.#content.split("\n")){
            const div = document.createElement("div");
            div.append(line ? document.createTextNode(line) : document.createElement("br"));
            this.editorDiv.append(div);
        }
    }
    #serializeContent() {
        return this.#content.replaceAll("\xa0", " ");
    }
    static #deserializeContent(content) {
        return content.replaceAll(" ", "\xa0");
    }
    get contentDiv() {
        return this.editorDiv;
    }
    getPDFRect() {
        const padding = $b3a01b20dd2ade98$var$FreeTextEditor._internalPadding * this.parentScale;
        return this.getRect(padding, padding);
    }
    static async deserialize(data, parent, uiManager) {
        let initialData = null;
        if (data instanceof $b3a01b20dd2ade98$var$FreeTextAnnotationElement) {
            const { data: { defaultAppearanceData: { fontSize: fontSize, fontColor: fontColor }, rect: rect, rotation: rotation, id: id, popupRef: popupRef, richText: richText, contentsObj: contentsObj, creationDate: creationDate, modificationDate: modificationDate }, textContent: textContent, textPosition: textPosition, parent: { page: { pageNumber: pageNumber } } } = data;
            if (!textContent || textContent.length === 0) return null;
            initialData = data = {
                annotationType: $b3a01b20dd2ade98$export$72ea3bfdd9a725bf.FREETEXT,
                color: Array.from(fontColor),
                fontSize: fontSize,
                value: textContent.join("\n"),
                position: textPosition,
                pageIndex: pageNumber - 1,
                rect: rect.slice(0),
                rotation: rotation,
                annotationElementId: id,
                id: id,
                deleted: false,
                popupRef: popupRef,
                comment: contentsObj?.str || null,
                richText: richText,
                creationDate: creationDate,
                modificationDate: modificationDate
            };
        }
        const editor = await super.deserialize(data, parent, uiManager);
        editor.#fontSize = data.fontSize;
        editor.color = $b3a01b20dd2ade98$export$f8f26dd395d7e1bd.makeHexColor(...data.color);
        editor.#content = $b3a01b20dd2ade98$var$FreeTextEditor.#deserializeContent(data.value);
        editor._initialData = initialData;
        if (data.comment) editor.setCommentData(data);
        return editor;
    }
    serialize(isForCopying = false) {
        if (this.isEmpty()) return null;
        if (this.deleted) return this.serializeDeleted();
        const color = $b3a01b20dd2ade98$var$AnnotationEditor._colorManager.convert(this.isAttachedToDOM ? getComputedStyle(this.editorDiv).color : this.color);
        const serialized = Object.assign(super.serialize(isForCopying), {
            color: color,
            fontSize: this.#fontSize,
            value: this.#serializeContent()
        });
        this.addComment(serialized);
        if (isForCopying) {
            serialized.isCopy = true;
            return serialized;
        }
        if (this.annotationElementId && !this.#hasElementChanged(serialized)) return null;
        serialized.id = this.annotationElementId;
        return serialized;
    }
    #hasElementChanged(serialized) {
        const { value: value, fontSize: fontSize, color: color, pageIndex: pageIndex } = this._initialData;
        return this.hasEditedComment || this._hasBeenMoved || serialized.value !== value || serialized.fontSize !== fontSize || serialized.color.some((c, i)=>c !== color[i]) || serialized.pageIndex !== pageIndex;
    }
    renderAnnotationElement(annotation) {
        const content = super.renderAnnotationElement(annotation);
        if (!content) return null;
        const { style: style } = content;
        style.fontSize = `calc(${this.#fontSize}px * var(--total-scale-factor))`;
        style.color = this.color;
        content.replaceChildren();
        for (const line of this.#content.split("\n")){
            const div = document.createElement("div");
            div.append(line ? document.createTextNode(line) : document.createElement("br"));
            content.append(div);
        }
        annotation.updateEdited({
            rect: this.getPDFRect(),
            popup: this._uiManager.hasCommentManager() || this.hasEditedComment ? this.comment : {
                text: this.#content
            }
        });
        return content;
    }
    resetAnnotationElement(annotation) {
        super.resetAnnotationElement(annotation);
        annotation.resetEdited();
    }
}
class $b3a01b20dd2ade98$var$Outline {
    static PRECISION = 1e-4;
    toSVGPath() {
        $b3a01b20dd2ade98$var$unreachable("Abstract method `toSVGPath` must be implemented.");
    }
    get box() {
        $b3a01b20dd2ade98$var$unreachable("Abstract getter `box` must be implemented.");
    }
    serialize(_bbox, _rotation) {
        $b3a01b20dd2ade98$var$unreachable("Abstract method `serialize` must be implemented.");
    }
    static _rescale(src, tx, ty, sx, sy, dest) {
        dest ||= new Float32Array(src.length);
        for(let i = 0, ii = src.length; i < ii; i += 2){
            dest[i] = tx + src[i] * sx;
            dest[i + 1] = ty + src[i + 1] * sy;
        }
        return dest;
    }
    static _rescaleAndSwap(src, tx, ty, sx, sy, dest) {
        dest ||= new Float32Array(src.length);
        for(let i = 0, ii = src.length; i < ii; i += 2){
            dest[i] = tx + src[i + 1] * sx;
            dest[i + 1] = ty + src[i] * sy;
        }
        return dest;
    }
    static _translate(src, tx, ty, dest) {
        dest ||= new Float32Array(src.length);
        for(let i = 0, ii = src.length; i < ii; i += 2){
            dest[i] = tx + src[i];
            dest[i + 1] = ty + src[i + 1];
        }
        return dest;
    }
    static svgRound(x) {
        return Math.round(x * 10000);
    }
    static _normalizePoint(x, y, parentWidth, parentHeight, rotation) {
        switch(rotation){
            case 90:
                return [
                    1 - y / parentWidth,
                    x / parentHeight
                ];
            case 180:
                return [
                    1 - x / parentWidth,
                    1 - y / parentHeight
                ];
            case 270:
                return [
                    y / parentWidth,
                    1 - x / parentHeight
                ];
            default:
                return [
                    x / parentWidth,
                    y / parentHeight
                ];
        }
    }
    static _normalizePagePoint(x, y, rotation) {
        switch(rotation){
            case 90:
                return [
                    1 - y,
                    x
                ];
            case 180:
                return [
                    1 - x,
                    1 - y
                ];
            case 270:
                return [
                    y,
                    1 - x
                ];
            default:
                return [
                    x,
                    y
                ];
        }
    }
    static createBezierPoints(x1, y1, x2, y2, x3, y3) {
        return [
            (x1 + 5 * x2) / 6,
            (y1 + 5 * y2) / 6,
            (5 * x2 + x3) / 6,
            (5 * y2 + y3) / 6,
            (x2 + x3) / 2,
            (y2 + y3) / 2
        ];
    }
}
class $b3a01b20dd2ade98$var$FreeDrawOutliner {
    #box;
    #bottom = [];
    #innerMargin;
    #isLTR;
    #top = [];
    #last = new Float32Array(18);
    #lastX;
    #lastY;
    #min;
    #min_dist;
    #scaleFactor;
    #thickness;
    #points = [];
    static #MIN_DIST = 8;
    static #MIN_DIFF = 2;
    static #MIN = $b3a01b20dd2ade98$var$FreeDrawOutliner.#MIN_DIST + $b3a01b20dd2ade98$var$FreeDrawOutliner.#MIN_DIFF;
    constructor({ x: x, y: y }, box, scaleFactor, thickness, isLTR, innerMargin = 0){
        this.#box = box;
        this.#thickness = thickness * scaleFactor;
        this.#isLTR = isLTR;
        this.#last.set([
            NaN,
            NaN,
            NaN,
            NaN,
            x,
            y
        ], 6);
        this.#innerMargin = innerMargin;
        this.#min_dist = $b3a01b20dd2ade98$var$FreeDrawOutliner.#MIN_DIST * scaleFactor;
        this.#min = $b3a01b20dd2ade98$var$FreeDrawOutliner.#MIN * scaleFactor;
        this.#scaleFactor = scaleFactor;
        this.#points.push(x, y);
    }
    isEmpty() {
        return isNaN(this.#last[8]);
    }
    #getLastCoords() {
        const lastTop = this.#last.subarray(4, 6);
        const lastBottom = this.#last.subarray(16, 18);
        const [x, y, width, height] = this.#box;
        return [
            (this.#lastX + (lastTop[0] - lastBottom[0]) / 2 - x) / width,
            (this.#lastY + (lastTop[1] - lastBottom[1]) / 2 - y) / height,
            (this.#lastX + (lastBottom[0] - lastTop[0]) / 2 - x) / width,
            (this.#lastY + (lastBottom[1] - lastTop[1]) / 2 - y) / height
        ];
    }
    add({ x: x, y: y }) {
        this.#lastX = x;
        this.#lastY = y;
        const [layerX, layerY, layerWidth, layerHeight] = this.#box;
        let [x1, y1, x2, y2] = this.#last.subarray(8, 12);
        const diffX = x - x2;
        const diffY = y - y2;
        const d = Math.hypot(diffX, diffY);
        if (d < this.#min) return false;
        const diffD = d - this.#min_dist;
        const K = diffD / d;
        const shiftX = K * diffX;
        const shiftY = K * diffY;
        let x0 = x1;
        let y0 = y1;
        x1 = x2;
        y1 = y2;
        x2 += shiftX;
        y2 += shiftY;
        this.#points?.push(x, y);
        const nX = -shiftY / diffD;
        const nY = shiftX / diffD;
        const thX = nX * this.#thickness;
        const thY = nY * this.#thickness;
        this.#last.set(this.#last.subarray(2, 8), 0);
        this.#last.set([
            x2 + thX,
            y2 + thY
        ], 4);
        this.#last.set(this.#last.subarray(14, 18), 12);
        this.#last.set([
            x2 - thX,
            y2 - thY
        ], 16);
        if (isNaN(this.#last[6])) {
            if (this.#top.length === 0) {
                this.#last.set([
                    x1 + thX,
                    y1 + thY
                ], 2);
                this.#top.push(NaN, NaN, NaN, NaN, (x1 + thX - layerX) / layerWidth, (y1 + thY - layerY) / layerHeight);
                this.#last.set([
                    x1 - thX,
                    y1 - thY
                ], 14);
                this.#bottom.push(NaN, NaN, NaN, NaN, (x1 - thX - layerX) / layerWidth, (y1 - thY - layerY) / layerHeight);
            }
            this.#last.set([
                x0,
                y0,
                x1,
                y1,
                x2,
                y2
            ], 6);
            return !this.isEmpty();
        }
        this.#last.set([
            x0,
            y0,
            x1,
            y1,
            x2,
            y2
        ], 6);
        const angle = Math.abs(Math.atan2(y0 - y1, x0 - x1) - Math.atan2(shiftY, shiftX));
        if (angle < Math.PI / 2) {
            [x1, y1, x2, y2] = this.#last.subarray(2, 6);
            this.#top.push(NaN, NaN, NaN, NaN, ((x1 + x2) / 2 - layerX) / layerWidth, ((y1 + y2) / 2 - layerY) / layerHeight);
            [x1, y1, x0, y0] = this.#last.subarray(14, 18);
            this.#bottom.push(NaN, NaN, NaN, NaN, ((x0 + x1) / 2 - layerX) / layerWidth, ((y0 + y1) / 2 - layerY) / layerHeight);
            return true;
        }
        [x0, y0, x1, y1, x2, y2] = this.#last.subarray(0, 6);
        this.#top.push(((x0 + 5 * x1) / 6 - layerX) / layerWidth, ((y0 + 5 * y1) / 6 - layerY) / layerHeight, ((5 * x1 + x2) / 6 - layerX) / layerWidth, ((5 * y1 + y2) / 6 - layerY) / layerHeight, ((x1 + x2) / 2 - layerX) / layerWidth, ((y1 + y2) / 2 - layerY) / layerHeight);
        [x2, y2, x1, y1, x0, y0] = this.#last.subarray(12, 18);
        this.#bottom.push(((x0 + 5 * x1) / 6 - layerX) / layerWidth, ((y0 + 5 * y1) / 6 - layerY) / layerHeight, ((5 * x1 + x2) / 6 - layerX) / layerWidth, ((5 * y1 + y2) / 6 - layerY) / layerHeight, ((x1 + x2) / 2 - layerX) / layerWidth, ((y1 + y2) / 2 - layerY) / layerHeight);
        return true;
    }
    toSVGPath() {
        if (this.isEmpty()) return "";
        const top = this.#top;
        const bottom = this.#bottom;
        if (isNaN(this.#last[6]) && !this.isEmpty()) return this.#toSVGPathTwoPoints();
        const buffer = [];
        buffer.push(`M${top[4]} ${top[5]}`);
        for(let i = 6; i < top.length; i += 6)if (isNaN(top[i])) buffer.push(`L${top[i + 4]} ${top[i + 5]}`);
        else buffer.push(`C${top[i]} ${top[i + 1]} ${top[i + 2]} ${top[i + 3]} ${top[i + 4]} ${top[i + 5]}`);
        this.#toSVGPathEnd(buffer);
        for(let i = bottom.length - 6; i >= 6; i -= 6)if (isNaN(bottom[i])) buffer.push(`L${bottom[i + 4]} ${bottom[i + 5]}`);
        else buffer.push(`C${bottom[i]} ${bottom[i + 1]} ${bottom[i + 2]} ${bottom[i + 3]} ${bottom[i + 4]} ${bottom[i + 5]}`);
        this.#toSVGPathStart(buffer);
        return buffer.join(" ");
    }
    #toSVGPathTwoPoints() {
        const [x, y, width, height] = this.#box;
        const [lastTopX, lastTopY, lastBottomX, lastBottomY] = this.#getLastCoords();
        return `M${(this.#last[2] - x) / width} ${(this.#last[3] - y) / height} L${(this.#last[4] - x) / width} ${(this.#last[5] - y) / height} L${lastTopX} ${lastTopY} L${lastBottomX} ${lastBottomY} L${(this.#last[16] - x) / width} ${(this.#last[17] - y) / height} L${(this.#last[14] - x) / width} ${(this.#last[15] - y) / height} Z`;
    }
    #toSVGPathStart(buffer) {
        const bottom = this.#bottom;
        buffer.push(`L${bottom[4]} ${bottom[5]} Z`);
    }
    #toSVGPathEnd(buffer) {
        const [x, y, width, height] = this.#box;
        const lastTop = this.#last.subarray(4, 6);
        const lastBottom = this.#last.subarray(16, 18);
        const [lastTopX, lastTopY, lastBottomX, lastBottomY] = this.#getLastCoords();
        buffer.push(`L${(lastTop[0] - x) / width} ${(lastTop[1] - y) / height} L${lastTopX} ${lastTopY} L${lastBottomX} ${lastBottomY} L${(lastBottom[0] - x) / width} ${(lastBottom[1] - y) / height}`);
    }
    newFreeDrawOutline(outline, points, box, scaleFactor, innerMargin, isLTR) {
        return new $b3a01b20dd2ade98$var$FreeDrawOutline(outline, points, box, scaleFactor, innerMargin, isLTR);
    }
    getOutlines() {
        const top = this.#top;
        const bottom = this.#bottom;
        const last = this.#last;
        const [layerX, layerY, layerWidth, layerHeight] = this.#box;
        const points = new Float32Array((this.#points?.length ?? 0) + 2);
        for(let i = 0, ii = points.length - 2; i < ii; i += 2){
            points[i] = (this.#points[i] - layerX) / layerWidth;
            points[i + 1] = (this.#points[i + 1] - layerY) / layerHeight;
        }
        points[points.length - 2] = (this.#lastX - layerX) / layerWidth;
        points[points.length - 1] = (this.#lastY - layerY) / layerHeight;
        if (isNaN(last[6]) && !this.isEmpty()) return this.#getOutlineTwoPoints(points);
        const outline = new Float32Array(this.#top.length + 24 + this.#bottom.length);
        let N = top.length;
        for(let i = 0; i < N; i += 2){
            if (isNaN(top[i])) {
                outline[i] = outline[i + 1] = NaN;
                continue;
            }
            outline[i] = top[i];
            outline[i + 1] = top[i + 1];
        }
        N = this.#getOutlineEnd(outline, N);
        for(let i = bottom.length - 6; i >= 6; i -= 6)for(let j = 0; j < 6; j += 2){
            if (isNaN(bottom[i + j])) {
                outline[N] = outline[N + 1] = NaN;
                N += 2;
                continue;
            }
            outline[N] = bottom[i + j];
            outline[N + 1] = bottom[i + j + 1];
            N += 2;
        }
        this.#getOutlineStart(outline, N);
        return this.newFreeDrawOutline(outline, points, this.#box, this.#scaleFactor, this.#innerMargin, this.#isLTR);
    }
    #getOutlineTwoPoints(points) {
        const last = this.#last;
        const [layerX, layerY, layerWidth, layerHeight] = this.#box;
        const [lastTopX, lastTopY, lastBottomX, lastBottomY] = this.#getLastCoords();
        const outline = new Float32Array(36);
        outline.set([
            NaN,
            NaN,
            NaN,
            NaN,
            (last[2] - layerX) / layerWidth,
            (last[3] - layerY) / layerHeight,
            NaN,
            NaN,
            NaN,
            NaN,
            (last[4] - layerX) / layerWidth,
            (last[5] - layerY) / layerHeight,
            NaN,
            NaN,
            NaN,
            NaN,
            lastTopX,
            lastTopY,
            NaN,
            NaN,
            NaN,
            NaN,
            lastBottomX,
            lastBottomY,
            NaN,
            NaN,
            NaN,
            NaN,
            (last[16] - layerX) / layerWidth,
            (last[17] - layerY) / layerHeight,
            NaN,
            NaN,
            NaN,
            NaN,
            (last[14] - layerX) / layerWidth,
            (last[15] - layerY) / layerHeight
        ], 0);
        return this.newFreeDrawOutline(outline, points, this.#box, this.#scaleFactor, this.#innerMargin, this.#isLTR);
    }
    #getOutlineStart(outline, pos) {
        const bottom = this.#bottom;
        outline.set([
            NaN,
            NaN,
            NaN,
            NaN,
            bottom[4],
            bottom[5]
        ], pos);
        return pos += 6;
    }
    #getOutlineEnd(outline, pos) {
        const lastTop = this.#last.subarray(4, 6);
        const lastBottom = this.#last.subarray(16, 18);
        const [layerX, layerY, layerWidth, layerHeight] = this.#box;
        const [lastTopX, lastTopY, lastBottomX, lastBottomY] = this.#getLastCoords();
        outline.set([
            NaN,
            NaN,
            NaN,
            NaN,
            (lastTop[0] - layerX) / layerWidth,
            (lastTop[1] - layerY) / layerHeight,
            NaN,
            NaN,
            NaN,
            NaN,
            lastTopX,
            lastTopY,
            NaN,
            NaN,
            NaN,
            NaN,
            lastBottomX,
            lastBottomY,
            NaN,
            NaN,
            NaN,
            NaN,
            (lastBottom[0] - layerX) / layerWidth,
            (lastBottom[1] - layerY) / layerHeight
        ], pos);
        return pos += 24;
    }
}
class $b3a01b20dd2ade98$var$FreeDrawOutline extends $b3a01b20dd2ade98$var$Outline {
    #box;
    #bbox = new Float32Array(4);
    #innerMargin;
    #isLTR;
    #points;
    #scaleFactor;
    #outline;
    constructor(outline, points, box, scaleFactor, innerMargin, isLTR){
        super();
        this.#outline = outline;
        this.#points = points;
        this.#box = box;
        this.#scaleFactor = scaleFactor;
        this.#innerMargin = innerMargin;
        this.#isLTR = isLTR;
        this.firstPoint = [
            NaN,
            NaN
        ];
        this.lastPoint = [
            NaN,
            NaN
        ];
        this.#computeMinMax(isLTR);
        const [x, y, width, height] = this.#bbox;
        for(let i = 0, ii = outline.length; i < ii; i += 2){
            outline[i] = (outline[i] - x) / width;
            outline[i + 1] = (outline[i + 1] - y) / height;
        }
        for(let i = 0, ii = points.length; i < ii; i += 2){
            points[i] = (points[i] - x) / width;
            points[i + 1] = (points[i + 1] - y) / height;
        }
    }
    toSVGPath() {
        const buffer = [
            `M${this.#outline[4]} ${this.#outline[5]}`
        ];
        for(let i = 6, ii = this.#outline.length; i < ii; i += 6){
            if (isNaN(this.#outline[i])) {
                buffer.push(`L${this.#outline[i + 4]} ${this.#outline[i + 5]}`);
                continue;
            }
            buffer.push(`C${this.#outline[i]} ${this.#outline[i + 1]} ${this.#outline[i + 2]} ${this.#outline[i + 3]} ${this.#outline[i + 4]} ${this.#outline[i + 5]}`);
        }
        buffer.push("Z");
        return buffer.join(" ");
    }
    serialize([blX, blY, trX, trY], rotation) {
        const width = trX - blX;
        const height = trY - blY;
        let outline;
        let points;
        switch(rotation){
            case 0:
                outline = $b3a01b20dd2ade98$var$Outline._rescale(this.#outline, blX, trY, width, -height);
                points = $b3a01b20dd2ade98$var$Outline._rescale(this.#points, blX, trY, width, -height);
                break;
            case 90:
                outline = $b3a01b20dd2ade98$var$Outline._rescaleAndSwap(this.#outline, blX, blY, width, height);
                points = $b3a01b20dd2ade98$var$Outline._rescaleAndSwap(this.#points, blX, blY, width, height);
                break;
            case 180:
                outline = $b3a01b20dd2ade98$var$Outline._rescale(this.#outline, trX, blY, -width, height);
                points = $b3a01b20dd2ade98$var$Outline._rescale(this.#points, trX, blY, -width, height);
                break;
            case 270:
                outline = $b3a01b20dd2ade98$var$Outline._rescaleAndSwap(this.#outline, trX, trY, -width, -height);
                points = $b3a01b20dd2ade98$var$Outline._rescaleAndSwap(this.#points, trX, trY, -width, -height);
                break;
        }
        return {
            outline: Array.from(outline),
            points: [
                Array.from(points)
            ]
        };
    }
    #computeMinMax(isLTR) {
        const outline = this.#outline;
        let lastX = outline[4];
        let lastY = outline[5];
        const minMax = [
            lastX,
            lastY,
            lastX,
            lastY
        ];
        let firstPointX = lastX;
        let firstPointY = lastY;
        let lastPointX = lastX;
        let lastPointY = lastY;
        const ltrCallback = isLTR ? Math.max : Math.min;
        const bezierBbox = new Float32Array(4);
        for(let i = 6, ii = outline.length; i < ii; i += 6){
            const x = outline[i + 4], y = outline[i + 5];
            if (isNaN(outline[i])) {
                $b3a01b20dd2ade98$export$f8f26dd395d7e1bd.pointBoundingBox(x, y, minMax);
                if (firstPointY > y) {
                    firstPointX = x;
                    firstPointY = y;
                } else if (firstPointY === y) firstPointX = ltrCallback(firstPointX, x);
                if (lastPointY < y) {
                    lastPointX = x;
                    lastPointY = y;
                } else if (lastPointY === y) lastPointX = ltrCallback(lastPointX, x);
            } else {
                bezierBbox[0] = bezierBbox[1] = Infinity;
                bezierBbox[2] = bezierBbox[3] = -Infinity;
                $b3a01b20dd2ade98$export$f8f26dd395d7e1bd.bezierBoundingBox(lastX, lastY, ...outline.slice(i, i + 6), bezierBbox);
                $b3a01b20dd2ade98$export$f8f26dd395d7e1bd.rectBoundingBox(bezierBbox[0], bezierBbox[1], bezierBbox[2], bezierBbox[3], minMax);
                if (firstPointY > bezierBbox[1]) {
                    firstPointX = bezierBbox[0];
                    firstPointY = bezierBbox[1];
                } else if (firstPointY === bezierBbox[1]) firstPointX = ltrCallback(firstPointX, bezierBbox[0]);
                if (lastPointY < bezierBbox[3]) {
                    lastPointX = bezierBbox[2];
                    lastPointY = bezierBbox[3];
                } else if (lastPointY === bezierBbox[3]) lastPointX = ltrCallback(lastPointX, bezierBbox[2]);
            }
            lastX = x;
            lastY = y;
        }
        const bbox = this.#bbox;
        bbox[0] = minMax[0] - this.#innerMargin;
        bbox[1] = minMax[1] - this.#innerMargin;
        bbox[2] = minMax[2] - minMax[0] + 2 * this.#innerMargin;
        bbox[3] = minMax[3] - minMax[1] + 2 * this.#innerMargin;
        this.firstPoint = [
            firstPointX,
            firstPointY
        ];
        this.lastPoint = [
            lastPointX,
            lastPointY
        ];
    }
    get box() {
        return this.#bbox;
    }
    newOutliner(point, box, scaleFactor, thickness, isLTR, innerMargin = 0) {
        return new $b3a01b20dd2ade98$var$FreeDrawOutliner(point, box, scaleFactor, thickness, isLTR, innerMargin);
    }
    getNewOutline(thickness, innerMargin) {
        const [x, y, width, height] = this.#bbox;
        const [layerX, layerY, layerWidth, layerHeight] = this.#box;
        const sx = width * layerWidth;
        const sy = height * layerHeight;
        const tx = x * layerWidth + layerX;
        const ty = y * layerHeight + layerY;
        const outliner = this.newOutliner({
            x: this.#points[0] * sx + tx,
            y: this.#points[1] * sy + ty
        }, this.#box, this.#scaleFactor, thickness, this.#isLTR, innerMargin ?? this.#innerMargin);
        for(let i = 2; i < this.#points.length; i += 2)outliner.add({
            x: this.#points[i] * sx + tx,
            y: this.#points[i + 1] * sy + ty
        });
        return outliner.getOutlines();
    }
}
class $b3a01b20dd2ade98$var$HighlightOutliner {
    #box;
    #firstPoint;
    #lastPoint;
    #verticalEdges = [];
    #intervals = [];
    constructor(boxes, borderWidth = 0, innerMargin = 0, isLTR = true){
        const minMax = [
            Infinity,
            Infinity,
            -Infinity,
            -Infinity
        ];
        const NUMBER_OF_DIGITS = 4;
        const EPSILON = 10 ** -NUMBER_OF_DIGITS;
        for (const { x: x, y: y, width: width, height: height } of boxes){
            const x1 = Math.floor((x - borderWidth) / EPSILON) * EPSILON;
            const x2 = Math.ceil((x + width + borderWidth) / EPSILON) * EPSILON;
            const y1 = Math.floor((y - borderWidth) / EPSILON) * EPSILON;
            const y2 = Math.ceil((y + height + borderWidth) / EPSILON) * EPSILON;
            const left = [
                x1,
                y1,
                y2,
                true
            ];
            const right = [
                x2,
                y1,
                y2,
                false
            ];
            this.#verticalEdges.push(left, right);
            $b3a01b20dd2ade98$export$f8f26dd395d7e1bd.rectBoundingBox(x1, y1, x2, y2, minMax);
        }
        const bboxWidth = minMax[2] - minMax[0] + 2 * innerMargin;
        const bboxHeight = minMax[3] - minMax[1] + 2 * innerMargin;
        const shiftedMinX = minMax[0] - innerMargin;
        const shiftedMinY = minMax[1] - innerMargin;
        let firstPointX = isLTR ? -Infinity : Infinity;
        let firstPointY = Infinity;
        const lastEdge = this.#verticalEdges.at(isLTR ? -1 : -2);
        const lastPoint = [
            lastEdge[0],
            lastEdge[2]
        ];
        for (const edge of this.#verticalEdges){
            const [x, y1, y2, left] = edge;
            if (!left && isLTR) {
                if (y1 < firstPointY) {
                    firstPointY = y1;
                    firstPointX = x;
                } else if (y1 === firstPointY) firstPointX = Math.max(firstPointX, x);
            } else if (left && !isLTR) {
                if (y1 < firstPointY) {
                    firstPointY = y1;
                    firstPointX = x;
                } else if (y1 === firstPointY) firstPointX = Math.min(firstPointX, x);
            }
            edge[0] = (x - shiftedMinX) / bboxWidth;
            edge[1] = (y1 - shiftedMinY) / bboxHeight;
            edge[2] = (y2 - shiftedMinY) / bboxHeight;
        }
        this.#box = new Float32Array([
            shiftedMinX,
            shiftedMinY,
            bboxWidth,
            bboxHeight
        ]);
        this.#firstPoint = [
            firstPointX,
            firstPointY
        ];
        this.#lastPoint = lastPoint;
    }
    getOutlines() {
        this.#verticalEdges.sort((a, b)=>a[0] - b[0] || a[1] - b[1] || a[2] - b[2]);
        const outlineVerticalEdges = [];
        for (const edge of this.#verticalEdges)if (edge[3]) {
            outlineVerticalEdges.push(...this.#breakEdge(edge));
            this.#insert(edge);
        } else {
            this.#remove(edge);
            outlineVerticalEdges.push(...this.#breakEdge(edge));
        }
        return this.#getOutlines(outlineVerticalEdges);
    }
    #getOutlines(outlineVerticalEdges) {
        const edges = [];
        const allEdges = new Set();
        for (const edge of outlineVerticalEdges){
            const [x, y1, y2] = edge;
            edges.push([
                x,
                y1,
                edge
            ], [
                x,
                y2,
                edge
            ]);
        }
        edges.sort((a, b)=>a[1] - b[1] || a[0] - b[0]);
        for(let i = 0, ii = edges.length; i < ii; i += 2){
            const edge1 = edges[i][2];
            const edge2 = edges[i + 1][2];
            edge1.push(edge2);
            edge2.push(edge1);
            allEdges.add(edge1);
            allEdges.add(edge2);
        }
        const outlines = [];
        let outline;
        while(allEdges.size > 0){
            const edge = allEdges.values().next().value;
            let [x, y1, y2, edge1, edge2] = edge;
            allEdges.delete(edge);
            let lastPointX = x;
            let lastPointY = y1;
            outline = [
                x,
                y2
            ];
            outlines.push(outline);
            while(true){
                let e;
                if (allEdges.has(edge1)) e = edge1;
                else if (allEdges.has(edge2)) e = edge2;
                else break;
                allEdges.delete(e);
                [x, y1, y2, edge1, edge2] = e;
                if (lastPointX !== x) {
                    outline.push(lastPointX, lastPointY, x, lastPointY === y1 ? y1 : y2);
                    lastPointX = x;
                }
                lastPointY = lastPointY === y1 ? y2 : y1;
            }
            outline.push(lastPointX, lastPointY);
        }
        return new $b3a01b20dd2ade98$var$HighlightOutline(outlines, this.#box, this.#firstPoint, this.#lastPoint);
    }
    #binarySearch(y) {
        const array = this.#intervals;
        let start = 0;
        let end = array.length - 1;
        while(start <= end){
            const middle = start + end >> 1;
            const y1 = array[middle][0];
            if (y1 === y) return middle;
            if (y1 < y) start = middle + 1;
            else end = middle - 1;
        }
        return end + 1;
    }
    #insert([, y1, y2]) {
        const index = this.#binarySearch(y1);
        this.#intervals.splice(index, 0, [
            y1,
            y2
        ]);
    }
    #remove([, y1, y2]) {
        const index = this.#binarySearch(y1);
        for(let i = index; i < this.#intervals.length; i++){
            const [start, end] = this.#intervals[i];
            if (start !== y1) break;
            if (start === y1 && end === y2) {
                this.#intervals.splice(i, 1);
                return;
            }
        }
        for(let i = index - 1; i >= 0; i--){
            const [start, end] = this.#intervals[i];
            if (start !== y1) break;
            if (start === y1 && end === y2) {
                this.#intervals.splice(i, 1);
                return;
            }
        }
    }
    #breakEdge(edge) {
        const [x, y1, y2] = edge;
        const results = [
            [
                x,
                y1,
                y2
            ]
        ];
        const index = this.#binarySearch(y2);
        for(let i = 0; i < index; i++){
            const [start, end] = this.#intervals[i];
            for(let j = 0, jj = results.length; j < jj; j++){
                const [, y3, y4] = results[j];
                if (end <= y3 || y4 <= start) continue;
                if (y3 >= start) {
                    if (y4 > end) results[j][1] = end;
                    else {
                        if (jj === 1) return [];
                        results.splice(j, 1);
                        j--;
                        jj--;
                    }
                    continue;
                }
                results[j][2] = start;
                if (y4 > end) results.push([
                    x,
                    end,
                    y4
                ]);
            }
        }
        return results;
    }
}
class $b3a01b20dd2ade98$var$HighlightOutline extends $b3a01b20dd2ade98$var$Outline {
    #box;
    #outlines;
    constructor(outlines, box, firstPoint, lastPoint){
        super();
        this.#outlines = outlines;
        this.#box = box;
        this.firstPoint = firstPoint;
        this.lastPoint = lastPoint;
    }
    toSVGPath() {
        const buffer = [];
        for (const polygon of this.#outlines){
            let [prevX, prevY] = polygon;
            buffer.push(`M${prevX} ${prevY}`);
            for(let i = 2; i < polygon.length; i += 2){
                const x = polygon[i];
                const y = polygon[i + 1];
                if (x === prevX) {
                    buffer.push(`V${y}`);
                    prevY = y;
                } else if (y === prevY) {
                    buffer.push(`H${x}`);
                    prevX = x;
                }
            }
            buffer.push("Z");
        }
        return buffer.join(" ");
    }
    serialize([blX, blY, trX, trY], _rotation) {
        const outlines = [];
        const width = trX - blX;
        const height = trY - blY;
        for (const outline of this.#outlines){
            const points = new Array(outline.length);
            for(let i = 0; i < outline.length; i += 2){
                points[i] = blX + outline[i] * width;
                points[i + 1] = trY - outline[i + 1] * height;
            }
            outlines.push(points);
        }
        return outlines;
    }
    get box() {
        return this.#box;
    }
    get classNamesForOutlining() {
        return [
            "highlightOutline"
        ];
    }
}
class $b3a01b20dd2ade98$var$FreeHighlightOutliner extends $b3a01b20dd2ade98$var$FreeDrawOutliner {
    newFreeDrawOutline(outline, points, box, scaleFactor, innerMargin, isLTR) {
        return new $b3a01b20dd2ade98$var$FreeHighlightOutline(outline, points, box, scaleFactor, innerMargin, isLTR);
    }
}
class $b3a01b20dd2ade98$var$FreeHighlightOutline extends $b3a01b20dd2ade98$var$FreeDrawOutline {
    newOutliner(point, box, scaleFactor, thickness, isLTR, innerMargin = 0) {
        return new $b3a01b20dd2ade98$var$FreeHighlightOutliner(point, box, scaleFactor, thickness, isLTR, innerMargin);
    }
}
class $b3a01b20dd2ade98$var$HighlightEditor extends $b3a01b20dd2ade98$var$AnnotationEditor {
    #anchorNode = null;
    #anchorOffset = 0;
    #boxes;
    #clipPathId = null;
    #colorPicker = null;
    #focusOutlines = null;
    #focusNode = null;
    #focusOffset = 0;
    #highlightDiv = null;
    #highlightOutlines = null;
    #id = null;
    #isFreeHighlight = false;
    #firstPoint = null;
    #lastPoint = null;
    #outlineId = null;
    #text = "";
    #thickness;
    #methodOfCreation = "";
    static _defaultColor = null;
    static _defaultOpacity = 1;
    static _defaultThickness = 12;
    static _type = "highlight";
    static _editorType = $b3a01b20dd2ade98$export$72ea3bfdd9a725bf.HIGHLIGHT;
    static _freeHighlightId = -1;
    static _freeHighlight = null;
    static _freeHighlightClipId = "";
    static get _keyboardManager() {
        const proto = $b3a01b20dd2ade98$var$HighlightEditor.prototype;
        return $b3a01b20dd2ade98$export$b8972b998723d602(this, "_keyboardManager", new $b3a01b20dd2ade98$var$KeyboardManager([
            [
                [
                    "ArrowLeft",
                    "mac+ArrowLeft"
                ],
                proto._moveCaret,
                {
                    args: [
                        0
                    ]
                }
            ],
            [
                [
                    "ArrowRight",
                    "mac+ArrowRight"
                ],
                proto._moveCaret,
                {
                    args: [
                        1
                    ]
                }
            ],
            [
                [
                    "ArrowUp",
                    "mac+ArrowUp"
                ],
                proto._moveCaret,
                {
                    args: [
                        2
                    ]
                }
            ],
            [
                [
                    "ArrowDown",
                    "mac+ArrowDown"
                ],
                proto._moveCaret,
                {
                    args: [
                        3
                    ]
                }
            ]
        ]));
    }
    constructor(params){
        super({
            ...params,
            name: "highlightEditor"
        });
        this.color = params.color || $b3a01b20dd2ade98$var$HighlightEditor._defaultColor;
        this.#thickness = params.thickness || $b3a01b20dd2ade98$var$HighlightEditor._defaultThickness;
        this.opacity = params.opacity || $b3a01b20dd2ade98$var$HighlightEditor._defaultOpacity;
        this.#boxes = params.boxes || null;
        this.#methodOfCreation = params.methodOfCreation || "";
        this.#text = params.text || "";
        this._isDraggable = false;
        this.defaultL10nId = "pdfjs-editor-highlight-editor";
        if (params.highlightId > -1) {
            this.#isFreeHighlight = true;
            this.#createFreeOutlines(params);
            this.#addToDrawLayer();
        } else if (this.#boxes) {
            this.#anchorNode = params.anchorNode;
            this.#anchorOffset = params.anchorOffset;
            this.#focusNode = params.focusNode;
            this.#focusOffset = params.focusOffset;
            this.#createOutlines();
            this.#addToDrawLayer();
            this.rotate(this.rotation);
        }
        if (!this.annotationElementId) this._uiManager.a11yAlert("pdfjs-editor-highlight-added-alert");
    }
    get telemetryInitialData() {
        return {
            action: "added",
            type: this.#isFreeHighlight ? "free_highlight" : "highlight",
            color: this._uiManager.getNonHCMColorName(this.color),
            thickness: this.#thickness,
            methodOfCreation: this.#methodOfCreation
        };
    }
    get telemetryFinalData() {
        return {
            type: "highlight",
            color: this._uiManager.getNonHCMColorName(this.color)
        };
    }
    static computeTelemetryFinalData(data) {
        return {
            numberOfColors: data.get("color").size
        };
    }
    #createOutlines() {
        const outliner = new $b3a01b20dd2ade98$var$HighlightOutliner(this.#boxes, 0.001);
        this.#highlightOutlines = outliner.getOutlines();
        [this.x, this.y, this.width, this.height] = this.#highlightOutlines.box;
        const outlinerForOutline = new $b3a01b20dd2ade98$var$HighlightOutliner(this.#boxes, 0.0025, 0.001, this._uiManager.direction === "ltr");
        this.#focusOutlines = outlinerForOutline.getOutlines();
        const { firstPoint: firstPoint } = this.#highlightOutlines;
        this.#firstPoint = [
            (firstPoint[0] - this.x) / this.width,
            (firstPoint[1] - this.y) / this.height
        ];
        const { lastPoint: lastPoint } = this.#focusOutlines;
        this.#lastPoint = [
            (lastPoint[0] - this.x) / this.width,
            (lastPoint[1] - this.y) / this.height
        ];
    }
    #createFreeOutlines({ highlightOutlines: highlightOutlines, highlightId: highlightId, clipPathId: clipPathId }) {
        this.#highlightOutlines = highlightOutlines;
        const extraThickness = 1.5;
        this.#focusOutlines = highlightOutlines.getNewOutline(this.#thickness / 2 + extraThickness, 0.0025);
        if (highlightId >= 0) {
            this.#id = highlightId;
            this.#clipPathId = clipPathId;
            this.parent.drawLayer.finalizeDraw(highlightId, {
                bbox: highlightOutlines.box,
                path: {
                    d: highlightOutlines.toSVGPath()
                }
            });
            this.#outlineId = this.parent.drawLayer.drawOutline({
                rootClass: {
                    highlightOutline: true,
                    free: true
                },
                bbox: this.#focusOutlines.box,
                path: {
                    d: this.#focusOutlines.toSVGPath()
                }
            }, true);
        } else if (this.parent) {
            const angle = this.parent.viewport.rotation;
            this.parent.drawLayer.updateProperties(this.#id, {
                bbox: $b3a01b20dd2ade98$var$HighlightEditor.#rotateBbox(this.#highlightOutlines.box, (angle - this.rotation + 360) % 360),
                path: {
                    d: highlightOutlines.toSVGPath()
                }
            });
            this.parent.drawLayer.updateProperties(this.#outlineId, {
                bbox: $b3a01b20dd2ade98$var$HighlightEditor.#rotateBbox(this.#focusOutlines.box, angle),
                path: {
                    d: this.#focusOutlines.toSVGPath()
                }
            });
        }
        const [x, y, width, height] = highlightOutlines.box;
        switch(this.rotation){
            case 0:
                this.x = x;
                this.y = y;
                this.width = width;
                this.height = height;
                break;
            case 90:
                {
                    const [pageWidth, pageHeight] = this.parentDimensions;
                    this.x = y;
                    this.y = 1 - x;
                    this.width = width * pageHeight / pageWidth;
                    this.height = height * pageWidth / pageHeight;
                    break;
                }
            case 180:
                this.x = 1 - x;
                this.y = 1 - y;
                this.width = width;
                this.height = height;
                break;
            case 270:
                {
                    const [pageWidth, pageHeight] = this.parentDimensions;
                    this.x = 1 - y;
                    this.y = x;
                    this.width = width * pageHeight / pageWidth;
                    this.height = height * pageWidth / pageHeight;
                    break;
                }
        }
        const { firstPoint: firstPoint } = highlightOutlines;
        this.#firstPoint = [
            (firstPoint[0] - x) / width,
            (firstPoint[1] - y) / height
        ];
        const { lastPoint: lastPoint } = this.#focusOutlines;
        this.#lastPoint = [
            (lastPoint[0] - x) / width,
            (lastPoint[1] - y) / height
        ];
    }
    static initialize(l10n, uiManager) {
        $b3a01b20dd2ade98$var$AnnotationEditor.initialize(l10n, uiManager);
        $b3a01b20dd2ade98$var$HighlightEditor._defaultColor ||= uiManager.highlightColors?.values().next().value || "#fff066";
    }
    static updateDefaultParams(type, value) {
        switch(type){
            case $b3a01b20dd2ade98$export$cf3df2a6ecc26692.HIGHLIGHT_COLOR:
                $b3a01b20dd2ade98$var$HighlightEditor._defaultColor = value;
                break;
            case $b3a01b20dd2ade98$export$cf3df2a6ecc26692.HIGHLIGHT_THICKNESS:
                $b3a01b20dd2ade98$var$HighlightEditor._defaultThickness = value;
                break;
        }
    }
    translateInPage(x, y) {}
    get toolbarPosition() {
        return this.#lastPoint;
    }
    get commentButtonPosition() {
        return this.#firstPoint;
    }
    updateParams(type, value) {
        switch(type){
            case $b3a01b20dd2ade98$export$cf3df2a6ecc26692.HIGHLIGHT_COLOR:
                this.#updateColor(value);
                break;
            case $b3a01b20dd2ade98$export$cf3df2a6ecc26692.HIGHLIGHT_THICKNESS:
                this.#updateThickness(value);
                break;
        }
    }
    static get defaultPropertiesToUpdate() {
        return [
            [
                $b3a01b20dd2ade98$export$cf3df2a6ecc26692.HIGHLIGHT_COLOR,
                $b3a01b20dd2ade98$var$HighlightEditor._defaultColor
            ],
            [
                $b3a01b20dd2ade98$export$cf3df2a6ecc26692.HIGHLIGHT_THICKNESS,
                $b3a01b20dd2ade98$var$HighlightEditor._defaultThickness
            ]
        ];
    }
    get propertiesToUpdate() {
        return [
            [
                $b3a01b20dd2ade98$export$cf3df2a6ecc26692.HIGHLIGHT_COLOR,
                this.color || $b3a01b20dd2ade98$var$HighlightEditor._defaultColor
            ],
            [
                $b3a01b20dd2ade98$export$cf3df2a6ecc26692.HIGHLIGHT_THICKNESS,
                this.#thickness || $b3a01b20dd2ade98$var$HighlightEditor._defaultThickness
            ],
            [
                $b3a01b20dd2ade98$export$cf3df2a6ecc26692.HIGHLIGHT_FREE,
                this.#isFreeHighlight
            ]
        ];
    }
    onUpdatedColor() {
        this.parent?.drawLayer.updateProperties(this.#id, {
            root: {
                fill: this.color,
                "fill-opacity": this.opacity
            }
        });
        this.#colorPicker?.updateColor(this.color);
        super.onUpdatedColor();
    }
    #updateColor(color) {
        const setColorAndOpacity = (col, opa)=>{
            this.color = col;
            this.opacity = opa;
            this.onUpdatedColor();
        };
        const savedColor = this.color;
        const savedOpacity = this.opacity;
        this.addCommands({
            cmd: setColorAndOpacity.bind(this, color, $b3a01b20dd2ade98$var$HighlightEditor._defaultOpacity),
            undo: setColorAndOpacity.bind(this, savedColor, savedOpacity),
            post: this._uiManager.updateUI.bind(this._uiManager, this),
            mustExec: true,
            type: $b3a01b20dd2ade98$export$cf3df2a6ecc26692.HIGHLIGHT_COLOR,
            overwriteIfSameType: true,
            keepUndo: true
        });
        this._reportTelemetry({
            action: "color_changed",
            color: this._uiManager.getNonHCMColorName(color)
        }, true);
    }
    #updateThickness(thickness) {
        const savedThickness = this.#thickness;
        const setThickness = (th)=>{
            this.#thickness = th;
            this.#changeThickness(th);
        };
        this.addCommands({
            cmd: setThickness.bind(this, thickness),
            undo: setThickness.bind(this, savedThickness),
            post: this._uiManager.updateUI.bind(this._uiManager, this),
            mustExec: true,
            type: $b3a01b20dd2ade98$export$cf3df2a6ecc26692.INK_THICKNESS,
            overwriteIfSameType: true,
            keepUndo: true
        });
        this._reportTelemetry({
            action: "thickness_changed",
            thickness: thickness
        }, true);
    }
    get toolbarButtons() {
        if (this._uiManager.highlightColors) {
            const colorPicker = this.#colorPicker = new $b3a01b20dd2ade98$export$9feb1bc2e5f1ccb3({
                editor: this
            });
            return [
                [
                    "colorPicker",
                    colorPicker
                ]
            ];
        }
        return super.toolbarButtons;
    }
    disableEditing() {
        super.disableEditing();
        this.div.classList.toggle("disabled", true);
    }
    enableEditing() {
        super.enableEditing();
        this.div.classList.toggle("disabled", false);
    }
    fixAndSetPosition() {
        return super.fixAndSetPosition(this.#getRotation());
    }
    getBaseTranslation() {
        return [
            0,
            0
        ];
    }
    getRect(tx, ty) {
        return super.getRect(tx, ty, this.#getRotation());
    }
    onceAdded(focus) {
        if (!this.annotationElementId) this.parent.addUndoableEditor(this);
        if (focus) this.div.focus();
    }
    remove() {
        this.#cleanDrawLayer();
        this._reportTelemetry({
            action: "deleted"
        });
        super.remove();
    }
    rebuild() {
        if (!this.parent) return;
        super.rebuild();
        if (this.div === null) return;
        this.#addToDrawLayer();
        if (!this.isAttachedToDOM) this.parent.add(this);
    }
    setParent(parent) {
        let mustBeSelected = false;
        if (this.parent && !parent) this.#cleanDrawLayer();
        else if (parent) {
            this.#addToDrawLayer(parent);
            mustBeSelected = !this.parent && this.div?.classList.contains("selectedEditor");
        }
        super.setParent(parent);
        this.show(this._isVisible);
        if (mustBeSelected) this.select();
    }
    #changeThickness(thickness) {
        if (!this.#isFreeHighlight) return;
        this.#createFreeOutlines({
            highlightOutlines: this.#highlightOutlines.getNewOutline(thickness / 2)
        });
        this.fixAndSetPosition();
        this.setDims();
    }
    #cleanDrawLayer() {
        if (this.#id === null || !this.parent) return;
        this.parent.drawLayer.remove(this.#id);
        this.#id = null;
        this.parent.drawLayer.remove(this.#outlineId);
        this.#outlineId = null;
    }
    #addToDrawLayer(parent = this.parent) {
        if (this.#id !== null) return;
        ({ id: this.#id, clipPathId: this.#clipPathId } = parent.drawLayer.draw({
            bbox: this.#highlightOutlines.box,
            root: {
                viewBox: "0 0 1 1",
                fill: this.color,
                "fill-opacity": this.opacity
            },
            rootClass: {
                highlight: true,
                free: this.#isFreeHighlight
            },
            path: {
                d: this.#highlightOutlines.toSVGPath()
            }
        }, false, true));
        this.#outlineId = parent.drawLayer.drawOutline({
            rootClass: {
                highlightOutline: true,
                free: this.#isFreeHighlight
            },
            bbox: this.#focusOutlines.box,
            path: {
                d: this.#focusOutlines.toSVGPath()
            }
        }, this.#isFreeHighlight);
        if (this.#highlightDiv) this.#highlightDiv.style.clipPath = this.#clipPathId;
    }
    static #rotateBbox([x, y, width, height], angle) {
        switch(angle){
            case 90:
                return [
                    1 - y - height,
                    x,
                    height,
                    width
                ];
            case 180:
                return [
                    1 - x - width,
                    1 - y - height,
                    width,
                    height
                ];
            case 270:
                return [
                    y,
                    1 - x - width,
                    height,
                    width
                ];
        }
        return [
            x,
            y,
            width,
            height
        ];
    }
    rotate(angle) {
        const { drawLayer: drawLayer } = this.parent;
        let box;
        if (this.#isFreeHighlight) {
            angle = (angle - this.rotation + 360) % 360;
            box = $b3a01b20dd2ade98$var$HighlightEditor.#rotateBbox(this.#highlightOutlines.box, angle);
        } else box = $b3a01b20dd2ade98$var$HighlightEditor.#rotateBbox([
            this.x,
            this.y,
            this.width,
            this.height
        ], angle);
        drawLayer.updateProperties(this.#id, {
            bbox: box,
            root: {
                "data-main-rotation": angle
            }
        });
        drawLayer.updateProperties(this.#outlineId, {
            bbox: $b3a01b20dd2ade98$var$HighlightEditor.#rotateBbox(this.#focusOutlines.box, angle),
            root: {
                "data-main-rotation": angle
            }
        });
    }
    render() {
        if (this.div) return this.div;
        const div = super.render();
        if (this.#text) {
            div.setAttribute("aria-label", this.#text);
            div.setAttribute("role", "mark");
        }
        if (this.#isFreeHighlight) div.classList.add("free");
        else this.div.addEventListener("keydown", this.#keydown.bind(this), {
            signal: this._uiManager._signal
        });
        const highlightDiv = this.#highlightDiv = document.createElement("div");
        div.append(highlightDiv);
        highlightDiv.setAttribute("aria-hidden", "true");
        highlightDiv.className = "internal";
        highlightDiv.style.clipPath = this.#clipPathId;
        this.setDims();
        $b3a01b20dd2ade98$var$bindEvents(this, this.#highlightDiv, [
            "pointerover",
            "pointerleave"
        ]);
        this.enableEditing();
        return div;
    }
    pointerover() {
        if (!this.isSelected) this.parent?.drawLayer.updateProperties(this.#outlineId, {
            rootClass: {
                hovered: true
            }
        });
    }
    pointerleave() {
        if (!this.isSelected) this.parent?.drawLayer.updateProperties(this.#outlineId, {
            rootClass: {
                hovered: false
            }
        });
    }
    #keydown(event) {
        $b3a01b20dd2ade98$var$HighlightEditor._keyboardManager.exec(this, event);
    }
    _moveCaret(direction) {
        this.parent.unselect(this);
        switch(direction){
            case 0:
            case 2:
                this.#setCaret(true);
                break;
            case 1:
            case 3:
                this.#setCaret(false);
                break;
        }
    }
    #setCaret(start) {
        if (!this.#anchorNode) return;
        const selection = window.getSelection();
        if (start) selection.setPosition(this.#anchorNode, this.#anchorOffset);
        else selection.setPosition(this.#focusNode, this.#focusOffset);
    }
    select() {
        super.select();
        if (!this.#outlineId) return;
        this.parent?.drawLayer.updateProperties(this.#outlineId, {
            rootClass: {
                hovered: false,
                selected: true
            }
        });
    }
    unselect() {
        super.unselect();
        if (!this.#outlineId) return;
        this.parent?.drawLayer.updateProperties(this.#outlineId, {
            rootClass: {
                selected: false
            }
        });
        if (!this.#isFreeHighlight) this.#setCaret(false);
    }
    get _mustFixPosition() {
        return !this.#isFreeHighlight;
    }
    show(visible = this._isVisible) {
        super.show(visible);
        if (this.parent) {
            this.parent.drawLayer.updateProperties(this.#id, {
                rootClass: {
                    hidden: !visible
                }
            });
            this.parent.drawLayer.updateProperties(this.#outlineId, {
                rootClass: {
                    hidden: !visible
                }
            });
        }
    }
    #getRotation() {
        return this.#isFreeHighlight ? this.rotation : 0;
    }
    #serializeBoxes() {
        if (this.#isFreeHighlight) return null;
        const [pageWidth, pageHeight] = this.pageDimensions;
        const [pageX, pageY] = this.pageTranslation;
        const boxes = this.#boxes;
        const quadPoints = new Float32Array(boxes.length * 8);
        let i = 0;
        for (const { x: x, y: y, width: width, height: height } of boxes){
            const sx = x * pageWidth + pageX;
            const sy = (1 - y) * pageHeight + pageY;
            quadPoints[i] = quadPoints[i + 4] = sx;
            quadPoints[i + 1] = quadPoints[i + 3] = sy;
            quadPoints[i + 2] = quadPoints[i + 6] = sx + width * pageWidth;
            quadPoints[i + 5] = quadPoints[i + 7] = sy - height * pageHeight;
            i += 8;
        }
        return quadPoints;
    }
    #serializeOutlines(rect) {
        return this.#highlightOutlines.serialize(rect, this.#getRotation());
    }
    static startHighlighting(parent, isLTR, { target: textLayer, x: x, y: y }) {
        const { x: layerX, y: layerY, width: parentWidth, height: parentHeight } = textLayer.getBoundingClientRect();
        const ac = new AbortController();
        const signal = parent.combinedSignal(ac);
        const pointerUpCallback = (e)=>{
            ac.abort();
            this.#endHighlight(parent, e);
        };
        window.addEventListener("blur", pointerUpCallback, {
            signal: signal
        });
        window.addEventListener("pointerup", pointerUpCallback, {
            signal: signal
        });
        window.addEventListener("pointerdown", $b3a01b20dd2ade98$export$7ae4cd3a66c1e050, {
            capture: true,
            passive: false,
            signal: signal
        });
        window.addEventListener("contextmenu", $b3a01b20dd2ade98$export$455b7811f904cadc, {
            signal: signal
        });
        textLayer.addEventListener("pointermove", this.#highlightMove.bind(this, parent), {
            signal: signal
        });
        this._freeHighlight = new $b3a01b20dd2ade98$var$FreeHighlightOutliner({
            x: x,
            y: y
        }, [
            layerX,
            layerY,
            parentWidth,
            parentHeight
        ], parent.scale, this._defaultThickness / 2, isLTR, 0.001);
        ({ id: this._freeHighlightId, clipPathId: this._freeHighlightClipId } = parent.drawLayer.draw({
            bbox: [
                0,
                0,
                1,
                1
            ],
            root: {
                viewBox: "0 0 1 1",
                fill: this._defaultColor,
                "fill-opacity": this._defaultOpacity
            },
            rootClass: {
                highlight: true,
                free: true
            },
            path: {
                d: this._freeHighlight.toSVGPath()
            }
        }, true, true));
    }
    static #highlightMove(parent, event) {
        if (this._freeHighlight.add(event)) parent.drawLayer.updateProperties(this._freeHighlightId, {
            path: {
                d: this._freeHighlight.toSVGPath()
            }
        });
    }
    static #endHighlight(parent, event) {
        if (!this._freeHighlight.isEmpty()) parent.createAndAddNewEditor(event, false, {
            highlightId: this._freeHighlightId,
            highlightOutlines: this._freeHighlight.getOutlines(),
            clipPathId: this._freeHighlightClipId,
            methodOfCreation: "main_toolbar"
        });
        else parent.drawLayer.remove(this._freeHighlightId);
        this._freeHighlightId = -1;
        this._freeHighlight = null;
        this._freeHighlightClipId = "";
    }
    static async deserialize(data, parent, uiManager) {
        let initialData = null;
        if (data instanceof $b3a01b20dd2ade98$var$HighlightAnnotationElement) {
            const { data: { quadPoints: quadPoints, rect: rect, rotation: rotation, id: id, color: color, opacity: opacity, popupRef: popupRef, richText: richText, contentsObj: contentsObj, creationDate: creationDate, modificationDate: modificationDate }, parent: { page: { pageNumber: pageNumber } } } = data;
            initialData = data = {
                annotationType: $b3a01b20dd2ade98$export$72ea3bfdd9a725bf.HIGHLIGHT,
                color: Array.from(color),
                opacity: opacity,
                quadPoints: quadPoints,
                boxes: null,
                pageIndex: pageNumber - 1,
                rect: rect.slice(0),
                rotation: rotation,
                annotationElementId: id,
                id: id,
                deleted: false,
                popupRef: popupRef,
                richText: richText,
                comment: contentsObj?.str || null,
                creationDate: creationDate,
                modificationDate: modificationDate
            };
        } else if (data instanceof $b3a01b20dd2ade98$var$InkAnnotationElement) {
            const { data: { inkLists: inkLists, rect: rect, rotation: rotation, id: id, color: color, borderStyle: { rawWidth: thickness }, popupRef: popupRef, richText: richText, contentsObj: contentsObj, creationDate: creationDate, modificationDate: modificationDate }, parent: { page: { pageNumber: pageNumber } } } = data;
            initialData = data = {
                annotationType: $b3a01b20dd2ade98$export$72ea3bfdd9a725bf.HIGHLIGHT,
                color: Array.from(color),
                thickness: thickness,
                inkLists: inkLists,
                boxes: null,
                pageIndex: pageNumber - 1,
                rect: rect.slice(0),
                rotation: rotation,
                annotationElementId: id,
                id: id,
                deleted: false,
                popupRef: popupRef,
                richText: richText,
                comment: contentsObj?.str || null,
                creationDate: creationDate,
                modificationDate: modificationDate
            };
        }
        const { color: color, quadPoints: quadPoints, inkLists: inkLists, outlines: outlines, opacity: opacity } = data;
        const editor = await super.deserialize(data, parent, uiManager);
        editor.color = $b3a01b20dd2ade98$export$f8f26dd395d7e1bd.makeHexColor(...color);
        editor.opacity = opacity || 1;
        if (inkLists) editor.#thickness = data.thickness;
        editor._initialData = initialData;
        if (data.comment) editor.setCommentData(data);
        const [pageWidth, pageHeight] = editor.pageDimensions;
        const [pageX, pageY] = editor.pageTranslation;
        if (quadPoints) {
            const boxes = editor.#boxes = [];
            for(let i = 0; i < quadPoints.length; i += 8)boxes.push({
                x: (quadPoints[i] - pageX) / pageWidth,
                y: 1 - (quadPoints[i + 1] - pageY) / pageHeight,
                width: (quadPoints[i + 2] - quadPoints[i]) / pageWidth,
                height: (quadPoints[i + 1] - quadPoints[i + 5]) / pageHeight
            });
            editor.#createOutlines();
            editor.#addToDrawLayer();
            editor.rotate(editor.rotation);
        } else if (inkLists || outlines) {
            editor.#isFreeHighlight = true;
            const points = (inkLists || outlines.points)[0];
            const point = {
                x: points[0] - pageX,
                y: pageHeight - (points[1] - pageY)
            };
            const outliner = new $b3a01b20dd2ade98$var$FreeHighlightOutliner(point, [
                0,
                0,
                pageWidth,
                pageHeight
            ], 1, editor.#thickness / 2, true, 0.001);
            for(let i = 0, ii = points.length; i < ii; i += 2){
                point.x = points[i] - pageX;
                point.y = pageHeight - (points[i + 1] - pageY);
                outliner.add(point);
            }
            const { id: id, clipPathId: clipPathId } = parent.drawLayer.draw({
                bbox: [
                    0,
                    0,
                    1,
                    1
                ],
                root: {
                    viewBox: "0 0 1 1",
                    fill: editor.color,
                    "fill-opacity": editor._defaultOpacity
                },
                rootClass: {
                    highlight: true,
                    free: true
                },
                path: {
                    d: outliner.toSVGPath()
                }
            }, true, true);
            editor.#createFreeOutlines({
                highlightOutlines: outliner.getOutlines(),
                highlightId: id,
                clipPathId: clipPathId
            });
            editor.#addToDrawLayer();
            editor.rotate(editor.parentRotation);
        }
        return editor;
    }
    serialize(isForCopying = false) {
        if (this.isEmpty() || isForCopying) return null;
        if (this.deleted) return this.serializeDeleted();
        const color = $b3a01b20dd2ade98$var$AnnotationEditor._colorManager.convert(this._uiManager.getNonHCMColor(this.color));
        const serialized = super.serialize(isForCopying);
        Object.assign(serialized, {
            color: color,
            opacity: this.opacity,
            thickness: this.#thickness,
            quadPoints: this.#serializeBoxes(),
            outlines: this.#serializeOutlines(serialized.rect)
        });
        this.addComment(serialized);
        if (this.annotationElementId && !this.#hasElementChanged(serialized)) return null;
        serialized.id = this.annotationElementId;
        return serialized;
    }
    #hasElementChanged(serialized) {
        const { color: color } = this._initialData;
        return this.hasEditedComment || serialized.color.some((c, i)=>c !== color[i]);
    }
    renderAnnotationElement(annotation) {
        if (this.deleted) {
            annotation.hide();
            return null;
        }
        annotation.updateEdited({
            rect: this.getPDFRect(),
            popup: this.comment
        });
        return null;
    }
    static canCreateNewEmptyEditor() {
        return false;
    }
}
class $b3a01b20dd2ade98$var$DrawingOptions {
    #svgProperties = Object.create(null);
    updateProperty(name, value) {
        this[name] = value;
        this.updateSVGProperty(name, value);
    }
    updateProperties(properties) {
        if (!properties) return;
        for (const [name, value] of Object.entries(properties))if (!name.startsWith("_")) this.updateProperty(name, value);
    }
    updateSVGProperty(name, value) {
        this.#svgProperties[name] = value;
    }
    toSVGProperties() {
        const root = this.#svgProperties;
        this.#svgProperties = Object.create(null);
        return {
            root: root
        };
    }
    reset() {
        this.#svgProperties = Object.create(null);
    }
    updateAll(options = this) {
        this.updateProperties(options);
    }
    clone() {
        $b3a01b20dd2ade98$var$unreachable("Not implemented");
    }
}
class $b3a01b20dd2ade98$var$DrawingEditor extends $b3a01b20dd2ade98$var$AnnotationEditor {
    #drawOutlines = null;
    #mustBeCommitted;
    _colorPicker = null;
    _drawId = null;
    static _currentDrawId = -1;
    static _currentParent = null;
    static #currentDraw = null;
    static #currentDrawingAC = null;
    static #currentDrawingOptions = null;
    static _INNER_MARGIN = 3;
    constructor(params){
        super(params);
        this.#mustBeCommitted = params.mustBeCommitted || false;
        this._addOutlines(params);
    }
    onUpdatedColor() {
        this._colorPicker?.update(this.color);
        super.onUpdatedColor();
    }
    _addOutlines(params) {
        if (params.drawOutlines) {
            this.#createDrawOutlines(params);
            this.#addToDrawLayer();
        }
    }
    #createDrawOutlines({ drawOutlines: drawOutlines, drawId: drawId, drawingOptions: drawingOptions }) {
        this.#drawOutlines = drawOutlines;
        this._drawingOptions ||= drawingOptions;
        if (!this.annotationElementId) this._uiManager.a11yAlert(`pdfjs-editor-${this.editorType}-added-alert`);
        if (drawId >= 0) {
            this._drawId = drawId;
            this.parent.drawLayer.finalizeDraw(drawId, drawOutlines.defaultProperties);
        } else this._drawId = this.#createDrawing(drawOutlines, this.parent);
        this.#updateBbox(drawOutlines.box);
    }
    #createDrawing(drawOutlines, parent) {
        const { id: id } = parent.drawLayer.draw($b3a01b20dd2ade98$var$DrawingEditor._mergeSVGProperties(this._drawingOptions.toSVGProperties(), drawOutlines.defaultSVGProperties), false, false);
        return id;
    }
    static _mergeSVGProperties(p1, p2) {
        const p1Keys = new Set(Object.keys(p1));
        for (const [key, value] of Object.entries(p2))if (p1Keys.has(key)) Object.assign(p1[key], value);
        else p1[key] = value;
        return p1;
    }
    static getDefaultDrawingOptions(_options) {
        $b3a01b20dd2ade98$var$unreachable("Not implemented");
    }
    static get typesMap() {
        $b3a01b20dd2ade98$var$unreachable("Not implemented");
    }
    static get isDrawer() {
        return true;
    }
    static get supportMultipleDrawings() {
        return false;
    }
    static updateDefaultParams(type, value) {
        const propertyName = this.typesMap.get(type);
        if (propertyName) this._defaultDrawingOptions.updateProperty(propertyName, value);
        if (this._currentParent) {
            $b3a01b20dd2ade98$var$DrawingEditor.#currentDraw.updateProperty(propertyName, value);
            this._currentParent.drawLayer.updateProperties(this._currentDrawId, this._defaultDrawingOptions.toSVGProperties());
        }
    }
    updateParams(type, value) {
        const propertyName = this.constructor.typesMap.get(type);
        if (propertyName) this._updateProperty(type, propertyName, value);
    }
    static get defaultPropertiesToUpdate() {
        const properties = [];
        const options = this._defaultDrawingOptions;
        for (const [type, name] of this.typesMap)properties.push([
            type,
            options[name]
        ]);
        return properties;
    }
    get propertiesToUpdate() {
        const properties = [];
        const { _drawingOptions: _drawingOptions } = this;
        for (const [type, name] of this.constructor.typesMap)properties.push([
            type,
            _drawingOptions[name]
        ]);
        return properties;
    }
    _updateProperty(type, name, value) {
        const options = this._drawingOptions;
        const savedValue = options[name];
        const setter = (val)=>{
            options.updateProperty(name, val);
            const bbox = this.#drawOutlines.updateProperty(name, val);
            if (bbox) this.#updateBbox(bbox);
            this.parent?.drawLayer.updateProperties(this._drawId, options.toSVGProperties());
            if (type === this.colorType) this.onUpdatedColor();
        };
        this.addCommands({
            cmd: setter.bind(this, value),
            undo: setter.bind(this, savedValue),
            post: this._uiManager.updateUI.bind(this._uiManager, this),
            mustExec: true,
            type: type,
            overwriteIfSameType: true,
            keepUndo: true
        });
    }
    _onResizing() {
        this.parent?.drawLayer.updateProperties(this._drawId, $b3a01b20dd2ade98$var$DrawingEditor._mergeSVGProperties(this.#drawOutlines.getPathResizingSVGProperties(this.#convertToDrawSpace()), {
            bbox: this.#rotateBox()
        }));
    }
    _onResized() {
        this.parent?.drawLayer.updateProperties(this._drawId, $b3a01b20dd2ade98$var$DrawingEditor._mergeSVGProperties(this.#drawOutlines.getPathResizedSVGProperties(this.#convertToDrawSpace()), {
            bbox: this.#rotateBox()
        }));
    }
    _onTranslating(_x, _y) {
        this.parent?.drawLayer.updateProperties(this._drawId, {
            bbox: this.#rotateBox()
        });
    }
    _onTranslated() {
        this.parent?.drawLayer.updateProperties(this._drawId, $b3a01b20dd2ade98$var$DrawingEditor._mergeSVGProperties(this.#drawOutlines.getPathTranslatedSVGProperties(this.#convertToDrawSpace(), this.parentDimensions), {
            bbox: this.#rotateBox()
        }));
    }
    _onStartDragging() {
        this.parent?.drawLayer.updateProperties(this._drawId, {
            rootClass: {
                moving: true
            }
        });
    }
    _onStopDragging() {
        this.parent?.drawLayer.updateProperties(this._drawId, {
            rootClass: {
                moving: false
            }
        });
    }
    commit() {
        super.commit();
        this.disableEditMode();
        this.disableEditing();
    }
    disableEditing() {
        super.disableEditing();
        this.div.classList.toggle("disabled", true);
    }
    enableEditing() {
        super.enableEditing();
        this.div.classList.toggle("disabled", false);
    }
    getBaseTranslation() {
        return [
            0,
            0
        ];
    }
    get isResizable() {
        return true;
    }
    onceAdded(focus) {
        if (!this.annotationElementId) this.parent.addUndoableEditor(this);
        this._isDraggable = true;
        if (this.#mustBeCommitted) {
            this.#mustBeCommitted = false;
            this.commit();
            this.parent.setSelected(this);
            if (focus && this.isOnScreen) this.div.focus();
        }
    }
    remove() {
        this.#cleanDrawLayer();
        super.remove();
    }
    rebuild() {
        if (!this.parent) return;
        super.rebuild();
        if (this.div === null) return;
        this.#addToDrawLayer();
        this.#updateBbox(this.#drawOutlines.box);
        if (!this.isAttachedToDOM) this.parent.add(this);
    }
    setParent(parent) {
        let mustBeSelected = false;
        if (this.parent && !parent) {
            this._uiManager.removeShouldRescale(this);
            this.#cleanDrawLayer();
        } else if (parent) {
            this._uiManager.addShouldRescale(this);
            this.#addToDrawLayer(parent);
            mustBeSelected = !this.parent && this.div?.classList.contains("selectedEditor");
        }
        super.setParent(parent);
        if (mustBeSelected) this.select();
    }
    #cleanDrawLayer() {
        if (this._drawId === null || !this.parent) return;
        this.parent.drawLayer.remove(this._drawId);
        this._drawId = null;
        this._drawingOptions.reset();
    }
    #addToDrawLayer(parent = this.parent) {
        if (this._drawId !== null && this.parent === parent) return;
        if (this._drawId !== null) {
            this.parent.drawLayer.updateParent(this._drawId, parent.drawLayer);
            return;
        }
        this._drawingOptions.updateAll();
        this._drawId = this.#createDrawing(this.#drawOutlines, parent);
    }
    #convertToParentSpace([x, y, width, height]) {
        const { parentDimensions: [pW, pH], rotation: rotation } = this;
        switch(rotation){
            case 90:
                return [
                    y,
                    1 - x,
                    width * (pH / pW),
                    height * (pW / pH)
                ];
            case 180:
                return [
                    1 - x,
                    1 - y,
                    width,
                    height
                ];
            case 270:
                return [
                    1 - y,
                    x,
                    width * (pH / pW),
                    height * (pW / pH)
                ];
            default:
                return [
                    x,
                    y,
                    width,
                    height
                ];
        }
    }
    #convertToDrawSpace() {
        const { x: x, y: y, width: width, height: height, parentDimensions: [pW, pH], rotation: rotation } = this;
        switch(rotation){
            case 90:
                return [
                    1 - y,
                    x,
                    width * (pW / pH),
                    height * (pH / pW)
                ];
            case 180:
                return [
                    1 - x,
                    1 - y,
                    width,
                    height
                ];
            case 270:
                return [
                    y,
                    1 - x,
                    width * (pW / pH),
                    height * (pH / pW)
                ];
            default:
                return [
                    x,
                    y,
                    width,
                    height
                ];
        }
    }
    #updateBbox(bbox) {
        [this.x, this.y, this.width, this.height] = this.#convertToParentSpace(bbox);
        if (this.div) {
            this.fixAndSetPosition();
            this.setDims();
        }
        this._onResized();
    }
    #rotateBox() {
        const { x: x, y: y, width: width, height: height, rotation: rotation, parentRotation: parentRotation, parentDimensions: [pW, pH] } = this;
        switch((rotation * 4 + parentRotation) / 90){
            case 1:
                return [
                    1 - y - height,
                    x,
                    height,
                    width
                ];
            case 2:
                return [
                    1 - x - width,
                    1 - y - height,
                    width,
                    height
                ];
            case 3:
                return [
                    y,
                    1 - x - width,
                    height,
                    width
                ];
            case 4:
                return [
                    x,
                    y - width * (pW / pH),
                    height * (pH / pW),
                    width * (pW / pH)
                ];
            case 5:
                return [
                    1 - y,
                    x,
                    width * (pW / pH),
                    height * (pH / pW)
                ];
            case 6:
                return [
                    1 - x - height * (pH / pW),
                    1 - y,
                    height * (pH / pW),
                    width * (pW / pH)
                ];
            case 7:
                return [
                    y - width * (pW / pH),
                    1 - x - height * (pH / pW),
                    width * (pW / pH),
                    height * (pH / pW)
                ];
            case 8:
                return [
                    x - width,
                    y - height,
                    width,
                    height
                ];
            case 9:
                return [
                    1 - y,
                    x - width,
                    height,
                    width
                ];
            case 10:
                return [
                    1 - x,
                    1 - y,
                    width,
                    height
                ];
            case 11:
                return [
                    y - height,
                    1 - x,
                    height,
                    width
                ];
            case 12:
                return [
                    x - height * (pH / pW),
                    y,
                    height * (pH / pW),
                    width * (pW / pH)
                ];
            case 13:
                return [
                    1 - y - width * (pW / pH),
                    x - height * (pH / pW),
                    width * (pW / pH),
                    height * (pH / pW)
                ];
            case 14:
                return [
                    1 - x,
                    1 - y - width * (pW / pH),
                    height * (pH / pW),
                    width * (pW / pH)
                ];
            case 15:
                return [
                    y,
                    1 - x,
                    width * (pW / pH),
                    height * (pH / pW)
                ];
            default:
                return [
                    x,
                    y,
                    width,
                    height
                ];
        }
    }
    rotate() {
        if (!this.parent) return;
        this.parent.drawLayer.updateProperties(this._drawId, $b3a01b20dd2ade98$var$DrawingEditor._mergeSVGProperties({
            bbox: this.#rotateBox()
        }, this.#drawOutlines.updateRotation((this.parentRotation - this.rotation + 360) % 360)));
    }
    onScaleChanging() {
        if (!this.parent) return;
        this.#updateBbox(this.#drawOutlines.updateParentDimensions(this.parentDimensions, this.parent.scale));
    }
    static onScaleChangingWhenDrawing() {}
    render() {
        if (this.div) return this.div;
        let baseX, baseY;
        if (this._isCopy) {
            baseX = this.x;
            baseY = this.y;
        }
        const div = super.render();
        div.classList.add("draw");
        const drawDiv = document.createElement("div");
        div.append(drawDiv);
        drawDiv.setAttribute("aria-hidden", "true");
        drawDiv.className = "internal";
        this.setDims();
        this._uiManager.addShouldRescale(this);
        this.disableEditing();
        if (this._isCopy) this._moveAfterPaste(baseX, baseY);
        return div;
    }
    static createDrawerInstance(_x, _y, _parentWidth, _parentHeight, _rotation) {
        $b3a01b20dd2ade98$var$unreachable("Not implemented");
    }
    static startDrawing(parent, uiManager, _isLTR, event) {
        const { target: target, offsetX: x, offsetY: y, pointerId: pointerId, pointerType: pointerType } = event;
        if ($b3a01b20dd2ade98$var$CurrentPointers.isInitializedAndDifferentPointerType(pointerType)) return;
        const { viewport: { rotation: rotation } } = parent;
        const { width: parentWidth, height: parentHeight } = target.getBoundingClientRect();
        const ac = $b3a01b20dd2ade98$var$DrawingEditor.#currentDrawingAC = new AbortController();
        const signal = parent.combinedSignal(ac);
        $b3a01b20dd2ade98$var$CurrentPointers.setPointer(pointerType, pointerId);
        window.addEventListener("pointerup", (e)=>{
            if ($b3a01b20dd2ade98$var$CurrentPointers.isSamePointerIdOrRemove(e.pointerId)) this._endDraw(e);
        }, {
            signal: signal
        });
        window.addEventListener("pointercancel", (e)=>{
            if ($b3a01b20dd2ade98$var$CurrentPointers.isSamePointerIdOrRemove(e.pointerId)) this._currentParent.endDrawingSession();
        }, {
            signal: signal
        });
        window.addEventListener("pointerdown", (e)=>{
            if (!$b3a01b20dd2ade98$var$CurrentPointers.isSamePointerType(e.pointerType)) return;
            $b3a01b20dd2ade98$var$CurrentPointers.initializeAndAddPointerId(e.pointerId);
            if ($b3a01b20dd2ade98$var$DrawingEditor.#currentDraw.isCancellable()) {
                $b3a01b20dd2ade98$var$DrawingEditor.#currentDraw.removeLastElement();
                if ($b3a01b20dd2ade98$var$DrawingEditor.#currentDraw.isEmpty()) this._currentParent.endDrawingSession(true);
                else this._endDraw(null);
            }
        }, {
            capture: true,
            passive: false,
            signal: signal
        });
        window.addEventListener("contextmenu", $b3a01b20dd2ade98$export$455b7811f904cadc, {
            signal: signal
        });
        target.addEventListener("pointermove", this._drawMove.bind(this), {
            signal: signal
        });
        target.addEventListener("touchmove", (e)=>{
            if ($b3a01b20dd2ade98$var$CurrentPointers.isSameTimeStamp(e.timeStamp)) $b3a01b20dd2ade98$export$7ae4cd3a66c1e050(e);
        }, {
            signal: signal
        });
        parent.toggleDrawing();
        uiManager._editorUndoBar?.hide();
        if ($b3a01b20dd2ade98$var$DrawingEditor.#currentDraw) {
            parent.drawLayer.updateProperties(this._currentDrawId, $b3a01b20dd2ade98$var$DrawingEditor.#currentDraw.startNew(x, y, parentWidth, parentHeight, rotation));
            return;
        }
        uiManager.updateUIForDefaultProperties(this);
        $b3a01b20dd2ade98$var$DrawingEditor.#currentDraw = this.createDrawerInstance(x, y, parentWidth, parentHeight, rotation);
        $b3a01b20dd2ade98$var$DrawingEditor.#currentDrawingOptions = this.getDefaultDrawingOptions();
        this._currentParent = parent;
        ({ id: this._currentDrawId } = parent.drawLayer.draw(this._mergeSVGProperties($b3a01b20dd2ade98$var$DrawingEditor.#currentDrawingOptions.toSVGProperties(), $b3a01b20dd2ade98$var$DrawingEditor.#currentDraw.defaultSVGProperties), true, false));
    }
    static _drawMove(event) {
        $b3a01b20dd2ade98$var$CurrentPointers.isSameTimeStamp(event.timeStamp);
        if (!$b3a01b20dd2ade98$var$DrawingEditor.#currentDraw) return;
        const { offsetX: offsetX, offsetY: offsetY, pointerId: pointerId } = event;
        if (!$b3a01b20dd2ade98$var$CurrentPointers.isSamePointerId(pointerId)) return;
        if ($b3a01b20dd2ade98$var$CurrentPointers.isUsingMultiplePointers()) {
            this._endDraw(event);
            return;
        }
        this._currentParent.drawLayer.updateProperties(this._currentDrawId, $b3a01b20dd2ade98$var$DrawingEditor.#currentDraw.add(offsetX, offsetY));
        $b3a01b20dd2ade98$var$CurrentPointers.setTimeStamp(event.timeStamp);
        $b3a01b20dd2ade98$export$7ae4cd3a66c1e050(event);
    }
    static _cleanup(all) {
        if (all) {
            this._currentDrawId = -1;
            this._currentParent = null;
            $b3a01b20dd2ade98$var$DrawingEditor.#currentDraw = null;
            $b3a01b20dd2ade98$var$DrawingEditor.#currentDrawingOptions = null;
            $b3a01b20dd2ade98$var$CurrentPointers.clearTimeStamp();
        }
        if ($b3a01b20dd2ade98$var$DrawingEditor.#currentDrawingAC) {
            $b3a01b20dd2ade98$var$DrawingEditor.#currentDrawingAC.abort();
            $b3a01b20dd2ade98$var$DrawingEditor.#currentDrawingAC = null;
            $b3a01b20dd2ade98$var$CurrentPointers.clearPointerIds();
        }
    }
    static _endDraw(event) {
        const parent = this._currentParent;
        if (!parent) return;
        parent.toggleDrawing(true);
        this._cleanup(false);
        if (event?.target === parent.div) parent.drawLayer.updateProperties(this._currentDrawId, $b3a01b20dd2ade98$var$DrawingEditor.#currentDraw.end(event.offsetX, event.offsetY));
        if (this.supportMultipleDrawings) {
            const draw = $b3a01b20dd2ade98$var$DrawingEditor.#currentDraw;
            const drawId = this._currentDrawId;
            const lastElement = draw.getLastElement();
            parent.addCommands({
                cmd: ()=>{
                    parent.drawLayer.updateProperties(drawId, draw.setLastElement(lastElement));
                },
                undo: ()=>{
                    parent.drawLayer.updateProperties(drawId, draw.removeLastElement());
                },
                mustExec: false,
                type: $b3a01b20dd2ade98$export$cf3df2a6ecc26692.DRAW_STEP
            });
            return;
        }
        this.endDrawing(false);
    }
    static endDrawing(isAborted) {
        const parent = this._currentParent;
        if (!parent) return null;
        parent.toggleDrawing(true);
        parent.cleanUndoStack($b3a01b20dd2ade98$export$cf3df2a6ecc26692.DRAW_STEP);
        if (!$b3a01b20dd2ade98$var$DrawingEditor.#currentDraw.isEmpty()) {
            const { pageDimensions: [pageWidth, pageHeight], scale: scale } = parent;
            const editor = parent.createAndAddNewEditor({
                offsetX: 0,
                offsetY: 0
            }, false, {
                drawId: this._currentDrawId,
                drawOutlines: $b3a01b20dd2ade98$var$DrawingEditor.#currentDraw.getOutlines(pageWidth * scale, pageHeight * scale, scale, this._INNER_MARGIN),
                drawingOptions: $b3a01b20dd2ade98$var$DrawingEditor.#currentDrawingOptions,
                mustBeCommitted: !isAborted
            });
            this._cleanup(true);
            return editor;
        }
        parent.drawLayer.remove(this._currentDrawId);
        this._cleanup(true);
        return null;
    }
    createDrawingOptions(_data) {}
    static deserializeDraw(_pageX, _pageY, _pageWidth, _pageHeight, _innerWidth, _data) {
        $b3a01b20dd2ade98$var$unreachable("Not implemented");
    }
    static async deserialize(data, parent, uiManager) {
        const { rawDims: { pageWidth: pageWidth, pageHeight: pageHeight, pageX: pageX, pageY: pageY } } = parent.viewport;
        const drawOutlines = this.deserializeDraw(pageX, pageY, pageWidth, pageHeight, this._INNER_MARGIN, data);
        const editor = await super.deserialize(data, parent, uiManager);
        editor.createDrawingOptions(data);
        editor.#createDrawOutlines({
            drawOutlines: drawOutlines
        });
        editor.#addToDrawLayer();
        editor.onScaleChanging();
        editor.rotate();
        return editor;
    }
    serializeDraw(isForCopying) {
        const [pageX, pageY] = this.pageTranslation;
        const [pageWidth, pageHeight] = this.pageDimensions;
        return this.#drawOutlines.serialize([
            pageX,
            pageY,
            pageWidth,
            pageHeight
        ], isForCopying);
    }
    renderAnnotationElement(annotation) {
        annotation.updateEdited({
            rect: this.getPDFRect()
        });
        return null;
    }
    static canCreateNewEmptyEditor() {
        return false;
    }
}
class $b3a01b20dd2ade98$var$InkDrawOutliner {
    #last = new Float64Array(6);
    #line;
    #lines;
    #rotation;
    #thickness;
    #points;
    #lastSVGPath = "";
    #lastIndex = 0;
    #outlines = new $b3a01b20dd2ade98$var$InkDrawOutline();
    #parentWidth;
    #parentHeight;
    constructor(x, y, parentWidth, parentHeight, rotation, thickness){
        this.#parentWidth = parentWidth;
        this.#parentHeight = parentHeight;
        this.#rotation = rotation;
        this.#thickness = thickness;
        [x, y] = this.#normalizePoint(x, y);
        const line = this.#line = [
            NaN,
            NaN,
            NaN,
            NaN,
            x,
            y
        ];
        this.#points = [
            x,
            y
        ];
        this.#lines = [
            {
                line: line,
                points: this.#points
            }
        ];
        this.#last.set(line, 0);
    }
    updateProperty(name, value) {
        if (name === "stroke-width") this.#thickness = value;
    }
    #normalizePoint(x, y) {
        return $b3a01b20dd2ade98$var$Outline._normalizePoint(x, y, this.#parentWidth, this.#parentHeight, this.#rotation);
    }
    isEmpty() {
        return !this.#lines || this.#lines.length === 0;
    }
    isCancellable() {
        return this.#points.length <= 10;
    }
    add(x, y) {
        [x, y] = this.#normalizePoint(x, y);
        const [x1, y1, x2, y2] = this.#last.subarray(2, 6);
        const diffX = x - x2;
        const diffY = y - y2;
        const d = Math.hypot(this.#parentWidth * diffX, this.#parentHeight * diffY);
        if (d <= 2) return null;
        this.#points.push(x, y);
        if (isNaN(x1)) {
            this.#last.set([
                x2,
                y2,
                x,
                y
            ], 2);
            this.#line.push(NaN, NaN, NaN, NaN, x, y);
            return {
                path: {
                    d: this.toSVGPath()
                }
            };
        }
        if (isNaN(this.#last[0])) this.#line.splice(6, 6);
        this.#last.set([
            x1,
            y1,
            x2,
            y2,
            x,
            y
        ], 0);
        this.#line.push(...$b3a01b20dd2ade98$var$Outline.createBezierPoints(x1, y1, x2, y2, x, y));
        return {
            path: {
                d: this.toSVGPath()
            }
        };
    }
    end(x, y) {
        const change = this.add(x, y);
        if (change) return change;
        if (this.#points.length === 2) return {
            path: {
                d: this.toSVGPath()
            }
        };
        return null;
    }
    startNew(x, y, parentWidth, parentHeight, rotation) {
        this.#parentWidth = parentWidth;
        this.#parentHeight = parentHeight;
        this.#rotation = rotation;
        [x, y] = this.#normalizePoint(x, y);
        const line = this.#line = [
            NaN,
            NaN,
            NaN,
            NaN,
            x,
            y
        ];
        this.#points = [
            x,
            y
        ];
        const last = this.#lines.at(-1);
        if (last) {
            last.line = new Float32Array(last.line);
            last.points = new Float32Array(last.points);
        }
        this.#lines.push({
            line: line,
            points: this.#points
        });
        this.#last.set(line, 0);
        this.#lastIndex = 0;
        this.toSVGPath();
        return null;
    }
    getLastElement() {
        return this.#lines.at(-1);
    }
    setLastElement(element) {
        if (!this.#lines) return this.#outlines.setLastElement(element);
        this.#lines.push(element);
        this.#line = element.line;
        this.#points = element.points;
        this.#lastIndex = 0;
        return {
            path: {
                d: this.toSVGPath()
            }
        };
    }
    removeLastElement() {
        if (!this.#lines) return this.#outlines.removeLastElement();
        this.#lines.pop();
        this.#lastSVGPath = "";
        for(let i = 0, ii = this.#lines.length; i < ii; i++){
            const { line: line, points: points } = this.#lines[i];
            this.#line = line;
            this.#points = points;
            this.#lastIndex = 0;
            this.toSVGPath();
        }
        return {
            path: {
                d: this.#lastSVGPath
            }
        };
    }
    toSVGPath() {
        const firstX = $b3a01b20dd2ade98$var$Outline.svgRound(this.#line[4]);
        const firstY = $b3a01b20dd2ade98$var$Outline.svgRound(this.#line[5]);
        if (this.#points.length === 2) {
            this.#lastSVGPath = `${this.#lastSVGPath} M ${firstX} ${firstY} Z`;
            return this.#lastSVGPath;
        }
        if (this.#points.length <= 6) {
            const i = this.#lastSVGPath.lastIndexOf("M");
            this.#lastSVGPath = `${this.#lastSVGPath.slice(0, i)} M ${firstX} ${firstY}`;
            this.#lastIndex = 6;
        }
        if (this.#points.length === 4) {
            const secondX = $b3a01b20dd2ade98$var$Outline.svgRound(this.#line[10]);
            const secondY = $b3a01b20dd2ade98$var$Outline.svgRound(this.#line[11]);
            this.#lastSVGPath = `${this.#lastSVGPath} L ${secondX} ${secondY}`;
            this.#lastIndex = 12;
            return this.#lastSVGPath;
        }
        const buffer = [];
        if (this.#lastIndex === 0) {
            buffer.push(`M ${firstX} ${firstY}`);
            this.#lastIndex = 6;
        }
        for(let i = this.#lastIndex, ii = this.#line.length; i < ii; i += 6){
            const [c1x, c1y, c2x, c2y, x, y] = this.#line.slice(i, i + 6).map($b3a01b20dd2ade98$var$Outline.svgRound);
            buffer.push(`C${c1x} ${c1y} ${c2x} ${c2y} ${x} ${y}`);
        }
        this.#lastSVGPath += buffer.join(" ");
        this.#lastIndex = this.#line.length;
        return this.#lastSVGPath;
    }
    getOutlines(parentWidth, parentHeight, scale, innerMargin) {
        const last = this.#lines.at(-1);
        last.line = new Float32Array(last.line);
        last.points = new Float32Array(last.points);
        this.#outlines.build(this.#lines, parentWidth, parentHeight, scale, this.#rotation, this.#thickness, innerMargin);
        this.#last = null;
        this.#line = null;
        this.#lines = null;
        this.#lastSVGPath = null;
        return this.#outlines;
    }
    get defaultSVGProperties() {
        return {
            root: {
                viewBox: "0 0 10000 10000"
            },
            rootClass: {
                draw: true
            },
            bbox: [
                0,
                0,
                1,
                1
            ]
        };
    }
}
class $b3a01b20dd2ade98$var$InkDrawOutline extends $b3a01b20dd2ade98$var$Outline {
    #bbox;
    #currentRotation = 0;
    #innerMargin;
    #lines;
    #parentWidth;
    #parentHeight;
    #parentScale;
    #rotation;
    #thickness;
    build(lines, parentWidth, parentHeight, parentScale, rotation, thickness, innerMargin) {
        this.#parentWidth = parentWidth;
        this.#parentHeight = parentHeight;
        this.#parentScale = parentScale;
        this.#rotation = rotation;
        this.#thickness = thickness;
        this.#innerMargin = innerMargin ?? 0;
        this.#lines = lines;
        this.#computeBbox();
    }
    get thickness() {
        return this.#thickness;
    }
    setLastElement(element) {
        this.#lines.push(element);
        return {
            path: {
                d: this.toSVGPath()
            }
        };
    }
    removeLastElement() {
        this.#lines.pop();
        return {
            path: {
                d: this.toSVGPath()
            }
        };
    }
    toSVGPath() {
        const buffer = [];
        for (const { line: line } of this.#lines){
            buffer.push(`M${$b3a01b20dd2ade98$var$Outline.svgRound(line[4])} ${$b3a01b20dd2ade98$var$Outline.svgRound(line[5])}`);
            if (line.length === 6) {
                buffer.push("Z");
                continue;
            }
            if (line.length === 12 && isNaN(line[6])) {
                buffer.push(`L${$b3a01b20dd2ade98$var$Outline.svgRound(line[10])} ${$b3a01b20dd2ade98$var$Outline.svgRound(line[11])}`);
                continue;
            }
            for(let i = 6, ii = line.length; i < ii; i += 6){
                const [c1x, c1y, c2x, c2y, x, y] = line.subarray(i, i + 6).map($b3a01b20dd2ade98$var$Outline.svgRound);
                buffer.push(`C${c1x} ${c1y} ${c2x} ${c2y} ${x} ${y}`);
            }
        }
        return buffer.join("");
    }
    serialize([pageX, pageY, pageWidth, pageHeight], isForCopying) {
        const serializedLines = [];
        const serializedPoints = [];
        const [x, y, width, height] = this.#getBBoxWithNoMargin();
        let tx, ty, sx, sy, x1, y1, x2, y2, rescaleFn;
        switch(this.#rotation){
            case 0:
                rescaleFn = $b3a01b20dd2ade98$var$Outline._rescale;
                tx = pageX;
                ty = pageY + pageHeight;
                sx = pageWidth;
                sy = -pageHeight;
                x1 = pageX + x * pageWidth;
                y1 = pageY + (1 - y - height) * pageHeight;
                x2 = pageX + (x + width) * pageWidth;
                y2 = pageY + (1 - y) * pageHeight;
                break;
            case 90:
                rescaleFn = $b3a01b20dd2ade98$var$Outline._rescaleAndSwap;
                tx = pageX;
                ty = pageY;
                sx = pageWidth;
                sy = pageHeight;
                x1 = pageX + y * pageWidth;
                y1 = pageY + x * pageHeight;
                x2 = pageX + (y + height) * pageWidth;
                y2 = pageY + (x + width) * pageHeight;
                break;
            case 180:
                rescaleFn = $b3a01b20dd2ade98$var$Outline._rescale;
                tx = pageX + pageWidth;
                ty = pageY;
                sx = -pageWidth;
                sy = pageHeight;
                x1 = pageX + (1 - x - width) * pageWidth;
                y1 = pageY + y * pageHeight;
                x2 = pageX + (1 - x) * pageWidth;
                y2 = pageY + (y + height) * pageHeight;
                break;
            case 270:
                rescaleFn = $b3a01b20dd2ade98$var$Outline._rescaleAndSwap;
                tx = pageX + pageWidth;
                ty = pageY + pageHeight;
                sx = -pageWidth;
                sy = -pageHeight;
                x1 = pageX + (1 - y - height) * pageWidth;
                y1 = pageY + (1 - x - width) * pageHeight;
                x2 = pageX + (1 - y) * pageWidth;
                y2 = pageY + (1 - x) * pageHeight;
                break;
        }
        for (const { line: line, points: points } of this.#lines){
            serializedLines.push(rescaleFn(line, tx, ty, sx, sy, isForCopying ? new Array(line.length) : null));
            serializedPoints.push(rescaleFn(points, tx, ty, sx, sy, isForCopying ? new Array(points.length) : null));
        }
        return {
            lines: serializedLines,
            points: serializedPoints,
            rect: [
                x1,
                y1,
                x2,
                y2
            ]
        };
    }
    static deserialize(pageX, pageY, pageWidth, pageHeight, innerMargin, { paths: { lines: lines, points: points }, rotation: rotation, thickness: thickness }) {
        const newLines = [];
        let tx, ty, sx, sy, rescaleFn;
        switch(rotation){
            case 0:
                rescaleFn = $b3a01b20dd2ade98$var$Outline._rescale;
                tx = -pageX / pageWidth;
                ty = pageY / pageHeight + 1;
                sx = 1 / pageWidth;
                sy = -1 / pageHeight;
                break;
            case 90:
                rescaleFn = $b3a01b20dd2ade98$var$Outline._rescaleAndSwap;
                tx = -pageY / pageHeight;
                ty = -pageX / pageWidth;
                sx = 1 / pageHeight;
                sy = 1 / pageWidth;
                break;
            case 180:
                rescaleFn = $b3a01b20dd2ade98$var$Outline._rescale;
                tx = pageX / pageWidth + 1;
                ty = -pageY / pageHeight;
                sx = -1 / pageWidth;
                sy = 1 / pageHeight;
                break;
            case 270:
                rescaleFn = $b3a01b20dd2ade98$var$Outline._rescaleAndSwap;
                tx = pageY / pageHeight + 1;
                ty = pageX / pageWidth + 1;
                sx = -1 / pageHeight;
                sy = -1 / pageWidth;
                break;
        }
        if (!lines) {
            lines = [];
            for (const point of points){
                const len = point.length;
                if (len === 2) {
                    lines.push(new Float32Array([
                        NaN,
                        NaN,
                        NaN,
                        NaN,
                        point[0],
                        point[1]
                    ]));
                    continue;
                }
                if (len === 4) {
                    lines.push(new Float32Array([
                        NaN,
                        NaN,
                        NaN,
                        NaN,
                        point[0],
                        point[1],
                        NaN,
                        NaN,
                        NaN,
                        NaN,
                        point[2],
                        point[3]
                    ]));
                    continue;
                }
                const line = new Float32Array(3 * (len - 2));
                lines.push(line);
                let [x1, y1, x2, y2] = point.subarray(0, 4);
                line.set([
                    NaN,
                    NaN,
                    NaN,
                    NaN,
                    x1,
                    y1
                ], 0);
                for(let i = 4; i < len; i += 2){
                    const x = point[i];
                    const y = point[i + 1];
                    line.set($b3a01b20dd2ade98$var$Outline.createBezierPoints(x1, y1, x2, y2, x, y), (i - 2) * 3);
                    [x1, y1, x2, y2] = [
                        x2,
                        y2,
                        x,
                        y
                    ];
                }
            }
        }
        for(let i = 0, ii = lines.length; i < ii; i++)newLines.push({
            line: rescaleFn(lines[i].map((x)=>x ?? NaN), tx, ty, sx, sy),
            points: rescaleFn(points[i].map((x)=>x ?? NaN), tx, ty, sx, sy)
        });
        const outlines = new this.prototype.constructor();
        outlines.build(newLines, pageWidth, pageHeight, 1, rotation, thickness, innerMargin);
        return outlines;
    }
    #getMarginComponents(thickness = this.#thickness) {
        const margin = this.#innerMargin + thickness / 2 * this.#parentScale;
        return this.#rotation % 180 === 0 ? [
            margin / this.#parentWidth,
            margin / this.#parentHeight
        ] : [
            margin / this.#parentHeight,
            margin / this.#parentWidth
        ];
    }
    #getBBoxWithNoMargin() {
        const [x, y, width, height] = this.#bbox;
        const [marginX, marginY] = this.#getMarginComponents(0);
        return [
            x + marginX,
            y + marginY,
            width - 2 * marginX,
            height - 2 * marginY
        ];
    }
    #computeBbox() {
        const bbox = this.#bbox = new Float32Array([
            Infinity,
            Infinity,
            -Infinity,
            -Infinity
        ]);
        for (const { line: line } of this.#lines){
            if (line.length <= 12) {
                for(let i = 4, ii = line.length; i < ii; i += 6)$b3a01b20dd2ade98$export$f8f26dd395d7e1bd.pointBoundingBox(line[i], line[i + 1], bbox);
                continue;
            }
            let lastX = line[4], lastY = line[5];
            for(let i = 6, ii = line.length; i < ii; i += 6){
                const [c1x, c1y, c2x, c2y, x, y] = line.subarray(i, i + 6);
                $b3a01b20dd2ade98$export$f8f26dd395d7e1bd.bezierBoundingBox(lastX, lastY, c1x, c1y, c2x, c2y, x, y, bbox);
                lastX = x;
                lastY = y;
            }
        }
        const [marginX, marginY] = this.#getMarginComponents();
        bbox[0] = $b3a01b20dd2ade98$export$b8106b171181a554(bbox[0] - marginX, 0, 1);
        bbox[1] = $b3a01b20dd2ade98$export$b8106b171181a554(bbox[1] - marginY, 0, 1);
        bbox[2] = $b3a01b20dd2ade98$export$b8106b171181a554(bbox[2] + marginX, 0, 1);
        bbox[3] = $b3a01b20dd2ade98$export$b8106b171181a554(bbox[3] + marginY, 0, 1);
        bbox[2] -= bbox[0];
        bbox[3] -= bbox[1];
    }
    get box() {
        return this.#bbox;
    }
    updateProperty(name, value) {
        if (name === "stroke-width") return this.#updateThickness(value);
        return null;
    }
    #updateThickness(thickness) {
        const [oldMarginX, oldMarginY] = this.#getMarginComponents();
        this.#thickness = thickness;
        const [newMarginX, newMarginY] = this.#getMarginComponents();
        const [diffMarginX, diffMarginY] = [
            newMarginX - oldMarginX,
            newMarginY - oldMarginY
        ];
        const bbox = this.#bbox;
        bbox[0] -= diffMarginX;
        bbox[1] -= diffMarginY;
        bbox[2] += 2 * diffMarginX;
        bbox[3] += 2 * diffMarginY;
        return bbox;
    }
    updateParentDimensions([width, height], scale) {
        const [oldMarginX, oldMarginY] = this.#getMarginComponents();
        this.#parentWidth = width;
        this.#parentHeight = height;
        this.#parentScale = scale;
        const [newMarginX, newMarginY] = this.#getMarginComponents();
        const diffMarginX = newMarginX - oldMarginX;
        const diffMarginY = newMarginY - oldMarginY;
        const bbox = this.#bbox;
        bbox[0] -= diffMarginX;
        bbox[1] -= diffMarginY;
        bbox[2] += 2 * diffMarginX;
        bbox[3] += 2 * diffMarginY;
        return bbox;
    }
    updateRotation(rotation) {
        this.#currentRotation = rotation;
        return {
            path: {
                transform: this.rotationTransform
            }
        };
    }
    get viewBox() {
        return this.#bbox.map($b3a01b20dd2ade98$var$Outline.svgRound).join(" ");
    }
    get defaultProperties() {
        const [x, y] = this.#bbox;
        return {
            root: {
                viewBox: this.viewBox
            },
            path: {
                "transform-origin": `${$b3a01b20dd2ade98$var$Outline.svgRound(x)} ${$b3a01b20dd2ade98$var$Outline.svgRound(y)}`
            }
        };
    }
    get rotationTransform() {
        const [, , width, height] = this.#bbox;
        let a = 0, b = 0, c = 0, d = 0, e = 0, f = 0;
        switch(this.#currentRotation){
            case 90:
                b = height / width;
                c = -width / height;
                e = width;
                break;
            case 180:
                a = -1;
                d = -1;
                e = width;
                f = height;
                break;
            case 270:
                b = -height / width;
                c = width / height;
                f = height;
                break;
            default:
                return "";
        }
        return `matrix(${a} ${b} ${c} ${d} ${$b3a01b20dd2ade98$var$Outline.svgRound(e)} ${$b3a01b20dd2ade98$var$Outline.svgRound(f)})`;
    }
    getPathResizingSVGProperties([newX, newY, newWidth, newHeight]) {
        const [marginX, marginY] = this.#getMarginComponents();
        const [x, y, width, height] = this.#bbox;
        if (Math.abs(width - marginX) <= $b3a01b20dd2ade98$var$Outline.PRECISION || Math.abs(height - marginY) <= $b3a01b20dd2ade98$var$Outline.PRECISION) {
            const tx = newX + newWidth / 2 - (x + width / 2);
            const ty = newY + newHeight / 2 - (y + height / 2);
            return {
                path: {
                    "transform-origin": `${$b3a01b20dd2ade98$var$Outline.svgRound(newX)} ${$b3a01b20dd2ade98$var$Outline.svgRound(newY)}`,
                    transform: `${this.rotationTransform} translate(${tx} ${ty})`
                }
            };
        }
        const s1x = (newWidth - 2 * marginX) / (width - 2 * marginX);
        const s1y = (newHeight - 2 * marginY) / (height - 2 * marginY);
        const s2x = width / newWidth;
        const s2y = height / newHeight;
        return {
            path: {
                "transform-origin": `${$b3a01b20dd2ade98$var$Outline.svgRound(x)} ${$b3a01b20dd2ade98$var$Outline.svgRound(y)}`,
                transform: `${this.rotationTransform} scale(${s2x} ${s2y}) ` + `translate(${$b3a01b20dd2ade98$var$Outline.svgRound(marginX)} ${$b3a01b20dd2ade98$var$Outline.svgRound(marginY)}) scale(${s1x} ${s1y}) ` + `translate(${$b3a01b20dd2ade98$var$Outline.svgRound(-marginX)} ${$b3a01b20dd2ade98$var$Outline.svgRound(-marginY)})`
            }
        };
    }
    getPathResizedSVGProperties([newX, newY, newWidth, newHeight]) {
        const [marginX, marginY] = this.#getMarginComponents();
        const bbox = this.#bbox;
        const [x, y, width, height] = bbox;
        bbox[0] = newX;
        bbox[1] = newY;
        bbox[2] = newWidth;
        bbox[3] = newHeight;
        if (Math.abs(width - marginX) <= $b3a01b20dd2ade98$var$Outline.PRECISION || Math.abs(height - marginY) <= $b3a01b20dd2ade98$var$Outline.PRECISION) {
            const tx = newX + newWidth / 2 - (x + width / 2);
            const ty = newY + newHeight / 2 - (y + height / 2);
            for (const { line: line, points: points } of this.#lines){
                $b3a01b20dd2ade98$var$Outline._translate(line, tx, ty, line);
                $b3a01b20dd2ade98$var$Outline._translate(points, tx, ty, points);
            }
            return {
                root: {
                    viewBox: this.viewBox
                },
                path: {
                    "transform-origin": `${$b3a01b20dd2ade98$var$Outline.svgRound(newX)} ${$b3a01b20dd2ade98$var$Outline.svgRound(newY)}`,
                    transform: this.rotationTransform || null,
                    d: this.toSVGPath()
                }
            };
        }
        const s1x = (newWidth - 2 * marginX) / (width - 2 * marginX);
        const s1y = (newHeight - 2 * marginY) / (height - 2 * marginY);
        const tx = -s1x * (x + marginX) + newX + marginX;
        const ty = -s1y * (y + marginY) + newY + marginY;
        if (s1x !== 1 || s1y !== 1 || tx !== 0 || ty !== 0) for (const { line: line, points: points } of this.#lines){
            $b3a01b20dd2ade98$var$Outline._rescale(line, tx, ty, s1x, s1y, line);
            $b3a01b20dd2ade98$var$Outline._rescale(points, tx, ty, s1x, s1y, points);
        }
        return {
            root: {
                viewBox: this.viewBox
            },
            path: {
                "transform-origin": `${$b3a01b20dd2ade98$var$Outline.svgRound(newX)} ${$b3a01b20dd2ade98$var$Outline.svgRound(newY)}`,
                transform: this.rotationTransform || null,
                d: this.toSVGPath()
            }
        };
    }
    getPathTranslatedSVGProperties([newX, newY], parentDimensions) {
        const [newParentWidth, newParentHeight] = parentDimensions;
        const bbox = this.#bbox;
        const tx = newX - bbox[0];
        const ty = newY - bbox[1];
        if (this.#parentWidth === newParentWidth && this.#parentHeight === newParentHeight) for (const { line: line, points: points } of this.#lines){
            $b3a01b20dd2ade98$var$Outline._translate(line, tx, ty, line);
            $b3a01b20dd2ade98$var$Outline._translate(points, tx, ty, points);
        }
        else {
            const sx = this.#parentWidth / newParentWidth;
            const sy = this.#parentHeight / newParentHeight;
            this.#parentWidth = newParentWidth;
            this.#parentHeight = newParentHeight;
            for (const { line: line, points: points } of this.#lines){
                $b3a01b20dd2ade98$var$Outline._rescale(line, tx, ty, sx, sy, line);
                $b3a01b20dd2ade98$var$Outline._rescale(points, tx, ty, sx, sy, points);
            }
            bbox[2] *= sx;
            bbox[3] *= sy;
        }
        bbox[0] = newX;
        bbox[1] = newY;
        return {
            root: {
                viewBox: this.viewBox
            },
            path: {
                d: this.toSVGPath(),
                "transform-origin": `${$b3a01b20dd2ade98$var$Outline.svgRound(newX)} ${$b3a01b20dd2ade98$var$Outline.svgRound(newY)}`
            }
        };
    }
    get defaultSVGProperties() {
        const bbox = this.#bbox;
        return {
            root: {
                viewBox: this.viewBox
            },
            rootClass: {
                draw: true
            },
            path: {
                d: this.toSVGPath(),
                "transform-origin": `${$b3a01b20dd2ade98$var$Outline.svgRound(bbox[0])} ${$b3a01b20dd2ade98$var$Outline.svgRound(bbox[1])}`,
                transform: this.rotationTransform || null
            },
            bbox: bbox
        };
    }
}
class $b3a01b20dd2ade98$var$InkDrawingOptions extends $b3a01b20dd2ade98$var$DrawingOptions {
    constructor(viewerParameters){
        super();
        this._viewParameters = viewerParameters;
        super.updateProperties({
            fill: "none",
            stroke: $b3a01b20dd2ade98$var$AnnotationEditor._defaultLineColor,
            "stroke-opacity": 1,
            "stroke-width": 1,
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-miterlimit": 10
        });
    }
    updateSVGProperty(name, value) {
        if (name === "stroke-width") {
            value ??= this["stroke-width"];
            value *= this._viewParameters.realScale;
        }
        super.updateSVGProperty(name, value);
    }
    clone() {
        const clone = new $b3a01b20dd2ade98$var$InkDrawingOptions(this._viewParameters);
        clone.updateAll(this);
        return clone;
    }
}
class $b3a01b20dd2ade98$var$InkEditor extends $b3a01b20dd2ade98$var$DrawingEditor {
    static _type = "ink";
    static _editorType = $b3a01b20dd2ade98$export$72ea3bfdd9a725bf.INK;
    static _defaultDrawingOptions = null;
    constructor(params){
        super({
            ...params,
            name: "inkEditor"
        });
        this._willKeepAspectRatio = true;
        this.defaultL10nId = "pdfjs-editor-ink-editor";
    }
    static initialize(l10n, uiManager) {
        $b3a01b20dd2ade98$var$AnnotationEditor.initialize(l10n, uiManager);
        this._defaultDrawingOptions = new $b3a01b20dd2ade98$var$InkDrawingOptions(uiManager.viewParameters);
    }
    static getDefaultDrawingOptions(options) {
        const clone = this._defaultDrawingOptions.clone();
        clone.updateProperties(options);
        return clone;
    }
    static get supportMultipleDrawings() {
        return true;
    }
    static get typesMap() {
        return $b3a01b20dd2ade98$export$b8972b998723d602(this, "typesMap", new Map([
            [
                $b3a01b20dd2ade98$export$cf3df2a6ecc26692.INK_THICKNESS,
                "stroke-width"
            ],
            [
                $b3a01b20dd2ade98$export$cf3df2a6ecc26692.INK_COLOR,
                "stroke"
            ],
            [
                $b3a01b20dd2ade98$export$cf3df2a6ecc26692.INK_OPACITY,
                "stroke-opacity"
            ]
        ]));
    }
    static createDrawerInstance(x, y, parentWidth, parentHeight, rotation) {
        return new $b3a01b20dd2ade98$var$InkDrawOutliner(x, y, parentWidth, parentHeight, rotation, this._defaultDrawingOptions["stroke-width"]);
    }
    static deserializeDraw(pageX, pageY, pageWidth, pageHeight, innerMargin, data) {
        return $b3a01b20dd2ade98$var$InkDrawOutline.deserialize(pageX, pageY, pageWidth, pageHeight, innerMargin, data);
    }
    static async deserialize(data, parent, uiManager) {
        let initialData = null;
        if (data instanceof $b3a01b20dd2ade98$var$InkAnnotationElement) {
            const { data: { inkLists: inkLists, rect: rect, rotation: rotation, id: id, color: color, opacity: opacity, borderStyle: { rawWidth: thickness }, popupRef: popupRef, richText: richText, contentsObj: contentsObj, creationDate: creationDate, modificationDate: modificationDate }, parent: { page: { pageNumber: pageNumber } } } = data;
            initialData = data = {
                annotationType: $b3a01b20dd2ade98$export$72ea3bfdd9a725bf.INK,
                color: Array.from(color),
                thickness: thickness,
                opacity: opacity,
                paths: {
                    points: inkLists
                },
                boxes: null,
                pageIndex: pageNumber - 1,
                rect: rect.slice(0),
                rotation: rotation,
                annotationElementId: id,
                id: id,
                deleted: false,
                popupRef: popupRef,
                richText: richText,
                comment: contentsObj?.str || null,
                creationDate: creationDate,
                modificationDate: modificationDate
            };
        }
        const editor = await super.deserialize(data, parent, uiManager);
        editor._initialData = initialData;
        if (data.comment) editor.setCommentData(data);
        return editor;
    }
    get toolbarButtons() {
        this._colorPicker ||= new $b3a01b20dd2ade98$var$BasicColorPicker(this);
        return [
            [
                "colorPicker",
                this._colorPicker
            ]
        ];
    }
    get colorType() {
        return $b3a01b20dd2ade98$export$cf3df2a6ecc26692.INK_COLOR;
    }
    get color() {
        return this._drawingOptions.stroke;
    }
    get opacity() {
        return this._drawingOptions["stroke-opacity"];
    }
    onScaleChanging() {
        if (!this.parent) return;
        super.onScaleChanging();
        const { _drawId: _drawId, _drawingOptions: _drawingOptions, parent: parent } = this;
        _drawingOptions.updateSVGProperty("stroke-width");
        parent.drawLayer.updateProperties(_drawId, _drawingOptions.toSVGProperties());
    }
    static onScaleChangingWhenDrawing() {
        const parent = this._currentParent;
        if (!parent) return;
        super.onScaleChangingWhenDrawing();
        this._defaultDrawingOptions.updateSVGProperty("stroke-width");
        parent.drawLayer.updateProperties(this._currentDrawId, this._defaultDrawingOptions.toSVGProperties());
    }
    createDrawingOptions({ color: color, thickness: thickness, opacity: opacity }) {
        this._drawingOptions = $b3a01b20dd2ade98$var$InkEditor.getDefaultDrawingOptions({
            stroke: $b3a01b20dd2ade98$export$f8f26dd395d7e1bd.makeHexColor(...color),
            "stroke-width": thickness,
            "stroke-opacity": opacity
        });
    }
    serialize(isForCopying = false) {
        if (this.isEmpty()) return null;
        if (this.deleted) return this.serializeDeleted();
        const { lines: lines, points: points } = this.serializeDraw(isForCopying);
        const { _drawingOptions: { stroke: stroke, "stroke-opacity": opacity, "stroke-width": thickness } } = this;
        const serialized = Object.assign(super.serialize(isForCopying), {
            color: $b3a01b20dd2ade98$var$AnnotationEditor._colorManager.convert(stroke),
            opacity: opacity,
            thickness: thickness,
            paths: {
                lines: lines,
                points: points
            }
        });
        this.addComment(serialized);
        if (isForCopying) {
            serialized.isCopy = true;
            return serialized;
        }
        if (this.annotationElementId && !this.#hasElementChanged(serialized)) return null;
        serialized.id = this.annotationElementId;
        return serialized;
    }
    #hasElementChanged(serialized) {
        const { color: color, thickness: thickness, opacity: opacity, pageIndex: pageIndex } = this._initialData;
        return this.hasEditedComment || this._hasBeenMoved || this._hasBeenResized || serialized.color.some((c, i)=>c !== color[i]) || serialized.thickness !== thickness || serialized.opacity !== opacity || serialized.pageIndex !== pageIndex;
    }
    renderAnnotationElement(annotation) {
        if (this.deleted) {
            annotation.hide();
            return null;
        }
        const { points: points, rect: rect } = this.serializeDraw(false);
        annotation.updateEdited({
            rect: rect,
            thickness: this._drawingOptions["stroke-width"],
            points: points,
            popup: this.comment
        });
        return null;
    }
}
class $b3a01b20dd2ade98$var$ContourDrawOutline extends $b3a01b20dd2ade98$var$InkDrawOutline {
    toSVGPath() {
        let path = super.toSVGPath();
        if (!path.endsWith("Z")) path += "Z";
        return path;
    }
}
const $b3a01b20dd2ade98$var$BASE_HEADER_LENGTH = 8;
const $b3a01b20dd2ade98$var$POINTS_PROPERTIES_NUMBER = 3;
class $b3a01b20dd2ade98$export$cc4fe8633f466b4a {
    static #PARAMETERS = {
        maxDim: 512,
        sigmaSFactor: 0.02,
        sigmaR: 25,
        kernelSize: 16
    };
    static #neighborIndexToId(i0, j0, i, j) {
        i -= i0;
        j -= j0;
        if (i === 0) return j > 0 ? 0 : 4;
        if (i === 1) return j + 6;
        return 2 - j;
    }
    static #neighborIdToIndex = new Int32Array([
        0,
        1,
        -1,
        1,
        -1,
        0,
        -1,
        -1,
        0,
        -1,
        1,
        -1,
        1,
        0,
        1,
        1
    ]);
    static #clockwiseNonZero(buf, width, i0, j0, i, j, offset) {
        const id = this.#neighborIndexToId(i0, j0, i, j);
        for(let k = 0; k < 8; k++){
            const kk = (-k + id - offset + 16) % 8;
            const shiftI = this.#neighborIdToIndex[2 * kk];
            const shiftJ = this.#neighborIdToIndex[2 * kk + 1];
            if (buf[(i0 + shiftI) * width + (j0 + shiftJ)] !== 0) return kk;
        }
        return -1;
    }
    static #counterClockwiseNonZero(buf, width, i0, j0, i, j, offset) {
        const id = this.#neighborIndexToId(i0, j0, i, j);
        for(let k = 0; k < 8; k++){
            const kk = (k + id + offset + 16) % 8;
            const shiftI = this.#neighborIdToIndex[2 * kk];
            const shiftJ = this.#neighborIdToIndex[2 * kk + 1];
            if (buf[(i0 + shiftI) * width + (j0 + shiftJ)] !== 0) return kk;
        }
        return -1;
    }
    static #findContours(buf, width, height, threshold) {
        const N = buf.length;
        const types = new Int32Array(N);
        for(let i = 0; i < N; i++)types[i] = buf[i] <= threshold ? 1 : 0;
        for(let i = 1; i < height - 1; i++)types[i * width] = types[i * width + width - 1] = 0;
        for(let i = 0; i < width; i++)types[i] = types[width * height - 1 - i] = 0;
        let nbd = 1;
        let lnbd;
        const contours = [];
        for(let i = 1; i < height - 1; i++){
            lnbd = 1;
            for(let j = 1; j < width - 1; j++){
                const ij = i * width + j;
                const pix = types[ij];
                if (pix === 0) continue;
                let i2 = i;
                let j2 = j;
                if (pix === 1 && types[ij - 1] === 0) {
                    nbd += 1;
                    j2 -= 1;
                } else if (pix >= 1 && types[ij + 1] === 0) {
                    nbd += 1;
                    j2 += 1;
                    if (pix > 1) lnbd = pix;
                } else {
                    if (pix !== 1) lnbd = Math.abs(pix);
                    continue;
                }
                const points = [
                    j,
                    i
                ];
                const isHole = j2 === j + 1;
                const contour = {
                    isHole: isHole,
                    points: points,
                    id: nbd,
                    parent: 0
                };
                contours.push(contour);
                let contour0;
                for (const c of contours)if (c.id === lnbd) {
                    contour0 = c;
                    break;
                }
                if (!contour0) contour.parent = isHole ? lnbd : 0;
                else if (contour0.isHole) contour.parent = isHole ? contour0.parent : lnbd;
                else contour.parent = isHole ? lnbd : contour0.parent;
                const k = this.#clockwiseNonZero(types, width, i, j, i2, j2, 0);
                if (k === -1) {
                    types[ij] = -nbd;
                    if (types[ij] !== 1) lnbd = Math.abs(types[ij]);
                    continue;
                }
                let shiftI = this.#neighborIdToIndex[2 * k];
                let shiftJ = this.#neighborIdToIndex[2 * k + 1];
                const i1 = i + shiftI;
                const j1 = j + shiftJ;
                i2 = i1;
                j2 = j1;
                let i3 = i;
                let j3 = j;
                while(true){
                    const kk = this.#counterClockwiseNonZero(types, width, i3, j3, i2, j2, 1);
                    shiftI = this.#neighborIdToIndex[2 * kk];
                    shiftJ = this.#neighborIdToIndex[2 * kk + 1];
                    const i4 = i3 + shiftI;
                    const j4 = j3 + shiftJ;
                    points.push(j4, i4);
                    const ij3 = i3 * width + j3;
                    if (types[ij3 + 1] === 0) types[ij3] = -nbd;
                    else if (types[ij3] === 1) types[ij3] = nbd;
                    if (i4 === i && j4 === j && i3 === i1 && j3 === j1) {
                        if (types[ij] !== 1) lnbd = Math.abs(types[ij]);
                        break;
                    } else {
                        i2 = i3;
                        j2 = j3;
                        i3 = i4;
                        j3 = j4;
                    }
                }
            }
        }
        return contours;
    }
    static #douglasPeuckerHelper(points, start, end, output) {
        if (end - start <= 4) {
            for(let i = start; i < end - 2; i += 2)output.push(points[i], points[i + 1]);
            return;
        }
        const ax = points[start];
        const ay = points[start + 1];
        const abx = points[end - 4] - ax;
        const aby = points[end - 3] - ay;
        const dist = Math.hypot(abx, aby);
        const nabx = abx / dist;
        const naby = aby / dist;
        const aa = nabx * ay - naby * ax;
        const m = aby / abx;
        const invS = 1 / dist;
        const phi = Math.atan(m);
        const cosPhi = Math.cos(phi);
        const sinPhi = Math.sin(phi);
        const tmax = invS * (Math.abs(cosPhi) + Math.abs(sinPhi));
        const poly = invS * (1 - tmax + tmax ** 2);
        const partialPhi = Math.max(Math.atan(Math.abs(sinPhi + cosPhi) * poly), Math.atan(Math.abs(sinPhi - cosPhi) * poly));
        let dmax = 0;
        let index = start;
        for(let i = start + 2; i < end - 2; i += 2){
            const d = Math.abs(aa - nabx * points[i + 1] + naby * points[i]);
            if (d > dmax) {
                index = i;
                dmax = d;
            }
        }
        if (dmax > (dist * partialPhi) ** 2) {
            this.#douglasPeuckerHelper(points, start, index + 2, output);
            this.#douglasPeuckerHelper(points, index, end, output);
        } else output.push(ax, ay);
    }
    static #douglasPeucker(points) {
        const output = [];
        const len = points.length;
        this.#douglasPeuckerHelper(points, 0, len, output);
        output.push(points[len - 2], points[len - 1]);
        return output.length <= 4 ? null : output;
    }
    static #bilateralFilter(buf, width, height, sigmaS, sigmaR, kernelSize) {
        const kernel = new Float32Array(kernelSize ** 2);
        const sigmaS2 = -2 * sigmaS ** 2;
        const halfSize = kernelSize >> 1;
        for(let i = 0; i < kernelSize; i++){
            const x = (i - halfSize) ** 2;
            for(let j = 0; j < kernelSize; j++)kernel[i * kernelSize + j] = Math.exp((x + (j - halfSize) ** 2) / sigmaS2);
        }
        const rangeValues = new Float32Array(256);
        const sigmaR2 = -2 * sigmaR ** 2;
        for(let i = 0; i < 256; i++)rangeValues[i] = Math.exp(i ** 2 / sigmaR2);
        const N = buf.length;
        const out = new Uint8Array(N);
        const histogram = new Uint32Array(256);
        for(let i = 0; i < height; i++)for(let j = 0; j < width; j++){
            const ij = i * width + j;
            const center = buf[ij];
            let sum = 0;
            let norm = 0;
            for(let k = 0; k < kernelSize; k++){
                const y = i + k - halfSize;
                if (y < 0 || y >= height) continue;
                for(let l = 0; l < kernelSize; l++){
                    const x = j + l - halfSize;
                    if (x < 0 || x >= width) continue;
                    const neighbour = buf[y * width + x];
                    const w = kernel[k * kernelSize + l] * rangeValues[Math.abs(neighbour - center)];
                    sum += neighbour * w;
                    norm += w;
                }
            }
            const pix = out[ij] = Math.round(sum / norm);
            histogram[pix]++;
        }
        return [
            out,
            histogram
        ];
    }
    static #getHistogram(buf) {
        const histogram = new Uint32Array(256);
        for (const g of buf)histogram[g]++;
        return histogram;
    }
    static #toUint8(buf) {
        const N = buf.length;
        const out = new Uint8ClampedArray(N >> 2);
        let max = -Infinity;
        let min = Infinity;
        for(let i = 0, ii = out.length; i < ii; i++){
            const pix = out[i] = buf[i << 2];
            max = Math.max(max, pix);
            min = Math.min(min, pix);
        }
        const ratio = 255 / (max - min);
        for(let i = 0, ii = out.length; i < ii; i++)out[i] = (out[i] - min) * ratio;
        return out;
    }
    static #guessThreshold(histogram) {
        let i;
        let M = -Infinity;
        let L = -Infinity;
        const min = histogram.findIndex((v)=>v !== 0);
        let pos = min;
        let spos = min;
        for(i = min; i < 256; i++){
            const v = histogram[i];
            if (v > M) {
                if (i - pos > L) {
                    L = i - pos;
                    spos = i - 1;
                }
                M = v;
                pos = i;
            }
        }
        for(i = spos - 1; i >= 0; i--){
            if (histogram[i] > histogram[i + 1]) break;
        }
        return i;
    }
    static #getGrayPixels(bitmap) {
        const originalBitmap = bitmap;
        const { width: width, height: height } = bitmap;
        const { maxDim: maxDim } = this.#PARAMETERS;
        let newWidth = width;
        let newHeight = height;
        if (width > maxDim || height > maxDim) {
            let prevWidth = width;
            let prevHeight = height;
            let steps = Math.log2(Math.max(width, height) / maxDim);
            const isteps = Math.floor(steps);
            steps = steps === isteps ? isteps - 1 : isteps;
            for(let i = 0; i < steps; i++){
                newWidth = Math.ceil(prevWidth / 2);
                newHeight = Math.ceil(prevHeight / 2);
                const offscreen = new OffscreenCanvas(newWidth, newHeight);
                const ctx = offscreen.getContext("2d");
                ctx.drawImage(bitmap, 0, 0, prevWidth, prevHeight, 0, 0, newWidth, newHeight);
                prevWidth = newWidth;
                prevHeight = newHeight;
                if (bitmap !== originalBitmap) bitmap.close();
                bitmap = offscreen.transferToImageBitmap();
            }
            const ratio = Math.min(maxDim / newWidth, maxDim / newHeight);
            newWidth = Math.round(newWidth * ratio);
            newHeight = Math.round(newHeight * ratio);
        }
        const offscreen = new OffscreenCanvas(newWidth, newHeight);
        const ctx = offscreen.getContext("2d", {
            willReadFrequently: true
        });
        ctx.fillStyle = "white";
        ctx.fillRect(0, 0, newWidth, newHeight);
        ctx.filter = "grayscale(1)";
        ctx.drawImage(bitmap, 0, 0, bitmap.width, bitmap.height, 0, 0, newWidth, newHeight);
        const grayImage = ctx.getImageData(0, 0, newWidth, newHeight).data;
        const uint8Buf = this.#toUint8(grayImage);
        return [
            uint8Buf,
            newWidth,
            newHeight
        ];
    }
    static extractContoursFromText(text, { fontFamily: fontFamily, fontStyle: fontStyle, fontWeight: fontWeight }, pageWidth, pageHeight, rotation, innerMargin) {
        let canvas = new OffscreenCanvas(1, 1);
        let ctx = canvas.getContext("2d", {
            alpha: false
        });
        const fontSize = 200;
        const font = ctx.font = `${fontStyle} ${fontWeight} ${fontSize}px ${fontFamily}`;
        const { actualBoundingBoxLeft: actualBoundingBoxLeft, actualBoundingBoxRight: actualBoundingBoxRight, actualBoundingBoxAscent: actualBoundingBoxAscent, actualBoundingBoxDescent: actualBoundingBoxDescent, fontBoundingBoxAscent: fontBoundingBoxAscent, fontBoundingBoxDescent: fontBoundingBoxDescent, width: width } = ctx.measureText(text);
        const SCALE = 1.5;
        const canvasWidth = Math.ceil(Math.max(Math.abs(actualBoundingBoxLeft) + Math.abs(actualBoundingBoxRight) || 0, width) * SCALE);
        const canvasHeight = Math.ceil(Math.max(Math.abs(actualBoundingBoxAscent) + Math.abs(actualBoundingBoxDescent) || fontSize, Math.abs(fontBoundingBoxAscent) + Math.abs(fontBoundingBoxDescent) || fontSize) * SCALE);
        canvas = new OffscreenCanvas(canvasWidth, canvasHeight);
        ctx = canvas.getContext("2d", {
            alpha: true,
            willReadFrequently: true
        });
        ctx.font = font;
        ctx.filter = "grayscale(1)";
        ctx.fillStyle = "white";
        ctx.fillRect(0, 0, canvasWidth, canvasHeight);
        ctx.fillStyle = "black";
        ctx.fillText(text, canvasWidth * (SCALE - 1) / 2, canvasHeight * (3 - SCALE) / 2);
        const uint8Buf = this.#toUint8(ctx.getImageData(0, 0, canvasWidth, canvasHeight).data);
        const histogram = this.#getHistogram(uint8Buf);
        const threshold = this.#guessThreshold(histogram);
        const contourList = this.#findContours(uint8Buf, canvasWidth, canvasHeight, threshold);
        return this.processDrawnLines({
            lines: {
                curves: contourList,
                width: canvasWidth,
                height: canvasHeight
            },
            pageWidth: pageWidth,
            pageHeight: pageHeight,
            rotation: rotation,
            innerMargin: innerMargin,
            mustSmooth: true,
            areContours: true
        });
    }
    static process(bitmap, pageWidth, pageHeight, rotation, innerMargin) {
        const [uint8Buf, width, height] = this.#getGrayPixels(bitmap);
        const [buffer, histogram] = this.#bilateralFilter(uint8Buf, width, height, Math.hypot(width, height) * this.#PARAMETERS.sigmaSFactor, this.#PARAMETERS.sigmaR, this.#PARAMETERS.kernelSize);
        const threshold = this.#guessThreshold(histogram);
        const contourList = this.#findContours(buffer, width, height, threshold);
        return this.processDrawnLines({
            lines: {
                curves: contourList,
                width: width,
                height: height
            },
            pageWidth: pageWidth,
            pageHeight: pageHeight,
            rotation: rotation,
            innerMargin: innerMargin,
            mustSmooth: true,
            areContours: true
        });
    }
    static processDrawnLines({ lines: lines, pageWidth: pageWidth, pageHeight: pageHeight, rotation: rotation, innerMargin: innerMargin, mustSmooth: mustSmooth, areContours: areContours }) {
        if (rotation % 180 !== 0) [pageWidth, pageHeight] = [
            pageHeight,
            pageWidth
        ];
        const { curves: curves, width: width, height: height } = lines;
        const thickness = lines.thickness ?? 0;
        const linesAndPoints = [];
        const ratio = Math.min(pageWidth / width, pageHeight / height);
        const xScale = ratio / pageWidth;
        const yScale = ratio / pageHeight;
        const newCurves = [];
        for (const { points: points } of curves){
            const reducedPoints = mustSmooth ? this.#douglasPeucker(points) : points;
            if (!reducedPoints) continue;
            newCurves.push(reducedPoints);
            const len = reducedPoints.length;
            const newPoints = new Float32Array(len);
            const line = new Float32Array(3 * (len === 2 ? 2 : len - 2));
            linesAndPoints.push({
                line: line,
                points: newPoints
            });
            if (len === 2) {
                newPoints[0] = reducedPoints[0] * xScale;
                newPoints[1] = reducedPoints[1] * yScale;
                line.set([
                    NaN,
                    NaN,
                    NaN,
                    NaN,
                    newPoints[0],
                    newPoints[1]
                ], 0);
                continue;
            }
            let [x1, y1, x2, y2] = reducedPoints;
            x1 *= xScale;
            y1 *= yScale;
            x2 *= xScale;
            y2 *= yScale;
            newPoints.set([
                x1,
                y1,
                x2,
                y2
            ], 0);
            line.set([
                NaN,
                NaN,
                NaN,
                NaN,
                x1,
                y1
            ], 0);
            for(let i = 4; i < len; i += 2){
                const x = newPoints[i] = reducedPoints[i] * xScale;
                const y = newPoints[i + 1] = reducedPoints[i + 1] * yScale;
                line.set($b3a01b20dd2ade98$var$Outline.createBezierPoints(x1, y1, x2, y2, x, y), (i - 2) * 3);
                [x1, y1, x2, y2] = [
                    x2,
                    y2,
                    x,
                    y
                ];
            }
        }
        if (linesAndPoints.length === 0) return null;
        const outline = areContours ? new $b3a01b20dd2ade98$var$ContourDrawOutline() : new $b3a01b20dd2ade98$var$InkDrawOutline();
        outline.build(linesAndPoints, pageWidth, pageHeight, 1, rotation, areContours ? 0 : thickness, innerMargin);
        return {
            outline: outline,
            newCurves: newCurves,
            areContours: areContours,
            thickness: thickness,
            width: width,
            height: height
        };
    }
    static async compressSignature({ outlines: outlines, areContours: areContours, thickness: thickness, width: width, height: height }) {
        let minDiff = Infinity;
        let maxDiff = -Infinity;
        let outlinesLength = 0;
        for (const points of outlines){
            outlinesLength += points.length;
            for(let i = 2, ii = points.length; i < ii; i++){
                const dx = points[i] - points[i - 2];
                minDiff = Math.min(minDiff, dx);
                maxDiff = Math.max(maxDiff, dx);
            }
        }
        let bufferType;
        if (minDiff >= -128 && maxDiff <= 127) bufferType = Int8Array;
        else if (minDiff >= -32768 && maxDiff <= 32767) bufferType = Int16Array;
        else bufferType = Int32Array;
        const len = outlines.length;
        const headerLength = $b3a01b20dd2ade98$var$BASE_HEADER_LENGTH + $b3a01b20dd2ade98$var$POINTS_PROPERTIES_NUMBER * len;
        const header = new Uint32Array(headerLength);
        let offset = 0;
        header[offset++] = headerLength * Uint32Array.BYTES_PER_ELEMENT + (outlinesLength - 2 * len) * bufferType.BYTES_PER_ELEMENT;
        header[offset++] = 0;
        header[offset++] = width;
        header[offset++] = height;
        header[offset++] = areContours ? 0 : 1;
        header[offset++] = Math.max(0, Math.floor(thickness ?? 0));
        header[offset++] = len;
        header[offset++] = bufferType.BYTES_PER_ELEMENT;
        for (const points of outlines){
            header[offset++] = points.length - 2;
            header[offset++] = points[0];
            header[offset++] = points[1];
        }
        const cs = new CompressionStream("deflate-raw");
        const writer = cs.writable.getWriter();
        await writer.ready;
        writer.write(header);
        const BufferCtor = bufferType.prototype.constructor;
        for (const points of outlines){
            const diffs = new BufferCtor(points.length - 2);
            for(let i = 2, ii = points.length; i < ii; i++)diffs[i - 2] = points[i] - points[i - 2];
            writer.write(diffs);
        }
        writer.close();
        const bytes = await new Response(cs.readable).bytes();
        return bytes.toBase64();
    }
    static async decompressSignature(signatureData) {
        try {
            const bytes = Uint8Array.fromBase64(signatureData);
            const { readable: readable, writable: writable } = new DecompressionStream("deflate-raw");
            const writer = writable.getWriter();
            await writer.ready;
            writer.write(bytes).then(async ()=>{
                await writer.ready;
                await writer.close();
            }).catch(()=>{});
            let data = null;
            let offset = 0;
            for await (const chunk of readable){
                data ||= new Uint8Array(new Uint32Array(chunk.buffer, 0, 4)[0]);
                data.set(chunk, offset);
                offset += chunk.length;
            }
            const header = new Uint32Array(data.buffer, 0, data.length >> 2);
            const version = header[1];
            if (version !== 0) throw new Error(`Invalid version: ${version}`);
            const width = header[2];
            const height = header[3];
            const areContours = header[4] === 0;
            const thickness = header[5];
            const numberOfDrawings = header[6];
            const bufferType = header[7];
            const outlines = [];
            const diffsOffset = ($b3a01b20dd2ade98$var$BASE_HEADER_LENGTH + $b3a01b20dd2ade98$var$POINTS_PROPERTIES_NUMBER * numberOfDrawings) * Uint32Array.BYTES_PER_ELEMENT;
            let diffs;
            switch(bufferType){
                case Int8Array.BYTES_PER_ELEMENT:
                    diffs = new Int8Array(data.buffer, diffsOffset);
                    break;
                case Int16Array.BYTES_PER_ELEMENT:
                    diffs = new Int16Array(data.buffer, diffsOffset);
                    break;
                case Int32Array.BYTES_PER_ELEMENT:
                    diffs = new Int32Array(data.buffer, diffsOffset);
                    break;
            }
            offset = 0;
            for(let i = 0; i < numberOfDrawings; i++){
                const len = header[$b3a01b20dd2ade98$var$POINTS_PROPERTIES_NUMBER * i + $b3a01b20dd2ade98$var$BASE_HEADER_LENGTH];
                const points = new Float32Array(len + 2);
                outlines.push(points);
                for(let j = 0; j < $b3a01b20dd2ade98$var$POINTS_PROPERTIES_NUMBER - 1; j++)points[j] = header[$b3a01b20dd2ade98$var$POINTS_PROPERTIES_NUMBER * i + $b3a01b20dd2ade98$var$BASE_HEADER_LENGTH + j + 1];
                for(let j = 0; j < len; j++)points[j + 2] = points[j] + diffs[offset++];
            }
            return {
                areContours: areContours,
                thickness: thickness,
                outlines: outlines,
                width: width,
                height: height
            };
        } catch (e) {
            $b3a01b20dd2ade98$var$warn(`decompressSignature: ${e}`);
            return null;
        }
    }
}
class $b3a01b20dd2ade98$var$SignatureOptions extends $b3a01b20dd2ade98$var$DrawingOptions {
    constructor(){
        super();
        super.updateProperties({
            fill: $b3a01b20dd2ade98$var$AnnotationEditor._defaultLineColor,
            "stroke-width": 0
        });
    }
    clone() {
        const clone = new $b3a01b20dd2ade98$var$SignatureOptions();
        clone.updateAll(this);
        return clone;
    }
}
class $b3a01b20dd2ade98$var$DrawnSignatureOptions extends $b3a01b20dd2ade98$var$InkDrawingOptions {
    constructor(viewerParameters){
        super(viewerParameters);
        super.updateProperties({
            stroke: $b3a01b20dd2ade98$var$AnnotationEditor._defaultLineColor,
            "stroke-width": 1
        });
    }
    clone() {
        const clone = new $b3a01b20dd2ade98$var$DrawnSignatureOptions(this._viewParameters);
        clone.updateAll(this);
        return clone;
    }
}
class $b3a01b20dd2ade98$var$SignatureEditor extends $b3a01b20dd2ade98$var$DrawingEditor {
    #isExtracted = false;
    #description = null;
    #signatureData = null;
    #signatureUUID = null;
    static _type = "signature";
    static _editorType = $b3a01b20dd2ade98$export$72ea3bfdd9a725bf.SIGNATURE;
    static _defaultDrawingOptions = null;
    constructor(params){
        super({
            ...params,
            mustBeCommitted: true,
            name: "signatureEditor"
        });
        this._willKeepAspectRatio = true;
        this.#signatureData = params.signatureData || null;
        this.#description = null;
        this.defaultL10nId = "pdfjs-editor-signature-editor1";
    }
    static initialize(l10n, uiManager) {
        $b3a01b20dd2ade98$var$AnnotationEditor.initialize(l10n, uiManager);
        this._defaultDrawingOptions = new $b3a01b20dd2ade98$var$SignatureOptions();
        this._defaultDrawnSignatureOptions = new $b3a01b20dd2ade98$var$DrawnSignatureOptions(uiManager.viewParameters);
    }
    static getDefaultDrawingOptions(options) {
        const clone = this._defaultDrawingOptions.clone();
        clone.updateProperties(options);
        return clone;
    }
    static get supportMultipleDrawings() {
        return false;
    }
    static get typesMap() {
        return $b3a01b20dd2ade98$export$b8972b998723d602(this, "typesMap", new Map());
    }
    static get isDrawer() {
        return false;
    }
    get telemetryFinalData() {
        return {
            type: "signature",
            hasDescription: !!this.#description
        };
    }
    static computeTelemetryFinalData(data) {
        const hasDescriptionStats = data.get("hasDescription");
        return {
            hasAltText: hasDescriptionStats.get(true) ?? 0,
            hasNoAltText: hasDescriptionStats.get(false) ?? 0
        };
    }
    get isResizable() {
        return true;
    }
    onScaleChanging() {
        if (this._drawId === null) return;
        super.onScaleChanging();
    }
    render() {
        if (this.div) return this.div;
        let baseX, baseY;
        const { _isCopy: _isCopy } = this;
        if (_isCopy) {
            this._isCopy = false;
            baseX = this.x;
            baseY = this.y;
        }
        super.render();
        if (this._drawId === null) {
            if (this.#signatureData) {
                const { lines: lines, mustSmooth: mustSmooth, areContours: areContours, description: description, uuid: uuid, heightInPage: heightInPage } = this.#signatureData;
                const { rawDims: { pageWidth: pageWidth, pageHeight: pageHeight }, rotation: rotation } = this.parent.viewport;
                const outline = $b3a01b20dd2ade98$export$cc4fe8633f466b4a.processDrawnLines({
                    lines: lines,
                    pageWidth: pageWidth,
                    pageHeight: pageHeight,
                    rotation: rotation,
                    innerMargin: $b3a01b20dd2ade98$var$SignatureEditor._INNER_MARGIN,
                    mustSmooth: mustSmooth,
                    areContours: areContours
                });
                this.addSignature(outline, heightInPage, description, uuid);
            } else {
                this.div.setAttribute("data-l10n-args", JSON.stringify({
                    description: ""
                }));
                this.div.hidden = true;
                this._uiManager.getSignature(this);
            }
        } else this.div.setAttribute("data-l10n-args", JSON.stringify({
            description: this.#description || ""
        }));
        if (_isCopy) {
            this._isCopy = true;
            this._moveAfterPaste(baseX, baseY);
        }
        return this.div;
    }
    setUuid(uuid) {
        this.#signatureUUID = uuid;
        this.addEditToolbar();
    }
    getUuid() {
        return this.#signatureUUID;
    }
    get description() {
        return this.#description;
    }
    set description(description) {
        this.#description = description;
        if (!this.div) return;
        this.div.setAttribute("data-l10n-args", JSON.stringify({
            description: description
        }));
        super.addEditToolbar().then((toolbar)=>{
            toolbar?.updateEditSignatureButton(description);
        });
    }
    getSignaturePreview() {
        const { newCurves: newCurves, areContours: areContours, thickness: thickness, width: width, height: height } = this.#signatureData;
        const maxDim = Math.max(width, height);
        const outlineData = $b3a01b20dd2ade98$export$cc4fe8633f466b4a.processDrawnLines({
            lines: {
                curves: newCurves.map((points)=>({
                        points: points
                    })),
                thickness: thickness,
                width: width,
                height: height
            },
            pageWidth: maxDim,
            pageHeight: maxDim,
            rotation: 0,
            innerMargin: 0,
            mustSmooth: false,
            areContours: areContours
        });
        return {
            areContours: areContours,
            outline: outlineData.outline
        };
    }
    get toolbarButtons() {
        if (this._uiManager.signatureManager) return [
            [
                "editSignature",
                this._uiManager.signatureManager
            ]
        ];
        return super.toolbarButtons;
    }
    addSignature(data, heightInPage, description, uuid) {
        const { x: savedX, y: savedY } = this;
        const { outline: outline } = this.#signatureData = data;
        this.#isExtracted = outline instanceof $b3a01b20dd2ade98$var$ContourDrawOutline;
        this.description = description;
        let drawingOptions;
        if (this.#isExtracted) drawingOptions = $b3a01b20dd2ade98$var$SignatureEditor.getDefaultDrawingOptions();
        else {
            drawingOptions = $b3a01b20dd2ade98$var$SignatureEditor._defaultDrawnSignatureOptions.clone();
            drawingOptions.updateProperties({
                "stroke-width": outline.thickness
            });
        }
        this._addOutlines({
            drawOutlines: outline,
            drawingOptions: drawingOptions
        });
        const [, pageHeight] = this.pageDimensions;
        let newHeight = heightInPage / pageHeight;
        newHeight = newHeight >= 1 ? 0.5 : newHeight;
        this.width *= newHeight / this.height;
        if (this.width >= 1) {
            newHeight *= 0.9 / this.width;
            this.width = 0.9;
        }
        this.height = newHeight;
        this.setDims();
        this.x = savedX;
        this.y = savedY;
        this.center();
        this._onResized();
        this.onScaleChanging();
        this.rotate();
        this._uiManager.addToAnnotationStorage(this);
        this.setUuid(uuid);
        this._reportTelemetry({
            action: "pdfjs.signature.inserted",
            data: {
                hasBeenSaved: !!uuid,
                hasDescription: !!description
            }
        });
        this.div.hidden = false;
    }
    getFromImage(bitmap) {
        const { rawDims: { pageWidth: pageWidth, pageHeight: pageHeight }, rotation: rotation } = this.parent.viewport;
        return $b3a01b20dd2ade98$export$cc4fe8633f466b4a.process(bitmap, pageWidth, pageHeight, rotation, $b3a01b20dd2ade98$var$SignatureEditor._INNER_MARGIN);
    }
    getFromText(text, fontInfo) {
        const { rawDims: { pageWidth: pageWidth, pageHeight: pageHeight }, rotation: rotation } = this.parent.viewport;
        return $b3a01b20dd2ade98$export$cc4fe8633f466b4a.extractContoursFromText(text, fontInfo, pageWidth, pageHeight, rotation, $b3a01b20dd2ade98$var$SignatureEditor._INNER_MARGIN);
    }
    getDrawnSignature(curves) {
        const { rawDims: { pageWidth: pageWidth, pageHeight: pageHeight }, rotation: rotation } = this.parent.viewport;
        return $b3a01b20dd2ade98$export$cc4fe8633f466b4a.processDrawnLines({
            lines: curves,
            pageWidth: pageWidth,
            pageHeight: pageHeight,
            rotation: rotation,
            innerMargin: $b3a01b20dd2ade98$var$SignatureEditor._INNER_MARGIN,
            mustSmooth: false,
            areContours: false
        });
    }
    createDrawingOptions({ areContours: areContours, thickness: thickness }) {
        if (areContours) this._drawingOptions = $b3a01b20dd2ade98$var$SignatureEditor.getDefaultDrawingOptions();
        else {
            this._drawingOptions = $b3a01b20dd2ade98$var$SignatureEditor._defaultDrawnSignatureOptions.clone();
            this._drawingOptions.updateProperties({
                "stroke-width": thickness
            });
        }
    }
    serialize(isForCopying = false) {
        if (this.isEmpty()) return null;
        const { lines: lines, points: points } = this.serializeDraw(isForCopying);
        const { _drawingOptions: { "stroke-width": thickness } } = this;
        const serialized = Object.assign(super.serialize(isForCopying), {
            isSignature: true,
            areContours: this.#isExtracted,
            color: [
                0,
                0,
                0
            ],
            thickness: this.#isExtracted ? 0 : thickness
        });
        this.addComment(serialized);
        if (isForCopying) {
            serialized.paths = {
                lines: lines,
                points: points
            };
            serialized.uuid = this.#signatureUUID;
            serialized.isCopy = true;
        } else serialized.lines = lines;
        if (this.#description) serialized.accessibilityData = {
            type: "Figure",
            alt: this.#description
        };
        return serialized;
    }
    static deserializeDraw(pageX, pageY, pageWidth, pageHeight, innerMargin, data) {
        if (data.areContours) return $b3a01b20dd2ade98$var$ContourDrawOutline.deserialize(pageX, pageY, pageWidth, pageHeight, innerMargin, data);
        return $b3a01b20dd2ade98$var$InkDrawOutline.deserialize(pageX, pageY, pageWidth, pageHeight, innerMargin, data);
    }
    static async deserialize(data, parent, uiManager) {
        const editor = await super.deserialize(data, parent, uiManager);
        editor.#isExtracted = data.areContours;
        editor.description = data.accessibilityData?.alt || "";
        editor.#signatureUUID = data.uuid;
        return editor;
    }
}
class $b3a01b20dd2ade98$var$StampEditor extends $b3a01b20dd2ade98$var$AnnotationEditor {
    #bitmap = null;
    #bitmapId = null;
    #bitmapPromise = null;
    #bitmapUrl = null;
    #bitmapFile = null;
    #bitmapFileName = "";
    #canvas = null;
    #missingCanvas = false;
    #resizeTimeoutId = null;
    #isSvg = false;
    #hasBeenAddedInUndoStack = false;
    static _type = "stamp";
    static _editorType = $b3a01b20dd2ade98$export$72ea3bfdd9a725bf.STAMP;
    constructor(params){
        super({
            ...params,
            name: "stampEditor"
        });
        this.#bitmapUrl = params.bitmapUrl;
        this.#bitmapFile = params.bitmapFile;
        this.defaultL10nId = "pdfjs-editor-stamp-editor";
    }
    static initialize(l10n, uiManager) {
        $b3a01b20dd2ade98$var$AnnotationEditor.initialize(l10n, uiManager);
    }
    static isHandlingMimeForPasting(mime) {
        return $b3a01b20dd2ade98$export$3234c88e9de64a88.includes(mime);
    }
    static paste(item, parent) {
        parent.pasteEditor({
            mode: $b3a01b20dd2ade98$export$72ea3bfdd9a725bf.STAMP
        }, {
            bitmapFile: item.getAsFile()
        });
    }
    altTextFinish() {
        if (this._uiManager.useNewAltTextFlow) this.div.hidden = false;
        super.altTextFinish();
    }
    get telemetryFinalData() {
        return {
            type: "stamp",
            hasAltText: !!this.altTextData?.altText
        };
    }
    static computeTelemetryFinalData(data) {
        const hasAltTextStats = data.get("hasAltText");
        return {
            hasAltText: hasAltTextStats.get(true) ?? 0,
            hasNoAltText: hasAltTextStats.get(false) ?? 0
        };
    }
    #getBitmapFetched(data, fromId = false) {
        if (!data) {
            this.remove();
            return;
        }
        this.#bitmap = data.bitmap;
        if (!fromId) {
            this.#bitmapId = data.id;
            this.#isSvg = data.isSvg;
        }
        if (data.file) this.#bitmapFileName = data.file.name;
        this.#createCanvas();
    }
    #getBitmapDone() {
        this.#bitmapPromise = null;
        this._uiManager.enableWaiting(false);
        if (!this.#canvas) return;
        if (this._uiManager.useNewAltTextWhenAddingImage && this._uiManager.useNewAltTextFlow && this.#bitmap) {
            this.addEditToolbar().then(()=>{
                this._editToolbar.hide();
                this._uiManager.editAltText(this, true);
            });
            return;
        }
        if (!this._uiManager.useNewAltTextWhenAddingImage && this._uiManager.useNewAltTextFlow && this.#bitmap) {
            this._reportTelemetry({
                action: "pdfjs.image.image_added",
                data: {
                    alt_text_modal: false,
                    alt_text_type: "empty"
                }
            });
            try {
                this.mlGuessAltText();
            } catch  {}
        }
        this.div.focus();
    }
    async mlGuessAltText(imageData = null, updateAltTextData = true) {
        if (this.hasAltTextData()) return null;
        const { mlManager: mlManager } = this._uiManager;
        if (!mlManager) throw new Error("No ML.");
        if (!await mlManager.isEnabledFor("altText")) throw new Error("ML isn't enabled for alt text.");
        const { data: data, width: width, height: height } = imageData || this.copyCanvas(null, null, true).imageData;
        const response = await mlManager.guess({
            name: "altText",
            request: {
                data: data,
                width: width,
                height: height,
                channels: data.length / (width * height)
            }
        });
        if (!response) throw new Error("No response from the AI service.");
        if (response.error) throw new Error("Error from the AI service.");
        if (response.cancel) return null;
        if (!response.output) throw new Error("No valid response from the AI service.");
        const altText = response.output;
        await this.setGuessedAltText(altText);
        if (updateAltTextData && !this.hasAltTextData()) this.altTextData = {
            alt: altText,
            decorative: false
        };
        return altText;
    }
    #getBitmap() {
        if (this.#bitmapId) {
            this._uiManager.enableWaiting(true);
            this._uiManager.imageManager.getFromId(this.#bitmapId).then((data)=>this.#getBitmapFetched(data, true)).finally(()=>this.#getBitmapDone());
            return;
        }
        if (this.#bitmapUrl) {
            const url = this.#bitmapUrl;
            this.#bitmapUrl = null;
            this._uiManager.enableWaiting(true);
            this.#bitmapPromise = this._uiManager.imageManager.getFromUrl(url).then((data)=>this.#getBitmapFetched(data)).finally(()=>this.#getBitmapDone());
            return;
        }
        if (this.#bitmapFile) {
            const file = this.#bitmapFile;
            this.#bitmapFile = null;
            this._uiManager.enableWaiting(true);
            this.#bitmapPromise = this._uiManager.imageManager.getFromFile(file).then((data)=>this.#getBitmapFetched(data)).finally(()=>this.#getBitmapDone());
            return;
        }
        const input = document.createElement("input");
        input.type = "file";
        input.accept = $b3a01b20dd2ade98$export$3234c88e9de64a88.join(",");
        const signal = this._uiManager._signal;
        this.#bitmapPromise = new Promise((resolve)=>{
            input.addEventListener("change", async ()=>{
                if (!input.files || input.files.length === 0) this.remove();
                else {
                    this._uiManager.enableWaiting(true);
                    const data = await this._uiManager.imageManager.getFromFile(input.files[0]);
                    this._reportTelemetry({
                        action: "pdfjs.image.image_selected",
                        data: {
                            alt_text_modal: this._uiManager.useNewAltTextFlow
                        }
                    });
                    this.#getBitmapFetched(data);
                }
                resolve();
            }, {
                signal: signal
            });
            input.addEventListener("cancel", ()=>{
                this.remove();
                resolve();
            }, {
                signal: signal
            });
        }).finally(()=>this.#getBitmapDone());
        input.click();
    }
    remove() {
        if (this.#bitmapId) {
            this.#bitmap = null;
            this._uiManager.imageManager.deleteId(this.#bitmapId);
            this.#canvas?.remove();
            this.#canvas = null;
            if (this.#resizeTimeoutId) {
                clearTimeout(this.#resizeTimeoutId);
                this.#resizeTimeoutId = null;
            }
        }
        super.remove();
    }
    rebuild() {
        if (!this.parent) {
            if (this.#bitmapId) this.#getBitmap();
            return;
        }
        super.rebuild();
        if (this.div === null) return;
        if (this.#bitmapId && this.#canvas === null) this.#getBitmap();
        if (!this.isAttachedToDOM) this.parent.add(this);
    }
    onceAdded(focus) {
        this._isDraggable = true;
        if (focus) this.div.focus();
    }
    isEmpty() {
        return !(this.#bitmapPromise || this.#bitmap || this.#bitmapUrl || this.#bitmapFile || this.#bitmapId || this.#missingCanvas);
    }
    get toolbarButtons() {
        return [
            [
                "altText",
                this.createAltText()
            ]
        ];
    }
    get isResizable() {
        return true;
    }
    render() {
        if (this.div) return this.div;
        let baseX, baseY;
        if (this._isCopy) {
            baseX = this.x;
            baseY = this.y;
        }
        super.render();
        this.div.hidden = true;
        this.createAltText();
        if (!this.#missingCanvas) {
            if (this.#bitmap) this.#createCanvas();
            else this.#getBitmap();
        }
        if (this._isCopy) this._moveAfterPaste(baseX, baseY);
        this._uiManager.addShouldRescale(this);
        return this.div;
    }
    setCanvas(annotationElementId, canvas) {
        const { id: bitmapId, bitmap: bitmap } = this._uiManager.imageManager.getFromCanvas(annotationElementId, canvas);
        canvas.remove();
        if (bitmapId && this._uiManager.imageManager.isValidId(bitmapId)) {
            this.#bitmapId = bitmapId;
            if (bitmap) this.#bitmap = bitmap;
            this.#missingCanvas = false;
            this.#createCanvas();
        }
    }
    _onResized() {
        this.onScaleChanging();
    }
    onScaleChanging() {
        if (!this.parent) return;
        if (this.#resizeTimeoutId !== null) clearTimeout(this.#resizeTimeoutId);
        const TIME_TO_WAIT = 200;
        this.#resizeTimeoutId = setTimeout(()=>{
            this.#resizeTimeoutId = null;
            this.#drawBitmap();
        }, TIME_TO_WAIT);
    }
    #createCanvas() {
        const { div: div } = this;
        let { width: width, height: height } = this.#bitmap;
        const [pageWidth, pageHeight] = this.pageDimensions;
        const MAX_RATIO = 0.75;
        if (this.width) {
            width = this.width * pageWidth;
            height = this.height * pageHeight;
        } else if (width > MAX_RATIO * pageWidth || height > MAX_RATIO * pageHeight) {
            const factor = Math.min(MAX_RATIO * pageWidth / width, MAX_RATIO * pageHeight / height);
            width *= factor;
            height *= factor;
        }
        this._uiManager.enableWaiting(false);
        const canvas = this.#canvas = document.createElement("canvas");
        canvas.setAttribute("role", "img");
        this.addContainer(canvas);
        this.width = width / pageWidth;
        this.height = height / pageHeight;
        this.setDims();
        if (this._initialOptions?.isCentered) this.center();
        else this.fixAndSetPosition();
        this._initialOptions = null;
        if (!this._uiManager.useNewAltTextWhenAddingImage || !this._uiManager.useNewAltTextFlow || this.annotationElementId) div.hidden = false;
        this.#drawBitmap();
        if (!this.#hasBeenAddedInUndoStack) {
            this.parent.addUndoableEditor(this);
            this.#hasBeenAddedInUndoStack = true;
        }
        this._reportTelemetry({
            action: "inserted_image"
        });
        if (this.#bitmapFileName) this.div.setAttribute("aria-description", this.#bitmapFileName);
        if (!this.annotationElementId) this._uiManager.a11yAlert("pdfjs-editor-stamp-added-alert");
    }
    copyCanvas(maxDataDimension, maxPreviewDimension, createImageData = false) {
        if (!maxDataDimension) maxDataDimension = 224;
        const { width: bitmapWidth, height: bitmapHeight } = this.#bitmap;
        const outputScale = new $b3a01b20dd2ade98$export$f16a99f63bccd50b();
        let bitmap = this.#bitmap;
        let width = bitmapWidth, height = bitmapHeight;
        let canvas = null;
        if (maxPreviewDimension) {
            if (bitmapWidth > maxPreviewDimension || bitmapHeight > maxPreviewDimension) {
                const ratio = Math.min(maxPreviewDimension / bitmapWidth, maxPreviewDimension / bitmapHeight);
                width = Math.floor(bitmapWidth * ratio);
                height = Math.floor(bitmapHeight * ratio);
            }
            canvas = document.createElement("canvas");
            const scaledWidth = canvas.width = Math.ceil(width * outputScale.sx);
            const scaledHeight = canvas.height = Math.ceil(height * outputScale.sy);
            if (!this.#isSvg) bitmap = this.#scaleBitmap(scaledWidth, scaledHeight);
            const ctx = canvas.getContext("2d");
            ctx.filter = this._uiManager.hcmFilter;
            let white = "white", black = "#cfcfd8";
            if (this._uiManager.hcmFilter !== "none") black = "black";
            else if ($b3a01b20dd2ade98$var$ColorScheme.isDarkMode) {
                white = "#8f8f9d";
                black = "#42414d";
            }
            const boxDim = 15;
            const boxDimWidth = boxDim * outputScale.sx;
            const boxDimHeight = boxDim * outputScale.sy;
            const pattern = new OffscreenCanvas(boxDimWidth * 2, boxDimHeight * 2);
            const patternCtx = pattern.getContext("2d");
            patternCtx.fillStyle = white;
            patternCtx.fillRect(0, 0, boxDimWidth * 2, boxDimHeight * 2);
            patternCtx.fillStyle = black;
            patternCtx.fillRect(0, 0, boxDimWidth, boxDimHeight);
            patternCtx.fillRect(boxDimWidth, boxDimHeight, boxDimWidth, boxDimHeight);
            ctx.fillStyle = ctx.createPattern(pattern, "repeat");
            ctx.fillRect(0, 0, scaledWidth, scaledHeight);
            ctx.drawImage(bitmap, 0, 0, bitmap.width, bitmap.height, 0, 0, scaledWidth, scaledHeight);
        }
        let imageData = null;
        if (createImageData) {
            let dataWidth, dataHeight;
            if (outputScale.symmetric && bitmap.width < maxDataDimension && bitmap.height < maxDataDimension) {
                dataWidth = bitmap.width;
                dataHeight = bitmap.height;
            } else {
                bitmap = this.#bitmap;
                if (bitmapWidth > maxDataDimension || bitmapHeight > maxDataDimension) {
                    const ratio = Math.min(maxDataDimension / bitmapWidth, maxDataDimension / bitmapHeight);
                    dataWidth = Math.floor(bitmapWidth * ratio);
                    dataHeight = Math.floor(bitmapHeight * ratio);
                    if (!this.#isSvg) bitmap = this.#scaleBitmap(dataWidth, dataHeight);
                }
            }
            const offscreen = new OffscreenCanvas(dataWidth, dataHeight);
            const offscreenCtx = offscreen.getContext("2d", {
                willReadFrequently: true
            });
            offscreenCtx.drawImage(bitmap, 0, 0, bitmap.width, bitmap.height, 0, 0, dataWidth, dataHeight);
            imageData = {
                width: dataWidth,
                height: dataHeight,
                data: offscreenCtx.getImageData(0, 0, dataWidth, dataHeight).data
            };
        }
        return {
            canvas: canvas,
            width: width,
            height: height,
            imageData: imageData
        };
    }
    #scaleBitmap(width, height) {
        const { width: bitmapWidth, height: bitmapHeight } = this.#bitmap;
        let newWidth = bitmapWidth;
        let newHeight = bitmapHeight;
        let bitmap = this.#bitmap;
        while(newWidth > 2 * width || newHeight > 2 * height){
            const prevWidth = newWidth;
            const prevHeight = newHeight;
            if (newWidth > 2 * width) newWidth = newWidth >= 16384 ? Math.floor(newWidth / 2) - 1 : Math.ceil(newWidth / 2);
            if (newHeight > 2 * height) newHeight = newHeight >= 16384 ? Math.floor(newHeight / 2) - 1 : Math.ceil(newHeight / 2);
            const offscreen = new OffscreenCanvas(newWidth, newHeight);
            const ctx = offscreen.getContext("2d");
            ctx.drawImage(bitmap, 0, 0, prevWidth, prevHeight, 0, 0, newWidth, newHeight);
            bitmap = offscreen.transferToImageBitmap();
        }
        return bitmap;
    }
    #drawBitmap() {
        const [parentWidth, parentHeight] = this.parentDimensions;
        const { width: width, height: height } = this;
        const outputScale = new $b3a01b20dd2ade98$export$f16a99f63bccd50b();
        const scaledWidth = Math.ceil(width * parentWidth * outputScale.sx);
        const scaledHeight = Math.ceil(height * parentHeight * outputScale.sy);
        const canvas = this.#canvas;
        if (!canvas || canvas.width === scaledWidth && canvas.height === scaledHeight) return;
        canvas.width = scaledWidth;
        canvas.height = scaledHeight;
        const bitmap = this.#isSvg ? this.#bitmap : this.#scaleBitmap(scaledWidth, scaledHeight);
        const ctx = canvas.getContext("2d");
        ctx.filter = this._uiManager.hcmFilter;
        ctx.drawImage(bitmap, 0, 0, bitmap.width, bitmap.height, 0, 0, scaledWidth, scaledHeight);
    }
    #serializeBitmap(toUrl) {
        if (toUrl) {
            if (this.#isSvg) {
                const url = this._uiManager.imageManager.getSvgUrl(this.#bitmapId);
                if (url) return url;
            }
            const canvas = document.createElement("canvas");
            ({ width: canvas.width, height: canvas.height } = this.#bitmap);
            const ctx = canvas.getContext("2d");
            ctx.drawImage(this.#bitmap, 0, 0);
            return canvas.toDataURL();
        }
        if (this.#isSvg) {
            const [pageWidth, pageHeight] = this.pageDimensions;
            const width = Math.round(this.width * pageWidth * $b3a01b20dd2ade98$export$6ef3b6b69e65342c.PDF_TO_CSS_UNITS);
            const height = Math.round(this.height * pageHeight * $b3a01b20dd2ade98$export$6ef3b6b69e65342c.PDF_TO_CSS_UNITS);
            const offscreen = new OffscreenCanvas(width, height);
            const ctx = offscreen.getContext("2d");
            ctx.drawImage(this.#bitmap, 0, 0, this.#bitmap.width, this.#bitmap.height, 0, 0, width, height);
            return offscreen.transferToImageBitmap();
        }
        return structuredClone(this.#bitmap);
    }
    static async deserialize(data, parent, uiManager) {
        let initialData = null;
        let missingCanvas = false;
        if (data instanceof $b3a01b20dd2ade98$var$StampAnnotationElement) {
            const { data: { rect: rect, rotation: rotation, id: id, structParent: structParent, popupRef: popupRef, richText: richText, contentsObj: contentsObj, creationDate: creationDate, modificationDate: modificationDate }, container: container, parent: { page: { pageNumber: pageNumber } }, canvas: canvas } = data;
            let bitmapId, bitmap;
            if (canvas) {
                delete data.canvas;
                ({ id: bitmapId, bitmap: bitmap } = uiManager.imageManager.getFromCanvas(container.id, canvas));
                canvas.remove();
            } else {
                missingCanvas = true;
                data._hasNoCanvas = true;
            }
            const altText = (await parent._structTree.getAriaAttributes(`${$b3a01b20dd2ade98$var$AnnotationPrefix}${id}`))?.get("aria-label") || "";
            initialData = data = {
                annotationType: $b3a01b20dd2ade98$export$72ea3bfdd9a725bf.STAMP,
                bitmapId: bitmapId,
                bitmap: bitmap,
                pageIndex: pageNumber - 1,
                rect: rect.slice(0),
                rotation: rotation,
                annotationElementId: id,
                id: id,
                deleted: false,
                accessibilityData: {
                    decorative: false,
                    altText: altText
                },
                isSvg: false,
                structParent: structParent,
                popupRef: popupRef,
                richText: richText,
                comment: contentsObj?.str || null,
                creationDate: creationDate,
                modificationDate: modificationDate
            };
        }
        const editor = await super.deserialize(data, parent, uiManager);
        const { rect: rect, bitmap: bitmap, bitmapUrl: bitmapUrl, bitmapId: bitmapId, isSvg: isSvg, accessibilityData: accessibilityData } = data;
        if (missingCanvas) {
            uiManager.addMissingCanvas(data.id, editor);
            editor.#missingCanvas = true;
        } else if (bitmapId && uiManager.imageManager.isValidId(bitmapId)) {
            editor.#bitmapId = bitmapId;
            if (bitmap) editor.#bitmap = bitmap;
        } else editor.#bitmapUrl = bitmapUrl;
        editor.#isSvg = isSvg;
        const [parentWidth, parentHeight] = editor.pageDimensions;
        editor.width = (rect[2] - rect[0]) / parentWidth;
        editor.height = (rect[3] - rect[1]) / parentHeight;
        if (accessibilityData) editor.altTextData = accessibilityData;
        editor._initialData = initialData;
        if (data.comment) editor.setCommentData(data);
        editor.#hasBeenAddedInUndoStack = !!initialData;
        return editor;
    }
    serialize(isForCopying = false, context = null) {
        if (this.isEmpty()) return null;
        if (this.deleted) return this.serializeDeleted();
        const serialized = Object.assign(super.serialize(isForCopying), {
            bitmapId: this.#bitmapId,
            isSvg: this.#isSvg
        });
        this.addComment(serialized);
        if (isForCopying) {
            serialized.bitmapUrl = this.#serializeBitmap(true);
            serialized.accessibilityData = this.serializeAltText(true);
            serialized.isCopy = true;
            return serialized;
        }
        const { decorative: decorative, altText: altText } = this.serializeAltText(false);
        if (!decorative && altText) serialized.accessibilityData = {
            type: "Figure",
            alt: altText
        };
        if (this.annotationElementId) {
            const changes = this.#hasElementChanged(serialized);
            if (changes.isSame) return null;
            if (changes.isSameAltText) delete serialized.accessibilityData;
            else serialized.accessibilityData.structParent = this._initialData.structParent ?? -1;
            serialized.id = this.annotationElementId;
            delete serialized.bitmapId;
            return serialized;
        }
        if (context === null) return serialized;
        context.stamps ||= new Map();
        const area = this.#isSvg ? (serialized.rect[2] - serialized.rect[0]) * (serialized.rect[3] - serialized.rect[1]) : null;
        if (!context.stamps.has(this.#bitmapId)) {
            context.stamps.set(this.#bitmapId, {
                area: area,
                serialized: serialized
            });
            serialized.bitmap = this.#serializeBitmap(false);
        } else if (this.#isSvg) {
            const prevData = context.stamps.get(this.#bitmapId);
            if (area > prevData.area) {
                prevData.area = area;
                prevData.serialized.bitmap.close();
                prevData.serialized.bitmap = this.#serializeBitmap(false);
            }
        }
        return serialized;
    }
    #hasElementChanged(serialized) {
        const { pageIndex: pageIndex, accessibilityData: { altText: altText } } = this._initialData;
        const isSamePageIndex = serialized.pageIndex === pageIndex;
        const isSameAltText = (serialized.accessibilityData?.alt || "") === altText;
        return {
            isSame: !this.hasEditedComment && !this._hasBeenMoved && !this._hasBeenResized && isSamePageIndex && isSameAltText,
            isSameAltText: isSameAltText
        };
    }
    renderAnnotationElement(annotation) {
        if (this.deleted) {
            annotation.hide();
            return null;
        }
        annotation.updateEdited({
            rect: this.getPDFRect(),
            popup: this.comment
        });
        return null;
    }
}
class $b3a01b20dd2ade98$export$47948c9fe1adbf1b {
    #accessibilityManager;
    #allowClick = false;
    #annotationLayer = null;
    #clickAC = null;
    #editorFocusTimeoutId = null;
    #editors = new Map();
    #hadPointerDown = false;
    #isDisabling = false;
    #isEnabling = false;
    #drawingAC = null;
    #focusedElement = null;
    #textLayer = null;
    #textSelectionAC = null;
    #textLayerDblClickAC = null;
    #lastPointerDownTimestamp = -1;
    #uiManager;
    static _initialized = false;
    static #editorTypes = new Map([
        $b3a01b20dd2ade98$var$FreeTextEditor,
        $b3a01b20dd2ade98$var$InkEditor,
        $b3a01b20dd2ade98$var$StampEditor,
        $b3a01b20dd2ade98$var$HighlightEditor,
        $b3a01b20dd2ade98$var$SignatureEditor
    ].map((type)=>[
            type._editorType,
            type
        ]));
    constructor({ uiManager: uiManager, pageIndex: pageIndex, div: div, structTreeLayer: structTreeLayer, accessibilityManager: accessibilityManager, annotationLayer: annotationLayer, drawLayer: drawLayer, textLayer: textLayer, viewport: viewport, l10n: l10n }){
        const editorTypes = [
            ...$b3a01b20dd2ade98$export$47948c9fe1adbf1b.#editorTypes.values()
        ];
        if (!$b3a01b20dd2ade98$export$47948c9fe1adbf1b._initialized) {
            $b3a01b20dd2ade98$export$47948c9fe1adbf1b._initialized = true;
            for (const editorType of editorTypes)editorType.initialize(l10n, uiManager);
        }
        uiManager.registerEditorTypes(editorTypes);
        this.#uiManager = uiManager;
        this.pageIndex = pageIndex;
        this.div = div;
        this.#accessibilityManager = accessibilityManager;
        this.#annotationLayer = annotationLayer;
        this.viewport = viewport;
        this.#textLayer = textLayer;
        this.drawLayer = drawLayer;
        this._structTree = structTreeLayer;
        this.#uiManager.addLayer(this);
    }
    get isEmpty() {
        return this.#editors.size === 0;
    }
    get isInvisible() {
        return this.isEmpty && this.#uiManager.getMode() === $b3a01b20dd2ade98$export$72ea3bfdd9a725bf.NONE;
    }
    updateToolbar(options) {
        this.#uiManager.updateToolbar(options);
    }
    updateMode(mode = this.#uiManager.getMode()) {
        this.#cleanup();
        switch(mode){
            case $b3a01b20dd2ade98$export$72ea3bfdd9a725bf.NONE:
                this.div.classList.toggle("nonEditing", true);
                this.disableTextSelection();
                this.togglePointerEvents(false);
                this.toggleAnnotationLayerPointerEvents(true);
                this.disableClick();
                return;
            case $b3a01b20dd2ade98$export$72ea3bfdd9a725bf.INK:
                this.disableTextSelection();
                this.togglePointerEvents(true);
                this.enableClick();
                break;
            case $b3a01b20dd2ade98$export$72ea3bfdd9a725bf.HIGHLIGHT:
                this.enableTextSelection();
                this.togglePointerEvents(false);
                this.disableClick();
                break;
            default:
                this.disableTextSelection();
                this.togglePointerEvents(true);
                this.enableClick();
        }
        this.toggleAnnotationLayerPointerEvents(false);
        const { classList: classList } = this.div;
        classList.toggle("nonEditing", false);
        if (mode === $b3a01b20dd2ade98$export$72ea3bfdd9a725bf.POPUP) classList.toggle("commentEditing", true);
        else {
            classList.toggle("commentEditing", false);
            for (const editorType of $b3a01b20dd2ade98$export$47948c9fe1adbf1b.#editorTypes.values())classList.toggle(`${editorType._type}Editing`, mode === editorType._editorType);
        }
        this.div.hidden = false;
    }
    hasTextLayer(textLayer) {
        return textLayer === this.#textLayer?.div;
    }
    setEditingState(isEditing) {
        this.#uiManager.setEditingState(isEditing);
    }
    addCommands(params) {
        this.#uiManager.addCommands(params);
    }
    cleanUndoStack(type) {
        this.#uiManager.cleanUndoStack(type);
    }
    toggleDrawing(enabled = false) {
        this.div.classList.toggle("drawing", !enabled);
    }
    togglePointerEvents(enabled = false) {
        this.div.classList.toggle("disabled", !enabled);
    }
    toggleAnnotationLayerPointerEvents(enabled = false) {
        this.#annotationLayer?.togglePointerEvents(enabled);
    }
    get #allEditorsIterator() {
        return this.#editors.size !== 0 ? this.#editors.values() : this.#uiManager.getEditors(this.pageIndex);
    }
    async enable() {
        this.#isEnabling = true;
        this.div.tabIndex = 0;
        this.togglePointerEvents(true);
        this.div.classList.toggle("nonEditing", false);
        this.#textLayerDblClickAC?.abort();
        this.#textLayerDblClickAC = null;
        const annotationElementIds = new Set();
        for (const editor of this.#allEditorsIterator){
            editor.enableEditing();
            editor.show(true);
            if (editor.annotationElementId) {
                this.#uiManager.removeChangedExistingAnnotation(editor);
                annotationElementIds.add(editor.annotationElementId);
            }
        }
        const annotationLayer = this.#annotationLayer;
        if (annotationLayer) for (const editable of annotationLayer.getEditableAnnotations()){
            editable.hide();
            if (this.#uiManager.isDeletedAnnotationElement(editable.data.id)) continue;
            if (annotationElementIds.has(editable.data.id)) continue;
            const editor = await this.deserialize(editable);
            if (!editor) continue;
            this.addOrRebuild(editor);
            editor.enableEditing();
        }
        this.#isEnabling = false;
        this.#uiManager._eventBus.dispatch("editorsrendered", {
            source: this,
            pageNumber: this.pageIndex + 1
        });
    }
    disable() {
        this.#isDisabling = true;
        this.div.tabIndex = -1;
        this.togglePointerEvents(false);
        this.div.classList.toggle("nonEditing", true);
        if (this.#textLayer && !this.#textLayerDblClickAC) {
            this.#textLayerDblClickAC = new AbortController();
            const signal = this.#uiManager.combinedSignal(this.#textLayerDblClickAC);
            this.#textLayer.div.addEventListener("pointerdown", (e)=>{
                const DBL_CLICK_THRESHOLD = 500;
                const { clientX: clientX, clientY: clientY, timeStamp: timeStamp } = e;
                const lastPointerDownTimestamp = this.#lastPointerDownTimestamp;
                if (timeStamp - lastPointerDownTimestamp > DBL_CLICK_THRESHOLD) {
                    this.#lastPointerDownTimestamp = timeStamp;
                    return;
                }
                this.#lastPointerDownTimestamp = -1;
                const { classList: classList } = this.div;
                classList.toggle("getElements", true);
                const elements = document.elementsFromPoint(clientX, clientY);
                classList.toggle("getElements", false);
                if (!this.div.contains(elements[0])) return;
                let id;
                const regex = new RegExp(`^${$b3a01b20dd2ade98$var$AnnotationEditorPrefix}[0-9]+$`);
                for (const element of elements)if (regex.test(element.id)) {
                    id = element.id;
                    break;
                }
                if (!id) return;
                const editor = this.#editors.get(id);
                if (editor?.annotationElementId === null) {
                    e.stopPropagation();
                    e.preventDefault();
                    editor.dblclick(e);
                }
            }, {
                signal: signal,
                capture: true
            });
        }
        const annotationLayer = this.#annotationLayer;
        const needFakeAnnotation = [];
        if (annotationLayer) {
            const changedAnnotations = new Map();
            const resetAnnotations = new Map();
            for (const editor of this.#allEditorsIterator){
                editor.disableEditing();
                if (!editor.annotationElementId) {
                    needFakeAnnotation.push(editor);
                    continue;
                }
                if (editor.serialize() !== null) {
                    changedAnnotations.set(editor.annotationElementId, editor);
                    continue;
                } else resetAnnotations.set(editor.annotationElementId, editor);
                this.getEditableAnnotation(editor.annotationElementId)?.show();
                editor.remove();
            }
            for (const editable of annotationLayer.getEditableAnnotations()){
                const { id: id } = editable.data;
                if (this.#uiManager.isDeletedAnnotationElement(id)) {
                    editable.updateEdited({
                        deleted: true
                    });
                    continue;
                }
                let editor = resetAnnotations.get(id);
                if (editor) {
                    editor.resetAnnotationElement(editable);
                    editor.show(false);
                    editable.show();
                    continue;
                }
                editor = changedAnnotations.get(id);
                if (editor) {
                    this.#uiManager.addChangedExistingAnnotation(editor);
                    if (editor.renderAnnotationElement(editable)) editor.show(false);
                }
                editable.show();
            }
        }
        this.#cleanup();
        if (this.isEmpty) this.div.hidden = true;
        const { classList: classList } = this.div;
        for (const editorType of $b3a01b20dd2ade98$export$47948c9fe1adbf1b.#editorTypes.values())classList.remove(`${editorType._type}Editing`);
        this.disableTextSelection();
        this.toggleAnnotationLayerPointerEvents(true);
        annotationLayer?.updateFakeAnnotations(needFakeAnnotation);
        this.#isDisabling = false;
    }
    getEditableAnnotation(id) {
        return this.#annotationLayer?.getEditableAnnotation(id) || null;
    }
    setActiveEditor(editor) {
        const currentActive = this.#uiManager.getActive();
        if (currentActive === editor) return;
        this.#uiManager.setActiveEditor(editor);
    }
    enableTextSelection() {
        this.div.tabIndex = -1;
        if (this.#textLayer?.div && !this.#textSelectionAC) {
            this.#textSelectionAC = new AbortController();
            const signal = this.#uiManager.combinedSignal(this.#textSelectionAC);
            this.#textLayer.div.addEventListener("pointerdown", this.#textLayerPointerDown.bind(this), {
                signal: signal
            });
            this.#textLayer.div.classList.add("highlighting");
        }
    }
    disableTextSelection() {
        this.div.tabIndex = 0;
        if (this.#textLayer?.div && this.#textSelectionAC) {
            this.#textSelectionAC.abort();
            this.#textSelectionAC = null;
            this.#textLayer.div.classList.remove("highlighting");
        }
    }
    #textLayerPointerDown(event) {
        this.#uiManager.unselectAll();
        const { target: target } = event;
        if (target === this.#textLayer.div || (target.getAttribute("role") === "img" || target.classList.contains("endOfContent")) && this.#textLayer.div.contains(target)) {
            const { isMac: isMac } = $b3a01b20dd2ade98$export$5fb8891d35c36978.platform;
            if (event.button !== 0 || event.ctrlKey && isMac) return;
            this.#uiManager.showAllEditors("highlight", true, true);
            this.#textLayer.div.classList.add("free");
            this.toggleDrawing();
            $b3a01b20dd2ade98$var$HighlightEditor.startHighlighting(this, this.#uiManager.direction === "ltr", {
                target: this.#textLayer.div,
                x: event.x,
                y: event.y
            });
            this.#textLayer.div.addEventListener("pointerup", ()=>{
                this.#textLayer.div.classList.remove("free");
                this.toggleDrawing(true);
            }, {
                once: true,
                signal: this.#uiManager._signal
            });
            event.preventDefault();
        }
    }
    enableClick() {
        if (this.#clickAC) return;
        this.#clickAC = new AbortController();
        const signal = this.#uiManager.combinedSignal(this.#clickAC);
        this.div.addEventListener("pointerdown", this.pointerdown.bind(this), {
            signal: signal
        });
        const pointerup = this.pointerup.bind(this);
        this.div.addEventListener("pointerup", pointerup, {
            signal: signal
        });
        this.div.addEventListener("pointercancel", pointerup, {
            signal: signal
        });
    }
    disableClick() {
        this.#clickAC?.abort();
        this.#clickAC = null;
    }
    attach(editor) {
        this.#editors.set(editor.id, editor);
        const { annotationElementId: annotationElementId } = editor;
        if (annotationElementId && this.#uiManager.isDeletedAnnotationElement(annotationElementId)) this.#uiManager.removeDeletedAnnotationElement(editor);
    }
    detach(editor) {
        this.#editors.delete(editor.id);
        this.#accessibilityManager?.removePointerInTextLayer(editor.contentDiv);
        if (!this.#isDisabling && editor.annotationElementId) this.#uiManager.addDeletedAnnotationElement(editor);
    }
    remove(editor) {
        this.detach(editor);
        this.#uiManager.removeEditor(editor);
        editor.div.remove();
        editor.isAttachedToDOM = false;
    }
    changeParent(editor) {
        if (editor.parent === this) return;
        if (editor.parent && editor.annotationElementId) {
            this.#uiManager.addDeletedAnnotationElement(editor);
            $b3a01b20dd2ade98$var$AnnotationEditor.deleteAnnotationElement(editor);
            editor.annotationElementId = null;
        }
        this.attach(editor);
        editor.parent?.detach(editor);
        editor.setParent(this);
        if (editor.div && editor.isAttachedToDOM) {
            editor.div.remove();
            this.div.append(editor.div);
        }
    }
    add(editor) {
        if (editor.parent === this && editor.isAttachedToDOM) return;
        this.changeParent(editor);
        this.#uiManager.addEditor(editor);
        this.attach(editor);
        if (!editor.isAttachedToDOM) {
            const div = editor.render();
            this.div.append(div);
            editor.isAttachedToDOM = true;
        }
        editor.fixAndSetPosition();
        editor.onceAdded(!this.#isEnabling);
        this.#uiManager.addToAnnotationStorage(editor);
        editor._reportTelemetry(editor.telemetryInitialData);
    }
    moveEditorInDOM(editor) {
        if (!editor.isAttachedToDOM) return;
        const { activeElement: activeElement } = document;
        if (editor.div.contains(activeElement) && !this.#editorFocusTimeoutId) {
            editor._focusEventsAllowed = false;
            this.#editorFocusTimeoutId = setTimeout(()=>{
                this.#editorFocusTimeoutId = null;
                if (!editor.div.contains(document.activeElement)) {
                    editor.div.addEventListener("focusin", ()=>{
                        editor._focusEventsAllowed = true;
                    }, {
                        once: true,
                        signal: this.#uiManager._signal
                    });
                    activeElement.focus();
                } else editor._focusEventsAllowed = true;
            }, 0);
        }
        editor._structTreeParentId = this.#accessibilityManager?.moveElementInDOM(this.div, editor.div, editor.contentDiv, true);
    }
    addOrRebuild(editor) {
        if (editor.needsToBeRebuilt()) {
            editor.parent ||= this;
            editor.rebuild();
            editor.show();
        } else this.add(editor);
    }
    addUndoableEditor(editor) {
        const cmd = ()=>editor._uiManager.rebuild(editor);
        const undo = ()=>{
            editor.remove();
        };
        this.addCommands({
            cmd: cmd,
            undo: undo,
            mustExec: false
        });
    }
    getEditorByUID(uid) {
        for (const editor of this.#editors.values()){
            if (editor.uid === uid) return editor;
        }
        return null;
    }
    get #currentEditorType() {
        return $b3a01b20dd2ade98$export$47948c9fe1adbf1b.#editorTypes.get(this.#uiManager.getMode());
    }
    combinedSignal(ac) {
        return this.#uiManager.combinedSignal(ac);
    }
    #createNewEditor(params) {
        const editorType = this.#currentEditorType;
        return editorType ? new editorType.prototype.constructor(params) : null;
    }
    canCreateNewEmptyEditor() {
        return this.#currentEditorType?.canCreateNewEmptyEditor();
    }
    async pasteEditor(options, params) {
        this.updateToolbar(options);
        await this.#uiManager.updateMode(options.mode);
        const { offsetX: offsetX, offsetY: offsetY } = this.#getCenterPoint();
        const id = this.#uiManager.getId();
        const editor = this.#createNewEditor({
            parent: this,
            id: id,
            x: offsetX,
            y: offsetY,
            uiManager: this.#uiManager,
            isCentered: true,
            ...params
        });
        if (editor) this.add(editor);
    }
    async deserialize(data) {
        return await $b3a01b20dd2ade98$export$47948c9fe1adbf1b.#editorTypes.get(data.annotationType ?? data.annotationEditorType)?.deserialize(data, this, this.#uiManager) || null;
    }
    createAndAddNewEditor(event, isCentered, data = {}) {
        const id = this.#uiManager.getId();
        const editor = this.#createNewEditor({
            parent: this,
            id: id,
            x: event.offsetX,
            y: event.offsetY,
            uiManager: this.#uiManager,
            isCentered: isCentered,
            ...data
        });
        if (editor) this.add(editor);
        return editor;
    }
    get boundingClientRect() {
        return this.div.getBoundingClientRect();
    }
    #getCenterPoint() {
        const { x: x, y: y, width: width, height: height } = this.boundingClientRect;
        const tlX = Math.max(0, x);
        const tlY = Math.max(0, y);
        const brX = Math.min(window.innerWidth, x + width);
        const brY = Math.min(window.innerHeight, y + height);
        const centerX = (tlX + brX) / 2 - x;
        const centerY = (tlY + brY) / 2 - y;
        const [offsetX, offsetY] = this.viewport.rotation % 180 === 0 ? [
            centerX,
            centerY
        ] : [
            centerY,
            centerX
        ];
        return {
            offsetX: offsetX,
            offsetY: offsetY
        };
    }
    addNewEditor(data = {}) {
        this.createAndAddNewEditor(this.#getCenterPoint(), true, data);
    }
    setSelected(editor) {
        this.#uiManager.setSelected(editor);
    }
    toggleSelected(editor) {
        this.#uiManager.toggleSelected(editor);
    }
    unselect(editor) {
        this.#uiManager.unselect(editor);
    }
    pointerup(event) {
        const { isMac: isMac } = $b3a01b20dd2ade98$export$5fb8891d35c36978.platform;
        if (event.button !== 0 || event.ctrlKey && isMac) return;
        if (event.target !== this.div) return;
        if (!this.#hadPointerDown) return;
        this.#hadPointerDown = false;
        if (this.#currentEditorType?.isDrawer && this.#currentEditorType.supportMultipleDrawings) return;
        if (!this.#allowClick) {
            this.#allowClick = true;
            return;
        }
        const currentMode = this.#uiManager.getMode();
        if (currentMode === $b3a01b20dd2ade98$export$72ea3bfdd9a725bf.STAMP || currentMode === $b3a01b20dd2ade98$export$72ea3bfdd9a725bf.POPUP || currentMode === $b3a01b20dd2ade98$export$72ea3bfdd9a725bf.SIGNATURE) {
            this.#uiManager.unselectAll();
            return;
        }
        this.createAndAddNewEditor(event, false);
    }
    pointerdown(event) {
        if (this.#uiManager.getMode() === $b3a01b20dd2ade98$export$72ea3bfdd9a725bf.HIGHLIGHT) this.enableTextSelection();
        if (this.#hadPointerDown) {
            this.#hadPointerDown = false;
            return;
        }
        const { isMac: isMac } = $b3a01b20dd2ade98$export$5fb8891d35c36978.platform;
        if (event.button !== 0 || event.ctrlKey && isMac) return;
        if (event.target !== this.div) return;
        this.#hadPointerDown = true;
        if (this.#currentEditorType?.isDrawer) {
            this.startDrawingSession(event);
            return;
        }
        const editor = this.#uiManager.getActive();
        this.#allowClick = !editor || editor.isEmpty();
    }
    startDrawingSession(event) {
        this.div.focus({
            preventScroll: true
        });
        if (this.#drawingAC) {
            this.#currentEditorType.startDrawing(this, this.#uiManager, false, event);
            return;
        }
        this.#uiManager.setCurrentDrawingSession(this);
        this.#drawingAC = new AbortController();
        const signal = this.#uiManager.combinedSignal(this.#drawingAC);
        this.div.addEventListener("blur", ({ relatedTarget: relatedTarget })=>{
            if (relatedTarget && !this.div.contains(relatedTarget)) {
                this.#focusedElement = null;
                this.commitOrRemove();
            }
        }, {
            signal: signal
        });
        this.#currentEditorType.startDrawing(this, this.#uiManager, false, event);
    }
    pause(on) {
        if (on) {
            const { activeElement: activeElement } = document;
            if (this.div.contains(activeElement)) this.#focusedElement = activeElement;
            return;
        }
        if (this.#focusedElement) setTimeout(()=>{
            this.#focusedElement?.focus();
            this.#focusedElement = null;
        }, 0);
    }
    endDrawingSession(isAborted = false) {
        if (!this.#drawingAC) return null;
        this.#uiManager.setCurrentDrawingSession(null);
        this.#drawingAC.abort();
        this.#drawingAC = null;
        this.#focusedElement = null;
        return this.#currentEditorType.endDrawing(isAborted);
    }
    findNewParent(editor, x, y) {
        const layer = this.#uiManager.findParent(x, y);
        if (layer === null || layer === this) return false;
        layer.changeParent(editor);
        return true;
    }
    commitOrRemove() {
        if (this.#drawingAC) {
            this.endDrawingSession();
            return true;
        }
        return false;
    }
    onScaleChanging() {
        if (!this.#drawingAC) return;
        this.#currentEditorType.onScaleChangingWhenDrawing(this);
    }
    destroy() {
        this.commitOrRemove();
        if (this.#uiManager.getActive()?.parent === this) {
            this.#uiManager.commitOrRemove();
            this.#uiManager.setActiveEditor(null);
        }
        if (this.#editorFocusTimeoutId) {
            clearTimeout(this.#editorFocusTimeoutId);
            this.#editorFocusTimeoutId = null;
        }
        for (const editor of this.#editors.values()){
            this.#accessibilityManager?.removePointerInTextLayer(editor.contentDiv);
            editor.setParent(null);
            editor.isAttachedToDOM = false;
            editor.div.remove();
        }
        this.div = null;
        this.#editors.clear();
        this.#uiManager.removeLayer(this);
    }
    #cleanup() {
        for (const editor of this.#editors.values())if (editor.isEmpty()) editor.remove();
    }
    async render({ viewport: viewport }) {
        this.viewport = viewport;
        $b3a01b20dd2ade98$export$af0a15a86e590226(this.div, viewport);
        for (const editor of this.#uiManager.getEditors(this.pageIndex)){
            this.add(editor);
            editor.rebuild();
        }
        await this.#uiManager.findClonesForPage(this);
        this.div.hidden = this.isEmpty;
        this.updateMode();
    }
    update({ viewport: viewport }) {
        this.#uiManager.commitOrRemove();
        this.#cleanup();
        const oldRotation = this.viewport.rotation;
        const rotation = viewport.rotation;
        this.viewport = viewport;
        $b3a01b20dd2ade98$export$af0a15a86e590226(this.div, {
            rotation: rotation
        });
        if (oldRotation !== rotation) for (const editor of this.#editors.values())editor.rotate(rotation);
    }
    get pageDimensions() {
        const { pageWidth: pageWidth, pageHeight: pageHeight } = this.viewport.rawDims;
        return [
            pageWidth,
            pageHeight
        ];
    }
    get scale() {
        return this.#uiManager.viewParameters.realScale;
    }
}
class $b3a01b20dd2ade98$export$3eb4521511f02450 {
    #parent = null;
    #mapping = new Map();
    #toUpdate = new Map();
    static #id = 0;
    setParent(parent) {
        if (!this.#parent) {
            this.#parent = parent;
            return;
        }
        if (this.#parent !== parent) {
            if (this.#mapping.size > 0) for (const root of this.#mapping.values()){
                root.remove();
                parent.append(root);
            }
            this.#parent = parent;
        }
    }
    static get _svgFactory() {
        return $b3a01b20dd2ade98$export$b8972b998723d602(this, "_svgFactory", new $b3a01b20dd2ade98$export$425e69f00724e63a());
    }
    static #setBox(element, [x, y, width, height]) {
        const { style: style } = element;
        style.top = `${100 * y}%`;
        style.left = `${100 * x}%`;
        style.width = `${100 * width}%`;
        style.height = `${100 * height}%`;
    }
    #createSVG() {
        const svg = $b3a01b20dd2ade98$export$3eb4521511f02450._svgFactory.create(1, 1, true);
        this.#parent.append(svg);
        svg.setAttribute("aria-hidden", true);
        return svg;
    }
    #createClipPath(defs, pathId) {
        const clipPath = $b3a01b20dd2ade98$export$3eb4521511f02450._svgFactory.createElement("clipPath");
        defs.append(clipPath);
        const clipPathId = `clip_${pathId}`;
        clipPath.setAttribute("id", clipPathId);
        clipPath.setAttribute("clipPathUnits", "objectBoundingBox");
        const clipPathUse = $b3a01b20dd2ade98$export$3eb4521511f02450._svgFactory.createElement("use");
        clipPath.append(clipPathUse);
        clipPathUse.setAttribute("href", `#${pathId}`);
        clipPathUse.classList.add("clip");
        return clipPathId;
    }
    #updateProperties(element, properties) {
        for (const [key, value] of Object.entries(properties))if (value === null) element.removeAttribute(key);
        else element.setAttribute(key, value);
    }
    draw(properties, isPathUpdatable = false, hasClip = false) {
        const id = $b3a01b20dd2ade98$export$3eb4521511f02450.#id++;
        const root = this.#createSVG();
        const defs = $b3a01b20dd2ade98$export$3eb4521511f02450._svgFactory.createElement("defs");
        root.append(defs);
        const path = $b3a01b20dd2ade98$export$3eb4521511f02450._svgFactory.createElement("path");
        defs.append(path);
        const pathId = `path_${id}`;
        path.setAttribute("id", pathId);
        path.setAttribute("vector-effect", "non-scaling-stroke");
        if (isPathUpdatable) this.#toUpdate.set(id, path);
        const clipPathId = hasClip ? this.#createClipPath(defs, pathId) : null;
        const use = $b3a01b20dd2ade98$export$3eb4521511f02450._svgFactory.createElement("use");
        root.append(use);
        use.setAttribute("href", `#${pathId}`);
        this.updateProperties(root, properties);
        this.#mapping.set(id, root);
        return {
            id: id,
            clipPathId: `url(#${clipPathId})`
        };
    }
    drawOutline(properties, mustRemoveSelfIntersections) {
        const id = $b3a01b20dd2ade98$export$3eb4521511f02450.#id++;
        const root = this.#createSVG();
        const defs = $b3a01b20dd2ade98$export$3eb4521511f02450._svgFactory.createElement("defs");
        root.append(defs);
        const path = $b3a01b20dd2ade98$export$3eb4521511f02450._svgFactory.createElement("path");
        defs.append(path);
        const pathId = `path_${id}`;
        path.setAttribute("id", pathId);
        path.setAttribute("vector-effect", "non-scaling-stroke");
        let maskId;
        if (mustRemoveSelfIntersections) {
            const mask = $b3a01b20dd2ade98$export$3eb4521511f02450._svgFactory.createElement("mask");
            defs.append(mask);
            maskId = `mask_${id}`;
            mask.setAttribute("id", maskId);
            mask.setAttribute("maskUnits", "objectBoundingBox");
            const rect = $b3a01b20dd2ade98$export$3eb4521511f02450._svgFactory.createElement("rect");
            mask.append(rect);
            rect.setAttribute("width", "1");
            rect.setAttribute("height", "1");
            rect.setAttribute("fill", "white");
            const use = $b3a01b20dd2ade98$export$3eb4521511f02450._svgFactory.createElement("use");
            mask.append(use);
            use.setAttribute("href", `#${pathId}`);
            use.setAttribute("stroke", "none");
            use.setAttribute("fill", "black");
            use.setAttribute("fill-rule", "nonzero");
            use.classList.add("mask");
        }
        const use1 = $b3a01b20dd2ade98$export$3eb4521511f02450._svgFactory.createElement("use");
        root.append(use1);
        use1.setAttribute("href", `#${pathId}`);
        if (maskId) use1.setAttribute("mask", `url(#${maskId})`);
        const use2 = use1.cloneNode();
        root.append(use2);
        use1.classList.add("mainOutline");
        use2.classList.add("secondaryOutline");
        this.updateProperties(root, properties);
        this.#mapping.set(id, root);
        return id;
    }
    finalizeDraw(id, properties) {
        this.#toUpdate.delete(id);
        this.updateProperties(id, properties);
    }
    updateProperties(elementOrId, properties) {
        if (!properties) return;
        const { root: root, bbox: bbox, rootClass: rootClass, path: path } = properties;
        const element = typeof elementOrId === "number" ? this.#mapping.get(elementOrId) : elementOrId;
        if (!element) return;
        if (root) this.#updateProperties(element, root);
        if (bbox) $b3a01b20dd2ade98$export$3eb4521511f02450.#setBox(element, bbox);
        if (rootClass) {
            const { classList: classList } = element;
            for (const [className, value] of Object.entries(rootClass))classList.toggle(className, value);
        }
        if (path) {
            const defs = element.firstElementChild;
            const pathElement = defs.firstElementChild;
            this.#updateProperties(pathElement, path);
        }
    }
    updateParent(id, layer) {
        if (layer === this) return;
        const root = this.#mapping.get(id);
        if (!root) return;
        layer.#parent.append(root);
        this.#mapping.delete(id);
        layer.#mapping.set(id, root);
    }
    remove(id) {
        this.#toUpdate.delete(id);
        if (this.#parent === null) return;
        this.#mapping.get(id).remove();
        this.#mapping.delete(id);
    }
    destroy() {
        this.#parent = null;
        for (const root of this.#mapping.values())root.remove();
        this.#mapping.clear();
        this.#toUpdate.clear();
    }
}
function $b3a01b20dd2ade98$var$percentage(value) {
    return `${(value * 100).toFixed(2)}%`;
}
class $b3a01b20dd2ade98$export$f44e3dd51af47bcc {
    #coordinates = [];
    #coordinatesByElement = new Map();
    #getPageCanvas = null;
    #minSize = 0;
    #pageWidth = 0;
    #pageHeight = 0;
    static #activeImage = null;
    constructor(minSize, coordinates, viewport, getPageCanvas){
        this.#minSize = minSize;
        this.#coordinates = coordinates;
        this.#pageWidth = viewport.rawDims.pageWidth;
        this.#pageHeight = viewport.rawDims.pageHeight;
        this.#getPageCanvas = getPageCanvas;
    }
    render() {
        const container = document.createElement("div");
        container.className = "textLayerImages";
        for(let i = 0; i < this.#coordinates.length; i += 6){
            const el = this.#createImagePlaceholder(this.#coordinates.subarray(i, i + 6));
            if (el) container.append(el);
        }
        container.addEventListener("contextmenu", (event)=>{
            if (!(event.target instanceof HTMLCanvasElement)) return;
            const imgElement = event.target;
            const coords = this.#coordinatesByElement.get(imgElement);
            if (!coords) return;
            const activeImage = $b3a01b20dd2ade98$export$f44e3dd51af47bcc.#activeImage?.deref();
            if (activeImage === imgElement) return;
            if (activeImage) {
                activeImage.width = 0;
                activeImage.height = 0;
            }
            $b3a01b20dd2ade98$export$f44e3dd51af47bcc.#activeImage = new WeakRef(imgElement);
            const { inverseTransform: inverseTransform, x1: x1, y1: y1, width: width, height: height } = coords;
            const pageCanvas = this.#getPageCanvas();
            const imageX1 = Math.ceil(x1 * pageCanvas.width);
            const imageY1 = Math.ceil(y1 * pageCanvas.height);
            const imageX2 = Math.floor((x1 + width / this.#pageWidth) * pageCanvas.width);
            const imageY2 = Math.floor((y1 + height / this.#pageHeight) * pageCanvas.height);
            imgElement.width = imageX2 - imageX1;
            imgElement.height = imageY2 - imageY1;
            const ctx = imgElement.getContext("2d");
            ctx.setTransform(...inverseTransform);
            ctx.translate(-imageX1, -imageY1);
            ctx.drawImage(pageCanvas, 0, 0);
        });
        return container;
    }
    #createImagePlaceholder([x1, y1, x2, y2, x3, y3]) {
        const width = Math.hypot((x3 - x1) * this.#pageWidth, (y3 - y1) * this.#pageHeight);
        const height = Math.hypot((x2 - x1) * this.#pageWidth, (y2 - y1) * this.#pageHeight);
        if (width < this.#minSize || height < this.#minSize) return null;
        const transform = [
            (x3 - x1) * this.#pageWidth / width,
            (y3 - y1) * this.#pageHeight / width,
            (x2 - x1) * this.#pageWidth / height,
            (y2 - y1) * this.#pageHeight / height,
            0,
            0
        ];
        const inverseTransform = $b3a01b20dd2ade98$export$f8f26dd395d7e1bd.inverseTransform(transform);
        const imgElement = document.createElement("canvas");
        imgElement.className = "textLayerImagePlaceholder";
        imgElement.width = 0;
        imgElement.height = 0;
        Object.assign(imgElement.style, {
            opacity: 0,
            position: "absolute",
            left: $b3a01b20dd2ade98$var$percentage(x1),
            top: $b3a01b20dd2ade98$var$percentage(y1),
            width: $b3a01b20dd2ade98$var$percentage(width / this.#pageWidth),
            height: $b3a01b20dd2ade98$var$percentage(height / this.#pageHeight),
            transformOrigin: "0% 0%",
            transform: `matrix(${transform.join(",")})`
        });
        this.#coordinatesByElement.set(imgElement, {
            inverseTransform: inverseTransform,
            width: width,
            height: height,
            x1: x1,
            y1: y1
        });
        return imgElement;
    }
}
globalThis._pdfjsTestingUtils = {
    HighlightOutliner: $b3a01b20dd2ade98$var$HighlightOutliner
};
globalThis.pdfjsLib = {
    AbortException: $b3a01b20dd2ade98$export$d0e978393d193d1a,
    AnnotationEditorLayer: $b3a01b20dd2ade98$export$47948c9fe1adbf1b,
    AnnotationEditorParamsType: $b3a01b20dd2ade98$export$cf3df2a6ecc26692,
    AnnotationEditorType: $b3a01b20dd2ade98$export$72ea3bfdd9a725bf,
    AnnotationEditorUIManager: $b3a01b20dd2ade98$export$26cb16552a82cf63,
    AnnotationLayer: $b3a01b20dd2ade98$export$3e7f45c326d9366c,
    AnnotationMode: $b3a01b20dd2ade98$export$5a7af0c07e33392e,
    AnnotationType: $b3a01b20dd2ade98$export$f50c3066a53a6f2c,
    applyOpacity: $b3a01b20dd2ade98$export$f8d1472813e87bf9,
    build: $b3a01b20dd2ade98$export$3f8fe6489e95757d,
    ColorPicker: $b3a01b20dd2ade98$export$9feb1bc2e5f1ccb3,
    createValidAbsoluteUrl: $b3a01b20dd2ade98$export$e076b47f5805ca0b,
    CSSConstants: $b3a01b20dd2ade98$export$cec677744f6a5015,
    DOMSVGFactory: $b3a01b20dd2ade98$export$425e69f00724e63a,
    DrawLayer: $b3a01b20dd2ade98$export$3eb4521511f02450,
    FeatureTest: $b3a01b20dd2ade98$export$5fb8891d35c36978,
    fetchData: $b3a01b20dd2ade98$export$8134c072fddab6a5,
    findContrastColor: $b3a01b20dd2ade98$export$7a96203b1fdebe8d,
    getDocument: $b3a01b20dd2ade98$export$f65ca476c09acec0,
    getFilenameFromUrl: $b3a01b20dd2ade98$export$b1c11df0696253ae,
    getPdfFilenameFromUrl: $b3a01b20dd2ade98$export$9de51790aa4bc73a,
    getRGB: $b3a01b20dd2ade98$export$2a2e9b507863ddda,
    getUuid: $b3a01b20dd2ade98$export$75f13a91ebdf8eb3,
    getXfaPageViewport: $b3a01b20dd2ade98$export$dd5d6edf3fc80aae,
    GlobalWorkerOptions: $b3a01b20dd2ade98$export$edf38ba293eb934,
    ImageKind: $b3a01b20dd2ade98$export$b890e9c15247e0b3,
    InvalidPDFException: $b3a01b20dd2ade98$export$e3d0f4ce5b91e9f1,
    isDataScheme: $b3a01b20dd2ade98$export$f67aae4532d8295b,
    isPdfFile: $b3a01b20dd2ade98$export$61b52d3570d24719,
    isValidExplicitDest: $b3a01b20dd2ade98$export$b5acece0a447dcdc,
    makeArr: $b3a01b20dd2ade98$export$be9af9a47496243a,
    makeMap: $b3a01b20dd2ade98$export$b41394a5437791c8,
    makeObj: $b3a01b20dd2ade98$export$5b3b706fb9845c88,
    MathClamp: $b3a01b20dd2ade98$export$b8106b171181a554,
    noContextMenu: $b3a01b20dd2ade98$export$455b7811f904cadc,
    normalizeUnicode: $b3a01b20dd2ade98$export$1fa1e6b1a06bd7fa,
    OPS: $b3a01b20dd2ade98$export$3a0f7f7a8a0b306b,
    OutputScale: $b3a01b20dd2ade98$export$f16a99f63bccd50b,
    PasswordResponses: $b3a01b20dd2ade98$export$5e72215208e4d9ad,
    PDFDataRangeTransport: $b3a01b20dd2ade98$export$c06899d9d7bce9ab,
    PDFDateString: $b3a01b20dd2ade98$export$66cbc314498fffc,
    PDFWorker: $b3a01b20dd2ade98$export$84e2e9f37426b265,
    PermissionFlag: $b3a01b20dd2ade98$export$bb99a5b8411e07d8,
    PixelsPerInch: $b3a01b20dd2ade98$export$6ef3b6b69e65342c,
    RenderingCancelledException: $b3a01b20dd2ade98$export$245847d31c09154f,
    renderRichText: $b3a01b20dd2ade98$export$611c480766035c4,
    ResponseException: $b3a01b20dd2ade98$export$ea8e9c34f66e603,
    setLayerDimensions: $b3a01b20dd2ade98$export$af0a15a86e590226,
    shadow: $b3a01b20dd2ade98$export$b8972b998723d602,
    SignatureExtractor: $b3a01b20dd2ade98$export$cc4fe8633f466b4a,
    stopEvent: $b3a01b20dd2ade98$export$7ae4cd3a66c1e050,
    SupportedImageMimeTypes: $b3a01b20dd2ade98$export$3234c88e9de64a88,
    TextLayer: $b3a01b20dd2ade98$export$fdbdc423a78c5262,
    TextLayerImages: $b3a01b20dd2ade98$export$f44e3dd51af47bcc,
    TouchManager: $b3a01b20dd2ade98$export$9ae7542b430d543e,
    updateUrlHash: $b3a01b20dd2ade98$export$e1e4297c21ab9d13,
    Util: $b3a01b20dd2ade98$export$f8f26dd395d7e1bd,
    VerbosityLevel: $b3a01b20dd2ade98$export$b18df09d23c244c4,
    version: $b3a01b20dd2ade98$export$83d89fbfd8236492,
    XfaLayer: $b3a01b20dd2ade98$export$f6af20c312d4b9a2
};


var $476338592ba8a76c$exports = {};
$476338592ba8a76c$exports = $parcel$resolve("94LWX");


let $b25dfe2ee2c25921$var$workerReadyPromise = null;
function $b25dfe2ee2c25921$var$ensurePdfWorker() {
    if (!$b25dfe2ee2c25921$var$workerReadyPromise) {
        $b3a01b20dd2ade98$export$edf38ba293eb934.workerSrc = (0, (/*@__PURE__*/$parcel$interopDefault($476338592ba8a76c$exports)));
        $b25dfe2ee2c25921$var$workerReadyPromise = Promise.resolve();
    }
    return $b25dfe2ee2c25921$var$workerReadyPromise;
}
const $b25dfe2ee2c25921$var$myPdfs = {};
function $b25dfe2ee2c25921$var$renderPdf(pdfs, canvas, pageno, scale, width) {
    const pdf = pdfs.pdf;
    pdf.getPage(pageno).then(function(page) {
        let viewport = page.getViewport({
            scale: scale
        });
        if (width) {
            const wscale = width / viewport.width;
            const newScale = wscale * scale;
            const height = wscale * viewport.height;
            viewport = page.getViewport({
                scale: newScale
            });
            viewport.width = width;
            viewport.height = height;
        }
        const context = canvas.getContext("2d", {
            alpha: false
        });
        const outputScale = $b25dfe2ee2c25921$var$getOutputScale(context);
        canvas.width = viewport.width * outputScale.sx | 0;
        canvas.height = viewport.height * outputScale.sy | 0;
        canvas.style.height = viewport.height + "px";
        canvas.style.width = viewport.width + "px";
        context.scale(outputScale.sx, outputScale.sy);
        pdfs.prevHeight = viewport.height;
        pdfs.prevWidth = viewport.width;
        const renderContext = {
            canvasContext: context,
            viewport: viewport
        };
        page.render(renderContext);
    });
}
function $b25dfe2ee2c25921$var$getOutputScale(ctx) {
    const devicePixelRatio = window.devicePixelRatio || 1;
    const backingStoreRatio = ctx.webkitBackingStorePixelRatio || ctx.mozBackingStorePixelRatio || ctx.msBackingStorePixelRatio || ctx.oBackingStorePixelRatio || ctx.backingStorePixelRatio || 1;
    const pixelRatio = devicePixelRatio / backingStoreRatio;
    return {
        sx: pixelRatio,
        sy: pixelRatio,
        scaled: pixelRatio !== 1
    };
}
class $b25dfe2ee2c25921$var$PdfViewerCustomElement extends HTMLElement {
    constructor(){
        super();
        const shadow = this.attachShadow({
            mode: "open"
        });
        this.canvas = document.createElement("canvas");
        shadow.appendChild(this.canvas);
    }
    connectedCallback() {
        const name = this.getAttribute("name");
        const page = parseInt(this.getAttribute("page"), 10);
        const widthRaw = Number.parseFloat(this.getAttribute("width"));
        const width = Number.isFinite(widthRaw) ? widthRaw : undefined;
        const pdf = $b25dfe2ee2c25921$var$myPdfs[name];
        if (pdf) {
            if (width) this.canvas.width = width;
            else if (pdf.prevWidth) this.canvas.width = pdf.prevWidth;
            if (pdf.prevHeight) this.canvas.height = pdf.prevHeight;
            $b25dfe2ee2c25921$var$renderPdf(pdf, this.canvas, page, 1, width);
        }
    }
}
function $b25dfe2ee2c25921$var$formatPdfError(reason) {
    if (reason == null) return "unknown error";
    if (typeof reason === "string") return reason;
    if (typeof reason === "object" && reason.message) return String(reason.message);
    return String(reason);
}
function $b25dfe2ee2c25921$var$pdfCommandHandler(app, cmd) {
    if (!app.ports.receivePdfMsg) return;
    if (cmd.cmd === "openurl") $b3a01b20dd2ade98$export$f65ca476c09acec0(cmd.url).promise.then(function(pdf) {
        $b25dfe2ee2c25921$var$myPdfs[cmd.name] = {
            pdf: pdf
        };
        app.ports.receivePdfMsg.send({
            msg: "loaded",
            name: cmd.name,
            pageCount: pdf.numPages
        });
    }, function(reason) {
        app.ports.receivePdfMsg.send({
            msg: "error",
            name: cmd.name,
            error: $b25dfe2ee2c25921$var$formatPdfError(reason)
        });
    });
    else if (cmd.cmd === "openstring") {
        const buff = Uint8Array.from(atob(cmd.string), (c)=>c.charCodeAt(0));
        $b3a01b20dd2ade98$export$f65ca476c09acec0(buff).promise.then(function(pdf) {
            $b25dfe2ee2c25921$var$myPdfs[cmd.name] = {
                pdf: pdf
            };
            app.ports.receivePdfMsg.send({
                msg: "loaded",
                name: cmd.name,
                pageCount: pdf.numPages
            });
        }, function(reason) {
            app.ports.receivePdfMsg.send({
                msg: "error",
                name: cmd.name,
                error: $b25dfe2ee2c25921$var$formatPdfError(reason)
            });
        });
    } else if (cmd.cmd === "close") {
        const entry = $b25dfe2ee2c25921$var$myPdfs[cmd.name];
        if (entry && entry.pdf) entry.pdf.destroy().then(function() {
            delete $b25dfe2ee2c25921$var$myPdfs[cmd.name];
        }).catch(function() {
            delete $b25dfe2ee2c25921$var$myPdfs[cmd.name];
        });
        else delete $b25dfe2ee2c25921$var$myPdfs[cmd.name];
    } else app.ports.receivePdfMsg.send({
        msg: "error",
        name: typeof cmd.name === "string" ? cmd.name : "",
        error: "invalid command to pdf-element: " + cmd.cmd
    });
}
const $b25dfe2ee2c25921$var$PdfPreviewPort = {
    add: function(app) {
        if (typeof customElements !== "undefined" && !customElements.get("pdf-element")) customElements.define("pdf-element", $b25dfe2ee2c25921$var$PdfViewerCustomElement);
        if (app.ports.sendPdfCommand) app.ports.sendPdfCommand.subscribe(function(cmd) {
            $b25dfe2ee2c25921$var$ensurePdfWorker().then(function() {
                $b25dfe2ee2c25921$var$pdfCommandHandler(app, cmd);
            }).catch(function(err) {
                if (app.ports.receivePdfMsg) app.ports.receivePdfMsg.send({
                    msg: "error",
                    name: typeof cmd.name === "string" ? cmd.name : "",
                    error: $b25dfe2ee2c25921$var$formatPdfError(err)
                });
            });
        });
    }
};
var $b25dfe2ee2c25921$export$2e2bcd8739ae039 = $b25dfe2ee2c25921$var$PdfPreviewPort;


var $91f945baf304556d$exports = {};
$91f945baf304556d$exports = $parcel$resolve("hW73M");


function $5b09ccb12fff0951$var$appendPreFallback(el, xmlText) {
    const pre = document.createElement("pre");
    pre.className = "whitespace-pre-wrap break-words rounded-md bg-gray-50 p-3 text-xs text-gray-800";
    pre.textContent = xmlText;
    el.appendChild(pre);
}
function $5b09ccb12fff0951$var$hasXmlParserError(doc) {
    return doc.getElementsByTagName("parsererror").length > 0;
}
let $5b09ccb12fff0951$var$xslCachePromise = null;
function $5b09ccb12fff0951$var$loadXslText() {
    if (!$5b09ccb12fff0951$var$xslCachePromise) $5b09ccb12fff0951$var$xslCachePromise = fetch((0, (/*@__PURE__*/$parcel$interopDefault($91f945baf304556d$exports)))).then((res)=>{
        if (!res.ok) throw new Error("xsl fetch failed");
        return res.text();
    });
    return $5b09ccb12fff0951$var$xslCachePromise;
}
const $5b09ccb12fff0951$var$XmlPreviewPort = {
    add (app) {
        if (!app.ports.requestXmlPreview || !app.ports.xmlPreviewResult) return;
        app.ports.requestXmlPreview.subscribe(async ({ requestId: requestId, url: url, elementId: elementId })=>{
            const sendFail = ()=>{
                app.ports.xmlPreviewResult.send({
                    requestId: requestId,
                    ok: false
                });
            };
            try {
                const el = document.getElementById(elementId);
                if (!el) {
                    sendFail();
                    return;
                }
                const res = await fetch(url);
                if (!res.ok) {
                    sendFail();
                    return;
                }
                const xmlText = await res.text();
                el.replaceChildren();
                const parser = new DOMParser();
                const xmlDoc = parser.parseFromString(xmlText, "application/xml");
                if ($5b09ccb12fff0951$var$hasXmlParserError(xmlDoc)) {
                    $5b09ccb12fff0951$var$appendPreFallback(el, xmlText);
                    app.ports.xmlPreviewResult.send({
                        requestId: requestId,
                        ok: true
                    });
                    return;
                }
                try {
                    const xslText = await $5b09ccb12fff0951$var$loadXslText();
                    const xsltProcessor = new XSLTProcessor();
                    const xslDoc = parser.parseFromString(xslText, "application/xml");
                    if ($5b09ccb12fff0951$var$hasXmlParserError(xslDoc)) throw new Error("Invalid XSL");
                    xsltProcessor.importStylesheet(xslDoc);
                    const fragment = xsltProcessor.transformToFragment(xmlDoc, document);
                    el.appendChild(fragment);
                } catch  {
                    $5b09ccb12fff0951$var$appendPreFallback(el, xmlText);
                }
                app.ports.xmlPreviewResult.send({
                    requestId: requestId,
                    ok: true
                });
            } catch  {
                sendFail();
            }
        });
        if (app.ports.clearXmlMount) app.ports.clearXmlMount.subscribe((elementId)=>{
            if (!elementId) return;
            const mount = document.getElementById(elementId);
            if (mount) mount.replaceChildren();
        });
    }
};
var $5b09ccb12fff0951$export$2e2bcd8739ae039 = $5b09ccb12fff0951$var$XmlPreviewPort;


var $397bcf58b99e38b9$exports = {};
const $397bcf58b99e38b9$var$WindowPort = {
    add: function(app) {
        const isInView = function(element) {
            if (!element) return false;
            const rect = element.getBoundingClientRect();
            return rect.top >= 0 && rect.bottom <= window.innerHeight && rect.left >= 0 && rect.right <= window.innerWidth;
        };
        app.ports.scrollTopAndIntoView.subscribe(function(elementId) {
            var element = document.getElementById(elementId);
            if (!element) return;
            // don't scroll if already visible
            if (isInView(element)) return;
            var scrollTimeout;
            var handleScroll = function() {
                clearTimeout(scrollTimeout);
                scrollTimeout = setTimeout(function() {
                    removeEventListener("scroll", handleScroll, true);
                    setTimeout(function() {
                        window.scroll({
                            top: 0,
                            behavior: "smooth"
                        });
                    }, 250);
                }, 100);
            };
            addEventListener("scroll", handleScroll, true);
            element.scrollIntoView({
                behavior: "smooth",
                block: "end"
            });
        });
        app.ports.scrollIdIntoView.subscribe(function(elementId) {
            var element = document.getElementById(elementId);
            if (!element) return;
            // don't scroll if already visible
            if (isInView(element)) return;
            element.scrollIntoView({
                behavior: "smooth"
            });
        });
        app.ports.scrollIdToBottom.subscribe(function(elementId) {
            var element = document.getElementById(elementId);
            if (!element) return;
            element.scrollIntoView({
                behavior: "smooth",
                block: "end"
            });
        });
        var scrollTimer = null;
        var lastScrollFireTime = 0;
        var minScrollTime = 100;
        window.addEventListener("scroll", ()=>{
            if (!scrollTimer) {
                var now = new Date().getTime();
                if (now - lastScrollFireTime > minScrollTime) {
                    app.ports.onWindowScroll.send({
                        x: window.scrollX,
                        y: window.scrollY
                    });
                    lastScrollFireTime = now;
                }
                scrollTimer = setTimeout(function() {
                    scrollTimer = null;
                    lastScrollFireTime = new Date().getTime();
                    app.ports.onWindowScroll.send({
                        x: window.scrollX,
                        y: window.scrollY
                    });
                }, minScrollTime);
            }
        });
        app.ports.printWindow.subscribe(function() {
            window.print();
        });
    }
};
$397bcf58b99e38b9$exports = $397bcf58b99e38b9$var$WindowPort;


var $0d34a6c94bf1f37e$exports = {};
/* global google */ var $a74131a19464fd13$exports = {};
!function(o, e) {
    e($a74131a19464fd13$exports);
}($a74131a19464fd13$exports, function(o) {
    "use strict";
    const e = (o)=>{
        var e, n, r, t = "The Google Maps JavaScript API", a = "google", i = "importLibrary", s = "__ib__", p = document, c = window, l = c[a] || (c[a] = {}), d = l.maps || (l.maps = {}), m = new Set, g = new URLSearchParams;
        d[i] ? console.warn(t + " only loads once. Ignoring:", o) : d[i] = (c, ...l)=>m.add(c) && (e || (e = new Promise(async (i, c)=>{
                for(r in await (n = p.createElement("script")), g.set("libraries", [
                    ...m
                ] + ""), o)g.set(r.replace(/[A-Z]/g, (o)=>"_" + o[0].toLowerCase()), o[r]);
                g.set("callback", a + ".maps." + s), function(o, e) {
                    o.src = e;
                }(n, "https://maps.googleapis.com/maps/api/js?" + g), d[s] = i, n.onerror = ()=>e = c(Error(t + " could not load.")), n.nonce = p.querySelector("script[nonce]")?.nonce || "", p.head.append(n);
            }))).then(()=>d[i](c, ...l));
    };
    "production";
    "production";
    let n = !1;
    o.Loader = class {
        constructor(...o){
            throw new Error("[@googlemaps/js-api-loader]: The Loader class is no longer available in this version.\nPlease use the new functional API: setOptions() and importLibrary().\nFor more information, see the updated documentation at: https://github.com/googlemaps/js-api-loader/blob/main/README.md");
        }
    }, o.importLibrary = async function(o) {
        if (!window?.google?.maps?.importLibrary) throw new Error("google.maps.importLibrary is not installed.");
        return await google.maps.importLibrary(o);
    }, o.setOptions = function(o) {
        n ? ((o)=>{
            JSON.stringify(o);
        })(o) : (!function(o) {
            const n = Boolean(window.google?.maps?.importLibrary);
            n && ((o)=>{
                JSON.stringify(o);
            })(o);
            n || e(o);
        }(o), n = !0);
    };
}); //# sourceMappingURL=index.cjs.map


const $0d34a6c94bf1f37e$var$GooglePlacesPort = {
    add: function(app, googleMapsKey) {
        if (!googleMapsKey) throw new Error("Google Maps Key is not configured.");
        let places;
        (0, $a74131a19464fd13$exports.setOptions)({
            key: googleMapsKey
        });
        const fetchAutocompleteSuggestions = (id, request, callback)=>{
            places.AutocompleteSuggestion.fetchAutocompleteSuggestions(request).then(({ suggestions: suggestions })=>{
                const formattedSuggestions = suggestions.map((s)=>{
                    const p = s.placePrediction;
                    return {
                        description: p.text.text,
                        place_id: p.placeId,
                        types: p.types
                    };
                });
                callback({
                    suggestions: formattedSuggestions,
                    id: id
                });
            }).catch((error)=>{
                console.log(error);
            });
        };
        (0, $a74131a19464fd13$exports.importLibrary)("places").then((imported)=>{
            places = imported;
            app.ports.googlePlacesPredictAddress.subscribe(function({ address: address, id: id }) {
                if (!address) return;
                let sessionToken = new places.AutocompleteSessionToken();
                let request = {
                    input: address,
                    sessionToken: sessionToken
                };
                navigator.geolocation.getCurrentPosition(({ coords: { latitude: latitude, longitude: longitude } })=>{
                    fetchAutocompleteSuggestions(id, {
                        ...request,
                        locationBias: {
                            radius: 5000,
                            center: {
                                lat: latitude,
                                lng: longitude
                            }
                        }
                    }, app.ports.googlePlacesAddressSuggestions.send);
                }, ()=>{
                    fetchAutocompleteSuggestions(id, request, app.ports.googlePlacesAddressSuggestions.send);
                });
            });
            app.ports.googlePlacesPredictionDetails.subscribe(function({ placeId: placeId, id: id }) {
                const place = new google.maps.places.Place({
                    id: placeId
                });
                place.fetchFields({
                    fields: [
                        "addressComponents",
                        "formattedAddress",
                        "displayName",
                        "id",
                        "types"
                    ]
                }).then((response)=>{
                    const transformedPlace = {
                        address_components: (response.place.addressComponents || []).map((component)=>({
                                long_name: component.longText,
                                short_name: component.shortText,
                                types: component.types
                            })),
                        formatted_address: response.place.formattedAddress,
                        name: response.place.displayName,
                        place_id: response.place.id,
                        types: response.place.types
                    };
                    const address = JSON.stringify(transformedPlace);
                    app.ports.googlePlacesAddressDetails.send({
                        address: address,
                        id: id
                    });
                }).catch((error)=>{
                    console.log("Error fetching place details:", error);
                    app.ports.googlePlacesAddressDetails.send({
                        address: null,
                        id: id
                    });
                });
            });
        }).catch((error)=>console.log(error));
    }
};
$0d34a6c94bf1f37e$exports = $0d34a6c94bf1f37e$var$GooglePlacesPort;


var $44d2ba25a7bfecb2$exports = {};
/* global CONFIGURATION, grecaptcha */ const $44d2ba25a7bfecb2$var$setup = function() {
    function loadRecaptchaAPI() {
        var script = document.createElement("script");
        script.type = "text/javascript";
        script.src = "https://www.google.com/recaptcha/api.js?render=" + CONFIGURATION.googleRecaptchaSiteKey + "&onload=recaptchaOnLoadfunction";
        document.body.appendChild(script);
    }
    if (CONFIGURATION.googleRecaptchaSiteKey) window.addEventListener("load", loadRecaptchaAPI, false);
};
window.recaptchaLoaded = false;
function $44d2ba25a7bfecb2$var$notifyRecaptchaLoaded(app) {
    setTimeout(function() {
        app.ports.gotRecaptchaInitializedPort.send("Ok");
    }, 0);
}
const $44d2ba25a7bfecb2$var$GoogleRecaptchaPort = {
    add: function(app) {
        window.recaptchaOnLoadfunction = function() {
            window.recaptchaLoaded = true;
            $44d2ba25a7bfecb2$var$notifyRecaptchaLoaded(app);
        };
        app.ports.initializeRecaptchaPort.subscribe(function() {
            if (window.recaptchaLoaded) $44d2ba25a7bfecb2$var$notifyRecaptchaLoaded(app);
        });
        $44d2ba25a7bfecb2$var$setup();
        app.ports.getRecaptchaTokenPort.subscribe(function(action) {
            if (typeof grecaptcha !== "undefined") grecaptcha.ready(function() {
                grecaptcha.execute(CONFIGURATION.googleRecaptchaSiteKey, {
                    action: action
                }).then(function(token) {
                    app.ports.gotRecaptchaTokenPort.send({
                        token: token,
                        result: "ok"
                    });
                }).catch(()=>app.ports.gotRecaptchaTokenPort.send({
                        token: "",
                        result: "remote-error"
                    }));
            });
            else app.ports.gotRecaptchaTokenPort.send({
                token: "",
                result: "recaptcha-not-defined"
            });
        });
    }
};
$44d2ba25a7bfecb2$exports = $44d2ba25a7bfecb2$var$GoogleRecaptchaPort;


var $f2086779cc7dd10e$exports = {};
var $37d19e55f1d922da$exports = {};
"use strict";
Object.defineProperty($37d19e55f1d922da$exports, "__esModule", {
    value: true
});
$37d19e55f1d922da$exports.storageFactory = void 0;
function $37d19e55f1d922da$var$storageFactory(getStorage) {
    var inMemoryStorage = {};
    function isSupported() {
        try {
            var testKey = "__some_random_key_you_are_not_going_to_use__";
            getStorage().setItem(testKey, testKey);
            getStorage().removeItem(testKey);
            return true;
        } catch (e) {
            return false;
        }
    }
    function clear() {
        if (isSupported()) getStorage().clear();
        else inMemoryStorage = {};
    }
    function getItem(name) {
        if (isSupported()) return getStorage().getItem(name);
        if (inMemoryStorage.hasOwnProperty(name)) return inMemoryStorage[name];
        return null;
    }
    function key(index) {
        if (isSupported()) return getStorage().key(index);
        else return Object.keys(inMemoryStorage)[index] || null;
    }
    function removeItem(name) {
        if (isSupported()) getStorage().removeItem(name);
        else delete inMemoryStorage[name];
    }
    function setItem(name, value) {
        if (isSupported()) getStorage().setItem(name, value);
        else inMemoryStorage[name] = String(value);
    }
    function length() {
        if (isSupported()) return getStorage().length;
        else return Object.keys(inMemoryStorage).length;
    }
    return {
        getItem: getItem,
        setItem: setItem,
        removeItem: removeItem,
        clear: clear,
        key: key,
        get length () {
            return length();
        }
    };
}
$37d19e55f1d922da$exports.storageFactory = $37d19e55f1d922da$var$storageFactory;


const $f2086779cc7dd10e$var$storage = (0, $37d19e55f1d922da$exports.storageFactory)(()=>localStorage);
const $f2086779cc7dd10e$var$LocalStoragePort = {
    getItem: $f2086779cc7dd10e$var$storage.getItem,
    add: (app)=>{
        app.ports.setItemPort.subscribe((object)=>{
            $f2086779cc7dd10e$var$storage.setItem(object.key, object.value);
        // Uncomment if you want a SetItem callback
        // app.ports.setItemPortCompleted.send({ value: object.value, itemType: object.itemType, action: object.action });
        });
        app.ports.getItemPort.subscribe(function(object) {
            const value = $f2086779cc7dd10e$var$storage.getItem(object.key);
            app.ports.gotItemPort.send({
                value: value,
                itemType: object.itemType,
                action: object.action
            });
        });
        app.ports.removeItemPort.subscribe(function(object) {
            $f2086779cc7dd10e$var$storage.removeItem(object.key);
            app.ports.removedItemPort.send({
                value: "",
                itemType: object.itemType,
                action: object.action
            });
        });
        window.addEventListener("storage", function(event) {
            if (event.key === "accountToken" && event.newValue === null) app.ports.removedItemPort.send({
                value: "",
                itemType: "AccountToken",
                action: "remove"
            });
        });
    }
};
$f2086779cc7dd10e$exports = $f2086779cc7dd10e$var$LocalStoragePort;


var $36331f456e6baed0$exports = {};
var $602195b98aff1e07$exports = {};
/* global CONFIGURATION */ "use strict";
var $c1c5241450caa1c1$exports = {};
/*! js-cookie v3.0.5 | MIT */ (function(global, factory) {
    $c1c5241450caa1c1$exports = factory();
})($c1c5241450caa1c1$exports, function() {
    'use strict';
    /* eslint-disable no-var */ function assign(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)target[key] = source[key];
        }
        return target;
    }
    /* eslint-enable no-var */ /* eslint-disable no-var */ var defaultConverter = {
        read: function(value) {
            if (value[0] === '"') value = value.slice(1, -1);
            return value.replace(/(%[\dA-F]{2})+/gi, decodeURIComponent);
        },
        write: function(value) {
            return encodeURIComponent(value).replace(/%(2[346BF]|3[AC-F]|40|5[BDE]|60|7[BCD])/g, decodeURIComponent);
        }
    };
    /* eslint-enable no-var */ /* eslint-disable no-var */ function init(converter, defaultAttributes) {
        function set(name, value, attributes) {
            if (typeof document === 'undefined') return;
            attributes = assign({}, defaultAttributes, attributes);
            if (typeof attributes.expires === 'number') attributes.expires = new Date(Date.now() + attributes.expires * 864e5);
            if (attributes.expires) attributes.expires = attributes.expires.toUTCString();
            name = encodeURIComponent(name).replace(/%(2[346B]|5E|60|7C)/g, decodeURIComponent).replace(/[()]/g, escape);
            var stringifiedAttributes = '';
            for(var attributeName in attributes){
                if (!attributes[attributeName]) continue;
                stringifiedAttributes += '; ' + attributeName;
                if (attributes[attributeName] === true) continue;
                // Considers RFC 6265 section 5.2:
                // ...
                // 3.  If the remaining unparsed-attributes contains a %x3B (";")
                //     character:
                // Consume the characters of the unparsed-attributes up to,
                // not including, the first %x3B (";") character.
                // ...
                stringifiedAttributes += '=' + attributes[attributeName].split(';')[0];
            }
            return document.cookie = name + '=' + converter.write(value, name) + stringifiedAttributes;
        }
        function get(name) {
            if (typeof document === 'undefined' || arguments.length && !name) return;
            // To prevent the for loop in the first place assign an empty array
            // in case there are no cookies at all.
            var cookies = document.cookie ? document.cookie.split('; ') : [];
            var jar = {};
            for(var i = 0; i < cookies.length; i++){
                var parts = cookies[i].split('=');
                var value = parts.slice(1).join('=');
                try {
                    var found = decodeURIComponent(parts[0]);
                    jar[found] = converter.read(value, found);
                    if (name === found) break;
                } catch (e) {}
            }
            return name ? jar[name] : jar;
        }
        return Object.create({
            set: set,
            get: get,
            remove: function(name, attributes) {
                set(name, '', assign({}, attributes, {
                    expires: -1
                }));
            },
            withAttributes: function(attributes) {
                return init(this.converter, assign({}, this.attributes, attributes));
            },
            withConverter: function(converter) {
                return init(assign({}, this.converter, converter), this.attributes);
            }
        }, {
            attributes: {
                value: Object.freeze(defaultAttributes)
            },
            converter: {
                value: Object.freeze(converter)
            }
        });
    }
    var api = init(defaultConverter, {
        path: '/'
    });
    /* eslint-enable no-var */ return api;
});


const $602195b98aff1e07$var$isSafari = window.safari !== undefined;
const $602195b98aff1e07$var$cookieOptions = {
    sameSite: "strict",
    secure: true,
    path: "/"
};
if ($602195b98aff1e07$var$isSafari && CONFIGURATION && CONFIGURATION.debugOrTest) delete $602195b98aff1e07$var$cookieOptions["secure"];
const $602195b98aff1e07$var$keyName = window.location.protocol === "https:" ? "__Host-hint.account_token" : "hint.account_token";
$602195b98aff1e07$exports = {
    set: function(value) {
        return $c1c5241450caa1c1$exports.set($602195b98aff1e07$var$keyName, value, $602195b98aff1e07$var$cookieOptions);
    },
    get: function() {
        return $c1c5241450caa1c1$exports.get($602195b98aff1e07$var$keyName);
    },
    remove: function() {
        $c1c5241450caa1c1$exports.remove($602195b98aff1e07$var$keyName, $602195b98aff1e07$var$cookieOptions);
    }
};


const $36331f456e6baed0$var$logoutChannel = new BroadcastChannel("account-token-channel");
const $36331f456e6baed0$var$AccountTokenStoragePort = {
    getItem: function(_key) {
        return $602195b98aff1e07$exports.get();
    },
    add: (app)=>{
        app.ports.setTokenPort.subscribe((object)=>{
            $602195b98aff1e07$exports.set(object.value);
        });
        app.ports.removeTokenPort.subscribe(()=>{
            $602195b98aff1e07$exports.remove();
            $36331f456e6baed0$var$logoutChannel.postMessage("logout");
            app.ports.accountTokenRemovedPort.send(null);
        });
        $36331f456e6baed0$var$logoutChannel.onmessage = (event)=>{
            if (event.data === "logout") app.ports.accountTokenRemovedPort.send(null);
        };
    }
};
$36331f456e6baed0$exports = $36331f456e6baed0$var$AccountTokenStoragePort;


var $1e586fe0a96f962b$exports = {};
const $1e586fe0a96f962b$var$NavigationPort = {
    add: function(app) {
        // Inform app of browser navigation (the BACK and FORWARD buttons)
        window.addEventListener("popstate", function() {
            app.ports.onUrlChange.send(location.href);
        });
        // Change the URL upon request, inform app of the change.
        app.ports.pushUrl.subscribe(function(url) {
            history.pushState({}, "", url);
            app.ports.onUrlChange.send(location.href);
        });
        // Intercept link clicks to change the location without refreshing the page
        document.addEventListener("click", function(event) {
            const { target: target } = event;
            if (event.ctrlKey || event.metaKey) return;
            const isLocalHref = (targetA)=>{
                return targetA.host == location.host;
            };
            const linkElement = target.localName == "a" ? target : target.closest("a");
            if (linkElement && linkElement.href && isLocalHref(linkElement) && linkElement.target !== "_blank") {
                event.preventDefault();
                history.pushState({}, "", linkElement.href);
                app.ports.onUrlChange.send(linkElement.href);
            }
        });
        if (app.ports.openInNewWindow) app.ports.openInNewWindow.subscribe((url)=>{
            const newPage = window.open(url, "_blank");
            if (!newPage) console.warn("Failed to open new window - pop-up may be blocked");
        });
        if (app.ports.replaceUrl) app.ports.replaceUrl.subscribe((url)=>{
            history.replaceState({}, "", url);
        });
    }
};
$1e586fe0a96f962b$exports = $1e586fe0a96f962b$var$NavigationPort;


var $3cef90824005e2d6$exports = {};

const $3cef90824005e2d6$var$SentryPort = {
    add: function(app, env) {
        app.ports.sentryPortCaptureErrorMessage.subscribe(function(messageAndContext) {
            const message = messageAndContext[0];
            const context = messageAndContext[1];
            if (![
                "feature",
                "staging",
                "production"
            ].includes(env)) console.error(message, context);
            $6c9d57d6c1e4fcbb$export$ec58d9285c204497(function(scope) {
                Object.keys(context || {}).forEach(function(contextKey) {
                    scope.setContext(contextKey, context[contextKey]);
                });
                $5125ad3d1e13a914$export$45654777c133ae80(message, "info");
            });
        });
    }
};
$3cef90824005e2d6$exports = $3cef90824005e2d6$var$SentryPort;


var $d5d5137484b98c41$exports = {};
/* global Stripe */ const $d5d5137484b98c41$var$StripePort = {
    add: function(app, publishableKey) {
        if (!window.Stripe) return;
        let stripeElements = {};
        // Cross browser support
        const requestAnimationFrame = window.requestAnimationFrame || window.mozRequestAnimationFrame || window.webkitRequestAnimationFrame || window.msRequestAnimationFrame;
        const mountAttemptsMax = 20;
        let mountAttempts = 0;
        let elements;
        function buildAndMountElementWithSetupIntent(stripeClient, params) {
            const cardElement = document.querySelector(params.selector);
            elements = stripeClient.elements({
                clientSecret: params.setupIntentSecret,
                fonts: [
                    {
                        cssSrc: "https://fonts.googleapis.com/css2?family=Wix+Madefor+Text:ital,wght@0,400..800;1,400..800&display=swap"
                    }
                ],
                appearance: {
                    theme: "flat",
                    variables: {
                        borderRadius: "3px",
                        border: "1px solid #C4DCF8",
                        boxShadow: "none",
                        colorPrimary: "#006CD1",
                        colorText: "#1D2334",
                        colorTextPlaceholder: "#497AA5",
                        colorTextSecondary: "#497AA5",
                        fontFamily: "Wix Madefor Text",
                        fontLineHeight: "21px",
                        colorBackground: "#FFFFFF",
                        fontSize: "1rem",
                        colorIconTabSelected: "#0056A6",
                        colorIconTabHover: "#0056A6"
                    },
                    rules: {
                        ".DropdownItem--highlight": {
                            backgroundColor: "#F1F6FC",
                            border: "1px solid #81AFE4"
                        },
                        ".Tab--selected, .Tab--selected:hover": {
                            borderColor: "#0056A6",
                            color: "#0056A6",
                            backgroundColor: "#f1f6fc"
                        },
                        ".Tab, .Input, .PickerItem": {
                            border: "1px solid #c4dcf8",
                            boxShadow: "none"
                        },
                        ".Input": {
                            padding: "10px",
                            fontSize: ".875rem"
                        },
                        ".Label": {
                            fontWeight: "850",
                            fontSize: "1rem",
                            fontLineHeight: "21px",
                            marginBottom: "10px"
                        },
                        ".PickerItem": {
                            color: "#497aa4",
                            textTransform: "uppercase",
                            lineHeight: "25px"
                        },
                        ".PickerItem:hover": {
                            backgroundColor: "#FFFFFF"
                        },
                        ".Tab:hover, .Input:hover, .PickerItem:hover": {
                            borderColor: "#81AFE4",
                            color: "#0056A6"
                        }
                    }
                }
            });
            const disallowedBrands = params.options.rejectAmex ? [
                "amex"
            ] : [];
            const paymentMethodOrder = params.options.encourageAch ? [
                "us_bank_account",
                "card"
            ] : [];
            const paymentElement = elements.create("payment", {
                paymentMethodOrder: paymentMethodOrder,
                terms: {
                    card: "never",
                    usBankAccount: "never"
                },
                disallowedCardBrands: disallowedBrands,
                wallets: {
                    applePay: "never",
                    googlePay: "never"
                }
            });
            paymentElement.mount(cardElement);
            paymentElement.on("change", function(element) {
                const type = element && element.value && element.value.type || "";
                app.ports.stripePortOnSetupIntentChange.send(type);
            });
            return {
                stripeClient: stripeClient,
                elements: elements,
                paymentElement: paymentElement,
                options: params.options
            };
        }
        function tryBuildAndMountElementWithSetupIntent(params) {
            const stripeClient = Stripe(publishableKey, {
                betas: [
                    "blocked_card_brands_beta_1"
                ],
                apiVersion: "2019-12-03",
                locale: params.locale
            });
            const cardElement = document.querySelector(params.selector);
            if (cardElement) requestAnimationFrame(function() {
                stripeElements[params.selector] = buildAndMountElementWithSetupIntent(stripeClient, params);
            });
            else if (mountAttempts <= mountAttemptsMax) {
                mountAttempts += 1;
                setTimeout(function() {
                    tryBuildAndMountElementWithSetupIntent(params);
                }, 100);
            }
        }
        app.ports.stripePortBuildAndMountElementWithSetupIntent.subscribe(tryBuildAndMountElementWithSetupIntent);
        app.ports.stripePortConfirmSetupIntent.subscribe(function(params) {
            const stripeElement = stripeElements[params.selector];
            const billingDetails = params.options && params.options.billingOptions ? {
                billing_details: {
                    name: params.options.billingOptions.name
                }
            } : {};
            stripeElement.stripeClient.confirmSetup({
                elements: elements,
                confirmParams: {
                    return_url: window.location.href,
                    payment_method_data: billingDetails
                },
                redirect: "if_required"
            }).then(({ error: error, setupIntent: setupIntent })=>{
                if (error) app.ports.stripePortOnSetupIntentConfirmed.send({
                    selector: params.selector,
                    setup_intent: null,
                    error: error.message
                });
                else app.ports.stripePortOnSetupIntentConfirmed.send({
                    selector: params.selector,
                    setup_intent: setupIntent,
                    error: null
                });
            });
        });
    }
};
$d5d5137484b98c41$exports = $d5d5137484b98c41$var$StripePort;


var $b78de99e3cb6b90b$exports = {};
function $b78de99e3cb6b90b$var$hexToHsl(hex) {
    // Convert hex to RGB first
    let r = 0, g = 0, b = 0;
    if (hex.length == 4) {
        r = "0x" + hex[1] + hex[1];
        g = "0x" + hex[2] + hex[2];
        b = "0x" + hex[3] + hex[3];
    } else if (hex.length == 7) {
        r = "0x" + hex[1] + hex[2];
        g = "0x" + hex[3] + hex[4];
        b = "0x" + hex[5] + hex[6];
    }
    // Then to HSL
    r /= 255;
    g /= 255;
    b /= 255;
    let cmin = Math.min(r, g, b), cmax = Math.max(r, g, b), delta = cmax - cmin;
    let h, s, l;
    if (delta == 0) h = 0;
    else if (cmax == r) h = (g - b) / delta % 6;
    else if (cmax == g) h = (b - r) / delta + 2;
    else h = (r - g) / delta + 4;
    h = Math.round(h * 60);
    if (h < 0) h += 360;
    l = (cmax + cmin) / 2;
    s = delta == 0 ? 0 : delta / (1 - Math.abs(2 * l - 1));
    s = +(s * 100).toFixed(1);
    l = +(l * 100).toFixed(1);
    return {
        h: h,
        s: s,
        l: l
    };
}
function $b78de99e3cb6b90b$var$toHsl({ h: h, s: s, l: l }) {
    return "hsl(" + h + "," + s + "%," + l + "%)";
}
function $b78de99e3cb6b90b$var$setTheme(hex) {
    const root = document.documentElement;
    const { h: h, s: s, l: l } = $b78de99e3cb6b90b$var$hexToHsl(hex);
    $b78de99e3cb6b90b$var$setProperty(root, "500", $b78de99e3cb6b90b$var$toHsl({
        h: h,
        s: 8,
        l: 40
    }));
    $b78de99e3cb6b90b$var$setProperty(root, "400", $b78de99e3cb6b90b$var$toHsl({
        h: h,
        s: s,
        l: l - 10
    }));
    $b78de99e3cb6b90b$var$setProperty(root, "300", $b78de99e3cb6b90b$var$toHsl({
        h: h,
        s: s,
        l: l
    }));
    $b78de99e3cb6b90b$var$setProperty(root, "200", $b78de99e3cb6b90b$var$toHsl({
        h: h,
        s: 79,
        l: 87
    }));
    $b78de99e3cb6b90b$var$setProperty(root, "250", $b78de99e3cb6b90b$var$toHsl({
        h: h,
        s: 65,
        l: 70
    }));
    $b78de99e3cb6b90b$var$setProperty(root, "100", $b78de99e3cb6b90b$var$toHsl({
        h: h,
        s: 65,
        l: 97
    }));
}
function $b78de99e3cb6b90b$var$setProperty(root, scale, color) {
    root.style.setProperty(`--custom-color-primary-${scale}`, color);
}
const $b78de99e3cb6b90b$var$ThemePort = {
    add: (app)=>{
        app.ports.setTheme.subscribe($b78de99e3cb6b90b$var$setTheme);
    }
};
$b78de99e3cb6b90b$exports = $b78de99e3cb6b90b$var$ThemePort;


var $72eb1b7e8424fce8$exports = {};
const $72eb1b7e8424fce8$var$CustomJavascriptPort = {
    add: function(app) {
        app.ports.fetchCustomJsFile.subscribe(function(customJavascriptFileUrl) {
            var script = document.createElement("script");
            script.src = customJavascriptFileUrl;
            document.head.appendChild(script);
        });
    }
};
$72eb1b7e8424fce8$exports = $72eb1b7e8424fce8$var$CustomJavascriptPort;


var $f4b7f13ee09e6363$exports = {};
const $f4b7f13ee09e6363$var$PageTitlePort = {
    add: function(app) {
        app.ports.updateTitle.subscribe((newText)=>{
            document.getElementsByTagName("title")[0].innerHTML = newText;
        });
    }
};
$f4b7f13ee09e6363$exports = $f4b7f13ee09e6363$var$PageTitlePort;


var $53030c4d0d659628$exports = {};
"use strict";
const $53030c4d0d659628$var$RainforestPort = {
    add: function(app) {
        const insertScriptTag = (rainforestEnv)=>{
            const paymentScript = document.createElement("script");
            if (rainforestEnv === "production") paymentScript.src = "https://static.rainforestpay.com/payment.js";
            else paymentScript.src = "https://static.rainforestpay.com/sandbox.payment.js";
            document.body.appendChild(paymentScript);
        };
        const requestAnimationFrame = window.requestAnimationFrame || window.mozRequestAnimationFrame || window.webkitRequestAnimationFrame || window.msRequestAnimationFrame;
        app.ports.rainforestPortLoad.subscribe(function(rainforestEnv) {
            requestAnimationFrame(function() {
                insertScriptTag(rainforestEnv);
            });
        });
        app.ports.rainforestSubmitPaymentMethod.subscribe(function() {
            const component = document.getElementsByTagName("rainforest-payment")[0];
            if (!component) return;
            component.submit();
        });
    }
};
$53030c4d0d659628$exports = $53030c4d0d659628$var$RainforestPort;


var $88841e90a30ba512$exports = {};
const $88841e90a30ba512$var$OnBeforeUnloadPort = {
    add: function(app) {
        window.addEventListener("beforeunload", ()=>{
            app.ports.onBeforeUnload.send(true);
        });
    }
};
$88841e90a30ba512$exports = $88841e90a30ba512$var$OnBeforeUnloadPort;


var $13a1730e1cbf1cc4$exports = {};
const $13a1730e1cbf1cc4$var$OnElementScrollPort = {
    add: function(app) {
        var sendElementScroll = function(element) {
            var scrollInfo = {
                scrollTop: element.scrollTop,
                scrollHeight: element.scrollHeight,
                clientHeight: element.clientHeight,
                atTop: element.scrollTop <= 0,
                atBottom: element.scrollHeight - element.scrollTop - element.clientHeight <= 1
            };
            app.ports.onElementScroll.send(scrollInfo);
        };
        app.ports.setupElementScroll.subscribe((elementId)=>{
            // wait for element creation, if it doesn't exist yet
            var waitTimer = null;
            var waitInterval = 100;
            var waitForElementCreation = function() {
                var element = document.getElementById(elementId);
                if (element) {
                    clearTimeout(waitTimer);
                    listenToElementScroll(element);
                } else waitTimer = setTimeout(function() {
                    clearTimeout(waitTimer);
                    waitForElementCreation();
                }, waitInterval);
            };
            var scrollTimer = null;
            var lastScrollFireTime = 0;
            var minScrollTime = 100;
            var listenToElementScroll = function(element) {
                if (element) {
                    // send scroll event for initial position
                    sendElementScroll(element);
                    element.addEventListener("scroll", ()=>{
                        if (!scrollTimer) {
                            var now = new Date().getTime();
                            if (now - lastScrollFireTime > minScrollTime) {
                                sendElementScroll(element);
                                lastScrollFireTime = now;
                            }
                            scrollTimer = setTimeout(function() {
                                scrollTimer = null;
                                lastScrollFireTime = new Date().getTime();
                                sendElementScroll(element);
                            }, minScrollTime);
                        }
                    });
                }
            };
            waitForElementCreation();
        });
    }
};
$13a1730e1cbf1cc4$exports = $13a1730e1cbf1cc4$var$OnElementScrollPort;


var $b28e419d9143a3c3$exports = {};
const $b28e419d9143a3c3$var$OnTabSelectPort = {
    add: function(app) {
        app.ports.tabSelected.subscribe((tabId)=>{
            app.ports.onTabSelected.send(tabId);
        });
    }
};
$b28e419d9143a3c3$exports = $b28e419d9143a3c3$var$OnTabSelectPort;


var $f2c7c3c854a3894f$exports = {};
const $f2c7c3c854a3894f$var$IntercomPort = {
    add: function(app, key) {
        window.setupIntercom(key);
        app.ports.start.subscribe(function() {
            if (!window.Intercom) return;
            window.Intercom("boot");
        });
    }
};
$f2c7c3c854a3894f$exports = $f2c7c3c854a3894f$var$IntercomPort;


var $085e3b96bb7da772$exports = {};
// @ts-nocheck
var $cc8e582106535db5$var$SnippetSrcV2 = "!function(m,n,e,t,l,o,g,y){var s,f,a=function(h){\nreturn!(h in m)||(m.console&&m.console.log&&m.console.log('FullStory namespace conflict. Please set window[\"_fs_namespace\"].'),!1)}(e)\n;function p(b){var h,d=[];function j(){h&&(d.forEach((function(b){var d;try{d=b[h[0]]&&b[h[0]](h[1])}catch(h){return void(b[3]&&b[3](h))}\nd&&d.then?d.then(b[2],b[3]):b[2]&&b[2](d)})),d.length=0)}function r(b){return function(d){h||(h=[b,d],j())}}return b(r(0),r(1)),{\nthen:function(b,h){return p((function(r,i){d.push([b,h,r,i]),j()}))}}}a&&(g=m[e]=function(){var b=function(b,d,j,r){function i(i,c){\nh(b,d,j,i,c,r)}r=r||2;var c,u=/Async$/;return u.test(b)?(b=b.replace(u,\"\"),\"function\"==typeof Promise?new Promise(i):p(i)):h(b,d,j,c,c,r)}\n;function h(h,d,j,r,i,c){return b._api?b._api(h,d,j,r,i,c):(b.q&&b.q.push([h,d,j,r,i,c]),null)}return b.q=[],b}(),y=function(b){function h(h){\n\"function\"==typeof h[4]&&h[4](new Error(b))}var d=g.q;if(d){for(var j=0;j<d.length;j++)h(d[j]);d.length=0,d.push=h}},function(){\n(o=n.createElement(t)).async=!0,o.crossOrigin=\"anonymous\",o.src=\"https://\"+l,o.onerror=function(){y(\"Error loading \"+l)}\n;var b=n.getElementsByTagName(t)[0];b&&b.parentNode?b.parentNode.insertBefore(o,b):n.head.appendChild(o)}(),function(){function b(){}\nfunction h(b,h,d){g(b,h,d,1)}function d(b,d,j){h(\"setProperties\",{type:b,properties:d},j)}function j(b,h){d(\"user\",b,h)}function r(b,h,d){j({\nuid:b},d),h&&j(h,d)}g.identify=r,g.setUserVars=j,g.identifyAccount=b,g.clearUserCookie=b,g.setVars=d,g.event=function(b,d,j){h(\"trackEvent\",{\nname:b,properties:d},j)},g.anonymize=function(){r(!1)},g.shutdown=function(){h(\"shutdown\")},g.restart=function(){h(\"restart\")},\ng.log=function(b,d){h(\"log\",{level:b,msg:d})},g.consent=function(b){h(\"setIdentity\",{consent:!arguments.length||b})}}(),s=\"fetch\",\nf=\"XMLHttpRequest\",g._w={},g._w[f]=m[f],g._w[s]=m[s],m[s]&&(m[s]=function(){return g._w[s].apply(this,arguments)}),g._v=\"2.0.0\")\n}(window,document,window._fs_namespace,\"script\",window._fs_script);";
var $cc8e582106535db5$var$SnippetSrcV2Delayed = "!function(m,n,e,t,l,o,g,y){var s,f,a=function(d){\nreturn!(d in m)||(m.console&&m.console.log&&m.console.log('FullStory namespace conflict. Please set window[\"_fs_namespace\"].'),!1)}(e)\n;function p(b){var d,h=[];function k(){d&&(h.forEach((function(b){var h;try{h=b[d[0]]&&b[d[0]](d[1])}catch(d){return void(b[3]&&b[3](d))}\nh&&h.then?h.then(b[2],b[3]):b[2]&&b[2](h)})),h.length=0)}function r(b){return function(h){d||(d=[b,h],k())}}return b(r(0),r(1)),{\nthen:function(b,d){return p((function(r,i){h.push([b,d,r,i]),k()}))}}}function j(){(o=n.createElement(t)).async=!0,o.crossOrigin=\"anonymous\",\no.src=\"https://\"+l,o.onerror=function(){y(\"Error loading \"+l)};var b=n.getElementsByTagName(t)[0]\n;b&&b.parentNode?b.parentNode.insertBefore(o,b):n.head.appendChild(o)}a&&(g=m[e]=function(){var b=function(b,h,k,r){function i(i,c){\nd(b,h,k,i,c,r)}r=r||2;var c,u=/Async$/;return u.test(b)?(b=b.replace(u,\"\"),\"function\"==typeof Promise?new Promise(i):p(i)):d(b,h,k,c,c,r)}\n;function d(d,h,k,r,i,c){return b._api?b._api(d,h,k,r,i,c):(b.q&&b.q.push([d,h,k,r,i,c]),null)}return b.q=[],b}(),y=function(b){function d(d){\n\"function\"==typeof d[4]&&d[4](new Error(b))}var h=g.q;if(h){for(var k=0;k<h.length;k++)d(h[k]);h.length=0,h.push=d}},function(){try{\nvar b=!1,d=\"paint\";if(void 0!==window.PerformanceObserver&&PerformanceObserver.supportedEntryTypes.indexOf(d)>-1){\nvar h=new PerformanceObserver((function(d){for(var k=d.getEntriesByName(\"first-contentful-paint\"),r=0;r<k.length;r++)k[r]&&(h.disconnect(),\nb||(b=!0,j()))}));h.observe({buffered:!0,type:d}),setTimeout((function(){b||(b=!0,j())}),1e3)}else j()}catch(b){}}(),function(){function b(){}\nfunction d(b,d,h){g(b,d,h,1)}function h(b,h,k){d(\"setProperties\",{type:b,properties:h},k)}function k(b,d){h(\"user\",b,d)}function r(b,d,h){k({\nuid:b},h),d&&k(d,h)}g.identify=r,g.setUserVars=k,g.identifyAccount=b,g.clearUserCookie=b,g.setVars=h,g.event=function(b,h,k){d(\"trackEvent\",{\nname:b,properties:h},k)},g.anonymize=function(){r(!1)},g.shutdown=function(){d(\"shutdown\")},g.restart=function(){d(\"restart\")},\ng.log=function(b,h){d(\"log\",{level:b,msg:h})},g.consent=function(b){d(\"setIdentity\",{consent:!arguments.length||b})}}(),s=\"fetch\",\nf=\"XMLHttpRequest\",g._w={},g._w[f]=m[f],g._w[s]=m[s],m[s]&&(m[s]=function(){return g._w[s].apply(this,arguments)}),g._v=\"2.0.0.delayed\")\n}(window,document,window._fs_namespace,\"script\",window._fs_script);";
var $cc8e582106535db5$var$mockSnippetV1 = "(function(m,n,e,t,l,o,g,y){\n    if (e in m) {if(m.console && m.console.log) { m.console.log('FullStory namespace conflict. Please set window[\"_fs_namespace\"].');} return;}\n    g=m[e]=function(a,b,s){g.q?g.q.push([a,b,s]):g._api(a,b,s);};g.q=[];\n    g.identify=function(i,v,s){g(l,{uid:i},s);if(v)g(l,v,s)};g.setUserVars=function(v,s){g(l,v,s)};g.event=function(i,v,s){g('event',{n:i,p:v},s)};\n    g.anonymize=function(){g.identify(!!0)};\n    g.shutdown=function(){g(\"rec\",!1)};g.restart=function(){g(\"rec\",!0)};\n    g.log = function(a,b){g(\"log\",[a,b])};\n    g.consent=function(a){g(\"consent\",!arguments.length||a)};\n    g.identifyAccount=function(i,v){o='account';v=v||{};v.acctId=i;g(o,v)};\n    g.clearUserCookie=function(){};\n    g.setVars=function(n, p){g('setVars',[n,p]);};\n    g._w={};y='XMLHttpRequest';g._w[y]=m[y];y='fetch';g._w[y]=m[y];\n    if(m[y])m[y]=function(){return g._w[y].apply(this,arguments)};\n    g._v=\"1.3.0\";\n})(window,document,window['_fs_namespace'],'script','user');";
var $cc8e582106535db5$var$mockSnippetV2 = "!function(m,n,e,t,l,o,g,y){var s,f,a=function(h){\nreturn!(h in m)||(m.console&&m.console.log&&m.console.log('FullStory namespace conflict. Please set window[\"_fs_namespace\"].'),!1)}(e)\n;function j(b){var h,d=[];function k(){h&&(d.forEach((function(b){var d;try{d=b[h[0]]&&b[h[0]](h[1])}catch(h){return void(b[3]&&b[3](h))}\nd&&d.then?d.then(b[2],b[3]):b[2]&&b[2](d)})),d.length=0)}function i(b){return function(d){h||(h=[b,d],k())}}return b(i(0),i(1)),{\nthen:function(b,h){return j((function(i,c){d.push([b,h,i,c]),k()}))}}}a&&(g=m[e]=function(){var b=function(b,d,k,i){function c(c,r){\nh(b,d,k,c,r,i)}i=i||2;var r,u=/Async$/;return u.test(b)?(b=b.replace(u,\"\"),\"function\"==typeof Promise?new Promise(c):j(c)):h(b,d,k,r,r,i)}\n;function h(h,d,k,i,c,r){return b._api?b._api(h,d,k,i,c,r):(b.q&&b.q.push([h,d,k,i,c,r]),null)}return b.q=[],b}(),function(){function b(){}\nfunction h(b,h,d){g(b,h,d,1)}function d(b,d,k){h(\"setProperties\",{type:b,properties:d},k)}function k(b,h){d(\"user\",b,h)}function i(b,h,d){k({\nuid:b},d),h&&k(h,d)}g.identify=i,g.setUserVars=k,g.identifyAccount=b,g.clearUserCookie=b,g.setVars=d,g.event=function(b,d,k){h(\"trackEvent\",{\nname:b,properties:d},k)},g.anonymize=function(){i(!1)},g.shutdown=function(){h(\"shutdown\")},g.restart=function(){h(\"restart\")},\ng.log=function(b,d){h(\"log\",{level:b,msg:d})},g.consent=function(b){h(\"setIdentity\",{consent:!arguments.length||b})}}(),s=\"fetch\",\nf=\"XMLHttpRequest\",g._w={},g._w[f]=m[f],g._w[s]=m[s],m[s]&&(m[s]=function(){return g._w[s].apply(this,arguments)}),g._v=\"2.0.0\")\n}(window,document,window._fs_namespace,0,window._fs_script);";
var $cc8e582106535db5$var$executeSnippet = function executeSnippet() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, _ref$wnd = _ref.wnd, wnd = _ref$wnd === void 0 ? window : _ref$wnd, _ref$injectedNamespac = _ref.injectedNamespace, injectedNamespace = _ref$injectedNamespac === void 0 ? wnd['_fs_namespace'] : _ref$injectedNamespac, _ref$injectedScript = _ref.injectedScript, injectedScript = _ref$injectedScript === void 0 ? wnd['_fs_script'] : _ref$injectedScript;
    (function(win, doc, fsNamespace, tagName, fsScript, script, api, rejector) {
        var valid = function checkNamespace(fsNamespace) {
            if (!(fsNamespace in win)) return true;
            if (win.console && win.console.log) win.console.log("FullStory namespace conflict. Please set window[\"_fs_namespace\"].");
            return false;
        }(fsNamespace);
        if (!valid) return;
        function makeThenable(callback) {
            var waiters = [];
            var resolution;
            function flush() {
                if (!resolution) return;
                waiters.forEach(function(waiter) {
                    var result;
                    try {
                        result = waiter[resolution[0]] && waiter[resolution[0]](resolution[1]);
                    } catch (error) {
                        waiter[3] && waiter[3](error);
                        return;
                    }
                    if (result && result.then) result.then(waiter[2], waiter[3]);
                    else waiter[2] && waiter[2](result);
                });
                waiters.length = 0;
            }
            function makeHandler(which) {
                return function(value) {
                    if (resolution) return;
                    resolution = [
                        which,
                        value
                    ];
                    flush();
                };
            }
            callback(makeHandler(0), makeHandler(1));
            function _then(onFulfilled, onRejected) {
                return makeThenable(function(nextResolve, nextReject) {
                    waiters.push([
                        onFulfilled,
                        onRejected,
                        nextResolve,
                        nextReject
                    ]);
                    flush();
                });
            }
            return {
                then: _then
            };
        }
        api = win[fsNamespace] = function createV2API() {
            var FS = function FS(action, options, source, apiVersion) {
                apiVersion = apiVersion || 2;
                function setResolve(resolve, reject) {
                    api(action, options, source, resolve, reject, apiVersion);
                }
                var re = /Async$/;
                if (re.test(action)) {
                    action = action.replace(re, '');
                    // @ts-ignore
                    if (typeof Promise === 'function') // @ts-ignore
                    return new Promise(setResolve);
                    return makeThenable(setResolve);
                }
                var _undefined;
                return api(action, options, source, _undefined, _undefined, apiVersion);
            };
            function api(op, args, source, resolve, reject, apiVersion) {
                // Once fs.js is bootstrapped, we have access to ._api which
                //   handles pushing deferred methods into the queue internally.
                if (FS._api) return FS._api(op, args, source, resolve, reject, apiVersion);
                if (FS.q) FS.q.push([
                    op,
                    args,
                    source,
                    resolve,
                    reject,
                    apiVersion
                ]);
                return null;
            }
            FS.q = [];
            return FS;
        }();
        rejector = function createRejector() {
            // Returns a function called on the error handler of the fs.js script tag.
            // Its purpose is to reject all pending and future asynchronous api calls.
            // The 4th argument to any api operation is always the reject function if it
            // has been called with the "Async" modifier.
            return function(reason) {
                function doReject(operation) {
                    if (typeof operation[4] === 'function') operation[4](new Error(reason));
                }
                var q = api.q;
                if (q) {
                    for(var i = 0; i < q.length; i++)doReject(q[i]);
                    q.length = 0;
                    q.push = doReject;
                }
            };
        }();
        (function insertScript() {
            script = doc.createElement(tagName);
            script.async = true;
            script.crossOrigin = 'anonymous';
            script.src = 'https://' + fsScript;
            script.onerror = function() {
                rejector('Error loading ' + fsScript);
            };
            var firstScript = doc.getElementsByTagName(tagName)[0];
            if (firstScript && firstScript.parentNode) firstScript.parentNode.insertBefore(script, firstScript);
            else doc.head.appendChild(script);
        })();
        (function translateV1API() {
            function noop() {}
            function callAPI(action, option, source) {
                api(action, option, source, 1);
            }
            function setProperties(scope, props, source) {
                callAPI('setProperties', {
                    type: scope,
                    properties: props
                }, source);
            }
            function setUserProperties(props, source) {
                setProperties('user', props, source);
            }
            function identify(uid, customVars, source) {
                setUserProperties({
                    uid: uid
                }, source);
                if (customVars) setUserProperties(customVars, source);
            }
            api.identify = identify;
            api.setUserVars = setUserProperties;
            api.identifyAccount = noop;
            api.clearUserCookie = noop;
            api.setVars = setProperties;
            api.event = function(eventName, eventProps, source) {
                callAPI('trackEvent', {
                    name: eventName,
                    properties: eventProps
                }, source);
            };
            api.anonymize = function() {
                identify(false);
            };
            api.shutdown = function() {
                callAPI('shutdown');
            };
            api.restart = function() {
                callAPI('restart');
            };
            api.log = function(level, msg) {
                callAPI('log', {
                    level: level,
                    msg: msg
                });
            };
            api.consent = function(userConsents) {
                callAPI('setIdentity', {
                    consent: !arguments.length || userConsents
                });
            };
        })();
        (function snapshotGlobals() {
            var f = 'fetch';
            var xhr = 'XMLHttpRequest';
            api._w = {};
            api._w[xhr] = win[xhr];
            api._w[f] = win[f];
            if (win[f]) win[f] = function() {
                return api._w[f].apply(this, arguments);
            };
        })();
        api._v = "2.0.0";
    })(wnd, wnd.document, injectedNamespace, 'script', injectedScript);
};
var $cc8e582106535db5$var$executeSnippetV1 = function executeSnippetV1() {
    var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, _ref2$wnd = _ref2.wnd, wnd = _ref2$wnd === void 0 ? window : _ref2$wnd, _ref2$injectedNamespa = _ref2.injectedNamespace, injectedNamespace = _ref2$injectedNamespa === void 0 ? wnd['_fs_namespace'] : _ref2$injectedNamespa;
    (function(m, n, e, t, l, o, g, y) {
        if (e in m) {
            if (m.console && m.console.log) m.console.log('FullStory namespace conflict. Please set window["_fs_namespace"].');
            return;
        }
        g = m[e] = function(a, b, s) {
            g.q ? g.q.push([
                a,
                b,
                s
            ]) : g._api(a, b, s);
        };
        g.q = [];
        o = n.createElement(t);
        o.async = 1;
        o.crossOrigin = 'anonymous';
        o.src = 'https://' + _fs_script;
        y = n.getElementsByTagName(t)[0];
        y.parentNode.insertBefore(o, y);
        g.identify = function(i, v, s) {
            g(l, {
                uid: i
            }, s);
            if (v) g(l, v, s);
        };
        g.setUserVars = function(v, s) {
            g(l, v, s);
        };
        g.event = function(i, v, s) {
            g('event', {
                n: i,
                p: v
            }, s);
        };
        g.anonymize = function() {
            g.identify(false);
        };
        g.shutdown = function() {
            g("rec", !1);
        };
        g.restart = function() {
            g("rec", !0);
        };
        g.log = function(a, b) {
            g("log", [
                a,
                b
            ]);
        };
        g.consent = function(a) {
            g("consent", !arguments.length || a);
        };
        g.identifyAccount = function(i, v) {
            o = 'account';
            v = v || {};
            v.acctId = i;
            g(o, v);
        };
        g.clearUserCookie = function() {};
        g.setVars = function(n, p) {
            g('setVars', [
                n,
                p
            ]);
        };
        g._w = {};
        y = 'XMLHttpRequest';
        g._w[y] = m[y];
        y = 'fetch';
        g._w[y] = m[y];
        if (m[y]) m[y] = function() {
            return g._w[y].apply(this, arguments);
        };
        g._v = "1.3.0";
    })(wnd, wnd.document, injectedNamespace, 'script', 'user');
};
var $cc8e582106535db5$var$getDocumentVar = function getDocumentVar(globalVar) {
    return globalVar === 'window' ? 'document' : "".concat(globalVar, ".document");
};
var $cc8e582106535db5$var$toV1String = function toV1String() {
    var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, _ref3$shouldInsertScr = _ref3.shouldInsertScript, shouldInsertScript = _ref3$shouldInsertScr === void 0 ? true : _ref3$shouldInsertScr, _ref3$globalVar = _ref3.globalVar, globalVar = _ref3$globalVar === void 0 ? 'window' : _ref3$globalVar, _ref3$globalNamespace = _ref3.globalNamespace, globalNamespace = _ref3$globalNamespace === void 0 ? "".concat(globalVar, "['_fs_namespace']") : _ref3$globalNamespace, _ref3$apiVersion = _ref3.apiVersion, apiVersion = _ref3$apiVersion === void 0 ? '1.3.0' : _ref3$apiVersion;
    return "(function(m,n,e,t,l,o,g,y){\n    if (e in m) {if(m.console && m.console.log) { m.console.log('FullStory namespace conflict. Please set window[\"_fs_namespace\"].');} return;}\n    g=m[e]=function(a,b,s){g.q?g.q.push([a,b,s]):g._api(a,b,s);};g.q=[];".concat(shouldInsertScript ? "\n    o=n.createElement(t);o.async=1;o.crossOrigin='anonymous';o.src='https://'+_fs_script;\n    y=n.getElementsByTagName(t)[0];y.parentNode.insertBefore(o,y);" : '', "\n    g.identify=function(i,v,s){g(l,{uid:i},s);if(v)g(l,v,s)};g.setUserVars=function(v,s){g(l,v,s)};g.event=function(i,v,s){g('event',{n:i,p:v},s)};\n    g.anonymize=function(){g.identify(!!0)};\n    g.shutdown=function(){g(\"rec\",!1)};g.restart=function(){g(\"rec\",!0)};\n    g.log = function(a,b){g(\"log\",[a,b])};\n    g.consent=function(a){g(\"consent\",!arguments.length||a)};\n    g.identifyAccount=function(i,v){o='account';v=v||{};v.acctId=i;g(o,v)};\n    g.clearUserCookie=function(){};\n    g.setVars=function(n, p){g('setVars',[n,p]);};\n    g._w={};y='XMLHttpRequest';g._w[y]=m[y];y='fetch';g._w[y]=m[y];\n    if(m[y])m[y]=function(){return g._w[y].apply(this,arguments)};\n    g._v=\"").concat(apiVersion, "\";\n})(").concat(globalVar, ",").concat($cc8e582106535db5$var$getDocumentVar(globalVar), ",").concat(globalNamespace, ",'script','user');");
};
var $cc8e582106535db5$export$52a15e44b483bf1c = function initFS(_a) {
    var orgId = _a.orgId, _b = _a.namespace, namespace = _b === void 0 ? 'FS' : _b, _c = _a.host, host = _c === void 0 ? 'fullstory.com' : _c, _d = _a.script, script = _d === void 0 ? 'edge.fullstory.com/s/fs.js' : _d;
    if (!orgId) throw new Error('FullStory orgId is a required parameter');
    window['_fs_host'] = host;
    window['_fs_script'] = script;
    window['_fs_org'] = orgId;
    window['_fs_namespace'] = namespace;
    $cc8e582106535db5$var$executeSnippet();
};
var $cc8e582106535db5$export$26bbcb54e60c59be = function initFSV1(_a) {
    var orgId = _a.orgId, _b = _a.namespace, namespace = _b === void 0 ? 'FS' : _b, _c = _a.host, host = _c === void 0 ? 'fullstory.com' : _c, _d = _a.script, script = _d === void 0 ? 'edge.fullstory.com/s/fs.js' : _d;
    if (!orgId) throw new Error('FullStory orgId is a required parameter');
    window['_fs_host'] = host;
    window['_fs_script'] = script;
    window['_fs_org'] = orgId;
    window['_fs_namespace'] = namespace;
    $cc8e582106535db5$var$executeSnippetV1();
};
var $cc8e582106535db5$export$41ad23cd2470a6dd = $cc8e582106535db5$var$SnippetSrcV2;
var $cc8e582106535db5$export$56870719feaa6534 = $cc8e582106535db5$var$SnippetSrcV2Delayed;
var $cc8e582106535db5$export$7ab8f32ee68a385 = $cc8e582106535db5$var$toV1String();
var $cc8e582106535db5$export$e843673607dd064a = function generateSnippetText(_a) {
    var orgId = _a.orgId, _b = _a.namespace, namespace = _b === void 0 ? 'FS' : _b, _c = _a.host, host = _c === void 0 ? 'fullstory.com' : _c, _d = _a.script, script = _d === void 0 ? 'edge.fullstory.com/s/fs.js' : _d;
    if (!orgId) throw new Error('FullStory orgId is a required parameter');
    return "window['_fs_host'] = '".concat(host, "';\nwindow['_fs_script'] = '").concat(script, "';\nwindow['_fs_org'] = '").concat(orgId, "';\nwindow['_fs_namespace'] = '").concat(namespace, "';\n").concat($cc8e582106535db5$export$41ad23cd2470a6dd, "\n");
};
var $cc8e582106535db5$export$449f4f90c1f01cdf = function generateSnippetTextV1(_a) {
    var orgId = _a.orgId, _b = _a.namespace, namespace = _b === void 0 ? 'FS' : _b, _c = _a.host, host = _c === void 0 ? 'fullstory.com' : _c, _d = _a.script, script = _d === void 0 ? 'edge.fullstory.com/s/fs.js' : _d;
    if (!orgId) throw new Error('FullStory orgId is a required parameter');
    return "window['_fs_host'] = '".concat(host, "';\nwindow['_fs_script'] = '").concat(script, "';\nwindow['_fs_org'] = '").concat(orgId, "';\nwindow['_fs_namespace'] = '").concat(namespace, "';\n").concat($cc8e582106535db5$export$7ab8f32ee68a385, "\n");
};
var $cc8e582106535db5$export$a91c1a98ec2aac0d = $cc8e582106535db5$var$mockSnippetV2;
var $cc8e582106535db5$export$f721247e8e626cdb = $cc8e582106535db5$var$mockSnippetV1;


/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var $5eac6979fd23fa61$var$__assign = function() {
    $5eac6979fd23fa61$var$__assign = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $5eac6979fd23fa61$var$__assign.apply(this, arguments);
};
var $5eac6979fd23fa61$var$getFullStory = function() {
    if (window._fs_namespace) return window[window._fs_namespace];
    return undefined;
};
var $5eac6979fd23fa61$var$ensureSnippetLoaded = function() {
    var fs = $5eac6979fd23fa61$var$getFullStory();
    if (!fs) throw Error('FullStory is not loaded, please ensure the init function is invoked before calling FullStory API functions');
    return fs;
};
var $5eac6979fd23fa61$var$_init = function(inputOptions, readyCallback) {
    // Make a copy so we can modify `options` if desired.
    var options = $5eac6979fd23fa61$var$__assign({}, inputOptions);
    if ($5eac6979fd23fa61$var$getFullStory()) {
        console.warn('The FullStory snippet has already been defined elsewhere (likely in the <head> element)');
        return;
    }
    // see README for details on the recordCrossDomainIFrames option
    if (options.recordCrossDomainIFrames) window._fs_run_in_iframe = true;
    if (options.appHost) window._fs_app_host = options.appHost;
    if (options.assetMapId) window._fs_asset_map_id = options.assetMapId;
    if (options.startCaptureManually) window._fs_capture_on_startup = false;
    // record the contents of this iFrame when embedded in a parent site
    if (options.recordOnlyThisIFrame) window._fs_is_outer_script = true;
    // Set cookie domain if it was specified.
    if (options.cookieDomain) window._fs_cookie_domain = options.cookieDomain;
    if (options.debug === true) {
        if (!options.script) options.script = 'edge.fullstory.com/s/fs-debug.js';
        else console.warn('Ignoring `debug = true` because `script` is set');
    }
    (0, $cc8e582106535db5$export$52a15e44b483bf1c)(options);
    var fs = $5eac6979fd23fa61$var$getFullStory();
    if (!fs) {
        console.warn('Failed to initialize FS snippet');
        return;
    }
    if (options.sessionUid) fs('init', {
        env: {
            sessionUid: options.sessionUid
        }
    });
    if (readyCallback) fs('observe', {
        type: 'start',
        callback: readyCallback
    });
    if (options.devMode === true) {
        var message = 'FullStory was initialized in devMode and will stop recording';
        fs('trackEvent', {
            name: 'FullStory Dev Mode',
            properties: {
                message: message
            }
        });
        fs('shutdown');
        window._fs_dev_mode = true;
        console.warn(message);
    }
};
var $5eac6979fd23fa61$var$initOnce = function(message) {
    return function(inputOptions, readyCallback) {
        if (window._fs_initialized) {
            if (message) console.warn(message);
            return;
        }
        $5eac6979fd23fa61$var$_init(inputOptions, readyCallback);
        window._fs_initialized = true;
    };
};
var $5eac6979fd23fa61$export$2cd8252107eb640b = $5eac6979fd23fa61$var$initOnce('FullStory init has already been called once, additional invocations are ignored');
// normalize undefined into boolean
var $5eac6979fd23fa61$export$3f95c6f800b78024 = function() {
    return !!window._fs_initialized;
};
var $5eac6979fd23fa61$var$hasFullStoryWithFunction = function() {
    var testNames = [];
    for(var _i = 0; _i < arguments.length; _i++)testNames[_i] = arguments[_i];
    var fs = $5eac6979fd23fa61$var$ensureSnippetLoaded();
    return testNames.every(function(current) {
        return fs[current];
    });
};
var $5eac6979fd23fa61$var$guard = function(name) {
    return function() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        if (window._fs_dev_mode) {
            var message = "FullStory is in dev mode and is not capturing: ".concat(name, " method not executed");
            console.warn(message);
            return message;
        }
        var fs = $5eac6979fd23fa61$var$getFullStory();
        if ($5eac6979fd23fa61$var$hasFullStoryWithFunction(name) && fs) return fs[name].apply(fs, args);
        console.warn("FS.".concat(name, " not ready"));
        return null;
    };
};
var $5eac6979fd23fa61$var$buildFullStoryShim = function() {
    var FS = function(operation, options, source) {
        var fs = $5eac6979fd23fa61$var$ensureSnippetLoaded();
        if (window._fs_dev_mode) {
            var message = "FullStory is in dev mode and is not capturing: ".concat(operation, " not executed");
            console.warn(message);
            return undefined;
        }
        return fs(operation, options, source);
    };
    FS.anonymize = $5eac6979fd23fa61$var$guard('anonymize');
    FS.consent = $5eac6979fd23fa61$var$guard('consent');
    FS.disableConsole = $5eac6979fd23fa61$var$guard('disableConsole');
    FS.enableConsole = $5eac6979fd23fa61$var$guard('enableConsole');
    FS.event = $5eac6979fd23fa61$var$guard('event');
    FS.getCurrentSessionURL = $5eac6979fd23fa61$var$guard('getCurrentSessionURL');
    FS.identify = $5eac6979fd23fa61$var$guard('identify');
    FS.log = $5eac6979fd23fa61$var$guard('log');
    FS.restart = $5eac6979fd23fa61$var$guard('restart');
    FS.setUserVars = $5eac6979fd23fa61$var$guard('setUserVars');
    FS.setVars = $5eac6979fd23fa61$var$guard('setVars');
    FS.shutdown = $5eac6979fd23fa61$var$guard('shutdown');
    return FS;
};
var $5eac6979fd23fa61$export$d55ddad8cc9093bd = $5eac6979fd23fa61$var$buildFullStoryShim();


"use strict";
const $085e3b96bb7da772$var$FullStoryPort = {
    add: function(app, orgId) {
        if (orgId) {
            (0, $5eac6979fd23fa61$export$2cd8252107eb640b)({
                orgId: orgId
            });
            app.ports.fullStoryPortInit.subscribe(function(practice) {
                (0, $5eac6979fd23fa61$export$d55ddad8cc9093bd)("setIdentity", {
                    anonymous: true,
                    properties: {
                        practice_id: practice.id,
                        practice_name: practice.name,
                        practice_email: practice.email
                    }
                });
            });
            app.ports.fullStoryPortIdentifySignup.subscribe(function(onlineEnrollmentId) {
                (0, $5eac6979fd23fa61$export$d55ddad8cc9093bd)("setIdentity", {
                    uid: onlineEnrollmentId,
                    properties: {
                        online_enrollment_id: onlineEnrollmentId
                    }
                });
            });
            app.ports.fullStoryPortIdentifyPatientPortal.subscribe(function(event) {
                (0, $5eac6979fd23fa61$export$d55ddad8cc9093bd)("setIdentity", {
                    uid: event.userId,
                    properties: {
                        scope: event.scope
                    }
                });
            });
            app.ports.fullStoryPortStopCapturing.subscribe(function() {
                (0, $5eac6979fd23fa61$export$d55ddad8cc9093bd)("shutdown");
            });
            app.ports.fullStoryPortLogEvent.subscribe(function(event) {
                const options = Object.assign(event.payload, {
                    app: "member"
                });
                (0, $5eac6979fd23fa61$export$d55ddad8cc9093bd)("trackEvent", {
                    name: event.type,
                    properties: options
                });
            });
        }
    }
};
$085e3b96bb7da772$exports = $085e3b96bb7da772$var$FullStoryPort;


var $15ca76013f461cc0$exports = {};
"use strict";
const $15ca76013f461cc0$var$FaviconPort = {
    add: function(app) {
        if (app.ports.setFaviconPort) app.ports.setFaviconPort.subscribe((favicons)=>{
            let icoLink = document.getElementById("faviconIco");
            let pngLink = document.getElementById("faviconPng");
            let appleLink = document.getElementById("faviconApple");
            icoLink.setAttribute("href", favicons.icoUrl);
            pngLink.setAttribute("href", favicons.pngUrl);
            appleLink.setAttribute("href", favicons.appleUrl);
        });
    }
};
$15ca76013f461cc0$exports = $15ca76013f461cc0$var$FaviconPort;


var $d13a3aa875c41ca7$exports = {};

const $d13a3aa875c41ca7$var$storage = (0, $37d19e55f1d922da$exports.storageFactory)(()=>localStorage);
const $d13a3aa875c41ca7$var$IdleTimePort = {
    add: (app)=>{
        const storageKey = "lastActivityAt";
        const oneMinMs = 60000;
        const halfMinMs = 30000;
        const sessionInactivityThreshold = 60; // matches JWT expiration
        const idleThresholdMs = sessionInactivityThreshold * oneMinMs;
        function throttle(func, timeFrame) {
            var lastTime = 0;
            return function() {
                var now = Date.now();
                if (now - lastTime >= timeFrame) {
                    func();
                    lastTime = now;
                }
            };
        }
        function checkIdleTimeAndlogout() {
            const lastActivityAt = parseInt($d13a3aa875c41ca7$var$storage.getItem(storageKey));
            const now = Date.now();
            if (lastActivityAt && now - lastActivityAt > idleThresholdMs) app.ports.idleUser.send(true);
        }
        const trackLastActivity = ()=>{
            $d13a3aa875c41ca7$var$storage.setItem(storageKey, Date.now());
        };
        setInterval(checkIdleTimeAndlogout, oneMinMs);
        window.addEventListener("mousemove", throttle(trackLastActivity, halfMinMs));
        window.addEventListener("keypress", throttle(trackLastActivity, halfMinMs));
    }
};
$d13a3aa875c41ca7$exports = $d13a3aa875c41ca7$var$IdleTimePort;


var $d2be32b72d8b955d$exports = {};
"use strict";
const $d2be32b72d8b955d$var$ScrollDetectionPort = {
    add: function(app) {
        if (app.ports.setupScrollDetection) app.ports.setupScrollDetection.subscribe(({ containerId: containerId })=>{
            // Find the visible container (not hidden by CSS)
            const allContainers = document.querySelectorAll(`#${containerId}`);
            let targetContainer = null;
            for (let container of allContainers){
                const style = getComputedStyle(container);
                if (style.display !== "none" && style.visibility !== "hidden" && container.offsetParent !== null) {
                    targetContainer = container;
                    break;
                }
            }
            if (targetContainer) {
                targetContainer.removeEventListener("scroll", handleScroll);
                targetContainer.addEventListener("scroll", handleScroll, {
                    passive: true
                });
            } else console.warn(`Container with id "${containerId}" not found when trying to setup scroll detection`);
        });
        const handleScroll = (event)=>{
            const container = event.target;
            const containerId = container.id;
            const scrollInfo = {
                containerId: containerId,
                x: container.scrollLeft,
                y: container.scrollTop,
                scrollHeight: container.scrollHeight,
                clientHeight: container.clientHeight
            };
            app.ports.onScroll.send(scrollInfo);
        };
    }
};
$d2be32b72d8b955d$exports = $d2be32b72d8b955d$var$ScrollDetectionPort;


var $a8ede6276a337434$exports = {};
let $a8ede6276a337434$var$selectedFiles = [];
function $a8ede6276a337434$var$initFileSelection(app) {
    if (!app.ports.openFileDialogPort || !app.ports.onFileSelectedPort) return;
    app.ports.openFileDialogPort.subscribe((acceptedTypes)=>{
        const fileInput = document.createElement("input");
        fileInput.type = "file";
        fileInput.style.display = "none";
        fileInput.accept = acceptedTypes || "*/*";
        fileInput.multiple = true;
        fileInput.addEventListener("change", (event)=>{
            const files = Array.from(event.target.files);
            if (files.length > 0) {
                $a8ede6276a337434$var$selectedFiles = files;
                const fileInfos = files.map((file)=>({
                        name: file.name,
                        size: file.size,
                        type: file.type || "application/octet-stream"
                    }));
                app.ports.onFileSelectedPort.send(fileInfos);
            } else {
                $a8ede6276a337434$var$selectedFiles = [];
                app.ports.onFileSelectedPort.send([]);
            }
            document.body.removeChild(fileInput);
        });
        document.body.appendChild(fileInput);
        fileInput.click();
    });
}
function $a8ede6276a337434$var$getSelectedFile(index) {
    return $a8ede6276a337434$var$selectedFiles[index] || null;
}
$a8ede6276a337434$exports = {
    initFileSelection: $a8ede6276a337434$var$initFileSelection,
    getSelectedFile: $a8ede6276a337434$var$getSelectedFile
};


var $70bed06a98643566$exports = {};
/**
 * File Upload Port Handler
 * Handles file uploads to API via multipart/form-data
 */ 
var $70bed06a98643566$require$getSelectedFile = $a8ede6276a337434$exports.getSelectedFile;
const $70bed06a98643566$var$FileUploadPort = {
    add: function(app) {
        if (app.ports && app.ports.uploadFileToApi) app.ports.uploadFileToApi.subscribe(async ({ request: request, url: url })=>{
            try {
                const file = $70bed06a98643566$require$getSelectedFile(request.fileIndex);
                if (!file) throw new Error("File not found at index " + request.fileIndex);
                const formData = new FormData();
                formData.append("file", file);
                const response = await fetch(url, {
                    method: "POST",
                    body: formData,
                    headers: {
                        Authorization: `Bearer ${request.authToken}`
                    }
                });
                if (response.ok) {
                    const result = await response.json();
                    if (app.ports.fileUploadResult) app.ports.fileUploadResult.send({
                        fileIndex: request.fileIndex,
                        success: true,
                        filePath: result.filePath,
                        filename: result.filename
                    });
                } else {
                    const errorText = await response.text();
                    throw new Error(`Upload failed with status: ${response.status} - ${errorText}`);
                }
            } catch (error) {
                console.error("FileUpload: Upload failed", error);
                if (app.ports.fileUploadResult) app.ports.fileUploadResult.send({
                    fileIndex: request.fileIndex,
                    success: false,
                    filePath: "",
                    filename: "",
                    error: error.message
                });
            }
        });
    }
};
$70bed06a98643566$exports = $70bed06a98643566$var$FileUploadPort;


var $ba7a6a20ab3b4d24$exports = {};
const $ba7a6a20ab3b4d24$var$ElementMeasurementPort = {
    add: function(app) {
        const observers = new Map();
        const resizeObserver = new ResizeObserver((entries)=>{
            entries.forEach((entry)=>{
                const elementId = entry.target.id;
                const config = observers.get(elementId);
                if (config) measureElement(entry.target, config, app);
            });
        });
        const measureElement = (element, config, app)=>{
            const { elementId: elementId, maxLines: maxLines } = config;
            const computedStyle = window.getComputedStyle(element);
            let lineHeight = parseFloat(computedStyle.lineHeight);
            if (isNaN(lineHeight) || lineHeight === 0) {
                const fontSize = parseFloat(computedStyle.fontSize);
                lineHeight = fontSize * 1.5;
            }
            const scrollHeight = element.scrollHeight;
            const maxHeight = lineHeight * maxLines;
            const tolerance = 2;
            const exceedsMaxLines = scrollHeight > maxHeight + tolerance;
            app.ports.onElementMeasured.send({
                elementId: elementId,
                scrollHeight: scrollHeight,
                clientHeight: element.clientHeight,
                lineHeight: lineHeight,
                exceedsMaxLines: exceedsMaxLines
            });
        };
        const setupObserver = (element, config, app)=>{
            const mutationObserver = new MutationObserver((mutations)=>{
                let shouldMeasure = false;
                mutations.forEach((mutation)=>{
                    if (mutation.type === "childList" || mutation.type === "characterData" || mutation.type === "attributes" && (mutation.attributeName === "style" || mutation.attributeName === "class")) shouldMeasure = true;
                });
                if (shouldMeasure) requestAnimationFrame(()=>measureElement(element, config, app));
            });
            mutationObserver.observe(element, {
                childList: true,
                subtree: true,
                characterData: true,
                attributes: true,
                attributeFilter: [
                    "style",
                    "class"
                ]
            });
            resizeObserver.observe(element);
            return mutationObserver;
        };
        app.ports.measureElement.subscribe(function(config) {
            const { elementId: elementId } = config;
            const element = document.getElementById(elementId);
            if (!element) {
                console.warn(`Element with id "${elementId}" not found for measurement`);
                return;
            }
            if (observers.has(elementId)) {
                const existingObserver = observers.get(elementId).observer;
                existingObserver.disconnect();
                resizeObserver.unobserve(element);
            }
            const observer = setupObserver(element, config, app);
            observers.set(elementId, {
                ...config,
                observer: observer
            });
            requestAnimationFrame(()=>{
                requestAnimationFrame(()=>measureElement(element, config, app));
            });
        });
        return function cleanup() {
            observers.forEach(({ observer: observer }, elementId)=>{
                observer.disconnect();
                const element = document.getElementById(elementId);
                if (element) resizeObserver.unobserve(element);
            });
            observers.clear();
            resizeObserver.disconnect();
        };
    }
};
$ba7a6a20ab3b4d24$exports = $ba7a6a20ab3b4d24$var$ElementMeasurementPort;


var $3b9526d384f0dd3d$exports = {};
"use strict";
const $3b9526d384f0dd3d$var$DropdownPort = {
    add: function(app) {
        // Handle outside click to close dropdown
        document.addEventListener("click", (event)=>{
            const dropdown = event.target.closest(".dropdown");
            if (!dropdown) {
                if (app.ports.onDropdownOutsideClick) app.ports.onDropdownOutsideClick.send("");
                return;
            }
            // Clicked inside a dropdown, check if it's the toggle button
            const toggleButton = dropdown.querySelector(".dropdown-toggle");
            if (toggleButton && toggleButton.contains(event.target)) // Toggle button clicked, let Elm handle it
            return;
        // Clicked inside dropdown but not on toggle, don't close
        // (This allows clicking on dropdown items without closing)
        });
        // Handle escape key to close dropdown
        document.addEventListener("keydown", function(event) {
            if (event.key === "Escape") {
                const dropdown = document.querySelector(".dropdown--open");
                if (dropdown) {
                    event.stopPropagation();
                    if (app.ports.onDropdownEscapeKeyPressed) app.ports.onDropdownEscapeKeyPressed.send("");
                }
            }
        }, {
            capture: true
        });
    }
};
$3b9526d384f0dd3d$exports = $3b9526d384f0dd3d$var$DropdownPort;


var $8e7e1145409c40a4$exports = {};
const $8e7e1145409c40a4$var$TextareaAutoResizePort = {
    add: function(app) {
        const elements = new Map();
        const getMaxHeight = ()=>{
            const viewportHeight = window.visualViewport?.height || window.innerHeight;
            return Math.min(viewportHeight * 0.4, 300);
        };
        const resizeTextarea = (element)=>{
            element.style.height = "auto";
            const scrollHeight = element.scrollHeight;
            const maxHeight = getMaxHeight();
            element.style.height = Math.min(scrollHeight, maxHeight) + "px";
            element.style.overflowY = scrollHeight > maxHeight ? "auto" : "hidden";
        };
        const setupElement = (elementId)=>{
            if (elements.has(elementId)) return;
            const element = document.getElementById(elementId);
            if (!element) return;
            const handleResize = ()=>{
                resizeTextarea(element);
            };
            element.addEventListener("input", handleResize);
            window.addEventListener("resize", handleResize);
            const visualViewport = window.visualViewport;
            if (visualViewport) visualViewport.addEventListener("resize", handleResize);
            elements.set(elementId, {
                element: element,
                handleResize: handleResize
            });
            resizeTextarea(element);
        };
        app.ports.autoResize.subscribe(function(elementId) {
            setupElement(elementId);
            const elementData = elements.get(elementId);
            if (elementData) setTimeout(()=>resizeTextarea(elementData.element), 0);
        });
    }
};
$8e7e1145409c40a4$exports = $8e7e1145409c40a4$var$TextareaAutoResizePort;


var $5ce5aeca99e3b2a2$exports = {};
var $c513f619e4da868b$var$d = (r, t, e)=>new Promise((c, f)=>{
        var o = (s)=>{
            try {
                a(e.next(s));
            } catch (u) {
                f(u);
            }
        }, n = (s)=>{
            try {
                a(e.throw(s));
            } catch (u) {
                f(u);
            }
        }, a = (s)=>s.done ? c(s.value) : Promise.resolve(s.value).then(o, n);
        a((e = e.apply(r, t)).next());
    });
var $c513f619e4da868b$export$cf709db89eaa620b = (r)=>$c513f619e4da868b$var$d(null, null, function*() {
        let e = (yield r.arrayBuffer()).slice(8, 12);
        switch(new TextDecoder("utf-8").decode(e).replace("\0", " ").trim()){
            case "mif1":
                return !0;
            case "msf1":
                return !0;
            case "heic":
            case "heix":
                return !0;
            case "hevc":
            case "hevx":
                return !0;
        }
        return !1;
    }), $c513f619e4da868b$var$i, $c513f619e4da868b$var$g = ()=>{
    if (!$c513f619e4da868b$var$i) {
        let r = '(()=>{var NL=Object.defineProperty;var UL=(p1,s1,V1)=>s1 in p1?NL(p1,s1,{enumerable:!0,configurable:!0,writable:!0,value:V1}):p1[s1]=V1;var Tk=(p1=>typeof require!="undefined"?require:typeof Proxy!="undefined"?new Proxy(p1,{get:(s1,V1)=>(typeof require!="undefined"?require:s1)[V1]}):p1)(function(p1){if(typeof require!="undefined")return require.apply(this,arguments);throw Error(\'Dynamic require of "\'+p1+\'" is not supported\')});var DL=(p1,s1)=>()=>(p1&&(s1=p1(p1=0)),s1);var ML=(p1,s1)=>()=>(s1||p1((s1={exports:{}}).exports,s1),s1.exports);var h8=(p1,s1,V1)=>UL(p1,typeof s1!="symbol"?s1+"":s1,V1);var v6=(p1,s1,V1)=>new Promise((r8,L)=>{var m6=C4=>{try{Ri(V1.next(C4))}catch(_8){L(_8)}},Z6=C4=>{try{Ri(V1.throw(C4))}catch(_8){L(_8)}},Ri=C4=>C4.done?r8(C4.value):Promise.resolve(C4.value).then(m6,Z6);Ri((V1=V1.apply(p1,s1)).next())});var HL,kw,nw=DL(()=>{HL=(()=>{var s1;var p1=typeof document!="undefined"?(s1=document.currentScript)==null?void 0:s1.src:void 0;return(function(V1={}){var r8,L=V1,m6,Z6,Ri=new Promise((J,D)=>{m6=J,Z6=D}),C4=typeof window=="object",_8=typeof WorkerGlobalScope!="undefined",G6=typeof process=="object"&&typeof process.versions=="object"&&typeof process.versions.node=="string"&&process.type!="renderer",jk=[],z3="./this.program",uw=(J,D)=>{throw D};typeof __filename!="undefined"?p1=__filename:_8&&(p1=self.location.href);var He="";function ow(J){return L.locateFile?L.locateFile(J,He):He+J}var x3,Ji;if(G6){var T3=Tk("fs"),TL=Tk("path");He=__dirname+"/",Ji=J=>{J=S3(J)?new URL(J):J;var D=T3.readFileSync(J);return D},x3=(J,D=!0)=>v6(null,null,function*(){J=S3(J)?new URL(J):J;var j=T3.readFileSync(J,D?void 0:"utf8");return j}),process.argv.length>1&&(z3=process.argv[1].replace(/\\\\/g,"/")),jk=process.argv.slice(2),uw=(J,D)=>{throw process.exitCode=J,D}}else if(C4||_8){try{He=new URL(".",p1).href}catch(J){}_8&&(Ji=J=>{var D=new XMLHttpRequest;return D.open("GET",J,!1),D.responseType="arraybuffer",D.send(null),new Uint8Array(D.response)}),x3=J=>v6(null,null,function*(){if(S3(J))return new Promise((j,K)=>{var i0=new XMLHttpRequest;i0.open("GET",J,!0),i0.responseType="arraybuffer",i0.onload=()=>{if(i0.status==200||i0.status==0&&i0.response){j(i0.response);return}K(i0.status)},i0.onerror=K,i0.send(null)});var D=yield fetch(J,{credentials:"same-origin"});if(D.ok)return D.arrayBuffer();throw new Error(D.status+" : "+D.url)})}var ze=console.log.bind(console),Ni=console.error.bind(console),xe,S6={Memory:function(J){this.buffer=new ArrayBuffer(J.initial*65536)},Module:function(J){},Instance:function(J,D){this.exports=(function(K){function i0(h1){return h1.set=function(W1,u){this[W1]=u},h1.get=function(W1){return this[W1]},h1}for(var c,h0=new Uint8Array(123),Z0=25;Z0>=0;--Z0)h0[48+Z0]=52+Z0,h0[65+Z0]=Z0,h0[97+Z0]=26+Z0;h0[43]=62,h0[47]=63;function B0(h1,W1,u){for(var g,i,l=0,C=W1,u0=u.length,p0=W1+(u0*3>>2)-(u[u0-2]=="=")-(u[u0-1]=="=");l<u0;l+=4)g=h0[u.charCodeAt(l+1)],i=h0[u.charCodeAt(l+2)],h1[C++]=h0[u.charCodeAt(l)]<<2|g>>4,C<p0&&(h1[C++]=g<<4|i>>2),C<p0&&(h1[C++]=i<<6|h0[u.charCodeAt(l+3)]);return h1}function q0(h1){B0(c,1024,"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"),B0(c,47142,"AQ=="),B0(c,47159,"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"),B0(c,49762,"AQ=="),B0(c,49779,"QDE1TWRhdERhdGFfTWVtb3J5ADhNZGF0RGF0YQADAAAACgAAAAsAAAAMAAAADQAAAA4AAAAPAAAAMTRJbWFnZUV4dHJhRGF0YQAxNEhlaWZQaXhlbEltYWdlAE5TdDNfXzIyM2VuYWJsZV9zaGFyZWRfZnJvbV90aGlzSTE0SGVpZlBpeGVsSW1hZ2VFRQAxMUVycm9yQnVmZmVyAE5TdDNfXzIyMF9fc2hhcmVkX3B0cl9lbXBsYWNlSTE4Y29sb3JfcHJvZmlsZV9uY2x4TlNfOWFsbG9jYXRvcklTMV9FRUVFAAMAAAAEAAAABgAAAAgAAAAGAAAACAAAADE3Y29sb3JfcHJvZmlsZV9yYXcAMThjb2xvcl9wcm9maWxlX25jbHgAOEJveF9jb2xyAE5TdDNfXzIyMF9fc2hhcmVkX3B0cl9lbXBsYWNlSTE3Y29sb3JfcHJvZmlsZV9yYXdOU185YWxsb2NhdG9ySVMxX0VFRUUAAACamZk+AAAAAAAAAAA9Clc+4XqUPlK4nj5SuJ4+/tR4PnsULj4AAAAAFK6HPhSuhz4="),B0(c,50240,"PQqXPpqZGT8AAAAAAAAAAI/CNT+amRk/7FEYP+xRGD/pJjE/MQhMPwAAgD/XozA/16MwPw=="),B0(c,50328,"SOEaP5qZGT4AAAAAAAAAAClcDz6amRk+UrgePlK4Hj7hehQ+3SQGPgAAAACamRk+mpkZPg=="),B0(c,50416,"UrgePo/CdT0AAAAAAAAAAArXoz2PwnU9KVyPPSlcjz05tEg9f2o8PQAAAACPwnU9j8J1PQ=="),B0(c,50504,"LbKdPQrXIz8AAAAAAAAAAB+FKz8K1yM/rkchP65HIT8EVi4/fT81PwAAgD97FC4/exQuPw=="),B0(c,50592,"rkchP8P1qD4AAAAAAAAAAMP1qD7D9ag+exSuPnsUrj74U6M+BoGVPgAAAAAK16M+CtejPg=="),B0(c,50680,"exSuPjcaoD4AAAAAAAAAAFK4nj43GqA+NxqgPjcaoD5SuJ4+NxqgPp+qqj6cxKA+NxqgPg=="),B0(c,50768,"NxqgPrByqD4AAAAAAAAAAMHKoT6wcqg+sHKoPrByqD7ByqE+sHKoPjuqqj5GtrM+sHKoPg=="),B0(c,50856,"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"),B0(c,59022,"AQ=="),B0(c,59039,"QDEyVHJhY2tfVmlzdWFsADE0VHJhY2tfTWV0YWRhdGEAU3VjY2Vzcw=="),B0(c,59088,"AQAAAAIAAABMAAAAVAAAAFQAAABQAAAAWAAAAFgAAADAQQAAyEEAAMhBAAAAAAAAxQAAALkAAADJAAAAxQAAALkAAADJAAAAlQAAAIYAAABuAAAAmgAAAHoAAACJAAAAjAAAAMYAAACpAAAAxgAAAIsAAACNAAAAnQAAAGsAAACLAAAAfgAAAGsAAACLAAAAfg=="),B0(c,59248,"uAAAAJoAAACLAAAAmgAAAJoAAACaAAAAiwAAAJoAAACaAAAAuAAAAJoAAAC3AAAAPwAAAJgAAACYAAAAAAAAAG8AAACNAAAAmQAAAG8AAABeAAAAigAAALYAAACaAAAAlQAAAGsAAACnAAAAmgAAAJUAAABcAAAApwAAAJoAAACZAAAAigAAAIoAAAB8AAAAigAAAF4AAADgAAAApwAAAHo="),B0(c,59424,"bgAAAG4AAAB8AAAAfQAAAIwAAACZAAAAfQAAAH8AAACMAAAAbQAAAG8AAACPAAAAfwAAAG8AAABPAAAAbAAAAHsAAAA/AAAAfQAAAG4AAABeAAAAbgAAAF8AAABPAAAAfQAAAG8AAABuAAAATgAAAG4AAABvAAAAbwAAAF8AAABeAAAAbAAAAHsAAABsAAAAfQAAAG4AAAB8AAAAbgAAAF8AAABeAAAAfQAAAG8AAABvAAAATwAAAH0AAAB+AAAAbwAAAG8AAABPAAAAbAAAAHsAAABd"),B0(c,59648,"WwAAAKsAAACGAAAAjQAAAHkAAACMAAAAPQAAAJoAAAB5AAAAjAAAAD0AAACaAAAAbwAAAG8AAAB9AAAAbgAAAG4AAABeAAAAfAAAAGwAAAB8AAAAawAAAH0AAACNAAAAswAAAJkAAAB9AAAAawAAAH0AAACNAAAAswAAAJkAAAB9AAAAawAAAH0AAACNAAAAswAAAJkAAAB9AAAAjAAAAIsAAAC2AAAAtgAAAJgAAACIAAAAmAAAAIgAAACZAAAAiAAAAIsAAABvAAAAiAAAAIsAAABvAAAAmwAAAJoAAACLAAAAmQAAAIsAAAB7AAAAewAAAD8AAACZAAAApgAAALcAAACMAAAAiAAAAJkAAACaAAAApgAAALcAAACMAAAAiAAAAJkAAACaAAAApgAAALcAAACMAAAAiAAAAJkAAACaAAAAqgAAAJkAAAB7AAAAewAAAGsAAAB5AAAAawAAAHkAAACnAAAAlwAAALcAAACMAAAAlwAAALcAAACMAAAAqgAAAJoAAACLAAAAmQAAAIsAAAB7AAAAewAAAD8AAAB8AAAApgAAALcAAACMAAAAiAAAAJkAAACaAAAApgAAALcAAACMAAAAiAAAAJkAAACaAAAApgAAALcAAACMAAAAiAAAAJkAAACaAAAAqgAAAJkAAACKAAAAigAAAHoAAAB5AAAAegAAAHkAAACnAAAAlwAAALcAAACMAAAAlwAAALcAAACM"),B0(c,60208,"jQAAAG8AAACMAAAAjAAAAIwAAACM"),B0(c,60240,"jAAAAFwAAACJAAAAigAAAIwAAACYAAAAigAAAIsAAACZAAAASgAAAJUAAABcAAAAiwAAAGsAAAB6AAAAmAAAAIwAAACzAAAApgAAALYAAACMAAAA4wAAAHoAAADFAAAAmgAAAMQAAADEAAAApwAAAJoAAACYAAAApwAAALYAAAC2AAAAhgAAAJUAAACIAAAAmQAAAHkAAACIAAAAiQAAAKkAAADCAAAApgAAAKcAAACaAAAApwAAAIkAAAC2AAAAmgAAAMQAAACnAAAApwAAAJoAAACYAAAApwAAALYAAAC2AAAAhgAAAJUAAACIAAAAmQAAAHkAAACIAAAAegAAAKkAAADQAAAApgAAAKcAAACaAAAAmAAAAKcAAAC2AAAAigAAAJkAAACIAAAApwAAAJgAAACYAAAAawAAAKcAAABbAAAAegAAAGsAAACnAAAAawAAAKcAAABbAAAAawAAAGsAAACnAAAAyAAAALkAAACgAAAAAAAAANzsAAAnBwAAKAcAACkHAAAqBwAAVE4BAOjsAAAI7QAAMjZ0aHJlYWRfdGFza19kZWJsb2NrX0NUQlJvdwAAAAAsTgEAEO0AADExdGhyZWFkX3Rhc2s="),B0(c,60720,"BgcICQoLDA0ODxAREhQWGBocHiAiJCYoKiwuMDI0Njg6PD5A"),B0(c,60786,"AQEBAQEBAQEBAgICAgMDAwMEBAQFBQYGBwgJCgsNDhASFBYY"),B0(c,60832,"gLDQ8ICnxeOAnrvYe5ayzXSOqcNvh6C5aYCYr2R6kKZfdImeWm6CllVoe45RY3WHTV5vgElZaXpFVWR0QlBfbj5MWmg7SFZjOEVRXjVBTVkzPklVMDtFUC44QkwrNT9IKTI7RScwOEElLTY+IyszOyEpMDggJy41HiUrMh0jKTAbISctGh8lKxgeIykXHCEnFhsgJRUaHiMUGB0hExcbHxIWGh4RFRkcEBQXGw8TFhkOEhUYDhEUFw0QExYMDxIVDA4RFAsOEBMLDQ8SCgwPEQoMDhAJCw0PCQsMDggKDA4ICQsNBwkLDAcJCgwHCAoLBggJCwYHCQoGBwgJAgICAgECAwQFBgcICQoLDA0ODxAREhMUFRYXGBkaGxwdHh8gISIjJCUmJygpKissLS4vMDEyMzQ1Njc4OTo7PD0+Pj8GBQQEAwMDAwICAgICAgICAQEBAQEBAQEBAQEBAQEBAQAAAQICBAQFBgcICQkLCwwNDQ8PEBASEhMTFRUWFhcYGBkaGhsbHB0dHh4eHyAgISEhIiIjIyMkJCQlJSUmJj8AAAAAkO8AACsHAAAsBwAAHgAAAB4AAAAAAAAAcO8AAC0HAAAuBwAALwcAADAHAABUTgEAfO8AAJDvAAAxNWRlY29kZXJfY29udGV4dAAAALBOAQCo7wAAAAAAAAEAAAC47wAAAgQAADEyYmFzZV9jb250ZXh0AAAsTgEAwO8AADExZXJyb3JfcXVldWUAAAAAAAAA7O8AADEHAAAyBwAAMwcAAC0BAAA0BwAAVE4BAPjvAADwSgEATlN0M19fMjIwX19zaGFyZWRfcHRyX2VtcGxhY2VJMTl2aWRlb19wYXJhbWV0ZXJfc2V0TlNfOWFsbG9jYXRvcklTMV9FRUVFAAAAAAAAAABg8AAANQcAADYHAAA3BwAALQEAADgHAABUTgEAbPAAAPBKAQBOU3QzX18yMjBfX3NoYXJlZF9wdHJfZW1wbGFjZUkxN3NlcV9wYXJhbWV0ZXJfc2V0TlNfOWFsbG9jYXRvcklTMV9FRUVFAAAAAAAA0PAAADkHAAA6BwAAOwcAAC0BAAA8BwAAVE4BANzwAADwSgEATlN0M19fMjIwX19zaGFyZWRfcHRyX2VtcGxhY2VJMTdwaWNfcGFyYW1ldGVyX3NldE5TXzlhbGxvY2F0b3JJUzFfRUVFRQ=="),B0(c,61744,"QEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBaWlhVUk5JQz02LiYfFg0E/PPq4drSysO9t7Kuq6implpXUEY5KxkJ9+fVx7qwqaamqbC6x9Xn9wkZKzlGUFdaWlJDLhb84cq3q6aossPa8w0mPU5YWlVJNh8E6tK9rqZZSzIS7s61p6e1zu4SMktZWUsyEu7Otaentc7uEjJLWVhDH/PKrqay0vwmSVpVPRbqw6umt9oELk5aUjYN4b2oVzkJ1bCmuucZRlpQK/fHqanH9ytQWkYZ57qmsNUJOVdVLvO9prfqJlJYNvzDprLhH05aPQTKqK7aFklaQw3Sq1Mk3K2t3CRTUyTcra3cJFNTJNytrdwkU1Mk3K2t3CRTUhbKpsMNTlUf0qa9BElYJtqot/xDWi7hq7LzPVo26q5QCbqp5zlaK9WmxxlXRvewsPdGVxnHptUrWjnnqboJUE78rrcNVUPqqMMfWjbaptIuWibKpuE9WBa9q/NJUgSyS+6nzjJZErW1ElkyzqfuS0vup84yWRK1tRJZMs6n7ktJ4abqTkPapvNSPdKo/FU2yqsEWC7Drg1aJr2yFloft0bVqQlaGbDHOVDnpvdXK7q6K1f3pudQOcewGVoJqdVGQ8qyJlXqpgRaDajhUi63wz1J0q4fWPOm/FoWq9pONr1AwMBAQMDAQEDAwEBAwMBAQMDAQEDAwEBAwMBAQMDAQD230lIfqPNa/KYWVdqyNkO9yk4mq+paBKYNWOGuLknDObDnWvepK0a61VcJphlQx8dQGaYJV9W6Riup91rnsDk2q/xY0sNSDaYmQ7LqWuG3SR+mFk692lrzrj0uqARVyjKnEku17lnOzlnutUsSpzIypxJLte5Zzs5Z7rVLEqcyLqYmNqYfPagWQ6sNSa4ETrL8UrfzVb3qWMPhWsraWtIrpjkZqUYJsFD3ulfnx1rV1VrH51e691CwCUapGTmmKyaoSfy9WtLhVbINPaY2Fq5S6spaw/NOqx8upkMEt1jaJK1T3NxTrSQkrVPc3FOtJCStU9zcU60kJK1T3NxTrSQfslrDBDaoUtrqSaZD89JVqy4NvVq3FiauWMr8PaZO4Rm6WrArCcdXqTn31VCmRufnRqZQ1fc5qVfHCSuwWroZFsNVpkna/C6yWq428+FDqFi9Hw3KUqZO0gQmt1qrPeoSzkunWbUy7u4ytVmnS84SEs5Lp1m1Mu7uMrVZp0vOEg3aPbJYplW3NuEEFtJDrlqmUr0u6vwfykmrWqhOwybzCecrx0awV6ZaqVC6OdUZ9/cZ1Tm6UKlaplewRscr5wkE8xbhJtI2w0O3Tq5VqFqmWqZYq1KySb09yi7aH+oN/AAAAAADAAAAAwAAAAIAAAAAAAAAAwAAAAQAAAAEAAAAAAAAAGj1AAAnBwAAkAcAAJEHAACSBwAAVE4BAHT1AAAI7QAAMTV0aHJlYWRfdGFza19zYW8AAAABAAAAAAAAAAEAAAD//////////wAAAAD/////AQAAAAAAAAABAAAAAQAAAAEAAAAAAAAA////////////////AAAAAAAAAABkqAEAZqgBAHCoAQCQqAEAEKkBABCrAQ=="),B0(c,62960,"ZKgBABCzAQAgswEAQLMBAMCzAQDAtQE="),B0(c,62992,"ZKgBAMC9AQDQvQEA8L0BAHC+AQBwwAE="),B0(c,63032,"cMgBAJDIAQAQyQEAEMsB"),B0(c,63056,"ENMBADDTAQCw0wEAsNUB"),B0(c,63080,"sN0BANDdAQBQ3gEAUOABAND1AADw9QAAEPY="),B0(c,63128,"IAAAABoAAAAVAAAAEQAAAA0AAAAJAAAABQAAAAIAAAAAAAAA/v////v////3////8////+/////r////5v///+D////m////6////+/////z////9/////v////+////AAAAAAIAAAAFAAAACQAAAA0AAAARAAAAFQAAABoAAAAgAAAAAAAAAADw//+a+f//cvz//4r9//8e/v//ev7//8X+//8A////xf7//3r+//8e/v//iv3//3L8//+a+f//APD//wAAAAAAAAAAAQAAAAAAAAACAAAAAQAAAAIAAAAAAAAAAwAAAAEAAAADAAAAAgAAAAMAAAABAAAAAAAAAAIAAAAAAAAAAgAAAAEAAAADAAAAAAAAAAMAAAABAAAAAwAAAAIAAAAAAAAA0PcAAJMHAACUBwAAVE4BANz3AAAA+AAAMzBNb3Rpb25WZWN0b3JBY2Nlc3NfZGUyNjVfaW1hZ2UAAAAALE4BAAj4AAAxOE1vdGlvblZlY3RvckFjY2VzcwAAAAAAAAAAAwAAAAMAAAACAAAAAAAAAAMAAAAEAAAABAAAAAABBAUCAwQFBgYICAcHCGMAAAAAGgAAAAoAAAABAAAAAAECAgICAwUHCAoMDQ8REhMUFRYXFxgYGRkaGxscHB0dHh8AAAAAAJz4AAAnBwAAlQcAAJYHAACXBwAAVE4BAKj4AAAI7QAAMjV0aHJlYWRfdGFza19zbGljZV9zZWdtZW50AAAAAADc+AAAJwcAAJgHAACZBwAAmgcAAFROAQDo+AAACO0AADE5dGhyZWFkX3Rhc2tfY3RiX3JvdwAAAAEAAAACAAAAAgAAAAEAAAABAAAAAgAAAAEAAAABAAAA5DIAAO9VAAA0VAAAAAAAAB0AAAAeAAAAHwAAACAAAAAhAAAAIQAAACIAAAAiAAAAIwAAACMAAAAkAAAAJAAAACU="),B0(c,63856,"KAAAAC0AAAAzAAAAOQAAAEAAAABIAAAAICQAAAVWAAA2MAAAJBM="),B0(c,63908,"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"),B0(c,67491,"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"),B0(c,69490,"pQJbAPABtQWMBSUBgwYdA5QE/wDHAzEDCwa8AY8BfwPKBCsA2gavAEIDTgPcAQ4EFQChBg0BlAILAjgGZAK8Av8CXQPnBAsHzwLLBe8F2wXhAh4GRQKFAIICbANvBPEA8wMYBdkA2gNMBlQCewGdA70EAABRABUCuwCzA20A/wGFBC8F+QQ4AGUBRgGfALcGqAFzAlMB"),B0(c,69688,"IQQAAAAAAAAAAC8C"),B0(c,69720,"NQRHBFYE"),B0(c,69742,"oAQ="),B0(c,69762,"RgVgBW4FYQYAAM8BAAAAAAAAAADJBukG+QYeBzkHSQdeBw=="),B0(c,69808,"GQALABkZGQAAAAAFAAAAAAAACQAAAAALAAAAAAAAAAAZAAoKGRkZAwoHAAEACQsYAAAJBgsAAAsABhkAAAAZGRk="),B0(c,69889,"DgAAAAAAAAAAGQALDRkZGQANAAACAAkOAAAACQAOAAAO"),B0(c,69947,"DA=="),B0(c,69959,"EwAAAAATAAAAAAkMAAAAAAAMAAAM"),B0(c,70005,"EA=="),B0(c,70017,"DwAAAAQPAAAAAAkQAAAAAAAQAAAQ"),B0(c,70063,"Eg=="),B0(c,70075,"EQAAAAARAAAAAAkSAAAAAAASAAASAAAaAAAAGhoa"),B0(c,70130,"GgAAABoaGgAAAAAAAAk="),B0(c,70179,"FA=="),B0(c,70191,"FwAAAAAXAAAAAAkUAAAAAAAUAAAU"),B0(c,70237,"Fg=="),B0(c,70249,"FQAAAAAVAAAAAAkWAAAAAAAWAAAWAAAwMTIzNDU2Nzg5QUJDREVG"),B0(c,70324,"owc="),B0(c,70364,"//////////8="),B0(c,70436,"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"),B0(c,73152,"hB0B"),B0(c,73184,"AgAAwAMAAMAEAADABQAAwAYAAMAHAADACAAAwAkAAMAKAADACwAAwAwAAMANAADADgAAwA8AAMAQAADAEQAAwBIAAMATAADAFAAAwBUAAMAWAADAFwAAwBgAAMAZAADAGgAAwBsAAMAcAADAHQAAwB4AAMAfAADAAAAAswEAAMMCAADDAwAAwwQAAMMFAADDBgAAwwcAAMMIAADDCQAAwwoAAMMLAADDDAAAww0AANMOAADDDwAAwwAADLsBAAzDAgAMwwMADMMEAAzbAAAAAOweAQCmBwAAAggAAAMIAACpBwAAqgcAAKsHAACsBwAArQcAAK4HAAAECAAABQgAAAYIAACyBwAAswcAAFROAQD4HgEAABcBAE5TdDNfXzIxMF9fc3RkaW5idWZJY0VFAAAAAABQHwEApgcAAAcIAAAICAAAqQcAAKoHAACrBwAACQgAAK0HAACuBwAArwcAALAHAACxBwAACggAAAsIAABUTgEAXB8BAAAXAQBOU3QzX18yMTFfX3N0ZG91dGJ1ZkljRUUAAAAAAAAAALgfAQDCBwAADAgAAA0IAADFBwAAxgcAAMcHAADIBwAAyQcAAMoHAAAOCAAADwgAABAIAADOBwAAzwcAAFROAQDEHwEAtBgBAE5TdDNfXzIxMF9fc3RkaW5idWZJd0VFAAAAAAAcIAEAwgcAABEIAAASCAAAxQcAAMYHAADHBwAAEwgAAMkHAADKBwAAywcAAMwHAADNBwAAFAgAABUIAABUTgEAKCABALQYAQBOU3QzX18yMTFfX3N0ZG91dGJ1Zkl3RUU="),B0(c,73808,"0XSeAFedvSqAcFIP//8+JwoAAABkAAAA6AMAABAnAACghgEAQEIPAICWmAAA4fUFGAAAADUAAABxAAAAa////877//+Sv///AAAAAAAAAAD/////////////////////////////////////////////////////////////////AAECAwQFBgcICf////////8KCwwNDg8QERITFBUWFxgZGhscHR4fICEiI////////woLDA0ODxAREhMUFRYXGBkaGxwdHh8gISIj/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////wABAgQHAwYFAAAAAAAAAExDX0NUWVBFAAAAAExDX05VTUVSSUMAAExDX1RJTUUAAAAAAExDX0NPTExBVEUAAExDX01PTkVUQVJZAExDX01FU1NBR0VT"),B0(c,74244,"gN4oAIDITQAAp3YAADSeAIASxwCAn+4AAH4XAYBcQAGA6WcBAMiQAQBVuAEu"),B0(c,74304,"U3VuAE1vbgBUdWUAV2VkAFRodQBGcmkAU2F0AFN1bmRheQBNb25kYXkAVHVlc2RheQBXZWRuZXNkYXkAVGh1cnNkYXkARnJpZGF5AFNhdHVyZGF5AEphbgBGZWIATWFyAEFwcgBNYXkASnVuAEp1bABBdWcAU2VwAE9jdABOb3YARGVjAEphbnVhcnkARmVicnVhcnkATWFyY2gAQXByaWwATWF5AEp1bmUASnVseQBBdWd1c3QAU2VwdGVtYmVyAE9jdG9iZXIATm92ZW1iZXIARGVjZW1iZXIAQU0AUE0AJWEgJWIgJWUgJVQgJVkAJW0vJWQvJXkAJUg6JU06JVMAJUk6JU06JVMgJXAAAAAlbS8lZC8leQAwMTIzNDU2Nzg5ACVhICViICVlICVUICVZACVIOiVNOiVTAAAAAABeW3lZXQBeW25OXQB5ZXMAbm8AAKAlAQ=="),B0(c,75172,"AQAAAAIAAAADAAAABAAAAAUAAAAGAAAABwAAAAgAAAAJAAAACgAAAAsAAAAMAAAADQAAAA4AAAAPAAAAEAAAABEAAAASAAAAEwAAABQAAAAVAAAAFgAAABcAAAAYAAAAGQAAABoAAAAbAAAAHAAAAB0AAAAeAAAAHwAAACAAAAAhAAAAIgAAACMAAAAkAAAAJQAAACYAAAAnAAAAKAAAACkAAAAqAAAAKwAAACwAAAAtAAAALgAAAC8AAAAwAAAAMQAAADIAAAAzAAAANAAAADUAAAA2AAAANwAAADgAAAA5AAAAOgAAADsAAAA8AAAAPQAAAD4AAAA/AAAAQAAAAEEAAABCAAAAQwAAAEQAAABFAAAARgAAAEcAAABIAAAASQAAAEoAAABLAAAATAAAAE0AAABOAAAATwAAAFAAAABRAAAAUgAAAFMAAABUAAAAVQAAAFYAAABXAAAAWAAAAFkAAABaAAAAWwAAAFwAAABdAAAAXgAAAF8AAABgAAAAQQAAAEIAAABDAAAARAAAAEUAAABGAAAARwAAAEgAAABJAAAASgAAAEsAAABMAAAATQAAAE4AAABPAAAAUAAAAFEAAABSAAAAUwAAAFQAAABVAAAAVgAAAFcAAABYAAAAWQAAAFoAAAB7AAAAfAAAAH0AAAB+AAAAfw=="),B0(c,76192,"sCsB"),B0(c,76724,"AQAAAAIAAAADAAAABAAAAAUAAAAGAAAABwAAAAgAAAAJAAAACgAAAAsAAAAMAAAADQAAAA4AAAAPAAAAEAAAABEAAAASAAAAEwAAABQAAAAVAAAAFgAAABcAAAAYAAAAGQAAABoAAAAbAAAAHAAAAB0AAAAeAAAAHwAAACAAAAAhAAAAIgAAACMAAAAkAAAAJQAAACYAAAAnAAAAKAAAACkAAAAqAAAAKwAAACwAAAAtAAAALgAAAC8AAAAwAAAAMQAAADIAAAAzAAAANAAAADUAAAA2AAAANwAAADgAAAA5AAAAOgAAADsAAAA8AAAAPQAAAD4AAAA/AAAAQAAAAGEAAABiAAAAYwAAAGQAAABlAAAAZgAAAGcAAABoAAAAaQAAAGoAAABrAAAAbAAAAG0AAABuAAAAbwAAAHAAAABxAAAAcgAAAHMAAAB0AAAAdQAAAHYAAAB3AAAAeAAAAHkAAAB6AAAAWwAAAFwAAABdAAAAXgAAAF8AAABgAAAAYQAAAGIAAABjAAAAZAAAAGUAAABmAAAAZwAAAGgAAABpAAAAagAAAGsAAABsAAAAbQAAAG4AAABvAAAAcAAAAHEAAAByAAAAcwAAAHQAAAB1AAAAdgAAAHcAAAB4AAAAeQAAAHoAAAB7AAAAfAAAAH0AAAB+AAAAfw=="),B0(c,77744,"MDEyMzQ1Njc4OWFiY2RlZkFCQ0RFRnhYKy1wUGlJbk4AJUk6JU06JVMgJXAlSDolTQ=="),B0(c,77808,"JQAAAG0AAAAvAAAAJQAAAGQAAAAvAAAAJQAAAHkAAAAlAAAAWQAAAC0AAAAlAAAAbQAAAC0AAAAlAAAAZAAAACUAAABJAAAAOgAAACUAAABNAAAAOgAAACUAAABTAAAAIAAAACUAAABwAAAAAAAAACUAAABIAAAAOgAAACUAAABN"),B0(c,77952,"JQAAAEgAAAA6AAAAJQAAAE0AAAA6AAAAJQAAAFMAAAAAAAAA4DkBACgIAAApCAAAKggAAAAAAABEOgEAKwgAACwIAAAqCAAALQgAAC4IAAAvCAAAMAgAADEIAAAyCAAAMwgAADQI"),B0(c,78064,"BAAAAAQAAAAEAAAABAAAAAQAAAAEAAAABAAAAAQAAAAEAAAABQIAAAUAAAAFAAAABQAAAAUAAAAEAAAABAAAAAQAAAAEAAAABAAAAAQAAAAEAAAABAAAAAQAAAAEAAAABAAAAAQAAAAEAAAABAAAAAQAAAAEAAAABAAAAAQAAAADAgAAggAAAIIAAACCAAAAggAAAIIAAACCAAAAggAAAIIAAACCAAAAggAAAIIAAACCAAAAggAAAIIAAACCAAAAQgEAAEIBAABCAQAAQgEAAEIBAABCAQAAQgEAAEIBAABCAQAAQgEAAIIAAACCAAAAggAAAIIAAACCAAAAggAAAIIAAAAqAQAAKgEAACoBAAAqAQAAKgEAACoBAAAqAAAAKgAAACoAAAAqAAAAKgAAACoAAAAqAAAAKgAAACoAAAAqAAAAKgAAACoAAAAqAAAAKgAAACoAAAAqAAAAKgAAACoAAAAqAAAAKgAAAIIAAACCAAAAggAAAIIAAACCAAAAggAAADIBAAAyAQAAMgEAADIBAAAyAQAAMgEAADIAAAAyAAAAMgAAADIAAAAyAAAAMgAAADIAAAAyAAAAMgAAADIAAAAyAAAAMgAAADIAAAAyAAAAMgAAADIAAAAyAAAAMgAAADIAAAAyAAAAggAAAIIAAACCAAAAggAAAAQ="),B0(c,79092,"nDkBADUIAAA2CAAAKggAADcIAAA4CAAAOQgAADoIAAA7CAAAPAgAAD0IAAAAAAAAeDoBAD4IAAA/CAAAKggAAEAIAABBCAAAQggAAEMIAABECAAAAAAAAJw6AQBFCAAARggAACoIAABHCAAASAgAAEkIAABKCAAASwgAAHQAAAByAAAAdQAAAGUAAAAAAAAAZgAAAGEAAABsAAAAcwAAAGUAAAAAAAAAJQAAAG0AAAAvAAAAJQAAAGQAAAAvAAAAJQAAAHkAAAAAAAAAJQAAAEgAAAA6AAAAJQAAAE0AAAA6AAAAJQAAAFMAAAAAAAAAJQAAAGEAAAAgAAAAJQAAAGIAAAAgAAAAJQAAAGQAAAAgAAAAJQAAAEgAAAA6AAAAJQAAAE0AAAA6AAAAJQAAAFMAAAAgAAAAJQAAAFkAAAAAAAAAJQAAAEkAAAA6AAAAJQAAAE0AAAA6AAAAJQAAAFMAAAAgAAAAJQAAAHA="),B0(c,79468,"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"),B0(c,84596,"YD8BAMAIAADBCAAAwggAAMMIAADECAAAxQgAAMYIAAAAAAAAUEABANAIAADRCAAA0ggAANMIAADUCAAA1QgAANYIAAAAAAAAzEoBAD8FAAAZCQAAHgAAACxOAQDUSgEATlN0M19fMjE0X19zaGFyZWRfY291bnRFAAAAALBOAQAISwEAAAAAAAEAAADMSgEAAAAAAE5TdDNfXzIxOV9fc2hhcmVkX3dlYWtfY291bnRFAAAAAAAAADxLAQAPAwAAGgkAABsJAABUTgEASEsBAFxPAQBOU3QzX18yMTJiYWRfd2Vha19wdHJFAAAAAAAAdEsBACAAAAAcCQAAHQkAAFROAQCASwEAXE8BAFN0MThiYWRfdmFyaWFudF9hY2Nlc3MAAFROAQCkSwEAUFABAE4xMF9fY3h4YWJpdjExNl9fc2hpbV90eXBlX2luZm9FAAAAAFROAQDUSwEAmEsBAE4xMF9fY3h4YWJpdjExN19fY2xhc3NfdHlwZV9pbmZvRQAAAFROAQAETAEAmEsBAE4xMF9fY3h4YWJpdjExN19fcGJhc2VfdHlwZV9pbmZvRQAAAFROAQA0TAEA+EsBAE4xMF9fY3h4YWJpdjExOV9fcG9pbnRlcl90eXBlX2luZm9FAFROAQBkTAEAmEsBAE4xMF9fY3h4YWJpdjEyMF9fZnVuY3Rpb25fdHlwZV9pbmZvRQAAAABUTgEAmEwBAPhLAQBOMTBfX2N4eGFiaXYxMjlfX3BvaW50ZXJfdG9fbWVtYmVyX3R5cGVfaW5mb0UAAAAAAAAA5EwBAB4JAAAfCQAAIAkAACEJAAAiCQAAVE4BAPBMAQCYSwEATjEwX19jeHhhYml2MTIzX19mdW5kYW1lbnRhbF90eXBlX2luZm9FANBMAQAgTQEAdgAAANBMAQAsTQEARG4AANBMAQA4TQEAYgAAANBMAQBETQEAYwAAANBMAQBQTQEAaAAAANBMAQBcTQEAYQAAANBMAQBoTQEAcwAAANBMAQB0TQEAdAAAANBMAQCATQEAaQAAANBMAQCMTQEAagAAANBMAQCYTQEAbAAAANBMAQCkTQEAbQAAANBMAQCwTQEAeAAAANBMAQC8TQEAeQAAANBMAQDITQEAZgAAANBMAQDUTQEAZAAAAAAAAAD0TQEAHgkAACMJAAAgCQAAIQkAACQJAABUTgEAAE4BAJhLAQBOMTBfX2N4eGFiaXYxMTZfX2VudW1fdHlwZV9pbmZvRQAAAAAAAAAAyEsBAB4JAAAlCQAAIAkAACEJAAAmCQAAJwkAACgJAAApCQAAAAAAAHROAQAeCQAAKgkAACAJAAAhCQAAJgkAACsJAAAsCQAALQkAAFROAQCATgEAyEsBAE4xMF9fY3h4YWJpdjEyMF9fc2lfY2xhc3NfdHlwZV9pbmZvRQAAAAAAAAAA0E4BAB4JAAAuCQAAIAkAACEJAAAmCQAALwkAADAJAAAxCQAAVE4BANxOAQDISwEATjEwX19jeHhhYml2MTIxX192bWlfY2xhc3NfdHlwZV9pbmZvRQAAAAAAAAAoTAEAHgkAADIJAAAgCQAAIQkAADMJAAAAAAAAdE8BACAAAAA0CQAANQkAAAAAAACQTwEAIAAAADYJAAA3CQAAAAAAAFxPAQAgAAAAOAkAADkJAAAsTgEAZE8BAFN0OWV4Y2VwdGlvbgAAAABUTgEAgE8BAFxPAQBTdDliYWRfYWxsb2MAAAAAVE4BAJxPAQB0TwEAU3QyMGJhZF9hcnJheV9uZXdfbGVuZ3RoAAAAAAAAAADMTwEAAQAAADoJAAA7CQAAVE4BANhPAQBcTwEAU3QxMWxvZ2ljX2Vycm9yAAAAAAD8TwEAAQAAADwJAAA7CQAAVE4BAAhQAQDMTwEAU3QxMmxlbmd0aF9lcnJvcgAAAAAAAAAAMFABAAEAAAA9CQAAOwkAAFROAQA8UAEAzE8BAFN0MTJvdXRfb2ZfcmFuZ2UAAAAALE4BAFhQAQBTdDl0eXBlX2luZm8="),B0(c,86132,"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"),B0(c,95531,"QAAAAAAAAAABAAAAAAABAADoAwAAAABABgAAAAAAAAAAAQAAAAABAAAgAAAAQAAAAGQAAAAAAAAAAQAAAAAEAAAABAAAgKgSAegDAAAD"),B0(c,95696,"BAAAAAAAAABbPwAAAAAAAPx1AQA2AwAANwMAADgDAAA5AwAAOgMAADsDAABUTgEAzMYAACRyAQAAAAAAKHYBADYDAAA8AwAAPQMAAD4DAAA/AwAAQAMAAFROAQDjxgAAJHIBAAAAAABUdgEANgMAAEEDAABCAwAAQwMAAEQDAABFAwAAVE4BAP7GAAAkcgEAAAAAAIB2AQA2AwAARgMAAEcDAABIAwAASQMAAEoDAABUTgEAF8cAACRyAQAAAAAArHYBAEsDAABMAwAATQMAAE4DAABPAwAAUAMAAFROAQA3xwAAJHIBAAAAAADYdgEAUQMAAFIDAABTAwAAVAMAAEkDAABVAwAAVE4BAFDHAAAkcgEAAAAAAAB3AQBWAwAAVwMAAFgDAAAtAQAAWQMAAFROAQBsxwAA8EoBAAAAAAAodwEAWgMAAFsDAABcAwAALQEAAF0DAABUTgEAtscAAPBKAQAAAAAAUHcBAF4DAABfAwAAYAMAAC0BAABhAwAAVE4BAATIAADwSgEAAAAAAHh3AQBiAwAAYwMAAGQDAAAtAQAAZQMAAFROAQBQyAAA8EoBAAAAAACgdwEAZgMAAGcDAABoAwAALQEAAGkDAABUTgEAnMgAAPBKAQAAAAAAyHcBAGoDAABrAwAAbAMAAC0BAABtAwAAVE4BAO/IAADwSgEAAAAAAG4DAABvAw=="),B0(c,96232,"3r4AAPB3AQAsTgEAPskAAAR4AQAMeAEA8HcBACxOAQCAyQAADE8BAI3JAAAAAAAAHHgBACxOAQCdyQAALHgBAPB3AQDgTQEAsckAADx4AQAMeAEALE4BAMzJAAA8eAEADHgBAIRNAQAMTwEA6MkAAAAAAABgeAEALE4BAP3J"),B0(c,96368,"PHgBAFB4AQCAeAEAiHgBAOBNAQARygAA4E0BACPKAAAMTwEAWMoAAAAAAACgeAEALE4BAGbKAADgTQEAc8oAACxOAQCCygAAGE0BADx4AQCETQEADHgBABhNAQAMeAEAeE0BAAx4AQAYTQEA4HgBAAxPAQCoygAAAQAAAGB4AQB4TQEA4HgBABhNAQAAeQEADE8BAL7KAAABAAAAoHgBADx4AQAceQEAhE0BAAxPAQDNygAAAQAAABx4AQB4TQEAHHkBAHhNAQAceQEAhE0BAOBNAQDjygAA4E0BAPXKAADgTQEACssAAOBNAQAkywAA4E0BAEnLAAAFAAAA0wcAAEwiAAAAAAAAswIAALQCAAAFAAAAAAAAAM9m"),B0(c,96660,"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"),B0(c,106884,"wOYAAAMAAAAJAAAAyScAADwAAAABAAAAAQAAABAHAAARBwAAEgcAABMHAAAUBwAAFQcAABYHAAAXBwAAGAcAABkHAAAaBwAAGwcAABwHAAAdBwAAHgcAAB8HAAAgBwAAIQcAACIHAAAjBwAAJAcAACUH"),B0(c,107032,"jgcAAI8HAAAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBEQERAREhESEhESFRMUFRQTFRgWFhgYFhYYGRkbHhsZGR0fIyMfHSQpLCkkLzY2L0FGQVhYcxAQEBAQEBAQEBARERERERISEhISEhQUFBQUFBQYGBgYGBgYGBkZGRkZGRkcHBwcHBwhISEhISkpKSk2NjZHR1sAIAAAAAAAAAU="),B0(c,107204,"nAc="),B0(c,107228,"nQcAAJ4HAABE6gE="),B0(c,107252,"Ag=="),B0(c,107268,"//////////8="),B0(c,107336,"uKIBAAAAAAAF"),B0(c,107356,"nwc="),B0(c,107380,"nQcAAKAHAABY6gEAAAQ="),B0(c,107404,"AQ=="),B0(c,107420,"/////wo="),B0(c,107488,"UKMBAPAAAwAJ"),B0(c,107508,"nAc="),B0(c,107528,"pAcAAAAAAACeBwAAWPABAAAE"),B0(c,107572,"/////w=="),B0(c,107640,"JW0vJWQvJXkAAAAIJUg6JU06JVMAAAAI")}var a0=new ArrayBuffer(16),m2=new Int32Array(a0),C2=new Float32Array(a0),B2=new Float64Array(a0);function t2(h1){return m2[h1]}function D2(h1,W1){m2[h1]=W1}function r1(){return B2[0]}function M2(h1){B2[0]=h1}function o0(h1,W1,u){if(h1=h1>>>0,u=u>>>0,h1+u>c.length)throw"trap: invalid memory.fill";c.fill(W1,h1,h1+u)}function H(){throw new Error("abort")}function x(h1,W1,u){c.copyWithin(h1,W1,W1+u)}function N1(h1){C2[2]=h1}function K4(){return C2[2]}function x1(h1){var W1=new ArrayBuffer(17039360),u=new Int8Array(W1),g=new Int16Array(W1),i=new Int32Array(W1),l=new Uint8Array(W1),C=new Uint16Array(W1),u0=new Uint32Array(W1),p0=new Float32Array(W1),t0=new Float64Array(W1),G=Math.imul,U=Math.fround,w2=Math.abs,k1=Math.clz32,Q00=Math.min,g00=Math.max,G_=Math.floor,W7=Math.ceil,V00=Math.trunc,X_=Math.sqrt,S2=h1.a,Y0=S2.a,D0=S2.b,o1=S2.c,B1=S2.d,E1=S2.e,i4=S2.f,D4=S2.g,f8=S2.h,N8=S2.i,U8=S2.j,Si=S2.k,ir=S2.l,nf=S2.m,tf=S2.n,uf=S2.o,of=S2.p,lf=S2.q,Q7=S2.r,g7=S2.s,V7=S2.t,F7=S2.u,W_=S2.v,Q_=S2.w,g_=S2.x,V_=S2.y,F_=S2.z,I_=S2.A,C_=S2.B,p_=S2.C,y_=S2.D,E_=S2.E,Y_=S2.F,R_=S2.G,J_=S2.H,N_=S2.I,U_=S2.J,D_=S2.K,M_=S2.L,H_=S2.M,z_=S2.N,x_=S2.O,v=196848,Q6=0,g6=0,l0=0;function sf(A,e){var r=0,f=0,k=0,n=0,t=0,o=0,s=0,w=0,h=0,_=0,B=0,m=0,X=0,Q=0,V=0,F=0,I=0,E=0,R=0,N=0,M=0,z=0,S=0,O=0,P=0,a=0,$=0,f0=0,A0=0,n0=0,_0=0,m0=0,X0=0,g0=0,I0=0,e0=0,r0=0,N0=0,U0=0,M0=0,H0=0,P0=0,K0=0,$0=0,L0=0,d0=0,n2=0;i:{e:{r:{if(!i[i[e+48>>2]+44>>2])break r;if(t=v-416|0,v=t,Ce(e+16|0,i[e+20>>2]),F=e+20|0,i[e+16>>2]=F,i[e+20>>2]=0,i[e+24>>2]=0,r=i[e+32>>2],o=i[e+28>>2],(r|0)!=(o|0))for(;;){f=i[r-4>>2];f:{if(!f||(n=i[f+4>>2],i[f+4>>2]=n-1,n))break f;W[i[i[f>>2]+8>>2]](f),y(f)}if(r=r-8|0,(o|0)==(r|0))break}i[e+32>>2]=o,r=i[e+44>>2],i[e+40>>2]=0,i[e+44>>2]=0;f:{if(!r||(f=i[r+4>>2],i[r+4>>2]=f-1,f))break f;W[i[i[r>>2]+8>>2]](r),y(r)}if(fA(t+364|0,i[e+48>>2]),m=i[t+364>>2],Q=i[t+368>>2],(m|0)!=(Q|0))for(I=e+28|0,B=t+160|0;;){s=i[m>>2],s4(t+328|0,i[e+48>>2],s);f:{A:{if(i[t+328>>2]){f=v-192|0,v=f,i[f+188>>2]=e,o=i[t+328>>2],r=i[o+112>>2],i[f+184>>2]=r,n=i[o+104>>2],i[f+180>>2]=n;k:{n:{t:{u:{o:{l:{s:{w:{_:{if((r|0)<=1785750886){if((r|0)<=1752589104){if((r|0)==1635135537)break w;if((r|0)==1635148593)break s;if((r|0)!=1735551332)break n;n=p(496),r=n,i[r+4>>2]=0,i[r+8>>2]=0,i[r>>2]=101016,r=E4(r+16|0,i[f+188>>2],i[f+180>>2]),i[r+448>>2]=0,i[r+452>>2]=0,i[r>>2]=101176,i[r+456>>2]=0,i[r+460>>2]=0,i[r+464>>2]=0,i[r+468>>2]=0,i[r+472>>2]=0,d0=r,n2=M6(),i[d0+472>>2]=n2,o=f+32|0,i[o+4>>2]=n,i[o>>2]=r,i[t+68>>2]=i[f+32>>2],i[t+72>>2]=i[f+36>>2],i[f+32>>2]=0,i[f+36>>2]=0,I2(o);break k}if((r|0)<=1768912491){if((r|0)==1752589105)break _;if((r|0)!=1768187246)break n;r=p(464),i[r+4>>2]=0,i[r+8>>2]=0,i[r>>2]=101096,n=E4(r+16|0,i[f+188>>2],i[f+180>>2]),i[n>>2]=101544,o=f+32|0,i[o+4>>2]=r,i[o>>2]=n,i[t+68>>2]=i[f+32>>2],i[t+72>>2]=i[f+36>>2],i[f+32>>2]=0,i[f+36>>2]=0,I2(o);break k}if((r|0)==1768912492)break t;if((r|0)!=1781689137)break n;n=p(480),r=n,i[r+4>>2]=0,i[r+8>>2]=0,i[r>>2]=100936,o=E4(r+16|0,i[f+188>>2],i[f+180>>2]),r=o,i[r+448>>2]=0,i[r+452>>2]=0,i[r>>2]=98720,i[r+456>>2]=0,i[r+460>>2]=0,r=p(64),i[r+16>>2]=0,i[r+20>>2]=0,i[r>>2]=98864,i[r+4>>2]=0,i[r+8>>2]=0,i[r+12>>2]=98976,i[r+24>>2]=0,i[r+28>>2]=0,i[r+32>>2]=0,i[r+36>>2]=0,i[r+40>>2]=0,i[r+44>>2]=0,i[r+48>>2]=0,i[r+52>>2]=0,i[r+56>>2]=0,i[r+60>>2]=0,i[o+460>>2]=r,i[o+456>>2]=r+12,r=f+32|0,i[r+4>>2]=n,i[r>>2]=o,i[t+68>>2]=i[f+32>>2],i[t+72>>2]=i[f+36>>2],i[f+32>>2]=0,i[f+36>>2]=0,I2(r);break k}if((r|0)<=1836280680){if((r|0)!=1785750887){if((r|0)==1818785329)break o;if((r|0)!=1835625829||(k=u[o+139|0],r=(k|0)<0,((r?i[o+132>>2]:k)|0)!=10)||N2(r?i[o+128>>2]:o+128|0,11266,10))break n}k=p(480),r=k,i[r+4>>2]=0,i[r+8>>2]=0,i[r>>2]=100736,o=E4(r+16|0,e,n),r=o,i[r+448>>2]=0,i[r+452>>2]=0,i[r>>2]=98320,i[r+456>>2]=0,i[r+460>>2]=0,r=p(64),i[r+16>>2]=0,i[r+20>>2]=0,i[r>>2]=98464,i[r+4>>2]=0,i[r+8>>2]=0,i[r+12>>2]=98656,i[r+24>>2]=0,i[r+28>>2]=0,i[r+32>>2]=0,i[r+36>>2]=0,i[r+40>>2]=0,i[r+44>>2]=0,i[r+48>>2]=0,i[r+52>>2]=0,i[r+56>>2]=0,i[r+60>>2]=0,i[o+460>>2]=r,i[o+456>>2]=r+12,i[t+72>>2]=k,i[t+68>>2]=o;break k}if((r|0)<=1970168680){if((r|0)==1836280681)break u;if((r|0)!=1953066089)break n;n=p(576),r=n,i[r+4>>2]=0,i[r+8>>2]=0,i[r>>2]=101136,r=E4(r+16|0,i[f+188>>2],i[f+180>>2]),i[r+512>>2]=0,i[r+516>>2]=0,i[r+544>>2]=0,i[r+548>>2]=0,u[r+540|0]=0,i[r+536>>2]=65536,i[r>>2]=101688,i[r+520>>2]=0,i[r+524>>2]=0,i[r+528>>2]=0,i[r+532>>2]=0,i[r+552>>2]=0,i[r+556>>2]=0,o=f+32|0,i[o+4>>2]=n,i[o>>2]=r,i[t+68>>2]=i[f+32>>2],i[t+72>>2]=i[f+36>>2],i[f+32>>2]=0,i[f+36>>2]=0,I2(o);break k}if((r|0)==1970168681)break l;if((r|0)!=1987470129)break n;k=p(480),r=k,i[r+4>>2]=0,i[r+8>>2]=0,i[r>>2]=100856,o=E4(r+16|0,e,n),r=o,i[r+448>>2]=0,i[r+452>>2]=0,i[r>>2]=99496,i[r+456>>2]=0,i[r+460>>2]=0,r=p(92),i[r>>2]=99640,i[r+4>>2]=0,i[r+8>>2]=0,o0(r+20|0,0,72),i[r+16>>2]=0,i[r+12>>2]=99744,u[r+20|0]=0,i[r+24>>2]=0,i[r+28>>2]=0,u[r+32|0]=0,i[r+36>>2]=0,i[r+40>>2]=0,u[r+44|0]=0,i[o+460>>2]=r,i[o+456>>2]=r+12,i[t+72>>2]=k,i[t+68>>2]=o;break k}k=p(480),r=k,i[r+4>>2]=0,i[r+8>>2]=0,i[r>>2]=100776,o=E4(r+16|0,e,n),r=o,i[r+448>>2]=0,i[r+452>>2]=0,i[r>>2]=97320,i[r+456>>2]=0,i[r+460>>2]=0,r=p(92),i[r>>2]=97464,i[r+4>>2]=0,i[r+8>>2]=0,o0(r+20|0,0,72),i[r+16>>2]=0,i[r+12>>2]=97712,u[r+20|0]=0,i[r+24>>2]=0,i[r+28>>2]=0,u[r+32|0]=0,i[r+36>>2]=0,i[r+40>>2]=0,u[r+44|0]=0,i[o+460>>2]=r,i[o+456>>2]=r+12,i[t+72>>2]=k,i[t+68>>2]=o;break k}k=p(480),r=k,i[r+4>>2]=0,i[r+8>>2]=0,i[r>>2]=100816,o=E4(r+16|0,e,n),r=o,i[r+448>>2]=0,i[r+452>>2]=0,i[r>>2]=97776,i[r+456>>2]=0,i[r+460>>2]=0,r=p(84),i[r+28>>2]=0,i[r+32>>2]=0,i[r>>2]=97920,i[r+4>>2]=0,i[r+8>>2]=0,u[r+19|0]=0,u[r+20|0]=0,u[r+21|0]=0,u[r+22|0]=0,u[r+23|0]=0,u[r+24|0]=0,u[r+25|0]=0,u[r+26|0]=0,u[r+18|0]=1,g[r+16>>1]=0,i[r+12>>2]=97960,u[r+27|0]=0,u[r+28|0]=0,u[r+29|0]=0,u[r+30|0]=0,i[r+36>>2]=0,i[r+40>>2]=0,i[r+44>>2]=0,i[r+48>>2]=0,i[r+52>>2]=0,i[r+56>>2]=0,i[r+60>>2]=0,i[r+64>>2]=0,i[r+68>>2]=0,i[r+72>>2]=0,i[r+76>>2]=0,i[r+80>>2]=0,i[o+460>>2]=r,i[o+456>>2]=r+12,i[t+72>>2]=k,i[t+68>>2]=o;break k}k=p(480),r=k,i[r+4>>2]=0,i[r+8>>2]=0,i[r>>2]=100896,o=E4(r+16|0,e,n),r=o,i[r+448>>2]=0,i[r+452>>2]=0,i[r>>2]=99928,i[r+456>>2]=0,i[r+460>>2]=0,r=p(92),i[r+28>>2]=0,i[r+32>>2]=0,i[r+36>>2]=0,i[r+40>>2]=0,i[r>>2]=100072,i[r+4>>2]=0,i[r+8>>2]=0,i[r+16>>2]=0,i[r+20>>2]=0,i[r+12>>2]=100256,u[r+21|0]=0,u[r+22|0]=0,u[r+23|0]=0,u[r+24|0]=0,u[r+25|0]=0,u[r+26|0]=0,u[r+27|0]=0,u[r+28|0]=0,i[r+44>>2]=0,i[r+48>>2]=0,i[r+52>>2]=0,i[r+56>>2]=0,i[r+60>>2]=0,i[r+64>>2]=0,i[r+68>>2]=0,i[r+72>>2]=0,i[r+76>>2]=0,i[r+80>>2]=0,i[r+84>>2]=0,i[r+88>>2]=0,i[r+32>>2]=0,i[r+36>>2]=0,u[r+40|0]=0,i[o+460>>2]=r,i[o+456>>2]=r+12,i[t+72>>2]=k,i[t+68>>2]=o;break k}_=hA(f+32|0),r=Y(_+8|0,27400,20),o=f+12|0,L1(o,i[f+184>>2]),n=r,k=o,r=u[f+23|0],o=(r|0)<0,Y(Y(n,o?i[f+12>>2]:k,o?i[f+16>>2]:r),25867,19),u[f+23|0]<0&&Z(i[f+12>>2]),QA(f,_),k=q(f+12|0,4,3001,f),u[f+11|0]<0&&Z(i[f>>2]),X=p(488),r=X,i[r+4>>2]=0,i[r+8>>2]=0,i[r>>2]=94504,V=r+16|0,r=V,o=v-32|0,v=o,E=i[f+180>>2],R=i[f+184>>2],w=i[k+4>>2],n=i[k>>2],i[o+8>>2]=n,i[o+12>>2]=w,h=o+16|0;l:{if(u[k+19|0]>=0){z=i[k+12>>2],i[h>>2]=i[k+8>>2],i[h+4>>2]=z,i[h+8>>2]=i[k+16>>2];break l}T(h,i[k+8>>2],i[k+12>>2]),n=i[o+8>>2],w=i[o+12>>2]}i[r+84>>2]=0,i[r+88>>2]=0,u[r+80|0]=0,u[r+68|0]=0,i[r+64>>2]=0,u[r+60|0]=0,u[r+36|0]=0,i[r+32>>2]=0,i[r+24>>2]=1,i[r+28>>2]=1,i[r+16>>2]=0,i[r+20>>2]=0,u[r+12|0]=1,g[r+10>>1]=2,g[r+6>>1]=2,g[r+8>>1]=2,u[r+4|0]=0,u[r+232|0]=0,i[r+132>>2]=0,i[r+136>>2]=0,i[r+92>>2]=0,i[r+96>>2]=4740,g[r+138>>1]=0,g[r+140>>1]=0,g[r+142>>1]=0,g[r+144>>1]=0,u[r+156|0]=0,i[r+148>>2]=0,i[r+152>>2]=0,i[r+160>>2]=0,i[r+164>>2]=0,u[r+168|0]=0,i[r+236>>2]=0,i[r+240>>2]=0,i[r+244>>2]=0,i[r+248>>2]=0,i[r+252>>2]=0,i[r+256>>2]=0,i[r+260>>2]=0,i[r+264>>2]=0,i[r+268>>2]=0,i[r+100>>2]=0,i[r+104>>2]=0,i[r+108>>2]=0,i[r+112>>2]=0,i[r+116>>2]=0,i[r+120>>2]=0,g[r+122>>1]=0,g[r+124>>1]=0,g[r+126>>1]=0,g[r+128>>1]=0,i[r+352>>2]=0,i[r+344>>2]=0,i[r+348>>2]=0,u[r+272|0]=1,u[r+281|0]=0,u[r+282|0]=0,u[r+283|0]=0,u[r+284|0]=0,u[r+285|0]=0,u[r+286|0]=0,u[r+287|0]=0,u[r+288|0]=0,i[r+276>>2]=0,i[r+280>>2]=0,u[r+336|0]=0,i[r+328>>2]=0,i[r+332>>2]=0,i[r+320>>2]=0,i[r+324>>2]=0,i[r+312>>2]=0,i[r+316>>2]=0,i[r+304>>2]=0,i[r+308>>2]=0,i[r+296>>2]=0,i[r+300>>2]=0,i[r+376>>2]=0,i[r+380>>2]=0,g[r+356>>1]=1,i[r+368>>2]=0,i[r+372>>2]=0,i[r+360>>2]=0,i[r+364>>2]=0,i[r+384>>2]=0,i[r+388>>2]=1072693248,i[r+176>>2]=0,i[r+180>>2]=0,i[r+184>>2]=0,i[r+188>>2]=0,i[r+192>>2]=0,i[r+196>>2]=0,i[r+200>>2]=0,i[r+204>>2]=0,i[r+208>>2]=0,i[r+212>>2]=0,i[r+216>>2]=0,i[r+220>>2]=0,i[r+224>>2]=0,i[r+228>>2]=0,i[r+416>>2]=0,i[r+408>>2]=0,i[r+412>>2]=0,i[r+400>>2]=0,i[r+404>>2]=0,i[r+392>>2]=0,i[r+396>>2]=0,i[r+440>>2]=0,i[r+444>>2]=0,i[r+432>>2]=0,i[r+436>>2]=0,i[r+424>>2]=0,i[r+428>>2]=0,i[r+116>>2]=E,i[r+452>>2]=n,i[r+456>>2]=w,i[r+448>>2]=R,i[r>>2]=94544,r=r+460|0;l:{if(u[o+27|0]>=0){n=i[h+4>>2],i[r>>2]=i[h>>2],i[r+4>>2]=n,i[r+8>>2]=i[h+8>>2];break l}if(T(r,i[o+16>>2],i[o+20>>2]),u[o+27|0]>=0)break l;Z(i[o+16>>2])}v=o+32|0,i[f+4>>2]=X,i[f>>2]=V,i[t+68>>2]=i[f>>2],i[t+72>>2]=i[f+4>>2],i[f>>2]=0,i[f+4>>2]=0,I2(f),u[k+19|0]<0&&Z(i[k+8>>2]),H6(_);break k}k=d2(f+12|0,4116),o=q(f+32|0,4,3001,k),w=p(488),r=w,i[r+4>>2]=0,i[r+8>>2]=0,i[r>>2]=94504,h=i[o+12>>2],n=i[o+8>>2],X=i[f+184>>2],V=i[f+180>>2],i[o+8>>2]=0,i[o+12>>2]=0,_=i[o+16>>2],i[o+16>>2]=0,E=i[o>>2],R=i[o+4>>2],r=r+16|0,i[r+84>>2]=0,i[r+88>>2]=0,u[r+80|0]=0,u[r+68|0]=0,i[r+64>>2]=0,u[r+60|0]=0,u[r+36|0]=0,i[r+32>>2]=0,i[r+24>>2]=1,i[r+28>>2]=1,i[r+16>>2]=0,i[r+20>>2]=0,u[r+12|0]=1,g[r+10>>1]=2,g[r+6>>1]=2,g[r+8>>1]=2,u[r+4|0]=0,i[r+92>>2]=0,u[r+232|0]=0,i[r+96>>2]=4740,g[r+138>>1]=0,g[r+140>>1]=0,g[r+142>>1]=0,g[r+144>>1]=0,i[r+132>>2]=0,i[r+136>>2]=0,u[r+156|0]=0,i[r+148>>2]=0,i[r+152>>2]=0,i[r+160>>2]=0,i[r+164>>2]=0,u[r+168|0]=0,i[r+236>>2]=0,i[r+240>>2]=0,i[r+244>>2]=0,i[r+248>>2]=0,i[r+252>>2]=0,i[r+256>>2]=0,i[r+260>>2]=0,i[r+264>>2]=0,i[r+268>>2]=0,i[r+100>>2]=0,i[r+104>>2]=0,i[r+108>>2]=0,i[r+112>>2]=0,i[r+116>>2]=0,i[r+120>>2]=0,g[r+122>>1]=0,g[r+124>>1]=0,g[r+126>>1]=0,g[r+128>>1]=0,i[r+352>>2]=0,i[r+344>>2]=0,i[r+348>>2]=0,u[r+272|0]=1,u[r+281|0]=0,u[r+282|0]=0,u[r+283|0]=0,u[r+284|0]=0,u[r+285|0]=0,u[r+286|0]=0,u[r+287|0]=0,u[r+288|0]=0,i[r+276>>2]=0,i[r+280>>2]=0,u[r+336|0]=0,i[r+328>>2]=0,i[r+332>>2]=0,i[r+320>>2]=0,i[r+324>>2]=0,i[r+312>>2]=0,i[r+316>>2]=0,i[r+304>>2]=0,i[r+308>>2]=0,i[r+296>>2]=0,i[r+300>>2]=0,i[r+376>>2]=0,i[r+380>>2]=0,g[r+356>>1]=1,i[r+368>>2]=0,i[r+372>>2]=0,i[r+360>>2]=0,i[r+364>>2]=0,i[r+384>>2]=0,i[r+388>>2]=1072693248,i[r+176>>2]=0,i[r+180>>2]=0,i[r+184>>2]=0,i[r+188>>2]=0,i[r+192>>2]=0,i[r+196>>2]=0,i[r+200>>2]=0,i[r+204>>2]=0,i[r+208>>2]=0,i[r+212>>2]=0,i[r+216>>2]=0,i[r+220>>2]=0,i[r+224>>2]=0,i[r+228>>2]=0,i[r+416>>2]=0,i[r+408>>2]=0,i[r+412>>2]=0,i[r+400>>2]=0,i[r+404>>2]=0,i[r+392>>2]=0,i[r+396>>2]=0,i[r+440>>2]=0,i[r+444>>2]=0,i[r+432>>2]=0,i[r+436>>2]=0,i[r+424>>2]=0,i[r+428>>2]=0,i[r+116>>2]=V,i[r+452>>2]=E,i[r+456>>2]=R,i[r+448>>2]=X,i[r>>2]=94544;o:{if((_|0)>=0){i[r+468>>2]=_,i[r+464>>2]=h,i[r+460>>2]=n;break o}T(r+460|0,n,h),Z(n)}if(i[f+4>>2]=w,i[f>>2]=r,i[t+68>>2]=i[f>>2],i[t+72>>2]=i[f+4>>2],i[f>>2]=0,i[f+4>>2]=0,I2(f),u[o+19|0]<0&&Z(i[o+8>>2]),u[k+11|0]>=0)break k;Z(i[k>>2]);break k}r=p(464),i[r+4>>2]=0,i[r+8>>2]=0,i[r>>2]=100976,o=i[f+180>>2],n=i[f+188>>2],i[r+100>>2]=0,i[r+104>>2]=0,u[r+96|0]=0,u[r+84|0]=0,i[r+80>>2]=0,u[r+76|0]=0,u[r+52|0]=0,i[r+48>>2]=0,i[r+40>>2]=1,i[r+44>>2]=1,i[r+32>>2]=0,i[r+36>>2]=0,u[r+28|0]=1,g[r+26>>1]=2,g[r+22>>1]=2,g[r+24>>1]=2,u[r+20|0]=0,i[r+108>>2]=0,u[r+248|0]=0,i[r+116>>2]=n,i[r+112>>2]=4740,g[r+144>>1]=0,i[r+136>>2]=0,i[r+140>>2]=0,i[r+128>>2]=0,i[r+132>>2]=0,i[r+120>>2]=0,i[r+124>>2]=0,i[r+148>>2]=0,i[r+152>>2]=0,g[r+154>>1]=0,g[r+156>>1]=0,g[r+158>>1]=0,g[r+160>>1]=0,i[r+164>>2]=0,i[r+168>>2]=0,u[r+172|0]=0,i[r+176>>2]=0,i[r+180>>2]=0,u[r+184|0]=0,i[r+252>>2]=0,i[r+256>>2]=0,i[r+260>>2]=0,i[r+264>>2]=0,i[r+268>>2]=0,i[r+272>>2]=0,i[r+276>>2]=0,i[r+280>>2]=0,i[r+284>>2]=0,u[r+288|0]=1,i[r+360>>2]=0,i[r+364>>2]=0,i[r+368>>2]=0,u[r+297|0]=0,u[r+298|0]=0,u[r+299|0]=0,u[r+300|0]=0,u[r+301|0]=0,u[r+302|0]=0,u[r+303|0]=0,u[r+304|0]=0,i[r+292>>2]=0,i[r+296>>2]=0,u[r+352|0]=0,i[r+344>>2]=0,i[r+348>>2]=0,i[r+336>>2]=0,i[r+340>>2]=0,i[r+328>>2]=0,i[r+332>>2]=0,i[r+320>>2]=0,i[r+324>>2]=0,i[r+312>>2]=0,i[r+316>>2]=0,i[r+392>>2]=0,i[r+396>>2]=0,g[r+372>>1]=1,i[r+384>>2]=0,i[r+388>>2]=0,i[r+376>>2]=0,i[r+380>>2]=0,i[r+400>>2]=0,i[r+404>>2]=1072693248,i[r+192>>2]=0,i[r+196>>2]=0,i[r+200>>2]=0,i[r+204>>2]=0,i[r+208>>2]=0,i[r+212>>2]=0,i[r+216>>2]=0,i[r+220>>2]=0,i[r+224>>2]=0,i[r+228>>2]=0,i[r+232>>2]=0,i[r+236>>2]=0,i[r+240>>2]=0,i[r+244>>2]=0,i[r+432>>2]=0,i[r+424>>2]=0,i[r+428>>2]=0,i[r+416>>2]=0,i[r+420>>2]=0,i[r+408>>2]=0,i[r+412>>2]=0,i[r+456>>2]=0,i[r+460>>2]=0,i[r+448>>2]=0,i[r+452>>2]=0,i[r+440>>2]=0,i[r+444>>2]=0,i[r+132>>2]=o,i[r+16>>2]=100392,o=f+32|0,i[o+4>>2]=r,i[o>>2]=r+16,i[t+68>>2]=i[f+32>>2],i[t+72>>2]=i[f+36>>2],i[f+32>>2]=0,i[f+36>>2]=0,I2(o);break k}n=p(512),r=n,i[r+4>>2]=0,i[r+8>>2]=0,i[r>>2]=101056,r=E4(r+16|0,i[f+188>>2],i[f+180>>2]),i[r+448>>2]=0,i[r+452>>2]=0,i[r+460>>2]=0,i[r+464>>2]=0,i[r>>2]=101384,g[r+456>>1]=0,i[r+468>>2]=0,i[r+472>>2]=0,i[r+476>>2]=0,i[r+480>>2]=0,i[r+484>>2]=0,i[r+488>>2]=0,o=f+32|0,i[o+4>>2]=n,i[o>>2]=r,i[t+68>>2]=i[f+32>>2],i[t+72>>2]=i[f+36>>2],i[f+32>>2]=0,i[f+36>>2]=0,I2(o);break k}i[t+68>>2]=0,i[t+72>>2]=0}v=f+192|0;k:{if(!i[t+68>>2])break k;i[t+312>>2]=0,i[t+304>>2]=0,i[t+308>>2]=0,j1(t+376|0,i[e+48>>2],s,t+304|0);n:{if(!i[t+376>>2])break n;r=i[t+68>>2],f=W[i[i[r>>2]+40>>2]](r)|0,r=p(488),i[r>>2]=94504,i[r+4>>2]=0,i[r+8>>2]=0,o=i[t+380>>2],i[t+152>>2]=i[t+376>>2],i[t+156>>2]=o,o=r+16|0;t:{if(u[t+395|0]>=0){n=i[t+388>>2],i[B>>2]=i[t+384>>2],i[B+4>>2]=n,i[B+8>>2]=i[t+392>>2];break t}T(B,i[t+384>>2],i[t+388>>2])}o=E4(o,0,s),i[o>>2]=94544,i[r+464>>2]=f,f=i[t+156>>2],i[r+468>>2]=i[t+152>>2],i[r+472>>2]=f,f=r+476|0;t:{if(u[t+171|0]>=0){n=i[B+4>>2],i[f>>2]=i[B>>2],i[f+4>>2]=n,i[f+8>>2]=i[B+8>>2];break t}if(T(f,i[t+160>>2],i[t+164>>2]),u[t+171|0]>=0)break t;Z(i[t+160>>2])}if(i[t+68>>2]=o,f=i[t+72>>2],i[t+72>>2]=r,!f||(r=i[f+4>>2],i[f+4>>2]=r-1,r))break n;W[i[i[f>>2]+8>>2]](f),y(f)}if(w=0,i[t+360>>2]=0,i[t+352>>2]=0,i[t+356>>2]=0,f=i[t+68>>2],r=0,h=0,o=i[t+304>>2],k=i[t+308>>2],(o|0)!=(k|0)){if(r=k-o|0,(r|0)<0)break i;for(h=p(r),i[t+352>>2]=h,w=r+h|0,i[t+360>>2]=w,r=h;i[r>>2]=i[o>>2],n=i[o+4>>2],i[r+4>>2]=n,n&&(i[n+4>>2]=i[n+4>>2]+1),r=r+8|0,o=o+8|0,(k|0)!=(o|0););i[t+356>>2]=r}if(n=i[f+104>>2],n){if(o=i[f+108>>2],k=n,(o|0)!=(k|0)){for(;;){r=i[o-4>>2];n:{if(!r||(k=i[r+4>>2],i[r+4>>2]=k-1,k))break n;W[i[i[r>>2]+8>>2]](r),y(r)}if(o=o-8|0,(n|0)==(o|0))break}k=i[f+104>>2],w=i[t+360>>2],h=i[t+352>>2],r=i[t+356>>2]}i[f+108>>2]=n,Z(k),o=i[t+68>>2]}else o=f;if(i[f+112>>2]=w,i[f+108>>2]=r,i[f+104>>2]=h,i[t+360>>2]=0,i[t+352>>2]=0,i[t+356>>2]=0,W[i[i[o>>2]+92>>2]](t+152|0,o),f=i[t+156>>2],r=i[t+152>>2],i[t+376>>2]=r,i[t+380>>2]=f,u[t+395|0]<0&&(Z(i[t+384>>2]),r=i[t+376>>2]),f=i[B+4>>2],i[t+384>>2]=i[B>>2],i[t+388>>2]=f,i[t+392>>2]=i[B+8>>2],f=i[t+68>>2],r){f=W[i[i[f>>2]+40>>2]](f)|0,r=p(488),i[r>>2]=94504,i[r+4>>2]=0,i[r+8>>2]=0,o=i[t+380>>2],i[t+152>>2]=i[t+376>>2],i[t+156>>2]=o,o=r+16|0;n:{if(u[t+395|0]>=0){n=i[t+388>>2],i[B>>2]=i[t+384>>2],i[B+4>>2]=n,i[B+8>>2]=i[t+392>>2];break n}T(B,i[t+384>>2],i[t+388>>2])}o=E4(o,0,s),i[o>>2]=94544,i[r+464>>2]=f,f=i[t+156>>2],i[r+468>>2]=i[t+152>>2],i[r+472>>2]=f,f=r+476|0;n:{if(u[t+171|0]>=0){n=i[B+4>>2],i[f>>2]=i[B>>2],i[f+4>>2]=n,i[f+8>>2]=i[B+8>>2];break n}if(T(f,i[t+160>>2],i[t+164>>2]),u[t+171|0]>=0)break n;Z(i[t+160>>2])}i[t+68>>2]=o,f=i[t+72>>2],i[t+72>>2]=r;n:{if(!f||(r=i[f+4>>2],i[f+4>>2]=r-1,r))break n;W[i[i[f>>2]+8>>2]](f),y(f)}if(w=0,i[t+348>>2]=0,i[t+340>>2]=0,i[t+344>>2]=0,n=i[t+68>>2],r=0,h=0,o=i[t+304>>2],k=i[t+308>>2],(o|0)!=(k|0)){if(r=k-o|0,(r|0)<0)break i;for(h=p(r),i[t+340>>2]=h,w=r+h|0,i[t+348>>2]=w,r=h;i[r>>2]=i[o>>2],f=i[o+4>>2],i[r+4>>2]=f,f&&(i[f+4>>2]=i[f+4>>2]+1),r=r+8|0,o=o+8|0,(k|0)!=(o|0););i[t+344>>2]=r}if(f=i[n+104>>2],f){if(o=i[n+108>>2],k=f,(o|0)!=(f|0)){for(;;){r=i[o-4>>2];n:{if(!r||(k=i[r+4>>2],i[r+4>>2]=k-1,k))break n;W[i[i[r>>2]+8>>2]](r),y(r)}if(o=o-8|0,(f|0)==(o|0))break}k=i[n+104>>2],w=i[t+348>>2],h=i[t+340>>2],r=i[t+344>>2]}i[n+108>>2]=f,Z(k),f=i[t+68>>2]}else f=n;i[n+112>>2]=w,i[n+108>>2]=r,i[n+104>>2]=h,i[t+348>>2]=0,i[t+340>>2]=0,i[t+344>>2]=0}n=i[t+72>>2],n&&(i[n+4>>2]=i[n+4>>2]+1);n:{t:{k=F,r=k,o=i[r>>2];u:{if(!o)break u;for(;;){if(r=o,o=i[r+16>>2],o>>>0>s>>>0){if(k=r,o=i[r>>2],o)continue;break u}if(o>>>0>=s>>>0)break t;if(o=i[r+4>>2],!o)break}k=r+4|0}o=p(28),i[o+24>>2]=n,i[o+20>>2]=f,i[o+16>>2]=s,i[o+8>>2]=r,i[o>>2]=0,i[o+4>>2]=0,i[k>>2]=o,r=i[i[e+16>>2]>>2],r&&(i[e+16>>2]=r),m1(i[e+20>>2],o),i[e+24>>2]=i[e+24>>2]+1;break n}if(!n||(r=i[n+4>>2],i[n+4>>2]=r-1,r))break n;W[i[i[n>>2]+8>>2]](n),y(n)}if(!l[i[t+328>>2]+164|0]){n:{if((s|0)!=i[i[i[e+48>>2]+92>>2]+104>>2]||(r=i[t+68>>2],u[r+128|0]=1,f=i[t+72>>2],f&&(i[f+4>>2]=i[f+4>>2]+1),i[e+40>>2]=r,r=i[e+44>>2],i[e+44>>2]=f,!r)||(f=i[r+4>>2],i[r+4>>2]=f-1,f))break n;W[i[i[r>>2]+8>>2]](r),y(r)}r2(I,t+68|0)}if(r=i[t+68>>2],W[i[i[r>>2]+96>>2]](r),u[t+395|0]<0&&Z(i[t+384>>2]),f=i[t+304>>2],!f)break k;if(r=i[t+308>>2],o=f,(r|0)!=(f|0)){for(;;){o=i[r-4>>2];n:{if(!o||(n=i[o+4>>2],i[o+4>>2]=n-1,n))break n;W[i[i[o>>2]+8>>2]](o),y(o)}if(r=r-8|0,(f|0)==(r|0))break}o=i[t+304>>2]}i[t+308>>2]=f,Z(o)}r=i[t+72>>2];k:{if(!r||(f=i[r+4>>2],i[r+4>>2]=f-1,f))break k;W[i[i[r>>2]+8>>2]](r),y(r)}if(r=i[t+332>>2],!r)break f;if(f=i[r+4>>2],i[r+4>>2]=f-1,!f)break A;break f}if(r=i[t+332>>2],!r||(f=i[r+4>>2],i[r+4>>2]=f-1,f))break f}W[i[i[r>>2]+8>>2]](r),y(r)}if(m=m+4|0,(Q|0)==(m|0))break}f:{A:{k:{if(!i[e+40>>2]){if(r=p(64),i[t+152>>2]=r,i[t+156>>2]=58,i[t+160>>2]=-2147483584,f=l[14418]|l[14419]<<8|(l[14420]<<16|l[14421]<<24),o=l[14414]|l[14415]<<8|(l[14416]<<16|l[14417]<<24),u[r|0]=o,u[r+1|0]=o>>>8,u[r+2|0]=o>>>16,u[r+3|0]=o>>>24,u[r+4|0]=f,u[r+5|0]=f>>>8,u[r+6|0]=f>>>16,u[r+7|0]=f>>>24,u[r+58|0]=0,f=l[14470]|l[14471]<<8,u[r+56|0]=f,u[r+57|0]=f>>>8,f=l[14466]|l[14467]<<8|(l[14468]<<16|l[14469]<<24),o=l[14462]|l[14463]<<8|(l[14464]<<16|l[14465]<<24),u[r+48|0]=o,u[r+49|0]=o>>>8,u[r+50|0]=o>>>16,u[r+51|0]=o>>>24,u[r+52|0]=f,u[r+53|0]=f>>>8,u[r+54|0]=f>>>16,u[r+55|0]=f>>>24,f=l[14458]|l[14459]<<8|(l[14460]<<16|l[14461]<<24),o=l[14454]|l[14455]<<8|(l[14456]<<16|l[14457]<<24),u[r+40|0]=o,u[r+41|0]=o>>>8,u[r+42|0]=o>>>16,u[r+43|0]=o>>>24,u[r+44|0]=f,u[r+45|0]=f>>>8,u[r+46|0]=f>>>16,u[r+47|0]=f>>>24,f=l[14450]|l[14451]<<8|(l[14452]<<16|l[14453]<<24),o=l[14446]|l[14447]<<8|(l[14448]<<16|l[14449]<<24),u[r+32|0]=o,u[r+33|0]=o>>>8,u[r+34|0]=o>>>16,u[r+35|0]=o>>>24,u[r+36|0]=f,u[r+37|0]=f>>>8,u[r+38|0]=f>>>16,u[r+39|0]=f>>>24,f=l[14442]|l[14443]<<8|(l[14444]<<16|l[14445]<<24),o=l[14438]|l[14439]<<8|(l[14440]<<16|l[14441]<<24),u[r+24|0]=o,u[r+25|0]=o>>>8,u[r+26|0]=o>>>16,u[r+27|0]=o>>>24,u[r+28|0]=f,u[r+29|0]=f>>>8,u[r+30|0]=f>>>16,u[r+31|0]=f>>>24,f=l[14434]|l[14435]<<8|(l[14436]<<16|l[14437]<<24),o=l[14430]|l[14431]<<8|(l[14432]<<16|l[14433]<<24),u[r+16|0]=o,u[r+17|0]=o>>>8,u[r+18|0]=o>>>16,u[r+19|0]=o>>>24,u[r+20|0]=f,u[r+21|0]=f>>>8,u[r+22|0]=f>>>16,u[r+23|0]=f>>>24,f=l[14426]|l[14427]<<8|(l[14428]<<16|l[14429]<<24),o=l[14422]|l[14423]<<8|(l[14424]<<16|l[14425]<<24),u[r+8|0]=o,u[r+9|0]=o>>>8,u[r+10|0]=o>>>16,u[r+11|0]=o>>>24,u[r+12|0]=f,u[r+13|0]=f>>>8,u[r+14|0]=f>>>16,u[r+15|0]=f>>>24,q(A,2,2e3,t+152|0),u[t+163|0]>=0)break k;Z(i[t+152>>2]);break k}if(o=i[e+16>>2],(F|0)!=(o|0))for(N=A+8|0,A0=i[18051],r0=A0-12|0,n0=i[18052],N0=n0-12|0,_0=i[18055],U0=_0-12|0,m0=i[18053],M0=m0-12|0,z=t+136|0,H0=i[18060],P0=i[18059],E=t+172|0,R=t+184|0,K0=i[18057],$0=i[18056],X0=i[18054],a=t+164|0,S=t+160|0,g0=t+216|0;;){r=i[o+20>>2],W[i[i[r>>2]+52>>2]](t+152|0,r),r=i[t+152>>2],u[t+171|0]<0&&Z(i[t+160>>2]);n:{if(r)break n;i[t+336>>2]=0,i[t+328>>2]=0,i[t+332>>2]=0,j1(t+304|0,i[e+48>>2],i[o+16>>2],t+328|0);t:{if(i[t+304>>2]){r=i[t+308>>2],i[A>>2]=i[t+304>>2],i[A+4>>2]=r,i[N+8>>2]=i[t+320>>2],r=i[t+316>>2],i[N>>2]=i[t+312>>2],i[N+4>>2]=r,i[t+312>>2]=0,i[t+316>>2]=0,i[t+320>>2]=0,m=1;break t}u:{o:{l:{s:{r=i[t+328>>2],s=i[t+332>>2];w:{_:{if((r|0)==(s|0))break _;for(;;){h:{if(f=i[r>>2],!f||!W0(f,86580,86784))break h;n=i[r+4>>2],n&&(i[n+4>>2]=i[n+4>>2]+1),f=i[e+48>>2],k=i[e+52>>2],k&&(i[k+4>>2]=i[k+4>>2]+1),m=i[f+52>>2],w=i[f+56>>2],w&&(i[w+4>>2]=i[w+4>>2]+1),Q=i[o+16>>2],i[t+152>>2]=i[r>>2],f=i[r+4>>2],i[t+156>>2]=f,f&&(i[f+4>>2]=i[f+4>>2]+1),f=i[e+48>>2],h=i[e+52>>2],h&&(i[h+4>>2]=i[h+4>>2]+1),i[t+376>>2]=i[f+60>>2],f=i[f+64>>2],i[t+380>>2]=f,f&&(i[f+4>>2]=i[f+4>>2]+1),f=i[m+36>>2],m=i[m+40>>2]-f>>3;B:{if((m|0)>0)v:for(_=i[t+152>>2],B=0;;){if((_|0)==i[f+(B<<3)>>2]){if(f=i[t+376>>2],_=i[f+104>>2],f=i[f+108>>2],(_|0)==(f|0))break v;for(m=B+1|0;;){Z:{G:{if((Q|0)!=i[_>>2]||(B=i[_+4>>2],I=i[_+8>>2],(B|0)==(I|0)))break G;for(;;){if((m|0)==C[B+2>>1])break Z;if(B=B+4|0,(I|0)==(B|0))break}}if(_=_+16|0,(f|0)!=(_|0))continue;break v}break}f=u[B|0]&1;break B}if(B=B+1|0,(m|0)==(B|0))break}f=0}m=i[t+380>>2];B:{if(!m||(B=i[m+4>>2],i[m+4>>2]=B-1,B))break B;W[i[i[m>>2]+8>>2]](m),y(m)}B:{if(!h||(m=i[h+4>>2],i[h+4>>2]=m-1,m))break B;W[i[i[h>>2]+8>>2]](h),y(h)}h=i[t+156>>2];B:{if(!h||(m=i[h+4>>2],i[h+4>>2]=m-1,m))break B;W[i[i[h>>2]+8>>2]](h),y(h)}B:{if(!w||(h=i[w+4>>2],i[w+4>>2]=h-1,h))break B;W[i[i[w>>2]+8>>2]](w),y(w)}B:{if(!k||(w=i[k+4>>2],i[k+4>>2]=w-1,w))break B;W[i[i[k>>2]+8>>2]](k),y(k)}B:{if(!n||(k=i[n+4>>2],i[n+4>>2]=k-1,k))break B;W[i[i[n>>2]+8>>2]](n),y(n)}if(!f)break h;i[t+244>>2]=0,i[t+152>>2]=m0,i[t+216>>2]=72196,i[t+160>>2]=72176,f=t+152|0,i[f+i[M0>>2]>>2]=X0,i[t+156>>2]=0,n=f+i[i[t+152>>2]-12>>2]|0,J0(n,a),u[n+80|0]=0,i[n+72>>2]=0,i[t+160>>2]=_0,i[S+i[U0>>2]>>2]=$0,i[t+152>>2]=n0,i[f+i[N0>>2]>>2]=K0,i[t+216>>2]=72196,i[t+152>>2]=72156,i[t+160>>2]=72176,n=R0(a),i[n>>2]=71232,i[t+204>>2]=0,i[t+208>>2]=0,i[t+196>>2]=0,i[t+200>>2]=0,i[t+212>>2]=24,f=Y(S,27301,31),k=t+376|0,ie(k,i[r>>2]),h=f,r=u[t+387|0],f=(r|0)<0,Y(Y(h,f?i[t+376>>2]:k,f?i[t+380>>2]:r),27419,1),u[t+387|0]<0&&Z(i[t+376>>2]),r=i[t+212>>2];B:{if(r&16){if(r=R,B=i[t+208>>2],f=i[t+188>>2],B>>>0>=f>>>0)break B;i[t+208>>2]=f,B=f;break B}if(!(r&8)){r=0,u[t+387|0]=0,B=t+376|0;break u}B=i[t+180>>2],r=E}if(f=i[r>>2],r=B-f|0,r>>>0>=2147483640)break s;if(r>>>0>=11){k=r|7,B=p(k+1|0),i[t+384>>2]=k-2147483647,i[t+376>>2]=B,i[t+380>>2]=r;break o}if(u[t+387|0]=r,B=t+376|0,r)break o;r=0;break u}if(r=r+8|0,(s|0)==(r|0))break}if(r=i[t+328>>2],f=i[t+332>>2],(r|0)!=(f|0)){for(;;){n=i[r>>2];h:{if(!n||(n=W0(n,86580,86864),!n))break h;if(k=i[r+4>>2],k&&(i[k+4>>2]=i[k+4>>2]+1),(W[i[i[n>>2]+36>>2]](n)|0)!=2)break l;w=i[o+20>>2],h=i[n+108>>2],i[t+128>>2]=i[n+104>>2],i[t+132>>2]=h;B:{if(u[n+123|0]>=0){h=i[n+116>>2],i[z>>2]=i[n+112>>2],i[z+4>>2]=h,i[z+8>>2]=i[n+120>>2];break B}T(z,i[n+112>>2],i[n+116>>2])}n=i[w+428>>2];B:{if(n>>>0<u0[w+432>>2]){h=i[t+132>>2],i[n>>2]=i[t+128>>2],i[n+4>>2]=h,i[n+16>>2]=i[z+8>>2],h=i[z+4>>2],i[n+8>>2]=i[z>>2],i[n+12>>2]=h,i[z>>2]=0,i[z+4>>2]=0,i[z+8>>2]=0,i[w+428>>2]=n+20;break B}if(n=ee(w+424|0,t+128|0),h=u[t+147|0],i[w+428>>2]=n,(h|0)>=0)break B;Z(i[t+136>>2])}if(!k||(n=i[k+4>>2],i[k+4>>2]=n-1,n))break h;W[i[i[k>>2]+8>>2]](k),y(k)}if(r=r+8|0,(f|0)==(r|0))break}f=i[t+332>>2],r=i[t+328>>2]}if(h=0,(r|0)==(f|0))break _;for(;;){h:{if(n=i[r>>2],!n||(n=W0(n,86580,86600),!n))break h;k=i[r+4>>2],k&&(i[k+4>>2]=i[k+4>>2]+1),w=i[n+104>>2],n=i[n+108>>2],B=(w|0)!=0&(n|0)!=0;B:{if(!B){if(n=p(32),i[t+152>>2]=n,i[t+156>>2]=26,i[t+160>>2]=-2147483616,w=l[4093]|l[4094]<<8|(l[4095]<<16|l[4096]<<24),m=l[4089]|l[4090]<<8|(l[4091]<<16|l[4092]<<24),u[n|0]=m,u[n+1|0]=m>>>8,u[n+2|0]=m>>>16,u[n+3|0]=m>>>24,u[n+4|0]=w,u[n+5|0]=w>>>8,u[n+6|0]=w>>>16,u[n+7|0]=w>>>24,u[n+26|0]=0,w=l[4113]|l[4114]<<8,u[n+24|0]=w,u[n+25|0]=w>>>8,w=l[4109]|l[4110]<<8|(l[4111]<<16|l[4112]<<24),m=l[4105]|l[4106]<<8|(l[4107]<<16|l[4108]<<24),u[n+16|0]=m,u[n+17|0]=m>>>8,u[n+18|0]=m>>>16,u[n+19|0]=m>>>24,u[n+20|0]=w,u[n+21|0]=w>>>8,u[n+22|0]=w>>>16,u[n+23|0]=w>>>24,w=l[4101]|l[4102]<<8|(l[4103]<<16|l[4104]<<24),m=l[4097]|l[4098]<<8|(l[4099]<<16|l[4100]<<24),u[n+8|0]=m,u[n+9|0]=m>>>8,u[n+10|0]=m>>>16,u[n+11|0]=m>>>24,u[n+12|0]=w,u[n+13|0]=w>>>8,u[n+14|0]=w>>>16,u[n+15|0]=w>>>24,q(A,2,129,t+152|0),u[t+163|0]>=0)break B;Z(i[t+152>>2]);break B}h=i[o+20>>2],i[h+124>>2]=n,i[h+120>>2]=w,h=1}B:{if(!k||(n=i[k+4>>2],i[k+4>>2]=n-1,n))break B;if(W[i[i[k>>2]+8>>2]](k),y(k),B)break h;m=1;break t}if(B)break h;m=1;break t}if(r=r+8|0,(f|0)==(r|0))break}if(X=1,h&1)break w}f=i[o+20>>2],u[t+152|0]=0,u[t+163|0]=0,n=q(t+104|0,2,137,t+152|0),r=i[f+428>>2];_:{if(r>>>0<u0[f+432>>2]){k=i[n+4>>2],i[r>>2]=i[n>>2],i[r+4>>2]=k,i[r+16>>2]=i[t+120>>2],n=i[t+116>>2],i[r+8>>2]=i[t+112>>2],i[r+12>>2]=n,i[t+112>>2]=0,i[t+116>>2]=0,i[t+120>>2]=0,i[f+428>>2]=r+20;break _}if(r=ee(f+424|0,n),n=u[t+123|0],i[f+428>>2]=r,(n|0)>=0)break _;Z(i[t+112>>2])}u[t+163|0]<0&&Z(i[t+152>>2]),X=0}r=i[t+328>>2],h=i[t+332>>2];w:{if((r|0)==(h|0))break w;for(;;){k=i[r>>2];_:{if(!k)break _;if(n=W0(k,86580,95468),n){f=i[r+4>>2],f&&(i[f+4>>2]=i[f+4>>2]+1),i[t+152>>2]=i[n+100>>2],n=i[n+104>>2],i[t+156>>2]=n,n&&(i[n+4>>2]=i[n+4>>2]+1),lt(i[o+20>>2],t+152|0),n=i[t+156>>2];h:{if(!n||(k=i[n+4>>2],i[n+4>>2]=k-1,k))break h;W[i[i[n>>2]+8>>2]](n),y(n)}if(!f||(n=i[f+4>>2],i[f+4>>2]=n-1,n))break _;W[i[i[f>>2]+8>>2]](f),y(f);break _}m=0,B=0;h:{B:{if(f=W0(k,86580,89196),!f)break B;if(B=i[r+4>>2],B&&(i[B+4>>2]=i[B+4>>2]+1),!X){u[t+152|0]=0,u[t+163|0]=0,q(A,2,137,t+152|0),u[t+163|0]<0&&Z(i[t+152>>2]),m=1,w=0;break h}if(n=i[o+20>>2],k=i[f+148>>2],i[t+192>>2]=i[f+144>>2],i[t+196>>2]=k,k=i[f+140>>2],i[t+184>>2]=i[f+136>>2],i[t+188>>2]=k,k=i[f+132>>2],i[t+176>>2]=i[f+128>>2],i[t+180>>2]=k,k=i[f+124>>2],i[t+168>>2]=i[f+120>>2],i[t+172>>2]=k,k=i[f+116>>2],i[S>>2]=i[f+112>>2],i[S+4>>2]=k,k=i[f+108>>2],i[t+152>>2]=i[f+104>>2],i[t+156>>2]=k,w=1,u[n+288|0]=1,f=yA(n),k=EA(n),M=+(f|0),P=t0[t+152>>3]*M,t0[t+376>>3]=P,L0=+(k|0),t0[t+384>>3]=l[t+176|0]?t0[t+184>>3]*L0:P,t0[t+392>>3]=t0[t+160>>3]*M,t0[t+400>>3]=t0[t+168>>3]*L0,t0[t+408>>3]=t0[t+192>>3],f=i[t+412>>2],i[n+328>>2]=i[t+408>>2],i[n+332>>2]=f,f=i[t+404>>2],i[n+320>>2]=i[t+400>>2],i[n+324>>2]=f,f=i[t+396>>2],i[n+312>>2]=i[t+392>>2],i[n+316>>2]=f,f=i[t+388>>2],i[n+304>>2]=i[t+384>>2],i[n+308>>2]=f,f=i[t+380>>2],i[n+296>>2]=i[t+376>>2],i[n+300>>2]=f,k=i[r>>2],k)break B;break h}if(k=W0(k,86580,89276),!k){w=1;break h}if(f=i[r+4>>2],f&&(i[f+4>>2]=i[f+4>>2]+1),n=i[o+20>>2],s=t+152|0,x(s,k+104|0,80),w=1,u[n+336|0]=1,x(n+344|0,s,76),!f||(n=i[f+4>>2],i[f+4>>2]=n-1,n))break h;W[i[i[f>>2]+8>>2]](f),y(f)}h:{if(!B||(f=i[B+4>>2],i[B+4>>2]=f-1,f))break h;W[i[i[B>>2]+8>>2]](B),y(B)}if(!w)break t}if(r=r+8|0,(h|0)==(r|0))break}if(r=i[t+328>>2],I0=i[t+332>>2],(r|0)==(I0|0))break w;for(;;){f=i[r>>2];_:{if(!f)break _;B=0,k=0,Q=W0(f,86580,88052);h:{if(Q){if(k=i[r+4>>2],k&&(i[k+4>>2]=i[k+4>>2]+1),w=i[Q+100>>2],f=i[Q+104>>2],h=(f|0)/2|0,n=w+h|0,_=(w>>31)+(h>>31)|0,f=G2(n,n>>>0<h>>>0?_+1|0:_,f,f>>31),m=i[Q+108>>2],n=i[Q+112>>2],s=(n|0)/2|0,w=m+s|0,_=(m>>31)+(s>>31)|0,h=i[o+20>>2],d0=h,n2=G2(w,s>>>0>w>>>0?_+1|0:_,n,n>>31),i[d0+124>>2]=n2,i[h+120>>2]=f,I=i[o+20>>2],l[I+288|0]==1){O=i[I+124>>2],f=i[I+120>>2],n=f-1|0,f=f+65535>>>0<131073,_=f?n:(n|0)/2|0,n=i[Q+116>>2],m=n>>31,h=f?2:1,w=i[Q+120>>2];B:{if((h|0)==(w|0)){if(s=(_>>31)+m|0,m=n+_|0,s=m>>>0<_>>>0?s+1|0:s,f=s,!(m- -2147483648>>>0<2147483648?f+1|0:f))break B;s=f>>31,n=m+(s|1)|0,_=f+s|0,m=G2(n,n>>>0<m>>>0?_+1|0:_,2,0),h=1;break B}if(V=w>>31,s=O0(w,V,_,_>>31),e0=l0,h=f,f0=s,$=n,s=f&31,(f&63)>>>0>=32?(_=n<<s,f=0):(_=(1<<s)-1&$>>>32-s|m<<s,f=$<<s),m=f0+f|0,s=_+e0|0,f=f>>>0>m>>>0?s+1|0:s,$=0-(f+(m>>>0>2147483647)|0)|0,s=w,n=h&31,(h&63)>>>0>=32?(_=s<<n,n=0):(_=(1<<n)-1&s>>>32-n|V<<n,n=s<<n),w=_,h=0-(w+(n>>>0>2147483647)|0)|$,(h|0)==1|h>>>0>1)for(;s=w>>31,h=n+(s|1)|0,_=s+w|0,n=G2(h,n>>>0>h>>>0?_+1|0:_,2,0),w=l0,s=f>>31,h=m+(s|1)|0,s=f+s|0,m=G2(h,h>>>0<m>>>0?s+1|0:s,2,0),f=l0,(f-(m>>>0<2147483648)|0)!=-1;);h=n}if(w=i[Q+100>>2],s=w,n=i[Q+104>>2],f=s-n|0,w=n>>31,s=(s>>31)-(w+(n>>>0>s>>>0)|0)|0,_=0-(s+(f>>>0>2147483647)|0)|0-((n>>>0>2147483647)+w|0),(_|0)==1|_>>>0>1){for(;_=w>>31,V=n+(_|1)|0,_=w+_|0,n=G2(V,n>>>0>V>>>0?_+1|0:_,2,0),w=l0,_=s>>31,V=f+(_|1)|0,s=s+_|0,f=G2(V,f>>>0>V>>>0?s+1|0:s,2,0),s=l0,(s-(f>>>0<2147483648)|0)!=-1;);w=n>>31}s=w<<1|n>>>31,n=n<<1,V=f>>31,_=0-((n>>>0>2147483646)+s|0)|0-(V+(f>>>0>2147483647)|0),(_|0)==1|_>>>0>1&&(_=w>>31,w=n+(_|1)|0,s=s+_|0,n=G2(w,n>>>0>w>>>0?s+1|0:s,2,0),s=V>>31,w=f+(s|1)|0,s=s+V|0,f=G2(w,f>>>0>w>>>0?s+1|0:s,2,0)),w=m>>31;B:{if((n|0)==(h|0)){if(w=w-((f>>31)+(f>>>0>m>>>0)|0)|0,n=m-f|0,f=h,s=f>>31,!(0-(w+(n>>>0>2147483647)|0)|0-(s+(f>>>0>2147483647)|0)))break B;for(;_=s>>31,h=f+(_|1)|0,_=s+_|0,f=G2(h,f>>>0>h>>>0?_+1|0:_,2,0),s=l0,_=w>>31,h=n+(_|1)|0,w=w+_|0,n=G2(h,n>>>0>h>>>0?w+1|0:w,2,0),w=l0,(w-(n>>>0<2147483648)|0)!=-1;);h=f;break B}if(s=n>>31,w=O0(n,s,m,w),_=l0,V=h>>31,f=O0(h,V,f,f>>31),m=w-f|0,w=_-(l0+(f>>>0>w>>>0)|0)|0,f=O0(n,s,h,V),n=m,s=l0,h=0-((n>>>0>2147483647)+w|0)|0-(s+(f>>>0>2147483647)|0),(h|0)==1|h>>>0>1)for(;_=s>>31,h=f+(_|1)|0,s=s+_|0,f=G2(h,f>>>0>h>>>0?s+1|0:s,2,0),m=l0,s=m,m=s-(f>>>0<2147483648)|0,_=w>>31,h=n+(_|1)|0,w=w+_|0,n=G2(h,n>>>0>h>>>0?w+1|0:w,2,0),w=l0,(w-(n>>>0<2147483648)&m)!=-1;);h=f}t0[I+312>>3]=t0[I+312>>3]-+(n|0)/+(h|0),M=t0[I+320>>3],f=O-1|0,n=f,h=(f|0)/2|0,f=O+65535>>>0<131073,_=f?n:h,n=i[Q+124>>2],m=n>>31,h=f?2:1,w=i[Q+128>>2];B:{if((h|0)==(w|0)){if(s=(_>>31)+m|0,m=n+_|0,s=m>>>0<_>>>0?s+1|0:s,f=s,!(m- -2147483648>>>0<2147483648?f+1|0:f))break B;s=f>>31,n=m+(s|1)|0,_=f+s|0,m=G2(n,n>>>0<m>>>0?_+1|0:_,2,0),h=1;break B}if(h=w,V=w>>31,s=O0(w,V,_,_>>31),$=l0,w=f,f0=s,O=n,s=f&31,(f&63)>>>0>=32?(_=n<<s,f=0):(_=(1<<s)-1&O>>>32-s|m<<s,f=O<<s),m=f0+f|0,s=_+$|0,f=f>>>0>m>>>0?s+1|0:s,s=0-(f+(m>>>0>2147483647)|0)|0,n=w&31,(w&63)>>>0>=32?(_=h<<n,n=0):(_=(1<<n)-1&h>>>32-n|V<<n,n=h<<n),w=_,h=0-(w+(n>>>0>2147483647)|0)|s,(h|0)==1|h>>>0>1)for(;s=w>>31,h=n+(s|1)|0,_=s+w|0,n=G2(h,n>>>0>h>>>0?_+1|0:_,2,0),w=l0,s=f>>31,h=m+(s|1)|0,s=f+s|0,m=G2(h,h>>>0<m>>>0?s+1|0:s,2,0),f=l0,(f-(m>>>0<2147483648)|0)!=-1;);h=n}if(w=i[Q+108>>2],s=w,n=i[Q+112>>2],f=s-n|0,w=n>>31,s=(s>>31)-(w+(n>>>0>s>>>0)|0)|0,_=0-(s+(f>>>0>2147483647)|0)|0-((n>>>0>2147483647)+w|0),(_|0)==1|_>>>0>1){for(;_=w>>31,Q=n+(_|1)|0,_=w+_|0,n=G2(Q,n>>>0>Q>>>0?_+1|0:_,2,0),w=l0,_=s>>31,Q=f+(_|1)|0,s=s+_|0,f=G2(Q,f>>>0>Q>>>0?s+1|0:s,2,0),s=l0,(s-(f>>>0<2147483648)|0)!=-1;);w=n>>31}s=w<<1|n>>>31,n=n<<1,Q=f>>31,_=0-((n>>>0>2147483646)+s|0)|0-(Q+(f>>>0>2147483647)|0),(_|0)==1|_>>>0>1&&(_=w>>31,w=n+(_|1)|0,s=s+_|0,n=G2(w,n>>>0>w>>>0?s+1|0:s,2,0),s=Q>>31,w=f+(s|1)|0,s=s+Q|0,f=G2(w,f>>>0>w>>>0?s+1|0:s,2,0)),w=m>>31;B:{if((n|0)==(h|0)){if(w=w-((f>>31)+(f>>>0>m>>>0)|0)|0,n=m-f|0,f=h,s=f>>31,!(0-(w+(n>>>0>2147483647)|0)|0-(s+(f>>>0>2147483647)|0)))break B;for(;_=s>>31,h=f+(_|1)|0,_=s+_|0,f=G2(h,f>>>0>h>>>0?_+1|0:_,2,0),s=l0,_=w>>31,h=n+(_|1)|0,w=w+_|0,n=G2(h,n>>>0>h>>>0?w+1|0:w,2,0),w=l0,(w-(n>>>0<2147483648)|0)!=-1;);h=f;break B}if(s=n>>31,w=O0(n,s,m,w),_=l0,Q=h>>31,f=O0(h,Q,f,f>>31),m=w-f|0,w=_-(l0+(f>>>0>w>>>0)|0)|0,f=O0(n,s,h,Q),n=m,s=l0,h=0-((n>>>0>2147483647)+w|0)|0-(s+(f>>>0>2147483647)|0),(h|0)==1|h>>>0>1)for(;_=s>>31,h=f+(_|1)|0,s=s+_|0,f=G2(h,f>>>0>h>>>0?s+1|0:s,2,0),m=l0,s=m,m=s-(f>>>0<2147483648)|0,_=w>>31,h=n+(_|1)|0,w=w+_|0,n=G2(h,n>>>0>h>>>0?w+1|0:w,2,0),w=l0,(w-(n>>>0<2147483648)&m)!=-1;);h=f}t0[I+320>>3]=M-+(n|0)/+(h|0)}if(f=i[r>>2],!f)break h}n=W0(f,86580,87972);B:{if(!n)break B;if(B=i[r+4>>2],B&&(i[B+4>>2]=i[B+4>>2]+1),!X){u[t+152|0]=0,u[t+163|0]=0,q(A,2,137,t+152|0),u[t+163|0]<0&&Z(i[t+152>>2]);v:{if(!B||(r=i[B+4>>2],i[B+4>>2]=r-1,r))break v;W[i[i[B>>2]+8>>2]](B),y(B)}if(m=1,!k||(r=i[k+4>>2],i[k+4>>2]=r-1,r))break t;W[i[i[k>>2]+8>>2]](k),y(k);break t}f=i[o+20>>2],h=i[f+124>>2],w=24,_=8;v:switch(i[n+100>>2]){case 1:t0[f+296>>3]=-t0[f+296>>3],h=i[f+120>>2],w=16,_=32;break;case 0:break v;default:break B}f=f+296|0,n=f+_|0,t0[n>>3]=-t0[n>>3],f=f+w|0,t0[f>>3]=+(h-1>>>0)-t0[f>>3]}f=i[r>>2];B:{if(!f||(n=W0(f,86580,87892),!n))break B;if(f=i[r+4>>2],f&&(i[f+4>>2]=i[f+4>>2]+1),n=i[n+100>>2],!((n|0)!=270&(n|0)!=90)){if(!X){u[t+152|0]=0,u[t+163|0]=0,q(A,2,137,t+152|0),u[t+163|0]<0&&Z(i[t+152>>2]);v:{if(!f||(r=i[f+4>>2],i[f+4>>2]=r-1,r))break v;W[i[i[f>>2]+8>>2]](f),y(f)}v:{if(!B||(r=i[B+4>>2],i[B+4>>2]=r-1,r))break v;W[i[i[B>>2]+8>>2]](B),y(B)}if(m=1,!k||(r=i[k+4>>2],i[k+4>>2]=r-1,r))break t;W[i[i[k>>2]+8>>2]](k),y(k);break t}n=i[o+20>>2],w=i[n+124>>2],i[n+124>>2]=i[n+120>>2],i[n+120>>2]=w}if(!f||(n=i[f+4>>2],i[f+4>>2]=n-1,n))break B;W[i[i[f>>2]+8>>2]](f),y(f)}if(!B||(f=i[B+4>>2],i[B+4>>2]=f-1,f))break h;W[i[i[B>>2]+8>>2]](B),y(B)}if(!k||(f=i[k+4>>2],i[k+4>>2]=f-1,f))break _;W[i[i[k>>2]+8>>2]](k),y(k)}if(r=r+8|0,(I0|0)==(r|0))break}}if(m=0,w=i[o+20>>2],r=i[w+104>>2],n=i[w+108>>2],(r|0)==(n|0))break t;for(;;){w:{if(f=i[r>>2],!f||(f=W0(f,86580,89572),!f))break w;r=i[r+4>>2],r&&(i[r+4>>2]=i[r+4>>2]+1,w=i[o+20>>2]);_:{if(u[f+111|0]>=0){i[t+96>>2]=i[f+108>>2],n=i[f+104>>2],i[t+88>>2]=i[f+100>>2],i[t+92>>2]=n;break _}T(t+88|0,i[f+100>>2],i[f+104>>2])}if(W[i[i[w>>2]+36>>2]](w,t+88|0),u[t+99|0]<0&&Z(i[t+88>>2]),!r||(f=i[r+4>>2],i[r+4>>2]=f-1,f))break t;W[i[i[r>>2]+8>>2]](r),y(r);break t}if(r=r+8|0,(n|0)==(r|0))break}break t}Q0(),H()}r=i[n+108>>2],i[A>>2]=i[n+104>>2],i[A+4>>2]=r;l:{if(u[n+123|0]>=0){r=i[n+116>>2],i[N>>2]=i[n+112>>2],i[N+4>>2]=r,i[N+8>>2]=i[n+120>>2];break l}T(N,i[n+112>>2],i[n+116>>2])}if(m=1,!k||(r=i[k+4>>2],i[k+4>>2]=r-1,r))break t;W[i[i[k>>2]+8>>2]](k),y(k);break t}if(!r)break u;x(B,f,r)}u[r+B|0]=0,q(A,4,3007,t+376|0),u[t+387|0]<0&&Z(i[t+376>>2]),i[t+152>>2]=A0,i[i[r0>>2]+(t+152|0)>>2]=P0,i[t+160>>2]=H0,i[n>>2]=71232,u[t+207|0]<0&&Z(i[t+196>>2]),E0(n),y0(g0),m=1}if(u[t+323|0]<0&&Z(i[t+312>>2]),f=i[t+328>>2],f){if(r=i[t+332>>2],k=f,(r|0)!=(f|0)){for(;;){n=i[r-4>>2];t:{if(!n||(k=i[n+4>>2],i[n+4>>2]=k-1,k))break t;W[i[i[n>>2]+8>>2]](n),y(n)}if(r=r-8|0,(f|0)==(r|0))break}k=i[t+328>>2]}i[t+332>>2]=f,Z(k)}switch(m|0){case 0:case 5:break n;default:break k}}k=i[o+4>>2];n:{if(k){for(;;)if(r=k,k=i[r>>2],!k)break n}for(;r=i[o+8>>2],f=i[r>>2]!=(o|0),o=r,!!f;);}if(o=r,(r|0)==(F|0))break}r=i[e+48>>2],R=i[r+84>>2],z=i[r+88>>2],z&&(i[z+4>>2]=i[z+4>>2]+1),o=i[e+16>>2];n:{if(!(!R|(F|0)==(o|0))){for(O=i[18051],$=O-12|0,A0=i[18052],r0=A0-12|0,n0=i[18055],N0=n0-12|0,_0=i[18053],U0=_0-12|0,m0=i[18060],M0=i[18059],Q=t+172|0,I=t+184|0,H0=i[18057],P0=i[18056],K0=i[18054],S=t+164|0,a=t+160|0,$0=t+216|0;;){i3(t+376|0,R,i[i[o+20>>2]+116>>2]),m=i[t+376>>2],X0=i[t+380>>2];t:{if((m|0)==(X0|0)){f=18;break t}E=o+20|0;u:{o:{l:{s:{for(;;){w:{_:{h:{B:{v:{Z:{G:{if(r=i[m+16>>2],(r|0)!=1635088492){if((r|0)!=1953000802)break w;if(i[t+160>>2]=0,i[t+152>>2]=0,i[t+156>>2]=0,r=i[m+48>>2],n=i[m+44>>2],(r|0)==(n|0))break G;if(r=r-n|0,(r|0)<0)break i;for(f=p(r),i[t+152>>2]=f,_=r+f|0,i[t+160>>2]=_,r&&x(f,n,r),i[t+156>>2]=_,w=f;;){n=i[w>>2],B=i[E>>2],u[B+129|0]=1;m:{k=F,r=i[k>>2];X:{if(!r)break X;for(;h=n>>>0>u0[r+16>>2],k=h?k:r,r=i[(h?4:0)+r>>2],!!r;);if((k|0)==(F|0))break X;if(n>>>0>=u0[k+16>>2])break m}if(r=p(48),i[t+304>>2]=r,i[t+308>>2]=41,i[t+312>>2]=-2147483600,n=l[14644]|l[14645]<<8|(l[14646]<<16|l[14647]<<24),k=l[14640]|l[14641]<<8|(l[14642]<<16|l[14643]<<24),u[r|0]=k,u[r+1|0]=k>>>8,u[r+2|0]=k>>>16,u[r+3|0]=k>>>24,u[r+4|0]=n,u[r+5|0]=n>>>8,u[r+6|0]=n>>>16,u[r+7|0]=n>>>24,u[r+41|0]=0,u[r+40|0]=l[14680],n=l[14676]|l[14677]<<8|(l[14678]<<16|l[14679]<<24),k=l[14672]|l[14673]<<8|(l[14674]<<16|l[14675]<<24),u[r+32|0]=k,u[r+33|0]=k>>>8,u[r+34|0]=k>>>16,u[r+35|0]=k>>>24,u[r+36|0]=n,u[r+37|0]=n>>>8,u[r+38|0]=n>>>16,u[r+39|0]=n>>>24,n=l[14668]|l[14669]<<8|(l[14670]<<16|l[14671]<<24),k=l[14664]|l[14665]<<8|(l[14666]<<16|l[14667]<<24),u[r+24|0]=k,u[r+25|0]=k>>>8,u[r+26|0]=k>>>16,u[r+27|0]=k>>>24,u[r+28|0]=n,u[r+29|0]=n>>>8,u[r+30|0]=n>>>16,u[r+31|0]=n>>>24,n=l[14660]|l[14661]<<8|(l[14662]<<16|l[14663]<<24),k=l[14656]|l[14657]<<8|(l[14658]<<16|l[14659]<<24),u[r+16|0]=k,u[r+17|0]=k>>>8,u[r+18|0]=k>>>16,u[r+19|0]=k>>>24,u[r+20|0]=n,u[r+21|0]=n>>>8,u[r+22|0]=n>>>16,u[r+23|0]=n>>>24,n=l[14652]|l[14653]<<8|(l[14654]<<16|l[14655]<<24),k=l[14648]|l[14649]<<8|(l[14650]<<16|l[14651]<<24),u[r+8|0]=k,u[r+9|0]=k>>>8,u[r+10|0]=k>>>16,u[r+11|0]=k>>>24,u[r+12|0]=n,u[r+13|0]=n>>>8,u[r+14|0]=n>>>16,u[r+15|0]=n>>>24,q(A,2,2e3,t+304|0),u[t+315|0]>=0)break o;Z(i[t+304>>2]);break o}if(h=i[k+20>>2],l[h+129|0]==1){if(r=p(40),i[t+304>>2]=r,i[t+308>>2]=38,i[t+312>>2]=-2147483608,n=l[9875]|l[9876]<<8|(l[9877]<<16|l[9878]<<24),k=l[9871]|l[9872]<<8|(l[9873]<<16|l[9874]<<24),u[r|0]=k,u[r+1|0]=k>>>8,u[r+2|0]=k>>>16,u[r+3|0]=k>>>24,u[r+4|0]=n,u[r+5|0]=n>>>8,u[r+6|0]=n>>>16,u[r+7|0]=n>>>24,u[r+38|0]=0,n=l[9905]|l[9906]<<8|(l[9907]<<16|l[9908]<<24),k=l[9901]|l[9902]<<8|(l[9903]<<16|l[9904]<<24),u[r+30|0]=k,u[r+31|0]=k>>>8,u[r+32|0]=k>>>16,u[r+33|0]=k>>>24,u[r+34|0]=n,u[r+35|0]=n>>>8,u[r+36|0]=n>>>16,u[r+37|0]=n>>>24,n=l[9899]|l[9900]<<8|(l[9901]<<16|l[9902]<<24),k=l[9895]|l[9896]<<8|(l[9897]<<16|l[9898]<<24),u[r+24|0]=k,u[r+25|0]=k>>>8,u[r+26|0]=k>>>16,u[r+27|0]=k>>>24,u[r+28|0]=n,u[r+29|0]=n>>>8,u[r+30|0]=n>>>16,u[r+31|0]=n>>>24,n=l[9891]|l[9892]<<8|(l[9893]<<16|l[9894]<<24),k=l[9887]|l[9888]<<8|(l[9889]<<16|l[9890]<<24),u[r+16|0]=k,u[r+17|0]=k>>>8,u[r+18|0]=k>>>16,u[r+19|0]=k>>>24,u[r+20|0]=n,u[r+21|0]=n>>>8,u[r+22|0]=n>>>16,u[r+23|0]=n>>>24,n=l[9883]|l[9884]<<8|(l[9885]<<16|l[9886]<<24),k=l[9879]|l[9880]<<8|(l[9881]<<16|l[9882]<<24),u[r+8|0]=k,u[r+9|0]=k>>>8,u[r+10|0]=k>>>16,u[r+11|0]=k>>>24,u[r+12|0]=n,u[r+13|0]=n>>>8,u[r+14|0]=n>>>16,u[r+15|0]=n>>>24,q(A,2,2e3,t+304|0),u[t+315|0]>=0)break o;Z(i[t+304>>2]);break o}if((h|0)==(B|0)){if(r=p(40),i[t+304>>2]=r,i[t+308>>2]=34,i[t+312>>2]=-2147483608,n=l[16560]|l[16561]<<8|(l[16562]<<16|l[16563]<<24),k=l[16556]|l[16557]<<8|(l[16558]<<16|l[16559]<<24),u[r|0]=k,u[r+1|0]=k>>>8,u[r+2|0]=k>>>16,u[r+3|0]=k>>>24,u[r+4|0]=n,u[r+5|0]=n>>>8,u[r+6|0]=n>>>16,u[r+7|0]=n>>>24,u[r+34|0]=0,n=l[16588]|l[16589]<<8,u[r+32|0]=n,u[r+33|0]=n>>>8,n=l[16584]|l[16585]<<8|(l[16586]<<16|l[16587]<<24),k=l[16580]|l[16581]<<8|(l[16582]<<16|l[16583]<<24),u[r+24|0]=k,u[r+25|0]=k>>>8,u[r+26|0]=k>>>16,u[r+27|0]=k>>>24,u[r+28|0]=n,u[r+29|0]=n>>>8,u[r+30|0]=n>>>16,u[r+31|0]=n>>>24,n=l[16576]|l[16577]<<8|(l[16578]<<16|l[16579]<<24),k=l[16572]|l[16573]<<8|(l[16574]<<16|l[16575]<<24),u[r+16|0]=k,u[r+17|0]=k>>>8,u[r+18|0]=k>>>16,u[r+19|0]=k>>>24,u[r+20|0]=n,u[r+21|0]=n>>>8,u[r+22|0]=n>>>16,u[r+23|0]=n>>>24,n=l[16568]|l[16569]<<8|(l[16570]<<16|l[16571]<<24),k=l[16564]|l[16565]<<8|(l[16566]<<16|l[16567]<<24),u[r+8|0]=k,u[r+9|0]=k>>>8,u[r+10|0]=k>>>16,u[r+11|0]=k>>>24,u[r+12|0]=n,u[r+13|0]=n>>>8,u[r+14|0]=n>>>16,u[r+15|0]=n>>>24,q(A,2,2e3,t+304|0),u[t+315|0]>=0)break o;Z(i[t+304>>2]);break o}r=i[h+136>>2],s=i[h+140>>2];m:{if(r>>>0<s>>>0){i[r>>2]=B,n=i[o+24>>2],i[r+4>>2]=n,n&&(i[n+4>>2]=i[n+4>>2]+1),k=r+8|0;break m}if(B=i[h+132>>2],k=r-B|0,n=k>>3,r=n+1|0,r>>>0>=536870912)break i;if(s=s-B|0,X=s>>2,r=s>>>0>=2147483640?536870911:r>>>0<X>>>0?X:r,r>>>0>=536870912)break Z;if(X=r<<3,V=p(X),r=V+k|0,i[r>>2]=i[o+20>>2],s=i[o+24>>2],i[r+4>>2]=s,s&&(i[s+4>>2]=i[s+4>>2]+1,B=i[h+132>>2],k=i[h+136>>2]-B|0,n=k>>3),n=r-(n<<3)|0,k&&x(n,B,k),i[h+140>>2]=X+V,k=r+8|0,i[h+136>>2]=k,i[h+132>>2]=n,!B)break m;Z(B)}if(i[h+136>>2]=k,w=w+4|0,(_|0)==(w|0))break}xr(e,E),Z(f);break w}m:{X:{W:{F:{V:{if(f=i[E>>2],r=i[f+104>>2],f=i[f+108>>2],(r|0)!=(f|0))for(;;){C:{if(n=i[r>>2],!n||(X=W0(n,86580,87812),!X))break C;if(N=i[r+4>>2],N&&(i[N+4>>2]=i[N+4>>2]+1),w=0,i[t+160>>2]=0,i[t+152>>2]=0,i[t+156>>2]=0,h=0,r=i[m+48>>2],f=i[m+44>>2],(r|0)!=(f|0)){if(r=r-f|0,(r|0)<0)break i;h=p(r),i[t+152>>2]=h,w=r+h|0,i[t+160>>2]=w,r&&x(h,f,r),i[t+156>>2]=w}switch(V=X+104|0,r=u[X+115|0],f=(r|0)<0,k=i[X+108>>2],n=f?k:r,n-25|0){case 0:break V;case 1:break F;case 18:break W;default:break m}}if(r=r+8|0,(f|0)==(r|0))break}i[t+244>>2]=0,i[t+152>>2]=_0,i[t+216>>2]=72196,i[t+160>>2]=72176,r=t+152|0,i[r+i[U0>>2]>>2]=K0,i[t+156>>2]=0,f=r+i[i[t+152>>2]-12>>2]|0,J0(f,S),u[f+80|0]=0,i[f+72>>2]=0,i[t+160>>2]=n0,i[a+i[N0>>2]>>2]=P0,i[t+152>>2]=A0,i[r+i[r0>>2]>>2]=H0,i[t+216>>2]=72196,i[t+152>>2]=72156,i[t+160>>2]=72176,n=R0(S),i[n>>2]=71232,i[t+204>>2]=0,i[t+208>>2]=0,i[t+196>>2]=0,i[t+200>>2]=0,i[t+212>>2]=24,V0(Y(a,28837,27),i[i[E>>2]+116>>2]),r=i[t+212>>2];C:{if(r&16){if(r=I,B=i[t+208>>2],f=i[t+188>>2],B>>>0>=f>>>0)break C;i[t+208>>2]=f,B=f;break C}if(!(r&8)){r=0,u[t+315|0]=0,B=t+304|0;break l}B=i[t+180>>2],r=Q}if(f=i[r>>2],r=B-f|0,r>>>0>=2147483640)break v;if(r>>>0>=11){k=r|7,B=p(k+1|0),i[t+312>>2]=k-2147483647,i[t+304>>2]=B,i[t+308>>2]=r;break s}if(u[t+315|0]=r,B=t+304|0,r)break s;r=0;break l}if(N2(f?i[V>>2]:V,21797,25))break m;if((w|0)!=(h|0))break X;break m}if(N2(f?i[V>>2]:V,21770,n))break m;if((w|0)!=(h|0))break X;break m}if(N2(f?i[V>>2]:V,19026,n)|(w|0)==(h|0))break m}for(;;){f=i[h>>2];X:{W:{k=F,r=i[k>>2];F:{if(!r)break F;for(;n=f>>>0>u0[r+16>>2],k=n?k:r,r=i[(n?4:0)+r>>2],!!r;);if((k|0)==(F|0))break F;if(f>>>0>=u0[k+16>>2])break W}if(ar(i[e+48>>2],f))break X;r=p(40),i[t+304>>2]=r,i[t+308>>2]=35,i[t+312>>2]=-2147483608,f=l[17757]|l[17758]<<8|(l[17759]<<16|l[17760]<<24),n=l[17753]|l[17754]<<8|(l[17755]<<16|l[17756]<<24),u[r|0]=n,u[r+1|0]=n>>>8,u[r+2|0]=n>>>16,u[r+3|0]=n>>>24,u[r+4|0]=f,u[r+5|0]=f>>>8,u[r+6|0]=f>>>16,u[r+7|0]=f>>>24,u[r+35|0]=0,f=l[17784]|l[17785]<<8|(l[17786]<<16|l[17787]<<24),u[r+31|0]=f,u[r+32|0]=f>>>8,u[r+33|0]=f>>>16,u[r+34|0]=f>>>24,f=l[17781]|l[17782]<<8|(l[17783]<<16|l[17784]<<24),n=l[17777]|l[17778]<<8|(l[17779]<<16|l[17780]<<24),u[r+24|0]=n,u[r+25|0]=n>>>8,u[r+26|0]=n>>>16,u[r+27|0]=n>>>24,u[r+28|0]=f,u[r+29|0]=f>>>8,u[r+30|0]=f>>>16,u[r+31|0]=f>>>24,f=l[17773]|l[17774]<<8|(l[17775]<<16|l[17776]<<24),n=l[17769]|l[17770]<<8|(l[17771]<<16|l[17772]<<24),u[r+16|0]=n,u[r+17|0]=n>>>8,u[r+18|0]=n>>>16,u[r+19|0]=n>>>24,u[r+20|0]=f,u[r+21|0]=f>>>8,u[r+22|0]=f>>>16,u[r+23|0]=f>>>24,f=l[17765]|l[17766]<<8|(l[17767]<<16|l[17768]<<24),n=l[17761]|l[17762]<<8|(l[17763]<<16|l[17764]<<24),u[r+8|0]=n,u[r+9|0]=n>>>8,u[r+10|0]=n>>>16,u[r+11|0]=n>>>24,u[r+12|0]=f,u[r+13|0]=f>>>8,u[r+14|0]=f>>>16,u[r+15|0]=f>>>24,q(A,2,2e3,t+304|0),u[t+315|0]<0&&Z(i[t+304>>2]),r=0;break h}n=i[k+20>>2],f=i[k+24>>2],f&&(i[f+4>>2]=i[f+4>>2]+1),B=i[E>>2];W:{if((B|0)==(n|0)){if(r=p(32),i[t+304>>2]=r,i[t+308>>2]=30,i[t+312>>2]=-2147483616,k=l[16626]|l[16627]<<8|(l[16628]<<16|l[16629]<<24),s=l[16622]|l[16623]<<8|(l[16624]<<16|l[16625]<<24),u[r|0]=s,u[r+1|0]=s>>>8,u[r+2|0]=s>>>16,u[r+3|0]=s>>>24,u[r+4|0]=k,u[r+5|0]=k>>>8,u[r+6|0]=k>>>16,u[r+7|0]=k>>>24,u[r+30|0]=0,k=l[16648]|l[16649]<<8|(l[16650]<<16|l[16651]<<24),s=l[16644]|l[16645]<<8|(l[16646]<<16|l[16647]<<24),u[r+22|0]=s,u[r+23|0]=s>>>8,u[r+24|0]=s>>>16,u[r+25|0]=s>>>24,u[r+26|0]=k,u[r+27|0]=k>>>8,u[r+28|0]=k>>>16,u[r+29|0]=k>>>24,k=l[16642]|l[16643]<<8|(l[16644]<<16|l[16645]<<24),s=l[16638]|l[16639]<<8|(l[16640]<<16|l[16641]<<24),u[r+16|0]=s,u[r+17|0]=s>>>8,u[r+18|0]=s>>>16,u[r+19|0]=s>>>24,u[r+20|0]=k,u[r+21|0]=k>>>8,u[r+22|0]=k>>>16,u[r+23|0]=k>>>24,k=l[16634]|l[16635]<<8|(l[16636]<<16|l[16637]<<24),s=l[16630]|l[16631]<<8|(l[16632]<<16|l[16633]<<24),u[r+8|0]=s,u[r+9|0]=s>>>8,u[r+10|0]=s>>>16,u[r+11|0]=s>>>24,u[r+12|0]=k,u[r+13|0]=k>>>8,u[r+14|0]=k>>>16,u[r+15|0]=k>>>24,q(A,2,2e3,t+304|0),u[t+315|0]>=0)break W;Z(i[t+304>>2]);break W}if(u[B+144|0]=1,k=i[o+24>>2],k&&(i[k+4>>2]=i[k+4>>2]+1),i[n+148>>2]=B,r=i[n+152>>2],i[n+152>>2]=k,!r||(k=i[r+4>>2],i[r+4>>2]=k-1,k))break W;W[i[i[r>>2]+8>>2]](r),y(r)}W:{if(!f||(r=i[f+4>>2],i[f+4>>2]=r-1,r))break W;W[i[i[f>>2]+8>>2]](f),y(f)}if((n|0)!=(B|0))break X;r=0;break h}if(h=h+4|0,(w|0)==(h|0))break}r=l[X+115|0],k=i[X+108>>2]}m:{X:{if(f=r,r=r<<24>>24<0,f=(r?k:f)-26|0,f){if((f|0)==17)break X;break B}if(!N2(r?i[V>>2]:V,21524,26))break m;break B}if(N2(r?i[V>>2]:V,10671,43))break B}if(u[i[E>>2]+156|0]=1,h=i[t+152>>2],g0=i[t+156>>2],(h|0)==(g0|0))break B;for(;;){m:{f=i[h>>2];X:{W:{k=F,r=i[k>>2];F:{if(!r)break F;for(;n=f>>>0>u0[r+16>>2],k=n?k:r,r=i[(n?4:0)+r>>2],!!r;);if((k|0)==(F|0))break F;if(f>>>0>=u0[k+16>>2])break W}if(ar(i[e+48>>2],f))break X;r=p(40),i[t+304>>2]=r,i[t+308>>2]=35,i[t+312>>2]=-2147483608,f=l[17687]|l[17688]<<8|(l[17689]<<16|l[17690]<<24),n=l[17683]|l[17684]<<8|(l[17685]<<16|l[17686]<<24),u[r|0]=n,u[r+1|0]=n>>>8,u[r+2|0]=n>>>16,u[r+3|0]=n>>>24,u[r+4|0]=f,u[r+5|0]=f>>>8,u[r+6|0]=f>>>16,u[r+7|0]=f>>>24,u[r+35|0]=0,f=l[17714]|l[17715]<<8|(l[17716]<<16|l[17717]<<24),u[r+31|0]=f,u[r+32|0]=f>>>8,u[r+33|0]=f>>>16,u[r+34|0]=f>>>24,f=l[17711]|l[17712]<<8|(l[17713]<<16|l[17714]<<24),n=l[17707]|l[17708]<<8|(l[17709]<<16|l[17710]<<24),u[r+24|0]=n,u[r+25|0]=n>>>8,u[r+26|0]=n>>>16,u[r+27|0]=n>>>24,u[r+28|0]=f,u[r+29|0]=f>>>8,u[r+30|0]=f>>>16,u[r+31|0]=f>>>24,f=l[17703]|l[17704]<<8|(l[17705]<<16|l[17706]<<24),n=l[17699]|l[17700]<<8|(l[17701]<<16|l[17702]<<24),u[r+16|0]=n,u[r+17|0]=n>>>8,u[r+18|0]=n>>>16,u[r+19|0]=n>>>24,u[r+20|0]=f,u[r+21|0]=f>>>8,u[r+22|0]=f>>>16,u[r+23|0]=f>>>24,f=l[17695]|l[17696]<<8|(l[17697]<<16|l[17698]<<24),n=l[17691]|l[17692]<<8|(l[17693]<<16|l[17694]<<24),u[r+8|0]=n,u[r+9|0]=n>>>8,u[r+10|0]=n>>>16,u[r+11|0]=n>>>24,u[r+12|0]=f,u[r+13|0]=f>>>8,u[r+14|0]=f>>>16,u[r+15|0]=f>>>24,q(A,2,2e3,t+304|0),u[t+315|0]<0&&Z(i[t+304>>2]),r=0;break h}if(r=i[E>>2],f=i[k+20>>2],(r|0)==(f|0)){r=p(32),i[t+304>>2]=r,i[t+308>>2]=30,i[t+312>>2]=-2147483616,f=l[16595]|l[16596]<<8|(l[16597]<<16|l[16598]<<24),n=l[16591]|l[16592]<<8|(l[16593]<<16|l[16594]<<24),u[r|0]=n,u[r+1|0]=n>>>8,u[r+2|0]=n>>>16,u[r+3|0]=n>>>24,u[r+4|0]=f,u[r+5|0]=f>>>8,u[r+6|0]=f>>>16,u[r+7|0]=f>>>24,u[r+30|0]=0,f=l[16617]|l[16618]<<8|(l[16619]<<16|l[16620]<<24),n=l[16613]|l[16614]<<8|(l[16615]<<16|l[16616]<<24),u[r+22|0]=n,u[r+23|0]=n>>>8,u[r+24|0]=n>>>16,u[r+25|0]=n>>>24,u[r+26|0]=f,u[r+27|0]=f>>>8,u[r+28|0]=f>>>16,u[r+29|0]=f>>>24,f=l[16611]|l[16612]<<8|(l[16613]<<16|l[16614]<<24),n=l[16607]|l[16608]<<8|(l[16609]<<16|l[16610]<<24),u[r+16|0]=n,u[r+17|0]=n>>>8,u[r+18|0]=n>>>16,u[r+19|0]=n>>>24,u[r+20|0]=f,u[r+21|0]=f>>>8,u[r+22|0]=f>>>16,u[r+23|0]=f>>>24,f=l[16603]|l[16604]<<8|(l[16605]<<16|l[16606]<<24),n=l[16599]|l[16600]<<8|(l[16601]<<16|l[16602]<<24),u[r+8|0]=n,u[r+9|0]=n>>>8,u[r+10|0]=n>>>16,u[r+11|0]=n>>>24,u[r+12|0]=f,u[r+13|0]=f>>>8,u[r+14|0]=f>>>16,u[r+15|0]=f>>>24,q(A,2,2e3,t+304|0),u[t+315|0]<0&&Z(i[t+304>>2]),r=0;break h}n=i[o+24>>2],n&&(i[n+4>>2]=i[n+4>>2]+1),i[f+160>>2]=r,r=i[f+164>>2],i[f+164>>2]=n;W:{if(!r||(f=i[r+4>>2],i[r+4>>2]=f-1,f))break W;W[i[i[r>>2]+8>>2]](r),y(r)}if(i[X+116>>2]==i[X+120>>2])break X;i[t+312>>2]=0,i[t+304>>2]=0,i[t+308>>2]=0,I0=t+304|0,n=v-112|0,v=n,r=i[X+116>>2],f=ei(n- -64|0,r,i[X+120>>2]-r|0),r=i[f+12>>2],w=r>>31<<3|r>>>29,k=i[f+24>>2],r=k+(r<<3)|0,s=(k>>31)+w|0;W:{F:{s=r>>>0<k>>>0?s+1|0:s;V:{if((s|0)<=0&r>>>0<=31|(s|0)<0){if(r=p(24),i[n+32>>2]=r,i[n+36>>2]=22,i[n+40>>2]=-2147483624,f=l[3673]|l[3674]<<8|(l[3675]<<16|l[3676]<<24),k=l[3669]|l[3670]<<8|(l[3671]<<16|l[3672]<<24),u[r|0]=k,u[r+1|0]=k>>>8,u[r+2|0]=k>>>16,u[r+3|0]=k>>>24,u[r+4|0]=f,u[r+5|0]=f>>>8,u[r+6|0]=f>>>16,u[r+7|0]=f>>>24,u[r+22|0]=0,f=l[3687]|l[3688]<<8|(l[3689]<<16|l[3690]<<24),k=l[3683]|l[3684]<<8|(l[3685]<<16|l[3686]<<24),u[r+14|0]=k,u[r+15|0]=k>>>8,u[r+16|0]=k>>>16,u[r+17|0]=k>>>24,u[r+18|0]=f,u[r+19|0]=f>>>8,u[r+20|0]=f>>>16,u[r+21|0]=f>>>24,f=l[3681]|l[3682]<<8|(l[3683]<<16|l[3684]<<24),k=l[3677]|l[3678]<<8|(l[3679]<<16|l[3680]<<24),u[r+8|0]=k,u[r+9|0]=k>>>8,u[r+10|0]=k>>>16,u[r+11|0]=k>>>24,u[r+12|0]=f,u[r+13|0]=f>>>8,u[r+14|0]=f>>>16,u[r+15|0]=f>>>24,q(A,2,100,n+32|0),u[n+43|0]>=0)break V;Z(i[n+32>>2]);break V}k=i2(f,32),r=(i[f+8>>2]-i[f+12>>2]|0)+(i[f+24>>2]/-8|0)|0;C:{if((k|0)<=(r|0))break C;if(r=r+i[X+116>>2]|0,k=ei(n+32|0,r,i[X+120>>2]-r|0),r=i[k+12>>2],s=r>>31<<3|r>>>29,f=i[k+24>>2],r=f+(r<<3)|0,_=(f>>31)+s|0,_=r>>>0<f>>>0?_+1|0:_,(_|0)<=0&r>>>0<=39|(_|0)<0){if(r=p(24),i[n+8>>2]=r,i[n+12>>2]=22,i[n+16>>2]=-2147483624,f=l[3673]|l[3674]<<8|(l[3675]<<16|l[3676]<<24),k=l[3669]|l[3670]<<8|(l[3671]<<16|l[3672]<<24),u[r|0]=k,u[r+1|0]=k>>>8,u[r+2|0]=k>>>16,u[r+3|0]=k>>>24,u[r+4|0]=f,u[r+5|0]=f>>>8,u[r+6|0]=f>>>16,u[r+7|0]=f>>>24,u[r+22|0]=0,f=l[3687]|l[3688]<<8|(l[3689]<<16|l[3690]<<24),k=l[3683]|l[3684]<<8|(l[3685]<<16|l[3686]<<24),u[r+14|0]=k,u[r+15|0]=k>>>8,u[r+16|0]=k>>>16,u[r+17|0]=k>>>24,u[r+18|0]=f,u[r+19|0]=f>>>8,u[r+20|0]=f>>>16,u[r+21|0]=f>>>24,f=l[3681]|l[3682]<<8|(l[3683]<<16|l[3684]<<24),k=l[3677]|l[3678]<<8|(l[3679]<<16|l[3680]<<24),u[r+8|0]=k,u[r+9|0]=k>>>8,u[r+10|0]=k>>>16,u[r+11|0]=k>>>24,u[r+12|0]=f,u[r+13|0]=f>>>8,u[r+14|0]=f>>>16,u[r+15|0]=f>>>24,q(A,2,100,n+8|0),u[n+19|0]>=0)break V;Z(i[n+8>>2]);break V}if(i2(k,32),r=I1(k,8),V2(k,8),((r>>>1|0)-39&255)>>>0>1)break C;if(r=i[k+24>>2],f=r,w=r>>31,r=i[k+12>>2],_=r>>31<<3|r>>>29,s=f,f=r<<3,r=s+f|0,w=w+_|0,w=r>>>0<f>>>0?w+1|0:w,(w|0)<=0&r>>>0<=15|(w|0)<0){if(r=p(24),i[n+8>>2]=r,i[n+12>>2]=22,i[n+16>>2]=-2147483624,f=l[3673]|l[3674]<<8|(l[3675]<<16|l[3676]<<24),k=l[3669]|l[3670]<<8|(l[3671]<<16|l[3672]<<24),u[r|0]=k,u[r+1|0]=k>>>8,u[r+2|0]=k>>>16,u[r+3|0]=k>>>24,u[r+4|0]=f,u[r+5|0]=f>>>8,u[r+6|0]=f>>>16,u[r+7|0]=f>>>24,u[r+22|0]=0,f=l[3687]|l[3688]<<8|(l[3689]<<16|l[3690]<<24),k=l[3683]|l[3684]<<8|(l[3685]<<16|l[3686]<<24),u[r+14|0]=k,u[r+15|0]=k>>>8,u[r+16|0]=k>>>16,u[r+17|0]=k>>>24,u[r+18|0]=f,u[r+19|0]=f>>>8,u[r+20|0]=f>>>16,u[r+21|0]=f>>>24,f=l[3681]|l[3682]<<8|(l[3683]<<16|l[3684]<<24),k=l[3677]|l[3678]<<8|(l[3679]<<16|l[3680]<<24),u[r+8|0]=k,u[r+9|0]=k>>>8,u[r+10|0]=k>>>16,u[r+11|0]=k>>>24,u[r+12|0]=f,u[r+13|0]=f>>>8,u[r+14|0]=f>>>16,u[r+15|0]=f>>>24,q(A,2,100,n+8|0),u[n+19|0]>=0)break V;Z(i[n+8>>2]);break V}if(r=I1(k,8),I1(k,8),(r|0)!=177)break C;B=n+8|0,w=v-48|0,v=w,r=p(80),i[r+16>>2]=0,i[r+20>>2]=0,i[r+24>>2]=0,i[r+28>>2]=0,i[r+4>>2]=0,i[r+8>>2]=0,i[r+72>>2]=0,i[r+76>>2]=0,i[r>>2]=97584,i[r+16>>2]=97624,i[r+32>>2]=0,i[r+36>>2]=0,i[r+40>>2]=0,i[r+44>>2]=0,i[r+48>>2]=0,i[r+52>>2]=0,i[r+56>>2]=0,i[r+60>>2]=0,f=r- -64|0,i[f>>2]=0,i[f+4>>2]=0,u[r+24|0]=1,f=i2(k,1),u[r+25|0]=f,d0=r,n2=i2(k,1),u[d0+26|0]=n2,s=i2(k,1),u[r+27|0]=s,_=i2(k,1),u[r+28|0]=_;g:{if(!$2(k,w+44|0)){f=p(48),i[w+12>>2]=f,i[w+16>>2]=42,i[w+20>>2]=-2147483600,k=l[3289]|l[3290]<<8,u[f+40|0]=k,u[f+41|0]=k>>>8,k=l[3285]|l[3286]<<8|(l[3287]<<16|l[3288]<<24),s=l[3281]|l[3282]<<8|(l[3283]<<16|l[3284]<<24),u[f+32|0]=s,u[f+33|0]=s>>>8,u[f+34|0]=s>>>16,u[f+35|0]=s>>>24,u[f+36|0]=k,u[f+37|0]=k>>>8,u[f+38|0]=k>>>16,u[f+39|0]=k>>>24,k=l[3277]|l[3278]<<8|(l[3279]<<16|l[3280]<<24),s=l[3273]|l[3274]<<8|(l[3275]<<16|l[3276]<<24),u[f+24|0]=s,u[f+25|0]=s>>>8,u[f+26|0]=s>>>16,u[f+27|0]=s>>>24,u[f+28|0]=k,u[f+29|0]=k>>>8,u[f+30|0]=k>>>16,u[f+31|0]=k>>>24,k=l[3269]|l[3270]<<8|(l[3271]<<16|l[3272]<<24),s=l[3265]|l[3266]<<8|(l[3267]<<16|l[3268]<<24),u[f+16|0]=s,u[f+17|0]=s>>>8,u[f+18|0]=s>>>16,u[f+19|0]=s>>>24,u[f+20|0]=k,u[f+21|0]=k>>>8,u[f+22|0]=k>>>16,u[f+23|0]=k>>>24,k=l[3261]|l[3262]<<8|(l[3263]<<16|l[3264]<<24),s=l[3257]|l[3258]<<8|(l[3259]<<16|l[3260]<<24),u[f+8|0]=s,u[f+9|0]=s>>>8,u[f+10|0]=s>>>16,u[f+11|0]=s>>>24,u[f+12|0]=k,u[f+13|0]=k>>>8,u[f+14|0]=k>>>16,u[f+15|0]=k>>>24,k=l[3253]|l[3254]<<8|(l[3255]<<16|l[3256]<<24),s=l[3249]|l[3250]<<8|(l[3251]<<16|l[3252]<<24),u[f|0]=s,u[f+1|0]=s>>>8,u[f+2|0]=s>>>16,u[f+3|0]=s>>>24,u[f+4|0]=k,u[f+5|0]=k>>>8,u[f+6|0]=k>>>16,u[f+7|0]=k>>>24,u[f+42|0]=0,f=q(w+24|0,2,2006,w+12|0),k=i[f+4>>2],i[B>>2]=i[f>>2],i[B+4>>2]=k,k=B+8|0;I:{if(u[f+19|0]>=0){s=i[f+12>>2],i[k>>2]=i[f+8>>2],i[k+4>>2]=s,i[k+8>>2]=i[f+16>>2],u[B+20|0]=1;break I}if(T(k,i[f+8>>2],i[f+12>>2]),k=u[f+19|0],u[B+20|0]=1,(k|0)>=0)break I;Z(i[f+8>>2])}if(u[w+23|0]>=0)break g;Z(i[w+12>>2]);break g}if(e0=i[w+44>>2],e0>>>0>=4){f=p(48),i[w+12>>2]=f,i[w+16>>2]=44,i[w+20>>2]=-2147483600,k=l[14015]|l[14016]<<8|(l[14017]<<16|l[14018]<<24),u[f+40|0]=k,u[f+41|0]=k>>>8,u[f+42|0]=k>>>16,u[f+43|0]=k>>>24,k=l[14011]|l[14012]<<8|(l[14013]<<16|l[14014]<<24),s=l[14007]|l[14008]<<8|(l[14009]<<16|l[14010]<<24),u[f+32|0]=s,u[f+33|0]=s>>>8,u[f+34|0]=s>>>16,u[f+35|0]=s>>>24,u[f+36|0]=k,u[f+37|0]=k>>>8,u[f+38|0]=k>>>16,u[f+39|0]=k>>>24,k=l[14003]|l[14004]<<8|(l[14005]<<16|l[14006]<<24),s=l[13999]|l[14e3]<<8|(l[14001]<<16|l[14002]<<24),u[f+24|0]=s,u[f+25|0]=s>>>8,u[f+26|0]=s>>>16,u[f+27|0]=s>>>24,u[f+28|0]=k,u[f+29|0]=k>>>8,u[f+30|0]=k>>>16,u[f+31|0]=k>>>24,k=l[13995]|l[13996]<<8|(l[13997]<<16|l[13998]<<24),s=l[13991]|l[13992]<<8|(l[13993]<<16|l[13994]<<24),u[f+16|0]=s,u[f+17|0]=s>>>8,u[f+18|0]=s>>>16,u[f+19|0]=s>>>24,u[f+20|0]=k,u[f+21|0]=k>>>8,u[f+22|0]=k>>>16,u[f+23|0]=k>>>24,k=l[13987]|l[13988]<<8|(l[13989]<<16|l[13990]<<24),s=l[13983]|l[13984]<<8|(l[13985]<<16|l[13986]<<24),u[f+8|0]=s,u[f+9|0]=s>>>8,u[f+10|0]=s>>>16,u[f+11|0]=s>>>24,u[f+12|0]=k,u[f+13|0]=k>>>8,u[f+14|0]=k>>>16,u[f+15|0]=k>>>24,k=l[13979]|l[13980]<<8|(l[13981]<<16|l[13982]<<24),s=l[13975]|l[13976]<<8|(l[13977]<<16|l[13978]<<24),u[f|0]=s,u[f+1|0]=s>>>8,u[f+2|0]=s>>>16,u[f+3|0]=s>>>24,u[f+4|0]=k,u[f+5|0]=k>>>8,u[f+6|0]=k>>>16,u[f+7|0]=k>>>24,u[f+44|0]=0,f=q(w+24|0,2,2006,w+12|0),k=i[f+4>>2],i[B>>2]=i[f>>2],i[B+4>>2]=k,k=B+8|0;I:{if(u[f+19|0]>=0){s=i[f+12>>2],i[k>>2]=i[f+8>>2],i[k+4>>2]=s,i[k+8>>2]=i[f+16>>2],u[B+20|0]=1;break I}if(T(k,i[f+8>>2],i[f+12>>2]),k=u[f+19|0],u[B+20|0]=1,(k|0)>=0)break I;Z(i[f+8>>2])}if(u[w+23|0]>=0)break g;Z(i[w+12>>2]);break g}if(i[r+64>>2]=e0,(s|_)&255){if(!$2(k,w+8|0)){f=p(48),i[w+12>>2]=f,i[w+16>>2]=41,i[w+20>>2]=-2147483600,u[f+40|0]=l[3247],k=l[3243]|l[3244]<<8|(l[3245]<<16|l[3246]<<24),s=l[3239]|l[3240]<<8|(l[3241]<<16|l[3242]<<24),u[f+32|0]=s,u[f+33|0]=s>>>8,u[f+34|0]=s>>>16,u[f+35|0]=s>>>24,u[f+36|0]=k,u[f+37|0]=k>>>8,u[f+38|0]=k>>>16,u[f+39|0]=k>>>24,k=l[3235]|l[3236]<<8|(l[3237]<<16|l[3238]<<24),s=l[3231]|l[3232]<<8|(l[3233]<<16|l[3234]<<24),u[f+24|0]=s,u[f+25|0]=s>>>8,u[f+26|0]=s>>>16,u[f+27|0]=s>>>24,u[f+28|0]=k,u[f+29|0]=k>>>8,u[f+30|0]=k>>>16,u[f+31|0]=k>>>24,k=l[3227]|l[3228]<<8|(l[3229]<<16|l[3230]<<24),s=l[3223]|l[3224]<<8|(l[3225]<<16|l[3226]<<24),u[f+16|0]=s,u[f+17|0]=s>>>8,u[f+18|0]=s>>>16,u[f+19|0]=s>>>24,u[f+20|0]=k,u[f+21|0]=k>>>8,u[f+22|0]=k>>>16,u[f+23|0]=k>>>24,k=l[3219]|l[3220]<<8|(l[3221]<<16|l[3222]<<24),s=l[3215]|l[3216]<<8|(l[3217]<<16|l[3218]<<24),u[f+8|0]=s,u[f+9|0]=s>>>8,u[f+10|0]=s>>>16,u[f+11|0]=s>>>24,u[f+12|0]=k,u[f+13|0]=k>>>8,u[f+14|0]=k>>>16,u[f+15|0]=k>>>24,k=l[3211]|l[3212]<<8|(l[3213]<<16|l[3214]<<24),s=l[3207]|l[3208]<<8|(l[3209]<<16|l[3210]<<24),u[f|0]=s,u[f+1|0]=s>>>8,u[f+2|0]=s>>>16,u[f+3|0]=s>>>24,u[f+4|0]=k,u[f+5|0]=k>>>8,u[f+6|0]=k>>>16,u[f+7|0]=k>>>24,u[f+41|0]=0,f=q(w+24|0,2,2006,w+12|0),k=i[f+4>>2],i[B>>2]=i[f>>2],i[B+4>>2]=k,k=B+8|0;I:{if(u[f+19|0]>=0){s=i[f+12>>2],i[k>>2]=i[f+8>>2],i[k+4>>2]=s,i[k+8>>2]=i[f+16>>2],u[B+20|0]=1;break I}if(T(k,i[f+8>>2],i[f+12>>2]),k=u[f+19|0],u[B+20|0]=1,(k|0)>=0)break I;Z(i[f+8>>2])}if(u[w+23|0]>=0)break g;Z(i[w+12>>2]);break g}i[r+68>>2]=i[w+8>>2],f=l[r+25|0]}if(f&255){_=I1(k,1),f=i2(k,7),s=I1(k,5)+1&255,M=+(i2(k,s)>>>0);I:{if((f|0)>0){P=A4(1,s),M=A4(1,f-31|0)*(M/P+1);break I}M=A4(1,-30-s|0)*M}t0[r+32>>3]=_?-M:M}if(l[r+26|0]){_=I1(k,1),f=i2(k,7),s=I1(k,5)+1&255,M=+(i2(k,s)>>>0);I:{if((f|0)>0){P=A4(1,s),M=A4(1,f-31|0)*(M/P+1);break I}M=A4(1,-30-s|0)*M}t0[r+40>>3]=_?-M:M}if(l[r+27|0]){_=I1(k,1),f=i2(k,7),s=I1(k,5)+1&255,M=+(i2(k,s)>>>0);I:{if((f|0)>0){P=A4(1,s),M=A4(1,f-31|0)*(M/P+1);break I}M=A4(1,-30-s|0)*M}t0[r+48>>3]=_?-M:M}if(l[r+28|0]){s=I1(k,1),f=i2(k,7),_=k,k=I1(k,5)+1&255,M=+(i2(_,k)>>>0);I:{if((f|0)>0){P=A4(1,k),M=A4(1,f-31|0)*(M/P+1);break I}M=A4(1,-30-k|0)*M}t0[r+56>>3]=s?-M:M}i[r+4>>2]=i[r+4>>2]+1,u[B+20|0]=0,i[B+4>>2]=r,i[B>>2]=r+16}f=i[r+4>>2],i[r+4>>2]=f-1,f||(W[i[i[r>>2]+8>>2]](r),y(r)),v=w+48|0,r=l[n+28|0];g:{if(r){if((r|0)!=1)break F;k8(A,B);break g}r2(I0,n+8|0)}if(f=l[n+28|0],(f|0)!=255&&(k=i[24409],i[n+104>>2]=i[24408],i[n+108>>2]=k,W[i[(n+104|0)+(f<<2)>>2]](n+103|0,n+8|0)),r)break V}if(r=i[26917],i[A>>2]=i[26916],i[A+4>>2]=r,r=A+8|0,u[107683]>=0){f=i[26919],i[r>>2]=i[26918],i[r+4>>2]=f,i[r+8>>2]=i[26920];break V}T(r,i[26918],i[26919])}v=n+112|0;break W}_2(),H()}if(r=i[t+304>>2],i[A>>2])break m;if(w=i[t+308>>2],(w|0)!=(r|0))for(;;){f=i[r>>2];W:{if(!f||(f=W0(f,94668,94676),!f))break W;if(k=i[r+4>>2],!k){n=i[E>>2],u[n+168|0]=1,k=i[f+12>>2],i[n+176>>2]=i[f+8>>2],i[n+180>>2]=k,k=i[f+20>>2],i[n+184>>2]=i[f+16>>2],i[n+188>>2]=k,k=i[f+28>>2],i[n+192>>2]=i[f+24>>2],i[n+196>>2]=k,k=i[f+36>>2],i[n+200>>2]=i[f+32>>2],i[n+204>>2]=k,k=i[f+44>>2],i[n+208>>2]=i[f+40>>2],i[n+212>>2]=k,k=i[f+52>>2],i[n+216>>2]=i[f+48>>2],i[n+220>>2]=k,k=i[f+60>>2],i[n+224>>2]=i[f+56>>2],i[n+228>>2]=k;break W}if(i[k+4>>2]=i[k+4>>2]+1,n=i[E>>2],u[n+168|0]=1,B=i[f+12>>2],i[n+176>>2]=i[f+8>>2],i[n+180>>2]=B,B=i[f+20>>2],i[n+184>>2]=i[f+16>>2],i[n+188>>2]=B,B=i[f+28>>2],i[n+192>>2]=i[f+24>>2],i[n+196>>2]=B,B=i[f+36>>2],i[n+200>>2]=i[f+32>>2],i[n+204>>2]=B,B=i[f+44>>2],i[n+208>>2]=i[f+40>>2],i[n+212>>2]=B,B=i[f+52>>2],i[n+216>>2]=i[f+48>>2],i[n+220>>2]=B,B=i[f+60>>2],i[n+224>>2]=i[f+56>>2],i[n+228>>2]=B,f=i[k+4>>2],i[k+4>>2]=f-1,f)break W;W[i[i[k>>2]+8>>2]](k),y(k)}if(r=r+8|0,(w|0)==(r|0))break}if(u[A+19|0]<0&&Z(i[A+8>>2]),f=i[t+304>>2],!f)break X;if(r=i[t+308>>2],k=f,(r|0)!=(f|0)){for(;;){n=i[r-4>>2];W:{if(!n||(k=i[n+4>>2],i[n+4>>2]=k-1,k))break W;W[i[i[n>>2]+8>>2]](n),y(n)}if(r=r-8|0,(f|0)==(r|0))break}k=i[t+304>>2]}i[t+308>>2]=f,Z(k)}if(h=h+4|0,(g0|0)!=(h|0))continue;break B}break}if(r){if(B=r,k=i[t+308>>2],(k|0)!=(r|0)){for(;;){f=i[k-4>>2];m:{if(!f||(n=i[f+4>>2],i[f+4>>2]=n-1,n))break m;W[i[i[f>>2]+8>>2]](f),y(f)}if(k=k-8|0,(k|0)==(r|0))break}B=i[t+304>>2]}i[t+308>>2]=r,Z(B)}r=0;break h}xr(e,E);break w}z0(),H()}Q0(),H()}n=i[E>>2],u[n+232|0]=1,r=n+236|0;B:{if((r|0)==(V|0))break B;if(f=u[X+115|0],u[n+247|0]>=0){if((f|0)>=0){f=i[V+4>>2],i[r>>2]=i[V>>2],i[r+4>>2]=f,i[r+8>>2]=i[V+8>>2];break B}M1(r,i[X+104>>2],i[X+108>>2]);break B}k=r,r=(f|0)<0,O1(k,r?i[X+104>>2]:V,r?i[X+108>>2]:f)}if(w=i[t+152>>2],_=i[t+156>>2],(w|0)==(_|0)){r=1;break _}for(;;){f=i[w>>2];B:{v:{k=F,r=i[k>>2];Z:{if(!r)break Z;for(;n=f>>>0>u0[r+16>>2],k=n?k:r,r=i[(n?4:0)+r>>2],!!r;);if((k|0)==(F|0))break Z;if(f>>>0>=u0[k+16>>2])break v}if(ar(i[e+48>>2],f))break B;r=p(40),i[t+304>>2]=r,i[t+308>>2]=33,i[t+312>>2]=-2147483608,f=l[17653]|l[17654]<<8|(l[17655]<<16|l[17656]<<24),n=l[17649]|l[17650]<<8|(l[17651]<<16|l[17652]<<24),u[r|0]=n,u[r+1|0]=n>>>8,u[r+2|0]=n>>>16,u[r+3|0]=n>>>24,u[r+4|0]=f,u[r+5|0]=f>>>8,u[r+6|0]=f>>>16,u[r+7|0]=f>>>24,u[r+33|0]=0,u[r+32|0]=l[17681],f=l[17677]|l[17678]<<8|(l[17679]<<16|l[17680]<<24),n=l[17673]|l[17674]<<8|(l[17675]<<16|l[17676]<<24),u[r+24|0]=n,u[r+25|0]=n>>>8,u[r+26|0]=n>>>16,u[r+27|0]=n>>>24,u[r+28|0]=f,u[r+29|0]=f>>>8,u[r+30|0]=f>>>16,u[r+31|0]=f>>>24,f=l[17669]|l[17670]<<8|(l[17671]<<16|l[17672]<<24),n=l[17665]|l[17666]<<8|(l[17667]<<16|l[17668]<<24),u[r+16|0]=n,u[r+17|0]=n>>>8,u[r+18|0]=n>>>16,u[r+19|0]=n>>>24,u[r+20|0]=f,u[r+21|0]=f>>>8,u[r+22|0]=f>>>16,u[r+23|0]=f>>>24,f=l[17661]|l[17662]<<8|(l[17663]<<16|l[17664]<<24),n=l[17657]|l[17658]<<8|(l[17659]<<16|l[17660]<<24),u[r+8|0]=n,u[r+9|0]=n>>>8,u[r+10|0]=n>>>16,u[r+11|0]=n>>>24,u[r+12|0]=f,u[r+13|0]=f>>>8,u[r+14|0]=f>>>16,u[r+15|0]=f>>>24,q(A,2,2e3,t+304|0),u[t+315|0]<0&&Z(i[t+304>>2]),r=0;break h}if(r=i[E>>2],n=i[k+20>>2],(r|0)==(n|0)){r=p(32),i[t+304>>2]=r,i[t+308>>2]=28,i[t+312>>2]=-2147483616,f=l[16531]|l[16532]<<8|(l[16533]<<16|l[16534]<<24),n=l[16527]|l[16528]<<8|(l[16529]<<16|l[16530]<<24),u[r|0]=n,u[r+1|0]=n>>>8,u[r+2|0]=n>>>16,u[r+3|0]=n>>>24,u[r+4|0]=f,u[r+5|0]=f>>>8,u[r+6|0]=f>>>16,u[r+7|0]=f>>>24,u[r+28|0]=0,f=l[16551]|l[16552]<<8|(l[16553]<<16|l[16554]<<24),u[r+24|0]=f,u[r+25|0]=f>>>8,u[r+26|0]=f>>>16,u[r+27|0]=f>>>24,f=l[16547]|l[16548]<<8|(l[16549]<<16|l[16550]<<24),n=l[16543]|l[16544]<<8|(l[16545]<<16|l[16546]<<24),u[r+16|0]=n,u[r+17|0]=n>>>8,u[r+18|0]=n>>>16,u[r+19|0]=n>>>24,u[r+20|0]=f,u[r+21|0]=f>>>8,u[r+22|0]=f>>>16,u[r+23|0]=f>>>24,f=l[16539]|l[16540]<<8|(l[16541]<<16|l[16542]<<24),n=l[16535]|l[16536]<<8|(l[16537]<<16|l[16538]<<24),u[r+8|0]=n,u[r+9|0]=n>>>8,u[r+10|0]=n>>>16,u[r+11|0]=n>>>24,u[r+12|0]=f,u[r+13|0]=f>>>8,u[r+14|0]=f>>>16,u[r+15|0]=f>>>24,q(A,2,2e3,t+304|0),u[t+315|0]<0&&Z(i[t+304>>2]),r=0;break h}i[t+80>>2]=r,r=i[o+24>>2],i[t+84>>2]=r,r&&(i[r+4>>2]=i[r+4>>2]+1),r=i[t+84>>2],i[t+8>>2]=i[t+80>>2],i[t+12>>2]=r;v:{if(r=i[n+252>>2],h=i[n+256>>2],r>>>0<h>>>0){i[r>>2]=i[t+8>>2],i[r+4>>2]=i[t+12>>2],i[n+252>>2]=r+8;break v}Z:{if(k=i[n+248>>2],r=r-k|0,s=r>>3,f=s+1|0,f>>>0<536870912){if(h=h-k|0,B=h>>2,h=h>>>0>=2147483640?536870911:f>>>0<B>>>0?B:f,h){if(h>>>0>=536870912)break Z;f=p(h<<3)}else f=0;B=f+r|0,i[B>>2]=i[t+8>>2],i[B+4>>2]=i[t+12>>2],s=B-(s<<3)|0,r&&x(s,k,r),i[n+256>>2]=f+(h<<3),r=B+8|0,i[n+252>>2]=r,i[n+248>>2]=s,k&&Z(k),i[n+252>>2]=r;break v}G0(),H()}z0(),H()}xr(e,E)}if(w=w+4|0,(_|0)==(w|0))break}r=1}w=i[t+152>>2]}w&&(i[t+156>>2]=w,Z(w));_:{if(!N||(f=i[N+4>>2],i[N+4>>2]=f-1,f))break _;W[i[i[N>>2]+8>>2]](N),y(N)}if(r)break w;f=1;break u}if(m=m+56|0,(X0|0)==(m|0))break}f=18;break u}if(!r)break l;x(B,f,r)}u[r+B|0]=0,q(A,2,123,t+304|0),u[t+315|0]<0&&Z(i[t+304>>2]),i[t+152>>2]=O,i[i[$>>2]+(t+152|0)>>2]=M0,i[t+160>>2]=m0,i[n>>2]=71232,u[t+207|0]<0&&Z(i[t+196>>2]),E0(n),y0($0),f=1;break u}Z(f),f=1}m=i[t+376>>2]}if(m){if(r=i[t+380>>2],k=m,(r|0)!=(k|0)){for(;n=i[r-12>>2],n&&(i[r-8>>2]=n,Z(n)),n=r-56|0,i[n>>2]=86356,k=i[r-36>>2],k&&(i[r-32>>2]=k,Z(k)),r=n,(m|0)!=(r|0););k=i[t+376>>2]}i[t+380>>2]=m,Z(k)}t:{if((f|0)!=18){if((f|0)==16)break t;break n}k=o,r=i[k+4>>2];u:{if(r){for(;;)if(o=r,r=i[r>>2],!r)break u}for(;o=i[k+8>>2],r=i[o>>2]!=(k|0),k=o,!!r;);}if((o|0)!=(F|0))continue}break}o=i[e+16>>2]}if((o|0)!=(F|0)){for(;;){if(r=i[o+20>>2],W[i[i[r>>2]+52>>2]](t+152|0,r),r=i[t+152>>2],u[t+171|0]<0&&Z(i[t+160>>2]),!r){s4(t+376|0,i[e+48>>2],i[i[o+20>>2]+116>>2]),r=i[i[t+376>>2]+112>>2];t:{if((r|0)==1752589105){r=i[e+48>>2],i[t+304>>2]=i[r+60>>2],f=i[r+64>>2],i[t+308>>2]=f,f&&(i[f+4>>2]=i[f+4>>2]+1,r=i[e+48>>2]),n=i[r+52>>2],f=i[r+56>>2],f&&(i[f+4>>2]=i[f+4>>2]+1),Nt(t+152|0,n,i[i[o+20>>2]+116>>2],t+304|0,1752589123),n=i[t+152>>2],r=i[t+156>>2];u:{if(!r||(k=i[r+4>>2],i[r+4>>2]=k-1,k))break u;W[i[i[r>>2]+8>>2]](r),y(r)}if(!n){r=p(40),i[t+152>>2]=r,i[t+156>>2]=35,i[t+160>>2]=-2147483608,n=l[14722]|l[14723]<<8|(l[14724]<<16|l[14725]<<24),k=l[14718]|l[14719]<<8|(l[14720]<<16|l[14721]<<24),u[r|0]=k,u[r+1|0]=k>>>8,u[r+2|0]=k>>>16,u[r+3|0]=k>>>24,u[r+4|0]=n,u[r+5|0]=n>>>8,u[r+6|0]=n>>>16,u[r+7|0]=n>>>24,u[r+35|0]=0,n=l[14749]|l[14750]<<8|(l[14751]<<16|l[14752]<<24),u[r+31|0]=n,u[r+32|0]=n>>>8,u[r+33|0]=n>>>16,u[r+34|0]=n>>>24,n=l[14746]|l[14747]<<8|(l[14748]<<16|l[14749]<<24),k=l[14742]|l[14743]<<8|(l[14744]<<16|l[14745]<<24),u[r+24|0]=k,u[r+25|0]=k>>>8,u[r+26|0]=k>>>16,u[r+27|0]=k>>>24,u[r+28|0]=n,u[r+29|0]=n>>>8,u[r+30|0]=n>>>16,u[r+31|0]=n>>>24,n=l[14738]|l[14739]<<8|(l[14740]<<16|l[14741]<<24),k=l[14734]|l[14735]<<8|(l[14736]<<16|l[14737]<<24),u[r+16|0]=k,u[r+17|0]=k>>>8,u[r+18|0]=k>>>16,u[r+19|0]=k>>>24,u[r+20|0]=n,u[r+21|0]=n>>>8,u[r+22|0]=n>>>16,u[r+23|0]=n>>>24,n=l[14730]|l[14731]<<8|(l[14732]<<16|l[14733]<<24),k=l[14726]|l[14727]<<8|(l[14728]<<16|l[14729]<<24),u[r+8|0]=k,u[r+9|0]=k>>>8,u[r+10|0]=k>>>16,u[r+11|0]=k>>>24,u[r+12|0]=n,u[r+13|0]=n>>>8,u[r+14|0]=n>>>16,u[r+15|0]=n>>>24,q(A,2,106,t+152|0),u[t+163|0]<0&&Z(i[t+152>>2]);u:{if(!f||(r=i[f+4>>2],i[f+4>>2]=r-1,r))break u;W[i[i[f>>2]+8>>2]](f),y(f)}r=i[t+308>>2];u:{if(!r||(f=i[r+4>>2],i[r+4>>2]=f-1,f))break u;W[i[i[r>>2]+8>>2]](r),y(r)}k=0;break t}u:{if(!f||(r=i[f+4>>2],i[f+4>>2]=r-1,r))break u;W[i[i[f>>2]+8>>2]](f),y(f)}r=i[t+308>>2];u:{if(!r||(f=i[r+4>>2],i[r+4>>2]=f-1,f))break u;W[i[i[r>>2]+8>>2]](r),y(r)}r=i[i[t+376>>2]+112>>2]}if(k=1,(r|0)!=1987470129)break t;r=i[e+48>>2],i[t+304>>2]=i[r+60>>2],f=i[r+64>>2],i[t+308>>2]=f,f&&(i[f+4>>2]=i[f+4>>2]+1,r=i[e+48>>2]),n=i[r+52>>2],f=i[r+56>>2],f&&(i[f+4>>2]=i[f+4>>2]+1),Nt(t+152|0,n,i[i[o+20>>2]+116>>2],t+304|0,1987470147),n=i[t+152>>2],r=i[t+156>>2];u:{if(!r||(w=i[r+4>>2],i[r+4>>2]=w-1,w))break u;W[i[i[r>>2]+8>>2]](r),y(r)}if(!n){r=p(40),i[t+152>>2]=r,i[t+156>>2]=35,i[t+160>>2]=-2147483608,n=l[14686]|l[14687]<<8|(l[14688]<<16|l[14689]<<24),k=l[14682]|l[14683]<<8|(l[14684]<<16|l[14685]<<24),u[r|0]=k,u[r+1|0]=k>>>8,u[r+2|0]=k>>>16,u[r+3|0]=k>>>24,u[r+4|0]=n,u[r+5|0]=n>>>8,u[r+6|0]=n>>>16,u[r+7|0]=n>>>24,u[r+35|0]=0,n=l[14713]|l[14714]<<8|(l[14715]<<16|l[14716]<<24),u[r+31|0]=n,u[r+32|0]=n>>>8,u[r+33|0]=n>>>16,u[r+34|0]=n>>>24,n=l[14710]|l[14711]<<8|(l[14712]<<16|l[14713]<<24),k=l[14706]|l[14707]<<8|(l[14708]<<16|l[14709]<<24),u[r+24|0]=k,u[r+25|0]=k>>>8,u[r+26|0]=k>>>16,u[r+27|0]=k>>>24,u[r+28|0]=n,u[r+29|0]=n>>>8,u[r+30|0]=n>>>16,u[r+31|0]=n>>>24,n=l[14702]|l[14703]<<8|(l[14704]<<16|l[14705]<<24),k=l[14698]|l[14699]<<8|(l[14700]<<16|l[14701]<<24),u[r+16|0]=k,u[r+17|0]=k>>>8,u[r+18|0]=k>>>16,u[r+19|0]=k>>>24,u[r+20|0]=n,u[r+21|0]=n>>>8,u[r+22|0]=n>>>16,u[r+23|0]=n>>>24,n=l[14694]|l[14695]<<8|(l[14696]<<16|l[14697]<<24),k=l[14690]|l[14691]<<8|(l[14692]<<16|l[14693]<<24),u[r+8|0]=k,u[r+9|0]=k>>>8,u[r+10|0]=k>>>16,u[r+11|0]=k>>>24,u[r+12|0]=n,u[r+13|0]=n>>>8,u[r+14|0]=n>>>16,u[r+15|0]=n>>>24,q(A,2,141,t+152|0),u[t+163|0]<0&&Z(i[t+152>>2]);u:{if(!f||(r=i[f+4>>2],i[f+4>>2]=r-1,r))break u;W[i[i[f>>2]+8>>2]](f),y(f)}r=i[t+308>>2];u:{if(!r||(f=i[r+4>>2],i[r+4>>2]=f-1,f))break u;W[i[i[r>>2]+8>>2]](r),y(r)}k=0;break t}u:{if(!f||(r=i[f+4>>2],i[f+4>>2]=r-1,r))break u;W[i[i[f>>2]+8>>2]](f),y(f)}if(r=i[t+308>>2],!r||(f=i[r+4>>2],i[r+4>>2]=f-1,f))break t;W[i[i[r>>2]+8>>2]](r),y(r)}r=i[t+380>>2];t:{if(!r||(f=i[r+4>>2],i[r+4>>2]=f-1,f))break t;W[i[i[r>>2]+8>>2]](r),y(r)}if(!k)break n}k=i[o+4>>2];t:{if(k){for(;;)if(r=k,k=i[r>>2],!k)break t}for(;r=i[o+8>>2],f=i[r>>2]!=(o|0),o=r,!!f;);}if(o=r,(r|0)==(F|0))break}o=i[e+16>>2]}t:{if((o|0)==(F|0))break t;for(;;){r=i[o+16>>2],f=i[o+20>>2],W[i[i[f>>2]+52>>2]](t+152|0,f),f=i[t+152>>2],u[t+171|0]<0&&Z(i[t+160>>2]);u:{if(f)break u;s4(t+376|0,i[e+48>>2],r),n=i[t+376>>2],f=n?32:33;o:{if(!R|!n)break o;if(i[n+112>>2]==1735551332){P8(t+152|0,R,r,1684630887),k=i[t+152>>2];l:{if((k|0)==i[t+156>>2]){f=33;break l}f=33,r=i[F>>2];s:{if(!r)break s;for(n=i[k>>2],k=F;w=n>>>0>u0[r+16>>2],k=w?k:r,r=i[(w?4:0)+r>>2],!!r;);if((k|0)==(F|0)|n>>>0<u0[k+16>>2])break s;f=i[k+20>>2],r=i[k+24>>2],r&&(i[r+4>>2]=i[r+4>>2]+1),k=i[o+20>>2];w:{if(i[k+16>>2]||(n=i[f+16>>2],!n))break w;i[t+304>>2]=n,n=i[f+20>>2],i[t+308>>2]=n,n&&(i[n+4>>2]=i[n+4>>2]+1),n=t+304|0,lt(k,n),I2(n),k=i[o+20>>2]}w:{if(S4(k)||!S4(f))break w;n=i[o+20>>2],k=C[f+10>>1]|C[f+12>>1]<<16,i[t+304>>2]=C[f+6>>1]|C[f+8>>1]<<16,i[t+308>>2]=k,W[i[i[n>>2]+8>>2]](n,t+304|0)}if(f=0,!r||(n=i[r+4>>2],i[r+4>>2]=n-1,n))break s;W[i[i[r>>2]+8>>2]](r),y(r)}k=i[t+152>>2]}if(k&&(i[t+156>>2]=k,Z(k)),f)break o}f=0}r=i[t+380>>2];o:{if(!r||(n=i[r+4>>2],i[r+4>>2]=n-1,n))break o;W[i[i[r>>2]+8>>2]](r),y(r)}if((f|0)==33)break u;if(f)break t}k=i[o+4>>2];u:{if(k){for(;;)if(r=k,k=i[r>>2],!k)break u}for(;r=i[o+8>>2],f=i[r>>2]!=(o|0),o=r,!!f;);}if(o=r,(r|0)==(F|0))break}}f=i[t+364>>2],I=i[t+368>>2];t:{if((f|0)==(I|0))break t;for(s=A+8|0,n=i[23590],X=i[23591];;){w=i[f>>2],r=J6(i[e+48>>2],w),m=t+376|0,o=0;u:{o:{k=i[e+48>>2],B=i[k+128>>2];l:{if(!B)break l;for(h=k+128|0,k=h;o=w>>>0>u0[B+16>>2],k=o?k:B,B=i[(o?4:0)+B>>2],!!B;);if(o=0,(k|0)==(h|0)|w>>>0<u0[k+16>>2])break l;if(h=i[k+20>>2],o=i[k+24>>2],o&&(i[o+4>>2]=i[o+4>>2]+1),h)break o}u[m|0]=0,u[m+11|0]=0;break u}if(u[h+139|0]>=0){k=i[h+132>>2],i[m>>2]=i[h+128>>2],i[m+4>>2]=k,i[m+8>>2]=i[h+136>>2];break u}T(m,i[h+128>>2],i[h+132>>2])}u:{if(!o||(k=i[o+4>>2],i[o+4>>2]=k-1,k))break u;W[i[i[o>>2]+8>>2]](o),y(o)}u:{o:{if((r|0)<=1785750886){if((r|0)<=1752589104){if(o=35,(r|0)==1635135537|(r|0)==1635148593)break u;if((r|0)!=1735551332)break o;break u}if((r|0)<=1768912491){if(o=35,(r|0)==1752589105)break u;if((r|0)!=1768187246)break o;break u}if(o=35,(r|0)==1768912492)break u;if((r|0)!=1781689137)break o;break u}l:{if((r|0)<=1919377773){if(o=35,(r|0)==1785750887)break u;if((r|0)==1835625829)break l;if((r|0)!=1836280681)break o;break u}if((r|0)<=1970168680){if(o=35,(r|0)==1919377774)break u;if((r|0)!=1953066089)break o;break u}if(o=35,(r|0)==1970168681)break u;if((r|0)!=1987470129)break o;break u}if(o=u[t+387|0],k=(o|0)<0,((k?i[t+380>>2]:o)|0)!=10)break o;if(o=35,!N2(k?i[t+376>>2]:t+376|0,11266,10))break u}m=t+304|0,o=0;o:{l:{k=i[e+48>>2],B=i[k+128>>2];s:{if(!B)break s;for(h=k+128|0,k=h;o=w>>>0>u0[B+16>>2],k=o?k:B,B=i[(o?4:0)+B>>2],!!B;);if(o=0,(k|0)==(h|0)|w>>>0<u0[k+16>>2])break s;if(h=i[k+20>>2],o=i[k+24>>2],o&&(i[o+4>>2]=i[o+4>>2]+1),h)break l}u[m|0]=0,u[m+11|0]=0;break o}if(u[h+163|0]>=0){k=i[h+156>>2],i[m>>2]=i[h+152>>2],i[m+4>>2]=k,i[m+8>>2]=i[h+160>>2];break o}T(m,i[h+152>>2],i[h+156>>2])}o:{if(!o||(k=i[o+4>>2],i[o+4>>2]=k-1,k))break o;W[i[i[o>>2]+8>>2]](o),y(o)}k=p(64),i[k+16>>2]=0,i[k+20>>2]=0,i[k>>2]=94724,i[k+4>>2]=0,i[k+8>>2]=0,i[k+12>>2]=w,i[k+24>>2]=0,i[k+28>>2]=0,i[k+32>>2]=0,i[k+36>>2]=0,i[k+40>>2]=0,i[k+44>>2]=0,i[k+48>>2]=0,i[k+52>>2]=0,i[k+56>>2]=0,i[k+60>>2]=0,L1(t+152|0,r),u[k+27|0]<0&&Z(i[k+16>>2]),o=i[t+156>>2],i[k+16>>2]=i[t+152>>2],i[k+20>>2]=o,i[k+24>>2]=i[t+160>>2],o=k+28|0,h=u[t+387|0];o:{if(u[k+39|0]>=0){if((h|0)>=0){h=i[t+380>>2],i[o>>2]=i[t+376>>2],i[o+4>>2]=h,i[o+8>>2]=i[t+384>>2];break o}M1(o,i[t+376>>2],i[t+380>>2]);break o}B=o,o=(h|0)<0,O1(B,o?i[t+376>>2]:t+376|0,o?i[t+380>>2]:h)}u[k+51|0]<0&&Z(i[k+40>>2]),o=i[t+308>>2],i[k+40>>2]=i[t+304>>2],i[k+44>>2]=o,i[k+48>>2]=i[t+312>>2],u[t+315|0]=0,u[t+304|0]=0,a6(t+152|0,i[e+48>>2],w),B=l[t+172|0];o:{l:{if(B){if((r|0)!=1835625829&&(o=35,(r|0)!=1165519206))break o;if((B|0)!=1)break A;if(r=i[t+156>>2],i[A>>2]=i[t+152>>2],i[A+4>>2]=r,u[t+171|0]>=0){r=i[t+164>>2],i[s>>2]=i[t+160>>2],i[s+4>>2]=r,i[s+8>>2]=i[t+168>>2],o=1;break l}T(s,i[t+160>>2],i[t+164>>2]),o=1;break l}if(r=i[t+152>>2],o=i[t+156>>2],d4(k+52|0,r,o,o-r|0),R){P8(t+328|0,R,w,1667527523),w=i[t+328>>2],V=i[t+332>>2];s:{if((w|0)!=(V|0)){E=k+12|0;w:{for(;;){h=i[w>>2];_:{h:{o=F,r=i[o>>2];B:{if(!r)break B;for(;m=h>>>0>u0[r+16>>2],o=m?o:r,r=i[(m?4:0)+r>>2],!!r;);if((o|0)==(F|0))break B;if(h>>>0>=u0[o+16>>2])break h}if(ar(i[e+48>>2],h))break _;r=p(40),i[t+68>>2]=r,i[t+72>>2]=39,i[t+76>>2]=-2147483608,o=l[14604]|l[14605]<<8|(l[14606]<<16|l[14607]<<24),w=l[14600]|l[14601]<<8|(l[14602]<<16|l[14603]<<24),u[r|0]=w,u[r+1|0]=w>>>8,u[r+2|0]=w>>>16,u[r+3|0]=w>>>24,u[r+4|0]=o,u[r+5|0]=o>>>8,u[r+6|0]=o>>>16,u[r+7|0]=o>>>24,u[r+39|0]=0,o=l[14635]|l[14636]<<8|(l[14637]<<16|l[14638]<<24),w=l[14631]|l[14632]<<8|(l[14633]<<16|l[14634]<<24),u[r+31|0]=w,u[r+32|0]=w>>>8,u[r+33|0]=w>>>16,u[r+34|0]=w>>>24,u[r+35|0]=o,u[r+36|0]=o>>>8,u[r+37|0]=o>>>16,u[r+38|0]=o>>>24,o=l[14628]|l[14629]<<8|(l[14630]<<16|l[14631]<<24),w=l[14624]|l[14625]<<8|(l[14626]<<16|l[14627]<<24),u[r+24|0]=w,u[r+25|0]=w>>>8,u[r+26|0]=w>>>16,u[r+27|0]=w>>>24,u[r+28|0]=o,u[r+29|0]=o>>>8,u[r+30|0]=o>>>16,u[r+31|0]=o>>>24,o=l[14620]|l[14621]<<8|(l[14622]<<16|l[14623]<<24),w=l[14616]|l[14617]<<8|(l[14618]<<16|l[14619]<<24),u[r+16|0]=w,u[r+17|0]=w>>>8,u[r+18|0]=w>>>16,u[r+19|0]=w>>>24,u[r+20|0]=o,u[r+21|0]=o>>>8,u[r+22|0]=o>>>16,u[r+23|0]=o>>>24,o=l[14612]|l[14613]<<8|(l[14614]<<16|l[14615]<<24),w=l[14608]|l[14609]<<8|(l[14610]<<16|l[14611]<<24),u[r+8|0]=w,u[r+9|0]=w>>>8,u[r+10|0]=w>>>16,u[r+11|0]=w>>>24,u[r+12|0]=o,u[r+13|0]=o>>>8,u[r+14|0]=o>>>16,u[r+15|0]=o>>>24,q(A,2,2e3,t+68|0),u[t+79|0]<0&&Z(i[t+68>>2]),r=0;break w}h=i[o+20>>2],i[t+64>>2]=k,i[t+60>>2]=E,i[k+4>>2]=i[k+4>>2]+1,r=i[t+64>>2],i[t>>2]=i[t+60>>2],i[t+4>>2]=r;h:{if(r=i[h+264>>2],B=i[h+268>>2],r>>>0<B>>>0){i[r>>2]=i[t>>2],i[r+4>>2]=i[t+4>>2],i[h+264>>2]=r+8;break h}B:{if(m=i[h+260>>2],r=r-m|0,Q=r>>3,o=Q+1|0,o>>>0<536870912){if(B=B-m|0,_=B>>2,B=B>>>0>=2147483640?536870911:o>>>0<_>>>0?_:o,B){if(B>>>0>=536870912)break B;o=p(B<<3)}else o=0;_=o+r|0,i[_>>2]=i[t>>2],i[_+4>>2]=i[t+4>>2],Q=_-(Q<<3)|0,r&&x(Q,m,r),i[h+268>>2]=o+(B<<3),r=_+8|0,i[h+264>>2]=r,i[h+260>>2]=Q,m&&Z(m),i[h+264>>2]=r;break h}G0(),H()}z0(),H()}}if(w=w+4|0,(V|0)==(w|0))break}r=1}w=i[t+328>>2];break s}r=1}if(w&&(i[t+332>>2]=w,Z(w)),o=1,!r)break l}o=0}B=l[t+172|0]}if(r=B&255,(r|0)!=255&&(i[t+328>>2]=n,i[t+332>>2]=X,W[i[(t+328|0)+(r<<2)>>2]](t+68|0,t+152|0)),r=i[k+4>>2],i[k+4>>2]=r-1,r||(W[i[i[k>>2]+8>>2]](k),y(k)),u[t+315|0]>=0)break u;Z(i[t+304>>2])}if(u[t+387|0]<0&&Z(i[t+376>>2]),o&&(o|0)!=35)break n;if(f=f+4|0,(I|0)==(f|0))break}if(m=i[t+364>>2],Q=i[t+368>>2],!(!R|(m|0)==(Q|0))){for(;;){w=i[m>>2],P8(t+152|0,R,w,1886545261),n=i[t+152>>2],h=i[t+156>>2];u:{if((n|0)==(h|0)){r=1;break u}f=n;o:{if(k=i[F>>2],!k)break o;for(;;){for(o=F,r=k;B=w>>>0>u0[r+16>>2],o=B?o:r,r=i[(B?4:0)+r>>2],!!r;);if((o|0)==(F|0)|w>>>0<u0[o+16>>2])break o;if(r=1,u[i[o+20>>2]+145|0]=1,f=f+4|0,(h|0)==(f|0))break}break u}r=p(48),i[t+376>>2]=r,i[t+380>>2]=42,i[t+384>>2]=-2147483600,f=l[14561]|l[14562]<<8|(l[14563]<<16|l[14564]<<24),o=l[14557]|l[14558]<<8|(l[14559]<<16|l[14560]<<24),u[r|0]=o,u[r+1|0]=o>>>8,u[r+2|0]=o>>>16,u[r+3|0]=o>>>24,u[r+4|0]=f,u[r+5|0]=f>>>8,u[r+6|0]=f>>>16,u[r+7|0]=f>>>24,u[r+42|0]=0,f=l[14597]|l[14598]<<8,u[r+40|0]=f,u[r+41|0]=f>>>8,f=l[14593]|l[14594]<<8|(l[14595]<<16|l[14596]<<24),o=l[14589]|l[14590]<<8|(l[14591]<<16|l[14592]<<24),u[r+32|0]=o,u[r+33|0]=o>>>8,u[r+34|0]=o>>>16,u[r+35|0]=o>>>24,u[r+36|0]=f,u[r+37|0]=f>>>8,u[r+38|0]=f>>>16,u[r+39|0]=f>>>24,f=l[14585]|l[14586]<<8|(l[14587]<<16|l[14588]<<24),o=l[14581]|l[14582]<<8|(l[14583]<<16|l[14584]<<24),u[r+24|0]=o,u[r+25|0]=o>>>8,u[r+26|0]=o>>>16,u[r+27|0]=o>>>24,u[r+28|0]=f,u[r+29|0]=f>>>8,u[r+30|0]=f>>>16,u[r+31|0]=f>>>24,f=l[14577]|l[14578]<<8|(l[14579]<<16|l[14580]<<24),o=l[14573]|l[14574]<<8|(l[14575]<<16|l[14576]<<24),u[r+16|0]=o,u[r+17|0]=o>>>8,u[r+18|0]=o>>>16,u[r+19|0]=o>>>24,u[r+20|0]=f,u[r+21|0]=f>>>8,u[r+22|0]=f>>>16,u[r+23|0]=f>>>24,f=l[14569]|l[14570]<<8|(l[14571]<<16|l[14572]<<24),o=l[14565]|l[14566]<<8|(l[14567]<<16|l[14568]<<24),u[r+8|0]=o,u[r+9|0]=o>>>8,u[r+10|0]=o>>>16,u[r+11|0]=o>>>24,u[r+12|0]=f,u[r+13|0]=f>>>8,u[r+14|0]=f>>>16,u[r+15|0]=f>>>24,q(A,2,2e3,t+376|0),u[t+387|0]<0&&Z(i[t+376>>2]),r=0,n=i[t+152>>2]}if(n&&(i[t+156>>2]=n,Z(n)),!r)break n;if(m=m+4|0,(Q|0)==(m|0))break}Q=i[t+368>>2],m=i[t+364>>2]}if((m|0)!=(Q|0)){for(E=e+156|0,N=e- -64|0,I=A+8|0,s=i[23590],S=i[23591];;){u:{X=i[m>>2];o:{if((J6(i[e+48>>2],X)|0)!=1919377774)break o;r=p(36),i[r+16>>2]=0,i[r+20>>2]=0,i[r+4>>2]=0,i[r+8>>2]=0,i[r>>2]=94464,i[r+24>>2]=0,i[r+28>>2]=0,i[r+32>>2]=0,i[t+72>>2]=r,i[t+68>>2]=r+12,i[r+12>>2]=X,a6(t+152|0,i[e+48>>2],X);l:{s:switch(l[t+172|0]){case 1:if(r=i[t+156>>2],i[A>>2]=i[t+152>>2],i[A+4>>2]=r,u[t+171|0]>=0){r=i[t+164>>2],i[I>>2]=i[t+160>>2],i[I+4>>2]=r,i[I+8>>2]=i[t+168>>2],B=1;break l}T(I,i[t+160>>2],i[t+164>>2]),B=1;break l;case 0:break s;default:break A}o=t+40|0,k=i[t+68>>2],f=v-16|0,v=f,w=t+152|0,r=i[w>>2],n=i[w+4>>2]-r|0;s:{if(n>>>0<=7){if(r=p(32),i[f+4>>2]=r,i[f+8>>2]=25,i[f+12>>2]=-2147483616,n=l[18855]|l[18856]<<8|(l[18857]<<16|l[18858]<<24),k=l[18851]|l[18852]<<8|(l[18853]<<16|l[18854]<<24),u[r|0]=k,u[r+1|0]=k>>>8,u[r+2|0]=k>>>16,u[r+3|0]=k>>>24,u[r+4|0]=n,u[r+5|0]=n>>>8,u[r+6|0]=n>>>16,u[r+7|0]=n>>>24,u[r+25|0]=0,u[r+24|0]=l[18875],n=l[18871]|l[18872]<<8|(l[18873]<<16|l[18874]<<24),k=l[18867]|l[18868]<<8|(l[18869]<<16|l[18870]<<24),u[r+16|0]=k,u[r+17|0]=k>>>8,u[r+18|0]=k>>>16,u[r+19|0]=k>>>24,u[r+20|0]=n,u[r+21|0]=n>>>8,u[r+22|0]=n>>>16,u[r+23|0]=n>>>24,n=l[18863]|l[18864]<<8|(l[18865]<<16|l[18866]<<24),k=l[18859]|l[18860]<<8|(l[18861]<<16|l[18862]<<24),u[r+8|0]=k,u[r+9|0]=k>>>8,u[r+10|0]=k>>>16,u[r+11|0]=k>>>24,u[r+12|0]=n,u[r+13|0]=n>>>8,u[r+14|0]=n>>>16,u[r+15|0]=n>>>24,q(o,2,136,f+4|0),u[f+15|0]>=0)break s;Z(i[f+4>>2]);break s}_=u[r+1|0]&1;w:{if(_){if(n>>>0<=11){if(r=p(24),i[f+4>>2]=r,i[f+8>>2]=22,i[f+12>>2]=-2147483624,n=l[12108]|l[12109]<<8|(l[12110]<<16|l[12111]<<24),k=l[12104]|l[12105]<<8|(l[12106]<<16|l[12107]<<24),u[r|0]=k,u[r+1|0]=k>>>8,u[r+2|0]=k>>>16,u[r+3|0]=k>>>24,u[r+4|0]=n,u[r+5|0]=n>>>8,u[r+6|0]=n>>>16,u[r+7|0]=n>>>24,u[r+22|0]=0,n=l[12122]|l[12123]<<8|(l[12124]<<16|l[12125]<<24),k=l[12118]|l[12119]<<8|(l[12120]<<16|l[12121]<<24),u[r+14|0]=k,u[r+15|0]=k>>>8,u[r+16|0]=k>>>16,u[r+17|0]=k>>>24,u[r+18|0]=n,u[r+19|0]=n>>>8,u[r+20|0]=n>>>16,u[r+21|0]=n>>>24,n=l[12116]|l[12117]<<8|(l[12118]<<16|l[12119]<<24),k=l[12112]|l[12113]<<8|(l[12114]<<16|l[12115]<<24),u[r+8|0]=k,u[r+9|0]=k>>>8,u[r+10|0]=k>>>16,u[r+11|0]=k>>>24,u[r+12|0]=n,u[r+13|0]=n>>>8,u[r+14|0]=n>>>16,u[r+15|0]=n>>>24,q(o,2,136,f+4|0),u[f+15|0]>=0)break s;Z(i[f+4>>2]);break s}n=l[r+2|0]|l[r+3|0]<<8|(l[r+4|0]<<16|l[r+5|0]<<24),i[k+4>>2]=n<<24|(n&65280)<<8|(n>>>8&65280|n>>>24),h=l[r+7|0]<<16|l[r+6|0]<<24|l[r+8|0]<<8,B=10,n=r+9|0;break w}i[k+4>>2]=l[r+3|0]|l[r+2|0]<<8,h=l[r+4|0]<<8,B=6,n=r+5|0}if(i[k+8>>2]=l[n|0]|h,n=l[r+B|0],i[f>>2]=B|1,n)for(h=_?32:16,k=k+12|0,B=0;;){if(r=i[f>>2],_=i[w>>2],r>>>0>=i[w+4>>2]-_>>>0){if(r=p(24),i[f+4>>2]=r,i[f+8>>2]=22,i[f+12>>2]=-2147483624,n=l[12108]|l[12109]<<8|(l[12110]<<16|l[12111]<<24),k=l[12104]|l[12105]<<8|(l[12106]<<16|l[12107]<<24),u[r|0]=k,u[r+1|0]=k>>>8,u[r+2|0]=k>>>16,u[r+3|0]=k>>>24,u[r+4|0]=n,u[r+5|0]=n>>>8,u[r+6|0]=n>>>16,u[r+7|0]=n>>>24,u[r+22|0]=0,n=l[12122]|l[12123]<<8|(l[12124]<<16|l[12125]<<24),k=l[12118]|l[12119]<<8|(l[12120]<<16|l[12121]<<24),u[r+14|0]=k,u[r+15|0]=k>>>8,u[r+16|0]=k>>>16,u[r+17|0]=k>>>24,u[r+18|0]=n,u[r+19|0]=n>>>8,u[r+20|0]=n>>>16,u[r+21|0]=n>>>24,n=l[12116]|l[12117]<<8|(l[12118]<<16|l[12119]<<24),k=l[12112]|l[12113]<<8|(l[12114]<<16|l[12115]<<24),u[r+8|0]=k,u[r+9|0]=k>>>8,u[r+10|0]=k>>>16,u[r+11|0]=k>>>24,u[r+12|0]=n,u[r+13|0]=n>>>8,u[r+14|0]=n>>>16,u[r+15|0]=n>>>24,q(o,2,136,f+4|0),u[f+15|0]>=0)break s;Z(i[f+4>>2]);break s}_=l[r+_|0],i[f>>2]=r+1;w:{_:{h:switch(_|0){case 0:r=p(24),i[r+16>>2]=0,i[r+20>>2]=0,i[r+4>>2]=0,i[r+8>>2]=0,i[r>>2]=95980,i[r+12>>2]=95716,i[f+8>>2]=r,i[f+4>>2]=r+12;break _;case 1:r=p(32),i[r+16>>2]=0,i[r+20>>2]=0,i[r+4>>2]=0,i[r+8>>2]=0,i[r>>2]=96020,i[r+24>>2]=0,i[r+28>>2]=0,i[r+12>>2]=95760,i[f+8>>2]=r,i[f+4>>2]=r+12;break _;case 2:r=p(32),i[r+16>>2]=0,i[r+20>>2]=0,i[r+4>>2]=0,i[r+8>>2]=0,i[r>>2]=96060,i[r+24>>2]=0,i[r+28>>2]=0,i[r+12>>2]=95804,i[f+8>>2]=r,i[f+4>>2]=r+12;break _;case 3:if(r=p(40),i[r+16>>2]=1,i[r+20>>2]=0,i[r+24>>2]=0,i[r+4>>2]=1,i[r+8>>2]=0,i[r>>2]=96100,i[r+12>>2]=95892,i[r+28>>2]=0,i[r+32>>2]=0,i[r+36>>2]=0,i[f+8>>2]=r,i[f+4>>2]=r+12,_=i[r+4>>2],i[r+4>>2]=_-1,_)break _;W[i[i[r>>2]+8>>2]](r),y(r);break _;case 4:r=p(36),i[r+16>>2]=0,i[r+20>>2]=0,i[r+4>>2]=0,i[r+8>>2]=0,i[r>>2]=96140,i[r+24>>2]=0,i[r+28>>2]=0,i[r+32>>2]=0,i[r+12>>2]=95848,i[f+8>>2]=r,i[f+4>>2]=r+12;break _;case 5:r=p(52),i[r+16>>2]=0,i[r+20>>2]=0,i[r+4>>2]=0,i[r+8>>2]=0,i[r+32>>2]=0,i[r+36>>2]=0,i[r>>2]=96180,i[r+24>>2]=0,i[r+28>>2]=0,i[r+12>>2]=95936,i[r+40>>2]=0,i[r+44>>2]=0,i[r+48>>2]=0,i[f+8>>2]=r,i[f+4>>2]=r+12;break _;case 6:break h;default:break w}if(r=p(40),i[r+16>>2]=0,i[r+20>>2]=0,i[r+24>>2]=0,i[r+4>>2]=1,i[r+8>>2]=0,i[r>>2]=96100,i[r+12>>2]=95892,i[r+28>>2]=0,i[r+32>>2]=0,i[r+36>>2]=0,i[f+8>>2]=r,i[f+4>>2]=r+12,_=i[r+4>>2],i[r+4>>2]=_-1,_)break _;W[i[i[r>>2]+8>>2]](r),y(r)}r=i[f+4>>2],W[i[i[r>>2]+12>>2]](o,r,w,h,f,N),_=i[o>>2];_:{if(_||(r2(k,f+4|0),u[o+19|0]>=0))break _;Z(i[o+8>>2])}r=i[f+8>>2];_:{if(!r||(V=i[r+4>>2],i[r+4>>2]=V-1,V))break _;W[i[i[r>>2]+8>>2]](r),y(r)}if(_)break s}if(B=B+1|0,(n|0)==(B|0))break}if(r=i[26917],i[o>>2]=i[26916],i[o+4>>2]=r,r=o+8|0,u[107683]>=0){o=i[26919],i[r>>2]=i[26918],i[r+4>>2]=o,i[r+8>>2]=i[26920];break s}T(r,i[26918],i[26919])}if(v=f+16|0,u[t+59|0]<0&&Z(i[t+48>>2]),R){i3(t+304|0,R,X),h=i[t+304>>2],a=i[t+308>>2];s:{if((h|0)==(a|0)){B=44;break s}w:{for(;;){if(r=i[h+16>>2],(r|0)==1667527523){if(i[t+384>>2]=0,i[t+376>>2]=0,i[t+380>>2]=0,r=i[h+48>>2],f=i[h+44>>2],(r|0)!=(f|0)){if(r=r-f|0,(r|0)<0)break i;for(n=p(r),r&&x(n,f,r),w=r+n|0,f=n;;){_:{r=i[F>>2];h:{if(!r)break h;for(k=i[f>>2],o=F;B=k>>>0>u0[r+16>>2],o=B?o:r,r=i[(B?4:0)+r>>2],!!r;);if((o|0)==(F|0))break h;if(k>>>0>=u0[o+16>>2])break _}r=p(48),i[t+328>>2]=r,i[t+332>>2]=42,i[t+336>>2]=-2147483600,f=l[14518]|l[14519]<<8|(l[14520]<<16|l[14521]<<24),o=l[14514]|l[14515]<<8|(l[14516]<<16|l[14517]<<24),u[r|0]=o,u[r+1|0]=o>>>8,u[r+2|0]=o>>>16,u[r+3|0]=o>>>24,u[r+4|0]=f,u[r+5|0]=f>>>8,u[r+6|0]=f>>>16,u[r+7|0]=f>>>24,u[r+42|0]=0,f=l[14554]|l[14555]<<8,u[r+40|0]=f,u[r+41|0]=f>>>8,f=l[14550]|l[14551]<<8|(l[14552]<<16|l[14553]<<24),o=l[14546]|l[14547]<<8|(l[14548]<<16|l[14549]<<24),u[r+32|0]=o,u[r+33|0]=o>>>8,u[r+34|0]=o>>>16,u[r+35|0]=o>>>24,u[r+36|0]=f,u[r+37|0]=f>>>8,u[r+38|0]=f>>>16,u[r+39|0]=f>>>24,f=l[14542]|l[14543]<<8|(l[14544]<<16|l[14545]<<24),o=l[14538]|l[14539]<<8|(l[14540]<<16|l[14541]<<24),u[r+24|0]=o,u[r+25|0]=o>>>8,u[r+26|0]=o>>>16,u[r+27|0]=o>>>24,u[r+28|0]=f,u[r+29|0]=f>>>8,u[r+30|0]=f>>>16,u[r+31|0]=f>>>24,f=l[14534]|l[14535]<<8|(l[14536]<<16|l[14537]<<24),o=l[14530]|l[14531]<<8|(l[14532]<<16|l[14533]<<24),u[r+16|0]=o,u[r+17|0]=o>>>8,u[r+18|0]=o>>>16,u[r+19|0]=o>>>24,u[r+20|0]=f,u[r+21|0]=f>>>8,u[r+22|0]=f>>>16,u[r+23|0]=f>>>24,f=l[14526]|l[14527]<<8|(l[14528]<<16|l[14529]<<24),o=l[14522]|l[14523]<<8|(l[14524]<<16|l[14525]<<24),u[r+8|0]=o,u[r+9|0]=o>>>8,u[r+10|0]=o>>>16,u[r+11|0]=o>>>24,u[r+12|0]=f,u[r+13|0]=f>>>8,u[r+14|0]=f>>>16,u[r+15|0]=f>>>24,q(A,2,2e3,t+328|0),u[t+339|0]<0&&Z(i[t+328>>2]),Z(n),B=1;break w}if(Au(i[o+20>>2],X),r2(E,t+68|0),f=f+4|0,(w|0)==(f|0))break}Z(n)}r=i[h+16>>2]}if((r|0)==1835103083){if(n=0,i[t+336>>2]=0,i[t+328>>2]=0,i[t+332>>2]=0,r=0,f=i[h+48>>2],o=i[h+44>>2],(f|0)!=(o|0)){if(f=f-o|0,(f|0)<0)break i;r=p(f),i[t+328>>2]=r,k=r+f|0,i[t+336>>2]=k,f&&x(r,o,f),i[t+332>>2]=k}V=0,o=i[t+68>>2],f=i[o+16>>2],o=i[o+12>>2],k=f-o|0;_:{if((k|0)<=0){B=48;break _}h:{for(;;){if(i[t+384>>2]=0,i[t+376>>2]=0,i[t+380>>2]=0,r=0,B=0,(f|0)!=(o|0)){if((k|0)<0)break i;for(B=p(k),i[t+376>>2]=B,i[t+384>>2]=k+B,r=B;i[r>>2]=i[o>>2],k=i[o+4>>2],i[r+4>>2]=k,k&&(i[k+4>>2]=i[k+4>>2]+1),r=r+8|0,o=o+8|0,(f|0)!=(o|0););i[t+380>>2]=r}if(O=n<<3,f=i[O+B>>2],k=W[i[i[f>>2]+8>>2]](f)|0,o=B,(o|0)!=(r|0)){for(;;){f=i[r-4>>2];B:{if(!f||(o=i[f+4>>2],i[f+4>>2]=o-1,o))break B;W[i[i[f>>2]+8>>2]](f),y(f)}if(r=r-8|0,(B|0)==(r|0))break}o=i[t+376>>2]}i[t+380>>2]=B,Z(o);B:{if((k|0)!=4)break B;if(w=0,i[t+384>>2]=0,i[t+376>>2]=0,i[t+380>>2]=0,r=0,B=0,o=i[t+68>>2],f=i[o+16>>2],o=i[o+12>>2],(f|0)!=(o|0)){if(r=f-o|0,(r|0)<0)break i;for(B=p(r),i[t+376>>2]=B,i[t+384>>2]=r+B,r=B;i[r>>2]=i[o>>2],k=i[o+4>>2],i[r+4>>2]=k,k&&(i[k+4>>2]=i[k+4>>2]+1),r=r+8|0,o=o+8|0,(f|0)!=(o|0););i[t+380>>2]=r}_=0,f=B+O|0,o=i[f>>2];v:{if(!o)break v;if(_=W0(o,94756,95872),!_){_=0;break v}if(w=i[f+4>>2],!w){w=0;break v}i[w+4>>2]=i[w+4>>2]+1}if(o=B,(o|0)!=(r|0)){for(;;){f=i[r-4>>2];v:{if(!f||(o=i[f+4>>2],i[f+4>>2]=o-1,o))break v;W[i[i[f>>2]+8>>2]](f),y(f)}if(r=r-8|0,(B|0)==(r|0))break}o=i[t+376>>2]}i[t+380>>2]=B,Z(o),r=i[t+328>>2];v:{if(i[t+332>>2]-r>>2>>>0<=V>>>0){r=p(64),i[t+376>>2]=r,i[t+380>>2]=60,i[t+384>>2]=-2147483584,f=l[15350]|l[15351]<<8|(l[15352]<<16|l[15353]<<24),o=l[15346]|l[15347]<<8|(l[15348]<<16|l[15349]<<24),u[r|0]=o,u[r+1|0]=o>>>8,u[r+2|0]=o>>>16,u[r+3|0]=o>>>24,u[r+4|0]=f,u[r+5|0]=f>>>8,u[r+6|0]=f>>>16,u[r+7|0]=f>>>24,u[r+60|0]=0,f=l[15402]|l[15403]<<8|(l[15404]<<16|l[15405]<<24),u[r+56|0]=f,u[r+57|0]=f>>>8,u[r+58|0]=f>>>16,u[r+59|0]=f>>>24,f=l[15398]|l[15399]<<8|(l[15400]<<16|l[15401]<<24),o=l[15394]|l[15395]<<8|(l[15396]<<16|l[15397]<<24),u[r+48|0]=o,u[r+49|0]=o>>>8,u[r+50|0]=o>>>16,u[r+51|0]=o>>>24,u[r+52|0]=f,u[r+53|0]=f>>>8,u[r+54|0]=f>>>16,u[r+55|0]=f>>>24,f=l[15390]|l[15391]<<8|(l[15392]<<16|l[15393]<<24),o=l[15386]|l[15387]<<8|(l[15388]<<16|l[15389]<<24),u[r+40|0]=o,u[r+41|0]=o>>>8,u[r+42|0]=o>>>16,u[r+43|0]=o>>>24,u[r+44|0]=f,u[r+45|0]=f>>>8,u[r+46|0]=f>>>16,u[r+47|0]=f>>>24,f=l[15382]|l[15383]<<8|(l[15384]<<16|l[15385]<<24),o=l[15378]|l[15379]<<8|(l[15380]<<16|l[15381]<<24),u[r+32|0]=o,u[r+33|0]=o>>>8,u[r+34|0]=o>>>16,u[r+35|0]=o>>>24,u[r+36|0]=f,u[r+37|0]=f>>>8,u[r+38|0]=f>>>16,u[r+39|0]=f>>>24,f=l[15374]|l[15375]<<8|(l[15376]<<16|l[15377]<<24),o=l[15370]|l[15371]<<8|(l[15372]<<16|l[15373]<<24),u[r+24|0]=o,u[r+25|0]=o>>>8,u[r+26|0]=o>>>16,u[r+27|0]=o>>>24,u[r+28|0]=f,u[r+29|0]=f>>>8,u[r+30|0]=f>>>16,u[r+31|0]=f>>>24,f=l[15366]|l[15367]<<8|(l[15368]<<16|l[15369]<<24),o=l[15362]|l[15363]<<8|(l[15364]<<16|l[15365]<<24),u[r+16|0]=o,u[r+17|0]=o>>>8,u[r+18|0]=o>>>16,u[r+19|0]=o>>>24,u[r+20|0]=f,u[r+21|0]=f>>>8,u[r+22|0]=f>>>16,u[r+23|0]=f>>>24,f=l[15358]|l[15359]<<8|(l[15360]<<16|l[15361]<<24),o=l[15354]|l[15355]<<8|(l[15356]<<16|l[15357]<<24),u[r+8|0]=o,u[r+9|0]=o>>>8,u[r+10|0]=o>>>16,u[r+11|0]=o>>>24,u[r+12|0]=f,u[r+13|0]=f>>>8,u[r+14|0]=f>>>16,u[r+15|0]=f>>>24,q(A,2,0,t+376|0),u[t+387|0]<0&&Z(i[t+376>>2]),r=0;break v}Z:{f=i[F>>2];G:{if(!f)break G;for(k=i[r+(V<<2)>>2],o=F,r=f;B=k>>>0>u0[r+16>>2],o=B?o:r,r=i[(B?4:0)+r>>2],!!r;);if((o|0)==(F|0))break G;if(k>>>0>=u0[o+16>>2])break Z}r=p(48),i[t+376>>2]=r,i[t+380>>2]=43,i[t+384>>2]=-2147483600,f=l[14325]|l[14326]<<8|(l[14327]<<16|l[14328]<<24),o=l[14321]|l[14322]<<8|(l[14323]<<16|l[14324]<<24),u[r|0]=o,u[r+1|0]=o>>>8,u[r+2|0]=o>>>16,u[r+3|0]=o>>>24,u[r+4|0]=f,u[r+5|0]=f>>>8,u[r+6|0]=f>>>16,u[r+7|0]=f>>>24,u[r+43|0]=0,f=l[14360]|l[14361]<<8|(l[14362]<<16|l[14363]<<24),u[r+39|0]=f,u[r+40|0]=f>>>8,u[r+41|0]=f>>>16,u[r+42|0]=f>>>24,f=l[14357]|l[14358]<<8|(l[14359]<<16|l[14360]<<24),o=l[14353]|l[14354]<<8|(l[14355]<<16|l[14356]<<24),u[r+32|0]=o,u[r+33|0]=o>>>8,u[r+34|0]=o>>>16,u[r+35|0]=o>>>24,u[r+36|0]=f,u[r+37|0]=f>>>8,u[r+38|0]=f>>>16,u[r+39|0]=f>>>24,f=l[14349]|l[14350]<<8|(l[14351]<<16|l[14352]<<24),o=l[14345]|l[14346]<<8|(l[14347]<<16|l[14348]<<24),u[r+24|0]=o,u[r+25|0]=o>>>8,u[r+26|0]=o>>>16,u[r+27|0]=o>>>24,u[r+28|0]=f,u[r+29|0]=f>>>8,u[r+30|0]=f>>>16,u[r+31|0]=f>>>24,f=l[14341]|l[14342]<<8|(l[14343]<<16|l[14344]<<24),o=l[14337]|l[14338]<<8|(l[14339]<<16|l[14340]<<24),u[r+16|0]=o,u[r+17|0]=o>>>8,u[r+18|0]=o>>>16,u[r+19|0]=o>>>24,u[r+20|0]=f,u[r+21|0]=f>>>8,u[r+22|0]=f>>>16,u[r+23|0]=f>>>24,f=l[14333]|l[14334]<<8|(l[14335]<<16|l[14336]<<24),o=l[14329]|l[14330]<<8|(l[14331]<<16|l[14332]<<24),u[r+8|0]=o,u[r+9|0]=o>>>8,u[r+10|0]=o>>>16,u[r+11|0]=o>>>24,u[r+12|0]=f,u[r+13|0]=f>>>8,u[r+14|0]=f>>>16,u[r+15|0]=f>>>24,q(A,2,0,t+376|0),u[t+387|0]<0&&Z(i[t+376>>2]),r=0;break v}for(r=F;o=k>>>0>u0[f+16>>2],r=o?r:f,f=i[(o?4:0)+f>>2],!!f;);Z:{if(!((r|0)!=(F|0)&k>>>0>=u0[r+16>>2])){i[t+376>>2]=0,i[t+380>>2]=0,r=0,o=0;break Z}if(f=i[r+20>>2],W[i[i[f>>2]+52>>2]](t+376|0,f),u[t+395|0]<0&&Z(i[t+384>>2]),o=i[r+20>>2],i[t+376>>2]=o,r=i[r+24>>2],i[t+380>>2]=r,!r){r=0;break Z}i[r+4>>2]=i[r+4>>2]+1}W[i[i[o>>2]+52>>2]](A,o),f=i[A>>2],f||(u[A+19|0]<0&&Z(i[A+8>>2]),i[_+20>>2]=k,i[_+12>>2]||(d0=_,n2=yA(o),i[d0+12>>2]=n2),i[_+16>>2]||(d0=_,n2=EA(o),i[d0+16>>2]=n2),xr(e,t+376|0),V=V+1|0);Z:{if(!r||(o=i[r+4>>2],i[r+4>>2]=o-1,o))break Z;W[i[i[r>>2]+8>>2]](r),y(r)}r=!f}v:{if(!w||(f=i[w+4>>2],i[w+4>>2]=f-1,f))break v;W[i[i[w>>2]+8>>2]](w),y(w)}if(r)break B;B=1,n=1;break h}if(n=n+1|0,r=i[t+68>>2],f=i[r+16>>2],o=i[r+12>>2],k=f-o|0,!((n|0)<k>>3))break}B=48,n=0}r=i[t+328>>2]}if(r&&(i[t+332>>2]=r,Z(r)),n)break w}if(h=h+56|0,(a|0)==(h|0))break}B=44}h=i[t+304>>2]}if(h){if(r=i[t+308>>2],o=h,(r|0)!=(o|0)){for(;f=i[r-12>>2],f&&(i[r-8>>2]=f,Z(f)),f=r-56|0,i[f>>2]=86356,o=i[r-36>>2],o&&(i[r-32>>2]=o,Z(o)),r=f,(h|0)!=(r|0););o=i[t+304>>2]}i[t+308>>2]=h,Z(o)}if((B|0)!=44)break l}B=0}r=l[t+172|0],(r|0)!=255&&(i[t+376>>2]=s,i[t+380>>2]=S,W[i[(t+376|0)+(r<<2)>>2]](t+304|0,t+152|0)),r=i[t+72>>2];l:{if(!r||(f=i[r+4>>2],i[r+4>>2]=f-1,f))break l;W[i[i[r>>2]+8>>2]](r),y(r)}l:switch(B-42|0){case 1:break o;case 0:break u;default:break l}if(B)break n}if(m=m+4|0,(Q|0)!=(m|0))continue}break}Q=i[t+368>>2],m=i[t+364>>2]}if((m|0)==(Q|0))break t;for(X=e+168|0,s=A+8|0,w=i[23590],V=i[23591];;){_=i[m>>2];u:{if((J6(i[e+48>>2],_)|0)!=1835625829)break u;r=p(28),i[r+16>>2]=0,i[r+20>>2]=0,i[r+4>>2]=0,i[r+8>>2]=0,i[r>>2]=94772,i[r+24>>2]=0,i[t+72>>2]=r,i[t+68>>2]=r+12,i[r+12>>2]=_,a6(t+152|0,i[e+48>>2],_);o:{l:switch(l[t+172|0]){case 1:if(r=i[t+156>>2],i[A>>2]=i[t+152>>2],i[A+4>>2]=r,u[t+171|0]>=0){r=i[t+164>>2],i[s>>2]=i[t+160>>2],i[s+4>>2]=r,i[s+8>>2]=i[t+168>>2],B=1;break o}T(s,i[t+160>>2],i[t+164>>2]),B=1;break o;case 0:break l;default:break A}o=t+20|0,r=i[t+156>>2],I=r;l:{s:{f=i[t+152>>2],B=r-f|0,n=i[t+68>>2]+4|0,k=i[n+8>>2],E=u[n+11|0],r=(E|0)>=0?10:(k&2147483647)-1|0;w:{if(B>>>0<=r>>>0){k=(k|0)<0?i[n>>2]:n;break w}if(B-r>>>0>2147483639-r>>>0)break s;N=i[n>>2];_:{h:{if(r>>>0>=1073741811){h=2147483639,k=p(2147483639);break h}if(k=r<<1,k=k>>>0<B>>>0?B:k,h=k>>>0<11?11:(k|7)+1|0,k=p(h),(r|0)==10)break _}Z((E|0)<0?N:n)}i[n>>2]=k,i[n+4>>2]=0,i[n+8>>2]=h|-2147483648}w:{if((f|0)==(I|0))break w;E=I-f&7;_:{if(!E){r=f;break _}for(h=0,r=f;u[k|0]=l[r|0],r=r+1|0,k=k+1|0,h=h+1|0,(E|0)!=(h|0););}if(f-I>>>0>4294967288)break w;for(;u[k|0]=l[r|0],u[k+1|0]=l[r+1|0],u[k+2|0]=l[r+2|0],u[k+3|0]=l[r+3|0],u[k+4|0]=l[r+4|0],u[k+5|0]=l[r+5|0],u[k+6|0]=l[r+6|0],u[k+7|0]=l[r+7|0],k=k+8|0,r=r+8|0,(I|0)!=(r|0););}if(u[k|0]=0,u[n+11|0]<0){i[n+4>>2]=B;break l}u[n+11|0]=B&127;break l}Q0(),H()}f=i[26917],r=o,i[r>>2]=i[26916],i[r+4>>2]=f,r=r+8|0;l:{if(u[107683]>=0){f=i[26919],i[r>>2]=i[26918],i[r+4>>2]=f,i[r+8>>2]=i[26920];break l}T(r,i[26918],i[26919])}if(u[t+39|0]<0&&Z(i[t+28>>2]),R){i3(t+376|0,R,_),f=i[t+376>>2],B=i[t+380>>2];l:{if((f|0)==(B|0)){B=53;break l}s:{for(;;){w:{if(i[f+16>>2]!=1952807028||(i[t+312>>2]=0,i[t+304>>2]=0,i[t+308>>2]=0,r=i[f+48>>2],o=i[f+44>>2],(r|0)==(o|0)))break w;if(r=r-o|0,(r|0)<0)break i;for(k=p(r),r&&x(k,o,r),I=r+k|0,n=k;;){_:{r=i[F>>2];h:{if(!r)break h;for(h=i[n>>2],o=F;E=h>>>0>u0[r+16>>2],o=E?o:r,r=i[(E?4:0)+r>>2],!!r;);if((o|0)==(F|0))break h;if(h>>>0>=u0[o+16>>2])break _}r=p(48),i[t+328>>2]=r,i[t+332>>2]=40,i[t+336>>2]=-2147483600,f=l[14477]|l[14478]<<8|(l[14479]<<16|l[14480]<<24),o=l[14473]|l[14474]<<8|(l[14475]<<16|l[14476]<<24),u[r|0]=o,u[r+1|0]=o>>>8,u[r+2|0]=o>>>16,u[r+3|0]=o>>>24,u[r+4|0]=f,u[r+5|0]=f>>>8,u[r+6|0]=f>>>16,u[r+7|0]=f>>>24,u[r+40|0]=0,f=l[14509]|l[14510]<<8|(l[14511]<<16|l[14512]<<24),o=l[14505]|l[14506]<<8|(l[14507]<<16|l[14508]<<24),u[r+32|0]=o,u[r+33|0]=o>>>8,u[r+34|0]=o>>>16,u[r+35|0]=o>>>24,u[r+36|0]=f,u[r+37|0]=f>>>8,u[r+38|0]=f>>>16,u[r+39|0]=f>>>24,f=l[14501]|l[14502]<<8|(l[14503]<<16|l[14504]<<24),o=l[14497]|l[14498]<<8|(l[14499]<<16|l[14500]<<24),u[r+24|0]=o,u[r+25|0]=o>>>8,u[r+26|0]=o>>>16,u[r+27|0]=o>>>24,u[r+28|0]=f,u[r+29|0]=f>>>8,u[r+30|0]=f>>>16,u[r+31|0]=f>>>24,f=l[14493]|l[14494]<<8|(l[14495]<<16|l[14496]<<24),o=l[14489]|l[14490]<<8|(l[14491]<<16|l[14492]<<24),u[r+16|0]=o,u[r+17|0]=o>>>8,u[r+18|0]=o>>>16,u[r+19|0]=o>>>24,u[r+20|0]=f,u[r+21|0]=f>>>8,u[r+22|0]=f>>>16,u[r+23|0]=f>>>24,f=l[14485]|l[14486]<<8|(l[14487]<<16|l[14488]<<24),o=l[14481]|l[14482]<<8|(l[14483]<<16|l[14484]<<24),u[r+8|0]=o,u[r+9|0]=o>>>8,u[r+10|0]=o>>>16,u[r+11|0]=o>>>24,u[r+12|0]=f,u[r+13|0]=f>>>8,u[r+14|0]=f>>>16,u[r+15|0]=f>>>24,q(A,2,2e3,t+328|0),u[t+339|0]<0&&Z(i[t+328>>2]),Z(k),B=1;break s}if(ku(i[o+20>>2],_),r2(X,t+68|0),n=n+4|0,(I|0)==(n|0))break}Z(k)}if(f=f+56|0,(B|0)==(f|0))break}B=53}f=i[t+376>>2]}if(f){if(r=i[t+380>>2],o=f,(r|0)!=(f|0)){for(;o=i[r-12>>2],o&&(i[r-8>>2]=o,Z(o)),o=r-56|0,i[o>>2]=86356,n=i[r-36>>2],n&&(i[r-32>>2]=n,Z(n)),r=o,(f|0)!=(r|0););o=i[t+376>>2]}i[t+380>>2]=f,Z(o)}if((B|0)!=53)break o}B=0}r=l[t+172|0],(r|0)!=255&&(i[t+376>>2]=w,i[t+380>>2]=V,W[i[(t+376|0)+(r<<2)>>2]](t+304|0,t+152|0)),r=i[t+72>>2];o:{if(!r||(f=i[r+4>>2],i[r+4>>2]=f-1,f))break o;W[i[i[r>>2]+8>>2]](r),y(r)}o:switch(B-51|0){case 0:break t;case 1:break u;default:break o}if(B)break n}if(m=m+4|0,(Q|0)==(m|0))break}}k8(A,107664)}if(!z||(r=i[z+4>>2],i[z+4>>2]=r-1,r))break k;W[i[i[z>>2]+8>>2]](z),y(z)}r=i[t+364>>2],r&&(i[t+368>>2]=r,Z(r)),v=t+416|0;break f}_2(),H()}if(i[A>>2])break e;if(u[A+19|0]>=0)break r;Z(i[A+8>>2])}r:{if(!i[i[e+48>>2]+140>>2])break r;Q=0,_=v+-64|0,v=_,F=e,k3(e+180|0,i[e+184>>2]),h=e+184|0,i[e+180>>2]=h,i[e+184>>2]=0,i[e+188>>2]=0,e=i[e+48>>2],f=i[e+140>>2],I=i[e+144>>2],I&&(i[I+4>>2]=i[I+4>>2]+1);f:{A:{k:{n:{r=i[f+36>>2],o=i[f+40>>2];t:{if((r|0)!=(o|0)){e=r;u:{for(;;){o:{l:{if(n=i[e>>2],!n||!W0(n,86580,104440))break l;if(Q=i[e+4>>2],!Q)break o;i[Q+4>>2]=i[Q+4>>2]+1,o=i[f+40>>2],r=i[f+36>>2];break u}if(e=e+8|0,(o|0)!=(e|0))continue}break}Q=0}if(i[_+56>>2]=0,i[_+48>>2]=0,i[_+52>>2]=0,(r|0)==(o|0))break t;for(;;){e=i[r>>2];u:{if(!e||(e=W0(e,86580,92824),!e)||(i[_+24>>2]=e,e=i[r+4>>2],i[_+28>>2]=e,e&&(i[e+4>>2]=i[e+4>>2]+1),r2(_+48|0,_+24|0),e=i[_+28>>2],!e)||(f=i[e+4>>2],i[e+4>>2]=f-1,f))break u;W[i[i[e>>2]+8>>2]](e),y(e)}if(r=r+8|0,(o|0)==(r|0))break}if(e=i[_+48>>2],t=i[_+52>>2],(e|0)==(t|0))break t;for(f=_+36|0,n=_+43|0,w=_+32|0,V=A+8|0,B=i[23602],z=i[23603],E=_+8|0;;){o=_+24|0,k=v-192|0,v=k,m=e;u:{o:{l:{s:{if(r=i[e>>2],e=i[r+36>>2],s=i[r+40>>2],(e|0)!=(s|0))for(;;){w:{if(r=i[e>>2],!r||(r=W0(r,86580,92984),!r))break w;s=i[e+4>>2],s&&(i[s+4>>2]=i[s+4>>2]+1);_:{h:{B:{if(e=i[r+36>>2],X=i[r+40>>2],(e|0)!=(X|0))for(;;){v:{if(r=i[e>>2],!r||(r=W0(r,86580,87184),!r))break v;if(X=i[e+4>>2],X&&(i[X+4>>2]=i[X+4>>2]+1),e=i[r+108>>2],(e|0)>1885954931)break B;if((e|0)==1635088502)break h;if((e|0)!=1835365473)break _;e=p(320),i[e+4>>2]=0,i[e+8>>2]=0,i[e>>2]=94892,r=Yu(e+16|0,F),i[r+288>>2]=0,i[r+292>>2]=0,i[r>>2]=106768,i[r+296>>2]=0;break s}if(e=e+8|0,(X|0)==(e|0))break}e=p(32),i[k+16>>2]=e,i[k+20>>2]=24,i[k+24>>2]=-2147483616,r=l[22904]|l[22905]<<8|(l[22906]<<16|l[22907]<<24),X=l[22900]|l[22901]<<8|(l[22902]<<16|l[22903]<<24),u[e+16|0]=X,u[e+17|0]=X>>>8,u[e+18|0]=X>>>16,u[e+19|0]=X>>>24,u[e+20|0]=r,u[e+21|0]=r>>>8,u[e+22|0]=r>>>16,u[e+23|0]=r>>>24,r=l[22896]|l[22897]<<8|(l[22898]<<16|l[22899]<<24),X=l[22892]|l[22893]<<8|(l[22894]<<16|l[22895]<<24),u[e+8|0]=X,u[e+9|0]=X>>>8,u[e+10|0]=X>>>16,u[e+11|0]=X>>>24,u[e+12|0]=r,u[e+13|0]=r>>>8,u[e+14|0]=r>>>16,u[e+15|0]=r>>>24,r=l[22888]|l[22889]<<8|(l[22890]<<16|l[22891]<<24),X=l[22884]|l[22885]<<8|(l[22886]<<16|l[22887]<<24),u[e|0]=X,u[e+1|0]=X>>>8,u[e+2|0]=X>>>16,u[e+3|0]=X>>>24,u[e+4|0]=r,u[e+5|0]=r>>>8,u[e+6|0]=r>>>16,u[e+7|0]=r>>>24,u[e+24|0]=0,e=q(k+40|0,2,0,k+16|0),r=i[e+4>>2],i[o>>2]=i[e>>2],i[o+4>>2]=r,r=o+8|0;v:{if(u[e+19|0]>=0){X=i[e+12>>2],i[r>>2]=i[e+8>>2],i[r+4>>2]=X,i[r+8>>2]=i[e+16>>2],u[o+20|0]=1;break v}if(T(r,i[e+8>>2],i[e+12>>2]),r=u[e+19|0],u[o+20|0]=1,(r|0)>=0)break v;Z(i[e+8>>2])}if(u[k+27|0]>=0)break o;Z(i[k+16>>2]);break o}if((e|0)==1986618469)break h;if((e|0)!=1885954932)break _}e=p(352),i[e+4>>2]=0,i[e+8>>2]=0,i[e>>2]=94852,r=Yu(e+16|0,F),i[r+308>>2]=0,i[r+312>>2]=0,u[r+300|0]=0,i[r+296>>2]=0,i[r+288>>2]=0,i[r+316>>2]=0,i[r+320>>2]=0,i[r>>2]=106672,i[r+304>>2]=r+308,i[r+324>>2]=0,i[r+328>>2]=0,i[r+332>>2]=0;break s}i[k+132>>2]=0,i[k+104>>2]=72196,i[k+48>>2]=72176,e=i[18053],i[k+40>>2]=e,f0=i[e-12>>2],e=k+40|0,i[f0+e>>2]=i[18054],i[k+44>>2]=0,R=e+i[i[k+40>>2]-12>>2]|0,N=k+52|0,J0(R,N),u[R+80|0]=0,i[R+72>>2]=0,R=i[18055],i[k+48>>2]=R,S=k+48|0,i[S+i[R-12>>2]>>2]=i[18056],R=i[18052],i[k+40>>2]=R,i[e+i[R-12>>2]>>2]=i[18057],i[k+104>>2]=72196,i[k+40>>2]=72156,i[k+48>>2]=72176,R=R0(N),i[R>>2]=71232,i[k+92>>2]=0,i[k+96>>2]=0,i[k+84>>2]=0,i[k+88>>2]=0,i[k+100>>2]=24,e=Y(S,27340,37),N=k+16|0,L1(N,i[r+108>>2]),f0=e,e=u[k+27|0],r=(e|0)<0,Y(Y(f0,r?i[k+16>>2]:N,r?i[k+20>>2]:e),26294,2),u[k+27|0]<0&&Z(i[k+16>>2]),e=i[k+100>>2];_:{h:{if(e&16){e=i[k+96>>2],r=i[k+76>>2],e>>>0<r>>>0&&(i[k+96>>2]=r,e=r),r=k+72|0;break h}if(!(e&8)){e=0,u[k+15|0]=0,r=k+4|0;break _}e=i[k+68>>2],r=k+60|0}h:{if(N=i[r>>2],e=e-N|0,e>>>0<2147483640){if(e>>>0>=11){S=e|7,r=p(S+1|0),i[k+12>>2]=S-2147483647,i[k+4>>2]=r,i[k+8>>2]=e;break h}if(u[k+15|0]=e,r=k+4|0,e)break h;e=0;break _}Q0(),H()}if(!e)break _;x(r,N,e)}u[e+r|0]=0,e=q(k+16|0,4,3008,k+4|0),r=i[e+4>>2],i[o>>2]=i[e>>2],i[o+4>>2]=r,r=o+8|0;_:{if(u[e+19|0]>=0){N=i[e+12>>2],i[r>>2]=i[e+8>>2],i[r+4>>2]=N,i[r+8>>2]=i[e+16>>2],u[o+20|0]=1;break _}if(T(r,i[e+8>>2],i[e+12>>2]),r=u[e+19|0],u[o+20|0]=1,(r|0)>=0)break _;Z(i[e+8>>2])}u[k+15|0]<0&&Z(i[k+4>>2]),e=i[18051],i[k+40>>2]=e,i[i[e-12>>2]+(k+40|0)>>2]=i[18059],i[k+48>>2]=i[18060],i[R>>2]=71232,u[k+95|0]<0&&Z(i[k+84>>2]),E0(R),y0(k+104|0);break l}if(e=e+8|0,(s|0)==(e|0))break}e=p(32),i[k+16>>2]=e,i[k+20>>2]=24,i[k+24>>2]=-2147483616,r=l[23258]|l[23259]<<8|(l[23260]<<16|l[23261]<<24),s=l[23254]|l[23255]<<8|(l[23256]<<16|l[23257]<<24),u[e+16|0]=s,u[e+17|0]=s>>>8,u[e+18|0]=s>>>16,u[e+19|0]=s>>>24,u[e+20|0]=r,u[e+21|0]=r>>>8,u[e+22|0]=r>>>16,u[e+23|0]=r>>>24,r=l[23250]|l[23251]<<8|(l[23252]<<16|l[23253]<<24),s=l[23246]|l[23247]<<8|(l[23248]<<16|l[23249]<<24),u[e+8|0]=s,u[e+9|0]=s>>>8,u[e+10|0]=s>>>16,u[e+11|0]=s>>>24,u[e+12|0]=r,u[e+13|0]=r>>>8,u[e+14|0]=r>>>16,u[e+15|0]=r>>>24,r=l[23242]|l[23243]<<8|(l[23244]<<16|l[23245]<<24),s=l[23238]|l[23239]<<8|(l[23240]<<16|l[23241]<<24),u[e|0]=s,u[e+1|0]=s>>>8,u[e+2|0]=s>>>16,u[e+3|0]=s>>>24,u[e+4|0]=r,u[e+5|0]=r>>>8,u[e+6|0]=r>>>16,u[e+7|0]=r>>>24,u[e+24|0]=0,e=q(k+40|0,2,0,k+16|0),r=i[e+4>>2],i[o>>2]=i[e>>2],i[o+4>>2]=r,r=o+8|0;w:{if(u[e+19|0]>=0){s=i[e+12>>2],i[r>>2]=i[e+8>>2],i[r+4>>2]=s,i[r+8>>2]=i[e+16>>2],u[o+20|0]=1;break w}if(T(r,i[e+8>>2],i[e+12>>2]),r=u[e+19|0],u[o+20|0]=1,(r|0)>=0)break w;Z(i[e+8>>2])}if(u[k+27|0]>=0)break u;Z(i[k+16>>2]);break u}W[i[i[r>>2]+8>>2]](k+40|0,r,m);s:{if(i[k+40>>2]){if(r=i[k+44>>2],i[o>>2]=i[k+40>>2],i[o+4>>2]=r,r=o+8|0,u[k+59|0]>=0){R=i[k+52>>2],i[r>>2]=i[k+48>>2],i[r+4>>2]=R,i[r+8>>2]=i[k+56>>2],r=1;break s}T(r,i[k+48>>2],i[k+52>>2]),r=1;break s}i[e+4>>2]=i[e+4>>2]+1,i[o+4>>2]=e,i[o>>2]=r,r=0}if(u[o+20|0]=r,u[k+59|0]<0&&Z(i[k+48>>2]),r=i[e+4>>2],i[e+4>>2]=r-1,r)break l;W[i[i[e>>2]+8>>2]](e),y(e)}if(!X||(e=i[X+4>>2],i[X+4>>2]=e-1,e))break o;W[i[i[X>>2]+8>>2]](X),y(X)}if(!s||(e=i[s+4>>2],i[s+4>>2]=e-1,e))break u;W[i[i[s>>2]+8>>2]](s),y(s)}v=k+192|0,r=107664,k=107676,o=107683,e=107672;u:switch(l[_+44|0]){case 1:r=_+24|0,e=w,o=n,k=f;break;case 0:break u;default:break n}X=i[r+4>>2],r=i[r>>2],i[_>>2]=r,i[_+4>>2]=X;u:{if(u[o|0]>=0){o=i[e+4>>2],i[E>>2]=i[e>>2],i[E+4>>2]=o,i[E+8>>2]=i[e+8>>2],e=r;break u}T(E,i[e>>2],i[k>>2]),e=i[_>>2]}u:{if(!e){r=1,e=0;break u}if(!((e|0)!=4|i[_+4>>2]!=3008)){r=1,e=1;break u}r=107664,k=107676,o=107683,e=107672;o:switch(l[_+44|0]){case 1:r=_+24|0,e=w,o=n,k=f;break;case 0:break o;default:break n}s=i[r+4>>2],i[A>>2]=i[r>>2],i[A+4>>2]=s;o:{if(u[o|0]>=0){r=i[e+4>>2],i[V>>2]=i[e>>2],i[V+4>>2]=r,i[V+8>>2]=i[e+8>>2];break o}T(V,i[e>>2],i[k>>2])}r=0,e=0}if(u[_+19|0]<0&&Z(i[_+8>>2]),r){u:{if(e)break u;if(l[_+44|0])break n;X=i[_+24>>2],s=i[_+28>>2];o:{if(!s){o=i[X+24>>2];break o}e=i[s+4>>2],i[s+4>>2]=e+1,o=i[X+24>>2],i[s+4>>2]=e+2}o:{l:{k=h,r=k,e=i[r>>2];s:{if(!e)break s;for(;;){if(r=e,e=i[r+16>>2],e>>>0>o>>>0){if(k=r,e=i[r>>2],e)continue;break s}if(e>>>0>=o>>>0)break l;if(e=i[r+4>>2],!e)break}k=r+4|0}e=p(28),i[e+24>>2]=s,i[e+20>>2]=X,i[e+16>>2]=o,i[e+8>>2]=r,i[e>>2]=0,i[e+4>>2]=0,i[k>>2]=e,r=i[i[F+180>>2]>>2],r&&(i[F+180>>2]=r),m1(i[F+184>>2],e),i[F+188>>2]=i[F+188>>2]+1;break o}if(!s||(e=i[s+4>>2],i[s+4>>2]=e-1,e))break o;W[i[i[s>>2]+8>>2]](s),y(s)}if(e=i[X+28>>2],i[F+192>>2]|!((e|0)==1885954932|(e|0)==1986618469)||(i[F+192>>2]=i[X+24>>2]),!s||(e=i[s+4>>2],i[s+4>>2]=e-1,e))break u;W[i[i[s>>2]+8>>2]](s),y(s)}if(e=l[_+44|0],(e|0)!=255&&(i[_>>2]=B,i[_+4>>2]=z,W[i[_+(e<<2)>>2]](_+63|0,_+24|0)),e=m+8|0,(t|0)!=(e|0))continue;break t}break}if(e=l[_+44|0],(e|0)==255)break f;r=i[23603],i[_>>2]=i[23602],i[_+4>>2]=r,W[i[_+(e<<2)>>2]](_+63|0,_+24|0);break f}i[_+56>>2]=0,i[_+48>>2]=0,i[_+52>>2]=0}if(i[_+32>>2]=0,i[_+24>>2]=0,i[_+28>>2]=0,r=i[F+180>>2],(h|0)==(r|0))break A;for(;;){r2(_+24|0,r+20|0),o=i[r+4>>2];t:{if(o){for(;;)if(e=o,o=i[o>>2],!o)break t}for(;e=i[r+8>>2],f=i[e>>2]!=(r|0),r=e,!!f;);}if(r=e,(h|0)==(r|0))break}break k}_2(),H()}r=i[F+180>>2]}A:{if((r|0)!=(h|0))for(;;){if(e=i[r+20>>2],W[i[i[e>>2]+12>>2]](A,e,F,_+24|0),i[A>>2])break A;u[A+19|0]<0&&Z(i[A+8>>2]),o=i[r+4>>2];k:{if(o){for(;;)if(e=o,o=i[o>>2],!o)break k}for(;e=i[r+8>>2],f=i[e>>2]!=(r|0),r=e,!!f;);}if(r=e,(h|0)==(r|0))break}if(e=i[26917],i[A>>2]=i[26916],i[A+4>>2]=e,e=A+8|0,u[107683]>=0){r=i[26919],i[e>>2]=i[26918],i[e+4>>2]=r,i[e+8>>2]=i[26920];break A}T(e,i[26918],i[26919])}if(f=i[_+24>>2],!f)break f;if(r=i[_+28>>2],e=f,(r|0)!=(f|0)){for(;;){e=i[r-4>>2];A:{if(!e||(o=i[e+4>>2],i[e+4>>2]=o-1,o))break A;W[i[i[e>>2]+8>>2]](e),y(e)}if(r=r-8|0,(f|0)==(r|0))break}e=i[_+24>>2]}i[_+28>>2]=f,Z(e)}if(f=i[_+48>>2],f){if(r=i[_+52>>2],e=f,(r|0)!=(f|0)){for(;;){e=i[r-4>>2];f:{if(!e||(o=i[e+4>>2],i[e+4>>2]=o-1,o))break f;W[i[i[e>>2]+8>>2]](e),y(e)}if(r=r-8|0,(f|0)==(r|0))break}e=i[_+48>>2]}i[_+52>>2]=f,Z(e)}f:{if(!Q||(e=i[Q+4>>2],i[Q+4>>2]=e-1,e))break f;W[i[i[Q>>2]+8>>2]](Q),y(Q)}f:{if(!I||(e=i[I+4>>2],i[I+4>>2]=e-1,e))break f;W[i[i[I>>2]+8>>2]](I),y(I)}if(v=_- -64|0,i[A>>2])break e;if(u[A+19|0]>=0)break r;Z(i[A+8>>2])}if(e=i[26917],i[A>>2]=i[26916],i[A+4>>2]=e,A=A+8|0,u[107683]>=0){e=i[26919],i[A>>2]=i[26918],i[A+4>>2]=e,i[A+8>>2]=i[26920];return}T(A,i[26918],i[26919])}return}G0(),H()}function I7(A,e){var r=0,f=0,k=0,n=0,t=0,o=0,s=0,w=0,h=0,_=0,B=0,m=0,X=0,Q=0,V=0,F=0,I=0,E=0,R=0,N=0,M=0,z=0,S=0,O=0,P=0,a=0,$=0,f0=0,A0=0,n0=0,_0=0,m0=0,X0=0,g0=0,I0=0,e0=0,r0=0;X0=v-16|0,v=X0;i:{e:{r:{f:{A:{if(i[A+580>>2])break A;n=l[A+549|0];k:{k=l[A+548|0];n:{if(!(k&1)&&(o=0,!(n&1)))break n;if(i[A+3208>>2]==i[A+3212>>2])break k;f=n,o=k}if(o&1|f&1)break A;if(r=13,!e)break f;i[e>>2]=1;break f}if(xl(A+2140|0),!e)break f;i[e>>2]=i[A+2192>>2];break f}if(!oo(A+2140|0,0)){if(r=9,!e)break f;i[e>>2]=1;break f}n=i[A+580>>2];A:{k:{if(n){if(n?(k=i[A+564>>2],o=i[A+576>>2],f=i[i[k+(o>>>8&16777212)>>2]+((o&1023)<<2)>>2],i[A+580>>2]=n-1,n=o+1|0,i[A+576>>2]=n,n>>>0>=2048&&(Z(i[k>>2]),i[A+564>>2]=i[A+564>>2]+4,i[A+576>>2]=i[A+576>>2]-1024),i[A+584>>2]=i[A+584>>2]-i[f+24>>2]):f=0,O=f,!f)break r;P=v-32|0,v=P,w=i[f+20>>2],h=i[f+24>>2],f=P+8|0,i[f+16>>2]=0,i[f+8>>2]=0,i[f+12>>2]=0,i[f+4>>2]=h,i[f>>2]=w,n=-64;n:{if(!h||(i[f>>2]=w+1,o=l[w|0],k=h-1|0,i[f+4>>2]=k,i[f+8>>2]=0,o=o<<24,i[f+12>>2]=o,!k)||(i[f>>2]=w+2,k=l[w+1|0],m=h-2|0,i[f+4>>2]=m,o=k<<16|o,k=o,i[f+8>>2]=_,i[f+12>>2]=k,!m)||(i[f>>2]=w+3,o=l[w+2|0],m=h-3|0,i[f+4>>2]=m,o=o<<8|k,k=o,i[f+8>>2]=t,i[f+12>>2]=k,!m)||(i[f>>2]=w+4,o=l[w+3|0],m=h-4|0,i[f+4>>2]=m,i[f+8>>2]=t,o=k|o,i[f+12>>2]=o,!m)||(i[f>>2]=w+5,k=l[w+4|0],Q=h-5|0,i[f+4>>2]=Q,m=k<<24|_,i[f+8>>2]=m,o=k>>>8|o,i[f+12>>2]=o,!Q)||(i[f>>2]=w+6,k=l[w+5|0],Q=h-6|0,i[f+4>>2]=Q,_=k<<16|m,i[f+8>>2]=_,o=k>>>16|o,i[f+12>>2]=o,!Q)||(i[f>>2]=w+7,k=l[w+6|0],m=h-7|0,i[f+4>>2]=m,t=o,o=_,_=k>>>24|0,o=o|k<<8,i[f+8>>2]=o,k=t|_,i[f+12>>2]=k,!m))break n;i[f>>2]=w+8,n=l[w+7|0],i[f+4>>2]=h-8,i[f+8>>2]=n|o,i[f+12>>2]=k,n=-56}i[f+16>>2]=(((h>>>0>=7?7:h)<<3)+n|0)- -64,u[P+7|0]=0,u[P+5|0]=0,u[P+6|0]=0,E6(f,1),e0=P,r0=v0(f,6),u[e0+5|0]=r0,e0=P,r0=v0(f,6),u[e0+6|0]=r0,e0=P,r0=v0(f,3)-1|0,u[e0+7|0]=r0,f=l[P+5|0],u[A+3204|0]=f,u[A+3206|0]=(f&248)==16,u[A+3205|0]=(f-19&255)>>>0<2;n:{if(l[P+6|0]){R4(A+548|0,O);break n}if(i[A+1904>>2]<l[P+7|0]){R4(A+548|0,O);break n}if(f>>>0<=31){s=A,_=P+8|0,B=v-16|0,v=B,k=p(1364),i[k+792>>2]=0,i[k+784>>2]=0,i[k+788>>2]=0,i[k+4>>2]=0,i[k+8>>2]=0,S=k+1340|0,A=S,i[A>>2]=0,i[A+4>>2]=0,i[k+1360>>2]=0,i[k+1352>>2]=0,i[k+1356>>2]=0,A=i[k+8>>2],i[k+4>>2]=0,i[k+8>>2]=0;t:{if(!A||(r=i[A+4>>2],i[A+4>>2]=r-1,r))break t;W[i[i[A>>2]+8>>2]](A),y(A)}u[k+40|0]=0,i[k+36>>2]=0,u[k+20|0]=0,i[k+16>>2]=0,g[k+12>>1]=0,i[k>>2]=0,i[k+24>>2]=0,i[k+28>>2]=0,g[k+32>>1]=0,o0(k+42|0,0,100),i[k+776>>2]=0,i[k+780>>2]=0,o0(k+144|0,0,237),o0(k+384|0,0,358),u[k+759|0]=0,u[k+760|0]=0,u[k+761|0]=0,u[k+762|0]=0,i[k+752>>2]=0,i[k+756>>2]=0,i[k+744>>2]=0,i[k+748>>2]=0,i[k+764>>2]=0,i[k+768>>2]=0,u[k+772|0]=0,i[k+796>>2]=0,i[k+800>>2]=0,i[k+804>>2]=0,i[k+808>>2]=0,i[k+812>>2]=0,i[k+816>>2]=0,i[k+788>>2]=i[k+784>>2],o0(k+820|0,0,100),o0(k+920|0,0,420),u[k+1348|0]=0,i[k+1356>>2]=i[k+1352>>2],u[B+15|0]=0,A=i[k+8>>2],i[k+4>>2]=0,i[k+8>>2]=0;t:{if(!A||(r=i[A+4>>2],i[A+4>>2]=r-1,r))break t;W[i[i[A>>2]+8>>2]](A),y(A)}u[k+40|0]=0,i[k+36>>2]=0,u[k+20|0]=0,i[k+16>>2]=0,g[k+12>>1]=0,i[k>>2]=0,i[k+24>>2]=0,i[k+28>>2]=0,g[k+32>>1]=0,o=k+42|0,o0(o,0,100),i[k+776>>2]=0,i[k+780>>2]=0,o0(k+144|0,0,237),o0(k+384|0,0,358),u[k+759|0]=0,u[k+760|0]=0,u[k+761|0]=0,u[k+762|0]=0,i[k+752>>2]=0,i[k+756>>2]=0,i[k+744>>2]=0,i[k+748>>2]=0,i[k+764>>2]=0,i[k+768>>2]=0,u[k+772|0]=0,i[k+796>>2]=0,i[k+800>>2]=0,i[k+804>>2]=0,i[k+808>>2]=0,i[k+812>>2]=0,i[k+816>>2]=0,i[k+788>>2]=i[k+784>>2],h=k+820|0,o0(h,0,100),o0(k+920|0,0,420),u[k+1348|0]=0,u[k+20|0]=0,i[k+1356>>2]=i[k+1352>>2],e0=k,r0=v0(_,1),u[e0+12|0]=r0,l[s+3206|0]&&(e0=k,r0=v0(_,1),u[e0+13|0]=r0),A=f2(_),i[k+16>>2]=A;t:{u:{o:{l:{s:{if(!((A|0)!=-99999&(A|0)<=63)||(A=s+(A<<3)|0,f=i[A+856>>2],!f))break s;r=i[A+860>>2],r&&(i[r+4>>2]=i[r+4>>2]+1),i[k+4>>2]=f,A=i[k+8>>2],i[k+8>>2]=r;w:{if(!A||(r=i[A+4>>2],i[A+4>>2]=r-1,r))break w;W[i[i[A>>2]+8>>2]](A),y(A)}if(r=i[k+4>>2],w=i[r+4>>2],!l[w|0]){F2(s+4|0,1010,0);break l}w:{_:{h:{B:{v:{if(!l[k+12|0]){for(A=0,l[r+14|0]?r=v0(_,1):r=0,u[k+20|0]=r,f=i[w+16908>>2];r=A,A=r+1|0,(f|0)>1<<r;);if(f=v0(_,r),t=l[k+20|0],t){if(!f){u[B+15|0]=0,F2(s+4|0,1021,0),A=0;break t}if(r=i[s+2220>>2],A=16,!r)break t;i[k>>2]=i[r>>2],A=i[r+4>>2],n=i[r+8>>2],n&&(i[n+4>>2]=i[n+4>>2]+1),i[k+4>>2]=A,A=i[k+8>>2],i[k+8>>2]=n;Z:{if(!A||(n=i[A+4>>2],i[A+4>>2]=n-1,n))break Z;W[i[i[A>>2]+8>>2]](A),y(A)}x(k+12|0,r+12|0,772);Z:{if((r|0)!=(k|0)){A=i[r+784>>2],n=i[r+788>>2],k6(k+784|0,A,n,n-A>>2),x(k+796|0,r+796|0,544),ni(k+1340|0,r+1340|0),u[k+1348|0]=l[r+1348|0],A=i[r+1352>>2],r=i[r+1356>>2],k6(k+1352|0,A,r,r-A>>2);break Z}x(k+796|0,r+796|0,544),ni(k+1340|0,r+1340|0),u[k+1348|0]=l[r+1348|0]}u[k+20|0]=1,u[k+12|0]=0}if(i[k+24>>2]=f,(f|0)<0)break w;if((f|0)<i[w+16908>>2])break v;break w}if(i[k+24>>2]=0,u[k+20|0]=0,i[w+16908>>2]<=0)break w;r=i[k+4>>2];break B}if(r=i[k+4>>2],t)break h}if(A=0,u[r+8240|0]>0)for(;E6(_,1),A=A+1|0,(A|0)<u[i[k+4>>2]+8240|0];);if(A=f2(_),i[k+28>>2]=A,!((A|0)!=-99999&(A|0)<=2)){F2(s+4|0,1007,0);break l}l[i[k+4>>2]+43|0]?A=v0(_,1):A=1,u[k+32|0]=A,l[w+480|0]==1&&(e0=k,r0=v0(_,2),u[e0+33|0]=r0),u[k+40|0]=0,i[k+36>>2]=0;B:{v:{Z:{G:{m:{if((l[s+3204|0]-19&255)>>>0>=2){e0=k,r0=v0(_,i[w+520>>2]),i[e0+36>>2]=r0,A=v0(_,1),u[k+40|0]=A;X:{if(!(A&255)){m9(s+4|0,w,_,o,(i[w+8820>>2]-i[w+8816>>2]|0)/100|0,w+8816|0,1),i[k+816>>2]=(i[w+8820>>2]-i[w+8816>>2]|0)/100;break X}for(o=i[w+8816>>2],t=(i[w+8820>>2]-o|0)/100|0,r=0;A=r,r=r+1|0,1<<A<(t|0););W:{if(!A){A=0;break W}A=v0(_,A),o=i[w+8816>>2],t=(i[w+8820>>2]-o|0)/100|0}if(i[k+144>>2]=A,(A|0)>=(t|0))break G;i[k+816>>2]=A,o=G(A,100)+o|0}x(h,o,100);X:{if(l[w+8828|0]){W:{if(i[w+8832>>2]>0){if(A=f2(_),i[k+148>>2]=A,(A|0)!=-99999)break W;A=8;break t}i[k+148>>2]=0}if(r=f2(_),i[k+152>>2]=r,o=8,(r|0)==-99999)break _;if(A=i[k+148>>2],r=r+A|0,i[(w+(u[w+2|0]<<2)|0)+524>>2]<(l[k+917|0]+(r+l[k+916|0]|0)|0))break Z;if((r|0)<=0)break X;for(f=s+2352|0,n=k+268|0,m=k+252|0,Q=w+8964|0,X=w+8836|0,F=k+156|0,E=s+2288|0,h=s+2224|0,V=k+236|0,N=k+172|0,t=0;;){W:{if((A|0)>(t|0)){for(z=i[w+8832>>2],A=0;r=A,A=r+1|0,(z|0)>1<<r;);if(A=t+F|0,r=v0(_,r),u[A|0]=r,r=r&255,(r|0)<i[w+8832>>2]){i[h+(t<<2)>>2]=i[X+(r<<2)>>2],A=Q+l[A|0]|0;break W}F2(s+4|0,1023,0);break l}r=t<<2,z=r+N|0,e0=z,r0=v0(_,i[w+520>>2]),i[e0>>2]=r0,A=t+V|0,e0=A,r0=v0(_,1),u[e0|0]=r0,i[r+h>>2]=i[z>>2]}r=t<<2,z=u[A|0],i[r+E>>2]=z,A=v0(_,1),u[t+m|0]=A;W:{if(A&255){if(A=f2(_),i[r+n>>2]=A,(A|0)!=-99999)break W;break _}A=0,i[r+n>>2]=0}if(I=((z|0)!=0)+I|0,i[r+f>>2]=!t|i[k+148>>2]==(t|0)?A:i[(r+f|0)-4>>2]+A|0,t=t+1|0,A=i[k+148>>2],!((t|0)<(A+i[k+152>>2]|0)))break}break X}i[k+148>>2]=0,i[k+152>>2]=0}if(l[w+8996|0]){e0=k,r0=v0(_,1),u[e0+332|0]=r0;break m}u[k+332|0]=0;break m}i[k+148>>2]=0,i[k+152>>2]=0}m:{if(l[w+8799|0]){if(e0=k,r0=v0(_,1),u[e0+333|0]=r0,A=0,!i[w+16848>>2])break m;A=v0(_,1);break m}u[k+333|0]=0,A=0}if(i[k+336>>2]=0,i[k+340>>2]=0,u[k+334|0]=A,u0[k+28>>2]>1)break B;A=v0(_,1),u[k+335|0]=A;m:{if(A&255){if(A=f2(_),i[k+336>>2]=A,(A|0)==-99999)break o;if(A=A+1|0,i[k+336>>2]=A,i[k+28>>2]){r=i[k+340>>2];break m}if(A=f2(_),i[k+340>>2]=A,(A|0)==-99999)break o;r=A+1|0,i[k+340>>2]=r,A=i[k+336>>2];break m}r=i[k+4>>2],A=u[r+17|0],i[k+336>>2]=A,r=u[r+18|0],i[k+340>>2]=r}if(o=8,(A|0)>16|(r|0)>16)break _;f=l[k+919|0]+I|0,i[k+920>>2]=f;m:{X:{if(!(!l[i[k+4>>2]+8233|0]|(f|0)<2)){for(r=0;A=r,r=r+1|0,(f|0)>1<<A;);if(r=v0(_,1),u[k+344|0]=r,!(!(r&255)|i[k+336>>2]<=0))for(f=k+346|0,r=0;e0=r+f|0,r0=v0(_,A),u[e0|0]=r0,r=r+1|0,(r|0)<i[k+336>>2];);if(!i[k+28>>2]){if(r=v0(_,1),u[k+345|0]=r,!(r&255)|i[k+340>>2]<=0)break X;for(f=k+362|0,r=0;e0=r+f|0,r0=v0(_,A),u[e0|0]=r0,r=r+1|0,(r|0)<i[k+340>>2];);break X}u[k+345|0]=0;break m}g[k+344>>1]=0}if(i[k+28>>2])break m;e0=k,r0=v0(_,1),u[e0+378|0]=r0}if(l[i[k+4>>2]+16|0]?A=v0(_,1):A=0,u[k+379|0]=A,!l[k+332|0])break v;A=1,i[k+28>>2]||(A=v0(_,1)),u[k+380|0]=A,r=A&255;m:{if(!(i[k+340>>2]<2|r)||i[k+336>>2]>1&&r){if(r=f2(_),i[k+384>>2]=r,(r|0)!=-99999){A=l[k+380|0];break m}break o}r=0,i[k+384>>2]=0}m:{if(A&255){if(i[k+336>>2]<=(r|0))break m;break v}if(i[k+340>>2]>(r|0))break v}break u}F2(s+4|0,1015,0),A=8;break t}F2(s+4|0,1018,0);break l}v:{if(A=i[k+4>>2],r=i[k+28>>2],!(!(r|!l[A+42|0])||(r|0)==1&&l[A+41|0]))break v;n=0;Z:{G:{if(A=i[(s+(i[k+16>>2]<<3)|0)+856>>2],A){if(t=i[(s+(u[A+13|0]<<3)|0)+728>>2],!t)break G;A=f2(_),u[k+388|0]=A;m:{if(A>>>0>7)break m;if(i[t+476>>2]){if(A=K1(_)+l[k+388|0]|0,A>>>0>7)break m;u[k+389|0]=A}for(R=k+679|0,A0=k+552|0,F=k+678|0,E=k+550|0,m0=k+518|0,V=k+454|0,N=k+422|0,a=k+390|0,f=k+336|0,o=k+340|0,r=1;;){A=f;X:{if(r||(A=o,!i[k+28>>2]))break X;n=1;break Z}if(h=0,Q=i[A>>2],(Q|0)>0){for(;I=n<<4,_0=I+a|0,e0=_0+h|0,r0=v0(_,1),u[e0|0]=r0,h=h+1|0,(Q|0)!=(h|0););if(h=0,i[t+476>>2])for(;e0=(I+N|0)+h|0,r0=v0(_,1),u[e0|0]=r0,h=h+1|0,(Q|0)!=(h|0););for(m=n<<5,M=m+R|0,z=n<<6,$=z+A0|0,h=0;;){X:{if(l[h+_0|0]){if(n=0,A=K1(_),A-128>>>0<4294967040)break Z;if(g[(m+V|0)+(h<<1)>>1]=A+(1<<l[k+388|0]),A=K1(_),X=i[t+16996>>2],(A|0)<(0-X|0))break m;if((A|0)<(X|0))break X;break m}g[(m+V|0)+(h<<1)>>1]=1<<l[k+388|0],A=0}u[(I+m0|0)+h|0]=A,I0=M+(h<<1)|0;X:{W:{if(l[(I+N|0)+h|0]){if(A=K1(_),A-128>>>0>=4294967040)break W;n=0;break Z}A=h<<2,n=1<<l[k+389|0],g[A+(E+z|0)>>1]=n,u[(m+F|0)+(h<<1)|0]=0,g[A+$>>1]=n,A=0;break X}if(f0=h<<2,n0=f0+(E+z|0)|0,g[n0>>1]=A+(1<<l[k+389|0]),n=0,X=K1(_),A=i[t+17e3>>2],g0=A<<2,(X|0)<(0-g0|0)|(X|0)>=(g0|0)||(g0=0-A|0,X=(A+X|0)-(G(A,g[n0>>1])>>l[k+389|0])|0,u[(m+F|0)+(h<<1)|0]=(X|0)<(g0|0)?g0:(A|0)>(X|0)?X:A-1|0,A=K1(_),A-128>>>0<4294967040)||(f0=$+f0|0,g[f0>>1]=A+(1<<l[k+389|0]),X=K1(_),A=i[t+17e3>>2],n0=A<<2,(X|0)<(0-n0|0)|(X|0)>=(n0|0)))break m;n0=0-A|0,n=(A+X|0)-(G(A,g[f0>>1])>>l[k+389|0])|0,A=(n|0)<(n0|0)?n0:(A|0)>(n|0)?n:A+255|0}if(u[I0|0]=A,h=h+1|0,(Q|0)==(h|0))break}}if(n=1,A=r,r=0,!A)break}}break Z}D0(4839,18297,152,13617),H()}D0(4835,18297,154,13617),H()}if(n)break v;break u}if(A=f2(_),i[k+744>>2]=A,(A|0)==-99999)break o;i[k+812>>2]=5-A}if(A=K1(_),i[k+748>>2]=A,(A|0)==-99999)break o;A=i[k+4>>2];B:{if(l[A+40|0]){if(A=K1(_),i[k+752>>2]=A,(A|0)==-99999)break o;if(A=K1(_),i[k+756>>2]=A,(A|0)!=-99999){A=i[k+4>>2];break B}break o}i[k+752>>2]=0,i[k+756>>2]=0}l[A+8248|0]==1&&(e0=k,r0=v0(_,1),u[e0+760|0]=r0,A=i[k+4>>2]);B:{v:{if(!l[A+60|0]){u[k+761|0]=0,i[k+764>>2]=i[A+64>>2],i[k+768>>2]=i[A+68>>2];break v}if(r=v0(_,1),u[k+761|0]=r,A=i[k+4>>2],i[k+764>>2]=i[A+64>>2],i[k+768>>2]=i[A+68>>2],!(r&255))break v;if(A=v0(_,1),u[k+762|0]=A,A&255)break B;if(A=K1(_),i[k+764>>2]=A,(A|0)==-99999||(i[k+764>>2]=A<<1,A=K1(_),i[k+768>>2]=A,(A|0)==-99999))break o;i[k+768>>2]=A<<1;break B}u[k+762|0]=l[A+61|0]}if(r=i[k+4>>2],A=l[r+58|0],!(!A|!(!l[k+762|0]||l[k+333|0]|l[k+334|0]))){e0=k,r0=v0(_,1),u[e0+772|0]=r0,r=i[k+4>>2];break h}u[k+772|0]=A}h:{if(l[r+46|0]|l[r+45|0]){if(A=f2(_),i[k+776>>2]=A,(A|0)==-99999||(r=i[k+4>>2],!(!l[r+45|0]|i[w+16900>>2]>(A+(i[k+24>>2]/i[w+16892>>2]|0)|0))|!(!l[r+46|0]|(A|0)<=(G(i[r+52>>2],i[r+48>>2])|0))))break o;r=k+784|0,f=i[r>>2],n=i[r+4>>2]-f>>2;B:{if(n>>>0<A>>>0){V8(r,A-n|0);break B}A>>>0<n>>>0&&(i[r+4>>2]=f+(A<<2))}if(i[k+776>>2]<=0)break h;if(r=f2(_),i[k+780>>2]=r,(r|0)==-99999)break o;if(f=r+1|0,i[k+780>>2]=f,A=8,(r|0)>31)break t;if(i[k+776>>2]<=0||(A=1,r=v0(_,f),i[i[k+784>>2]>>2]=r+1,i[k+776>>2]<2))break h;for(;r=v0(_,i[k+780>>2]),f=i[k+784>>2]+(A<<2)|0,i[f>>2]=(r+i[f-4>>2]|0)+1,A=A+1|0,(A|0)<i[k+776>>2];);break h}i[k+776>>2]=0}h:{if(!l[i[k+4>>2]+8241|0])break h;if(r=f2(_),i[k+796>>2]=r,(r|0)==-99999|(r|0)>1e3)break o;if(A=0,(r|0)<=0)break h;for(;v0(_,8),A=A+1|0,(A|0)<i[k+796>>2];);}i[k+800>>2]=i[k+748>>2]+i[i[k+4>>2]+20>>2],A=0;h:{B:{v:switch(i[k+28>>2]){case 1:A=u[k+379|0]+1|0;break B;case 0:break v;case 2:break B;default:break h}A=2-u[k+379|0]|0}i[k+804>>2]=A}i[k+812>>2]=5-i[k+744>>2],u[B+15|0]=1,o=0}A=o;break t}F2(s+4|0,1020,0),A=8;break t}F2(s+4|0,1009,0),A=0;break t}u[B+15|0]=0,A=0;break t}F2(s+4|0,1007,0),A=8;break t}F2(s+4|0,8,0),A=8}i[B+8>>2]=A;t:{u:{if(!l[B+15|0]){A=i[s+2216>>2],A&&(u[A+312|0]=2),R4(s+548|0,O),A=i[k+1352>>2],A&&(i[k+1356>>2]=A,Z(A)),L8(S),A=i[k+784>>2],A&&(i[k+788>>2]=A,Z(A)),A=i[k+8>>2];o:{if(!A||(r=i[A+4>>2],i[A+4>>2]=r-1,r))break o;W[i[i[A>>2]+8>>2]](A),y(A)}Z(k),r=i[B+8>>2];break u}if(f=i[s+528>>2],(f|0)>=0)o:{A=v-864|0,v=A,r=67556;l:{s:{w:{_:switch(f-1|0){case 1:r=67552;break;case 0:break _;default:break w}if(r=i[r>>2],k0(r,42211,0),f=i[(s+(i[k+16>>2]<<3)|0)+856>>2],!f){k0(r,33478,0);break w}if(!l[f|0])break s;if(n=i[(s+(u[f+13|0]<<3)|0)+728>>2],!n){k0(r,33454,0);break w}if(!l[n|0])break l;i[A+848>>2]=u[k+12|0],k0(r,38692,A+848|0),(l[s+3204|0]&248)==16&&(i[A+832>>2]=u[k+13|0],k0(r,39330,A+832|0)),i[A+816>>2]=i[k+16>>2],k0(r,40052,A+816|0),l[k+12|0]||(i[A+800>>2]=u[k+20|0],k0(r,39287,A+800|0),i[A+784>>2]=i[k+24>>2],k0(r,40828,A+784|0)),o=i[k+28>>2],i[A+768>>2]=o?(o|0)==1?80:73:66,k0(r,41547,A+768|0),l[f+43|0]&&(i[A+752>>2]=u[k+32|0],k0(r,41276,A+752|0)),l[n+480|0]==1&&(i[A+736>>2]=u[k+33|0],k0(r,41319,A+736|0)),i[A+720>>2]=i[k+36>>2],k0(r,40560,A+720|0);_:{if((l[s+3204|0]-19&255)>>>0<2)break _;i[A+704>>2]=u[k+40|0],k0(r,38411,A+704|0),o=i[n+8820>>2]-i[n+8816>>2]|0;h:{B:{if(!l[k+40|0]){i[A+672>>2]=(o|0)/100,k0(r,32444,A+672|0),o=k+42|0;break B}if((o|0)<101)break h;i[A+688>>2]=i[k+144>>2],k0(r,39783,A+688|0),o=i[n+8816>>2]+G(i[k+144>>2],100)|0}_t(o,r)}if(l[n+8828|0]&&(i[n+8832>>2]>0&&(i[A+656>>2]=i[k+148>>2],k0(r,41453,A+656|0)),i[A+640>>2]=i[k+152>>2],k0(r,41362,A+640|0)),!l[n+8996|0])break _;i[A+624>>2]=u[k+332|0],k0(r,35996,A+624|0)}if(l[n+8799|0]&&(i[A+608>>2]=u[k+333|0],k0(r,40449,A+608|0),i[A+592>>2]=u[k+334|0],k0(r,40014,A+592|0)),u0[k+28>>2]<=1){i[A+576>>2]=u[k+335|0],k0(r,35703,A+576|0),o=l[k+335|0],i[A+560>>2]=i[k+336>>2],i[A+564>>2]=o?42673:26574,k0(r,33002,A+560|0),i[k+28>>2]||(o=l[k+335|0],i[A+544>>2]=i[k+340>>2],i[A+548>>2]=o?42673:26574,k0(r,32962,A+544|0));_:{if(!l[f+8233|0]|i[k+920>>2]<2)break _;if(i[A+528>>2]=u[k+344|0],k0(r,36621,A+528|0),!(!l[k+344|0]|i[k+336>>2]<=0))for(o=k+346|0,t=0;i[A+516>>2]=l[o+t|0],i[A+512>>2]=t,k0(r,34686,A+512|0),t=t+1|0,(t|0)<i[k+336>>2];);if(i[A+496>>2]=u[k+345|0],k0(r,36581,A+496|0),!l[k+345|0]|i[k+340>>2]<=0)break _;for(o=k+362|0,t=0;i[A+484>>2]=l[o+t|0],i[A+480>>2]=t,k0(r,34686,A+480|0),t=t+1|0,(t|0)<i[k+340>>2];);}i[k+28>>2]||(i[A+464>>2]=u[k+378|0],k0(r,40761,A+464|0)),i[A+448>>2]=u[k+379|0],k0(r,40904,A+448|0),l[k+332|0]&&(i[A+432>>2]=u[k+380|0],k0(r,39107,A+432|0),i[A+416>>2]=i[k+384>>2],k0(r,40250,A+416|0)),o=i[k+28>>2];_:{if(!(!(o|!l[f+42|0])||(o|0)==1&&l[f+41|0]))break _;if(i[A+400>>2]=l[k+388|0],k0(r,39250,A+400|0),i[n+476>>2]&&(i[A+384>>2]=l[k+389|0],k0(r,39578,A+384|0)),o=i[k+336>>2],(o|0)>0)for(w=k+678|0,h=k+550|0,m=k+518|0,Q=k+454|0,I=k+679|0,X=k+552|0,t=0;n=t<<1,i[A+376>>2]=g[n+Q>>1],i[A+372>>2]=t,i[A+368>>2]=0,k0(r,40487,A+368|0),i[A+360>>2]=u[t+m|0],i[A+356>>2]=t,i[A+352>>2]=0,k0(r,40213,A+352|0),F=t<<2,i[A+348>>2]=g[F+h>>1],i[A+344>>2]=0,i[A+340>>2]=t,i[A+336>>2]=0,k0(r,39144,A+336|0),i[A+332>>2]=u[n+w|0],i[A+328>>2]=0,i[A+324>>2]=t,i[A+320>>2]=0,k0(r,39182,A+320|0),i[A+316>>2]=g[X+F>>1],i[A+312>>2]=1,i[A+308>>2]=t,i[A+304>>2]=0,k0(r,39144,A+304|0),i[A+300>>2]=u[n+I|0],i[A+296>>2]=1,i[A+292>>2]=t,i[A+288>>2]=0,k0(r,39182,A+288|0),t=t+1|0,(o|0)!=(t|0););if(i[k+28>>2]||(o=i[k+340>>2],(o|0)<=0))break _;for(w=k+711|0,h=k+616|0,m=k+710|0,Q=k+614|0,I=k+534|0,X=k+486|0,t=0;n=t<<1,i[A+280>>2]=g[n+X>>1],i[A+276>>2]=t,i[A+272>>2]=1,k0(r,40487,A+272|0),i[A+264>>2]=u[t+I|0],i[A+260>>2]=t,i[A+256>>2]=1,k0(r,40213,A+256|0),F=t<<2,i[A+252>>2]=g[F+Q>>1],i[A+248>>2]=0,i[A+244>>2]=t,i[A+240>>2]=1,k0(r,39144,A+240|0),i[A+236>>2]=u[n+m|0],i[A+232>>2]=0,i[A+228>>2]=t,i[A+224>>2]=1,k0(r,39182,A+224|0),i[A+220>>2]=g[h+F>>1],i[A+216>>2]=1,i[A+212>>2]=t,i[A+208>>2]=1,k0(r,39144,A+208|0),i[A+204>>2]=u[n+w|0],i[A+200>>2]=1,i[A+196>>2]=t,i[A+192>>2]=1,k0(r,39182,A+192|0),t=t+1|0,(o|0)!=(t|0););}i[A+176>>2]=i[k+744>>2],k0(r,36970,A+176|0)}if(i[A+160>>2]=i[k+748>>2],k0(r,39478,A+160|0),l[f+40|0]&&(i[A+144>>2]=i[k+752>>2],k0(r,37868,A+144|0),i[A+128>>2]=i[k+756>>2],k0(r,37839,A+128|0)),l[f+60|0]&&(i[A+112>>2]=u[k+761|0],k0(r,35665,A+112|0)),n=l[k+761|0],i[A+96>>2]=u[k+762|0],i[A+100>>2]=n?26540:26369,k0(r,32915,A+96|0),l[k+762|0]|!l[k+761|0]||(i[A+80>>2]=i[k+764>>2],k0(r,36807,A+80|0),i[A+64>>2]=i[k+768>>2],k0(r,37422,A- -64|0)),!l[f+58|0]|!(!l[k+762|0]||l[k+333|0]|l[k+334|0])||(i[A+48>>2]=u[k+772|0],k0(r,35945,A+48|0)),!(l[f+46|0]|l[f+45|0])||(i[A+32>>2]=i[k+776>>2],k0(r,37484,A+32|0),i[k+776>>2]<=0)||(i[A+16>>2]=i[k+780>>2],k0(r,41021,A+16|0),i[k+776>>2]<=0))break w;for(t=0;i[A+4>>2]=i[i[k+784>>2]+(t<<2)>>2],i[A>>2]=t,k0(r,36519,A),t=t+1|0,(t|0)<i[k+776>>2];);}v=A+864|0;break o}D0(17839,18297,1287,7306),H()}D0(17825,18297,1294,7306),H()}n=i[O+8>>2],F=i[O+12>>2],E=i[O+16>>2],Q=v-80|0,v=Q,i[B+8>>2]=0,u[s+3220|0]=0,r=i[k+16>>2],f=s+(r<<3)|0,A=i[f+856>>2];o:{if(!(l[A|0]&&A)){if(i[Q>>2]=r,r=v-16|0,v=r,l[125269]|i[31316]<-9999||(A=i[16889],f=l[33502]==42,f||P1(32487,5,1,A),i[r+12>>2]=Q,Ur(A,f+33502|0,Q,1953,1954),n6(A)),v=r+16|0,A=i[i[s+2216>>2]+112>>2],r=i[A+84>>2],(r|0)==20){i[A+80>>2]=1001,r=0;break o}i[A+84>>2]=r+1,i[(A+(r<<2)|0)+4>>2]=1009,r=0;break o}r=i[f+860>>2],r&&(i[r+4>>2]=i[r+4>>2]+1),i[s+1384>>2]=A,A=i[s+1388>>2],i[s+1388>>2]=r;l:{if(!A||(r=i[A+4>>2],i[A+4>>2]=r-1,r))break l;W[i[i[A>>2]+8>>2]](A),y(A)}A=s+(u[i[s+1384>>2]+13|0]<<3)|0,f=i[A+728>>2],r=i[A+732>>2],r&&(i[r+4>>2]=i[r+4>>2]+1),i[s+1376>>2]=f,A=i[s+1380>>2],i[s+1380>>2]=r;l:{if(!A||(r=i[A+4>>2],i[A+4>>2]=r-1,r))break l;W[i[i[A>>2]+8>>2]](A),y(A)}A=s+(u[i[s+1376>>2]+1|0]<<3)|0,f=i[A+600>>2],r=i[A+604>>2],r&&(i[r+4>>2]=i[r+4>>2]+1),i[s+1368>>2]=f,A=i[s+1372>>2],i[s+1372>>2]=r;l:{if(!A||(r=i[A+4>>2],i[A+4>>2]=r-1,r))break l;W[i[i[A>>2]+8>>2]](A),y(A)}l:{s:{w:{_:{if(A=i[s+1376>>2],!A){if(A=i[s+1368>>2],A)break _;if(A=6,l[s+2108|0]!=6)break s;break l}if(t=u[A+2|0],A=t-1|0,(A|0)!=u[s+2108|0])break w;break l}if(t=i[A+8>>2],u[s+2108|0]==(t-1|0))break l;A=t-1|0}if((t|0)<=0)break l}for(V=s+2112|0,h=s+1908|0,m=A+1|0;;){r=G(A,100),w=(r+100|0)/(m|0)|0,f=(r|0)/(m|0)|0;s:{if((w|0)<(f|0)){r=A;break s}o=i[s+1888>>2];w:{if(f+w&1){r=A,t=f;break w}r=h+(f<<1)|0,u[r+1|0]=(A|0)>(o|0)?100:0,t=r,r=(A|0)<(o|0)?A:o,u[t|0]=r,t=f+1|0}if((f|0)==(w|0))break s;for(I=w-f|0,A=r;X=h+(t<<1)|0,r=(A|0)<(o|0)?A:o,u[X|0]=r,u[X+1|0]=(A|0)>(o|0)?100:(G(t-f|0,100)|0)/(I|0)|0,X=t+1|0,A=h+(X<<1)|0,u[A+1|0]=(G(X-f|0,100)|0)/(I|0),u[A|0]=r,t=t+2|0,A=r,(w|0)!=(X|0););}if(i[V+(r<<2)>>2]=w,A=r-1|0,!((r|0)>0))break}}A=s+(i[s+1892>>2]<<1)|0,r=u[A+1908|0],i[s+1896>>2]=r,i[s+1900>>2]=u[A+1909|0],i[s+1904>>2]=r;l:{s:{if(l[k+12|0]){if(i[s+2196>>2]=i[k+36>>2],A=i[s+1376>>2],r=l[A+8799|0],f=l[s+533|0],i[Q+72>>2]=A,A=i[s+1380>>2],i[Q+76>>2]=A,A&&(i[A+4>>2]=i[A+4>>2]+1),A=i[Q+76>>2],i[Q+40>>2]=i[Q+72>>2],i[Q+44>>2]=A,A=on(s+2140|0,Q+40|0,s,n,F,E,(f|!r)&1),(A|0)<0){r=0,i[B+8>>2]=0-A;break o}r=0,f=i[s+2148>>2],A>>>0<i[s+2152>>2]-f>>2>>>0&&(r=i[f+(A<<2)>>2]),i[s+2216>>2]=r,u[r+316|0]=l[P+7|0],A=l[P+5|0]|l[P+6|0]<<8,u[r+314|0]=A,u[r+315|0]=A>>>8,A=i[s+2216>>2],i[Q+64>>2]=i[s+1368>>2],r=i[s+1372>>2],i[Q+68>>2]=r,r&&(i[r+4>>2]=i[r+4>>2]+1),i[Q+56>>2]=i[s+1376>>2],r=i[s+1380>>2],i[Q+60>>2]=r,r&&(i[r+4>>2]=i[r+4>>2]+1),i[Q+48>>2]=i[s+1384>>2],r=i[s+1388>>2],i[Q+52>>2]=r,r&&(i[r+4>>2]=i[r+4>>2]+1),r=i[Q+68>>2],i[Q+32>>2]=i[Q+64>>2],i[Q+36>>2]=r,r=i[Q+60>>2],i[Q+24>>2]=i[Q+56>>2],i[Q+28>>2]=r,r=i[Q+52>>2],i[Q+16>>2]=i[Q+48>>2],i[Q+20>>2]=r,r=i[Q+32>>2],f=i[Q+36>>2],f&&(i[f+4>>2]=i[f+4>>2]+1),i[A+116>>2]=r,r=i[A+120>>2],i[A+120>>2]=f;w:{if(!r||(f=i[r+4>>2],i[r+4>>2]=f-1,f))break w;W[i[i[r>>2]+8>>2]](r),y(r)}r=i[Q+24>>2],f=i[Q+28>>2],f&&(i[f+4>>2]=i[f+4>>2]+1),i[A+124>>2]=r,r=i[A+128>>2],i[A+128>>2]=f;w:{if(!r||(f=i[r+4>>2],i[r+4>>2]=f-1,f))break w;W[i[i[r>>2]+8>>2]](r),y(r)}r=i[Q+16>>2],f=i[Q+20>>2],f&&(i[f+4>>2]=i[f+4>>2]+1),i[A+132>>2]=r,r=i[A+136>>2],i[A+136>>2]=f;w:{if(!r||(A=i[r+4>>2],i[r+4>>2]=A-1,A))break w;W[i[i[r>>2]+8>>2]](r),y(r)}A=i[Q+20>>2];w:{if(!A||(r=i[A+4>>2],i[A+4>>2]=r-1,r))break w;W[i[i[A>>2]+8>>2]](A),y(A)}A=i[Q+28>>2];w:{if(!A||(r=i[A+4>>2],i[A+4>>2]=r-1,r))break w;W[i[i[A>>2]+8>>2]](A),y(A)}A=i[Q+36>>2];w:{if(!A||(r=i[A+4>>2],i[A+4>>2]=r-1,r))break w;W[i[i[A>>2]+8>>2]](A),y(A)}A=i[s+2216>>2],i[A+112>>2]=s,o=0,h=0,r=i[A+160>>2];w:{if(!r||(f=G(i[A+164>>2],3),!f))break w;o0(r,0,f)}r=i[A+140>>2];w:{if(!r||(f=G(i[A+144>>2],24),!f))break w;o0(r,0,f)}r=i[A+260>>2];w:{if(!r||(f=i[A+264>>2],!f))break w;o0(r,0,f)}n=i[A+144>>2];w:{if((n|0)<=0)break w;if(A=i[A+320>>2],r=0,n>>>0>=8)for(t=A+532|0,w=A+456|0,m=A+380|0,I=A+304|0,X=A+228|0,F=A+152|0,E=A+76|0,V=n&2147483640;f=G(r,76),i[f+A>>2]=0,i[f+E>>2]=0,i[f+F>>2]=0,i[f+X>>2]=0,i[f+I>>2]=0,i[f+m>>2]=0,i[f+w>>2]=0,i[f+t>>2]=0,r=r+8|0,h=h+8|0,(V|0)!=(h|0););if(f=n&7,!f)break w;for(;i[A+G(r,76)>>2]=0,r=r+1|0,o=o+1|0,(f|0)!=(o|0););}A=l[s+3204|0];w:{if((A&248)!=16)break w;_:{if(!(u[s+2200|0]&1|((A|0)==18|(A&254)==16|(A-19&255)>>>0<2))&&!(u[s+2203|0]&1))break _;u[s+2203|0]=0,u[s+2201|0]=1;break w}u[s+2201|0]=0,u[s+2202|0]=0}w:{if(!(!(u[s+2201|0]&1)|(l[s+3204|0]&254)!=8)){u[i[s+2216>>2]+104|0]=0;break w}u[i[s+2216>>2]+104|0]=l[k+32|0]!=0}f=0;w:{if(!(!(u[s+2201|0]&1)|(l[s+3204|0]&248)!=16)){u[s+3220|0]=1,i[s+2204>>2]=0,A=i[k+36>>2];break w}A=i[k+36>>2],f=i[s+2208>>2],r=i[i[s+1376>>2]+16868>>2];_:{if(!((A|0)>=(f|0)|(f-A|0)<((r|0)/2|0))){o=r+i[s+2212>>2]|0;break _}if(o=i[s+2212>>2]-r|0,!((A|0)<=(f|0)|(A-f|0)<=((r|0)/2|0)))break _;o=i[s+2212>>2]}f=o,i[s+2204>>2]=f}r=i[s+2216>>2],i[r+92>>2]=A,i[r+96>>2]=A+f;w:{if(l[r+316|0]||(A=l[s+3204|0],!(A&241))||(A=A&254,(A|0)==8|(A|0)==6))break w;i[s+2208>>2]=i[k+36>>2],i[s+2212>>2]=i[s+2204>>2]}if(!l[k+12|0])break s;i[i[s+2216>>2]+100>>2]=1,f=0,o=0,h=0,n=0,m=v-32|0,v=m,i[m+28>>2]=0,i[m+20>>2]=0,i[m+24>>2]=0,r=i[s+2216>>2],I=i[r>>2];w:{_:{h:{B:{if(!(!(u[s+2201|0]&1)|(l[s+3204|0]&248)!=16)){if(A=i[s+2152>>2],t=i[s+2148>>2],(A|0)!=(t|0))for(E=i[r+96>>2];;){X=i[(f<<2)+t>>2];v:{if(!i[X+100>>2]|(E|0)<=i[X+96>>2]||(w=i[X>>2],w>>>0>=u0[X+108>>2]))break v;Z:{if(n>>>0<h>>>0){i[n>>2]=w,n=n+4|0;break Z}if(r=n-o|0,V=r>>2,F=V+1|0,F>>>0>=1073741824)break B;if(n=h-o|0,h=n>>1,F=n>>>0>=2147483644?1073741823:h>>>0>F>>>0?h:F,F){if(F>>>0>=1073741824)break e;h=p(F<<2)}else h=0;n=h+r|0,i[n>>2]=w,w=n-(V<<2)|0,r&&x(w,o,r),n=n+4|0,h=h+(F<<2)|0,o&&(Z(o),t=i[s+2148>>2],A=i[s+2152>>2]),o=w}i[X+108>>2]=i[X>>2]}if(f=f+1|0,!(f>>>0<A-t>>2>>>0))break}i[m+28>>2]=h,i[m+24>>2]=n,i[m+20>>2]=o}v:{if((l[s+3204|0]-19&255)>>>0<2){i[s+2544>>2]=0,i[s+2548>>2]=0,i[s+2560>>2]=0,A=s+2552|0,i[A>>2]=0,i[A+4>>2]=0;break v}if(t=0,o=0,A=0,n=l[k+916|0],n)for(w=k+820|0,h=s+2692|0,X=s+2564|0,F=k+884|0,E=i[s+2216>>2],f=0;;){r=i[E+96>>2]+g[w+(f<<1)>>1]|0;Z:{if(l[f+F|0]){i[X+(A<<2)>>2]=r,A=A+1|0;break Z}i[h+(o<<2)>>2]=r,o=o+1|0}if(f=f+1|0,(n|0)==(f|0))break}if(i[s+2544>>2]=A,r=l[k+917|0],r)for(n=s+2692|0,w=s+2628|0,h=k+852|0,X=k+900|0,F=i[s+2216>>2],f=0;;){A=i[F+96>>2]+g[h+(f<<1)>>1]|0;Z:{if(l[f+X|0]){i[w+(t<<2)>>2]=A,t=t+1|0;break Z}i[n+(o<<2)>>2]=A,o=o+1|0}if(f=f+1|0,(r|0)==(f|0))break}i[s+2552>>2]=o,i[s+2548>>2]=t;Z:{if((i[k+152>>2]+i[k+148>>2]|0)<=0){n=0,r=0;break Z}for(w=s+2480|0,h=s+2820|0,X=s+2416|0,F=s+2756|0,E=s+2288|0,V=s+2352|0,N=k+252|0,z=s+2224|0,$=i[s+1376>>2],R=i[s+2216>>2],f=0,r=0,n=0;;){A=f<<2,o=i[A+z>>2],t=f+N|0,l[t|0]&&(o=i[R+96>>2]+o-(i[k+36>>2]+G(i[$+16868>>2],i[A+V>>2]))|0);G:{if(i[A+E>>2]){A=r<<2,i[A+F>>2]=o,i[A+X>>2]=u[t|0],r=r+1|0;break G}A=n<<2,i[A+h>>2]=o,i[A+w>>2]=u[t|0],n=n+1|0}if(f=f+1|0,!((f|0)<(i[k+152>>2]+i[k+148>>2]|0)))break}}i[s+2560>>2]=n,i[s+2556>>2]=r}if(A=i[s+2148>>2],r=i[s+2152>>2],i[m+16>>2]=0,i[m+8>>2]=0,i[m+12>>2]=0,(A|0)!=(r|0)){if(A=r-A>>2,(A|0)<0)break i;r=p(A),i[m+8>>2]=r,f=A+r|0,i[m+16>>2]=f,A&&o0(r,0,A),i[m+12>>2]=f}if(n=s+2140|0,A=i[s+2556>>2],(A|0)<=0)break h;for(X=s+3076|0,F=s+2756|0,E=s+2416|0,t=0;;){A=t<<2,o=A+F|0,r=i[o>>2],V=A+X|0;v:{if(!i[A+E>>2]){f=nu(n,r,I);break v}f=ue(n,r,I,1)}i[V>>2]=f;v:{Z:{if((f|0)>=0){u[i[m+8>>2]+f|0]=1;break Z}if(f=pr(s,i[s+1376>>2],i[o>>2],1),(f|0)<0)break v;o=i[s+2152>>2]-i[s+2148>>2]>>2,A=i[m+12>>2],r=i[m+8>>2],w=A-r|0;G:{if(o>>>0>w>>>0){if(h=o-w|0,N=i[m+16>>2],h>>>0<=N-A>>>0){h&&o0(A,0,h),i[m+12>>2]=A+h;break G}if((o|0)<0)break i;if(A=N-r|0,N=A<<1,N=A>>>0>=1073741823?2147483647:o>>>0<N>>>0?N:o,A=p(N),h&&o0(A+w|0,0,h),w&&x(A,r,w),i[m+16>>2]=A+N,i[m+12>>2]=A+o,i[m+8>>2]=A,!r){r=A;break G}Z(r),r=A;break G}if(o>>>0>=w>>>0)break G;i[m+12>>2]=r+o}i[V>>2]=f,u[r+f|0]=1}if(l[i[i[s+2148>>2]+(f<<2)>>2]+312|0]&&(u[i[s+2216>>2]+312|0]=4),A=i[s+2556>>2],t=t+1|0,(A|0)>(t|0))continue;break h}break}f=0-f|0;break _}i[m+28>>2]=h,i[m+24>>2]=n,i[m+20>>2]=o;break i}if(o=i[s+2560>>2],(o|0)>0){X=s+3140|0,F=s+2820|0,E=s+2480|0,t=0;h:{B:{for(;;){A=t<<2,f=A+F|0,r=i[f>>2],V=A+X|0;v:{if(!i[A+E>>2]){A=nu(n,r,I);break v}A=ue(n,r,I,1)}i[V>>2]=A;v:{Z:{if((A|0)>=0){u[A+i[m+8>>2]|0]=1;break Z}if(h=pr(s,i[s+1376>>2],i[f>>2],1),(h|0)<0)break B;r=i[s+2152>>2]-i[s+2148>>2]>>2,A=i[m+12>>2],f=i[m+8>>2],o=A-f|0;G:{if(r>>>0>o>>>0){if(w=r-o|0,N=i[m+16>>2],w>>>0<=N-A>>>0){w&&o0(A,0,w),i[m+12>>2]=A+w;break G}if((r|0)<0)break v;if(A=N-f|0,N=A<<1,N=A>>>0>=1073741823?2147483647:r>>>0<N>>>0?N:r,A=p(N),w&&o0(A+o|0,0,w),o&&x(A,f,o),i[m+16>>2]=A+N,i[m+12>>2]=A+r,i[m+8>>2]=A,!f){f=A;break G}Z(f),f=A;break G}if(r>>>0>=o>>>0)break G;i[m+12>>2]=r+f}i[V>>2]=h,u[f+h|0]=1}if(o=i[s+2560>>2],t=t+1|0,(o|0)<=(t|0))break h;continue}break}break i}f=0-h|0;break _}A=i[s+2556>>2]}h:{if((A|0)<=0)break h;if(X=s+3076|0,w=i[s+2148>>2],r=0,f=0,A>>>0>=4)for(F=A&2147483644,t=0;h=X+(f<<2)|0,i[i[w+(i[h>>2]<<2)>>2]+100>>2]=2,i[i[w+(i[h+4>>2]<<2)>>2]+100>>2]=2,i[i[w+(i[h+8>>2]<<2)>>2]+100>>2]=2,i[i[w+(i[h+12>>2]<<2)>>2]+100>>2]=2,f=f+4|0,t=t+4|0,(F|0)!=(t|0););if(A=A&3,!A)break h;for(;i[i[w+(i[X+(f<<2)>>2]<<2)>>2]+100>>2]=2,f=f+1|0,r=r+1|0,(A|0)!=(r|0););}h:{if((o|0)<=0)break h;if(w=o&3,h=s+3140|0,A=i[s+2148>>2],r=0,f=0,o>>>0>=4)for(X=o&2147483644,o=0;t=h+(f<<2)|0,i[i[A+(i[t>>2]<<2)>>2]+100>>2]=2,i[i[A+(i[t+4>>2]<<2)>>2]+100>>2]=2,i[i[A+(i[t+8>>2]<<2)>>2]+100>>2]=2,i[i[A+(i[t+12>>2]<<2)>>2]+100>>2]=2,f=f+4|0,o=o+4|0,(X|0)!=(o|0););if(!w)break h;for(;i[i[A+(i[h+(f<<2)>>2]<<2)>>2]+100>>2]=2,f=f+1|0,r=r+1|0,(w|0)!=(r|0););}h:{if(i[s+2544>>2]<=0)break h;X=s+2884|0,F=s+2564|0,t=0;B:{for(;;){v:{A=t<<2,r=A+X|0,A=A+F|0,f=ue(n,i[A>>2],I,0),i[r>>2]=f;Z:{if((f|0)>=0){u[i[m+8>>2]+f|0]=1;break Z}if(f=pr(s,i[s+1376>>2],i[A>>2],0),(f|0)<0)break B;i[r>>2]=f,o=i[s+2152>>2]-i[s+2148>>2]>>2,r=i[m+12>>2],A=i[m+8>>2],w=r-A|0;G:{if(o>>>0>w>>>0){if(h=o-w|0,E=i[m+16>>2],h>>>0<=E-r>>>0){h&&o0(r,0,h),i[m+12>>2]=r+h;break G}if((o|0)<0)break v;if(r=E-A|0,E=r<<1,E=r>>>0>=1073741823?2147483647:o>>>0<E>>>0?E:o,r=p(E),h&&o0(r+w|0,0,h),w&&x(r,A,w),i[m+16>>2]=r+E,i[m+12>>2]=r+o,i[m+8>>2]=r,!A){A=r;break G}Z(A),A=r;break G}if(o>>>0>=w>>>0)break G;i[m+12>>2]=A+o}u[A+f|0]=1}if(l[i[i[s+2148>>2]+(f<<2)>>2]+312|0]&&(u[i[s+2216>>2]+312|0]=4),t=t+1|0,(t|0)<i[s+2544>>2])continue;break h}break}break i}f=0-f|0;break _}h:{if(i[s+2548>>2]<=0)break h;X=s+2948|0,F=s+2628|0,t=0;B:{for(;;){v:{A=t<<2,r=A+X|0,A=A+F|0,f=ue(n,i[A>>2],I,0),i[r>>2]=f;Z:{if((f|0)>=0){u[i[m+8>>2]+f|0]=1;break Z}if(f=pr(s,i[s+1376>>2],i[A>>2],0),(f|0)<0)break B;i[r>>2]=f,o=i[s+2152>>2]-i[s+2148>>2]>>2,r=i[m+12>>2],A=i[m+8>>2],w=r-A|0;G:{if(o>>>0>w>>>0){if(h=o-w|0,E=i[m+16>>2],h>>>0<=E-r>>>0){h&&o0(r,0,h),i[m+12>>2]=r+h;break G}if((o|0)<0)break v;if(r=E-A|0,E=r<<1,E=r>>>0>=1073741823?2147483647:o>>>0<E>>>0?E:o,r=p(E),h&&o0(r+w|0,0,h),w&&x(r,A,w),i[m+16>>2]=r+E,i[m+12>>2]=r+o,i[m+8>>2]=r,!A){A=r;break G}Z(A),A=r;break G}if(o>>>0>=w>>>0)break G;i[m+12>>2]=A+o}u[A+f|0]=1}if(l[i[i[s+2148>>2]+(f<<2)>>2]+312|0]&&(u[i[s+2216>>2]+312|0]=4),t=t+1|0,(t|0)<i[s+2548>>2])continue;break h}break}break i}f=0-f|0;break _}if(i[s+2552>>2]>0)for(r=s+3012|0,o=s+2692|0,f=0;t=f<<2,A=ue(n,i[t+o>>2],I,0),i[r+t>>2]=A,(A|0)>=0&&(u[A+i[m+8>>2]|0]=1),f=f+1|0,(f|0)<i[s+2552>>2];);if(A=i[s+2152>>2],I=i[s+2148>>2],(A-I|0)>0)for(F=i[m+8>>2],E=i[m+12>>2]-F|0,f=0,n=i[m+24>>2],h=i[m+28>>2],t=i[m+20>>2];;){h:{if(l[f+F|0]&&f>>>0<E>>>0||(w=i[(f<<2)+I>>2],r=i[s+2216>>2],(w|0)==(r|0)|u0[w+108>>2]<=u0[r>>2]|!i[w+100>>2]))break h;o=i[w>>2];B:{if(n>>>0<h>>>0){i[n>>2]=o,n=n+4|0;break B}if(r=n-t|0,V=r>>2,n=V+1|0,n>>>0>=1073741824)break i;if(h=h-t|0,X=h>>1,h=h>>>0>=2147483644?1073741823:n>>>0<X>>>0?X:n,h){if(h>>>0>=1073741824)break e;n=p(h<<2)}else n=0;X=n+r|0,i[X>>2]=o,o=X-(V<<2)|0,r&&x(o,t,r),h=n+(h<<2)|0,i[m+28>>2]=h,i[m+20>>2]=o,n=X+4|0,t&&(Z(t),I=i[s+2148>>2],A=i[s+2152>>2]),t=o}i[m+24>>2]=n,i[w+108>>2]=i[i[s+2216>>2]>>2]}if(f=f+1|0,!((f|0)<A-I>>2))break}if(f=0,A=k+1352|0,(A|0)==(m+20|0))break _;o=A,A=i[m+20>>2],r=i[m+24>>2],k6(o,A,r,r-A>>2)}A=i[m+8>>2],A&&(i[m+12>>2]=A,Z(A)),A=i[m+20>>2],A&&(i[m+24>>2]=A,Z(A)),v=m+32|0;break w}if(i[B+8>>2]=f,!f)break s;r=0;break o}if(i[s+2216>>2])break l;r=0;break o}A=i[s+2216>>2],i[A+100>>2]=1,i[31316]=i[A+96>>2],u[s+2200|0]=0}r=1;l:{if(u0[k+28>>2]>1)break l;A=0,n=v-480|0,v=n,o=i[k+336>>2],t=i[k+920>>2],o0(n,0,96),h=s+3076|0,m=s+2948|0,I=s+2884|0,f=(o|0)>(t|0)?o:t,w=f-1|0,N=i[s+2556>>2],X=N-1|0,z=i[s+2548>>2],F=z-1|0,V=i[s+2544>>2],E=V-1|0,$=(V|0)<=0;s:{w:{_:{h:{B:{for(;;){if((A|0)>=(f|0))break B;if($||(V=w-A|0,V=V>>>0<E>>>0?V:E,R=(V<<2)+4|0,R&&x((n+288|0)+(A<<2)|0,I,R),A=(A+V|0)+1|0),(z|0)<=0|(A|0)>=(f|0)||(V=w-A|0,V=F>>>0>V>>>0?V:F,R=(V<<2)+4|0,R&&x((n+288|0)+(A<<2)|0,m,R),A=(A+V|0)+1|0),(N|0)<=0|(A|0)>=(f|0)||(V=w-A|0,R=X>>>0>V>>>0?V:X,V=R+1|0,V&&o0(A+n|0,1,V),R=(R<<2)+4|0,R&&x((n+288|0)+(A<<2)|0,h,R),A=A+V|0),!A)break}if(A=i[s+84>>2],(A|0)==20){i[s+80>>2]=1001,f=0;break h}i[s+84>>2]=A+1,i[(s+(A<<2)|0)+4>>2]=1016,f=0;break h}if((o|0)>16)break _;if((o|0)>0)for(F=k+1180|0,E=k+1052|0,V=k+1308|0,N=k+924|0,z=k+346|0,A=0,$=l[k+344|0];;){if(w=A<<2,X=w+N|0,f=$?l[A+z|0]:A,i[X>>2]=i[(n+288|0)+(f<<2)>>2],u[A+V|0]=l[f+n|0],f=0,X=i[X>>2],R=i[s+2148>>2],X>>>0>=i[s+2152>>2]-R>>2>>>0||(X=i[R+(X<<2)>>2],!X))break h;if(i[w+E>>2]=i[X+96>>2],i[w+F>>2]=i[X+100>>2],A=A+1|0,(o|0)==(A|0))break}if(f=1,i[k+28>>2])break h;N=i[s+2556>>2],w=N-1|0,z=i[s+2544>>2],X=z-1|0,V=i[s+2548>>2],F=V-1|0,o=i[k+340>>2],f=(o|0)>(t|0)?o:t,t=f-1|0,E=n+48|0,A=0,$=(V|0)<=0;B:{for(;;){if((A|0)>=(f|0))break B;if($||(V=t-A|0,V=F>>>0>V>>>0?V:F,R=(V<<2)+4|0,R&&x((n+96|0)+(A<<2)|0,m,R),A=(A+V|0)+1|0),(z|0)<=0|(A|0)>=(f|0)||(V=t-A|0,V=X>>>0>V>>>0?V:X,R=(V<<2)+4|0,R&&x((n+96|0)+(A<<2)|0,I,R),A=(A+V|0)+1|0),(N|0)<=0|(A|0)>=(f|0)||(V=t-A|0,R=w>>>0>V>>>0?V:w,V=R+1|0,V&&o0(A+E|0,1,V),R=(R<<2)+4|0,R&&x((n+96|0)+(A<<2)|0,h,R),A=A+V|0),!A)break}if(A=i[s+84>>2],(A|0)==20){i[s+80>>2]=1001,f=0;break h}i[s+84>>2]=A+1,i[(s+(A<<2)|0)+4>>2]=1016,f=0;break h}if((o|0)>16)break w;if(f=1,(o|0)<=0)break h;for(h=k+1244|0,m=k+1116|0,I=k+1324|0,X=k+988|0,F=k+362|0,A=0,V=l[k+345|0];;){if(t=A<<2,w=t+X|0,f=V?l[A+F|0]:A,i[w>>2]=i[(n+96|0)+(f<<2)>>2],u[A+I|0]=l[f+E|0],f=0,w=i[w>>2],N=i[s+2148>>2],w>>>0>=i[s+2152>>2]-N>>2>>>0||(w=i[N+(w<<2)>>2],!w))break h;if(i[t+m>>2]=i[w+96>>2],i[t+h>>2]=i[w+100>>2],f=1,A=A+1|0,(o|0)==(A|0))break}}v=n+480|0;break s}D0(21140,18155,1799,4451),H()}D0(21107,18155,1852,4451),H()}if(f)break l;r=0;break o}i[k+808>>2]=i[(l[k+20|0]?i[s+2220>>2]+808|0:k+24|0)>>2],i[s+2220>>2]=k}if(v=Q+80|0,f=i[s+2216>>2],!r){f&&(u[f+312|0]=2),R4(s+548|0,O),A=i[k+1352>>2],A&&(i[k+1356>>2]=A,Z(A)),L8(S),A=i[k+784>>2],A&&(i[k+788>>2]=A,Z(A)),A=i[k+8>>2];o:{if(!A||(r=i[A+4>>2],i[A+4>>2]=r-1,r))break o;W[i[i[A>>2]+8>>2]](A),y(A)}Z(k),r=i[B+8>>2];break u}A=i[f+56>>2],r=i[f+52>>2],n=A-r|0,t=n>>2,i[k>>2]=t;o:{if(o=i[f+60>>2],o>>>0>A>>>0){i[A>>2]=k,i[f+56>>2]=A+4;break o}l:{if(A=t+1|0,A>>>0<1073741824){if(o=o-r|0,w=o>>1,o=o>>>0>=2147483644?1073741823:A>>>0<w>>>0?w:A,o){if(o>>>0>=1073741824)break l;A=p(o<<2)}else A=0;w=A+n|0,i[w>>2]=k,t=w-(t<<2)|0,n&&x(t,r,n),i[f+60>>2]=A+(o<<2),A=w+4|0,i[f+56>>2]=A,i[f+52>>2]=t,r&&Z(r),i[f+56>>2]=A;break o}break i}break e}if(E6(_,1),gl(_),i[k+776>>2]>0)for(o=i[_>>2]-i[O+20>>2]|0,f=i[k+784>>2],t=0;;){w=t<<2,f=i[w+f>>2],h=i[O+32>>2],A=i[O+36>>2]-h>>2;o:{for(;;){if(r=A,n=0,(r|0)<=0)break o;if(A=r-1|0,!((f|0)<(i[h+(A<<2)>>2]-o|0)))break}n=r}if(f=i[k+784>>2],A=w+f|0,i[A>>2]=i[A>>2]-n,t=t+1|0,!((t|0)<i[k+776>>2]))break}o:{if(!l[k+12|0]){t=i[s+3212>>2];break o}f=p(480),Kt(f+8|0),i[f+472>>2]=0,i[f+476>>2]=0,i[f+464>>2]=0,i[f+468>>2]=0,i[f+456>>2]=0,i[f+460>>2]=0,i[f+448>>2]=0,i[f+452>>2]=0,i[f+440>>2]=0,i[f+444>>2]=0,i[f+432>>2]=0,i[f+436>>2]=0,i[f+424>>2]=0,i[f+428>>2]=0,i[f>>2]=i[s+2216>>2],A=i[s+3212>>2],o=i[s+3216>>2];l:{if(A>>>0<o>>>0){i[A>>2]=f,t=A+4|0;break l}if(n=i[s+3208>>2],A=A-n|0,w=A>>2,r=w+1|0,r>>>0>=1073741824)break i;if(o=o-n|0,t=o>>1,o=o>>>0>=2147483644?1073741823:r>>>0<t>>>0?t:r,o){if(o>>>0>=1073741824)break e;r=p(o<<2)}else r=0;if(t=r+A|0,i[t>>2]=f,f=t-(w<<2)|0,A&&x(f,n,A),i[s+3216>>2]=r+(o<<2),t=t+4|0,i[s+3212>>2]=t,i[s+3208>>2]=f,!n)break l;Z(n)}i[s+3212>>2]=t}if(i[s+3208>>2]!=(t|0)){f=p(144),u[f+36|0]=0,i[f+32>>2]=0,i[f>>2]=0,i[f+4>>2]=0,i[f+44>>2]=0,i[f+140>>2]=s,i[f+128>>2]=-1,i[f+132>>2]=0,i[f+120>>2]=0,i[f+124>>2]=-1,i[f+136>>2]=0,i[f+40>>2]=0,i[f+4>>2]=k,i[f>>2]=O,A=i[_+4>>2],i[f+8>>2]=i[_>>2],i[f+12>>2]=A,A=i[_+12>>2],i[f+16>>2]=i[_+8>>2],i[f+20>>2]=A,A=i[_+20>>2],i[f+24>>2]=i[_+16>>2],i[f+28>>2]=A,u[f+36|0]=l[s+3220|0],n=i[i[s+3212>>2]-4>>2],A=i[n+428>>2],k=i[n+432>>2];o:{if(A>>>0<k>>>0){i[A>>2]=f,t=A+4|0;break o}if(o=i[n+424>>2],A=A-o|0,O=A>>2,r=O+1|0,r>>>0>=1073741824)break i;if(k=k-o|0,t=k>>1,k=k>>>0>=2147483644?1073741823:r>>>0<t>>>0?t:r,k){if(k>>>0>=1073741824)break e;r=p(k<<2)}else r=0;if(t=r+A|0,i[t>>2]=f,f=t-(O<<2)|0,A&&x(f,o,A),i[n+432>>2]=r+(k<<2),t=t+4|0,i[n+428>>2]=t,i[n+424>>2]=f,!o)break o;Z(o)}i[n+428>>2]=t}y7(s,B+7|0),r=0}v=B+16|0;break t}break n}t:switch(f-32|0){case 0:s=p(668),i[s>>2]=61400,i[s+4>>2]=0,i[s+8>>2]=0,r=s+12|0,o0(r,0,656),o=A,_=A+4|0,k=P+8|0,A=v0(k,4),i[r>>2]=A,n=8;u:{o:{l:{s:{if((A|0)>15||(E6(k,2),A=v0(k,6),i[r+4>>2]=A+1,(A|0)>62)||(A=v0(k,3),i[r+8>>2]=A+1,(A|0)>6))break s;if(e0=r,r0=v0(k,1),i[e0+12>>2]=r0,E6(k,16),Uu(r+16|0,k,i[r+8>>2]),A=v0(k,1),i[r+484>>2]=A,t=i[r+8>>2],f=A?0:t-1|0,(f|0)<(t|0)){for(B=r+488|0,A=f;;){if(t=B+G(A,12)|0,e0=t,r0=f2(k),i[e0>>2]=r0,e0=t,r0=f2(k),i[e0+4>>2]=r0,w=f2(k),i[t+8>>2]=w,i[t>>2]==-99999|(w|0)==-99999|i[t+4>>2]==-99999)break s;if(A=A+1|0,!((A|0)<i[r+8>>2]))break}A=i[r+484>>2]}w:{if(A)break w;if((f|0)>7)break l;if((f|0)<=0||(t=(r+488|0)+G(f,12)|0,A=i[t>>2],n=i[t+4>>2],t=i[t+8>>2],i[r+496>>2]=t,i[r+492>>2]=n,i[r+488>>2]=A,(f|0)==1)||(i[r+508>>2]=t,i[r+504>>2]=n,i[r+500>>2]=A,(f|0)==2)||(i[r+520>>2]=t,i[r+516>>2]=n,i[r+512>>2]=A,(f|0)==3)||(i[r+532>>2]=t,i[r+528>>2]=n,i[r+524>>2]=A,(f|0)==4)||(i[r+544>>2]=t,i[r+540>>2]=n,i[r+536>>2]=A,(f|0)==5)||(i[r+556>>2]=t,i[r+552>>2]=n,i[r+548>>2]=A,(f|0)==6))break w;i[r+568>>2]=t,i[r+564>>2]=n,i[r+560>>2]=A}if(e0=r,r0=v0(k,6),u[e0+584|0]=r0,A=f2(k),i[r+588>>2]=A,A-1023>>>0<=4294966271)break o;f=A+1|0,i[r+588>>2]=f,A=i[r+596>>2],n=i[r+592>>2],t=(A-n|0)/12|0;w:{if(t>>>0<f>>>0){if(n=0,f=f-t|0,w=i[r+600>>2],f>>>0<=(w-A|0)/12>>>0){f&&(f=G(f,12)-12|0,f=(f-((f>>>0)%12|0)|0)+12|0,f&&o0(A,0,f),A=A+f|0),i[r+596>>2]=A;break w}_:{if(t=A,A=i[r+592>>2],t=t-A|0,B=f+((t|0)/12|0)|0,B>>>0<357913942){if(w=(w-A|0)/12|0,h=w<<1,B=w>>>0>=178956970?357913941:h>>>0>B>>>0?h:B,B){if(B>>>0>=357913942)break _;n=p(G(B,12))}w=n+t|0,f=G(f,12)-12|0,f=(f-((f>>>0)%12|0)|0)+12|0,f&&o0(w,0,f),h=w+G((t|0)/-12|0,12)|0,t&&x(h,A,t),i[r+600>>2]=G(B,12)+n,i[r+596>>2]=f+w,i[r+592>>2]=h,A&&Z(A);break w}break i}break e}if(f>>>0>=t>>>0)break w;if(n=n+G(f,12)|0,(n|0)!=(A|0))for(;f=A-12|0,t=i[f>>2],t&&(i[A-8>>2]=t,Z(t)),A=f,(A|0)!=(n|0););i[r+596>>2]=n}if(i[r+588>>2]>=2)for(n=l[r+584|0],f=1;;){t=n+1|0,V=n,m=G(f,12),A=m+i[r+592>>2]|0,h=i[A+4>>2],n=i[A>>2],B=h-n|0;w:{if(V>>>0>=B>>>0){if(w=t-B|0,Q=i[A+8>>2],w>>>0<=Q-h>>>0){w&&o0(h,0,w),i[A+4>>2]=w+h;break w}if(h=Q-n|0,Q=h<<1,Q=h>>>0>=1073741823?2147483647:t>>>0<Q>>>0?Q:t,h=p(Q),w&&o0(h+B|0,0,w),B&&x(h,n,B),i[A+8>>2]=h+Q,i[A+4>>2]=t+h,i[A>>2]=h,!n)break w;Z(n);break w}if(t>>>0>=B>>>0)break w;i[A+4>>2]=n+t}for(A=0;n=v0(k,1),u[i[m+i[r+592>>2]>>2]+A|0]=n,n=l[r+584|0],t=n>>>0>A>>>0,A=A+1|0,!!t;);if(f=f+1|0,!((f|0)<i[r+588>>2]))break}A=v0(k,1),u[r+604|0]=A;w:{_:{if(!(A&255)||(e0=r,r0=v0(k,32),i[e0+608>>2]=r0,e0=r,r0=v0(k,32),i[e0+612>>2]=r0,A=v0(k,1),u[r+616|0]=A,!(A&255)))break _;if(e0=r,r0=f2(k)+1|0,i[e0+620>>2]=r0,n=f2(k),i[r+624>>2]=n,n>>>0>=1024)break o;f=0,A=i[r+632>>2],B=i[r+628>>2],t=A-B>>1;h:{if(t>>>0<n>>>0){if(n=n-t|0,w=i[r+636>>2],n>>>0<=w-A>>1>>>0){n&&(f=n<<1,f&&o0(A,0,f),A=A+f|0),i[r+632>>2]=A;break h}B:{if(t=A,A=i[r+628>>2],t=t-A|0,h=t>>1,B=h+n|0,(B|0)>=0){if(w=w-A|0,B=w>>>0>=2147483646?2147483647:w>>>0>B>>>0?w:B,B){if((B|0)<0)break B;f=p(B<<1)}w=f+t|0,n=n<<1,n&&o0(w,0,n),h=w-(h<<1)|0,t&&x(h,A,t),i[r+636>>2]=(B<<1)+f,i[r+632>>2]=n+w,i[r+628>>2]=h,A&&Z(A);break h}break i}break e}n>>>0<t>>>0&&(i[r+632>>2]=B+(n<<1))}h:{if(A=i[r+624>>2],B=i[r+644>>2],f=i[r+640>>2],n=B-f|0,A>>>0>n>>>0){if(t=A-n|0,w=i[r+648>>2],t>>>0<=w-B>>>0){t&&o0(B,0,t),i[r+644>>2]=t+B;break h}if((A|0)<0)break i;if(B=w-f|0,w=B<<1,w=B>>>0>=1073741823?2147483647:A>>>0<w>>>0?w:A,B=p(w),t&&o0(n+B|0,0,t),n&&x(B,f,n),i[r+648>>2]=w+B,i[r+644>>2]=A+B,i[r+640>>2]=B,!f)break h;Z(f);break h}if(A>>>0>=n>>>0)break h;i[r+644>>2]=A+f;break h}if(i[r+624>>2]<=0)break _;A=f2(k),g[i[r+628>>2]>>1]=A;break w}e0=r,r0=v0(k,1),u[e0+652|0]=r0}n=0}f=n;break u}D0(19273,18181,144,17848),H()}F2(_,8,0),f=8}u:{if(f)break u;if(n=i[o+520>>2],(n|0)>=0){k=v-368|0,v=k,A=67556;o:{l:switch(n-1|0){case 1:A=67552;break;case 0:break l;default:break o}if(t=i[A>>2],k0(t,42047,0),i[k+352>>2]=i[r>>2],k0(t,40977,k+352|0),i[k+336>>2]=i[r+4>>2],k0(t,41409,k+336|0),i[k+320>>2]=i[r+8>>2],k0(t,41054,k+320|0),i[k+304>>2]=i[r+12>>2],k0(t,39661,k+304|0),A=i[r+8>>2],lr(r+16|0,1,t),(A|0)>=2)for(n=A-2|0,B=r+68|0,A=0;i[k+288>>2]=A,k0(t,41590,k+288|0),lr(B+G(A,52)|0,0,t),w=(A|0)!=(n|0),A=A+1|0,!!w;);i[k+272>>2]=i[r+484>>2],k0(t,35102,k+272|0);l:{if(i[r+484>>2]){if(i[r+8>>2]<=0)break l;for(B=r+488|0,A=0;n=B+G(A,12)|0,i[k+260>>2]=i[n>>2],i[k+256>>2]=A,k0(t,33627,k+256|0),i[k+240>>2]=i[n+4>>2],k0(t,33918,k+240|0),i[k+224>>2]=i[n+8>>2],k0(t,33963,k+224|0),A=A+1|0,(A|0)<i[r+8>>2];);break l}i[k+208>>2]=i[r+488>>2],k0(t,33669,k+208|0),i[k+192>>2]=i[r+492>>2],k0(t,33914,k+192|0),i[k+176>>2]=i[r+496>>2],k0(t,33959,k+176|0)}if(i[k+160>>2]=l[r+584|0],k0(t,34004,k+160|0),i[k+144>>2]=i[r+588>>2],k0(t,33574,k+144|0),i[r+588>>2]>=2)for(n=1;;){for(A=0,B=G(n,12);i[k+136>>2]=u[i[B+i[r+592>>2]>>2]+A|0],i[k+132>>2]=A,i[k+128>>2]=n,k0(t,33877,k+128|0),w=l[r+584|0]>A>>>0,A=A+1|0,!!w;);if(n=n+1|0,!((n|0)<i[r+588>>2]))break}i[k+112>>2]=u[r+604|0],k0(t,33714,k+112|0);l:{if(!l[r+604|0]||(i[k+96>>2]=i[r+608>>2],k0(t,33599,k+96|0),i[k+80>>2]=i[r+612>>2],k0(t,34062,k+80|0),i[k+64>>2]=u[r+616|0],k0(t,33774,k- -64|0),!l[r+616|0])||(i[k+48>>2]=i[r+620>>2],k0(t,33816,k+48|0),i[k+32>>2]=i[r+624>>2],k0(t,34029,k+32|0),i[r+624>>2]<=0))break l;i[k+20>>2]=C[i[r+628>>2]>>1],i[k+16>>2]=0,k0(t,33849,k+16|0);break o}i[k>>2]=u[r+652|0],k0(t,33749,k)}v=k+368|0}if(i[s+4>>2]=i[s+4>>2]+1,n=o+(i[s+12>>2]<<3)|0,i[n+600>>2]=r,A=i[n+604>>2],i[n+604>>2]=s,!A||(r=i[A+4>>2],i[A+4>>2]=r-1,r))break u;W[i[i[A>>2]+8>>2]](A),y(A)}A=i[s+4>>2],i[s+4>>2]=A-1,A||(W[i[i[s>>2]+8>>2]](s),y(s)),r=f,R4(o+548|0,O);break n;case 1:B=p(17016),i[B>>2]=61516,i[B+4>>2]=0,i[B+8>>2]=0,w=A+4|0,k=B+12|0,i[k+8824>>2]=0,i[k+8816>>2]=0,i[k+8820>>2]=0,r=k+9e3|0,g[r+2>>1]=0,g[r+4>>1]=0,u[r|0]=0,u[r+21|0]=0,u[r+22|0]=0,u[r+23|0]=0,u[r+24|0]=0,u[r+25|0]=0,u[r+26|0]=0,u[r+27|0]=0,u[r+28|0]=0,u[r+20|0]=2,i[r+12>>2]=5,i[r+16>>2]=33685504,i[r+48>>2]=0,i[r+52>>2]=0,g[r+7810>>1]=258,g[r+7812>>1]=3855,g[r+7808>>1]=0,i[r+7804>>2]=65536,u[r+64|0]=0,i[r+60>>2]=1,u[r+5|0]=0,u[r+6|0]=0,u[r+7|0]=0,u[r+8|0]=0,u[r+29|0]=0,u[r+30|0]=0,u[r+31|0]=0,u[r+32|0]=0,u[r+33|0]=0,u[r+34|0]=0,u[r+35|0]=0,u[r+36|0]=0,u[r+37|0]=0,u[r+38|0]=0,u[r+39|0]=0,u[r+40|0]=0,u[r+41|0]=0,u[r+42|0]=0,u[r+43|0]=0,u[r+44|0]=0,u[r+56|0]=0,u[k+16828|0]=0,i[k+16820>>2]=0,i[k+16824>>2]=0,u[k|0]=0,o=P+8|0,e0=k,r0=v0(o,4),u[e0+1|0]=r0,r=v0(o,3)+1|0,u[k+2|0]=r,n=8;u:{if(r<<24>>24>7)break u;e0=k,r0=v0(o,1),u[e0+3|0]=r0,Uu(k+4|0,o,u[k+2|0]);o:{l:{s:{if(r=f2(o),(r|0)==-99999)break s;if(i[k+472>>2]=r,(r|0)>15)break u;if(t=f2(o),(t|0)==-99999)break s;if(i[k+476>>2]=t,(t|0)==3&&(s=v0(o,1),t=i[k+476>>2]),u[k+480|0]=s,t>>>0>=4){F2(w,1019,0);break u}if(r=f2(o),(r|0)==-99999||(i[k+484>>2]=r,r=f2(o),(r|0)==-99999))break s;if(i[k+488>>2]=r,!r||(f=i[k+484>>2],!f|(r|0)>65535|(f|0)>65535))break u;r=v0(o,1),u[k+492|0]=r;w:{if(r&255){if(r=f2(o),(r|0)==-99999||(i[k+496>>2]=r,r=f2(o),(r|0)==-99999)||(i[k+500>>2]=r,r=f2(o),(r|0)==-99999)||(i[k+504>>2]=r,r=f2(o),(r|0)==-99999))break s;i[k+508>>2]=r;break w}i[k+496>>2]=0,i[k+500>>2]=0,i[k+504>>2]=0,i[k+508>>2]=0}if(r=f2(o),(r|0)==-99999||(i[k+512>>2]=r+8,r=f2(o),(r|0)==-99999))break s;if(i[k+516>>2]=r+8,!(i[k+512>>2]<17&(r|0)<=8))break l;if(r=f2(o),(r|0)==-99999)break s;if(f=r+4|0,i[k+520>>2]=f,r>>>0>=13)break l;if(i[k+16868>>2]=1<<f,r=v0(o,1),u[k+524|0]=r,t=u[k+2|0],n=r&255?0:t-1|0,(n|0)<(t|0)){for(s=k+16964|0,h=k+584|0,_=k+556|0,m=k+528|0;;){if(f=f2(o),!((f|0)!=-99999&(f|0)<16)||(r=n<<2,i[r+m>>2]=f+1,f=f2(o),(f|0)==-99999)||(t=r+_|0,i[t>>2]=f,f=f2(o),(f|0)==-99999))break s;if(i[r+h>>2]=f,i[r+s>>2]=(f+i[t>>2]|0)-1,t=u[k+2|0],n=n+1|0,!((t|0)>(n|0)))break}r=l[k+524|0]}w:{_:{if(!(r&255))break _;if((t|0)>7)break w;if((t|0)<2||(r=t-1|0,t=r<<2,f=t+(k+528|0)|0,i[k+528>>2]=i[f>>2],n=t+(k+556|0)|0,i[k+556>>2]=i[n>>2],t=t+(k+584|0)|0,i[k+584>>2]=i[t>>2],(r|0)==1)||(i[k+532>>2]=i[f>>2],i[k+560>>2]=i[n>>2],i[k+588>>2]=i[t>>2],(r|0)==2)||(i[k+536>>2]=i[f>>2],i[k+564>>2]=i[n>>2],i[k+592>>2]=i[t>>2],(r|0)==3)||(i[k+540>>2]=i[f>>2],i[k+568>>2]=i[n>>2],i[k+596>>2]=i[t>>2],(r|0)==4)||(i[k+544>>2]=i[f>>2],i[k+572>>2]=i[n>>2],i[k+600>>2]=i[t>>2],(r|0)==5))break _;i[k+548>>2]=i[f>>2],i[k+576>>2]=i[n>>2],i[k+604>>2]=i[t>>2]}if(r=f2(o),(r|0)==-99999||(i[k+612>>2]=r+3,r=f2(o),(r|0)==-99999)||(i[k+616>>2]=r,r=f2(o),(r|0)==-99999)||(i[k+620>>2]=r+2,r=f2(o),(r|0)==-99999)||(i[k+624>>2]=r,r=f2(o),(r|0)==-99999)||(i[k+628>>2]=r,r=f2(o),(r|0)==-99999))break s;if(i[k+632>>2]=r,n=8,r=i[k+612>>2],(r|0)>6|(r+i[k+616>>2]|0)>6||(r=i[k+620>>2],(r|0)>5|(r+i[k+624>>2]|0)>5))break u;r=v0(o,1),u[k+636|0]=r;_:{if(!(r&255))break _;if(f=v0(o,1),u[k+637|0]=f,r=k+638|0,f&255){if(n=k9(o,r),!n)break _;break u}for(n=0,G8(r,107040,0),G8(r+16|0,107040,0),G8(r+32|0,107040,0),G8(r+48|0,107040,0),G8(r- -64|0,107040,0),G8(r+80|0,107040,0),t=r+96|0,s=i[i[15774]+12>>2];f=s+(n<<1)|0,u[(t+(l[f+1|0]<<3)|0)+l[f|0]|0]=l[n+107056|0],u[l[f+2|0]+(t+(l[f+3|0]<<3)|0)|0]=l[n+107057|0],n=n+2|0,(n|0)!=64;);for(t=r+288|0,n=0,s=i[i[15774]+12>>2];f=s+(n<<1)|0,u[(t+(l[f+1|0]<<3)|0)+l[f|0]|0]=l[n+107120|0],u[l[f+2|0]+(t+(l[f+3|0]<<3)|0)|0]=l[n+107121|0],n=n+2|0,(n|0)!=64;);for(t=r+160|0,n=0,s=i[i[15774]+12>>2];f=s+(n<<1)|0,u[(t+(l[f+1|0]<<3)|0)+l[f|0]|0]=l[n+107056|0],u[l[f+2|0]+(t+(l[f+3|0]<<3)|0)|0]=l[n+107057|0],n=n+2|0,(n|0)!=64;);for(t=r+352|0,n=0,s=i[i[15774]+12>>2];f=s+(n<<1)|0,u[(t+(l[f+1|0]<<3)|0)+l[f|0]|0]=l[n+107120|0],u[l[f+2|0]+(t+(l[f+3|0]<<3)|0)|0]=l[n+107121|0],n=n+2|0,(n|0)!=64;);for(t=r+224|0,n=0,s=i[i[15774]+12>>2];f=s+(n<<1)|0,u[(t+(l[f+1|0]<<3)|0)+l[f|0]|0]=l[n+107056|0],u[l[f+2|0]+(t+(l[f+3|0]<<3)|0)|0]=l[n+107057|0],n=n+2|0,(n|0)!=64;);for(t=r+416|0,n=0,s=i[i[15774]+12>>2];f=s+(n<<1)|0,u[(t+(l[f+1|0]<<3)|0)+l[f|0]|0]=l[n+107120|0],u[l[f+2|0]+(t+(l[f+3|0]<<3)|0)|0]=l[n+107121|0],n=n+2|0,(n|0)!=64;);for(t=r+481|0,s=r+480|0,n=0,h=i[i[15774]+12>>2];f=h+(n<<1)|0,_=n+107056|0,m=l[_|0],u[(s+(l[f|0]<<1)|0)+(l[f+1|0]<<5)|0]=m,u[(t+(l[f|0]<<1)|0)+(l[f+1|0]<<5)|0]=m,_=l[_|0],u[((s+(l[f|0]<<1)|0)+(l[f+1|0]<<5)|0)+16|0]=_,u[((t+(l[f|0]<<1)|0)+(l[f+1|0]<<5)|0)+16|0]=_,n=n+1|0,(n|0)!=64;);for(t=r+1249|0,s=r+1248|0,n=0,h=i[i[15774]+12>>2];f=h+(n<<1)|0,_=n+107120|0,m=l[_|0],u[(s+(l[f|0]<<1)|0)+(l[f+1|0]<<5)|0]=m,u[(t+(l[f|0]<<1)|0)+(l[f+1|0]<<5)|0]=m,_=l[_|0],u[((s+(l[f|0]<<1)|0)+(l[f+1|0]<<5)|0)+16|0]=_,u[((t+(l[f|0]<<1)|0)+(l[f+1|0]<<5)|0)+16|0]=_,n=n+1|0,(n|0)!=64;);for(t=r+737|0,s=r+736|0,n=0,h=i[i[15774]+12>>2];f=h+(n<<1)|0,_=n+107056|0,m=l[_|0],u[(s+(l[f|0]<<1)|0)+(l[f+1|0]<<5)|0]=m,u[(t+(l[f|0]<<1)|0)+(l[f+1|0]<<5)|0]=m,_=l[_|0],u[((s+(l[f|0]<<1)|0)+(l[f+1|0]<<5)|0)+16|0]=_,u[((t+(l[f|0]<<1)|0)+(l[f+1|0]<<5)|0)+16|0]=_,n=n+1|0,(n|0)!=64;);for(t=r+1505|0,s=r+1504|0,n=0,h=i[i[15774]+12>>2];f=h+(n<<1)|0,_=n+107120|0,m=l[_|0],u[(s+(l[f|0]<<1)|0)+(l[f+1|0]<<5)|0]=m,u[(t+(l[f|0]<<1)|0)+(l[f+1|0]<<5)|0]=m,_=l[_|0],u[((s+(l[f|0]<<1)|0)+(l[f+1|0]<<5)|0)+16|0]=_,u[((t+(l[f|0]<<1)|0)+(l[f+1|0]<<5)|0)+16|0]=_,n=n+1|0,(n|0)!=64;);for(t=r+993|0,s=r+992|0,n=0,h=i[i[15774]+12>>2];f=h+(n<<1)|0,_=n+107056|0,m=l[_|0],u[(s+(l[f|0]<<1)|0)+(l[f+1|0]<<5)|0]=m,u[(t+(l[f|0]<<1)|0)+(l[f+1|0]<<5)|0]=m,_=l[_|0],u[((s+(l[f|0]<<1)|0)+(l[f+1|0]<<5)|0)+16|0]=_,u[((t+(l[f|0]<<1)|0)+(l[f+1|0]<<5)|0)+16|0]=_,n=n+1|0,(n|0)!=64;);for(t=r+1761|0,s=r+1760|0,n=0,h=i[i[15774]+12>>2];f=h+(n<<1)|0,_=n+107120|0,m=l[_|0],u[(s+(l[f|0]<<1)|0)+(l[f+1|0]<<5)|0]=m,u[(t+(l[f|0]<<1)|0)+(l[f+1|0]<<5)|0]=m,_=l[_|0],u[((s+(l[f|0]<<1)|0)+(l[f+1|0]<<5)|0)+16|0]=_,u[((t+(l[f|0]<<1)|0)+(l[f+1|0]<<5)|0)+16|0]=_,n=n+1|0,(n|0)!=64;);G8(r+2016|0,107056,3),G8(r+3040|0,107120,3)}e0=k,r0=v0(o,1),u[e0+8798|0]=r0,e0=k,r0=v0(o,1),u[e0+8799|0]=r0,r=v0(o,1),u[k+8800|0]=r;_:{if(r&255){if(e0=k,r0=v0(o,4)+1|0,u[e0+8801|0]=r0,e0=k,r0=v0(o,4)+1|0,u[e0+8802|0]=r0,r=f2(o),(r|0)==-99999||(i[k+8804>>2]=r+3,r=f2(o),(r|0)==-99999))break s;if(i[k+8808>>2]=r,e0=k,r0=v0(o,1),u[e0+8812|0]=r0,i[k+512>>2]<u[k+8801|0])break o;if(i[k+516>>2]>=u[k+8802|0])break _;break o}i[k+8804>>2]=0,i[k+8808>>2]=0,u[k+8801|0]=0,u[k+8802|0]=0,u[k+8812|0]=0}if(n=f2(o),(n|0)==-99999)break s;if(n>>>0>=65){F2(w,1014,0),n=8;break u}s=0,r=k+8816|0,f=i[r+4>>2],h=i[r>>2],t=(f-h|0)/100|0;_:{if(t>>>0<n>>>0){if(t=n-t|0,m=i[r+8>>2],t>>>0<=(m-f|0)/100>>>0){t&&(t=G(t,100)-100|0,t=(t-((t>>>0)%100|0)|0)+100|0,t&&o0(f,0,t),f=f+t|0),i[r+4>>2]=f;break _}h:{if(V=f,f=i[r>>2],h=V-f|0,_=t+((h|0)/100|0)|0,_>>>0<42949673){if(m=(m-f|0)/100|0,Q=m<<1,_=m>>>0>=21474836?42949672:_>>>0<Q>>>0?Q:_,_){if(_>>>0>=42949673)break h;s=p(G(_,100))}m=s+h|0,t=G(t,100)-100|0,t=(t-((t>>>0)%100|0)|0)+100|0,t&&o0(m,0,t),Q=m+G((h|0)/-100|0,100)|0,h&&x(Q,f,h),i[r+8>>2]=G(_,100)+s,i[r+4>>2]=t+m,i[r>>2]=Q,f&&Z(f);break _}break i}break e}n>>>0<t>>>0&&(i[r+4>>2]=h+G(n,100))}_:{if(!n)break _;for(t=0;;){if(m9(w,k,o,i[k+8816>>2]+G(t,100)|0,t,r,0)){if(t=t+1|0,(n|0)!=(t|0))continue;break _}break}n=1005;break u}r=v0(o,1),u[k+8828|0]=r;_:{if(r&255){if(r=f2(o),(r|0)==-99999)break s;if(i[k+8832>>2]=r,n=8,(r|0)>32)break u;if((r|0)<=0)break _;for(r=k+8964|0,f=k+8836|0,t=0;e0=f+(t<<2)|0,r0=v0(o,i[k+520>>2]),i[e0>>2]=r0,e0=r+t|0,r0=v0(o,1),u[e0|0]=r0,t=t+1|0,(t|0)<i[k+8832>>2];);break _}i[k+8832>>2]=0}if(e0=k,r0=v0(o,1),u[e0+8996|0]=r0,e0=k,r0=v0(o,1),u[e0+8997|0]=r0,r=v0(o,1),u[k+8998|0]=r,r&255){n=0,r=k+9e3|0,f=v0(o,1),u[r|0]=(f|0)!=0;_:{if(f){if(f=v0(o,8),(f|0)<=17){f=f<<2,g[r+2>>1]=C[f+63904>>1],n=C[f+63906>>1];break _}if((f|0)==255){e0=r,r0=v0(o,16),g[e0+2>>1]=r0,n=v0(o,16);break _}}g[r+2>>1]=0}g[r+4>>1]=n,f=v0(o,1),u[r+6|0]=(f|0)!=0,f&&(e0=r,r0=(v0(o,1)|0)!=0,u[e0+7|0]=r0),u[r+20|0]=2,g[r+18>>1]=514,u[r+16|0]=0,i[r+12>>2]=5,f=v0(o,1),u[r+8|0]=(f|0)!=0;_:{if(!f||(f=v0(o,3),i[r+12>>2]=(f|0)>=5?5:f,e0=r,r0=(v0(o,1)|0)!=0,u[e0+16|0]=r0,f=v0(o,1),u[r+17|0]=(f|0)!=0,!f))break _;f=v0(o,8),u[r+18|0]=f;h:{B:{v:switch(f=f&255,f|0){case 0:case 3:break B;default:break v}if(f>>>0<11)break h}u[r+18|0]=2}f=v0(o,8),u[r+19|0]=f;h:{B:switch(f&255){default:if((f&254)>>>0<18)break h;break;case 0:case 3:break B}u[r+19|0]=2}f=v0(o,8),u[r+20|0]=(f&255)>>>0>10?2:f}n=0,f=v0(o,1),u[r+21|0]=(f|0)!=0;_:{h:{B:{if(f){if(f=f2(o),(f|0)==-99999)break h;if(u[r+22|0]=f,n=f2(o),(n|0)!=-99999)break B;break h}u[r+22|0]=0}u[r+23|0]=n,e0=r,r0=(v0(o,1)|0)!=0,u[e0+24|0]=r0,e0=r,r0=(v0(o,1)|0)!=0,u[e0+25|0]=r0,e0=r,r0=(v0(o,1)|0)!=0,u[e0+26|0]=r0,f=v0(o,1),u[r+27|0]=(f|0)!=0;B:{if(f){if(f=f2(o),(f|0)==-99999||(i[r+28>>2]=f,f=f2(o),(f|0)==-99999)||(i[r+32>>2]=f,f=f2(o),(f|0)==-99999)||(i[r+36>>2]=f,f=f2(o),(f|0)==-99999))break h;i[r+40>>2]=f;break B}i[r+28>>2]=0,i[r+32>>2]=0,i[r+36>>2]=0,i[r+40>>2]=0}f=v0(o,1),u[r+44|0]=(f|0)!=0;B:{v:{if(!f)break v;if(e0=r,r0=v0(o,32),i[e0+48>>2]=r0,e0=r,r0=v0(o,32),i[e0+52>>2]=r0,f=v0(o,1),u[r+56|0]=(f|0)!=0,f){if(f=f2(o),(f|0)==-99999)break h;i[r+60>>2]=f+1}if(f=v0(o,1),u[r+64|0]=(f|0)!=0,!f)break v;s=0,e0=r,r0=(v0(o,1)|0)!=0,u[e0+65|0]=r0,f=v0(o,1),u[r+66|0]=(f|0)!=0,f|u[r+65|0]&1&&(f=v0(o,1),u[r+67|0]=(f|0)!=0,f&&(e0=r,r0=v0(o,8),i[e0+68>>2]=r0,e0=r,r0=v0(o,5),i[e0+72>>2]=r0,e0=r,r0=(v0(o,1)|0)!=0,u[e0+76|0]=r0,e0=r,r0=v0(o,5),i[e0+80>>2]=r0),e0=r,r0=v0(o,4),i[e0+84>>2]=r0,e0=r,r0=v0(o,4),i[e0+88>>2]=r0,l[r+67|0]==1&&(e0=r,r0=v0(o,4),i[e0+92>>2]=r0),e0=r,r0=v0(o,5),i[e0+96>>2]=r0,e0=r,r0=v0(o,5),i[e0+100>>2]=r0,e0=r,r0=v0(o,5),i[e0+104>>2]=r0),n=0;Z:{if(u[k+2|0]<=0)break Z;I=r+7357|0,X=r+5568|0,F=r+3776|0,S=r+1984|0,E=r+192|0,V=r+7356|0,N=r+5564|0,z=r+3772|0,$=r+1980|0,R=r+188|0,A0=r+160|0,_=r+132|0,m=r+122|0,Q=r+115|0,m0=r+108|0;G:{for(;;){m:{f=v0(o,1),u[s+m0|0]=(f|0)!=0;X:{W:{F:{V:{if(f){u[s+Q|0]=1,n=s+m|0,u[n|0]=0,f=_+(s<<2)|0,i[f>>2]=0;break V}if(t=v0(o,1),u[s+Q|0]=(t|0)!=0,n=s+m|0,u[n|0]=0,f=_+(s<<2)|0,i[f>>2]=0,!t)break F}if(t=f2(o),(t|0)==-99999)break m;if(i[A0+(s<<2)>>2]=t,u[n|0]&1)break X;break W}if(t=n,n=v0(o,1),u[t|0]=(n|0)!=0,n)break X}if(n=f2(o),(n|0)==-99999)break m;if(i[f>>2]=n,n>>>0<=31)break X;n=8;break Z}if(n=0,u[r+65|0]&1)for(;;){if(a=f2(o),(a|0)==-99999||(h=n<<3,t=s<<8,i[h+(t+R|0)>>2]=a,a=f2(o),(a|0)==-99999))break m;if(i[h+(t+$|0)>>2]=a,l[r+67|0]==1){if(a=f2(o),(a|0)==-99999||(i[h+(t+z|0)>>2]=a,a=f2(o),(a|0)==-99999))break m;i[h+(t+N|0)>>2]=a}if(e0=(V+(s<<6)|0)+(n<<1)|0,r0=(v0(o,1)|0)!=0,u[e0|0]=r0,t=u0[f>>2]>n>>>0,n=n+1|0,!t)break}if(u[r+66|0]&1)for(h=I+(s<<6)|0,n=s<<8,a=n+X|0,_0=n+F|0,M=n+S|0,n0=n+E|0,n=0;;){if(f0=f2(o),(f0|0)==-99999||(t=n<<3,i[t+n0>>2]=f0,f0=f2(o),(f0|0)==-99999))break m;if(i[t+M>>2]=f0,l[r+67|0]==1){if(f0=f2(o),(f0|0)==-99999||(i[t+_0>>2]=f0,f0=f2(o),(f0|0)==-99999))break m;i[t+a>>2]=f0}if(e0=h+(n<<1)|0,r0=(v0(o,1)|0)!=0,u[e0|0]=r0,t=u0[f>>2]>n>>>0,n=n+1|0,!t)break}if(n=0,s=s+1|0,(s|0)<u[k+2|0])continue;break G}break}n=8,F2(w,8,0)}}if(n)break B}if(f=v0(o,1),u[r+7804|0]=(f|0)!=0,f){if(e0=r,r0=(v0(o,1)|0)!=0,u[e0+7805|0]=r0,e0=r,r0=(v0(o,1)|0)!=0,u[e0+7806|0]=r0,e0=r,r0=(v0(o,1)|0)!=0,u[e0+7807|0]=r0,f=f2(o),(f|0)==-99999||(g[r+7808>>1]=f,f&61440&&(F2(w,8,0),g[r+7808>>1]=0),f=f2(o),(f|0)==-99999)||(u[r+7810|0]=f,(f&255)>>>0>=17&&(F2(w,8,0),u[r+7810|0]=2),f=f2(o),(f|0)==-99999)||(u[r+7811|0]=f,(f&255)>>>0>=17&&(F2(w,8,0),u[r+7811|0]=1),f=f2(o),(f|0)==-99999)||(u[r+7812|0]=f,f&240&&(F2(w,8,0),u[r+7812|0]=15),f=f2(o),(f|0)==-99999))break h;if(u[r+7813|0]=f,n=0,!(f&240))break B;F2(w,8,0),u[r+7813|0]=15;break _}g[r+7810>>1]=258,g[r+7812>>1]=3855,n=0,g[r+7808>>1]=0,u[r+7807|0]=0,u[r+7805|0]=0,u[r+7806|0]=1}break _}F2(w,8,0),n=8}if(n)break u}r=v0(o,1),u[k+16816|0]=r;_:{if(!(r&255)){u[k+16817|0]=0;break _}if(e0=k,r0=v0(o,1),u[e0+16817|0]=r0,e0=k,r0=v0(o,1),u[e0+16818|0]=r0,e0=k,r0=v0(o,6),u[e0+16819|0]=r0,!l[k+16817|0])break _;r=k+16820|0,e0=r,r0=v0(o,1),u[e0|0]=r0,e0=r,r0=v0(o,1),u[e0+1|0]=r0,e0=r,r0=v0(o,1),u[e0+2|0]=r0,e0=r,r0=v0(o,1),u[e0+3|0]=r0,e0=r,r0=v0(o,1),u[e0+4|0]=r0,e0=r,r0=v0(o,1),u[e0+5|0]=r0,e0=r,r0=v0(o,1),u[e0+6|0]=r0,e0=r,r0=v0(o,1),u[e0+7|0]=r0,e0=r,r0=v0(o,1),u[e0+8|0]=r0}t=i[k+476>>2],r=t<<2,I=i[r+63760>>2],i[k+16856>>2]=I,X=i[r+63744>>2],i[k+16852>>2]=X,E=l[k+480|0];_:{if(E){i[k+16848>>2]=0,o=1,r=1;break _}i[k+16848>>2]=t,o=t?I:1,r=t?X:1}i[k+16864>>2]=o,i[k+16860>>2]=r,w=i[k+512>>2],i[k+16832>>2]=w,h=i[k+516>>2],i[k+16840>>2]=h,_=i[k+612>>2],i[k+16872>>2]=_,n=1<<_,i[k+16880>>2]=n,V=i[k+616>>2],m=V+_|0,i[k+16876>>2]=m,F=i[k+488>>2],S=i[k+484>>2],i[k+16912>>2]=G(F,S),i[k+16836>>2]=G(w,6)-48,i[k+16844>>2]=G(h,6)-48,f=1<<m,i[k+16884>>2]=f,r=S-1|0,s=(r+n|0)/(n|0)|0,i[k+16888>>2]=s,Q=F-1|0,N=(Q+n|0)/(n|0)|0,i[k+16896>>2]=N,o=(r+f|0)/(f|0)|0,i[k+16892>>2]=o,i[k+16904>>2]=G(s,N),s=(f+Q|0)/(f|0)|0,i[k+16900>>2]=s,i[k+16908>>2]=G(o,s),r=0,A0=0;_:{if(!t||(A0=0,E))break _;r=(f|0)/(X|0)|0,A0=(f|0)/(I|0)|0}i[k+16920>>2]=A0,i[k+16916>>2]=r,r=i[k+620>>2],i[k+16936>>2]=r,Q=r+i[k+624>>2]|0,i[k+16940>>2]=Q;_:{h:{if(f=m-r|0,(f|0)<i[k+628>>2]){P1(33226,70,1,i[16888]);break h}if((f|0)<i[k+632>>2]){P1(33297,70,1,i[16888]);break h}i[k+16944>>2]=_-1,t=i[k+8804>>2],i[k+16956>>2]=t,I=s<<f,i[k+16928>>2]=I,f=o<<f,i[k+16924>>2]=f,A0=s,s=V+1|0,i[k+16952>>2]=A0<<s,i[k+16948>>2]=o<<s,i[k+16960>>2]=t+i[k+8808>>2],i[k+16932>>2]=G(f,I);B:{if(l[k+16826|0]){s=1<<h-1,o=1<<w-1,t=0,f=0;break B}o=128,s=128,t=h-8|0,f=w-8|0}if(i[k+17e3>>2]=s,i[k+16996>>2]=o,u[k+16993|0]=t,u[k+16992|0]=f,n-1&(F|S)){P1(32868,24,1,i[16888]);break h}if((r|0)>(_|0)){P1(41728,19,1,i[16888]);break h}if((Q|0)>(((m|0)>=5?5:m)|0)){P1(41697,30,1,i[16888]);break h}if(w-17>>>0<=4294967286){P1(41623,36,1,i[16888]);break h}if(h-17>>>0<=4294967286){P1(41660,36,1,i[16888]);break h}u[k|0]=1,n=0;break _}n=8}if(n)break u;u[k|0]=1,n=0;break u}D0(21101,18188,320,17848),H()}F2(w,8,0),n=8;break u}F2(w,1005,0);break u}F2(w,1027,0),n=8}if(o=n,!n){if(s=i[A+516>>2],(s|0)>=0){r=v-928|0,v=r,t=67556;u:{o:switch(s-1|0){case 1:t=67552;break;case 0:break o;default:break u}if(f=i[t>>2],k0(f,42088,0),i[r+912>>2]=u[k+1|0],k0(f,37007,r+912|0),i[r+896>>2]=u[k+2|0],k0(f,38264,r+896|0),i[r+880>>2]=u[k+3|0],k0(f,35483,r+880|0),o=u[k+2|0],n=v-16|0,v=n,t=k+4|0,lr(t,1,f),(o|0)>=2)for(o=o-2|0,w=t+52|0,t=0;i[n>>2]=t,k0(f,41590,n),lr(w+G(t,52)|0,0,f),h=(o|0)==(t|0),t=t+1|0,!h;);v=n+16|0,i[r+864>>2]=i[k+472>>2],k0(f,37809,r+864|0),n=i[k+476>>2];o:{if(n>>>0>=3){o=(n|0)==3?21364:7978;break o}o=i[(n<<2)+63776>>2]}if(i[r+852>>2]=o,i[r+848>>2]=n,k0(f,42336,r+848|0),i[k+476>>2]==3&&(i[r+832>>2]=u[k+480|0],k0(f,35560,r+832|0)),i[r+816>>2]=i[k+484>>2],k0(f,36832,r+816|0),i[r+800>>2]=i[k+488>>2],k0(f,34791,r+800|0),i[r+784>>2]=u[k+492|0],k0(f,37620,r+784|0),l[k+492|0]&&(i[r+768>>2]=i[k+496>>2],k0(f,36743,r+768|0),i[r+752>>2]=i[k+500>>2],k0(f,34696,r+752|0),i[r+736>>2]=i[k+504>>2],k0(f,37073,r+736|0),i[r+720>>2]=i[k+508>>2],k0(f,34090,r+720|0)),i[r+704>>2]=i[k+512>>2],k0(f,37251,r+704|0),i[r+688>>2]=i[k+516>>2],k0(f,36496,r+688|0),i[r+672>>2]=i[k+520>>2],k0(f,36421,r+672|0),i[r+656>>2]=u[k+524|0],k0(f,35149,r+656|0),n=u[k+2|0],t=l[k+524|0]?0:n-1|0,(t|0)<(n|0))for(o=k+584|0,w=k+556|0,h=k+528|0;i[r+640>>2]=t,k0(f,33564,r+640|0),n=t<<2,i[r+624>>2]=i[n+h>>2],k0(f,38372,r+624|0),i[r+608>>2]=i[n+w>>2],k0(f,38807,r+608|0),i[r+592>>2]=i[n+o>>2],k0(f,36542,r+592|0),t=t+1|0,(t|0)<u[k+2|0];);i[r+576>>2]=i[k+612>>2],k0(f,36218,r+576|0),i[r+560>>2]=i[k+616>>2],k0(f,36171,r+560|0),i[r+544>>2]=i[k+620>>2],k0(f,37170,r+544|0),i[r+528>>2]=i[k+624>>2],k0(f,36126,r+528|0),i[r+512>>2]=i[k+628>>2],k0(f,34824,r+512|0),i[r+496>>2]=i[k+632>>2],k0(f,36454,r+496|0),i[r+480>>2]=u[k+636|0],k0(f,35593,r+480|0);o:{if(!l[k+636|0]||(i[r+464>>2]=u[k+637|0],k0(f,35322,r+464|0),!l[k+637|0]))break o;k0(f,16483,0)}if(i[r+448>>2]=u[k+8798|0],k0(f,41098,r+448|0),i[r+432>>2]=u[k+8799|0],k0(f,35815,r+432|0),i[r+416>>2]=u[k+8800|0],k0(f,41140,r+416|0),l[k+8800|0]&&(i[r+400>>2]=u[k+8801|0],k0(f,38209,r+400|0),i[r+384>>2]=u[k+8802|0],k0(f,37274,r+384|0),i[r+368>>2]=i[k+8804>>2],k0(f,36307,r+368|0),i[r+352>>2]=i[k+8808>>2],k0(f,36256,r+352|0),i[r+336>>2]=u[k+8812|0],k0(f,36934,r+336|0)),i[r+320>>2]=(i[k+8820>>2]-i[k+8816>>2]|0)/100,k0(f,34724,r+320|0),i[k+8820>>2]!=i[k+8816>>2])for(t=0;i[r+304>>2]=t,k0(f,32444,r+304|0),_t(i[k+8816>>2]+G(t,100)|0,f),t=t+1|0,t>>>0<(i[k+8820>>2]-i[k+8816>>2]|0)/100>>>0;);i[r+288>>2]=u[k+8828|0],k0(f,35031,r+288|0);o:{if(!l[k+8828|0]||(i[r+272>>2]=i[k+8832>>2],k0(f,34758,r+272|0),i[k+8832>>2]<=0))break o;for(n=k+8964|0,o=k+8836|0,t=0;w=i[o+(t<<2)>>2],i[r+264>>2]=u[n+t|0],i[r+260>>2]=w,i[r+256>>2]=t,k0(f,42575,r+256|0),t=t+1|0,(t|0)<i[k+8832>>2];);}if(i[r+240>>2]=u[k+8996|0],k0(f,38651,r+240|0),i[r+224>>2]=u[k+8997|0],k0(f,35624,r+224|0),i[r+208>>2]=u[k+8998|0],k0(f,39066,r+208|0),i[r+192>>2]=u[k+16816|0],k0(f,37686,r+192|0),i[r+176>>2]=u[k+16817|0],k0(f,38454,r+176|0),i[r+160>>2]=u[k+16818|0],k0(f,35411,r+160|0),i[r+144>>2]=u[k+16819|0],k0(f,39826,r+144|0),i[r+128>>2]=i[k+16884>>2],k0(f,38245,r+128|0),i[r+112>>2]=i[k+16880>>2],k0(f,37329,r+112|0),i[r+96>>2]=1<<i[k+616>>2]+i[k+612>>2],k0(f,37310,r+96|0),i[r+80>>2]=1<<i[k+620>>2],k0(f,37367,r+80|0),i[r+64>>2]=1<<i[k+624>>2]+i[k+620>>2],k0(f,37348,r- -64|0),i[r+48>>2]=i[k+16892>>2],k0(f,39507,r+48|0),i[r+32>>2]=i[k+16900>>2],k0(f,39220,r+32|0),i[r+16>>2]=i[k+16852>>2],k0(f,40798,r+16|0),i[r>>2]=i[k+16856>>2],k0(f,40649,r),l[k+16817|0]){o=k+16820|0,f=v-144|0,v=f,n=67556;o:switch(s-1|0){case 1:n=67552;case 0:n=i[n>>2],k0(n,41990,0),i[f+128>>2]=l[o|0],k0(n,37763,f+128|0),i[f+112>>2]=l[o+1|0],k0(n,38001,f+112|0),i[f+96>>2]=l[o+2|0],k0(n,40403,f+96|0),i[f+80>>2]=l[o+3|0],k0(n,40357,f+80|0),i[f+64>>2]=l[o+4|0],k0(n,38526,f- -64|0),i[f+48>>2]=l[o+5|0],k0(n,39933,f+48|0),i[f+32>>2]=l[o+6|0],k0(n,38093,f+32|0),i[f+16>>2]=l[o+7|0],k0(n,36080,f+16|0),i[f>>2]=l[o+8|0],k0(n,38047,f);break;default:break o}v=f+144|0}if(!l[k+8998|0])break u;o=k+9e3|0,f=v-576|0,v=f,n=67556;o:{l:switch(s-1|0){case 1:n=67552;break;case 0:break l;default:break o}if(n=i[n>>2],k0(n,42170,0),t=C[o+2>>1],i[f+564>>2]=C[o+4>>1],i[f+560>>2]=t,k0(n,33528,f+560|0),i[f+544>>2]=l[o+6|0],k0(n,35069,f+544|0),i[f+528>>2]=l[o+7|0],k0(n,36901,f+528|0),i[f+512>>2]=l[o+8|0],k0(n,34233,f+512|0),l[o+8|0]==1&&(t=i[o+12>>2],t>>>0<=4?t=i[(t<<2)+63976>>2]:t=17185,i[f+496>>2]=t,k0(n,33071,f+496|0),i[f+480>>2]=l[o+16|0],k0(n,38923,f+480|0),i[f+464>>2]=l[o+17|0],k0(n,35232,f+464|0),i[f+448>>2]=l[o+18|0],k0(n,40095,f+448|0),i[f+432>>2]=l[o+19|0],k0(n,37543,f+432|0),i[f+416>>2]=l[o+20|0],k0(n,40679,f+416|0)),i[f+400>>2]=l[o+21|0],k0(n,34118,f+400|0),l[o+21|0]==1&&(i[f+384>>2]=l[o+22|0],k0(n,37208,f+384|0),i[f+368>>2]=l[o+23|0],k0(n,34643,f+368|0)),i[f+352>>2]=l[o+24|0],k0(n,34349,f+352|0),i[f+336>>2]=l[o+25|0],k0(n,40941,f+336|0),i[f+320>>2]=l[o+26|0],k0(n,35196,f+320|0),i[f+304>>2]=l[o+27|0],k0(n,37101,f+304|0),i[f+288>>2]=i[o+28>>2],k0(n,37386,f+288|0),i[f+272>>2]=i[o+32>>2],k0(n,37037,f+272|0),i[f+256>>2]=i[o+36>>2],k0(n,37897,f+256|0),i[f+240>>2]=i[o+40>>2],k0(n,36771,f+240|0),i[f+224>>2]=l[o+44|0],k0(n,36865,f+224|0),l[o+44|0]==1&&(i[f+208>>2]=i[o+48>>2],k0(n,38846,f+208|0),i[f+192>>2]=i[o+52>>2],k0(n,40524,f+192|0)),i[f+176>>2]=l[o+56|0],k0(n,35518,f+176|0),i[f+160>>2]=i[o+60>>2],k0(n,39741,f+160|0),i[f+144>>2]=l[o+64|0],k0(n,34993,f+144|0),i[f+128>>2]=l[o+7804|0],k0(n,39402,f+128|0),l[o+7804|0]!=1)break o;i[f+112>>2]=l[o+7805|0],k0(n,38882,f+112|0),i[f+96>>2]=l[o+7806|0],k0(n,35363,f+96|0),i[f+80>>2]=l[o+7807|0],k0(n,37722,f+80|0),i[f+64>>2]=C[o+7808>>1],k0(n,38168,f- -64|0),i[f+48>>2]=l[o+7810|0],k0(n,39537,f+48|0),i[f+32>>2]=l[o+7811|0],k0(n,39025,f+32|0),i[f+16>>2]=l[o+7812|0],k0(n,37579,f+16|0),i[f>>2]=l[o+7813|0],k0(n,38331,f)}v=f+576|0}v=r+928|0}i[B+4>>2]=i[B+4>>2]+1,f=(i[B+484>>2]<<3)+A|0,i[f+728>>2]=k,r=i[f+732>>2],i[f+732>>2]=B;u:{if(!r||(f=i[r+4>>2],i[r+4>>2]=f-1,f))break u;W[i[i[r>>2]+8>>2]](r),y(r)}for(o=856,t=A+856|0;;){r=i[t>>2];u:{if(!r|i[B+484>>2]!=u[r+13|0]||(r=i[t+4>>2],i[t>>2]=0,i[t+4>>2]=0,!r)||(f=i[r+4>>2],i[r+4>>2]=f-1,f))break u;W[i[i[r>>2]+8>>2]](r),y(r)}if(o=o+8|0,t=o+A|0,(o|0)==1368)break}o=0}r=i[B+4>>2],i[B+4>>2]=r-1,r||(W[i[i[B>>2]+8>>2]](B),y(B)),r=o,R4(A+548|0,O);break n;case 2:o=A,A=P+8|0,m=p(8520),i[m>>2]=61628,i[m+4>>2]=0,i[m+8>>2]=0,t=1006,k=m+12|0,u[k+8263|0]=0,u[k+8264|0]=0,u[k+8246|0]=2,u[k+8247|0]=0,u[k+8248|0]=0,u[k+8249|0]=0,u[k+8250|0]=0,i[k+4>>2]=0,i[k+8>>2]=0,u[k|0]=0,i[k+8448>>2]=0,i[k+8452>>2]=0,u[k+26|0]=0,g[k+24>>1]=0,i[k+20>>2]=27,u[k+17|0]=1,u[k+18|0]=1,u[k+9|0]=0,u[k+10|0]=0,u[k+11|0]=0,u[k+12|0]=0,u[k+13|0]=0,u[k+14|0]=0,u[k+15|0]=0,u[k+16|0]=0,r=k+8456|0,i[r>>2]=0,i[r+4>>2]=0,r=k+8464|0,i[r>>2]=0,i[r+4>>2]=0,f=k+8472|0,i[f>>2]=0,i[f+4>>2]=0,f=k+8480|0,i[f>>2]=0,i[f+4>>2]=0,f=k+8488|0,i[f>>2]=0,i[f+4>>2]=0,n=k+8496|0,i[n>>2]=0,i[n+4>>2]=0,i[k+8504>>2]=0,u[k+43|0]=0,u[k+44|0]=0,u[k+45|0]=0,u[k+46|0]=0,i[k+36>>2]=0,i[k+40>>2]=0,i[k+28>>2]=0,i[k+32>>2]=0,g[k+56>>1]=257,i[k+48>>2]=1,i[k+52>>2]=1,u[k+58|0]=1,o0(k+8280|0,0,168),i[f>>2]=0,i[r>>2]=0,i[k+8268>>2]=0,u[k+8233|0]=0,u[k+61|0]=0,u[k+59|0]=0,u[k+60|0]=0,i[k+64>>2]=0,i[k+68>>2]=0,u[k+72|0]=0,i[k+8236>>2]=2,i[k+8240>>2]=0,g[k+8244>>1]=0,u[k|0]=0,r=i[k+8>>2],i[k+4>>2]=0,i[k+8>>2]=0;u:{if(!r||(f=i[r+4>>2],i[r+4>>2]=f-1,f))break u;W[i[i[r>>2]+8>>2]](r),y(r)}i[k+12>>2]=0,i[k+28>>2]=0,i[k+32>>2]=0,u[k+26|0]=0,g[k+24>>1]=0,i[k+20>>2]=27,u[k+18|0]=1,u[k+58|0]=1,g[k+56>>1]=257,i[k+48>>2]=1,i[k+52>>2]=1,g[k+16>>1]=256,i[k+36>>2]=0,i[k+40>>2]=0,u[k+43|0]=0,u[k+44|0]=0,u[k+45|0]=0,u[k+46|0]=0,w=k+8280|0,o0(w,0,168),i[k+8268>>2]=0,u[k+8233|0]=0,u[k+61|0]=0,u[k+59|0]=0,u[k+60|0]=0,i[k+64>>2]=0,i[k+68>>2]=0,u[k+72|0]=0,i[k+8236>>2]=2,i[k+8240>>2]=0,g[k+8244>>1]=0,i[k+8452>>2]=i[k+8448>>2],i[k+8464>>2]=i[k+8460>>2],i[k+8476>>2]=i[k+8472>>2],i[k+8488>>2]=i[k+8484>>2],i[k+8500>>2]=i[k+8496>>2],r=f2(A),u[k+12|0]=r;u:{if(!((r|0)!=-99999&(r|0)<=63)){F2(o+4|0,1009,0);break u}r=f2(A),u[k+13|0]=r;o:{l:{if(!((r|0)!=-99999&(r|0)<=15))break l;if(e0=k,r0=v0(A,1),u[e0+14|0]=r0,e0=k,r0=v0(A,1),u[e0+43|0]=r0,e0=k,r0=v0(A,3),u[e0+8240|0]=r0,e0=k,r0=v0(A,1),u[e0+15|0]=r0,e0=k,r0=v0(A,1),u[e0+16|0]=r0,r=f2(A),u[k+17|0]=r,(r|0)==-99999||(u[k+17|0]=r+1,r=f2(A),u[k+18|0]=r,(r|0)==-99999))break o;if(u[k+18|0]=r+1,r=o+(u[k+13|0]<<3)|0,n=i[r+728>>2],!n)break l;f=i[r+732>>2],f&&(i[f+4>>2]=i[f+4>>2]+1),i[k+4>>2]=n,r=i[k+8>>2],i[k+8>>2]=f;s:{if(!r||(f=i[r+4>>2],i[r+4>>2]=f-1,f))break s;W[i[i[r>>2]+8>>2]](r),y(r)}if(r=K1(A),i[k+20>>2]=r,(r|0)==-99999)break o;i[k+20>>2]=r+26,e0=k,r0=v0(A,1),u[e0+24|0]=r0,e0=k,r0=v0(A,1),u[e0+25|0]=r0,r=v0(A,1),u[k+26|0]=r;s:{if(r&255){if(r=f2(A),i[k+28>>2]=r,(r|0)!=-99999)break s;break o}i[k+28>>2]=0}if(r=K1(A),i[k+32>>2]=r,(r|0)==-99999||(r=K1(A),i[k+36>>2]=r,(r|0)==-99999))break o;e0=k,r0=v0(A,1),u[e0+40|0]=r0,e0=k,r0=v0(A,1),u[e0+41|0]=r0,e0=k,r0=v0(A,1),u[e0+42|0]=r0,e0=k,r0=v0(A,1),u[e0+44|0]=r0,e0=k,r0=v0(A,1),u[e0+46|0]=r0,e0=k,r0=v0(A,1),u[e0+45|0]=r0;s:{w:{if(l[k+46|0]){if(r=f2(A),i[k+48>>2]=r,!((r|0)!=-99999&(r|0)<10)||(i[k+48>>2]=r+1,r=f2(A),i[k+52>>2]=r,!((r|0)!=-99999&(r|0)<10)))break o;if(i[k+52>>2]=r+1,r=v0(A,1),u[k+56|0]=r,!(r&255)){if(r=i[k+4>>2],f=i[r+16900>>2],n=i[r+16892>>2],h=i[k+48>>2],(h|0)>=2)for(r=0;;){if(_=w+(r<<2)|0,h=f2(A),i[_>>2]=h,(h|0)==-99999)break o;if(h=h+1|0,i[_>>2]=h,n=n-h|0,r=r+1|0,h=i[k+48>>2],!((r|0)<(h-1|0)))break}if((n|0)<=0)break s;if(i[(w+(h<<2)|0)-4>>2]=n,n=i[k+52>>2],(n|0)>=2)for(w=k+8320|0,r=0;;){if(h=w+(r<<2)|0,n=f2(A),i[h>>2]=n,(n|0)==-99999)break o;if(n=n+1|0,i[h>>2]=n,f=f-n|0,r=r+1|0,n=i[k+52>>2],!((r|0)<(n-1|0)))break}if((f|0)<=0)break s;i[(k+(n<<2)|0)+8316>>2]=f}r=v0(A,1);break w}u[k+56|0]=1,i[k+48>>2]=1,i[k+52>>2]=1,r=0}i[k+64>>2]=0,i[k+68>>2]=0,u[k+57|0]=r,e0=k,r0=v0(A,1),u[e0+58|0]=r0,r=v0(A,1),u[k+59|0]=r;w:{if(r&255){if(e0=k,r0=v0(A,1),u[e0+60|0]=r0,r=v0(A,1),u[k+61|0]=r,r&255)break w;if(r=K1(A),i[k- -64>>2]=r,(r|0)==-99999||(i[k+64>>2]=r<<1,r=K1(A),i[k+68>>2]=r,(r|0)==-99999))break o;i[k+68>>2]=r<<1;break w}g[k+60>>1]=0}if(f=v0(A,1),u[k+72|0]=f,r=i[k+4>>2],n=f&255,!(l[r+636|0]|!n))break o;f=k+73|0;w:{if(n){if(r=k9(A,f),!r)break w;F2(o+4|0,r,0);break u}x(f,r+638|0,8160)}if(e0=k,r0=v0(A,1),u[e0+8233|0]=r0,r=f2(A),i[k+8236>>2]=r,(r|0)==-99999)break o;if(i[k+8236>>2]=r+2,f=i[k+4>>2],(r|0)>((i[f+612>>2]+i[f+616>>2]|0)-2|0))break s;e0=k,r0=v0(A,1),u[e0+8241|0]=r0,r=v0(A,1),u[k+8242|0]=r;w:{if(!(r&255)||(e0=k,r0=v0(A,1),u[e0+8243|0]=r0,e0=k,r0=v0(A,1),u[e0+8244|0]=r0,e0=k,r0=v0(A,6),u[e0+8245|0]=r0,!l[k+8243|0]))break w;r=k+8246|0,f=i[(o+(u[k+13|0]<<3)|0)+728>>2],l[k+25|0]&&(e0=r,r0=f2(A)+2|0,u[e0|0]=r0),n=v0(A,1),u[r+1|0]=(n|0)!=0,!n|i[f+16848>>2]==3||F2(o+4|0,1006,0),n=v0(A,1),u[r+2|0]=(n|0)!=0;_:{h:{B:{v:{if(!(i[f+16848>>2]|!n)){if(F2(o+4|0,1006,0),u[r+2|0]&1)break v;break B}if(!n)break B}if(n=f2(A),!((n|0)!=-99999&(n|0)<=i[f+616>>2])||(u[r+3|0]=n,n=f2(A),!((n|0)!=-99999&(n|0)<6)))break h;if(n=(n&255)+1|0,u[r+4|0]=n,(n|0)!=(n&255))break B;for(w=r+11|0,h=r+5|0,n=0;;){if(_=K1(A),_-13>>>0<=4294967270||(u[n+h|0]=_,_=K1(A),_-13>>>0<=4294967270))break h;if(u[n+w|0]=_,n=n+1|0,!(n>>>0<l[r+4|0]))break}}B:{if(n=f2(A),(n|0)!=-99999&&(w=i[f+16832>>2],(n|0)<=(((w|0)<=10?10:w)-10|0)))break B;break h}u[r+17|0]=n;B:{if(A=f2(A),(A|0)!=-99999&&(f=i[f+16840>>2],(A|0)<=(((f|0)<=10?10:f)-10|0)))break B;break h}u[r+18|0]=A,A=1;break _}F2(o+4|0,1006,0),A=0}if(!A)break s}f=0,r=v,A0=r,w=i[k+4>>2],A=i[w+16876>>2],i[k+8276>>2]=l[k+8246|0],i[k+8268>>2]=A-i[k+28>>2],i[k+8272>>2]=A-l[k+8249|0],h=i[k+48>>2];w:{if(!l[k+56|0])break w;_=r-((h<<2)+19&-16)|0,v=_;_:{if((h|0)<0)break _;if(A=i[w+16892>>2],h)for(n=h+1&-2,r=0;i[_+(f<<2)>>2]=(G(A,f)|0)/(h|0),Q=f|1,i[_+(Q<<2)>>2]=(G(A,Q)|0)/(h|0),f=f+2|0,r=r+2|0,(n|0)!=(r|0););h&1||(i[_+(f<<2)>>2]=(G(A,f)|0)/(h|0)),I=h&3,Q=k+8280|0,r=i[_>>2];h:{if(h-1>>>0<3){f=0;break h}for(F=h&2147483644,f=0,n=0;A=f<<2,S=A|4,X=i[S+_>>2],i[A+Q>>2]=X-r,V=Q+S|0,r=A|8,S=i[r+_>>2],i[V>>2]=S-X,A=A|12,X=i[A+_>>2],i[r+Q>>2]=X-S,f=f+4|0,r=i[_+(f<<2)>>2],i[A+Q>>2]=r-X,n=n+4|0,(F|0)!=(n|0););}if(!I)break _;for(;n=Q+(f<<2)|0,f=f+1|0,A=i[_+(f<<2)>>2],i[n>>2]=A-r,r=A,s=s+1|0,(I|0)!=(s|0););}if(f=0,A=i[k+52>>2],_=_-((A<<2)+19&-16)|0,v=_,(A|0)<0)break w;if(n=i[w+16900>>2],A)for(s=A+1&-2,r=0;i[_+(f<<2)>>2]=(G(f,n)|0)/(A|0),Q=f|1,i[_+(Q<<2)>>2]=(G(n,Q)|0)/(A|0),f=f+2|0,r=r+2|0,(s|0)!=(r|0););A&1||(i[_+(f<<2)>>2]=(G(f,n)|0)/(A|0)),I=A&3,Q=k+8320|0,r=i[_>>2],s=0;_:{if(A-1>>>0<3){f=0;break _}for(F=A&2147483644,f=0,n=0;A=f<<2,S=A|4,X=i[S+_>>2],i[A+Q>>2]=X-r,V=Q+S|0,r=A|8,S=i[r+_>>2],i[V>>2]=S-X,A=A|12,X=i[A+_>>2],i[r+Q>>2]=X-S,f=f+4|0,r=i[_+(f<<2)>>2],i[A+Q>>2]=r-X,n=n+4|0,(F|0)!=(n|0););}if(!I)break w;for(;n=Q+(f<<2)|0,f=f+1|0,A=i[_+(f<<2)>>2],i[n>>2]=A-r,r=A,s=s+1|0,(I|0)!=(s|0););}i[k+8360>>2]=0,_=k+8360|0;w:{if((h|0)<=0)break w;if(s=k+8280|0,A=0,h>>>0>=4)for(f=h&2147483644,n=0;r=A<<2,Q=r|4,B=i[r+s>>2]+B|0,i[Q+_>>2]=B,I=r|8,B=B+i[s+Q>>2]|0,i[I+_>>2]=B,r=r|12,B=B+i[s+I>>2]|0,i[r+_>>2]=B,A=A+4|0,B=B+i[r+s>>2]|0,i[_+(A<<2)>>2]=B,n=n+4|0,(f|0)!=(n|0););if(n=h&3,!n)break w;for(r=0;f=A+1|0,B=i[s+(A<<2)>>2]+B|0,i[_+(f<<2)>>2]=B,A=f,r=r+1|0,(n|0)!=(r|0););}i[k+8404>>2]=0,h=k+8404|0,r=i[k+52>>2];w:{if((r|0)<=0)break w;if(s=k+8320|0,n=0,B=0,A=0,r>>>0>=4)for(I=r&2147483644,f=0;Q=A<<2,X=Q|4,B=i[s+Q>>2]+B|0,i[X+h>>2]=B,F=Q|8,B=B+i[s+X>>2]|0,i[F+h>>2]=B,Q=Q|12,B=B+i[s+F>>2]|0,i[Q+h>>2]=B,A=A+4|0,B=B+i[s+Q>>2]|0,i[h+(A<<2)>>2]=B,f=f+4|0,(I|0)!=(f|0););if(f=r&3,!f)break w;for(;r=A+1|0,B=i[s+(A<<2)>>2]+B|0,i[h+(r<<2)>>2]=B,A=r,n=n+1|0,(f|0)!=(n|0););}S=k+8448|0,A=i[w+16908>>2],f=i[k+8448>>2],r=i[k+8452>>2]-f>>2;w:{if(A>>>0>r>>>0){V8(S,A-r|0),A=i[w+16908>>2];break w}if(A>>>0>=r>>>0)break w;i[k+8452>>2]=f+(A<<2)}f=i[k+8460>>2],r=i[k+8464>>2]-f>>2;w:{if(r>>>0<A>>>0){V8(k+8460|0,A-r|0),A=i[w+16908>>2];break w}if(A>>>0>=r>>>0)break w;i[k+8464>>2]=f+(A<<2)}N=k+8472|0,f=i[k+8472>>2],r=i[k+8476>>2]-f>>2;w:{if(r>>>0<A>>>0){V8(N,A-r|0),A=i[w+16908>>2];break w}if(A>>>0>=r>>>0)break w;i[k+8476>>2]=f+(A<<2)}z=k+8484|0,f=i[k+8484>>2],r=i[k+8488>>2]-f>>2;w:{if(r>>>0<A>>>0){V8(z,A-r|0);break w}if(A>>>0>=r>>>0)break w;i[k+8488>>2]=f+(A<<2)}$=k+8496|0,A=i[w+16932>>2],f=i[k+8496>>2],r=i[k+8500>>2]-f>>2;w:{if(A>>>0>r>>>0){V8($,A-r|0);break w}if(A>>>0>=r>>>0)break w;i[k+8500>>2]=f+(A<<2)}if(i[w+16908>>2]>0)for(E=k+8280|0,V=k+8320|0,m0=i[k+8460>>2],a=i[k+8448>>2],r=0;;){A=i[w+16892>>2],Q=(r|0)/(A|0)|0,I=r-G(A,Q)|0,s=-1,n=i[k+48>>2];w:{if((n|0)<=0)break w;if(f=0,A=0,n>>>0>=4)for(X=n&2147483644,B=0;M=(I|0)<i[_+(A<<2)>>2]?s:A,s=A|1,M=(I|0)<i[_+(s<<2)>>2]?M:s,s=A|2,M=(I|0)<i[_+(s<<2)>>2]?M:s,s=A|3,s=(I|0)<i[_+(s<<2)>>2]?M:s,A=A+4|0,B=B+4|0,(X|0)!=(B|0););if(n=n&3,!n)break w;for(;s=(I|0)<i[_+(A<<2)>>2]?s:A,A=A+1|0,f=f+1|0,(n|0)!=(f|0););}X=i[k+52>>2];w:{if((X|0)<=0){n=-1;break w}if(n=-1,f=0,A=0,X>>>0>=4)for(F=X&2147483644,B=0;M=(Q|0)<i[h+(A<<2)>>2]?n:A,n=A|1,M=(Q|0)<i[h+(n<<2)>>2]?M:n,n=A|2,M=(Q|0)<i[h+(n<<2)>>2]?M:n,n=A|3,n=(Q|0)<i[h+(n<<2)>>2]?M:n,A=A+4|0,B=B+4|0,(F|0)!=(B|0););if(B=X&3,!B)break w;for(;n=(Q|0)<i[h+(A<<2)>>2]?n:A,A=A+1|0,f=f+1|0,(B|0)!=(f|0););}f=0,A=a+(r<<2)|0,i[A>>2]=0;w:{if((s|0)<=0)break w;if(X=V+(n<<2)|0,F=0,B=0,s>>>0>=4)for(_0=s&2147483644,R=0;M=f,f=E+(B<<2)|0,M=M+G(i[f>>2],i[X>>2])|0,i[A>>2]=M,M=M+G(i[f+4>>2],i[X>>2])|0,i[A>>2]=M,M=M+G(i[f+8>>2],i[X>>2])|0,i[A>>2]=M,f=M+G(i[f+12>>2],i[X>>2])|0,i[A>>2]=f,B=B+4|0,R=R+4|0,(_0|0)!=(R|0););if(R=s&3,!R)break w;for(;f=G(i[E+(B<<2)>>2],i[X>>2])+f|0,i[A>>2]=f,B=B+1|0,F=F+1|0,(R|0)!=(F|0););}w:{if((n|0)<=0)break w;R=n&3,X=0;_:{if(n>>>0<4){B=0;break _}for(_0=n&2147483644,B=0,F=0;M=f,f=V+(B<<2)|0,M=M+G(i[f>>2],i[w+16892>>2])|0,i[A>>2]=M,M=M+G(i[f+4>>2],i[w+16892>>2])|0,i[A>>2]=M,M=M+G(i[f+8>>2],i[w+16892>>2])|0,i[A>>2]=M,f=M+G(i[f+12>>2],i[w+16892>>2])|0,i[A>>2]=f,B=B+4|0,F=F+4|0,(_0|0)!=(F|0););}if(!R)break w;for(;f=G(i[V+(B<<2)>>2],i[w+16892>>2])+f|0,i[A>>2]=f,B=B+1|0,X=X+1|0,(R|0)!=(X|0););}if((n|s)<0&&(D0(21952,18195,620,5221),H()),B=f,f=s<<2,n=B+G(i[f+E>>2],Q-i[h+(n<<2)>>2]|0)|0,i[A>>2]=n,s=A,A=n+(I-i[f+_>>2]|0)|0,i[s>>2]=A,i[m0+(A<<2)>>2]=r,r=r+1|0,!((r|0)<i[w+16908>>2]))break}f=i[k+52>>2];w:{if((f|0)<=0||(B=0,A=i[k+48>>2],(A|0)<=0))break w;for(s=0;;){_:{if((A|0)<=0){s=s+1|0;break _}if(n=0,Q=h+(s<<2)|0,s=s+1|0,F=h+(s<<2)|0,X=i[F>>2],(X|0)<=i[Q>>2]){B=((A|0)<=1?1:A)+B|0;break _}for(;;){f=i[Q>>2];h:{if((X|0)<=(f|0)){n=n+1|0;break h}if(I=_+(n<<2)|0,n=n+1|0,E=_+(n<<2)|0,r=i[E>>2],(r|0)<=i[I>>2])break h;for(V=i[z>>2],R=i[N>>2],m0=i[S>>2];;){if(A=i[I>>2],(r|0)>(A|0)){for(;r=A<<2,i[R+(i[r+(m0+(G(i[w+16892>>2],f)<<2)|0)>>2]<<2)>>2]=B,i[r+(V+(G(i[w+16892>>2],f)<<2)|0)>>2]=B,A=A+1|0,r=i[E>>2],(A|0)<(r|0););X=i[F>>2]}if(f=f+1|0,!((X|0)>(f|0)))break}A=i[k+48>>2]}if(B=B+1|0,!((A|0)>(n|0)))break}f=i[k+52>>2]}if(!((f|0)>(s|0)))break}}f=i[w+16928>>2];w:{if((f|0)<=0||(n=0,A=i[w+16924>>2],(A|0)<=0))break w;for(_=i[$>>2],Q=i[S>>2];;){if(r=0,(A|0)>0){for(;;){I=_+(r<<2)|0,s=I+(G(A,n)<<2)|0,A=i[w+16936>>2],f=i[w+16876>>2],i[s>>2]=i[(Q+(G(i[w+16892>>2],n<<A>>f)<<2)|0)+(r<<A>>f<<2)>>2]<<(f-A<<1),s=i[w+16876>>2],B=i[w+16936>>2],h=s-B|0;_:{if((h|0)<=0){f=0;break _}if(A=0,f=0,(s|0)!=(B+1|0))for(X=h&2147483646,s=0;F=A|1,B=2<<A,V=f,f=1<<A,f=((B&n?4<<A<<F:0)+((V+(f&n?B<<A:0)|0)+(r&f?f<<A:0)|0)|0)+(r&B?B<<F:0)|0,A=A+2|0,s=s+2|0,(X|0)!=(s|0););if(!(h&1))break _;s=f,f=1<<A,f=(s+(f&n?2<<A<<A:0)|0)+(r&f?f<<A:0)|0}if(A=I+(G(i[w+16924>>2],n)<<2)|0,i[A>>2]=i[A>>2]+f,A=i[w+16924>>2],r=r+1|0,!((A|0)>(r|0)))break}f=i[w+16928>>2]}if(n=n+1|0,!((n|0)<(f|0)))break}}v=A0,u[k|0]=1,s=1}break u}F2(o+4|0,1010,0);break u}F2(o+4|0,1006,0)}u:{if(!s)break u;if(t=0,s=i[o+524>>2],(s|0)>=0){f=0,A=v-720|0,v=A,r=67556;o:{l:switch(s-1|0){case 1:r=67552;break;case 0:break l;default:break o}if(r=i[r>>2],k0(r,42129,0),i[A+704>>2]=u[k+12|0],k0(r,38992,A+704|0),i[A+688>>2]=u[k+13|0],k0(r,38959,A+688|0),i[A+672>>2]=u[k+14|0],k0(r,35857,A+672|0),i[A+656>>2]=u[k+15|0],k0(r,38572,A+656|0),i[A+640>>2]=u[k+16|0],k0(r,37653,A+640|0),i[A+624>>2]=u[k+17|0],k0(r,36385,A+624|0),i[A+608>>2]=u[k+18|0],k0(r,36349,A+608|0),i[A+592>>2]=i[k+20>>2],k0(r,40871,A+592|0),i[A+576>>2]=u[k+24|0],k0(r,34446,A+576|0),i[A+560>>2]=u[k+25|0],k0(r,34527,A+560|0),i[A+544>>2]=u[k+26|0],k0(r,37137,A+544|0),l[k+26|0]&&(i[A+528>>2]=i[k+28>>2],k0(r,37933,A+528|0)),i[A+512>>2]=i[k+32>>2],k0(r,40322,A+512|0),i[A+496>>2]=i[k+36>>2],k0(r,40287,A+496|0),i[A+480>>2]=u[k+40|0],k0(r,34946,A+480|0),i[A+464>>2]=u[k+41|0],k0(r,39898,A+464|0),i[A+448>>2]=u[k+42|0],k0(r,39443,A+448|0),i[A+432>>2]=u[k+43|0],k0(r,37966,A+432|0),i[A+416>>2]=u[k+44|0],k0(r,34411,A+416|0),i[A+400>>2]=u[k+46|0],k0(r,39979,A+400|0),i[A+384>>2]=u[k+45|0],k0(r,34605,A+384|0),l[k+46|0]){if(i[A+368>>2]=i[k+48>>2],k0(r,37517,A+368|0),i[A+352>>2]=i[k+52>>2],k0(r,38781,A+352|0),i[A+336>>2]=u[k+56|0],k0(r,34385,A+336|0),k0(r,30175,0),i[k+48>>2]>=0)for(n=k+8360|0;i[A+320>>2]=i[n+(f<<2)>>2],k0(r,29163,A+320|0),B=i[k+48>>2]>(f|0),f=f+1|0,!!B;);if(f=0,k0(r,42323,0),k0(r,30153,0),i[k+52>>2]>=0)for(n=k+8404|0;i[A+304>>2]=i[n+(f<<2)>>2],k0(r,29163,A+304|0),B=i[k+52>>2]>(f|0),f=f+1|0,!!B;);k0(r,42323,0),i[A+288>>2]=u[k+57|0],k0(r,35901,A+288|0)}if(i[A+272>>2]=u[k+58|0],k0(r,34479,A+272|0),i[A+256>>2]=u[k+59|0],k0(r,34189,A+256|0),l[k+59|0]&&(i[A+240>>2]=u[k+60|0],k0(r,34560,A+240|0),i[A+224>>2]=u[k+61|0],k0(r,34309,A+224|0),i[A+208>>2]=i[k+64>>2],k0(r,41500,A+208|0),i[A+192>>2]=i[k+68>>2],k0(r,41518,A+192|0)),i[A+176>>2]=u[k+72|0],k0(r,34269,A+176|0),i[A+160>>2]=u[k+8233|0],k0(r,34152,A+160|0),i[A+144>>2]=i[k+8236>>2],k0(r,38294,A+144|0),i[A+128>>2]=u[k+8240|0],k0(r,37447,A+128|0),i[A+112>>2]=u[k+8241|0],k0(r,35272,A+112|0),i[A+96>>2]=u[k+8242|0],k0(r,40131,A+96|0),i[A+80>>2]=u[k+8243|0],k0(r,38490,A+80|0),i[A+64>>2]=u[k+8244|0],k0(r,35447,A- -64|0),i[A+48>>2]=u[k+8245|0],k0(r,39862,A+48|0),i[A+32>>2]=i[k+8268>>2],k0(r,39705,A+32|0),i[A+16>>2]=i[k+8272>>2],k0(r,36661,A+16|0),i[A>>2]=i[k+8276>>2],k0(r,36702,A),!l[k+8243|0])break o;f=k+8246|0,r=v-144|0,v=r,n=67556;l:switch(s-1|0){case 1:n=67552;case 0:s=i[n>>2],k0(s,42254,0),i[r+128>>2]=l[f|0],k0(s,38735,r+128|0),i[r+112>>2]=l[f+1|0],k0(s,36034,r+112|0),i[r+96>>2]=l[f+2|0],k0(s,38605,r+96|0);s:{if(l[f+2|0]!=1||(i[r+80>>2]=l[f+3|0],k0(s,39615,r+80|0),i[r+64>>2]=l[f+4|0],k0(s,40715,r- -64|0),!l[f+4|0]))break s;for(B=f+11|0,w=f+5|0,n=0;i[r+52>>2]=u[n+w|0],i[r+48>>2]=n,k0(s,41229,r+48|0),i[r+36>>2]=u[n+B|0],i[r+32>>2]=n,k0(s,41182,r+32|0),n=n+1|0,n>>>0<l[f+4|0];);}i[r+16>>2]=l[f+17|0],k0(s,40603,r+16|0),i[r>>2]=l[f+18|0],k0(s,40167,r);break;default:break l}v=r+144|0}v=A+720|0}if(i[m+4>>2]=i[m+4>>2]+1,r=o+(u[m+24|0]<<3)|0,i[r+856>>2]=k,A=i[r+860>>2],i[r+860>>2]=m,!A||(r=i[A+4>>2],i[A+4>>2]=r-1,r))break u;W[i[i[A>>2]+8>>2]](A),y(A)}A=i[m+4>>2],i[m+4>>2]=A-1,A||(W[i[i[m>>2]+8>>2]](m),y(m)),r=t,R4(o+548|0,O);break n;case 7:case 8:n=P+8|0,s=(f|0)==40,f=0,t=0,o=v-80|0,v=o;u:{for(k=i[A+1376>>2];r=v0(n,8),f=r+f|0,(r|0)==255;);for(;r=v0(n,8),t=r+t|0,(r|0)==255;);i[o+4>>2]=t,i[o>>2]=f,r=0;o:{if((f|0)!=132||(e0=o,r0=v0(n,8),i[e0+8>>2]=r0,r=1025,!k))break o;for(f=o+27|0,B=o+26|0,w=o+25|0,h=o+24|0,_=o+23|0,m=o+22|0,Q=o+21|0,I=o+20|0,X=o+19|0,F=o+18|0,S=o+17|0,E=o+16|0,V=o+15|0,N=o+14|0,z=o+13|0,$=o+12|0,R=o+60|0,A0=o+68|0,k=i[k+476>>2],t=0;;){l:{s:switch(i[o+8>>2]){case 0:r=t<<4,e0=r+$|0,r0=v0(n,8),u[e0|0]=r0,e0=r+z|0,r0=v0(n,8),u[e0|0]=r0,e0=r+N|0,r0=v0(n,8),u[e0|0]=r0,e0=r+V|0,r0=v0(n,8),u[e0|0]=r0,e0=r+E|0,r0=v0(n,8),u[e0|0]=r0,e0=r+S|0,r0=v0(n,8),u[e0|0]=r0,e0=r+F|0,r0=v0(n,8),u[e0|0]=r0,e0=r+X|0,r0=v0(n,8),u[e0|0]=r0,e0=r+I|0,r0=v0(n,8),u[e0|0]=r0,e0=r+Q|0,r0=v0(n,8),u[e0|0]=r0,e0=r+m|0,r0=v0(n,8),u[e0|0]=r0,e0=r+_|0,r0=v0(n,8),u[e0|0]=r0,e0=r+h|0,r0=v0(n,8),u[e0|0]=r0,e0=r+w|0,r0=v0(n,8),u[e0|0]=r0,e0=r+B|0,r0=v0(n,8),u[e0|0]=r0,e0=r+f|0,r0=v0(n,8),u[e0|0]=r0;break l;case 1:e0=R+(t<<1)|0,r0=v0(n,16),g[e0>>1]=r0;break l;case 2:break s;default:break l}e0=A0+(t<<2)|0,r0=v0(n,32),i[e0>>2]=r0}if(!(k&&(r=t>>>0<2,t=t+1|0,r)))break}r=0}o:{if(!r){if(!s||(f=i[A+3212>>2],(f|0)==i[A+3208>>2]))break o;if(k=i[f-4>>2],f=i[k+440>>2],s=i[k+444>>2],f>>>0<s>>>0){x(f,o,80),i[k+440>>2]=f+80;break o}if(t=i[k+436>>2],f=f-t|0,n=((f|0)/80|0)+1|0,n>>>0>=53687092)break i;if(s=(s-t|0)/80|0,B=s<<1,s=s>>>0>=26843545?53687091:n>>>0<B>>>0?B:n,s){if(s>>>0>=53687092)break e;n=p(G(s,80))}else n=0;B=n+f|0,x(B,o,80),w=B+G((f|0)/-80|0,80)|0,f&&x(w,t,f),i[k+444>>2]=n+G(s,80),f=B+80|0,i[k+440>>2]=f,i[k+436>>2]=w,t&&Z(t),i[k+440>>2]=f;break o}if(f=i[A+84>>2],(f|0)==20){i[A+80>>2]=1001;break o}i[A+84>>2]=f+1,i[((f<<2)+A|0)+4>>2]=r}v=o+80|0;break u}R4(A+548|0,O);break n;case 4:u[A+2203|0]=1,R4(A+548|0,O);break n;default:break t}R4(A+548|0,O)}v=P+32|0,u[X0+15|0]=1;break k}if(!(l[A+549|0]!=1|i[A+3208>>2]!=i[A+3212>>2])){if(r=13,A=1,e)break A;break f}r=y7(A,X0+15|0)}if(!e)break f;A=r?0:l[X0+15|0]}i[e>>2]=A}return v=X0+16|0,r}D0(10152,18155,1328,15108),H()}z0(),H()}G0(),H()}function V6(A,e,r,f){var k=0,n=0,t=0,o=0,s=0,w=0,h=0,_=0,B=0;n=v-336|0,v=n,i[n+304>>2]=0,i[n+308>>2]=0,i[n+312>>2]=0,i[n+316>>2]=0,i[n+320>>2]=0,i[n+296>>2]=0,i[n+300>>2]=0,i[n+288>>2]=86356,$6(n+264|0,n+288|0,e);i:{if(i[n+264>>2]){e=i[n+268>>2],i[A>>2]=i[n+264>>2],i[A+4>>2]=e,i[A+16>>2]=i[n+280>>2],e=i[n+276>>2],i[A+8>>2]=i[n+272>>2],i[A+12>>2]=e,i[n+280>>2]=0,i[n+272>>2]=0,i[n+276>>2]=0;break i}if(l[e+20|0]==1){if(u[n+72|0]=0,u[n+83|0]=0,q(A,2,100,n+72|0),u[n+83|0]>=0)break i;Z(i[n+72>>2]);break i}k=i[r+4>>2],i[r>>2]=0,i[r+4>>2]=0;e:{if(!k||(t=i[k+4>>2],i[k+4>>2]=t-1,t))break e;W[i[i[k>>2]+8>>2]](k),y(k)}i[n+256>>2]=0,i[n+260>>2]=0;e:{r:{f:{A:{k:{n:{t:{u:{o:{l:{s:{w:{_:{h:{B:{v:{Z:{G:{m:{X:{W:{F:{V:{C:{g:{I:{y:{U:{D:{M:{J:{p:{E:{$:{Y:{H:{z:{x:{T:{R:{S:{j:{O:{P:{L:{K:{q:{_0:{d:{v0:{c:{b:{i0:{e0:{r0:{f0:{A0:{k0:{n0:{t0:{m0:{u0:{o0:{l0:{s0:{w0:{N:{a:{h0:{k=i[n+304>>2];Z0:{if((k|0)<=1781689192){if((k|0)<=1701604966){if((k|0)<=1667523941){if((k|0)<=1635135536){if((k|0)<=1634563684){if((k|0)==1630628984)break O;if((k|0)==1630629744)break P;if((k|0)!=1634497650)break f;k=p(136),i[k+4>>2]=0,i[k+8>>2]=0,i[k>>2]=90964,t=k+16|0,o0(t,0,104),i[k+80>>2]=-1,i[k+84>>2]=-1,i[k+72>>2]=-1,i[k+76>>2]=-1,i[k+88>>2]=0,i[k+92>>2]=0,i[k+96>>2]=0,i[k+100>>2]=0,i[k+104>>2]=0,i[k+108>>2]=0,g[k+112>>1]=0,i[k+120>>2]=0,i[k+124>>2]=0,i[k+16>>2]=88312,i[k+128>>2]=0,i[k+132>>2]=0,i[n+260>>2]=k,i[n+256>>2]=t,i[n+72>>2]=0,i[n+76>>2]=0;break e}if((k|0)==1634563685)break R;if((k|0)==1635088451)break k0;if((k|0)!=1635088489)break f;k=p(136),i[k+32>>2]=0,i[k+36>>2]=0,i[k+24>>2]=0,i[k+28>>2]=0,i[k+4>>2]=0,i[k+8>>2]=0,i[k+72>>2]=-1,i[k+76>>2]=-1,i[k+116>>2]=0,i[k+88>>2]=0,i[k+92>>2]=0,i[k+16>>2]=105420,i[k+120>>2]=0,i[k+124>>2]=0,i[k>>2]=93644,i[k+40>>2]=0,i[k+44>>2]=0,i[k+48>>2]=0,i[k+52>>2]=0,i[k+56>>2]=0,i[k+60>>2]=0,i[k- -64>>2]=0,i[k+80>>2]=-1,i[k+84>>2]=-1,i[k+96>>2]=0,i[k+100>>2]=0,i[k+104>>2]=0,i[k+108>>2]=0,g[k+112>>1]=0,i[k+128>>2]=0,i[k+32>>2]=1635088489,i[n+76>>2]=k,i[n+72>>2]=k+16,t=i[n+72>>2],o=i[n+76>>2],i[n+72>>2]=0,i[n+76>>2]=0,k=i[n+260>>2],i[n+256>>2]=t,i[n+260>>2]=o;Q:{if(!k||(t=i[k+4>>2],i[k+4>>2]=t-1,t))break Q;W[i[i[k>>2]+8>>2]](k),y(k)}break e}if((k|0)<=1635148592){if((k|0)==1635135537)break i0;if((k|0)!=1635135811)break f;k=p(144),i[k+24>>2]=0,i[k+28>>2]=0,i[k+4>>2]=0,i[k+8>>2]=0,i[k+72>>2]=-1,i[k+76>>2]=-1,i[k+88>>2]=0,i[k+92>>2]=0,i[k+16>>2]=98080,g[k+114>>1]=0,g[k+116>>1]=0,g[k+118>>1]=0,g[k+120>>1]=0,i[k+136>>2]=0,i[k+128>>2]=0,i[k+132>>2]=0,i[k>>2]=90524,i[k+32>>2]=0,i[k+36>>2]=0,i[k+40>>2]=0,i[k+44>>2]=0,i[k+48>>2]=0,i[k+52>>2]=0,i[k+56>>2]=0,i[k+60>>2]=0,i[k- -64>>2]=0,i[k+80>>2]=-1,i[k+84>>2]=-1,i[k+96>>2]=0,i[k+100>>2]=0,i[k+104>>2]=0,i[k+108>>2]=0,g[k+112>>1]=256,u[k+121|0]=0,u[k+122|0]=0,u[k+123|0]=0,u[k+124|0]=0,i[k+32>>2]=1635135811,i[n+76>>2]=k,i[n+72>>2]=k+16,t=i[n+72>>2],o=i[n+76>>2],i[n+72>>2]=0,i[n+76>>2]=0,k=i[n+260>>2],i[n+256>>2]=t,i[n+260>>2]=o;Q:{if(!k||(t=i[k+4>>2],i[k+4>>2]=t-1,t))break Q;W[i[i[k>>2]+8>>2]](k),y(k)}break e}Q:switch(k-1635148593|0){case 0:break y;case 18:break U;case 1:case 2:case 3:case 4:case 5:case 6:case 7:case 8:case 9:case 10:case 11:case 12:case 13:case 14:case 15:case 16:case 17:break f;default:break Q}if((k|0)==1651798644)break o;if((k|0)!=1667462004)break f;k=p(128),i[k+32>>2]=0,i[k+36>>2]=0,i[k+24>>2]=0,i[k+28>>2]=0,i[k+4>>2]=0,i[k+8>>2]=0,i[k+72>>2]=-1,i[k+76>>2]=-1,i[k+116>>2]=0,i[k+88>>2]=0,i[k+92>>2]=0,u[k+122|0]=0,u[k+120|0]=0,u[k+121|0]=0,i[k+16>>2]=105340,i[k>>2]=93604,i[k+40>>2]=0,i[k+44>>2]=0,i[k+48>>2]=0,i[k+52>>2]=0,i[k+56>>2]=0,i[k+60>>2]=0,i[k- -64>>2]=0,i[k+80>>2]=-1,i[k+84>>2]=-1,i[k+96>>2]=0,i[k+100>>2]=0,i[k+104>>2]=0,i[k+108>>2]=0,g[k+112>>1]=0,i[k+32>>2]=1667462004,i[n+76>>2]=k,i[n+72>>2]=k+16,t=i[n+72>>2],o=i[n+76>>2],i[n+72>>2]=0,i[n+76>>2]=0,k=i[n+260>>2],i[n+256>>2]=t,i[n+260>>2]=o;Q:{if(!k||(t=i[k+4>>2],i[k+4>>2]=t-1,t))break Q;W[i[i[k>>2]+8>>2]](k),y(k)}break e}if((k|0)<=1668114797){if((k|0)<=1668050024){if((k|0)==1667523942)break E;if((k|0)!=1668047216)break f;k=p(152),i[k+24>>2]=0,i[k+28>>2]=0,i[k+4>>2]=0,i[k+8>>2]=0,i[k+72>>2]=-1,i[k+76>>2]=-1,i[k+88>>2]=0,i[k+92>>2]=0,i[k+140>>2]=0,i[k+144>>2]=1,i[k+132>>2]=0,i[k+136>>2]=1,i[k+124>>2]=0,i[k+128>>2]=1,i[k+116>>2]=0,i[k+120>>2]=1,i[k>>2]=90284,i[k+32>>2]=0,i[k+36>>2]=0,i[k+40>>2]=0,i[k+44>>2]=0,i[k+48>>2]=0,i[k+52>>2]=0,i[k+56>>2]=0,i[k+60>>2]=0,i[k- -64>>2]=0,i[k+80>>2]=-1,i[k+84>>2]=-1,i[k+96>>2]=0,i[k+100>>2]=0,i[k+104>>2]=0,i[k+108>>2]=0,u[k+112|0]=0,i[k+16>>2]=87992,i[k+32>>2]=1668047216,i[n+76>>2]=k,i[n+72>>2]=k+16,t=i[n+72>>2],o=i[n+76>>2],i[n+72>>2]=0,i[n+76>>2]=0,k=i[n+260>>2],i[n+256>>2]=t,i[n+260>>2]=o;Q:{if(!k||(t=i[k+4>>2],i[k+4>>2]=t-1,t))break Q;W[i[i[k>>2]+8>>2]](k),y(k)}break e}if((k|0)==1668050025)break j;if((k|0)==1668112752)break p;if((k|0)!=1668113784)break f;cn(n+72|0),t=i[n+72>>2],o=i[n+76>>2],i[n+72>>2]=0,i[n+76>>2]=0,k=i[n+260>>2],i[n+256>>2]=t,i[n+260>>2]=o;Q:{if(!k||(t=i[k+4>>2],i[k+4>>2]=t-1,t))break Q;W[i[i[k>>2]+8>>2]](k),y(k)}break e}if((k|0)<=1684631141){if((k|0)==1668114798)break T;if((k|0)==1668246642)break L;if((k|0)!=1668576371)break f;k=p(144),i[k+24>>2]=0,i[k+28>>2]=0,i[k+4>>2]=0,i[k+8>>2]=0,i[k+72>>2]=-1,i[k+76>>2]=-1,i[k+116>>2]=0,i[k+88>>2]=0,i[k+92>>2]=0,i[k+16>>2]=104940,i[k+120>>2]=0,i[k+124>>2]=0,i[k>>2]=93404,i[k+32>>2]=0,i[k+36>>2]=0,i[k+40>>2]=0,i[k+44>>2]=0,i[k+48>>2]=0,i[k+52>>2]=0,i[k+56>>2]=0,i[k+60>>2]=0,i[k- -64>>2]=0,i[k+80>>2]=-1,i[k+84>>2]=-1,i[k+96>>2]=0,i[k+100>>2]=0,i[k+104>>2]=0,i[k+108>>2]=0,g[k+112>>1]=0,i[k+128>>2]=0,i[k+132>>2]=0,i[k+136>>2]=0,i[k+32>>2]=1668576371,i[n+76>>2]=k,i[n+72>>2]=k+16,t=i[n+72>>2],o=i[n+76>>2],i[n+72>>2]=0,i[n+76>>2]=0,k=i[n+260>>2],i[n+256>>2]=t,i[n+260>>2]=o;Q:{if(!k||(t=i[k+4>>2],i[k+4>>2]=t-1,t))break Q;W[i[i[k>>2]+8>>2]](k),y(k)}break e}if((k|0)==1684631142)break _0;if((k|0)==1685218662)break q;if((k|0)!=1701082227)break f;k=p(120),i[k+32>>2]=0,i[k+36>>2]=0,i[k+24>>2]=0,i[k+28>>2]=0,i[k+4>>2]=0,i[k+8>>2]=0,i[k+72>>2]=-1,i[k+76>>2]=-1,i[k+88>>2]=0,i[k+92>>2]=0,i[k>>2]=93684,i[k+40>>2]=0,i[k+44>>2]=0,i[k+48>>2]=0,i[k+52>>2]=0,i[k+56>>2]=0,i[k+60>>2]=0,i[k- -64>>2]=0,i[k+80>>2]=-1,i[k+84>>2]=-1,i[k+96>>2]=0,i[k+100>>2]=0,i[k+104>>2]=0,i[k+108>>2]=0,u[k+112|0]=0,i[k+16>>2]=93724,i[k+32>>2]=1701082227,i[n+260>>2]=k,i[n+256>>2]=k+16,i[n+72>>2]=0,i[n+76>>2]=0;break e}if((k|0)<=1768778097){if((k|0)<=1752589104){if((k|0)<=1718909295){if((k|0)==1701604967)break Y;if((k|0)==1701606260)break w;if((k|0)==1718773093)break Z0;break f}if((k|0)==1718909296)break w0;if((k|0)==1735553132)break v0;if((k|0)!=1751411826)break f;k=p(152),i[k+24>>2]=0,i[k+28>>2]=0,i[k+4>>2]=0,i[k+8>>2]=0,i[k+72>>2]=-1,i[k+76>>2]=-1,i[k+116>>2]=0,i[k+88>>2]=0,i[k+92>>2]=0,i[k+120>>2]=0,i[k+124>>2]=1885954932,i[k+128>>2]=0,i[k+132>>2]=0,i[k>>2]=89804,i[k+32>>2]=0,i[k+36>>2]=0,i[k+40>>2]=0,i[k+44>>2]=0,i[k+48>>2]=0,i[k+52>>2]=0,i[k+56>>2]=0,i[k+60>>2]=0,i[k- -64>>2]=0,i[k+80>>2]=-1,i[k+84>>2]=-1,i[k+96>>2]=0,i[k+100>>2]=0,i[k+104>>2]=0,i[k+108>>2]=0,g[k+112>>1]=0,i[k+16>>2]=87124,i[k+136>>2]=0,i[k+140>>2]=0,i[k+144>>2]=0,i[k+148>>2]=0,i[k+32>>2]=1751411826,i[n+76>>2]=k,i[n+72>>2]=k+16,t=i[n+72>>2],o=i[n+76>>2],i[n+72>>2]=0,i[n+76>>2]=0,k=i[n+260>>2],i[n+256>>2]=t,i[n+260>>2]=o;Q:{if(!k||(t=i[k+4>>2],i[k+4>>2]=t-1,t))break Q;W[i[i[k>>2]+8>>2]](k),y(k)}break e}if((k|0)<=1768517221)switch(k-1752589105|0){case 0:break e0;case 18:break r0;case 1:case 2:case 3:case 4:case 5:case 6:case 7:case 8:case 9:case 10:case 11:case 12:case 13:case 14:case 15:case 16:case 17:break f;default:break A}if((k|0)==1768517222)break o0;if((k|0)!=1768714083)break f;k=p(176),i[k+24>>2]=0,i[k+28>>2]=0,i[k+4>>2]=0,i[k+8>>2]=0,i[k+72>>2]=-1,i[k+76>>2]=-1,i[k+116>>2]=0,i[k+88>>2]=0,i[k+92>>2]=0,i[k+152>>2]=0,i[k+144>>2]=0,i[k>>2]=89884,i[k+32>>2]=0,i[k+36>>2]=0,i[k+40>>2]=0,i[k+44>>2]=0,i[k+48>>2]=0,i[k+52>>2]=0,i[k+56>>2]=0,i[k+60>>2]=0,i[k- -64>>2]=0,i[k+80>>2]=-1,i[k+84>>2]=-1,i[k+96>>2]=0,i[k+100>>2]=0,i[k+104>>2]=0,i[k+108>>2]=0,g[k+112>>1]=0,i[k+16>>2]=86384,u[k+133|0]=0,u[k+134|0]=0,u[k+135|0]=0,u[k+136|0]=0,u[k+137|0]=0,u[k+138|0]=0,u[k+139|0]=0,u[k+140|0]=0,i[k+128>>2]=0,i[k+132>>2]=0,i[k+120>>2]=0,i[k+124>>2]=0,i[k+32>>2]=1768714083,u[k+148|0]=0,i[n+76>>2]=k,i[n+72>>2]=k+16,t=i[n+72>>2],o=i[n+76>>2],i[n+72>>2]=0,i[n+76>>2]=0,k=i[n+260>>2],i[n+256>>2]=t,i[n+260>>2]=o;Q:{if(!k||(t=i[k+4>>2],i[k+4>>2]=t-1,t))break Q;W[i[i[k>>2]+8>>2]](k),y(k)}break e}if((k|0)<=1769107315){if((k|0)<=1768975712){if((k|0)==1768778098)break f0;if((k|0)==1768842853)break u0;if((k|0)!=1768973167)break f;k=p(120),i[k+32>>2]=0,i[k+36>>2]=0,i[k+24>>2]=0,i[k+28>>2]=0,i[k+4>>2]=0,i[k+8>>2]=0,i[k+72>>2]=-1,i[k+76>>2]=-1,i[k+88>>2]=0,i[k+92>>2]=0,i[k>>2]=90044,i[k+40>>2]=0,i[k+44>>2]=0,i[k+48>>2]=0,i[k+52>>2]=0,i[k+56>>2]=0,i[k+60>>2]=0,i[k- -64>>2]=0,i[k+80>>2]=-1,i[k+84>>2]=-1,i[k+96>>2]=0,i[k+100>>2]=0,i[k+104>>2]=0,i[k+108>>2]=0,u[k+112|0]=0,i[k+16>>2]=87524,i[k+32>>2]=1768973167,i[n+260>>2]=k,i[n+256>>2]=k+16,i[n+72>>2]=0,i[n+76>>2]=0;break e}if((k|0)==1768975713)break t0;if((k|0)==1768977008)break m0;if((k|0)!=1769104742)break f;k=p(136),i[k+32>>2]=0,i[k+36>>2]=0,i[k+24>>2]=0,i[k+28>>2]=0,i[k+4>>2]=0,i[k+8>>2]=0,i[k+72>>2]=-1,i[k+76>>2]=-1,i[k+116>>2]=0,i[k+88>>2]=0,i[k+92>>2]=0,i[k+128>>2]=0,i[k+120>>2]=0,i[k+124>>2]=0,i[k>>2]=90324,i[k+40>>2]=0,i[k+44>>2]=0,i[k+48>>2]=0,i[k+52>>2]=0,i[k+56>>2]=0,i[k+60>>2]=0,i[k- -64>>2]=0,i[k+80>>2]=-1,i[k+84>>2]=-1,i[k+96>>2]=0,i[k+100>>2]=0,i[k+104>>2]=0,i[k+108>>2]=0,g[k+112>>1]=0,i[k+16>>2]=88072,i[k+32>>2]=1769104742,i[n+76>>2]=k,i[n+72>>2]=k+16,t=i[n+72>>2],o=i[n+76>>2],i[n+72>>2]=0,i[n+76>>2]=0,k=i[n+260>>2],i[n+256>>2]=t,i[n+260>>2]=o;Q:{if(!k||(t=i[k+4>>2],i[k+4>>2]=t-1,t))break Q;W[i[i[k>>2]+8>>2]](k),y(k)}break e}if((k|0)<=1781689159){if((k|0)==1769107316)break A0;if((k|0)==1769173093)break n0;if((k|0)!=1769234793)break f;k=p(144),i[k+32>>2]=0,i[k+36>>2]=0,i[k+24>>2]=0,i[k+28>>2]=0,i[k+4>>2]=0,i[k+8>>2]=0,i[k+72>>2]=-1,i[k+76>>2]=-1,i[k+116>>2]=0,i[k+88>>2]=0,i[k+92>>2]=0,i[k>>2]=92204,i[k+40>>2]=0,i[k+44>>2]=0,i[k+48>>2]=0,i[k+52>>2]=0,i[k+56>>2]=0,i[k+60>>2]=0,i[k- -64>>2]=0,i[k+80>>2]=-1,i[k+84>>2]=-1,i[k+96>>2]=0,i[k+100>>2]=0,i[k+104>>2]=0,i[k+108>>2]=0,g[k+112>>1]=0,i[k+16>>2]=89444,i[k+32>>2]=1769234793,i[k+128>>2]=0,i[k+132>>2]=0,u[k+120|0]=1,u[k+135|0]=0,u[k+136|0]=0,u[k+137|0]=0,u[k+138|0]=0,i[n+76>>2]=k,i[n+72>>2]=k+16,t=i[n+72>>2],o=i[n+76>>2],i[n+72>>2]=0,i[n+76>>2]=0,k=i[n+260>>2],i[n+256>>2]=t,i[n+260>>2]=o;Q:{if(!k||(t=i[k+4>>2],i[k+4>>2]=t-1,t))break Q;W[i[i[k>>2]+8>>2]](k),y(k)}break e}switch(k-1781689160|0){case 0:break $;case 4:break M;default:break f}}if((k|0)<=1936158819){if((k|0)<=1836476515){if((k|0)<=1835297120){if((k|0)<=1835295091){if((k|0)==1781689193)break D;if((k|0)==1785751363)break z;if((k|0)!=1819501932)break f;k=p(120),i[k+32>>2]=0,i[k+36>>2]=0,i[k+24>>2]=0,i[k+28>>2]=0,i[k+4>>2]=0,i[k+8>>2]=0,i[k+72>>2]=-1,i[k+76>>2]=-1,i[k+88>>2]=0,i[k+92>>2]=0,g[k+114>>1]=0,i[k>>2]=91284,i[k+40>>2]=0,i[k+44>>2]=0,i[k+48>>2]=0,i[k+52>>2]=0,i[k+56>>2]=0,i[k+60>>2]=0,i[k- -64>>2]=0,i[k+80>>2]=-1,i[k+84>>2]=-1,i[k+96>>2]=0,i[k+100>>2]=0,i[k+104>>2]=0,i[k+108>>2]=0,u[k+112|0]=0,i[k+16>>2]=88952,i[k+32>>2]=1819501932,i[n+76>>2]=k,i[n+72>>2]=k+16,t=i[n+72>>2],o=i[n+76>>2],i[n+72>>2]=0,i[n+76>>2]=0,k=i[n+260>>2],i[n+256>>2]=t,i[n+260>>2]=o;Q:{if(!k||(t=i[k+4>>2],i[k+4>>2]=t-1,t))break Q;W[i[i[k>>2]+8>>2]](k),y(k)}break e}if((k|0)==1835295092)break I;if((k|0)==1835295606)break S;if((k|0)!=1835296868)break f;k=p(160),i[k+24>>2]=0,i[k+28>>2]=0,i[k+4>>2]=0,i[k+8>>2]=0,i[k+72>>2]=-1,i[k+76>>2]=-1,i[k+116>>2]=0,i[k+88>>2]=0,i[k+92>>2]=0,i[k+144>>2]=0,i[k+148>>2]=0,i[k+16>>2]=104540,i[k+120>>2]=0,i[k+124>>2]=0,i[k>>2]=93004,i[k+32>>2]=0,i[k+36>>2]=0,i[k+40>>2]=0,i[k+44>>2]=0,i[k+48>>2]=0,i[k+52>>2]=0,i[k+56>>2]=0,i[k+60>>2]=0,i[k- -64>>2]=0,i[k+80>>2]=-1,i[k+84>>2]=-1,i[k+96>>2]=0,i[k+100>>2]=0,i[k+104>>2]=0,i[k+108>>2]=0,g[k+112>>1]=0,i[k+128>>2]=0,i[k+132>>2]=0,i[k+136>>2]=0,i[k+32>>2]=1835296868,u[k+152|0]=117,u[k+153|0]=110,u[k+154|0]=107,u[k+155|0]=0,i[n+76>>2]=k,i[n+72>>2]=k+16,t=i[n+72>>2],o=i[n+76>>2],i[n+72>>2]=0,i[n+76>>2]=0,k=i[n+260>>2],i[n+256>>2]=t,i[n+260>>2]=o;Q:{if(!k||(t=i[k+4>>2],i[k+4>>2]=t-1,t))break Q;W[i[i[k>>2]+8>>2]](k),y(k)}break e}if((k|0)<=1835692134){if((k|0)==1835297121)break X;if((k|0)==1835365473)break s0;if((k|0)!=1835626086)break f;k=p(120),i[k+32>>2]=0,i[k+36>>2]=0,i[k+24>>2]=0,i[k+28>>2]=0,i[k+4>>2]=0,i[k+8>>2]=0,i[k+72>>2]=-1,i[k+76>>2]=-1,i[k+88>>2]=0,i[k+92>>2]=0,i[k>>2]=93044,i[k+40>>2]=0,i[k+44>>2]=0,i[k+48>>2]=0,i[k+52>>2]=0,i[k+56>>2]=0,i[k+60>>2]=0,i[k- -64>>2]=0,i[k+80>>2]=-1,i[k+84>>2]=-1,i[k+96>>2]=0,i[k+100>>2]=0,i[k+104>>2]=0,i[k+108>>2]=0,u[k+112|0]=0,i[k+16>>2]=93084,i[k+32>>2]=1835626086,i[n+260>>2]=k,i[n+256>>2]=k+16,i[n+72>>2]=0,i[n+76>>2]=0;break e}if((k|0)==1835692135)break H;if((k|0)==1836019574)break C;if((k|0)!=1836280643)break f;k=p(128),i[k+32>>2]=0,i[k+36>>2]=0,i[k+24>>2]=0,i[k+28>>2]=0,i[k+4>>2]=0,i[k+8>>2]=0,i[k+72>>2]=-1,i[k+76>>2]=-1,i[k+116>>2]=0,i[k+88>>2]=0,i[k+92>>2]=0,u[k+120|0]=0,i[k+16>>2]=100312,i[k>>2]=92164,i[k+40>>2]=0,i[k+44>>2]=0,i[k+48>>2]=0,i[k+52>>2]=0,i[k+56>>2]=0,i[k+60>>2]=0,i[k- -64>>2]=0,i[k+80>>2]=-1,i[k+84>>2]=-1,i[k+96>>2]=0,i[k+100>>2]=0,i[k+104>>2]=0,i[k+108>>2]=0,g[k+112>>1]=0,i[k+32>>2]=1836280643,i[n+76>>2]=k,i[n+72>>2]=k+16,t=i[n+72>>2],o=i[n+76>>2],i[n+72>>2]=0,i[n+76>>2]=0,k=i[n+260>>2],i[n+256>>2]=t,i[n+260>>2]=o;Q:{if(!k||(t=i[k+4>>2],i[k+4>>2]=t-1,t))break Q;W[i[i[k>>2]+8>>2]](k),y(k)}break e}if((k|0)<=1887006051){if((k|0)<=1885564017){if((k|0)==1836476516)break V;if((k|0)==1852663908)break k;if((k|0)!=1885434736)break f;k=p(128),i[k+32>>2]=0,i[k+36>>2]=0,i[k+24>>2]=0,i[k+28>>2]=0,i[k+4>>2]=0,i[k+8>>2]=0,i[k+72>>2]=-1,i[k+76>>2]=-1,i[k+88>>2]=0,i[k+92>>2]=0,i[k+116>>2]=1,i[k+120>>2]=1,i[k>>2]=91244,i[k+40>>2]=0,i[k+44>>2]=0,i[k+48>>2]=0,i[k+52>>2]=0,i[k+56>>2]=0,i[k+60>>2]=0,i[k- -64>>2]=0,i[k+80>>2]=-1,i[k+84>>2]=-1,i[k+96>>2]=0,i[k+100>>2]=0,i[k+104>>2]=0,i[k+108>>2]=0,u[k+112|0]=0,i[k+16>>2]=88872,i[k+32>>2]=1885434736,i[n+76>>2]=k,i[n+72>>2]=k+16,t=i[n+72>>2],o=i[n+76>>2],i[n+72>>2]=0,i[n+76>>2]=0,k=i[n+260>>2],i[n+256>>2]=t,i[n+260>>2]=o;Q:{if(!k||(t=i[k+4>>2],i[k+4>>2]=t-1,t))break Q;W[i[i[k>>2]+8>>2]](k),y(k)}break e}if((k|0)==1885564018)break J;if((k|0)==1885959277)break l0;if((k|0)!=1885960297)break f;k=p(136),i[k+32>>2]=0,i[k+36>>2]=0,i[k+24>>2]=0,i[k+28>>2]=0,i[k+4>>2]=0,i[k+8>>2]=0,i[k+72>>2]=-1,i[k+76>>2]=-1,i[k+116>>2]=0,i[k+88>>2]=0,i[k+92>>2]=0,i[k+128>>2]=0,i[k+120>>2]=0,i[k+124>>2]=0,i[k>>2]=91204,i[k+40>>2]=0,i[k+44>>2]=0,i[k+48>>2]=0,i[k+52>>2]=0,i[k+56>>2]=0,i[k+60>>2]=0,i[k- -64>>2]=0,i[k+80>>2]=-1,i[k+84>>2]=-1,i[k+96>>2]=0,i[k+100>>2]=0,i[k+104>>2]=0,i[k+108>>2]=0,g[k+112>>1]=0,i[k+16>>2]=88792,i[k+32>>2]=1885960297,i[n+76>>2]=k,i[n+72>>2]=k+16,t=i[n+72>>2],o=i[n+76>>2],i[n+72>>2]=0,i[n+76>>2]=0,k=i[n+260>>2],i[n+256>>2]=t,i[n+260>>2]=o;Q:{if(!k||(t=i[k+4>>2],i[k+4>>2]=t-1,t))break Q;W[i[i[k>>2]+8>>2]](k),y(k)}break e}if((k|0)<=1935828847)switch(k-1935763823|0){case 1:case 2:case 3:case 4:case 5:case 6:case 7:case 8:case 9:case 10:break f;case 0:break t;case 11:break u;default:break d}if((k|0)==1935828848)break s;if((k|0)!=1935963248)break f;k=p(136),i[k+32>>2]=0,i[k+36>>2]=0,i[k+24>>2]=0,i[k+28>>2]=0,i[k+4>>2]=0,i[k+8>>2]=0,i[k+72>>2]=-1,i[k+76>>2]=-1,i[k+116>>2]=0,i[k+88>>2]=0,i[k+92>>2]=0,i[k+128>>2]=0,i[k+120>>2]=0,i[k+124>>2]=0,i[k+16>>2]=106188,i[k>>2]=94204,i[k+40>>2]=0,i[k+44>>2]=0,i[k+48>>2]=0,i[k+52>>2]=0,i[k+56>>2]=0,i[k+60>>2]=0,i[k- -64>>2]=0,i[k+80>>2]=-1,i[k+84>>2]=-1,i[k+96>>2]=0,i[k+100>>2]=0,i[k+104>>2]=0,i[k+108>>2]=0,g[k+112>>1]=0,i[k+32>>2]=1935963248,i[n+76>>2]=k,i[n+72>>2]=k+16,t=i[n+72>>2],o=i[n+76>>2],i[n+72>>2]=0,i[n+76>>2]=0,k=i[n+260>>2],i[n+256>>2]=t,i[n+260>>2]=o;Q:{if(!k||(t=i[k+4>>2],i[k+4>>2]=t-1,t))break Q;W[i[i[k>>2]+8>>2]](k),y(k)}break e}if((k|0)>1953196131)break N;if((k|0)>1937011554)break a;if((k|0)>1937007211)break h0;if((k|0)==1936158820)break l;if((k|0)!=1936419184)break f}k=p(120),i[k+32>>2]=0,i[k+36>>2]=0,i[k+24>>2]=0,i[k+28>>2]=0,i[k+4>>2]=0,i[k+8>>2]=0,i[k+72>>2]=-1,i[k+76>>2]=-1,i[k+88>>2]=0,i[k+92>>2]=0,i[k>>2]=89764,i[k+40>>2]=0,i[k+44>>2]=0,i[k+48>>2]=0,i[k+52>>2]=0,i[k+56>>2]=0,i[k+60>>2]=0,i[k- -64>>2]=0,i[k+80>>2]=-1,i[k+84>>2]=-1,i[k+96>>2]=0,i[k+100>>2]=0,i[k+104>>2]=0,i[k+108>>2]=0,u[k+112|0]=0,i[k+16>>2]=86964,i[k+32>>2]=1718773093,i[n+260>>2]=k,i[n+256>>2]=k+16,i[n+72>>2]=0,i[n+76>>2]=0;break e}if((k|0)==1937007212)break m;if((k|0)==1937007471)break B;if((k|0)!=1937007986)break f;k=p(136),i[k+32>>2]=0,i[k+36>>2]=0,i[k+24>>2]=0,i[k+28>>2]=0,i[k+4>>2]=0,i[k+8>>2]=0,i[k+72>>2]=-1,i[k+76>>2]=-1,i[k+88>>2]=0,i[k+92>>2]=0,i[k+116>>2]=0,i[k+120>>2]=0,i[k>>2]=91004,i[k+40>>2]=0,i[k+44>>2]=0,i[k+48>>2]=0,i[k+52>>2]=0,i[k+56>>2]=0,i[k+60>>2]=0,i[k- -64>>2]=0,i[k+80>>2]=-1,i[k+84>>2]=-1,i[k+96>>2]=0,i[k+100>>2]=0,i[k+104>>2]=0,i[k+108>>2]=0,g[k+112>>1]=0,i[k+124>>2]=0,i[k+128>>2]=0,i[k+132>>2]=0,i[k+16>>2]=88392,i[k+32>>2]=1937007986,i[n+76>>2]=k,i[n+72>>2]=k+16,t=i[n+72>>2],o=i[n+76>>2],i[n+72>>2]=0,i[n+76>>2]=0,k=i[n+260>>2],i[n+256>>2]=t,i[n+260>>2]=o;h0:{if(!k||(t=i[k+4>>2],i[k+4>>2]=t-1,t))break h0;W[i[i[k>>2]+8>>2]](k),y(k)}break e}a:switch(k-1937011555|0){case 2:case 3:case 4:case 5:case 6:case 7:case 8:case 9:case 10:case 11:case 12:case 13:case 14:case 15:case 17:case 18:case 19:case 20:case 21:case 22:break f;case 0:break v;case 1:break G;case 16:break _;case 23:break h;default:break a}if((k|0)==1937011827)break Z;if((k|0)!=1952541027)break f;k=p(152),i[k+32>>2]=0,i[k+36>>2]=0,i[k+24>>2]=0,i[k+28>>2]=0,i[k+4>>2]=0,i[k+8>>2]=0,i[k+72>>2]=-1,i[k+76>>2]=-1,i[k+116>>2]=0,i[k+88>>2]=0,i[k+92>>2]=0,i[k>>2]=92244,i[k+40>>2]=0,i[k+44>>2]=0,i[k+48>>2]=0,i[k+52>>2]=0,i[k+56>>2]=0,i[k+60>>2]=0,i[k- -64>>2]=0,i[k+80>>2]=-1,i[k+84>>2]=-1,i[k+96>>2]=0,i[k+100>>2]=0,i[k+104>>2]=0,i[k+108>>2]=0,g[k+112>>1]=0,i[k+16>>2]=89376,i[k+32>>2]=1952541027,u[k+144|0]=0,i[k+136>>2]=0,i[k+140>>2]=2147483647,i[k+128>>2]=-1,i[k+132>>2]=-1,u[k+120|0]=1,i[n+76>>2]=k,i[n+72>>2]=k+16,t=i[n+72>>2],o=i[n+76>>2],i[n+72>>2]=0,i[n+76>>2]=0,k=i[n+260>>2],i[n+256>>2]=t,i[n+260>>2]=o;a:{if(!k||(t=i[k+4>>2],i[k+4>>2]=t-1,t))break a;W[i[i[k>>2]+8>>2]](k),y(k)}break e}if((k|0)<=1970433055){if((k|0)<=1969513842){if((k|0)==1953196132)break W;if((k|0)==1953653099)break F;if((k|0)!=1953654118)break f;k=p(128),i[k+32>>2]=0,i[k+36>>2]=0,i[k+24>>2]=0,i[k+28>>2]=0,i[k+4>>2]=0,i[k+8>>2]=0,i[k+72>>2]=-1,i[k+76>>2]=-1,i[k+88>>2]=0,i[k+92>>2]=0,i[k+124>>2]=0,i[k+116>>2]=0,i[k+120>>2]=0,i[k+16>>2]=106268,i[k>>2]=94164,i[k+40>>2]=0,i[k+44>>2]=0,i[k+48>>2]=0,i[k+52>>2]=0,i[k+56>>2]=0,i[k+60>>2]=0,i[k- -64>>2]=0,i[k+80>>2]=-1,i[k+84>>2]=-1,i[k+96>>2]=0,i[k+100>>2]=0,i[k+104>>2]=0,i[k+108>>2]=0,u[k+112|0]=0,i[k+32>>2]=1953654118,i[n+76>>2]=k,i[n+72>>2]=k+16,t=i[n+72>>2],o=i[n+76>>2],i[n+72>>2]=0,i[n+76>>2]=0,k=i[n+260>>2],i[n+256>>2]=t,i[n+260>>2]=o;N:{if(!k||(t=i[k+4>>2],i[k+4>>2]=t-1,t))break N;W[i[i[k>>2]+8>>2]](k),y(k)}break e}if((k|0)==1969513843)break x;if((k|0)==1970432288)break n;if((k|0)!=1970432365)break f;k=p(120),i[k+32>>2]=0,i[k+36>>2]=0,i[k+24>>2]=0,i[k+28>>2]=0,i[k+4>>2]=0,i[k+8>>2]=0,i[k+72>>2]=-1,i[k+76>>2]=-1,i[k+88>>2]=0,i[k+92>>2]=0,i[k+16>>2]=105580,i[k>>2]=94044,i[k+40>>2]=0,i[k+44>>2]=0,i[k+48>>2]=0,i[k+52>>2]=0,i[k+56>>2]=0,i[k+60>>2]=0,i[k- -64>>2]=0,i[k+80>>2]=-1,i[k+84>>2]=-1,i[k+96>>2]=0,i[k+100>>2]=0,i[k+104>>2]=0,i[k+108>>2]=0,u[k+112|0]=0,i[k+32>>2]=1970432365,i[n+260>>2]=k,i[n+256>>2]=k+16,i[n+72>>2]=0,i[n+76>>2]=0;break e}if((k|0)<=1987470128){if((k|0)==1970433056)break K;if((k|0)==1970628964)break g;if((k|0)!=1986881636)break f;k=p(128),i[k+32>>2]=0,i[k+36>>2]=0,i[k+24>>2]=0,i[k+28>>2]=0,i[k+4>>2]=0,i[k+8>>2]=0,i[k+72>>2]=-1,i[k+76>>2]=-1,i[k+88>>2]=0,i[k+92>>2]=0,i[k+120>>2]=0,i[k+124>>2]=0,i[k+16>>2]=104620,i[k+116>>2]=1,i[k>>2]=93164,i[k+40>>2]=0,i[k+44>>2]=0,i[k+48>>2]=0,i[k+52>>2]=0,i[k+56>>2]=0,i[k+60>>2]=0,i[k- -64>>2]=0,i[k+80>>2]=-1,i[k+84>>2]=-1,i[k+96>>2]=0,i[k+100>>2]=0,i[k+104>>2]=0,i[k+108>>2]=0,g[k+112>>1]=0,i[k+32>>2]=1986881636,i[n+76>>2]=k,i[n+72>>2]=k+16,t=i[n+72>>2],o=i[n+76>>2],i[n+72>>2]=0,i[n+76>>2]=0,k=i[n+260>>2],i[n+256>>2]=t,i[n+260>>2]=o;N:{if(!k||(t=i[k+4>>2],i[k+4>>2]=t-1,t))break N;W[i[i[k>>2]+8>>2]](k),y(k)}break e}if(t=k-1987470129|0,!t)break c;if((t|0)==18)break b;break f}k=p(136),i[k+32>>2]=0,i[k+36>>2]=0,i[k+24>>2]=0,i[k+28>>2]=0,i[k+4>>2]=0,i[k+8>>2]=0,i[k+72>>2]=-1,i[k+76>>2]=-1,i[k+88>>2]=0,i[k+92>>2]=0,i[k+116>>2]=0,i[k+120>>2]=0,i[k>>2]=89724,i[k+40>>2]=0,i[k+44>>2]=0,i[k+48>>2]=0,i[k+52>>2]=0,i[k+56>>2]=0,i[k+60>>2]=0,i[k- -64>>2]=0,i[k+80>>2]=-1,i[k+84>>2]=-1,i[k+96>>2]=0,i[k+100>>2]=0,i[k+104>>2]=0,i[k+108>>2]=0,u[k+112|0]=0,i[k+16>>2]=86884,i[k+124>>2]=0,i[k+128>>2]=0,i[k+132>>2]=0,i[k+32>>2]=1718909296,i[n+76>>2]=k,i[n+72>>2]=k+16,t=i[n+72>>2],o=i[n+76>>2],i[n+72>>2]=0,i[n+76>>2]=0,k=i[n+260>>2],i[n+256>>2]=t,i[n+260>>2]=o;w0:{if(!k||(t=i[k+4>>2],i[k+4>>2]=t-1,t))break w0;W[i[i[k>>2]+8>>2]](k),y(k)}break e}k=p(120),i[k+32>>2]=0,i[k+36>>2]=0,i[k+24>>2]=0,i[k+28>>2]=0,i[k+4>>2]=0,i[k+8>>2]=0,i[k+72>>2]=-1,i[k+76>>2]=-1,i[k+116>>2]=0,i[k+88>>2]=0,i[k+92>>2]=0,i[k>>2]=89684,i[k+40>>2]=0,i[k+44>>2]=0,i[k+48>>2]=0,i[k+52>>2]=0,i[k+56>>2]=0,i[k+60>>2]=0,i[k- -64>>2]=0,i[k+80>>2]=-1,i[k+84>>2]=-1,i[k+96>>2]=0,i[k+100>>2]=0,i[k+104>>2]=0,i[k+108>>2]=0,g[k+112>>1]=0,i[k+16>>2]=87044,i[k+32>>2]=1835365473,i[n+76>>2]=k,i[n+72>>2]=k+16,t=i[n+72>>2],o=i[n+76>>2],i[n+72>>2]=0,i[n+76>>2]=0,k=i[n+260>>2],i[n+256>>2]=t,i[n+260>>2]=o;s0:{if(!k||(t=i[k+4>>2],i[k+4>>2]=t-1,t))break s0;W[i[i[k>>2]+8>>2]](k),y(k)}break e}k=p(128),i[k+32>>2]=0,i[k+36>>2]=0,i[k+24>>2]=0,i[k+28>>2]=0,i[k+4>>2]=0,i[k+8>>2]=0,i[k+72>>2]=-1,i[k+76>>2]=-1,i[k+88>>2]=0,i[k+92>>2]=0,i[k+116>>2]=0,i[k+120>>2]=0,i[k>>2]=89844,i[k+40>>2]=0,i[k+44>>2]=0,i[k+48>>2]=0,i[k+52>>2]=0,i[k+56>>2]=0,i[k+60>>2]=0,i[k- -64>>2]=0,i[k+80>>2]=-1,i[k+84>>2]=-1,i[k+96>>2]=0,i[k+100>>2]=0,i[k+104>>2]=0,i[k+108>>2]=0,g[k+112>>1]=0,i[k+16>>2]=87204,i[k+32>>2]=1885959277,i[n+76>>2]=k,i[n+72>>2]=k+16,t=i[n+72>>2],o=i[n+76>>2],i[n+72>>2]=0,i[n+76>>2]=0,k=i[n+260>>2],i[n+256>>2]=t,i[n+260>>2]=o;l0:{if(!k||(t=i[k+4>>2],i[k+4>>2]=t-1,t))break l0;W[i[i[k>>2]+8>>2]](k),y(k)}break e}k=p(120),i[k+32>>2]=0,i[k+36>>2]=0,i[k+24>>2]=0,i[k+28>>2]=0,i[k+4>>2]=0,i[k+8>>2]=0,i[k+72>>2]=-1,i[k+76>>2]=-1,i[k+116>>2]=0,i[k+88>>2]=0,i[k+92>>2]=0,i[k>>2]=89924,i[k+40>>2]=0,i[k+44>>2]=0,i[k+48>>2]=0,i[k+52>>2]=0,i[k+56>>2]=0,i[k+60>>2]=0,i[k- -64>>2]=0,i[k+80>>2]=-1,i[k+84>>2]=-1,i[k+96>>2]=0,i[k+100>>2]=0,i[k+104>>2]=0,i[k+108>>2]=0,g[k+112>>1]=0,i[k+16>>2]=87364,i[k+32>>2]=1768517222,i[n+76>>2]=k,i[n+72>>2]=k+16,t=i[n+72>>2],o=i[n+76>>2],i[n+72>>2]=0,i[n+76>>2]=0,k=i[n+260>>2],i[n+256>>2]=t,i[n+260>>2]=o;o0:{if(!k||(t=i[k+4>>2],i[k+4>>2]=t-1,t))break o0;W[i[i[k>>2]+8>>2]](k),y(k)}break e}k=p(184),i[k+24>>2]=0,i[k+28>>2]=0,i[k+4>>2]=0,i[k+8>>2]=0,i[k+72>>2]=-1,i[k+76>>2]=-1,i[k+88>>2]=0,i[k+92>>2]=0,g[k+124>>1]=0,i[k+116>>2]=0,i[k+120>>2]=0,i[k+128>>2]=0,i[k+132>>2]=0,i[k>>2]=89964,i[k+32>>2]=0,i[k+36>>2]=0,i[k+40>>2]=0,i[k+44>>2]=0,i[k+48>>2]=0,i[k+52>>2]=0,i[k+56>>2]=0,i[k+60>>2]=0,i[k- -64>>2]=0,i[k+80>>2]=-1,i[k+84>>2]=-1,i[k+96>>2]=0,i[k+100>>2]=0,i[k+104>>2]=0,i[k+108>>2]=0,g[k+112>>1]=0,i[k+16>>2]=87284,u[k+173|0]=0,u[k+174|0]=0,u[k+175|0]=0,u[k+176|0]=0,u[k+177|0]=0,u[k+178|0]=0,u[k+179|0]=0,u[k+180|0]=0,i[k+168>>2]=0,i[k+172>>2]=0,i[k+160>>2]=0,i[k+164>>2]=0,i[k+152>>2]=0,i[k+156>>2]=0,i[k+144>>2]=0,i[k+148>>2]=0,i[k+136>>2]=0,i[k+140>>2]=0,i[k+32>>2]=1768842853,i[n+76>>2]=k,i[n+72>>2]=k+16,t=i[n+72>>2],o=i[n+76>>2],i[n+72>>2]=0,i[n+76>>2]=0,k=i[n+260>>2],i[n+256>>2]=t,i[n+260>>2]=o;u0:{if(!k||(t=i[k+4>>2],i[k+4>>2]=t-1,t))break u0;W[i[i[k>>2]+8>>2]](k),y(k)}break e}k=p(120),i[k+32>>2]=0,i[k+36>>2]=0,i[k+24>>2]=0,i[k+28>>2]=0,i[k+4>>2]=0,i[k+8>>2]=0,i[k+72>>2]=-1,i[k+76>>2]=-1,i[k+88>>2]=0,i[k+92>>2]=0,i[k>>2]=90004,i[k+40>>2]=0,i[k+44>>2]=0,i[k+48>>2]=0,i[k+52>>2]=0,i[k+56>>2]=0,i[k+60>>2]=0,i[k- -64>>2]=0,i[k+80>>2]=-1,i[k+84>>2]=-1,i[k+96>>2]=0,i[k+100>>2]=0,i[k+104>>2]=0,i[k+108>>2]=0,u[k+112|0]=0,i[k+16>>2]=87444,i[k+32>>2]=1768977008,i[n+260>>2]=k,i[n+256>>2]=k+16,i[n+72>>2]=0,i[n+76>>2]=0;break e}k=p(136),i[k+32>>2]=0,i[k+36>>2]=0,i[k+24>>2]=0,i[k+28>>2]=0,i[k+4>>2]=0,i[k+8>>2]=0,i[k+72>>2]=-1,i[k+76>>2]=-1,i[k+116>>2]=0,i[k+88>>2]=0,i[k+92>>2]=0,i[k+128>>2]=0,i[k+120>>2]=0,i[k+124>>2]=0,i[k>>2]=90084,i[k+40>>2]=0,i[k+44>>2]=0,i[k+48>>2]=0,i[k+52>>2]=0,i[k+56>>2]=0,i[k+60>>2]=0,i[k- -64>>2]=0,i[k+80>>2]=-1,i[k+84>>2]=-1,i[k+96>>2]=0,i[k+100>>2]=0,i[k+104>>2]=0,i[k+108>>2]=0,g[k+112>>1]=0,i[k+16>>2]=87672,i[k+32>>2]=1768975713,i[n+76>>2]=k,i[n+72>>2]=k+16,t=i[n+72>>2],o=i[n+76>>2],i[n+72>>2]=0,i[n+76>>2]=0,k=i[n+260>>2],i[n+256>>2]=t,i[n+260>>2]=o;t0:{if(!k||(t=i[k+4>>2],i[k+4>>2]=t-1,t))break t0;W[i[i[k>>2]+8>>2]](k),y(k)}break e}qt(n+72|0),t=i[n+72>>2],o=i[n+76>>2],i[n+72>>2]=0,i[n+76>>2]=0,k=i[n+260>>2],i[n+256>>2]=t,i[n+260>>2]=o;n0:{if(!k||(t=i[k+4>>2],i[k+4>>2]=t-1,t))break n0;W[i[i[k>>2]+8>>2]](k),y(k)}break e}k=p(144),i[k+24>>2]=0,i[k+28>>2]=0,i[k+4>>2]=0,i[k+8>>2]=0,i[k+72>>2]=-1,i[k+76>>2]=-1,i[k+116>>2]=0,i[k+88>>2]=0,i[k+92>>2]=0,i[k+120>>2]=0,i[k+124>>2]=0,i[k>>2]=90164,i[k+32>>2]=0,i[k+36>>2]=0,i[k+40>>2]=0,i[k+44>>2]=0,i[k+48>>2]=0,i[k+52>>2]=0,i[k+56>>2]=0,i[k+60>>2]=0,i[k- -64>>2]=0,i[k+80>>2]=-1,i[k+84>>2]=-1,i[k+96>>2]=0,i[k+100>>2]=0,i[k+104>>2]=0,i[k+108>>2]=0,g[k+112>>1]=0,i[k+16>>2]=87752,i[k+128>>2]=0,i[k+132>>2]=0,i[k+136>>2]=0,i[k+140>>2]=0,i[k+32>>2]=1635088451,i[n+76>>2]=k,i[n+72>>2]=k+16,t=i[n+72>>2],o=i[n+76>>2],i[n+72>>2]=0,i[n+76>>2]=0,k=i[n+260>>2],i[n+256>>2]=t,i[n+260>>2]=o;k0:{if(!k||(t=i[k+4>>2],i[k+4>>2]=t-1,t))break k0;W[i[i[k>>2]+8>>2]](k),y(k)}break e}k=p(120),i[k+32>>2]=0,i[k+36>>2]=0,i[k+24>>2]=0,i[k+28>>2]=0,i[k+4>>2]=0,i[k+8>>2]=0,i[k+72>>2]=-1,i[k+76>>2]=-1,i[k+88>>2]=0,i[k+92>>2]=0,i[k+116>>2]=0,i[k>>2]=90204,i[k+40>>2]=0,i[k+44>>2]=0,i[k+48>>2]=0,i[k+52>>2]=0,i[k+56>>2]=0,i[k+60>>2]=0,i[k- -64>>2]=0,i[k+80>>2]=-1,i[k+84>>2]=-1,i[k+96>>2]=0,i[k+100>>2]=0,i[k+104>>2]=0,i[k+108>>2]=0,u[k+112|0]=0,i[k+16>>2]=87832,i[k+32>>2]=1769107316,i[n+76>>2]=k,i[n+72>>2]=k+16,t=i[n+72>>2],o=i[n+76>>2],i[n+72>>2]=0,i[n+76>>2]=0,k=i[n+260>>2],i[n+256>>2]=t,i[n+260>>2]=o;A0:{if(!k||(t=i[k+4>>2],i[k+4>>2]=t-1,t))break A0;W[i[i[k>>2]+8>>2]](k),y(k)}break e}k=p(120),i[k+32>>2]=0,i[k+36>>2]=0,i[k+24>>2]=0,i[k+28>>2]=0,i[k+4>>2]=0,i[k+8>>2]=0,i[k+72>>2]=-1,i[k+76>>2]=-1,i[k+88>>2]=0,i[k+92>>2]=0,i[k+116>>2]=0,i[k>>2]=90244,i[k+40>>2]=0,i[k+44>>2]=0,i[k+48>>2]=0,i[k+52>>2]=0,i[k+56>>2]=0,i[k+60>>2]=0,i[k- -64>>2]=0,i[k+80>>2]=-1,i[k+84>>2]=-1,i[k+96>>2]=0,i[k+100>>2]=0,i[k+104>>2]=0,i[k+108>>2]=0,u[k+112|0]=0,i[k+16>>2]=87912,i[k+32>>2]=1768778098,i[n+76>>2]=k,i[n+72>>2]=k+16,t=i[n+72>>2],o=i[n+76>>2],i[n+72>>2]=0,i[n+76>>2]=0,k=i[n+260>>2],i[n+256>>2]=t,i[n+260>>2]=o;f0:{if(!k||(t=i[k+4>>2],i[k+4>>2]=t-1,t))break f0;W[i[i[k>>2]+8>>2]](k),y(k)}break e}k=p(160),i[k+24>>2]=0,i[k+28>>2]=0,i[k+4>>2]=0,i[k+8>>2]=0,i[k+72>>2]=-1,i[k+76>>2]=-1,i[k+88>>2]=0,i[k+92>>2]=0,i[k+156>>2]=0,i[k+148>>2]=0,i[k+152>>2]=0,u[k+145|0]=4,i[k+124>>2]=0,i[k+128>>2]=0,i[k+16>>2]=97504,i[k>>2]=90364,i[k+32>>2]=0,i[k+36>>2]=0,i[k+40>>2]=0,i[k+44>>2]=0,i[k+48>>2]=0,i[k+52>>2]=0,i[k+56>>2]=0,i[k+60>>2]=0,i[k- -64>>2]=0,i[k+80>>2]=-1,i[k+84>>2]=-1,i[k+96>>2]=0,i[k+100>>2]=0,i[k+104>>2]=0,i[k+108>>2]=0,u[k+112|0]=0,i[k+32>>2]=1752589123,i[n+76>>2]=k,i[n+72>>2]=k+16,t=i[n+72>>2],o=i[n+76>>2],i[n+72>>2]=0,i[n+76>>2]=0,k=i[n+260>>2],i[n+256>>2]=t,i[n+260>>2]=o;r0:{if(!k||(t=i[k+4>>2],i[k+4>>2]=t-1,t))break r0;W[i[i[k>>2]+8>>2]](k),y(k)}break e}k=p(168),i[k+24>>2]=0,i[k+28>>2]=0,i[k+4>>2]=0,i[k+8>>2]=0,i[k+72>>2]=-1,i[k+76>>2]=-1,i[k+88>>2]=0,i[k+92>>2]=0,g[k+118>>1]=0,g[k+120>>1]=0,g[k+122>>1]=0,g[k+124>>1]=0,g[k+116>>1]=1,i[k>>2]=90404,i[k+32>>2]=0,i[k+36>>2]=0,i[k+40>>2]=0,i[k+44>>2]=0,i[k+48>>2]=0,i[k+52>>2]=0,i[k+56>>2]=0,i[k+60>>2]=0,i[k- -64>>2]=0,i[k+80>>2]=-1,i[k+84>>2]=-1,i[k+96>>2]=0,i[k+100>>2]=0,i[k+104>>2]=0,i[k+108>>2]=0,u[k+112|0]=0,g[k+126>>1]=0,g[k+128>>1]=0,g[k+130>>1]=0,g[k+132>>1]=0,g[k+134>>1]=0,g[k+144>>1]=1,i[k+136>>2]=4718592,i[k+140>>2]=4718592,i[k+148>>2]=0,i[k+152>>2]=0,i[k+156>>2]=0,i[k+160>>2]=-65512,i[k+16>>2]=90444,i[k+32>>2]=1752589105,i[n+76>>2]=k,i[n+72>>2]=k+16,t=i[n+72>>2],o=i[n+76>>2],i[n+72>>2]=0,i[n+76>>2]=0,k=i[n+260>>2],i[n+256>>2]=t,i[n+260>>2]=o;e0:{if(!k||(t=i[k+4>>2],i[k+4>>2]=t-1,t))break e0;W[i[i[k>>2]+8>>2]](k),y(k)}break e}k=p(168),i[k+24>>2]=0,i[k+28>>2]=0,i[k+4>>2]=0,i[k+8>>2]=0,i[k+72>>2]=-1,i[k+76>>2]=-1,i[k+88>>2]=0,i[k+92>>2]=0,g[k+118>>1]=0,g[k+120>>1]=0,g[k+122>>1]=0,g[k+124>>1]=0,g[k+116>>1]=1,i[k>>2]=90564,i[k+32>>2]=0,i[k+36>>2]=0,i[k+40>>2]=0,i[k+44>>2]=0,i[k+48>>2]=0,i[k+52>>2]=0,i[k+56>>2]=0,i[k+60>>2]=0,i[k- -64>>2]=0,i[k+80>>2]=-1,i[k+84>>2]=-1,i[k+96>>2]=0,i[k+100>>2]=0,i[k+104>>2]=0,i[k+108>>2]=0,u[k+112|0]=0,g[k+126>>1]=0,g[k+128>>1]=0,g[k+130>>1]=0,g[k+132>>1]=0,g[k+134>>1]=0,g[k+144>>1]=1,i[k+136>>2]=4718592,i[k+140>>2]=4718592,i[k+148>>2]=0,i[k+152>>2]=0,i[k+156>>2]=0,i[k+160>>2]=-65512,i[k+16>>2]=90604,i[k+32>>2]=1635135537,i[n+76>>2]=k,i[n+72>>2]=k+16,t=i[n+72>>2],o=i[n+76>>2],i[n+72>>2]=0,i[n+76>>2]=0,k=i[n+260>>2],i[n+256>>2]=t,i[n+260>>2]=o;i0:{if(!k||(t=i[k+4>>2],i[k+4>>2]=t-1,t))break i0;W[i[i[k>>2]+8>>2]](k),y(k)}break e}k=p(208),i[k+24>>2]=0,i[k+28>>2]=0,i[k+4>>2]=0,i[k+8>>2]=0,i[k+72>>2]=-1,i[k+76>>2]=-1,i[k+116>>2]=0,i[k+88>>2]=0,i[k+92>>2]=0,g[k+120>>1]=259,i[k+16>>2]=99816,i[k+136>>2]=0,i[k+140>>2]=0,i[k>>2]=90684,i[k+32>>2]=0,i[k+36>>2]=0,i[k+40>>2]=0,i[k+44>>2]=0,i[k+48>>2]=0,i[k+52>>2]=0,i[k+56>>2]=0,i[k+60>>2]=0,i[k- -64>>2]=0,i[k+80>>2]=-1,i[k+84>>2]=-1,i[k+96>>2]=0,i[k+100>>2]=0,i[k+104>>2]=0,i[k+108>>2]=0,g[k+112>>1]=0,i[k+144>>2]=0,i[k+148>>2]=0,i[k+152>>2]=0,i[k+156>>2]=0,i[k+160>>2]=0,i[k+164>>2]=0,i[k+168>>2]=0,i[k+172>>2]=0,i[k+176>>2]=0,i[k+180>>2]=0,i[k+200>>2]=0,i[k+192>>2]=0,i[k+196>>2]=0,i[k+32>>2]=1987470147,i[n+76>>2]=k,i[n+72>>2]=k+16,t=i[n+72>>2],o=i[n+76>>2],i[n+72>>2]=0,i[n+76>>2]=0,k=i[n+260>>2],i[n+256>>2]=t,i[n+260>>2]=o;b:{if(!k||(t=i[k+4>>2],i[k+4>>2]=t-1,t))break b;W[i[i[k>>2]+8>>2]](k),y(k)}break e}k=p(168),i[k+24>>2]=0,i[k+28>>2]=0,i[k+4>>2]=0,i[k+8>>2]=0,i[k+72>>2]=-1,i[k+76>>2]=-1,i[k+88>>2]=0,i[k+92>>2]=0,g[k+118>>1]=0,g[k+120>>1]=0,g[k+122>>1]=0,g[k+124>>1]=0,g[k+116>>1]=1,i[k>>2]=90724,i[k+32>>2]=0,i[k+36>>2]=0,i[k+40>>2]=0,i[k+44>>2]=0,i[k+48>>2]=0,i[k+52>>2]=0,i[k+56>>2]=0,i[k+60>>2]=0,i[k- -64>>2]=0,i[k+80>>2]=-1,i[k+84>>2]=-1,i[k+96>>2]=0,i[k+100>>2]=0,i[k+104>>2]=0,i[k+108>>2]=0,u[k+112|0]=0,g[k+126>>1]=0,g[k+128>>1]=0,g[k+130>>1]=0,g[k+132>>1]=0,g[k+134>>1]=0,g[k+144>>1]=1,i[k+136>>2]=4718592,i[k+140>>2]=4718592,i[k+148>>2]=0,i[k+152>>2]=0,i[k+156>>2]=0,i[k+160>>2]=-65512,i[k+16>>2]=90764,i[k+32>>2]=1987470129,i[n+76>>2]=k,i[n+72>>2]=k+16,t=i[n+72>>2],o=i[n+76>>2],i[n+72>>2]=0,i[n+76>>2]=0,k=i[n+260>>2],i[n+256>>2]=t,i[n+260>>2]=o;c:{if(!k||(t=i[k+4>>2],i[k+4>>2]=t-1,t))break c;W[i[i[k>>2]+8>>2]](k),y(k)}break e}k=p(120),i[k+32>>2]=0,i[k+36>>2]=0,i[k+24>>2]=0,i[k+28>>2]=0,i[k+4>>2]=0,i[k+8>>2]=0,i[k+72>>2]=-1,i[k+76>>2]=-1,i[k+88>>2]=0,i[k+92>>2]=0,i[k>>2]=90884,i[k+40>>2]=0,i[k+44>>2]=0,i[k+48>>2]=0,i[k+52>>2]=0,i[k+56>>2]=0,i[k+60>>2]=0,i[k- -64>>2]=0,i[k+80>>2]=-1,i[k+84>>2]=-1,i[k+96>>2]=0,i[k+100>>2]=0,i[k+104>>2]=0,i[k+108>>2]=0,u[k+112|0]=0,i[k+16>>2]=88232,i[k+32>>2]=1735553132,i[n+260>>2]=k,i[n+256>>2]=k+16,i[n+72>>2]=0,i[n+76>>2]=0;break e}if((k|0)!=1887006052)break f;k=p(152),i[k+24>>2]=0,i[k+28>>2]=0,i[k+4>>2]=0,i[k+8>>2]=0,i[k+72>>2]=-1,i[k+76>>2]=-1,i[k+88>>2]=0,i[k+92>>2]=0,i[k+116>>2]=0,i[k+120>>2]=0,i[k>>2]=90924,i[k+32>>2]=0,i[k+36>>2]=0,i[k+40>>2]=0,i[k+44>>2]=0,i[k+48>>2]=0,i[k+52>>2]=0,i[k+56>>2]=0,i[k+60>>2]=0,i[k- -64>>2]=0,i[k+80>>2]=-1,i[k+84>>2]=-1,i[k+96>>2]=0,i[k+100>>2]=0,i[k+104>>2]=0,i[k+108>>2]=0,g[k+112>>1]=0,i[k+124>>2]=0,i[k+128>>2]=0,i[k+132>>2]=0,i[k+16>>2]=88472,i[k+144>>2]=0,i[k+148>>2]=0,i[k+136>>2]=0,i[k+140>>2]=0,i[k+32>>2]=1887006052,i[n+76>>2]=k,i[n+72>>2]=k+16,t=i[n+72>>2],o=i[n+76>>2],i[n+72>>2]=0,i[n+76>>2]=0,k=i[n+260>>2],i[n+256>>2]=t,i[n+260>>2]=o;d:{if(!k||(t=i[k+4>>2],i[k+4>>2]=t-1,t))break d;W[i[i[k>>2]+8>>2]](k),y(k)}break e}k=p(120),i[k+32>>2]=0,i[k+36>>2]=0,i[k+24>>2]=0,i[k+28>>2]=0,i[k+4>>2]=0,i[k+8>>2]=0,i[k+72>>2]=-1,i[k+76>>2]=-1,i[k+88>>2]=0,i[k+92>>2]=0,i[k>>2]=91044,i[k+40>>2]=0,i[k+44>>2]=0,i[k+48>>2]=0,i[k+52>>2]=0,i[k+56>>2]=0,i[k+60>>2]=0,i[k- -64>>2]=0,i[k+80>>2]=-1,i[k+84>>2]=-1,i[k+96>>2]=0,i[k+100>>2]=0,i[k+104>>2]=0,i[k+108>>2]=0,u[k+112|0]=0,i[k+16>>2]=88552,i[k+32>>2]=1684631142,i[n+260>>2]=k,i[n+256>>2]=k+16,i[n+72>>2]=0,i[n+76>>2]=0;break e}k=p(120),i[k+32>>2]=0,i[k+36>>2]=0,i[k+24>>2]=0,i[k+28>>2]=0,i[k+4>>2]=0,i[k+8>>2]=0,i[k+72>>2]=-1,i[k+76>>2]=-1,i[k+116>>2]=0,i[k+88>>2]=0,i[k+92>>2]=0,i[k>>2]=91084,i[k+40>>2]=0,i[k+44>>2]=0,i[k+48>>2]=0,i[k+52>>2]=0,i[k+56>>2]=0,i[k+60>>2]=0,i[k- -64>>2]=0,i[k+80>>2]=-1,i[k+84>>2]=-1,i[k+96>>2]=0,i[k+100>>2]=0,i[k+104>>2]=0,i[k+108>>2]=0,g[k+112>>1]=0,i[k+16>>2]=88632,i[k+32>>2]=1685218662,i[n+76>>2]=k,i[n+72>>2]=k+16,t=i[n+72>>2],o=i[n+76>>2],i[n+72>>2]=0,i[n+76>>2]=0,k=i[n+260>>2],i[n+256>>2]=t,i[n+260>>2]=o;q:{if(!k||(t=i[k+4>>2],i[k+4>>2]=t-1,t))break q;W[i[i[k>>2]+8>>2]](k),y(k)}break e}k=p(136),i[k+32>>2]=0,i[k+36>>2]=0,i[k+24>>2]=0,i[k+28>>2]=0,i[k+4>>2]=0,i[k+8>>2]=0,i[k+72>>2]=-1,i[k+76>>2]=-1,i[k+88>>2]=0,i[k+92>>2]=0,i[k+120>>2]=0,i[k+124>>2]=0,i[k+116>>2]=1,i[k>>2]=91124,i[k+40>>2]=0,i[k+44>>2]=0,i[k+48>>2]=0,i[k+52>>2]=0,i[k+56>>2]=0,i[k+60>>2]=0,i[k- -64>>2]=0,i[k+80>>2]=-1,i[k+84>>2]=-1,i[k+96>>2]=0,i[k+100>>2]=0,i[k+104>>2]=0,i[k+108>>2]=0,g[k+112>>1]=0,i[k+16>>2]=88712,i[k+128>>2]=0,i[k+32>>2]=1970433056,i[n+76>>2]=k,i[n+72>>2]=k+16,t=i[n+72>>2],o=i[n+76>>2],i[n+72>>2]=0,i[n+76>>2]=0,k=i[n+260>>2],i[n+256>>2]=t,i[n+260>>2]=o;K:{if(!k||(t=i[k+4>>2],i[k+4>>2]=t-1,t))break K;W[i[i[k>>2]+8>>2]](k),y(k)}break e}k=p(128),i[k+32>>2]=0,i[k+36>>2]=0,i[k+24>>2]=0,i[k+28>>2]=0,i[k+4>>2]=0,i[k+8>>2]=0,i[k+72>>2]=-1,i[k+76>>2]=-1,i[k+88>>2]=0,i[k+92>>2]=0,i[k+116>>2]=0,i[k+120>>2]=0,i[k+16>>2]=95408,i[k>>2]=91164,i[k+40>>2]=0,i[k+44>>2]=0,i[k+48>>2]=0,i[k+52>>2]=0,i[k+56>>2]=0,i[k+60>>2]=0,i[k- -64>>2]=0,i[k+80>>2]=-1,i[k+84>>2]=-1,i[k+96>>2]=0,i[k+100>>2]=0,i[k+104>>2]=0,i[k+108>>2]=0,u[k+112|0]=0,i[k+32>>2]=1668246642,i[n+76>>2]=k,i[n+72>>2]=k+16,t=i[n+72>>2],o=i[n+76>>2],i[n+72>>2]=0,i[n+76>>2]=0,k=i[n+260>>2],i[n+256>>2]=t,i[n+260>>2]=o;L:{if(!k||(t=i[k+4>>2],i[k+4>>2]=t-1,t))break L;W[i[i[k>>2]+8>>2]](k),y(k)}break e}k=p(120),i[k+32>>2]=0,i[k+36>>2]=0,i[k+24>>2]=0,i[k+28>>2]=0,i[k+4>>2]=0,i[k+8>>2]=0,i[k+72>>2]=-1,i[k+76>>2]=-1,i[k+88>>2]=0,i[k+92>>2]=0,i[k+16>>2]=98160,i[k>>2]=91324,i[k+40>>2]=0,i[k+44>>2]=0,i[k+48>>2]=0,i[k+52>>2]=0,i[k+56>>2]=0,i[k+60>>2]=0,i[k- -64>>2]=0,i[k+80>>2]=-1,i[k+84>>2]=-1,i[k+96>>2]=0,i[k+100>>2]=0,i[k+104>>2]=0,i[k+108>>2]=0,g[k+112>>1]=0,i[k+32>>2]=1630629744,i[n+76>>2]=k,i[n+72>>2]=k+16,t=i[n+72>>2],o=i[n+76>>2],i[n+72>>2]=0,i[n+76>>2]=0,k=i[n+260>>2],i[n+256>>2]=t,i[n+260>>2]=o;P:{if(!k||(t=i[k+4>>2],i[k+4>>2]=t-1,t))break P;W[i[i[k>>2]+8>>2]](k),y(k)}break e}k=p(128),i[k+32>>2]=0,i[k+36>>2]=0,i[k+24>>2]=0,i[k+28>>2]=0,i[k+4>>2]=0,i[k+8>>2]=0,i[k+72>>2]=-1,i[k+76>>2]=-1,i[k+88>>2]=0,i[k+92>>2]=0,i[k+116>>2]=0,i[k+120>>2]=0,i[k+16>>2]=98240,i[k>>2]=91364,i[k+40>>2]=0,i[k+44>>2]=0,i[k+48>>2]=0,i[k+52>>2]=0,i[k+56>>2]=0,i[k+60>>2]=0,i[k- -64>>2]=0,i[k+80>>2]=-1,i[k+84>>2]=-1,i[k+96>>2]=0,i[k+100>>2]=0,i[k+104>>2]=0,i[k+108>>2]=0,u[k+112|0]=0,i[k+124>>2]=0,i[k+32>>2]=1630628984,i[n+76>>2]=k,i[n+72>>2]=k+16,t=i[n+72>>2],o=i[n+76>>2],i[n+72>>2]=0,i[n+76>>2]=0,k=i[n+260>>2],i[n+256>>2]=t,i[n+260>>2]=o;O:{if(!k||(t=i[k+4>>2],i[k+4>>2]=t-1,t))break O;W[i[i[k>>2]+8>>2]](k),y(k)}break e}k=p(120),i[k+32>>2]=0,i[k+36>>2]=0,i[k+24>>2]=0,i[k+28>>2]=0,i[k+4>>2]=0,i[k+8>>2]=0,i[k+72>>2]=-1,i[k+76>>2]=-1,i[k+88>>2]=0,i[k+92>>2]=0,g[k+114>>1]=0,g[k+116>>1]=0,i[k>>2]=91404,i[k+40>>2]=0,i[k+44>>2]=0,i[k+48>>2]=0,i[k+52>>2]=0,i[k+56>>2]=0,i[k+60>>2]=0,i[k- -64>>2]=0,i[k+80>>2]=-1,i[k+84>>2]=-1,i[k+96>>2]=0,i[k+100>>2]=0,i[k+104>>2]=0,i[k+108>>2]=0,u[k+112|0]=0,i[k+16>>2]=89032,i[k+32>>2]=1668050025,i[n+76>>2]=k,i[n+72>>2]=k+16,t=i[n+72>>2],o=i[n+76>>2],i[n+72>>2]=0,i[n+76>>2]=0,k=i[n+260>>2],i[n+256>>2]=t,i[n+260>>2]=o;j:{if(!k||(t=i[k+4>>2],i[k+4>>2]=t-1,t))break j;W[i[i[k>>2]+8>>2]](k),y(k)}break e}k=p(144),i[k+32>>2]=0,i[k+36>>2]=0,i[k+24>>2]=0,i[k+28>>2]=0,i[k+4>>2]=0,i[k+8>>2]=0,i[k+72>>2]=-1,i[k+76>>2]=-1,i[k+88>>2]=0,i[k+92>>2]=0,i[k+116>>2]=0,i[k+120>>2]=0,i[k>>2]=91444,i[k+40>>2]=0,i[k+44>>2]=0,i[k+48>>2]=0,i[k+52>>2]=0,i[k+56>>2]=0,i[k+60>>2]=0,i[k- -64>>2]=0,i[k+80>>2]=-1,i[k+84>>2]=-1,i[k+96>>2]=0,i[k+100>>2]=0,i[k+104>>2]=0,i[k+108>>2]=0,u[k+112|0]=0,i[k+16>>2]=86452,i[k+132>>2]=0,i[k+136>>2]=0,i[k+124>>2]=0,i[k+128>>2]=0,i[k+32>>2]=1835295606,i[n+76>>2]=k,i[n+72>>2]=k+16,t=i[n+72>>2],o=i[n+76>>2],i[n+72>>2]=0,i[n+76>>2]=0,k=i[n+260>>2],i[n+256>>2]=t,i[n+260>>2]=o;S:{if(!k||(t=i[k+4>>2],i[k+4>>2]=t-1,t))break S;W[i[i[k>>2]+8>>2]](k),y(k)}break e}k=p(128),i[k+32>>2]=0,i[k+36>>2]=0,i[k+24>>2]=0,i[k+28>>2]=0,i[k+4>>2]=0,i[k+8>>2]=0,i[k+72>>2]=-1,i[k+76>>2]=-1,i[k+88>>2]=0,i[k+92>>2]=0,i[k+116>>2]=0,i[k+120>>2]=0,i[k>>2]=91484,i[k+40>>2]=0,i[k+44>>2]=0,i[k+48>>2]=0,i[k+52>>2]=0,i[k+56>>2]=0,i[k+60>>2]=0,i[k- -64>>2]=0,i[k+80>>2]=-1,i[k+84>>2]=-1,i[k+96>>2]=0,i[k+100>>2]=0,i[k+104>>2]=0,i[k+108>>2]=0,u[k+112|0]=0,i[k+16>>2]=86520,i[k+32>>2]=1634563685,i[n+76>>2]=k,i[n+72>>2]=k+16,t=i[n+72>>2],o=i[n+76>>2],i[n+72>>2]=0,i[n+76>>2]=0,k=i[n+260>>2],i[n+256>>2]=t,i[n+260>>2]=o;R:{if(!k||(t=i[k+4>>2],i[k+4>>2]=t-1,t))break R;W[i[i[k>>2]+8>>2]](k),y(k)}break e}vt(n+72|0),t=i[n+72>>2],o=i[n+76>>2],i[n+72>>2]=0,i[n+76>>2]=0,k=i[n+260>>2],i[n+256>>2]=t,i[n+260>>2]=o;T:{if(!k||(t=i[k+4>>2],i[k+4>>2]=t-1,t))break T;W[i[i[k>>2]+8>>2]](k),y(k)}break e}k=p(168),i[k+24>>2]=0,i[k+28>>2]=0,i[k+4>>2]=0,i[k+8>>2]=0,i[k+72>>2]=-1,i[k+76>>2]=-1,i[k+116>>2]=0,i[k+88>>2]=0,i[k+92>>2]=0,i[k+120>>2]=0,i[k+124>>2]=0,i[k>>2]=91604,i[k+32>>2]=0,i[k+36>>2]=0,i[k+40>>2]=0,i[k+44>>2]=0,i[k+48>>2]=0,i[k+52>>2]=0,i[k+56>>2]=0,i[k+60>>2]=0,i[k- -64>>2]=0,i[k+80>>2]=-1,i[k+84>>2]=-1,i[k+96>>2]=0,i[k+100>>2]=0,i[k+104>>2]=0,i[k+108>>2]=0,g[k+112>>1]=0,i[k+16>>2]=89296,i[k+128>>2]=0,i[k+132>>2]=0,i[k+136>>2]=0,i[k+140>>2]=0,i[k+144>>2]=0,i[k+148>>2]=0,i[k+152>>2]=0,i[k+156>>2]=0,i[k+160>>2]=0,i[k+164>>2]=0,i[k+32>>2]=1969513843,i[n+76>>2]=k,i[n+72>>2]=k+16,t=i[n+72>>2],o=i[n+76>>2],i[n+72>>2]=0,i[n+76>>2]=0,k=i[n+260>>2],i[n+256>>2]=t,i[n+260>>2]=o;x:{if(!k||(t=i[k+4>>2],i[k+4>>2]=t-1,t))break x;W[i[i[k>>2]+8>>2]](k),y(k)}break e}k=p(128),i[k+32>>2]=0,i[k+36>>2]=0,i[k+24>>2]=0,i[k+28>>2]=0,i[k+4>>2]=0,i[k+8>>2]=0,i[k+72>>2]=-1,i[k+76>>2]=-1,i[k+88>>2]=0,i[k+92>>2]=0,i[k+124>>2]=0,i[k+116>>2]=0,i[k+120>>2]=0,i[k+16>>2]=98504,i[k>>2]=91644,i[k+40>>2]=0,i[k+44>>2]=0,i[k+48>>2]=0,i[k+52>>2]=0,i[k+56>>2]=0,i[k+60>>2]=0,i[k- -64>>2]=0,i[k+80>>2]=-1,i[k+84>>2]=-1,i[k+96>>2]=0,i[k+100>>2]=0,i[k+104>>2]=0,i[k+108>>2]=0,u[k+112|0]=0,i[k+32>>2]=1785751363,i[n+76>>2]=k,i[n+72>>2]=k+16,t=i[n+72>>2],o=i[n+76>>2],i[n+72>>2]=0,i[n+76>>2]=0,k=i[n+260>>2],i[n+256>>2]=t,i[n+260>>2]=o;z:{if(!k||(t=i[k+4>>2],i[k+4>>2]=t-1,t))break z;W[i[i[k>>2]+8>>2]](k),y(k)}break e}k=p(168),i[k+24>>2]=0,i[k+28>>2]=0,i[k+4>>2]=0,i[k+8>>2]=0,i[k+72>>2]=-1,i[k+76>>2]=-1,i[k+88>>2]=0,i[k+92>>2]=0,g[k+118>>1]=0,g[k+120>>1]=0,g[k+122>>1]=0,g[k+124>>1]=0,g[k+116>>1]=1,i[k>>2]=91684,i[k+32>>2]=0,i[k+36>>2]=0,i[k+40>>2]=0,i[k+44>>2]=0,i[k+48>>2]=0,i[k+52>>2]=0,i[k+56>>2]=0,i[k+60>>2]=0,i[k- -64>>2]=0,i[k+80>>2]=-1,i[k+84>>2]=-1,i[k+96>>2]=0,i[k+100>>2]=0,i[k+104>>2]=0,i[k+108>>2]=0,u[k+112|0]=0,g[k+126>>1]=0,g[k+128>>1]=0,g[k+130>>1]=0,g[k+132>>1]=0,g[k+134>>1]=0,g[k+144>>1]=1,i[k+136>>2]=4718592,i[k+140>>2]=4718592,i[k+148>>2]=0,i[k+152>>2]=0,i[k+156>>2]=0,i[k+160>>2]=-65512,i[k+16>>2]=91724,i[k+32>>2]=1835692135,i[n+76>>2]=k,i[n+72>>2]=k+16,t=i[n+72>>2],o=i[n+76>>2],i[n+72>>2]=0,i[n+76>>2]=0,k=i[n+260>>2],i[n+256>>2]=t,i[n+260>>2]=o;H:{if(!k||(t=i[k+4>>2],i[k+4>>2]=t-1,t))break H;W[i[i[k>>2]+8>>2]](k),y(k)}break e}k=p(136),i[k+32>>2]=0,i[k+36>>2]=0,i[k+24>>2]=0,i[k+28>>2]=0,i[k+4>>2]=0,i[k+8>>2]=0,i[k+72>>2]=-1,i[k+76>>2]=-1,i[k+116>>2]=0,i[k+88>>2]=0,i[k+92>>2]=0,i[k+120>>2]=0,i[k+124>>2]=0,i[k>>2]=91804,i[k+40>>2]=0,i[k+44>>2]=0,i[k+48>>2]=0,i[k+52>>2]=0,i[k+56>>2]=0,i[k+60>>2]=0,i[k- -64>>2]=0,i[k+80>>2]=-1,i[k+84>>2]=-1,i[k+96>>2]=0,i[k+100>>2]=0,i[k+104>>2]=0,i[k+108>>2]=0,g[k+112>>1]=0,i[k+16>>2]=89592,i[k+128>>2]=0,i[k+32>>2]=1701604967,i[n+76>>2]=k,i[n+72>>2]=k+16,t=i[n+72>>2],o=i[n+76>>2],i[n+72>>2]=0,i[n+76>>2]=0,k=i[n+260>>2],i[n+256>>2]=t,i[n+260>>2]=o;Y:{if(!k||(t=i[k+4>>2],i[k+4>>2]=t-1,t))break Y;W[i[i[k>>2]+8>>2]](k),y(k)}break e}k=p(120),i[k+32>>2]=0,i[k+36>>2]=0,i[k+24>>2]=0,i[k+28>>2]=0,i[k+4>>2]=0,i[k+8>>2]=0,i[k+72>>2]=-1,i[k+76>>2]=-1,i[k+88>>2]=0,i[k+92>>2]=0,i[k+16>>2]=99416,i[k>>2]=91844,i[k+40>>2]=0,i[k+44>>2]=0,i[k+48>>2]=0,i[k+52>>2]=0,i[k+56>>2]=0,i[k+60>>2]=0,i[k- -64>>2]=0,i[k+80>>2]=-1,i[k+84>>2]=-1,i[k+96>>2]=0,i[k+100>>2]=0,i[k+104>>2]=0,i[k+108>>2]=0,u[k+112|0]=0,i[k+32>>2]=1781689160,i[n+260>>2]=k,i[n+256>>2]=k+16,i[n+72>>2]=0,i[n+76>>2]=0;break e}k=p(128),i[k+32>>2]=0,i[k+36>>2]=0,i[k+24>>2]=0,i[k+28>>2]=0,i[k+4>>2]=0,i[k+8>>2]=0,i[k+72>>2]=-1,i[k+76>>2]=-1,i[k+88>>2]=0,i[k+92>>2]=0,i[k+124>>2]=0,i[k+116>>2]=0,i[k+120>>2]=0,i[k+16>>2]=99096,i[k>>2]=91884,i[k+40>>2]=0,i[k+44>>2]=0,i[k+48>>2]=0,i[k+52>>2]=0,i[k+56>>2]=0,i[k+60>>2]=0,i[k- -64>>2]=0,i[k+80>>2]=-1,i[k+84>>2]=-1,i[k+96>>2]=0,i[k+100>>2]=0,i[k+104>>2]=0,i[k+108>>2]=0,u[k+112|0]=0,i[k+32>>2]=1667523942,i[n+76>>2]=k,i[n+72>>2]=k+16,t=i[n+72>>2],o=i[n+76>>2],i[n+72>>2]=0,i[n+76>>2]=0,k=i[n+260>>2],i[n+256>>2]=t,i[n+260>>2]=o;E:{if(!k||(t=i[k+4>>2],i[k+4>>2]=t-1,t))break E;W[i[i[k>>2]+8>>2]](k),y(k)}break e}k=p(128),i[k+32>>2]=0,i[k+36>>2]=0,i[k+24>>2]=0,i[k+28>>2]=0,i[k+4>>2]=0,i[k+8>>2]=0,i[k+72>>2]=-1,i[k+76>>2]=-1,i[k+88>>2]=0,i[k+92>>2]=0,i[k+124>>2]=0,i[k+116>>2]=0,i[k+120>>2]=0,i[k+16>>2]=99176,i[k>>2]=91924,i[k+40>>2]=0,i[k+44>>2]=0,i[k+48>>2]=0,i[k+52>>2]=0,i[k+56>>2]=0,i[k+60>>2]=0,i[k- -64>>2]=0,i[k+80>>2]=-1,i[k+84>>2]=-1,i[k+96>>2]=0,i[k+100>>2]=0,i[k+104>>2]=0,i[k+108>>2]=0,u[k+112|0]=0,i[k+32>>2]=1668112752,i[n+76>>2]=k,i[n+72>>2]=k+16,t=i[n+72>>2],o=i[n+76>>2],i[n+72>>2]=0,i[n+76>>2]=0,k=i[n+260>>2],i[n+256>>2]=t,i[n+260>>2]=o;p:{if(!k||(t=i[k+4>>2],i[k+4>>2]=t-1,t))break p;W[i[i[k>>2]+8>>2]](k),y(k)}break e}k=p(144),i[k+32>>2]=0,i[k+36>>2]=0,i[k+24>>2]=0,i[k+28>>2]=0,i[k+4>>2]=0,i[k+8>>2]=0,i[k+72>>2]=-1,i[k+76>>2]=-1,i[k+88>>2]=0,i[k+92>>2]=0,i[k+116>>2]=0,i[k+120>>2]=0,i[k+16>>2]=99256,i[k>>2]=91964,i[k+40>>2]=0,i[k+44>>2]=0,i[k+48>>2]=0,i[k+52>>2]=0,i[k+56>>2]=0,i[k+60>>2]=0,i[k- -64>>2]=0,i[k+80>>2]=-1,i[k+84>>2]=-1,i[k+96>>2]=0,i[k+100>>2]=0,i[k+104>>2]=0,i[k+108>>2]=0,u[k+112|0]=0,i[k+124>>2]=0,i[k+128>>2]=0,i[k+132>>2]=0,i[k+136>>2]=0,i[k+32>>2]=1885564018,i[n+76>>2]=k,i[n+72>>2]=k+16,t=i[n+72>>2],o=i[n+76>>2],i[n+72>>2]=0,i[n+76>>2]=0,k=i[n+260>>2],i[n+256>>2]=t,i[n+260>>2]=o;J:{if(!k||(t=i[k+4>>2],i[k+4>>2]=t-1,t))break J;W[i[i[k>>2]+8>>2]](k),y(k)}break e}k=p(136),i[k+32>>2]=0,i[k+36>>2]=0,i[k+24>>2]=0,i[k+28>>2]=0,i[k+4>>2]=0,i[k+8>>2]=0,i[k+72>>2]=-1,i[k+76>>2]=-1,i[k+116>>2]=0,i[k+88>>2]=0,i[k+92>>2]=0,i[k+128>>2]=0,i[k+120>>2]=0,i[k+124>>2]=0,i[k+16>>2]=99336,i[k>>2]=92004,i[k+40>>2]=0,i[k+44>>2]=0,i[k+48>>2]=0,i[k+52>>2]=0,i[k+56>>2]=0,i[k+60>>2]=0,i[k- -64>>2]=0,i[k+80>>2]=-1,i[k+84>>2]=-1,i[k+96>>2]=0,i[k+100>>2]=0,i[k+104>>2]=0,i[k+108>>2]=0,g[k+112>>1]=0,i[k+32>>2]=1781689164,i[n+76>>2]=k,i[n+72>>2]=k+16,t=i[n+72>>2],o=i[n+76>>2],i[n+72>>2]=0,i[n+76>>2]=0,k=i[n+260>>2],i[n+256>>2]=t,i[n+260>>2]=o;M:{if(!k||(t=i[k+4>>2],i[k+4>>2]=t-1,t))break M;W[i[i[k>>2]+8>>2]](k),y(k)}break e}k=p(168),i[k+24>>2]=0,i[k+28>>2]=0,i[k+4>>2]=0,i[k+8>>2]=0,i[k+72>>2]=-1,i[k+76>>2]=-1,i[k+88>>2]=0,i[k+92>>2]=0,g[k+118>>1]=0,g[k+120>>1]=0,g[k+122>>1]=0,g[k+124>>1]=0,g[k+116>>1]=1,i[k>>2]=92044,i[k+32>>2]=0,i[k+36>>2]=0,i[k+40>>2]=0,i[k+44>>2]=0,i[k+48>>2]=0,i[k+52>>2]=0,i[k+56>>2]=0,i[k+60>>2]=0,i[k- -64>>2]=0,i[k+80>>2]=-1,i[k+84>>2]=-1,i[k+96>>2]=0,i[k+100>>2]=0,i[k+104>>2]=0,i[k+108>>2]=0,u[k+112|0]=0,g[k+126>>1]=0,g[k+128>>1]=0,g[k+130>>1]=0,g[k+132>>1]=0,g[k+134>>1]=0,g[k+144>>1]=1,i[k+136>>2]=4718592,i[k+140>>2]=4718592,i[k+148>>2]=0,i[k+152>>2]=0,i[k+156>>2]=0,i[k+160>>2]=-65512,i[k+16>>2]=92084,i[k+32>>2]=1781689193,i[n+76>>2]=k,i[n+72>>2]=k+16,t=i[n+72>>2],o=i[n+76>>2],i[n+72>>2]=0,i[n+76>>2]=0,k=i[n+260>>2],i[n+256>>2]=t,i[n+260>>2]=o;D:{if(!k||(t=i[k+4>>2],i[k+4>>2]=t-1,t))break D;W[i[i[k>>2]+8>>2]](k),y(k)}break e}k=p(168),i[k+24>>2]=0,i[k+28>>2]=0,i[k+4>>2]=0,i[k+8>>2]=0,i[k+72>>2]=-1,i[k+76>>2]=-1,i[k+88>>2]=0,i[k+92>>2]=0,i[k+116>>2]=0,i[k+16>>2]=100112,g[k+128>>1]=2056,i[k+124>>2]=1,i[k>>2]=92284,i[k+32>>2]=0,i[k+36>>2]=0,i[k+40>>2]=0,i[k+44>>2]=0,i[k+48>>2]=0,i[k+52>>2]=0,i[k+56>>2]=0,i[k+60>>2]=0,i[k- -64>>2]=0,i[k+80>>2]=-1,i[k+84>>2]=-1,i[k+96>>2]=0,i[k+100>>2]=0,i[k+104>>2]=0,i[k+108>>2]=0,u[k+112|0]=0,u[k+120|0]=0,i[k+164>>2]=0,i[k+156>>2]=0,i[k+160>>2]=0,i[k+148>>2]=0,i[k+152>>2]=0,i[k+140>>2]=0,i[k+144>>2]=0,i[k+132>>2]=0,i[k+136>>2]=0,i[k+32>>2]=1635148611,i[n+76>>2]=k,i[n+72>>2]=k+16,t=i[n+72>>2],o=i[n+76>>2],i[n+72>>2]=0,i[n+76>>2]=0,k=i[n+260>>2],i[n+256>>2]=t,i[n+260>>2]=o;U:{if(!k||(t=i[k+4>>2],i[k+4>>2]=t-1,t))break U;W[i[i[k>>2]+8>>2]](k),y(k)}break e}k=p(168),i[k+24>>2]=0,i[k+28>>2]=0,i[k+4>>2]=0,i[k+8>>2]=0,i[k+72>>2]=-1,i[k+76>>2]=-1,i[k+88>>2]=0,i[k+92>>2]=0,g[k+118>>1]=0,g[k+120>>1]=0,g[k+122>>1]=0,g[k+124>>1]=0,g[k+116>>1]=1,i[k>>2]=92324,i[k+32>>2]=0,i[k+36>>2]=0,i[k+40>>2]=0,i[k+44>>2]=0,i[k+48>>2]=0,i[k+52>>2]=0,i[k+56>>2]=0,i[k+60>>2]=0,i[k- -64>>2]=0,i[k+80>>2]=-1,i[k+84>>2]=-1,i[k+96>>2]=0,i[k+100>>2]=0,i[k+104>>2]=0,i[k+108>>2]=0,u[k+112|0]=0,g[k+126>>1]=0,g[k+128>>1]=0,g[k+130>>1]=0,g[k+132>>1]=0,g[k+134>>1]=0,g[k+144>>1]=1,i[k+136>>2]=4718592,i[k+140>>2]=4718592,i[k+148>>2]=0,i[k+152>>2]=0,i[k+156>>2]=0,i[k+160>>2]=-65512,i[k+16>>2]=92364,i[k+32>>2]=1635148593,i[n+76>>2]=k,i[n+72>>2]=k+16,t=i[n+72>>2],o=i[n+76>>2],i[n+72>>2]=0,i[n+76>>2]=0,k=i[n+260>>2],i[n+256>>2]=t,i[n+260>>2]=o;y:{if(!k||(t=i[k+4>>2],i[k+4>>2]=t-1,t))break y;W[i[i[k>>2]+8>>2]](k),y(k)}break e}k=p(120),i[k+4>>2]=0,i[k+8>>2]=0,i[k>>2]=92444,t=k+16|0,o0(t,0,104),i[k+52>>2]=0,i[k+56>>2]=0,i[k+16>>2]=86656,i[k+60>>2]=0,i[k+64>>2]=0,i[k+72>>2]=-1,i[k+76>>2]=-1,i[k+80>>2]=-1,i[k+84>>2]=-1,i[k+88>>2]=0,i[k+92>>2]=0,i[k+96>>2]=0,i[k+100>>2]=0,i[k+104>>2]=0,i[k+108>>2]=0,u[k+112|0]=0,i[n+260>>2]=k,i[n+256>>2]=t,i[n+72>>2]=0,i[n+76>>2]=0;break e}if($r(n+40|0,n+288|0),i[n+240>>2]=16,u[n+80|0]=157,u[n+81|0]=144,u[n+82|0]=78,u[n+83|0]=182,u[n+84|0]=236,u[n+85|0]=186,u[n+86|0]=243,u[n+87|0]=163,u[n+72|0]=34,u[n+73|0]=204,u[n+74|0]=4,u[n+75|0]=199,u[n+76|0]=214,u[n+77|0]=217,u[n+78|0]=78,u[n+79|0]=7,i[n+236>>2]=n+72,k=i[n+240>>2],i[n+24>>2]=i[n+236>>2],i[n+28>>2]=k,t=0,s=KA(n+244|0,n+24|0),o=i[s>>2],k=i[n+40>>2],w=i[n+44>>2]-k|0,(i[s+4>>2]-o|0)==(w|0)&&(t=!N2(k,o,w)),o&&(i[s+4>>2]=o,Z(o),k=i[n+40>>2]),k&&(i[n+44>>2]=k,Z(k)),t){vt(n+72|0),t=i[n+72>>2],o=i[n+76>>2],i[n+72>>2]=0,i[n+76>>2]=0,k=i[n+260>>2],i[n+256>>2]=t,i[n+260>>2]=o;g:{if(!k||(t=i[k+4>>2],i[k+4>>2]=t-1,t))break g;W[i[i[k>>2]+8>>2]](k),y(k)}break e}if($r(n+40|0,n+288|0),i[n+232>>2]=16,u[n+80|0]=151,u[n+81|0]=174,u[n+82|0]=190,u[n+83|0]=166,u[n+84|0]=152,u[n+85|0]=3,u[n+86|0]=180,u[n+87|0]=52,u[n+72|0]=67,u[n+73|0]=99,u[n+74|0]=233,u[n+75|0]=20,u[n+76|0]=91,u[n+77|0]=125,u[n+78|0]=74,u[n+79|0]=171,i[n+228>>2]=n+72,k=i[n+232>>2],i[n+16>>2]=i[n+228>>2],i[n+20>>2]=k,t=0,s=KA(n+244|0,n+16|0),o=i[s>>2],k=i[n+40>>2],w=i[n+44>>2]-k|0,(i[s+4>>2]-o|0)==(w|0)&&(t=!N2(k,o,w)),o&&(i[s+4>>2]=o,Z(o),k=i[n+40>>2]),k&&(i[n+44>>2]=k,Z(k)),t){cn(n+72|0),t=i[n+72>>2],o=i[n+76>>2],i[n+72>>2]=0,i[n+76>>2]=0,k=i[n+260>>2],i[n+256>>2]=t,i[n+260>>2]=o;g:{if(!k||(t=i[k+4>>2],i[k+4>>2]=t-1,t))break g;W[i[i[k>>2]+8>>2]](k),y(k)}break e}if($r(n+40|0,n+288|0),i[n+224>>2]=16,u[n+80|0]=172,u[n+81|0]=189,u[n+82|0]=157,u[n+83|0]=44,u[n+84|0]=142,u[n+85|0]=167,u[n+86|0]=53,u[n+87|0]=34,u[n+72|0]=38,u[n+73|0]=30,u[n+74|0]=243,u[n+75|0]=116,u[n+76|0]=29,u[n+77|0]=151,u[n+78|0]=91,u[n+79|0]=186,i[n+220>>2]=n+72,k=i[n+224>>2],i[n+8>>2]=i[n+220>>2],i[n+12>>2]=k,t=0,s=KA(n+244|0,n+8|0),o=i[s>>2],k=i[n+40>>2],w=i[n+44>>2]-k|0,(i[s+4>>2]-o|0)==(w|0)&&(t=!N2(k,o,w)),o&&(i[s+4>>2]=o,Z(o),k=i[n+40>>2]),k&&(i[n+44>>2]=k,Z(k)),t){t=p(128),i[t+24>>2]=0,i[t+28>>2]=0,i[t+4>>2]=0,i[t+8>>2]=0,i[t+72>>2]=-1,i[t+76>>2]=-1,i[t+88>>2]=0,i[t+92>>2]=0,i[t+116>>2]=0,i[t+120>>2]=0,i[t>>2]=92484,i[t+32>>2]=0,i[t+36>>2]=0,i[t+40>>2]=0,i[t+44>>2]=0,i[t+48>>2]=0,i[t+52>>2]=0,i[t+56>>2]=0,i[t+60>>2]=0,i[t- -64>>2]=0,i[t+80>>2]=-1,i[t+84>>2]=-1,i[t+96>>2]=0,i[t+100>>2]=0,i[t+104>>2]=0,i[t+108>>2]=0,u[t+112|0]=0,i[t+16>>2]=89512,i[t+124>>2]=0,o=p(16),u[o|0]=38,u[o+1|0]=30,u[o+2|0]=243,u[o+3|0]=116,u[o+4|0]=29,u[o+5|0]=151,u[o+6|0]=91,u[o+7|0]=186,u[o+8|0]=172,u[o+9|0]=189,u[o+10|0]=157,u[o+11|0]=44,u[o+12|0]=142,u[o+13|0]=167,u[o+14|0]=53,u[o+15|0]=34,i[t+32>>2]=1970628964,k=p(16),i[t+36>>2]=k,h=k+16|0,i[t+44>>2]=h,s=l[o+12|0]|l[o+13|0]<<8|(l[o+14|0]<<16|l[o+15|0]<<24),w=l[o+8|0]|l[o+9|0]<<8|(l[o+10|0]<<16|l[o+11|0]<<24),u[k+8|0]=w,u[k+9|0]=w>>>8,u[k+10|0]=w>>>16,u[k+11|0]=w>>>24,u[k+12|0]=s,u[k+13|0]=s>>>8,u[k+14|0]=s>>>16,u[k+15|0]=s>>>24,s=l[o+4|0]|l[o+5|0]<<8|(l[o+6|0]<<16|l[o+7|0]<<24),w=l[o|0]|l[o+1|0]<<8|(l[o+2|0]<<16|l[o+3|0]<<24),u[k|0]=w,u[k+1|0]=w>>>8,u[k+2|0]=w>>>16,u[k+3|0]=w>>>24,u[k+4|0]=s,u[k+5|0]=s>>>8,u[k+6|0]=s>>>16,u[k+7|0]=s>>>24,i[t+40>>2]=h,Z(o),i[n+76>>2]=t,i[n+72>>2]=t+16,t=i[n+72>>2],o=i[n+76>>2],i[n+72>>2]=0,i[n+76>>2]=0,k=i[n+260>>2],i[n+256>>2]=t,i[n+260>>2]=o;g:{if(!k||(t=i[k+4>>2],i[k+4>>2]=t-1,t))break g;W[i[i[k>>2]+8>>2]](k),y(k)}break e}i[n+40>>2]=1970628964,$t(n+72|0,n+40|0),t=i[n+72>>2],o=i[n+76>>2],i[n+72>>2]=0,i[n+76>>2]=0,k=i[n+260>>2],i[n+256>>2]=t,i[n+260>>2]=o;g:{if(!k||(t=i[k+4>>2],i[k+4>>2]=t-1,t))break g;W[i[i[k>>2]+8>>2]](k),y(k)}break e}k=p(120),i[k+32>>2]=0,i[k+36>>2]=0,i[k+24>>2]=0,i[k+28>>2]=0,i[k+4>>2]=0,i[k+8>>2]=0,i[k+72>>2]=-1,i[k+76>>2]=-1,i[k+88>>2]=0,i[k+92>>2]=0,i[k>>2]=92564,i[k+40>>2]=0,i[k+44>>2]=0,i[k+48>>2]=0,i[k+52>>2]=0,i[k+56>>2]=0,i[k+60>>2]=0,i[k- -64>>2]=0,i[k+80>>2]=-1,i[k+84>>2]=-1,i[k+96>>2]=0,i[k+100>>2]=0,i[k+104>>2]=0,i[k+108>>2]=0,u[k+112|0]=0,i[k+16>>2]=92604,i[k+32>>2]=1836019574,i[n+260>>2]=k,i[n+256>>2]=k+16,i[n+72>>2]=0,i[n+76>>2]=0;break e}k=p(200),i[k+24>>2]=0,i[k+28>>2]=0,i[k+4>>2]=0,i[k+8>>2]=0,i[k+72>>2]=-1,i[k+76>>2]=-1,i[k+116>>2]=0,i[k+88>>2]=0,i[k+92>>2]=0,i[k+144>>2]=0,i[k+148>>2]=0,i[k+16>>2]=104380,i[k+120>>2]=0,i[k+124>>2]=0,i[k>>2]=92684,i[k+32>>2]=0,i[k+36>>2]=0,i[k+40>>2]=0,i[k+44>>2]=0,i[k+48>>2]=0,i[k+52>>2]=0,i[k+56>>2]=0,i[k+60>>2]=0,i[k- -64>>2]=0,i[k+80>>2]=-1,i[k+84>>2]=-1,i[k+96>>2]=0,i[k+100>>2]=0,i[k+104>>2]=0,i[k+108>>2]=0,g[k+112>>1]=0,i[k+128>>2]=0,i[k+132>>2]=0,i[k+136>>2]=0,g[k+156>>1]=256,i[k+152>>2]=65536,i[k+196>>2]=0,i[k+32>>2]=1836476516,t=i[11782],i[k+160>>2]=i[11781],i[k+164>>2]=t,t=i[11784],i[k+168>>2]=i[11783],i[k+172>>2]=t,t=i[11786],i[k+176>>2]=i[11785],i[k+180>>2]=t,t=i[11788],i[k+184>>2]=i[11787],i[k+188>>2]=t,i[k+192>>2]=i[11789],i[n+72>>2]=k+16,i[n+76>>2]=k,t=i[n+72>>2],o=i[n+76>>2],i[n+72>>2]=0,i[n+76>>2]=0,k=i[n+260>>2],i[n+256>>2]=t,i[n+260>>2]=o;V:{if(!k||(t=i[k+4>>2],i[k+4>>2]=t-1,t))break V;W[i[i[k>>2]+8>>2]](k),y(k)}break e}k=p(120),i[k+32>>2]=0,i[k+36>>2]=0,i[k+24>>2]=0,i[k+28>>2]=0,i[k+4>>2]=0,i[k+8>>2]=0,i[k+72>>2]=-1,i[k+76>>2]=-1,i[k+88>>2]=0,i[k+92>>2]=0,i[k>>2]=92724,i[k+40>>2]=0,i[k+44>>2]=0,i[k+48>>2]=0,i[k+52>>2]=0,i[k+56>>2]=0,i[k+60>>2]=0,i[k- -64>>2]=0,i[k+80>>2]=-1,i[k+84>>2]=-1,i[k+96>>2]=0,i[k+100>>2]=0,i[k+104>>2]=0,i[k+108>>2]=0,u[k+112|0]=0,i[k+16>>2]=92764,i[k+32>>2]=1953653099,i[n+260>>2]=k,i[n+256>>2]=k+16,i[n+72>>2]=0,i[n+76>>2]=0;break e}k=p(208),i[k+24>>2]=0,i[k+28>>2]=0,i[k+4>>2]=0,i[k+8>>2]=0,i[k+72>>2]=-1,i[k+76>>2]=-1,i[k+88>>2]=0,i[k+92>>2]=0,i[k+152>>2]=0,i[k+144>>2]=0,i[k+148>>2]=0,i[k+16>>2]=104460,i[k+120>>2]=0,i[k+124>>2]=0,i[k>>2]=92844,i[k+32>>2]=0,i[k+36>>2]=0,i[k+40>>2]=0,i[k+44>>2]=0,i[k+48>>2]=0,i[k+52>>2]=0,i[k+56>>2]=0,i[k+60>>2]=0,i[k- -64>>2]=0,i[k+80>>2]=-1,i[k+84>>2]=-1,i[k+96>>2]=0,i[k+100>>2]=0,i[k+104>>2]=0,i[k+108>>2]=0,g[k+112>>1]=0,i[k+136>>2]=0,i[k+128>>2]=0,i[k+132>>2]=0,g[k+156>>1]=256,i[k+196>>2]=0,i[k+200>>2]=0,i[k+116>>2]=7,i[k+32>>2]=1953196132,i[k+192>>2]=i[11789],t=i[11788],i[k+184>>2]=i[11787],i[k+188>>2]=t,t=i[11786],i[k+176>>2]=i[11785],i[k+180>>2]=t,t=i[11784],i[k+168>>2]=i[11783],i[k+172>>2]=t,t=i[11782],i[k+160>>2]=i[11781],i[k+164>>2]=t,i[n+76>>2]=k,i[n+72>>2]=k+16,t=i[n+72>>2],o=i[n+76>>2],i[n+72>>2]=0,i[n+76>>2]=0,k=i[n+260>>2],i[n+256>>2]=t,i[n+260>>2]=o;W:{if(!k||(t=i[k+4>>2],i[k+4>>2]=t-1,t))break W;W[i[i[k>>2]+8>>2]](k),y(k)}break e}k=p(120),i[k+32>>2]=0,i[k+36>>2]=0,i[k+24>>2]=0,i[k+28>>2]=0,i[k+4>>2]=0,i[k+8>>2]=0,i[k+72>>2]=-1,i[k+76>>2]=-1,i[k+88>>2]=0,i[k+92>>2]=0,i[k>>2]=92884,i[k+40>>2]=0,i[k+44>>2]=0,i[k+48>>2]=0,i[k+52>>2]=0,i[k+56>>2]=0,i[k+60>>2]=0,i[k- -64>>2]=0,i[k+80>>2]=-1,i[k+84>>2]=-1,i[k+96>>2]=0,i[k+100>>2]=0,i[k+104>>2]=0,i[k+108>>2]=0,u[k+112|0]=0,i[k+16>>2]=92924,i[k+32>>2]=1835297121,i[n+260>>2]=k,i[n+256>>2]=k+16,i[n+72>>2]=0,i[n+76>>2]=0;break e}k=p(120),i[k+32>>2]=0,i[k+36>>2]=0,i[k+24>>2]=0,i[k+28>>2]=0,i[k+4>>2]=0,i[k+8>>2]=0,i[k+72>>2]=-1,i[k+76>>2]=-1,i[k+88>>2]=0,i[k+92>>2]=0,i[k>>2]=93204,i[k+40>>2]=0,i[k+44>>2]=0,i[k+48>>2]=0,i[k+52>>2]=0,i[k+56>>2]=0,i[k+60>>2]=0,i[k- -64>>2]=0,i[k+80>>2]=-1,i[k+84>>2]=-1,i[k+96>>2]=0,i[k+100>>2]=0,i[k+104>>2]=0,i[k+108>>2]=0,u[k+112|0]=0,i[k+16>>2]=93244,i[k+32>>2]=1937007212,i[n+260>>2]=k,i[n+256>>2]=k+16,i[n+72>>2]=0,i[n+76>>2]=0;break e}k=p(136),i[k+32>>2]=0,i[k+36>>2]=0,i[k+24>>2]=0,i[k+28>>2]=0,i[k+4>>2]=0,i[k+8>>2]=0,i[k+72>>2]=-1,i[k+76>>2]=-1,i[k+116>>2]=0,i[k+88>>2]=0,i[k+92>>2]=0,i[k+128>>2]=0,i[k+120>>2]=0,i[k+124>>2]=0,i[k+16>>2]=104780,i[k>>2]=93324,i[k+40>>2]=0,i[k+44>>2]=0,i[k+48>>2]=0,i[k+52>>2]=0,i[k+56>>2]=0,i[k+60>>2]=0,i[k- -64>>2]=0,i[k+80>>2]=-1,i[k+84>>2]=-1,i[k+96>>2]=0,i[k+100>>2]=0,i[k+104>>2]=0,i[k+108>>2]=0,g[k+112>>1]=0,i[k+32>>2]=1937011556,i[n+76>>2]=k,i[n+72>>2]=k+16,t=i[n+72>>2],o=i[n+76>>2],i[n+72>>2]=0,i[n+76>>2]=0,k=i[n+260>>2],i[n+256>>2]=t,i[n+260>>2]=o;G:{if(!k||(t=i[k+4>>2],i[k+4>>2]=t-1,t))break G;W[i[i[k>>2]+8>>2]](k),y(k)}break e}k=p(144),i[k+24>>2]=0,i[k+28>>2]=0,i[k+4>>2]=0,i[k+8>>2]=0,i[k+72>>2]=-1,i[k+76>>2]=-1,i[k+116>>2]=0,i[k+88>>2]=0,i[k+92>>2]=0,i[k+16>>2]=104860,i[k+120>>2]=0,i[k+124>>2]=0,i[k>>2]=93364,i[k+32>>2]=0,i[k+36>>2]=0,i[k+40>>2]=0,i[k+44>>2]=0,i[k+48>>2]=0,i[k+52>>2]=0,i[k+56>>2]=0,i[k+60>>2]=0,i[k- -64>>2]=0,i[k+80>>2]=-1,i[k+84>>2]=-1,i[k+96>>2]=0,i[k+100>>2]=0,i[k+104>>2]=0,i[k+108>>2]=0,g[k+112>>1]=0,i[k+128>>2]=0,i[k+132>>2]=0,i[k+136>>2]=0,i[k+32>>2]=1937011827,i[n+76>>2]=k,i[n+72>>2]=k+16,t=i[n+72>>2],o=i[n+76>>2],i[n+72>>2]=0,i[n+76>>2]=0,k=i[n+260>>2],i[n+256>>2]=t,i[n+260>>2]=o;Z:{if(!k||(t=i[k+4>>2],i[k+4>>2]=t-1,t))break Z;W[i[i[k>>2]+8>>2]](k),y(k)}break e}k=p(144),i[k+24>>2]=0,i[k+28>>2]=0,i[k+4>>2]=0,i[k+8>>2]=0,i[k+72>>2]=-1,i[k+76>>2]=-1,i[k+116>>2]=0,i[k+88>>2]=0,i[k+92>>2]=0,i[k+16>>2]=105020,i[k+120>>2]=0,i[k+124>>2]=0,i[k>>2]=93444,i[k+32>>2]=0,i[k+36>>2]=0,i[k+40>>2]=0,i[k+44>>2]=0,i[k+48>>2]=0,i[k+52>>2]=0,i[k+56>>2]=0,i[k+60>>2]=0,i[k- -64>>2]=0,i[k+80>>2]=-1,i[k+84>>2]=-1,i[k+96>>2]=0,i[k+100>>2]=0,i[k+104>>2]=0,i[k+108>>2]=0,g[k+112>>1]=0,i[k+128>>2]=0,i[k+132>>2]=0,i[k+136>>2]=0,i[k+32>>2]=1937011555,i[n+76>>2]=k,i[n+72>>2]=k+16,t=i[n+72>>2],o=i[n+76>>2],i[n+72>>2]=0,i[n+76>>2]=0,k=i[n+260>>2],i[n+256>>2]=t,i[n+260>>2]=o;v:{if(!k||(t=i[k+4>>2],i[k+4>>2]=t-1,t))break v;W[i[i[k>>2]+8>>2]](k),y(k)}break e}k=p(144),i[k+24>>2]=0,i[k+28>>2]=0,i[k+4>>2]=0,i[k+8>>2]=0,i[k+72>>2]=-1,i[k+76>>2]=-1,i[k+116>>2]=0,i[k+88>>2]=0,i[k+92>>2]=0,i[k+16>>2]=105100,i[k+120>>2]=0,i[k+124>>2]=0,i[k>>2]=93484,i[k+32>>2]=0,i[k+36>>2]=0,i[k+40>>2]=0,i[k+44>>2]=0,i[k+48>>2]=0,i[k+52>>2]=0,i[k+56>>2]=0,i[k+60>>2]=0,i[k- -64>>2]=0,i[k+80>>2]=-1,i[k+84>>2]=-1,i[k+96>>2]=0,i[k+100>>2]=0,i[k+104>>2]=0,i[k+108>>2]=0,g[k+112>>1]=0,i[k+128>>2]=0,i[k+132>>2]=0,i[k+136>>2]=0,i[k+140>>2]=0,i[k+32>>2]=1937007471,i[n+76>>2]=k,i[n+72>>2]=k+16,t=i[n+72>>2],o=i[n+76>>2],i[n+72>>2]=0,i[n+76>>2]=0,k=i[n+260>>2],i[n+256>>2]=t,i[n+260>>2]=o;B:{if(!k||(t=i[k+4>>2],i[k+4>>2]=t-1,t))break B;W[i[i[k>>2]+8>>2]](k),y(k)}break e}k=p(152),i[k+24>>2]=0,i[k+28>>2]=0,i[k+4>>2]=0,i[k+8>>2]=0,i[k+72>>2]=-1,i[k+76>>2]=-1,i[k+116>>2]=0,i[k+88>>2]=0,i[k+92>>2]=0,i[k+16>>2]=105180,i[k+120>>2]=0,i[k+124>>2]=0,i[k>>2]=93524,i[k+32>>2]=0,i[k+36>>2]=0,i[k+40>>2]=0,i[k+44>>2]=0,i[k+48>>2]=0,i[k+52>>2]=0,i[k+56>>2]=0,i[k+60>>2]=0,i[k- -64>>2]=0,i[k+80>>2]=-1,i[k+84>>2]=-1,i[k+96>>2]=0,i[k+100>>2]=0,i[k+104>>2]=0,i[k+108>>2]=0,g[k+112>>1]=0,i[k+128>>2]=0,i[k+132>>2]=0,i[k+136>>2]=0,i[k+140>>2]=0,i[k+144>>2]=0,i[k+32>>2]=1937011578,i[n+76>>2]=k,i[n+72>>2]=k+16,t=i[n+72>>2],o=i[n+76>>2],i[n+72>>2]=0,i[n+76>>2]=0,k=i[n+260>>2],i[n+256>>2]=t,i[n+260>>2]=o;h:{if(!k||(t=i[k+4>>2],i[k+4>>2]=t-1,t))break h;W[i[i[k>>2]+8>>2]](k),y(k)}break e}k=p(144),i[k+24>>2]=0,i[k+28>>2]=0,i[k+4>>2]=0,i[k+8>>2]=0,i[k+72>>2]=-1,i[k+76>>2]=-1,i[k+116>>2]=0,i[k+88>>2]=0,i[k+92>>2]=0,i[k+16>>2]=105260,i[k+120>>2]=0,i[k+124>>2]=0,i[k>>2]=93564,i[k+32>>2]=0,i[k+36>>2]=0,i[k+40>>2]=0,i[k+44>>2]=0,i[k+48>>2]=0,i[k+52>>2]=0,i[k+56>>2]=0,i[k+60>>2]=0,i[k- -64>>2]=0,i[k+80>>2]=-1,i[k+84>>2]=-1,i[k+96>>2]=0,i[k+100>>2]=0,i[k+104>>2]=0,i[k+108>>2]=0,g[k+112>>1]=0,i[k+128>>2]=0,i[k+132>>2]=0,u[k+133|0]=0,u[k+134|0]=0,u[k+135|0]=0,u[k+136|0]=0,u[k+137|0]=0,u[k+138|0]=0,u[k+139|0]=0,u[k+140|0]=0,i[k+32>>2]=1937011571,i[n+76>>2]=k,i[n+72>>2]=k+16,t=i[n+72>>2],o=i[n+76>>2],i[n+72>>2]=0,i[n+76>>2]=0,k=i[n+260>>2],i[n+256>>2]=t,i[n+260>>2]=o;_:{if(!k||(t=i[k+4>>2],i[k+4>>2]=t-1,t))break _;W[i[i[k>>2]+8>>2]](k),y(k)}break e}k=p(136),i[k+32>>2]=0,i[k+36>>2]=0,i[k+24>>2]=0,i[k+28>>2]=0,i[k+4>>2]=0,i[k+8>>2]=0,i[k+72>>2]=-1,i[k+76>>2]=-1,i[k+116>>2]=0,i[k+88>>2]=0,i[k+92>>2]=0,i[k+128>>2]=0,i[k+120>>2]=0,i[k+124>>2]=0,i[k+16>>2]=106348,i[k>>2]=93804,i[k+40>>2]=0,i[k+44>>2]=0,i[k+48>>2]=0,i[k+52>>2]=0,i[k+56>>2]=0,i[k+60>>2]=0,i[k- -64>>2]=0,i[k+80>>2]=-1,i[k+84>>2]=-1,i[k+96>>2]=0,i[k+100>>2]=0,i[k+104>>2]=0,i[k+108>>2]=0,g[k+112>>1]=0,i[k+32>>2]=1701606260,i[n+76>>2]=k,i[n+72>>2]=k+16,t=i[n+72>>2],o=i[n+76>>2],i[n+72>>2]=0,i[n+76>>2]=0,k=i[n+260>>2],i[n+256>>2]=t,i[n+260>>2]=o;w:{if(!k||(t=i[k+4>>2],i[k+4>>2]=t-1,t))break w;W[i[i[k>>2]+8>>2]](k),y(k)}break e}k=p(152),i[k+24>>2]=0,i[k+28>>2]=0,i[k+4>>2]=0,i[k+8>>2]=0,i[k+72>>2]=-1,i[k+76>>2]=-1,i[k+88>>2]=0,i[k+92>>2]=0,u[k+128|0]=0,u[k+124|0]=0,i[k+116>>2]=0,i[k+120>>2]=0,i[k+16>>2]=105740,i[k>>2]=93844,i[k+32>>2]=0,i[k+36>>2]=0,i[k+40>>2]=0,i[k+44>>2]=0,i[k+48>>2]=0,i[k+52>>2]=0,i[k+56>>2]=0,i[k+60>>2]=0,i[k- -64>>2]=0,i[k+80>>2]=-1,i[k+84>>2]=-1,i[k+96>>2]=0,i[k+100>>2]=0,i[k+104>>2]=0,i[k+108>>2]=0,g[k+112>>1]=0,i[k+148>>2]=0,i[k+140>>2]=0,i[k+144>>2]=0,i[k+132>>2]=0,i[k+136>>2]=0,i[k+32>>2]=1935828848,i[n+76>>2]=k,i[n+72>>2]=k+16,t=i[n+72>>2],o=i[n+76>>2],i[n+72>>2]=0,i[n+76>>2]=0,k=i[n+260>>2],i[n+256>>2]=t,i[n+260>>2]=o;s:{if(!k||(t=i[k+4>>2],i[k+4>>2]=t-1,t))break s;W[i[i[k>>2]+8>>2]](k),y(k)}break e}k=p(152),i[k+24>>2]=0,i[k+28>>2]=0,i[k+4>>2]=0,i[k+8>>2]=0,i[k+72>>2]=-1,i[k+76>>2]=-1,i[k+88>>2]=0,i[k+92>>2]=0,i[k+148>>2]=0,i[k+140>>2]=0,i[k+144>>2]=0,u[k+136|0]=0,u[k+132|0]=0,u[k+128|0]=0,u[k+124|0]=0,i[k+116>>2]=0,i[k+120>>2]=0,i[k+16>>2]=105868,i[k>>2]=93884,i[k+32>>2]=0,i[k+36>>2]=0,i[k+40>>2]=0,i[k+44>>2]=0,i[k+48>>2]=0,i[k+52>>2]=0,i[k+56>>2]=0,i[k+60>>2]=0,i[k- -64>>2]=0,i[k+80>>2]=-1,i[k+84>>2]=-1,i[k+96>>2]=0,i[k+100>>2]=0,i[k+104>>2]=0,i[k+108>>2]=0,g[k+112>>1]=0,i[k+32>>2]=1936158820,i[n+76>>2]=k,i[n+72>>2]=k+16,t=i[n+72>>2],o=i[n+76>>2],i[n+72>>2]=0,i[n+76>>2]=0,k=i[n+260>>2],i[n+256>>2]=t,i[n+260>>2]=o;l:{if(!k||(t=i[k+4>>2],i[k+4>>2]=t-1,t))break l;W[i[i[k>>2]+8>>2]](k),y(k)}break e}k=p(136),i[k+32>>2]=0,i[k+36>>2]=0,i[k+24>>2]=0,i[k+28>>2]=0,i[k+4>>2]=0,i[k+8>>2]=0,i[k+72>>2]=-1,i[k+76>>2]=-1,i[k+116>>2]=0,i[k+88>>2]=0,i[k+92>>2]=0,i[k+16>>2]=105948,i[k>>2]=93924,i[k+40>>2]=0,i[k+44>>2]=0,i[k+48>>2]=0,i[k+52>>2]=0,i[k+56>>2]=0,i[k+60>>2]=0,i[k- -64>>2]=0,i[k+80>>2]=-1,i[k+84>>2]=-1,i[k+96>>2]=0,i[k+100>>2]=0,i[k+104>>2]=0,i[k+108>>2]=0,g[k+112>>1]=0,i[k+32>>2]=1651798644,i[n+76>>2]=k,i[n+72>>2]=k+16,t=i[n+72>>2],o=i[n+76>>2],i[n+72>>2]=0,i[n+76>>2]=0,k=i[n+260>>2],i[n+256>>2]=t,i[n+260>>2]=o;o:{if(!k||(t=i[k+4>>2],i[k+4>>2]=t-1,t))break o;W[i[i[k>>2]+8>>2]](k),y(k)}break e}k=p(160),i[k+24>>2]=0,i[k+28>>2]=0,i[k+4>>2]=0,i[k+8>>2]=0,i[k+72>>2]=-1,i[k+76>>2]=-1,i[k+116>>2]=0,i[k+88>>2]=0,i[k+92>>2]=0,i[k+16>>2]=106028,i[k+120>>2]=0,i[k+124>>2]=0,i[k>>2]=93964,i[k+32>>2]=0,i[k+36>>2]=0,i[k+40>>2]=0,i[k+44>>2]=0,i[k+48>>2]=0,i[k+52>>2]=0,i[k+56>>2]=0,i[k+60>>2]=0,i[k- -64>>2]=0,i[k+80>>2]=-1,i[k+84>>2]=-1,i[k+96>>2]=0,i[k+100>>2]=0,i[k+104>>2]=0,i[k+108>>2]=0,g[k+112>>1]=0,u[k+128|0]=0,i[k+148>>2]=0,i[k+152>>2]=0,i[k+140>>2]=0,i[k+144>>2]=0,i[k+132>>2]=0,i[k+136>>2]=0,i[k+32>>2]=1935763834,i[n+76>>2]=k,i[n+72>>2]=k+16,t=i[n+72>>2],o=i[n+76>>2],i[n+72>>2]=0,i[n+76>>2]=0,k=i[n+260>>2],i[n+256>>2]=t,i[n+260>>2]=o;u:{if(!k||(t=i[k+4>>2],i[k+4>>2]=t-1,t))break u;W[i[i[k>>2]+8>>2]](k),y(k)}break e}k=p(168),i[k+24>>2]=0,i[k+28>>2]=0,i[k+4>>2]=0,i[k+8>>2]=0,i[k+72>>2]=-1,i[k+76>>2]=-1,i[k+116>>2]=0,i[k+88>>2]=0,i[k+92>>2]=0,i[k+16>>2]=106108,i[k+120>>2]=0,i[k+124>>2]=0,i[k>>2]=94004,i[k+32>>2]=0,i[k+36>>2]=0,i[k+40>>2]=0,i[k+44>>2]=0,i[k+48>>2]=0,i[k+52>>2]=0,i[k+56>>2]=0,i[k+60>>2]=0,i[k- -64>>2]=0,i[k+80>>2]=-1,i[k+84>>2]=-1,i[k+96>>2]=0,i[k+100>>2]=0,i[k+104>>2]=0,i[k+108>>2]=0,g[k+112>>1]=0,u[k+128|0]=0,i[k+160>>2]=0,i[k+152>>2]=0,i[k+156>>2]=0,i[k+144>>2]=0,i[k+148>>2]=0,i[k+32>>2]=1935763823,i[n+76>>2]=k,i[n+72>>2]=k+16,t=i[n+72>>2],o=i[n+76>>2],i[n+72>>2]=0,i[n+76>>2]=0,k=i[n+260>>2],i[n+256>>2]=t,i[n+260>>2]=o;t:{if(!k||(t=i[k+4>>2],i[k+4>>2]=t-1,t))break t;W[i[i[k>>2]+8>>2]](k),y(k)}break e}k=p(136),i[k+32>>2]=0,i[k+36>>2]=0,i[k+24>>2]=0,i[k+28>>2]=0,i[k+4>>2]=0,i[k+8>>2]=0,i[k+72>>2]=-1,i[k+76>>2]=-1,i[k+116>>2]=0,i[k+88>>2]=0,i[k+92>>2]=0,i[k+16>>2]=105660,i[k+120>>2]=0,i[k+124>>2]=0,i[k>>2]=94084,i[k+40>>2]=0,i[k+44>>2]=0,i[k+48>>2]=0,i[k+52>>2]=0,i[k+56>>2]=0,i[k+60>>2]=0,i[k- -64>>2]=0,i[k+80>>2]=-1,i[k+84>>2]=-1,i[k+96>>2]=0,i[k+100>>2]=0,i[k+104>>2]=0,i[k+108>>2]=0,g[k+112>>1]=0,i[k+128>>2]=0,i[k+32>>2]=1970432288,i[n+76>>2]=k,i[n+72>>2]=k+16,t=i[n+72>>2],o=i[n+76>>2],i[n+72>>2]=0,i[n+76>>2]=0,k=i[n+260>>2],i[n+256>>2]=t,i[n+260>>2]=o;n:{if(!k||(t=i[k+4>>2],i[k+4>>2]=t-1,t))break n;W[i[i[k>>2]+8>>2]](k),y(k)}break e}k=p(120),i[k+32>>2]=0,i[k+36>>2]=0,i[k+24>>2]=0,i[k+28>>2]=0,i[k+4>>2]=0,i[k+8>>2]=0,i[k+72>>2]=-1,i[k+76>>2]=-1,i[k+88>>2]=0,i[k+92>>2]=0,i[k+116>>2]=1,i[k+16>>2]=104700,i[k>>2]=94124,i[k+40>>2]=0,i[k+44>>2]=0,i[k+48>>2]=0,i[k+52>>2]=0,i[k+56>>2]=0,i[k+60>>2]=0,i[k- -64>>2]=0,i[k+80>>2]=-1,i[k+84>>2]=-1,i[k+96>>2]=0,i[k+100>>2]=0,i[k+104>>2]=0,i[k+108>>2]=0,g[k+112>>1]=0,i[k+32>>2]=1852663908,i[n+76>>2]=k,i[n+72>>2]=k+16,t=i[n+72>>2],o=i[n+76>>2],i[n+72>>2]=0,i[n+76>>2]=0,k=i[n+260>>2],i[n+256>>2]=t,i[n+260>>2]=o;k:{if(!k||(t=i[k+4>>2],i[k+4>>2]=t-1,t))break k;W[i[i[k>>2]+8>>2]](k),y(k)}break e}if((k|0)==1768186228)break r}i[n+40>>2]=k,$t(n+72|0,n+40|0),t=i[n+72>>2],o=i[n+76>>2],i[n+72>>2]=0,i[n+76>>2]=0,k=i[n+260>>2],i[n+256>>2]=t,i[n+260>>2]=o;f:{if(!k||(t=i[k+4>>2],i[k+4>>2]=t-1,t))break f;W[i[i[k>>2]+8>>2]](k),y(k)}break e}k=p(152),i[k+4>>2]=0,i[k+8>>2]=0,i[k>>2]=90844,t=k+16|0,o0(t,0,136),i[k+80>>2]=-1,i[k+84>>2]=-1,i[k+72>>2]=-1,i[k+76>>2]=-1,i[k+88>>2]=0,i[k+92>>2]=0,i[k+96>>2]=0,i[k+100>>2]=0,i[k+104>>2]=0,i[k+108>>2]=0,u[k+112|0]=0,i[k+120>>2]=0,i[k+124>>2]=0,i[k+16>>2]=88152,i[k+128>>2]=0,i[k+132>>2]=0,i[k+136>>2]=0,i[k+140>>2]=0,i[k+144>>2]=0,i[n+260>>2]=k,i[n+256>>2]=t,i[n+72>>2]=0,i[n+76>>2]=0}t=n+72|0,I2(t),o=i[n+300>>2],k=i[n+256>>2],i[k+8>>2]=i[n+296>>2],i[k+12>>2]=o,i[k+16>>2]=i[n+304>>2],o=i[n+308>>2],s=i[n+312>>2],d4(k+20|0,o,s,s-o|0),o=k,k=i[n+320>>2],i[o+32>>2]=k,ie(t,n+288|0),t=i[n+256>>2],u[t+95|0]<0&&Z(i[t+84>>2]),o=i[n+76>>2],i[t+84>>2]=i[n+72>>2],i[t+88>>2]=o,i[t+92>>2]=i[n+80>>2];e:{if(i[e+12>>2]>=21){if(e=p(64),i[n+72>>2]=e,i[n+76>>2]=61,i[n+80>>2]=-2147483584,r=l[17351]|l[17352]<<8|(l[17353]<<16|l[17354]<<24),f=l[17347]|l[17348]<<8|(l[17349]<<16|l[17350]<<24),u[e|0]=f,u[e+1|0]=f>>>8,u[e+2|0]=f>>>16,u[e+3|0]=f>>>24,u[e+4|0]=r,u[e+5|0]=r>>>8,u[e+6|0]=r>>>16,u[e+7|0]=r>>>24,u[e+61|0]=0,r=l[17404]|l[17405]<<8|(l[17406]<<16|l[17407]<<24),f=l[17400]|l[17401]<<8|(l[17402]<<16|l[17403]<<24),u[e+53|0]=f,u[e+54|0]=f>>>8,u[e+55|0]=f>>>16,u[e+56|0]=f>>>24,u[e+57|0]=r,u[e+58|0]=r>>>8,u[e+59|0]=r>>>16,u[e+60|0]=r>>>24,r=l[17399]|l[17400]<<8|(l[17401]<<16|l[17402]<<24),f=l[17395]|l[17396]<<8|(l[17397]<<16|l[17398]<<24),u[e+48|0]=f,u[e+49|0]=f>>>8,u[e+50|0]=f>>>16,u[e+51|0]=f>>>24,u[e+52|0]=r,u[e+53|0]=r>>>8,u[e+54|0]=r>>>16,u[e+55|0]=r>>>24,r=l[17391]|l[17392]<<8|(l[17393]<<16|l[17394]<<24),f=l[17387]|l[17388]<<8|(l[17389]<<16|l[17390]<<24),u[e+40|0]=f,u[e+41|0]=f>>>8,u[e+42|0]=f>>>16,u[e+43|0]=f>>>24,u[e+44|0]=r,u[e+45|0]=r>>>8,u[e+46|0]=r>>>16,u[e+47|0]=r>>>24,r=l[17383]|l[17384]<<8|(l[17385]<<16|l[17386]<<24),f=l[17379]|l[17380]<<8|(l[17381]<<16|l[17382]<<24),u[e+32|0]=f,u[e+33|0]=f>>>8,u[e+34|0]=f>>>16,u[e+35|0]=f>>>24,u[e+36|0]=r,u[e+37|0]=r>>>8,u[e+38|0]=r>>>16,u[e+39|0]=r>>>24,r=l[17375]|l[17376]<<8|(l[17377]<<16|l[17378]<<24),f=l[17371]|l[17372]<<8|(l[17373]<<16|l[17374]<<24),u[e+24|0]=f,u[e+25|0]=f>>>8,u[e+26|0]=f>>>16,u[e+27|0]=f>>>24,u[e+28|0]=r,u[e+29|0]=r>>>8,u[e+30|0]=r>>>16,u[e+31|0]=r>>>24,r=l[17367]|l[17368]<<8|(l[17369]<<16|l[17370]<<24),f=l[17363]|l[17364]<<8|(l[17365]<<16|l[17366]<<24),u[e+16|0]=f,u[e+17|0]=f>>>8,u[e+18|0]=f>>>16,u[e+19|0]=f>>>24,u[e+20|0]=r,u[e+21|0]=r>>>8,u[e+22|0]=r>>>16,u[e+23|0]=r>>>24,r=l[17359]|l[17360]<<8|(l[17361]<<16|l[17362]<<24),f=l[17355]|l[17356]<<8|(l[17357]<<16|l[17358]<<24),u[e+8|0]=f,u[e+9|0]=f>>>8,u[e+10|0]=f>>>16,u[e+11|0]=f>>>24,u[e+12|0]=r,u[e+13|0]=r>>>8,u[e+14|0]=r>>>16,u[e+15|0]=r>>>24,q(A,6,1e3,n+72|0),u[n+83|0]>=0)break e;Z(i[n+72>>2]);break e}r:{f:{A:{t=i[n+296>>2],s=i[n+300>>2];k:{if(t|s){if(o=k,!s&k>>>0>t>>>0){i[n+164>>2]=0,i[n+136>>2]=72196,i[n+80>>2]=72176,e=i[18053],i[n+72>>2]=e,r=i[e-12>>2],e=n+72|0,i[r+e>>2]=i[18054],i[n+76>>2]=0,r=e+i[i[n+72>>2]-12>>2]|0,f=n+84|0,J0(r,f),u[r+80|0]=0,i[r+72>>2]=0,r=i[18055],i[n+80>>2]=r,o=i[r-12>>2],r=n+80|0,i[o+r>>2]=i[18056],o=i[18052],i[n+72>>2]=o,i[e+i[o-12>>2]>>2]=i[18057],i[n+136>>2]=72196,i[n+72>>2]=72156,i[n+80>>2]=72176,f=R0(f),i[f>>2]=71232,i[n+124>>2]=0,i[n+128>>2]=0,i[n+116>>2]=0,i[n+120>>2]=0,i[n+132>>2]=24,Y(V0(Y(q2(Y(r,27074,10),t,s),27085,34),k),26411,7),e=i[n+132>>2];n:{if(e&16){k=n+104|0,r=i[n+128>>2],e=i[n+108>>2],r>>>0<e>>>0?i[n+128>>2]=e:e=r;break n}if(!(e&8)){e=0,u[n+51|0]=0,k=n+40|0;break r}k=n+92|0,e=i[n+100>>2]}if(r=i[k>>2],e=e-r|0,e>>>0>=2147483640)break A;if(e>>>0>=11){t=e|7,k=p(t+1|0),i[n+48>>2]=t-2147483647,i[n+40>>2]=k,i[n+44>>2]=e;break f}if(u[n+51|0]=e,k=n+40|0,e)break f;e=0;break r}if(k=t-o|0,t=s-(t>>>0<o>>>0)|0,(t|0)==1|t>>>0>1){if(e=A,A=d2(n+72|0,13899),q(e,6,101,A),u[A+11|0]>=0)break e;Z(i[A>>2]);break e}if((s|0)<0){if(e=A,A=d2(n+72|0,42673),q(e,2,101,A),u[A+11|0]>=0)break e;Z(i[A>>2]);break e}if(o=i[e>>2],s=W[i[i[o>>2]+8>>2]](o)|0,w=i[e>>2],o=l0,s=k+s|0,o=s>>>0<k>>>0?o+1|0:o,W[i[i[w>>2]+12>>2]](w,s,o)|0){if(e=A,A=d2(n+72|0,42673),q(e,2,100,A),u[A+11|0]>=0)break e;Z(i[A>>2]);break e}if(!t&u0[e+16>>2]>=k>>>0)break k;if(u[n+72|0]=0,u[n+83|0]=0,q(A,2,101,n+72|0),u[n+83|0]>=0)break e;Z(i[n+72>>2]);break e}k=i[e+16>>2]}if(i[n+64>>2]=i[e>>2],t=i[e+4>>2],i[n+68>>2]=t,t&&(i[t+4>>2]=i[t+4>>2]+1),t=i[n+68>>2],i[n>>2]=i[n+64>>2],i[n+4>>2]=t,k=pe(n+72|0,n,k,e),e=i[n+256>>2],W[i[i[e>>2]+48>>2]](n+40|0,e,k,f),e=i[n+44>>2],i[n+264>>2]=i[n+40>>2],i[n+268>>2]=e,u[n+283|0]<0&&Z(i[n+272>>2]),e=i[n+52>>2],i[n+272>>2]=i[n+48>>2],i[n+276>>2]=e,i[n+280>>2]=i[n+56>>2],f=i[k+16>>2],f&&(e=i[k+8>>2],e&&(c1(e,f),f=i[k+16>>2]),e=i[k>>2],o=W[i[i[e>>2]+8>>2]](e)|0,t=l0,s=f,f=f+o|0,t=s>>>0>f>>>0?t+1|0:t,W[i[i[e>>2]+20>>2]](e,f,t)|0,i[k+16>>2]=0),i[n+264>>2]!=i[26916]){e=i[n+256>>2],_=n,B=W[i[i[e>>2]+36>>2]](e)|0,i[_+244>>2]=B,i[n+36>>2]=i[i[n+256>>2]+16>>2],t=v-32|0,v=t,e=p(144),i[e+4>>2]=0,i[e+8>>2]=0,i[e>>2]=94244,o=i[n+36>>2],f=i[n+268>>2],i[t+8>>2]=i[n+264>>2],i[t+12>>2]=f,f=t+16|0;k:{if(u[n+283|0]>=0){s=i[n+276>>2],i[f>>2]=i[n+272>>2],i[f+4>>2]=s,i[f+8>>2]=i[n+280>>2];break k}T(f,i[n+272>>2],i[n+276>>2])}s=i[n+244>>2],i[e- -64>>2]=0,i[e+56>>2]=0,i[e+60>>2]=0,i[e+48>>2]=0,i[e+52>>2]=0,i[e+40>>2]=0,i[e+44>>2]=0,i[e+32>>2]=0,i[e+36>>2]=0,i[e+24>>2]=0,i[e+28>>2]=0,i[e+72>>2]=-1,i[e+76>>2]=-1,i[e+80>>2]=-1,i[e+84>>2]=-1,i[e+88>>2]=0,i[e+92>>2]=0,i[e+96>>2]=0,i[e+100>>2]=0,i[e+104>>2]=0,i[e+108>>2]=0,u[e+112|0]=0,i[e+16>>2]=86804,i[e+120>>2]=0,i[e+124>>2]=0,i[e+136>>2]=0,i[e+128>>2]=0,i[e+132>>2]=0,i[e+116>>2]=o,i[e+32>>2]=1163022880,o=i[t+12>>2],i[e+120>>2]=i[t+8>>2],i[e+124>>2]=o,u[e+139|0]<0&&Z(i[e+128>>2]),o=i[f+4>>2],i[e+128>>2]=i[f>>2],i[e+132>>2]=o,i[e+136>>2]=i[f+8>>2],i[e+140>>2]=s,i[n+44>>2]=e,i[n+40>>2]=e+16,v=t+32|0,f=i[n+40>>2],t=i[n+44>>2],i[n+40>>2]=0,i[n+44>>2]=0,e=i[n+260>>2],i[n+256>>2]=f,i[n+260>>2]=t;k:{if(!e||(f=i[e+4>>2],i[e+4>>2]=f-1,f))break k;W[i[i[e>>2]+8>>2]](e),y(e)}I2(n+40|0)}if(p8(r,n+256|0),e=i[n+268>>2],i[A>>2]=i[n+264>>2],i[A+4>>2]=e,i[A+16>>2]=i[n+280>>2],e=i[n+276>>2],i[A+8>>2]=i[n+272>>2],i[A+12>>2]=e,i[n+272>>2]=0,i[n+276>>2]=0,i[n+280>>2]=0,A=i[k+4>>2],!A||(e=i[A+4>>2],i[A+4>>2]=e-1,e))break e;W[i[i[A>>2]+8>>2]](A),y(A);break e}Q0(),H()}if(!e)break r;x(k,r,e)}u[e+k|0]=0,q(A,2,101,n+40|0),u[n+51|0]<0&&Z(i[n+40>>2]),A=i[18051],i[n+72>>2]=A,i[i[A-12>>2]+(n+72|0)>>2]=i[18059],i[n+80>>2]=i[18060],i[f>>2]=71232,u[n+127|0]<0&&Z(i[n+116>>2]),E0(f),y0(n+136|0)}if(A=i[n+260>>2],!A||(e=i[A+4>>2],i[A+4>>2]=e-1,e))break i;W[i[i[A>>2]+8>>2]](A),y(A)}u[n+283|0]<0&&Z(i[n+272>>2]),A=i[n+308>>2],A&&Z(A),v=n+336|0}function D8(A,e,r,f,k,n,t){var o=0,s=0,w=0,h=0,_=0,B=0,m=0,X=0,Q=0,V=0,F=0,I=0,E=0,R=0,N=0,M=0,z=0,S=0,O=0,P=0,a=0,$=0,f0=0,A0=0,n0=0,_0=0,m0=0,X0=0;i:{e:{r:{if(!n){F=i[A+18588>>2],A0=i[F+124>>2];f:{if(!k){if(s=i[F+208>>2],o=e>>s,(o|0)<0||(h=i[F+212>>2],(h|0)<=(o|0)))break e;if(s=r>>s,(s|0)<0|(s|0)>=i[F+216>>2])break i;o=l[(o+i[F+200>>2]|0)+G(s,h)|0],o=o>>>0<=34?o:0;break f}if(s=i[F+228>>2],o=G(i[A0+16852>>2],e)>>s,(o|0)<0||(h=i[F+232>>2],(h|0)<=(o|0)))break e;if(s=G(i[A0+16856>>2],r)>>s,(s|0)<0|(s|0)>=i[F+236>>2])break i;o=l[(o+i[F+220>>2]|0)+G(s,h)|0]&63}n0=o>>>0>34?1:o,E=n0,z=i[F+(k?44:40)>>2],o=G(z,r),s=i[(F+(k<<2)|0)+4>>2];f:{A:{k:{n:{t:{u:{if(i[i[F+124>>2]+(k?16840:16832)>>2]>=9){M=s+(e+o<<1)|0,h=0,S=v-528|0,v=S,X=v-336|0,v=X,i[X+24>>2]=k,i[X+16>>2]=F,i[X+32>>2]=r,i[X+28>>2]=e,m=S+256|0,i[X+12>>2]=m,i[X+20>>2]=f;o:{if((f|0)<65){i[X+316>>2]=16843009,w=X+12|0,tn(w);l:{if(i[w+8>>2]<33){if(s=i[w+4>>2],o=i[w+12>>2],B=i[s+(o?44:40)>>2],_=i[w+16>>2],Q=i[w+24>>2],V=i[Q+16936>>2],N=i[w+20>>2],Q=i[(i[i[w+28>>2]+8496>>2]+(G(_,i[w+296>>2])>>V<<2)|0)+(G(i[Q+16924>>2],G(N,i[w+300>>2])>>V)<<2)>>2],V=i[(s+(o<<2)|0)+4>>2],o=i[w+308>>2],!(l[w+304|0]!=1|(o|0)<=0))for(O=V-2|0,o=o-1|0;;){s=o;s:{if(l[w+304|0]!=1)break s;R=i[w+28>>2],P=G(i[w+296>>2],_-1|0),I=i[w+24>>2],a=i[I+16936>>2],$=o+N|0,f0=G($,i[w+300>>2]),I=i[(i[R+8496>>2]+(P>>a<<2)|0)+(G(i[I+16924>>2],f0>>a)<<2)>>2];w:{if(l[R+24|0]){if(R=P,o=i[w+4>>2],P=i[o+168>>2],R=R>>P,(R|0)<0||(a=i[o+172>>2],(a|0)<=(R|0)))break e;if(P=f0>>P,(P|0)<0|(P|0)>=i[o+176>>2])break i;if(l[((i[o+160>>2]+G(R,3)|0)+G(G(P,a),3)|0)+1|0]&3)break s;if((Q|0)>=(I|0))break w;break s}if((Q|0)<(I|0))break s}i[w+316>>2]||(g[w+320>>1]=C[(O+(_<<1)|0)+(G(B,$)<<1)>>1]),o=s^-1,u[o+i[w+292>>2]|0]=1,g[i[w>>2]+(o<<1)>>1]=C[(O+(i[w+16>>2]<<1)|0)+(G(B,s+i[w+20>>2]|0)<<1)>>1],u[i[w+292>>2]-s|0]=1,g[i[w>>2]-(s<<1)>>1]=C[(O+(i[w+16>>2]<<1)|0)+(G(B,(s+i[w+20>>2]|0)-1|0)<<1)>>1],o=1-s|0,u[o+i[w+292>>2]|0]=1,g[i[w>>2]+(o<<1)>>1]=C[(O+(i[w+16>>2]<<1)|0)+(G(B,(s+i[w+20>>2]|0)-2|0)<<1)>>1],o=2-s|0,u[o+i[w+292>>2]|0]=1,_=i[w+16>>2],N=i[w+20>>2],g[i[w>>2]+(o<<1)>>1]=C[(O+(_<<1)|0)+(G(B,(s+N|0)-3|0)<<1)>>1],i[w+316>>2]=i[w+316>>2]+4}if(o=s-4|0,!((s|0)>3))break}s:{if(!l[w+307|0])break s;o=i[w+28>>2],O=G(i[w+296>>2],_-1|0),s=i[w+24>>2],I=i[s+16936>>2],R=N-1|0,N=G(R,i[w+300>>2]),s=i[(i[o+8496>>2]+(O>>I<<2)|0)+(G(i[s+16924>>2],N>>I)<<2)>>2];w:{if(l[o+24|0]){if(o=i[w+4>>2],I=i[o+168>>2],O=O>>I,(O|0)<0||(P=i[o+172>>2],(P|0)<=(O|0)))break e;if(N=N>>I,(N|0)<0|(N|0)>=i[o+176>>2])break i;if(l[((i[o+160>>2]+G(O,3)|0)+G(G(N,P),3)|0)+1|0]&3)break s;if((s|0)<=(Q|0))break w;break s}if((s|0)>(Q|0))break s}o=G(B,R),i[w+316>>2]||(g[w+320>>1]=C[((V+(_<<1)|0)+(o<<1)|0)-2>>1]),g[i[w>>2]>>1]=C[((V+(_<<1)|0)+(o<<1)|0)-2>>1],u[i[w+292>>2]]=1,i[w+316>>2]=i[w+316>>2]+1}if(o=i[w+312>>2],(o|0)>0)for(_=0;;){s:{if(l[w+(i[w+8>>2]>(_|0)?305:306)|0]!=1)break s;s=i[w+28>>2],O=i[w+16>>2],I=G(i[w+296>>2],O+_|0),N=i[w+24>>2],R=i[N+16936>>2],P=i[w+20>>2]-1|0,a=G(P,i[w+300>>2]),N=i[(i[s+8496>>2]+(I>>R<<2)|0)+(G(i[N+16924>>2],a>>R)<<2)>>2];w:{if(l[s+24|0]){if(s=i[w+4>>2],R=i[s+168>>2],I=I>>R,(I|0)<0||($=i[s+172>>2],($|0)<=(I|0)))break e;if(R=a>>R,(R|0)<0|(R|0)>=i[s+176>>2])break i;if(l[((i[s+160>>2]+G(I,3)|0)+G(G(R,$),3)|0)+1|0]&3)break s;if((Q|0)>=(N|0))break w;break s}if((Q|0)<(N|0))break s}s=G(B,P),i[w+316>>2]||(g[w+320>>1]=C[((V+(O<<1)|0)+(_<<1)|0)+(s<<1)>>1]),N=_|1,o=V+(_<<1)|0,g[i[w>>2]+(N<<1)>>1]=C[(o+(O<<1)|0)+(s<<1)>>1],u[N+i[w+292>>2]|0]=1,s=_|2,g[i[w>>2]+(s<<1)>>1]=C[((o+(i[w+16>>2]<<1)|0)+(G(B,i[w+20>>2]-1|0)<<1)|0)+2>>1],u[s+i[w+292>>2]|0]=1,s=_|3,g[i[w>>2]+(s<<1)>>1]=C[((o+(i[w+16>>2]<<1)|0)+(G(B,i[w+20>>2]-1|0)<<1)|0)+4>>1],u[s+i[w+292>>2]|0]=1,s=_+4|0,g[i[w>>2]+(s<<1)>>1]=C[((o+(i[w+16>>2]<<1)|0)+(G(B,i[w+20>>2]-1|0)<<1)|0)+6>>1],u[s+i[w+292>>2]|0]=1,i[w+316>>2]=i[w+316>>2]+4,o=i[w+312>>2]}if(_=_+4|0,!((_|0)<(o|0)))break}break l}break u}s=i[X+328>>2],o=i[X+20>>2],w=o<<2,V=w|1;l:{if((s|0)==(V|0))break l;if(!s){if(B=0,Q=o<<1,_=0-Q|0,(_|0)>(Q|0))break l;for(V=V&5,o=1<<i[i[i[X+16>>2]+124>>2]+(i[X+24>>2]?16840:16832)>>2]-1,s=i[X+12>>2];g[s+(_<<1)>>1]=o,_=_+1|0,B=B+1|0,(V|0)!=(B|0););if(w>>>0<7)break l;for(B=s+12|0,V=s+10|0,O=s+8|0,N=s+6|0,I=s+4|0,R=s+2|0;w=_<<1,g[w+s>>1]=o,g[w+R>>1]=o,g[w+I>>1]=o,g[w+N>>1]=o,g[w+O>>1]=o,g[w+V>>1]=o,g[w+B>>1]=o,w=_+7|0,g[s+(w<<1)>>1]=o,_=_+8|0,(w|0)!=(Q|0););break l}if(o=o<<1,s=0-o|0,w=i[X+304>>2],l[w-o|0]||(g[i[X+12>>2]+(s<<1)>>1]=C[X+332>>1]),(o|0)<=(s|0))break l;for(_=s|1,s=i[X+12>>2];l[w+_|0]||(B=s+(_<<1)|0,g[B>>1]=C[B-2>>1]),B=_+1|0,l[B+w|0]||(Q=s+(B<<1)|0,g[Q>>1]=C[Q-2>>1]),_=_+2|0,(o|0)!=(B|0););}v=X+336|0;break o}break t}o=i[F+124>>2];o:{if(l[o+16825|0]||k&&(h=k,i[o+16848>>2]!=3))break o;w=v-272|0,v=w;l:{if((f|0)==4|(E|0)==1)break l;s=(E|0)<26?26-E|0:E-26|0,_=(E|0)<10?10-E|0:E-10|0,s=(s|0)<(_|0)?s:_;s:{w:switch(k2(f-8|0,29)|0){case 1:if((s|0)<=1)break l;break s;case 3:if((s|0)>0)break s;break l;case 7:break l;case 0:break w;default:break n}if((s|0)<8)break l}s:{w:{_:{if(!(!l[o+8997|0]|(h|(f|0)!=32))&&(h=C[m+128>>1],s=C[m>>1],B=(h+s|0)-(C[m+64>>1]<<1)|0,_=B>>31,X=1<<i[o+512>>2]-5,(X|0)>((_^B)-_|0)))break _;o=w+128|0;break w}if(o=w+128|0,_=C[m-128>>1],Q=(_+s|0)-(C[m+-64>>1]<<1)|0,B=Q>>31,X>>>0<=(B^Q)-B>>>0)break w;for(g[w+256>>1]=h,g[w>>1]=_,g[w+128>>1]=s,B=h-s|0,X=_-s|0,h=1;;)if(_=h<<1,g[o-_>>1]=s+(G(h,X)+32>>>6|0),g[o+_>>1]=s+(G(h,B)+32>>>6|0),_=h+1|0,(_|0)==64){_=-64;break s}else{g[((h^-1)<<1)+o>>1]=s+(G(_,X)+32>>>6|0),g[(_<<1)+o>>1]=s+(G(_,B)+32>>>6|0),h=h+2|0;continue}}if(s=w+128|0,h=f<<2,g[s-h>>1]=C[m-h>>1],g[s+h>>1]=C[h+m>>1],B=f<<1,_=0-B|0,h=1-B|0,(h|0)>=(B|0))break s;for(Q=h<<1,O=m-2|0,h=2-B|0,X=C[m+(h<<1)>>1],g[Q+s>>1]=(C[O+Q>>1]+(X+(C[m+Q>>1]<<1)|0)|0)+2>>>2;Q=h<<1,N=Q+2|0,V=C[N+m>>1],g[s+Q>>1]=(C[Q+O>>1]+(V+(X<<1)|0)|0)+2>>>2,h=h+2|0,X=C[m+(h<<1)>>1],g[s+N>>1]=(C[m+Q>>1]+(X+(V<<1)|0)|0)+2>>>2,(h|0)!=(B|0););}if(s=f<<3|2,!s)break l;h=_<<1,x(h+m|0,o+h|0,s)}v=w+272|0}o:{l:switch(E|0){case 0:s:{if((f|0)>=2){for(s=0,o=f;h=s,s=s+1|0,w=o>>>0>3,o=o>>>1|0,!!w;);w=h+2|0;break s}if(w=1,(f|0)!=1)break o}for(N=f&-2,I=f&1,h=f-1|0,R=C[m+((f^-1)<<1)>>1],_=C[(m+(f<<1)|0)+2>>1],o=0;;){if(B=h-o|0,s=o+1|0,E=G(s,R),F=M+(G(o,z)<<1)|0,X=C[m+((o^-1)<<1)>>1],o=0,Q=0,(f|0)!=1)for(;V=o|1,O=V<<1,g[F+(o<<1)>>1]=E+(((G(X,h-o|0)+f|0)+G(_,V)|0)+G(B,C[m+O>>1])|0)>>w,o=o+2|0,g[F+O>>1]=E+(((G(X,h-V|0)+f|0)+G(_,o)|0)+G(B,C[m+(o<<1)>>1])|0)>>w,Q=Q+2|0,(N|0)!=(Q|0););if(I&&(V=F+(o<<1)|0,P=G(X,h-o|0)+f|0,o=o+1|0,g[V>>1]=E+((P+G(o,_)|0)+G(B,C[m+(o<<1)>>1])|0)>>w),o=s,(o|0)==(f|0))break}break o;case 1:s=0,h=0;s:{w:{if((f|0)>=2){for(o=f;h=s,s=s+1|0,w=o>>>0>3,o=o>>>1|0,!!w;);_=h+2|0;break w}if(_=1,(f|0)!=1)break s}h=1,E=f&1;w:{if((f|0)==1){w=0,s=0;break w}for(F=m+2|0,X=f&-2,o=0,s=0,B=0;w=o+2|0,s=C[m+((o^2147483646)<<1)>>1]+(C[m+(w<<1)>>1]+(C[m+((o^-1)<<1)>>1]+(C[F+(o<<1)>>1]+s|0)|0)|0)|0,o=w,B=B+2|0,(X|0)!=(B|0););}if(!E)break s;s=C[m+((w^-1)<<1)>>1]+(C[(m+(w<<1)|0)+2>>1]+s|0)|0}_=f+s>>_;s:{if(!(!k&(f|0)<=31)){if(!h)break s;for(E=f&-8,m=f&7,w=0,F=f-1>>>0<7;;){if(o=M+(G(w,z)<<1)|0,s=0,!F)for(X=o+14|0,Q=o+12|0,V=o+10|0,O=o+8|0,N=o+6|0,I=o+4|0,R=o+2|0,B=0;h=s<<1,g[h+o>>1]=_,g[h+R>>1]=_,g[h+I>>1]=_,g[h+N>>1]=_,g[h+O>>1]=_,g[h+V>>1]=_,g[h+Q>>1]=_,g[h+X>>1]=_,s=s+8|0,B=B+8|0,(E|0)!=(B|0););if(B=0,m)for(;g[o+(s<<1)>>1]=_,s=s+1|0,B=B+1|0,(m|0)!=(B|0););if(w=w+1|0,(w|0)==(f|0))break}break s}if(s=1,g[M>>1]=(C[m+2>>1]+(C[m-2>>1]+(_<<1)|0)|0)+2>>>2,(f|0)<2)break s;if(h=f-1|0,E=h&3,w=G(_,3)+2|0,F=f-2|0,F>>>0>=3)for(Q=h&-4,o=0;B=s<<1,X=B+2|0,g[B+M>>1]=w+C[m+X>>1]>>>2,I=X+M|0,X=B+4|0,g[I>>1]=w+C[X+m>>1]>>>2,B=B+6|0,g[X+M>>1]=w+C[B+m>>1]>>>2,s=s+4|0,g[B+M>>1]=w+C[m+(s<<1)>>1]>>>2,o=o+4|0,(Q|0)!=(o|0););if(E)for(B=0;o=M+(s<<1)|0,s=s+1|0,g[o>>1]=w+C[m+(s<<1)>>1]>>>2,B=B+1|0,(E|0)!=(B|0););if(s=1,o=G(_,3)+2|0,F)for(w=h&-2,B=0;g[M+(G(s,z)<<1)>>1]=o+C[m+((s^-1)<<1)>>1]>>>2,g[M+(G(z,s+1|0)<<1)>>1]=o+C[m+(-2-s<<1)>>1]>>>2,s=s+2|0,B=B+2|0,(w|0)!=(B|0););for(h&1&&(g[M+(G(s,z)<<1)>>1]=o+C[m+((s^-1)<<1)>>1]>>>2),E=h&-8,m=h&7,w=1;;){if(o=M+(G(w,z)<<1)|0,s=1,F>>>0>=7)for(X=o+14|0,Q=o+12|0,V=o+10|0,O=o+8|0,N=o+6|0,I=o+4|0,R=o+2|0,B=0;h=s<<1,g[h+o>>1]=_,g[h+R>>1]=_,g[h+I>>1]=_,g[h+N>>1]=_,g[h+O>>1]=_,g[h+V>>1]=_,g[h+Q>>1]=_,g[h+X>>1]=_,s=s+8|0,B=B+8|0,(E|0)!=(B|0););if(B=0,m)for(;g[o+(s<<1)>>1]=_,s=s+1|0,B=B+1|0,(m|0)!=(B|0););if(w=w+1|0,(w|0)==(f|0))break}}break o;default:break l}if(o=i[F+124>>2],O=i[o+(k?16840:16832)>>2],l[o+16822|0]){if(s=i[F+168>>2],o=e>>s,(o|0)<0||(h=i[F+172>>2],(h|0)<=(o|0)))break e;if(s=r>>s,(s|0)<0|(s|0)>=i[F+176>>2])break i;w=(l[((i[F+160>>2]+G(o,3)|0)+G(G(s,h),3)|0)+1|0]&8)>>>3|0}else w=0;o=0,h=0,F=v-528|0,v=F;l:{if((E|0)<35){if((E|0)<=1)break A;_=F+256|0,B=i[(E<<2)+63120>>2];s:{w:{_:{if(E>>>0<=17){h:{if((f|0)<0)break h;if(s=f+1|0,X=s&3,f>>>0>=3)for(Q=s&-4;s=o<<1,g[s+_>>1]=C[m-s>>1],V=s|2,g[V+_>>1]=C[m-V>>1],V=s|4,g[V+_>>1]=C[m-V>>1],s=s|6,g[s+_>>1]=C[m-s>>1],o=o+4|0,h=h+4|0,(Q|0)!=(h|0););if(!X)break h;for(s=0;h=o<<1,g[h+_>>1]=C[m-h>>1],o=o+1|0,s=s+1|0,(X|0)!=(s|0););}if(s=E-11|0,s>>>0<15)break _;if(X=f<<1,(X|0)<=(f|0))break w;if(o=f,Q=o&3,Q)for(h=0,s=o;o=s+1|0,g[_+(o<<1)>>1]=C[m+((s^-1)<<1)>>1],s=o,h=h+1|0,(Q|0)!=(h|0););if(f-1>>>0<3)break w;for(h=_+6|0,Q=_+4|0,V=_+2|0;s=o<<1,g[s+V>>1]=C[m+((o^-1)<<1)>>1],g[s+Q>>1]=C[m+(-2-o<<1)>>1],g[s+h>>1]=C[m+(-3-o<<1)>>1],s=o+4|0,g[_+(s<<1)>>1]=C[m+(-4-o<<1)>>1],o=s,(X|0)!=(o|0););break w}h:{if((f|0)<0||(o=(f<<1)+2|0,!o))break h;x(_,m,o)}s=E-11|0;h:{if(s>>>0>=15){if(o=f<<1,(o|0)<=(f|0)|!o)break h;x((o+F|0)+258|0,(o+m|0)+2|0,o);break h}if(h=G(f,B),o=h>>5,(o|0)>-2)break h;for(s=i[(s<<2)+63264>>2],h&32&&(g[_+(o<<1)>>1]=C[m-(G(o,s)+128>>8<<1)>>1],o=o+1|0);g[_+(o<<1)>>1]=C[m-(G(o,s)+128>>8<<1)>>1],h=o+1|0,g[_+(h<<1)>>1]=C[m-(G(s,h)+128>>8<<1)>>1],o=o+2|0,!!o;);}if((f|0)>0)for(a=F+258|0,$=f&2147483646,f0=f&1,N=f<<1,m0=z<<1,s=0;;){o=s,s=o+1|0,h=G(B,s),V=h>>5<<1,h=h&31;h:{if(h){if(X=M+(G(o,z)<<1)|0,Q=32-h|0,V=_+V|0,o=0,(f|0)!=1)for(X0=V+4|0,I=0;R=o<<1,_0=R+V|0,P=C[_0+4>>1],g[X+R>>1]=(G(Q,C[_0+2>>1])+G(h,P)|0)+16>>>5,R=R|2,g[R+X>>1]=(G(Q,P)+G(h,C[R+X0>>1])|0)+16>>>5,o=o+2|0,I=I+2|0,($|0)!=(I|0););if(!f0)break h;I=V,V=o<<1,o=I+V|0,g[X+V>>1]=(G(Q,C[o+2>>1])+G(h,C[o+4>>1])|0)+16>>>5;break h}if(!N)break h;x(M+G(o,m0)|0,V+a|0,N)}if((f|0)==(s|0))break}if((E|0)!=26|f-32>>>0<4294967265|(k|w))break s;for(s=-1<<O^-1,o=0;h=C[m+2>>1]+(C[m+((o^-1)<<1)>>1]-C[m>>1]>>1)|0,g[M+(G(o,z)<<1)>>1]=(h|0)>=0?(s|0)>(h|0)?h:s:0,o=o+1|0,(o|0)!=(f|0););break s}if(h=G(f,B),o=h>>5,(o|0)>-2)break w;for(s=i[(s<<2)+63264>>2],h&32&&(g[_+(o<<1)>>1]=C[m+(G(o,s)+128>>8<<1)>>1],o=o+1|0);g[_+(o<<1)>>1]=C[m+(G(o,s)+128>>8<<1)>>1],h=o+1|0,g[_+(h<<1)>>1]=C[m+(G(s,h)+128>>8<<1)>>1],o=o+2|0,!!o;);}if((f|0)>0)for(Q=F+258|0,h=0;;){for(o=h<<1,V=o+Q|0,N=o+_|0,I=M+(G(h,z)<<1)|0,o=0;;){s=o+1|0,R=G(s,B),X=R>>5,P=I+(o<<1)|0,o=R&31;w:{if(o){X=N+(X<<1)|0,o=(G(C[X+2>>1],32-o|0)+G(o,C[X+4>>1])|0)+16>>>5|0;break w}o=C[V+(X<<1)>>1]}if(g[P>>1]=o,o=s,(o|0)==(f|0))break}if(h=h+1|0,(h|0)==(f|0))break}if((E|0)!=10|f-32>>>0<4294967265|(k|w))break s;if(h=m-2|0,o=-1<<O^-1,s=0,(f|0)!=1)for(_=f&30,B=0;E=s<<1,z=E|2,w=C[h>>1]+(C[z+m>>1]-C[m>>1]>>1)|0,g[E+M>>1]=(w|0)>=0?(o|0)>(w|0)?w:o:0,s=s+2|0,w=C[h>>1]+(C[m+(s<<1)>>1]-C[m>>1]>>1)|0,g[M+z>>1]=(w|0)>=0?(o|0)>(w|0)?w:o:0,B=B+2|0,(_|0)!=(B|0););if(!(f&1))break s;w=C[h>>1],h=s<<1,s=w+(C[(h+m|0)+2>>1]-C[m>>1]>>1)|0,g[h+M>>1]=(s|0)>=0?(o|0)>(s|0)?s:o:0}v=F+528|0;break l}break k}}v=S+528|0;break f}M=o+(e+s|0)|0,h=0,O=v-272|0,v=O,B=v-336|0,v=B,i[B+24>>2]=k,i[B+16>>2]=F,i[B+32>>2]=r,i[B+28>>2]=e,m=O+128|0,i[B+12>>2]=m,i[B+20>>2]=f;o:{if((f|0)<65){i[B+316>>2]=16843009,w=B+12|0,tn(w);l:{if(i[w+8>>2]<33){if(s=i[w+4>>2],o=i[w+12>>2],X=i[s+(o?44:40)>>2],_=i[w+24>>2],Q=i[_+16936>>2],Q=i[(i[i[w+28>>2]+8496>>2]+(G(i[w+296>>2],i[w+16>>2])>>Q<<2)|0)+(G(i[_+16924>>2],G(i[w+300>>2],i[w+20>>2])>>Q)<<2)>>2],V=i[(s+(o<<2)|0)+4>>2],o=i[w+308>>2],!(l[w+304|0]!=1|(o|0)<=0))for(_=V-1|0,o=o-1|0;;){s=o;s:{if(l[w+304|0]!=1)break s;S=i[w+28>>2],R=i[w+16>>2],I=G(i[w+296>>2],R-1|0),N=i[w+24>>2],P=i[N+16936>>2],a=o+i[w+20>>2]|0,$=G(a,i[w+300>>2]),N=i[(i[S+8496>>2]+(I>>P<<2)|0)+(G(i[N+16924>>2],$>>P)<<2)>>2];w:{if(l[S+24|0]){if(S=I,o=i[w+4>>2],I=i[o+168>>2],S=S>>I,(S|0)<0||(P=i[o+172>>2],(P|0)<=(S|0)))break e;if(I=$>>I,(I|0)<0|(I|0)>=i[o+176>>2])break i;if(l[((i[o+160>>2]+G(S,3)|0)+G(G(I,P),3)|0)+1|0]&3)break s;if((Q|0)>=(N|0))break w;break s}if((Q|0)<(N|0))break s}i[w+316>>2]||(u[w+320|0]=l[(_+R|0)+G(X,a)|0]),o=s^-1,u[o+i[w+292>>2]|0]=1,u[o+i[w>>2]|0]=l[(_+i[w+16>>2]|0)+G(X,s+i[w+20>>2]|0)|0],u[i[w+292>>2]-s|0]=1,u[i[w>>2]-s|0]=l[(_+i[w+16>>2]|0)+G(X,(s+i[w+20>>2]|0)-1|0)|0],o=1-s|0,u[o+i[w+292>>2]|0]=1,u[o+i[w>>2]|0]=l[(_+i[w+16>>2]|0)+G(X,(s+i[w+20>>2]|0)-2|0)|0],o=2-s|0,u[o+i[w+292>>2]|0]=1,u[o+i[w>>2]|0]=l[(_+i[w+16>>2]|0)+G(X,(s+i[w+20>>2]|0)-3|0)|0],i[w+316>>2]=i[w+316>>2]+4}if(o=s-4|0,!((s|0)>3))break}s:{if(!l[w+307|0])break s;o=i[w+28>>2],s=i[w+16>>2],N=G(i[w+296>>2],s-1|0),_=i[w+24>>2],S=i[_+16936>>2],I=i[w+20>>2]-1|0,R=G(I,i[w+300>>2]),_=i[(i[o+8496>>2]+(N>>S<<2)|0)+(G(i[_+16924>>2],R>>S)<<2)>>2];w:{if(l[o+24|0]){if(o=i[w+4>>2],S=i[o+168>>2],N=N>>S,(N|0)<0||(P=i[o+172>>2],(P|0)<=(N|0)))break e;if(S=R>>S,(S|0)<0|(S|0)>=i[o+176>>2])break i;if(l[((i[o+160>>2]+G(N,3)|0)+G(G(S,P),3)|0)+1|0]&3)break s;if((_|0)<=(Q|0))break w;break s}if((_|0)>(Q|0))break s}o=G(X,I),i[w+316>>2]||(u[w+320|0]=l[(o+(s+V|0)|0)-1|0]),u[i[w>>2]]=l[(o+(s+V|0)|0)-1|0],u[i[w+292>>2]]=1,i[w+316>>2]=i[w+316>>2]+1}if(o=i[w+312>>2],(o|0)>0)for(_=0;;){s:{if(l[w+(i[w+8>>2]>(_|0)?305:306)|0]!=1)break s;s=i[w+28>>2],N=i[w+16>>2],I=G(i[w+296>>2],N+_|0),S=i[w+24>>2],R=i[S+16936>>2],P=i[w+20>>2]-1|0,a=G(P,i[w+300>>2]),S=i[(i[s+8496>>2]+(I>>R<<2)|0)+(G(i[S+16924>>2],a>>R)<<2)>>2];w:{if(l[s+24|0]){if(s=i[w+4>>2],R=i[s+168>>2],I=I>>R,(I|0)<0||($=i[s+172>>2],($|0)<=(I|0)))break e;if(R=a>>R,(R|0)<0|(R|0)>=i[s+176>>2])break i;if(l[((i[s+160>>2]+G(I,3)|0)+G(G(R,$),3)|0)+1|0]&3)break s;if((Q|0)>=(S|0))break w;break s}if((Q|0)<(S|0))break s}s=G(X,P),i[w+316>>2]||(u[w+320|0]=l[s+((V+N|0)+_|0)|0]),S=_|1,o=_+V|0,u[S+i[w>>2]|0]=l[s+(o+N|0)|0],u[S+i[w+292>>2]|0]=1,s=_|2,u[s+i[w>>2]|0]=l[((o+i[w+16>>2]|0)+G(X,i[w+20>>2]-1|0)|0)+1|0],u[s+i[w+292>>2]|0]=1,s=_|3,u[s+i[w>>2]|0]=l[((o+i[w+16>>2]|0)+G(X,i[w+20>>2]-1|0)|0)+2|0],u[s+i[w+292>>2]|0]=1,s=_+4|0,u[s+i[w>>2]|0]=l[((o+i[w+16>>2]|0)+G(X,i[w+20>>2]-1|0)|0)+3|0],u[s+i[w+292>>2]|0]=1,i[w+316>>2]=i[w+316>>2]+4,o=i[w+312>>2]}if(_=_+4|0,!((_|0)<(o|0)))break}break l}break u}w=i[B+328>>2],o=i[B+20>>2],s=o<<2|1;l:{if((w|0)==(s|0))break l;if(!w){if(!s)break l;o0(i[B+12>>2]-(o<<1)|0,1<<i[i[i[B+16>>2]+124>>2]+(i[B+24>>2]?16840:16832)>>2]-1,s);break l}if(s=o<<1,_=0-s|0,l[i[B+304>>2]-s|0]||(u[i[B+12>>2]+_|0]=l[B+332|0],o=i[B+20>>2],_=0-(o<<1)|0),o<<1<=(_|0))break l;for(_=_|1;l[i[B+304>>2]+_|0]||(o=i[B+12>>2]+_|0,u[o|0]=l[o-1|0],o=i[B+20>>2]),s=o<<1>(_|0),_=_+1|0,!!s;);}v=B+336|0;break o}break t}o=i[F+124>>2];o:{if(l[o+16825|0]||k&&(h=k,i[o+16848>>2]!=3))break o;w=v-144|0,v=w;l:{if((f|0)==4|(E|0)==1)break l;s=(E|0)<26?26-E|0:E-26|0,_=(E|0)<10?10-E|0:E-10|0,s=(s|0)<(_|0)?s:_;s:{w:switch(k2(f-8|0,29)|0){case 1:if((s|0)<=1)break l;break s;case 3:if((s|0)>0)break s;break l;case 7:break l;case 0:break w;default:break n}if((s|0)<8)break l}s:{w:{_:{if(!(!l[o+8997|0]|(h|(f|0)!=32))&&(h=l[m+64|0],s=l[m|0],B=(h+s|0)-(l[m+32|0]<<1)|0,_=B>>31,X=1<<i[o+512>>2]-5,(X|0)>((_^B)-_|0)))break _;o=w- -64|0;break w}if(o=w- -64|0,_=l[m+-64|0],Q=(_+s|0)-(l[m-32|0]<<1)|0,B=Q>>31,X>>>0<=(B^Q)-B>>>0)break w;for(u[w+128|0]=h,u[w|0]=_,u[w+64|0]=s,B=h-s|0,X=_-s|0,h=1;;)if(u[o-h|0]=s+(G(h,X)+32>>>6|0),u[o+h|0]=s+(G(h,B)+32>>>6|0),_=h+1|0,(_|0)==64){B=-64;break s}else{u[(h^-1)+o|0]=s+(G(_,X)+32>>>6|0),u[o+_|0]=s+(G(_,B)+32>>>6|0),h=h+2|0;continue}}if(_=w- -64|0,s=f<<1,u[_-s|0]=l[m-s|0],u[s+_|0]=l[s+m|0],B=0-s|0,Q=1-s|0,(Q|0)>=(s|0))break s;for(V=m-1|0,h=2-s|0,X=l[m+h|0],u[_+Q|0]=(l[V+Q|0]+(X+(l[m+Q|0]<<1)|0)|0)+2>>>2;I=X<<1,X=h+1|0,Q=l[X+m|0],u[h+_|0]=(l[h+V|0]+(I+Q|0)|0)+2>>>2,I=_+X|0,R=l[h+m|0],h=h+2|0,X=l[m+h|0],u[I|0]=(R+(X+(Q<<1)|0)|0)+2>>>2,(s|0)!=(h|0););}if(s=f<<2|1,!s)break l;x(m+B|0,o+B|0,s)}v=w+144|0}o:{l:switch(E|0){case 0:s:{if((f|0)>=2){for(s=0,o=f;h=s,s=s+1|0,w=o>>>0>3,o=o>>>1|0,!!w;);w=h+2|0;break s}if(w=1,(f|0)!=1)break o}for(N=f&-2,S=f&1,h=f-1|0,I=l[m+(f^-1)|0],_=l[(f+m|0)+1|0],o=0;;){if(E=h-o|0,s=o+1|0,F=G(s,I),X=M+G(o,z)|0,Q=l[m+(o^-1)|0],o=0,B=0,(f|0)!=1)for(;V=o|1,u[o+X|0]=F+(((G(Q,h-o|0)+f|0)+G(V,_)|0)+G(E,l[m+V|0])|0)>>w,o=o+2|0,u[X+V|0]=F+(((G(Q,h-V|0)+f|0)+G(_,o)|0)+G(E,l[o+m|0])|0)>>w,B=B+2|0,(N|0)!=(B|0););if(S&&(V=o+X|0,R=G(Q,h-o|0)+f|0,o=o+1|0,u[V|0]=F+((R+G(o,_)|0)+G(E,l[o+m|0])|0)>>w),o=s,(o|0)==(f|0))break}break o;case 1:s=0,h=0;s:{w:{if((f|0)>=2){for(o=f;h=s,s=s+1|0,w=o>>>0>3,o=o>>>1|0,!!w;);_=h+2|0;break w}if(_=1,(f|0)!=1)break s}h=1,E=f&1;w:{if((f|0)==1){w=0,s=0;break w}for(F=m+1|0,X=f&-2,o=0,s=0,B=0;w=o+2|0,s=l[m+(o^-2)|0]+(l[m+w|0]+(l[m+(o^-1)|0]+(l[o+F|0]+s|0)|0)|0)|0,o=w,B=B+2|0,(X|0)!=(B|0););}if(!E)break s;s=l[m+(w^-1)|0]+(l[(w+m|0)+1|0]+s|0)|0}s=f+s>>_;s:{if(!(!k&(f|0)<=31)){if(!h)break s;if(w=0,o=0,f-1>>>0>=3)for(m=f&-4,B=0;h=!f,h||o0(M+G(o,z)|0,s,f),h||o0(M+G(z,o|1)|0,s,f),h||o0(M+G(z,o|2)|0,s,f),h||o0(M+G(z,o|3)|0,s,f),o=o+4|0,B=B+4|0,(m|0)!=(B|0););if(h=f&3,!h)break s;for(;f&&o0(M+G(o,z)|0,s,f),o=o+1|0,w=w+1|0,(h|0)!=(w|0););break s}if(o=1,u[M|0]=(l[m+1|0]+(l[m-1|0]+(s<<1)|0)|0)+2>>>2,(f|0)<2)break s;if(w=f-1|0,_=w&3,h=G(s,3)+2|0,E=f-2|0,E>>>0>=3)for(F=w&-4,B=0;X=o+1|0,u[o+M|0]=h+l[X+m|0]>>>2,I=X+M|0,X=o+2|0,u[I|0]=h+l[X+m|0]>>>2,I=X+M|0,X=o+3|0,u[I|0]=h+l[X+m|0]>>>2,o=o+4|0,u[X+M|0]=h+l[m+o|0]>>>2,B=B+4|0,(F|0)!=(B|0););if(_)for(B=0;I=o+M|0,o=o+1|0,u[I|0]=h+l[m+o|0]>>>2,B=B+1|0,(_|0)!=(B|0););if(o=1,h=G(s,3)+2|0,E)for(_=w&-2,B=0;u[M+G(o,z)|0]=h+l[m+(o^-1)|0]>>>2,u[M+G(z,o+1|0)|0]=h+l[(m-o|0)-2|0]>>>2,o=o+2|0,B=B+2|0,(_|0)!=(B|0););if(w&1&&(u[M+G(o,z)|0]=h+l[m+(o^-1)|0]>>>2),h=f-1|0,m=(M+z|0)+1|0,_=0,o=0,E>>>0>=3)for(F=w&-4,B=0;E=!h,E||o0(m+G(o,z)|0,s,h),E||o0(m+G(z,o|1)|0,s,h),E||o0(m+G(z,o|2)|0,s,h),E||o0(m+G(z,o|3)|0,s,h),o=o+4|0,B=B+4|0,(F|0)!=(B|0););if(w=w&3,!w)break s;for(;h&&o0(m+G(o,z)|0,s,h),o=o+1|0,_=_+1|0,(w|0)!=(_|0););}break o;default:break l}if(o=i[F+124>>2],N=i[o+(k?16840:16832)>>2],l[o+16822|0]){if(s=i[F+168>>2],o=e>>s,(o|0)<0||(h=i[F+172>>2],(h|0)<=(o|0)))break e;if(s=r>>s,(s|0)<0|(s|0)>=i[F+176>>2])break i;w=(l[((i[F+160>>2]+G(o,3)|0)+G(G(s,h),3)|0)+1|0]&8)>>>3|0}else w=0;o=0,F=v-272|0,v=F;l:{if((E|0)<35){if((E|0)<=1)break A;_=F+128|0,B=i[(E<<2)+63120>>2];s:{w:{_:{if(E>>>0<=17){h:{if((f|0)<0)break h;if(s=f+1|0,h=s&3,f>>>0>=3)for(X=s&-4,s=0;u[o+_|0]=l[m-o|0],Q=o|1,u[Q+_|0]=l[m-Q|0],Q=o|2,u[Q+_|0]=l[m-Q|0],Q=o|3,u[Q+_|0]=l[m-Q|0],o=o+4|0,s=s+4|0,(X|0)!=(s|0););if(!h)break h;for(s=0;u[o+_|0]=l[m-o|0],o=o+1|0,s=s+1|0,(h|0)!=(s|0););}if(s=E-11|0,s>>>0<15)break _;if(X=f<<1,(X|0)<=(f|0))break w;if(o=f,Q=o&3,Q)for(h=0,s=o;o=s+1|0,u[_+o|0]=l[m+(s^-1)|0],s=o,h=h+1|0,(Q|0)!=(h|0););if(f-1>>>0<3)break w;for(h=_+3|0,Q=_+2|0,V=_+1|0;u[o+V|0]=l[m+(o^-1)|0],s=m-o|0,u[o+Q|0]=l[s-2|0],u[o+h|0]=l[s-3|0],o=o+4|0,u[_+o|0]=l[s-4|0],(o|0)!=(X|0););break w}h:{if((f|0)<0||(o=f+1|0,!o))break h;x(_,m,o)}s=E-11|0;h:{if(s>>>0>=15){if(!f|f<<1<=(f|0))break h;x((f+F|0)+129|0,(f+m|0)+1|0,f);break h}if(h=G(f,B),o=h>>5,(o|0)>-2)break h;for(s=i[(s<<2)+63264>>2],h&32&&(u[o+_|0]=l[m-(G(o,s)+128>>8)|0],o=o+1|0);u[o+_|0]=l[m-(G(o,s)+128>>8)|0],h=o+1|0,u[h+_|0]=l[m-(G(s,h)+128>>8)|0],o=o+2|0,!!o;);}if((f|0)>0)for(R=F+129|0,P=f&2147483646,a=f&1,s=0;;){h=M+G(s,z)|0,s=s+1|0,X=G(B,s),o=X>>5,X=X&31;h:{if(X){if(Q=o+_|0,V=32-X|0,o=0,(f|0)!=1)for($=Q+2|0,S=0;f0=o+Q|0,I=l[f0+2|0],u[o+h|0]=(G(V,l[f0+1|0])+G(X,I)|0)+16>>>5,f0=o|1,u[f0+h|0]=(G(V,I)+G(X,l[$+f0|0])|0)+16>>>5,o=o+2|0,S=S+2|0,(P|0)!=(S|0););if(!a)break h;h=o+h|0,o=o+Q|0,u[h|0]=(G(V,l[o+1|0])+G(X,l[o+2|0])|0)+16>>>5;break h}if(!f)break h;x(h,o+R|0,f)}if((f|0)==(s|0))break}if((E|0)!=26|f-32>>>0<4294967265|(k|w))break s;for(s=-1<<N^-1,o=0;h=l[m+1|0]+(l[m+(o^-1)|0]-l[m|0]>>1)|0,u[M+G(o,z)|0]=(h|0)>=0?(s|0)>(h|0)?h:s:0,o=o+1|0,(o|0)!=(f|0););break s}if(h=G(f,B),o=h>>5,(o|0)>-2)break w;for(s=i[(s<<2)+63264>>2],h&32&&(u[o+_|0]=l[m+(G(o,s)+128>>8)|0],o=o+1|0);u[o+_|0]=l[m+(G(o,s)+128>>8)|0],h=o+1|0,u[h+_|0]=l[m+(G(s,h)+128>>8)|0],o=o+2|0,!!o;);}if((f|0)>0)for(Q=F+129|0,h=0;;){for(V=h+Q|0,S=h+_|0,I=M+G(h,z)|0,o=0;;){s=o+1|0,R=G(s,B),X=R>>5,P=o+I|0,o=R&31;w:{if(o){X=X+S|0,o=(G(l[X+1|0],32-o|0)+G(o,l[X+2|0])|0)+16>>>5|0;break w}o=l[X+V|0]}if(u[P|0]=o,o=s,(o|0)==(f|0))break}if(h=h+1|0,(h|0)==(f|0))break}if((E|0)!=10|f-32>>>0<4294967265|(k|w))break s;if(h=m-1|0,s=-1<<N^-1,o=0,(f|0)!=1)for(_=f&30,B=0;E=o|1,w=l[h|0]+(l[E+m|0]-l[m|0]>>1)|0,u[o+M|0]=(w|0)>=0?(s|0)>(w|0)?w:s:0,o=o+2|0,w=l[h|0]+(l[m+o|0]-l[m|0]>>1)|0,u[E+M|0]=(w|0)>=0?(s|0)>(w|0)?w:s:0,B=B+2|0,(_|0)!=(B|0););if(!(f&1))break s;w=o+M|0,o=l[h|0]+(l[(o+m|0)+1|0]-l[m|0]>>1)|0,u[w|0]=(o|0)>=0?(o|0)<(s|0)?o:s:0}v=F+272|0;break l}break k}}v=O+272|0;break f}D0(21583,10923,533,14233),H()}D0(19662,10923,146,3881),H()}D0(12200,10923,211,11160),H()}D0(21274,10923,342,7633),H()}D0(21491,10923,343,7633),H()}o=0,o=!l[A0+16822|0]|!(l[A+32|0]|l[(A+k|0)+33|0])?o:(n0&47)==10,o=(n0|0)==26?o&&2:o;break r}if(o=0,!l[A+36|0])break r;o=l[A+37|0]?2:1}r:{f:{A:{k:{if(!t){if(!k|!i[A+28>>2])break k;g[((k<<1)+A|0)+14396>>1]=0,o=0}X=l[(A+k|0)+33|0]!=0,h=!n,n=k?16840:16832;n:{if(i[n+i[i[A+18588>>2]+124>>2]>>2]>=9){t=A,M=v-4096|0,v=M;t:{if(k>>>0<3){if(s=i[A+18588>>2],m=i[s+168>>2],w=e>>m,(w|0)<0||(F=i[s+172>>2],(F|0)<=(w|0)))break e;if(_=r>>m,(_|0)<0|(_|0)>=i[s+176>>2])break i;Q=k<<2,E=i[s+(k?44:40)>>2],z=i[(Q+s|0)+4>>2]+(G(E,r)+e<<1)|0,B=i[s+124>>2],m=i[B+n>>2],n=i[A+2104>>2],e=0,V=l[((i[s+160>>2]+G(w,3)|0)+G(G(_,F),3)|0)+1|0]&3,F=!V&(f|0)==4&l[B+16820|0]!=0;u:{if(l[A+32|0]){if(A=A+(k<<1)|0,g[A+14396>>1]>0)for(e=A+14396|0,A=0,r=k<<11,s=r+(t+8252|0)|0,r=r+(t+2108|0)|0;h=A<<1,g[n+(g[h+s>>1]<<1)>>1]=C[r+h>>1],A=A+1|0,(A|0)<g[e>>1];);if(F&&W[i[i[t+18584>>2]+432>>2]](n,4),h=t+14404|0,s=k?M:h,W[i[i[t+18584>>2]+(o?(o|0)==2?368:372:364)>>2]](s,n,f),!(!k|!i[t+28>>2]|(f|0)<=0))for(A=i[i[t+18588>>2]+124>>2],o=i[A+16832>>2],w=i[A+16840>>2],X=f&2147483646,Q=f&1,r=0;;){if(_=G(r,f),A=0,e=0,(f|0)!=1)for(;B=A+_<<2,V=B+s|0,i[V>>2]=i[V>>2]+(G(i[t+28>>2],i[h+B>>2]<<w>>o)>>3),B=B+4|0,V=B+s|0,i[V>>2]=i[V>>2]+(G(i[t+28>>2],i[h+B>>2]<<w>>o)>>3),A=A+2|0,e=e+2|0,(X|0)!=(e|0););if(Q&&(A=A+_<<2,e=A+s|0,i[e>>2]=i[e>>2]+(G(i[t+28>>2],i[A+h>>2]<<w>>o)>>3)),r=r+1|0,(f|0)==(r|0))break}if(W[i[i[t+18584>>2]+460>>2]](z,E,s,f,m),!F)break u;g[n>>1]=0,g[n+2>>1]=0,g[n+4>>1]=0,g[n+6>>1]=0,g[n+24>>1]=0,g[n+26>>1]=0,g[n+28>>1]=0,g[n+30>>1]=0,g[n+16>>1]=0,g[n+18>>1]=0,g[n+20>>1]=0,g[n+22>>1]=0,g[n+8>>1]=0,g[n+10>>1]=0,g[n+12>>1]=0,g[n+14>>1]=0;break u}if((f|0)>=2)for(A=f;e=e+1|0,r=A>>>0>3,A=A>>>1|0,!!r;);_=i[s+132>>2],r=i[(t+Q|0)+18536>>2],e=e+m|0;o:{if(!l[B+636|0]){if(A=t+(k<<1)|0,g[A+14396>>1]<=0)break o;for(r=i[((r|0)%6<<2)+63856>>2]<<(r|0)/6,s=e-9|0,h=1<<e-10,w=A+14396|0,A=0,e=k<<11,B=e+(t+2108|0)|0,Q=e+(t+8252|0)|0;O=A<<1,e=h+G(r,g[O+B>>1])>>s,e=(e|0)>=32767?32767:e,g[n+(g[Q+O>>1]<<1)>>1]=(e|0)<=-32768?-32768:e,A=A+1|0,(A|0)<g[w>>1];);break o}A=k,s=A;l:{if(h||(s=A+3|0,(f|0)<=31))break l;s=A+1|0}A=s;l:{s:switch(k2(f-4|0,30)|0){case 1:A=(_+(A<<6)|0)+169|0;break l;case 3:A=(_+(A<<8)|0)+553|0;break l;case 7:A=(_+(A<<10)|0)+2089|0;break l;case 0:break s;default:break A}A=(_+(A<<4)|0)+73|0}if(s=t+(k<<1)|0,g[s+14396>>1]<=0)break o;for(w=A,Q=s+14396|0,O=(r|0)/6|0,A0=i[(r-G(O,6)<<2)+63856>>2],s=e-5|0,h=1<<e-6,N=h>>31,A=0,e=k<<11,n0=e+(t+2108|0)|0,S=e+(t+8252|0)|0;e=A<<1,r=g[e+S>>1],I=n+(r<<1)|0,e=g[e+n0>>1],R=e,P=e>>31,e=G(A0,l[r+w|0])<<O,e=O0(R,P,e,e>>31),r=N+l0|0,e=e+h|0,r=e>>>0<h>>>0?r+1|0:r,R=e,B=s&31,(s&63)>>>0>=32?(e=r>>31,r=r>>B):(e=r>>B,r=((1<<B)-1&r)<<32-B|R>>>B),B=(e|0)>=0&r>>>0>=32767|(e|0)>0,r=B?32767:r,e=B?0:e,(e|0)<-1?e=1:e=(e|0)<0&r>>>0<=4294934528,g[I>>1]=e?-32768:r,A=A+1|0,(A|0)<g[Q>>1];);}if(X){if(A=5,(f|0)>=2){for(e=0,A=f;r=e,e=e+1|0,s=A>>>0>3,A=A>>>1|0,!!s;);A=r+6|0}if(F&&W[i[i[t+18584>>2]+432>>2]](n,4),h=t+14404|0,s=k?M:h,W[i[i[t+18584>>2]+(o?(o|0)==2?464:468:472)>>2]](s,n,f,A,(m|0)<20?20-m|0:0),!(!k|!i[t+28>>2]|(f|0)<=0))for(A=i[i[t+18588>>2]+124>>2],o=i[A+16832>>2],w=i[A+16840>>2],X=f&2147483646,Q=f&1,r=0;;){if(_=G(r,f),A=0,e=0,(f|0)!=1)for(;B=A+_<<2,V=B+s|0,i[V>>2]=i[V>>2]+(G(i[t+28>>2],i[h+B>>2]<<w>>o)>>3),B=B+4|0,V=B+s|0,i[V>>2]=i[V>>2]+(G(i[t+28>>2],i[h+B>>2]<<w>>o)>>3),A=A+2|0,e=e+2|0,(X|0)!=(e|0););if(Q&&(A=A+_<<2,e=A+s|0,i[e>>2]=i[e>>2]+(G(i[t+28>>2],i[A+h>>2]<<w>>o)>>3)),r=r+1|0,(f|0)==(r|0))break}if(W[i[i[t+18584>>2]+460>>2]](z,E,s,f,m),!F)break u;g[n>>1]=0,g[n+2>>1]=0,g[n+4>>1]=0,g[n+6>>1]=0,g[n+24>>1]=0,g[n+26>>1]=0,g[n+28>>1]=0,g[n+30>>1]=0,g[n+16>>1]=0,g[n+18>>1]=0,g[n+20>>1]=0,g[n+22>>1]=0,g[n+8>>1]=0,g[n+10>>1]=0,g[n+12>>1]=0,g[n+14>>1]=0;break u}if(o)break t;if(e=!(k|V)&(f|0)==4,l[_+8247|0]==1){r=0,h=v-4096|0,v=h,s=20-m|0,o=t+14404|0,A=k?h:o,w=i[t+18584>>2];o:{if(e){e=436;break o}e=440;l:switch(f-4|0){case 4:e=444;break o;case 12:e=448;break o;case 0:break o;default:break l}e=452}if(W[i[e+w>>2]](A,n,s,15),!(!k|!i[t+28>>2]|(f|0)<=0))for(e=i[i[t+18588>>2]+124>>2],n=i[e+16832>>2],s=i[e+16840>>2],X=f&2147483646,Q=f&1;;){if(B=G(r,f),e=0,_=0,(f|0)!=1)for(;F=e+B<<2,V=F+A|0,i[V>>2]=i[V>>2]+(G(i[t+28>>2],i[o+F>>2]<<s>>n)>>3),F=F+4|0,V=F+A|0,i[V>>2]=i[V>>2]+(G(i[t+28>>2],i[o+F>>2]<<s>>n)>>3),e=e+2|0,_=_+2|0,(X|0)!=(_|0););if(Q&&(e=e+B<<2,_=e+A|0,i[_>>2]=i[_>>2]+(G(i[t+28>>2],i[e+o>>2]<<s>>n)>>3)),r=r+1|0,(f|0)==(r|0))break}W[i[w+460>>2]](z,E,A,f,m),v=h+4096|0;break u}r=i[t+18584>>2]+172|0;o:{if(e){A=240;break o}A=244;l:switch(f-4|0){case 4:A=248;break o;case 12:A=252;break o;case 0:break o;default:break l}A=256}W[i[A+r>>2]](z,n,E,m)}if(A=t+(k<<1)|0,g[A+14396>>1]>0)for(e=A+14396|0,r=i[t+2104>>2],f=(t+8252|0)+(k<<11)|0,A=0;g[r+(g[f+(A<<1)>>1]<<1)>>1]=0,A=A+1|0,(A|0)<g[e>>1];);v=M+4096|0;break n}break f}break r}t=A,F=v-4096|0,v=F;t:{if(k>>>0<3){if(s=i[A+18588>>2],n=i[s+168>>2],w=e>>n,(w|0)<0||(_=i[s+172>>2],(_|0)<=(w|0)))break e;if(m=r>>n,(m|0)<0|(m|0)>=i[s+176>>2])break i;M=k<<2,B=i[s+(k?44:40)>>2],E=(i[(M+s|0)+4>>2]+e|0)+G(B,r)|0,n=i[A+2104>>2],e=0,Q=l[((i[s+160>>2]+G(w,3)|0)+G(G(_,m),3)|0)+1|0]&3,w=i[s+124>>2],z=!Q&(f|0)==4&l[w+16820|0]!=0;u:{if(l[A+32|0]){if(A=A+(k<<1)|0,g[A+14396>>1]>0)for(e=A+14396|0,A=0,r=k<<11,s=r+(t+8252|0)|0,r=r+(t+2108|0)|0;h=A<<1,g[n+(g[h+s>>1]<<1)>>1]=C[r+h>>1],A=A+1|0,(A|0)<g[e>>1];);if(z&&W[i[i[t+18584>>2]+432>>2]](n,4),h=t+14404|0,s=k?F:h,W[i[i[t+18584>>2]+(o?(o|0)==2?368:372:364)>>2]](s,n,f),!(!k|!i[t+28>>2]|(f|0)<=0))for(A=i[i[t+18588>>2]+124>>2],o=i[A+16832>>2],w=i[A+16840>>2],M=f&2147483646,X=f&1,r=0;;){if(m=G(r,f),A=0,e=0,(f|0)!=1)for(;_=A+m<<2,Q=_+s|0,i[Q>>2]=i[Q>>2]+(G(i[t+28>>2],i[h+_>>2]<<w>>o)>>3),_=_+4|0,Q=_+s|0,i[Q>>2]=i[Q>>2]+(G(i[t+28>>2],i[h+_>>2]<<w>>o)>>3),A=A+2|0,e=e+2|0,(M|0)!=(e|0););if(X&&(A=A+m<<2,e=A+s|0,i[e>>2]=i[e>>2]+(G(i[t+28>>2],i[A+h>>2]<<w>>o)>>3)),r=r+1|0,(f|0)==(r|0))break}if(W[i[i[t+18584>>2]+456>>2]](E,B,s,f,8),!z)break u;g[n>>1]=0,g[n+2>>1]=0,g[n+4>>1]=0,g[n+6>>1]=0,g[n+24>>1]=0,g[n+26>>1]=0,g[n+28>>1]=0,g[n+30>>1]=0,g[n+16>>1]=0,g[n+18>>1]=0,g[n+20>>1]=0,g[n+22>>1]=0,g[n+8>>1]=0,g[n+10>>1]=0,g[n+12>>1]=0,g[n+14>>1]=0;break u}if(_=i[w+(k?16840:16832)>>2],(f|0)>=2)for(A=f;e=e+1|0,r=A>>>0>3,A=A>>>1|0,!!r;);m=i[s+132>>2],r=i[(t+M|0)+18536>>2],e=e+_|0;o:{if(!l[w+636|0]){if(A=t+(k<<1)|0,g[A+14396>>1]<=0)break o;for(r=i[((r|0)%6<<2)+63856>>2]<<(r|0)/6,s=e-9|0,h=1<<e-10,w=A+14396|0,A=0,e=k<<11,_=e+(t+2108|0)|0,M=e+(t+8252|0)|0;V=A<<1,e=h+G(r,g[V+_>>1])>>s,e=(e|0)>=32767?32767:e,g[n+(g[V+M>>1]<<1)>>1]=(e|0)<=-32768?-32768:e,A=A+1|0,(A|0)<g[w>>1];);break o}A=k,s=A;l:{if(h||(s=A+3|0,(f|0)<=31))break l;s=A+1|0}A=s;l:{s:switch(k2(f-4|0,30)|0){case 1:A=(m+(A<<6)|0)+169|0;break l;case 3:A=(m+(A<<8)|0)+553|0;break l;case 7:A=(m+(A<<10)|0)+2089|0;break l;case 0:break s;default:break A}A=(m+(A<<4)|0)+73|0}if(s=t+(k<<1)|0,g[s+14396>>1]<=0)break o;for(w=A,M=s+14396|0,V=(r|0)/6|0,O=i[(r-G(V,6)<<2)+63856>>2],s=e-5|0,h=1<<e-6,A0=h>>31,A=0,e=k<<11,N=e+(t+2108|0)|0,n0=e+(t+8252|0)|0;e=A<<1,r=g[e+n0>>1],S=n+(r<<1)|0,e=g[e+N>>1],I=e,R=e>>31,e=G(O,l[r+w|0])<<V,e=O0(I,R,e,e>>31),r=A0+l0|0,e=e+h|0,r=e>>>0<h>>>0?r+1|0:r,I=e,_=s&31,(s&63)>>>0>=32?(e=r>>31,r=r>>_):(e=r>>_,r=((1<<_)-1&r)<<32-_|I>>>_),_=(e|0)>=0&r>>>0>=32767|(e|0)>0,r=_?32767:r,e=_?0:e,(e|0)<-1?e=1:e=(e|0)<0&r>>>0<=4294934528,g[S>>1]=e?-32768:r,A=A+1|0,(A|0)<g[M>>1];);}if(X){if(A=5,(f|0)>=2){for(e=0,A=f;r=e,e=e+1|0,s=A>>>0>3,A=A>>>1|0,!!s;);A=r+6|0}if(z&&W[i[i[t+18584>>2]+432>>2]](n,4),h=t+14404|0,s=k?F:h,W[i[i[t+18584>>2]+(o?(o|0)==2?464:468:472)>>2]](s,n,f,A,12),!(!k|!i[t+28>>2]|(f|0)<=0))for(A=i[i[t+18588>>2]+124>>2],o=i[A+16832>>2],w=i[A+16840>>2],M=f&2147483646,X=f&1,r=0;;){if(m=G(r,f),A=0,e=0,(f|0)!=1)for(;_=A+m<<2,Q=_+s|0,i[Q>>2]=i[Q>>2]+(G(i[t+28>>2],i[h+_>>2]<<w>>o)>>3),_=_+4|0,Q=_+s|0,i[Q>>2]=i[Q>>2]+(G(i[t+28>>2],i[h+_>>2]<<w>>o)>>3),A=A+2|0,e=e+2|0,(M|0)!=(e|0););if(X&&(A=A+m<<2,e=A+s|0,i[e>>2]=i[e>>2]+(G(i[t+28>>2],i[A+h>>2]<<w>>o)>>3)),r=r+1|0,(f|0)==(r|0))break}if(W[i[i[t+18584>>2]+456>>2]](E,B,s,f,8),!z)break u;g[n>>1]=0,g[n+2>>1]=0,g[n+4>>1]=0,g[n+6>>1]=0,g[n+24>>1]=0,g[n+26>>1]=0,g[n+28>>1]=0,g[n+30>>1]=0,g[n+16>>1]=0,g[n+18>>1]=0,g[n+20>>1]=0,g[n+22>>1]=0,g[n+8>>1]=0,g[n+10>>1]=0,g[n+12>>1]=0,g[n+14>>1]=0;break u}if(o)break r;if(e=!(k|Q)&(f|0)==4,l[m+8247|0]==1){r=0,h=v-4096|0,v=h,o=t+14404|0,A=k?h:o,w=i[t+18584>>2];o:{if(e){e=436;break o}e=440;l:switch(f-4|0){case 4:e=444;break o;case 12:e=448;break o;case 0:break o;default:break l}e=452}if(W[i[e+w>>2]](A,n,12,15),!(!k|!i[t+28>>2]|(f|0)<=0))for(e=i[i[t+18588>>2]+124>>2],n=i[e+16832>>2],s=i[e+16840>>2],M=f&2147483646,X=f&1;;){if(m=G(r,f),e=0,_=0,(f|0)!=1)for(;z=e+m<<2,Q=z+A|0,i[Q>>2]=i[Q>>2]+(G(i[t+28>>2],i[o+z>>2]<<s>>n)>>3),z=z+4|0,Q=z+A|0,i[Q>>2]=i[Q>>2]+(G(i[t+28>>2],i[o+z>>2]<<s>>n)>>3),e=e+2|0,_=_+2|0,(M|0)!=(_|0););if(X&&(e=e+m<<2,m=e+A|0,i[m>>2]=i[m>>2]+(G(i[t+28>>2],i[e+o>>2]<<s>>n)>>3)),r=r+1|0,(f|0)==(r|0))break}W[i[w+456>>2]](E,B,A,f,8),v=h+4096|0;break u}r=i[t+18584>>2]+172|0;o:{if(e){A=216;break o}A=220;l:switch(f-4|0){case 4:A=224;break o;case 12:A=228;break o;case 0:break o;default:break l}A=232}W[i[A+r>>2]](E,n,B)}if(A=t+(k<<1)|0,g[A+14396>>1]>0)for(e=A+14396|0,r=i[t+2104>>2],f=(t+8252|0)+(k<<11)|0,A=0;g[r+(g[f+(A<<1)>>1]<<1)>>1]=0,A=A+1|0,(A|0)<g[e>>1];);v=F+4096|0;break t}break f}}}return}D0(22181,18235,502,10128),H()}D0(22181,18235,377,10128),H()}D0(21973,18235,599,10128),H()}D0(4656,10893,118,4231),H()}D0(4618,10893,119,4231),H()}function wf(A,e,r){var f=0,k=0,n=0,t=0,o=0,s=0,w=0,h=0,_=0,B=0,m=0,X=0,Q=0,V=0,F=0,I=0,E=0,R=0,N=0,M=0;B=v-48|0,v=B,f=i[r>>2],k=i[r+4>>2],k&&(i[k+4>>2]=i[k+4>>2]+1),i[e+8>>2]=f,f=i[e+12>>2],i[e+12>>2]=k;i:{if(!f||(k=i[f+4>>2],i[f+4>>2]=k-1,k))break i;W[i[i[f>>2]+8>>2]](f),y(f)}if(i[B+24>>2]=0,i[B+28>>2]=0,i[B+40>>2]=0,i[B+32>>2]=0,i[B+36>>2]=0,V=i[e+156>>2],t=v-320|0,v=t,w=i[e>>2],k=i[w+16>>2],n=i[w+20>>2],(k|0)!=(n|0))for(;;){f=i[n-4>>2];i:{if(!f||(s=i[f+4>>2],i[f+4>>2]=s-1,s))break i;W[i[i[f>>2]+8>>2]](f),y(f)}if(n=n-8|0,(k|0)==(n|0))break}i[w+20>>2]=k,f=i[r>>2],k=i[r+4>>2],k&&(i[k+4>>2]=i[k+4>>2]+1),i[w+64>>2]=f,f=i[w+68>>2],i[w+68>>2]=k;i:{if(!f||(k=i[f+4>>2],i[f+4>>2]=k-1,k))break i;W[i[i[f>>2]+8>>2]](f),y(f)}f=i[r>>2],f=W[i[i[f>>2]+24>>2]](f,0,0,1024,0)|0,i[w+56>>2]=f,k=l0,i[w+60>>2]=k;i:{if(!k&f>>>0<=31){if(r=p(24),i[t+248>>2]=r,i[t+252>>2]=20,i[t+256>>2]=-2147483624,f=l[24594]|l[24595]<<8|(l[24596]<<16|l[24597]<<24),k=l[24590]|l[24591]<<8|(l[24592]<<16|l[24593]<<24),u[r|0]=k,u[r+1|0]=k>>>8,u[r+2|0]=k>>>16,u[r+3|0]=k>>>24,u[r+4|0]=f,u[r+5|0]=f>>>8,u[r+6|0]=f>>>16,u[r+7|0]=f>>>24,u[r+20|0]=0,f=l[24606]|l[24607]<<8|(l[24608]<<16|l[24609]<<24),u[r+16|0]=f,u[r+17|0]=f>>>8,u[r+18|0]=f>>>16,u[r+19|0]=f>>>24,f=l[24602]|l[24603]<<8|(l[24604]<<16|l[24605]<<24),k=l[24598]|l[24599]<<8|(l[24600]<<16|l[24601]<<24),u[r+8|0]=k,u[r+9|0]=k>>>8,u[r+10|0]=k>>>16,u[r+11|0]=k>>>24,u[r+12|0]=f,u[r+13|0]=f>>>8,u[r+14|0]=f>>>16,u[r+15|0]=f>>>24,q(B,2,0,t+248|0),u[t+259|0]>=0)break i;Z(i[t+248>>2]);break i}i[t+288>>2]=i[w+64>>2],k=i[w+68>>2],i[t+292>>2]=k,k&&(i[k+4>>2]=i[k+4>>2]+1,f=i[w+56>>2]),k=i[t+292>>2],i[t+32>>2]=i[t+288>>2],i[t+36>>2]=k,I=pe(t+296|0,t+32|0,f,0),Q=t+248|0,f=Q,i[f+8>>2]=0,i[f+12>>2]=0,i[f+16>>2]=0,i[f+20>>2]=0,i[f+24>>2]=0,i[f+28>>2]=0,i[f+32>>2]=0,i[f>>2]=86356,i[t+224>>2]=0,i[t+228>>2]=0,i[t+240>>2]=0,i[t+232>>2]=0,i[t+236>>2]=0,$6(t+112|0,f,I),k=i[t+116>>2],f=i[t+112>>2],i[t+224>>2]=f,i[t+228>>2]=k,u[t+243|0]<0&&(Z(i[t+232>>2]),f=i[t+224>>2]),k=i[t+124>>2],i[t+232>>2]=i[t+120>>2],i[t+236>>2]=k,i[t+240>>2]=i[t+128>>2];e:{if(f){r=i[t+228>>2],i[B>>2]=i[t+224>>2],i[B+4>>2]=r,i[B+16>>2]=i[t+240>>2],r=i[t+236>>2],i[B+8>>2]=i[t+232>>2],i[B+12>>2]=r,i[t+232>>2]=0,i[t+236>>2]=0,i[t+240>>2]=0;break e}if(i[Q+16>>2]!=1718909296){if(r=p(40),i[t+112>>2]=r,i[t+116>>2]=36,i[t+120>>2]=-2147483608,f=l[22913]|l[22914]<<8|(l[22915]<<16|l[22916]<<24),k=l[22909]|l[22910]<<8|(l[22911]<<16|l[22912]<<24),u[r|0]=k,u[r+1|0]=k>>>8,u[r+2|0]=k>>>16,u[r+3|0]=k>>>24,u[r+4|0]=f,u[r+5|0]=f>>>8,u[r+6|0]=f>>>16,u[r+7|0]=f>>>24,u[r+36|0]=0,f=l[22941]|l[22942]<<8|(l[22943]<<16|l[22944]<<24),u[r+32|0]=f,u[r+33|0]=f>>>8,u[r+34|0]=f>>>16,u[r+35|0]=f>>>24,f=l[22937]|l[22938]<<8|(l[22939]<<16|l[22940]<<24),k=l[22933]|l[22934]<<8|(l[22935]<<16|l[22936]<<24),u[r+24|0]=k,u[r+25|0]=k>>>8,u[r+26|0]=k>>>16,u[r+27|0]=k>>>24,u[r+28|0]=f,u[r+29|0]=f>>>8,u[r+30|0]=f>>>16,u[r+31|0]=f>>>24,f=l[22929]|l[22930]<<8|(l[22931]<<16|l[22932]<<24),k=l[22925]|l[22926]<<8|(l[22927]<<16|l[22928]<<24),u[r+16|0]=k,u[r+17|0]=k>>>8,u[r+18|0]=k>>>16,u[r+19|0]=k>>>24,u[r+20|0]=f,u[r+21|0]=f>>>8,u[r+22|0]=f>>>16,u[r+23|0]=f>>>24,f=l[22921]|l[22922]<<8|(l[22923]<<16|l[22924]<<24),k=l[22917]|l[22918]<<8|(l[22919]<<16|l[22920]<<24),u[r+8|0]=k,u[r+9|0]=k>>>8,u[r+10|0]=k>>>16,u[r+11|0]=k>>>24,u[r+12|0]=f,u[r+13|0]=f>>>8,u[r+14|0]=f>>>16,u[r+15|0]=f>>>24,q(B,2,102,t+112|0),u[t+123|0]>=0)break e;Z(i[t+112>>2]);break e}if(f=i[Q+12>>2],_=f,k=i[Q+8>>2],!(f|k)){if(r=p(48),i[t+112>>2]=r,i[t+116>>2]=46,i[t+120>>2]=-2147483600,f=l[13350]|l[13351]<<8|(l[13352]<<16|l[13353]<<24),k=l[13346]|l[13347]<<8|(l[13348]<<16|l[13349]<<24),u[r|0]=k,u[r+1|0]=k>>>8,u[r+2|0]=k>>>16,u[r+3|0]=k>>>24,u[r+4|0]=f,u[r+5|0]=f>>>8,u[r+6|0]=f>>>16,u[r+7|0]=f>>>24,u[r+46|0]=0,f=l[13388]|l[13389]<<8|(l[13390]<<16|l[13391]<<24),k=l[13384]|l[13385]<<8|(l[13386]<<16|l[13387]<<24),u[r+38|0]=k,u[r+39|0]=k>>>8,u[r+40|0]=k>>>16,u[r+41|0]=k>>>24,u[r+42|0]=f,u[r+43|0]=f>>>8,u[r+44|0]=f>>>16,u[r+45|0]=f>>>24,f=l[13382]|l[13383]<<8|(l[13384]<<16|l[13385]<<24),k=l[13378]|l[13379]<<8|(l[13380]<<16|l[13381]<<24),u[r+32|0]=k,u[r+33|0]=k>>>8,u[r+34|0]=k>>>16,u[r+35|0]=k>>>24,u[r+36|0]=f,u[r+37|0]=f>>>8,u[r+38|0]=f>>>16,u[r+39|0]=f>>>24,f=l[13374]|l[13375]<<8|(l[13376]<<16|l[13377]<<24),k=l[13370]|l[13371]<<8|(l[13372]<<16|l[13373]<<24),u[r+24|0]=k,u[r+25|0]=k>>>8,u[r+26|0]=k>>>16,u[r+27|0]=k>>>24,u[r+28|0]=f,u[r+29|0]=f>>>8,u[r+30|0]=f>>>16,u[r+31|0]=f>>>24,f=l[13366]|l[13367]<<8|(l[13368]<<16|l[13369]<<24),k=l[13362]|l[13363]<<8|(l[13364]<<16|l[13365]<<24),u[r+16|0]=k,u[r+17|0]=k>>>8,u[r+18|0]=k>>>16,u[r+19|0]=k>>>24,u[r+20|0]=f,u[r+21|0]=f>>>8,u[r+22|0]=f>>>16,u[r+23|0]=f>>>24,f=l[13358]|l[13359]<<8|(l[13360]<<16|l[13361]<<24),k=l[13354]|l[13355]<<8|(l[13356]<<16|l[13357]<<24),u[r+8|0]=k,u[r+9|0]=k>>>8,u[r+10|0]=k>>>16,u[r+11|0]=k>>>24,u[r+12|0]=f,u[r+13|0]=f>>>8,u[r+14|0]=f>>>16,u[r+15|0]=f>>>24,q(B,2,102,t+112|0),u[t+123|0]>=0)break e;Z(i[t+112>>2]);break e}if(s=i[w+60>>2],(_|0)==(s|0)&k>>>0>u0[w+56>>2]|s>>>0<_>>>0){if(r=p(40),i[t+112>>2]=r,i[t+116>>2]=39,i[t+120>>2]=-2147483608,f=l[14064]|l[14065]<<8|(l[14066]<<16|l[14067]<<24),k=l[14060]|l[14061]<<8|(l[14062]<<16|l[14063]<<24),u[r|0]=k,u[r+1|0]=k>>>8,u[r+2|0]=k>>>16,u[r+3|0]=k>>>24,u[r+4|0]=f,u[r+5|0]=f>>>8,u[r+6|0]=f>>>16,u[r+7|0]=f>>>24,u[r+39|0]=0,f=l[14095]|l[14096]<<8|(l[14097]<<16|l[14098]<<24),k=l[14091]|l[14092]<<8|(l[14093]<<16|l[14094]<<24),u[r+31|0]=k,u[r+32|0]=k>>>8,u[r+33|0]=k>>>16,u[r+34|0]=k>>>24,u[r+35|0]=f,u[r+36|0]=f>>>8,u[r+37|0]=f>>>16,u[r+38|0]=f>>>24,f=l[14088]|l[14089]<<8|(l[14090]<<16|l[14091]<<24),k=l[14084]|l[14085]<<8|(l[14086]<<16|l[14087]<<24),u[r+24|0]=k,u[r+25|0]=k>>>8,u[r+26|0]=k>>>16,u[r+27|0]=k>>>24,u[r+28|0]=f,u[r+29|0]=f>>>8,u[r+30|0]=f>>>16,u[r+31|0]=f>>>24,f=l[14080]|l[14081]<<8|(l[14082]<<16|l[14083]<<24),k=l[14076]|l[14077]<<8|(l[14078]<<16|l[14079]<<24),u[r+16|0]=k,u[r+17|0]=k>>>8,u[r+18|0]=k>>>16,u[r+19|0]=k>>>24,u[r+20|0]=f,u[r+21|0]=f>>>8,u[r+22|0]=f>>>16,u[r+23|0]=f>>>24,f=l[14072]|l[14073]<<8|(l[14074]<<16|l[14075]<<24),k=l[14068]|l[14069]<<8|(l[14070]<<16|l[14071]<<24),u[r+8|0]=k,u[r+9|0]=k>>>8,u[r+10|0]=k>>>16,u[r+11|0]=k>>>24,u[r+12|0]=f,u[r+13|0]=f>>>8,u[r+14|0]=f>>>16,u[r+15|0]=f>>>24,q(B,2,102,t+112|0),u[t+123|0]>=0)break e;Z(i[t+112>>2]);break e}i[t+192>>2]=i[w+64>>2],f=i[w+68>>2],i[t+196>>2]=f,f&&(i[f+4>>2]=i[f+4>>2]+1),f=i[t+196>>2],i[t+24>>2]=i[t+192>>2],i[t+28>>2]=f,s=0,R=t3(t+200|0,t+24|0,0,k),i[t+184>>2]=0,i[t+188>>2]=0,V6(t+112|0,R,t+184|0,V),f=i[t+116>>2],i[t+224>>2]=i[t+112>>2],i[t+228>>2]=f,u[t+243|0]<0&&Z(i[t+232>>2]),f=i[t+124>>2],i[t+232>>2]=i[t+120>>2],i[t+236>>2]=f,i[t+240>>2]=i[t+128>>2],E=w+16|0,r2(E,t+184|0),n=0,f=i[t+184>>2];r:{if(!f)break r;if(n=W0(f,86580,86944),!n){n=0;break r}if(s=i[t+188>>2],!s){s=0;break r}i[s+4>>2]=i[s+4>>2]+1}i[w+28>>2]=n,f=i[w+32>>2],i[w+32>>2]=s;r:{if(!f||(s=i[f+4>>2],i[f+4>>2]=s-1,s))break r;W[i[i[f>>2]+8>>2]](f),y(f)}for(M=w+44|0,m=B+8|0,s=0;;){f=_,o=k+32|0,n=o>>>0<32?f+1|0:f,X=i[w+60>>2],f=i[w+56>>2],(n|0)==(X|0)&f>>>0<o>>>0|n>>>0>X>>>0&&(f=i[r>>2],f=W[i[i[f>>2]+24>>2]](f,k,_,o,n)|0,h=l0,X=h,i[w+56>>2]=f,i[w+60>>2]=h);r:{if((n|0)==(X|0)&f>>>0<o>>>0|n>>>0>X>>>0){if((s|F)&1){if(r=i[26917],i[B>>2]=i[26916],i[B+4>>2]=r,u[107683]>=0){r=i[26919],i[m>>2]=i[26918],i[m+4>>2]=r,i[m+8>>2]=i[26920];break r}T(m,i[26918],i[26919]);break r}if(r=p(24),i[t+112>>2]=r,i[t+116>>2]=23,i[t+120>>2]=-2147483624,f=l[18756]|l[18757]<<8|(l[18758]<<16|l[18759]<<24),k=l[18752]|l[18753]<<8|(l[18754]<<16|l[18755]<<24),u[r|0]=k,u[r+1|0]=k>>>8,u[r+2|0]=k>>>16,u[r+3|0]=k>>>24,u[r+4|0]=f,u[r+5|0]=f>>>8,u[r+6|0]=f>>>16,u[r+7|0]=f>>>24,u[r+23|0]=0,f=l[18771]|l[18772]<<8|(l[18773]<<16|l[18774]<<24),k=l[18767]|l[18768]<<8|(l[18769]<<16|l[18770]<<24),u[r+15|0]=k,u[r+16|0]=k>>>8,u[r+17|0]=k>>>16,u[r+18|0]=k>>>24,u[r+19|0]=f,u[r+20|0]=f>>>8,u[r+21|0]=f>>>16,u[r+22|0]=f>>>24,f=l[18764]|l[18765]<<8|(l[18766]<<16|l[18767]<<24),k=l[18760]|l[18761]<<8|(l[18762]<<16|l[18763]<<24),u[r+8|0]=k,u[r+9|0]=k>>>8,u[r+10|0]=k>>>16,u[r+11|0]=k>>>24,u[r+12|0]=f,u[r+13|0]=f>>>8,u[r+14|0]=f>>>16,u[r+15|0]=f>>>24,q(B,2,0,t+112|0),u[t+123|0]>=0)break r;Z(i[t+112>>2]);break r}i[t+152>>2]=i[w+64>>2],n=i[w+68>>2],i[t+156>>2]=n,n&&(i[n+4>>2]=i[n+4>>2]+1,f=i[w+56>>2]),n=i[t+156>>2],i[t+16>>2]=i[t+152>>2],i[t+20>>2]=n,n=t3(t+160|0,t+16|0,k,f),N=t+112|0,f=N,i[f+8>>2]=0,i[f+12>>2]=0,i[f+16>>2]=0,i[f+20>>2]=0,i[f+24>>2]=0,i[f+28>>2]=0,i[f+32>>2]=0,i[f>>2]=86356,$6(t+88|0,f,n),n=i[t+92>>2],f=i[t+88>>2],i[t+224>>2]=f,i[t+228>>2]=n,u[t+243|0]<0&&(Z(i[t+232>>2]),f=i[t+224>>2]),n=i[t+100>>2],i[t+232>>2]=i[t+96>>2],i[t+236>>2]=n,i[t+240>>2]=i[t+104>>2];f:{if(f){f=i[t+228>>2],i[B>>2]=i[t+224>>2],i[B+4>>2]=f,i[m+8>>2]=i[t+240>>2],f=i[t+236>>2],i[m>>2]=i[t+232>>2],i[m+4>>2]=f,i[t+232>>2]=0,i[t+236>>2]=0,i[t+240>>2]=0,f=0;break f}if(f=i[t+128>>2],(f|0)==1835365473){if(o=i[t+120>>2],n=i[t+124>>2],!(o|n)){f=p(48),i[t+88>>2]=f,i[t+92>>2]=42,i[t+96>>2]=-2147483600,n=l[11794]|l[11795]<<8|(l[11796]<<16|l[11797]<<24),o=l[11790]|l[11791]<<8|(l[11792]<<16|l[11793]<<24),u[f|0]=o,u[f+1|0]=o>>>8,u[f+2|0]=o>>>16,u[f+3|0]=o>>>24,u[f+4|0]=n,u[f+5|0]=n>>>8,u[f+6|0]=n>>>16,u[f+7|0]=n>>>24,u[f+42|0]=0,n=l[11830]|l[11831]<<8,u[f+40|0]=n,u[f+41|0]=n>>>8,n=l[11826]|l[11827]<<8|(l[11828]<<16|l[11829]<<24),o=l[11822]|l[11823]<<8|(l[11824]<<16|l[11825]<<24),u[f+32|0]=o,u[f+33|0]=o>>>8,u[f+34|0]=o>>>16,u[f+35|0]=o>>>24,u[f+36|0]=n,u[f+37|0]=n>>>8,u[f+38|0]=n>>>16,u[f+39|0]=n>>>24,n=l[11818]|l[11819]<<8|(l[11820]<<16|l[11821]<<24),o=l[11814]|l[11815]<<8|(l[11816]<<16|l[11817]<<24),u[f+24|0]=o,u[f+25|0]=o>>>8,u[f+26|0]=o>>>16,u[f+27|0]=o>>>24,u[f+28|0]=n,u[f+29|0]=n>>>8,u[f+30|0]=n>>>16,u[f+31|0]=n>>>24,n=l[11810]|l[11811]<<8|(l[11812]<<16|l[11813]<<24),o=l[11806]|l[11807]<<8|(l[11808]<<16|l[11809]<<24),u[f+16|0]=o,u[f+17|0]=o>>>8,u[f+18|0]=o>>>16,u[f+19|0]=o>>>24,u[f+20|0]=n,u[f+21|0]=n>>>8,u[f+22|0]=n>>>16,u[f+23|0]=n>>>24,n=l[11802]|l[11803]<<8|(l[11804]<<16|l[11805]<<24),o=l[11798]|l[11799]<<8|(l[11800]<<16|l[11801]<<24),u[f+8|0]=o,u[f+9|0]=o>>>8,u[f+10|0]=o>>>16,u[f+11|0]=o>>>24,u[f+12|0]=n,u[f+13|0]=n>>>8,u[f+14|0]=n>>>16,u[f+15|0]=n>>>24,q(B,2,104,t+88|0),u[t+99|0]<0&&Z(i[t+88>>2]),f=0;break f}if(f=i[w+56>>2],h=i[w+60>>2],X=h,n=n+_|0,o=k+o|0,n=o>>>0<k>>>0?n+1|0:n,(n|0)==(h|0)&f>>>0<o>>>0|n>>>0>h>>>0&&(f=i[w+64>>2],f=W[i[i[f>>2]+24>>2]](f,k,_,o,n)|0,h=l0,X=h,i[w+56>>2]=f,i[w+60>>2]=h),(n|0)==(X|0)&f>>>0<o>>>0|n>>>0>X>>>0){f=p(32),i[t+88>>2]=f,i[t+92>>2]=25,i[t+96>>2]=-2147483616,n=l[2437]|l[2438]<<8|(l[2439]<<16|l[2440]<<24),o=l[2433]|l[2434]<<8|(l[2435]<<16|l[2436]<<24),u[f|0]=o,u[f+1|0]=o>>>8,u[f+2|0]=o>>>16,u[f+3|0]=o>>>24,u[f+4|0]=n,u[f+5|0]=n>>>8,u[f+6|0]=n>>>16,u[f+7|0]=n>>>24,u[f+25|0]=0,u[f+24|0]=l[2457],n=l[2453]|l[2454]<<8|(l[2455]<<16|l[2456]<<24),o=l[2449]|l[2450]<<8|(l[2451]<<16|l[2452]<<24),u[f+16|0]=o,u[f+17|0]=o>>>8,u[f+18|0]=o>>>16,u[f+19|0]=o>>>24,u[f+20|0]=n,u[f+21|0]=n>>>8,u[f+22|0]=n>>>16,u[f+23|0]=n>>>24,n=l[2445]|l[2446]<<8|(l[2447]<<16|l[2448]<<24),o=l[2441]|l[2442]<<8|(l[2443]<<16|l[2444]<<24),u[f+8|0]=o,u[f+9|0]=o>>>8,u[f+10|0]=o>>>16,u[f+11|0]=o>>>24,u[f+12|0]=n,u[f+13|0]=n>>>8,u[f+14|0]=n>>>16,u[f+15|0]=n>>>24,q(B,2,104,t+88|0),u[t+99|0]<0&&Z(i[t+88>>2]),f=0;break f}i[t+80>>2]=i[w+64>>2],f=i[w+68>>2],i[t+84>>2]=f,f&&(i[f+4>>2]=i[f+4>>2]+1),f=i[t+84>>2],i[t+8>>2]=i[t+80>>2],i[t+12>>2]=f,f=t3(t+88|0,t+8|0,k,o),i[t+72>>2]=0,i[t+76>>2]=0,V6(t+48|0,f,t+72|0,V),n=i[t+52>>2],f=i[t+48>>2],i[t+224>>2]=f,i[t+228>>2]=n,u[t+243|0]<0&&(Z(i[t+232>>2]),f=i[t+224>>2]),n=i[t+60>>2],i[t+232>>2]=i[t+56>>2],i[t+236>>2]=n,i[t+240>>2]=i[t+64>>2],o=f;A:{if(f){f=i[t+228>>2],i[B>>2]=i[t+224>>2],i[B+4>>2]=f,i[m+8>>2]=i[t+240>>2],f=i[t+236>>2],i[m>>2]=i[t+232>>2],i[m+4>>2]=f,i[t+232>>2]=0,i[t+236>>2]=0,i[t+240>>2]=0;break A}r2(E,t+72|0);k:{n:{if(f=i[t+72>>2],!f||(n=W0(f,86580,87104),!n))break n;if(s=i[t+76>>2],!s){s=0;break k}i[s+4>>2]=i[s+4>>2]+1;break k}s=0,n=0}if(i[w+36>>2]=n,f=i[w+40>>2],i[w+40>>2]=s,s=1,!f||(n=i[f+4>>2],i[f+4>>2]=n-1,n))break A;W[i[i[f>>2]+8>>2]](f),y(f)}f=i[t+76>>2];A:{if(!f||(n=i[f+4>>2],i[f+4>>2]=n-1,n))break A;W[i[i[f>>2]+8>>2]](f),y(f)}f=i[t+92>>2];A:{if(!f||(n=i[f+4>>2],i[f+4>>2]=n-1,n))break A;W[i[i[f>>2]+8>>2]](f),y(f)}if(f=0,o)break f;f=i[t+128>>2]}A:{if((f|0)!=1836019574)break A;if(o=i[t+120>>2],n=i[t+124>>2],!(o|n)){f=p(48),i[t+88>>2]=f,i[t+92>>2]=42,i[t+96>>2]=-2147483600,n=l[11751]|l[11752]<<8|(l[11753]<<16|l[11754]<<24),o=l[11747]|l[11748]<<8|(l[11749]<<16|l[11750]<<24),u[f|0]=o,u[f+1|0]=o>>>8,u[f+2|0]=o>>>16,u[f+3|0]=o>>>24,u[f+4|0]=n,u[f+5|0]=n>>>8,u[f+6|0]=n>>>16,u[f+7|0]=n>>>24,u[f+42|0]=0,n=l[11787]|l[11788]<<8,u[f+40|0]=n,u[f+41|0]=n>>>8,n=l[11783]|l[11784]<<8|(l[11785]<<16|l[11786]<<24),o=l[11779]|l[11780]<<8|(l[11781]<<16|l[11782]<<24),u[f+32|0]=o,u[f+33|0]=o>>>8,u[f+34|0]=o>>>16,u[f+35|0]=o>>>24,u[f+36|0]=n,u[f+37|0]=n>>>8,u[f+38|0]=n>>>16,u[f+39|0]=n>>>24,n=l[11775]|l[11776]<<8|(l[11777]<<16|l[11778]<<24),o=l[11771]|l[11772]<<8|(l[11773]<<16|l[11774]<<24),u[f+24|0]=o,u[f+25|0]=o>>>8,u[f+26|0]=o>>>16,u[f+27|0]=o>>>24,u[f+28|0]=n,u[f+29|0]=n>>>8,u[f+30|0]=n>>>16,u[f+31|0]=n>>>24,n=l[11767]|l[11768]<<8|(l[11769]<<16|l[11770]<<24),o=l[11763]|l[11764]<<8|(l[11765]<<16|l[11766]<<24),u[f+16|0]=o,u[f+17|0]=o>>>8,u[f+18|0]=o>>>16,u[f+19|0]=o>>>24,u[f+20|0]=n,u[f+21|0]=n>>>8,u[f+22|0]=n>>>16,u[f+23|0]=n>>>24,n=l[11759]|l[11760]<<8|(l[11761]<<16|l[11762]<<24),o=l[11755]|l[11756]<<8|(l[11757]<<16|l[11758]<<24),u[f+8|0]=o,u[f+9|0]=o>>>8,u[f+10|0]=o>>>16,u[f+11|0]=o>>>24,u[f+12|0]=n,u[f+13|0]=n>>>8,u[f+14|0]=n>>>16,u[f+15|0]=n>>>24,q(B,2,151,t+88|0),u[t+99|0]<0&&Z(i[t+88>>2]),f=0;break f}if(f=i[w+56>>2],h=i[w+60>>2],X=h,n=n+_|0,o=k+o|0,n=o>>>0<k>>>0?n+1|0:n,(n|0)==(h|0)&f>>>0<o>>>0|n>>>0>h>>>0&&(f=i[w+64>>2],f=W[i[i[f>>2]+24>>2]](f,k,_,o,n)|0,h=l0,X=h,i[w+56>>2]=f,i[w+60>>2]=h),(n|0)==(X|0)&f>>>0<o>>>0|n>>>0>X>>>0){f=p(32),i[t+88>>2]=f,i[t+92>>2]=25,i[t+96>>2]=-2147483616,n=l[2347]|l[2348]<<8|(l[2349]<<16|l[2350]<<24),o=l[2343]|l[2344]<<8|(l[2345]<<16|l[2346]<<24),u[f|0]=o,u[f+1|0]=o>>>8,u[f+2|0]=o>>>16,u[f+3|0]=o>>>24,u[f+4|0]=n,u[f+5|0]=n>>>8,u[f+6|0]=n>>>16,u[f+7|0]=n>>>24,u[f+25|0]=0,u[f+24|0]=l[2367],n=l[2363]|l[2364]<<8|(l[2365]<<16|l[2366]<<24),o=l[2359]|l[2360]<<8|(l[2361]<<16|l[2362]<<24),u[f+16|0]=o,u[f+17|0]=o>>>8,u[f+18|0]=o>>>16,u[f+19|0]=o>>>24,u[f+20|0]=n,u[f+21|0]=n>>>8,u[f+22|0]=n>>>16,u[f+23|0]=n>>>24,n=l[2355]|l[2356]<<8|(l[2357]<<16|l[2358]<<24),o=l[2351]|l[2352]<<8|(l[2353]<<16|l[2354]<<24),u[f+8|0]=o,u[f+9|0]=o>>>8,u[f+10|0]=o>>>16,u[f+11|0]=o>>>24,u[f+12|0]=n,u[f+13|0]=n>>>8,u[f+14|0]=n>>>16,u[f+15|0]=n>>>24,q(B,2,151,t+88|0),u[t+99|0]<0&&Z(i[t+88>>2]),f=0;break f}i[t+40>>2]=i[w+64>>2],f=i[w+68>>2],i[t+44>>2]=f,f&&(i[f+4>>2]=i[f+4>>2]+1),f=i[t+44>>2],i[t>>2]=i[t+40>>2],i[t+4>>2]=f,f=t3(t+88|0,t,k,o),i[t+72>>2]=0,i[t+76>>2]=0,V6(t+48|0,f,t+72|0,V),n=i[t+52>>2],f=i[t+48>>2],i[t+224>>2]=f,i[t+228>>2]=n,u[t+243|0]<0&&(Z(i[t+232>>2]),f=i[t+224>>2]),n=i[t+60>>2],i[t+232>>2]=i[t+56>>2],i[t+236>>2]=n,i[t+240>>2]=i[t+64>>2];k:{if(f){n=i[t+228>>2],i[B>>2]=i[t+224>>2],i[B+4>>2]=n,i[m+8>>2]=i[t+240>>2],n=i[t+236>>2],i[m>>2]=i[t+232>>2],i[m+4>>2]=n,i[t+232>>2]=0,i[t+236>>2]=0,i[t+240>>2]=0;break k}r2(E,t+72|0),n=t+48|0;n:{t:{if(o=i[t+72>>2],!o||(o=W0(o,86580,92664),!o))break t;if(i[n>>2]=o,o=i[t+76>>2],i[n+4>>2]=o,!o)break n;i[o+4>>2]=i[o+4>>2]+1;break n}i[n>>2]=0,i[n+4>>2]=0}p8(M,n),I2(n),F=1}n=i[t+76>>2];k:{if(!n||(o=i[n+4>>2],i[n+4>>2]=o-1,o))break k;W[i[i[n>>2]+8>>2]](n),y(n)}n=i[t+92>>2];k:{if(!n||(o=i[n+4>>2],i[n+4>>2]=o-1,o))break k;W[i[i[n>>2]+8>>2]](n),y(n)}if(!f)break A;f=0;break f}if(f=i[t+120>>2],n=i[t+124>>2],!(f|n)){if((s|F)&1){if(f=i[26917],i[B>>2]=i[26916],i[B+4>>2]=f,u[107683]>=0){f=i[26919],i[m>>2]=i[26918],i[m+4>>2]=f,i[m+8>>2]=i[26920],f=0;break f}T(m,i[26918],i[26919]),f=0;break f}f=p(24),i[t+88>>2]=f,i[t+92>>2]=17,i[t+96>>2]=-2147483624,s=l[15835]|l[15836]<<8|(l[15837]<<16|l[15838]<<24),n=l[15831]|l[15832]<<8|(l[15833]<<16|l[15834]<<24),u[f|0]=n,u[f+1|0]=n>>>8,u[f+2|0]=n>>>16,u[f+3|0]=n>>>24,u[f+4|0]=s,u[f+5|0]=s>>>8,u[f+6|0]=s>>>16,u[f+7|0]=s>>>24,u[f+17|0]=0,u[f+16|0]=l[15847],s=l[15843]|l[15844]<<8|(l[15845]<<16|l[15846]<<24),n=l[15839]|l[15840]<<8|(l[15841]<<16|l[15842]<<24),u[f+8|0]=n,u[f+9|0]=n>>>8,u[f+10|0]=n>>>16,u[f+11|0]=n>>>24,u[f+12|0]=s,u[f+13|0]=s>>>8,u[f+14|0]=s>>>16,u[f+15|0]=s>>>24,q(B,2,0,t+88|0),u[t+99|0]<0&&Z(i[t+88>>2]),F=0,s=0,f=0;break f}if(o=n^-1,(_|0)==(o|0)&k>>>0>(f^-1)>>>0|o>>>0<_>>>0){f=p(40),i[t+88>>2]=f,i[t+92>>2]=36,i[t+96>>2]=-2147483608,n=l[3004]|l[3005]<<8|(l[3006]<<16|l[3007]<<24),o=l[3e3]|l[3001]<<8|(l[3002]<<16|l[3003]<<24),u[f|0]=o,u[f+1|0]=o>>>8,u[f+2|0]=o>>>16,u[f+3|0]=o>>>24,u[f+4|0]=n,u[f+5|0]=n>>>8,u[f+6|0]=n>>>16,u[f+7|0]=n>>>24,u[f+36|0]=0,n=l[3032]|l[3033]<<8|(l[3034]<<16|l[3035]<<24),u[f+32|0]=n,u[f+33|0]=n>>>8,u[f+34|0]=n>>>16,u[f+35|0]=n>>>24,n=l[3028]|l[3029]<<8|(l[3030]<<16|l[3031]<<24),o=l[3024]|l[3025]<<8|(l[3026]<<16|l[3027]<<24),u[f+24|0]=o,u[f+25|0]=o>>>8,u[f+26|0]=o>>>16,u[f+27|0]=o>>>24,u[f+28|0]=n,u[f+29|0]=n>>>8,u[f+30|0]=n>>>16,u[f+31|0]=n>>>24,n=l[3020]|l[3021]<<8|(l[3022]<<16|l[3023]<<24),o=l[3016]|l[3017]<<8|(l[3018]<<16|l[3019]<<24),u[f+16|0]=o,u[f+17|0]=o>>>8,u[f+18|0]=o>>>16,u[f+19|0]=o>>>24,u[f+20|0]=n,u[f+21|0]=n>>>8,u[f+22|0]=n>>>16,u[f+23|0]=n>>>24,n=l[3012]|l[3013]<<8|(l[3014]<<16|l[3015]<<24),o=l[3008]|l[3009]<<8|(l[3010]<<16|l[3011]<<24),u[f+8|0]=o,u[f+9|0]=o>>>8,u[f+10|0]=o>>>16,u[f+11|0]=o>>>24,u[f+12|0]=n,u[f+13|0]=n>>>8,u[f+14|0]=n>>>16,u[f+15|0]=n>>>24,q(B,2,0,t+88|0),u[t+99|0]<0&&Z(i[t+88>>2]),f=0;break f}_=n+_|0,h=k,k=f+k|0,_=h>>>0>k>>>0?_+1|0:_,f=1}i[N>>2]=86356,n=i[t+132>>2],n&&(i[t+136>>2]=n,Z(n)),n=i[t+164>>2];f:{if(!n||(o=i[n+4>>2],i[n+4>>2]=o-1,o))break f;W[i[i[n>>2]+8>>2]](n),y(n)}if(f)continue}break}r=i[t+188>>2];r:{if(!r||(f=i[r+4>>2],i[r+4>>2]=f-1,f))break r;W[i[i[r>>2]+8>>2]](r),y(r)}if(r=i[R+4>>2],!r||(f=i[r+4>>2],i[r+4>>2]=f-1,f))break e;W[i[i[r>>2]+8>>2]](r),y(r)}if(u[t+243|0]<0&&Z(i[t+232>>2]),i[Q>>2]=86356,r=i[Q+20>>2],r&&(i[Q+24>>2]=r,Z(r)),r=i[I+4>>2],!r||(f=i[r+4>>2],i[r+4>>2]=f-1,f))break i;W[i[i[r>>2]+8>>2]](r),y(r)}v=t+320|0,f=i[B+4>>2],r=i[B>>2],i[B+24>>2]=r,i[B+28>>2]=f,u[B+43|0]<0&&(Z(i[B+32>>2]),r=i[B+24>>2]),f=i[B+12>>2],i[B+32>>2]=i[B+8>>2],i[B+36>>2]=f,i[B+40>>2]=i[B+16>>2];i:{if(r){e=i[B+28>>2],i[A>>2]=i[B+24>>2],i[A+4>>2]=e,e=i[B+36>>2],i[A+8>>2]=i[B+32>>2],i[A+12>>2]=e,i[A+16>>2]=i[B+40>>2];break i}X=v-160|0,v=X,f=i[e>>2],r=i[f+28>>2],k=i[f+32>>2],k&&(i[k+4>>2]=i[k+4>>2]+1),i[e+28>>2]=r,f=i[e+32>>2],i[e+32>>2]=k,f&&(r=i[f+4>>2],i[f+4>>2]=r-1,r||(W[i[i[f>>2]+8>>2]](f),y(f)),r=i[e+28>>2]);e:{r:{f:{A:{if(!r){if(u[X+12|0]=0,u[X+23|0]=0,q(A,2,102,X+12|0),u[X+23|0]>=0)break A;Z(i[X+12>>2]);break A}s=i[e+32>>2],s&&(i[s+4>>2]=i[s+4>>2]+1),f=i[e+20>>2],_=i[e+24>>2];k:{if(f>>>0<_>>>0){i[f+4>>2]=s,i[f>>2]=r,r=f+8|0;break k}if(n=i[e+16>>2],f=f-n|0,h=f>>3,k=h+1|0,k>>>0>=536870912)break f;if(_=_-n|0,o=_>>2,_=_>>>0>=2147483640?536870911:k>>>0<o>>>0?o:k,_){if(_>>>0>=536870912)break r;k=p(_<<3)}else k=0;if(o=k+f|0,i[o+4>>2]=s,i[o>>2]=r,s=o-(h<<3)|0,f&&x(s,n,f),i[e+24>>2]=k+(_<<3),r=o+8|0,i[e+20>>2]=r,i[e+16>>2]=s,!n)break k;Z(n)}i[e+20>>2]=r,n=1;k:{if(J4(i[e+28>>2],1836279345)||J4(i[e+28>>2],1769172845)||J4(i[e+28>>2],1836069937))break k;n=J4(i[e+28>>2],1836069938)}k:{if(J4(i[e+28>>2],1751476579)||J4(i[e+28>>2],1751476600)||J4(i[e+28>>2],1835623985)||J4(i[e+28>>2],1635150182)||J4(i[e+28>>2],829450595)||J4(i[e+28>>2],1785750887)||J4(i[e+28>>2],1769172845)||J4(i[e+28>>2],1836069938)||J4(i[e+28>>2],1836069937)||J4(i[e+28>>2],1836279345))break k;e=hA(X+12|0),Y(e+8|0,41808,44),QA(X,e),q(A,3,0,X),u[X+11|0]<0&&Z(i[X>>2]),H6(e);break A}if(f=i[e>>2],r=i[f+36>>2],k=i[f+40>>2],k&&(i[k+4>>2]=i[k+4>>2]+1),i[e+44>>2]=r,f=i[e+48>>2],i[e+48>>2]=k,f&&(r=i[f+4>>2],i[f+4>>2]=r-1,r||(W[i[i[f>>2]+8>>2]](f),y(f)),r=i[e+44>>2]),r){s=i[e+48>>2],s&&(i[s+4>>2]=i[s+4>>2]+1),f=i[e+20>>2],o=i[e+24>>2];k:{if(f>>>0<o>>>0){i[f+4>>2]=s,i[f>>2]=r,r=f+8|0;break k}if(_=i[e+16>>2],f=f-_|0,t=f>>3,k=t+1|0,k>>>0>=536870912)break f;if(o=o-_|0,h=o>>2,o=o>>>0>=2147483640?536870911:k>>>0<h>>>0?h:k,o){if(o>>>0>=536870912)break r;k=p(o<<3)}else k=0;if(h=k+f|0,i[h+4>>2]=s,i[h>>2]=r,s=h-(t<<3)|0,f&&x(s,_,f),i[e+24>>2]=k+(o<<3),r=h+8|0,i[e+20>>2]=r,i[e+16>>2]=s,!_)break k;Z(_)}i[e+20>>2]=r}if(f=i[e>>2],r=i[f+44>>2],k=i[f+48>>2],k&&(i[k+4>>2]=i[k+4>>2]+1),i[e+140>>2]=r,f=i[e+144>>2],i[e+144>>2]=k,f&&(r=i[f+4>>2],i[f+4>>2]=r-1,r||(W[i[i[f>>2]+8>>2]](f),y(f)),r=i[e+140>>2]),r){s=i[e+144>>2],s&&(i[s+4>>2]=i[s+4>>2]+1),f=i[e+20>>2],o=i[e+24>>2];k:{if(f>>>0<o>>>0){i[f+4>>2]=s,i[f>>2]=r,r=f+8|0;break k}if(_=i[e+16>>2],f=f-_|0,t=f>>3,k=t+1|0,k>>>0>=536870912)break f;if(o=o-_|0,h=o>>2,o=o>>>0>=2147483640?536870911:k>>>0<h>>>0?h:k,o){if(o>>>0>=536870912)break r;k=p(o<<3)}else k=0;if(h=k+f|0,i[h+4>>2]=s,i[h>>2]=r,s=h-(t<<3)|0,f&&x(s,_,f),i[e+24>>2]=k+(o<<3),r=h+8|0,i[e+20>>2]=r,i[e+16>>2]=s,!_)break k;Z(_)}i[e+20>>2]=r}if(f=i[e+44>>2],!((f|0)!=0|n)){if(u[X+12|0]=0,u[X+23|0]=0,q(A,2,104,X+12|0),u[X+23|0]>=0)break A;Z(i[X+12>>2]);break A}if(r=i[e+140>>2],!(n^1|(r|0)!=0)){if(u[X+12|0]=0,u[X+23|0]=0,q(A,2,151,X+12|0),u[X+23|0]>=0)break A;Z(i[X+12>>2]);break A}if(f){w=v-48|0,v=w,r=i[e+44>>2],f=i[r+36>>2],k=i[r+40>>2];k:{n:{if((f|0)!=(k|0))for(;;){t:{if(r=i[f>>2],!r||(r=W0(r,86580,87184),!r))break t;if(f=i[f+4>>2],!f)break n;i[f+4>>2]=i[f+4>>2]+1;break k}if(f=f+8|0,(k|0)==(f|0))break}r=0}f=0}i[e+36>>2]=r,k=i[e+40>>2],i[e+40>>2]=f,k&&(r=i[k+4>>2],i[k+4>>2]=r-1,r||(W[i[i[k>>2]+8>>2]](k),y(k)),r=i[e+36>>2]);k:{if(!(!r|i[r+108>>2]==1885954932)){if(u[w+36|0]=0,u[w+47|0]=0,q(A,2,114,w+36|0),u[w+47|0]>=0)break k;Z(i[w+36>>2]);break k}r=i[e+44>>2],f=i[r+36>>2],k=i[r+40>>2];n:{t:{if((f|0)!=(k|0))for(;;){u:{if(r=i[f>>2],!r||(r=W0(r,86580,87264),!r))break u;if(f=i[f+4>>2],!f)break t;i[f+4>>2]=i[f+4>>2]+1;break n}if(f=f+8|0,(k|0)==(f|0))break}r=0}f=0}if(i[e+92>>2]=r,k=i[e+96>>2],i[e+96>>2]=f,k&&(r=i[k+4>>2],i[k+4>>2]=r-1,r||(W[i[i[k>>2]+8>>2]](k),y(k)),r=i[e+92>>2]),!r){if(u[w+36|0]=0,u[w+47|0]=0,q(A,2,107,w+36|0),u[w+47|0]>=0)break k;Z(i[w+36>>2]);break k}r=i[e+44>>2],f=i[r+36>>2],k=i[r+40>>2];n:{t:{if((f|0)!=(k|0))for(;;){u:{if(r=i[f>>2],!r||(r=W0(r,86580,87504),!r))break u;if(f=i[f+4>>2],!f)break t;i[f+4>>2]=i[f+4>>2]+1;break n}if(f=f+8|0,(k|0)==(f|0))break}r=0}f=0}if(i[e+116>>2]=r,k=i[e+120>>2],i[e+120>>2]=f,k&&(r=i[k+4>>2],i[k+4>>2]=r-1,r||(W[i[i[k>>2]+8>>2]](k),y(k)),r=i[e+116>>2]),!r){if(u[w+36|0]=0,u[w+47|0]=0,q(A,2,112,w+36|0),u[w+47|0]>=0)break k;Z(i[w+36>>2]);break k}f=i[r+36>>2],k=i[r+40>>2];n:{if((f|0)!=(k|0))for(;;){t:{if(r=i[f>>2],!r||(r=W0(r,86580,87584),!r))break t;if(f=i[f+4>>2],!f){f=0;break n}i[f+4>>2]=i[f+4>>2]+1;break n}if(f=f+8|0,(k|0)==(f|0))break}f=0,r=0}if(i[e+52>>2]=r,k=i[e+56>>2],i[e+56>>2]=f,k&&(r=i[k+4>>2],i[k+4>>2]=r-1,r||(W[i[i[k>>2]+8>>2]](k),y(k)),r=i[e+52>>2]),!r){if(u[w+36|0]=0,u[w+47|0]=0,q(A,2,108,w+36|0),u[w+47|0]>=0)break k;Z(i[w+36>>2]);break k}r=i[e+116>>2],i[w+44>>2]=0,i[w+36>>2]=0,i[w+40>>2]=0;n:{t:{if(f=i[r+36>>2],k=i[r+40>>2],(f|0)==(k|0))break t;for(;;){r=i[f>>2];u:{if(!r||(r=W0(r,86580,87732),!r)||(i[w+24>>2]=r,r=i[f+4>>2],i[w+28>>2]=r,r&&(i[r+4>>2]=i[r+4>>2]+1),r2(w+36|0,w+24|0),r=i[w+28>>2],!r)||(s=i[r+4>>2],i[r+4>>2]=s-1,s))break u;W[i[i[r>>2]+8>>2]](r),y(r)}if(f=f+8|0,(k|0)==(f|0))break}if(f=i[w+36>>2],r=i[w+40>>2],(f|0)==(r|0))break t;if(r-f>>>0>8)for(r=1;;){k=0,s=i[f>>2],Q=s+104|0,_=i[s+108>>2],f=i[(r<<3)+f>>2],s=i[f+104>>2],o=s,f=i[f+108>>2],F=f,m=v-32|0,v=m;u:{o:{l:{s:{w:{s=f-o>>4;_:{if((s|0)<=0)break _;if(h=i[Q+8>>2],n=i[Q+4>>2],(s|0)<=h-n>>4){f=n-_|0,R=f>>4;h:{if((R|0)>=(s|0)){t=(s<<4)+o|0,f=n;break h}t=f+o|0;B:{if((F|0)==(t|0)){f=n;break B}for(k=t,f=n;;){if(h=i[k>>2],i[f+12>>2]=0,i[f+4>>2]=0,i[f+8>>2]=0,i[f>>2]=h,h=i[k+8>>2],I=i[k+4>>2],(h|0)!=(I|0)){if(h=h-I|0,(h|0)<0)break w;V=p(h),i[f+8>>2]=V,i[f+4>>2]=V,E=h+V|0,i[f+12>>2]=E,h&&x(V,I,h),i[f+8>>2]=E}if(f=f+16|0,k=k+16|0,(F|0)==(k|0))break}}if(i[Q+4>>2]=f,(R|0)<=0)break _}if(s=s<<4,V=s+_|0,k=f,s=f-s|0,n>>>0>s>>>0)for(h=s;F=i[h>>2],i[k+12>>2]=0,i[k+4>>2]=0,i[k+8>>2]=0,i[k>>2]=F,i[k+4>>2]=i[h+4>>2],i[k+8>>2]=i[h+8>>2],i[k+12>>2]=i[h+12>>2],i[h+12>>2]=0,i[h+4>>2]=0,i[h+8>>2]=0,k=k+16|0,h=h+16|0,n>>>0>h>>>0;);if(i[Q+4>>2]=k,(f|0)!=(V|0))for(;k=f-16|0,n=s-16|0,i[k>>2]=i[n>>2],h=f-12|0,Q=i[h>>2],Q&&(V=f-8|0,i[V>>2]=Q,Z(Q),i[V>>2]=0,i[V+4>>2]=0,i[h>>2]=0),Q=h,h=s-12|0,i[Q>>2]=i[h>>2],i[f-8>>2]=i[s-8>>2],Q=f-4|0,f=s-4|0,i[Q>>2]=i[f>>2],i[f>>2]=0,i[h>>2]=0,i[h+4>>2]=0,f=k,s=n,(n|0)!=(_|0););if((t|0)==(o|0))break _;for(f=_;i[f>>2]=i[o>>2],(f|0)!=(o|0)&&(k=i[o+4>>2],s=i[o+8>>2],k6(f+4|0,k,s,s-k>>2)),f=f+16|0,o=o+16|0,(t|0)!=(o|0););break _}if(f=i[Q>>2],n=s+(n-f>>4)|0,n>>>0>=268435456)break s;if(i[m+28>>2]=Q+8,h=h-f|0,t=h>>3,n=h>>>0>=2147483632?268435455:n>>>0<t>>>0?t:n,n){if(n>>>0>=268435456)break l;k=p(n<<4)}for(i[m+12>>2]=k,f=(_-f|0)+k|0,i[m+20>>2]=f,i[m+24>>2]=(n<<4)+k,i[m+16>>2]=f,n=(s<<4)+f|0;;){if(k=i[o>>2],i[f+12>>2]=0,i[f+4>>2]=0,i[f+8>>2]=0,i[f>>2]=k,k=i[o+8>>2],h=i[o+4>>2],(k|0)!=(h|0)){if(k=k-h|0,(k|0)<0)break o;s=p(k),i[f+8>>2]=s,i[f+4>>2]=s,t=k+s|0,i[f+12>>2]=t,k&&x(s,h,k),i[f+8>>2]=t}if(o=o+16|0,f=f+16|0,(n|0)==(f|0))break}i[m+20>>2]=n,k=i[m+20>>2],s=i[m+16>>2],f=_,n=i[Q+4>>2];h:{if((f|0)==(n|0)){n=f;break h}for(s=f;_=i[s>>2],i[k+12>>2]=0,i[k+4>>2]=0,i[k+8>>2]=0,i[k>>2]=_,i[k+4>>2]=i[s+4>>2],i[k+8>>2]=i[s+8>>2],i[k+12>>2]=i[s+12>>2],i[s+12>>2]=0,i[s+4>>2]=0,i[s+8>>2]=0,k=k+16|0,s=s+16|0,(n|0)!=(s|0););for(k=f;s=i[k+4>>2],s&&(i[k+8>>2]=s,Z(s)),k=k+16|0,(n|0)!=(k|0););k=i[m+20>>2],s=i[m+16>>2],n=i[Q+4>>2]}if(i[m+20>>2]=(n-f|0)+k,i[Q+4>>2]=f,n=i[Q>>2],_=(n-f|0)+s|0,(f|0)!=(n|0)){for(k=n,s=_;o=i[k>>2],i[s+12>>2]=0,i[s+4>>2]=0,i[s+8>>2]=0,i[s>>2]=o,i[s+4>>2]=i[k+4>>2],i[s+8>>2]=i[k+8>>2],i[s+12>>2]=i[k+12>>2],i[k+12>>2]=0,i[k+4>>2]=0,i[k+8>>2]=0,s=s+16|0,k=k+16|0,(f|0)!=(k|0););for(;k=i[n+4>>2],k&&(i[n+8>>2]=k,Z(k)),n=n+16|0,(f|0)!=(n|0););n=i[Q>>2]}if(i[m+16>>2]=_,i[Q+4>>2]=n,i[Q>>2]=i[m+16>>2],i[m+16>>2]=n,f=i[Q+4>>2],i[Q+4>>2]=i[m+20>>2],i[m+20>>2]=f,f=i[Q+8>>2],i[Q+8>>2]=i[m+24>>2],i[m+24>>2]=f,i[m+12>>2]=i[m+16>>2],o=i[m+20>>2],k=i[m+16>>2],(o|0)!=(k|0))for(;f=o-16|0,i[m+20>>2]=f,s=i[o-12>>2],s&&(i[o-8>>2]=s,Z(s),f=i[m+20>>2]),o=f,(k|0)!=(f|0););if(f=i[m+12>>2],!f)break _;Z(f)}v=m+32|0;break u}G0(),H()}G0(),H()}z0(),H()}G0(),H()}if(r=r+1|0,f=i[w+36>>2],!(r>>>0<i[w+40>>2]-f>>3>>>0))break}r=i[f>>2],f=i[f+4>>2],f&&(i[f+4>>2]=i[f+4>>2]+1),i[e+60>>2]=r,r=i[e+64>>2],i[e+64>>2]=f;u:{if(!r||(f=i[r+4>>2],i[r+4>>2]=f-1,f))break u;W[i[i[r>>2]+8>>2]](r),y(r)}r=i[e+44>>2],f=i[r+36>>2],k=i[r+40>>2];u:{if((f|0)!=(k|0))for(;;){o:{if(r=i[f>>2],!r||(r=W0(r,86580,89664),!r))break o;if(f=i[f+4>>2],!f){f=0;break u}i[f+4>>2]=i[f+4>>2]+1;break u}if(f=f+8|0,(k|0)==(f|0))break}f=0,r=0}if(i[e+68>>2]=r,k=i[e+72>>2],i[e+72>>2]=f,k&&(r=i[k+4>>2],i[k+4>>2]=r-1,r||(W[i[i[k>>2]+8>>2]](k),y(k)),r=i[e+68>>2]),!r){if(u[w+24|0]=0,u[w+35|0]=0,q(A,2,110,w+24|0),u[w+35|0]>=0)break n;Z(i[w+24>>2]);break n}r=i[e+44>>2],f=i[r+36>>2],k=i[r+40>>2];u:{if((f|0)!=(k|0))for(;;){o:{if(r=i[f>>2],!r||(r=W0(r,86580,88212),!r))break o;if(f=i[f+4>>2],!f){f=0;break u}i[f+4>>2]=i[f+4>>2]+1;break u}if(f=f+8|0,(k|0)==(f|0))break}f=0,r=0}i[e+76>>2]=r,r=i[e+80>>2],i[e+80>>2]=f;u:{if(!r||(f=i[r+4>>2],i[r+4>>2]=f-1,f))break u;W[i[i[r>>2]+8>>2]](r),y(r)}r=i[e+44>>2],f=i[r+36>>2],k=i[r+40>>2];u:{if((f|0)!=(k|0))for(;;){o:{if(r=i[f>>2],!r||(r=W0(r,86580,88132),!r))break o;if(f=i[f+4>>2],!f){f=0;break u}i[f+4>>2]=i[f+4>>2]+1;break u}if(f=f+8|0,(k|0)==(f|0))break}f=0,r=0}i[e+84>>2]=r,k=i[e+88>>2],i[e+88>>2]=f,f=e+84|0,k&&(r=i[k+4>>2],i[k+4>>2]=r-1,r||(W[i[i[k>>2]+8>>2]](k),y(k)),r=i[f>>2]);u:{if(!r)break u;if(r=i[i[e+92>>2]+104>>2],k=v-32|0,v=k,i[k+16>>2]=0,i[k+20>>2]=0,i[k+8>>2]=0,i[k+12>>2]=0,i[k+24>>2]=1065353216,K7(A,e,r,f,k+8|0),r=i[k+16>>2],r)for(;f=i[r>>2],Z(r),r=f,!!f;);if(r=i[k+8>>2],i[k+8>>2]=0,r&&Z(r),v=k+32|0,i[A>>2])break n;if(u[A+19|0]>=0)break u;Z(i[A+8>>2])}if(r=w+24|0,ZA(r,i[e+44>>2]),p8(e+100|0,r),I2(r),!i[e+100>>2]){if(r=d2(r,42673),q(A,2,111,r),u[r+11|0]>=0)break n;Z(i[r>>2]);break n}f=w+24|0;u:{o:{if(r=i[e+44>>2],s=i[r+36>>2],n=i[r+40>>2],(s|0)!=(n|0)){if(k=i[s>>2],k&&(r=i[f+4>>2],k=W0(k,86580,88292),k))break o;if(s=s+8|0,(n|0)!=(s|0))for(;;){if(k=i[s>>2],k&&(r=0,k=W0(k,86580,88292),k))break o;if(s=s+8|0,(n|0)==(s|0))break}i[f>>2]=0,i[f+4>>2]=0}i[f>>2]=0,i[f+4>>2]=0;break u}if(i[f+4>>2]=r,i[f>>2]=k,r=i[s+4>>2],i[f+4>>2]=r,!r)break u;i[r+4>>2]=i[r+4>>2]+1}p8(e+108|0,f),I2(f),mu(f,i[e+100>>2]),_=i[w+24>>2],t=i[w+28>>2];u:{if((_|0)!=(t|0))for(s=e+128|0;;){if(h=i[_>>2],!h){if(u[w+12|0]=0,u[w+23|0]=0,q(A,2,125,w+12|0),u[w+23|0]>=0)break u;Z(i[w+12>>2]);break u}o=i[h+104>>2],n=i[_+4>>2],n&&(i[n+4>>2]=i[n+4>>2]+1);o:{l:{k=s,f=k,r=i[f>>2];s:{if(!r)break s;for(;;){if(f=r,r=i[f+16>>2],r>>>0>o>>>0){if(k=f,r=i[f>>2],r)continue;break s}if(r>>>0>=o>>>0)break l;if(r=i[f+4>>2],!r)break}k=f+4|0}r=p(28),i[r+24>>2]=n,i[r+20>>2]=h,i[r+16>>2]=o,i[r+8>>2]=f,i[r>>2]=0,i[r+4>>2]=0,i[k>>2]=r,f=i[i[e+124>>2]>>2],f&&(i[e+124>>2]=f),m1(i[e+128>>2],r),i[e+132>>2]=i[e+132>>2]+1;break o}if(!n||(r=i[n+4>>2],i[n+4>>2]=r-1,r))break o;W[i[i[n>>2]+8>>2]](n),y(n)}if(_=_+8|0,(t|0)==(_|0))break}k8(A,107664)}ve(w+24|0);break n}if(u[w+24|0]=0,u[w+35|0]=0,q(A,2,109,w+24|0),u[w+35|0]>=0)break n;Z(i[w+24>>2])}if(k=i[w+36>>2],!k)break k;if(r=k,f=i[w+40>>2],(r|0)!=(f|0)){for(;;){r=i[f-4>>2];n:{if(!r||(s=i[r+4>>2],i[r+4>>2]=s-1,s))break n;W[i[i[r>>2]+8>>2]](r),y(r)}if(f=f-8|0,(k|0)==(f|0))break}r=i[w+36>>2]}i[w+40>>2]=k,Z(r)}if(v=w+48|0,i[A>>2])break A;u[A+19|0]<0&&Z(i[A+8>>2]),r=i[e+140>>2]}k:{if(!r)break k;r=v-16|0,v=r,k=i[e+140>>2],f=i[k+36>>2],k=i[k+40>>2];n:{if((f|0)!=(k|0))for(;;){t:{if(s=i[f>>2],!s||(s=W0(s,86580,104440),!s))break t;if(k=i[f+4>>2],!k){k=0;break n}i[k+4>>2]=i[k+4>>2]+1;break n}if(f=f+8|0,(k|0)==(f|0))break}k=0,s=0}i[e+148>>2]=s,f=i[e+152>>2],i[e+152>>2]=k,f&&(k=i[f+4>>2],i[f+4>>2]=k-1,k||(W[i[i[f>>2]+8>>2]](f),y(f)),s=i[e+148>>2]);n:{if(!s){if(e=p(32),i[r+4>>2]=e,i[r+8>>2]=30,i[r+12>>2]=-2147483616,f=l[25576]|l[25577]<<8|(l[25578]<<16|l[25579]<<24),k=l[25572]|l[25573]<<8|(l[25574]<<16|l[25575]<<24),u[e|0]=k,u[e+1|0]=k>>>8,u[e+2|0]=k>>>16,u[e+3|0]=k>>>24,u[e+4|0]=f,u[e+5|0]=f>>>8,u[e+6|0]=f>>>16,u[e+7|0]=f>>>24,u[e+30|0]=0,f=l[25598]|l[25599]<<8|(l[25600]<<16|l[25601]<<24),k=l[25594]|l[25595]<<8|(l[25596]<<16|l[25597]<<24),u[e+22|0]=k,u[e+23|0]=k>>>8,u[e+24|0]=k>>>16,u[e+25|0]=k>>>24,u[e+26|0]=f,u[e+27|0]=f>>>8,u[e+28|0]=f>>>16,u[e+29|0]=f>>>24,f=l[25592]|l[25593]<<8|(l[25594]<<16|l[25595]<<24),k=l[25588]|l[25589]<<8|(l[25590]<<16|l[25591]<<24),u[e+16|0]=k,u[e+17|0]=k>>>8,u[e+18|0]=k>>>16,u[e+19|0]=k>>>24,u[e+20|0]=f,u[e+21|0]=f>>>8,u[e+22|0]=f>>>16,u[e+23|0]=f>>>24,f=l[25584]|l[25585]<<8|(l[25586]<<16|l[25587]<<24),k=l[25580]|l[25581]<<8|(l[25582]<<16|l[25583]<<24),u[e+8|0]=k,u[e+9|0]=k>>>8,u[e+10|0]=k>>>16,u[e+11|0]=k>>>24,u[e+12|0]=f,u[e+13|0]=f>>>8,u[e+14|0]=f>>>16,u[e+15|0]=f>>>24,q(A,2,0,r+4|0),u[r+15|0]>=0)break n;Z(i[r+4>>2]);break n}if(e=i[26917],i[A>>2]=i[26916],i[A+4>>2]=e,e=A+8|0,u[107683]>=0){f=i[26919],i[e>>2]=i[26918],i[e+4>>2]=f,i[e+8>>2]=i[26920];break n}T(e,i[26918],i[26919])}if(v=r+16|0,i[A>>2])break A;if(u[A+19|0]>=0)break k;Z(i[A+8>>2])}if(e=i[26917],i[A>>2]=i[26916],i[A+4>>2]=e,A=A+8|0,u[107683]>=0){e=i[26919],i[A>>2]=i[26918],i[A+4>>2]=e,i[A+8>>2]=i[26920];break A}T(A,i[26918],i[26919])}v=X+160|0;break e}G0(),H()}z0(),H()}if(u[B+43|0]>=0)break i;Z(i[B+32>>2])}v=B+48|0}function hf(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,t=0,o=0,s=0,w=0,h=0,_=0,B=0,m=0,X=0,Q=0,V=0,F=0,I=0,E=0,R=0,N=0,M=0,z=0,S=0,O=0,P=0,a=0,$=0,f0=0,A0=0;s=v-192|0,v=s,f=i[r>>2],k=i[r+4>>2],k&&(i[k+4>>2]=i[k+4>>2]+1),i[e+132>>2]=f,f=i[e+136>>2],i[e+136>>2]=k;i:{if(!f||(k=i[f+4>>2],i[f+4>>2]=k-1,k))break i;W[i[i[f>>2]+8>>2]](f),y(f)}i:{e:{r:{if(k=i[r>>2],f=i[k+36>>2],n=i[k+40>>2],(f|0)!=(n|0))for(;;){f:{if(k=i[f>>2],!k||(k=W0(k,86580,104520),!k))break f;F=i[f+4>>2],F&&(i[F+4>>2]=i[F+4>>2]+2),i[e+140>>2]=k,f=i[e+144>>2],i[e+144>>2]=F;A:{if(!f||(n=i[f+4>>2],i[f+4>>2]=n-1,n))break A;W[i[i[f>>2]+8>>2]](f),y(f)}if(i[e+24>>2]=i[k+120>>2],k=i[r>>2],f=i[k+36>>2],n=i[k+40>>2],(f|0)!=(n|0))break r;break e}if(f=f+8|0,(n|0)==(f|0))break}if(e=p(32),i[s+24>>2]=e,i[s+28>>2]=24,i[s+32>>2]=-2147483616,r=l[23167]|l[23168]<<8|(l[23169]<<16|l[23170]<<24),f=l[23163]|l[23164]<<8|(l[23165]<<16|l[23166]<<24),u[e|0]=f,u[e+1|0]=f>>>8,u[e+2|0]=f>>>16,u[e+3|0]=f>>>24,u[e+4|0]=r,u[e+5|0]=r>>>8,u[e+6|0]=r>>>16,u[e+7|0]=r>>>24,u[e+24|0]=0,r=l[23183]|l[23184]<<8|(l[23185]<<16|l[23186]<<24),f=l[23179]|l[23180]<<8|(l[23181]<<16|l[23182]<<24),u[e+16|0]=f,u[e+17|0]=f>>>8,u[e+18|0]=f>>>16,u[e+19|0]=f>>>24,u[e+20|0]=r,u[e+21|0]=r>>>8,u[e+22|0]=r>>>16,u[e+23|0]=r>>>24,r=l[23175]|l[23176]<<8|(l[23177]<<16|l[23178]<<24),f=l[23171]|l[23172]<<8|(l[23173]<<16|l[23174]<<24),u[e+8|0]=f,u[e+9|0]=f>>>8,u[e+10|0]=f>>>16,u[e+11|0]=f>>>24,u[e+12|0]=r,u[e+13|0]=r>>>8,u[e+14|0]=r>>>16,u[e+15|0]=r>>>24,q(A,2,0,s+24|0),u[s+35|0]>=0)break i;Z(i[s+24>>2]);break i}for(;;){r:{if(k=i[f>>2],!k||(k=W0(k,86580,93784),!k))break r;E=i[f+4>>2],E&&(i[E+4>>2]=i[E+4>>2]+1),f=i[k+36>>2],n=i[k+40>>2];f:{if((f|0)!=(n|0))for(;;){A:{if(k=i[f>>2],!k||(k=W0(k,86580,106408),!k))break A;if(t=i[f+4>>2],!t){t=0;break f}i[t+4>>2]=i[t+4>>2]+1;break f}if(f=f+8|0,(n|0)==(f|0))break}k=0}if(i[e+236>>2]=k,f=i[e+240>>2],i[e+240>>2]=t,!f||(k=i[f+4>>2],i[f+4>>2]=k-1,k))break e;W[i[i[f>>2]+8>>2]](f),y(f);break e}if(f=f+8|0,(n|0)==(f|0))break}}f=i[r>>2],k=i[f+36>>2],t=i[f+40>>2];e:{if((k|0)!=(t|0))for(f=k;;){r:{if(n=i[f>>2],!n||(n=W0(n,86580,92984),!n))break r;R=i[f+4>>2],R&&(i[R+4>>2]=i[R+4>>2]+1,f=i[r>>2],t=i[f+40>>2],k=i[f+36>>2]);f:{if((k|0)!=(t|0))for(;;){A:{if(f=i[k>>2],!f||(f=W0(f,86580,106328),!f))break A;if(t=i[k+4>>2],!t){t=0;break f}i[t+4>>2]=i[t+4>>2]+1;break f}if(k=k+8|0,(t|0)==(k|0))break}t=0,f=0}i[e+244>>2]=f,f=i[e+248>>2],i[e+248>>2]=t;f:{if(!f||(k=i[f+4>>2],i[f+4>>2]=k-1,k))break f;W[i[i[f>>2]+8>>2]](f),y(f)}k=i[n+36>>2],t=i[n+40>>2];f:{if((k|0)!=(t|0))for(f=k;;){A:{if(o=i[f>>2],!o||(o=W0(o,86580,87184),!o))break A;N=i[f+4>>2],N&&(i[N+4>>2]=i[N+4>>2]+1,t=i[n+40>>2],k=i[n+36>>2]),i[e+28>>2]=i[o+108>>2];k:{if((k|0)!=(t|0))for(;;){n:{if(f=i[k>>2],!f||(f=W0(f,86580,93144),!f))break n;if(t=i[k+4>>2],!t){t=0;break k}i[t+4>>2]=i[t+4>>2]+1;break k}if(k=k+8|0,(t|0)==(k|0))break}t=0,f=0}i[e+148>>2]=f,k=i[e+152>>2],i[e+152>>2]=t,k&&(f=i[k+4>>2],i[k+4>>2]=f-1,f||(W[i[i[k>>2]+8>>2]](k),y(k)),f=i[e+148>>2]);k:{if(!f){if(e=p(32),i[s+24>>2]=e,i[s+28>>2]=24,i[s+32>>2]=-2147483616,r=l[23117]|l[23118]<<8|(l[23119]<<16|l[23120]<<24),f=l[23113]|l[23114]<<8|(l[23115]<<16|l[23116]<<24),u[e|0]=f,u[e+1|0]=f>>>8,u[e+2|0]=f>>>16,u[e+3|0]=f>>>24,u[e+4|0]=r,u[e+5|0]=r>>>8,u[e+6|0]=r>>>16,u[e+7|0]=r>>>24,u[e+24|0]=0,r=l[23133]|l[23134]<<8|(l[23135]<<16|l[23136]<<24),f=l[23129]|l[23130]<<8|(l[23131]<<16|l[23132]<<24),u[e+16|0]=f,u[e+17|0]=f>>>8,u[e+18|0]=f>>>16,u[e+19|0]=f>>>24,u[e+20|0]=r,u[e+21|0]=r>>>8,u[e+22|0]=r>>>16,u[e+23|0]=r>>>24,r=l[23125]|l[23126]<<8|(l[23127]<<16|l[23128]<<24),f=l[23121]|l[23122]<<8|(l[23123]<<16|l[23124]<<24),u[e+8|0]=f,u[e+9|0]=f>>>8,u[e+10|0]=f>>>16,u[e+11|0]=f>>>24,u[e+12|0]=r,u[e+13|0]=r>>>8,u[e+14|0]=r>>>16,u[e+15|0]=r>>>24,q(A,2,0,s+24|0),u[s+35|0]>=0)break k;Z(i[s+24>>2]);break k}f=i[n+36>>2],n=i[n+40>>2];n:{if((f|0)!=(n|0))for(;;){t:{if(k=i[f>>2],!k||(k=W0(k,86580,104600),!k))break t;if(t=i[f+4>>2],!t){t=0;break n}i[t+4>>2]=i[t+4>>2]+1;break n}if(f=f+8|0,(n|0)==(f|0))break}t=0,k=0}if(i[e+156>>2]=k,f=i[e+160>>2],i[e+160>>2]=t,f&&(k=i[f+4>>2],i[f+4>>2]=k-1,k||(W[i[i[f>>2]+8>>2]](f),y(f)),k=i[e+156>>2]),!k){if(e=p(32),i[s+24>>2]=e,i[s+28>>2]=24,i[s+32>>2]=-2147483616,r=l[23192]|l[23193]<<8|(l[23194]<<16|l[23195]<<24),f=l[23188]|l[23189]<<8|(l[23190]<<16|l[23191]<<24),u[e|0]=f,u[e+1|0]=f>>>8,u[e+2|0]=f>>>16,u[e+3|0]=f>>>24,u[e+4|0]=r,u[e+5|0]=r>>>8,u[e+6|0]=r>>>16,u[e+7|0]=r>>>24,u[e+24|0]=0,r=l[23208]|l[23209]<<8|(l[23210]<<16|l[23211]<<24),f=l[23204]|l[23205]<<8|(l[23206]<<16|l[23207]<<24),u[e+16|0]=f,u[e+17|0]=f>>>8,u[e+18|0]=f>>>16,u[e+19|0]=f>>>24,u[e+20|0]=r,u[e+21|0]=r>>>8,u[e+22|0]=r>>>16,u[e+23|0]=r>>>24,r=l[23200]|l[23201]<<8|(l[23202]<<16|l[23203]<<24),f=l[23196]|l[23197]<<8|(l[23198]<<16|l[23199]<<24),u[e+8|0]=f,u[e+9|0]=f>>>8,u[e+10|0]=f>>>16,u[e+11|0]=f>>>24,u[e+12|0]=r,u[e+13|0]=r>>>8,u[e+14|0]=r>>>16,u[e+15|0]=r>>>24,q(A,2,0,s+24|0),u[s+35|0]>=0)break k;Z(i[s+24>>2]);break k}n:{t:{if(k=i[e+148>>2],f=i[k+36>>2],k=i[k+40>>2],(f|0)!=(k|0))for(;;){u:{if(n=i[f>>2],!n||(X=W0(n,86580,93304),!X))break u;M=i[f+4>>2],M&&(i[M+4>>2]=i[M+4>>2]+1),n=s+24|0;o:{l:{if(t=i[X+36>>2],o=i[X+40>>2],(t|0)!=(o|0)){if(f=i[t>>2],f&&(k=i[n+4>>2],f=W0(f,86580,104840),f))break l;if(t=t+8|0,(o|0)!=(t|0))for(;;){if(f=i[t>>2],f&&(k=0,f=W0(f,86580,104840),f))break l;if(t=t+8|0,(o|0)==(t|0))break}i[n>>2]=0,i[n+4>>2]=0}i[n>>2]=0,i[n+4>>2]=0;break o}if(i[n+4>>2]=k,i[n>>2]=f,f=i[t+4>>2],i[n+4>>2]=f,!f)break o;i[f+4>>2]=i[f+4>>2]+1}if(p8(e+180|0,n),I2(n),i[e+180>>2])break t;if(e=A,A=d2(n,23138),q(e,2,0,A),u[A+11|0]>=0)break n;Z(i[A>>2]);break n}if(f=f+8|0,(k|0)==(f|0))break}if(e=A,A=d2(s+24|0,23088),q(e,2,0,A),u[A+11|0]>=0)break k;Z(i[A>>2]);break k}n=s+24|0;t:{u:{if(t=i[X+36>>2],o=i[X+40>>2],(t|0)!=(o|0)){if(f=i[t>>2],f&&(k=i[n+4>>2],f=W0(f,86580,105080),f))break u;if(t=t+8|0,(o|0)!=(t|0))for(;;){if(f=i[t>>2],f&&(k=0,f=W0(f,86580,105080),f))break u;if(t=t+8|0,(o|0)==(t|0))break}i[n>>2]=0,i[n+4>>2]=0}i[n>>2]=0,i[n+4>>2]=0;break t}if(i[n+4>>2]=k,i[n>>2]=f,f=i[t+4>>2],i[n+4>>2]=f,!f)break t;i[f+4>>2]=i[f+4>>2]+1}if(p8(e+188|0,n),I2(n),!i[e+188>>2]){if(e=A,A=d2(n,23213),q(e,2,0,A),u[A+11|0]>=0)break n;Z(i[A>>2]);break n}n=s+24|0;t:{u:{if(t=i[X+36>>2],o=i[X+40>>2],(t|0)!=(o|0)){if(f=i[t>>2],f&&(k=i[n+4>>2],f=W0(f,86580,105160),f))break u;if(t=t+8|0,(o|0)!=(t|0))for(;;){if(f=i[t>>2],f&&(k=0,f=W0(f,86580,105160),f))break u;if(t=t+8|0,(o|0)==(t|0))break}i[n>>2]=0,i[n+4>>2]=0}i[n>>2]=0,i[n+4>>2]=0;break t}if(i[n+4>>2]=k,i[n>>2]=f,f=i[t+4>>2],i[n+4>>2]=f,!f)break t;i[f+4>>2]=i[f+4>>2]+1}if(p8(e+196|0,n),I2(n),!i[e+196>>2]){if(e=A,A=d2(n,23063),q(e,2,0,A),u[A+11|0]>=0)break n;Z(i[A>>2]);break n}n=s+24|0;t:{u:{if(t=i[X+36>>2],o=i[X+40>>2],(t|0)!=(o|0)){if(f=i[t>>2],f&&(k=i[n+4>>2],f=W0(f,86580,105240),f))break u;if(t=t+8|0,(o|0)!=(t|0))for(;;){if(f=i[t>>2],f&&(k=0,f=W0(f,86580,105240),f))break u;if(t=t+8|0,(o|0)==(t|0))break}i[n>>2]=0,i[n+4>>2]=0}i[n>>2]=0,i[n+4>>2]=0;break t}if(i[n+4>>2]=k,i[n>>2]=f,f=i[t+4>>2],i[n+4>>2]=f,!f)break t;i[f+4>>2]=i[f+4>>2]+1}if(p8(e+228|0,n),I2(n),!i[e+228>>2]){if(e=A,A=d2(n,22766),q(e,2,0,A),u[A+11|0]>=0)break n;Z(i[A>>2]);break n}n=s+24|0;t:{u:{if(t=i[X+36>>2],o=i[X+40>>2],(t|0)!=(o|0)){if(f=i[t>>2],f&&(k=i[n+4>>2],f=W0(f,86580,104920),f))break u;if(t=t+8|0,(o|0)!=(t|0))for(;;){if(f=i[t>>2],f&&(k=0,f=W0(f,86580,104920),f))break u;if(t=t+8|0,(o|0)==(t|0))break}i[n>>2]=0,i[n+4>>2]=0}i[n>>2]=0,i[n+4>>2]=0;break t}if(i[n+4>>2]=k,i[n>>2]=f,f=i[t+4>>2],i[n+4>>2]=f,!f)break t;i[f+4>>2]=i[f+4>>2]+1}if(p8(e+204|0,n),I2(n),f=i[e+204>>2],!f){if(e=A,A=d2(n,22859),q(e,2,0,A),u[A+11|0]>=0)break n;Z(i[A>>2]);break n}if((ul(f)|0)!=i[i[e+228>>2]+108>>2]){if(e=A,A=d2(s+24|0,23347),q(e,2,0,A),u[A+11|0]>=0)break n;Z(i[A>>2]);break n}t:{if(f=i[e+212>>2],!f||(ul(f)|0)==i[i[e+228>>2]+108>>2])break t;if(e=A,A=d2(s+24|0,23403),q(e,2,0,A),u[A+11|0]>=0)break n;Z(i[A>>2]);break n}h=i[e+196>>2],i[s+176>>2]=0;t:{if(i[h+108>>2]!=i[h+104>>2])for(f0=e+100|0,A0=e+280|0,Q=-1,f=0;;){if(B=f+1|0,k=xA(i[e+188>>2],B),!k){if(e=A,A=d2(s+24|0,24611),q(e,2,0,A),u[A+11|0]>=0)break n;Z(i[A>>2]);break n}n=i[k+8>>2],i[s+32>>2]=n,o=i[k+4>>2],i[s+24>>2]=i[k>>2],i[s+28>>2]=o,o=i[e+180>>2],k=i[o+104>>2];u:{n=n-1|0;o:{if(n>>>0>=i[o+108>>2]-k>>3>>>0){i[s+140>>2]=0,i[s+144>>2]=0;break o}if(n=k+(n<<3)|0,k=i[n>>2],i[s+140>>2]=k,n=i[n+4>>2],i[s+144>>2]=n,n&&(i[n+4>>2]=i[n+4>>2]+1),k)break u}if(e=A,A=d2(s+48|0,24263),q(e,2,0,A),u[A+11|0]>=0)break t;Z(i[A>>2]);break t}u:{o:{if(w=i[k+36>>2],n=i[k+40>>2],(w|0)!=(n|0)){if(k=i[w>>2],k&&(t=i[s+132>>2],k=W0(k,86580,105480),k))break o;if(w=w+8|0,(n|0)!=(w|0))for(;;){if(k=i[w>>2],k&&(t=0,k=W0(k,86580,105480),k))break o;if(w=w+8|0,(n|0)==(w|0))break}i[s+128>>2]=0,i[s+132>>2]=0}i[s+128>>2]=0,i[s+132>>2]=0;break u}if(i[s+132>>2]=t,i[s+128>>2]=k,k=i[w+4>>2],i[s+132>>2]=k,!k)break u;i[k+4>>2]=i[k+4>>2]+1}if(k=i[s+128>>2],k){u:{if(u[k+115|0]>=0){i[s+56>>2]=i[k+112>>2],n=i[k+108>>2],i[s+48>>2]=i[k+104>>2],i[s+52>>2]=n;break u}T(s+48|0,i[k+104>>2],i[k+108>>2])}u[e+263|0]<0&&Z(i[e+252>>2]),k=i[s+52>>2],i[e+252>>2]=i[s+48>>2],i[e+256>>2]=k,i[e+260>>2]=i[s+56>>2]}if(I2(s+128|0),!i[A0>>2]){n=s+48|0;u:{o:{if(k=i[s+140>>2],w=i[k+36>>2],o=i[k+40>>2],(w|0)!=(o|0)){if(k=i[w>>2],k&&(t=i[n+4>>2],k=W0(k,86580,86624),k))break o;if(w=w+8|0,(o|0)!=(w|0))for(;;){if(k=i[w>>2],k&&(t=0,k=W0(k,86580,86624),k))break o;if(w=w+8|0,(o|0)==(w|0))break}i[n>>2]=0,i[n+4>>2]=0}i[n>>2]=0,i[n+4>>2]=0;break u}if(i[n+4>>2]=t,i[n>>2]=k,k=i[w+4>>2],i[n+4>>2]=k,!k)break u;i[k+4>>2]=i[k+4>>2]+1}i[s+48>>2]&&r3(A0,n),I2(s+48|0)}if(u0[i[e+228>>2]+108>>2]<i[s+28>>2]+i[s+176>>2]>>>0){if(e=A,A=d2(s+48|0,22791),q(e,2,0,A),u[A+11|0]>=0)break t;Z(i[A>>2]);break t}n=i[i[e+196>>2]+104>>2],_=v-16|0,v=_,a=p(68),k=a,i[k+4>>2]=0,i[k+8>>2]=0,i[k>>2]=106632,o=i[(f<<2)+n>>2],n=0,$=i[s+28>>2],V=i[s+176>>2],t=i[e+24>>2],w=i[e+20>>2],i[_+8>>2]=i[e+228>>2],k=i[e+232>>2],i[_+12>>2]=k,k&&(i[k+4>>2]=i[k+4>>2]+1),O=0,k=a+12|0,i[k+12>>2]=0,i[k+16>>2]=0,i[k+20>>2]=0,i[k+24>>2]=0,i[k+8>>2]=t,i[k+4>>2]=w,i[k+16>>2]=V,i[k+28>>2]=0,i[k+32>>2]=0,i[k+36>>2]=0,i[k+40>>2]=0,i[k+44>>2]=0,i[k+48>>2]=0,m=0,i[k+52>>2]=0,i[k>>2]=106468,i[k+24>>2]=V,i[k+20>>2]=(V+$|0)-1;u:{o:{l:{if($)for(;;){t=i[_+8>>2],w=i[t+104>>2],w||(w=i[(i[t+112>>2]+(V<<2)|0)+(O<<2)>>2]),I=i[k+36>>2];s:{if(I>>>0>m>>>0){i[m+8>>2]=w,i[m>>2]=o,i[m+4>>2]=n,m=m+16|0;break s}if(z=i[k+28>>2],P=m-z|0,S=P>>4,t=S+1|0,t>>>0>=268435456)break l;if(m=I-z|0,I=m>>3,I=m>>>0>=2147483632?268435455:t>>>0<I>>>0?I:t,I){if(I>>>0>=268435456)break o;t=p(I<<4)}else t=0;if(m=t+P|0,i[m+8>>2]=w,i[m>>2]=o,i[m+4>>2]=n,S=m-(S<<4)|0,P&&x(S,z,P),i[k+36>>2]=t+(I<<4),m=m+16|0,i[k+32>>2]=m,i[k+28>>2]=S,!z)break s;Z(z)}if(i[k+32>>2]=m,o=o+w|0,n=o>>>0<w>>>0?n+1|0:n,O=O+1|0,($|0)==(O|0))break}break u}G0(),H()}z0(),H()}n=i[_+12>>2];u:{if(!n||(o=i[n+4>>2],i[n+4>>2]=o-1,o))break u;W[i[i[n>>2]+8>>2]](n),y(n)}i[s+52>>2]=a,i[s+48>>2]=k,v=_+16|0;u:{o:{if(k=i[s+140>>2],!k||(k=W0(k,86580,105560),!k))break o;if(i[s+128>>2]=k,k=i[s+144>>2],i[s+132>>2]=k,!k)break u;i[k+4>>2]=i[k+4>>2]+1;break u}i[s+128>>2]=0,i[s+132>>2]=0}if(k=i[s+128>>2],k){w=i[s+48>>2];u:{if(!(!f|i[s+32>>2]!=(Q|0))){k=s+168|0,f=i[(i[f0>>2]+(f<<3)|0)-8>>2],W[i[i[f>>2]+8>>2]](k,f),f=k;break u}i[s+152>>2]=k,f=i[s+132>>2],i[s+156>>2]=f,f&&(i[f+4>>2]=i[f+4>>2]+1),f=i[s+156>>2],i[s+16>>2]=i[s+152>>2],i[s+20>>2]=f,n=s+160|0,_=v-16|0,v=_,f=i[s+16>>2];o:{if(u[f+143|0]>=0){i[_+8>>2]=i[f+140>>2],k=i[f+136>>2],i[_>>2]=i[f+132>>2],i[_+4>>2]=k;break o}T(_,i[f+132>>2],i[f+136>>2])}o:{l:{s:{w:{_:{if(k=i[f+16>>2],(k|0)<=1781689192){h:{B:{v:{Z:{if((k|0)!=1635135537){if((k|0)==1635148593)break Z;if((k|0)!=1752589105)break _;t=i[f+36>>2],f=i[f+40>>2];G:{m:{if((t|0)!=(f|0))for(;;){X:{if(k=i[t>>2],!k||(k=W0(k,86580,97564),!k))break X;if(f=i[t+4>>2],!f)break m;i[f+4>>2]=i[f+4>>2]+1;break G}if(t=t+8|0,(f|0)==(t|0))break}k=0}f=0}if(o=p(88),i[o+4>>2]=0,i[o+8>>2]=0,i[o>>2]=97080,f&&(i[f+4>>2]=i[f+4>>2]+1),t=o+16|0,i[o+64>>2]=0,i[o+56>>2]=0,i[o+60>>2]=0,i[o+24>>2]=0,i[o+28>>2]=0,i[o+36>>2]=0,i[o+40>>2]=0,i[o+72>>2]=0,i[o+76>>2]=0,i[o+84>>2]=f,i[o+80>>2]=k,u[o+32|0]=0,i[o+44>>2]=0,i[o+48>>2]=0,i[o+16>>2]=97648,!f)break v;if(i[f+4>>2]==-1&&(W[i[i[f>>2]+8>>2]](f),y(f)),i[n+4>>2]=o,i[n>>2]=t,k=i[f+4>>2],i[f+4>>2]=k-1,k)break o;W[i[i[f>>2]+8>>2]](f),y(f);break o}t=i[f+36>>2],f=i[f+40>>2];G:{m:{if((t|0)!=(f|0))for(;;){X:{if(k=i[t>>2],!k||(k=W0(k,86580,98140),!k))break X;if(f=i[t+4>>2],!f)break m;i[f+4>>2]=i[f+4>>2]+1;break G}if(t=t+8|0,(f|0)==(t|0))break}k=0}f=0}if(o=p(88),i[o+4>>2]=0,i[o+8>>2]=0,i[o>>2]=97120,f&&(i[f+4>>2]=i[f+4>>2]+1),t=o+16|0,i[o+64>>2]=0,i[o+56>>2]=0,i[o+60>>2]=0,i[o+24>>2]=0,i[o+28>>2]=0,i[o+36>>2]=0,i[o+40>>2]=0,i[o+72>>2]=0,i[o+76>>2]=0,i[o+84>>2]=f,i[o+80>>2]=k,u[o+32|0]=0,i[o+44>>2]=0,i[o+48>>2]=0,i[o+16>>2]=98016,!f)break B;if(i[f+4>>2]==-1&&(W[i[i[f>>2]+8>>2]](f),y(f)),i[n+4>>2]=o,i[n>>2]=t,k=i[f+4>>2],i[f+4>>2]=k-1,k)break o;W[i[i[f>>2]+8>>2]](f),y(f);break o}t=i[f+36>>2],f=i[f+40>>2];Z:{if((t|0)!=(f|0))for(;;){G:{if(k=i[t>>2],!k||(k=W0(k,86580,100172),!k))break G;if(f=i[t+4>>2],!f){f=0;break Z}i[f+4>>2]=i[f+4>>2]+1;break Z}if(t=t+8|0,(f|0)==(t|0))break}f=0,k=0}if(o=p(88),i[o+4>>2]=0,i[o+8>>2]=0,i[o>>2]=97160,f&&(i[f+4>>2]=i[f+4>>2]+1),t=o+16|0,i[o+64>>2]=0,i[o+56>>2]=0,i[o+60>>2]=0,i[o+24>>2]=0,i[o+28>>2]=0,i[o+36>>2]=0,i[o+40>>2]=0,i[o+72>>2]=0,i[o+76>>2]=0,i[o+84>>2]=f,i[o+80>>2]=k,u[o+32|0]=0,i[o+44>>2]=0,i[o+48>>2]=0,i[o+16>>2]=100192,!f)break h;if(i[f+4>>2]==-1&&(W[i[i[f>>2]+8>>2]](f),y(f)),i[n+4>>2]=o,i[n>>2]=t,k=i[f+4>>2],i[f+4>>2]=k-1,k)break o;W[i[i[f>>2]+8>>2]](f),y(f);break o}i[n+4>>2]=o,i[n>>2]=t;break o}i[n+4>>2]=o,i[n>>2]=t;break o}i[n+4>>2]=o,i[n>>2]=t;break o}h:{if((k|0)!=1781689193){if((k|0)==1835692135)break h;if((k|0)!=1987470129)break _;t=i[f+36>>2],f=i[f+40>>2];B:{v:{if((t|0)!=(f|0))for(;;){Z:{if(k=i[t>>2],!k||(k=W0(k,86580,99876),!k))break Z;if(f=i[t+4>>2],!f)break v;i[f+4>>2]=i[f+4>>2]+1;break B}if(t=t+8|0,(f|0)==(t|0))break}k=0}f=0}if(o=p(88),i[o+4>>2]=0,i[o+8>>2]=0,i[o>>2]=97240,f&&(i[f+4>>2]=i[f+4>>2]+1),t=o+16|0,i[o+64>>2]=0,i[o+56>>2]=0,i[o+60>>2]=0,i[o+24>>2]=0,i[o+28>>2]=0,i[o+36>>2]=0,i[o+40>>2]=0,i[o+72>>2]=0,i[o+76>>2]=0,i[o+84>>2]=f,i[o+80>>2]=k,u[o+32|0]=0,i[o+44>>2]=0,i[o+48>>2]=0,i[o+16>>2]=99680,!f)break w;if(i[f+4>>2]==-1&&(W[i[i[f>>2]+8>>2]](f),y(f)),i[n+4>>2]=o,i[n>>2]=t,k=i[f+4>>2],i[f+4>>2]=k-1,k)break o;W[i[i[f>>2]+8>>2]](f),y(f);break o}t=i[f+36>>2],f=i[f+40>>2];B:{if((t|0)!=(f|0))for(;;){v:{if(k=i[t>>2],!k||(k=W0(k,86580,99476),!k))break v;if(f=i[t+4>>2],!f){f=0;break B}i[f+4>>2]=i[f+4>>2]+1;break B}if(t=t+8|0,(f|0)==(t|0))break}f=0,k=0}if(o=p(88),i[o+4>>2]=0,i[o+8>>2]=0,i[o>>2]=97200,f&&(i[f+4>>2]=i[f+4>>2]+1),t=o+16|0,i[o+64>>2]=0,i[o+56>>2]=0,i[o+60>>2]=0,i[o+24>>2]=0,i[o+28>>2]=0,i[o+36>>2]=0,i[o+40>>2]=0,i[o+72>>2]=0,i[o+76>>2]=0,i[o+84>>2]=f,i[o+80>>2]=k,u[o+32|0]=0,i[o+44>>2]=0,i[o+48>>2]=0,i[o+16>>2]=98904,!f)break s;if(i[f+4>>2]==-1&&(W[i[i[f>>2]+8>>2]](f),y(f)),i[n+4>>2]=o,i[n>>2]=t,k=i[f+4>>2],i[f+4>>2]=k-1,k)break o;W[i[i[f>>2]+8>>2]](f),y(f);break o}t=i[f+36>>2],k=i[f+40>>2];h:{if((t|0)!=(k|0))for(;;){B:{if(f=i[t>>2],!f||(f=W0(f,86580,98564),!f))break B;if(k=i[t+4>>2],!k){k=0;break h}i[k+4>>2]=i[k+4>>2]+1;break h}if(t=t+8|0,(k|0)==(t|0))break}k=0,f=0}if(o=p(112),i[o+4>>2]=0,i[o+8>>2]=0,i[o>>2]=97280,k&&(i[k+4>>2]=i[k+4>>2]+1),t=o+16|0,i[o+64>>2]=0,i[o+56>>2]=0,i[o+60>>2]=0,i[o+24>>2]=0,i[o+28>>2]=0,i[o+36>>2]=0,i[o+40>>2]=0,i[o+72>>2]=0,i[o+76>>2]=0,i[o+84>>2]=k,i[o+80>>2]=f,u[o+32|0]=0,i[o+44>>2]=0,i[o+48>>2]=0,i[o+16>>2]=98584,!k)break l;if(i[k+4>>2]=i[k+4>>2]+1,u[o+104|0]=0,u[o+88|0]=0,f=i[k+4>>2],i[k+4>>2]=f-1,f||(W[i[i[k>>2]+8>>2]](k),y(k)),i[n+4>>2]=o,i[n>>2]=t,f=i[k+4>>2],i[k+4>>2]=f-1,f)break o;W[i[i[k>>2]+8>>2]](k),y(k);break o}i[n>>2]=0,i[n+4>>2]=0;break o}i[n+4>>2]=o,i[n>>2]=t;break o}i[n+4>>2]=o,i[n>>2]=t;break o}u[o+104|0]=0,u[o+88|0]=0,i[n+4>>2]=o,i[n>>2]=t}u[_+11|0]<0&&Z(i[_>>2]),f=i[s+20>>2];o:{if(!f||(k=i[f+4>>2],i[f+4>>2]=k-1,k))break o;W[i[i[f>>2]+8>>2]](f),y(f)}v=_+16|0,f=n}k=i[f+4>>2],i[s+8>>2]=i[f>>2],i[s+12>>2]=k,f=i[s+8>>2],k=i[s+12>>2],k&&(i[k+4>>2]=i[k+4>>2]+1),i[w+40>>2]=f,f=i[w+44>>2],i[w+44>>2]=k;u:{if(!f||(k=i[f+4>>2],i[f+4>>2]=k-1,k))break u;W[i[i[f>>2]+8>>2]](f),y(f)}f=i[s+12>>2];u:{if(!f||(k=i[f+4>>2],i[f+4>>2]=k-1,k))break u;W[i[i[f>>2]+8>>2]](f),y(f)}}if(I2(s+128|0),f=s+48|0,r2(f0,f),i[s+176>>2]=i[s+176>>2]+i[s+28>>2],Q=i[s+32>>2],I2(f),I2(s+140|0),f=B,!(f>>>0<i[h+108>>2]-i[h+104>>2]>>2>>>0))break}if(f=v-16|0,v=f,n=s+140|0,i[n+8>>2]=0,i[n>>2]=0,i[n+4>>2]=0,t=i[X+36>>2],o=i[X+40>>2],(t|0)!=(o|0))for(;;){k=i[t>>2];u:{if(!k||(k=W0(k,86580,106088),!k)||(i[f+8>>2]=k,k=i[t+4>>2],i[f+12>>2]=k,k&&(i[k+4>>2]=i[k+4>>2]+1),r2(n,f+8|0),k=i[f+12>>2],!k)||(B=i[k+4>>2],i[k+4>>2]=B-1,B))break u;W[i[i[k>>2]+8>>2]](k),y(k)}if(t=t+8|0,(o|0)==(t|0))break}if(v=f+16|0,f=v-16|0,v=f,n=s+128|0,i[n+8>>2]=0,i[n>>2]=0,i[n+4>>2]=0,t=i[X+36>>2],o=i[X+40>>2],(t|0)!=(o|0))for(;;){k=i[t>>2];u:{if(!k||(k=W0(k,86580,106168),!k)||(i[f+8>>2]=k,k=i[t+4>>2],i[f+12>>2]=k,k&&(i[k+4>>2]=i[k+4>>2]+1),r2(n,f+8|0),k=i[f+12>>2],!k)||(B=i[k+4>>2],i[k+4>>2]=B-1,B))break u;W[i[i[k>>2]+8>>2]](k),y(k)}if(t=t+8|0,(o|0)==(t|0))break}v=f+16|0;u:{o:{l:{if(o=i[s+144>>2],f=i[s+140>>2],(i[s+132>>2]-i[s+128>>2]|0)==(o-f|0)){if((f|0)!=(o|0))for(B=e+276|0,X=e+272|0,t=e+100|0;;){if(k=i[f>>2],_=i[k+108>>2],n=i[k+104>>2],i[s+48>>2]=0,i[s+52>>2]=0,k=i[s+128>>2],Q=i[s+132>>2],(k|0)==(Q|0))break l;for(;;){if(w=i[k>>2],!((n|0)==i[w+104>>2]&(_|0)==i[w+108>>2])){if(k=k+8|0,(Q|0)!=(k|0))continue;break l}break}if(r3(s+48|0,k),k=i[s+48>>2],!k)break l;s:{if(k=i[k+132>>2]-i[k+128>>2]|0,(k|0)==8||(_=k>>3,k=i[e+196>>2],(_|0)==i[k+108>>2]-i[k+104>>2]>>2))break s;if(e=A,A=d2(s+24|0,22983),q(e,2,0,A),u[A+11|0]>=0)break o;Z(i[A>>2]);break o}s:{if((n|0)!=1937006953){if((n|0)!=1937074532)break s;k=L9(f,s+48|0,t),i[s+24>>2]=0,_i(B,k),_i(s+24|0,0);break s}k=L9(f,s+48|0,t),i[s+24>>2]=0,_i(X,k),_i(s+24|0,0)}if(I2(s+48|0),f=f+8|0,(o|0)==(f|0))break}s:{w:{if(r=i[r>>2],k=i[r+36>>2],n=i[r+40>>2],(k|0)!=(n|0)){if(r=i[k>>2],r&&(f=i[s+124>>2],r=W0(r,86580,87104),r))break w;if(k=k+8|0,(n|0)!=(k|0))for(;;){if(r=i[k>>2],r&&(f=0,r=W0(r,86580,87104),r))break w;if(k=k+8|0,(n|0)==(k|0))break}i[s+120>>2]=0,i[s+124>>2]=0}i[s+120>>2]=0,i[s+124>>2]=0;break s}if(i[s+124>>2]=f,i[s+120>>2]=r,r=i[k+4>>2],i[s+124>>2]=r,!r)break s;i[r+4>>2]=i[r+4>>2]+1}s:{if(r=i[s+120>>2],r){w:{_:{if(k=i[r+36>>2],n=i[r+40>>2],(k|0)!=(n|0)){if(r=i[k>>2],r&&(f=i[s+116>>2],r=W0(r,86580,89664),r))break _;if(k=k+8|0,(n|0)!=(k|0))for(;;){if(r=i[k>>2],r&&(f=0,r=W0(r,86580,89664),r))break _;if(k=k+8|0,(n|0)==(k|0))break}i[s+112>>2]=0,i[s+116>>2]=0}i[s+112>>2]=0,i[s+116>>2]=0;break w}if(i[s+116>>2]=f,i[s+112>>2]=r,r=i[k+4>>2],i[s+116>>2]=r,!r)break w;i[r+4>>2]=i[r+4>>2]+1}w:{_:{if(r=i[s+120>>2],k=i[r+36>>2],n=i[r+40>>2],(k|0)!=(n|0)){if(r=i[k>>2],r&&(f=i[s+108>>2],r=W0(r,86580,88212),r))break _;if(k=k+8|0,(n|0)!=(k|0))for(;;){if(r=i[k>>2],r&&(f=0,r=W0(r,86580,88212),r))break _;if(k=k+8|0,(n|0)==(k|0))break}i[s+104>>2]=0,i[s+108>>2]=0}i[s+104>>2]=0,i[s+108>>2]=0;break w}if(i[s+108>>2]=f,i[s+104>>2]=r,r=i[k+4>>2],i[s+108>>2]=r,!r)break w;i[r+4>>2]=i[r+4>>2]+1}if(ZA(s+96|0,i[s+120>>2]),r=i[s+96>>2],r){if(mu(s+84|0,r),k=i[s+84>>2],t=i[s+88>>2],(k|0)!=(t|0))for(B=e+52|0,r=i[26648],X=i[26649];;){f=i[k>>2];w:{if(i[f+112>>2]!=1970432288||(f=f+152|0,o=u[f+11|0],n=(o|0)<0,o=n?i[f+4>>2]:o,(h2(21423)|0)==(o|0)?f=N2(n?i[f>>2]:f,21423,o):f=1,f))break w;if(o=i[i[k>>2]+104>>2],i[s+80>>2]=0,i[s+72>>2]=0,i[s+76>>2]=0,_=i[s+112>>2],f=i[e+20>>2],n=i[f+48>>2],i[s+184>>2]=n,f=i[f+52>>2],i[s+188>>2]=f,f&&(i[f+4>>2]=i[f+4>>2]+1),i[s+24>>2]=i[n+8>>2],f=i[n+12>>2],i[s+28>>2]=f,f&&(i[f+4>>2]=i[f+4>>2]+1),f=s+24|0,n=s+72|0,q6(s+48|0,_,o,f,s+104|0,n,0,0,-1,-1,i[e+20>>2]- -64|0),I2(f),o=s+184|0,I2(o),If(f,n),l[s+44|0])break s;if(Vo(B,f),n=l[s+44|0],(n|0)!=255&&(i[s+184>>2]=r,i[s+188>>2]=X,W[i[o+(n<<2)>>2]](s+183|0,f)),u[s+67|0]<0&&Z(i[s+56>>2]),f=i[s+72>>2],!f)break w;i[s+76>>2]=f,Z(f)}if(k=k+8|0,(t|0)==(k|0))break}ve(s+84|0)}I2(s+96|0),I2(s+104|0),I2(s+112|0)}if(I2(s+120|0),u0[i[e+228>>2]+108>>2]>u0[i[e+20>>2]+144>>2]){if(e=A,A=d2(s+24|0,17285),q(e,6,1e3,A),u[A+11|0]>=0)break u;Z(i[A>>2]);break u}X=s+24|0,w=0,k=0,Q=0,m=0,o=0,n=0,f=0,h=v-32|0,v=h,r=i[i[e+228>>2]+108>>2],i[e+64>>2]=r;w:{if(!r){t=0;break w}t=0;_:{for(;;){i[h+4>>2]=0,i[h+8>>2]=0,i[h+12>>2]=0,i[h+16>>2]=0,_=f,f=f+1|0,B=i[e+204>>2],r=i[B+104>>2],r=(r|0)!=i[B+108>>2]?i[r+4>>2]:0,V=i[e+100>>2],B=i[e+104>>2]-V>>3;h:{if(B>>>0<=k>>>0|u0[i[V+(k<<3)>>2]+20>>2]>=m>>>0)break h;if(f=0,k=k+1|0,(B|0)!=(k|0))for(;;){if(u0[i[V+(k<<3)>>2]+20>>2]>=m>>>0)break h;if(k=k+1|0,(B|0)==(k|0))break}k=B}h:{B:{if(w>>>0<Q>>>0){i[w+8>>2]=k,i[w+4>>2]=_,i[w>>2]=m,B=i[h+4>>2],i[w+12>>2]=i[h>>2],i[w+16>>2]=B,B=i[h+12>>2],i[w+20>>2]=i[h+8>>2],i[w+24>>2]=B,i[w+28>>2]=i[h+16>>2],i[w+44>>2]=0,i[w+40>>2]=r,i[w+32>>2]=o,i[w+36>>2]=n,w=w+48|0;break B}if(B=w-t|0,V=((B|0)/48|0)+1|0,V>>>0>=89478486)break h;if(Q=(Q-t|0)/48|0,w=Q<<1,V=Q>>>0>=44739242?89478485:w>>>0>V>>>0?w:V,V){if(V>>>0>=89478486)break _;Q=p(G(V,48))}else Q=0;w=Q+B|0,i[w+8>>2]=k,i[w+4>>2]=_,i[w>>2]=m,_=i[h+4>>2],i[w+12>>2]=i[h>>2],i[w+16>>2]=_,_=i[h+12>>2],i[w+20>>2]=i[h+8>>2],i[w+24>>2]=_,i[w+28>>2]=i[h+16>>2],i[w+44>>2]=0,i[w+40>>2]=r,i[w+32>>2]=o,i[w+36>>2]=n,_=w+G((B|0)/-48|0,48)|0,B&&x(_,t,B),w=w+48|0,Q=Q+G(V,48)|0,t&&Z(t),t=_}if(o=r+o|0,n=o>>>0<r>>>0?n+1|0:n,m=m+1|0,m>>>0>=u0[e+64>>2])break w;continue}break}i[h+28>>2]=Q,i[h+24>>2]=w,i[h+20>>2]=t,G0(),H()}z0(),H()}i[h+28>>2]=Q,i[h+24>>2]=w,i[h+20>>2]=t;w:{_:{h:{if(f=e,r=Eo(i[f+20>>2]),o=i[f+156>>2],(r|0)!=i[o+120>>2]||(n=i[f+236>>2],!n)||(k=i[n+104>>2],(i[n+108>>2]-k|0)!=24|(i[k+8>>2]|i[k+12>>2]))||(r=i[k>>2],k=i[k+4>>2],!(u[n+100|0]&1)|((r|0)!=i[o+128>>2]|(k|0)!=i[o+132>>2])))break h;if(n=f+68|0,(n|0)!=(h+20|0)&&(Xt(n,t,w,(w-t|0)/48|0),k=i[f+156>>2],r=i[k+128>>2],k=i[k+132>>2]),!(r|k)){e=d2(h,24239),q(X,2,0,e),u[e+11|0]<0&&Z(i[e>>2]),t=i[h+20>>2];break w}r=Go(i[e+20>>2]),e=i[e+156>>2],e=d8(r,l0,i[e+128>>2],i[e+132>>2]),t=i[h+20>>2],e=O0(e,l0,(i[h+24>>2]-t|0)/48|0,0),r=l0;break _}e=e+68|0,(e|0)!=(h+20|0)&&(Xt(e,t,w,(w-t|0)/48|0),w=i[h+24>>2],t=i[h+20>>2]),e=(w-t|0)/48|0,r=0}i[f+80>>2]=e,i[f+84>>2]=r,e=X,i[e>>2]=0,i[e+4>>2]=0,i[e+16>>2]=0,i[e+8>>2]=0,i[e+12>>2]=0}if(t&&(i[h+24>>2]=t,Z(t)),v=h+32|0,i[s+24>>2]){e=i[s+28>>2],i[A>>2]=i[s+24>>2],i[A+4>>2]=e,e=i[s+36>>2],i[A+8>>2]=i[s+32>>2],i[A+12>>2]=e,i[A+16>>2]=i[s+40>>2];break u}if(i[A>>2]=0,i[A+4>>2]=0,i[A+16>>2]=0,i[A+8>>2]=0,i[A+12>>2]=0,u[s+43|0]>=0)break u;Z(i[s+32>>2]);break u}_2(),H()}if(e=A,A=d2(s+24|0,23829),q(e,2,0,A),u[A+11|0]>=0)break u;Z(i[A>>2]);break u}if(e=A,A=d2(s+24|0,23023),q(e,2,0,A),u[A+11|0]>=0)break o;Z(i[A>>2])}I2(s+48|0)}ve(s+128|0),ve(s+140|0);break n}I2(s+140|0)}if(!M||(A=i[M+4>>2],i[M+4>>2]=A-1,A))break k;W[i[i[M>>2]+8>>2]](M),y(M)}if(!N||(A=i[N+4>>2],i[N+4>>2]=A-1,A))break f;W[i[i[N>>2]+8>>2]](N),y(N);break f}if(f=f+8|0,(t|0)==(f|0))break}if(e=p(32),i[s+24>>2]=e,i[s+28>>2]=24,i[s+32>>2]=-2147483616,r=l[22888]|l[22889]<<8|(l[22890]<<16|l[22891]<<24),f=l[22884]|l[22885]<<8|(l[22886]<<16|l[22887]<<24),u[e|0]=f,u[e+1|0]=f>>>8,u[e+2|0]=f>>>16,u[e+3|0]=f>>>24,u[e+4|0]=r,u[e+5|0]=r>>>8,u[e+6|0]=r>>>16,u[e+7|0]=r>>>24,u[e+24|0]=0,r=l[22904]|l[22905]<<8|(l[22906]<<16|l[22907]<<24),f=l[22900]|l[22901]<<8|(l[22902]<<16|l[22903]<<24),u[e+16|0]=f,u[e+17|0]=f>>>8,u[e+18|0]=f>>>16,u[e+19|0]=f>>>24,u[e+20|0]=r,u[e+21|0]=r>>>8,u[e+22|0]=r>>>16,u[e+23|0]=r>>>24,r=l[22896]|l[22897]<<8|(l[22898]<<16|l[22899]<<24),f=l[22892]|l[22893]<<8|(l[22894]<<16|l[22895]<<24),u[e+8|0]=f,u[e+9|0]=f>>>8,u[e+10|0]=f>>>16,u[e+11|0]=f>>>24,u[e+12|0]=r,u[e+13|0]=r>>>8,u[e+14|0]=r>>>16,u[e+15|0]=r>>>24,q(A,2,0,s+24|0),u[s+35|0]>=0)break f;Z(i[s+24>>2])}if(!R||(A=i[R+4>>2],i[R+4>>2]=A-1,A))break e;W[i[i[R>>2]+8>>2]](R),y(R);break e}if(f=f+8|0,(t|0)==(f|0))break}if(e=p(32),i[s+24>>2]=e,i[s+28>>2]=24,i[s+32>>2]=-2147483616,r=l[23242]|l[23243]<<8|(l[23244]<<16|l[23245]<<24),f=l[23238]|l[23239]<<8|(l[23240]<<16|l[23241]<<24),u[e|0]=f,u[e+1|0]=f>>>8,u[e+2|0]=f>>>16,u[e+3|0]=f>>>24,u[e+4|0]=r,u[e+5|0]=r>>>8,u[e+6|0]=r>>>16,u[e+7|0]=r>>>24,u[e+24|0]=0,r=l[23258]|l[23259]<<8|(l[23260]<<16|l[23261]<<24),f=l[23254]|l[23255]<<8|(l[23256]<<16|l[23257]<<24),u[e+16|0]=f,u[e+17|0]=f>>>8,u[e+18|0]=f>>>16,u[e+19|0]=f>>>24,u[e+20|0]=r,u[e+21|0]=r>>>8,u[e+22|0]=r>>>16,u[e+23|0]=r>>>24,r=l[23250]|l[23251]<<8|(l[23252]<<16|l[23253]<<24),f=l[23246]|l[23247]<<8|(l[23248]<<16|l[23249]<<24),u[e+8|0]=f,u[e+9|0]=f>>>8,u[e+10|0]=f>>>16,u[e+11|0]=f>>>24,u[e+12|0]=r,u[e+13|0]=r>>>8,u[e+14|0]=r>>>16,u[e+15|0]=r>>>24,q(A,2,0,s+24|0),u[s+35|0]>=0)break e;Z(i[s+24>>2])}e:{if(!E||(A=i[E+4>>2],i[E+4>>2]=A-1,A))break e;W[i[i[E>>2]+8>>2]](E),y(E)}if(!F||(A=i[F+4>>2],i[F+4>>2]=A-1,A))break i;W[i[i[F>>2]+8>>2]](F),y(F)}v=s+192|0}function T_(A,e,r,f,k,n,t){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,t=t|0;var o=0,s=0,w=0,h=0,_=0,B=0,m=0,X=0,Q=0,V=0,F=0,I=0,E=0,R=0,N=0,M=0,z=0,S=0,O=0,P=0,a=0,$=0,f0=0,A0=0,n0=0,_0=0,m0=0,X0=0,g0=0,I0=0,e0=0,r0=0,N0=0,U0=0,M0=0,H0=0,P0=0,K0=0,$0=0,L0=0,d0=0,n2=0,Z2=0,Q2=0,g2=0,p2=0,H2=0,T2=0;E=v+-64|0,v=E,X=i[e+116>>2],_=t+4|0,h=_,s=h,o=i[t+4>>2];i:{e:{r:{if(!o)break r;for(s=o;m=X>>>0>u0[s+16>>2],h=m?h:s,s=i[(m?4:0)+s>>2],!!s;);if(!((h|0)==(_|0)|X>>>0<u0[h+16>>2])){f=p(32),i[E+28>>2]=f,i[E+32>>2]=28,i[E+36>>2]=-2147483616,e=l[5952]|l[5953]<<8|(l[5954]<<16|l[5955]<<24),u[f+24|0]=e,u[f+25|0]=e>>>8,u[f+26|0]=e>>>16,u[f+27|0]=e>>>24,r=l[5948]|l[5949]<<8|(l[5950]<<16|l[5951]<<24),e=l[5944]|l[5945]<<8|(l[5946]<<16|l[5947]<<24),u[f+16|0]=e,u[f+17|0]=e>>>8,u[f+18|0]=e>>>16,u[f+19|0]=e>>>24,u[f+20|0]=r,u[f+21|0]=r>>>8,u[f+22|0]=r>>>16,u[f+23|0]=r>>>24,r=l[5940]|l[5941]<<8|(l[5942]<<16|l[5943]<<24),e=l[5936]|l[5937]<<8|(l[5938]<<16|l[5939]<<24),u[f+8|0]=e,u[f+9|0]=e>>>8,u[f+10|0]=e>>>16,u[f+11|0]=e>>>24,u[f+12|0]=r,u[f+13|0]=r>>>8,u[f+14|0]=r>>>16,u[f+15|0]=r>>>24,r=l[5932]|l[5933]<<8|(l[5934]<<16|l[5935]<<24),e=l[5928]|l[5929]<<8|(l[5930]<<16|l[5931]<<24),u[f|0]=e,u[f+1|0]=e>>>8,u[f+2|0]=e>>>16,u[f+3|0]=e>>>24,u[f+4|0]=r,u[f+5|0]=r>>>8,u[f+6|0]=r>>>16,u[f+7|0]=r>>>24,u[f+28|0]=0,f=q(E+40|0,2,0,E+28|0),e=i[f+4>>2],i[A>>2]=i[f>>2],i[A+4>>2]=e,r=A+8|0;f:{if(u[f+19|0]>=0){e=i[f+12>>2],i[r>>2]=i[f+8>>2],i[r+4>>2]=e,i[r+8>>2]=i[f+16>>2],u[A+20|0]=1;break f}if(T(r,i[f+8>>2],i[f+12>>2]),e=u[f+19|0],u[A+20|0]=1,(e|0)>=0)break f;Z(i[f+8>>2])}if(u[E+39|0]>=0)break i;Z(i[E+28>>2]);break i}for(;;){if(s=o,h=i[s+16>>2],h>>>0>X>>>0){if(h=s,o=i[s>>2],o)continue;break r}if(h>>>0>=X>>>0)break e;if(o=i[s+4>>2],!o)break}h=s+4|0}o=p(20),i[o+8>>2]=s,i[o>>2]=0,i[o+4>>2]=0,i[o+16>>2]=X,i[h>>2]=o,s=i[i[t>>2]>>2],s&&(i[t>>2]=s),m1(i[t+4>>2],o),i[t+8>>2]=i[t+8>>2]+1}if(f){i[E+20>>2]=0,i[E+24>>2]=0,i[E+16>>2]=E+20,o=E+16|0,t8(o,i[t>>2],_),s=v-48|0,v=s,f=s+24|0,r4(f,i[e+100>>2],i[(i[e+460>>2]+(G(C[e+450>>1],n)<<2)|0)+(k<<2)>>2],1),t=i[s+28>>2],e=f,f=i[s+24>>2],W[i[i[f>>2]+52>>2]](e,f);e:{if(i[s+24>>2]){if(e=i[s+28>>2],i[A>>2]=i[s+24>>2],i[A+4>>2]=e,r=A+8|0,u[s+43|0]>=0){e=i[s+36>>2],i[r>>2]=i[s+32>>2],i[r+4>>2]=e,i[r+8>>2]=i[s+40>>2],u[A+20|0]=1;break e}if(T(r,i[s+32>>2],i[s+36>>2]),e=u[s+43|0],u[A+20|0]=1,(e|0)>=0)break e;Z(i[s+32>>2]);break e}u[s+43|0]<0&&Z(i[s+32>>2]),i[s+16>>2]=0,i[s+20>>2]=0,i[s+12>>2]=s+16,e=s+12|0,t8(e,i[o>>2],o+4|0),W[i[i[f>>2]+104>>2]](A,f,r,1,k,n,e),Y1(e,i[s+16>>2])}e:{if(!t||(A=i[t+4>>2],i[t+4>>2]=A-1,A))break e;W[i[i[t>>2]+8>>2]](t),y(t)}v=s+48|0,Y1(o,i[E+20>>2]);break i}i[E+8>>2]=0,i[E+12>>2]=0,i[E+4>>2]=E+8,$0=E+4|0,t8($0,i[t>>2],_),f=0,w=v-240|0,v=w,i[w+232>>2]=0,i[w+236>>2]=0;e:{r:{f:{A:{k:{if(k=i[e+460>>2],t=i[e+464>>2],(k|0)==(t|0))break k;for(;;){if(n=i[k>>2],go(i[e+100>>2],n)){if(k=k+4|0,(t|0)!=(k|0))continue;break k}break}i[w+172>>2]=0,i[w+144>>2]=72196,i[w+88>>2]=72176,e=i[18053],i[w+80>>2]=e,k=w+80|0,i[k+i[e-12>>2]>>2]=i[18054],i[w+84>>2]=0,e=k+i[i[w+80>>2]-12>>2]|0,f=w+92|0,J0(e,f),u[e+80|0]=0,i[e+72>>2]=0,e=i[18055],i[w+88>>2]=e,r=w+88|0,i[r+i[e-12>>2]>>2]=i[18056],e=i[18052],i[w+80>>2]=e,i[k+i[e-12>>2]>>2]=i[18057],i[w+144>>2]=72196,i[w+80>>2]=72156,i[w+88>>2]=72176,k=R0(f),i[k>>2]=71232,i[w+132>>2]=0,i[w+136>>2]=0,i[w+124>>2]=0,i[w+128>>2]=0,i[w+140>>2]=24,Y(V0(Y(r,21018,14),n),25314,23),e=i[w+140>>2];n:{if(e&16){t=w+112|0,e=i[w+136>>2],r=i[w+116>>2],e>>>0<r>>>0&&(i[w+136>>2]=r,e=r);break n}if(!(e&8)){e=0,u[w+55|0]=0,t=w+44|0;break r}t=w+100|0,e=i[w+108>>2]}if(f=i[t>>2],e=e-f|0,e>>>0>=2147483640)break A;if(e>>>0>=11){r=e|7,t=p(r+1|0),i[w+52>>2]=r-2147483647,i[w+44>>2]=t,i[w+48>>2]=e;break f}if(u[w+55|0]=e,t=w+44|0,e)break f;e=0;break r}di(w+80|0,i[e+100>>2]- -64|0,i[e+452>>2],i[e+456>>2]);k:{if(i[w+80>>2]){e=i[w+84>>2],i[A>>2]=i[w+80>>2],i[A+4>>2]=e,r=A+8|0;n:{if(u[w+99|0]>=0){e=i[w+92>>2],i[r>>2]=i[w+88>>2],i[r+4>>2]=e,i[r+8>>2]=i[w+96>>2];break n}T(r,i[w+88>>2],i[w+92>>2])}u[A+20|0]=1;break k}k=i[r+4>>2],k&&W[k|0](0,G(C[e+450>>1],C[e+448>>1]),i[r+16>>2]),k=i[r+8>>2],k&&W[k|0](0,0,i[r+16>>2]),i[w+40>>2]=0,O=p(12),i[O+8>>2]=0,i[O>>2]=0,i[O+4>>2]=0,P=p(16),i[P+12>>2]=O,i[P>>2]=101344,i[P+4>>2]=0,i[P+8>>2]=0,t=C[e+448>>1];n:{t:{if(!t)break t;for(H2=$0+4|0,F=A+8|0,k=C[e+450>>1],Q=w- -64|0,T2=w+24|0,n=0;;){u:{o:{if(k&65535){L0=0,t=0;break o}k=0,n0=0;break u}for(;;){k=w+56|0,h=i[i[e+460>>2]+(_0<<2)>>2],r4(k,i[e+100>>2],h,1),e0=i[w+60>>2],_=i[w+56>>2];o:{if(!_){if(!(l[r+21|0]|!_0)){u[w+44|0]=0,u[w+55|0]=0,o=q(k,2,119,w+44|0),s=i[O+4>>2];l:{if(s>>>0<u0[O+8>>2]){k=i[o+4>>2],i[s>>2]=i[o>>2],i[s+4>>2]=k,i[s+16>>2]=i[Q+8>>2],k=i[Q+4>>2],i[s+8>>2]=i[Q>>2],i[s+12>>2]=k,i[Q>>2]=0,i[Q+4>>2]=0,i[Q+8>>2]=0,i[O+4>>2]=s+20;break l}if(o=ee(O,o),k=u[w+75|0],i[O+4>>2]=o,(k|0)>=0)break l;Z(i[w+64>>2])}u[w+55|0]<0&&Z(i[w+44>>2]),t=f+t|0,_0=_0+1|0,k=9,n0=0;break o}s=p(40),i[w+44>>2]=s,i[w+48>>2]=33,i[w+52>>2]=-2147483608,u[s+32|0]=l[17751],o=l[17747]|l[17748]<<8|(l[17749]<<16|l[17750]<<24),k=l[17743]|l[17744]<<8|(l[17745]<<16|l[17746]<<24),u[s+24|0]=k,u[s+25|0]=k>>>8,u[s+26|0]=k>>>16,u[s+27|0]=k>>>24,u[s+28|0]=o,u[s+29|0]=o>>>8,u[s+30|0]=o>>>16,u[s+31|0]=o>>>24,o=l[17739]|l[17740]<<8|(l[17741]<<16|l[17742]<<24),k=l[17735]|l[17736]<<8|(l[17737]<<16|l[17738]<<24),u[s+16|0]=k,u[s+17|0]=k>>>8,u[s+18|0]=k>>>16,u[s+19|0]=k>>>24,u[s+20|0]=o,u[s+21|0]=o>>>8,u[s+22|0]=o>>>16,u[s+23|0]=o>>>24,o=l[17731]|l[17732]<<8|(l[17733]<<16|l[17734]<<24),k=l[17727]|l[17728]<<8|(l[17729]<<16|l[17730]<<24),u[s+8|0]=k,u[s+9|0]=k>>>8,u[s+10|0]=k>>>16,u[s+11|0]=k>>>24,u[s+12|0]=o,u[s+13|0]=o>>>8,u[s+14|0]=o>>>16,u[s+15|0]=o>>>24,o=l[17723]|l[17724]<<8|(l[17725]<<16|l[17726]<<24),k=l[17719]|l[17720]<<8|(l[17721]<<16|l[17722]<<24),u[s|0]=k,u[s+1|0]=k>>>8,u[s+2|0]=k>>>16,u[s+3|0]=k>>>24,u[s+4|0]=o,u[s+5|0]=o>>>8,u[s+6|0]=o>>>16,u[s+7|0]=o>>>24,u[s+33|0]=0,o=q(w+56|0,2,119,w+44|0),k=i[o+4>>2],i[A>>2]=i[o>>2],i[A+4>>2]=k;l:{if(u[w+75|0]>=0){k=i[Q+4>>2],i[F>>2]=i[Q>>2],i[F+4>>2]=k,i[F+8>>2]=i[Q+8>>2],u[A+20|0]=1;break l}if(T(F,i[w+64>>2],i[w+68>>2]),k=u[w+75|0],u[A+20|0]=1,(k|0)>=0)break l;Z(i[w+64>>2])}u[w+55|0]<0&&Z(i[w+44>>2]),k=1,n0=0;break o}W[i[i[_>>2]+52>>2]](w+56|0,_),s=i[w+56>>2],k=0;l:{if(!s)break l;if(!(l[r+21|0]|!_0)){k=O,X=i[k+4>>2];s:{if(X>>>0<u0[k+8>>2]){if(o=i[w+60>>2],i[X>>2]=i[w+56>>2],i[X+4>>2]=o,m=X+8|0,u[w+75|0]>=0){o=i[Q+4>>2],i[m>>2]=i[Q>>2],i[m+4>>2]=o,i[m+8>>2]=i[Q+8>>2],o=X+20|0;break s}T(m,i[w+64>>2],i[w+68>>2]),o=X+20|0;break s}o=fi(O,w+56|0)}i[k+4>>2]=o,t=f+t|0,_0=_0+1|0,k=9;break l}k=i[w+60>>2],i[A>>2]=i[w+56>>2],i[A+4>>2]=k;s:{if(u[w+75|0]>=0){k=i[Q+4>>2],i[F>>2]=i[Q>>2],i[F+4>>2]=k,i[F+8>>2]=i[Q+8>>2];break s}T(F,i[w+64>>2],i[w+68>>2])}u[A+20|0]=1,k=1}if(u[w+75|0]<0&&Z(i[w+64>>2]),n0=0,s)break o;M0=i[_+120>>2],o=i[_+124>>2],di(w+56|0,i[e+100>>2]- -64|0,M0,o),s=i[w+60>>2],k=i[w+56>>2],i[w+80>>2]=k,i[w+84>>2]=s,u[w+99|0]<0&&(Z(i[w+88>>2]),k=i[w+80>>2]),s=i[Q+4>>2],i[w+88>>2]=i[Q>>2],i[w+92>>2]=s,i[w+96>>2]=i[Q+8>>2];l:{if(k){if(k=i[w+84>>2],i[A>>2]=i[w+80>>2],i[A+4>>2]=k,u[w+99|0]>=0){k=i[w+92>>2],i[F>>2]=i[w+88>>2],i[F+4>>2]=k,i[F+8>>2]=i[w+96>>2];break l}T(F,i[w+88>>2],i[w+92>>2]);break l}s:{if(u0[e+452>>2]/C[e+450>>1]>>>0<=M0>>>0&&o>>>0>=u0[e+456>>2]/C[e+448>>1]>>>0)break s;s=p(40),i[w+44>>2]=s,i[w+48>>2]=35,i[w+52>>2]=-2147483608,k=l[14785]|l[14786]<<8|(l[14787]<<16|l[14788]<<24),u[s+31|0]=k,u[s+32|0]=k>>>8,u[s+33|0]=k>>>16,u[s+34|0]=k>>>24,o=l[14782]|l[14783]<<8|(l[14784]<<16|l[14785]<<24),k=l[14778]|l[14779]<<8|(l[14780]<<16|l[14781]<<24),u[s+24|0]=k,u[s+25|0]=k>>>8,u[s+26|0]=k>>>16,u[s+27|0]=k>>>24,u[s+28|0]=o,u[s+29|0]=o>>>8,u[s+30|0]=o>>>16,u[s+31|0]=o>>>24,o=l[14774]|l[14775]<<8|(l[14776]<<16|l[14777]<<24),k=l[14770]|l[14771]<<8|(l[14772]<<16|l[14773]<<24),u[s+16|0]=k,u[s+17|0]=k>>>8,u[s+18|0]=k>>>16,u[s+19|0]=k>>>24,u[s+20|0]=o,u[s+21|0]=o>>>8,u[s+22|0]=o>>>16,u[s+23|0]=o>>>24,o=l[14766]|l[14767]<<8|(l[14768]<<16|l[14769]<<24),k=l[14762]|l[14763]<<8|(l[14764]<<16|l[14765]<<24),u[s+8|0]=k,u[s+9|0]=k>>>8,u[s+10|0]=k>>>16,u[s+11|0]=k>>>24,u[s+12|0]=o,u[s+13|0]=o>>>8,u[s+14|0]=o>>>16,u[s+15|0]=o>>>24,o=l[14758]|l[14759]<<8|(l[14760]<<16|l[14761]<<24),k=l[14754]|l[14755]<<8|(l[14756]<<16|l[14757]<<24),u[s|0]=k,u[s+1|0]=k>>>8,u[s+2|0]=k>>>16,u[s+3|0]=k>>>24,u[s+4|0]=o,u[s+5|0]=o>>>8,u[s+6|0]=o>>>16,u[s+7|0]=o>>>24,u[s+35|0]=0,o=q(w+56|0,2,118,w+44|0),k=i[o+4>>2],i[A>>2]=i[o>>2],i[A+4>>2]=k;w:{if(u[w+75|0]>=0){k=i[Q+4>>2],i[F>>2]=i[Q>>2],i[F+4>>2]=k,i[F+8>>2]=i[Q+8>>2],u[A+20|0]=1;break w}if(T(F,i[w+64>>2],i[w+68>>2]),k=u[w+75|0],u[A+20|0]=1,(k|0)>=0)break w;Z(i[w+64>>2])}u[w+55|0]<0&&Z(i[w+44>>2]),k=1;break o}s:{if(!(L0|Z2)){f=M0,n=o;break s}if((f|0)==(M0|0)&(n|0)==(o|0))break s;s=p(32),i[w+44>>2]=s,i[w+48>>2]=31,i[w+52>>2]=-2147483616,o=l[5177]|l[5178]<<8|(l[5179]<<16|l[5180]<<24),k=l[5173]|l[5174]<<8|(l[5175]<<16|l[5176]<<24),u[s+23|0]=k,u[s+24|0]=k>>>8,u[s+25|0]=k>>>16,u[s+26|0]=k>>>24,u[s+27|0]=o,u[s+28|0]=o>>>8,u[s+29|0]=o>>>16,u[s+30|0]=o>>>24,o=l[5170]|l[5171]<<8|(l[5172]<<16|l[5173]<<24),k=l[5166]|l[5167]<<8|(l[5168]<<16|l[5169]<<24),u[s+16|0]=k,u[s+17|0]=k>>>8,u[s+18|0]=k>>>16,u[s+19|0]=k>>>24,u[s+20|0]=o,u[s+21|0]=o>>>8,u[s+22|0]=o>>>16,u[s+23|0]=o>>>24,o=l[5162]|l[5163]<<8|(l[5164]<<16|l[5165]<<24),k=l[5158]|l[5159]<<8|(l[5160]<<16|l[5161]<<24),u[s+8|0]=k,u[s+9|0]=k>>>8,u[s+10|0]=k>>>16,u[s+11|0]=k>>>24,u[s+12|0]=o,u[s+13|0]=o>>>8,u[s+14|0]=o>>>16,u[s+15|0]=o>>>24,o=l[5154]|l[5155]<<8|(l[5156]<<16|l[5157]<<24),k=l[5150]|l[5151]<<8|(l[5152]<<16|l[5153]<<24),u[s|0]=k,u[s+1|0]=k>>>8,u[s+2|0]=k>>>16,u[s+3|0]=k>>>24,u[s+4|0]=o,u[s+5|0]=o>>>8,u[s+6|0]=o>>>16,u[s+7|0]=o>>>24,u[s+31|0]=0,o=q(w+56|0,2,118,w+44|0),k=i[o+4>>2],i[A>>2]=i[o>>2],i[A+4>>2]=k;w:{if(u[w+75|0]>=0){k=i[Q+4>>2],i[F>>2]=i[Q>>2],i[F+4>>2]=k,i[F+8>>2]=i[Q+8>>2],u[A+20|0]=1;break w}if(T(F,i[w+64>>2],i[w+68>>2]),k=u[w+75|0],u[A+20|0]=1,(k|0)>=0)break w;Z(i[w+64>>2])}u[w+55|0]<0&&Z(i[w+44>>2]),k=1;break o}k=i[r+44>>2],k?n0=(W[k|0](i[r+16>>2])|0)!=0:n0=0,i[w+36>>2]=P,i[w+32>>2]=O,i[P+4>>2]=i[P+4>>2]+1,i[w+20>>2]=T2,i[w+24>>2]=0,i[w+28>>2]=0,o=w+20|0,t8(o,i[$0>>2],H2),k=i[w+36>>2],i[w+8>>2]=i[w+32>>2],i[w+12>>2]=k,R=w+56|0,r0=w+232|0,B=v-80|0,v=B,k=B+40|0,r4(k,i[e+100>>2],h,1),N0=i[B+44>>2];s:{w:{s=i[B+40>>2];_:{if(!(s|l[r+21|0])){s=i[w+8>>2],u[B+64|0]=0,u[B+75|0]=0,h=q(k,2,119,B- -64|0),o=i[s+4>>2];h:{if(o>>>0<u0[s+8>>2]){k=i[h+4>>2],i[o>>2]=i[h>>2],i[o+4>>2]=k,i[o+16>>2]=i[h+16>>2],k=i[h+12>>2],i[o+8>>2]=i[h+8>>2],i[o+12>>2]=k,i[h+16>>2]=0,i[h+8>>2]=0,i[h+12>>2]=0,i[s+4>>2]=o+20;break h}if(o=ee(s,h),k=u[h+19|0],i[s+4>>2]=o,(k|0)>=0)break h;Z(i[h+8>>2])}if(u[B+75|0]<0&&Z(i[B+64>>2]),s=i[r+8>>2],s&&(o=i[r+16>>2],k=i[w+40>>2]+1|0,i[w+40>>2]=k,W[s|0](0,k,o)),k=i[26917],i[R>>2]=i[26916],i[R+4>>2]=k,o=R+8|0,I=0,u[107683]>=0){k=i[26919],i[o>>2]=i[26918],i[o+4>>2]=k,i[o+8>>2]=i[26920];break _}T(o,i[26918],i[26919]);break _}if(W[i[i[s>>2]+52>>2]](R,s),I=0,i[R>>2])break _;u[R+19|0]<0&&Z(i[R+8>>2]),i[B+32>>2]=0,i[B+36>>2]=0,i[B+28>>2]=B+32,k=B+28|0,t8(k,i[o>>2],o+4|0),W[i[i[s>>2]+100>>2]](B+40|0,s,r,0,0,0,k),Y1(k,i[B+32>>2]),k=l[B+60|0];h:{if(k){if(!l[r+21|0]){if((k|0)!=1)break w;o=i[w+8>>2],h=i[o+4>>2];B:{if(h>>>0<u0[o+8>>2]){k=i[B+44>>2],i[h>>2]=i[B+40>>2],i[h+4>>2]=k,s=h+8|0;v:{if(u[B+59|0]>=0){k=i[B+52>>2],i[s>>2]=i[B+48>>2],i[s+4>>2]=k,i[s+8>>2]=i[B+56>>2];break v}T(s,i[B+48>>2],i[B+52>>2])}k=h+20|0;break B}k=fi(o,B+40|0)}if(i[o+4>>2]=k,s=i[r+8>>2],s&&(o=i[r+16>>2],k=i[w+40>>2]+1|0,i[w+40>>2]=k,W[s|0](0,k,o)),k=i[26917],i[R>>2]=i[26916],i[R+4>>2]=k,o=R+8|0,u[107683]>=0){k=i[26919],i[o>>2]=i[26918],i[o+4>>2]=k,i[o+8>>2]=i[26920];break h}T(o,i[26918],i[26919]);break h}if((k|0)!=1)break w;if(k=i[B+44>>2],i[R>>2]=i[B+40>>2],i[R+4>>2]=k,o=R+8|0,u[B+59|0]>=0){k=i[B+52>>2],i[o>>2]=i[B+48>>2],i[o+4>>2]=k,i[o+8>>2]=i[B+56>>2];break h}T(o,i[B+48>>2],i[B+52>>2]);break h}I=i[B+44>>2],I&&(i[I+4>>2]=i[I+4>>2]+1),g0=i[B+40>>2];B:{if(o=i[r0>>2],!o){s=i[e+456>>2],o=i[e+452>>2],h=p(172),i[h+4>>2]=0,i[h+8>>2]=0,i[h>>2]=94812,o0(h+16|0,0,80),i[h+104>>2]=0,i[h+108>>2]=0,i[h+36>>2]=1,i[h+40>>2]=1,u[h+24|0]=1,g[h+22>>1]=2,g[h+18>>1]=2,g[h+20>>1]=2,i[h+112>>2]=0,i[h+116>>2]=4740,i[h+140>>2]=0,i[h+144>>2]=0,i[h+128>>2]=99,i[h+132>>2]=99,i[h+120>>2]=0,i[h+124>>2]=0,i[h+12>>2]=95160,i[h+148>>2]=0,i[h+152>>2]=0,i[h+136>>2]=h+140,i[h+156>>2]=0,i[h+160>>2]=0,i[h+164>>2]=0,i[h+168>>2]=0,i[B+68>>2]=h,k=h+12|0,i[B+64>>2]=k,i[h+96>>2]=k,i[h+8>>2]=i[h+8>>2]+1,i[h+100>>2]=h,i[h+4>>2]==-1&&(W[i[i[h>>2]+8>>2]](h),y(h)),k=i[B+64>>2],i[B+24>>2]=I,i[B+20>>2]=g0,I&&(i[I+4>>2]=i[I+4>>2]+1),g9(R,k,B+20|0,o,s,i[e+100>>2]- -64|0),o=i[B+24>>2];v:{if(!o||(k=i[o+4>>2],i[o+4>>2]=k-1,k))break v;W[i[i[o>>2]+8>>2]](o),y(o)}if(i[R>>2])break B;if(u1(i[B+64>>2],6)){M=(-1<<j0(i[B+64>>2],6)^-1)&65535,I0=0,k=1;v:{Z:{G:{m:switch(s=i[B+64>>2],i[s+120>>2]){case 10:case 12:case 14:break m;case 11:case 13:case 15:break G;case 0:case 1:case 2:case 3:case 99:break v;default:break Z}k=3;break v}k=4;break v}k=0}N=k,o=i[s+128>>2];v:{if(!o)break v;for(s=s+128|0,h=s,k=o;m=i[k+16>>2]<6,h=m?h:k,k=i[(m?4:0)+k>>2],!!k;);m=0;Z:{if((s|0)==(h|0)||(m=0,i[h+16>>2]>6))break Z;m=l[h+24|0]<9}for(h=s,k=o;_=i[k+16>>2]<6,h=_?h:k,k=i[(_?4:0)+k>>2],!!k;);X=0;Z:{if((s|0)==(h|0)||(X=0,i[h+16>>2]>6))break Z;X=i[h+28>>2]}for(h=s,k=o;_=i[k+16>>2]<6,h=_?h:k,k=i[(_?4:0)+k>>2],!!k;);if(_=0,_=(s|0)==(h|0)|i[h+16>>2]>6?_:i[h+32>>2],m){for(k=s;h=i[o+16>>2]<6,k=h?k:o,o=i[(h?4:0)+o>>2],!!o;);Z:{if((k|0)==(s|0)){h=0,o=0;break Z}if(h=0,o=0,i[k+16>>2]>6)break Z;h=i[k+56>>2],o=i[k+44>>2]}if(!_)break v;if(k=o,X=G(X,N),N=0,o=0,_>>>0>=4)for(s=_&-4;m=!X,m||o0(k+G(o,h)|0,M,X),m||o0(k+G(o|1,h)|0,M,X),m||o0(k+G(o|2,h)|0,M,X),m||o0(k+G(o|3,h)|0,M,X),o=o+4|0,I0=I0+4|0,(s|0)!=(I0|0););if(s=_&3,!s)break v;for(;X&&o0(k+G(o,h)|0,M,X),o=o+1|0,N=N+1|0,(s|0)!=(N|0););break v}for(k=s;h=i[o+16>>2]<6,k=h?k:o,o=i[(h?4:0)+o>>2],!!o;);o=0;Z:{if((k|0)==(s|0)||(o=0,i[k+16>>2]>6))break Z;I0=i[k+44>>2],o=i[k+56>>2]>>>1|0}if(!_||(s=G(X,N),!s))break v;for(k=o,Q2=s&-8,d0=s&7,N=0,g2=s>>>0<8;;){if(a=(G(k,N)<<1)+I0|0,f0=0,!g2)for(U0=a+14|0,m0=a+12|0,X0=a+10|0,X=a+8|0,m=a+6|0,s=a+4|0,o=a+2|0,h=0;z=f0<<1,g[z+a>>1]=M,g[o+z>>1]=M,g[s+z>>1]=M,g[m+z>>1]=M,g[X+z>>1]=M,g[z+X0>>1]=M,g[z+m0>>1]=M,g[z+U0>>1]=M,f0=f0+8|0,h=h+8|0,(Q2|0)!=(h|0););if(o=0,d0)for(;g[a+(f0<<1)>>1]=M,f0=f0+1|0,o=o+1|0,(d0|0)!=(o|0););if(N=N+1|0,(N|0)==(_|0))break}}}k=i[B+64>>2],i[B+24>>2]=I,i[B+20>>2]=g0,I&&(i[I+4>>2]=i[I+4>>2]+1),_=v-32|0,v=_,m=B+20|0,s=i[m>>2],o=C[s+10>>1]|C[s+12>>1]<<16,i[_+8>>2]=C[s+6>>1]|C[s+8>>1]<<16,i[_+12>>2]=o,W[i[i[k>>2]+8>>2]](k,_+8|0),W[i[i[k>>2]+12>>2]](k,i[m>>2]+16|0),o=i[m>>2],h=i[o+24>>2],s=i[o+28>>2],(h|0)!=(s|0)&&(W[i[i[k>>2]+20>>2]](k,h,s),o=i[m>>2]),C[o+32>>1]|C[o+34>>1]&&(i[_+8>>2]=i[o+32>>2],W[i[i[k>>2]+24>>2]](k,_+8|0),o=i[m>>2]),l[o+60|0]==1&&(s=i[o+56>>2],i[_+24>>2]=i[o+52>>2],i[_+28>>2]=s,s=i[o+48>>2],i[_+16>>2]=i[o+44>>2],i[_+20>>2]=s,s=i[o+40>>2],i[_+8>>2]=i[o+36>>2],i[_+12>>2]=s,W[i[i[k>>2]+28>>2]](k,_+8|0),o=i[m>>2]),W[i[i[k>>2]+16>>2]](k,l[o+4|0]),v=_+32|0,I2(m),r3(r0,B- -64|0),u[R+19|0]<0&&Z(i[R+8>>2]),I2(B- -64|0),o=i[r0>>2]}if(i[o+120>>2]!=i[g0+120>>2]){if(s=p(64),i[B+64>>2]=s,i[B+68>>2]=58,i[B+72>>2]=-2147483584,o=l[14956]|l[14957]<<8|(l[14958]<<16|l[14959]<<24),k=l[14952]|l[14953]<<8|(l[14954]<<16|l[14955]<<24),u[s|0]=k,u[s+1|0]=k>>>8,u[s+2|0]=k>>>16,u[s+3|0]=k>>>24,u[s+4|0]=o,u[s+5|0]=o>>>8,u[s+6|0]=o>>>16,u[s+7|0]=o>>>24,u[s+58|0]=0,k=l[15008]|l[15009]<<8,u[s+56|0]=k,u[s+57|0]=k>>>8,o=l[15004]|l[15005]<<8|(l[15006]<<16|l[15007]<<24),k=l[15e3]|l[15001]<<8|(l[15002]<<16|l[15003]<<24),u[s+48|0]=k,u[s+49|0]=k>>>8,u[s+50|0]=k>>>16,u[s+51|0]=k>>>24,u[s+52|0]=o,u[s+53|0]=o>>>8,u[s+54|0]=o>>>16,u[s+55|0]=o>>>24,o=l[14996]|l[14997]<<8|(l[14998]<<16|l[14999]<<24),k=l[14992]|l[14993]<<8|(l[14994]<<16|l[14995]<<24),u[s+40|0]=k,u[s+41|0]=k>>>8,u[s+42|0]=k>>>16,u[s+43|0]=k>>>24,u[s+44|0]=o,u[s+45|0]=o>>>8,u[s+46|0]=o>>>16,u[s+47|0]=o>>>24,o=l[14988]|l[14989]<<8|(l[14990]<<16|l[14991]<<24),k=l[14984]|l[14985]<<8|(l[14986]<<16|l[14987]<<24),u[s+32|0]=k,u[s+33|0]=k>>>8,u[s+34|0]=k>>>16,u[s+35|0]=k>>>24,u[s+36|0]=o,u[s+37|0]=o>>>8,u[s+38|0]=o>>>16,u[s+39|0]=o>>>24,o=l[14980]|l[14981]<<8|(l[14982]<<16|l[14983]<<24),k=l[14976]|l[14977]<<8|(l[14978]<<16|l[14979]<<24),u[s+24|0]=k,u[s+25|0]=k>>>8,u[s+26|0]=k>>>16,u[s+27|0]=k>>>24,u[s+28|0]=o,u[s+29|0]=o>>>8,u[s+30|0]=o>>>16,u[s+31|0]=o>>>24,o=l[14972]|l[14973]<<8|(l[14974]<<16|l[14975]<<24),k=l[14968]|l[14969]<<8|(l[14970]<<16|l[14971]<<24),u[s+16|0]=k,u[s+17|0]=k>>>8,u[s+18|0]=k>>>16,u[s+19|0]=k>>>24,u[s+20|0]=o,u[s+21|0]=o>>>8,u[s+22|0]=o>>>16,u[s+23|0]=o>>>24,o=l[14964]|l[14965]<<8|(l[14966]<<16|l[14967]<<24),k=l[14960]|l[14961]<<8|(l[14962]<<16|l[14963]<<24),u[s+8|0]=k,u[s+9|0]=k>>>8,u[s+10|0]=k>>>16,u[s+11|0]=k>>>24,u[s+12|0]=o,u[s+13|0]=o>>>8,u[s+14|0]=o>>>16,u[s+15|0]=o>>>24,q(R,2,127,B- -64|0),u[B+75|0]>=0)break h;Z(i[B+64>>2]);break h}i[B+68>>2]=I,i[B+64>>2]=g0,I&&(i[I+4>>2]=i[I+4>>2]+1),h=o,V=v-32|0,v=V,f0=B- -64|0,k=i[f0>>2],U0=V+24|0,i[V+20>>2]=U0,i[V+24>>2]=0,i[V+28>>2]=0;v:{Z:{s=i[k+124>>2],_=k+128|0;G:{if((s|0)==(_|0))break G;for(;;){X=i[s+16>>2],m=U0,k=m,o=i[V+24>>2];m:{X:{if(!o)break X;for(;;){if(k=o,o=i[o+16>>2],(o|0)>(X|0)){if(m=k,o=i[k>>2],o)continue;break X}if((o|0)>=(X|0))break m;if(o=i[k+4>>2],!o)break}m=k+4|0}o=p(20),i[o+8>>2]=k,i[o>>2]=0,i[o+4>>2]=0,i[o+16>>2]=X,i[m>>2]=o,k=i[i[V+20>>2]>>2],k&&(i[V+20>>2]=k),m1(i[V+24>>2],o),i[V+28>>2]=i[V+28>>2]+1}o=i[s+4>>2];m:{if(o){for(;;)if(k=o,o=i[o>>2],!o)break m}for(;k=i[s+8>>2],o=i[k>>2]!=(s|0),s=k,!!o;);}if(s=k,(_|0)==(s|0))break}if(N=i[V+20>>2],(U0|0)==(N|0))break G;if(o=i[h+108>>2],o>>>0<=t>>>0||(k=i[h+112>>2],k>>>0<=A0>>>0))break Z;for(X=h+128|0,H0=A0+1>>>1|0,a=t+1>>>1|0,g0=k-A0|0,I0=g0+1>>>1|0,r0=o-t|0,d0=r0+1>>>1|0,k=i[h+120>>2],Q2=(k|0)==1,g2=k-1>>>0<2;;){S=i[N+16>>2],z=i[f0>>2],h=z+128|0,s=h,k=i[z+128>>2],o=k;m:{X:{if(!o)break X;for(;m=(S|0)>i[o+16>>2],s=m?s:o,o=i[(m?4:0)+o>>2],!!o;);if((s|0)==(h|0))break X;if(P0=0,m0=0,(S|0)<i[s+16>>2])break m;P0=i[s+44>>2],m0=i[s+56>>2];break m}P0=0,m0=0}m:{X:{if(m=X,o=i[m>>2],s=o,!s)break X;for(;_=(S|0)>i[s+16>>2],m=_?m:s,s=i[(_?4:0)+s>>2],!!s;);if((m|0)==(X|0))break X;if(p2=0,X0=0,(S|0)<i[m+16>>2])break m;p2=i[m+44>>2],X0=i[m+56>>2];break m}p2=0,X0=0}$=255,m=h,s=k,_=255;m:{if(!s)break m;for(;_=(S|0)>i[s+16>>2],m=_?m:s,s=i[(_?4:0)+s>>2],!!s;);if(_=255,(h|0)==(m|0)||(_=255,(S|0)<i[m+16>>2]))break m;_=l[m+24|0]}m=_,s=X;m:{if(!o)break m;for(;_=(S|0)>i[o+16>>2],s=_?s:o,o=i[(_?4:0)+o>>2],!!o;);if((s|0)==(X|0)|(S|0)<i[s+16>>2])break m;$=l[s+24|0]}m:{X:{if((m&255)==($|0)){s=h,o=k;W:{if(!o){K0=0,o=0;break W}for(;m=(S|0)>i[o+16>>2],s=m?s:o,o=i[(m?4:0)+o>>2],!!o;);for(K0=0,K0=(s|0)==(h|0)|(S|0)<i[s+16>>2]?K0:i[s+28>>2],s=h,o=k;m=(S|0)>i[o+16>>2],s=m?s:o,o=i[(m?4:0)+o>>2],!!o;);if(o=0,(s|0)==(h|0)|(S|0)<i[s+16>>2])break W;o=i[s+32>>2]}if(m=S-1>>>0<2,_=m&Q2,s=_?I0:g0,n2=s>>>0<o>>>0?s:o,M=m&g2,(S|0)!=10){if(s=h,o=k,!o)break X;for(;m=(S|0)>i[o+16>>2],s=m?s:o,o=i[(m?4:0)+o>>2],!!o;);for($=0,$=(s|0)==(h|0)|(S|0)<i[s+16>>2]?$:(l[s+24|0]+7&248)>>>3|0,m=_?H0:A0,_=M?a:t,o=h;s=(S|0)>i[k+16>>2],o=s?o:k,k=i[(s?4:0)+k>>2],!!k;);if(s=0,(o|0)==(h|0)|(S|0)<i[o+16>>2])break m;s=(l[o+24|0]+7&248)>>>3|0;break m}s=8,$=8;W:{F:{V:{C:{g:switch(k=i[z+120>>2],k-10|0){case 0:break g;case 1:break V;case 2:case 4:break C;case 3:case 5:break W;default:break F}m=_?H0:A0,$=3,_=t,s=3;break m}$=6;break W}m=_?H0:A0,$=4,_=t,s=4;break m}$=31}m=_?H0:A0,_=t;W:{F:switch(k-12|0){case 0:case 2:s=6;break W;case 1:case 3:break m;default:break F}s=31}break m}if(u[V+8|0]=0,u[V+19|0]=0,q(B,2,132,V+8|0),u[V+19|0]>=0)break v;Z(i[V+8>>2]);break v}m=_?H0:A0,_=M?a:t,$=0,s=0}m:{if(!n2)break m;if(k=M?d0:r0,z=G(k>>>0<K0>>>0?k:K0,$),_=G(s,_)+p2|0,k=0,(n2|0)!=1)for(h=n2&-2,s=0;o=!z,o||x(_+G(X0,k+m|0)|0,G(k,m0)+P0|0,z),o||(o=k|1,x(_+G(X0,o+m|0)|0,G(o,m0)+P0|0,z)),k=k+2|0,s=s+2|0,(h|0)!=(s|0););if(!(n2&1)|!z)break m;x(_+G(X0,k+m|0)|0,G(k,m0)+P0|0,z)}o=i[N+4>>2];m:{if(o){for(;;)if(k=o,o=i[o>>2],!o)break m}for(;k=i[N+8>>2],o=i[k>>2]!=(N|0),N=k,!!o;);}if(N=k,(k|0)==(U0|0))break}}if(k=i[26917],i[B>>2]=i[26916],i[B+4>>2]=k,o=B+8|0,u[107683]>=0){k=i[26919],i[o>>2]=i[26918],i[o+4>>2]=k,i[o+8>>2]=i[26920];break v}T(o,i[26918],i[26919]);break v}if(u[V+8|0]=0,u[V+19|0]=0,q(B,2,118,V+8|0),u[V+19|0]>=0)break v;Z(i[V+8>>2])}Ii(V+20|0,i[V+24>>2]),v=V+32|0,u[B+19|0]<0&&Z(i[B+8>>2]),o=i[B+68>>2];v:{if(!o||(k=i[o+4>>2],i[o+4>>2]=k-1,k))break v;W[i[i[o>>2]+8>>2]](o),y(o)}if(s=i[r+8>>2],s&&(o=i[r+16>>2],k=i[w+40>>2]+1|0,i[w+40>>2]=k,W[s|0](0,k,o)),k=i[26917],i[R>>2]=i[26916],i[R+4>>2]=k,o=R+8|0,u[107683]>=0){k=i[26919],i[o>>2]=i[26918],i[o+4>>2]=k,i[o+8>>2]=i[26920];break h}T(o,i[26918],i[26919]);break h}if(o=i[B+68>>2],!o||(k=i[o+4>>2],i[o+4>>2]=k-1,k))break h;W[i[i[o>>2]+8>>2]](o),y(o)}if(o=l[B+60|0],(o|0)==255)break _;k=i[25331],i[B+64>>2]=i[25330],i[B+68>>2]=k,W[i[(B- -64|0)+(o<<2)>>2]](B+20|0,B+40|0)}_:{if(!N0||(k=i[N0+4>>2],i[N0+4>>2]=k-1,k))break _;W[i[i[N0>>2]+8>>2]](N0),y(N0)}_:{if(!I||(k=i[I+4>>2],i[I+4>>2]=k-1,k))break _;W[i[i[I>>2]+8>>2]](I),y(I)}o=i[w+12>>2];_:{if(!o||(k=i[o+4>>2],i[o+4>>2]=k-1,k))break _;W[i[i[o>>2]+8>>2]](o),y(o)}v=B+80|0;break s}_2(),H()}if(k=i[w+60>>2],i[w+80>>2]=i[w+56>>2],i[w+84>>2]=k,u[w+99|0]<0&&Z(i[w+88>>2]),k=i[Q+4>>2],i[w+88>>2]=i[Q>>2],i[w+92>>2]=k,i[w+96>>2]=i[Q+8>>2],u[w+64|0]=0,u[w+75|0]=0,Y1(w+20|0,i[w+24>>2]),i[w+80>>2]){if(k=i[w+84>>2],i[A>>2]=i[w+80>>2],i[A+4>>2]=k,u[w+99|0]>=0){k=i[w+92>>2],i[F>>2]=i[w+88>>2],i[F+4>>2]=k,i[F+8>>2]=i[w+96>>2];break l}T(F,i[w+88>>2],i[w+92>>2]);break l}_0=_0+1|0,t=t+M0|0,k=0;break o}k=1,u[A+20|0]=1}o:{if(!e0||(o=i[e0+4>>2],i[e0+4>>2]=o-1,o))break o;W[i[i[e0>>2]+8>>2]](e0),y(e0)}o:switch(k|0){case 0:case 9:break o;default:break n}if(k=C[e+450>>1],L0=L0+1|0,!!(k>>>0<=L0>>>0|n0))break}t=C[e+448>>1]}if(Z2=Z2+1|0,Z2>>>0>=(t&65535)>>>0)break t;if(A0=n+A0|0,!!n0)break}}if(e=i[r+12>>2],e&&W[e|0](0,i[r+16>>2]),n0){e=p(32),i[w+44>>2]=e,i[w+48>>2]=31,i[w+52>>2]=-2147483616,f=l[17089]|l[17090]<<8|(l[17091]<<16|l[17092]<<24),r=l[17085]|l[17086]<<8|(l[17087]<<16|l[17088]<<24),u[e+23|0]=r,u[e+24|0]=r>>>8,u[e+25|0]=r>>>16,u[e+26|0]=r>>>24,u[e+27|0]=f,u[e+28|0]=f>>>8,u[e+29|0]=f>>>16,u[e+30|0]=f>>>24,f=l[17082]|l[17083]<<8|(l[17084]<<16|l[17085]<<24),r=l[17078]|l[17079]<<8|(l[17080]<<16|l[17081]<<24),u[e+16|0]=r,u[e+17|0]=r>>>8,u[e+18|0]=r>>>16,u[e+19|0]=r>>>24,u[e+20|0]=f,u[e+21|0]=f>>>8,u[e+22|0]=f>>>16,u[e+23|0]=f>>>24,f=l[17074]|l[17075]<<8|(l[17076]<<16|l[17077]<<24),r=l[17070]|l[17071]<<8|(l[17072]<<16|l[17073]<<24),u[e+8|0]=r,u[e+9|0]=r>>>8,u[e+10|0]=r>>>16,u[e+11|0]=r>>>24,u[e+12|0]=f,u[e+13|0]=f>>>8,u[e+14|0]=f>>>16,u[e+15|0]=f>>>24,f=l[17066]|l[17067]<<8|(l[17068]<<16|l[17069]<<24),r=l[17062]|l[17063]<<8|(l[17064]<<16|l[17065]<<24),u[e|0]=r,u[e+1|0]=r>>>8,u[e+2|0]=r>>>16,u[e+3|0]=r>>>24,u[e+4|0]=f,u[e+5|0]=f>>>8,u[e+6|0]=f>>>16,u[e+7|0]=f>>>24,u[e+31|0]=0,f=q(w+56|0,12,0,w+44|0),e=i[f+4>>2],i[A>>2]=i[f>>2],i[A+4>>2]=e,r=A+8|0;t:{if(u[f+19|0]>=0){e=i[f+12>>2],i[r>>2]=i[f+8>>2],i[r+4>>2]=e,i[r+8>>2]=i[f+16>>2],u[A+20|0]=1;break t}if(T(r,i[f+8>>2],i[f+12>>2]),e=u[f+19|0],u[A+20|0]=1,(e|0)>=0)break t;Z(i[f+8>>2])}if(u[w+55|0]>=0)break n;Z(i[w+44>>2]);break n}r=i[w+232>>2],e=0;t:{if(!r||(e=r,k=i[O>>2],t=i[O+4>>2],(k|0)==(t|0)))break t;for(n=e+148|0,e=i[e+152>>2];;){u:{if(u0[r+156>>2]>e>>>0){if(f=i[k+4>>2],i[e>>2]=i[k>>2],i[e+4>>2]=f,o=e+8|0,u[k+19|0]>=0){f=i[k+12>>2],i[o>>2]=i[k+8>>2],i[o+4>>2]=f,i[o+8>>2]=i[k+16>>2],e=e+20|0;break u}T(o,i[k+8>>2],i[k+12>>2]),e=e+20|0;break u}e=fi(n,k)}if(i[r+152>>2]=e,k=k+20|0,(t|0)==(k|0))break}e=i[w+232>>2]}r=i[w+236>>2],i[w+232>>2]=0,i[w+236>>2]=0,u[A+20|0]=0,i[A+4>>2]=r,i[A>>2]=e}if(A=i[P+4>>2],i[P+4>>2]=A-1,A)break k;W[i[i[P>>2]+8>>2]](P),y(P)}if(u[w+99|0]>=0)break e;Z(i[w+88>>2]);break e}Q0(),H()}if(!e)break r;x(t,f,e)}u[e+t|0]=0,f=q(w+56|0,2,119,w+44|0),e=i[f+4>>2],i[A>>2]=i[f>>2],i[A+4>>2]=e,r=A+8|0;r:{if(u[f+19|0]>=0){e=i[f+12>>2],i[r>>2]=i[f+8>>2],i[r+4>>2]=e,i[r+8>>2]=i[f+16>>2],u[A+20|0]=1;break r}if(T(r,i[f+8>>2],i[f+12>>2]),e=u[f+19|0],u[A+20|0]=1,(e|0)>=0)break r;Z(i[f+8>>2])}u[w+55|0]<0&&Z(i[w+44>>2]),A=i[18051],i[w+80>>2]=A,i[i[A-12>>2]+(w+80|0)>>2]=i[18059],i[w+88>>2]=i[18060],i[k>>2]=71232,u[w+135|0]<0&&Z(i[w+124>>2]),E0(k),y0(w+144|0)}e=i[w+236>>2];e:{if(!e||(A=i[e+4>>2],i[e+4>>2]=A-1,A))break e;W[i[i[e>>2]+8>>2]](e),y(e)}v=w+240|0,Y1($0,i[E+8>>2])}v=E- -64|0}function C7(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0;var k=0,n=0,t=0,o=0,s=0,w=0,h=0,_=0,B=0,m=0,X=0,Q=0,V=0,F=0,I=0,E=0,R=0,N=0,M=0,z=0,S=0,O=0;F=v-48|0,v=F;i:{e:{if(!r){if(u[F+12|0]=0,u[F+23|0]=0,r=A,A=q(F+24|0,5,2001,F+12|0),b0(r,A,i[e>>2]),u[A+19|0]<0&&Z(i[A+8>>2]),u[F+23|0]>=0)break e;Z(i[F+12>>2]);break e}if(i[r>>2]!=1){if(u[F+12|0]=0,u[F+23|0]=0,r=q(F+24|0,5,2004,F+12|0),u[F+23|0]<0&&Z(i[F+12>>2]),b0(A,r,i[e>>2]),u[r+19|0]>=0)break e;Z(i[r+8>>2]);break e}i[F+32>>2]=0,i[F+36>>2]=0,i[F+24>>2]=0,i[F+28>>2]=0,M=F+24|0,B=v-80|0,v=B,h=i[e>>2],n=i[h+48>>2],E=i[n+148>>2],V=i[n+152>>2],V&&(i[V+4>>2]=i[V+4>>2]+1);r:{f:{if(E){if(k=i[h+180>>2],z=h+184|0,(k|0)!=(z|0))for(;;){n=i[k+20>>2],W[i[i[n>>2]+20>>2]](B+56|0,n),u[B+75|0]<0&&Z(i[B+64>>2]),t=i[i[k+20>>2]+156>>2],n=i[t+128>>2],m=i[t+132>>2],w=i[t+120>>2],o=i[h+48>>2],t=i[o+148>>2],o=i[o+152>>2];A:{if(!o){t=i[t+120>>2];break A}if(s=i[o+4>>2],X=s+1|0,i[o+4>>2]=X,t=i[t+120>>2],i[o+4>>2]=s,X)break A;W[i[i[o>>2]+8>>2]](o),y(o)}A:{if(t)break A;if(t=i[i[i[k+20>>2]+156>>2]+120>>2],o=i[h+48>>2],s=i[o+148>>2],o=i[o+152>>2],!o){i[s+120>>2]=t;break A}if(i[o+4>>2]=i[o+4>>2]+1,i[s+120>>2]=t,s=i[o+4>>2],i[o+4>>2]=s-1,s)break A;W[i[i[o>>2]+8>>2]](o),y(o)}w?(n=d8(O0(n,m,t,0),l0,w,0),w=l0):(n=0,w=0),t=i[h+196>>2];A:{k:{if(!t){o=-1,I=-1;break k}if($1(B,t,0,0,0,n,w,0,0),R=O0(t,0,n,w),s=(i[B+8>>2]|i[B+12>>2])!=0,o=s?-1:R,I=s?-1:l0,(t|0)==1)break A}m=v-16|0,v=m,X=i[k+20>>2];k:{if(i[X+236>>2])break k;s=p(120),i[s+4>>2]=0,i[s+8>>2]=0,i[s>>2]=93684,t=s+16|0,i[t+8>>2]=0,i[t+12>>2]=0,i[s+32>>2]=0,i[s+36>>2]=0,i[s+40>>2]=0,i[s+44>>2]=0,i[s+48>>2]=0,i[s+16>>2]=86356,i[s+60>>2]=0,i[s+64>>2]=0,i[s+52>>2]=0,i[s+56>>2]=0,i[s+72>>2]=-1,i[s+76>>2]=-1,i[s+80>>2]=-1,i[s+84>>2]=-1,i[s+88>>2]=0,i[s+92>>2]=0,i[s+96>>2]=0,i[s+100>>2]=0,i[s+104>>2]=0,i[s+108>>2]=0,u[s+112|0]=0,i[s+32>>2]=1701082227,i[s+16>>2]=93724,Q=i[X+132>>2],i[m+12>>2]=s,i[m+8>>2]=t,i[s+4>>2]=i[s+4>>2]+1,r2(Q+36|0,m+8|0),t=i[m+12>>2];n:{if(!t||(Q=i[t+4>>2],i[t+4>>2]=Q-1,Q))break n;W[i[i[t>>2]+8>>2]](t),y(t)}S=s+52|0,t=p(136),i[t+4>>2]=0,i[t+8>>2]=0,i[t>>2]=93804,R=t+16|0,Q=R,i[Q+8>>2]=0,i[Q+12>>2]=0,i[t+32>>2]=0,i[t+36>>2]=0,i[t+40>>2]=0,i[t+44>>2]=0,i[t+48>>2]=0,i[t+16>>2]=86356,i[t+60>>2]=0,i[t+64>>2]=0,i[t+52>>2]=0,i[t+56>>2]=0,i[t+72>>2]=-1,i[t+76>>2]=-1,i[t+80>>2]=-1,i[t+84>>2]=-1,i[t+116>>2]=0,i[t+88>>2]=0,i[t+92>>2]=0,i[t+96>>2]=0,i[t+100>>2]=0,i[t+104>>2]=0,i[t+108>>2]=0,g[t+112>>1]=0,i[t+16>>2]=106348,i[t+128>>2]=0,i[t+120>>2]=0,i[t+124>>2]=0,i[t+32>>2]=1701606260,i[X+236>>2]=Q,Q=i[X+240>>2],i[X+240>>2]=t;n:{t:{if(!Q){i[m+12>>2]=t,i[m+8>>2]=R;break t}if(t=i[Q+4>>2],i[Q+4>>2]=t-1,t||(W[i[i[Q>>2]+8>>2]](Q),y(Q)),Q=i[X+236>>2],t=i[X+240>>2],i[m+12>>2]=t,i[m+8>>2]=Q,!t)break n}i[t+4>>2]=i[t+4>>2]+1}r2(S,m+8|0),t=i[m+12>>2];n:{if(!t||(Q=i[t+4>>2],i[t+4>>2]=Q-1,Q))break n;W[i[i[t>>2]+8>>2]](t),y(t)}if(t=i[X+236>>2],i[t+100>>2]=i[t+100>>2]&-2|1,t=i[s+4>>2],i[s+4>>2]=t-1,t)break k;W[i[i[s>>2]+8>>2]](s),y(s)}v=m+16|0}if(s=v-32|0,v=s,t=i[k+20>>2],m=i[t+140>>2],i[m+128>>2]=o,i[m+132>>2]=I,m=i[t+236>>2],m){i[s+24>>2]=1,i[s+16>>2]=0,i[s+20>>2]=0,i[s+8>>2]=n,i[s+12>>2]=w;A:{if(n=i[m+108>>2],w=i[m+112>>2],n>>>0<w>>>0){t=i[s+12>>2],i[n>>2]=i[s+8>>2],i[n+4>>2]=t,t=i[s+28>>2],i[n+16>>2]=i[s+24>>2],i[n+20>>2]=t,t=i[s+20>>2],i[n+8>>2]=i[s+16>>2],i[n+12>>2]=t,i[m+108>>2]=n+24;break A}k:{if(X=i[m+104>>2],n=n-X|0,t=((n|0)/24|0)+1|0,t>>>0<178956971){if(w=(w-X|0)/24|0,Q=w<<1,Q=w>>>0>=89478485?178956970:t>>>0<Q>>>0?Q:t,Q){if(Q>>>0>=178956971)break k;t=p(G(Q,24))}else t=0;w=t+n|0,R=i[s+12>>2],i[w>>2]=i[s+8>>2],i[w+4>>2]=R,R=i[s+28>>2],i[w+16>>2]=i[s+24>>2],i[w+20>>2]=R,R=i[s+20>>2],i[w+8>>2]=i[s+16>>2],i[w+12>>2]=R,R=w+G((n|0)/-24|0,24)|0,n&&x(R,X,n),i[m+112>>2]=t+G(Q,24),n=w+24|0,i[m+108>>2]=n,i[m+104>>2]=R,X&&Z(X),i[m+108>>2]=n;break A}break f}z0(),H()}}v=s+32|0,w=(I|0)==(N|0)&o>>>0<_>>>0|I>>>0<N>>>0,t=i[k+4>>2];A:{if(t){for(;;)if(n=t,t=i[n>>2],!t)break A}for(;n=i[k+8>>2],t=i[n>>2]!=(k|0),k=n,!!t;);}if(_=w?_:o,N=w?N:I,k=n,(z|0)==(k|0))break}i[E+128>>2]=_,i[E+132>>2]=N}A:{if(!V||(n=i[V+4>>2],i[V+4>>2]=n-1,n))break A;W[i[i[V>>2]+8>>2]](V),y(V)}if(t=i[h+16>>2],V=h+20|0,(t|0)!=(V|0))for(;;){if(k=i[t+20>>2],n=i[k+276>>2],o=i[k+280>>2],(n|0)!=(o|0))for(;w=i[h+48>>2],_=i[n>>2],s=i[t+16>>2],k=p(4),i[B+16>>2]=k,m=k+4|0,i[B+24>>2]=m,i[k>>2]=s,i[B+20>>2]=m,a4(w,_,1667527523,B+16|0),k=i[B+16>>2],k&&(i[B+20>>2]=k,Z(k)),n=n+4|0,(o|0)!=(n|0););k=i[t+4>>2];A:{if(k){for(;;)if(n=k,k=i[k>>2],!k)break A}for(;n=i[t+8>>2],k=i[n>>2]!=(t|0),t=n,!!k;);}if(t=n,(V|0)==(n|0))break}if(n=i[h+156>>2],X=i[h+160>>2],(n|0)!=(X|0))for(;;){i[B+48>>2]=0,i[B+40>>2]=0,i[B+44>>2]=0,_=B+16|0,o=i[n>>2],m=B+40|0,w=0,t=v-32|0,v=t,i[t+24>>2]=0,i[t+28>>2]=0,i[t+16>>2]=0,i[t+20>>2]=0,l2(t+16|0,0);A:{k:{if(!(u0[o+4>>2]>65535|u0[o+8>>2]>=65536)){w=1;break k}if(s=2,k=i[o+12>>2],Q=i[o+16>>2],(k|0)==(Q|0))break A;for(;;){if(w=i[k>>2],w=W[i[i[w>>2]+16>>2]](w)|0,w)break k;if(k=k+8|0,(Q|0)==(k|0))break}break A}s=4}k=t+16|0,l2(k,w),Z1(k,s,i[o+4>>2],0),Z1(k,s,i[o+8>>2],0),k=i[o+16>>2]-i[o+12>>2]>>3;A:{if(k>>>0>=256){if(u[t+4|0]=0,u[t+15|0]=0,q(_,9,5004,t+4|0),u[t+15|0]>=0)break A;Z(i[t+4>>2]);break A}if(l2(t+16|0,k),k=i[o+12>>2],o=i[o+16>>2],(k|0)!=(o|0))for(;w=i[k>>2],W[i[i[w>>2]+20>>2]](w,t+16|0,s),k=k+8|0,(o|0)!=(k|0););if(w=0,i[t+12>>2]=0,i[t+4>>2]=0,i[t+8>>2]=0,k=0,o=i[t+20>>2],s=i[t+16>>2],(o|0)!=(s|0)){if(o=o-s|0,(o|0)<0)break f;k=p(o),o&&x(k,s,o),w=k+o|0}if((m|0)!=(t+4|0)&&d4(m,k,w,w-k|0),k&&Z(k),k=i[26917],i[_>>2]=i[26916],i[_+4>>2]=k,k=_+8|0,u[107683]>=0){o=i[26919],i[k>>2]=i[26918],i[k+4>>2]=o,i[k+8>>2]=i[26920];break A}T(k,i[26918],i[26919])}if(k=i[t+16>>2],k&&(i[t+20>>2]=k,Z(k)),v=t+32|0,q8(i[h+48>>2],i[i[n>>2]>>2],m,0),u[B+35|0]<0&&Z(i[B+24>>2]),t=i[B+40>>2],t&&(i[B+44>>2]=t,Z(t)),n=n+8|0,(X|0)==(n|0))break}if(t=i[h+16>>2],(V|0)!=(t|0))for(;;){if(k=i[t+20>>2],n=i[k+436>>2],o=i[k+440>>2],(n|0)!=(o|0))for(;w=i[h+48>>2],_=i[n>>2],s=i[t+16>>2],k=p(4),i[B+16>>2]=k,m=k+4|0,i[B+24>>2]=m,i[k>>2]=s,i[B+20>>2]=m,a4(w,_,1952807028,B+16|0),k=i[B+16>>2],k&&(i[B+20>>2]=k,Z(k)),n=n+4|0,(o|0)!=(n|0););k=i[t+4>>2];A:{if(k){for(;;)if(n=k,k=i[k>>2],!k)break A}for(;n=i[t+8>>2],k=i[n>>2]!=(t|0),t=n,!!k;);}if(t=n,(V|0)==(n|0))break}if(n=i[h+168>>2],Q=i[h+172>>2],(n|0)!=(Q|0))for(w=i[23590],I=i[23591];;){t=i[n>>2],o=v-16|0,v=o,i[o+12>>2]=0,i[o+4>>2]=0,i[o+8>>2]=0,_=u[t+15|0],s=(_|0)<0,k=s?i[t+4>>2]:t+4|0,t=s?i[t+8>>2]:_,m=k+t|0;A:{if(s=i[o+12>>2],_=i[o+4>>2],t>>>0<=s-_>>>0){if(E=t,t=i[o+8>>2],X=t-_|0,E>>>0>X>>>0){if(s=k+X|0,(t|0)!=(_|0)&&(X&&x(_,k,X),t=i[o+8>>2]),k=t,(s|0)!=(m|0))for(;u[k|0]=l[s|0],k=k+1|0,s=s+1|0,(m|0)!=(s|0););i[o+8>>2]=(k-t|0)+t;break A}t=m-k|0,!t|(k|0)==(m|0)||x(_,k,t),i[o+8>>2]=t+_;break A}if(_&&(i[o+8>>2]=_,Z(_),i[o+12>>2]=0,i[o+4>>2]=0,i[o+8>>2]=0,s=0),(t|0)>=0){_=s<<1,_=s>>>0>=1073741823?2147483647:t>>>0<_>>>0?_:t,t=p(_),i[o+8>>2]=t,i[o+4>>2]=t,i[o+12>>2]=t+_,(k|0)!=(m|0)&&(_=m-k|0,_&&x(t,k,_),t=t+_|0),i[o+8>>2]=t;break A}break f}if(t=i[o+4>>2],_=i[o+8>>2],s=i[o+12>>2],k=B+16|0,u[k+20|0]=0,i[k+8>>2]=s,i[k>>2]=t,i[k+4>>2]=_,v=o+16|0,t=l[B+36|0],t||(q8(i[h+48>>2],i[i[n>>2]>>2],k,1),t=l[B+36|0]),t=t&255,(t|0)!=255&&(i[B+40>>2]=w,i[B+44>>2]=I,W[i[(B+40|0)+(t<<2)>>2]](B+79|0,B+16|0)),n=n+8|0,(Q|0)==(n|0))break}if(t=i[h+16>>2],(V|0)!=(t|0))for(;;){n=i[t+20>>2],W[i[i[n>>2]+80>>2]](n),k=i[t+4>>2];A:{if(k){for(;;)if(n=k,k=i[k>>2],!k)break A}for(;n=i[t+8>>2],k=i[n>>2]!=(t|0),t=n,!!k;);}if(t=n,(V|0)==(n|0))break}n=i[h+48>>2],o=i[n+60>>2],_=i[n+64>>2],_&&(i[_+4>>2]=i[_+4>>2]+1);A:{if(!o)break A;if(n=i[h+48>>2],i[B+16>>2]=i[n+52>>2],n=i[n+56>>2],i[B+20>>2]=n,n&&(i[n+4>>2]=i[n+4>>2]+1),n=0,t=0,V=v-16|0,v=V,w=i[B+16>>2],i[V+12>>2]=0,i[V+4>>2]=0,i[V+8>>2]=0,k=i[w+36>>2],s=i[w+40>>2],(k|0)!=(s|0)){if(n=s-k|0,(n|0)<0)break f;for(t=p(n),i[V+4>>2]=t,i[V+12>>2]=n+t,n=t;i[n>>2]=i[k>>2],w=i[k+4>>2],i[n+4>>2]=w,w&&(i[w+4>>2]=i[w+4>>2]+1),n=n+8|0,k=k+8|0,(s|0)!=(k|0););i[V+8>>2]=n}if(m=i[o+104>>2],N=i[o+108>>2],(m|0)!=(N|0))for(Q=t-8|0;;){if(s=0,E=(i[m+8>>2]-i[m+4>>2]>>2)-1|0,w=E,w)for(;;){for(R=w>>>0<=1?1:w,k=0;;){o=k,k=k+1|0,o=o<<2,X=i[Q+(C[(o+i[m+4>>2]|0)+2>>1]<<3)>>2];k:{if(!(W[i[i[X>>2]+44>>2]](X)|0)||(X=k<<2,I=i[Q+(C[(X+i[m+4>>2]|0)+2>>1]<<3)>>2],W[i[i[I>>2]+44>>2]](I)|0))break k;z=i[m+4>>2],o=z+o|0,I=C[o>>1]|C[o+2>>1]<<16,X=X+z|0,z=C[X>>1]|C[X+2>>1]<<16,g[o>>1]=z,g[o+2>>1]=z>>>16,g[X>>1]=I,g[X+2>>1]=I>>>16}if((k|0)==(R|0))break}if(w=w-1|0,s=s+1|0,(E|0)==(s|0))break}if(m=m+16|0,(N|0)==(m|0))break}if(t){if((n|0)!=(t|0)){for(;;){k=i[n-4>>2];k:{if(!k||(o=i[k+4>>2],i[k+4>>2]=o-1,o))break k;W[i[i[k>>2]+8>>2]](k),y(k)}if(n=n-8|0,(t|0)==(n|0))break}t=i[V+4>>2]}Z(t)}if(v=V+16|0,n=i[B+20>>2],!n||(t=i[n+4>>2],i[n+4>>2]=t-1,t))break A;W[i[i[n>>2]+8>>2]](n),y(n)}A:{if(!_||(n=i[_+4>>2],i[_+4>>2]=n-1,n))break A;W[i[i[_>>2]+8>>2]](_),y(_)}if(t=i[h+48>>2],n=i[t+16>>2],t=i[t+20>>2],(n|0)!=(t|0))for(;Al(i[n>>2]),n=n+8|0,(t|0)!=(n|0););m=0,_=v+-64|0,v=_,i[B+24>>2]=0,i[B+16>>2]=0,i[B+20>>2]=0,V=B+40|0,V&&(i[V>>2]=0),n=h,k=i[n+48>>2],w=i[n+52>>2],w&&(i[w+4>>2]=i[w+4>>2]+1),t=i[k+44>>2],s=i[k+48>>2],s&&(i[s+4>>2]=i[s+4>>2]+1);A:{if(l[t+97|0]|!t||(k=i[t+36>>2],h=i[t+40>>2],(k|0)==(h|0)))break A;for(;;){k:{if(o=i[k>>2],!o||(o=W0(o,86580,87184),!o))break k;X=i[k+4>>2],X&&(i[X+4>>2]=i[X+4>>2]+1);n:{if(l[o+97|0]||(k=i[t+36>>2],h=i[t+40>>2],(k|0)==(h|0)))break n;for(;;){t:{if(o=i[k>>2],!o||(o=W0(o,86580,89664),!o))break t;if(Q=i[k+4>>2],Q&&(i[Q+4>>2]=i[Q+4>>2]+1),l[o+97|0]<=2){if(ZA(_+12|0,t),k=i[_+12>>2],!(!k|l[k+97|0]>1)){u:{o:{if(o=i[k+36>>2],h=i[k+40>>2],(o|0)!=(h|0)){if(k=i[o>>2],k&&(I=i[_+40>>2],k=W0(k,86580,87344),k))break o;if(o=o+8|0,(h|0)!=(o|0))for(;;){if(k=i[o>>2],k&&(I=0,k=W0(k,86580,87344),k))break o;if(o=o+8|0,(h|0)==(o|0))break}i[_+36>>2]=0,i[_+40>>2]=0}i[_+36>>2]=0,i[_+40>>2]=0;break u}if(i[_+40>>2]=I,i[_+36>>2]=k,k=i[o+4>>2],i[_+40>>2]=k,!k)break u;i[k+4>>2]=i[k+4>>2]+1}if(k=i[_+36>>2],!(!k|(l[k+97|0]&254)!=2)){u:{o:{if(o=i[t+36>>2],h=i[t+40>>2],(o|0)!=(h|0)){if(k=i[o>>2],k&&(I=i[_+60>>2],k=W0(k,86580,87264),k))break o;if(o=o+8|0,(h|0)!=(o|0))for(;;){if(k=i[o>>2],k&&(I=0,k=W0(k,86580,87264),k))break o;if(o=o+8|0,(h|0)==(o|0))break}i[_+56>>2]=0,i[_+60>>2]=0}i[_+56>>2]=0,i[_+60>>2]=0;break u}if(i[_+60>>2]=I,i[_+56>>2]=k,k=i[o+4>>2],i[_+60>>2]=k,!k)break u;i[k+4>>2]=i[k+4>>2]+1}if(k=i[_+56>>2],!(!k|l[k+97|0]>1)){h=_+48|0;u:{o:{if(o=i[t+36>>2],t=i[t+40>>2],(o|0)!=(t|0)){if(m=i[o>>2],m&&(k=i[h+4>>2],I=W0(m,86580,87504),I))break o;if(o=o+8|0,(t|0)!=(o|0))for(;;){if(m=i[o>>2],m&&(k=0,I=W0(m,86580,87504),I))break o;if(o=o+8|0,(t|0)==(o|0))break}i[h>>2]=0,i[h+4>>2]=0}i[h>>2]=0,i[h+4>>2]=0;break u}if(i[h+4>>2]=k,i[h>>2]=I,t=i[o+4>>2],i[h+4>>2]=t,!t)break u;i[t+4>>2]=i[t+4>>2]+1}m=i[_+48>>2]!=0,I2(h)}I2(_+56|0)}I2(_+36|0)}I2(_+12|0)}if(!Q||(t=i[Q+4>>2],i[Q+4>>2]=t-1,t))break n;W[i[i[Q>>2]+8>>2]](Q),y(Q);break n}if(k=k+8|0,(h|0)==(k|0))break}}if(!X||(t=i[X+4>>2],i[X+4>>2]=t-1,t))break A;W[i[i[X>>2]+8>>2]](X),y(X);break A}if(k=k+8|0,(h|0)==(k|0))break}}A:{if(!s||(t=i[s+4>>2],i[s+4>>2]=t-1,t))break A;W[i[i[s>>2]+8>>2]](s),y(s)}A:{if(!w||(t=i[w+4>>2],i[w+4>>2]=t-1,t))break A;W[i[i[w>>2]+8>>2]](w),y(w)}A:{k:{n:{t:{if(!m)break t;t=i[B+20>>2],o=i[B+24>>2];u:{if(t>>>0<o>>>0){i[t>>2]=1835623985,k=t+4|0;break u}if(h=i[B+16>>2],t=t-h|0,s=t>>2,k=s+1|0,k>>>0>=1073741824)break f;if(o=o-h|0,w=o>>1,o=o>>>0>=2147483644?1073741823:k>>>0<w>>>0?w:k,o){if(o>>>0>=1073741824)break n;k=p(o<<2)}else k=0;if(w=k+t|0,i[w>>2]=1835623985,s=w-(s<<2)|0,t&&x(s,h,t),i[B+24>>2]=k+(o<<2),k=w+4|0,i[B+20>>2]=k,i[B+16>>2]=s,!h)break u;Z(h)}if(i[B+20>>2]=k,!V)break t;i[V>>2]=1835623985}t=v-16|0,v=t,o=v-32|0,v=o;t:{u:{if(h=n,n=i[n+40>>2],!n||(W[i[i[n>>2]+52>>2]](o+12|0,n),n=i[o+12>>2],u[o+31|0]<0&&Z(i[o+20>>2]),n))break u;if(k=i[h+40>>2],n=i[h+44>>2],!n){n=0;break t}i[n+4>>2]=i[n+4>>2]+1;break t}n=0,k=0}i[t+12>>2]=n,i[t+8>>2]=k,v=o+32|0,w=i[t+8>>2];t:{if(w){if(n=i[t+12>>2],i[t+8>>2]=0,i[t+12>>2]=0,k=p(8),i[_+36>>2]=k,o=k+8|0,i[_+44>>2]=o,i[k+4>>2]=n,i[k>>2]=w,!n){i[_+40>>2]=o;break t}if(i[n+4>>2]=i[n+4>>2]+1,i[_+40>>2]=o,k=i[n+4>>2],i[n+4>>2]=k-1,k)break t;W[i[i[n>>2]+8>>2]](n),y(n);break t}i[_+44>>2]=0,i[_+36>>2]=0,i[_+40>>2]=0}n=i[t+12>>2];t:{if(!n||(k=i[n+4>>2],i[n+4>>2]=k-1,k))break t;W[i[i[n>>2]+8>>2]](n),y(n)}v=t+16|0;t:{u:{o:{n=i[_+36>>2],I=i[_+40>>2],R=(n|0)==(I|0);l:{if(R){t=1;break l}if(!m)break o;for(t=1,k=n;;){o=i[k>>2],s=W[i[i[o>>2]+88>>2]](o)|0;s:{if(!s||(o=i[B+16>>2],w=i[B+20>>2],o=_3(o,s,w-o>>2),o=o||w,w=i[B+20>>2],(o|0)!=(w|0)))break s;Q=i[B+24>>2];w:{if(Q>>>0>o>>>0){i[w>>2]=s,s=w+4|0;break w}if(X=i[B+16>>2],o=o-X|0,E=o>>2,w=E+1|0,w>>>0>=1073741824)break f;if(Q=Q-X|0,N=Q>>1,Q=Q>>>0>=2147483644?1073741823:w>>>0<N>>>0?N:w,Q){if(Q>>>0>=1073741824)break n;w=p(Q<<2)}else w=0;if(N=w+o|0,i[N>>2]=s,E=N-(E<<2)|0,o&&x(E,X,o),i[B+24>>2]=w+(Q<<2),s=N+4|0,i[B+20>>2]=s,i[B+16>>2]=E,!X)break w;Z(X)}i[B+20>>2]=s}if(t=l[i[k>>2]+272|0]&t,k=k+8|0,(I|0)==(k|0))break}}if(t&m){t=i[B+20>>2],w=i[B+24>>2];l:{if(t>>>0<w>>>0){i[t>>2]=1835622758,k=t+4|0;break l}if(o=i[B+16>>2],t=t-o|0,m=t>>2,k=m+1|0,k>>>0>=1073741824)break f;if(w=w-o|0,s=w>>1,w=w>>>0>=2147483644?1073741823:k>>>0<s>>>0?s:k,w){if(w>>>0>=1073741824)break n;k=p(w<<2)}else k=0;if(s=k+t|0,i[s>>2]=1835622758,m=s-(m<<2)|0,t&&x(m,o,t),i[B+24>>2]=k+(w<<2),k=s+4|0,i[B+20>>2]=k,i[B+16>>2]=m,!o)break l;Z(o)}i[B+20>>2]=k}if(R)break t;break u}for(k=n;t=i[k>>2],W[i[i[t>>2]+88>>2]](t)|0,k=k+8|0,(I|0)!=(k|0););}if(t=i[n>>2],t=W[i[i[t>>2]+88>>2]](t)|0,!V|!t)break t;i[V>>2]=t}if(i[h+188>>2]){t=i[B+24>>2],n=i[B+20>>2];t:{if(t>>>0>n>>>0){i[n>>2]=1836279345,k=n+4|0;break t}if(o=i[B+16>>2],n=n-o|0,s=n>>2,k=s+1|0,k>>>0>=1073741824)break f;if(t=t-o|0,w=t>>1,k=t>>>0>=2147483644?1073741823:k>>>0<w>>>0?w:k,k){if(k>>>0>=1073741824)break n;t=p(k<<2)}else t=0;if(w=t+n|0,i[w>>2]=1836279345,s=w-(s<<2)|0,n&&x(s,o,n),t=t+(k<<2)|0,i[B+24>>2]=t,k=w+4|0,i[B+20>>2]=k,i[B+16>>2]=s,!o)break t;Z(o),t=i[B+24>>2]}i[B+20>>2]=k;t:{if(k>>>0<t>>>0){i[k>>2]=1769172792,k=k+4|0;break t}if(o=i[B+16>>2],n=k-o|0,s=n>>2,k=s+1|0,k>>>0>=1073741824)break f;if(t=t-o|0,w=t>>1,k=t>>>0>=2147483644?1073741823:k>>>0<w>>>0?w:k,k){if(k>>>0>=1073741824)break n;t=p(k<<2)}else t=0;if(w=t+n|0,i[w>>2]=1769172792,s=w-(s<<2)|0,n&&x(s,o,n),i[B+24>>2]=t+(k<<2),k=w+4|0,i[B+20>>2]=k,i[B+16>>2]=s,!o)break t;Z(o)}i[B+20>>2]=k,t=_+12|0,n=v-48|0,v=n,Mf(n+8|0,h,0);t:{u:{o:{l:switch(o=l[n+28|0],o|0){case 0:break u;case 1:break o;default:break l}_2(),H()}if(k=i[n+12>>2],i[t>>2]=i[n+8>>2],i[t+4>>2]=k,k=t+8|0,u[n+27|0]>=0){w=i[n+20>>2],i[k>>2]=i[n+16>>2],i[k+4>>2]=w,i[k+8>>2]=i[n+24>>2];break t}T(k,i[n+16>>2],i[n+20>>2]);break t}w=i[n+8>>2],k=i[n+12>>2],k&&(i[k+4>>2]=i[k+4>>2]+1),i[t+4>>2]=k,i[t>>2]=w}if(u[t+20|0]=o,t=l[n+28|0],(t|0)!=255&&(k=i[23603],i[n+40>>2]=i[23602],i[n+44>>2]=k,W[i[(n+40|0)+(t<<2)>>2]](n+39|0,n+8|0)),v=n+48|0,l[_+32|0])break k;if(n=i[_+12>>2],k=i[_+16>>2],k&&(i[k+4>>2]=i[k+4>>2]+1),t=0,n=W0(n,106564,106696),!k|!n||(i[k+4>>2]=i[k+4>>2]+1,t=k),o=i[n+180>>2],n=i[o+104>>2],(n|0)==i[o+108>>2])n=0;else{w=i[n>>2],o=i[n+4>>2],o&&(i[o+4>>2]=i[o+4>>2]+1);t:{u:{o:{l:{s:{w:{if(n=i[w+16>>2],(n|0)<=1781689192){if((n|0)==1635135537)break w;if((n|0)!=1635148593)break o;n=1635148659;break t}if((n|0)==1781689193)break s;if((n|0)==1835692135)break l;if((n|0)!=1987470129)break u;n=1987471731;break t}n=1635150195;break t}n=1781688691;break t}n=1785751411;break t}if((n|0)!=1752589105||(n=i[w+36>>2],w=i[w+40>>2],(n|0)==(w|0)))break u;for(;;){o:{if(s=i[n>>2],!s||(s=W0(s,86580,97564),!s))break o;if(w=i[n+4>>2],w&&(i[w+4>>2]=i[w+4>>2]+1),n=1751479907,m=l[s+103|0],s=i[s+104>>2],(m|0)==1|(s&1073741824)!=0||(n=s&268435456|(m|0)==3?1751479907:1751479928),!w||(s=i[w+4>>2],i[w+4>>2]=s-1,s))break t;W[i[i[w>>2]+8>>2]](w),y(w);break t}if(n=n+8|0,(w|0)==(n|0))break}}n=0}t:{if(!o||(w=i[o+4>>2],i[o+4>>2]=w-1,w))break t;W[i[i[o>>2]+8>>2]](o),y(o)}}t:{u:{if(n){o=i[B+20>>2],s=i[B+24>>2];o:{if(o>>>0<s>>>0){i[o>>2]=n,s=o+4|0;break o}if(m=i[B+16>>2],o=o-m|0,Q=o>>2,w=Q+1|0,w>>>0>=1073741824)break f;if(s=s-m|0,X=s>>1,s=s>>>0>=2147483644?1073741823:w>>>0<X>>>0?X:w,s){if(s>>>0>=1073741824)break n;w=p(s<<2)}else w=0;if(X=w+o|0,i[X>>2]=n,Q=X-(Q<<2)|0,o&&x(Q,m,o),i[B+24>>2]=w+(s<<2),s=X+4|0,i[B+20>>2]=s,i[B+16>>2]=Q,!m)break o;Z(m)}if(i[B+20>>2]=s,V)break u;break t}if(i[V>>2]|!V)break t;n=1836279345}i[V>>2]=n}t:{if(!t||(n=i[t+4>>2],i[t+4>>2]=n-1,n))break t;W[i[i[t>>2]+8>>2]](t),y(t)}t:{if(!k||(n=i[k+4>>2],i[k+4>>2]=n-1,n))break t;W[i[i[k>>2]+8>>2]](k),y(k)}n=l[_+32|0],(n|0)!=255&&(t=i[24055],i[_+56>>2]=i[24054],i[_+60>>2]=t,W[i[(_+56|0)+(n<<2)>>2]](_+48|0,_+12|0)),n=i[_+36>>2]}if(n){if(k=n,t=i[_+40>>2],(k|0)!=(t|0)){for(;;){k=i[t-4>>2];t:{if(!k||(o=i[k+4>>2],i[k+4>>2]=o-1,o))break t;W[i[i[k>>2]+8>>2]](k),y(k)}if(t=t-8|0,(t|0)==(n|0))break}k=i[_+36>>2]}i[_+40>>2]=n,Z(k)}v=_- -64|0;break A}z0(),H()}_2(),H()}if(o=i[B+20>>2],n=i[h+48>>2],k=i[n+28>>2],m=i[n+32>>2],m&&(i[m+4>>2]=i[m+4>>2]+1),t=i[B+16>>2],i[k+100>>2]||(i[k+100>>2]=i[B+40>>2]),i[k+104>>2]=0,(t|0)!=(o|0))for(n=t;Hr(k,i[n>>2]),n=n+4|0,(o|0)!=(n|0););if(s=v-48|0,v=s,V=i[h+48>>2],k=i[V+16>>2],n=i[V+20>>2],(k|0)!=(n|0))for(;h=i[k>>2],W[i[i[h>>2]+20>>2]](s+12|0,h,M),u[s+31|0]<0&&Z(i[s+20>>2]),k=k+8|0,(n|0)!=(k|0););n=i[V+68>>2];A:{if(!n)break A;if(_=0,h=v-176|0,v=h,E=M,o=i[n+104>>2],k=i[n+108>>2],(o|0)==(k|0))k=8;else{for(;;){k:{if(l[o+4|0]||(w=i[o+16>>2],X=i[o+20>>2],(w|0)==(X|0)))break k;for(;_=i[w+16>>2]+_|0,w=w+40|0,(X|0)!=(w|0););}if(o=o+32|0,(k|0)==(o|0))break}k=_+8|0}F0(E,k),F0(M,1835295092),l[n+132|0]&&co(i[n+136>>2],0,0,0),Q=s+12|0;k:{n:{t:{u:{o:{if(_=i[n+104>>2],I=i[n+108>>2],(_|0)!=(I|0))for(;;){l:{if(l[_+4|0]||(i[_+8>>2]=i[M+12>>2],i[_+12>>2]=0,w=i[_+16>>2],N=i[_+20>>2],(w|0)==(N|0)))break l;for(;;){k=i[M+12>>2],o=i[_+8>>2],X=k-o|0,k=0-(i[_+12>>2]+(k>>>0<o>>>0)|0)|0,i[w+8>>2]=X,i[w+12>>2]=k;s:{if(l[n+132|0]==1){X=i[w+16>>2],k=0,i[h+172>>2]=0,i[h+164>>2]=0,i[h+168>>2]=0;w:{if(!X){o=0;break w}if((X|0)<0)break f;o=p(X),i[h+164>>2]=o,k=o+X|0,i[h+172>>2]=k,X&&o0(o,0,X),i[h+168>>2]=k,k=i[w+16>>2]}if(E=i[n+136>>2],X=v-16|0,v=X,i[X+12>>2]=k,i[X+8>>2]=o,k=V7(E|0,X+8|0,1,X+4|0)|0,k?(i[31324]=k,k=-1):k=0,v=X+16|0,k=k?-1:i[X+4>>2],(k|0)<0){i[h+108>>2]=0,i[h+80>>2]=72196,i[h+24>>2]=72176,n=i[18053],i[h+16>>2]=n,k=i[n-12>>2],n=h+16|0,i[k+n>>2]=i[18054],i[h+20>>2]=0,k=n+i[i[h+16>>2]-12>>2]|0,o=h+28|0,J0(k,o),u[k+80|0]=0,i[k+72>>2]=0,k=i[18055],i[h+24>>2]=k,w=i[k-12>>2],k=h+24|0,i[w+k>>2]=i[18056],w=i[18052],i[h+16>>2]=w,i[n+i[w-12>>2]>>2]=i[18057],i[h+80>>2]=72196,i[h+16>>2]=72156,i[h+24>>2]=72176,o=R0(o),i[o>>2]=71232,i[h+68>>2]=0,i[h+72>>2]=0,i[h+60>>2]=0,i[h+64>>2]=0,i[h+76>>2]=24,S0(Y(k,27709,33),i[31324]),n=i[h+76>>2];w:{if(n&16){_=h+48|0,k=i[h+72>>2],n=i[h+52>>2],k>>>0<n>>>0?i[h+72>>2]=n:n=k;break w}if(!(n&8)){w=0,u[h+15|0]=0,_=h+4|0;break t}_=h+36|0,n=i[h+44>>2]}if(k=n,n=i[_>>2],w=k-n|0,w>>>0>=2147483640)break o;if(w>>>0>=11){k=w|7,_=p(k+1|0),i[h+12>>2]=k-2147483647,i[h+4>>2]=_,i[h+8>>2]=w;break u}if(u[h+15|0]=w,_=h+4|0,w)break u;w=0;break t}if(i[w+16>>2]!=(k|0)|i[w+20>>2]){if(n=p(40),i[h+16>>2]=n,i[h+20>>2]=37,i[h+24>>2]=-2147483608,k=l[1636]|l[1637]<<8|(l[1638]<<16|l[1639]<<24),o=l[1632]|l[1633]<<8|(l[1634]<<16|l[1635]<<24),u[n|0]=o,u[n+1|0]=o>>>8,u[n+2|0]=o>>>16,u[n+3|0]=o>>>24,u[n+4|0]=k,u[n+5|0]=k>>>8,u[n+6|0]=k>>>16,u[n+7|0]=k>>>24,u[n+37|0]=0,k=l[1665]|l[1666]<<8|(l[1667]<<16|l[1668]<<24),o=l[1661]|l[1662]<<8|(l[1663]<<16|l[1664]<<24),u[n+29|0]=o,u[n+30|0]=o>>>8,u[n+31|0]=o>>>16,u[n+32|0]=o>>>24,u[n+33|0]=k,u[n+34|0]=k>>>8,u[n+35|0]=k>>>16,u[n+36|0]=k>>>24,k=l[1660]|l[1661]<<8|(l[1662]<<16|l[1663]<<24),o=l[1656]|l[1657]<<8|(l[1658]<<16|l[1659]<<24),u[n+24|0]=o,u[n+25|0]=o>>>8,u[n+26|0]=o>>>16,u[n+27|0]=o>>>24,u[n+28|0]=k,u[n+29|0]=k>>>8,u[n+30|0]=k>>>16,u[n+31|0]=k>>>24,k=l[1652]|l[1653]<<8|(l[1654]<<16|l[1655]<<24),o=l[1648]|l[1649]<<8|(l[1650]<<16|l[1651]<<24),u[n+16|0]=o,u[n+17|0]=o>>>8,u[n+18|0]=o>>>16,u[n+19|0]=o>>>24,u[n+20|0]=k,u[n+21|0]=k>>>8,u[n+22|0]=k>>>16,u[n+23|0]=k>>>24,k=l[1644]|l[1645]<<8|(l[1646]<<16|l[1647]<<24),o=l[1640]|l[1641]<<8|(l[1642]<<16|l[1643]<<24),u[n+8|0]=o,u[n+9|0]=o>>>8,u[n+10|0]=o>>>16,u[n+11|0]=o>>>24,u[n+12|0]=k,u[n+13|0]=k>>>8,u[n+14|0]=k>>>16,u[n+15|0]=k>>>24,q(Q,9,0,h+16|0),u[h+27|0]>=0)break n;Z(i[h+16>>2]);break n}if(I4(M,h+164|0),k=i[h+164>>2],!k)break s;i[h+168>>2]=k,Z(k);break s}I4(M,w+24|0)}if(w=w+40|0,(N|0)==(w|0))break}}if(_=_+32|0,(I|0)==(_|0))break}if(qn(n,M),n=i[26917],i[Q>>2]=i[26916],i[Q+4>>2]=n,n=Q+8|0,u[107683]>=0){k=i[26919],i[n>>2]=i[26918],i[n+4>>2]=k,i[n+8>>2]=i[26920];break k}T(n,i[26918],i[26919]);break k}Q0(),H()}if(!w)break t;x(_,n,w)}u[w+_|0]=0,q(Q,9,0,h+4|0),u[h+15|0]<0&&Z(i[h+4>>2]),n=i[18051],i[h+16>>2]=n,i[i[n-12>>2]+(h+16|0)>>2]=i[18059],i[h+24>>2]=i[18060],i[o>>2]=71232,u[h+71|0]<0&&Z(i[h+60>>2]),E0(o),y0(h+80|0)}if(n=i[h+164>>2],!n)break k;i[h+168>>2]=n,Z(n)}if(v=h+176|0,u[s+31|0]>=0)break A;Z(i[s+20>>2])}k=i[V+136>>2];A:{if(!k)break A;n=v-32|0,v=n,k=W[i[i[k>>2]+12>>2]](k)|0;k:{if(k>>>0<=4294967287){F0(M,k+8|0),F0(M,1835295092);break k}F0(M,1),F0(M,1835295092),e4(M,k+16|0,0)}if(k=i[M+12>>2],h=i[V+136>>2],W[i[i[h>>2]+16>>2]](n+12|0,h,M),u[n+31|0]<0&&Z(i[n+20>>2]),u[s+32|0]=0,i[s+12>>2]=k,v=n+32|0,n=l[s+32|0],(n|0)==255)break A;k:{if(n||(k=i[V+16>>2],h=i[V+20>>2],(k|0)==(h|0)))break k;for(;Ko(i[k>>2],M,i[s+12>>2]),k=k+8|0,(h|0)!=(k|0););}k=i[23733],i[s+40>>2]=i[23732],i[s+44>>2]=k,W[i[(s+40|0)+(n<<2)>>2]](s+39|0,s+12|0)}v=s+48|0;A:{if(!m||(n=i[m+4>>2],i[m+4>>2]=n-1,n))break A;W[i[i[m>>2]+8>>2]](m),y(m)}t&&Z(t),v=B+80|0;break r}G0(),H()}i[F+20>>2]=0,i[F+12>>2]=0,i[F+16>>2]=0,n=i[F+28>>2],k=i[F+24>>2];r:{if((n|0)==(k|0)){n=0;break r}if(t=n-k|0,(t|0)<0)break i;n=p(t),t&&x(n,k,t),O=n+t|0}W[i[r+4>>2]](F,e,n,O-n|0,f);r:{if(!i[F+8>>2]){if(!i[F>>2]){i[F+8>>2]=48862,i[A+8>>2]=48862,e=i[F+4>>2],i[A>>2]=i[F>>2],i[A+4>>2]=e;break r}i[A>>2]=5,i[A+4>>2]=2001,i[A+8>>2]=3134;break r}e=i[F+4>>2],i[A>>2]=i[F>>2],i[A+4>>2]=e,i[A+8>>2]=i[F+8>>2]}if(n&&Z(n),A=i[F+24>>2],!A)break e;i[F+28>>2]=A,Z(A)}v=F+48|0;return}G0(),H()}function p7(A,e,r,f){var k=0,n=0,t=0,o=0,s=0,w=0,h=0,_=0,B=0,m=0,X=0,Q=0,V=0;t=v-48|0,v=t,i[A+4>>2]=0,i[A+8>>2]=0,i[A+40>>2]=0,i[A+44>>2]=0,u[A+36|0]=0,i[A+32>>2]=9e4,i[A+24>>2]=0,i[A+28>>2]=0,i[A+12>>2]=0,i[A+16>>2]=4740,i[A+48>>2]=0,i[A+52>>2]=0,i[A+56>>2]=0,i[A+60>>2]=0,k=A- -64|0,i[k>>2]=0,i[k+4>>2]=0,i[A+72>>2]=0,i[A+76>>2]=0,i[A+80>>2]=0,i[A+84>>2]=0,i[A+88>>2]=0,i[A+92>>2]=0,u[A+96|0]=0,i[A>>2]=106540,o0(A+100|0,0,188),i[A+20>>2]=e,k=i[e+48>>2],s=i[e+52>>2],s&&(i[s+4>>2]=i[s+4>>2]+1),e=i[k+140>>2],k=i[k+144>>2],k&&(i[k+4>>2]=i[k+4>>2]+1),i[A+124>>2]=e,n=i[A+128>>2],i[A+128>>2]=k;i:{if(!n||(e=i[n+4>>2],i[n+4>>2]=e-1,e))break i;W[i[i[n>>2]+8>>2]](n),y(n)}i:{if(!s||(e=i[s+4>>2],i[s+4>>2]=e-1,e))break i;W[i[i[s>>2]+8>>2]](s),y(s)}k=i[A+124>>2],i[t+36>>2]=0,i[t+28>>2]=0,i[t+32>>2]=0,e=i[k+36>>2],n=i[k+40>>2];i:{if((e|0)==(n|0)){o=1;break i}for(;;){k=i[e>>2];e:{if(!k||(k=W0(k,86580,92824),!k)||(i[t+40>>2]=k,k=i[e+4>>2],i[t+44>>2]=k,k&&(i[k+4>>2]=i[k+4>>2]+1),r2(t+28|0,t+40|0),s=i[t+44>>2],!s)||(k=i[s+4>>2],i[s+4>>2]=k-1,k))break e;W[i[i[s>>2]+8>>2]](s),y(s)}if(e=e+8|0,(n|0)==(e|0))break}if(o=1,n=i[t+28>>2],s=i[t+32>>2],(n|0)!=(s|0)){for(;;){for(e=i[i[n>>2]+36>>2];;){e:{if(k=i[e>>2],k&&(w=W0(k,86580,104520),w))break e;e=e+8|0;continue}break}_=i[e+4>>2];e:{if(!_){e=i[w+120>>2],o=e>>>0<o>>>0?o:e+1|0;break e}if(k=i[_+4>>2],e=k+1|0,i[_+4>>2]=e,w=i[w+120>>2],i[_+4>>2]=k,o=o>>>0>w>>>0?o:w+1|0,e)break e;W[i[i[_>>2]+8>>2]](_),y(_)}if(n=n+8|0,(s|0)==(n|0))break}n=i[t+28>>2]}if(!n)break i;if(e=i[t+32>>2],k=n,(e|0)!=(k|0)){for(;;){s=i[e-4>>2];e:{if(!s||(k=i[s+4>>2],i[s+4>>2]=k-1,k))break e;W[i[i[s>>2]+8>>2]](s),y(s)}if(e=e-8|0,(n|0)==(e|0))break}k=i[t+28>>2]}i[t+32>>2]=n,Z(k)}for(e=i[i[A+124>>2]+36>>2];;){i:{e:{if(k=i[e>>2],!k||(k=W0(k,86580,104440),!k))break e;if(n=i[e+4>>2],!n){i[k+180>>2]=o+1,i[A+24>>2]=o;break i}if(i[n+4>>2]=i[n+4>>2]+1,i[k+180>>2]=o+1,i[A+24>>2]=o,e=i[n+4>>2],i[n+4>>2]=e-1,e)break i;W[i[i[n>>2]+8>>2]](n),y(n);break i}e=e+8|0;continue}break}e=p(120),i[e+4>>2]=0,i[e+8>>2]=0,i[e>>2]=92724,n=e+16|0,k=n,i[k+8>>2]=0,i[k+12>>2]=0,i[e+32>>2]=0,i[e+36>>2]=0,i[e+40>>2]=0,i[e+44>>2]=0,i[e+48>>2]=0,i[e+16>>2]=86356,i[e+60>>2]=0,i[e+64>>2]=0,i[e+52>>2]=0,i[e+56>>2]=0,i[e+72>>2]=-1,i[e+76>>2]=-1,i[e+80>>2]=-1,i[e+84>>2]=-1,i[e+88>>2]=0,i[e+92>>2]=0,i[e+96>>2]=0,i[e+100>>2]=0,i[e+104>>2]=0,i[e+108>>2]=0,u[e+112|0]=0,i[e+32>>2]=1953653099,i[e+16>>2]=92764,i[A+132>>2]=k,k=i[A+136>>2],i[A+136>>2]=e;i:{e:{if(!k){k=i[A+124>>2],i[t+32>>2]=e,i[t+28>>2]=n;break e}if(e=i[k+4>>2],i[k+4>>2]=e-1,e||(W[i[i[k>>2]+8>>2]](k),y(k)),k=i[A+124>>2],n=i[A+132>>2],e=i[A+136>>2],i[t+32>>2]=e,i[t+28>>2]=n,!e)break i}i[e+4>>2]=i[e+4>>2]+1}r2(k+36|0,t+28|0),k=i[t+32>>2];i:{if(!k||(e=i[k+4>>2],i[k+4>>2]=e-1,e))break i;W[i[i[k>>2]+8>>2]](k),y(k)}e=p(208),i[e+4>>2]=0,i[e+8>>2]=0,i[e>>2]=92844,n=e+16|0,k=n,i[k+8>>2]=0,i[k+12>>2]=0,i[e+32>>2]=0,i[e+36>>2]=0,i[e+40>>2]=0,i[e+44>>2]=0,i[e+48>>2]=0,i[e+16>>2]=86356,i[e+60>>2]=0,i[e+64>>2]=0,i[e+52>>2]=0,i[e+56>>2]=0,i[e+72>>2]=-1,i[e+76>>2]=-1,i[e+80>>2]=-1,i[e+84>>2]=-1,i[e+88>>2]=0,i[e+92>>2]=0,i[e+96>>2]=0,i[e+100>>2]=0,i[e+104>>2]=0,i[e+108>>2]=0,g[e+112>>1]=0,i[e+16>>2]=104460,k=i[14752],i[e+160>>2]=i[14751],i[e+164>>2]=k,k=i[14754],i[e+168>>2]=i[14753],i[e+172>>2]=k,k=i[14756],i[e+176>>2]=i[14755],i[e+180>>2]=k,k=i[14758],i[e+184>>2]=i[14757],i[e+188>>2]=k,i[e+192>>2]=i[14759],i[e+152>>2]=0,i[e+144>>2]=0,i[e+148>>2]=0,i[e+120>>2]=0,i[e+124>>2]=0,i[e+128>>2]=0,i[e+132>>2]=0,i[e+136>>2]=0,g[e+156>>1]=256,i[e+196>>2]=0,i[e+200>>2]=0,i[e+32>>2]=1953196132,i[e+116>>2]=7,i[A+140>>2]=n,k=i[A+144>>2],i[A+144>>2]=e;i:{e:{if(!k){k=i[A+132>>2],i[t+32>>2]=e,i[t+28>>2]=n;break e}if(e=i[k+4>>2],i[k+4>>2]=e-1,e||(W[i[i[k>>2]+8>>2]](k),y(k)),k=i[A+132>>2],n=i[A+140>>2],e=i[A+144>>2],i[t+32>>2]=e,i[t+28>>2]=n,!e)break i}i[e+4>>2]=i[e+4>>2]+1}r2(k+36|0,t+28|0),k=i[t+32>>2];i:{if(!k||(e=i[k+4>>2],i[k+4>>2]=e-1,e))break i;W[i[i[k>>2]+8>>2]](k),y(k)}i[i[A+140>>2]+120>>2]=o,s=p(120),i[s>>2]=92884,i[s+4>>2]=0,i[s+8>>2]=0,k=s+16|0,e=k,i[e+8>>2]=0,i[e+12>>2]=0,i[s+32>>2]=0,i[s+36>>2]=0,i[s+40>>2]=0,i[s+44>>2]=0,i[s+48>>2]=0,i[s+16>>2]=86356,i[s+60>>2]=0,i[s+64>>2]=0,i[s+52>>2]=0,i[s+56>>2]=0,i[s+72>>2]=-1,i[s+76>>2]=-1,i[s+80>>2]=-1,i[s+84>>2]=-1,i[s+88>>2]=0,i[s+92>>2]=0,i[s+96>>2]=0,i[s+100>>2]=0,i[s+104>>2]=0,i[s+108>>2]=0,u[s+112|0]=0,i[s+32>>2]=1835297121,i[s+16>>2]=92924,e=i[A+132>>2],i[t+32>>2]=s,i[t+28>>2]=k,i[s+4>>2]=i[s+4>>2]+1,r2(e+36|0,t+28|0),k=i[t+32>>2];i:{if(!k||(e=i[k+4>>2],i[k+4>>2]=e-1,e))break i;W[i[i[k>>2]+8>>2]](k),y(k)}e=p(160),i[e+4>>2]=0,i[e+8>>2]=0,i[e>>2]=93004,k=e+16|0,i[k+8>>2]=0,i[k+12>>2]=0,i[e+32>>2]=0,i[e+36>>2]=0,i[e+40>>2]=0,i[e+44>>2]=0,i[e+48>>2]=0,i[e+16>>2]=86356,i[e+60>>2]=0,i[e+64>>2]=0,i[e+52>>2]=0,i[e+56>>2]=0,i[e+72>>2]=-1,i[e+76>>2]=-1,i[e+80>>2]=-1,i[e+84>>2]=-1,i[e+116>>2]=0,i[e+88>>2]=0,i[e+92>>2]=0,i[e+96>>2]=0,i[e+100>>2]=0,i[e+104>>2]=0,i[e+108>>2]=0,g[e+112>>1]=0,i[e+16>>2]=104540,i[e+120>>2]=0,i[e+124>>2]=0,i[e+144>>2]=0,i[e+148>>2]=0,i[e+128>>2]=0,i[e+132>>2]=0,i[e+136>>2]=0,u[e+152|0]=117,u[e+153|0]=110,u[e+154|0]=107,u[e+155|0]=0,i[e+32>>2]=1835296868,i[A+156>>2]=k,k=i[A+160>>2],i[A+160>>2]=e;i:{if(!k||(e=i[k+4>>2],i[k+4>>2]=e-1,e))break i;W[i[i[k>>2]+8>>2]](k),y(k)}e=i[A+156>>2],i[e+120>>2]=r?i[r>>2]:9e4,i[t+28>>2]=e,e=i[A+160>>2],i[t+32>>2]=e,e&&(i[e+4>>2]=i[e+4>>2]+1),n=s+52|0,r2(n,t+28|0),k=i[t+32>>2];i:{if(!k||(e=i[k+4>>2],i[k+4>>2]=e-1,e))break i;W[i[i[k>>2]+8>>2]](k),y(k)}e=p(152),i[e+4>>2]=0,i[e+8>>2]=0,i[e>>2]=89804,k=e+16|0,i[k+8>>2]=0,i[k+12>>2]=0,i[e+32>>2]=0,i[e+36>>2]=0,i[e+40>>2]=0,i[e+44>>2]=0,i[e+48>>2]=0,i[e+16>>2]=86356,i[e+60>>2]=0,i[e+64>>2]=0,i[e+52>>2]=0,i[e+56>>2]=0,i[e+72>>2]=-1,i[e+76>>2]=-1,i[e+80>>2]=-1,i[e+84>>2]=-1,i[e+116>>2]=0,i[e+88>>2]=0,i[e+92>>2]=0,i[e+96>>2]=0,i[e+100>>2]=0,i[e+104>>2]=0,i[e+108>>2]=0,g[e+112>>1]=0,i[e+16>>2]=87124,i[e+128>>2]=0,i[e+132>>2]=0,i[e+120>>2]=0,i[e+124>>2]=1885954932,i[e+136>>2]=0,i[e+140>>2]=0,i[e+144>>2]=0,i[e+148>>2]=0,i[e+32>>2]=1751411826,i[A+164>>2]=k,w=i[A+168>>2],i[A+168>>2]=e;i:{e:{if(!w){i[t+32>>2]=e,i[t+28>>2]=k;break e}if(e=i[w+4>>2],i[w+4>>2]=e-1,e||(W[i[i[w>>2]+8>>2]](w),y(w)),k=i[A+164>>2],e=i[A+168>>2],i[t+32>>2]=e,i[t+28>>2]=k,!e)break i}i[e+4>>2]=i[e+4>>2]+1}r2(n,t+28|0),k=i[t+32>>2];i:{if(!k||(e=i[k+4>>2],i[k+4>>2]=e-1,e))break i;W[i[i[k>>2]+8>>2]](k),y(k)}i[i[A+164>>2]+108>>2]=f,e=p(120),i[e>>2]=93044,i[e+4>>2]=0,i[e+8>>2]=0,f=e+16|0,i[f+8>>2]=0,i[f+12>>2]=0,i[e+32>>2]=0,i[e+36>>2]=0,i[e+40>>2]=0,i[e+44>>2]=0,i[e+48>>2]=0,i[e+16>>2]=86356,i[e+60>>2]=0,i[e+64>>2]=0,i[e+52>>2]=0,i[e+56>>2]=0,i[e+72>>2]=-1,i[e+76>>2]=-1,i[e+80>>2]=-1,i[e+84>>2]=-1,i[e+88>>2]=0,i[e+92>>2]=0,i[e+96>>2]=0,i[e+100>>2]=0,i[e+104>>2]=0,i[e+108>>2]=0,u[e+112|0]=0,i[e+32>>2]=1835626086,i[e+16>>2]=93084,i[A+148>>2]=f,k=i[A+152>>2],i[A+152>>2]=e;i:{e:{if(!k){i[t+32>>2]=e,i[t+28>>2]=f;break e}if(e=i[k+4>>2],i[k+4>>2]=e-1,e||(W[i[i[k>>2]+8>>2]](k),y(k)),f=i[A+148>>2],e=i[A+152>>2],i[t+32>>2]=e,i[t+28>>2]=f,!e)break i}i[e+4>>2]=i[e+4>>2]+1}r2(n,t+28|0),f=i[t+32>>2];i:{if(!f||(e=i[f+4>>2],i[f+4>>2]=e-1,e))break i;W[i[i[f>>2]+8>>2]](f),y(f)}f=p(120),e=f,i[e+4>>2]=0,i[e+8>>2]=0,i[e>>2]=91044,k=e+16|0,e=k,i[e+8>>2]=0,i[e+12>>2]=0,i[f+32>>2]=0,i[f+36>>2]=0,i[f+40>>2]=0,i[f+44>>2]=0,i[f+48>>2]=0,i[f+16>>2]=86356,i[f+60>>2]=0,i[f+64>>2]=0,i[f+52>>2]=0,i[f+56>>2]=0,i[f+72>>2]=-1,i[f+76>>2]=-1,i[f+80>>2]=-1,i[f+84>>2]=-1,i[f+88>>2]=0,i[f+92>>2]=0,i[f+96>>2]=0,i[f+100>>2]=0,i[f+104>>2]=0,i[f+108>>2]=0,u[f+112|0]=0,i[f+16>>2]=88552,i[f+32>>2]=1684631142,m=p(120),i[m>>2]=91084,i[m+4>>2]=0,i[m+8>>2]=0,o=m+16|0,e=o,i[e+8>>2]=0,i[e+12>>2]=0,i[e+16>>2]=0,i[e+20>>2]=0,i[e+24>>2]=0,i[e+28>>2]=0,i[e+32>>2]=0,i[e>>2]=86356,i[m+60>>2]=0,i[m+64>>2]=0,i[m+52>>2]=0,i[m+56>>2]=0,i[m+72>>2]=-1,i[m+76>>2]=-1,i[m+80>>2]=-1,i[m+84>>2]=-1,i[m+116>>2]=0,i[m+88>>2]=0,i[m+92>>2]=0,i[m+96>>2]=0,i[m+100>>2]=0,i[m+104>>2]=0,i[m+108>>2]=0,g[m+112>>1]=0,i[e>>2]=88632,i[m+32>>2]=1685218662,_=p(136),i[_>>2]=91124,i[_+4>>2]=0,i[_+8>>2]=0,w=_+16|0,e=w,i[e+8>>2]=0,i[e+12>>2]=0,i[e+16>>2]=0,i[e+20>>2]=0,i[e+24>>2]=0,i[e+28>>2]=0,i[e+32>>2]=0,i[e>>2]=86356,i[_+60>>2]=0,i[_+64>>2]=0,i[_+52>>2]=0,i[_+56>>2]=0,i[_+72>>2]=-1,i[_+76>>2]=-1,i[_+80>>2]=-1,i[_+84>>2]=-1,i[_+88>>2]=0,i[_+92>>2]=0,i[_+96>>2]=0,i[_+100>>2]=0,i[_+104>>2]=0,i[_+108>>2]=0,g[_+112>>1]=0,i[e>>2]=88712,i[_+128>>2]=0,i[_+120>>2]=0,i[_+124>>2]=0,i[_+116>>2]=1,i[_+32>>2]=1970433056,e=i[A+148>>2],i[t+32>>2]=f,i[t+28>>2]=k,i[f+4>>2]=i[f+4>>2]+1,r2(e+36|0,t+28|0),n=f+52|0,k=i[t+32>>2];i:{if(!k||(e=i[k+4>>2],i[k+4>>2]=e-1,e))break i;W[i[i[k>>2]+8>>2]](k),y(k)}k=m+52|0,i[t+32>>2]=m,i[t+28>>2]=o,i[m+4>>2]=i[m+4>>2]+1,r2(n,t+28|0),n=i[t+32>>2];i:{if(!n||(e=i[n+4>>2],i[n+4>>2]=e-1,e))break i;W[i[i[n>>2]+8>>2]](n),y(n)}i[t+32>>2]=_,i[t+28>>2]=w,i[_+4>>2]=i[_+4>>2]+1,r2(k,t+28|0),k=i[t+32>>2];i:{if(!k||(e=i[k+4>>2],i[k+4>>2]=e-1,e))break i;W[i[i[k>>2]+8>>2]](k),y(k)}e=p(120),i[e+4>>2]=0,i[e+8>>2]=0,i[e>>2]=93204,k=e+16|0,i[k+8>>2]=0,i[k+12>>2]=0,i[e+32>>2]=0,i[e+36>>2]=0,i[e+40>>2]=0,i[e+44>>2]=0,i[e+48>>2]=0,i[e+16>>2]=86356,i[e+60>>2]=0,i[e+64>>2]=0,i[e+52>>2]=0,i[e+56>>2]=0,i[e+72>>2]=-1,i[e+76>>2]=-1,i[e+80>>2]=-1,i[e+84>>2]=-1,i[e+88>>2]=0,i[e+92>>2]=0,i[e+96>>2]=0,i[e+100>>2]=0,i[e+104>>2]=0,i[e+108>>2]=0,u[e+112|0]=0,i[e+32>>2]=1937007212,i[e+16>>2]=93244,i[A+172>>2]=k,n=i[A+176>>2],i[A+176>>2]=e;i:{e:{if(!n){o=i[A+148>>2],i[t+32>>2]=e,i[t+28>>2]=k;break e}if(e=i[n+4>>2],i[n+4>>2]=e-1,e||(W[i[i[n>>2]+8>>2]](n),y(n)),o=i[A+148>>2],k=i[A+172>>2],e=i[A+176>>2],i[t+32>>2]=e,i[t+28>>2]=k,!e)break i}i[e+4>>2]=i[e+4>>2]+1}r2(o+36|0,t+28|0),k=i[t+32>>2];i:{if(!k||(e=i[k+4>>2],i[k+4>>2]=e-1,e))break i;W[i[i[k>>2]+8>>2]](k),y(k)}e=p(136),i[e+4>>2]=0,i[e+8>>2]=0,i[e>>2]=93324,k=e+16|0,i[k+8>>2]=0,i[k+12>>2]=0,i[e+32>>2]=0,i[e+36>>2]=0,i[e+40>>2]=0,i[e+44>>2]=0,i[e+48>>2]=0,i[e+16>>2]=86356,i[e+60>>2]=0,i[e+64>>2]=0,i[e+52>>2]=0,i[e+56>>2]=0,i[e+72>>2]=-1,i[e+76>>2]=-1,i[e+80>>2]=-1,i[e+84>>2]=-1,i[e+116>>2]=0,i[e+88>>2]=0,i[e+92>>2]=0,i[e+96>>2]=0,i[e+100>>2]=0,i[e+104>>2]=0,i[e+108>>2]=0,g[e+112>>1]=0,i[e+16>>2]=104780,i[e+128>>2]=0,i[e+120>>2]=0,i[e+124>>2]=0,i[e+32>>2]=1937011556,i[A+180>>2]=k,n=i[A+184>>2],i[A+184>>2]=e;i:{e:{if(!n){o=i[A+172>>2],i[t+32>>2]=e,i[t+28>>2]=k;break e}if(e=i[n+4>>2],i[n+4>>2]=e-1,e||(W[i[i[n>>2]+8>>2]](n),y(n)),o=i[A+172>>2],k=i[A+180>>2],e=i[A+184>>2],i[t+32>>2]=e,i[t+28>>2]=k,!e)break i}i[e+4>>2]=i[e+4>>2]+1}r2(o+36|0,t+28|0),k=i[t+32>>2];i:{if(!k||(e=i[k+4>>2],i[k+4>>2]=e-1,e))break i;W[i[i[k>>2]+8>>2]](k),y(k)}e=p(144),i[e+4>>2]=0,i[e+8>>2]=0,i[e>>2]=93364,k=e+16|0,i[k+8>>2]=0,i[k+12>>2]=0,i[e+32>>2]=0,i[e+36>>2]=0,i[e+40>>2]=0,i[e+44>>2]=0,i[e+48>>2]=0,i[e+16>>2]=86356,i[e+60>>2]=0,i[e+64>>2]=0,i[e+52>>2]=0,i[e+56>>2]=0,i[e+72>>2]=-1,i[e+76>>2]=-1,i[e+80>>2]=-1,i[e+84>>2]=-1,i[e+116>>2]=0,i[e+88>>2]=0,i[e+92>>2]=0,i[e+96>>2]=0,i[e+100>>2]=0,i[e+104>>2]=0,i[e+108>>2]=0,g[e+112>>1]=0,i[e+16>>2]=104860,i[e+136>>2]=0,i[e+128>>2]=0,i[e+132>>2]=0,i[e+120>>2]=0,i[e+124>>2]=0,i[e+32>>2]=1937011827,i[A+204>>2]=k,n=i[A+208>>2],i[A+208>>2]=e;i:{e:{if(!n){o=i[A+172>>2],i[t+32>>2]=e,i[t+28>>2]=k;break e}if(e=i[n+4>>2],i[n+4>>2]=e-1,e||(W[i[i[n>>2]+8>>2]](n),y(n)),o=i[A+172>>2],k=i[A+204>>2],e=i[A+208>>2],i[t+32>>2]=e,i[t+28>>2]=k,!e)break i}i[e+4>>2]=i[e+4>>2]+1}r2(o+36|0,t+28|0),k=i[t+32>>2];i:{if(!k||(e=i[k+4>>2],i[k+4>>2]=e-1,e))break i;W[i[i[k>>2]+8>>2]](k),y(k)}e=p(144),i[e+4>>2]=0,i[e+8>>2]=0,i[e>>2]=93404,k=e+16|0,i[k+8>>2]=0,i[k+12>>2]=0,i[e+32>>2]=0,i[e+36>>2]=0,i[e+40>>2]=0,i[e+44>>2]=0,i[e+48>>2]=0,i[e+16>>2]=86356,i[e+60>>2]=0,i[e+64>>2]=0,i[e+52>>2]=0,i[e+56>>2]=0,i[e+72>>2]=-1,i[e+76>>2]=-1,i[e+80>>2]=-1,i[e+84>>2]=-1,i[e+116>>2]=0,i[e+88>>2]=0,i[e+92>>2]=0,i[e+96>>2]=0,i[e+100>>2]=0,i[e+104>>2]=0,i[e+108>>2]=0,g[e+112>>1]=0,i[e+16>>2]=104940,i[e+136>>2]=0,i[e+128>>2]=0,i[e+132>>2]=0,i[e+120>>2]=0,i[e+124>>2]=0,i[e+32>>2]=1668576371,i[A+212>>2]=k,k=i[A+216>>2],i[A+216>>2]=e;i:{if(!k||(e=i[k+4>>2],i[k+4>>2]=e-1,e))break i;W[i[i[k>>2]+8>>2]](k),y(k)}e=p(144),i[e+4>>2]=0,i[e+8>>2]=0,i[e>>2]=93444,k=e+16|0,i[k+8>>2]=0,i[k+12>>2]=0,i[e+32>>2]=0,i[e+36>>2]=0,i[e+40>>2]=0,i[e+44>>2]=0,i[e+48>>2]=0,i[e+16>>2]=86356,i[e+60>>2]=0,i[e+64>>2]=0,i[e+52>>2]=0,i[e+56>>2]=0,i[e+72>>2]=-1,i[e+76>>2]=-1,i[e+80>>2]=-1,i[e+84>>2]=-1,i[e+116>>2]=0,i[e+88>>2]=0,i[e+92>>2]=0,i[e+96>>2]=0,i[e+100>>2]=0,i[e+104>>2]=0,i[e+108>>2]=0,g[e+112>>1]=0,i[e+16>>2]=105020,i[e+136>>2]=0,i[e+128>>2]=0,i[e+132>>2]=0,i[e+120>>2]=0,i[e+124>>2]=0,i[e+32>>2]=1937011555,i[A+188>>2]=k,n=i[A+192>>2],i[A+192>>2]=e;i:{e:{if(!n){o=i[A+172>>2],i[t+32>>2]=e,i[t+28>>2]=k;break e}if(e=i[n+4>>2],i[n+4>>2]=e-1,e||(W[i[i[n>>2]+8>>2]](n),y(n)),o=i[A+172>>2],k=i[A+188>>2],e=i[A+192>>2],i[t+32>>2]=e,i[t+28>>2]=k,!e)break i}i[e+4>>2]=i[e+4>>2]+1}r2(o+36|0,t+28|0),k=i[t+32>>2];i:{if(!k||(e=i[k+4>>2],i[k+4>>2]=e-1,e))break i;W[i[i[k>>2]+8>>2]](k),y(k)}e=p(152),i[e+4>>2]=0,i[e+8>>2]=0,i[e>>2]=93524,k=e+16|0,i[k+8>>2]=0,i[k+12>>2]=0,i[e+32>>2]=0,i[e+36>>2]=0,i[e+40>>2]=0,i[e+44>>2]=0,i[e+48>>2]=0,i[e+16>>2]=86356,i[e+60>>2]=0,i[e+64>>2]=0,i[e+52>>2]=0,i[e+56>>2]=0,i[e+72>>2]=-1,i[e+76>>2]=-1,i[e+80>>2]=-1,i[e+84>>2]=-1,i[e+116>>2]=0,i[e+88>>2]=0,i[e+92>>2]=0,i[e+96>>2]=0,i[e+100>>2]=0,i[e+104>>2]=0,i[e+108>>2]=0,g[e+112>>1]=0,i[e+16>>2]=105180,i[e+144>>2]=0,i[e+136>>2]=0,i[e+140>>2]=0,i[e+128>>2]=0,i[e+132>>2]=0,i[e+120>>2]=0,i[e+124>>2]=0,i[e+32>>2]=1937011578,i[A+228>>2]=k,n=i[A+232>>2],i[A+232>>2]=e;i:{e:{if(!n){o=i[A+172>>2],i[t+32>>2]=e,i[t+28>>2]=k;break e}if(e=i[n+4>>2],i[n+4>>2]=e-1,e||(W[i[i[n>>2]+8>>2]](n),y(n)),o=i[A+172>>2],k=i[A+228>>2],e=i[A+232>>2],i[t+32>>2]=e,i[t+28>>2]=k,!e)break i}i[e+4>>2]=i[e+4>>2]+1}r2(o+36|0,t+28|0),k=i[t+32>>2];i:{if(!k||(e=i[k+4>>2],i[k+4>>2]=e-1,e))break i;W[i[i[k>>2]+8>>2]](k),y(k)}e=p(144),i[e+4>>2]=0,i[e+8>>2]=0,i[e>>2]=93484,k=e+16|0,i[k+8>>2]=0,i[k+12>>2]=0,i[e+32>>2]=0,i[e+36>>2]=0,i[e+40>>2]=0,i[e+44>>2]=0,i[e+48>>2]=0,i[e+16>>2]=86356,i[e+60>>2]=0,i[e+64>>2]=0,i[e+52>>2]=0,i[e+56>>2]=0,i[e+72>>2]=-1,i[e+76>>2]=-1,i[e+80>>2]=-1,i[e+84>>2]=-1,i[e+116>>2]=0,i[e+88>>2]=0,i[e+92>>2]=0,i[e+96>>2]=0,i[e+100>>2]=0,i[e+104>>2]=0,i[e+108>>2]=0,g[e+112>>1]=0,i[e+16>>2]=105100,i[e+136>>2]=0,i[e+140>>2]=0,i[e+128>>2]=0,i[e+132>>2]=0,i[e+120>>2]=0,i[e+124>>2]=0,i[e+32>>2]=1937007471,i[A+196>>2]=k,n=i[A+200>>2],i[A+200>>2]=e;i:{e:{if(!n){o=i[A+172>>2],i[t+32>>2]=e,i[t+28>>2]=k;break e}if(e=i[n+4>>2],i[n+4>>2]=e-1,e||(W[i[i[n>>2]+8>>2]](n),y(n)),o=i[A+172>>2],k=i[A+196>>2],e=i[A+200>>2],i[t+32>>2]=e,i[t+28>>2]=k,!e)break i}i[e+4>>2]=i[e+4>>2]+1}r2(o+36|0,t+28|0),k=i[t+32>>2];i:{if(!k||(e=i[k+4>>2],i[k+4>>2]=e-1,e))break i;W[i[i[k>>2]+8>>2]](k),y(k)}e=p(144),i[e+4>>2]=0,i[e+8>>2]=0,i[e>>2]=93564,k=e+16|0,i[k+8>>2]=0,i[k+12>>2]=0,i[e+32>>2]=0,i[e+36>>2]=0,i[e+40>>2]=0,i[e+44>>2]=0,i[e+48>>2]=0,i[e+16>>2]=86356,i[e+60>>2]=0,i[e+64>>2]=0,i[e+52>>2]=0,i[e+56>>2]=0,i[e+72>>2]=-1,i[e+76>>2]=-1,i[e+80>>2]=-1,i[e+84>>2]=-1,i[e+116>>2]=0,i[e+88>>2]=0,i[e+92>>2]=0,i[e+96>>2]=0,i[e+100>>2]=0,i[e+104>>2]=0,i[e+108>>2]=0,g[e+112>>1]=0,i[e+16>>2]=105260,u[e+133|0]=0,u[e+134|0]=0,u[e+135|0]=0,u[e+136|0]=0,u[e+137|0]=0,u[e+138|0]=0,u[e+139|0]=0,u[e+140|0]=0,i[e+128>>2]=0,i[e+132>>2]=0,i[e+120>>2]=0,i[e+124>>2]=0,i[e+32>>2]=1937011571,i[A+220>>2]=k,n=i[A+224>>2],i[A+224>>2]=e;i:{e:{if(!n){o=i[A+172>>2],i[t+32>>2]=e,i[t+28>>2]=k;break e}if(e=i[n+4>>2],i[n+4>>2]=e-1,e||(W[i[i[n>>2]+8>>2]](n),y(n)),o=i[A+172>>2],k=i[A+220>>2],e=i[A+224>>2],i[t+32>>2]=e,i[t+28>>2]=k,!e)break i}i[e+4>>2]=i[e+4>>2]+1}r2(o+36|0,t+28|0),k=i[t+32>>2];i:{if(!k||(e=i[k+4>>2],i[k+4>>2]=e-1,e))break i;W[i[i[k>>2]+8>>2]](k),y(k)}i:{if(!r)break i;if(o=A+32|0,(o|0)!=(r|0))e:{i[o>>2]=i[r>>2],u[o+4|0]=l[r+4|0],i[o+8>>2]=i[r+8>>2];r:{if(i[r+12>>2]){e=f5(),i[o+12>>2]=e,A3(e,i[r+12>>2]);break r}i[o+12>>2]=0}if(i[o+16>>2]=i[r+16>>2],w=o+20|0,n=r+20|0,k=u[r+31|0],u[o+31|0]>=0){if((k|0)>=0){e=i[n+4>>2],i[w>>2]=i[n>>2],i[w+4>>2]=e,i[w+8>>2]=i[n+8>>2];break e}M1(w,i[r+20>>2],i[r+24>>2]);break e}e=(k|0)<0,O1(w,e?i[r+20>>2]:n,e?i[r+24>>2]:k)}if(i[A+40>>2]&&(e=nn(p(32),l[A+36|0]),i[t+28>>2]=0,Bi(A+264|0,e),Bi(t+28|0,0),e=i[A+264>>2],k=i[e>>2],i[k+108>>2]=0,i[k+104>>2]=1937006953,i[k+100>>2]=1,e=i[e+8>>2],i[e+108>>2]=0,i[e+104>>2]=1937006953,i[e+100>>2]=1),i[A+48>>2]&&(e=nn(p(32),l[A+36|0]),i[t+28>>2]=0,Bi(A+268|0,e),Bi(t+28|0,0),e=i[A+268>>2],k=i[e>>2],i[k+108>>2]=0,i[k+104>>2]=1937074532,i[k+100>>2]=1,e=i[e+8>>2],i[e+108>>2]=0,i[e+104>>2]=1937074532,i[e+100>>2]=1),e=u[r+31|0],!((e|0)<0?i[r+24>>2]:e))break i;V=r+20|0,n=p(152),e=n,i[e+4>>2]=0,i[e+8>>2]=0,i[e>>2]=89804,Q=e+16|0,e=Q,i[e+8>>2]=0,i[e+12>>2]=0,i[e+16>>2]=0,i[e+20>>2]=0,i[e+24>>2]=0,i[e+28>>2]=0,i[e+32>>2]=0,i[e>>2]=86356,i[n+60>>2]=0,i[n+64>>2]=0,i[n+52>>2]=0,i[n+56>>2]=0,i[n+72>>2]=-1,i[n+76>>2]=-1,i[n+80>>2]=-1,i[n+84>>2]=-1,i[n+116>>2]=0,i[n+88>>2]=0,i[n+92>>2]=0,i[n+96>>2]=0,i[n+100>>2]=0,i[n+104>>2]=0,i[n+108>>2]=0,g[n+112>>1]=0,i[e>>2]=87124,i[n+128>>2]=0,i[n+132>>2]=0,i[n+120>>2]=0,i[n+124>>2]=1835365473,i[n+136>>2]=0,i[n+140>>2]=0,i[n+144>>2]=0,i[n+148>>2]=0,i[n+32>>2]=1751411826,k=p(184),i[k>>2]=89964,i[k+4>>2]=0,i[k+8>>2]=0,o=k+16|0,e=o,i[e+8>>2]=0,i[e+12>>2]=0,i[k+32>>2]=0,i[k+36>>2]=0,i[k+40>>2]=0,i[k+44>>2]=0,i[k+48>>2]=0,i[k+16>>2]=86356,i[k+60>>2]=0,i[k+64>>2]=0,i[k+52>>2]=0,i[k+56>>2]=0,i[k+72>>2]=-1,i[k+76>>2]=-1,i[k+80>>2]=-1,i[k+84>>2]=-1,i[k+116>>2]=0,i[k+88>>2]=0,i[k+92>>2]=0,i[k+96>>2]=0,i[k+100>>2]=0,i[k+104>>2]=0,i[k+108>>2]=0,g[k+112>>1]=0,i[k+16>>2]=87284,i[k+128>>2]=0,i[k+132>>2]=0,g[k+124>>1]=0,i[k+120>>2]=0,i[k+136>>2]=0,i[k+140>>2]=0,i[k+144>>2]=0,i[k+148>>2]=0,i[k+152>>2]=0,i[k+156>>2]=0,i[k+160>>2]=0,i[k+164>>2]=0,w=k+168|0,e=w,i[e>>2]=0,i[e+4>>2]=0,u[k+173|0]=0,u[k+174|0]=0,u[k+175|0]=0,u[k+176|0]=0,u[k+177|0]=0,u[k+178|0]=0,u[k+179|0]=0,u[k+180|0]=0,i[k+32>>2]=1768842853,i[k+128>>2]=1970432288,e=p(48),u[e+45|0]=0,B=l[21464]|l[21465]<<8|(l[21466]<<16|l[21467]<<24),h=l[21460]|l[21461]<<8|(l[21462]<<16|l[21463]<<24),u[e+37|0]=h,u[e+38|0]=h>>>8,u[e+39|0]=h>>>16,u[e+40|0]=h>>>24,u[e+41|0]=B,u[e+42|0]=B>>>8,u[e+43|0]=B>>>16,u[e+44|0]=B>>>24,B=l[21459]|l[21460]<<8|(l[21461]<<16|l[21462]<<24),h=l[21455]|l[21456]<<8|(l[21457]<<16|l[21458]<<24),u[e+32|0]=h,u[e+33|0]=h>>>8,u[e+34|0]=h>>>16,u[e+35|0]=h>>>24,u[e+36|0]=B,u[e+37|0]=B>>>8,u[e+38|0]=B>>>16,u[e+39|0]=B>>>24,B=l[21451]|l[21452]<<8|(l[21453]<<16|l[21454]<<24),h=l[21447]|l[21448]<<8|(l[21449]<<16|l[21450]<<24),u[e+24|0]=h,u[e+25|0]=h>>>8,u[e+26|0]=h>>>16,u[e+27|0]=h>>>24,u[e+28|0]=B,u[e+29|0]=B>>>8,u[e+30|0]=B>>>16,u[e+31|0]=B>>>24,B=l[21443]|l[21444]<<8|(l[21445]<<16|l[21446]<<24),h=l[21439]|l[21440]<<8|(l[21441]<<16|l[21442]<<24),u[e+16|0]=h,u[e+17|0]=h>>>8,u[e+18|0]=h>>>16,u[e+19|0]=h>>>24,u[e+20|0]=B,u[e+21|0]=B>>>8,u[e+22|0]=B>>>16,u[e+23|0]=B>>>24,B=l[21435]|l[21436]<<8|(l[21437]<<16|l[21438]<<24),h=l[21431]|l[21432]<<8|(l[21433]<<16|l[21434]<<24),u[e+8|0]=h,u[e+9|0]=h>>>8,u[e+10|0]=h>>>16,u[e+11|0]=h>>>24,u[e+12|0]=B,u[e+13|0]=B>>>8,u[e+14|0]=B>>>16,u[e+15|0]=B>>>24,B=l[21427]|l[21428]<<8|(l[21429]<<16|l[21430]<<24),h=l[21423]|l[21424]<<8|(l[21425]<<16|l[21426]<<24),u[e|0]=h,u[e+1|0]=h>>>8,u[e+2|0]=h>>>16,u[e+3|0]=h>>>24,u[e+4|0]=B,u[e+5|0]=B>>>8,u[e+6|0]=B>>>16,u[e+7|0]=B>>>24,M1(w,e,45),Z(e),i[k+120>>2]=1,w=p(120),i[w>>2]=89924,i[w+4>>2]=0,i[w+8>>2]=0,e=w+16|0,i[e+8>>2]=0,i[e+12>>2]=0,i[e+16>>2]=0,i[e+20>>2]=0,i[e+24>>2]=0,i[e+28>>2]=0,i[e+32>>2]=0,i[e>>2]=86356,i[w+60>>2]=0,i[w+64>>2]=0,i[w+52>>2]=0,i[w+56>>2]=0,i[w+72>>2]=-1,i[w+76>>2]=-1,i[w+80>>2]=-1,i[w+84>>2]=-1,i[w+116>>2]=0,i[w+88>>2]=0,i[w+92>>2]=0,i[w+96>>2]=0,i[w+100>>2]=0,i[w+104>>2]=0,i[w+108>>2]=0,g[w+112>>1]=0,i[e>>2]=87364,i[w+32>>2]=1768517222,i[t+32>>2]=k,i[t+28>>2]=o,i[k+4>>2]=i[k+4>>2]+1,r2(w+52|0,t+28|0),h=i[t+32>>2];e:{if(!h||(o=i[h+4>>2],i[h+4>>2]=o-1,o))break e;W[i[i[h>>2]+8>>2]](h),y(h)}i[t+36>>2]=0,i[t+28>>2]=0,i[t+32>>2]=0,B=t+28|0,o=V,h=u[r+31|0],V=(h|0)<0,o=V?i[r+20>>2]:o,r=(V?i[r+24>>2]:h)+1|0,Xn(B,o,r+o|0,r),X=p(176),i[X>>2]=89884,i[X+4>>2]=0,i[X+8>>2]=0,V=It(X+16|0),rr(t+8|0,V,1,B,1),u[t+27|0]<0&&Z(i[t+16>>2]),r=p(120),i[r+4>>2]=0,i[r+8>>2]=0,i[r>>2]=89684,B=r+16|0,o=B,i[o+8>>2]=0,i[o+12>>2]=0,i[o+16>>2]=0,i[o+20>>2]=0,i[o+24>>2]=0,i[o+28>>2]=0,i[o+32>>2]=0,i[o>>2]=86356,i[r+60>>2]=0,i[r+64>>2]=0,i[r+52>>2]=0,i[r+56>>2]=0,i[r+72>>2]=-1,i[r+76>>2]=-1,i[r+80>>2]=-1,i[r+84>>2]=-1,i[r+116>>2]=0,i[r+88>>2]=0,i[r+92>>2]=0,i[r+96>>2]=0,i[r+100>>2]=0,i[r+104>>2]=0,i[r+108>>2]=0,g[r+112>>1]=0,i[o>>2]=87044,i[r+32>>2]=1835365473,i[t+44>>2]=n,i[t+40>>2]=Q,i[n+4>>2]=i[n+4>>2]+1,h=r+52|0,r2(h,t+40|0),Q=i[t+44>>2];e:{if(!Q||(o=i[Q+4>>2],i[Q+4>>2]=o-1,o))break e;W[i[i[Q>>2]+8>>2]](Q),y(Q)}i[t+44>>2]=w,i[t+40>>2]=e,i[w+4>>2]=i[w+4>>2]+1,r2(h,t+40|0),o=i[t+44>>2];e:{if(!o||(e=i[o+4>>2],i[o+4>>2]=e-1,e))break e;W[i[i[o>>2]+8>>2]](o),y(o)}i[t+44>>2]=X,i[t+40>>2]=V,i[X+4>>2]=i[X+4>>2]+1,r2(h,t+40|0),o=i[t+44>>2];e:{if(!o||(e=i[o+4>>2],i[o+4>>2]=e-1,e))break e;W[i[i[o>>2]+8>>2]](o),y(o)}e=i[A+132>>2],i[t+44>>2]=r,i[t+40>>2]=B,i[r+4>>2]=i[r+4>>2]+1,r2(e+36|0,t+40|0),o=i[t+44>>2];e:{if(!o||(e=i[o+4>>2],i[o+4>>2]=e-1,e))break e;W[i[i[o>>2]+8>>2]](o),y(o)}if(e=i[r+4>>2],i[r+4>>2]=e-1,e||(W[i[i[r>>2]+8>>2]](r),y(r)),e=i[X+4>>2],i[X+4>>2]=e-1,e||(W[i[i[X>>2]+8>>2]](X),y(X)),e=i[t+28>>2],e&&(i[t+32>>2]=e,Z(e)),e=i[w+4>>2],i[w+4>>2]=e-1,e||(W[i[i[w>>2]+8>>2]](w),y(w)),e=i[k+4>>2],i[k+4>>2]=e-1,e||(W[i[i[k>>2]+8>>2]](k),y(k)),e=i[n+4>>2],i[n+4>>2]=e-1,e)break i;W[i[i[n>>2]+8>>2]](n),y(n)}return e=i[_+4>>2],i[_+4>>2]=e-1,e||(W[i[i[_>>2]+8>>2]](_),y(_)),e=i[m+4>>2],i[m+4>>2]=e-1,e||(W[i[i[m>>2]+8>>2]](m),y(m)),e=i[f+4>>2],i[f+4>>2]=e-1,e||(W[i[i[f>>2]+8>>2]](f),y(f)),e=i[s+4>>2],i[s+4>>2]=e-1,e||(W[i[i[s>>2]+8>>2]](s),y(s)),v=t+48|0,A}function S_(A,e){A=A|0,e=e|0;var r=0,f=0,k=0,n=0,t=0,o=0,s=0,w=0,h=0,_=0,B=0,m=0,X=0,Q=0,V=0,F=0,I=0;k=v-144|0,v=k,r=i[e+100>>2],i[k+124>>2]=i[r+48>>2],X=i[r+52>>2],i[k+128>>2]=X,X&&(i[X+4>>2]=i[X+4>>2]+1),r=i[e+108>>2],n=i[e+104>>2];i:{if((r|0)!=(n|0))for(f=n;;){e:{if(t=i[f>>2],!t||(t=W0(t,86580,101812),!t))break e;V=i[f+4>>2],V&&(i[V+4>>2]=i[V+4>>2]+1,n=i[e+104>>2],r=i[e+108>>2]);r:{f:{A:{k:{n:{t:{if((r|0)!=(n|0))for(;;){u:{if(f=i[n>>2],!f||(B=W0(f,86580,86600),!B))break u;if(F=i[n+4>>2],F&&(i[F+4>>2]=i[F+4>>2]+1),r=i[t+164>>2],i[k+112>>2]=i[t+160>>2],i[k+116>>2]=r,r=i[t+156>>2],i[k+104>>2]=i[t+152>>2],i[k+108>>2]=r,r=i[t+148>>2],i[k+96>>2]=i[t+144>>2],i[k+100>>2]=r,r=i[t+140>>2],i[k+88>>2]=i[t+136>>2],i[k+92>>2]=r,r=i[t+132>>2],i[k+80>>2]=i[t+128>>2],i[k+84>>2]=r,r=i[t+124>>2],i[k+72>>2]=i[t+120>>2],i[k+76>>2]=r,r=i[t+116>>2],n=k- -64|0,i[n>>2]=i[t+112>>2],i[n+4>>2]=r,r=i[t+108>>2],i[k+56>>2]=i[t+104>>2],i[k+60>>2]=r,f=i[B+104>>2],i[k+60>>2]=f,r=i[B+108>>2],i[n>>2]=r,r&&f)break t;if(e=p(40),i[k+32>>2]=e,i[k+36>>2]=39,i[k+40>>2]=-2147483608,f=l[23544]|l[23545]<<8|(l[23546]<<16|l[23547]<<24),r=l[23540]|l[23541]<<8|(l[23542]<<16|l[23543]<<24),u[e|0]=r,u[e+1|0]=r>>>8,u[e+2|0]=r>>>16,u[e+3|0]=r>>>24,u[e+4|0]=f,u[e+5|0]=f>>>8,u[e+6|0]=f>>>16,u[e+7|0]=f>>>24,u[e+39|0]=0,f=l[23575]|l[23576]<<8|(l[23577]<<16|l[23578]<<24),r=l[23571]|l[23572]<<8|(l[23573]<<16|l[23574]<<24),u[e+31|0]=r,u[e+32|0]=r>>>8,u[e+33|0]=r>>>16,u[e+34|0]=r>>>24,u[e+35|0]=f,u[e+36|0]=f>>>8,u[e+37|0]=f>>>16,u[e+38|0]=f>>>24,f=l[23568]|l[23569]<<8|(l[23570]<<16|l[23571]<<24),r=l[23564]|l[23565]<<8|(l[23566]<<16|l[23567]<<24),u[e+24|0]=r,u[e+25|0]=r>>>8,u[e+26|0]=r>>>16,u[e+27|0]=r>>>24,u[e+28|0]=f,u[e+29|0]=f>>>8,u[e+30|0]=f>>>16,u[e+31|0]=f>>>24,f=l[23560]|l[23561]<<8|(l[23562]<<16|l[23563]<<24),r=l[23556]|l[23557]<<8|(l[23558]<<16|l[23559]<<24),u[e+16|0]=r,u[e+17|0]=r>>>8,u[e+18|0]=r>>>16,u[e+19|0]=r>>>24,u[e+20|0]=f,u[e+21|0]=f>>>8,u[e+22|0]=f>>>16,u[e+23|0]=f>>>24,f=l[23552]|l[23553]<<8|(l[23554]<<16|l[23555]<<24),r=l[23548]|l[23549]<<8|(l[23550]<<16|l[23551]<<24),u[e+8|0]=r,u[e+9|0]=r>>>8,u[e+10|0]=r>>>16,u[e+11|0]=r>>>24,u[e+12|0]=f,u[e+13|0]=f>>>8,u[e+14|0]=f>>>16,u[e+15|0]=f>>>24,q(A,2,0,k+32|0),u[k+43|0]>=0)break n;Z(i[k+32>>2]);break n}if(n=n+8|0,(n|0)==(r|0))break}if(e=p(48),i[k+56>>2]=e,i[k+60>>2]=40,i[k+64>>2]=-2147483600,f=l[22275]|l[22276]<<8|(l[22277]<<16|l[22278]<<24),r=l[22271]|l[22272]<<8|(l[22273]<<16|l[22274]<<24),u[e|0]=r,u[e+1|0]=r>>>8,u[e+2|0]=r>>>16,u[e+3|0]=r>>>24,u[e+4|0]=f,u[e+5|0]=f>>>8,u[e+6|0]=f>>>16,u[e+7|0]=f>>>24,u[e+40|0]=0,f=l[22307]|l[22308]<<8|(l[22309]<<16|l[22310]<<24),r=l[22303]|l[22304]<<8|(l[22305]<<16|l[22306]<<24),u[e+32|0]=r,u[e+33|0]=r>>>8,u[e+34|0]=r>>>16,u[e+35|0]=r>>>24,u[e+36|0]=f,u[e+37|0]=f>>>8,u[e+38|0]=f>>>16,u[e+39|0]=f>>>24,f=l[22299]|l[22300]<<8|(l[22301]<<16|l[22302]<<24),r=l[22295]|l[22296]<<8|(l[22297]<<16|l[22298]<<24),u[e+24|0]=r,u[e+25|0]=r>>>8,u[e+26|0]=r>>>16,u[e+27|0]=r>>>24,u[e+28|0]=f,u[e+29|0]=f>>>8,u[e+30|0]=f>>>16,u[e+31|0]=f>>>24,f=l[22291]|l[22292]<<8|(l[22293]<<16|l[22294]<<24),r=l[22287]|l[22288]<<8|(l[22289]<<16|l[22290]<<24),u[e+16|0]=r,u[e+17|0]=r>>>8,u[e+18|0]=r>>>16,u[e+19|0]=r>>>24,u[e+20|0]=f,u[e+21|0]=f>>>8,u[e+22|0]=f>>>16,u[e+23|0]=f>>>24,f=l[22283]|l[22284]<<8|(l[22285]<<16|l[22286]<<24),r=l[22279]|l[22280]<<8|(l[22281]<<16|l[22282]<<24),u[e+8|0]=r,u[e+9|0]=r>>>8,u[e+10|0]=r>>>16,u[e+11|0]=r>>>24,u[e+12|0]=f,u[e+13|0]=f>>>8,u[e+14|0]=f>>>16,u[e+15|0]=f>>>24,q(A,2,0,k+56|0),u[k+67|0]>=0)break k;Z(i[k+56>>2]);break k}B=A,I=v-16|0,v=I,A=i[k+60>>2],_=e+448|0,r=_,i[r>>2]=i[k+56>>2],i[r+4>>2]=A,A=i[k+116>>2],i[r+56>>2]=i[k+112>>2],i[r+60>>2]=A,A=i[k+108>>2],i[r+48>>2]=i[k+104>>2],i[r+52>>2]=A,A=i[k+100>>2],i[r+40>>2]=i[k+96>>2],i[r+44>>2]=A,A=i[k+92>>2],i[r+32>>2]=i[k+88>>2],i[r+36>>2]=A,A=i[k+84>>2],i[r+24>>2]=i[k+80>>2],i[r+28>>2]=A,A=i[k+76>>2],i[r+16>>2]=i[k+72>>2],i[r+20>>2]=A,A=i[k+68>>2],i[r+8>>2]=i[k+64>>2],i[r+12>>2]=A,n=i[k+68>>2],r=i[k+60>>2],A=i[23885],w=A;t:{u:{if(f=i[23884],!(A|f)){n=((r+n|0)-1>>>0)/(n>>>0)|0,A=i[k+72>>2],Q=((A+i[k+64>>2]|0)-1>>>0)/(A>>>0)|0,r=l[k+82|0];break u}A=i[k+72>>2],Q=((A+i[k+64>>2]|0)-1>>>0)/(A>>>0)|0,n=((r+n|0)-1>>>0)/(n>>>0)|0,A=O0(Q,0,n,0),o=l0,r=l[k+82|0];o:{if(!r||(A=O0(A,o,i[k+84>>2],0),o=l0,h=r-1|0,!h)||(A=O0(A,o,i[k+88>>2],0),o=l0,(h|0)==1)||(A=O0(A,o,i[k+92>>2],0),o=l0,(h|0)==2)||(A=O0(A,o,i[k+96>>2],0),o=l0,(h|0)==3)||(A=O0(A,o,i[k+100>>2],0),o=l0,(h|0)==4)||(A=O0(A,o,i[k+104>>2],0),o=l0,(h|0)==5)||(A=O0(A,o,i[k+108>>2],0),o=l0,(h|0)==6))break o;A=O0(A,o,i[k+112>>2],0),o=l0}if((w|0)==(o|0)&A>>>0<=f>>>0|o>>>0<w>>>0)break u;if(A=p(40),i[I+4>>2]=A,i[I+8>>2]=38,i[I+12>>2]=-2147483608,f=l[3890]|l[3891]<<8|(l[3892]<<16|l[3893]<<24),r=l[3886]|l[3887]<<8|(l[3888]<<16|l[3889]<<24),u[A|0]=r,u[A+1|0]=r>>>8,u[A+2|0]=r>>>16,u[A+3|0]=r>>>24,u[A+4|0]=f,u[A+5|0]=f>>>8,u[A+6|0]=f>>>16,u[A+7|0]=f>>>24,u[A+38|0]=0,f=l[3920]|l[3921]<<8|(l[3922]<<16|l[3923]<<24),r=l[3916]|l[3917]<<8|(l[3918]<<16|l[3919]<<24),u[A+30|0]=r,u[A+31|0]=r>>>8,u[A+32|0]=r>>>16,u[A+33|0]=r>>>24,u[A+34|0]=f,u[A+35|0]=f>>>8,u[A+36|0]=f>>>16,u[A+37|0]=f>>>24,f=l[3914]|l[3915]<<8|(l[3916]<<16|l[3917]<<24),r=l[3910]|l[3911]<<8|(l[3912]<<16|l[3913]<<24),u[A+24|0]=r,u[A+25|0]=r>>>8,u[A+26|0]=r>>>16,u[A+27|0]=r>>>24,u[A+28|0]=f,u[A+29|0]=f>>>8,u[A+30|0]=f>>>16,u[A+31|0]=f>>>24,f=l[3906]|l[3907]<<8|(l[3908]<<16|l[3909]<<24),r=l[3902]|l[3903]<<8|(l[3904]<<16|l[3905]<<24),u[A+16|0]=r,u[A+17|0]=r>>>8,u[A+18|0]=r>>>16,u[A+19|0]=r>>>24,u[A+20|0]=f,u[A+21|0]=f>>>8,u[A+22|0]=f>>>16,u[A+23|0]=f>>>24,f=l[3898]|l[3899]<<8|(l[3900]<<16|l[3901]<<24),r=l[3894]|l[3895]<<8|(l[3896]<<16|l[3897]<<24),u[A+8|0]=r,u[A+9|0]=r>>>8,u[A+10|0]=r>>>16,u[A+11|0]=r>>>24,u[A+12|0]=f,u[A+13|0]=f>>>8,u[A+14|0]=f>>>16,u[A+15|0]=f>>>24,q(B,3,1e3,I+4|0),u[I+15|0]>=0)break t;Z(i[I+4>>2]);break t}A=G(n,Q),r=r&255;u:{if(!r||(A=G(A,i[k+84>>2]),r=r-1|0,!r)||(A=G(A,i[k+88>>2]),(r|0)==1)||(A=G(A,i[k+92>>2]),(r|0)==2)||(A=G(A,i[k+96>>2]),(r|0)==3)||(A=G(A,i[k+100>>2]),(r|0)==4)||(A=G(A,i[k+104>>2]),(r|0)==5)||(A=G(A,i[k+108>>2]),(r|0)==6))break u;A=G(A,i[k+112>>2])}f=A,r=i[_+68>>2],A=i[_+64>>2],w=r-A>>4;u:{if(f>>>0>w>>>0){Q=0;o:{if(h=f-w|0,o=_- -64|0,n=i[o+8>>2],r=i[o+4>>2],h>>>0<=n-r>>4>>>0){l:{if(!h)break l;if(A=r,f=h&7,f)for(;i[A>>2]=10,i[A+4>>2]=0,i[A+8>>2]=0,i[A+12>>2]=0,A=A+16|0,Q=Q+1|0,(f|0)!=(Q|0););if(r=(h<<4)+r|0,(h-1&268435455)>>>0<7)break l;for(;i[A+24>>2]=0,i[A+28>>2]=0,i[A>>2]=10,i[A+4>>2]=0,i[A+8>>2]=0,i[A+12>>2]=0,i[A+40>>2]=0,i[A+44>>2]=0,i[A+16>>2]=10,i[A+20>>2]=0,i[A+56>>2]=0,i[A+60>>2]=0,i[A+32>>2]=10,i[A+36>>2]=0,i[A+72>>2]=0,i[A+76>>2]=0,i[A+48>>2]=10,i[A+52>>2]=0,i[A+88>>2]=0,i[A+92>>2]=0,i[A+64>>2]=10,i[A+68>>2]=0,i[A+104>>2]=0,i[A+108>>2]=0,i[A+80>>2]=10,i[A+84>>2]=0,i[A+120>>2]=0,i[A+124>>2]=0,i[A+96>>2]=10,i[A+100>>2]=0,i[A+112>>2]=10,i[A+116>>2]=0,A=A+128|0,(r|0)!=(A|0););}i[o+4>>2]=r;break o}l:{if(A=i[o>>2],f=r-A|0,w=h+(f>>4)|0,w>>>0<268435456){if(r=n-A|0,A=r>>3,w=r>>>0>=2147483632?268435455:A>>>0>w>>>0?A:w,w){if(w>>>0>=268435456)break l;s=p(w<<4)}if(n=f+s|0,A=n,r=h&7,r)for(;i[A>>2]=10,i[A+4>>2]=0,i[A+8>>2]=0,i[A+12>>2]=0,A=A+16|0,Q=Q+1|0,(r|0)!=(Q|0););if(f=n+(h<<4)|0,(h-1&268435455)>>>0>=7)for(;i[A+24>>2]=0,i[A+28>>2]=0,i[A>>2]=10,i[A+4>>2]=0,i[A+8>>2]=0,i[A+12>>2]=0,i[A+40>>2]=0,i[A+44>>2]=0,i[A+16>>2]=10,i[A+20>>2]=0,i[A+56>>2]=0,i[A+60>>2]=0,i[A+32>>2]=10,i[A+36>>2]=0,i[A+72>>2]=0,i[A+76>>2]=0,i[A+48>>2]=10,i[A+52>>2]=0,i[A+88>>2]=0,i[A+92>>2]=0,i[A+64>>2]=10,i[A+68>>2]=0,i[A+104>>2]=0,i[A+108>>2]=0,i[A+80>>2]=10,i[A+84>>2]=0,i[A+120>>2]=0,i[A+124>>2]=0,i[A+96>>2]=10,i[A+100>>2]=0,i[A+112>>2]=10,i[A+116>>2]=0,A=A+128|0,(f|0)!=(A|0););A=n,n=i[o>>2],r=i[o+4>>2]-n|0,A=A-r|0,r&&x(A,n,r),i[o+4>>2]=f,i[o>>2]=A,i[o+8>>2]=(w<<4)+s,n&&Z(n);break o}G0(),H()}z0(),H()}r=i[_+68>>2],A=i[_+64>>2];break u}if(f>>>0>=w>>>0)break u;r=(f<<4)+A|0,i[_+68>>2]=r}if((A|0)!=(r|0))for(;i[A>>2]=10,i[A+4>>2]=0,A=A+16|0,(r|0)!=(A|0););if(A=i[26917],i[B>>2]=i[26916],i[B+4>>2]=A,r=B+8|0,u[107683]>=0){A=i[26919],i[r>>2]=i[26918],i[r+4>>2]=A,i[r+8>>2]=i[26920];break t}T(r,i[26918],i[26919])}if(v=I+16|0,i[B>>2])break n;u[B+19|0]<0&&Z(i[B+8>>2]),A=Hu(i[e+468>>2]),Xf(k+32|0,i[e+100>>2],A),r=i[k+32>>2],A=i[k+36>>2],i[k+32>>2]=0,i[k+36>>2]=0,f=i[e+548>>2],i[e+544>>2]=r,i[e+548>>2]=A;t:{if(!f||(A=i[f+4>>2],i[f+4>>2]=A-1,A))break t;W[i[i[f>>2]+8>>2]](f),y(f)}r=i[k+36>>2];t:{if(!r||(A=i[r+4>>2],i[r+4>>2]=A-1,A))break t;W[i[i[r>>2]+8>>2]](r),y(r)}t:{if(l[t+97|0]==1){A=k+32|0,bi(A,e),m=l[k+52|0];u:{if(m){if((m|0)!=1)break A;k8(B,A);break u}s=i[e+544>>2],f=k+20|0,i[f+8>>2]=0,i[f>>2]=0,i[f+4>>2]=0;o:{l:{if(A=i[k+32>>2],t=i[k+36>>2],(A|0)!=(t|0)){if(n=t-A|0,(n|0)<0)break l;for(r=p(n),i[f+4>>2]=r,i[f>>2]=r,i[f+8>>2]=r+n;i[r>>2]=i[A>>2],n=i[A+4>>2],i[r+4>>2]=n,n&&(i[n+4>>2]=i[n+4>>2]+1),r=r+8|0,A=A+8|0,(t|0)!=(A|0););i[f+4>>2]=r}A=f;break o}G0(),H()}if(r=A,A=i[s+104>>2],A){if(t=i[s+108>>2],f=A,(t|0)!=(A|0)){for(;;){n=i[t-4>>2];o:{if(!n||(f=i[n+4>>2],i[n+4>>2]=f-1,f))break o;W[i[i[n>>2]+8>>2]](n),y(n)}if(t=t-8|0,(A|0)==(t|0))break}f=i[s+104>>2]}i[s+108>>2]=A,Z(f),i[s+112>>2]=0,i[s+104>>2]=0,i[s+108>>2]=0}i[s+104>>2]=i[r>>2],i[s+108>>2]=i[r+4>>2],i[s+112>>2]=i[r+8>>2],i[r+8>>2]=0,i[r>>2]=0,i[r+4>>2]=0,ve(r)}if(r=l[k+52|0],(r|0)!=255&&(A=i[25461],i[k+136>>2]=i[25460],i[k+140>>2]=A,W[i[(k+136|0)+(r<<2)>>2]](k+135|0,k+32|0)),!m)break t;break n}i[k+40>>2]=0,i[k+32>>2]=0,i[k+36>>2]=0,f=i[t+36>>2],t=i[t+40>>2];u:{if((f|0)!=(t|0)){if(A=t-f|0,(A|0)<0)break f;for(r=p(A),i[k+36>>2]=r,i[k+32>>2]=r,i[k+40>>2]=A+r,A=r;i[A>>2]=i[f>>2],n=A,A=i[f+4>>2],i[n+4>>2]=A,A&&(i[A+4>>2]=i[A+4>>2]+1),A=n+8|0,f=f+8|0,(t|0)!=(f|0););for(i[k+36>>2]=A,f=r;;){if(i[i[f>>2]+16>>2]==1769173093)break u;if(t=(f|0)==(n|0),f=f+8|0,!!t)break}}h=k+136|0,qt(h),A=i[k+72>>2],r=i[k+136>>2],i[r+104>>2]=i[k+68>>2],i[r+108>>2]=A;o:{l:{s:{r=i[k+36>>2],A=i[k+40>>2];w:{if(r>>>0<A>>>0){i[r>>2]=i[h>>2],i[r+4>>2]=i[h+4>>2],i[h>>2]=0,i[h+4>>2]=0,n=r+8|0;break w}if(w=i[k+32>>2],s=r-w|0,f=s>>3,n=f+1|0,n>>>0>=536870912)break s;if(r=A-w|0,A=r>>2,t=r>>>0>=2147483640?536870911:A>>>0>n>>>0?A:n,t){if(t>>>0>=536870912)break l;A=p(t<<3)}else A=0;if(n=A+s|0,i[n>>2]=i[h>>2],i[n+4>>2]=i[h+4>>2],i[h>>2]=0,i[h+4>>2]=0,r=n-(f<<3)|0,s&&x(r,w,s),i[k+40>>2]=A+(t<<3),n=n+8|0,i[k+36>>2]=n,i[k+32>>2]=r,!w)break w;Z(w)}i[k+36>>2]=n;break o}G0(),H()}z0(),H()}I2(h),A=i[k+36>>2],r=i[k+32>>2]}if(w=i[e+544>>2],i[k+16>>2]=0,i[k+8>>2]=0,i[k+12>>2]=0,f=0,t=0,(A|0)!=(r|0)){if(f=A-r|0,(f|0)<0)break r;for(t=p(f),i[k+8>>2]=t,m=f+t|0,i[k+16>>2]=m,n=r,f=t;i[f>>2]=i[n>>2],s=i[n+4>>2],i[f+4>>2]=s,s&&(i[s+4>>2]=i[s+4>>2]+1),f=f+8|0,n=n+8|0,(n|0)!=(A|0););i[k+12>>2]=f}if(A=i[w+104>>2],A){if(r=A,n=i[w+108>>2],(A|0)!=(n|0)){for(;;){f=i[n-4>>2];u:{if(!f||(r=i[f+4>>2],i[f+4>>2]=r-1,r))break u;W[i[i[f>>2]+8>>2]](f),y(f)}if(n=n-8|0,(A|0)==(n|0))break}m=i[k+16>>2],f=i[k+12>>2],t=i[k+8>>2],r=i[w+104>>2]}i[w+108>>2]=A,Z(r),r=i[k+32>>2]}if(i[w+112>>2]=m,i[w+108>>2]=f,i[w+104>>2]=t,i[k+16>>2]=0,i[k+8>>2]=0,i[k+12>>2]=0,!r)break t;if(n=r,f=i[k+36>>2],(f|0)!=(r|0)){for(;;){n=i[f-4>>2];u:{if(!n||(A=i[n+4>>2],i[n+4>>2]=A-1,A))break u;W[i[i[n>>2]+8>>2]](n),y(n)}if(f=f-8|0,(f|0)==(r|0))break}n=i[k+32>>2]}i[k+36>>2]=r,Z(n)}t:{u:{o:{l:{s:{if(f=i[e+544>>2],A=W[i[i[f>>2]+40>>2]](f)|0,(A|0)<=1781689136){w:{if((A|0)!=1635135537){if((A|0)==1635148593)break w;if((A|0)!=1752589105)break s;r=i[f+104>>2],f=i[f+108>>2];_:{h:{if((r|0)!=(f|0))for(;;){B:{if(A=i[r>>2],!A||(n=W0(A,86580,97564),!n))break B;if(f=i[r+4>>2],!f)break h;i[f+4>>2]=i[f+4>>2]+1;break _}if(r=r+8|0,(f|0)==(r|0))break}n=0}f=0}if(r=p(88),A=r,i[A+4>>2]=0,i[A+8>>2]=0,i[A>>2]=97080,f&&(i[f+4>>2]=i[f+4>>2]+1),A=r+16|0,i[r+64>>2]=0,i[r+56>>2]=0,i[r+60>>2]=0,i[r+24>>2]=0,i[r+28>>2]=0,i[r+36>>2]=0,i[r+40>>2]=0,i[r+72>>2]=0,i[r+76>>2]=0,i[r+84>>2]=f,i[r+80>>2]=n,u[r+32|0]=0,i[r+44>>2]=0,i[r+48>>2]=0,i[r+16>>2]=97648,!f)break u;break o}r=i[f+104>>2],f=i[f+108>>2];_:{h:{if((r|0)!=(f|0))for(;;){B:{if(A=i[r>>2],!A||(n=W0(A,86580,98140),!n))break B;if(f=i[r+4>>2],!f)break h;i[f+4>>2]=i[f+4>>2]+1;break _}if(r=r+8|0,(f|0)==(r|0))break}n=0}f=0}if(r=p(88),A=r,i[A+4>>2]=0,i[A+8>>2]=0,i[A>>2]=97120,f&&(i[f+4>>2]=i[f+4>>2]+1),A=r+16|0,i[r+64>>2]=0,i[r+56>>2]=0,i[r+60>>2]=0,i[r+24>>2]=0,i[r+28>>2]=0,i[r+36>>2]=0,i[r+40>>2]=0,i[r+72>>2]=0,i[r+76>>2]=0,i[r+84>>2]=f,i[r+80>>2]=n,u[r+32|0]=0,i[r+44>>2]=0,i[r+48>>2]=0,i[r+16>>2]=98016,!f)break u;break o}r=i[f+104>>2],f=i[f+108>>2];w:{_:{if((r|0)!=(f|0))for(;;){h:{if(A=i[r>>2],!A||(n=W0(A,86580,100172),!n))break h;if(f=i[r+4>>2],!f)break _;i[f+4>>2]=i[f+4>>2]+1;break w}if(r=r+8|0,(f|0)==(r|0))break}n=0}f=0}if(r=p(88),A=r,i[A+4>>2]=0,i[A+8>>2]=0,i[A>>2]=97160,f&&(i[f+4>>2]=i[f+4>>2]+1),A=r+16|0,i[r+64>>2]=0,i[r+56>>2]=0,i[r+60>>2]=0,i[r+24>>2]=0,i[r+28>>2]=0,i[r+36>>2]=0,i[r+40>>2]=0,i[r+72>>2]=0,i[r+76>>2]=0,i[r+84>>2]=f,i[r+80>>2]=n,u[r+32|0]=0,i[r+44>>2]=0,i[r+48>>2]=0,i[r+16>>2]=100192,!f)break u;break o}if((A|0)<=1836280680){if((A|0)!=1781689137){if((A|0)!=1785750887)break s;r=i[f+104>>2],n=i[f+108>>2];w:{if((r|0)!=(n|0))for(;;){_:{if(A=i[r>>2],!A||(f=W0(A,86580,98564),!f))break _;if(n=i[r+4>>2],!n){n=0;break w}i[n+4>>2]=i[n+4>>2]+1;break w}if(r=r+8|0,(n|0)==(r|0))break}n=0,f=0}if(r=p(112),A=r,i[A+4>>2]=0,i[A+8>>2]=0,i[A>>2]=97280,n&&(i[n+4>>2]=i[n+4>>2]+1),A=r+16|0,i[r+64>>2]=0,i[r+56>>2]=0,i[r+60>>2]=0,i[r+24>>2]=0,i[r+28>>2]=0,i[r+36>>2]=0,i[r+40>>2]=0,i[r+72>>2]=0,i[r+76>>2]=0,i[r+84>>2]=n,i[r+80>>2]=f,u[r+32|0]=0,i[r+44>>2]=0,i[r+48>>2]=0,i[r+16>>2]=98584,n){if(i[n+4>>2]=i[n+4>>2]+1,u[r+104|0]=0,u[r+88|0]=0,f=i[n+4>>2],i[n+4>>2]=f-1,f||(W[i[i[n>>2]+8>>2]](n),y(n)),i[k+36>>2]=r,i[k+32>>2]=A,A=i[n+4>>2],i[n+4>>2]=A-1,A)break t;W[i[i[n>>2]+8>>2]](n),y(n);break t}u[r+104|0]=0,u[r+88|0]=0;break u}r=i[f+104>>2],f=i[f+108>>2];w:{if((r|0)!=(f|0))for(;;){_:{if(A=i[r>>2],!A||(n=W0(A,86580,99476),!n))break _;if(f=i[r+4>>2],!f){f=0;break w}i[f+4>>2]=i[f+4>>2]+1;break w}if(r=r+8|0,(f|0)==(r|0))break}f=0,n=0}if(r=p(88),A=r,i[A+4>>2]=0,i[A+8>>2]=0,i[A>>2]=97200,f&&(i[f+4>>2]=i[f+4>>2]+1),A=r+16|0,i[r+64>>2]=0,i[r+56>>2]=0,i[r+60>>2]=0,i[r+24>>2]=0,i[r+28>>2]=0,i[r+36>>2]=0,i[r+40>>2]=0,i[r+72>>2]=0,i[r+76>>2]=0,i[r+84>>2]=f,i[r+80>>2]=n,u[r+32|0]=0,i[r+44>>2]=0,i[r+48>>2]=0,i[r+16>>2]=98904,f)break o;break u}if((A|0)!=1836280681){if((A|0)!=1987470129)break s;r=i[f+104>>2],f=i[f+108>>2];w:{if((r|0)!=(f|0))for(;;){_:{if(A=i[r>>2],!A||(n=W0(A,86580,99876),!n))break _;if(f=i[r+4>>2],!f){f=0;break w}i[f+4>>2]=i[f+4>>2]+1;break w}if(r=r+8|0,(f|0)==(r|0))break}f=0,n=0}if(r=p(88),A=r,i[A+4>>2]=0,i[A+8>>2]=0,i[A>>2]=97240,f&&(i[f+4>>2]=i[f+4>>2]+1),A=r+16|0,i[r+64>>2]=0,i[r+56>>2]=0,i[r+60>>2]=0,i[r+24>>2]=0,i[r+28>>2]=0,i[r+36>>2]=0,i[r+40>>2]=0,i[r+72>>2]=0,i[r+76>>2]=0,i[r+84>>2]=f,i[r+80>>2]=n,u[r+32|0]=0,i[r+44>>2]=0,i[r+48>>2]=0,i[r+16>>2]=99680,!f)break l;break o}i[k+32>>2]=0,i[k+36>>2]=0;break t}i[k+32>>2]=0,i[k+36>>2]=0;break t}i[k+36>>2]=r,i[k+32>>2]=A;break t}if(i[f+4>>2]==-1&&(W[i[i[f>>2]+8>>2]](f),y(f)),i[k+36>>2]=r,i[k+32>>2]=A,A=i[f+4>>2],i[f+4>>2]=A-1,A)break t;W[i[i[f>>2]+8>>2]](f),y(f);break t}i[k+36>>2]=r,i[k+32>>2]=A}r=i[k+32>>2],A=i[k+36>>2],i[k+32>>2]=0,i[k+36>>2]=0,f=i[e+556>>2],i[e+552>>2]=r,i[e+556>>2]=A;t:{if(!f||(A=i[f+4>>2],i[f+4>>2]=A-1,A))break t;W[i[i[f>>2]+8>>2]](f),y(f)}r=i[k+36>>2];t:{if(!r||(A=i[r+4>>2],i[r+4>>2]=A-1,A))break t;W[i[i[r>>2]+8>>2]](r),y(r)}if(!i[e+552>>2]){if(A=p(56),i[k+32>>2]=A,i[k+36>>2]=49,i[k+40>>2]=-2147483592,r=l[23584]|l[23585]<<8|(l[23586]<<16|l[23587]<<24),e=l[23580]|l[23581]<<8|(l[23582]<<16|l[23583]<<24),u[A|0]=e,u[A+1|0]=e>>>8,u[A+2|0]=e>>>16,u[A+3|0]=e>>>24,u[A+4|0]=r,u[A+5|0]=r>>>8,u[A+6|0]=r>>>16,u[A+7|0]=r>>>24,u[A+49|0]=0,u[A+48|0]=l[23628],r=l[23624]|l[23625]<<8|(l[23626]<<16|l[23627]<<24),e=l[23620]|l[23621]<<8|(l[23622]<<16|l[23623]<<24),u[A+40|0]=e,u[A+41|0]=e>>>8,u[A+42|0]=e>>>16,u[A+43|0]=e>>>24,u[A+44|0]=r,u[A+45|0]=r>>>8,u[A+46|0]=r>>>16,u[A+47|0]=r>>>24,r=l[23616]|l[23617]<<8|(l[23618]<<16|l[23619]<<24),e=l[23612]|l[23613]<<8|(l[23614]<<16|l[23615]<<24),u[A+32|0]=e,u[A+33|0]=e>>>8,u[A+34|0]=e>>>16,u[A+35|0]=e>>>24,u[A+36|0]=r,u[A+37|0]=r>>>8,u[A+38|0]=r>>>16,u[A+39|0]=r>>>24,r=l[23608]|l[23609]<<8|(l[23610]<<16|l[23611]<<24),e=l[23604]|l[23605]<<8|(l[23606]<<16|l[23607]<<24),u[A+24|0]=e,u[A+25|0]=e>>>8,u[A+26|0]=e>>>16,u[A+27|0]=e>>>24,u[A+28|0]=r,u[A+29|0]=r>>>8,u[A+30|0]=r>>>16,u[A+31|0]=r>>>24,r=l[23600]|l[23601]<<8|(l[23602]<<16|l[23603]<<24),e=l[23596]|l[23597]<<8|(l[23598]<<16|l[23599]<<24),u[A+16|0]=e,u[A+17|0]=e>>>8,u[A+18|0]=e>>>16,u[A+19|0]=e>>>24,u[A+20|0]=r,u[A+21|0]=r>>>8,u[A+22|0]=r>>>16,u[A+23|0]=r>>>24,r=l[23592]|l[23593]<<8|(l[23594]<<16|l[23595]<<24),e=l[23588]|l[23589]<<8|(l[23590]<<16|l[23591]<<24),u[A+8|0]=e,u[A+9|0]=e>>>8,u[A+10|0]=e>>>16,u[A+11|0]=e>>>24,u[A+12|0]=r,u[A+13|0]=r>>>8,u[A+14|0]=r>>>16,u[A+15|0]=r>>>24,q(B,4,3e3,k+32|0),u[k+43|0]>=0)break n;Z(i[k+32>>2]);break n}t:{if(l[e+540|0]!=1)break t;t=k+124|0,n=i[e+116>>2],s=v-16|0,v=s,r=i[23884],m=i[23885],o=!(r|m),A=i[_+16>>2],e=((A+i[_+8>>2]|0)-1>>>0)/(A>>>0)|0,A=i[_+12>>2],A=O0(e,0,((A+i[_+4>>2]|0)-1>>>0)/(A>>>0)|0,0),e=l0,f=l[_+26|0];u:{if(!f||(A=O0(A,e,i[_+28>>2],0),e=l0,f=f-1|0,!f)||(A=O0(A,e,i[_+32>>2],0),e=l0,(f|0)==1)||(A=O0(A,e,i[_+36>>2],0),e=l0,(f|0)==2)||(A=O0(A,e,i[_+40>>2],0),e=l0,(f|0)==3)||(A=O0(A,e,i[_+44>>2],0),e=l0,(f|0)==4)||(A=O0(A,e,i[_+48>>2],0),e=l0,(f|0)==5)||(A=O0(A,e,i[_+52>>2],0),e=l0,(f|0)==6))break u;A=O0(A,e,i[_+56>>2],0),e=l0}u:{if(!(o|((e|0)==(m|0)&A>>>0<=r>>>0|e>>>0<m>>>0))){if(A=p(40),i[s+4>>2]=A,i[s+8>>2]=39,i[s+12>>2]=-2147483608,r=l[23463]|l[23464]<<8|(l[23465]<<16|l[23466]<<24),e=l[23459]|l[23460]<<8|(l[23461]<<16|l[23462]<<24),u[A|0]=e,u[A+1|0]=e>>>8,u[A+2|0]=e>>>16,u[A+3|0]=e>>>24,u[A+4|0]=r,u[A+5|0]=r>>>8,u[A+6|0]=r>>>16,u[A+7|0]=r>>>24,u[A+39|0]=0,r=l[23494]|l[23495]<<8|(l[23496]<<16|l[23497]<<24),e=l[23490]|l[23491]<<8|(l[23492]<<16|l[23493]<<24),u[A+31|0]=e,u[A+32|0]=e>>>8,u[A+33|0]=e>>>16,u[A+34|0]=e>>>24,u[A+35|0]=r,u[A+36|0]=r>>>8,u[A+37|0]=r>>>16,u[A+38|0]=r>>>24,r=l[23487]|l[23488]<<8|(l[23489]<<16|l[23490]<<24),e=l[23483]|l[23484]<<8|(l[23485]<<16|l[23486]<<24),u[A+24|0]=e,u[A+25|0]=e>>>8,u[A+26|0]=e>>>16,u[A+27|0]=e>>>24,u[A+28|0]=r,u[A+29|0]=r>>>8,u[A+30|0]=r>>>16,u[A+31|0]=r>>>24,r=l[23479]|l[23480]<<8|(l[23481]<<16|l[23482]<<24),e=l[23475]|l[23476]<<8|(l[23477]<<16|l[23478]<<24),u[A+16|0]=e,u[A+17|0]=e>>>8,u[A+18|0]=e>>>16,u[A+19|0]=e>>>24,u[A+20|0]=r,u[A+21|0]=r>>>8,u[A+22|0]=r>>>16,u[A+23|0]=r>>>24,r=l[23471]|l[23472]<<8|(l[23473]<<16|l[23474]<<24),e=l[23467]|l[23468]<<8|(l[23469]<<16|l[23470]<<24),u[A+8|0]=e,u[A+9|0]=e>>>8,u[A+10|0]=e>>>16,u[A+11|0]=e>>>24,u[A+12|0]=r,u[A+13|0]=r>>>8,u[A+14|0]=r>>>16,u[A+15|0]=r>>>24,q(B,2,1e3,s+4|0),u[s+15|0]>=0)break u;Z(i[s+4>>2]);break u}c7(B,_,t,n,0,A,e)}if(v=s+16|0,i[B>>2])break n;if(u[B+19|0]>=0)break t;Z(i[B+8>>2])}k8(B,107664)}if(!F||(A=i[F+4>>2],i[F+4>>2]=A-1,A))break k;W[i[i[F>>2]+8>>2]](F),y(F)}if(!V||(A=i[V+4>>2],i[V+4>>2]=A-1,A))break i;W[i[i[V>>2]+8>>2]](V),y(V);break i}_2(),H()}G0(),H()}G0(),H()}if(f=f+8|0,(f|0)==(r|0))break}if(e=p(48),i[k+56>>2]=e,i[k+60>>2]=40,i[k+64>>2]=-2147483600,f=l[22316]|l[22317]<<8|(l[22318]<<16|l[22319]<<24),r=l[22312]|l[22313]<<8|(l[22314]<<16|l[22315]<<24),u[e|0]=r,u[e+1|0]=r>>>8,u[e+2|0]=r>>>16,u[e+3|0]=r>>>24,u[e+4|0]=f,u[e+5|0]=f>>>8,u[e+6|0]=f>>>16,u[e+7|0]=f>>>24,u[e+40|0]=0,f=l[22348]|l[22349]<<8|(l[22350]<<16|l[22351]<<24),r=l[22344]|l[22345]<<8|(l[22346]<<16|l[22347]<<24),u[e+32|0]=r,u[e+33|0]=r>>>8,u[e+34|0]=r>>>16,u[e+35|0]=r>>>24,u[e+36|0]=f,u[e+37|0]=f>>>8,u[e+38|0]=f>>>16,u[e+39|0]=f>>>24,f=l[22340]|l[22341]<<8|(l[22342]<<16|l[22343]<<24),r=l[22336]|l[22337]<<8|(l[22338]<<16|l[22339]<<24),u[e+24|0]=r,u[e+25|0]=r>>>8,u[e+26|0]=r>>>16,u[e+27|0]=r>>>24,u[e+28|0]=f,u[e+29|0]=f>>>8,u[e+30|0]=f>>>16,u[e+31|0]=f>>>24,f=l[22332]|l[22333]<<8|(l[22334]<<16|l[22335]<<24),r=l[22328]|l[22329]<<8|(l[22330]<<16|l[22331]<<24),u[e+16|0]=r,u[e+17|0]=r>>>8,u[e+18|0]=r>>>16,u[e+19|0]=r>>>24,u[e+20|0]=f,u[e+21|0]=f>>>8,u[e+22|0]=f>>>16,u[e+23|0]=f>>>24,f=l[22324]|l[22325]<<8|(l[22326]<<16|l[22327]<<24),r=l[22320]|l[22321]<<8|(l[22322]<<16|l[22323]<<24),u[e+8|0]=r,u[e+9|0]=r>>>8,u[e+10|0]=r>>>16,u[e+11|0]=r>>>24,u[e+12|0]=f,u[e+13|0]=f>>>8,u[e+14|0]=f>>>16,u[e+15|0]=f>>>24,q(A,2,0,k+56|0),u[k+67|0]>=0)break i;Z(i[k+56>>2])}i:{if(!X||(A=i[X+4>>2],i[X+4>>2]=A-1,A))break i;W[i[i[X>>2]+8>>2]](X),y(X)}v=k+144|0}function y7(A,e){var r=0,f=0,k=0,n=0,t=0,o=0,s=0,w=0,h=0,_=0,B=0,m=0,X=0,Q=0,V=0,F=0,I=0,E=0,R=0,N=0,M=0,z=0,S=0,O=0,P=0,a=0,$=0,f0=0,A0=0,n0=0,_0=0,m0=0,X0=0,g0=0,I0=0,e0=0,r0=0,N0=0,U0=0,M0=0,H0=0,P0=0,K0=0,$0=0,L0=0,d0=0,n2=0;if(u[e|0]=0,r=i[A+3212>>2],f=i[A+3208>>2],(r|0)==(f|0))return 0;i:{e:{w=i[f>>2],k=i[w+428>>2],s=i[w+424>>2];r:{f:{if((k|0)==(s|0))break f;for(k=k-s>>2,t=k>>>0<=1?1:k;;){if(k=i[s+(h<<2)>>2],i[k+40>>2]){if(h=h+1|0,(t|0)!=(h|0))continue;break f}break}if(l[k+36|0]==1&&xl(A+2140|0),u[e|0]=1,f=k,k=i[f+4>>2],r=i[k+1352>>2],(r|0)!=i[k+1356>>2])for(s=A+2140|0;r=No(s,i[(n<<2)+r>>2]),(r|0)>=0&&(i[i[i[A+2148>>2]+(r<<2)>>2]+100>>2]=0),n=n+1|0,r=i[k+1352>>2],n>>>0<i[k+1356>>2]-r>>2>>>0;);o=i[w>>2],r=i[o+132>>2],i[f+40>>2]=1,k=l[r+46|0],s=l[r+45|0],r=i[o+112>>2],_=i[r+1884>>2];A:{if(k|(s|(_|0)<=0))break A;t=i[r+168>>2];k:{if((t|0)>0){for(h=r+88|0,n=0;;){if(i[h+(n<<2)>>2]==1e3)break A;if(n=n+1|0,(t|0)==(n|0))break}if((t|0)>19)break k}i[r+168>>2]=t+1,i[(r+(t<<2)|0)+88>>2]=1e3}if(t=i[r+84>>2],(t|0)==20){i[r+80>>2]=1001;break A}i[r+84>>2]=t+1,i[(r+4|0)+(t<<2)>>2]=1e3}r=i[w+424>>2],n=i[w+428>>2];A:{if((r|0)==(n|0)|(f|0)!=i[r>>2]||(t=i[i[f+4>>2]+24>>2],(t|0)<=0))break A;for(n=0;r=i[o+320>>2]+G(n,76)|0,i[r>>2]<=0&&(i[r>>2]=1),n=n+1|0,(t|0)!=(n|0););r=i[w+424>>2],n=i[w+428>>2]}o=n-r>>2;A:{if(o>>>0<2)break A;for(n=1;;){if(t=(n<<2)+r|0,(f|0)!=i[t>>2]){if(n=n+1|0,(o|0)!=(n|0))continue;break A}break}if(t=i[t-4>>2],!t|i[t+40>>2]!=2||(o=o-1|0,!o))break A;for(n=0;;){if(h=(n<<2)+r|0,(t|0)!=i[h>>2]){if(n=n+1|0,(o|0)!=(n|0))continue;break A}break}if(r=i[h+4>>2],!r||(n=i[i[t+4>>2]+24>>2],(n|0)>=i[i[r+4>>2]+24>>2]))break A;for(;;){if(t=i[w>>2],i[t+144>>2]<=(n|0))break A;if(t=i[t+320>>2]+G(n,76)|0,i[t>>2]<=0&&(i[t>>2]=1),n=n+1|0,!((n|0)<i[i[r+4>>2]+24>>2]))break}}n=0;A:{if(!(k|s&&(_|0)>0)){if(k=0,o=v-18608|0,v=o,s=i[f+4>>2],r=i[s+1352>>2],(r|0)!=i[s+1356>>2]){for(t=A+2140|0;r=No(t,i[(k<<2)+r>>2]),(r|0)>=0&&(i[i[i[A+2148>>2]+(r<<2)>>2]+100>>2]=0),k=k+1|0,r=i[s+1352>>2],k>>>0<i[s+1356>>2]-r>>2>>>0;);s=i[f+4>>2]}if(k=6,r=i[i[w>>2]+132>>2],u0[s+24>>2]<i[r+8452>>2]-i[r+8448>>2]>>2>>>0){h=o+18572|0,i[h>>2]=0,i[h+4>>2]=0,i[o+18516>>2]=0,r=o+18508|0,i[r>>2]=0,i[r+4>>2]=0,i[o+18500>>2]=0,i[o+18504>>2]=0,r=(o+38&-16)+16|0,i[o+2104>>2]=r,o0(r,0,2048),k=i[f+4>>2],i[o+18592>>2]=k,r=i[w>>2],i[o+18600>>2]=f,i[o+18596>>2]=w,i[o+18584>>2]=A,i[o+18588>>2]=r,r=i[i[i[r+132>>2]+8448>>2]+(i[k+24>>2]<<2)>>2],i[o+18604>>2]=0,i[o+4>>2]=r,ke(o),r=i[f+12>>2];k:{if((r|0)<=0){k=17;break k}Ye(o+18548|0,i[f+8>>2],r);n:{if(!l[i[i[w>>2]+132>>2]+45|0]|!l[i[f+4>>2]+12|0])break n;if(r=i[i[i[A+2216>>2]+124>>2]+16900>>2]-1|0,k=i[w+472>>2],t=i[w+468>>2],s=k-t>>3,r>>>0>s>>>0){En(w+468|0,r-s|0);break n}if(r>>>0>=s>>>0)break n;if(r=t+(r<<3)|0,(r|0)!=(k|0))for(;k=L8(k-8|0),(r|0)!=(k|0););i[w+472>>2]=r}i[f+120>>2]=1,k=0,s=0,r=i[o+18588>>2],_=i[r+132>>2],r=i[r+124>>2],t=i[r+16908>>2],B=i[o+4>>2],(t|0)>(B|0)&&(t=i[i[_+8460>>2]+(B<<2)>>2]),r=i[r+16892>>2],i[o>>2]=t,B=(t|0)/(r|0)|0,i[o+12>>2]=B,i[o+8>>2]=t-G(r,B),B=i[o+18592>>2],r=18;n:{t:{if(!af(o)||(Ze(o+18548|0),t=1,r=0,!(fr(o,0,!l[B+20|0])&1)))break n;B=o+18572|0;u:{if(l[_+46|0]){if(k=i[o+18592>>2],s=i[k+804>>2],s>>>0>2)break t;r=0;break u}r=1}for(;;){if(!r){ji(B,s,i[k+800>>2]),u[o+18580|0]=0,u[o+18581|0]=0,u[o+18582|0]=0,u[o+18583|0]=0,r=1;continue}for(;;){k=i[o+18592>>2],r=i[k+784>>2],s=i[k+788>>2]-r>>2,k=t-1|0;u:{if(s>>>0>k>>>0&&i[r+(k<<2)>>2]==((i[o+18552>>2]-i[o+18548>>2]|0)-2|0))break u;F2(i[o+18584>>2]+4|0,1003,1)}if(r=0,!(fr(o,0,0)&1))break n;if(t=t+1|0,!!l[_+46|0])break}if(k=i[o+18592>>2],s=i[k+804>>2],!(s>>>0<3))break}break t}D0(21669,18297,1520,5105),H()}k=r,i[f+44>>2]<=0&&(i[f+44>>2]=1)}L8(h)}if(v=o+18608|0,r=k,i[f+40>>2]=2,k=i[w+424>>2],s=(i[w+428>>2]-k>>2)-1|0,!s)break A;for(;;){if(t=k+(n<<2)|0,(f|0)!=i[t>>2]){if(n=n+1|0,(s|0)!=(n|0))continue;break A}break}if(k=i[t+4>>2],!k||(n=i[i[f+4>>2]+24>>2],(n|0)>=i[i[k+4>>2]+24>>2]))break A;for(;;){if(f=i[w>>2],i[f+144>>2]<=(n|0))break A;if(f=i[f+320>>2]+G(n,76)|0,i[f>>2]<=0&&(i[f>>2]=1),n=n+1|0,!((n|0)<i[i[k+4>>2]+24>>2]))break}break A}if(s&&(r=1006,k))break A;if(s){s=f;k:{if(t=i[w>>2],i[t+332>>2]==(0-i[t+328>>2]|0)){h=i[f+4>>2],_=i[h+776>>2],V=i[t+132>>2],r=i[t+124>>2],X=i[r+16892>>2];n:{if(!l[h+12|0])break n;if(r=i[r+16900>>2]-1|0,f=i[w+472>>2],o=i[w+468>>2],k=f-o>>3,r>>>0>k>>>0){En(w+468|0,r-k|0);break n}if(r>>>0>=k>>>0)break n;if(r=o+(r<<3)|0,(r|0)!=(f|0))for(;f=L8(f-8|0),(r|0)!=(f|0););i[w+472>>2]=r}if(i[s+132>>2])break e;k=_+1|0,o=p((L0=-1,d0=O0(k,0,18608,0)|4,n2=l0,n2?L0:d0)),i[o>>2]=k,r=o+4|0;n:{if(!k){i[s+136>>2]=k,i[s+132>>2]=r;break n}for(B=r+G(k,18608)|0,f=r;Q=f+18572|0,i[Q>>2]=0,i[Q+4>>2]=0,i[f+18516>>2]=0,Q=f+18508|0,i[Q>>2]=0,i[Q+4>>2]=0,i[f+18500>>2]=0,i[f+18504>>2]=0,i[f+18584>>2]=0,i[f+18588>>2]=0,Q=f+18592|0,i[Q>>2]=0,i[Q+4>>2]=0,i[f+18600>>2]=0,Q=(f+38&-15)+16|0,i[f+2104>>2]=Q,o0(Q,0,2048),f=f+18608|0,(B|0)!=(f|0););if(i[s+136>>2]=k,i[s+132>>2]=r,(_|0)<0)break n;if(f=i[h+24>>2],B=(f|0)/(X|0)|0,_){if(f-G(B,X)|0)break n;if((_|0)==2147483647)break i}if(i[o+18596>>2]=h,k=i[t+112>>2],i[o+18604>>2]=s,i[o+18600>>2]=w,i[o+18592>>2]=t,i[o+18588>>2]=k,i[o+8>>2]=i[i[V+8448>>2]+(f<<2)>>2],ke(r),Q=s+12|0,f=Q,_&&(f=i[h+784>>2]),f=i[f>>2],(f|0)>i[Q>>2]||(k=1,(f|0)<=0)||(Ye(o+18552|0,i[s+8>>2],f),i[t+324>>2]=i[t+324>>2]+1,i[t+340>>2]=i[t+340>>2]+1,i[s+120>>2]=i[s+120>>2]+1,pt(A,r,1,B),!_))break n;for(;;){if(i[s+136>>2]<=(k|0))break i;if(r=i[s+132>>2]+G(k,18608)|0,i[r+18592>>2]=h,f=i[t+112>>2],i[r+18600>>2]=s,i[r+18596>>2]=w,i[r+18588>>2]=t,i[r+18584>>2]=f,B=B+1|0,i[r+4>>2]=i[i[V+8448>>2]+(G(X,B)<<2)>>2],ke(r),o=k<<2,m=i[h+784>>2],f=i[(o+m|0)-4>>2],(f|0)<0||(R=o+m|0,m=(k|0)!=(_|0),o=i[(m?R:Q)>>2],(o|0)>i[Q>>2]|(f|0)>=(o|0)))break n;if(Ye(r+18548|0,f+i[s+8>>2]|0,o-f|0),i[t+324>>2]=i[t+324>>2]+1,i[t+340>>2]=i[t+340>>2]+1,i[s+120>>2]=i[s+120>>2]+1,pt(A,r,0,B),k=k+1|0,!m)break}}if(v3(t),r=i[w+460>>2],k=i[w+456>>2],(r|0)!=(k|0))for(f=0;t=i[(f<<2)+k>>2],t&&(W[i[i[t>>2]+4>>2]](t),k=i[w+456>>2],r=i[w+460>>2]),f=f+1|0,f>>>0<r-k>>2>>>0;);i[w+460>>2]=k;break k}D0(22152,18155,1003,19400),H()}if(i[s+40>>2]=2,r=0,f=i[w+424>>2],k=(i[w+428>>2]-f>>2)-1|0,!k)break A;for(;;){if(t=f+(n<<2)|0,(s|0)!=i[t>>2]){if(n=n+1|0,(k|0)!=(n|0))continue;break A}break}if(f=i[t+4>>2],!f||(n=i[i[s+4>>2]+24>>2],(n|0)>=i[i[f+4>>2]+24>>2]))break A;for(;;){if(k=i[w>>2],i[k+144>>2]<=(n|0))break A;if(k=i[k+320>>2]+G(n,76)|0,i[k>>2]<=0&&(i[k>>2]=1),n=n+1|0,!((n|0)<i[i[f+4>>2]+24>>2]))break}break A}k:{if(!k)break k;t=0;n:{if(o=i[w>>2],i[o+332>>2]==(0-i[o+328>>2]|0)){if(i[f+132>>2])break e;h=i[o+132>>2],X=i[i[o+124>>2]+16892>>2],Q=i[f+4>>2],B=i[Q+776>>2],k=B+1|0,_=p((L0=-1,d0=O0(k,0,18608,0)|4,n2=l0,n2?L0:d0)),i[_>>2]=k,r=_+4|0;t:{if(!k){i[f+136>>2]=k,i[f+132>>2]=r;break t}for(V=r+G(k,18608)|0,s=r;m=s+18572|0,i[m>>2]=0,i[m+4>>2]=0,i[s+18516>>2]=0,m=s+18508|0,i[m>>2]=0,i[m+4>>2]=0,i[s+18500>>2]=0,i[s+18504>>2]=0,i[s+18584>>2]=0,i[s+18588>>2]=0,m=s+18592|0,i[m>>2]=0,i[m+4>>2]=0,i[s+18600>>2]=0,m=(s+38&-15)+16|0,i[s+2104>>2]=m,o0(m,0,2048),s=s+18608|0,(V|0)!=(s|0););if(i[f+136>>2]=k,i[f+132>>2]=r,(B|0)<0)break t;if((B|0)==2147483647)break i;if(m=i[Q+24>>2],k=m<<2,s=i[k+i[h+8484>>2]>>2],i[_+18596>>2]=Q,V=i[o+112>>2],i[_+18604>>2]=f,i[_+18600>>2]=w,i[_+18592>>2]=o,i[_+18588>>2]=V,i[_+8>>2]=i[k+i[h+8448>>2]>>2],ke(r),V=f+12|0,k=V,B&&(k=i[Q+784>>2]),I=i[k>>2],(I|0)>i[V>>2]){t=17;break t}if(k=1,(I|0)<=0){t=17;break t}if(Ye(_+18552|0,i[f+8>>2],I),i[o+324>>2]=i[o+324>>2]+1,i[o+340>>2]=i[o+340>>2]+1,i[f+120>>2]=i[f+120>>2]+1,R=r,r=(m|0)/(X|0)|0,Ft(A,R,1,m-G(r,X)|0,r),!B)break t;for(I=h+8404|0,E=h+8360|0;;){if(s=s+1|0,r=i[h+48>>2],(s|0)>=(G(r,i[h+52>>2])|0)){t=1007;break t}if(i[f+136>>2]<=(k|0))break i;if(t=(s|0)/(r|0)|0,_=i[I+(t<<2)>>2],t=i[E+(s-G(r,t)<<2)>>2],r=i[f+132>>2]+G(k,18608)|0,i[r+18592>>2]=Q,m=i[o+112>>2],i[r+18600>>2]=f,i[r+18596>>2]=w,i[r+18588>>2]=o,i[r+18584>>2]=m,_=t+G(_,X)|0,i[r+4>>2]=i[i[h+8448>>2]+(_<<2)>>2],ke(r),m=k<<2,F=i[Q+784>>2],t=i[(m+F|0)-4>>2],(t|0)<0){t=17;break t}if(m=i[((k|0)!=(B|0)?m+F|0:V)>>2],(m|0)>i[V>>2]){t=17;break t}if((t|0)>=(m|0)){t=17;break t}if(Ye(r+18548|0,t+i[f+8>>2]|0,m-t|0),i[o+324>>2]=i[o+324>>2]+1,i[o+340>>2]=i[o+340>>2]+1,i[f+120>>2]=i[f+120>>2]+1,t=0,R=r,r=(_|0)/(X|0)|0,Ft(A,R,0,_-G(r,X)|0,r),r=(k|0)!=(B|0),k=k+1|0,!r)break}}if(v3(o),r=i[w+460>>2],k=i[w+456>>2],(r|0)!=(k|0))for(s=0;o=i[(s<<2)+k>>2],o&&(W[i[i[o>>2]+4>>2]](o),k=i[w+456>>2],r=i[w+460>>2]),s=s+1|0,s>>>0<r-k>>2>>>0;);i[w+460>>2]=k,r=t;break n}D0(22152,18155,1117,5457),H()}if(i[f+40>>2]=2,k=i[w+424>>2],s=(i[w+428>>2]-k>>2)-1|0,!s)break A;for(;;){if(t=k+(n<<2)|0,(f|0)!=i[t>>2]){if(n=n+1|0,(s|0)!=(n|0))continue;break A}break}if(k=i[t+4>>2],!k||(n=i[i[f+4>>2]+24>>2],(n|0)>=i[i[k+4>>2]+24>>2]))break A;for(;;){if(f=i[w>>2],i[f+144>>2]<=(n|0))break A;if(f=i[f+320>>2]+G(n,76)|0,i[f>>2]<=0&&(i[f>>2]=1),n=n+1|0,!((n|0)<i[i[k+4>>2]+24>>2]))break}break A}D0(12200,18155,985,10067),H()}if(r)break r;f=i[A+3208>>2],r=i[A+3212>>2]}f:{if(r-f>>>0>=5&&(s=i[f>>2],k=i[s+428>>2],i[i[k-4>>2]+40>>2]|(k|0)==i[s+424>>2]))break f;if((r|0)==(f|0))return 0;if(s=i[f>>2],f=i[s+428>>2],(f|0)!=i[s+424>>2]&&(r=0,!i[i[f-4>>2]+40>>2])||(r=0,i[A+580>>2]!=((i[A+556>>2]?-1:0)|0)))break r;if(l[A+548|0])break f;if(!(u[A+549|0]&1))break r}if(u[e|0]=1,e=i[s>>2],i[e+144>>2]>0)for(h=0;r=i[e+320>>2]+G(h,76)|0,i[r>>2]<=0&&(i[r>>2]=1),h=h+1|0,(h|0)<i[e+144>>2];);w=i[s>>2],e=i[w+112>>2],r=l[e+532|0];f:{if(i[i[i[A+2216>>2]+112>>2]+1884>>2]){if(f=1,!(r&1)){f=0,k=i[s>>2],e=i[k+112>>2],r=i[i[k+124>>2]+16900>>2]<<1,i[k+324>>2]=r+i[k+324>>2],i[k+340>>2]=r+i[k+340>>2];A:{if(i[i[k+124>>2]+16900>>2]<=0)break A;_=e+1392|0;k:{n:{for(;;){t=p(20),u[t+16|0]=1,i[t+12>>2]=f,i[t+8>>2]=k,i[t>>2]=60620,i[t+4>>2]=0,e=i[s+460>>2],o=i[s+464>>2];t:{if(e>>>0<o>>>0){i[e>>2]=t,e=e+4|0;break t}if(n=i[s+456>>2],e=e-n|0,B=e>>2,r=B+1|0,r>>>0>=1073741824)break n;if(o=o-n|0,h=o>>1,o=o>>>0>=2147483644?1073741823:r>>>0<h>>>0?h:r,o){if(o>>>0>=1073741824)break k;r=p(o<<2)}else r=0;if(h=r+e|0,i[h>>2]=t,B=h-(B<<2)|0,e&&x(B,n,e),i[s+464>>2]=r+(o<<2),e=h+4|0,i[s+460>>2]=e,i[s+456>>2]=B,!n)break t;Z(n)}if(i[s+460>>2]=e,Be(_,t),f=f+1|0,e=i[i[k+124>>2]+16900>>2],!((f|0)<(e|0)))break}if((e|0)<=0)break A;for(f=0;;){t=p(20),u[t+16|0]=0,i[t+12>>2]=f,i[t+8>>2]=k,i[t>>2]=60620,i[t+4>>2]=0,e=i[s+460>>2],o=i[s+464>>2];t:{if(e>>>0>=o>>>0){if(n=i[s+456>>2],e=e-n|0,B=e>>2,r=B+1|0,r>>>0>1073741823)break n;if(o=o-n|0,h=o>>1,o=o>>>0>=2147483644?1073741823:r>>>0<h>>>0?h:r,o){if(o>>>0>1073741823)break k;r=p(o<<2)}else r=0;if(h=r+e|0,i[h>>2]=t,B=h-(B<<2)|0,e&&x(B,n,e),i[s+464>>2]=r+(o<<2),e=h+4|0,i[s+460>>2]=e,i[s+456>>2]=B,!n)break t;Z(n);break t}i[e>>2]=t,e=e+4|0}if(i[s+460>>2]=e,Be(_,t),f=f+1|0,!((f|0)<i[i[k+124>>2]+16900>>2]))break}break A}G0(),H()}z0(),H()}f=3,e=i[w+112>>2]}if(!l[e+533|0])A:{k=f,_=v-16|0,v=_;k:{n:{n=i[s>>2],t=i[n+124>>2];t:{if(!l[t+8799|0])break t;if(o=i[n+20>>2],h=i[n+28>>2],B=i[n+24>>2],e=i[n+112>>2],i[_+8>>2]=t,r=i[n+128>>2],i[_+12>>2]=r,f=e,r&&(i[r+4>>2]=i[r+4>>2]+1,f=i[n+112>>2]),r=i[n+288>>2],X=i[n+280>>2],Q=i[n+284>>2],V=i[_+12>>2],i[_>>2]=i[_+8>>2],i[_+4>>2]=V,V=s+8|0,A9(V,B,h,o,_,0,f,X,Q,r,1)){F2(i[n+112>>2]+4|0,1024,0);break t}if(Q=i[t+16900>>2],r=Q,i[n+324>>2]=r+i[n+324>>2],i[n+340>>2]=r+i[n+340>>2],(r|0)>0)for(m=e+1392|0,t=0;;){o=p(28),i[o+20>>2]=V,i[o+16>>2]=n,i[o>>2]=62808,i[o+4>>2]=0,i[o+12>>2]=n,i[o+24>>2]=k,i[o+8>>2]=t,e=i[s+460>>2],f=i[s+464>>2];u:{if(e>>>0<f>>>0){i[e>>2]=o,f=e+4|0;break u}if(h=i[s+456>>2],e=e-h|0,X=e>>2,r=X+1|0,r>>>0>=1073741824)break n;if(f=f-h|0,B=f>>1,f=f>>>0>=2147483644?1073741823:r>>>0<B>>>0?B:r,f){if(f>>>0>=1073741824)break k;r=p(f<<2)}else r=0;if(B=r+e|0,i[B>>2]=o,X=B-(X<<2)|0,e&&x(X,h,e),i[s+464>>2]=r+(f<<2),f=B+4|0,i[s+460>>2]=f,i[s+456>>2]=X,!h)break u;Z(h)}if(i[s+460>>2]=f,Be(m,o),t=t+1|0,(Q|0)==(t|0))break}v3(n),e=i[n+4>>2],i[n+4>>2]=i[s+12>>2],i[s+12>>2]=e,e=i[n+64>>2],i[n+64>>2]=i[s+72>>2],i[s+72>>2]=e,e=i[n+292>>2],i[n+292>>2]=i[s+300>>2],i[s+300>>2]=e,e=i[n+8>>2],i[n+8>>2]=i[s+16>>2],i[s+16>>2]=e,e=i[n+68>>2],i[n+68>>2]=i[s+76>>2],i[s+76>>2]=e,e=i[n+296>>2],i[n+296>>2]=i[s+304>>2],i[s+304>>2]=e,e=i[n+12>>2],i[n+12>>2]=i[s+20>>2],i[s+20>>2]=e,e=i[n+72>>2],i[n+72>>2]=i[s+80>>2],i[s+80>>2]=e,e=i[n+300>>2],i[n+300>>2]=i[s+308>>2],i[s+308>>2]=e,e=i[n+40>>2],i[n+40>>2]=i[s+48>>2],i[s+48>>2]=e,e=i[n+44>>2],i[n+44>>2]=i[s+52>>2],i[s+52>>2]=e,e=i[n+304>>2],r=i[n+308>>2],f=i[s+316>>2],i[n+304>>2]=i[s+312>>2],i[n+308>>2]=f,i[s+312>>2]=e,i[s+316>>2]=r}v=_+16|0;break A}G0(),H()}z0(),H()}v3(w);break f}if(!(r&1)){f=0,r=0;A:{if(i[i[w+124>>2]+16900>>2]<=0)break A;for(;r=t9(w,f)|r,f=f+1|0,(f|0)<i[i[w+124>>2]+16900>>2];);if(!(r&1))break A;gf(w,1,0,i[w+276>>2],i[w+272>>2]),e=i[w+272>>2],r=i[w+276>>2];k:{if(i[i[w+124>>2]+16832>>2]>=9){vf(w,1,0,r,e);break k}mf(w,1,0,r,e)}f=i[w+124>>2];k:{if(!i[f+16848>>2])break k;if(e=i[w+272>>2],r=i[w+276>>2],i[f+16840>>2]>=9){Wf(w,1,0,r,e);break k}Qf(w,1,0,r,e)}gf(w,0,0,i[w+276>>2],i[w+272>>2]),e=i[w+272>>2],r=i[w+276>>2];k:{if(i[i[w+124>>2]+16832>>2]>=9){vf(w,0,0,r,e);break k}mf(w,0,0,r,e)}if(f=i[w+124>>2],!i[f+16848>>2])break A;if(e=i[w+272>>2],r=i[w+276>>2],i[f+16840>>2]>=9){Wf(w,0,0,r,e);break A}Qf(w,0,0,r,e)}e=i[w+112>>2]}if(l[e+533|0])break f;if(e=i[w+124>>2],l[e+8799|0]){for(r=G(G(i[w+28>>2],i[w+40>>2]),(i[e+16832>>2]+7|0)/8|0),f=G(G(i[w+36>>2],i[w+44>>2]),(i[e+16840>>2]+7|0)/8|0),k=p((r|0)>(f|0)?r:f),Q=i[e+16848>>2]?3:1,V=w+4|0,f=i[e+16900>>2],n=0;;){_=V+(n<<2)|0,m=w+(n?44:40)|0,o=i[m>>2],r=G(G(o,i[w+(n?36:28)>>2]),(i[i[w+124>>2]+(n?16840:16832)>>2]+7|0)/8|0),r&&x(k,i[_>>2],r);A:{k:{if((f|0)<=0||(r=0,t=i[e+16892>>2],(t|0)<=0))break k;for(;;){n:{if((t|0)<=0)break n;if(f=0,!n)for(;;){if(h=C[((i[w+140>>2]+G(f,24)|0)+G(G(i[w+152>>2],r),24)|0)+2>>1],t=i[w+52>>2],h>>>0>=i[w+56>>2]-t>>2>>>0||(t=i[t+(h<<2)>>2],!t))break A;t:{if(!l[t+333|0])break t;if(t=1<<i[e+16876>>2],h=i[w+40>>2],B=i[w+4>>2],i[i[w+124>>2]+16832>>2]<=8){Ki(w,f,r,0,t,t,k,o,B,h);break t}Li(w,f,r,0,t,t,k,o,B,h)}if(f=f+1|0,t=i[e+16892>>2],!((f|0)<(t|0)))break n}for(;;){if(h=C[((i[w+140>>2]+G(f,24)|0)+G(G(i[w+152>>2],r),24)|0)+2>>1],t=i[w+52>>2],h>>>0>=i[w+56>>2]-t>>2>>>0||(t=i[t+(h<<2)>>2],!t))break A;t:{if(!l[t+334|0])break t;if(h=1<<i[e+16876>>2],t=(h|0)/i[e+16856>>2]|0,h=(h|0)/i[e+16852>>2]|0,B=i[m>>2],X=i[_>>2],i[i[w+124>>2]+16840>>2]>=9){Li(w,f,r,n,h,t,k,o,X,B);break t}Ki(w,f,r,n,h,t,k,o,X,B)}if(f=f+1|0,t=i[e+16892>>2],!((f|0)<(t|0)))break}}if(r=r+1|0,f=i[e+16900>>2],!((r|0)<(f|0)))break}}if(n=n+1|0,(Q|0)!=(n|0))continue}break}Z(k)}}r=i[s+436>>2];f:{if((r|0)==i[s+440>>2]){r=0;break f}for(h=0;;){e=0,t=0,n=v-176|0,v=n,o=G(h,80)+r|0,B=i[s>>2];A:{if(i[o>>2]!=132|l[i[B+112>>2]+512|0]!=1|!l[B+104|0])break A;for(S=o+27|0,O=o+26|0,P=o+25|0,a=o+24|0,$=o+23|0,f0=o+22|0,A0=o+21|0,n0=o+20|0,_0=o+19|0,m0=o+18|0,X0=o+17|0,g0=o+16|0,I0=o+15|0,e0=o+14|0,r0=o+13|0,N0=o+12|0,U0=o+60|0,M0=o+68|0,H0=B+4|0,P0=i[i[B+124>>2]+476>>2];;){Q=i[B+(t?44:40)>>2],_=i[B+(t?36:28)>>2],w=i[B+(t?32:24)>>2],I=t<<2,V=i[I+H0>>2];k:{n:switch(i[o+8>>2]){case 0:r=i[i[B+124>>2]+(t?16840:16832)>>2],i[n+40>>2]=-1732584194,i[n+44>>2]=271733878,i[n+32>>2]=1732584193,i[n+36>>2]=-271733879,i[n+24>>2]=0,i[n+28>>2]=0;t:{if((_|0)>0){if((r|0)>=9){r=w<<1;u:{if((w|0)<=0){for(f=0;f||(f=p(r)),HA(n+24|0,f,r),e=e+1|0,(_|0)!=(e|0););break u}for(E=w&2147483646,F=w&1,X=0,f=0;;){if(f||(f=p(r)),m=V+(G(X,Q)<<1)|0,e=0,k=0,(w|0)!=1)for(;I=e<<1,N=I+f|0,M=m+I|0,u[N|0]=l[M|0],u[N+1|0]=l[M+1|0],I=I|2,N=I+f|0,I=m+I|0,u[N|0]=l[I|0],u[N+1|0]=l[I+1|0],e=e+2|0,k=k+2|0,(E|0)!=(k|0););if(F&&(e=e<<1,k=e+f|0,e=e+m|0,u[k|0]=l[e|0],u[k+1|0]=l[e+1|0]),HA(n+24|0,f,r),X=X+1|0,(_|0)==(X|0))break}}ht(n,n+24|0),Z(f);break t}for(;HA(n+24|0,V+G(e,Q)|0,w),e=e+1|0,(_|0)!=(e|0););}ht(n,n+24|0)}e=t<<4;t:{if(l[n|0]!=l[e+N0|0]|l[n+1|0]!=l[e+r0|0]|(l[n+2|0]!=l[e+e0|0]|l[n+3|0]!=l[e+I0|0])||l[n+4|0]!=l[e+g0|0]|l[n+5|0]!=l[e+X0|0]|(l[n+6|0]!=l[e+m0|0]|l[n+7|0]!=l[e+_0|0])||l[n+8|0]!=l[e+n0|0]|l[n+9|0]!=l[e+A0|0]|(l[n+10|0]!=l[e+f0|0]|l[n+11|0]!=l[e+$|0])||l[n+12|0]!=l[e+a|0]|l[n+13|0]!=l[e+P|0]|l[n+14|0]!=l[e+O|0])break t;if(l[n+15|0]==l[e+S|0])break k}e=5;break A;case 1:e=7439;t:{if((_|0)<=0)break t;if(i[i[B+124>>2]+(t?16840:16832)>>2]>=9){if(X=w<<1,(w|0)<=0){for(e=0,r=0;r||(r=p(X)),e=e+1|0,(_|0)!=(e|0););e=7439,Z(r);break t}for(N=w&2147483646,M=w&1,I=(X|0)<=1?1:X,K0=I&2147483646,$0=I&1,m=0,f=0;;){if(f||(f=p(X)),k=V+(G(m,Q)<<1)|0,r=0,E=0,(w|0)!=1)for(;F=r<<1,R=F+f|0,z=k+F|0,u[R|0]=l[z|0],u[R+1|0]=l[z+1|0],F=F|2,R=F+f|0,F=k+F|0,u[R|0]=l[F|0],u[R+1|0]=l[F+1|0],r=r+2|0,E=E+2|0,(N|0)!=(E|0););if(M&&(r=r<<1,E=r+f|0,r=r+k|0,u[E|0]=l[r|0],u[E+1|0]=l[r+1|0]),r=0,(I|0)!=1)for(E=f+1|0,k=0;R=e<<8,e=l[r+f|0]^(e&65280)>>>8,e=e>>>4^e,F=(R|e)^e<<5,e=l[r+E|0]^((F^e<<12)&65280)>>>8,e=e>>>4^e,e=(F<<8|e)^e<<5^e<<12,r=r+2|0,k=k+2|0,(K0|0)!=(k|0););if($0&&(k=e<<8,e=l[r+f|0]^(e&65280)>>>8,e=e>>>4^e,e=(k|e)^e<<5^e<<12),m=m+1|0,(_|0)==(m|0))break}Z(f);break t}if((w|0)<=0)break t;for(m=w&2147483646,I=w&1,X=0;;){f=V+G(X,Q)|0;u:{if((w|0)==1){r=0;break u}for(E=f+1|0,r=0,k=0;R=e<<8,e=l[r+f|0]^(e&65280)>>>8,e=e>>>4^e,F=(R|e)^e<<5,e=l[r+E|0]^((F^e<<12)&65280)>>>8,e=e>>>4^e,e=(F<<8|e)^e<<5^e<<12,r=r+2|0,k=k+2|0,(m|0)!=(k|0););}if(I&&(k=e<<8,e=l[r+f|0]^(e&65280)>>>8,e=e>>>4^e,e=(k|e)^e<<5^e<<12),X=X+1|0,(_|0)==(X|0))break}}if(C[(t<<1)+U0>>1]==(e&65535))break k;e=5;break A;case 2:break n;default:break k}e=(w|0)>0&(_|0)>0;n:{if(i[i[B+124>>2]+(t?16840:16832)>>2]>=9){if(!e){r=0;break n}for(E=w&2147483646,F=w&1,r=0,f=0;;){if(X=V+G(f,Q)|0,e=0,k=0,(w|0)!=1)for(;N=(e^f)>>>8^f,M=e|1,m=(N^M)&255,R=r,r=(e^N)&255,r=(m+((R+r|0)+(r^l[e+X|0])|0)|0)+(m^l[X+M|0])|0,e=e+2|0,k=k+2|0,(E|0)!=(k|0););if(F&&(k=r,r=((e^f)>>>8^f^e)&255,r=(k+r|0)+(r^l[e+X|0])|0),f=f+1|0,(_|0)==(f|0))break}break n}if(!e){r=0;break n}for(m=w&2147483646,E=w&1,r=0,f=0;;){if(X=V+G(f,Q)|0,e=0,k=0,(w|0)!=1)for(;F=(e^f)>>>8^f,N=e|1,r=((F^N)&255^l[X+N|0])+((l[e+X|0]^(e^F)&255)+r|0)|0,e=e+2|0,k=k+2|0,(m|0)!=(k|0););if(E&&(r=(l[e+X|0]^((e^f)>>>8^f^e)&255)+r|0),f=f+1|0,(_|0)==(f|0))break}}if(i[I+M0>>2]==(r|0))break k;e=5;break A}if(e=0,!P0)break A;if(r=t>>>0<2,t=t+1|0,!r)break}}if(v=n+176|0,r=e,r)break f;if(h=h+1|0,r=i[s+436>>2],!(h>>>0<(i[s+440>>2]-r|0)/80>>>0))break}r=0}if(t=i[s>>2],t){if(!(l[t+104|0]!=1|(u[A+514|0]&1?l[t+312|0]:0)))f:{if(k=A+2140|0,e=i[k+24>>2],w=i[k+28>>2],e>>>0<w>>>0){i[e>>2]=t,i[k+24>>2]=e+4;break f}A:{if(n=i[k+20>>2],e=e-n|0,_=e>>2,f=_+1|0,f>>>0<1073741824){if(w=w-n|0,o=w>>1,w=w>>>0>=2147483644?1073741823:f>>>0<o>>>0?o:f,w){if(w>>>0>=1073741824)break A;f=p(w<<2)}else f=0;o=f+e|0,i[o>>2]=t,_=o-(_<<2)|0,e&&x(_,n,e),i[k+28>>2]=f+(w<<2),e=o+4|0,i[k+24>>2]=e,i[k+20>>2]=_,n&&Z(n),i[k+24>>2]=e;break f}G0(),H()}z0(),H()}e=i[t+116>>2],e?e=i[(e+G(i[e+8>>2],12)|0)+480>>2]:e=0,(e|0)<i[A+2164>>2]-i[A+2160>>2]>>2&&Kn(A+2140|0)}Z(Tn(s)),f=i[A+3212>>2],e=i[A+3208>>2],k=f-e|0;f:{if(k>>>0<5||(k=k-4|0,!k))break f;x(e,e+4|0,k)}i[A+3212>>2]=f-4}return r}D0(19456,18155,172,4396),H()}D0(4421,10882,174,3115),H()}function r6(A,e,r,f,k,n,t,o,s){var w=0,h=0,_=0,B=0,m=0,X=0,Q=0,V=0,F=0,I=0,E=0,R=0,N=0,M=0,z=0,S=0,O=0,P=0,a=0,$=0,f0=0,A0=0;h=v-160|0,v=h,N=bo(),Ao(N,o),_=i[e>>2],w=i[_+112>>2],o=i[_+108>>2];i:{e:{if(!u1(_,6)||(o8(i[e>>2],6)|0)==(o|0)&&(l8(i[e>>2],6)|0)==(w|0))break e;e=i[26922],i[A>>2]=i[26921],i[A+4>>2]=e,r=A+8|0;r:{if(u[107703]>=0){e=i[26924],i[r>>2]=i[26923],i[r+4>>2]=e,i[r+8>>2]=i[26925];break r}T(r,i[26923],i[26924])}u[A+20|0]=1;break i}if(!(f-4>>>0>4294967292|r)){e=i[26922],i[A>>2]=i[26921],i[A+4>>2]=e,r=A+8|0;e:{if(u[107703]>=0){e=i[26924],i[r>>2]=i[26923],i[r+4>>2]=e,i[r+8>>2]=i[26925];break e}T(r,i[26923],i[26924])}u[A+20|0]=1;break i}if(u[h+158|0]=1,g[h+156>>1]=2,i[h+148>>2]=8,i[h+152>>2]=131074,o=i[e>>2],i[h+136>>2]=i[o+116>>2],i[h+140>>2]=i[o+120>>2],u1(o,6)?o=1:(o=i[i[e>>2]+120>>2],o=43008>>>o&o>>>0<16),u[h+144|0]=o,S4(i[e>>2])&&(w=i[e>>2],o=C[w+6>>1]|C[w+8>>1]<<16,w=C[w+10>>1]|C[w+12>>1]<<16,u[h+158|0]=w>>>16,g[h+156>>1]=w,i[h+152>>2]=o),Tl(h+152|0),o=i[e>>2],E=h+124|0,w=E,i[w+4>>2]=0,i[w+8>>2]=0,I=w+4|0,i[w>>2]=I,w=i[o+124>>2],F=o+128|0,(w|0)!=(F|0))for(;;){V=i[w+16>>2],X=I,o=X,_=i[o>>2];e:{r:{if(!_)break r;for(;;){if(o=_,_=i[o+16>>2],(_|0)>(V|0)){if(X=o,_=i[o>>2],_)continue;break r}if((_|0)>=(V|0))break e;if(_=i[o+4>>2],!_)break}X=o+4|0}_=p(20),i[_+8>>2]=o,i[_>>2]=0,i[_+4>>2]=0,i[_+16>>2]=V,i[X>>2]=_,o=i[i[E>>2]>>2],o&&(i[E>>2]=o),m1(i[E+4>>2],_),i[E+8>>2]=i[E+8>>2]+1}_=i[w+4>>2];e:{if(_){for(;;)if(o=_,_=i[o>>2],!_)break e}for(;o=i[w+8>>2],_=i[o>>2]!=(w|0),w=o,!!_;);}if(w=o,(F|0)==(o|0))break}f0=h,A0=j0(i[e>>2],i[i[h+124>>2]+16>>2]),i[f0+148>>2]=A0,o=i[h+156>>2],i[h+112>>2]=i[h+152>>2],i[h+116>>2]=o,o=i[h+148>>2],i[h+104>>2]=i[h+144>>2],i[h+108>>2]=o,o=i[h+140>>2],i[h+96>>2]=i[h+136>>2],i[h+100>>2]=o,i[h+100>>2]=f,i[h+96>>2]=r,r=l[k+3|0]|l[k+4|0]<<8|(l[k+5|0]<<16|l[k+6|0]<<24),u[h+115|0]=r,u[h+116|0]=r>>>8,u[h+117|0]=r>>>16,u[h+118|0]=r>>>24,i[h+112>>2]=C[k>>1]|C[k+2>>1]<<16,C[h+116>>1]==2&&(g[h+116>>1]=C[h+156>>1]),C[h+112>>1]==2&&(g[h+112>>1]=C[h+152>>1]),C[h+114>>1]==2&&(g[h+114>>1]=C[h+154>>1]),r=1;e:{r:switch(f|0){case 10:case 12:case 14:r=3;break e;case 11:case 13:case 15:r=4;break e;case 0:case 1:case 2:case 3:case 99:break e;default:break r}r=0}e:{if((r|0)>=2){u[h+104|0]=43008>>>f&f>>>0<16;break e}if(i[N+4>>2]){u[h+104|0]=0;break e}u[h+104|0]=l[h+144|0]}if(n&&(i[h+108>>2]=n),(f&-2)!=10?r=i[h+108>>2]<9:(i[h+108>>2]=8,r=1),!r|(f&-4)!=12||(i[h+108>>2]=10),i[h+52>>2]=0,i[h+44>>2]=0,i[h+48>>2]=0,m=h+136|0,Q=h+96|0,B=v+-64|0,v=B,f=i[h+48>>2],k=i[h+44>>2],(f|0)!=(k|0))for(;;){n=i[f-52>>2];e:{if(!n||(r=i[n+4>>2],i[n+4>>2]=r-1,r))break e;W[i[i[n>>2]+8>>2]](n),y(n)}if(f=f-56|0,(k|0)==(f|0))break}i[h+48>>2]=k,r=i[t+12>>2],i[h+64>>2]=i[t+8>>2],i[h+68>>2]=r,r=i[t+4>>2],i[h+56>>2]=i[t>>2],i[h+60>>2]=r,r=i[N+20>>2],i[h+88>>2]=i[N+16>>2],i[h+92>>2]=r,r=i[N+12>>2],i[h+80>>2]=i[N+8>>2],i[h+84>>2]=r,r=i[N+4>>2],i[h+72>>2]=i[N>>2],i[h+76>>2]=r,r=i[m>>2];e:{if(!((r|0)!=i[Q>>2]|i[m+4>>2]!=i[Q+4>>2]|(l[m+8|0]!=l[Q+8|0]|i[m+12>>2]!=i[Q+12>>2]))&&(w=1,r||G3(m+16|0,Q+16|0)))break e;_f(),i[B+60>>2]=0,i[B+52>>2]=0,i[B+56>>2]=0,i[B+48>>2]=0,i[B+40>>2]=0,i[B+44>>2]=0,i[B>>2]=-1,i[B+24>>2]=0,i[B+36>>2]=0;r:{f:{A:{w=i[B+44>>2],r=i[B+48>>2];k:{if(w>>>0<r>>>0){o=i[B+36>>2],r=i[B>>2],i[w+4>>2]=0,i[w+8>>2]=0,i[w>>2]=r,u[w+34|0]=1,g[w+32>>1]=2,i[w+24>>2]=8,i[w+28>>2]=131074,u[w+20|0]=0,i[w+12>>2]=99,i[w+16>>2]=99,r=i[m+12>>2],i[w+20>>2]=i[m+8>>2],i[w+24>>2]=r,n=i[m+16>>2],k=i[m+20>>2],f=i[m>>2],r=i[m+4>>2],i[w+36>>2]=o,i[w+28>>2]=n,i[w+32>>2]=k,i[w+12>>2]=f,i[w+16>>2]=r,r=w+40|0;break k}if(f=w,w=i[B+40>>2],o=f-w|0,k=((o|0)/40|0)+1|0,k>>>0>=107374183)break A;if(f=(r-w|0)/40|0,r=f<<1,n=f>>>0>=53687091?107374182:r>>>0>k>>>0?r:k,n){if(n>>>0>=107374183)break f;r=p(G(n,40))}else r=0;if(k=i[B+36>>2],f=i[B>>2],_=r+o|0,i[_+4>>2]=0,i[_+8>>2]=0,i[_>>2]=f,f=i[m+4>>2],i[_+12>>2]=i[m>>2],i[_+16>>2]=f,f=i[m+12>>2],i[_+20>>2]=i[m+8>>2],i[_+24>>2]=f,f=i[m+20>>2],i[_+28>>2]=i[m+16>>2],i[_+32>>2]=f,i[_+36>>2]=k,f=_+G((o|0)/-40|0,40)|0,o&&x(f,w,o),i[B+48>>2]=r+G(n,40),r=_+40|0,i[B+44>>2]=r,i[B+40>>2]=f,!w)break k;Z(w)}i[B+44>>2]=r;break r}G0(),H()}z0(),H()}f=i[B+44>>2],k=i[B+40>>2],w=0;r:{if((f|0)==(k|0))break r;for(a=Q+16|0;;){f=f-k|0;f:{if((f|0)<=0){X=-1;break f}r=(f>>>0)/40|0,r=r>>>0<=1?1:r,z=r&3,w=0;A:{if(f>>>0<160){r=2147483647,X=-1,f=0;break A}for(V=r&67108860,f=0,r=2147483647,X=-1,R=0;o=i[(G(f,40)+k|0)+36>>2],O=(o|0)<(r|0),F=f|1,n=i[(G(F,40)+k|0)+36>>2],r=O?o:r,P=(n|0)<(r|0),I=f|2,_=i[(G(I,40)+k|0)+36>>2],r=P?n:r,E=(_|0)<(r|0),o=f|3,n=i[(G(o,40)+k|0)+36>>2],r=E?_:r,_=(n|0)<(r|0),r=_?n:r,X=_?o:E?I:P?F:O?f:X,f=f+4|0,R=R+4|0,(V|0)!=(R|0););}if(!z)break f;for(;n=i[(G(f,40)+k|0)+36>>2],o=(n|0)<(r|0),r=o?n:r,X=o?f:X,f=f+1|0,w=w+1|0,(z|0)!=(w|0););}o=G(X,40),_=o+k|0;f:{if(f=i[B+56>>2],r=i[B+60>>2],f>>>0<r>>>0){i[f>>2]=i[_>>2],i[f+4>>2]=i[_+4>>2],r=i[_+8>>2],i[f+8>>2]=r,r&&(i[r+4>>2]=i[r+4>>2]+1),r=i[_+16>>2],i[f+12>>2]=i[_+12>>2],i[f+16>>2]=r,i[f+36>>2]=i[_+36>>2],r=i[_+32>>2],i[f+28>>2]=i[_+28>>2],i[f+32>>2]=r,r=i[_+24>>2],i[f+20>>2]=i[_+20>>2],i[f+24>>2]=r,i[B+56>>2]=f+40;break f}A:{if(k=i[B+52>>2],w=f-k|0,n=((w|0)/40|0)+1|0,n>>>0<107374183){if(f=(r-k|0)/40|0,r=f<<1,r=f>>>0>=53687091?107374182:r>>>0>n>>>0?r:n,r>>>0>=107374183)break A;n=G(r,40),f=p(n),X=f+w|0,i[X>>2]=i[_>>2],i[X+4>>2]=i[_+4>>2],r=i[_+8>>2],i[X+8>>2]=r,r&&(i[r+4>>2]=i[r+4>>2]+1,k=i[B+52>>2],w=i[B+56>>2]-k|0),r=i[_+16>>2],i[X+12>>2]=i[_+12>>2],i[X+16>>2]=r,i[X+36>>2]=i[_+36>>2],r=i[_+32>>2],i[X+28>>2]=i[_+28>>2],i[X+32>>2]=r,r=i[_+24>>2],i[X+20>>2]=i[_+20>>2],i[X+24>>2]=r,_=X+G((w|0)/-40|0,40)|0,w&&x(_,k,w),i[B+60>>2]=f+n,r=X+40|0,i[B+56>>2]=r,i[B+52>>2]=_,k&&Z(k),i[B+56>>2]=r;break f}G0(),H()}z0(),H()}o=o+i[B+40>>2]|0,k=i[B+44>>2],i[o>>2]=i[k-40>>2],r=i[k-36>>2],f=i[k-32>>2],f&&(i[f+4>>2]=i[f+4>>2]+1),i[o+4>>2]=r,n=i[o+8>>2],i[o+8>>2]=f;f:{if(!n||(r=i[n+4>>2],i[n+4>>2]=r-1,r))break f;W[i[i[n>>2]+8>>2]](n),y(n)}f=k-28|0,r=i[f+4>>2],i[o+12>>2]=i[f>>2],i[o+16>>2]=r,i[o+36>>2]=i[f+24>>2],r=i[f+20>>2],i[o+28>>2]=i[f+16>>2],i[o+32>>2]=r,r=i[f+12>>2],i[o+20>>2]=i[f+8>>2],i[o+24>>2]=r,f=i[B+44>>2],k=i[f-32>>2];f:{if(!k||(r=i[k+4>>2],i[k+4>>2]=r-1,r))break f;W[i[i[k>>2]+8>>2]](k),y(k)}i[B+44>>2]=f-40;f:{if(r=i[B+56>>2],f=i[r-28>>2],(f|0)!=i[Q>>2]|i[r-24>>2]!=i[Q+4>>2]|(l[r-20|0]!=l[Q+8|0]|i[r-16>>2]!=i[Q+12>>2]))break f;if(!f){if(!G3(r-12|0,a))break f;r=i[B+56>>2]}k=i[B+52>>2],r=((r-k|0)/40|0)-1|0;A:{k:{if(r){for(f=0;n=f,f=f+1|0,r=i[k+G(r,40)>>2],!!r;);if(t=i[h+48>>2],r=t,w=i[h+44>>2],k=(r-w|0)/56|0,n>>>0<k>>>0)break k;n:{if(w=f-k|0,n=i[h+52>>2],w>>>0<=(n-r|0)/56>>>0){if(w){for(r=G(w,56)+r|0;i[t+48>>2]=0,i[t+52>>2]=0,i[t+40>>2]=0,i[t+44>>2]=0,i[t+24>>2]=0,i[t+28>>2]=0,i[t+16>>2]=0,i[t+20>>2]=0,i[t>>2]=0,i[t+4>>2]=0,i[t+32>>2]=99,i[t+36>>2]=99,i[t+8>>2]=99,i[t+12>>2]=99,u[t+54|0]=1,g[t+52>>1]=2,g[t+48>>1]=2,g[t+50>>1]=2,i[t+44>>2]=8,u[t+30|0]=1,g[t+28>>1]=2,g[t+24>>1]=2,g[t+26>>1]=2,i[t+20>>2]=8,t=t+56|0,(r|0)!=(t|0););t=r}i[h+48>>2]=t;break n}t:{if(k=i[h+44>>2],r=t-k|0,o=w+((r|0)/56|0)|0,o>>>0<76695845){if(n=(n-k|0)/56|0,k=n<<1,_=n>>>0>=38347922?76695844:k>>>0>o>>>0?k:o,_){if(_>>>0>=76695845)break t;k=p(G(_,56))}else k=0;for(n=k+r|0,o=n+G(w,56)|0,r=n;i[r+48>>2]=0,i[r+52>>2]=0,i[r+40>>2]=0,i[r+44>>2]=0,i[r+24>>2]=0,i[r+28>>2]=0,i[r+16>>2]=0,i[r+20>>2]=0,i[r>>2]=0,i[r+4>>2]=0,i[r+32>>2]=99,i[r+36>>2]=99,i[r+8>>2]=99,i[r+12>>2]=99,u[r+54|0]=1,g[r+52>>1]=2,g[r+48>>1]=2,g[r+50>>1]=2,i[r+44>>2]=8,u[r+30|0]=1,g[r+28>>1]=2,g[r+24>>1]=2,g[r+26>>1]=2,i[r+20>>2]=8,r=r+56|0,(o|0)!=(r|0););w=i[h+44>>2],t=t-w|0,r=n+G((t|0)/-56|0,56)|0,t&&x(r,w,t),i[h+52>>2]=k+G(_,56),i[h+48>>2]=o,i[h+44>>2]=r,w&&Z(w);break n}G0(),H()}z0(),H()}break A}r=i[h+48>>2],w=i[h+44>>2],k=(r-w|0)/56|0,f=0}if(f>>>0>=k>>>0)break A;if(n=G(f,56)+w|0,(n|0)!=(r|0))for(;;){t=i[r-52>>2];k:{if(!t||(k=i[t+4>>2],i[t+4>>2]=k-1,k))break k;W[i[i[t>>2]+8>>2]](t),y(t)}if(r=r-56|0,(n|0)==(r|0))break}i[h+48>>2]=n}if(r=i[h+44>>2],k=i[B+52>>2],t=((i[B+56>>2]-k|0)/40|0)-1|0,t){n=f-1|0,o=G(n,56)+r|0,k=k+G(t,40)|0,r=i[k+4>>2],k=i[k+8>>2],k&&(i[k+4>>2]=i[k+4>>2]+1),i[o>>2]=r,w=i[o+4>>2],i[o+4>>2]=k;A:{if(!w||(r=i[w+4>>2],i[w+4>>2]=r-1,r))break A;W[i[i[w>>2]+8>>2]](w),y(w)}if(k=i[h+44>>2]+G(n,56)|0,_=i[B+52>>2],n=_+G(t,40)|0,r=i[n+16>>2],i[k+32>>2]=i[n+12>>2],i[k+36>>2]=r,r=i[n+32>>2],i[k+48>>2]=i[n+28>>2],i[k+52>>2]=r,r=i[n+24>>2],i[k+40>>2]=i[n+20>>2],i[k+44>>2]=r,X=i[n>>2],X)for(r=1;;){o=G((r^-1)+f|0,56),w=o+i[h+44>>2]|0,t=G(X,40),n=t+_|0,k=i[n+4>>2],n=i[n+8>>2],n&&(i[n+4>>2]=i[n+4>>2]+1),i[w>>2]=k,_=i[w+4>>2],i[w+4>>2]=n;A:{if(!_||(k=i[_+4>>2],i[_+4>>2]=k-1,k))break A;W[i[i[_>>2]+8>>2]](_),y(_)}if(_=i[B+52>>2],w=t+_|0,k=i[w+16>>2],n=o+i[h+44>>2]|0,i[n+32>>2]=i[w+12>>2],i[n+36>>2]=k,k=i[w+32>>2],i[n+48>>2]=i[w+28>>2],i[n+52>>2]=k,k=i[w+24>>2],i[n+40>>2]=i[w+20>>2],i[n+44>>2]=k,k=i[h+44>>2],n=k+G(f-r|0,56)|0,t=k+o|0,k=i[t+36>>2],i[n+8>>2]=i[t+32>>2],i[n+12>>2]=k,k=i[t+52>>2],i[n+24>>2]=i[t+48>>2],i[n+28>>2]=k,k=i[t+44>>2],i[n+16>>2]=i[t+40>>2],i[n+20>>2]=k,r=r+1|0,X=i[w>>2],!X)break}r=i[h+44>>2]}f=i[m+4>>2],i[r+8>>2]=i[m>>2],i[r+12>>2]=f,f=i[m+20>>2],i[r+24>>2]=i[m+16>>2],i[r+28>>2]=f,f=i[m+12>>2],i[r+16>>2]=i[m+8>>2],i[r+20>>2]=f,k=i[B+40>>2],w=1;break r}if(w=i[26970],$=i[26971],(w|0)!=($|0))for(;;){if(r=i[w>>2],W[i[i[r>>2]+8>>2]](B+24|0,r,i[B+56>>2]-28|0,Q,t,N),f=i[B+24>>2],z=i[B+28>>2],(f|0)!=(z|0)){f:{A:{for(;;){k:{X=i[B+56>>2],_=i[X-4>>2],o=i[f+24>>2],r=i[B+52>>2];n:{if((X|0)!=(r|0))for(n=f+16|0;;){if(k=i[r+12>>2],!((k|0)!=i[f>>2]|i[r+16>>2]!=i[f+4>>2]|(l[r+20|0]!=l[f+8|0]|i[r+24>>2]!=i[f+12>>2]))&&(k||G3(r+28|0,n)))break n;if(r=r+40|0,(X|0)==(r|0))break}if(r=i[B+40>>2],k=i[B+44>>2],(r|0)!=(k|0)){for(S=o+_|0,o=f+16|0;;){t:{if(n=i[r+12>>2],(n|0)!=i[f>>2]|i[r+16>>2]!=i[f+4>>2]|(l[r+20|0]!=l[f+8|0]|i[r+24>>2]!=i[f+12>>2])||!n&&!G3(r+28|0,o))break t;if((S|0)>=i[r+36>>2])break n;O=((i[B+56>>2]-i[B+52>>2]|0)/40|0)-1|0,k=i[w>>2],M=i[w+4>>2],M&&(i[M+4>>2]=i[M+4>>2]+1),P=l[f+8|0],E=i[f+4>>2],V=i[f>>2],u[B+2|0]=l[f+11|0],g[B>>1]=l[f+9|0]|l[f+10|0]<<8,R=i[r+8>>2],F=l[f+23|0],I=l[f+22|0],X=C[f+20>>1],_=C[f+18>>1],o=C[f+16>>1],n=i[f+12>>2],i[r+8>>2]=M,i[r+4>>2]=k,i[r>>2]=O;u:{if(!R||(k=i[R+4>>2],i[R+4>>2]=k-1,k))break u;W[i[i[R>>2]+8>>2]](R),y(R)}u[r+20|0]=P,i[r+16>>2]=E,i[r+12>>2]=V,k=C[B>>1],u[r+21|0]=k,u[r+22|0]=k>>>8,u[r+23|0]=l[B+2|0],u[r+35|0]=F,u[r+34|0]=I,g[r+32>>1]=X,g[r+30>>1]=_,g[r+28>>1]=o,i[r+24>>2]=n,i[r+36>>2]=S;break n}if(r=r+40|0,(k|0)==(r|0))break}k=i[B+44>>2]}r=i[f+20>>2],i[B+16>>2]=i[f+16>>2],i[B+20>>2]=r,r=i[f+12>>2],i[B+8>>2]=i[f+8>>2],i[B+12>>2]=r,r=i[f+4>>2],i[B>>2]=i[f>>2],i[B+4>>2]=r,r=i[B+56>>2],X=((r-i[B+52>>2]|0)/40|0)-1|0,_=i[r-4>>2]+i[f+24>>2]|0,r=i[B+48>>2];t:{if(r>>>0>k>>>0){u[k+34|0]=1,g[k+32>>1]=2,i[k+24>>2]=8,i[k+28>>2]=131074,u[k+20|0]=0,i[k+12>>2]=99,i[k+16>>2]=99,i[k+4>>2]=0,i[k+8>>2]=0,i[k>>2]=X,r=i[w>>2],n=i[w+4>>2];u:{if(!n){i[k+8>>2]=0,i[k+4>>2]=r;break u}if(i[n+4>>2]=i[n+4>>2]+1,i[k+4>>2]=r,o=i[k+8>>2],i[k+8>>2]=n,!o||(r=i[o+4>>2],i[o+4>>2]=r-1,r))break u;W[i[i[o>>2]+8>>2]](o),y(o)}r=i[B+4>>2],i[k+12>>2]=i[B>>2],i[k+16>>2]=r,r=i[B+20>>2],i[k+28>>2]=i[B+16>>2],i[k+32>>2]=r,r=i[B+12>>2],i[k+20>>2]=i[B+8>>2],i[k+24>>2]=r,i[k+36>>2]=_,r=k+40|0;break t}if(F=i[B+40>>2],k=k-F|0,o=((k|0)/40|0)+1|0,o>>>0>=107374183)break k;if(n=(r-F|0)/40|0,r=n<<1,I=n>>>0>=53687091?107374182:r>>>0>o>>>0?r:o,I){if(I>>>0>=107374183)break A;r=p(G(I,40))}else r=0;if(V=r+k|0,i[V>>2]=X,n=i[w>>2],o=i[w+4>>2],o&&(i[o+4>>2]=i[o+4>>2]+1,k=i[B+44>>2]-F|0),i[V+8>>2]=o,i[V+4>>2]=n,n=i[B+20>>2],i[V+28>>2]=i[B+16>>2],i[V+32>>2]=n,n=i[B+12>>2],i[V+20>>2]=i[B+8>>2],i[V+24>>2]=n,n=i[B+4>>2],i[V+12>>2]=i[B>>2],i[V+16>>2]=n,i[V+36>>2]=_,n=V+G((k|0)/-40|0,40)|0,k&&x(n,F,k),i[B+48>>2]=r+G(I,40),r=V+40|0,i[B+44>>2]=r,i[B+40>>2]=n,!F)break t;Z(F)}i[B+44>>2]=r}if(f=f+28|0,(z|0)!=(f|0))continue;break f}break}G0(),H()}z0(),H()}f=i[B+24>>2]}if(f&&(i[B+28>>2]=f,Z(f)),w=w+8|0,($|0)==(w|0))break}if(f=i[B+44>>2],k=i[B+40>>2],(f|0)==(k|0))break}w=0}if(k){if(r=k,f=i[B+44>>2],(r|0)!=(f|0)){for(;;){n=i[f-32>>2];r:{if(!n||(r=i[n+4>>2],i[n+4>>2]=r-1,r))break r;W[i[i[n>>2]+8>>2]](n),y(n)}if(f=f-40|0,(k|0)==(f|0))break}r=i[B+40>>2]}i[B+44>>2]=k,Z(r)}if(k=i[B+52>>2],!k)break e;if(r=k,f=i[B+56>>2],(r|0)!=(f|0)){for(;;){n=i[f-32>>2];r:{if(!n||(r=i[n+4>>2],i[n+4>>2]=r-1,r))break r;W[i[i[n>>2]+8>>2]](n),y(n)}if(f=f-40|0,(k|0)==(f|0))break}r=i[B+52>>2]}i[B+56>>2]=k,Z(r)}v=B- -64|0;e:{if(!w){u[h+12|0]=0,u[h+23|0]=0,f=q(h+24|0,4,3003,h+12|0),e=i[f+4>>2],i[A>>2]=i[f>>2],i[A+4>>2]=e,r=A+8|0;r:{if(u[f+19|0]>=0){e=i[f+12>>2],i[r>>2]=i[f+8>>2],i[r+4>>2]=e,i[r+8>>2]=i[f+16>>2],u[A+20|0]=1;break r}if(T(r,i[f+8>>2],i[f+12>>2]),e=u[f+19|0],u[A+20|0]=1,(e|0)>=0)break r;Z(i[f+8>>2])}if(u[h+23|0]>=0)break e;Z(i[h+12>>2]);break e}if(i[h+44>>2]==i[h+48>>2]){r=i[e>>2],e=i[e+4>>2],e&&(i[e+4>>2]=i[e+4>>2]+1),u[A+20|0]=0,i[A+4>>2]=e,i[A>>2]=r;break e}n=A,m=v-112|0,v=m,A=i[e>>2],r=i[e+4>>2],r&&(i[r+4>>2]=i[r+4>>2]+2);r:{f:{if(e=h+44|0,_=i[e>>2],$=i[e+4>>2],(_|0)==($|0)){e=A;break f}for(M=n+8|0,z=e+28|0,O=e+12|0,f=i[25472],P=i[25473],Q=m+8|0,e=A;;){k=i[_>>2],i[m+60>>2]=r,i[m+56>>2]=A,r&&(i[r+4>>2]=i[r+4>>2]+1),W[i[i[k>>2]+12>>2]](m+80|0,k,m+56|0,_+8|0,_+32|0,O,z,s),t=i[m+60>>2];A:{if(!t||(k=i[t+4>>2],i[t+4>>2]=k-1,k))break A;W[i[i[t>>2]+8>>2]](t),y(t)}A:{k:{n:{t:{u:{if(a=l[m+100|0],a){if((a|0)!=1)break u;k=i[m+84>>2],i[n>>2]=i[m+80>>2],i[n+4>>2]=k;o:{if(u[m+99|0]>=0){k=i[m+92>>2],i[M>>2]=i[m+88>>2],i[M+4>>2]=k,i[M+8>>2]=i[m+96>>2];break o}T(M,i[m+88>>2],i[m+92>>2])}u[n+20|0]=1;break A}k=i[m+84>>2],k&&(i[k+4>>2]=i[k+4>>2]+1),e=i[m+80>>2];o:{if(!r||(t=i[r+4>>2],i[r+4>>2]=t-1,t))break o;W[i[i[r>>2]+8>>2]](r),y(r)}W[i[i[e>>2]+8>>2]](e,_+48|0),W[i[i[e>>2]+12>>2]](e,A+16|0),W[i[i[e>>2]+16>>2]](e,l[A+4|0]),C[A+32>>1]|C[A+34>>1]&&(i[m+56>>2]=i[A+32>>2],W[i[i[e>>2]+24>>2]](e,m+56|0)),l[A+60|0]==1&&(t=i[A+56>>2],i[m+72>>2]=i[A+52>>2],i[m+76>>2]=t,t=i[A+48>>2],o=m- -64|0,i[o>>2]=i[A+44>>2],i[o+4>>2]=t,t=i[A+40>>2],i[m+56>>2]=i[A+36>>2],i[m+60>>2]=t,W[i[i[e>>2]+28>>2]](e,m+56|0)),o=i[A+24>>2],t=i[A+28>>2],(o|0)!=(t|0)&&W[i[i[e>>2]+20>>2]](e,o,t);o:{if(l[A+80|0]!=1)break o;l:{if(u[A+79|0]>=0){i[m+48>>2]=i[A+76>>2],t=i[A+72>>2],i[m+40>>2]=i[A+68>>2],i[m+44>>2]=t;break l}T(m+40|0,i[A+68>>2],i[A+72>>2])}if(W[i[i[e>>2]+36>>2]](e,m+40|0),u[m+51|0]>=0)break o;Z(i[m+40>>2])}t=i[A+64>>2];o:{if(!t||(W[i[i[e>>2]+32>>2]](m+20|0,e,t),u[m+39|0]>=0))break o;Z(i[m+28>>2])}if(i[e+144>>2]=i[A+144>>2],w=i[A+148>>2],E=i[A+152>>2],(w|0)==(E|0))break k;for(;;){A=i[w+4>>2],i[m>>2]=i[w>>2],i[m+4>>2]=A;o:{if(u[w+19|0]>=0){A=i[w+12>>2],i[Q>>2]=i[w+8>>2],i[Q+4>>2]=A,i[Q+8>>2]=i[w+16>>2];break o}T(Q,i[w+8>>2],i[w+12>>2])}o=i[e+152>>2],t=i[e+156>>2];o:{if(o>>>0<t>>>0){A=i[m+4>>2],i[o>>2]=i[m>>2],i[o+4>>2]=A,i[o+16>>2]=i[Q+8>>2],A=i[Q+4>>2],i[o+8>>2]=i[Q>>2],i[o+12>>2]=A,i[Q>>2]=0,i[Q+4>>2]=0,i[Q+8>>2]=0,R=o+20|0;break o}if(A=i[e+148>>2],o=o-A|0,X=((o|0)/20|0)+1|0,X>>>0>=214748365)break t;if(t=(t-A|0)/20|0,A=t<<1,A=t>>>0>=107374182?214748364:A>>>0>X>>>0?A:X,A>>>0>=214748365)break n;if(V=G(A,20),F=p(V),t=F+o|0,A=i[m+4>>2],i[t>>2]=i[m>>2],i[t+4>>2]=A,i[t+16>>2]=i[Q+8>>2],A=i[Q+4>>2],i[t+8>>2]=i[Q>>2],i[t+12>>2]=A,i[Q>>2]=0,i[Q+4>>2]=0,i[Q+8>>2]=0,R=t+20|0,o=i[e+148>>2],A=o,S=i[e+152>>2],I=t+G((S-o|0)/-20|0,20)|0,X=I,(o|0)!=(S|0)){for(;t=i[A+4>>2],i[X>>2]=i[A>>2],i[X+4>>2]=t,i[X+16>>2]=i[A+16>>2],t=i[A+12>>2],i[X+8>>2]=i[A+8>>2],i[X+12>>2]=t,i[A+16>>2]=0,i[A+8>>2]=0,i[A+12>>2]=0,X=X+20|0,A=A+20|0,(S|0)!=(A|0););for(;u[o+19|0]<0&&Z(i[o+8>>2]),o=o+20|0,(S|0)!=(o|0););o=i[e+148>>2]}if(i[e+152>>2]=R,i[e+148>>2]=I,i[e+156>>2]=V+F,!o)break o;Z(o)}if(i[e+152>>2]=R,u[m+19|0]<0&&Z(i[m+8>>2]),w=w+20|0,(E|0)==(w|0))break}break k}_2(),H()}G0(),H()}z0(),H()}k&&(i[k+4>>2]=i[k+4>>2]+1);k:{if(!r||(A=i[r+4>>2],i[r+4>>2]=A-1,A))break k;W[i[i[r>>2]+8>>2]](r),y(r)}r=k,A=e}if(k=l[m+100|0],(k|0)!=255&&(i[m+56>>2]=f,i[m+60>>2]=P,W[i[(m+56|0)+(k<<2)>>2]](m+111|0,m+80|0)),!a){if(_=_+56|0,($|0)==(_|0))break f;continue}break}if(!r||(A=i[r+4>>2],i[r+4>>2]=A-1,A))break r;W[i[i[r>>2]+8>>2]](r),y(r);break r}u[n+20|0]=0,i[n+4>>2]=r,i[n>>2]=e}r:{if(!r||(A=i[r+4>>2],i[r+4>>2]=A-1,A))break r;W[i[i[r>>2]+8>>2]](r),y(r)}v=m+112|0}if(r=i[h+44>>2],r){if(e=i[h+48>>2],A=r,(e|0)!=(r|0)){for(;;){f=i[e-52>>2];e:{if(!f||(A=i[f+4>>2],i[f+4>>2]=A-1,A))break e;W[i[i[f>>2]+8>>2]](f),y(f)}if(e=e-56|0,(r|0)==(e|0))break}A=i[h+44>>2]}i[h+48>>2]=r,Z(A)}Ii(h+124|0,i[h+128>>2])}N&&x2(N),v=h+160|0}function E7(A,e,r,f,k,n,t,o,s,w,h,_){var B=0,m=0,X=0,Q=0,V=0,F=0,I=0,E=0,R=0,N=0,M=0,z=0,S=0,O=0,P=0,a=0,$=0,f0=0,A0=0,n0=0,_0=0,m0=0,X0=0,g0=0,I0=0,e0=0,r0=0,N0=0,U0=0,M0=0,H0=0,P0=0,K0=0,$0=0,L0=0,d0=0,n2=0,Z2=0,Q2=0,g2=0,p2=0,H2=0,T2=0,b2=0,e1=0,X1=0,J1=0,z1=0,b1=0,G4=0,X4=0,W4=0,j4=0,O4=0,P4=0,c8=0,b8=0;z1=v-16|0,v=z1,R=z1+4|0,M=v-80|0,v=M;i:{e:{if(m=i[r+168>>2],P=k>>m,(P|0)<0||(F=i[r+172>>2],(F|0)<=(P|0)))break e;if(a=n>>m,(a|0)<0|(a|0)>=i[r+176>>2])break i;m=n+o|0,E=k+t|0,N=l[f+10|0];r:{f:{A:switch((l[((i[r+160>>2]+G(P,3)|0)+G(G(F,a),3)|0)+1|0]&3)-1|0){case 0:if(!(N&16))break f;break;case 1:break A;default:break f}i[M+12>>2]=r,i[M+8>>2]=63432,B=M+8|0,f=m,P=w,a=h,F=_,n0=N>>>5|0,Q=M+16|0,N=v-16|0,v=N,I=i[i[r+132>>2]+8236>>2],(s|0)!=8|i[i[r+132>>2]+8236>>2]<3||(a=8,F=0,P=8,E=k,f=n),O=f+a|0,z=O-1|0,m=W[i[i[B>>2]>>2]](B,k,n)|0;A:{f0=n0+1|0,$=E>>I,A0=E-1|0,N0=($|0)!=A0>>I;k:{if(!N0&&(_=0,f>>I==z>>I)||!((F|0)!=1|m>>>0>7)&&(_=0,1<<m&196)||(_=0,!X8(r,k,n,s,E,f,P,a,F,A0,z)))break k;_=W[i[i[B>>2]+4>>2]](B,A0,z)|0,B=C[_+4>>1]|C[_+6>>1]<<16,z=C[_>>1]|C[_+2>>1]<<16,g[Q>>1]=z,g[Q+2>>1]=z>>>16,g[Q+4>>1]=B,g[Q+6>>1]=B>>>16,_=C[_+8>>1]|C[_+10>>1]<<16,g[Q+8>>1]=_,g[Q+10>>1]=_>>>16,_=1}if((f0|0)<=(_|0))break A;k:{n:{t:{if(V=E+P|0,B=V-1|0,z=f-1|0,!(!(1<<m&50)||(F|0)!=1|m>>>0>5)|($|0)==B>>I&f>>I==z>>I||!X8(r,k,n,s,E,f,P,a,F,B,z))break t;if(X=i[r+188>>2],m=B>>X,(m|0)<0||(B=i[r+192>>2],(B|0)<=(m|0)))break e;if(X=z>>X,!((X|0)<0|(X|0)>=i[r+196>>2])){B=(i[r+180>>2]+G(m,12)|0)+G(G(B,X),12)|0;u:{if(!_||(m=l[Q|0],(m|0)!=l[B|0])||m&&C[Q+4>>1]!=C[B+4>>1]|C[Q+6>>1]!=C[B+6>>1]|l[Q+2|0]!=l[B+2|0]||(I0=l[Q+1|0],(I0|0)!=l[B+1|0]))break u;if(X=0,g0=1,m=_,!I0)break n;if(C[Q+8>>1]!=C[B+8>>1]|C[Q+10>>1]!=C[B+10>>1]|l[Q+3|0]!=l[B+3|0])break u;m=_;break n}X=C[B+4>>1]|C[B+6>>1]<<16,m=Q+G(_,12)|0,g0=C[B>>1]|C[B+2>>1]<<16,g[m>>1]=g0,g[m+2>>1]=g0>>>16,g[m+4>>1]=X,g[m+6>>1]=X>>>16,X=C[B+8>>1]|C[B+10>>1]<<16,g[m+8>>1]=X,g[m+10>>1]=X>>>16,g0=1,X=_,m=_+1|0;break n}break k}m=_}n:{if(f0>>>0<=m>>>0)break n;t:{if(($|0)==V>>I&f>>I==z>>I||!X8(r,k,n,s,E,f,P,a,F,V,z))break t;if(B=V,V=i[r+188>>2],B=B>>V,(B|0)<0||($=i[r+192>>2],($|0)<=(B|0)))break e;if(V=z>>V,(V|0)<0|(V|0)>=i[r+196>>2])break k;B=(i[r+180>>2]+G(B,12)|0)+G(G(V,$),12)|0;u:{if(!g0||(V=Q+G(X,12)|0,$=l[V|0],($|0)!=l[B|0])||$&&C[V+4>>1]!=C[B+4>>1]|C[V+6>>1]!=C[B+6>>1]|l[V+2|0]!=l[B+2|0]||($=l[V+1|0],($|0)!=l[B+1|0]))break u;if(!$)break t;if(C[V+8>>1]!=C[B+8>>1]|C[V+10>>1]!=C[B+10>>1])break u;if(l[V+3|0]==l[B+3|0])break t}$=C[B+4>>1]|C[B+6>>1]<<16,V=Q+G(m,12)|0,I0=C[B>>1]|C[B+2>>1]<<16,g[V>>1]=I0,g[V+2>>1]=I0>>>16,g[V+4>>1]=$,g[V+6>>1]=$>>>16,B=C[B+8>>1]|C[B+10>>1]<<16,g[V+8>>1]=B,g[V+10>>1]=B>>>16,m=m+1|0}if(m>>>0>=f0>>>0)break n;t:{u:{if(!N0&&(B=f>>I,(B|0)==O>>I))break u;o:{if(!X8(r,k,n,s,E,f,P,a,F,A0,O))break o;if(V=i[r+188>>2],B=A0>>V,(B|0)<0||($=i[r+192>>2],($|0)<=(B|0)))break e;if(V=O>>V,(V|0)<0|(V|0)>=i[r+196>>2])break k;B=(i[r+180>>2]+G(B,12)|0)+G(G(V,$),12)|0;l:{if(!_||(V=l[Q|0],(V|0)!=l[B|0])||V&&C[Q+4>>1]!=C[B+4>>1]|C[Q+6>>1]!=C[B+6>>1]|l[Q+2|0]!=l[B+2|0]||(V=l[Q+1|0],(V|0)!=l[B+1|0]))break l;if(!V)break o;if(C[Q+8>>1]!=C[B+8>>1]|C[Q+10>>1]!=C[B+10>>1])break l;if(l[Q+3|0]==l[B+3|0])break o}O=C[B+4>>1]|C[B+6>>1]<<16,V=Q+G(m,12)|0,$=C[B>>1]|C[B+2>>1]<<16,g[V>>1]=$,g[V+2>>1]=$>>>16,g[V+4>>1]=O,g[V+6>>1]=O>>>16,B=C[B+8>>1]|C[B+10>>1]<<16,g[V+8>>1]=B,g[V+10>>1]=B>>>16,m=m+1|0}if((m|0)==4|m>>>0>=f0>>>0)break n;if(N0)break t;B=f>>I}if(z>>I==(B|0))break n}if(!X8(r,k,n,s,E,f,P,a,F,A0,z))break n;if(I=i[r+188>>2],F=A0>>I,(F|0)<0||(B=i[r+192>>2],(B|0)<=(F|0)))break e;if(I=z>>I,(I|0)<0|(I|0)>=i[r+196>>2])break k;if(F=(i[r+180>>2]+G(F,12)|0)+G(G(B,I),12)|0,g0&&to(Q+G(X,12)|0,F)||_&&to(Q,F))break n;X=C[F+4>>1]|C[F+6>>1]<<16,_=Q+G(m,12)|0,I=C[F>>1]|C[F+2>>1]<<16,g[_>>1]=I,g[_+2>>1]=I>>>16,g[_+4>>1]=X,g[_+6>>1]=X>>>16,F=C[F+8>>1]|C[F+10>>1]<<16,g[_+8>>1]=F,g[_+10>>1]=F>>>16,m=m+1|0}_=m;break A}break i}i[N+12>>2]=_;A:{if((_|0)>(n0|0)||(Dr(A,r,e,E,f,P,a,0,0,N+4|0,N+2|0),u[N+3|0]=0,m=l[N+2|0],i[e+28>>2]||(Dr(A,r,e,E,f,P,a,0,1,N+8|0,N+3|0),M0=l[N+3|0],m=m|M0),!(m&255)))break A;i[N+12>>2]=_+1,f=Q+G(_,12)|0,_=i[N+4>>2],g[f+4>>1]=_,g[f+6>>1]=_>>>16,_=i[N+8>>2],g[f+8>>1]=_,g[f+10>>1]=_>>>16,_=l[N+2|0],g[f+2>>1]=0,u[f+1|0]=M0,u[f|0]=_}if(_=i[e+28>>2],!_){E=0;A:{if(P=i[N+12>>2],(P|0)<2|(P|0)>=(f0|0))break A;I=e+988|0,B=e+924|0,z=G(P,P-1|0);k:{for(;;){if(f=E<<2,_=i[f+63328>>2],(_|0)>=(P|0)||(m=i[f+63376>>2],(m|0)>=(P|0)))break k;if(F=0,f=0,_=Q+G(_,12)|0,l[_|0]&&(f=W[i[i[A>>2]+8>>2]](A,i[B+(u[_+2|0]<<2)>>2])|0),m=Q+G(m,12)|0,l[m+1|0]&&(F=W[i[i[A>>2]+8>>2]](A,i[I+(u[m+3|0]<<2)>>2])|0),a=l[_|0],!(!a||f)||(X=l[m+1|0],!(!X||F))||(!(i[f+96>>2]!=i[F+96>>2]|C[_+4>>1]!=C[m+8>>1])&C[_+6>>1]==C[m+10>>1]|(!a|!X)||(f=Q+G(i[N+12>>2],12)|0,u[f+2|0]=l[_+2|0],F=l[m+3|0],u[f+1|0]=X,u[f|0]=a,u[f+3|0]=F,_=C[_+4>>1]|C[_+6>>1]<<16,g[f+4>>1]=_,g[f+6>>1]=_>>>16,_=C[m+8>>1]|C[m+10>>1]<<16,g[f+8>>1]=_,g[f+10>>1]=_>>>16,i[N+12>>2]=i[N+12>>2]+1),E=E+1|0,(z|0)==(E|0)))break A;if((f0|0)==i[N+12>>2])break}break A}D0(12200,18225,1432,5247),H()}_=i[e+28>>2]}P=i[e+336>>2],(_|0)!=1&&(f=i[e+340>>2],P=(f|0)>(P|0)?P:f),a=i[N+12>>2];A:{if((n0|0)<(a|0))break A;if(f=f0-a|0,E=f&1,_=0,(a|0)!=(n0|0))for(F=f&-2,f=0;f0=i[e+28>>2],m=Q+G(a,12)|0,X=(_|0)<(P|0)?_:0,u[m+2|0]=X,g[m+4>>1]=0,g[m+6>>1]=0,g[m+8>>1]=0,g[m+10>>1]=0,f0=(f0|0)!=1,u[m+1|0]=f0,u[m|0]=1,u[m+3|0]=f0?X:-1,f0=i[e+28>>2],X=_|1,X=(X|0)<(P|0)?X:0,u[m+14|0]=X,g[m+16>>1]=0,g[m+18>>1]=0,g[m+20>>1]=0,g[m+22>>1]=0,u[m+12|0]=1,f0=(f0|0)!=1,u[m+13|0]=f0,u[m+15|0]=f0?X:-1,_=_+2|0,a=a+2|0,f=f+2|0,(F|0)!=(f|0););if(!E)break A;m=i[e+28>>2],f=Q+G(a,12)|0,_=(_|0)<(P|0)?_:0,u[f+2|0]=_,g[f+4>>1]=0,g[f+6>>1]=0,g[f+8>>1]=0,g[f+10>>1]=0,m=(m|0)!=1,u[f+1|0]=m,u[f|0]=1,u[f+3|0]=m?_:-1}if(v=N+16|0,f=Q+G(n0,12)|0,_=C[f>>1]|C[f+2>>1]<<16,m=C[f+4>>1]|C[f+6>>1]<<16,g[R>>1]=_,g[R+2>>1]=_>>>16,g[R+4>>1]=m,g[R+6>>1]=m>>>16,f=C[f+8>>1]|C[f+10>>1]<<16,g[R+8>>1]=f,g[R+10>>1]=f>>>16,!(_&255)|!l[R+1|0]|(w+h|0)!=12)break r;u[R+1|0]=0,u[R+3|0]=255;break r}f:{A:{k:{n:switch((N&3)-1|0){case 0:case 2:if(N=u[f|0],u[R|0]=1,u[R+2|0]=N,u[f|0]<16)break k;f=R+2|0;break f;default:break n}u[R|0]=0,u[R+2|0]=255;break A}P=C[f+4>>1],a=C[f+2>>1],X=N,N=M+16|0,z7(A,e,r,k,n,s,E,m,w,h,0,X,_,N),N=N+(l[f+10|0]&4)|0,N=C[N>>1]|C[N+2>>1]<<16,g[R+4>>1]=N+a,g[R+6>>1]=P+(N>>>16|0)}if(!(l[f+10|0]&2)){u[R+1|0]=0,u[R+3|0]=255;break r}if(N=u[f+1|0],u[R+1|0]=1,u[R+3|0]=N,u[f+1|0]>15){f=R+3|0;break f}P=C[f+8>>1],a=C[f+6>>1],X=_,_=M+16|0,z7(A,e,r,k,n,s,E,m,w,h,1,N,X,_),f=_+(l[f+10|0]>>>1&4)|0,f=C[f>>1]|C[f+2>>1]<<16,g[R+8>>1]=f+a,g[R+10>>1]=P+(f>>>16|0);break r}u[f|0]=0,u[r+312|0]=3,F2(A+4|0,1012,0)}v=M+80|0,_=A,m=k,N=n,P=t,a=o,f=R,k=v-49152|0,v=k;r:{f:{if(n=e,T2=i[e+4>>2],V=i[T2+4>>2],z=i[V+16832>>2],A=i[r+124>>2],(z|0)==i[A+16832>>2]&&(B=i[V+16840>>2],(B|0)==i[A+16840>>2]))break f;u[r+312|0]=3,F2(_+4|0,1031,0);break r}if(i[V+476>>2]!=i[r+20>>2]){u[r+312|0]=3,F2(_+4|0,1030,0);break r}I=i[r+44>>2],d0=N+a|0,n2=i[V+16856>>2],Z2=m+P|0,Q2=i[V+16852>>2],A=G(I,(d0|0)/(n2|0)|0)+((Z2|0)/(Q2|0)|0)|0,e=A<<l[r+18|0],o=i[r+12>>2],A=A<<l[r+17|0],R=i[r+8>>2],g0=i[r+40>>2],X=G(g0,d0)+Z2<<l[r+16|0],Q=i[r+4>>2],E=l[f+1|0],t=l[f|0];f:{if(l[T2+41|0]|!t|(!E|C[f+4>>1]!=C[f+8>>1])||C[f+6>>1]!=C[f+10>>1])break f;E=i[(n+(u[f+2|0]<<2)|0)+924>>2]!=i[(n+(u[f+3|0]<<2)|0)+988>>2]?E:0}for(F=k+40960|0,f0=k- -8192|0,$=e+o|0,N0=A+R|0,I0=Q+X|0,c8=f+4|0,H2=_+4|0,b8=n+924|0,b1=f+2|0,M0=k+16384|0,o=k+32768|0,e=k,R=1,A=t;;){f:{if(!A)break f;if(A=u[e1+b1|0],(A|0)>=16){u[r+312|0]=3,F2(H2,1012,0);break r}if(n0=W[i[i[_>>2]+8>>2]](_,i[((e1<<6)+b8|0)+(A<<2)>>2])|0,!(i[n0+100>>2]&&n0)){u[r+312|0]=3,F2(H2,1012,0);break f}if(!(!(i[n0+24>>2]!=i[V+484>>2]|i[n0+28>>2]!=i[V+488>>2])&i[r+20>>2]==i[n0+20>>2])){u[r+312|0]=3,F2(H2,1029,0);break f}if(X=i[r+124>>2],Q=i[X+16832>>2],A=i[n0+124>>2],!((Q|0)==i[A+16832>>2]&i[X+16840>>2]==i[A+16840>>2])){u[r+312|0]=3,F2(H2,1028,0);break f}g2=(e1<<2)+c8|0,A=g[g2+2>>1],X=g[g2>>1],A0=i[n0+40>>2],p2=i[n0+4>>2];A:{if((Q|0)>=9){M=0,m0=v-20448|0,v=m0,e0=(A>>2)+d0|0,O=(X>>2)+Z2|0,H0=i[V+488>>2],X0=i[V+484>>2];k:{if(!((A|X)&3)){A=i[V+16832>>2];n:{if(!((O|e0)<0|(X0|0)<(w+O|0))&&(H0|0)>=(h+e0|0))break n;if((h|0)<=0|(w|0)<=0)break k;for(Q=14-A|0,P0=H0-1|0,_0=X0-1|0,K0=w&2147483646,$0=w&1;;){if(A=M+e0|0,r0=(G((A|0)>=0?(A|0)<(H0|0)?A:P0:0,A0)<<1)+p2|0,U0=(G(s,M)<<1)+o|0,A=0,X=0,(w|0)!=1)for(;S=A+O|0,g[U0+(A<<1)>>1]=C[r0+(((S|0)>=0?(S|0)<(X0|0)?S:_0:0)<<1)>>1]<<Q,L0=A|1,S=L0+O|0,g[U0+(L0<<1)>>1]=C[r0+(((S|0)>=0?(S|0)<(X0|0)?S:_0:0)<<1)>>1]<<Q,A=A+2|0,X=X+2|0,(K0|0)!=(X|0););if($0&&(X=U0+(A<<1)|0,A=A+O|0,g[X>>1]=C[r0+(((A|0)>=0?(A|0)<(X0|0)?A:_0:0)<<1)>>1]<<Q),M=M+1|0,(M|0)==(h|0))break}break k}if(A=((G(A0,e0)<<1)+p2|0)+(O<<1)|0,(z|0)<=8){W[i[_+220>>2]](o,s,A,A0,w,h,m0+11360|0);break k}W[i[_+300>>2]](o,s,A,A0,w,h,m0+11360|0,z);break k}P0=A&3,A=P0<<2,Q=i[A+63536>>2],r0=i[A+63520>>2],K0=X&3,X=K0<<2,A=i[X+63536>>2],_0=i[X+63520>>2];n:{if(!((e0|0)<(r0|0)|(_0|0)>(O|0)|((X0|0)<=(A+(w+O|0)|0)|(H0|0)<=(Q+(h+e0|0)|0)))){A=((O<<1)+p2|0)+(G(A0,e0)<<1)|0;break n}M=0-r0|0,L0=h+Q|0;t:{if((M|0)>=(L0|0)||(b2=A+w|0,X=0-_0|0,(b2|0)<=(X|0)))break t;for(G4=H0-1|0,X4=_0+1|0,W4=O+1|0,Q=1-_0|0,X1=(A+_0|0)+w|0,J1=X1&1,A=O-_0|0,$0=X0-1|0,j4=((A|0)>=0?(A|0)<(X0|0)?A:$0:0)<<1;;){if(A=M+e0|0,U0=(G((A|0)>=0?(A|0)<(H0|0)?A:G4:0,A0)<<1)+p2|0,S=G(M+r0|0,80),A=X,J1&&(g[m0+(S<<1)>>1]=C[U0+j4>>1],A=Q),(X1|0)!=1)for(O4=S+_0|0,P4=S+X4|0;S=A+O|0,g[m0+(A+O4<<1)>>1]=C[U0+(((S|0)>=0?(S|0)<(X0|0)?S:$0:0)<<1)>>1],S=A+W4|0,g[m0+(A+P4<<1)>>1]=C[U0+(((S|0)>=0?(S|0)<(X0|0)?S:$0:0)<<1)>>1],A=A+2|0,(b2|0)!=(A|0););if(M=M+1|0,(L0|0)==(M|0))break}}A0=80,A=m0+(_0+G(r0,80)<<1)|0}if((z|0)<=8){W[i[((_+(K0<<4)|0)+(P0<<2)|0)+220>>2]](o,s,A,A0,w,h,m0+11360|0);break k}W[i[((_+(K0<<4)|0)+(P0<<2)|0)+300>>2]](o,s,A,A0,w,h,m0+11360|0,z)}v=m0+20448|0;break A}M=0,m0=v-14768|0,v=m0,e0=(A>>2)+d0|0,O=(X>>2)+Z2|0,H0=i[V+488>>2],X0=i[V+484>>2];k:{if(!((A|X)&3)){A=i[V+16832>>2];n:{if(!((O|e0)<0|(X0|0)<(w+O|0))&&(H0|0)>=(h+e0|0))break n;if((h|0)<=0|(w|0)<=0)break k;for(Q=14-A|0,P0=H0-1|0,_0=X0-1|0,K0=w&2147483646,$0=w&1;;){if(A=M+e0|0,r0=G((A|0)>=0?(A|0)<(H0|0)?A:P0:0,A0)+p2|0,U0=(G(s,M)<<1)+o|0,A=0,X=0,(w|0)!=1)for(;S=A+O|0,g[U0+(A<<1)>>1]=l[r0+((S|0)>=0?(S|0)<(X0|0)?S:_0:0)|0]<<Q,L0=A|1,S=L0+O|0,g[U0+(L0<<1)>>1]=l[r0+((S|0)>=0?(S|0)<(X0|0)?S:_0:0)|0]<<Q,A=A+2|0,X=X+2|0,(K0|0)!=(X|0););if($0&&(X=U0+(A<<1)|0,A=A+O|0,g[X>>1]=l[r0+((A|0)>=0?(A|0)<(X0|0)?A:_0:0)|0]<<Q),M=M+1|0,(M|0)==(h|0))break}break k}if(A=O+(G(A0,e0)+p2|0)|0,(z|0)<=8){W[i[_+220>>2]](o,s,A,A0,w,h,m0+5680|0);break k}W[i[_+300>>2]](o,s,A,A0,w,h,m0+5680|0,z);break k}P0=A&3,A=P0<<2,Q=i[A+63536>>2],r0=i[A+63520>>2],K0=X&3,X=K0<<2,A=i[X+63536>>2],_0=i[X+63520>>2];n:{if(!((e0|0)<(r0|0)|(_0|0)>(O|0)|((X0|0)<=(A+(w+O|0)|0)|(H0|0)<=(Q+(h+e0|0)|0)))){A=(O+p2|0)+G(A0,e0)|0;break n}M=0-r0|0,L0=h+Q|0;t:{if((M|0)>=(L0|0)||(b2=A+w|0,X=0-_0|0,(b2|0)<=(X|0)))break t;for(G4=H0-1|0,Q=O-_0|0,$0=X0-1|0,X4=(Q|0)>=0?(Q|0)<(X0|0)?Q:$0:0,W4=_0+1|0,X1=O+1|0,Q=1-_0|0,J1=(A+_0|0)+w|0,j4=J1&1;;){if(A=M+e0|0,U0=G((A|0)>=0?(A|0)<(H0|0)?A:G4:0,A0)+p2|0,S=G(M+r0|0,80),A=X,j4&&(u[S+m0|0]=l[U0+X4|0],A=Q),(J1|0)!=1)for(O4=S+_0|0,P4=S+W4|0;S=A+O|0,u[m0+(A+O4|0)|0]=l[U0+((S|0)>=0?(S|0)<(X0|0)?S:$0:0)|0],S=A+X1|0,u[m0+(A+P4|0)|0]=l[U0+((S|0)>=0?(S|0)<(X0|0)?S:$0:0)|0],A=A+2|0,(b2|0)!=(A|0););if(M=M+1|0,(L0|0)==(M|0))break}}A0=80,A=m0+(_0+G(r0,80)|0)|0}if((z|0)<=8){W[i[((_+(K0<<4)|0)+(P0<<2)|0)+220>>2]](o,s,A,A0,w,h,m0+5680|0);break k}W[i[((_+(K0<<4)|0)+(P0<<2)|0)+300>>2]](o,s,A,A0,w,h,m0+5680|0,z)}v=m0+14768|0}if(!i[r+20>>2])break f;if(A=(h|0)/(n2|0)|0,o=(w|0)/(Q2|0)|0,X=(e1<<13)+M0|0,Q=g[g2+2>>1],M=g[g2>>1],A0=i[n0+44>>2],O=i[n0+8>>2],i[i[r+124>>2]+16840>>2]>=9){H9(_,V,M,Q,Z2,d0,e,s,O,A0,o,A,B),H9(_,V,g[g2>>1],g[g2+2>>1],Z2,d0,X,s,i[n0+12>>2],i[n0+44>>2],o,A,B);break f}j9(_,V,M,Q,Z2,d0,e,s,O,A0,o,A,B),j9(_,V,g[g2>>1],g[g2+2>>1],Z2,d0,X,s,i[n0+12>>2],i[n0+44>>2],o,A,B)}if(e1=1,X=R,R=0,A=E,e=f0,o=F,!X)break}A=i[V+16840>>2],o=(A|0)>12?2:14-A|0,A=i[V+16832>>2],R=(A|0)>12?2:14-A|0,e=i[r+124>>2],A=l[e+16993|0],e=l[e+16992|0];f:switch(i[n+28>>2]){case 1:if(t=!E&(t|0)==1,!l[T2+41|0]){if(t){A:{if((z|0)<=8){W[i[_+176>>2]](I0,g0,k+32768|0,s,w,h);break A}W[i[_+192>>2]](I0,g0,k+32768|0,s,w,h,z)}if(!i[r+20>>2])break r;if(A=(h|0)/(n2|0)|0,e=(w|0)/(Q2|0)|0,(B|0)<=8){W[i[_+176>>2]](N0,I,k,s,e,A),W[i[_+176>>2]]($,I,M0,s,e,A);break r}W[i[_+192>>2]](N0,I,k,s,e,A,B),W[i[_+192>>2]]($,I,M0,s,e,A,B);break r}F2(H2,1011,0),u[r+312|0]=3;break r}if(t){t=R+l[n+388|0]|0,E=u[b1|0],e=u[(E+n|0)+518|0]<<e,R=n+(E<<1)|0,f0=u[R+679|0],F=n+(E<<2)|0,E=g[F+552>>1],X=u[R+678|0],F=g[F+550>>1],R=g[R+454>>1],Q=l[n+389|0];A:{if((z|0)<=8){W[i[_+180>>2]](I0,g0,k+32768|0,s,w,h,R,e,t);break A}W[i[_+196>>2]](I0,g0,k+32768|0,s,w,h,R,e,t,z)}if(!i[r+20>>2])break r;if(e=(h|0)/(n2|0)|0,n=(w|0)/(Q2|0)|0,t=o+Q|0,o=X<<A,A=f0<<A,(B|0)<=8){W[i[_+180>>2]](N0,I,k,s,n,e,F,o,t),W[i[_+180>>2]]($,I,M0,s,n,e,E,A,t);break r}W[i[_+196>>2]](N0,I,k,s,n,e,F,o,t,B),W[i[_+196>>2]]($,I,M0,s,n,e,E,A,t,B);break r}F2(H2,1011,0),u[r+312|0]=3;break r;default:D0(20068,18225,528,5388),H();case 0:break f}if(!((t|0)!=1|(E|0)!=1)){if(!l[T2+42|0]){A=k+40960|0;f:{if((z|0)<=8){W[i[_+172>>2]](I0,g0,k+32768|0,A,s,w,h);break f}W[i[_+188>>2]](I0,g0,k+32768|0,A,s,w,h,z)}if(!i[r+20>>2])break r;if(A=(h|0)/(n2|0)|0,e=(w|0)/(Q2|0)|0,n=k- -8192|0,t=k+24576|0,(B|0)<=8){W[i[_+172>>2]](N0,I,k,n,s,e,A),W[i[_+172>>2]]($,I,M0,t,s,e,A);break r}W[i[_+188>>2]](N0,I,k,n,s,e,A,B),W[i[_+188>>2]]($,I,M0,t,s,e,A,B);break r}if(t=u[f+3|0],E=n+(t<<1)|0,X=u[E+711|0],F=n+(t<<2)|0,Q=g[F+616>>1],M=u[E+710|0],V=g[F+614>>1],F=u[f+2|0],f0=n+(F<<1)|0,A0=u[f0+679|0],n0=n+(F<<2)|0,O=g[n0+552>>1],X0=u[f0+678|0],n0=g[n0+550>>1],m0=l[n+389|0],_=_+172|0,e5(_,I0,g0,k+32768|0,k+40960|0,s,w,h,g[f0+454>>1],u[(n+F|0)+518|0]<<e,g[E+486>>1],u[(n+t|0)+534|0]<<e,R+l[n+388|0]|0,z),!i[r+20>>2])break r;e=(w|0)/(Q2|0)|0,n=(h|0)/(n2|0)|0,t=o+m0|0,e5(_,N0,I,k,k- -8192|0,s,e,n,n0,X0<<A,V,M<<A,t,B),e5(_,$,I,M0,k+24576|0,s,e,n,O,A0<<A,Q,X<<A,t,B);break r}if(!((t|0)!=1&(E|0)!=1)){if(!l[T2+42|0]){A=(k+32768|0)+(t?0:8192)|0;f:{if((z|0)<=8){W[i[_+176>>2]](I0,g0,A,s,w,h);break f}W[i[_+192>>2]](I0,g0,A,s,w,h,z)}if(!i[r+20>>2])break r;if(n=t?M0:k+24576|0,t=k+(t?0:8192)|0,A=(h|0)/(n2|0)|0,e=(w|0)/(Q2|0)|0,(B|0)<=8){W[i[_+176>>2]](N0,I,t,s,e,A),W[i[_+176>>2]]($,I,n,s,e,A);break r}W[i[_+192>>2]](N0,I,t,s,e,A,B),W[i[_+192>>2]]($,I,n,s,e,A,B);break r}E=!t,F=u[E+b1|0],e=u[(F+(n+(E<<4)|0)|0)+518|0]<<e,f0=(k+32768|0)+(t?0:8192)|0,X=(n+(E<<5)|0)+(F<<1)|0,Q=u[X+679|0],F=(n+(E<<6)|0)+(F<<2)|0,E=g[F+552>>1],M=u[X+678|0],F=g[F+550>>1],X=g[X+454>>1],R=R+l[n+388|0]|0,V=l[n+389|0];f:{if((z|0)<=8){W[i[_+180>>2]](I0,g0,f0,s,w,h,X,e,R);break f}W[i[_+196>>2]](I0,g0,f0,s,w,h,X,e,R,z)}if(!i[r+20>>2])break r;if(R=t?M0:k+24576|0,f0=k+(t?0:8192)|0,e=(h|0)/(n2|0)|0,n=(w|0)/(Q2|0)|0,t=o+V|0,o=M<<A,A=Q<<A,(B|0)<=8){W[i[_+180>>2]](N0,I,f0,s,n,e,F,o,t),W[i[_+180>>2]]($,I,R,s,n,e,E,A,t);break r}W[i[_+196>>2]](N0,I,f0,s,n,e,F,o,t,B),W[i[_+196>>2]]($,I,R,s,n,e,E,A,t,B);break r}F2(H2,1011,0),u[r+312|0]=3}v=k+49152|0,k=m+P|0,n=N+a|0,A=f,h=h>>2;r:{if((h|0)<=0||(e=w>>2,(e|0)<=0))break r;for(_=n>>2,n=k>>2,m=i[r+192>>2],w=w&4,E=e&2147483646,f=0,R=(e|0)==1;;){if(o=G(m,f+_|0),e=0,t=0,!R)for(;s=C[A+4>>1]|C[A+6>>1]<<16,a=G(o,12),P=G(e,12),N=G(n,12),k=a+(P+(N+i[r+180>>2]|0)|0)|0,F=C[A>>1]|C[A+2>>1]<<16,g[k>>1]=F,g[k+2>>1]=F>>>16,g[k+4>>1]=s,g[k+6>>1]=s>>>16,s=C[A+8>>1]|C[A+10>>1]<<16,g[k+8>>1]=s,g[k+10>>1]=s>>>16,k=a+(P+(N+i[r+180>>2]|0)|0)|0,s=C[A+8>>1]|C[A+10>>1]<<16,g[k+20>>1]=s,g[k+22>>1]=s>>>16,s=C[A+4>>1]|C[A+6>>1]<<16,N=C[A>>1]|C[A+2>>1]<<16,g[k+12>>1]=N,g[k+14>>1]=N>>>16,g[k+16>>1]=s,g[k+18>>1]=s>>>16,e=e+2|0,t=t+2|0,(E|0)!=(t|0););if(w&&(k=C[A+4>>1]|C[A+6>>1]<<16,e=((i[r+180>>2]+G(n,12)|0)+G(e,12)|0)+G(o,12)|0,t=C[A>>1]|C[A+2>>1]<<16,g[e>>1]=t,g[e+2>>1]=t>>>16,g[e+4>>1]=k,g[e+6>>1]=k>>>16,k=C[A+8>>1]|C[A+10>>1]<<16,g[e+8>>1]=k,g[e+10>>1]=k>>>16),f=f+1|0,(h|0)==(f|0))break}}v=z1+16|0;return}D0(4656,10893,118,4231),H()}D0(4618,10893,119,4231),H()}function _f(){var A=0,e=0,r=0,f=0,k=0,n=0,t=0,o=0;i:{e:{if(r=i[26970],n=i[26971],(r|0)==(n|0)){A=p(16),i[A+12>>2]=103948,i[A+4>>2]=0,i[A+8>>2]=0,i[A>>2]=101904,f=A+12|0,e=i[26972];r:{if(r>>>0<e>>>0){i[n+4>>2]=A,i[n>>2]=f,A=n+8|0;break r}if(e=e-r|0,n=e>>2,e=e>>>0>=2147483640?536870911:n>>>0<=1?1:n,e>>>0>=536870912)break e;if(e=e<<3,n=p(e),i[n+4>>2]=A,i[n>>2]=f,e=e+n|0,i[26972]=e,A=n+8|0,i[26971]=A,i[26970]=n,!r)break r;Z(r),e=i[26972]}i[26971]=A,r=p(16),i[r+12>>2]=104092,i[r>>2]=101952,i[r+4>>2]=0,i[r+8>>2]=0,t=r+12|0;r:{if(A>>>0<e>>>0){i[A+4>>2]=r,i[A>>2]=t,A=A+8|0;break r}if(n=i[26970],A=A-n|0,o=A>>3,f=o+1|0,f>>>0>=536870912)break i;if(e=e-n|0,k=e>>2,f=e>>>0>=2147483640?536870911:f>>>0<k>>>0?k:f,f){if(f>>>0>=536870912)break e;e=p(f<<3)}else e=0;if(k=e+A|0,i[k+4>>2]=r,i[k>>2]=t,r=k-(o<<3)|0,A&&x(r,n,A),e=e+(f<<3)|0,i[26972]=e,A=k+8|0,i[26971]=A,i[26970]=r,!n)break r;Z(n),e=i[26972]}i[26971]=A,r=p(16),i[r+12>>2]=102032,i[r>>2]=101992,i[r+4>>2]=0,i[r+8>>2]=0,t=r+12|0;r:{if(A>>>0<e>>>0){i[A+4>>2]=r,i[A>>2]=t,A=A+8|0;break r}if(n=i[26970],A=A-n|0,o=A>>3,f=o+1|0,f>>>0>=536870912)break i;if(e=e-n|0,k=e>>2,f=e>>>0>=2147483640?536870911:f>>>0<k>>>0?k:f,f){if(f>>>0>=536870912)break e;e=p(f<<3)}else e=0;if(k=e+A|0,i[k+4>>2]=r,i[k>>2]=t,r=k-(o<<3)|0,A&&x(r,n,A),e=e+(f<<3)|0,i[26972]=e,A=k+8|0,i[26971]=A,i[26970]=r,!n)break r;Z(n),e=i[26972]}i[26971]=A,r=p(16),i[r+12>>2]=102108,i[r>>2]=102068,i[r+4>>2]=0,i[r+8>>2]=0,t=r+12|0;r:{if(A>>>0<e>>>0){i[A+4>>2]=r,i[A>>2]=t,A=A+8|0;break r}if(n=i[26970],A=A-n|0,o=A>>3,f=o+1|0,f>>>0>=536870912)break i;if(e=e-n|0,k=e>>2,f=e>>>0>=2147483640?536870911:f>>>0<k>>>0?k:f,f){if(f>>>0>=536870912)break e;e=p(f<<3)}else e=0;if(k=e+A|0,i[k+4>>2]=r,i[k>>2]=t,r=k-(o<<3)|0,A&&x(r,n,A),e=e+(f<<3)|0,i[26972]=e,A=k+8|0,i[26971]=A,i[26970]=r,!n)break r;Z(n),e=i[26972]}i[26971]=A,r=p(16),i[r+12>>2]=103840,i[r>>2]=102144,i[r+4>>2]=0,i[r+8>>2]=0,t=r+12|0;r:{if(A>>>0<e>>>0){i[A+4>>2]=r,i[A>>2]=t,A=A+8|0;break r}if(n=i[26970],A=A-n|0,o=A>>3,f=o+1|0,f>>>0>=536870912)break i;if(e=e-n|0,k=e>>2,f=e>>>0>=2147483640?536870911:f>>>0<k>>>0?k:f,f){if(f>>>0>=536870912)break e;e=p(f<<3)}else e=0;if(k=e+A|0,i[k+4>>2]=r,i[k>>2]=t,r=k-(o<<3)|0,A&&x(r,n,A),e=e+(f<<3)|0,i[26972]=e,A=k+8|0,i[26971]=A,i[26970]=r,!n)break r;Z(n),e=i[26972]}i[26971]=A,r=p(16),i[r+12>>2]=103876,i[r>>2]=102184,i[r+4>>2]=0,i[r+8>>2]=0,t=r+12|0;r:{if(A>>>0<e>>>0){i[A+4>>2]=r,i[A>>2]=t,A=A+8|0;break r}if(n=i[26970],A=A-n|0,o=A>>3,f=o+1|0,f>>>0>=536870912)break i;if(e=e-n|0,k=e>>2,f=e>>>0>=2147483640?536870911:f>>>0<k>>>0?k:f,f){if(f>>>0>=536870912)break e;e=p(f<<3)}else e=0;if(k=e+A|0,i[k+4>>2]=r,i[k>>2]=t,r=k-(o<<3)|0,A&&x(r,n,A),e=e+(f<<3)|0,i[26972]=e,A=k+8|0,i[26971]=A,i[26970]=r,!n)break r;Z(n),e=i[26972]}i[26971]=A,r=p(16),i[r+12>>2]=103912,i[r>>2]=102224,i[r+4>>2]=0,i[r+8>>2]=0,t=r+12|0;r:{if(A>>>0<e>>>0){i[A+4>>2]=r,i[A>>2]=t,A=A+8|0;break r}if(n=i[26970],A=A-n|0,o=A>>3,f=o+1|0,f>>>0>=536870912)break i;if(e=e-n|0,k=e>>2,f=e>>>0>=2147483640?536870911:f>>>0<k>>>0?k:f,f){if(f>>>0>=536870912)break e;e=p(f<<3)}else e=0;if(k=e+A|0,i[k+4>>2]=r,i[k>>2]=t,r=k-(o<<3)|0,A&&x(r,n,A),e=e+(f<<3)|0,i[26972]=e,A=k+8|0,i[26971]=A,i[26970]=r,!n)break r;Z(n),e=i[26972]}i[26971]=A,r=p(16),i[r+12>>2]=103984,i[r>>2]=102264,i[r+4>>2]=0,i[r+8>>2]=0,t=r+12|0;r:{if(A>>>0<e>>>0){i[A+4>>2]=r,i[A>>2]=t,A=A+8|0;break r}if(n=i[26970],A=A-n|0,o=A>>3,f=o+1|0,f>>>0>=536870912)break i;if(e=e-n|0,k=e>>2,f=e>>>0>=2147483640?536870911:f>>>0<k>>>0?k:f,f){if(f>>>0>=536870912)break e;e=p(f<<3)}else e=0;if(k=e+A|0,i[k+4>>2]=r,i[k>>2]=t,r=k-(o<<3)|0,A&&x(r,n,A),e=e+(f<<3)|0,i[26972]=e,A=k+8|0,i[26971]=A,i[26970]=r,!n)break r;Z(n),e=i[26972]}i[26971]=A,r=p(16),i[r+12>>2]=104020,i[r>>2]=102304,i[r+4>>2]=0,i[r+8>>2]=0,t=r+12|0;r:{if(A>>>0<e>>>0){i[A+4>>2]=r,i[A>>2]=t,A=A+8|0;break r}if(n=i[26970],A=A-n|0,o=A>>3,f=o+1|0,f>>>0>=536870912)break i;if(e=e-n|0,k=e>>2,f=e>>>0>=2147483640?536870911:f>>>0<k>>>0?k:f,f){if(f>>>0>=536870912)break e;e=p(f<<3)}else e=0;if(k=e+A|0,i[k+4>>2]=r,i[k>>2]=t,r=k-(o<<3)|0,A&&x(r,n,A),e=e+(f<<3)|0,i[26972]=e,A=k+8|0,i[26971]=A,i[26970]=r,!n)break r;Z(n),e=i[26972]}i[26971]=A,r=p(16),i[r+12>>2]=104164,i[r>>2]=102344,i[r+4>>2]=0,i[r+8>>2]=0,t=r+12|0;r:{if(A>>>0<e>>>0){i[A+4>>2]=r,i[A>>2]=t,A=A+8|0;break r}if(n=i[26970],A=A-n|0,o=A>>3,f=o+1|0,f>>>0>=536870912)break i;if(e=e-n|0,k=e>>2,f=e>>>0>=2147483640?536870911:f>>>0<k>>>0?k:f,f){if(f>>>0>=536870912)break e;e=p(f<<3)}else e=0;if(k=e+A|0,i[k+4>>2]=r,i[k>>2]=t,r=k-(o<<3)|0,A&&x(r,n,A),e=e+(f<<3)|0,i[26972]=e,A=k+8|0,i[26971]=A,i[26970]=r,!n)break r;Z(n),e=i[26972]}i[26971]=A,r=p(16),i[r+12>>2]=104200,i[r>>2]=102384,i[r+4>>2]=0,i[r+8>>2]=0,t=r+12|0;r:{if(A>>>0<e>>>0){i[A+4>>2]=r,i[A>>2]=t,A=A+8|0;break r}if(n=i[26970],A=A-n|0,o=A>>3,f=o+1|0,f>>>0>=536870912)break i;if(e=e-n|0,k=e>>2,f=e>>>0>=2147483640?536870911:f>>>0<k>>>0?k:f,f){if(f>>>0>=536870912)break e;e=p(f<<3)}else e=0;if(k=e+A|0,i[k+4>>2]=r,i[k>>2]=t,r=k-(o<<3)|0,A&&x(r,n,A),e=e+(f<<3)|0,i[26972]=e,A=k+8|0,i[26971]=A,i[26970]=r,!n)break r;Z(n),e=i[26972]}i[26971]=A,r=p(16),i[r+12>>2]=104128,i[r>>2]=102424,i[r+4>>2]=0,i[r+8>>2]=0,t=r+12|0;r:{if(A>>>0<e>>>0){i[A+4>>2]=r,i[A>>2]=t,A=A+8|0;break r}if(n=i[26970],A=A-n|0,o=A>>3,f=o+1|0,f>>>0>=536870912)break i;if(e=e-n|0,k=e>>2,f=e>>>0>=2147483640?536870911:f>>>0<k>>>0?k:f,f){if(f>>>0>=536870912)break e;e=p(f<<3)}else e=0;if(k=e+A|0,i[k+4>>2]=r,i[k>>2]=t,r=k-(o<<3)|0,A&&x(r,n,A),e=e+(f<<3)|0,i[26972]=e,A=k+8|0,i[26971]=A,i[26970]=r,!n)break r;Z(n),e=i[26972]}i[26971]=A,r=p(16),i[r+12>>2]=104056,i[r>>2]=102464,i[r+4>>2]=0,i[r+8>>2]=0,t=r+12|0;r:{if(A>>>0<e>>>0){i[A+4>>2]=r,i[A>>2]=t,A=A+8|0;break r}if(n=i[26970],A=A-n|0,o=A>>3,f=o+1|0,f>>>0>=536870912)break i;if(e=e-n|0,k=e>>2,f=e>>>0>=2147483640?536870911:f>>>0<k>>>0?k:f,f){if(f>>>0>=536870912)break e;e=p(f<<3)}else e=0;if(k=e+A|0,i[k+4>>2]=r,i[k>>2]=t,r=k-(o<<3)|0,A&&x(r,n,A),e=e+(f<<3)|0,i[26972]=e,A=k+8|0,i[26971]=A,i[26970]=r,!n)break r;Z(n),e=i[26972]}i[26971]=A,r=p(16),i[r+12>>2]=103732,i[r>>2]=102504,i[r+4>>2]=0,i[r+8>>2]=0,t=r+12|0;r:{if(A>>>0<e>>>0){i[A+4>>2]=r,i[A>>2]=t,A=A+8|0;break r}if(n=i[26970],A=A-n|0,o=A>>3,f=o+1|0,f>>>0>=536870912)break i;if(e=e-n|0,k=e>>2,f=e>>>0>=2147483640?536870911:f>>>0<k>>>0?k:f,f){if(f>>>0>=536870912)break e;e=p(f<<3)}else e=0;if(k=e+A|0,i[k+4>>2]=r,i[k>>2]=t,r=k-(o<<3)|0,A&&x(r,n,A),e=e+(f<<3)|0,i[26972]=e,A=k+8|0,i[26971]=A,i[26970]=r,!n)break r;Z(n),e=i[26972]}i[26971]=A,r=p(16),i[r+12>>2]=102584,i[r>>2]=102544,i[r+4>>2]=0,i[r+8>>2]=0,t=r+12|0;r:{if(A>>>0<e>>>0){i[A+4>>2]=r,i[A>>2]=t,A=A+8|0;break r}if(n=i[26970],A=A-n|0,o=A>>3,f=o+1|0,f>>>0>=536870912)break i;if(e=e-n|0,k=e>>2,f=e>>>0>=2147483640?536870911:f>>>0<k>>>0?k:f,f){if(f>>>0>=536870912)break e;e=p(f<<3)}else e=0;if(k=e+A|0,i[k+4>>2]=r,i[k>>2]=t,r=k-(o<<3)|0,A&&x(r,n,A),e=e+(f<<3)|0,i[26972]=e,A=k+8|0,i[26971]=A,i[26970]=r,!n)break r;Z(n),e=i[26972]}i[26971]=A,r=p(16),i[r+12>>2]=102660,i[r>>2]=102620,i[r+4>>2]=0,i[r+8>>2]=0,t=r+12|0;r:{if(A>>>0<e>>>0){i[A+4>>2]=r,i[A>>2]=t,A=A+8|0;break r}if(n=i[26970],A=A-n|0,o=A>>3,f=o+1|0,f>>>0>=536870912)break i;if(e=e-n|0,k=e>>2,f=e>>>0>=2147483640?536870911:f>>>0<k>>>0?k:f,f){if(f>>>0>=536870912)break e;e=p(f<<3)}else e=0;if(k=e+A|0,i[k+4>>2]=r,i[k>>2]=t,r=k-(o<<3)|0,A&&x(r,n,A),e=e+(f<<3)|0,i[26972]=e,A=k+8|0,i[26971]=A,i[26970]=r,!n)break r;Z(n),e=i[26972]}i[26971]=A,r=p(16),i[r+12>>2]=103696,i[r>>2]=102696,i[r+4>>2]=0,i[r+8>>2]=0,t=r+12|0;r:{if(A>>>0<e>>>0){i[A+4>>2]=r,i[A>>2]=t,A=A+8|0;break r}if(n=i[26970],A=A-n|0,o=A>>3,f=o+1|0,f>>>0>=536870912)break i;if(e=e-n|0,k=e>>2,f=e>>>0>=2147483640?536870911:f>>>0<k>>>0?k:f,f){if(f>>>0>=536870912)break e;e=p(f<<3)}else e=0;if(k=e+A|0,i[k+4>>2]=r,i[k>>2]=t,r=k-(o<<3)|0,A&&x(r,n,A),e=e+(f<<3)|0,i[26972]=e,A=k+8|0,i[26971]=A,i[26970]=r,!n)break r;Z(n),e=i[26972]}i[26971]=A,r=p(16),i[r+12>>2]=103768,i[r>>2]=102736,i[r+4>>2]=0,i[r+8>>2]=0,t=r+12|0;r:{if(A>>>0<e>>>0){i[A+4>>2]=r,i[A>>2]=t,A=A+8|0;break r}if(n=i[26970],A=A-n|0,o=A>>3,f=o+1|0,f>>>0>=536870912)break i;if(e=e-n|0,k=e>>2,f=e>>>0>=2147483640?536870911:f>>>0<k>>>0?k:f,f){if(f>>>0>=536870912)break e;e=p(f<<3)}else e=0;if(k=e+A|0,i[k+4>>2]=r,i[k>>2]=t,r=k-(o<<3)|0,A&&x(r,n,A),e=e+(f<<3)|0,i[26972]=e,A=k+8|0,i[26971]=A,i[26970]=r,!n)break r;Z(n),e=i[26972]}i[26971]=A,r=p(16),i[r+12>>2]=104308,i[r>>2]=102776,i[r+4>>2]=0,i[r+8>>2]=0,t=r+12|0;r:{if(A>>>0<e>>>0){i[A+4>>2]=r,i[A>>2]=t,A=A+8|0;break r}if(n=i[26970],A=A-n|0,o=A>>3,f=o+1|0,f>>>0>=536870912)break i;if(e=e-n|0,k=e>>2,f=e>>>0>=2147483640?536870911:f>>>0<k>>>0?k:f,f){if(f>>>0>=536870912)break e;e=p(f<<3)}else e=0;if(k=e+A|0,i[k+4>>2]=r,i[k>>2]=t,r=k-(o<<3)|0,A&&x(r,n,A),e=e+(f<<3)|0,i[26972]=e,A=k+8|0,i[26971]=A,i[26970]=r,!n)break r;Z(n),e=i[26972]}i[26971]=A,r=p(16),i[r+12>>2]=102856,i[r>>2]=102816,i[r+4>>2]=0,i[r+8>>2]=0,t=r+12|0;r:{if(A>>>0<e>>>0){i[A+4>>2]=r,i[A>>2]=t,A=A+8|0;break r}if(n=i[26970],A=A-n|0,o=A>>3,f=o+1|0,f>>>0>=536870912)break i;if(e=e-n|0,k=e>>2,f=e>>>0>=2147483640?536870911:f>>>0<k>>>0?k:f,f){if(f>>>0>=536870912)break e;e=p(f<<3)}else e=0;if(k=e+A|0,i[k+4>>2]=r,i[k>>2]=t,r=k-(o<<3)|0,A&&x(r,n,A),e=e+(f<<3)|0,i[26972]=e,A=k+8|0,i[26971]=A,i[26970]=r,!n)break r;Z(n),e=i[26972]}i[26971]=A,r=p(16),i[r+12>>2]=102932,i[r>>2]=102892,i[r+4>>2]=0,i[r+8>>2]=0,t=r+12|0;r:{if(A>>>0<e>>>0){i[A+4>>2]=r,i[A>>2]=t,A=A+8|0;break r}if(n=i[26970],A=A-n|0,o=A>>3,f=o+1|0,f>>>0>=536870912)break i;if(e=e-n|0,k=e>>2,f=e>>>0>=2147483640?536870911:f>>>0<k>>>0?k:f,f){if(f>>>0>=536870912)break e;e=p(f<<3)}else e=0;if(k=e+A|0,i[k+4>>2]=r,i[k>>2]=t,r=k-(o<<3)|0,A&&x(r,n,A),e=e+(f<<3)|0,i[26972]=e,A=k+8|0,i[26971]=A,i[26970]=r,!n)break r;Z(n),e=i[26972]}i[26971]=A,r=p(16),i[r+12>>2]=104236,i[r>>2]=102968,i[r+4>>2]=0,i[r+8>>2]=0,t=r+12|0;r:{if(A>>>0<e>>>0){i[A+4>>2]=r,i[A>>2]=t,A=A+8|0;break r}if(n=i[26970],A=A-n|0,o=A>>3,f=o+1|0,f>>>0>=536870912)break i;if(e=e-n|0,k=e>>2,f=e>>>0>=2147483640?536870911:f>>>0<k>>>0?k:f,f){if(f>>>0>=536870912)break e;e=p(f<<3)}else e=0;if(k=e+A|0,i[k+4>>2]=r,i[k>>2]=t,r=k-(o<<3)|0,A&&x(r,n,A),e=e+(f<<3)|0,i[26972]=e,A=k+8|0,i[26971]=A,i[26970]=r,!n)break r;Z(n),e=i[26972]}i[26971]=A,r=p(16),i[r+12>>2]=104272,i[r>>2]=103008,i[r+4>>2]=0,i[r+8>>2]=0,t=r+12|0;r:{if(A>>>0<e>>>0){i[A+4>>2]=r,i[A>>2]=t,A=A+8|0;break r}if(n=i[26970],A=A-n|0,o=A>>3,f=o+1|0,f>>>0>=536870912)break i;if(e=e-n|0,k=e>>2,f=e>>>0>=2147483640?536870911:f>>>0<k>>>0?k:f,f){if(f>>>0>=536870912)break e;e=p(f<<3)}else e=0;if(k=e+A|0,i[k+4>>2]=r,i[k>>2]=t,r=k-(o<<3)|0,A&&x(r,n,A),e=e+(f<<3)|0,i[26972]=e,A=k+8|0,i[26971]=A,i[26970]=r,!n)break r;Z(n),e=i[26972]}i[26971]=A,r=p(16),i[r+12>>2]=103088,i[r>>2]=103048,i[r+4>>2]=0,i[r+8>>2]=0,t=r+12|0;r:{if(A>>>0<e>>>0){i[A+4>>2]=r,i[A>>2]=t,A=A+8|0;break r}if(n=i[26970],A=A-n|0,o=A>>3,f=o+1|0,f>>>0>=536870912)break i;if(e=e-n|0,k=e>>2,f=e>>>0>=2147483640?536870911:f>>>0<k>>>0?k:f,f){if(f>>>0>=536870912)break e;e=p(f<<3)}else e=0;if(k=e+A|0,i[k+4>>2]=r,i[k>>2]=t,r=k-(o<<3)|0,A&&x(r,n,A),e=e+(f<<3)|0,i[26972]=e,A=k+8|0,i[26971]=A,i[26970]=r,!n)break r;Z(n),e=i[26972]}i[26971]=A,r=p(16),i[r+12>>2]=103164,i[r>>2]=103124,i[r+4>>2]=0,i[r+8>>2]=0,t=r+12|0;r:{if(A>>>0<e>>>0){i[A+4>>2]=r,i[A>>2]=t,A=A+8|0;break r}if(n=i[26970],A=A-n|0,o=A>>3,f=o+1|0,f>>>0>=536870912)break i;if(e=e-n|0,k=e>>2,f=e>>>0>=2147483640?536870911:f>>>0<k>>>0?k:f,f){if(f>>>0>=536870912)break e;e=p(f<<3)}else e=0;if(k=e+A|0,i[k+4>>2]=r,i[k>>2]=t,r=k-(o<<3)|0,A&&x(r,n,A),e=e+(f<<3)|0,i[26972]=e,A=k+8|0,i[26971]=A,i[26970]=r,!n)break r;Z(n),e=i[26972]}i[26971]=A,r=p(16),i[r+12>>2]=103240,i[r>>2]=103200,i[r+4>>2]=0,i[r+8>>2]=0,t=r+12|0;r:{if(A>>>0<e>>>0){i[A+4>>2]=r,i[A>>2]=t,A=A+8|0;break r}if(n=i[26970],A=A-n|0,o=A>>3,f=o+1|0,f>>>0>=536870912)break i;if(e=e-n|0,k=e>>2,f=e>>>0>=2147483640?536870911:f>>>0<k>>>0?k:f,f){if(f>>>0>=536870912)break e;e=p(f<<3)}else e=0;if(k=e+A|0,i[k+4>>2]=r,i[k>>2]=t,r=k-(o<<3)|0,A&&x(r,n,A),e=e+(f<<3)|0,i[26972]=e,A=k+8|0,i[26971]=A,i[26970]=r,!n)break r;Z(n),e=i[26972]}i[26971]=A,r=p(16),i[r+12>>2]=103316,i[r>>2]=103276,i[r+4>>2]=0,i[r+8>>2]=0,t=r+12|0;r:{if(A>>>0<e>>>0){i[A+4>>2]=r,i[A>>2]=t,A=A+8|0;break r}if(n=i[26970],A=A-n|0,o=A>>3,f=o+1|0,f>>>0>=536870912)break i;if(e=e-n|0,k=e>>2,f=e>>>0>=2147483640?536870911:f>>>0<k>>>0?k:f,f){if(f>>>0>=536870912)break e;e=p(f<<3)}else e=0;if(k=e+A|0,i[k+4>>2]=r,i[k>>2]=t,r=k-(o<<3)|0,A&&x(r,n,A),e=e+(f<<3)|0,i[26972]=e,A=k+8|0,i[26971]=A,i[26970]=r,!n)break r;Z(n),e=i[26972]}i[26971]=A,r=p(16),i[r+12>>2]=103392,i[r>>2]=103352,i[r+4>>2]=0,i[r+8>>2]=0,t=r+12|0;r:{if(A>>>0<e>>>0){i[A+4>>2]=r,i[A>>2]=t,A=A+8|0;break r}if(n=i[26970],A=A-n|0,o=A>>3,f=o+1|0,f>>>0>=536870912)break i;if(e=e-n|0,k=e>>2,f=e>>>0>=2147483640?536870911:f>>>0<k>>>0?k:f,f){if(f>>>0>=536870912)break e;e=p(f<<3)}else e=0;if(k=e+A|0,i[k+4>>2]=r,i[k>>2]=t,r=k-(o<<3)|0,A&&x(r,n,A),e=e+(f<<3)|0,i[26972]=e,A=k+8|0,i[26971]=A,i[26970]=r,!n)break r;Z(n),e=i[26972]}i[26971]=A,r=p(16),i[r+12>>2]=103468,i[r>>2]=103428,i[r+4>>2]=0,i[r+8>>2]=0,t=r+12|0;r:{if(A>>>0<e>>>0){i[A+4>>2]=r,i[A>>2]=t,A=A+8|0;break r}if(n=i[26970],A=A-n|0,o=A>>3,f=o+1|0,f>>>0>=536870912)break i;if(e=e-n|0,k=e>>2,f=e>>>0>=2147483640?536870911:f>>>0<k>>>0?k:f,f){if(f>>>0>=536870912)break e;e=p(f<<3)}else e=0;if(k=e+A|0,i[k+4>>2]=r,i[k>>2]=t,r=k-(o<<3)|0,A&&x(r,n,A),e=e+(f<<3)|0,i[26972]=e,A=k+8|0,i[26971]=A,i[26970]=r,!n)break r;Z(n),e=i[26972]}i[26971]=A,r=p(16),i[r+12>>2]=103544,i[r>>2]=103504,i[r+4>>2]=0,i[r+8>>2]=0,t=r+12|0;r:{if(A>>>0<e>>>0){i[A+4>>2]=r,i[A>>2]=t,A=A+8|0;break r}if(n=i[26970],A=A-n|0,o=A>>3,f=o+1|0,f>>>0>=536870912)break i;if(e=e-n|0,k=e>>2,f=e>>>0>=2147483640?536870911:f>>>0<k>>>0?k:f,f){if(f>>>0>=536870912)break e;e=p(f<<3)}else e=0;if(k=e+A|0,i[k+4>>2]=r,i[k>>2]=t,r=k-(o<<3)|0,A&&x(r,n,A),e=e+(f<<3)|0,i[26972]=e,A=k+8|0,i[26971]=A,i[26970]=r,!n)break r;Z(n),e=i[26972]}i[26971]=A,r=p(16),i[r+12>>2]=103620,i[r>>2]=103580,i[r+4>>2]=0,i[r+8>>2]=0,t=r+12|0;r:{if(A>>>0<e>>>0){i[A+4>>2]=r,i[A>>2]=t,A=A+8|0;break r}if(n=i[26970],A=A-n|0,o=A>>3,f=o+1|0,f>>>0>=536870912)break i;if(e=e-n|0,k=e>>2,f=e>>>0>=2147483640?536870911:f>>>0<k>>>0?k:f,f){if(f>>>0>=536870912)break e;e=p(f<<3)}else e=0;if(k=e+A|0,i[k+4>>2]=r,i[k>>2]=t,r=k-(o<<3)|0,A&&x(r,n,A),e=e+(f<<3)|0,i[26972]=e,A=k+8|0,i[26971]=A,i[26970]=r,!n)break r;Z(n),e=i[26972]}i[26971]=A,r=p(16),i[r+12>>2]=103804,i[r>>2]=103656,i[r+4>>2]=0,i[r+8>>2]=0,t=r+12|0;r:{if(A>>>0<e>>>0){i[A+4>>2]=r,i[A>>2]=t,e=A+8|0;break r}if(n=i[26970],A=A-n|0,o=A>>3,f=o+1|0,f>>>0>=536870912)break i;if(e=e-n|0,k=e>>2,f=e>>>0>=2147483640?536870911:f>>>0<k>>>0?k:f,f){if(f>>>0>=536870912)break e;e=p(f<<3)}else e=0;if(k=e+A|0,i[k+4>>2]=r,i[k>>2]=t,r=k-(o<<3)|0,A&&x(r,n,A),i[26972]=e+(f<<3),e=k+8|0,i[26971]=e,i[26970]=r,!n)break r;Z(n)}i[26971]=e}return}z0(),H()}G0(),H()}function Y7(A,e,r,f){var k=0,n=0,t=0,o=0,s=0,w=0,h=0,_=0,B=0,m=0,X=0,Q=0,V=0,F=0,I=0,E=0,R=0,N=0,M=0,z=0,S=0,O=0,P=0,a=0,$=0,f0=0,A0=0;X=v-48|0,v=X;i:{e:{if(r>>>0>2)break e;for(r=r<<2,P=i[r+73868>>2],O=i[r+73856>>2];;){r=i[e+4>>2];r:{if((r|0)!=i[e+104>>2]){i[e+4>>2]=r+1,r=l[r|0];break r}r=j2(e)}if(!((r|0)==32|r-9>>>0<5))break}V=1;r:{f:switch(r-43|0){case 0:case 2:break f;default:break r}if(V=(r|0)==45?-1:1,r=i[e+4>>2],(r|0)!=i[e+104>>2]){i[e+4>>2]=r+1,r=l[r|0];break r}r=j2(e)}r:{f:{if((r&-33)==73)for(;;){if((t|0)==7)break f;r=i[e+4>>2];A:{if((r|0)!=i[e+104>>2]){i[e+4>>2]=r+1,r=l[r|0];break A}r=j2(e)}if(k=t+1491|0,t=t+1|0,u[k|0]!=(r|32))break}if((t|0)!=3){if(k=(t|0)==8,k)break f;if(!f|t>>>0<4)break r;if(k)break f}if(r=i[e+116>>2],(r|0)>=0|(r|0)>0&&(i[e+4>>2]=i[e+4>>2]-1),!f|t>>>0<4)break f;for(r=(r|0)<0;r||(i[e+4>>2]=i[e+4>>2]-1),t=t-1|0,t>>>0>3;);}s=v-16|0,v=s,f=(N1(U(U(V|0)*U(1/0))),t2(2)),e=f&8388607,Q=f>>>23|0,r=Q&255;f:{if(r){if((r|0)!=255){r=e,e=e>>>7|0,o=r<<25,n=e,r=(Q&255)+16256|0;break f}r=e,e=e>>>7|0,o=r<<25,n=e,r=32767;break f}if(r=0,!e)break f;r=e,e=k1(e),o4(s,r,0,0,0,e+81|0),o=i[s+8>>2],n=i[s+12>>2]^65536,w=i[s>>2],h=i[s+4>>2],r=16265-e|0}i[X>>2]=w,i[X+4>>2]=h,e=X,i[e+8>>2]=o,i[e+12>>2]=n|(f&-2147483648|r<<16),v=s+16|0,o=i[e+8>>2],n=i[e+12>>2],w=i[e>>2],h=i[e+4>>2];break i}r:{f:{A:{k:{n:{t:{if(t||(t=0,(r&-33)!=78))break t;for(;;){if((t|0)==2)break n;r=i[e+4>>2];u:{if((r|0)!=i[e+104>>2]){i[e+4>>2]=r+1,r=l[r|0];break u}r=j2(e)}if(k=t+9337|0,t=t+1|0,u[k|0]!=(r|32))break}}switch(t|0){case 3:break n;case 0:break f;default:break k}}n:{r=i[e+4>>2];t:{if((r|0)!=i[e+104>>2]){i[e+4>>2]=r+1,r=l[r|0];break t}r=j2(e)}if((r|0)==40){t=1;break n}if(n=2147450880,i[e+116>>2]<0)break i;i[e+4>>2]=i[e+4>>2]-1;break i}for(;;){n:{r=i[e+4>>2];t:{if((r|0)!=i[e+104>>2]){i[e+4>>2]=r+1,r=l[r|0];break t}r=j2(e)}if(!(r-48>>>0<10|r-65>>>0<26|(r|0)==95)&&r-97>>>0>=26)break n;t=t+1|0;continue}break}if(n=2147450880,(r|0)==41)break i;r=i[e+116>>2],(r|0)>=0|(r|0)>0&&(i[e+4>>2]=i[e+4>>2]-1);n:{if(f){if(t)break n;break r}i[31324]=28;break A}for(;(r|0)>0|(r|0)>=0&&(i[e+4>>2]=i[e+4>>2]-1),t=t-1|0,!!t;);break r}r=i[e+116>>2],(r|0)>0?r=1:r=(r|0)>=0,r&&(i[e+4>>2]=i[e+4>>2]-1),i[31324]=28}u8(e,0,0);break e}f:{if((r|0)!=48)break f;t=i[e+4>>2];A:{if((t|0)!=i[e+104>>2]){i[e+4>>2]=t+1,t=l[t|0];break A}t=j2(e)}if((t&-33)==88){k=v-432|0,v=k,r=i[e+4>>2];A:{if((r|0)!=i[e+104>>2]){i[e+4>>2]=r+1,r=l[r|0];break A}r=j2(e)}A:{k:{for(;;){if((r|0)!=48)n:{if((r|0)!=46)break A;if(r=i[e+4>>2],(r|0)==i[e+104>>2])break n;i[e+4>>2]=r+1,r=l[r|0];break k}else{r=i[e+4>>2],(r|0)!=i[e+104>>2]?(F=1,i[e+4>>2]=r+1,r=l[r|0]):(F=1,r=j2(e));continue}break}r=j2(e)}if((r|0)!=48){M=1;break A}for(;;){r=Q,Q=r-1|0,I=I-!r|0,r=i[e+4>>2];k:{if((r|0)!=i[e+104>>2]){i[e+4>>2]=r+1,r=l[r|0];break k}r=j2(e)}if((r|0)!=48)break}M=1,F=1}for(h=1073676288;;){A:{t=r;k:{n:{if(a=r-48|0,a>>>0<10)break n;if(f0=(r|0)!=46,t=r|32,f0&t-97>>>0>5)break A;if(f0)break n;if(M)break A;M=1,Q=o,I=n;break k}r=(r|0)>57?t-87|0:a;n:{if((n|0)<=0&o>>>0<=7|(n|0)<0){_=r+(_<<4)|0;break n}if(!n&o>>>0<=28){H4(k+48|0,r),n1(k+32|0,z,S,w,h,0,0,0,1073414144),z=i[k+32>>2],S=i[k+36>>2],w=i[k+40>>2],h=i[k+44>>2],n1(k+16|0,i[k+48>>2],i[k+52>>2],i[k+56>>2],i[k+60>>2],z,S,w,h),y4(k,i[k+16>>2],i[k+20>>2],i[k+24>>2],i[k+28>>2],s,B,R,N),R=i[k+8>>2],N=i[k+12>>2],s=i[k>>2],B=i[k+4>>2];break n}if(m|!r)break n;n1(k+80|0,z,S,w,h,0,0,0,1073610752),y4(k- -64|0,i[k+80>>2],i[k+84>>2],i[k+88>>2],i[k+92>>2],s,B,R,N),m=1,R=i[k+72>>2],N=i[k+76>>2],s=i[k+64>>2],B=i[k+68>>2]}o=o+1|0,n=o?n:n+1|0,F=1}r=i[e+4>>2],(r|0)!=i[e+104>>2]?(i[e+4>>2]=r+1,r=l[r|0]):r=j2(e);continue}break}A:{if(!F){r=i[e+116>>2],(r|0)>0?r=1:r=(r|0)>=0;k:{n:{if(r){if(r=i[e+4>>2],i[e+4>>2]=r-1,!f)break n;if(i[e+4>>2]=r-2,!M)break k;i[e+4>>2]=r-3;break k}if(f)break k}u8(e,0,0)}M2(0),e=t2(1)|0,f=t2(0)|0,M2(+(V|0)),r=t2(1)|0,t2(0)|0,D2(0,f|0),D2(1,e&2147483647|r&-2147483648),g8(k+96|0,+r1()),s=i[k+96>>2],B=i[k+100>>2],r=i[k+108>>2],e=i[k+104>>2];break A}if((n|0)<=0&o>>>0<=7|(n|0)<0)for(w=o,h=n;_=_<<4,w=w+1|0,h=w?h:h+1|0,!!((w|0)!=8|h););k:{n:{t:{if((r&-33)==80){if(w=hn(e,f),r=l0,h=r,w|(r|0)!=-2147483648)break k;if(f){if(r=i[e+116>>2],(r|0)>0?r=1:r=(r|0)>=0,r)break t;break n}s=0,B=0,u8(e,0,0),r=0,e=0;break A}if(w=0,h=0,i[e+116>>2]<0)break k}i[e+4>>2]=i[e+4>>2]-1}w=0,h=0}if(!_){M2(0),e=t2(1)|0,f=t2(0)|0,M2(+(V|0)),r=t2(1)|0,t2(0)|0,D2(0,f|0),D2(1,e&2147483647|r&-2147483648),g8(k+112|0,+r1()),s=i[k+112>>2],B=i[k+116>>2],r=i[k+124>>2],e=i[k+120>>2];break A}if(e=M?Q:o,f=w+(e<<2)|0,e=h+((M?I:n)<<2|e>>>30)|0,o=f-32|0,r=0-P|0,n=(f>>>0<w>>>0?e+1|0:e)-(f>>>0<32)|0,e=n,(e|0)>0?e=1:e=r>>>0<o>>>0&(e|0)>=0,e){i[31324]=68,H4(k+160|0,V),n1(k+144|0,i[k+160>>2],i[k+164>>2],i[k+168>>2],i[k+172>>2],-1,-1,-1,2147418111),n1(k+128|0,i[k+144>>2],i[k+148>>2],i[k+152>>2],i[k+156>>2],-1,-1,-1,2147418111),s=i[k+128>>2],B=i[k+132>>2],r=i[k+140>>2],e=i[k+136>>2];break A}if(e=P-226|0,r=e>>31,(n|0)>=(r|0)&e>>>0<=o>>>0|(r|0)<(n|0)){if((_|0)>=0)for(;y4(k+416|0,s,B,R,N,0,0,0,-1073807360),e=Bu(s,B,R,N,1073610752),e=(e|0)>=0,y4(k+400|0,s,B,R,N,e?i[k+416>>2]:s,e?i[k+420>>2]:B,e?i[k+424>>2]:R,e?i[k+428>>2]:N),r=_<<1,_=r|e,e=o,o=e-1|0,n=n-!e|0,R=i[k+408>>2],N=i[k+412>>2],s=i[k+400>>2],B=i[k+404>>2],(r|0)>=0;);e=32-P|0,r=e,e=e+o|0,h=r>>>0>e>>>0?n+1|0:n,r=e>>>0<O>>>0&(h|0)<=0|(h|0)<0?(e|0)>0?e:0:O;k:{if(r>>>0>=113){H4(k+384|0,V),w=i[k+392>>2],h=i[k+396>>2],z=i[k+384>>2],S=i[k+388>>2],n=0,e=0;break k}g8(k+352|0,A4(1,144-r|0)),H4(k+336|0,V),z=i[k+336>>2],S=i[k+340>>2],w=i[k+344>>2],h=i[k+348>>2],pl(k+368|0,i[k+352>>2],i[k+356>>2],i[k+360>>2],i[k+364>>2],h),E=i[k+376>>2],$=i[k+380>>2],n=i[k+372>>2],e=i[k+368>>2]}f=!(_&1)&((p6(s,B,R,N,0,0,0,0)|0)!=0&r>>>0<32),mi(k+320|0,f|_),n1(k+304|0,z,S,w,h,i[k+320>>2],i[k+324>>2],i[k+328>>2],i[k+332>>2]),r=e,y4(k+272|0,i[k+304>>2],i[k+308>>2],i[k+312>>2],i[k+316>>2],e,n,E,$),e=f,n1(k+288|0,z,S,w,h,e?0:s,e?0:B,e?0:R,e?0:N),y4(k+256|0,i[k+288>>2],i[k+292>>2],i[k+296>>2],i[k+300>>2],i[k+272>>2],i[k+276>>2],i[k+280>>2],i[k+284>>2]),cA(k+240|0,i[k+256>>2],i[k+260>>2],i[k+264>>2],i[k+268>>2],r,n,E,$),e=i[k+240>>2],f=i[k+244>>2],r=i[k+248>>2],w=i[k+252>>2],p6(e,f,r,w,0,0,0,0)||(i[31324]=68),it(k+224|0,e,f,r,w,o),s=i[k+224>>2],B=i[k+228>>2],r=i[k+236>>2],e=i[k+232>>2];break A}i[31324]=68,H4(k+208|0,V),n1(k+192|0,i[k+208>>2],i[k+212>>2],i[k+216>>2],i[k+220>>2],0,0,0,65536),n1(k+176|0,i[k+192>>2],i[k+196>>2],i[k+200>>2],i[k+204>>2],0,0,0,65536),s=i[k+176>>2],B=i[k+180>>2],r=i[k+188>>2],e=i[k+184>>2]}i[X+16>>2]=s,i[X+20>>2]=B,i[X+24>>2]=e,i[X+28>>2]=r,v=k+432|0,o=i[X+24>>2],n=i[X+28>>2],w=i[X+16>>2],h=i[X+20>>2];break i}if(i[e+116>>2]<0)break f;i[e+4>>2]=i[e+4>>2]-1}t=e,s=r,E=f,f=0,k=v-8976|0,v=k,a=0-P|0,$=a-O|0;f:{A:{for(;;){if((s|0)!=48)k:{if((s|0)!=46)break f;if(e=i[t+4>>2],(e|0)==i[t+104>>2])break k;i[t+4>>2]=e+1,s=l[e|0];break A}else{e=i[t+4>>2],(e|0)!=i[t+104>>2]?(i[t+4>>2]=e+1,s=l[e|0]):s=j2(t),f=1;continue}break}s=j2(t)}if((s|0)==48){for(;;){e=o,o=e-1|0,n=n-!e|0,e=i[t+4>>2];A:{if((e|0)!=i[t+104>>2]){i[t+4>>2]=e+1,s=l[e|0];break A}s=j2(t)}if((s|0)!=48)break}f=1}M=1}i[k+784>>2]=0;f:{A:{e=(s|0)==46,r=s-48|0;k:{n:{t:{if(e|r>>>0<=9)for(;;){u:{if(e&1){if(!M){o=w,n=h,M=1;break u}e=!f;break t}if(e=h,w=w+1|0,h=w?e:e+1|0,(_|0)<=2044){F=(s|0)==48?F:w,e=(k+784|0)+(_<<2)|0,m&&(r=(G(i[e>>2],10)+s|0)-48|0),i[e>>2]=r,f=1,r=m+1|0,e=(r|0)==9,m=e?0:r,_=e+_|0;break u}if((s|0)==48)break u;i[k+8960>>2]=i[k+8960>>2]|1,F=18396}e=i[t+4>>2];u:{if((e|0)!=i[t+104>>2]){i[t+4>>2]=e+1,s=l[e|0];break u}s=j2(t)}if(e=(s|0)==46,r=s-48|0,!(e|r>>>0<10))break}if(o=M?o:w,n=M?n:h,!(!f|(s&-33)!=69)){s=hn(t,E),e=l0,B=e;u:{if(s|(e|0)!=-2147483648)break u;if(!E)break k;if(s=0,B=0,i[t+116>>2]<0)break u;i[t+4>>2]=i[t+4>>2]-1}n=n+B|0,o=o+s|0,n=o>>>0<s>>>0?n+1|0:n;break A}if(e=!f,(s|0)<0)break n}if(i[t+116>>2]<0)break n;i[t+4>>2]=i[t+4>>2]-1}if(!e)break A;i[31324]=28}u8(t,0,0),o=0,n=0,r=0,e=0;break f}if(e=i[k+784>>2],!e){M2(0),e=t2(1)|0,f=t2(0)|0,M2(+(V|0)),r=t2(1)|0,t2(0)|0,D2(0,f|0),D2(1,e&2147483647|r&-2147483648),g8(k,+r1()),o=i[k+8>>2],n=i[k+12>>2],r=i[k+4>>2],e=i[k>>2];break f}if(!(w>>>0>9&(h|0)>=0|(h|0)>0|((o|0)!=(w|0)|(n|0)!=(h|0))|(e>>>O|0?O>>>0<=30:0))){H4(k+48|0,V),mi(k+32|0,e),n1(k+16|0,i[k+48>>2],i[k+52>>2],i[k+56>>2],i[k+60>>2],i[k+32>>2],i[k+36>>2],i[k+40>>2],i[k+44>>2]),o=i[k+24>>2],n=i[k+28>>2],r=i[k+20>>2],e=i[k+16>>2];break f}if(e=a>>>1|0,e>>>0<o>>>0&(n|0)>=0|(n|0)>0){i[31324]=68,H4(k+96|0,V),n1(k+80|0,i[k+96>>2],i[k+100>>2],i[k+104>>2],i[k+108>>2],-1,-1,-1,2147418111),n1(k- -64|0,i[k+80>>2],i[k+84>>2],i[k+88>>2],i[k+92>>2],-1,-1,-1,2147418111),o=i[k+72>>2],n=i[k+76>>2],r=i[k+68>>2],e=i[k+64>>2];break f}if(e=P-226|0,r=o>>>0<e>>>0,e=e>>31,r&(n|0)<=(e|0)|(e|0)>(n|0)){i[31324]=68,H4(k+144|0,V),n1(k+128|0,i[k+144>>2],i[k+148>>2],i[k+152>>2],i[k+156>>2],0,0,0,65536),n1(k+112|0,i[k+128>>2],i[k+132>>2],i[k+136>>2],i[k+140>>2],0,0,0,65536),o=i[k+120>>2],n=i[k+124>>2],r=i[k+116>>2],e=i[k+112>>2];break f}if(m){if((m|0)<=8){for(e=(k+784|0)+(_<<2)|0,t=i[e>>2];t=G(t,10),m=m+1|0,(m|0)!=9;);i[e>>2]=t}_=_+1|0}m=o;A:{if(o>>>0>17&(n|0)>=0|(n|0)>0|(F|0)>=9|(o|0)<(F|0))break A;if(!n&(o|0)==9){H4(k+192|0,V),mi(k+176|0,i[k+784>>2]),n1(k+160|0,i[k+192>>2],i[k+196>>2],i[k+200>>2],i[k+204>>2],i[k+176>>2],i[k+180>>2],i[k+184>>2],i[k+188>>2]),o=i[k+168>>2],n=i[k+172>>2],r=i[k+164>>2],e=i[k+160>>2];break f}if((n|0)<=0&o>>>0<=8|(n|0)<0){H4(k+272|0,V),mi(k+256|0,i[k+784>>2]),n1(k+240|0,i[k+272>>2],i[k+276>>2],i[k+280>>2],i[k+284>>2],i[k+256>>2],i[k+260>>2],i[k+264>>2],i[k+268>>2]),H4(k+224|0,i[(0-m<<2)+73856>>2]),S7(k+208|0,i[k+240>>2],i[k+244>>2],i[k+248>>2],i[k+252>>2],i[k+224>>2],i[k+228>>2],i[k+232>>2],i[k+236>>2]),o=i[k+216>>2],n=i[k+220>>2],r=i[k+212>>2],e=i[k+208>>2];break f}if(e=(G(m,-3)+O|0)+27|0,r=i[k+784>>2],r>>>e|0&&(e|0)<=30)break A;H4(k+352|0,V),mi(k+336|0,r),n1(k+320|0,i[k+352>>2],i[k+356>>2],i[k+360>>2],i[k+364>>2],i[k+336>>2],i[k+340>>2],i[k+344>>2],i[k+348>>2]),H4(k+304|0,i[(m<<2)+73784>>2]),n1(k+288|0,i[k+320>>2],i[k+324>>2],i[k+328>>2],i[k+332>>2],i[k+304>>2],i[k+308>>2],i[k+312>>2],i[k+316>>2]),o=i[k+296>>2],n=i[k+300>>2],r=i[k+292>>2],e=i[k+288>>2];break f}for(;e=_,_=e-1|0,!i[(k+784|0)+(_<<2)>>2];);F=0,r=(m|0)%9|0;A:{if(!r){r=0;break A}f=(n|0)<0?r+9|0:r;k:{if(!e){r=0,e=0;break k}for(o=i[(0-f<<2)+73856>>2],n=1e9/(o|0)|0,s=0,t=0,r=0;w=s,h=k+784|0,s=h+(t<<2)|0,_=i[s>>2],E=(_>>>0)/(o>>>0)|0,w=w+E|0,i[s>>2]=w,w=!w&(r|0)==(t|0),r=w?r+1&2047:r,m=w?m-9|0:m,s=G(n,_-G(o,E)|0),t=t+1|0,(t|0)!=(e|0););if(!s)break k;i[h+(e<<2)>>2]=s,e=e+1|0}m=(m-f|0)+9|0}for(;;){h=(k+784|0)+(r<<2)|0,t=(m|0)<36;A:{for(;;){if(!t&((m|0)!=36|u0[h>>2]>=10384593))break A;for(_=e+2047|0,f=0;w=e,o=f,s=_&2047,_=(k+784|0)+(s<<2)|0,f=i[_>>2],e=f>>>3|0,f=f<<29,o=o+f|0,n=f>>>0>o>>>0?e+1|0:e,!n&o>>>0<1000000001?f=0:(e=o,f=d8(e,n,1e9,0),E=O0(f,l0,1e9,0),o=e-E|0,n=n-(l0+(e>>>0<E>>>0)|0)|0),i[_>>2]=o,e=(r|0)==(s|0)||n|o?w:s,o=w-1&2047,e=(o|0)!=(s|0)?w:e,_=s-1|0,(r|0)!=(s|0););if(F=F-29|0,e=w,!!f)break}r=r-1&2047,(r|0)==(e|0)&&(n=(e+2046&2047)<<2,e=k+784|0,w=n+e|0,i[w>>2]=i[w>>2]|i[e+(o<<2)>>2],e=o),m=m+9|0,i[(k+784|0)+(r<<2)>>2]=f;continue}break}A:{k:for(;;){for(o=e+1&2047,n=(k+784|0)+((e-1&2047)<<2)|0;;){w=(m|0)>45?9:1;n:{for(;;){f=r,t=0;t:{for(;;){u:{if(r=f+t&2047,(r|0)==(e|0)||(r=i[(k+784|0)+(r<<2)>>2],s=i[(t<<2)+73808>>2],r>>>0<s>>>0))break u;if(r>>>0>s>>>0)break t;if(t=t+1|0,(t|0)!=4)continue}break}if((m|0)!=36)break t;for(o=0,n=0,t=0,w=0,h=0;r=f+t&2047,(r|0)==(e|0)&&(e=e+1&2047,i[((e<<2)+k|0)+780>>2]=0),mi(k+768|0,i[(k+784|0)+(r<<2)>>2]),n1(k+752|0,o,n,w,h,0,0,1342177280,1075633366),y4(k+736|0,i[k+752>>2],i[k+756>>2],i[k+760>>2],i[k+764>>2],i[k+768>>2],i[k+772>>2],i[k+776>>2],i[k+780>>2]),w=i[k+744>>2],h=i[k+748>>2],o=i[k+736>>2],n=i[k+740>>2],t=t+1|0,(t|0)!=4;);if(H4(k+720|0,V),n1(k+704|0,o,n,w,h,i[k+720>>2],i[k+724>>2],i[k+728>>2],i[k+732>>2]),o=0,n=0,w=i[k+712>>2],h=i[k+716>>2],s=i[k+704>>2],B=i[k+708>>2],E=F+113|0,t=E-P|0,m=(t|0)<(O|0),r=m?(t|0)>0?t:0:O,r>>>0<=112)break n;break A}if(F=w+F|0,r=e,(e|0)!=(f|0))break}for(h=1e9>>>w|0,_=-1<<w^-1,t=0,r=f;s=t,E=k+784|0,t=E+(f<<2)|0,B=i[t>>2],s=s+(B>>>w|0)|0,i[t>>2]=s,s=!s&(r|0)==(f|0),r=s?r+1&2047:r,m=s?m-9|0:m,t=G(h,_&B),f=f+1&2047,(f|0)!=(e|0););if(!t)continue;if((r|0)!=(o|0)){i[E+(e<<2)>>2]=t,e=o;continue k}i[n>>2]=i[n>>2]|1;continue}break}break}g8(k+656|0,A4(1,225-r|0)),pl(k+688|0,i[k+656>>2],i[k+660>>2],i[k+664>>2],i[k+668>>2],h),z=i[k+696>>2],S=i[k+700>>2],R=i[k+688>>2],N=i[k+692>>2],g8(k+640|0,A4(1,113-r|0)),U9(k+672|0,s,B,w,h,i[k+640>>2],i[k+644>>2],i[k+648>>2],i[k+652>>2]),o=i[k+672>>2],n=i[k+676>>2],Q=i[k+680>>2],I=i[k+684>>2],cA(k+624|0,s,B,w,h,o,n,Q,I),y4(k+608|0,R,N,z,S,i[k+624>>2],i[k+628>>2],i[k+632>>2],i[k+636>>2]),w=i[k+616>>2],h=i[k+620>>2],s=i[k+608>>2],B=i[k+612>>2]}_=f+4&2047;A:{if((_|0)==(e|0))break A;_=i[(k+784|0)+(_<<2)>>2];k:{if(_>>>0<=499999999){if(!_&(f+5&2047)==(e|0))break k;g8(k+496|0,+(V|0)*.25),y4(k+480|0,o,n,Q,I,i[k+496>>2],i[k+500>>2],i[k+504>>2],i[k+508>>2]),Q=i[k+488>>2],I=i[k+492>>2],o=i[k+480>>2],n=i[k+484>>2];break k}if((_|0)!=5e8){g8(k+592|0,+(V|0)*.75),y4(k+576|0,o,n,Q,I,i[k+592>>2],i[k+596>>2],i[k+600>>2],i[k+604>>2]),Q=i[k+584>>2],I=i[k+588>>2],o=i[k+576>>2],n=i[k+580>>2];break k}if(A0=+(V|0),(f+5&2047)==(e|0)){g8(k+528|0,A0*.5),y4(k+512|0,o,n,Q,I,i[k+528>>2],i[k+532>>2],i[k+536>>2],i[k+540>>2]),Q=i[k+520>>2],I=i[k+524>>2],o=i[k+512>>2],n=i[k+516>>2];break k}g8(k+560|0,A0*.75),y4(k+544|0,o,n,Q,I,i[k+560>>2],i[k+564>>2],i[k+568>>2],i[k+572>>2]),Q=i[k+552>>2],I=i[k+556>>2],o=i[k+544>>2],n=i[k+548>>2]}if(r>>>0>111||(U9(k+464|0,o,n,Q,I,0,0,0,1073676288),p6(i[k+464>>2],i[k+468>>2],i[k+472>>2],i[k+476>>2],0,0,0,0)))break A;y4(k+448|0,o,n,Q,I,0,0,0,1073676288),Q=i[k+456>>2],I=i[k+460>>2],o=i[k+448>>2],n=i[k+452>>2]}y4(k+432|0,s,B,w,h,o,n,Q,I),cA(k+416|0,i[k+432>>2],i[k+436>>2],i[k+440>>2],i[k+444>>2],R,N,z,S),w=i[k+424>>2],h=i[k+428>>2],s=i[k+416>>2],B=i[k+420>>2];A:{if(($-2|0)>=(E&2147483647)||(i[k+408>>2]=w,i[k+412>>2]=h&2147483647,i[k+400>>2]=s,i[k+404>>2]=B,n1(k+384|0,s,B,w,h,0,0,0,1073610752),f=Bu(i[k+400>>2],i[k+404>>2],i[k+408>>2],i[k+412>>2],1081081856),e=(f|0)>=0,w=e?i[k+392>>2]:w,h=e?i[k+396>>2]:h,s=e?i[k+384>>2]:s,B=e?i[k+388>>2]:B,o=p6(o,n,Q,I,0,0,0,0),F=e+F|0,(F+110|0)<=($|0)&&!(m&((r|0)!=(t|0)|(f|0)<0)&(o|0)!=0)))break A;i[31324]=68}it(k+368|0,s,B,w,h,F),o=i[k+376>>2],n=i[k+380>>2],r=i[k+372>>2],e=i[k+368>>2]}i[X+40>>2]=o,i[X+44>>2]=n,i[X+32>>2]=e,i[X+36>>2]=r,v=k+8976|0,o=i[X+40>>2],n=i[X+44>>2],w=i[X+32>>2],h=i[X+36>>2];break i}break i}n=0}i[A>>2]=w,i[A+4>>2]=h,i[A+8>>2]=o,i[A+12>>2]=n,v=X+48|0}function er(A,e,r,f,k){var n=0,t=0,o=0,s=0,w=0,h=0,_=0,B=0,m=0,X=0,Q=0,V=0,F=0,I=0,E=0,R=0,N=0,M=0,z=0,S=0,O=0,P=0,a=0,$=0,f0=0,A0=0,n0=0;h=A+18548|0;i:{e:{r:{f:{A:{k:{n:{t:{for(;;){s=i[A+18588>>2],w=i[s+132>>2];u:{o:{if(_=i[s+124>>2],o=i[_+484>>2],t=1<<f,(o|0)<(t+e|0)||(m=i[_+488>>2],(m|0)<(r+t|0)|i[_+16872>>2]>=(f|0)))break o;n=1,B=e-1|0,t=1;l:{if((B|r)<0||(t=1,(e|0)>(o|0))||(t=1,(r|0)>=(m|0))||(Q=i[_+16876>>2],F=G(i[_+16892>>2],r>>Q),V=i[s+140>>2],X=F+(e>>Q)|0,Q=F+(B>>Q)|0,t=1,C[V+G(X,24)>>1]!=C[V+G(Q,24)>>1]))break l;t=i[w+8484>>2],t=i[t+(X<<2)>>2]!=i[t+(Q<<2)>>2]}Q=r-1|0;l:{if((Q|e)<0|(e|0)>=(o|0)|(r|0)>(m|0)||(o=i[_+16876>>2],m=e>>o,V=i[s+140>>2],F=i[_+16892>>2],X=m+G(F,r>>o)|0,o=m+G(F,Q>>o)|0,C[V+G(X,24)>>1]!=C[V+G(o,24)>>1]))break l;n=i[w+8484>>2],n=i[n+(X<<2)>>2]!=i[n+(o<<2)>>2]}if(o=0,!t){if(o=i[s+168>>2],t=B>>o,(t|0)<0||(m=i[s+172>>2],(m|0)<=(t|0)))break A;if(o=r>>o,(o|0)<0|(o|0)>=i[s+176>>2])break f;t=(i[s+160>>2]+G(t,3)|0)+G(G(o,m),3)|0,o=((l[t|0]|l[t+1|0]<<8)>>>6&3)>(k|0)}if(n)t=0;else{if(n=i[s+168>>2],t=e>>n,(t|0)<0||(m=i[s+172>>2],(m|0)<=(t|0)))break A;if(n=Q>>n,(n|0)<0|(n|0)>=i[s+176>>2])break f;t=(i[s+160>>2]+G(t,3)|0)+G(G(n,m),3)|0,t=((l[t|0]|l[t+1|0]<<8)>>>6&3)>(k|0)}t=!v2(h,(t+(i[A+18572>>2]+o|0)|0)+2|0);break u}t=i[_+16872>>2]>=(f|0)}if(!l[w+26|0]|i[w+8268>>2]>(f|0)||(i[A+18500>>2]=0,i[A+18504>>2]=0),!l[i[A+18592>>2]+760|0]|i[w+8272>>2]>(f|0)||(i[A+18508>>2]=0),!t){if(f=f-1|0,k=k+1|0,er(A,e,r,f,k),s=1<<f,t=s+r|0,s=e+s|0,(s|0)<i[_+484>>2]&&er(A,s,r,f,k),(t|0)<i[_+488>>2]&&er(A,e,t,f,k),(s|0)>=i[_+484>>2])break t;if(e=s,r=t,(r|0)<i[_+488>>2])continue;break t}break}if(t=i[s+168>>2],h=f-t|0,(h|0)!=31)for(o=r>>t,h=1<<h,n=o+h|0,t=e>>t,m=t+h|0,B=k<<6&192;;){for(w=t;h=(i[s+160>>2]+G(w,3)|0)+G(G(i[s+172>>2],o),3)|0,_=B|(l[h|0]|l[h+1|0]<<8)&65343,u[h|0]=_,u[h+1|0]=_>>>8,w=w+1|0,(m|0)>(w|0););if(o=o+1|0,!((n|0)>(o|0)))break}if(m=v+-64|0,v=m,t=A,F=i[A+18592>>2],n=i[A+18588>>2],B=i[n+132>>2],Q=i[n+124>>2],s=e,h=r,_=f,A=i[n+168>>2],w=f-A|0,(w|0)!=31)for(r=r>>A,w=1<<w,X=r+w|0,e=e>>A,V=e+w|0;;){for(A=e;w=(i[n+160>>2]+G(A,3)|0)+G(G(i[n+172>>2],r),3)|0,o=(l[w|0]|l[w+1|0]<<8)&65528,u[w|0]=o,u[w+1|0]=o>>>8,A=A+1|0,(V|0)>(A|0););if(r=r+1|0,!((X|0)>(r|0)))break}if(e=i[n+168>>2],A=s>>e,(A|0)<0||(r=i[n+172>>2],(r|0)<=(A|0)))break n;if(e=h>>e,(e|0)<0|(e|0)>=i[n+176>>2])break k;if(A=(i[n+160>>2]+G(A,3)|0)+G(G(e,r),3)|0,e=(l[A|0]|l[A+1|0]<<8)&65528|f&7,u[A|0]=e,u[A+1|0]=e>>>8,e=i[n+248>>2],r=_-e|0,(r|0)!=31)for(A=h>>e,r=1<<r,f=A+r|0,w=r,r=s>>e,w=w+r|0;;){for(e=r;u[(i[n+240>>2]+e|0)+G(i[n+252>>2],A)|0]=0,e=e+1|0,(w|0)>(e|0););if(A=A+1|0,!((f|0)>(A|0)))break}y9(t,s,h);u:{if(l[B+44|0]){if(A=v2(t+18548|0,i[t+18572>>2]+161|0),u[t+32|0]=A,!A)break u;if(A=i[n+168>>2],e=_-A|0,(e|0)!=31)for(r=h>>A,e=1<<e,o=r+e|0,f=e,e=s>>A,B=f+e|0;;){for(A=e;f=(i[n+160>>2]+G(A,3)|0)+G(G(i[n+172>>2],r),3)|0,w=(l[f|0]|l[f+1|0]<<8)&63487|2048,u[f|0]=w,u[f+1|0]=w>>>8,A=A+1|0,(B|0)>(A|0););if(r=r+1|0,!((o|0)>(r|0)))break}if(e=i[n+148>>2],A=s>>e,(A|0)<0||(r=i[n+152>>2],(r|0)<=(A|0)))break n;if(e=h>>e,(e|0)<0|(e|0)>=i[n+156>>2])break k;u[((i[n+140>>2]+G(A,24)|0)+G(G(e,r),24)|0)+22|0]=1;break u}u[t+32|0]=0}o=1<<_,f=0;u:{o:{if(i[F+28>>2]==2)break o;e=i[t+18588>>2],B=1,w=s-1|0,A=1;l:{if((w|h)<0||(r=i[e+124>>2],A=1,(s|0)>i[r+484>>2])||(A=1,(h|0)>=i[r+488>>2])||(A=i[r+16892>>2],r=i[r+16876>>2],f=G(A,h>>r),V=i[e+140>>2],X=f+(s>>r)|0,r=f+(w>>r)|0,A=1,C[V+G(X,24)>>1]!=C[V+G(r,24)>>1]))break l;A=i[i[e+132>>2]+8484>>2],A=i[A+(X<<2)>>2]!=i[A+(r<<2)>>2]}X=h-1|0;l:{if((X|s)<0||(r=i[e+124>>2],(s|0)>=i[r+484>>2]|(h|0)>i[r+488>>2])||(f=i[r+16876>>2],V=s>>f,E=i[e+140>>2],r=i[r+16892>>2],I=V+G(r,h>>f)|0,r=V+G(r,X>>f)|0,C[E+G(I,24)>>1]!=C[E+G(r,24)>>1]))break l;f=i[i[e+132>>2]+8484>>2],B=i[f+(I<<2)>>2]!=i[f+(r<<2)>>2]}if(f=0,r=0,!A){if(r=i[e+168>>2],A=w>>r,(A|0)<0||(w=i[e+172>>2],(w|0)<=(A|0)))break A;if(r=h>>r,(r|0)<0|(r|0)>=i[e+176>>2])break f;A=(i[e+160>>2]+G(A,3)|0)+G(G(r,w),3)|0,r=((l[A|0]|l[A+1|0]<<8)&768)==512}if(!B){if(f=i[e+168>>2],A=s>>f,(A|0)<0||(w=i[e+172>>2],(w|0)<=(A|0)))break A;if(f=X>>f,(f|0)<0|(f|0)>=i[e+176>>2])break f;A=(i[e+160>>2]+G(A,3)|0)+G(G(f,w),3)|0,f=((l[A|0]|l[A+1|0]<<8)&768)==512}if(A=t+18548|0,v2(A,((i[t+18572>>2]+r|0)+f|0)+5|0)&255){e=16;l:{if(i[i[t+18592>>2]+812>>2]<2||!v2(A,i[t+18572>>2]+148|0)||(e=48,i[i[t+18592>>2]+812>>2]<3))break l;for(e=1;k4(A)&&(e=e+1|0,(e|0)<(i[i[t+18592>>2]+812>>2]-1|0)););e=e<<5|16}if(u[t+26|0]=l[t+26|0]&15|e,e=i[n+168>>2],A=s>>e,(A|0)<0||(r=i[n+172>>2],(r|0)<=(A|0)))break n;if(e=h>>e,(e|0)<0|(e|0)>=i[n+176>>2])break k;if(A=(i[n+160>>2]+G(A,3)|0)+G(G(e,r),3)|0,e=(l[A|0]|l[A+1|0]<<8)&65479,u[A|0]=e,u[A+1|0]=e>>>8,A=i[n+168>>2],e=_-A|0,(e|0)!=31)for(r=h>>A,e=1<<e,_=r+e|0,A=s>>A,w=A+e|0;;){for(e=A;f=(i[n+160>>2]+G(e,3)|0)+G(G(i[n+172>>2],r),3)|0,k=(l[f|0]|l[f+1|0]<<8)&64767|512,u[f|0]=k,u[f+1|0]=k>>>8,e=e+1|0,(w|0)>(e|0););if(r=r+1|0,!((_|0)>(r|0)))break}E7(i[t+18584>>2],i[t+18592>>2],i[t+18588>>2],t+16|0,s,h,0,0,o,o,o,0);break u}if(f=0,i[F+28>>2]==2)break o;f=!v2(A,i[t+18572>>2]+149|0)}if(A=i[n+168>>2],e=_-A|0,(e|0)!=31)for(r=h>>A,e=1<<e,F=r+e|0,X=f<<8,A=s>>A,V=A+e|0;;){for(e=A;w=(i[n+160>>2]+G(e,3)|0)+G(G(i[n+172>>2],r),3)|0,B=X|(l[w|0]|l[w+1|0]<<8)&64767,u[w|0]=B,u[w+1|0]=B>>>8,e=e+1|0,(V|0)>(e|0););if(r=r+1|0,!((F|0)>(r|0)))break}B=!f;o:{l:{if(f){w=i[i[t+18588>>2]+124>>2],A=0,r=t+18548|0;s:{if(v2(r,i[t+18572>>2]+8|0))break s;e=v2(r,i[t+18572>>2]+9|0);w:{_:{if((_|0)>i[w+16872>>2]){if(A=e?1:2,!l[w+8798|0]||v2(r,i[t+18572>>2]+11|0))break s;if(A=k4(r),!(!e|!A)){A=5;break s}if(!(A|!e)){A=4;break s}if(A|e)break _;A=6;break s}if(A=1,e)break s;if((_|0)!=3)break w;A=2;break s}if(!(!A|e)){A=7;break s}D0(12200,18297,1774,15091),H()}A=3-v2(r,i[t+18572>>2]+10|0)|0}break l}if(e=0,w=0,(_|0)!=i[Q+16872>>2])break o;A=v2(t+18548|0,i[t+18572>>2]+8|0)?0:3}e=A,w=(A|0)==3&B}if(r=i[n+168>>2],A=s>>r,(A|0)<0||(B=i[n+172>>2],(B|0)<=(A|0)))break n;if(r=h>>r,(r|0)<0|(r|0)>=i[n+176>>2])break k;A=(i[n+160>>2]+G(A,3)|0)+G(G(r,B),3)|0,r=(l[A|0]|l[A+1|0]<<8)&65479|e<<3&56,u[A|0]=r,u[A+1|0]=r>>>8;o:{if(!f){l:{if(!l[Q+8800|0]|e|((_|0)<i[Q+16956>>2]|(_|0)>i[Q+16960>>2])||!NA(t+18548|0))break l;if(A=i[n+168>>2],e=_-A|0,(e|0)!=31)for(r=h>>A,e=1<<e,w=r+e|0,f=e,e=s>>A,o=f+e|0;;){for(A=e;f=(i[n+160>>2]+G(A,3)|0)+G(G(i[n+172>>2],r),3)|0,k=(l[f|0]|l[f+1|0]<<8)&64511|1024,u[f|0]=k,u[f+1|0]=k>>>8,A=A+1|0,(o|0)>(A|0););if(r=r+1|0,!((w|0)>(r|0)))break}if(e=i[n+148>>2],A=s>>e,(A|0)<0||(r=i[n+152>>2],(r|0)<=(A|0)))break n;if(e=h>>e,(e|0)<0|(e|0)>=i[n+156>>2])break k;u[((i[n+140>>2]+G(A,24)|0)+G(G(e,r),24)|0)+22|0]=1,r=0,k=v-32|0,v=k,A=i[t+18552>>2],i[k+8>>2]=A,e=i[t+18556>>2],i[k+24>>2]=0,i[k+16>>2]=0,i[k+20>>2]=0,i[k+12>>2]=e-A,A=1<<_,e=i[t+18588>>2],w=i[e+40>>2],n=G(w,h),o=i[e+4>>2],e=i[e+124>>2],f=u[e+8801|0],e=i[e+16832>>2];s:{if((e|0)>=9){if((_|0)==31)break s;for(e=e-f|0,B=(e|0)>0?e:0,n=o+(n+s<<1)|0;;){for(o=n+(G(r,w)<<1)|0,e=0;A0=o+(e<<1)|0,n0=v0(k+8|0,f)<<B,g[A0>>1]=n0,e=e+1|0,(A|0)!=(e|0););if(r=r+1|0,(A|0)==(r|0))break}break s}if((_|0)==31)break s;for(e=e-f|0,B=(e|0)>0?e:0,n=n+(o+s|0)|0;;){for(o=n+G(r,w)|0,e=0;A0=e+o|0,n0=v0(k+8|0,f)<<B,u[A0|0]=n0,e=e+1|0,(A|0)!=(e|0););if(r=r+1|0,(A|0)==(r|0))break}}w=i[t+18588>>2],f=i[w+124>>2];s:{if(!i[f+16848>>2])break s;if(A=i[f+16852>>2],B=(s|0)/(A|0)|0,Q=1<<_,_=i[f+16856>>2],r=(Q|0)/(_|0)|0,e=(Q|0)/(A|0)|0,o=i[w+44>>2],A=G(o,(h|0)/(_|0)|0),F=i[w+8>>2],_=u[f+8802|0],n=i[f+16840>>2],(n|0)>=9){if(f=0,n=n-_|0,n=(n|0)>0?n:0,A=A+B<<1,!((e|0)<=0|(r|0)<=0)){for(w=A+F|0;;){for(B=w+(G(f,o)<<1)|0,A=0;A0=B+(A<<1)|0,n0=v0(k+8|0,_)<<n,g[A0>>1]=n0,A=A+1|0,(e|0)!=(A|0););if(f=f+1|0,(f|0)==(r|0))break}w=i[t+18588>>2],A=i[w+124>>2],_=u[A+8802|0],e=i[A+16840>>2]-_|0,n=(e|0)>0?e:0,o=i[w+44>>2],e=i[A+16856>>2],f=i[A+16852>>2],A=G(o,(h|0)/(e|0)|0)+((s|0)/(f|0)|0)<<1,r=(Q|0)/(e|0)|0,e=(Q|0)/(f|0)|0}if((e|0)<=0|(r|0)<=0)break s;for(s=i[w+12>>2]+A|0,f=0;;){for(h=s+(G(f,o)<<1)|0,A=0;A0=h+(A<<1)|0,n0=v0(k+8|0,_)<<n,g[A0>>1]=n0,A=A+1|0,(e|0)!=(A|0););if(f=f+1|0,(f|0)==(r|0))break}break s}if(f=0,n=n-_|0,n=(n|0)>0?n:0,!((e|0)<=0|(r|0)<=0)){for(w=(B+F|0)+A|0;;){for(B=w+G(f,o)|0,A=0;A0=A+B|0,n0=v0(k+8|0,_)<<n,u[A0|0]=n0,A=A+1|0,(e|0)!=(A|0););if(f=f+1|0,(f|0)==(r|0))break}w=i[t+18588>>2],A=i[w+124>>2],_=u[A+8802|0],e=i[A+16840>>2]-_|0,n=(e|0)>0?e:0,e=i[A+16852>>2],B=(s|0)/(e|0)|0,A=i[A+16856>>2],r=(Q|0)/(A|0)|0,e=(Q|0)/(e|0)|0,o=i[w+44>>2],A=G(o,(h|0)/(A|0)|0)}if((e|0)<=0|(r|0)<=0)break s;for(s=(i[w+12>>2]+B|0)+A|0,f=0;;){for(h=s+G(f,o)|0,A=0;A0=A+h|0,n0=v0(k+8|0,_)<<n,u[A0|0]=n0,A=A+1|0,(e|0)!=(A|0););if(f=f+1|0,(f|0)==(r|0))break}}gl(k+8|0),i[t+18552>>2]=i[k+8>>2],Ze(t+18548|0),v=k+32|0;break u}if(B=(e|0)==3,F=B?(o|0)/2|0:o,(_|0)!=31)for(r=t+18548|0,e=0,f=0;;){for(A=0;A0=(m+48|0)+(e<<2)|0,n0=v2(r,i[t+18572>>2]+12|0),i[A0>>2]=n0,e=e+1|0,A=A+F|0,(o|0)>(A|0););if(f=f+F|0,!((o|0)>(f|0)))break}f=s-1|0,A=0;l:{if((f|h)<0||(e=i[n+124>>2],A=0,(s|0)>i[e+484>>2])||(A=0,(h|0)>=i[e+488>>2])||(A=i[e+16892>>2],e=i[e+16876>>2],r=G(A,h>>e),X=i[n+140>>2],k=r+(s>>e)|0,e=r+(f>>e)|0,A=0,C[X+G(k,24)>>1]!=C[X+G(e,24)>>1]))break l;A=i[i[n+132>>2]+8484>>2],A=i[A+(k<<2)>>2]==i[A+(e<<2)>>2]}k=A,f=h-1|0;l:{if((f|s)<0||(A=i[n+124>>2],(s|0)>=i[A+484>>2]|(h|0)>i[A+488>>2])||(e=i[A+16876>>2],r=s>>e,V=i[n+140>>2],A=i[A+16892>>2],X=r+G(A,h>>e)|0,A=r+G(A,f>>e)|0,C[V+G(X,24)>>1]!=C[V+G(A,24)>>1]))break l;e=i[i[n+132>>2]+8484>>2],$=i[e+(X<<2)>>2]==i[e+(A<<2)>>2]}if(V=_-B|0,(_|0)!=31)for(S=t+18548|0,B=0;;){for(X=h+B|0,f0=(B|0)>0|$,I=0;;){E=O<<2,P=i[E+(m+48|0)>>2];l:{if(P){f=we(S,2),A=m+32|0;break l}f=F8(S,5),A=m+16|0}i[A+E>>2]=f,r=s+I|0,z=r,A=i[Q+16944>>2],R=G(i[Q+16948>>2],X>>A)+(r>>A)|0,f=R,M=i[n+124>>2],e=1,A=1;l:{if(!((I|0)>0|k))break l;if(A=i[n+168>>2],r=r-1>>A,(r|0)<0||(a=i[n+172>>2],(a|0)<=(r|0)))break A;if(N=X>>A,(N|0)<0|(N|0)>=i[n+176>>2])break f;if(A=1,l[((i[n+160>>2]+G(r,3)|0)+G(G(N,a),3)|0)+1|0]&7)break l;A=l[(f+i[n+200>>2]|0)-1|0]}l:{if(!f0)break l;if(N=i[n+168>>2],r=z>>N,(r|0)<0||(z=i[n+172>>2],(z|0)<=(r|0)))break A;if(N=X-1>>N,(N|0)<0|(N|0)>=i[n+176>>2])break f;if(l[((i[n+160>>2]+G(r,3)|0)+G(G(N,z),3)|0)+1|0]&7|(X|0)==(X&-1<<i[M+16876>>2]))break l;e=l[i[n+200>>2]+(f-i[M+16948>>2]|0)|0]}l:{if((A|0)==(e|0)){if(A>>>0<=1){i[m+12>>2]=26,i[m+4>>2]=0,i[m+8>>2]=1;break l}i[m+4>>2]=A,i[m+12>>2]=(A-1&31)+2,i[m+8>>2]=(A+29&31)+2;break l}if(i[m+8>>2]=e,i[m+4>>2]=A,!(!A|!e)){i[m+12>>2]=0;break l}if(!((A|0)==1|(e|0)==1)){i[m+12>>2]=1;break l}i[m+12>>2]=26}l:{if((P|0)!=1){A=i[m+4>>2],r=i[m+8>>2],e=(A|0)>(r|0)?A:r,A=(A|0)<(r|0)?A:r,r=i[m+12>>2];s:{if((A|0)<=(r|0)){f=A,A=r;break s}i[m+12>>2]=A,i[m+4>>2]=r,f=r}s:{if((A|0)>=(e|0)){r=A,A=e;break s}i[m+8>>2]=A,r=e}e=A,A=i[E+(m+16|0)>>2],A=((A|0)>=(f|0))+A|0,A=((e|0)<=(A|0))+A|0,f=((A|0)>=(r|0))+A|0;break l}f=i[(m+4|0)+(i[E+(m+32|0)>>2]<<2)>>2]}if(E=i[n+208>>2],A=V-E|0,(A|0)!=31)for(M=1<<A,N=M&2147483646,A=0;;){if(e=0,r=0,(V|0)!=(E|0))for(;u[((i[n+200>>2]+R|0)+e|0)+G(i[n+212>>2],A)|0]=f,u[(((i[n+200>>2]+R|0)+e|0)+G(i[n+212>>2],A)|0)+1|0]=f,e=e+2|0,r=r+2|0,(N|0)!=(r|0););if((V|0)==(E|0)&&(u[((i[n+200>>2]+R|0)+e|0)+G(i[n+212>>2],A)|0]=f),A=A+1|0,(M|0)==(A|0))break}if(O=O+1|0,I=F+I|0,!((o|0)>(I|0)))break}if(B=B+F|0,!((o|0)>(B|0)))break}l:switch(i[Q+16848>>2]){case 3:if((_|0)==31)break o;f=t+18548|0,r=0;s:{for(;;){k=r+h|0,B=0;w:{for(;;){if(v2(f,i[t+18572>>2]+13|0)?A=F8(f,2):A=4,E=s+B|0,X=i[n+208>>2],e=E>>X,(e|0)<0||(R=i[n+212>>2],(R|0)<=(e|0)))break w;if(I=k>>X,(I|0)<0|(I|0)>=i[n+216>>2])break f;if(e=l[(e+i[n+200>>2]|0)+G(I,R)|0],e=e>>>0<=34?e:0,I=(A|0)==4,I||(A=i[(A<<2)+63568>>2],e=(A|0)==(e|0)?34:A),A=V-X|0,(A|0)!=31)for(I=I?e|-128:e,e=i[n+124>>2],X=i[e+16944>>2],E=G(k>>X,i[e+16948>>2])+(E>>X)|0,X=1<<A,A=0;;){for(e=0;;){if(R=i[n+124>>2],i[R+16948>>2]<=(e|0))break r;if(i[R+16952>>2]<=(A|0))break e;if(R=(e+E|0)+G(i[n+232>>2],A)|0,(R|0)>=i[n+224>>2])break s;if(u[R+i[n+220>>2]|0]=I,e=e+1|0,(X|0)==(e|0))break}if(A=A+1|0,(X|0)==(A|0))break}if(B=B+F|0,!((o|0)>(B|0)))break}if(r=r+F|0,(o|0)>(r|0))continue;break o}break}break A}break i;case 0:break o;default:break l}if(A=t+18548|0,v2(A,i[t+18572>>2]+13|0)?A=F8(A,2):A=4,r=i[n+208>>2],e=s>>r,(e|0)<0||(f=i[n+212>>2],(f|0)<=(e|0)))break A;if(r=h>>r,(r|0)<0|(r|0)>=i[n+216>>2])break f;if(e=l[(e+i[n+200>>2]|0)+G(r,f)|0],e=e>>>0<=34?e:0,(A|0)!=4&&(r=i[(A<<2)+63568>>2],e=(e|0)==(r|0)?34:r),e=i[Q+16848>>2]==2?l[e+63584|0]:e,A=(A|0)==4,r=_-i[n+208>>2]|0,(r|0)!=31)for(f=i[n+124>>2],k=i[f+16944>>2],f=G(h>>k,i[f+16948>>2])+(s>>k)|0,k=A?e|-128:e,r=1<<r,A=0;;){for(e=0;;){if(o=i[n+124>>2],i[o+16948>>2]<=(e|0))break r;if(i[o+16952>>2]<=(A|0))break e;if(o=(e+f|0)+G(i[n+232>>2],A)|0,(o|0)>=i[n+224>>2])break i;if(u[o+i[n+220>>2]|0]=k,e=e+1|0,(r|0)==(e|0))break}if(A=A+1|0,(r|0)==(A|0))break}break o}l:{s:{w:switch(e|0){case 1:A=(o|0)/2|0,_4(t,s,h,0,0,o,A,k,o,0),_4(t,s,h,0,A,o,A,k,o,1);break s;case 2:A=(o|0)/2|0,_4(t,s,h,0,0,A,o,k,o,0),_4(t,s,h,A,0,A,o,k,o,1);break s;case 4:A=(o|0)/4|0,_4(t,s,h,0,0,o,A,k,o,0),_4(t,s,h,0,A,o,(3<<_)/4|0,k,o,1);break s;case 5:A=(3<<_)/4|0,_4(t,s,h,0,0,o,A,k,o,0),_4(t,s,h,0,A,o,(o|0)/4|0,k,o,1);break s;case 6:A=(o|0)/4|0,_4(t,s,h,0,0,A,o,k,o,0),_4(t,s,h,A,0,(3<<_)/4|0,o,k,o,1);break s;case 7:A=(3<<_)/4|0,_4(t,s,h,0,0,A,o,k,o,0),_4(t,s,h,A,0,(o|0)/4|0,o,k,o,1);break s;case 3:A=(o|0)/2|0,_4(t,s,h,0,0,A,A,k,o,0),_4(t,s,h,A,0,A,A,k,o,1),_4(t,s,h,0,A,A,A,k,o,2),_4(t,s,h,A,A,A,A,k,o,3);break s;default:D0(22181,18297,4544,3864),H();case 0:break w}if(_4(t,s,h,0,0,o,o,k,o,0),l[t+26|0]&16)break l}if(!v2(t+18548|0,i[t+18572>>2]+153|0))break u}A=i[Q+16848>>2]!=0,Pi(t,s,h,s,h,s,h,_,0,0,i[Q+628>>2],w,1,A,A);break u}A=i[Q+16848>>2]!=0,Pi(t,s,h,s,h,s,h,_,0,0,w+i[Q+632>>2]|0,w,0,A,A)}v=m- -64|0}return}D0(4656,10893,128,4231),H()}D0(4618,10893,129,4231),H()}D0(4656,10893,118,4231),H()}D0(4618,10893,119,4231),H()}D0(6129,10893,690,19913),H()}D0(6104,10893,691,19913),H()}D0(11452,10893,694,19913),H()}function j_(A,e,r,f,k,n,t){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,t=t|0;var o=0,s=0,w=0,h=0,_=0,B=0,m=0,X=0,Q=0,V=0,F=0,I=0,E=0,R=0,N=0,M=0,z=0,S=0,O=0,P=0,a=0,$=0,f0=0,A0=0,n0=0,_0=0,m0=0,X0=0,g0=0,I0=0,e0=0,r0=0,N0=0,U0=0,M0=0,H0=0,P0=0,K0=0,$0=0,L0=0,d0=0,n2=0,Z2=0,Q2=0,g2=0,p2=0;f=v-16|0,v=f,i[f+8>>2]=0,i[f+12>>2]=0,i[f+4>>2]=f+8,k=f+4|0,t8(k,i[t>>2],t+4|0),n=A,f0=r,o=v-112|0,v=o,F=e,s=i[e+116>>2],A0=k+4|0,t=A0,A=t,e=i[k+4>>2];i:{e:{r:{if(!e)break r;for(A=e;r=s>>>0>u0[A+16>>2],t=r?t:A,A=i[(r?4:0)+A>>2],!!A;);if(!((t|0)==(A0|0)|s>>>0<u0[t+16>>2])){r=p(32),i[o>>2]=r,i[o+4>>2]=28,i[o+8>>2]=-2147483616,A=l[5952]|l[5953]<<8|(l[5954]<<16|l[5955]<<24),u[r+24|0]=A,u[r+25|0]=A>>>8,u[r+26|0]=A>>>16,u[r+27|0]=A>>>24,e=l[5948]|l[5949]<<8|(l[5950]<<16|l[5951]<<24),A=l[5944]|l[5945]<<8|(l[5946]<<16|l[5947]<<24),u[r+16|0]=A,u[r+17|0]=A>>>8,u[r+18|0]=A>>>16,u[r+19|0]=A>>>24,u[r+20|0]=e,u[r+21|0]=e>>>8,u[r+22|0]=e>>>16,u[r+23|0]=e>>>24,e=l[5940]|l[5941]<<8|(l[5942]<<16|l[5943]<<24),A=l[5936]|l[5937]<<8|(l[5938]<<16|l[5939]<<24),u[r+8|0]=A,u[r+9|0]=A>>>8,u[r+10|0]=A>>>16,u[r+11|0]=A>>>24,u[r+12|0]=e,u[r+13|0]=e>>>8,u[r+14|0]=e>>>16,u[r+15|0]=e>>>24,e=l[5932]|l[5933]<<8|(l[5934]<<16|l[5935]<<24),A=l[5928]|l[5929]<<8|(l[5930]<<16|l[5931]<<24),u[r|0]=A,u[r+1|0]=A>>>8,u[r+2|0]=A>>>16,u[r+3|0]=A>>>24,u[r+4|0]=e,u[r+5|0]=e>>>8,u[r+6|0]=e>>>16,u[r+7|0]=e>>>24,u[r+28|0]=0,r=q(o+48|0,2,0,o),A=i[r+4>>2],i[n>>2]=i[r>>2],i[n+4>>2]=A,e=n+8|0;f:{if(u[r+19|0]>=0){A=i[r+12>>2],i[e>>2]=i[r+8>>2],i[e+4>>2]=A,i[e+8>>2]=i[r+16>>2],u[n+20|0]=1;break f}if(T(e,i[r+8>>2],i[r+12>>2]),A=u[r+19|0],u[n+20|0]=1,(A|0)>=0)break f;Z(i[r+8>>2])}if(u[o+11|0]>=0)break i;Z(i[o>>2]);break i}for(;;){if(A=e,e=i[e+16>>2],e>>>0>s>>>0){if(t=A,e=i[t>>2],e)continue;break r}if(e>>>0>=s>>>0)break e;if(e=i[A+4>>2],!e)break}t=A+4|0}e=p(20),i[e+8>>2]=A,i[e>>2]=0,i[e+4>>2]=0,i[e+16>>2]=s,i[t>>2]=e,A=i[i[k>>2]>>2],A&&(i[k>>2]=A),m1(i[k+4>>2],e),i[k+8>>2]=i[k+8>>2]+1}s=i[F+460>>2],t=i[F+464>>2],di(o+80|0,i[F+100>>2]- -64|0,s,t);e:{if(i[o+80>>2]){A=i[o+84>>2],i[n>>2]=i[o+80>>2],i[n+4>>2]=A,e=n+8|0;r:{if(u[o+99|0]>=0){A=i[o+92>>2],i[e>>2]=i[o+88>>2],i[e+4>>2]=A,i[e+8>>2]=i[o+96>>2];break r}T(e,i[o+88>>2],i[o+92>>2])}u[n+20|0]=1,A=0;break e}if(A=p(172),i[A+4>>2]=0,i[A+8>>2]=0,i[A>>2]=94812,o0(A+16|0,0,80),e=i[A+4>>2],r=e+1|0,i[A+4>>2]=r,i[A+104>>2]=0,i[A+108>>2]=0,i[A+36>>2]=1,i[A+40>>2]=1,u[A+24|0]=1,g[A+22>>1]=2,g[A+18>>1]=2,g[A+20>>1]=2,i[A+112>>2]=0,i[A+116>>2]=4740,i[A+140>>2]=0,i[A+144>>2]=0,i[A+128>>2]=99,i[A+132>>2]=99,i[A+120>>2]=0,i[A+124>>2]=0,i[A+12>>2]=95160,i[A+148>>2]=0,i[A+152>>2]=0,i[A+136>>2]=A+140,i[A+156>>2]=0,i[A+160>>2]=0,i[A+164>>2]=0,i[A+168>>2]=0,i[A+4>>2]=e,e=i[A+8>>2],E=A+12|0,i[A+96>>2]=E,i[A+8>>2]=e+1,i[A+100>>2]=A,r||(W[i[i[A>>2]+8>>2]](A),y(A)),i[E+120>>2]=3,i[E+116>>2]=1,i[E+112>>2]=t,i[E+108>>2]=s,T0(o+48|0,E,3,s,t,8,i[F+100>>2]- -64|0),i[o+48>>2]){if(e=i[o+52>>2],i[n>>2]=i[o+48>>2],i[n+4>>2]=e,r=n+8|0,u[o+67|0]>=0){e=i[o+60>>2],i[r>>2]=i[o+56>>2],i[r+4>>2]=e,i[r+8>>2]=i[o+64>>2],u[n+20|0]=1;break e}if(T(r,i[o+56>>2],i[o+60>>2]),e=u[o+67|0],u[n+20|0]=1,(e|0)>=0)break e;Z(i[o+56>>2]);break e}if(u[o+67|0]<0&&Z(i[o+56>>2]),T0(o+48|0,E,4,s,t,8,i[F+100>>2]- -64|0),i[o+48>>2]){if(e=i[o+52>>2],i[n>>2]=i[o+48>>2],i[n+4>>2]=e,r=n+8|0,u[o+67|0]>=0){e=i[o+60>>2],i[r>>2]=i[o+56>>2],i[r+4>>2]=e,i[r+8>>2]=i[o+64>>2],u[n+20|0]=1;break e}if(T(r,i[o+56>>2],i[o+60>>2]),e=u[o+67|0],u[n+20|0]=1,(e|0)>=0)break e;Z(i[o+56>>2]);break e}if(u[o+67|0]<0&&Z(i[o+56>>2]),T0(o+48|0,E,5,s,t,8,i[F+100>>2]- -64|0),i[o+48>>2]){if(e=i[o+52>>2],i[n>>2]=i[o+48>>2],i[n+4>>2]=e,r=n+8|0,u[o+67|0]>=0){e=i[o+60>>2],i[r>>2]=i[o+56>>2],i[r+4>>2]=e,i[r+8>>2]=i[o+64>>2],u[n+20|0]=1;break e}if(T(r,i[o+56>>2],i[o+60>>2]),e=u[o+67|0],u[n+20|0]=1,(e|0)>=0)break e;Z(i[o+56>>2]);break e}u[o+67|0]<0&&Z(i[o+56>>2]),m=o+48|0,w=C[F+450>>1],V=C[F+452>>1],X=C[F+454>>1],s=C[F+456>>1],_=v-16|0,v=_;r:{f:{if(h=i[E+128>>2],!h)break f;for(e=E+128|0,r=e;t=i[h+16>>2]<3,r=t?r:h,h=i[(t?4:0)+h>>2],!!h;);if((e|0)==(r|0)|i[r+16>>2]>=4)break f;R=V>>>8|0,V=X>>>8|0,X=s>>>8|0,s=w>>>8|0;A:{if(l[r+24|0]!=8)break A;if(t=G(i[r+56>>2],i[r+32>>2]),t&&o0(i[r+44>>2],s,t),h=i[e>>2],!h)break f;for(r=e;t=i[h+16>>2]<4,r=t?r:h,h=i[(t?4:0)+h>>2],!!h;);if((e|0)==(r|0)|i[r+16>>2]>4)break f;if(l[r+24|0]!=8)break A;if(t=G(i[r+56>>2],i[r+32>>2]),t&&o0(i[r+44>>2],R,t),h=i[e>>2],!h)break f;for(r=e;t=i[h+16>>2]<5,r=t?r:h,h=i[(t?4:0)+h>>2],!!h;);if((e|0)==(r|0)|i[r+16>>2]>5)break f;if(l[r+24|0]!=8)break A;t=G(i[r+56>>2],i[r+32>>2]),t&&o0(i[r+44>>2],V,t),h=i[e>>2];k:{if(!h)break k;for(r=e;t=i[h+16>>2]<6,r=t?r:h,h=i[(t?4:0)+h>>2],!!h;);if((e|0)==(r|0)|i[r+16>>2]>6)break k;if(l[r+24|0]!=8)break A;if(e=G(i[r+56>>2],i[r+32>>2]),!e)break k;o0(i[r+44>>2],X,e)}if(e=i[26917],i[m>>2]=i[26916],i[m+4>>2]=e,r=m+8|0,u[107683]>=0){e=i[26919],i[r>>2]=i[26918],i[r+4>>2]=e,i[r+8>>2]=i[26920];break r}T(r,i[26918],i[26919]);break r}if(e=p(56),i[_+4>>2]=e,i[_+8>>2]=52,i[_+12>>2]=-2147483592,t=l[9929]|l[9930]<<8|(l[9931]<<16|l[9932]<<24),r=l[9925]|l[9926]<<8|(l[9927]<<16|l[9928]<<24),u[e|0]=r,u[e+1|0]=r>>>8,u[e+2|0]=r>>>16,u[e+3|0]=r>>>24,u[e+4|0]=t,u[e+5|0]=t>>>8,u[e+6|0]=t>>>16,u[e+7|0]=t>>>24,u[e+52|0]=0,r=l[9973]|l[9974]<<8|(l[9975]<<16|l[9976]<<24),u[e+48|0]=r,u[e+49|0]=r>>>8,u[e+50|0]=r>>>16,u[e+51|0]=r>>>24,t=l[9969]|l[9970]<<8|(l[9971]<<16|l[9972]<<24),r=l[9965]|l[9966]<<8|(l[9967]<<16|l[9968]<<24),u[e+40|0]=r,u[e+41|0]=r>>>8,u[e+42|0]=r>>>16,u[e+43|0]=r>>>24,u[e+44|0]=t,u[e+45|0]=t>>>8,u[e+46|0]=t>>>16,u[e+47|0]=t>>>24,t=l[9961]|l[9962]<<8|(l[9963]<<16|l[9964]<<24),r=l[9957]|l[9958]<<8|(l[9959]<<16|l[9960]<<24),u[e+32|0]=r,u[e+33|0]=r>>>8,u[e+34|0]=r>>>16,u[e+35|0]=r>>>24,u[e+36|0]=t,u[e+37|0]=t>>>8,u[e+38|0]=t>>>16,u[e+39|0]=t>>>24,t=l[9953]|l[9954]<<8|(l[9955]<<16|l[9956]<<24),r=l[9949]|l[9950]<<8|(l[9951]<<16|l[9952]<<24),u[e+24|0]=r,u[e+25|0]=r>>>8,u[e+26|0]=r>>>16,u[e+27|0]=r>>>24,u[e+28|0]=t,u[e+29|0]=t>>>8,u[e+30|0]=t>>>16,u[e+31|0]=t>>>24,t=l[9945]|l[9946]<<8|(l[9947]<<16|l[9948]<<24),r=l[9941]|l[9942]<<8|(l[9943]<<16|l[9944]<<24),u[e+16|0]=r,u[e+17|0]=r>>>8,u[e+18|0]=r>>>16,u[e+19|0]=r>>>24,u[e+20|0]=t,u[e+21|0]=t>>>8,u[e+22|0]=t>>>16,u[e+23|0]=t>>>24,t=l[9937]|l[9938]<<8|(l[9939]<<16|l[9940]<<24),r=l[9933]|l[9934]<<8|(l[9935]<<16|l[9936]<<24),u[e+8|0]=r,u[e+9|0]=r>>>8,u[e+10|0]=r>>>16,u[e+11|0]=r>>>24,u[e+12|0]=t,u[e+13|0]=t>>>8,u[e+14|0]=t>>>16,u[e+15|0]=t>>>24,q(m,4,0,_+4|0),u[_+15|0]>=0)break r;Z(i[_+4>>2]);break r}if(u[_+4|0]=0,u[_+15|0]=0,q(m,5,2002,_+4|0),u[_+15|0]>=0)break r;Z(i[_+4>>2])}if(v=_+16|0,r=i[o+52>>2],e=i[o+48>>2],i[o+80>>2]=e,i[o+84>>2]=r,u[o+99|0]<0&&(Z(i[o+88>>2]),e=i[o+80>>2]),r=i[o+60>>2],i[o+88>>2]=i[o+56>>2],i[o+92>>2]=r,i[o+96>>2]=i[o- -64>>2],!e){r:{f:{A:{if(r=i[F+480>>2],(r|0)!=i[F+484>>2])for(Q=n+8|0,M0=f0+28|0,X0=i[25382],g0=i[25383],H0=o+40|0,e=0;;){if(t=i[(e<<2)+r>>2],(t|0)==i[F+116>>2]){r=d2(o,24442),t=q(o+48|0,2,0,r),e=i[t+4>>2],i[n>>2]=i[t>>2],i[n+4>>2]=e;k:{if(u[t+19|0]>=0){e=i[t+12>>2],i[Q>>2]=i[t+8>>2],i[Q+4>>2]=e,i[Q+8>>2]=i[t+16>>2],u[n+20|0]=1;break k}if(T(Q,i[t+8>>2],i[t+12>>2]),e=u[t+19|0],u[n+20|0]=1,(e|0)>=0)break k;Z(i[t+8>>2])}if(u[r+11|0]>=0)break e;Z(i[r>>2]);break e}if(r=o+48|0,r4(r,i[F+100>>2],t,1),t=i[o+48>>2],i[o+72>>2]=t,i[o+76>>2]=i[o+52>>2],!t){e=r,r=d2(o,24397),t=q(e,2,2e3,r),e=i[t+4>>2],i[n>>2]=i[t>>2],i[n+4>>2]=e;k:{if(u[t+19|0]>=0){e=i[t+12>>2],i[Q>>2]=i[t+8>>2],i[Q+4>>2]=e,i[Q+8>>2]=i[t+16>>2],u[n+20|0]=1;break k}if(T(Q,i[t+8>>2],i[t+12>>2]),e=u[t+19|0],u[n+20|0]=1,(e|0)>=0)break k;Z(i[t+8>>2])}if(u[r+11|0]>=0)break r;Z(i[r>>2]);break r}if(W[i[i[t>>2]+52>>2]](o+48|0,t),i[o+48>>2]){if(e=i[o+52>>2],i[n>>2]=i[o+48>>2],i[n+4>>2]=e,u[o+67|0]>=0){e=i[o+60>>2],i[Q>>2]=i[o+56>>2],i[Q+4>>2]=e,i[Q+8>>2]=i[o+64>>2],u[n+20|0]=1;break r}if(T(Q,i[o+56>>2],i[o+60>>2]),e=u[o+67|0],u[n+20|0]=1,(e|0)>=0)break r;Z(i[o+56>>2]);break r}if(u[o+67|0]<0&&Z(i[o+56>>2]),i[o+40>>2]=0,i[o+44>>2]=0,i[o+36>>2]=H0,s=i[o+72>>2],r=o+36|0,t8(r,i[k>>2],A0),t=o+48|0,W[i[i[s>>2]+100>>2]](t,s,f0,0,0,0,r),Y1(r,i[o+40>>2]),r=l[o+68|0],r){if((r|0)!=1)break f;D6(n,t),r=l[o+68|0],(r|0)!=255&&(e=i[25383],i[o>>2]=i[25382],i[o+4>>2]=e,W[i[o+(r<<2)>>2]](o+104|0,t)),I2(o+72|0);break e}if(r=i[o+48>>2],i[o+28>>2]=r,t=i[o+52>>2],i[o+32>>2]=t,t&&(i[t+4>>2]=i[t+4>>2]+1),!(i[r+116>>2]==1&i[r+120>>2]==3)){u[o+110|0]=1,g[o+108>>1]=2,g[o+104>>1]=2,g[o+106>>1]=2,r6(o,o+28|0,1,3,o+104|0,0,M0,i[f0+48>>2],i[F+100>>2]- -64|0),t=l[o+20|0];k:{if(t){if((t|0)!=1)break f;if(r=i[o+4>>2],i[n>>2]=i[o>>2],i[n+4>>2]=r,u[o+19|0]>=0){r=i[o+12>>2],i[Q>>2]=i[o+8>>2],i[Q+4>>2]=r,i[Q+8>>2]=i[o+16>>2],u[n+20|0]=1;break k}T(Q,i[o+8>>2],i[o+12>>2]),u[n+20|0]=1;break k}if(r=i[o+4>>2],r&&(i[r+4>>2]=i[r+4>>2]+1),i[o+28>>2]=i[o>>2],s=i[o+32>>2],i[o+32>>2]=r,!s||(r=i[s+4>>2],i[s+4>>2]=r-1,r))break k;W[i[i[s>>2]+8>>2]](s),y(s)}if(r=l[o+20|0],(r|0)!=255&&(i[o+104>>2]=X0,i[o+108>>2]=g0,W[i[(o+104|0)+(r<<2)>>2]](o+103|0,o)),t)break A}if(r=i[F+468>>2]+G(e,12)|0,z=i[r+4>>2],N=i[r+8>>2],I0=0,I=v-16|0,v=I,t=i[o+28>>2],P=I+8|0,i[I+4>>2]=P,i[I+8>>2]=0,i[I+12>>2]=0,s=i[t+124>>2],V=t+128|0,(s|0)!=(V|0)){for(;;){R=i[s+16>>2],X=P,r=X,t=i[I+8>>2];k:{n:{if(!t)break n;for(;;){if(r=t,t=i[r+16>>2],(t|0)>(R|0)){if(X=r,t=i[r>>2],t)continue;break n}if((t|0)>=(R|0))break k;if(t=i[r+4>>2],!t)break}X=r+4|0}t=p(20),i[t+8>>2]=r,i[t>>2]=0,i[t+4>>2]=0,i[t+16>>2]=R,i[X>>2]=t,r=i[i[I+4>>2]>>2],r&&(i[I+4>>2]=r),m1(i[I+8>>2],t),i[I+12>>2]=i[I+12>>2]+1}t=i[s+4>>2];k:{if(t){for(;;)if(r=t,t=i[r>>2],!t)break k}for(;r=i[s+8>>2],t=i[r>>2]!=(s|0),s=r,!!t;);}if(s=r,(r|0)==(V|0))break}t=i[o+28>>2]}r=i[t+128>>2];k:{if(!r){e0=1;break k}for(X=t+128|0,s=X,t=r;V=i[t+16>>2]<6,s=V?s:t,t=i[(V?4:0)+t>>2],!!t;);for(e0=(s|0)==(X|0)|i[s+16>>2]>6,t=X;s=i[r+16>>2]<6,t=s?t:r,r=i[(s?4:0)+r>>2],!!r;);if((t|0)==(X|0)|i[t+16>>2]>6)break k;I0=i[t+44>>2]}k:{n:{if(X=i[I+4>>2],(P|0)==(X|0)||(t=i[E+128>>2],!t))break n;for(r0=0-z|0,a=(z|0)>=0,$=a?0:r0,P0=a?0:z,K0=a?z:0,V=E+128|0,$0=N>>31,L0=z>>31,d0=N+1|0,N0=0-N|0,n0=(N|0)>=0,R=n0?0:N0,_0=n0?0:N,n2=R-_0|0,Z2=R+1|0,Q2=N+R|0,g2=_0-R|0;;){t:{if(!t)break t;for(B=i[X+16>>2],s=V,r=t;w=(B|0)>i[r+16>>2],s=w?s:r,r=i[(w?4:0)+r>>2],!!r;);if((s|0)==(V|0)|(B|0)<i[s+16>>2])break t;r=i[o+28>>2],m=r+128|0,w=m;u:{o:{if(s=i[r+128>>2],r=s,!r)break o;for(;_=(B|0)>i[r+16>>2],w=_?w:r,r=i[(_?4:0)+r>>2],!!r;);if((w|0)==(m|0))break o;if(S=0,r=0,(B|0)<i[w+16>>2])break u;S=i[w+56>>2],r=i[w+44>>2];break u}S=0,r=0}for(U0=r,w=V,r=t;_=(B|0)>i[r+16>>2],w=_?w:r,r=i[(_?4:0)+r>>2],!!r;);_=0;u:{if((w|0)==(V|0)){O=0,h=0;break u}if(O=0,h=0,(B|0)<i[w+16>>2])break u;O=i[w+56>>2],h=i[w+44>>2]}w=m,r=s,M=0;u:{if(!r)break u;for(;M=(B|0)>i[r+16>>2],w=M?w:r,r=i[(M?4:0)+r>>2],!!r;);for(_=(w|0)==(m|0)|(B|0)<i[w+16>>2]?_:i[w+28>>2],r=m;w=(B|0)>i[s+16>>2],r=w?r:s,s=i[(w?4:0)+s>>2],!!s;);if(M=0,(r|0)==(m|0)|(B|0)<i[r+16>>2])break u;M=i[r+32>>2]}for(s=V,r=t;w=(B|0)>i[r+16>>2],s=w?s:r,r=i[(w?4:0)+r>>2],!!r;);for(w=0,w=(s|0)==(V|0)|(B|0)<i[s+16>>2]?w:i[s+28>>2],r=V;s=(B|0)>i[t+16>>2],r=s?r:t,t=i[(s?4:0)+t>>2],!!t;);if(s=0,s=(r|0)==(V|0)|(B|0)<i[r+16>>2]?s:i[r+32>>2],!((z|0)<=0|w>>>0>z>>>0)){if(r=i[26917],i[o>>2]=i[26916],i[o+4>>2]=r,t=o+8|0,u[107683]>=0){r=i[26919],i[t>>2]=i[26918],i[t+4>>2]=r,i[t+8>>2]=i[26920];break k}T(t,i[26918],i[26919]);break k}if(!(_>>>0>r0>>>0|a)){if(r=i[26917],i[o>>2]=i[26916],i[o+4>>2]=r,t=o+8|0,u[107683]>=0){r=i[26919],i[t>>2]=i[26918],i[t+4>>2]=r,i[t+8>>2]=i[26920];break k}T(t,i[26918],i[26919]);break k}if(!((N|0)<=0|s>>>0>N>>>0)){if(r=i[26917],i[o>>2]=i[26916],i[o+4>>2]=r,t=o+8|0,u[107683]>=0){r=i[26919],i[t>>2]=i[26918],i[t+4>>2]=r,i[t+8>>2]=i[26920];break k}T(t,i[26918],i[26919]);break k}if(!(M>>>0>N0>>>0|n0)){if(r=i[26917],i[o>>2]=i[26916],i[o+4>>2]=r,t=o+8|0,u[107683]>=0){r=i[26919],i[t>>2]=i[26918],i[t+4>>2]=r,i[t+8>>2]=i[26920];break k}T(t,i[26918],i[26919]);break k}if(r=$0,m0=s-N|0,m=M,t=m+N|0,r=t>>>0<N>>>0?r+1|0:r,(r|0)>0?r=1:r=t>>>0>s>>>0&(r|0)>=0,m=r?m0:m,M=m+_0|0,M>>>0<=R>>>0)break t;if(r=L0,s=w-z|0,t=_+z|0,r=t>>>0<z>>>0?r+1|0:r,(r|0)>0?r=1:r=t>>>0>w>>>0&(r|0)>=0,B=(r?s:_)+P0|0,h=h+K0|0,e0){if(s=$+U0|0,r=R,m+g2&1&&(B&&x(G(O,Q2)+h|0,s+G(r,S)|0,B),r=Z2),(m-1|0)==(n2|0))break t;for(;t=!B,t||x(G(r+N|0,O)+h|0,s+G(r,S)|0,B),t||x(G(r+d0|0,O)+h|0,s+G(r+1|0,S)|0,B),r=r+2|0,(M|0)!=(r|0););break t}if(_=R,B>>>0<=$>>>0)break t;for(;;){for(m=G(_,S)+$|0,w=G(_+N|0,O)+h|0,r=$;t=r+w|0,m0=t,p2=l[t|0],s=r+m|0,t=l[s+I0|0],u[m0|0]=(G(p2,t^255)+G(t,l[s+U0|0])>>>0)/255,r=r+1|0,(B|0)!=(r|0););if(_=_+1|0,(M|0)==(_|0))break}}t=i[X+4>>2];t:{if(t){for(;;)if(r=t,t=i[r>>2],!t)break t}for(;r=i[X+8>>2],t=i[r>>2]!=(X|0),X=r,!!t;);}if((r|0)==(P|0))break n;t=i[V>>2],X=r}}if(r=i[26917],i[o>>2]=i[26916],i[o+4>>2]=r,t=o+8|0,u[107683]>=0){r=i[26919],i[t>>2]=i[26918],i[t+4>>2]=r,i[t+8>>2]=i[26920];break k}T(t,i[26918],i[26919])}if(Ii(I+4|0,i[I+8>>2]),v=I+16|0,t=i[o+4>>2],r=i[o>>2],i[o+80>>2]=r,i[o+84>>2]=t,u[o+99|0]<0&&(Z(i[o+88>>2]),r=i[o+80>>2]),t=i[o+12>>2],i[o+88>>2]=i[o+8>>2],i[o+92>>2]=t,i[o+96>>2]=i[o+16>>2],!(!r|(r|0)==2&i[o+84>>2]==122)){e=i[o+84>>2],i[n>>2]=i[o+80>>2],i[n+4>>2]=e;k:{if(u[o+99|0]>=0){e=i[o+92>>2],i[Q>>2]=i[o+88>>2],i[Q+4>>2]=e,i[Q+8>>2]=i[o+96>>2];break k}T(Q,i[o+88>>2],i[o+92>>2])}u[n+20|0]=1,I2(o+28|0),r=l[o+68|0],(r|0)!=255&&(e=i[25383],i[o>>2]=i[25382],i[o+4>>2]=e,W[i[o+(r<<2)>>2]](o+104|0,o+48|0)),I2(o+72|0);break e}t=i[o+32>>2];k:{if(!t||(r=i[t+4>>2],i[t+4>>2]=r-1,r))break k;W[i[i[t>>2]+8>>2]](t),y(t)}r=l[o+68|0],(r|0)!=255&&(i[o>>2]=X0,i[o+4>>2]=g0,W[i[o+(r<<2)>>2]](o+104|0,o+48|0)),t=i[o+76>>2];k:{if(!t||(r=i[t+4>>2],i[t+4>>2]=r-1,r))break k;W[i[i[t>>2]+8>>2]](t),y(t)}if(e=e+1|0,r=i[F+480>>2],!(e>>>0<i[F+484>>2]-r>>2>>>0))break}u[n+20|0]=0,i[n+4>>2]=A,i[n>>2]=E,A=0;break e}I2(o+28|0),r=l[o+68|0],(r|0)!=255&&(e=i[25383],i[o>>2]=i[25382],i[o+4>>2]=e,W[i[(r<<2)+o>>2]](o+104|0,o+48|0)),I2(o+72|0);break e}_2(),H()}I2(o+72|0);break e}e=i[o+84>>2],i[n>>2]=i[o+80>>2],i[n+4>>2]=e,r=n+8|0;r:{if(u[o+99|0]>=0){e=i[o+92>>2],i[r>>2]=i[o+88>>2],i[r+4>>2]=e,i[r+8>>2]=i[o+96>>2];break r}T(r,i[o+88>>2],i[o+92>>2])}u[n+20|0]=1}if(u[o+99|0]<0&&Z(i[o+88>>2]),!A||(e=i[A+4>>2],i[A+4>>2]=e-1,e))break i;W[i[i[A>>2]+8>>2]](A),y(A)}v=o+112|0,Y1(k,i[f+8>>2]),v=f+16|0}function q6(A,e,r,f,k,n,t,o,s,w,h){var _=0,B=0,m=0,X=0,Q=0,V=0,F=0,I=0,E=0,R=0,N=0,M=0,z=0,S=0,O=0,P=0,a=0,$=0,f0=0;_=v-192|0,v=_;i:{e:{r:{f:{A:{if(X=i[e+104>>2],e=i[e+108>>2],(X|0)!=(e|0))for(;;){if(i[X>>2]==(r|0))break A;if(X=X+32|0,(e|0)==(X|0))break}i[_+136>>2]=0,i[_+108>>2]=72196,i[_+52>>2]=72176,e=i[18053],i[_+44>>2]=e,f=i[e-12>>2],e=_+44|0,i[f+e>>2]=i[18054],i[_+48>>2]=0,f=e+i[i[_+44>>2]-12>>2]|0,k=_+56|0,J0(f,k),u[f+80|0]=0,i[f+72>>2]=0,f=i[18055],i[_+52>>2]=f,n=_+52|0,i[n+i[f-12>>2]>>2]=i[18056],f=i[18052],i[_+44>>2]=f,i[e+i[f-12>>2]>>2]=i[18057],i[_+108>>2]=72196,i[_+44>>2]=72156,i[_+52>>2]=72176,f=R0(k),i[f>>2]=71232,i[_+96>>2]=0,i[_+100>>2]=0,i[_+88>>2]=0,i[_+92>>2]=0,i[_+104>>2]=24,Y(V0(Y(n,29175,13),r),18918,23),e=i[_+104>>2];k:{if(e&16){X=i[_+100>>2],e=i[_+80>>2],X>>>0<e>>>0&&(i[_+100>>2]=e,X=e),e=_+76|0;break k}if(!(e&8)){X=0,u[_+43|0]=0,r=_+32|0;break r}X=i[_+72>>2],e=_- -64|0}if(e=i[e>>2],X=X-e|0,X>>>0>=2147483640)break i;if(X>>>0>=11){k=X|7,r=p(k+1|0),i[_+40>>2]=k-2147483647,i[_+32>>2]=r,i[_+36>>2]=X;break f}if(u[_+43|0]=X,r=_+32|0,X)break f;X=0;break r}e=s,M=w;A:{k:{n:{t:{u:{o:{if(r=i[X+16>>2],a=i[X+20>>2],(r|0)!=(a|0))for(;;){l:{s:{w:switch(l[X+4|0]){case 0:V=i[r+8>>2];_:{B=i[r+12>>2];h:{if(B>>>0>8388607||(m=i[X+8>>2],Q=i[X+12>>2],I=Q,Q>>>0>8388607))break h;if(Q=i[r+16>>2],F=i[r+20>>2],F>>>0<8388608)break _}if(e=p(40),i[_+44>>2]=e,i[_+48>>2]=39,i[_+52>>2]=-2147483608,r=l[14024]|l[14025]<<8|(l[14026]<<16|l[14027]<<24),f=l[14020]|l[14021]<<8|(l[14022]<<16|l[14023]<<24),u[e|0]=f,u[e+1|0]=f>>>8,u[e+2|0]=f>>>16,u[e+3|0]=f>>>24,u[e+4|0]=r,u[e+5|0]=r>>>8,u[e+6|0]=r>>>16,u[e+7|0]=r>>>24,u[e+39|0]=0,r=l[14055]|l[14056]<<8|(l[14057]<<16|l[14058]<<24),f=l[14051]|l[14052]<<8|(l[14053]<<16|l[14054]<<24),u[e+31|0]=f,u[e+32|0]=f>>>8,u[e+33|0]=f>>>16,u[e+34|0]=f>>>24,u[e+35|0]=r,u[e+36|0]=r>>>8,u[e+37|0]=r>>>16,u[e+38|0]=r>>>24,r=l[14048]|l[14049]<<8|(l[14050]<<16|l[14051]<<24),f=l[14044]|l[14045]<<8|(l[14046]<<16|l[14047]<<24),u[e+24|0]=f,u[e+25|0]=f>>>8,u[e+26|0]=f>>>16,u[e+27|0]=f>>>24,u[e+28|0]=r,u[e+29|0]=r>>>8,u[e+30|0]=r>>>16,u[e+31|0]=r>>>24,r=l[14040]|l[14041]<<8|(l[14042]<<16|l[14043]<<24),f=l[14036]|l[14037]<<8|(l[14038]<<16|l[14039]<<24),u[e+16|0]=f,u[e+17|0]=f>>>8,u[e+18|0]=f>>>16,u[e+19|0]=f>>>24,u[e+20|0]=r,u[e+21|0]=r>>>8,u[e+22|0]=r>>>16,u[e+23|0]=r>>>24,r=l[14032]|l[14033]<<8|(l[14034]<<16|l[14035]<<24),f=l[14028]|l[14029]<<8|(l[14030]<<16|l[14031]<<24),u[e+8|0]=f,u[e+9|0]=f>>>8,u[e+10|0]=f>>>16,u[e+11|0]=f>>>24,u[e+12|0]=r,u[e+13|0]=r>>>8,u[e+14|0]=r>>>16,u[e+15|0]=r>>>24,q(A,2,1e3,_+44|0),u[_+55|0]>=0)break e;Z(i[_+44>>2]);break e}E=i[f>>2],B=B+I|0,R=m,m=m+V|0,B=F+(R>>>0>m>>>0?B+1|0:B)|0,m=m+Q|0,B=m>>>0<Q>>>0?B+1|0:B;_:switch((W[i[i[E>>2]+12>>2]](E,m,B)|0)-1|0){case 1:i[n+4>>2]=i[n>>2],i[_+108>>2]=72196,i[_+136>>2]=0,i[_+52>>2]=72176,e=i[18053],i[_+44>>2]=e,f=i[e-12>>2],e=_+44|0,i[f+e>>2]=i[18054],i[_+48>>2]=0,f=e+i[i[_+44>>2]-12>>2]|0,k=_+56|0,J0(f,k),u[f+80|0]=0,i[f+72>>2]=0,f=i[18055],i[_+52>>2]=f,n=_+52|0,i[n+i[f-12>>2]>>2]=i[18056],f=i[18052],i[_+44>>2]=f,i[e+i[f-12>>2]>>2]=i[18057],i[_+108>>2]=72196,i[_+44>>2]=72156,i[_+52>>2]=72176,f=R0(k),i[f>>2]=71232,i[_+96>>2]=0,i[_+100>>2]=0,i[_+88>>2]=0,i[_+92>>2]=0,i[_+104>>2]=24,k=Y(Y(n,27614,58),27951,25),B=i[X+12>>2]+i[r+12>>2]|0,n=i[r+8>>2],e=n+i[X+8>>2]|0,Y(q2(k,e,e>>>0<n>>>0?B+1|0:B),42669,2),e=i[_+104>>2];h:{if(e&16){X=i[_+100>>2],e=i[_+80>>2],X>>>0<e>>>0&&(i[_+100>>2]=e,X=e),e=_+76|0;break h}if(!(e&8)){X=0,u[_+43|0]=0,r=_+32|0;break A}X=i[_+72>>2],e=_- -64|0}if(e=i[e>>2],X=X-e|0,X>>>0>=2147483640)break i;if(X>>>0>=11){k=X|7,r=p(k+1|0),i[_+40>>2]=k-2147483647,i[_+32>>2]=r,i[_+36>>2]=X;break k}if(u[_+43|0]=X,r=_+32|0,X)break k;X=0;break A;case 0:if(u[_+44|0]=0,u[_+55|0]=0,q(A,2,100,_+44|0),u[_+55|0]>=0)break e;Z(i[_+44>>2]);break e;default:break _}if(Q=i[r+16>>2],V=i[r+20>>2],I=(V|0)==(o|0)&t>>>0>Q>>>0|o>>>0>V>>>0,B=I?Q:t,m=t-B|0,I=I?V:o,o=o-(I+(t>>>0<B>>>0)|0)|0,t=m,o|m||(m=Q-B|0,Q=V-((B>>>0>Q>>>0)+I|0)|0,V=(M|0)==(Q|0)&e>>>0<m>>>0|Q>>>0>M>>>0,m=V?e:m,Q=V?M:Q,V=Q,!(m|Q)))break l;Q=i[n+4>>2]-i[n>>2]|0;_:{if(t=i[h+40>>2],o=i[h+44>>2],!(t|o)||(E=o-(t>>>0<Q>>>0)|0,(V|0)==(E|0)&m>>>0<=t-Q>>>0|V>>>0<E>>>0))break _;i[_+136>>2]=0,i[_+108>>2]=72196,i[_+52>>2]=72176,e=i[18053],i[_+44>>2]=e,f=i[e-12>>2],e=_+44|0,i[f+e>>2]=i[18054],i[_+48>>2]=0,f=e+i[i[_+44>>2]-12>>2]|0,k=_+56|0,J0(f,k),u[f+80|0]=0,i[f+72>>2]=0,f=i[18055],i[_+52>>2]=f,n=_+52|0,i[n+i[f-12>>2]>>2]=i[18056],f=i[18052],i[_+44>>2]=f,i[e+i[f-12>>2]>>2]=i[18057],i[_+108>>2]=72196,i[_+44>>2]=72156,i[_+52>>2]=72176,f=R0(k),i[f>>2]=71232,i[_+96>>2]=0,i[_+100>>2]=0,i[_+88>>2]=0,i[_+92>>2]=0,i[_+104>>2]=24,e=Y(q2(Y(n,28981,19),i[r+16>>2],i[r+20>>2]),28865,35),B=i[r+20>>2],r=Q+i[r+16>>2]|0,B=r>>>0<Q>>>0?B+1|0:B,Y(q2(Y(q2(e,r,B),28591,40),t,o),5240,6),e=i[_+104>>2];h:{if(e&16){X=i[_+100>>2],e=i[_+80>>2],X>>>0<e>>>0&&(i[_+100>>2]=e,X=e),e=_+76|0;break h}if(!(e&8)){X=0,u[_+43|0]=0,r=_+32|0;break n}X=i[_+72>>2],e=_- -64|0}if(e=i[e>>2],X=X-e|0,X>>>0>=2147483640)break i;if(X>>>0>=11){k=X|7,r=p(k+1|0),i[_+40>>2]=k-2147483647,i[_+32>>2]=r,i[_+36>>2]=X;break t}if(u[_+43|0]=X,r=_+32|0,X)break t;X=0;break n}if(F=i[f>>2],E=i[X+8>>2],t=I+i[r+12>>2]|0,o=B+i[r+8>>2]|0,B=i[X+12>>2]+(o>>>0<B>>>0?t+1|0:t)|0,t=o+E|0,o=t>>>0<o>>>0?B+1|0:B,B=V+o|0,I=t+m|0,B=I>>>0<m>>>0?B+1|0:B,I=W[i[i[F>>2]+24>>2]](F,t,o,I,B)|0,B=i[f>>2],!(l0|I)){if(e=i[B+8>>2],i[A>>2]=i[B+4>>2],i[A+4>>2]=e,A=A+8|0,u[B+23|0]>=0){e=i[B+16>>2],i[A>>2]=i[B+12>>2],i[A+4>>2]=e,i[A+8>>2]=i[B+20>>2];break e}T(A,i[B+12>>2],i[B+16>>2]);break e}if(!(W[i[i[B>>2]+20>>2]](B,t,o)|0)){if(e=A,A=d2(_+44|0,8155),q(e,2,0,A),u[A+11|0]>=0)break e;Z(i[A>>2]);break e}if(Wu(n,m+Q|0),t=i[f>>2],W[i[i[t>>2]+16>>2]](t,Q+i[n>>2]|0,m)|0)break s;if(e=A,A=d2(_+44|0,13222),q(e,2,0,A),u[A+11|0]>=0)break e;Z(i[A>>2]);break e;case 1:if(z=i[k>>2],!z){if(e=p(56),i[_+44>>2]=e,i[_+48>>2]=54,i[_+52>>2]=-2147483592,r=l[13251]|l[13252]<<8|(l[13253]<<16|l[13254]<<24),f=l[13247]|l[13248]<<8|(l[13249]<<16|l[13250]<<24),u[e|0]=f,u[e+1|0]=f>>>8,u[e+2|0]=f>>>16,u[e+3|0]=f>>>24,u[e+4|0]=r,u[e+5|0]=r>>>8,u[e+6|0]=r>>>16,u[e+7|0]=r>>>24,u[e+54|0]=0,r=l[13297]|l[13298]<<8|(l[13299]<<16|l[13300]<<24),f=l[13293]|l[13294]<<8|(l[13295]<<16|l[13296]<<24),u[e+46|0]=f,u[e+47|0]=f>>>8,u[e+48|0]=f>>>16,u[e+49|0]=f>>>24,u[e+50|0]=r,u[e+51|0]=r>>>8,u[e+52|0]=r>>>16,u[e+53|0]=r>>>24,r=l[13291]|l[13292]<<8|(l[13293]<<16|l[13294]<<24),f=l[13287]|l[13288]<<8|(l[13289]<<16|l[13290]<<24),u[e+40|0]=f,u[e+41|0]=f>>>8,u[e+42|0]=f>>>16,u[e+43|0]=f>>>24,u[e+44|0]=r,u[e+45|0]=r>>>8,u[e+46|0]=r>>>16,u[e+47|0]=r>>>24,r=l[13283]|l[13284]<<8|(l[13285]<<16|l[13286]<<24),f=l[13279]|l[13280]<<8|(l[13281]<<16|l[13282]<<24),u[e+32|0]=f,u[e+33|0]=f>>>8,u[e+34|0]=f>>>16,u[e+35|0]=f>>>24,u[e+36|0]=r,u[e+37|0]=r>>>8,u[e+38|0]=r>>>16,u[e+39|0]=r>>>24,r=l[13275]|l[13276]<<8|(l[13277]<<16|l[13278]<<24),f=l[13271]|l[13272]<<8|(l[13273]<<16|l[13274]<<24),u[e+24|0]=f,u[e+25|0]=f>>>8,u[e+26|0]=f>>>16,u[e+27|0]=f>>>24,u[e+28|0]=r,u[e+29|0]=r>>>8,u[e+30|0]=r>>>16,u[e+31|0]=r>>>24,r=l[13267]|l[13268]<<8|(l[13269]<<16|l[13270]<<24),f=l[13263]|l[13264]<<8|(l[13265]<<16|l[13266]<<24),u[e+16|0]=f,u[e+17|0]=f>>>8,u[e+18|0]=f>>>16,u[e+19|0]=f>>>24,u[e+20|0]=r,u[e+21|0]=r>>>8,u[e+22|0]=r>>>16,u[e+23|0]=r>>>24,r=l[13259]|l[13260]<<8|(l[13261]<<16|l[13262]<<24),f=l[13255]|l[13256]<<8|(l[13257]<<16|l[13258]<<24),u[e+8|0]=f,u[e+9|0]=f>>>8,u[e+10|0]=f>>>16,u[e+11|0]=f>>>24,u[e+12|0]=r,u[e+13|0]=r>>>8,u[e+14|0]=r>>>16,u[e+15|0]=r>>>24,q(A,2,103,_+44|0),u[_+55|0]>=0)break e;Z(i[_+44>>2]);break e}S=_+12|0,m=i[r+8>>2],F=m+i[X+8>>2]|0,B=i[X+12>>2]+i[r+12>>2]|0,E=m>>>0>F>>>0?B+1|0:B,Q=i[r+16>>2],I=i[r+20>>2],m=v-160|0,v=m,O=i[n+4>>2]-i[n>>2]|0,B=i[h+40>>2],V=B;_:{h:{B:{v:{Z:{G:{if(N=i[h+44>>2],!(N|B)||(R=B-O|0,B=N-(B>>>0<O>>>0)|0,(I|0)==(B|0)&Q>>>0<=R>>>0|B>>>0>I>>>0))break G;i[m+104>>2]=0,i[m+76>>2]=72196,i[m+20>>2]=72176,B=i[18053],i[m+12>>2]=B,R=i[B-12>>2],B=m+12|0,i[R+B>>2]=i[18054],i[m+16>>2]=0,F=B+i[i[m+12>>2]-12>>2]|0,E=m+24|0,J0(F,E),u[F+80|0]=0,i[F+72>>2]=0,F=i[18055],i[m+20>>2]=F,R=m+20|0,i[R+i[F-12>>2]>>2]=i[18056],F=i[18052],i[m+12>>2]=F,i[B+i[F-12>>2]>>2]=i[18057],i[m+76>>2]=72196,i[m+12>>2]=72156,i[m+20>>2]=72176,F=R0(E),i[F>>2]=71232,B=m- -64|0,i[B>>2]=0,i[B+4>>2]=0,i[m+56>>2]=0,i[m+60>>2]=0,i[m+72>>2]=24,E=Y(q2(Y(R,28961,19),Q,I),28865,35),B=I,Q=Q+O|0,B=Q>>>0<O>>>0?B+1|0:B,Y(q2(Y(q2(E,Q,B),28591,40),V,N),5240,6),B=i[m+72>>2];m:{if(B&16){Q=m+44|0,V=i[m+68>>2],B=i[m+48>>2],V>>>0<B>>>0?i[m+68>>2]=B:B=V;break m}if(!(B&8)){B=0,u[m+11|0]=0,Q=m;break h}Q=m+32|0,B=i[m+40>>2]}if(V=i[Q>>2],B=B-V|0,B>>>0>=2147483640)break Z;if(B>>>0>=11){I=B|7,Q=p(I+1|0),i[m+8>>2]=I-2147483647,i[m>>2]=Q,i[m+4>>2]=B;break B}if(u[m+11|0]=B,Q=m,B)break B;B=0;break h}if(V=i[z+8>>2],N=i[z+112>>2],P=V+N|0,R=i[z+12>>2],$=i[z+116>>2],B=R+$|0,B=N>>>0>P>>>0?B+1|0:B,(E|0)==(B|0)&F>>>0>P>>>0|B>>>0<E>>>0){if(u[m+12|0]=0,u[m+23|0]=0,q(S,2,100,m+12|0),u[m+23|0]>=0)break _;Z(i[m+12>>2]);break _}G:{if(B=R,(B|0)==(I|0)&Q>>>0<=V>>>0|B>>>0>I>>>0&&(R=V,V=B,B=I+E|0,P=Q+F|0,B=P>>>0<F>>>0?B+1|0:B,f0=R,R=P,(B|0)==(V|0)&f0>>>0>=R>>>0|B>>>0<V>>>0))break G;if(u[m+12|0]=0,u[m+23|0]=0,q(S,2,100,m+12|0),u[m+23|0]>=0)break _;Z(i[m+12>>2]);break _}if(V=i[f>>2],B=B+$|0,N=N+R|0,B=N>>>0<R>>>0?B+1|0:B,((W[i[i[V>>2]+12>>2]](V,N,B)|0)-1&255)>>>0<=1){if(u[m+12|0]=0,u[m+23|0]=0,q(S,2,100,m+12|0),u[m+23|0]>=0)break _;Z(i[m+12>>2]);break _}if(V=i[f>>2],B=E+i[z+116>>2]|0,R=F,F=F+i[z+112>>2]|0,B=R>>>0>F>>>0?B+1|0:B,W[i[i[V>>2]+20>>2]](V,F,B)|0,Q|I){B=Q+O|0,E=i[n+4>>2],V=i[n>>2],I=E-V|0;G:{if(B>>>0>I>>>0){if(F=B-I|0,N=i[n+8>>2],F>>>0<=N-E>>>0){F&&o0(E,0,F),i[n+4>>2]=F+E;break G}if((B|0)<0)break v;if(E=N-V|0,N=E<<1,N=E>>>0>=1073741823?2147483647:B>>>0<N>>>0?N:B,E=p(N),F&&o0(I+E|0,0,F),I&&x(E,V,I),i[n+8>>2]=E+N,i[n+4>>2]=B+E,i[n>>2]=E,!V)break G;Z(V);break G}if(B>>>0>=I>>>0)break G;i[n+4>>2]=B+V}B=i[f>>2],W[i[i[B>>2]+16>>2]](B,i[n>>2]+O|0,Q)|0}if(B=i[26917],i[S>>2]=i[26916],i[S+4>>2]=B,B=S+8|0,u[107683]>=0){Q=i[26919],i[B>>2]=i[26918],i[B+4>>2]=Q,i[B+8>>2]=i[26920];break _}T(B,i[26918],i[26919]);break _}Q0(),H()}G0(),H()}if(!B)break h;x(Q,V,B)}u[B+Q|0]=0,q(S,6,1e3,m),u[m+11|0]<0&&Z(i[m>>2]),B=i[18051],i[m+12>>2]=B,i[i[B-12>>2]+(m+12|0)>>2]=i[18059],i[m+20>>2]=i[18060],i[F>>2]=71232,u[m+67|0]<0&&Z(i[m+56>>2]),E0(F),y0(m+76|0)}v=m+160|0,u[_+31|0]<0&&Z(i[_+20>>2]),B=e,m=i[r+16>>2],e=e-m|0,M=M-(i[r+20>>2]+(B>>>0<m>>>0)|0)|0;break l;default:break w}i[_+136>>2]=0,i[_+108>>2]=72196,i[_+52>>2]=72176,e=i[18053],i[_+44>>2]=e,r=i[e-12>>2],e=_+44|0,i[r+e>>2]=i[18054],i[_+48>>2]=0,r=e+i[i[_+44>>2]-12>>2]|0,f=_+56|0,J0(r,f),u[r+80|0]=0,i[r+72>>2]=0,r=i[18055],i[_+52>>2]=r,k=_+52|0,i[k+i[r-12>>2]>>2]=i[18056],r=i[18052],i[_+44>>2]=r,i[e+i[r-12>>2]>>2]=i[18057],i[_+108>>2]=72196,i[_+44>>2]=72156,i[_+52>>2]=72176,r=R0(f),i[r>>2]=71232,i[_+96>>2]=0,i[_+100>>2]=0,i[_+88>>2]=0,i[_+92>>2]=0,i[_+104>>2]=24,Y(S0(Y(k,28901,25),l[X+4|0]),16510,16),e=i[_+104>>2];w:{if(e&16){X=i[_+100>>2],e=i[_+80>>2],X>>>0<e>>>0&&(i[_+100>>2]=e,X=e),e=_+76|0;break w}if(!(e&8)){X=0,u[_+43|0]=0,e=_+32|0;break u}X=i[_+72>>2],e=_- -64|0}if(f=i[e>>2],X=X-f|0,X>>>0>=2147483640)break i;if(X>>>0>=11){k=X|7,e=p(k+1|0),i[_+40>>2]=k-2147483647,i[_+32>>2]=e,i[_+36>>2]=X;break o}if(u[_+43|0]=X,e=_+32|0,X)break o;X=0;break u}t=e,e=e-m|0,M=M-((t>>>0<m>>>0)+V|0)|0,t=0,o=0}if(r=r+40|0,(a|0)==(r|0))break}if(!(!(e|M)|(s&w)==-1)){if(e=p(56),i[_+44>>2]=e,i[_+48>>2]=53,i[_+52>>2]=-2147483592,r=l[23267]|l[23268]<<8|(l[23269]<<16|l[23270]<<24),f=l[23263]|l[23264]<<8|(l[23265]<<16|l[23266]<<24),u[e|0]=f,u[e+1|0]=f>>>8,u[e+2|0]=f>>>16,u[e+3|0]=f>>>24,u[e+4|0]=r,u[e+5|0]=r>>>8,u[e+6|0]=r>>>16,u[e+7|0]=r>>>24,u[e+53|0]=0,r=l[23312]|l[23313]<<8|(l[23314]<<16|l[23315]<<24),f=l[23308]|l[23309]<<8|(l[23310]<<16|l[23311]<<24),u[e+45|0]=f,u[e+46|0]=f>>>8,u[e+47|0]=f>>>16,u[e+48|0]=f>>>24,u[e+49|0]=r,u[e+50|0]=r>>>8,u[e+51|0]=r>>>16,u[e+52|0]=r>>>24,r=l[23307]|l[23308]<<8|(l[23309]<<16|l[23310]<<24),f=l[23303]|l[23304]<<8|(l[23305]<<16|l[23306]<<24),u[e+40|0]=f,u[e+41|0]=f>>>8,u[e+42|0]=f>>>16,u[e+43|0]=f>>>24,u[e+44|0]=r,u[e+45|0]=r>>>8,u[e+46|0]=r>>>16,u[e+47|0]=r>>>24,r=l[23299]|l[23300]<<8|(l[23301]<<16|l[23302]<<24),f=l[23295]|l[23296]<<8|(l[23297]<<16|l[23298]<<24),u[e+32|0]=f,u[e+33|0]=f>>>8,u[e+34|0]=f>>>16,u[e+35|0]=f>>>24,u[e+36|0]=r,u[e+37|0]=r>>>8,u[e+38|0]=r>>>16,u[e+39|0]=r>>>24,r=l[23291]|l[23292]<<8|(l[23293]<<16|l[23294]<<24),f=l[23287]|l[23288]<<8|(l[23289]<<16|l[23290]<<24),u[e+24|0]=f,u[e+25|0]=f>>>8,u[e+26|0]=f>>>16,u[e+27|0]=f>>>24,u[e+28|0]=r,u[e+29|0]=r>>>8,u[e+30|0]=r>>>16,u[e+31|0]=r>>>24,r=l[23283]|l[23284]<<8|(l[23285]<<16|l[23286]<<24),f=l[23279]|l[23280]<<8|(l[23281]<<16|l[23282]<<24),u[e+16|0]=f,u[e+17|0]=f>>>8,u[e+18|0]=f>>>16,u[e+19|0]=f>>>24,u[e+20|0]=r,u[e+21|0]=r>>>8,u[e+22|0]=r>>>16,u[e+23|0]=r>>>24,r=l[23275]|l[23276]<<8|(l[23277]<<16|l[23278]<<24),f=l[23271]|l[23272]<<8|(l[23273]<<16|l[23274]<<24),u[e+8|0]=f,u[e+9|0]=f>>>8,u[e+10|0]=f>>>16,u[e+11|0]=f>>>24,u[e+12|0]=r,u[e+13|0]=r>>>8,u[e+14|0]=r>>>16,u[e+15|0]=r>>>24,q(A,2,100,_+44|0),u[_+55|0]>=0)break e;Z(i[_+44>>2]);break e}if(e=i[26917],i[A>>2]=i[26916],i[A+4>>2]=e,A=A+8|0,u[107683]>=0){e=i[26919],i[A>>2]=i[26918],i[A+4>>2]=e,i[A+8>>2]=i[26920];break e}T(A,i[26918],i[26919]);break e}if(!X)break u;x(e,f,X)}u[e+X|0]=0,q(A,4,3004,_+32|0),u[_+43|0]<0&&Z(i[_+32>>2]),A=i[18051],i[_+44>>2]=A,i[i[A-12>>2]+(_+44|0)>>2]=i[18059],i[_+52>>2]=i[18060],i[r>>2]=71232,u[_+99|0]<0&&Z(i[_+88>>2]),E0(r),y0(_+108|0);break e}if(!X)break n;x(r,e,X)}u[r+X|0]=0,q(A,6,1e3,_+32|0),u[_+43|0]<0&&Z(i[_+32>>2]),A=i[18051],i[_+44>>2]=A,i[i[A-12>>2]+(_+44|0)>>2]=i[18059],i[_+52>>2]=i[18060],i[f>>2]=71232,u[_+99|0]<0&&Z(i[_+88>>2]),E0(f),y0(_+108|0);break e}if(!X)break A;x(r,e,X)}u[r+X|0]=0,q(A,2,100,_+32|0),u[_+43|0]<0&&Z(i[_+32>>2]),A=i[18051],i[_+44>>2]=A,i[i[A-12>>2]+(_+44|0)>>2]=i[18059],i[_+52>>2]=i[18060],i[f>>2]=71232,u[_+99|0]<0&&Z(i[_+88>>2]),E0(f),y0(_+108|0);break e}if(!X)break r;x(r,e,X)}u[r+X|0]=0,q(A,2,117,_+32|0),u[_+43|0]<0&&Z(i[_+32>>2]),A=i[18051],i[_+44>>2]=A,i[i[A-12>>2]+(_+44|0)>>2]=i[18059],i[_+52>>2]=i[18060],i[f>>2]=71232,u[_+99|0]<0&&Z(i[_+88>>2]),E0(f),y0(_+108|0)}v=_+192|0;return}Q0(),H()}function R7(A,e,r,f){var k=0,n=0,t=0,o=0,s=0,w=0,h=0,_=0,B=0,m=0,X=0,Q=0,V=0,F=0,I=0,E=0,R=0,N=0,M=0,z=0,S=0,O=0,P=0,a=0,$=0,f0=0,A0=0,n0=0,_0=0,m0=0;V=v+-64|0,v=V;i:{e:{r:{f:{A:{k:{n:{t:switch(i[e+120>>2]-1|0){case 1:if((r|0)<=179){if(!r)break A;if((r|0)==90)break n;break r}if((r|0)==270)break n;if((r|0)!=180)break r;if(k=i[e+112>>2],k&1)break n;n=i[e+108>>2];break e;case 0:break t;default:break k}if((r|0)<=179){if(!r)break A;if((r|0)!=90)break r;if(k=i[e+108>>2],k&1)break n;n=i[e+112>>2];break e}if((r|0)!=180){if((r|0)!=270)break r;if(n=i[e+112>>2],n&1)break n;k=i[e+108>>2];break e}if(n=i[e+108>>2],n&1)break n;if(k=i[e+112>>2],!(k&1))break e}if(i[V+48>>2]=0,i[V+52>>2]=0,i[V+40>>2]=0,i[V+44>>2]=0,u[V+52|0]=1,i[V+44>>2]=2,i[V+48>>2]=2,u[V+40|0]=1,i[V+56>>2]=i[e+84>>2],k=i[e+88>>2],!k||(k=Gi(k),i[V+60>>2]=k,!k))break f;i[V+8>>2]=131074,i[V+12>>2]=65538,k=255,t=i[e+128>>2];n:{if(!t)break n;for(e=e+128|0,n=e;P=i[t+16>>2],n=(P|0)<0?n:t,t=i[(P>>>29&4)+t>>2],!!t;);if((e|0)==(n|0)|i[n+16>>2]>0)break n;k=l[n+24|0]}r6(V+16|0,V+56|0,0,3,V+8|0,k,V+40|0,0,f),e=i[V+60>>2];n:{if(!e||(k=i[e+4>>2],i[e+4>>2]=k-1,k))break n;W[i[i[e>>2]+8>>2]](e),y(e)}n:{t:switch(l[V+36|0]){default:_2(),H();case 1:e=i[V+20>>2],i[A>>2]=i[V+16>>2],i[A+4>>2]=e,e=A+8|0;u:{if(u[V+35|0]>=0){r=i[V+28>>2],i[e>>2]=i[V+24>>2],i[e+4>>2]=r,i[e+8>>2]=i[V+32>>2];break u}T(e,i[V+24>>2],i[V+28>>2])}u[A+20|0]=1;break n;case 0:break t}R7(A,i[V+16>>2],r,f)}if(A=l[V+36|0],(A|0)==255)break i;e=i[23817],i[V+56>>2]=i[23816],i[V+60>>2]=e,W[i[(V+56|0)+(A<<2)>>2]](V+8|0,V+16|0);break i}if(r)break r}if(r=i[e+88>>2],!r||(e=i[e+84>>2],r=Gi(r),!r))break f;u[A+20|0]=0,i[A+4>>2]=r,i[A>>2]=e;break i}Q3(),H()}if(n=i[e+112>>2],t=i[e+108>>2],!((r|0)==270|(r|0)==90)){k=n,n=t;break e}k=t}M=p(172),t=M,i[t+4>>2]=0,i[t+8>>2]=0,i[t>>2]=94812,o0(t+16|0,0,80),o=i[t+4>>2],_=o+1|0,i[t+4>>2]=_,i[t+104>>2]=0,i[t+108>>2]=0,i[t+36>>2]=1,i[t+40>>2]=1,u[t+24|0]=1,g[t+22>>1]=2,g[t+18>>1]=2,g[t+20>>1]=2,i[t+112>>2]=0,i[t+116>>2]=4740,i[t+140>>2]=0,i[t+144>>2]=0,i[t+128>>2]=99,i[t+132>>2]=99,i[t+120>>2]=0,i[t+124>>2]=0,i[t+12>>2]=95160,i[t+148>>2]=0,i[t+152>>2]=0,P=t+140|0,i[t+136>>2]=P,i[t+156>>2]=0,i[t+160>>2]=0,i[t+164>>2]=0,i[t+168>>2]=0,i[t+4>>2]=o,o=i[t+8>>2],a=t+12|0,i[t+96>>2]=a,i[t+8>>2]=o+1,i[t+100>>2]=t,_||(W[i[i[t>>2]+8>>2]](t),y(t)),t=i[e+120>>2],o=i[e+116>>2],i[M+124>>2]=k,i[M+128>>2]=o,i[M+132>>2]=t,i[M+120>>2]=n;e:{if(t=i[e+124>>2],A0=e+128|0,(t|0)!=(A0|0))for(f0=A+8|0,_0=(r|0)==270,m0=(r|0)!=90;;){o=i[t+32>>2],n=i[t+28>>2];r:{if(!(!m0|_0)){k=n,n=o;break r}k=o}o=i[t+16>>2],Tf(V+16|0,a,o,k,n,i[t+20>>2],l[t+24|0],f),n0=i[V+16>>2];r:{if(n0){if(k=i[V+20>>2],i[A>>2]=i[V+16>>2],i[A+4>>2]=k,u[V+35|0]>=0){k=i[V+28>>2],i[f0>>2]=i[V+24>>2],i[f0+4>>2]=k,i[f0+8>>2]=i[V+32>>2],u[A+20|0]=1;break r}T(f0,i[V+24>>2],i[V+28>>2]),u[A+20|0]=1;break r}k=P,n=i[k>>2];f:{A:{if(!n)break A;for(;_=(o|0)>i[n+16>>2],k=_?k:n,n=i[(_?4:0)+n>>2],!!n;);if((k|0)==(P|0))break A;if((o|0)>=i[k+16>>2])break f}k=P}if(n=l[t+24|0],n>>>0<=8){o=0,N=i[k+44>>2],_=i[k+56>>2],E=i[t+44>>2],m=i[t+56>>2],B=i[t+32>>2],k=i[t+28>>2];f:{if((r|0)!=270){if((r|0)!=180){if(!k|(!B|(r|0)!=90))break f;for(Q=k+E|0,X=k&-4,E=k&3,R=k>>>0<4;;){if(s=o+N|0,h=Q+G(o,m)|0,k=0,n=0,!R)for(;u[s+G(k,_)|0]=l[h+(k^-1)|0],u[s+G(_,k|1)|0]=l[h+(k^-2)|0],u[s+G(_,k|2)|0]=l[h+(k^-3)|0],u[s+G(_,k|3)|0]=l[h+(k^-4)|0],k=k+4|0,n=n+4|0,(X|0)!=(n|0););if(n=0,E)for(;u[s+G(k,_)|0]=l[h+(k^-1)|0],k=k+1|0,n=n+1|0,(E|0)!=(n|0););if(o=o+1|0,(B|0)==(o|0))break}break f}if(!B|!k)break f;for(Q=k+E|0,X=k&-4,E=k&3,R=k>>>0<4;;){if(s=N+G(o,_)|0,h=Q+G(m,B+(o^-1)|0)|0,k=0,!R)for(w=s+3|0,I=s+2|0,F=s+1|0,n=0;u[k+s|0]=l[h+(k^-1)|0],u[k+F|0]=l[h+(k^-2)|0],u[k+I|0]=l[h+(k^-3)|0],u[k+w|0]=l[h+(k^-4)|0],k=k+4|0,n=n+4|0,(X|0)!=(n|0););if(n=0,E)for(;u[k+s|0]=l[h+(k^-1)|0],k=k+1|0,n=n+1|0,(E|0)!=(n|0););if(o=o+1|0,(B|0)==(o|0))break}break f}if(!B|!k)break f;for(X=k&-4,Q=k&3,R=k-1>>>0<3;;){if(s=o+N|0,h=E+G(m,B+(o^-1)|0)|0,k=0,n=0,!R)for(;u[s+G(k,_)|0]=l[k+h|0],w=k|1,u[s+G(w,_)|0]=l[h+w|0],w=k|2,u[s+G(w,_)|0]=l[h+w|0],w=k|3,u[s+G(w,_)|0]=l[h+w|0],k=k+4|0,n=n+4|0,(X|0)!=(n|0););if(n=0,Q)for(;u[s+G(k,_)|0]=l[k+h|0],k=k+1|0,n=n+1|0,(Q|0)!=(n|0););if(o=o+1|0,(B|0)==(o|0))break}}break r}if(n>>>0<=16){o=0,_=i[k+56>>2]>>>1|0,N=i[t+56>>2]>>>1|0,E=i[k+44>>2],m=i[t+44>>2],B=i[t+32>>2],k=i[t+28>>2];f:{if((r|0)!=270){if((r|0)!=180){if(!k|(!B|(r|0)!=90))break f;for(Q=m+(k<<1)|0,X=k&-4,m=k&3,R=k>>>0<4;;){if(s=E+(o<<1)|0,h=Q+(G(o,N)<<1)|0,k=0,n=0,!R)for(;g[s+(G(k,_)<<1)>>1]=C[h+((k^-1)<<1)>>1],g[s+(G(_,k|1)<<1)>>1]=C[h+((k^2147483646)<<1)>>1],g[s+(G(_,k|2)<<1)>>1]=C[h+((k^2147483645)<<1)>>1],g[s+(G(_,k|3)<<1)>>1]=C[h+((k^2147483644)<<1)>>1],k=k+4|0,n=n+4|0,(X|0)!=(n|0););if(n=0,m)for(;g[s+(G(k,_)<<1)>>1]=C[h+((k^-1)<<1)>>1],k=k+1|0,n=n+1|0,(m|0)!=(n|0););if(o=o+1|0,(B|0)==(o|0))break}break f}if(!B|!k)break f;for(X=m+(k<<1)|0,R=k&-4,Q=k&3,w=k>>>0<4;;){if(s=E+(G(o,_)<<1)|0,h=X+(G(N,B+(o^-1)|0)<<1)|0,k=0,!w)for(I=s+6|0,F=s+4|0,S=s+2|0,n=0;m=k<<1,g[m+s>>1]=C[h+((k^-1)<<1)>>1],g[m+S>>1]=C[h+((k^2147483646)<<1)>>1],g[m+F>>1]=C[h+((k^2147483645)<<1)>>1],g[m+I>>1]=C[h+((k^2147483644)<<1)>>1],k=k+4|0,n=n+4|0,(R|0)!=(n|0););if(n=0,Q)for(;g[s+(k<<1)>>1]=C[h+((k^-1)<<1)>>1],k=k+1|0,n=n+1|0,(Q|0)!=(n|0););if(o=o+1|0,(B|0)==(o|0))break}break f}if(!B|!k)break f;for(X=k&-4,Q=k&3,R=k-1>>>0<3;;){if(s=E+(o<<1)|0,h=m+(G(N,B+(o^-1)|0)<<1)|0,k=0,n=0,!R)for(;g[s+(G(k,_)<<1)>>1]=C[h+(k<<1)>>1],w=k|1,g[s+(G(w,_)<<1)>>1]=C[h+(w<<1)>>1],w=k|2,g[s+(G(w,_)<<1)>>1]=C[h+(w<<1)>>1],w=k|3,g[s+(G(w,_)<<1)>>1]=C[h+(w<<1)>>1],k=k+4|0,n=n+4|0,(X|0)!=(n|0););if(n=0,Q)for(;g[s+(G(k,_)<<1)>>1]=C[h+(k<<1)>>1],k=k+1|0,n=n+1|0,(Q|0)!=(n|0););if(o=o+1|0,(B|0)==(o|0))break}}break r}if(n>>>0<=32){o=0,_=i[k+56>>2]>>>2|0,N=i[t+56>>2]>>>2|0,E=i[k+44>>2],m=i[t+44>>2],B=i[t+32>>2],k=i[t+28>>2];f:{if((r|0)!=270){if((r|0)!=180){if(!k|(!B|(r|0)!=90))break f;for(Q=m+(k<<2)|0,X=k&-4,m=k&3,R=k>>>0<4;;){if(s=E+(o<<2)|0,h=Q+(G(o,N)<<2)|0,k=0,n=0,!R)for(;i[s+(G(k,_)<<2)>>2]=i[h+((k^-1)<<2)>>2],i[s+(G(_,k|1)<<2)>>2]=i[h+((k^1073741822)<<2)>>2],i[s+(G(_,k|2)<<2)>>2]=i[h+((k^1073741821)<<2)>>2],i[s+(G(_,k|3)<<2)>>2]=i[h+((k^1073741820)<<2)>>2],k=k+4|0,n=n+4|0,(X|0)!=(n|0););if(n=0,m)for(;i[s+(G(k,_)<<2)>>2]=i[h+((k^-1)<<2)>>2],k=k+1|0,n=n+1|0,(m|0)!=(n|0););if(o=o+1|0,(B|0)==(o|0))break}break f}if(!B|!k)break f;for(X=m+(k<<2)|0,R=k&-4,Q=k&3,w=k>>>0<4;;){if(s=E+(G(o,_)<<2)|0,h=X+(G(N,B+(o^-1)|0)<<2)|0,k=0,!w)for(I=s+12|0,F=s+8|0,S=s+4|0,n=0;m=k<<2,i[m+s>>2]=i[h+((k^-1)<<2)>>2],i[m+S>>2]=i[h+((k^1073741822)<<2)>>2],i[m+F>>2]=i[h+((k^1073741821)<<2)>>2],i[m+I>>2]=i[h+((k^1073741820)<<2)>>2],k=k+4|0,n=n+4|0,(R|0)!=(n|0););if(n=0,Q)for(;i[s+(k<<2)>>2]=i[h+((k^-1)<<2)>>2],k=k+1|0,n=n+1|0,(Q|0)!=(n|0););if(o=o+1|0,(B|0)==(o|0))break}break f}if(!B|!k)break f;for(X=k&-4,Q=k&3,R=k-1>>>0<3;;){if(s=E+(o<<2)|0,h=m+(G(N,B+(o^-1)|0)<<2)|0,k=0,n=0,!R)for(;i[s+(G(k,_)<<2)>>2]=i[h+(k<<2)>>2],w=k|1,i[s+(G(w,_)<<2)>>2]=i[h+(w<<2)>>2],w=k|2,i[s+(G(w,_)<<2)>>2]=i[h+(w<<2)>>2],w=k|3,i[s+(G(w,_)<<2)>>2]=i[h+(w<<2)>>2],k=k+4|0,n=n+4|0,(X|0)!=(n|0););if(n=0,Q)for(;i[s+(G(k,_)<<2)>>2]=i[h+(k<<2)>>2],k=k+1|0,n=n+1|0,(Q|0)!=(n|0););if(o=o+1|0,(B|0)==(o|0))break}}break r}if(n>>>0<=64){o=0,_=i[k+56>>2]>>>3|0,N=i[t+56>>2]>>>3|0,E=i[k+44>>2],m=i[t+44>>2],B=i[t+32>>2],k=i[t+28>>2];f:{if((r|0)!=270){if((r|0)!=180){if(!k|(!B|(r|0)!=90))break f;for(Q=m+(k<<3)|0,X=k&-4,m=k&3,R=k>>>0<4;;){if(s=E+(o<<3)|0,h=Q+(G(o,N)<<3)|0,k=0,n=0,!R)for(;I=h+((k^-1)<<3)|0,F=i[I+4>>2],w=s+(G(k,_)<<3)|0,i[w>>2]=i[I>>2],i[w+4>>2]=F,I=h+((k^536870910)<<3)|0,F=i[I+4>>2],w=s+(G(_,k|1)<<3)|0,i[w>>2]=i[I>>2],i[w+4>>2]=F,I=h+((k^536870909)<<3)|0,F=i[I+4>>2],w=s+(G(_,k|2)<<3)|0,i[w>>2]=i[I>>2],i[w+4>>2]=F,I=h+((k^536870908)<<3)|0,F=i[I+4>>2],w=s+(G(_,k|3)<<3)|0,i[w>>2]=i[I>>2],i[w+4>>2]=F,k=k+4|0,n=n+4|0,(X|0)!=(n|0););if(n=0,m)for(;I=h+((k^-1)<<3)|0,F=i[I+4>>2],w=s+(G(k,_)<<3)|0,i[w>>2]=i[I>>2],i[w+4>>2]=F,k=k+1|0,n=n+1|0,(m|0)!=(n|0););if(o=o+1|0,(B|0)==(o|0))break}break f}if(!B|!k)break f;for(X=m+(k<<3)|0,R=k&-4,Q=k&3,w=k>>>0<4;;){if(s=E+(G(o,_)<<3)|0,h=X+(G(N,B+(o^-1)|0)<<3)|0,k=0,!w)for(I=s+24|0,F=s+16|0,S=s+8|0,n=0;O=h+((k^-1)<<3)|0,$=i[O+4>>2],m=k<<3,z=m+s|0,i[z>>2]=i[O>>2],i[z+4>>2]=$,O=h+((k^536870910)<<3)|0,$=i[O+4>>2],z=m+S|0,i[z>>2]=i[O>>2],i[z+4>>2]=$,O=h+((k^536870909)<<3)|0,$=i[O+4>>2],z=m+F|0,i[z>>2]=i[O>>2],i[z+4>>2]=$,z=h+((k^536870908)<<3)|0,O=i[z+4>>2],m=m+I|0,i[m>>2]=i[z>>2],i[m+4>>2]=O,k=k+4|0,n=n+4|0,(R|0)!=(n|0););if(n=0,Q)for(;I=h+((k^-1)<<3)|0,F=i[I+4>>2],m=s+(k<<3)|0,i[m>>2]=i[I>>2],i[m+4>>2]=F,k=k+1|0,n=n+1|0,(Q|0)!=(n|0););if(o=o+1|0,(B|0)==(o|0))break}break f}if(!B|!k)break f;for(X=k&-4,Q=k&3,R=k-1>>>0<3;;){if(s=E+(o<<3)|0,h=m+(G(N,B+(o^-1)|0)<<3)|0,k=0,n=0,!R)for(;I=h+(k<<3)|0,F=i[I+4>>2],w=s+(G(k,_)<<3)|0,i[w>>2]=i[I>>2],i[w+4>>2]=F,w=k|1,I=s+(G(w,_)<<3)|0,w=h+(w<<3)|0,F=i[w+4>>2],i[I>>2]=i[w>>2],i[I+4>>2]=F,w=k|2,I=s+(G(w,_)<<3)|0,w=h+(w<<3)|0,F=i[w+4>>2],i[I>>2]=i[w>>2],i[I+4>>2]=F,w=k|3,I=s+(G(w,_)<<3)|0,w=h+(w<<3)|0,F=i[w+4>>2],i[I>>2]=i[w>>2],i[I+4>>2]=F,k=k+4|0,n=n+4|0,(X|0)!=(n|0););if(n=0,Q)for(;I=h+(k<<3)|0,F=i[I+4>>2],w=s+(G(k,_)<<3)|0,i[w>>2]=i[I>>2],i[w+4>>2]=F,k=k+1|0,n=n+1|0,(Q|0)!=(n|0););if(o=o+1|0,(B|0)==(o|0))break}}break r}if(n>>>0>128)break r;s=i[k+56>>2]>>>4|0,h=i[t+56>>2]>>>4|0,N=i[k+44>>2],E=i[t+44>>2],_=i[t+32>>2],n=i[t+28>>2];f:{if((r|0)!=270){if((r|0)!=180){if(!n|(!_|(r|0)!=90))break f;for(R=E+(n<<4)|0,w=n&-2,I=n&1,o=0;;){if(E=N+(o<<4)|0,m=R+(G(o,h)<<4)|0,k=0,B=0,(n|0)!=1)for(;Q=m+((k^-1)<<4)|0,F=i[Q+4>>2],X=E+(G(k,s)<<4)|0,i[X>>2]=i[Q>>2],i[X+4>>2]=F,F=i[Q+12>>2],i[X+8>>2]=i[Q+8>>2],i[X+12>>2]=F,Q=m+((k^268435454)<<4)|0,F=i[Q+12>>2],X=E+(G(s,k|1)<<4)|0,i[X+8>>2]=i[Q+8>>2],i[X+12>>2]=F,F=i[Q+4>>2],i[X>>2]=i[Q>>2],i[X+4>>2]=F,k=k+2|0,B=B+2|0,(w|0)!=(B|0););if(I&&(B=E+(G(k,s)<<4)|0,k=m+((k^-1)<<4)|0,E=i[k+4>>2],i[B>>2]=i[k>>2],i[B+4>>2]=E,E=i[k+12>>2],i[B+8>>2]=i[k+8>>2],i[B+12>>2]=E),o=o+1|0,(_|0)==(o|0))break}break f}if(!_|!n)break f;for(R=E+(n<<4)|0,w=n&-2,I=n&1,o=0;;){if(E=N+(G(s,o)<<4)|0,m=R+(G(h,_+(o^-1)|0)<<4)|0,k=0,(n|0)!=1)for(F=E+16|0,B=0;Q=m+((k^-1)<<4)|0,z=i[Q+4>>2],S=k<<4,X=S+E|0,i[X>>2]=i[Q>>2],i[X+4>>2]=z,z=i[Q+12>>2],i[X+8>>2]=i[Q+8>>2],i[X+12>>2]=z,X=F+S|0,Q=m+((k^268435454)<<4)|0,S=i[Q+12>>2],i[X+8>>2]=i[Q+8>>2],i[X+12>>2]=S,S=i[Q+4>>2],i[X>>2]=i[Q>>2],i[X+4>>2]=S,k=k+2|0,B=B+2|0,(w|0)!=(B|0););if(I&&(B=E+(k<<4)|0,k=m+((k^-1)<<4)|0,E=i[k+4>>2],i[B>>2]=i[k>>2],i[B+4>>2]=E,E=i[k+12>>2],i[B+8>>2]=i[k+8>>2],i[B+12>>2]=E),o=o+1|0,(_|0)==(o|0))break}break f}if(!_|!n)break f;for(w=n&-2,I=n&1,o=0;;){if(m=N+(o<<4)|0,Q=E+(G(h,_+(o^-1)|0)<<4)|0,k=0,B=0,(n|0)!=1)for(;X=Q+(k<<4)|0,F=i[X+4>>2],R=m+(G(k,s)<<4)|0,i[R>>2]=i[X>>2],i[R+4>>2]=F,F=i[X+12>>2],i[R+8>>2]=i[X+8>>2],i[R+12>>2]=F,X=k|1,R=m+(G(X,s)<<4)|0,X=Q+(X<<4)|0,F=i[X+12>>2],i[R+8>>2]=i[X+8>>2],i[R+12>>2]=F,F=i[X+4>>2],i[R>>2]=i[X>>2],i[R+4>>2]=F,k=k+2|0,B=B+2|0,(w|0)!=(B|0););if(I&&(B=m+(G(k,s)<<4)|0,k=Q+(k<<4)|0,m=i[k+4>>2],i[B>>2]=i[k>>2],i[B+4>>2]=m,m=i[k+12>>2],i[B+8>>2]=i[k+8>>2],i[B+12>>2]=m),o=o+1|0,(_|0)==(o|0))break}}}if(u[V+35|0]<0&&Z(i[V+24>>2]),n0)break e;k=t,n=i[k+4>>2];r:{if(n){for(;;)if(t=n,n=i[n>>2],!n)break r}for(;t=i[k+8>>2],n=i[t>>2]!=(k|0),k=t,!!n;);}if((t|0)==(A0|0))break}if(r=C[e+10>>1]|C[e+12>>1]<<16,i[V+16>>2]=C[e+6>>1]|C[e+8>>1]<<16,i[V+20>>2]=r,W[i[i[a>>2]+8>>2]](a,V+16|0),W[i[i[a>>2]+12>>2]](a,e+16|0),n=i[e+148>>2],r=i[e+152>>2],(n|0)!=(r|0))for(f=M+160|0,t=i[M+164>>2];;){r:{if(u0[M+168>>2]>t>>>0){if(e=i[n+4>>2],i[t>>2]=i[n>>2],i[t+4>>2]=e,e=t+8|0,u[n+19|0]>=0){k=i[n+12>>2],i[e>>2]=i[n+8>>2],i[e+4>>2]=k,i[e+8>>2]=i[n+16>>2],t=t+20|0;break r}T(e,i[n+8>>2],i[n+12>>2]),t=t+20|0;break r}t=fi(f,n)}if(i[M+164>>2]=t,n=n+20|0,(r|0)==(n|0))break}u[A+20|0]=0,i[A+4>>2]=M,i[A>>2]=a;break i}if(A=i[M+4>>2],i[M+4>>2]=A-1,A)break i;W[i[i[M>>2]+8>>2]](M),y(M)}v=V- -64|0}function Bf(A,e,r,f,k,n){var t=0,o=0,s=0,w=0,h=0,_=0,B=0,m=0,X=0,Q=0,V=0,F=0,I=0,E=0,R=0,N=0,M=0,z=0,S=0;B=v-16|0,v=B,t=p(172),i[t+4>>2]=0,i[t+8>>2]=0,i[t>>2]=94812,o0(t+16|0,0,80),h=i[t+4>>2],o=h+1|0,i[t+4>>2]=o,i[t+104>>2]=0,i[t+108>>2]=0,i[t+36>>2]=1,i[t+40>>2]=1,u[t+24|0]=1,g[t+22>>1]=2,g[t+18>>1]=2,g[t+20>>1]=2,i[t+112>>2]=0,i[t+116>>2]=4740,i[t+140>>2]=0,i[t+144>>2]=0,i[t+128>>2]=99,i[t+132>>2]=99,i[t+120>>2]=0,i[t+124>>2]=0,i[t+12>>2]=95160,i[t+148>>2]=0,i[t+152>>2]=0,i[t+136>>2]=t+140,i[t+156>>2]=0,i[t+160>>2]=0,i[t+164>>2]=0,i[t+168>>2]=0,i[t+4>>2]=h,h=i[t+8>>2],s=t+12|0,i[t+96>>2]=s,i[t+8>>2]=h+1,i[t+100>>2]=t,o||(W[i[i[t>>2]+8>>2]](t),y(t)),i[r>>2]=s,h=i[r+4>>2],i[r+4>>2]=t;i:{if(!h||(t=i[h+4>>2],i[h+4>>2]=t-1,t))break i;W[i[i[h>>2]+8>>2]](h),y(h)}V=i[e+116>>2],m=i[r>>2],X=i[e+120>>2],i[m+120>>2]=X,i[m+116>>2]=V,i[m+112>>2]=k,i[m+108>>2]=f;i:{e:{r:{f:{A:{k:{n:{t:{u:{o:{l:{s:{if(s=i[e+128>>2],s){for(h=e+128|0,o=h,t=s;w=i[t+16>>2]<10,o=w?o:t,t=i[(w?4:0)+t>>2],!!t;);if(!((o|0)==(h|0)|i[o+16>>2]>10)){for(t=h;o=i[s+16>>2]<10,t=o?t:s,s=i[(o?4:0)+s>>2],!!s;);if(o=255,T0(A,m,10,f,k,(t|0)==(h|0)|i[t+16>>2]>10?o:l[t+24|0],n),i[A>>2])break i;if(u[A+19|0]>=0)break e;Z(i[A+8>>2]);break e}switch(_=h,t=s,o=t,w=t,V|0){case 0:break t;case 1:break s;case 2:break o;default:break A}}switch(V|0){case 1:break l;case 2:break u;case 0:break n;default:break A}}for(;o=i[t+16>>2]<3,_=o?_:t,t=i[(o?4:0)+t>>2],!!t;);if((h|0)==(_|0)|i[_+16>>2]>3)break l;for(o=h,t=s;w=i[t+16>>2]<4,o=w?o:t,t=i[(w?4:0)+t>>2],!!t;);if((o|0)==(h|0)|i[o+16>>2]>4)break l;for(o=h,t=s;w=i[t+16>>2]<5,o=w?o:t,t=i[(w?4:0)+t>>2],!!t;);if((o|0)==(h|0)|i[o+16>>2]>=6)break l;for(t=h;o=i[s+16>>2]<3,t=o?t:s,s=i[(o?4:0)+s>>2],!!s;);if(o=255,T0(A,m,3,f,k,(t|0)==(h|0)|i[t+16>>2]>3?o:l[t+24|0],n),i[A>>2]||(u[A+19|0]<0&&Z(i[A+8>>2]),T0(A,i[r>>2],4,f,k,j0(e,4),n),i[A>>2])||(u[A+19|0]<0&&Z(i[A+8>>2]),T0(A,i[r>>2],5,f,k,j0(e,5),n),i[A>>2]))break i;if(u[A+19|0]>=0)break r;Z(i[A+8>>2]);break r}if(e=p(32),i[B+4>>2]=e,i[B+8>>2]=31,i[B+12>>2]=-2147483616,r=l[5334]|l[5335]<<8|(l[5336]<<16|l[5337]<<24),f=l[5330]|l[5331]<<8|(l[5332]<<16|l[5333]<<24),u[e|0]=f,u[e+1|0]=f>>>8,u[e+2|0]=f>>>16,u[e+3|0]=f>>>24,u[e+4|0]=r,u[e+5|0]=r>>>8,u[e+6|0]=r>>>16,u[e+7|0]=r>>>24,u[e+31|0]=0,r=l[5357]|l[5358]<<8|(l[5359]<<16|l[5360]<<24),f=l[5353]|l[5354]<<8|(l[5355]<<16|l[5356]<<24),u[e+23|0]=f,u[e+24|0]=f>>>8,u[e+25|0]=f>>>16,u[e+26|0]=f>>>24,u[e+27|0]=r,u[e+28|0]=r>>>8,u[e+29|0]=r>>>16,u[e+30|0]=r>>>24,r=l[5350]|l[5351]<<8|(l[5352]<<16|l[5353]<<24),f=l[5346]|l[5347]<<8|(l[5348]<<16|l[5349]<<24),u[e+16|0]=f,u[e+17|0]=f>>>8,u[e+18|0]=f>>>16,u[e+19|0]=f>>>24,u[e+20|0]=r,u[e+21|0]=r>>>8,u[e+22|0]=r>>>16,u[e+23|0]=r>>>24,r=l[5342]|l[5343]<<8|(l[5344]<<16|l[5345]<<24),f=l[5338]|l[5339]<<8|(l[5340]<<16|l[5341]<<24),u[e+8|0]=f,u[e+9|0]=f>>>8,u[e+10|0]=f>>>16,u[e+11|0]=f>>>24,u[e+12|0]=r,u[e+13|0]=r>>>8,u[e+14|0]=r>>>16,u[e+15|0]=r>>>24,q(A,2,0,B+4|0),u[B+15|0]>=0)break i;Z(i[B+4>>2]);break i}for(;t=i[o+16>>2],_=(t|0)<0?_:o,o=i[(t>>>29&4)+o>>2],!!o;);if((h|0)==(_|0)|i[_+16>>2]>0)break u;for(t=h;o=i[s+16>>2],t=(o|0)<0?t:s,s=i[(o>>>29&4)+s>>2],!!s;);if(o=255,T0(A,m,0,f,k,(t|0)==(h|0)|i[t+16>>2]>0?o:l[t+24|0],n),i[A>>2])break i;if(u[A+19|0]>=0)break r;Z(i[A+8>>2]);break r}if(e=p(40),i[B+4>>2]=e,i[B+8>>2]=32,i[B+12>>2]=-2147483608,r=l[12931]|l[12932]<<8|(l[12933]<<16|l[12934]<<24),f=l[12927]|l[12928]<<8|(l[12929]<<16|l[12930]<<24),u[e|0]=f,u[e+1|0]=f>>>8,u[e+2|0]=f>>>16,u[e+3|0]=f>>>24,u[e+4|0]=r,u[e+5|0]=r>>>8,u[e+6|0]=r>>>16,u[e+7|0]=r>>>24,u[e+32|0]=0,r=l[12955]|l[12956]<<8|(l[12957]<<16|l[12958]<<24),f=l[12951]|l[12952]<<8|(l[12953]<<16|l[12954]<<24),u[e+24|0]=f,u[e+25|0]=f>>>8,u[e+26|0]=f>>>16,u[e+27|0]=f>>>24,u[e+28|0]=r,u[e+29|0]=r>>>8,u[e+30|0]=r>>>16,u[e+31|0]=r>>>24,r=l[12947]|l[12948]<<8|(l[12949]<<16|l[12950]<<24),f=l[12943]|l[12944]<<8|(l[12945]<<16|l[12946]<<24),u[e+16|0]=f,u[e+17|0]=f>>>8,u[e+18|0]=f>>>16,u[e+19|0]=f>>>24,u[e+20|0]=r,u[e+21|0]=r>>>8,u[e+22|0]=r>>>16,u[e+23|0]=r>>>24,r=l[12939]|l[12940]<<8|(l[12941]<<16|l[12942]<<24),f=l[12935]|l[12936]<<8|(l[12937]<<16|l[12938]<<24),u[e+8|0]=f,u[e+9|0]=f>>>8,u[e+10|0]=f>>>16,u[e+11|0]=f>>>24,u[e+12|0]=r,u[e+13|0]=r>>>8,u[e+14|0]=r>>>16,u[e+15|0]=r>>>24,q(A,2,0,B+4|0),u[B+15|0]>=0)break i;Z(i[B+4>>2]);break i}for(;t=i[w+16>>2],_=(t|0)<0?_:w,w=i[(t>>>29&4)+w>>2],!!w;);if((h|0)==(_|0)|i[_+16>>2]>0)break n;for(t=h;o=i[s+16>>2]<=0,t=o?t:s,s=i[(o?4:0)+s>>2],!!s;);if((t|0)==(h|0)|i[t+16>>2]>1)break n;if(u1(e,2))break k}if(e=p(40),i[B+4>>2]=e,i[B+8>>2]=34,i[B+12>>2]=-2147483608,r=l[5299]|l[5300]<<8|(l[5301]<<16|l[5302]<<24),f=l[5295]|l[5296]<<8|(l[5297]<<16|l[5298]<<24),u[e|0]=f,u[e+1|0]=f>>>8,u[e+2|0]=f>>>16,u[e+3|0]=f>>>24,u[e+4|0]=r,u[e+5|0]=r>>>8,u[e+6|0]=r>>>16,u[e+7|0]=r>>>24,u[e+34|0]=0,r=l[5327]|l[5328]<<8,u[e+32|0]=r,u[e+33|0]=r>>>8,r=l[5323]|l[5324]<<8|(l[5325]<<16|l[5326]<<24),f=l[5319]|l[5320]<<8|(l[5321]<<16|l[5322]<<24),u[e+24|0]=f,u[e+25|0]=f>>>8,u[e+26|0]=f>>>16,u[e+27|0]=f>>>24,u[e+28|0]=r,u[e+29|0]=r>>>8,u[e+30|0]=r>>>16,u[e+31|0]=r>>>24,r=l[5315]|l[5316]<<8|(l[5317]<<16|l[5318]<<24),f=l[5311]|l[5312]<<8|(l[5313]<<16|l[5314]<<24),u[e+16|0]=f,u[e+17|0]=f>>>8,u[e+18|0]=f>>>16,u[e+19|0]=f>>>24,u[e+20|0]=r,u[e+21|0]=r>>>8,u[e+22|0]=r>>>16,u[e+23|0]=r>>>24,r=l[5307]|l[5308]<<8|(l[5309]<<16|l[5310]<<24),f=l[5303]|l[5304]<<8|(l[5305]<<16|l[5306]<<24),u[e+8|0]=f,u[e+9|0]=f>>>8,u[e+10|0]=f>>>16,u[e+11|0]=f>>>24,u[e+12|0]=r,u[e+13|0]=r>>>8,u[e+14|0]=r>>>16,u[e+15|0]=r>>>24,q(A,2,0,B+4|0),u[B+15|0]>=0)break i;Z(i[B+4>>2]);break i}if(OA(f,k,1,X,B+4|0,B),T0(A,i[r>>2],0,f,k,j0(e,0),n),i[A>>2]||(u[A+19|0]<0&&Z(i[A+8>>2]),T0(A,i[r>>2],1,i[B+4>>2],i[B>>2],j0(e,1),n),i[A>>2]))break i;if(u[A+19|0]<0&&Z(i[A+8>>2]),T0(A,i[r>>2],2,i[B+4>>2],i[B>>2],j0(e,2),n),t=i[A>>2],t|u[A+19|0]>=0)break f;Z(i[A+8>>2]);break r}if(e=p(32),i[B+4>>2]=e,i[B+8>>2]=27,i[B+12>>2]=-2147483616,r=l[8299]|l[8300]<<8|(l[8301]<<16|l[8302]<<24),f=l[8295]|l[8296]<<8|(l[8297]<<16|l[8298]<<24),u[e|0]=f,u[e+1|0]=f>>>8,u[e+2|0]=f>>>16,u[e+3|0]=f>>>24,u[e+4|0]=r,u[e+5|0]=r>>>8,u[e+6|0]=r>>>16,u[e+7|0]=r>>>24,u[e+27|0]=0,r=l[8318]|l[8319]<<8|(l[8320]<<16|l[8321]<<24),u[e+23|0]=r,u[e+24|0]=r>>>8,u[e+25|0]=r>>>16,u[e+26|0]=r>>>24,r=l[8315]|l[8316]<<8|(l[8317]<<16|l[8318]<<24),f=l[8311]|l[8312]<<8|(l[8313]<<16|l[8314]<<24),u[e+16|0]=f,u[e+17|0]=f>>>8,u[e+18|0]=f>>>16,u[e+19|0]=f>>>24,u[e+20|0]=r,u[e+21|0]=r>>>8,u[e+22|0]=r>>>16,u[e+23|0]=r>>>24,r=l[8307]|l[8308]<<8|(l[8309]<<16|l[8310]<<24),f=l[8303]|l[8304]<<8|(l[8305]<<16|l[8306]<<24),u[e+8|0]=f,u[e+9|0]=f>>>8,u[e+10|0]=f>>>16,u[e+11|0]=f>>>24,u[e+12|0]=r,u[e+13|0]=r>>>8,u[e+14|0]=r>>>16,u[e+15|0]=r>>>24,q(A,2,0,B+4|0),u[B+15|0]>=0)break i;Z(i[B+4>>2]);break i}if(t)break i}if(t=i[h>>2],!t)break e;for(o=h;s=i[t+16>>2]<6,o=s?o:t,t=i[(s?4:0)+t>>2],!!t;);if((o|0)==(h|0)|i[o+16>>2]>6)break e;if(T0(A,i[r>>2],6,f,k,j0(e,6),n),i[A>>2])break i;if(u[A+19|0]>=0)break e;Z(i[A+8>>2])}n=1;e:{r:switch(i[e+120>>2]){case 10:case 12:case 14:n=3;break e;case 11:case 13:case 15:n=4;break e;case 0:case 1:case 2:case 3:case 99:break e;default:break r}n=0}e:{r:{if(n>>>0>=2){t=i[h>>2];f:{A:{if(!t)break A;for(w=h;o=i[t+16>>2]<10,w=o?w:t,t=i[(o?4:0)+t>>2],!!t;);if((w|0)==(h|0))break A;if(i[w+16>>2]<11)break f}w=h}if(r=i[r>>2],t=i[r+128>>2],!t)break e;for(r=r+128|0,s=r,o=t;h=i[o+16>>2]<10,s=h?s:o,o=i[(h?4:0)+o>>2],!!o;);h=0;f:{if((r|0)==(s|0)||(h=0,i[s+16>>2]>10))break f;h=i[s+28>>2]}for(s=r,o=t;_=i[o+16>>2]<10,s=_?s:o,o=i[(_?4:0)+o>>2],!!o;);if(F=(r|0)==(s|0)|i[s+16>>2]>10?F:i[s+32>>2],V=i[w+44>>2],X=i[w+56>>2],l[w+24|0]>8)break r;for(o=r;s=i[t+16>>2]<10,o=s?o:t,t=i[(s?4:0)+t>>2],!!t;);t=0;f:{if((r|0)==(o|0)||(t=0,i[o+16>>2]>10))break f;Q=i[o+44>>2],t=i[o+56>>2]}if(!F)break e;for(r=t,R=n&4,N=n&3,_=0;;){if(h)for(M=G(r,_)+Q|0,E=V+G(X,(G(i[e+112>>2],_)>>>0)/(k>>>0)|0)|0,m=0;;){if(o=M+G(n,m)|0,w=E+G((G(i[e+108>>2],m)>>>0)/(f>>>0)|0,n)|0,t=0,s=0,n>>>0>3)for(;u[t+o|0]=l[t+w|0],I=t|1,u[I+o|0]=l[w+I|0],I=t|2,u[I+o|0]=l[w+I|0],I=t|3,u[I+o|0]=l[w+I|0],t=t+4|0,s=s+4|0,(R|0)!=(s|0););if(s=0,N)for(;u[t+o|0]=l[t+w|0],t=t+1|0,s=s+1|0,(N|0)!=(s|0););if(m=m+1|0,(h|0)==(m|0))break}if(_=_+1|0,(F|0)==(_|0))break}break e}if(m=i[e+124>>2],(h|0)==(m|0))break e;for(;;){f:{n=i[r>>2],w=i[n+128>>2];A:{if(!w)break A;for(o=i[m+16>>2],n=n+128|0,s=n,t=w;_=(o|0)>i[t+16>>2],s=_?s:t,t=i[(_?4:0)+t>>2],!!t;);if((n|0)==(s|0))break A;if(_=n,t=w,(o|0)>=i[s+16>>2])break f}if(e=p(40),i[B+4>>2]=e,i[B+8>>2]=35,i[B+12>>2]=-2147483608,r=l[12895]|l[12896]<<8|(l[12897]<<16|l[12898]<<24),f=l[12891]|l[12892]<<8|(l[12893]<<16|l[12894]<<24),u[e|0]=f,u[e+1|0]=f>>>8,u[e+2|0]=f>>>16,u[e+3|0]=f>>>24,u[e+4|0]=r,u[e+5|0]=r>>>8,u[e+6|0]=r>>>16,u[e+7|0]=r>>>24,u[e+35|0]=0,r=l[12922]|l[12923]<<8|(l[12924]<<16|l[12925]<<24),u[e+31|0]=r,u[e+32|0]=r>>>8,u[e+33|0]=r>>>16,u[e+34|0]=r>>>24,r=l[12919]|l[12920]<<8|(l[12921]<<16|l[12922]<<24),f=l[12915]|l[12916]<<8|(l[12917]<<16|l[12918]<<24),u[e+24|0]=f,u[e+25|0]=f>>>8,u[e+26|0]=f>>>16,u[e+27|0]=f>>>24,u[e+28|0]=r,u[e+29|0]=r>>>8,u[e+30|0]=r>>>16,u[e+31|0]=r>>>24,r=l[12911]|l[12912]<<8|(l[12913]<<16|l[12914]<<24),f=l[12907]|l[12908]<<8|(l[12909]<<16|l[12910]<<24),u[e+16|0]=f,u[e+17|0]=f>>>8,u[e+18|0]=f>>>16,u[e+19|0]=f>>>24,u[e+20|0]=r,u[e+21|0]=r>>>8,u[e+22|0]=r>>>16,u[e+23|0]=r>>>24,r=l[12903]|l[12904]<<8|(l[12905]<<16|l[12906]<<24),f=l[12899]|l[12900]<<8|(l[12901]<<16|l[12902]<<24),u[e+8|0]=f,u[e+9|0]=f>>>8,u[e+10|0]=f>>>16,u[e+11|0]=f>>>24,u[e+12|0]=r,u[e+13|0]=r>>>8,u[e+14|0]=r>>>16,u[e+15|0]=r>>>24,q(A,2,0,B+4|0),u[B+15|0]>=0)break i;Z(i[B+4>>2]);break i}for(;s=(o|0)>i[t+16>>2],_=s?_:t,t=i[(s?4:0)+t>>2],!!t;);for(Q=0,Q=(n|0)==(_|0)|(o|0)<i[_+16>>2]?Q:i[_+28>>2],s=n,t=w;_=(o|0)>i[t+16>>2],s=_?s:t,t=i[(_?4:0)+t>>2],!!t;);V=0,V=(n|0)==(s|0)|(o|0)<i[s+16>>2]?V:i[s+32>>2],N=i[m+44>>2],X=i[m+56>>2],t=n,s=t;f:{if(l[m+24|0]<=8){for(;s=(o|0)>i[w+16>>2],t=s?t:w,w=i[(s?4:0)+w>>2],!!w;);A:{if((n|0)==(t|0)){F=0,n=0;break A}if(F=0,n=0,(o|0)<i[t+16>>2])break A;F=i[t+56>>2],n=i[t+44>>2]}if(!V)break f;for(R=Q&-2,M=Q&1,_=0;;){A:{if(!Q)break A;if(o=n+G(_,F)|0,w=N+G(X,(G(i[e+112>>2],_)>>>0)/(k>>>0)|0)|0,t=0,s=0,(Q|0)!=1)for(;u[t+o|0]=l[w+((G(i[e+108>>2],t)>>>0)/(f>>>0)|0)|0],E=t|1,u[E+o|0]=l[w+((G(E,i[e+108>>2])>>>0)/(f>>>0)|0)|0],t=t+2|0,s=s+2|0,(R|0)!=(s|0););if(!M)break A;u[t+o|0]=l[w+((G(i[e+108>>2],t)>>>0)/(f>>>0)|0)|0]}if(_=_+1|0,(V|0)==(_|0))break}break f}for(;t=(o|0)>i[w+16>>2],s=t?s:w,w=i[(t?4:0)+w>>2],!!w;);A:{if((n|0)==(s|0)){F=0,n=0;break A}if(F=0,n=0,(o|0)<i[s+16>>2])break A;F=i[s+56>>2]>>>1|0,n=i[s+44>>2]}if(!V)break f;for(o=n,R=X>>>1|0,M=Q&-2,E=Q&1,w=i[e+108>>2],I=i[e+112>>2],n=0;;){A:{if(!Q)break A;if(_=o+(G(n,F)<<1)|0,X=N+(G(R,(G(n,I)>>>0)/(k>>>0)|0)<<1)|0,t=0,s=0,(Q|0)!=1)for(;g[_+(t<<1)>>1]=C[X+((G(t,w)>>>0)/(f>>>0)<<1)>>1],S=t|1,g[_+(S<<1)>>1]=C[X+((G(w,S)>>>0)/(f>>>0)<<1)>>1],t=t+2|0,s=s+2|0,(M|0)!=(s|0););if(!E)break A;g[_+(t<<1)>>1]=C[X+((G(t,w)>>>0)/(f>>>0)<<1)>>1]}if(n=n+1|0,(V|0)==(n|0))break}}o=i[m+4>>2];f:{if(o){for(;;)if(t=o,o=i[t>>2],!o)break f}for(;t=i[m+8>>2],n=i[t>>2]!=(m|0),m=t,!!n;);}if(m=t,(t|0)==(h|0))break}break e}for(o=r;s=i[t+16>>2]<10,o=s?o:t,t=i[(s?4:0)+t>>2],!!t;);t=0;r:{if((r|0)==(o|0)||(t=0,i[o+16>>2]>10))break r;Q=i[o+44>>2],t=i[o+56>>2]>>>1|0}if(!F)break e;for(r=t,N=X>>>1|0,R=n&4,X=n&3,M=i[e+108>>2],E=i[e+112>>2],m=0;;){if(h)for(I=(G(r,m)<<1)+Q|0,S=V+(G(N,(G(m,E)>>>0)/(k>>>0)|0)<<1)|0,e=0;;){if(o=I+(G(e,n)<<1)|0,w=S+(G((G(e,M)>>>0)/(f>>>0)|0,n)<<1)|0,t=0,_=0,n>>>0>3)for(;s=t<<1,g[s+o>>1]=C[s+w>>1],z=s|2,g[z+o>>1]=C[w+z>>1],z=s|4,g[z+o>>1]=C[w+z>>1],s=s|6,g[s+o>>1]=C[s+w>>1],t=t+4|0,_=_+4|0,(R|0)!=(_|0););if(s=0,X)for(;_=t<<1,g[_+o>>1]=C[w+_>>1],t=t+1|0,s=s+1|0,(X|0)!=(s|0););if(e=e+1|0,(h|0)==(e|0))break}if(m=m+1|0,(F|0)==(m|0))break}}if(e=i[26917],i[A>>2]=i[26916],i[A+4>>2]=e,A=A+8|0,u[107683]>=0){e=i[26919],i[A>>2]=i[26918],i[A+4>>2]=e,i[A+8>>2]=i[26920];break i}T(A,i[26918],i[26919])}v=B+16|0}function O_(A,e,r,f,k,n,t){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,t=t|0;var o=0,s=0,w=0,h=0,_=0,B=0,m=0,X=0,Q=0,V=0,F=0,I=0,E=0,R=0,N=0,M=0;o=v-208|0,v=o,i[o+196>>2]=n,i[o+200>>2]=k;i:{e:{if(!f){if(n=i[e+104>>2],k=i[e+108>>2],(n|0)==(k|0))break e;for(;;){r:{if(w=i[n>>2],!w||(w=W0(w,86580,86600),!w))break r;k=i[n+4>>2],k&&(i[k+4>>2]=i[k+4>>2]+1),di(o+168|0,i[e+100>>2]- -64|0,i[w+104>>2],i[w+108>>2]),w=i[o+168>>2];f:{if(w){if(n=i[o+172>>2],i[A>>2]=i[o+168>>2],i[A+4>>2]=n,n=A+8|0,u[o+187|0]>=0){s=i[o+180>>2],i[n>>2]=i[o+176>>2],i[n+4>>2]=s,i[n+8>>2]=i[o+184>>2],u[A+20|0]=1;break f}if(T(n,i[o+176>>2],i[o+180>>2]),n=u[o+187|0],u[A+20|0]=1,(n|0)>=0)break f;Z(i[o+176>>2]);break f}if(u[o+187|0]>=0)break f;Z(i[o+176>>2])}f:{if(!k||(n=i[k+4>>2],i[k+4>>2]=n-1,n))break f;W[i[i[k>>2]+8>>2]](k),y(k)}if(!w)break e;break i}if(n=n+8|0,(k|0)==(n|0))break}break e}if(l[r+1|0])break e;if(An(o+168|0,e,o+200|0,o+196|0),n=i[o+168>>2],n){k=i[o+172>>2],i[A>>2]=i[o+168>>2],i[A+4>>2]=k,k=A+8|0;r:{if(u[o+187|0]>=0){w=i[o+180>>2],i[k>>2]=i[o+176>>2],i[k+4>>2]=w,i[k+8>>2]=i[o+184>>2];break r}T(k,i[o+176>>2],i[o+180>>2])}u[A+20|0]=1}if(u[o+187|0]<0&&Z(i[o+176>>2]),n)break i}i[o+160>>2]=0,i[o+164>>2]=0,i[o+156>>2]=o+160,n=i[o+200>>2],w=i[o+196>>2],k=o+156|0,E=t+4|0,t8(k,i[t>>2],E),W[i[i[e>>2]+104>>2]](o+168|0,e,r,f,n,w,k),Y1(k,i[o+160>>2]);e:{r:{f:{A:{k:{n:{t:{u:{o:{l:{s:switch(l[o+188|0]){case 1:e=i[o+172>>2],i[A>>2]=i[o+168>>2],i[A+4>>2]=e,e=A+8|0;w:{if(u[o+187|0]>=0){r=i[o+180>>2],i[e>>2]=i[o+176>>2],i[e+4>>2]=r,i[e+8>>2]=i[o+184>>2];break w}T(e,i[o+176>>2],i[o+180>>2])}u[A+20|0]=1;break e;case 0:break s;default:break l}if(_=i[o+168>>2],w=i[o+172>>2],w&&(i[w+4>>2]=i[w+4>>2]+1),!_){u[o+80|0]=0,u[o+91|0]=0,e=q(o+112|0,7,0,o+80|0),r=i[e+4>>2],i[A>>2]=i[e>>2],i[A+4>>2]=r,r=A+8|0;s:{if(u[e+19|0]>=0){f=i[e+12>>2],i[r>>2]=i[e+8>>2],i[r+4>>2]=f,i[r+8>>2]=i[e+16>>2],u[A+20|0]=1;break s}if(T(r,i[e+8>>2],i[e+12>>2]),r=u[e+19|0],u[A+20|0]=1,(r|0)>=0)break s;Z(i[e+8>>2])}if(u[o+91|0]>=0)break r;Z(i[o+80>>2]);break r}k=i[e+100>>2],R=i[k+48>>2],V=i[k+52>>2],V&&(i[V+4>>2]=i[V+4>>2]+1),X=o+136|0,k=X,i[k>>2]=0,i[k+4>>2]=0,i[k+16>>2]=0,i[k+8>>2]=0,i[k+12>>2]=0;s:{if(l[r+1|0])break s;bi(o+112|0,e);w:switch(l[o+132|0]){case 1:e=i[o+116>>2],i[A>>2]=i[o+112>>2],i[A+4>>2]=e,e=A+8|0;_:{if(u[o+131|0]>=0){r=i[o+124>>2],i[e>>2]=i[o+120>>2],i[e+4>>2]=r,i[e+8>>2]=i[o+128>>2],n=1,u[A+20|0]=1;break _}if(T(e,i[o+120>>2],i[o+124>>2]),n=l[o+132|0],u[A+20|0]=1,(n|0)==255)break f}A=i[25179],i[o+80>>2]=i[25178],i[o+84>>2]=A,W[i[(o+80|0)+(n<<2)>>2]](o+56|0,o+112|0);break f;case 0:break w;default:break l}n=i[o+112>>2],N=i[o+116>>2];w:{if((n|0)==(N|0)){n=0;break w}for(B=A+8|0,k=i[25180],Q=i[25181];;){s=i[n>>2];_:{if(!s||(h=W0(s,86580,87892),!h))break _;i[o+104>>2]=h,s=i[n+4>>2],i[o+108>>2]=s,s&&(i[s+4>>2]=i[s+4>>2]+1),R7(o+80|0,_,i[h+100>>2],i[e+100>>2]- -64|0),h=l[o+100|0];h:{if(h){if(s=i[X+4>>2],i[A>>2]=i[X>>2],i[A+4>>2]=s,u[X+19|0]>=0){s=i[X+12>>2],i[B>>2]=i[X+8>>2],i[B+4>>2]=s,i[B+8>>2]=i[X+16>>2],u[A+20|0]=1;break h}T(B,i[X+8>>2],i[X+12>>2]),u[A+20|0]=1;break h}s=i[o+84>>2],s&&(i[s+4>>2]=i[s+4>>2]+1),_=i[o+80>>2];B:{if(!w||(m=i[w+4>>2],i[w+4>>2]=m-1,m))break B;W[i[i[w>>2]+8>>2]](w),y(w)}w=s}if(s=l[o+100|0],(s|0)!=255&&(i[o+56>>2]=k,i[o+60>>2]=Q,W[i[(o+56|0)+(s<<2)>>2]](o+72|0,o+80|0)),h)break A;if(s=i[o+108>>2],!s||(h=i[s+4>>2],i[s+4>>2]=h-1,h))break _;W[i[i[s>>2]+8>>2]](s),y(s)}s=i[n>>2];_:{if(!s||(h=W0(s,86580,87972),!h))break _;i[o+104>>2]=h,s=i[n+4>>2],i[o+108>>2]=s,s&&(i[s+4>>2]=i[s+4>>2]+1),D7(o+80|0,_,i[h+100>>2],i[e+100>>2]- -64|0),h=l[o+100|0];h:{if(h){if(s=i[X+4>>2],i[A>>2]=i[X>>2],i[A+4>>2]=s,u[X+19|0]>=0){s=i[X+12>>2],i[B>>2]=i[X+8>>2],i[B+4>>2]=s,i[B+8>>2]=i[X+16>>2],u[A+20|0]=1;break h}T(B,i[X+8>>2],i[X+12>>2]),u[A+20|0]=1;break h}s=i[o+84>>2],s&&(i[s+4>>2]=i[s+4>>2]+1),_=i[o+80>>2];B:{if(!w||(m=i[w+4>>2],i[w+4>>2]=m-1,m))break B;W[i[i[w>>2]+8>>2]](w),y(w)}w=s}if(s=l[o+100|0],(s|0)!=255&&(i[o+56>>2]=k,i[o+60>>2]=Q,W[i[(o+56|0)+(s<<2)>>2]](o+72|0,o+80|0)),h)break A;if(s=i[o+108>>2],!s||(h=i[s+4>>2],i[s+4>>2]=h-1,h))break _;W[i[i[s>>2]+8>>2]](s),y(s)}_:{if(f||(s=i[n>>2],!s)||(s=W0(s,86580,88052),!s))break _;i[o+104>>2]=s,h=i[n+4>>2],i[o+108>>2]=h,h&&(i[h+4>>2]=i[h+4>>2]+1),i[o+72>>2]=0,i[o+76>>2]=0,h=i[_+112>>2],m=i[_+108>>2],F=$i(s,m),I=bf(s,m),M=qi(s,h),s=cf(s,h);h:{if(F=(F|0)>0?F:0,m=m>>>0>I>>>0?I:m-1|0,(F|0)<=(m|0)&&(I=(M|0)>0?M:0,s=s>>>0<h>>>0?s:h-1|0,(I|0)<=(s|0)))break h;r=d2(o+56|0,42673),e=q(o+80|0,2,120,r),f=i[e+4>>2],i[A>>2]=i[e>>2],i[A+4>>2]=f;B:{if(u[e+19|0]>=0){f=i[e+12>>2],i[B>>2]=i[e+8>>2],i[B+4>>2]=f,i[B+8>>2]=i[e+16>>2],u[A+20|0]=1;break B}if(T(B,i[e+8>>2],i[e+12>>2]),f=u[e+19|0],u[A+20|0]=1,(f|0)>=0)break B;Z(i[e+8>>2])}u[r+11|0]<0&&Z(i[r>>2]),I2(o+72|0);break A}Ff(o+80|0,_,F,m,I,s,i[e+100>>2]- -64|0),h=l[o+100|0];h:{if(h){if((h|0)!=1)break l;if(s=i[o+84>>2],i[A>>2]=i[o+80>>2],i[A+4>>2]=s,u[o+99|0]>=0){s=i[o+92>>2],i[B>>2]=i[o+88>>2],i[B+4>>2]=s,i[B+8>>2]=i[o+96>>2],u[A+20|0]=1;break h}T(B,i[o+88>>2],i[o+92>>2]),u[A+20|0]=1;break h}s=i[o+84>>2],s&&(i[s+4>>2]=i[s+4>>2]+1),_=i[o+80>>2];B:{if(!w||(m=i[w+4>>2],i[w+4>>2]=m-1,m))break B;W[i[i[w>>2]+8>>2]](w),y(w)}w=s}s=l[o+100|0],(s|0)!=255&&(i[o+56>>2]=k,i[o+60>>2]=Q,W[i[(o+56|0)+(s<<2)>>2]](o+207|0,o+80|0)),s=i[o+76>>2];h:{if(!s||(m=i[s+4>>2],i[s+4>>2]=m-1,m))break h;W[i[i[s>>2]+8>>2]](s),y(s)}if(h)break A;if(s=i[o+108>>2],!s||(h=i[s+4>>2],i[s+4>>2]=h-1,h))break _;W[i[i[s>>2]+8>>2]](s),y(s)}if(n=n+8|0,(N|0)==(n|0))break}if(n=l[o+132|0],(n|0)==255)break s}k=i[25179],i[o+80>>2]=i[25178],i[o+84>>2]=k,W[i[(o+80|0)+(n<<2)>>2]](o+56|0,o+112|0)}if(k=i[e+148>>2],h=i[e+152>>2],h&&(i[h+4>>2]=i[h+4>>2]+1),!k)break t;if(W[i[i[k>>2]+52>>2]](o+112|0,k),n=i[o+112>>2],u[o+131|0]<0&&Z(i[o+120>>2]),n){if(W[i[i[k>>2]+52>>2]](o+112|0,k),e=i[o+116>>2],i[A>>2]=i[o+112>>2],i[A+4>>2]=e,e=A+8|0,u[o+131|0]>=0){r=i[o+124>>2],i[e>>2]=i[o+120>>2],i[e+4>>2]=r,i[e+8>>2]=i[o+128>>2],u[A+20|0]=1;break k}if(T(e,i[o+120>>2],i[o+124>>2]),e=u[o+131|0],u[A+20|0]=1,(e|0)>=0)break k;Z(i[o+120>>2]);break k}switch(i[o+48>>2]=0,i[o+52>>2]=0,i[o+44>>2]=o+48,s=i[o+200>>2],B=i[o+196>>2],n=o+44|0,t8(n,i[t>>2],E),W[i[i[k>>2]+100>>2]](o+112|0,k,r,f,s,B,n),Y1(n,i[o+48>>2]),l[o+132|0]){case 0:break u;case 1:break o;default:break l}}_2(),H()}if(e=A,A=o+112|0,D6(e,A),e=l[o+132|0],(e|0)==255)break k;r=i[25181],i[o+80>>2]=i[25180],i[o+84>>2]=r,W[i[(o+80|0)+(e<<2)>>2]](o+56|0,A);break k}if(f=i[o+112>>2],i[o+104>>2]=f,r=i[o+116>>2],i[o+108>>2]=r,r&&(i[r+4>>2]=i[r+4>>2]+1),r=i[f+116>>2],r>>>0>=3){f=d2(o+56|0,42673),e=q(o+80|0,2,3003,f),r=i[e+4>>2],i[A>>2]=i[e>>2],i[A+4>>2]=r,r=A+8|0;u:{if(u[e+19|0]>=0){k=i[e+12>>2],i[r>>2]=i[e+8>>2],i[r+4>>2]=k,i[r+8>>2]=i[e+16>>2],u[A+20|0]=1;break u}if(T(r,i[e+8>>2],i[e+12>>2]),r=u[e+19|0],u[A+20|0]=1,(r|0)>=0)break u;Z(i[e+8>>2])}if(u[f+11|0]>=0)break n;Z(i[f>>2]);break n}t=i[(r<<2)+54648>>2],r=i[_+108>>2];u:{o:{if((r|0)!=i[k+120>>2]){n=i[_+112>>2];break o}if(n=i[_+112>>2],(n|0)==i[k+124>>2])break u}i[o+56>>2]=0,i[o+60>>2]=0,Bf(o+80|0,f,o+56|0,r,n,i[e+100>>2]- -64|0),f=i[o+80>>2];o:{if(f){r=i[o+84>>2],i[A>>2]=i[o+80>>2],i[A+4>>2]=r,r=A+8|0;l:{if(u[o+99|0]>=0){k=i[o+92>>2],i[r>>2]=i[o+88>>2],i[r+4>>2]=k,i[r+8>>2]=i[o+96>>2];break l}T(r,i[o+88>>2],i[o+92>>2])}u[A+20|0]=1;break o}if(k=i[o+56>>2],n=i[o+60>>2],i[o+56>>2]=0,i[o+60>>2]=0,r=i[o+108>>2],i[o+104>>2]=k,i[o+108>>2]=n,!r||(k=i[r+4>>2],i[r+4>>2]=k-1,k))break o;W[i[i[r>>2]+8>>2]](r),y(r)}if(u[o+99|0]<0&&Z(i[o+88>>2]),I2(o+56|0),f)break n}if(J9(_,o+104|0,t),l[e+145|0]==1&&W[i[i[_>>2]+16>>2]](_,1),I2(o+104|0),r=l[o+132|0],(r|0)==255)break t;f=i[25181],i[o+80>>2]=i[25180],i[o+84>>2]=f,W[i[(o+80|0)+(r<<2)>>2]](o+56|0,o+112|0)}r=C[e+10>>1]|C[e+12>>1]<<16,i[o+112>>2]=C[e+6>>1]|C[e+8>>1]<<16,i[o+116>>2]=r,f=0,r=o+112|0,C[r>>1]!=2|C[r+2>>1]!=2|C[r+4>>1]!=2||(f=l[r+6|0]),f||W[i[i[_>>2]+8>>2]](_,r),f=i[e+16>>2],i[o+80>>2]=f,r=i[e+20>>2],i[o+84>>2]=r,r&&(i[r+4>>2]=i[r+4>>2]+1),f&&W[i[i[_>>2]+12>>2]](_,o+80|0),Q=i[R+56>>2],Q&&(i[Q+4>>2]=i[Q+4>>2]+1),m=i[R+64>>2],m&&(i[m+4>>2]=i[m+4>>2]+1),r=i[e+104>>2],n=i[e+108>>2];t:{u:{if((r|0)==(n|0)){t=0,s=0,B=0;break u}k=r;o:{for(;;){l:{if(f=i[k>>2],!f||(f=W0(f,86580,89092),!f))break l;s=i[k+4>>2],s&&(i[s+4>>2]=i[s+4>>2]+1),W[i[i[_>>2]+24>>2]](_,f+98|0),n=i[e+108>>2],r=i[e+104>>2];break o}if(k=k+8|0,(n|0)==(k|0))break}s=0}t=0;o:{if((r|0)!=(n|0))for(k=r;;){l:{if(f=i[k>>2],!f||(f=W0(f,86580,89104),!f))break l;B=i[k+4>>2],B&&(i[B+4>>2]=i[B+4>>2]+1),W[i[i[_>>2]+28>>2]](_,f+100|0),n=i[e+108>>2],r=i[e+104>>2];break o}if(k=k+8|0,(n|0)==(k|0))break}B=0}o:{if((r|0)==(n|0))break o;for(k=r;;){l:{if(f=i[k>>2],!f||(f=W0(f,86580,88932),!f))break l;t=i[k+4>>2],t&&(i[t+4>>2]=i[t+4>>2]+1),W[i[i[_>>2]+20>>2]](_,i[f+100>>2],i[f+104>>2]),n=i[e+108>>2],r=i[e+104>>2];break o}if(k=k+8|0,(n|0)==(k|0))break}}if((r|0)==(n|0))break u;for(;;){o:{if(f=i[r>>2],!f||(k=W0(f,86580,86636),!k))break o;if(f=i[r+4>>2],f&&(i[f+4>>2]=i[f+4>>2]+1),W[i[i[_>>2]+32>>2]](o+24|0,_,k+104|0),u[o+43|0]>=0)break t;Z(i[o+32>>2]);break t}if(r=r+8|0,(n|0)==(r|0))break}}f=0}n=i[e+104>>2],e=i[e+108>>2];t:{if((n|0)==(e|0))break t;for(;;){u:{if(r=i[n>>2],!r||(r=W0(r,86580,89572),!r))break u;e=i[n+4>>2],e&&(i[e+4>>2]=i[e+4>>2]+1);o:{if(u[r+111|0]>=0){i[o+16>>2]=i[r+108>>2],k=i[r+104>>2],i[o+8>>2]=i[r+100>>2],i[o+12>>2]=k;break o}T(o+8|0,i[r+100>>2],i[r+104>>2])}if(W[i[i[_>>2]+36>>2]](_,o+8|0),u[o+19|0]<0&&Z(i[o+8>>2]),!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break t;W[i[i[e>>2]+8>>2]](e),y(e);break t}if(n=n+8|0,(e|0)==(n|0))break}}t:{if(!f||(e=i[f+4>>2],i[f+4>>2]=e-1,e))break t;W[i[i[f>>2]+8>>2]](f),y(f)}t:{if(!t||(e=i[t+4>>2],i[t+4>>2]=e-1,e))break t;W[i[i[t>>2]+8>>2]](t),y(t)}t:{if(!B||(e=i[B+4>>2],i[B+4>>2]=e-1,e))break t;W[i[i[B>>2]+8>>2]](B),y(B)}t:{if(!s||(e=i[s+4>>2],i[s+4>>2]=e-1,e))break t;W[i[i[s>>2]+8>>2]](s),y(s)}t:{if(!m||(e=i[m+4>>2],i[m+4>>2]=e-1,e))break t;W[i[i[m>>2]+8>>2]](m),y(m)}t:{if(!Q||(e=i[Q+4>>2],i[Q+4>>2]=e-1,e))break t;W[i[i[Q>>2]+8>>2]](Q),y(Q)}u[A+20|0]=0,i[A+4>>2]=w,i[A>>2]=_,A=i[o+84>>2];t:{if(!A||(e=i[A+4>>2],i[A+4>>2]=e-1,e))break t;W[i[i[A>>2]+8>>2]](A),y(A)}w=0;break k}if(I2(o+104|0),A=l[o+132|0],(A|0)==255)break k;e=i[25181],i[o+80>>2]=i[25180],i[o+84>>2]=e,W[i[(o+80|0)+(A<<2)>>2]](o+56|0,o+112|0)}if(!h||(A=i[h+4>>2],i[h+4>>2]=A-1,A))break f;W[i[i[h>>2]+8>>2]](h),y(h);break f}if(I2(o+104|0),A=l[o+132|0],(A|0)==255)break f;e=i[25179],i[o+80>>2]=i[25178],i[o+84>>2]=e,W[i[(o+80|0)+(A<<2)>>2]](o+56|0,o+112|0)}if(u[X+19|0]<0&&Z(i[X+8>>2]),!V||(A=i[V+4>>2],i[V+4>>2]=A-1,A))break r;W[i[i[V>>2]+8>>2]](V),y(V)}if(!w||(A=i[w+4>>2],i[w+4>>2]=A-1,A))break e;W[i[i[w>>2]+8>>2]](w),y(w)}if(A=l[o+188|0],(A|0)==255)break i;e=i[25181],i[o+112>>2]=i[25180],i[o+116>>2]=e,W[i[(o+112|0)+(A<<2)>>2]](o+80|0,o+168|0)}v=o+208|0}function J7(A,e,r){var f=0,k=0,n=0,t=0,o=0,s=0,w=0,h=0,_=0,B=0,m=0,X=0,Q=0;k=e+60|0,(k|0)!=(r|0)&&(f=k,k=i[r>>2],r=i[r+4>>2],d4(f,k,r,r-k|0)),o=v-48|0,v=o,i[e+72>>2]=0,t=o+24|0,k=v-16|0,v=k;i:{e:{if(f=i[e+60>>2],r=i[e+64>>2]-f|0,r>>>0>=2&&(n=r-2|0,r=i[e+72>>2],n>>>0>=r>>>0))break e;if(u[k+4|0]=0,u[k+15|0]=0,q(t,2,140,k+4|0),u[k+15|0]>=0)break i;Z(i[k+4>>2]);break i}if(f=r+f|0,f=l[f|0]|l[f+1|0]<<8,i[e+72>>2]=r+2,((f<<8|f>>>8)&65535)==65359){if(r=i[26917],i[t>>2]=i[26916],i[t+4>>2]=r,r=t+8|0,u[107683]>=0){t=i[26919],i[r>>2]=i[26918],i[r+4>>2]=t,i[r+8>>2]=i[26920];break i}T(r,i[26918],i[26919]);break i}if(r=p(32),i[k+4>>2]=r,i[k+8>>2]=27,i[k+12>>2]=-2147483616,f=l[7180]|l[7181]<<8|(l[7182]<<16|l[7183]<<24),s=l[7176]|l[7177]<<8|(l[7178]<<16|l[7179]<<24),u[r|0]=s,u[r+1|0]=s>>>8,u[r+2|0]=s>>>16,u[r+3|0]=s>>>24,u[r+4|0]=f,u[r+5|0]=f>>>8,u[r+6|0]=f>>>16,u[r+7|0]=f>>>24,u[r+27|0]=0,f=l[7199]|l[7200]<<8|(l[7201]<<16|l[7202]<<24),u[r+23|0]=f,u[r+24|0]=f>>>8,u[r+25|0]=f>>>16,u[r+26|0]=f>>>24,f=l[7196]|l[7197]<<8|(l[7198]<<16|l[7199]<<24),s=l[7192]|l[7193]<<8|(l[7194]<<16|l[7195]<<24),u[r+16|0]=s,u[r+17|0]=s>>>8,u[r+18|0]=s>>>16,u[r+19|0]=s>>>24,u[r+20|0]=f,u[r+21|0]=f>>>8,u[r+22|0]=f>>>16,u[r+23|0]=f>>>24,f=l[7188]|l[7189]<<8|(l[7190]<<16|l[7191]<<24),s=l[7184]|l[7185]<<8|(l[7186]<<16|l[7187]<<24),u[r+8|0]=s,u[r+9|0]=s>>>8,u[r+10|0]=s>>>16,u[r+11|0]=s>>>24,u[r+12|0]=f,u[r+13|0]=f>>>8,u[r+14|0]=f>>>16,u[r+15|0]=f>>>24,q(t,2,140,k+4|0),u[k+15|0]>=0)break i;Z(i[k+4>>2])}v=k+16|0;i:{if(i[o+24>>2]){e=i[o+28>>2],i[A>>2]=i[o+24>>2],i[A+4>>2]=e,i[A+16>>2]=i[o+40>>2],e=i[o+36>>2],i[A+8>>2]=i[o+32>>2],i[A+12>>2]=e,i[o+40>>2]=0,i[o+32>>2]=0,i[o+36>>2]=0;break i}t=v-16|0,v=t;e:{r:{if(k=i[e+60>>2],s=i[e+64>>2]-k|0,s>>>0>=43&&(r=i[e+72>>2],r>>>0<=s-43>>>0))break r;if(u[t+4|0]=0,u[t+15|0]=0,q(o,2,140,t+4|0),u[t+15|0]>=0)break e;Z(i[t+4>>2]);break e}if(f=r+k|0,f=l[f|0]|l[f+1|0]<<8,n=r+2|0,i[e+72>>2]=n,((f<<8|f>>>8)&65535)!=65361){if(r=p(32),i[t+4>>2]=r,i[t+8>>2]=27,i[t+12>>2]=-2147483616,k=l[7152]|l[7153]<<8|(l[7154]<<16|l[7155]<<24),f=l[7148]|l[7149]<<8|(l[7150]<<16|l[7151]<<24),u[r|0]=f,u[r+1|0]=f>>>8,u[r+2|0]=f>>>16,u[r+3|0]=f>>>24,u[r+4|0]=k,u[r+5|0]=k>>>8,u[r+6|0]=k>>>16,u[r+7|0]=k>>>24,u[r+27|0]=0,k=l[7171]|l[7172]<<8|(l[7173]<<16|l[7174]<<24),u[r+23|0]=k,u[r+24|0]=k>>>8,u[r+25|0]=k>>>16,u[r+26|0]=k>>>24,k=l[7168]|l[7169]<<8|(l[7170]<<16|l[7171]<<24),f=l[7164]|l[7165]<<8|(l[7166]<<16|l[7167]<<24),u[r+16|0]=f,u[r+17|0]=f>>>8,u[r+18|0]=f>>>16,u[r+19|0]=f>>>24,u[r+20|0]=k,u[r+21|0]=k>>>8,u[r+22|0]=k>>>16,u[r+23|0]=k>>>24,k=l[7160]|l[7161]<<8|(l[7162]<<16|l[7163]<<24),f=l[7156]|l[7157]<<8|(l[7158]<<16|l[7159]<<24),u[r+8|0]=f,u[r+9|0]=f>>>8,u[r+10|0]=f>>>16,u[r+11|0]=f>>>24,u[r+12|0]=k,u[r+13|0]=k>>>8,u[r+14|0]=k>>>16,u[r+15|0]=k>>>24,q(o,2,140,t+4|0),u[t+15|0]>=0)break e;Z(i[t+4>>2]);break e}if(f=k+n|0,f=l[f|0]|l[f+1|0]<<8,n=r+4|0,i[e+72>>2]=n,((f<<8|f>>>8)+16345&65535)>>>0<=16385){if(r=p(24),i[t+4>>2]=r,i[t+8>>2]=23,i[t+12>>2]=-2147483624,k=l[11932]|l[11933]<<8|(l[11934]<<16|l[11935]<<24),f=l[11928]|l[11929]<<8|(l[11930]<<16|l[11931]<<24),u[r|0]=f,u[r+1|0]=f>>>8,u[r+2|0]=f>>>16,u[r+3|0]=f>>>24,u[r+4|0]=k,u[r+5|0]=k>>>8,u[r+6|0]=k>>>16,u[r+7|0]=k>>>24,u[r+23|0]=0,k=l[11947]|l[11948]<<8|(l[11949]<<16|l[11950]<<24),f=l[11943]|l[11944]<<8|(l[11945]<<16|l[11946]<<24),u[r+15|0]=f,u[r+16|0]=f>>>8,u[r+17|0]=f>>>16,u[r+18|0]=f>>>24,u[r+19|0]=k,u[r+20|0]=k>>>8,u[r+21|0]=k>>>16,u[r+22|0]=k>>>24,k=l[11940]|l[11941]<<8|(l[11942]<<16|l[11943]<<24),f=l[11936]|l[11937]<<8|(l[11938]<<16|l[11939]<<24),u[r+8|0]=f,u[r+9|0]=f>>>8,u[r+10|0]=f>>>16,u[r+11|0]=f>>>24,u[r+12|0]=k,u[r+13|0]=k>>>8,u[r+14|0]=k>>>16,u[r+15|0]=k>>>24,q(o,2,140,t+4|0),u[t+15|0]>=0)break e;Z(i[t+4>>2]);break e}if(f=k+n|0,f=l[f|0]|l[f+1|0]<<8,n=r+6|0,i[e+72>>2]=n,g[e>>1]=f<<8|f>>>8,f=k+n|0,f=l[f|0]|l[f+1|0]<<8|(l[f+2|0]<<16|l[f+3|0]<<24),n=r+10|0,i[e+72>>2]=n,i[e+4>>2]=f<<24|(f&65280)<<8|(f>>>8&65280|f>>>24),f=k+n|0,f=l[f|0]|l[f+1|0]<<8|(l[f+2|0]<<16|l[f+3|0]<<24),n=r+14|0,i[e+72>>2]=n,i[e+8>>2]=f<<24|(f&65280)<<8|(f>>>8&65280|f>>>24),f=k+n|0,f=l[f|0]|l[f+1|0]<<8|(l[f+2|0]<<16|l[f+3|0]<<24),n=r+18|0,i[e+72>>2]=n,i[e+12>>2]=f<<24|(f&65280)<<8|(f>>>8&65280|f>>>24),f=k+n|0,f=l[f|0]|l[f+1|0]<<8|(l[f+2|0]<<16|l[f+3|0]<<24),n=r+22|0,i[e+72>>2]=n,i[e+16>>2]=f<<24|(f&65280)<<8|(f>>>8&65280|f>>>24),f=k+n|0,f=l[f|0]|l[f+1|0]<<8|(l[f+2|0]<<16|l[f+3|0]<<24),n=r+26|0,i[e+72>>2]=n,i[e+20>>2]=f<<24|(f&65280)<<8|(f>>>8&65280|f>>>24),f=k+n|0,f=l[f|0]|l[f+1|0]<<8|(l[f+2|0]<<16|l[f+3|0]<<24),n=r+30|0,i[e+72>>2]=n,i[e+24>>2]=f<<24|(f&65280)<<8|(f>>>8&65280|f>>>24),f=k+n|0,f=l[f|0]|l[f+1|0]<<8|(l[f+2|0]<<16|l[f+3|0]<<24),n=r+34|0,i[e+72>>2]=n,i[e+28>>2]=f<<24|(f&65280)<<8|(f>>>8&65280|f>>>24),f=k+n|0,f=l[f|0]|l[f+1|0]<<8|(l[f+2|0]<<16|l[f+3|0]<<24),n=r+38|0,i[e+72>>2]=n,i[e+32>>2]=f<<24|(f&65280)<<8|(f>>>8&65280|f>>>24),k=k+n|0,k=l[k|0]|l[k+1|0]<<8,r=r+40|0,i[e+72>>2]=r,_=k<<8|k>>>8,(_-16385&65535)>>>0<=49151){if(r=p(24),i[t+4>>2]=r,i[t+8>>2]=23,i[t+12>>2]=-2147483624,k=l[11956]|l[11957]<<8|(l[11958]<<16|l[11959]<<24),f=l[11952]|l[11953]<<8|(l[11954]<<16|l[11955]<<24),u[r|0]=f,u[r+1|0]=f>>>8,u[r+2|0]=f>>>16,u[r+3|0]=f>>>24,u[r+4|0]=k,u[r+5|0]=k>>>8,u[r+6|0]=k>>>16,u[r+7|0]=k>>>24,u[r+23|0]=0,k=l[11971]|l[11972]<<8|(l[11973]<<16|l[11974]<<24),f=l[11967]|l[11968]<<8|(l[11969]<<16|l[11970]<<24),u[r+15|0]=f,u[r+16|0]=f>>>8,u[r+17|0]=f>>>16,u[r+18|0]=f>>>24,u[r+19|0]=k,u[r+20|0]=k>>>8,u[r+21|0]=k>>>16,u[r+22|0]=k>>>24,k=l[11964]|l[11965]<<8|(l[11966]<<16|l[11967]<<24),f=l[11960]|l[11961]<<8|(l[11962]<<16|l[11963]<<24),u[r+8|0]=f,u[r+9|0]=f>>>8,u[r+10|0]=f>>>16,u[r+11|0]=f>>>24,u[r+12|0]=k,u[r+13|0]=k>>>8,u[r+14|0]=k>>>16,u[r+15|0]=k>>>24,q(o,2,140,t+4|0),u[t+15|0]>=0)break e;Z(i[t+4>>2]);break e}if(r>>>0<=s+G(_&65535,-3)>>>0){r=i[e+40>>2];r:{f:{for(;;){f=i[e+60>>2],k=i[e+72>>2],s=l[f+k|0],n=k+1|0,i[e+72>>2]=n,w=l[f+n|0],n=k+2|0,i[e+72>>2]=n,B=l[f+n|0],i[e+72>>2]=k+3,m=s>>>7|0,X=(s&127)+1|0,f=i[e+44>>2];A:{if(f>>>0>r>>>0){k=w|(X<<16|m<<24|B<<8),u[r|0]=k,u[r+1|0]=k>>>8,u[r+2|0]=k>>>16,u[r+3|0]=k>>>24,r=r+4|0;break A}if(s=i[e+36>>2],r=r-s|0,Q=r>>2,k=Q+1|0,k>>>0>=1073741824)break f;if(f=f-s|0,n=f>>1,n=f>>>0>=2147483644?1073741823:k>>>0<n>>>0?n:k,n){if(n>>>0>=1073741824)break r;k=p(n<<2)}else k=0;if(f=k+r|0,w=w|(X<<16|m<<24|B<<8),u[f|0]=w,u[f+1|0]=w>>>8,u[f+2|0]=w>>>16,u[f+3|0]=w>>>24,w=f-(Q<<2)|0,r&&x(w,s,r),i[e+44>>2]=k+(n<<2),r=f+4|0,i[e+40>>2]=r,i[e+36>>2]=w,!s)break A;Z(s)}if(i[e+40>>2]=r,h=h+1|0,!((h&65535)>>>0<(_&65535)>>>0))break}k8(o,107664);break e}G0(),H()}z0(),H()}if(r=d2(t+4|0,42673),q(o,2,140,r),u[r+11|0]>=0)break e;Z(i[r>>2])}if(v=t+16|0,k=i[o+4>>2],r=i[o>>2],i[o+24>>2]=r,i[o+28>>2]=k,u[o+43|0]<0&&(Z(i[o+32>>2]),r=i[o+24>>2]),k=i[o+12>>2],i[o+32>>2]=i[o+8>>2],i[o+36>>2]=k,i[o+40>>2]=i[o+16>>2],r){e=i[o+28>>2],i[A>>2]=i[o+24>>2],i[A+4>>2]=e,i[A+16>>2]=i[o+40>>2],e=i[o+36>>2],i[A+8>>2]=i[o+32>>2],i[A+12>>2]=e,i[o+32>>2]=0,i[o+36>>2]=0,i[o+40>>2]=0;break i}if(r=i[e+72>>2],k=i[e+60>>2],r>>>0<(i[e+64>>2]-k|0)-2>>>0){if(k=r+k|0,k=l[k|0]|l[k+1|0]<<8,i[e+72>>2]=r+2,((k<<8|k>>>8)&65535)==65360){t=v-16|0,v=t,k=i[e+72>>2],r=i[e+60>>2];e:{if(k>>>0>(i[e+64>>2]-r|0)-8>>>0){if(u[t+4|0]=0,u[t+15|0]=0,q(A,2,140,t+4|0),u[t+15|0]>=0)break e;Z(i[t+4>>2]);break e}if(f=r+k|0,f=l[f|0]|l[f+1|0]<<8,s=k+2|0,i[e+72>>2]=s,((f<<8|f>>>8)-71&65535)>>>0<=65472){if(e=p(24),i[t+4>>2]=e,i[t+8>>2]=23,i[t+12>>2]=-2147483624,r=l[12004]|l[12005]<<8|(l[12006]<<16|l[12007]<<24),k=l[12e3]|l[12001]<<8|(l[12002]<<16|l[12003]<<24),u[e|0]=k,u[e+1|0]=k>>>8,u[e+2|0]=k>>>16,u[e+3|0]=k>>>24,u[e+4|0]=r,u[e+5|0]=r>>>8,u[e+6|0]=r>>>16,u[e+7|0]=r>>>24,u[e+23|0]=0,r=l[12019]|l[12020]<<8|(l[12021]<<16|l[12022]<<24),k=l[12015]|l[12016]<<8|(l[12017]<<16|l[12018]<<24),u[e+15|0]=k,u[e+16|0]=k>>>8,u[e+17|0]=k>>>16,u[e+18|0]=k>>>24,u[e+19|0]=r,u[e+20|0]=r>>>8,u[e+21|0]=r>>>16,u[e+22|0]=r>>>24,r=l[12012]|l[12013]<<8|(l[12014]<<16|l[12015]<<24),k=l[12008]|l[12009]<<8|(l[12010]<<16|l[12011]<<24),u[e+8|0]=k,u[e+9|0]=k>>>8,u[e+10|0]=k>>>16,u[e+11|0]=k>>>24,u[e+12|0]=r,u[e+13|0]=r>>>8,u[e+14|0]=r>>>16,u[e+15|0]=r>>>24,q(A,2,140,t+4|0),u[t+15|0]>=0)break e;Z(i[t+4>>2]);break e}for(r=r+s|0,r=l[r|0]|l[r+1|0]<<8|(l[r+2|0]<<16|l[r+3|0]<<24),i[e+72>>2]=k+6,_=r<<24|(r&65280)<<8|(r>>>8&65280|r>>>24),f=2;;){r:{if(!(_>>>32-f&1))break r;if((f|0)==15){r=i[e+72>>2],k=r+i[e+60>>2]|0,s=l[k+1|0],k=l[k|0],i[e+72>>2]=r+2,r=k<<24|s<<16|15,i[t>>2]=r,i[t+4>>2]=r;f:{if(r=i[e+52>>2],n=i[e+56>>2],r>>>0<n>>>0){k=C[t>>1]|C[t+2>>1]<<16,g[r>>1]=k,g[r+2>>1]=k>>>16,i[e+52>>2]=r+4;break f}A:{if(s=i[e+48>>2],r=r-s|0,h=r>>2,k=h+1|0,k>>>0<1073741824){if(n=n-s|0,w=n>>1,n=n>>>0>=2147483644?1073741823:k>>>0<w>>>0?w:k,n){if(n>>>0>=1073741824)break A;k=p(n<<2)}else k=0;w=k+r|0,B=C[t>>1]|C[t+2>>1]<<16,g[w>>1]=B,g[w+2>>1]=B>>>16,h=w-(h<<2)|0,r&&x(h,s,r),i[e+56>>2]=k+(n<<2),r=w+4|0,i[e+52>>2]=r,i[e+48>>2]=h,s&&Z(s),i[e+52>>2]=r;break f}G0(),H()}z0(),H()}break r}s=t+4|0,r=S0(Y(128276,31327,39),f),k=i[(i[i[r>>2]-12>>2]+r|0)+28>>2],i[s>>2]=k,(k|0)!=129576&&(i[k+4>>2]=i[k+4>>2]+1),k=c0(s,129760),n=W[i[i[k>>2]+28>>2]](k,10)|0,e2(s),k=v-16|0,v=k,G1(k+8|0,r);f:{if(!l[k+8|0]||(s=k+4|0,i[s>>2]=i[(r+i[i[r>>2]-12>>2]|0)+24>>2],m5(s,n),i[s>>2]))break f;m4(r+i[i[r>>2]-12>>2]|0,1)}_1(k+8|0),v=k+16|0,We(r),i[e+72>>2]=i[e+72>>2]+2}if(f=f+1|0,(f|0)==33)break}if(e=i[26917],i[A>>2]=i[26916],i[A+4>>2]=e,A=A+8|0,u[107683]>=0){e=i[26919],i[A>>2]=i[26918],i[A+4>>2]=e,i[A+8>>2]=i[26920];break e}T(A,i[26918],i[26919])}v=t+16|0;break i}if(e=i[26917],i[A>>2]=i[26916],i[A+4>>2]=e,A=A+8|0,u[107683]>=0){e=i[26919],i[A>>2]=i[26918],i[A+4>>2]=e,i[A+8>>2]=i[26920];break i}T(A,i[26918],i[26919]);break i}if(e=p(40),i[o>>2]=e,i[o+4>>2]=33,i[o+8>>2]=-2147483608,r=l[26423]|l[26424]<<8|(l[26425]<<16|l[26426]<<24),k=l[26419]|l[26420]<<8|(l[26421]<<16|l[26422]<<24),u[e|0]=k,u[e+1|0]=k>>>8,u[e+2|0]=k>>>16,u[e+3|0]=k>>>24,u[e+4|0]=r,u[e+5|0]=r>>>8,u[e+6|0]=r>>>16,u[e+7|0]=r>>>24,u[e+33|0]=0,u[e+32|0]=l[26451],r=l[26447]|l[26448]<<8|(l[26449]<<16|l[26450]<<24),k=l[26443]|l[26444]<<8|(l[26445]<<16|l[26446]<<24),u[e+24|0]=k,u[e+25|0]=k>>>8,u[e+26|0]=k>>>16,u[e+27|0]=k>>>24,u[e+28|0]=r,u[e+29|0]=r>>>8,u[e+30|0]=r>>>16,u[e+31|0]=r>>>24,r=l[26439]|l[26440]<<8|(l[26441]<<16|l[26442]<<24),k=l[26435]|l[26436]<<8|(l[26437]<<16|l[26438]<<24),u[e+16|0]=k,u[e+17|0]=k>>>8,u[e+18|0]=k>>>16,u[e+19|0]=k>>>24,u[e+20|0]=r,u[e+21|0]=r>>>8,u[e+22|0]=r>>>16,u[e+23|0]=r>>>24,r=l[26431]|l[26432]<<8|(l[26433]<<16|l[26434]<<24),k=l[26427]|l[26428]<<8|(l[26429]<<16|l[26430]<<24),u[e+8|0]=k,u[e+9|0]=k>>>8,u[e+10|0]=k>>>16,u[e+11|0]=k>>>24,u[e+12|0]=r,u[e+13|0]=r>>>8,u[e+14|0]=r>>>16,u[e+15|0]=r>>>24,q(A,2,140,o),u[o+11|0]>=0)break i;Z(i[o>>2])}u[o+43|0]<0&&Z(i[o+32>>2]),v=o+48|0}function P_(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,t=0,o=0,s=0,w=0,h=0,_=0,B=0,m=0,X=0,Q=0,V=0,F=0,I=0;f=v-176|0,v=f,i[f+108>>2]=0,i[f+80>>2]=72500,t=i[18128],i[f+24>>2]=t,n=i[t-12>>2],t=f+24|0,i[n+t>>2]=i[18129],n=t+i[i[f+24>>2]-12>>2]|0,k=f+28|0,J0(n,k),u[n+80|0]=0,i[n+72>>2]=0,i[f+80>>2]=72500,i[f+24>>2]=72480,m=R0(k),i[m>>2]=71232,i[f+68>>2]=0,i[f+72>>2]=0,i[f+60>>2]=0,i[f+64>>2]=0,i[f+76>>2]=16,n=f+164|0,Y2(n,e,r),k=t,o=n,t=u[f+175|0],n=(t|0)<0,Y(k,n?i[f+164>>2]:o,n?i[f+168>>2]:t),u[f+175|0]<0&&Z(i[f+164>>2]),t=f+164|0,s0(t,r),k=t,t=u[f+175|0],n=(t|0)<0,Y(f+24|0,n?i[f+164>>2]:k,n?i[f+168>>2]:t),u[f+175|0]<0&&Z(i[f+164>>2]),k=Y(S0(Y(f+24|0,30746,23),l[e+100|0]),42670,1),t=f+164|0,s0(t,r),o=t,t=u[f+175|0],n=(t|0)<0,Y(k,n?i[f+164>>2]:o,n?i[f+168>>2]:t),u[f+175|0]<0&&Z(i[f+164>>2]),t=f+8|7,n=f+18|0,w=Y(S0(Y(k,30723,22),l[e+101|0]),27147,2);i:{e:{r:{f:{A:{k:{n:{t:{u:{o:{l:{s:switch(k=l[e+101|0],k-66|0){case 0:break r;case 1:case 2:case 3:case 4:case 5:case 6:case 7:case 8:case 9:case 10:case 12:case 13:case 14:case 15:case 16:case 17:case 18:case 19:case 20:case 21:case 23:case 24:case 25:case 26:case 27:case 28:case 29:case 30:case 31:case 32:case 33:case 35:case 36:case 37:case 38:case 39:case 40:case 41:case 42:case 43:case 45:case 46:case 47:case 48:case 49:case 50:case 51:case 52:case 53:case 54:case 55:break A;case 11:break l;case 22:break o;case 34:break u;case 44:break t;case 56:break n;default:break s}if((k|0)==244)break k;if((k|0)!=44)break A;n=p(16),i[f+8>>2]=n,i[f+12>>2]=11,i[f+16>>2]=-2147483632,t=l[21362]|l[21363]<<8|(l[21364]<<16|l[21365]<<24),k=l[21358]|l[21359]<<8|(l[21360]<<16|l[21361]<<24),u[n|0]=k,u[n+1|0]=k>>>8,u[n+2|0]=k>>>16,u[n+3|0]=k>>>24,u[n+4|0]=t,u[n+5|0]=t>>>8,u[n+6|0]=t>>>16,u[n+7|0]=t>>>24,u[n+11|0]=0,t=l[21365]|l[21366]<<8|(l[21367]<<16|l[21368]<<24),u[n+7|0]=t,u[n+8|0]=t>>>8,u[n+9|0]=t>>>16,u[n+10|0]=t>>>24;break e}t=f+8|4,i[f+8>>2]=1852399949,u[f+19|0]=4,k=4;break f}t=f+16|0,i[f+8>>2]=1702131781,i[f+12>>2]=1684366446,u[f+19|0]=8,k=8;break f}n=p(16),i[f+8>>2]=n,i[f+12>>2]=12,i[f+16>>2]=-2147483632,t=l[3814]|l[3815]<<8|(l[3816]<<16|l[3817]<<24),k=l[3810]|l[3811]<<8|(l[3812]<<16|l[3813]<<24),u[n|0]=k,u[n+1|0]=k>>>8,u[n+2|0]=k>>>16,u[n+3|0]=k>>>24,u[n+4|0]=t,u[n+5|0]=t>>>8,u[n+6|0]=t>>>16,u[n+7|0]=t>>>24,u[n+12|0]=0,t=l[3818]|l[3819]<<8|(l[3820]<<16|l[3821]<<24),u[n+8|0]=t,u[n+9|0]=t>>>8,u[n+10|0]=t>>>16,u[n+11|0]=t>>>24;break e}u[f+19|0]=7,i[f+8>>2]=l[22028]|l[22029]<<8|(l[22030]<<16|l[22031]<<24),n=l[22031]|l[22032]<<8|(l[22033]<<16|l[22034]<<24),u[f+11|0]=n,u[f+12|0]=n>>>8,u[f+13|0]=n>>>16,u[f+14|0]=n>>>24,k=7;break f}g[f+16>>1]=l[21559]|l[21560]<<8,u[f+19|0]=10,t=l[21555]|l[21556]<<8|(l[21557]<<16|l[21558]<<24),i[f+8>>2]=l[21551]|l[21552]<<8|(l[21553]<<16|l[21554]<<24),i[f+12>>2]=t,t=n,k=10;break f}g[f+16>>1]=l[21355]|l[21356]<<8,u[f+19|0]=10,t=l[21351]|l[21352]<<8|(l[21353]<<16|l[21354]<<24),i[f+8>>2]=l[21347]|l[21348]<<8|(l[21349]<<16|l[21350]<<24),i[f+12>>2]=t,t=n,k=10;break f}u[f+19|0]=7,i[f+8>>2]=l[7986]|l[7987]<<8|(l[7988]<<16|l[7989]<<24),n=l[7989]|l[7990]<<8|(l[7991]<<16|l[7992]<<24),u[f+11|0]=n,u[f+12|0]=n>>>8,u[f+13|0]=n>>>16,u[f+14|0]=n>>>24,k=7}u[t|0]=0,n=f+8|0;break i}n=p(24),i[f+8>>2]=n,i[f+12>>2]=20,i[f+16>>2]=-2147483624,t=l[12852]|l[12853]<<8|(l[12854]<<16|l[12855]<<24),k=l[12848]|l[12849]<<8|(l[12850]<<16|l[12851]<<24),u[n|0]=k,u[n+1|0]=k>>>8,u[n+2|0]=k>>>16,u[n+3|0]=k>>>24,u[n+4|0]=t,u[n+5|0]=t>>>8,u[n+6|0]=t>>>16,u[n+7|0]=t>>>24,u[n+20|0]=0,t=l[12864]|l[12865]<<8|(l[12866]<<16|l[12867]<<24),u[n+16|0]=t,u[n+17|0]=t>>>8,u[n+18|0]=t>>>16,u[n+19|0]=t>>>24,t=l[12860]|l[12861]<<8|(l[12862]<<16|l[12863]<<24),k=l[12856]|l[12857]<<8|(l[12858]<<16|l[12859]<<24),u[n+8|0]=k,u[n+9|0]=k>>>8,u[n+10|0]=k>>>16,u[n+11|0]=k>>>24,u[n+12|0]=t,u[n+13|0]=t>>>8,u[n+14|0]=t>>>16,u[n+15|0]=t>>>24}k=i[f+12>>2]}t=Y(Y(w,n,k),42669,2),n=f+164|0,s0(n,r),o=n,n=u[f+175|0],k=(n|0)<0,Y(t,k?i[f+164>>2]:o,k?i[f+168>>2]:n),u[f+175|0]<0&&Z(i[f+164>>2]),t=Y(S0(Y(t,29212,23),l[e+102|0]),42670,1),n=f+164|0,s0(n,r),o=n,n=u[f+175|0],k=(n|0)<0,Y(t,k?i[f+164>>2]:o,k?i[f+168>>2]:n),u[f+175|0]<0&&Z(i[f+164>>2]),t=Y(S0(Y(t,30702,20),l[e+103|0]),42670,1),n=f+164|0,s0(n,r),o=n,n=u[f+175|0],k=(n|0)<0,Y(t,k?i[f+164>>2]:o,k?i[f+168>>2]:n),u[f+175|0]<0&&Z(i[f+164>>2]),Y(t,29758,15),u[f+19|0]<0&&Z(i[f+8>>2]);i:{e:switch(i[e+108>>2]){case 0:Y(f+24|0,41801,6);break i;case 1:Y(f+24|0,41794,6);break i;case 2:Y(f+24|0,41787,6);break i;case 3:Y(f+24|0,41780,6);break i;default:break e}Y(f+24|0,33430,12)}t=f+164|0,s0(t,r),k=t,t=u[f+175|0],n=(t|0)<0,Y(f+24|0,n?i[f+164>>2]:k,n?i[f+168>>2]:t),u[f+175|0]<0&&Z(i[f+164>>2]),t=Y(S0(Y(f+24|0,32389,16),l[e+112|0]),42670,1),n=f+164|0,s0(n,r),o=n,n=u[f+175|0],k=(n|0)<0,Y(t,k?i[f+164>>2]:o,k?i[f+168>>2]:n),u[f+175|0]<0&&Z(i[f+164>>2]),Y(S0(Y(t,32425,18),l[e+113|0]),42670,1);i:{if(n=i[e+116>>2],V=i[e+120>>2],(n|0)!=(V|0))for(F=f+36|0;;){t=f+164|0,s0(t,r),o=t,t=u[f+175|0],k=(t|0)<0,Y(f+24|0,k?i[f+164>>2]:o,k?i[f+168>>2]:t),u[f+175|0]<0&&Z(i[f+164>>2]),Y(f+24|0,32475,5);e:{if(t=i[n>>2],X=i[n+4>>2],(t|0)==(X|0))break e;for(;;){s=l[t|0],k=i[f+24>>2],w=i[k-12>>2]+(f+24|0)|0,l[w+80|0]||(o=f+164|0,k=i[w+28>>2],i[o>>2]=k,(k|0)!=129576&&(i[k+4>>2]=i[k+4>>2]+1),k=c0(o,129760),W[i[i[k>>2]+28>>2]](k,32)|0,e2(o),k=i[f+24>>2]),u[w+76|0]=48,u[w+77|0]=0,u[w+78|0]=0,u[w+79|0]=0,u[w+80|0]=1,k=k-12|0,i[F+i[k>>2]>>2]=2,k=i[k>>2]+m|0,i[k>>2]=i[k>>2]&-75|8;r:{_=S0(f+24|0,s),Q=G1(f+8|0,_);f:{if(l[Q|0]!=1)break f;o=_+i[i[_>>2]-12>>2]|0,B=i[o+4>>2],h=i[o+24>>2];A:{if(l[o+80|0]==1){w=l[o+76|0]|l[o+77|0]<<8|(l[o+78|0]<<16|l[o+79|0]<<24);break A}s=f+164|0,k=i[o+28>>2],i[s>>2]=k,(k|0)!=129576&&(i[k+4>>2]=i[k+4>>2]+1),k=c0(s,129760),w=W[i[i[k>>2]+28>>2]](k,32)|0,e2(s),u[o+76|0]=w,u[o+77|0]=w>>>8,u[o+78|0]=w>>>16,u[o+79|0]=w>>>24,u[o+80|0]=1}A:{if(!h||(k=i[o+12>>2],B=(B&176)==32?32809:32808,s=B-32808|0,(s|0)>0&&(W[i[i[h>>2]+48>>2]](h,32808,s)|0)!=(s|0)))break A;if((k|0)>=2){if(k>>>0>=2147483641)break r;s=((k|0)<=1?1:k)-1|0;k:{if(k>>>0>=12){I=s|7,k=p(I+1|0),i[f+172>>2]=I-2147483647,i[f+164>>2]=k,i[f+168>>2]=s;break k}u[f+175|0]=s,k=f+164|0}if(s&&o0(k,w,s),u[k+s|0]=0,k=W[i[i[h>>2]+48>>2]](h,u[f+175|0]<0?i[f+164>>2]:f+164|0,s)|0,u[f+175|0]<0&&Z(i[f+164>>2]),(k|0)!=(s|0))break A}if(k=32809-B|0,(k|0)>0&&(W[i[i[h>>2]+48>>2]](h,B,k)|0)!=(k|0))break A;i[o+12>>2]=0;break f}k=_+i[i[_>>2]-12>>2]|0,H1(k,i[k+16>>2]|5)}if(_1(Q),t=t+1|0,(X|0)==(t|0))break e;continue}break}break i}if(Y(f+24|0,42670,1),t=i[i[f+24>>2]-12>>2]+m|0,i[t>>2]=i[t>>2]&-75|2,n=n+12|0,(V|0)==(n|0))break}if(n=i[e+140>>2],V=i[e+144>>2],(n|0)!=(V|0))for(F=f+36|0;;){t=f+164|0,s0(t,r),o=t,t=u[f+175|0],k=(t|0)<0,Y(f+24|0,k?i[f+164>>2]:o,k?i[f+168>>2]:t),u[f+175|0]<0&&Z(i[f+164>>2]),Y(f+24|0,32465,9);e:{if(t=i[n>>2],X=i[n+4>>2],(t|0)==(X|0))break e;for(;;){s=l[t|0],k=i[f+24>>2],w=i[k-12>>2]+(f+24|0)|0,l[w+80|0]||(o=f+164|0,k=i[w+28>>2],i[o>>2]=k,(k|0)!=129576&&(i[k+4>>2]=i[k+4>>2]+1),k=c0(o,129760),W[i[i[k>>2]+28>>2]](k,32)|0,e2(o),k=i[f+24>>2]),u[w+76|0]=48,u[w+77|0]=0,u[w+78|0]=0,u[w+79|0]=0,u[w+80|0]=1,k=k-12|0,i[F+i[k>>2]>>2]=2,k=i[k>>2]+m|0,i[k>>2]=i[k>>2]&-75|8;r:{_=S0(f+24|0,s),Q=G1(f+8|0,_);f:{if(l[Q|0]!=1)break f;o=_+i[i[_>>2]-12>>2]|0,B=i[o+4>>2],h=i[o+24>>2];A:{if(l[o+80|0]==1){w=l[o+76|0]|l[o+77|0]<<8|(l[o+78|0]<<16|l[o+79|0]<<24);break A}s=f+164|0,k=i[o+28>>2],i[s>>2]=k,(k|0)!=129576&&(i[k+4>>2]=i[k+4>>2]+1),k=c0(s,129760),w=W[i[i[k>>2]+28>>2]](k,32)|0,e2(s),u[o+76|0]=w,u[o+77|0]=w>>>8,u[o+78|0]=w>>>16,u[o+79|0]=w>>>24,u[o+80|0]=1}A:{if(!h||(k=i[o+12>>2],B=(B&176)==32?32809:32808,s=B-32808|0,(s|0)>0&&(W[i[i[h>>2]+48>>2]](h,32808,s)|0)!=(s|0)))break A;if((k|0)>=2){if(k>>>0>=2147483641)break r;s=((k|0)<=1?1:k)-1|0;k:{if(k>>>0>=12){I=s|7,k=p(I+1|0),i[f+172>>2]=I-2147483647,i[f+164>>2]=k,i[f+168>>2]=s;break k}u[f+175|0]=s,k=f+164|0}if(s&&o0(k,w,s),u[k+s|0]=0,k=W[i[i[h>>2]+48>>2]](h,u[f+175|0]<0?i[f+164>>2]:f+164|0,s)|0,u[f+175|0]<0&&Z(i[f+164>>2]),(k|0)!=(s|0))break A}if(k=32809-B|0,(k|0)>0&&(W[i[i[h>>2]+48>>2]](h,B,k)|0)!=(k|0))break A;i[o+12>>2]=0;break f}k=_+i[i[_>>2]-12>>2]|0,H1(k,i[k+16>>2]|5)}if(_1(Q),t=t+1|0,(X|0)==(t|0))break e;continue}break}break i}if(Y(f+24|0,42670,1),t=i[i[f+24>>2]-12>>2]+m|0,i[t>>2]=i[t>>2]&-75|2,n=n+12|0,(V|0)==(n|0))break}if(n=i[e+128>>2],B=i[e+132>>2],(n|0)!=(B|0))for(V=f+36|0;;){e=f+164|0,s0(e,r),k=e,e=u[f+175|0],t=(e|0)<0,Y(f+24|0,t?i[f+164>>2]:k,t?i[f+168>>2]:e),u[f+175|0]<0&&Z(i[f+164>>2]),Y(f+24|0,32481,5);e:{if(t=i[n>>2],F=i[n+4>>2],(t|0)==(F|0))break e;for(;;){o=l[t|0],k=i[f+24>>2],e=i[k-12>>2]+(f+24|0)|0,l[e+80|0]||(w=f+164|0,k=i[e+28>>2],i[w>>2]=k,(k|0)!=129576&&(i[k+4>>2]=i[k+4>>2]+1),k=c0(w,129760),W[i[i[k>>2]+28>>2]](k,32)|0,e2(w),k=i[f+24>>2]),u[e+76|0]=48,u[e+77|0]=0,u[e+78|0]=0,u[e+79|0]=0,u[e+80|0]=1,e=k-12|0,i[V+i[e>>2]>>2]=2,e=i[e>>2]+m|0,i[e>>2]=i[e>>2]&-75|8;r:{h=S0(f+24|0,o),X=G1(f+8|0,h);f:{if(l[X|0]!=1)break f;e=h+i[i[h>>2]-12>>2]|0,_=i[e+4>>2],s=i[e+24>>2];A:{if(l[e+80|0]==1){w=l[e+76|0]|l[e+77|0]<<8|(l[e+78|0]<<16|l[e+79|0]<<24);break A}o=f+164|0,k=i[e+28>>2],i[o>>2]=k,(k|0)!=129576&&(i[k+4>>2]=i[k+4>>2]+1),k=c0(o,129760),w=W[i[i[k>>2]+28>>2]](k,32)|0,e2(o),u[e+76|0]=w,u[e+77|0]=w>>>8,u[e+78|0]=w>>>16,u[e+79|0]=w>>>24,u[e+80|0]=1}A:{if(!s||(k=i[e+12>>2],_=(_&176)==32?32809:32808,o=_-32808|0,(o|0)>0&&(W[i[i[s>>2]+48>>2]](s,32808,o)|0)!=(o|0)))break A;if((k|0)>=2){if(k>>>0>=2147483641)break r;o=((k|0)<=1?1:k)-1|0;k:{if(k>>>0>=12){Q=o|7,k=p(Q+1|0),i[f+172>>2]=Q-2147483647,i[f+164>>2]=k,i[f+168>>2]=o;break k}u[f+175|0]=o,k=f+164|0}if(o&&o0(k,w,o),u[k+o|0]=0,k=W[i[i[s>>2]+48>>2]](s,u[f+175|0]<0?i[f+164>>2]:f+164|0,o)|0,u[f+175|0]<0&&Z(i[f+164>>2]),(k|0)!=(o|0))break A}if(k=32809-_|0,(k|0)>0&&(W[i[i[s>>2]+48>>2]](s,_,k)|0)!=(k|0))break A;i[e+12>>2]=0;break f}e=h+i[i[h>>2]-12>>2]|0,H1(e,i[e+16>>2]|5)}if(_1(X),t=t+1|0,(F|0)==(t|0))break e;continue}break}break i}if(Y(f+24|0,42670,1),e=i[i[f+24>>2]-12>>2]+m|0,i[e>>2]=i[e>>2]&-75|2,n=n+12|0,(B|0)==(n|0))break}e=i[f+76>>2];e:{r:{if(e&16){n=i[f+72>>2],e=i[f+52>>2],n>>>0<e>>>0&&(i[f+72>>2]=e,n=e),e=f+48|0;break r}if(!(e&8)){n=0,u[A+11|0]=0;break e}n=i[f+44>>2],e=f+36|0}r:{if(r=i[e>>2],n=n-r|0,n>>>0<2147483640){if(n>>>0>=11){t=n|7,e=p(t+1|0),i[A+8>>2]=t-2147483647,i[A>>2]=e,i[A+4>>2]=n,A=e;break r}if(u[A+11|0]=n,n)break r;n=0;break e}Q0(),H()}if(!n)break e;x(A,r,n)}u[A+n|0]=0,A=i[18127],i[f+24>>2]=A,i[i[A-12>>2]+(f+24|0)>>2]=i[18130],i[m>>2]=71232,u[f+71|0]<0&&Z(i[f+60>>2]),E0(m),y0(f+80|0),v=f+176|0;return}Q0(),H()}function L_(A,e,r,f,k,n,t,o){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,t=t|0,o=o|0;var s=U(0),w=U(0),h=0,_=0,B=0,m=0,X=0,Q=0,V=U(0),F=0,I=0,E=0,R=U(0),N=0,M=0,z=U(0),S=U(0),O=U(0),P=0,a=0,$=0,f0=0,A0=0,n0=0,_0=0,m0=0,X0=0,g0=0,I0=0,e0=0;n=v-160|0,v=n,e=i[r>>2],I=i[e+112>>2],Q=i[e+108>>2],t=p(172),i[t>>2]=94812,i[t+4>>2]=0,i[t+8>>2]=0,o0(t+16|0,0,80),f=i[t+4>>2],h=f+1|0,i[t+4>>2]=h,i[t+104>>2]=0,i[t+108>>2]=0,i[t+36>>2]=1,i[t+40>>2]=1,u[t+24|0]=1,g[t+22>>1]=2,g[t+18>>1]=2,g[t+20>>1]=2,i[t+112>>2]=0,i[t+116>>2]=4740,i[t+140>>2]=0,i[t+144>>2]=0,i[t+128>>2]=99,i[t+132>>2]=99,i[t+120>>2]=0,i[t+124>>2]=0,i[t+12>>2]=95160,i[t+148>>2]=0,i[t+152>>2]=0,e=t+140|0,i[t+136>>2]=e,i[t+156>>2]=0,i[t+160>>2]=0,i[t+164>>2]=0,i[t+168>>2]=0,i[t+4>>2]=f,f=i[t+8>>2],P=t+12|0,i[t+96>>2]=P,i[t+8>>2]=f+1,i[t+100>>2]=t,h||(W[i[i[t>>2]+8>>2]](t),y(t)),f=i[k+4>>2],h=f>>>0<4,i[P+120>>2]=f,i[P+116>>2]=0,i[P+112>>2]=I,i[P+108>>2]=Q,_0=l[k+8|0],I0=i[i[r>>2]+120>>2],T0(n+136|0,P,0,Q,I,8,o),n0=Q-1|0,f=f<<3,N=(h?16908801>>>f|0:0)&3,M=(n0+N>>>0)/(N>>>0)|0,m0=I-1|0,B=(h?16843265>>>f|0:0)&3,h=(m0+B>>>0)/(B>>>0)|0,T0(n+112|0,P,1,M,h,8,o),f=n+16|0;i:{if(i[n+136>>2]){if(X=i[n+140>>2],i[n+8>>2]=i[n+136>>2],i[n+12>>2]=X,u[n+155|0]>=0){X=i[n+148>>2],i[f>>2]=i[n+144>>2],i[f+4>>2]=X,i[f+8>>2]=i[n+152>>2];break i}T(f,i[n+144>>2],i[n+148>>2]);break i}if(X=i[n+116>>2],i[n+8>>2]=i[n+112>>2],i[n+12>>2]=X,u[n+131|0]>=0){X=i[n+124>>2],i[f>>2]=i[n+120>>2],i[f+4>>2]=X,i[f+8>>2]=i[n+128>>2];break i}T(f,i[n+120>>2],i[n+124>>2])}T0(n+88|0,P,2,M,h,8,o),h=n+56|0;i:{if(i[n+8>>2]){if(M=i[n+12>>2],i[n+48>>2]=i[n+8>>2],i[n+52>>2]=M,u[n+27|0]>=0){M=i[f+4>>2],i[h>>2]=i[f>>2],i[h+4>>2]=M,i[h+8>>2]=i[f+8>>2];break i}T(h,i[n+16>>2],i[n+20>>2]);break i}if(f=i[n+92>>2],i[n+48>>2]=i[n+88>>2],i[n+52>>2]=f,u[n+107|0]>=0){f=i[n+100>>2],i[h>>2]=i[n+96>>2],i[h+4>>2]=f,i[h+8>>2]=i[n+104>>2];break i}T(h,i[n+96>>2],i[n+100>>2])}u[n+107|0]<0&&Z(i[n+96>>2]),u[n+27|0]<0&&Z(i[n+16>>2]),u[n+131|0]<0&&Z(i[n+120>>2]),u[n+155|0]<0&&Z(i[n+144>>2]);i:{e:{if(i[n+48>>2]){if(e=i[n+52>>2],i[A>>2]=i[n+48>>2],i[A+4>>2]=e,e=A+8|0,u[n+67|0]>=0){r=i[h+4>>2],i[e>>2]=i[h>>2],i[e+4>>2]=r,i[e+8>>2]=i[h+8>>2],u[A+20|0]=1;break e}if(T(e,i[n+56>>2],i[n+60>>2]),e=u[n+67|0],u[A+20|0]=1,(e|0)>=0)break e;Z(i[n+56>>2]);break e}u[n+67|0]<0&&Z(i[n+56>>2]);r:{if(!(_0&1))break r;if(T0(n+48|0,P,6,Q,I,8,o),i[n+48>>2]){if(e=i[n+52>>2],i[A>>2]=i[n+48>>2],i[A+4>>2]=e,e=A+8|0,u[n+67|0]>=0){r=i[n+60>>2],i[e>>2]=i[n+56>>2],i[e+4>>2]=r,i[e+8>>2]=i[n+64>>2],u[A+20|0]=1;break e}if(T(e,i[n+56>>2],i[n+60>>2]),e=u[n+67|0],u[A+20|0]=1,(e|0)>=0)break e;Z(i[n+56>>2]);break e}if(u[n+67|0]>=0)break r;Z(i[n+56>>2])}r:{f:{if(r=i[r>>2],o=i[r+128>>2],!o)break f;for(f=r+128|0,r=f;h=i[o+16>>2]<10,r=h?r:o,o=i[(h?4:0)+o>>2],!!o;);if((r|0)==(f|0))break f;if(h=0,i[r+16>>2]>10)break r;a=i[r+44>>2],h=i[r+56>>2];break r}h=0}r:{f:{if(r=i[e>>2],r){for(f=e,o=r;_=i[o+16>>2],f=(_|0)<0?f:o,o=i[(_>>>29&4)+o>>2],!!o;);_=0;A:{if((e|0)==(f|0)||(_=0,i[f+16>>2]>0))break A;X0=i[f+56>>2],_=i[f+44>>2]}for(f=e,o=r;F=i[o+16>>2]<=0,f=F?f:o,o=i[(F?4:0)+o>>2],!!o;);F=0;A:{if((e|0)==(f|0)||(F=0,i[f+16>>2]>1))break A;$=i[f+44>>2],F=i[f+56>>2]}for(f=e,o=r;E=i[o+16>>2]<2,f=E?f:o,o=i[(E?4:0)+o>>2],!!o;);E=0;A:{if((e|0)==(f|0)||(E=0,i[f+16>>2]>2))break A;f0=i[f+56>>2],E=i[f+44>>2]}if(M=0,!(_0&1))break r;for(o=e;f=i[r+16>>2]<6,o=f?o:r,r=i[(f?4:0)+r>>2],!!r;);if((e|0)!=(o|0))break f}M=0;break r}if(M=0,i[o+16>>2]>6)break r;e0=i[o+56>>2],M=i[o+44>>2]}i[n+84>>2]=-1113159960,i[n+76>>2]=1056964608,i[n+80>>2]=-1093247418,i[n+68>>2]=-1096180881,i[n+72>>2]=1056964608,i[n+60>>2]=1038710997,i[n+64>>2]=-1104361250,i[n+52>>2]=1050220167,i[n+56>>2]=1058424226,u[n+48|0]=1,m=l[k+22|0],Nr(n+8|0,C[k+20>>1],C[k+16>>1]),e=i[n+44>>2],i[n+80>>2]=i[n+40>>2],i[n+84>>2]=e,e=i[n+36>>2],i[n+72>>2]=i[n+32>>2],i[n+76>>2]=e,r=i[n+28>>2],e=n- -64|0,i[e>>2]=i[n+24>>2],i[e+4>>2]=r,e=i[n+20>>2],i[n+56>>2]=i[n+16>>2],i[n+60>>2]=e,e=i[n+12>>2],i[n+48>>2]=i[n+8>>2],i[n+52>>2]=e,X=(I0|0)==11?4:3;r:{f:{A:{if(I){if(Q){for(e=0,g0=m&1;;){k=G(e,X0)+_|0,o=G(e,h)+a|0,f=0,r=0;k:{if(!g0){for(;;)if(A0=f+k|0,s=U(U(U(U(U(l[o+2|0])*p0[n+60>>2])+U(U(U(l[o|0])*p0[n+52>>2])+U(p0[n+56>>2]*U(l[o+1|0]))))*U(.8554700016975403))+U(.5)),U(w2(s))<U(2147483648)?r=~~s:r=-2147483648,u[A0|0]=(r|0)<0?16:(r>>>0>=219?219:r)+16|0,o=o+X|0,f=f+1|0,(Q|0)==(f|0))break k}for(;A0=r+k|0,s=U(U(U(U(l[o+2|0])*p0[n+60>>2])+U(U(U(l[o|0])*p0[n+52>>2])+U(p0[n+56>>2]*U(l[o+1|0]))))+U(.5)),U(w2(s))<U(2147483648)?f=~~s:f=-2147483648,f=(f|0)>=255?255:f,u[A0|0]=(f|0)>0?f:0,o=o+X|0,r=r+1|0,(Q|0)!=(r|0););}if(e=e+1|0,(I|0)==(e|0))break}if(o=(B|0)==1,(N|0)!=1|(B|0)!=1)break A;for(B=m&1,e=0;;){k=G(e,f0)+E|0,_=G(e,F)+$|0,o=G(e,h)+a|0,f=0,r=0;k:{if(!B){for(;;)if(s=p0[n+84>>2],w=p0[n+76>>2],R=p0[n+80>>2],m=f+_|0,V=U(l[o+2|0]),z=U(l[o|0]),S=U(l[o+1|0]),O=U(U(U(U(U(V*p0[n+72>>2])+U(U(z*p0[n+64>>2])+U(p0[n+68>>2]*S)))*U(.875))+U(128))+U(.5)),U(w2(O))<U(2147483648)?r=~~O:r=-2147483648,r=(r|0)>=255?255:r,u[m|0]=(r|0)>0?r:0,m=f+k|0,s=U(U(U(U(U(V*s)+U(U(z*w)+U(R*S)))*U(.875))+U(128))+U(.5)),U(w2(s))<U(2147483648)?r=~~s:r=-2147483648,r=(r|0)>=255?255:r,u[m|0]=(r|0)>0?r:0,o=o+X|0,f=f+1|0,(Q|0)==(f|0))break k}for(;s=p0[n+84>>2],w=p0[n+76>>2],R=p0[n+80>>2],m=r+_|0,V=U(l[o+2|0]),z=U(l[o|0]),S=U(l[o+1|0]),O=U(U(U(U(V*p0[n+72>>2])+U(U(z*p0[n+64>>2])+U(p0[n+68>>2]*S)))+U(128))+U(.5)),U(w2(O))<U(2147483648)?f=~~O:f=-2147483648,f=(f|0)>=255?255:f,u[m|0]=(f|0)>0?f:0,m=r+k|0,s=U(U(U(U(V*s)+U(U(z*w)+U(R*S)))+U(128))+U(.5)),U(w2(s))<U(2147483648)?f=~~s:f=-2147483648,f=(f|0)>=255?255:f,u[m|0]=(f|0)>0?f:0,o=o+X|0,r=r+1|0,(Q|0)!=(r|0););}if(e=e+1|0,(I|0)==(e|0))break}break f}if(e=(B|0)==1,o=e,(N|0)!=1)break A;if(e)break r;break A}if(e=(B|0)==1,o=e,(N|0)!=1)break A;if(e)break f}if(e=(N|0)!=2,!(e|(B|0)!=2)){B=I&-2;A:{if(!B||(N=Q&-2,!N))break A;for(X0=X<<1,f=0;;){for(o=G(f,h)+a|0,e=f>>>1|0,g0=G(e,f0)+E|0,A0=G(e,F)+$|0,r=0;;){e=o+X|0,k=e+h|0,_=o+h|0,w=U((l[k+2|0]+(l[_+2|0]+(l[e+2|0]+l[o+2|0]|0)|0)>>>2&255)>>>0),R=U((l[k|0]+(l[_|0]+(l[e|0]+l[o|0]|0)|0)>>>2&255)>>>0),V=U((l[k+1|0]+(l[_+1|0]+(l[e+1|0]+l[o+1|0]|0)|0)>>>2&255)>>>0),s=U(U(w*p0[n+84>>2])+U(U(R*p0[n+76>>2])+U(p0[n+80>>2]*V))),w=U(U(w*p0[n+72>>2])+U(U(R*p0[n+64>>2])+U(p0[n+68>>2]*V))),k=r>>>1|0,e=k+g0|0,o=o+X0|0,_=k+A0|0;k:{if(!(m&1)){s=U(U(s*U(.875))+U(128)),w=U(U(U(w*U(.875))+U(128))+U(.5)),U(w2(w))<U(2147483648)?k=~~w:k=-2147483648,k=(k|0)>=255?255:k,k=(k|0)>0?k:0;break k}s=U(s+U(128)),w=U(U(w+U(128))+U(.5)),U(w2(w))<U(2147483648)?k=~~w:k=-2147483648,k=(k|0)>=255?255:k,k=(k|0)>0?k:0}if(u[_|0]=k,_=e,s=U(s+U(.5)),U(w2(s))<U(2147483648)?k=~~s:k=-2147483648,e=(k|0)>=255?255:k,u[_|0]=(e|0)>0?e:0,r=r+2|0,!(N>>>0>r>>>0))break}if(f=f+2|0,!(B>>>0>f>>>0))break}}if(Q&1){if(!I)break f;for(_=h<<1,e=n0>>>1|0,B=e+E|0,N=e+$|0,o=G(X,n0)+a|0,f=0;;){r=l[o|0];A:{if((f|1)>>>0<I>>>0){e=o+h|0,r=l[e|0]+(r&255)>>>1|0,k=l[e+2|0]+l[o+2|0]>>>1|0,e=l[e+1|0]+l[o+1|0]>>>1|0;break A}k=l[o+2|0],e=l[o+1|0]}w=U((k&255)>>>0),R=U((r&255)>>>0),V=U((e&255)>>>0),s=U(U(w*p0[n+84>>2])+U(U(R*p0[n+76>>2])+U(p0[n+80>>2]*V))),w=U(U(w*p0[n+72>>2])+U(U(R*p0[n+64>>2])+U(p0[n+68>>2]*V))),r=f>>>1|0,e=B+G(r,f0)|0,k=N+G(r,F)|0;A:{if(m&1){s=U(s+U(128)),w=U(U(w+U(128))+U(.5)),U(w2(w))<U(2147483648)?r=~~w:r=-2147483648,r=(r|0)>=255?255:r,r=(r|0)>0?r:0;break A}s=U(U(s*U(.875))+U(128)),w=U(U(U(w*U(.875))+U(128))+U(.5)),U(w2(w))<U(2147483648)?r=~~w:r=-2147483648,r=(r|0)>=255?255:r,r=(r|0)>0?r:0}if(u[k|0]=r,k=e,s=U(s+U(.5)),U(w2(s))<U(2147483648)?r=~~s:r=-2147483648,e=(r|0)>=255?255:r,u[k|0]=(e|0)>0?e:0,o=o+_|0,f=f+2|0,!(I>>>0>f>>>0))break}}if(!(I&1)|!Q)break f;for(_=X<<1,o=G(h,m0)+a|0,e=m0>>>1|0,E=G(e,f0)+E|0,F=G(e,F)+$|0,f=0;;){r=l[o|0];A:{if((f|1)>>>0<Q>>>0){e=o+X|0,r=l[e|0]+(r&255)>>>1|0,k=l[e+2|0]+l[o+2|0]>>>1|0,e=l[e+1|0]+l[o+1|0]>>>1|0;break A}k=l[o+2|0],e=l[o+1|0]}w=U((k&255)>>>0),R=U((r&255)>>>0),V=U((e&255)>>>0),s=U(U(w*p0[n+84>>2])+U(U(R*p0[n+76>>2])+U(p0[n+80>>2]*V))),w=U(U(w*p0[n+72>>2])+U(U(R*p0[n+64>>2])+U(p0[n+68>>2]*V))),r=f>>>1|0,e=r+E|0,k=r+F|0;A:{if(m&1){s=U(s+U(128)),w=U(U(w+U(128))+U(.5)),U(w2(w))<U(2147483648)?r=~~w:r=-2147483648,r=(r|0)>=255?255:r,r=(r|0)>0?r:0;break A}s=U(U(s*U(.875))+U(128)),w=U(U(U(w*U(.875))+U(128))+U(.5)),U(w2(w))<U(2147483648)?r=~~w:r=-2147483648,r=(r|0)>=255?255:r,r=(r|0)>0?r:0}if(u[k|0]=r,k=e,s=U(s+U(.5)),U(w2(s))<U(2147483648)?r=~~s:r=-2147483648,e=(r|0)>=255?255:r,u[k|0]=(e|0)>0?e:0,o=o+_|0,f=f+2|0,!(Q>>>0>f>>>0))break}break f}if(!Q|(!I|(e|o^1)))break f;for(k=X<<1,e=0,B=m&1;;){_=G(e,f0)+E|0,X=G(e,F)+$|0,o=G(e,h)+a|0,r=0,f=0;A:{if(!B){for(;;)if(s=p0[n+84>>2],w=p0[n+76>>2],R=p0[n+80>>2],m=r>>>1|0,N=m+X|0,V=U(l[o+2|0]),z=U(l[o|0]),S=U(l[o+1|0]),O=U(U(U(U(U(V*p0[n+72>>2])+U(U(z*p0[n+64>>2])+U(p0[n+68>>2]*S)))*U(.875))+U(128))+U(.5)),U(w2(O))<U(2147483648)?f=~~O:f=-2147483648,f=(f|0)>=255?255:f,u[N|0]=(f|0)>0?f:0,m=_+m|0,s=U(U(U(U(U(V*s)+U(U(z*w)+U(R*S)))*U(.875))+U(128))+U(.5)),U(w2(s))<U(2147483648)?f=~~s:f=-2147483648,f=(f|0)>=255?255:f,u[m|0]=(f|0)>0?f:0,o=k+o|0,r=r+2|0,!(Q>>>0>r>>>0))break A}for(;s=p0[n+84>>2],w=p0[n+76>>2],R=p0[n+80>>2],m=f>>>1|0,N=m+X|0,V=U(l[o+2|0]),z=U(l[o|0]),S=U(l[o+1|0]),O=U(U(U(U(V*p0[n+72>>2])+U(U(z*p0[n+64>>2])+U(p0[n+68>>2]*S)))+U(128))+U(.5)),U(w2(O))<U(2147483648)?r=~~O:r=-2147483648,r=(r|0)>=255?255:r,u[N|0]=(r|0)>0?r:0,m=_+m|0,s=U(U(U(U(V*s)+U(U(z*w)+U(R*S)))+U(128))+U(.5)),U(w2(s))<U(2147483648)?r=~~s:r=-2147483648,r=(r|0)>=255?255:r,u[m|0]=(r|0)>0?r:0,o=k+o|0,f=f+2|0,Q>>>0>f>>>0;);}if(e=e+1|0,(I|0)==(e|0))break}}if(!Q|(!(_0&1)|!I))break r;for(E=a+3|0,X=Q&-4,F=Q&3,_=0,a=(I0|0)!=11;;){e=G(_,e0)+M|0;f:{A:{k:{if(!a){if(f=E+G(h,_)|0,r=0,o=0,k=0,n0>>>0>=3)break k;break A}if(!Q)break f;o0(e,255,Q);break f}for(;u[e+o|0]=l[f+(o<<2)|0],B=o|1,u[B+e|0]=l[f+(B<<2)|0],B=o|2,u[B+e|0]=l[f+(B<<2)|0],B=o|3,u[B+e|0]=l[f+(B<<2)|0],o=o+4|0,k=k+4|0,(X|0)!=(k|0););}if(!F)break f;for(;u[e+o|0]=l[f+(o<<2)|0],o=o+1|0,r=r+1|0,(F|0)!=(r|0););}if(_=_+1|0,(I|0)==(_|0))break}}u[A+20|0]=0,i[A+4>>2]=t,i[A>>2]=P;break i}if(A=i[t+4>>2],i[t+4>>2]=A-1,A)break i;W[i[i[t>>2]+8>>2]](t),y(t)}v=n+160|0}function ji(A,e,r){var f=0,k=0,n=0,t=0,o=0,s=0,w=0,h=0,_=0;h=v-32|0,v=h,l[108637]==1&&(i[h+16>>2]=A,E8(32893,h+16|0));i:{k=i[A+4>>2];e:{if(k){if(n=i[k>>2],(n|0)==1){k=i[A>>2];break e}if((n|0)<=1)break i;i[k>>2]=n-1}l[108637]==1&&(i[h>>2]=A,E8(42644,h)),k=p(172),i[A>>2]=k,o0(k,0,172),s=A,A=p(4),i[s+4>>2]=A,i[A>>2]=1}e:{r:{f:{A:{k:{n:{t:{u:{o:{l:{s:{w:{_:{h:{B:{if((e|0)<=0){A=(r|0)>=51?51:r,n=(A|0)>0?A:0;break B}if(t=e-1|0,f=G(t,12)+59136|0,A=i[f>>2],r=(r|0)>=51?51:r,n=(r|0)>0?r:0,A=((A<<3&120)+(G(n,G(A>>4,5)-45|0)>>4)|0)-16|0,r=(A|0)>=126?126:A,r=(r|0)<=1?1:r,A=(A|0)>63,s=A?r^64:63-r|0,A=s<<1|A,r=k+5|0,(s&127)>>>0>=63||(u[k+5|0]=A,A=i[f+4>>2],A=((A<<3&120)+(G(G(A>>4,5)-45|0,n)>>4)|0)-16|0,r=(A|0)>=126?126:A,r=(r|0)<=1?1:r,A=(A|0)>63,s=A?r^64:63-r|0,A=s<<1|A,r=k+6|0,(s&127)>>>0>62)||(u[k+6|0]=A,A=i[f+8>>2],A=((A<<3&120)+(G(G(A>>4,5)-45|0,n)>>4)|0)-16|0,r=(A|0)>=126?126:A,r=(r|0)<=1?1:r,A=(A|0)>63,f=A?r^64:63-r|0,A=f<<1|A,r=k+7|0,(f&127)>>>0>62))break k;if(u[k+7|0]=A,A=t<<2,r=i[A+59160>>2],r=((r<<3&120)+(G(G(r>>4,5)-45|0,n)>>4)|0)-16|0,f=(r|0)>=126?126:r,f=(f|0)<=1?1:f,r=(r|0)>63,f=r?f^64:63-f|0,r=f<<1|r,(f&127)>>>0>=63)break h;if(u[k+149|0]=r,r=i[A+59168>>2],r=((r<<3&120)+(G(G(r>>4,5)-45|0,n)>>4)|0)-16|0,f=(r|0)>=126?126:r,f=(f|0)<=1?1:f,r=(r|0)>63,f=r?f^64:63-f|0,r=f<<1|r,(f&127)>>>0>=63)break _;if(u[k+147|0]=r,A=i[A+59176>>2],A=((A<<3&120)+(G(G(A>>4,5)-45|0,n)>>4)|0)-16|0,r=(A|0)>=126?126:A,r=(r|0)<=1?1:r,A=(A|0)>63,r=A?r^64:63-r|0,A=r<<1|A,(r&127)>>>0>=63)break w;if(u[k+148|0]=A,A=G(n,-20)>>4,r=(A|0)>-41,f=r?A+104^64:-41-A|0,A=r|f<<1,r=k+156|0,(f&127)>>>0>=63||(u[k+156|0]=A,f=G(n,-25)>>4,t=-41-f|0,_=f+104^64,s=(f|0)>-41,A=s,o=A?_:t,A=o<<1|A,r=k+157|0,(o&127)>>>0>62)||(u[k+157|0]=A,A=G(n,-30)>>4,r=(A|0)>-41,o=r?A+104^64:-41-A|0,A=r|o<<1,r=k+158|0,(o&127)>>>0>62)||(u[k+158|0]=A,A=G(n,-40)>>4,r=(A|0)<=-103?-103:A,A=(A|0)>-41,o=A?r+104^64:-41-r|0,A=o<<1|A,r=k+159|0,(o&127)>>>0>62)||(A=G(A&255,257),u[k+159|0]=A,u[k+160|0]=A>>>8,u[k+154|0]=14,u[k+155|0]=14,o=(e|0)!=1?59192:59184,A=i[o>>2],A=((A<<3&120)+(G(G(A>>4,5)-45|0,n)>>4)|0)-16|0,r=(A|0)>=126?126:A,r=(r|0)<=1?1:r,A=(A|0)>63,w=A?r^64:63-r|0,A=w<<1|A,r=k+150|0,(w&127)>>>0>=63)||(u[k+150|0]=A,A=i[o+4>>2],A=((A<<3&120)+(G(G(A>>4,5)-45|0,n)>>4)|0)-16|0,r=(A|0)>=126?126:A,r=(r|0)<=1?1:r,A=(A|0)>63,o=A?r^64:63-r|0,A=o<<1|A,r=k+151|0,(o&127)>>>0>62))break k;if(u[k+151|0]=A,u[k+152|0]=30-(G(n,5)>>>3&62),r=s?_:t,A=s|r<<1,(r&127)>>>0>62)break s;if(u[k+153|0]=A,A=G(n,-5)>>4,r=(A|0)>-9,f=r?A+72^64:-9-A|0,A=r|f<<1,(f&127)>>>0>=63)break l;A=G(A&255,16843009),u[k+143|0]=A,u[k+144|0]=A>>>8,u[k+145|0]=A>>>16,u[k+146|0]=A>>>24}if(t=G(e,12),f=t+59200|0,A=i[f>>2],A=((A<<3&120)+(G(G(A>>4,5)-45|0,n)>>4)|0)-16|0,r=(A|0)>=126?126:A,r=(r|0)<=1?1:r,A=(A|0)>63,s=A?r^64:63-r|0,A=s<<1|A,r=k+2|0,(s&127)>>>0>=63||(u[k+2|0]=A,A=i[f+4>>2],A=((A<<3&120)+(G(G(A>>4,5)-45|0,n)>>4)|0)-16|0,r=(A|0)>=126?126:A,r=(r|0)<=1?1:r,A=(A|0)>63,s=A?r^64:63-r|0,A=s<<1|A,r=k+3|0,(s&127)>>>0>62)||(u[k+3|0]=A,A=i[f+8>>2],A=((A<<3&120)+(G(G(A>>4,5)-45|0,n)>>4)|0)-16|0,r=(A|0)>=126?126:A,r=(r|0)<=1?1:r,A=(A|0)>63,f=A?r^64:63-r|0,A=f<<1|A,r=k+4|0,(f&127)>>>0>62)||(u[k+4|0]=A,f=(((e|0)==2?5:e)<<2)+59248|0,A=i[f>>2],A=((A<<3&120)+(G(G(A>>4,5)-45|0,n)>>4)|0)-16|0,r=(A|0)>=126?126:A,r=(r|0)<=1?1:r,A=(A|0)>63,s=A?r^64:63-r|0,A=s<<1|A,r=k+8|0,(s&127)>>>0>=63)||(u[k+8|0]=A,A=i[f+4>>2],A=((A<<3&120)+(G(G(A>>4,5)-45|0,n)>>4)|0)-16|0,r=(A|0)>=126?126:A,r=(r|0)<=1?1:r,A=(A|0)>63,s=A?r^64:63-r|0,A=s<<1|A,r=k+9|0,(s&127)>>>0>62)||(u[k+9|0]=A,A=i[f+8>>2],A=((A<<3&120)+(G(G(A>>4,5)-45|0,n)>>4)|0)-16|0,r=(A|0)>=126?126:A,r=(r|0)<=1?1:r,A=(A|0)>63,s=A?r^64:63-r|0,A=s<<1|A,r=k+10|0,(s&127)>>>0>62)||(u[k+10|0]=A,A=i[f+12>>2],A=((A<<3&120)+(G(G(A>>4,5)-45|0,n)>>4)|0)-16|0,r=(A|0)>=126?126:A,r=(r|0)<=1?1:r,A=(A|0)>63,f=A?r^64:63-r|0,A=f<<1|A,r=k+11|0,(f&127)>>>0>62))break k;if(u[k+11|0]=A,s=e<<2,r=s,A=i[r+59284>>2],A=((A<<3&120)+(G(G(A>>4,5)-45|0,n)>>4)|0)-16|0,f=(A|0)>=126?126:A,f=(f|0)<=1?1:f,A=(A|0)>63,f=A?f^64:63-f|0,A=f<<1|A,(f&127)>>>0>=63)break o;if(u[k+12|0]=A,A=i[r+59296>>2],A=((A<<3&120)+(G(G(A>>4,5)-45|0,n)>>4)|0)-16|0,r=(A|0)>=126?126:A,r=(r|0)<=1?1:r,A=(A|0)>63,r=A?r^64:63-r|0,A=r<<1|A,(r&127)>>>0>=63)break u;if(u[k+13|0]=A,f=e?59320:59312,A=i[f>>2],A=((A<<3&120)+(G(G(A>>4,5)-45|0,n)>>4)|0)-16|0,r=(A|0)>=126?126:A,r=(r|0)<=1?1:r,A=(A|0)>63,o=A?r^64:63-r|0,A=o<<1|A,r=k+14|0,(o&127)>>>0>=63||(u[k+14|0]=A,A=i[f+4>>2],A=((A<<3&120)+(G(G(A>>4,5)-45|0,n)>>4)|0)-16|0,r=(A|0)>=126?126:A,r=(r|0)<=1?1:r,A=(A|0)>63,f=A?r^64:63-r|0,A=f<<1|A,r=k+15|0,(f&127)>>>0>62)||(u[k+15|0]=A,f=(e<<4)+59328|0,A=i[f>>2],A=((A<<3&120)+(G(G(A>>4,5)-45|0,n)>>4)|0)-16|0,r=(A|0)>=126?126:A,r=(r|0)<=1?1:r,A=(A|0)>63,o=A?r^64:63-r|0,A=o<<1|A,r=k+16|0,(o&127)>>>0>=63)||(u[k+16|0]=A,A=i[f+4>>2],A=((A<<3&120)+(G(G(A>>4,5)-45|0,n)>>4)|0)-16|0,r=(A|0)>=126?126:A,r=(r|0)<=1?1:r,A=(A|0)>63,o=A?r^64:63-r|0,A=o<<1|A,r=k+17|0,(o&127)>>>0>62)||(u[k+17|0]=A,A=i[f+8>>2],A=((A<<3&120)+(G(G(A>>4,5)-45|0,n)>>4)|0)-16|0,r=(A|0)>=126?126:A,r=(r|0)<=1?1:r,A=(A|0)>63,o=A?r^64:63-r|0,A=o<<1|A,r=k+18|0,(o&127)>>>0>62)||(u[k+18|0]=A,A=i[f+12>>2],A=((A<<3&120)+(G(G(A>>4,5)-45|0,n)>>4)|0)-16|0,r=(A|0)>=126?126:A,r=(r|0)<=1?1:r,A=(A|0)>63,f=A?r^64:63-r|0,A=f<<1|A,r=k+19|0,(f&127)>>>0>62)||(u[k+19|0]=A,f=t+59376|0,A=i[f>>2],A=((A<<3&120)+(G(G(A>>4,5)-45|0,n)>>4)|0)-16|0,r=(A|0)>=126?126:A,r=(r|0)<=1?1:r,A=(A|0)>63,t=A?r^64:63-r|0,A=t<<1|A,r=k+20|0,(t&127)>>>0>=63)||(u[k+20|0]=A,A=i[f+4>>2],A=((A<<3&120)+(G(G(A>>4,5)-45|0,n)>>4)|0)-16|0,r=(A|0)>=126?126:A,r=(r|0)<=1?1:r,A=(A|0)>63,t=A?r^64:63-r|0,A=t<<1|A,r=k+21|0,(t&127)>>>0>62)||(u[k+21|0]=A,A=i[f+8>>2],A=((A<<3&120)+(G(G(A>>4,5)-45|0,n)>>4)|0)-16|0,r=(A|0)>=126?126:A,r=(r|0)<=1?1:r,A=(A|0)>63,f=A?r^64:63-r|0,A=f<<1|A,r=k+22|0,(f&127)>>>0>62))break k;for(u[k+22|0]=A,o=k+25|0,t=G(e,72)+59424|0,A=0;;){if(r=i[t+(A<<2)>>2],r=((r<<3&120)+(G(G(r>>4,5)-45|0,n)>>4)|0)-16|0,f=(r|0)>=126?126:r,f=(f|0)<=1?1:f,r=(r|0)>63,w=r?f^64:63-f|0,f=w<<1|r,r=A+o|0,(w&127)>>>0>=63)break A;if(u[r|0]=f,A=A+1|0,(A|0)==18)break}for(o=k+43|0,A=0;;){if(r=i[t+(A<<2)>>2],r=((r<<3&120)+(G(G(r>>4,5)-45|0,n)>>4)|0)-16|0,f=(r|0)>=126?126:r,f=(f|0)<=1?1:f,r=(r|0)>63,w=r?f^64:63-f|0,f=w<<1|r,r=A+o|0,(w&127)>>>0>=63)break A;if(u[r|0]=f,A=A+1|0,(A|0)==18)break}if(f=(s<<2)+59648|0,A=i[f>>2],A=((A<<3&120)+(G(G(A>>4,5)-45|0,n)>>4)|0)-16|0,r=(A|0)>=126?126:A,r=(r|0)<=1?1:r,A=(A|0)>63,t=A?r^64:63-r|0,A=t<<1|A,r=k+61|0,(t&127)>>>0>=63||(u[k+61|0]=A,A=i[f+4>>2],A=((A<<3&120)+(G(G(A>>4,5)-45|0,n)>>4)|0)-16|0,r=(A|0)>=126?126:A,r=(r|0)<=1?1:r,A=(A|0)>63,t=A?r^64:63-r|0,A=t<<1|A,r=k+62|0,(t&127)>>>0>62)||(u[k+62|0]=A,A=i[f+8>>2],A=((A<<3&120)+(G(G(A>>4,5)-45|0,n)>>4)|0)-16|0,r=(A|0)>=126?126:A,r=(r|0)<=1?1:r,A=(A|0)>63,t=A?r^64:63-r|0,A=t<<1|A,r=k+63|0,(t&127)>>>0>62)||(u[k+63|0]=A,A=i[f+12>>2],A=((A<<3&120)+(G(G(A>>4,5)-45|0,n)>>4)|0)-16|0,r=(A|0)>=126?126:A,r=(r|0)<=1?1:r,A=(A|0)>63,f=A?r^64:63-r|0,A=f<<1|A,r=k- -64|0,(f&127)>>>0>62))break k;for(u[r|0]=A,t=k+65|0,s=G(e,168)+59696|0,A=0;;){if(r=i[s+(A<<2)>>2],r=((r<<3&120)+(G(G(r>>4,5)-45|0,n)>>4)|0)-16|0,f=(r|0)>=126?126:r,f=(f|0)<=1?1:f,r=(r|0)>63,o=r?f^64:63-f|0,r=o<<1|r,f=A+t|0,(o&127)>>>0>=63)break f;if(u[f|0]=r,A=A+1|0,(A|0)==42)break}if(f=(e<<3)+60208|0,A=i[f>>2],A=((A<<3&120)+(G(G(A>>4,5)-45|0,n)>>4)|0)-16|0,r=(A|0)>=126?126:A,r=(r|0)<=1?1:r,A=(A|0)>63,t=A?r^64:63-r|0,A=t<<1|A,r=k+107|0,(t&127)>>>0>=63||(u[k+107|0]=A,A=i[f+4>>2],A=((A<<3&120)+(G(G(A>>4,5)-45|0,n)>>4)|0)-16|0,r=(A|0)>=126?126:A,r=(r|0)<=1?1:r,A=(A|0)>63,f=A?r^64:63-r|0,A=f<<1|A,r=k+108|0,(f&127)>>>0>62))break k;for(u[k+108|0]=A,t=k+109|0,s=G(e,96)+60240|0,A=0;;){if(r=i[s+(A<<2)>>2],r=((r<<3&120)+(G(G(r>>4,5)-45|0,n)>>4)|0)-16|0,f=(r|0)>=126?126:r,f=(f|0)<=1?1:f,r=(r|0)>63,o=r?f^64:63-f|0,r=o<<1|r,f=A+t|0,(o&127)>>>0>=63)break f;if(u[f|0]=r,A=A+1|0,(A|0)==24)break}if(f=G(e,24)+60528|0,A=i[f>>2],A=((A<<3&120)+(G(G(A>>4,5)-45|0,n)>>4)|0)-16|0,r=(A|0)>=126?126:A,r=(r|0)<=1?1:r,A=(A|0)>63,t=A?r^64:63-r|0,A=t<<1|A,r=k+133|0,(t&127)>>>0>=63||(u[k+133|0]=A,A=i[f+4>>2],A=((A<<3&120)+(G(G(A>>4,5)-45|0,n)>>4)|0)-16|0,r=(A|0)>=126?126:A,r=(r|0)<=1?1:r,A=(A|0)>63,t=A?r^64:63-r|0,A=t<<1|A,r=k+134|0,(t&127)>>>0>62)||(u[k+134|0]=A,A=i[f+8>>2],A=((A<<3&120)+(G(G(A>>4,5)-45|0,n)>>4)|0)-16|0,r=(A|0)>=126?126:A,r=(r|0)<=1?1:r,A=(A|0)>63,t=A?r^64:63-r|0,A=t<<1|A,r=k+135|0,(t&127)>>>0>62)||(u[k+135|0]=A,A=i[f+12>>2],A=((A<<3&120)+(G(G(A>>4,5)-45|0,n)>>4)|0)-16|0,r=(A|0)>=126?126:A,r=(r|0)<=1?1:r,A=(A|0)>63,t=A?r^64:63-r|0,A=t<<1|A,r=k+136|0,(t&127)>>>0>62)||(u[k+136|0]=A,A=i[f+16>>2],A=((A<<3&120)+(G(G(A>>4,5)-45|0,n)>>4)|0)-16|0,r=(A|0)>=126?126:A,r=(r|0)<=1?1:r,A=(A|0)>63,t=A?r^64:63-r|0,A=t<<1|A,r=k+137|0,(t&127)>>>0>62)||(u[k+137|0]=A,A=i[f+20>>2],A=((A<<3&120)+(G(G(A>>4,5)-45|0,n)>>4)|0)-16|0,r=(A|0)>=126?126:A,r=(r|0)<=1?1:r,A=(A|0)>63,f=A?r^64:63-r|0,A=f<<1|A,r=k+138|0,(f&127)>>>0>62))break k;if(u[k+138|0]=A,u[k|0]=14,A=i[(e<<2)+60600>>2],A=((A<<3&120)+(G(G(A>>4,5)-45|0,n)>>4)|0)-16|0,e=(A|0)>=126?126:A,e=(e|0)<=1?1:e,A=(A|0)>63,e=A?e^64:63-e|0,A=e<<1|A,(e&127)>>>0>=63)break t;if(u[k+1|0]=A,u[k+139|0]=1,u[k+140|0]=1,A=G(n,-5)>>4,e=(A|0)>=54?54:A,e=(e|0)<=-71?-71:e,A=(A|0)>-9,e=A?e+72^64:-9-e|0,A=e<<1|A,(e&127)>>>0<=62)break n;u[k+141|0]=A;break r}u[k+149|0]=r;break r}u[k+147|0]=r;break r}u[k+148|0]=A;break r}u[k+153|0]=A;break r}u[k+143|0]=A;break r}u[k+12|0]=A;break r}u[k+13|0]=A;break r}u[k+1|0]=A;break r}A=G(A&255,257),u[k+141|0]=A,u[k+142|0]=A>>>8,u[k+170|0]=1,u[k+171|0]=1,u[k+162|0]=1,u[k+163|0]=1,u[k+164|0]=1,u[k+165|0]=1,u[k+166|0]=1,u[k+167|0]=1,u[k+168|0]=1,u[k+169|0]=1,u[k+161|0]=1,u[k+23|0]=1,u[k+24|0]=1;break e}u[r|0]=A;break r}u[r|0]=f;break r}u[f|0]=r}D0(21562,18261,212,12058),H()}v=h+32|0;return}D0(21750,18261,177,18414),H()}function Oi(A,e,r,f,k,n){var t=0,o=0,s=0,w=0,h=0,_=0,B=0,m=0,X=0,Q=0,V=0;t=v-208|0,v=t,Xf(t+200|0,e,i[i[f>>2]+4>>2]),i[t+192>>2]=i[k+32>>2],o=i[k+28>>2],i[t+184>>2]=i[k+24>>2],i[t+188>>2]=o,o=i[k+20>>2],i[t+176>>2]=i[k+16>>2],i[t+180>>2]=o,o=i[k+12>>2],i[t+168>>2]=i[k+8>>2],i[t+172>>2]=o,o=i[k+4>>2],i[t+160>>2]=i[k>>2],i[t+164>>2]=o,i[t+152>>2]=0,i[t+156>>2]=0,k=i[t+200>>2],W[i[i[k>>2]+116>>2]](t+128|0,k),o=i[t+128>>2],k=i[t+132>>2];i:{if(!k||(w=i[k+4>>2],i[k+4>>2]=w-1,w))break i;W[i[i[k>>2]+8>>2]](k),y(k)}i:{e:{r:{f:{A:{k:{n:{if(o){k=i[t+200>>2],W[i[i[k>>2]+116>>2]](t+128|0,k),k=i[t+128>>2],o=W[i[i[k>>2]+8>>2]](k)|0,k=i[t+132>>2];t:{if(!k||(w=i[k+4>>2],i[k+4>>2]=w-1,w))break t;W[i[i[k>>2]+8>>2]](k),y(k)}if(o&&(i[t+164>>2]=o),u[t+148|0]=0,i[t+128>>2]=0,i[t+132>>2]=0,k=i[t+200>>2],W[i[i[k>>2]+116>>2]](t+48|0,k),df(t+104|0,i[t+48>>2],r,f,i[t+164>>2],t+176|0,e- -64|0),k=l[t+124|0],o=l[t+148|0],(o|0)==255){if((k|0)==255)break A;break n}if((k|0)!=255)break n;k=i[23595],i[t+80>>2]=i[23594],i[t+84>>2]=k,W[i[(t+80|0)+(o<<2)>>2]](t+72|0,t+128|0),u[t+148|0]=255;break k}if(k=i[r>>2],o=i[r+4>>2],o&&(i[o+4>>2]=i[o+4>>2]+1),i[t+152>>2]=k,k=i[t+156>>2],i[t+156>>2]=o,!k||(o=i[k+4>>2],i[k+4>>2]=o-1,o))break f;W[i[i[k>>2]+8>>2]](k),y(k);break f}o=t+128|0,i[t+72>>2]=o,w=i[23597],i[t+80>>2]=i[23596],i[t+84>>2]=w,W[i[(t+80|0)+(k<<2)>>2]](t+72|0,o,t+104|0)}if(k=l[t+124|0],(k|0)==255)break A;o=i[23595],i[t+80>>2]=i[23594],i[t+84>>2]=o,W[i[(t+80|0)+(k<<2)>>2]](t+72|0,t+104|0)}u[t+124|0]=255,k=i[t+52>>2];A:{if(!k||(o=i[k+4>>2],i[k+4>>2]=o-1,o))break A;W[i[i[k>>2]+8>>2]](k),y(k)}w=l[t+148|0];A:{if(w){if((w|0)!=1)break e;k=i[t+132>>2],i[A>>2]=i[t+128>>2],i[A+4>>2]=k,k=A+8|0;k:{if(u[t+147|0]>=0){o=i[t+140>>2],i[k>>2]=i[t+136>>2],i[k+4>>2]=o,i[k+8>>2]=i[t+144>>2];break k}T(k,i[t+136>>2],i[t+140>>2])}u[A+20|0]=1;break A}if(k=i[t+128>>2],o=i[t+132>>2],o&&(i[o+4>>2]=i[o+4>>2]+1),i[t+152>>2]=k,k=i[t+156>>2],i[t+156>>2]=o,!k||(o=i[k+4>>2],i[k+4>>2]=o-1,o))break A;W[i[i[k>>2]+8>>2]](k),y(k)}if(k=l[t+148|0],(k|0)!=255&&(o=i[23595],i[t+104>>2]=i[23594],i[t+108>>2]=o,W[i[(t+104|0)+(k<<2)>>2]](t+80|0,t+128|0)),w)break r}B=t+80|0,o=v-80|0,v=o,X=t+152|0,s=i[X>>2],_=i[s+112>>2],w=i[t+200>>2],k=w,i[k+120>>2]=i[s+108>>2],i[k+124>>2]=_,x7(o+16|0,k,X,f,t+160|0,n);f:{A:{k:{n:switch(l[o+60|0]){case 1:if(k=i[o+20>>2],i[B>>2]=i[o+16>>2],i[B+4>>2]=k,k=B+8|0,u[o+35|0]>=0){n=i[o+28>>2],i[k>>2]=i[o+24>>2],i[k+4>>2]=n,i[k+8>>2]=i[o+32>>2];break k}T(k,i[o+24>>2],i[o+28>>2]);break k;case 0:break n;default:break A}n=i[e+48>>2],k=i[e+52>>2];n:{if(k){if(i[k+4>>2]=i[k+4>>2]+1,Z8(o+72|0,n,W[i[i[w>>2]+40>>2]](w)|0),n=i[k+4>>2],i[k+4>>2]=n-1,n)break n;W[i[i[k>>2]+8>>2]](k),y(k);break n}Z8(o+72|0,n,W[i[i[w>>2]+40>>2]](w)|0)}n=o+28|0,_=i[i[o+72>>2]+104>>2],i[w+116>>2]=_,s=i[e+48>>2],k=i[e+52>>2];n:{if(!k){q8(s,_,n,0);break n}if(i[k+4>>2]=i[k+4>>2]+1,q8(s,_,n,0),n=i[k+4>>2],i[k+4>>2]=n-1,n)break n;W[i[i[k>>2]+8>>2]](k),y(k)}if(l[o+60|0])break A;if(k=i[o+16>>2],Q=i[o+20>>2],(k|0)!=(Q|0))for(;;){s=i[k>>2],n=i[s+16>>2]==1769173093,s=n?w:s,V=W[i[i[s>>2]+(n?48:40)>>2]](s)|0,s=i[e+48>>2],n=i[e+52>>2],n&&(i[n+4>>2]=i[n+4>>2]+1),h=i[s+52>>2],s=i[s+56>>2];n:{if(!s){h=R6(h,k);break n}if(i[s+4>>2]=i[s+4>>2]+1,h=R6(h,k),m=i[s+4>>2],i[s+4>>2]=m-1,m)break n;W[i[i[s>>2]+8>>2]](s),y(s)}n:{if(!n||(s=i[n+4>>2],i[n+4>>2]=s-1,s))break n;W[i[i[n>>2]+8>>2]](n),y(n)}s=i[e+48>>2],n=i[e+52>>2],n&&(i[n+4>>2]=i[n+4>>2]+1),m=i[s+60>>2],s=i[s+64>>2];n:{if(s){if(i[s+4>>2]=i[s+4>>2]+1,g[o+14>>1]=h+1,u[o+12|0]=V,i[o+8>>2]=C[o+12>>1]|C[o+14>>1]<<16,C6(m,_,o+8|0),h=i[s+4>>2],i[s+4>>2]=h-1,h)break n;W[i[i[s>>2]+8>>2]](s),y(s);break n}u[o+12|0]=V,g[o+14>>1]=h+1,i[o+4>>2]=C[o+12>>1]|C[o+14>>1]<<16,C6(m,_,o+4|0)}n:{if(!n||(s=i[n+4>>2],i[n+4>>2]=s-1,s))break n;W[i[i[n>>2]+8>>2]](n),y(n)}if(k=k+8|0,(Q|0)==(k|0))break}n:{if(i[i[f>>2]+4>>2]==4||(n=i[X>>2],i[n+116>>2]))break n;s=i[n+108>>2],h=i[n+112>>2],k=1;t:{u:switch(i[n+120>>2]){case 2:k=!(s&1);break t;case 1:k=!((s|h)&1);break t;case 0:case 3:break t;default:break u}k=0}if(k)break n;u[w+272|0]=0}n=i[e+48>>2],k=i[e+52>>2];n:{if(!k){a9(n,_,i[t+172>>2]);break n}if(i[k+4>>2]=i[k+4>>2]+1,a9(n,_,i[t+172>>2]),n=i[k+4>>2],i[k+4>>2]=n-1,n)break n;W[i[i[k>>2]+8>>2]](k),y(k)}k=i[26917],i[B>>2]=i[26916],i[B+4>>2]=k,k=B+8|0;n:{if(u[107683]>=0){n=i[26919],i[k>>2]=i[26918],i[k+4>>2]=n,i[k+8>>2]=i[26920];break n}T(k,i[26918],i[26919])}if(k=i[o+76>>2],!k||(n=i[k+4>>2],i[k+4>>2]=n-1,n))break k;W[i[i[k>>2]+8>>2]](k),y(k)}k=l[o+60|0],(k|0)!=255&&(n=i[25175],i[o+72>>2]=i[25174],i[o+76>>2]=n,W[i[(o+72|0)+(k<<2)>>2]](o+71|0,o+16|0)),v=o+80|0;break f}_2(),H()}f:{if(i[t+80>>2]){e=i[t+84>>2],i[A>>2]=i[t+80>>2],i[A+4>>2]=e,e=A+8|0;A:{if(u[t+99|0]>=0){r=i[t+92>>2],i[e>>2]=i[t+88>>2],i[e+4>>2]=r,i[e+8>>2]=i[t+96>>2];break A}T(e,i[t+88>>2],i[t+92>>2])}u[A+20|0]=1;break f}Mr(e,i[i[t+200>>2]+116>>2],t+200|0);A:{if(!l[t+161|0]||!TA(i[t+152>>2])||(k=i[t+200>>2],!(W[i[i[k>>2]+44>>2]](k)|0)))break A;i[t+72>>2]=0,i[t+76>>2]=0,X9(t+128|0,t+152|0,e- -64|0);k:switch(l[t+148|0]){case 1:e=i[t+132>>2],i[A>>2]=i[t+128>>2],i[A+4>>2]=e,e=A+8|0;n:{t:{if(u[t+147|0]>=0){r=i[t+140>>2],i[e>>2]=i[t+136>>2],i[e+4>>2]=r,i[e+8>>2]=i[t+144>>2],k=1,u[A+20|0]=1;break t}if(T(e,i[t+136>>2],i[t+140>>2]),k=l[t+148|0],u[A+20|0]=1,(k|0)==255)break n}A=i[23595],i[t+104>>2]=i[23594],i[t+108>>2]=A,W[i[(t+104|0)+(k<<2)>>2]](t+48|0,t+128|0)}if(A=i[t+76>>2],!A||(e=i[A+4>>2],i[A+4>>2]=e-1,e))break f;W[i[i[A>>2]+8>>2]](A),y(A);break f;case 0:break k;default:break e}k=i[t+128>>2],n=i[t+132>>2],n&&(i[n+4>>2]=i[n+4>>2]+1),i[t+72>>2]=k,k=i[t+76>>2],i[t+76>>2]=n;k:{if(!k||(n=i[k+4>>2],i[k+4>>2]=n-1,n))break k;W[i[i[k>>2]+8>>2]](k),y(k)}k=t+104|0,Oi(k,e,t+72|0,f,t+160|0,2),s=l[t+124|0];k:{if(s){if((s|0)!=1)break e;D6(A,k);break k}k=i[t+104>>2],i[t+64>>2]=k,f=i[t+108>>2],i[t+68>>2]=f,f&&(i[f+4>>2]=i[f+4>>2]+1),f=i[k+116>>2],k=i[e+48>>2],n=i[i[t+200>>2]+116>>2],i[t+44>>2]=1,i[t+36>>2]=n,i[t+40>>2]=t+36,n=i[t+44>>2],i[t+8>>2]=i[t+40>>2],i[t+12>>2]=n,n=f,f=Fo(t+48|0,t+8|0),a4(k,n,1635088492,f),k=i[f>>2],k&&(i[f+4>>2]=k,Z(k)),B=i[e+48>>2],_=i[i[t+64>>2]+116>>2],f=i[t+200>>2],o=d2(t+48|0,W[i[i[f>>2]+44>>2]](f)|0),n=v-16|0,v=n,f=p(144),i[f+4>>2]=0,i[f+8>>2]=0,i[f>>2]=90164,k=f+16|0,i[k+8>>2]=0,i[k+12>>2]=0,i[k+16>>2]=0,i[k+20>>2]=0,i[k+24>>2]=0,i[k+28>>2]=0,i[k+32>>2]=0,i[k>>2]=86356,i[f+60>>2]=0,i[f+64>>2]=0,i[f+52>>2]=0,i[f+56>>2]=0,i[f+72>>2]=-1,i[f+76>>2]=-1,i[f+80>>2]=-1,i[f+84>>2]=-1,i[f+116>>2]=0,i[f+88>>2]=0,i[f+92>>2]=0,i[f+96>>2]=0,i[f+100>>2]=0,i[f+104>>2]=0,i[f+108>>2]=0,g[f+112>>1]=0,i[k>>2]=87752,i[f+136>>2]=0,i[f+140>>2]=0,i[f+128>>2]=0,i[f+132>>2]=0,i[f+120>>2]=0,i[f+124>>2]=0,i[f+32>>2]=1635088451,w=f+120|0;n:{if((w|0)==(o|0))break n;if(u[o+11|0]>=0){h=i[o+4>>2],i[w>>2]=i[o>>2],i[w+4>>2]=h,i[w+8>>2]=i[o+8>>2];break n}M1(w,i[o>>2],i[o+4>>2])}w=i[B+52>>2],i[n+12>>2]=f,i[n+8>>2]=k,i[f+4>>2]=i[f+4>>2]+1,w=R6(w,n+8|0),k=i[n+12>>2];n:{if(!k||(h=i[k+4>>2],i[k+4>>2]=h-1,h))break n;W[i[i[k>>2]+8>>2]](k),y(k)}k=i[B+60>>2],u[n+4|0]=1,g[n+6>>1]=w+1,i[n>>2]=C[n+4>>1]|C[n+6>>1]<<16,C6(k,_,n),k=i[f+4>>2],i[f+4>>2]=k-1,k||(W[i[i[f>>2]+8>>2]](f),y(f)),v=n+16|0,u[o+11|0]<0&&Z(i[o>>2]);n:{if(l[i[r>>2]+4|0]!=1||(r=i[i[t+200>>2]+116>>2],f=i[e+48>>2],k=i[i[t+64>>2]+116>>2],i[t+32>>2]=1,i[t+36>>2]=k,i[t+28>>2]=t+36,k=i[t+32>>2],i[t>>2]=i[t+28>>2],i[t+4>>2]=k,k=r,r=Fo(t+48|0,t),a4(f,k,1886545261,r),f=i[r>>2],!f))break n;i[r+4>>2]=f,Z(f)}I2(t- -64|0)}r=l[t+124|0],(r|0)!=255&&(f=i[23599],i[t+48>>2]=i[23598],i[t+52>>2]=f,W[i[(t+48|0)+(r<<2)>>2]](t- -64|0,t+104|0)),r=l[t+148|0],(r|0)!=255&&(f=i[23595],i[t+104>>2]=i[23594],i[t+108>>2]=f,W[i[(t+104|0)+(r<<2)>>2]](t+48|0,t+128|0)),r=i[t+76>>2];k:{if(!r||(f=i[r+4>>2],i[r+4>>2]=f-1,f))break k;W[i[i[r>>2]+8>>2]](r),y(r)}if(s)break f}i[t+112>>2]=0,i[t+104>>2]=0,i[t+108>>2]=0,j1(t+128|0,i[e+48>>2],i[i[t+200>>2]+116>>2],t+104|0),r=i[t+132>>2],e=i[t+128>>2],i[t+80>>2]=e,i[t+84>>2]=r,u[t+99|0]<0&&(Z(i[t+88>>2]),e=i[t+80>>2]),r=i[t+140>>2],i[t+88>>2]=i[t+136>>2],i[t+92>>2]=r,i[t+96>>2]=i[t+144>>2];A:{if(e){if(e=i[t+84>>2],i[A>>2]=i[t+80>>2],i[A+4>>2]=e,e=A+8|0,u[t+99|0]>=0){r=i[t+92>>2],i[e>>2]=i[t+88>>2],i[e+4>>2]=r,i[e+8>>2]=i[t+96>>2],e=1;break A}T(e,i[t+88>>2],i[t+92>>2]),e=1;break A}if(w=0,i[t+24>>2]=0,i[t+16>>2]=0,i[t+20>>2]=0,r=i[t+200>>2],k=0,n=0,e=i[t+104>>2],o=i[t+108>>2],(e|0)!=(o|0)){if(f=o-e|0,(f|0)<0)break i;for(n=p(f),i[t+16>>2]=n,w=f+n|0,i[t+24>>2]=w,k=n;i[k>>2]=i[e>>2],f=i[e+4>>2],i[k+4>>2]=f,f&&(i[f+4>>2]=i[f+4>>2]+1),k=k+8|0,e=e+8|0,(o|0)!=(e|0););i[t+20>>2]=k}if(o=i[r+104>>2],o){if(e=i[r+108>>2],f=o,(e|0)!=(o|0)){for(;;){f=i[e-4>>2];k:{if(!f||(k=i[f+4>>2],i[f+4>>2]=k-1,k))break k;W[i[i[f>>2]+8>>2]](f),y(f)}if(e=e-8|0,(o|0)==(e|0))break}w=i[t+24>>2],k=i[t+20>>2],n=i[t+16>>2],f=i[r+104>>2]}i[r+108>>2]=o,Z(f),e=i[t+200>>2]}else e=r;i[r+112>>2]=w,i[r+108>>2]=k,i[r+104>>2]=n,i[t+24>>2]=0,i[t+16>>2]=0,i[t+20>>2]=0,r=i[t+204>>2],i[t+200>>2]=0,i[t+204>>2]=0,i[A+4>>2]=r,i[A>>2]=e,e=0}if(u[A+20|0]=e,A=i[t+104>>2],!A)break f;if(e=A,k=i[t+108>>2],(e|0)!=(k|0)){for(;;){e=i[k-4>>2];A:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break A;W[i[i[e>>2]+8>>2]](e),y(e)}if(k=k-8|0,(A|0)==(k|0))break}e=i[t+104>>2]}i[t+108>>2]=A,Z(e)}if(u[t+99|0]>=0)break r;Z(i[t+88>>2])}A=i[t+156>>2];r:{if(!A||(e=i[A+4>>2],i[A+4>>2]=e-1,e))break r;W[i[i[A>>2]+8>>2]](A),y(A)}A=i[t+204>>2];r:{if(!A||(e=i[A+4>>2],i[A+4>>2]=e-1,e))break r;W[i[i[A>>2]+8>>2]](A),y(A)}v=t+208|0;return}_2(),H()}G0(),H()}function K_(A,e,r,f,k,n,t,o,s){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,t=t|0,o=o|0,s=s|0;var w=0,h=0,_=0,B=0,m=0,X=0,Q=0,V=0,F=0,I=0,E=0,R=0,N=0,M=0,z=0,S=0,O=0;h=v-80|0,v=h;i:{if(!n){e=i[23570],i[A>>2]=i[23569],i[A+4>>2]=e,i[A+8>>2]=i[23571];break i}if(!k){if(u[h|0]=0,u[h+11|0]=0,r=A,A=q(h+24|0,5,2006,h),b0(r,A,i[e>>2]),u[A+19|0]<0&&Z(i[A+8>>2]),u[h+11|0]>=0)break i;Z(i[h>>2]);break i}i[h+64>>2]=0,i[h+56>>2]=0,i[h+60>>2]=0,w=n,m=k<<2,_=n+m|0,Q=k;e:{if((k|0)<=0)break e;if(B=i[h+64>>2],n=i[h+60>>2],B-n>>2>=(k|0)){B=n>>2;r:{if((B|0)>=(k|0)){m=w+m|0,k=n;break r}if(m=n+w|0,k=_-m|0,!k|(_|0)==(m|0)||x(n,m,k),k=k+n|0,i[h+60>>2]=k,(B|0)<=0)break e}if(B=Q<<2,V=B,_=k,B=k-B|0,n>>>0>B>>>0)for(;i[_>>2]=i[B>>2],_=_+4|0,B=B+4|0,n>>>0>B>>>0;);i[h+60>>2]=_;r:{if((k|0)==(V|0)||(n=k-V|0,!n))break r;x(k-n|0,0,n)}if((w|0)==(m|0)||(k=m-w|0,!k))break e;x(0,w,k);break e}r:{if(_=i[h+56>>2],k=Q+(n-_>>2)|0,k>>>0<1073741824){if(B=B-_|0,m=B>>1,B=B>>>0>=2147483644?1073741823:k>>>0<m>>>0?m:k,B){if(B>>>0>=1073741824)break r;k=p(B<<2)}else k=0;m=0-_|0,V=k+m|0,F=Q<<2,F&&x(V,w,F),F=V+F|0,n&&x(F,0,n),i[h+60>>2]=0,V=V-(m&-4)|0,m&&x(V,_,m),i[h+64>>2]=k+(B<<2),i[h+60>>2]=n+F,i[h+56>>2]=V,_&&Z(_);break e}G0(),H()}z0(),H()}g[h+32>>1]=0,i[h+52>>2]=0,i[h+24>>2]=0,i[h+28>>2]=0,i[h+44>>2]=0,i[h+48>>2]=0,i[h+40>>2]=f,i[h+36>>2]=r,o&&(g[h+26>>1]=C[o>>1],g[h+28>>1]=C[o+2>>1],g[h+30>>1]=C[o+4>>1],g[h+32>>1]=C[o+6>>1]);e:{if(!t){for(;;)if(Tt(h+24|0,i[w+(X<<2)>>2],0,0),X=X+1|0,(Q|0)==(X|0))break e}for(r=t+4|0;f=X<<3,Tt(h+24|0,i[w+(X<<2)>>2],i[f+t>>2],i[r+f>>2]),X=X+1|0,(Q|0)!=(X|0););}V=i[e>>2],w=v-80|0,v=w,k=i[h+48>>2],f=i[h+44>>2];e:{if((k-f|0)/12>>>0>=65536){r=p(48),i[w+44>>2]=r,i[w+48>>2]=40,i[w+52>>2]=-2147483600,f=l[26795]|l[26796]<<8|(l[26797]<<16|l[26798]<<24),k=l[26791]|l[26792]<<8|(l[26793]<<16|l[26794]<<24),u[r+32|0]=k,u[r+33|0]=k>>>8,u[r+34|0]=k>>>16,u[r+35|0]=k>>>24,u[r+36|0]=f,u[r+37|0]=f>>>8,u[r+38|0]=f>>>16,u[r+39|0]=f>>>24,f=l[26787]|l[26788]<<8|(l[26789]<<16|l[26790]<<24),k=l[26783]|l[26784]<<8|(l[26785]<<16|l[26786]<<24),u[r+24|0]=k,u[r+25|0]=k>>>8,u[r+26|0]=k>>>16,u[r+27|0]=k>>>24,u[r+28|0]=f,u[r+29|0]=f>>>8,u[r+30|0]=f>>>16,u[r+31|0]=f>>>24,f=l[26779]|l[26780]<<8|(l[26781]<<16|l[26782]<<24),k=l[26775]|l[26776]<<8|(l[26777]<<16|l[26778]<<24),u[r+16|0]=k,u[r+17|0]=k>>>8,u[r+18|0]=k>>>16,u[r+19|0]=k>>>24,u[r+20|0]=f,u[r+21|0]=f>>>8,u[r+22|0]=f>>>16,u[r+23|0]=f>>>24,f=l[26771]|l[26772]<<8|(l[26773]<<16|l[26774]<<24),k=l[26767]|l[26768]<<8|(l[26769]<<16|l[26770]<<24),u[r+8|0]=k,u[r+9|0]=k>>>8,u[r+10|0]=k>>>16,u[r+11|0]=k>>>24,u[r+12|0]=f,u[r+13|0]=f>>>8,u[r+14|0]=f>>>16,u[r+15|0]=f>>>24,f=l[26763]|l[26764]<<8|(l[26765]<<16|l[26766]<<24),k=l[26759]|l[26760]<<8|(l[26761]<<16|l[26762]<<24),u[r|0]=k,u[r+1|0]=k>>>8,u[r+2|0]=k>>>16,u[r+3|0]=k>>>24,u[r+4|0]=f,u[r+5|0]=f>>>8,u[r+6|0]=f>>>16,u[r+7|0]=f>>>24,u[r+40|0]=0,r=q(w+56|0,5,0,w+44|0),f=i[r+4>>2],i[h>>2]=i[r>>2],i[h+4>>2]=f,f=h+8|0;r:{if(u[r+19|0]>=0){k=i[r+12>>2],i[f>>2]=i[r+8>>2],i[f+4>>2]=k,i[f+8>>2]=i[r+16>>2],u[h+20|0]=1;break r}if(T(f,i[r+8>>2],i[r+12>>2]),f=u[r+19|0],u[h+20|0]=1,(f|0)>=0)break r;Z(i[r+8>>2])}if(u[w+55|0]>=0)break e;Z(i[w+44>>2]);break e}i[w+64>>2]=0,i[w+56>>2]=0,i[w+60>>2]=0,X=i[V+48>>2],Q=i[V+52>>2],Q&&(i[Q+4>>2]=i[Q+4>>2]+1,k=i[h+48>>2],f=i[h+44>>2]);r:{if((f|0)==(k|0))break r;f:{for(;;){s4(w+44|0,X,i[f>>2]),r=i[w+44>>2],u[r+164|0]=1,i[r+100>>2]=i[r+100>>2]&-2|1,r=i[w+48>>2];A:{if(!r||(n=i[r+4>>2],i[r+4>>2]=n-1,n))break A;W[i[i[r>>2]+8>>2]](r),y(r)}A:{r=i[w+60>>2],o=i[w+64>>2];k:{if(r>>>0<o>>>0){i[r>>2]=i[f>>2],_=r+4|0;break k}if(t=i[w+56>>2],r=r-t|0,B=r>>2,n=B+1|0,n>>>0>=1073741824)break A;if(o=o-t|0,_=o>>1,o=o>>>0>=2147483644?1073741823:n>>>0<_>>>0?_:n,o){if(o>>>0>=1073741824)break f;n=p(o<<2)}else n=0;if(_=n+r|0,i[_>>2]=i[f>>2],B=_-(B<<2)|0,r&&x(B,t,r),i[w+64>>2]=n+(o<<2),_=_+4|0,i[w+60>>2]=_,i[w+56>>2]=B,!t)break k;Z(t)}if(i[w+60>>2]=_,f=f+12|0,(k|0)!=(f|0))continue;break r}break}G0(),H()}z0(),H()}_=i[h+36>>2],m=i[h+40>>2],f=_>>>0>65535|m>>>0>65535,t=i[h+44>>2],F=i[h+48>>2],R=(t|0)==(F|0),r=f;r:{f:{if(R)break f;for(k=t;;){if(n=i[k+4>>2],(n|0)>=32768){i[w+52>>2]=0,i[w+44>>2]=0,i[w+48>>2]=0,k=F-t|0,o=2,r=1,f=4;break r}if(r=1,(n|0)<-32768|i[k+8>>2]-32768>>>0<=4294901759)break f;if(k=k+12|0,(F|0)==(k|0))break}r=f}i[w+52>>2]=0,i[w+44>>2]=0,i[w+48>>2]=0,f=r&1,o=f?2:1,k=F-t|0,f=f?4:2}r:{if(n=((k|0)/12<<1)+2<<o,(n|0)>-11){if(k=0,o=n+10|0,n=p(o),o&&o0(n,0,o),o=n+o|0,i[w+52>>2]=o,i[w+48>>2]=o,i[w+44>>2]=n,o=l[h+24|0],u[n+1|0]=r&1,u[n|0]=o,r=C[h+26>>1],r=r<<8|r>>>8,u[n+2|0]=r,u[n+3|0]=r>>>8,r=C[h+28>>1],r=r<<8|r>>>8,u[n+4|0]=r,u[n+5|0]=r>>>8,r=C[h+30>>1],r=r<<8|r>>>8,u[n+6|0]=r,u[n+7|0]=r>>>8,r=C[h+32>>1],r=r<<8|r>>>8,u[n+8|0]=r,u[n+9|0]=r>>>8,o=n+10|0,f>>>0>=4)for(B=o+3|0,I=o+2|0,N=o+1|0,M=f&4,r=0;u[k+o|0]=_>>>(f+(k^-1)<<3),u[k+N|0]=_>>>(f+(k^536870910)<<3),u[k+I|0]=_>>>(f+(k^536870909)<<3),u[k+B|0]=_>>>(f+(k^536870908)<<3),k=k+4|0,r=r+4|0,(M|0)!=(r|0););if(B=f&2,B)for(r=0;u[k+o|0]=_>>>(f+(k^-1)<<3),k=k+1|0,r=r+1|0,(B|0)!=(r|0););if(I=f+10|0,o=n+I|0,B=0,k=0,f>>>0>=4)for(_=o+3|0,N=o+2|0,M=o+1|0,E=f&4,r=0;u[k+o|0]=m>>>(f+(k^-1)<<3),u[k+M|0]=m>>>(f+(k^536870910)<<3),u[k+N|0]=m>>>(f+(k^536870909)<<3),u[k+_|0]=m>>>(f+(k^536870908)<<3),k=k+4|0,r=r+4|0,(E|0)!=(r|0););if(r=f&2,r)for(;u[k+o|0]=m>>>(f+(k^-1)<<3),k=k+1|0,B=B+1|0,(r|0)!=(B|0););if(!R)for(N=f<<1,R=f&4,m=f&2,M=f+n|0;;){if(o=I+M|0,_=i[t+4>>2],r=0,k=0,E=f>>>0<4,!E)for(z=o+3|0,S=o+2|0,O=o+1|0,B=0;u[k+o|0]=_>>(f+(k^-1)<<3),u[k+O|0]=_>>(f+(k^536870910)<<3),u[k+S|0]=_>>(f+(k^536870909)<<3),u[k+z|0]=_>>(f+(k^536870908)<<3),k=k+4|0,B=B+4|0,(R|0)!=(B|0););if(m)for(;u[k+o|0]=_>>(f+(k^-1)<<3),k=k+1|0,r=r+1|0,(m|0)!=(r|0););if(I=I+N|0,o=n+I|0,_=i[t+8>>2],r=0,k=0,!E)for(E=o+3|0,z=o+2|0,S=o+1|0,B=0;u[k+o|0]=_>>(f+(k^-1)<<3),u[k+S|0]=_>>(f+(k^536870910)<<3),u[k+z|0]=_>>(f+(k^536870909)<<3),u[k+E|0]=_>>(f+(k^536870908)<<3),k=k+4|0,B=B+4|0,(R|0)!=(B|0););if(m)for(;u[k+o|0]=_>>(f+(k^-1)<<3),k=k+1|0,r=r+1|0,(m|0)!=(r|0););if(t=t+12|0,(F|0)==(t|0))break}break r}G0(),H()}f=aA(X,1768912492),k=p(512),i[k>>2]=101056,r=k,i[r+4>>2]=0,i[r+8>>2]=0,_=E4(r+16|0,V,f),i[_>>2]=101384,g[r+472>>1]=0,i[r+464>>2]=0,i[r+468>>2]=0,i[r+476>>2]=0,i[r+480>>2]=0,i[r+484>>2]=0,i[r+488>>2]=0,i[r+492>>2]=0,i[r+496>>2]=0,i[r+500>>2]=0,i[r+504>>2]=0,i[w+40>>2]=r,i[w+36>>2]=_,i[r+4>>2]=i[r+4>>2]+1,Mr(V,f,w+36|0),r=i[w+40>>2];r:{if(!r||(n=i[r+4>>2],i[r+4>>2]=n-1,n))break r;W[i[i[r>>2]+8>>2]](r),y(r)}q8(X,f,w+44|0,1),a4(X,f,1684630887,w+56|0),n=p(128),i[n>>2]=90124,i[n+4>>2]=0,i[n+8>>2]=0,r=n+16|0,i[r+8>>2]=0,i[r+12>>2]=0,i[n+32>>2]=0,i[n+36>>2]=0,i[n+40>>2]=0,i[n+44>>2]=0,i[n+48>>2]=0,i[n+16>>2]=86356,i[n+60>>2]=0,i[n+64>>2]=0,i[n+52>>2]=0,i[n+56>>2]=0,i[n+72>>2]=-1,i[n+76>>2]=-1,i[n+80>>2]=-1,i[n+84>>2]=-1,i[n+116>>2]=0,i[n+88>>2]=0,i[n+92>>2]=0,i[n+96>>2]=0,i[n+100>>2]=0,i[n+104>>2]=0,i[n+108>>2]=0,g[n+112>>1]=0,i[n+16>>2]=87604,i[n+32>>2]=1769173093,f=i[h+40>>2],i[n+120>>2]=i[h+36>>2],i[n+124>>2]=f,i[w+32>>2]=n,i[w+28>>2]=r,i[n+4>>2]=i[n+4>>2]+1,r=i[w+32>>2],i[w+8>>2]=i[w+28>>2],i[w+12>>2]=r,M4(_,w+8|0,0),r=i[i[w+56>>2]>>2],t=v-32|0,v=t,i[t+28>>2]=0,i[t+20>>2]=0,i[t+24>>2]=0,j1(t,X,r,t+20|0);r:{if(i[t>>2]){i[w+36>>2]=0,i[w+40>>2]=0;break r}f:{if(o=i[t+20>>2],f=i[t+24>>2],(o|0)!=(f|0)){if(r=i[o>>2],r&&(X=i[w+40>>2],r=W0(r,86580,88852),r))break f;if(o=o+8|0,(f|0)!=(o|0))for(;;){if(r=i[o>>2],r&&(X=0,r=W0(r,86580,88852),r))break f;if(o=o+8|0,(f|0)==(o|0))break}i[w+36>>2]=0,i[w+40>>2]=0}i[w+36>>2]=0,i[w+40>>2]=0;break r}if(i[w+40>>2]=X,i[w+36>>2]=r,r=i[o+4>>2],i[w+40>>2]=r,!r)break r;i[r+4>>2]=i[r+4>>2]+1}if(u[t+19|0]<0&&Z(i[t+8>>2]),f=i[t+20>>2],f){if(r=f,o=i[t+24>>2],(r|0)!=(o|0)){for(;;){r=i[o-4>>2];r:{if(!r||(B=i[r+4>>2],i[r+4>>2]=B-1,B))break r;W[i[i[r>>2]+8>>2]](r),y(r)}if(o=o-8|0,(f|0)==(o|0))break}r=i[t+20>>2]}i[t+24>>2]=f,Z(r)}v=t+32|0,i[w+20>>2]=i[w+36>>2],r=i[w+40>>2],i[w+24>>2]=r,r&&(i[r+4>>2]=i[r+4>>2]+1),r=i[w+24>>2],i[w>>2]=i[w+20>>2],i[w+4>>2]=r,M4(_,w,1),u[h+20|0]=0,i[h+4>>2]=k,i[h>>2]=_,r=i[w+40>>2];r:{if(!r||(f=i[r+4>>2],i[r+4>>2]=f-1,f))break r;W[i[i[r>>2]+8>>2]](r),y(r)}r=i[n+4>>2],i[n+4>>2]=r-1,r||(W[i[i[n>>2]+8>>2]](n),y(n)),r=i[w+44>>2],r&&(i[w+48>>2]=r,Z(r));r:{if(!Q||(r=i[Q+4>>2],i[Q+4>>2]=r-1,r))break r;W[i[i[Q>>2]+8>>2]](Q),y(Q)}if(r=i[w+56>>2],!r)break e;i[w+60>>2]=r,Z(r)}v=w+80|0;e:{r:switch(l[h+20|0]){default:_2(),H();case 1:b0(A,h,i[e>>2]);break e;case 0:break r}k=i[h>>2];r:{r=i[h+4>>2];f:{if(!r){if(s)break f;e=i[24057],i[A>>2]=i[24056],i[A+4>>2]=e,i[A+8>>2]=i[24058];break e}if(i[r+4>>2]=i[r+4>>2]+1,!s)break r}f=p(16),i[f+8>>2]=0,i[f+12>>2]=0,i[s>>2]=f,i[f+4>>2]=r,i[f>>2]=k,k=i[e>>2],r=i[e+4>>2];f:{if(!r){i[f+12>>2]=r,i[f+8>>2]=k;break f}if(i[r+4>>2]=i[r+4>>2]+1,i[f+8>>2]=k,e=i[f+12>>2],i[f+12>>2]=r,!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break f;W[i[i[e>>2]+8>>2]](e),y(e)}e=i[24057],i[A>>2]=i[24056],i[A+4>>2]=e,i[A+8>>2]=i[24058];break e}if(e=i[24057],i[A>>2]=i[24056],i[A+4>>2]=e,i[A+8>>2]=i[24058],A=i[r+4>>2],i[r+4>>2]=A-1,A)break e;W[i[i[r>>2]+8>>2]](r),y(r)}if(A=l[h+20|0],(A|0)!=255&&(e=i[24211],i[h+72>>2]=i[24210],i[h+76>>2]=e,W[i[(h+72|0)+(A<<2)>>2]](h+71|0,h)),A=i[h+44>>2],A&&(i[h+48>>2]=A,Z(A)),A=i[h+56>>2],!A)break i;i[h+60>>2]=A,Z(A)}v=h+80|0}function N7(A,e,r,f,k,n){var t=0,o=0,s=0,w=0,h=0,_=0;t=v-176|0,v=t;i:{o=i[r>>2];e:{if(!(u0[o+108>>2]<=65535&u0[o+112>>2]<65536)){if(e=p(32),i[t+128>>2]=e,i[t+132>>2]=31,i[t+136>>2]=-2147483616,f=l[10848]|l[10849]<<8|(l[10850]<<16|l[10851]<<24),k=l[10844]|l[10845]<<8|(l[10846]<<16|l[10847]<<24),u[e|0]=k,u[e+1|0]=k>>>8,u[e+2|0]=k>>>16,u[e+3|0]=k>>>24,u[e+4|0]=f,u[e+5|0]=f>>>8,u[e+6|0]=f>>>16,u[e+7|0]=f>>>24,u[e+31|0]=0,f=l[10871]|l[10872]<<8|(l[10873]<<16|l[10874]<<24),k=l[10867]|l[10868]<<8|(l[10869]<<16|l[10870]<<24),u[e+23|0]=k,u[e+24|0]=k>>>8,u[e+25|0]=k>>>16,u[e+26|0]=k>>>24,u[e+27|0]=f,u[e+28|0]=f>>>8,u[e+29|0]=f>>>16,u[e+30|0]=f>>>24,f=l[10864]|l[10865]<<8|(l[10866]<<16|l[10867]<<24),k=l[10860]|l[10861]<<8|(l[10862]<<16|l[10863]<<24),u[e+16|0]=k,u[e+17|0]=k>>>8,u[e+18|0]=k>>>16,u[e+19|0]=k>>>24,u[e+20|0]=f,u[e+21|0]=f>>>8,u[e+22|0]=f>>>16,u[e+23|0]=f>>>24,f=l[10856]|l[10857]<<8|(l[10858]<<16|l[10859]<<24),k=l[10852]|l[10853]<<8|(l[10854]<<16|l[10855]<<24),u[e+8|0]=k,u[e+9|0]=k>>>8,u[e+10|0]=k>>>16,u[e+11|0]=k>>>24,u[e+12|0]=f,u[e+13|0]=f>>>8,u[e+14|0]=f>>>16,u[e+15|0]=f>>>24,q(A,2,0,t+128|0),u[t+139|0]>=0)break e;Z(i[t+128>>2]);break e}i[e+292>>2]=n;r:{f:{A:{if(!i[k+36>>2]||!TA(o)|i[e+320>>2]|i[i[f>>2]+4>>2]==8)break A;if(i[e+328>>2]){if(e=A,A=d2(t+128|0,24522),q(e,5,0,A),u[A+11|0]>=0)break e;Z(i[A>>2]);break e}i[t+144>>2]=0,i[t+148>>2]=0,i[t+152>>2]=0,i[t+156>>2]=0,i[t+136>>2]=0,i[t+140>>2]=0,u[t+132|0]=0,i[t+128>>2]=i[e+32>>2],o=i[r>>2],rn(t+104|0,i[e+20>>2],t+128|0,1635088502,C[o+108>>1],C[o+112>>1]),o=107664;k:switch(l[t+124|0]){case 1:o=t+104|0;break;case 0:break k;default:break i}if(w=k8(A,o),i[w>>2])break f;if(u[w+19|0]<0&&Z(i[w+8>>2]),l[t+124|0])break i;if(r3(e+320|0,t+104|0),M9(i[e+320>>2],1635088492,i[e+24>>2]),o=p(8),s=i[f>>2],i[o+4>>2]=0,i[o>>2]=s,i[t+40>>2]=o,s=t+40|0,h=i[s>>2],i[s>>2]=0,o=i[e+332>>2],i[e+332>>2]=h,o&&(h=i[o+4>>2],h&&(W[i[i[o>>2]+40>>2]](h),i[o+4>>2]=0),Z(o)),o=i[s>>2],i[s>>2]=0,o&&(h=i[o+4>>2],h&&(W[i[i[o>>2]+40>>2]](h),i[o+4>>2]=0),Z(o)),w5(s,i[e+332>>2]),o=i[t+40>>2],o){e=i[t+44>>2],A=d2(t+16|0,i[t+48>>2]),q(w,o,e,A),u[A+11|0]<0&&Z(i[A>>2]),A=l[t+124|0],(A|0)!=255&&(e=i[26689],i[t+40>>2]=i[26688],i[t+44>>2]=e,W[i[(t+40|0)+(A<<2)>>2]](t+16|0,t+104|0)),W5(t+128|0);break e}o=l[t+124|0],(o|0)!=255&&(s=i[26689],i[t+40>>2]=i[26688],i[t+44>>2]=s,W[i[(t+40|0)+(o<<2)>>2]](t+16|0,t+104|0)),W5(t+128|0)}if(o=i[e+328>>2],!o){i[e+328>>2]=f;break r}if((f|0)==(o|0))break r;if(e=p(64),i[t+128>>2]=e,i[t+132>>2]=62,i[t+136>>2]=-2147483584,f=l[25607]|l[25608]<<8|(l[25609]<<16|l[25610]<<24),k=l[25603]|l[25604]<<8|(l[25605]<<16|l[25606]<<24),u[e|0]=k,u[e+1|0]=k>>>8,u[e+2|0]=k>>>16,u[e+3|0]=k>>>24,u[e+4|0]=f,u[e+5|0]=f>>>8,u[e+6|0]=f>>>16,u[e+7|0]=f>>>24,u[e+62|0]=0,f=l[25661]|l[25662]<<8|(l[25663]<<16|l[25664]<<24),k=l[25657]|l[25658]<<8|(l[25659]<<16|l[25660]<<24),u[e+54|0]=k,u[e+55|0]=k>>>8,u[e+56|0]=k>>>16,u[e+57|0]=k>>>24,u[e+58|0]=f,u[e+59|0]=f>>>8,u[e+60|0]=f>>>16,u[e+61|0]=f>>>24,f=l[25655]|l[25656]<<8|(l[25657]<<16|l[25658]<<24),k=l[25651]|l[25652]<<8|(l[25653]<<16|l[25654]<<24),u[e+48|0]=k,u[e+49|0]=k>>>8,u[e+50|0]=k>>>16,u[e+51|0]=k>>>24,u[e+52|0]=f,u[e+53|0]=f>>>8,u[e+54|0]=f>>>16,u[e+55|0]=f>>>24,f=l[25647]|l[25648]<<8|(l[25649]<<16|l[25650]<<24),k=l[25643]|l[25644]<<8|(l[25645]<<16|l[25646]<<24),u[e+40|0]=k,u[e+41|0]=k>>>8,u[e+42|0]=k>>>16,u[e+43|0]=k>>>24,u[e+44|0]=f,u[e+45|0]=f>>>8,u[e+46|0]=f>>>16,u[e+47|0]=f>>>24,f=l[25639]|l[25640]<<8|(l[25641]<<16|l[25642]<<24),k=l[25635]|l[25636]<<8|(l[25637]<<16|l[25638]<<24),u[e+32|0]=k,u[e+33|0]=k>>>8,u[e+34|0]=k>>>16,u[e+35|0]=k>>>24,u[e+36|0]=f,u[e+37|0]=f>>>8,u[e+38|0]=f>>>16,u[e+39|0]=f>>>24,f=l[25631]|l[25632]<<8|(l[25633]<<16|l[25634]<<24),k=l[25627]|l[25628]<<8|(l[25629]<<16|l[25630]<<24),u[e+24|0]=k,u[e+25|0]=k>>>8,u[e+26|0]=k>>>16,u[e+27|0]=k>>>24,u[e+28|0]=f,u[e+29|0]=f>>>8,u[e+30|0]=f>>>16,u[e+31|0]=f>>>24,f=l[25623]|l[25624]<<8|(l[25625]<<16|l[25626]<<24),k=l[25619]|l[25620]<<8|(l[25621]<<16|l[25622]<<24),u[e+16|0]=k,u[e+17|0]=k>>>8,u[e+18|0]=k>>>16,u[e+19|0]=k>>>24,u[e+20|0]=f,u[e+21|0]=f>>>8,u[e+22|0]=f>>>16,u[e+23|0]=f>>>24,f=l[25615]|l[25616]<<8|(l[25617]<<16|l[25618]<<24),k=l[25611]|l[25612]<<8|(l[25613]<<16|l[25614]<<24),u[e+8|0]=k,u[e+9|0]=k>>>8,u[e+10|0]=k>>>16,u[e+11|0]=k>>>24,u[e+12|0]=f,u[e+13|0]=f>>>8,u[e+14|0]=f>>>16,u[e+15|0]=f>>>24,q(A,5,0,t+128|0),u[t+139|0]>=0)break e;Z(i[t+128>>2]);break e}A=l[t+124|0],(A|0)!=255&&(e=i[26689],i[t+40>>2]=i[26688],i[t+44>>2]=e,W[i[(t+40|0)+(A<<2)>>2]](t+16|0,t+104|0)),W5(t+128|0);break e}if(o=i[f>>2],i[o>>2]<=3){if(e=p(48),i[t+128>>2]=e,i[t+132>>2]=46,i[t+136>>2]=-2147483600,f=l[26076]|l[26077]<<8|(l[26078]<<16|l[26079]<<24),k=l[26072]|l[26073]<<8|(l[26074]<<16|l[26075]<<24),u[e|0]=k,u[e+1|0]=k>>>8,u[e+2|0]=k>>>16,u[e+3|0]=k>>>24,u[e+4|0]=f,u[e+5|0]=f>>>8,u[e+6|0]=f>>>16,u[e+7|0]=f>>>24,u[e+46|0]=0,f=l[26114]|l[26115]<<8|(l[26116]<<16|l[26117]<<24),k=l[26110]|l[26111]<<8|(l[26112]<<16|l[26113]<<24),u[e+38|0]=k,u[e+39|0]=k>>>8,u[e+40|0]=k>>>16,u[e+41|0]=k>>>24,u[e+42|0]=f,u[e+43|0]=f>>>8,u[e+44|0]=f>>>16,u[e+45|0]=f>>>24,f=l[26108]|l[26109]<<8|(l[26110]<<16|l[26111]<<24),k=l[26104]|l[26105]<<8|(l[26106]<<16|l[26107]<<24),u[e+32|0]=k,u[e+33|0]=k>>>8,u[e+34|0]=k>>>16,u[e+35|0]=k>>>24,u[e+36|0]=f,u[e+37|0]=f>>>8,u[e+38|0]=f>>>16,u[e+39|0]=f>>>24,f=l[26100]|l[26101]<<8|(l[26102]<<16|l[26103]<<24),k=l[26096]|l[26097]<<8|(l[26098]<<16|l[26099]<<24),u[e+24|0]=k,u[e+25|0]=k>>>8,u[e+26|0]=k>>>16,u[e+27|0]=k>>>24,u[e+28|0]=f,u[e+29|0]=f>>>8,u[e+30|0]=f>>>16,u[e+31|0]=f>>>24,f=l[26092]|l[26093]<<8|(l[26094]<<16|l[26095]<<24),k=l[26088]|l[26089]<<8|(l[26090]<<16|l[26091]<<24),u[e+16|0]=k,u[e+17|0]=k>>>8,u[e+18|0]=k>>>16,u[e+19|0]=k>>>24,u[e+20|0]=f,u[e+21|0]=f>>>8,u[e+22|0]=f>>>16,u[e+23|0]=f>>>24,f=l[26084]|l[26085]<<8|(l[26086]<<16|l[26087]<<24),k=l[26080]|l[26081]<<8|(l[26082]<<16|l[26083]<<24),u[e+8|0]=k,u[e+9|0]=k>>>8,u[e+10|0]=k>>>16,u[e+11|0]=k>>>24,u[e+12|0]=f,u[e+13|0]=f>>>8,u[e+14|0]=f>>>16,u[e+15|0]=f>>>24,q(A,11,6003,t+128|0),u[t+139|0]>=0)break e;Z(i[t+128>>2]);break e}w=i[e+104>>2];r:{f:{if((w|0)==i[e+100>>2]){s=i[o+4>>2];break f}if(s=i[o+4>>2],o=i[w-8>>2],(s|0)==i[o+12>>2])break r}_9(e,s),o=i[i[e+104>>2]-8>>2]}W[i[i[o>>2]+12>>2]](t+96|0,o),o=i[t+96>>2],o=W[i[i[o>>2]+8>>2]](o)|0,o||(o=i[k+4>>2]),df(t+128|0,i[t+96>>2],r,f,o,k+8|0,i[e+20>>2]- -64|0);r:{f:switch(l[t+148|0]){case 1:if(e=i[t+132>>2],i[A>>2]=i[t+128>>2],i[A+4>>2]=e,A=A+8|0,u[t+147|0]>=0){e=i[t+140>>2],i[A>>2]=i[t+136>>2],i[A+4>>2]=e,i[A+8>>2]=i[t+144>>2];break r}T(A,i[t+136>>2],i[t+140>>2]);break r;case 0:break f;default:break i}o=i[t+128>>2],i[t+88>>2]=o,s=i[t+132>>2],i[t+92>>2]=s,s&&(i[s+4>>2]=i[s+4>>2]+1),g[e+288>>1]=i[o+108>>2],g[e+290>>1]=i[o+112>>2],s=i[t+96>>2],W[i[i[s>>2]+20>>2]](t- -64|0,s,t+88|0,f,k,n,i[o+144>>2],i[i[e+156>>2]+120>>2],i[e+296>>2]);f:{if(i[t+64>>2]){e=i[t+68>>2],i[A>>2]=i[t+64>>2],i[A+4>>2]=e,e=i[t+76>>2],i[A+8>>2]=i[t+72>>2],i[A+12>>2]=e,i[A+16>>2]=i[t+80>>2];break f}if(n=i[i[t+88>>2]+144>>2],i[e+316>>2]=n,i[t+124>>2]=0,u[t+120|0]=0,u[t+108|0]=0,i[t+104>>2]=n,w=t+108|0,n=i[r>>2],l[n+80|0]==1){A:{k:{if(u[n+79|0]>=0){i[t+48>>2]=i[n+76>>2],o=i[n+72>>2],i[t+40>>2]=i[n+68>>2],i[t+44>>2]=o;break k}if(T(t+40|0,i[n+68>>2],i[n+72>>2]),!(u[t+120|0]&1))break k;u[t+119|0]<0&&Z(i[t+108>>2]),n=i[t+44>>2],i[w>>2]=i[t+40>>2],i[w+4>>2]=n,i[w+8>>2]=i[t+48>>2];break A}n=i[t+44>>2],i[w>>2]=i[t+40>>2],i[w+4>>2]=n,i[w+8>>2]=i[t+48>>2],u[t+120|0]=1}n=i[r>>2]}n=i[n+64>>2],n&&(o=ye(),i[t+124>>2]=o,Qi(o,n)),_=i[e+296>>2],h=e+304|0,o=i[h+4>>2];A:{k:{if(!o){s=h+4|0,n=s;break k}for(;;){if(n=o,s=i[o+16>>2],s>>>0>_>>>0){if(s=o,o=i[o>>2],o)continue;break k}if(s>>>0>=_>>>0)break A;if(o=i[n+4>>2],!o)break}s=n+4|0}o=p(44),i[o+20>>2]=0,i[o+24>>2]=0,i[o+16>>2]=_,i[o+8>>2]=n,i[o>>2]=0,i[o+4>>2]=0,i[o+28>>2]=0,i[o+32>>2]=0,i[o+36>>2]=0,i[o+40>>2]=0,i[s>>2]=o,n=i[i[h>>2]>>2],n&&(i[h>>2]=n),m1(i[h+4>>2],o),i[h+8>>2]=i[h+8>>2]+1}n=o+20|0,i[n>>2]=i[t+104>>2],bt(n+4|0,w),i[n+20>>2]=i[t+124>>2],i[e+296>>2]=i[e+296>>2]+1,e9(t+40|0,e,f),o=107664;A:switch(l[t+60|0]){case 1:o=t+40|0;break;case 0:break A;default:break i}n=k8(A,o);A:{if(i[n>>2])break A;if(u[n+19|0]<0&&Z(i[n+8>>2]),i[e+320>>2]){X9(t+16|0,t+88|0,i[e+20>>2]- -64|0),A=107664;k:switch(l[t+36|0]){case 1:A=t+16|0;break;case 0:break k;default:break i}f=0,A=k8(n,A);k:{if(i[A>>2])break k;if(u[n+19|0]<0&&Z(i[A+8>>2]),l[t+36|0])break i;if(o=i[t+16>>2],i[o+144>>2]=i[i[t+88>>2]+144>>2],s=i[e+320>>2],i[t+8>>2]=o,o=i[t+20>>2],i[t+12>>2]=o,o&&(i[o+4>>2]=i[o+4>>2]+1),e=i[e+332>>2],o=i[t+12>>2],i[t>>2]=i[t+8>>2],i[t+4>>2]=o,N7(A,s,t,e,k,2),i[A>>2]||(f=1,u[n+19|0]>=0))break k;Z(i[A+8>>2])}if(A=l[t+36|0],(A|0)!=255&&(e=i[26679],i[t+168>>2]=i[26678],i[t+172>>2]=e,W[i[(t+168|0)+(A<<2)>>2]](t+167|0,t+16|0)),!f)break A}i[n>>2]=0,i[n+4>>2]=0,i[n+16>>2]=0,i[n+8>>2]=0,i[n+12>>2]=0}if(A=l[t+60|0],(A|0)!=255&&(e=i[26687],i[t+16>>2]=i[26686],i[t+20>>2]=e,W[i[(t+16|0)+(A<<2)>>2]](t+168|0,t+40|0)),l[t+120|0]!=1|u[t+119|0]>=0||Z(i[t+108>>2]),u[t+83|0]>=0)break f;Z(i[t+72>>2])}if(A=i[t+92>>2],!A||(e=i[A+4>>2],i[A+4>>2]=e-1,e))break r;W[i[i[A>>2]+8>>2]](A),y(A)}if(A=l[t+148|0],(A|0)!=255&&(e=i[26679],i[t+104>>2]=i[26678],i[t+108>>2]=e,W[i[(t+104|0)+(A<<2)>>2]](t+40|0,t+128|0)),A=i[t+100>>2],!A||(e=i[A+4>>2],i[A+4>>2]=e-1,e))break e;W[i[i[A>>2]+8>>2]](A),y(A)}A=i[r+4>>2];e:{if(!A||(e=i[A+4>>2],i[A+4>>2]=e-1,e))break e;W[i[i[A>>2]+8>>2]](A),y(A)}v=t+176|0;return}_2(),H()}function q_(A,e,r,f,k,n,t){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,t=t|0;var o=0,s=0,w=0,h=0,_=0,B=0,m=0;o=v+-64|0,v=o,B=i[e+116>>2],m=t+4|0,h=m,s=h,w=i[t+4>>2];i:{e:{r:{if(!w)break r;for(s=w;_=B>>>0>u0[s+16>>2],h=_?h:s,s=i[(_?4:0)+s>>2],!!s;);if(!((h|0)==(m|0)|B>>>0<u0[h+16>>2])){f=p(32),i[o+28>>2]=f,i[o+32>>2]=28,i[o+36>>2]=-2147483616,e=l[5952]|l[5953]<<8|(l[5954]<<16|l[5955]<<24),u[f+24|0]=e,u[f+25|0]=e>>>8,u[f+26|0]=e>>>16,u[f+27|0]=e>>>24,r=l[5948]|l[5949]<<8|(l[5950]<<16|l[5951]<<24),e=l[5944]|l[5945]<<8|(l[5946]<<16|l[5947]<<24),u[f+16|0]=e,u[f+17|0]=e>>>8,u[f+18|0]=e>>>16,u[f+19|0]=e>>>24,u[f+20|0]=r,u[f+21|0]=r>>>8,u[f+22|0]=r>>>16,u[f+23|0]=r>>>24,r=l[5940]|l[5941]<<8|(l[5942]<<16|l[5943]<<24),e=l[5936]|l[5937]<<8|(l[5938]<<16|l[5939]<<24),u[f+8|0]=e,u[f+9|0]=e>>>8,u[f+10|0]=e>>>16,u[f+11|0]=e>>>24,u[f+12|0]=r,u[f+13|0]=r>>>8,u[f+14|0]=r>>>16,u[f+15|0]=r>>>24,r=l[5932]|l[5933]<<8|(l[5934]<<16|l[5935]<<24),e=l[5928]|l[5929]<<8|(l[5930]<<16|l[5931]<<24),u[f|0]=e,u[f+1|0]=e>>>8,u[f+2|0]=e>>>16,u[f+3|0]=e>>>24,u[f+4|0]=r,u[f+5|0]=r>>>8,u[f+6|0]=r>>>16,u[f+7|0]=r>>>24,u[f+28|0]=0,f=q(o+40|0,2,0,o+28|0),e=i[f+4>>2],i[A>>2]=i[f>>2],i[A+4>>2]=e,r=A+8|0;f:{if(u[f+19|0]>=0){e=i[f+12>>2],i[r>>2]=i[f+8>>2],i[r+4>>2]=e,i[r+8>>2]=i[f+16>>2],u[A+20|0]=1;break f}if(T(r,i[f+8>>2],i[f+12>>2]),e=u[f+19|0],u[A+20|0]=1,(e|0)>=0)break f;Z(i[f+8>>2])}if(u[o+39|0]>=0)break i;Z(i[o+28>>2]);break i}for(;;){if(s=w,w=i[s+16>>2],w>>>0>B>>>0){if(h=s,w=i[s>>2],w)continue;break r}if(w>>>0>=B>>>0)break e;if(w=i[s+4>>2],!w)break}h=s+4|0}w=p(20),i[w+8>>2]=s,i[w>>2]=0,i[w+4>>2]=0,i[w+16>>2]=B,i[h>>2]=w,s=i[i[t>>2]>>2],s&&(i[t>>2]=s),m1(i[t+4>>2],w),i[t+8>>2]=i[t+8>>2]+1}s=i[e+100>>2],i[o+40>>2]=i[s+48>>2],s=i[s+52>>2],i[o+44>>2]=s,s&&(i[s+4>>2]=i[s+4>>2]+1),s=i[o+40>>2],w=i[s+84>>2],_=i[s+88>>2],_&&(i[_+4>>2]=i[_+4>>2]+1),h=i[o+44>>2];e:{if(!h||(s=i[h+4>>2],i[h+4>>2]=s-1,s))break e;W[i[i[h>>2]+8>>2]](h),y(h)}e:{if(!w){f=p(56),i[o+28>>2]=f,i[o+32>>2]=48,i[o+36>>2]=-2147483592,r=l[14316]|l[14317]<<8|(l[14318]<<16|l[14319]<<24),e=l[14312]|l[14313]<<8|(l[14314]<<16|l[14315]<<24),u[f+40|0]=e,u[f+41|0]=e>>>8,u[f+42|0]=e>>>16,u[f+43|0]=e>>>24,u[f+44|0]=r,u[f+45|0]=r>>>8,u[f+46|0]=r>>>16,u[f+47|0]=r>>>24,r=l[14308]|l[14309]<<8|(l[14310]<<16|l[14311]<<24),e=l[14304]|l[14305]<<8|(l[14306]<<16|l[14307]<<24),u[f+32|0]=e,u[f+33|0]=e>>>8,u[f+34|0]=e>>>16,u[f+35|0]=e>>>24,u[f+36|0]=r,u[f+37|0]=r>>>8,u[f+38|0]=r>>>16,u[f+39|0]=r>>>24,r=l[14300]|l[14301]<<8|(l[14302]<<16|l[14303]<<24),e=l[14296]|l[14297]<<8|(l[14298]<<16|l[14299]<<24),u[f+24|0]=e,u[f+25|0]=e>>>8,u[f+26|0]=e>>>16,u[f+27|0]=e>>>24,u[f+28|0]=r,u[f+29|0]=r>>>8,u[f+30|0]=r>>>16,u[f+31|0]=r>>>24,r=l[14292]|l[14293]<<8|(l[14294]<<16|l[14295]<<24),e=l[14288]|l[14289]<<8|(l[14290]<<16|l[14291]<<24),u[f+16|0]=e,u[f+17|0]=e>>>8,u[f+18|0]=e>>>16,u[f+19|0]=e>>>24,u[f+20|0]=r,u[f+21|0]=r>>>8,u[f+22|0]=r>>>16,u[f+23|0]=r>>>24,r=l[14284]|l[14285]<<8|(l[14286]<<16|l[14287]<<24),e=l[14280]|l[14281]<<8|(l[14282]<<16|l[14283]<<24),u[f+8|0]=e,u[f+9|0]=e>>>8,u[f+10|0]=e>>>16,u[f+11|0]=e>>>24,u[f+12|0]=r,u[f+13|0]=r>>>8,u[f+14|0]=r>>>16,u[f+15|0]=r>>>24,r=l[14276]|l[14277]<<8|(l[14278]<<16|l[14279]<<24),e=l[14272]|l[14273]<<8|(l[14274]<<16|l[14275]<<24),u[f|0]=e,u[f+1|0]=e>>>8,u[f+2|0]=e>>>16,u[f+3|0]=e>>>24,u[f+4|0]=r,u[f+5|0]=r>>>8,u[f+6|0]=r>>>16,u[f+7|0]=r>>>24,u[f+48|0]=0,f=q(o+40|0,2,113,o+28|0),e=i[f+4>>2],i[A>>2]=i[f>>2],i[A+4>>2]=e,r=A+8|0;r:{if(u[f+19|0]>=0){e=i[f+12>>2],i[r>>2]=i[f+8>>2],i[r+4>>2]=e,i[r+8>>2]=i[f+16>>2],u[A+20|0]=1;break r}if(T(r,i[f+8>>2],i[f+12>>2]),e=u[f+19|0],u[A+20|0]=1,(e|0)>=0)break r;Z(i[f+8>>2])}if(u[o+39|0]>=0)break e;Z(i[o+28>>2]);break e}P8(o+28|0,w,i[e+116>>2],1684630887),s=i[o+32>>2],w=i[o+28>>2];r:{if(s-w>>>0>=5){f=p(48),i[o+16>>2]=f,i[o+20>>2]=47,i[o+24>>2]=-2147483600,r=l[14875]|l[14876]<<8|(l[14877]<<16|l[14878]<<24),e=l[14871]|l[14872]<<8|(l[14873]<<16|l[14874]<<24),u[f+39|0]=e,u[f+40|0]=e>>>8,u[f+41|0]=e>>>16,u[f+42|0]=e>>>24,u[f+43|0]=r,u[f+44|0]=r>>>8,u[f+45|0]=r>>>16,u[f+46|0]=r>>>24,r=l[14868]|l[14869]<<8|(l[14870]<<16|l[14871]<<24),e=l[14864]|l[14865]<<8|(l[14866]<<16|l[14867]<<24),u[f+32|0]=e,u[f+33|0]=e>>>8,u[f+34|0]=e>>>16,u[f+35|0]=e>>>24,u[f+36|0]=r,u[f+37|0]=r>>>8,u[f+38|0]=r>>>16,u[f+39|0]=r>>>24,r=l[14860]|l[14861]<<8|(l[14862]<<16|l[14863]<<24),e=l[14856]|l[14857]<<8|(l[14858]<<16|l[14859]<<24),u[f+24|0]=e,u[f+25|0]=e>>>8,u[f+26|0]=e>>>16,u[f+27|0]=e>>>24,u[f+28|0]=r,u[f+29|0]=r>>>8,u[f+30|0]=r>>>16,u[f+31|0]=r>>>24,r=l[14852]|l[14853]<<8|(l[14854]<<16|l[14855]<<24),e=l[14848]|l[14849]<<8|(l[14850]<<16|l[14851]<<24),u[f+16|0]=e,u[f+17|0]=e>>>8,u[f+18|0]=e>>>16,u[f+19|0]=e>>>24,u[f+20|0]=r,u[f+21|0]=r>>>8,u[f+22|0]=r>>>16,u[f+23|0]=r>>>24,r=l[14844]|l[14845]<<8|(l[14846]<<16|l[14847]<<24),e=l[14840]|l[14841]<<8|(l[14842]<<16|l[14843]<<24),u[f+8|0]=e,u[f+9|0]=e>>>8,u[f+10|0]=e>>>16,u[f+11|0]=e>>>24,u[f+12|0]=r,u[f+13|0]=r>>>8,u[f+14|0]=r>>>16,u[f+15|0]=r>>>24,r=l[14836]|l[14837]<<8|(l[14838]<<16|l[14839]<<24),e=l[14832]|l[14833]<<8|(l[14834]<<16|l[14835]<<24),u[f|0]=e,u[f+1|0]=e>>>8,u[f+2|0]=e>>>16,u[f+3|0]=e>>>24,u[f+4|0]=r,u[f+5|0]=r>>>8,u[f+6|0]=r>>>16,u[f+7|0]=r>>>24,u[f+47|0]=0,f=q(o+40|0,2,0,o+16|0),e=i[f+4>>2],i[A>>2]=i[f>>2],i[A+4>>2]=e,r=A+8|0;f:{if(u[f+19|0]>=0){e=i[f+12>>2],i[r>>2]=i[f+8>>2],i[r+4>>2]=e,i[r+8>>2]=i[f+16>>2],u[A+20|0]=1;break f}if(T(r,i[f+8>>2],i[f+12>>2]),e=u[f+19|0],u[A+20|0]=1,(e|0)>=0)break f;Z(i[f+8>>2])}if(u[o+27|0]>=0)break r;Z(i[o+16>>2]);break r}if((s|0)==(w|0)){f=p(40),i[o+16>>2]=f,i[o+20>>2]=37,i[o+24>>2]=-2147483608,r=l[15440]|l[15441]<<8|(l[15442]<<16|l[15443]<<24),e=l[15436]|l[15437]<<8|(l[15438]<<16|l[15439]<<24),u[f+29|0]=e,u[f+30|0]=e>>>8,u[f+31|0]=e>>>16,u[f+32|0]=e>>>24,u[f+33|0]=r,u[f+34|0]=r>>>8,u[f+35|0]=r>>>16,u[f+36|0]=r>>>24,r=l[15435]|l[15436]<<8|(l[15437]<<16|l[15438]<<24),e=l[15431]|l[15432]<<8|(l[15433]<<16|l[15434]<<24),u[f+24|0]=e,u[f+25|0]=e>>>8,u[f+26|0]=e>>>16,u[f+27|0]=e>>>24,u[f+28|0]=r,u[f+29|0]=r>>>8,u[f+30|0]=r>>>16,u[f+31|0]=r>>>24,r=l[15427]|l[15428]<<8|(l[15429]<<16|l[15430]<<24),e=l[15423]|l[15424]<<8|(l[15425]<<16|l[15426]<<24),u[f+16|0]=e,u[f+17|0]=e>>>8,u[f+18|0]=e>>>16,u[f+19|0]=e>>>24,u[f+20|0]=r,u[f+21|0]=r>>>8,u[f+22|0]=r>>>16,u[f+23|0]=r>>>24,r=l[15419]|l[15420]<<8|(l[15421]<<16|l[15422]<<24),e=l[15415]|l[15416]<<8|(l[15417]<<16|l[15418]<<24),u[f+8|0]=e,u[f+9|0]=e>>>8,u[f+10|0]=e>>>16,u[f+11|0]=e>>>24,u[f+12|0]=r,u[f+13|0]=r>>>8,u[f+14|0]=r>>>16,u[f+15|0]=r>>>24,r=l[15411]|l[15412]<<8|(l[15413]<<16|l[15414]<<24),e=l[15407]|l[15408]<<8|(l[15409]<<16|l[15410]<<24),u[f|0]=e,u[f+1|0]=e>>>8,u[f+2|0]=e>>>16,u[f+3|0]=e>>>24,u[f+4|0]=r,u[f+5|0]=r>>>8,u[f+6|0]=r>>>16,u[f+7|0]=r>>>24,u[f+37|0]=0,f=q(o+40|0,2,0,o+16|0),e=i[f+4>>2],i[A>>2]=i[f>>2],i[A+4>>2]=e,r=A+8|0;f:{if(u[f+19|0]>=0){e=i[f+12>>2],i[r>>2]=i[f+8>>2],i[r+4>>2]=e,i[r+8>>2]=i[f+16>>2],u[A+20|0]=1;break f}if(T(r,i[f+8>>2],i[f+12>>2]),e=u[f+19|0],u[A+20|0]=1,(e|0)>=0)break f;Z(i[f+8>>2])}if(u[o+27|0]>=0)break r;Z(i[o+16>>2]);break r}if(w=i[w>>2],(w|0)==i[e+116>>2]){f=p(40),i[o+16>>2]=f,i[o+20>>2]=32,i[o+24>>2]=-2147483608,r=l[11337]|l[11338]<<8|(l[11339]<<16|l[11340]<<24),e=l[11333]|l[11334]<<8|(l[11335]<<16|l[11336]<<24),u[f+24|0]=e,u[f+25|0]=e>>>8,u[f+26|0]=e>>>16,u[f+27|0]=e>>>24,u[f+28|0]=r,u[f+29|0]=r>>>8,u[f+30|0]=r>>>16,u[f+31|0]=r>>>24,r=l[11329]|l[11330]<<8|(l[11331]<<16|l[11332]<<24),e=l[11325]|l[11326]<<8|(l[11327]<<16|l[11328]<<24),u[f+16|0]=e,u[f+17|0]=e>>>8,u[f+18|0]=e>>>16,u[f+19|0]=e>>>24,u[f+20|0]=r,u[f+21|0]=r>>>8,u[f+22|0]=r>>>16,u[f+23|0]=r>>>24,r=l[11321]|l[11322]<<8|(l[11323]<<16|l[11324]<<24),e=l[11317]|l[11318]<<8|(l[11319]<<16|l[11320]<<24),u[f+8|0]=e,u[f+9|0]=e>>>8,u[f+10|0]=e>>>16,u[f+11|0]=e>>>24,u[f+12|0]=r,u[f+13|0]=r>>>8,u[f+14|0]=r>>>16,u[f+15|0]=r>>>24,r=l[11313]|l[11314]<<8|(l[11315]<<16|l[11316]<<24),e=l[11309]|l[11310]<<8|(l[11311]<<16|l[11312]<<24),u[f|0]=e,u[f+1|0]=e>>>8,u[f+2|0]=e>>>16,u[f+3|0]=e>>>24,u[f+4|0]=r,u[f+5|0]=r>>>8,u[f+6|0]=r>>>16,u[f+7|0]=r>>>24,u[f+32|0]=0,f=q(o+40|0,2,0,o+16|0),e=i[f+4>>2],i[A>>2]=i[f>>2],i[A+4>>2]=e,r=A+8|0;f:{if(u[f+19|0]>=0){e=i[f+12>>2],i[r>>2]=i[f+8>>2],i[r+4>>2]=e,i[r+8>>2]=i[f+16>>2],u[A+20|0]=1;break f}if(T(r,i[f+8>>2],i[f+12>>2]),e=u[f+19|0],u[A+20|0]=1,(e|0)>=0)break f;Z(i[f+8>>2])}if(u[o+27|0]>=0)break r;Z(i[o+16>>2]);break r}s=o+40|0,r4(s,i[e+100>>2],w,1),h=i[o+44>>2],w=i[o+40>>2];f:{if(!w){r=d2(o+16|0,14790),k=q(s,2,0,r),e=i[k+4>>2],i[A>>2]=i[k>>2],i[A+4>>2]=e,f=A+8|0;A:{if(u[k+19|0]>=0){e=i[k+12>>2],i[f>>2]=i[k+8>>2],i[f+4>>2]=e,i[f+8>>2]=i[k+16>>2],u[A+20|0]=1;break A}if(T(f,i[k+8>>2],i[k+12>>2]),e=u[k+19|0],u[A+20|0]=1,(e|0)>=0)break A;Z(i[k+8>>2])}if(u[r+11|0]>=0)break f;Z(i[r>>2]);break f}if(W[i[i[w>>2]+52>>2]](o+40|0,w),i[o+40>>2]){if(e=i[o+44>>2],i[A>>2]=i[o+40>>2],i[A+4>>2]=e,r=A+8|0,u[o+59|0]>=0){e=i[o+52>>2],i[r>>2]=i[o+48>>2],i[r+4>>2]=e,i[r+8>>2]=i[o+56>>2],u[A+20|0]=1;break f}if(T(r,i[o+48>>2],i[o+52>>2]),e=u[o+59|0],u[A+20|0]=1,(e|0)>=0)break f;Z(i[o+48>>2]);break f}u[o+59|0]<0&&Z(i[o+48>>2]),i[o+8>>2]=0,i[o+12>>2]=0,i[o+4>>2]=o+8,e=o+4|0,t8(e,i[t>>2],m),W[i[i[w>>2]+100>>2]](A,w,r,f,k,n,e),Y1(e,i[o+8>>2])}if(!h||(A=i[h+4>>2],i[h+4>>2]=A-1,A))break r;W[i[i[h>>2]+8>>2]](h),y(h)}if(A=i[o+28>>2],!A)break e;i[o+32>>2]=A,Z(A)}if(!_||(A=i[_+4>>2],i[_+4>>2]=A-1,A))break i;W[i[i[_>>2]+8>>2]](_),y(_)}v=o- -64|0}function y2(A){A=A|0;var e=0,r=0,f=0,k=0,n=0,t=0,o=0,s=0,w=0,h=0,_=0,B=0,m=0;h=v-16|0,v=h;i:{e:{r:{f:{A:{k:{n:{t:{u:{o:{if(A>>>0<=244){if(k=i[31638],t=A>>>0<11?16:A+11&504,A=t>>>3|0,e=k>>>A|0,e&3){r=A+((e^-1)&1)|0,e=r<<3,A=e+126592|0,e=i[e+126600>>2],f=i[e+8>>2];l:{if((A|0)==(f|0)){B=126552,m=k2(-2,r)&k,i[B>>2]=m;break l}i[f+12>>2]=A,i[A+8>>2]=f}A=e+8|0,r=r<<3,i[e+4>>2]=r|3,e=e+r|0,i[e+4>>2]=i[e+4>>2]|1;break i}if(s=i[31640],s>>>0>=t>>>0)break o;if(e){r=2<<A,A=e8((0-r|r)&e<<A),r=A<<3,e=r+126592|0,r=i[r+126600>>2],f=i[r+8>>2];l:{if((e|0)==(f|0)){k=k2(-2,A)&k,i[31638]=k;break l}i[f+12>>2]=e,i[e+8>>2]=f}if(i[r+4>>2]=t|3,o=r+t|0,A=A<<3,n=A-t|0,i[o+4>>2]=n|1,i[A+r>>2]=n,s){A=(s&-8)+126592|0,f=i[31643],e=1<<(s>>>3);l:{if(!(e&k)){i[31638]=e|k,e=A;break l}e=i[A+8>>2]}i[A+8>>2]=f,i[e+12>>2]=f,i[f+12>>2]=A,i[f+8>>2]=e}A=r+8|0,i[31643]=o,i[31640]=n;break i}if(_=i[31639],!_)break o;for(r=i[(e8(_)<<2)+126856>>2],n=(i[r+4>>2]&-8)-t|0,e=r;;){l:{if(A=i[e+16>>2],!A&&(A=i[e+20>>2],!A))break l;f=(i[A+4>>2]&-8)-t|0,e=f>>>0<n>>>0,n=e?f:n,r=e?A:r,e=A;continue}break}if(w=i[r+24>>2],A=i[r+12>>2],(r|0)!=(A|0)){e=i[r+8>>2],i[e+12>>2]=A,i[A+8>>2]=e;break e}if(e=i[r+20>>2],e)f=r+20|0;else{if(e=i[r+16>>2],!e)break u;f=r+16|0}for(;o=f,A=e,f=A+20|0,e=i[A+20>>2],!(!e&&(f=A+16|0,e=i[A+16>>2],!e)););i[o>>2]=0;break e}if(t=-1,A>>>0>4294967231||(e=A+11|0,t=e&-8,o=i[31639],!o))break o;s=31,n=0-t|0,A>>>0<=16777204&&(A=k1(e>>>8|0),s=((t>>>38-A&1)-(A<<1)|0)+62|0),e=i[(s<<2)+126856>>2];l:{s:{w:{if(!e){A=0;break w}for(A=0,r=t<<((s|0)!=31?25-(s>>>1|0)|0:0);;){_:{if(k=(i[e+4>>2]&-8)-t|0,k>>>0>=n>>>0||(f=e,n=k,n))break _;n=0,A=e;break s}if(k=i[e+20>>2],e=i[((r>>>29&4)+e|0)+16>>2],A=k?(k|0)==(e|0)?A:k:A,r=r<<1,!e)break}}if(!(A|f)){if(f=0,A=2<<s,A=(0-A|A)&o,!A)break o;A=i[(e8(A)<<2)+126856>>2]}if(!A)break l}for(;r=(i[A+4>>2]&-8)-t|0,e=r>>>0<n>>>0,n=e?r:n,f=e?A:f,e=i[A+16>>2],e?A=e:A=i[A+20>>2],!!A;);}if(!f|i[31640]-t>>>0<=n>>>0)break o;if(s=i[f+24>>2],A=i[f+12>>2],(f|0)!=(A|0)){e=i[f+8>>2],i[e+12>>2]=A,i[A+8>>2]=e;break r}if(e=i[f+20>>2],e)r=f+20|0;else{if(e=i[f+16>>2],!e)break t;r=f+16|0}for(;k=r,A=e,r=A+20|0,e=i[A+20>>2],!(!e&&(r=A+16|0,e=i[A+16>>2],!e)););i[k>>2]=0;break r}if(f=i[31640],f>>>0>=t>>>0){A=i[31643],e=f-t|0;o:{if(e>>>0>=16){r=A+t|0,i[r+4>>2]=e|1,i[A+f>>2]=e,i[A+4>>2]=t|3;break o}i[A+4>>2]=f|3,e=A+f|0,i[e+4>>2]=i[e+4>>2]|1,r=0,e=0}i[31640]=e,i[31643]=r,A=A+8|0;break i}if(r=i[31641],r>>>0>t>>>0){e=r-t|0,i[31641]=e,A=i[31644],r=A+t|0,i[31644]=r,i[r+4>>2]=e|1,i[A+4>>2]=t|3,A=A+8|0;break i}if(A=0,n=t+47|0,i[31756]?e=i[31758]:(i[31759]=-1,i[31760]=-1,i[31757]=4096,i[31758]=4096,i[31756]=h+12&-16^1431655768,i[31761]=0,i[31749]=0,e=4096),k=n+e|0,o=0-e|0,e=k&o,e>>>0<=t>>>0||(s=i[31748],s&&(w=i[31746],f=w+e|0,f>>>0<=w>>>0|f>>>0>s>>>0)))break i;o:{if(!(l[126996]&4)){l:{s:{w:{_:{if(f=i[31644],f)for(A=127e3;;){if(s=i[A>>2],s>>>0<=f>>>0&f>>>0<s+i[A+4>>2]>>>0)break _;if(A=i[A+8>>2],!A)break}if(r=Wi(0),(r|0)==-1||(k=e,A=i[31757],f=A-1|0,f&r&&(k=(e-r|0)+(r+f&0-A)|0),k>>>0<=t>>>0)||(f=i[31748],f&&(o=i[31746],A=o+k|0,A>>>0<=o>>>0|A>>>0>f>>>0)))break l;if(A=Wi(k),(r|0)!=(A|0))break w;break o}if(k=o&k-r,r=Wi(k),(r|0)==(i[A>>2]+i[A+4>>2]|0))break s;A=r}if((A|0)==-1)break l;if(t+48>>>0<=k>>>0){r=A;break o}if(r=i[31758],r=r+(n-k|0)&0-r,(Wi(r)|0)==-1)break l;k=r+k|0,r=A;break o}if((r|0)!=-1)break o}i[31749]=i[31749]|4}if(r=Wi(e),A=Wi(0),(r|0)==-1|(A|0)==-1|A>>>0<=r>>>0||(k=A-r|0,k>>>0<=t+40>>>0))break A}A=i[31746]+k|0,i[31746]=A,A>>>0>u0[31747]&&(i[31747]=A);o:{if(n=i[31644],n){for(A=127e3;;){if(e=i[A>>2],f=i[A+4>>2],(e+f|0)==(r|0))break o;if(A=i[A+8>>2],!A)break}break n}for(A=i[31642],A>>>0<=r>>>0&&A||(i[31642]=r),A=0,i[31751]=k,i[31750]=r,i[31646]=-1,i[31647]=i[31756],i[31753]=0;e=A<<3,f=e+126592|0,i[e+126600>>2]=f,i[e+126604>>2]=f,A=A+1|0,(A|0)!=32;);A=k-40|0,e=-8-r&7,f=A-e|0,i[31641]=f,e=e+r|0,i[31644]=e,i[e+4>>2]=f|1,i[(A+r|0)+4>>2]=40,i[31645]=i[31760];break k}if(i[A+12>>2]&8|(r>>>0<=n>>>0|e>>>0>n>>>0))break n;i[A+4>>2]=f+k,A=-8-n&7,e=A+n|0,i[31644]=e,r=i[31641]+k|0,A=r-A|0,i[31641]=A,i[e+4>>2]=A|1,i[(r+n|0)+4>>2]=40,i[31645]=i[31760];break k}A=0;break e}A=0;break r}u0[31642]>r>>>0&&(i[31642]=r),f=r+k|0,A=127e3;n:{for(;;){if(e=i[A>>2],(e|0)!=(f|0)){if(A=i[A+8>>2],A)continue;break n}break}if(!(l[A+12|0]&8))break f}for(A=127e3;;){n:{if(e=i[A>>2],e>>>0<=n>>>0&&(f=e+i[A+4>>2]|0,f>>>0>n>>>0))break n;A=i[A+8>>2];continue}break}for(A=k-40|0,e=-8-r&7,o=A-e|0,i[31641]=o,e=e+r|0,i[31644]=e,i[e+4>>2]=o|1,i[(A+r|0)+4>>2]=40,i[31645]=i[31760],A=(f+(39-f&7)|0)-47|0,e=A>>>0<n+16>>>0?n:A,i[e+4>>2]=27,A=i[31753],i[e+16>>2]=i[31752],i[e+20>>2]=A,A=i[31751],i[e+8>>2]=i[31750],i[e+12>>2]=A,i[31752]=e+8,i[31751]=k,i[31750]=r,i[31753]=0,A=e+24|0;i[A+4>>2]=7,r=A+8|0,A=A+4|0,r>>>0<f>>>0;);if((e|0)==(n|0))break k;i[e+4>>2]=i[e+4>>2]&-2,r=e-n|0,i[n+4>>2]=r|1,i[e>>2]=r;n:{if(r>>>0<=255){A=(r&-8)+126592|0,e=i[31638],r=1<<(r>>>3);t:{if(!(e&r)){i[31638]=e|r,e=A;break t}e=i[A+8>>2]}i[A+8>>2]=n,i[e+12>>2]=n,f=8,r=12;break n}A=31,r>>>0<=16777215&&(A=k1(r>>>8|0),A=((r>>>38-A&1)-(A<<1)|0)+62|0),i[n+28>>2]=A,i[n+16>>2]=0,i[n+20>>2]=0,e=(A<<2)+126856|0;t:{f=i[31639],k=1<<A;u:{if(!(f&k)){i[31639]=f|k,i[e>>2]=n;break u}for(A=r<<((A|0)!=31?25-(A>>>1|0)|0:0),f=i[e>>2];;){if(e=f,(r|0)==(i[e+4>>2]&-8))break t;if(f=A>>>29|0,A=A<<1,k=(f&4)+e|0,f=i[k+16>>2],!f)break}i[k+16>>2]=n}i[n+24>>2]=e,e=n,A=e,f=12,r=8;break n}A=i[e+8>>2],i[A+12>>2]=n,i[e+8>>2]=n,i[n+8>>2]=A,A=0,f=12,r=24}i[f+n>>2]=e,i[r+n>>2]=A}if(A=i[31641],A>>>0<=t>>>0)break A;e=A-t|0,i[31641]=e,A=i[31644],r=A+t|0,i[31644]=r,i[r+4>>2]=e|1,i[A+4>>2]=t|3,A=A+8|0;break i}i[31324]=48,A=0;break i}i[A>>2]=r,i[A+4>>2]=i[A+4>>2]+k,s=(-8-r&7)+r|0,i[s+4>>2]=t|3,k=e+(-8-e&7)|0,n=t+s|0,o=k-n|0;f:{if(i[31644]==(k|0)){i[31644]=n,A=i[31641]+o|0,i[31641]=A,i[n+4>>2]=A|1;break f}if(i[31643]==(k|0)){i[31643]=n,A=i[31640]+o|0,i[31640]=A,i[n+4>>2]=A|1,i[A+n>>2]=A;break f}if(A=i[k+4>>2],(A&3)==1){w=A&-8,r=i[k+12>>2];A:{if(A>>>0<=255){if(e=i[k+8>>2],(e|0)==(r|0)){B=126552,m=i[31638]&k2(-2,A>>>3|0),i[B>>2]=m;break A}i[e+12>>2]=r,i[r+8>>2]=e;break A}t=i[k+24>>2];k:{if((r|0)!=(k|0)){A=i[k+8>>2],i[A+12>>2]=r,i[r+8>>2]=A;break k}n:{if(A=i[k+20>>2],A)e=k+20|0;else{if(A=i[k+16>>2],!A)break n;e=k+16|0}for(;f=e,r=A,e=A+20|0,A=i[A+20>>2],!(!A&&(e=r+16|0,A=i[r+16>>2],!A)););i[f>>2]=0;break k}r=0}if(!t)break A;A=i[k+28>>2],e=(A<<2)+126856|0;k:{if(i[e>>2]==(k|0)){if(i[e>>2]=r,r)break k;B=126556,m=i[31639]&k2(-2,A),i[B>>2]=m;break A}n:{if(i[t+16>>2]==(k|0)){i[t+16>>2]=r;break n}i[t+20>>2]=r}if(!r)break A}if(i[r+24>>2]=t,A=i[k+16>>2],A&&(i[r+16>>2]=A,i[A+24>>2]=r),A=i[k+20>>2],!A)break A;i[r+20>>2]=A,i[A+24>>2]=r}o=o+w|0,k=k+w|0,A=i[k+4>>2]}if(i[k+4>>2]=A&-2,i[n+4>>2]=o|1,i[n+o>>2]=o,o>>>0<=255){A=(o&-8)+126592|0,e=i[31638],r=1<<(o>>>3);A:{if(!(e&r)){i[31638]=e|r,e=A;break A}e=i[A+8>>2]}i[A+8>>2]=n,i[e+12>>2]=n,i[n+12>>2]=A,i[n+8>>2]=e;break f}r=31,o>>>0<=16777215&&(A=k1(o>>>8|0),r=((o>>>38-A&1)-(A<<1)|0)+62|0),i[n+28>>2]=r,i[n+16>>2]=0,i[n+20>>2]=0,A=(r<<2)+126856|0;A:{e=i[31639],f=1<<r;k:{if(!(e&f)){i[31639]=e|f,i[A>>2]=n;break k}for(r=o<<((r|0)!=31?25-(r>>>1|0)|0:0),e=i[A>>2];;){if(A=e,(i[A+4>>2]&-8)==(o|0))break A;if(e=r>>>29|0,r=r<<1,f=(e&4)+A|0,e=i[f+16>>2],!e)break}i[f+16>>2]=n}i[n+24>>2]=A,i[n+12>>2]=n,i[n+8>>2]=n;break f}e=i[A+8>>2],i[e+12>>2]=n,i[A+8>>2]=n,i[n+24>>2]=0,i[n+12>>2]=A,i[n+8>>2]=e}A=s+8|0;break i}r:{if(!s)break r;e=i[f+28>>2],r=(e<<2)+126856|0;f:{if(i[r>>2]==(f|0)){if(i[r>>2]=A,A)break f;o=k2(-2,e)&o,i[31639]=o;break r}A:{if(i[s+16>>2]==(f|0)){i[s+16>>2]=A;break A}i[s+20>>2]=A}if(!A)break r}if(i[A+24>>2]=s,e=i[f+16>>2],e&&(i[A+16>>2]=e,i[e+24>>2]=A),e=i[f+20>>2],!e)break r;i[A+20>>2]=e,i[e+24>>2]=A}r:{if(n>>>0<=15){A=n+t|0,i[f+4>>2]=A|3,A=A+f|0,i[A+4>>2]=i[A+4>>2]|1;break r}if(i[f+4>>2]=t|3,k=f+t|0,i[k+4>>2]=n|1,i[n+k>>2]=n,n>>>0<=255){A=(n&-8)+126592|0,e=i[31638],r=1<<(n>>>3);f:{if(!(e&r)){i[31638]=e|r,e=A;break f}e=i[A+8>>2]}i[A+8>>2]=k,i[e+12>>2]=k,i[k+12>>2]=A,i[k+8>>2]=e;break r}A=31,n>>>0<=16777215&&(A=k1(n>>>8|0),A=((n>>>38-A&1)-(A<<1)|0)+62|0),i[k+28>>2]=A,i[k+16>>2]=0,i[k+20>>2]=0,e=(A<<2)+126856|0;f:{r=1<<A;A:{if(!(r&o)){i[31639]=r|o,i[e>>2]=k,i[k+24>>2]=e;break A}for(A=n<<((A|0)!=31?25-(A>>>1|0)|0:0),e=i[e>>2];;){if(r=e,(i[e+4>>2]&-8)==(n|0))break f;if(o=A>>>29|0,A=A<<1,o=e+(o&4)|0,e=i[o+16>>2],!e)break}i[o+16>>2]=k,i[k+24>>2]=r}i[k+12>>2]=k,i[k+8>>2]=k;break r}A=i[r+8>>2],i[A+12>>2]=k,i[r+8>>2]=k,i[k+24>>2]=0,i[k+12>>2]=r,i[k+8>>2]=A}A=f+8|0;break i}e:{if(!w)break e;e=i[r+28>>2],f=(e<<2)+126856|0;r:{if(i[f>>2]==(r|0)){if(i[f>>2]=A,A)break r;B=126556,m=k2(-2,e)&_,i[B>>2]=m;break e}f:{if(i[w+16>>2]==(r|0)){i[w+16>>2]=A;break f}i[w+20>>2]=A}if(!A)break e}if(i[A+24>>2]=w,e=i[r+16>>2],e&&(i[A+16>>2]=e,i[e+24>>2]=A),e=i[r+20>>2],!e)break e;i[A+20>>2]=e,i[e+24>>2]=A}e:{if(n>>>0<=15){A=n+t|0,i[r+4>>2]=A|3,A=A+r|0,i[A+4>>2]=i[A+4>>2]|1;break e}if(i[r+4>>2]=t|3,o=r+t|0,i[o+4>>2]=n|1,i[n+o>>2]=n,s){A=(s&-8)+126592|0,f=i[31643],e=1<<(s>>>3);r:{if(!(e&k)){i[31638]=e|k,e=A;break r}e=i[A+8>>2]}i[A+8>>2]=f,i[e+12>>2]=f,i[f+12>>2]=A,i[f+8>>2]=e}i[31643]=o,i[31640]=n}A=r+8|0}return v=h+16|0,A|0}function a_(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,t=0,o=0;k=v-32|0,v=k,o=W[i[i[e>>2]+52>>2]](e,r,0)|0,l2(r,l[e+100|0]),l2(r,l[e+101|0]),l2(r,l[e+102|0]),l2(r,l[e+103|0]),l2(r,(l[e+104|0]-1|252)&255),f=(i[e+120>>2]-i[e+116>>2]|0)/12|0;i:{if(f>>>0>=32){if(e=p(48),i[k+20>>2]=e,i[k+24>>2]=44,i[k+28>>2]=-2147483600,r=l[22725]|l[22726]<<8|(l[22727]<<16|l[22728]<<24),f=l[22721]|l[22722]<<8|(l[22723]<<16|l[22724]<<24),u[e|0]=f,u[e+1|0]=f>>>8,u[e+2|0]=f>>>16,u[e+3|0]=f>>>24,u[e+4|0]=r,u[e+5|0]=r>>>8,u[e+6|0]=r>>>16,u[e+7|0]=r>>>24,u[e+44|0]=0,r=l[22761]|l[22762]<<8|(l[22763]<<16|l[22764]<<24),u[e+40|0]=r,u[e+41|0]=r>>>8,u[e+42|0]=r>>>16,u[e+43|0]=r>>>24,r=l[22757]|l[22758]<<8|(l[22759]<<16|l[22760]<<24),f=l[22753]|l[22754]<<8|(l[22755]<<16|l[22756]<<24),u[e+32|0]=f,u[e+33|0]=f>>>8,u[e+34|0]=f>>>16,u[e+35|0]=f>>>24,u[e+36|0]=r,u[e+37|0]=r>>>8,u[e+38|0]=r>>>16,u[e+39|0]=r>>>24,r=l[22749]|l[22750]<<8|(l[22751]<<16|l[22752]<<24),f=l[22745]|l[22746]<<8|(l[22747]<<16|l[22748]<<24),u[e+24|0]=f,u[e+25|0]=f>>>8,u[e+26|0]=f>>>16,u[e+27|0]=f>>>24,u[e+28|0]=r,u[e+29|0]=r>>>8,u[e+30|0]=r>>>16,u[e+31|0]=r>>>24,r=l[22741]|l[22742]<<8|(l[22743]<<16|l[22744]<<24),f=l[22737]|l[22738]<<8|(l[22739]<<16|l[22740]<<24),u[e+16|0]=f,u[e+17|0]=f>>>8,u[e+18|0]=f>>>16,u[e+19|0]=f>>>24,u[e+20|0]=r,u[e+21|0]=r>>>8,u[e+22|0]=r>>>16,u[e+23|0]=r>>>24,r=l[22733]|l[22734]<<8|(l[22735]<<16|l[22736]<<24),f=l[22729]|l[22730]<<8|(l[22731]<<16|l[22732]<<24),u[e+8|0]=f,u[e+9|0]=f>>>8,u[e+10|0]=f>>>16,u[e+11|0]=f>>>24,u[e+12|0]=r,u[e+13|0]=r>>>8,u[e+14|0]=r>>>16,u[e+15|0]=r>>>24,q(A,9,0,k+20|0),u[k+31|0]>=0)break i;Z(i[k+20>>2]);break i}if(l2(r,(f|224)&255),f=i[e+116>>2],n=i[e+120>>2],(f|0)!=(n|0))for(;;){if(t=i[f+4>>2]-i[f>>2]|0,t>>>0>=65536){if(e=p(56),i[k+20>>2]=e,i[k+24>>2]=55,i[k+28>>2]=-2147483592,r=l[22567]|l[22568]<<8|(l[22569]<<16|l[22570]<<24),f=l[22563]|l[22564]<<8|(l[22565]<<16|l[22566]<<24),u[e|0]=f,u[e+1|0]=f>>>8,u[e+2|0]=f>>>16,u[e+3|0]=f>>>24,u[e+4|0]=r,u[e+5|0]=r>>>8,u[e+6|0]=r>>>16,u[e+7|0]=r>>>24,u[e+55|0]=0,r=l[22614]|l[22615]<<8|(l[22616]<<16|l[22617]<<24),f=l[22610]|l[22611]<<8|(l[22612]<<16|l[22613]<<24),u[e+47|0]=f,u[e+48|0]=f>>>8,u[e+49|0]=f>>>16,u[e+50|0]=f>>>24,u[e+51|0]=r,u[e+52|0]=r>>>8,u[e+53|0]=r>>>16,u[e+54|0]=r>>>24,r=l[22607]|l[22608]<<8|(l[22609]<<16|l[22610]<<24),f=l[22603]|l[22604]<<8|(l[22605]<<16|l[22606]<<24),u[e+40|0]=f,u[e+41|0]=f>>>8,u[e+42|0]=f>>>16,u[e+43|0]=f>>>24,u[e+44|0]=r,u[e+45|0]=r>>>8,u[e+46|0]=r>>>16,u[e+47|0]=r>>>24,r=l[22599]|l[22600]<<8|(l[22601]<<16|l[22602]<<24),f=l[22595]|l[22596]<<8|(l[22597]<<16|l[22598]<<24),u[e+32|0]=f,u[e+33|0]=f>>>8,u[e+34|0]=f>>>16,u[e+35|0]=f>>>24,u[e+36|0]=r,u[e+37|0]=r>>>8,u[e+38|0]=r>>>16,u[e+39|0]=r>>>24,r=l[22591]|l[22592]<<8|(l[22593]<<16|l[22594]<<24),f=l[22587]|l[22588]<<8|(l[22589]<<16|l[22590]<<24),u[e+24|0]=f,u[e+25|0]=f>>>8,u[e+26|0]=f>>>16,u[e+27|0]=f>>>24,u[e+28|0]=r,u[e+29|0]=r>>>8,u[e+30|0]=r>>>16,u[e+31|0]=r>>>24,r=l[22583]|l[22584]<<8|(l[22585]<<16|l[22586]<<24),f=l[22579]|l[22580]<<8|(l[22581]<<16|l[22582]<<24),u[e+16|0]=f,u[e+17|0]=f>>>8,u[e+18|0]=f>>>16,u[e+19|0]=f>>>24,u[e+20|0]=r,u[e+21|0]=r>>>8,u[e+22|0]=r>>>16,u[e+23|0]=r>>>24,r=l[22575]|l[22576]<<8|(l[22577]<<16|l[22578]<<24),f=l[22571]|l[22572]<<8|(l[22573]<<16|l[22574]<<24),u[e+8|0]=f,u[e+9|0]=f>>>8,u[e+10|0]=f>>>16,u[e+11|0]=f>>>24,u[e+12|0]=r,u[e+13|0]=r>>>8,u[e+14|0]=r>>>16,u[e+15|0]=r>>>24,q(A,9,0,k+20|0),u[k+31|0]>=0)break i;Z(i[k+20>>2]);break i}if(u2(r,t),I4(r,f),f=f+12|0,(n|0)==(f|0))break}if(f=(i[e+132>>2]-i[e+128>>2]|0)/12|0,f>>>0>=256){if(e=p(48),i[k+20>>2]=e,i[k+24>>2]=45,i[k+28>>2]=-2147483600,r=l[22679]|l[22680]<<8|(l[22681]<<16|l[22682]<<24),f=l[22675]|l[22676]<<8|(l[22677]<<16|l[22678]<<24),u[e|0]=f,u[e+1|0]=f>>>8,u[e+2|0]=f>>>16,u[e+3|0]=f>>>24,u[e+4|0]=r,u[e+5|0]=r>>>8,u[e+6|0]=r>>>16,u[e+7|0]=r>>>24,u[e+45|0]=0,r=l[22716]|l[22717]<<8|(l[22718]<<16|l[22719]<<24),f=l[22712]|l[22713]<<8|(l[22714]<<16|l[22715]<<24),u[e+37|0]=f,u[e+38|0]=f>>>8,u[e+39|0]=f>>>16,u[e+40|0]=f>>>24,u[e+41|0]=r,u[e+42|0]=r>>>8,u[e+43|0]=r>>>16,u[e+44|0]=r>>>24,r=l[22711]|l[22712]<<8|(l[22713]<<16|l[22714]<<24),f=l[22707]|l[22708]<<8|(l[22709]<<16|l[22710]<<24),u[e+32|0]=f,u[e+33|0]=f>>>8,u[e+34|0]=f>>>16,u[e+35|0]=f>>>24,u[e+36|0]=r,u[e+37|0]=r>>>8,u[e+38|0]=r>>>16,u[e+39|0]=r>>>24,r=l[22703]|l[22704]<<8|(l[22705]<<16|l[22706]<<24),f=l[22699]|l[22700]<<8|(l[22701]<<16|l[22702]<<24),u[e+24|0]=f,u[e+25|0]=f>>>8,u[e+26|0]=f>>>16,u[e+27|0]=f>>>24,u[e+28|0]=r,u[e+29|0]=r>>>8,u[e+30|0]=r>>>16,u[e+31|0]=r>>>24,r=l[22695]|l[22696]<<8|(l[22697]<<16|l[22698]<<24),f=l[22691]|l[22692]<<8|(l[22693]<<16|l[22694]<<24),u[e+16|0]=f,u[e+17|0]=f>>>8,u[e+18|0]=f>>>16,u[e+19|0]=f>>>24,u[e+20|0]=r,u[e+21|0]=r>>>8,u[e+22|0]=r>>>16,u[e+23|0]=r>>>24,r=l[22687]|l[22688]<<8|(l[22689]<<16|l[22690]<<24),f=l[22683]|l[22684]<<8|(l[22685]<<16|l[22686]<<24),u[e+8|0]=f,u[e+9|0]=f>>>8,u[e+10|0]=f>>>16,u[e+11|0]=f>>>24,u[e+12|0]=r,u[e+13|0]=r>>>8,u[e+14|0]=r>>>16,u[e+15|0]=r>>>24,q(A,9,0,k+20|0),u[k+31|0]>=0)break i;Z(i[k+20>>2]);break i}if(l2(r,f),f=i[e+128>>2],n=i[e+132>>2],(f|0)!=(n|0))for(;;){if(t=i[f+4>>2]-i[f>>2]|0,t>>>0>=65536){if(e=p(56),i[k+20>>2]=e,i[k+24>>2]=55,i[k+28>>2]=-2147483592,r=l[22623]|l[22624]<<8|(l[22625]<<16|l[22626]<<24),f=l[22619]|l[22620]<<8|(l[22621]<<16|l[22622]<<24),u[e|0]=f,u[e+1|0]=f>>>8,u[e+2|0]=f>>>16,u[e+3|0]=f>>>24,u[e+4|0]=r,u[e+5|0]=r>>>8,u[e+6|0]=r>>>16,u[e+7|0]=r>>>24,u[e+55|0]=0,r=l[22670]|l[22671]<<8|(l[22672]<<16|l[22673]<<24),f=l[22666]|l[22667]<<8|(l[22668]<<16|l[22669]<<24),u[e+47|0]=f,u[e+48|0]=f>>>8,u[e+49|0]=f>>>16,u[e+50|0]=f>>>24,u[e+51|0]=r,u[e+52|0]=r>>>8,u[e+53|0]=r>>>16,u[e+54|0]=r>>>24,r=l[22663]|l[22664]<<8|(l[22665]<<16|l[22666]<<24),f=l[22659]|l[22660]<<8|(l[22661]<<16|l[22662]<<24),u[e+40|0]=f,u[e+41|0]=f>>>8,u[e+42|0]=f>>>16,u[e+43|0]=f>>>24,u[e+44|0]=r,u[e+45|0]=r>>>8,u[e+46|0]=r>>>16,u[e+47|0]=r>>>24,r=l[22655]|l[22656]<<8|(l[22657]<<16|l[22658]<<24),f=l[22651]|l[22652]<<8|(l[22653]<<16|l[22654]<<24),u[e+32|0]=f,u[e+33|0]=f>>>8,u[e+34|0]=f>>>16,u[e+35|0]=f>>>24,u[e+36|0]=r,u[e+37|0]=r>>>8,u[e+38|0]=r>>>16,u[e+39|0]=r>>>24,r=l[22647]|l[22648]<<8|(l[22649]<<16|l[22650]<<24),f=l[22643]|l[22644]<<8|(l[22645]<<16|l[22646]<<24),u[e+24|0]=f,u[e+25|0]=f>>>8,u[e+26|0]=f>>>16,u[e+27|0]=f>>>24,u[e+28|0]=r,u[e+29|0]=r>>>8,u[e+30|0]=r>>>16,u[e+31|0]=r>>>24,r=l[22639]|l[22640]<<8|(l[22641]<<16|l[22642]<<24),f=l[22635]|l[22636]<<8|(l[22637]<<16|l[22638]<<24),u[e+16|0]=f,u[e+17|0]=f>>>8,u[e+18|0]=f>>>16,u[e+19|0]=f>>>24,u[e+20|0]=r,u[e+21|0]=r>>>8,u[e+22|0]=r>>>16,u[e+23|0]=r>>>24,r=l[22631]|l[22632]<<8|(l[22633]<<16|l[22634]<<24),f=l[22627]|l[22628]<<8|(l[22629]<<16|l[22630]<<24),u[e+8|0]=f,u[e+9|0]=f>>>8,u[e+10|0]=f>>>16,u[e+11|0]=f>>>24,u[e+12|0]=r,u[e+13|0]=r>>>8,u[e+14|0]=r>>>16,u[e+15|0]=r>>>24,q(A,9,0,k+20|0),u[k+31|0]>=0)break i;Z(i[k+20>>2]);break i}if(u2(r,t),I4(r,f),f=f+12|0,(n|0)==(f|0))break}f=l[e+101|0]-66|0;e:{if(1<<f&4196353&&f>>>0<=22)break e;if(l2(r,l[e+108|0]),l2(r,l[e+112|0]-8&255),l2(r,l[e+113|0]-8&255),f=(i[e+144>>2]-i[e+140>>2]|0)/12|0,f>>>0>=256){if(e=A,A=d2(k+20|0,22453),q(e,9,0,A),u[A+11|0]>=0)break i;Z(i[A>>2]);break i}if(l2(r,f),f=i[e+140>>2],n=i[e+144>>2],(f|0)==(n|0))break e;for(;;){if(t=i[f+4>>2]-i[f>>2]|0,t>>>0>=65536){if(e=p(64),i[k+20>>2]=e,i[k+24>>2]=59,i[k+28>>2]=-2147483584,r=l[22507]|l[22508]<<8|(l[22509]<<16|l[22510]<<24),f=l[22503]|l[22504]<<8|(l[22505]<<16|l[22506]<<24),u[e|0]=f,u[e+1|0]=f>>>8,u[e+2|0]=f>>>16,u[e+3|0]=f>>>24,u[e+4|0]=r,u[e+5|0]=r>>>8,u[e+6|0]=r>>>16,u[e+7|0]=r>>>24,u[e+59|0]=0,r=l[22558]|l[22559]<<8|(l[22560]<<16|l[22561]<<24),u[e+55|0]=r,u[e+56|0]=r>>>8,u[e+57|0]=r>>>16,u[e+58|0]=r>>>24,r=l[22555]|l[22556]<<8|(l[22557]<<16|l[22558]<<24),f=l[22551]|l[22552]<<8|(l[22553]<<16|l[22554]<<24),u[e+48|0]=f,u[e+49|0]=f>>>8,u[e+50|0]=f>>>16,u[e+51|0]=f>>>24,u[e+52|0]=r,u[e+53|0]=r>>>8,u[e+54|0]=r>>>16,u[e+55|0]=r>>>24,r=l[22547]|l[22548]<<8|(l[22549]<<16|l[22550]<<24),f=l[22543]|l[22544]<<8|(l[22545]<<16|l[22546]<<24),u[e+40|0]=f,u[e+41|0]=f>>>8,u[e+42|0]=f>>>16,u[e+43|0]=f>>>24,u[e+44|0]=r,u[e+45|0]=r>>>8,u[e+46|0]=r>>>16,u[e+47|0]=r>>>24,r=l[22539]|l[22540]<<8|(l[22541]<<16|l[22542]<<24),f=l[22535]|l[22536]<<8|(l[22537]<<16|l[22538]<<24),u[e+32|0]=f,u[e+33|0]=f>>>8,u[e+34|0]=f>>>16,u[e+35|0]=f>>>24,u[e+36|0]=r,u[e+37|0]=r>>>8,u[e+38|0]=r>>>16,u[e+39|0]=r>>>24,r=l[22531]|l[22532]<<8|(l[22533]<<16|l[22534]<<24),f=l[22527]|l[22528]<<8|(l[22529]<<16|l[22530]<<24),u[e+24|0]=f,u[e+25|0]=f>>>8,u[e+26|0]=f>>>16,u[e+27|0]=f>>>24,u[e+28|0]=r,u[e+29|0]=r>>>8,u[e+30|0]=r>>>16,u[e+31|0]=r>>>24,r=l[22523]|l[22524]<<8|(l[22525]<<16|l[22526]<<24),f=l[22519]|l[22520]<<8|(l[22521]<<16|l[22522]<<24),u[e+16|0]=f,u[e+17|0]=f>>>8,u[e+18|0]=f>>>16,u[e+19|0]=f>>>24,u[e+20|0]=r,u[e+21|0]=r>>>8,u[e+22|0]=r>>>16,u[e+23|0]=r>>>24,r=l[22515]|l[22516]<<8|(l[22517]<<16|l[22518]<<24),f=l[22511]|l[22512]<<8|(l[22513]<<16|l[22514]<<24),u[e+8|0]=f,u[e+9|0]=f>>>8,u[e+10|0]=f>>>16,u[e+11|0]=f>>>24,u[e+12|0]=r,u[e+13|0]=r>>>8,u[e+14|0]=r>>>16,u[e+15|0]=r>>>24,q(A,9,0,k+20|0),u[k+31|0]>=0)break i;Z(i[k+20>>2]);break i}if(u2(r,t),I4(r,f),f=f+12|0,(n|0)==(f|0))break}}if(f1(k,e,r,o),u[k+19|0]<0&&Z(i[k+8>>2]),e=i[26917],i[A>>2]=i[26916],i[A+4>>2]=e,A=A+8|0,u[107683]>=0){e=i[26919],i[A>>2]=i[26918],i[A+4>>2]=e,i[A+8>>2]=i[26920];break i}T(A,i[26918],i[26919])}v=k+32|0}function $_(A,e){A=A|0,e=e|0;var r=0,f=0,k=0,n=0,t=0,o=0,s=0,w=0,h=0,_=0,B=0,m=0,X=0,Q=0,V=0,F=0,I=0,E=0,R=0,N=0,M=0,z=0,S=0,O=0,P=0,a=0;I=v-32|0,v=I,s=v+-64|0,v=s,k=i[e+100>>2],r=i[k+48>>2],Q=i[k+52>>2],Q&&(i[Q+4>>2]=i[Q+4>>2]+1),k=i[r+84>>2],V=i[r+88>>2],V&&(i[V+4>>2]=i[V+4>>2]+1),m=I+8|0;i:{if(!k){if(e=p(56),i[s+40>>2]=e,i[s+44>>2]=48,i[s+48>>2]=-2147483592,r=l[14369]|l[14370]<<8|(l[14371]<<16|l[14372]<<24),k=l[14365]|l[14366]<<8|(l[14367]<<16|l[14368]<<24),u[e|0]=k,u[e+1|0]=k>>>8,u[e+2|0]=k>>>16,u[e+3|0]=k>>>24,u[e+4|0]=r,u[e+5|0]=r>>>8,u[e+6|0]=r>>>16,u[e+7|0]=r>>>24,u[e+48|0]=0,r=l[14409]|l[14410]<<8|(l[14411]<<16|l[14412]<<24),k=l[14405]|l[14406]<<8|(l[14407]<<16|l[14408]<<24),u[e+40|0]=k,u[e+41|0]=k>>>8,u[e+42|0]=k>>>16,u[e+43|0]=k>>>24,u[e+44|0]=r,u[e+45|0]=r>>>8,u[e+46|0]=r>>>16,u[e+47|0]=r>>>24,r=l[14401]|l[14402]<<8|(l[14403]<<16|l[14404]<<24),k=l[14397]|l[14398]<<8|(l[14399]<<16|l[14400]<<24),u[e+32|0]=k,u[e+33|0]=k>>>8,u[e+34|0]=k>>>16,u[e+35|0]=k>>>24,u[e+36|0]=r,u[e+37|0]=r>>>8,u[e+38|0]=r>>>16,u[e+39|0]=r>>>24,r=l[14393]|l[14394]<<8|(l[14395]<<16|l[14396]<<24),k=l[14389]|l[14390]<<8|(l[14391]<<16|l[14392]<<24),u[e+24|0]=k,u[e+25|0]=k>>>8,u[e+26|0]=k>>>16,u[e+27|0]=k>>>24,u[e+28|0]=r,u[e+29|0]=r>>>8,u[e+30|0]=r>>>16,u[e+31|0]=r>>>24,r=l[14385]|l[14386]<<8|(l[14387]<<16|l[14388]<<24),k=l[14381]|l[14382]<<8|(l[14383]<<16|l[14384]<<24),u[e+16|0]=k,u[e+17|0]=k>>>8,u[e+18|0]=k>>>16,u[e+19|0]=k>>>24,u[e+20|0]=r,u[e+21|0]=r>>>8,u[e+22|0]=r>>>16,u[e+23|0]=r>>>24,r=l[14377]|l[14378]<<8|(l[14379]<<16|l[14380]<<24),k=l[14373]|l[14374]<<8|(l[14375]<<16|l[14376]<<24),u[e+8|0]=k,u[e+9|0]=k>>>8,u[e+10|0]=k>>>16,u[e+11|0]=k>>>24,u[e+12|0]=r,u[e+13|0]=r>>>8,u[e+14|0]=r>>>16,u[e+15|0]=r>>>24,q(m,2,113,s+40|0),u[s+51|0]>=0)break i;Z(i[s+40>>2]);break i}P8(s+40|0,k,i[e+116>>2],1684630887),k=i[e+480>>2],k&&(i[e+484>>2]=k,Z(k)),i[e+480>>2]=i[s+40>>2],i[e+484>>2]=i[s+44>>2],i[e+488>>2]=i[s+48>>2],a6(s+40|0,r,i[e+116>>2]);e:{r:switch(l[s+60|0]){default:_2(),H();case 1:if(e=i[s+44>>2],i[m>>2]=i[s+40>>2],i[m+4>>2]=e,e=m+8|0,u[s+59|0]>=0){r=i[s+52>>2],i[e>>2]=i[s+48>>2],i[e+4>>2]=r,i[e+8>>2]=i[s+56>>2];break e}T(e,i[s+48>>2],i[s+52>>2]);break e;case 0:break r}B=s+16|0,w=e+448|0,E=i[e+484>>2]-i[e+480>>2]>>2,o=v-192|0,v=o,r=p(32),i[o+20>>2]=r,i[o+24>>2]=29,i[o+28>>2]=-2147483616,k=l[12152]|l[12153]<<8|(l[12154]<<16|l[12155]<<24),t=l[12148]|l[12149]<<8|(l[12150]<<16|l[12151]<<24),u[r+21|0]=t,u[r+22|0]=t>>>8,u[r+23|0]=t>>>16,u[r+24|0]=t>>>24,u[r+25|0]=k,u[r+26|0]=k>>>8,u[r+27|0]=k>>>16,u[r+28|0]=k>>>24,k=l[12147]|l[12148]<<8|(l[12149]<<16|l[12150]<<24),t=l[12143]|l[12144]<<8|(l[12145]<<16|l[12146]<<24),u[r+16|0]=t,u[r+17|0]=t>>>8,u[r+18|0]=t>>>16,u[r+19|0]=t>>>24,u[r+20|0]=k,u[r+21|0]=k>>>8,u[r+22|0]=k>>>16,u[r+23|0]=k>>>24,k=l[12139]|l[12140]<<8|(l[12141]<<16|l[12142]<<24),t=l[12135]|l[12136]<<8|(l[12137]<<16|l[12138]<<24),u[r+8|0]=t,u[r+9|0]=t>>>8,u[r+10|0]=t>>>16,u[r+11|0]=t>>>24,u[r+12|0]=k,u[r+13|0]=k>>>8,u[r+14|0]=k>>>16,u[r+15|0]=k>>>24,k=l[12131]|l[12132]<<8|(l[12133]<<16|l[12134]<<24),t=l[12127]|l[12128]<<8|(l[12129]<<16|l[12130]<<24),u[r|0]=t,u[r+1|0]=t>>>8,u[r+2|0]=t>>>16,u[r+3|0]=t>>>24,u[r+4|0]=k,u[r+5|0]=k>>>8,u[r+6|0]=k>>>16,u[r+7|0]=k>>>24,u[r+29|0]=0,k=q(o+168|0,2,121,o+20|0),u[o+31|0]<0&&Z(i[o+20>>2]),r=i[s+40>>2],n=i[s+44>>2]-r|0;r:{if(n>>>0<=9){r=i[k+4>>2],i[B>>2]=i[k>>2],i[B+4>>2]=r,i[B+16>>2]=i[k+16>>2],r=i[k+12>>2],i[B+8>>2]=i[k+8>>2],i[B+12>>2]=r,i[k+16>>2]=0,i[k+8>>2]=0,i[k+12>>2]=0;break r}t=l[r|0],u[w|0]=t;f:{A:{k:{if(t){i[o+112>>2]=0,i[o+84>>2]=72196,i[o+28>>2]=72176,r=i[18053],i[o+20>>2]=r,n=i[r-12>>2],r=o+20|0,i[n+r>>2]=i[18054],i[o+24>>2]=0,f=r+i[i[o+20>>2]-12>>2]|0,t=o+32|0,J0(f,t),u[f+80|0]=0,i[f+72>>2]=0,f=i[18055],i[o+28>>2]=f,n=i[f-12>>2],f=o+28|0,i[n+f>>2]=i[18056],n=i[18052],i[o+20>>2]=n,i[r+i[n-12>>2]>>2]=i[18057],i[o+84>>2]=72196,i[o+20>>2]=72156,i[o+28>>2]=72176,n=R0(t),i[n>>2]=71232,i[o+72>>2]=0,i[o+76>>2]=0,i[o+64>>2]=0,i[o+68>>2]=0,i[o+80>>2]=24,Y(S0(Y(f,28029,27),l[w|0]),4165,23),r=i[o+80>>2];n:{if(r&16){f=o+52|0,t=i[o+76>>2],r=i[o+56>>2],t>>>0<r>>>0?i[o+76>>2]=r:r=t;break n}if(!(r&8)){r=0,u[o+19|0]=0,f=o+8|0;break f}f=o+40|0,r=i[o+48>>2]}if(t=i[f>>2],r=r-t|0,r>>>0>=2147483640)break k;if(r>>>0>=11){w=r|7,f=p(w+1|0),i[o+16>>2]=w-2147483647,i[o+8>>2]=f,i[o+12>>2]=r;break A}if(u[o+19|0]=r,f=o+8|0,r)break A;r=0;break f}if(t=l[r+1|0],u[w+1|0]=t,r=10,N=t&1,X=N?4:2,z=X<<1,t=z+10|0,n>>>0>=t+(E<<1<<(N?2:1))>>>0){if(n=i[s+40>>2],n=l[n+2|0]|l[n+3|0]<<8,g[w+2>>1]=n<<8|n>>>8,n=i[s+40>>2],n=l[n+4|0]|l[n+5|0]<<8,g[w+4>>1]=n<<8|n>>>8,n=i[s+40>>2],n=l[n+6|0]|l[n+7|0]<<8,g[w+6>>1]=n<<8|n>>>8,n=i[s+40>>2],n=l[n+8|0]|l[n+9|0]<<8,g[w+8>>1]=n<<8|n>>>8,_=i[s+40>>2],N){for(F=X&4;n=r,r=r+4|0,h=h+4|0,(F|0)!=(h|0););n=n+_|0,n=l[n|0]|l[n+1|0]<<8|(l[n+2|0]<<16|l[n+3|0]<<24),h=n<<24|(n&65280)<<8|(n>>>8&65280|n>>>24)}if(n=X&2,n)for(;h=l[r+_|0]|h<<8,r=r+1|0,f=f+1|0,(n|0)!=(f|0););if(i[w+12>>2]=h,F=X&2,r=X+10|0,R=i[s+40>>2],_=0,N){for(M=X&4,f=0;n=r,r=r+4|0,f=f+4|0,(M|0)!=(f|0););f=n+R|0,f=l[f|0]|l[f+1|0]<<8|(l[f+2|0]<<16|l[f+3|0]<<24),f=f<<24|(f&65280)<<8|(f>>>8&65280|f>>>24)}else f=0;if(F)for(;f=l[r+R|0]|f<<8,r=r+1|0,_=_+1|0,(F|0)!=(_|0););if(i[w+16>>2]=f,!(f&&h)){if(r=p(48),i[o+20>>2]=r,i[o+24>>2]=40,i[o+28>>2]=-2147483600,f=l[23503]|l[23504]<<8|(l[23505]<<16|l[23506]<<24),t=l[23499]|l[23500]<<8|(l[23501]<<16|l[23502]<<24),u[r|0]=t,u[r+1|0]=t>>>8,u[r+2|0]=t>>>16,u[r+3|0]=t>>>24,u[r+4|0]=f,u[r+5|0]=f>>>8,u[r+6|0]=f>>>16,u[r+7|0]=f>>>24,u[r+40|0]=0,f=l[23535]|l[23536]<<8|(l[23537]<<16|l[23538]<<24),t=l[23531]|l[23532]<<8|(l[23533]<<16|l[23534]<<24),u[r+32|0]=t,u[r+33|0]=t>>>8,u[r+34|0]=t>>>16,u[r+35|0]=t>>>24,u[r+36|0]=f,u[r+37|0]=f>>>8,u[r+38|0]=f>>>16,u[r+39|0]=f>>>24,f=l[23527]|l[23528]<<8|(l[23529]<<16|l[23530]<<24),t=l[23523]|l[23524]<<8|(l[23525]<<16|l[23526]<<24),u[r+24|0]=t,u[r+25|0]=t>>>8,u[r+26|0]=t>>>16,u[r+27|0]=t>>>24,u[r+28|0]=f,u[r+29|0]=f>>>8,u[r+30|0]=f>>>16,u[r+31|0]=f>>>24,f=l[23519]|l[23520]<<8|(l[23521]<<16|l[23522]<<24),t=l[23515]|l[23516]<<8|(l[23517]<<16|l[23518]<<24),u[r+16|0]=t,u[r+17|0]=t>>>8,u[r+18|0]=t>>>16,u[r+19|0]=t>>>24,u[r+20|0]=f,u[r+21|0]=f>>>8,u[r+22|0]=f>>>16,u[r+23|0]=f>>>24,f=l[23511]|l[23512]<<8|(l[23513]<<16|l[23514]<<24),t=l[23507]|l[23508]<<8|(l[23509]<<16|l[23510]<<24),u[r+8|0]=t,u[r+9|0]=t>>>8,u[r+10|0]=t>>>16,u[r+11|0]=t>>>24,u[r+12|0]=f,u[r+13|0]=f>>>8,u[r+14|0]=f>>>16,u[r+15|0]=f>>>24,q(B,2,121,o+20|0),u[o+31|0]>=0)break r;Z(i[o+20>>2]);break r}r=w+20|0,n=i[w+20>>2],f=(i[w+24>>2]-n|0)/12|0;n:{t:{if(f>>>0<E>>>0){Dt(r,E-f|0);break t}if(f>>>0>E>>>0&&(i[w+24>>2]=n+G(E,12)),!E)break n}for(M=X&4,F=X&2,S=128<<(X<<3)-8,a=i[r>>2],R=0;;){if(f=i[s+40>>2],r=t,_=0,h=0,N){for(;n=r,r=r+4|0,_=_+4|0,(M|0)!=(_|0););n=f+n|0,w=(l[n|0]<<16|l[n+1|0]<<8|l[n+2|0])<<8,h=w|l[n+3|0]}if(_=0,F)for(;w=h<<8,h=w|l[r+f|0],r=r+1|0,_=_+1|0,(F|0)!=(_|0););if(O=G(R,12)+a|0,i[O+4>>2]=w&S?h|-2147483648:h,r=t+X|0,P=i[s+40>>2],_=0,w=0,h=0,N){for(;f=r,r=r+4|0,w=w+4|0,(M|0)!=(w|0););n=f+P|0,f=(l[n|0]<<16|l[n+1|0]<<8|l[n+2|0])<<8,h=f|l[n+3|0]}if(F)for(;f=h<<8,h=f|l[r+P|0],r=r+1|0,_=_+1|0,(F|0)!=(_|0););if(i[O+8>>2]=f&S?h|-2147483648:h,t=t+z|0,R=R+1|0,(R|0)==(E|0))break}}if(r=i[26917],i[B>>2]=i[26916],i[B+4>>2]=r,r=B+8|0,u[107683]>=0){f=i[26919],i[r>>2]=i[26918],i[r+4>>2]=f,i[r+8>>2]=i[26920];break r}T(r,i[26918],i[26919]);break r}r=i[k+4>>2],i[B>>2]=i[k>>2],i[B+4>>2]=r,i[B+16>>2]=i[k+16>>2],r=i[k+12>>2],i[B+8>>2]=i[k+8>>2],i[B+12>>2]=r,i[k+16>>2]=0,i[k+8>>2]=0,i[k+12>>2]=0;break r}Q0(),H()}if(!r)break f;x(f,t,r)}u[r+f|0]=0,q(B,4,3002,o+8|0),u[o+19|0]<0&&Z(i[o+8>>2]),r=i[18051],i[o+20>>2]=r,i[i[r-12>>2]+(o+20|0)>>2]=i[18059],i[o+28>>2]=i[18060],i[n>>2]=71232,u[o+75|0]<0&&Z(i[o+64>>2]),E0(n),y0(o+84|0)}u[k+19|0]<0&&Z(i[k+8>>2]),v=o+192|0;r:{if(i[s+16>>2]){e=i[s+20>>2],i[m>>2]=i[s+16>>2],i[m+4>>2]=e,i[m+16>>2]=i[s+32>>2],e=i[s+28>>2],i[m+8>>2]=i[s+24>>2],i[m+12>>2]=e,i[s+32>>2]=0,i[s+24>>2]=0,i[s+28>>2]=0;break r}if(((i[e+472>>2]-i[e+468>>2]|0)/12|0)!=i[e+484>>2]-i[e+480>>2]>>2){if(e=p(72),i[s+4>>2]=e,i[s+8>>2]=69,i[s+12>>2]=-2147483576,x(e,5858,69),u[e+69|0]=0,q(m,2,121,s+4|0),u[s+15|0]>=0)break r;Z(i[s+4>>2]);break r}if(e=i[26917],i[m>>2]=i[26916],i[m+4>>2]=e,e=m+8|0,u[107683]>=0){r=i[26919],i[e>>2]=i[26918],i[e+4>>2]=r,i[e+8>>2]=i[26920];break r}T(e,i[26918],i[26919])}if(u[s+35|0]>=0)break e;Z(i[s+24>>2])}if(e=l[s+60|0],(e|0)==255)break i;r=i[25381],i[s+16>>2]=i[25380],i[s+20>>2]=r,W[i[(s+16|0)+(e<<2)>>2]](s+4|0,s+40|0)}i:{if(!V||(e=i[V+4>>2],i[V+4>>2]=e-1,e))break i;W[i[i[V>>2]+8>>2]](V),y(V)}i:{if(!Q||(e=i[Q+4>>2],i[Q+4>>2]=e-1,e))break i;W[i[i[Q>>2]+8>>2]](Q),y(Q)}v=s- -64|0,r=A+8|0;i:{if(i[I+8>>2]){e=I,k=i[e+12>>2],i[A>>2]=i[e+8>>2],i[A+4>>2]=k,i[r+8>>2]=i[e+24>>2],A=i[e+20>>2],i[r>>2]=i[e+16>>2],i[r+4>>2]=A,i[e+24>>2]=0,i[e+16>>2]=0,i[e+20>>2]=0;break i}if(e=i[26917],i[A>>2]=i[26916],i[A+4>>2]=e,u[107683]>=0){A=i[26919],i[r>>2]=i[26918],i[r+4>>2]=A,i[r+8>>2]=i[26920];break i}T(r,i[26918],i[26919])}u[I+27|0]<0&&Z(i[I+16>>2]),v=I+32|0}function d_(A,e,r,f,k,n,t){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,t=t|0;var o=0,s=0,w=0,h=0,_=0,B=0,m=0,X=0,Q=0,V=0,F=0,I=0;X=v-32|0,v=X;i:{e:{if(!(!n|(!e|!r))&&t)break e;e=i[23570],i[A>>2]=i[23569],i[A+4>>2]=e,i[A+8>>2]=i[23571];break i}e:{if(s=i[r>>2],!s)break e;if(h=W0(s,100660,101824),h){_=i[r+4>>2],_&&(i[_+4>>2]=i[_+4>>2]+1),o=v-112|0,v=o,Xf(o+100|0,i[h+100>>2],i[i[t>>2]+4>>2]),r=M6(),u[o+96|0]=0,i[o+76>>2]=0,i[o+80>>2]=0,s=i[o+100>>2],W[i[i[s>>2]+116>>2]](o+68|0,s),df(o+16|0,i[o+68>>2],n,t,i[r+4>>2],r+16|0,i[h+100>>2]- -64|0),s=l[o+36|0];r:{if((s|0)==255){W[i[25462]](o,o+76|0),u[o+96|0]=255;break r}w=o+76|0,i[o+108>>2]=w,B=i[25465],i[o>>2]=i[25464],i[o+4>>2]=B,W[i[o+(s<<2)>>2]](o+108|0,w,o+16|0)}s=l[o+36|0],(s|0)!=255&&(w=i[25463],i[o>>2]=i[25462],i[o+4>>2]=w,W[i[o+(s<<2)>>2]](o+108|0,o+16|0)),w=X+12|0,u[o+36|0]=255,s=i[o+72>>2];r:{if(!s||(B=i[s+4>>2],i[s+4>>2]=B-1,B))break r;W[i[i[s>>2]+8>>2]](s),y(s)}r:{f:{A:{k:{n:{if(l[o+96|0]){x2(r),f=107664,k=107676,r=107683,t=107672;t:switch(l[o+96|0]){case 1:k=o+88|0,r=o+95|0,t=o+84|0,f=o+76|0;break;case 0:break t;default:break n}if(n=i[f+4>>2],i[w>>2]=i[f>>2],i[w+4>>2]=n,f=w+8|0,u[r|0]>=0){r=i[t+4>>2],i[f>>2]=i[t>>2],i[f+4>>2]=r,i[f+8>>2]=i[t+8>>2];break r}T(f,i[t>>2],i[k>>2]);break r}i[o+68>>2]=i[o+76>>2],s=i[o+80>>2],i[o+72>>2]=s,s&&(i[s+4>>2]=i[s+4>>2]+1),x7(o+16|0,i[o+100>>2],o+68|0,t,r,1),x2(r);t:{u:switch(l[o+60|0]){case 1:if(r=i[o+20>>2],i[w>>2]=i[o+16>>2],i[w+4>>2]=r,r=w+8|0,u[o+35|0]<0)break t;f=i[o+28>>2],i[r>>2]=i[o+24>>2],i[r+4>>2]=f,i[r+8>>2]=i[o+32>>2];break f;case 0:break u;default:break n}if(r=i[h+100>>2],i[o>>2]=i[r+48>>2],r=i[r+52>>2],i[o+4>>2]=r,r&&(i[r+4>>2]=i[r+4>>2]+1),l[o+60|0])break n;q8(i[o>>2],i[h+116>>2],o+28|0,0),r=i[o+4>>2];u:{if(!r||(t=i[r+4>>2],i[r+4>>2]=t-1,t))break u;W[i[i[r>>2]+8>>2]](r),y(r)}if(r=i[n>>2],n=i[r+108>>2],!((n|0)==i[h+460>>2]&i[r+112>>2]==i[h+464>>2])){if(r=p(56),i[o>>2]=r,i[o+4>>2]=55,i[o+8>>2]=-2147483592,f=l[24891]|l[24892]<<8|(l[24893]<<16|l[24894]<<24),k=l[24887]|l[24888]<<8|(l[24889]<<16|l[24890]<<24),u[r|0]=k,u[r+1|0]=k>>>8,u[r+2|0]=k>>>16,u[r+3|0]=k>>>24,u[r+4|0]=f,u[r+5|0]=f>>>8,u[r+6|0]=f>>>16,u[r+7|0]=f>>>24,u[r+55|0]=0,f=l[24938]|l[24939]<<8|(l[24940]<<16|l[24941]<<24),k=l[24934]|l[24935]<<8|(l[24936]<<16|l[24937]<<24),u[r+47|0]=k,u[r+48|0]=k>>>8,u[r+49|0]=k>>>16,u[r+50|0]=k>>>24,u[r+51|0]=f,u[r+52|0]=f>>>8,u[r+53|0]=f>>>16,u[r+54|0]=f>>>24,f=l[24931]|l[24932]<<8|(l[24933]<<16|l[24934]<<24),k=l[24927]|l[24928]<<8|(l[24929]<<16|l[24930]<<24),u[r+40|0]=k,u[r+41|0]=k>>>8,u[r+42|0]=k>>>16,u[r+43|0]=k>>>24,u[r+44|0]=f,u[r+45|0]=f>>>8,u[r+46|0]=f>>>16,u[r+47|0]=f>>>24,f=l[24923]|l[24924]<<8|(l[24925]<<16|l[24926]<<24),k=l[24919]|l[24920]<<8|(l[24921]<<16|l[24922]<<24),u[r+32|0]=k,u[r+33|0]=k>>>8,u[r+34|0]=k>>>16,u[r+35|0]=k>>>24,u[r+36|0]=f,u[r+37|0]=f>>>8,u[r+38|0]=f>>>16,u[r+39|0]=f>>>24,f=l[24915]|l[24916]<<8|(l[24917]<<16|l[24918]<<24),k=l[24911]|l[24912]<<8|(l[24913]<<16|l[24914]<<24),u[r+24|0]=k,u[r+25|0]=k>>>8,u[r+26|0]=k>>>16,u[r+27|0]=k>>>24,u[r+28|0]=f,u[r+29|0]=f>>>8,u[r+30|0]=f>>>16,u[r+31|0]=f>>>24,f=l[24907]|l[24908]<<8|(l[24909]<<16|l[24910]<<24),k=l[24903]|l[24904]<<8|(l[24905]<<16|l[24906]<<24),u[r+16|0]=k,u[r+17|0]=k>>>8,u[r+18|0]=k>>>16,u[r+19|0]=k>>>24,u[r+20|0]=f,u[r+21|0]=f>>>8,u[r+22|0]=f>>>16,u[r+23|0]=f>>>24,f=l[24899]|l[24900]<<8|(l[24901]<<16|l[24902]<<24),k=l[24895]|l[24896]<<8|(l[24897]<<16|l[24898]<<24),u[r+8|0]=k,u[r+9|0]=k>>>8,u[r+10|0]=k>>>16,u[r+11|0]=k>>>24,u[r+12|0]=f,u[r+13|0]=f>>>8,u[r+14|0]=f>>>16,u[r+15|0]=f>>>24,q(w,5,0,o),u[o+11|0]>=0)break f;Z(i[o>>2]);break f}if(l[o+60|0])break n;if(r=i[h+532>>2],t=i[h+528>>2],f=(i[h+512>>2]+(G(((n+i[h+452>>2]|0)-1>>>0)/(n>>>0)|0,k)<<4)|0)+(f<<4)|0,k=i[o+32>>2]-i[o+28>>2]|0,i[f+8>>2]=k,i[f>>2]=t,i[f+4>>2]=r,f=k+t|0,r=k>>>0>f>>>0?r+1|0:r,i[h+528>>2]=f,i[h+532>>2]=r,f=i[h+104>>2],r=i[h+108>>2],(f|0)==(r|0))break k;for(;;){u:{o:{if(k=i[f>>2],!k||(t=W0(k,86580,101812),!t))break o;if(s=i[f+4>>2],s)break u;s=0;break A}if(f=f+8|0,(r|0)!=(f|0))continue;break k}break}if(i[s+4>>2]=i[s+4>>2]+1,l[o+60|0])break n;break A}T(r,i[o+24>>2],i[o+28>>2]);break f}_2(),H()}s=0,t=0}if(k=i[o+16>>2],n=i[o+20>>2],(k|0)!=(n|0))for(B=t+36|0;;){r=i[i[k>>2]+16>>2];A:{if((r|0)==1769173093)break A;if(f=i[t+36>>2],m=i[t+40>>2],(f|0)!=(m|0))for(;;){if((r|0)==i[i[f>>2]+16>>2])break A;if(f=f+8|0,(m|0)==(f|0))break}if(Vt(B,k),i[i[k>>2]+16>>2]!=1885960297||(r=i[h+100>>2],i[o>>2]=i[r+48>>2],r=i[r+52>>2],i[o+4>>2]=r,r&&(i[r+4>>2]=i[r+4>>2]+1),r=i[k>>2],f3(i[o>>2],i[h+116>>2],k,W[i[i[r>>2]+40>>2]](r)|0),r=i[o+4>>2],!r)||(f=i[r+4>>2],i[r+4>>2]=f-1,f))break A;W[i[i[r>>2]+8>>2]](r),y(r)}if(k=k+8|0,(n|0)==(k|0))break}r=i[26917],i[w>>2]=i[26916],i[w+4>>2]=r,r=w+8|0;A:{if(u[107683]>=0){f=i[26919],i[r>>2]=i[26918],i[r+4>>2]=f,i[r+8>>2]=i[26920];break A}T(r,i[26918],i[26919])}if(!s||(r=i[s+4>>2],i[s+4>>2]=r-1,r))break f;W[i[i[s>>2]+8>>2]](s),y(s)}if(r=l[o+60|0],(r|0)!=255&&(f=i[25467],i[o>>2]=i[25466],i[o+4>>2]=f,W[i[o+(r<<2)>>2]](o+108|0,o+16|0)),r=i[o+72>>2],!r||(f=i[r+4>>2],i[r+4>>2]=f-1,f))break r;W[i[i[r>>2]+8>>2]](r),y(r)}r=l[o+96|0],(r|0)!=255&&(f=i[25463],i[o+16>>2]=i[25462],i[o+20>>2]=f,W[i[(o+16|0)+(r<<2)>>2]](o,o+76|0)),r=i[o+104>>2];r:{if(!r||(f=i[r+4>>2],i[r+4>>2]=f-1,f))break r;W[i[i[r>>2]+8>>2]](r),y(r)}if(v=o+112|0,b0(A,w,i[e>>2]),u[X+31|0]<0&&Z(i[X+20>>2]),!_||(A=i[_+4>>2],i[_+4>>2]=A-1,A))break i;W[i[i[_>>2]+8>>2]](_),y(_);break i}if(w=W0(s,100660,101300),!w)break e;_=i[r+4>>2],_&&(i[_+4>>2]=i[_+4>>2]+1),m=X+12|0,s=0,o=v-192|0,v=o,F=i[w+472>>2],Oi(o+168|0,i[w+100>>2],n,t,F,1);r:{f:switch(l[o+188|0]){default:_2(),H();case 1:if(r=i[o+172>>2],i[m>>2]=i[o+168>>2],i[m+4>>2]=r,r=m+8|0,u[o+187|0]>=0){f=i[o+180>>2],i[r>>2]=i[o+176>>2],i[r+4>>2]=f,i[r+8>>2]=i[o+184>>2];break r}T(r,i[o+176>>2],i[o+180>>2]);break r;case 0:break f}Q=i[o+168>>2],B=i[o+172>>2],B&&(i[B+4>>2]=i[B+4>>2]+1),r=i[w+100>>2],i[o+160>>2]=i[r+48>>2],r=i[r+52>>2],i[o+164>>2]=r,r&&(i[r+4>>2]=i[r+4>>2]+1),s4(o+88|0,i[o+160>>2],i[Q+116>>2]),r=i[o+88>>2],u[r+164|0]=1,i[r+100>>2]=i[r+100>>2]&-2|1,r=i[o+92>>2];f:{if(!r||(t=i[r+4>>2],i[r+4>>2]=t-1,t))break f;W[i[i[r>>2]+8>>2]](r),y(r)}if(W[i[i[w>>2]+108>>2]](o+88|0,w),t=i[w+116>>2],h=G(i[o+92>>2],k)+f|0,I=i[Q+116>>2],V=i[i[o+160>>2]+84>>2],r=i[V+104>>2],V=i[V+108>>2],(r|0)!=(V|0))for(;;){f:{if(!((t|0)!=i[r+40>>2]|i[r+16>>2]!=1684630887)){i[i[r+44>>2]+(h<<2)>>2]=I;break f}if(r=r+56|0,(V|0)!=(r|0))continue}break}i[(i[w+460>>2]+(G(C[w+450>>1],k)<<2)|0)+(f<<2)>>2]=i[Q+116>>2],t=0,r=i[Q+104>>2],h=i[Q+108>>2];f:{A:{if((r|0)==(h|0))break A;for(;;){k:{if(t=i[r>>2],!t||(t=W0(t,86580,88852),!t))break k;if(r=i[r+4>>2],!r)break A;i[r+4>>2]=i[r+4>>2]+1,i[o+84>>2]=r,i[o+80>>2]=t,i[r+4>>2]=i[r+4>>2]+1,s=r,h=0;break f}if(r=r+8|0,(h|0)==(r|0))break}t=0}i[o+84>>2]=0,i[o+80>>2]=t,h=1}r=i[o+84>>2],i[o+24>>2]=i[o+80>>2],i[o+28>>2]=r,M4(w,o+24|0,1);f:{if(f|k)break f;if(Gf(o+68|0,Q,0),r=i[o+68>>2],k=i[o+72>>2],(r|0)!=(k|0))for(;i[o+60>>2]=i[r>>2],f=i[r+4>>2],i[o+64>>2]=f,f&&(i[f+4>>2]=i[f+4>>2]+1),t=i[r>>2],f=i[t+16>>2]==1769173093,t=f?w:t,f=W[i[i[t>>2]+(f?48:40)>>2]](t)|0,t=i[o+64>>2],i[o+16>>2]=i[o+60>>2],i[o+20>>2]=t,M4(w,o+16|0,f),r=r+8|0,(k|0)!=(r|0););if(D9(o+48|0,n,F,1,i[F+4>>2]),r=i[o+48>>2],k=i[o+52>>2],(r|0)!=(k|0)){for(;;){n=i[r>>2],i[o+40>>2]=n,f=i[r+4>>2],i[o+44>>2]=f;A:{if(!f){i[o+36>>2]=0,i[o+32>>2]=n;break A}if(i[f+4>>2]=i[f+4>>2]+1,n=i[r>>2],f=i[r+4>>2],i[o+36>>2]=f,i[o+32>>2]=n,!f)break A;i[f+4>>2]=i[f+4>>2]+1}n=i[o+32>>2],f=i[n+16>>2]==1769173093,n=f?w:n,f=W[i[i[n>>2]+(f?48:40)>>2]](n)|0,n=i[o+44>>2],i[o+8>>2]=i[o+40>>2],i[o+12>>2]=n,M4(w,o+8|0,f),f=i[o+36>>2];A:{if(!f||(n=i[f+4>>2],i[f+4>>2]=n-1,n))break A;W[i[i[f>>2]+8>>2]](f),y(f)}if(r=r+8|0,(k|0)==(r|0))break}r=i[o+48>>2]}if(r){if(t=r,f=i[o+52>>2],(f|0)!=(r|0)){for(;;){k=i[f-4>>2];A:{if(!k||(n=i[k+4>>2],i[k+4>>2]=n-1,n))break A;W[i[i[k>>2]+8>>2]](k),y(k)}if(f=f-8|0,(f|0)==(r|0))break}t=i[o+48>>2]}i[o+52>>2]=r,Z(t)}if(k=i[o+68>>2],!k)break f;if(r=i[o+72>>2],f=k,(r|0)!=(f|0)){for(;;){f=i[r-4>>2];A:{if(!f||(n=i[f+4>>2],i[f+4>>2]=n-1,n))break A;W[i[i[f>>2]+8>>2]](f),y(f)}if(r=r-8|0,(k|0)==(r|0))break}f=i[o+68>>2]}i[o+72>>2]=k,Z(f)}r=i[26917],i[m>>2]=i[26916],i[m+4>>2]=r,r=m+8|0;f:{if(u[107683]>=0){f=i[26919],i[r>>2]=i[26918],i[r+4>>2]=f,i[r+8>>2]=i[26920];break f}T(r,i[26918],i[26919])}f:{if(h||(r=i[s+4>>2],i[s+4>>2]=r-1,r))break f;W[i[i[s>>2]+8>>2]](s),y(s)}r=i[o+164>>2];f:{if(!r||(f=i[r+4>>2],i[r+4>>2]=f-1,f))break f;W[i[i[r>>2]+8>>2]](r),y(r)}if(!B||(r=i[B+4>>2],i[B+4>>2]=r-1,r))break r;W[i[i[B>>2]+8>>2]](B),y(B)}if(r=l[o+188|0],(r|0)!=255&&(f=i[25333],i[o+88>>2]=i[25332],i[o+92>>2]=f,W[i[(o+88|0)+(r<<2)>>2]](o+68|0,o+168|0)),v=o+192|0,b0(A,m,i[e>>2]),u[X+31|0]<0&&Z(i[X+20>>2]),!_||(A=i[_+4>>2],i[_+4>>2]=A-1,A))break i;W[i[i[_>>2]+8>>2]](_),y(_);break i}i[A>>2]=5,i[A+4>>2]=0,i[A+8>>2]=15011}v=X+32|0}function U7(A,e,r){var f=0,k=0,n=0,t=0,o=0,s=0,w=0,h=0,_=0,B=0,m=0,X=0,Q=0,V=0,F=0,I=0,E=0,R=0,N=0,M=0,z=0,S=0,O=U(0),P=0;f=v-144|0,v=f,o0(f,0,144),i[f+76>>2]=-1,i[f+44>>2]=A,i[f+32>>2]=2070,i[f+84>>2]=A,k=e,R=r,o=v-304|0,v=o;i:{e:{if(!i[f+4>>2]&&(Ge(f),!i[f+4>>2]))break e;if(e=l[k|0],!e)break i;r:{f:{for(;;){A:{A=e&255;k:{if((A|0)==32|A-9>>>0<5){for(;e=k,k=k+1|0,A=l[e+1|0],!!((A|0)==32|A-9>>>0<5););for(u8(f,0,0);;){A=i[f+4>>2];n:{if((A|0)!=i[f+104>>2]){i[f+4>>2]=A+1,A=l[A|0];break n}A=j2(f)}if(!((A|0)==32|A-9>>>0<5))break}k=i[f+4>>2],A=i[f+116>>2],(A|0)>0?A=1:A=(A|0)>=0,A&&(k=k-1|0,i[f+4>>2]=k),A=k-i[f+44>>2]|0,r=A,t=X+i[f+124>>2]|0,k=A>>31,A=_+i[f+120>>2]|0,t=k+(A>>>0<_>>>0?t+1|0:t)|0,_=A+r|0,X=_>>>0<A>>>0?t+1|0:t;break k}n:{t:{u:{if((A|0)==37){if(A=l[k+1|0],(A|0)==42)break u;if((A|0)!=37)break t}u8(f,0,0);o:{if(l[k|0]==37){for(;;){A=i[f+4>>2];l:{if((A|0)!=i[f+104>>2]){i[f+4>>2]=A+1,e=l[A|0];break l}e=j2(f)}if(!((e|0)==32|e-9>>>0<5))break}k=k+1|0;break o}if(A=i[f+4>>2],(A|0)!=i[f+104>>2]){i[f+4>>2]=A+1,e=l[A|0];break o}e=j2(f)}if(l[k|0]!=(e|0)){if(A=i[f+116>>2],(A|0)>0?A=1:A=(A|0)>=0,A&&(i[f+4>>2]=i[f+4>>2]-1),E|(e|0)>=0)break i;break e}A=i[f+4>>2]-i[f+44>>2]|0,r=A,n=A>>31,A=X+i[f+124>>2]|0,e=_+i[f+120>>2]|0,s=(e>>>0<_>>>0?A+1|0:A)+n|0,_=e+r|0,X=_>>>0<e>>>0?s+1|0:s,e=k;break k}h=0,e=k+2|0;break n}if(A=A-48|0,!(l[k+2|0]!=36|A>>>0>9)){e=v-16|0,i[e+12>>2]=R,A=A>>>0>1?((A<<2)+R|0)-4|0:R,i[e+8>>2]=A+4,h=i[A>>2],e=k+3|0;break n}h=i[R>>2],R=R+4|0,e=k+1|0}if(F=0,r=0,k=l[e|0],(k-48&255)>>>0<=9)for(;r=(G(r,10)+(k&255)|0)-48|0,k=l[e+1|0],e=e+1|0,(k-48&255)>>>0<10;);(k&255)==109&&(m=0,F=(h|0)!=0,k=l[e+1|0],Q=0,e=e+1|0),n=e,e=e+1|0,A=3;n:{t:switch((k&255)-65|0){case 39:A=l[n+1|0]==104,e=A?n+2|0:e,A=A?-2:-1;break n;case 43:A=l[n+1|0]==108,e=A?n+2|0:e,A=A?3:1;break n;case 51:case 57:A=1;break n;case 11:A=2;break n;case 0:case 2:case 4:case 5:case 6:case 18:case 23:case 26:case 32:case 34:case 35:case 36:case 37:case 38:case 40:case 45:case 46:case 47:case 50:case 52:case 55:break t;case 41:break n;default:break f}A=0,e=n}n=A,A=l[e|0],k=(A&47)==3,N=k?1:n,V=k?A|32:A;n:{if((V|0)==91)break n;t:{if((V|0)!=110){if((V|0)!=99)break t;r=(r|0)<=1?1:r;break n}Ho(h,N,_,X);break k}for(u8(f,0,0);;){A=i[f+4>>2];t:{if((A|0)!=i[f+104>>2]){i[f+4>>2]=A+1,A=l[A|0];break t}A=j2(f)}if(!((A|0)==32|A-9>>>0<5))break}k=i[f+4>>2],A=i[f+116>>2],(A|0)>0?A=1:A=(A|0)>=0,A&&(k=k-1|0,i[f+4>>2]=k),A=k-i[f+44>>2]|0,k=A,t=X+i[f+124>>2]|0,n=A>>31,A=_+i[f+120>>2]|0,X=n+(A>>>0<_>>>0?t+1|0:t)|0,_=A+k|0,X=_>>>0<A>>>0?X+1|0:X}s=r,B=r>>31,u8(f,r,B),A=i[f+4>>2];n:{if((A|0)!=i[f+104>>2]){i[f+4>>2]=A+1;break n}if((j2(f)|0)<0)break f}A=i[f+116>>2],(A|0)>0?A=1:A=(A|0)>=0,A&&(i[f+4>>2]=i[f+4>>2]-1),k=16;n:{t:{u:{o:{l:{s:{w:switch(V-88|0){default:if(A=V-65|0,A>>>0>6|!(1<<A&113))break n;case 9:case 13:case 14:case 15:if(Y7(o+8|0,f,N,0),A=i[f+4>>2]-i[f+44>>2]|0,i[f+120>>2]==(0-A|0)&i[f+124>>2]==(0-((A>>31)+((A|0)!=0)|0)|0))break r;if(!h)break n;switch(A=i[o+16>>2],k=i[o+20>>2],r=i[o+8>>2],n=i[o+12>>2],N|0){case 0:break l;case 1:break o;case 2:break u;default:break n}case 3:case 11:case 27:if((V|16)==115){if(Ae(o+32|0,-1,257),u[o+32|0]=0,(V|0)!=115)break t;u[o+65|0]=0,u[o+46|0]=0,g[o+42>>1]=0,g[o+44>>1]=0;break t}k=l[e+1|0],n=(k|0)==94,Ae(o+32|0,n,257),u[o+32|0]=0,A=n?e+2|0:e+1|0;_:{h:{B:{if(e=l[(n?2:1)+e|0],(e|0)!=45){if((e|0)==93)break B;w=(k|0)!=94;break _}w=(k|0)!=94,u[o+78|0]=w;break h}w=(k|0)!=94,u[o+126|0]=w}A=A+1|0}for(e=A;;){A=l[e|0];_:{if((A|0)!=45){if(!A)break f;if((A|0)==93)break t;break _}if(A=45,n=l[e+1|0],!n|(n|0)==93)break _;t=e+1|0,k=l[e-1|0];h:{if(n>>>0<=k>>>0){A=n;break h}for(;k=k+1|0,u[k+(o+32|0)|0]=w,A=l[t|0],k>>>0<A>>>0;);}e=t}u[((o+32|0)+A|0)+1|0]=w,e=e+1|0}case 23:k=8;break s;case 12:case 29:k=10;break s;case 0:case 24:case 32:break s;case 1:case 2:case 4:case 5:case 6:case 7:case 8:case 10:case 16:case 18:case 19:case 20:case 21:case 22:case 25:case 26:case 28:case 30:case 31:break n;case 17:break w}k=0}n=0,t=0,r=0,s=0,w=0,M=v-16|0,v=M;s:{if(!((k|0)!=1&k>>>0<=36)){i[31324]=28;break s}for(;;){A=i[f+4>>2];w:{if((A|0)!=i[f+104>>2]){i[f+4>>2]=A+1,A=l[A|0];break w}A=j2(f)}if(!((A|0)==32|A-9>>>0<5))break}w:{_:switch(A-43|0){case 0:case 2:break _;default:break w}if(w=(A|0)==45?-1:0,A=i[f+4>>2],(A|0)!=i[f+104>>2]){i[f+4>>2]=A+1,A=l[A|0];break w}A=j2(f)}w:{_:{h:{B:{if(!((k|0)!=0&(k|0)!=16|(A|0)!=48)){A=i[f+4>>2];v:{if((A|0)!=i[f+104>>2]){i[f+4>>2]=A+1,A=l[A|0];break v}A=j2(f)}if((A&-33)==88){k=16,A=i[f+4>>2];v:{if((A|0)!=i[f+104>>2]){i[f+4>>2]=A+1,A=l[A|0];break v}A=j2(f)}if(l[A+73889|0]<16)break h;A=i[f+116>>2],(A|0)>0?A=1:A=(A|0)>=0,A&&(i[f+4>>2]=i[f+4>>2]-1),u8(f,0,0);break s}if(k)break B;k=8;break h}if(k=k||10,k>>>0>l[A+73889|0])break B;A=i[f+116>>2],(A|0)>0?A=1:A=(A|0)>=0,A&&(i[f+4>>2]=i[f+4>>2]-1),u8(f,0,0),i[31324]=28;break s}if((k|0)!=10)break h;if(r=A-48|0,r>>>0<=9){for(A=0;;){A=G(A,10)+r|0,k=A>>>0<429496729,r=i[f+4>>2];B:{if((r|0)!=i[f+104>>2]){i[f+4>>2]=r+1,r=l[r|0];break B}r=j2(f)}if(r=r-48|0,!(k&r>>>0<=9))break}n=A}if(r>>>0>9)break w;for(k=O0(n,0,10,0),B=l0;;){B:{t=B,n=r+k|0,t=n>>>0<r>>>0?t+1|0:t,r=(t|0)==429496729&n>>>0<2576980378|t>>>0<429496729,A=i[f+4>>2];v:{if((A|0)!=i[f+104>>2]){i[f+4>>2]=A+1,A=l[A|0];break v}A=j2(f)}if(s=A-48|0,!(r&s>>>0<=9)){if(s>>>0<=9)break B;break w}if(k=O0(n,t,10,0),B=l0,r=s,(B|0)==-1&(r^-1)>>>0>=k>>>0|(B|0)!=-1)continue}break}k=10;break _}if(k-1&k){if(s=l[A+73889|0],s>>>0<k>>>0){for(;;){r=G(r,k)+s|0,n=r>>>0<119304647,A=i[f+4>>2];h:{if((A|0)!=i[f+104>>2]){i[f+4>>2]=A+1,A=l[A|0];break h}A=j2(f)}if(s=l[A+73889|0],!(n&s>>>0<k>>>0))break}n=r}if(k>>>0<=s>>>0)break _;for(;;){if(r=O0(n,t,k,0),B=l0,s=s&255,(B|0)==-1&(s^-1)>>>0<r>>>0)break _;t=B,n=r+s|0,t=n>>>0<s>>>0?t+1|0:t,A=i[f+4>>2];h:{if((A|0)!=i[f+104>>2]){i[f+4>>2]=A+1,A=l[A|0];break h}A=j2(f)}if(s=l[A+73889|0],k>>>0<=s>>>0)break _;if($1(M,k,0,0,0,n,t,0,0),!!(i[M+8>>2]|i[M+12>>2]))break}break _}if(B=u[(G(k,23)>>>5&7)+74145|0],r=l[A+73889|0],k>>>0>r>>>0){for(;;){A=s<<B,s=A|r,n=A>>>0<134217728,A=i[f+4>>2];h:{if((A|0)!=i[f+104>>2]){i[f+4>>2]=A+1,A=l[A|0];break h}A=j2(f)}if(r=l[A+73889|0],!(n&k>>>0>r>>>0))break}n=s}if(r>>>0>=k>>>0||(I=B&31,(B&63)>>>0>=32?(s=0,I=-1>>>I|0):(s=-1>>>I|0,I=s|(1<<I)-1<<32-I),!s&n>>>0>I>>>0))break _;for(;;){z=r&255,r=n,A=B&31,(B&63)>>>0>=32?(t=r<<A,A=0):(t=(1<<A)-1&r>>>32-A|t<<A,A=r<<A),n=z|A,A=i[f+4>>2];h:{if((A|0)!=i[f+104>>2]){i[f+4>>2]=A+1,A=l[A|0];break h}A=j2(f)}if(r=l[A+73889|0],k>>>0<=r>>>0)break _;if(!((t|0)==(s|0)&n>>>0<=I>>>0|t>>>0<s>>>0))break}}if(l[A+73889|0]>=k>>>0)break w;for(;;){A=i[f+4>>2];_:{if((A|0)!=i[f+104>>2]){i[f+4>>2]=A+1,A=l[A|0];break _}A=j2(f)}if(!(l[A+73889|0]<k>>>0))break}i[31324]=68,w=0,n=-1,t=-1}A=i[f+116>>2],(A|0)>0?A=1:A=(A|0)>=0,A&&(i[f+4>>2]=i[f+4>>2]-1);w:if((t&n)!=-1)break w;A=n^w,n=A-w|0,r=w>>31,t=(r^t)-((A>>>0<w>>>0)+r|0)|0}if(v=M+16|0,A=i[f+4>>2]-i[f+44>>2]|0,i[f+120>>2]==(0-A|0)&i[f+124>>2]==(0-((A>>31)+((A|0)!=0)|0)|0))break r;if(!(!h|(V|0)!=112)){i[h>>2]=n;break n}Ho(h,N,n,t);break n}S=h,O=Cn(r,n,A,k),p0[S>>2]=O;break n}S=h,P=Pf(r,n,A,k),t0[S>>3]=P;break n}i[h>>2]=r,i[h+4>>2]=n,i[h+8>>2]=A,i[h+12>>2]=k;break n}n=(V|0)!=99,w=n?31:r+1|0;t:{if((N|0)==1){if(r=h,F&&(r=y2(w<<2),!r))break A;i[o+296>>2]=0,i[o+300>>2]=0,k=0;u:{o:{for(;;){for(A=r;;){r=i[f+4>>2];l:{if((r|0)!=i[f+104>>2]){i[f+4>>2]=r+1,r=l[r|0];break l}r=j2(f)}if(!l[(r+o|0)+33|0])break o;if(u[o+27|0]=r,r=ne(o+28|0,o+27|0,1,o+296|0),(r|0)!=-2){if((r|0)==-1){m=0;break u}if(A&&(i[(k<<2)+A>>2]=i[o+28>>2],k=k+1|0),!(!F|(k|0)!=(w|0)))break}}if(w=w<<1|1,r=vr(A,w<<2),!r)break}m=0,Q=A,F=1;break f}if(m=0,Q=A,!(o+296|0&&i[o+296>>2]))break t}Q=A;break f}if(F){if(k=0,r=y2(w),!r)break A;for(;;){for(A=r;;){r=i[f+4>>2];u:{if((r|0)!=i[f+104>>2]){i[f+4>>2]=r+1,r=l[r|0];break u}r=j2(f)}if(!l[(r+o|0)+33|0]){m=A,Q=0;break t}if(u[A+k|0]=r,k=k+1|0,(w|0)==(k|0))break}if(w=w<<1|1,r=vr(A,w),!r)break}Q=0,m=A,F=1;break f}if(k=0,h)for(;;){A=i[f+4>>2];u:{if((A|0)!=i[f+104>>2]){i[f+4>>2]=A+1,A=l[A|0];break u}A=j2(f)}if(l[(A+o|0)+33|0]){u[k+h|0]=A,k=k+1|0;continue}else{A=h,m=A,Q=0;break t}}for(;;){A=i[f+4>>2];u:{if((A|0)!=i[f+104>>2]){i[f+4>>2]=A+1,A=l[A|0];break u}A=j2(f)}if(!l[(A+o|0)+33|0])break}A=0,m=0,Q=0}if(r=i[f+4>>2],t=i[f+116>>2],(t|0)>0?t=1:t=(t|0)>=0,t&&(r=r-1|0,i[f+4>>2]=r),t=r-i[f+44>>2]|0,w=t,r=t+i[f+120>>2]|0,t=i[f+124>>2]+(t>>31)|0,t=r>>>0<w>>>0?t+1|0:t,!(t|r)|!(n|(r|0)==(s|0)&(t|0)==(B|0)))break r;if(F&&(i[h>>2]=A),(V|0)==99)break n;if(Q&&(i[(k<<2)+Q>>2]=0),!m){m=0;break n}u[k+m|0]=0}A=i[f+4>>2]-i[f+44>>2]|0,k=A,n=A>>31,A=X+i[f+124>>2]|0,r=_+i[f+120>>2]|0,t=(r>>>0<_>>>0?A+1|0:A)+n|0,_=r+k|0,X=_>>>0<r>>>0?t+1|0:t,E=((h|0)!=0)+E|0}if(k=e+1|0,e=l[e+1|0],e)continue;break i}break}F=1,m=0,Q=0}E=E||-1}if(!F)break i;Z(m),Z(Q);break i}E=-1}return v=o+304|0,v=f+144|0,E}function c_(A,e,r,f,k,n,t,o){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,t=t|0,o=o|0;var s=0,w=0,h=U(0),_=0,B=0,m=0,X=0,Q=0,V=0,F=0,I=0,E=0,R=0,N=0,M=0,z=0,S=0,O=0,P=0,a=0,$=0,f0=0,A0=0,n0=0,_0=0,m0=U(0),X0=0,g0=0,I0=0,e0=U(0),r0=U(0),N0=U(0),U0=0,M0=0,H0=0,P0=0,K0=0,$0=0,L0=0,d0=0,n2=0,Z2=0,Q2=U(0),g2=U(0),p2=U(0),H2=0,T2=U(0),b2=U(0),e1=U(0),X1=U(0);w=v-160|0,v=w,e=i[r>>2],I=i[e+112>>2],B=i[e+108>>2],n=i[k+4>>2],f=n>>>0<4,t=n<<3,E=(f?16908801>>>t|0:0)&3,O=(f?16843265>>>t|0:0)&3,V=j0(e,3);i:{if(V>>>0<=8){e=i[26922],i[A>>2]=i[26921],i[A+4>>2]=e,r=A+8|0;e:{if(u[107703]>=0){e=i[26924],i[r>>2]=i[26923],i[r+4>>2]=e,i[r+8>>2]=i[26925];break e}T(r,i[26923],i[26924])}u[A+20|0]=1;break i}e:{if(A0=u1(i[r>>2],6),!A0||(j0(i[r>>2],6)|0)==(V|0))break e;e=i[26922],i[A>>2]=i[26921],i[A+4>>2]=e,r=A+8|0;r:{if(u[107703]>=0){e=i[26924],i[r>>2]=i[26923],i[r+4>>2]=e,i[r+8>>2]=i[26925];break r}T(r,i[26923],i[26924])}u[A+20|0]=1;break i}z=p(172),s=z,i[s+4>>2]=0,i[s+8>>2]=0,i[s>>2]=94812,o0(s+16|0,0,80),e=i[s+4>>2],f=e+1|0,i[s+4>>2]=f,i[s+104>>2]=0,i[s+108>>2]=0,i[s+36>>2]=1,i[s+40>>2]=1,u[s+24|0]=1,g[s+22>>1]=2,g[s+18>>1]=2,g[s+20>>1]=2,i[s+112>>2]=0,i[s+116>>2]=4740,i[s+140>>2]=0,i[s+144>>2]=0,i[s+128>>2]=99,i[s+132>>2]=99,i[s+120>>2]=0,i[s+124>>2]=0,i[s+12>>2]=95160,i[s+148>>2]=0,i[s+152>>2]=0,t=s+140|0,i[s+136>>2]=t,i[s+156>>2]=0,i[s+160>>2]=0,i[s+164>>2]=0,i[s+168>>2]=0,i[s+4>>2]=e,e=i[s+8>>2],N=s+12|0,i[s+96>>2]=N,i[s+8>>2]=e+1,i[s+100>>2]=s,f||(W[i[i[s>>2]+8>>2]](s),y(s)),i[N+120>>2]=n,i[N+116>>2]=0,i[N+112>>2]=I,i[N+108>>2]=B,T0(w+136|0,N,0,B,I,V,o),n=((B+E|0)-1>>>0)/(E>>>0)|0,f=((I+O|0)-1>>>0)/(O>>>0)|0,T0(w+112|0,N,1,n,f,V,o),s=w+16|0;e:{if(i[w+136>>2]){if(e=i[w+140>>2],i[w+8>>2]=i[w+136>>2],i[w+12>>2]=e,u[w+155|0]>=0){e=i[w+148>>2],i[s>>2]=i[w+144>>2],i[s+4>>2]=e,i[s+8>>2]=i[w+152>>2];break e}T(s,i[w+144>>2],i[w+148>>2]);break e}if(e=i[w+116>>2],i[w+8>>2]=i[w+112>>2],i[w+12>>2]=e,u[w+131|0]>=0){e=i[w+124>>2],i[s>>2]=i[w+120>>2],i[s+4>>2]=e,i[s+8>>2]=i[w+128>>2];break e}T(s,i[w+120>>2],i[w+124>>2])}T0(w+88|0,N,2,n,f,V,o),f=w+56|0;e:{if(i[w+8>>2]){if(e=i[w+12>>2],i[w+48>>2]=i[w+8>>2],i[w+52>>2]=e,u[w+27|0]>=0){e=i[s+4>>2],i[f>>2]=i[s>>2],i[f+4>>2]=e,i[f+8>>2]=i[s+8>>2];break e}T(f,i[w+16>>2],i[w+20>>2]);break e}if(e=i[w+92>>2],i[w+48>>2]=i[w+88>>2],i[w+52>>2]=e,u[w+107|0]>=0){e=i[w+100>>2],i[f>>2]=i[w+96>>2],i[f+4>>2]=e,i[f+8>>2]=i[w+104>>2];break e}T(f,i[w+96>>2],i[w+100>>2])}u[w+107|0]<0&&Z(i[w+96>>2]),u[w+27|0]<0&&Z(i[w+16>>2]),u[w+131|0]<0&&Z(i[w+120>>2]),u[w+155|0]<0&&Z(i[w+144>>2]);e:{if(i[w+48>>2]){if(e=i[w+52>>2],i[A>>2]=i[w+48>>2],i[A+4>>2]=e,r=A+8|0,u[w+67|0]>=0){e=i[f+4>>2],i[r>>2]=i[f>>2],i[r+4>>2]=e,i[r+8>>2]=i[f+8>>2],u[A+20|0]=1;break e}if(T(r,i[w+56>>2],i[w+60>>2]),e=u[w+67|0],u[A+20|0]=1,(e|0)>=0)break e;Z(i[w+56>>2]);break e}u[w+67|0]<0&&Z(i[w+56>>2]);r:{if(!A0)break r;if(T0(w+48|0,N,6,B,I,V,o),i[w+48>>2]){if(e=i[w+52>>2],i[A>>2]=i[w+48>>2],i[A+4>>2]=e,r=A+8|0,u[w+67|0]>=0){e=i[w+60>>2],i[r>>2]=i[w+56>>2],i[r+4>>2]=e,i[r+8>>2]=i[w+64>>2],u[A+20|0]=1;break e}if(T(r,i[w+56>>2],i[w+60>>2]),e=u[w+67|0],u[A+20|0]=1,(e|0)>=0)break e;Z(i[w+56>>2]);break e}if(u[w+67|0]>=0)break r;Z(i[w+56>>2])}e=i[r>>2],n=e+128|0;r:{f:{if(o=i[e+128>>2],o){for(f=n,e=o;s=i[e+16>>2]<3,f=s?f:e,e=i[(s?4:0)+e>>2],!!e;);_=0;A:{if((f|0)==(n|0)||(_=0,i[f+16>>2]>3))break A;n0=i[f+44>>2],_=i[f+56>>2]}for(f=n,e=o;s=i[e+16>>2]<4,f=s?f:e,e=i[(s?4:0)+e>>2],!!e;);e=0;A:{if((f|0)==(n|0)||(e=0,i[f+16>>2]>4))break A;P=i[f+56>>2],e=i[f+44>>2]}for(U0=e,f=n,e=o;s=i[e+16>>2]<5,f=s?f:e,e=i[(s?4:0)+e>>2],!!e;);if((f|0)!=(n|0))break f}e=0;break r}if(e=0,i[f+16>>2]>5)break r;M0=i[f+56>>2]>>>1|0,e=i[f+44>>2]}H0=e;r:{f:{if(f=i[t>>2],f){for(s=t,e=f;R=i[e+16>>2],s=(R|0)<0?s:e,e=i[(R>>>29&4)+e>>2],!!e;);m=0;A:{if((t|0)==(s|0)||(m=0,i[s+16>>2]>0))break A;a=i[s+56>>2],m=i[s+44>>2]}for(s=t,e=f;R=i[e+16>>2]<=0,s=R?s:e,e=i[(R?4:0)+e>>2],!!e;);R=0;A:{if((t|0)==(s|0)||(R=0,i[s+16>>2]>1))break A;S=i[s+56>>2],R=i[s+44>>2]}for(s=t,e=f;M=i[e+16>>2]<2,s=M?s:e,e=i[(M?4:0)+e>>2],!!e;);if((t|0)!=(s|0))break f}M=0;break r}if(M=0,i[s+16>>2]>2)break r;H2=i[s+56>>2]>>>1|0,M=i[s+44>>2]}s=0;r:{if(!A0)break r;f:{A:{if(!o)break A;for(e=n;s=i[o+16>>2]<6,e=s?e:o,o=i[(s?4:0)+o>>2],!!o;);if((e|0)==(n|0))break A;if(n=0,i[e+16>>2]>6)break f;P0=i[e+44>>2],n=i[e+56>>2];break f}n=0}if(K0=n,s=0,!f)break r;for(e=t;n=i[f+16>>2]<6,e=n?e:f,f=i[(n?4:0)+f>>2],!!f;);if(s=0,(e|0)==(t|0)||(s=0,i[e+16>>2]>6))break r;$0=i[e+56>>2],s=i[e+44>>2]}n=s,i[w+84>>2]=-1113159960,i[w+76>>2]=1056964608,i[w+80>>2]=-1093247418,i[w+68>>2]=-1096180881,i[w+72>>2]=1056964608,i[w+60>>2]=1038710997,i[w+64>>2]=-1104361250,i[w+52>>2]=1050220167,i[w+56>>2]=1058424226,u[w+48|0]=1,_0=l[k+22|0],L0=C[k+20>>1],Nr(w+8|0,L0,C[k+16>>1]),e=i[w+44>>2],i[w+80>>2]=i[w+40>>2],i[w+84>>2]=e,e=i[w+36>>2],i[w+72>>2]=i[w+32>>2],i[w+76>>2]=e,e=i[w+28>>2],f=w- -64|0,i[f>>2]=i[w+24>>2],i[f+4>>2]=e,e=i[w+20>>2],i[w+56>>2]=i[w+16>>2],i[w+60>>2]=e,e=i[w+12>>2],i[w+48>>2]=i[w+8>>2],i[w+52>>2]=e;r:{if(!I)break r;if(d0=P>>>1|0,n2=_>>>1|0,e=-1<<V^-1,m0=U(16<<V-8),B)for(Z2=a>>>1|0,X0=B&-4,$=B&3,P=B&-2,a=B&1,o=B>>>0<4,_=0;;){X=(G(_,Z2)<<1)+m|0,F=(G(_,M0)<<1)+H0|0,s=(G(_,n2)<<1)+n0|0,Q=(G(_,d0)<<1)+U0|0,Q2=p0[w+60>>2],g2=p0[w+56>>2],p2=p0[w+52>>2],f=0;f:{A:{k:switch(L0|0){default:for(;k=f<<1,t=k+X|0,h=U(U(U(C[k+F>>1])*Q2)+U(U(U(C[k+s>>1])*p2)+U(g2*U(C[k+Q>>1])))),h=U((_0&1?h:U(U(U(h*U(219))*U(.00390625))+m0))+U(.5)),U(w2(h))<U(2147483648)?k=~~h:k=-2147483648,g[t>>1]=(k|0)>=0?(e|0)<(k|0)?e:k:0,f=f+1|0,(B|0)!=(f|0););break f;case 0:if(s=0,_0&1){if(k=0,o)break A;for(;F=s<<1,g[F+X>>1]=C[Q+F>>1],t=F|2,g[t+X>>1]=C[t+Q>>1],t=F|4,g[t+X>>1]=C[t+Q>>1],t=F|6,g[t+X>>1]=C[t+Q>>1],s=s+4|0,f=f+4|0,(X0|0)!=(f|0););break A}for(;f=s<<1,k=f+X|0,h=U(U(U(U(U(C[f+Q>>1])*U(219))*U(.00390625))+m0)+U(.5)),U(w2(h))<U(2147483648)?f=~~h:f=-2147483648,g[k>>1]=(f|0)>=0?(e|0)<(f|0)?e:f:0,s=s+1|0,(B|0)!=(s|0););break f;case 8:break k}if(k=0,(B|0)!=1)for(;t=f<<1,g[t+X>>1]=(C[t+Q>>1]>>>1)+(C[t+F>>1]+C[t+s>>1]>>>2),t=t|2,g[t+X>>1]=(C[t+Q>>1]>>>1)+(C[t+F>>1]+C[t+s>>1]>>>2),f=f+2|0,k=k+2|0,(P|0)!=(k|0););if(!a)break f;f=f<<1,g[f+X>>1]=(C[f+Q>>1]>>>1)+(C[f+F>>1]+C[f+s>>1]>>>2);break f}if(!$)break f;for(;f=s<<1,g[f+X>>1]=C[f+Q>>1],s=s+1|0,k=k+1|0,($|0)!=(k|0););}if(_=_+1|0,(I|0)==(_|0))break}if(!B)break r;for(Z2=S>>>1|0,g0=e&65535,V=1<<V-1&65535,T2=U(V>>>0),X0=(O|0)==2,P=X0&(E|0)==2,a=(E|O)>>>0<2,m=0;;){k=G(m,M0)<<1,f0=k+H0|0,X=(G(m,n2)<<1)+n0|0,Q=(G(m,d0)<<1)+U0|0,t=(m>>>0)/(O>>>0)|0,f=G(t,Z2)<<1,I0=f+R|0;f:{A:{k:switch(L0|0){default:for(f=m+1|0,f=X0&&f>>>0<I>>>0?f:m,F=(G(f,M0)<<1)+H0|0,$=(G(f,d0)<<1)+U0|0,S=(G(f,n2)<<1)+n0|0,b2=p0[w+84>>2],e1=p0[w+80>>2],X1=p0[w+76>>2],Q2=p0[w+72>>2],g2=p0[w+68>>2],p2=p0[w+64>>2],_=(G(t,H2)<<1)+M|0,o=0;k=o<<1,e0=U(C[k+f0>>1]),r0=U(C[k+Q>>1]),N0=U(C[k+X>>1]),a||(f=o+1|0,f=(f>>>0<B>>>0&&P?f:o)<<1,e0=U(U(U(U(e0+U(C[f+f0>>1]))+U(C[k+F>>1]))+U(C[f+F>>1]))*U(.25)),r0=U(U(U(U(r0+U(C[f+Q>>1]))+U(C[k+$>>1]))+U(C[f+$>>1]))*U(.25)),N0=U(U(U(U(N0+U(C[f+X>>1]))+U(C[k+S>>1]))+U(C[f+S>>1]))*U(.25))),s=(o>>>0)/(E>>>0)<<1,k=s+I0|0,h=U(U(e0*Q2)+U(U(N0*p2)+U(r0*g2))),t=_0&1,h=U(U((t?h:U(U(h*U(224))*U(.00390625)))+T2)+U(.5)),U(w2(h))<U(2147483648)?f=~~h:f=-2147483648,g[k>>1]=(f|0)>=0?(e|0)<(f|0)?e:f:0,k=s+_|0,h=U(U(e0*b2)+U(U(N0*X1)+U(r0*e1))),h=U(U((t?h:U(U(h*U(224))*U(.00390625)))+T2)+U(.5)),U(w2(h))<U(2147483648)?f=~~h:f=-2147483648,g[k>>1]=(f|0)>=0?(e|0)<(f|0)?e:f:0,o=o+E|0,B>>>0>o>>>0;);break f;case 0:if(S=k+n0|0,_=f+M|0,o=0,_0&1)break A;for(;s=(o>>>0)/(E>>>0)<<1,k=s+I0|0,t=o<<1,h=U(U(U(U(U(C[t+f0>>1])*U(224))*U(.00390625))+m0)+U(.5)),U(w2(h))<U(2147483648)?f=~~h:f=-2147483648,g[k>>1]=(f|0)>=0?(e|0)<(f|0)?e:f:0,k=s+_|0,h=U(U(U(U(U(C[t+S>>1])*U(224))*U(.00390625))+m0)+U(.5)),U(w2(h))<U(2147483648)?f=~~h:f=-2147483648,g[k>>1]=(f|0)>=0?(e|0)<(f|0)?e:f:0,o=o+E|0,B>>>0>o>>>0;);break f;case 8:break k}for(t=(G(t,H2)<<1)+M|0,o=0;f=o<<1,_=f+f0|0,k=(o>>>0)/(E>>>0)<<1,s=C[f+Q>>1]>>>1|0,f=f+X|0,s=V+(s-(C[_>>1]+C[f>>1]>>>2|0)|0)|0,g[k+I0>>1]=(s|0)>=0?s>>>0<g0>>>0?s:g0:0,f=V+((C[f>>1]-C[_>>1]|0)/2|0)|0,g[k+t>>1]=(f|0)>=0?f>>>0<g0>>>0?f:g0:0,o=o+E|0,B>>>0>o>>>0;);break f}for(;k=(o>>>0)/(E>>>0)<<1,f=o<<1,g[k+I0>>1]=C[f+f0>>1],g[k+_>>1]=C[f+S>>1],o=o+E|0,B>>>0>o>>>0;);}if(m=m+O|0,!(I>>>0>m>>>0))break}}r:{if(!A0||(e=j0(i[r>>2],6),!I))break r;if(k=B<<(e>>>0>8),e=0,(I|0)!=1)for(f=I&-2,o=0;r=!k,r||x(G(e,$0)+n|0,G(e,K0)+P0|0,k),r||(r=e|1,x(G(r,$0)+n|0,G(r,K0)+P0|0,k)),e=e+2|0,o=o+2|0,(f|0)!=(o|0););if(!(I&1)|!k)break r;x(G(e,$0)+n|0,G(e,K0)+P0|0,k)}u[A+20|0]=0,i[A+4>>2]=z,i[A>>2]=N;break i}if(A=i[z+4>>2],i[z+4>>2]=A-1,A)break i;W[i[i[z>>2]+8>>2]](z),y(z)}v=w+160|0}function D7(A,e,r,f){var k=0,n=0,t=0,o=0,s=0,w=0,h=0,_=0,B=0,m=0,X=0,Q=0,V=0,F=0,I=0,E=0,R=0,N=0,M=0,z=0,S=0;n=v-208|0,v=n;i:{e:{r:{f:{A:switch(i[e+120>>2]-1|0){case 1:if((r|0)!=1)break r;if(u[e+108|0]&1)break f;break r;case 0:break A;default:break r}if(u[e+108|0]&1)break f;if(!(u[e+112|0]&1))break r}if(i[n+32>>2]=0,i[n+36>>2]=0,i[n+24>>2]=0,i[n+28>>2]=0,u[n+36|0]=1,i[n+28>>2]=2,i[n+32>>2]=2,u[n+24|0]=1,i[n+8>>2]=i[e+84>>2],k=i[e+88>>2],!k||(k=Gi(k),i[n+12>>2]=k,!k))break i;i[n+200>>2]=131074,i[n+204>>2]=65538,t=255,k=i[e+128>>2];f:{if(!k)break f;for(e=e+128|0,h=e;B=i[k+16>>2],h=(B|0)<0?h:k,k=i[(B>>>29&4)+k>>2],!!k;);if((e|0)==(h|0)|i[h+16>>2]>0)break f;t=l[h+24|0]}r6(n+48|0,n+8|0,0,3,n+200|0,t,n+24|0,0,f),e=i[n+12>>2];f:{if(!e||(k=i[e+4>>2],i[e+4>>2]=k-1,k))break f;W[i[i[e>>2]+8>>2]](e),y(e)}f:{A:switch(l[n+68|0]){default:_2(),H();case 1:e=i[n+52>>2],i[A>>2]=i[n+48>>2],i[A+4>>2]=e,e=A+8|0;k:{if(u[n+67|0]>=0){r=i[n+60>>2],i[e>>2]=i[n+56>>2],i[e+4>>2]=r,i[e+8>>2]=i[n+64>>2];break k}T(e,i[n+56>>2],i[n+60>>2])}u[A+20|0]=1;break f;case 0:break A}D7(A,i[n+48>>2],r,f)}if(A=l[n+68|0],(A|0)==255)break e;e=i[23817],i[n+8>>2]=i[23816],i[n+12>>2]=e,W[i[(n+8|0)+(A<<2)>>2]](n+200|0,n+48|0);break e}if(B=i[e+124>>2],z=e+128|0,(B|0)!=(z|0))for(M=(r|0)==1;;){r:{if(r=l[B+24|0],r>>>0<=8){if(h=i[B+44>>2],_=i[B+32>>2],f=i[B+28>>2],!M){if(!f|_>>>0<2)break r;for(X=_>>>1|0,V=f&-2,o=f&1,r=0;;){if(t=_+(r^-1)|0,k=0,Q=0,(f|0)!=1)for(;w=i[B+56>>2],E=(h+G(w,r)|0)+k|0,R=l[E|0],w=(h+G(t,w)|0)+k|0,u[E|0]=l[w|0],u[w|0]=R,E=k|1,w=i[B+56>>2],R=E+(h+G(w,r)|0)|0,s=l[R|0],w=E+(h+G(t,w)|0)|0,u[R|0]=l[w|0],u[w|0]=s,k=k+2|0,Q=Q+2|0,(V|0)!=(Q|0););if(o&&(Q=i[B+56>>2],w=(h+G(Q,r)|0)+k|0,E=l[w|0],k=(h+G(t,Q)|0)+k|0,u[w|0]=l[k|0],u[k|0]=E),r=r+1|0,(X|0)==(r|0))break}break r}if(!_|f>>>0<2)break r;for(Q=f&2,X=f>>>1|0,V=X&2147483646,r=0;;){if(k=0,t=0,(X|0)!=1)for(;o=h+G(i[B+56>>2],r)|0,w=o+k|0,E=l[w|0],o=(f+o|0)+(k^-1)|0,u[w|0]=l[o|0],u[o|0]=E,o=h+G(i[B+56>>2],r)|0,w=o+k|0,E=l[w+1|0],o=(f+o|0)+(k^-2)|0,u[w+1|0]=l[o|0],u[o|0]=E,k=k+2|0,t=t+2|0,(V|0)!=(t|0););if(Q&&(t=h+G(i[B+56>>2],r)|0,o=t+k|0,w=l[o|0],k=(f+t|0)+(k^-1)|0,u[o|0]=l[k|0],u[k|0]=w),r=r+1|0,(_|0)==(r|0))break}break r}if(r>>>0<=16){if(X=i[B+44>>2],_=i[B+32>>2],f=i[B+28>>2],!M){if(!f|_>>>0<2)break r;for(w=_>>>1|0,V=i[B+56>>2],E=f&-4,o=f&3,h=0,R=f>>>0<4;;){if(r=X+(G(h,V)&-2)|0,Q=X+(G(V,_+(h^-1)|0)&-2)|0,k=0,t=0,!R)for(;f=k<<1,s=f+r|0,m=C[s>>1],I=s,s=f+Q|0,g[I>>1]=C[s>>1],g[s>>1]=m,s=f|2,m=s+r|0,F=C[m>>1],s=s+Q|0,g[m>>1]=C[s>>1],g[s>>1]=F,s=f|4,m=s+r|0,F=C[m>>1],s=s+Q|0,g[m>>1]=C[s>>1],g[s>>1]=F,f=f|6,s=f+r|0,m=C[s>>1],f=f+Q|0,g[s>>1]=C[f>>1],g[f>>1]=m,k=k+4|0,t=t+4|0,(E|0)!=(t|0););if(f=0,o)for(;t=k<<1,s=t+r|0,m=C[s>>1],t=t+Q|0,g[s>>1]=C[t>>1],g[t>>1]=m,k=k+1|0,f=f+1|0,(o|0)!=(f|0););if(h=h+1|0,(w|0)==(h|0))break}break r}if(!_|f>>>0<2)break r;for(V=i[B+56>>2],o=f&2,w=f>>>1|0,E=w&2147483646,h=0;;){if(t=X+(G(h,V)&-2)|0,Q=t+(f<<1)|0,k=0,(w|0)!=1)for(R=t+2|0,r=0;s=k<<1,m=s+t|0,F=C[m>>1],I=m,m=Q+((k^-1)<<1)|0,g[I>>1]=C[m>>1],g[m>>1]=F,s=s+R|0,m=C[s>>1],I=s,s=Q+((k^2147483646)<<1)|0,g[I>>1]=C[s>>1],g[s>>1]=m,k=k+2|0,r=r+2|0,(E|0)!=(r|0););if(o&&(r=t+(k<<1)|0,t=C[r>>1],s=r,r=Q+((k^-1)<<1)|0,g[s>>1]=C[r>>1],g[r>>1]=t),h=h+1|0,(_|0)==(h|0))break}break r}if(r>>>0<=32){if(V=i[B+44>>2],Q=i[B+32>>2],_=i[B+28>>2],!M){if(!_|Q>>>0<2)break r;for(E=Q>>>1|0,o=i[B+56>>2],R=_&-4,w=_&3,h=0;;){if(r=V+(G(o,h)&-4)|0,X=V+(G(o,Q+(h^-1)|0)&-4)|0,k=0,t=0,_>>>0>=4)for(;f=k<<2,s=f+r|0,m=i[s>>2],I=s,s=f+X|0,i[I>>2]=i[s>>2],i[s>>2]=m,s=f|4,m=s+r|0,F=i[m>>2],s=s+X|0,i[m>>2]=i[s>>2],i[s>>2]=F,s=f|8,m=s+r|0,F=i[m>>2],s=s+X|0,i[m>>2]=i[s>>2],i[s>>2]=F,f=f|12,s=f+r|0,m=i[s>>2],f=f+X|0,i[s>>2]=i[f>>2],i[f>>2]=m,k=k+4|0,t=t+4|0,(R|0)!=(t|0););if(f=0,w)for(;t=k<<2,s=t+r|0,m=i[s>>2],t=t+X|0,i[s>>2]=i[t>>2],i[t>>2]=m,k=k+1|0,f=f+1|0,(w|0)!=(f|0););if(h=h+1|0,(E|0)==(h|0))break}break r}if(!Q|_>>>0<2)break r;for(X=i[B+56>>2],o=_&2,w=_>>>1|0,E=w&2147483646,h=0;;){if(f=V+(G(h,X)&-4)|0,t=f+(_<<2)|0,k=0,(w|0)!=1)for(R=f+4|0,r=0;s=k<<2,m=s+f|0,F=i[m>>2],I=m,m=t+((k^-1)<<2)|0,i[I>>2]=i[m>>2],i[m>>2]=F,s=s+R|0,m=i[s>>2],I=s,s=t+((k^1073741822)<<2)|0,i[I>>2]=i[s>>2],i[s>>2]=m,k=k+2|0,r=r+2|0,(E|0)!=(r|0););if(o&&(r=f+(k<<2)|0,f=i[r>>2],s=r,r=t+((k^-1)<<2)|0,i[s>>2]=i[r>>2],i[r>>2]=f),h=h+1|0,(Q|0)==(h|0))break}break r}if(r>>>0<=64){if(V=i[B+44>>2],Q=i[B+32>>2],h=i[B+28>>2],!M){if(!h|Q>>>0<2)break r;for(s=Q>>>1|0,E=i[B+56>>2],m=h&-4,R=h&3,_=0;;){if(r=V+(G(_,E)&-8)|0,X=V+(G(E,Q+(_^-1)|0)&-8)|0,k=0,t=0,h>>>0>=4)for(;f=k<<3,o=f+r|0,F=i[o>>2],I=i[o+4>>2],w=f+X|0,N=i[w+4>>2],i[o>>2]=i[w>>2],i[o+4>>2]=N,i[w>>2]=F,i[w+4>>2]=I,o=f|8,w=o+r|0,F=i[w>>2],I=i[w+4>>2],o=o+X|0,N=i[o+4>>2],i[w>>2]=i[o>>2],i[w+4>>2]=N,i[o>>2]=F,i[o+4>>2]=I,o=f|16,w=o+r|0,F=i[w>>2],I=i[w+4>>2],o=o+X|0,N=i[o+4>>2],i[w>>2]=i[o>>2],i[w+4>>2]=N,i[o>>2]=F,i[o+4>>2]=I,o=f|24,f=o+r|0,w=i[f>>2],F=i[f+4>>2],o=o+X|0,I=i[o+4>>2],i[f>>2]=i[o>>2],i[f+4>>2]=I,i[o>>2]=w,i[o+4>>2]=F,k=k+4|0,t=t+4|0,(m|0)!=(t|0););if(f=0,R)for(;o=k<<3,t=o+r|0,w=i[t>>2],F=i[t+4>>2],o=o+X|0,I=i[o+4>>2],i[t>>2]=i[o>>2],i[t+4>>2]=I,i[o>>2]=w,i[o+4>>2]=F,k=k+1|0,f=f+1|0,(R|0)!=(f|0););if(_=_+1|0,(s|0)==(_|0))break}break r}if(!Q|h>>>0<2)break r;for(w=i[B+56>>2],E=h&2,R=h>>>1|0,s=R&2147483646,_=0;;){if(f=V+(G(_,w)&-8)|0,t=f+(h<<3)|0,k=0,(R|0)!=1)for(m=f+8|0,r=0;F=k<<3,X=F+f|0,I=i[X>>2],N=i[X+4>>2],o=t+((k^-1)<<3)|0,S=i[o+4>>2],i[X>>2]=i[o>>2],i[X+4>>2]=S,i[o>>2]=I,i[o+4>>2]=N,X=m+F|0,F=i[X>>2],I=i[X+4>>2],o=t+((k^536870910)<<3)|0,N=i[o+4>>2],i[X>>2]=i[o>>2],i[X+4>>2]=N,i[o>>2]=F,i[o+4>>2]=I,k=k+2|0,r=r+2|0,(s|0)!=(r|0););if(E&&(r=f+(k<<3)|0,X=i[r>>2],o=i[r+4>>2],f=t+((k^-1)<<3)|0,k=i[f+4>>2],i[r>>2]=i[f>>2],i[r+4>>2]=k,i[f>>2]=X,i[f+4>>2]=o),_=_+1|0,(Q|0)==(_|0))break}break r}if(r>>>0<=128){if(Q=i[B+44>>2],f=i[B+32>>2],h=i[B+28>>2],!M){if(!h|f>>>0<2)break r;for(X=f>>>1|0,r=0;;){for(V=f+(r^-1)|0,k=0;o=k<<4,_=i[B+56>>2],t=o+(Q+(G(_,r)&-16)|0)|0,w=i[t+12>>2],i[n+56>>2]=i[t+8>>2],i[n+60>>2]=w,w=i[t+4>>2],i[n+48>>2]=i[t>>2],i[n+52>>2]=w,_=o+(Q+(G(_,V)&-16)|0)|0,o=i[_+12>>2],i[t+8>>2]=i[_+8>>2],i[t+12>>2]=o,o=i[_+4>>2],i[t>>2]=i[_>>2],i[t+4>>2]=o,t=i[n+60>>2],i[_+8>>2]=i[n+56>>2],i[_+12>>2]=t,t=i[n+52>>2],i[_>>2]=i[n+48>>2],i[_+4>>2]=t,k=k+1|0,(h|0)!=(k|0););if(r=r+1|0,(X|0)==(r|0))break}break r}if(!f|h>>>0<2)break r;for(X=h>>>1|0,r=0;;){for(k=0;_=Q+(G(i[B+56>>2],r)&-16)|0,t=_+(k<<4)|0,V=i[t+12>>2],i[n+56>>2]=i[t+8>>2],i[n+60>>2]=V,V=i[t+4>>2],i[n+48>>2]=i[t>>2],i[n+52>>2]=V,_=(_+(h<<4)|0)+((k^-1)<<4)|0,V=i[_+12>>2],i[t+8>>2]=i[_+8>>2],i[t+12>>2]=V,V=i[_+4>>2],i[t>>2]=i[_>>2],i[t+4>>2]=V,t=i[n+60>>2],i[_+8>>2]=i[n+56>>2],i[_+12>>2]=t,t=i[n+52>>2],i[_>>2]=i[n+48>>2],i[_+4>>2]=t,k=k+1|0,(X|0)!=(k|0););if(r=r+1|0,(f|0)==(r|0))break}break r}i[n+140>>2]=0,i[n+112>>2]=72196,i[n+56>>2]=72176,e=i[18053],i[n+48>>2]=e,r=i[e-12>>2],e=n+48|0,i[r+e>>2]=i[18054],i[n+52>>2]=0,r=e+i[i[n+48>>2]-12>>2]|0,f=n+60|0,J0(r,f),u[r+80|0]=0,i[r+72>>2]=0,r=i[18055],i[n+56>>2]=r,s=i[r-12>>2],r=n+56|0,i[s+r>>2]=i[18056],k=i[18052],i[n+48>>2]=k,i[e+i[k-12>>2]>>2]=i[18057],i[n+112>>2]=72196,i[n+48>>2]=72156,i[n+56>>2]=72176,f=R0(f),i[f>>2]=71232,i[n+100>>2]=0,i[n+104>>2]=0,i[n+92>>2]=0,i[n+96>>2]=0,i[n+108>>2]=24,e=Y(r,28331,26),u[n+24|0]=l[B+24|0],Y(Y(e,n+24|0,1),9962,15),e=i[n+108>>2];f:{A:{if(e&16){B=n+80|0,r=i[n+104>>2],e=i[n+84>>2],r>>>0<e>>>0?i[n+104>>2]=e:e=r;break A}if(!(e&8)){k=0,u[n+19|0]=0,B=n+8|0;break f}B=n+68|0,e=i[n+76>>2]}A:{if(r=e,e=i[B>>2],k=r-e|0,k>>>0<2147483640){if(k>>>0>=11){r=k|7,B=p(r+1|0),i[n+16>>2]=r-2147483647,i[n+8>>2]=B,i[n+12>>2]=k;break A}if(u[n+19|0]=k,B=n+8|0,k)break A;k=0;break f}Q0(),H()}if(!k)break f;x(B,e,k)}u[k+B|0]=0,e=q(n+24|0,4,0,n+8|0),r=i[e+4>>2],i[A>>2]=i[e>>2],i[A+4>>2]=r,r=A+8|0;f:{if(u[e+19|0]>=0){k=i[e+12>>2],i[r>>2]=i[e+8>>2],i[r+4>>2]=k,i[r+8>>2]=i[e+16>>2],u[A+20|0]=1;break f}if(T(r,i[e+8>>2],i[e+12>>2]),r=u[e+19|0],u[A+20|0]=1,(r|0)>=0)break f;Z(i[e+8>>2])}u[n+19|0]<0&&Z(i[n+8>>2]),A=i[18051],i[n+48>>2]=A,i[i[A-12>>2]+(n+48|0)>>2]=i[18059],i[n+56>>2]=i[18060],i[f>>2]=71232,u[n+103|0]<0&&Z(i[n+92>>2]),E0(f),y0(n+112|0);break e}h=i[B+4>>2];r:{if(h){for(;;)if(k=h,h=i[k>>2],!h)break r}for(;k=i[B+8>>2],r=i[k>>2]!=(B|0),B=k,!!r;);}if(B=k,(k|0)==(z|0))break}if(r=i[e+88>>2],!r||(e=i[e+84>>2],r=Gi(r),!r))break i;u[A+20|0]=0,i[A+4>>2]=r,i[A>>2]=e}v=n+208|0;return}Q3(),H()}function b_(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0;var k=0,n=0,t=0,o=0,s=0,w=0,h=0,_=0,B=0,m=0,X=0,Q=0,V=0,F=0,I=0,E=0,R=0,N=0,M=0,z=0,S=0,O=0,P=0,a=0,$=0,f0=0,A0=0,n0=0,_0=0,m0=0,X0=0,g0=0,I0=0,e0=0,r0=0,N0=0,U0=0,M0=0,H0=0,P0=0,K0=0,$0=0,L0=0,d0=0;k=v-256|0,v=k,z2(k+236|0,e,r),u[k+255|0]<0&&Z(i[k+244>>2]);i:{m=l[e+97|0];e:{if(m>>>0>=3){t1(A,e,17959);break e}o=o2(r);r:{if((m|0)!=2){n=o2(r);break r}n=C0(r)}if(t=i[f+28>>2],I=n,!(t>>>0<n>>>0&&t)){r:{f:{A:{if(n)for(A0=o&15,r0=(A0|0)!=0&(m-1&255)>>>0<2,N0=e+104|0,Q=i[18051],E=Q-12|0,n0=i[18052],R=n0-12|0,_0=i[18055],N=_0-12|0,V=i[18053],M=V-12|0,z=i[18060],S=i[18059],U0=k+108|0,M0=k+120|0,O=i[18057],P=i[18056],a=i[18054],m0=k+100|0,X0=k+96|0,H0=k+152|0,B=k+56|6,P0=(o>>>4&15)-4|0,K0=(o>>>12|0)-4|0,$0=(o>>>8&15)-4|0;;){if(u[k+60|0]=0,i[k+56>>2]=0,g[B+14>>1]=0,g[B+16>>1]=0,g[B+18>>1]=0,g[B+20>>1]=0,g[B+8>>1]=0,g[B+10>>1]=0,g[B+12>>1]=0,g[B+14>>1]=0,g[B>>1]=0,g[B+2>>1]=0,g[B+4>>1]=0,g[B+6>>1]=0,!i[r+16>>2]){i[k+180>>2]=0,i[k+88>>2]=V,i[k+152>>2]=72196,i[k+96>>2]=72176,f=k+88|0,i[f+i[M>>2]>>2]=a,i[k+92>>2]=0,e=f+i[i[k+88>>2]-12>>2]|0,r=k+100|0,J0(e,r),u[e+80|0]=0,i[e+72>>2]=0,e=k+96|0,i[e+i[N>>2]>>2]=P,i[f+i[R>>2]>>2]=O,i[k+152>>2]=72196,i[k+88>>2]=72156,i[k+96>>2]=72176,n=R0(r),i[n>>2]=71232,i[k+140>>2]=0,i[k+144>>2]=0,i[k+132>>2]=0,i[k+136>>2]=0,i[k+148>>2]=24,Y(V0(Y(V0(Y(e,28251,24),I),29033,29),$),23873,7),e=i[k+148>>2];k:{if(e&16){h=k+120|0,e=i[k+144>>2],r=i[k+124>>2],e>>>0<r>>>0&&(i[k+144>>2]=r,e=r);break k}if(!(e&8)){r=0,u[k+27|0]=0,h=k+16|0;break f}h=k+108|0,e=i[k+116>>2]}if(f=i[h>>2],r=e-f|0,r>>>0>=2147483640)break i;if(r>>>0>=11){e=r|7,h=p(e+1|0),i[k+24>>2]=e-2147483647,i[k+16>>2]=h,i[k+20>>2]=r;break A}if(u[k+27|0]=r,h=k+16|0,r)break A;r=0;break f}k:{n:{if((m|0)==2){L0=k,d0=C0(r),i[L0+56>>2]=d0;break n}if(L0=k,d0=o2(r),i[L0+56>>2]=d0,!m)break k}L0=k,d0=o2(r)&15,u[L0+60|0]=d0}n=o2(r),i[k+64>>2]=0,i[k+68>>2]=0,g[k+62>>1]=n,t=k;k:{n:{t:switch(P0|0){case 0:n=C0(r),o=0;break n;case 4:break t;default:break k}n=C0(r),i[k+64>>2]=0,i[k+68>>2]=n,n=C0(r)|i[k+64>>2],o=i[k+68>>2]}i[t+64>>2]=n,i[t+68>>2]=o}X=o2(r);k:{n:{t:{u:{if(n=i[f+52>>2],!(n>>>0<X>>>0&&n)){if(h=0,X)break u;break k}i[k+180>>2]=0,i[k+88>>2]=V,i[k+152>>2]=72196,i[k+96>>2]=72176,f=k+88|0,i[f+i[M>>2]>>2]=a,i[k+92>>2]=0,e=f+i[i[k+88>>2]-12>>2]|0,r=k+100|0,J0(e,r),u[e+80|0]=0,i[e+72>>2]=0,e=k+96|0,i[e+i[N>>2]>>2]=P,i[f+i[R>>2]>>2]=O,i[k+152>>2]=72196,i[k+88>>2]=72156,i[k+96>>2]=72176,t=R0(r),i[t>>2]=71232,i[k+140>>2]=0,i[k+144>>2]=0,i[k+132>>2]=0,i[k+136>>2]=0,i[k+148>>2]=24,Y(V0(Y(V0(Y(e,26969,31),X),27001,26),n),42669,2),e=i[k+148>>2];o:{if(e&16){n=k+120|0,e=i[k+144>>2],r=i[k+124>>2],e>>>0<r>>>0&&(i[k+144>>2]=r,e=r);break o}if(!(e&8)){r=0,u[k+27|0]=0,n=k+16|0;break n}n=k+108|0,e=i[k+116>>2]}if(f=i[n>>2],r=e-f|0,r>>>0>=2147483640)break i;if(r>>>0>=11){e=r|7,n=p(e+1|0),i[k+24>>2]=e-2147483647,i[k+16>>2]=n,i[k+20>>2]=r;break t}if(u[k+27|0]=r,n=k+16|0,r)break t;r=0;break n}for(;;){i[k+48>>2]=0,i[k+40>>2]=0,i[k+44>>2]=0,i[k+32>>2]=0,i[k+36>>2]=0,i[k+24>>2]=0,i[k+28>>2]=0,i[k+16>>2]=0,i[k+20>>2]=0;u:{o:{l:{s:{w:{if(g0=i[r+16>>2],!g0){i[k+180>>2]=0,i[k+88>>2]=V,i[k+152>>2]=72196,i[k+96>>2]=72176,t=k+88|0,i[t+i[M>>2]>>2]=a,i[k+92>>2]=0,n=t+i[i[k+88>>2]-12>>2]|0,J0(n,m0),u[n+80|0]=0,i[n+72>>2]=0,i[k+96>>2]=_0,i[i[N>>2]+X0>>2]=P,i[k+88>>2]=n0,i[t+i[R>>2]>>2]=O,i[k+152>>2]=72196,i[k+88>>2]=72156,i[k+96>>2]=72176,s=R0(m0),i[s>>2]=71232,i[k+140>>2]=0,i[k+144>>2]=0,i[k+132>>2]=0,i[k+136>>2]=0,i[k+148>>2]=24,Y(S0(Y(V0(Y(X0,28276,25),X),29001,31),h),23736,9),n=i[k+148>>2];_:{if(n&16){if(n=M0,t=i[k+144>>2],o=i[k+124>>2],t>>>0>=o>>>0)break _;i[k+144>>2]=o,t=o;break _}if(!(n&8)){n=0,u[k+15|0]=0,t=k+4|0;break o}t=i[k+116>>2],n=U0}if(w=i[n>>2],n=t-w|0,n>>>0>=2147483640)break w;if(n>>>0>=11){o=n|7,t=p(o+1|0),i[k+12>>2]=o-2147483647,i[k+4>>2]=t,i[k+8>>2]=n;break l}if(u[k+15|0]=n,t=k+4|0,n)break l;n=0;break o}_:{if(!r0)break _;t=k;h:{B:switch(A0-4|0){case 0:n=C0(r),o=0;break h;case 4:break B;default:break _}n=C0(r),i[k+16>>2]=0,i[k+20>>2]=n,n=C0(r)|i[k+16>>2],o=i[k+20>>2]}i[t+16>>2]=n,i[t+20>>2]=o}i[k+24>>2]=0,i[k+28>>2]=0,t=k;_:{h:{B:switch(K0|0){case 0:n=C0(r),o=0;break h;case 4:break B;default:break _}n=C0(r),i[k+24>>2]=0,i[k+28>>2]=n,n=C0(r)|i[k+24>>2],o=i[k+28>>2]}i[t+24>>2]=n,i[t+28>>2]=o}i[k+32>>2]=0,i[k+36>>2]=0;_:{h:{B:switch($0|0){case 0:n=C0(r),o=0;break h;case 4:break B;default:break _}n=C0(r),i[k+32>>2]=0,i[k+36>>2]=n,n=C0(r)|i[k+32>>2],o=i[k+36>>2]}i[t+32>>2]=n,i[t+36>>2]=o}s=i[k+76>>2];_:{if(s>>>0<u0[k+80>>2]){if(n=i[k+20>>2],i[s>>2]=i[k+16>>2],i[s+4>>2]=n,n=i[k+36>>2],i[s+16>>2]=i[k+32>>2],i[s+20>>2]=n,n=i[k+28>>2],i[s+8>>2]=i[k+24>>2],i[s+12>>2]=n,i[s+32>>2]=0,i[s+24>>2]=0,i[s+28>>2]=0,n=i[k+44>>2],t=i[k+40>>2],(n|0)!=(t|0)){if(w=n-t|0,(w|0)<0)break s;o=p(w),i[s+28>>2]=o,i[s+24>>2]=o,n=o+w|0,i[s+32>>2]=n,w&&x(o,t,w),i[s+28>>2]=n}n=s+40|0;break _}h:{B:{v:{if(F=i[k+76>>2],n=i[k+72>>2],f0=F-n|0,w=((f0|0)/40|0)+1|0,w>>>0<107374183){if(o=(i[k+80>>2]-n|0)/40|0,t=o<<1,t=o>>>0>=53687091?107374182:t>>>0>w>>>0?t:w,t>>>0>=107374183)break v;if(I0=G(t,40),e0=p(I0),w=f0+e0|0,o=w,t=i[k+20>>2],i[o>>2]=i[k+16>>2],i[o+4>>2]=t,_=i[k+24>>2],s=i[k+28>>2],o=i[k+32>>2],t=i[k+36>>2],i[w+32>>2]=0,i[w+24>>2]=0,i[w+28>>2]=0,i[w+16>>2]=o,i[w+20>>2]=t,i[w+8>>2]=_,i[w+12>>2]=s,t=i[k+44>>2],s=i[k+40>>2],(t|0)!=(s|0)){if(_=t-s|0,(_|0)<0)break B;o=p(_),i[w+24>>2]=o,t=o+_|0,i[w+32>>2]=t,_&&x(o,s,_),i[w+28>>2]=t}if(o=w+G((f0|0)/-40|0,40)|0,(n|0)!=(F|0)){for(t=n,s=o;_=i[t+4>>2],i[s>>2]=i[t>>2],i[s+4>>2]=_,_=i[t+20>>2],i[s+16>>2]=i[t+16>>2],i[s+20>>2]=_,_=i[t+12>>2],i[s+8>>2]=i[t+8>>2],i[s+12>>2]=_,i[s+24>>2]=i[t+24>>2],i[s+28>>2]=i[t+28>>2],i[s+32>>2]=i[t+32>>2],i[t+32>>2]=0,i[t+24>>2]=0,i[t+28>>2]=0,s=s+40|0,t=t+40|0,(F|0)!=(t|0););for(;t=i[n+24>>2],t&&(i[n+28>>2]=t,Z(t)),n=n+40|0,(F|0)!=(n|0););n=i[k+72>>2]}i[k+80>>2]=I0+e0,t=w+40|0,i[k+76>>2]=t,i[k+72>>2]=o,n&&Z(n),n=t;break h}G0(),H()}z0(),H()}G0(),H()}}i[k+76>>2]=n;break u}Q0(),H()}G0(),H()}if(!n)break o;x(t,w,n)}u[n+t|0]=0,q(A,2,100,k+4|0),u[k+15|0]<0&&Z(i[k+4>>2]),i[k+88>>2]=Q,i[i[E>>2]+(k+88|0)>>2]=S,i[k+96>>2]=z,i[s>>2]=71232,u[k+143|0]<0&&Z(i[k+132>>2]),E0(s),y0(H0)}if(n=i[k+40>>2],n&&(i[k+44>>2]=n,Z(n)),!g0)break r;if(h=h+1|0,(X|0)==(h|0))break}break k}if(!r)break n;x(n,f,r)}u[r+n|0]=0,q(A,6,1e3,k+16|0),u[k+27|0]<0&&Z(i[k+16>>2]),i[k+88>>2]=Q,i[i[E>>2]+(k+88|0)>>2]=S,i[k+96>>2]=z,i[t>>2]=71232,u[k+143|0]<0&&Z(i[k+132>>2]),E0(t),y0(k+152|0);break r}if(!l[r+20|0]){n=i[e+108>>2];k:{if(n>>>0<u0[e+112>>2]){t=i[k+60>>2],i[n>>2]=i[k+56>>2],i[n+4>>2]=t,o=k- -64|0,t=i[o+4>>2],i[n+8>>2]=i[o>>2],i[n+12>>2]=t,i[n+24>>2]=0,i[n+16>>2]=0,i[n+20>>2]=0,o=i[k+72>>2],t=i[k+76>>2],oA(n+16|0,o,t,(t-o|0)/40|0),o=n+32|0;break k}o=c9(N0,k+56|0)}i[e+108>>2]=o}if(t=i[k+72>>2],t){if(n=i[k+76>>2],h=t,(n|0)!=(t|0)){for(;o=i[n-16>>2],o&&(i[n-12>>2]=o,Z(o)),n=n-40|0,(t|0)!=(n|0););h=i[k+72>>2]}i[k+76>>2]=t,Z(h)}if($=$+1|0,($|0)==(I|0))break}if(l[r+20|0]==1){if(u[k+88|0]=0,u[k+99|0]=0,q(A,2,100,k+88|0),u[k+99|0]>=0)break e;Z(i[k+88>>2]);break e}if(e=i[26917],i[A>>2]=i[26916],i[A+4>>2]=e,e=A+8|0,u[107683]>=0){A=i[26919],i[e>>2]=i[26918],i[e+4>>2]=A,i[e+8>>2]=i[26920];break e}T(e,i[26918],i[26919]);break e}if(!r)break f;x(h,f,r)}u[r+h|0]=0,q(A,2,100,k+16|0),u[k+27|0]<0&&Z(i[k+16>>2]),i[k+88>>2]=Q,i[i[E>>2]+(k+88|0)>>2]=S,i[k+96>>2]=z,i[n>>2]=71232,u[k+143|0]<0&&Z(i[k+132>>2]),E0(n),y0(k+152|0)}if(A=i[k+72>>2],!A)break e;if(r=i[k+76>>2],n=A,(r|0)!=(n|0)){for(;e=i[r-16>>2],e&&(i[r-12>>2]=e,Z(e)),r=r-40|0,(A|0)!=(r|0););n=i[k+72>>2]}i[k+76>>2]=A,Z(n);break e}i[k+180>>2]=0,i[k+152>>2]=72196,i[k+96>>2]=72176,e=i[18053],i[k+88>>2]=e,t=k+88|0,i[t+i[e-12>>2]>>2]=i[18054],i[k+92>>2]=0,e=t+i[i[k+88>>2]-12>>2]|0,n=k+100|0,J0(e,n),u[e+80|0]=0,i[e+72>>2]=0,e=i[18055],i[k+96>>2]=e,r=k+96|0,i[r+i[e-12>>2]>>2]=i[18056],e=i[18052],i[k+88>>2]=e,i[t+i[e-12>>2]>>2]=i[18057],i[k+152>>2]=72196,i[k+88>>2]=72156,i[k+96>>2]=72176,n=R0(n),i[n>>2]=71232,i[k+140>>2]=0,i[k+144>>2]=0,i[k+132>>2]=0,i[k+136>>2]=0,i[k+148>>2]=24,Y(V0(Y(V0(Y(r,27595,18),I),28546,44),i[f+28>>2]),23873,7),e=i[k+148>>2];r:{f:{if(e&16){h=k+120|0,e=i[k+144>>2],r=i[k+124>>2],e>>>0<r>>>0&&(i[k+144>>2]=r,e=r);break f}if(!(e&8)){r=0,u[k+27|0]=0,h=k+16|0;break r}h=k+108|0,e=i[k+116>>2]}f:{if(f=i[h>>2],r=e-f|0,r>>>0<2147483640){if(r>>>0>=11){e=r|7,h=p(e+1|0),i[k+24>>2]=e-2147483647,i[k+16>>2]=h,i[k+20>>2]=r;break f}if(u[k+27|0]=r,h=k+16|0,r)break f;r=0;break r}break i}if(!r)break r;x(h,f,r)}u[r+h|0]=0,q(A,6,1e3,k+16|0),u[k+27|0]<0&&Z(i[k+16>>2]),A=i[18051],i[k+88>>2]=A,i[i[A-12>>2]+(k+88|0)>>2]=i[18059],i[k+96>>2]=i[18060],i[n>>2]=71232,u[k+143|0]<0&&Z(i[k+132>>2]),E0(n),y0(k+152|0)}v=k+256|0;return}Q0(),H()}function M7(A,e,r){var f=0,k=0,n=0,t=0,o=0,s=0,w=0,h=0,_=0,B=0,m=0,X=0,Q=0,V=0,F=0,I=0,E=0;f=v-192|0,v=f,k=i[r+52>>2],n=k?i[e+64>>2]:i[e+80>>2];i:{if(!(!k&&i[e+84>>2])&n>>>0<=u0[e+92>>2]){e=p(16),i[f+48>>2]=e,i[f+52>>2]=15,i[f+56>>2]=-2147483632,r=l[15286]|l[15287]<<8|(l[15288]<<16|l[15289]<<24),s=l[15282]|l[15283]<<8|(l[15284]<<16|l[15285]<<24),u[e+7|0]=s,u[e+8|0]=s>>>8,u[e+9|0]=s>>>16,u[e+10|0]=s>>>24,u[e+11|0]=r,u[e+12|0]=r>>>8,u[e+13|0]=r>>>16,u[e+14|0]=r>>>24,r=l[15279]|l[15280]<<8|(l[15281]<<16|l[15282]<<24),s=l[15275]|l[15276]<<8|(l[15277]<<16|l[15278]<<24),u[e|0]=s,u[e+1|0]=s>>>8,u[e+2|0]=s>>>16,u[e+3|0]=s>>>24,u[e+4|0]=r,u[e+5|0]=r>>>8,u[e+6|0]=r>>>16,u[e+7|0]=r>>>24,u[e+15|0]=0,e=q(f+120|0,13,0,f+48|0),r=i[e+4>>2],i[A>>2]=i[e>>2],i[A+4>>2]=r,r=A+8|0;e:{if(u[e+19|0]>=0){s=i[e+12>>2],i[r>>2]=i[e+8>>2],i[r+4>>2]=s,i[r+8>>2]=i[e+16>>2],u[A+20|0]=1;break e}if(T(r,i[e+8>>2],i[e+12>>2]),r=u[e+19|0],u[A+20|0]=1,(r|0)>=0)break e;Z(i[e+8>>2])}if(u[f+59|0]>=0)break i;Z(i[f+48>>2]);break i}Q=f+132|0,V=f+139|0,F=f+128|0,i[f+188>>2]=0,o=A+8|0,I=i[26678],E=i[26679];e:{r:{f:{A:{for(;;){k=i[e+68>>2],k=G(u0[e+88>>2]%((i[e+72>>2]-k|0)/48>>>0)|0,48)+k|0,m=i[k>>2],_=i[e+100>>2]+(i[k+8>>2]<<3)|0,k=i[_>>2],W[i[i[k>>2]+8>>2]](f+180|0,k);k:{if(i[e+88>>2]){k=i[f+180>>2],W[i[i[k>>2]+40>>2]](f+120|0,k,r,f+188|0,i[e+20>>2]- -64|0);n:{t:{u:{o:{l:{s:switch(l[f+140|0]){case 0:if(k=107664,!i[26916])break o;t=107676,h=107683,n=107672;break l;case 1:break s;default:break f}if(k=f+120|0,n=F,h=V,t=Q,!i[f+120>>2])break f}B=i[k+4>>2],i[A>>2]=i[k>>2],i[A+4>>2]=B;l:{if(u[h|0]>=0){k=i[n+4>>2],i[o>>2]=i[n>>2],i[o+4>>2]=k,i[o+8>>2]=i[n+8>>2];break l}T(o,i[n>>2],i[t>>2])}u[A+20|0]=1;break u}if(h=i[f+120>>2],h){t=i[f+124>>2],t&&(i[t+4>>2]=i[t+4>>2]+1);o:{if(!w||(s=i[w+4>>2],i[w+4>>2]=s-1,s))break o;W[i[i[w>>2]+8>>2]](w),y(w)}if(n=2,k=0,(i[e+92>>2]+1>>>0)%((i[e+72>>2]-i[e+68>>2]|0)/48>>>0)|0)break t;u[e+96|0]=0;break t}if(k=1,l[e+96|0]!=1){n=0;break n}k=p(32),i[f+168>>2]=k,i[f+172>>2]=25,i[f+176>>2]=-2147483616,u[k+24|0]=l[5386],n=l[5382]|l[5383]<<8|(l[5384]<<16|l[5385]<<24),t=l[5378]|l[5379]<<8|(l[5380]<<16|l[5381]<<24),u[k+16|0]=t,u[k+17|0]=t>>>8,u[k+18|0]=t>>>16,u[k+19|0]=t>>>24,u[k+20|0]=n,u[k+21|0]=n>>>8,u[k+22|0]=n>>>16,u[k+23|0]=n>>>24,n=l[5374]|l[5375]<<8|(l[5376]<<16|l[5377]<<24),t=l[5370]|l[5371]<<8|(l[5372]<<16|l[5373]<<24),u[k+8|0]=t,u[k+9|0]=t>>>8,u[k+10|0]=t>>>16,u[k+11|0]=t>>>24,u[k+12|0]=n,u[k+13|0]=n>>>8,u[k+14|0]=n>>>16,u[k+15|0]=n>>>24,n=l[5366]|l[5367]<<8|(l[5368]<<16|l[5369]<<24),t=l[5362]|l[5363]<<8|(l[5364]<<16|l[5365]<<24),u[k|0]=t,u[k+1|0]=t>>>8,u[k+2|0]=t>>>16,u[k+3|0]=t>>>24,u[k+4|0]=n,u[k+5|0]=n>>>8,u[k+6|0]=n>>>16,u[k+7|0]=n>>>24,u[k+25|0]=0,k=q(f+48|0,7,0,f+168|0),n=i[k+4>>2],i[A>>2]=i[k>>2],i[A+4>>2]=n;o:{if(u[f+67|0]>=0){k=i[f+60>>2],i[o>>2]=i[f+56>>2],i[o+4>>2]=k,i[o+8>>2]=i[f+64>>2],u[A+20|0]=1;break o}if(T(o,i[f+56>>2],i[f+60>>2]),k=u[f+67|0],u[A+20|0]=1,(k|0)>=0)break o;Z(i[f+56>>2])}u[f+179|0]<0&&Z(i[f+168>>2])}n=1,k=0;break n}s=h,w=t}if(t=l[f+140|0],(t|0)!=255&&(i[f+48>>2]=I,i[f+52>>2]=E,W[i[(f+48|0)+(t<<2)>>2]](f+168|0,f+120|0)),!k)break k;k=i[e+88>>2]}else k=0;n:{t:{if(n=i[e+84>>2],!n&u0[e+80>>2]>k>>>0|n){if(At(f+120|0,i[_>>2],m),B=i[f+120>>2],i[f+72>>2]=B,t=i[f+124>>2],i[f+76>>2]=t,t&&(i[t+4>>2]=i[t+4>>2]+1),k=i[f+180>>2],i[f+92>>2]=0,i[f+84>>2]=0,i[f+88>>2]=0,u[f+80|0]=l[f+128|0],n=i[f+136>>2],h=i[f+132>>2],(n|0)!=(h|0)){if(n=n-h|0,(n|0)<0)break A;_=p(n),i[f+84>>2]=_,X=n+_|0,i[f+92>>2]=X,n&&x(_,h,n),i[f+88>>2]=X}n=i[f+148>>2],i[f+96>>2]=i[f+144>>2],i[f+100>>2]=n,i[f+112>>2]=i[f+160>>2],n=i[f+156>>2],i[f+104>>2]=i[f+152>>2],i[f+108>>2]=n,i[f+72>>2]=0,i[f+76>>2]=0,i[k+8>>2]=B,n=i[k+12>>2],i[k+12>>2]=t;u:{if(!n||(t=i[n+4>>2],i[n+4>>2]=t-1,t))break u;W[i[i[n>>2]+8>>2]](n),y(n)}u[k+16|0]=l[f+80|0],n=i[k+20>>2],n&&(i[k+24>>2]=n,Z(n)),i[k+20>>2]=i[f+84>>2],i[k+24>>2]=i[f+88>>2],i[k+28>>2]=i[f+92>>2],i[f+92>>2]=0,i[f+84>>2]=0,i[f+88>>2]=0,i[k+48>>2]=i[f+112>>2],n=i[f+108>>2],i[k+40>>2]=i[f+104>>2],i[k+44>>2]=n,n=i[f+100>>2],i[k+32>>2]=i[f+96>>2],i[k+36>>2]=n,k=i[f+76>>2];u:{if(!k||(n=i[k+4>>2],i[k+4>>2]=n-1,n))break u;W[i[i[k>>2]+8>>2]](k),y(k)}if(i[e+88>>2]=i[e+88>>2]+1,k=i[f+180>>2],W[i[i[k>>2]+32>>2]](f+48|0,k,!m,r,m,i[e+20>>2]- -64|0),!i[f+48>>2])break t;k=i[f+52>>2],i[A>>2]=i[f+48>>2],i[A+4>>2]=k;u:{if(u[f+67|0]>=0){k=i[f+60>>2],i[o>>2]=i[f+56>>2],i[o+4>>2]=k,i[o+8>>2]=i[f+64>>2],u[A+20|0]=1;break u}if(T(o,i[f+56>>2],i[f+60>>2]),k=u[f+67|0],u[A+20|0]=1,(k|0)>=0)break u;Z(i[f+56>>2])}k=i[f+132>>2],k&&(i[f+136>>2]=k,Z(k)),k=i[f+124>>2];u:{if(!k||(n=i[k+4>>2],i[k+4>>2]=n-1,n))break u;W[i[i[k>>2]+8>>2]](k),y(k)}n=1;break k}k=i[f+180>>2],W[i[i[k>>2]+36>>2]](f+120|0,k),k=i[f+120>>2];u:{if(k){if(n=i[f+124>>2],i[A>>2]=i[f+120>>2],i[A+4>>2]=n,u[f+139|0]>=0){n=i[f+132>>2],i[o>>2]=i[f+128>>2],i[o+4>>2]=n,i[o+8>>2]=i[f+136>>2],u[A+20|0]=1;break u}T(o,i[f+128>>2],i[f+132>>2]),u[A+20|0]=1;break u}u[e+96|0]=1}if(u[f+139|0]<0&&Z(i[f+128>>2]),n=1,!k)break n;break k}if(u[f+67|0]<0&&Z(i[f+56>>2]),k=i[f+132>>2],k&&(i[f+136>>2]=k,Z(k)),k=i[f+124>>2],!k||(n=i[k+4>>2],i[k+4>>2]=n-1,n))break n;W[i[i[k>>2]+8>>2]](k),y(k)}n=0}k=i[f+184>>2];k:{if(!k||(t=i[k+4>>2],i[k+4>>2]=t-1,t))break k;W[i[i[k>>2]+8>>2]](k),y(k)}if(n)break}if((n|0)!=2)break e;if(k=i[e+204>>2],k&&(t=i[k+108>>2],k=i[k+104>>2],(t|0)==(k|0)?k=0:k=i[k+4>>2],i[s+144>>2]=k),k=i[e+320>>2],k){M7(f+120|0,k,r),k=l[f+140|0];k:{if(k){if((k|0)!=1)break f;r=i[f+124>>2],i[A>>2]=i[f+120>>2],i[A+4>>2]=r;n:{if(u[f+139|0]>=0){r=i[f+132>>2],i[o>>2]=i[f+128>>2],i[o+4>>2]=r,i[o+8>>2]=i[f+136>>2];break n}T(o,i[f+128>>2],i[f+132>>2])}u[A+20|0]=1;break k}if(i[f+48>>2]=i[f+120>>2],r=i[f+124>>2],i[f+52>>2]=r,r&&(i[r+4>>2]=i[r+4>>2]+1),J9(s,f+48|0,0),r=i[f+52>>2],!r||(n=i[r+4>>2],i[r+4>>2]=n-1,n))break k;W[i[i[r>>2]+8>>2]](r),y(r)}if(r=l[f+140|0],(r|0)!=255&&(n=i[26679],i[f+48>>2]=i[26678],i[f+52>>2]=n,W[i[(f+48|0)+(r<<2)>>2]](f+168|0,f+120|0)),k)break e}if(k=i[e+276>>2],k){r=i[e+20>>2],i[f+48>>2]=i[r+48>>2],r=i[r+52>>2],i[f+52>>2]=r,r&&(i[r+4>>2]=i[r+4>>2]+1),ri(f+120|0,k,i[f+48>>2],i[f+188>>2]),r=i[f+52>>2];k:{if(!r||(k=i[r+4>>2],i[r+4>>2]=k-1,k))break k;W[i[i[r>>2]+8>>2]](r),y(r)}k:switch(l[f+140|0]){case 1:e=i[f+124>>2],i[A>>2]=i[f+120>>2],i[A+4>>2]=e;n:{if(u[f+139|0]>=0){e=i[f+132>>2],i[o>>2]=i[f+128>>2],i[o+4>>2]=e,i[o+8>>2]=i[f+136>>2],e=1,u[A+20|0]=1;break n}if(T(o,i[f+128>>2],i[f+132>>2]),e=l[f+140|0],u[A+20|0]=1,(e|0)==255)break e}A=i[26683],i[f+48>>2]=i[26682],i[f+52>>2]=A,W[i[(f+48|0)+(e<<2)>>2]](f+168|0,f+120|0);break e;case 0:break k;default:break f}If(f+48|0,f+120|0),r=l[f+68|0];k:{if(r){if((r|0)!=1)break f;k=i[f+52>>2],i[A>>2]=i[f+48>>2],i[A+4>>2]=k;n:{if(u[f+67|0]>=0){k=i[f+60>>2],i[o>>2]=i[f+56>>2],i[o+4>>2]=k,i[o+8>>2]=i[f+64>>2];break n}T(o,i[f+56>>2],i[f+60>>2])}u[A+20|0]=1;break k}n:{if(u[f+59|0]>=0){i[f+40>>2]=i[f+56>>2],k=i[f+52>>2],i[f+32>>2]=i[f+48>>2],i[f+36>>2]=k;break n}T(f+32|0,i[f+48>>2],i[f+52>>2])}if(W[i[i[s>>2]+36>>2]](s,f+32|0),u[f+43|0]>=0)break k;Z(i[f+32>>2])}if(k=l[f+68|0],(k|0)!=255&&(n=i[26681],i[f+168>>2]=i[26680],i[f+172>>2]=n,W[i[(f+168|0)+(k<<2)>>2]](f+180|0,f+48|0)),k=l[f+140|0],(k|0)!=255&&(n=i[26683],i[f+48>>2]=i[26682],i[f+52>>2]=n,W[i[(f+48|0)+(k<<2)>>2]](f+168|0,f+120|0)),r)break e}k=i[e+272>>2];k:{if(!k)break k;r=i[e+20>>2],i[f+120>>2]=i[r+48>>2],r=i[r+52>>2],i[f+124>>2]=r,r&&(i[r+4>>2]=i[r+4>>2]+1),ri(f+48|0,k,i[f+120>>2],i[f+188>>2]),r=i[f+124>>2];n:{if(!r||(k=i[r+4>>2],i[r+4>>2]=k-1,k))break n;W[i[i[r>>2]+8>>2]](r),y(r)}n:switch(l[f+68|0]){case 1:e=i[f+52>>2],i[A>>2]=i[f+48>>2],i[A+4>>2]=e;t:{if(u[f+67|0]>=0){e=i[f+60>>2],i[o>>2]=i[f+56>>2],i[o+4>>2]=e,i[o+8>>2]=i[f+64>>2],k=1;break t}T(o,i[f+56>>2],i[f+60>>2]),k=l[f+68|0]}u[A+20|0]=1;break r;case 0:break n;default:break f}n:{if(i[f+48>>2]==i[f+52>>2]){k=0;break n}k=f+120|0,$9(k,f+48|0),r=l[f+144|0];t:{if(r){if((r|0)!=1)break f;D6(A,k);break t}if(W[i[i[s>>2]+32>>2]](f+12|0,s,f+120|0),u[f+31|0]>=0)break t;Z(i[f+20>>2])}if(k=l[f+144|0],(k|0)!=255&&(n=i[26685],i[f+168>>2]=i[26684],i[f+172>>2]=n,W[i[(f+168|0)+(k<<2)>>2]](f+180|0,f+120|0)),k=l[f+68|0],r)break r;if((k&255)==255)break k}r=i[26683],i[f+120>>2]=i[26682],i[f+124>>2]=r,W[i[(f+120|0)+((k&255)<<2)>>2]](f+168|0,f+48|0)}i[e+92>>2]=i[e+92>>2]+1,u[A+20|0]=0,i[A+4>>2]=w,i[A>>2]=s;break i}G0(),H()}_2(),H()}if(A=k&255,(A|0)==255)break e;e=i[26683],i[f+120>>2]=i[26682],i[f+124>>2]=e,W[i[(f+120|0)+(A<<2)>>2]](f+168|0,f+48|0)}if(!w||(A=i[w+4>>2],i[w+4>>2]=A-1,A))break i;W[i[i[w>>2]+8>>2]](w),y(w)}v=f+192|0}function iB(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,t=0,o=0,s=0,w=0,h=0,_=0,B=0,m=0,X=0,Q=0,V=0,F=0,I=0,E=0;for(f=v-176|0,v=f,i[f+88>>2]=0,i[f+60>>2]=72500,k=i[18128],i[f+4>>2]=k,n=i[k-12>>2],k=f+4|0,i[n+k>>2]=i[18129],n=k+i[i[f+4>>2]-12>>2]|0,t=f+8|0,J0(n,t),u[n+80|0]=0,i[n+72>>2]=0,i[f+60>>2]=72500,i[f+4>>2]=72480,m=R0(t),i[m>>2]=71232,i[f+48>>2]=0,i[f+52>>2]=0,i[f+40>>2]=0,i[f+44>>2]=0,i[f+56>>2]=16,n=f+164|0,Y2(n,e,r),t=k,o=n,k=u[f+175|0],n=(k|0)<0,Y(t,n?i[f+164>>2]:o,n?i[f+168>>2]:k),u[f+175|0]<0&&Z(i[f+164>>2]),k=f+164|0,s0(k,r),t=k,k=u[f+175|0],n=(k|0)<0,Y(f+4|0,n?i[f+164>>2]:t,n?i[f+168>>2]:k),u[f+175|0]<0&&Z(i[f+164>>2]),k=Y(S0(Y(f+4|0,30746,23),l[e+100|0]),42670,1),n=f+164|0,s0(n,r),o=n,n=u[f+175|0],t=(n|0)<0,Y(k,t?i[f+164>>2]:o,t?i[f+168>>2]:n),u[f+175|0]<0&&Z(i[f+164>>2]),k=Y(S0(Y(k,32047,23),l[e+101|0]),42670,1),n=f+164|0,s0(n,r),o=n,n=u[f+175|0],t=(n|0)<0,Y(k,t?i[f+164>>2]:o,t?i[f+168>>2]:n),u[f+175|0]<0&&Z(i[f+164>>2]),k=Y(li(Y(k,31094,19),l[e+102|0]),42670,1),n=f+164|0,s0(n,r),o=n,n=u[f+175|0],t=(n|0)<0,Y(k,t?i[f+164>>2]:o,t?i[f+168>>2]:n),u[f+175|0]<0&&Z(i[f+164>>2]),Y(S0(Y(k,32322,21),l[e+103|0]),42670,1),k=f+164|0,s0(k,r),t=k,k=u[f+175|0],n=(k|0)<0,Y(f+4|0,n?i[f+164>>2]:t,n?i[f+168>>2]:k),u[f+175|0]<0&&Z(i[f+164>>2]),Y(f+4|0,29983,37),k=0;;){n=f+4|0,V0(n,i[e+104>>2]>>>31-k&1);i:{if((k&7)==7){u[f+164|0]=32,Y(n,f+164|0,1);break i}if((k&3)!=3)break i;u[f+164|0]=46,Y(f+4|0,f+164|0,1)}if(k=k+1|0,(k|0)==32)break}for(n=f+4|0,Y(n,42670,1),t=f+164|0,s0(t,r),k=0,o=n,s=t,n=u[f+175|0],t=(n|0)<0,Y(o,t?i[f+164>>2]:s,t?i[f+168>>2]:n),u[f+175|0]<0&&Z(i[f+164>>2]),Y(f+4|0,30021,36),n=e+108|0;t=f+4|0,S0(t,i[n+(k>>>3&536870908)>>2]>>>k&1),k=k+1|0,k&7||(u[f+164|0]=32,Y(t,f+164|0,1)),(k|0)!=48;);k=f+4|0,Y(k,42670,1),n=f+164|0,s0(n,r),t=k,o=n,k=u[f+175|0],n=(k|0)<0,Y(t,n?i[f+164>>2]:o,n?i[f+168>>2]:k),u[f+175|0]<0&&Z(i[f+164>>2]),k=Y(S0(Y(f+4|0,32302,19),l[e+116|0]),42670,1),n=f+164|0,s0(n,r),o=n,n=u[f+175|0],t=(n|0)<0,Y(k,t?i[f+164>>2]:o,t?i[f+168>>2]:n),u[f+175|0]<0&&Z(i[f+164>>2]),k=Y(V0(Y(k,32271,30),C[e+118>>1]),42670,1),n=f+164|0,s0(n,r),o=n,n=u[f+175|0],t=(n|0)<0,Y(k,t?i[f+164>>2]:o,t?i[f+168>>2]:n),u[f+175|0]<0&&Z(i[f+164>>2]),k=Y(S0(Y(k,31623,18),l[e+120|0]),42670,1),n=f+164|0,s0(n,r),o=n,n=u[f+175|0],t=(n|0)<0,Y(k,t?i[f+164>>2]:o,t?i[f+168>>2]:n),u[f+175|0]<0&&Z(i[f+164>>2]),Y(k,29726,15);i:{e:{r:{f:{A:{k:switch(k=l[e+121|0],k|0){case 0:break k;case 1:break A;case 2:break f;case 3:break r;default:break e}Y(f+4|0,13028,10);break i}Y(f+4|0,21999,5);break i}Y(f+4|0,21556,5);break i}Y(f+4|0,21364,5);break i}S0(f+4|0,k)}k=Y(f+4|0,42670,1),n=f+164|0,s0(n,r),o=n,n=u[f+175|0],t=(n|0)<0,Y(k,t?i[f+164>>2]:o,t?i[f+168>>2]:n),u[f+175|0]<0&&Z(i[f+164>>2]),k=Y(S0(Y(k,32372,16),l[e+122|0]),42670,1),n=f+164|0,s0(n,r),o=n,n=u[f+175|0],t=(n|0)<0,Y(k,t?i[f+164>>2]:o,t?i[f+168>>2]:n),u[f+175|0]<0&&Z(i[f+164>>2]),k=Y(S0(Y(k,32406,18),l[e+123|0]),42670,1),n=f+164|0,s0(n,r),o=n,n=u[f+175|0],t=(n|0)<0,Y(k,t?i[f+164>>2]:o,t?i[f+168>>2]:n),u[f+175|0]<0&&Z(i[f+164>>2]),k=Y(V0(Y(k,31460,16),C[e+124>>1]),42670,1),n=f+164|0,s0(n,r),o=n,n=u[f+175|0],t=(n|0)<0,Y(k,t?i[f+164>>2]:o,t?i[f+168>>2]:n),u[f+175|0]<0&&Z(i[f+164>>2]),k=Y(S0(Y(k,31438,21),l[e+126|0]),42670,1),n=f+164|0,s0(n,r),o=n,n=u[f+175|0],t=(n|0)<0,Y(k,t?i[f+164>>2]:o,t?i[f+168>>2]:n),u[f+175|0]<0&&Z(i[f+164>>2]),k=Y(S0(Y(k,29882,21),l[e+127|0]),42670,1),n=f+164|0,s0(n,r),o=n,n=u[f+175|0],t=(n|0)<0,Y(k,t?i[f+164>>2]:o,t?i[f+168>>2]:n),u[f+175|0]<0&&Z(i[f+164>>2]),k=Y(S0(Y(k,32160,20),l[e+128|0]),42670,1),n=f+164|0,s0(n,r),o=n,n=u[f+175|0],t=(n|0)<0,Y(k,t?i[f+164>>2]:o,t?i[f+168>>2]:n),u[f+175|0]<0&&Z(i[f+164>>2]),Y(S0(Y(k,31208,13),l[e+129|0]),42670,1);i:{if(_=i[e+132>>2],F=i[e+136>>2],(_|0)!=(F|0))for(E=f+16|0;;){e=f+164|0,s0(e,r),n=e,e=u[f+175|0],k=(e|0)<0,Y(f+4|0,k?i[f+164>>2]:n,k?i[f+168>>2]:e),u[f+175|0]<0&&Z(i[f+164>>2]),e=f+4|0,Y(e,41748,8),i[r>>2]=i[r>>2]+1,k=f+164|0,s0(k,r),n=e,t=k,e=u[f+175|0],k=(e|0)<0,Y(n,k?i[f+164>>2]:t,k?i[f+168>>2]:e),u[f+175|0]<0&&Z(i[f+164>>2]),e=Y(S0(Y(f+4|0,29824,20),l[_|0]),42670,1),k=f+164|0,s0(k,r),t=k,k=u[f+175|0],n=(k|0)<0,Y(e,n?i[f+164>>2]:t,n?i[f+168>>2]:k),u[f+175|0]<0&&Z(i[f+164>>2]),Y(S0(Y(e,31562,15),l[_+1|0]),42670,1);e:{if(B=i[_+4>>2],I=i[_+8>>2],(B|0)==(I|0))break e;for(;;){s0(f+144|0,r),t=u[f+155|0],o=i[f+144>>2],h=i[f+148>>2],e=f+4|0,X=G1(f+156|0,e);r:{if(l[X|0]!=1)break r;e=e+i[i[f+4>>2]-12>>2]|0,V=i[e+4>>2],s=i[e+24>>2];f:{if(l[e+80|0]==1){k=l[e+76|0]|l[e+77|0]<<8|(l[e+78|0]<<16|l[e+79|0]<<24);break f}n=f+164|0,k=i[e+28>>2],i[n>>2]=k,(k|0)!=129576&&(i[k+4>>2]=i[k+4>>2]+1),k=c0(n,129760),k=W[i[i[k>>2]+28>>2]](k,32)|0,e2(n),u[e+76|0]=k,u[e+77|0]=k>>>8,u[e+78|0]=k>>>16,u[e+79|0]=k>>>24,u[e+80|0]=1}f:{if(!s||(w=i[e+12>>2],n=o,o=(t|0)<0,n=o?n:f+144|0,t=o?h:t,Q=n+t|0,o=(V&176)==32?Q:n,h=o-n|0,(h|0)>0&&(W[i[i[s>>2]+48>>2]](s,n,h)|0)!=(h|0)))break f;if(t=(t|0)<(w|0)?w-t|0:0,(t|0)>0){if(t>>>0>=2147483640)break i;A:{if(t>>>0>=11){w=t|7,n=p(w+1|0),i[f+172>>2]=w-2147483647,i[f+164>>2]=n,i[f+168>>2]=t;break A}u[f+175|0]=t,n=f+164|0}if(t&&o0(n,k,t),u[n+t|0]=0,k=W[i[i[s>>2]+48>>2]](s,u[f+175|0]<0?i[f+164>>2]:f+164|0,t)|0,u[f+175|0]<0&&Z(i[f+164>>2]),(k|0)!=(t|0))break f}if(k=Q-o|0,(k|0)>0&&(W[i[i[s>>2]+48>>2]](s,o,k)|0)!=(k|0))break f;i[e+12>>2]=0;break r}e=i[i[f+4>>2]-12>>2]+(f+4|0)|0,H1(e,i[e+16>>2]|5)}if(_1(X),u[f+155|0]<0&&Z(i[f+144>>2]),e=i[B>>2],X=i[B+4>>2],(e|0)!=(X|0))for(;;){s=l[e|0],n=i[f+4>>2],k=i[n-12>>2]+(f+4|0)|0,l[k+80|0]||(t=f+164|0,n=i[k+28>>2],i[t>>2]=n,(n|0)!=129576&&(i[n+4>>2]=i[n+4>>2]+1),n=c0(t,129760),W[i[i[n>>2]+28>>2]](n,32)|0,e2(t),n=i[f+4>>2]),u[k+76|0]=48,u[k+77|0]=0,u[k+78|0]=0,u[k+79|0]=0,u[k+80|0]=1,k=n-12|0,i[i[k>>2]+E>>2]=2,k=i[k>>2]+m|0,i[k>>2]=i[k>>2]&-75|8,o=S0(f+4|0,s),V=G1(f+144|0,o);r:{if(l[V|0]!=1)break r;n=o+i[i[o>>2]-12>>2]|0,h=i[n+4>>2],s=i[n+24>>2];f:{if(l[n+80|0]==1){w=l[n+76|0]|l[n+77|0]<<8|(l[n+78|0]<<16|l[n+79|0]<<24);break f}t=f+164|0,k=i[n+28>>2],i[t>>2]=k,(k|0)!=129576&&(i[k+4>>2]=i[k+4>>2]+1),k=c0(t,129760),w=W[i[i[k>>2]+28>>2]](k,32)|0,e2(t),u[n+76|0]=w,u[n+77|0]=w>>>8,u[n+78|0]=w>>>16,u[n+79|0]=w>>>24,u[n+80|0]=1}f:{if(!s||(k=i[n+12>>2],h=(h&176)==32?32809:32808,t=h-32808|0,(t|0)>0&&(W[i[i[s>>2]+48>>2]](s,32808,t)|0)!=(t|0)))break f;if((k|0)>=2){if(k>>>0>=2147483641)break i;t=((k|0)<=1?1:k)-1|0;A:{if(k>>>0>=12){Q=t|7,k=p(Q+1|0),i[f+172>>2]=Q-2147483647,i[f+164>>2]=k,i[f+168>>2]=t;break A}u[f+175|0]=t,k=f+164|0}if(t&&o0(k,w,t),u[k+t|0]=0,k=W[i[i[s>>2]+48>>2]](s,u[f+175|0]<0?i[f+164>>2]:f+164|0,t)|0,u[f+175|0]<0&&Z(i[f+164>>2]),(k|0)!=(t|0))break f}if(k=32809-h|0,(k|0)>0&&(W[i[i[s>>2]+48>>2]](s,h,k)|0)!=(k|0))break f;i[n+12>>2]=0;break r}k=o+i[i[o>>2]-12>>2]|0,H1(k,i[k+16>>2]|5)}if(_1(V),e=e+1|0,(X|0)==(e|0))break}r:{e=f+4|0,o=G1(f+144|0,e);f:{if(l[o|0]!=1)break f;e=e+i[i[f+4>>2]-12>>2]|0,t=i[e+4>>2],s=i[e+24>>2];A:{if(l[e+80|0]==1){k=l[e+76|0]|l[e+77|0]<<8|(l[e+78|0]<<16|l[e+79|0]<<24);break A}n=f+164|0,k=i[e+28>>2],i[n>>2]=k,(k|0)!=129576&&(i[k+4>>2]=i[k+4>>2]+1),k=c0(n,129760),k=W[i[i[k>>2]+28>>2]](k,32)|0,e2(n),u[e+76|0]=k,u[e+77|0]=k>>>8,u[e+78|0]=k>>>16,u[e+79|0]=k>>>24,u[e+80|0]=1}A:{if(!s||(n=i[e+12>>2],w=(t&176)==32?42671:42670,t=w-42670|0,(t|0)>0&&(W[i[i[s>>2]+48>>2]](s,42670,t)|0)!=(t|0)))break A;if((n|0)>=2){if(n>>>0>=2147483641)break r;t=((n|0)<=1?1:n)-1|0;k:{if(n>>>0>=12){h=t|7,n=p(h+1|0),i[f+172>>2]=h-2147483647,i[f+164>>2]=n,i[f+168>>2]=t;break k}u[f+175|0]=t,n=f+164|0}if(t&&o0(n,k,t),u[n+t|0]=0,k=W[i[i[s>>2]+48>>2]](s,u[f+175|0]<0?i[f+164>>2]:f+164|0,t)|0,u[f+175|0]<0&&Z(i[f+164>>2]),(k|0)!=(t|0))break A}if(k=42671-w|0,(k|0)>0&&(W[i[i[s>>2]+48>>2]](s,w,k)|0)!=(k|0))break A;i[e+12>>2]=0;break f}e=i[i[f+4>>2]-12>>2]+(f+4|0)|0,H1(e,i[e+16>>2]|5)}if(_1(o),e=i[i[f+4>>2]-12>>2]+m|0,i[e>>2]=i[e>>2]&-75|2,B=B+12|0,(I|0)==(B|0))break e;continue}break}break i}if(e=i[r>>2],i[r>>2]=((e|0)<=1?1:e)-1,_=_+16|0,(F|0)==(_|0))break}e=i[f+56>>2];e:{r:{if(e&16){k=i[f+52>>2],e=i[f+32>>2],k>>>0<e>>>0&&(i[f+52>>2]=e,k=e),e=f+28|0;break r}if(!(e&8)){k=0,u[A+11|0]=0;break e}k=i[f+24>>2],e=f+16|0}r:{if(r=i[e>>2],k=k-r|0,k>>>0<2147483640){if(k>>>0>=11){n=k|7,e=p(n+1|0),i[A+8>>2]=n-2147483647,i[A>>2]=e,i[A+4>>2]=k,A=e;break r}if(u[A+11|0]=k,k)break r;k=0;break e}Q0(),H()}if(!k)break e;x(A,r,k)}u[A+k|0]=0,A=i[18127],i[f+4>>2]=A,i[i[A-12>>2]+(f+4|0)>>2]=i[18130],i[m>>2]=71232,u[f+51|0]<0&&Z(i[f+40>>2]),E0(m),y0(f+60|0),v=f+176|0;return}Q0(),H()}function eB(A,e,r,f,k,n,t,o){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,t=t|0,o=o|0;var s=0,w=0,h=U(0),_=0,B=0,m=0,X=0,Q=0,V=0,F=0,I=0,E=0,R=0,N=0,M=0,z=0,S=0,O=0,P=0,a=0,$=0,f0=0,A0=0,n0=U(0),_0=U(0),m0=U(0),X0=0,g0=0,I0=0,e0=0,r0=0,N0=0,U0=0,M0=0,H0=0,P0=0,K0=0,$0=0,L0=0,d0=U(0),n2=U(0),Z2=U(0);s=v-160|0,v=s,e=i[r>>2],X=i[e+112>>2],_=i[e+108>>2],n=i[k+4>>2],f=n>>>0<4,t=n<<3,Q=(f?16908801>>>t|0:0)&3,N=(f?16843265>>>t|0:0)&3;i:{if((j0(e,3)|0)!=8){e=i[26922],i[A>>2]=i[26921],i[A+4>>2]=e,r=A+8|0;e:{if(u[107703]>=0){e=i[26924],i[r>>2]=i[26923],i[r+4>>2]=e,i[r+8>>2]=i[26925];break e}T(r,i[26923],i[26924])}u[A+20|0]=1;break i}e:{if(S=u1(i[r>>2],6),!S||(j0(i[r>>2],6)|0)==8)break e;e=i[26922],i[A>>2]=i[26921],i[A+4>>2]=e,r=A+8|0;r:{if(u[107703]>=0){e=i[26924],i[r>>2]=i[26923],i[r+4>>2]=e,i[r+8>>2]=i[26925];break r}T(r,i[26923],i[26924])}u[A+20|0]=1;break i}R=p(172),w=R,i[w+4>>2]=0,i[w+8>>2]=0,i[w>>2]=94812,o0(w+16|0,0,80),e=i[w+4>>2],f=e+1|0,i[w+4>>2]=f,i[w+104>>2]=0,i[w+108>>2]=0,i[w+36>>2]=1,i[w+40>>2]=1,u[w+24|0]=1,g[w+22>>1]=2,g[w+18>>1]=2,g[w+20>>1]=2,i[w+112>>2]=0,i[w+116>>2]=4740,i[w+140>>2]=0,i[w+144>>2]=0,i[w+128>>2]=99,i[w+132>>2]=99,i[w+120>>2]=0,i[w+124>>2]=0,i[w+12>>2]=95160,i[w+148>>2]=0,i[w+152>>2]=0,t=w+140|0,i[w+136>>2]=t,i[w+156>>2]=0,i[w+160>>2]=0,i[w+164>>2]=0,i[w+168>>2]=0,i[w+4>>2]=e,e=i[w+8>>2],F=w+12|0,i[w+96>>2]=F,i[w+8>>2]=e+1,i[w+100>>2]=w,f||(W[i[i[w>>2]+8>>2]](w),y(w)),i[F+120>>2]=n,i[F+116>>2]=0,i[F+112>>2]=X,i[F+108>>2]=_,T0(s+136|0,F,0,_,X,8,o),n=((_+Q|0)-1>>>0)/(Q>>>0)|0,f=((X+N|0)-1>>>0)/(N>>>0)|0,T0(s+112|0,F,1,n,f,8,o),w=s+16|0;e:{if(i[s+136>>2]){if(e=i[s+140>>2],i[s+8>>2]=i[s+136>>2],i[s+12>>2]=e,u[s+155|0]>=0){e=i[s+148>>2],i[w>>2]=i[s+144>>2],i[w+4>>2]=e,i[w+8>>2]=i[s+152>>2];break e}T(w,i[s+144>>2],i[s+148>>2]);break e}if(e=i[s+116>>2],i[s+8>>2]=i[s+112>>2],i[s+12>>2]=e,u[s+131|0]>=0){e=i[s+124>>2],i[w>>2]=i[s+120>>2],i[w+4>>2]=e,i[w+8>>2]=i[s+128>>2];break e}T(w,i[s+120>>2],i[s+124>>2])}T0(s+88|0,F,2,n,f,8,o),f=s+56|0;e:{if(i[s+8>>2]){if(e=i[s+12>>2],i[s+48>>2]=i[s+8>>2],i[s+52>>2]=e,u[s+27|0]>=0){e=i[w+4>>2],i[f>>2]=i[w>>2],i[f+4>>2]=e,i[f+8>>2]=i[w+8>>2];break e}T(f,i[s+16>>2],i[s+20>>2]);break e}if(e=i[s+92>>2],i[s+48>>2]=i[s+88>>2],i[s+52>>2]=e,u[s+107|0]>=0){e=i[s+100>>2],i[f>>2]=i[s+96>>2],i[f+4>>2]=e,i[f+8>>2]=i[s+104>>2];break e}T(f,i[s+96>>2],i[s+100>>2])}u[s+107|0]<0&&Z(i[s+96>>2]),u[s+27|0]<0&&Z(i[s+16>>2]),u[s+131|0]<0&&Z(i[s+120>>2]),u[s+155|0]<0&&Z(i[s+144>>2]);e:{if(i[s+48>>2]){if(e=i[s+52>>2],i[A>>2]=i[s+48>>2],i[A+4>>2]=e,r=A+8|0,u[s+67|0]>=0){e=i[f+4>>2],i[r>>2]=i[f>>2],i[r+4>>2]=e,i[r+8>>2]=i[f+8>>2],u[A+20|0]=1;break e}if(T(r,i[s+56>>2],i[s+60>>2]),e=u[s+67|0],u[A+20|0]=1,(e|0)>=0)break e;Z(i[s+56>>2]);break e}u[s+67|0]<0&&Z(i[s+56>>2]);r:{if(!S)break r;if(T0(s+48|0,F,6,_,X,8,o),i[s+48>>2]){if(e=i[s+52>>2],i[A>>2]=i[s+48>>2],i[A+4>>2]=e,r=A+8|0,u[s+67|0]>=0){e=i[s+60>>2],i[r>>2]=i[s+56>>2],i[r+4>>2]=e,i[r+8>>2]=i[s+64>>2],u[A+20|0]=1;break e}if(T(r,i[s+56>>2],i[s+60>>2]),e=u[s+67|0],u[A+20|0]=1,(e|0)>=0)break e;Z(i[s+56>>2]);break e}if(u[s+67|0]>=0)break r;Z(i[s+56>>2])}e=i[r>>2],n=e+128|0;r:{f:{if(o=i[e+128>>2],o){for(f=n,e=o;w=i[e+16>>2]<3,f=w?f:e,e=i[(w?4:0)+e>>2],!!e;);e=0;A:{if((f|0)==(n|0)||(e=0,i[f+16>>2]>3))break A;X0=i[f+56>>2],e=i[f+44>>2]}for(O=e,f=n,e=o;w=i[e+16>>2]<4,f=w?f:e,e=i[(w?4:0)+e>>2],!!e;);e=0;A:{if((f|0)==(n|0)||(e=0,i[f+16>>2]>4))break A;g0=i[f+56>>2],e=i[f+44>>2]}for(I0=e,f=n,e=o;w=i[e+16>>2]<5,f=w?f:e,e=i[(w?4:0)+e>>2],!!e;);if((f|0)!=(n|0))break f}e=0;break r}if(e=0,i[f+16>>2]>5)break r;e0=i[f+56>>2],e=i[f+44>>2]}r0=e;r:{f:{if(f=i[t>>2],f){for(w=t,e=f;V=i[e+16>>2],w=(V|0)<0?w:e,e=i[(V>>>29&4)+e>>2],!!e;);I=0;A:{if((t|0)==(w|0)||(I=0,i[w+16>>2]>0))break A;P=i[w+44>>2],I=i[w+56>>2]}for(w=t,e=f;V=i[e+16>>2]<=0,w=V?w:e,e=i[(V?4:0)+e>>2],!!e;);V=0;A:{if((t|0)==(w|0)||(V=0,i[w+16>>2]>1))break A;L0=i[w+56>>2],V=i[w+44>>2]}for(w=t,e=f;E=i[e+16>>2]<2,w=E?w:e,e=i[(E?4:0)+e>>2],!!e;);if((t|0)!=(w|0))break f}E=0;break r}if(E=0,i[w+16>>2]>2)break r;$0=i[w+56>>2],E=i[w+44>>2]}w=0;r:{if(!S)break r;f:{A:{if(!o)break A;for(e=n;w=i[o+16>>2]<6,e=w?e:o,o=i[(w?4:0)+o>>2],!!o;);if((e|0)==(n|0))break A;if(n=0,i[e+16>>2]>6)break f;N0=i[e+44>>2],n=i[e+56>>2];break f}n=0}if(U0=n,w=0,!f)break r;for(e=t;n=i[f+16>>2]<6,e=n?e:f,f=i[(n?4:0)+f>>2],!!f;);if(w=0,(e|0)==(t|0)||(w=0,i[e+16>>2]>6))break r;M0=i[e+56>>2],w=i[e+44>>2]}if(t=w,i[s+84>>2]=-1113159960,i[s+76>>2]=1056964608,i[s+80>>2]=-1093247418,i[s+68>>2]=-1096180881,i[s+72>>2]=1056964608,i[s+60>>2]=1038710997,i[s+64>>2]=-1104361250,i[s+52>>2]=1050220167,i[s+56>>2]=1058424226,u[s+48|0]=1,a=l[k+22|0],H0=C[k+20>>1],Nr(s+8|0,H0,C[k+16>>1]),e=i[s+44>>2],i[s+80>>2]=i[s+40>>2],i[s+84>>2]=e,e=i[s+36>>2],i[s+72>>2]=i[s+32>>2],i[s+76>>2]=e,e=i[s+28>>2],f=s- -64|0,i[f>>2]=i[s+24>>2],i[f+4>>2]=e,e=i[s+20>>2],i[s+56>>2]=i[s+16>>2],i[s+60>>2]=e,e=i[s+12>>2],i[s+48>>2]=i[s+8>>2],i[s+52>>2]=e,!(!X|!_)){for($=_&-4,M=_&3,f0=_&-2,P0=_&1,K0=_>>>0<4,n=0;;){B=G(n,I)+P|0,w=G(n,e0)+r0|0,o=G(n,X0)+O|0,m=G(n,g0)+I0|0,e=0;r:{f:{A:switch(H0|0){default:for(;k=e+B|0,h=U(U(U(l[e+w|0])*p0[s+60>>2])+U(U(U(l[e+o|0])*p0[s+52>>2])+U(p0[s+56>>2]*U(l[e+m|0])))),h=U((a&1?h:U(U(U(h*U(219))*U(.00390625))+U(16)))+U(.5)),U(w2(h))<U(2147483648)?f=~~h:f=-2147483648,u[k|0]=(f|0)>=0?f>>>0>=255?255:f:0,e=e+1|0,(_|0)!=(e|0););break r;case 0:if(a&1){if(w=0,o=0,K0)break f;for(;u[e+B|0]=l[e+m|0],f=e|1,u[f+B|0]=l[f+m|0],f=e|2,u[f+B|0]=l[f+m|0],f=e|3,u[f+B|0]=l[f+m|0],e=e+4|0,o=o+4|0,($|0)!=(o|0););break f}for(;k=e+B|0,h=U(U(U(U(U(l[e+m|0])*U(219))*U(.00390625))+U(16))+U(.5)),U(w2(h))<U(2147483648)?f=~~h:f=-2147483648,u[k|0]=(f|0)>=0?f>>>0>=255?255:f:0,e=e+1|0,(_|0)!=(e|0););break r;case 8:break A}if(f=0,(_|0)!=1)for(;u[e+B|0]=(l[e+m|0]>>>1)+(l[e+w|0]+l[e+o|0]>>>2),k=e|1,u[k+B|0]=(l[k+m|0]>>>1)+(l[k+w|0]+l[k+o|0]>>>2),e=e+2|0,f=f+2|0,(f0|0)!=(f|0););if(!P0)break r;u[e+B|0]=(l[e+m|0]>>>1)+(l[e+w|0]+l[e+o|0]>>>2);break r}if(!M)break r;for(;u[e+B|0]=l[e+m|0],e=e+1|0,w=w+1|0,(M|0)!=(w|0););}if(n=n+1|0,(X|0)==(n|0))break}for(f0=(N|0)==2,P0=f0&(Q|0)==2,K0=(Q|N)>>>0<2,f=0;;){k=G(f,e0),z=k+r0|0,B=G(f,X0)+O|0,m=G(f,g0)+I0|0,n=(f>>>0)/(N>>>0)|0,e=G(n,L0),A0=e+V|0;r:{f:{A:switch(H0|0){default:for(e=f+1|0,e=f0&&e>>>0<X>>>0?e:f,M=G(e,e0)+r0|0,P=G(e,g0)+I0|0,$=G(e,X0)+O|0,I=G(n,$0)+E|0,e=0;n0=U(l[e+z|0]),_0=U(l[e+m|0]),m0=U(l[e+B|0]),K0||(k=e+1|0,k=k>>>0<_>>>0&&P0?k:e,n0=U(U(U(U(n0+U(l[k+z|0]))+U(l[e+M|0]))+U(l[k+M|0]))*U(.25)),_0=U(U(U(U(_0+U(l[k+m|0]))+U(l[e+P|0]))+U(l[k+P|0]))*U(.25)),m0=U(U(U(U(m0+U(l[k+B|0]))+U(l[e+$|0]))+U(l[k+$|0]))*U(.25))),d0=p0[s+84>>2],n2=p0[s+76>>2],Z2=p0[s+80>>2],w=(e>>>0)/(Q>>>0)|0,n=w+A0|0,h=U(U(n0*p0[s+72>>2])+U(U(m0*p0[s+64>>2])+U(_0*p0[s+68>>2]))),o=a&1,h=U(U((o?h:U(U(h*U(224))*U(.00390625)))+U(128))+U(.5)),U(w2(h))<U(2147483648)?k=~~h:k=-2147483648,u[n|0]=(k|0)>=0?k>>>0>=255?255:k:0,n=w+I|0,h=U(U(n0*d0)+U(U(m0*n2)+U(_0*Z2))),h=U(U((o?h:U(U(h*U(224))*U(.00390625)))+U(128))+U(.5)),U(w2(h))<U(2147483648)?k=~~h:k=-2147483648,u[n|0]=(k|0)>=0?k>>>0>=255?255:k:0,e=e+Q|0,_>>>0>e>>>0;);break r;case 0:if(I=k+O|0,w=e+E|0,e=0,a&1)break f;for(;o=(e>>>0)/(Q>>>0)|0,n=o+A0|0,h=U(U(U(U(U(l[e+z|0])*U(224))*U(.00390625))+U(16))+U(.5)),U(w2(h))<U(2147483648)?k=~~h:k=-2147483648,u[n|0]=(k|0)>=0?k>>>0>=255?255:k:0,n=o+w|0,h=U(U(U(U(U(l[e+I|0])*U(224))*U(.00390625))+U(16))+U(.5)),U(w2(h))<U(2147483648)?k=~~h:k=-2147483648,u[n|0]=(k|0)>=0?k>>>0>=255?255:k:0,e=e+Q|0,_>>>0>e>>>0;);break r;case 8:break A}for(w=G(n,$0)+E|0,e=0;o=(e>>>0)/(Q>>>0)|0,n=e+z|0,k=e+B|0,u[o+A0|0]=(l[e+m|0]>>>1)-(l[n|0]+l[k|0]>>>2)^128,u[o+w|0]=(l[k|0]-l[n|0]|0)/2^128,e=e+Q|0,_>>>0>e>>>0;);break r}for(;k=(e>>>0)/(Q>>>0)|0,u[k+A0|0]=l[e+z|0],u[k+w|0]=l[e+I|0],e=e+Q|0,_>>>0>e>>>0;);}if(f=f+N|0,!(X>>>0>f>>>0))break}}r:{if(!S||(e=j0(i[r>>2],6),!X))break r;if(n=_<<(e>>>0>8),e=0,(X|0)!=1)for(k=X&-2,f=0;r=!n,r||x(G(e,M0)+t|0,G(e,U0)+N0|0,n),r||(r=e|1,x(G(r,M0)+t|0,G(r,U0)+N0|0,n)),e=e+2|0,f=f+2|0,(k|0)!=(f|0););if(!(X&1)|!n)break r;x(G(e,M0)+t|0,G(e,U0)+N0|0,n)}u[A+20|0]=0,i[A+4>>2]=R,i[A>>2]=F;break i}if(A=i[R+4>>2],i[R+4>>2]=A-1,A)break i;W[i[i[R>>2]+8>>2]](R),y(R)}v=s+160|0}function H7(){var A=0,e=0,r=0,f=0,k=0,n=0,t=0,o=0,s=0,w=0,h=0,_=0,B=0,m=0,X=0;for(u[114112]=0,u[114113]=0,u[114114]=0,u[114115]=1,u[114116]=1,u[114117]=0,u[114118]=1,u[114119]=1,u[111376]=0,u[111377]=0,u[111378]=1,u[111379]=0,u[111380]=0,u[111381]=1,u[111382]=1,u[111383]=1;;){if((A|0)<0)A=0;else{i:{e:{if(A>>>0<=1){if(k=e<<1,u[k+108647|0]=A,u[k+108646|0]=0,r=e+1|0,!A){e=r;break i}u[(r<<1)+108646|0]=1,f=A-1|0,k=2;break e}if((A|0)!=2)break i;f=1,u[(e<<1)+108646|0]=1,r=e,k=1}u[(r<<1)+108647|0]=f,e=e+k|0}A=A+1|0}if(!((e|0)<4))break}for(i[27854]=50397952,i[27855]=50529026,i[27852]=33620480,i[27853]=33751554,i[27850]=16843008,i[27851]=16974082,i[27848]=65536,i[27849]=196610,i[28532]=16777216,i[28533]=50332160,i[28534]=16842753,i[28535]=50397697,i[28536]=16908290,i[28537]=50463234,i[28538]=16973827,i[28539]=50528771,e=0,A=0;;){if((A|0)<0)A=0;else{i:{e:{r:{f:{A:{k:{n:{if(A>>>0<=3){if(k=e<<1,u[k+108657|0]=A,u[k+108656|0]=0,k=e+1|0,A)break n;e=k;break i}if((A|0)!=4)break k;g[(e<<1)+108656>>1]=769,r=e+1|0,f=2;break A}if(k=k<<1,u[k+108657|0]=A-1,u[k+108656|0]=1,k=e+2|0,(A|0)==1){e=k;break i}if(k=k<<1,u[k+108657|0]=A-2,u[k+108656|0]=2,k=e+3|0,(A|0)!=2)break f;e=k;break i}if(f=1,r=e,A>>>0>=6)break r}k=r<<1,u[k+108657|0]=A-2,u[k+108656|0]=2,e=e+f|0;break e}k=k<<1,u[k+108657|0]=A-3,u[k+108656|0]=3,e=e+4|0;break i}if((A|0)!=6)break i}k=e<<1,u[k+108657|0]=A-3,u[k+108656|0]=3,e=e+1|0}A=A+1|0}if(!((e|0)<16))break}for(i[27886]=117769988,i[27887]=117901062,i[27884]=117507840,i[27885]=117638914,i[27882]=100992516,i[27883]=101123590,i[27880]=100730368,i[27881]=100861442,i[27878]=84215044,i[27879]=84346118,i[27876]=83952896,i[27877]=84083970,i[27874]=67437572,i[27875]=67568646,i[27872]=67175424,i[27873]=67306498,i[27870]=50660100,i[27871]=50791174,i[27868]=50397952,i[27869]=50529026,i[27866]=33882628,i[27867]=34013702,i[27864]=33620480,i[27865]=33751554,i[27862]=17105156,i[27863]=17236230,i[27860]=16843008,i[27861]=16974082,i[27858]=327684,i[27859]=458758,i[27856]=65536,i[27857]=196610,i[28540]=16777216,i[28541]=50332160,i[28542]=83887104,i[28543]=117442048,i[28544]=16842753,i[28545]=50397697,i[28546]=83952641,i[28547]=117507585,i[28548]=16908290,i[28549]=50463234,i[28550]=84018178,i[28551]=117573122,i[28552]=16973827,i[28553]=50528771,i[28554]=84083715,i[28555]=117638659,i[28556]=17039364,i[28557]=50594308,i[28558]=84149252,i[28559]=117704196,i[28560]=17104901,i[28561]=50659845,i[28562]=84214789,i[28563]=117769733,i[28564]=17170438,i[28565]=50725382,i[28566]=84280326,i[28567]=117835270,i[28568]=17235975,i[28569]=50790919,i[28570]=84345863,i[28571]=117900807,r=0,k=0;;){if((k|0)<0)k=0;else{i:{if(!k){e=0,A=k;break i}for(n=k+1&-2,e=0,A=k,f=0;(A|0)>7|e>>>0>7||(t=r<<1,u[t+108689|0]=A,u[t+108688|0]=e,r=r+1|0),(A|0)>8|e>>>0>7||(t=r<<1,u[t+108689|0]=A-1,u[t+108688|0]=e|1,r=r+1|0),e=e+2|0,A=A-2|0,f=f+2|0,(n|0)!=(f|0););}k&1|(A|0)>7|e>>>0>7||(n=r<<1,u[n+108689|0]=A,u[n+108688|0]=e,r=r+1|0),k=k+1|0}if(!((r|0)<64))break}for(r=0,f=0;A=f<<1,u[A+111583|0]=r,u[A+111582|0]=15,u[A+111581|0]=r,u[A+111580|0]=14,u[A+111579|0]=r,u[A+111578|0]=13,u[A+111577|0]=r,u[A+111576|0]=12,u[A+111575|0]=r,u[A+111574|0]=11,u[A+111573|0]=r,u[A+111572|0]=10,u[A+111571|0]=r,u[A+111570|0]=9,u[A+111569|0]=r,u[A+111568|0]=8,u[A+111567|0]=r,u[A+111566|0]=7,u[A+111565|0]=r,u[A+111564|0]=6,u[A+111563|0]=r,u[A+111562|0]=5,u[A+111561|0]=r,u[A+111560|0]=4,u[A+111559|0]=r,u[A+111558|0]=3,u[A+111557|0]=r,u[A+111556|0]=2,u[A+111555|0]=r,u[A+111554|0]=1,u[A+111553|0]=r,e=0,u[A+111552|0]=0,f=f+16|0,r=r+1|0,(r|0)!=16;);for(f=0;A=f<<1,u[A+114319|0]=15,u[A+114318|0]=e,u[A+114317|0]=14,u[A+114316|0]=e,u[A+114315|0]=13,u[A+114314|0]=e,u[A+114313|0]=12,u[A+114312|0]=e,u[A+114311|0]=11,u[A+114310|0]=e,u[A+114309|0]=10,u[A+114308|0]=e,u[A+114307|0]=9,u[A+114306|0]=e,u[A+114305|0]=8,u[A+114304|0]=e,u[A+114303|0]=7,u[A+114302|0]=e,u[A+114301|0]=6,u[A+114300|0]=e,u[A+114299|0]=5,u[A+114298|0]=e,u[A+114297|0]=4,u[A+114296|0]=e,u[A+114295|0]=3,u[A+114294|0]=e,u[A+114293|0]=2,u[A+114292|0]=e,u[A+114291|0]=1,u[A+114290|0]=e,r=0,u[A+114289|0]=0,u[A+114288|0]=e,f=f+16|0,e=e+1|0,(e|0)!=16;);for(n=0;;){if(f=0,(n|0)<0)n=0;else{i:{if(!n){e=0,A=n;break i}for(t=n+1&-2,e=0,A=n,k=0;(A|0)>15|e>>>0>15||(o=r<<1,u[o+108817|0]=A,u[o+108816|0]=e,r=r+1|0),(A|0)>16|e>>>0>15||(o=r<<1,u[o+108817|0]=A-1,u[o+108816|0]=e|1,r=r+1|0),e=e+2|0,A=A-2|0,k=k+2|0,(t|0)!=(k|0););}n&1|(A|0)>15|e>>>0>15||(k=r<<1,u[k+108817|0]=A,u[k+108816|0]=e,r=r+1|0),n=n+1|0}if(!((r|0)<256))break}for(r=0;A=r<<1,u[A+112127|0]=f,u[A+112126|0]=31,u[A+112125|0]=f,u[A+112124|0]=30,u[A+112123|0]=f,u[A+112122|0]=29,u[A+112121|0]=f,u[A+112120|0]=28,u[A+112119|0]=f,u[A+112118|0]=27,u[A+112117|0]=f,u[A+112116|0]=26,u[A+112115|0]=f,u[A+112114|0]=25,u[A+112113|0]=f,u[A+112112|0]=24,u[A+112111|0]=f,u[A+112110|0]=23,u[A+112109|0]=f,u[A+112108|0]=22,u[A+112107|0]=f,u[A+112106|0]=21,u[A+112105|0]=f,u[A+112104|0]=20,u[A+112103|0]=f,u[A+112102|0]=19,u[A+112101|0]=f,u[A+112100|0]=18,u[A+112099|0]=f,u[A+112098|0]=17,u[A+112097|0]=f,u[A+112096|0]=16,u[A+112095|0]=f,u[A+112094|0]=15,u[A+112093|0]=f,u[A+112092|0]=14,u[A+112091|0]=f,u[A+112090|0]=13,u[A+112089|0]=f,u[A+112088|0]=12,u[A+112087|0]=f,u[A+112086|0]=11,u[A+112085|0]=f,u[A+112084|0]=10,u[A+112083|0]=f,u[A+112082|0]=9,u[A+112081|0]=f,u[A+112080|0]=8,u[A+112079|0]=f,u[A+112078|0]=7,u[A+112077|0]=f,u[A+112076|0]=6,u[A+112075|0]=f,u[A+112074|0]=5,u[A+112073|0]=f,u[A+112072|0]=4,u[A+112071|0]=f,u[A+112070|0]=3,u[A+112069|0]=f,u[A+112068|0]=2,u[A+112067|0]=f,u[A+112066|0]=1,u[A+112065|0]=f,e=0,u[A+112064|0]=0,r=r+32|0,f=f+1|0,(f|0)!=32;);for(f=0;A=f<<1,u[A+114863|0]=31,u[A+114862|0]=e,u[A+114861|0]=30,u[A+114860|0]=e,u[A+114859|0]=29,u[A+114858|0]=e,u[A+114857|0]=28,u[A+114856|0]=e,u[A+114855|0]=27,u[A+114854|0]=e,u[A+114853|0]=26,u[A+114852|0]=e,u[A+114851|0]=25,u[A+114850|0]=e,u[A+114849|0]=24,u[A+114848|0]=e,u[A+114847|0]=23,u[A+114846|0]=e,u[A+114845|0]=22,u[A+114844|0]=e,u[A+114843|0]=21,u[A+114842|0]=e,u[A+114841|0]=20,u[A+114840|0]=e,u[A+114839|0]=19,u[A+114838|0]=e,u[A+114837|0]=18,u[A+114836|0]=e,u[A+114835|0]=17,u[A+114834|0]=e,u[A+114833|0]=16,u[A+114832|0]=e,u[A+114831|0]=15,u[A+114830|0]=e,u[A+114829|0]=14,u[A+114828|0]=e,u[A+114827|0]=13,u[A+114826|0]=e,u[A+114825|0]=12,u[A+114824|0]=e,u[A+114823|0]=11,u[A+114822|0]=e,u[A+114821|0]=10,u[A+114820|0]=e,u[A+114819|0]=9,u[A+114818|0]=e,u[A+114817|0]=8,u[A+114816|0]=e,u[A+114815|0]=7,u[A+114814|0]=e,u[A+114813|0]=6,u[A+114812|0]=e,u[A+114811|0]=5,u[A+114810|0]=e,u[A+114809|0]=4,u[A+114808|0]=e,u[A+114807|0]=3,u[A+114806|0]=e,u[A+114805|0]=2,u[A+114804|0]=e,u[A+114803|0]=1,u[A+114802|0]=e,r=0,u[A+114801|0]=0,u[A+114800|0]=e,f=f+32|0,e=e+1|0,(e|0)!=32;);for(k=0;;){if((k|0)<0)k=0;else{i:{if(!k){e=0,A=k;break i}for(n=k+1&-2,e=0,A=k,f=0;(A|0)>31|e>>>0>31||(t=r<<1,u[t+109329|0]=A,u[t+109328|0]=e,r=r+1|0),(A|0)>32|e>>>0>31||(t=r<<1,u[t+109329|0]=A-1,u[t+109328|0]=e|1,r=r+1|0),e=e+2|0,A=A-2|0,f=f+2|0,(n|0)!=(f|0););}k&1|(A|0)>31|e>>>0>31||(n=r<<1,u[n+109329|0]=A,u[n+109328|0]=e,r=r+1|0),k=k+1|0}if(!((r|0)<1024))break}for(f=2;;){for(e=f-2|0,k=(1<<e<<e)-1|0,t=1<<f,o=f<<2,B=i[o+63024>>2],h=e<<2,_=i[h+62928>>2],n=0;;){for(X=B+(n<<f<<1)|0,r=0;;){for(s=X+(r<<1)|0,A=16,e=k;e=e-!A|0,w=_+(e<<1)|0,A=A?A-1|0:15,m=A<<1,!!((l[m+108656|0]+(l[w|0]<<2)|0)!=(r|0)|(l[m+108657|0]+(l[w+1|0]<<2)|0)!=(n|0)););if(u[s+1|0]=A,u[s|0]=e,r=r+1|0,(t|0)==(r|0))break}if(n=n+1|0,(t|0)==(n|0))break}for(B=i[h+62960>>2],_=i[o+63048>>2],n=0;;){for(X=_+(n<<f<<1)|0,r=0;;){for(s=X+(r<<1)|0,A=16,e=k;e=e-!A|0,w=B+(e<<1)|0,A=A?A-1|0:15,m=A<<1,!!((l[m+111392|0]+(l[w|0]<<2)|0)!=(r|0)|(l[m+111393|0]+(l[w+1|0]<<2)|0)!=(n|0)););if(u[s+1|0]=A,u[s|0]=e,r=r+1|0,(t|0)==(r|0))break}if(n=n+1|0,(t|0)==(n|0))break}for(s=i[h+62992>>2],w=i[o+63072>>2],n=0;;){for(B=w+(n<<f<<1)|0,r=0;;){for(o=B+(r<<1)|0,A=16,e=k;e=e-!A|0,h=s+(e<<1)|0,A=A?A-1|0:15,_=A<<1,!!((l[_+114128|0]+(l[h|0]<<2)|0)!=(r|0)|(l[_+114129|0]+(l[h+1|0]<<2)|0)!=(n|0)););if(u[o+1|0]=A,u[o|0]=e,r=r+1|0,(t|0)==(r|0))break}if(n=n+1|0,(t|0)==(n|0))break}if(f=f+1|0,(f|0)==6)break}}function z7(A,e,r,f,k,n,t,o,s,w,h,_,B,m){var X=0,Q=0,V=0,F=0,I=0,E=0,R=0,N=0,M=0,z=0,S=0,O=0,P=0,a=0,$=0,f0=0,A0=0,n0=0,_0=0,m0=0,X0=0;Q=v-32|0,v=Q,F=A,X=r,_0=e,O=f,A0=k,n0=n,E=Q+20|0,I=v+-64|0,v=I;i:{e:{r:{f:{if((_|0)>=16){F2(A+4|0,1008,0),u[X+312|0]=3,u[Q+30|0]=0,u[Q+31|0]=0,g[E>>1]=0,g[E+2>>1]=0,g[E+4>>1]=0,g[E+6>>1]=0;break f}if(u[Q+31|0]=0,f=-1,P=t-1|0,i[I+60>>2]=P,i[I+56>>2]=P,e=o+w|0,i[I+52>>2]=e,k=e-1|0,i[I+48>>2]=k,u[Q+30|0]=0,g[E>>1]=0,g[E+2>>1]=0,R=X8(X,O,A0,n0,t,o,s,w,B,P,e),u[I+47|0]=R,a=X8(X,O,A0,n0,t,o,s,w,B,P,k),u[I+46|0]=a,M=_0+924|0,z=h<<6,m0=(M+z|0)+(_<<2)|0,r=W[i[i[F>>2]+8>>2]](F,i[m0>>2])|0,!r)break f;A=1-h|0,S=i[r+96>>2];A:{if(l[Q+30|0]|!R)break A;if(n=i[X+168>>2],r=P>>n,(r|0)<0||(V=i[X+172>>2],(V|0)<=(r|0)))break r;if(n=e>>n,(n|0)<0|(n|0)>=i[X+176>>2])break e;if(!(l[((i[X+160>>2]+G(r,3)|0)+G(G(n,V),3)|0)+1|0]&3))break A;if(n=i[X+188>>2],r=P>>n,(r|0)<0||(f0=i[X+192>>2],(f0|0)<=(r|0)))break r;if(e=e>>n,(e|0)<0|(e|0)>=i[X+196>>2])break e;if(n=0,V=0,e=(i[X+180>>2]+G(r,12)|0)+G(G(e,f0),12)|0,r=e+h|0,l[r|0]){if(V=l[r+2|0],V>>>0>15)break f;V=W[i[i[F>>2]+8>>2]](F,i[(M+z|0)+(V<<2)>>2])|0}if(z=A+e|0,l[z|0]){if(n=l[z+2|0],n>>>0>15)break f;n=W[i[i[F>>2]+8>>2]](F,i[((A<<6)+M|0)+(n<<2)>>2])|0}k:{if(!(!V|!l[r|0])&&(r=h,i[V+96>>2]==(S|0)))break k;if(!n|!l[z|0]||(r=A,i[n+96>>2]!=(S|0)))break A}u[Q+30|0]=1,f=e+(r<<2)|0,f=C[f+4>>1]|C[f+6>>1]<<16,g[E>>1]=f,g[E+2>>1]=f>>>16,f=u[(e+r|0)+2|0]}A:{if(l[Q+30|0]|!a)break A;if(r=i[X+168>>2],e=P>>r,(e|0)<0||(n=i[X+172>>2],(n|0)<=(e|0)))break r;if(r=k>>r,(r|0)<0|(r|0)>=i[X+176>>2])break e;if(!(l[((i[X+160>>2]+G(e,3)|0)+G(G(r,n),3)|0)+1|0]&3))break A;if(r=i[X+188>>2],e=P>>r,(e|0)<0||(n=i[X+192>>2],(n|0)<=(e|0)))break r;if(k=k>>r,(k|0)<0|(k|0)>=i[X+196>>2])break e;if(V=0,r=0,k=(i[X+180>>2]+G(e,12)|0)+G(G(k,n),12)|0,e=k+h|0,l[e|0]){if(r=l[e+2|0],r>>>0>15)break f;r=W[i[i[F>>2]+8>>2]](F,i[((h<<6)+M|0)+(r<<2)>>2])|0}if(n=A+k|0,l[n|0]){if(V=l[n+2|0],V>>>0>15)break f;V=W[i[i[F>>2]+8>>2]](F,i[((A<<6)+M|0)+(V<<2)>>2])|0}k:{if(!(!r|!l[e|0])&&(e=h,i[r+96>>2]==(S|0)))break k;if(!V|!l[n|0]||(e=A,i[V+96>>2]!=(S|0)))break A}u[Q+30|0]=1,r=k+(e<<2)|0,r=C[r+4>>1]|C[r+6>>1]<<16,g[E>>1]=r,g[E+2>>1]=r>>>16,f=u[(e+k|0)+2|0]}X0=R|a,z=_0+1308|0,R=z+(h<<4)|0,a=R+_|0,f0=F+4|0,e=I+60|0,V=I+52|0,n=I+47|0,r=1;A:{k:{n:{for(;;){if(!l[Q+30|0]){k=-1;t:{if(l[n|0]!=1)break t;if(N=i[e>>2],n=i[X+168>>2],e=N>>n,(e|0)<0||($=i[X+172>>2],($|0)<=(e|0)))break r;if(V=i[V>>2],n=V>>n,(n|0)<0|(n|0)>=i[X+176>>2])break e;if(!(l[((i[X+160>>2]+G(e,3)|0)+G(G(n,$),3)|0)+1|0]&3))break t;if(n=i[X+188>>2],e=N>>n,(e|0)<0||(N=i[X+192>>2],(N|0)<=(e|0)))break r;if(n=V>>n,(n|0)<0|(n|0)>=i[X+196>>2])break e;if(e=(i[X+180>>2]+G(e,12)|0)+G(G(n,N),12)|0,n=e+h|0,!(l[n|0]!=1|l[a|0]!=l[R+u[n+2|0]|0])){u[Q+30|0]=1,e=e+(h<<2)|0,e=C[e+4>>1]|C[e+6>>1]<<16,g[E>>1]=e,g[E+2>>1]=e>>>16,f=u[n+2|0],k=h;break t}if(n=A+e|0,l[n|0]!=1|l[a|0]!=l[u[n+2|0]+(z+(A<<4)|0)|0])break t;u[Q+30|0]=1,e=e+(A<<2)|0,e=C[e+4>>1]|C[e+6>>1]<<16,g[E>>1]=e,g[E+2>>1]=e>>>16,f=u[n+2|0],k=A}t:{if(l[Q+30|0]!=1)break t;if((f|0)<0){u[Q+30|0]=0,u[Q+31|0]=0;break f}if((k|0)<0)break n;if(n=W[i[i[F>>2]+8>>2]](F,i[((k<<6)+M|0)+(f<<2)>>2])|0,W[i[i[F>>2]+8>>2]](F,i[m0>>2])|0,l[(z+(k<<4)|0)+f|0]|l[a|0])break t;if(e=i[X+96>>2],k=i[n+96>>2],(e|0)!=(k|0)){k=e-k|0,k=(k|0)>=127?127:k,k=(k|0)<=-128?-128:k,n=k>>31,e=e-S|0,e=(e|0)>=127?127:e,e=G(((k^n)-n>>>1|16384)/(k|0)<<16>>16,(e|0)<=-128?-128:e)+32>>6,e=(e|0)>=4095?4095:e,n=(e|0)<=-4096?-4096:e,V=C[E>>1]|C[E+2>>1]<<16,e=G(n,V>>16),k=e>>31,e=G(((e|0)>0)-((e|0)<0)|0,((e^k)-k|0)+127>>>8|0),e=(e|0)>=32767?32767:e,g[E+2>>1]=(e|0)<=-32768?-32768:e,e=G(n,V<<16>>16),k=e>>31,e=G(((e|0)>0)-((e|0)<0)|0,((e^k)-k|0)+127>>>8|0),e=(e|0)>=32767?32767:e,g[E>>1]=(e|0)<=-32768?-32768:e;break t}F2(f0,1008,0),u[X+312|0]=3}if(k=r&1,e=I+56|0,V=I+48|0,n=I+46|0,r=0,k)continue}break}i[I+40>>2]=P,e=t+s|0,i[I+32>>2]=e,r=-1,k=o-1|0,i[I+20>>2]=k,i[I+24>>2]=k,i[I+28>>2]=k,N=e-1|0,i[I+36>>2]=N,u[Q+31|0]=0,g[E+4>>1]=0,g[E+6>>1]=0,f=X8(X,O,A0,n0,t,o,s,w,B,e,k),u[I+17|0]=f,R=E+4|0;t:{if(l[Q+31|0]|!f)break t;if(f=i[X+188>>2],e=e>>f,(e|0)<0||($=i[X+192>>2],($|0)<=(e|0)))break r;if(f=k>>f,(f|0)<0|(f|0)>=i[X+196>>2])break e;if(n=0,V=0,f=(i[X+180>>2]+G(e,12)|0)+G(G(f,$),12)|0,e=f+h|0,l[e|0]){if(V=l[e+2|0],V>>>0>15)break f;V=W[i[i[F>>2]+8>>2]](F,i[((h<<6)+M|0)+(V<<2)>>2])|0}if($=A+f|0,l[$|0]){if(n=l[$+2|0],n>>>0>15)break f;n=W[i[i[F>>2]+8>>2]](F,i[((A<<6)+M|0)+(n<<2)>>2])|0}u:{if(!(!V|!l[e|0])&&(e=h,i[V+96>>2]==(S|0)))break u;if(!n|!l[$|0]||(e=A,i[n+96>>2]!=(S|0)))break t}u[Q+31|0]=1,r=f+(e<<2)|0,r=C[r+4>>1]|C[r+6>>1]<<16,g[R>>1]=r,g[R+2>>1]=r>>>16,r=u[(e+f|0)+2|0]}e=X8(X,O,A0,n0,t,o,s,w,B,N,k),u[I+18|0]=e;t:{if(l[Q+31|0]|!e)break t;if(e=i[X+188>>2],f=N>>e,(f|0)<0||(N=i[X+192>>2],(N|0)<=(f|0)))break r;if(n=k>>e,(n|0)<0|(n|0)>=i[X+196>>2])break e;if(V=0,e=0,n=(i[X+180>>2]+G(f,12)|0)+G(G(n,N),12)|0,f=n+h|0,l[f|0]){if(e=l[f+2|0],e>>>0>15)break f;e=W[i[i[F>>2]+8>>2]](F,i[((h<<6)+M|0)+(e<<2)>>2])|0}if(N=A+n|0,l[N|0]){if(V=l[N+2|0],V>>>0>15)break f;V=W[i[i[F>>2]+8>>2]](F,i[((A<<6)+M|0)+(V<<2)>>2])|0}u:{if(!(!e|!l[f|0])&&(f=h,i[e+96>>2]==(S|0)))break u;if(!V|!l[N|0]||(f=A,i[V+96>>2]!=(S|0)))break t}u[Q+31|0]=1,e=n+(f<<2)|0,e=C[e+4>>1]|C[e+6>>1]<<16,g[R>>1]=e,g[R+2>>1]=e>>>16,r=u[(f+n|0)+2|0]}e=X8(X,O,A0,n0,t,o,s,w,B,P,k),u[I+19|0]=e;t:{if(l[Q+31|0]|!e)break t;if(f=i[X+188>>2],e=P>>f,(e|0)<0||(n=i[X+192>>2],(n|0)<=(e|0)))break r;if(k=k>>f,(k|0)<0|(k|0)>=i[X+196>>2])break e;if(V=0,f=0,e=(i[X+180>>2]+G(e,12)|0)+G(G(k,n),12)|0,k=e+h|0,l[k|0]){if(f=l[k+2|0],f>>>0>15)break f;f=W[i[i[F>>2]+8>>2]](F,i[((h<<6)+M|0)+(f<<2)>>2])|0}if(B=A+e|0,l[B|0]){if(n=l[B+2|0],n>>>0>15)break f;V=W[i[i[F>>2]+8>>2]](F,i[((A<<6)+M|0)+(n<<2)>>2])|0}u:{if(!(!f|!l[k|0])&&(n=h,i[f+96>>2]==(S|0)))break u;if(!V|!l[B|0]||(n=A,i[V+96>>2]!=(S|0)))break t}u[Q+31|0]=1,r=e+(n<<2)|0,r=C[r+4>>1]|C[r+6>>1]<<16,g[R>>1]=r,g[R+2>>1]=r>>>16,r=u[(e+n|0)+2|0]}if(X0)break f;for(l[Q+31|0]&&(u[Q+30|0]=1,e=C[E+4>>1]|C[E+6>>1]<<16,g[E>>1]=e,g[E+2>>1]=e>>>16),u[Q+31|0]=0,n=z+(h<<4)|0,k=0;;){e=-1;t:{if(l[(I+17|0)+k|0]!=1)break t;if(f=k<<2,B=i[X+188>>2],e=i[f+(I+32|0)>>2]>>B,(e|0)<0||(O=i[X+192>>2],(O|0)<=(e|0)))break r;if(f=i[f+(I+20|0)>>2]>>B,(f|0)<0|(f|0)>=i[X+196>>2])break e;if(f=(i[X+180>>2]+G(e,12)|0)+G(G(f,O),12)|0,B=f+2|0,e=B+h|0,O=u[e|0],(O|0)>15)break k;if(!(l[f+h|0]!=1|l[a|0]!=l[n+O|0])){u[Q+31|0]=1,r=f+(h<<2)|0,r=C[r+4>>1]|C[r+6>>1]<<16,g[R>>1]=r,g[R+2>>1]=r>>>16,r=u[e|0],e=h;break t}if(e=-1,l[A+f|0]!=1||(B=A+B|0,e=-1,l[a|0]!=l[u[B|0]+(z+(A<<4)|0)|0]))break t;u[Q+31|0]=1,e=f+(A<<2)|0,e=C[e+4>>1]|C[e+6>>1]<<16,g[R>>1]=e,g[R+2>>1]=e>>>16,r=u[B|0],e=A}t:{if(l[Q+31|0]!=1)break t;if((r|0)<0){u[Q+30|0]=0,u[Q+31|0]=0;break f}if((e|0)<0)break A;f=W[i[i[F>>2]+8>>2]](F,i[((e<<6)+M|0)+(r<<2)>>2])|0,B=W[i[i[F>>2]+8>>2]](F,i[m0>>2])|0;u:{if(!(B&&f)){F2(i[X+112>>2]+4|0,1012,0);break u}if(f=i[f+96>>2],l[a|0]|(l[(z+(e<<4)|0)+r|0]|(f|0)==i[B+96>>2])||(e=i[X+96>>2],B=C[R>>1]|C[R+2>>1]<<16,i[I+8>>2]=B,i[I+12>>2]=B,Ut(R,I+8|0,e-f|0,e-S|0)))break t;F2(f0,1008,0)}u[X+312|0]=3}if(k=k+1|0,(k|0)==3)break f;if(l[Q+31|0])break}break f}D0(21938,18225,1801,8189),H()}u[X+312|0]=3,F2(f0,1012,0);break f}D0(21938,18225,1959,8189),H()}v=I- -64|0;break i}D0(4656,10893,118,4231),H()}D0(4618,10893,119,4231),H()}i:{e:{r:{f:{A:{k:{if(A=l[Q+30|0],e=l[Q+31|0],!(!A|!e)){if(C[Q+20>>1]!=C[Q+24>>1]|C[Q+22>>1]!=C[Q+26>>1])break k;Dr(F,X,_0,t,o,s,w,_,h,Q+12|0,Q+19|0);break A}if(Dr(F,X,_0,t,o,s,w,_,h,Q+12|0,Q+19|0),A)break f;if(_=0,A=0,!e)break i;break e}u[Q+19|0]=0}A=i[Q+20>>2],g[m>>1]=A,g[m+2>>1]=A>>>16;break r}if(A=i[Q+20>>2],g[m>>1]=A,g[m+2>>1]=A>>>16,e)break r;A=1;break i}if(_=1,C[Q+20>>1]!=C[Q+24>>1])break e;if(A=1,C[Q+22>>1]==C[Q+26>>1])break i}A=(_<<2)+m|0,e=i[Q+24>>2],g[A>>1]=e,g[A+2>>1]=e>>>16,A=_+1|0}_=A,l[Q+19|0]&&(A=(_<<2)+m|0,e=i[Q+12>>2],g[A>>1]=e,g[A+2>>1]=e>>>16,_=_+1|0);i:{if(_>>>0<=1){if(A=_<<2,e=8-A|0,!e)break i;o0(A+m|0,0,e);break i}if((_|0)==2)break i;D0(21508,18225,2063,4767),H()}v=Q+32|0}function Z8(A,e,r){var f=0,k=0,n=0,t=0,o=0,s=0,w=0,h=0,_=0,B=0,m=0,X=0,Q=0;h=v-16|0,v=h,n=v-16|0,v=n;i:{e:{r:{if(k=e,!i[e+44>>2]){e=p(152),i[e+4>>2]=0,i[e+8>>2]=0,i[e>>2]=89804,f=e+16|0,i[f+8>>2]=0,i[f+12>>2]=0,i[e+32>>2]=0,i[e+36>>2]=0,i[e+40>>2]=0,i[e+44>>2]=0,i[e+48>>2]=0,i[e+16>>2]=86356,i[e+60>>2]=0,i[e+64>>2]=0,i[e+52>>2]=0,i[e+56>>2]=0,i[e+72>>2]=-1,i[e+76>>2]=-1,i[e+80>>2]=-1,i[e+84>>2]=-1,i[e+116>>2]=0,i[e+88>>2]=0,i[e+92>>2]=0,i[e+96>>2]=0,i[e+100>>2]=0,i[e+104>>2]=0,i[e+108>>2]=0,g[e+112>>1]=0,i[e+16>>2]=87124,i[e+128>>2]=0,i[e+132>>2]=0,i[e+120>>2]=0,i[e+124>>2]=1885954932,i[e+136>>2]=0,i[e+140>>2]=0,i[e+144>>2]=0,i[e+148>>2]=0,i[e+32>>2]=1751411826,i[k+36>>2]=f,f=i[k+40>>2],i[k+40>>2]=e;f:{if(!f||(e=i[f+4>>2],i[f+4>>2]=e-1,e))break f;W[i[i[f>>2]+8>>2]](f),y(f)}e=p(120),i[e+4>>2]=0,i[e+8>>2]=0,i[e>>2]=89684,f=e+16|0,i[f+8>>2]=0,i[f+12>>2]=0,i[e+32>>2]=0,i[e+36>>2]=0,i[e+40>>2]=0,i[e+44>>2]=0,i[e+48>>2]=0,i[e+16>>2]=86356,i[e+60>>2]=0,i[e+64>>2]=0,i[e+52>>2]=0,i[e+56>>2]=0,i[e+72>>2]=-1,i[e+76>>2]=-1,i[e+80>>2]=-1,i[e+84>>2]=-1,i[e+116>>2]=0,i[e+88>>2]=0,i[e+92>>2]=0,i[e+96>>2]=0,i[e+100>>2]=0,i[e+104>>2]=0,i[e+108>>2]=0,g[e+112>>1]=0,i[e+16>>2]=87044,i[e+32>>2]=1835365473,i[k+44>>2]=f,f=i[k+48>>2],i[k+48>>2]=e;f:{if(!f||(e=i[f+4>>2],i[f+4>>2]=e-1,e))break f;W[i[i[f>>2]+8>>2]](f),y(f)}e=p(120),i[e+4>>2]=0,i[e+8>>2]=0,i[e>>2]=90044,f=e+16|0,i[f+8>>2]=0,i[f+12>>2]=0,i[e+32>>2]=0,i[e+36>>2]=0,i[e+40>>2]=0,i[e+44>>2]=0,i[e+48>>2]=0,i[e+16>>2]=86356,i[e+60>>2]=0,i[e+64>>2]=0,i[e+52>>2]=0,i[e+56>>2]=0,i[e+72>>2]=-1,i[e+76>>2]=-1,i[e+80>>2]=-1,i[e+84>>2]=-1,i[e+88>>2]=0,i[e+92>>2]=0,i[e+96>>2]=0,i[e+100>>2]=0,i[e+104>>2]=0,i[e+108>>2]=0,u[e+112|0]=0,i[e+16>>2]=87524,i[e+32>>2]=1768973167,i[k+52>>2]=f,f=i[k+56>>2],i[k+56>>2]=e;f:{if(!f||(e=i[f+4>>2],i[f+4>>2]=e-1,e))break f;W[i[i[f>>2]+8>>2]](f),y(f)}e=p(136),i[e+4>>2]=0,i[e+8>>2]=0,i[e>>2]=90084,f=e+16|0,i[f+8>>2]=0,i[f+12>>2]=0,i[e+32>>2]=0,i[e+36>>2]=0,i[e+40>>2]=0,i[e+44>>2]=0,i[e+48>>2]=0,i[e+16>>2]=86356,i[e+60>>2]=0,i[e+64>>2]=0,i[e+52>>2]=0,i[e+56>>2]=0,i[e+72>>2]=-1,i[e+76>>2]=-1,i[e+80>>2]=-1,i[e+84>>2]=-1,i[e+116>>2]=0,i[e+88>>2]=0,i[e+92>>2]=0,i[e+96>>2]=0,i[e+100>>2]=0,i[e+104>>2]=0,i[e+108>>2]=0,g[e+112>>1]=0,i[e+16>>2]=87672,i[e+128>>2]=0,i[e+120>>2]=0,i[e+124>>2]=0,i[e+32>>2]=1768975713,i[k+60>>2]=f,f=i[k+64>>2],i[k+64>>2]=e;f:{if(!f||(e=i[f+4>>2],i[f+4>>2]=e-1,e))break f;W[i[i[f>>2]+8>>2]](f),y(f)}f=p(176),i[f+4>>2]=0,i[f+8>>2]=0,i[f>>2]=89884,X=k,Q=It(f+16|0),i[X+68>>2]=Q,e=i[k+72>>2],i[k+72>>2]=f;f:{if(!e||(f=i[e+4>>2],i[e+4>>2]=f-1,f))break f;W[i[i[e>>2]+8>>2]](e),y(e)}e=p(120),i[e+4>>2]=0,i[e+8>>2]=0,i[e>>2]=89924,f=e+16|0,i[f+8>>2]=0,i[f+12>>2]=0,i[e+32>>2]=0,i[e+36>>2]=0,i[e+40>>2]=0,i[e+44>>2]=0,i[e+48>>2]=0,i[e+16>>2]=86356,i[e+60>>2]=0,i[e+64>>2]=0,i[e+52>>2]=0,i[e+56>>2]=0,i[e+72>>2]=-1,i[e+76>>2]=-1,i[e+80>>2]=-1,i[e+84>>2]=-1,i[e+116>>2]=0,i[e+88>>2]=0,i[e+92>>2]=0,i[e+96>>2]=0,i[e+100>>2]=0,i[e+104>>2]=0,i[e+108>>2]=0,g[e+112>>1]=0,i[e+16>>2]=87364,i[e+32>>2]=1768517222,i[k+100>>2]=f,f=i[k+104>>2],i[k+104>>2]=e;f:{if(!f||(e=i[f+4>>2],i[f+4>>2]=e-1,e))break f;W[i[i[f>>2]+8>>2]](f),y(f)}e=p(120),i[e+4>>2]=0,i[e+8>>2]=0,i[e>>2]=90004,f=e+16|0,i[f+8>>2]=0,i[f+12>>2]=0,i[e+32>>2]=0,i[e+36>>2]=0,i[e+40>>2]=0,i[e+44>>2]=0,i[e+48>>2]=0,i[e+16>>2]=86356,i[e+60>>2]=0,i[e+64>>2]=0,i[e+52>>2]=0,i[e+56>>2]=0,i[e+72>>2]=-1,i[e+76>>2]=-1,i[e+80>>2]=-1,i[e+84>>2]=-1,i[e+88>>2]=0,i[e+92>>2]=0,i[e+96>>2]=0,i[e+100>>2]=0,i[e+104>>2]=0,i[e+108>>2]=0,u[e+112|0]=0,i[e+16>>2]=87444,i[e+32>>2]=1768977008,i[k+116>>2]=f,f=i[k+120>>2],i[k+120>>2]=e;f:{if(!f||(e=i[f+4>>2],i[f+4>>2]=e-1,e))break f;W[i[i[f>>2]+8>>2]](f),y(f)}e=p(128),i[e+4>>2]=0,i[e+8>>2]=0,i[e>>2]=89844,f=e+16|0,i[f+8>>2]=0,i[f+12>>2]=0,i[e+32>>2]=0,i[e+36>>2]=0,i[e+40>>2]=0,i[e+44>>2]=0,i[e+48>>2]=0,i[e+16>>2]=86356,i[e+60>>2]=0,i[e+64>>2]=0,i[e+52>>2]=0,i[e+56>>2]=0,i[e+72>>2]=-1,i[e+76>>2]=-1,i[e+80>>2]=-1,i[e+84>>2]=-1,i[e+116>>2]=0,i[e+88>>2]=0,i[e+92>>2]=0,i[e+96>>2]=0,i[e+100>>2]=0,i[e+104>>2]=0,i[e+108>>2]=0,g[e+112>>1]=0,i[e+16>>2]=87204,i[e+32>>2]=1885959277,i[e+120>>2]=0,i[k+92>>2]=f,f=i[k+96>>2],i[k+96>>2]=e;f:{if(!f||(e=i[f+4>>2],i[f+4>>2]=e-1,e))break f;W[i[i[f>>2]+8>>2]](f),y(f)}f=i[k+44>>2],i[n+8>>2]=i[k+36>>2],e=i[k+40>>2],i[n+12>>2]=e,e&&(i[e+4>>2]=i[e+4>>2]+1),r2(f+36|0,n+8|0),e=i[n+12>>2];f:{if(!e||(f=i[e+4>>2],i[e+4>>2]=f-1,f))break f;W[i[i[e>>2]+8>>2]](e),y(e)}f=i[k+44>>2],i[n+8>>2]=i[k+92>>2],e=i[k+96>>2],i[n+12>>2]=e,e&&(i[e+4>>2]=i[e+4>>2]+1),r2(f+36|0,n+8|0),e=i[n+12>>2];f:{if(!e||(f=i[e+4>>2],i[e+4>>2]=f-1,f))break f;W[i[i[e>>2]+8>>2]](e),y(e)}f=i[k+44>>2],i[n+8>>2]=i[k+68>>2],e=i[k+72>>2],i[n+12>>2]=e,e&&(i[e+4>>2]=i[e+4>>2]+1),r2(f+36|0,n+8|0),e=i[n+12>>2];f:{if(!e||(f=i[e+4>>2],i[e+4>>2]=f-1,f))break f;W[i[i[e>>2]+8>>2]](e),y(e)}f=i[k+44>>2],i[n+8>>2]=i[k+100>>2],e=i[k+104>>2],i[n+12>>2]=e,e&&(i[e+4>>2]=i[e+4>>2]+1),r2(f+36|0,n+8|0),e=i[n+12>>2];f:{if(!e||(f=i[e+4>>2],i[e+4>>2]=f-1,f))break f;W[i[i[e>>2]+8>>2]](e),y(e)}f=i[k+44>>2],i[n+8>>2]=i[k+116>>2],e=i[k+120>>2],i[n+12>>2]=e,e&&(i[e+4>>2]=i[e+4>>2]+1),r2(f+36|0,n+8|0),e=i[n+12>>2];f:{if(!e||(f=i[e+4>>2],i[e+4>>2]=f-1,f))break f;W[i[i[e>>2]+8>>2]](e),y(e)}f=i[k+116>>2],i[n+8>>2]=i[k+52>>2],e=i[k+56>>2],i[n+12>>2]=e,e&&(i[e+4>>2]=i[e+4>>2]+1),r2(f+36|0,n+8|0),e=i[n+12>>2];f:{if(!e||(f=i[e+4>>2],i[e+4>>2]=f-1,f))break f;W[i[i[e>>2]+8>>2]](e),y(e)}f=i[k+116>>2],i[n+8>>2]=i[k+60>>2],e=i[k+64>>2],i[n+12>>2]=e,e&&(i[e+4>>2]=i[e+4>>2]+1),r2(f+36|0,n+8|0),e=i[n+12>>2];f:{if(!e||(f=i[e+4>>2],i[e+4>>2]=f-1,f))break f;W[i[i[e>>2]+8>>2]](e),y(e)}n3(k+124|0,i[k+128>>2]),i[k+124>>2]=k+128,i[k+128>>2]=0,i[k+132>>2]=0,B=i[k+44>>2],o=i[k+48>>2],o&&(i[o+4>>2]=i[o+4>>2]+1),e=i[k+20>>2],t=i[k+24>>2];f:{if(e>>>0<t>>>0){i[e+4>>2]=o,i[e>>2]=B,e=e+8|0;break f}if(s=i[k+16>>2],e=e-s|0,m=e>>3,f=m+1|0,f>>>0>=536870912)break r;if(t=t-s|0,w=t>>2,t=t>>>0>=2147483640?536870911:f>>>0<w>>>0?w:f,t){if(t>>>0>=536870912)break e;f=p(t<<3)}else f=0;if(w=f+e|0,i[w+4>>2]=o,i[w>>2]=B,o=w-(m<<3)|0,e&&x(o,s,e),i[k+24>>2]=f+(t<<3),e=w+8|0,i[k+20>>2]=e,i[k+16>>2]=o,!s)break f;Z(s)}i[k+20>>2]=e}v=n+16|0;break i}G0(),H()}z0(),H()}if(n=k+128|0,e=i[k+124>>2],(n|0)==(e|0))s=1;else{for(;;){o=i[i[e+20>>2]+104>>2],s=o>>>0<_>>>0,f=i[e+4>>2];i:{if(f){for(;;)if(e=f,f=i[e>>2],!f)break i}for(;f=e,e=i[e+8>>2],(f|0)!=i[e>>2];);}if(_=s?_:o,(e|0)==(n|0))break}s=_+1|0}o=p(184),e=o,i[e+4>>2]=0,i[e+8>>2]=0,i[e>>2]=89964,t=e+16|0,e=t,i[e+8>>2]=0,i[e+12>>2]=0,i[e+16>>2]=0,i[e+20>>2]=0,i[e+24>>2]=0,i[e+28>>2]=0,i[e+32>>2]=0,i[e>>2]=86356,e=o,i[e+60>>2]=0,i[e+64>>2]=0,i[e+52>>2]=0,i[e+56>>2]=0,i[e+72>>2]=-1,i[e+76>>2]=-1,i[e+80>>2]=-1,i[e+84>>2]=-1,i[e+116>>2]=0,i[e+88>>2]=0,i[e+92>>2]=0,i[e+96>>2]=0,i[e+100>>2]=0,i[e+104>>2]=0,i[e+108>>2]=0,g[e+112>>1]=0,i[t>>2]=87284,i[e+128>>2]=0,i[e+132>>2]=0,g[e+124>>1]=0,i[e+136>>2]=0,i[e+140>>2]=0,i[e+144>>2]=0,i[e+148>>2]=0,i[e+152>>2]=0,i[e+156>>2]=0,i[e+160>>2]=0,i[e+164>>2]=0,i[e+168>>2]=0,i[e+172>>2]=0,u[e+173|0]=0,u[e+174|0]=0,u[e+175|0]=0,u[e+176|0]=0,u[e+177|0]=0,u[e+178|0]=0,u[e+179|0]=0,u[e+180|0]=0,i[e+32>>2]=1768842853,i[A+4>>2]=e,i[A>>2]=t,i[e+120>>2]=s,u[t+164|0]=0,i[t+100>>2]=i[t+100>>2]&-2,i[e+128>>2]=r,e=n,f=i[e>>2];i:{e:{if(!f)break e;for(;;){if(e=f,r=i[e+16>>2],r>>>0>s>>>0){if(n=e,f=i[e>>2],f)continue;break e}if(r>>>0>=s>>>0)break i;if(f=i[e+4>>2],!f)break}n=e+4|0}f=p(28),i[f+20>>2]=0,i[f+24>>2]=0,i[f+16>>2]=s,i[f+8>>2]=e,i[f>>2]=0,i[f+4>>2]=0,i[n>>2]=f,e=i[i[k+124>>2]>>2],e&&(i[k+124>>2]=e),m1(i[k+128>>2],f),i[k+132>>2]=i[k+132>>2]+1}i[o+4>>2]=i[o+4>>2]+1,i[f+20>>2]=t,e=i[f+24>>2],i[f+24>>2]=o;i:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break i;W[i[i[e>>2]+8>>2]](e),y(e)}e=i[k+100>>2],i[h+8>>2]=i[A>>2],A=i[A+4>>2],i[h+12>>2]=A,A&&(i[A+4>>2]=i[A+4>>2]+1),r2(e+36|0,h+8|0),A=i[h+12>>2];i:{if(!A||(e=i[A+4>>2],i[A+4>>2]=e-1,e))break i;W[i[i[A>>2]+8>>2]](A),y(A)}v=h+16|0}function x7(A,e,r,f,k,n){var t=0,o=0,s=0,w=0,h=0,_=0,B=0,m=0,X=0,Q=0;s=v-112|0,v=s,W[i[i[e>>2]+120>>2]](A,e,r,f,k,n);i:{e:{r:{f:{if(l[A+44|0])break f;D9(s+100|0,r,k,n,i[k+4>>2]),k=i[s+100>>2],n=i[s+104>>2],d9(A,i[A+4>>2],k,n,n-k>>3),k=i[r>>2],h=i[k+112>>2],w=i[k+108>>2],k=i[A+28>>2],i[s+96>>2]=k,i[s+92>>2]=i[A+32>>2];A:{if(k)break A;k:{if(k=i[f>>2],i[k>>2]<3||(k=i[k+112>>2],!k))break k;W[k|0](i[f+4>>2],w,h,s+96|0,s+92|0);break A}i[s+92>>2]=h,i[s+96>>2]=w}n=p(128),f=n,i[f+4>>2]=0,i[f+8>>2]=0,i[f>>2]=90124,t=f+16|0,i[t+8>>2]=0,i[t+12>>2]=0,i[t+16>>2]=0,i[t+20>>2]=0,i[t+24>>2]=0,i[t+28>>2]=0,i[t+32>>2]=0,i[t>>2]=86356,i[f+60>>2]=0,i[f+64>>2]=0,i[f+52>>2]=0,i[f+56>>2]=0,i[f+72>>2]=-1,i[f+76>>2]=-1,i[f+80>>2]=-1,i[f+84>>2]=-1,i[f+116>>2]=0,i[f+88>>2]=0,i[f+92>>2]=0,i[f+96>>2]=0,i[f+100>>2]=0,i[f+104>>2]=0,i[f+108>>2]=0,g[f+112>>1]=0,i[t>>2]=87604,i[f+32>>2]=1769173093,k=i[s+96>>2],i[f+124>>2]=i[s+92>>2],i[f+120>>2]=k,X=f,Q=W[i[i[e>>2]+48>>2]](e)|0,u[X+112|0]=Q,i[f+4>>2]=i[f+4>>2]+1,k=i[A+4>>2],o=i[A+8>>2];A:{if(k>>>0<o>>>0){i[k+4>>2]=f,i[k>>2]=t,k=k+8|0;break A}if(B=i[A>>2],f=k-B|0,m=f>>3,k=m+1|0,k>>>0>=536870912)break r;if(o=o-B|0,_=o>>2,o=o>>>0>=2147483640?536870911:k>>>0<_>>>0?_:k,o){if(o>>>0>=536870912)break e;k=p(o<<3)}else k=0;if(_=k+f|0,i[_+4>>2]=n,i[_>>2]=t,t=_-(m<<3)|0,f&&x(t,B,f),i[A+8>>2]=k+(o<<3),k=_+8|0,i[A+4>>2]=k,i[A>>2]=t,!B)break A;Z(B)}i[A+4>>2]=k;A:{if((w|0)==i[s+96>>2]&i[s+92>>2]==(h|0))break A;k=p(152),f=k,i[f+4>>2]=0,i[f+8>>2]=0,i[f>>2]=90284,B=f+16|0,i[B+8>>2]=0,i[B+12>>2]=0,i[B+16>>2]=0,i[B+20>>2]=0,i[B+24>>2]=0,i[B+28>>2]=0,i[B+32>>2]=0,i[B>>2]=86356,i[f+60>>2]=0,i[f+64>>2]=0,i[f+52>>2]=0,i[f+56>>2]=0,i[f+72>>2]=-1,i[f+76>>2]=-1,i[f+80>>2]=-1,i[f+84>>2]=-1,i[f+88>>2]=0,i[f+92>>2]=0,i[f+96>>2]=0,i[f+100>>2]=0,i[f+104>>2]=0,i[f+108>>2]=0,u[f+112|0]=0,i[B>>2]=87992,i[f+140>>2]=0,i[f+144>>2]=1,i[f+132>>2]=0,i[f+136>>2]=1,i[f+124>>2]=0,i[f+128>>2]=1,i[f+116>>2]=0,i[f+120>>2]=1,i[f+32>>2]=1668047216,o=i[s+96>>2],t=i[s+92>>2],i[B+108>>2]=h,i[B+112>>2]=1,i[B+100>>2]=w,i[B+104>>2]=1,t=h-t|0,h=t-65537>>>0<4294836223,i[B+124>>2]=0|(h?(t|0)/2|0:t),i[B+128>>2]=h?1:2,t=w-o|0,h=t-65537>>>0<4294836223,i[B+116>>2]=0|(h?(t|0)/2|0:t),i[B+120>>2]=h?1:2,i[f+4>>2]=i[f+4>>2]+1,t=i[A+4>>2],w=i[A+8>>2];k:{if(t>>>0<w>>>0){i[t+4>>2]=f,i[t>>2]=B,f=t+8|0;break k}if(h=i[A>>2],f=t-h|0,_=f>>3,t=_+1|0,t>>>0>=536870912)break r;if(w=w-h|0,o=w>>2,w=w>>>0>=2147483640?536870911:t>>>0<o>>>0?o:t,w){if(w>>>0>=536870912)break e;t=p(w<<3)}else t=0;if(o=t+f|0,i[o+4>>2]=k,i[o>>2]=B,B=o-(_<<3)|0,f&&x(B,h,f),i[A+8>>2]=t+(w<<3),f=o+8|0,i[A+4>>2]=f,i[A>>2]=B,!h)break k;Z(h)}if(i[A+4>>2]=f,f=i[k+4>>2],i[k+4>>2]=f-1,f)break A;W[i[i[k>>2]+8>>2]](k),y(k)}f=i[r>>2],k=i[f+120>>2],h=i[f+116>>2],t=p(136),i[t>>2]=91204,i[t+4>>2]=0,i[t+8>>2]=0,B=t+16|0,f=B,i[f+8>>2]=0,i[f+12>>2]=0,i[f+16>>2]=0,i[f+20>>2]=0,i[f+24>>2]=0,i[f+28>>2]=0,i[f+32>>2]=0,i[f>>2]=86356,i[t+60>>2]=0,i[t+64>>2]=0,i[t+52>>2]=0,i[t+56>>2]=0,i[t+72>>2]=-1,i[t+76>>2]=-1,i[t+80>>2]=-1,i[t+84>>2]=-1,i[t+116>>2]=0,i[t+88>>2]=0,i[t+92>>2]=0,i[t+96>>2]=0,i[t+100>>2]=0,i[t+104>>2]=0,i[t+108>>2]=0,g[t+112>>1]=0,i[f>>2]=88792,i[t+128>>2]=0,i[t+120>>2]=0,i[t+124>>2]=0,i[t+32>>2]=1885960297;A:{k:switch(h|0){case 2:if(w=j0(i[r>>2],0),f=i[t+124>>2],o=i[t+128>>2],f>>>0<o>>>0){u[f|0]=w,i[t+124>>2]=f+1;break A}if(h=i[t+120>>2],f=f-h|0,k=f+1|0,(k|0)<0)break i;o=o-h|0,_=o<<1,o=o>>>0>=1073741823?2147483647:k>>>0<_>>>0?_:k,o?k=p(o):k=0,_=k+f|0,u[_|0]=w,f&&x(k,h,f),i[t+128>>2]=k+o,f=_+1|0,i[t+124>>2]=f,i[t+120>>2]=k,h&&Z(h),i[t+124>>2]=f;break A;case 0:w=j0(i[r>>2],0),f=i[t+124>>2],o=i[t+128>>2];n:{if(f>>>0<o>>>0){u[f|0]=w,f=f+1|0;break n}if(h=i[t+120>>2],f=f-h|0,k=f+1|0,(k|0)<0)break i;if(o=o-h|0,_=o<<1,o=o>>>0>=1073741823?2147483647:k>>>0<_>>>0?_:k,o?k=p(o):k=0,_=k+f|0,u[_|0]=w,f&&x(k,h,f),i[t+128>>2]=k+o,f=_+1|0,i[t+124>>2]=f,i[t+120>>2]=k,!h)break n;Z(h)}i[t+124>>2]=f,w=j0(i[r>>2],1),f=i[t+124>>2],o=i[t+128>>2];n:{if(f>>>0<o>>>0){u[f|0]=w,f=f+1|0;break n}if(h=i[t+120>>2],f=f-h|0,k=f+1|0,(k|0)<0)break i;if(o=o-h|0,_=o<<1,o=o>>>0>=1073741823?2147483647:k>>>0<_>>>0?_:k,o?k=p(o):k=0,_=k+f|0,u[_|0]=w,f&&x(k,h,f),i[t+128>>2]=k+o,f=_+1|0,i[t+124>>2]=f,i[t+120>>2]=k,!h)break n;Z(h)}if(i[t+124>>2]=f,w=j0(i[r>>2],2),f=i[t+124>>2],o=i[t+128>>2],f>>>0<o>>>0){u[f|0]=w,i[t+124>>2]=f+1;break A}if(h=i[t+120>>2],f=f-h|0,k=f+1|0,(k|0)<0)break i;o=o-h|0,_=o<<1,o=o>>>0>=1073741823?2147483647:k>>>0<_>>>0?_:k,o?k=p(o):k=0,_=k+f|0,u[_|0]=w,f&&x(k,h,f),i[t+128>>2]=k+o,f=_+1|0,i[t+124>>2]=f,i[t+120>>2]=k,h&&Z(h),i[t+124>>2]=f;break A;case 1:break k;default:break A}if(k-10>>>0>=6){if((k|0)!=3)break A;IA(B,j0(i[r>>2],3)),IA(B,j0(i[r>>2],4)),IA(B,j0(i[r>>2],5));break A}h=j0(i[r>>2],10),f=i[t+124>>2],o=i[t+128>>2];k:{if(f>>>0<o>>>0){u[f|0]=h,f=f+1|0;break k}if(w=i[t+120>>2],f=f-w|0,k=f+1|0,(k|0)<0)break i;if(o=o-w|0,_=o<<1,o=o>>>0>=1073741823?2147483647:k>>>0<_>>>0?_:k,o?k=p(o):k=0,_=k+f|0,u[_|0]=h,f&&x(k,w,f),i[t+128>>2]=k+o,f=_+1|0,i[t+124>>2]=f,i[t+120>>2]=k,!w)break k;Z(w)}i[t+124>>2]=f,o=i[t+128>>2];k:{if(o>>>0>f>>>0){u[f|0]=h,f=f+1|0;break k}if(w=i[t+120>>2],f=f-w|0,k=f+1|0,(k|0)<0)break i;if(o=o-w|0,_=o<<1,o=o>>>0>=1073741823?2147483647:k>>>0<_>>>0?_:k,o?k=p(o):k=0,_=k+f|0,u[_|0]=h,f&&x(k,w,f),i[t+128>>2]=k+o,f=_+1|0,i[t+124>>2]=f,i[t+120>>2]=k,!w)break k;Z(w)}i[t+124>>2]=f,o=i[t+128>>2];k:{if(o>>>0>f>>>0){u[f|0]=h,f=f+1|0;break k}if(w=i[t+120>>2],f=f-w|0,k=f+1|0,(k|0)<0)break i;if(o=o-w|0,_=o<<1,o=o>>>0>=1073741823?2147483647:k>>>0<_>>>0?_:k,o?k=p(o):k=0,_=k+f|0,u[_|0]=h,f&&x(k,w,f),i[t+128>>2]=k+o,f=_+1|0,i[t+124>>2]=f,i[t+120>>2]=k,!w)break k;Z(w)}i[t+124>>2]=f}i[t+4>>2]=i[t+4>>2]+1,f=i[A+4>>2],w=i[A+8>>2];A:{if(f>>>0<w>>>0){i[f+4>>2]=t,i[f>>2]=B,f=f+8|0;break A}if(h=i[A>>2],f=f-h|0,_=f>>3,k=_+1|0,k>>>0>=536870912)break r;if(w=w-h|0,o=w>>2,w=w>>>0>=2147483640?536870911:k>>>0<o>>>0?o:k,w){if(w>>>0>=536870912)break e;k=p(w<<3)}else k=0;if(o=k+f|0,i[o+4>>2]=t,i[o>>2]=B,B=o-(_<<3)|0,f&&x(B,h,f),i[A+8>>2]=k+(w<<3),f=o+8|0,i[A+4>>2]=f,i[A>>2]=B,!h)break A;Z(h)}if(i[A+4>>2]=f,f=i[r>>2],i[s+8>>2]=95112,u[s+20|0]=l[f+12|0],k=i[f+8>>2],i[s+12>>2]=i[f+4>>2],i[s+16>>2]=k,i[s+24>>2]=i[f+16>>2],k=i[f+20>>2],i[s+28>>2]=k,k&&(i[k+4>>2]=i[k+4>>2]+1),i[s+72>>2]=i[f- -64>>2],B=i[f+60>>2],k=s- -64|0,i[k>>2]=i[f+56>>2],i[k+4>>2]=B,k=i[f+52>>2],i[s+56>>2]=i[f+48>>2],i[s+60>>2]=k,k=i[f+44>>2],i[s+48>>2]=i[f+40>>2],i[s+52>>2]=k,k=i[f+36>>2],i[s+40>>2]=i[f+32>>2],i[s+44>>2]=k,k=i[f+28>>2],i[s+32>>2]=i[f+24>>2],i[s+36>>2]=k,u[s+88|0]=0,u[s+76|0]=0,k=s+76|0,l[f+80|0]==1){A:{if(u[f+79|0]>=0){B=i[f+72>>2],i[k>>2]=i[f+68>>2],i[k+4>>2]=B,i[k+8>>2]=i[f+76>>2];break A}T(k,i[f+68>>2],i[f+72>>2])}u[s+88|0]=1}f=i[s+16>>2],i[e+4>>2]=i[s+12>>2],i[e+8>>2]=f,u[e+12|0]=l[s+20|0],f=i[s+24>>2],B=i[s+28>>2],B&&(i[B+4>>2]=i[B+4>>2]+1),i[e+16>>2]=f,f=i[e+20>>2],i[e+20>>2]=B;A:{if(!f||(B=i[f+4>>2],i[f+4>>2]=B-1,B))break A;W[i[i[f>>2]+8>>2]](f),y(f)}if(f=i[s+36>>2],i[e+24>>2]=i[s+32>>2],i[e+28>>2]=f,i[e- -64>>2]=i[s+72>>2],f=i[s+68>>2],i[e+56>>2]=i[s+64>>2],i[e+60>>2]=f,f=i[s+60>>2],i[e+48>>2]=i[s+56>>2],i[e+52>>2]=f,f=i[s+52>>2],i[e+40>>2]=i[s+48>>2],i[e+44>>2]=f,f=i[s+44>>2],i[e+32>>2]=i[s+40>>2],i[e+36>>2]=f,bt(e+68|0,k),e=s+8|0,PA(e),Gf(e,i[r>>2],0),r=A,f=i[A+4>>2],A=i[s+8>>2],e=i[s+12>>2],d9(r,f,A,e,e-A>>3),r=i[s+8>>2],r){if(A=i[s+12>>2],e=r,(A|0)!=(e|0)){for(;;){e=i[A-4>>2];A:{if(!e||(f=i[e+4>>2],i[e+4>>2]=f-1,f))break A;W[i[i[e>>2]+8>>2]](e),y(e)}if(A=A-8|0,(r|0)==(A|0))break}e=i[s+8>>2]}i[s+12>>2]=r,Z(e)}if(A=i[t+4>>2],i[t+4>>2]=A-1,A||(W[i[i[t>>2]+8>>2]](t),y(t)),A=i[n+4>>2],i[n+4>>2]=A-1,A||(W[i[i[n>>2]+8>>2]](n),y(n)),r=i[s+100>>2],!r)break f;if(A=i[s+104>>2],e=r,(A|0)!=(e|0)){for(;;){e=i[A-4>>2];A:{if(!e||(f=i[e+4>>2],i[e+4>>2]=f-1,f))break A;W[i[i[e>>2]+8>>2]](e),y(e)}if(A=A-8|0,(r|0)==(A|0))break}e=i[s+100>>2]}i[s+104>>2]=r,Z(e)}v=s+112|0;return}G0(),H()}z0(),H()}G0(),H()}function rB(A,e,r,f,k,n){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0;var t=0,o=0,s=0,w=0,h=0,_=0,B=0,m=0,X=0,Q=0;t=v-16|0,v=t,o=(f|0)/8|0,w=i[r>>2],B=i[r+4>>2]-w|0,s=i[k>>2];i:{if(o>>>0>B-s>>>0){if(e=p(40),i[t+4>>2]=e,i[t+8>>2]=39,i[t+12>>2]=-2147483608,r=l[9161]|l[9162]<<8|(l[9163]<<16|l[9164]<<24),f=l[9157]|l[9158]<<8|(l[9159]<<16|l[9160]<<24),u[e|0]=f,u[e+1|0]=f>>>8,u[e+2|0]=f>>>16,u[e+3|0]=f>>>24,u[e+4|0]=r,u[e+5|0]=r>>>8,u[e+6|0]=r>>>16,u[e+7|0]=r>>>24,u[e+39|0]=0,r=l[9192]|l[9193]<<8|(l[9194]<<16|l[9195]<<24),f=l[9188]|l[9189]<<8|(l[9190]<<16|l[9191]<<24),u[e+31|0]=f,u[e+32|0]=f>>>8,u[e+33|0]=f>>>16,u[e+34|0]=f>>>24,u[e+35|0]=r,u[e+36|0]=r>>>8,u[e+37|0]=r>>>16,u[e+38|0]=r>>>24,r=l[9185]|l[9186]<<8|(l[9187]<<16|l[9188]<<24),f=l[9181]|l[9182]<<8|(l[9183]<<16|l[9184]<<24),u[e+24|0]=f,u[e+25|0]=f>>>8,u[e+26|0]=f>>>16,u[e+27|0]=f>>>24,u[e+28|0]=r,u[e+29|0]=r>>>8,u[e+30|0]=r>>>16,u[e+31|0]=r>>>24,r=l[9177]|l[9178]<<8|(l[9179]<<16|l[9180]<<24),f=l[9173]|l[9174]<<8|(l[9175]<<16|l[9176]<<24),u[e+16|0]=f,u[e+17|0]=f>>>8,u[e+18|0]=f>>>16,u[e+19|0]=f>>>24,u[e+20|0]=r,u[e+21|0]=r>>>8,u[e+22|0]=r>>>16,u[e+23|0]=r>>>24,r=l[9169]|l[9170]<<8|(l[9171]<<16|l[9172]<<24),f=l[9165]|l[9166]<<8|(l[9167]<<16|l[9168]<<24),u[e+8|0]=f,u[e+9|0]=f>>>8,u[e+10|0]=f>>>16,u[e+11|0]=f>>>24,u[e+12|0]=r,u[e+13|0]=r>>>8,u[e+14|0]=r>>>16,u[e+15|0]=r>>>24,q(A,2,136,t+4|0),u[t+15|0]>=0)break i;Z(i[t+4>>2]);break i}h=w+s|0,_=l[h|0],w=l[h+1|0];e:{if((f|0)==32){_=w<<16|_<<24|l[h+2|0]<<8,w=l[h+3|0],h=4;break e}_=_<<8,h=2}if(h=h+s|0,i[k>>2]=h,s=B-h|0,h=w|_,o=O0(o,o>>31,h,0),w=l0<<1|o>>>31,o=o<<1,!w&s>>>0<o>>>0|w){if(e=p(40),i[t+4>>2]=e,i[t+8>>2]=39,i[t+12>>2]=-2147483608,r=l[9161]|l[9162]<<8|(l[9163]<<16|l[9164]<<24),f=l[9157]|l[9158]<<8|(l[9159]<<16|l[9160]<<24),u[e|0]=f,u[e+1|0]=f>>>8,u[e+2|0]=f>>>16,u[e+3|0]=f>>>24,u[e+4|0]=r,u[e+5|0]=r>>>8,u[e+6|0]=r>>>16,u[e+7|0]=r>>>24,u[e+39|0]=0,r=l[9192]|l[9193]<<8|(l[9194]<<16|l[9195]<<24),f=l[9188]|l[9189]<<8|(l[9190]<<16|l[9191]<<24),u[e+31|0]=f,u[e+32|0]=f>>>8,u[e+33|0]=f>>>16,u[e+34|0]=f>>>24,u[e+35|0]=r,u[e+36|0]=r>>>8,u[e+37|0]=r>>>16,u[e+38|0]=r>>>24,r=l[9185]|l[9186]<<8|(l[9187]<<16|l[9188]<<24),f=l[9181]|l[9182]<<8|(l[9183]<<16|l[9184]<<24),u[e+24|0]=f,u[e+25|0]=f>>>8,u[e+26|0]=f>>>16,u[e+27|0]=f>>>24,u[e+28|0]=r,u[e+29|0]=r>>>8,u[e+30|0]=r>>>16,u[e+31|0]=r>>>24,r=l[9177]|l[9178]<<8|(l[9179]<<16|l[9180]<<24),f=l[9173]|l[9174]<<8|(l[9175]<<16|l[9176]<<24),u[e+16|0]=f,u[e+17|0]=f>>>8,u[e+18|0]=f>>>16,u[e+19|0]=f>>>24,u[e+20|0]=r,u[e+21|0]=r>>>8,u[e+22|0]=r>>>16,u[e+23|0]=r>>>24,r=l[9169]|l[9170]<<8|(l[9171]<<16|l[9172]<<24),f=l[9165]|l[9166]<<8|(l[9167]<<16|l[9168]<<24),u[e+8|0]=f,u[e+9|0]=f>>>8,u[e+10|0]=f>>>16,u[e+11|0]=f>>>24,u[e+12|0]=r,u[e+13|0]=r>>>8,u[e+14|0]=r>>>16,u[e+15|0]=r>>>24,q(A,2,136,t+4|0),u[t+15|0]>=0)break i;Z(i[t+4>>2]);break i}e:{if(l[e+4|0]==1){if(h>>>0>2)break e;if(e=p(40),i[t+4>>2]=e,i[t+8>>2]=39,i[t+12>>2]=-2147483608,r=l[23659]|l[23660]<<8|(l[23661]<<16|l[23662]<<24),f=l[23655]|l[23656]<<8|(l[23657]<<16|l[23658]<<24),u[e|0]=f,u[e+1|0]=f>>>8,u[e+2|0]=f>>>16,u[e+3|0]=f>>>24,u[e+4|0]=r,u[e+5|0]=r>>>8,u[e+6|0]=r>>>16,u[e+7|0]=r>>>24,u[e+39|0]=0,r=l[23690]|l[23691]<<8|(l[23692]<<16|l[23693]<<24),f=l[23686]|l[23687]<<8|(l[23688]<<16|l[23689]<<24),u[e+31|0]=f,u[e+32|0]=f>>>8,u[e+33|0]=f>>>16,u[e+34|0]=f>>>24,u[e+35|0]=r,u[e+36|0]=r>>>8,u[e+37|0]=r>>>16,u[e+38|0]=r>>>24,r=l[23683]|l[23684]<<8|(l[23685]<<16|l[23686]<<24),f=l[23679]|l[23680]<<8|(l[23681]<<16|l[23682]<<24),u[e+24|0]=f,u[e+25|0]=f>>>8,u[e+26|0]=f>>>16,u[e+27|0]=f>>>24,u[e+28|0]=r,u[e+29|0]=r>>>8,u[e+30|0]=r>>>16,u[e+31|0]=r>>>24,r=l[23675]|l[23676]<<8|(l[23677]<<16|l[23678]<<24),f=l[23671]|l[23672]<<8|(l[23673]<<16|l[23674]<<24),u[e+16|0]=f,u[e+17|0]=f>>>8,u[e+18|0]=f>>>16,u[e+19|0]=f>>>24,u[e+20|0]=r,u[e+21|0]=r>>>8,u[e+22|0]=r>>>16,u[e+23|0]=r>>>24,r=l[23667]|l[23668]<<8|(l[23669]<<16|l[23670]<<24),f=l[23663]|l[23664]<<8|(l[23665]<<16|l[23666]<<24),u[e+8|0]=f,u[e+9|0]=f>>>8,u[e+10|0]=f>>>16,u[e+11|0]=f>>>24,u[e+12|0]=r,u[e+13|0]=r>>>8,u[e+14|0]=r>>>16,u[e+15|0]=r>>>24,q(A,2,0,t+4|0),u[t+15|0]>=0)break i;Z(i[t+4>>2]);break i}if(h>>>0>1)break e;if(e=p(48),i[t+4>>2]=e,i[t+8>>2]=40,i[t+12>>2]=-2147483600,r=l[23699]|l[23700]<<8|(l[23701]<<16|l[23702]<<24),f=l[23695]|l[23696]<<8|(l[23697]<<16|l[23698]<<24),u[e|0]=f,u[e+1|0]=f>>>8,u[e+2|0]=f>>>16,u[e+3|0]=f>>>24,u[e+4|0]=r,u[e+5|0]=r>>>8,u[e+6|0]=r>>>16,u[e+7|0]=r>>>24,u[e+40|0]=0,r=l[23731]|l[23732]<<8|(l[23733]<<16|l[23734]<<24),f=l[23727]|l[23728]<<8|(l[23729]<<16|l[23730]<<24),u[e+32|0]=f,u[e+33|0]=f>>>8,u[e+34|0]=f>>>16,u[e+35|0]=f>>>24,u[e+36|0]=r,u[e+37|0]=r>>>8,u[e+38|0]=r>>>16,u[e+39|0]=r>>>24,r=l[23723]|l[23724]<<8|(l[23725]<<16|l[23726]<<24),f=l[23719]|l[23720]<<8|(l[23721]<<16|l[23722]<<24),u[e+24|0]=f,u[e+25|0]=f>>>8,u[e+26|0]=f>>>16,u[e+27|0]=f>>>24,u[e+28|0]=r,u[e+29|0]=r>>>8,u[e+30|0]=r>>>16,u[e+31|0]=r>>>24,r=l[23715]|l[23716]<<8|(l[23717]<<16|l[23718]<<24),f=l[23711]|l[23712]<<8|(l[23713]<<16|l[23714]<<24),u[e+16|0]=f,u[e+17|0]=f>>>8,u[e+18|0]=f>>>16,u[e+19|0]=f>>>24,u[e+20|0]=r,u[e+21|0]=r>>>8,u[e+22|0]=r>>>16,u[e+23|0]=r>>>24,r=l[23707]|l[23708]<<8|(l[23709]<<16|l[23710]<<24),f=l[23703]|l[23704]<<8|(l[23705]<<16|l[23706]<<24),u[e+8|0]=f,u[e+9|0]=f>>>8,u[e+10|0]=f>>>16,u[e+11|0]=f>>>24,u[e+12|0]=r,u[e+13|0]=r>>>8,u[e+14|0]=r>>>16,u[e+15|0]=r>>>24,q(A,2,0,t+4|0),u[t+15|0]>=0)break i;Z(i[t+4>>2]);break i}if(_>>>0>=536870912){if(e=p(48),i[t+4>>2]=e,i[t+8>>2]=42,i[t+12>>2]=-2147483600,r=l[25168]|l[25169]<<8|(l[25170]<<16|l[25171]<<24),f=l[25164]|l[25165]<<8|(l[25166]<<16|l[25167]<<24),u[e|0]=f,u[e+1|0]=f>>>8,u[e+2|0]=f>>>16,u[e+3|0]=f>>>24,u[e+4|0]=r,u[e+5|0]=r>>>8,u[e+6|0]=r>>>16,u[e+7|0]=r>>>24,u[e+42|0]=0,r=l[25204]|l[25205]<<8,u[e+40|0]=r,u[e+41|0]=r>>>8,r=l[25200]|l[25201]<<8|(l[25202]<<16|l[25203]<<24),f=l[25196]|l[25197]<<8|(l[25198]<<16|l[25199]<<24),u[e+32|0]=f,u[e+33|0]=f>>>8,u[e+34|0]=f>>>16,u[e+35|0]=f>>>24,u[e+36|0]=r,u[e+37|0]=r>>>8,u[e+38|0]=r>>>16,u[e+39|0]=r>>>24,r=l[25192]|l[25193]<<8|(l[25194]<<16|l[25195]<<24),f=l[25188]|l[25189]<<8|(l[25190]<<16|l[25191]<<24),u[e+24|0]=f,u[e+25|0]=f>>>8,u[e+26|0]=f>>>16,u[e+27|0]=f>>>24,u[e+28|0]=r,u[e+29|0]=r>>>8,u[e+30|0]=r>>>16,u[e+31|0]=r>>>24,r=l[25184]|l[25185]<<8|(l[25186]<<16|l[25187]<<24),f=l[25180]|l[25181]<<8|(l[25182]<<16|l[25183]<<24),u[e+16|0]=f,u[e+17|0]=f>>>8,u[e+18|0]=f>>>16,u[e+19|0]=f>>>24,u[e+20|0]=r,u[e+21|0]=r>>>8,u[e+22|0]=r>>>16,u[e+23|0]=r>>>24,r=l[25176]|l[25177]<<8|(l[25178]<<16|l[25179]<<24),f=l[25172]|l[25173]<<8|(l[25174]<<16|l[25175]<<24),u[e+8|0]=f,u[e+9|0]=f>>>8,u[e+10|0]=f>>>16,u[e+11|0]=f>>>24,u[e+12|0]=r,u[e+13|0]=r>>>8,u[e+14|0]=r>>>16,u[e+15|0]=r>>>24,q(A,6,0,t+4|0),u[t+15|0]>=0)break i;Z(i[t+4>>2]);break i}if(q4(A,e+20|0,h<<3,n,9197),i[A>>2])break i;u[A+19|0]<0&&Z(i[A+8>>2]),Q=(f|0)!=32;e:{r:{for(;;){n=i[k>>2],f=n+4|0,o=i[r>>2],w=o+n|0,_=l[w|0],s=l[w+1|0];f:{if(!Q){B=l[w+3|0],m=l[w+2|0],i[k>>2]=f,f=f+o|0,f=l[f|0]|l[f+1|0]<<8|(l[f+2|0]<<16|l[f+3|0]<<24),w=f<<24|(f&65280)<<8|(f>>>8&65280|f>>>24),f=n+8|0,n=s<<16|_<<24|m<<8|B;break f}n=n+2|0,i[k>>2]=n,n=n+o|0,w=(l[n+1|0]<<16|l[n|0]<<24)>>16,n=(s<<16|_<<24)>>16}i[k>>2]=f;f:{f=i[e+12>>2],s=i[e+16>>2];A:{if(f>>>0<s>>>0){i[f>>2]=n,i[f+4>>2]=w,f=f+8|0;break A}if(_=i[e+8>>2],f=f-_|0,m=f>>3,o=m+1|0,o>>>0>=536870912)break f;if(s=s-_|0,B=s>>2,s=s>>>0>=2147483640?536870911:o>>>0<B>>>0?B:o,s){if(s>>>0>=536870912)break r;o=p(s<<3)}else o=0;if(B=o+f|0,i[B>>2]=n,i[B+4>>2]=w,n=B-(m<<3)|0,f&&x(n,_,f),i[e+16>>2]=o+(s<<3),f=B+8|0,i[e+12>>2]=f,i[e+8>>2]=n,!_)break A;Z(_)}if(i[e+12>>2]=f,X=X+1|0,(h|0)==(X|0))break e;continue}break}G0(),H()}z0(),H()}if(e=i[26917],i[A>>2]=i[26916],i[A+4>>2]=e,A=A+8|0,u[107683]>=0){e=i[26919],i[A>>2]=i[26918],i[A+4>>2]=e,i[A+8>>2]=i[26920];break i}T(A,i[26918],i[26919])}v=t+16|0}function fB(A,e,r,f,k,n,t,o){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,t=t|0,o=o|0;var s=0,w=0,h=U(0),_=0,B=0,m=0,X=0,Q=0,V=0,F=0,I=0,E=0,R=0,N=0,M=0,z=0,S=0,O=0,P=0,a=0,$=0,f0=0,A0=0,n0=U(0),_0=0,m0=0,X0=U(0),g0=0,I0=0,e0=U(0),r0=0,N0=0,U0=0,M0=0,H0=0,P0=0,K0=0,$0=0,L0=0,d0=0,n2=0,Z2=0,Q2=0,g2=0,p2=U(0),H2=U(0),T2=U(0),b2=U(0),e1=U(0);s=v-128|0,v=s,e=i[r>>2],_0=i[e+120>>2],m=j0(e,0),a=j0(i[r>>2],1),e=j0(i[r>>2],2),m0=u1(i[r>>2],6),m0&&(f0=j0(i[r>>2],6));i:{if(!(!((m|0)==8|(a|0)==8)&(e|0)!=8)){e=i[26922],i[A>>2]=i[26921],i[A+4>>2]=e,r=A+8|0;e:{if(u[107703]>=0){e=i[26924],i[r>>2]=i[26923],i[r+4>>2]=e,i[r+8>>2]=i[26925];break e}T(r,i[26923],i[26924])}u[A+20|0]=1;break i}if(!((m|0)==(a|0)&(e|0)==(m|0))){e=i[26922],i[A>>2]=i[26921],i[A+4>>2]=e,r=A+8|0;e:{if(u[107703]>=0){e=i[26924],i[r>>2]=i[26923],i[r+4>>2]=e,i[r+8>>2]=i[26925];break e}T(r,i[26923],i[26924])}u[A+20|0]=1;break i}e=i[r>>2],I=i[e+112>>2],V=i[e+108>>2],w=p(172),i[w>>2]=94812,i[w+4>>2]=0,i[w+8>>2]=0,o0(w+16|0,0,80),e=i[w+4>>2],f=e+1|0,i[w+4>>2]=f,i[w+104>>2]=0,i[w+108>>2]=0,i[w+36>>2]=1,i[w+40>>2]=1,u[w+24|0]=1,g[w+22>>1]=2,g[w+18>>1]=2,g[w+20>>1]=2,i[w+112>>2]=0,i[w+116>>2]=4740,i[w+140>>2]=0,i[w+144>>2]=0,i[w+128>>2]=99,i[w+132>>2]=99,i[w+120>>2]=0,i[w+124>>2]=0,i[w+12>>2]=95160,i[w+148>>2]=0,i[w+152>>2]=0,n=w+140|0,i[w+136>>2]=n,i[w+156>>2]=0,i[w+160>>2]=0,i[w+164>>2]=0,i[w+168>>2]=0,i[w+4>>2]=e,e=i[w+8>>2],F=w+12|0,i[w+96>>2]=F,i[w+8>>2]=e+1,i[w+100>>2]=w,f||(W[i[i[w>>2]+8>>2]](w),y(w)),i[F+120>>2]=3,i[F+116>>2]=1,i[F+112>>2]=I,i[F+108>>2]=V,T0(s+56|0,F,3,V,I,m,o),T0(s+32|0,F,4,V,I,m,o),k=s+88|0;e:{if(i[s+56>>2]){if(e=i[s+60>>2],i[s+80>>2]=i[s+56>>2],i[s+84>>2]=e,u[s+75|0]>=0){f=s- -64|0,e=i[f+4>>2],i[k>>2]=i[f>>2],i[k+4>>2]=e,i[k+8>>2]=i[f+8>>2];break e}T(k,i[s+64>>2],i[s+68>>2]);break e}if(e=i[s+36>>2],i[s+80>>2]=i[s+32>>2],i[s+84>>2]=e,u[s+51|0]>=0){e=i[s+44>>2],i[k>>2]=i[s+40>>2],i[k+4>>2]=e,i[k+8>>2]=i[s+48>>2];break e}T(k,i[s+40>>2],i[s+44>>2])}T0(s+8|0,F,5,V,I,m,o),f=s+112|0;e:{if(i[s+80>>2]){if(e=i[s+84>>2],i[s+104>>2]=i[s+80>>2],i[s+108>>2]=e,u[s+99|0]>=0){e=i[k+4>>2],i[f>>2]=i[k>>2],i[f+4>>2]=e,i[f+8>>2]=i[k+8>>2];break e}T(f,i[s+88>>2],i[s+92>>2]);break e}if(e=i[s+12>>2],i[s+104>>2]=i[s+8>>2],i[s+108>>2]=e,u[s+27|0]>=0){e=i[s+20>>2],i[f>>2]=i[s+16>>2],i[f+4>>2]=e,i[f+8>>2]=i[s+24>>2];break e}T(f,i[s+16>>2],i[s+20>>2])}u[s+27|0]<0&&Z(i[s+16>>2]),u[s+99|0]<0&&Z(i[s+88>>2]),u[s+51|0]<0&&Z(i[s+40>>2]),u[s+75|0]<0&&Z(i[s+64>>2]);e:{if(i[s+104>>2]){if(e=i[s+108>>2],i[A>>2]=i[s+104>>2],i[A+4>>2]=e,r=A+8|0,u[s+123|0]>=0){e=i[f+4>>2],i[r>>2]=i[f>>2],i[r+4>>2]=e,i[r+8>>2]=i[f+8>>2],u[A+20|0]=1;break e}if(T(r,i[s+112>>2],i[s+116>>2]),e=u[s+123|0],u[A+20|0]=1,(e|0)>=0)break e;Z(i[s+112>>2]);break e}u[s+123|0]<0&&Z(i[s+112>>2]);r:{if(!m0)break r;if(T0(s+104|0,F,6,V,I,f0,o),i[s+104>>2]){if(e=i[s+108>>2],i[A>>2]=i[s+104>>2],i[A+4>>2]=e,r=A+8|0,u[s+123|0]>=0){e=i[s+116>>2],i[r>>2]=i[s+112>>2],i[r+4>>2]=e,i[r+8>>2]=i[s+120>>2],u[A+20|0]=1;break e}if(T(r,i[s+112>>2],i[s+116>>2]),e=u[s+123|0],u[A+20|0]=1,(e|0)>=0)break e;Z(i[s+112>>2]);break e}if(u[s+123|0]>=0)break r;Z(i[s+112>>2])}e=i[r>>2],k=e+128|0;r:{f:{if(o=i[e+128>>2],o){for(f=k,e=o;t=i[e+16>>2],f=(t|0)<0?f:e,e=i[(t>>>29&4)+e>>2],!!e;);e=0;A:{if((f|0)==(k|0)||(e=0,i[f+16>>2]>0))break A;r0=i[f+44>>2],e=i[f+56>>2]}for(I0=e,f=k,e=o;t=i[e+16>>2]<=0,f=t?f:e,e=i[(t?4:0)+e>>2],!!e;);Q=0;A:{if((f|0)==(k|0)||(Q=0,i[f+16>>2]>1))break A;N0=i[f+44>>2],Q=i[f+56>>2]}for(f=k,e=o;t=i[e+16>>2]<2,f=t?f:e,e=i[(t?4:0)+e>>2],!!e;);if((f|0)!=(k|0))break f}e=0;break r}if(e=0,i[f+16>>2]>2)break r;U0=i[f+56>>2]>>>1|0,e=i[f+44>>2]}M0=e;r:{f:{if(f=i[n>>2],f){for(t=n,e=f;_=i[e+16>>2]<3,t=_?t:e,e=i[(_?4:0)+e>>2],!!e;);B=0;A:{if((n|0)==(t|0)||(B=0,i[t+16>>2]>3))break A;H0=i[t+44>>2],B=i[t+56>>2]}for(t=n,e=f;_=i[e+16>>2]<4,t=_?t:e,e=i[(_?4:0)+e>>2],!!e;);_=0;A:{if((n|0)==(t|0)||(_=0,i[t+16>>2]>4))break A;P0=i[t+44>>2],_=i[t+56>>2]}for(t=n,e=f;X=i[e+16>>2]<5,t=X?t:e,e=i[(X?4:0)+e>>2],!!e;);if((n|0)!=(t|0))break f}e=0;break r}if(e=0,i[t+16>>2]>5)break r;K0=i[t+56>>2]>>>1|0,e=i[t+44>>2]}t=e,X=0;r:{if(!m0)break r;f:{A:{if(!o)break A;for(e=k;E=i[o+16>>2]<6,e=E?e:o,o=i[(E?4:0)+o>>2],!!o;);if((e|0)==(k|0))break A;if(E=0,i[e+16>>2]>6)break f;$0=i[e+44>>2],E=i[e+56>>2];break f}E=0}if(X=0,!f)break r;for(e=n;k=i[f+16>>2]<6,e=k?e:f,f=i[(k?4:0)+f>>2],!!f;);if(X=0,(e|0)==(n|0)||(X=0,i[e+16>>2]>6))break r;L0=i[e+56>>2],X=i[e+44>>2]}if(k=X,X=_0<<3,n=_0>>>0<4,f=(n?16908801>>>X|0:0)&3,i[s+116>>2]=-1086926434,i[s+120>>2]=1071829221,i[s+108>>2]=1068725436,i[s+112>>2]=-1095748968,u[s+104|0]=1,o=2,A0=1,S4(i[r>>2])&&(r=i[r>>2],e=C[r+6>>1]|C[r+8>>1]<<16,o=C[r+10>>1]|C[r+12>>1]<<16,r=o,le(s+80|0,r&65535,e&65535),i[s+120>>2]=i[s+96>>2],e=i[s+92>>2],i[s+112>>2]=i[s+88>>2],i[s+116>>2]=e,e=i[s+84>>2],i[s+104>>2]=i[s+80>>2],i[s+108>>2]=e,A0=(r&65536)>>>16|0),I)for(d0=_>>>1|0,n2=B>>>1|0,Z2=Q>>>1|0,Q2=I0>>>1|0,R=f-1|0,g2=((n?16843265>>>X|0:0)&3)-1|0,X0=U(16<<m-8),_0=V&-2,X=V&1,g0=1<<m-1&65535,e=-1<<m^-1,$=e&65535,a=1<<a-1,f0=V<<(f0>>>0>8),I0=o&65535,f=0;;){r:{if(!V)break r;N=(G(f,K0)<<1)+t|0,M=(G(f,d0)<<1)+P0|0,z=(G(f,n2)<<1)+H0|0,S=(G(f,Q2)<<1)+r0|0,r=f>>>g2|0,O=(G(r,U0)<<1)+M0|0,P=(G(r,Z2)<<1)+N0|0,r=0,p2=p0[s+120>>2],H2=p0[s+116>>2],T2=p0[s+112>>2],b2=p0[s+108>>2];f:switch(I0|0){case 0:if(A0){if(Q=0,(V|0)!=1)for(;o=r<<1,n=r>>>R<<1,g[o+z>>1]=C[n+O>>1],g[o+M>>1]=C[o+S>>1],g[o+N>>1]=C[n+P>>1],n=r|1,o=n<<1,n=n>>>R<<1,g[o+z>>1]=C[n+O>>1],g[o+M>>1]=C[o+S>>1],g[o+N>>1]=C[n+P>>1],r=r+2|0,Q=Q+2|0,(_0|0)!=(Q|0););if(!X)break r;n=r<<1,r=r>>>R<<1,g[n+z>>1]=C[r+O>>1],g[n+M>>1]=C[n+S>>1],g[n+N>>1]=C[r+P>>1];break r}for(;B=r<<1,o=B+z|0,_=r>>>R<<1,h=U(U(U(U(C[_+O>>1])-X0)*U(1.142899990081787))+U(.5)),U(w2(h))<U(2147483648)?n=~~h:n=-2147483648,g[o>>1]=(n|0)>=0?(e|0)<(n|0)?e:n:0,o=B+M|0,h=U(U(U(U(C[B+S>>1])-X0)*U(1.1689000129699707))+U(.5)),U(w2(h))<U(2147483648)?n=~~h:n=-2147483648,g[o>>1]=(n|0)>=0?(e|0)<(n|0)?e:n:0,o=B+N|0,h=U(U(U(U(C[_+P>>1])-X0)*U(1.142899990081787))+U(.5)),U(w2(h))<U(2147483648)?n=~~h:n=-2147483648,g[o>>1]=(n|0)>=0?(e|0)<(n|0)?e:n:0,r=r+1|0,(V|0)!=(r|0););break r;case 8:for(;m=r<<1,_=C[m+S>>1],n=r>>>R<<1,o=C[n+P>>1]-g0|0,Q=_-o|0,n=C[n+O>>1]-g0|0,B=n+Q|0,g[m+z>>1]=(B|0)>=0?B>>>0>=255?255:B:0,o=o+_|0,g[m+M>>1]=(o|0)>=0?o>>>0>=255?255:o:0,n=Q-n|0,g[m+N>>1]=(n|0)>=0?n>>>0>=255?255:n:0,r=r+1|0,(V|0)!=(r|0););break r;case 16:for(;m=r<<1,n=r>>>R<<1,B=C[n+P>>1]-a|0,_=C[m+S>>1]-(B<<16>>16>>1)|0,n=C[n+O>>1]-a|0,Q=_-(n<<16>>16>>1)|0,o=n+Q<<16>>16,n=o<<2,g[m+z>>1]=(o|0)>=0?n>>>0<$>>>0?n:$:0,o=B+_<<16>>16,n=o<<2,g[m+M>>1]=(o|0)>=0?n>>>0<$>>>0?n:$:0,o=Q<<16>>16,n=o<<2,g[m+N>>1]=(o|0)>=0?n>>>0<$>>>0?n:$:0,r=r+1|0,(V|0)!=(r|0););break r;default:break f}for(;n=r>>>R<<1,_=C[n+P>>1],B=r<<1,o=B+z|0,h=U(C[n+O>>1]-g0|0),n0=A0?h:U(h*U(1.142899990081787)),h=U(C[B+S>>1]),e0=A0?h:U(U(h-X0)*U(1.1689000129699707)),h=U(U(U(b2*n0)+e0)+U(.5)),U(w2(h))<U(2147483648)?n=~~h:n=-2147483648,g[o>>1]=(n|0)>=0?(e|0)<(n|0)?e:n:0,o=B+M|0,e1=U(H2*n0),h=U(_-g0|0),n0=A0?h:U(h*U(1.142899990081787)),h=U(U(e1+U(U(T2*n0)+e0))+U(.5)),U(w2(h))<U(2147483648)?n=~~h:n=-2147483648,g[o>>1]=(n|0)>=0?(e|0)<(n|0)?e:n:0,o=B+N|0,h=U(U(U(p2*n0)+e0)+U(.5)),U(w2(h))<U(2147483648)?n=~~h:n=-2147483648,g[o>>1]=(n|0)>=0?(e|0)<(n|0)?e:n:0,r=r+1|0,(V|0)!=(r|0););}if(!m0|!f0||x(G(f,L0)+k|0,G(f,E)+$0|0,f0),f=f+1|0,(I|0)==(f|0))break}u[A+20|0]=0,i[A+4>>2]=w,i[A>>2]=F;break i}if(A=i[w+4>>2],i[w+4>>2]=A-1,A)break i;W[i[i[w>>2]+8>>2]](w),y(w)}v=s+128|0}function AB(A,e,r,f,k,n,t,o){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,t=t|0,o=o|0;var s=0,w=0,h=0,_=0,B=0,m=0,X=0,Q=0,V=0,F=0,I=0,E=0,R=0,N=0,M=0,z=0,S=0,O=0,P=0,a=0,$=0,f0=0,A0=0,n0=0,_0=0,m0=0,X0=0,g0=0,I0=0,e0=0,r0=0,N0=0,U0=0,M0=0,H0=0,P0=0,K0=0,$0=0,L0=0,d0=0,n2=0,Z2=0;s=v-128|0,v=s,h=j0(i[r>>2],0),t=j0(i[r>>2],1),n=j0(i[r>>2],2),f0=u1(i[r>>2],6),f0&&(H0=j0(i[r>>2],6));i:{if(!(!(h>>>0<9|t>>>0<9)&n>>>0>8)){e=i[26922],i[A>>2]=i[26921],i[A+4>>2]=e,r=A+8|0;e:{if(u[107703]>=0){e=i[26924],i[r>>2]=i[26923],i[r+4>>2]=e,i[r+8>>2]=i[26925];break e}T(r,i[26923],i[26924])}u[A+20|0]=1;break i}if(!((t|0)==(h|0)&(n|0)==(h|0))){e=i[26922],i[A>>2]=i[26921],i[A+4>>2]=e,r=A+8|0;e:{if(u[107703]>=0){e=i[26924],i[r>>2]=i[26923],i[r+4>>2]=e,i[r+8>>2]=i[26925];break e}T(r,i[26923],i[26924])}u[A+20|0]=1;break i}e=i[r>>2],I=i[e+112>>2],_=i[e+108>>2],w=p(172),i[w>>2]=94812,i[w+4>>2]=0,i[w+8>>2]=0,o0(w+16|0,0,80),e=i[w+4>>2],f=e+1|0,i[w+4>>2]=f,i[w+104>>2]=0,i[w+108>>2]=0,i[w+36>>2]=1,i[w+40>>2]=1,u[w+24|0]=1,g[w+22>>1]=2,g[w+18>>1]=2,g[w+20>>1]=2,i[w+112>>2]=0,i[w+116>>2]=4740,i[w+140>>2]=0,i[w+144>>2]=0,i[w+128>>2]=99,i[w+132>>2]=99,i[w+120>>2]=0,i[w+124>>2]=0,i[w+12>>2]=95160,i[w+148>>2]=0,i[w+152>>2]=0,k=w+140|0,i[w+136>>2]=k,i[w+156>>2]=0,i[w+160>>2]=0,i[w+164>>2]=0,i[w+168>>2]=0,i[w+4>>2]=e,e=i[w+8>>2],N=w+12|0,i[w+96>>2]=N,i[w+8>>2]=e+1,i[w+100>>2]=w,f||(W[i[i[w>>2]+8>>2]](w),y(w)),i[N+120>>2]=3,i[N+116>>2]=0,i[N+112>>2]=I,i[N+108>>2]=_,T0(s+56|0,N,0,_,I,h,o),T0(s+32|0,N,1,_,I,t,o),t=s+88|0;e:{if(i[s+56>>2]){if(e=i[s+60>>2],i[s+80>>2]=i[s+56>>2],i[s+84>>2]=e,u[s+75|0]>=0){f=s- -64|0,e=i[f+4>>2],i[t>>2]=i[f>>2],i[t+4>>2]=e,i[t+8>>2]=i[f+8>>2];break e}T(t,i[s+64>>2],i[s+68>>2]);break e}if(e=i[s+36>>2],i[s+80>>2]=i[s+32>>2],i[s+84>>2]=e,u[s+51|0]>=0){e=i[s+44>>2],i[t>>2]=i[s+40>>2],i[t+4>>2]=e,i[t+8>>2]=i[s+48>>2];break e}T(t,i[s+40>>2],i[s+44>>2])}T0(s+8|0,N,2,_,I,n,o),f=s+112|0;e:{if(i[s+80>>2]){if(e=i[s+84>>2],i[s+104>>2]=i[s+80>>2],i[s+108>>2]=e,u[s+99|0]>=0){e=i[t+4>>2],i[f>>2]=i[t>>2],i[f+4>>2]=e,i[f+8>>2]=i[t+8>>2];break e}T(f,i[s+88>>2],i[s+92>>2]);break e}if(e=i[s+12>>2],i[s+104>>2]=i[s+8>>2],i[s+108>>2]=e,u[s+27|0]>=0){e=i[s+20>>2],i[f>>2]=i[s+16>>2],i[f+4>>2]=e,i[f+8>>2]=i[s+24>>2];break e}T(f,i[s+16>>2],i[s+20>>2])}u[s+27|0]<0&&Z(i[s+16>>2]),u[s+99|0]<0&&Z(i[s+88>>2]),u[s+51|0]<0&&Z(i[s+40>>2]),u[s+75|0]<0&&Z(i[s+64>>2]);e:{if(i[s+104>>2]){if(e=i[s+108>>2],i[A>>2]=i[s+104>>2],i[A+4>>2]=e,r=A+8|0,u[s+123|0]>=0){e=i[f+4>>2],i[r>>2]=i[f>>2],i[r+4>>2]=e,i[r+8>>2]=i[f+8>>2],u[A+20|0]=1;break e}if(T(r,i[s+112>>2],i[s+116>>2]),e=u[s+123|0],u[A+20|0]=1,(e|0)>=0)break e;Z(i[s+112>>2]);break e}u[s+123|0]<0&&Z(i[s+112>>2]);r:{if(!f0)break r;if(T0(s+104|0,N,6,_,I,H0,o),i[s+104>>2]){if(e=i[s+108>>2],i[A>>2]=i[s+104>>2],i[A+4>>2]=e,r=A+8|0,u[s+123|0]>=0){e=i[s+116>>2],i[r>>2]=i[s+112>>2],i[r+4>>2]=e,i[r+8>>2]=i[s+120>>2],u[A+20|0]=1;break e}if(T(r,i[s+112>>2],i[s+116>>2]),e=u[s+123|0],u[A+20|0]=1,(e|0)>=0)break e;Z(i[s+112>>2]);break e}if(u[s+123|0]>=0)break r;Z(i[s+112>>2])}e=i[r>>2],f=e+128|0,o=0;r:{f:{t=i[e+128>>2];A:{if(!t)break A;for(e=f,r=t;n=i[r+16>>2],e=(n|0)<0?e:r,r=i[(n>>>29&4)+r>>2],!!r;);r=0;k:{if((e|0)==(f|0)||(r=0,i[e+16>>2]>0))break k;P0=i[e+44>>2],r=i[e+56>>2]}for(K0=r,e=f,r=t;n=i[r+16>>2]<=0,e=n?e:r,r=i[(n?4:0)+r>>2],!!r;);B=0;k:{if((e|0)==(f|0)||(B=0,i[e+16>>2]>1))break k;Q=i[e+56>>2],B=i[e+44>>2]}for(e=f,r=t;n=i[r+16>>2]<2,e=n?e:r,r=i[(n?4:0)+r>>2],!!r;);if((e|0)!=(f|0))break f}X=0;break r}if(X=0,i[e+16>>2]>2)break r;M=i[e+56>>2]>>>1|0,X=i[e+44>>2]}r:{f:{if(e=i[k>>2],e){for(n=k,r=e;o=i[r+16>>2],n=(o|0)<0?n:r,r=i[(o>>>29&4)+r>>2],!!r;);r=0;A:{if((k|0)==(n|0)||(r=0,i[n+16>>2]>0))break A;$0=i[n+44>>2],r=i[n+56>>2]}for(L0=r,n=k,r=e;o=i[r+16>>2]<=0,n=o?n:r,r=i[(o?4:0)+r>>2],!!r;);o=0;A:{if((k|0)==(n|0)||(o=0,i[n+16>>2]>1))break A;E=i[n+56>>2],o=i[n+44>>2]}for(n=k,r=e;h=i[r+16>>2]<2,n=h?n:r,r=i[(h?4:0)+r>>2],!!r;);if((k|0)!=(n|0))break f}h=0;break r}if(h=0,i[n+16>>2]>2)break r;z=i[n+56>>2]>>>1|0,h=i[n+44>>2]}n=0;r:{if(!f0)break r;f:{A:{if(!t)break A;for(r=f;n=i[t+16>>2]<6,r=n?r:t,t=i[(n?4:0)+t>>2],!!t;);if((r|0)==(f|0))break A;if(f=0,i[r+16>>2]>6)break f;d0=i[r+44>>2],f=i[r+56>>2];break f}f=0}if(n2=f,n=0,!e)break r;for(r=k;f=i[e+16>>2]<6,r=f?r:e,e=i[(f?4:0)+e>>2],!!e;);if(n=0,(r|0)==(k|0)||(n=0,i[r+16>>2]>6))break r;Z2=i[r+56>>2],n=i[r+44>>2]}if(e=n,g[o>>1]=C[B>>1],g[h>>1]=C[X>>1],P=_-1|0,a=P>>>1|0,P>>>0>=2)for(V=a>>>0<=1?1:a,r=0;n=r<<2,m=n|2,F=r&-2,t=F+2|0,k=t+B|0,f=B+F|0,g[m+o>>1]=(C[k>>1]+G(C[f>>1],3)|0)+2>>>2,n=n+4|0,g[n+o>>1]=(C[f>>1]+G(C[k>>1],3)|0)+2>>>2,k=t+X|0,f=X+F|0,g[h+m>>1]=(C[k>>1]+G(C[f>>1],3)|0)+2>>>2,g[n+h>>1]=(C[f>>1]+G(C[k>>1],3)|0)+2>>>2,r=r+1|0,(V|0)!=(r|0););if($=_&1,$||(f=P<<1,r=_-2|0,g[f+o>>1]=C[r+B>>1],g[f+h>>1]=C[r+X>>1]),S=E>>>1|0,O=Q>>>1|0,R=I-1|0,Q=R>>>1|0,R>>>0>=2)for(V=Q>>>0<=1?1:Q,r=0;n=r<<1,m=n|1,E=r>>>1|0,t=E+1|0,k=(G(t,O)<<1)+B|0,f=(G(E,O)<<1)+B|0,g[(G(m,S)<<1)+o>>1]=(C[k>>1]+G(C[f>>1],3)|0)+2>>>2,n=n+2|0,g[(G(n,S)<<1)+o>>1]=(C[f>>1]+G(C[k>>1],3)|0)+2>>>2,k=(G(t,M)<<1)+X|0,f=(G(E,M)<<1)+X|0,g[h+(G(z,m)<<1)>>1]=(C[k>>1]+G(C[f>>1],3)|0)+2>>>2,g[h+(G(n,z)<<1)>>1]=(C[f>>1]+G(C[k>>1],3)|0)+2>>>2,r=r+1|0,(V|0)!=(r|0););if(E=I&1,E||(r=(I>>>1|0)-1|0,g[(G(R,S)<<1)+o>>1]=C[(G(r,O)<<1)+B>>1],g[h+(G(z,R)<<1)>>1]=C[(G(r,M)<<1)+X>>1]),!(R>>>0<2|$))for(A0=(_+X|0)-2|0,n0=(_+B|0)-2|0,r=_<<1,_0=(r+h|0)-2|0,F=(r+o|0)-2|0,V=Q>>>0<=1?1:Q,r=0;n=r<<1,m=n|1,Q=r>>>1|0,t=Q+1|0,k=n0+(G(t,O)<<1)|0,f=n0+(G(Q,O)<<1)|0,g[F+(G(m,S)<<1)>>1]=(C[k>>1]+G(C[f>>1],3)|0)+2>>>2,n=n+2|0,g[F+(G(n,S)<<1)>>1]=(C[f>>1]+G(C[k>>1],3)|0)+2>>>2,k=A0+(G(t,M)<<1)|0,f=A0+(G(Q,M)<<1)|0,g[_0+(G(z,m)<<1)>>1]=(C[k>>1]+G(C[f>>1],3)|0)+2>>>2,g[_0+(G(n,z)<<1)>>1]=(C[f>>1]+G(C[k>>1],3)|0)+2>>>2,r=r+1|0,(V|0)!=(r|0););r:{if(E)break r;if(P>>>0>=2)for(Q=a>>>0<=1?1:a,E=h+(G(z,R)<<1)|0,V=(G(R,S)<<1)+o|0,r=(I>>>1|0)-1|0,m=(G(r,M)<<1)+X|0,t=(G(r,O)<<1)+B|0,r=0;n=r<<2,f=n+V|0,k=r&-2,F=k+t|0,g[f+2>>1]=(C[F+2>>1]+G(C[F>>1],3)|0)+2>>>2,g[f+4>>1]=(C[F>>1]+G(C[F+2>>1],3)|0)+2>>>2,f=n+E|0,k=k+m|0,g[f+2>>1]=(C[k+2>>1]+G(C[k>>1],3)|0)+2>>>2,g[f+4>>1]=(C[k>>1]+G(C[k+2>>1],3)|0)+2>>>2,r=r+1|0,(Q|0)!=(r|0););if($)break r;f=_<<1,r=(I>>>1|0)-1|0,g[(f+((G(R,S)<<1)+o|0)|0)-2>>1]=C[(((G(r,O)<<1)+B|0)+_|0)-2>>1],g[(f+(h+(G(z,R)<<1)|0)|0)-2>>1]=C[(((G(r,M)<<1)+X|0)+_|0)-2>>1]}r:{if(R>>>0>=2){if(P>>>0>=2)for(t=1;;){for(a=h+(G(t,z)<<1)|0,$=(G(t,S)<<1)+o|0,r=t+1|0,A0=h+(G(r,z)<<1)|0,n0=(G(r,S)<<1)+o|0,r=t>>>1|0,_0=(G(r,M)<<1)+X|0,F=(G(r,O)<<1)+B|0,r=r+1|0,Q=(G(r,M)<<1)+X|0,E=(G(r,O)<<1)+B|0,r=1;n=r&-2,f=n+Q|0,X0=C[f+2>>1],g0=C[f>>1],f=n+_0|0,I0=C[f>>1],e0=C[f+2>>1],f=n+E|0,r0=C[f>>1],m0=r<<1,k=m0+$|0,N0=C[f+2>>1],V=G(N0,3),f=n+F|0,U0=C[f>>1],m=G(U0,3)+8|0,M0=C[f+2>>1],g[k+2>>1]=V+(r0+(m+G(M0,9)|0)|0)>>>4,f=k,k=G(r0,3),n=G(M0,3)+8|0,g[f>>1]=N0+(k+(n+G(U0,9)|0)|0)>>>4,f=n0+m0|0,g[f+2>>1]=(k+(n+U0|0)|0)+G(N0,9)>>>4,g[f>>1]=((m+M0|0)+G(r0,9)|0)+V>>>4,f=a+m0|0,m=G(X0,3),V=G(I0,3)+8|0,g[f+2>>1]=m+(g0+(V+G(e0,9)|0)|0)>>>4,k=G(g0,3),n=G(e0,3)+8|0,g[f>>1]=X0+(k+(n+G(I0,9)|0)|0)>>>4,f=A0+m0|0,g[f+2>>1]=(k+(n+I0|0)|0)+G(X0,9)>>>4,g[f>>1]=m+((V+e0|0)+G(g0,9)|0)>>>4,r=r+2|0,P>>>0>r>>>0;);if(t=t+2|0,!(R>>>0>t>>>0))break}if(!I)break r}for(k=L0>>>1|0,f=K0>>>1|0,t=_<<1,n=H0>>>0>8?t:_,r=0;t&&x((G(r,k)<<1)+$0|0,(G(r,f)<<1)+P0|0,t),!f0|!n||x(G(r,Z2)+e|0,G(r,n2)+d0|0,n),r=r+1|0,(I|0)!=(r|0););}u[A+20|0]=0,i[A+4>>2]=w,i[A>>2]=N;break i}if(A=i[w+4>>2],i[w+4>>2]=A-1,A)break i;W[i[i[w>>2]+8>>2]](w),y(w)}v=s+128|0}function T7(A,e,r,f){var k=0,n=0,t=0,o=0,s=0,w=0,h=0,_=0,B=0,m=0,X=0,Q=0,V=0,F=0,I=0,E=0;i:{e:{r:for(;;){V=e-4|0,F=e-20|0,X=e-24|0,I=e-12|0,Q=e-16|0,B=e-8|0;f:for(;;){E=f&1;A:{for(;;){k:{n:{t:{u:{o:{l:switch(k=A,t=e-k>>3,t|0){case 0:case 1:break A;case 2:break l;case 3:break o;case 4:break n;case 5:break u;default:break t}if(i[e-4>>2]<=i[k+4>>2])break A;n=i[k>>2],_=i[k+4>>2],A=e-8|0,e=i[A+4>>2],i[k>>2]=i[A>>2],i[k+4>>2]=e;break e}if(A=e-8|0,f=e-4|0,r=i[f>>2],e=i[k+12>>2],(e|0)<=i[k+4>>2]){if((e|0)>=(r|0)||(f=i[k+8>>2],r=i[k+12>>2],e=i[A+4>>2],i[k+8>>2]=i[A>>2],i[k+12>>2]=e,i[A>>2]=f,i[A+4>>2]=r,i[k+12>>2]<=i[k+4>>2]))break A;n=i[k+8>>2],_=i[k+12>>2];break i}if(n=i[k>>2],_=i[k+4>>2],(e|0)<(r|0)){e=i[A+4>>2],i[k>>2]=i[A>>2],i[k+4>>2]=e;break e}if(r=i[k+8>>2],e=i[k+12>>2],i[k+8>>2]=n,i[k+12>>2]=_,i[k>>2]=r,i[k+4>>2]=e,(_|0)>=i[f>>2])break A;e=i[A+4>>2],i[k+8>>2]=i[A>>2],i[k+12>>2]=e;break e}if(yr(k,k+8|0,k+16|0,k+24|0),i[e-4>>2]<=i[k+28>>2]||(f=i[k+24>>2],r=i[k+28>>2],e=e-8|0,A=i[e+4>>2],i[k+24>>2]=i[e>>2],i[k+28>>2]=A,i[e>>2]=f,i[e+4>>2]=r,i[k+28>>2]<=i[k+20>>2])||(n=i[k+24>>2],_=i[k+28>>2],A=i[k+20>>2],i[k+24>>2]=i[k+16>>2],i[k+28>>2]=A,i[k+16>>2]=n,i[k+20>>2]=_,(_|0)<=i[k+12>>2])||(A=i[k+12>>2],i[k+16>>2]=i[k+8>>2],i[k+20>>2]=A,i[k+8>>2]=n,i[k+12>>2]=_,(_|0)<=i[k+4>>2]))break A;break i}if((t|0)<=23){if(A=k+8|0,r=(e|0)==(k|0)|(e|0)==(A|0),f&1){if(r)break A;for(s=k;;){if(r=A,i[s+12>>2]>i[s+4>>2]){for(n=i[A>>2],f=i[A+4>>2],t=A;;){t:{if(A=s,w=i[A+4>>2],i[t>>2]=i[A>>2],i[t+4>>2]=w,(A|0)==(k|0)){A=k;break t}if(s=A-8|0,t=A,(f|0)>i[A-4>>2])continue}break}i[A>>2]=n,i[A+4>>2]=f}if(s=r,A=s+8|0,(e|0)==(A|0))break}break A}if(r)break A;for(;;){if(i[k+12>>2]>i[k+4>>2]){for(f=i[A>>2],r=i[A+4>>2],s=A;n=s,s=k,t=i[k+4>>2],i[n>>2]=i[k>>2],i[n+4>>2]=t,k=k-8|0,(r|0)>i[s-4>>2];);i[s>>2]=f,i[s+4>>2]=r}if(k=A,A=k+8|0,(e|0)==(A|0))break}break A}if(!r){if((e|0)==(k|0))break A;for(h=t-2>>>1|0,A=h;;){_=A;t:{if(A>>>0>h>>>0||(w=(A<<3)+k|0,r=A<<1,s=r|1,A=(s<<3)+k|0,r=r+2|0,(r|0)<(t|0)&&(f=r,r=i[A+4>>2]>i[A+12>>2],s=r?f:s,A=(r?8:0)+A|0),i[A+4>>2]>i[w+4>>2]))break t;for(f=i[w>>2],r=i[w+4>>2];;){u:{if(n=w,w=A,m=i[A+4>>2],i[n>>2]=i[A>>2],i[n+4>>2]=m,(s|0)>(h|0))break u;if(n=s<<1,s=n|1,A=(s<<3)+k|0,n=n+2|0,(n|0)<(t|0)&&(m=n,n=i[A+4>>2]>i[A+12>>2],s=n?m:s,A=(n?8:0)+A|0),(r|0)>=i[A+4>>2])continue}break}i[w>>2]=f,i[w+4>>2]=r}if(A=_-1|0,!((_|0)>0))break}for(;;){for(w=t,_=t-2>>>1|0,f=i[k>>2],m=i[k+4>>2],s=0,t=k;;){n=s<<1,r=n|1,h=(s<<3)+t|0,A=h+8|0,n=n+2|0;t:{if((n|0)>=(w|0)){s=r;break t}s=r,r=i[h+12>>2]>i[h+20>>2],s=r?n:s,A=r?h+16|0:A}if(r=i[A+4>>2],i[t>>2]=i[A>>2],i[t+4>>2]=r,t=A,!((s|0)<=(_|0)))break}e=e-8|0;t:{if((A|0)==(e|0)){i[A>>2]=f,i[A+4>>2]=m;break t}if(r=i[e+4>>2],i[A>>2]=i[e>>2],i[A+4>>2]=r,i[e>>2]=f,i[e+4>>2]=m,r=(A-k|0)+8>>3,(r|0)<2||(s=r-2>>>1|0,t=(s<<3)+k|0,i[t+4>>2]<=i[A+4>>2]))break t;for(n=i[A>>2],f=i[A+4>>2];;){u:{if(r=A,A=t,t=i[A+4>>2],i[r>>2]=i[A>>2],i[r+4>>2]=t,!s)break u;if(s=s-1>>>1|0,t=(s<<3)+k|0,(f|0)<i[t+4>>2])continue}break}i[A>>2]=n,i[A+4>>2]=f}if(t=w-1|0,!((w|0)>2))break}break A}o=(t<<2&-8)+k|0,w=i[V>>2];t:{if(t>>>0>=129){n=i[o+4>>2];u:{if((n|0)<=i[k+4>>2]){if((n|0)>=(w|0)||(t=i[o>>2],n=i[o+4>>2],A=i[B+4>>2],i[o>>2]=i[B>>2],i[o+4>>2]=A,i[B>>2]=t,i[B+4>>2]=n,i[o+4>>2]<=i[k+4>>2]))break u;t=i[k>>2],n=i[k+4>>2],A=i[o+4>>2],i[k>>2]=i[o>>2],i[k+4>>2]=A,i[o>>2]=t,i[o+4>>2]=n;break u}A=i[k>>2],t=i[k+4>>2];o:{if((n|0)<(w|0)){n=i[B+4>>2],i[k>>2]=i[B>>2],i[k+4>>2]=n;break o}if(n=i[o+4>>2],i[k>>2]=i[o>>2],i[k+4>>2]=n,i[o>>2]=A,i[o+4>>2]=t,(t|0)>=i[V>>2])break u;n=i[B+4>>2],i[o>>2]=i[B>>2],i[o+4>>2]=n}i[B>>2]=A,i[B+4>>2]=t}h=o-8|0,t=i[I>>2],w=o-4|0,n=i[w>>2];u:{if((n|0)<=i[k+12>>2]){if((n|0)>=(t|0)||(t=i[h>>2],n=i[h+4>>2],A=i[Q+4>>2],i[h>>2]=i[Q>>2],i[h+4>>2]=A,i[Q>>2]=t,i[Q+4>>2]=n,i[w>>2]<=i[k+12>>2]))break u;t=i[k+8>>2],n=i[k+12>>2],A=i[h+4>>2],i[k+8>>2]=i[h>>2],i[k+12>>2]=A,i[h>>2]=t,i[h+4>>2]=n;break u}A=i[k+8>>2],s=i[k+12>>2];o:{if((n|0)<(t|0)){n=i[Q+4>>2],i[k+8>>2]=i[Q>>2],i[k+12>>2]=n;break o}if(n=i[h+4>>2],i[k+8>>2]=i[h>>2],i[k+12>>2]=n,i[h>>2]=A,i[h+4>>2]=s,(s|0)>=i[I>>2])break u;n=i[Q+4>>2],i[h>>2]=i[Q>>2],i[h+4>>2]=n}i[Q>>2]=A,i[Q+4>>2]=s}t=i[F>>2],n=i[o+12>>2];u:{if((n|0)<=i[k+20>>2]){if((n|0)>=(t|0)||(t=i[o+8>>2],n=i[o+12>>2],A=i[X+4>>2],i[o+8>>2]=i[X>>2],i[o+12>>2]=A,i[X>>2]=t,i[X+4>>2]=n,i[o+12>>2]<=i[k+20>>2]))break u;t=i[k+16>>2],n=i[k+20>>2],A=i[o+12>>2],i[k+16>>2]=i[o+8>>2],i[k+20>>2]=A,i[o+8>>2]=t,i[o+12>>2]=n;break u}A=i[k+16>>2],s=i[k+20>>2];o:{if((n|0)<(t|0)){n=i[X+4>>2],i[k+16>>2]=i[X>>2],i[k+20>>2]=n;break o}if(n=i[o+12>>2],i[k+16>>2]=i[o+8>>2],i[k+20>>2]=n,i[o+8>>2]=A,i[o+12>>2]=s,(s|0)>=i[F>>2])break u;n=i[X+4>>2],i[o+8>>2]=i[X>>2],i[o+12>>2]=n}i[X>>2]=A,i[X+4>>2]=s}m=i[o+12>>2],s=i[o+4>>2],w=i[w>>2];u:{o:{if((s|0)<=(w|0)){if(n=i[o>>2],_=i[o+4>>2],(s|0)>=(m|0))break u;if(A=i[o+8>>2],t=i[o+12>>2],i[o+8>>2]=n,i[o+12>>2]=_,i[o>>2]=A,i[o+4>>2]=t,(t|0)<=(w|0)){n=A,_=t;break u}n=i[h>>2],_=i[h+4>>2],i[h>>2]=A,i[h+4>>2]=t;break o}if(A=i[h>>2],t=i[h+4>>2],(s|0)<(m|0)){n=i[o+12>>2],i[h>>2]=i[o+8>>2],i[h+4>>2]=n,i[o+8>>2]=A,i[o+12>>2]=t,n=i[o>>2],_=i[o+4>>2];break u}if(n=i[o+4>>2],i[h>>2]=i[o>>2],i[h+4>>2]=n,i[o>>2]=A,i[o+4>>2]=t,(t|0)>=(m|0)){n=A,_=t;break u}n=i[o+8>>2],_=i[o+12>>2],i[o+8>>2]=A,i[o+12>>2]=t}i[o>>2]=n,i[o+4>>2]=_}t=i[k>>2],A=i[k+4>>2],i[k>>2]=n,i[k+4>>2]=_,i[o>>2]=t,i[o+4>>2]=A;break t}if(n=i[k+4>>2],(n|0)<=i[o+4>>2]){if((n|0)>=(w|0)||(t=i[k>>2],n=i[k+4>>2],A=i[B+4>>2],i[k>>2]=i[B>>2],i[k+4>>2]=A,i[B>>2]=t,i[B+4>>2]=n,i[k+4>>2]<=i[o+4>>2]))break t;t=i[o>>2],n=i[o+4>>2],A=i[k+4>>2],i[o>>2]=i[k>>2],i[o+4>>2]=A,i[k>>2]=t,i[k+4>>2]=n;break t}A=i[o>>2],t=i[o+4>>2];u:{if((n|0)<(w|0)){n=i[B+4>>2],i[o>>2]=i[B>>2],i[o+4>>2]=n;break u}if(n=i[k+4>>2],i[o>>2]=i[k>>2],i[o+4>>2]=n,i[k>>2]=A,i[k+4>>2]=t,(t|0)>=i[V>>2])break t;n=i[B+4>>2],i[k>>2]=i[B>>2],i[k+4>>2]=n}i[B>>2]=A,i[B+4>>2]=t}if(r=r-1|0,E){n=i[k>>2],_=i[k+4>>2];break k}if(n=i[k>>2],A=i[k+4>>2],_=A,i[k-4>>2]>i[k+4>>2])break k;t=k,w=k,s=A;t:{if((A|0)>i[V>>2]){for(;;)if(f=t,A=t+8|0,t=A,!((s|0)<=i[f+12>>2]))break t}for(;;){if(A=w+8|0,e>>>0<=A>>>0)break t;if(f=w,w=A,!((s|0)<=i[f+12>>2]))break}}if(w=e,w>>>0>A>>>0)for(;f=w-4|0,w=w-8|0,(s|0)>i[f>>2];);if(A>>>0<w>>>0)for(;;){for(m=i[A>>2],t=i[A+4>>2],f=i[w+4>>2],i[A>>2]=i[w>>2],i[A+4>>2]=f,i[w>>2]=m,i[w+4>>2]=t;t=A,f=A+8|0,A=f,(s|0)<=i[t+12>>2];);for(A=w;t=A-4|0,w=A-8|0,A=w,(s|0)>i[t>>2];);if(A=f,!(w>>>0>A>>>0))break}t=A-8|0,(t|0)!=(k|0)&&(f=i[t+4>>2],i[k>>2]=i[t>>2],i[k+4>>2]=f),i[t>>2]=n,i[t+4>>2]=_,f=0;continue f}yr(k,k+8|0,k+16|0,e-8|0);break A}for(t=k;s=t,t=t+8|0,i[s+12>>2]>(_|0););w=e,A=w;k:{if((k|0)==(s|0))for(;;){if(t>>>0>=w>>>0){m=w;break k}if(A=w-4|0,m=w-8|0,w=m,!(i[A>>2]<=(_|0)))break k}for(;w=A-4|0,m=A-8|0,A=m,i[w>>2]<=(_|0););}if(A=m,w=t,A>>>0>t>>>0)for(;;){for(o=i[w>>2],h=i[w+4>>2],s=i[A+4>>2],i[w>>2]=i[A>>2],i[w+4>>2]=s,i[A>>2]=o,i[A+4>>2]=h;s=w,w=s+8|0,i[s+12>>2]>(_|0););for(;h=A-4|0,A=A-8|0,i[h>>2]<=(_|0););if(!(A>>>0>w>>>0))break}if((k|0)!=(s|0)&&(A=i[s+4>>2],i[k>>2]=i[s>>2],i[k+4>>2]=A),i[s>>2]=n,i[s+4>>2]=_,t>>>0>=m>>>0){if(n=E9(k,s),A=s+8|0,E9(A,e)){if(e=s,A=k,!n)continue r;break A}if(n)continue}break}T7(k,s,r,E),A=s+8|0,f=0;continue}break}break}return}i[A>>2]=n,i[A+4>>2]=_;return}A=i[k+4>>2],i[k+8>>2]=i[k>>2],i[k+12>>2]=A,i[k>>2]=n,i[k+4>>2]=_}function kB(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0;var k=0,n=0,t=0,o=0,s=0,w=0,h=0,_=0,B=0,m=0,X=0,Q=0,V=0,F=0,I=0,E=0,R=0,N=0,M=0,z=0,S=0,O=0,P=0,a=0,$=0,f0=0,A0=0,n0=0,_0=0,m0=0,X0=0;for(n=v-240|0,v=n,X0=e+100|0,B=A+8|0,I=i[18051],R=I-12|0,N=i[18052]-12|0,M=i[18055]-12|0,E=i[18053],z=E-12|0,S=n+48|0,O=n+60|0,Q=n+40|0,V=n+36|0,P=n+92|0,a=i[18060],$=i[18059],f0=i[18057],A0=i[18056],n0=i[18054];;){i:{e:{r:{f:{A:{k:{n:{t:{u:{o:{l:{s:{if(i[r+16>>2]){if(_0=n+200|0,k=_0,i[k+8>>2]=0,i[k+12>>2]=0,i[k+16>>2]=0,i[k+20>>2]=0,i[k+24>>2]=0,i[k+28>>2]=0,i[k+32>>2]=0,i[k>>2]=86356,$6(n+176|0,k,r),i[n+176>>2]!=i[26916]){k=i[n+180>>2],i[A>>2]=i[n+176>>2],i[A+4>>2]=k,i[B+8>>2]=i[n+192>>2],k=i[n+188>>2],i[B>>2]=i[n+184>>2],i[B+4>>2]=k,i[n+184>>2]=0,i[n+188>>2]=0,k=0,i[n+192>>2]=0;break e}if(_=i[n+212>>2],k=i[n+208>>2],s=i[n+232>>2],!_&k>>>0<s>>>0){k=p(40),i[n+28>>2]=k,i[n+32>>2]=38,i[n+36>>2]=-2147483608,t=l[26457]|l[26458]<<8|(l[26459]<<16|l[26460]<<24),o=l[26453]|l[26454]<<8|(l[26455]<<16|l[26456]<<24),u[k|0]=o,u[k+1|0]=o>>>8,u[k+2|0]=o>>>16,u[k+3|0]=o>>>24,u[k+4|0]=t,u[k+5|0]=t>>>8,u[k+6|0]=t>>>16,u[k+7|0]=t>>>24,u[k+38|0]=0,t=l[26487]|l[26488]<<8|(l[26489]<<16|l[26490]<<24),o=l[26483]|l[26484]<<8|(l[26485]<<16|l[26486]<<24),u[k+30|0]=o,u[k+31|0]=o>>>8,u[k+32|0]=o>>>16,u[k+33|0]=o>>>24,u[k+34|0]=t,u[k+35|0]=t>>>8,u[k+36|0]=t>>>16,u[k+37|0]=t>>>24,t=l[26481]|l[26482]<<8|(l[26483]<<16|l[26484]<<24),o=l[26477]|l[26478]<<8|(l[26479]<<16|l[26480]<<24),u[k+24|0]=o,u[k+25|0]=o>>>8,u[k+26|0]=o>>>16,u[k+27|0]=o>>>24,u[k+28|0]=t,u[k+29|0]=t>>>8,u[k+30|0]=t>>>16,u[k+31|0]=t>>>24,t=l[26473]|l[26474]<<8|(l[26475]<<16|l[26476]<<24),o=l[26469]|l[26470]<<8|(l[26471]<<16|l[26472]<<24),u[k+16|0]=o,u[k+17|0]=o>>>8,u[k+18|0]=o>>>16,u[k+19|0]=o>>>24,u[k+20|0]=t,u[k+21|0]=t>>>8,u[k+22|0]=t>>>16,u[k+23|0]=t>>>24,t=l[26465]|l[26466]<<8|(l[26467]<<16|l[26468]<<24),o=l[26461]|l[26462]<<8|(l[26463]<<16|l[26464]<<24),u[k+8|0]=o,u[k+9|0]=o>>>8,u[k+10|0]=o>>>16,u[k+11|0]=o>>>24,u[k+12|0]=t,u[k+13|0]=t>>>8,u[k+14|0]=t>>>16,u[k+15|0]=t>>>24,q(A,2,0,n+28|0),u[n+39|0]<0&&Z(i[n+28>>2]),k=0;break e}if(t=k-s|0,o=t,w=_-(k>>>0<s>>>0)|0,!(!(t&3)&(!w&t>>>0>=4|(w|0)!=0))){k=p(72),i[n+28>>2]=k,i[n+32>>2]=64,i[n+36>>2]=-2147483576,t=l[25084]|l[25085]<<8|(l[25086]<<16|l[25087]<<24),o=l[25080]|l[25081]<<8|(l[25082]<<16|l[25083]<<24),u[k|0]=o,u[k+1|0]=o>>>8,u[k+2|0]=o>>>16,u[k+3|0]=o>>>24,u[k+4|0]=t,u[k+5|0]=t>>>8,u[k+6|0]=t>>>16,u[k+7|0]=t>>>24,u[k+64|0]=0,t=l[25140]|l[25141]<<8|(l[25142]<<16|l[25143]<<24),o=l[25136]|l[25137]<<8|(l[25138]<<16|l[25139]<<24),u[k+56|0]=o,u[k+57|0]=o>>>8,u[k+58|0]=o>>>16,u[k+59|0]=o>>>24,u[k+60|0]=t,u[k+61|0]=t>>>8,u[k+62|0]=t>>>16,u[k+63|0]=t>>>24,t=l[25132]|l[25133]<<8|(l[25134]<<16|l[25135]<<24),o=l[25128]|l[25129]<<8|(l[25130]<<16|l[25131]<<24),u[k+48|0]=o,u[k+49|0]=o>>>8,u[k+50|0]=o>>>16,u[k+51|0]=o>>>24,u[k+52|0]=t,u[k+53|0]=t>>>8,u[k+54|0]=t>>>16,u[k+55|0]=t>>>24,t=l[25124]|l[25125]<<8|(l[25126]<<16|l[25127]<<24),o=l[25120]|l[25121]<<8|(l[25122]<<16|l[25123]<<24),u[k+40|0]=o,u[k+41|0]=o>>>8,u[k+42|0]=o>>>16,u[k+43|0]=o>>>24,u[k+44|0]=t,u[k+45|0]=t>>>8,u[k+46|0]=t>>>16,u[k+47|0]=t>>>24,t=l[25116]|l[25117]<<8|(l[25118]<<16|l[25119]<<24),o=l[25112]|l[25113]<<8|(l[25114]<<16|l[25115]<<24),u[k+32|0]=o,u[k+33|0]=o>>>8,u[k+34|0]=o>>>16,u[k+35|0]=o>>>24,u[k+36|0]=t,u[k+37|0]=t>>>8,u[k+38|0]=t>>>16,u[k+39|0]=t>>>24,t=l[25108]|l[25109]<<8|(l[25110]<<16|l[25111]<<24),o=l[25104]|l[25105]<<8|(l[25106]<<16|l[25107]<<24),u[k+24|0]=o,u[k+25|0]=o>>>8,u[k+26|0]=o>>>16,u[k+27|0]=o>>>24,u[k+28|0]=t,u[k+29|0]=t>>>8,u[k+30|0]=t>>>16,u[k+31|0]=t>>>24,t=l[25100]|l[25101]<<8|(l[25102]<<16|l[25103]<<24),o=l[25096]|l[25097]<<8|(l[25098]<<16|l[25099]<<24),u[k+16|0]=o,u[k+17|0]=o>>>8,u[k+18|0]=o>>>16,u[k+19|0]=o>>>24,u[k+20|0]=t,u[k+21|0]=t>>>8,u[k+22|0]=t>>>16,u[k+23|0]=t>>>24,t=l[25092]|l[25093]<<8|(l[25094]<<16|l[25095]<<24),o=l[25088]|l[25089]<<8|(l[25090]<<16|l[25091]<<24),u[k+8|0]=o,u[k+9|0]=o>>>8,u[k+10|0]=o>>>16,u[k+11|0]=o>>>24,u[k+12|0]=t,u[k+13|0]=t>>>8,u[k+14|0]=t>>>16,u[k+15|0]=t>>>24,q(A,2,0,n+28|0),u[n+39|0]<0&&Z(i[n+28>>2]),k=0;break e}if(t=w,w=t>>>2|0,F=(t&3)<<30|o>>>2,t=i[f+28>>2],o=w,!(!t|!o&t>>>0>=F>>>0)){i[n+120>>2]=0,i[n+28>>2]=E,i[n+92>>2]=72196,i[n+36>>2]=72176,k=n+28|0,i[k+i[z>>2]>>2]=n0,i[n+32>>2]=0,t=k+i[i[n+28>>2]-12>>2]|0,J0(t,Q),u[t+80|0]=0,i[t+72>>2]=0,i[i[M>>2]+V>>2]=A0,i[k+i[N>>2]>>2]=f0,i[n+92>>2]=72196,i[n+28>>2]=72156,i[n+36>>2]=72176,s=R0(Q),i[s>>2]=71232,i[n+80>>2]=0,i[n+84>>2]=0,i[n+72>>2]=0,i[n+76>>2]=0,i[n+88>>2]=24,Y(V0(Y(q2(Y(V,26899,34),F,o),28632,33),i[f+28>>2]),24226,12),k=i[n+88>>2];w:{if(k&16){if(k=O,t=i[n+84>>2],o=i[n+64>>2],t>>>0>=o>>>0)break w;i[n+84>>2]=o,t=o;break w}if(!(k&8)){k=0,u[n+23|0]=0,t=n+12|0;break r}t=i[n+56>>2],k=S}if(o=i[k>>2],k=t-o|0,k>>>0>=2147483640)break s;if(k>>>0>=11){w=k|7,t=p(w+1|0),i[n+20>>2]=w-2147483647,i[n+12>>2]=t,i[n+16>>2]=k;break f}if(u[n+23|0]=k,t=n+12|0,k)break f;k=0;break r}if(i[n+24>>2]=0,w=0,t=0,i[n+16>>2]=0,i[n+20>>2]=0,i[n+12>>2]=i[n+216>>2],(k|0)!=(s|0)|_)for(;;){if(!i[r+16>>2]){i[n+120>>2]=0,i[n+28>>2]=E,i[n+92>>2]=72196,i[n+36>>2]=72176,k=n+28|0,i[k+i[z>>2]>>2]=n0,i[n+32>>2]=0,s=k+i[i[n+28>>2]-12>>2]|0,J0(s,Q),u[s+80|0]=0,i[s+72>>2]=0,i[i[M>>2]+V>>2]=A0,i[k+i[N>>2]>>2]=f0,i[n+92>>2]=72196,i[n+28>>2]=72156,i[n+36>>2]=72176,s=R0(Q),i[s>>2]=71232,i[n+80>>2]=0,i[n+84>>2]=0,i[n+72>>2]=0,i[n+76>>2]=0,i[n+88>>2]=24,Y(q2(Y(q2(Y(V,28201,24),F,o),29128,34),w,t),24226,12),k=i[n+88>>2];w:{if(k&16){if(k=O,t=i[n+84>>2],o=i[n+64>>2],t>>>0>=o>>>0)break w;i[n+84>>2]=o,t=o;break w}if(!(k&8)){k=0,u[n+11|0]=0,t=n;break k}t=i[n+56>>2],k=S}if(o=i[k>>2],k=t-o|0,k>>>0>=2147483640)break l;if(k>>>0>=11){w=k|7,t=p(w+1|0),i[n+8>>2]=w-2147483647,i[n>>2]=t,i[n+4>>2]=k;break n}if(u[n+11|0]=k,t=n,k)break n;k=0;break k}X=C0(r),k=i[n+20>>2],h=i[n+24>>2];w:{if(k>>>0<h>>>0){i[k>>2]=X,k=k+4|0;break w}if(_=i[n+16>>2],k=k-_|0,m0=k>>2,s=m0+1|0,s>>>0>=1073741824)break o;if(h=h-_|0,m=h>>1,h=h>>>0>=2147483644?1073741823:s>>>0<m>>>0?m:s,h){if(h>>>0>=1073741824)break u;s=p(h<<2)}else s=0;if(m=s+k|0,i[m>>2]=X,X=m-(m0<<2)|0,k&&x(X,_,k),i[n+24>>2]=s+(h<<2),k=m+4|0,i[n+20>>2]=k,i[n+16>>2]=X,!_)break w;Z(_)}if(i[n+20>>2]=k,w=w+1|0,t=w?t:t+1|0,!((w|0)!=(F|0)|(t|0)!=(o|0)))break}k=i[e+104>>2];w:{if(k>>>0<u0[e+108>>2]){if(t=i[n+12>>2],i[k+12>>2]=0,i[k+4>>2]=0,i[k+8>>2]=0,i[k>>2]=t,t=i[n+20>>2],s=i[n+16>>2],(t|0)!=(s|0)){if(t=t-s|0,(t|0)<0)break t;o=p(t),i[k+8>>2]=o,i[k+4>>2]=o,w=t+o|0,i[k+12>>2]=w,t&&x(o,s,t),i[k+8>>2]=w}k=k+16|0;break w}k=Yr(X0,n+12|0)}i[e+104>>2]=k,k=1;break A}if(v9(A,e),i[A>>2])break i;if(u[A+19|0]<0&&Z(i[A+8>>2]),l[r+20|0]==1){if(u[n+28|0]=0,u[n+39|0]=0,q(A,2,100,n+28|0),u[n+39|0]>=0)break i;Z(i[n+28>>2]);break i}if(e=i[26917],i[A>>2]=i[26916],i[A+4>>2]=e,u[107683]>=0){A=i[26919],i[B>>2]=i[26918],i[B+4>>2]=A,i[B+8>>2]=i[26920];break i}T(B,i[26918],i[26919]);break i}Q0(),H()}Q0(),H()}G0(),H()}z0(),H()}G0(),H()}if(!k)break k;x(t,o,k)}u[k+t|0]=0,q(A,2,100,n),u[n+11|0]<0&&Z(i[n>>2]),i[n+28>>2]=I,i[i[R>>2]+(n+28|0)>>2]=$,i[n+36>>2]=a,i[s>>2]=71232,u[n+83|0]<0&&Z(i[n+72>>2]),E0(s),y0(P),k=0}if(t=i[n+16>>2],!t)break e;i[n+20>>2]=t,Z(t);break e}if(!k)break r;x(t,o,k)}u[k+t|0]=0,q(A,2,1e3,n+12|0),u[n+23|0]<0&&Z(i[n+12>>2]),i[n+28>>2]=I,i[i[R>>2]+(n+28|0)>>2]=$,i[n+36>>2]=a,i[s>>2]=71232,u[n+83|0]<0&&Z(i[n+72>>2]),E0(s),y0(P),k=0}if(u[n+195|0]<0&&Z(i[n+184>>2]),i[_0>>2]=86356,t=i[n+220>>2],t&&(i[n+224>>2]=t,Z(t)),k)continue}break}v=n+240|0}function nB(A,e,r,f,k,n,t,o){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,t=t|0,o=o|0;var s=0,w=0,h=0,_=0,B=0,m=0,X=0,Q=0,V=0,F=0,I=0,E=0,R=0,N=0,M=0,z=0,S=0,O=0,P=0,a=0,$=0,f0=0,A0=0,n0=0,_0=0,m0=0,X0=0,g0=0,I0=0,e0=0,r0=0,N0=0,U0=0,M0=0,H0=0,P0=0,K0=0,$0=0,L0=0,d0=0,n2=0;s=v-128|0,v=s,k=j0(i[r>>2],0),n=j0(i[r>>2],1),t=j0(i[r>>2],2),X0=u1(i[r>>2],6),X0&&(N0=j0(i[r>>2],6));i:{if(!(!(k>>>0>8|n>>>0>8)&t>>>0<9)){e=i[26922],i[A>>2]=i[26921],i[A+4>>2]=e,e=A+8|0;e:{if(u[107703]>=0){r=i[26924],i[e>>2]=i[26923],i[e+4>>2]=r,i[e+8>>2]=i[26925];break e}T(e,i[26923],i[26924])}u[A+20|0]=1;break i}if(!((k|0)==(n|0)&(k|0)==(t|0))){e=i[26922],i[A>>2]=i[26921],i[A+4>>2]=e,e=A+8|0;e:{if(u[107703]>=0){r=i[26924],i[e>>2]=i[26923],i[e+4>>2]=r,i[e+8>>2]=i[26925];break e}T(e,i[26923],i[26924])}u[A+20|0]=1;break i}e=i[r>>2],N=i[e+112>>2],X=i[e+108>>2],f0=p(172),i[f0>>2]=94812,e=f0,i[e+4>>2]=0,i[e+8>>2]=0,o0(e+16|0,0,80),m=i[e+4>>2],V=m+1|0,i[e+4>>2]=V,i[e+104>>2]=0,i[e+108>>2]=0,i[e+36>>2]=1,i[e+40>>2]=1,u[e+24|0]=1,g[e+22>>1]=2,g[e+18>>1]=2,g[e+20>>1]=2,i[e+112>>2]=0,i[e+116>>2]=4740,i[e+140>>2]=0,i[e+144>>2]=0,i[e+128>>2]=99,i[e+132>>2]=99,i[e+120>>2]=0,i[e+124>>2]=0,i[e+12>>2]=95160,i[e+148>>2]=0,i[e+152>>2]=0,f=e+140|0,i[e+136>>2]=f,i[e+156>>2]=0,i[e+160>>2]=0,i[e+164>>2]=0,i[e+168>>2]=0,i[e+4>>2]=m,m=i[e+8>>2],S=e+12|0,i[e+96>>2]=S,i[e+8>>2]=m+1,i[e+100>>2]=e,V||(W[i[i[e>>2]+8>>2]](e),y(e)),i[S+120>>2]=3,i[S+116>>2]=0,i[S+112>>2]=N,i[S+108>>2]=X,T0(s+56|0,S,0,X,N,k,o),T0(s+32|0,S,1,X,N,n,o),e=s+88|0;e:{if(i[s+56>>2]){if(k=i[s+60>>2],i[s+80>>2]=i[s+56>>2],i[s+84>>2]=k,u[s+75|0]>=0){k=s- -64|0,n=i[k+4>>2],i[e>>2]=i[k>>2],i[e+4>>2]=n,i[e+8>>2]=i[k+8>>2];break e}T(e,i[s+64>>2],i[s+68>>2]);break e}if(k=i[s+36>>2],i[s+80>>2]=i[s+32>>2],i[s+84>>2]=k,u[s+51|0]>=0){k=i[s+44>>2],i[e>>2]=i[s+40>>2],i[e+4>>2]=k,i[e+8>>2]=i[s+48>>2];break e}T(e,i[s+40>>2],i[s+44>>2])}T0(s+8|0,S,2,X,N,t,o),k=s+112|0;e:{if(i[s+80>>2]){if(n=i[s+84>>2],i[s+104>>2]=i[s+80>>2],i[s+108>>2]=n,u[s+99|0]>=0){n=i[e+4>>2],i[k>>2]=i[e>>2],i[k+4>>2]=n,i[k+8>>2]=i[e+8>>2];break e}T(k,i[s+88>>2],i[s+92>>2]);break e}if(e=i[s+12>>2],i[s+104>>2]=i[s+8>>2],i[s+108>>2]=e,u[s+27|0]>=0){e=i[s+20>>2],i[k>>2]=i[s+16>>2],i[k+4>>2]=e,i[k+8>>2]=i[s+24>>2];break e}T(k,i[s+16>>2],i[s+20>>2])}u[s+27|0]<0&&Z(i[s+16>>2]),u[s+99|0]<0&&Z(i[s+88>>2]),u[s+51|0]<0&&Z(i[s+40>>2]),u[s+75|0]<0&&Z(i[s+64>>2]);e:{if(i[s+104>>2]){if(e=i[s+108>>2],i[A>>2]=i[s+104>>2],i[A+4>>2]=e,e=A+8|0,u[s+123|0]>=0){r=i[k+4>>2],i[e>>2]=i[k>>2],i[e+4>>2]=r,i[e+8>>2]=i[k+8>>2],u[A+20|0]=1;break e}if(T(e,i[s+112>>2],i[s+116>>2]),e=u[s+123|0],u[A+20|0]=1,(e|0)>=0)break e;Z(i[s+112>>2]);break e}u[s+123|0]<0&&Z(i[s+112>>2]);r:{if(!X0)break r;if(T0(s+104|0,S,6,X,N,N0,o),i[s+104>>2]){if(e=i[s+108>>2],i[A>>2]=i[s+104>>2],i[A+4>>2]=e,e=A+8|0,u[s+123|0]>=0){r=i[s+116>>2],i[e>>2]=i[s+112>>2],i[e+4>>2]=r,i[e+8>>2]=i[s+120>>2],u[A+20|0]=1;break e}if(T(e,i[s+112>>2],i[s+116>>2]),e=u[s+123|0],u[A+20|0]=1,(e|0)>=0)break e;Z(i[s+112>>2]);break e}if(u[s+123|0]>=0)break r;Z(i[s+112>>2])}e=i[r>>2],k=e+128|0,o=0;r:{f:{t=i[e+128>>2];A:{if(!t){m=0;break A}for(e=k,r=t;n=i[r+16>>2],e=(n|0)<0?e:r,r=i[(n>>>29&4)+r>>2],!!r;);_0=0;k:{if((e|0)==(k|0)||(_0=0,i[e+16>>2]>0))break k;P0=i[e+44>>2],_0=i[e+56>>2]}for(e=k,r=t;n=i[r+16>>2]<=0,e=n?e:r,r=i[(n?4:0)+r>>2],!!r;);r=0;k:{if((e|0)==(k|0)||(r=0,i[e+16>>2]>1))break k;O=i[e+56>>2],r=i[e+44>>2]}for(m=r,e=k,r=t;n=i[r+16>>2]<2,e=n?e:r,r=i[(n?4:0)+r>>2],!!r;);if((e|0)!=(k|0))break f}r=0;break r}if(r=0,i[e+16>>2]>2)break r;P=i[e+56>>2],r=i[e+44>>2]}V=r;r:{f:{if(e=i[f>>2],e){for(n=f,r=e;o=i[r+16>>2],n=(o|0)<0?n:r,r=i[(o>>>29&4)+r>>2],!!r;);m0=0;A:{if((f|0)==(n|0)||(m0=0,i[n+16>>2]>0))break A;K0=i[n+44>>2],m0=i[n+56>>2]}for(n=f,r=e;o=i[r+16>>2]<=0,n=o?n:r,r=i[(o?4:0)+r>>2],!!r;);o=0;A:{if((f|0)==(n|0)||(o=0,i[n+16>>2]>1))break A;a=i[n+56>>2],o=i[n+44>>2]}for(n=f,r=e;F=i[r+16>>2]<2,n=F?n:r,r=i[(F?4:0)+r>>2],!!r;);if((f|0)!=(n|0))break f}r=0;break r}if(r=0,i[n+16>>2]>2)break r;$=i[n+56>>2],r=i[n+44>>2]}F=r,n=0,M=0;r:{if(!X0)break r;f:{A:{if(!t)break A;for(r=k;M=i[t+16>>2]<6,r=M?r:t,t=i[(M?4:0)+t>>2],!!t;);if((r|0)==(k|0))break A;if(g0=0,i[r+16>>2]>6)break f;$0=i[r+44>>2],g0=i[r+56>>2];break f}g0=0}if(M=0,!e)break r;for(r=f;k=i[e+16>>2]<6,r=k?r:e,e=i[(k?4:0)+e>>2],!!e;);if(M=0,(r|0)==(f|0)||(M=0,i[r+16>>2]>6))break r;n=i[r+56>>2],M=i[r+44>>2]}if(u[o|0]=l[m|0],u[F|0]=l[V|0],f=X-1|0,k=f>>>1|0,f>>>0>=2)for(t=k>>>0<=1?1:k,r=0;I=r<<1,w=I|1,e=r>>>1|0,E=e+1|0,B=E+m|0,h=e+m|0,u[w+o|0]=(l[B|0]+G(l[h|0],3)|0)+2>>>2,I=I+2|0,u[I+o|0]=(l[h|0]+G(l[B|0],3)|0)+2>>>2,z=w+F|0,w=V+E|0,e=e+V|0,u[z|0]=(l[w|0]+G(l[e|0],3)|0)+2>>>2,u[F+I|0]=(l[e|0]+G(l[w|0],3)|0)+2>>>2,r=r+1|0,(t|0)!=(r|0););if(I=X&1,I||(e=(X>>>1|0)-1|0,u[f+o|0]=l[e+m|0],u[f+F|0]=l[e+V|0]),e=N-1|0,t=e>>>1|0,e>>>0>=2)for(E=t>>>0<=1?1:t,r=0;B=r<<1,h=B|1,w=r>>>1|0,_=w+1|0,Q=G(_,O)+m|0,R=G(w,O)+m|0,u[G(h,a)+o|0]=(l[Q|0]+G(l[R|0],3)|0)+2>>>2,B=B+2|0,u[G(B,a)+o|0]=(l[R|0]+G(l[Q|0],3)|0)+2>>>2,z=F+G(h,$)|0,h=G(_,P)+V|0,w=G(w,P)+V|0,u[z|0]=(l[h|0]+G(l[w|0],3)|0)+2>>>2,u[F+G(B,$)|0]=(l[w|0]+G(l[h|0],3)|0)+2>>>2,r=r+1|0,(E|0)!=(r|0););if(_=N&1,_||(r=(N>>>1|0)-1|0,u[G(e,a)+o|0]=l[G(r,O)+m|0],u[F+G(e,$)|0]=l[G(r,P)+V|0]),!(e>>>0<2|I))for(w=(X+F|0)-1|0,E=(o+X|0)-1|0,Q=t>>>0<=1?1:t,r=X>>>1|0,t=(r+V|0)-1|0,B=(r+m|0)-1|0,r=0;R=r<<1,n0=R|1,h=r>>>1|0,I0=h+1|0,e0=B+G(I0,O)|0,r0=B+G(h,O)|0,u[E+G(n0,a)|0]=(l[e0|0]+G(l[r0|0],3)|0)+2>>>2,R=R+2|0,u[E+G(R,a)|0]=(l[r0|0]+G(l[e0|0],3)|0)+2>>>2,z=w+G($,n0)|0,n0=t+G(P,I0)|0,h=t+G(h,P)|0,u[z|0]=(l[n0|0]+G(l[h|0],3)|0)+2>>>2,u[w+G($,R)|0]=(l[h|0]+G(l[n0|0],3)|0)+2>>>2,r=r+1|0,(Q|0)!=(r|0););r:{if(_)break r;if(f>>>0>=2)for(t=k>>>0<=1?1:k,w=F+G(e,$)|0,E=G(e,a)+o|0,r=(N>>>1|0)-1|0,B=G(r,P)+V|0,h=G(r,O)+m|0,r=0;_=r<<1,Q=_+E|0,R=r>>>1|0,k=R+h|0,u[Q+1|0]=(l[k+1|0]+G(l[k|0],3)|0)+2>>>2,u[Q+2|0]=(l[k|0]+G(l[k+1|0],3)|0)+2>>>2,_=w+_|0,k=B+R|0,u[_+1|0]=(l[k+1|0]+G(l[k|0],3)|0)+2>>>2,u[_+2|0]=(l[k|0]+G(l[k+1|0],3)|0)+2>>>2,r=r+1|0,(t|0)!=(r|0););if(I)break r;k=X>>>1|0,r=(N>>>1|0)-1|0,u[((G(e,a)+o|0)+X|0)-1|0]=l[(k+(G(r,O)+m|0)|0)-1|0],u[((F+G(e,$)|0)+X|0)-1|0]=l[(k+(G(r,P)+V|0)|0)-1|0]}r:{if(e>>>0>=2){if(f>>>0>=2)for(k=1;;){for(R=F+G(k,$)|0,n0=G(k,a)+o|0,r=k+1|0,I0=F+G(r,$)|0,e0=G(r,a)+o|0,r=k>>>1|0,r0=G(r,P)+V|0,L0=G(r,O)+m|0,r=r+1|0,d0=G(r,P)+V|0,n2=G(r,O)+m|0,r=1;t=r>>>1|0,w=t+d0|0,I=l[w+1|0],w=l[w|0],B=t+r0|0,E=l[B|0],B=l[B+1|0],_=t+n2|0,h=l[_|0],A0=r+n0|0,_=l[_+1|0],U0=G(_,3),Q=t+L0|0,t=l[Q|0],M0=G(t,3)+8|0,Q=l[Q+1|0],u[A0+1|0]=U0+(h+(M0+G(Q,9)|0)|0)>>>4,z=A0,H0=G(h,3),A0=G(Q,3)+8|0,u[z|0]=_+(H0+(A0+G(t,9)|0)|0)>>>4,z=r+e0|0,u[z+1|0]=(H0+(t+A0|0)|0)+G(_,9)>>>4,u[z|0]=((Q+M0|0)+G(h,9)|0)+U0>>>4,t=r+R|0,_=G(I,3),h=G(E,3)+8|0,u[t+1|0]=_+(w+(h+G(B,9)|0)|0)>>>4,z=t,Q=G(w,3),t=G(B,3)+8|0,u[z|0]=I+(Q+(t+G(E,9)|0)|0)>>>4,A0=r+I0|0,u[A0+1|0]=(Q+(t+E|0)|0)+G(I,9)>>>4,u[A0|0]=_+((h+B|0)+G(w,9)|0)>>>4,r=r+2|0,f>>>0>r>>>0;);if(k=k+2|0,!(e>>>0>k>>>0))break}if(!N)break r}for(e=X<<(N0>>>0>8),r=0;X&&x(G(r,m0)+K0|0,G(r,_0)+P0|0,X),!X0|!e||x(G(r,n)+M|0,G(r,g0)+$0|0,e),r=r+1|0,(N|0)!=(r|0););}u[A+20|0]=0,i[A+4>>2]=f0,i[A>>2]=S;break i}if(A=i[f0+4>>2],i[f0+4>>2]=A-1,A)break i;W[i[i[f0>>2]+8>>2]](f0),y(f0)}v=s+128|0}function tB(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0;var k=0,n=0,t=0,o=0,s=0,w=0,h=0,_=0,B=0,m=0,X=0,Q=0,V=0,F=0;t=v-48|0,v=t,z2(t+28|0,e,r),u[t+47|0]<0&&Z(i[t+36>>2]),f=X2(r),n=f&1,u[e+105|0]=n,u[e+104|0]=f>>>1&3;i:{e:{r:{f:{A:{k:{if(n){if(f=o2(r),u[e+110|0]=f&3,g[e+106>>1]=f>>>7,u[e+109|0]=f>>>2&3,u[e+108|0]=f>>>4&7,V=e,F=X2(r)>>>5|0,u[V+111|0]=F,f=X2(r)&63,u[e+112|0]=f,!f){if(e=p(56),i[t+12>>2]=e,i[t+16>>2]=54,i[t+20>>2]=-2147483592,r=l[25747]|l[25748]<<8|(l[25749]<<16|l[25750]<<24),f=l[25743]|l[25744]<<8|(l[25745]<<16|l[25746]<<24),u[e|0]=f,u[e+1|0]=f>>>8,u[e+2|0]=f>>>16,u[e+3|0]=f>>>24,u[e+4|0]=r,u[e+5|0]=r>>>8,u[e+6|0]=r>>>16,u[e+7|0]=r>>>24,u[e+54|0]=0,r=l[25793]|l[25794]<<8|(l[25795]<<16|l[25796]<<24),f=l[25789]|l[25790]<<8|(l[25791]<<16|l[25792]<<24),u[e+46|0]=f,u[e+47|0]=f>>>8,u[e+48|0]=f>>>16,u[e+49|0]=f>>>24,u[e+50|0]=r,u[e+51|0]=r>>>8,u[e+52|0]=r>>>16,u[e+53|0]=r>>>24,r=l[25787]|l[25788]<<8|(l[25789]<<16|l[25790]<<24),f=l[25783]|l[25784]<<8|(l[25785]<<16|l[25786]<<24),u[e+40|0]=f,u[e+41|0]=f>>>8,u[e+42|0]=f>>>16,u[e+43|0]=f>>>24,u[e+44|0]=r,u[e+45|0]=r>>>8,u[e+46|0]=r>>>16,u[e+47|0]=r>>>24,r=l[25779]|l[25780]<<8|(l[25781]<<16|l[25782]<<24),f=l[25775]|l[25776]<<8|(l[25777]<<16|l[25778]<<24),u[e+32|0]=f,u[e+33|0]=f>>>8,u[e+34|0]=f>>>16,u[e+35|0]=f>>>24,u[e+36|0]=r,u[e+37|0]=r>>>8,u[e+38|0]=r>>>16,u[e+39|0]=r>>>24,r=l[25771]|l[25772]<<8|(l[25773]<<16|l[25774]<<24),f=l[25767]|l[25768]<<8|(l[25769]<<16|l[25770]<<24),u[e+24|0]=f,u[e+25|0]=f>>>8,u[e+26|0]=f>>>16,u[e+27|0]=f>>>24,u[e+28|0]=r,u[e+29|0]=r>>>8,u[e+30|0]=r>>>16,u[e+31|0]=r>>>24,r=l[25763]|l[25764]<<8|(l[25765]<<16|l[25766]<<24),f=l[25759]|l[25760]<<8|(l[25761]<<16|l[25762]<<24),u[e+16|0]=f,u[e+17|0]=f>>>8,u[e+18|0]=f>>>16,u[e+19|0]=f>>>24,u[e+20|0]=r,u[e+21|0]=r>>>8,u[e+22|0]=r>>>16,u[e+23|0]=r>>>24,r=l[25755]|l[25756]<<8|(l[25757]<<16|l[25758]<<24),f=l[25751]|l[25752]<<8|(l[25753]<<16|l[25754]<<24),u[e+8|0]=f,u[e+9|0]=f>>>8,u[e+10|0]=f>>>16,u[e+11|0]=f>>>24,u[e+12|0]=r,u[e+13|0]=r>>>8,u[e+14|0]=r>>>16,u[e+15|0]=r>>>24,q(A,2,2006,t+12|0),u[t+23|0]>=0)break f;Z(i[t+12>>2]);break f}if(f=X2(r),u[e+114|0]=f&1,u[e+113|0]=f>>>1,V=e,F=X2(r),u[V+115|0]=F,!l[e+112|0])break A;f=X2(r),u[e+116|0]=f>>>7,u[e+117|0]=f>>>6&1,w=f&63,n=i[e+124>>2],s=i[e+128>>2];n:{if(n>>>0>=s>>>0){if(f=0,k=i[e+120>>2],n=n-k|0,o=n+1|0,(o|0)<0)break k;if(s=s-k|0,h=s<<1,o=s>>>0>=1073741823?2147483647:o>>>0<h>>>0?h:o,o&&(f=p(o)),s=f+n|0,u[s|0]=w,n&&x(f,k,n),i[e+128>>2]=f+o,n=s+1|0,i[e+124>>2]=n,i[e+120>>2]=f,!k)break n;Z(k);break n}u[n|0]=w,n=n+1|0}if(i[e+124>>2]=n,n=1,l[e+112|0]<=1)break A;for(;;){o=X2(r),f=i[e+124>>2],s=i[e+128>>2];n:{if(f>>>0<s>>>0){u[f|0]=o,o=f+1|0;break n}if(w=i[e+120>>2],f=f-w|0,k=f+1|0,(k|0)<0)break k;if(s=s-w|0,h=s<<1,s=s>>>0>=1073741823?2147483647:k>>>0<h>>>0?h:k,s?k=p(s):k=0,h=k+f|0,u[h|0]=o,f&&x(k,w,f),i[e+128>>2]=k+s,o=h+1|0,i[e+124>>2]=o,i[e+120>>2]=k,!w)break n;Z(w)}if(i[e+124>>2]=o,n=n+1|0,!(n>>>0<l[e+112|0]))break}break A}if(e=p(72),i[t+12>>2]=e,i[t+16>>2]=68,i[t+20>>2]=-2147483576,x(e,25798,68),u[e+68|0]=0,q(A,4,0,t+12|0),u[t+23|0]>=0)break f;Z(i[t+12>>2]);break f}G0(),H()}w=l[e+108|0];A:{if(w>>>0<=1||(fn(e+132|0,w-1|0),s=X2(r),w=l[e+108|0],w>>>0<2))break A;for(f=w-2|0,h=i[e+132>>2],n=128;k=1<<f,o=h+(f>>>3&536870908)|0,n&s?k=k|i[o>>2]:k=i[o>>2]&(k^-1),i[o>>2]=k,n=n>>>1|0,k=(f|0)>0,f=f-1|0,!!k;);}o=i[e+148>>2],f=i[e+144>>2],n=o-f|0;A:{if(n>>>0<w>>>0){if(k=w-n|0,s=i[e+152>>2],k>>>0<=s-o>>>0){k&&o0(o,0,k),i[e+148>>2]=k+o;break A}if(o=s-f|0,s=o<<1,s=o>>>0>=1073741823?2147483647:w>>>0<s>>>0?s:w,o=p(s),k&&o0(n+o|0,0,k),n&&x(o,f,n),i[e+152>>2]=o+s,i[e+148>>2]=w+o,i[e+144>>2]=o,!f)break A;Z(f);break A}if(n>>>0<=w>>>0)break A;i[e+148>>2]=f+w}f=l[e+108|0];A:{if(!f||(u[(f+i[e+144>>2]|0)-1|0]=l[e+115|0],f=l[e+108|0],f>>>0<2))break A;for(f=f-2|0;;){k:{if(i[i[e+132>>2]+(f>>>3&536870908)>>2]>>>f&1){n=X2(r),u[i[e+144>>2]+f|0]=n;break k}n=i[e+144>>2]+f|0,u[n|0]=l[n+1|0]}if(n=(f|0)>0,f=f-1|0,!n)break}}if(_=X2(r),_)for(w=0;;){s=C0(r),f=i[e+160>>2],o=i[e+164>>2];A:{if(f>>>0<o>>>0){i[f>>2]=s,f=f+4|0;break A}if(k=i[e+156>>2],f=f-k|0,B=f>>2,n=B+1|0,n>>>0>=1073741824)break i;if(o=o-k|0,h=o>>1,o=o>>>0>=2147483644?1073741823:n>>>0<h>>>0?h:n,o){if(o>>>0>=1073741824)break r;n=p(o<<2)}else n=0;if(h=n+f|0,i[h>>2]=s,s=h-(B<<2)|0,f&&x(s,k,f),i[e+164>>2]=n+(o<<2),f=h+4|0,i[e+160>>2]=f,i[e+156>>2]=s,!k)break A;Z(k)}if(i[e+160>>2]=f,w=w+1|0,(_|0)==(w|0))break}V=e,F=o2(r),g[V+168>>1]=F,V=e,F=o2(r),g[V+170>>1]=F,V=e,F=o2(r),g[V+172>>1]=F,m=X2(r);A:{if(!m)break A;for(Q=e+176|0,B=0;;){if(l[r+20|0])break A;f=X2(r),o=0,i[t+24>>2]=0,i[t+16>>2]=0,i[t+20>>2]=0,u[t+13|0]=f&63,u[t+12|0]=f>>>7,X=o2(r);k:{n:{if(!X|u[r+20|0]&1)break n;for(;;){if(f=o2(r),f){w=0,n=0;t:{if(!f4(r,f))break t;n=p(f),f&&o0(n,0,f),w=f+n|0,s=i[r>>2],k=i[r+4>>2];u:{if(!k){if(!(W[i[i[s>>2]+16>>2]](s,n,f)|0))break u;break t}if(i[k+4>>2]=i[k+4>>2]+1,f=W[i[i[s>>2]+16>>2]](s,n,f)|0,s=i[k+4>>2],i[k+4>>2]=s-1,s||(W[i[i[k>>2]+8>>2]](k),y(k)),f)break t}f=p(32),i[t>>2]=f,i[t+4>>2]=28,i[t+8>>2]=-2147483616,k=l[2534]|l[2535]<<8|(l[2536]<<16|l[2537]<<24),w=l[2530]|l[2531]<<8|(l[2532]<<16|l[2533]<<24),u[f|0]=w,u[f+1|0]=w>>>8,u[f+2|0]=w>>>16,u[f+3|0]=w>>>24,u[f+4|0]=k,u[f+5|0]=k>>>8,u[f+6|0]=k>>>16,u[f+7|0]=k>>>24,u[f+28|0]=0,k=l[2554]|l[2555]<<8|(l[2556]<<16|l[2557]<<24),u[f+24|0]=k,u[f+25|0]=k>>>8,u[f+26|0]=k>>>16,u[f+27|0]=k>>>24,k=l[2550]|l[2551]<<8|(l[2552]<<16|l[2553]<<24),w=l[2546]|l[2547]<<8|(l[2548]<<16|l[2549]<<24),u[f+16|0]=w,u[f+17|0]=w>>>8,u[f+18|0]=w>>>16,u[f+19|0]=w>>>24,u[f+20|0]=k,u[f+21|0]=k>>>8,u[f+22|0]=k>>>16,u[f+23|0]=k>>>24,k=l[2542]|l[2543]<<8|(l[2544]<<16|l[2545]<<24),w=l[2538]|l[2539]<<8|(l[2540]<<16|l[2541]<<24),u[f+8|0]=w,u[f+9|0]=w>>>8,u[f+10|0]=w>>>16,u[f+11|0]=w>>>24,u[f+12|0]=k,u[f+13|0]=k>>>8,u[f+14|0]=k>>>16,u[f+15|0]=k>>>24,q(A,2,100,t),u[t+11|0]<0&&Z(i[t>>2]),Z(n),f=0;break k}f=i[t+20>>2],h=i[t+24>>2];t:{if(f>>>0<h>>>0){i[f+8>>2]=w,i[f+4>>2]=w,i[f>>2]=n,f=f+12|0;break t}if(s=i[t+16>>2],f=f-s|0,k=((f|0)/12|0)+1|0,k>>>0>=357913942)break e;if(h=(h-s|0)/12|0,_=h<<1,_=h>>>0>=178956970?357913941:k>>>0<_>>>0?_:k,_){if(_>>>0>=357913942)break r;k=p(G(_,12))}else k=0;if(h=k+f|0,i[h+8>>2]=w,i[h+4>>2]=w,i[h>>2]=n,n=h+G((f|0)/-12|0,12)|0,f&&x(n,s,f),i[t+24>>2]=k+G(_,12),f=h+12|0,i[t+20>>2]=f,i[t+16>>2]=n,!s)break t;Z(s)}i[t+20>>2]=f}if(o=o+1|0,X>>>0<=o>>>0)break n;if(u[r+20|0]&1)break}}f=i[e+180>>2];n:{if(f>>>0<u0[e+184>>2]){n=C[t+12>>1],i[f+12>>2]=0,i[f+4>>2]=0,i[f+8>>2]=0,g[f>>1]=n,i[f+4>>2]=i[t+16>>2],i[f+8>>2]=i[t+20>>2],i[f+12>>2]=i[t+24>>2],i[t+24>>2]=0,i[t+16>>2]=0,i[t+20>>2]=0,f=f+16|0;break n}f=Nn(Q,t+12|0)}i[e+180>>2]=f,f=1}if(w=f,k=i[t+16>>2],k){if(f=i[t+20>>2],n=k,(f|0)!=(k|0)){for(;n=f-12|0,o=i[n>>2],o&&(i[f-8>>2]=o,Z(o)),f=n,(k|0)!=(f|0););n=i[t+16>>2]}i[t+20>>2]=k,Z(n)}if(!w)break f;if(B=B+1|0,(m|0)==(B|0))break}}if(l[r+20|0]==1){if(u[t+12|0]=0,u[t+23|0]=0,q(A,2,100,t+12|0),u[t+23|0]>=0)break f;Z(i[t+12>>2]);break f}if(e=i[26917],i[A>>2]=i[26916],i[A+4>>2]=e,A=A+8|0,u[107683]>=0){e=i[26919],i[A>>2]=i[26918],i[A+4>>2]=e,i[A+8>>2]=i[26920];break f}T(A,i[26918],i[26919])}v=t+48|0;return}z0(),H()}G0(),H()}G0(),H()}function uB(A,e,r,f,k,n,t,o){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,t=t|0,o=o|0;var s=0,w=0,h=U(0),_=0,B=0,m=0,X=0,Q=0,V=0,F=0,I=0,E=0,R=0,N=0,M=0,z=0,S=0,O=0,P=0,a=0,$=U(0),f0=0,A0=0,n0=0,_0=0,m0=0,X0=U(0),g0=0,I0=0,e0=0,r0=0,N0=0,U0=0,M0=0,H0=0,P0=0,K0=0,$0=0,L0=U(0);s=v-128|0,v=s,e=i[r>>2],f0=i[e+120>>2],k=j0(e,0),f=j0(i[r>>2],1),e=j0(i[r>>2],2),A0=u1(i[r>>2],6),A0&&(n0=j0(i[r>>2],6));i:{if(!(!((k|0)!=8|(f|0)!=8)&(e|0)==8)){e=i[26922],i[A>>2]=i[26921],i[A+4>>2]=e,r=A+8|0;e:{if(u[107703]>=0){e=i[26924],i[r>>2]=i[26923],i[r+4>>2]=e,i[r+8>>2]=i[26925];break e}T(r,i[26923],i[26924])}u[A+20|0]=1;break i}e=i[r>>2],Q=i[e+112>>2],B=i[e+108>>2],w=p(172),i[w>>2]=94812,i[w+4>>2]=0,i[w+8>>2]=0,o0(w+16|0,0,80),e=i[w+4>>2],f=e+1|0,i[w+4>>2]=f,i[w+104>>2]=0,i[w+108>>2]=0,i[w+36>>2]=1,i[w+40>>2]=1,u[w+24|0]=1,g[w+22>>1]=2,g[w+18>>1]=2,g[w+20>>1]=2,i[w+112>>2]=0,i[w+116>>2]=4740,i[w+140>>2]=0,i[w+144>>2]=0,i[w+128>>2]=99,i[w+132>>2]=99,i[w+120>>2]=0,i[w+124>>2]=0,i[w+12>>2]=95160,i[w+148>>2]=0,i[w+152>>2]=0,n=w+140|0,i[w+136>>2]=n,i[w+156>>2]=0,i[w+160>>2]=0,i[w+164>>2]=0,i[w+168>>2]=0,i[w+4>>2]=e,e=i[w+8>>2],X=w+12|0,i[w+96>>2]=X,i[w+8>>2]=e+1,i[w+100>>2]=w,f||(W[i[i[w>>2]+8>>2]](w),y(w)),i[X+120>>2]=3,i[X+116>>2]=1,i[X+112>>2]=Q,i[X+108>>2]=B,T0(s+56|0,X,3,B,Q,k,o),T0(s+32|0,X,4,B,Q,k,o),t=s+88|0;e:{if(i[s+56>>2]){if(e=i[s+60>>2],i[s+80>>2]=i[s+56>>2],i[s+84>>2]=e,u[s+75|0]>=0){f=s- -64|0,e=i[f+4>>2],i[t>>2]=i[f>>2],i[t+4>>2]=e,i[t+8>>2]=i[f+8>>2];break e}T(t,i[s+64>>2],i[s+68>>2]);break e}if(e=i[s+36>>2],i[s+80>>2]=i[s+32>>2],i[s+84>>2]=e,u[s+51|0]>=0){e=i[s+44>>2],i[t>>2]=i[s+40>>2],i[t+4>>2]=e,i[t+8>>2]=i[s+48>>2];break e}T(t,i[s+40>>2],i[s+44>>2])}T0(s+8|0,X,5,B,Q,k,o),f=s+112|0;e:{if(i[s+80>>2]){if(e=i[s+84>>2],i[s+104>>2]=i[s+80>>2],i[s+108>>2]=e,u[s+99|0]>=0){e=i[t+4>>2],i[f>>2]=i[t>>2],i[f+4>>2]=e,i[f+8>>2]=i[t+8>>2];break e}T(f,i[s+88>>2],i[s+92>>2]);break e}if(e=i[s+12>>2],i[s+104>>2]=i[s+8>>2],i[s+108>>2]=e,u[s+27|0]>=0){e=i[s+20>>2],i[f>>2]=i[s+16>>2],i[f+4>>2]=e,i[f+8>>2]=i[s+24>>2];break e}T(f,i[s+16>>2],i[s+20>>2])}u[s+27|0]<0&&Z(i[s+16>>2]),u[s+99|0]<0&&Z(i[s+88>>2]),u[s+51|0]<0&&Z(i[s+40>>2]),u[s+75|0]<0&&Z(i[s+64>>2]);e:{if(i[s+104>>2]){if(e=i[s+108>>2],i[A>>2]=i[s+104>>2],i[A+4>>2]=e,r=A+8|0,u[s+123|0]>=0){e=i[f+4>>2],i[r>>2]=i[f>>2],i[r+4>>2]=e,i[r+8>>2]=i[f+8>>2],u[A+20|0]=1;break e}if(T(r,i[s+112>>2],i[s+116>>2]),e=u[s+123|0],u[A+20|0]=1,(e|0)>=0)break e;Z(i[s+112>>2]);break e}u[s+123|0]<0&&Z(i[s+112>>2]);r:{if(!A0)break r;if(T0(s+104|0,X,6,B,Q,n0,o),i[s+104>>2]){if(e=i[s+108>>2],i[A>>2]=i[s+104>>2],i[A+4>>2]=e,r=A+8|0,u[s+123|0]>=0){e=i[s+116>>2],i[r>>2]=i[s+112>>2],i[r+4>>2]=e,i[r+8>>2]=i[s+120>>2],u[A+20|0]=1;break e}if(T(r,i[s+112>>2],i[s+116>>2]),e=u[s+123|0],u[A+20|0]=1,(e|0)>=0)break e;Z(i[s+112>>2]);break e}if(u[s+123|0]>=0)break r;Z(i[s+112>>2])}e=i[r>>2],k=e+128|0;r:{f:{if(o=i[e+128>>2],o){for(f=k,e=o;t=i[e+16>>2],f=(t|0)<0?f:e,e=i[(t>>>29&4)+e>>2],!!e;);O=0;A:{if((f|0)==(k|0)||(O=0,i[f+16>>2]>0))break A;e0=i[f+44>>2],O=i[f+56>>2]}for(f=k,e=o;t=i[e+16>>2]<=0,f=t?f:e,e=i[(t?4:0)+e>>2],!!e;);P=0;A:{if((f|0)==(k|0)||(P=0,i[f+16>>2]>1))break A;r0=i[f+56>>2],P=i[f+44>>2]}for(f=k,e=o;t=i[e+16>>2]<2,f=t?f:e,e=i[(t?4:0)+e>>2],!!e;);if((f|0)!=(k|0))break f}_0=0;break r}if(_0=0,i[f+16>>2]>2)break r;N0=i[f+56>>2],_0=i[f+44>>2]}r:{f:{if(f=i[n>>2],f){for(t=n,e=f;V=i[e+16>>2]<3,t=V?t:e,e=i[(V?4:0)+e>>2],!!e;);a=0;A:{if((n|0)==(t|0)||(a=0,i[t+16>>2]>3))break A;U0=i[t+44>>2],a=i[t+56>>2]}for(t=n,e=f;V=i[e+16>>2]<4,t=V?t:e,e=i[(V?4:0)+e>>2],!!e;);e=0;A:{if((n|0)==(t|0)||(e=0,i[t+16>>2]>4))break A;M0=i[t+56>>2],e=i[t+44>>2]}for(V=e,t=n,e=f;_=i[e+16>>2]<5,t=_?t:e,e=i[(_?4:0)+e>>2],!!e;);if((n|0)!=(t|0))break f}e=0;break r}if(e=0,i[t+16>>2]>5)break r;H0=i[t+56>>2],e=i[t+44>>2]}t=e,m=0;r:{if(!A0)break r;f:{A:{if(!o)break A;for(e=k;m0=i[o+16>>2]<6,e=m0?e:o,o=i[(m0?4:0)+o>>2],!!o;);if((e|0)==(k|0))break A;if(k=0,i[e+16>>2]>6)break f;P0=i[e+44>>2],k=i[e+56>>2];break f}k=0}if(m0=k,m=0,!f)break r;for(e=n;k=i[f+16>>2]<6,e=k?e:f,f=i[(k?4:0)+f>>2],!!f;);if(m=0,(e|0)==(n|0)||(m=0,i[e+16>>2]>6))break r;K0=i[e+56>>2],m=i[e+44>>2]}f=m,_=f0<<3,o=f0>>>0<4,k=(o?16908801>>>_|0:0)&3,i[s+116>>2]=-1086926434,i[s+120>>2]=1071829221,i[s+108>>2]=1068725436,i[s+112>>2]=-1095748968,u[s+104|0]=1;r:{if(!S4(i[r>>2])){r=2,n=1;break r}r=i[r>>2],e=C[r+6>>1]|C[r+8>>1]<<16,r=C[r+10>>1]|C[r+12>>1]<<16,le(s+80|0,r&65535,e&65535),i[s+120>>2]=i[s+96>>2],e=i[s+92>>2],i[s+112>>2]=i[s+88>>2],i[s+116>>2]=e,e=i[s+84>>2],i[s+104>>2]=i[s+80>>2],i[s+108>>2]=e,n=(r&65536)>>>16|0}if(Q)for(F=k-1|0,$0=((o?16843265>>>_|0:0)&3)-1|0,m=B&-2,f0=B&1,g0=B<<(n0>>>0>8),n0=r&65535,r=0;;){r:{if(!B)break r;I=G(r,H0)+t|0,E=G(r,M0)+V|0,R=G(r,a)+U0|0,N=G(r,O)+e0|0,e=r>>>$0|0,M=G(e,N0)+_0|0,z=G(e,r0)+P|0,e=0;f:switch(n0|0){case 0:if(n){if(o=0,(B|0)!=1)for(;k=e>>>F|0,u[e+R|0]=l[k+M|0],u[e+E|0]=l[e+N|0],u[e+I|0]=l[k+z|0],_=e|1,k=_>>>F|0,u[_+R|0]=l[k+M|0],u[_+E|0]=l[_+N|0],u[_+I|0]=l[k+z|0],e=e+2|0,o=o+2|0,(m|0)!=(o|0););if(!f0)break r;k=e>>>F|0,u[e+R|0]=l[k+M|0],u[e+E|0]=l[e+N|0],u[e+I|0]=l[k+z|0];break r}for(;o=e+R|0,_=e>>>F|0,h=U(U(U(U(l[_+M|0])+U(-16))*U(1.142899990081787))+U(.5)),U(w2(h))<U(2147483648)?k=~~h:k=-2147483648,u[o|0]=(k|0)>=0?k>>>0>=255?255:k:0,o=e+E|0,h=U(U(U(U(l[e+N|0])+U(-16))*U(1.1689000129699707))+U(.5)),U(w2(h))<U(2147483648)?k=~~h:k=-2147483648,u[o|0]=(k|0)>=0?k>>>0>=255?255:k:0,o=e+I|0,h=U(U(U(U(l[_+z|0])+U(-16))*U(1.142899990081787))+U(.5)),U(w2(h))<U(2147483648)?k=~~h:k=-2147483648,u[o|0]=(k|0)>=0?k>>>0>=255?255:k:0,e=e+1|0,(B|0)!=(e|0););break r;case 8:for(;_=l[e+N|0],k=e>>>F|0,o=l[k+z|0]-128|0,I0=_-o|0,k=l[k+M|0]-128|0,S=I0+k|0,u[e+R|0]=(S|0)>=0?S>>>0>=255?255:S:0,o=o+_|0,u[e+E|0]=(o|0)>=0?o>>>0>=255?255:o:0,k=I0-k|0,u[e+I|0]=(k|0)>=0?k>>>0>=255?255:k:0,e=e+1|0,(B|0)!=(e|0););break r;case 16:for(;k=e>>>F|0,_=l[k+z|0]-128|0,o=l[e+N|0]-(_>>>1|0)|0,k=l[k+M|0]-128|0,S=o-(k>>>1|0)|0,k=k+S<<16>>14,u[e+R|0]=(k|0)>=0?k>>>0>=255?255:k:0,k=o+_<<16>>14,u[e+E|0]=(k|0)>=0?k>>>0>=255?255:k:0,k=S<<16>>14,u[e+I|0]=(k|0)>=0?k>>>0>=255?255:k:0,e=e+1|0,(B|0)!=(e|0););break r;default:break f}for(;k=e>>>F|0,_=l[k+z|0],o=e+R|0,h=U(l[k+M|0]-128|0),$=n?h:U(h*U(1.142899990081787)),h=U(l[e+N|0]),X0=n?h:U(U(h+U(-16))*U(1.1689000129699707)),h=U(U(U(p0[s+108>>2]*$)+X0)+U(.5)),U(w2(h))<U(2147483648)?k=~~h:k=-2147483648,u[o|0]=(k|0)>=0?k>>>0>=255?255:k:0,o=e+E|0,L0=U(p0[s+116>>2]*$),h=U(_-128|0),$=n?h:U(h*U(1.142899990081787)),h=U(U(L0+U(U(p0[s+112>>2]*$)+X0))+U(.5)),U(w2(h))<U(2147483648)?k=~~h:k=-2147483648,u[o|0]=(k|0)>=0?k>>>0>=255?255:k:0,o=e+I|0,h=U(U(U(p0[s+120>>2]*$)+X0)+U(.5)),U(w2(h))<U(2147483648)?k=~~h:k=-2147483648,u[o|0]=(k|0)>=0?k>>>0>=255?255:k:0,e=e+1|0,(B|0)!=(e|0););}if(!A0|!g0||x(G(r,K0)+f|0,G(r,m0)+P0|0,g0),r=r+1|0,(Q|0)==(r|0))break}u[A+20|0]=0,i[A+4>>2]=w,i[A>>2]=X;break i}if(A=i[w+4>>2],i[w+4>>2]=A-1,A)break i;W[i[i[w>>2]+8>>2]](w),y(w)}v=s+128|0}function S7(A,e,r,f,k,n,t,o,s){var w=0,h=0,_=0,B=0,m=0,X=0,Q=0,V=0,F=0,I=0,E=0,R=0,N=0,M=0,z=0,S=0,O=0,P=0,a=0,$=0,f0=0,A0=0,n0=0,_0=0,m0=0,X0=0,g0=0,I0=0,e0=0,r0=0,N0=0,U0=0,M0=0;h=v-336|0,v=h,B=o,m=s&65535,X=f,Q=k&65535,I=(k^s)&-2147483648,z=s>>>16&32767,R=k>>>16&32767;i:{e:{if(z-32767>>>0>4294934529&R-32767>>>0>=4294934530)break e;if(w=k&2147483647,!(!f&(w|0)==2147418112?!(e|r):w>>>0<2147418112)){F=f,I=k|32768;break i}if(k=s&2147483647,!(!o&(k|0)==2147418112?!(n|t):k>>>0<2147418112)){F=o,I=s|32768,e=n,r=t;break i}if(!(e|f|(w^2147418112|r))){if(!(n|o|(k^2147418112|t))){e=0,r=0,I=2147450880;break i}I=I|2147418112,e=0,r=0;break i}if(!(n|o|(k^2147418112|t))){e=0,r=0;break i}if(!(e|f|(r|w))){e=!(n|o|(k|t)),F=e?0:F,I=e?2147450880:I,e=0,r=0;break i}if(!(n|o|(k|t))){I=I|2147418112,e=0,r=0;break i}if((w|0)==65535|w>>>0<65535&&(f=!(X|Q),s=k1(f?r:Q),f=((s|0)==32?k1(f?e:X)+32|0:s)+(f?64:0)|0,o4(h+320|0,e,r,X,Q,f-15|0),V=16-f|0,X=i[h+328>>2],Q=i[h+332>>2],r=i[h+324>>2],e=i[h+320>>2]),k>>>0>65535)break e;f=!(m|B),o=k1(f?t:m),f=((o|0)==32?k1(f?n:B)+32|0:o)+(f?64:0)|0,o4(h+304|0,n,t,B,m,f-15|0),V=(f+V|0)-16|0,B=i[h+312>>2],m=i[h+316>>2],n=i[h+304>>2],t=i[h+308>>2]}k=m|65536,S=k,O=B,f=B,w=k<<15|f>>>17,k=f<<15|t>>>17,f=k,s=0-f|0,o=w,w=1963258675-(w+((f|0)!=0)|0)|0,$1(h+288|0,f,o,0,0,s,w,0,0),f=i[h+296>>2],$1(h+272|0,0-f|0,0-(i[h+300>>2]+((f|0)!=0)|0)|0,0,0,s,w,0,0),f=i[h+280>>2],s=f<<1|i[h+276>>2]>>>31,f=i[h+284>>2]<<1|f>>>31,$1(h+256|0,s,f,0,0,k,o,0,0),w=i[h+264>>2],$1(h+240|0,s,f,0,0,0-w|0,0-(i[h+268>>2]+((w|0)!=0)|0)|0,0,0),s=i[h+248>>2],w=s<<1|i[h+244>>2]>>>31,f=i[h+252>>2]<<1|s>>>31,$1(h+224|0,w,f,0,0,k,o,0,0),s=i[h+232>>2],$1(h+208|0,w,f,0,0,0-s|0,0-(i[h+236>>2]+((s|0)!=0)|0)|0,0,0),f=i[h+216>>2],s=f<<1|i[h+212>>2]>>>31,f=i[h+220>>2]<<1|f>>>31,$1(h+192|0,s,f,0,0,k,o,0,0),w=i[h+200>>2],$1(h+176|0,s,f,0,0,0-w|0,0-(i[h+204>>2]+((w|0)!=0)|0)|0,0,0),s=k,k=i[h+184>>2],f=o,B=k<<1|i[h+180>>2]>>>31,o=B-1|0,k=(i[h+188>>2]<<1|k>>>31)-!B|0,$1(h+160|0,s,f,0,0,o,k,0,0),f=o,$1(h+144|0,n<<15,t<<15|n>>>17,0,0,f,k,0,0),N=h+112|0,P=i[h+168>>2],o=i[h+172>>2],B=i[h+160>>2],s=i[h+152>>2],_=B+s|0,m=i[h+164>>2],w=m+i[h+156>>2]|0,w=s>>>0>_>>>0?w+1|0:w,s=w,w=(m|0)==(w|0)&_>>>0<B>>>0|w>>>0<m>>>0,m=w+P|0,w=w>>>0>m>>>0?o+1|0:o,B=!s&_>>>0>1|(s|0)!=0,o=m+B|0,w=B>>>0>o>>>0?w+1|0:w,$1(N,f,k,0,0,0-o|0,0-(((o|0)!=0)+w|0)|0,0,0),$1(h+128|0,1-_|0,0-((_>>>0>1)+s|0)|0,0,0,f,k,0,0),g0=(R-z|0)+V|0,k=i[h+116>>2],R=k,f=i[h+112>>2],w=k<<1|f>>>31,s=f<<1,m=w,f=w,o=i[h+140>>2],M=o,k=i[h+136>>2],w=o<<1|k>>>31,_=k<<1|i[h+132>>2]>>>31,o=_+s|0,f=f+w|0,f=o>>>0<_>>>0?f+1|0:f,k=f,f=f-(o>>>0<13927)|0,E=f,N=f,_=0,w=Q|65536,I0=w,e0=X,f=X,w=w<<1|f>>>31,N0=f<<1,U0=w,A0=w,f=O0(E,_,w,0),w=l0,a=f,$=w,_0=e<<1,f=r<<1|e>>>31,z=f,P=f,w=0,V=w,B=o-13927|0,E=(k|0)==(E|0)&B>>>0<o>>>0|k>>>0>E>>>0,k=(k|0)==(m|0)&o>>>0<s>>>0|k>>>0<m>>>0,f=i[h+120>>2],o=i[h+124>>2]<<1|f>>>31,f=f<<1|R>>>31,_=M>>>31|0,f=_+f|0,w=o,w=f>>>0<_>>>0?w+1|0:w,o=f,f=f+k|0,w=o>>>0>f>>>0?w+1|0:w,k=f,f=f+E|0,_=k>>>0>f>>>0?w+1|0:w,k=f-1|0,f0=_-!f|0,M=0,s=O0(P,V,f0,M),f=s+a|0,o=l0+$|0,o=f>>>0<s>>>0?o+1|0:o,m=($|0)==(o|0)&f>>>0<a>>>0|o>>>0<$>>>0,a=k,r0=r>>>31|0,n0=r0|X<<1,E=0,k=O0(k,0,n0,E),X=k+f|0,w=l0+o|0,_=0,w=k>>>0>X>>>0?w+1|0:w,Q=w,f=(w|0)==(o|0)&f>>>0>X>>>0|o>>>0>w>>>0,k=f,f=f+m|0,_=k>>>0>f>>>0?1:_,k=O0(A0,V,f0,M),f=k+f|0,w=l0+_|0,m=f,f=f>>>0<k>>>0?w+1|0:w,k=O0(A0,V,a,E),_=l0,o=k,k=O0(n0,E,f0,M),s=o+k|0,w=l0+_|0,w=k>>>0>s>>>0?w+1|0:w,k=w,w=(_|0)==(w|0)&o>>>0>s>>>0|w>>>0<_>>>0,_=m+k|0,f=f+w|0,f=_>>>0<k>>>0?f+1|0:f,m=_,_=f,k=0,f=k+X|0,w=s+Q|0,w=f>>>0<k>>>0?w+1|0:w,k=w,o=(w|0)==(Q|0)&f>>>0<X>>>0|w>>>0<Q>>>0,w=_,s=o,o=o+m|0,w=s>>>0>o>>>0?w+1|0:w,R=o,_=w,X=f,$=B,f=O0(B,0,n0,E),s=l0,o=f,B=O0(N,F,P,F),f=f+B|0,w=l0+s|0,w=f>>>0<B>>>0?w+1|0:w,B=(s|0)==(w|0)&f>>>0<o>>>0|s>>>0>w>>>0,o=w,m0=_0&-2,s=O0(a,E,m0,0),Q=s+f|0,w=l0+w|0,w=s>>>0>Q>>>0?w+1|0:w,s=w,f=(w|0)==(o|0)&f>>>0>Q>>>0|o>>>0>w>>>0,o=0,w=f+B|0,f=(w>>>0<f>>>0?1:o)+k|0,m=w+X|0,f=m>>>0<w>>>0?f+1|0:f,w=_,B=f,f=(f|0)==(k|0)&m>>>0<X>>>0|f>>>0<k>>>0,k=f,f=f+R|0,w=k>>>0>f>>>0?w+1|0:w,M0=f,R=w,f=O0(A0,V,$,F),X0=l0,A0=f,k=O0(f0,M,m0,F),f=f+k|0,w=l0+X0|0,w=f>>>0<k>>>0?w+1|0:w,X=f,_=O0(N,F,n0,E),k=f+_|0,o=w,f=w+l0|0,f=k>>>0<_>>>0?f+1|0:f,V=k,w=O0(P,F,a,E),k=k+w|0,_=l0+f|0,_=k>>>0<w>>>0?_+1|0:_,f0=(f|0)==(_|0)&k>>>0<V>>>0|f>>>0>_>>>0,w=(o|0)==(X0|0)&X>>>0<A0>>>0|o>>>0<X0>>>0,f=(f|0)==(o|0)&X>>>0>V>>>0|f>>>0<o>>>0,f=f+w|0,f=f+f0|0,o=_,V=o+m|0,w=(f|M)+B|0,w=o>>>0>V>>>0?w+1|0:w,X=w,f=(B|0)==(w|0)&m>>>0>V>>>0|w>>>0<B>>>0,w=R,o=f,f=f+M0|0,w=o>>>0>f>>>0?w+1|0:w,M=f,B=w,f=O0(N,F,m0,F),N=l0,m=f,o=O0(P,F,$,F),f=f+o|0,w=l0+N|0,w=f>>>0<o>>>0?w+1|0:w,R=0,o=(w|0)==(N|0)&f>>>0<m>>>0|w>>>0<N>>>0,m=w,f=w+Q|0,w=(o|R)+s|0,w=f>>>0<m>>>0?w+1|0:w,s=(s|0)==(w|0)&f>>>0<Q>>>0|s>>>0>w>>>0,o=w,w=k,Q=0,k=Q+f|0,_=o+w|0,w=0,_=k>>>0<Q>>>0?_+1|0:_,f=(o|0)==(_|0)&f>>>0>k>>>0|o>>>0>_>>>0,k=f,f=f+s|0,w=(k>>>0>f>>>0?1:w)+X|0,_=B,k=f,f=f+V|0,w=k>>>0>f>>>0?w+1|0:w,k=w,o=(X|0)==(w|0)&f>>>0<V>>>0|w>>>0<X>>>0,s=o,o=o+M|0,_=s>>>0>o>>>0?_+1|0:_,s=_;e:{if((_|0)==131071|_>>>0<131071){e0=N0|r0,I0=E|U0,$1(h+80|0,f,w,o,_,n,t,O,S),_=i[h+84>>2],V=_,w=e<<17,X=0,Q=i[h+88>>2],r=X-Q|0,e=i[h+80>>2],_=(_|e)!=0,B=r-_|0,m=(w-(i[h+92>>2]+(X>>>0<Q>>>0)|0)|0)-(r>>>0<_>>>0)|0,Q=0-(((e|0)!=0)+V|0)|0,V=g0+16382|0,X=0-e|0;break e}f=(k&1)<<31|f>>>1,k=o<<31|k>>>1,o=(s&1)<<31|o>>>1,s=s>>>1|0,$1(h+96|0,f,k,o,s,n,t,O,S),B=i[h+100>>2],z=B,m=0,V=i[h+104>>2],X=m-V|0,_=i[h+96>>2],Q=(B|_)!=0,B=X-Q|0,m=((e<<16)-(i[h+108>>2]+(m>>>0<V>>>0)|0)|0)-(X>>>0<Q>>>0)|0,Q=0-(((_|0)!=0)+z|0)|0,_0=e,z=r,V=g0+16383|0,X=0-_|0}if((V|0)>=32767){I=I|2147418112,e=0,r=0;break i}e:{if((V|0)>0){e=B<<1|Q>>>31,r=m<<1|B>>>31,B=o,m=s&65535|V<<16,_=Q<<1|X>>>31,o=X<<1;break e}if((V|0)<=-113){e=0,r=0;break i}Y6(h- -64|0,f,k,o,s,1-V|0),o4(h+48|0,_0,z,e0,I0,V+112|0),f=i[h+64>>2],k=i[h+68>>2],B=i[h+72>>2],m=i[h+76>>2],$1(h+32|0,n,t,O,S,f,k,B,m),e=i[h+40>>2],r=i[h+56>>2],s=i[h+36>>2],Q=e<<1|s>>>31,_=r-Q|0,Q=i[h+60>>2]-((i[h+44>>2]<<1|e>>>31)+(r>>>0<Q>>>0)|0)|0,r=i[h+52>>2],V=r,e=i[h+32>>2],o=s<<1|e>>>31,X=e<<1,e=X,w=i[h+48>>2],r=(r|0)==(o|0)&e>>>0>w>>>0|r>>>0<o>>>0,e=_-r|0,r=Q-(r>>>0>_>>>0)|0,_=V-((w>>>0<X>>>0)+o|0)|0,o=w-X|0}$1(h+16|0,n,t,O,S,3,0,0,0),$1(h,n,t,O,S,5,0,0,0),X=f,Q=f&1,s=Q,f=o+s|0,w=0,o=w+_|0,o=f>>>0<s>>>0?o+1|0:o,s=f,t=(t|0)==(o|0)&f>>>0>n>>>0|t>>>0<o>>>0,_=r,f=(o|0)==(w|0)&f>>>0<Q>>>0|o>>>0<w>>>0,n=e+f|0,_=f>>>0>n>>>0?_+1|0:_,w=k,e=(_|0)==(S|0),e=e&(n|0)==(O|0)?t:e&n>>>0>O>>>0|_>>>0>S>>>0,r=e,e=e+X|0,w=r>>>0>e>>>0?w+1|0:w,r=w,f=(k|0)==(w|0)&e>>>0<X>>>0|k>>>0>w>>>0,w=m,k=f,f=f+B|0,w=k>>>0>f>>>0?w+1|0:w,t=f,k=i[h+20>>2],B=(k|0)==(o|0)&u0[h+16>>2]<s>>>0|k>>>0<o>>>0,k=i[h+28>>2],f=i[h+24>>2],k=w>>>0<2147418112&((f|0)==(n|0)&(k|0)==(_|0)?B:(k|0)==(_|0)&f>>>0<n>>>0|k>>>0<_>>>0),f=r,B=k,k=e+k|0,f=B>>>0>k>>>0?f+1|0:f,e=(r|0)==(f|0)&e>>>0>k>>>0|r>>>0>f>>>0,r=e,e=e+t|0,w=r>>>0>e>>>0?w+1|0:w,t=e,r=i[h+4>>2],o=(r|0)==(o|0)&u0[h>>2]<s>>>0|r>>>0<o>>>0,r=i[h+12>>2],e=i[h+8>>2],e=w>>>0<2147418112&((e|0)==(n|0)&(r|0)==(_|0)?o:(r|0)==(_|0)&e>>>0<n>>>0|r>>>0<_>>>0),r=e,e=e+k|0,_=r>>>0>e>>>0?f+1|0:f,r=_,k=(f|0)==(_|0)&e>>>0<k>>>0|f>>>0>_>>>0,f=w,n=k,k=k+t|0,f=n>>>0>k>>>0?f+1|0:f,F=k|F,I=f|I}i[A>>2]=e,i[A+4>>2]=r,i[A+8>>2]=F,i[A+12>>2]=I,v=h+336|0}function oB(A,e,r,f,k){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0;var n=0,t=0,o=0,s=0,w=0,h=0,_=0,B=0,m=0,X=0,Q=0;o=v-96|0,v=o;i:{e:{if(!(k&&e)){e=i[23570],i[A>>2]=i[23569],i[A+4>>2]=e,i[A+8>>2]=i[23571];break e}s=v-96|0,v=s,t=i[e>>2],n=i[t+48>>2],_=i[t+52>>2],_&&(i[_+4>>2]=i[_+4>>2]+1),w=o+60|0;r:{if(!f){n=v-48|0,v=n,f=i[t+48>>2],B=i[t+52>>2],B&&(i[B+4>>2]=i[B+4>>2]+1),t=v-32|0,v=t,i[t+28>>2]=0,i[t+20>>2]=0,i[t+24>>2]=0,j1(t,f,r,t+20|0);f:{if(i[t>>2]){i[n+40>>2]=0,i[n+44>>2]=0;break f}A:{if(h=i[t+20>>2],f=i[t+24>>2],(h|0)!=(f|0)){if(r=i[h>>2],r&&(m=i[n+44>>2],r=W0(r,86580,89356),r))break A;if(h=h+8|0,(f|0)!=(h|0))for(;;){if(r=i[h>>2],r&&(m=0,r=W0(r,86580,89356),r))break A;if(h=h+8|0,(f|0)==(h|0))break}i[n+40>>2]=0,i[n+44>>2]=0}i[n+40>>2]=0,i[n+44>>2]=0;break f}if(i[n+44>>2]=m,i[n+40>>2]=r,r=i[h+4>>2],i[n+44>>2]=r,!r)break f;i[r+4>>2]=i[r+4>>2]+1}if(u[t+19|0]<0&&Z(i[t+8>>2]),f=i[t+20>>2],f){if(r=f,h=i[t+24>>2],(r|0)!=(h|0)){for(;;){r=i[h-4>>2];f:{if(!r||(m=i[r+4>>2],i[r+4>>2]=m-1,m))break f;W[i[i[r>>2]+8>>2]](r),y(r)}if(h=h-8|0,(f|0)==(h|0))break}r=i[t+20>>2]}i[t+24>>2]=f,Z(r)}v=t+32|0,r=i[n+40>>2];f:{if(!r){r=p(32),i[n+4>>2]=r,i[n+8>>2]=26,i[n+12>>2]=-2147483616,f=l[9611]|l[9612]<<8,u[r+24|0]=f,u[r+25|0]=f>>>8,f=l[9607]|l[9608]<<8|(l[9609]<<16|l[9610]<<24),t=l[9603]|l[9604]<<8|(l[9605]<<16|l[9606]<<24),u[r+16|0]=t,u[r+17|0]=t>>>8,u[r+18|0]=t>>>16,u[r+19|0]=t>>>24,u[r+20|0]=f,u[r+21|0]=f>>>8,u[r+22|0]=f>>>16,u[r+23|0]=f>>>24,f=l[9599]|l[9600]<<8|(l[9601]<<16|l[9602]<<24),t=l[9595]|l[9596]<<8|(l[9597]<<16|l[9598]<<24),u[r+8|0]=t,u[r+9|0]=t>>>8,u[r+10|0]=t>>>16,u[r+11|0]=t>>>24,u[r+12|0]=f,u[r+13|0]=f>>>8,u[r+14|0]=f>>>16,u[r+15|0]=f>>>24,f=l[9591]|l[9592]<<8|(l[9593]<<16|l[9594]<<24),t=l[9587]|l[9588]<<8|(l[9589]<<16|l[9590]<<24),u[r|0]=t,u[r+1|0]=t>>>8,u[r+2|0]=t>>>16,u[r+3|0]=t>>>24,u[r+4|0]=f,u[r+5|0]=f>>>8,u[r+6|0]=f>>>16,u[r+7|0]=f>>>24,u[r+26|0]=0,r=q(n+16|0,2,116,n+4|0),f=i[r+4>>2],i[w>>2]=i[r>>2],i[w+4>>2]=f,f=w+8|0;A:{if(u[r+19|0]>=0){t=i[r+12>>2],i[f>>2]=i[r+8>>2],i[f+4>>2]=t,i[f+8>>2]=i[r+16>>2],u[w+20|0]=1;break A}if(T(f,i[r+8>>2],i[r+12>>2]),f=u[r+19|0],u[w+20|0]=1,(f|0)>=0)break A;Z(i[r+8>>2])}if(u[n+15|0]<0&&Z(i[n+4>>2]),r=i[n+44>>2],!r||(f=i[r+4>>2],i[r+4>>2]=f-1,f))break f;W[i[i[r>>2]+8>>2]](r),y(r);break f}f=i[n+44>>2],u[w+20|0]=0,i[w+4>>2]=f,i[w>>2]=r}f:{if(!B||(r=i[B+4>>2],i[B+4>>2]=r-1,r))break f;W[i[i[B>>2]+8>>2]](B),y(B)}v=n+48|0;break r}i[s+92>>2]=0,i[s+84>>2]=0,i[s+88>>2]=0,j1(s- -64|0,n,r,s+84|0);f:{if(i[s+64>>2]){r=i[s+68>>2],i[w>>2]=i[s+64>>2],i[w+4>>2]=r,r=w+8|0;A:{if(u[s+83|0]>=0){f=i[s+76>>2],i[r>>2]=i[s+72>>2],i[r+4>>2]=f,i[r+8>>2]=i[s+80>>2];break A}T(r,i[s+72>>2],i[s+76>>2])}u[w+20|0]=1;break f}t=f-1|0,n=i[s+84>>2],t>>>0>=i[s+88>>2]-n>>3>>>0&&(r=p(32),i[s+24>>2]=r,i[s+28>>2]=27,i[s+32>>2]=-2147483616,f=l[13922]|l[13923]<<8|(l[13924]<<16|l[13925]<<24),n=l[13918]|l[13919]<<8|(l[13920]<<16|l[13921]<<24),u[r|0]=n,u[r+1|0]=n>>>8,u[r+2|0]=n>>>16,u[r+3|0]=n>>>24,u[r+4|0]=f,u[r+5|0]=f>>>8,u[r+6|0]=f>>>16,u[r+7|0]=f>>>24,u[r+27|0]=0,f=l[13941]|l[13942]<<8|(l[13943]<<16|l[13944]<<24),u[r+23|0]=f,u[r+24|0]=f>>>8,u[r+25|0]=f>>>16,u[r+26|0]=f>>>24,f=l[13938]|l[13939]<<8|(l[13940]<<16|l[13941]<<24),n=l[13934]|l[13935]<<8|(l[13936]<<16|l[13937]<<24),u[r+16|0]=n,u[r+17|0]=n>>>8,u[r+18|0]=n>>>16,u[r+19|0]=n>>>24,u[r+20|0]=f,u[r+21|0]=f>>>8,u[r+22|0]=f>>>16,u[r+23|0]=f>>>24,f=l[13930]|l[13931]<<8|(l[13932]<<16|l[13933]<<24),n=l[13926]|l[13927]<<8|(l[13928]<<16|l[13929]<<24),u[r+8|0]=n,u[r+9|0]=n>>>8,u[r+10|0]=n>>>16,u[r+11|0]=n>>>24,u[r+12|0]=f,u[r+13|0]=f>>>8,u[r+14|0]=f>>>16,u[r+15|0]=f>>>24,r=q(s+44|0,5,2007,s+24|0),u[r+19|0]<0&&Z(i[r+8>>2]),u[s+35|0]<0&&Z(i[s+24>>2]),n=i[s+84>>2]),f=n+(t<<3)|0,r=i[f>>2],f=i[f+4>>2],f&&(i[f+4>>2]=i[f+4>>2]+1);A:{k:{if(!r||(r=W0(r,86580,89356),!r))break k;f&&(i[f+4>>2]=i[f+4>>2]+1),u[w+20|0]=0,i[w+4>>2]=f,i[w>>2]=r;break A}r=p(24),i[s+12>>2]=r,i[s+16>>2]=19,i[s+20>>2]=-2147483624,n=l[12730]|l[12731]<<8|(l[12732]<<16|l[12733]<<24),u[r+15|0]=n,u[r+16|0]=n>>>8,u[r+17|0]=n>>>16,u[r+18|0]=n>>>24,n=l[12727]|l[12728]<<8|(l[12729]<<16|l[12730]<<24),t=l[12723]|l[12724]<<8|(l[12725]<<16|l[12726]<<24),u[r+8|0]=t,u[r+9|0]=t>>>8,u[r+10|0]=t>>>16,u[r+11|0]=t>>>24,u[r+12|0]=n,u[r+13|0]=n>>>8,u[r+14|0]=n>>>16,u[r+15|0]=n>>>24,n=l[12719]|l[12720]<<8|(l[12721]<<16|l[12722]<<24),t=l[12715]|l[12716]<<8|(l[12717]<<16|l[12718]<<24),u[r|0]=t,u[r+1|0]=t>>>8,u[r+2|0]=t>>>16,u[r+3|0]=t>>>24,u[r+4|0]=n,u[r+5|0]=n>>>8,u[r+6|0]=n>>>16,u[r+7|0]=n>>>24,u[r+19|0]=0,r=q(s+24|0,5,2007,s+12|0),n=i[r+4>>2],i[w>>2]=i[r>>2],i[w+4>>2]=n,n=w+8|0;k:{if(u[r+19|0]>=0){t=i[r+12>>2],i[n>>2]=i[r+8>>2],i[n+4>>2]=t,i[n+8>>2]=i[r+16>>2],u[w+20|0]=1;break k}if(T(n,i[r+8>>2],i[r+12>>2]),n=u[r+19|0],u[w+20|0]=1,(n|0)>=0)break k;Z(i[r+8>>2])}if(u[s+23|0]>=0)break A;Z(i[s+12>>2])}if(!f||(r=i[f+4>>2],i[f+4>>2]=r-1,r))break f;W[i[i[f>>2]+8>>2]](f),y(f)}if(u[s+83|0]<0&&Z(i[s+72>>2]),r=i[s+84>>2],!r)break r;if(f=r,n=i[s+88>>2],(r|0)!=(n|0)){for(;;){f=i[n-4>>2];f:{if(!f||(w=i[f+4>>2],i[f+4>>2]=w-1,w))break f;W[i[i[f>>2]+8>>2]](f),y(f)}if(n=n-8|0,(r|0)==(n|0))break}f=i[s+84>>2]}i[s+88>>2]=r,Z(f)}r:{if(!_||(r=i[_+4>>2],i[_+4>>2]=r-1,r))break r;W[i[i[_>>2]+8>>2]](_),y(_)}v=s+96|0;r:{f:switch(l[o+80|0]){case 1:b0(A,o+60|0,i[e>>2]);break r;case 0:break f;default:break i}e=p(20),i[e>>2]=0,i[e+4>>2]=0,i[e+16>>2]=0,i[e+8>>2]=0,i[e+12>>2]=0,i[e>>2]=1,r=i[o+60>>2];f:{if(u[r+115|0]>=0){i[o+56>>2]=i[r+112>>2],f=i[r+108>>2],i[o+48>>2]=i[r+104>>2],i[o+52>>2]=f;break f}T(o+48|0,i[r+104>>2],i[r+108>>2])}if(f=u[o+59|0],r=(f|0)<0,n=p((r?i[o+52>>2]:f)+1|0),f=i[o+48>>2],X=e,Q=c4(n,r?f:o+48|0),i[X+4>>2]=Q,r&&Z(f),l[o+80|0])break i;r=i[o+60>>2];f:{if(u[r+127|0]>=0){i[o+40>>2]=i[r+124>>2],f=i[r+120>>2],i[o+32>>2]=i[r+116>>2],i[o+36>>2]=f;break f}T(o+32|0,i[r+116>>2],i[r+120>>2])}if(f=u[o+43|0],r=(f|0)<0,n=p((r?i[o+36>>2]:f)+1|0),f=i[o+32>>2],X=e,Q=c4(n,r?f:o+32|0),i[X+8>>2]=Q,r&&Z(f),l[o+80|0])break i;r=i[o+60>>2];f:{if(u[r+139|0]>=0){i[o+24>>2]=i[r+136>>2],f=i[r+132>>2],i[o+16>>2]=i[r+128>>2],i[o+20>>2]=f;break f}T(o+16|0,i[r+128>>2],i[r+132>>2])}if(f=u[o+27|0],r=(f|0)<0,n=p((r?i[o+20>>2]:f)+1|0),f=i[o+16>>2],X=e,Q=c4(n,r?f:o+16|0),i[X+12>>2]=Q,r&&Z(f),l[o+80|0])break i;r=i[o+60>>2];f:{if(u[r+151|0]>=0){i[o+8>>2]=i[r+148>>2],f=i[r+144>>2],i[o>>2]=i[r+140>>2],i[o+4>>2]=f;break f}T(o,i[r+140>>2],i[r+144>>2])}f=u[o+11|0],r=(f|0)<0,n=p((r?i[o+4>>2]:f)+1|0),f=i[o>>2],X=e,Q=c4(n,r?f:o),i[X+16>>2]=Q,r&&Z(f),i[k>>2]=e,i[A+8>>2]=i[24058],e=i[24057],i[A>>2]=i[24056],i[A+4>>2]=e}if(A=l[o+80|0],(A|0)==255)break e;e=i[24173],i[o+88>>2]=i[24172],i[o+92>>2]=e,W[i[(o+88|0)+(A<<2)>>2]](o+87|0,o+60|0)}v=o+96|0;return}_2(),H()}function lB(A,e,r,f,k,n,t){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,t=t|0;var o=0,s=0,w=0,h=0,_=0,B=0,m=0;r=v+-64|0,v=r,i[r+56>>2]=0,i[r+60>>2]=0,i[r+52>>2]=0,i[r+44>>2]=0,i[r+48>>2]=0,f=i[e+100>>2],i[r>>2]=i[f+48>>2],f=i[f+52>>2],i[r+4>>2]=f,f&&(i[f+4>>2]=i[f+4>>2]+1),gr(r+24|0,i[r>>2],i[e+116>>2],r+44|0,0,0,-1,-1),k=i[r+4>>2];i:{if(!k||(f=i[k+4>>2],i[k+4>>2]=f-1,f))break i;W[i[i[k>>2]+8>>2]](k),y(k)}i:{if(i[r+24>>2]){e=i[r+28>>2],i[A>>2]=i[r+24>>2],i[A+4>>2]=e,f=A+8|0;e:{if(u[r+43|0]>=0){e=i[r+36>>2],i[f>>2]=i[r+32>>2],i[f+4>>2]=e,i[f+8>>2]=i[r+40>>2];break e}T(f,i[r+32>>2],i[r+36>>2])}u[A+20|0]=1;break i}t=0,s=v-32|0,v=s,f=s+8|0,n=i[e+100>>2],r4(f,n,i[e+116>>2],0),m=i[s+12>>2],_=i[s+8>>2];e:{if(!_){if(u[s+8|0]=0,u[s+19|0]=0,q(r,2,2e3,f),u[s+19|0]>=0)break e;Z(i[s+8>>2]);break e}r:{f:{f=i[_+104>>2],o=i[_+108>>2];A:{if((f|0)==(o|0))break A;e=f;k:{for(;;){n:{if(k=i[e>>2],!k||(k=W0(k,86580,86600),!k))break n;if(h=i[e+4>>2],!h){h=0;break k}i[h+4>>2]=i[h+4>>2]+1,o=i[_+108>>2],f=i[_+104>>2];break k}if(e=e+8|0,(o|0)==(e|0))break}k=0}k:{if((f|0)!=(o|0))for(;;){n:{if(e=i[f>>2],!e||(e=W0(e,86580,100372),!e))break n;if(t=i[f+4>>2],!t){t=0;break k}i[t+4>>2]=i[t+4>>2]+1;break k}if(f=f+8|0,(o|0)==(f|0))break}e=0}if(!k)break A;if(_=n- -64|0,w=i[k+104>>2],B=i[k+108>>2],di(r,_,w,B),i[r>>2])break r;if(u[r+19|0]<0&&Z(i[r+8>>2]),e)break f}if(e=p(40),i[s+8>>2]=e,i[s+12>>2]=35,i[s+16>>2]=-2147483608,k=l[18101]|l[18102]<<8|(l[18103]<<16|l[18104]<<24),f=l[18097]|l[18098]<<8|(l[18099]<<16|l[18100]<<24),u[e|0]=f,u[e+1|0]=f>>>8,u[e+2|0]=f>>>16,u[e+3|0]=f>>>24,u[e+4|0]=k,u[e+5|0]=k>>>8,u[e+6|0]=k>>>16,u[e+7|0]=k>>>24,u[e+35|0]=0,f=l[18128]|l[18129]<<8|(l[18130]<<16|l[18131]<<24),u[e+31|0]=f,u[e+32|0]=f>>>8,u[e+33|0]=f>>>16,u[e+34|0]=f>>>24,k=l[18125]|l[18126]<<8|(l[18127]<<16|l[18128]<<24),f=l[18121]|l[18122]<<8|(l[18123]<<16|l[18124]<<24),u[e+24|0]=f,u[e+25|0]=f>>>8,u[e+26|0]=f>>>16,u[e+27|0]=f>>>24,u[e+28|0]=k,u[e+29|0]=k>>>8,u[e+30|0]=k>>>16,u[e+31|0]=k>>>24,k=l[18117]|l[18118]<<8|(l[18119]<<16|l[18120]<<24),f=l[18113]|l[18114]<<8|(l[18115]<<16|l[18116]<<24),u[e+16|0]=f,u[e+17|0]=f>>>8,u[e+18|0]=f>>>16,u[e+19|0]=f>>>24,u[e+20|0]=k,u[e+21|0]=k>>>8,u[e+22|0]=k>>>16,u[e+23|0]=k>>>24,k=l[18109]|l[18110]<<8|(l[18111]<<16|l[18112]<<24),f=l[18105]|l[18106]<<8|(l[18107]<<16|l[18108]<<24),u[e+8|0]=f,u[e+9|0]=f>>>8,u[e+10|0]=f>>>16,u[e+11|0]=f>>>24,u[e+12|0]=k,u[e+13|0]=k>>>8,u[e+14|0]=k>>>16,u[e+15|0]=k>>>24,q(r,4,3002,s+8|0),u[s+19|0]>=0)break r;Z(i[s+8>>2]);break r}f:switch(l[e+104|0]-8|0){default:if(e=p(40),i[s+8>>2]=e,i[s+12>>2]=35,i[s+16>>2]=-2147483608,k=l[9618]|l[9619]<<8|(l[9620]<<16|l[9621]<<24),f=l[9614]|l[9615]<<8|(l[9616]<<16|l[9617]<<24),u[e|0]=f,u[e+1|0]=f>>>8,u[e+2|0]=f>>>16,u[e+3|0]=f>>>24,u[e+4|0]=k,u[e+5|0]=k>>>8,u[e+6|0]=k>>>16,u[e+7|0]=k>>>24,u[e+35|0]=0,f=l[9645]|l[9646]<<8|(l[9647]<<16|l[9648]<<24),u[e+31|0]=f,u[e+32|0]=f>>>8,u[e+33|0]=f>>>16,u[e+34|0]=f>>>24,k=l[9642]|l[9643]<<8|(l[9644]<<16|l[9645]<<24),f=l[9638]|l[9639]<<8|(l[9640]<<16|l[9641]<<24),u[e+24|0]=f,u[e+25|0]=f>>>8,u[e+26|0]=f>>>16,u[e+27|0]=f>>>24,u[e+28|0]=k,u[e+29|0]=k>>>8,u[e+30|0]=k>>>16,u[e+31|0]=k>>>24,k=l[9634]|l[9635]<<8|(l[9636]<<16|l[9637]<<24),f=l[9630]|l[9631]<<8|(l[9632]<<16|l[9633]<<24),u[e+16|0]=f,u[e+17|0]=f>>>8,u[e+18|0]=f>>>16,u[e+19|0]=f>>>24,u[e+20|0]=k,u[e+21|0]=k>>>8,u[e+22|0]=k>>>16,u[e+23|0]=k>>>24,k=l[9626]|l[9627]<<8|(l[9628]<<16|l[9629]<<24),f=l[9622]|l[9623]<<8|(l[9624]<<16|l[9625]<<24),u[e+8|0]=f,u[e+9|0]=f>>>8,u[e+10|0]=f>>>16,u[e+11|0]=f>>>24,u[e+12|0]=k,u[e+13|0]=k>>>8,u[e+14|0]=k>>>16,u[e+15|0]=k>>>24,q(r,4,3002,s+8|0),u[s+19|0]>=0)break r;Z(i[s+8>>2]);break r;case 0:case 8:break f}if(i[r+48>>2]-i[r+44>>2]>>>0<G(w,B)>>>0){if(e=p(32),i[s+8>>2]=e,i[s+12>>2]=28,i[s+16>>2]=-2147483616,k=l[3644]|l[3645]<<8|(l[3646]<<16|l[3647]<<24),f=l[3640]|l[3641]<<8|(l[3642]<<16|l[3643]<<24),u[e|0]=f,u[e+1|0]=f>>>8,u[e+2|0]=f>>>16,u[e+3|0]=f>>>24,u[e+4|0]=k,u[e+5|0]=k>>>8,u[e+6|0]=k>>>16,u[e+7|0]=k>>>24,u[e+28|0]=0,f=l[3664]|l[3665]<<8|(l[3666]<<16|l[3667]<<24),u[e+24|0]=f,u[e+25|0]=f>>>8,u[e+26|0]=f>>>16,u[e+27|0]=f>>>24,k=l[3660]|l[3661]<<8|(l[3662]<<16|l[3663]<<24),f=l[3656]|l[3657]<<8|(l[3658]<<16|l[3659]<<24),u[e+16|0]=f,u[e+17|0]=f>>>8,u[e+18|0]=f>>>16,u[e+19|0]=f>>>24,u[e+20|0]=k,u[e+21|0]=k>>>8,u[e+22|0]=k>>>16,u[e+23|0]=k>>>24,k=l[3652]|l[3653]<<8|(l[3654]<<16|l[3655]<<24),f=l[3648]|l[3649]<<8|(l[3650]<<16|l[3651]<<24),u[e+8|0]=f,u[e+9|0]=f>>>8,u[e+10|0]=f>>>16,u[e+11|0]=f>>>24,u[e+12|0]=k,u[e+13|0]=k>>>8,u[e+14|0]=k>>>16,u[e+15|0]=k>>>24,q(r,2,0,s+8|0),u[s+19|0]>=0)break r;Z(i[s+8>>2]);break r}o=p(172),i[o+4>>2]=0,i[o+8>>2]=0,i[o>>2]=94812,o0(o+16|0,0,80),f=i[o+4>>2],n=f+1|0,i[o+4>>2]=n,i[o+104>>2]=0,i[o+108>>2]=0,i[o+36>>2]=1,i[o+40>>2]=1,u[o+24|0]=1,g[o+22>>1]=2,g[o+18>>1]=2,g[o+20>>1]=2,i[o+112>>2]=0,i[o+116>>2]=4740,i[o+140>>2]=0,i[o+144>>2]=0,i[o+128>>2]=99,i[o+132>>2]=99,i[o+120>>2]=0,i[o+124>>2]=0,i[o+12>>2]=95160,i[o+148>>2]=0,i[o+152>>2]=0,i[o+136>>2]=o+140,i[o+156>>2]=0,i[o+160>>2]=0,i[o+164>>2]=0,i[o+168>>2]=0,i[o+4>>2]=f,k=i[o+8>>2],f=o+12|0,i[o+96>>2]=f,i[o+8>>2]=k+1,i[o+100>>2]=o,n||(W[i[i[o>>2]+8>>2]](o),y(o)),i[r+56>>2]=f,k=i[r+60>>2],i[r+60>>2]=o;f:{if(!k||(f=i[k+4>>2],i[k+4>>2]=f-1,f))break f;W[i[i[k>>2]+8>>2]](k),y(k)}if(f=i[r+56>>2],i[f+120>>2]=0,i[f+116>>2]=2,i[f+112>>2]=B,i[f+108>>2]=w,T0(s+8|0,i[r+56>>2],0,w,B,l[e+104|0],_),i[s+8>>2]){e=i[s+12>>2],i[r>>2]=i[s+8>>2],i[r+4>>2]=e,e=i[s+20>>2],i[r+8>>2]=i[s+16>>2],i[r+12>>2]=e,i[r+16>>2]=i[s+24>>2];break r}o=bu(i[r+56>>2],0,s+4|0);f:{if((w|0)!=i[s+4>>2]){if(!B)break f;if(e=0,(B|0)!=1)for(n=B&-2,f=0;k=!w,k||x(o+G(i[s+4>>2],e)|0,i[r+44>>2]+G(e,w)|0,w),k||(k=e|1,x(o+G(k,i[s+4>>2])|0,i[r+44>>2]+G(k,w)|0,w)),e=e+2|0,f=f+2|0,(n|0)!=(f|0););if(!(B&1)|!w)break f;x(o+G(i[s+4>>2],e)|0,i[r+44>>2]+G(e,w)|0,w);break f}if(f=i[r+44>>2],e=i[r+48>>2]-f|0,!e)break f;x(o,f,e)}if(k8(r,107664),u[s+27|0]>=0)break r;Z(i[s+16>>2])}r:{if(!t||(e=i[t+4>>2],i[t+4>>2]=e-1,e))break r;W[i[i[t>>2]+8>>2]](t),y(t)}if(!h||(e=i[h+4>>2],i[h+4>>2]=e-1,e))break e;W[i[i[h>>2]+8>>2]](h),y(h)}e:{if(!m||(e=i[m+4>>2],i[m+4>>2]=e-1,e))break e;W[i[i[m>>2]+8>>2]](m),y(m)}v=s+32|0;e:{if(i[r>>2]){if(e=i[r+4>>2],i[A>>2]=i[r>>2],i[A+4>>2]=e,f=A+8|0,u[r+19|0]>=0){e=i[r+12>>2],i[f>>2]=i[r+8>>2],i[f+4>>2]=e,i[f+8>>2]=i[r+16>>2],e=1;break e}T(f,i[r+8>>2],i[r+12>>2]),e=1;break e}f=i[r+56>>2],e=i[r+60>>2],i[r+56>>2]=0,i[r+60>>2]=0,i[A>>2]=f,i[A+4>>2]=e,e=0}if(u[A+20|0]=e,u[r+19|0]>=0)break i;Z(i[r+8>>2])}u[r+43|0]<0&&Z(i[r+32>>2]),A=i[r+44>>2],A&&(i[r+48>>2]=A,Z(A)),e=i[r+60>>2];i:{if(!e||(A=i[e+4>>2],i[e+4>>2]=A-1,A))break i;W[i[i[e>>2]+8>>2]](e),y(e)}v=r- -64|0}function sB(A,e,r,f,k,n){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0;var t=0,o=0,s=0,w=0,h=0,_=0,B=0,m=0;s=v-16|0,v=s,w=i[r>>2],B=i[r+4>>2]-w|0,o=i[k>>2];i:{if(B-o>>>0<=(f|0)/8<<2>>>0){if(e=p(56),i[s+4>>2]=e,i[s+8>>2]=50,i[s+12>>2]=-2147483592,r=l[8959]|l[8960]<<8|(l[8961]<<16|l[8962]<<24),f=l[8955]|l[8956]<<8|(l[8957]<<16|l[8958]<<24),u[e|0]=f,u[e+1|0]=f>>>8,u[e+2|0]=f>>>16,u[e+3|0]=f>>>24,u[e+4|0]=r,u[e+5|0]=r>>>8,u[e+6|0]=r>>>16,u[e+7|0]=r>>>24,u[e+50|0]=0,r=l[9003]|l[9004]<<8,u[e+48|0]=r,u[e+49|0]=r>>>8,r=l[8999]|l[9e3]<<8|(l[9001]<<16|l[9002]<<24),f=l[8995]|l[8996]<<8|(l[8997]<<16|l[8998]<<24),u[e+40|0]=f,u[e+41|0]=f>>>8,u[e+42|0]=f>>>16,u[e+43|0]=f>>>24,u[e+44|0]=r,u[e+45|0]=r>>>8,u[e+46|0]=r>>>16,u[e+47|0]=r>>>24,r=l[8991]|l[8992]<<8|(l[8993]<<16|l[8994]<<24),f=l[8987]|l[8988]<<8|(l[8989]<<16|l[8990]<<24),u[e+32|0]=f,u[e+33|0]=f>>>8,u[e+34|0]=f>>>16,u[e+35|0]=f>>>24,u[e+36|0]=r,u[e+37|0]=r>>>8,u[e+38|0]=r>>>16,u[e+39|0]=r>>>24,r=l[8983]|l[8984]<<8|(l[8985]<<16|l[8986]<<24),f=l[8979]|l[8980]<<8|(l[8981]<<16|l[8982]<<24),u[e+24|0]=f,u[e+25|0]=f>>>8,u[e+26|0]=f>>>16,u[e+27|0]=f>>>24,u[e+28|0]=r,u[e+29|0]=r>>>8,u[e+30|0]=r>>>16,u[e+31|0]=r>>>24,r=l[8975]|l[8976]<<8|(l[8977]<<16|l[8978]<<24),f=l[8971]|l[8972]<<8|(l[8973]<<16|l[8974]<<24),u[e+16|0]=f,u[e+17|0]=f>>>8,u[e+18|0]=f>>>16,u[e+19|0]=f>>>24,u[e+20|0]=r,u[e+21|0]=r>>>8,u[e+22|0]=r>>>16,u[e+23|0]=r>>>24,r=l[8967]|l[8968]<<8|(l[8969]<<16|l[8970]<<24),f=l[8963]|l[8964]<<8|(l[8965]<<16|l[8966]<<24),u[e+8|0]=f,u[e+9|0]=f>>>8,u[e+10|0]=f>>>16,u[e+11|0]=f>>>24,u[e+12|0]=r,u[e+13|0]=r>>>8,u[e+14|0]=r>>>16,u[e+15|0]=r>>>24,q(A,2,136,s+4|0),u[s+15|0]>=0)break i;Z(i[s+4>>2]);break i}t=o+w|0,h=l[t|0],_=l[t+1|0];e:{if((f|0)==32){m=l[t+3|0],t=l[t+2|0],i[k>>2]=o+4,i[e+4>>2]=_<<16|h<<24|t<<8|m,t=i[k>>2],o=t+w|0,o=l[o|0]|l[o+1|0]<<8|(l[o+2|0]<<16|l[o+3|0]<<24),i[k>>2]=t+4,i[e+8>>2]=o<<24|(o&65280)<<8|(o>>>8&65280|o>>>24),o=i[k>>2],t=w+o|0,h=l[t+1|0]<<16|l[t|0]<<24|l[t+2|0]<<8,t=t+3|0,_=4;break e}i[k>>2]=o+2,i[e+4>>2]=(_<<16|h<<24)>>16,o=i[k>>2],t=o+w|0,h=l[t+1|0],t=l[t|0],i[k>>2]=o+2,i[e+8>>2]=(h<<16|t<<24)>>16,o=i[k>>2],h=w+o|0,t=h+1|0,h=l[h|0]<<8,_=2}t=l[t|0],i[k>>2]=o+_,i[e+12>>2]=t|h,_=i[k>>2],t=_+w|0,h=l[t|0],o=l[t+1|0];e:{if((f|0)==32){f=o<<16|h<<24|l[t+2|0]<<8,o=l[t+3|0],t=4;break e}f=h<<8,t=2}if(i[k>>2]=t+_,i[e+16>>2]=f|o,f=i[k>>2],w=l[f+w|0],o=f+1|0,i[k>>2]=o,w){if(e=p(56),i[s+4>>2]=e,i[s+8>>2]=51,i[s+12>>2]=-2147483592,r=l[16435]|l[16436]<<8|(l[16437]<<16|l[16438]<<24),f=l[16431]|l[16432]<<8|(l[16433]<<16|l[16434]<<24),u[e|0]=f,u[e+1|0]=f>>>8,u[e+2|0]=f>>>16,u[e+3|0]=f>>>24,u[e+4|0]=r,u[e+5|0]=r>>>8,u[e+6|0]=r>>>16,u[e+7|0]=r>>>24,u[e+51|0]=0,r=l[16478]|l[16479]<<8|(l[16480]<<16|l[16481]<<24),u[e+47|0]=r,u[e+48|0]=r>>>8,u[e+49|0]=r>>>16,u[e+50|0]=r>>>24,r=l[16475]|l[16476]<<8|(l[16477]<<16|l[16478]<<24),f=l[16471]|l[16472]<<8|(l[16473]<<16|l[16474]<<24),u[e+40|0]=f,u[e+41|0]=f>>>8,u[e+42|0]=f>>>16,u[e+43|0]=f>>>24,u[e+44|0]=r,u[e+45|0]=r>>>8,u[e+46|0]=r>>>16,u[e+47|0]=r>>>24,r=l[16467]|l[16468]<<8|(l[16469]<<16|l[16470]<<24),f=l[16463]|l[16464]<<8|(l[16465]<<16|l[16466]<<24),u[e+32|0]=f,u[e+33|0]=f>>>8,u[e+34|0]=f>>>16,u[e+35|0]=f>>>24,u[e+36|0]=r,u[e+37|0]=r>>>8,u[e+38|0]=r>>>16,u[e+39|0]=r>>>24,r=l[16459]|l[16460]<<8|(l[16461]<<16|l[16462]<<24),f=l[16455]|l[16456]<<8|(l[16457]<<16|l[16458]<<24),u[e+24|0]=f,u[e+25|0]=f>>>8,u[e+26|0]=f>>>16,u[e+27|0]=f>>>24,u[e+28|0]=r,u[e+29|0]=r>>>8,u[e+30|0]=r>>>16,u[e+31|0]=r>>>24,r=l[16451]|l[16452]<<8|(l[16453]<<16|l[16454]<<24),f=l[16447]|l[16448]<<8|(l[16449]<<16|l[16450]<<24),u[e+16|0]=f,u[e+17|0]=f>>>8,u[e+18|0]=f>>>16,u[e+19|0]=f>>>24,u[e+20|0]=r,u[e+21|0]=r>>>8,u[e+22|0]=r>>>16,u[e+23|0]=r>>>24,r=l[16443]|l[16444]<<8|(l[16445]<<16|l[16446]<<24),f=l[16439]|l[16440]<<8|(l[16441]<<16|l[16442]<<24),u[e+8|0]=f,u[e+9|0]=f>>>8,u[e+10|0]=f>>>16,u[e+11|0]=f>>>24,u[e+12|0]=r,u[e+13|0]=r>>>8,u[e+14|0]=r>>>16,u[e+15|0]=r>>>24,q(A,2,136,s+4|0),u[s+15|0]>=0)break i;Z(i[s+4>>2]);break i}e:{if(f=i[e+12>>2],f&&(w=i[e+16>>2],w))break e;if(e=p(24),i[s+4>>2]=e,i[s+8>>2]=21,i[s+12>>2]=-2147483624,r=l[25495]|l[25496]<<8|(l[25497]<<16|l[25498]<<24),f=l[25491]|l[25492]<<8|(l[25493]<<16|l[25494]<<24),u[e|0]=f,u[e+1|0]=f>>>8,u[e+2|0]=f>>>16,u[e+3|0]=f>>>24,u[e+4|0]=r,u[e+5|0]=r>>>8,u[e+6|0]=r>>>16,u[e+7|0]=r>>>24,u[e+21|0]=0,r=l[25508]|l[25509]<<8|(l[25510]<<16|l[25511]<<24),f=l[25504]|l[25505]<<8|(l[25506]<<16|l[25507]<<24),u[e+13|0]=f,u[e+14|0]=f>>>8,u[e+15|0]=f>>>16,u[e+16|0]=f>>>24,u[e+17|0]=r,u[e+18|0]=r>>>8,u[e+19|0]=r>>>16,u[e+20|0]=r>>>24,r=l[25503]|l[25504]<<8|(l[25505]<<16|l[25506]<<24),f=l[25499]|l[25500]<<8|(l[25501]<<16|l[25502]<<24),u[e+8|0]=f,u[e+9|0]=f>>>8,u[e+10|0]=f>>>16,u[e+11|0]=f>>>24,u[e+12|0]=r,u[e+13|0]=r>>>8,u[e+14|0]=r>>>16,u[e+15|0]=r>>>24,q(A,2,0,s+4|0),u[s+15|0]>=0)break i;Z(i[s+4>>2]);break i}if(4294967295/(w>>>0)>>>0<=f>>>3>>>0){if(e=p(48),i[s+4>>2]=e,i[s+8>>2]=46,i[s+12>>2]=-2147483600,r=l[25211]|l[25212]<<8|(l[25213]<<16|l[25214]<<24),f=l[25207]|l[25208]<<8|(l[25209]<<16|l[25210]<<24),u[e|0]=f,u[e+1|0]=f>>>8,u[e+2|0]=f>>>16,u[e+3|0]=f>>>24,u[e+4|0]=r,u[e+5|0]=r>>>8,u[e+6|0]=r>>>16,u[e+7|0]=r>>>24,u[e+46|0]=0,r=l[25249]|l[25250]<<8|(l[25251]<<16|l[25252]<<24),f=l[25245]|l[25246]<<8|(l[25247]<<16|l[25248]<<24),u[e+38|0]=f,u[e+39|0]=f>>>8,u[e+40|0]=f>>>16,u[e+41|0]=f>>>24,u[e+42|0]=r,u[e+43|0]=r>>>8,u[e+44|0]=r>>>16,u[e+45|0]=r>>>24,r=l[25243]|l[25244]<<8|(l[25245]<<16|l[25246]<<24),f=l[25239]|l[25240]<<8|(l[25241]<<16|l[25242]<<24),u[e+32|0]=f,u[e+33|0]=f>>>8,u[e+34|0]=f>>>16,u[e+35|0]=f>>>24,u[e+36|0]=r,u[e+37|0]=r>>>8,u[e+38|0]=r>>>16,u[e+39|0]=r>>>24,r=l[25235]|l[25236]<<8|(l[25237]<<16|l[25238]<<24),f=l[25231]|l[25232]<<8|(l[25233]<<16|l[25234]<<24),u[e+24|0]=f,u[e+25|0]=f>>>8,u[e+26|0]=f>>>16,u[e+27|0]=f>>>24,u[e+28|0]=r,u[e+29|0]=r>>>8,u[e+30|0]=r>>>16,u[e+31|0]=r>>>24,r=l[25227]|l[25228]<<8|(l[25229]<<16|l[25230]<<24),f=l[25223]|l[25224]<<8|(l[25225]<<16|l[25226]<<24),u[e+16|0]=f,u[e+17|0]=f>>>8,u[e+18|0]=f>>>16,u[e+19|0]=f>>>24,u[e+20|0]=r,u[e+21|0]=r>>>8,u[e+22|0]=r>>>16,u[e+23|0]=r>>>24,r=l[25219]|l[25220]<<8|(l[25221]<<16|l[25222]<<24),f=l[25215]|l[25216]<<8|(l[25217]<<16|l[25218]<<24),u[e+8|0]=f,u[e+9|0]=f>>>8,u[e+10|0]=f>>>16,u[e+11|0]=f>>>24,u[e+12|0]=r,u[e+13|0]=r>>>8,u[e+14|0]=r>>>16,u[e+15|0]=r>>>24,q(A,6,0,s+4|0),u[s+15|0]>=0)break i;Z(i[s+4>>2]);break i}if(t=d8(i[n+8>>2],i[n+12>>2],f,0),!l0&t>>>0<w>>>0){if(e=A,A=d2(s+4|0,25034),q(e,6,1e3,A),u[A+11|0]>=0)break i;Z(i[A>>2]);break i}if(w=G(f,w),f=w>>>3|0,f>>>0>B-o>>>0){if(e=A,A=d2(s+4|0,19126),q(e,2,136,A),u[A+11|0]>=0)break i;Z(i[A>>2]);break i}if(q4(A,e+32|0,f,n,10178),i[A>>2])break i;u[A+19|0]<0&&Z(i[A+8>>2]),Wu(e+20|0,f),!f|w>>>0<8||x(i[e+20>>2],i[r>>2]+i[k>>2]|0,f),k8(A,107664)}v=s+16|0}function j7(){var A=0,e=0,r=0,f=0,k=0,n=0,t=0,o=0,s=0,w=0,h=0,_=0,B=0,m=0,X=0,Q=0,V=0,F=0,I=0,E=0,R=0,N=0,M=0;i:{if(o=y2(11296),o)for(o0(o,255,11296),k=o+1056|0,i[31288]=k,i[31284]=k,i[31283]=o+992,i[31282]=o+928,i[31281]=o+864,i[31280]=o+800,i[31279]=o+736,i[31278]=o+672,i[31277]=o+608,i[31276]=o+544,i[31275]=o+480,i[31274]=o+416,i[31273]=o+352,i[31272]=o+288,i[31271]=o+224,i[31270]=o+160,i[31269]=o+96,i[31268]=o+32,k=o+16|0,i[31267]=k,i[31266]=k,i[31265]=k,i[31264]=k,i[31263]=k,i[31262]=k,i[31261]=k,i[31260]=k,i[31259]=o,i[31258]=o,i[31257]=o,i[31256]=o,i[31255]=o,i[31254]=o,i[31253]=o,i[31252]=o,k=o+1312|0,i[31289]=k,i[31285]=k,k=o+1568|0,i[31290]=k,i[31286]=k,k=o+2080|0,i[31296]=k,i[31292]=k,k=o+1824|0,i[31291]=k,i[31287]=k,k=o+2336|0,i[31297]=k,i[31293]=k,k=o+2592|0,i[31298]=k,i[31294]=k,k=o+3104|0,i[31304]=k,i[31300]=k,k=o+2848|0,i[31299]=k,i[31295]=k,k=o+4128|0,i[31305]=k,i[31301]=k,k=o+5152|0,i[31306]=k,i[31302]=k,k=o+7200|0,i[31312]=k,i[31308]=k,k=o+6176|0,i[31307]=k,i[31303]=k,k=o+8224|0,i[31313]=k,i[31309]=k,k=o+9248|0,i[31314]=k,i[31310]=k,k=o+10272|0,i[31315]=k,i[31311]=k,m=2;;){N=m-2|0,s=1<<m;e:{if((m|0)!=2){for(F=(m|0)==3,B=F?11:14,M=0,r=1;;){for(k=1,A=0;;){for(I=((N<<6)+(M<<5)|0)+(A<<4)|0,Q=I+125008|0,E=k?9:15,w=0;;){for(R=w&3,t=w<<m,A=0;;){f=A|w,e=0;r:{if(!f)break r;if(e=R+(A&3)|0,h=e>>>0<=2?e?1:2:0,r){if(h=f>>>0<4?h:h+3|0,e=h+E|0,(m|0)==3)break r;e=h+21|0;break r}if(e=h+9|0,(m|0)==3)break r;e=h|12}if(h=t+(i[Q>>2]+A|0)|0,f=l[h|0],e=r?e:e+27|0,(f|0)!=255&(e|0)!=(f|0))break i;if(u[h|0]=e,A=A+1|0,(s|0)==(A|0))break}if(w=w+1|0,(w|0)==(s|0))break}for(t=I+125012|0,w=0;;){for(e=w&3,h=e?(e|0)==1:2,f=F?h+9|0:h|12,X=h+3|0,n=w<<m,A=0;;){Q=A|w,e=Q?f:0,R=!r;r:{if(R|!Q)break r;if(e=Q>>>0<4?h:X,!F){e=e+21|0;break r}e=e+E|0}if(Q=n+(i[t>>2]+A|0)|0,_=l[Q|0],e=r?e:e+27|0,(_|0)!=255&(e|0)!=(_|0))break i;if(u[Q|0]=e,A=A+1|0,(s|0)==(A|0))break}if(w=w+1|0,(w|0)==(s|0))break}for(Q=I+125016|0,w=0;;){for(t=w<<m,A=0;;){f=A|w,e=0;r:{if(!f)break r;if(e=A&3,h=e?(e|0)==1:2,!r){if(e=h|12,!F)break r;e=h+9|0;break r}if(h=f>>>0<4?h:h+3|0,e=h+21|0,!F)break r;e=h+E|0}if(h=t+(i[Q>>2]+A|0)|0,f=l[h|0],e=r?e:e+27|0,(f|0)!=255&(e|0)!=(f|0))break i;if(u[h|0]=e,A=A+1|0,(s|0)==(A|0))break}if(w=w+1|0,(w|0)==(s|0))break}for(I=I+125020|0,w=0;;){for(Q=w<<m,A=0;;){h=A|w,e=h?B:0;r:{if(R|!h)break r;if(e=h>>>0<4?2:5,!F){e=e+21|0;break r}e=e+E|0}if(h=Q+(i[I>>2]+A|0)|0,t=l[h|0],e=r?e:e+27|0,(t|0)!=255&(e|0)!=(t|0))break i;if(u[h|0]=e,A=A+1|0,(s|0)==(A|0))break}if(w=w+1|0,(w|0)==(s|0))break}if(A=1,e=k,k=0,!e)break}if(M=1,k=r,r=0,!k)break}break e}for(w=N<<6,F=w+125036|0,E=w+125032|0,h=w+125028|0,I=w+125024|0,N=w+125020|0,M=w+125016|0,Q=w+125012|0,R=w+125008|0,e=0,k=1;;){r=0;r:{if(!k){for(e=w+(e<<5)|0,B=e+125008|0;;){for(t=r<<2,f=r<<m,A=0;;){if(X=f+(i[B>>2]+A|0)|0,n=l[X|0],V=(n|0)!=255,_=n,n=l[(A+t|0)+63552|0]+27|0,V&(_|0)!=(n|0))break i;if(u[X|0]=n,A=A+1|0,(s|0)==(A|0))break}if(r=r+1|0,(s|0)==(r|0))break}for(B=e+125012|0,r=0;;){for(t=r<<2,f=r<<m,A=0;;){if(X=f+(i[B>>2]+A|0)|0,n=l[X|0],V=(n|0)!=255,_=n,n=l[(A+t|0)+63552|0]+27|0,V&(_|0)!=(n|0))break i;if(u[X|0]=n,A=A+1|0,(s|0)==(A|0))break}if(r=r+1|0,(s|0)==(r|0))break}for(B=e+125016|0,r=0;;){for(t=r<<2,f=r<<m,A=0;;){if(X=f+(i[B>>2]+A|0)|0,n=l[X|0],V=(n|0)!=255,_=n,n=l[(A+t|0)+63552|0]+27|0,V&(_|0)!=(n|0))break i;if(u[X|0]=n,A=A+1|0,(s|0)==(A|0))break}if(r=r+1|0,(s|0)==(r|0))break}for(B=e+125020|0,r=0;;){for(t=r<<2,f=r<<m,A=0;;){if(X=f+(i[B>>2]+A|0)|0,n=l[X|0],V=(n|0)!=255,_=n,n=l[(A+t|0)+63552|0]+27|0,V&(_|0)!=(n|0))break i;if(u[X|0]=n,A=A+1|0,(s|0)==(A|0))break}if(r=r+1|0,(s|0)==(r|0))break}for(B=e+125024|0,r=0;;){for(t=r<<2,f=r<<m,A=0;;){if(X=f+(i[B>>2]+A|0)|0,n=l[X|0],V=(n|0)!=255,_=n,n=l[(A+t|0)+63552|0]+27|0,V&(_|0)!=(n|0))break i;if(u[X|0]=n,A=A+1|0,(s|0)==(A|0))break}if(r=r+1|0,(s|0)==(r|0))break}for(B=e+125028|0,r=0;;){for(t=r<<2,f=r<<m,A=0;;){if(X=f+(i[B>>2]+A|0)|0,n=l[X|0],V=(n|0)!=255,_=n,n=l[(A+t|0)+63552|0]+27|0,V&(_|0)!=(n|0))break i;if(u[X|0]=n,A=A+1|0,(s|0)==(A|0))break}if(r=r+1|0,(s|0)==(r|0))break}for(B=e+125032|0,r=0;;){for(t=r<<2,f=r<<m,A=0;;){if(X=f+(i[B>>2]+A|0)|0,n=l[X|0],V=(n|0)!=255,_=n,n=l[(A+t|0)+63552|0]+27|0,V&(_|0)!=(n|0))break i;if(u[X|0]=n,A=A+1|0,(s|0)==(A|0))break}if(r=r+1|0,(s|0)==(r|0))break}for(e=e+125036|0,r=0;;){for(B=r<<2,t=r<<m,A=0;;){if(f=t+(i[e>>2]+A|0)|0,X=l[f|0],_=(X|0)!=255,n=X,X=l[(A+B|0)+63552|0]+27|0,_&(n|0)!=(X|0))break i;if(u[f|0]=X,A=A+1|0,(s|0)==(A|0))break}if(r=r+1|0,(s|0)==(r|0))break}break r}for(;;){for(e=r<<2,B=r<<m,A=0;;){if(t=B+(i[R>>2]+A|0)|0,f=l[t|0],_=(f|0)!=255,n=f,f=l[(A+e|0)+63552|0],_&(n|0)!=(f|0))break i;if(u[t|0]=f,A=A+1|0,(s|0)==(A|0))break}if(e=0,r=r+1|0,(s|0)==(r|0))break}for(;;){for(r=e<<2,B=e<<m,A=0;;){if(t=B+(i[Q>>2]+A|0)|0,f=l[t|0],_=(f|0)!=255,n=f,f=l[(A+r|0)+63552|0],_&(n|0)!=(f|0))break i;if(u[t|0]=f,A=A+1|0,(s|0)==(A|0))break}if(r=0,e=e+1|0,(s|0)==(e|0))break}for(;;){for(e=r<<2,B=r<<m,A=0;;){if(t=B+(i[M>>2]+A|0)|0,f=l[t|0],_=(f|0)!=255,n=f,f=l[(A+e|0)+63552|0],_&(n|0)!=(f|0))break i;if(u[t|0]=f,A=A+1|0,(s|0)==(A|0))break}if(e=0,r=r+1|0,(s|0)==(r|0))break}for(;;){for(r=e<<2,B=e<<m,A=0;;){if(t=B+(i[N>>2]+A|0)|0,f=l[t|0],_=(f|0)!=255,n=f,f=l[(A+r|0)+63552|0],_&(n|0)!=(f|0))break i;if(u[t|0]=f,A=A+1|0,(s|0)==(A|0))break}if(r=0,e=e+1|0,(s|0)==(e|0))break}for(;;){for(e=r<<2,B=r<<m,A=0;;){if(t=B+(i[I>>2]+A|0)|0,f=l[t|0],_=(f|0)!=255,n=f,f=l[(A+e|0)+63552|0],_&(n|0)!=(f|0))break i;if(u[t|0]=f,A=A+1|0,(s|0)==(A|0))break}if(e=0,r=r+1|0,(s|0)==(r|0))break}for(;;){for(r=e<<2,B=e<<m,A=0;;){if(t=B+(i[h>>2]+A|0)|0,f=l[t|0],_=(f|0)!=255,n=f,f=l[(A+r|0)+63552|0],_&(n|0)!=(f|0))break i;if(u[t|0]=f,A=A+1|0,(s|0)==(A|0))break}if(r=0,e=e+1|0,(s|0)==(e|0))break}for(;;){for(e=r<<2,B=r<<m,A=0;;){if(t=B+(i[E>>2]+A|0)|0,f=l[t|0],_=(f|0)!=255,n=f,f=l[(A+e|0)+63552|0],_&(n|0)!=(f|0))break i;if(u[t|0]=f,A=A+1|0,(s|0)==(A|0))break}if(e=0,r=r+1|0,(s|0)==(r|0))break}for(;;){for(r=e<<2,B=e<<m,A=0;;){if(t=B+(i[F>>2]+A|0)|0,f=l[t|0],_=(f|0)!=255,n=f,f=l[(A+r|0)+63552|0],_&(n|0)!=(f|0))break i;if(u[t|0]=f,A=A+1|0,(s|0)==(A|0))break}if(e=e+1|0,(s|0)==(e|0))break}}if(e=1,r=k,k=0,!r)break}}if(m=m+1|0,(m|0)==6)break}return(o|0)!=0}D0(17964,18297,2114,13828),H()}function wB(A,e,r,f,k,n,t,o){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,t=t|0,o=o|0;var s=0,w=U(0),h=0,_=0,B=0,m=0,X=0,Q=0,V=0,F=0,I=0,E=0,R=0,N=0,M=0,z=0,S=0,O=0,P=U(0),a=U(0),$=0,f0=0,A0=U(0),n0=U(0),_0=0,m0=0,X0=0,g0=0,I0=0,e0=0,r0=0,N0=0,U0=U(0),M0=0,H0=U(0),P0=U(0),K0=U(0),$0=U(0),L0=U(0);n=v-144|0,v=n,e=i[r>>2],R=i[e+112>>2],I=i[e+108>>2],S=j0(e,10),V=i[i[r>>2]+120>>2],t=p(172),i[t>>2]=94812,i[t+4>>2]=0,i[t+8>>2]=0,o0(t+16|0,0,80),f=i[t+4>>2],s=f+1|0,i[t+4>>2]=s,i[t+104>>2]=0,i[t+108>>2]=0,i[t+36>>2]=1,i[t+40>>2]=1,u[t+24|0]=1,g[t+22>>1]=2,g[t+18>>1]=2,g[t+20>>1]=2,i[t+112>>2]=0,i[t+116>>2]=4740,i[t+140>>2]=0,i[t+144>>2]=0,i[t+128>>2]=99,i[t+132>>2]=99,i[t+120>>2]=0,i[t+124>>2]=0,i[t+12>>2]=95160,i[t+148>>2]=0,i[t+152>>2]=0,e=t+140|0,i[t+136>>2]=e,i[t+156>>2]=0,i[t+160>>2]=0,i[t+164>>2]=0,i[t+168>>2]=0,i[t+4>>2]=f,f=i[t+8>>2],N=t+12|0,i[t+96>>2]=N,i[t+8>>2]=f+1,i[t+100>>2]=t,s||(W[i[i[t>>2]+8>>2]](t),y(t)),i[N+120>>2]=1,i[N+116>>2]=0,i[N+112>>2]=R,i[N+108>>2]=I,T0(n+96|0,N,0,I,R,S,o),m=I+1>>>1|0,s=R+1>>>1|0,T0(n+72|0,N,1,m,s,S,o),_=n+128|0;i:{if(i[n+96>>2]){if(f=i[n+100>>2],i[n+120>>2]=i[n+96>>2],i[n+124>>2]=f,u[n+115|0]>=0){f=i[n+108>>2],i[_>>2]=i[n+104>>2],i[_+4>>2]=f,i[_+8>>2]=i[n+112>>2];break i}T(_,i[n+104>>2],i[n+108>>2]);break i}if(f=i[n+76>>2],i[n+120>>2]=i[n+72>>2],i[n+124>>2]=f,u[n+91|0]>=0){f=i[n+84>>2],i[_>>2]=i[n+80>>2],i[_+4>>2]=f,i[_+8>>2]=i[n+88>>2];break i}T(_,i[n+80>>2],i[n+84>>2])}T0(n+48|0,N,2,m,s,S,o),s=n+16|0;i:{if(i[n+120>>2]){if(f=i[n+124>>2],i[n+8>>2]=i[n+120>>2],i[n+12>>2]=f,u[n+139|0]>=0){f=i[_+4>>2],i[s>>2]=i[_>>2],i[s+4>>2]=f,i[s+8>>2]=i[_+8>>2];break i}T(s,i[n+128>>2],i[n+132>>2]);break i}if(f=i[n+52>>2],i[n+8>>2]=i[n+48>>2],i[n+12>>2]=f,u[n+67|0]>=0){f=i[n+60>>2],i[s>>2]=i[n+56>>2],i[s+4>>2]=f,i[s+8>>2]=i[n+64>>2];break i}T(s,i[n+56>>2],i[n+60>>2])}u[n+67|0]<0&&Z(i[n+56>>2]),u[n+139|0]<0&&Z(i[n+128>>2]),u[n+91|0]<0&&Z(i[n+80>>2]),u[n+115|0]<0&&Z(i[n+104>>2]);i:{e:{if(i[n+8>>2]){if(e=i[n+12>>2],i[A>>2]=i[n+8>>2],i[A+4>>2]=e,r=A+8|0,u[n+27|0]>=0){e=i[s+4>>2],i[r>>2]=i[s>>2],i[r+4>>2]=e,i[r+8>>2]=i[s+8>>2],u[A+20|0]=1;break e}if(T(r,i[n+16>>2],i[n+20>>2]),e=u[n+27|0],u[A+20|0]=1,(e|0)>=0)break e;Z(i[n+16>>2]);break e}u[n+27|0]<0&&Z(i[n+16>>2]);r:{f:switch(V-13|0){case 0:case 2:break f;default:break r}if(T0(n+8|0,N,6,I,R,S,o),i[n+8>>2]){if(e=i[n+12>>2],i[A>>2]=i[n+8>>2],i[A+4>>2]=e,r=A+8|0,u[n+27|0]>=0){e=i[n+20>>2],i[r>>2]=i[n+16>>2],i[r+4>>2]=e,i[r+8>>2]=i[n+24>>2],u[A+20|0]=1;break e}if(T(r,i[n+16>>2],i[n+20>>2]),e=u[n+27|0],u[A+20|0]=1,(e|0)>=0)break e;Z(i[n+16>>2]);break e}if(u[n+27|0]>=0)break r;Z(i[n+16>>2])}r:{f:{if(m=i[r>>2],o=i[m+128>>2],!o)break f;for(s=m+128|0,f=s;r=i[o+16>>2]<10,f=r?f:o,o=i[(r?4:0)+o>>2],!!o;);if((f|0)==(s|0))break f;if(s=0,i[f+16>>2]>10)break r;m0=i[f+44>>2],s=i[f+56>>2];break r}s=0}r:{f:{if(f=i[e>>2],f){for(r=e,o=f;F=i[o+16>>2],r=(F|0)<0?r:o,o=i[(F>>>29&4)+o>>2],!!o;);o=0;A:{if((e|0)==(r|0)||(o=0,i[r+16>>2]>0))break A;B=i[r+56>>2],o=i[r+44>>2]}for($=o,r=e,o=f;F=i[o+16>>2]<=0,r=F?r:o,o=i[(F?4:0)+o>>2],!!o;);h=0;A:{if((e|0)==(r|0)||(h=0,i[r+16>>2]>1))break A;M0=i[r+44>>2],h=i[r+56>>2]}for(r=e,o=f;F=i[o+16>>2]<2,r=F?r:o,o=i[(F?4:0)+o>>2],!!o;);F=0;A:{if((e|0)==(r|0)||(F=0,i[r+16>>2]>2))break A;I0=i[r+56>>2],F=i[r+44>>2]}r=0;A:switch(V-13|0){case 0:case 2:break A;default:break r}for(o=e;r=i[f+16>>2]<6,o=r?o:f,f=i[(r?4:0)+f>>2],!!f;);if((e|0)!=(o|0))break f}r=0;break r}if(i[o+16>>2]>6){r=0;break r}O=i[o+56>>2]>>>1|0,r=i[o+44>>2]}e0=l[k+22|0],e=i[m+120>>2],Nr(n+8|0,C[k+20>>1],C[k+16>>1]);r:{if(!R)break r;f0=(V&-3)==13?8:6,k=-1<<S^-1,M=e&-2,z=(M|0)==14,X0=z^3;f:{if(!I)break f;r0=B>>>1|0,A0=U(16<<S-8),X=z?4:5,E=!z,n0=p0[n+20>>2],P=p0[n+16>>2],a=p0[n+12>>2],e=0;A:switch(V-13|0){case 0:case 2:if(g0=z^7,e0&1)for(;;){for(_0=G(e,s)+m0|0,_=(G(e,O)<<1)+r|0,V=(G(e,r0)<<1)+$|0,f=0;m=f<<1,N0=m+V|0,B=_0+G(f,f0)|0,Q=B+z|0,w=U(U(U(U((l[Q+4|0]<<8|l[X+B|0])>>>0)*n0)+U(U(U((l[B+E|0]|l[Q|0]<<8)>>>0)*a)+U(P*U((l[B+X0|0]|l[Q+2|0]<<8)>>>0))))+U(.5)),U(w2(w))<U(2147483648)?o=~~w:o=-2147483648,g[N0>>1]=(o|0)>=0?(k|0)<(o|0)?k:o:0,g[_+m>>1]=l[B+g0|0]|l[Q+6|0]<<8,f=f+1|0,(I|0)!=(f|0););if(e=e+1|0,(R|0)==(e|0))break f}for(;;){for(_0=G(e,s)+m0|0,_=(G(e,O)<<1)+r|0,V=(G(e,r0)<<1)+$|0,f=0;m=f<<1,N0=m+V|0,B=_0+G(f,f0)|0,Q=B+z|0,w=U(U(U(U(U(U((l[Q+4|0]<<8|l[X+B|0])>>>0)*n0)+U(U(U((l[B+E|0]|l[Q|0]<<8)>>>0)*a)+U(P*U((l[B+X0|0]|l[Q+2|0]<<8)>>>0))))*U(.8554700016975403))+A0)+U(.5)),U(w2(w))<U(2147483648)?o=~~w:o=-2147483648,g[N0>>1]=(o|0)>=0?(k|0)<(o|0)?k:o:0,g[_+m>>1]=l[B+g0|0]|l[Q+6|0]<<8,f=f+1|0,(I|0)!=(f|0););if(e=e+1|0,(R|0)==(e|0))break}break f;default:break A}for(;;){for(m=G(e,s)+m0|0,B=(G(e,r0)<<1)+$|0,o=0;f=B+(o<<1)|0,V=m+G(o,f0)|0,r=V+z|0,w=U(U(U((l[r+4|0]<<8|l[X+V|0])>>>0)*n0)+U(U(U((l[V+E|0]|l[r|0]<<8)>>>0)*a)+U(P*U((l[V+X0|0]|l[r+2|0]<<8)>>>0)))),w=U((e0&1?w:U(U(w*U(.8554700016975403))+A0))+U(.5)),U(w2(w))<U(2147483648)?r=~~w:r=-2147483648,g[f>>1]=(r|0)>=0?(r|0)>(k|0)?k:r:0,o=o+1|0,(I|0)!=(o|0););if(e=e+1|0,(R|0)==(e|0))break}}if(!I)break r;for(g0=I0>>>1|0,I0=h>>>1|0,_0=(M|0)==14?4:5,_=!z,U0=U((1<<S-1&65535)>>>0),o=0,H0=p0[n+44>>2],P0=p0[n+40>>2],K0=p0[n+36>>2],$0=p0[n+32>>2],L0=p0[n+28>>2],n0=p0[n+24>>2];;){for(X=(o|1)>>>0<R>>>0?s:0,V=G(o,s)+m0|0,e=o>>>1|0,m=(G(e,g0)<<1)+F|0,B=(G(e,I0)<<1)+M0|0,r=0;$=r+B|0,O=V+G(r,f0)|0,E=O+z|0,h=E+4|0,Q=(r|1)>>>0<I>>>0?f0:0,f=h+Q|0,M=O+_0|0,e=M+Q|0,P=U(U((((l[f|0]<<8|l[e|0])+(l[M|0]|l[E+4|0]<<8)|0)+(l[X+M|0]|l[X+h|0]<<8)|0)+(l[e+X|0]|l[f+X|0]<<8)>>>0)*U(.25)),h=_+O|0,f=h+Q|0,e=Q+E|0,a=U(U((((l[f|0]|l[e|0]<<8)+(l[h|0]|l[E|0]<<8)|0)+(l[X+h|0]|l[X+E|0]<<8)|0)+(l[f+X|0]|l[e+X|0]<<8)>>>0)*U(.25)),M=O+X0|0,h=M+Q|0,f=E+2|0,e=f+Q|0,A0=U(U((((l[h|0]|l[e|0]<<8)+(l[M|0]|l[E+2|0]<<8)|0)+(l[X+M|0]|l[f+X|0]<<8)|0)+(l[X+h|0]|l[e+X|0]<<8)>>>0)*U(.25)),w=U(U(P*$0)+U(U(a*n0)+U(L0*A0))),h=e0&1,w=U(U((h?w:U(w*U(.875)))+U0)+U(.5)),U(w2(w))<U(2147483648)?e=~~w:e=-2147483648,g[$>>1]=(e|0)>=0?(e|0)>(k|0)?k:e:0,f=r+m|0,w=U(U(P*H0)+U(U(a*K0)+U(A0*P0))),w=U(U((h?w:U(w*U(.875)))+U0)+U(.5)),U(w2(w))<U(2147483648)?e=~~w:e=-2147483648,g[f>>1]=(e|0)>=0?(e|0)>(k|0)?k:e:0,r=r+2|0,I>>>0>r>>>0;);if(o=o+2|0,!(R>>>0>o>>>0))break}}u[A+20|0]=0,i[A+4>>2]=t,i[A>>2]=N;break i}if(A=i[t+4>>2],i[t+4>>2]=A-1,A)break i;W[i[i[t>>2]+8>>2]](t),y(t)}v=n+144|0}function hB(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0;var k=0,n=0,t=0,o=0,s=0,w=0,h=0,_=0,B=0;t=v-32|0,v=t,k=C0(r),i[t+16>>2]=k;i:{e:{r:{f:{A:{k:{n:{if((k|0)<=1886547813){if((k|0)==1852009571)break k;if((k|0)!=1852009592)break n;f=p(24),u[f+22|0]=1,g[f+20>>1]=6,g[f+16>>1]=1,g[f+18>>1]=13,i[f+4>>2]=1,i[f+8>>2]=0,i[f+12>>2]=95368,i[f>>2]=95288,n=f+12|0,i[e+100>>2]=n,k=i[e+104>>2],i[e+104>>2]=f;t:{if(!k||(e=i[k+4>>2],i[k+4>>2]=e-1,e))break t;W[i[i[k>>2]+8>>2]](k),y(k)}e=v-16|0,v=e,k=i[r>>2],o=W[i[i[k>>2]+8>>2]](k)|0,s=i[r>>2],k=l0,o=o+7|0,k=o>>>0<7?k+1|0:k;t:{if(W[i[i[s>>2]+12>>2]](s,o,k)|0){if(u[e+4|0]=0,u[e+15|0]=0,q(A,2,100,e+4|0),u[e+15|0]>=0)break t;Z(i[e+4>>2]);break t}if(_=n,B=o2(r),g[_+4>>1]=B,_=n,B=o2(r),g[_+6>>1]=B,_=n,B=o2(r),g[_+8>>1]=B,_=n,B=X2(r)>>>7|0,u[_+10|0]=B,k=i[26917],i[A>>2]=i[26916],i[A+4>>2]=k,k=A+8|0,u[107683]>=0){n=i[26919],i[k>>2]=i[26918],i[k+4>>2]=n,i[k+8>>2]=i[26920];break t}T(k,i[26918],i[26919])}if(v=e+16|0,i[A>>2])break r;if(u[A+19|0]<0&&Z(i[A+8>>2]),e=i[f+4>>2],i[f+4>>2]=e-1,e)break f;W[i[i[f>>2]+8>>2]](f),y(f);break f}if((k|0)==1886547814|(k|0)==1917403971)break A}if(u[t+20|0]=0,u[t+31|0]=0,q(A,2,126,t+20|0),u[t+31|0]>=0)break i;Z(i[t+20>>2]);break i}f=p(24),u[f+22|0]=1,g[f+20>>1]=6,g[f+16>>1]=1,g[f+18>>1]=13,i[f+4>>2]=1,i[f+8>>2]=0,i[f+12>>2]=95368,i[f>>2]=95288,n=f+12|0,i[e+100>>2]=n,k=i[e+104>>2],i[e+104>>2]=f;k:{if(!k||(e=i[k+4>>2],i[k+4>>2]=e-1,e))break k;W[i[i[k>>2]+8>>2]](k),y(k)}e=v-16|0,v=e,k=i[r>>2],o=W[i[i[k>>2]+8>>2]](k)|0,s=i[r>>2],k=l0,o=o+6|0,k=o>>>0<6?k+1|0:k;k:{if(W[i[i[s>>2]+12>>2]](s,o,k)|0){if(u[e+4|0]=0,u[e+15|0]=0,q(A,2,100,e+4|0),u[e+15|0]>=0)break k;Z(i[e+4>>2]);break k}if(_=n,B=o2(r),g[_+4>>1]=B,_=n,B=o2(r),g[_+6>>1]=B,k=o2(r),g[n+8>>1]=k,u[n+10|0]=!k,k=i[26917],i[A>>2]=i[26916],i[A+4>>2]=k,k=A+8|0,u[107683]>=0){n=i[26919],i[k>>2]=i[26918],i[k+4>>2]=n,i[k+8>>2]=i[26920];break k}T(k,i[26918],i[26919])}if(v=e+16|0,i[A>>2])break e;if(u[A+19|0]<0&&Z(i[A+8>>2]),e=i[f+4>>2],i[f+4>>2]=e-1,e)break f;W[i[i[f>>2]+8>>2]](f),y(f);break f}if(k=i[e+12>>2],w=k,n=i[e+8>>2],!(k|n)){if(e=p(56),i[t+20>>2]=e,i[t+24>>2]=52,i[t+28>>2]=-2147483592,r=l[16316]|l[16317]<<8|(l[16318]<<16|l[16319]<<24),f=l[16312]|l[16313]<<8|(l[16314]<<16|l[16315]<<24),u[e|0]=f,u[e+1|0]=f>>>8,u[e+2|0]=f>>>16,u[e+3|0]=f>>>24,u[e+4|0]=r,u[e+5|0]=r>>>8,u[e+6|0]=r>>>16,u[e+7|0]=r>>>24,u[e+52|0]=0,r=l[16360]|l[16361]<<8|(l[16362]<<16|l[16363]<<24),u[e+48|0]=r,u[e+49|0]=r>>>8,u[e+50|0]=r>>>16,u[e+51|0]=r>>>24,r=l[16356]|l[16357]<<8|(l[16358]<<16|l[16359]<<24),f=l[16352]|l[16353]<<8|(l[16354]<<16|l[16355]<<24),u[e+40|0]=f,u[e+41|0]=f>>>8,u[e+42|0]=f>>>16,u[e+43|0]=f>>>24,u[e+44|0]=r,u[e+45|0]=r>>>8,u[e+46|0]=r>>>16,u[e+47|0]=r>>>24,r=l[16348]|l[16349]<<8|(l[16350]<<16|l[16351]<<24),f=l[16344]|l[16345]<<8|(l[16346]<<16|l[16347]<<24),u[e+32|0]=f,u[e+33|0]=f>>>8,u[e+34|0]=f>>>16,u[e+35|0]=f>>>24,u[e+36|0]=r,u[e+37|0]=r>>>8,u[e+38|0]=r>>>16,u[e+39|0]=r>>>24,r=l[16340]|l[16341]<<8|(l[16342]<<16|l[16343]<<24),f=l[16336]|l[16337]<<8|(l[16338]<<16|l[16339]<<24),u[e+24|0]=f,u[e+25|0]=f>>>8,u[e+26|0]=f>>>16,u[e+27|0]=f>>>24,u[e+28|0]=r,u[e+29|0]=r>>>8,u[e+30|0]=r>>>16,u[e+31|0]=r>>>24,r=l[16332]|l[16333]<<8|(l[16334]<<16|l[16335]<<24),f=l[16328]|l[16329]<<8|(l[16330]<<16|l[16331]<<24),u[e+16|0]=f,u[e+17|0]=f>>>8,u[e+18|0]=f>>>16,u[e+19|0]=f>>>24,u[e+20|0]=r,u[e+21|0]=r>>>8,u[e+22|0]=r>>>16,u[e+23|0]=r>>>24,r=l[16324]|l[16325]<<8|(l[16326]<<16|l[16327]<<24),f=l[16320]|l[16321]<<8|(l[16322]<<16|l[16323]<<24),u[e+8|0]=f,u[e+9|0]=f>>>8,u[e+10|0]=f>>>16,u[e+11|0]=f>>>24,u[e+12|0]=r,u[e+13|0]=r>>>8,u[e+14|0]=r>>>16,u[e+15|0]=r>>>24,q(A,4,0,t+20|0),u[t+31|0]>=0)break i;Z(i[t+20>>2]);break i}if(h=i[e+32>>2],o=n-h|0,k=o-4|0,f=i[f+32>>2],!(!f|(w-(n>>>0<h>>>0)|0)==(o>>>0<4|0)&f>>>0>=k>>>0)){if(e=p(48),i[t+20>>2]=e,i[t+24>>2]=44,i[t+28>>2]=-2147483600,r=l[11706]|l[11707]<<8|(l[11708]<<16|l[11709]<<24),f=l[11702]|l[11703]<<8|(l[11704]<<16|l[11705]<<24),u[e|0]=f,u[e+1|0]=f>>>8,u[e+2|0]=f>>>16,u[e+3|0]=f>>>24,u[e+4|0]=r,u[e+5|0]=r>>>8,u[e+6|0]=r>>>16,u[e+7|0]=r>>>24,u[e+44|0]=0,r=l[11742]|l[11743]<<8|(l[11744]<<16|l[11745]<<24),u[e+40|0]=r,u[e+41|0]=r>>>8,u[e+42|0]=r>>>16,u[e+43|0]=r>>>24,r=l[11738]|l[11739]<<8|(l[11740]<<16|l[11741]<<24),f=l[11734]|l[11735]<<8|(l[11736]<<16|l[11737]<<24),u[e+32|0]=f,u[e+33|0]=f>>>8,u[e+34|0]=f>>>16,u[e+35|0]=f>>>24,u[e+36|0]=r,u[e+37|0]=r>>>8,u[e+38|0]=r>>>16,u[e+39|0]=r>>>24,r=l[11730]|l[11731]<<8|(l[11732]<<16|l[11733]<<24),f=l[11726]|l[11727]<<8|(l[11728]<<16|l[11729]<<24),u[e+24|0]=f,u[e+25|0]=f>>>8,u[e+26|0]=f>>>16,u[e+27|0]=f>>>24,u[e+28|0]=r,u[e+29|0]=r>>>8,u[e+30|0]=r>>>16,u[e+31|0]=r>>>24,r=l[11722]|l[11723]<<8|(l[11724]<<16|l[11725]<<24),f=l[11718]|l[11719]<<8|(l[11720]<<16|l[11721]<<24),u[e+16|0]=f,u[e+17|0]=f>>>8,u[e+18|0]=f>>>16,u[e+19|0]=f>>>24,u[e+20|0]=r,u[e+21|0]=r>>>8,u[e+22|0]=r>>>16,u[e+23|0]=r>>>24,r=l[11714]|l[11715]<<8|(l[11716]<<16|l[11717]<<24),f=l[11710]|l[11711]<<8|(l[11712]<<16|l[11713]<<24),u[e+8|0]=f,u[e+9|0]=f>>>8,u[e+10|0]=f>>>16,u[e+11|0]=f>>>24,u[e+12|0]=r,u[e+13|0]=r>>>8,u[e+14|0]=r>>>16,u[e+15|0]=r>>>24,q(A,2,1e3,t+20|0),u[t+31|0]>=0)break i;Z(i[t+20>>2]);break i}if(f=i[r>>2],n=W[i[i[f>>2]+8>>2]](f)|0,o=i[r>>2],f=l0,n=k+n|0,f=n>>>0<k>>>0?f+1|0:f,W[i[i[o>>2]+12>>2]](o,n,f)|0){if(u[t+20|0]=0,u[t+31|0]=0,q(A,2,100,t+20|0),u[t+31|0]>=0)break i;Z(i[t+20>>2]);break i}f=t+20|0,i[f+8>>2]=0,i[f>>2]=0,i[f+4>>2]=0;A:{k:{if(k){if((k|0)<0)break k;n=p(k),i[f>>2]=n,o=k+n|0,i[f+8>>2]=o,k&&o0(n,0,k),i[f+4>>2]=o}break A}G0(),H()}if(k)for(;n=X2(r),u[i[f>>2]+s|0]=n,s=s+1|0,(k|0)!=(s|0););n=t+8|0,k=p(32),i[k+4>>2]=0,i[k+8>>2]=0,i[k>>2]=95488,o=i[t+16>>2],i[k+28>>2]=0,i[k+20>>2]=0,i[k+24>>2]=0,i[k+16>>2]=o,i[k+12>>2]=95328;A:{k:{if(o=i[f+4>>2],s=i[f>>2],(o|0)!=(s|0)){if(o=o-s|0,(o|0)<0)break k;w=p(o),i[k+20>>2]=w,h=o+w|0,i[k+28>>2]=h,o&&x(w,s,o),i[k+24>>2]=h}i[n+4>>2]=k,i[n>>2]=k+12;break A}G0(),H()}if(p8(e+100|0,n),I2(n),e=i[f>>2],!e)break f;i[f+4>>2]=e,Z(e)}if(l[r+20|0]==1){if(u[t+20|0]=0,u[t+31|0]=0,q(A,2,100,t+20|0),u[t+31|0]>=0)break i;Z(i[t+20>>2]);break i}if(e=i[26917],i[A>>2]=i[26916],i[A+4>>2]=e,A=A+8|0,u[107683]>=0){e=i[26919],i[A>>2]=i[26918],i[A+4>>2]=e,i[A+8>>2]=i[26920];break i}T(A,i[26918],i[26919]);break i}if(A=i[f+4>>2],i[f+4>>2]=A-1,A)break i;W[i[i[f>>2]+8>>2]](f),y(f);break i}if(A=i[f+4>>2],i[f+4>>2]=A-1,A)break i;W[i[i[f>>2]+8>>2]](f),y(f)}v=t+32|0}function _B(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,t=0,o=0,s=0,w=0,h=0;w=v-48|0,v=w,s=w+16|0,o=v-48|0,v=o,t=i[i[e>>2]+180>>2],f=i[t+104>>2];i:{if((f|0)==i[t+108>>2]){f=p(40),i[o+12>>2]=f,i[o+16>>2]=33,i[o+20>>2]=-2147483608,u[f+32|0]=l[24188],t=l[24184]|l[24185]<<8|(l[24186]<<16|l[24187]<<24),k=l[24180]|l[24181]<<8|(l[24182]<<16|l[24183]<<24),u[f+24|0]=k,u[f+25|0]=k>>>8,u[f+26|0]=k>>>16,u[f+27|0]=k>>>24,u[f+28|0]=t,u[f+29|0]=t>>>8,u[f+30|0]=t>>>16,u[f+31|0]=t>>>24,t=l[24176]|l[24177]<<8|(l[24178]<<16|l[24179]<<24),k=l[24172]|l[24173]<<8|(l[24174]<<16|l[24175]<<24),u[f+16|0]=k,u[f+17|0]=k>>>8,u[f+18|0]=k>>>16,u[f+19|0]=k>>>24,u[f+20|0]=t,u[f+21|0]=t>>>8,u[f+22|0]=t>>>16,u[f+23|0]=t>>>24,t=l[24168]|l[24169]<<8|(l[24170]<<16|l[24171]<<24),k=l[24164]|l[24165]<<8|(l[24166]<<16|l[24167]<<24),u[f+8|0]=k,u[f+9|0]=k>>>8,u[f+10|0]=k>>>16,u[f+11|0]=k>>>24,u[f+12|0]=t,u[f+13|0]=t>>>8,u[f+14|0]=t>>>16,u[f+15|0]=t>>>24,t=l[24160]|l[24161]<<8|(l[24162]<<16|l[24163]<<24),k=l[24156]|l[24157]<<8|(l[24158]<<16|l[24159]<<24),u[f|0]=k,u[f+1|0]=k>>>8,u[f+2|0]=k>>>16,u[f+3|0]=k>>>24,u[f+4|0]=t,u[f+5|0]=t>>>8,u[f+6|0]=t>>>16,u[f+7|0]=t>>>24,u[f+33|0]=0,f=q(o+24|0,2,0,o+12|0),t=i[f+4>>2],i[s>>2]=i[f>>2],i[s+4>>2]=t,t=s+8|0;e:{if(u[f+19|0]>=0){k=i[f+12>>2],i[t>>2]=i[f+8>>2],i[t+4>>2]=k,i[t+8>>2]=i[f+16>>2],u[s+20|0]=1;break e}if(T(t,i[f+8>>2],i[f+12>>2]),t=u[f+19|0],u[s+20|0]=1,(t|0)>=0)break e;Z(i[f+8>>2])}if(u[o+23|0]>=0)break i;Z(i[o+12>>2]);break i}k=i[f>>2],t=i[f+4>>2],t&&(i[t+4>>2]=i[t+4>>2]+1);e:{r:{if(!k||(k=W0(k,86580,105640),!k))break r;t&&(i[t+4>>2]=i[t+4>>2]+1);f:{A:{k:{if(f=i[k+36>>2],n=i[k+40>>2],(f|0)!=(n|0))for(;;){n:{if(k=i[f>>2],!k||(k=W0(k,86580,105720),!k))break n;if(f=i[f+4>>2],f&&(i[f+4>>2]=i[f+4>>2]+1),u[k+115|0]<0)break k;i[o+8>>2]=i[k+112>>2],n=i[k+108>>2],i[o>>2]=i[k+104>>2],i[o+4>>2]=n;break A}if(f=f+8|0,(n|0)==(f|0))break}f=p(40),i[o+12>>2]=f,i[o+16>>2]=38,i[o+20>>2]=-2147483608,k=l[22448]|l[22449]<<8|(l[22450]<<16|l[22451]<<24),n=l[22444]|l[22445]<<8|(l[22446]<<16|l[22447]<<24),u[f+30|0]=n,u[f+31|0]=n>>>8,u[f+32|0]=n>>>16,u[f+33|0]=n>>>24,u[f+34|0]=k,u[f+35|0]=k>>>8,u[f+36|0]=k>>>16,u[f+37|0]=k>>>24,k=l[22442]|l[22443]<<8|(l[22444]<<16|l[22445]<<24),n=l[22438]|l[22439]<<8|(l[22440]<<16|l[22441]<<24),u[f+24|0]=n,u[f+25|0]=n>>>8,u[f+26|0]=n>>>16,u[f+27|0]=n>>>24,u[f+28|0]=k,u[f+29|0]=k>>>8,u[f+30|0]=k>>>16,u[f+31|0]=k>>>24,k=l[22434]|l[22435]<<8|(l[22436]<<16|l[22437]<<24),n=l[22430]|l[22431]<<8|(l[22432]<<16|l[22433]<<24),u[f+16|0]=n,u[f+17|0]=n>>>8,u[f+18|0]=n>>>16,u[f+19|0]=n>>>24,u[f+20|0]=k,u[f+21|0]=k>>>8,u[f+22|0]=k>>>16,u[f+23|0]=k>>>24,k=l[22426]|l[22427]<<8|(l[22428]<<16|l[22429]<<24),n=l[22422]|l[22423]<<8|(l[22424]<<16|l[22425]<<24),u[f+8|0]=n,u[f+9|0]=n>>>8,u[f+10|0]=n>>>16,u[f+11|0]=n>>>24,u[f+12|0]=k,u[f+13|0]=k>>>8,u[f+14|0]=k>>>16,u[f+15|0]=k>>>24,k=l[22418]|l[22419]<<8|(l[22420]<<16|l[22421]<<24),n=l[22414]|l[22415]<<8|(l[22416]<<16|l[22417]<<24),u[f|0]=n,u[f+1|0]=n>>>8,u[f+2|0]=n>>>16,u[f+3|0]=n>>>24,u[f+4|0]=k,u[f+5|0]=k>>>8,u[f+6|0]=k>>>16,u[f+7|0]=k>>>24,u[f+38|0]=0,f=q(o+24|0,2,0,o+12|0),k=i[f+4>>2],i[s>>2]=i[f>>2],i[s+4>>2]=k,k=s+8|0;n:{if(u[f+19|0]>=0){n=i[f+12>>2],i[k>>2]=i[f+8>>2],i[k+4>>2]=n,i[k+8>>2]=i[f+16>>2],u[s+20|0]=1;break n}if(T(k,i[f+8>>2],i[f+12>>2]),k=u[f+19|0],u[s+20|0]=1,(k|0)>=0)break n;Z(i[f+8>>2])}if(u[o+23|0]>=0)break f;Z(i[o+12>>2]);break f}T(o,i[k+104>>2],i[k+108>>2])}if(k=i[o+4>>2],i[s>>2]=i[o>>2],i[s+4>>2]=k,i[s+8>>2]=i[o+8>>2],i[o+8>>2]=0,i[o>>2]=0,i[o+4>>2]=0,u[s+20|0]=0,!f||(s=i[f+4>>2],i[f+4>>2]=s-1,s))break f;W[i[i[f>>2]+8>>2]](f),y(f)}if(!t)break i;if(f=i[t+4>>2],i[t+4>>2]=f-1,f)break e;W[i[i[t>>2]+8>>2]](t),y(t);break e}f=p(40),i[o+12>>2]=f,i[o+16>>2]=39,i[o+20>>2]=-2147483608,k=l[22266]|l[22267]<<8|(l[22268]<<16|l[22269]<<24),n=l[22262]|l[22263]<<8|(l[22264]<<16|l[22265]<<24),u[f+31|0]=n,u[f+32|0]=n>>>8,u[f+33|0]=n>>>16,u[f+34|0]=n>>>24,u[f+35|0]=k,u[f+36|0]=k>>>8,u[f+37|0]=k>>>16,u[f+38|0]=k>>>24,k=l[22259]|l[22260]<<8|(l[22261]<<16|l[22262]<<24),n=l[22255]|l[22256]<<8|(l[22257]<<16|l[22258]<<24),u[f+24|0]=n,u[f+25|0]=n>>>8,u[f+26|0]=n>>>16,u[f+27|0]=n>>>24,u[f+28|0]=k,u[f+29|0]=k>>>8,u[f+30|0]=k>>>16,u[f+31|0]=k>>>24,k=l[22251]|l[22252]<<8|(l[22253]<<16|l[22254]<<24),n=l[22247]|l[22248]<<8|(l[22249]<<16|l[22250]<<24),u[f+16|0]=n,u[f+17|0]=n>>>8,u[f+18|0]=n>>>16,u[f+19|0]=n>>>24,u[f+20|0]=k,u[f+21|0]=k>>>8,u[f+22|0]=k>>>16,u[f+23|0]=k>>>24,k=l[22243]|l[22244]<<8|(l[22245]<<16|l[22246]<<24),n=l[22239]|l[22240]<<8|(l[22241]<<16|l[22242]<<24),u[f+8|0]=n,u[f+9|0]=n>>>8,u[f+10|0]=n>>>16,u[f+11|0]=n>>>24,u[f+12|0]=k,u[f+13|0]=k>>>8,u[f+14|0]=k>>>16,u[f+15|0]=k>>>24,k=l[22235]|l[22236]<<8|(l[22237]<<16|l[22238]<<24),n=l[22231]|l[22232]<<8|(l[22233]<<16|l[22234]<<24),u[f|0]=n,u[f+1|0]=n>>>8,u[f+2|0]=n>>>16,u[f+3|0]=n>>>24,u[f+4|0]=k,u[f+5|0]=k>>>8,u[f+6|0]=k>>>16,u[f+7|0]=k>>>24,u[f+39|0]=0,f=q(o+24|0,5,0,o+12|0),k=i[f+4>>2],i[s>>2]=i[f>>2],i[s+4>>2]=k,k=s+8|0;r:{if(u[f+19|0]>=0){n=i[f+12>>2],i[k>>2]=i[f+8>>2],i[k+4>>2]=n,i[k+8>>2]=i[f+16>>2],u[s+20|0]=1;break r}if(T(k,i[f+8>>2],i[f+12>>2]),k=u[f+19|0],u[s+20|0]=1,(k|0)>=0)break r;Z(i[f+8>>2])}if(u[o+23|0]<0&&Z(i[o+12>>2]),!t)break i}if(f=i[t+4>>2],i[t+4>>2]=f-1,f)break i;W[i[i[t>>2]+8>>2]](t),y(t)}v=o+48|0;i:{e:switch(l[w+36|0]){default:_2(),H();case 1:b0(A,w+16|0,i[e+8>>2]);break i;case 0:break e}e:{if(!r)break e;i[w+8>>2]=i[w+24>>2],i[w+24>>2]=0,e=i[w+20>>2],i[w>>2]=i[w+16>>2],i[w+4>>2]=e,i[w+16>>2]=0,i[w+20>>2]=0,t=u[w+11|0],s=(t|0)<0,f=s?i[w+4>>2]:t,k=p(f+1|0),o=k,e=f,h=i[w>>2],s=s?h:w;r:{f:{A:{k:{if((s^k)&3)break k;n=(f|0)!=0;n:{if(!(s&3)|!f)break n;for(;;){if(n=l[s|0],u[o|0]=n,!n)break r;if(o=o+1|0,e=e-1|0,n=(e|0)!=0,s=s+1|0,!(s&3))break n;if(!e)break}}if(!n)break f;if(!l[s|0])break r;if(e>>>0<4)break k;for(;;){if(n=i[s>>2],((16843008-n|n)&-2139062144)!=-2139062144)break A;if(i[o>>2]=n,o=o+4|0,s=s+4|0,e=e-4|0,!(e>>>0>3))break}}if(!e)break f}for(;;){if(n=l[s|0],u[o|0]=n,!n)break r;if(o=o+1|0,s=s+1|0,e=e-1|0,!e)break}}e=0}if(Ae(o,0,e),u[f+k|0]=0,i[r>>2]=k,(t|0)>=0)break e;Z(h)}e=i[24164],i[A>>2]=i[24163],i[A+4>>2]=e,i[A+8>>2]=i[24165]}A=l[w+36|0],(A|0)!=255&&(e=i[24193],i[w>>2]=i[24192],i[w+4>>2]=e,W[i[w+(A<<2)>>2]](w+47|0,w+16|0)),v=w+48|0}function BB(A,e,r,f,k,n,t,o){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,t=t|0,o=o|0;var s=0,w=0,h=0,_=0,B=0,m=0,X=0,Q=0,V=0,F=0,I=0,E=0,R=0,N=0,M=0,z=0,S=0,O=0,P=0,a=0,$=0,f0=0,A0=0,n0=0;h=v-112|0,v=h;i:{if(!(n&&r)){e=i[23570],i[A>>2]=i[23569],i[A+4>>2]=e,i[A+8>>2]=i[23571];break i}if(!(k&&f)){if(u[h+4|0]=0,u[h+15|0]=0,r=A,A=q(h+48|0,5,2006,h+4|0),b0(r,A,i[e>>2]),u[A+19|0]<0&&Z(i[A+8>>2]),u[h+15|0]>=0)break i;Z(i[h+4>>2]);break i}E=M6();e:{if(!t||(Sr(E,t),i[E+4>>2])||!S4(i[i[r>>2]>>2]))break e;w=i[i[r>>2]>>2],t=C[w+6>>1]|C[w+8>>1]<<16,w=C[w+10>>1]|C[w+12>>1]<<16,i[E+4>>2]=h+48,i[h+56>>2]=t>>>16,i[h+52>>2]=t&65535,u[h+48|0]=1,u[h+64|0]=w>>>16&1,i[h+60>>2]=w&65535}if(t=0,i[h+44>>2]=0,i[h+36>>2]=0,i[h+40>>2]=0,w=G(f,k),w)for(;r2(h+36|0,i[(t<<2)+r>>2]),t=t+1|0,(w|0)!=(t|0););i[h+28>>2]=0,i[h+32>>2]=0,R=i[e>>2],s=v-112|0,v=s,r=o8(i[i[h+36>>2]>>2],10),m=G(l8(i[i[h+36>>2]>>2],10),k),t=G(r,f),w=m|t,X=w>>>0>65535,r=X?12:8,_=p(r),i[s+88>>2]=_,B=r+_|0,i[s+96>>2]=B,r&&o0(_,0,r),i[s+92>>2]=B,u[_+3|0]=f-1,u[_+2|0]=k-1,u[_+1|0]=X,u[_|0]=0;e:{if(w>>>0>=65536){r=m<<24|(m&65280)<<8|(m>>>8&65280|m>>>24),u[_+8|0]=r,u[_+9|0]=r>>>8,u[_+10|0]=r>>>16,u[_+11|0]=r>>>24,B=t>>>24|0,r=t,w=r>>>16|0;break e}B=t>>>8|0,r=m,w=t}u[_+7|0]=r,u[_+5|0]=w,u[_+4|0]=B,u[_+6|0]=r>>>8,z=i[R+48>>2],V=i[R+52>>2],V&&(i[V+4>>2]=i[V+4>>2]+1),F=h+4|0,_=n,i[s+84>>2]=0,i[s+76>>2]=0,i[s+80>>2]=0,r=0,n=0;e:{r:{f:{A:{a=G(f,k);k:{if(a)for(S=F+8|0,X=i[25332],f0=i[25333],k=0;;){Oi(s+48|0,R,i[h+36>>2]+(k<<3)|0,_,E,1),P=l[s+68|0];n:{if(P){if((P|0)!=1)break A;f=i[s+52>>2],i[F>>2]=i[s+48>>2],i[F+4>>2]=f;t:{if(u[s+67|0]>=0){f=i[s+60>>2],i[S>>2]=i[s+56>>2],i[S+4>>2]=f,i[S+8>>2]=i[s+64>>2];break t}T(S,i[s+56>>2],i[s+60>>2])}u[F+20|0]=1,B=0;break n}B=i[s+52>>2],B&&(i[B+4>>2]=i[B+4>>2]+1),O=i[s+48>>2],s4(s+104|0,z,i[O+116>>2]),f=i[s+104>>2],u[f+164|0]=1,i[f+100>>2]=i[f+100>>2]&-2|1,f=i[s+108>>2];t:{if(!f||(w=i[f+4>>2],i[f+4>>2]=w-1,w))break t;W[i[i[f>>2]+8>>2]](f),y(f)}N=i[O+116>>2],f=i[s+80>>2],Q=i[s+84>>2];t:{if(f>>>0<Q>>>0){i[f>>2]=N,f=f+4|0;break t}if(M=i[s+76>>2],f=f-M|0,$=f>>2,w=$+1|0,w>>>0>=1073741824)break f;if(Q=Q-M|0,I=Q>>1,Q=Q>>>0>=2147483644?1073741823:w>>>0<I>>>0?I:w,Q){if(Q>>>0>=1073741824)break r;w=p(Q<<2)}else w=0;if(I=w+f|0,i[I>>2]=N,N=I-($<<2)|0,f&&x(N,M,f),i[s+84>>2]=w+(Q<<2),f=I+4|0,i[s+80>>2]=f,i[s+76>>2]=N,!M)break t;Z(M)}if(i[s+80>>2]=f,r)break n;f=i[O+104>>2],w=i[O+108>>2];t:{if((f|0)!=(w|0))for(;;){u:{if(r=i[f>>2],!r||(r=W0(r,86580,88852),!r))break u;if(f=i[f+4>>2],!f){f=0;break t}i[f+4>>2]=i[f+4>>2]+1;break t}if(f=f+8|0,(w|0)==(f|0))break}f=0,r=0}t:{if(!n||(w=i[n+4>>2],i[n+4>>2]=w-1,w))break t;W[i[i[n>>2]+8>>2]](n),y(n)}n=f}f=l[s+68|0],(f|0)!=255&&(i[s+104>>2]=X,i[s+108>>2]=f0,W[i[(s+104|0)+(f<<2)>>2]](s+103|0,s+48|0));n:{if(!B||(f=i[B+4>>2],i[B+4>>2]=f-1,f))break n;W[i[i[B>>2]+8>>2]](B),y(B)}if(P)break k;if(k=k+1|0,(a|0)==(k|0))break}w=aA(z,1735551332),k=p(496),i[k>>2]=101016,f=k,i[f+4>>2]=0,i[f+8>>2]=0,_=E4(f+16|0,R,w),i[_>>2]=101176,i[f+488>>2]=0,i[f+480>>2]=0,i[f+484>>2]=0,i[f+472>>2]=0,i[f+476>>2]=0,i[f+464>>2]=0,i[f+468>>2]=0,A0=f,n0=M6(),i[A0+488>>2]=n0,i[s+52>>2]=f,i[s+48>>2]=_,i[f+4>>2]=i[f+4>>2]+1,Mr(R,w,s+48|0),f=i[s+52>>2];n:{if(!f||(X=i[f+4>>2],i[f+4>>2]=X-1,X))break n;W[i[i[f>>2]+8>>2]](f),y(f)}if(q8(z,w,s+88|0,1),a4(z,w,1684630887,s+76|0),w=p(128),i[w>>2]=90124,i[w+4>>2]=0,i[w+8>>2]=0,X=w+16|0,f=X,i[f+8>>2]=0,i[f+12>>2]=0,f=w,i[f+32>>2]=0,i[f+36>>2]=0,i[f+40>>2]=0,i[f+44>>2]=0,i[f+48>>2]=0,i[f+16>>2]=86356,i[f+60>>2]=0,i[f+64>>2]=0,i[f+52>>2]=0,i[f+56>>2]=0,i[f+72>>2]=-1,i[f+76>>2]=-1,i[f+80>>2]=-1,i[f+84>>2]=-1,i[f+116>>2]=0,i[f+88>>2]=0,i[f+92>>2]=0,i[f+96>>2]=0,i[f+100>>2]=0,i[f+104>>2]=0,i[f+108>>2]=0,g[f+112>>1]=0,i[f+16>>2]=87604,i[f+124>>2]=m,i[f+120>>2]=t,i[f+32>>2]=1769173093,i[s+44>>2]=f,i[s+40>>2]=X,i[f+4>>2]=i[f+4>>2]+1,f=i[s+44>>2],i[s+16>>2]=i[s+40>>2],i[s+20>>2]=f,M4(_,s+16|0,0),i[s+36>>2]=n,i[s+32>>2]=r,n&&(i[n+4>>2]=i[n+4>>2]+1),r=i[s+36>>2],i[s+8>>2]=i[s+32>>2],i[s+12>>2]=r,M4(_,s+8|0,1),Gf(s+48|0,i[i[h+36>>2]>>2],1),f=i[s+48>>2],t=i[s+52>>2],(f|0)!=(t|0)){for(;i[s+24>>2]=i[f>>2],r=i[f+4>>2],i[s+28>>2]=r,r&&(i[r+4>>2]=i[r+4>>2]+1),m=i[f>>2],r=i[m+16>>2]==1769173093,m=r?_:m,r=W[i[i[m>>2]+(r?48:40)>>2]](m)|0,m=i[s+28>>2],i[s>>2]=i[s+24>>2],i[s+4>>2]=m,M4(_,s,r),f=f+8|0,(t|0)!=(f|0););f=i[s+48>>2]}if(u[F+20|0]=0,i[F+4>>2]=k,i[F>>2]=_,f){if(k=f,B=i[s+52>>2],(B|0)!=(f|0)){for(;;){r=i[B-4>>2];n:{if(!r||(k=i[r+4>>2],i[r+4>>2]=k-1,k))break n;W[i[i[r>>2]+8>>2]](r),y(r)}if(B=B-8|0,(B|0)==(f|0))break}k=i[s+48>>2]}i[s+52>>2]=f,Z(k)}if(r=i[w+4>>2],i[w+4>>2]=r-1,r)break k;W[i[i[w>>2]+8>>2]](w),y(w)}k:{if(!n||(r=i[n+4>>2],i[n+4>>2]=r-1,r))break k;W[i[i[n>>2]+8>>2]](n),y(n)}r=i[s+76>>2],r&&(i[s+80>>2]=r,Z(r));k:{if(!V||(r=i[V+4>>2],i[V+4>>2]=r-1,r))break k;W[i[i[V>>2]+8>>2]](V),y(V)}r=i[s+88>>2],r&&(i[s+92>>2]=r,Z(r)),v=s+112|0;break e}_2(),H()}G0(),H()}z0(),H()}x2(E);e:{r:switch(l[h+24|0]){default:_2(),H();case 1:b0(A,h+4|0,i[e>>2]);break e;case 0:break r}f=i[h+4>>2],r=i[h+8>>2],r&&(i[r+4>>2]=i[r+4>>2]+1),i[h+32>>2]=r,i[h+28>>2]=f,r=i[e>>2],i[r+40>>2]||zf(r,h+28|0);r:{if(!o)break r;if(r=p(16),i[r+8>>2]=0,i[r+12>>2]=0,i[o>>2]=r,f=i[h+28>>2],k=i[h+32>>2],i[h+28>>2]=0,i[h+32>>2]=0,i[r>>2]=f,i[r+4>>2]=k,k=i[e>>2],f=i[e+4>>2],!f){i[r+12>>2]=f,i[r+8>>2]=k;break r}if(i[f+4>>2]=i[f+4>>2]+1,i[r+8>>2]=k,e=i[r+12>>2],i[r+12>>2]=f,!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break r;W[i[i[e>>2]+8>>2]](e),y(e)}e=i[24057],i[A>>2]=i[24056],i[A+4>>2]=e,i[A+8>>2]=i[24058]}A=l[h+24|0],(A|0)!=255&&(e=i[24237],i[h+104>>2]=i[24236],i[h+108>>2]=e,W[i[(h+104|0)+(A<<2)>>2]](h+103|0,h+4|0)),A=i[h+32>>2];e:{if(!A||(e=i[A+4>>2],i[A+4>>2]=e-1,e))break e;W[i[i[A>>2]+8>>2]](A),y(A)}if(A=i[h+36>>2],!A)break i;if(r=A,t=i[h+40>>2],(r|0)!=(t|0)){for(;;){e=i[t-4>>2];e:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break e;W[i[i[e>>2]+8>>2]](e),y(e)}if(t=t-8|0,(A|0)==(t|0))break}r=i[h+36>>2]}i[h+40>>2]=A,Z(r)}v=h+112|0}function O7(A,e,r,f,k){var n=0,t=0,o=0,s=0,w=0,h=0,_=0,B=0,m=0,X=0,Q=0,V=0,F=0,I=0,E=0,R=0,N=0,M=0,z=0,S=0,O=0,P=0;if(h=v-128|0,v=h,e){i:{for(;;){e:{r:{f:{A:{w=l[r|0];k:{if((w|0)!=37){if(w)break k;n=_;break i}t=0,o=1;n:switch(n=l[r+1|0],n-45|0){case 0:case 3:break A;case 1:case 2:break f;default:break n}if((n|0)==95)break A;if(n)break f}u[A+_|0]=w,_=_+1|0;break r}t=n,n=l[r+2|0],o=2}I=0,z=n,w=(r+o|0)+((n|0)==43)|0;f:{if(u[w|0]-48>>>0<=9){r=b6(w,h+12|0,10,-1,0),o=i[h+12>>2];break f}i[h+12>>2]=w,r=0,o=w}n=l[o|0],s=n-67|0;f:{if(s>>>0>22|!(1<<s&4194329)||(I=r,r))break f;I=(o|0)!=(w|0)}(n|0)==79|(n|0)==69?(n=l[o+1|0],r=o+1|0):r=o,w=h+16|0,N=t,t=0,m=v-80|0,v=m,B=1757,M=48,X=131112;f:{A:{k:{n:{t:{u:{o:{l:{s:{w:{_:{h:{B:{v:{Z:{G:{m:{X:{W:{F:{V:{C:{g:{I:{y:{U:{D:{M:{J:{p:{E:{$:{Y:{H:{z:{x:{T:{R:{S:{j:{O:{P:{L:{K:{q:{_0:switch(Q=n<<24>>24,Q-37|0){case 0:break B;case 28:break q;case 29:break L;case 30:break P;case 31:break o;case 33:break S;case 34:case 66:break R;case 35:break T;case 36:break x;case 40:break Y;case 45:break p;case 46:break M;case 47:break U;case 48:break I;case 49:break C;case 50:break g;case 51:break X;case 52:break G;case 53:break v;case 60:break _0;case 61:case 67:break K;case 62:break l;case 63:break j;case 64:break O;case 69:break z;case 72:break H;case 73:break $;case 75:break E;case 77:break s;case 78:break J;case 79:break D;case 80:break y;case 82:break V;case 83:break W;case 84:break m;case 85:break Z;default:break f}if(n=i[f+24>>2],n>>>0<=6)break _;break k}if(n=i[f+24>>2],n>>>0>6)break k;t=n+131079|0;break w}if(n=i[f+16>>2],n>>>0>11)break k;t=n+131086|0;break w}if(n=i[f+16>>2],n>>>0>11)break k;t=n+131098|0;break w}n=i[f+20>>2],t=n>>31,n=n+1900|0,t=n>>>0<1900?t+1|0:t,n=G2(n,t,100,0),o=l0;break u}M=95}n=i[f+12>>2],o=n>>31;break u}B=17891;break o}s=i[f+20>>2],t=s>>31,n=s+1900|0,o=n>>>0<1900?t+1|0:t,X=i[f+28>>2];R:{if((X|0)<=2){s=s+1899|0,t=s>>>0<1899?t+1|0:t,V=s,s=(mA(f)|0)==1,n=s?n:V,o=s?o:t;break R}if(X>>>0<361)break R;s=s+1901|0,t=s>>>0<1901?t+1|0:t,V=s,s=(mA(f)|0)==1,n=s?V:n,o=s?t:o}if((Q|0)==103)break h;break t}n=i[f+8>>2],o=n>>31;break u}if(t=2,o=i[f+8>>2],!o){n=12,o=0;break n}Q=(o|0)>12,n=Q?o-12|0:o,s=o>>31,o=Q?s-(o>>>0<12)|0:s;break n}n=i[f+28>>2]+1|0,o=n>>31,t=3;break n}n=i[f+16>>2]+1|0,o=n>>31;break u}n=i[f+4>>2],o=n>>31;break u}i[h+124>>2]=1,t=42670;break f}t=i[f+8>>2]>11?131111:131110;break w}B=19435;break o}X=0,E=0,R=v-16|0,v=R,n=i[f+20>>2],o=n>>31,B=i[f+16>>2],B>>>0>=12&&(s=(B|0)/12|0,t=B-G(s,12)|0,B=(t|0)<0?t+12|0:t,t=s+(t>>31)|0,o=o+(t>>31)|0,s=n,n=n+t|0,o=s>>>0>n>>>0?o+1|0:o),s=R+12|0;J:{if((n>>>0<2|0)==(o|0)&n-2>>>0<=136){t=n-68>>2;p:{E:{if(!(n&3)){if(t=t-1|0,!s)break p;o=1;break E}if(!s)break p;o=0}i[s>>2]=o}n=(G(n,31536e3)+G(t,86400)|0)+2087447296|0,t=n>>31;break J}t=n-100|0,Q=t,n=o-(n>>>0<100)|0,V=n,n=G2(t,n,400,0),F=O0(n,l0,400,0),o=t-F|0,t=V-(l0+(t>>>0<F>>>0)|0)|0,F=n+(t>>31)|0;p:{E:{$:{if(n=(t|0)<0?o+400|0:o,n){Y:{if((n|0)>=200){if(n>>>0>=300){X=3,n=n-300|0;break Y}X=2,n=n-200|0;break Y}X=(n|0)>99,n=X?n-100|0:n}if(n)break $;t=0}else t=1;if(s)break E;break p}if(E=n>>>2|0,t=!(n&3),!s)break p}i[s>>2]=t}o=O0(Q,V,31536e3,0),s=l0,Q=o,n=((G(X,24)+G(F,97)|0)+E|0)-t|0,o=O0(n,n>>31,86400,0),n=Q+o|0,t=l0+s|0,t=n>>>0<o>>>0?t+1|0:t,n=n+946771200|0,t=n>>>0<946771200?t+1|0:t}E=i[f+12>>2],s=i[f+8>>2],V=s>>31,Q=i[f+4>>2],F=Q>>31,v=R+16|0,o=i[f>>2],X=o,S=o>>31,o=i[(B<<2)+74240>>2],B=(B|0)>1&&i[R+12>>2]?o+86400|0:o,o=(B>>31)+t|0,t=n+B|0,o=t>>>0<B>>>0?o+1|0:o,n=E-1|0,B=O0(n,n>>31,86400,0),n=B+t|0,t=l0+o|0,t=n>>>0<B>>>0?t+1|0:t,o=O0(s,V,3600,0),n=o+n|0,t=l0+t|0,t=n>>>0<o>>>0?t+1|0:t,o=O0(Q,F,60,0),n=o+n|0,t=l0+t|0,o=(n>>>0<o>>>0?t+1|0:t)+S|0,t=n+X|0,o=t>>>0<n>>>0?o+1|0:o,s=i[f+36>>2],n=t-s|0,o=o-((s>>31)+(t>>>0<s>>>0)|0)|0;break F}n=i[f>>2],o=n>>31;break u}i[h+124>>2]=1,t=42672;break f}B=19376;break o}n=i[f+24>>2],n=n||7,o=n>>31;break F}n=((i[f+28>>2]-i[f+24>>2]|0)+7>>>0)/7|0,o=0;break u}n=((i[f+28>>2]-((i[f+24>>2]+6>>>0)%7|0)|0)+7>>>0)/7|0,o=0;break u}n=mA(f),o=0;break u}n=i[f+24>>2],o=n>>31}t=1;break n}X=131113;break l}X=131114;break l}n=i[f+20>>2],t=n>>31,n=n+1900|0,t=n>>>0<1900?t+1|0:t,t=tl(n,t),n=l0,Q=n,o=t,t=n>>31,s=o^t,n=s-t|0,o=(t^Q)-((t>>>0>s>>>0)+t|0)|0;break u}if(n=i[f+20>>2],o=n>>31,s=n,t=o,n=n+1900|0,o=n>>>0<1900?t+1|0:t,s>>>0<8100&(t|0)<=0|(t|0)<0)break t;i[m+48>>2]=n,i[m+52>>2]=o,O=h,P=a8(w,100,15862,m+48|0),i[O+124>>2]=P,t=w;break f}if(i[f+32>>2]<0){i[h+124>>2]=0,t=42673;break f}n=i[f+36>>2],t=(n|0)/3600|0,i[m+64>>2]=G(t,100)+((n-G(t,3600)<<16>>16)/60<<16>>16),O=h,P=a8(w,100,15868,m- -64|0),i[O+124>>2]=P,t=w;break f}if(i[f+32>>2]<0){i[h+124>>2]=0,t=42673;break f}t=i[f+40>>2],u[129268]&1||(F_(129224,129228,129280,129312),i[32309]=129312,i[32308]=129280,u[129268]=1);break A}i[h+124>>2]=1,t=27421;break f}n=tl(n,o),o=l0;break u}t=n|131072}t=vu(t,k);break A}X=131115}B=vu(X,k)}n=O7(w,100,B,f,k),i[h+124>>2]=n,t=n?w:0;break f}t=2;break n}t=4}n:{if(s=N||M,(s|0)!=95){if((s|0)!=45)break n;i[m+16>>2]=n,i[m+20>>2]=o,O=h,P=a8(w,100,15863,m+16|0),i[O+124>>2]=P,t=w;break f}i[m+40>>2]=n,i[m+44>>2]=o,i[m+32>>2]=t,O=h,P=a8(w,100,15856,m+32|0),i[O+124>>2]=P,t=w;break f}i[m+8>>2]=n,i[m+12>>2]=o,i[m>>2]=t,O=h,P=a8(w,100,15849,m),i[O+124>>2]=P,t=w;break f}t=26297}O=h,P=h2(t),i[O+124>>2]=P}if(v=m+80|0,!t)break e;f:{if(!I){o=i[h+124>>2];break f}A:{k:{n:switch(n=l[t|0],n-43|0){case 0:case 2:break k;default:break n}o=i[h+124>>2];break A}n=l[t+1|0],t=t+1|0,o=i[h+124>>2]-1|0}A:{if((n&255)!=48)break A;for(;;){if(n=u[t+1|0],n-48>>>0>9)break A;if(t=t+1|0,o=o-1|0,(n|0)!=48)break}}for(i[h+124>>2]=o,n=0;w=n,n=n+1|0,u[t+w|0]-48>>>0<10;);n=o>>>0<I>>>0?I:o,s=A+_|0;A:{if(i[f+20>>2]<-1900)w=45;else{if((z|0)!=43|w+(n-o|0)>>>0<(l[i[h+12>>2]]==67?3:5)>>>0)break A;w=43}u[s|0]=w,n=n-1|0,_=_+1|0}if(n>>>0<=o>>>0|e>>>0<=_>>>0)break f;for(;;){if(u[A+_|0]=48,_=_+1|0,n=n-1|0,o>>>0>=n>>>0)break f;if(!(e>>>0>_>>>0))break}}n=e-_|0,n=n>>>0>o>>>0?o:n,i[h+124>>2]=n,A8(A+_|0,t,n),_=i[h+124>>2]+_|0}if(r=r+1|0,e>>>0>_>>>0)continue}break}_=(e|0)==(_|0)?e-1|0:_,n=0}u[A+_|0]=0}return v=h+128|0,n}function vB(A,e,r,f,k,n){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0;var t=0,o=0,s=0,w=0,h=0,_=0;if(k=v-80|0,v=k,i[k+40>>2]=0,i[k+44>>2]=0,i[k+48>>2]=0,i[k+52>>2]=0,u[k+55|0]=0,u[k+56|0]=0,u[k+57|0]=0,u[k+58|0]=0,i[k+32>>2]=0,i[k+36>>2]=0,i[k+60>>2]=0,i[k+64>>2]=0,i[k+72>>2]=0,u[k+68|0]=1,w=i[r>>2],e=i[r+4>>2],e&&(i[e+4>>2]=i[e+4>>2]+1),i[k+28>>2]=e,i[k+24>>2]=w,e=k+12|0,W[i[i[f>>2]+100>>2]](e,i[f+4>>2],k+24|0,n),W[i[i[f>>2]+104>>2]](e,i[f+4>>2],k+8|0,k+4|0,0),e=i[k+8>>2],e)for(;Ue(k+32|0,e,i[k+4>>2]),W[i[i[f>>2]+104>>2]](k+12|0,i[f+4>>2],k+8|0,k+4|0,0),e=i[k+8>>2],!!e;);w=p(120),i[w>>2]=91844,i[w+4>>2]=0,i[w+8>>2]=0,h=w+16|0,e=h,i[e+8>>2]=0,i[e+12>>2]=0,e=w,i[e+32>>2]=0,i[e+36>>2]=0,i[e+40>>2]=0,i[e+44>>2]=0,i[e+48>>2]=0,i[e+16>>2]=86356,i[e+60>>2]=0,i[e+64>>2]=0,i[e+52>>2]=0,i[e+56>>2]=0,i[e+72>>2]=-1,i[e+76>>2]=-1,i[e+80>>2]=-1,i[e+84>>2]=-1,i[e+88>>2]=0,i[e+92>>2]=0,i[e+96>>2]=0,i[e+100>>2]=0,i[e+104>>2]=0,i[e+108>>2]=0,u[e+112|0]=0,i[e+16>>2]=99416,i[e+32>>2]=1781689160,t=p(128),i[t>>2]=91884,i[t+4>>2]=0,i[t+8>>2]=0,_=t+16|0,e=_,i[e+8>>2]=0,i[e+12>>2]=0,i[t+32>>2]=0,i[t+36>>2]=0,i[t+40>>2]=0,i[t+44>>2]=0,i[t+48>>2]=0,i[t+16>>2]=86356,i[t+60>>2]=0,i[t+64>>2]=0,i[t+52>>2]=0,i[t+56>>2]=0,i[t+72>>2]=-1,i[t+76>>2]=-1,i[t+80>>2]=-1,i[t+84>>2]=-1,i[t+88>>2]=0,i[t+92>>2]=0,i[t+96>>2]=0,i[t+100>>2]=0,i[t+104>>2]=0,i[t+108>>2]=0,u[t+112|0]=0,i[t+16>>2]=99096,i[t+124>>2]=0,i[t+116>>2]=0,i[t+120>>2]=0,i[t+32>>2]=1667523942;i:{e:{r:{f:{A:{k:{n:{t:switch(i[i[r>>2]+116>>2]){case 1:f=i[t+124>>2],e=i[t+120>>2];u:{if(f>>>0>e>>>0){g[e+4>>1]=1,g[e>>1]=0,g[e+2>>1]=0,r=e+6|0;break u}if(r=e,e=i[t+116>>2],n=r-e|0,o=((n|0)/6|0)+1|0,o>>>0>=715827883)break n;if(r=0,f=(f-e|0)/6|0,s=f<<1,f=f>>>0>=357913941?715827882:o>>>0<s>>>0?s:o,f){if(f>>>0>=715827883)break k;r=p(G(f,6))}if(o=r+n|0,g[o+4>>1]=1,g[o>>1]=0,g[o+2>>1]=0,s=o+G((n|0)/-6|0,6)|0,n&&x(s,e,n),f=G(f,6)+r|0,i[t+124>>2]=f,r=o+6|0,i[t+120>>2]=r,i[t+116>>2]=s,!e)break u;Z(e),f=i[t+124>>2]}i[t+120>>2]=r;u:{if(r>>>0<f>>>0){g[r+4>>1]=2,g[r>>1]=1,g[r+2>>1]=0,r=r+6|0;break u}if(n=i[t+116>>2],e=r-n|0,r=((e|0)/6|0)+1|0,r>>>0>=715827883)break n;if(f=(f-n|0)/6|0,o=f<<1,f=f>>>0>=357913941?715827882:r>>>0<o>>>0?o:r,f){if(f>>>0>=715827883)break k;r=p(G(f,6))}else r=0;if(o=r+e|0,g[o+4>>1]=2,g[o>>1]=1,g[o+2>>1]=0,s=o+G((e|0)/-6|0,6)|0,e&&x(s,n,e),f=r+G(f,6)|0,i[t+124>>2]=f,r=o+6|0,i[t+120>>2]=r,i[t+116>>2]=s,!n)break u;Z(n),f=i[t+124>>2]}if(i[t+120>>2]=r,r>>>0<f>>>0)break r;if(e=r,r=i[t+116>>2],e=e-r|0,n=((e|0)/6|0)+1|0,n>>>0>=715827883)break n;if(f=(f-r|0)/6|0,o=f<<1,n=f>>>0>=357913941?715827882:n>>>0<o>>>0?o:n,n){if(n>>>0>=715827883)break k;f=p(G(n,6))}else f=0;o=e+f|0,g[o+4>>1]=3;break e;case 0:f=i[t+124>>2],e=i[t+120>>2];u:{if(f>>>0>e>>>0){g[e+4>>1]=1,g[e>>1]=0,g[e+2>>1]=0,r=e+6|0;break u}if(r=e,e=i[t+116>>2],n=r-e|0,o=((n|0)/6|0)+1|0,o>>>0>=715827883)break A;if(r=0,f=(f-e|0)/6|0,s=f<<1,f=f>>>0>=357913941?715827882:o>>>0<s>>>0?s:o,f){if(f>>>0>=715827883)break k;r=p(G(f,6))}if(o=r+n|0,g[o+4>>1]=1,g[o>>1]=0,g[o+2>>1]=0,s=o+G((n|0)/-6|0,6)|0,n&&x(s,e,n),f=G(f,6)+r|0,i[t+124>>2]=f,r=o+6|0,i[t+120>>2]=r,i[t+116>>2]=s,!e)break u;Z(e),f=i[t+124>>2]}i[t+120>>2]=r;u:{if(r>>>0<f>>>0){g[r+4>>1]=2,g[r>>1]=1,g[r+2>>1]=0,r=r+6|0;break u}if(n=i[t+116>>2],e=r-n|0,r=((e|0)/6|0)+1|0,r>>>0>=715827883)break A;if(f=(f-n|0)/6|0,o=f<<1,f=f>>>0>=357913941?715827882:r>>>0<o>>>0?o:r,f){if(f>>>0>=715827883)break k;r=p(G(f,6))}else r=0;if(o=r+e|0,g[o+4>>1]=2,g[o>>1]=1,g[o+2>>1]=0,s=o+G((e|0)/-6|0,6)|0,e&&x(s,n,e),f=r+G(f,6)|0,i[t+124>>2]=f,r=o+6|0,i[t+120>>2]=r,i[t+116>>2]=s,!n)break u;Z(n),f=i[t+124>>2]}if(i[t+120>>2]=r,r>>>0<f>>>0)break r;if(e=r,r=i[t+116>>2],e=e-r|0,n=((e|0)/6|0)+1|0,n>>>0>=715827883)break A;if(f=(f-r|0)/6|0,o=f<<1,n=f>>>0>=357913941?715827882:n>>>0<o>>>0?o:n,n){if(n>>>0>=715827883)break k;f=p(G(n,6))}else f=0;o=e+f|0,g[o+4>>1]=3;break e;case 2:break t;default:break i}e=i[t+120>>2],o=i[t+124>>2];t:{if(e>>>0<o>>>0){g[e+4>>1]=1,g[e>>1]=0,g[e+2>>1]=0,f=e+6|0;break t}if(r=e,e=i[t+116>>2],r=r-e|0,f=((r|0)/6|0)+1|0,f>>>0>=715827883)break f;if(n=0,o=(o-e|0)/6|0,s=o<<1,o=o>>>0>=357913941?715827882:f>>>0<s>>>0?s:f,o){if(o>>>0>=715827883)break k;n=p(G(o,6))}if(f=r+n|0,g[f+4>>1]=1,g[f>>1]=0,g[f+2>>1]=0,s=f+G((r|0)/-6|0,6)|0,r&&x(s,e,r),i[t+124>>2]=G(o,6)+n,f=f+6|0,i[t+120>>2]=f,i[t+116>>2]=s,!e)break t;Z(e)}i[t+120>>2]=f;break i}G0(),H()}z0(),H()}G0(),H()}G0(),H()}g[r+4>>1]=3,g[r>>1]=2,g[r+2>>1]=0,i[t+120>>2]=r+6;break i}g[o>>1]=2,g[o+2>>1]=0,s=G((e|0)/-6|0,6)+o|0,e&&x(s,r,e),i[t+124>>2]=G(n,6)+f,e=o+6|0,i[t+120>>2]=e,i[t+116>>2]=s,r&&Z(r),i[t+120>>2]=e}i[k+16>>2]=t,i[k+12>>2]=_,i[t+4>>2]=i[t+4>>2]+1,r2(w+52|0,k+12|0),e=i[k+16>>2];i:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break i;W[i[i[e>>2]+8>>2]](e),y(e)}i[w+4>>2]=i[w+4>>2]+1;i:{e:{r=i[k+40>>2],e=i[k+36>>2];r:{if(r>>>0>e>>>0){i[e+4>>2]=w,i[e>>2]=h,n=e+8|0;break r}if(f=i[k+32>>2],n=e-f|0,s=n>>3,e=s+1|0,e>>>0>=536870912)break e;if(r=r-f|0,o=r>>2,r=r>>>0>=2147483640?536870911:e>>>0<o>>>0?o:e,r){if(r>>>0>=536870912)break i;e=p(r<<3)}else e=0;if(o=e+n|0,i[o+4>>2]=w,i[o>>2]=h,h=o-(s<<3)|0,n&&x(h,f,n),r=e+(r<<3)|0,i[k+40>>2]=r,n=o+8|0,i[k+36>>2]=n,i[k+32>>2]=h,!f)break r;Z(f),r=i[k+40>>2]}u[k+58|0]=0,g[k+56>>1]=1,e=i[k+32>>2],i[k+32>>2]=0,i[k+36>>2]=0,i[k+40>>2]=0,f=i[k+52>>2],i[k+52>>2]=0,o=i[k+44>>2],h=i[k+48>>2],i[k+44>>2]=0,i[k+48>>2]=0,i[A+20>>2]=f,i[A+12>>2]=o,i[A+16>>2]=h,i[A+8>>2]=r,i[A+4>>2]=n,i[A>>2]=e,e=i[k+60>>2],i[A+24>>2]=i[k+56>>2],i[A+28>>2]=e,e=k- -64|0,r=i[e+4>>2],i[A+32>>2]=i[e>>2],i[A+36>>2]=r,i[A+40>>2]=i[k+72>>2],u[A+44|0]=0,A=i[t+4>>2],i[t+4>>2]=A-1,A||(W[i[i[t>>2]+8>>2]](t),y(t)),A=i[w+4>>2],i[w+4>>2]=A-1,A||(W[i[i[w>>2]+8>>2]](w),y(w)),A=i[k+28>>2];r:{if(!A||(e=i[A+4>>2],i[A+4>>2]=e-1,e))break r;W[i[i[A>>2]+8>>2]](A),y(A)}if(A=i[k+44>>2],A&&(i[k+48>>2]=A,Z(A)),A=i[k+32>>2],A){if(e=A,f=i[k+36>>2],(e|0)!=(f|0)){for(;;){e=i[f-4>>2];r:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break r;W[i[i[e>>2]+8>>2]](e),y(e)}if(f=f-8|0,(A|0)==(f|0))break}e=i[k+32>>2]}i[k+36>>2]=A,Z(e)}v=k+80|0;return}G0(),H()}z0(),H()}function mB(A,e,r,f,k,n,t,o){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,t=t|0,o=o|0;var s=0,w=0,h=0,_=0,B=0,m=0,X=0,Q=0,V=0,F=0,I=0,E=0,R=0,N=0,M=0,z=0,S=0,O=0,P=0,a=0,$=0,f0=0,A0=0,n0=0,_0=0,m0=0,X0=0,g0=0,I0=0,e0=0,r0=0,N0=0;s=v-128|0,v=s,k=j0(i[r>>2],0),n=j0(i[r>>2],1),t=j0(i[r>>2],2),O=u1(i[r>>2],6),O&&(f0=j0(i[r>>2],6));i:{if(!(!(k>>>0<9|n>>>0<9)&t>>>0>8)){e=i[26922],i[A>>2]=i[26921],i[A+4>>2]=e,e=A+8|0;e:{if(u[107703]>=0){r=i[26924],i[e>>2]=i[26923],i[e+4>>2]=r,i[e+8>>2]=i[26925];break e}T(e,i[26923],i[26924])}u[A+20|0]=1;break i}if(!((k|0)==(n|0)&(k|0)==(t|0))){e=i[26922],i[A>>2]=i[26921],i[A+4>>2]=e,e=A+8|0;e:{if(u[107703]>=0){r=i[26924],i[e>>2]=i[26923],i[e+4>>2]=r,i[e+8>>2]=i[26925];break e}T(e,i[26923],i[26924])}u[A+20|0]=1;break i}e=i[r>>2],X=i[e+112>>2],Q=i[e+108>>2],I=p(172),i[I>>2]=94812,e=I,i[e+4>>2]=0,i[e+8>>2]=0,o0(e+16|0,0,80),_=i[e+4>>2],B=_+1|0,i[e+4>>2]=B,i[e+104>>2]=0,i[e+108>>2]=0,i[e+36>>2]=1,i[e+40>>2]=1,u[e+24|0]=1,g[e+22>>1]=2,g[e+18>>1]=2,g[e+20>>1]=2,i[e+112>>2]=0,i[e+116>>2]=4740,i[e+140>>2]=0,i[e+144>>2]=0,i[e+128>>2]=99,i[e+132>>2]=99,i[e+120>>2]=0,i[e+124>>2]=0,i[e+12>>2]=95160,i[e+148>>2]=0,i[e+152>>2]=0,f=e+140|0,i[e+136>>2]=f,i[e+156>>2]=0,i[e+160>>2]=0,i[e+164>>2]=0,i[e+168>>2]=0,i[e+4>>2]=_,_=i[e+8>>2],V=e+12|0,i[e+96>>2]=V,i[e+8>>2]=_+1,i[e+100>>2]=e,B||(W[i[i[e>>2]+8>>2]](e),y(e)),i[V+120>>2]=1,i[V+116>>2]=0,i[V+112>>2]=X,i[V+108>>2]=Q,T0(s+56|0,V,0,Q,X,k,o),w=Q+1>>>1|0,R=X+1>>>1|0,T0(s+32|0,V,1,w,R,n,o),e=s+88|0;e:{if(i[s+56>>2]){if(k=i[s+60>>2],i[s+80>>2]=i[s+56>>2],i[s+84>>2]=k,u[s+75|0]>=0){k=s- -64|0,n=i[k+4>>2],i[e>>2]=i[k>>2],i[e+4>>2]=n,i[e+8>>2]=i[k+8>>2];break e}T(e,i[s+64>>2],i[s+68>>2]);break e}if(k=i[s+36>>2],i[s+80>>2]=i[s+32>>2],i[s+84>>2]=k,u[s+51|0]>=0){k=i[s+44>>2],i[e>>2]=i[s+40>>2],i[e+4>>2]=k,i[e+8>>2]=i[s+48>>2];break e}T(e,i[s+40>>2],i[s+44>>2])}T0(s+8|0,V,2,w,R,t,o),k=s+112|0;e:{if(i[s+80>>2]){if(n=i[s+84>>2],i[s+104>>2]=i[s+80>>2],i[s+108>>2]=n,u[s+99|0]>=0){n=i[e+4>>2],i[k>>2]=i[e>>2],i[k+4>>2]=n,i[k+8>>2]=i[e+8>>2];break e}T(k,i[s+88>>2],i[s+92>>2]);break e}if(e=i[s+12>>2],i[s+104>>2]=i[s+8>>2],i[s+108>>2]=e,u[s+27|0]>=0){e=i[s+20>>2],i[k>>2]=i[s+16>>2],i[k+4>>2]=e,i[k+8>>2]=i[s+24>>2];break e}T(k,i[s+16>>2],i[s+20>>2])}u[s+27|0]<0&&Z(i[s+16>>2]),u[s+99|0]<0&&Z(i[s+88>>2]),u[s+51|0]<0&&Z(i[s+40>>2]),u[s+75|0]<0&&Z(i[s+64>>2]);e:{if(i[s+104>>2]){if(e=i[s+108>>2],i[A>>2]=i[s+104>>2],i[A+4>>2]=e,e=A+8|0,u[s+123|0]>=0){r=i[k+4>>2],i[e>>2]=i[k>>2],i[e+4>>2]=r,i[e+8>>2]=i[k+8>>2],u[A+20|0]=1;break e}if(T(e,i[s+112>>2],i[s+116>>2]),e=u[s+123|0],u[A+20|0]=1,(e|0)>=0)break e;Z(i[s+112>>2]);break e}u[s+123|0]<0&&Z(i[s+112>>2]);r:{if(!O)break r;if(T0(s+104|0,V,6,Q,X,f0,o),i[s+104>>2]){if(e=i[s+108>>2],i[A>>2]=i[s+104>>2],i[A+4>>2]=e,e=A+8|0,u[s+123|0]>=0){r=i[s+116>>2],i[e>>2]=i[s+112>>2],i[e+4>>2]=r,i[e+8>>2]=i[s+120>>2],u[A+20|0]=1;break e}if(T(e,i[s+112>>2],i[s+116>>2]),e=u[s+123|0],u[A+20|0]=1,(e|0)>=0)break e;Z(i[s+112>>2]);break e}if(u[s+123|0]>=0)break r;Z(i[s+112>>2])}e=i[r>>2],k=e+128|0;r:{f:{t=i[e+128>>2];A:{if(!t){o=0;break A}for(e=k,r=t;n=i[r+16>>2],e=(n|0)<0?e:r,r=i[(n>>>29&4)+r>>2],!!r;);r=0;k:{if((e|0)==(k|0)||(r=0,i[e+16>>2]>0))break k;n0=i[e+44>>2],r=i[e+56>>2]}for(_0=r,e=k,r=t;n=i[r+16>>2]<=0,e=n?e:r,r=i[(n?4:0)+r>>2],!!r;);o=0;k:{if((e|0)==(k|0)||(o=0,i[e+16>>2]>1))break k;m=i[e+56>>2],o=i[e+44>>2]}for(e=k,r=t;n=i[r+16>>2]<2,e=n?e:r,r=i[(n?4:0)+r>>2],!!r;);if((e|0)!=(k|0))break f}_=0;break r}if(_=0,i[e+16>>2]>2)break r;z=i[e+56>>2]>>>1|0,_=i[e+44>>2]}r:{f:{if(e=i[f>>2],e){for(n=f,r=e;h=i[r+16>>2],n=(h|0)<0?n:r,r=i[(h>>>29&4)+r>>2],!!r;);r=0;A:{if((f|0)==(n|0)||(r=0,i[n+16>>2]>0))break A;m0=i[n+44>>2],r=i[n+56>>2]}for(X0=r,n=f,r=e;h=i[r+16>>2]<=0,n=h?n:r,r=i[(h?4:0)+r>>2],!!r;);h=0;A:{if((f|0)==(n|0)||(h=0,i[n+16>>2]>1))break A;E=i[n+56>>2],h=i[n+44>>2]}for(n=f,r=e;B=i[r+16>>2]<2,n=B?n:r,r=i[(B?4:0)+r>>2],!!r;);if((f|0)!=(n|0))break f}B=0;break r}if(B=0,i[n+16>>2]>2)break r;P=i[n+56>>2]>>>1|0,B=i[n+44>>2]}n=0;r:{if(!O)break r;f:{A:{if(!t)break A;for(r=k;n=i[t+16>>2]<6,r=n?r:t,t=i[(n?4:0)+t>>2],!!t;);if((r|0)==(k|0))break A;if(k=0,i[r+16>>2]>6)break f;g0=i[r+44>>2],k=i[r+56>>2];break f}k=0}if(I0=k,n=0,!e)break r;for(r=f;k=i[e+16>>2]<6,r=k?r:e,e=i[(k?4:0)+e>>2],!!e;);if(n=0,(r|0)==(f|0)||(n=0,i[r+16>>2]>6))break r;e0=i[r+56>>2],n=i[r+44>>2]}t=E>>>1|0,e=m>>>1|0;r:{f:{A:{k:{if(a=X&1,a){if(f=Q-1|0,!f)break k;for(r=R-1|0,k=B+(G(r,P)<<1)|0,m=X-1|0,E=(G(m,z)<<1)+_|0,S=(G(r,t)<<1)+h|0,m=(G(e,m)<<1)+o|0,r=0;F=r<<1,N=F+m|0,g[r+S>>1]=(C[N>>1]+C[N+2>>1]|0)+1>>>1,F=E+F|0,g[r+k>>1]=(C[F>>1]+C[F+2>>1]|0)+1>>>1,r=r+2|0,f>>>0>r>>>0;);}if(Q&1)break k;f=X-1|0;break A}if(k=w<<1,w=Q<<1,f=X-1|0,f){for(S=(k+B|0)-2|0,m=(w+_|0)-2|0,F=(k+h|0)-2|0,E=(o+w|0)-2|0,r=0;N=r>>>1|0,M=r|1,g[F+(G(N,t)<<1)>>1]=(C[E+(G(e,r)<<1)>>1]+C[E+(G(M,e)<<1)>>1]|0)+1>>>1,g[S+(G(P,N)<<1)>>1]=(C[m+(G(r,z)<<1)>>1]+C[m+(G(z,M)<<1)>>1]|0)+1>>>1,r=r+2|0,f>>>0>r>>>0;);if(!a)break f}r=R-1|0,g[(k+((G(r,t)<<1)+h|0)|0)-2>>1]=C[(w+((G(e,f)<<1)+o|0)|0)-2>>1],g[(k+(B+(G(r,P)<<1)|0)|0)-2>>1]=C[(w+((G(f,z)<<1)+_|0)|0)-2>>1]}if(!f)break r}if(R=Q-1|0,!R)break r;for(k=0;;){for(m=(G(k,z)<<1)+_|0,E=(G(e,k)<<1)+o|0,r=k>>>1|0,a=B+(G(r,P)<<1)|0,S=(G(r,t)<<1)+h|0,r=k|1,F=(G(r,z)<<1)+_|0,N=(G(e,r)<<1)+o|0,r=0;w=r<<1,M=w+F|0,r0=C[M+2>>1],M=C[M>>1],$=w+m|0,N0=C[$+2>>1],$=C[$>>1],A0=w+N|0,w=w+E|0,g[r+S>>1]=((C[A0>>1]+(C[w>>1]+C[w+2>>1]|0)|0)+C[A0+2>>1]|0)+2>>>2,g[r+a>>1]=((M+($+N0|0)|0)+r0|0)+2>>>2,r=r+2|0,R>>>0>r>>>0;);if(k=k+2|0,!(k>>>0<f>>>0))break}}if(X)for(k=X0>>>1|0,t=_0>>>1|0,e=Q<<1,f=f0>>>0>8?e:Q,r=0;e&&x((G(r,k)<<1)+m0|0,(G(r,t)<<1)+n0|0,e),!O|!f||x(G(r,e0)+n|0,G(r,I0)+g0|0,f),r=r+1|0,(X|0)!=(r|0););u[A+20|0]=0,i[A+4>>2]=I,i[A>>2]=V;break i}if(A=i[I+4>>2],i[I+4>>2]=A-1,A)break i;W[i[i[I>>2]+8>>2]](I),y(I)}v=s+128|0}function ZB(A,e,r,f,k){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0;var n=0,t=0,o=0,s=0,w=0;n=v-240|0,v=n;i:{e:{r:{f:{A:{k:{n:{t:{u:{o:{if(t=i[A+24>>2],i[t>>2]>=2){W[i[t+20>>2]](n+216|0,e,r,f,k,i[A+28>>2]),i[n+208>>2]=0,i[n+200>>2]=0,i[n+204>>2]=0,r=i[n+236>>2];l:{if(!r)break l;if(e=h2(r),e>>>0>=2147483640)break o;s:{w:{if(e>>>0>=11){o=e|7,t=p(o+1|0),i[n+56>>2]=o-2147483647,i[n+48>>2]=t,i[n+52>>2]=e;break w}if(u[n+59|0]=e,t=n+48|0,!e)break s}if(!e)break s;x(t,r,e)}if(u[e+t|0]=0,u[n+211|0]<0&&Z(i[n+200>>2]),i[n+208>>2]=i[n+56>>2],e=i[n+52>>2],i[n+200>>2]=i[n+48>>2],i[n+204>>2]=e,e=i[i[A+24>>2]+32>>2],!e)break l;W[e|0](i[n+236>>2])}l:switch(i[n+216>>2]){case 2:e=p(24),i[n+24>>2]=e,i[n+28>>2]=21,i[n+32>>2]=-2147483624,r=l[11636]|l[11637]<<8|(l[11638]<<16|l[11639]<<24),f=l[11632]|l[11633]<<8|(l[11634]<<16|l[11635]<<24),u[e+13|0]=f,u[e+14|0]=f>>>8,u[e+15|0]=f>>>16,u[e+16|0]=f>>>24,u[e+17|0]=r,u[e+18|0]=r>>>8,u[e+19|0]=r>>>16,u[e+20|0]=r>>>24,r=l[11631]|l[11632]<<8|(l[11633]<<16|l[11634]<<24),f=l[11627]|l[11628]<<8|(l[11629]<<16|l[11630]<<24),u[e+8|0]=f,u[e+9|0]=f>>>8,u[e+10|0]=f>>>16,u[e+11|0]=f>>>24,u[e+12|0]=r,u[e+13|0]=r>>>8,u[e+14|0]=r>>>16,u[e+15|0]=r>>>24,r=l[11623]|l[11624]<<8|(l[11625]<<16|l[11626]<<24),f=l[11619]|l[11620]<<8|(l[11621]<<16|l[11622]<<24),u[e|0]=f,u[e+1|0]=f>>>8,u[e+2|0]=f>>>16,u[e+3|0]=f>>>24,u[e+4|0]=r,u[e+5|0]=r>>>8,u[e+6|0]=r>>>16,u[e+7|0]=r>>>24,u[e+21|0]=0,e=q(n+48|0,2,100,n+24|0),r=i[e+4>>2],i[A+4>>2]=i[e>>2],i[A+8>>2]=r,u[A+23|0]<0&&Z(i[A+12>>2]),r=i[e+12>>2],i[A+12>>2]=i[e+8>>2],i[A+16>>2]=r,i[A+20>>2]=i[e+16>>2],u[e+19|0]=0,u[e+8|0]=0,u[n+35|0]<0&&Z(i[n+24>>2]),f=i[n+224>>2],k=i[n+228>>2];break e;case 3:if(i[n+236>>2]){i[n+140>>2]=0,i[n+112>>2]=72196,i[n+56>>2]=72176,e=i[18053],i[n+48>>2]=e,r=i[e-12>>2],e=n+48|0,i[r+e>>2]=i[18054],i[n+52>>2]=0,r=e+i[i[n+48>>2]-12>>2]|0,f=n+60|0,J0(r,f),u[r+80|0]=0,i[r+72>>2]=0,r=i[18055],i[n+56>>2]=r,k=i[r-12>>2],r=n+56|0,i[k+r>>2]=i[18056],k=i[18052],i[n+48>>2]=k,i[e+i[k-12>>2]>>2]=i[18057],i[n+112>>2]=72196,i[n+48>>2]=72156,i[n+56>>2]=72176,f=R0(f),i[f>>2]=71232,i[n+100>>2]=0,i[n+104>>2]=0,i[n+92>>2]=0,i[n+96>>2]=0,i[n+108>>2]=24,k=Y(S0(Y(r,27060,13),i[n+232>>2]),32727,4),e=u[n+211|0],r=(e|0)<0,Y(k,r?i[n+200>>2]:n+200|0,r?i[n+204>>2]:e),e=i[n+108>>2];s:{if(e&16){t=n+80|0,r=i[n+104>>2],e=i[n+84>>2],r>>>0<e>>>0?i[n+104>>2]=e:e=r;break s}if(!(e&8)){e=0,u[n+23|0]=0,t=n+12|0;break f}t=n+68|0,e=i[n+76>>2]}if(r=i[t>>2],e=e-r|0,e>>>0>=2147483640)break u;if(e>>>0>=11){k=e|7,t=p(k+1|0),i[n+20>>2]=k-2147483647,i[n+12>>2]=t,i[n+16>>2]=e;break A}if(u[n+23|0]=e,t=n+12|0,e)break A;e=0;break f}i[n+140>>2]=0,i[n+112>>2]=72196,i[n+56>>2]=72176,e=i[18053],i[n+48>>2]=e,r=i[e-12>>2],e=n+48|0,i[r+e>>2]=i[18054],i[n+52>>2]=0,r=e+i[i[n+48>>2]-12>>2]|0,f=n+60|0,J0(r,f),u[r+80|0]=0,i[r+72>>2]=0,r=i[18055],i[n+56>>2]=r,k=i[r-12>>2],r=n+56|0,i[k+r>>2]=i[18056],k=i[18052],i[n+48>>2]=k,i[e+i[k-12>>2]>>2]=i[18057],i[n+112>>2]=72196,i[n+48>>2]=72156,i[n+56>>2]=72176,f=R0(f),i[f>>2]=71232,i[n+100>>2]=0,i[n+104>>2]=0,i[n+92>>2]=0,i[n+96>>2]=0,i[n+108>>2]=24,Y(S0(Y(r,27060,13),i[n+232>>2]),26897,1),e=i[n+108>>2];s:{if(e&16){t=n+80|0,r=i[n+104>>2],e=i[n+84>>2],r>>>0<e>>>0?i[n+104>>2]=e:e=r;break s}if(!(e&8)){e=0,u[n+23|0]=0,t=n+12|0;break k}t=n+68|0,e=i[n+76>>2]}if(r=i[t>>2],e=e-r|0,e>>>0>=2147483640)break t;if(e>>>0>=11){k=e|7,t=p(k+1|0),i[n+20>>2]=k-2147483647,i[n+12>>2]=t,i[n+16>>2]=e;break n}if(u[n+23|0]=e,t=n+12|0,e)break n;e=0;break k;case 0:break e;case 1:break r;default:break l}if(e=p(40),i[n+24>>2]=e,i[n+28>>2]=33,i[n+32>>2]=-2147483608,u[e+32|0]=l[12056],r=l[12052]|l[12053]<<8|(l[12054]<<16|l[12055]<<24),f=l[12048]|l[12049]<<8|(l[12050]<<16|l[12051]<<24),u[e+24|0]=f,u[e+25|0]=f>>>8,u[e+26|0]=f>>>16,u[e+27|0]=f>>>24,u[e+28|0]=r,u[e+29|0]=r>>>8,u[e+30|0]=r>>>16,u[e+31|0]=r>>>24,r=l[12044]|l[12045]<<8|(l[12046]<<16|l[12047]<<24),f=l[12040]|l[12041]<<8|(l[12042]<<16|l[12043]<<24),u[e+16|0]=f,u[e+17|0]=f>>>8,u[e+18|0]=f>>>16,u[e+19|0]=f>>>24,u[e+20|0]=r,u[e+21|0]=r>>>8,u[e+22|0]=r>>>16,u[e+23|0]=r>>>24,r=l[12036]|l[12037]<<8|(l[12038]<<16|l[12039]<<24),f=l[12032]|l[12033]<<8|(l[12034]<<16|l[12035]<<24),u[e+8|0]=f,u[e+9|0]=f>>>8,u[e+10|0]=f>>>16,u[e+11|0]=f>>>24,u[e+12|0]=r,u[e+13|0]=r>>>8,u[e+14|0]=r>>>16,u[e+15|0]=r>>>24,r=l[12028]|l[12029]<<8|(l[12030]<<16|l[12031]<<24),f=l[12024]|l[12025]<<8|(l[12026]<<16|l[12027]<<24),u[e|0]=f,u[e+1|0]=f>>>8,u[e+2|0]=f>>>16,u[e+3|0]=f>>>24,u[e+4|0]=r,u[e+5|0]=r>>>8,u[e+6|0]=r>>>16,u[e+7|0]=r>>>24,u[e+33|0]=0,e=q(n+48|0,2,0,n+24|0),r=i[e+4>>2],i[A+4>>2]=i[e>>2],i[A+8>>2]=r,u[A+23|0]<0&&Z(i[A+12>>2]),r=i[e+12>>2],i[A+12>>2]=i[e+8>>2],i[A+16>>2]=r,i[A+20>>2]=i[e+16>>2],u[e+19|0]=0,u[e+8|0]=0,u[n+35|0]>=0)break r;Z(i[n+24>>2]);break r}if(!(W[i[t+16>>2]](f,k,i[A+28>>2])|0))break i;if(e=W[i[i[A+24>>2]+4>>2]](i[A+28>>2])|0,r=l0,t=r,o=e+1|0,r=o?r:r+1|0,(f|0)==(o|0)&(r|0)==(k|0)){f=e,k=t;break i}for(r=f,o=k,f=e,k=t;t=k+o|0,s=r+f|0,t=s>>>0<r>>>0?t+1|0:t,s=(t&1)<<31|s>>>1,e=t>>>1|0,w=W[i[i[A+24>>2]+16>>2]](s,e,i[A+28>>2])|0,r=w?s:r,t=w?e:o,o=t,e=w?k:e,k=e,f=w?f:s,s=f+1|0,e=s?e:e+1|0,!!((r|0)!=(s|0)|(e|0)!=(t|0)););break i}Q0(),H()}Q0(),H()}Q0(),H()}if(!e)break k;x(t,r,e)}u[e+t|0]=0,e=q(n+24|0,2,0,n+12|0),r=i[e+4>>2],i[A+4>>2]=i[e>>2],i[A+8>>2]=r,u[A+23|0]<0&&Z(i[A+12>>2]),r=i[e+12>>2],i[A+12>>2]=i[e+8>>2],i[A+16>>2]=r,i[A+20>>2]=i[e+16>>2],u[e+19|0]=0,u[e+8|0]=0,u[n+23|0]<0&&Z(i[n+12>>2]),A=i[18051],i[n+48>>2]=A,i[i[A-12>>2]+(n+48|0)>>2]=i[18059],i[n+56>>2]=i[18060],i[f>>2]=71232,u[n+103|0]<0&&Z(i[n+92>>2]),E0(f),y0(n+112|0);break r}if(!e)break f;x(t,r,e)}u[e+t|0]=0,e=q(n+24|0,2,0,n+12|0),r=i[e+4>>2],i[A+4>>2]=i[e>>2],i[A+8>>2]=r,u[A+23|0]<0&&Z(i[A+12>>2]),r=i[e+12>>2],i[A+12>>2]=i[e+8>>2],i[A+16>>2]=r,i[A+20>>2]=i[e+16>>2],u[e+19|0]=0,u[e+8|0]=0,u[n+23|0]<0&&Z(i[n+12>>2]),A=i[18051],i[n+48>>2]=A,i[i[A-12>>2]+(n+48|0)>>2]=i[18059],i[n+56>>2]=i[18060],i[f>>2]=71232,u[n+103|0]<0&&Z(i[n+92>>2]),E0(f),y0(n+112|0)}f=0,k=0}if(u[n+211|0]>=0)break i;Z(i[n+200>>2])}return v=n+240|0,l0=k,f|0}function vf(A,e,r,f,k){var n=0,t=0,o=0,s=0,w=0,h=0,_=0,B=0,m=0,X=0,Q=0,V=0,F=0,I=0,E=0,R=0,N=0,M=0,z=0,S=0,O=0,P=0,a=0,$=0,f0=0,A0=0,n0=0,_0=0,m0=0,X0=0,g0=0,I0=0,e0=0,r0=0,N0=0,U0=0,M0=0,H0=0,P0=0,K0=0,$0=0,L0=0,d0=0,n2=0,Z2=0,Q2=0,g2=0,p2=0,H2=0,T2=0,b2=0,e1=0,X1=0,J1=0,z1=0,b1=0,G4=0,X4=0,W4=0;n=v+-64|0,v=n;i:{e:{h=i[A+276>>2],n2=(f|0)<(h|0)?f:h;r:{if((n2|0)<=(r|0)||(K0=i[A+272>>2],Z2=(k|0)<(K0|0)?k:K0,(Z2|0)<=0))break r;for(b2=e?1:2,e1=e?2:1,R=i[A+40>>2],Q2=R<<1,g2=i[A+124>>2],f=i[g2+16832>>2],p2=f-8|0,O=-1<<f^-1,X1=e?4:3,m0=G(R,-6),X0=G(R,6),e0=R<<2,$0=0-e0|0,J1=R<<(e^1)<<3,z1=G(r,R)<<3,b1=i[A+260>>2],g0=0-R<<1,P=R<<1,U0=0-P<<1;;){for(r0=r<<2,H2=r0-1|0,G4=G(R,r0),X4=G(T2,J1)+z1|0,W4=G(r0>>2,K0)+b1|0,L0=0,M0=0;;){s=M0<<2,f0=l[(s>>2)+W4|0]&3;f:{if(!f0)break f;f=i[A+4>>2],h=f+(s+G4<<1)|0;A:{if(!e){g[n+32>>1]=C[h>>1],f=C[h+g0>>1],g[n>>1]=f,g[n+34>>1]=C[h+P>>1],w=C[h+U0>>1],g[n+2>>1]=w,_=P<<1,g[n+36>>1]=C[_+h>>1],m=C[h+m0>>1],g[n+4>>1]=m,g[n+38>>1]=C[h+X0>>1],B=$0<<1,o=C[B+h>>1],g[n+6>>1]=o,k=h+2|0,g[n+40>>1]=C[k>>1],g[n+8>>1]=C[k+g0>>1],g[n+42>>1]=C[k+P>>1],g[n+10>>1]=C[k+U0>>1],g[n+44>>1]=C[k+_>>1],g[n+12>>1]=C[k+m0>>1],g[n+46>>1]=C[k+X0>>1],g[n+14>>1]=C[k+B>>1],k=h+4|0,g[n+48>>1]=C[k>>1],g[n+16>>1]=C[k+g0>>1],g[n+50>>1]=C[k+P>>1],g[n+18>>1]=C[k+U0>>1],g[n+52>>1]=C[k+_>>1],g[n+20>>1]=C[k+m0>>1],g[n+54>>1]=C[k+X0>>1],g[n+22>>1]=C[k+B>>1],t=h+6|0,g[n+56>>1]=C[t>>1],F=C[t+g0>>1],g[n+24>>1]=F,g[n+58>>1]=C[t+P>>1],k=C[t+U0>>1],g[n+26>>1]=k,g[n+60>>1]=C[t+_>>1],_=C[t+m0>>1],g[n+28>>1]=_,g[n+62>>1]=C[t+X0>>1],t=t+B|0;break A}k=f+((L0<<X1)+X4|0)|0,f=C[k+4>>1]|C[k+6>>1]<<16,i[n+32>>2]=C[k>>1]|C[k+2>>1]<<16,i[n+36>>2]=f,f=C[h-2>>1],g[n>>1]=f,w=C[h-4>>1],g[n+2>>1]=w,m=C[h-6>>1],g[n+4>>1]=m,o=C[h-8>>1],g[n+6>>1]=o,t=k+Q2|0,_=C[t+4>>1]|C[t+6>>1]<<16,i[n+40>>2]=C[t>>1]|C[t+2>>1]<<16,i[n+44>>2]=_,t=h+P|0,g[n+8>>1]=C[t-2>>1],g[n+10>>1]=C[t-4>>1],g[n+12>>1]=C[t-6>>1],g[n+14>>1]=C[t-8>>1],t=k+e0|0,_=C[t+4>>1]|C[t+6>>1]<<16,i[n+48>>2]=C[t>>1]|C[t+2>>1]<<16,i[n+52>>2]=_,t=h+e0|0,g[n+16>>1]=C[t-2>>1],g[n+18>>1]=C[t-4>>1],g[n+20>>1]=C[t-6>>1],g[n+22>>1]=C[t-8>>1],k=k+X0|0,t=C[k+4>>1]|C[k+6>>1]<<16,i[n+56>>2]=C[k>>1]|C[k+2>>1]<<16,i[n+60>>2]=t,t=h+X0|0,F=C[t-2>>1],g[n+24>>1]=F,k=C[t-4>>1],g[n+26>>1]=k,_=C[t-6>>1],g[n+28>>1]=_,t=t-8|0}if(H0=C[t>>1],g[n+30>>1]=H0,B=i[A+168>>2],E=s>>B,(E|0)<0||(t=i[A+172>>2],(t|0)<=(E|0)))break i;if(N=r0>>B,(N|0)<0||(S=i[A+176>>2],(S|0)<=(N|0)))break e;X=G(E,3),E=i[A+160>>2],M=X+E|0,N=G(G(t,N),3),a=M+N|0,d0=u[a+2|0];A:{if(!e){if(X=H2>>B,(X|0)<0|(X|0)>=(S|0))break e;X=(M+G(G(t,X),3)|0)+2|0;break A}if(X=s-1>>B,(X|0)<0|t>>>0<=X>>>0)break i;X=(N+(E+G(X,3)|0)|0)+2|0}if(Q=i[A+148>>2],V=s>>Q,(V|0)<0||(P0=i[A+152>>2],(P0|0)<=(V|0)))break i;if(Q=r0>>Q,(Q|0)<0|(Q|0)>=i[A+156>>2])break e;if(I0=C[n+56>>1],A0=I0+(C[n+60>>1]-(C[n+58>>1]<<1)|0)|0,n0=A0>>31,F=F&65535,_0=F+(_-((k&65535)<<1)|0)|0,k=_0>>31,N0=C[n+32>>1],I=N0+(C[n+36>>1]-(C[n+34>>1]<<1)|0)|0,_=I>>31,m=(m-(w<<1)|0)+f|0,w=m>>31,n0=(n0^A0)-n0|0,A0=(k^_0)-k|0,_0=n0+A0|0,I=(_^I)-_|0,z=(w^m)-w|0,$=I+z|0,_=(d0+u[X|0]|0)+1>>1,k=i[i[A+52>>2]+(C[((i[A+140>>2]+G(V,24)|0)+G(G(Q,P0),24)|0)+2>>1]<<2)>>2],w=_+i[k+764>>2]|0,w=(w|0)>=51?51:w,m=l[((w|0)>0?w:0)+60704|0]<<p2,(_0+$|0)>=(m|0))break f;k=(i[k+768>>2]+(_+(f0<<1)|0)|0)-2|0,k=(k|0)>=53?53:k,_=l[((k|0)>0?k:0)+60768|0]<<p2,w=0,V=m>>>2|0,k=0;A:{if(V>>>0<=$<<1>>>0||(Q=N0-C[n+38>>1]|0,X=Q>>31,f0=o-f|0,o=f0>>31,k=0,(X^Q)-X+((o^f0)-o)>>>0>=m>>>3>>>0))break A;k=f-N0|0,f=k>>31,k=((f^k)-f|0)<G(_,5)+1>>1}f=k;A:{if(V>>>0<=_0<<1>>>0||(X=I0-C[n+62>>1]|0,k=X>>31,V=H0-F|0,o=V>>31,(k^X)-k+((o^V)-o)>>>0>=m>>>3>>>0))break A;w=F-I0|0,k=w>>31,w=((k^w)-k|0)<G(_,5)+1>>1}o=l[g2+8812|0];A:{if(!e){if(s=H2>>B,o){if((s|0)<0|(s|0)>=(S|0))break e;k=!(l[(M+G(G(t,s),3)|0)+1|0]&4)}else k=1;if((s|0)<0|(s|0)>=(S|0))break e;t=M+G(G(t,s),3)|0;break A}if(s=s-1>>B,o){if((s|0)<0|t>>>0<=s>>>0)break i;k=!(l[(N+(E+G(s,3)|0)|0)+1|0]&4)}else k=1;if((s|0)<0|t>>>0<=s>>>0)break i;t=N+(E+G(s,3)|0)|0}for(N0=f&w,E=!(l[t+1|0]&8)&k,f=m+(m>>>1|0)>>>3|0,f0=E&f>>>0>z+A0>>>0,k=f>>>0>I+n0>>>0,f=l[a|0]|l[a+1|0]<<8,S=!(f&2048)&(!o|!(f&1024)),n0=k&S,t=_<<1,f=0,I0=0-_|0,H0=G(_,10),d0=h+2|0,P0=h-4|0,A0=h-2|0,a=_>>1,X=0-a|0,_0=h+P|0;;){w=f<<3,k=w+n|0,s=C[k+2>>1],o=w+(n+32|0)|0,M=C[o+4>>1],w=C[o+2>>1],B=C[o>>1],N=C[k+4>>1],m=C[k>>1];A:{if(!N0){if(k=(G(B-m|0,9)+G(w-s|0,-3)|0)+8>>4,o=k>>31,(H0|0)<=((k^o)-o|0))break A;o=(k|0)<(I0|0)?I0:(k|0)<(_|0)?k:_;k:{n:{if(!e){if(E&&(k=o+m|0,g[h+(f-R<<1)>>1]=(k|0)>=0?(k|0)<(O|0)?k:O:0),!S)break k;k=B-o|0,F=(k|0)>=0?(k|0)<(O|0)?k:O:0,k=f;break n}if(E&&(k=o+m|0,g[A0+(G(f,R)<<1)>>1]=(k|0)>=0?(k|0)<(O|0)?k:O:0),!S)break k;k=B-o|0,F=(k|0)>=0?(k|0)<(O|0)?k:O:0,k=G(f,R)}g[(k<<1)+h>>1]=F}k:{if(!f0)break k;if(k=o+(((m+N|0)+1>>>1|0)-s|0)>>1,k=((k|0)<(X|0)?X:(k|0)<(a|0)?k:a)+s|0,k=(k|0)>=0?(k|0)<(O|0)?k:O:0,!e){g[h+(f-Q2<<1)>>1]=k;break k}g[P0+(G(f,R)<<1)>>1]=k}if(!n0)break A;if(k=((B+M|0)+1>>>1)-(o+w)>>1,k=w+((k|0)<(X|0)?X:(k|0)<(a|0)?k:a)|0,k=(k|0)>=0?(k|0)<(O|0)?k:O:0,!e){g[_0+(f<<1)>>1]=k;break A}g[d0+(G(f,R)<<1)>>1]=k;break A}if(V=w-t|0,Q=B+m|0,I=Q+w|0,F=(I+M|0)+2>>>2|0,z=t+w|0,F=(F|0)<(V|0)?V:(F|0)<(z|0)?F:z,z=s-t|0,Q=s+Q|0,V=(Q+N|0)+2>>>2|0,$=t+s|0,V=(V|0)<(z|0)?z:(V|0)<($|0)?V:$,z=M-t|0,o=((I+G(M,3)|0)+(C[o+6>>1]<<1)|0)+4>>>3|0,I=t+M|0,o=(o|0)<(z|0)?z:(o|0)<(I|0)?o:I,I=N-t|0,k=((Q+G(N,3)|0)+(C[k+6>>1]<<1)|0)+4>>>3|0,Q=t+N|0,Q=(k|0)<(I|0)?I:(k|0)<(Q|0)?k:Q,I=B-t|0,$=B<<1,z=(m<<1)+4|0,k=M+(($+(z+s|0)|0)+(w<<1)|0)>>>3|0,B=t+B|0,B=(k|0)<(I|0)?I:(k|0)<(B|0)?k:B,M=m-t|0,k=w+($+((N+z|0)+(s<<1)|0)|0)>>>3|0,s=t+m|0,s=(k|0)<(M|0)?M:(k|0)<(s|0)?k:s,!e){if(k=h+(f<<1)|0,!E){if(!S)break A;g[k>>1]=B,g[k+P>>1]=F,g[k+e0>>1]=o;break A}if(!S){g[k+g0>>1]=s,g[k+$0>>1]=V,g[k+m0>>1]=Q;break A}g[k+g0>>1]=s,g[k>>1]=B,g[k+$0>>1]=V,g[k+P>>1]=F,g[k+m0>>1]=Q,g[k+e0>>1]=o;break A}if(k=h+(G(f,R)<<1)|0,E&&(g[k-2>>1]=s),S&&(g[k>>1]=B),E&&(g[k-4>>1]=V),S&&(g[k+2>>1]=F),E&&(g[k-6>>1]=Q),!S)break A;g[k+4>>1]=o}if(f=f+1|0,(f|0)==4)break}}if(L0=L0+1|0,M0=M0+e1|0,!((Z2|0)>(M0|0)))break}if(T2=T2+1|0,r=r+b2|0,!((n2|0)>(r|0)))break}}v=n- -64|0;return}D0(4618,10893,119,4231),H()}D0(4656,10893,118,4231),H()}function GB(A,e,r,f,k,n,t,o){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,t=t|0,o=o|0;var s=0,w=0,h=0,_=0,B=0,m=0,X=0,Q=0,V=0,F=0,I=0,E=0,R=0,N=0,M=0,z=0,S=0,O=0,P=0,a=0,$=0,f0=0,A0=0,n0=0,_0=0,m0=0,X0=0,g0=0,I0=0;s=v-128|0,v=s,k=j0(i[r>>2],0),n=j0(i[r>>2],1),t=j0(i[r>>2],2),S=u1(i[r>>2],6),S&&($=j0(i[r>>2],6));i:{if(!(!(k>>>0<9|n>>>0<9)&t>>>0>8)){e=i[26922],i[A>>2]=i[26921],i[A+4>>2]=e,e=A+8|0;e:{if(u[107703]>=0){r=i[26924],i[e>>2]=i[26923],i[e+4>>2]=r,i[e+8>>2]=i[26925];break e}T(e,i[26923],i[26924])}u[A+20|0]=1;break i}if(!((k|0)==(n|0)&(k|0)==(t|0))){e=i[26922],i[A>>2]=i[26921],i[A+4>>2]=e,e=A+8|0;e:{if(u[107703]>=0){r=i[26924],i[e>>2]=i[26923],i[e+4>>2]=r,i[e+8>>2]=i[26925];break e}T(e,i[26923],i[26924])}u[A+20|0]=1;break i}e=i[r>>2],h=i[e+112>>2],_=i[e+108>>2],I=p(172),i[I>>2]=94812,e=I,i[e+4>>2]=0,i[e+8>>2]=0,o0(e+16|0,0,80),m=i[e+4>>2],w=m+1|0,i[e+4>>2]=w,i[e+104>>2]=0,i[e+108>>2]=0,i[e+36>>2]=1,i[e+40>>2]=1,u[e+24|0]=1,g[e+22>>1]=2,g[e+18>>1]=2,g[e+20>>1]=2,i[e+112>>2]=0,i[e+116>>2]=4740,i[e+140>>2]=0,i[e+144>>2]=0,i[e+128>>2]=99,i[e+132>>2]=99,i[e+120>>2]=0,i[e+124>>2]=0,i[e+12>>2]=95160,i[e+148>>2]=0,i[e+152>>2]=0,f=e+140|0,i[e+136>>2]=f,i[e+156>>2]=0,i[e+160>>2]=0,i[e+164>>2]=0,i[e+168>>2]=0,i[e+4>>2]=m,m=i[e+8>>2],V=e+12|0,i[e+96>>2]=V,i[e+8>>2]=m+1,i[e+100>>2]=e,w||(W[i[i[e>>2]+8>>2]](e),y(e)),i[V+120>>2]=3,i[V+116>>2]=0,i[V+112>>2]=h,i[V+108>>2]=_,T0(s+56|0,V,0,_,h,k,o),T0(s+32|0,V,1,_,h,n,o),e=s+88|0;e:{if(i[s+56>>2]){if(k=i[s+60>>2],i[s+80>>2]=i[s+56>>2],i[s+84>>2]=k,u[s+75|0]>=0){k=s- -64|0,n=i[k+4>>2],i[e>>2]=i[k>>2],i[e+4>>2]=n,i[e+8>>2]=i[k+8>>2];break e}T(e,i[s+64>>2],i[s+68>>2]);break e}if(k=i[s+36>>2],i[s+80>>2]=i[s+32>>2],i[s+84>>2]=k,u[s+51|0]>=0){k=i[s+44>>2],i[e>>2]=i[s+40>>2],i[e+4>>2]=k,i[e+8>>2]=i[s+48>>2];break e}T(e,i[s+40>>2],i[s+44>>2])}T0(s+8|0,V,2,_,h,t,o),k=s+112|0;e:{if(i[s+80>>2]){if(n=i[s+84>>2],i[s+104>>2]=i[s+80>>2],i[s+108>>2]=n,u[s+99|0]>=0){n=i[e+4>>2],i[k>>2]=i[e>>2],i[k+4>>2]=n,i[k+8>>2]=i[e+8>>2];break e}T(k,i[s+88>>2],i[s+92>>2]);break e}if(e=i[s+12>>2],i[s+104>>2]=i[s+8>>2],i[s+108>>2]=e,u[s+27|0]>=0){e=i[s+20>>2],i[k>>2]=i[s+16>>2],i[k+4>>2]=e,i[k+8>>2]=i[s+24>>2];break e}T(k,i[s+16>>2],i[s+20>>2])}u[s+27|0]<0&&Z(i[s+16>>2]),u[s+99|0]<0&&Z(i[s+88>>2]),u[s+51|0]<0&&Z(i[s+40>>2]),u[s+75|0]<0&&Z(i[s+64>>2]);e:{if(i[s+104>>2]){if(e=i[s+108>>2],i[A>>2]=i[s+104>>2],i[A+4>>2]=e,e=A+8|0,u[s+123|0]>=0){r=i[k+4>>2],i[e>>2]=i[k>>2],i[e+4>>2]=r,i[e+8>>2]=i[k+8>>2],u[A+20|0]=1;break e}if(T(e,i[s+112>>2],i[s+116>>2]),e=u[s+123|0],u[A+20|0]=1,(e|0)>=0)break e;Z(i[s+112>>2]);break e}u[s+123|0]<0&&Z(i[s+112>>2]);r:{if(!S)break r;if(T0(s+104|0,V,6,_,h,$,o),i[s+104>>2]){if(e=i[s+108>>2],i[A>>2]=i[s+104>>2],i[A+4>>2]=e,e=A+8|0,u[s+123|0]>=0){r=i[s+116>>2],i[e>>2]=i[s+112>>2],i[e+4>>2]=r,i[e+8>>2]=i[s+120>>2],u[A+20|0]=1;break e}if(T(e,i[s+112>>2],i[s+116>>2]),e=u[s+123|0],u[A+20|0]=1,(e|0)>=0)break e;Z(i[s+112>>2]);break e}if(u[s+123|0]>=0)break r;Z(i[s+112>>2])}e=i[r>>2],k=e+128|0;r:{f:{if(t=i[e+128>>2],t){for(e=k,r=t;n=i[r+16>>2],e=(n|0)<0?e:r,r=i[(n>>>29&4)+r>>2],!!r;);M=0;A:{if((e|0)==(k|0)||(M=0,i[e+16>>2]>0))break A;_0=i[e+44>>2],M=i[e+56>>2]}for(e=k,r=t;n=i[r+16>>2]<=0,e=n?e:r,r=i[(n?4:0)+r>>2],!!r;);F=0;A:{if((e|0)==(k|0)||(F=0,i[e+16>>2]>1))break A;B=i[e+56>>2],F=i[e+44>>2]}for(e=k,r=t;n=i[r+16>>2]<2,e=n?e:r,r=i[(n?4:0)+r>>2],!!r;);if((e|0)!=(k|0))break f}m=0,o=0;break r}if(m=0,o=0,i[e+16>>2]>2)break r;m=i[e+44>>2],o=i[e+56>>2]>>>1|0}r:{f:{if(e=i[f>>2],e){for(n=f,r=e;X=i[r+16>>2],n=(X|0)<0?n:r,r=i[(X>>>29&4)+r>>2],!!r;);z=0;A:{if((f|0)==(n|0)||(z=0,i[n+16>>2]>0))break A;m0=i[n+44>>2],z=i[n+56>>2]}for(n=f,r=e;X=i[r+16>>2]<=0,n=X?n:r,r=i[(X?4:0)+r>>2],!!r;);r=0;A:{if((f|0)==(n|0)||(r=0,i[n+16>>2]>1))break A;E=i[n+56>>2],r=i[n+44>>2]}for(X=r,n=f,r=e;w=i[r+16>>2]<2,n=w?n:r,r=i[(w?4:0)+r>>2],!!r;);if((f|0)!=(n|0))break f}r=0;break r}if(r=0,i[n+16>>2]>2)break r;R=i[n+56>>2]>>>1|0,r=i[n+44>>2]}n=r,w=0;r:{if(!S)break r;f:{A:{if(!t)break A;for(r=k;w=i[t+16>>2]<6,r=w?r:t,t=i[(w?4:0)+t>>2],!!t;);if((r|0)==(k|0))break A;if(O=0,i[r+16>>2]>6)break f;X0=i[r+44>>2],O=i[r+56>>2];break f}O=0}if(w=0,!e)break r;for(r=f;k=i[e+16>>2]<6,r=k?r:e,e=i[(k?4:0)+e>>2],!!e;);if(w=0,(r|0)==(f|0)||(w=0,i[r+16>>2]>6))break r;g0=i[r+56>>2],w=i[r+44>>2]}f=E>>>1|0,k=B>>>1|0;r:{f:{A:{if(h){if(r=0,(h|0)!=1)for(B=h&-2,e=0;g[(G(r,f)<<1)+X>>1]=C[(G(r,k)<<1)+F>>1],g[n+(G(r,R)<<1)>>1]=C[(G(r,o)<<1)+m>>1],t=r|1,g[(G(t,f)<<1)+X>>1]=C[(G(k,t)<<1)+F>>1],g[n+(G(t,R)<<1)>>1]=C[(G(t,o)<<1)+m>>1],r=r+2|0,e=e+2|0,(B|0)!=(e|0););if(h&1&&(g[(G(r,f)<<1)+X>>1]=C[(G(r,k)<<1)+F>>1],g[n+(G(r,R)<<1)>>1]=C[(G(r,o)<<1)+m>>1]),_&1)break f;break A}if(_&1)break r}if(!h)break r;if(e=(_+m|0)-2|0,t=(_+F|0)-2|0,r=_<<1,B=(r+n|0)-2|0,E=(r+X|0)-2|0,r=0,(h|0)!=1)for(a=h&-2;g[E+(G(r,f)<<1)>>1]=C[t+(G(r,k)<<1)>>1],g[B+(G(r,R)<<1)>>1]=C[e+(G(r,o)<<1)>>1],N=r|1,g[E+(G(N,f)<<1)>>1]=C[t+(G(k,N)<<1)>>1],g[B+(G(R,N)<<1)>>1]=C[e+(G(o,N)<<1)>>1],r=r+2|0,P=P+2|0,(a|0)!=(P|0););if(!(h&1))break f;g[E+(G(r,f)<<1)>>1]=C[t+(G(r,k)<<1)>>1],g[B+(G(r,R)<<1)>>1]=C[e+(G(r,o)<<1)>>1]}if(E=_-1|0,E>>>0>=2)for(e=0;;){for(N=n+(G(e,R)<<1)|0,a=(G(e,f)<<1)+X|0,P=(G(e,o)<<1)+m|0,I0=(G(e,k)<<1)+F|0,r=1;Q=r&-2,B=Q+P|0,t=C[B>>1],B=C[B+2>>1],f0=r<<1,A0=a+f0|0,Q=Q+I0|0,n0=C[Q>>1],Q=C[Q+2>>1],g[A0>>1]=(G(n0,3)+Q|0)+2>>>2,g[A0+2>>1]=(G(Q,3)+n0|0)+2>>>2,Q=N+f0|0,g[Q+2>>1]=(t+G(B,3)|0)+2>>>2,g[Q>>1]=(B+G(t,3)|0)+2>>>2,r=r+2|0,E>>>0>r>>>0;);if(e=e+1|0,(h|0)==(e|0))break}for(k=z>>>1|0,n=M>>>1|0,e=_<<1,f=$>>>0>8?e:_,r=0;e&&x((G(r,k)<<1)+m0|0,(G(r,n)<<1)+_0|0,e),!S|!f||x(G(r,g0)+w|0,G(r,O)+X0|0,f),r=r+1|0,(h|0)!=(r|0););}u[A+20|0]=0,i[A+4>>2]=I,i[A>>2]=V;break i}if(A=i[I+4>>2],i[I+4>>2]=A-1,A)break i;W[i[i[I>>2]+8>>2]](I),y(I)}v=s+128|0}function P7(A,e,r,f,k,n,t,o,s,w,h){var _=0,B=0,m=0,X=0,Q=0,V=0,F=0,I=0,E=0,R=0,N=0;_=v-528|0,v=_,i[_+520>>2]=h,i[_+524>>2]=e;i:{if(L2(A,_+524|0)){i[n>>2]=i[n>>2]|4,A=0;break i}i[_+76>>2]=2072,V=_+76|0,F=Q1(_+104|0,_+112|0,V),e=i[F>>2],i[_+100>>2]=e,i[_+96>>2]=e+400,e=v-16|0,v=e,i[V>>2]=0,i[V+4>>2]=0,i[V+8>>2]=0,v=e+16|0,e=v-16|0,v=e,X=_- -64|0,i[X>>2]=0,i[X+4>>2]=0,i[X+8>>2]=0,v=e+16|0,e=v-16|0,v=e,m=_+52|0,i[m>>2]=0,i[m+4>>2]=0,i[m+8>>2]=0,v=e+16|0,e=v-16|0,v=e,B=_+40|0,i[B>>2]=0,i[B+4>>2]=0,i[B+8>>2]=0,v=e+16|0,e=v-16|0,v=e,Q=_+28|0,i[Q>>2]=0,i[Q+4>>2]=0,i[Q+8>>2]=0,v=e+16|0,e=v-16|0,v=e;e:{if(r){h=e+4|0,r=c0(f,129496),W[i[i[r>>2]+44>>2]](h,r);break e}h=e+4|0,r=c0(f,129488),W[i[i[r>>2]+44>>2]](h,r)}for(f=i[e+4>>2],u[_+92|0]=f,u[_+93|0]=f>>>8,u[_+94|0]=f>>>16,u[_+95|0]=f>>>24,W[i[i[r>>2]+32>>2]](h,r),K8(B,h),s2(h),W[i[i[r>>2]+28>>2]](h,r),K8(m,h),s2(h),R=_,N=W[i[i[r>>2]+12>>2]](r)|0,u[R+91|0]=N,R=_,N=W[i[i[r>>2]+16>>2]](r)|0,u[R+90|0]=N,W[i[i[r>>2]+20>>2]](h,r),K8(V,h),s2(h),W[i[i[r>>2]+24>>2]](h,r),K8(X,h),s2(h),R=_,N=W[i[i[r>>2]+36>>2]](r)|0,i[R+24>>2]=N,v=e+16|0,i[w>>2]=i[s>>2],I=k&512,f=0,e=0;;){r=e;e:{r:{f:{A:{if((f|0)==4||L2(A,_+524|0))break A;h=0;k:{n:{t:{u:{o:switch(l[(_+92|0)+f|0]){case 1:if((f|0)==3)break r;e=i[A>>2],k=i[e+12>>2];l:{if((k|0)==i[e+16>>2]){e=W[i[i[e>>2]+36>>2]](e)|0;break l}e=u[k|0]}if(e=e<<24>>24,(e|0)>=0?e=i[i[o+8>>2]+(e<<2)>>2]&1:e=0,e){fs(_+16|0,A),oi(Q,u[_+16|0]);break u}i[n>>2]=i[n>>2]|4,A=0;break f;case 0:break o;case 2:break n;case 3:break t;case 4:break k;default:break e}if((f|0)==3)break r}for(;;){if(L2(A,_+524|0))break r;e=i[A>>2],k=i[e+12>>2];u:{if((k|0)==i[e+16>>2]){e=W[i[i[e>>2]+36>>2]](e)|0;break u}e=u[k|0]}if(e=e<<24>>24,(e|0)>=0?e=i[i[o+8>>2]+(e<<2)>>2]&1:e=0,!e)break r;fs(_+16|0,A),oi(Q,u[_+16|0])}}t:{if(l[m+11|0]>>>7|0?e=i[m+4>>2]:e=l[m+11|0]&127,!e)break t;e=i[A>>2],k=i[e+12>>2];u:{if((k|0)==i[e+16>>2]){e=W[i[i[e>>2]+36>>2]](e)|0;break u}e=u[k|0]}if(k=e<<24>>24&255,l[m+11|0]>>>7|0?e=i[m>>2]:e=m,(k|0)!=l[e|0])break t;q1(A),u[t|0]=0,l[m+11|0]>>>7|0?e=i[m+4>>2]:e=l[m+11|0]&127,e=e>>>0>1?m:r;break e}t:{if(l[B+11|0]>>>7|0?e=i[B+4>>2]:e=l[B+11|0]&127,!e)break t;e=i[A>>2],k=i[e+12>>2];u:{if((k|0)==i[e+16>>2]){e=W[i[i[e>>2]+36>>2]](e)|0;break u}e=u[k|0]}if(k=e<<24>>24&255,l[B+11|0]>>>7|0?e=i[B>>2]:e=B,(k|0)!=l[e|0])break t;q1(A),u[t|0]=1,l[B+11|0]>>>7|0?e=i[B+4>>2]:e=l[B+11|0]&127,e=e>>>0>1?B:r;break e}if(l[m+11|0]>>>7|0?e=i[m+4>>2]:e=l[m+11|0]&127,k=!e,l[B+11|0]>>>7|0?e=i[B+4>>2]:e=l[B+11|0]&127,!(k|!e)){i[n>>2]=i[n>>2]|4,A=0;break f}if(l[m+11|0]>>>7|0?e=i[m+4>>2]:e=l[m+11|0]&127,!e&&(l[B+11|0]>>>7|0?e=i[B+4>>2]:e=l[B+11|0]&127,!e))break r;l[B+11|0]>>>7|0?e=i[B+4>>2]:e=l[B+11|0]&127,u[t|0]=!e;break r}if(!(I|(f>>>0<2|r))&&(e=0,!((f|0)==2&l[_+95|0]!=0)))break e;R=_,N=T4(X),i[R+12>>2]=N,i[_+16>>2]=i[_+12>>2];n:{if(!f|l[(f+_|0)+91|0]>1)break n;for(;;){t:{if(R=_,N=w6(X),i[R+12>>2]=N,e=i[_+16>>2],(e|0)==i[_+12>>2]||(e=u[e|0],(e|0)>=0?e=i[i[o+8>>2]+(e<<2)>>2]&1:e=0,!e))break t;i[_+16>>2]=i[_+16>>2]+1;continue}break}if(R=_,N=T4(X),i[R+12>>2]=N,l[Q+11|0]>>>7|0?h=i[Q+4>>2]:h=l[Q+11|0]&127,e=_+12|0,k=i[_+16>>2]-i[e>>2]|0,h>>>0>=k>>>0&&(R=_,N=w6(Q),i[R+12>>2]=N,e=o5(e,0-k|0),k=w6(Q),h=T4(X),E=v-16|0,v=E,e=h6(e),k=h6(k),e=N2(e,h6(h),k-e|0),v=E+16|0,!e))break n;R=_,N=T4(X),i[R+8>>2]=N,i[_+12>>2]=i[_+8>>2],i[_+16>>2]=i[_+12>>2]}for(i[_+12>>2]=i[_+16>>2];;){n:{if(R=_,N=w6(X),i[R+8>>2]=N,i[_+12>>2]==i[_+8>>2]||L2(A,_+524|0))break n;e=i[A>>2],k=i[e+12>>2];t:{if((k|0)==i[e+16>>2]){e=W[i[i[e>>2]+36>>2]](e)|0;break t}e=u[k|0]}if((e<<24>>24&255)!=l[i[_+12>>2]])break n;q1(A),i[_+12>>2]=i[_+12>>2]+1;continue}break}if(!I||(R=_,N=w6(X),i[R+8>>2]=N,i[_+12>>2]==i[_+8>>2]))break r;i[n>>2]=i[n>>2]|4,A=0;break f}for(;;){k:{if(L2(A,_+524|0))break k;e=i[A>>2],k=i[e+12>>2];n:{if((k|0)==i[e+16>>2]){e=W[i[i[e>>2]+36>>2]](e)|0;break n}e=u[k|0]}e=e<<24>>24,(e|0)>=0?k=i[i[o+8>>2]+(e<<2)>>2]&64:k=0;n:{if(k){k=i[w>>2],(k|0)==i[_+520>>2]&&(yu(s,w,_+520|0),k=i[w>>2]),i[w>>2]=k+1,u[k|0]=e,h=h+1|0;break n}if(l[V+11|0]>>>7|0?k=i[V+4>>2]:k=l[V+11|0]&127,!k|!h|l[_+90|0]!=(e&255))break k;e=i[_+100>>2],(e|0)==i[_+96>>2]&&(si(F,_+100|0,_+96|0),e=i[_+100>>2]),i[_+100>>2]=e+4,i[e>>2]=h,h=0}q1(A);continue}break}e=i[_+100>>2],!h|(e|0)==i[F>>2]||(i[_+96>>2]==(e|0)&&(si(F,_+100|0,_+96|0),e=i[_+100>>2]),i[_+100>>2]=e+4,i[e>>2]=h);k:{if(i[_+24>>2]<=0)break k;n:{if(!L2(A,_+524|0)){e=i[A>>2],k=i[e+12>>2];t:{if((k|0)==i[e+16>>2]){e=W[i[i[e>>2]+36>>2]](e)|0;break t}e=u[k|0]}if((e<<24>>24&255)==l[_+91|0])break n}i[n>>2]=i[n>>2]|4,A=0;break f}for(;;){if(q1(A),i[_+24>>2]<=0)break k;n:{if(!L2(A,_+524|0)){e=i[A>>2],k=i[e+12>>2];t:{if((k|0)==i[e+16>>2]){e=W[i[i[e>>2]+36>>2]](e)|0;break t}e=u[k|0]}if(e=e<<24>>24,(e|0)>=0?e=i[i[o+8>>2]+(e<<2)>>2]&64:e=0,e)break n}i[n>>2]=i[n>>2]|4,A=0;break f}i[w>>2]==i[_+520>>2]&&yu(s,w,_+520|0),e=i[A>>2],k=i[e+12>>2];n:{if((k|0)==i[e+16>>2]){e=W[i[i[e>>2]+36>>2]](e)|0;break n}e=u[k|0]}k=i[w>>2],i[w>>2]=k+1,u[k|0]=e<<24>>24,i[_+24>>2]=i[_+24>>2]-1}}if(e=r,i[s>>2]!=i[w>>2])break e;i[n>>2]=i[n>>2]|4,A=0;break f}A:{if(!r)break A;for(h=1;;){if(l[r+11|0]>>>7|0?e=i[r+4>>2]:e=l[r+11|0]&127,e>>>0<=h>>>0)break A;k:{if(!L2(A,_+524|0)){e=i[A>>2],f=i[e+12>>2];n:{if((f|0)==i[e+16>>2]){e=W[i[i[e>>2]+36>>2]](e)|0;break n}e=u[f|0]}if(f=e<<24>>24&255,l[r+11|0]>>>7|0?e=i[r>>2]:e=r,(f|0)==l[e+h|0])break k}i[n>>2]=i[n>>2]|4,A=0;break f}q1(A),h=h+1|0}}if(A=1,i[F>>2]==i[_+100>>2])break f;if(A=0,i[_+16>>2]=0,l4(V,i[F>>2],i[_+100>>2],_+16|0),i[_+16>>2]){i[n>>2]=i[n>>2]|4;break f}A=1}s2(Q),s2(B),s2(m),s2(X),s2(V),e=i[F>>2],i[F>>2]=0,e&&W[i[F+4>>2]](e);break i}e=r}f=f+1|0}}return v=_+528|0,A}function XB(A,e,r,f,k,n,t,o){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,t=t|0,o=o|0;var s=0,w=0,h=0,_=0,B=0,m=0,X=0,Q=0,V=0,F=0,I=0,E=0,R=0,N=0,M=0,z=0,S=0,O=0,P=0,a=0,$=0,f0=0;n=v-128|0,v=n,t=p(172),e=t,i[e+4>>2]=0,i[e+8>>2]=0,i[e>>2]=94812,o0(e+16|0,0,80),k=i[e+4>>2],w=k+1|0,i[e+4>>2]=w,i[e+104>>2]=0,i[e+108>>2]=0,i[e+36>>2]=1,i[e+40>>2]=1,u[e+24|0]=1,g[e+22>>1]=2,g[e+18>>1]=2,g[e+20>>1]=2,i[e+112>>2]=0,i[e+116>>2]=4740,i[e+140>>2]=0,i[e+144>>2]=0,i[e+128>>2]=99,i[e+132>>2]=99,i[e+120>>2]=0,i[e+124>>2]=0,i[e+12>>2]=95160,i[e+148>>2]=0,i[e+152>>2]=0,f=e+140|0,i[e+136>>2]=f,i[e+156>>2]=0,i[e+160>>2]=0,i[e+164>>2]=0,i[e+168>>2]=0,i[e+4>>2]=k,k=i[e+8>>2],V=e+12|0,i[e+96>>2]=V,i[e+8>>2]=k+1,i[e+100>>2]=e,w||(W[i[i[e>>2]+8>>2]](e),y(e)),k=i[r>>2],F=i[k+108>>2],e=F,m=i[k+112>>2],k=m,i[V+120>>2]=1,i[V+116>>2]=0,i[V+112>>2]=k,i[V+108>>2]=e,X=j0(i[r>>2],0),T0(n+56|0,V,0,e,k,X,o),w=e+1|0,Q=w>>>1|0,E=k+1|0,R=E>>>1|0,T0(n+32|0,V,1,Q,R,X,o),e=n+88|0;i:{if(i[n+56>>2]){if(k=i[n+60>>2],i[n+80>>2]=i[n+56>>2],i[n+84>>2]=k,u[n+75|0]>=0){k=n- -64|0,h=i[k+4>>2],i[e>>2]=i[k>>2],i[e+4>>2]=h,i[e+8>>2]=i[k+8>>2];break i}T(e,i[n+64>>2],i[n+68>>2]);break i}if(k=i[n+36>>2],i[n+80>>2]=i[n+32>>2],i[n+84>>2]=k,u[n+51|0]>=0){k=i[n+44>>2],i[e>>2]=i[n+40>>2],i[e+4>>2]=k,i[e+8>>2]=i[n+48>>2];break i}T(e,i[n+40>>2],i[n+44>>2])}T0(n+8|0,V,2,Q,R,X,o),k=n+112|0;i:{if(i[n+80>>2]){if(h=i[n+84>>2],i[n+104>>2]=i[n+80>>2],i[n+108>>2]=h,u[n+99|0]>=0){h=i[e+4>>2],i[k>>2]=i[e>>2],i[k+4>>2]=h,i[k+8>>2]=i[e+8>>2];break i}T(k,i[n+88>>2],i[n+92>>2]);break i}if(e=i[n+12>>2],i[n+104>>2]=i[n+8>>2],i[n+108>>2]=e,u[n+27|0]>=0){e=i[n+20>>2],i[k>>2]=i[n+16>>2],i[k+4>>2]=e,i[k+8>>2]=i[n+24>>2];break i}T(k,i[n+16>>2],i[n+20>>2])}u[n+27|0]<0&&Z(i[n+16>>2]),u[n+99|0]<0&&Z(i[n+88>>2]),u[n+51|0]<0&&Z(i[n+40>>2]),u[n+75|0]<0&&Z(i[n+64>>2]);i:{e:{if(i[n+104>>2]){if(e=i[n+108>>2],i[A>>2]=i[n+104>>2],i[A+4>>2]=e,e=A+8|0,u[n+123|0]>=0){r=i[k+4>>2],i[e>>2]=i[k>>2],i[e+4>>2]=r,i[e+8>>2]=i[k+8>>2],u[A+20|0]=1;break e}if(T(e,i[n+112>>2],i[n+116>>2]),e=u[n+123|0],u[A+20|0]=1,(e|0)>=0)break e;Z(i[n+112>>2]);break e}if(u[n+123|0]<0&&Z(i[n+112>>2]),M=u1(i[r>>2],6),M){if(e=j0(i[r>>2],6),T0(n+104|0,V,6,F,m,e,o),i[n+104>>2]){if(e=i[n+108>>2],i[A>>2]=i[n+104>>2],i[A+4>>2]=e,e=A+8|0,u[n+123|0]>=0){r=i[n+116>>2],i[e>>2]=i[n+112>>2],i[e+4>>2]=r,i[e+8>>2]=i[n+120>>2],u[A+20|0]=1;break e}if(T(e,i[n+112>>2],i[n+116>>2]),e=u[n+123|0],u[A+20|0]=1,(e|0)>=0)break e;Z(i[n+112>>2]);break e}u[n+123|0]<0&&Z(i[n+112>>2]),z=e>>>0>8}e=i[r>>2],k=e+128|0,o=i[e+128>>2];r:{f:{A:{if(X>>>0<=8){if(w=0,!o)break A;for(e=k;h=i[o+16>>2],e=(h|0)<0?e:o,o=i[(h>>>29&4)+o>>2],!!o;);if((e|0)==(k|0))break A;if(h=0,i[e+16>>2]>0)break f;B=i[e+44>>2],h=i[e+56>>2];break f}k:{n:{if(!o)break n;for(e=k;h=i[o+16>>2],e=(h|0)<0?e:o,o=i[(h>>>29&4)+o>>2],!!o;);if((e|0)==(k|0))break n;if(h=0,i[e+16>>2]>0)break k;I=i[e+44>>2],h=i[e+56>>2]>>>1|0;break k}h=0}k:{n:{if(o=i[f>>2],o){for(k=f,e=o;_=i[e+16>>2],k=(_|0)<0?k:e,e=i[(_>>>29&4)+e>>2],!!e;);_=0;t:{if((f|0)==(k|0)||(_=0,i[k+16>>2]>0))break t;S=i[k+56>>2],_=i[k+44>>2]}for(k=f,e=o;s=i[e+16>>2]<=0,k=s?k:e,e=i[(s?4:0)+e>>2],!!e;);s=0;t:{if((f|0)==(k|0)||(s=0,i[k+16>>2]>1))break t;O=i[k+44>>2],s=i[k+56>>2]}for(e=f;k=i[o+16>>2]<2,e=k?e:o,o=i[(k?4:0)+o>>2],!!o;);if((e|0)!=(f|0))break n}k=0;break k}if(k=0,i[e+16>>2]>2)break k;P=i[e+56>>2]>>>1|0,k=i[e+44>>2]}k:{if(E>>>0>=2){if(w>>>0<2)break k;for(a=s>>>1|0,o=128<<X-8,$=Q&2147483644,E=Q&3,w=0,f0=Q-1>>>0<3;;){if(B=(G(w,P)<<1)+k|0,X=(G(w,a)<<1)+O|0,e=0,Q=0,!f0)for(;s=e<<1,g[s+X>>1]=o,g[s+B>>1]=o,N=s|2,g[N+X>>1]=o,g[B+N>>1]=o,N=s|4,g[N+X>>1]=o,g[B+N>>1]=o,s=s|6,g[s+X>>1]=o,g[s+B>>1]=o,e=e+4|0,Q=Q+4|0,($|0)!=(Q|0););if(s=0,E)for(;Q=e<<1,g[Q+X>>1]=o,g[B+Q>>1]=o,e=e+1|0,s=s+1|0,(E|0)!=(s|0););if(w=w+1|0,(R|0)==(w|0))break}}if(!m)break r}if(s=S>>>1|0,e=F<<1,o=0,(m|0)!=1)for(w=m&-2,k=0;B=!e,B||x((G(o,s)<<1)+_|0,(G(o,h)<<1)+I|0,e),B||(B=o|1,x((G(B,s)<<1)+_|0,(G(B,h)<<1)+I|0,e)),o=o+2|0,k=k+2|0,(w|0)!=(k|0););if(!(m&1)|!e)break r;x((G(o,s)<<1)+_|0,(G(o,h)<<1)+I|0,e);break r}h=0}f:{A:{if(o=i[f>>2],o){for(k=f,e=o;_=i[e+16>>2],k=(_|0)<0?k:e,e=i[(_>>>29&4)+e>>2],!!e;);_=0;k:{if((f|0)==(k|0)||(_=0,i[k+16>>2]>0))break k;I=i[k+44>>2],_=i[k+56>>2]}for(k=f,e=o;w=i[e+16>>2]<=0,k=w?k:e,e=i[(w?4:0)+e>>2],!!e;);w=0;k:{if((f|0)==(k|0)||(w=0,i[k+16>>2]>1))break k;s=i[k+56>>2],w=i[k+44>>2]}for(e=f;k=i[o+16>>2]<2,e=k?e:o,o=i[(k?4:0)+o>>2],!!o;);if((e|0)!=(f|0))break A}o=0,k=0;break f}if(o=0,k=0,i[e+16>>2]>2)break f;o=i[e+56>>2],k=i[e+44>>2]}if(e=1<<X-1,s=G(s,R),s&&o0(w,e,s),o=G(o,R),o&&o0(k,e,o),!m)break r;if(o=0,(m|0)!=1)for(k=m&-2,e=0;s=!F,s||x(G(o,_)+I|0,G(o,h)+B|0,F),s||(s=o|1,x(G(s,_)+I|0,G(s,h)+B|0,F)),o=o+2|0,e=e+2|0,(k|0)!=(e|0););if(!(m&1)|!F)break r;x(G(o,_)+I|0,G(o,h)+B|0,F)}r:{if(!M)break r;s=0;f:{A:{if(e=i[r>>2],o=i[e+128>>2],!o)break A;for(r=e+128|0,e=r;k=i[o+16>>2]<6,e=k?e:o,o=i[(k?4:0)+o>>2],!!o;);if((e|0)==(r|0))break A;if(B=0,k=0,i[e+16>>2]>6)break f;B=i[e+44>>2],k=i[e+56>>2];break f}B=0,k=0}o=i[f>>2],r=0;f:{if(!o)break f;for(e=f;r=i[o+16>>2]<6,e=r?e:o,o=i[(r?4:0)+o>>2],!!o;);if(r=0,(e|0)==(f|0)||(r=0,i[e+16>>2]>6))break f;s=i[e+56>>2],r=i[e+44>>2]}if(!m)break r;if(e=k,f=F<<z,o=0,(m|0)!=1)for(_=m&-2,k=0;w=!f,w||x(r+G(o,s)|0,G(e,o)+B|0,f),w||(w=o|1,x(r+G(w,s)|0,G(e,w)+B|0,f)),o=o+2|0,k=k+2|0,(_|0)!=(k|0););if(!(m&1)|!f)break r;x(r+G(o,s)|0,G(e,o)+B|0,f)}u[A+20|0]=0,i[A+4>>2]=t,i[A>>2]=V;break i}if(A=i[t+4>>2],i[t+4>>2]=A-1,A)break i;W[i[i[t>>2]+8>>2]](t),y(t)}v=n+128|0}function WB(A,e,r,f,k,n,t,o){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,t=t|0,o=o|0;var s=0,w=0,h=0,_=0,B=0,m=0,X=0,Q=0,V=0,F=0,I=0,E=0,R=0,N=0,M=0,z=0,S=0,O=0,P=0,a=0,$=0,f0=0,A0=0,n0=0,_0=0,m0=0,X0=0,g0=0,I0=0,e0=0,r0=0,N0=0,U0=0;s=v-128|0,v=s,k=j0(i[r>>2],0),n=j0(i[r>>2],1),t=j0(i[r>>2],2),a=u1(i[r>>2],6),a&&(m0=j0(i[r>>2],6));i:{if(!(!(k>>>0>8|n>>>0>8)&t>>>0<9)){e=i[26922],i[A>>2]=i[26921],i[A+4>>2]=e,e=A+8|0;e:{if(u[107703]>=0){r=i[26924],i[e>>2]=i[26923],i[e+4>>2]=r,i[e+8>>2]=i[26925];break e}T(e,i[26923],i[26924])}u[A+20|0]=1;break i}if(!((k|0)==(n|0)&(k|0)==(t|0))){e=i[26922],i[A>>2]=i[26921],i[A+4>>2]=e,e=A+8|0;e:{if(u[107703]>=0){r=i[26924],i[e>>2]=i[26923],i[e+4>>2]=r,i[e+8>>2]=i[26925];break e}T(e,i[26923],i[26924])}u[A+20|0]=1;break i}e=i[r>>2],_=i[e+112>>2],h=i[e+108>>2],V=p(172),i[V>>2]=94812,e=V,i[e+4>>2]=0,i[e+8>>2]=0,o0(e+16|0,0,80),B=i[e+4>>2],w=B+1|0,i[e+4>>2]=w,i[e+104>>2]=0,i[e+108>>2]=0,i[e+36>>2]=1,i[e+40>>2]=1,u[e+24|0]=1,g[e+22>>1]=2,g[e+18>>1]=2,g[e+20>>1]=2,i[e+112>>2]=0,i[e+116>>2]=4740,i[e+140>>2]=0,i[e+144>>2]=0,i[e+128>>2]=99,i[e+132>>2]=99,i[e+120>>2]=0,i[e+124>>2]=0,i[e+12>>2]=95160,i[e+148>>2]=0,i[e+152>>2]=0,f=e+140|0,i[e+136>>2]=f,i[e+156>>2]=0,i[e+160>>2]=0,i[e+164>>2]=0,i[e+168>>2]=0,i[e+4>>2]=B,B=i[e+8>>2],m=e+12|0,i[e+96>>2]=m,i[e+8>>2]=B+1,i[e+100>>2]=e,w||(W[i[i[e>>2]+8>>2]](e),y(e)),i[m+120>>2]=1,i[m+116>>2]=0,i[m+112>>2]=_,i[m+108>>2]=h,T0(s+56|0,m,0,h,_,k,o),F=h+1>>>1|0,R=_+1>>>1|0,T0(s+32|0,m,1,F,R,n,o),e=s+88|0;e:{if(i[s+56>>2]){if(k=i[s+60>>2],i[s+80>>2]=i[s+56>>2],i[s+84>>2]=k,u[s+75|0]>=0){k=s- -64|0,n=i[k+4>>2],i[e>>2]=i[k>>2],i[e+4>>2]=n,i[e+8>>2]=i[k+8>>2];break e}T(e,i[s+64>>2],i[s+68>>2]);break e}if(k=i[s+36>>2],i[s+80>>2]=i[s+32>>2],i[s+84>>2]=k,u[s+51|0]>=0){k=i[s+44>>2],i[e>>2]=i[s+40>>2],i[e+4>>2]=k,i[e+8>>2]=i[s+48>>2];break e}T(e,i[s+40>>2],i[s+44>>2])}T0(s+8|0,m,2,F,R,t,o),k=s+112|0;e:{if(i[s+80>>2]){if(n=i[s+84>>2],i[s+104>>2]=i[s+80>>2],i[s+108>>2]=n,u[s+99|0]>=0){n=i[e+4>>2],i[k>>2]=i[e>>2],i[k+4>>2]=n,i[k+8>>2]=i[e+8>>2];break e}T(k,i[s+88>>2],i[s+92>>2]);break e}if(e=i[s+12>>2],i[s+104>>2]=i[s+8>>2],i[s+108>>2]=e,u[s+27|0]>=0){e=i[s+20>>2],i[k>>2]=i[s+16>>2],i[k+4>>2]=e,i[k+8>>2]=i[s+24>>2];break e}T(k,i[s+16>>2],i[s+20>>2])}u[s+27|0]<0&&Z(i[s+16>>2]),u[s+99|0]<0&&Z(i[s+88>>2]),u[s+51|0]<0&&Z(i[s+40>>2]),u[s+75|0]<0&&Z(i[s+64>>2]);e:{if(i[s+104>>2]){if(e=i[s+108>>2],i[A>>2]=i[s+104>>2],i[A+4>>2]=e,e=A+8|0,u[s+123|0]>=0){r=i[k+4>>2],i[e>>2]=i[k>>2],i[e+4>>2]=r,i[e+8>>2]=i[k+8>>2],u[A+20|0]=1;break e}if(T(e,i[s+112>>2],i[s+116>>2]),e=u[s+123|0],u[A+20|0]=1,(e|0)>=0)break e;Z(i[s+112>>2]);break e}u[s+123|0]<0&&Z(i[s+112>>2]);r:{if(!a)break r;if(T0(s+104|0,m,6,h,_,m0,o),i[s+104>>2]){if(e=i[s+108>>2],i[A>>2]=i[s+104>>2],i[A+4>>2]=e,e=A+8|0,u[s+123|0]>=0){r=i[s+116>>2],i[e>>2]=i[s+112>>2],i[e+4>>2]=r,i[e+8>>2]=i[s+120>>2],u[A+20|0]=1;break e}if(T(e,i[s+112>>2],i[s+116>>2]),e=u[s+123|0],u[A+20|0]=1,(e|0)>=0)break e;Z(i[s+112>>2]);break e}if(u[s+123|0]>=0)break r;Z(i[s+112>>2])}e=i[r>>2],k=e+128|0;r:{f:{t=i[e+128>>2];A:{if(!t){o=0;break A}for(e=k,r=t;n=i[r+16>>2],e=(n|0)<0?e:r,r=i[(n>>>29&4)+r>>2],!!r;);M=0;k:{if((e|0)==(k|0)||(M=0,i[e+16>>2]>0))break k;e0=i[e+44>>2],M=i[e+56>>2]}for(e=k,r=t;n=i[r+16>>2]<=0,e=n?e:r,r=i[(n?4:0)+r>>2],!!r;);k:{if((e|0)==(k|0)){o=0;break k}if(o=0,i[e+16>>2]>1)break k;z=i[e+44>>2],o=i[e+56>>2]}for(e=k,r=t;n=i[r+16>>2]<2,e=n?e:r,r=i[(n?4:0)+r>>2],!!r;);if((e|0)!=(k|0))break f}r=0;break r}if(r=0,i[e+16>>2]>2)break r;N=i[e+56>>2],r=i[e+44>>2]}B=r;r:{f:{if(e=i[f>>2],e){for(n=f,r=e;w=i[r+16>>2],n=(w|0)<0?n:r,r=i[(w>>>29&4)+r>>2],!!r;);S=0;A:{if((f|0)==(n|0)||(S=0,i[n+16>>2]>0))break A;r0=i[n+44>>2],S=i[n+56>>2]}for(n=f,r=e;w=i[r+16>>2]<=0,n=w?n:r,r=i[(w?4:0)+r>>2],!!r;);I=0;A:{if((f|0)==(n|0)||(I=0,i[n+16>>2]>1))break A;$=i[n+56>>2],I=i[n+44>>2]}for(n=f,r=e;w=i[r+16>>2]<2,n=w?n:r,r=i[(w?4:0)+r>>2],!!r;);if((f|0)!=(n|0))break f}E=0;break r}if(E=0,i[n+16>>2]>2)break r;f0=i[n+56>>2],E=i[n+44>>2]}n=0,w=0;r:{if(!a)break r;f:{A:{if(!t)break A;for(r=k;w=i[t+16>>2]<6,r=w?r:t,t=i[(w?4:0)+t>>2],!!t;);if((r|0)==(k|0))break A;if(A0=0,i[r+16>>2]>6)break f;N0=i[r+44>>2],A0=i[r+56>>2];break f}A0=0}if(w=0,!e)break r;for(r=f;k=i[e+16>>2]<6,r=k?r:e,e=i[(k?4:0)+e>>2],!!e;);if(w=0,(r|0)==(f|0)||(w=0,i[r+16>>2]>6))break r;n=i[r+56>>2],w=i[r+44>>2]}r:{f:{A:{k:{if(t=_&1,t){if(e=h-1|0,!e)break k;for(r=R-1|0,f=G(r,f0)+E|0,k=_-1|0,O=G(k,N)+B|0,P=G(r,$)+I|0,k=G(k,o)+z|0,r=0;X=r>>>1|0,Q=r+k|0,u[X+P|0]=(l[Q|0]+l[Q+1|0]|0)+1>>>1,_0=f+X|0,X=r+O|0,u[_0|0]=(l[X|0]+l[X+1|0]|0)+1>>>1,r=r+2|0,e>>>0>r>>>0;);}if(h&1)break k;e=_-1|0;break A}if(e=_-1|0,e){for(O=(F+E|0)-1|0,f=(h+B|0)-1|0,P=(F+I|0)-1|0,k=(h+z|0)-1|0,r=0;X=r>>>1|0,Q=r|1,u[P+G(X,$)|0]=(l[k+G(r,o)|0]+l[k+G(Q,o)|0]|0)+1>>>1,u[O+G(X,f0)|0]=(l[f+G(r,N)|0]+l[f+G(Q,N)|0]|0)+1>>>1,r=r+2|0,r>>>0<e>>>0;);if(!t)break f}r=R-1|0,u[(F+(G(r,$)+I|0)|0)-1|0]=l[((G(e,o)+z|0)+h|0)-1|0],u[(F+(G(r,f0)+E|0)|0)-1|0]=l[((G(e,N)+B|0)+h|0)-1|0]}if(!e)break r}if(k=h-1|0,!k)break r;for(f=0;;){for(t=G(f,N)+B|0,F=G(f,o)+z|0,r=f>>>1|0,R=G(r,f0)+E|0,O=G(r,$)+I|0,r=f|1,P=G(r,N)+B|0,X=G(r,o)+z|0,r=0;Q=r+P|0,U0=l[Q+1|0],Q=l[Q|0],n0=r+t|0,_0=l[n0+1|0],n0=l[n0|0],X0=r>>>1|0,g0=r+X|0,I0=r+F|0,u[O+X0|0]=((l[g0|0]+(l[I0|0]+l[I0+1|0]|0)|0)+l[g0+1|0]|0)+2>>>2,u[R+X0|0]=((Q+(n0+_0|0)|0)+U0|0)+2>>>2,r=r+2|0,k>>>0>r>>>0;);if(f=f+2|0,!(f>>>0<e>>>0))break}}if(_)for(e=h<<(m0>>>0>8),r=0;h&&x(G(r,S)+r0|0,G(r,M)+e0|0,h),!a|!e||x(w+G(r,n)|0,G(r,A0)+N0|0,e),r=r+1|0,(_|0)!=(r|0););u[A+20|0]=0,i[A+4>>2]=V,i[A>>2]=m;break i}if(A=i[V+4>>2],i[V+4>>2]=A-1,A)break i;W[i[i[V>>2]+8>>2]](V),y(V)}v=s+128|0}function QB(A,e,r,f,k,n,t,o,s){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,t=t|0,o=o|0,s=s|0;var w=0,h=0,_=0,B=0,m=0,X=0,Q=0,V=0,F=0,I=0;m=v-48|0,v=m,h=v-96|0,v=h,A=i[A>>2],w=i[A+48>>2],X=i[A+52>>2],X&&(i[X+4>>2]=i[X+4>>2]+1),_=m+12|0;i:{if(!r){r=v-48|0,v=r,B=i[A+48>>2],Q=i[A+52>>2],Q&&(i[Q+4>>2]=i[Q+4>>2]+1),w=v-32|0,v=w,i[w+28>>2]=0,i[w+20>>2]=0,i[w+24>>2]=0,j1(w,B,e,w+20|0);e:{if(i[w>>2]){i[r+40>>2]=0,i[r+44>>2]=0;break e}r:{if(B=i[w+20>>2],A=i[w+24>>2],(B|0)!=(A|0)){if(e=i[B>>2],e&&(V=i[r+44>>2],e=W0(e,86580,88052),e))break r;if(B=B+8|0,(A|0)!=(B|0))for(;;){if(e=i[B>>2],e&&(V=0,e=W0(e,86580,88052),e))break r;if(B=B+8|0,(A|0)==(B|0))break}i[r+40>>2]=0,i[r+44>>2]=0}i[r+40>>2]=0,i[r+44>>2]=0;break e}if(i[r+44>>2]=V,i[r+40>>2]=e,A=i[B+4>>2],i[r+44>>2]=A,!A)break e;i[A+4>>2]=i[A+4>>2]+1}if(u[w+19|0]<0&&Z(i[w+8>>2]),A=i[w+20>>2],A){if(B=i[w+24>>2],e=A,(B|0)!=(A|0)){for(;;){e=i[B-4>>2];e:{if(!e||(V=i[e+4>>2],i[e+4>>2]=V-1,V))break e;W[i[i[e>>2]+8>>2]](e),y(e)}if(B=B-8|0,(A|0)==(B|0))break}e=i[w+20>>2]}i[w+24>>2]=A,Z(e)}v=w+32|0,A=i[r+40>>2];e:{if(!A){A=p(32),i[r+4>>2]=A,i[r+8>>2]=26,i[r+12>>2]=-2147483616,e=l[9611]|l[9612]<<8,u[A+24|0]=e,u[A+25|0]=e>>>8,e=l[9607]|l[9608]<<8|(l[9609]<<16|l[9610]<<24),w=l[9603]|l[9604]<<8|(l[9605]<<16|l[9606]<<24),u[A+16|0]=w,u[A+17|0]=w>>>8,u[A+18|0]=w>>>16,u[A+19|0]=w>>>24,u[A+20|0]=e,u[A+21|0]=e>>>8,u[A+22|0]=e>>>16,u[A+23|0]=e>>>24,e=l[9599]|l[9600]<<8|(l[9601]<<16|l[9602]<<24),w=l[9595]|l[9596]<<8|(l[9597]<<16|l[9598]<<24),u[A+8|0]=w,u[A+9|0]=w>>>8,u[A+10|0]=w>>>16,u[A+11|0]=w>>>24,u[A+12|0]=e,u[A+13|0]=e>>>8,u[A+14|0]=e>>>16,u[A+15|0]=e>>>24,e=l[9591]|l[9592]<<8|(l[9593]<<16|l[9594]<<24),w=l[9587]|l[9588]<<8|(l[9589]<<16|l[9590]<<24),u[A|0]=w,u[A+1|0]=w>>>8,u[A+2|0]=w>>>16,u[A+3|0]=w>>>24,u[A+4|0]=e,u[A+5|0]=e>>>8,u[A+6|0]=e>>>16,u[A+7|0]=e>>>24,u[A+26|0]=0,A=q(r+16|0,2,116,r+4|0),e=i[A+4>>2],i[_>>2]=i[A>>2],i[_+4>>2]=e,e=_+8|0;r:{if(u[A+19|0]>=0){w=i[A+12>>2],i[e>>2]=i[A+8>>2],i[e+4>>2]=w,i[e+8>>2]=i[A+16>>2],u[_+20|0]=1;break r}if(T(e,i[A+8>>2],i[A+12>>2]),e=u[A+19|0],u[_+20|0]=1,(e|0)>=0)break r;Z(i[A+8>>2])}if(u[r+15|0]<0&&Z(i[r+4>>2]),A=i[r+44>>2],!A||(e=i[A+4>>2],i[A+4>>2]=e-1,e))break e;W[i[i[A>>2]+8>>2]](A),y(A);break e}e=i[r+44>>2],u[_+20|0]=0,i[_+4>>2]=e,i[_>>2]=A}e:{if(!Q||(A=i[Q+4>>2],i[Q+4>>2]=A-1,A))break e;W[i[i[Q>>2]+8>>2]](Q),y(Q)}v=r+48|0;break i}i[h+92>>2]=0,i[h+84>>2]=0,i[h+88>>2]=0,j1(h- -64|0,w,e,h+84|0);e:{if(i[h+64>>2]){A=i[h+68>>2],i[_>>2]=i[h+64>>2],i[_+4>>2]=A,A=_+8|0;r:{if(u[h+83|0]>=0){e=i[h+76>>2],i[A>>2]=i[h+72>>2],i[A+4>>2]=e,i[A+8>>2]=i[h+80>>2];break r}T(A,i[h+72>>2],i[h+76>>2])}u[_+20|0]=1;break e}w=r-1|0,r=i[h+84>>2],w>>>0>=i[h+88>>2]-r>>3>>>0&&(A=p(32),i[h+24>>2]=A,i[h+28>>2]=27,i[h+32>>2]=-2147483616,e=l[13922]|l[13923]<<8|(l[13924]<<16|l[13925]<<24),r=l[13918]|l[13919]<<8|(l[13920]<<16|l[13921]<<24),u[A|0]=r,u[A+1|0]=r>>>8,u[A+2|0]=r>>>16,u[A+3|0]=r>>>24,u[A+4|0]=e,u[A+5|0]=e>>>8,u[A+6|0]=e>>>16,u[A+7|0]=e>>>24,u[A+27|0]=0,e=l[13941]|l[13942]<<8|(l[13943]<<16|l[13944]<<24),u[A+23|0]=e,u[A+24|0]=e>>>8,u[A+25|0]=e>>>16,u[A+26|0]=e>>>24,e=l[13938]|l[13939]<<8|(l[13940]<<16|l[13941]<<24),r=l[13934]|l[13935]<<8|(l[13936]<<16|l[13937]<<24),u[A+16|0]=r,u[A+17|0]=r>>>8,u[A+18|0]=r>>>16,u[A+19|0]=r>>>24,u[A+20|0]=e,u[A+21|0]=e>>>8,u[A+22|0]=e>>>16,u[A+23|0]=e>>>24,e=l[13930]|l[13931]<<8|(l[13932]<<16|l[13933]<<24),r=l[13926]|l[13927]<<8|(l[13928]<<16|l[13929]<<24),u[A+8|0]=r,u[A+9|0]=r>>>8,u[A+10|0]=r>>>16,u[A+11|0]=r>>>24,u[A+12|0]=e,u[A+13|0]=e>>>8,u[A+14|0]=e>>>16,u[A+15|0]=e>>>24,A=q(h+44|0,5,2007,h+24|0),u[A+19|0]<0&&Z(i[A+8>>2]),u[h+35|0]<0&&Z(i[h+24>>2]),r=i[h+84>>2]),e=r+(w<<3)|0,A=i[e>>2],e=i[e+4>>2],e&&(i[e+4>>2]=i[e+4>>2]+1);r:{f:{if(!A||(A=W0(A,86580,88052),!A))break f;e&&(i[e+4>>2]=i[e+4>>2]+1),u[_+20|0]=0,i[_+4>>2]=e,i[_>>2]=A;break r}A=p(24),i[h+12>>2]=A,i[h+16>>2]=19,i[h+20>>2]=-2147483624,r=l[12730]|l[12731]<<8|(l[12732]<<16|l[12733]<<24),u[A+15|0]=r,u[A+16|0]=r>>>8,u[A+17|0]=r>>>16,u[A+18|0]=r>>>24,r=l[12727]|l[12728]<<8|(l[12729]<<16|l[12730]<<24),w=l[12723]|l[12724]<<8|(l[12725]<<16|l[12726]<<24),u[A+8|0]=w,u[A+9|0]=w>>>8,u[A+10|0]=w>>>16,u[A+11|0]=w>>>24,u[A+12|0]=r,u[A+13|0]=r>>>8,u[A+14|0]=r>>>16,u[A+15|0]=r>>>24,r=l[12719]|l[12720]<<8|(l[12721]<<16|l[12722]<<24),w=l[12715]|l[12716]<<8|(l[12717]<<16|l[12718]<<24),u[A|0]=w,u[A+1|0]=w>>>8,u[A+2|0]=w>>>16,u[A+3|0]=w>>>24,u[A+4|0]=r,u[A+5|0]=r>>>8,u[A+6|0]=r>>>16,u[A+7|0]=r>>>24,u[A+19|0]=0,A=q(h+24|0,5,2007,h+12|0),r=i[A+4>>2],i[_>>2]=i[A>>2],i[_+4>>2]=r,r=_+8|0;f:{if(u[A+19|0]>=0){w=i[A+12>>2],i[r>>2]=i[A+8>>2],i[r+4>>2]=w,i[r+8>>2]=i[A+16>>2],u[_+20|0]=1;break f}if(T(r,i[A+8>>2],i[A+12>>2]),r=u[A+19|0],u[_+20|0]=1,(r|0)>=0)break f;Z(i[A+8>>2])}if(u[h+23|0]>=0)break r;Z(i[h+12>>2])}if(!e||(A=i[e+4>>2],i[e+4>>2]=A-1,A))break e;W[i[i[e>>2]+8>>2]](e),y(e)}if(u[h+83|0]<0&&Z(i[h+72>>2]),A=i[h+84>>2],!A)break i;if(r=i[h+88>>2],e=A,(r|0)!=(A|0)){for(;;){e=i[r-4>>2];e:{if(!e||(_=i[e+4>>2],i[e+4>>2]=_-1,_))break e;W[i[i[e>>2]+8>>2]](e),y(e)}if(r=r-8|0,(A|0)==(r|0))break}e=i[h+84>>2]}i[h+88>>2]=A,Z(e)}i:{if(!X||(A=i[X+4>>2],i[X+4>>2]=A-1,A))break i;W[i[i[X>>2]+8>>2]](X),y(X)}v=h+96|0;i:{A=l[m+32|0];e:{r:{f:{if(A)break f;A:{k:{n:{t:{u:{o:{l:{if(n){if(F=n,I=$i(i[m+12>>2],f),i[F>>2]=I,A=l[m+32|0],!o)break o;if(!A)break l;break i}if(!o)break u}F=o,I=(bf(i[m+12>>2],f)^-1)+f|0,i[F>>2]=I,A=l[m+32|0]}if(!t)break n;if(A&255)break i;break t}if(!t)break k}F=t,I=qi(i[m+12>>2],k),i[F>>2]=I,A=l[m+32|0]}if(!s)break f;if(A&255)break i;break A}if(s)break A;A=0;break r}F=s,I=(cf(i[m+12>>2],k)^-1)+k|0,i[F>>2]=I,A=l[m+32|0]}if((A&255)==255)break e}e=i[24179],i[m+40>>2]=i[24178],i[m+44>>2]=e,W[i[(m+40|0)+((A&255)<<2)>>2]](m+39|0,m+12|0)}v=m+48|0;return}_2(),H()}function M8(A,e,r,f,k){var n=0,t=0,o=0,s=0,w=0,h=0,_=0,B=0,m=0,X=0,Q=0,V=0,F=0,I=0,E=0,R=0,N=0,M=0,z=0,S=0,O=0,P=0,a=0,$=0,f0=0,A0=0,n0=0,_0=0,m0=0,X0=0,g0=0,I0=0,e0=0,r0=0,N0=0,U0=0,M0=0,H0=0;w=v-160|0,v=w;i:{e:{if(B=i[A+18588>>2],t=i[B+168>>2],s=e>>t,(s|0)<0||(n=i[B+172>>2],(n|0)<=(s|0)))break e;if(t=r>>t,(t|0)<0|(t|0)>=i[B+176>>2])break i;P=i[B+132>>2],N=i[B+124>>2],h=l[((i[B+160>>2]+G(s,3)|0)+G(G(n,t),3)|0)+1|0];r:{if(k||(s=i[B+248>>2],n=f-s|0,(n|0)==31))break r;for(t=r>>s,n=1<<n,X=t+n|0,s=e>>s,o=s+n|0;;){for(n=s;m=(i[B+240>>2]+n|0)+G(i[B+252>>2],t)|0,u[m|0]=l[m|0]|128,n=n+1|0,(o|0)>(n|0););if(t=t+1|0,!((X|0)>(t|0)))break}}A0=h&3,n=A+k|0,a=n,t=0;r:{if(!l[P+25|0]||(t=0,l[A+32|0])||(t=0,i[P+8276>>2]<(f|0)))break r;t=v2(A+18548|0,i[A+18572>>2]+(k?142:141)|0)}u[n+33|0]=t,u[A+36|0]=0;r:{if(!(l[n+33|0]|l[A+32|0])|(!l[N+16823|0]|(A0|0)!=1)||(s=A+18548|0,t=(k|0)!=0,n=v2(s,(t+i[A+18572>>2]|0)+143|0),u[A+36|0]=n,!(n&255)))break r;M0=A,H0=v2(s,(t+i[A+18572>>2]|0)+145|0),u[M0+37|0]=H0}m=k?0:2,m=l[a+33|0]|l[A+32|0]?m|1:m,h=f<<1;r:{if(!k){o=f+1>>2,n=(G(f,3)+(f-1>>2)|0)-6|0;break r}o=f-2|0,n=15}_=i[A+18572>>2],t=h-1|0;r:{if((h|0)<2){n=t;break r}X=n+(_+25|0)|0,s=A+18548|0,n=0;f:{for(;;){if(!v2(s,X+(n>>>o|0)|0))break f;if(n=n+1|0,(t|0)==(n|0))break}n=t}_=i[A+18572>>2]}r:{if(!k){o=(G(f,3)+(f-1>>2)|0)-6|0,s=f+1>>2;break r}o=15,s=f-2|0}r:{if((h|0)<2)break r;for(h=o+(_+43|0)|0,X=A+18548|0,o=0;;){if(!v2(X,h+(o>>>s|0)|0)){t=o;break r}if(o=o+1|0,(o|0)==(t|0))break}}(n|0)>=4&&(s=(n>>>1|0)-1|0,n=F8(A+18548|0,s)+((n&1|2)<<s)|0),(t|0)>=4&&(s=(t>>>1|0)-1|0,t=F8(A+18548|0,s)+((t&1|2)<<s)|0);r:{f:{if(A0){o=0;break f}A:{if(!k){if(o=i[B+208>>2],X=e>>o,(X|0)<0||(s=i[B+212>>2],(s|0)<=(X|0)))break e;if(o=r>>o,(o|0)<0|(o|0)>=i[B+216>>2])break i;s=l[(X+i[B+200>>2]|0)+G(o,s)|0],_=s>>>0<=34?s:0,s=0;break A}if(o=i[B+228>>2],X=e>>o,(X|0)<0||(s=i[B+232>>2],(s|0)<=(X|0)))break e;if(o=r>>o,(o|0)<0|(o|0)>=i[B+236>>2])break i;_=l[(X+i[B+220>>2]|0)+G(o,s)|0]&63,s=k}o=2,X=s,s=0;A:{k:{n:switch(f-2|0){case 0:break k;case 1:break n;default:break A}if(!X)break k;if(i[N+16848>>2]!=3)break A}if(s=2,_-6>>>0<9)break A;s=_-22>>>0<9}if((s|0)!=2){o=s;break f}s=t;break r}s=n,n=t}for(R=f-2|0,t=R,o>>>0<=2?X=i[i[(o<<2)+63096>>2]+(t<<2)>>2]:X=0,g0=o>>>0<=2?i[i[(o<<2)+63096>>2]+8>>2]:0,n=(i[(G(o,24)+(f<<2)|0)+63024>>2]+(n<<f<<1)|0)+(s<<1)|0,n=l[n|0]|l[n+1|0]<<8,u[w+158|0]=n,u[w+159|0]=n>>>8,S=l[w+158|0],I0=l[w+159|0],n=1<<R<<R,n&&o0(w+80|0,0,n),O=((k<<1)+A|0)+14396|0,g[O>>1]=0,s=k?43:42,I=A+18548|0,$=(A+m|0)+18580|0,e0=I0-1|0,r0=R<<6|((k|0)!=0)<<5|((o|0)!=0)<<4,n=k<<11,N0=n+(A+2108|0)|0,U0=n+(A+8252|0)|0,E=1,n=S;;){t=(n<<1)+X|0,o=l[t+1|0],h=l[t|0],M=n;r:{f:{if(!(!n|n>>>0>=S>>>0)){if(n=l[w+80+(h+(o<<R))|0],n=n&1|n>>>1,m=1,v2(I,(i[A+18572>>2]+(k?n+2|0:n)|0)+61|0))break f;break r}if((M|0)!=(S|0)&&M)break r;m=0}if(h&&(n=(h+(o<<R)|0)+w|0,u[n+79|0]=l[n+79|0]|1),_=0,t=0,o&&(n=w+80+(h+(o-1<<R))|0,u[n|0]=l[n|0]|2,t=o),n=((l[w+80+(h+(t<<R))|0]<<2)+r0|0)+125008|0,(M|0)==(S|0)&&(u[w|0]=1,g[w+48>>1]=1,u[w+32|0]=I0,_=1),f0=i[n>>2],n0=t<<2,_0=h<<2,t=(M|0)!=(S|0)?15:e0,(t|0)>0)for(Q=f0+_0|0,n=t;;){o=(n<<1)+g0|0,V=l[o+1|0],h=l[o|0],z=i[A+18572>>2];f:{if(l[N+16821|0]&&(o=s,l[A+32|0]|l[a+33|0]))break f;o=l[(h+Q|0)+(V+n0<<f)|0]}if(v2(I,(z+(o&255)|0)+65|0)&&(u[w+_|0]=1,u[(w+32|0)+_|0]=n,g[(w+48|0)+(_<<1)>>1]=1,_=_+1|0,m=0),o=(n|0)>1,n=n-1|0,!o)break}f:{if((t|0)<0)break f;if(!m){t=i[A+18572>>2];A:{if(l[N+16821|0]&&(n=s,l[A+32|0]|l[a+33|0]))break A;n=l[(f0+_0|0)+(n0<<f)|0]}if(!v2(I,(t+(n&255)|0)+65|0))break f}u[w+_|0]=1,u[(w+32|0)+_|0]=0,g[(w+48|0)+(_<<1)>>1]=1,_=_+1|0}if(!_)break r;m=1;f:{if((_|0)<=0)break f;n=!E,E=(k|0)>0,Q=n|(E?0:M?2:0),n=Q<<2,V=E?n|16:n,F=v2(I,(V+i[A+18572>>2]|0)+110|0);A:{if(F){g[w+48>>1]=C[w+48>>1]+1,m=0,t=0;break A}u[w|0]=0,m=2,t=-1}if(o=1,(_|0)!=1)for(h=(_|0)>=8?8:_,n=1;;){n=(n|0)>0?(F|0)!=1?n+1|0:0:n,F=v2(I,(V+(i[A+18572>>2]+((n|0)>=3?3:n)|0)|0)+109|0);A:{if(F){m=(w+48|0)+(o<<1)|0,g[m>>1]=C[m>>1]+1,t=(t|0)==-1?o:t,m=0;break A}u[o+w|0]=0,m=(m-1>>>0<2)+m|0}if(o=o+1|0,(h|0)==(o|0))break}if((t|0)==-1)break f;o=v2(I,(i[A+18572>>2]+(E?Q|4:Q)|0)+133|0),u[t+w|0]=o,n=(w+48|0)+(t<<1)|0,g[n>>1]=o+C[n>>1]}f:{if(!k){if(t=i[B+208>>2],o=e>>t,(o|0)<0||(n=i[B+212>>2],(n|0)<=(o|0)))break e;if(t=r>>t,(t|0)<0|(t|0)>=i[B+216>>2])break i;n=l[(o+i[B+200>>2]|0)+G(n,t)|0],t=n>>>0<=34?n:0;break f}if(t=i[B+228>>2],o=e>>t,(o|0)<0||(n=i[B+232>>2],(n|0)<=(o|0)))break e;if(t=r>>t,(t|0)<0|(t|0)>=i[B+236>>2])break i;t=l[(o+i[B+220>>2]|0)+G(n,t)|0]&63}n=0,V=0;f:{if(l[A+32|0]||!(!l[N+16822|0]|A0|(t&239)!=10)&&(V=0,l[a+33|0])||(V=0,l[A+36|0]))break f;V=(u[w+32|0]-u[(w+_|0)+31|0]|0)>3}if(m0=_-1|0,(_|0)>1)for(;M0=(w+16|0)+n|0,H0=k4(I),u[M0|0]=H0,n=n+1|0,(m0|0)!=(n|0););if(o=0,t=m0+(w+16|0)|0,V&l[P+15|0]!=0?n=0:n=k4(I),u[t|0]=n,o=l[N+16827|0]?l[$|0]>>>2|0:o,E=1,F=0,X0=0,(_|0)>0)for(;;){t=g[(w+48|0)+(F<<1)>>1],n=-1;f:{if(!l[w+F|0]){n=0;break f}Q=3<<o;A:{for(;;){if(f0=k4(I),h=n,z=0,(n|0)==64)break A;if(n=n+1|0,!f0)break}if((h|0)<=2){z=F8(I,o)+(n<<o)|0;break A}n=h-2|0,z=F8(I,n+o|0)+((1<<n)+2<<o)|0}n=z,h=t+n|0;A:{if(!l[N+16827|0]){if((h|0)<=(Q|0))break A;o=((o|0)>=3?3:o)+1|0;break A}if(o=((h|0)>(Q|0))+o|0,!(E&1))break A;if(Q=l[$|0],h=Q>>>2|0,3<<h<=(n|0)){u[$|0]=Q+1;break A}if(!Q|n<<1>=1<<h)break A;u[$|0]=Q-1}E=0}if(n=n+t|0,n=l[(w+16|0)+F|0]?0-n|0:n,t=(u[(w+32|0)+F|0]<<1)+g0|0,Q=l[t+1|0],h=l[t|0],t=(g[O>>1]<<1)+N0|0,V&l[P+15|0]!=0&&(X0=(n&65535)+X0|0,n=(F|0)!=(m0|0)?n:X0&1?0-n|0:n),g[t>>1]=n,g[(g[O>>1]<<1)+U0>>1]=(h+_0|0)+(Q+n0<<f),g[O>>1]=C[O>>1]+1,F=F+1|0,(F|0)==(_|0))break}E=m}if(n=M-1|0,!((M|0)>0))break}v=w+160|0;return}D0(4656,10893,118,4231),H()}D0(4618,10893,119,4231),H()}function gB(A,e,r,f,k,n,t,o){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,t=t|0,o=o|0;var s=0,w=0,h=0,_=0,B=0,m=0,X=0,Q=0,V=0,F=0,I=0,E=0,R=0,N=0,M=0,z=0,S=0,O=0,P=0,a=0,$=0,f0=0,A0=0,n0=0,_0=0,m0=0,X0=0,g0=0;s=v-128|0,v=s,k=j0(i[r>>2],0),n=j0(i[r>>2],1),t=j0(i[r>>2],2),z=u1(i[r>>2],6),z&&(a=j0(i[r>>2],6));i:{if(!(!(k>>>0>8|n>>>0>8)&t>>>0<9)){e=i[26922],i[A>>2]=i[26921],i[A+4>>2]=e,e=A+8|0;e:{if(u[107703]>=0){r=i[26924],i[e>>2]=i[26923],i[e+4>>2]=r,i[e+8>>2]=i[26925];break e}T(e,i[26923],i[26924])}u[A+20|0]=1;break i}if(!((k|0)==(n|0)&(k|0)==(t|0))){e=i[26922],i[A>>2]=i[26921],i[A+4>>2]=e,e=A+8|0;e:{if(u[107703]>=0){r=i[26924],i[e>>2]=i[26923],i[e+4>>2]=r,i[e+8>>2]=i[26925];break e}T(e,i[26923],i[26924])}u[A+20|0]=1;break i}e=i[r>>2],_=i[e+112>>2],B=i[e+108>>2],I=p(172),i[I>>2]=94812,e=I,i[e+4>>2]=0,i[e+8>>2]=0,o0(e+16|0,0,80),m=i[e+4>>2],h=m+1|0,i[e+4>>2]=h,i[e+104>>2]=0,i[e+108>>2]=0,i[e+36>>2]=1,i[e+40>>2]=1,u[e+24|0]=1,g[e+22>>1]=2,g[e+18>>1]=2,g[e+20>>1]=2,i[e+112>>2]=0,i[e+116>>2]=4740,i[e+140>>2]=0,i[e+144>>2]=0,i[e+128>>2]=99,i[e+132>>2]=99,i[e+120>>2]=0,i[e+124>>2]=0,i[e+12>>2]=95160,i[e+148>>2]=0,i[e+152>>2]=0,f=e+140|0,i[e+136>>2]=f,i[e+156>>2]=0,i[e+160>>2]=0,i[e+164>>2]=0,i[e+168>>2]=0,i[e+4>>2]=m,m=i[e+8>>2],V=e+12|0,i[e+96>>2]=V,i[e+8>>2]=m+1,i[e+100>>2]=e,h||(W[i[i[e>>2]+8>>2]](e),y(e)),i[V+120>>2]=3,i[V+116>>2]=0,i[V+112>>2]=_,i[V+108>>2]=B,T0(s+56|0,V,0,B,_,k,o),T0(s+32|0,V,1,B,_,n,o),e=s+88|0;e:{if(i[s+56>>2]){if(k=i[s+60>>2],i[s+80>>2]=i[s+56>>2],i[s+84>>2]=k,u[s+75|0]>=0){k=s- -64|0,n=i[k+4>>2],i[e>>2]=i[k>>2],i[e+4>>2]=n,i[e+8>>2]=i[k+8>>2];break e}T(e,i[s+64>>2],i[s+68>>2]);break e}if(k=i[s+36>>2],i[s+80>>2]=i[s+32>>2],i[s+84>>2]=k,u[s+51|0]>=0){k=i[s+44>>2],i[e>>2]=i[s+40>>2],i[e+4>>2]=k,i[e+8>>2]=i[s+48>>2];break e}T(e,i[s+40>>2],i[s+44>>2])}T0(s+8|0,V,2,B,_,t,o),k=s+112|0;e:{if(i[s+80>>2]){if(n=i[s+84>>2],i[s+104>>2]=i[s+80>>2],i[s+108>>2]=n,u[s+99|0]>=0){n=i[e+4>>2],i[k>>2]=i[e>>2],i[k+4>>2]=n,i[k+8>>2]=i[e+8>>2];break e}T(k,i[s+88>>2],i[s+92>>2]);break e}if(e=i[s+12>>2],i[s+104>>2]=i[s+8>>2],i[s+108>>2]=e,u[s+27|0]>=0){e=i[s+20>>2],i[k>>2]=i[s+16>>2],i[k+4>>2]=e,i[k+8>>2]=i[s+24>>2];break e}T(k,i[s+16>>2],i[s+20>>2])}u[s+27|0]<0&&Z(i[s+16>>2]),u[s+99|0]<0&&Z(i[s+88>>2]),u[s+51|0]<0&&Z(i[s+40>>2]),u[s+75|0]<0&&Z(i[s+64>>2]);e:{if(i[s+104>>2]){if(e=i[s+108>>2],i[A>>2]=i[s+104>>2],i[A+4>>2]=e,e=A+8|0,u[s+123|0]>=0){r=i[k+4>>2],i[e>>2]=i[k>>2],i[e+4>>2]=r,i[e+8>>2]=i[k+8>>2],u[A+20|0]=1;break e}if(T(e,i[s+112>>2],i[s+116>>2]),e=u[s+123|0],u[A+20|0]=1,(e|0)>=0)break e;Z(i[s+112>>2]);break e}u[s+123|0]<0&&Z(i[s+112>>2]);r:{if(!z)break r;if(T0(s+104|0,V,6,B,_,a,o),i[s+104>>2]){if(e=i[s+108>>2],i[A>>2]=i[s+104>>2],i[A+4>>2]=e,e=A+8|0,u[s+123|0]>=0){r=i[s+116>>2],i[e>>2]=i[s+112>>2],i[e+4>>2]=r,i[e+8>>2]=i[s+120>>2],u[A+20|0]=1;break e}if(T(e,i[s+112>>2],i[s+116>>2]),e=u[s+123|0],u[A+20|0]=1,(e|0)>=0)break e;Z(i[s+112>>2]);break e}if(u[s+123|0]>=0)break r;Z(i[s+112>>2])}e=i[r>>2],k=e+128|0;r:{f:{t=i[e+128>>2];A:{if(!t){o=0;break A}for(e=k,r=t;n=i[r+16>>2],e=(n|0)<0?e:r,r=i[(n>>>29&4)+r>>2],!!r;);r=0;k:{if((e|0)==(k|0)||(r=0,i[e+16>>2]>0))break k;A0=i[e+44>>2],r=i[e+56>>2]}for(n0=r,e=k,r=t;n=i[r+16>>2]<=0,e=n?e:r,r=i[(n?4:0)+r>>2],!!r;);o=0;k:{if((e|0)==(k|0)||(o=0,i[e+16>>2]>1))break k;N=i[e+44>>2],o=i[e+56>>2]}for(e=k,r=t;n=i[r+16>>2]<2,e=n?e:r,r=i[(n?4:0)+r>>2],!!r;);if((e|0)!=(k|0))break f}m=0;break r}if(m=0,i[e+16>>2]>2)break r;E=i[e+56>>2],m=i[e+44>>2]}r:{f:{if(e=i[f>>2],e){for(n=f,r=e;w=i[r+16>>2],n=(w|0)<0?n:r,r=i[(w>>>29&4)+r>>2],!!r;);r=0;A:{if((f|0)==(n|0)||(r=0,i[n+16>>2]>0))break A;_0=i[n+44>>2],r=i[n+56>>2]}for(m0=r,n=f,r=e;w=i[r+16>>2]<=0,n=w?n:r,r=i[(w?4:0)+r>>2],!!r;);w=0;A:{if((f|0)==(n|0)||(w=0,i[n+16>>2]>1))break A;M=i[n+44>>2],w=i[n+56>>2]}for(n=f,r=e;h=i[r+16>>2]<2,n=h?n:r,r=i[(h?4:0)+r>>2],!!r;);if((f|0)!=(n|0))break f}h=0;break r}if(h=0,i[n+16>>2]>2)break r;R=i[n+56>>2],h=i[n+44>>2]}n=0,X=0;r:{if(!z)break r;f:{A:{if(!t)break A;for(r=k;X=i[t+16>>2]<6,r=X?r:t,t=i[(X?4:0)+t>>2],!!t;);if((r|0)==(k|0))break A;if(k=0,i[r+16>>2]>6)break f;X0=i[r+44>>2],k=i[r+56>>2];break f}k=0}if(g0=k,X=0,!e)break r;for(r=f;k=i[e+16>>2]<6,r=k?r:e,e=i[(k?4:0)+e>>2],!!e;);if(X=0,(r|0)==(f|0)||(X=0,i[r+16>>2]>6))break r;n=i[r+56>>2],X=i[r+44>>2]}if(_){k=_&1,F=_-1|0;r:{if(!F){r=0;break r}for(t=_&-2,r=0,e=0;u[G(r,w)+M|0]=l[G(r,o)+N|0],u[G(r,R)+h|0]=l[G(r,E)+m|0],f=r|1,u[G(f,w)+M|0]=l[G(f,o)+N|0],u[G(f,R)+h|0]=l[G(f,E)+m|0],r=r+2|0,e=e+2|0,(t|0)!=(e|0););}k&&(u[G(r,w)+M|0]=l[G(r,o)+N|0],u[G(r,R)+h|0]=l[G(r,E)+m|0]);r:{if(B&1)break r;O=_&1,e=(B+h|0)-1|0,f=(B+M|0)-1|0,r=B>>>1|0,k=(r+m|0)-1|0,t=(r+N|0)-1|0;f:{if(!F){r=0;break f}for(P=_&-2,r=0;u[f+G(r,w)|0]=l[t+G(r,o)|0],u[e+G(r,R)|0]=l[k+G(r,E)|0],F=r|1,u[f+G(F,w)|0]=l[t+G(o,F)|0],u[e+G(R,F)|0]=l[k+G(E,F)|0],r=r+2|0,S=S+2|0,(P|0)!=(S|0););}if(!O)break r;u[f+G(r,w)|0]=l[t+G(r,o)|0],u[e+G(r,R)|0]=l[k+G(r,E)|0]}if(t=B-1|0,t>>>0>=2)for(e=0;;){for(F=G(e,R)+h|0,O=G(e,w)+M|0,P=G(e,E)+m|0,S=G(e,o)+N|0,r=1;Q=r>>>1|0,k=Q+P|0,f=l[k|0],k=l[k+1|0],$=r+O|0,Q=Q+S|0,f0=l[Q|0],Q=l[Q+1|0],u[$|0]=(G(f0,3)+Q|0)+2>>>2,u[$+1|0]=(G(Q,3)+f0|0)+2>>>2,Q=r+F|0,u[Q+1|0]=(f+G(k,3)|0)+2>>>2,u[Q|0]=(k+G(f,3)|0)+2>>>2,r=r+2|0,t>>>0>r>>>0;);if(e=e+1|0,(_|0)==(e|0))break}for(e=B<<(a>>>0>8),r=0;B&&x(G(r,m0)+_0|0,G(r,n0)+A0|0,B),!z|!e||x(G(r,n)+X|0,G(r,g0)+X0|0,e),r=r+1|0,(_|0)!=(r|0););}u[A+20|0]=0,i[A+4>>2]=I,i[A>>2]=V;break i}if(A=i[I+4>>2],i[I+4>>2]=A-1,A)break i;W[i[i[I>>2]+8>>2]](I),y(I)}v=s+128|0}function L7(A,e,r,f,k,n,t,o,s,w,h){var _=0,B=0,m=0,X=0,Q=0,V=0,F=0,I=0,E=0,R=0,N=0;_=v-528|0,v=_,i[_+520>>2]=h,i[_+524>>2]=e;i:{if(K2(A,_+524|0)){i[n>>2]=i[n>>2]|4,A=0;break i}i[_+72>>2]=2072,V=_+72|0,I=Q1(_+104|0,_+112|0,V),e=i[I>>2],i[_+100>>2]=e,i[_+96>>2]=e+400,e=v-16|0,v=e,i[V>>2]=0,i[V+4>>2]=0,i[V+8>>2]=0,v=e+16|0,e=v-16|0,v=e,X=_+60|0,i[X>>2]=0,i[X+4>>2]=0,i[X+8>>2]=0,v=e+16|0,e=v-16|0,v=e,m=_+48|0,i[m>>2]=0,i[m+4>>2]=0,i[m+8>>2]=0,v=e+16|0,e=v-16|0,v=e,B=_+36|0,i[B>>2]=0,i[B+4>>2]=0,i[B+8>>2]=0,v=e+16|0,e=v-16|0,v=e,Q=_+24|0,i[Q>>2]=0,i[Q+4>>2]=0,i[Q+8>>2]=0,v=e+16|0,F=v-16|0,v=F;e:{if(r){h=F+4|0,r=c0(f,129512),W[i[i[r>>2]+44>>2]](h,r);break e}h=F+4|0,r=c0(f,129504),W[i[i[r>>2]+44>>2]](h,r)}for(e=i[F+4>>2],u[_+92|0]=e,u[_+93|0]=e>>>8,u[_+94|0]=e>>>16,u[_+95|0]=e>>>24,W[i[i[r>>2]+32>>2]](h,r),me(B,h),R1(h),W[i[i[r>>2]+28>>2]](h,r),me(m,h),R1(h),R=_,N=W[i[i[r>>2]+12>>2]](r)|0,i[R+88>>2]=N,R=_,N=W[i[i[r>>2]+16>>2]](r)|0,i[R+84>>2]=N,W[i[i[r>>2]+20>>2]](h,r),K8(V,h),s2(h),W[i[i[r>>2]+24>>2]](h,r),me(X,h),R1(h),R=_,N=W[i[i[r>>2]+36>>2]](r)|0,i[R+20>>2]=N,v=F+16|0,i[w>>2]=i[s>>2],E=k&512,f=0,e=0;;){r=e;e:{r:{f:{A:{if((f|0)==4||K2(A,_+524|0))break A;h=0;k:{n:{t:{u:{o:switch(l[(_+92|0)+f|0]){case 1:if((f|0)==3)break r;k=i[A>>2],e=i[k+12>>2];l:{if((e|0)==i[k+16>>2]){e=W[i[i[k>>2]+36>>2]](k)|0;break l}e=i[e>>2]}if(W[i[i[o>>2]+12>>2]](o,1,e)|0){ls(_+12|0,A),BA(Q,i[_+12>>2]);break u}i[n>>2]=i[n>>2]|4,A=0;break f;case 0:break o;case 2:break n;case 3:break t;case 4:break k;default:break e}if((f|0)==3)break r}for(;;){if(K2(A,_+524|0))break r;k=i[A>>2],e=i[k+12>>2];u:{if((e|0)==i[k+16>>2]){e=W[i[i[k>>2]+36>>2]](k)|0;break u}e=i[e>>2]}if(!(W[i[i[o>>2]+12>>2]](o,1,e)|0))break r;ls(_+12|0,A),BA(Q,i[_+12>>2])}}t:{if(l[m+11|0]>>>7|0?e=i[m+4>>2]:e=l[m+11|0]&127,!e)break t;k=i[A>>2],e=i[k+12>>2];u:{if((e|0)==i[k+16>>2]){e=W[i[i[k>>2]+36>>2]](k)|0;break u}e=i[e>>2]}if(l[m+11|0]>>>7|0?k=i[m>>2]:k=m,(e|0)!=i[k>>2])break t;a1(A),u[t|0]=0,l[m+11|0]>>>7|0?e=i[m+4>>2]:e=l[m+11|0]&127,e=e>>>0>1?m:r;break e}t:{if(l[B+11|0]>>>7|0?e=i[B+4>>2]:e=l[B+11|0]&127,!e)break t;k=i[A>>2],e=i[k+12>>2];u:{if((e|0)==i[k+16>>2]){e=W[i[i[k>>2]+36>>2]](k)|0;break u}e=i[e>>2]}if(l[B+11|0]>>>7|0?k=i[B>>2]:k=B,(e|0)!=i[k>>2])break t;a1(A),u[t|0]=1,l[B+11|0]>>>7|0?e=i[B+4>>2]:e=l[B+11|0]&127,e=e>>>0>1?B:r;break e}if(l[m+11|0]>>>7|0?e=i[m+4>>2]:e=l[m+11|0]&127,e=!e,l[B+11|0]>>>7|0?k=i[B+4>>2]:k=l[B+11|0]&127,!(e|!k)){i[n>>2]=i[n>>2]|4,A=0;break f}if(l[m+11|0]>>>7|0?e=i[m+4>>2]:e=l[m+11|0]&127,!e&&(l[B+11|0]>>>7|0?e=i[B+4>>2]:e=l[B+11|0]&127,!e))break r;l[B+11|0]>>>7|0?e=i[B+4>>2]:e=l[B+11|0]&127,u[t|0]=!e;break r}if(!(E|(f>>>0<2|r))&&(e=0,!((f|0)==2&l[_+95|0]!=0)))break e;R=_,N=T4(X),i[R+8>>2]=N,i[_+12>>2]=i[_+8>>2];n:{if(!f|l[(f+_|0)+91|0]>1)break n;for(;;){t:{if(R=_,N=s6(X),i[R+8>>2]=N,e=i[_+12>>2],(e|0)==i[_+8>>2]||!(W[i[i[o>>2]+12>>2]](o,1,i[e>>2])|0))break t;i[_+12>>2]=i[_+12>>2]+4;continue}break}if(R=_,N=T4(X),i[R+8>>2]=N,l[Q+11|0]>>>7|0?h=i[Q+4>>2]:h=l[Q+11|0]&127,k=_+8|0,e=i[_+12>>2]-i[k>>2]>>2,h>>>0>=e>>>0&&(R=_,N=s6(Q),i[R+8>>2]=N,F=n5(k,0-e|0),e=s6(Q),h=T4(X),k=v-16|0,v=k,F=h6(F),e=h6(e),e=N2(F,h6(h),e-F&-4),v=k+16|0,!e))break n;R=_,N=T4(X),i[R+4>>2]=N,i[_+8>>2]=i[_+4>>2],i[_+12>>2]=i[_+8>>2]}for(i[_+8>>2]=i[_+12>>2];;){n:{if(R=_,N=s6(X),i[R+4>>2]=N,i[_+8>>2]==i[_+4>>2]||K2(A,_+524|0))break n;k=i[A>>2],e=i[k+12>>2];t:{if((e|0)==i[k+16>>2]){e=W[i[i[k>>2]+36>>2]](k)|0;break t}e=i[e>>2]}if((e|0)!=i[i[_+8>>2]>>2])break n;a1(A),i[_+8>>2]=i[_+8>>2]+4;continue}break}if(!E||(R=_,N=s6(X),i[R+4>>2]=N,i[_+8>>2]==i[_+4>>2]))break r;i[n>>2]=i[n>>2]|4,A=0;break f}for(;;){k:{if(K2(A,_+524|0))break k;k=i[A>>2],e=i[k+12>>2];n:{if((e|0)==i[k+16>>2]){e=W[i[i[k>>2]+36>>2]](k)|0;break n}e=i[e>>2]}n:{if(W[i[i[o>>2]+12>>2]](o,64,e)|0){k=i[w>>2],(k|0)==i[_+520>>2]&&(si(s,w,_+520|0),k=i[w>>2]),i[w>>2]=k+4,i[k>>2]=e,h=h+1|0;break n}if(l[V+11|0]>>>7|0?k=i[V+4>>2]:k=l[V+11|0]&127,!k|!h|(e|0)!=i[_+84>>2])break k;e=i[_+100>>2],(e|0)==i[_+96>>2]&&(si(I,_+100|0,_+96|0),e=i[_+100>>2]),i[_+100>>2]=e+4,i[e>>2]=h,h=0}a1(A);continue}break}e=i[_+100>>2],!h|(e|0)==i[I>>2]||(i[_+96>>2]==(e|0)&&(si(I,_+100|0,_+96|0),e=i[_+100>>2]),i[_+100>>2]=e+4,i[e>>2]=h);k:{if(i[_+20>>2]<=0)break k;n:{if(!K2(A,_+524|0)){k=i[A>>2],e=i[k+12>>2];t:{if((e|0)==i[k+16>>2]){e=W[i[i[k>>2]+36>>2]](k)|0;break t}e=i[e>>2]}if((e|0)==i[_+88>>2])break n}i[n>>2]=i[n>>2]|4,A=0;break f}for(;;){if(a1(A),i[_+20>>2]<=0)break k;n:{if(!K2(A,_+524|0)){k=i[A>>2],e=i[k+12>>2];t:{if((e|0)==i[k+16>>2]){e=W[i[i[k>>2]+36>>2]](k)|0;break t}e=i[e>>2]}if(W[i[i[o>>2]+12>>2]](o,64,e)|0)break n}i[n>>2]=i[n>>2]|4,A=0;break f}i[w>>2]==i[_+520>>2]&&si(s,w,_+520|0),k=i[A>>2],e=i[k+12>>2];n:{if((e|0)==i[k+16>>2]){k=W[i[i[k>>2]+36>>2]](k)|0;break n}k=i[e>>2]}e=i[w>>2],i[w>>2]=e+4,i[e>>2]=k,i[_+20>>2]=i[_+20>>2]-1}}if(e=r,i[s>>2]!=i[w>>2])break e;i[n>>2]=i[n>>2]|4,A=0;break f}A:{if(!r)break A;for(h=1;;){if(l[r+11|0]>>>7|0?e=i[r+4>>2]:e=l[r+11|0]&127,e>>>0<=h>>>0)break A;k:{if(!K2(A,_+524|0)){f=i[A>>2],e=i[f+12>>2];n:{if((e|0)==i[f+16>>2]){e=W[i[i[f>>2]+36>>2]](f)|0;break n}e=i[e>>2]}if(l[r+11|0]>>>7|0?f=i[r>>2]:f=r,(e|0)==i[f+(h<<2)>>2])break k}i[n>>2]=i[n>>2]|4,A=0;break f}a1(A),h=h+1|0}}if(A=1,i[I>>2]==i[_+100>>2])break f;if(A=0,i[_+12>>2]=0,l4(V,i[I>>2],i[_+100>>2],_+12|0),i[_+12>>2]){i[n>>2]=i[n>>2]|4;break f}A=1}R1(Q),R1(B),R1(m),R1(X),s2(V),e=i[I>>2],i[I>>2]=0,e&&W[i[I+4>>2]](e);break i}e=r}f=f+1|0}}return v=_+528|0,A}function mf(A,e,r,f,k){var n=0,t=0,o=0,s=0,w=0,h=0,_=0,B=0,m=0,X=0,Q=0,V=0,F=0,I=0,E=0,R=0,N=0,M=0,z=0,S=0,O=0,P=0,a=0,$=0,f0=0,A0=0,n0=0,_0=0,m0=0,X0=0,g0=0,I0=0,e0=0,r0=0,N0=0,U0=0,M0=0,H0=0,P0=0,K0=0,$0=0,L0=0,d0=0,n2=0,Z2=0,Q2=0,g2=0,p2=0,H2=0,T2=0,b2=0,e1=0,X1=0;t=v-32|0,v=t;i:{e:{n=i[A+276>>2],n2=(f|0)<(n|0)?f:n;r:{if((n2|0)<=(r|0)||(f=i[A+272>>2],Z2=(f|0)>(k|0)?k:f,(Z2|0)<=0))break r;for(H2=e?1:2,T2=e?2:1,w=i[A+40>>2],b2=w<<1,Q2=i[A+124>>2],f=i[Q2+16832>>2],g2=f-8|0,E=-1<<f^-1,e1=e?3:2,e0=G(w,-3),r0=0-w|0,N0=G(w,3),P=w<<1,U0=0-P|0,K0=0-(w<<2)|0;;){for(P0=r<<2,p2=P0-1|0,X1=P0>>2,d0=0,$0=0;;){Q=$0<<2,B=l[(i[A+260>>2]+(Q>>2)|0)+G(i[A+272>>2],X1)|0]&3;f:{if(!B)break f;f=G(i[A+40>>2],P0),k=i[A+4>>2],s=f+(k+Q|0)|0;A:{if(!e){u[t+16|0]=l[s|0],f=l[s+r0|0],u[t|0]=f,u[t+17|0]=l[s+w|0],X=l[s+U0|0],u[t+1|0]=X,u[t+18|0]=l[s+P|0],a=l[s+e0|0],u[t+2|0]=a,u[t+19|0]=l[s+N0|0],O=l[s+K0|0],u[t+3|0]=O,k=s+1|0,u[t+20|0]=l[k|0],u[t+4|0]=l[k+r0|0],u[t+21|0]=l[k+w|0],u[t+5|0]=l[k+U0|0],u[t+22|0]=l[k+P|0],u[t+6|0]=l[k+e0|0],u[t+23|0]=l[k+N0|0],u[t+7|0]=l[k+K0|0],k=s+2|0,u[t+24|0]=l[k|0],u[t+8|0]=l[k+r0|0],u[t+25|0]=l[k+w|0],u[t+9|0]=l[k+U0|0],u[t+26|0]=l[k+P|0],u[t+10|0]=l[k+e0|0],u[t+27|0]=l[k+N0|0],u[t+11|0]=l[k+K0|0],n=s+3|0,u[t+28|0]=l[n|0],_=l[n+r0|0],u[t+12|0]=_,u[t+29|0]=l[n+w|0],k=l[n+U0|0],u[t+13|0]=k,u[t+30|0]=l[n+P|0],R=l[n+e0|0],u[t+14|0]=R,u[t+31|0]=l[n+N0|0],n=n+K0|0;break A}n=k+(f+(d0<<e1)|0)|0,i[t+16>>2]=l[n|0]|l[n+1|0]<<8|(l[n+2|0]<<16|l[n+3|0]<<24),f=l[s-1|0],u[t|0]=f,X=l[s-2|0],u[t+1|0]=X,a=l[s-3|0],u[t+2|0]=a,O=l[s-4|0],u[t+3|0]=O,k=n+w|0,i[t+20>>2]=l[k|0]|l[k+1|0]<<8|(l[k+2|0]<<16|l[k+3|0]<<24),k=s+w|0,u[t+4|0]=l[k-1|0],u[t+5|0]=l[k-2|0],u[t+6|0]=l[k-3|0],u[t+7|0]=l[k-4|0],k=n+P|0,i[t+24>>2]=l[k|0]|l[k+1|0]<<8|(l[k+2|0]<<16|l[k+3|0]<<24),k=s+P|0,u[t+8|0]=l[k-1|0],u[t+9|0]=l[k-2|0],u[t+10|0]=l[k-3|0],u[t+11|0]=l[k-4|0],k=n+N0|0,i[t+28>>2]=l[k|0]|l[k+1|0]<<8|(l[k+2|0]<<16|l[k+3|0]<<24),n=s+N0|0,_=l[n-1|0],u[t+12|0]=_,k=l[n-2|0],u[t+13|0]=k,R=l[n-3|0],u[t+14|0]=R,n=n-4|0}if(L0=l[n|0],u[t+15|0]=L0,V=i[A+168>>2],o=Q>>V,(o|0)<0||(m=i[A+172>>2],(m|0)<=(o|0)))break i;if(n=P0>>V,(n|0)<0||(I=i[A+176>>2],(I|0)<=(n|0)))break e;N=i[A+160>>2],z=N+G(o,3)|0,S=G(G(n,m),3),$=z+S|0,M0=u[$+2|0];A:{if(!e){if(n=p2>>V,(n|0)<0|(n|0)>=(I|0))break e;A0=(z+G(G(n,m),3)|0)+2|0;break A}if(n=Q-1>>V,(n|0)<0|n>>>0>=m>>>0)break i;A0=(S+(N+G(n,3)|0)|0)+2|0}if(n=i[A+148>>2],n0=Q>>n,(n0|0)<0||(_0=i[A+152>>2],(_0|0)<=(n0|0)))break i;if(F=P0>>n,(F|0)<0|(F|0)>=i[A+156>>2])break e;if(m0=l[t+28|0],h=m0+(l[t+30|0]-(l[t+29|0]<<1)|0)|0,X0=h>>31,_=_&255,o=_+(R-((k&255)<<1)|0)|0,g0=o>>31,H0=l[t+16|0],n=H0+(l[t+18|0]-(l[t+17|0]<<1)|0)|0,I0=n>>31,k=(a-(X<<1)|0)+f|0,R=k>>31,a=(h^X0)-X0|0,X0=(o^g0)-g0|0,g0=a+X0|0,I0=(n^I0)-I0|0,R=(k^R)-R|0,h=I0+R|0,n=(M0+u[A0|0]|0)+1>>1,o=i[i[A+52>>2]+(C[((i[A+140>>2]+G(n0,24)|0)+G(G(F,_0),24)|0)+2>>1]<<2)>>2],k=n+i[o+764>>2]|0,k=(k|0)>=51?51:k,F=l[((k|0)>0?k:0)+60704|0]<<g2,(g0+h|0)>=(F|0))break f;k=(i[o+768>>2]+(n+(B<<1)|0)|0)-2|0,k=(k|0)>=53?53:k,f0=l[((k|0)>0?k:0)+60768|0]<<g2,X=0,n=h<<1,h=F>>>2|0,k=0;A:{if(n>>>0>=h>>>0||(o=H0-l[t+19|0]|0,M0=o>>31,n=O-f|0,_0=n>>31,k=0,(o^M0)-M0+((n^_0)-_0)>>>0>=F>>>3>>>0))break A;f=f-H0|0,k=f>>31,k=((f^k)-k|0)<G(f0,5)+1>>1}f=k;A:{if(h>>>0<=g0<<1>>>0||(n=m0-l[t+31|0]|0,h=n>>31,k=L0-_|0,o=k>>31,(n^h)-h+((k^o)-o)>>>0>=F>>>3>>>0))break A;k=_-m0|0,n=k>>31,X=((k^n)-n|0)<G(f0,5)+1>>1}o=l[Q2+8812|0];A:{if(!e){if(n=p2>>V,o){if((n|0)<0|(n|0)>=(I|0))break e;k=!(l[(z+G(G(n,m),3)|0)+1|0]&4)}else k=1;if((n|0)<0|(n|0)>=(I|0))break e;n=z+G(G(n,m),3)|0;break A}if(n=Q-1>>V,o){if((n|0)<0|n>>>0>=m>>>0)break i;k=!(l[(S+(N+G(n,3)|0)|0)+1|0]&4)}else k=1;if((n|0)<0|n>>>0>=m>>>0)break i;n=S+(N+G(n,3)|0)|0}for(L0=f&X,N=!(l[n+1|0]&8)&k,f=F+(F>>>1|0)>>>3|0,M0=N&f>>>0>R+X0>>>0,k=f>>>0>a+I0>>>0,f=l[$|0]|l[$+1|0]<<8,I=!(f&2048)&(!o|!(f&1024)),_0=k&I,M=f0<<1,f=0,H0=0-f0|0,a=G(f0,10),X0=s+1|0,g0=s+w|0,I0=s-2|0,R=s-1|0,O=f0>>1,$=0-O|0;;){k=f<<2,A0=k+t|0,m=l[A0+1|0],_=k+(t+16|0)|0,z=l[_+2|0],Q=l[_+1|0],X=l[_|0],S=l[A0+2|0],V=l[A0|0];A:{if(!L0){if(n=(G(X-V|0,9)+G(Q-m|0,-3)|0)+8>>4,k=n>>31,(a|0)<=((k^n)-k|0))break A;n=(n|0)<(H0|0)?H0:(n|0)<(f0|0)?n:f0;k:{n:{if(!e){if(N&&(k=n+V|0,u[s+(f-w|0)|0]=(k|0)>=0?(k|0)<(E|0)?k:E:0),!I)break k;k=X-n|0,_=(k|0)>=0?(k|0)<(E|0)?k:E:0,k=f;break n}if(N&&(k=n+V|0,u[R+G(f,w)|0]=(k|0)>=0?(k|0)<(E|0)?k:E:0),!I)break k;k=X-n|0,_=(k|0)>=0?(k|0)<(E|0)?k:E:0,k=G(f,w)}u[k+s|0]=_}k:{if(!M0)break k;if(k=n+(((V+S|0)+1>>>1|0)-m|0)>>1,k=((k|0)<($|0)?$:(k|0)<(O|0)?k:O)+m|0,k=(k|0)>=0?(k|0)<(E|0)?k:E:0,!e){u[s+(f-b2|0)|0]=k;break k}u[I0+G(f,w)|0]=k}if(!_0)break A;if(k=((X+z|0)+1>>>1)-(n+Q)>>1,k=Q+((k|0)<($|0)?$:(k|0)<(O|0)?k:O)|0,k=(k|0)>=0?(k|0)<(E|0)?k:E:0,!e){u[f+g0|0]=k;break A}u[X0+G(f,w)|0]=k;break A}if(n=Q-M|0,o=X+V|0,h=o+Q|0,B=(h+z|0)+2>>>2|0,k=Q+M|0,n0=(n|0)>(B|0)?n:(k|0)>(B|0)?B:k,n=m-M|0,o=o+m|0,B=(o+S|0)+2>>>2|0,k=m+M|0,F=(n|0)>(B|0)?n:(k|0)>(B|0)?B:k,n=z-M|0,h=((h+G(z,3)|0)+(l[_+3|0]<<1)|0)+4>>>3|0,k=M+z|0,m0=(n|0)>(h|0)?n:(k|0)>(h|0)?h:k,n=S-M|0,o=((o+G(S,3)|0)+(l[A0+3|0]<<1)|0)+4>>>3|0,k=M+S|0,_=(n|0)>(o|0)?n:(k|0)>(o|0)?o:k,n=X-M|0,o=X<<1,h=(V<<1)+4|0,B=z+((o+(h+m|0)|0)+(Q<<1)|0)>>>3|0,k=X+M|0,B=(n|0)>(B|0)?n:(k|0)>(B|0)?B:k,n=V-M|0,o=Q+(o+((h+S|0)+(m<<1)|0)|0)>>>3|0,k=V+M|0,k=(n|0)>(o|0)?n:(k|0)>(o|0)?o:k,!e){if(n=f+s|0,!N){if(!I)break A;u[n|0]=B,u[n+w|0]=n0,u[n+P|0]=m0;break A}if(!I){u[n+r0|0]=k,u[n+U0|0]=F,u[n+e0|0]=_;break A}u[n+r0|0]=k,u[n|0]=B,u[n+U0|0]=F,u[n+w|0]=n0,u[n+e0|0]=_,u[n+P|0]=m0;break A}if(n=s+G(f,w)|0,N&&(u[n-1|0]=k),I&&(u[n|0]=B),N&&(u[n-2|0]=F),I&&(u[n+1|0]=n0),N&&(u[n-3|0]=_),!I)break A;u[n+2|0]=m0}if(f=f+1|0,(f|0)==4)break}}if(d0=d0+1|0,$0=$0+T2|0,!((Z2|0)>($0|0)))break}if(r=r+H2|0,!((n2|0)>(r|0)))break}}v=t+32|0;return}D0(4618,10893,119,4231),H()}D0(4656,10893,118,4231),H()}function rr(A,e,r,f,k){var n=0,t=0,o=0,s=0,w=0,h=0,_=0,B=0;n=v-208|0,v=n,s=i[e+108>>2],h=i[e+104>>2],w=s-h>>5;i:{if((s|0)==(h|0))break i;for(o=w>>>0<=1?1:w;;){if(i[(t<<5)+h>>2]==(r|0))break i;if(t=t+1|0,(o|0)==(t|0))break}t=o}if(B=e+104|0,(t|0)==(w|0)){g[n+36>>1]=0,g[n+38>>1]=0,g[n+40>>1]=0,g[n+42>>1]=0,g[n+30>>1]=0,g[n+32>>1]=0,g[n+34>>1]=0,g[n+36>>1]=0,g[n+22>>1]=0,g[n+24>>1]=0,g[n+26>>1]=0,g[n+28>>1]=0,u[n+20|0]=k,i[n+16>>2]=r;i:{if(s>>>0<u0[e+112>>2]){r=i[n+20>>2],i[s>>2]=i[n+16>>2],i[s+4>>2]=r,r=i[n+28>>2],i[s+8>>2]=i[n+24>>2],i[s+12>>2]=r,i[s+24>>2]=0,i[s+16>>2]=0,i[s+20>>2]=0,oA(s+16|0,0,0,0),i[e+108>>2]=s+32;break i}if(r=c9(B,n+16|0),o=i[n+32>>2],i[e+108>>2]=r,!o)break i;if(r=o,h=i[n+36>>2],(r|0)!=(h|0)){for(;r=i[h-16>>2],r&&(i[h-12>>2]=r,Z(r)),h=h-40|0,(o|0)!=(h|0););r=i[n+32>>2]}i[n+36>>2]=o,Z(r)}h=i[B>>2]}i[n+200>>2]=0,i[n+192>>2]=0,i[n+196>>2]=0,i[n+184>>2]=0,i[n+188>>2]=0,i[n+176>>2]=0,i[n+180>>2]=0,i[n+168>>2]=0,i[n+172>>2]=0,o=i[f+4>>2],s=i[f>>2],_=o-s|0,i[n+184>>2]=_,i[n+188>>2]=0;i:{e:{r:{f:{A:{if(!(!(u[e+132|0]&1)|k)){if(e=el(i[e+136>>2],s,_),(e|0)<0){i[n+108>>2]=0,i[n+80>>2]=72196,i[n+24>>2]=72176,e=i[18053],i[n+16>>2]=e,r=i[e-12>>2],k=n+16|0,e=k,i[r+e>>2]=i[18054],i[n+20>>2]=0,e=e+i[i[n+16>>2]-12>>2]|0,f=n+28|0,J0(e,f),u[e+80|0]=0,i[e+72>>2]=0,e=i[18055],i[n+24>>2]=e,r=n+24|0,i[r+i[e-12>>2]>>2]=i[18056],e=i[18052],i[n+16>>2]=e,i[k+i[e-12>>2]>>2]=i[18057],i[n+80>>2]=72196,i[n+16>>2]=72156,i[n+24>>2]=72176,k=R0(f),i[k>>2]=71232,i[n+68>>2]=0,i[n+72>>2]=0,i[n+60>>2]=0,i[n+64>>2]=0,i[n+76>>2]=24,S0(Y(r,27673,35),i[31324]),e=i[n+76>>2];k:{if(e&16){t=i[n+72>>2],e=i[n+52>>2],t>>>0<e>>>0&&(i[n+72>>2]=e,t=e),e=n+48|0;break k}if(!(e&8)){t=0,u[n+15|0]=0,r=n+4|0;break e}t=i[n+44>>2],e=n+36|0}if(f=i[e>>2],t=t-f|0,t>>>0>=2147483640)break f;if(t>>>0>=11){e=t|7,r=p(e+1|0),i[n+12>>2]=e-2147483647,i[n+4>>2]=r,i[n+8>>2]=t;break r}if(u[n+15|0]=t,r=n+4|0,t)break r;t=0;break e}if((e|0)==(i[f+4>>2]-i[f>>2]|0))break A;if(e=p(48),i[n+16>>2]=e,i[n+20>>2]=43,i[n+24>>2]=-2147483600,f=l[26631]|l[26632]<<8|(l[26633]<<16|l[26634]<<24),r=l[26627]|l[26628]<<8|(l[26629]<<16|l[26630]<<24),u[e|0]=r,u[e+1|0]=r>>>8,u[e+2|0]=r>>>16,u[e+3|0]=r>>>24,u[e+4|0]=f,u[e+5|0]=f>>>8,u[e+6|0]=f>>>16,u[e+7|0]=f>>>24,u[e+43|0]=0,r=l[26666]|l[26667]<<8|(l[26668]<<16|l[26669]<<24),u[e+39|0]=r,u[e+40|0]=r>>>8,u[e+41|0]=r>>>16,u[e+42|0]=r>>>24,f=l[26663]|l[26664]<<8|(l[26665]<<16|l[26666]<<24),r=l[26659]|l[26660]<<8|(l[26661]<<16|l[26662]<<24),u[e+32|0]=r,u[e+33|0]=r>>>8,u[e+34|0]=r>>>16,u[e+35|0]=r>>>24,u[e+36|0]=f,u[e+37|0]=f>>>8,u[e+38|0]=f>>>16,u[e+39|0]=f>>>24,f=l[26655]|l[26656]<<8|(l[26657]<<16|l[26658]<<24),r=l[26651]|l[26652]<<8|(l[26653]<<16|l[26654]<<24),u[e+24|0]=r,u[e+25|0]=r>>>8,u[e+26|0]=r>>>16,u[e+27|0]=r>>>24,u[e+28|0]=f,u[e+29|0]=f>>>8,u[e+30|0]=f>>>16,u[e+31|0]=f>>>24,f=l[26647]|l[26648]<<8|(l[26649]<<16|l[26650]<<24),r=l[26643]|l[26644]<<8|(l[26645]<<16|l[26646]<<24),u[e+16|0]=r,u[e+17|0]=r>>>8,u[e+18|0]=r>>>16,u[e+19|0]=r>>>24,u[e+20|0]=f,u[e+21|0]=f>>>8,u[e+22|0]=f>>>16,u[e+23|0]=f>>>24,f=l[26639]|l[26640]<<8|(l[26641]<<16|l[26642]<<24),r=l[26635]|l[26636]<<8|(l[26637]<<16|l[26638]<<24),u[e+8|0]=r,u[e+9|0]=r>>>8,u[e+10|0]=r>>>16,u[e+11|0]=r>>>24,u[e+12|0]=f,u[e+13|0]=f>>>8,u[e+14|0]=f>>>16,u[e+15|0]=f>>>24,q(A,9,0,n+16|0),u[n+27|0]>=0)break i;Z(i[n+16>>2]);break i}if(r=(t<<5)+h|0,w=i[r+20>>2],(w|0)!=i[r+16>>2]){if(r=w-16|0,e=w-12|0,$4(r,i[e>>2],s,o,_),r=i[e>>2]-i[r>>2]|0,e=w-24|0,i[e>>2]=r,i[e+4>>2]=0,e=i[26917],i[A>>2]=i[26916],i[A+4>>2]=e,e=A+8|0,u[107683]>=0){A=i[26919],i[e>>2]=i[26918],i[e+4>>2]=A,i[e+8>>2]=i[26920];break i}T(e,i[26918],i[26919]);break i}if(r=n+192|0,(r|0)!=(f|0)&&d4(r,s,o,_),(k|0)!=1)break A;k=i[e+128>>2],r=k,i[n+176>>2]=r,i[n+180>>2]=r>>31,r=i[f+4>>2]-i[f>>2]|0,i[n+184>>2]=r,i[n+188>>2]=0,i[e+128>>2]=r+k}k=i[B>>2]+(t<<5)|0,e=i[k+20>>2];A:{if(u0[k+24>>2]>e>>>0){r=i[n+172>>2],i[e>>2]=i[n+168>>2],i[e+4>>2]=r,r=i[n+188>>2],i[e+16>>2]=i[n+184>>2],i[e+20>>2]=r,r=i[n+180>>2],i[e+8>>2]=i[n+176>>2],i[e+12>>2]=r,i[e+32>>2]=0,i[e+24>>2]=0,i[e+28>>2]=0,i[e+24>>2]=i[n+192>>2],i[e+28>>2]=i[n+196>>2],i[e+32>>2]=i[n+200>>2],i[n+200>>2]=0,i[n+192>>2]=0,i[n+196>>2]=0,e=e+40|0;break A}k:{n:{if(w=i[k+20>>2],e=i[k+16>>2],o=w-e|0,t=((o|0)/40|0)+1|0,t>>>0<107374183){if(f=(i[k+24>>2]-e|0)/40|0,r=f<<1,r=f>>>0>=53687091?107374182:r>>>0>t>>>0?r:t,r>>>0>=107374183)break n;if(B=G(r,40),s=p(B),_=s+o|0,f=_,r=i[n+172>>2],i[f>>2]=i[n+168>>2],i[f+4>>2]=r,r=i[n+188>>2],i[f+16>>2]=i[n+184>>2],i[f+20>>2]=r,r=i[n+180>>2],i[f+8>>2]=i[n+176>>2],i[f+12>>2]=r,i[f+24>>2]=i[n+192>>2],i[f+28>>2]=i[n+196>>2],i[f+32>>2]=i[n+200>>2],i[n+200>>2]=0,i[n+192>>2]=0,i[n+196>>2]=0,t=f+G((o|0)/-40|0,40)|0,(e|0)!=(w|0)){for(r=e,f=t;o=i[r+4>>2],i[f>>2]=i[r>>2],i[f+4>>2]=o,o=i[r+20>>2],i[f+16>>2]=i[r+16>>2],i[f+20>>2]=o,o=i[r+12>>2],i[f+8>>2]=i[r+8>>2],i[f+12>>2]=o,i[f+24>>2]=i[r+24>>2],i[f+28>>2]=i[r+28>>2],i[f+32>>2]=i[r+32>>2],i[r+32>>2]=0,i[r+24>>2]=0,i[r+28>>2]=0,f=f+40|0,r=r+40|0,(w|0)!=(r|0););for(;r=i[e+24>>2],r&&(i[e+28>>2]=r,Z(r)),e=e+40|0,(w|0)!=(e|0););e=i[k+16>>2]}i[k+24>>2]=s+B,r=_+40|0,i[k+20>>2]=r,i[k+16>>2]=t,e&&Z(e),e=r;break k}G0(),H()}z0(),H()}}if(i[k+20>>2]=e,e=i[26917],i[A>>2]=i[26916],i[A+4>>2]=e,e=A+8|0,u[107683]>=0){A=i[26919],i[e>>2]=i[26918],i[e+4>>2]=A,i[e+8>>2]=i[26920];break i}T(e,i[26918],i[26919]);break i}Q0(),H()}if(!t)break e;x(r,f,t)}u[r+t|0]=0,q(A,9,0,n+4|0),u[n+15|0]<0&&Z(i[n+4>>2]),A=i[18051],i[n+16>>2]=A,i[i[A-12>>2]+(n+16|0)>>2]=i[18059],i[n+24>>2]=i[18060],i[k>>2]=71232,u[n+71|0]<0&&Z(i[n+60>>2]),E0(k),y0(n+80|0)}A=i[n+192>>2],A&&(i[n+196>>2]=A,Z(A)),v=n+208|0}function fr(A,e,r){var f=0,k=0,n=0,t=0,o=0,s=0,w=0,h=0,_=0,B=0,m=0,X=0,Q=0,V=0,F=0,I=0,E=0,R=0,N=0,M=0,z=0,S=0,O=0,P=0,a=0,$=0,f0=0,A0=0,n0=0,_0=0,m0=0,X0=0,g0=0,I0=0,e0=0,r0=0,N0=0,U0=0,M0=0,H0=0,P0=0,K0=0,$0=0,L0=0,d0=0;f=i[A+18588>>2],Q=i[f+132>>2],R=i[f+124>>2],M=i[R+16892>>2];i:{e:{r:{f:{if(!l[Q+45|0]|r||(r=i[A+12>>2],i[A+8>>2]|(r|0)<=0))break f;if(z=2,(M|0)>=2){if(r=r-1|0,k=i[A+18596>>2],r>>>0>=i[k+472>>2]-i[k+468>>2]>>3>>>0)break r;C8(f,i[A+18604>>2],1,r,1),ni(A+18572|0,(i[i[A+18596>>2]+468>>2]+(i[A+12>>2]<<3)|0)-8|0),mo((i[i[A+18596>>2]+468>>2]+(i[A+12>>2]<<3)|0)-8|0);break f}if(C8(f,i[A+18604>>2],0,r-1|0,1),r=i[A+18592>>2],f=i[r+804>>2],f>>>0>=3)break e;ji(A+18572|0,f,i[r+800>>2]),u[A+18580|0]=0,u[A+18581|0]=0,u[A+18582|0]=0,u[A+18583|0]=0}for(S=A+18548|0,m0=A+18572|0,I0=M-1|0,_=i[A+12>>2],r=i[A+8>>2],z=2;;){if(X0=G(_,M)+r|0,i[R+16892>>2]<=(r|0)|X0>>>0>=i[Q+8452>>2]-i[Q+8448>>2]>>2>>>0|i[R+16900>>2]<=(_|0)||(!e|(_|0)<=0|(r|0)>=(I0|0)||C8(i[A+18588>>2],i[A+18604>>2],r+1|0,_-1|0,1),!i[A+18576>>2]))break r;F=0,O=0,f=i[A>>2],k=i[A+18588>>2],P=i[k+124>>2],t=i[P+16892>>2],s=(f|0)/(t|0)|0,m=f-G(t,s)|0,f=i[P+16876>>2],h=m<<f,t=i[A+18592>>2],n=i[k+152>>2],(n|0)<=(m|0)|(s|0)>=i[k+156>>2]||(g[(i[k+140>>2]+G(m,24)|0)+G(G(n,s),24)>>1]=i[t+808>>2]);f:{A:{if(o=i[k+148>>2],w=h>>o,!((w|0)<0|(n|0)<=(w|0))){if(V=s<<f,o=V>>o,(o|0)<0|(o|0)>=i[k+156>>2])break A;if(g[((i[k+140>>2]+G(w,24)|0)+G(G(n,o),24)|0)+2>>1]=i[t>>2],e0=h,r0=V,l[t+333|0]|l[t+334|0]){t=v-32|0,v=t,N=i[A+18592>>2],w=i[A+18588>>2],a=i[w+132>>2],n=i[w+124>>2],u[t+24|0]=0,i[t+16>>2]=0,i[t+20>>2]=0,i[t+8>>2]=0,i[t+12>>2]=0,f=0;k:{if((m|0)<=0||(f=0,i[A>>2]<=i[N+808>>2])||(k=(i[a+8484>>2]+(m<<2)|0)+(G(s,i[n+16892>>2])<<2)|0,f=0,i[k>>2]!=i[k-4>>2]))break k;f=v2(A+18548|0,i[A+18572>>2])}k:{if(f&255|(s|0)<=0||(k=i[n+16892>>2],i[N+808>>2]>(i[A>>2]-k|0))||(o=i[a+8484>>2]+(m<<2)|0,i[o+(G(k,s)<<2)>>2]!=i[o+(G(k,s-1|0)<<2)>>2]))break k;O=(v2(A+18548|0,i[A+18572>>2])&255)!=0}if(g0=f&255,!(O|g0)){for(k=A+18548|0,N0=t+16|0,f=t+8|0,U0=f|7,M0=f|6,H0=f|2,P0=f|5,K0=i[n+16848>>2],n=0,o=0;;){k:{n:{t:{u:{o:{if(!l[N+333|0]||n){if(!n|!l[N+334|0])break k;if((n|0)!=1)break t;if(v2(k,i[A+18572>>2]+1|0))break o;f=0;break u}if(!v2(k,i[A+18572>>2]+1|0)){o=0,f=0;break n}o=k4(k)?2:1,f=o;break n}f=k4(k)?2:1}o=f<<2|f<<4|o;break n}f=(o&255)>>>(n<<1)&3}if(!f)break k;h=n<<2,$=h+P0|0,X=n?16840:16832,B=i[X+i[w+124>>2]>>2],B=we(k,-1<<((B|0)>=10?10:B)-5^-1),u[$|0]=B,f0=h+M0|0,I=i[X+i[w+124>>2]>>2],I=we(k,-1<<((I|0)>=10?10:I)-5^-1),u[f0|0]=I,A0=h+U0|0,E=i[X+i[w+124>>2]>>2],E=we(k,-1<<((E|0)>=10?10:E)-5^-1),u[A0|0]=E,n0=h+N0|0,h=i[X+i[w+124>>2]>>2],X=we(k,-1<<((h|0)>=10?10:h)-5^-1),u[n0|0]=X;n:{if((f|0)==1){f=0,V=0,B&255&&(V=k4(k)?-1:1),I&255&&(f=k4(k)?-1:1),h=0,_0=0,E&255&&(_0=k4(k)?-1:1),X&255&&(h=k4(k)?-1:1),L0=n+H0|0,d0=F8(k,5),u[L0|0]=d0,X=l[n0|0],E=l[A0|0],I=l[f0|0],B=l[$|0];break n}t:{if(!n){f=1,h=-1,F=F8(k,2);break t}if(f=1,h=-1,(n|0)!=1)break t;V=F,F=F8(k,2),F=V|(F<<2|F<<4)}_0=-1,V=1}$0=B,B=l[(n?8264:8263)+a|0],u[$|0]=G($0<<B,V),u[f0|0]=G(I<<B,f),u[A0|0]=G(E<<B,_0),u[n0|0]=G(X<<B,h)}if(!(K0&&(f=n>>>0<2,n=n+1|0,f)))break}u[t+8|0]=o,u[t+9|0]=F,f=(i[w+140>>2]+G(m,24)|0)+G(G(s,i[w+152>>2]),24)|0,u[f+20|0]=l[t+24|0],k=i[t+20>>2],n=i[t+16>>2],u[f+12|0]=n,u[f+13|0]=n>>>8,u[f+14|0]=n>>>16,u[f+15|0]=n>>>24,u[f+16|0]=k,u[f+17|0]=k>>>8,u[f+18|0]=k>>>16,u[f+19|0]=k>>>24,k=i[t+12>>2],n=i[t+8>>2],u[f+4|0]=n,u[f+5|0]=n>>>8,u[f+6|0]=n>>>16,u[f+7|0]=n>>>24,u[f+8|0]=k,u[f+9|0]=k>>>8,u[f+10|0]=k>>>16,u[f+11|0]=k>>>24}g0&&(f=(i[w+140>>2]+G(m,24)|0)+G(G(s,i[w+152>>2]),24)|0,k=f-20|0,n=l[k+4|0]|l[k+5|0]<<8|(l[k+6|0]<<16|l[k+7|0]<<24),o=l[k|0]|l[k+1|0]<<8|(l[k+2|0]<<16|l[k+3|0]<<24),u[f+4|0]=o,u[f+5|0]=o>>>8,u[f+6|0]=o>>>16,u[f+7|0]=o>>>24,u[f+8|0]=n,u[f+9|0]=n>>>8,u[f+10|0]=n>>>16,u[f+11|0]=n>>>24,u[f+20|0]=l[k+16|0],n=l[k+12|0]|l[k+13|0]<<8|(l[k+14|0]<<16|l[k+15|0]<<24),k=l[k+8|0]|l[k+9|0]<<8|(l[k+10|0]<<16|l[k+11|0]<<24),u[f+12|0]=k,u[f+13|0]=k>>>8,u[f+14|0]=k>>>16,u[f+15|0]=k>>>24,u[f+16|0]=n,u[f+17|0]=n>>>8,u[f+18|0]=n>>>16,u[f+19|0]=n>>>24),O&&(n=i[w+140>>2]+G(m,24)|0,k=i[w+152>>2],f=n+G(G(k,s),24)|0,k=n+G(G(k,s-1|0),24)|0,u[f+20|0]=l[k+20|0],n=l[k+16|0]|l[k+17|0]<<8|(l[k+18|0]<<16|l[k+19|0]<<24),s=l[k+12|0]|l[k+13|0]<<8|(l[k+14|0]<<16|l[k+15|0]<<24),u[f+12|0]=s,u[f+13|0]=s>>>8,u[f+14|0]=s>>>16,u[f+15|0]=s>>>24,u[f+16|0]=n,u[f+17|0]=n>>>8,u[f+18|0]=n>>>16,u[f+19|0]=n>>>24,n=l[k+8|0]|l[k+9|0]<<8|(l[k+10|0]<<16|l[k+11|0]<<24),k=l[k+4|0]|l[k+5|0]<<8|(l[k+6|0]<<16|l[k+7|0]<<24),u[f+4|0]=k,u[f+5|0]=k>>>8,u[f+6|0]=k>>>16,u[f+7|0]=k>>>24,u[f+8|0]=n,u[f+9|0]=n>>>8,u[f+10|0]=n>>>16,u[f+11|0]=n>>>24),v=t+32|0,f=i[P+16876>>2]}er(A,e0,r0,f,0);break f}D0(4656,10893,128,4231),H()}D0(4618,10893,129,4231),H()}if(!(!l[Q+45|0]|(r|0)!=1|(i[R+16900>>2]-1|0)<=(_|0))){if(f=i[A+18596>>2],r=i[f+468>>2],i[f+472>>2]-r>>3>>>0<=_>>>0)break r;f=r,r=_<<3,ni(f+r|0,m0),no(r+i[i[A+18596>>2]+468>>2]|0)}if(k=NA(S),!k|!l[Q+14|0]||(ni(i[A+18592>>2]+1340|0,m0),no(i[A+18592>>2]+1340|0),u[i[A+18592>>2]+1348|0]=1),r=i[i[A+18588>>2]+320>>2]+G(X0,76)|0,i[r>>2]<=0&&(i[r>>2]=1),s=i[A+4>>2],f=s+1|0,i[A+4>>2]=f,w=i[A+12>>2],_=i[A+18588>>2],n=i[_+124>>2],t=i[n+16908>>2],n=i[n+16892>>2],r=(f|0)<(t|0)?i[i[i[_+132>>2]+8460>>2]+(f<<2)>>2]:t,i[A>>2]=r,_=(r|0)/(n|0)|0,i[A+12>>2]=_,r=r-G(n,_)|0,i[A+8>>2]=r,!((f|0)<(t|0)|k)){F2(i[A+18584>>2]+4|0,1004,0);break i}if(k)return 0;if(l[Q+46|0]?(t=f<<2,f=i[Q+8472>>2],f=i[t+f>>2]!=i[f+(s<<2)>>2]):f=0,!!(f|l[Q+45|0]!=0&(w|0)!=(_|0)))break}if(!NA(S)){F2(i[A+18584>>2]+4|0,1017,0);break i}Ze(S),z=1}return z}D0(21669,18297,1520,5105),H()}return u[i[A+18588>>2]+312|0]=3,2}function VB(A,e,r,f,k,n,t,o){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,t=t|0,o=o|0;var s=0,w=0,h=0,_=0,B=0,m=0,X=0,Q=0,V=0,F=0,I=0,E=0,R=0,N=0,M=0,z=0,S=0,O=0,P=0,a=0,$=0,f0=0,A0=0,n0=0,_0=0,m0=0,X0=0;s=v-128|0,v=s,_=j0(i[r>>2],0),t=j0(i[r>>2],1),n=j0(i[r>>2],2),M=u1(i[r>>2],6),M&&(f0=j0(i[r>>2],6));i:{if(!(!(_>>>0<9|t>>>0<9)&n>>>0>8)){e=i[26922],i[A>>2]=i[26921],i[A+4>>2]=e,r=A+8|0;e:{if(u[107703]>=0){e=i[26924],i[r>>2]=i[26923],i[r+4>>2]=e,i[r+8>>2]=i[26925];break e}T(r,i[26923],i[26924])}u[A+20|0]=1;break i}if(!((t|0)==(_|0)&(n|0)==(_|0))){e=i[26922],i[A>>2]=i[26921],i[A+4>>2]=e,r=A+8|0;e:{if(u[107703]>=0){e=i[26924],i[r>>2]=i[26923],i[r+4>>2]=e,i[r+8>>2]=i[26925];break e}T(r,i[26923],i[26924])}u[A+20|0]=1;break i}e=i[r>>2],B=i[e+112>>2],X=i[e+108>>2],w=p(172),i[w>>2]=94812,i[w+4>>2]=0,i[w+8>>2]=0,o0(w+16|0,0,80),e=i[w+4>>2],f=e+1|0,i[w+4>>2]=f,i[w+104>>2]=0,i[w+108>>2]=0,i[w+36>>2]=1,i[w+40>>2]=1,u[w+24|0]=1,g[w+22>>1]=2,g[w+18>>1]=2,g[w+20>>1]=2,i[w+112>>2]=0,i[w+116>>2]=4740,i[w+140>>2]=0,i[w+144>>2]=0,i[w+128>>2]=99,i[w+132>>2]=99,i[w+120>>2]=0,i[w+124>>2]=0,i[w+12>>2]=95160,i[w+148>>2]=0,i[w+152>>2]=0,k=w+140|0,i[w+136>>2]=k,i[w+156>>2]=0,i[w+160>>2]=0,i[w+164>>2]=0,i[w+168>>2]=0,i[w+4>>2]=e,e=i[w+8>>2],m=w+12|0,i[w+96>>2]=m,i[w+8>>2]=e+1,i[w+100>>2]=w,f||(W[i[i[w>>2]+8>>2]](w),y(w)),i[m+120>>2]=2,i[m+116>>2]=0,i[m+112>>2]=B,i[m+108>>2]=X,T0(s+56|0,m,0,X,B,_,o),Q=X+1>>>1|0,T0(s+32|0,m,1,Q,B,t,o),t=s+88|0;e:{if(i[s+56>>2]){if(e=i[s+60>>2],i[s+80>>2]=i[s+56>>2],i[s+84>>2]=e,u[s+75|0]>=0){f=s- -64|0,e=i[f+4>>2],i[t>>2]=i[f>>2],i[t+4>>2]=e,i[t+8>>2]=i[f+8>>2];break e}T(t,i[s+64>>2],i[s+68>>2]);break e}if(e=i[s+36>>2],i[s+80>>2]=i[s+32>>2],i[s+84>>2]=e,u[s+51|0]>=0){e=i[s+44>>2],i[t>>2]=i[s+40>>2],i[t+4>>2]=e,i[t+8>>2]=i[s+48>>2];break e}T(t,i[s+40>>2],i[s+44>>2])}T0(s+8|0,m,2,Q,B,n,o),f=s+112|0;e:{if(i[s+80>>2]){if(e=i[s+84>>2],i[s+104>>2]=i[s+80>>2],i[s+108>>2]=e,u[s+99|0]>=0){e=i[t+4>>2],i[f>>2]=i[t>>2],i[f+4>>2]=e,i[f+8>>2]=i[t+8>>2];break e}T(f,i[s+88>>2],i[s+92>>2]);break e}if(e=i[s+12>>2],i[s+104>>2]=i[s+8>>2],i[s+108>>2]=e,u[s+27|0]>=0){e=i[s+20>>2],i[f>>2]=i[s+16>>2],i[f+4>>2]=e,i[f+8>>2]=i[s+24>>2];break e}T(f,i[s+16>>2],i[s+20>>2])}u[s+27|0]<0&&Z(i[s+16>>2]),u[s+99|0]<0&&Z(i[s+88>>2]),u[s+51|0]<0&&Z(i[s+40>>2]),u[s+75|0]<0&&Z(i[s+64>>2]);e:{if(i[s+104>>2]){if(e=i[s+108>>2],i[A>>2]=i[s+104>>2],i[A+4>>2]=e,r=A+8|0,u[s+123|0]>=0){e=i[f+4>>2],i[r>>2]=i[f>>2],i[r+4>>2]=e,i[r+8>>2]=i[f+8>>2],u[A+20|0]=1;break e}if(T(r,i[s+112>>2],i[s+116>>2]),e=u[s+123|0],u[A+20|0]=1,(e|0)>=0)break e;Z(i[s+112>>2]);break e}u[s+123|0]<0&&Z(i[s+112>>2]);r:{if(!M)break r;if(T0(s+104|0,m,6,X,B,f0,o),i[s+104>>2]){if(e=i[s+108>>2],i[A>>2]=i[s+104>>2],i[A+4>>2]=e,r=A+8|0,u[s+123|0]>=0){e=i[s+116>>2],i[r>>2]=i[s+112>>2],i[r+4>>2]=e,i[r+8>>2]=i[s+120>>2],u[A+20|0]=1;break e}if(T(r,i[s+112>>2],i[s+116>>2]),e=u[s+123|0],u[A+20|0]=1,(e|0)>=0)break e;Z(i[s+112>>2]);break e}if(u[s+123|0]>=0)break r;Z(i[s+112>>2])}e=i[r>>2],f=e+128|0;r:{f:{if(t=i[e+128>>2],t){for(e=f,r=t;n=i[r+16>>2],e=(n|0)<0?e:r,r=i[(n>>>29&4)+r>>2],!!r;);E=0;A:{if((e|0)==(f|0)||(E=0,i[e+16>>2]>0))break A;_0=i[e+44>>2],E=i[e+56>>2]}for(e=f,r=t;n=i[r+16>>2]<=0,e=n?e:r,r=i[(n?4:0)+r>>2],!!r;);F=0;A:{if((e|0)==(f|0)||(F=0,i[e+16>>2]>1))break A;V=i[e+56>>2],F=i[e+44>>2]}for(e=f,r=t;n=i[r+16>>2]<2,e=n?e:r,r=i[(n?4:0)+r>>2],!!r;);if((e|0)!=(f|0))break f}R=0;break r}if(R=0,i[e+16>>2]>2)break r;z=i[e+56>>2]>>>1|0,R=i[e+44>>2]}r:{f:{e=i[k>>2];A:{if(!e){o=0;break A}for(n=k,r=e;o=i[r+16>>2],n=(o|0)<0?n:r,r=i[(o>>>29&4)+r>>2],!!r;);N=0;k:{if((k|0)==(n|0)||(N=0,i[n+16>>2]>0))break k;m0=i[n+44>>2],N=i[n+56>>2]}for(n=k,r=e;o=i[r+16>>2]<=0,n=o?n:r,r=i[(o?4:0)+r>>2],!!r;);o=0;k:{if((k|0)==(n|0)||(o=0,i[n+16>>2]>1))break k;A0=i[n+44>>2],o=i[n+56>>2]}for(n=k,r=e;_=i[r+16>>2]<2,n=_?n:r,r=i[(_?4:0)+r>>2],!!r;);if((k|0)!=(n|0))break f}r=0;break r}if(r=0,i[n+16>>2]>2)break r;S=i[n+56>>2]>>>1|0,r=i[n+44>>2]}_=r,n=0,h=0;r:{if(!M)break r;f:{A:{if(!t)break A;for(r=f;O=i[t+16>>2]<6,r=O?r:t,t=i[(O?4:0)+t>>2],!!t;);if((r|0)==(f|0))break A;if(f=0,i[r+16>>2]>6)break f;X0=i[r+44>>2],f=i[r+56>>2];break f}f=0}if(O=f,h=0,!e)break r;for(r=k;f=i[e+16>>2]<6,r=f?r:e,e=i[(f?4:0)+e>>2],!!e;);if(h=0,(r|0)==(k|0)||(h=0,i[r+16>>2]>6))break r;n=i[r+56>>2],h=i[r+44>>2]}e=h,P=o>>>1|0,a=V>>>1|0;r:{f:{A:{if(!(X&1))break A;if(k=B-1|0,!k)break f;if(f=Q<<1,Q=(f+_|0)-2|0,r=X<<1,V=(r+R|0)-2|0,I=(f+A0|0)-2|0,o=(r+F|0)-2|0,r=0,(B|0)!=2)for(f=k&-2;g[I+(G(r,P)<<1)>>1]=C[o+(G(r,a)<<1)>>1],g[Q+(G(r,S)<<1)>>1]=C[V+(G(r,z)<<1)>>1],t=r|1,g[I+(G(t,P)<<1)>>1]=C[o+(G(t,a)<<1)>>1],g[Q+(G(t,S)<<1)>>1]=C[V+(G(t,z)<<1)>>1],r=r+2|0,$=$+2|0,(f|0)!=($|0););if(!(k&1))break A;g[I+(G(r,P)<<1)>>1]=C[o+(G(r,a)<<1)>>1],g[Q+(G(r,S)<<1)>>1]=C[V+(G(r,z)<<1)>>1]}if(!B)break r}if(n0=X-1|0,n0)for(o=0;;){for(h=(G(o,S)<<1)+_|0,Q=(G(o,P)<<1)+A0|0,V=(G(o,z)<<1)+R|0,$=(G(o,a)<<1)+F|0,r=0;I=r<<1,f=I+V|0,t=C[f>>1],k=C[f+2>>1],f=I+$|0,g[r+Q>>1]=(C[f>>1]+C[f+2>>1]|0)+1>>>1,g[r+h>>1]=(k+t|0)+1>>>1,r=r+2|0,n0>>>0>r>>>0;);if(o=o+1|0,(B|0)==(o|0))break}for(k=N>>>1|0,f=E>>>1|0,o=X<<1,t=f0>>>0>8?o:X,r=0;o&&x((G(r,k)<<1)+m0|0,(G(r,f)<<1)+_0|0,o),!M|!t||x(G(r,n)+e|0,G(r,O)+X0|0,t),r=r+1|0,(B|0)!=(r|0););}u[A+20|0]=0,i[A+4>>2]=w,i[A>>2]=m;break i}if(A=i[w+4>>2],i[w+4>>2]=A-1,A)break i;W[i[i[w>>2]+8>>2]](w),y(w)}v=s+128|0}function FB(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,t=0,o=0,s=0,w=0,h=0,_=0,B=0,m=0,X=0,Q=0,V=0,F=0,I=0;if(f=v-176|0,v=f,i[f+88>>2]=0,i[f+60>>2]=72500,k=i[18128],i[f+4>>2]=k,t=i[k-12>>2],k=f+4|0,i[t+k>>2]=i[18129],t=k+i[i[f+4>>2]-12>>2]|0,n=f+8|0,J0(t,n),u[t+80|0]=0,i[t+72>>2]=0,i[f+60>>2]=72500,i[f+4>>2]=72480,X=R0(n),i[X>>2]=71232,i[f+48>>2]=0,i[f+52>>2]=0,i[f+40>>2]=0,i[f+44>>2]=0,i[f+56>>2]=16,t=f+164|0,Y2(t,e,r),w=k,n=t,k=u[f+175|0],t=(k|0)<0,Y(w,t?i[f+164>>2]:n,t?i[f+168>>2]:k),u[f+175|0]<0&&Z(i[f+164>>2]),m=i[e+104>>2],Q=i[e+108>>2],(m|0)!=(Q|0))for(;;){if(e=f+164|0,s0(e,r),t=e,e=u[f+175|0],k=(e|0)<0,Y(f+4|0,k?i[f+164>>2]:t,k?i[f+168>>2]:e),u[f+175|0]<0&&Z(i[f+164>>2]),Y(V0(Y(f+4|0,32555,26),i[m>>2]),42670,1),e=i[r>>2]+1|0,i[r>>2]=e,_=i[m+4>>2],V=i[m+8>>2],(_|0)!=(V|0)){i:{e:{for(;;){r:{s0(f+144|0,r),n=u[f+155|0],w=i[f+144>>2],h=i[f+148>>2],e=f+4|0,B=G1(f+156|0,e);f:{if(l[B|0]!=1)break f;k=e+i[i[f+4>>2]-12>>2]|0,I=i[k+4>>2],o=i[k+24>>2];A:{if(l[k+80|0]==1){t=l[k+76|0]|l[k+77|0]<<8|(l[k+78|0]<<16|l[k+79|0]<<24);break A}s=f+164|0,e=i[k+28>>2],i[s>>2]=e,(e|0)!=129576&&(i[e+4>>2]=i[e+4>>2]+1),e=c0(s,129760),t=W[i[i[e>>2]+28>>2]](e,32)|0,e2(s),u[k+76|0]=t,u[k+77|0]=t>>>8,u[k+78|0]=t>>>16,u[k+79|0]=t>>>24,u[k+80|0]=1}A:{if(!o||(s=i[k+12>>2],e=w,w=(n|0)<0,e=w?e:f+144|0,n=w?h:n,F=e+n|0,w=(I&176)==32?F:e,h=w-e|0,(h|0)>0&&(W[i[i[o>>2]+48>>2]](o,e,h)|0)!=(h|0)))break A;if(n=(n|0)<(s|0)?s-n|0:0,(n|0)>0){if(n>>>0>=2147483640)break r;k:{if(n>>>0>=11){s=n|7,e=p(s+1|0),i[f+172>>2]=s-2147483647,i[f+164>>2]=e,i[f+168>>2]=n;break k}u[f+175|0]=n,e=f+164|0}if(n&&o0(e,t,n),u[e+n|0]=0,e=W[i[i[o>>2]+48>>2]](o,u[f+175|0]<0?i[f+164>>2]:f+164|0,n)|0,u[f+175|0]<0&&Z(i[f+164>>2]),(e|0)!=(n|0))break A}if(e=F-w|0,(e|0)>0&&(W[i[i[o>>2]+48>>2]](o,w,e)|0)!=(e|0))break A;i[k+12>>2]=0;break f}e=i[i[f+4>>2]-12>>2]+(f+4|0)|0,H1(e,i[e+16>>2]|5)}_1(B),u[f+155|0]<0&&Z(i[f+144>>2]),e=f+4|0,w=G1(f+144|0,e);f:{if(l[w|0]!=1)break f;e=e+i[i[f+4>>2]-12>>2]|0,s=i[e+4>>2],n=i[e+24>>2];A:{if(l[e+80|0]==1){t=l[e+76|0]|l[e+77|0]<<8|(l[e+78|0]<<16|l[e+79|0]<<24);break A}o=f+164|0,k=i[e+28>>2],i[o>>2]=k,(k|0)!=129576&&(i[k+4>>2]=i[k+4>>2]+1),k=c0(o,129760),t=W[i[i[k>>2]+28>>2]](k,32)|0,e2(o),u[e+76|0]=t,u[e+77|0]=t>>>8,u[e+78|0]=t>>>16,u[e+79|0]=t>>>24,u[e+80|0]=1}A:{if(!n||(o=i[e+12>>2],s=(s&176)==32?29480:29464,k=s-29464|0,(k|0)>0&&(W[i[i[n>>2]+48>>2]](n,29464,k)|0)!=(k|0)))break A;if((o|0)>=17){k=((o|0)<=16?16:o)-16|0;k:{if(o>>>0>=27){h=k|7,o=p(h+1|0),i[f+172>>2]=h-2147483647,i[f+164>>2]=o,i[f+168>>2]=k;break k}u[f+175|0]=k,o=f+164|0}if(k&&o0(o,t,k),u[k+o|0]=0,t=W[i[i[n>>2]+48>>2]](n,u[f+175|0]<0?i[f+164>>2]:f+164|0,k)|0,u[f+175|0]<0&&Z(i[f+164>>2]),(k|0)!=(t|0))break A}if(k=29480-s|0,(k|0)>0&&(W[i[i[n>>2]+48>>2]](n,s,k)|0)!=(k|0))break A;i[e+12>>2]=0;break f}e=i[i[f+4>>2]-12>>2]+(f+4|0)|0,H1(e,i[e+16>>2]|5)}_1(w),o=V0(f+4|0,C[_+2>>1]),h=G1(f+144|0,o);f:{if(l[h|0]!=1)break f;k=o+i[i[o>>2]-12>>2]|0,w=i[k+4>>2],s=i[k+24>>2];A:{if(l[k+80|0]==1){t=l[k+76|0]|l[k+77|0]<<8|(l[k+78|0]<<16|l[k+79|0]<<24);break A}n=f+164|0,e=i[k+28>>2],i[n>>2]=e,(e|0)!=129576&&(i[e+4>>2]=i[e+4>>2]+1),e=c0(n,129760),t=W[i[i[e>>2]+28>>2]](e,32)|0,e2(n),u[k+76|0]=t,u[k+77|0]=t>>>8,u[k+78|0]=t>>>16,u[k+79|0]=t>>>24,u[k+80|0]=1}A:{if(!s||(e=i[k+12>>2],w=(w&176)==32?30905:30892,n=w-30892|0,(n|0)>0&&(W[i[i[s>>2]+48>>2]](s,30892,n)|0)!=(n|0)))break A;if((e|0)>=14){n=((e|0)<=13?13:e)-13|0;k:{if(e>>>0>=24){B=n|7,e=p(B+1|0),i[f+172>>2]=B-2147483647,i[f+164>>2]=e,i[f+168>>2]=n;break k}u[f+175|0]=n,e=f+164|0}if(n&&o0(e,t,n),u[e+n|0]=0,e=W[i[i[s>>2]+48>>2]](s,u[f+175|0]<0?i[f+164>>2]:f+164|0,n)|0,u[f+175|0]<0&&Z(i[f+164>>2]),(e|0)!=(n|0))break A}if(e=30905-w|0,(e|0)>0&&(W[i[i[s>>2]+48>>2]](s,w,e)|0)!=(e|0))break A;i[k+12>>2]=0;break f}e=o+i[i[o>>2]-12>>2]|0,H1(e,i[e+16>>2]|5)}_1(h),e=o+i[i[o>>2]-12>>2]|0,i[e+4>>2]=i[e+4>>2]|1,s=li(o,l[_|0]),h=G1(f+144|0,s);f:{if(l[h|0]!=1)break f;k=s+i[i[s>>2]-12>>2]|0,w=i[k+4>>2],o=i[k+24>>2];A:{if(l[k+80|0]==1){t=l[k+76|0]|l[k+77|0]<<8|(l[k+78|0]<<16|l[k+79|0]<<24);break A}n=f+164|0,e=i[k+28>>2],i[n>>2]=e,(e|0)!=129576&&(i[e+4>>2]=i[e+4>>2]+1),e=c0(n,129760),t=W[i[i[e>>2]+28>>2]](e,32)|0,e2(n),u[k+76|0]=t,u[k+77|0]=t>>>8,u[k+78|0]=t>>>16,u[k+79|0]=t>>>24,u[k+80|0]=1}A:{if(!o||(e=i[k+12>>2],w=(w&176)==32?42671:42669,n=w-42669|0,(n|0)>0&&(W[i[i[o>>2]+48>>2]](o,42669,n)|0)!=(n|0)))break A;if((e|0)>=3){if(e>>>0>=2147483642)break e;n=((e|0)<=2?2:e)-2|0;k:{if(e>>>0>=13){B=n|7,e=p(B+1|0),i[f+172>>2]=B-2147483647,i[f+164>>2]=e,i[f+168>>2]=n;break k}u[f+175|0]=n,e=f+164|0}if(n&&o0(e,t,n),u[e+n|0]=0,e=W[i[i[o>>2]+48>>2]](o,u[f+175|0]<0?i[f+164>>2]:f+164|0,n)|0,u[f+175|0]<0&&Z(i[f+164>>2]),(e|0)!=(n|0))break A}if(e=42671-w|0,(e|0)>0&&(W[i[i[o>>2]+48>>2]](o,w,e)|0)!=(e|0))break A;i[k+12>>2]=0;break f}e=s+i[i[s>>2]-12>>2]|0,H1(e,i[e+16>>2]|5)}if(_1(h),_=_+4|0,(V|0)!=(_|0))continue;break i}break}Q0(),H()}Q0(),H()}e=i[r>>2]}if(i[r>>2]=((e|0)<=1?1:e)-1,m=m+16|0,(Q|0)==(m|0))break}e=i[f+56>>2];i:{e:{if(e&16){_=f+28|0,r=i[f+52>>2],e=i[f+32>>2],r>>>0<e>>>0?i[f+52>>2]=e:e=r;break e}if(!(e&8)){e=0,u[A+11|0]=0;break i}_=f+16|0,e=i[f+24>>2]}e:{if(k=i[_>>2],e=e-k|0,e>>>0<2147483640){if(e>>>0>=11){t=e|7,r=p(t+1|0),i[A+8>>2]=t-2147483647,i[A>>2]=r,i[A+4>>2]=e,A=r;break e}if(u[A+11|0]=e,e)break e;e=0;break i}Q0(),H()}if(!e)break i;x(A,k,e)}u[A+e|0]=0,A=i[18127],i[f+4>>2]=A,i[i[A-12>>2]+(f+4|0)>>2]=i[18130],i[X>>2]=71232,u[f+51|0]<0&&Z(i[f+40>>2]),E0(X),y0(f+60|0),v=f+176|0}function IB(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,t=0,o=0,s=0,w=0,h=0,_=0,B=0,m=0,X=0,Q=0,V=0,F=0,I=0;if(f=v-192|0,v=f,i[f+116>>2]=0,i[f+88>>2]=72500,n=i[18128],i[f+32>>2]=n,k=i[n-12>>2],n=f+32|0,i[k+n>>2]=i[18129],k=n+i[i[f+32>>2]-12>>2]|0,t=f+36|0,J0(k,t),u[k+80|0]=0,i[k+72>>2]=0,i[f+88>>2]=72500,i[f+32>>2]=72480,m=R0(t),i[m>>2]=71232,i[f+76>>2]=0,i[f+80>>2]=0,i[f+68>>2]=0,i[f+72>>2]=0,i[f+84>>2]=16,k=f+180|0,U1(k,e,r),o=n,t=k,n=u[f+191|0],k=(n|0)<0,Y(o,k?i[f+180>>2]:t,k?i[f+184>>2]:n),u[f+191|0]<0&&Z(i[f+180>>2]),n=f+180|0,s0(n,r),o=n,n=u[f+191|0],k=(n|0)<0,Y(f+32|0,k?i[f+180>>2]:o,k?i[f+184>>2]:n),u[f+191|0]<0&&Z(i[f+180>>2]),n=f+32|0,Y(S0(Y(n,31240,17),l[e+104|0]+1|0),42670,1),l[e+105|0]==1&&(k=f+180|0,s0(k,r),o=n,t=k,n=u[f+191|0],k=(n|0)<0,Y(o,k?i[f+180>>2]:t,k?i[f+184>>2]:n),u[f+191|0]<0&&Z(i[f+180>>2]),n=Y(V0(Y(f+32|0,29441,11),C[e+106>>1]),42670,1),k=f+180|0,s0(k,r),o=k,k=u[f+191|0],t=(k|0)<0,Y(n,t?i[f+180>>2]:o,t?i[f+184>>2]:k),u[f+191|0]<0&&Z(i[f+180>>2]),n=Y(S0(Y(n,29866,15),l[e+108|0]),42670,1),k=f+180|0,s0(k,r),o=k,k=u[f+191|0],t=(k|0)<0,Y(n,t?i[f+180>>2]:o,t?i[f+184>>2]:k),u[f+191|0]<0&&Z(i[f+180>>2]),k=Y(n,31477,21),n=l[e+109|0],n=(n|0)==1?3801:(n|0)==2?6905:7978,n=Y(Y(k,n,h2(n)),42670,1),k=f+180|0,s0(k,r),o=k,k=u[f+191|0],t=(k|0)<0,Y(n,t?i[f+180>>2]:o,t?i[f+184>>2]:k),u[f+191|0]<0&&Z(i[f+180>>2]),k=Y(n,29742,15),n=i[(l[e+110|0]<<2)+99792>>2],n=Y(Y(k,n,h2(n)),42670,1),k=f+180|0,s0(k,r),o=k,k=u[f+191|0],t=(k|0)<0,Y(n,t?i[f+180>>2]:o,t?i[f+184>>2]:k),u[f+191|0]<0&&Z(i[f+180>>2]),n=Y(S0(Y(n,30966,11),l[e+111|0]+8|0),42670,1),k=f+180|0,s0(k,r),o=k,k=u[f+191|0],t=(k|0)<0,Y(n,t?i[f+180>>2]:o,t?i[f+184>>2]:k),u[f+191|0]<0&&Z(i[f+180>>2]),n=Y(V0(Y(n,32746,20),C[e+168>>1]),42670,1),k=f+180|0,s0(k,r),o=k,k=u[f+191|0],t=(k|0)<0,Y(n,t?i[f+180>>2]:o,t?i[f+184>>2]:k),u[f+191|0]<0&&Z(i[f+180>>2]),Y(V0(Y(n,29674,20),C[e+170>>1]),42670,1),n=f+180|0,s0(n,r),o=n,n=u[f+191|0],k=(n|0)<0,Y(f+32|0,k?i[f+180>>2]:o,k?i[f+184>>2]:n),u[f+191|0]<0&&Z(i[f+180>>2]),n=Y(S0(Y(f+32|0,31875,17),l[e+113|0]),42670,1),k=f+180|0,s0(k,r),o=k,k=u[f+191|0],t=(k|0)<0,Y(n,t?i[f+180>>2]:o,t?i[f+184>>2]:k),u[f+191|0]<0&&Z(i[f+180>>2]),n=Y(S0(Y(n,31165,11),l[e+114|0]),42670,1),k=f+180|0,s0(k,r),o=k,k=u[f+191|0],t=(k|0)<0,Y(n,t?i[f+180>>2]:o,t?i[f+184>>2]:k),u[f+191|0]<0&&Z(i[f+180>>2]),n=Y(S0(Y(n,21067,14),l[e+115|0]),42670,1),k=f+180|0,s0(k,r),o=k,k=u[f+191|0],t=(k|0)<0,Y(n,t?i[f+180>>2]:o,t?i[f+184>>2]:k),u[f+191|0]<0&&Z(i[f+180>>2]),n=Y(S0(Y(n,31132,32),l[e+116|0]),42670,1),k=f+180|0,s0(k,r),o=k,k=u[f+191|0],t=(k|0)<0,Y(n,t?i[f+180>>2]:o,t?i[f+184>>2]:k),u[f+191|0]<0&&Z(i[f+180>>2]),Y(S0(Y(n,31177,30),l[e+117|0]),42670,1)),n=f+180|0,s0(n,r),o=n,n=u[f+191|0],k=(n|0)<0,Y(f+32|0,k?i[f+180>>2]:o,k?i[f+184>>2]:n),u[f+191|0]<0&&Z(i[f+180>>2]),n=f+32|0,Y(V0(Y(n,29774,15),i[e+180>>2]-i[e+176>>2]>>4),42670,1),k=f+180|0,s0(k,r),o=n,t=k,n=u[f+191|0],k=(n|0)<0,Y(o,k?i[f+180>>2]:t,k?i[f+184>>2]:n),u[f+191|0]<0&&Z(i[f+180>>2]),Y(f+32|0,41766,13),w=i[e+176>>2],X=i[e+180>>2],(w|0)!=(X|0))for(e=i[r>>2]+1|0;;){i[r>>2]=e,e=f+180|0,s0(e,r),k=e,e=u[f+191|0],n=(e|0)<0,Y(f+32|0,n?i[f+180>>2]:k,n?i[f+184>>2]:e),u[f+191|0]<0&&Z(i[f+180>>2]),k=Y(S0(Y(f+32|0,31766,10),l[w+1|0]),27147,2),e=l[w+1|0]-12&255,e>>>0>7?e=20212:e=i[(e<<2)+99888>>2],Y(Y(k,e,h2(e)),42669,2),e=f+180|0,s0(e,r),k=e,e=u[f+191|0],n=(e|0)<0,Y(f+32|0,n?i[f+180>>2]:k,n?i[f+184>>2]:e),u[f+191|0]<0&&Z(i[f+180>>2]),Y(S0(Y(f+32|0,29845,20),l[w|0]),42670,1);i:{if(e=i[w+4>>2],Q=i[w+8>>2],(e|0)==(Q|0))break i;for(;;){e:{i[r>>2]=i[r>>2]+1,n=f+20|0,s0(n,r),k=i[e>>2],S9(f+8|0,k,i[e+4>>2]-k|0,n,n),s=u[f+19|0],o=i[f+8>>2],_=i[f+12>>2],n=f+32|0,V=G1(f+172|0,n);r:{if(l[V|0]!=1)break r;k=n+i[i[f+32>>2]-12>>2]|0,I=i[k+4>>2],h=i[k+24>>2];f:{if(l[k+80|0]==1){n=l[k+76|0]|l[k+77|0]<<8|(l[k+78|0]<<16|l[k+79|0]<<24);break f}t=f+180|0,n=i[k+28>>2],i[t>>2]=n,(n|0)!=129576&&(i[n+4>>2]=i[n+4>>2]+1),n=c0(t,129760),n=W[i[i[n>>2]+28>>2]](n,32)|0,e2(t),u[k+76|0]=n,u[k+77|0]=n>>>8,u[k+78|0]=n>>>16,u[k+79|0]=n>>>24,u[k+80|0]=1}f:{if(!h||(B=i[k+12>>2],t=o,o=(s|0)<0,t=o?t:f+8|0,s=o?_:s,F=t+s|0,o=(I&176)==32?F:t,_=o-t|0,(_|0)>0&&(W[i[i[h>>2]+48>>2]](h,t,_)|0)!=(_|0)))break f;if(t=(s|0)<(B|0)?B-s|0:0,(t|0)>0){if(t>>>0>=2147483640)break e;A:{if(t>>>0>=11){B=t|7,s=p(B+1|0),i[f+188>>2]=B-2147483647,i[f+180>>2]=s,i[f+184>>2]=t;break A}u[f+191|0]=t,s=f+180|0}if(t&&o0(s,n,t),u[t+s|0]=0,n=W[i[i[h>>2]+48>>2]](h,u[f+191|0]<0?i[f+180>>2]:f+180|0,t)|0,u[f+191|0]<0&&Z(i[f+180>>2]),(n|0)!=(t|0))break f}if(n=F-o|0,(n|0)>0&&(W[i[i[h>>2]+48>>2]](h,o,n)|0)!=(n|0))break f;i[k+12>>2]=0;break r}n=i[i[f+32>>2]-12>>2]+(f+32|0)|0,H1(n,i[n+16>>2]|5)}if(_1(V),u[f+19|0]<0&&Z(i[f+8>>2]),n=i[r>>2],i[r>>2]=((n|0)<=1?1:n)-1,u[f+31|0]<0&&Z(i[f+20>>2]),e=e+12|0,(Q|0)!=(e|0))continue;break i}break}Q0(),H()}if(e=i[r>>2],e=(e|0)<=1?1:e,i[r>>2]=e-1,w=w+16|0,(X|0)==(w|0))break}e=i[f+84>>2];i:{e:{if(e&16){r=i[f+80>>2],e=i[f+60>>2],r>>>0<e>>>0&&(i[f+80>>2]=e,r=e),e=f+56|0;break e}if(!(e&8)){r=0,u[A+11|0]=0;break i}r=i[f+52>>2],e=f+44|0}e:{if(n=i[e>>2],r=r-n|0,r>>>0<2147483640){if(r>>>0>=11){k=r|7,e=p(k+1|0),i[A+8>>2]=k-2147483647,i[A>>2]=e,i[A+4>>2]=r,A=e;break e}if(u[A+11|0]=r,r)break e;r=0;break i}Q0(),H()}if(!r)break i;x(A,n,r)}u[A+r|0]=0,A=i[18127],i[f+32>>2]=A,i[i[A-12>>2]+(f+32|0)>>2]=i[18130],i[m>>2]=71232,u[f+79|0]<0&&Z(i[f+68>>2]),E0(m),y0(f+88|0),v=f+192|0}function K7(A,e,r,f,k){var n=0,t=0,o=0,s=0,w=0,h=0,_=0,B=U(0),m=0,X=0,Q=U(0);_=v-16|0,v=_,i[_+12>>2]=r;i:{e:{if(t=i[k+4>>2],!t)break e;n=i[k>>2],h=Re(t),s=t-1&r;r:{if(h>>>0<=1||(s=r,r>>>0<t>>>0))break r;s=(r>>>0)%(t>>>0)|0}if(n=i[n+(s<<2)>>2],!n||(n=i[n>>2],!n))break e;r:{if(h>>>0<=1){for(o=t-1|0;;){t=i[n+4>>2];f:{if((t|0)!=(r|0)){if((s|0)==(t&o))break f;break e}if(i[n+8>>2]==(r|0))break r}if(n=i[n>>2],!n)break}break e}for(;;){o=i[n+4>>2];f:{if((o|0)!=(r|0)){if(t>>>0<=o>>>0&&(o=(o>>>0)%(t>>>0)|0),(o|0)==(s|0))break f;break e}if(i[n+8>>2]==(r|0))break r}if(n=i[n>>2],!n)break}break e}if(e=p(24),i[_>>2]=e,i[_+4>>2]=21,i[_+8>>2]=-2147483624,r=l[13592]|l[13593]<<8|(l[13594]<<16|l[13595]<<24),f=l[13588]|l[13589]<<8|(l[13590]<<16|l[13591]<<24),u[e|0]=f,u[e+1|0]=f>>>8,u[e+2|0]=f>>>16,u[e+3|0]=f>>>24,u[e+4|0]=r,u[e+5|0]=r>>>8,u[e+6|0]=r>>>16,u[e+7|0]=r>>>24,u[e+21|0]=0,r=l[13605]|l[13606]<<8|(l[13607]<<16|l[13608]<<24),f=l[13601]|l[13602]<<8|(l[13603]<<16|l[13604]<<24),u[e+13|0]=f,u[e+14|0]=f>>>8,u[e+15|0]=f>>>16,u[e+16|0]=f>>>24,u[e+17|0]=r,u[e+18|0]=r>>>8,u[e+19|0]=r>>>16,u[e+20|0]=r>>>24,r=l[13600]|l[13601]<<8|(l[13602]<<16|l[13603]<<24),f=l[13596]|l[13597]<<8|(l[13598]<<16|l[13599]<<24),u[e+8|0]=f,u[e+9|0]=f>>>8,u[e+10|0]=f>>>16,u[e+11|0]=f>>>24,u[e+12|0]=r,u[e+13|0]=r>>>8,u[e+14|0]=r>>>16,u[e+15|0]=r>>>24,q(A,2,2008,_),u[_+11|0]>=0)break i;Z(i[_>>2]);break i}r=0,s=i[_+12>>2],t=i[k+4>>2];e:{r:{if(!t)break r;n=i[k>>2],o=Re(t),r=s&t-1;f:{if(o>>>0<=1||(r=s,r>>>0<t>>>0))break f;r=(r>>>0)%(t>>>0)|0}if(n=i[n+(r<<2)>>2],!n||(w=i[n>>2],!w))break r;if(o>>>0<=1){for(n=t-1|0;;){f:{if(o=i[w+4>>2],(o|0)!=(s|0)){if((n&o)!=(r|0))break r;break f}if((s|0)!=i[w+8>>2])break f;r=0;break e}if(w=i[w>>2],!w)break}break r}for(;;){f:{if(n=i[w+4>>2],(n|0)!=(s|0)){if(n>>>0>=t>>>0&&(n=(n>>>0)%(t>>>0)|0),(r|0)!=(n|0))break r;break f}if((s|0)!=i[w+8>>2])break f;r=0;break e}if(w=i[w>>2],!w)break}}w=p(12),i[w+4>>2]=s,i[w>>2]=0,i[w+8>>2]=i[_+12>>2],Q=U(i[k+12>>2]+1>>>0),B=p0[k+16>>2];r:{if(!(Q>U(B*U(t>>>0)))&&t)break r;r=2,o=(t-1&t)!=0|t>>>0<3|t<<1,B=U(W7(U(Q/B))),B<U(4294967296)&B>=U(0)?n=~~B>>>0:n=0,n=n>>>0<o>>>0?o:n;f:{if((n|0)==1)break f;if(!(n&n-1)){r=n;break f}r=i9(n),t=i[k+4>>2]}f:{if(r>>>0<=t>>>0){if(r>>>0>=t>>>0)break f;B=U(W7(U(U(u0[k+12>>2])/p0[k+16>>2]))),B<U(4294967296)&B>=U(0)?n=~~B>>>0:n=0;A:{k:{if(t>>>0<3||Re(t)>>>0>1)break k;n=n>>>0<2?n:1<<32-k1(n-1|0);break A}n=i9(n)}if(r=r>>>0>n>>>0?r:n,t>>>0<=r>>>0)break f}h=r;A:{k:{n:{if(r){if(r>>>0>=1073741824)break n;if(r=r<<2,m=p(r),n=i[k>>2],i[k>>2]=m,n&&(Z(n),m=i[k>>2]),i[k+4>>2]=h,r&&o0(m,0,r),r=i[k+8>>2],!r)break A;if(n=k+8|0,t=i[r+4>>2],o=h-1|0,!(o&h))break k;for(t=t>>>0>=h>>>0?(t>>>0)%(h>>>0)|0:t,i[(t<<2)+m>>2]=n;;){if(o=i[r>>2],!o)break A;if(n=i[o+4>>2],h>>>0<=n>>>0&&(n=(n>>>0)%(h>>>0)|0),(n|0)==(t|0)){r=o;continue}X=(n<<2)+m|0,i[X>>2]?(i[r>>2]=i[o>>2],i[o>>2]=i[i[X>>2]>>2],i[i[X>>2]>>2]=o):(i[X>>2]=r,r=o,t=n)}}r=i[k>>2],i[k>>2]=0,r&&Z(r),i[k+4>>2]=0;break A}z0(),H()}if(t=t&o,i[(t<<2)+m>>2]=n,n=i[r>>2],!n)break A;for(X=h-1|0;;){o=X&i[n+4>>2];k:{if((o|0)==(t|0)){r=n;break k}if(h=(o<<2)+m|0,i[h>>2]){i[r>>2]=i[n>>2],i[n>>2]=i[i[h>>2]>>2],i[i[h>>2]>>2]=n;break k}i[h>>2]=r,r=n,t=o}if(n=i[r>>2],!n)break}}}if(t=i[k+4>>2],r=t-1|0,!(r&t)){r=r&s;break r}if(t>>>0>s>>>0){r=s;break r}r=(s>>>0)%(t>>>0)|0}n=i[k>>2],o=n+(r<<2)|0,r=i[o>>2];r:{if(!r){if(r=k+8|0,i[w>>2]=i[r>>2],i[k+8>>2]=w,i[o>>2]=r,r=i[w>>2],!r)break r;r=i[r+4>>2],o=t-1|0;f:{if(!(o&t)){r=r&o;break f}if(r>>>0<t>>>0)break f;r=(r>>>0)%(t>>>0)|0}i[n+(r<<2)>>2]=w;break r}i[w>>2]=i[r>>2],i[r>>2]=w}i[k+12>>2]=i[k+12>>2]+1,r=1}u[_+4|0]=r,i[_>>2]=w,P8(_,i[f>>2],i[_+12>>2],1684630887),n=i[_>>2],r=i[_+4>>2];e:{if((n|0)!=(r|0))for(;;){if(K7(A,e,i[n>>2],f,k),i[A>>2])break e;if(u[A+19|0]<0&&Z(i[A+8>>2]),n=n+4|0,(r|0)==(n|0))break}h=v-16|0,v=h,o=i[k+4>>2];r:{if(!o)break r;f=i[k>>2],r=i[_+12>>2],e=r&o-1,s=Re(o);f:{if(s>>>0<=1||(e=r,r>>>0<o>>>0))break f;e=(r>>>0)%(o>>>0)|0}if(n=e,e=i[(n<<2)+f>>2],!e||(e=i[e>>2],!e))break r;f:{if(s>>>0<=1){for(f=o-1|0;;){o=i[e+4>>2];A:{if((o|0)!=(r|0)){if((n|0)==(f&o))break A;break r}if((r|0)==i[e+8>>2])break f}if(e=i[e>>2],!e)break}break r}for(;;){f=i[e+4>>2];A:{if((f|0)!=(r|0)){if(f>>>0>=o>>>0&&(f=(f>>>0)%(o>>>0)|0),(f|0)==(n|0))break A;break r}if((r|0)==i[e+8>>2])break f}if(e=i[e>>2],!e)break}break r}t=i[e+4>>2],s=i[k+4>>2],w=Re(s);f:{if(w>>>0<=1){t=s-1&t;break f}if(t>>>0<s>>>0)break f;t=(t>>>0)%(s>>>0)|0}for(m=i[k>>2],n=m+(t<<2)|0,f=i[n>>2];r=f,f=i[r>>2],(f|0)!=(e|0););X=k+8|0;f:{if((X|0)!=(r|0)){f=i[r+4>>2];A:{if(w>>>0<=1){f=s-1&f;break A}if(f>>>0<s>>>0)break A;f=(f>>>0)%(s>>>0)|0}if((f|0)==(t|0))break f}if(f=i[e>>2],f){f=i[f+4>>2];A:{if(w>>>0<=1){f=s-1&f;break A}if(f>>>0<s>>>0)break A;f=(f>>>0)%(s>>>0)|0}if((f|0)==(t|0))break f}i[n>>2]=0}o=i[e>>2],n=0;f:{if(!o)break f;f=i[o+4>>2];A:{if(w>>>0<=1){f=s-1&f;break A}if(f>>>0<s>>>0)break A;f=(f>>>0)%(s>>>0)|0}if(n=o,(f|0)==(t|0))break f;i[m+(f<<2)>>2]=r,n=i[e>>2]}i[r>>2]=n,i[e>>2]=0,i[k+12>>2]=i[k+12>>2]-1,u[h+12|0]=1,i[h+8>>2]=X,i[h+4>>2]=e,e=i[h+4>>2],i[h+4>>2]=0,e&&Z(e)}if(v=h+16|0,e=i[26917],i[A>>2]=i[26916],i[A+4>>2]=e,A=A+8|0,u[107683]>=0){e=i[26919],i[A>>2]=i[26918],i[A+4>>2]=e,i[A+8>>2]=i[26920];break e}T(A,i[26918],i[26919])}if(A=i[_>>2],!A)break i;i[_+4>>2]=A,Z(A)}v=_+16|0}function CB(A,e,r,f,k,n){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0;var t=0,o=0,s=0,w=0,h=0,_=0;f=v-96|0,v=f,i[f+56>>2]=0,i[f+60>>2]=0,e=f- -64|0,i[e>>2]=0,i[e+4>>2]=0,u[f+71|0]=0,u[f+72|0]=0,u[f+73|0]=0,u[f+74|0]=0,i[f+48>>2]=0,i[f+52>>2]=0,i[f+76>>2]=0,i[f+80>>2]=0,i[f+88>>2]=0,u[f+84|0]=1;i:{e:{e=i[r>>2];r:{if(i[e+116>>2]!=2){e=p(40),i[f+12>>2]=e,i[f+16>>2]=39,i[f+20>>2]=-2147483608,r=l[8950]|l[8951]<<8|(l[8952]<<16|l[8953]<<24),k=l[8946]|l[8947]<<8|(l[8948]<<16|l[8949]<<24),u[e+31|0]=k,u[e+32|0]=k>>>8,u[e+33|0]=k>>>16,u[e+34|0]=k>>>24,u[e+35|0]=r,u[e+36|0]=r>>>8,u[e+37|0]=r>>>16,u[e+38|0]=r>>>24,r=l[8943]|l[8944]<<8|(l[8945]<<16|l[8946]<<24),k=l[8939]|l[8940]<<8|(l[8941]<<16|l[8942]<<24),u[e+24|0]=k,u[e+25|0]=k>>>8,u[e+26|0]=k>>>16,u[e+27|0]=k>>>24,u[e+28|0]=r,u[e+29|0]=r>>>8,u[e+30|0]=r>>>16,u[e+31|0]=r>>>24,r=l[8935]|l[8936]<<8|(l[8937]<<16|l[8938]<<24),k=l[8931]|l[8932]<<8|(l[8933]<<16|l[8934]<<24),u[e+16|0]=k,u[e+17|0]=k>>>8,u[e+18|0]=k>>>16,u[e+19|0]=k>>>24,u[e+20|0]=r,u[e+21|0]=r>>>8,u[e+22|0]=r>>>16,u[e+23|0]=r>>>24,r=l[8927]|l[8928]<<8|(l[8929]<<16|l[8930]<<24),k=l[8923]|l[8924]<<8|(l[8925]<<16|l[8926]<<24),u[e+8|0]=k,u[e+9|0]=k>>>8,u[e+10|0]=k>>>16,u[e+11|0]=k>>>24,u[e+12|0]=r,u[e+13|0]=r>>>8,u[e+14|0]=r>>>16,u[e+15|0]=r>>>24,r=l[8919]|l[8920]<<8|(l[8921]<<16|l[8922]<<24),k=l[8915]|l[8916]<<8|(l[8917]<<16|l[8918]<<24),u[e|0]=k,u[e+1|0]=k>>>8,u[e+2|0]=k>>>16,u[e+3|0]=k>>>24,u[e+4|0]=r,u[e+5|0]=r>>>8,u[e+6|0]=r>>>16,u[e+7|0]=r>>>24,u[e+39|0]=0,e=q(f+24|0,4,3002,f+12|0),r=i[e+4>>2],i[A>>2]=i[e>>2],i[A+4>>2]=r,r=A+8|0;f:{if(u[e+19|0]>=0){k=i[e+12>>2],i[r>>2]=i[e+8>>2],i[r+4>>2]=k,i[r+8>>2]=i[e+16>>2],u[A+44|0]=1;break f}if(T(r,i[e+8>>2],i[e+12>>2]),r=u[e+19|0],u[A+44|0]=1,(r|0)>=0)break f;Z(i[e+8>>2])}if(u[f+23|0]>=0)break r;Z(i[f+12>>2]);break r}if((j0(e,0)|0)!=8){e=p(40),i[f+12>>2]=e,i[f+16>>2]=37,i[f+20>>2]=-2147483608,r=l[8910]|l[8911]<<8|(l[8912]<<16|l[8913]<<24),k=l[8906]|l[8907]<<8|(l[8908]<<16|l[8909]<<24),u[e+29|0]=k,u[e+30|0]=k>>>8,u[e+31|0]=k>>>16,u[e+32|0]=k>>>24,u[e+33|0]=r,u[e+34|0]=r>>>8,u[e+35|0]=r>>>16,u[e+36|0]=r>>>24,r=l[8905]|l[8906]<<8|(l[8907]<<16|l[8908]<<24),k=l[8901]|l[8902]<<8|(l[8903]<<16|l[8904]<<24),u[e+24|0]=k,u[e+25|0]=k>>>8,u[e+26|0]=k>>>16,u[e+27|0]=k>>>24,u[e+28|0]=r,u[e+29|0]=r>>>8,u[e+30|0]=r>>>16,u[e+31|0]=r>>>24,r=l[8897]|l[8898]<<8|(l[8899]<<16|l[8900]<<24),k=l[8893]|l[8894]<<8|(l[8895]<<16|l[8896]<<24),u[e+16|0]=k,u[e+17|0]=k>>>8,u[e+18|0]=k>>>16,u[e+19|0]=k>>>24,u[e+20|0]=r,u[e+21|0]=r>>>8,u[e+22|0]=r>>>16,u[e+23|0]=r>>>24,r=l[8889]|l[8890]<<8|(l[8891]<<16|l[8892]<<24),k=l[8885]|l[8886]<<8|(l[8887]<<16|l[8888]<<24),u[e+8|0]=k,u[e+9|0]=k>>>8,u[e+10|0]=k>>>16,u[e+11|0]=k>>>24,u[e+12|0]=r,u[e+13|0]=r>>>8,u[e+14|0]=r>>>16,u[e+15|0]=r>>>24,r=l[8881]|l[8882]<<8|(l[8883]<<16|l[8884]<<24),k=l[8877]|l[8878]<<8|(l[8879]<<16|l[8880]<<24),u[e|0]=k,u[e+1|0]=k>>>8,u[e+2|0]=k>>>16,u[e+3|0]=k>>>24,u[e+4|0]=r,u[e+5|0]=r>>>8,u[e+6|0]=r>>>16,u[e+7|0]=r>>>24,u[e+37|0]=0,e=q(f+24|0,4,3002,f+12|0),r=i[e+4>>2],i[A>>2]=i[e>>2],i[A+4>>2]=r,r=A+8|0;f:{if(u[e+19|0]>=0){k=i[e+12>>2],i[r>>2]=i[e+8>>2],i[r+4>>2]=k,i[r+8>>2]=i[e+16>>2],u[A+44|0]=1;break f}if(T(r,i[e+8>>2],i[e+12>>2]),r=u[e+19|0],u[A+44|0]=1,(r|0)>=0)break f;Z(i[e+8>>2])}if(u[f+23|0]>=0)break r;Z(i[f+12>>2]);break r}i[f+32>>2]=0,i[f+24>>2]=0,i[f+28>>2]=0,t=i[r>>2],k=i[t+128>>2],n=0;f:{if(!k)break f;for(n=t+128|0,e=n;o=i[k+16>>2],e=(o|0)<0?e:k,k=i[(o>>>29&4)+k>>2],!!k;);if((e|0)==(n|0)){o=0,n=0;break f}if(o=0,n=0,i[e+16>>2]>0)break f;o=i[e+44>>2],n=i[e+56>>2]}f:{A:{k:{if(s=i[t+112>>2],t=i[t+108>>2],e=G(s,t),e){if((e|0)<0)break k;k=p(e),e&&o0(k,0,e),w=e+k|0,i[f+32>>2]=w,i[f+28>>2]=w,i[f+24>>2]=k}if((n|0)==(t|0))break A;if(!s)break f;for(k=0;Ue(f+48|0,o+G(k,n)|0,t),k=k+1|0,(s|0)!=(k|0););break f}G0(),H()}Ue(f+48|0,o,e)}k=p(128),e=k,i[e+4>>2]=0,i[e+8>>2]=0,i[e>>2]=92164,n=e+16|0,e=n,i[e+8>>2]=0,i[e+12>>2]=0,i[e+16>>2]=0,i[e+20>>2]=0,i[e+24>>2]=0,i[e+28>>2]=0,i[e+32>>2]=0,i[e>>2]=86356,i[k+60>>2]=0,i[k+64>>2]=0,i[k+52>>2]=0,i[k+56>>2]=0,i[k+72>>2]=-1,i[k+76>>2]=-1,i[k+80>>2]=-1,i[k+84>>2]=-1,i[k+116>>2]=0,i[k+88>>2]=0,i[k+92>>2]=0,i[k+96>>2]=0,i[k+100>>2]=0,i[k+104>>2]=0,i[k+108>>2]=0,g[k+112>>1]=0,i[e>>2]=100312,i[k+32>>2]=1836280643,u[k+120|0]=0,h=k,_=j0(i[r>>2],0),u[h+120|0]=_,i[k+4>>2]=i[k+4>>2]+1,e=i[f+56>>2],r=i[f+52>>2];f:{if(e>>>0>r>>>0){i[r+4>>2]=k,i[r>>2]=n,n=r+8|0;break f}if(o=i[f+48>>2],r=r-o|0,w=r>>3,t=w+1|0,t>>>0>=536870912)break e;if(e=e-o|0,s=e>>2,t=e>>>0>=2147483640?536870911:t>>>0<s>>>0?s:t,t){if(t>>>0>=536870912)break i;e=p(t<<3)}else e=0;if(s=e+r|0,i[s+4>>2]=k,i[s>>2]=n,w=s-(w<<3)|0,r&&x(w,o,r),e=e+(t<<3)|0,i[f+56>>2]=e,n=s+8|0,i[f+52>>2]=n,i[f+48>>2]=w,!o)break f;Z(o),e=i[f+56>>2]}if(r=i[f+60>>2],o=i[f+64>>2],i[f+56>>2]=0,i[f+60>>2]=0,t=i[f+48>>2],i[f+48>>2]=0,i[f+52>>2]=0,s=i[f+68>>2],i[f+64>>2]=0,i[f+68>>2]=0,i[A+20>>2]=s,i[A+12>>2]=r,i[A+16>>2]=o,i[A+8>>2]=e,i[A+4>>2]=n,i[A>>2]=t,e=i[f+76>>2],i[A+24>>2]=i[f+72>>2],i[A+28>>2]=e,e=i[f+84>>2],i[A+32>>2]=i[f+80>>2],i[A+36>>2]=e,i[A+40>>2]=i[f+88>>2],u[A+44|0]=0,A=i[k+4>>2],i[k+4>>2]=A-1,A||(W[i[i[k>>2]+8>>2]](k),y(k)),A=i[f+24>>2],!A)break r;i[f+28>>2]=A,Z(A)}if(A=i[f+60>>2],A&&(i[f+64>>2]=A,Z(A)),A=i[f+48>>2],A){if(e=A,k=i[f+52>>2],(e|0)!=(k|0)){for(;;){e=i[k-4>>2];r:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break r;W[i[i[e>>2]+8>>2]](e),y(e)}if(k=k-8|0,(A|0)==(k|0))break}e=i[f+48>>2]}i[f+52>>2]=A,Z(e)}v=f+96|0;return}G0(),H()}z0(),H()}function pB(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0;var k=0,n=0,t=0,o=0,s=0,w=0,h=0,_=0,B=0,m=0,X=0,Q=0,V=0,F=0,I=0,E=0,R=0,N=0,M=0,z=0,S=0,O=0,P=0,a=0,$=0,f0=0,A0=0,n0=0,_0=0,m0=0,X0=0,g0=0;n=v-272|0,v=n,z2(n+252|0,e,r),u[n+271|0]<0&&Z(i[n+260>>2]);i:{if(l[e+97|0]<=1){for(m0=e+104|0,B=A+8|0,F=i[18051],E=F-12|0,R=i[18052]-12|0,N=i[18055]-12|0,I=i[18053],M=I-12|0,z=n+40|0,S=n+52|0,_=n- -64|0,Q=n+32|0,V=n+28|0,O=n+84|0,P=i[18060],a=i[18059],$=i[18057],f0=i[18056],A0=i[18054];;){e:{r:{f:{A:{k:{n:{t:{u:{o:{if(i[r+16>>2]){if(i[n+192>>2]=86356,i[n+224>>2]=0,i[n+216>>2]=0,i[n+220>>2]=0,i[n+208>>2]=0,i[n+212>>2]=0,i[n+200>>2]=0,i[n+204>>2]=0,i[n+244>>2]=0,i[n+236>>2]=0,i[n+240>>2]=0,$6(n+168|0,n+192|0,r),i[n+168>>2]!=i[26916]){k=i[n+172>>2],i[A>>2]=i[n+168>>2],i[A+4>>2]=k,i[B+8>>2]=i[n+184>>2],k=i[n+180>>2],i[B>>2]=i[n+176>>2],i[B+4>>2]=k,i[n+176>>2]=0,i[n+180>>2]=0,i[n+184>>2]=0,k=0;break e}if(n0=l[e+97|0]?32:16,X0=n,g0=wn(r,n0),i[X0+232>>2]=g0,w=o2(r),!w){k=p(56),i[n+20>>2]=k,i[n+24>>2]=48,i[n+28>>2]=-2147483592,t=l[24194]|l[24195]<<8|(l[24196]<<16|l[24197]<<24),o=l[24190]|l[24191]<<8|(l[24192]<<16|l[24193]<<24),u[k|0]=o,u[k+1|0]=o>>>8,u[k+2|0]=o>>>16,u[k+3|0]=o>>>24,u[k+4|0]=t,u[k+5|0]=t>>>8,u[k+6|0]=t>>>16,u[k+7|0]=t>>>24,u[k+48|0]=0,t=l[24234]|l[24235]<<8|(l[24236]<<16|l[24237]<<24),o=l[24230]|l[24231]<<8|(l[24232]<<16|l[24233]<<24),u[k+40|0]=o,u[k+41|0]=o>>>8,u[k+42|0]=o>>>16,u[k+43|0]=o>>>24,u[k+44|0]=t,u[k+45|0]=t>>>8,u[k+46|0]=t>>>16,u[k+47|0]=t>>>24,t=l[24226]|l[24227]<<8|(l[24228]<<16|l[24229]<<24),o=l[24222]|l[24223]<<8|(l[24224]<<16|l[24225]<<24),u[k+32|0]=o,u[k+33|0]=o>>>8,u[k+34|0]=o>>>16,u[k+35|0]=o>>>24,u[k+36|0]=t,u[k+37|0]=t>>>8,u[k+38|0]=t>>>16,u[k+39|0]=t>>>24,t=l[24218]|l[24219]<<8|(l[24220]<<16|l[24221]<<24),o=l[24214]|l[24215]<<8|(l[24216]<<16|l[24217]<<24),u[k+24|0]=o,u[k+25|0]=o>>>8,u[k+26|0]=o>>>16,u[k+27|0]=o>>>24,u[k+28|0]=t,u[k+29|0]=t>>>8,u[k+30|0]=t>>>16,u[k+31|0]=t>>>24,t=l[24210]|l[24211]<<8|(l[24212]<<16|l[24213]<<24),o=l[24206]|l[24207]<<8|(l[24208]<<16|l[24209]<<24),u[k+16|0]=o,u[k+17|0]=o>>>8,u[k+18|0]=o>>>16,u[k+19|0]=o>>>24,u[k+20|0]=t,u[k+21|0]=t>>>8,u[k+22|0]=t>>>16,u[k+23|0]=t>>>24,t=l[24202]|l[24203]<<8|(l[24204]<<16|l[24205]<<24),o=l[24198]|l[24199]<<8|(l[24200]<<16|l[24201]<<24),u[k+8|0]=o,u[k+9|0]=o>>>8,u[k+10|0]=o>>>16,u[k+11|0]=o>>>24,u[k+12|0]=t,u[k+13|0]=t>>>8,u[k+14|0]=t>>>16,u[k+15|0]=t>>>24,q(A,2,0,n+20|0),u[n+31|0]<0&&Z(i[n+20>>2]),k=0;break e}if(t=0,k=i[f+28>>2],!(!k|k>>>0>=w>>>0)){i[n+112>>2]=0,i[n+20>>2]=I,i[n+84>>2]=72196,i[n+28>>2]=72176,k=n+20|0,i[k+i[M>>2]>>2]=A0,i[n+24>>2]=0,t=k+i[i[n+20>>2]-12>>2]|0,J0(t,Q),u[t+80|0]=0,i[t+72>>2]=0,i[i[N>>2]+V>>2]=f0,i[k+i[R>>2]>>2]=$,i[n+84>>2]=72196,i[n+20>>2]=72156,i[n+28>>2]=72176,s=R0(Q),i[s>>2]=71232,i[_+8>>2]=0,i[_+12>>2]=0,i[_>>2]=0,i[_+4>>2]=0,i[n+80>>2]=24,Y(V0(Y(V0(Y(V,26934,34),w),28632,33),i[f+28>>2]),24226,12),k=i[n+80>>2];l:{if(k&16){if(k=S,t=i[n+76>>2],o=i[n+56>>2],t>>>0>=o>>>0)break l;i[n+76>>2]=o,t=o;break l}if(!(k&8)){k=0,u[n+19|0]=0,t=n+8|0;break r}t=i[n+48>>2],k=z}if(o=i[k>>2],k=t-o|0,k>>>0>=2147483640)break o;if(k>>>0>=11){w=k|7,t=p(w+1|0),i[n+16>>2]=w-2147483647,i[n+8>>2]=t,i[n+12>>2]=k;break f}if(u[n+19|0]=k,t=n+8|0,k)break f;k=0;break r}for(;;){if(!i[r+16>>2]){i[n+112>>2]=0,i[n+20>>2]=I,i[n+84>>2]=72196,i[n+28>>2]=72176,k=n+20|0,i[k+i[M>>2]>>2]=A0,i[n+24>>2]=0,o=k+i[i[n+20>>2]-12>>2]|0,J0(o,Q),u[o+80|0]=0,i[o+72>>2]=0,i[i[N>>2]+V>>2]=f0,i[k+i[R>>2]>>2]=$,i[n+84>>2]=72196,i[n+20>>2]=72156,i[n+28>>2]=72176,s=R0(Q),i[s>>2]=71232,i[_+8>>2]=0,i[_+12>>2]=0,i[_>>2]=0,i[_+4>>2]=0,i[n+80>>2]=24,Y(S0(Y(V0(Y(V,28226,24),w),29128,34),t),24226,12),k=i[n+80>>2];l:{if(k&16){if(k=S,t=i[n+76>>2],o=i[n+56>>2],t>>>0>=o>>>0)break l;i[n+76>>2]=o,t=o;break l}if(!(k&8)){k=0,u[n+19|0]=0,t=n+8|0;break A}t=i[n+48>>2],k=z}if(o=i[k>>2],k=t-o|0,k>>>0>=2147483640)break u;if(k>>>0>=11){w=k|7,t=p(w+1|0),i[n+16>>2]=w-2147483647,i[n+8>>2]=t,i[n+12>>2]=k;break k}if(u[n+19|0]=k,t=n+8|0,k)break k;k=0;break A}k=wn(r,n0),s=k,o=i[n+240>>2],h=i[n+244>>2];l:{if(o>>>0<h>>>0){i[o>>2]=k,k=o+4|0;break l}if(X=i[n+236>>2],k=o-X|0,_0=k>>2,o=_0+1|0,o>>>0>=1073741824)break t;if(h=h-X|0,m=h>>1,h=h>>>0>=2147483644?1073741823:o>>>0<m>>>0?m:o,h){if(h>>>0>=1073741824)break n;o=p(h<<2)}else o=0;if(m=o+k|0,i[m>>2]=s,s=m-(_0<<2)|0,k&&x(s,X,k),i[n+244>>2]=o+(h<<2),k=m+4|0,i[n+240>>2]=k,i[n+236>>2]=s,!X)break l;Z(X)}if(i[n+240>>2]=k,t=t+1|0,(w|0)==(t|0))break}k=i[e+108>>2];l:{if(k>>>0<u0[e+112>>2]){te(k,n+192|0),k=k+56|0;break l}k=nA(m0,n+192|0)}i[e+108>>2]=k,k=1;break e}if(B9(A,e),i[A>>2])break i;if(u[A+19|0]<0&&Z(i[A+8>>2]),l[r+20|0]==1){if(u[n+20|0]=0,u[n+31|0]=0,q(A,2,100,n+20|0),u[n+31|0]>=0)break i;Z(i[n+20>>2]);break i}if(e=i[26917],i[A>>2]=i[26916],i[A+4>>2]=e,u[107683]>=0){A=i[26919],i[B>>2]=i[26918],i[B+4>>2]=A,i[B+8>>2]=i[26920];break i}T(B,i[26918],i[26919]);break i}Q0(),H()}Q0(),H()}G0(),H()}z0(),H()}if(!k)break A;x(t,o,k)}u[k+t|0]=0,q(A,2,100,n+8|0),u[n+19|0]<0&&Z(i[n+8>>2]),i[n+20>>2]=F,i[i[E>>2]+(n+20|0)>>2]=a,i[n+28>>2]=P,i[s>>2]=71232,u[n+75|0]<0&&Z(i[n+64>>2]),E0(s),y0(O),k=0;break e}if(!k)break r;x(t,o,k)}u[k+t|0]=0,q(A,2,1e3,n+8|0),u[n+19|0]<0&&Z(i[n+8>>2]),i[n+20>>2]=F,i[i[E>>2]+(n+20|0)>>2]=a,i[n+28>>2]=P,i[s>>2]=71232,u[n+75|0]<0&&Z(i[n+64>>2]),E0(s),y0(O),k=0}if(u[n+187|0]<0&&Z(i[n+176>>2]),t=i[n+236>>2],t&&(i[n+240>>2]=t,Z(t)),i[n+192>>2]=86356,t=i[n+212>>2],t&&(i[n+216>>2]=t,Z(t)),!k)break}break i}t1(A,e,11368)}v=n+272|0}function yB(A,e,r,f,k,n){A=A|0,e=+e,r=r|0,f=f|0,k=k|0,n=n|0;var t=0,o=0,s=0,w=0,h=0,_=0,B=0,m=0,X=0,Q=0,V=0,F=0,I=0,E=0,R=0,N=0,M=0,z=0,S=0,O=0,P=0;m=v-560|0,v=m,i[m+44>>2]=0,M2(+e),o=t2(1)|0,t2(0)|0;i:{if((o|0)<0){I=1,M=2970,e=-e,M2(+e),o=t2(1)|0,t2(0)|0;break i}if(k&2048){I=1,M=2973;break i}I=k&1,M=I?2976:2971,S=!I}i:{if((o&2146435072)==2146435072){o=I+3|0,w4(A,32,r,o,k&-65537),t4(A,M,I),f=n&32,t4(A,e!=e?f?9336:19422:f?11305:19654,3),w4(A,32,r,o,k^8192),_=(r|0)>(o|0)?r:o;break i}R=m+16|0;e:{r:{f:{if(e=Xo(e,m+44|0),e=e+e,e!=0){if(o=i[m+44>>2],i[m+44>>2]=o-1,N=n|32,(N|0)!=97)break f;break e}if(N=n|32,(N|0)==97)break e;B=i[m+44>>2];break r}B=o-29|0,i[m+44>>2]=B,e=e*268435456}for(h=(f|0)<0?6:f,V=(m+48|0)+((B|0)>=0?288:0)|0,o=V;f=e<4294967295&e>=0?~~e>>>0:0,i[o>>2]=f,o=o+4|0,e=(e-+(f>>>0))*1e9,e!=0;);r:{if((B|0)<=0){w=B,t=o,s=V;break r}for(s=V,w=B;;){w=w>>>0>=29?29:w,t=o-4|0;f:{if(s>>>0>t>>>0)break f;for(X=0;f=i[t>>2],Q=w&31,_=X,(w&63)>>>0>=32?(X=f<<Q,f=0):(X=(1<<Q)-1&f>>>32-Q,f=f<<Q),_=_+f|0,Q=X+z|0,Q=f>>>0>_>>>0?Q+1|0:Q,X=d8(_,Q,1e9,0),O=t,P=_-O0(X,l0,1e9,0)|0,i[O>>2]=P,t=t-4|0,s>>>0<=t>>>0;);if(!Q&_>>>0<1e9)break f;s=s-4|0,i[s>>2]=X}for(;t=o,s>>>0<t>>>0&&(o=t-4|0,!i[o>>2]););if(w=i[m+44>>2]-w|0,i[m+44>>2]=w,o=t,!((w|0)>0))break}}if((w|0)<0)for(E=((h+25>>>0)/9|0)+1|0,Q=(N|0)==102;;){f=0-w|0,_=f>>>0>=9?9:f;r:{if(t>>>0<=s>>>0){o=i[s>>2]?0:4;break r}for(z=1e9>>>_|0,X=-1<<_^-1,w=0,o=s;f=i[o>>2],i[o>>2]=(f>>>_|0)+w,w=G(z,f&X),o=o+4|0,o>>>0<t>>>0;);if(o=i[s>>2]?0:4,!w)break r;i[t>>2]=w,t=t+4|0}if(w=_+i[m+44>>2]|0,i[m+44>>2]=w,s=o+s|0,f=Q?V:s,t=t-f>>2>(E|0)?f+(E<<2)|0:t,!((w|0)<0))break}w=0;r:{if(t>>>0<=s>>>0||(w=G(V-s>>2,9),o=10,f=i[s>>2],f>>>0<10))break r;for(;w=w+1|0,o=G(o,10),f>>>0>=o>>>0;);}if(f=(h-((N|0)!=102?w:0)|0)-((N|0)==103&(h|0)!=0)|0,(f|0)<(G(t-V>>2,9)-9|0)){if(o=(m+48|0)+((B|0)<0?-4092:-3804)|0,B=f+9216|0,f=(B|0)/9|0,_=o+(f<<2)|0,o=10,f=B-G(f,9)|0,(f|0)<=7)for(;o=G(o,10),f=f+1|0,(f|0)!=8;);B=i[_>>2],E=(B>>>0)/(o>>>0)|0,X=B-G(o,E)|0,f=_+4|0;r:{if(!X&(f|0)==(t|0))break r;f:{if(!(E&1)&&(e=9007199254740992,!(u[_-4|0]&1)|((o|0)!=1e9|s>>>0>=_>>>0)))break f;e=9007199254740994}if(F=(f|0)==(t|0)?1:1.5,f=o>>>1|0,F=f>>>0>X>>>0?.5:(f|0)==(X|0)?F:1.5,l[M|0]!=45|S||(F=-F,e=-e),f=B-X|0,i[_>>2]=f,e+F==e)break r;if(f=f+o|0,i[_>>2]=f,f>>>0>=1e9)for(;i[_>>2]=0,_=_-4|0,_>>>0<s>>>0&&(s=s-4|0,i[s>>2]=0),f=i[_>>2]+1|0,i[_>>2]=f,f>>>0>999999999;);if(w=G(V-s>>2,9),o=10,f=i[s>>2],f>>>0<10)break r;for(;w=w+1|0,o=G(o,10),f>>>0>=o>>>0;);}f=_+4|0,t=f>>>0<t>>>0?f:t}for(;B=t,X=t>>>0<=s>>>0,!X&&(t=t-4|0,!i[t>>2]););r:{if((N|0)!=103){Q=k&8;break r}if(o=h||1,f=(o|0)>(w|0)&(w|0)>-5,h=(f?w^-1:-1)+o|0,n=(f?-1:-2)+n|0,Q=k&8,Q)break r;t=-9;f:{if(X||(X=i[B-4>>2],!X)||(f=10,t=0,(X>>>0)%10|0))break f;for(;o=t,t=t+1|0,f=G(f,10),!((X>>>0)%(f>>>0)|0););t=o^-1}if(f=G(B-V>>2,9),(n&-33)==70){Q=0,f=(f+t|0)-9|0,f=(f|0)>0?f:0,h=(f|0)>(h|0)?h:f;break r}Q=0,f=((f+w|0)+t|0)-9|0,f=(f|0)>0?f:0,h=(f|0)>(h|0)?h:f}if(_=-1,X=h|Q,((X?2147483645:2147483646)|0)<(h|0))break i;z=(((X|0)!=0)+h|0)+1|0,o=n&-33;r:{if((o|0)==70){if((z^2147483647)<(w|0))break i;t=(w|0)>0?w:0;break r}if(f=w>>31,t=vi((f^w)-f|0,0,R),(R-t|0)<=1)for(;t=t-1|0,u[t|0]=48,(R-t|0)<2;);if(E=t-2|0,u[E|0]=n,u[t-1|0]=(w|0)<0?45:43,t=R-E|0,(t|0)>(z^2147483647))break i}if(f=t+z|0,(f|0)>(I^2147483647))break i;w=f+I|0,w4(A,32,r,w,k),t4(A,M,I),w4(A,48,r,w,k^65536);r:{f:{A:{if((o|0)==70){for(o=m+16|9,n=s>>>0>V>>>0?V:s,s=n;;){t=vi(i[s>>2],0,o);k:{if((n|0)!=(s|0)){if(m+16>>>0>=t>>>0)break k;for(;t=t-1|0,u[t|0]=48,m+16>>>0<t>>>0;);break k}if((t|0)!=(o|0))break k;t=t-1|0,u[t|0]=48}if(t4(A,t,o-t|0),s=s+4|0,!(V>>>0>=s>>>0))break}if(X&&t4(A,26295,1),(h|0)<=0|s>>>0>=B>>>0)break A;for(;;){if(t=vi(i[s>>2],0,o),t>>>0>m+16>>>0)for(;t=t-1|0,u[t|0]=48,m+16>>>0<t>>>0;);if(t4(A,t,(h|0)>=9?9:h),t=h-9|0,s=s+4|0,B>>>0<=s>>>0)break f;if(f=(h|0)>9,h=t,!f)break}break f}k:{if((h|0)<0)break k;for(n=s>>>0<B>>>0?B:s+4|0,B=m+16|9,o=s;;){t=vi(i[o>>2],0,B),(B|0)==(t|0)&&(t=t-1|0,u[t|0]=48);n:{if((o|0)!=(s|0)){if(m+16>>>0>=t>>>0)break n;for(;t=t-1|0,u[t|0]=48,m+16>>>0<t>>>0;);break n}if(t4(A,t,1),t=t+1|0,!(h|Q))break n;t4(A,26295,1)}if(f=B-t|0,t4(A,t,(f|0)<(h|0)?f:h),h=h-f|0,o=o+4|0,n>>>0<=o>>>0)break k;if(!((h|0)>=0))break}}w4(A,48,h+18|0,18,0),t4(A,E,R-E|0);break r}t=h}w4(A,48,t+9|0,9,0)}w4(A,32,r,w,k^8192),_=(r|0)>(w|0)?r:w;break i}h=(n<<26>>31&9)+M|0;e:{if(f>>>0>11)break e;for(t=12-f|0,F=16;F=F*16,t=t-1|0,!!t;);if(l[h|0]==45){e=-(F+(-e-F));break e}e=e+F-F}for(o=i[m+44>>2],t=o>>31,t=vi((t^o)-t|0,0,R),(R|0)==(t|0)&&(t=t-1|0,u[t|0]=48,o=i[m+44>>2]),V=I|2,s=n&32,B=t-2|0,u[B|0]=n+15,u[t-1|0]=(o|0)<0?45:43,t=!(k&8)&(f|0)<=0,o=m+16|0;n=o,w=w2(e)<2147483647?~~e:-2147483648,u[o|0]=s|l[w+70272|0],e=(e-+(w|0))*16,o=o+1|0,t&e==0|(o-(m+16|0)|0)!=1||(u[n+1|0]=46,o=n+2|0),e!=0;);if(_=-1,t=R-B|0,n=t+V|0,(2147483645-n|0)<(f|0))break i;w=n,n=m+16|0,s=o-n|0,f=f&&(s-2|0)<(f|0)?f+2|0:s,o=w+f|0,w4(A,32,r,o,k),t4(A,h,V),w4(A,48,r,o,k^65536),t4(A,n,s),w4(A,48,f-s|0,0,0),t4(A,B,t),w4(A,32,r,o,k^8192),_=(r|0)>(o|0)?r:o}return v=m+560|0,_|0}function q7(A,e){var r=0,f=0,k=0,n=0,t=0,o=0,s=0,w=0,h=0,_=0,B=0,m=0,X=0,Q=0,V=0,F=0,I=0,E=0,R=0,N=0,M=0,z=0,S=0,O=0;Q=v-48|0,v=Q,M2(+A),h=t2(1)|0,r=t2(0)|0;i:{e:{o=h&2147483647;r:{if(o>>>0<=1074752122){if((h&1048575)==598523)break r;if(o>>>0<=1073928572){if((h|0)>0|(h|0)>=0){A=A+-1.5707963267341256,k=A+-6077100506506192e-26,t0[e>>3]=k,t0[e+8>>3]=A-k+-6077100506506192e-26,f=1;break i}A=A+1.5707963267341256,k=A+6077100506506192e-26,t0[e>>3]=k,t0[e+8>>3]=A-k+6077100506506192e-26,f=-1;break i}if((h|0)>0|(h|0)>=0){A=A+-3.1415926534682512,k=A+-12154201013012384e-26,t0[e>>3]=k,t0[e+8>>3]=A-k+-12154201013012384e-26,f=2;break i}A=A+3.1415926534682512,k=A+12154201013012384e-26,t0[e>>3]=k,t0[e+8>>3]=A-k+12154201013012384e-26,f=-2;break i}if(o>>>0<=1075594811){if(o>>>0<=1075183036){if((o|0)==1074977148)break r;if((h|0)>0|(h|0)>=0){A=A+-4.712388980202377,k=A+-18231301519518578e-26,t0[e>>3]=k,t0[e+8>>3]=A-k+-18231301519518578e-26,f=3;break i}A=A+4.712388980202377,k=A+18231301519518578e-26,t0[e>>3]=k,t0[e+8>>3]=A-k+18231301519518578e-26,f=-3;break i}if((o|0)==1075388923)break r;if((h|0)>0|(h|0)>=0){A=A+-6.2831853069365025,k=A+-2430840202602477e-25,t0[e>>3]=k,t0[e+8>>3]=A-k+-2430840202602477e-25,f=4;break i}A=A+6.2831853069365025,k=A+2430840202602477e-25,t0[e>>3]=k,t0[e+8>>3]=A-k+2430840202602477e-25,f=-4;break i}if(o>>>0>1094263290)break e}w=A*.6366197723675814+6755399441055744+-6755399441055744,w2(w)<2147483647?f=~~w:f=-2147483648,k=A+w*-1.5707963267341256,B=w*6077100506506192e-26,R=k-B;r:{if(R<-.7853981633974483){f=f-1|0,w=w+-1,B=w*6077100506506192e-26,k=A+w*-1.5707963267341256;break r}if(!(R>.7853981633974483))break r;f=f+1|0,w=w+1,B=w*6077100506506192e-26,k=A+w*-1.5707963267341256}A=k-B,t0[e>>3]=A,M2(+A),r=t2(1)|0,t2(0)|0,h=o>>>20|0;r:{if((h-(r>>>20&2047)|0)<17||(B=k,A=w*6077100506303966e-26,k=k-A,B=w*20222662487959506e-37-(B-k-A),A=k-B,t0[e>>3]=A,M2(+A),r=t2(1)|0,t2(0)|0,(h-(r>>>20&2047)|0)<50))break r;B=k,A=w*20222662487111665e-37,k=k-A,B=w*84784276603689e-45-(B-k-A),A=k-B,t0[e>>3]=A}t0[e+8>>3]=k-A-B;break i}if(o>>>0>=2146435072){A=A-A,t0[e>>3]=A,t0[e+8>>3]=A;break i}for(f=Q+16|0,n=f|8,D2(0,r|0),D2(1,h&1048575|1096810496),A=+r1(),r=1;k=+((w2(A)<2147483647?~~A:-2147483648)|0),t0[f>>3]=k,A=(A-k)*16777216,_=r,r=0,f=n,!!_;);for(t0[Q+32>>3]=A,f=2;r=f,f=r-1|0,I=Q+16|0,t0[I+(r<<3)>>3]==0;);if(n=0,t=v-560|0,v=t,f=(o>>>20|0)-1046|0,_=(f-3|0)/24|0,E=(_|0)>0?_:0,V=G(E,-24)+f|0,_=i[16177],F=r+1|0,s=F-1|0,(_+s|0)>=0)for(f=_+F|0,r=E-s|0;t0[(t+320|0)+(n<<3)>>3]=(r|0)<0?0:+i[(r<<2)+64720>>2],r=r+1|0,n=n+1|0,(f|0)!=(n|0););for(o=V-24|0,f=0,n=(_|0)>0?_:0,X=(F|0)<=0;;){e:{if(X){A=0;break e}for(m=f+s|0,r=0,A=0;A=t0[(r<<3)+I>>3]*t0[(t+320|0)+(m-r<<3)>>3]+A,r=r+1|0,(F|0)!=(r|0););}if(t0[(f<<3)+t>>3]=A,r=(f|0)==(n|0),f=f+1|0,!!r)break}S=47-V|0,N=48-V|0,O=V-25|0,f=_;e:{for(;;){if(A=t0[(f<<3)+t>>3],r=0,n=f,(f|0)>0)for(;X=(t+480|0)+(r<<2)|0,k=A*5960464477539063e-23,w2(k)<2147483647?s=~~k:s=-2147483648,k=+(s|0),A=k*-16777216+A,w2(A)<2147483647?s=~~A:s=-2147483648,i[X>>2]=s,n=n-1|0,A=t0[(n<<3)+t>>3]+k,r=r+1|0,(f|0)!=(r|0););A=A4(A,o),A=A+G_(A*.125)*-8,w2(A)<2147483647?X=~~A:X=-2147483648,A=A-+(X|0);r:{f:{A:{M=(o|0)<=0;k:{if(!M){n=(f<<2)+t|0,s=i[n+476>>2],r=s>>N,m=n,n=s-(r<<N)|0,i[m+476>>2]=n,X=r+X|0,s=n>>S;break k}if(o)break A;s=i[((f<<2)+t|0)+476>>2]>>23}if((s|0)<=0)break r;break f}if(s=2,A>=.5)break f;s=0;break r}if(r=0,m=0,n=1,(f|0)>0)for(;;){n=(t+480|0)+(r<<2)|0,z=i[n>>2];f:{A:{if(m)m=16777215;else{if(!z)break A;m=16777216}i[n>>2]=m-z,m=1,n=0;break f}m=0,n=1}if(r=r+1|0,(f|0)==(r|0))break}f:{if(M)break f;r=8388607;A:switch(O|0){case 1:r=4194303;break;case 0:break A;default:break f}m=(f<<2)+t|0,i[m+476>>2]=i[m+476>>2]&r}if(X=X+1|0,(s|0)!=2||(A=1-A,s=2,n))break r;A=A-A4(1,o)}if(A==0){n=0;r:{if(r=f,(_|0)>=(r|0))break r;for(;r=r-1|0,n=i[(t+480|0)+(r<<2)>>2]|n,(r|0)>(_|0););if(!n)break r;for(;o=o-24|0,f=f-1|0,!i[(t+480|0)+(f<<2)>>2];);break e}for(r=1;n=r,r=r+1|0,!i[(t+480|0)+(_-n<<2)>>2];);for(n=f+n|0;;){if(s=f+F|0,f=f+1|0,t0[(t+320|0)+(s<<3)>>3]=i[(E+f<<2)+64720>>2],r=0,A=0,(F|0)>0)for(;A=t0[(r<<3)+I>>3]*t0[(t+320|0)+(s-r<<3)>>3]+A,r=r+1|0,(F|0)!=(r|0););if(t0[(f<<3)+t>>3]=A,!((f|0)<(n|0)))break}f=n;continue}break}A=A4(A,24-V|0);r:{if(A>=16777216){o=(t+480|0)+(f<<2)|0,k=A*5960464477539063e-23,w2(k)<2147483647?r=~~k:r=-2147483648,A=+(r|0)*-16777216+A,w2(A)<2147483647?n=~~A:n=-2147483648,i[o>>2]=n,f=f+1|0,o=V;break r}r=w2(A)<2147483647?~~A:-2147483648}i[(t+480|0)+(f<<2)>>2]=r}if(A=A4(1,o),(f|0)>=0){for(r=f;n=r,t0[(r<<3)+t>>3]=A*+i[(t+480|0)+(r<<2)>>2],r=r-1|0,A=A*5960464477539063e-23,!!n;);for(n=f;;){if(A=0,r=0,o=f-n|0,V=(o|0)>(_|0)?_:o,(V|0)>=0)for(;A=t0[(r<<3)+67488>>3]*t0[(r+n<<3)+t>>3]+A,F=(r|0)!=(V|0),r=r+1|0,!!F;);if(t0[(t+160|0)+(o<<3)>>3]=A,r=(n|0)>0,n=n-1|0,!r)break}}if(A=0,(f|0)>=0)for(r=f;n=r,r=r-1|0,A=A+t0[(t+160|0)+(n<<3)>>3],!!n;);if(t0[Q>>3]=s?-A:A,A=t0[t+160>>3]-A,r=1,(f|0)>0)for(;A=A+t0[(t+160|0)+(r<<3)>>3],n=(r|0)!=(f|0),r=r+1|0,!!n;);if(t0[Q+8>>3]=s?-A:A,v=t+560|0,f=X&7,A=t0[Q>>3],(h|0)<0){t0[e>>3]=-A,t0[e+8>>3]=-t0[Q+8>>3],f=0-f|0;break i}t0[e>>3]=A,t0[e+8>>3]=t0[Q+8>>3]}return v=Q+48|0,f}function EB(A,e,r,f,k,n,t,o){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,t=t|0,o=o|0;var s=0,w=0,h=0,_=0,B=0,m=0,X=0,Q=0,V=0,F=0,I=0,E=0,R=0,N=0,M=0,z=0,S=0,O=0,P=0,a=0,$=0,f0=0,A0=0,n0=0,_0=0,m0=0,X0=0;s=v-128|0,v=s,h=j0(i[r>>2],0),t=j0(i[r>>2],1),n=j0(i[r>>2],2),z=u1(i[r>>2],6),z&&($=j0(i[r>>2],6));i:{if(!(!(h>>>0>8|t>>>0>8)&n>>>0<9)){e=i[26922],i[A>>2]=i[26921],i[A+4>>2]=e,r=A+8|0;e:{if(u[107703]>=0){e=i[26924],i[r>>2]=i[26923],i[r+4>>2]=e,i[r+8>>2]=i[26925];break e}T(r,i[26923],i[26924])}u[A+20|0]=1;break i}if(!((t|0)==(h|0)&(n|0)==(h|0))){e=i[26922],i[A>>2]=i[26921],i[A+4>>2]=e,r=A+8|0;e:{if(u[107703]>=0){e=i[26924],i[r>>2]=i[26923],i[r+4>>2]=e,i[r+8>>2]=i[26925];break e}T(r,i[26923],i[26924])}u[A+20|0]=1;break i}e=i[r>>2],m=i[e+112>>2],_=i[e+108>>2],w=p(172),i[w>>2]=94812,i[w+4>>2]=0,i[w+8>>2]=0,o0(w+16|0,0,80),e=i[w+4>>2],f=e+1|0,i[w+4>>2]=f,i[w+104>>2]=0,i[w+108>>2]=0,i[w+36>>2]=1,i[w+40>>2]=1,u[w+24|0]=1,g[w+22>>1]=2,g[w+18>>1]=2,g[w+20>>1]=2,i[w+112>>2]=0,i[w+116>>2]=4740,i[w+140>>2]=0,i[w+144>>2]=0,i[w+128>>2]=99,i[w+132>>2]=99,i[w+120>>2]=0,i[w+124>>2]=0,i[w+12>>2]=95160,i[w+148>>2]=0,i[w+152>>2]=0,k=w+140|0,i[w+136>>2]=k,i[w+156>>2]=0,i[w+160>>2]=0,i[w+164>>2]=0,i[w+168>>2]=0,i[w+4>>2]=e,e=i[w+8>>2],X=w+12|0,i[w+96>>2]=X,i[w+8>>2]=e+1,i[w+100>>2]=w,f||(W[i[i[w>>2]+8>>2]](w),y(w)),i[X+120>>2]=2,i[X+116>>2]=0,i[X+112>>2]=m,i[X+108>>2]=_,T0(s+56|0,X,0,_,m,h,o),Q=_+1>>>1|0,T0(s+32|0,X,1,Q,m,t,o),t=s+88|0;e:{if(i[s+56>>2]){if(e=i[s+60>>2],i[s+80>>2]=i[s+56>>2],i[s+84>>2]=e,u[s+75|0]>=0){f=s- -64|0,e=i[f+4>>2],i[t>>2]=i[f>>2],i[t+4>>2]=e,i[t+8>>2]=i[f+8>>2];break e}T(t,i[s+64>>2],i[s+68>>2]);break e}if(e=i[s+36>>2],i[s+80>>2]=i[s+32>>2],i[s+84>>2]=e,u[s+51|0]>=0){e=i[s+44>>2],i[t>>2]=i[s+40>>2],i[t+4>>2]=e,i[t+8>>2]=i[s+48>>2];break e}T(t,i[s+40>>2],i[s+44>>2])}T0(s+8|0,X,2,Q,m,n,o),f=s+112|0;e:{if(i[s+80>>2]){if(e=i[s+84>>2],i[s+104>>2]=i[s+80>>2],i[s+108>>2]=e,u[s+99|0]>=0){e=i[t+4>>2],i[f>>2]=i[t>>2],i[f+4>>2]=e,i[f+8>>2]=i[t+8>>2];break e}T(f,i[s+88>>2],i[s+92>>2]);break e}if(e=i[s+12>>2],i[s+104>>2]=i[s+8>>2],i[s+108>>2]=e,u[s+27|0]>=0){e=i[s+20>>2],i[f>>2]=i[s+16>>2],i[f+4>>2]=e,i[f+8>>2]=i[s+24>>2];break e}T(f,i[s+16>>2],i[s+20>>2])}u[s+27|0]<0&&Z(i[s+16>>2]),u[s+99|0]<0&&Z(i[s+88>>2]),u[s+51|0]<0&&Z(i[s+40>>2]),u[s+75|0]<0&&Z(i[s+64>>2]);e:{if(i[s+104>>2]){if(e=i[s+108>>2],i[A>>2]=i[s+104>>2],i[A+4>>2]=e,r=A+8|0,u[s+123|0]>=0){e=i[f+4>>2],i[r>>2]=i[f>>2],i[r+4>>2]=e,i[r+8>>2]=i[f+8>>2],u[A+20|0]=1;break e}if(T(r,i[s+112>>2],i[s+116>>2]),e=u[s+123|0],u[A+20|0]=1,(e|0)>=0)break e;Z(i[s+112>>2]);break e}u[s+123|0]<0&&Z(i[s+112>>2]);r:{if(!z)break r;if(T0(s+104|0,X,6,_,m,$,o),i[s+104>>2]){if(e=i[s+108>>2],i[A>>2]=i[s+104>>2],i[A+4>>2]=e,r=A+8|0,u[s+123|0]>=0){e=i[s+116>>2],i[r>>2]=i[s+112>>2],i[r+4>>2]=e,i[r+8>>2]=i[s+120>>2],u[A+20|0]=1;break e}if(T(r,i[s+112>>2],i[s+116>>2]),e=u[s+123|0],u[A+20|0]=1,(e|0)>=0)break e;Z(i[s+112>>2]);break e}if(u[s+123|0]>=0)break r;Z(i[s+112>>2])}e=i[r>>2],f=e+128|0;r:{f:{t=i[e+128>>2];A:{if(!t){o=0;break A}for(e=f,r=t;n=i[r+16>>2],e=(n|0)<0?e:r,r=i[(n>>>29&4)+r>>2],!!r;);I=0;k:{if((e|0)==(f|0)||(I=0,i[e+16>>2]>0))break k;_0=i[e+44>>2],I=i[e+56>>2]}for(e=f,r=t;n=i[r+16>>2]<=0,e=n?e:r,r=i[(n?4:0)+r>>2],!!r;);o=0;k:{if((e|0)==(f|0)||(o=0,i[e+16>>2]>1))break k;f0=i[e+44>>2],o=i[e+56>>2]}for(e=f,r=t;n=i[r+16>>2]<2,e=n?e:r,r=i[(n?4:0)+r>>2],!!r;);if((e|0)!=(f|0))break f}E=0;break r}if(E=0,i[e+16>>2]>2)break r;S=i[e+56>>2],E=i[e+44>>2]}r:{f:{if(e=i[k>>2],e){for(n=k,r=e;V=i[r+16>>2],n=(V|0)<0?n:r,r=i[(V>>>29&4)+r>>2],!!r;);V=0;A:{if((k|0)==(n|0)||(V=0,i[n+16>>2]>0))break A;m0=i[n+44>>2],V=i[n+56>>2]}for(n=k,r=e;h=i[r+16>>2]<=0,n=h?n:r,r=i[(h?4:0)+r>>2],!!r;);F=0;A:{if((k|0)==(n|0)||(F=0,i[n+16>>2]>1))break A;A0=i[n+44>>2],F=i[n+56>>2]}for(n=k,r=e;h=i[r+16>>2]<2,n=h?n:r,r=i[(h?4:0)+r>>2],!!r;);if((k|0)!=(n|0))break f}r=0;break r}if(r=0,i[n+16>>2]>2)break r;O=i[n+56>>2],r=i[n+44>>2]}h=r,n=0,B=0;r:{if(!z)break r;f:{A:{if(!t)break A;for(r=f;P=i[t+16>>2]<6,r=P?r:t,t=i[(P?4:0)+t>>2],!!t;);if((r|0)==(f|0))break A;if(f=0,i[r+16>>2]>6)break f;X0=i[r+44>>2],f=i[r+56>>2];break f}f=0}if(P=f,B=0,!e)break r;for(r=k;f=i[e+16>>2]<6,r=f?r:e,e=i[(f?4:0)+e>>2],!!e;);if(B=0,(r|0)==(k|0)||(B=0,i[r+16>>2]>6))break r;n=i[r+56>>2],B=i[r+44>>2]}f=B;r:{f:{A:{if(!(_&1))break A;if(k=m-1|0,!k)break f;if(R=(h+Q|0)-1|0,N=(_+E|0)-1|0,Q=(Q+A0|0)-1|0,M=(_+f0|0)-1|0,r=0,(m|0)!=2)for(e=k&-2;u[Q+G(r,F)|0]=l[M+G(r,o)|0],u[R+G(r,O)|0]=l[N+G(r,S)|0],t=r|1,u[Q+G(t,F)|0]=l[M+G(t,o)|0],u[R+G(t,O)|0]=l[N+G(t,S)|0],r=r+2|0,a=a+2|0,(e|0)!=(a|0););if(!(k&1))break A;u[Q+G(r,F)|0]=l[M+G(r,o)|0],u[R+G(r,O)|0]=l[N+G(r,S)|0]}if(!m)break r}if(n0=_-1|0,n0)for(e=0;;){for(B=G(e,O)+h|0,R=G(e,F)+A0|0,N=G(e,S)+E|0,Q=G(e,o)+f0|0,r=0;k=r+N|0,a=l[k|0],M=l[k+1|0],t=r>>>1|0,k=r+Q|0,u[R+t|0]=(l[k|0]+l[k+1|0]|0)+1>>>1,u[t+B|0]=(M+a|0)+1>>>1,r=r+2|0,n0>>>0>r>>>0;);if(e=e+1|0,(m|0)==(e|0))break}for(e=_<<($>>>0>8),r=0;_&&x(G(r,V)+m0|0,G(r,I)+_0|0,_),!z|!e||x(G(r,n)+f|0,G(r,P)+X0|0,e),r=r+1|0,(m|0)!=(r|0););}u[A+20|0]=0,i[A+4>>2]=w,i[A>>2]=X;break i}if(A=i[w+4>>2],i[w+4>>2]=A-1,A)break i;W[i[i[w>>2]+8>>2]](w),y(w)}v=s+128|0}function YB(A,e,r,f,k,n,t,o){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,t=t|0,o=o|0;var s=0,w=0,h=0,_=0,B=0,m=0,X=0,Q=0,V=0,F=0,I=0,E=0,R=0,N=0,M=0,z=0,S=0,O=0,P=0,a=0,$=0,f0=0,A0=0,n0=0,_0=0,m0=0,X0=0,g0=0,I0=0,e0=0,r0=0,N0=0,U0=0;m=v-48|0,v=m,h=m+12|0,I=r,z=f,$=k,f0=n,m0=t,s=v-80|0,v=s,Q=i[e>>2],n=i[Q+108>>2],k=i[Q+112>>2],w=p(172),i[w>>2]=94812,i[w+4>>2]=0,i[w+8>>2]=0,o0(w+16|0,0,80),r=i[w+4>>2],f=r+1|0,i[w+4>>2]=f,i[w+104>>2]=0,i[w+108>>2]=0,i[w+36>>2]=1,i[w+40>>2]=1,u[w+24|0]=1,g[w+22>>1]=2,g[w+18>>1]=2,g[w+20>>1]=2,i[w+112>>2]=0,i[w+116>>2]=4740,i[w+140>>2]=0,i[w+144>>2]=0,i[w+128>>2]=99,i[w+132>>2]=99,i[w+120>>2]=0,i[w+124>>2]=0,i[w+12>>2]=95160,i[w+148>>2]=0,i[w+152>>2]=0,S=w+140|0,i[w+136>>2]=S,i[w+156>>2]=0,i[w+160>>2]=0,i[w+164>>2]=0,i[w+168>>2]=0,i[w+4>>2]=r,r=i[w+8>>2],O=w+12|0,i[w+96>>2]=O,i[w+8>>2]=r+1,i[w+100>>2]=w,f||(W[i[i[w>>2]+8>>2]](w),y(w)),i[s+24>>2]=i[Q+84>>2];i:{e:{if(r=i[Q+88>>2],!r||(f=Gi(r),i[s+28>>2]=f,!f))break e;r=n-I|0,E=r>>>0<$>>>0?r:$,r=k-z|0,P=r>>>0<f0>>>0?r:f0,g9(s+56|0,O,s+24|0,E,P,m0),r=i[f+4>>2],i[f+4>>2]=r-1,r||(W[i[i[f>>2]+8>>2]](f),y(f));r:{if(i[s+56>>2]){r=i[s+60>>2],i[h>>2]=i[s+56>>2],i[h+4>>2]=r,k=h+8|0;f:{if(u[s+75|0]>=0){f=s- -64|0,r=i[f+4>>2],i[k>>2]=i[f>>2],i[k+4>>2]=r,i[k+8>>2]=i[f+8>>2];break f}T(k,i[s+64>>2],i[s+68>>2])}u[h+20|0]=1;break r}i[s+48>>2]=0,i[s+52>>2]=0,a=s+48|0,i[s+44>>2]=a,k=i[Q+124>>2],t=Q+128|0;f:{A:{if((k|0)==(t|0))break A;for(;;){X=i[k+16>>2],f=a,r=f,n=i[s+48>>2];k:{n:{if(!n)break n;for(;;){if(r=n,f=i[r+16>>2],(f|0)>(X|0)){if(f=r,n=i[r>>2],n)continue;break n}if((f|0)>=(X|0))break k;if(n=i[r+4>>2],!n)break}f=r+4|0}n=p(20),i[n+8>>2]=r,i[n>>2]=0,i[n+4>>2]=0,i[n+16>>2]=X,i[f>>2]=n,r=i[i[s+44>>2]>>2],r&&(i[s+44>>2]=r),m1(i[s+48>>2],n),i[s+52>>2]=i[s+52>>2]+1}n=i[k+4>>2];k:{if(n){for(;;)if(r=n,n=i[r>>2],!n)break k}for(;r=i[k+8>>2],f=i[r>>2]!=(k|0),k=r,!!f;);}if(k=r,(t|0)==(r|0))break}if(X=i[s+44>>2],(a|0)==(X|0))break A;for(r=i[Q+120>>2],X0=(r|0)==1,e0=X0?P+1>>>1|0:P,A0=r-1>>>0<2,r0=A0?E+1>>>1|0:E,N0=G(E,3),U0=E<<2,g0=I+1>>>1|0,I0=z+1>>>1|0;;){B=i[X+16>>2],k=t,r=i[k>>2],n=r;k:{n:{if(!r)break n;for(;f=(B|0)>i[n+16>>2],k=f?k:n,n=i[(f?4:0)+n>>2],!!n;);if((k|0)==(t|0))break n;if(n0=0,f=0,(B|0)<i[k+16>>2])break k;n0=i[k+44>>2],f=i[k+56>>2];break k}n0=0,f=0}_0=f,V=255,f=S,n=i[f>>2],k=n;k:{if(!k){R=0,M=0,f=255;break k}for(;_=(B|0)>i[k+16>>2],f=_?f:k,k=i[(_?4:0)+k>>2],!!k;);n:{if((f|0)==(S|0)){M=0,R=0;break n}if(M=0,R=0,(B|0)<i[f+16>>2])break n;M=i[f+56>>2],R=i[f+44>>2]}for(k=S;f=(B|0)>i[n+16>>2],k=f?k:n,n=i[(f?4:0)+n>>2],!!n;);if(f=255,(k|0)==(S|0)||(f=255,(B|0)<i[k+16>>2]))break k;f=l[k+24|0]}k=t,n=r;k:{if(!r)break k;for(;_=(B|0)>i[n+16>>2],k=_?k:n,n=i[(_?4:0)+n>>2],!!n;);if((k|0)==(t|0)|(B|0)<i[k+16>>2])break k;V=l[k+24|0]}if((f&255)!=(V&255)){u[s+12|0]=0,u[s+23|0]=0,k=q(s+24|0,2,132,s+12|0),r=i[k+4>>2],i[h>>2]=i[k>>2],i[h+4>>2]=r,f=h+8|0;k:{if(u[k+19|0]>=0){r=i[k+12>>2],i[f>>2]=i[k+8>>2],i[f+4>>2]=r,i[f+8>>2]=i[k+16>>2],u[h+20|0]=1;break k}if(T(f,i[k+8>>2],i[k+12>>2]),r=u[k+19|0],u[h+20|0]=1,(r|0)>=0)break k;Z(i[k+8>>2])}if(u[s+23|0]>=0)break f;Z(i[s+12>>2]);break f}V=e0,_=X0,f=r0;k:n:{t:{u:{o:{l:{s:{w:{if(N=B-1>>>0<2,N||(_=0,V=P,f=E,(B|0)!=10))break w;k=3,r=6,_=z,F=I,f=N0;_:{h:switch(n=i[Q+120>>2],n-10|0){case 0:break k;case 1:break h;case 2:case 4:break l;case 3:case 5:break s;default:break _}k=4,f=U0;break k}r=31;break l}if(k=t,n=r,!r)break o;for(;F=(B|0)>i[n+16>>2],k=F?k:n,n=i[(F?4:0)+n>>2],!!n;);for(n=0,_=_?I0:z,F=N&&A0?g0:I,f=G((k|0)==(t|0)|(B|0)<i[k+16>>2]?n:(l[k+24|0]+7&248)>>>3|0,f),n=t;k=(B|0)>i[r+16>>2],n=k?n:r,r=i[(k?4:0)+r>>2],!!r;);if(k=0,(n|0)==(t|0)|(B|0)<i[n+16>>2])break k;k=(l[n+24|0]+7&248)>>>3|0;break k}r=8}switch(f=G(r,E),k=6,n-12|0){case 0:case 2:break k;case 1:case 3:break u;default:break t}}_=_?I0:z,F=N&&A0?g0:I,f=0,k=0;break k}k=8;break n}k=31}k:{if(!V)break k;if(N=G(k,F)+n0|0,r=0,(V|0)!=1)for(F=V&-2,n=0;k=!f,k||x(G(r,M)+R|0,N+G(r+_|0,_0)|0,f),k||(k=r|1,x(G(k,M)+R|0,N+G(k+_|0,_0)|0,f)),r=r+2|0,n=n+2|0,(F|0)!=(n|0););if(!(V&1)|!f)break k;x(G(r,M)+R|0,N+G(r+_|0,_0)|0,f)}n=i[X+4>>2];k:{if(n){for(;;)if(r=n,n=i[r>>2],!n)break k}for(;r=i[X+8>>2],f=i[r>>2]!=(X|0),X=r,!!f;);}if(X=r,(r|0)==(a|0))break}}if(F9(s+24|0,O,$,f0,m0),f=i[s+28>>2],r=i[s+24>>2],i[s+56>>2]=r,i[s+60>>2]=f,k=s- -64|0,u[s+75|0]<0&&(Z(i[s+64>>2]),r=i[s+56>>2]),f=i[s+36>>2],i[k>>2]=i[s+32>>2],i[k+4>>2]=f,i[k+8>>2]=i[s+40>>2],r){r=i[s+60>>2],i[h>>2]=i[s+56>>2],i[h+4>>2]=r,f=h+8|0;A:{if(u[s+75|0]>=0){r=i[k+4>>2],i[f>>2]=i[k>>2],i[f+4>>2]=r,i[f+8>>2]=i[k+8>>2];break A}T(f,i[s+64>>2],i[s+68>>2])}u[h+20|0]=1;break f}u[h+20|0]=0,i[h+4>>2]=w,i[h>>2]=O,w=0}Ii(s+44|0,i[s+48>>2])}u[s+75|0]<0&&Z(i[s+64>>2]);r:{if(!w||(r=i[w+4>>2],i[w+4>>2]=r-1,r))break r;W[i[i[w>>2]+8>>2]](w),y(w)}v=s+80|0;break i}Q3(),H()}i:{e:switch(l[m+32|0]){default:_2(),H();case 1:r=A,A=i[e>>2],b0(r,m+12|0,A?A+92|0:0);break i;case 0:break e}f=p(8),e=i[m+12>>2],r=i[m+16>>2],r&&(i[r+4>>2]=i[r+4>>2]+1),i[f+4>>2]=r,i[f>>2]=e,i[o>>2]=f,i[A+8>>2]=i[24058],e=i[24057],i[A>>2]=i[24056],i[A+4>>2]=e}e=l[m+32|0],(e|0)!=255&&(A=i[24159],i[m+40>>2]=i[24158],i[m+44>>2]=A,W[i[(m+40|0)+(e<<2)>>2]](m+39|0,m+12|0)),v=m+48|0}function RB(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,t=0,o=0,s=0,w=0,h=0;o=v-48|0,v=o,k=v-96|0,v=k,A=i[A>>2],f=i[A+48>>2],s=i[A+52>>2],s&&(i[s+4>>2]=i[s+4>>2]+1),n=o+12|0;i:{if(!r){r=v-48|0,v=r,t=i[A+48>>2],w=i[A+52>>2],w&&(i[w+4>>2]=i[w+4>>2]+1),f=v-32|0,v=f,i[f+28>>2]=0,i[f+20>>2]=0,i[f+24>>2]=0,j1(f,t,e,f+20|0);e:{if(i[f>>2]){i[r+40>>2]=0,i[r+44>>2]=0;break e}r:{if(t=i[f+20>>2],A=i[f+24>>2],(t|0)!=(A|0)){if(e=i[t>>2],e&&(h=i[r+44>>2],e=W0(e,86580,87972),e))break r;if(t=t+8|0,(A|0)!=(t|0))for(;;){if(e=i[t>>2],e&&(h=0,e=W0(e,86580,87972),e))break r;if(t=t+8|0,(A|0)==(t|0))break}i[r+40>>2]=0,i[r+44>>2]=0}i[r+40>>2]=0,i[r+44>>2]=0;break e}if(i[r+44>>2]=h,i[r+40>>2]=e,A=i[t+4>>2],i[r+44>>2]=A,!A)break e;i[A+4>>2]=i[A+4>>2]+1}if(u[f+19|0]<0&&Z(i[f+8>>2]),A=i[f+20>>2],A){if(t=i[f+24>>2],e=A,(t|0)!=(A|0)){for(;;){e=i[t-4>>2];e:{if(!e||(h=i[e+4>>2],i[e+4>>2]=h-1,h))break e;W[i[i[e>>2]+8>>2]](e),y(e)}if(t=t-8|0,(A|0)==(t|0))break}e=i[f+20>>2]}i[f+24>>2]=A,Z(e)}v=f+32|0,A=i[r+40>>2];e:{if(!A){A=p(32),i[r+4>>2]=A,i[r+8>>2]=26,i[r+12>>2]=-2147483616,e=l[9611]|l[9612]<<8,u[A+24|0]=e,u[A+25|0]=e>>>8,e=l[9607]|l[9608]<<8|(l[9609]<<16|l[9610]<<24),f=l[9603]|l[9604]<<8|(l[9605]<<16|l[9606]<<24),u[A+16|0]=f,u[A+17|0]=f>>>8,u[A+18|0]=f>>>16,u[A+19|0]=f>>>24,u[A+20|0]=e,u[A+21|0]=e>>>8,u[A+22|0]=e>>>16,u[A+23|0]=e>>>24,e=l[9599]|l[9600]<<8|(l[9601]<<16|l[9602]<<24),f=l[9595]|l[9596]<<8|(l[9597]<<16|l[9598]<<24),u[A+8|0]=f,u[A+9|0]=f>>>8,u[A+10|0]=f>>>16,u[A+11|0]=f>>>24,u[A+12|0]=e,u[A+13|0]=e>>>8,u[A+14|0]=e>>>16,u[A+15|0]=e>>>24,e=l[9591]|l[9592]<<8|(l[9593]<<16|l[9594]<<24),f=l[9587]|l[9588]<<8|(l[9589]<<16|l[9590]<<24),u[A|0]=f,u[A+1|0]=f>>>8,u[A+2|0]=f>>>16,u[A+3|0]=f>>>24,u[A+4|0]=e,u[A+5|0]=e>>>8,u[A+6|0]=e>>>16,u[A+7|0]=e>>>24,u[A+26|0]=0,A=q(r+16|0,2,116,r+4|0),e=i[A+4>>2],i[n>>2]=i[A>>2],i[n+4>>2]=e,e=n+8|0;r:{if(u[A+19|0]>=0){f=i[A+12>>2],i[e>>2]=i[A+8>>2],i[e+4>>2]=f,i[e+8>>2]=i[A+16>>2],u[n+20|0]=1;break r}if(T(e,i[A+8>>2],i[A+12>>2]),e=u[A+19|0],u[n+20|0]=1,(e|0)>=0)break r;Z(i[A+8>>2])}if(u[r+15|0]<0&&Z(i[r+4>>2]),A=i[r+44>>2],!A||(e=i[A+4>>2],i[A+4>>2]=e-1,e))break e;W[i[i[A>>2]+8>>2]](A),y(A);break e}e=i[r+44>>2],u[n+20|0]=0,i[n+4>>2]=e,i[n>>2]=A}e:{if(!w||(A=i[w+4>>2],i[w+4>>2]=A-1,A))break e;W[i[i[w>>2]+8>>2]](w),y(w)}v=r+48|0;break i}i[k+92>>2]=0,i[k+84>>2]=0,i[k+88>>2]=0,j1(k- -64|0,f,e,k+84|0);e:{if(i[k+64>>2]){A=i[k+68>>2],i[n>>2]=i[k+64>>2],i[n+4>>2]=A,A=n+8|0;r:{if(u[k+83|0]>=0){e=i[k+76>>2],i[A>>2]=i[k+72>>2],i[A+4>>2]=e,i[A+8>>2]=i[k+80>>2];break r}T(A,i[k+72>>2],i[k+76>>2])}u[n+20|0]=1;break e}f=r-1|0,r=i[k+84>>2],f>>>0>=i[k+88>>2]-r>>3>>>0&&(A=p(32),i[k+24>>2]=A,i[k+28>>2]=27,i[k+32>>2]=-2147483616,e=l[13922]|l[13923]<<8|(l[13924]<<16|l[13925]<<24),r=l[13918]|l[13919]<<8|(l[13920]<<16|l[13921]<<24),u[A|0]=r,u[A+1|0]=r>>>8,u[A+2|0]=r>>>16,u[A+3|0]=r>>>24,u[A+4|0]=e,u[A+5|0]=e>>>8,u[A+6|0]=e>>>16,u[A+7|0]=e>>>24,u[A+27|0]=0,e=l[13941]|l[13942]<<8|(l[13943]<<16|l[13944]<<24),u[A+23|0]=e,u[A+24|0]=e>>>8,u[A+25|0]=e>>>16,u[A+26|0]=e>>>24,e=l[13938]|l[13939]<<8|(l[13940]<<16|l[13941]<<24),r=l[13934]|l[13935]<<8|(l[13936]<<16|l[13937]<<24),u[A+16|0]=r,u[A+17|0]=r>>>8,u[A+18|0]=r>>>16,u[A+19|0]=r>>>24,u[A+20|0]=e,u[A+21|0]=e>>>8,u[A+22|0]=e>>>16,u[A+23|0]=e>>>24,e=l[13930]|l[13931]<<8|(l[13932]<<16|l[13933]<<24),r=l[13926]|l[13927]<<8|(l[13928]<<16|l[13929]<<24),u[A+8|0]=r,u[A+9|0]=r>>>8,u[A+10|0]=r>>>16,u[A+11|0]=r>>>24,u[A+12|0]=e,u[A+13|0]=e>>>8,u[A+14|0]=e>>>16,u[A+15|0]=e>>>24,A=q(k+44|0,5,2007,k+24|0),u[A+19|0]<0&&Z(i[A+8>>2]),u[k+35|0]<0&&Z(i[k+24>>2]),r=i[k+84>>2]),e=r+(f<<3)|0,A=i[e>>2],e=i[e+4>>2],e&&(i[e+4>>2]=i[e+4>>2]+1);r:{f:{if(!A||(A=W0(A,86580,87972),!A))break f;e&&(i[e+4>>2]=i[e+4>>2]+1),u[n+20|0]=0,i[n+4>>2]=e,i[n>>2]=A;break r}A=p(24),i[k+12>>2]=A,i[k+16>>2]=19,i[k+20>>2]=-2147483624,r=l[12730]|l[12731]<<8|(l[12732]<<16|l[12733]<<24),u[A+15|0]=r,u[A+16|0]=r>>>8,u[A+17|0]=r>>>16,u[A+18|0]=r>>>24,r=l[12727]|l[12728]<<8|(l[12729]<<16|l[12730]<<24),f=l[12723]|l[12724]<<8|(l[12725]<<16|l[12726]<<24),u[A+8|0]=f,u[A+9|0]=f>>>8,u[A+10|0]=f>>>16,u[A+11|0]=f>>>24,u[A+12|0]=r,u[A+13|0]=r>>>8,u[A+14|0]=r>>>16,u[A+15|0]=r>>>24,r=l[12719]|l[12720]<<8|(l[12721]<<16|l[12722]<<24),f=l[12715]|l[12716]<<8|(l[12717]<<16|l[12718]<<24),u[A|0]=f,u[A+1|0]=f>>>8,u[A+2|0]=f>>>16,u[A+3|0]=f>>>24,u[A+4|0]=r,u[A+5|0]=r>>>8,u[A+6|0]=r>>>16,u[A+7|0]=r>>>24,u[A+19|0]=0,A=q(k+24|0,5,2007,k+12|0),r=i[A+4>>2],i[n>>2]=i[A>>2],i[n+4>>2]=r,r=n+8|0;f:{if(u[A+19|0]>=0){f=i[A+12>>2],i[r>>2]=i[A+8>>2],i[r+4>>2]=f,i[r+8>>2]=i[A+16>>2],u[n+20|0]=1;break f}if(T(r,i[A+8>>2],i[A+12>>2]),r=u[A+19|0],u[n+20|0]=1,(r|0)>=0)break f;Z(i[A+8>>2])}if(u[k+23|0]>=0)break r;Z(i[k+12>>2])}if(!e||(A=i[e+4>>2],i[e+4>>2]=A-1,A))break e;W[i[i[e>>2]+8>>2]](e),y(e)}if(u[k+83|0]<0&&Z(i[k+72>>2]),A=i[k+84>>2],!A)break i;if(r=i[k+88>>2],e=A,(r|0)!=(A|0)){for(;;){e=i[r-4>>2];e:{if(!e||(n=i[e+4>>2],i[e+4>>2]=n-1,n))break e;W[i[i[e>>2]+8>>2]](e),y(e)}if(r=r-8|0,(A|0)==(r|0))break}e=i[k+84>>2]}i[k+88>>2]=A,Z(e)}i:{if(!s||(A=i[s+4>>2],i[s+4>>2]=A-1,A))break i;W[i[i[s>>2]+8>>2]](s),y(s)}return v=k+96|0,A=-1,e=l[o+32|0],(e|0)!=255&&(A=e?A:i[i[o+12>>2]+100>>2],r=i[24175],i[o+40>>2]=i[24174],i[o+44>>2]=r,W[i[(o+40|0)+(e<<2)>>2]](o+39|0,o+12|0)),v=o+48|0,A|0}function JB(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,t=0,o=0,s=0,w=0,h=0;o=v-48|0,v=o,k=v-96|0,v=k,A=i[A>>2],f=i[A+48>>2],s=i[A+52>>2],s&&(i[s+4>>2]=i[s+4>>2]+1),n=o+12|0;i:{if(!r){r=v-48|0,v=r,t=i[A+48>>2],w=i[A+52>>2],w&&(i[w+4>>2]=i[w+4>>2]+1),f=v-32|0,v=f,i[f+28>>2]=0,i[f+20>>2]=0,i[f+24>>2]=0,j1(f,t,e,f+20|0);e:{if(i[f>>2]){i[r+40>>2]=0,i[r+44>>2]=0;break e}r:{if(t=i[f+20>>2],A=i[f+24>>2],(t|0)!=(A|0)){if(e=i[t>>2],e&&(h=i[r+44>>2],e=W0(e,86580,87892),e))break r;if(t=t+8|0,(A|0)!=(t|0))for(;;){if(e=i[t>>2],e&&(h=0,e=W0(e,86580,87892),e))break r;if(t=t+8|0,(A|0)==(t|0))break}i[r+40>>2]=0,i[r+44>>2]=0}i[r+40>>2]=0,i[r+44>>2]=0;break e}if(i[r+44>>2]=h,i[r+40>>2]=e,A=i[t+4>>2],i[r+44>>2]=A,!A)break e;i[A+4>>2]=i[A+4>>2]+1}if(u[f+19|0]<0&&Z(i[f+8>>2]),A=i[f+20>>2],A){if(t=i[f+24>>2],e=A,(t|0)!=(A|0)){for(;;){e=i[t-4>>2];e:{if(!e||(h=i[e+4>>2],i[e+4>>2]=h-1,h))break e;W[i[i[e>>2]+8>>2]](e),y(e)}if(t=t-8|0,(A|0)==(t|0))break}e=i[f+20>>2]}i[f+24>>2]=A,Z(e)}v=f+32|0,A=i[r+40>>2];e:{if(!A){A=p(32),i[r+4>>2]=A,i[r+8>>2]=26,i[r+12>>2]=-2147483616,e=l[9611]|l[9612]<<8,u[A+24|0]=e,u[A+25|0]=e>>>8,e=l[9607]|l[9608]<<8|(l[9609]<<16|l[9610]<<24),f=l[9603]|l[9604]<<8|(l[9605]<<16|l[9606]<<24),u[A+16|0]=f,u[A+17|0]=f>>>8,u[A+18|0]=f>>>16,u[A+19|0]=f>>>24,u[A+20|0]=e,u[A+21|0]=e>>>8,u[A+22|0]=e>>>16,u[A+23|0]=e>>>24,e=l[9599]|l[9600]<<8|(l[9601]<<16|l[9602]<<24),f=l[9595]|l[9596]<<8|(l[9597]<<16|l[9598]<<24),u[A+8|0]=f,u[A+9|0]=f>>>8,u[A+10|0]=f>>>16,u[A+11|0]=f>>>24,u[A+12|0]=e,u[A+13|0]=e>>>8,u[A+14|0]=e>>>16,u[A+15|0]=e>>>24,e=l[9591]|l[9592]<<8|(l[9593]<<16|l[9594]<<24),f=l[9587]|l[9588]<<8|(l[9589]<<16|l[9590]<<24),u[A|0]=f,u[A+1|0]=f>>>8,u[A+2|0]=f>>>16,u[A+3|0]=f>>>24,u[A+4|0]=e,u[A+5|0]=e>>>8,u[A+6|0]=e>>>16,u[A+7|0]=e>>>24,u[A+26|0]=0,A=q(r+16|0,2,116,r+4|0),e=i[A+4>>2],i[n>>2]=i[A>>2],i[n+4>>2]=e,e=n+8|0;r:{if(u[A+19|0]>=0){f=i[A+12>>2],i[e>>2]=i[A+8>>2],i[e+4>>2]=f,i[e+8>>2]=i[A+16>>2],u[n+20|0]=1;break r}if(T(e,i[A+8>>2],i[A+12>>2]),e=u[A+19|0],u[n+20|0]=1,(e|0)>=0)break r;Z(i[A+8>>2])}if(u[r+15|0]<0&&Z(i[r+4>>2]),A=i[r+44>>2],!A||(e=i[A+4>>2],i[A+4>>2]=e-1,e))break e;W[i[i[A>>2]+8>>2]](A),y(A);break e}e=i[r+44>>2],u[n+20|0]=0,i[n+4>>2]=e,i[n>>2]=A}e:{if(!w||(A=i[w+4>>2],i[w+4>>2]=A-1,A))break e;W[i[i[w>>2]+8>>2]](w),y(w)}v=r+48|0;break i}i[k+92>>2]=0,i[k+84>>2]=0,i[k+88>>2]=0,j1(k- -64|0,f,e,k+84|0);e:{if(i[k+64>>2]){A=i[k+68>>2],i[n>>2]=i[k+64>>2],i[n+4>>2]=A,A=n+8|0;r:{if(u[k+83|0]>=0){e=i[k+76>>2],i[A>>2]=i[k+72>>2],i[A+4>>2]=e,i[A+8>>2]=i[k+80>>2];break r}T(A,i[k+72>>2],i[k+76>>2])}u[n+20|0]=1;break e}f=r-1|0,r=i[k+84>>2],f>>>0>=i[k+88>>2]-r>>3>>>0&&(A=p(32),i[k+24>>2]=A,i[k+28>>2]=27,i[k+32>>2]=-2147483616,e=l[13922]|l[13923]<<8|(l[13924]<<16|l[13925]<<24),r=l[13918]|l[13919]<<8|(l[13920]<<16|l[13921]<<24),u[A|0]=r,u[A+1|0]=r>>>8,u[A+2|0]=r>>>16,u[A+3|0]=r>>>24,u[A+4|0]=e,u[A+5|0]=e>>>8,u[A+6|0]=e>>>16,u[A+7|0]=e>>>24,u[A+27|0]=0,e=l[13941]|l[13942]<<8|(l[13943]<<16|l[13944]<<24),u[A+23|0]=e,u[A+24|0]=e>>>8,u[A+25|0]=e>>>16,u[A+26|0]=e>>>24,e=l[13938]|l[13939]<<8|(l[13940]<<16|l[13941]<<24),r=l[13934]|l[13935]<<8|(l[13936]<<16|l[13937]<<24),u[A+16|0]=r,u[A+17|0]=r>>>8,u[A+18|0]=r>>>16,u[A+19|0]=r>>>24,u[A+20|0]=e,u[A+21|0]=e>>>8,u[A+22|0]=e>>>16,u[A+23|0]=e>>>24,e=l[13930]|l[13931]<<8|(l[13932]<<16|l[13933]<<24),r=l[13926]|l[13927]<<8|(l[13928]<<16|l[13929]<<24),u[A+8|0]=r,u[A+9|0]=r>>>8,u[A+10|0]=r>>>16,u[A+11|0]=r>>>24,u[A+12|0]=e,u[A+13|0]=e>>>8,u[A+14|0]=e>>>16,u[A+15|0]=e>>>24,A=q(k+44|0,5,2007,k+24|0),u[A+19|0]<0&&Z(i[A+8>>2]),u[k+35|0]<0&&Z(i[k+24>>2]),r=i[k+84>>2]),e=r+(f<<3)|0,A=i[e>>2],e=i[e+4>>2],e&&(i[e+4>>2]=i[e+4>>2]+1);r:{f:{if(!A||(A=W0(A,86580,87892),!A))break f;e&&(i[e+4>>2]=i[e+4>>2]+1),u[n+20|0]=0,i[n+4>>2]=e,i[n>>2]=A;break r}A=p(24),i[k+12>>2]=A,i[k+16>>2]=19,i[k+20>>2]=-2147483624,r=l[12730]|l[12731]<<8|(l[12732]<<16|l[12733]<<24),u[A+15|0]=r,u[A+16|0]=r>>>8,u[A+17|0]=r>>>16,u[A+18|0]=r>>>24,r=l[12727]|l[12728]<<8|(l[12729]<<16|l[12730]<<24),f=l[12723]|l[12724]<<8|(l[12725]<<16|l[12726]<<24),u[A+8|0]=f,u[A+9|0]=f>>>8,u[A+10|0]=f>>>16,u[A+11|0]=f>>>24,u[A+12|0]=r,u[A+13|0]=r>>>8,u[A+14|0]=r>>>16,u[A+15|0]=r>>>24,r=l[12719]|l[12720]<<8|(l[12721]<<16|l[12722]<<24),f=l[12715]|l[12716]<<8|(l[12717]<<16|l[12718]<<24),u[A|0]=f,u[A+1|0]=f>>>8,u[A+2|0]=f>>>16,u[A+3|0]=f>>>24,u[A+4|0]=r,u[A+5|0]=r>>>8,u[A+6|0]=r>>>16,u[A+7|0]=r>>>24,u[A+19|0]=0,A=q(k+24|0,5,2007,k+12|0),r=i[A+4>>2],i[n>>2]=i[A>>2],i[n+4>>2]=r,r=n+8|0;f:{if(u[A+19|0]>=0){f=i[A+12>>2],i[r>>2]=i[A+8>>2],i[r+4>>2]=f,i[r+8>>2]=i[A+16>>2],u[n+20|0]=1;break f}if(T(r,i[A+8>>2],i[A+12>>2]),r=u[A+19|0],u[n+20|0]=1,(r|0)>=0)break f;Z(i[A+8>>2])}if(u[k+23|0]>=0)break r;Z(i[k+12>>2])}if(!e||(A=i[e+4>>2],i[e+4>>2]=A-1,A))break e;W[i[i[e>>2]+8>>2]](e),y(e)}if(u[k+83|0]<0&&Z(i[k+72>>2]),A=i[k+84>>2],!A)break i;if(r=i[k+88>>2],e=A,(r|0)!=(A|0)){for(;;){e=i[r-4>>2];e:{if(!e||(n=i[e+4>>2],i[e+4>>2]=n-1,n))break e;W[i[i[e>>2]+8>>2]](e),y(e)}if(r=r-8|0,(A|0)==(r|0))break}e=i[k+84>>2]}i[k+88>>2]=A,Z(e)}i:{if(!s||(A=i[s+4>>2],i[s+4>>2]=A-1,A))break i;W[i[i[s>>2]+8>>2]](s),y(s)}return v=k+96|0,A=-1,e=l[o+32|0],(e|0)!=255&&(A=e?A:i[i[o+12>>2]+100>>2],r=i[24177],i[o+40>>2]=i[24176],i[o+44>>2]=r,W[i[(o+40|0)+(e<<2)>>2]](o+39|0,o+12|0)),v=o+48|0,A|0}function NB(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,t=0,o=0,s=0,w=0,h=0,_=0,B=0,m=0,X=0,Q=0,V=0,F=0,I=0,E=0,R=0,N=0,M=0;if(f=g[e+22>>1],B=g[e+6>>1],h=g[e+30>>1],o=((G(f,-74)+G(B,74)|0)+G(h,74)|0)- -64>>7,o=(o|0)>=32767?32767:o,o=(o|0)<=-32768?-32768:o,n=g[e+20>>1],s=g[e+4>>1],t=g[e+28>>1],X=((G(n,-74)+G(s,74)|0)+G(t,74)|0)- -64>>7,X=(X|0)>=32767?32767:X,X=(X|0)<=-32768?-32768:X,F=g[e+18>>1],w=g[e+2>>1],m=g[e+26>>1],_=((G(F,-74)+G(w,74)|0)+G(m,74)|0)- -64>>7,_=(_|0)>=32767?32767:_,I=(_|0)<=-32768?-32768:_,E=g[e+16>>1],R=g[e>>1],N=g[e+24>>1],_=((G(E,-74)+G(R,74)|0)+G(N,74)|0)- -64>>7,_=(_|0)>=32767?32767:_,_=(_|0)<=-32768?-32768:_,k=g[e+14>>1],Q=(((G(k,-74)+G(B,84)|0)+G(f,55)|0)+G(h,-29)|0)- -64>>7,Q=(Q|0)>=32767?32767:Q,Q=(Q|0)<=-32768?-32768:Q,V=G(k,74),k=(((V+G(B,55)|0)+G(f,-29)|0)+G(h,-84)|0)- -64>>7,k=(k|0)>=32767?32767:k,k=(k|0)<=-32768?-32768:k,f=(((V+G(B,29)|0)+G(f,84)|0)+G(h,55)|0)- -64>>7,f=(f|0)>=32767?32767:f,f=(f|0)<=-32768?-32768:f,h=g[e+12>>1],B=(((G(h,-74)+G(s,84)|0)+G(n,55)|0)+G(t,-29)|0)- -64>>7,B=(B|0)>=32767?32767:B,B=(B|0)<=-32768?-32768:B,V=G(h,74),h=(((V+G(s,55)|0)+G(n,-29)|0)+G(t,-84)|0)- -64>>7,h=(h|0)>=32767?32767:h,h=(h|0)<=-32768?-32768:h,n=(((V+G(s,29)|0)+G(n,84)|0)+G(t,55)|0)- -64>>7,n=(n|0)>=32767?32767:n,n=(n|0)<=-32768?-32768:n,s=g[e+10>>1],t=(((G(s,-74)+G(w,84)|0)+G(F,55)|0)+G(m,-29)|0)- -64>>7,t=(t|0)>=32767?32767:t,V=(t|0)<=-32768?-32768:t,s=G(s,74),t=(((s+G(w,55)|0)+G(F,-29)|0)+G(m,-84)|0)- -64>>7,t=(t|0)>=32767?32767:t,M=(t|0)<=-32768?-32768:t,s=(((s+G(w,29)|0)+G(F,84)|0)+G(m,55)|0)- -64>>7,s=(s|0)>=32767?32767:s,F=(s|0)<=-32768?-32768:s,s=g[e+8>>1],e=(((G(s,-74)+G(R,84)|0)+G(E,55)|0)+G(N,-29)|0)- -64>>7,e=(e|0)>=32767?32767:e,e=(e|0)<=-32768?-32768:e,t=G(s,74),s=(((t+G(R,55)|0)+G(E,-29)|0)+G(N,-84)|0)- -64>>7,s=(s|0)>=32767?32767:s,s=(s|0)<=-32768?-32768:s,t=(((t+G(R,29)|0)+G(E,84)|0)+G(N,55)|0)- -64>>7,t=(t|0)>=32767?32767:t,t=(t|0)<=-32768?-32768:t,(r|0)!=1){w=l[A+2|0]+(((G(n,-74)+G(t,74)|0)+G(f,74)|0)+2048>>12)|0,w=(w|0)>=255?255:w,u[A+2|0]=(w|0)>0?w:0,w=G(F,74),m=l[A|0]+((((w+G(t,29)|0)+G(n,84)|0)+G(f,55)|0)+2048>>12)|0,m=(m|0)>=255?255:m,u[A|0]=(m|0)>0?m:0,w=l[A+1|0]+((((w+G(t,55)|0)+G(n,-29)|0)+G(f,-84)|0)+2048>>12)|0,w=(w|0)>=255?255:w,u[A+1|0]=(w|0)>0?w:0,f=l[A+3|0]+((((G(F,-74)+G(t,84)|0)+G(n,55)|0)+G(f,-29)|0)+2048>>12)|0,f=(f|0)>=255?255:f,u[A+3|0]=(f|0)>0?f:0,f=A+r|0,t=G(M,74),n=l[f|0]+((((t+G(s,29)|0)+G(h,84)|0)+G(k,55)|0)+2048>>12)|0,n=(n|0)>=255?255:n,u[f|0]=(n|0)>0?n:0,n=l[f+1|0]+((((t+G(s,55)|0)+G(h,-29)|0)+G(k,-84)|0)+2048>>12)|0,n=(n|0)>=255?255:n,u[f+1|0]=(n|0)>0?n:0,n=l[f+2|0]+(((G(h,-74)+G(s,74)|0)+G(k,74)|0)+2048>>12)|0,n=(n|0)>=255?255:n,u[f+2|0]=(n|0)>0?n:0,k=l[f+3|0]+((((G(M,-74)+G(s,84)|0)+G(h,55)|0)+G(k,-29)|0)+2048>>12)|0,k=(k|0)>=255?255:k,u[f+3|0]=(k|0)>0?k:0,k=(r<<1)+A|0,h=G(I,74),f=l[k|0]+((((h+G(_,29)|0)+G(X,84)|0)+G(o,55)|0)+2048>>12)|0,f=(f|0)>=255?255:f,u[k|0]=(f|0)>0?f:0,f=l[k+1|0]+((((h+G(_,55)|0)+G(X,-29)|0)+G(o,-84)|0)+2048>>12)|0,f=(f|0)>=255?255:f,u[k+1|0]=(f|0)>0?f:0,f=l[k+2|0]+(((G(X,-74)+G(_,74)|0)+G(o,74)|0)+2048>>12)|0,f=(f|0)>=255?255:f,u[k+2|0]=(f|0)>0?f:0,o=l[k+3|0]+((((G(I,-74)+G(_,84)|0)+G(X,55)|0)+G(o,-29)|0)+2048>>12)|0,o=(o|0)>=255?255:o,u[k+3|0]=(o|0)>0?o:0,A=G(r,3)+A|0,o=G(V,74),r=l[A|0]+((((o+G(e,29)|0)+G(B,84)|0)+G(Q,55)|0)+2048>>12)|0,r=(r|0)>=255?255:r,u[A|0]=(r|0)>0?r:0,r=l[A+1|0]+((((o+G(e,55)|0)+G(B,-29)|0)+G(Q,-84)|0)+2048>>12)|0,r=(r|0)>=255?255:r,u[A+1|0]=(r|0)>0?r:0,r=l[A+2|0]+(((G(B,-74)+G(e,74)|0)+G(Q,74)|0)+2048>>12)|0,r=(r|0)>=255?255:r,u[A+2|0]=(r|0)>0?r:0,r=A,A=l[A+3|0]+((((G(V,-74)+G(e,84)|0)+G(B,55)|0)+G(Q,-29)|0)+2048>>12)|0,A=(A|0)>=255?255:A,u[r+3|0]=(A|0)>0?A:0;return}w=l[A+2|0]+(((G(n,-74)+G(t,74)|0)+G(f,74)|0)+2048>>12)|0,w=(w|0)>=255?255:w,u[A+2|0]=(w|0)>0?w:0,w=G(F,74),m=l[A|0]+((((w+G(t,29)|0)+G(n,84)|0)+G(f,55)|0)+2048>>12)|0,m=(m|0)>=255?255:m,u[A|0]=(m|0)>0?m:0,w=l[A+1|0]+((((w+G(t,55)|0)+G(n,-29)|0)+G(f,-84)|0)+2048>>12)|0,w=(w|0)>=255?255:w,u[A+1|0]=(w|0)>0?w:0,f=l[A+3|0]+((((G(F,-74)+G(t,84)|0)+G(n,55)|0)+G(f,-29)|0)+2048>>12)|0,f=(f|0)>=255?255:f,n=(f|0)>0?f:0,u[A+3|0]=n,f=A+r|0,n=n+(((G(h,-74)+G(s,74)|0)+G(k,74)|0)+2048>>12)|0,n=(n|0)>=255?255:n,u[f+2|0]=(n|0)>0?n:0,n=G(M,74),t=l[f|0]+((((n+G(s,29)|0)+G(h,84)|0)+G(k,55)|0)+2048>>12)|0,t=(t|0)>=255?255:t,u[f|0]=(t|0)>0?t:0,n=l[f+1|0]+((((n+G(s,55)|0)+G(h,-29)|0)+G(k,-84)|0)+2048>>12)|0,n=(n|0)>=255?255:n,u[f+1|0]=(n|0)>0?n:0,k=l[f+3|0]+((((G(M,-74)+G(s,84)|0)+G(h,55)|0)+G(k,-29)|0)+2048>>12)|0,k=(k|0)>=255?255:k,k=(k|0)>0?k:0,u[f+3|0]=k,k=k+(((G(X,-74)+G(_,74)|0)+G(o,74)|0)+2048>>12)|0,k=(k|0)>=255?255:k,u[A+4|0]=(k|0)>0?k:0,k=G(I,74),f=l[A+2|0]+((((k+G(_,29)|0)+G(X,84)|0)+G(o,55)|0)+2048>>12)|0,f=(f|0)>=255?255:f,u[A+2|0]=(f|0)>0?f:0,k=l[A+3|0]+((((k+G(_,55)|0)+G(X,-29)|0)+G(o,-84)|0)+2048>>12)|0,k=(k|0)>=255?255:k,u[A+3|0]=(k|0)>0?k:0,o=l[A+5|0]+((((G(I,-74)+G(_,84)|0)+G(X,55)|0)+G(o,-29)|0)+2048>>12)|0,o=(o|0)>=255?255:o,o=(o|0)>0?o:0,u[A+5|0]=o,A=G(r,3)+A|0,r=o+(((G(B,-74)+G(e,74)|0)+G(Q,74)|0)+2048>>12)|0,r=(r|0)>=255?255:r,u[A+2|0]=(r|0)>0?r:0,r=G(V,74),o=l[A|0]+((((r+G(e,29)|0)+G(B,84)|0)+G(Q,55)|0)+2048>>12)|0,o=(o|0)>=255?255:o,u[A|0]=(o|0)>0?o:0,r=l[A+1|0]+((((r+G(e,55)|0)+G(B,-29)|0)+G(Q,-84)|0)+2048>>12)|0,r=(r|0)>=255?255:r,u[A+1|0]=(r|0)>0?r:0,r=A,A=l[A+3|0]+((((G(V,-74)+G(e,84)|0)+G(B,55)|0)+G(Q,-29)|0)+2048>>12)|0,A=(A|0)>=255?255:A,u[r+3|0]=(A|0)>0?A:0}function UB(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,t=0,o=0,s=0,w=0,h=0,_=0,B=0,m=0,X=0,Q=0,V=0,F=0,I=0,E=0,R=0,N=0,M=0,z=0,S=0,O=0,P=0,a=0,$=0,f0=0,A0=0,n0=0,_0=0,m0=0,X0=0,g0=0,I0=0,e0=0,r0=0,N0=0,U0=0,M0=0,H0=0,P0=0,K0=0,$0=0,L0=0,d0=0,n2=0,Z2=0,Q2=0,g2=0,p2=0,H2=0,T2=0,b2=0,e1=0,X1=0,J1=0,z1=0,b1=0,G4=0,X4=0,W4=0,j4=0,O4=0,P4=0,c8=0,b8=0,Ei=0,Yi=0,z5=0,x5=0,T5=0,S5=0,j5=0,O5=0,P5=0,L5=0,K5=0,q5=0,a5=0,$5=0,d5=0,c5=0,b5=0,ik=0,ek=0,rk=0,fk=0,Ak=0,kk=0,nk=0,tk=0,uk=0,ok=0,lk=0,sk=0,wk=0,hk=0,_k=0,Bk=0,vk=0,mk=0,Zk=0,Gk=0,Xk=0,Wk=0,Qk=0,gk=0,Vk=0,Fk=0,Ik=0,Ck=0,pk=0,yk=0,Ek=0,Yk=0,Rk=0,Jk=0,Nk=0,Uk=0,Dk=0,Mk=0,Hk=0,zk=0,xk=0;X=G(r,14)+e|0,E=C[X+14>>1],R=C[e+14>>1],N=C[e+6>>1],s=R+N|0,O=C[e+10>>1],P=C[e+2>>1],w=O+P|0,f=s+w|0,a=C[e+12>>1],$=C[e+4>>1],_=a+$|0,m0=C[e+8>>1],X0=C[e>>1],B=m0+X0|0,n=_+B|0,t=f+n|0,k=(r<<3)+e|0,g0=C[k+14>>1],I0=C[k+6>>1],Q=g0+I0|0,e0=C[k+10>>1],r0=C[k+2>>1],V=e0+r0|0,h=Q+V|0,N0=C[k+12>>1],U0=C[k+4>>1],F=N0+U0|0,Z2=C[k+8>>1],Q2=C[k>>1],M=Z2+Q2|0,m=F+M|0,o=h+m|0,I=t-o|0,k=(r<<2)+e|0,g2=C[k+14>>1],p2=C[k+6>>1],M0=g2+p2|0,H2=C[k+10>>1],T2=C[k+2>>1],H0=H2+T2|0,f0=M0+H0|0,b2=C[k+12>>1],e1=C[k+4>>1],P0=b2+e1|0,X1=C[k+8>>1],J1=C[k>>1],K0=X1+J1|0,A0=P0+K0|0,z=f0+A0|0,k=G(r,12)+e|0,z1=C[k+14>>1],b1=C[k+6>>1],$0=z1+b1|0,G4=C[k+10>>1],X4=C[k+2>>1],L0=G4+X4|0,n0=$0+L0|0,W4=C[k+12>>1],j4=C[k+4>>1],d0=W4+j4|0,O4=C[k+8>>1],c8=C[k>>1],P4=O4+c8|0,n2=d0+P4|0,_0=n0+n2|0,S=z-_0|0,b8=I-S|0,k=(r<<1)+e|0,Ei=C[k+14>>1],Yi=C[k+6>>1],z5=Ei+Yi|0,x5=C[k+10>>1],T5=C[k+2>>1],S5=x5+T5|0,j5=z5+S5|0,O5=C[k+12>>1],P5=C[k+4>>1],L5=O5+P5|0,K5=C[k+8>>1],q5=C[k>>1],a5=K5+q5|0,$5=L5+a5|0,d5=j5+$5|0,k=G(r,10)+e|0,c5=C[k+14>>1],b5=C[k+6>>1],ik=c5+b5|0,ek=C[k+10>>1],rk=C[k+2>>1],fk=ek+rk|0,Ak=ik+fk|0,kk=C[k+12>>1],nk=C[k+4>>1],tk=kk+nk|0,uk=C[k+8>>1],k=C[k>>1],ok=uk+k|0,lk=tk+ok|0,sk=Ak+lk|0,wk=d5-sk|0,e=G(r,6)+e|0,r=C[e+14>>1],hk=C[e+6>>1],_k=r+hk|0,Bk=C[e+10>>1],vk=C[e+2>>1],mk=Bk+vk|0,Zk=_k+mk|0,Gk=C[e+12>>1],Xk=C[e+4>>1],Wk=Gk+Xk|0,Qk=C[e+8>>1],e=C[e>>1],gk=Qk+e|0,Vk=Wk+gk|0,Fk=Zk+Vk|0,Ik=C[X+6>>1],Ck=E+Ik|0,pk=C[X+10>>1],yk=C[X+2>>1],Ek=pk+yk|0,Yk=Ck+Ek|0,Rk=C[X+12>>1],Jk=C[X+4>>1],Nk=Rk+Jk|0,Uk=C[X+8>>1],X=C[X>>1],Dk=Uk+X|0,Mk=Nk+Dk|0,Hk=Yk+Mk|0,zk=Fk-Hk|0,xk=wk-zk|0,g[A+112>>1]=b8-xk,g[A+96>>1]=b8+xk,I=I+S|0,S=wk+zk|0,g[A+80>>1]=I-S,g[A+64>>1]=I+S,t=t+o|0,o=z+_0|0,I=t-o|0,z=d5+sk|0,_0=Fk+Hk|0,S=z-_0|0,g[A+48>>1]=I-S,g[A+32>>1]=I+S,t=t+o|0,o=z+_0|0,g[A+16>>1]=t-o,g[A>>1]=t+o,f=n-f|0,n=m-h|0,t=f-n|0,h=A0-f0|0,m=n2-n0|0,o=h-m|0,I=t-o|0,f0=$5-j5|0,A0=lk-Ak|0,z=f0-A0|0,n0=Vk-Zk|0,n2=Mk-Yk|0,_0=n0-n2|0,S=z-_0|0,g[A+114>>1]=I-S,g[A+98>>1]=I+S,t=t+o|0,o=z+_0|0,g[A+82>>1]=t-o,g[A+66>>1]=t+o,f=f+n|0,n=h+m|0,t=f-n|0,h=f0+A0|0,m=n0+n2|0,o=h-m|0,g[A+50>>1]=t-o,g[A+34>>1]=t+o,f=f+n|0,n=h+m|0,g[A+18>>1]=f-n,g[A+2>>1]=f+n,s=w-s|0,w=B-_|0,f=s+w|0,_=V-Q|0,B=M-F|0,n=_+B|0,t=f-n|0,Q=H0-M0|0,V=K0-P0|0,h=Q+V|0,F=L0-$0|0,M=P4-d0|0,m=F+M|0,o=h-m|0,I=t-o|0,M0=S5-z5|0,H0=a5-L5|0,f0=M0+H0|0,P0=fk-ik|0,K0=ok-tk|0,A0=P0+K0|0,z=f0-A0|0,$0=mk-_k|0,L0=gk-Wk|0,n0=$0+L0|0,d0=Ek-Ck|0,P4=Dk-Nk|0,n2=d0+P4|0,_0=n0-n2|0,S=z-_0|0,g[A+116>>1]=I-S,g[A+100>>1]=I+S,t=t+o|0,o=z+_0|0,g[A+84>>1]=t-o,g[A+68>>1]=t+o,f=f+n|0,n=h+m|0,t=f-n|0,h=f0+A0|0,m=n0+n2|0,o=h-m|0,g[A+52>>1]=t-o,g[A+36>>1]=t+o,f=f+n|0,n=h+m|0,g[A+20>>1]=f-n,g[A+4>>1]=f+n,s=w-s|0,w=B-_|0,f=s-w|0,_=V-Q|0,B=M-F|0,n=_-B|0,t=f-n|0,Q=H0-M0|0,V=K0-P0|0,h=Q-V|0,F=L0-$0|0,M=P4-d0|0,m=F-M|0,o=h-m|0,g[A+118>>1]=t-o,g[A+102>>1]=t+o,f=f+n|0,n=h+m|0,g[A+86>>1]=f-n,g[A+70>>1]=f+n,s=s+w|0,w=_+B|0,f=s-w|0,_=Q+V|0,B=F+M|0,n=_-B|0,g[A+54>>1]=f-n,g[A+38>>1]=f+n,s=s+w|0,w=_+B|0,g[A+22>>1]=s-w,g[A+6>>1]=s+w,R=N-R|0,N=P-O|0,s=R+N|0,O=$-a|0,P=X0-m0|0,w=O+P|0,f=s+w|0,a=I0-g0|0,$=r0-e0|0,_=a+$|0,m0=U0-N0|0,X0=Q2-Z2|0,B=m0+X0|0,n=_+B|0,t=f-n|0,g0=p2-g2|0,I0=T2-H2|0,Q=g0+I0|0,e0=e1-b2|0,r0=J1-X1|0,V=e0+r0|0,h=Q+V|0,N0=b1-z1|0,U0=X4-G4|0,F=N0+U0|0,Z2=j4-W4|0,Q2=c8-O4|0,M=Z2+Q2|0,m=F+M|0,o=h-m|0,I=t-o|0,g2=Yi-Ei|0,p2=T5-x5|0,M0=g2+p2|0,H2=P5-O5|0,T2=q5-K5|0,H0=H2+T2|0,f0=M0+H0|0,b2=b5-c5|0,e1=rk-ek|0,P0=b2+e1|0,X1=nk-kk|0,k=k-uk|0,J1=X1+k|0,K0=P0+J1|0,A0=f0-K0|0,r=hk-r|0,z=vk-Bk|0,z1=r+z|0,b1=Xk-Gk|0,e=e-Qk|0,$0=b1+e|0,G4=z1+$0|0,E=Ik-E|0,X4=yk-pk|0,L0=E+X4|0,n0=Jk-Rk|0,X=X-Uk|0,W4=n0+X|0,j4=L0+W4|0,d0=G4-j4|0,O4=A0-d0|0,g[A+120>>1]=I-O4,g[A+104>>1]=I+O4,t=t+o|0,o=A0+d0|0,g[A+88>>1]=t-o,g[A+72>>1]=t+o,f=f+n|0,n=h+m|0,t=f-n|0,h=f0+K0|0,m=G4+j4|0,o=h-m|0,g[A+56>>1]=t-o,g[A+40>>1]=t+o,f=f+n|0,n=h+m|0,g[A+24>>1]=f-n,g[A+8>>1]=f+n,s=w-s|0,w=B-_|0,f=s-w|0,_=V-Q|0,B=M-F|0,n=_-B|0,t=f-n|0,Q=H0-M0|0,V=J1-P0|0,h=Q-V|0,F=$0-z1|0,M=W4-L0|0,m=F-M|0,o=h-m|0,g[A+122>>1]=t-o,g[A+106>>1]=t+o,f=f+n|0,n=h+m|0,g[A+90>>1]=f-n,g[A+74>>1]=f+n,s=s+w|0,w=_+B|0,f=s-w|0,_=Q+V|0,B=F+M|0,n=_-B|0,g[A+58>>1]=f-n,g[A+42>>1]=f+n,s=s+w|0,w=_+B|0,g[A+26>>1]=s-w,g[A+10>>1]=s+w,R=N-R|0,N=P-O|0,s=R+N|0,O=$-a|0,P=X0-m0|0,w=O+P|0,f=s-w|0,a=I0-g0|0,$=r0-e0|0,_=a+$|0,m0=U0-N0|0,X0=Q2-Z2|0,B=m0+X0|0,n=_-B|0,t=f-n|0,g0=p2-g2|0,I0=T2-H2|0,Q=g0+I0|0,e0=e1-b2|0,k=k-X1|0,r0=e0+k|0,V=Q-r0|0,r=z-r|0,e=e-b1|0,h=r+e|0,E=X4-E|0,X=X-n0|0,N0=E+X|0,U0=h-N0|0,F=V-U0|0,g[A+124>>1]=t-F,g[A+108>>1]=t+F,f=f+n|0,n=V+U0|0,g[A+92>>1]=f-n,g[A+76>>1]=f+n,s=s+w|0,w=_+B|0,f=s-w|0,_=Q+r0|0,B=h+N0|0,n=_-B|0,g[A+60>>1]=f-n,g[A+44>>1]=f+n,s=s+w|0,w=_+B|0,g[A+28>>1]=s-w,g[A+12>>1]=s+w,X=X-E|0,e=e-r|0,r=X+e|0,k=k-e0|0,E=I0-g0|0,s=k+E|0,w=r+s|0,f=X0-m0|0,a=$-a|0,$=f+a|0,O=P-O|0,R=N-R|0,N=O+R|0,P=$+N|0,g[A+14>>1]=w+P,g[A+30>>1]=P-w,r=s-r|0,N=N-$|0,g[A+46>>1]=r+N,g[A+62>>1]=N-r,e=e-X|0,r=E-k|0,X=e+r|0,k=a-f|0,E=R-O|0,R=k+E|0,g[A+78>>1]=X+R,g[A+94>>1]=R-X,e=r-e|0,r=E-k|0,g[A+110>>1]=e+r,g[A+126>>1]=r-e}function a7(A,e,r,f,k,n,t,o){var s=0,w=0,h=0,_=0,B=0,m=0,X=0,Q=0,V=0;s=v-32|0,v=s,h=i[r>>2],w=i[r+4>>2],$4(e+112|0,i[e+116>>2],h,w,w-h|0),h=i[i[e+188>>2]+108>>2]-8|0,i[h>>2]=i[h>>2]+1;i:{if(w=i[e+228>>2],h=i[w+108>>2],X=i[r+4>>2]-i[r>>2]|0,!(h|!X)){i[w+104>>2]=X,i[w+108>>2]=1;break i}if(r=i[w+104>>2],!(!X|(r|0)!=(X|0))){i[w+108>>2]=h+1;break i}e:{r:{f:{if(r){if(h)for(r=i[w+116>>2];;){_=i[w+120>>2];A:{if(_>>>0>r>>>0){i[r>>2]=i[w+104>>2],r=r+4|0;break A}if(m=i[w+112>>2],r=r-m|0,Q=r>>2,h=Q+1|0,h>>>0>=1073741824)break f;if(_=_-m|0,B=_>>1,_=_>>>0>=2147483644?1073741823:h>>>0<B>>>0?B:h,_){if(_>>>0>=1073741824)break r;h=p(_<<2)}else h=0;if(B=h+r|0,i[B>>2]=i[w+104>>2],Q=B-(Q<<2)|0,r&&x(Q,m,r),i[w+120>>2]=h+(_<<2),r=B+4|0,i[w+116>>2]=r,i[w+112>>2]=Q,!m)break A;Z(m)}if(i[w+116>>2]=r,V=V+1|0,!(V>>>0<u0[w+108>>2]))break}i[w+104>>2]=0}r=i[w+116>>2],_=i[w+120>>2];A:{if(r>>>0<_>>>0){i[r>>2]=X,r=r+4|0;break A}if(m=i[w+112>>2],r=r-m|0,Q=r>>2,h=Q+1|0,h>>>0>=1073741824)break e;if(_=_-m|0,B=_>>1,_=_>>>0>=2147483644?1073741823:h>>>0<B>>>0?B:h,_){if(_>>>0>=1073741824)break r;h=p(_<<2)}else h=0;if(B=h+r|0,i[B>>2]=X,X=B-(Q<<2)|0,r&&x(X,m,r),i[w+120>>2]=h+(_<<2),r=B+4|0,i[w+116>>2]=r,i[w+112>>2]=X,!m)break A;Z(m)}i[w+116>>2]=r,i[w+108>>2]=i[w+108>>2]+1;break i}G0(),H()}z0(),H()}G0(),H()}n&&fu(i[e+220>>2],i[e+92>>2]+1|0);i:{if(!f){if(e=p(32),i[s+16>>2]=e,i[s+20>>2]=28,i[s+24>>2]=-2147483616,r=l[22066]|l[22067]<<8|(l[22068]<<16|l[22069]<<24),f=l[22062]|l[22063]<<8|(l[22064]<<16|l[22065]<<24),u[e|0]=f,u[e+1|0]=f>>>8,u[e+2|0]=f>>>16,u[e+3|0]=f>>>24,u[e+4|0]=r,u[e+5|0]=r>>>8,u[e+6|0]=r>>>16,u[e+7|0]=r>>>24,u[e+28|0]=0,r=l[22086]|l[22087]<<8|(l[22088]<<16|l[22089]<<24),u[e+24|0]=r,u[e+25|0]=r>>>8,u[e+26|0]=r>>>16,u[e+27|0]=r>>>24,r=l[22082]|l[22083]<<8|(l[22084]<<16|l[22085]<<24),f=l[22078]|l[22079]<<8|(l[22080]<<16|l[22081]<<24),u[e+16|0]=f,u[e+17|0]=f>>>8,u[e+18|0]=f>>>16,u[e+19|0]=f>>>24,u[e+20|0]=r,u[e+21|0]=r>>>8,u[e+22|0]=r>>>16,u[e+23|0]=r>>>24,r=l[22074]|l[22075]<<8|(l[22076]<<16|l[22077]<<24),f=l[22070]|l[22071]<<8|(l[22072]<<16|l[22073]<<24),u[e+8|0]=f,u[e+9|0]=f>>>8,u[e+10|0]=f>>>16,u[e+11|0]=f>>>24,u[e+12|0]=r,u[e+13|0]=r>>>8,u[e+14|0]=r>>>16,u[e+15|0]=r>>>24,q(A,5,0,s+16|0),u[s+27|0]>=0)break i;Z(i[s+16>>2]);break i}Jt(i[e+204>>2],f),Jt(i[e+212>>2],k);e:{if(r=i[e+40>>2],!r)break e;if(t){if(r=s+16|0,gu(r,t),N9(A,i[e+264>>2],r),f=i[A>>2],f|u[A+19|0]>=0||Z(i[A+8>>2]),r=i[s+16>>2],r&&(i[s+20>>2]=r,Z(r)),f)break i;break e}if((r|0)==1){Kf(i[i[e+264>>2]>>2],0);break e}if(e=p(32),i[s+16>>2]=e,i[s+20>>2]=31,i[s+24>>2]=-2147483616,r=l[10974]|l[10975]<<8|(l[10976]<<16|l[10977]<<24),f=l[10970]|l[10971]<<8|(l[10972]<<16|l[10973]<<24),u[e|0]=f,u[e+1|0]=f>>>8,u[e+2|0]=f>>>16,u[e+3|0]=f>>>24,u[e+4|0]=r,u[e+5|0]=r>>>8,u[e+6|0]=r>>>16,u[e+7|0]=r>>>24,u[e+31|0]=0,r=l[10997]|l[10998]<<8|(l[10999]<<16|l[11e3]<<24),f=l[10993]|l[10994]<<8|(l[10995]<<16|l[10996]<<24),u[e+23|0]=f,u[e+24|0]=f>>>8,u[e+25|0]=f>>>16,u[e+26|0]=f>>>24,u[e+27|0]=r,u[e+28|0]=r>>>8,u[e+29|0]=r>>>16,u[e+30|0]=r>>>24,r=l[10990]|l[10991]<<8|(l[10992]<<16|l[10993]<<24),f=l[10986]|l[10987]<<8|(l[10988]<<16|l[10989]<<24),u[e+16|0]=f,u[e+17|0]=f>>>8,u[e+18|0]=f>>>16,u[e+19|0]=f>>>24,u[e+20|0]=r,u[e+21|0]=r>>>8,u[e+22|0]=r>>>16,u[e+23|0]=r>>>24,r=l[10982]|l[10983]<<8|(l[10984]<<16|l[10985]<<24),f=l[10978]|l[10979]<<8|(l[10980]<<16|l[10981]<<24),u[e+8|0]=f,u[e+9|0]=f>>>8,u[e+10|0]=f>>>16,u[e+11|0]=f>>>24,u[e+12|0]=r,u[e+13|0]=r>>>8,u[e+14|0]=r>>>16,u[e+15|0]=r>>>24,q(A,9,0,s+16|0),u[s+27|0]>=0)break i;Z(i[s+16>>2]);break i}e:{r:{r=i[e+48>>2];f:{if(!r)break f;if(l[o+12|0]==1){A:{if(u[o+11|0]>=0){i[s+24>>2]=i[o+8>>2],r=i[o+4>>2],i[s+16>>2]=i[o>>2],i[s+20>>2]=r;break A}T(s+16|0,i[o>>2],i[o+4>>2])}if(f=i[s+16>>2],r=u[s+27|0],i[s+12>>2]=0,i[s+4>>2]=0,i[s+8>>2]=0,k=s+4|0,n=f,f=(r|0)<0,n=f?n:s+16|0,r=(f?i[s+20>>2]:r)+1|0,Xn(k,n,r+n|0,r),N9(A,i[e+268>>2],k),f=i[A>>2],f|u[A+19|0]>=0||Z(i[A+8>>2]),r=i[s+4>>2],r&&(i[s+8>>2]=r,Z(r)),u[s+27|0]<0&&Z(i[s+16>>2]),!f)break f;break i}if((r|0)!=1)break r;Kf(i[i[e+268>>2]>>2],0)}if(i[e+92>>2]=i[e+92>>2]+1,e=i[26917],i[A>>2]=i[26916],i[A+4>>2]=e,A=A+8|0,u[107683]<0)break e;e=i[26919],i[A>>2]=i[26918],i[A+4>>2]=e,i[A+8>>2]=i[26920];break i}if(e=p(32),i[s+16>>2]=e,i[s+20>>2]=27,i[s+24>>2]=-2147483616,r=l[11006]|l[11007]<<8|(l[11008]<<16|l[11009]<<24),f=l[11002]|l[11003]<<8|(l[11004]<<16|l[11005]<<24),u[e|0]=f,u[e+1|0]=f>>>8,u[e+2|0]=f>>>16,u[e+3|0]=f>>>24,u[e+4|0]=r,u[e+5|0]=r>>>8,u[e+6|0]=r>>>16,u[e+7|0]=r>>>24,u[e+27|0]=0,r=l[11025]|l[11026]<<8|(l[11027]<<16|l[11028]<<24),u[e+23|0]=r,u[e+24|0]=r>>>8,u[e+25|0]=r>>>16,u[e+26|0]=r>>>24,r=l[11022]|l[11023]<<8|(l[11024]<<16|l[11025]<<24),f=l[11018]|l[11019]<<8|(l[11020]<<16|l[11021]<<24),u[e+16|0]=f,u[e+17|0]=f>>>8,u[e+18|0]=f>>>16,u[e+19|0]=f>>>24,u[e+20|0]=r,u[e+21|0]=r>>>8,u[e+22|0]=r>>>16,u[e+23|0]=r>>>24,r=l[11014]|l[11015]<<8|(l[11016]<<16|l[11017]<<24),f=l[11010]|l[11011]<<8|(l[11012]<<16|l[11013]<<24),u[e+8|0]=f,u[e+9|0]=f>>>8,u[e+10|0]=f>>>16,u[e+11|0]=f>>>24,u[e+12|0]=r,u[e+13|0]=r>>>8,u[e+14|0]=r>>>16,u[e+15|0]=r>>>24,q(A,9,0,s+16|0),u[s+27|0]>=0)break i;Z(i[s+16>>2]);break i}T(A,i[26918],i[26919])}v=s+32|0}function DB(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,t=0,o=0,s=0,w=0,h=0,_=0,B=0,m=0,X=0,Q=0,V=0;k=v-160|0,v=k,i[k+84>>2]=0,i[k+56>>2]=72500,f=i[18128],i[k>>2]=f,i[i[f-12>>2]+k>>2]=i[18129],f=i[i[k>>2]-12>>2]+k|0,n=k+4|0,J0(f,n),u[f+80|0]=0,i[f+72>>2]=0,i[k+56>>2]=72500,i[k>>2]=72480,m=R0(n),i[m>>2]=71232,i[k+44>>2]=0,i[k+48>>2]=0,i[k+36>>2]=0,i[k+40>>2]=0,i[k+52>>2]=16,f=k+148|0,Y2(f,e,r),t=f,f=u[k+159|0],n=(f|0)<0,Y(k,n?i[k+148>>2]:t,n?i[k+152>>2]:f),u[k+159|0]<0&&Z(i[k+148>>2]);i:{if(h=i[e+104>>2],X=i[e+108>>2],(h|0)!=(X|0))for(;;){e=k+148|0,s0(e,r),t=e,e=u[k+159|0],f=(e|0)<0,Y(k,f?i[k+148>>2]:t,f?i[k+152>>2]:e),u[k+159|0]<0&&Z(i[k+148>>2]),e=Y(V0(Y(k,32572,9),i[h>>2]),42670,1),f=k+148|0,s0(f,r),t=f,f=u[k+159|0],n=(f|0)<0,Y(e,n?i[k+148>>2]:t,n?i[k+152>>2]:f),u[k+159|0]<0&&Z(i[k+148>>2]),e=Y(S0(Y(e,32071,23),l[h+4|0]),42670,1),f=k+148|0,s0(f,r),t=f,f=u[k+159|0],n=(f|0)<0,Y(e,n?i[k+148>>2]:t,n?i[k+152>>2]:f),u[k+159|0]<0&&Z(i[k+148>>2]),e=Y(e,29416,24),f=i[i[e>>2]-12>>2]+e|0,i[f+4>>2]=i[f+4>>2]&-75|8,e=V0(e,C[h+6>>1]),f=i[i[e>>2]-12>>2]+e|0,i[f+4>>2]=i[f+4>>2]&-75|2,e=Y(e,42670,1),f=k+148|0,s0(f,r),t=f,f=u[k+159|0],n=(f|0)<0,Y(e,n?i[k+148>>2]:t,n?i[k+152>>2]:f),u[k+159|0]<0&&Z(i[k+148>>2]),Y(q2(Y(e,29710,15),i[h+8>>2],i[h+12>>2]),42670,1),e=k+148|0,s0(e,r),t=e,e=u[k+159|0],f=(e|0)<0,Y(k,f?i[k+148>>2]:t,f?i[k+152>>2]:e),u[k+159|0]<0&&Z(i[k+148>>2]),Y(k,29790,11);e:{if(e=i[h+16>>2],Q=i[h+20>>2],(e|0)==(Q|0))break e;r:{for(;;){f:{w=q2(k,i[e+8>>2],i[e+12>>2]),B=G1(k+140|0,w);A:{if(l[B|0]!=1)break A;n=w+i[i[w>>2]-12>>2]|0,_=i[n+4>>2],o=i[n+24>>2];k:{if(l[n+80|0]==1){s=l[n+76|0]|l[n+77|0]<<8|(l[n+78|0]<<16|l[n+79|0]<<24);break k}t=k+148|0,f=i[n+28>>2],i[t>>2]=f,(f|0)!=129576&&(i[f+4>>2]=i[f+4>>2]+1),f=c0(t,129760),s=W[i[i[f>>2]+28>>2]](f,32)|0,e2(t),u[n+76|0]=s,u[n+77|0]=s>>>8,u[n+78|0]=s>>>16,u[n+79|0]=s>>>24,u[n+80|0]=1}k:{if(!o||(f=i[n+12>>2],_=(_&176)==32?26301:26300,t=_-26300|0,(t|0)>0&&(W[i[i[o>>2]+48>>2]](o,26300,t)|0)!=(t|0)))break k;if((f|0)>=2){if(f>>>0>=2147483641)break f;t=((f|0)<=1?1:f)-1|0;n:{if(f>>>0>=12){V=t|7,f=p(V+1|0),i[k+156>>2]=V-2147483647,i[k+148>>2]=f,i[k+152>>2]=t;break n}u[k+159|0]=t,f=k+148|0}if(t&&o0(f,s,t),u[f+t|0]=0,f=W[i[i[o>>2]+48>>2]](o,u[k+159|0]<0?i[k+148>>2]:k+148|0,t)|0,u[k+159|0]<0&&Z(i[k+148>>2]),(f|0)!=(t|0))break k}if(f=26301-_|0,(f|0)>0&&(W[i[i[o>>2]+48>>2]](o,_,f)|0)!=(f|0))break k;i[n+12>>2]=0;break A}f=w+i[i[w>>2]-12>>2]|0,H1(f,i[f+16>>2]|5)}if(_1(B),q2(w,i[e+16>>2],i[e+20>>2]),i[e>>2]|i[e+4>>2]){_=G1(k+140|0,k);A:{if(l[_|0]!=1)break A;n=i[i[k>>2]-12>>2]+k|0,o=i[n+4>>2],s=i[n+24>>2];k:{if(l[n+80|0]==1){f=l[n+76|0]|l[n+77|0]<<8|(l[n+78|0]<<16|l[n+79|0]<<24);break k}t=k+148|0,f=i[n+28>>2],i[t>>2]=f,(f|0)!=129576&&(i[f+4>>2]=i[f+4>>2]+1),f=c0(t,129760),f=W[i[i[f>>2]+28>>2]](f,32)|0,e2(t),u[n+76|0]=f,u[n+77|0]=f>>>8,u[n+78|0]=f>>>16,u[n+79|0]=f>>>24,u[n+80|0]=1}k:{if(!s||(t=i[n+12>>2],w=(o&176)==32?20879:20872,o=w-20872|0,(o|0)>0&&(W[i[i[s>>2]+48>>2]](s,20872,o)|0)!=(o|0)))break k;if((t|0)>=8){if((t|0)==2147483647)break i;o=((t|0)<=7?7:t)-7|0;n:{if(t>>>0>=18){B=o|7,t=p(B+1|0),i[k+156>>2]=B-2147483647,i[k+148>>2]=t,i[k+152>>2]=o;break n}u[k+159|0]=o,t=k+148|0}if(o&&o0(t,f,o),u[t+o|0]=0,f=W[i[i[s>>2]+48>>2]](s,u[k+159|0]<0?i[k+148>>2]:k+148|0,o)|0,u[k+159|0]<0&&Z(i[k+148>>2]),(f|0)!=(o|0))break k}if(f=20879-w|0,(f|0)>0&&(W[i[i[s>>2]+48>>2]](s,w,f)|0)!=(f|0))break k;i[n+12>>2]=0;break A}f=i[i[k>>2]-12>>2]+k|0,H1(f,i[f+16>>2]|5)}_1(_),q2(k,i[e>>2],i[e+4>>2])}_=G1(k+140|0,k);A:{if(l[_|0]!=1)break A;n=i[i[k>>2]-12>>2]+k|0,o=i[n+4>>2],s=i[n+24>>2];k:{if(l[n+80|0]==1){f=l[n+76|0]|l[n+77|0]<<8|(l[n+78|0]<<16|l[n+79|0]<<24);break k}t=k+148|0,f=i[n+28>>2],i[t>>2]=f,(f|0)!=129576&&(i[f+4>>2]=i[f+4>>2]+1),f=c0(t,129760),f=W[i[i[f>>2]+28>>2]](f,32)|0,e2(t),u[n+76|0]=f,u[n+77|0]=f>>>8,u[n+78|0]=f>>>16,u[n+79|0]=f>>>24,u[n+80|0]=1}k:{if(!s||(t=i[n+12>>2],w=(o&176)==32?32809:32808,o=w-32808|0,(o|0)>0&&(W[i[i[s>>2]+48>>2]](s,32808,o)|0)!=(o|0)))break k;if((t|0)>=2){if(t>>>0>=2147483641)break r;o=((t|0)<=1?1:t)-1|0;n:{if(t>>>0>=12){B=o|7,t=p(B+1|0),i[k+156>>2]=B-2147483647,i[k+148>>2]=t,i[k+152>>2]=o;break n}u[k+159|0]=o,t=k+148|0}if(o&&o0(t,f,o),u[t+o|0]=0,f=W[i[i[s>>2]+48>>2]](s,u[k+159|0]<0?i[k+148>>2]:k+148|0,o)|0,u[k+159|0]<0&&Z(i[k+148>>2]),(f|0)!=(o|0))break k}if(f=32809-w|0,(f|0)>0&&(W[i[i[s>>2]+48>>2]](s,w,f)|0)!=(f|0))break k;i[n+12>>2]=0;break A}f=i[i[k>>2]-12>>2]+k|0,H1(f,i[f+16>>2]|5)}if(_1(_),e=e+40|0,(Q|0)!=(e|0))continue;break e}break}break i}break i}if(Y(k,42670,1),h=h+32|0,(X|0)==(h|0))break}e=i[k+52>>2];e:{r:{if(e&16){e=i[k+48>>2],r=i[k+28>>2],e>>>0<r>>>0&&(i[k+48>>2]=r,e=r),r=k+24|0;break r}if(!(e&8)){e=0,u[A+11|0]=0;break e}e=i[k+20>>2],r=k+12|0}r:{if(f=i[r>>2],e=e-f|0,e>>>0<2147483640){if(e>>>0>=11){n=e|7,r=p(n+1|0),i[A+8>>2]=n-2147483647,i[A>>2]=r,i[A+4>>2]=e,A=r;break r}if(u[A+11|0]=e,e)break r;e=0;break e}Q0(),H()}if(!e)break e;x(A,f,e)}u[A+e|0]=0,A=i[18127],i[k>>2]=A,i[i[A-12>>2]+k>>2]=i[18130],i[m>>2]=71232,u[k+47|0]<0&&Z(i[k+36>>2]),E0(m),y0(k+56|0),v=k+160|0;return}Q0(),H()}function MB(A,e,r,f,k,n,t,o){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,t=t|0,o=o|0;var s=0,w=0,h=U(0),_=0,B=0,m=0,X=0,Q=0,V=0,F=0,I=0,E=0,R=0,N=0,M=0,z=0,S=U(0),O=0,P=0,a=0,$=0,f0=U(0),A0=U(0),n0=0,_0=0,m0=0,X0=0,g0=0,I0=0,e0=0,r0=U(0),N0=0,U0=0,M0=0,H0=0,P0=U(0),K0=0,$0=0,L0=0,d0=0,n2=0,Z2=0,Q2=0,g2=0;s=v-48|0,v=s,e=i[r>>2],X=i[e+112>>2],Q=i[e+108>>2],_=j0(e,0),M=u1(i[r>>2],6),B=i[k+4>>2],w=p(172),i[w>>2]=94812,i[w+4>>2]=0,i[w+8>>2]=0,o0(w+16|0,0,80),e=i[w+4>>2],n=e+1|0,i[w+4>>2]=n,i[w+104>>2]=0,i[w+108>>2]=0,i[w+36>>2]=1,i[w+40>>2]=1,u[w+24|0]=1,g[w+22>>1]=2,g[w+18>>1]=2,g[w+20>>1]=2,i[w+112>>2]=0,i[w+116>>2]=4740,i[w+140>>2]=0,i[w+144>>2]=0,i[w+128>>2]=99,i[w+132>>2]=99,i[w+120>>2]=0,i[w+124>>2]=0,i[w+12>>2]=95160,i[w+148>>2]=0,i[w+152>>2]=0,f=w+140|0,i[w+136>>2]=f,i[w+156>>2]=0,i[w+160>>2]=0,i[w+164>>2]=0,i[w+168>>2]=0,i[w+4>>2]=e,e=i[w+8>>2],m=w+12|0,i[w+96>>2]=m,i[w+8>>2]=e+1,i[w+100>>2]=w,n||(W[i[i[w>>2]+8>>2]](w),y(w)),i[m+120>>2]=i[k+4>>2],i[m+116>>2]=1,i[m+112>>2]=X,i[m+108>>2]=Q,T0(s+24|0,m,10,Q,X,_,o);i:{e:{if(i[s+24>>2]){if(e=i[s+28>>2],i[A>>2]=i[s+24>>2],i[A+4>>2]=e,r=A+8|0,u[s+43|0]>=0){e=i[s+36>>2],i[r>>2]=i[s+32>>2],i[r+4>>2]=e,i[r+8>>2]=i[s+40>>2],u[A+20|0]=1;break e}if(T(r,i[s+32>>2],i[s+36>>2]),e=u[s+43|0],u[A+20|0]=1,(e|0)>=0)break e;Z(i[s+32>>2]);break e}u[s+43|0]<0&&Z(i[s+32>>2]);r:{if(!M)break r;f:{if((o8(i[r>>2],6)|0)==(Q|0)&&(l8(i[r>>2],6)|0)==(X|0))break f;e=p(96),i[s+4>>2]=e,i[s+8>>2]=90,i[s+12>>2]=-2147483552,x(e,24943,90),u[e+90|0]=0,f=q(s+24|0,4,0,s+4|0),e=i[f+4>>2],i[A>>2]=i[f>>2],i[A+4>>2]=e,r=A+8|0;A:{if(u[f+19|0]>=0){e=i[f+12>>2],i[r>>2]=i[f+8>>2],i[r+4>>2]=e,i[r+8>>2]=i[f+16>>2],u[A+20|0]=1;break A}if(T(r,i[f+8>>2],i[f+12>>2]),e=u[f+19|0],u[A+20|0]=1,(e|0)>=0)break A;Z(i[f+8>>2])}if(u[s+15|0]>=0)break e;Z(i[s+4>>2]);break e}if((j0(i[r>>2],6)|0)!=(_|0)){e=p(96),i[s+4>>2]=e,i[s+8>>2]=94,i[s+12>>2]=-2147483552,x(e,25338,94),u[e+94|0]=0,f=q(s+24|0,4,0,s+4|0),e=i[f+4>>2],i[A>>2]=i[f>>2],i[A+4>>2]=e,r=A+8|0;f:{if(u[f+19|0]>=0){e=i[f+12>>2],i[r>>2]=i[f+8>>2],i[r+4>>2]=e,i[r+8>>2]=i[f+16>>2],u[A+20|0]=1;break f}if(T(r,i[f+8>>2],i[f+12>>2]),e=u[f+19|0],u[A+20|0]=1,(e|0)>=0)break f;Z(i[f+8>>2])}if(u[s+15|0]>=0)break e;Z(i[s+4>>2]);break e}if(T0(s+24|0,m,6,Q,X,_,o),i[s+24>>2]){if(e=i[s+28>>2],i[A>>2]=i[s+24>>2],i[A+4>>2]=e,r=A+8|0,u[s+43|0]>=0){e=i[s+36>>2],i[r>>2]=i[s+32>>2],i[r+4>>2]=e,i[r+8>>2]=i[s+40>>2],u[A+20|0]=1;break e}if(T(r,i[s+32>>2],i[s+36>>2]),e=u[s+43|0],u[A+20|0]=1,(e|0)>=0)break e;Z(i[s+32>>2]);break e}if(u[s+43|0]>=0)break r;Z(i[s+32>>2])}r:{f:{if(k=i[f>>2],!k)break f;for(e=f;n=i[k+16>>2]<10,e=n?e:k,k=i[(n?4:0)+k>>2],!!k;);if((e|0)==(f|0))break f;if(f=0,i[e+16>>2]>10)break r;_0=i[e+56>>2],f=i[e+44>>2];break r}f=0}I=f;r:{f:{if(f=i[r>>2],e=i[f+128>>2],e){for(f=f+128|0,n=f,k=e;t=i[k+16>>2],n=(t|0)<0?n:k,k=i[(t>>>29&4)+k>>2],!!k;);E=0;A:{if((f|0)==(n|0)||(E=0,i[n+16>>2]>0))break A;m0=i[n+56>>2],E=i[n+44>>2]}for(n=f,k=e;t=i[k+16>>2]<=0,n=t?n:k,k=i[(t?4:0)+k>>2],!!k;);R=0;A:{if((f|0)==(n|0)||(R=0,i[n+16>>2]>1))break A;X0=i[n+44>>2],R=i[n+56>>2]}for(n=f,k=e;t=i[k+16>>2]<2,n=t?n:k,k=i[(t?4:0)+k>>2],!!k;);N=0;A:{if((f|0)==(n|0)||(N=0,i[n+16>>2]>2))break A;g0=i[n+56>>2],N=i[n+44>>2]}if(V=0,!M)break r;for(k=f;n=i[e+16>>2]<6,k=n?k:e,e=i[(n?4:0)+e>>2],!!e;);if((f|0)!=(k|0))break f}V=0;break r}if(V=0,i[k+16>>2]>6)break r;I0=i[k+56>>2],V=i[k+44>>2]}if(i[s+36>>2]=-1086926434,i[s+40>>2]=1071829221,i[s+28>>2]=1068725436,i[s+32>>2]=-1095748968,u[s+24|0]=1,e=1,S4(i[r>>2])&&(r=i[r>>2],e=C[r+6>>1]|C[r+8>>1]<<16,r=C[r+10>>1]|C[r+12>>1]<<16,le(s+4|0,r&65535,e&65535),i[s+40>>2]=i[s+20>>2],e=i[s+16>>2],i[s+32>>2]=i[s+12>>2],i[s+36>>2]=e,e=i[s+8>>2],i[s+24>>2]=i[s+4>>2],i[s+28>>2]=e,e=(r&65536)>>>16|0),!(!X|!Q))for(r=B&-2,P=(r|0)==14,e0=M?8:6,r0=U(16<<_-8),B=-1<<_^-1,n=B>>>8|0,a=1<<_-1,N0=((r|0)!=14)+I|0,r=(r|0)==14,U0=(r?6:7)+I|0,M0=(r?4:5)+I|0,H0=(r?2:3)+I|0,P0=p0[s+28>>2];;){for(z=G(F,_0),K0=U0+z|0,$0=(G(F,I0)&-2)+V|0,L0=(G(F,m0)&-2)+E|0,$=I+z|0,d0=($+P|0)+6|0,r=F>>>1|0,n2=(G(r,g0)&-2)+N|0,Z2=(G(r,R)&-2)+X0|0,k=0;;){r=0,f=k&-2,h=U(C[f+Z2>>1]-a|0),f0=e?h:U(h*U(1.142899990081787)),t=0,h=U(C[f+n2>>1]-a|0),A0=e?h:U(h*U(1.142899990081787)),n0=k<<1,h=U(C[n0+L0>>1]),S=e?h:U(U(h-r0)*U(1.1689000129699707)),h=U(U(U(P0*A0)+S)+U(.5)),U(w2(h))<U(2147483648)?o=~~h:o=-2147483648,f=0;r:{if((o|0)<0)break r;if((o|0)>(B|0)){t=n,f=B;break r}t=o>>>8|0,f=o}Q2=f,h=U(U(U(p0[s+36>>2]*A0)+U(U(p0[s+32>>2]*f0)+S))+U(.5)),U(w2(h))<U(2147483648)?f=~~h:f=-2147483648,o=0;r:{if((f|0)<0)break r;if((f|0)>(B|0)){r=B,o=n;break r}r=f,o=f>>>8|0}g2=o,o=0,h=U(U(U(p0[s+40>>2]*f0)+S)+U(.5)),U(w2(h))<U(2147483648)?f=~~h:f=-2147483648,_=0;r:{if((f|0)<0)break r;if((f|0)>(B|0)){o=n,_=B;break r}o=f>>>8|0,_=f}if(f=G(k,e0),O=(f+$|0)+P|0,u[O|0]=t,u[O+2|0]=g2,u[O+4|0]=o,f=f+z|0,u[f+N0|0]=Q2,u[f+H0|0]=r,u[f+M0|0]=_,M&&(f=k<<3,r=$0+n0|0,u[f+d0|0]=l[r+1|0],u[f+K0|0]=l[r|0]),k=k+1|0,(Q|0)==(k|0))break}if(F=F+1|0,(F|0)==(X|0))break}u[A+20|0]=0,i[A+4>>2]=w,i[A>>2]=m;break i}if(A=i[w+4>>2],i[w+4>>2]=A-1,A)break i;W[i[i[w>>2]+8>>2]](w),y(w)}v=s+48|0}function F6(A,e,r,f){var k=0,n=0,t=0,o=0;k=v-160|0,v=k,n=J6(i[e+48>>2],r);i:{if(!(!((n|0)==1735551332|(n|0)==1768912492)&(n|0)!=1768187246)){n=i[e+48>>2],t=i[n+84>>2],n=i[n+88>>2],n&&(i[n+4>>2]=i[n+4>>2]+1);e:{if(!t){if(e=p(56),i[k>>2]=e,i[k+4>>2]=54,i[k+8>>2]=-2147483592,r=l[5037]|l[5038]<<8|(l[5039]<<16|l[5040]<<24),f=l[5033]|l[5034]<<8|(l[5035]<<16|l[5036]<<24),u[e|0]=f,u[e+1|0]=f>>>8,u[e+2|0]=f>>>16,u[e+3|0]=f>>>24,u[e+4|0]=r,u[e+5|0]=r>>>8,u[e+6|0]=r>>>16,u[e+7|0]=r>>>24,u[e+54|0]=0,r=l[5083]|l[5084]<<8|(l[5085]<<16|l[5086]<<24),f=l[5079]|l[5080]<<8|(l[5081]<<16|l[5082]<<24),u[e+46|0]=f,u[e+47|0]=f>>>8,u[e+48|0]=f>>>16,u[e+49|0]=f>>>24,u[e+50|0]=r,u[e+51|0]=r>>>8,u[e+52|0]=r>>>16,u[e+53|0]=r>>>24,r=l[5077]|l[5078]<<8|(l[5079]<<16|l[5080]<<24),f=l[5073]|l[5074]<<8|(l[5075]<<16|l[5076]<<24),u[e+40|0]=f,u[e+41|0]=f>>>8,u[e+42|0]=f>>>16,u[e+43|0]=f>>>24,u[e+44|0]=r,u[e+45|0]=r>>>8,u[e+46|0]=r>>>16,u[e+47|0]=r>>>24,r=l[5069]|l[5070]<<8|(l[5071]<<16|l[5072]<<24),f=l[5065]|l[5066]<<8|(l[5067]<<16|l[5068]<<24),u[e+32|0]=f,u[e+33|0]=f>>>8,u[e+34|0]=f>>>16,u[e+35|0]=f>>>24,u[e+36|0]=r,u[e+37|0]=r>>>8,u[e+38|0]=r>>>16,u[e+39|0]=r>>>24,r=l[5061]|l[5062]<<8|(l[5063]<<16|l[5064]<<24),f=l[5057]|l[5058]<<8|(l[5059]<<16|l[5060]<<24),u[e+24|0]=f,u[e+25|0]=f>>>8,u[e+26|0]=f>>>16,u[e+27|0]=f>>>24,u[e+28|0]=r,u[e+29|0]=r>>>8,u[e+30|0]=r>>>16,u[e+31|0]=r>>>24,r=l[5053]|l[5054]<<8|(l[5055]<<16|l[5056]<<24),f=l[5049]|l[5050]<<8|(l[5051]<<16|l[5052]<<24),u[e+16|0]=f,u[e+17|0]=f>>>8,u[e+18|0]=f>>>16,u[e+19|0]=f>>>24,u[e+20|0]=r,u[e+21|0]=r>>>8,u[e+22|0]=r>>>16,u[e+23|0]=r>>>24,r=l[5045]|l[5046]<<8|(l[5047]<<16|l[5048]<<24),f=l[5041]|l[5042]<<8|(l[5043]<<16|l[5044]<<24),u[e+8|0]=f,u[e+9|0]=f>>>8,u[e+10|0]=f>>>16,u[e+11|0]=f>>>24,u[e+12|0]=r,u[e+13|0]=r>>>8,u[e+14|0]=r>>>16,u[e+15|0]=r>>>24,q(A,2,117,k),u[k+11|0]>=0)break e;Z(i[k>>2]);break e}P8(k,t,r,1684630887);r:{f:{if(t=i[k>>2],(t|0)!=i[k+4>>2]&&(o=r,r=i[t>>2],(o|0)!=(r|0)))break f;if(e=p(56),i[k+148>>2]=e,i[k+152>>2]=54,i[k+156>>2]=-2147483592,r=l[5037]|l[5038]<<8|(l[5039]<<16|l[5040]<<24),f=l[5033]|l[5034]<<8|(l[5035]<<16|l[5036]<<24),u[e|0]=f,u[e+1|0]=f>>>8,u[e+2|0]=f>>>16,u[e+3|0]=f>>>24,u[e+4|0]=r,u[e+5|0]=r>>>8,u[e+6|0]=r>>>16,u[e+7|0]=r>>>24,u[e+54|0]=0,r=l[5083]|l[5084]<<8|(l[5085]<<16|l[5086]<<24),f=l[5079]|l[5080]<<8|(l[5081]<<16|l[5082]<<24),u[e+46|0]=f,u[e+47|0]=f>>>8,u[e+48|0]=f>>>16,u[e+49|0]=f>>>24,u[e+50|0]=r,u[e+51|0]=r>>>8,u[e+52|0]=r>>>16,u[e+53|0]=r>>>24,r=l[5077]|l[5078]<<8|(l[5079]<<16|l[5080]<<24),f=l[5073]|l[5074]<<8|(l[5075]<<16|l[5076]<<24),u[e+40|0]=f,u[e+41|0]=f>>>8,u[e+42|0]=f>>>16,u[e+43|0]=f>>>24,u[e+44|0]=r,u[e+45|0]=r>>>8,u[e+46|0]=r>>>16,u[e+47|0]=r>>>24,r=l[5069]|l[5070]<<8|(l[5071]<<16|l[5072]<<24),f=l[5065]|l[5066]<<8|(l[5067]<<16|l[5068]<<24),u[e+32|0]=f,u[e+33|0]=f>>>8,u[e+34|0]=f>>>16,u[e+35|0]=f>>>24,u[e+36|0]=r,u[e+37|0]=r>>>8,u[e+38|0]=r>>>16,u[e+39|0]=r>>>24,r=l[5061]|l[5062]<<8|(l[5063]<<16|l[5064]<<24),f=l[5057]|l[5058]<<8|(l[5059]<<16|l[5060]<<24),u[e+24|0]=f,u[e+25|0]=f>>>8,u[e+26|0]=f>>>16,u[e+27|0]=f>>>24,u[e+28|0]=r,u[e+29|0]=r>>>8,u[e+30|0]=r>>>16,u[e+31|0]=r>>>24,r=l[5053]|l[5054]<<8|(l[5055]<<16|l[5056]<<24),f=l[5049]|l[5050]<<8|(l[5051]<<16|l[5052]<<24),u[e+16|0]=f,u[e+17|0]=f>>>8,u[e+18|0]=f>>>16,u[e+19|0]=f>>>24,u[e+20|0]=r,u[e+21|0]=r>>>8,u[e+22|0]=r>>>16,u[e+23|0]=r>>>24,r=l[5045]|l[5046]<<8|(l[5047]<<16|l[5048]<<24),f=l[5041]|l[5042]<<8|(l[5043]<<16|l[5044]<<24),u[e+8|0]=f,u[e+9|0]=f>>>8,u[e+10|0]=f>>>16,u[e+11|0]=f>>>24,u[e+12|0]=r,u[e+13|0]=r>>>8,u[e+14|0]=r>>>16,u[e+15|0]=r>>>24,q(A,2,117,k+148|0),u[k+159|0]>=0)break r;Z(i[k+148>>2]);break r}F6(A,e,r,f)}if(A=i[k>>2],!A)break e;i[k+4>>2]=A,Z(A)}if(!n||(A=i[n+4>>2],i[n+4>>2]=A-1,A))break i;W[i[i[n>>2]+8>>2]](n),y(n);break i}e:{r:{f:{A:{k:{if(n=i[e+20>>2],!n)break k;for(t=e+20|0,e=t;o=u0[n+16>>2]<r>>>0,e=o?e:n,n=i[(o?4:0)+n>>2],!!n;);if((e|0)==(t|0)|u0[e+16>>2]>r>>>0)break k;if(i[f>>2]=r,e=i[26917],i[A>>2]=i[26916],i[A+4>>2]=e,A=A+8|0,u[107683]<0)break A;e=i[26919],i[A>>2]=i[26918],i[A+4>>2]=e,i[A+8>>2]=i[26920];break i}i[k+92>>2]=0,i[k+64>>2]=72196,i[k+8>>2]=72176,e=i[18053],i[k>>2]=e,i[i[e-12>>2]+k>>2]=i[18054],i[k+4>>2]=0,e=i[i[k>>2]-12>>2]+k|0,f=k+12|0,J0(e,f),u[e+80|0]=0,i[e+72>>2]=0,e=i[18055],i[k+8>>2]=e,n=i[e-12>>2],e=k+8|0,i[n+e>>2]=i[18056],n=i[18052],i[k>>2]=n,i[i[n-12>>2]+k>>2]=i[18057],i[k+64>>2]=72196,i[k>>2]=72156,i[k+8>>2]=72176,f=R0(f),i[f>>2]=71232,i[k+52>>2]=0,i[k+56>>2]=0,i[k+44>>2]=0,i[k+48>>2]=0,i[k+60>>2]=24,Y(V0(Y(e,28314,11),r),32819,35),e=i[k+60>>2];k:{if(e&16){n=i[k+56>>2],e=i[k+36>>2],n>>>0<e>>>0&&(i[k+56>>2]=e,n=e),e=k+32|0;break k}if(!(e&8)){n=0,u[k+159|0]=0,e=k+148|0;break e}n=i[k+28>>2],e=k+20|0}if(r=i[e>>2],n=n-r|0,n>>>0>=2147483640)break f;if(n>>>0>=11){t=n|7,e=p(t+1|0),i[k+156>>2]=t-2147483647,i[k+148>>2]=e,i[k+152>>2]=n;break r}if(u[k+159|0]=n,e=k+148|0,n)break r;n=0;break e}T(A,i[26918],i[26919]);break i}Q0(),H()}if(!n)break e;x(e,r,n)}u[e+n|0]=0,q(A,2,2e3,k+148|0),u[k+159|0]<0&&Z(i[k+148>>2]),A=i[18051],i[k>>2]=A,i[i[A-12>>2]+k>>2]=i[18059],i[k+8>>2]=i[18060],i[f>>2]=71232,u[k+55|0]<0&&Z(i[k+44>>2]),E0(f),y0(k- -64|0)}v=k+160|0}function Zf(A,e,r,f){var k=0,n=0,t=0,o=0,s=0,w=0;n=v-96|0,v=n,k=i[e+48>>2],o=i[e+52>>2],o&&(i[o+4>>2]=i[o+4>>2]+1);i:{if(!f){f=v-48|0,v=f,t=i[e+48>>2],s=i[e+52>>2],s&&(i[s+4>>2]=i[s+4>>2]+1),k=v-32|0,v=k,i[k+28>>2]=0,i[k+20>>2]=0,i[k+24>>2]=0,j1(k,t,r,k+20|0);e:{if(i[k>>2]){i[f+40>>2]=0,i[f+44>>2]=0;break e}r:{if(t=i[k+20>>2],r=i[k+24>>2],(t|0)!=(r|0)){if(e=i[t>>2],e&&(w=i[f+44>>2],e=W0(e,86580,86784),e))break r;if(t=t+8|0,(r|0)!=(t|0))for(;;){if(e=i[t>>2],e&&(w=0,e=W0(e,86580,86784),e))break r;if(t=t+8|0,(r|0)==(t|0))break}i[f+40>>2]=0,i[f+44>>2]=0}i[f+40>>2]=0,i[f+44>>2]=0;break e}if(i[f+44>>2]=w,i[f+40>>2]=e,e=i[t+4>>2],i[f+44>>2]=e,!e)break e;i[e+4>>2]=i[e+4>>2]+1}if(u[k+19|0]<0&&Z(i[k+8>>2]),r=i[k+20>>2],r){if(e=r,t=i[k+24>>2],(e|0)!=(t|0)){for(;;){e=i[t-4>>2];e:{if(!e||(w=i[e+4>>2],i[e+4>>2]=w-1,w))break e;W[i[i[e>>2]+8>>2]](e),y(e)}if(t=t-8|0,(r|0)==(t|0))break}e=i[k+20>>2]}i[k+24>>2]=r,Z(e)}v=k+32|0,e=i[f+40>>2];e:{if(!e){e=p(32),i[f+4>>2]=e,i[f+8>>2]=26,i[f+12>>2]=-2147483616,r=l[9611]|l[9612]<<8,u[e+24|0]=r,u[e+25|0]=r>>>8,r=l[9607]|l[9608]<<8|(l[9609]<<16|l[9610]<<24),k=l[9603]|l[9604]<<8|(l[9605]<<16|l[9606]<<24),u[e+16|0]=k,u[e+17|0]=k>>>8,u[e+18|0]=k>>>16,u[e+19|0]=k>>>24,u[e+20|0]=r,u[e+21|0]=r>>>8,u[e+22|0]=r>>>16,u[e+23|0]=r>>>24,r=l[9599]|l[9600]<<8|(l[9601]<<16|l[9602]<<24),k=l[9595]|l[9596]<<8|(l[9597]<<16|l[9598]<<24),u[e+8|0]=k,u[e+9|0]=k>>>8,u[e+10|0]=k>>>16,u[e+11|0]=k>>>24,u[e+12|0]=r,u[e+13|0]=r>>>8,u[e+14|0]=r>>>16,u[e+15|0]=r>>>24,r=l[9591]|l[9592]<<8|(l[9593]<<16|l[9594]<<24),k=l[9587]|l[9588]<<8|(l[9589]<<16|l[9590]<<24),u[e|0]=k,u[e+1|0]=k>>>8,u[e+2|0]=k>>>16,u[e+3|0]=k>>>24,u[e+4|0]=r,u[e+5|0]=r>>>8,u[e+6|0]=r>>>16,u[e+7|0]=r>>>24,u[e+26|0]=0,e=q(f+16|0,2,116,f+4|0),r=i[e+4>>2],i[A>>2]=i[e>>2],i[A+4>>2]=r,r=A+8|0;r:{if(u[e+19|0]>=0){k=i[e+12>>2],i[r>>2]=i[e+8>>2],i[r+4>>2]=k,i[r+8>>2]=i[e+16>>2],u[A+20|0]=1;break r}if(T(r,i[e+8>>2],i[e+12>>2]),r=u[e+19|0],u[A+20|0]=1,(r|0)>=0)break r;Z(i[e+8>>2])}if(u[f+15|0]<0&&Z(i[f+4>>2]),A=i[f+44>>2],!A||(e=i[A+4>>2],i[A+4>>2]=e-1,e))break e;W[i[i[A>>2]+8>>2]](A),y(A);break e}r=i[f+44>>2],u[A+20|0]=0,i[A+4>>2]=r,i[A>>2]=e}e:{if(!s||(A=i[s+4>>2],i[s+4>>2]=A-1,A))break e;W[i[i[s>>2]+8>>2]](s),y(s)}v=f+48|0;break i}i[n+92>>2]=0,i[n+84>>2]=0,i[n+88>>2]=0,j1(n- -64|0,k,r,n+84|0);e:{if(i[n+64>>2]){e=i[n+68>>2],i[A>>2]=i[n+64>>2],i[A+4>>2]=e,e=A+8|0;r:{if(u[n+83|0]>=0){r=i[n+76>>2],i[e>>2]=i[n+72>>2],i[e+4>>2]=r,i[e+8>>2]=i[n+80>>2];break r}T(e,i[n+72>>2],i[n+76>>2])}u[A+20|0]=1;break e}k=f-1|0,e=i[n+84>>2],k>>>0>=i[n+88>>2]-e>>3>>>0&&(e=p(32),i[n+24>>2]=e,i[n+28>>2]=27,i[n+32>>2]=-2147483616,r=l[13922]|l[13923]<<8|(l[13924]<<16|l[13925]<<24),f=l[13918]|l[13919]<<8|(l[13920]<<16|l[13921]<<24),u[e|0]=f,u[e+1|0]=f>>>8,u[e+2|0]=f>>>16,u[e+3|0]=f>>>24,u[e+4|0]=r,u[e+5|0]=r>>>8,u[e+6|0]=r>>>16,u[e+7|0]=r>>>24,u[e+27|0]=0,r=l[13941]|l[13942]<<8|(l[13943]<<16|l[13944]<<24),u[e+23|0]=r,u[e+24|0]=r>>>8,u[e+25|0]=r>>>16,u[e+26|0]=r>>>24,r=l[13938]|l[13939]<<8|(l[13940]<<16|l[13941]<<24),f=l[13934]|l[13935]<<8|(l[13936]<<16|l[13937]<<24),u[e+16|0]=f,u[e+17|0]=f>>>8,u[e+18|0]=f>>>16,u[e+19|0]=f>>>24,u[e+20|0]=r,u[e+21|0]=r>>>8,u[e+22|0]=r>>>16,u[e+23|0]=r>>>24,r=l[13930]|l[13931]<<8|(l[13932]<<16|l[13933]<<24),f=l[13926]|l[13927]<<8|(l[13928]<<16|l[13929]<<24),u[e+8|0]=f,u[e+9|0]=f>>>8,u[e+10|0]=f>>>16,u[e+11|0]=f>>>24,u[e+12|0]=r,u[e+13|0]=r>>>8,u[e+14|0]=r>>>16,u[e+15|0]=r>>>24,e=q(n+44|0,5,2007,n+24|0),u[e+19|0]<0&&Z(i[e+8>>2]),u[n+35|0]<0&&Z(i[n+24>>2]),e=i[n+84>>2]),r=e+(k<<3)|0,e=i[r>>2],r=i[r+4>>2],r&&(i[r+4>>2]=i[r+4>>2]+1);r:{f:{if(!e||(e=W0(e,86580,86784),!e))break f;r&&(i[r+4>>2]=i[r+4>>2]+1),u[A+20|0]=0,i[A+4>>2]=r,i[A>>2]=e;break r}e=p(24),i[n+12>>2]=e,i[n+16>>2]=19,i[n+20>>2]=-2147483624,f=l[12730]|l[12731]<<8|(l[12732]<<16|l[12733]<<24),u[e+15|0]=f,u[e+16|0]=f>>>8,u[e+17|0]=f>>>16,u[e+18|0]=f>>>24,f=l[12727]|l[12728]<<8|(l[12729]<<16|l[12730]<<24),k=l[12723]|l[12724]<<8|(l[12725]<<16|l[12726]<<24),u[e+8|0]=k,u[e+9|0]=k>>>8,u[e+10|0]=k>>>16,u[e+11|0]=k>>>24,u[e+12|0]=f,u[e+13|0]=f>>>8,u[e+14|0]=f>>>16,u[e+15|0]=f>>>24,f=l[12719]|l[12720]<<8|(l[12721]<<16|l[12722]<<24),k=l[12715]|l[12716]<<8|(l[12717]<<16|l[12718]<<24),u[e|0]=k,u[e+1|0]=k>>>8,u[e+2|0]=k>>>16,u[e+3|0]=k>>>24,u[e+4|0]=f,u[e+5|0]=f>>>8,u[e+6|0]=f>>>16,u[e+7|0]=f>>>24,u[e+19|0]=0,e=q(n+24|0,5,2007,n+12|0),f=i[e+4>>2],i[A>>2]=i[e>>2],i[A+4>>2]=f,f=A+8|0;f:{if(u[e+19|0]>=0){k=i[e+12>>2],i[f>>2]=i[e+8>>2],i[f+4>>2]=k,i[f+8>>2]=i[e+16>>2],u[A+20|0]=1;break f}if(T(f,i[e+8>>2],i[e+12>>2]),f=u[e+19|0],u[A+20|0]=1,(f|0)>=0)break f;Z(i[e+8>>2])}if(u[n+23|0]>=0)break r;Z(i[n+12>>2])}if(!r||(A=i[r+4>>2],i[r+4>>2]=A-1,A))break e;W[i[i[r>>2]+8>>2]](r),y(r)}if(u[n+83|0]<0&&Z(i[n+72>>2]),r=i[n+84>>2],!r)break i;if(e=i[n+88>>2],A=r,(e|0)!=(r|0)){for(;;){A=i[e-4>>2];e:{if(!A||(f=i[A+4>>2],i[A+4>>2]=f-1,f))break e;W[i[i[A>>2]+8>>2]](A),y(A)}if(e=e-8|0,(r|0)==(e|0))break}A=i[n+84>>2]}i[n+88>>2]=r,Z(A)}i:{if(!o||(A=i[o+4>>2],i[o+4>>2]=A-1,A))break i;W[i[i[o>>2]+8>>2]](o),y(o)}v=n+96|0}function $7(A,e,r,f,k,n){var t=0,o=0,s=0,w=0,h=0,_=0,B=0,m=0;o=v-80|0,v=o,Sf(o+68|0,e,r),e=i[o+68>>2],e=ei(o+32|0,e,i[o+72>>2]-e|0),V2(e,16),V2(e,4),V2(e,4),g[f+2>>1]=0,B=f,m=I1(e,3)+1|0,u[B+4|0]=m,B=f,m=I1(e,2),u[B+6|0]=m,V2(e,2);i:{if(!i2(e,1))break i;B=f,m=I1(e,7),u[B+9|0]=m,B=f,m=I1(e,1),u[B+10|0]=m,B=f,m=I1(e,8),u[B+11|0]=m,B=f,m=I1(e,1),u[B+12|0]=m,B=f,m=I1(e,1),u[B+13|0]=m;e:{r:{if(!i2(e,1)){u[f+8|0]=1,r=i[f+20>>2],h=i[f+24>>2];f:{if(r>>>0<h>>>0){u[r|0]=0,s=r+1|0;break f}if(t=i[f+16>>2],s=r-t|0,w=s+1|0,(w|0)<0)break r;if(r=0,h=h-t|0,_=h<<1,w=h>>>0>=1073741823?2147483647:w>>>0<_>>>0?_:w,w&&(r=p(w)),h=r+s|0,u[h|0]=0,s&&x(r,t,s),i[f+24>>2]=r+w,s=h+1|0,i[f+20>>2]=s,i[f+16>>2]=r,!t)break f;Z(t)}i[f+20>>2]=s}if(r=i[e+24>>2],i[e+24>>2]=r&-8,w=i[e+20>>2],s=i[e+16>>2],t=r&7,r=t,(r&63)>>>0>=32?(t=s<<r,r=0):(t=(1<<r)-1&s>>>32-r|w<<r,r=s<<r),i[e+16>>2]=r,i[e+20>>2]=t,fn(f+28|0,l[f+4|0]),r=l[f+4|0],r>>>0<2)break e;for(r=r-2|0;t=1<<r,w=i2(e,1),s=i[f+28>>2]+(r>>>3&536870908)|0,w?t=t|i[s>>2]:t=i[s>>2]&(t^-1),i[s>>2]=t,t=(r|0)>0,r=r-1|0,!!t;);break e}G0(),H()}r=i[e+24>>2],i[e+24>>2]=r&-8,w=i[e+20>>2],s=i[e+16>>2],t=r&7,r=t,(r&63)>>>0>=32?(t=s<<r,r=0):(t=(1<<r)-1&s>>>32-r|w<<r,r=s<<r),i[e+16>>2]=r,i[e+20>>2]=t,r=l[f+4|0],h=i[f+44>>2],t=i[f+40>>2],s=h-t|0;e:{if(r>>>0>s>>>0){if(w=r-s|0,_=i[f+48>>2],w>>>0<=_-h>>>0){w&&o0(h,0,w),i[f+44>>2]=w+h;break e}if(h=_-t|0,_=h<<1,_=h>>>0>=1073741823?2147483647:r>>>0<_>>>0?_:r,h=p(_),w&&o0(s+h|0,0,w),s&&x(h,t,s),i[f+48>>2]=h+_,i[f+44>>2]=r+h,i[f+40>>2]=h,!t)break e;Z(t);break e}if(r>>>0>=s>>>0)break e;i[f+44>>2]=r+t}if(r=l[f+4|0],r>>>0>=2)for(r=r-2|0;i[i[f+28>>2]+(r>>>3&536870908)>>2]>>>r&1&&(t=I1(e,8),u[i[f+40>>2]+r|0]=t),t=(r|0)>0,r=r-1|0,!!t;);s=f+52|0,t=i2(e,8),w=i[f+52>>2],r=i[f+56>>2]-w>>2;e:{if(t>>>0>r>>>0){V8(s,t-r|0);break e}if(r>>>0<=t>>>0)break e;i[f+56>>2]=w+(t<<2)}if(r=0,(t|0)<=0)break i;for(;w=i2(e,32),i[i[s>>2]+(r<<2)>>2]=w,r=r+1|0,(t|0)!=(r|0););}V2(e,1),i2(e,1)&&V2(e,1),$2(e,o+28|0),$2(e,o+24|0),r=i[o+28>>2],i[k>>2]=r,k=i[o+24>>2],i[n>>2]=k;i:{if(!((k|0)<65536&(r|0)<=65535)){if(e=p(56),i[o+12>>2]=e,i[o+16>>2]=55,i[o+20>>2]=-2147483592,r=l[26675]|l[26676]<<8|(l[26677]<<16|l[26678]<<24),f=l[26671]|l[26672]<<8|(l[26673]<<16|l[26674]<<24),u[e|0]=f,u[e+1|0]=f>>>8,u[e+2|0]=f>>>16,u[e+3|0]=f>>>24,u[e+4|0]=r,u[e+5|0]=r>>>8,u[e+6|0]=r>>>16,u[e+7|0]=r>>>24,u[e+55|0]=0,r=l[26722]|l[26723]<<8|(l[26724]<<16|l[26725]<<24),f=l[26718]|l[26719]<<8|(l[26720]<<16|l[26721]<<24),u[e+47|0]=f,u[e+48|0]=f>>>8,u[e+49|0]=f>>>16,u[e+50|0]=f>>>24,u[e+51|0]=r,u[e+52|0]=r>>>8,u[e+53|0]=r>>>16,u[e+54|0]=r>>>24,r=l[26715]|l[26716]<<8|(l[26717]<<16|l[26718]<<24),f=l[26711]|l[26712]<<8|(l[26713]<<16|l[26714]<<24),u[e+40|0]=f,u[e+41|0]=f>>>8,u[e+42|0]=f>>>16,u[e+43|0]=f>>>24,u[e+44|0]=r,u[e+45|0]=r>>>8,u[e+46|0]=r>>>16,u[e+47|0]=r>>>24,r=l[26707]|l[26708]<<8|(l[26709]<<16|l[26710]<<24),f=l[26703]|l[26704]<<8|(l[26705]<<16|l[26706]<<24),u[e+32|0]=f,u[e+33|0]=f>>>8,u[e+34|0]=f>>>16,u[e+35|0]=f>>>24,u[e+36|0]=r,u[e+37|0]=r>>>8,u[e+38|0]=r>>>16,u[e+39|0]=r>>>24,r=l[26699]|l[26700]<<8|(l[26701]<<16|l[26702]<<24),f=l[26695]|l[26696]<<8|(l[26697]<<16|l[26698]<<24),u[e+24|0]=f,u[e+25|0]=f>>>8,u[e+26|0]=f>>>16,u[e+27|0]=f>>>24,u[e+28|0]=r,u[e+29|0]=r>>>8,u[e+30|0]=r>>>16,u[e+31|0]=r>>>24,r=l[26691]|l[26692]<<8|(l[26693]<<16|l[26694]<<24),f=l[26687]|l[26688]<<8|(l[26689]<<16|l[26690]<<24),u[e+16|0]=f,u[e+17|0]=f>>>8,u[e+18|0]=f>>>16,u[e+19|0]=f>>>24,u[e+20|0]=r,u[e+21|0]=r>>>8,u[e+22|0]=r>>>16,u[e+23|0]=r>>>24,r=l[26683]|l[26684]<<8|(l[26685]<<16|l[26686]<<24),f=l[26679]|l[26680]<<8|(l[26681]<<16|l[26682]<<24),u[e+8|0]=f,u[e+9|0]=f>>>8,u[e+10|0]=f>>>16,u[e+11|0]=f>>>24,u[e+12|0]=r,u[e+13|0]=r>>>8,u[e+14|0]=r>>>16,u[e+15|0]=r>>>24,q(A,9,2006,o+12|0),u[o+23|0]>=0)break i;Z(i[o+12>>2]);break i}if(g[f+66>>1]=k,g[f+64>>1]=r,i2(e,1)&&($2(e,o+12|0),$2(e,o+8|0),$2(e,o+4|0),$2(e,o)),i2(e,1),$2(e,o+8|0),e=i[o+8>>2],(e|0)>=248){if(e=p(32),i[o+12>>2]=e,i[o+16>>2]=27,i[o+20>>2]=-2147483616,r=l[25258]|l[25259]<<8|(l[25260]<<16|l[25261]<<24),f=l[25254]|l[25255]<<8|(l[25256]<<16|l[25257]<<24),u[e|0]=f,u[e+1|0]=f>>>8,u[e+2|0]=f>>>16,u[e+3|0]=f>>>24,u[e+4|0]=r,u[e+5|0]=r>>>8,u[e+6|0]=r>>>16,u[e+7|0]=r>>>24,u[e+27|0]=0,r=l[25277]|l[25278]<<8|(l[25279]<<16|l[25280]<<24),u[e+23|0]=r,u[e+24|0]=r>>>8,u[e+25|0]=r>>>16,u[e+26|0]=r>>>24,r=l[25274]|l[25275]<<8|(l[25276]<<16|l[25277]<<24),f=l[25270]|l[25271]<<8|(l[25272]<<16|l[25273]<<24),u[e+16|0]=f,u[e+17|0]=f>>>8,u[e+18|0]=f>>>16,u[e+19|0]=f>>>24,u[e+20|0]=r,u[e+21|0]=r>>>8,u[e+22|0]=r>>>16,u[e+23|0]=r>>>24,r=l[25266]|l[25267]<<8|(l[25268]<<16|l[25269]<<24),f=l[25262]|l[25263]<<8|(l[25264]<<16|l[25265]<<24),u[e+8|0]=f,u[e+9|0]=f>>>8,u[e+10|0]=f>>>16,u[e+11|0]=f>>>24,u[e+12|0]=r,u[e+13|0]=r>>>8,u[e+14|0]=r>>>16,u[e+15|0]=r>>>24,q(A,9,0,o+12|0),u[o+23|0]>=0)break i;Z(i[o+12>>2]);break i}if(u[f+5|0]=1,u[f+7|0]=e,e=i[26917],i[A>>2]=i[26916],i[A+4>>2]=e,A=A+8|0,u[107683]>=0){e=i[26919],i[A>>2]=i[26918],i[A+4>>2]=e,i[A+8>>2]=i[26920];break i}T(A,i[26918],i[26919])}A=i[o+68>>2],A&&(i[o+72>>2]=A,Z(A)),v=o+80|0}function d7(A,e,r,f,k,n,t){var o=0,s=0,w=0,h=0,_=0,B=0,m=0,X=0,Q=0,V=0,F=0,I=0,E=0,R=0,N=0,M=0,z=0,S=0,O=0,P=0;w=v+-64|0,v=w,i[w+60>>2]=e,O=w+39|0,E=w+40|0;i:{e:{r:{f:{A:for(;;){o=0;k:for(;;){if(h=e,(X^2147483647)<(o|0))break f;X=o+X|0;n:{t:{u:{o:{if(o=e,s=l[o|0],s)for(;;){l:{e=s&255;s:{if(!e){e=o;break s}if((e|0)!=37)break l;for(s=o;;){if(l[s+1|0]!=37){e=s;break s}if(o=o+1|0,m=l[s+2|0],e=s+2|0,s=e,(m|0)!=37)break}}if(o=o-h|0,S=X^2147483647,(o|0)>(S|0))break f;if(A&&t4(A,h,o),o)continue k;i[w+60>>2]=e,o=e+1|0,V=-1,s=u[e+1|0]-48|0,l[e+2|0]!=36|s>>>0>9||(R=1,V=s,o=e+3|0),i[w+60>>2]=o,B=0,s=u[o|0],e=s-32|0;s:{if(e>>>0>31){m=o;break s}if(m=o,e=1<<e,!(e&75913))break s;for(;;){if(m=o+1|0,i[w+60>>2]=m,B=e|B,s=u[o+1|0],e=s-32|0,e>>>0>=32)break s;if(o=m,e=1<<e,!(e&75913))break}}s:{if((s|0)==42){e=u[m+1|0]-48|0;w:{if(!(l[m+2|0]!=36|e>>>0>9)){_:{if(!A){i[(e<<2)+k>>2]=10,Q=0;break _}Q=i[(e<<3)+f>>2]}e=m+3|0,R=1;break w}if(R)break o;if(e=m+1|0,!A){i[w+60>>2]=e,R=0,Q=0;break s}o=i[r>>2],i[r>>2]=o+4,Q=i[o>>2],R=0}if(i[w+60>>2]=e,(Q|0)>=0)break s;Q=0-Q|0,B=B|8192;break s}if(Q=Zo(w+60|0),(Q|0)<0)break f;e=i[w+60>>2]}o=0,_=-1,s=0;s:{if(l[e|0]!=46)break s;if(l[e+1|0]==42){s=u[e+2|0]-48|0;w:{if(!(l[e+3|0]!=36|s>>>0>9)){e=e+4|0;_:{if(!A){i[(s<<2)+k>>2]=10,_=0;break _}_=i[(s<<3)+f>>2]}break w}if(R)break o;if(e=e+2|0,_=0,!A)break w;s=i[r>>2],i[r>>2]=s+4,_=i[s>>2]}i[w+60>>2]=e,s=(_|0)>=0;break s}i[w+60>>2]=e+1,_=Zo(w+60|0),e=i[w+60>>2],s=1}for(M=s;;){if(N=o,m=28,F=e,s=u[e|0],s-123>>>0<4294967238)break r;if(e=e+1|0,o=l[(s+G(o,58)|0)+69743|0],!((o-1&255)>>>0<8))break}i[w+60>>2]=e;s:{if((o|0)!=27){if(!o)break r;if((V|0)>=0){if(!A){i[(V<<2)+k>>2]=o;continue A}o=(V<<3)+f|0,s=i[o+4>>2],i[w+48>>2]=i[o>>2],i[w+52>>2]=s;break s}if(!A)break n;bn(w+48|0,o,r,t);break s}if((V|0)>=0)break r;if(o=0,!A)continue k}if(l[A|0]&32)break e;s=B&-65537,B=B&8192?s:B,V=0,z=2960,m=E;s:{w:{_:{h:{B:{v:{Z:{G:{m:{X:{W:{F:{V:{C:{g:{I:{y:switch(F=l[F|0],o=F<<24>>24,o=N&&(F&15)==3?o&-45:o,o-88|0){case 0:case 32:break V;case 1:case 2:case 3:case 4:case 5:case 6:case 7:case 8:case 10:case 16:case 18:case 19:case 20:case 21:case 25:case 26:case 28:case 30:case 31:break t;case 9:case 13:case 14:case 15:break s;case 11:break G;case 12:case 17:break W;case 22:break g;case 23:break F;case 24:break C;case 27:break Z;case 29:break I;default:break y}y:switch(o-65|0){case 1:case 3:break t;case 0:case 4:case 5:case 6:break s;case 2:break v;default:break y}if((o|0)==83)break B;break t}s=i[w+48>>2],F=i[w+52>>2],e=2960;break X}o=0;g:switch(N|0){case 0:i[i[w+48>>2]>>2]=X;continue k;case 1:i[i[w+48>>2]>>2]=X;continue k;case 2:h=i[w+48>>2],i[h>>2]=X,i[h+4>>2]=X>>31;continue k;case 3:g[i[w+48>>2]>>1]=X;continue k;case 4:u[i[w+48>>2]]=X;continue k;case 6:i[i[w+48>>2]>>2]=X;continue k;case 7:break g;default:continue k}h=i[w+48>>2],i[h>>2]=X,i[h+4>>2]=X>>31;continue k}_=_>>>0<=8?8:_,B=B|8,o=120}if(e=E,P=o&32,h=i[w+52>>2],F=h,s=i[w+48>>2],I=s,s|h)for(;e=e-1|0,u[e|0]=P|l[(I&15)+70272|0],N=!h&I>>>0>15|(h|0)!=0,I=(h&15)<<28|I>>>4,h=h>>>4|0,!!N;);if(h=e,!(s|F)|!(B&8))break m;z=(o>>>4|0)+2960|0,V=2;break m}if(e=E,h=i[w+52>>2],F=h,s=i[w+48>>2],I=s,s|h)for(;e=e-1|0,u[e|0]=I&7|48,N=!h&I>>>0>7|(h|0)!=0,I=(h&7)<<29|I>>>3,h=h>>>3|0,!!N;);if(h=e,!(B&8))break m;e=E-e|0,_=(e|0)<(_|0)?_:e+1|0;break m}if(s=i[w+48>>2],e=i[w+52>>2],F=e,(e|0)<0){o=0-(e+((s|0)!=0)|0)|0,F=o,s=0-s|0,i[w+48>>2]=s,i[w+52>>2]=o,V=1,e=2960;break X}if(B&2048){V=1,e=2961;break X}V=B&1,e=V?2962:2960}z=e,h=vi(s,F,E)}if((_|0)<0&M)break f;if(B=M?B&-65537:B,!(_|(s|F)!=0)){h=E,_=0;break t}e=!(s|F)+(E-h|0)|0,_=(e|0)<(_|0)?_:e;break t}o=l[w+48|0];break u}if(e=i[w+48>>2],h=e||26502,e=_>>>0>=2147483647?2147483647:_,o=wA(h,0,e),e=o?o-h|0:e,m=e+h|0,(_|0)>=0){B=s,_=e;break t}if(B=s,_=e,l[m|0])break f;break t}if(o=i[w+48>>2],o|i[w+52>>2])break h;o=0;break u}if(_){s=i[w+48>>2];break _}o=0,w4(A,32,Q,0,B);break w}i[w+12>>2]=0,i[w+8>>2]=o,s=w+8|0,i[w+48>>2]=s,_=-1}for(o=0;;){_:{if(h=i[s>>2],!h)break _;if(h=p3(w+4|0,h),(h|0)<0)break e;if(h>>>0>_-o>>>0)break _;if(s=s+4|0,o=o+h|0,_>>>0>o>>>0)continue}break}if(m=61,(o|0)<0)break r;if(w4(A,32,Q,o,B),!o){o=0;break w}for(m=0,s=i[w+48>>2];;){if(h=i[s>>2],!h||(_=w+4|0,h=p3(_,h),m=h+m|0,m>>>0>o>>>0))break w;if(t4(A,_,h),s=s+4|0,!(o>>>0>m>>>0))break}}w4(A,32,Q,o,B^8192),o=(o|0)<(Q|0)?Q:o;continue k}if((_|0)<0&M)break f;if(m=61,o=W[n|0](A,t0[w+48>>3],Q,_,B,o)|0,(o|0)>=0)continue k;break r}s=l[o+1|0],o=o+1|0}if(A)break i;if(!R)break n;for(o=1;;){if(A=i[(o<<2)+k>>2],A){if(bn((o<<3)+f|0,A,r,t),X=1,o=o+1|0,(o|0)!=10)continue;break i}break}if(o>>>0>=10){X=1;break i}for(;;){if(i[(o<<2)+k>>2])break o;if(X=1,o=o+1|0,(o|0)==10)break}break i}m=28;break r}u[w+39|0]=o,_=1,h=O,B=s}if(s=m-h|0,_=(s|0)<(_|0)?_:s,(_|0)>(V^2147483647))break f;if(m=61,e=_+V|0,o=(e|0)<(Q|0)?Q:e,(S|0)<(o|0))break r;w4(A,32,o,e,B),t4(A,z,V),w4(A,48,o,e,B^65536),w4(A,48,_,s,0),t4(A,h,s),w4(A,32,o,e,B^8192),e=i[w+60>>2];continue}break}break}X=0;break i}m=61}i[31324]=m}X=-1}return v=w- -64|0,X}function c7(A,e,r,f,k,n,t){var o=0,s=0,w=0,h=0,_=0,B=0,m=0,X=0,Q=0,V=0,F=0,I=0,E=0,R=0,N=0,M=0,z=0,S=0,O=0;h=v+-64|0,v=h,o=p(32),i[h+8>>2]=o,i[h+12>>2]=27,i[h+16>>2]=-2147483616,s=l[12099]|l[12100]<<8|(l[12101]<<16|l[12102]<<24),u[o+23|0]=s,u[o+24|0]=s>>>8,u[o+25|0]=s>>>16,u[o+26|0]=s>>>24,s=l[12096]|l[12097]<<8|(l[12098]<<16|l[12099]<<24),w=l[12092]|l[12093]<<8|(l[12094]<<16|l[12095]<<24),u[o+16|0]=w,u[o+17|0]=w>>>8,u[o+18|0]=w>>>16,u[o+19|0]=w>>>24,u[o+20|0]=s,u[o+21|0]=s>>>8,u[o+22|0]=s>>>16,u[o+23|0]=s>>>24,s=l[12088]|l[12089]<<8|(l[12090]<<16|l[12091]<<24),w=l[12084]|l[12085]<<8|(l[12086]<<16|l[12087]<<24),u[o+8|0]=w,u[o+9|0]=w>>>8,u[o+10|0]=w>>>16,u[o+11|0]=w>>>24,u[o+12|0]=s,u[o+13|0]=s>>>8,u[o+14|0]=s>>>16,u[o+15|0]=s>>>24,s=l[12080]|l[12081]<<8|(l[12082]<<16|l[12083]<<24),w=l[12076]|l[12077]<<8|(l[12078]<<16|l[12079]<<24),u[o|0]=w,u[o+1|0]=w>>>8,u[o+2|0]=w>>>16,u[o+3|0]=w>>>24,u[o+4|0]=s,u[o+5|0]=s>>>8,u[o+6|0]=s>>>16,u[o+7|0]=s>>>24,u[o+27|0]=0,z=q(h+44|0,2,0,h+8|0),u[h+19|0]<0&&Z(i[h+8>>2]),i[h+40>>2]=0,i[h+32>>2]=0,i[h+36>>2]=0,o=i[r>>2],s=l[e+24|0],r=s+l[e+25|0]|0,s=r>>>0<s>>>0,w=O0(r,s,k,0),Q=l0,V=r,r=n-k|0,s=O0(V,s,r,t-(k>>>0>n>>>0)|0),gr(h+8|0,o,f,h+32|0,(Q&7)<<29|w>>>3,0,(l0&7)<<29|s>>>3,0);i:{e:{if(!i[h+8>>2]){if(!t&k>>>0>=n>>>0)break e;if(f=l[e+24|0],X=f>>>3|0,Q=i[e+64>>2],e=l[e+25|0],!e){if(f>>>0>=8){for(_=X&28,m=X&3,e=0,F=X-1>>>0<3;;){if(o=0,f=0,s=i[h+32>>2],r=e,!F)for(V=s+3|0,I=s+2|0,E=s+1|0,w=0;f=(f<<16|o>>>16)<<16,o=l[r+E|0]|(o<<16|l[r+s|0]<<8),f=f|o>>>16,o=l[r+V|0]|(o<<16|l[r+I|0]<<8),r=r+4|0,w=w+4|0,(_|0)!=(w|0););if(w=0,m)for(;f=f<<8|o>>>24,o=l[r+s|0]|o<<8,r=r+1|0,w=w+1|0,(m|0)!=(w|0););if(r=(k<<4)+Q|0,i[r>>2]=o,i[r+4>>2]=f,e=e+X|0,k=k+1|0,B=k?B:B+1|0,!((k|0)!=(n|0)|(t|0)!=(B|0)))break}break e}if(o=k,f=0,e=0,B=r&7,B)for(r=0;s=(o<<4)+Q|0,i[s>>2]=0,i[s+4>>2]=0,o=o+1|0,f=o?f:f+1|0,e=e+1|0,r=e?r:r+1|0,!!(r|(e|0)!=(B|0)););if((0-((k>>>0<n>>>0)+t|0)|0)==-1&k-n>>>0>4294967288)break e;for(r=Q+112|0,k=Q+96|0,B=Q+80|0,s=Q- -64|0,w=Q+48|0,X=Q+32|0,m=Q+16|0;e=o<<4,_=e+Q|0,i[_>>2]=0,i[_+4>>2]=0,_=e+m|0,i[_>>2]=0,i[_+4>>2]=0,_=e+X|0,i[_>>2]=0,i[_+4>>2]=0,_=e+w|0,i[_>>2]=0,i[_+4>>2]=0,_=e+s|0,i[_>>2]=0,i[_+4>>2]=0,_=e+B|0,i[_>>2]=0,i[_+4>>2]=0,_=e+k|0,i[_>>2]=0,i[_+4>>2]=0,e=e+r|0,i[e>>2]=0,i[e+4>>2]=0,o=o+8|0,f=o>>>0<8?f+1|0:f,!!((n|0)!=(o|0)|(f|0)!=(t|0)););break e}if(m=e>>>3|0,f>>>0<=7){if(e>>>0>=8){for(_=m&28,s=m&3,f=0,F=m-1>>>0<3;;){if(V=(k<<4)+Q|0,e=V,i[e>>2]=0,i[e+4>>2]=0,X=i[h+32>>2],r=f,e=0,w=0,!F){for(;o=r,r=o+4|0,e=e+4|0,(_|0)!=(e|0););e=o+X|0,e=l[e|0]|l[e+1|0]<<8|(l[e+2|0]<<16|l[e+3|0]<<24),w=e<<24|(e&65280)<<8|(e>>>8&65280|e>>>24)}if(e=0,s)for(;w=l[r+X|0]|w<<8,r=r+1|0,e=e+1|0,(s|0)!=(e|0););if(i[V+8>>2]=w,f=f+m|0,k=k+1|0,B=k?B:B+1|0,!((k|0)!=(n|0)|(t|0)!=(B|0)))break}break e}if(o=k,f=0,e=0,s=r&3,s)for(r=0;B=(o<<4)+Q|0,i[B+8>>2]=0,i[B>>2]=0,i[B+4>>2]=0,o=o+1|0,f=o?f:f+1|0,e=e+1|0,r=e?r:r+1|0,!!(r|(e|0)!=(s|0)););if((0-((k>>>0<n>>>0)+t|0)|0)==-1&k-n>>>0>4294967292)break e;for(;e=(o<<4)+Q|0,i[e+8>>2]=0,i[e>>2]=0,i[e+4>>2]=0,i[e+56>>2]=0,i[e+48>>2]=0,i[e+52>>2]=0,i[e+40>>2]=0,i[e+32>>2]=0,i[e+36>>2]=0,i[e+24>>2]=0,i[e+16>>2]=0,i[e+20>>2]=0,o=o+4|0,f=o>>>0<4?f+1|0:f,!!((n|0)!=(o|0)|(f|0)!=(t|0)););break e}if(e>>>0<=7){for(_=X&28,m=X&3,F=X-1>>>0<3,e=0;;){if(o=0,f=0,s=i[h+32>>2],r=e,!F)for(V=s+3|0,I=s+2|0,E=s+1|0,w=0;R=l[r+E|0]|(l[r+s|0]<<8|o<<16),M=R<<16,f=(f<<16|o>>>16)<<16|R>>>16,o=l[r+V|0]|(l[r+I|0]<<8|M),r=r+4|0,w=w+4|0,(_|0)!=(w|0););if(w=0,m)for(;f=f<<8|o>>>24,o=l[r+s|0]|o<<8,r=r+1|0,w=w+1|0,(m|0)!=(w|0););if(r=(k<<4)+Q|0,i[r+8>>2]=0,i[r>>2]=o,i[r+4>>2]=f,e=e+X|0,k=k+1|0,B=k?B:B+1|0,!((k|0)!=(n|0)|(t|0)!=(B|0)))break}break e}for(V=m&28,_=m&3,I=X&28,F=X&3,E=m+X|0,s=0,R=X-1>>>0<3,M=m-1>>>0<3;;){if(o=0,f=0,e=i[h+32>>2],r=s,!R)for(m=e+3|0,N=e+2|0,O=e+1|0,w=0;S=l[r+O|0]|(o<<16|l[e+r|0]<<8),f=(f<<16|o>>>16)<<16|S>>>16,o=l[r+m|0]|(l[r+N|0]<<8|S<<16),r=r+4|0,w=w+4|0,(I|0)!=(w|0););if(w=0,F)for(;f=f<<8|o>>>24,o=l[e+r|0]|o<<8,r=r+1|0,w=w+1|0,(F|0)!=(w|0););if(N=(k<<4)+Q|0,e=N,i[e>>2]=o,i[e+4>>2]=f,r=s+X|0,e=0,m=i[h+32>>2],f=0,w=0,!M){for(;o=r,r=o+4|0,f=f+4|0,(V|0)!=(f|0););f=o+m|0,f=l[f|0]|l[f+1|0]<<8|(l[f+2|0]<<16|l[f+3|0]<<24),w=f<<24|(f&65280)<<8|(f>>>8&65280|f>>>24)}if(_)for(;w=l[r+m|0]|w<<8,r=r+1|0,e=e+1|0,(_|0)!=(e|0););if(i[N+8>>2]=w,s=s+E|0,k=k+1|0,B=k?B:B+1|0,!((k|0)!=(n|0)|(t|0)!=(B|0)))break}break e}e=i[h+12>>2],i[A>>2]=i[h+8>>2],i[A+4>>2]=e,i[A+16>>2]=i[h+24>>2],e=i[h+20>>2],i[A+8>>2]=i[h+16>>2],i[A+12>>2]=e,i[h+24>>2]=0,i[h+16>>2]=0,i[h+20>>2]=0;break i}if(e=i[26917],i[A>>2]=i[26916],i[A+4>>2]=e,A=A+8|0,u[107683]>=0){e=i[26919],i[A>>2]=i[26918],i[A+4>>2]=e,i[A+8>>2]=i[26920];break i}T(A,i[26918],i[26919])}u[h+27|0]<0&&Z(i[h+16>>2]),A=i[h+32>>2],A&&(i[h+36>>2]=A,Z(A)),u[z+19|0]<0&&Z(i[z+8>>2]),v=h- -64|0}function HB(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0;var k=0,n=0,t=0,o=0,s=0,w=0,h=0,_=0,B=0,m=0,X=0,Q=0;f=v-16|0,v=f,B=o2(r);i:{e:{if(h=X2(r),!h)break e;for(;;){if(n=X2(r),n<<24>>24<0){if(e=p(40),i[f+4>>2]=e,i[f+8>>2]=38,i[f+12>>2]=-2147483608,r=l[16184]|l[16185]<<8|(l[16186]<<16|l[16187]<<24),k=l[16180]|l[16181]<<8|(l[16182]<<16|l[16183]<<24),u[e|0]=k,u[e+1|0]=k>>>8,u[e+2|0]=k>>>16,u[e+3|0]=k>>>24,u[e+4|0]=r,u[e+5|0]=r>>>8,u[e+6|0]=r>>>16,u[e+7|0]=r>>>24,u[e+38|0]=0,r=l[16214]|l[16215]<<8|(l[16216]<<16|l[16217]<<24),k=l[16210]|l[16211]<<8|(l[16212]<<16|l[16213]<<24),u[e+30|0]=k,u[e+31|0]=k>>>8,u[e+32|0]=k>>>16,u[e+33|0]=k>>>24,u[e+34|0]=r,u[e+35|0]=r>>>8,u[e+36|0]=r>>>16,u[e+37|0]=r>>>24,r=l[16208]|l[16209]<<8|(l[16210]<<16|l[16211]<<24),k=l[16204]|l[16205]<<8|(l[16206]<<16|l[16207]<<24),u[e+24|0]=k,u[e+25|0]=k>>>8,u[e+26|0]=k>>>16,u[e+27|0]=k>>>24,u[e+28|0]=r,u[e+29|0]=r>>>8,u[e+30|0]=r>>>16,u[e+31|0]=r>>>24,r=l[16200]|l[16201]<<8|(l[16202]<<16|l[16203]<<24),k=l[16196]|l[16197]<<8|(l[16198]<<16|l[16199]<<24),u[e+16|0]=k,u[e+17|0]=k>>>8,u[e+18|0]=k>>>16,u[e+19|0]=k>>>24,u[e+20|0]=r,u[e+21|0]=r>>>8,u[e+22|0]=r>>>16,u[e+23|0]=r>>>24,r=l[16192]|l[16193]<<8|(l[16194]<<16|l[16195]<<24),k=l[16188]|l[16189]<<8|(l[16190]<<16|l[16191]<<24),u[e+8|0]=k,u[e+9|0]=k>>>8,u[e+10|0]=k>>>16,u[e+11|0]=k>>>24,u[e+12|0]=r,u[e+13|0]=r>>>8,u[e+14|0]=r>>>16,u[e+15|0]=r>>>24,q(A,4,3002,f+4|0),u[f+15|0]>=0)break i;Z(i[f+4>>2]);break i}if(n>>>0>=17){if(e=p(56),i[f+4>>2]=e,i[f+8>>2]=51,i[f+12>>2]=-2147483592,r=l[16132]|l[16133]<<8|(l[16134]<<16|l[16135]<<24),k=l[16128]|l[16129]<<8|(l[16130]<<16|l[16131]<<24),u[e|0]=k,u[e+1|0]=k>>>8,u[e+2|0]=k>>>16,u[e+3|0]=k>>>24,u[e+4|0]=r,u[e+5|0]=r>>>8,u[e+6|0]=r>>>16,u[e+7|0]=r>>>24,u[e+51|0]=0,r=l[16175]|l[16176]<<8|(l[16177]<<16|l[16178]<<24),u[e+47|0]=r,u[e+48|0]=r>>>8,u[e+49|0]=r>>>16,u[e+50|0]=r>>>24,r=l[16172]|l[16173]<<8|(l[16174]<<16|l[16175]<<24),k=l[16168]|l[16169]<<8|(l[16170]<<16|l[16171]<<24),u[e+40|0]=k,u[e+41|0]=k>>>8,u[e+42|0]=k>>>16,u[e+43|0]=k>>>24,u[e+44|0]=r,u[e+45|0]=r>>>8,u[e+46|0]=r>>>16,u[e+47|0]=r>>>24,r=l[16164]|l[16165]<<8|(l[16166]<<16|l[16167]<<24),k=l[16160]|l[16161]<<8|(l[16162]<<16|l[16163]<<24),u[e+32|0]=k,u[e+33|0]=k>>>8,u[e+34|0]=k>>>16,u[e+35|0]=k>>>24,u[e+36|0]=r,u[e+37|0]=r>>>8,u[e+38|0]=r>>>16,u[e+39|0]=r>>>24,r=l[16156]|l[16157]<<8|(l[16158]<<16|l[16159]<<24),k=l[16152]|l[16153]<<8|(l[16154]<<16|l[16155]<<24),u[e+24|0]=k,u[e+25|0]=k>>>8,u[e+26|0]=k>>>16,u[e+27|0]=k>>>24,u[e+28|0]=r,u[e+29|0]=r>>>8,u[e+30|0]=r>>>16,u[e+31|0]=r>>>24,r=l[16148]|l[16149]<<8|(l[16150]<<16|l[16151]<<24),k=l[16144]|l[16145]<<8|(l[16146]<<16|l[16147]<<24),u[e+16|0]=k,u[e+17|0]=k>>>8,u[e+18|0]=k>>>16,u[e+19|0]=k>>>24,u[e+20|0]=r,u[e+21|0]=r>>>8,u[e+22|0]=r>>>16,u[e+23|0]=r>>>24,r=l[16140]|l[16141]<<8|(l[16142]<<16|l[16143]<<24),k=l[16136]|l[16137]<<8|(l[16138]<<16|l[16139]<<24),u[e+8|0]=k,u[e+9|0]=k>>>8,u[e+10|0]=k>>>16,u[e+11|0]=k>>>24,u[e+12|0]=r,u[e+13|0]=r>>>8,u[e+14|0]=r>>>16,u[e+15|0]=r>>>24,q(A,4,3002,f+4|0),u[f+15|0]>=0)break i;Z(i[f+4>>2]);break i}r:{k=i[e+104>>2],o=i[e+108>>2];f:{if(k>>>0<o>>>0){u[k|0]=n,n=k+1|0;break f}if(s=i[e+100>>2],k=k-s|0,t=k+1|0,(t|0)<0)break r;if(o=o-s|0,w=o<<1,o=o>>>0>=1073741823?2147483647:t>>>0<w>>>0?w:t,o?t=p(o):t=0,w=t+k|0,u[w|0]=n,k&&x(t,s,k),i[e+108>>2]=t+o,n=w+1|0,i[e+104>>2]=n,i[e+100>>2]=t,!s)break f;Z(s)}if(i[e+104>>2]=n,_=_+1|0,h>>>0>(_&255)>>>0)continue;break e}break}G0(),H()}e:{if(!B)break e;for(;;){r:{i[f+12>>2]=0,i[f+4>>2]=0,i[f+8>>2]=0,k=i[e+116>>2];f:{if(k>>>0<u0[e+120>>2]){if(i[k+8>>2]=0,i[k>>2]=0,i[k+4>>2]=0,n=i[f+8>>2],s=i[f+4>>2],(n|0)!=(s|0)){if(n=n-s|0,(n|0)<0)break r;t=p(n),i[k+4>>2]=t,i[k>>2]=t,o=n+t|0,i[k+8>>2]=o,n&&x(t,s,n),i[k+4>>2]=o}k=k+12|0;break f}A:{k:{n:{if(h=i[e+116>>2],k=i[e+112>>2],t=h-k|0,n=((t|0)/12|0)+1|0,n>>>0<357913942){if(s=(i[e+120>>2]-k|0)/12|0,o=s<<1,n=s>>>0>=178956970?357913941:n>>>0<o>>>0?o:n,n>>>0>=357913942)break n;if(_=G(n,12),m=p(_),o=t+m|0,i[o+8>>2]=0,i[o>>2]=0,i[o+4>>2]=0,n=i[f+8>>2],s=i[f+4>>2],(n|0)!=(s|0)){if(n=n-s|0,(n|0)<0)break k;w=p(n),i[o>>2]=w,X=n+w|0,i[o+8>>2]=X,n&&x(w,s,n),i[o+4>>2]=X}if(s=o+G((t|0)/-12|0,12)|0,(k|0)!=(h|0)){for(t=k,n=s;i[n>>2]=i[t>>2],i[n+4>>2]=i[t+4>>2],i[n+8>>2]=i[t+8>>2],i[t+8>>2]=0,i[t>>2]=0,i[t+4>>2]=0,n=n+12|0,t=t+12|0,(h|0)!=(t|0););for(;n=i[k>>2],n&&(i[k+4>>2]=n,Z(n)),k=k+12|0,(h|0)!=(k|0););k=i[e+112>>2]}i[e+120>>2]=_+m,n=o+12|0,i[e+116>>2]=n,i[e+112>>2]=s,k&&Z(k),k=n;break A}G0(),H()}z0(),H()}G0(),H()}}if(i[e+116>>2]=k,k=i[f+4>>2],k&&(i[f+8>>2]=k,Z(k)),Q=Q+1|0,(Q&65535)>>>0<B>>>0)continue;break e}break}G0(),H()}if(l[r+20|0]==1){if(u[f+4|0]=0,u[f+15|0]=0,q(A,2,100,f+4|0),u[f+15|0]>=0)break i;Z(i[f+4>>2]);break i}if(e=i[26917],i[A>>2]=i[26916],i[A+4>>2]=e,A=A+8|0,u[107683]>=0){e=i[26919],i[A>>2]=i[26918],i[A+4>>2]=e,i[A+8>>2]=i[26920];break i}T(A,i[26918],i[26919])}v=f+16|0}function zB(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,t=0;t=v-48|0,v=t,hf(t+24|0,e,r);i:{if(i[t+24>>2]){e=i[t+28>>2],i[A>>2]=i[t+24>>2],i[A+4>>2]=e,i[A+16>>2]=i[t+40>>2],e=i[t+36>>2],i[A+8>>2]=i[t+32>>2],i[A+12>>2]=e,i[t+40>>2]=0,i[t+32>>2]=0,i[t+36>>2]=0;break i}r=i[e+196>>2];e:{if(i[r+104>>2]==i[r+108>>2])break e;if(f=xA(i[e+188>>2],1),!f){if(e=p(32),i[t+12>>2]=e,i[t+16>>2]=27,i[t+20>>2]=-2147483616,r=l[21868]|l[21869]<<8|(l[21870]<<16|l[21871]<<24),k=l[21864]|l[21865]<<8|(l[21866]<<16|l[21867]<<24),u[e|0]=k,u[e+1|0]=k>>>8,u[e+2|0]=k>>>16,u[e+3|0]=k>>>24,u[e+4|0]=r,u[e+5|0]=r>>>8,u[e+6|0]=r>>>16,u[e+7|0]=r>>>24,u[e+27|0]=0,r=l[21887]|l[21888]<<8|(l[21889]<<16|l[21890]<<24),u[e+23|0]=r,u[e+24|0]=r>>>8,u[e+25|0]=r>>>16,u[e+26|0]=r>>>24,r=l[21884]|l[21885]<<8|(l[21886]<<16|l[21887]<<24),k=l[21880]|l[21881]<<8|(l[21882]<<16|l[21883]<<24),u[e+16|0]=k,u[e+17|0]=k>>>8,u[e+18|0]=k>>>16,u[e+19|0]=k>>>24,u[e+20|0]=r,u[e+21|0]=r>>>8,u[e+22|0]=r>>>16,u[e+23|0]=r>>>24,r=l[21876]|l[21877]<<8|(l[21878]<<16|l[21879]<<24),k=l[21872]|l[21873]<<8|(l[21874]<<16|l[21875]<<24),u[e+8|0]=k,u[e+9|0]=k>>>8,u[e+10|0]=k>>>16,u[e+11|0]=k>>>24,u[e+12|0]=r,u[e+13|0]=r>>>8,u[e+14|0]=r>>>16,u[e+15|0]=r>>>24,q(A,2,0,t+12|0),u[t+23|0]>=0)break i;Z(i[t+12>>2]);break i}r=0,n=i[e+180>>2],k=i[n+104>>2];r:{if(f=i[f+8>>2]-1|0,f>>>0<i[n+108>>2]-k>>3>>>0&&(r=k+(f<<3)|0,k=i[r>>2],r=i[r+4>>2],r&&(i[r+4>>2]=i[r+4>>2]+1),k))break r;if(e=p(40),i[t+12>>2]=e,i[t+16>>2]=35,i[t+20>>2]=-2147483608,k=l[8006]|l[8007]<<8|(l[8008]<<16|l[8009]<<24),f=l[8002]|l[8003]<<8|(l[8004]<<16|l[8005]<<24),u[e|0]=f,u[e+1|0]=f>>>8,u[e+2|0]=f>>>16,u[e+3|0]=f>>>24,u[e+4|0]=k,u[e+5|0]=k>>>8,u[e+6|0]=k>>>16,u[e+7|0]=k>>>24,u[e+35|0]=0,k=l[8033]|l[8034]<<8|(l[8035]<<16|l[8036]<<24),u[e+31|0]=k,u[e+32|0]=k>>>8,u[e+33|0]=k>>>16,u[e+34|0]=k>>>24,k=l[8030]|l[8031]<<8|(l[8032]<<16|l[8033]<<24),f=l[8026]|l[8027]<<8|(l[8028]<<16|l[8029]<<24),u[e+24|0]=f,u[e+25|0]=f>>>8,u[e+26|0]=f>>>16,u[e+27|0]=f>>>24,u[e+28|0]=k,u[e+29|0]=k>>>8,u[e+30|0]=k>>>16,u[e+31|0]=k>>>24,k=l[8022]|l[8023]<<8|(l[8024]<<16|l[8025]<<24),f=l[8018]|l[8019]<<8|(l[8020]<<16|l[8021]<<24),u[e+16|0]=f,u[e+17|0]=f>>>8,u[e+18|0]=f>>>16,u[e+19|0]=f>>>24,u[e+20|0]=k,u[e+21|0]=k>>>8,u[e+22|0]=k>>>16,u[e+23|0]=k>>>24,k=l[8014]|l[8015]<<8|(l[8016]<<16|l[8017]<<24),f=l[8010]|l[8011]<<8|(l[8012]<<16|l[8013]<<24),u[e+8|0]=f,u[e+9|0]=f>>>8,u[e+10|0]=f>>>16,u[e+11|0]=f>>>24,u[e+12|0]=k,u[e+13|0]=k>>>8,u[e+14|0]=k>>>16,u[e+15|0]=k>>>24,q(A,2,0,t+12|0),u[t+23|0]<0&&Z(i[t+12>>2]),!r||(A=i[r+4>>2],i[r+4>>2]=A-1,A))break i;W[i[i[r>>2]+8>>2]](r),y(r);break i}r:{f:{if(k=W0(k,86580,105560),k){if(r)break f;g[e+288>>1]=C[k+116>>1],g[e+290>>1]=C[k+118>>1];break e}if(e=p(64),i[t+12>>2]=e,i[t+16>>2]=60,i[t+20>>2]=-2147483584,f=l[24784]|l[24785]<<8|(l[24786]<<16|l[24787]<<24),n=l[24780]|l[24781]<<8|(l[24782]<<16|l[24783]<<24),u[e|0]=n,u[e+1|0]=n>>>8,u[e+2|0]=n>>>16,u[e+3|0]=n>>>24,u[e+4|0]=f,u[e+5|0]=f>>>8,u[e+6|0]=f>>>16,u[e+7|0]=f>>>24,u[e+60|0]=0,f=l[24836]|l[24837]<<8|(l[24838]<<16|l[24839]<<24),u[e+56|0]=f,u[e+57|0]=f>>>8,u[e+58|0]=f>>>16,u[e+59|0]=f>>>24,f=l[24832]|l[24833]<<8|(l[24834]<<16|l[24835]<<24),n=l[24828]|l[24829]<<8|(l[24830]<<16|l[24831]<<24),u[e+48|0]=n,u[e+49|0]=n>>>8,u[e+50|0]=n>>>16,u[e+51|0]=n>>>24,u[e+52|0]=f,u[e+53|0]=f>>>8,u[e+54|0]=f>>>16,u[e+55|0]=f>>>24,f=l[24824]|l[24825]<<8|(l[24826]<<16|l[24827]<<24),n=l[24820]|l[24821]<<8|(l[24822]<<16|l[24823]<<24),u[e+40|0]=n,u[e+41|0]=n>>>8,u[e+42|0]=n>>>16,u[e+43|0]=n>>>24,u[e+44|0]=f,u[e+45|0]=f>>>8,u[e+46|0]=f>>>16,u[e+47|0]=f>>>24,f=l[24816]|l[24817]<<8|(l[24818]<<16|l[24819]<<24),n=l[24812]|l[24813]<<8|(l[24814]<<16|l[24815]<<24),u[e+32|0]=n,u[e+33|0]=n>>>8,u[e+34|0]=n>>>16,u[e+35|0]=n>>>24,u[e+36|0]=f,u[e+37|0]=f>>>8,u[e+38|0]=f>>>16,u[e+39|0]=f>>>24,f=l[24808]|l[24809]<<8|(l[24810]<<16|l[24811]<<24),n=l[24804]|l[24805]<<8|(l[24806]<<16|l[24807]<<24),u[e+24|0]=n,u[e+25|0]=n>>>8,u[e+26|0]=n>>>16,u[e+27|0]=n>>>24,u[e+28|0]=f,u[e+29|0]=f>>>8,u[e+30|0]=f>>>16,u[e+31|0]=f>>>24,f=l[24800]|l[24801]<<8|(l[24802]<<16|l[24803]<<24),n=l[24796]|l[24797]<<8|(l[24798]<<16|l[24799]<<24),u[e+16|0]=n,u[e+17|0]=n>>>8,u[e+18|0]=n>>>16,u[e+19|0]=n>>>24,u[e+20|0]=f,u[e+21|0]=f>>>8,u[e+22|0]=f>>>16,u[e+23|0]=f>>>24,f=l[24792]|l[24793]<<8|(l[24794]<<16|l[24795]<<24),n=l[24788]|l[24789]<<8|(l[24790]<<16|l[24791]<<24),u[e+8|0]=n,u[e+9|0]=n>>>8,u[e+10|0]=n>>>16,u[e+11|0]=n>>>24,u[e+12|0]=f,u[e+13|0]=f>>>8,u[e+14|0]=f>>>16,u[e+15|0]=f>>>24,q(A,2,0,t+12|0),u[t+23|0]<0&&Z(i[t+12>>2]),!r)break i;if(e=i[r+4>>2],i[r+4>>2]=e-1,!e)break r;break i}if(i[r+4>>2]=i[r+4>>2]+1,g[e+288>>1]=C[k+116>>1],g[e+290>>1]=C[k+118>>1],e=i[r+4>>2],i[r+4>>2]=e-1,e||(W[i[i[r>>2]+8>>2]](r),y(r)),e=i[r+4>>2],i[r+4>>2]=e-1,e)break e}if(W[i[i[r>>2]+8>>2]](r),y(r),!k)break i}i[A>>2]=0,i[A+4>>2]=0,i[A+16>>2]=0,i[A+8>>2]=0,i[A+12>>2]=0}u[t+43|0]<0&&Z(i[t+32>>2]),v=t+48|0}function Pi(A,e,r,f,k,n,t,o,s,w,h,_,B,m,X){var Q=0,V=0,F=0,I=0,E=0,R=0,N=0,M=0;i:{e:{if(I=i[A+18588>>2],V=i[I+168>>2],Q=e>>V,(Q|0)<0)break e;R=A+18548|0,N=r>>V;r:{f:{A:{k:{n:{t:{for(;;){if(V=i[I+172>>2],(V|0)<=(Q|0))break e;if((N|0)<0|i[I+176>>2]<=(N|0))break i;if(Q=(i[I+160>>2]+G(Q,3)|0)+G(G(V,N),3)|0,Q=l[Q|0]|l[Q+1|0]<<8,N=Q>>>8&3,(N|0)!=(B|0))break n;u:{o:{l:{s:{w:{F=i[I+124>>2],V=i[F+16940>>2]<(o|0);_:{h:{B:{if(!(V|(s|0)>=(h|0)|(!s&(_|0)!=0|i[F+16936>>2]>=(o|0)))){if(o-3>>>0>=3)break k;if(v2(R,(i[A+18572>>2]-o|0)+25|0))break B;E=1;break _}if(E=1,V|!s&(_|0)==1)break B;if(!(!(i[F+628>>2]|s)&(N|0)==1&(Q&56)!=0))break h}if(V=i[I+248>>2],Q=e>>V,(Q|0)<0||(E=i[I+252>>2],(E|0)<=(Q|0)))break A;if(V=r>>V,(V|0)<0|(V|0)>=i[I+256>>2])break f;Q=(Q+i[I+240>>2]|0)+G(V,E)|0,u[Q|0]=l[Q|0]|1<<s,E=0}if((o|0)<3)break w}if(i[F+16848>>2])break s;Q=-1,I=0;break o}if(Q=-1,i[F+16848>>2]!=3)break l}Q=-1,V=-1;s:{if(!(m&255)||(V=v2(R,(i[A+18572>>2]+s|0)+16|0),!E&(o|0)!=3|i[F+16848>>2]!=2))break s;V=v2(R,(i[A+18572>>2]+s|0)+16|0)<<1|V}s:{if(!(X&255)||(Q=v2(R,(i[A+18572>>2]+s|0)+16|0),!E&(o|0)!=3|i[F+16848>>2]!=2))break s;Q=v2(R,(i[A+18572>>2]+s|0)+16|0)<<1|Q}if((V|0)>=0)break u}if(I=(o|0)==2,(o|0)!=2)break o;if(!s)break r}V=I&&(s|0)>0?m&255:0}if((Q|0)<0&&(Q=(o|0)==2&&(s|0)>0?X&255:0),E)break t;if(o=o-1|0,s=s+1|0,f=V&255,k=Q&255,Pi(A,e,r,e,r,n,t,o,s,0,h,_,B,f,k),w=1<<o,E=w+e|0,Pi(A,E,r,e,r,n,t,o,s,1,h,_,B,f,k),F=r+w|0,Pi(A,e,F,e,r,n,t,o,s,2,h,_,B,f,k),I=i[A+18588>>2],M=i[I+168>>2],N=F>>M,w=3,X=Q,m=V,k=r,f=e,r=F,e=E,Q=e>>M,!((Q|0)>=0))break}break e}t:{if(N&&(h=1,!(s|V|Q)))break t;h=v2(R,i[A+18572>>2]+(s?14:15)|0)}t:{u:{o:{l:{s:{w:{if((V|0)!=-1){if((Q|0)==-1)break w;if((h|0)==-1)break s;if(s=i[A+18588>>2],m=i[s+124>>2],X=i[m+16848>>2],u[A+33|0]=0,u[A+34|0]=0,u[A+35|0]=0,u[A+36|0]=0,B=i[s+168>>2],_=e>>B,(_|0)<0||(F=i[s+172>>2],(F|0)<=(_|0)))break e;if(B=r>>B,(B|0)<0|(B|0)>=i[s+176>>2])break i;if(E=o-((X|0)!=3)|0,I=(E|0)>2,R=l[((i[s+160>>2]+G(_,3)|0)+G(G(B,F),3)|0)+1|0],F=Q|V,!(F|h))break t;if(_=0,i[A+18500>>2]|!l[i[s+132>>2]+26|0])break u;if(_=1,B=A+18548|0,!v2(B,i[A+18572>>2]+139|0)){s=0,B=1;break o}if(s=1,!v2(B,i[A+18572>>2]+140|0))break l;if(!v2(B,i[A+18572>>2]+140|0)){s=2;break l}if(!v2(B,i[A+18572>>2]+140|0)){s=3;break l}if(!v2(B,i[A+18572>>2]+140|0)){s=4;break l}if(s=eA(B,0)+5|0,s)break l;s=0,B=1;break o}D0(21836,18297,3575,3844),H()}D0(21823,18297,3576,3844),H()}D0(21849,18297,3577,3844),H()}B=1-(k4(B)<<1)|0}i[A+18500>>2]=1,i[A+18504>>2]=G(s,B)}u:{o:{l:{if(!(!F|!l[i[A+18592>>2]+760|0]|(l[A+32|0]|i[A+18508>>2]))){if(_=A+18548|0,!v2(_,i[A+18572>>2]+23|0))break l;s=0,B=i[i[A+18588>>2]+132>>2],l[B+8250|0]>=2&&(s=v2(_,i[A+18572>>2]+24|0)),i[A+18508>>2]=1,s=s+B|0,i[A+18512>>2]=u[s+8251|0],s=u[s+8257|0];break o}if(_)break u;break t}i[A+18508>>2]=1,i[A+18512>>2]=0,s=0}i[A+18516>>2]=s}y9(A,n,t)}n=i[m+16856>>2],s=i[m+16852>>2],i[A+28>>2]=0,h&&M8(A,e,r,o,0),F=I?E:2,_=1<<F,B=1<<o,t=R&3,D8(A,e,r,B,0,t,(h|0)!=0);t:{if(!((X|0)!=3&(o|0)<=2)){f=0,k=0;u:{if(!h||(o=i[A+18588>>2],k=0,!(u[i[o+132>>2]+8247|0]&1)))break u;if((t|0)!=1){if(f=i[o+228>>2],w=e>>f,(w|0)<0||(B=i[o+232>>2],(B|0)<=(w|0)))break e;if(h=r>>f,(h|0)<0|(h|0)>=i[o+236>>2])break i;if(f=0,k=0,u[(w+i[o+220>>2]|0)+G(h,B)|0]>=0)break u}if(o=A+18548|0,k=1,!v2(o,i[A+18572>>2]+162|0))break u;f=0;o:{if(!v2(o,i[A+18572>>2]+163|0)||(f=1,!v2(o,i[A+18572>>2]+164|0)))break o;f=v2(o,i[A+18572>>2]+165|0)?3:2}f=1-(v2(o,i[A+18572>>2]+170|0)<<1)<<f,k=1}i[A+28>>2]=f,f=V&1,f&&M8(A,e,r,F,1),i[m+16848>>2]&&D8(A,(e|0)/(s|0)|0,(r|0)/(n|0)|0,_,1,t,f),(X|0)==2&&(f=V&2,f&&M8(A,e,(n<<F)+r|0,F,1),D8(A,(e|0)/(s|0)|0,_+((r|0)/(n|0)|0)|0,_,1,t,(f|0)!=0)),f=0;u:{if(!k||(k=A+18548|0,!v2(k,i[A+18572>>2]+166|0)))break u;f=0;o:{if(!v2(k,i[A+18572>>2]+167|0)||(f=1,!v2(k,i[A+18572>>2]+168|0)))break o;f=v2(k,i[A+18572>>2]+169|0)?3:2}f=1-(v2(k,i[A+18572>>2]+171|0)<<1)<<f}if(i[A+28>>2]=f,f=Q&1,f&&M8(A,e,r,F,2),i[m+16848>>2]&&D8(A,(e|0)/(s|0)|0,(r|0)/(n|0)|0,_,2,t,f),(X|0)!=2)break t;f=Q&2,f&&M8(A,e,(n<<F)+r|0,F,2),D8(A,(e|0)/(s|0)|0,_+((r|0)/(n|0)|0)|0,_,2,t,(f|0)!=0);break t}if((w|0)!=3||(e=V&1,e&&M8(A,f,k,o,1),i[m+16848>>2]&&D8(A,(f|0)/(s|0)|0,(k|0)/(n|0)|0,B,1,t,e),e=V&2,e&&M8(A,f,k+B|0,o,1),(X|0)==2&&D8(A,(f|0)/(s|0)|0,B+((k|0)/(n|0)|0)|0,B,1,t,(e|0)!=0),e=Q&1,e&&M8(A,f,k,o,2),i[m+16848>>2]&&D8(A,(f|0)/(s|0)|0,(k|0)/(n|0)|0,B,2,t,e),e=Q&2,e&&M8(A,f,k+_|0,o,2),(X|0)!=2))break t;D8(A,(f|0)/(s|0)|0,B+((k|0)/(n|0)|0)|0,B,2,t,(e|0)!=0);break t}return}D0(15158,18297,3857,15053),H()}D0(21613,18297,1834,11277),H()}D0(4656,10893,128,4231),H()}D0(4618,10893,129,4231),H()}D0(26800,18297,3924,15053),H()}D0(4656,10893,118,4231),H()}D0(4618,10893,119,4231),H()}function b7(A){A=A|0;var e=0,r=0,f=0,k=0,n=0;if(i[A>>2]=61280,e=i[A+3212>>2],r=i[A+3208>>2],(e|0)!=(r|0))for(;f=i[e-4>>2],f&&(Z(Tn(f)),r=i[A+3208>>2],e=i[A+3212>>2]),e=e-4|0,i[A+3212>>2]=e,(e|0)!=(r|0););if(r&&(i[A+3212>>2]=r,Z(r)),r=0,e=A+2140|0,f=i[e+12>>2],k=i[e+8>>2],(f|0)!=(k|0))for(;n=i[(r<<2)+k>>2],n&&(Z(uA(n)),k=i[e+8>>2],f=i[e+12>>2]),r=r+1|0,r>>>0<f-k>>2>>>0;);_A(e+32|0),r=i[e+20>>2],r&&(i[e+24>>2]=r,Z(r)),r=i[e+8>>2],r&&(i[e+12>>2]=r,Z(r)),_A(A+1396|0),e=i[A+1388>>2];i:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break i;W[i[i[e>>2]+8>>2]](e),y(e)}e=i[A+1380>>2];i:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break i;W[i[i[e>>2]+8>>2]](e),y(e)}e=i[A+1372>>2];i:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break i;W[i[i[e>>2]+8>>2]](e),y(e)}for(f=A+4|0,e=1368;;){e=e-8|0,r=i[f+e>>2];i:{if(!r||(k=i[r+4>>2],i[r+4>>2]=k-1,k))break i;W[i[i[r>>2]+8>>2]](r),y(r)}if((e|0)==856)break}e=i[A+852>>2];i:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break i;W[i[i[e>>2]+8>>2]](e),y(e)}e=i[A+844>>2];i:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break i;W[i[i[e>>2]+8>>2]](e),y(e)}e=i[A+836>>2];i:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break i;W[i[i[e>>2]+8>>2]](e),y(e)}e=i[A+828>>2];i:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break i;W[i[i[e>>2]+8>>2]](e),y(e)}e=i[A+820>>2];i:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break i;W[i[i[e>>2]+8>>2]](e),y(e)}e=i[A+812>>2];i:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break i;W[i[i[e>>2]+8>>2]](e),y(e)}e=i[A+804>>2];i:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break i;W[i[i[e>>2]+8>>2]](e),y(e)}e=i[A+796>>2];i:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break i;W[i[i[e>>2]+8>>2]](e),y(e)}e=i[A+788>>2];i:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break i;W[i[i[e>>2]+8>>2]](e),y(e)}e=i[A+780>>2];i:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break i;W[i[i[e>>2]+8>>2]](e),y(e)}e=i[A+772>>2];i:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break i;W[i[i[e>>2]+8>>2]](e),y(e)}e=i[A+764>>2];i:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break i;W[i[i[e>>2]+8>>2]](e),y(e)}e=i[A+756>>2];i:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break i;W[i[i[e>>2]+8>>2]](e),y(e)}e=i[A+748>>2];i:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break i;W[i[i[e>>2]+8>>2]](e),y(e)}e=i[A+740>>2];i:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break i;W[i[i[e>>2]+8>>2]](e),y(e)}e=i[A+732>>2];i:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break i;W[i[i[e>>2]+8>>2]](e),y(e)}e=i[A+724>>2];i:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break i;W[i[i[e>>2]+8>>2]](e),y(e)}e=i[A+716>>2];i:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break i;W[i[i[e>>2]+8>>2]](e),y(e)}e=i[A+708>>2];i:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break i;W[i[i[e>>2]+8>>2]](e),y(e)}e=i[A+700>>2];i:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break i;W[i[i[e>>2]+8>>2]](e),y(e)}e=i[A+692>>2];i:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break i;W[i[i[e>>2]+8>>2]](e),y(e)}e=i[A+684>>2];i:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break i;W[i[i[e>>2]+8>>2]](e),y(e)}e=i[A+676>>2];i:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break i;W[i[i[e>>2]+8>>2]](e),y(e)}e=i[A+668>>2];i:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break i;W[i[i[e>>2]+8>>2]](e),y(e)}e=i[A+660>>2];i:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break i;W[i[i[e>>2]+8>>2]](e),y(e)}e=i[A+652>>2];i:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break i;W[i[i[e>>2]+8>>2]](e),y(e)}e=i[A+644>>2];i:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break i;W[i[i[e>>2]+8>>2]](e),y(e)}e=i[A+636>>2];i:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break i;W[i[i[e>>2]+8>>2]](e),y(e)}e=i[A+628>>2];i:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break i;W[i[i[e>>2]+8>>2]](e),y(e)}e=i[A+620>>2];i:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break i;W[i[i[e>>2]+8>>2]](e),y(e)}e=i[A+612>>2];i:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break i;W[i[i[e>>2]+8>>2]](e),y(e)}e=i[A+604>>2];i:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break i;W[i[i[e>>2]+8>>2]](e),y(e)}if(e=A+548|0,r=i[e+32>>2],r)for(;n=i[e+16>>2],f=i[e+28>>2],k=i[i[n+(f>>>8&16777212)>>2]+((f&1023)<<2)>>2],i[e+32>>2]=r-1,r=f+1|0,i[e+28>>2]=r,r>>>0>=2048&&(Z(i[n>>2]),i[e+16>>2]=i[e+16>>2]+4,i[e+28>>2]=i[e+28>>2]-1024),i[e+36>>2]=i[e+36>>2]-i[k+24>>2],R4(e,k),r=i[e+32>>2],!!r;);if(r=i[e+8>>2],r&&R4(e,r),r=i[e+40>>2],n=i[e+44>>2],(r|0)!=(n|0))for(f=0;k=i[(f<<2)+r>>2],k&&(Z(i[k+20>>2]),r=i[k+32>>2],r&&(i[k+36>>2]=r,Z(r)),Z(k),n=i[e+44>>2],r=i[e+40>>2]),f=f+1|0,f>>>0<n-r>>2>>>0;);return r&&(i[e+44>>2]=r,Z(r)),_A(e+12|0),A|0}function xB(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,t=0,o=0,s=0,w=0,h=0,_=0,B=0,m=0,X=0,Q=0,V=0,F=0,I=0;f=v-160|0,v=f,i[f+84>>2]=0,i[f+56>>2]=72500,n=i[18128],i[f>>2]=n,i[i[n-12>>2]+f>>2]=i[18129],n=i[i[f>>2]-12>>2]+f|0,k=f+4|0,J0(n,k),u[n+80|0]=0,i[n+72>>2]=0,i[f+56>>2]=72500,i[f>>2]=72480,B=R0(k),i[B>>2]=71232,i[f+44>>2]=0,i[f+48>>2]=0,i[f+36>>2]=0,i[f+40>>2]=0,i[f+52>>2]=16,n=f+148|0,U1(n,e,r),t=n,n=u[f+159|0],k=(n|0)<0,Y(f,k?i[f+148>>2]:t,k?i[f+152>>2]:n),u[f+159|0]<0&&Z(i[f+148>>2]),n=f+148|0,s0(n,r),t=n,n=u[f+159|0],k=(n|0)<0,Y(f,k?i[f+148>>2]:t,k?i[f+152>>2]:n),u[f+159|0]<0&&Z(i[f+148>>2]),k=Y(f,32213,15),n=i[e+100>>2]&1,n=Y(Y(k,n?5217:7951,n|2),42670,1),k=f+148|0,s0(k,r),t=k,k=u[f+159|0],o=(k|0)<0,Y(n,o?i[f+148>>2]:t,o?i[f+152>>2]:k),u[f+159|0]<0&&Z(i[f+148>>2]),k=Y(n,31926,16),n=i[e+100>>2]&2,n=Y(Y(k,n?5217:7951,n?3:2),42670,1),k=f+148|0,s0(k,r),t=k,k=u[f+159|0],o=(k|0)<0,Y(n,o?i[f+148>>2]:t,o?i[f+152>>2]:k),u[f+159|0]<0&&Z(i[f+148>>2]),k=Y(n,29581,18),n=i[e+100>>2]&4,n=Y(Y(k,n?5217:7951,n?3:2),42670,1),k=f+148|0,s0(k,r),t=k,k=u[f+159|0],o=(k|0)<0,Y(n,o?i[f+148>>2]:t,o?i[f+152>>2]:k),u[f+159|0]<0&&Z(i[f+148>>2]),k=Y(n,30447,28),n=i[e+100>>2]&8,Y(Y(k,n?5217:7951,n?3:2),42670,1),n=f+148|0,s0(n,r),t=n,n=u[f+159|0],k=(n|0)<0,Y(f,k?i[f+148>>2]:t,k?i[f+152>>2]:n),u[f+159|0]<0&&Z(i[f+148>>2]),n=Y(q2(Y(f,32777,19),i[e+104>>2],i[e+108>>2]),42670,1),k=f+148|0,s0(k,r),t=k,k=u[f+159|0],o=(k|0)<0,Y(n,o?i[f+148>>2]:t,o?i[f+152>>2]:k),u[f+159|0]<0&&Z(i[f+148>>2]),n=Y(q2(Y(n,31799,19),i[e+112>>2],i[e+116>>2]),42670,1),k=f+148|0,s0(k,r),t=k,k=u[f+159|0],o=(k|0)<0,Y(n,o?i[f+148>>2]:t,o?i[f+152>>2]:k),u[f+159|0]<0&&Z(i[f+148>>2]),n=Y(V0(Y(n,32582,10),i[e+120>>2]),42670,1),k=f+148|0,s0(k,r),t=k,k=u[f+159|0],o=(k|0)<0,Y(n,o?i[f+148>>2]:t,o?i[f+152>>2]:k),u[f+159|0]<0&&Z(i[f+148>>2]),Y(q2(Y(n,30633,10),i[e+128>>2],i[e+132>>2]),42670,1),n=f+148|0,s0(n,r),t=n,n=u[f+159|0],k=(n|0)<0,Y(f,k?i[f+148>>2]:t,k?i[f+152>>2]:n),u[f+159|0]<0&&Z(i[f+148>>2]),n=Y(V0(Y(f,30332,7),C[e+136>>1]),42670,1),k=f+148|0,s0(k,r),t=k,k=u[f+159|0],o=(k|0)<0,Y(n,o?i[f+148>>2]:t,o?i[f+152>>2]:k),u[f+159|0]<0&&Z(i[f+148>>2]),n=Y(V0(Y(n,30413,17),C[e+138>>1]),42670,1),k=f+148|0,s0(k,r),t=k,k=u[f+159|0],o=(k|0)<0,Y(n,o?i[f+148>>2]:t,o?i[f+152>>2]:k),u[f+159|0]<0&&Z(i[f+148>>2]),n=Y(Zu(Y(n,31777,8),U(U(C[e+140>>1])*U(.00390625))),42670,1),k=f+148|0,s0(k,r),t=k,k=u[f+159|0],o=(k|0)<0,Y(n,o?i[f+148>>2]:t,o?i[f+152>>2]:k),u[f+159|0]<0&&Z(i[f+148>>2]),Y(n,41757,8),F=e+144|0;i:{for(;;){n=f+148|0,s0(n,r),t=n,n=u[f+159|0],k=(n|0)<0,Y(f,k?i[f+148>>2]:t,k?i[f+152>>2]:n),u[f+159|0]<0&&Z(i[f+148>>2]),Y(f,32807,2),I=G(m,3),n=0;e:{for(;;){k=f+140|0,o=n+I|0,(o|0)!=8?X=+u0[(o<<2)+F>>2]*152587890625e-16:X=1,h=d1(f,X),Q=G1(k,h);r:{if(l[Q|0]!=1)break r;o=i[i[h>>2]-12>>2]+h|0,_=i[o+4>>2],w=i[o+24>>2];f:{if(l[o+80|0]==1){k=l[o+76|0]|l[o+77|0]<<8|(l[o+78|0]<<16|l[o+79|0]<<24);break f}t=f+148|0,k=i[o+28>>2],i[t>>2]=k,(k|0)!=129576&&(i[k+4>>2]=i[k+4>>2]+1),k=c0(t,129760),k=W[i[i[k>>2]+28>>2]](k,32)|0,e2(t),u[o+76|0]=k,u[o+77|0]=k>>>8,u[o+78|0]=k>>>16,u[o+79|0]=k>>>24,u[o+80|0]=1}f:{if(!w||(s=i[o+12>>2],_=(_&176)==32?32809:32808,t=_-32808|0,(t|0)>0&&(W[i[i[w>>2]+48>>2]](w,32808,t)|0)!=(t|0)))break f;if((s|0)>=2){if(s>>>0>=2147483641)break e;t=((s|0)<=1?1:s)-1|0;A:{if(s>>>0>=12){V=t|7,s=p(V+1|0),i[f+156>>2]=V-2147483647,i[f+148>>2]=s,i[f+152>>2]=t;break A}u[f+159|0]=t,s=f+148|0}if(t&&o0(s,k,t),u[t+s|0]=0,k=W[i[i[w>>2]+48>>2]](w,u[f+159|0]<0?i[f+148>>2]:f+148|0,t)|0,u[f+159|0]<0&&Z(i[f+148>>2]),(k|0)!=(t|0))break f}if(k=32809-_|0,(k|0)>0&&(W[i[i[w>>2]+48>>2]](w,_,k)|0)!=(k|0))break f;i[o+12>>2]=0;break r}k=i[i[h>>2]-12>>2]+h|0,H1(k,i[k+16>>2]|5)}if(_1(Q),n=n+1|0,(n|0)==3)break}if(Y(f,42670,1),m=m+1|0,(m|0)==3)break i;continue}break}Q0(),H()}n=f+148|0,s0(n,r),t=n,n=u[f+159|0],k=(n|0)<0,Y(f,k?i[f+148>>2]:t,k?i[f+152>>2]:n),u[f+159|0]<0&&Z(i[f+148>>2]),n=Y(d1(Y(f,31016,7),+U(u0[e+180>>2])*152587890625e-16),42670,1),k=f+148|0,s0(k,r),t=k,r=u[f+159|0],k=(r|0)<0,Y(n,k?i[f+148>>2]:t,k?i[f+152>>2]:r),u[f+159|0]<0&&Z(i[f+148>>2]),Y(d1(Y(n,29701,8),+U(u0[e+184>>2])*152587890625e-16),42670,1),e=i[f+52>>2];i:{e:{if(e&16){n=i[f+48>>2],e=i[f+28>>2],n>>>0<e>>>0&&(i[f+48>>2]=e,n=e),e=f+24|0;break e}if(!(e&8)){n=0,u[A+11|0]=0;break i}n=i[f+20>>2],e=f+12|0}e:{if(r=i[e>>2],n=n-r|0,n>>>0<2147483640){if(n>>>0>=11){k=n|7,e=p(k+1|0),i[A+8>>2]=k-2147483647,i[A>>2]=e,i[A+4>>2]=n,A=e;break e}if(u[A+11|0]=n,n)break e;n=0;break i}Q0(),H()}if(!n)break i;x(A,r,n)}u[A+n|0]=0,A=i[18127],i[f>>2]=A,i[i[A-12>>2]+f>>2]=i[18130],i[B>>2]=71232,u[f+47|0]<0&&Z(i[f+36>>2]),E0(B),y0(f+56|0),v=f+160|0}function Gf(A,e,r){var f=0,k=0,n=0,t=0,o=0,s=0,w=0,h=0,_=0;_=v-16|0,v=_,i[A+8>>2]=0,i[A>>2]=0,i[A+4>>2]=0;i:{e:{r:{if(i[e+24>>2]==i[e+28>>2])break r;f=p(128),i[f+4>>2]=0,i[f+8>>2]=0,i[f>>2]=91244,s=f+16|0,k=s,i[k+8>>2]=0,i[k+12>>2]=0,i[k+16>>2]=0,i[k+20>>2]=0,i[k+24>>2]=0,i[k+28>>2]=0,i[k+32>>2]=0,i[k>>2]=86356,i[f+60>>2]=0,i[f+64>>2]=0,i[f+52>>2]=0,i[f+56>>2]=0,i[f+72>>2]=-1,i[f+76>>2]=-1,i[f+80>>2]=-1,i[f+84>>2]=-1,i[f+88>>2]=0,i[f+92>>2]=0,i[f+96>>2]=0,i[f+100>>2]=0,i[f+104>>2]=0,i[f+108>>2]=0,u[f+112|0]=0,i[k>>2]=88872,i[f+32>>2]=1885434736,i[f+116>>2]=i[e+24>>2],i[f+120>>2]=i[e+28>>2],i[f+4>>2]=i[f+4>>2]+1,k=i[A+4>>2],o=i[A+8>>2];f:{if(k>>>0<o>>>0){i[k+4>>2]=f,i[k>>2]=s,k=k+8|0;break f}if(n=i[A>>2],k=k-n|0,h=k>>3,t=h+1|0,t>>>0>=536870912)break e;if(o=o-n|0,w=o>>2,o=o>>>0>=2147483640?536870911:t>>>0<w>>>0?w:t,o){if(o>>>0>=536870912)break i;t=p(o<<3)}else t=0;if(w=t+k|0,i[w+4>>2]=f,i[w>>2]=s,s=w-(h<<3)|0,k&&x(s,n,k),i[A+8>>2]=t+(o<<3),k=w+8|0,i[A+4>>2]=k,i[A>>2]=s,!n)break f;Z(n)}if(i[A+4>>2]=k,k=i[f+4>>2],i[f+4>>2]=k-1,k)break r;W[i[i[f>>2]+8>>2]](f),y(f)}if(C[e+32>>1]|C[e+34>>1]){f=p(120),i[f+4>>2]=0,i[f+8>>2]=0,i[f>>2]=91404,n=f+16|0,i[n+8>>2]=0,i[n+12>>2]=0,i[n+16>>2]=0,i[n+20>>2]=0,i[n+24>>2]=0,i[n+28>>2]=0,i[n+32>>2]=0,i[n>>2]=86356,i[f+60>>2]=0,i[f+64>>2]=0,i[f+52>>2]=0,i[f+56>>2]=0,i[f+72>>2]=-1,i[f+76>>2]=-1,i[f+80>>2]=-1,i[f+84>>2]=-1,i[f+88>>2]=0,i[f+92>>2]=0,i[f+96>>2]=0,i[f+100>>2]=0,i[f+104>>2]=0,i[f+108>>2]=0,u[f+112|0]=0,i[n>>2]=89032,i[f+32>>2]=1668050025,k=i[e+32>>2],g[f+114>>1]=k,g[f+116>>1]=k>>>16,k=i[A+4>>2],o=i[A+8>>2];r:{if(k>>>0<o>>>0){i[k+4>>2]=f,i[k>>2]=n,k=k+8|0;break r}if(s=i[A>>2],k=k-s|0,h=k>>3,t=h+1|0,t>>>0>=536870912)break e;if(o=o-s|0,w=o>>2,o=o>>>0>=2147483640?536870911:t>>>0<w>>>0?w:t,o){if(o>>>0>=536870912)break i;t=p(o<<3)}else t=0;if(w=t+k|0,i[w+4>>2]=f,i[w>>2]=n,f=w-(h<<3)|0,k&&x(f,s,k),i[A+8>>2]=t+(o<<3),k=w+8|0,i[A+4>>2]=k,i[A>>2]=f,!s)break r;Z(s)}i[A+4>>2]=k}r:{if(l[e+60|0]!=1)break r;f=p(144),i[f+4>>2]=0,i[f+8>>2]=0,i[f>>2]=91444,w=tu(f+16|0),k=i[e+56>>2],i[f+132>>2]=i[e+52>>2],i[f+136>>2]=k,k=i[e+48>>2],i[f+124>>2]=i[e+44>>2],i[f+128>>2]=k,k=i[e+40>>2],i[f+116>>2]=i[e+36>>2],i[f+120>>2]=k,i[f+4>>2]=i[f+4>>2]+1,k=i[A+4>>2],s=i[A+8>>2];f:{if(k>>>0<s>>>0){i[k+4>>2]=f,i[k>>2]=w,k=k+8|0;break f}if(n=i[A>>2],k=k-n|0,h=k>>3,t=h+1|0,t>>>0>=536870912)break e;if(s=s-n|0,o=s>>2,s=s>>>0>=2147483640?536870911:o>>>0>t>>>0?o:t,s){if(s>>>0>=536870912)break i;t=p(s<<3)}else t=0;if(o=t+k|0,i[o+4>>2]=f,i[o>>2]=w,w=o-(h<<3)|0,k&&x(w,n,k),i[A+8>>2]=t+(s<<3),k=o+8|0,i[A+4>>2]=k,i[A>>2]=w,!n)break f;Z(n)}if(i[A+4>>2]=k,k=i[f+4>>2],i[f+4>>2]=k-1,k)break r;W[i[i[f>>2]+8>>2]](f),y(f)}t=i[e+64>>2];r:{if(!t)break r;f=p(144),i[f+4>>2]=0,i[f+8>>2]=0,i[f>>2]=92204,n=f+16|0,i[n+8>>2]=0,i[n+12>>2]=0,i[n+16>>2]=0,i[n+20>>2]=0,i[n+24>>2]=0,i[n+28>>2]=0,i[n+32>>2]=0,i[n>>2]=86356,i[f+60>>2]=0,i[f+64>>2]=0,i[f+52>>2]=0,i[f+56>>2]=0,i[f+72>>2]=-1,i[f+76>>2]=-1,i[f+80>>2]=-1,i[f+84>>2]=-1,i[f+116>>2]=0,i[f+88>>2]=0,i[f+92>>2]=0,i[f+96>>2]=0,i[f+100>>2]=0,i[f+104>>2]=0,i[f+108>>2]=0,g[f+112>>1]=0,i[n>>2]=89444,i[f+32>>2]=1769234793,k=f+120|0,i[k+8>>2]=0,i[k+12>>2]=0,u[k|0]=1,u[k+15|0]=0,u[k+16|0]=0,u[k+17|0]=0,u[k+18|0]=0,Qi(k,t),i[f+4>>2]=i[f+4>>2]+1,k=i[A+4>>2],o=i[A+8>>2];f:{if(k>>>0<o>>>0){i[k+4>>2]=f,i[k>>2]=n,k=k+8|0;break f}if(s=i[A>>2],k=k-s|0,h=k>>3,t=h+1|0,t>>>0>=536870912)break e;if(o=o-s|0,w=o>>2,o=o>>>0>=2147483640?536870911:t>>>0<w>>>0?w:t,o){if(o>>>0>=536870912)break i;t=p(o<<3)}else t=0;if(w=t+k|0,i[w+4>>2]=f,i[w>>2]=n,n=w-(h<<3)|0,k&&x(n,s,k),i[A+8>>2]=t+(o<<3),k=w+8|0,i[A+4>>2]=k,i[A>>2]=n,!s)break f;Z(s)}if(i[A+4>>2]=k,k=i[f+4>>2],i[f+4>>2]=k-1,k)break r;W[i[i[f>>2]+8>>2]](f),y(f)}r:{if(!r)break r;f:{if(!(C[e+6>>1]!=2|C[e+8>>1]!=2|C[e+10>>1]!=2)&&l[e+12|0])break f;On(_+8|0,e),s=i[_+12>>2],o=i[_+8>>2],r=i[A+4>>2],f=i[A+8>>2];A:{if(r>>>0<f>>>0){i[r+4>>2]=s,i[r>>2]=o,k=r+8|0;break A}if(t=i[A>>2],r=r-t|0,w=r>>3,k=w+1|0,k>>>0>=536870912)break e;if(f=f-t|0,n=f>>2,f=f>>>0>=2147483640?536870911:k>>>0<n>>>0?n:k,f){if(f>>>0>=536870912)break i;k=p(f<<3)}else k=0;if(n=k+r|0,i[n+4>>2]=s,i[n>>2]=o,s=n-(w<<3)|0,r&&x(s,t,r),i[A+8>>2]=k+(f<<3),k=n+8|0,i[A+4>>2]=k,i[A>>2]=s,!t)break A;Z(t)}i[A+4>>2]=k}if(!i[e+16>>2])break r;Pn(_+8|0,e),n=i[_+12>>2],s=i[_+8>>2],e=i[A+4>>2],t=i[A+8>>2];f:{if(e>>>0<t>>>0){i[e+4>>2]=n,i[e>>2]=s,e=e+8|0;break f}if(k=i[A>>2],e=e-k|0,o=e>>3,r=o+1|0,r>>>0>=536870912)break e;if(t=t-k|0,f=t>>2,t=t>>>0>=2147483640?536870911:r>>>0<f>>>0?f:r,t){if(t>>>0>=536870912)break i;r=p(t<<3)}else r=0;if(f=r+e|0,i[f+4>>2]=n,i[f>>2]=s,n=f-(o<<3)|0,e&&x(n,k,e),i[A+8>>2]=r+(t<<3),e=f+8|0,i[A+4>>2]=e,i[A>>2]=n,!k)break f;Z(k)}i[A+4>>2]=e}v=_+16|0;return}G0(),H()}z0(),H()}function TB(A,e,r,f,k,n,t,o){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,t=t|0,o=o|0;var s=0,w=0,h=0,_=0,B=0,m=0,X=0,Q=0,V=0,F=0,I=0,E=0,R=0,N=0,M=0,z=0,S=0,O=0,P=0,a=0,$=0,f0=0,A0=0,n0=0;f=v-128|0,v=f,e=i[r>>2],V=i[e+112>>2],t=i[e+108>>2],n=p(172),i[n>>2]=94812,i[n+4>>2]=0,i[n+8>>2]=0,o0(n+16|0,0,80),s=i[n+4>>2],h=s+1|0,i[n+4>>2]=h,i[n+104>>2]=0,i[n+108>>2]=0,i[n+36>>2]=1,i[n+40>>2]=1,u[n+24|0]=1,g[n+22>>1]=2,g[n+18>>1]=2,g[n+20>>1]=2,i[n+112>>2]=0,i[n+116>>2]=4740,i[n+140>>2]=0,i[n+144>>2]=0,i[n+128>>2]=99,i[n+132>>2]=99,i[n+120>>2]=0,i[n+124>>2]=0,i[n+12>>2]=95160,i[n+148>>2]=0,i[n+152>>2]=0,e=n+140|0,i[n+136>>2]=e,i[n+156>>2]=0,i[n+160>>2]=0,i[n+164>>2]=0,i[n+168>>2]=0,i[n+4>>2]=s,s=i[n+8>>2],X=n+12|0,i[n+96>>2]=X,i[n+8>>2]=s+1,i[n+100>>2]=n,h||(W[i[i[n>>2]+8>>2]](n),y(n)),i[X+120>>2]=3,i[X+116>>2]=0,i[X+112>>2]=V,i[X+108>>2]=t,_=l[k+8|0],h=i[i[r>>2]+120>>2],T0(f+56|0,X,0,t,V,8,o),T0(f+32|0,X,1,t,V,8,o),w=f+88|0;i:{if(i[f+56>>2]){if(k=i[f+60>>2],i[f+80>>2]=i[f+56>>2],i[f+84>>2]=k,u[f+75|0]>=0){s=f- -64|0,k=i[s+4>>2],i[w>>2]=i[s>>2],i[w+4>>2]=k,i[w+8>>2]=i[s+8>>2];break i}T(w,i[f+64>>2],i[f+68>>2]);break i}if(k=i[f+36>>2],i[f+80>>2]=i[f+32>>2],i[f+84>>2]=k,u[f+51|0]>=0){k=i[f+44>>2],i[w>>2]=i[f+40>>2],i[w+4>>2]=k,i[w+8>>2]=i[f+48>>2];break i}T(w,i[f+40>>2],i[f+44>>2])}T0(f+8|0,X,2,t,V,8,o),s=f+112|0;i:{if(i[f+80>>2]){if(k=i[f+84>>2],i[f+104>>2]=i[f+80>>2],i[f+108>>2]=k,u[f+99|0]>=0){k=i[w+4>>2],i[s>>2]=i[w>>2],i[s+4>>2]=k,i[s+8>>2]=i[w+8>>2];break i}T(s,i[f+88>>2],i[f+92>>2]);break i}if(k=i[f+12>>2],i[f+104>>2]=i[f+8>>2],i[f+108>>2]=k,u[f+27|0]>=0){k=i[f+20>>2],i[s>>2]=i[f+16>>2],i[s+4>>2]=k,i[s+8>>2]=i[f+24>>2];break i}T(s,i[f+16>>2],i[f+20>>2])}u[f+27|0]<0&&Z(i[f+16>>2]),u[f+99|0]<0&&Z(i[f+88>>2]),u[f+51|0]<0&&Z(i[f+40>>2]),u[f+75|0]<0&&Z(i[f+64>>2]);i:{e:{if(i[f+104>>2]){if(e=i[f+108>>2],i[A>>2]=i[f+104>>2],i[A+4>>2]=e,r=A+8|0,u[f+123|0]>=0){e=i[s+4>>2],i[r>>2]=i[s>>2],i[r+4>>2]=e,i[r+8>>2]=i[s+8>>2],u[A+20|0]=1;break e}if(T(r,i[f+112>>2],i[f+116>>2]),e=u[f+123|0],u[A+20|0]=1,(e|0)>=0)break e;Z(i[f+112>>2]);break e}u[f+123|0]<0&&Z(i[f+112>>2]);r:{if(!(_&1))break r;if(T0(f+104|0,X,6,t,V,8,o),i[f+104>>2]){if(e=i[f+108>>2],i[A>>2]=i[f+104>>2],i[A+4>>2]=e,r=A+8|0,u[f+123|0]>=0){e=i[f+116>>2],i[r>>2]=i[f+112>>2],i[r+4>>2]=e,i[r+8>>2]=i[f+120>>2],u[A+20|0]=1;break e}if(T(r,i[f+112>>2],i[f+116>>2]),e=u[f+123|0],u[A+20|0]=1,(e|0)>=0)break e;Z(i[f+112>>2]);break e}if(u[f+123|0]>=0)break r;Z(i[f+112>>2])}r:{f:{if(r=i[r>>2],o=i[r+128>>2],!o)break f;for(s=r+128|0,r=s;k=i[o+16>>2]<10,r=k?r:o,o=i[(k?4:0)+o>>2],!!o;);if((r|0)==(s|0))break f;if(s=0,i[r+16>>2]>10)break r;$=i[r+56>>2],s=i[r+44>>2];break r}s=0}r:{f:{if(r=i[e>>2],r){for(k=e,o=r;m=i[o+16>>2],k=(m|0)<0?k:o,o=i[(m>>>29&4)+o>>2],!!o;);I=0;A:{if((e|0)==(k|0)||(I=0,i[k+16>>2]>0))break A;f0=i[k+56>>2],I=i[k+44>>2]}for(k=e,o=r;m=i[o+16>>2]<=0,k=m?k:o,o=i[(m?4:0)+o>>2],!!o;);E=0;A:{if((e|0)==(k|0)||(E=0,i[k+16>>2]>1))break A;A0=i[k+44>>2],E=i[k+56>>2]}for(k=e,o=r;m=i[o+16>>2]<2,k=m?k:o,o=i[(m?4:0)+o>>2],!!o;);o=0;A:{if((e|0)==(k|0)||(o=0,i[k+16>>2]>2))break A;n0=i[k+56>>2],o=i[k+44>>2]}if(m=o,k=0,!(_&1))break r;for(o=e;k=i[r+16>>2]<6,o=k?o:r,r=i[(k?4:0)+r>>2],!!r;);if((e|0)!=(o|0))break f}k=0;break r}if(k=0,i[o+16>>2]>6)break r;N=i[o+56>>2],k=i[o+44>>2]}r:{if(!V|!t)break r;if(!(_&1)){for(F=(h|0)==11?4:3,w=t&-2,_=t&1,e=0;;){if(B=G(e,n0)+m|0,N=G(e,E)+A0|0,M=G(e,f0)+I|0,z=G(e,$)+s|0,o=0,r=0,(t|0)!=1)for(;Q=z+G(o,F)|0,h=l[Q|0],k=l[Q+2|0],u[o+M|0]=l[Q+1|0],u[o+N|0]=k,u[o+B|0]=h,R=o|1,Q=z+G(R,F)|0,h=l[Q|0],k=l[Q+2|0],u[M+R|0]=l[Q+1|0],u[N+R|0]=k,u[B+R|0]=h,o=o+2|0,r=r+2|0,(w|0)!=(r|0););if(_&&(h=z+G(o,F)|0,k=l[h|0],r=l[h+2|0],u[o+M|0]=l[h+1|0],u[o+N|0]=r,u[o+B|0]=k),e=e+1|0,(V|0)==(e|0))break}break r}for(M=s+3|0,z=t&-2,R=t&1,e=0,Q=(h|0)==11;;){S=k+G(e,N)|0,O=G(e,n0)+m|0,P=G(e,E)+A0|0,a=G(e,f0)+I|0,r=G(e,$),F=r+s|0;f:{if(Q){for(w=r+M|0,o=0;_=o<<2,B=_+F|0,h=l[B|0],r=l[B+2|0],u[o+a|0]=l[B+1|0],u[o+P|0]=r,u[o+O|0]=h,u[o+S|0]=l[w+_|0],o=o+1|0,(o|0)!=(t|0););break f}if(o=0,r=0,(t|0)!=1)for(;w=F+G(o,3)|0,_=l[w|0],h=l[w+2|0],u[o+a|0]=l[w+1|0],u[o+P|0]=h,u[o+O|0]=_,u[o+S|0]=255,B=o|1,w=F+G(B,3)|0,_=l[w|0],h=l[w+2|0],u[B+a|0]=l[w+1|0],u[B+P|0]=h,u[B+O|0]=_,u[B+S|0]=255,o=o+2|0,r=r+2|0,(z|0)!=(r|0););if(!R)break f;_=F+G(o,3)|0,h=l[_|0],r=l[_+2|0],u[o+a|0]=l[_+1|0],u[o+P|0]=r,u[o+O|0]=h,u[o+S|0]=255}if(e=e+1|0,(V|0)==(e|0))break}}u[A+20|0]=0,i[A+4>>2]=n,i[A>>2]=X;break i}if(A=i[n+4>>2],i[n+4>>2]=A-1,A)break i;W[i[i[n>>2]+8>>2]](n),y(n)}v=f+128|0}function SB(A,e,r,f,k,n,t,o){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,t=t|0,o=o|0;var s=0,w=0,h=0,_=0,B=0,m=0,X=0,Q=0,V=0,F=0,I=0;h=v-48|0,v=h;i:{if(!e){e=i[23570],i[A>>2]=i[23569],i[A+4>>2]=e,i[A+8>>2]=i[23571];break i}if(!(n&&k)){if(u[h+32|0]=0,u[h+43|0]=0,r=A,A=q(h+8|0,5,2006,h+32|0),b0(r,A,i[e>>2]),u[A+19|0]<0&&Z(i[A+8>>2]),u[h+43|0]>=0)break i;Z(i[h+32>>2]);break i}if((k|n)>>>0>=65536){i[A>>2]=5,i[A+4>>2]=129,i[A+8>>2]=21291;break i}m=h+8|0,F=i[e>>2],X=t,s=v-48|0,v=s,Q=G(k,n);e:{if(Q>>>16|0){r=p(32),i[s+12>>2]=r,i[s+16>>2]=31,i[s+20>>2]=-2147483616,f=l[26754]|l[26755]<<8|(l[26756]<<16|l[26757]<<24),k=l[26750]|l[26751]<<8|(l[26752]<<16|l[26753]<<24),u[r+23|0]=k,u[r+24|0]=k>>>8,u[r+25|0]=k>>>16,u[r+26|0]=k>>>24,u[r+27|0]=f,u[r+28|0]=f>>>8,u[r+29|0]=f>>>16,u[r+30|0]=f>>>24,f=l[26747]|l[26748]<<8|(l[26749]<<16|l[26750]<<24),k=l[26743]|l[26744]<<8|(l[26745]<<16|l[26746]<<24),u[r+16|0]=k,u[r+17|0]=k>>>8,u[r+18|0]=k>>>16,u[r+19|0]=k>>>24,u[r+20|0]=f,u[r+21|0]=f>>>8,u[r+22|0]=f>>>16,u[r+23|0]=f>>>24,f=l[26739]|l[26740]<<8|(l[26741]<<16|l[26742]<<24),k=l[26735]|l[26736]<<8|(l[26737]<<16|l[26738]<<24),u[r+8|0]=k,u[r+9|0]=k>>>8,u[r+10|0]=k>>>16,u[r+11|0]=k>>>24,u[r+12|0]=f,u[r+13|0]=f>>>8,u[r+14|0]=f>>>16,u[r+15|0]=f>>>24,f=l[26731]|l[26732]<<8|(l[26733]<<16|l[26734]<<24),k=l[26727]|l[26728]<<8|(l[26729]<<16|l[26730]<<24),u[r|0]=k,u[r+1|0]=k>>>8,u[r+2|0]=k>>>16,u[r+3|0]=k>>>24,u[r+4|0]=f,u[r+5|0]=f>>>8,u[r+6|0]=f>>>16,u[r+7|0]=f>>>24,u[r+31|0]=0,r=q(s+24|0,5,0,s+12|0),f=i[r+4>>2],i[m>>2]=i[r>>2],i[m+4>>2]=f,f=m+8|0;r:{if(u[r+19|0]>=0){k=i[r+12>>2],i[f>>2]=i[r+8>>2],i[f+4>>2]=k,i[f+8>>2]=i[r+16>>2],u[m+20|0]=1;break r}if(T(f,i[r+8>>2],i[r+12>>2]),f=u[r+19|0],u[m+20|0]=1,(f|0)>=0)break r;Z(i[r+8>>2])}if(u[s+23|0]>=0)break e;Z(i[s+12>>2]);break e}_=r|f,B=_>>>0>65535,t=B?12:8,w=p(t),i[s+24>>2]=w,V=t+w|0,i[s+32>>2]=V,t&&o0(w,0,t),i[s+28>>2]=V,u[w+3|0]=k-1,u[w+2|0]=n-1,u[w+1|0]=B,u[w|0]=0;r:{if(_>>>0>=65536){t=f<<24|(f&65280)<<8|(f>>>8&65280|f>>>24),u[w+8|0]=t,u[w+9|0]=t>>>8,u[w+10|0]=t>>>16,u[w+11|0]=t>>>24,B=r>>>24|0,_=r,t=r>>>16|0;break r}B=r>>>8|0,_=f,t=r}u[w+7|0]=_,u[w+5|0]=t,u[w+4|0]=B,u[w+6|0]=_>>>8,w=i[F+48>>2],_=i[F+52>>2],_&&(i[_+4>>2]=i[_+4>>2]+1),B=aA(w,1735551332),t=p(496),i[t>>2]=101016,i[t+4>>2]=0,i[t+8>>2]=0,V=E4(t+16|0,F,B),i[V>>2]=101176,i[t+488>>2]=0,i[t+480>>2]=0,i[t+484>>2]=0,i[t+472>>2]=0,i[t+476>>2]=0,i[t+464>>2]=0,i[t+468>>2]=0,I=M6(),i[t+488>>2]=I,Sr(I,X),i[t+472>>2]=f,i[t+468>>2]=r,g[t+466>>1]=k,g[t+464>>1]=n,n=i[t+476>>2],k=i[t+480>>2]-n>>2;r:{if(k>>>0<Q>>>0){V8(t+476|0,Q-k|0);break r}if(k>>>0<=Q>>>0)break r;i[t+480>>2]=n+(Q<<2)}i[t+140>>2]=f,i[t+136>>2]=r,i[s+16>>2]=t,i[s+12>>2]=V,i[t+4>>2]=i[t+4>>2]+1,Mr(F,B,s+12|0),k=i[s+16>>2];r:{if(!k||(n=i[k+4>>2],i[k+4>>2]=n-1,n))break r;W[i[i[k>>2]+8>>2]](k),y(k)}q8(w,B,s+24|0,1),i[s+20>>2]=0,i[s+12>>2]=0,i[s+16>>2]=0,Q&&V8(s+12|0,Q),a4(w,B,1684630887,s+12|0),n=v-16|0,v=n,k=p(128),i[k+4>>2]=0,i[k+8>>2]=0,i[k>>2]=90124,X=k+16|0,i[X+8>>2]=0,i[X+12>>2]=0,i[k+32>>2]=0,i[k+36>>2]=0,i[k+40>>2]=0,i[k+44>>2]=0,i[k+48>>2]=0,i[k+16>>2]=86356,i[k+60>>2]=0,i[k+64>>2]=0,i[k+52>>2]=0,i[k+56>>2]=0,i[k+72>>2]=-1,i[k+76>>2]=-1,i[k+80>>2]=-1,i[k+84>>2]=-1,i[k+116>>2]=0,i[k+88>>2]=0,i[k+92>>2]=0,i[k+96>>2]=0,i[k+100>>2]=0,i[k+104>>2]=0,i[k+108>>2]=0,g[k+112>>1]=0,i[k+16>>2]=87604,i[k+124>>2]=f,i[k+120>>2]=r,i[k+32>>2]=1769173093,r=i[w+52>>2],i[n+12>>2]=k,i[n+8>>2]=X,i[k+4>>2]=i[k+4>>2]+1,f=R6(r,n+8|0),r=i[n+12>>2];r:{if(!r||(X=i[r+4>>2],i[r+4>>2]=X-1,X))break r;W[i[i[r>>2]+8>>2]](r),y(r)}r=i[w+60>>2],g[n+6>>1]=f+1,u[n+4|0]=0,i[n>>2]=C[n+4>>1]|C[n+6>>1]<<16,C6(r,B,n),r=i[k+4>>2],i[k+4>>2]=r-1,r||(W[i[i[k>>2]+8>>2]](k),y(k)),v=n+16|0,u[m+20|0]=0,i[m+4>>2]=t,i[m>>2]=V,r=i[s+12>>2],r&&(i[s+16>>2]=r,Z(r));r:{if(!_||(r=i[_+4>>2],i[_+4>>2]=r-1,r))break r;W[i[i[_>>2]+8>>2]](_),y(_)}if(r=i[s+24>>2],!r)break e;i[s+28>>2]=r,Z(r)}v=s+48|0;e:{r:switch(l[h+28|0]){default:_2(),H();case 1:b0(A,h+8|0,i[e>>2]);break e;case 0:break r}r:{if(!o)break r;k=p(16),r=k,i[r>>2]=0,i[r+4>>2]=0,i[r+8>>2]=0,i[r+12>>2]=0,i[o>>2]=r,n=i[h+8>>2],f=i[h+12>>2];f:{if(!f){i[r+4>>2]=f,i[r>>2]=n;break f}if(i[f+4>>2]=i[f+4>>2]+1,i[k>>2]=n,r=i[k+4>>2],i[k+4>>2]=f,!r||(f=i[r+4>>2],i[r+4>>2]=f-1,f))break f;W[i[i[r>>2]+8>>2]](r),y(r)}if(k=i[e>>2],r=i[o>>2],f=i[e+4>>2],f&&(i[f+4>>2]=i[f+4>>2]+1),i[r+8>>2]=k,e=i[r+12>>2],i[r+12>>2]=f,!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break r;W[i[i[e>>2]+8>>2]](e),y(e)}e=i[24057],i[A>>2]=i[24056],i[A+4>>2]=e,i[A+8>>2]=i[24058]}if(A=l[h+28|0],(A|0)==255)break i;e=i[24237],i[h+32>>2]=i[24236],i[h+36>>2]=e,W[i[(h+32|0)+(A<<2)>>2]](h+47|0,h+8|0)}v=h+48|0}function jB(A,e,r,f,k,n,t,o){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,t=t|0,o=o|0;var s=0,w=0,h=0,_=0,B=0,m=0,X=0,Q=0,V=0,F=0,I=0,E=0,R=0,N=0,M=0,z=0,S=0,O=0,P=0,a=0,$=0,f0=0,A0=0,n0=0,_0=0;w=v-112|0,v=w,e=i[r>>2],i[w+92>>2]=e,s=i[r+4>>2],i[w+96>>2]=s,s&&(i[s+4>>2]=i[s+4>>2]+1),s=i[t+20>>2],i[w+80>>2]=i[t+16>>2],i[w+84>>2]=s,s=i[t+12>>2],i[w+72>>2]=i[t+8>>2],i[w+76>>2]=s,s=i[t+4>>2],i[w+64>>2]=i[t>>2],i[w+68>>2]=s,i[w+68>>2]=0;i:{e:{r:{if(i[t+4>>2]){AA(w+40|0,w+92|0,1,f+16|0,i[f+12>>2],n,w- -64|0,o),B=l[w+60|0];f:{if(B){if((B|0)!=1)break r;e=i[w+44>>2],i[A>>2]=i[w+40>>2],i[A+4>>2]=e,s=A+8|0;A:{if(u[w+59|0]>=0){e=i[w+52>>2],i[s>>2]=i[w+48>>2],i[s+4>>2]=e,i[s+8>>2]=i[w+56>>2];break A}T(s,i[w+48>>2],i[w+52>>2])}u[A+20|0]=1;break f}if(e=i[w+40>>2],s=i[w+44>>2],s&&(i[s+4>>2]=i[s+4>>2]+1),i[w+92>>2]=e,Q=i[w+96>>2],i[w+96>>2]=s,!Q||(e=i[Q+4>>2],i[Q+4>>2]=e-1,e))break f;W[i[i[Q>>2]+8>>2]](Q),y(Q)}if(s=l[w+60|0],(s|0)!=255&&(e=i[26085],i[w+104>>2]=i[26084],i[w+108>>2]=e,W[i[(w+104|0)+(s<<2)>>2]](w+32|0,w+40|0)),B)break i;e=i[w+92>>2]}for(R=i[e+112>>2],F=i[e+108>>2],s=p(172),i[s>>2]=94812,i[s+4>>2]=0,i[s+8>>2]=0,o0(s+16|0,0,80),i[s+104>>2]=0,i[s+108>>2]=0,i[s+36>>2]=1,i[s+40>>2]=1,u[s+24|0]=1,g[s+22>>1]=2,g[s+18>>1]=2,g[s+20>>1]=2,i[s+112>>2]=0,i[s+116>>2]=4740,i[s+140>>2]=0,i[s+144>>2]=0,i[s+128>>2]=99,i[s+132>>2]=99,i[s+120>>2]=0,i[s+124>>2]=0,i[s+12>>2]=95160,i[s+148>>2]=0,i[s+152>>2]=0,i[s+136>>2]=s+140,i[s+156>>2]=0,i[s+160>>2]=0,i[s+164>>2]=0,i[s+168>>2]=0,i[w+36>>2]=s,e=s+12|0,i[w+32>>2]=e,i[s+96>>2]=e,i[s+8>>2]=i[s+8>>2]+1,i[s+100>>2]=s,i[s+4>>2]==-1&&(W[i[i[s>>2]+8>>2]](s),y(s)),s=i[w+92>>2],e=i[s+116>>2],a=i[w+32>>2],B=a,i[B+120>>2]=i[s+120>>2],i[B+116>>2]=e,i[B+112>>2]=R,i[B+108>>2]=F,i[w+48>>2]=5,i[w+40>>2]=3,i[w+44>>2]=4,n0=F&-2,_0=F&1,A0=B+128|0;;){X=i[(w+40|0)+$>>2],T0(w+12|0,a,X,F,R,i[k+12>>2],o),u[w+31|0]<0&&Z(i[w+20>>2]),f0=0,_=i[w+92>>2],B=_+128|0,e=B;f:{A:{if(h=i[_+128>>2],!h)break A;for(;s=i[h+16>>2]<6,e=s?e:h,h=i[(s?4:0)+h>>2],!!h;);if((e|0)==(B|0))break A;if(O=0,Q=0,i[e+16>>2]>6)break f;O=i[e+44>>2],Q=i[e+56>>2]>>>1|0;break f}O=0,Q=0}M=j0(_,6),m=i[w+92>>2],_=m+128|0,e=_,h=i[m+128>>2],B=0;f:{if(!h)break f;for(;s=(X|0)>i[h+16>>2],e=s?e:h,h=i[(s?4:0)+h>>2],!!h;);if((e|0)==(_|0)){B=0;break f}if(B=0,(X|0)<i[e+16>>2])break f;f0=i[e+56>>2]>>>1|0,B=i[e+44>>2]}_=-1<<M;f:{A:{if(e=A0,h=i[e>>2],!h)break A;for(;s=(X|0)>i[h+16>>2],e=s?e:h,h=i[(s?4:0)+h>>2],!!h;);if((e|0)==(A0|0))break A;if(P=0,s=0,(X|0)<i[e+16>>2])break f;P=i[e+44>>2],s=i[e+56>>2]>>>1|0;break f}P=0,s=0}I=_^-1;f:{A:{k:switch(i[t+4>>2]-1|0){case 1:if(C[t+20>>1])break A;break;case 0:break k;default:break A}e=0;k:{n:switch(X-3|0){case 0:e=C[t+8>>1];break k;case 1:e=C[t+10>>1];break k;case 2:break n;default:break k}e=C[t+12>>1]}if(_=j0(m,X),!R|!F)break f;for(E=(e&65535)>>>16-_|0,N=I&65535,h=0;;){if(z=(G(s,h)<<1)+P|0,S=(G(h,f0)<<1)+B|0,X=(G(h,Q)<<1)+O|0,e=0,I=0,(F|0)!=1)for(;m=e<<1,_=C[m+X>>1],g[m+z>>1]=G(_,C[m+S>>1])+G(E,N-_|0)>>M,m=m|2,_=C[m+X>>1],g[m+z>>1]=G(_,C[m+S>>1])+G(E,N-_|0)>>M,e=e+2|0,I=I+2|0,(n0|0)!=(I|0););if(_0&&(_=e<<1,e=C[_+X>>1],g[_+z>>1]=G(e,C[_+S>>1])+G(E,N-e|0)>>M),h=h+1|0,(R|0)==(h|0))break}break f}e=0,V=0;A:{k:switch(X-3|0){case 0:V=C[t+14>>1],e=C[t+8>>1];break A;case 1:V=C[t+16>>1],e=C[t+10>>1];break A;case 2:break k;default:break A}V=C[t+18>>1],e=C[t+12>>1]}if(m=j0(m,X),_=j0(i[w+92>>2],X),!R|!F)break f;for(z=(e&65535)>>>16-m|0,S=(V&65535)>>>16-_|0,X=I&65535,V=0;;){for(I=(G(s,V)<<1)+P|0,m=(G(V,f0)<<1)+B|0,_=(G(V,Q)<<1)+O|0,h=0;E=h<<1,N=C[E+_>>1],e=C[t+20>>1],g[I+E>>1]=G(X-N|0,((V>>>0)/(e>>>0)|0)+((h>>>0)/(e>>>0)|0)&1?z:S)+G(N,C[m+E>>1])>>M,h=h+1|0,(F|0)!=(h|0););if(V=V+1|0,(R|0)==(V|0))break}}if($=$+4|0,($|0)==12)break}if(!i[t+4>>2])break e;e=i[r>>2],r6(w+40|0,w+32|0,i[e+116>>2],i[e+120>>2],f+16|0,i[f+12>>2],n,w- -64|0,o);f:{A:switch(l[w+60|0]){case 1:e=i[w+44>>2],i[A>>2]=i[w+40>>2],i[A+4>>2]=e,r=A+8|0;k:{if(u[w+59|0]>=0){e=i[w+52>>2],i[r>>2]=i[w+48>>2],i[r+4>>2]=e,i[r+8>>2]=i[w+56>>2];break k}T(r,i[w+48>>2],i[w+52>>2])}u[A+20|0]=1;break f;case 0:break A;default:break r}u[A+20|0]=255,u[A|0]=0,i[w+104>>2]=A,W[i[26088]](w+104|0,w+40|0),u[A+20|0]=0}if(e=l[w+60|0],(e|0)!=255&&(A=i[26087],i[w+104>>2]=i[26086],i[w+108>>2]=A,W[i[(w+104|0)+(e<<2)>>2]](w+103|0,w+40|0)),e=i[w+36>>2],!e||(A=i[e+4>>2],i[e+4>>2]=A-1,A))break i;W[i[i[e>>2]+8>>2]](e),y(e);break i}_2(),H()}e=i[w+36>>2],u[A+20|0]=0,i[A+4>>2]=e,i[A>>2]=a}e=i[w+96>>2];i:{if(!e||(A=i[e+4>>2],i[e+4>>2]=A-1,A))break i;W[i[i[e>>2]+8>>2]](e),y(e)}v=w+112|0}function OB(A,e,r,f,k,n,t,o){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,t=t|0,o=o|0;var s=0,w=0,h=0,_=0,B=0,m=0,X=0,Q=0,V=0,F=0,I=0,E=0,R=0,N=0,M=0,z=0,S=0,O=0,P=0,a=0,$=0,f0=0,A0=0;n=v-128|0,v=n,B=l[k+8|0],w=i[i[r>>2]+120>>2],t=p(172),i[t>>2]=94812,i[t+4>>2]=0,i[t+8>>2]=0,o0(t+16|0,0,80),f=i[t+4>>2],k=f+1|0,i[t+4>>2]=k,i[t+104>>2]=0,i[t+108>>2]=0,i[t+36>>2]=1,i[t+40>>2]=1,u[t+24|0]=1,g[t+22>>1]=2,g[t+18>>1]=2,g[t+20>>1]=2,i[t+112>>2]=0,i[t+116>>2]=4740,i[t+140>>2]=0,i[t+144>>2]=0,i[t+128>>2]=99,i[t+132>>2]=99,i[t+120>>2]=0,i[t+124>>2]=0,i[t+12>>2]=95160,i[t+148>>2]=0,i[t+152>>2]=0,e=t+140|0,i[t+136>>2]=e,i[t+156>>2]=0,i[t+160>>2]=0,i[t+164>>2]=0,i[t+168>>2]=0,i[t+4>>2]=f,f=i[t+8>>2],_=t+12|0,i[t+96>>2]=_,i[t+8>>2]=f+1,i[t+100>>2]=t,k||(W[i[i[t>>2]+8>>2]](t),y(t)),f=i[r>>2],Q=i[f+112>>2],m=i[f+108>>2],V=j0(f,10),i[_+120>>2]=3,i[_+116>>2]=1,i[_+112>>2]=Q,i[_+108>>2]=m,T0(n+56|0,_,3,m,Q,V,o),T0(n+32|0,_,4,m,Q,V,o),s=n+88|0;i:{if(i[n+56>>2]){if(f=i[n+60>>2],i[n+80>>2]=i[n+56>>2],i[n+84>>2]=f,u[n+75|0]>=0){k=n- -64|0,f=i[k+4>>2],i[s>>2]=i[k>>2],i[s+4>>2]=f,i[s+8>>2]=i[k+8>>2];break i}T(s,i[n+64>>2],i[n+68>>2]);break i}if(f=i[n+36>>2],i[n+80>>2]=i[n+32>>2],i[n+84>>2]=f,u[n+51|0]>=0){f=i[n+44>>2],i[s>>2]=i[n+40>>2],i[s+4>>2]=f,i[s+8>>2]=i[n+48>>2];break i}T(s,i[n+40>>2],i[n+44>>2])}T0(n+8|0,_,5,m,Q,V,o),k=n+112|0;i:{if(i[n+80>>2]){if(f=i[n+84>>2],i[n+104>>2]=i[n+80>>2],i[n+108>>2]=f,u[n+99|0]>=0){f=i[s+4>>2],i[k>>2]=i[s>>2],i[k+4>>2]=f,i[k+8>>2]=i[s+8>>2];break i}T(k,i[n+88>>2],i[n+92>>2]);break i}if(f=i[n+12>>2],i[n+104>>2]=i[n+8>>2],i[n+108>>2]=f,u[n+27|0]>=0){f=i[n+20>>2],i[k>>2]=i[n+16>>2],i[k+4>>2]=f,i[k+8>>2]=i[n+24>>2];break i}T(k,i[n+16>>2],i[n+20>>2])}u[n+27|0]<0&&Z(i[n+16>>2]),u[n+99|0]<0&&Z(i[n+88>>2]),u[n+51|0]<0&&Z(i[n+40>>2]),u[n+75|0]<0&&Z(i[n+64>>2]);i:{e:{if(i[n+104>>2]){if(e=i[n+108>>2],i[A>>2]=i[n+104>>2],i[A+4>>2]=e,r=A+8|0,u[n+123|0]>=0){e=i[k+4>>2],i[r>>2]=i[k>>2],i[r+4>>2]=e,i[r+8>>2]=i[k+8>>2],u[A+20|0]=1;break e}if(T(r,i[n+112>>2],i[n+116>>2]),e=u[n+123|0],u[A+20|0]=1,(e|0)>=0)break e;Z(i[n+112>>2]);break e}u[n+123|0]<0&&Z(i[n+112>>2]);r:{if(!(B&1))break r;if(T0(n+104|0,_,6,m,Q,V,o),i[n+104>>2]){if(e=i[n+108>>2],i[A>>2]=i[n+104>>2],i[A+4>>2]=e,r=A+8|0,u[n+123|0]>=0){e=i[n+116>>2],i[r>>2]=i[n+112>>2],i[r+4>>2]=e,i[r+8>>2]=i[n+120>>2],u[A+20|0]=1;break e}if(T(r,i[n+112>>2],i[n+116>>2]),e=u[n+123|0],u[A+20|0]=1,(e|0)>=0)break e;Z(i[n+112>>2]);break e}if(u[n+123|0]>=0)break r;Z(i[n+112>>2])}r:{f:{if(r=i[r>>2],o=i[r+128>>2],!o)break f;for(k=r+128|0,f=k;r=i[o+16>>2]<10,f=r?f:o,o=i[(r?4:0)+o>>2],!!o;);if((f|0)==(k|0))break f;if(r=0,i[f+16>>2]>10)break r;M=i[f+44>>2],r=i[f+56>>2];break r}r=0}s=r;r:{f:{f=i[e>>2];A:{if(!f){r=0;break A}for(k=e,o=f;r=i[o+16>>2]<3,k=r?k:o,o=i[(r?4:0)+o>>2],!!o;);I=0;k:{if((e|0)==(k|0)||(I=0,i[k+16>>2]>3))break k;h=i[k+56>>2],I=i[k+44>>2]}for(k=e,o=f;r=i[o+16>>2]<4,k=r?k:o,o=i[(r?4:0)+o>>2],!!o;);E=0;k:{if((e|0)==(k|0)||(E=0,i[k+16>>2]>4))break k;R=i[k+56>>2],E=i[k+44>>2]}for(k=e,o=f;r=i[o+16>>2]<5,k=r?k:o,o=i[(r?4:0)+o>>2],!!o;);r=0;k:{if((e|0)==(k|0)||(r=0,i[k+16>>2]>5))break k;z=i[k+44>>2],r=i[k+56>>2]}if(k=0,!(B&1))break r;for(o=e;k=i[f+16>>2]<6,o=k?o:f,f=i[(k?4:0)+f>>2],!!f;);if((e|0)!=(o|0))break f}k=0;break r}if(k=0,i[o+16>>2]>6)break r;N=i[o+56>>2]>>>1|0,k=i[o+44>>2]}f=k;r:{if(!Q|!m)break r;if(S=(w&-3)==13?8:6,O=r>>>1|0,P=R>>>1|0,a=h>>>1|0,e=0,B&1){for(R=-1<<V^-1,k=w-13|0;;){$=G(e,s)+M|0,f0=(G(e,N)<<1)+f|0,A0=(G(e,O)<<1)+z|0,V=(G(e,P)<<1)+E|0,B=(G(e,a)<<1)+I|0,o=0;f:{A:switch(k|0){case 0:case 2:for(;F=$+(o<<3)|0,w=l[F+4|0]|l[F+5|0]<<8,h=l[F+2|0]|l[F+3|0]<<8,X=o<<1,r=l[F|0]|l[F+1|0]<<8,g[X+B>>1]=r<<8|r>>>8,g[V+X>>1]=h<<8|h>>>8,g[X+A0>>1]=w<<8|w>>>8,r=l[F+6|0]|l[F+7|0]<<8,g[X+f0>>1]=r<<8|r>>>8,o=o+1|0,(m|0)!=(o|0););break f;default:break A}for(;r=$+G(o,S)|0,w=l[r+4|0]|l[r+5|0]<<8,h=l[r+2|0]|l[r+3|0]<<8,X=o<<1,r=l[r|0]|l[r+1|0]<<8,g[X+B>>1]=r<<8|r>>>8,g[V+X>>1]=h<<8|h>>>8,g[X+A0>>1]=w<<8|w>>>8,g[X+f0>>1]=R,o=o+1|0,(m|0)!=(o|0););}if(e=e+1|0,(Q|0)==(e|0))break}break r}for(;;){for(N=G(e,s)+M|0,R=(G(e,O)<<1)+z|0,k=(G(e,P)<<1)+E|0,f=(G(e,a)<<1)+I|0,o=0;r=N+G(o,S)|0,B=l[r+4|0]|l[r+5|0]<<8,w=l[r+2|0]|l[r+3|0]<<8,h=o<<1,r=l[r|0]|l[r+1|0]<<8,g[h+f>>1]=r<<8|r>>>8,g[k+h>>1]=w<<8|w>>>8,g[h+R>>1]=B<<8|B>>>8,o=o+1|0,(m|0)!=(o|0););if(e=e+1|0,(Q|0)==(e|0))break}}u[A+20|0]=0,i[A+4>>2]=t,i[A>>2]=_;break i}if(A=i[t+4>>2],i[t+4>>2]=A-1,A)break i;W[i[i[t>>2]+8>>2]](t),y(t)}v=n+128|0}function Li(A,e,r,f,k,n,t,o,s,w){var h=0,_=0,B=0,m=0,X=0,Q=0,V=0,F=0,I=0,E=0,R=0,N=0,M=0,z=0,S=0,O=0,P=0,a=0,$=0,f0=0,A0=0,n0=0,_0=0,m0=0,X0=0,g0=0,I0=0,e0=0,r0=0,N0=0,U0=0,M0=0,H0=0,P0=0,K0=0,$0=0,L0=0,d0=0,n2=0,Z2=0,Q2=0,g2=0,p2=0,H2=0,T2=0,b2=0,e1=0,X1=0,J1=0,z1=0;F=v-128|0,v=F;i:{e:{r:{if(S=i[A+140>>2],h=S+G(e,24)|0,X=i[A+152>>2],I=G(X,r),m=(h+G(I,24)|0)+4|0,_0=f<<1,m0=l[m|0]>>>_0&3,!m0)break r;if(R=G(e,k),E=i[A+148>>2],N=R>>E,(N|0)<0|(X|0)<=(N|0))break e;if(O=G(r,n),Q=O>>E,(Q|0)<0|(Q|0)>=i[A+156>>2])break i;if(r=i[A+124>>2],V=i[r+(f?16840:16832)>>2],e=-1<<V^-1,A0=i[(f?36:28)+A>>2],P=(A0|0)<(n+O|0)?A0-O|0:n,n0=i[(f?32:24)+A>>2],a=(n0|0)<(k+R|0)?n0-R|0:k,$=f?i[r+16856>>2]-1|0:0,z=f?i[r+16852>>2]-1|0:0,N0=l[(h+G(I,24)|0)+22|0],(m0|0)==2){if(I=i[A+132>>2],V=i[A+52>>2],N=i[i[V+(C[((S+G(N,24)|0)+G(G(X,Q),24)|0)+2>>1]<<2)>>2]+808>>2],k=i[A+56>>2],n=i[r+16876>>2],Q=i[r+16892>>2],h=l[m+1|0],f=m+(f<<2)|0,u[F|0]=l[f+5|0],m=l[f+6|0],u[F+2|0]=0,u[F+1|0]=m,u[F+3|0]=l[f+7|0],u[F+4|0]=l[f+8|0],(P|0)<=0|(a|0)<=0)break r;for(m0=k-V>>2,k=(h>>>_0&3)<<2,_0=i[k+62872>>2],U0=i[k+62856>>2],X0=n-z|0,M0=R>>X0,L0=P-1|0,d0=a-1|0,g0=n-$|0,H0=G(Q,O>>g0),f=R<<1,n2=f+s|0,Z2=f+t|0,f=0,P0=i[k+62888>>2],Q2=G(P0,o)<<1,K0=i[k+62904>>2],g2=G(K0,o)<<1;;){for(k=f+O|0,p2=(G(k,w)<<1)+n2|0,H2=(G(k,o)<<1)+Z2|0,I0=k<<$,t=I0>>E,T2=(S+G(G(t,X),24)|0)+2|0,s=k+P0|0,e0=s<<$>>E,b2=(S+G(G(X,e0),24)|0)+2|0,m=k+K0|0,r0=m<<$>>E,e1=(S+G(G(X,r0),24)|0)+2|0,X1=G(Q,m>>>g0|0)<<2,J1=G(Q,s>>>g0|0)<<2,z1=(f|0)==(L0|0),k=0;;){f:{A:{if(!(N0&1)){n=i[A+168>>2];break A}if(n=i[A+168>>2],!l[r+8812|0])break A;if(h=k+R<<z>>n,(h|0)<0||(B=i[A+172>>2],(B|0)<=(h|0)))break e;if(_=I0>>n,(_|0)<0|(_|0)>=i[A+176>>2])break i;if(l[((i[A+160>>2]+G(h,3)|0)+G(G(_,B),3)|0)+1|0]&4)break f}if(_=k+R|0,M=_<<z,h=M>>n,(h|0)<0||(B=i[A+172>>2],(B|0)<=(h|0)))break e;if(n=I0>>n,(n|0)<0|(n|0)>=i[A+176>>2])break i;if(l[((i[A+160>>2]+G(h,3)|0)+G(G(n,B),3)|0)+1|0]&8)break f;A:{if(!(!f|!k|(k|0)==(d0|0))&&!z1)break A;if(n=_+_0|0,(n|0)>=(n0|0)|(n|0)<0|((m|0)<0|(m|0)>=(A0|0)))break f;if(B=n<<z>>E,(B|0)<0|(X|0)<=(B|0))break e;if((r0|0)<0||(h=i[A+156>>2],(h|0)<=(r0|0)))break i;if(B=C[G(B,24)+e1>>1],B>>>0>=m0>>>0||(B=i[V+(B<<2)>>2],!B))break r;M=M>>E,$0=(M|0)>=0&X>>>0>M>>>0,M=G(M,24)+T2|0;k:{if(f0=i[B+808>>2],(f0|0)<(N|0)){if(!$0)break e;if((t|0)<0|(t|0)>=(h|0))break k;if(!l[i[V+(C[M>>1]<<2)>>2]+772|0])break f}if(!l[B+772|0]&(N|0)<(f0|0)||(B=l[I+57|0],!B&&(f0=n>>>X0<<2,n=i[I+8484>>2],i[(f0+n|0)+X1>>2]!=i[(n+(M0<<2)|0)+(H0<<2)>>2]))||(n=_+U0|0,(n|0)>=(n0|0)|(n|0)<0|((s|0)<0|(s|0)>=(A0|0))))break f;if(_=n<<z>>E,(_|0)<0|(_|0)>=(X|0))break e;if((e0|0)<0|(h|0)<=(e0|0))break i;if(_=C[G(_,24)+b2>>1],_>>>0>=m0>>>0||(_=i[V+(_<<2)>>2],!_))break r;if(f0=i[_+808>>2],(f0|0)<(N|0)){if(!$0)break e;if((t|0)<0|(t|0)>=(h|0))break k;if(!l[i[V+(C[M>>1]<<2)>>2]+772|0])break f}if(!l[_+772|0]&(N|0)<(f0|0))break f;if(B||(h=n>>>X0<<2,n=i[I+8484>>2],i[(h+n|0)+J1>>2]==i[(n+(M0<<2)|0)+(H0<<2)>>2]))break A;break f}break i}_=k<<1,h=_+H2|0,n=C[h>>1],B=_+p2|0,_=C[(h+(_0<<1)|0)+g2>>1],h=C[(h+(U0<<1)|0)+Q2>>1],n=n+u[(((_>>>0<n>>>0)-(n>>>0<_>>>0)+((h>>>0<n>>>0)-(n>>>0<h>>>0))|0)+F|0)+2|0]|0,g[B>>1]=(n|0)>=0?(e|0)>(n|0)?n:e:0}if(k=k+1|0,(a|0)==(k|0))break}if(f=f+1|0,(P|0)==(f|0))break}break r}if(k=l[(f+m|0)+2|0],o0(F,0,128),i[((k&31)<<2)+F>>2]=1,i[((k+1&31)<<2)+F>>2]=2,i[((k+2&31)<<2)+F>>2]=3,i[((k+3&31)<<2)+F>>2]=4,E=V-5|0,!(N0&1)){if((P|0)<=0|(a|0)<=0|(V|0)>12)break r;for(n=m+5|0,X=(R<<1)+t|0,r=0;;){for(A=r+O|0,z=(G(A,w)<<1)+s|0,A=G(A,o)<<1,m=A+t|0,$=A+X|0,A=0;k=C[$+(A<<1)>>1],k=i[((e>>>0>k>>>0?k:e)>>>E<<2)+F>>2],(k|0)>0&&(V=A+R<<1,k=C[V+m>>1]+u[(k+(n+(f<<2)|0)|0)-1|0]|0,g[V+z>>1]=(k|0)>=0?(e|0)>(k|0)?k:e:0),A=A+1|0,(a|0)>(A|0););if(r=r+1|0,!((P|0)>(r|0)))break}break r}if((P|0)<=0|(a|0)<=0)break r;S=m+5|0,m=i[A+168>>2],N=l[r+8812|0],V=(V|0)>12,X=0;f:{for(;;){r=X+O|0,k=r<<$>>m,A0=(G(r,w)<<1)+s|0,n0=(G(r,o)<<1)+t|0,r=0;A:{for(;;){I=r+R|0,n=I<<z>>m;k:{n:{if(N){if((n|0)<0||(Q=i[A+172>>2],(Q|0)<=(n|0)))break A;if((k|0)<0|(k|0)>=i[A+176>>2])break i;if(!(l[((i[A+160>>2]+G(n,3)|0)+G(G(k,Q),3)|0)+1|0]&4))break n;break k}if((n|0)<0)break e}if(Q=i[A+172>>2],(Q|0)<=(n|0))break e;if((k|0)<0|(k|0)>=i[A+176>>2])break f;if(V|l[((i[A+160>>2]+G(n,3)|0)+G(G(k,Q),3)|0)+1|0]&8||(I=I<<1,n=C[I+n0>>1],Q=i[((e>>>0>n>>>0?n:e)>>>E<<2)+F>>2],(Q|0)<=0))break k;n=n+u[(Q+(S+(f<<2)|0)|0)-1|0]|0,g[I+A0>>1]=(n|0)>=0?(e|0)>(n|0)?n:e:0}if(r=r+1|0,!((a|0)>(r|0)))break}if(X=X+1|0,(P|0)<=(X|0))break r;continue}break}break e}break i}v=F+128|0;return}D0(4656,10893,118,4231),H()}D0(4618,10893,119,4231),H()}function PB(A,e,r,f,k,n,t,o){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,t=t|0,o=o|0;var s=0,w=0,h=0,_=0,B=0,m=0,X=0,Q=0,V=0,F=0,I=0,E=0,R=0,N=0,M=0,z=0,S=0,O=0,P=0,a=0,$=0;f=v-128|0,v=f,w=l[k+8|0],F=i[i[r>>2]+120>>2],n=p(172),i[n>>2]=94812,i[n+4>>2]=0,i[n+8>>2]=0,o0(n+16|0,0,80),k=i[n+4>>2],t=k+1|0,i[n+4>>2]=t,i[n+104>>2]=0,i[n+108>>2]=0,i[n+36>>2]=1,i[n+40>>2]=1,u[n+24|0]=1,g[n+22>>1]=2,g[n+18>>1]=2,g[n+20>>1]=2,i[n+112>>2]=0,i[n+116>>2]=4740,i[n+140>>2]=0,i[n+144>>2]=0,i[n+128>>2]=99,i[n+132>>2]=99,i[n+120>>2]=0,i[n+124>>2]=0,i[n+12>>2]=95160,i[n+148>>2]=0,i[n+152>>2]=0,e=n+140|0,i[n+136>>2]=e,i[n+156>>2]=0,i[n+160>>2]=0,i[n+164>>2]=0,i[n+168>>2]=0,i[n+4>>2]=k,k=i[n+8>>2],m=n+12|0,i[n+96>>2]=m,i[n+8>>2]=k+1,i[n+100>>2]=n,t||(W[i[i[n>>2]+8>>2]](n),y(n)),k=i[r>>2],h=i[k+108>>2],I=i[k+112>>2],k=I,i[m+120>>2]=3,i[m+116>>2]=1,i[m+112>>2]=k,i[m+108>>2]=h,T0(f+56|0,m,3,h,k,8,o),T0(f+32|0,m,4,h,k,8,o),s=f+88|0;i:{if(i[f+56>>2]){if(k=i[f+60>>2],i[f+80>>2]=i[f+56>>2],i[f+84>>2]=k,u[f+75|0]>=0){t=f- -64|0,k=i[t+4>>2],i[s>>2]=i[t>>2],i[s+4>>2]=k,i[s+8>>2]=i[t+8>>2];break i}T(s,i[f+64>>2],i[f+68>>2]);break i}if(k=i[f+36>>2],i[f+80>>2]=i[f+32>>2],i[f+84>>2]=k,u[f+51|0]>=0){k=i[f+44>>2],i[s>>2]=i[f+40>>2],i[s+4>>2]=k,i[s+8>>2]=i[f+48>>2];break i}T(s,i[f+40>>2],i[f+44>>2])}T0(f+8|0,m,5,h,I,8,o),t=f+112|0;i:{if(i[f+80>>2]){if(k=i[f+84>>2],i[f+104>>2]=i[f+80>>2],i[f+108>>2]=k,u[f+99|0]>=0){k=i[s+4>>2],i[t>>2]=i[s>>2],i[t+4>>2]=k,i[t+8>>2]=i[s+8>>2];break i}T(t,i[f+88>>2],i[f+92>>2]);break i}if(k=i[f+12>>2],i[f+104>>2]=i[f+8>>2],i[f+108>>2]=k,u[f+27|0]>=0){k=i[f+20>>2],i[t>>2]=i[f+16>>2],i[t+4>>2]=k,i[t+8>>2]=i[f+24>>2];break i}T(t,i[f+16>>2],i[f+20>>2])}u[f+27|0]<0&&Z(i[f+16>>2]),u[f+99|0]<0&&Z(i[f+88>>2]),u[f+51|0]<0&&Z(i[f+40>>2]),u[f+75|0]<0&&Z(i[f+64>>2]);i:{e:{if(i[f+104>>2]){if(e=i[f+108>>2],i[A>>2]=i[f+104>>2],i[A+4>>2]=e,r=A+8|0,u[f+123|0]>=0){e=i[t+4>>2],i[r>>2]=i[t>>2],i[r+4>>2]=e,i[r+8>>2]=i[t+8>>2],u[A+20|0]=1;break e}if(T(r,i[f+112>>2],i[f+116>>2]),e=u[f+123|0],u[A+20|0]=1,(e|0)>=0)break e;Z(i[f+112>>2]);break e}u[f+123|0]<0&&Z(i[f+112>>2]);r:{if(!(w&1))break r;if(T0(f+104|0,m,6,h,I,8,o),i[f+104>>2]){if(e=i[f+108>>2],i[A>>2]=i[f+104>>2],i[A+4>>2]=e,r=A+8|0,u[f+123|0]>=0){e=i[f+116>>2],i[r>>2]=i[f+112>>2],i[r+4>>2]=e,i[r+8>>2]=i[f+120>>2],u[A+20|0]=1;break e}if(T(r,i[f+112>>2],i[f+116>>2]),e=u[f+123|0],u[A+20|0]=1,(e|0)>=0)break e;Z(i[f+112>>2]);break e}if(u[f+123|0]>=0)break r;Z(i[f+112>>2])}r:{f:{if(r=i[r>>2],o=i[r+128>>2],!o)break f;for(t=r+128|0,r=t;k=i[o+16>>2]<10,r=k?r:o,o=i[(k?4:0)+o>>2],!!o;);if((r|0)==(t|0))break f;if(t=0,i[r+16>>2]>10)break r;O=i[r+44>>2],t=i[r+56>>2];break r}t=0}r:{f:{r=i[e>>2];A:{if(!r)break A;for(k=e,o=r;_=i[o+16>>2]<3,k=_?k:o,o=i[(_?4:0)+o>>2],!!o;);E=0;k:{if((e|0)==(k|0)||(E=0,i[k+16>>2]>3))break k;P=i[k+56>>2],E=i[k+44>>2]}for(k=e,o=r;_=i[o+16>>2]<4,k=_?k:o,o=i[(_?4:0)+o>>2],!!o;);R=0;k:{if((e|0)==(k|0)||(R=0,i[k+16>>2]>4))break k;a=i[k+44>>2],R=i[k+56>>2]}for(k=e,o=r;_=i[o+16>>2]<5,k=_?k:o,o=i[(_?4:0)+o>>2],!!o;);k:{if((e|0)==(k|0)){o=0;break k}if(o=0,i[k+16>>2]>5)break k;$=i[k+56>>2],o=i[k+44>>2]}if(_=o,k=0,!(w&1))break r;for(o=e;k=i[r+16>>2]<6,o=k?o:r,r=i[(k?4:0)+r>>2],!!r;);if((e|0)!=(o|0))break f}k=0;break r}if(k=0,i[o+16>>2]>6)break r;N=i[o+56>>2],k=i[o+44>>2]}r:{if(!I|!h)break r;if(!(w&1)){for(Q=(F|0)==11?4:3,F=h&-2,k=h&1,e=0;;){if(V=G(e,$)+_|0,X=G(e,R)+a|0,B=G(e,P)+E|0,N=G(e,t)+O|0,o=0,r=0,(h|0)!=1)for(;w=N+G(o,Q)|0,u[o+B|0]=l[w|0],u[o+X|0]=l[w+1|0],u[o+V|0]=l[w+2|0],s=o|1,w=N+G(s,Q)|0,u[s+B|0]=l[w|0],u[s+X|0]=l[w+1|0],u[s+V|0]=l[w+2|0],o=o+2|0,r=r+2|0,(F|0)!=(r|0););if(k&&(r=N+G(o,Q)|0,u[o+B|0]=l[r|0],u[o+X|0]=l[r+1|0],u[o+V|0]=l[r+2|0]),e=e+1|0,(I|0)==(e|0))break}break r}for(s=h&-2,w=h&1,e=0,F=(F|0)==11;;){M=k+G(e,N)|0,z=G(e,$)+_|0,S=G(e,R)+a|0,Q=G(e,P)+E|0,V=G(e,t)+O|0,o=0;f:{if(!F){if(r=0,(h|0)!=1)for(;B=V+G(o,3)|0,u[o+Q|0]=l[B|0],u[o+S|0]=l[B+1|0],u[o+z|0]=l[B+2|0],u[o+M|0]=255,X=o|1,B=V+G(X,3)|0,u[Q+X|0]=l[B|0],u[X+S|0]=l[B+1|0],u[X+z|0]=l[B+2|0],u[X+M|0]=255,o=o+2|0,r=r+2|0,(s|0)!=(r|0););if(!w)break f;r=V+G(o,3)|0,u[o+Q|0]=l[r|0],u[o+S|0]=l[r+1|0],u[o+z|0]=l[r+2|0],u[o+M|0]=255;break f}for(;r=V+(o<<2)|0,u[o+Q|0]=l[r|0],u[o+S|0]=l[r+1|0],u[o+z|0]=l[r+2|0],u[o+M|0]=l[r+3|0],o=o+1|0,(h|0)!=(o|0););}if(e=e+1|0,(I|0)==(e|0))break}}u[A+20|0]=0,i[A+4>>2]=n,i[A>>2]=m;break i}if(A=i[n+4>>2],i[n+4>>2]=A-1,A)break i;W[i[i[n>>2]+8>>2]](n),y(n)}v=f+128|0}function Ki(A,e,r,f,k,n,t,o,s,w){var h=0,_=0,B=0,m=0,X=0,Q=0,V=0,F=0,I=0,E=0,R=0,N=0,M=0,z=0,S=0,O=0,P=0,a=0,$=0,f0=0,A0=0,n0=0,_0=0,m0=0,X0=0,g0=0,I0=0,e0=0,r0=0,N0=0,U0=0,M0=0,H0=0,P0=0,K0=0,$0=0,L0=0,d0=0,n2=0,Z2=0,Q2=0,g2=0,p2=0,H2=0,T2=0,b2=0,e1=0;X=v-128|0,v=X;i:{e:{r:{if(h=i[A+140>>2],V=h+G(e,24)|0,R=i[A+152>>2],M=G(R,r),B=(V+G(M,24)|0)+4|0,E=f<<1,_0=l[B|0]>>>E&3,!_0)break r;if(e=G(e,k),F=i[A+148>>2],I=e>>F,(I|0)<0|(I|0)>=(R|0))break e;if(O=G(r,n),r=O>>F,(r|0)<0|(r|0)>=i[A+156>>2])break i;if(N=i[A+124>>2],m=i[N+(f?16840:16832)>>2],F=-1<<m^-1,P=i[(f?36:28)+A>>2],a=(P|0)<(n+O|0)?P-O|0:n,n0=i[(f?32:24)+A>>2],$=(n0|0)<(e+k|0)?n0-e|0:k,f0=f?i[N+16856>>2]-1|0:0,z=f?i[N+16852>>2]-1|0:0,k=l[(V+G(M,24)|0)+22|0],(_0|0)==2){if(M=i[A+132>>2],m=i[i[i[A+52>>2]+(C[((h+G(I,24)|0)+G(G(r,R),24)|0)+2>>1]<<2)>>2]+808>>2],n=i[N+16876>>2],R=i[N+16892>>2],I=l[B+1|0],r=B+(f<<2)|0,u[X|0]=l[r+5|0],f=l[r+6|0],u[X+2|0]=0,u[X+1|0]=f,u[X+3|0]=l[r+7|0],u[X+4|0]=l[r+8|0],(a|0)<=0|($|0)<=0)break r;for(r=(I>>>E&3)<<2,I0=i[r+62888>>2],P0=G(I0,o),e0=i[r+62904>>2],K0=G(e0,o),_0=i[r+62872>>2],r0=i[r+62856>>2],m0=n-z|0,N0=e>>m0,$0=a-1|0,L0=$-1|0,d0=e+s|0,n2=e+t|0,X0=n-f0|0,U0=G(R,O>>X0),t=0,Z2=k&1;;){for(r=t+O|0,s=r<<f0,B=r+I0|0,Q2=B<<f0,I=r+e0|0,g2=I<<f0,p2=G(r,w)+d0|0,H2=G(r,o)+n2|0,T2=G(R,I>>>X0|0)<<2,b2=G(R,B>>>X0|0)<<2,e1=(t|0)!=($0|0),k=0;;){f:{A:{if(!Z2){n=i[A+168>>2];break A}if(n=i[A+168>>2],!l[N+8812|0])break A;if(r=e+k<<z>>n,(r|0)<0||(h=i[A+172>>2],(h|0)<=(r|0)))break e;if(f=s>>n,(f|0)<0|(f|0)>=i[A+176>>2])break i;if(l[((i[A+160>>2]+G(r,3)|0)+G(G(f,h),3)|0)+1|0]&4)break f}if(Q=e+k|0,A0=Q<<z,r=A0>>n,(r|0)<0||(h=i[A+172>>2],(h|0)<=(r|0)))break e;if(f=s>>n,(f|0)<0|(f|0)>=i[A+176>>2])break i;if(l[((i[A+160>>2]+G(r,3)|0)+G(G(f,h),3)|0)+1|0]&8)break f;A:{if(!(!t|!k|(k|0)==(L0|0))&&e1)break A;if(h=Q+_0|0,(h|0)>=(n0|0)|(h|0)<0|((I|0)<0|(I|0)>=(P|0)))break f;if(r=i[A+148>>2],E=h<<z>>r,(E|0)<0||(f=i[A+152>>2],(f|0)<=(E|0)))break e;if(_=g2>>r,(_|0)<0||(V=i[A+156>>2],(V|0)<=(_|0)))break i;if(n=i[A+52>>2],M0=i[A+56>>2]-n>>2,S=G(E,24),E=i[A+140>>2],_=C[((S+E|0)+G(G(f,_),24)|0)+2>>1],M0>>>0<=_>>>0||(_=i[n+(_<<2)>>2],!_))break r;if(H0=i[_+808>>2],(m|0)>(H0|0)){if(S=A0>>r,(S|0)<0|f>>>0<=S>>>0)break e;if(g0=s>>r,(g0|0)<0|(V|0)<=(g0|0))break i;if(!l[i[n+(C[((E+G(S,24)|0)+G(G(f,g0),24)|0)+2>>1]<<2)>>2]+772|0])break f}if(!l[_+772|0]&(m|0)<(H0|0)||(S=l[M+57|0],!S&&(_=h>>>m0<<2,h=i[M+8484>>2],i[(_+h|0)+T2>>2]!=i[(h+(N0<<2)|0)+(U0<<2)>>2]))||(h=Q+r0|0,(h|0)>=(n0|0)|(h|0)<0|((B|0)<0|(B|0)>=(P|0))))break f;if(Q=h<<z>>r,(Q|0)<0|f>>>0<=Q>>>0)break e;if(_=Q2>>r,(_|0)<0|(_|0)>=(V|0))break i;if(Q=C[((E+G(Q,24)|0)+G(G(f,_),24)|0)+2>>1],Q>>>0>=M0>>>0||(Q=i[n+(Q<<2)>>2],!Q))break r;if(_=i[Q+808>>2],(_|0)<(m|0)){if(A0=A0>>r,(A0|0)<0|f>>>0<=A0>>>0)break e;if(r=s>>r,(r|0)<0|(r|0)>=(V|0))break i;if(!l[i[n+(C[((E+G(A0,24)|0)+G(G(r,f),24)|0)+2>>1]<<2)>>2]+772|0])break f}if(!l[Q+772|0]&(m|0)<(_|0))break f;if(S||(r=i[M+8484>>2],i[(r+(h>>>m0<<2)|0)+b2>>2]==i[(r+(N0<<2)|0)+(U0<<2)>>2]))break A;break f}f=k+H2|0,r=l[f|0],n=l[(f+_0|0)+K0|0],f=l[(f+r0|0)+P0|0],r=u[(((r>>>0>n>>>0)-(r>>>0<n>>>0)+((f>>>0<r>>>0)-(r>>>0<f>>>0))|0)+X|0)+2|0]+r|0,u[k+p2|0]=(r|0)>=0?(r|0)<(F|0)?r:F:0}if(k=k+1|0,($|0)==(k|0))break}if(t=t+1|0,(a|0)==(t|0))break}break r}if(r=l[(f+B|0)+2|0],o0(X,0,128),i[((r&31)<<2)+X>>2]=1,i[((r+1&31)<<2)+X>>2]=2,i[((r+2&31)<<2)+X>>2]=3,i[((r+3&31)<<2)+X>>2]=4,P=m-5|0,!(k&1)){if((a|0)<=0|($|0)<=0|(m|0)>12)break r;for(n=B+5|0,N=e+t|0,r=0;;){for(A=r+O|0,z=G(A,w)+s|0,A=G(A,o),B=A+t|0,f0=A+N|0,A=0;k=l[A+f0|0],k=i[((k>>>0<F>>>0?k:F)>>>P<<2)+X>>2],(k|0)>0&&(m=A+e|0,k=l[m+B|0]+u[(k+(n+(f<<2)|0)|0)-1|0]|0,u[m+z|0]=(k|0)>=0?(k|0)<(F|0)?k:F:0),A=A+1|0,($|0)>(A|0););if(r=r+1|0,!((a|0)>(r|0)))break}break r}if((a|0)<=0|($|0)<=0)break r;n0=B+5|0,B=0,M=(m|0)>12;f:{for(;;){r=B+O|0,R=r<<f0,I=G(r,w)+s|0,h=G(r,o)+t|0,r=0;A:{for(;;){n=i[A+168>>2],k=R>>n,m=e+r|0,n=m<<z>>n;k:{n:{if(l[N+8812|0]){if((n|0)<0||(V=i[A+172>>2],(V|0)<=(n|0)))break A;if((k|0)<0|(k|0)>=i[A+176>>2])break i;if(!(l[((i[A+160>>2]+G(n,3)|0)+G(G(k,V),3)|0)+1|0]&4))break n;break k}if((n|0)<0)break e}if(V=i[A+172>>2],(V|0)<=(n|0))break e;if((k|0)<0|(k|0)>=i[A+176>>2])break f;if(M|l[((i[A+160>>2]+G(n,3)|0)+G(G(k,V),3)|0)+1|0]&8||(k=l[h+m|0],n=i[((k>>>0<F>>>0?k:F)>>>P<<2)+X>>2],(n|0)<=0))break k;k=k+u[(n+(n0+(f<<2)|0)|0)-1|0]|0,u[m+I|0]=(k|0)>=0?(k|0)<(F|0)?k:F:0}if(r=r+1|0,!(($|0)>(r|0)))break}if(B=B+1|0,(a|0)<=(B|0))break r;continue}break}break e}break i}v=X+128|0;return}D0(4656,10893,118,4231),H()}D0(4618,10893,119,4231),H()}function LB(A,e){A=A|0,e=e|0;var r=0,f=0,k=0,n=0,t=0,o=0,s=0,w=0,h=0,_=0;_=v-16|0,v=_,i[_+12>>2]=0,i[_+4>>2]=0,i[_+8>>2]=0,k=_+4|0;i:{e:{if(w=i[e+64>>2],s=i[w+116>>2],h=i[w+120>>2],(s|0)!=(h|0))for(;;){n=i[s+4>>2]-i[s>>2]>>>24|0,e=i[k+4>>2],f=i[k+8>>2];r:{if(e>>>0<f>>>0){u[e|0]=n,e=e+1|0;break r}if(t=i[k>>2],e=e-t|0,r=e+1|0,(r|0)<0)break e;if(f=f-t|0,o=f<<1,f=f>>>0>=1073741823?2147483647:r>>>0<o>>>0?o:r,f?r=p(f):r=0,o=r+e|0,u[o|0]=n,e&&x(r,t,e),i[k+8>>2]=r+f,e=o+1|0,i[k+4>>2]=e,i[k>>2]=r,!t)break r;Z(t)}i[k+4>>2]=e,n=i[s+4>>2]-i[s>>2]>>>16|0,f=i[k+8>>2];r:{if(f>>>0>e>>>0){u[e|0]=n,e=e+1|0;break r}if(t=i[k>>2],e=e-t|0,r=e+1|0,(r|0)<0)break e;if(f=f-t|0,o=f<<1,f=f>>>0>=1073741823?2147483647:r>>>0<o>>>0?o:r,f?r=p(f):r=0,o=r+e|0,u[o|0]=n,e&&x(r,t,e),i[k+8>>2]=r+f,e=o+1|0,i[k+4>>2]=e,i[k>>2]=r,!t)break r;Z(t)}i[k+4>>2]=e,n=i[s+4>>2]-i[s>>2]>>>8|0,f=i[k+8>>2];r:{if(f>>>0>e>>>0){u[e|0]=n,e=e+1|0;break r}if(t=i[k>>2],e=e-t|0,r=e+1|0,(r|0)<0)break e;if(f=f-t|0,o=f<<1,f=f>>>0>=1073741823?2147483647:r>>>0<o>>>0?o:r,f?r=p(f):r=0,o=r+e|0,u[o|0]=n,e&&x(r,t,e),i[k+8>>2]=r+f,e=o+1|0,i[k+4>>2]=e,i[k>>2]=r,!t)break r;Z(t)}i[k+4>>2]=e,n=i[s+4>>2]-i[s>>2]|0,f=i[k+8>>2];r:{if(f>>>0>e>>>0){u[e|0]=n,e=e+1|0;break r}if(t=i[k>>2],e=e-t|0,r=e+1|0,(r|0)<0)break e;if(f=f-t|0,o=f<<1,f=f>>>0>=1073741823?2147483647:r>>>0<o>>>0?o:r,f?r=p(f):r=0,o=r+e|0,u[o|0]=n,e&&x(r,t,e),i[k+8>>2]=r+f,e=o+1|0,i[k+4>>2]=e,i[k>>2]=r,!t)break r;Z(t)}if(i[k+4>>2]=e,n=e,e=i[s>>2],r=i[s+4>>2],$4(k,n,e,r,r-e|0),s=s+12|0,(h|0)==(s|0))break}if(s=i[w+140>>2],h=i[w+144>>2],(s|0)!=(h|0))for(;;){n=i[s+4>>2]-i[s>>2]>>>24|0,e=i[k+4>>2],f=i[k+8>>2];r:{if(e>>>0<f>>>0){u[e|0]=n,e=e+1|0;break r}if(t=i[k>>2],e=e-t|0,r=e+1|0,(r|0)<0)break e;if(f=f-t|0,o=f<<1,f=f>>>0>=1073741823?2147483647:r>>>0<o>>>0?o:r,f?r=p(f):r=0,o=r+e|0,u[o|0]=n,e&&x(r,t,e),i[k+8>>2]=r+f,e=o+1|0,i[k+4>>2]=e,i[k>>2]=r,!t)break r;Z(t)}i[k+4>>2]=e,n=i[s+4>>2]-i[s>>2]>>>16|0,f=i[k+8>>2];r:{if(f>>>0>e>>>0){u[e|0]=n,e=e+1|0;break r}if(t=i[k>>2],e=e-t|0,r=e+1|0,(r|0)<0)break e;if(f=f-t|0,o=f<<1,f=f>>>0>=1073741823?2147483647:r>>>0<o>>>0?o:r,f?r=p(f):r=0,o=r+e|0,u[o|0]=n,e&&x(r,t,e),i[k+8>>2]=r+f,e=o+1|0,i[k+4>>2]=e,i[k>>2]=r,!t)break r;Z(t)}i[k+4>>2]=e,n=i[s+4>>2]-i[s>>2]>>>8|0,f=i[k+8>>2];r:{if(f>>>0>e>>>0){u[e|0]=n,e=e+1|0;break r}if(t=i[k>>2],e=e-t|0,r=e+1|0,(r|0)<0)break e;if(f=f-t|0,o=f<<1,f=f>>>0>=1073741823?2147483647:r>>>0<o>>>0?o:r,f?r=p(f):r=0,o=r+e|0,u[o|0]=n,e&&x(r,t,e),i[k+8>>2]=r+f,e=o+1|0,i[k+4>>2]=e,i[k>>2]=r,!t)break r;Z(t)}i[k+4>>2]=e,n=i[s+4>>2]-i[s>>2]|0,f=i[k+8>>2];r:{if(f>>>0>e>>>0){u[e|0]=n,e=e+1|0;break r}if(t=i[k>>2],e=e-t|0,r=e+1|0,(r|0)<0)break e;if(f=f-t|0,o=f<<1,f=f>>>0>=1073741823?2147483647:r>>>0<o>>>0?o:r,f?r=p(f):r=0,o=r+e|0,u[o|0]=n,e&&x(r,t,e),i[k+8>>2]=r+f,e=o+1|0,i[k+4>>2]=e,i[k>>2]=r,!t)break r;Z(t)}if(i[k+4>>2]=e,n=e,e=i[s>>2],r=i[s+4>>2],$4(k,n,e,r,r-e|0),s=s+12|0,(h|0)==(s|0))break}if(s=i[w+128>>2],f=i[w+132>>2],(s|0)!=(f|0))for(;;){t=i[s+4>>2]-i[s>>2]>>>24|0,e=i[k+4>>2],n=i[k+8>>2];r:{if(e>>>0<n>>>0){u[e|0]=t,e=e+1|0;break r}if(w=i[k>>2],e=e-w|0,r=e+1|0,(r|0)<0)break e;if(n=n-w|0,h=n<<1,n=n>>>0>=1073741823?2147483647:r>>>0<h>>>0?h:r,n?r=p(n):r=0,h=r+e|0,u[h|0]=t,e&&x(r,w,e),i[k+8>>2]=r+n,e=h+1|0,i[k+4>>2]=e,i[k>>2]=r,!w)break r;Z(w)}i[k+4>>2]=e,t=i[s+4>>2]-i[s>>2]>>>16|0,n=i[k+8>>2];r:{if(n>>>0>e>>>0){u[e|0]=t,e=e+1|0;break r}if(w=i[k>>2],e=e-w|0,r=e+1|0,(r|0)<0)break e;if(n=n-w|0,h=n<<1,n=n>>>0>=1073741823?2147483647:r>>>0<h>>>0?h:r,n?r=p(n):r=0,h=r+e|0,u[h|0]=t,e&&x(r,w,e),i[k+8>>2]=r+n,e=h+1|0,i[k+4>>2]=e,i[k>>2]=r,!w)break r;Z(w)}i[k+4>>2]=e,t=i[s+4>>2]-i[s>>2]>>>8|0,n=i[k+8>>2];r:{if(n>>>0>e>>>0){u[e|0]=t,e=e+1|0;break r}if(w=i[k>>2],e=e-w|0,r=e+1|0,(r|0)<0)break e;if(n=n-w|0,h=n<<1,n=n>>>0>=1073741823?2147483647:r>>>0<h>>>0?h:r,n?r=p(n):r=0,h=r+e|0,u[h|0]=t,e&&x(r,w,e),i[k+8>>2]=r+n,e=h+1|0,i[k+4>>2]=e,i[k>>2]=r,!w)break r;Z(w)}i[k+4>>2]=e,t=i[s+4>>2]-i[s>>2]|0,n=i[k+8>>2];r:{if(n>>>0>e>>>0){u[e|0]=t,e=e+1|0;break r}if(w=i[k>>2],e=e-w|0,r=e+1|0,(r|0)<0)break e;if(n=n-w|0,h=n<<1,n=n>>>0>=1073741823?2147483647:r>>>0<h>>>0?h:r,n?r=p(n):r=0,h=r+e|0,u[h|0]=t,e&&x(r,w,e),i[k+8>>2]=r+n,e=h+1|0,i[k+4>>2]=e,i[k>>2]=r,!w)break r;Z(w)}if(i[k+4>>2]=e,n=e,e=i[s>>2],r=i[s+4>>2],$4(k,n,e,r,r-e|0),s=s+12|0,(f|0)==(s|0))break}break i}G0(),H()}e=i[_+8>>2],r=i[_+4>>2],k=i[_+12>>2],u[A+20|0]=0,i[A+8>>2]=k,i[A>>2]=r,i[A+4>>2]=e,v=_+16|0}function KB(A,e,r,f,k,n,t,o){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,t=t|0,o=o|0;var s=0,w=0,h=0,_=0,B=0,m=0,X=0,Q=0,V=0,F=0,I=0,E=0,R=0,N=0,M=0,z=0,S=0,O=0,P=0,a=0,$=0,f0=0,A0=0,n0=0;w=v-112|0,v=w,e=i[r>>2],i[w+92>>2]=e,s=i[r+4>>2],i[w+96>>2]=s,s&&(i[s+4>>2]=i[s+4>>2]+1),s=i[t+20>>2],i[w+80>>2]=i[t+16>>2],i[w+84>>2]=s,s=i[t+12>>2],i[w+72>>2]=i[t+8>>2],i[w+76>>2]=s,s=i[t+4>>2],i[w+64>>2]=i[t>>2],i[w+68>>2]=s,i[w+68>>2]=0;i:{e:{r:{if(i[t+4>>2]){AA(w+40|0,w+92|0,1,f+16|0,i[f+12>>2],n,w- -64|0,o),B=l[w+60|0];f:{if(B){if((B|0)!=1)break r;e=i[w+44>>2],i[A>>2]=i[w+40>>2],i[A+4>>2]=e,s=A+8|0;A:{if(u[w+59|0]>=0){e=i[w+52>>2],i[s>>2]=i[w+48>>2],i[s+4>>2]=e,i[s+8>>2]=i[w+56>>2];break A}T(s,i[w+48>>2],i[w+52>>2])}u[A+20|0]=1;break f}if(e=i[w+40>>2],s=i[w+44>>2],s&&(i[s+4>>2]=i[s+4>>2]+1),i[w+92>>2]=e,Q=i[w+96>>2],i[w+96>>2]=s,!Q||(e=i[Q+4>>2],i[Q+4>>2]=e-1,e))break f;W[i[i[Q>>2]+8>>2]](Q),y(Q)}if(s=l[w+60|0],(s|0)!=255&&(e=i[26085],i[w+104>>2]=i[26084],i[w+108>>2]=e,W[i[(w+104|0)+(s<<2)>>2]](w+32|0,w+40|0)),B)break i;e=i[w+92>>2]}for(I=i[e+112>>2],V=i[e+108>>2],s=p(172),i[s>>2]=94812,i[s+4>>2]=0,i[s+8>>2]=0,o0(s+16|0,0,80),i[s+104>>2]=0,i[s+108>>2]=0,i[s+36>>2]=1,i[s+40>>2]=1,u[s+24|0]=1,g[s+22>>1]=2,g[s+18>>1]=2,g[s+20>>1]=2,i[s+112>>2]=0,i[s+116>>2]=4740,i[s+140>>2]=0,i[s+144>>2]=0,i[s+128>>2]=99,i[s+132>>2]=99,i[s+120>>2]=0,i[s+124>>2]=0,i[s+12>>2]=95160,i[s+148>>2]=0,i[s+152>>2]=0,i[s+136>>2]=s+140,i[s+156>>2]=0,i[s+160>>2]=0,i[s+164>>2]=0,i[s+168>>2]=0,i[w+36>>2]=s,e=s+12|0,i[w+32>>2]=e,i[s+96>>2]=e,i[s+8>>2]=i[s+8>>2]+1,i[s+100>>2]=s,i[s+4>>2]==-1&&(W[i[i[s>>2]+8>>2]](s),y(s)),s=i[w+92>>2],e=i[s+116>>2],P=i[w+32>>2],B=P,i[B+120>>2]=i[s+120>>2],i[B+116>>2]=e,i[B+112>>2]=I,i[B+108>>2]=V,i[w+48>>2]=5,i[w+40>>2]=3,i[w+44>>2]=4,A0=V&-2,n0=V&1,f0=B+128|0;;){m=i[(w+40|0)+a>>2],T0(w+12|0,P,m,V,I,i[k+12>>2],o),u[w+31|0]<0&&Z(i[w+20>>2]),$=0,_=i[w+92>>2],B=_+128|0,e=B;f:{A:{if(h=i[_+128>>2],!h)break A;for(;s=i[h+16>>2]<6,e=s?e:h,h=i[(s?4:0)+h>>2],!!h;);if((e|0)==(B|0))break A;if(S=0,Q=0,i[e+16>>2]>6)break f;S=i[e+44>>2],Q=i[e+56>>2];break f}S=0,Q=0}E=j0(_,6),X=i[w+92>>2],_=X+128|0,e=_,h=i[X+128>>2],B=0;f:{if(!h)break f;for(;s=(m|0)>i[h+16>>2],e=s?e:h,h=i[(s?4:0)+h>>2],!!h;);if((e|0)==(_|0)){B=0;break f}if(B=0,(m|0)<i[e+16>>2])break f;$=i[e+56>>2],B=i[e+44>>2]}_=-1<<E;f:{A:{if(e=f0,h=i[e>>2],!h)break A;for(;s=(m|0)>i[h+16>>2],e=s?e:h,h=i[(s?4:0)+h>>2],!!h;);if((e|0)==(f0|0))break A;if(O=0,s=0,(m|0)<i[e+16>>2])break f;O=i[e+44>>2],s=i[e+56>>2];break f}O=0,s=0}F=_^-1;f:{A:{k:switch(i[t+4>>2]-1|0){case 1:if(C[t+20>>1])break A;break;case 0:break k;default:break A}e=0;k:{n:switch(m-3|0){case 0:e=C[t+8>>1];break k;case 1:e=C[t+10>>1];break k;case 2:break n;default:break k}e=C[t+12>>1]}if(_=j0(X,m),!I|!V)break f;for(R=(e&65535)>>>16-_&255,N=F&255,e=0;;){if(M=G(e,s)+O|0,z=G(e,$)+B|0,m=G(e,Q)+S|0,h=0,F=0,(V|0)!=1)for(;_=l[h+m|0],u[h+M|0]=G(_,l[h+z|0])+G(R,N-_|0)>>E,X=h|1,_=l[X+m|0],u[X+M|0]=G(_,l[X+z|0])+G(R,N-_|0)>>E,h=h+2|0,F=F+2|0,(A0|0)!=(F|0););if(n0&&(_=l[h+m|0],u[h+M|0]=G(_,l[h+z|0])+G(R,N-_|0)>>E),e=e+1|0,(I|0)==(e|0))break}break f}e=0,h=0;A:{k:switch(m-3|0){case 0:h=C[t+14>>1],e=C[t+8>>1];break A;case 1:h=C[t+16>>1],e=C[t+10>>1];break A;case 2:break k;default:break A}h=C[t+18>>1],e=C[t+12>>1]}if(X=j0(X,m),_=j0(i[w+92>>2],m),!I|!V)break f;for(R=(e&65535)>>>16-X|0,N=h>>>16-_|0,M=F&255,e=0;;){for(z=G(e,s)+O|0,m=G(e,$)+B|0,F=G(e,Q)+S|0,h=0;X=l[h+F|0],_=C[t+20>>1],u[h+z|0]=G(M-X|0,(((e>>>0)/(_>>>0)|0)+((h>>>0)/(_>>>0)|0)&1?R:N)&255)+G(X,l[h+m|0])>>E,h=h+1|0,(V|0)!=(h|0););if(e=e+1|0,(I|0)==(e|0))break}}if(a=a+4|0,(a|0)==12)break}if(!i[t+4>>2])break e;e=i[r>>2],r6(w+40|0,w+32|0,i[e+116>>2],i[e+120>>2],f+16|0,i[f+12>>2],n,w- -64|0,o);f:{A:switch(l[w+60|0]){case 1:e=i[w+44>>2],i[A>>2]=i[w+40>>2],i[A+4>>2]=e,r=A+8|0;k:{if(u[w+59|0]>=0){e=i[w+52>>2],i[r>>2]=i[w+48>>2],i[r+4>>2]=e,i[r+8>>2]=i[w+56>>2];break k}T(r,i[w+48>>2],i[w+52>>2])}u[A+20|0]=1;break f;case 0:break A;default:break r}u[A+20|0]=255,u[A|0]=0,i[w+104>>2]=A,W[i[26088]](w+104|0,w+40|0),u[A+20|0]=0}if(e=l[w+60|0],(e|0)!=255&&(A=i[26087],i[w+104>>2]=i[26086],i[w+108>>2]=A,W[i[(w+104|0)+(e<<2)>>2]](w+103|0,w+40|0)),e=i[w+36>>2],!e||(A=i[e+4>>2],i[e+4>>2]=A-1,A))break i;W[i[i[e>>2]+8>>2]](e),y(e);break i}_2(),H()}e=i[w+36>>2],u[A+20|0]=0,i[A+4>>2]=e,i[A>>2]=P}e=i[w+96>>2];i:{if(!e||(A=i[e+4>>2],i[e+4>>2]=A-1,A))break i;W[i[i[e>>2]+8>>2]](e),y(e)}v=w+112|0}function i9(A){var e=0,r=0,f=0,k=0,n=0,t=0,o=0;k=v-16|0,v=k,i[k+12>>2]=A;i:{if(A>>>0<=211){A=i[lo(70432,70624,k+12|0)>>2];break i}for(A>>>0>=4294967292&&(g1(),H()),n=(A>>>0)/210|0,f=G(n,210),i[k+8>>2]=A-f,t=lo(70624,70816,k+8|0)-70624>>2;;){A=i[(t<<2)+70624>>2]+f|0,f=5;e:{r:{for(;;){if(r=f,(r|0)==47)break r;if(o=i[(r<<2)+70432>>2],e=(A>>>0)/(o>>>0)|0,e>>>0<o>>>0)break i;if(f=r+1|0,(G(e,o)|0)==(A|0))break}if(r>>>0<47)break e}for(f=211;;){if(r=(A>>>0)/(f>>>0)|0,r>>>0<f>>>0)break i;if((G(r,f)|0)==(A|0))break e;if(e=f+10|0,r=(A>>>0)/(e>>>0)|0,r>>>0<e>>>0)break i;if((G(r,e)|0)==(A|0))break e;if(e=f+12|0,r=(A>>>0)/(e>>>0)|0,r>>>0<e>>>0)break i;if((G(r,e)|0)==(A|0))break e;if(e=f+16|0,r=(A>>>0)/(e>>>0)|0,r>>>0<e>>>0)break i;if((G(r,e)|0)==(A|0))break e;if(e=f+18|0,r=(A>>>0)/(e>>>0)|0,r>>>0<e>>>0)break i;if((G(r,e)|0)==(A|0))break e;if(e=f+22|0,r=(A>>>0)/(e>>>0)|0,r>>>0<e>>>0)break i;if((G(r,e)|0)==(A|0))break e;if(e=f+28|0,r=(A>>>0)/(e>>>0)|0,r>>>0<e>>>0)break i;if((G(r,e)|0)==(A|0))break e;if(e=f+30|0,r=(A>>>0)/(e>>>0)|0,r>>>0<e>>>0)break i;if((G(r,e)|0)==(A|0))break e;if(e=f+36|0,r=(A>>>0)/(e>>>0)|0,r>>>0<e>>>0)break i;if((G(r,e)|0)==(A|0))break e;if(e=f+40|0,r=(A>>>0)/(e>>>0)|0,r>>>0<e>>>0)break i;if((G(r,e)|0)==(A|0))break e;if(e=f+42|0,r=(A>>>0)/(e>>>0)|0,r>>>0<e>>>0)break i;if((G(r,e)|0)==(A|0))break e;if(e=f+46|0,r=(A>>>0)/(e>>>0)|0,r>>>0<e>>>0)break i;if((G(r,e)|0)==(A|0))break e;if(e=f+52|0,r=(A>>>0)/(e>>>0)|0,r>>>0<e>>>0)break i;if((G(r,e)|0)==(A|0))break e;if(e=f+58|0,r=(A>>>0)/(e>>>0)|0,r>>>0<e>>>0)break i;if((G(r,e)|0)==(A|0))break e;if(e=f+60|0,r=(A>>>0)/(e>>>0)|0,r>>>0<e>>>0)break i;if((G(r,e)|0)==(A|0))break e;if(e=f+66|0,r=(A>>>0)/(e>>>0)|0,r>>>0<e>>>0)break i;if((G(r,e)|0)==(A|0))break e;if(e=f+70|0,r=(A>>>0)/(e>>>0)|0,r>>>0<e>>>0)break i;if((G(r,e)|0)==(A|0))break e;if(e=f+72|0,r=(A>>>0)/(e>>>0)|0,r>>>0<e>>>0)break i;if((G(r,e)|0)==(A|0))break e;if(e=f+78|0,r=(A>>>0)/(e>>>0)|0,r>>>0<e>>>0)break i;if((G(r,e)|0)==(A|0))break e;if(e=f+82|0,r=(A>>>0)/(e>>>0)|0,r>>>0<e>>>0)break i;if((G(r,e)|0)==(A|0))break e;if(e=f+88|0,r=(A>>>0)/(e>>>0)|0,r>>>0<e>>>0)break i;if((G(r,e)|0)==(A|0))break e;if(e=f+96|0,r=(A>>>0)/(e>>>0)|0,r>>>0<e>>>0)break i;if((G(r,e)|0)==(A|0))break e;if(e=f+100|0,r=(A>>>0)/(e>>>0)|0,r>>>0<e>>>0)break i;if((G(r,e)|0)==(A|0))break e;if(e=f+102|0,r=(A>>>0)/(e>>>0)|0,r>>>0<e>>>0)break i;if((G(r,e)|0)==(A|0))break e;if(e=f+106|0,r=(A>>>0)/(e>>>0)|0,r>>>0<e>>>0)break i;if((G(r,e)|0)==(A|0))break e;if(e=f+108|0,r=(A>>>0)/(e>>>0)|0,r>>>0<e>>>0)break i;if((G(r,e)|0)==(A|0))break e;if(e=f+112|0,r=(A>>>0)/(e>>>0)|0,r>>>0<e>>>0)break i;if((G(r,e)|0)==(A|0))break e;if(e=f+120|0,r=(A>>>0)/(e>>>0)|0,r>>>0<e>>>0)break i;if((G(r,e)|0)==(A|0))break e;if(e=f+126|0,r=(A>>>0)/(e>>>0)|0,r>>>0<e>>>0)break i;if((G(r,e)|0)==(A|0))break e;if(e=f+130|0,r=(A>>>0)/(e>>>0)|0,r>>>0<e>>>0)break i;if((G(r,e)|0)==(A|0))break e;if(e=f+136|0,r=(A>>>0)/(e>>>0)|0,r>>>0<e>>>0)break i;if((G(r,e)|0)==(A|0))break e;if(e=f+138|0,r=(A>>>0)/(e>>>0)|0,r>>>0<e>>>0)break i;if((G(r,e)|0)==(A|0))break e;if(e=f+142|0,r=(A>>>0)/(e>>>0)|0,r>>>0<e>>>0)break i;if((G(r,e)|0)==(A|0))break e;if(e=f+148|0,r=(A>>>0)/(e>>>0)|0,r>>>0<e>>>0)break i;if((G(r,e)|0)==(A|0))break e;if(e=f+150|0,r=(A>>>0)/(e>>>0)|0,r>>>0<e>>>0)break i;if((G(r,e)|0)==(A|0))break e;if(e=f+156|0,r=(A>>>0)/(e>>>0)|0,r>>>0<e>>>0)break i;if((G(r,e)|0)==(A|0))break e;if(e=f+162|0,r=(A>>>0)/(e>>>0)|0,r>>>0<e>>>0)break i;if((G(r,e)|0)==(A|0))break e;if(e=f+166|0,r=(A>>>0)/(e>>>0)|0,r>>>0<e>>>0)break i;if((G(r,e)|0)==(A|0))break e;if(e=f+168|0,r=(A>>>0)/(e>>>0)|0,r>>>0<e>>>0)break i;if((G(r,e)|0)==(A|0))break e;if(e=f+172|0,r=(A>>>0)/(e>>>0)|0,r>>>0<e>>>0)break i;if((G(r,e)|0)==(A|0))break e;if(e=f+178|0,r=(A>>>0)/(e>>>0)|0,r>>>0<e>>>0)break i;if((G(r,e)|0)==(A|0))break e;if(e=f+180|0,r=(A>>>0)/(e>>>0)|0,r>>>0<e>>>0)break i;if((G(r,e)|0)==(A|0))break e;if(e=f+186|0,r=(A>>>0)/(e>>>0)|0,r>>>0<e>>>0)break i;if((G(r,e)|0)==(A|0))break e;if(e=f+190|0,r=(A>>>0)/(e>>>0)|0,r>>>0<e>>>0)break i;if((G(r,e)|0)==(A|0))break e;if(e=f+192|0,r=(A>>>0)/(e>>>0)|0,r>>>0<e>>>0)break i;if((G(r,e)|0)==(A|0))break e;if(e=f+196|0,r=(A>>>0)/(e>>>0)|0,r>>>0<e>>>0)break i;if((G(r,e)|0)==(A|0))break e;if(e=f+198|0,r=(A>>>0)/(e>>>0)|0,r>>>0<e>>>0)break i;if((G(r,e)|0)==(A|0))break e;if(e=f+208|0,r=(A>>>0)/(e>>>0)|0,r>>>0<e>>>0)break i;if(f=f+210|0,(G(r,e)|0)==(A|0))break}}A=t+1|0,r=(A|0)==48,t=r?0:A,n=r+n|0,f=G(n,210)}}return v=k+16|0,A}function qB(A,e,r,f,k,n){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0;var t=0,o=0,s=0,w=0,h=0;n=v+-64|0,v=n,w9(n+40|0,e,f);i:{e:{r:{f:{if(i[n+40>>2]){e=i[n+44>>2],i[A>>2]=i[n+40>>2],i[A+4>>2]=e,i[A+16>>2]=i[n+56>>2],e=i[n+52>>2],i[A+8>>2]=i[n+48>>2],i[A+12>>2]=e,i[n+56>>2]=0,i[n+48>>2]=0,i[n+52>>2]=0;break f}o=e+60|0;A:{if(i[e+60>>2])break A;if(t=i[e+56>>2],s=i[t+20>>2],!s){if(e=p(48),i[n>>2]=e,i[n+4>>2]=42,i[n+8>>2]=-2147483600,r=l[24358]|l[24359]<<8|(l[24360]<<16|l[24361]<<24),f=l[24354]|l[24355]<<8|(l[24356]<<16|l[24357]<<24),u[e|0]=f,u[e+1|0]=f>>>8,u[e+2|0]=f>>>16,u[e+3|0]=f>>>24,u[e+4|0]=r,u[e+5|0]=r>>>8,u[e+6|0]=r>>>16,u[e+7|0]=r>>>24,u[e+42|0]=0,r=l[24394]|l[24395]<<8,u[e+40|0]=r,u[e+41|0]=r>>>8,r=l[24390]|l[24391]<<8|(l[24392]<<16|l[24393]<<24),f=l[24386]|l[24387]<<8|(l[24388]<<16|l[24389]<<24),u[e+32|0]=f,u[e+33|0]=f>>>8,u[e+34|0]=f>>>16,u[e+35|0]=f>>>24,u[e+36|0]=r,u[e+37|0]=r>>>8,u[e+38|0]=r>>>16,u[e+39|0]=r>>>24,r=l[24382]|l[24383]<<8|(l[24384]<<16|l[24385]<<24),f=l[24378]|l[24379]<<8|(l[24380]<<16|l[24381]<<24),u[e+24|0]=f,u[e+25|0]=f>>>8,u[e+26|0]=f>>>16,u[e+27|0]=f>>>24,u[e+28|0]=r,u[e+29|0]=r>>>8,u[e+30|0]=r>>>16,u[e+31|0]=r>>>24,r=l[24374]|l[24375]<<8|(l[24376]<<16|l[24377]<<24),f=l[24370]|l[24371]<<8|(l[24372]<<16|l[24373]<<24),u[e+16|0]=f,u[e+17|0]=f>>>8,u[e+18|0]=f>>>16,u[e+19|0]=f>>>24,u[e+20|0]=r,u[e+21|0]=r>>>8,u[e+22|0]=r>>>16,u[e+23|0]=r>>>24,r=l[24366]|l[24367]<<8|(l[24368]<<16|l[24369]<<24),f=l[24362]|l[24363]<<8|(l[24364]<<16|l[24365]<<24),u[e+8|0]=f,u[e+9|0]=f>>>8,u[e+10|0]=f>>>16,u[e+11|0]=f>>>24,u[e+12|0]=r,u[e+13|0]=r>>>8,u[e+14|0]=r>>>16,u[e+15|0]=r>>>24,q(A,11,6003,n),u[n+11|0]>=0)break f;Z(i[n>>2]);break f}if(i[t>>2]>=5){if(w=n,h=W[i[i[e>>2]+8>>2]](e)|0,i[w>>2]=h,i[n+8>>2]=i[f+64>>2],i[n+4>>2]=l[f+21|0],W[i[i[e+56>>2]+56>>2]](n+24|0,o,n),t=i[n+24>>2],!t)break A;if(r=i[n+28>>2],k=i[n+32>>2],e=h2(k),e>>>0>=2147483640)break r;k:{n:{if(e>>>0>=11){o=e|7,f=p(o+1|0),i[n+32>>2]=o-2147483647,i[n+24>>2]=f,i[n+28>>2]=e;break n}if(u[n+35|0]=e,f=n+24|0,!e)break k}if(!e)break k;x(f,k,e)}if(u[e+f|0]=0,q(A,t,r,n+24|0),u[n+35|0]>=0)break f;Z(i[n+24>>2]);break f}if(W[s|0](n,o),t=i[n>>2],t){if(r=i[n+4>>2],k=i[n+8>>2],e=h2(k),e>>>0>=2147483640)break e;k:{n:{if(e>>>0>=11){o=e|7,f=p(o+1|0),i[n+8>>2]=o-2147483647,i[n>>2]=f,i[n+4>>2]=e;break n}if(u[n+11|0]=e,f=n,!e)break k}if(!e)break k;x(f,k,e)}if(u[e+f|0]=0,q(A,t,r,n),u[n+11|0]>=0)break f;Z(i[n>>2]);break f}if(t=i[e+56>>2],i[t>>2]<2||(t=i[t+36>>2],!t))break A;W[t|0](i[o>>2],l[f+21|0])}Br(n,e,r);A:{k:switch(l[n+20|0]){default:_2(),H();case 1:if(e=i[n+4>>2],i[A>>2]=i[n>>2],i[A+4>>2]=e,A=A+8|0,u[n+19|0]>=0){e=i[n+12>>2],i[A>>2]=i[n+8>>2],i[A+4>>2]=e,i[A+8>>2]=i[n+16>>2];break A}T(A,i[n+8>>2],i[n+12>>2]);break A;case 0:break k}if(f=i[n+4>>2],r=i[n>>2],(f|0)==(r|0)){if(e=p(32),i[n+24>>2]=e,i[n+28>>2]=29,i[n+32>>2]=-2147483616,r=l[23321]|l[23322]<<8|(l[23323]<<16|l[23324]<<24),f=l[23317]|l[23318]<<8|(l[23319]<<16|l[23320]<<24),u[e|0]=f,u[e+1|0]=f>>>8,u[e+2|0]=f>>>16,u[e+3|0]=f>>>24,u[e+4|0]=r,u[e+5|0]=r>>>8,u[e+6|0]=r>>>16,u[e+7|0]=r>>>24,u[e+29|0]=0,r=l[23342]|l[23343]<<8|(l[23344]<<16|l[23345]<<24),f=l[23338]|l[23339]<<8|(l[23340]<<16|l[23341]<<24),u[e+21|0]=f,u[e+22|0]=f>>>8,u[e+23|0]=f>>>16,u[e+24|0]=f>>>24,u[e+25|0]=r,u[e+26|0]=r>>>8,u[e+27|0]=r>>>16,u[e+28|0]=r>>>24,r=l[23337]|l[23338]<<8|(l[23339]<<16|l[23340]<<24),f=l[23333]|l[23334]<<8|(l[23335]<<16|l[23336]<<24),u[e+16|0]=f,u[e+17|0]=f>>>8,u[e+18|0]=f>>>16,u[e+19|0]=f>>>24,u[e+20|0]=r,u[e+21|0]=r>>>8,u[e+22|0]=r>>>16,u[e+23|0]=r>>>24,r=l[23329]|l[23330]<<8|(l[23331]<<16|l[23332]<<24),f=l[23325]|l[23326]<<8|(l[23327]<<16|l[23328]<<24),u[e+8|0]=f,u[e+9|0]=f>>>8,u[e+10|0]=f>>>16,u[e+11|0]=f>>>24,u[e+12|0]=r,u[e+13|0]=r>>>8,u[e+14|0]=r>>>16,u[e+15|0]=r>>>24,q(A,2,0,n+24|0),u[n+35|0]>=0)break A;Z(i[n+24>>2]);break A}f=f-r|0;k:{n:{if(e=i[e+56>>2],i[e>>2]<5||(t=i[e+60>>2],!t))break n;W[t|0](n+24|0,i[o>>2],r,f,k);break k}W[i[e+28>>2]](n+24|0,i[o>>2],r,f)}if(f=i[n+32>>2],k=i[n+28>>2],o=i[n+24>>2],o){if(e=h2(f),e>>>0>=2147483640)break i;k:{n:{if(e>>>0>=11){t=e|7,r=p(t+1|0),i[n+32>>2]=t-2147483647,i[n+24>>2]=r,i[n+28>>2]=e;break n}if(u[n+35|0]=e,r=n+24|0,!e)break k}if(!e)break k;x(r,f,e)}if(u[e+r|0]=0,q(A,o,k,n+24|0),u[n+35|0]>=0)break A;Z(i[n+24>>2]);break A}i[A>>2]=0,i[A+4>>2]=0,i[A+16>>2]=0,i[A+8>>2]=0,i[A+12>>2]=0}if(A=l[n+20|0],(A|0)==255)break f;e=i[24261],i[n+24>>2]=i[24260],i[n+28>>2]=e,W[i[(n+24|0)+(A<<2)>>2]](n+63|0,n)}u[n+59|0]<0&&Z(i[n+48>>2]),v=n- -64|0;return}Q0(),H()}Q0(),H()}Q0(),H()}function Ar(A,e,r){var f=0,k=0,n=0,t=0,o=0,s=0,w=0,h=0,_=0,B=0,m=0,X=0,Q=0,V=0,F=0,I=0,E=0,R=0,N=0,M=0,z=0,S=0,O=0,P=0,a=0,$=0;for(_=i[A+20>>2],h=i[A+16>>2],w=i[A+12>>2],a=i[A+8>>2];s=l[e|0]|l[e+1|0]<<8|(l[e+2|0]<<16|l[e+3|0]<<24),i[A+88>>2]=s,B=l[e+4|0]|l[e+5|0]<<8|(l[e+6|0]<<16|l[e+7|0]<<24),i[A+92>>2]=B,m=l[e+8|0]|l[e+9|0]<<8|(l[e+10|0]<<16|l[e+11|0]<<24),i[A+96>>2]=m,X=l[e+12|0]|l[e+13|0]<<8|(l[e+14|0]<<16|l[e+15|0]<<24),i[A+100>>2]=X,Q=l[e+16|0]|l[e+17|0]<<8|(l[e+18|0]<<16|l[e+19|0]<<24),i[A+104>>2]=Q,V=l[e+20|0]|l[e+21|0]<<8|(l[e+22|0]<<16|l[e+23|0]<<24),i[A+108>>2]=V,F=l[e+24|0]|l[e+25|0]<<8|(l[e+26|0]<<16|l[e+27|0]<<24),i[A+112>>2]=F,I=l[e+28|0]|l[e+29|0]<<8|(l[e+30|0]<<16|l[e+31|0]<<24),i[A+116>>2]=I,E=l[e+32|0]|l[e+33|0]<<8|(l[e+34|0]<<16|l[e+35|0]<<24),i[A+120>>2]=E,R=l[e+36|0]|l[e+37|0]<<8|(l[e+38|0]<<16|l[e+39|0]<<24),i[A+124>>2]=R,N=l[e+40|0]|l[e+41|0]<<8|(l[e+42|0]<<16|l[e+43|0]<<24),i[A+128>>2]=N,M=l[e+44|0]|l[e+45|0]<<8|(l[e+46|0]<<16|l[e+47|0]<<24),i[A+132>>2]=M,z=l[e+48|0]|l[e+49|0]<<8|(l[e+50|0]<<16|l[e+51|0]<<24),i[A+136>>2]=z,S=l[e+52|0]|l[e+53|0]<<8|(l[e+54|0]<<16|l[e+55|0]<<24),i[A+140>>2]=S,O=l[e+56|0]|l[e+57|0]<<8|(l[e+58|0]<<16|l[e+59|0]<<24),i[A+144>>2]=O,P=l[e+60|0]|l[e+61|0]<<8|(l[e+62|0]<<16|l[e+63|0]<<24),i[A+148>>2]=P,f=k2(((((h^_)&w^_)+a|0)+s|0)-680876936|0,7)+w|0,k=k2(((_+B|0)+(f&(w^h)^h)|0)-389564586|0,12)+f|0,n=k2(((h+m|0)+(k&(f^w)^w)|0)+606105819|0,17)+k|0,t=k2(((w+X|0)+(f^n&(f^k))|0)-1044525330|0,22)+n|0,f=k2(((f+Q|0)+(k^t&(k^n))|0)-176418897|0,7)+t|0,k=k2(((k+V|0)+(n^f&(t^n))|0)+1200080426|0,12)+f|0,n=k2(((n+F|0)+(t^k&(f^t))|0)-1473231341|0,17)+k|0,t=k2(((t+I|0)+(f^n&(f^k))|0)-45705983|0,22)+n|0,f=k2(((f+E|0)+(k^t&(k^n))|0)+1770035416|0,7)+t|0,k=k2(((k+R|0)+(n^f&(t^n))|0)-1958414417|0,12)+f|0,n=k2(((n+N|0)+(t^k&(f^t))|0)-42063|0,17)+k|0,t=k2(((t+M|0)+(f^n&(f^k))|0)-1990404162|0,22)+n|0,o=k+S|0,k=k2(((f+z|0)+(k^t&(k^n))|0)+1804603682|0,7)+t|0,o=k2((o+(n^k&(t^n))|0)-40341101|0,12)+k|0,f=t+P|0,t=k2(((n+O|0)+(t^o&(k^t))|0)-1502002290|0,17)+o|0,f=k2((f+(k^t&(k^o))|0)+1236535329|0,22)+t|0,k=k2(((k+B|0)+(t^o&(f^t))|0)-165796510|0,5)+f|0,n=k2(((o+F|0)+((f^k)&t^f)|0)-1069501632|0,9)+k|0,t=k2(((t+M|0)+(k^f&(k^n))|0)+643717713|0,14)+n|0,f=k2(((f+s|0)+(n^k&(t^n))|0)-373897302|0,20)+t|0,k=k2(((k+V|0)+(t^n&(f^t))|0)-701558691|0,5)+f|0,n=k2(((n+N|0)+((f^k)&t^f)|0)+38016083|0,9)+k|0,t=k2(((t+P|0)+(k^f&(k^n))|0)-660478335|0,14)+n|0,f=k2(((f+Q|0)+(n^k&(t^n))|0)-405537848|0,20)+t|0,k=k2(((k+R|0)+(t^n&(f^t))|0)+568446438|0,5)+f|0,n=k2(((n+O|0)+((f^k)&t^f)|0)-1019803690|0,9)+k|0,t=k2(((t+X|0)+(k^f&(k^n))|0)-187363961|0,14)+n|0,f=k2(((f+E|0)+(n^k&(t^n))|0)+1163531501|0,20)+t|0,k=k2(((k+S|0)+(t^n&(f^t))|0)-1444681467|0,5)+f|0,n=k2(((n+m|0)+((f^k)&t^f)|0)-51403784|0,9)+k|0,$=f+z|0,o=k2(((t+I|0)+(k^f&(k^n))|0)+1735328473|0,14)+n|0,f=o^n,t=k2(($+(n^k&f)|0)-1926607734|0,20)+o|0,f=k2(((k+V|0)+(f^t)|0)-378558|0,4)+t|0,k=k2(((n+E|0)+(f^(t^o))|0)-2022574463|0,11)+f|0,n=k2(((o+M|0)+(k^(f^t))|0)+1839030562|0,16)+k|0,t=k2(((t+O|0)+(n^(f^k))|0)-35309556|0,23)+n|0,f=k2(((f+B|0)+(t^(k^n))|0)-1530992060|0,4)+t|0,k=k2(((k+Q|0)+(f^(t^n))|0)+1272893353|0,11)+f|0,n=k2(((n+I|0)+(k^(f^t))|0)-155497632|0,16)+k|0,t=k2(((t+N|0)+(n^(f^k))|0)-1094730640|0,23)+n|0,f=k2(((f+S|0)+(t^(k^n))|0)+681279174|0,4)+t|0,k=k2(((k+s|0)+(f^(t^n))|0)-358537222|0,11)+f|0,n=k2(((n+X|0)+(k^(f^t))|0)-722521979|0,16)+k|0,t=k2(((t+F|0)+(n^(f^k))|0)+76029189|0,23)+n|0,f=k2(((f+R|0)+(t^(k^n))|0)-640364487|0,4)+t|0,k=k2(((k+z|0)+(f^(t^n))|0)-421815835|0,11)+f|0,o=f+s|0,s=f^k,f=k2(((n+P|0)+(k^(f^t))|0)+530742520|0,16)+k|0,n=k2(((t+m|0)+(s^f)|0)-995338651|0,23)+f|0,t=k2((o+((n|k^-1)^f)|0)-198630844|0,6)+n|0,o=n+V|0,s=f+O|0,f=k2(((k+I|0)+(n^(t|f^-1))|0)+1126891415|0,10)+t|0,n=k2((s+(t^(f|n^-1))|0)-1416354905|0,15)+f|0,k=k2((o+((n|t^-1)^f)|0)-57434055|0,21)+n|0,o=n+N|0,s=f+X|0,f=k2(((t+z|0)+(n^(k|f^-1))|0)+1700485571|0,6)+k|0,n=k2((s+(k^(f|n^-1))|0)-1894986606|0,10)+f|0,t=k2((o+((n|k^-1)^f)|0)-1051523|0,15)+n|0,o=n+P|0,s=f+E|0,f=k2(((k+B|0)+(n^(t|f^-1))|0)-2054922799|0,21)+t|0,n=k2((s+(t^(f|n^-1))|0)+1873313359|0,6)+f|0,k=k2((o+((n|t^-1)^f)|0)-30611744|0,10)+n|0,o=n+Q|0,s=f+S|0,f=k2(((t+F|0)+(n^(k|f^-1))|0)-1560198380|0,15)+k|0,n=k2((s+(k^(f|n^-1))|0)+1309151649|0,21)+f|0,t=k2((o+((n|k^-1)^f)|0)-145523070|0,6)+n|0,k=k2(((k+M|0)+(n^(t|f^-1))|0)-1120210379|0,10)+t|0,f=k2(((f+m|0)+(t^(k|n^-1))|0)+718787259|0,15)+k|0,w=(f+w|0)+k2(((n+R|0)+(k^(f|t^-1))|0)-343485551|0,21)|0,h=f+h|0,_=k+_|0,a=t+a|0,e=e- -64|0,r=r+-64|0,!!r;);return i[A+20>>2]=_,i[A+16>>2]=h,i[A+12>>2]=w,i[A+8>>2]=a,e}function e9(A,e,r){var f=0,k=0,n=0,t=0,o=0,s=0;k=v-112|0,v=k,f=i[i[e+104>>2]-8>>2],W[i[i[f>>2]+12>>2]](k+104|0,f),f=i[k+104>>2],W[i[i[f>>2]+28>>2]](k+56|0,f);i:{e:{if(!l[k+100|0]){i[A>>2]=0,i[A+4>>2]=0,i[A+16>>2]=0,i[A+20>>2]=0,i[A+8>>2]=0,i[A+12>>2]=0;break e}if(o=i[k+68>>2],f=i[k+72>>2],!((o|0)!=(f|0)|i[k+56>>2]!=i[k+60>>2])){u[A+20|0]=0,u[A|0]=0;break e}if(!l[e+300|0]){if(f=i[k+104>>2],W[i[i[f>>2]+32>>2]](k+48|0,f,k+56|0),f=i[k+48>>2],f){g[f+116>>1]=C[e+288>>1],g[f+118>>1]=C[e+290>>1],t=p(128),i[t>>2]=93604,i[t+4>>2]=0,i[t+8>>2]=0,o=t+16|0,f=o,i[f+8>>2]=0,i[f+12>>2]=0,i[t+32>>2]=0,i[t+36>>2]=0,i[t+40>>2]=0,i[t+44>>2]=0,i[t+48>>2]=0,i[t+16>>2]=86356,i[t+60>>2]=0,i[t+64>>2]=0,i[t+52>>2]=0,i[t+56>>2]=0,i[t+72>>2]=-1,i[t+76>>2]=-1,i[t+80>>2]=-1,i[t+84>>2]=-1,i[t+116>>2]=0,i[t+88>>2]=0,i[t+92>>2]=0,i[t+96>>2]=0,i[t+100>>2]=0,i[t+104>>2]=0,i[t+108>>2]=0,g[t+112>>1]=0,i[t+16>>2]=105340,i[t+32>>2]=1667462004,g[t+120>>1]=C[k+80>>1],u[t+122|0]=l[k+82|0],f=i[k+48>>2],i[k+20>>2]=t,i[k+16>>2]=o,i[t+4>>2]=i[t+4>>2]+1,r2(f+36|0,k+16|0),o=i[k+20>>2];r:{if(!o||(f=i[o+4>>2],i[o+4>>2]=f-1,f))break r;W[i[i[o>>2]+8>>2]](o),y(o)}f=i[t+4>>2],i[t+4>>2]=f-1,f||(W[i[i[t>>2]+8>>2]](t),y(t));r:{if(i[e+292>>2]!=2)break r;if(n=p(136),i[n+4>>2]=0,i[n+8>>2]=0,i[n>>2]=93644,t=n+16|0,f=t,i[f+8>>2]=0,i[f+12>>2]=0,i[n+32>>2]=0,i[n+36>>2]=0,i[n+40>>2]=0,i[n+44>>2]=0,i[n+48>>2]=0,i[n+16>>2]=86356,i[n+60>>2]=0,i[n+64>>2]=0,i[n+52>>2]=0,i[n+56>>2]=0,i[n+72>>2]=-1,i[n+76>>2]=-1,i[n+80>>2]=-1,i[n+84>>2]=-1,i[n+116>>2]=0,i[n+88>>2]=0,i[n+92>>2]=0,i[n+96>>2]=0,i[n+100>>2]=0,i[n+104>>2]=0,i[n+108>>2]=0,g[n+112>>1]=0,i[n+16>>2]=105420,i[n+128>>2]=0,i[n+120>>2]=0,i[n+124>>2]=0,i[n+32>>2]=1635088489,r=i[i[r>>2]+4>>2],o=(r|0)==1?21770:(r|0)==2?21797:19026,s=h2(o),s>>>0>=2147483640)break i;f:{A:{if(s>>>0>=11){f=s|7,r=p(f+1|0),i[k+24>>2]=f-2147483647,i[k+16>>2]=r,i[k+20>>2]=s;break A}if(u[k+27|0]=s,r=k+16|0,!s)break f}if(!s)break f;x(r,o,s)}o=n+120|0,u[r+s|0]=0,f=u[k+27|0];f:{A:{if(u[n+131|0]>=0){if((f|0)>=0){r=i[k+20>>2],i[o>>2]=i[k+16>>2],i[o+4>>2]=r,i[o+8>>2]=i[k+24>>2];break f}M1(o,i[k+16>>2],i[k+20>>2]);break A}r=(f|0)<0,O1(o,r?i[k+16>>2]:k+16|0,r?i[k+20>>2]:f)}if(u[k+27|0]>=0)break f;Z(i[k+16>>2])}r=i[k+48>>2],i[k+20>>2]=n,i[k+16>>2]=t,i[n+4>>2]=i[n+4>>2]+1,r2(r+36|0,k+16|0),f=i[k+20>>2];f:{if(!f||(r=i[f+4>>2],i[f+4>>2]=r-1,r))break f;W[i[i[f>>2]+8>>2]](f),y(f)}if(r=i[n+4>>2],i[n+4>>2]=r-1,r)break r;W[i[i[n>>2]+8>>2]](n),y(n)}i[k+40>>2]=i[k+48>>2],r=i[k+52>>2],i[k+44>>2]=r,r&&(i[r+4>>2]=i[r+4>>2]+1),r=i[k+44>>2],i[k+8>>2]=i[k+40>>2],i[k+12>>2]=r,mn(e,k+8|0),u[e+300|0]=1}f=i[k+52>>2];r:{if(!f||(r=i[f+4>>2],i[f+4>>2]=r-1,r))break r;W[i[i[f>>2]+8>>2]](f),y(f)}o=i[k+68>>2],f=i[k+72>>2]}r:{if((f|0)==(o|0))break r;t=k+68|0,s=i[k+96>>2],i[k+48>>2]=s,n=e+304|0,f=i[e+308>>2];f:{A:{if(!f){r=e+308|0,o=r;break A}for(;;){if(o=f,r=i[f+16>>2],r>>>0>s>>>0){if(r=f,f=i[f>>2],f)continue;break A}if(r>>>0>=s>>>0)break f;if(f=i[o+4>>2],!f)break}r=o+4|0}f=p(44),i[f+20>>2]=0,i[f+24>>2]=0,i[f+16>>2]=s,i[f+8>>2]=o,i[f>>2]=0,i[f+4>>2]=0,i[f+28>>2]=0,i[f+32>>2]=0,i[f+36>>2]=0,i[f+40>>2]=0,i[r>>2]=f,r=i[i[n>>2]>>2],r&&(i[n>>2]=r),m1(i[e+308>>2],f),i[e+312>>2]=i[e+312>>2]+1}if(a7(k+16|0,e,t,i[f+20>>2],G(i[e+316>>2],s-i[i[e+228>>2]+108>>2]|0),l[k+92|0],i[f+40>>2],f+24|0),x2(i[f+40>>2]),i[f+40>>2]=0,f=i[n+4>>2],f){for(s=i[k+48>>2],t=n+4|0,o=t,r=f;e=s>>>0>u0[r+16>>2],o=e?o:r,r=i[(e?4:0)+r>>2],!!r;);if(!((t|0)==(o|0)|s>>>0<u0[o+16>>2])){e=i[o+4>>2];f:{if(!e){for(e=o;r=i[e+8>>2],t=i[r>>2]!=(e|0),e=r,!!t;);break f}for(;r=e,e=i[r>>2],!!e;);}i[n>>2]==(o|0)&&(i[n>>2]=r),i[n+8>>2]=i[n+8>>2]-1,yf(f,o),l[o+36|0]!=1|u[o+35|0]>=0||Z(i[o+24>>2]),Z(o)}}if(i[k+16>>2]){if(e=i[k+20>>2],i[A>>2]=i[k+16>>2],i[A+4>>2]=e,r=A+8|0,u[k+35|0]>=0){e=i[k+28>>2],i[r>>2]=i[k+24>>2],i[r+4>>2]=e,i[r+8>>2]=i[k+32>>2],u[A+20|0]=1;break e}if(T(r,i[k+24>>2],i[k+28>>2]),e=u[k+35|0],u[A+20|0]=1,(e|0)>=0)break e;Z(i[k+24>>2]);break e}if(u[k+35|0]>=0)break r;Z(i[k+24>>2])}u[A+20|0]=0,u[A|0]=1}e:{if(l[k+100|0]!=1||(A=i[k+68>>2],A&&(i[k+72>>2]=A,Z(A)),A=i[k+56>>2],!A))break e;if(o=i[k+60>>2],f=A,(o|0)!=(f|0)){for(;;){r=i[o-4>>2];r:{if(!r||(e=i[r+4>>2],i[r+4>>2]=e-1,e))break r;W[i[i[r>>2]+8>>2]](r),y(r)}if(o=o-8|0,(A|0)==(o|0))break}f=i[k+56>>2]}i[k+60>>2]=A,Z(f)}e=i[k+108>>2];e:{if(!e||(A=i[e+4>>2],i[e+4>>2]=A-1,A))break e;W[i[i[e>>2]+8>>2]](e),y(e)}v=k+112|0;return}Q0(),H()}function aB(A,e){A=A|0,e=e|0;var r=0,f=0,k=0,n=0,t=0,o=0,s=0,w=0,h=0;n=v-32|0,v=n,f=v-224|0,v=f,r=i[e+100>>2],k=i[r+48>>2],o=i[r+52>>2],o&&(i[o+4>>2]=i[o+4>>2]+1),t=n+8|0,a6(f+200|0,k,i[e+116>>2]);i:{e:switch(l[f+220|0]){default:_2(),H();case 1:if(e=i[f+204>>2],i[t>>2]=i[f+200>>2],i[t+4>>2]=e,r=t+8|0,u[f+219|0]>=0){e=i[f+212>>2],i[r>>2]=i[f+208>>2],i[r+4>>2]=e,i[r+8>>2]=i[f+216>>2];break i}T(r,i[f+208>>2],i[f+212>>2]);break i;case 0:break e}s9(f+176|0,e+448|0,f+200|0);e:{if(i[f+176>>2]){e=i[f+180>>2],i[t>>2]=i[f+176>>2],i[t+4>>2]=e,i[t+16>>2]=i[f+192>>2],e=i[f+188>>2],i[t+8>>2]=i[f+184>>2],i[t+12>>2]=e,i[f+192>>2]=0,i[f+184>>2]=0,i[f+188>>2]=0;break e}r=i[k+84>>2],s=i[k+88>>2],s&&(i[s+4>>2]=i[s+4>>2]+1);r:{if(!r){if(k=p(56),i[f+24>>2]=k,i[f+28>>2]=48,i[f+32>>2]=-2147483592,r=l[14884]|l[14885]<<8|(l[14886]<<16|l[14887]<<24),e=l[14880]|l[14881]<<8|(l[14882]<<16|l[14883]<<24),u[k|0]=e,u[k+1|0]=e>>>8,u[k+2|0]=e>>>16,u[k+3|0]=e>>>24,u[k+4|0]=r,u[k+5|0]=r>>>8,u[k+6|0]=r>>>16,u[k+7|0]=r>>>24,u[k+48|0]=0,r=l[14924]|l[14925]<<8|(l[14926]<<16|l[14927]<<24),e=l[14920]|l[14921]<<8|(l[14922]<<16|l[14923]<<24),u[k+40|0]=e,u[k+41|0]=e>>>8,u[k+42|0]=e>>>16,u[k+43|0]=e>>>24,u[k+44|0]=r,u[k+45|0]=r>>>8,u[k+46|0]=r>>>16,u[k+47|0]=r>>>24,r=l[14916]|l[14917]<<8|(l[14918]<<16|l[14919]<<24),e=l[14912]|l[14913]<<8|(l[14914]<<16|l[14915]<<24),u[k+32|0]=e,u[k+33|0]=e>>>8,u[k+34|0]=e>>>16,u[k+35|0]=e>>>24,u[k+36|0]=r,u[k+37|0]=r>>>8,u[k+38|0]=r>>>16,u[k+39|0]=r>>>24,r=l[14908]|l[14909]<<8|(l[14910]<<16|l[14911]<<24),e=l[14904]|l[14905]<<8|(l[14906]<<16|l[14907]<<24),u[k+24|0]=e,u[k+25|0]=e>>>8,u[k+26|0]=e>>>16,u[k+27|0]=e>>>24,u[k+28|0]=r,u[k+29|0]=r>>>8,u[k+30|0]=r>>>16,u[k+31|0]=r>>>24,r=l[14900]|l[14901]<<8|(l[14902]<<16|l[14903]<<24),e=l[14896]|l[14897]<<8|(l[14898]<<16|l[14899]<<24),u[k+16|0]=e,u[k+17|0]=e>>>8,u[k+18|0]=e>>>16,u[k+19|0]=e>>>24,u[k+20|0]=r,u[k+21|0]=r>>>8,u[k+22|0]=r>>>16,u[k+23|0]=r>>>24,r=l[14892]|l[14893]<<8|(l[14894]<<16|l[14895]<<24),e=l[14888]|l[14889]<<8|(l[14890]<<16|l[14891]<<24),u[k+8|0]=e,u[k+9|0]=e>>>8,u[k+10|0]=e>>>16,u[k+11|0]=e>>>24,u[k+12|0]=r,u[k+13|0]=r>>>8,u[k+14|0]=r>>>16,u[k+15|0]=r>>>24,q(t,2,113,f+24|0),u[f+35|0]>=0)break r;Z(i[f+24>>2]);break r}P8(f+24|0,r,i[e+116>>2],1684630887),r=i[e+460>>2],r&&(i[e+464>>2]=r,Z(r)),k=i[f+24>>2],i[e+460>>2]=k,r=i[f+28>>2],i[e+464>>2]=r,i[e+468>>2]=i[f+32>>2];f:{A:{k:{if((G(C[e+450>>1],C[e+448>>1])|0)!=r-k>>2){i[f+116>>2]=0,i[f+88>>2]=72196,i[f+32>>2]=72176,r=i[18053],i[f+24>>2]=r,w=f+24|0,i[w+i[r-12>>2]>>2]=i[18054],i[f+28>>2]=0,r=w+i[i[f+24>>2]-12>>2]|0,h=f+36|0,J0(r,h),u[r+80|0]=0,i[r+72>>2]=0,r=i[18055],i[f+32>>2]=r,k=f+32|0,i[k+i[r-12>>2]>>2]=i[18056],r=i[18052],i[f+24>>2]=r,i[w+i[r-12>>2]>>2]=i[18057],i[f+88>>2]=72196,i[f+24>>2]=72156,i[f+32>>2]=72176,h=R0(h),i[h>>2]=71232,i[f+76>>2]=0,i[f+80>>2]=0,i[f+68>>2]=0,i[f+72>>2]=0,i[f+84>>2]=24,Y(V0(Y(S0(Y(V0(Y(V0(Y(k,28358,17),C[e+448>>1]),2998,1),C[e+450>>1]),21050,1),G(C[e+450>>1],C[e+448>>1])),27456,17),i[e+464>>2]-i[e+460>>2]>>2),13302,20),e=i[f+84>>2];n:{if(e&16){e=i[f+80>>2],r=i[f+60>>2],e>>>0<r>>>0&&(i[f+80>>2]=r,e=r),r=f+56|0;break n}if(!(e&8)){e=0,u[f+23|0]=0,w=f+12|0;break f}e=i[f+52>>2],r=f+44|0}if(k=i[r>>2],e=e-k|0,e>>>0>=2147483640)break k;if(e>>>0>=11){r=e|7,w=p(r+1|0),i[f+20>>2]=r-2147483647,i[f+12>>2]=w,i[f+16>>2]=e;break A}if(u[f+23|0]=e,w=f+12|0,e)break A;e=0;break f}if(e=i[26917],i[t>>2]=i[26916],i[t+4>>2]=e,r=t+8|0,u[107683]>=0){e=i[26919],i[r>>2]=i[26918],i[r+4>>2]=e,i[r+8>>2]=i[26920];break r}T(r,i[26918],i[26919]);break r}Q0(),H()}if(!e)break f;x(w,k,e)}u[e+w|0]=0,q(t,2,119,f+12|0),u[f+23|0]<0&&Z(i[f+12>>2]),e=i[18051],i[f+24>>2]=e,i[i[e-12>>2]+(f+24|0)>>2]=i[18059],i[f+32>>2]=i[18060],i[h>>2]=71232,u[f+79|0]<0&&Z(i[f+68>>2]),E0(h),y0(f+88|0)}if(!s||(e=i[s+4>>2],i[s+4>>2]=e-1,e))break e;W[i[i[s>>2]+8>>2]](s),y(s)}if(u[f+195|0]>=0)break i;Z(i[f+184>>2])}r=l[f+220|0],(r|0)!=255&&(e=i[25329],i[f+24>>2]=i[25328],i[f+28>>2]=e,W[i[(f+24|0)+(r<<2)>>2]](f+176|0,f+200|0));i:{if(!o||(e=i[o+4>>2],i[o+4>>2]=e-1,e))break i;W[i[i[o>>2]+8>>2]](o),y(o)}v=f+224|0,r=A+8|0;i:{if(i[n+8>>2]){e=i[n+12>>2],i[A>>2]=i[n+8>>2],i[A+4>>2]=e,i[r+8>>2]=i[n+24>>2],A=i[n+20>>2],i[r>>2]=i[n+16>>2],i[r+4>>2]=A,i[n+24>>2]=0,i[n+16>>2]=0,i[n+20>>2]=0;break i}if(e=i[26917],i[A>>2]=i[26916],i[A+4>>2]=e,u[107683]>=0){A=i[26919],i[r>>2]=i[26918],i[r+4>>2]=A,i[r+8>>2]=i[26920];break i}T(r,i[26918],i[26919])}u[n+27|0]<0&&Z(i[n+16>>2]),v=n+32|0}function Xf(A,e,r){var f=0,k=0;i:{e:switch(r-1|0){case 2:f=p(480),i[f+4>>2]=0,i[f+8>>2]=0,i[f>>2]=100736,k=c6(f+16|0,e),e=k,i[e+448>>2]=0,i[e+452>>2]=0,i[e>>2]=98320,i[e+456>>2]=0,i[e+460>>2]=0,e=p(64),i[e+16>>2]=0,i[e+20>>2]=0,i[e>>2]=98464,i[e+4>>2]=0,i[e+8>>2]=0,i[e+12>>2]=98656,i[e+24>>2]=0,i[e+28>>2]=0,i[e+32>>2]=0,i[e+36>>2]=0,i[e+40>>2]=0,i[e+44>>2]=0,i[e+48>>2]=0,i[e+52>>2]=0,i[e+56>>2]=0,i[e+60>>2]=0,i[k+460>>2]=e,i[k+456>>2]=e+12;break i;case 0:f=p(480),i[f+4>>2]=0,i[f+8>>2]=0,i[f>>2]=100776,k=c6(f+16|0,e),e=k,i[e+448>>2]=0,i[e+452>>2]=0,i[e>>2]=97320,i[e+456>>2]=0,i[e+460>>2]=0,e=p(92),i[e>>2]=97464,i[e+4>>2]=0,i[e+8>>2]=0,o0(e+20|0,0,72),i[e+16>>2]=0,i[e+12>>2]=97712,u[e+20|0]=0,i[e+24>>2]=0,i[e+28>>2]=0,u[e+32|0]=0,i[e+36>>2]=0,i[e+40>>2]=0,u[e+44|0]=0,i[k+460>>2]=e,i[k+456>>2]=e+12;break i;case 3:f=p(480),i[f+4>>2]=0,i[f+8>>2]=0,i[f>>2]=100816,k=c6(f+16|0,e),e=k,i[e+448>>2]=0,i[e+452>>2]=0,i[e>>2]=97776,i[e+456>>2]=0,i[e+460>>2]=0,e=p(84),i[e+28>>2]=0,i[e+32>>2]=0,i[e>>2]=97920,i[e+4>>2]=0,i[e+8>>2]=0,u[e+19|0]=0,u[e+20|0]=0,u[e+21|0]=0,u[e+22|0]=0,u[e+23|0]=0,u[e+24|0]=0,u[e+25|0]=0,u[e+26|0]=0,u[e+18|0]=1,g[e+16>>1]=0,i[e+12>>2]=97960,u[e+27|0]=0,u[e+28|0]=0,u[e+29|0]=0,u[e+30|0]=0,i[e+36>>2]=0,i[e+40>>2]=0,i[e+44>>2]=0,i[e+48>>2]=0,i[e+52>>2]=0,i[e+56>>2]=0,i[e+60>>2]=0,i[e+64>>2]=0,i[e+68>>2]=0,i[e+72>>2]=0,i[e+76>>2]=0,i[e+80>>2]=0,i[k+460>>2]=e,i[k+456>>2]=e+12;break i;case 4:f=p(480),i[f+4>>2]=0,i[f+8>>2]=0,i[f>>2]=100856,k=c6(f+16|0,e),e=k,i[e+448>>2]=0,i[e+452>>2]=0,i[e>>2]=99496,i[e+456>>2]=0,i[e+460>>2]=0,e=p(92),i[e>>2]=99640,i[e+4>>2]=0,i[e+8>>2]=0,o0(e+20|0,0,72),i[e+16>>2]=0,i[e+12>>2]=99744,u[e+20|0]=0,i[e+24>>2]=0,i[e+28>>2]=0,u[e+32|0]=0,i[e+36>>2]=0,i[e+40>>2]=0,u[e+44|0]=0,i[k+460>>2]=e,i[k+456>>2]=e+12;break i;case 1:f=p(480),i[f+4>>2]=0,i[f+8>>2]=0,i[f>>2]=100896,k=c6(f+16|0,e),e=k,i[e+448>>2]=0,i[e+452>>2]=0,i[e>>2]=99928,i[e+456>>2]=0,i[e+460>>2]=0,e=p(92),i[e+28>>2]=0,i[e+32>>2]=0,i[e+36>>2]=0,i[e+40>>2]=0,i[e>>2]=100072,i[e+4>>2]=0,i[e+8>>2]=0,i[e+16>>2]=0,i[e+20>>2]=0,i[e+12>>2]=100256,u[e+21|0]=0,u[e+22|0]=0,u[e+23|0]=0,u[e+24|0]=0,u[e+25|0]=0,u[e+26|0]=0,u[e+27|0]=0,u[e+28|0]=0,i[e+44>>2]=0,i[e+48>>2]=0,i[e+52>>2]=0,i[e+56>>2]=0,i[e+60>>2]=0,i[e+64>>2]=0,i[e+68>>2]=0,i[e+72>>2]=0,i[e+76>>2]=0,i[e+80>>2]=0,i[e+84>>2]=0,i[e+88>>2]=0,i[e+32>>2]=0,i[e+36>>2]=0,u[e+40|0]=0,i[k+460>>2]=e,i[k+456>>2]=e+12;break i;case 6:case 9:f=p(480),i[f+4>>2]=0,i[f+8>>2]=0,i[f>>2]=100936,k=c6(f+16|0,e),e=k,i[e+448>>2]=0,i[e+452>>2]=0,i[e>>2]=98720,i[e+456>>2]=0,i[e+460>>2]=0,e=p(64),i[e+16>>2]=0,i[e+20>>2]=0,i[e>>2]=98864,i[e+4>>2]=0,i[e+8>>2]=0,i[e+12>>2]=98976,i[e+24>>2]=0,i[e+28>>2]=0,i[e+32>>2]=0,i[e+36>>2]=0,i[e+40>>2]=0,i[e+44>>2]=0,i[e+48>>2]=0,i[e+52>>2]=0,i[e+56>>2]=0,i[e+60>>2]=0,i[k+460>>2]=e,i[k+456>>2]=e+12;break i;case 8:break e;default:break i}f=p(464),u[f+96|0]=0,u[f+84|0]=0,i[f+80>>2]=0,u[f+76|0]=0,u[f+52|0]=0,i[f+48>>2]=0,i[f+40>>2]=1,i[f+44>>2]=1,i[f+32>>2]=0,i[f+36>>2]=0,u[f+28|0]=1,g[f+26>>1]=2,g[f+22>>1]=2,g[f+24>>1]=2,u[f+20|0]=0,i[f+4>>2]=0,i[f+8>>2]=0,i[f+100>>2]=0,i[f+104>>2]=0,i[f+112>>2]=4740,i[f+116>>2]=e,u[f+248|0]=0,i[f>>2]=100976,i[f+108>>2]=0,g[f+144>>1]=0,i[f+136>>2]=0,i[f+140>>2]=0,i[f+128>>2]=0,i[f+132>>2]=0,i[f+120>>2]=0,i[f+124>>2]=0,i[f+148>>2]=0,i[f+152>>2]=0,g[f+154>>1]=0,g[f+156>>1]=0,g[f+158>>1]=0,g[f+160>>1]=0,i[f+164>>2]=0,i[f+168>>2]=0,u[f+172|0]=0,i[f+176>>2]=0,i[f+180>>2]=0,u[f+184|0]=0,i[f+252>>2]=0,i[f+256>>2]=0,i[f+260>>2]=0,i[f+264>>2]=0,i[f+268>>2]=0,i[f+272>>2]=0,i[f+276>>2]=0,i[f+280>>2]=0,i[f+284>>2]=0,u[f+288|0]=1,i[f+360>>2]=0,i[f+364>>2]=0,i[f+368>>2]=0,u[f+297|0]=0,u[f+298|0]=0,u[f+299|0]=0,u[f+300|0]=0,u[f+301|0]=0,u[f+302|0]=0,u[f+303|0]=0,u[f+304|0]=0,i[f+292>>2]=0,i[f+296>>2]=0,u[f+352|0]=0,i[f+344>>2]=0,i[f+348>>2]=0,i[f+336>>2]=0,i[f+340>>2]=0,i[f+328>>2]=0,i[f+332>>2]=0,i[f+320>>2]=0,i[f+324>>2]=0,i[f+312>>2]=0,i[f+316>>2]=0,i[f+392>>2]=0,i[f+396>>2]=0,g[f+372>>1]=1,i[f+384>>2]=0,i[f+388>>2]=0,i[f+376>>2]=0,i[f+380>>2]=0,i[f+400>>2]=0,i[f+404>>2]=1072693248,i[f+192>>2]=0,i[f+196>>2]=0,i[f+200>>2]=0,i[f+204>>2]=0,i[f+208>>2]=0,i[f+212>>2]=0,i[f+216>>2]=0,i[f+220>>2]=0,i[f+224>>2]=0,i[f+228>>2]=0,i[f+232>>2]=0,i[f+236>>2]=0,i[f+240>>2]=0,i[f+244>>2]=0,i[f+432>>2]=0,i[f+424>>2]=0,i[f+428>>2]=0,i[f+416>>2]=0,i[f+420>>2]=0,i[f+408>>2]=0,i[f+412>>2]=0,i[f+456>>2]=0,i[f+460>>2]=0,i[f+448>>2]=0,i[f+452>>2]=0,i[f+440>>2]=0,i[f+444>>2]=0,i[f+16>>2]=100392,k=f+16|0}i[A+4>>2]=f,i[A>>2]=k}function r9(){var A=0,e=0;B1(8642,1,96236,51581,880,881,0,0),B1(1580,3,96248,51628,882,883,0,0),B1(12433,2,96292,51656,884,885,0,0),B1(6235,2,96308,51679,886,887,0,0),B1(13505,3,96324,51683,888,889,0,0),B1(13434,2,96308,51679,886,890,0,0),B1(21469,4,96368,51761,891,892,0,0),B1(7505,1,96448,51873,893,894,0,0),B1(17925,1,96452,51581,895,896,0,0),B1(15073,2,96456,51876,897,898,0,0),B1(5601,2,96464,51656,899,900,0,0),B1(12206,2,96472,51876,901,902,0,0),B1(10811,2,96496,51656,903,904,0,0),B1(4039,2,96496,51656,903,905,0,0),B1(14188,2,96496,51656,903,906,0,0),B1(12232,2,96504,51876,907,908,0,0),B1(9991,2,96496,51656,903,909,0,0),B1(18985,2,96496,51656,903,910,0,0),B1(6153,2,96308,51679,886,911,0,0),B1(12522,3,96528,51683,912,913,0,0),B1(12485,3,96528,51683,912,914,0,0),B1(11194,3,96528,51683,912,915,0,0),B1(12583,3,96528,51683,912,916,0,0),B1(13039,3,96528,51683,912,917,0,0),B1(5e3,2,96556,51656,918,919,0,0),B1(9311,3,96564,51934,920,921,0,0),B1(12410,2,96292,51656,884,885,0,0),B1(6187,2,96308,51679,886,887,0,0),B1(13472,3,96324,51683,888,889,0,0),B1(13393,2,96308,51679,886,890,0,0),U8(96576,15142,4,0),Y0(96576,10517,0),Y0(96576,3351,1),Y0(96576,3182,2),Y0(96576,6541,11),Y0(96576,12453,3),Y0(96576,12359,4),Y0(96576,6584,5),Y0(96576,6381,6),Y0(96576,6448,7),Y0(96576,6416,8),Y0(96576,6480,9),Y0(96576,15188,13),Y0(96576,3383,10),Y0(96576,17094,12),U8(96584,15123,4,0),Y0(96584,17197,0),Y0(96584,18483,5e3),Y0(96584,6334,1001),Y0(96584,18641,150),Y0(96584,8243,5001),Y0(96584,11235,5002),Y0(96584,7798,5003),Y0(96584,4922,5004),Y0(96584,18583,100),Y0(96584,11388,101),Y0(96584,1878,102),Y0(96584,1800,103),Y0(96584,2148,104),Y0(96584,1774,151),Y0(96584,1826,105),Y0(96584,2226,106),Y0(96584,2200,141),Y0(96584,1956,107),Y0(96584,1930,108),Y0(96584,2174,109),Y0(96584,2122,110),Y0(96584,2044,111),Y0(96584,1904,112),Y0(96584,2070,113),Y0(96584,7097,114),Y0(96584,1154,115),Y0(96584,9484,116),Y0(96584,18556,117),Y0(96584,18609,118),Y0(96584,5645,119),Y0(96584,2278,131),Y0(96584,2252,143),Y0(96584,2013,149),Y0(96584,12251,120),Y0(96584,18448,121),Y0(96584,6058,122),Y0(96584,17409,6001),Y0(96584,6506,6e3),Y0(96584,17114,123),Y0(96584,1537,6002),Y0(96584,16986,6003),Y0(96584,9443,124),Y0(96584,2096,125),Y0(96584,17223,1e3),Y0(96584,12615,126),Y0(96584,4269,127),Y0(96584,7529,128),Y0(96584,11419,129),Y0(96584,17518,2e3),Y0(96584,3730,2001),Y0(96584,17560,2002),Y0(96584,8700,2003),Y0(96584,8659,2004),Y0(96584,6917,2005),Y0(96584,11890,2006),Y0(96584,1240,2007),Y0(96584,13553,2008),Y0(96584,1982,130),Y0(96584,18522,136),Y0(96584,18065,3e3),Y0(96584,12656,3001),Y0(96584,8741,3002),Y0(96584,15664,3006),Y0(96584,1109,3007),Y0(96584,8570,3003),Y0(96584,15561,3004),Y0(96584,15612,3005),Y0(96584,10573,4e3),Y0(96584,12546,3008),Y0(96584,10609,132),Y0(96584,5513,133),Y0(96584,5968,134),Y0(96584,4538,135),Y0(96584,1209,137),Y0(96584,16795,138),Y0(96584,16747,139),Y0(96584,9743,140),Y0(96584,1852,142),U8(96592,4245,4,0),Y0(96592,16843,0),Y0(96592,20001,1),Y0(96592,20023,2),Y0(96592,19632,3),Y0(96592,21710,4),Y0(96592,19959,5),Y0(96592,19980,6),Y0(96592,22036,7),Y0(96592,16684,8),Y0(96592,10156,9),Y0(96592,19568,10),U8(96392,18957,4,0),Y0(96392,16896,99),Y0(96392,13016,0),Y0(96392,22005,1),Y0(96392,21590,2),Y0(96392,21370,3),Y0(96392,20121,10),Y0(96392,20149,11),Y0(96392,19764,12),Y0(96392,19798,13),Y0(96392,19694,14),Y0(96392,19728,15),Y0(96392,3979,10),Y0(96392,4009,11),U8(96600,9408,4,0),Y0(96600,14155,2),Y0(96600,6836,1),Y0(96600,3059,3),U8(96608,9375,4,0),Y0(96608,7672,2),Y0(96608,6796,1),U8(96384,15509,4,0),Y0(96384,16870,99),Y0(96384,7724,0),Y0(96384,20101,1),Y0(96384,12989,2),Y0(96384,10094,3),U8(96424,9978,4,0),Y0(96424,19207,0),Y0(96424,7746,2),Y0(96424,18368,1),Y0(96424,19385,3),Y0(96424,19612,4),Y0(96424,20053,5),Y0(96424,19070,6),Y0(96424,15945,10),Y0(96424,1670,11),Y0(96424,10652,12),Y0(96424,1467,13),U8(96300,3823,4,0),Y0(96300,7937,0),Y0(96300,16e3,1),Y0(96300,15970,2),Y0(96300,15536,3),uf(96284,96268,96540,0,51581,922,52076,0,52076,0,3102,52078,923),uf(96352,96336,96480,0,51581,924,52076,0,52076,0,13535,52078,925),uf(96416,96400,96512,0,51581,926,52076,0,52076,0,14249,52078,927),Q_(96260,6573,52081,928,52078,929),A=p(4),i[A>>2]=0,e=p(4),i[e>>2]=0,tf(96260,15153,96576,51656,930,A|0,96576,52083,931,e|0),A=p(4),i[A>>2]=4,e=p(4),i[e>>2]=4,tf(96260,15115,96584,51656,932,A|0,96584,52083,933,e|0),A=p(4),i[A>>2]=934,e=p(4),i[e>>2]=935,tf(96260,14147,96240,51679,936,A|0,96240,52088,937,e|0),W_(96260)}function $B(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,t=0,o=0,s=0,w=0,h=0,_=0,B=0,m=0;h=v-48|0,v=h,t=i[e>>2],_=i[e+4>>2],_&&(i[_+4>>2]=i[_+4>>2]+1);i:{if(!i[t+84>>2]&u0[t+80>>2]<=u0[t+92>>2]){i[A>>2]=13,i[A+4>>2]=0,i[A+8>>2]=15275;break i}s=h+12|0,k=v-144|0,v=k,f=i[t+92>>2];e:{if(!i[t+84>>2]&f>>>0>=u0[t+80>>2]){f=p(16),i[k>>2]=f,i[k+4>>2]=15,i[k+8>>2]=-2147483632,n=l[15286]|l[15287]<<8|(l[15288]<<16|l[15289]<<24),t=l[15282]|l[15283]<<8|(l[15284]<<16|l[15285]<<24),u[f+7|0]=t,u[f+8|0]=t>>>8,u[f+9|0]=t>>>16,u[f+10|0]=t>>>24,u[f+11|0]=n,u[f+12|0]=n>>>8,u[f+13|0]=n>>>16,u[f+14|0]=n>>>24,n=l[15279]|l[15280]<<8|(l[15281]<<16|l[15282]<<24),t=l[15275]|l[15276]<<8|(l[15277]<<16|l[15278]<<24),u[f|0]=t,u[f+1|0]=t>>>8,u[f+2|0]=t>>>16,u[f+3|0]=t>>>24,u[f+4|0]=n,u[f+5|0]=n>>>8,u[f+6|0]=n>>>16,u[f+7|0]=n>>>24,u[f+15|0]=0,f=q(k+80|0,13,0,k),n=i[f+4>>2],i[s>>2]=i[f>>2],i[s+4>>2]=n,n=s+8|0;r:{if(u[f+19|0]>=0){t=i[f+12>>2],i[n>>2]=i[f+8>>2],i[n+4>>2]=t,i[n+8>>2]=i[f+16>>2],u[s+20|0]=1;break r}if(T(n,i[f+8>>2],i[f+12>>2]),n=u[f+19|0],u[s+20|0]=1,(n|0)>=0)break r;Z(i[f+8>>2])}if(u[k+11|0]>=0)break e;Z(i[k>>2]);break e}n=f,f=i[t+68>>2],f=G((n>>>0)%((i[t+72>>2]-f|0)/48>>>0)|0,48)+f|0,w=i[f>>2],n=k+80|0,At(n,i[i[t+100>>2]+(i[f+8>>2]<<3)>>2],w),rA(k+56|0,n);r:{f:{A:{k:{n:switch(l[k+76|0]){case 1:f=i[k+60>>2],i[s>>2]=i[k+56>>2],i[s+4>>2]=f,f=s+8|0;t:{if(u[k+75|0]>=0){n=k- -64|0,t=i[n+4>>2],i[f>>2]=i[n>>2],i[f+4>>2]=t,i[f+8>>2]=i[n+8>>2];break t}T(f,i[k+64>>2],i[k+68>>2])}u[s+20|0]=1;break r;case 0:break n;default:break k}n=p(32),f=n,i[f>>2]=0,i[f+4>>2]=0,i[f+24>>2]=0,i[f+28>>2]=0,i[f+16>>2]=0,i[f+20>>2]=0,i[f+8>>2]=0,i[f+12>>2]=0,o=i[k+56>>2],(o|0)!=(f|0)&&(f=i[o>>2],o=i[o+4>>2],d4(n,f,o,o-f|0)),f=i[t+204>>2],f&&(o=i[f+108>>2],f=i[f+104>>2],(o|0)==(f|0)?f=0:f=i[f+4>>2],i[n+12>>2]=f),o=i[t+276>>2];n:{if(!o)break n;f=i[t+20>>2],B=i[f+48>>2],f=i[f+52>>2];t:{if(!f){ri(k,o,B,w);break t}if(i[f+4>>2]=i[f+4>>2]+1,ri(k,o,B,w),o=i[f+4>>2],i[f+4>>2]=o-1,o)break t;W[i[i[f>>2]+8>>2]](f),y(f)}t:switch(l[k+20|0]){case 1:f=i[k+4>>2],i[s>>2]=i[k>>2],i[s+4>>2]=f,f=s+8|0;u:{if(u[k+19|0]>=0){n=i[k+12>>2],i[f>>2]=i[k+8>>2],i[f+4>>2]=n,i[f+8>>2]=i[k+16>>2],f=1;break u}T(f,i[k+8>>2],i[k+12>>2]),f=l[k+20|0]}u[s+20|0]=1;break f;case 0:break t;default:break k}t:{if(i[k>>2]==i[k+4>>2]){f=0;break t}f=k+32|0,If(f,k),o=l[k+52|0];u:{if(o){if((o|0)!=1)break k;D6(s,f);break u}Vo(n+20|0,k+32|0)}if(f=l[k+52|0],(f|0)!=255&&(B=i[26649],i[k+136>>2]=i[26648],i[k+140>>2]=B,W[i[(k+136|0)+(f<<2)>>2]](k+135|0,k+32|0)),f=l[k+20|0],o)break f;if((f|0)==255)break n}o=i[26651],i[k+32>>2]=i[26650],i[k+36>>2]=o,W[i[(k+32|0)+(f<<2)>>2]](k+136|0,k)}o=i[t+272>>2];n:{if(!o)break n;f=i[t+20>>2],B=i[f+48>>2],f=i[f+52>>2];t:{if(!f){ri(k+32|0,o,B,w);break t}if(i[f+4>>2]=i[f+4>>2]+1,ri(k+32|0,o,B,w),w=i[f+4>>2],i[f+4>>2]=w-1,w)break t;W[i[i[f>>2]+8>>2]](f),y(f)}t:switch(l[k+52|0]){case 1:f=i[k+36>>2],i[s>>2]=i[k+32>>2],i[s+4>>2]=f,f=s+8|0;u:{if(u[k+51|0]>=0){n=i[k+44>>2],i[f>>2]=i[k+40>>2],i[f+4>>2]=n,i[f+8>>2]=i[k+48>>2],f=1;break u}T(f,i[k+40>>2],i[k+44>>2]),f=l[k+52|0]}u[s+20|0]=1;break A;case 0:break t;default:break k}t:{if(i[k+32>>2]==i[k+36>>2]){f=0;break t}$9(k,k+32|0),w=l[k+24|0];u:{if(w){if((w|0)!=1)break k;D6(s,k);break u}if(f=ye(),i[n+16>>2]=f,l[k+24|0])break k;Qi(f,k)}if(f=l[k+24|0],(f|0)!=255&&(o=i[26653],i[k+136>>2]=i[26652],i[k+140>>2]=o,W[i[(k+136|0)+(f<<2)>>2]](k+135|0,k)),f=l[k+52|0],w)break A;if((f|0)==255)break n}w=i[26651],i[k>>2]=i[26650],i[k+4>>2]=w,W[i[(f<<2)+k>>2]](k+136|0,k+32|0)}i[t+92>>2]=i[t+92>>2]+1,u[s+20|0]=0,i[s>>2]=n;break r}_2(),H()}if((f|0)==255)break r;n=i[26651],i[k>>2]=i[26650],i[k+4>>2]=n,W[i[(f<<2)+k>>2]](k+136|0,k+32|0);break r}if((f|0)==255)break r;n=i[26651],i[k+32>>2]=i[26650],i[k+36>>2]=n,W[i[(k+32|0)+(f<<2)>>2]](k+136|0,k)}if(f=l[k+76|0],(f|0)!=255&&(n=i[26655],i[k>>2]=i[26654],i[k+4>>2]=n,W[i[(f<<2)+k>>2]](k+32|0,k+56|0)),f=i[k+92>>2],f&&(i[k+96>>2]=f,Z(f)),f=i[k+84>>2],!f||(n=i[f+4>>2],i[f+4>>2]=n-1,n))break e;W[i[i[f>>2]+8>>2]](f),y(f)}v=k+144|0;e:{r:switch(l[h+32|0]){default:_2(),H();case 0:i[r>>2]=i[h+12>>2],i[A+8>>2]=i[24058],e=i[24057],i[A>>2]=i[24056],i[A+4>>2]=e;break e;case 1:break r}if(b0(A,h+12|0,i[e+8>>2]),m=l[h+32|0],(m|0)==255)break i}A=i[24195],i[h+40>>2]=i[24194],i[h+44>>2]=A,W[i[(h+40|0)+(m<<2)>>2]](h+39|0,h+12|0)}i:{if(!_||(A=i[_+4>>2],i[_+4>>2]=A-1,A))break i;W[i[i[_>>2]+8>>2]](_),y(_)}v=h+48|0}function f9(A,e,r,f,k,n){var t=0,o=0,s=0,w=0,h=0,_=0,B=0,m=0,X=0,Q=0,V=0,F=0,I=0;if(t=v-144|0,v=t,Sf(t+132|0,e,r),e=i[t+132>>2],s=ei(t+96|0,e,i[t+136>>2]-e|0),V2(s,8),u[f|0]=1,F=f,I=I1(s,8),u[F+1|0]=I,F=f,I=I1(s,8),u[F+2|0]=I,e=I1(s,8),u[f+4|0]=4,u[f+3|0]=e,$2(s,t+92|0),e=p(48),i[t+32>>2]=e,i[t+36>>2]=46,i[t+40>>2]=-2147483600,r=l[7405]|l[7406]<<8|(l[7407]<<16|l[7408]<<24),o=l[7401]|l[7402]<<8|(l[7403]<<16|l[7404]<<24),u[e+38|0]=o,u[e+39|0]=o>>>8,u[e+40|0]=o>>>16,u[e+41|0]=o>>>24,u[e+42|0]=r,u[e+43|0]=r>>>8,u[e+44|0]=r>>>16,u[e+45|0]=r>>>24,r=l[7399]|l[7400]<<8|(l[7401]<<16|l[7402]<<24),o=l[7395]|l[7396]<<8|(l[7397]<<16|l[7398]<<24),u[e+32|0]=o,u[e+33|0]=o>>>8,u[e+34|0]=o>>>16,u[e+35|0]=o>>>24,u[e+36|0]=r,u[e+37|0]=r>>>8,u[e+38|0]=r>>>16,u[e+39|0]=r>>>24,r=l[7391]|l[7392]<<8|(l[7393]<<16|l[7394]<<24),o=l[7387]|l[7388]<<8|(l[7389]<<16|l[7390]<<24),u[e+24|0]=o,u[e+25|0]=o>>>8,u[e+26|0]=o>>>16,u[e+27|0]=o>>>24,u[e+28|0]=r,u[e+29|0]=r>>>8,u[e+30|0]=r>>>16,u[e+31|0]=r>>>24,r=l[7383]|l[7384]<<8|(l[7385]<<16|l[7386]<<24),o=l[7379]|l[7380]<<8|(l[7381]<<16|l[7382]<<24),u[e+16|0]=o,u[e+17|0]=o>>>8,u[e+18|0]=o>>>16,u[e+19|0]=o>>>24,u[e+20|0]=r,u[e+21|0]=r>>>8,u[e+22|0]=r>>>16,u[e+23|0]=r>>>24,r=l[7375]|l[7376]<<8|(l[7377]<<16|l[7378]<<24),o=l[7371]|l[7372]<<8|(l[7373]<<16|l[7374]<<24),u[e+8|0]=o,u[e+9|0]=o>>>8,u[e+10|0]=o>>>16,u[e+11|0]=o>>>24,u[e+12|0]=r,u[e+13|0]=r>>>8,u[e+14|0]=r>>>16,u[e+15|0]=r>>>24,r=l[7367]|l[7368]<<8|(l[7369]<<16|l[7370]<<24),o=l[7363]|l[7364]<<8|(l[7365]<<16|l[7366]<<24),u[e|0]=o,u[e+1|0]=o>>>8,u[e+2|0]=o>>>16,u[e+3|0]=o>>>24,u[e+4|0]=r,u[e+5|0]=r>>>8,u[e+6|0]=r>>>16,u[e+7|0]=r>>>24,u[e+46|0]=0,w=q(t+72|0,2,0,t+32|0),u[t+43|0]<0&&Z(i[t+32>>2]),i[t+56>>2]=i[13453],e=i[13452],i[t+48>>2]=i[13451],i[t+52>>2]=e,e=i[13450],i[t+40>>2]=i[13449],i[t+44>>2]=e,i[t+64>>2]=0,i[t+68>>2]=0,X=t- -64|0,i[t+60>>2]=X,e=i[13448],i[t+32>>2]=i[13447],i[t+36>>2]=e,B=t+32|0,h=t+60|0,(B|0)!=(h|0))for(m=h+4|0;;){_=i[h+4>>2];i:{e:{r:{if(o=m,V=i[h>>2],(o|0)==(V|0))break r;r=o;f:{if(e=_,e){for(;o=e,e=i[e+4>>2],!!e;);if(Q=i[B>>2],(Q|0)<=i[o+16>>2])break f;break r}for(;o=i[r+8>>2],e=i[o>>2]==(r|0),r=o,!!e;);if(r=m,e=r,i[o+16>>2]<i[B>>2])break r;break e}for(;;){if(e=_,r=i[e+16>>2],(r|0)>(Q|0)){if(r=e,_=i[e>>2],_)continue;break e}if((r|0)>=(Q|0))break i;if(_=i[e+4>>2],!_)break}r=e+4|0;break e}if(r=_?o+4|0:m,i[r>>2])break i;e=_?o:m}o=p(20),_=i[B>>2],i[o+8>>2]=e,i[o>>2]=0,i[o+4>>2]=0,i[o+16>>2]=_,i[r>>2]=o,e=i[V>>2],e&&(i[h>>2]=e),m1(i[h+4>>2],o),i[h+8>>2]=i[h+8>>2]+1}if(B=B+4|0,(h|0)==(B|0))break}i:{e:{r:{r=i[t+64>>2];f:{if(!r)break f;for(h=l[f+1|0],e=X,o=r;_=e,m=o,B=(h|0)>i[o+16>>2],e=B?e:o,o=i[(B?4:0)+o>>2],!!o;);if((e|0)==(X|0))break f;if((h|0)>=i[(B?_:m)+16>>2])break r}g3(t+60|0,r),g[f+12>>1]=2056,i[f+8>>2]=1;break e}if(g3(t+60|0,r),!$2(s,t+92|0)){e=i[w+4>>2],i[A>>2]=i[w>>2],i[A+4>>2]=e,e=i[w+12>>2],i[A+8>>2]=i[w+8>>2],i[A+12>>2]=e,i[A+16>>2]=i[w+16>>2];break i}if(e=i[t+92>>2],i[f+8>>2]=e,(e|0)==3&&V2(s,1),!$2(s,t+92|0)){e=i[w+4>>2],i[A>>2]=i[w>>2],i[A+4>>2]=e,e=i[w+12>>2],i[A+8>>2]=i[w+8>>2],i[A+12>>2]=e,i[A+16>>2]=i[w+16>>2];break i}if(u[f+12|0]=l[t+92|0]+8,!$2(s,t+92|0)){e=i[w+4>>2],i[A>>2]=i[w>>2],i[A+4>>2]=e,e=i[w+12>>2],i[A+8>>2]=i[w+8>>2],i[A+12>>2]=e,i[A+16>>2]=i[w+16>>2];break i}if(u[f+13|0]=l[t+92|0]+8,V2(s,1),!i2(s,1))break e;for(o=0;;){r:{if(!i2(s,1))break r;if(r=8,e=0,o>>>0<=5)for(;;){if(w3(s,t+32|0),r=((i[t+32>>2]+r|0)+256|0)%256|0,!r)break r;if(e=e+1|0,(e|0)==16)break r}for(;;){if(w3(s,t+32|0),r=((i[t+32>>2]+r|0)+256|0)%256|0,!r)break r;if(e=e+1|0,(e|0)==64)break}}if(o=o+1|0,!(o>>>0<(i[f+8>>2]==3?12:8)>>>0))break}}$2(s,t+92|0),$2(s,t+32|0);e:{r:switch(i[t+32>>2]){case 1:if(i2(s,1),e=t+92|0,w3(s,e),w3(s,e),$2(s,t+60|0),r=0,i[t+60>>2]<=0)break e;for(;$2(s,t+92|0),r=r+1|0,(r|0)<i[t+60>>2];);break e;case 0:break r;default:break e}$2(s,t+92|0)}if($2(s,t+92|0),V2(s,1),$2(s,t+60|0),$2(s,t+28|0),i[k>>2]=(i[t+60>>2]<<4)+16,i[n>>2]=(i[t+28>>2]<<4)+16,i2(s,1)||V2(s,1),V2(s,1),i2(s,1)&&($2(s,t+24|0),$2(s,t+20|0),$2(s,t+16|0),$2(s,t+12|0),i[k>>2]=i[k>>2]-(i[t+20>>2]+i[t+24>>2]|0),i[n>>2]=i[n>>2]-(i[t+12>>2]+i[t+16>>2]|0)),i[A>>2]=0,i[A+4>>2]=0,i[A+16>>2]=0,i[A+8>>2]=0,i[A+12>>2]=0,u[w+19|0]>=0)break i;Z(i[w+8>>2])}A=i[t+132>>2],A&&(i[t+136>>2]=A,Z(A)),v=t+144|0}function A9(A,e,r,f,k,n,t,o,s,w,h){var _=0,B=0,m=0,X=0,Q=0,V=0,F=0,I=0,E=0,R=0,N=0,M=0;_=v-48|0,v=_,B=i[k>>2];i:{e:{if(n){if(B)break e;D0(4835,18288,242,14260),H()}if(!B)break i}if(m=i[k+4>>2],m&&(i[m+4>>2]=i[m+4>>2]+1),i[A+124>>2]=B,B=i[A+128>>2],i[A+128>>2]=m,!B||(m=i[B+4>>2],i[B+4>>2]=m-1,m))break i;W[i[i[B>>2]+8>>2]](B),y(B)}lA(A),X=1,m=i[27160],i[27160]=m+1,i[A+112>>2]=t,i[A+108>>2]=2147483647,i[A>>2]=m,i[A+288>>2]=w,i[A+36>>2]=r,i[A+32>>2]=e,i[A+28>>2]=r,i[A+24>>2]=e,i[A+20>>2]=f,i[A+280>>2]=o,i[A+284>>2]=s;i:{e:{r:{f:{A:{k:{n:{t:switch(f|0){default:D0(22181,18288,278,14260),H();case 1:X=2,i[_+8>>2]=2,Q=(r+1|0)/2|0,i[A+36>>2]=Q,V=(e+1|0)/2|0,i[A+32>>2]=V,w=2,f=2;break k;case 2:i[_+8>>2]=3,X=2,V=(e+1|0)/2|0,i[A+32>>2]=V,w=1;break n;case 0:break A;case 3:break t}i[_+8>>2]=4,V=e,w=1}Q=r,f=1}if(u[A+51|0]=w,u[A+50|0]=X,w=i[k>>2],!w){i[_+20>>2]=16,i[_+16>>2]=r,i[_+12>>2]=e,I=1;break f}if(i[w+16852>>2]!=(X|0))break r;if(i[w+16856>>2]==(f|0)){i[_+20>>2]=16,i[_+16>>2]=r,i[_+12>>2]=e;break e}D0(19855,18288,318,14260),H()}if(I=1,i[_+8>>2]=1,g[A+50>>1]=257,i[A+32>>2]=0,i[A+36>>2]=0,w=i[k>>2],i[_+20>>2]=16,i[_+16>>2]=r,i[_+12>>2]=e,w){f=1;break e}f=1}w=0,o=0;break i}D0(19885,18288,317,14260),H()}R=i[w+508>>2],E=i[w+504>>2],N=i[w+500>>2],I=0,o=i[w+496>>2]}F=8,M=o+N|0,B=G(M,X);i:{if((B|0)>=(e|0)||(m=E+R|0,s=G(m,f),(s|0)>=(r|0)))break i;i[A+88>>2]=Q-m,i[A+84>>2]=V-M,r=r-s|0,i[A+80>>2]=r,e=e-B|0,i[A+76>>2]=e,i[_+44>>2]=r,i[_+40>>2]=e,i[_+36>>2]=G(f,R),Q=G(f,E),i[_+32>>2]=Q,i[_+28>>2]=G(X,N),s=G(o,X),i[_+24>>2]=s,f=0,r=8,X=0,e=8,I||(r=i[w+16832>>2],X=(r&255)>>>0>8,e=i[w+16840>>2]),u[A+49|0]=e,u[A+48|0]=r,u[A+16|0]=X,e=(e&255)>>>0>8,u[A+18|0]=e,u[A+17|0]=e;e:{r:{if(!t||(f=i[t+544>>2],!h))break r;r=i[t+540>>2],e=i[t+536>>2];break e}r=i[26759],e=i[26758]}i[A+304>>2]=e,i[A+308>>2]=r;e:{if(!e)break e;r=W[e|0](t,_+8|0,A,f)|0,i[A+64>>2]=(s+i[A+4>>2]|0)+G(Q,i[A+40>>2]);r:{if(!i[A+20>>2]){X=0,e=0;break r}e=G(i[A+44>>2],E),X=e+(i[A+12>>2]+o|0)|0,e=e+(i[A+8>>2]+o|0)|0}if(i[A+72>>2]=X,i[A+68>>2]=e,r)break e;F=7;break i}e:{if(!n)break e;e=i[A+200>>2],n=i[w+16944>>2],f=i[w+16952>>2],r=i[w+16948>>2],t=G(f,r);r:{if((t|0)!=i[A+204>>2]){if(Z(e),e=y2(t),i[A+200>>2]=e,!e){i[A+204>>2]=0,r=0;break r}i[A+204>>2]=t}i[A+216>>2]=f,i[A+212>>2]=r,i[A+208>>2]=n,r=(e|0)!=0}e=i[A+220>>2],t=i[w+16944>>2],n=i[w+16952>>2],f=i[w+16948>>2],o=G(n,f);r:{if((o|0)!=i[A+224>>2]){if(Z(e),e=y2(o),i[A+220>>2]=e,!e){i[A+224>>2]=0,e=0;break r}i[A+224>>2]=o}i[A+236>>2]=n,i[A+232>>2]=f,i[A+228>>2]=t,e=(e|0)!=0}t=e&r,e=i[A+160>>2],n=i[w+16872>>2],f=i[w+16896>>2],r=i[w+16888>>2],o=G(f,r);r:{if((o|0)!=i[A+164>>2]){if(Z(e),e=y2(G(o,3)),i[A+160>>2]=e,!e){i[A+164>>2]=0,e=0;break r}i[A+164>>2]=o}i[A+176>>2]=f,i[A+172>>2]=r,i[A+168>>2]=n,e=(e|0)!=0}n=e&t,e=i[A+180>>2],r=i[w+16872>>2]-2|0,f=i[w+16896>>2]<<r,r=i[w+16888>>2]<<r,t=G(f,r);r:{if((t|0)!=i[A+184>>2]){if(Z(e),e=y2(G(t,12)),i[A+180>>2]=e,!e){i[A+184>>2]=0,e=0;break r}i[A+184>>2]=t}i[A+196>>2]=f,i[A+192>>2]=r,i[A+188>>2]=2,e=(e|0)!=0}t=e&n,e=i[A+240>>2],n=i[w+16936>>2],f=i[w+16928>>2],r=i[w+16924>>2],o=G(f,r);r:{if((o|0)!=i[A+244>>2]){if(Z(e),e=y2(o),i[A+240>>2]=e,!e){i[A+244>>2]=0,e=0;break r}i[A+244>>2]=o}i[A+256>>2]=f,i[A+252>>2]=r,i[A+248>>2]=n,e=(e|0)!=0}n=e&t,e=i[A+260>>2],f=(i[w+488>>2]+3|0)/4|0,r=(i[w+484>>2]+3|0)/4|0,t=G(f,r);r:{if((t|0)!=i[A+264>>2]){if(Z(e),e=y2(t),i[A+260>>2]=e,!e){i[A+264>>2]=0,e=0;break r}i[A+264>>2]=t}i[A+276>>2]=f,i[A+272>>2]=r,i[A+268>>2]=2,e=(e|0)!=0}if(t=e&n,w=i[k>>2],r=i[w+16892>>2],!((r|0)==i[A+152>>2]&i[A+156>>2]==i[w+16900>>2])){if(f=i[A+320>>2],f){if(r=f-4|0,e=i[r>>2],e){for(w=f+G(e,76)|0;w=w-76|0,(f|0)!=(w|0););w=i[k>>2]}Z(r),r=i[w+16892>>2]}e=i[A+140>>2],n=i[w+16876>>2],f=i[w+16900>>2],w=G(f,r);r:{if((w|0)!=i[A+144>>2]){if(Z(e),e=y2(G(w,24)),i[A+140>>2]=e,!e){w=0,i[A+144>>2]=0,e=0;break r}i[A+144>>2]=w}i[A+156>>2]=f,i[A+152>>2]=r,i[A+148>>2]=n,e=(e|0)!=0}if(r=O0(w,0,76,0),f=r+4|0,r=p(l0||r>>>0>f>>>0?-1:f),i[r>>2]=w,r=r+4|0,w)for(f=r+G(w,76)|0,w=r;i[w>>2]=0,w=w+76|0,(f|0)!=(w|0););if(i[A+320>>2]=r,e&t)break e;F=7;break i}if(t)break e;F=7;break i}F=0}e=i[k+4>>2];i:{if(!e||(A=i[e+4>>2],i[e+4>>2]=A-1,A))break i;W[i[i[e>>2]+8>>2]](e),y(e)}return v=_+48|0,F}function dB(A,e,r,f,k,n,t,o){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,t=t|0,o=o|0;var s=0,w=0,h=0,_=0,B=0,m=0,X=0,Q=0,V=0,F=0,I=0,E=0,R=0,N=0,M=0,z=0,S=0,O=0,P=0,a=0,$=0;t=v-32|0,v=t;i:{e:{r:{if(j0(i[r>>2],3)>>>0<9||j0(i[r>>2],4)>>>0<9)break r;if(j0(i[r>>2],5)>>>0>8)break e}e=i[26922],i[A>>2]=i[26921],i[A+4>>2]=e,r=A+8|0;r:{if(u[107703]>=0){e=i[26924],i[r>>2]=i[26923],i[r+4>>2]=e,i[r+8>>2]=i[26925];break r}T(r,i[26923],i[26924])}u[A+20|0]=1;break i}X=u1(i[r>>2],6),k=l[k+8|0];e:{if(!X)break e;if(j0(i[r>>2],6)>>>0<=8){e=i[26922],i[A>>2]=i[26921],i[A+4>>2]=e,r=A+8|0;r:{if(u[107703]>=0){e=i[26924],i[r>>2]=i[26923],i[r+4>>2]=e,i[r+8>>2]=i[26925];break r}T(r,i[26923],i[26924])}u[A+20|0]=1;break i}if((o8(i[r>>2],6)|0)==(o8(i[r>>2],4)|0)&&(l8(i[r>>2],6)|0)==(l8(i[r>>2],4)|0))break e;e=i[26922],i[A>>2]=i[26921],i[A+4>>2]=e,r=A+8|0;r:{if(u[107703]>=0){e=i[26924],i[r>>2]=i[26923],i[r+4>>2]=e,i[r+8>>2]=i[26925];break r}T(r,i[26923],i[26924])}u[A+20|0]=1;break i}if(_=j0(i[r>>2],3),!_){e=i[26922],i[A>>2]=i[26921],i[A+4>>2]=e,r=A+8|0;e:{if(u[107703]>=0){e=i[26924],i[r>>2]=i[26923],i[r+4>>2]=e,i[r+8>>2]=i[26925];break e}T(r,i[26923],i[26924])}u[A+20|0]=1;break i}n=p(172),i[n+4>>2]=0,i[n+8>>2]=0,i[n>>2]=94812,o0(n+16|0,0,80),e=i[n+4>>2],f=e+1|0,i[n+4>>2]=f,i[n+104>>2]=0,i[n+108>>2]=0,i[n+36>>2]=1,i[n+40>>2]=1,u[n+24|0]=1,g[n+22>>1]=2,g[n+18>>1]=2,g[n+20>>1]=2,i[n+112>>2]=0,i[n+116>>2]=4740,i[n+140>>2]=0,i[n+144>>2]=0,i[n+128>>2]=99,i[n+132>>2]=99,i[n+120>>2]=0,i[n+124>>2]=0,i[n+12>>2]=95160,i[n+148>>2]=0,i[n+152>>2]=0,s=n+140|0,i[n+136>>2]=s,i[n+156>>2]=0,i[n+160>>2]=0,i[n+164>>2]=0,i[n+168>>2]=0,i[n+4>>2]=e,e=i[n+8>>2],I=n+12|0,i[n+96>>2]=I,i[n+8>>2]=e+1,i[n+100>>2]=n,f||(W[i[i[n>>2]+8>>2]](n),y(n)),e=i[r>>2],R=i[e+108>>2],f=R,N=i[e+112>>2],e=N,V=k|X,i[I+120>>2]=V&1?13:12,i[I+116>>2]=1,i[I+112>>2]=e,i[I+108>>2]=f,T0(t+8|0,I,10,f,e,_,o);e:{if(i[t+8>>2]){if(e=i[t+12>>2],i[A>>2]=i[t+8>>2],i[A+4>>2]=e,r=A+8|0,u[t+27|0]>=0){e=i[t+20>>2],i[r>>2]=i[t+16>>2],i[r+4>>2]=e,i[r+8>>2]=i[t+24>>2],u[A+20|0]=1;break e}if(T(r,i[t+16>>2],i[t+20>>2]),e=u[t+27|0],u[A+20|0]=1,(e|0)>=0)break e;Z(i[t+16>>2]);break e}u[t+27|0]<0&&Z(i[t+16>>2]),i[t+8>>2]=0;r:{f:{Q=i[r>>2],r=i[Q+128>>2];A:{if(!r)break A;for(e=Q+128|0,o=e,k=r;f=i[k+16>>2]<3,o=f?o:k,k=i[(f?4:0)+k>>2],!!k;);w=0;k:{if((e|0)==(o|0)||(w=0,i[o+16>>2]>3))break k;z=i[o+44>>2],w=i[o+56>>2]}for(o=e,k=r;f=i[k+16>>2]<4,o=f?o:k,k=i[(f?4:0)+k>>2],!!k;);f=0;k:{if((e|0)==(o|0)||(f=0,i[o+16>>2]>4))break k;E=i[o+56>>2],f=i[o+44>>2]}for(S=f,k=e;f=i[r+16>>2]<5,k=f?k:r,r=i[(f?4:0)+r>>2],!!r;);if((e|0)!=(k|0))break f}o=0,f=0;break r}if(o=0,f=0,i[k+16>>2]>5)break r;o=i[k+56>>2]>>>1|0,f=i[k+44>>2]}r=i[s>>2],e=0;r:{if(!r)break r;for(k=s;e=i[r+16>>2]<10,k=e?k:r,r=i[(e?4:0)+r>>2],!!r;);if(e=0,(k|0)==(s|0)||(e=0,i[k+16>>2]>10))break r;O=i[k+56>>2],e=i[k+44>>2]}r=e;r:{if(X){if(h=bu(Q,6,t+8|0),!h)break r;B=i[t+8>>2]>>>1|0}f:{if(!N|!R)break f;if(e=V&1,P=e?8:6,a=E>>>1|0,$=w>>>1|0,!e){for(w=0;;){for(Q=r+G(w,O)|0,V=(G(o,w)<<1)+f|0,E=(G(w,a)<<1)+S|0,s=(G(w,$)<<1)+z|0,k=0;e=k<<1,B=C[e+s>>1],_=C[e+E>>1],h=Q+G(k,P)|0,e=C[e+V>>1],u[h+5|0]=e,u[h+3|0]=_,u[h+1|0]=B,u[h+4|0]=e>>>8,u[h+2|0]=_>>>8,u[h|0]=B>>>8,k=k+1|0,(R|0)!=(k|0););if(w=w+1|0,(N|0)==(w|0))break}break f}if(e=0,X)for(;;){for(_=r+G(e,O)|0,Q=(G(e,B)<<1)+h|0,V=(G(e,o)<<1)+f|0,E=(G(e,a)<<1)+S|0,w=(G(e,$)<<1)+z|0,k=0;M=k<<1,m=C[M+w>>1],X=C[E+M>>1],F=_+G(k,P)|0,s=C[V+M>>1],u[F+5|0]=s,u[F+3|0]=X,u[F+1|0]=m,u[F+4|0]=s>>>8,u[F+2|0]=X>>>8,u[F|0]=m>>>8,s=C[Q+M>>1],s=s<<8|s>>>8,u[F+6|0]=s,u[F+7|0]=s>>>8,k=k+1|0,(R|0)!=(k|0););if(e=e+1|0,(N|0)==(e|0))break f}for(_=-1<<_^-1,Q=(_&65280)>>>8|0;;){for(V=r+G(e,O)|0,E=(G(e,o)<<1)+f|0,w=(G(e,a)<<1)+S|0,s=(G(e,$)<<1)+z|0,k=0;B=k<<1,X=C[B+s>>1],h=C[w+B>>1],B=C[B+E>>1],m=V+G(k,P)|0,u[m+7|0]=_,u[m+6|0]=Q,u[m+5|0]=B,u[m+3|0]=h,u[m+1|0]=X,u[m+4|0]=B>>>8,u[m+2|0]=h>>>8,u[m|0]=X>>>8,k=k+1|0,(R|0)!=(k|0););if(e=e+1|0,(N|0)==(e|0))break}}u[A+20|0]=0,i[A+4>>2]=n,i[A>>2]=I;break i}D6(A,107684)}if(A=i[n+4>>2],i[n+4>>2]=A-1,A)break i;W[i[i[n>>2]+8>>2]](n),y(n)}v=t+32|0}function cB(A,e,r,f,k,n,t,o){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,t=t|0,o=o|0;var s=0,w=0,h=0,_=0,B=0,m=0;w=v-80|0,v=w,_=M6(),Sr(_,n),h=w+56|0,m=i[e>>2],n=k,s=v+-64|0,v=s,B=i[r>>2],r=i[B+112>>2],k=i[B+108>>2];i:{if(!((k|0)>(t|0)|(r|0)>(t|0))){r=i[26917],i[h>>2]=i[26916],i[h+4>>2]=r,r=h+8|0;e:{if(u[107683]>=0){k=i[26919],i[r>>2]=i[26918],i[r+4>>2]=k,i[r+8>>2]=i[26920];break e}T(r,i[26918],i[26919])}u[h+20|0]=1;break i}e:{if((r|0)<(k|0)){r=(G(r,t)|0)/(k|0)|0,k=t;break e}k=(G(k,t)|0)/(r|0)|0,r=t}i[s+44>>2]=0,i[s+48>>2]=0,Bf(s+24|0,B,s+44|0,k&-2,r&-2,m- -64|0);e:{if(i[s+24>>2]){r=i[s+28>>2],i[h>>2]=i[s+24>>2],i[h+4>>2]=r,r=h+8|0;r:{if(u[s+43|0]>=0){k=i[s+36>>2],i[r>>2]=i[s+32>>2],i[r+4>>2]=k,i[r+8>>2]=i[s+40>>2];break r}T(r,i[s+32>>2],i[s+36>>2])}u[h+20|0]=1;break e}Oi(s,m,s+44|0,n,_,4);r:{f:{A:{k:switch(k=l[s+20|0],k|0){case 0:break f;case 1:break A;default:break k}_2(),H()}if(r=i[s+4>>2],i[h>>2]=i[s>>2],i[h+4>>2]=r,r=h+8|0,u[s+19|0]>=0){n=i[s+12>>2],i[r>>2]=i[s+8>>2],i[r+4>>2]=n,i[r+8>>2]=i[s+16>>2];break r}T(r,i[s+8>>2],i[s+12>>2]);break r}n=i[s>>2],r=i[s+4>>2],r&&(i[r+4>>2]=i[r+4>>2]+1),i[h+4>>2]=r,i[h>>2]=n}if(u[h+20|0]=k,r=l[s+20|0],(r|0)==255)break e;k=i[23599],i[s+56>>2]=i[23598],i[s+60>>2]=k,W[i[(s+56|0)+(r<<2)>>2]](s+55|0,s)}if(u[s+43|0]<0&&Z(i[s+32>>2]),r=i[s+48>>2],!r||(k=i[r+4>>2],i[r+4>>2]=k-1,k))break i;W[i[i[r>>2]+8>>2]](r),y(r)}v=s- -64|0,x2(_);i:{e:switch(l[w+76|0]){default:_2(),H();case 1:b0(A,w+56|0,i[e>>2]);break i;case 0:break e}k=i[w+56>>2],i[w+48>>2]=k,r=i[w+60>>2],i[w+52>>2]=r,r&&(i[r+4>>2]=i[r+4>>2]+1);e:{if(!k){if(f=p(64),i[w+12>>2]=f,i[w+16>>2]=57,i[w+20>>2]=-2147483584,u[f+56|0]=l[25489],k=l[25485]|l[25486]<<8|(l[25487]<<16|l[25488]<<24),n=l[25481]|l[25482]<<8|(l[25483]<<16|l[25484]<<24),u[f+48|0]=n,u[f+49|0]=n>>>8,u[f+50|0]=n>>>16,u[f+51|0]=n>>>24,u[f+52|0]=k,u[f+53|0]=k>>>8,u[f+54|0]=k>>>16,u[f+55|0]=k>>>24,k=l[25477]|l[25478]<<8|(l[25479]<<16|l[25480]<<24),n=l[25473]|l[25474]<<8|(l[25475]<<16|l[25476]<<24),u[f+40|0]=n,u[f+41|0]=n>>>8,u[f+42|0]=n>>>16,u[f+43|0]=n>>>24,u[f+44|0]=k,u[f+45|0]=k>>>8,u[f+46|0]=k>>>16,u[f+47|0]=k>>>24,k=l[25469]|l[25470]<<8|(l[25471]<<16|l[25472]<<24),n=l[25465]|l[25466]<<8|(l[25467]<<16|l[25468]<<24),u[f+32|0]=n,u[f+33|0]=n>>>8,u[f+34|0]=n>>>16,u[f+35|0]=n>>>24,u[f+36|0]=k,u[f+37|0]=k>>>8,u[f+38|0]=k>>>16,u[f+39|0]=k>>>24,k=l[25461]|l[25462]<<8|(l[25463]<<16|l[25464]<<24),n=l[25457]|l[25458]<<8|(l[25459]<<16|l[25460]<<24),u[f+24|0]=n,u[f+25|0]=n>>>8,u[f+26|0]=n>>>16,u[f+27|0]=n>>>24,u[f+28|0]=k,u[f+29|0]=k>>>8,u[f+30|0]=k>>>16,u[f+31|0]=k>>>24,k=l[25453]|l[25454]<<8|(l[25455]<<16|l[25456]<<24),n=l[25449]|l[25450]<<8|(l[25451]<<16|l[25452]<<24),u[f+16|0]=n,u[f+17|0]=n>>>8,u[f+18|0]=n>>>16,u[f+19|0]=n>>>24,u[f+20|0]=k,u[f+21|0]=k>>>8,u[f+22|0]=k>>>16,u[f+23|0]=k>>>24,k=l[25445]|l[25446]<<8|(l[25447]<<16|l[25448]<<24),n=l[25441]|l[25442]<<8|(l[25443]<<16|l[25444]<<24),u[f+8|0]=n,u[f+9|0]=n>>>8,u[f+10|0]=n>>>16,u[f+11|0]=n>>>24,u[f+12|0]=k,u[f+13|0]=k>>>8,u[f+14|0]=k>>>16,u[f+15|0]=k>>>24,k=l[25437]|l[25438]<<8|(l[25439]<<16|l[25440]<<24),n=l[25433]|l[25434]<<8|(l[25435]<<16|l[25436]<<24),u[f|0]=n,u[f+1|0]=n>>>8,u[f+2|0]=n>>>16,u[f+3|0]=n>>>24,u[f+4|0]=k,u[f+5|0]=k>>>8,u[f+6|0]=k>>>16,u[f+7|0]=k>>>24,u[f+57|0]=0,f=q(w+24|0,5,2006,w+12|0),u[w+23|0]<0&&Z(i[w+12>>2]),b0(A,f,i[e>>2]),u[f+19|0]>=0)break e;Z(i[f+8>>2]);break e}r=w+24|0,Fu(r,i[e>>2],f,w+48|0);r:{if(i[w+24>>2]!=i[26916]){b0(A,r,i[e>>2]);break r}f:{if(!o)break f;k=p(16),r=k,i[r>>2]=0,i[r+4>>2]=0,i[r+8>>2]=0,i[r+12>>2]=0,i[o>>2]=r,n=i[w+48>>2],f=i[w+52>>2];A:{if(!f){i[r+4>>2]=f,i[r>>2]=n;break A}if(i[f+4>>2]=i[f+4>>2]+1,i[k>>2]=n,r=i[k+4>>2],i[k+4>>2]=f,!r||(f=i[r+4>>2],i[r+4>>2]=f-1,f))break A;W[i[i[r>>2]+8>>2]](r),y(r)}if(k=i[e>>2],r=i[o>>2],f=i[e+4>>2],f&&(i[f+4>>2]=i[f+4>>2]+1),i[r+8>>2]=k,e=i[r+12>>2],i[r+12>>2]=f,!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break f;W[i[i[e>>2]+8>>2]](e),y(e)}e=i[24057],i[A>>2]=i[24056],i[A+4>>2]=e,i[A+8>>2]=i[24058]}u[w+43|0]<0&&Z(i[w+32>>2]),r=i[w+52>>2]}if(!r||(A=i[r+4>>2],i[r+4>>2]=A-1,A))break i;W[i[i[r>>2]+8>>2]](r),y(r)}A=l[w+76|0],(A|0)!=255&&(e=i[24201],i[w+24>>2]=i[24200],i[w+28>>2]=e,W[i[(w+24|0)+(A<<2)>>2]](w+12|0,w+56|0)),v=w+80|0}function bB(A,e,r,f,k,n,t,o,s,w){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,t=t|0,o=o|0,s=s|0,w=w|0;var h=0,_=0,B=0,m=0,X=0,Q=0,V=0,F=0,I=0,E=0,R=0,N=0,M=0,z=0,S=0,O=0,P=0;m=w-8|0,B=n+3|0,N=v-((G(B,k)<<1)+15&-16)|0;i:{if((n|0)>=-2){if((k|0)<=0)break i;for(V=r-2|0,R=N+2|0,r=n+2|0,F=(r|0)>0?r:0,S=k&2147483646,O=k&1,I=k-t&3,X=-1,E=k-1|0,P=E-t>>>0<3;;){_=R+(X<<1)|0,w=V+(G(f,X)<<1)|0;e:{r:{f:switch(t|0){case 0:if(s=0,r=t,I)for(;g[_+(G(r,B)<<1)>>1]=C[w+2>>1],r=r+1|0,w=w+2|0,s=s+1|0,(I|0)!=(s|0););if(P)break e;for(;g[_+(G(r,B)<<1)>>1]=C[w+2>>1],g[_+(G(r+1|0,B)<<1)>>1]=C[w+4>>1],g[_+(G(r+2|0,B)<<1)>>1]=C[w+6>>1],g[_+(G(r+3|0,B)<<1)>>1]=C[w+8>>1],w=w+8|0,r=r+4|0,(k|0)!=(r|0););break e;default:for(s=C[w>>1],r=0;h=C[w+2>>1],g[_+(G(r,B)<<1)>>1]=(G(C[w+4>>1],58)+G(h,10)|0)-(C[w+6>>1]+(s&65535)<<1)>>m,w=w+2|0,s=h,r=r+1|0,(k|0)!=(r|0););break e;case 1:for(s=C[w>>1],r=0;h=C[w+2>>1],g[_+(G(r,B)<<1)>>1]=(G(C[w+4>>1],10)+G(h,58)|0)-(C[w+6>>1]+(s&65535)<<1)>>m,w=w+2|0,s=h,r=r+1|0,(k|0)!=(r|0););break e;case 2:for(s=C[w>>1],r=0;h=s&65535,s=C[w+2>>1],g[_+(G(r,B)<<1)>>1]=G(s,54)+(C[w+4>>1]<<4)-((h<<2)+(C[w+6>>1]<<1))>>m,w=w+2|0,r=r+1|0,(k|0)!=(r|0););break e;case 3:for(s=C[w>>1],r=0;h=s&65535,s=C[w+2>>1],g[_+(G(r,B)<<1)>>1]=((G(s,46)+G(h,-6)|0)+G(C[w+4>>1],28)|0)-(C[w+6>>1]<<2)>>m,w=w+2|0,r=r+1|0,(k|0)!=(r|0););break e;case 4:if(s=C[w>>1],r=0,Q=0,!E)break r;for(;h=s&65535,s=C[w+4>>1],M=C[w+2>>1],z=C[w+6>>1],g[_+(G(r,B)<<1)>>1]=G(s+M|0,36)-(h+z<<2)>>m,g[_+(G(r|1,B)<<1)>>1]=G(s+z|0,36)-(C[w+8>>1]+M<<2)>>m,r=r+2|0,w=w+4|0,Q=Q+2|0,(S|0)!=(Q|0););break r;case 5:for(s=C[w>>1],r=0;h=s&65535,s=C[w+2>>1],g[_+(G(r,B)<<1)>>1]=((G(s,28)-(h<<2)|0)+G(C[w+4>>1],46)|0)+G(C[w+6>>1],-6)>>m,w=w+2|0,r=r+1|0,(k|0)!=(r|0););break e;case 6:break f}for(s=C[w>>1],r=0;h=s&65535,s=C[w+2>>1],g[_+(G(r,B)<<1)>>1]=G(C[w+4>>1],54)+(s<<4)-((h<<1)+(C[w+6>>1]<<2))>>m,w=w+2|0,r=r+1|0,(k|0)!=(r|0););break e}if(!O)break e;g[_+(G(r,B)<<1)>>1]=G(C[w+4>>1]+C[w+2>>1]|0,36)-(C[w+6>>1]+(s&65535)<<2)>>m}if(X=X+1|0,(F|0)==(X|0))break}}if((k|0)<=0|(n|0)<=0)break i;for(h=t?6:m,m=n&2147483646,I=n&1,_=n-o&3,X=0,V=n-1|0,R=V-o>>>0<3;;){t=(X<<1)+A|0,w=(G(B,X)<<1)+N|0;e:{r:{f:switch(o|0){case 0:if(s=0,r=o,_)for(;g[t+(G(e,r)<<1)>>1]=C[w+2>>1],r=r+1|0,w=w+2|0,s=s+1|0,(_|0)!=(s|0););if(R)break e;for(;g[t+(G(e,r)<<1)>>1]=C[w+2>>1],g[t+(G(r+1|0,e)<<1)>>1]=C[w+4>>1],g[t+(G(r+2|0,e)<<1)>>1]=C[w+6>>1],g[t+(G(r+3|0,e)<<1)>>1]=C[w+8>>1],w=w+8|0,r=r+4|0,(n|0)!=(r|0););break e;default:for(s=C[w>>1],r=0;f=g[w+2>>1],g[t+(G(e,r)<<1)>>1]=(G(g[w+4>>1],58)+G(f,10)|0)-(g[w+6>>1]+(s<<16>>16)<<1)>>h,w=w+2|0,s=f,r=r+1|0,(n|0)!=(r|0););break e;case 1:for(s=C[w>>1],r=0;f=g[w+2>>1],g[t+(G(e,r)<<1)>>1]=(G(g[w+4>>1],10)+G(f,58)|0)-(g[w+6>>1]+(s<<16>>16)<<1)>>h,w=w+2|0,s=f,r=r+1|0,(n|0)!=(r|0););break e;case 2:for(s=C[w>>1],r=0;f=s<<16>>16,s=g[w+2>>1],g[t+(G(e,r)<<1)>>1]=G(s,54)+(g[w+4>>1]<<4)-((f<<2)+(g[w+6>>1]<<1))>>h,w=w+2|0,r=r+1|0,(n|0)!=(r|0););break e;case 3:for(s=C[w>>1],r=0;f=s<<16>>16,s=g[w+2>>1],g[t+(G(e,r)<<1)>>1]=((G(s,46)+G(f,-6)|0)+G(g[w+4>>1],28)|0)-(g[w+6>>1]<<2)>>h,w=w+2|0,r=r+1|0,(n|0)!=(r|0););break e;case 4:if(s=C[w>>1],r=0,Q=0,!V)break r;for(;f=s<<16>>16,s=g[w+4>>1],F=g[w+2>>1],E=f,f=g[w+6>>1],g[t+(G(e,r)<<1)>>1]=G(s+F|0,36)-(E+f<<2)>>h,g[t+(G(r|1,e)<<1)>>1]=G(f+s|0,36)-(F+g[w+8>>1]<<2)>>h,r=r+2|0,w=w+4|0,Q=Q+2|0,(m|0)!=(Q|0););break r;case 5:for(s=C[w>>1],r=0;f=s<<16>>16,s=g[w+2>>1],g[t+(G(e,r)<<1)>>1]=((G(s,28)-(f<<2)|0)+G(g[w+4>>1],46)|0)+G(g[w+6>>1],-6)>>h,w=w+2|0,r=r+1|0,(n|0)!=(r|0););break e;case 6:break f}for(s=C[w>>1],r=0;f=s<<16>>16,s=g[w+2>>1],g[t+(G(e,r)<<1)>>1]=G(g[w+4>>1],54)+(s<<4)-((f<<1)+(g[w+6>>1]<<2))>>h,w=w+2|0,r=r+1|0,(n|0)!=(r|0););break e}if(!I)break e;g[t+(G(e,r)<<1)>>1]=G(g[w+4>>1]+g[w+2>>1]|0,36)-(g[w+6>>1]+(s<<16>>16)<<2)>>h}if(X=X+1|0,(X|0)==(k|0))break}}}function n1(A,e,r,f,k,n,t,o,s){var w=0,h=0,_=0,B=0,m=0,X=0,Q=0,V=0,F=0,I=0,E=0,R=0,N=0,M=0,z=0,S=0,O=0,P=0,a=0,$=0,f0=0,A0=0,n0=0,_0=0,m0=0,X0=0,g0=0,I0=0,e0=0,r0=0,N0=0,U0=0,M0=0,H0=0;h=v-96|0,v=h,R=s&65535,m=(k^s)&-2147483648,Q=k&65535,P=Q,M0=s>>>16&32767,H0=k>>>16&32767;i:{e:{if(M0-32767>>>0>4294934529&H0-32767>>>0>=4294934530)break e;if(_=k&2147483647,X=_,w=f,!(!w&(_|0)==2147418112?!(e|r):_>>>0<2147418112)){B=w,m=k|32768;break i}if(_=s&2147483647,k=o,!(!k&(_|0)==2147418112?!(n|t):_>>>0<2147418112)){B=k,m=s|32768,e=n,r=t;break i}if(!(e|w|(X^2147418112|r))){if(!(k|n|(t|_))){m=2147450880,e=0,r=0;break i}m=m|2147418112,e=0,r=0;break i}if(!(k|n|(_^2147418112|t))){if(k=e|w,f=r|X,e=0,r=0,!(f|k)){m=2147450880;break i}m=m|2147418112;break i}if(!(e|w|(r|X))){e=0,r=0;break i}if(!(k|n|(t|_))){e=0,r=0;break i}if((X|0)==65535|X>>>0<65535&&(w=!(f|Q),s=k1(w?r:Q),w=((s|0)==32?k1(w?e:f)+32|0:s)+(w?64:0)|0,o4(h+80|0,e,r,f,Q,w-15|0),I=16-w|0,f=i[h+88>>2],P=i[h+92>>2],r=i[h+84>>2],e=i[h+80>>2]),_>>>0>65535)break e;s=!(o|R),k=k1(s?t:R),s=((k|0)==32?k1(s?n:o)+32|0:k)+(s?64:0)|0,o4(h- -64|0,n,t,o,R,s-15|0),I=(I-s|0)+16|0,o=i[h+72>>2],R=i[h+76>>2],n=i[h+64>>2],t=i[h+68>>2]}k=n,n=t<<15|k>>>17,s=k<<15,k=0,N=s&-32768,I0=r,S=O0(N,k,r,0),k=l0,a=k,e0=n,V=e,e=O0(n,0,e,0),r=e+S|0,w=l0+k|0,s=e>>>0>r>>>0?w+1|0:w,w=0,e=O0(V,E,N,E),X=w+e|0,n=r,k=n+l0|0,k=e>>>0>X>>>0?k+1|0:k,Q=k,r=(n|0)==(k|0)&w>>>0>X>>>0|k>>>0<n>>>0,r0=f,F=O0(N,E,f,0),N0=l0,e=O0(I0,O,e0,O),M=e+F|0,w=l0+N0|0,w=e>>>0>M>>>0?w+1|0:w,_=w,e=R<<15|o>>>17,f0=o<<15|t>>>17,f=O0(f0,0,V,E),A0=f+M|0,w=l0+w|0,w=f>>>0>A0>>>0?w+1|0:w,n0=w,k=s,_0=k+A0|0,n=((k|0)==(a|0)&n>>>0<S>>>0|k>>>0<a>>>0)+w|0,n=k>>>0>_0>>>0?n+1|0:n,s=n,t=_0,m0=P|65536,a=O0(N,E,m0,z),U0=l0,f=O0(r0,B,e0,O),N=f+a|0,k=l0+U0|0,k=f>>>0>N>>>0?k+1|0:k,o=k,X0=e|-2147483648,e=O0(X0,0,V,E),E=e+N|0,w=l0+k|0,w=e>>>0>E>>>0?w+1|0:w,e=O0(f0,B,I0,O),z=e+E|0,g0=w,n=w+l0|0,R=e>>>0>z>>>0?n+1|0:n,e=0,S=e+t|0,k=s+z|0,k=e>>>0>S>>>0?k+1|0:k,P=k,e=S+r|0,r=e>>>0<S>>>0?k+1|0:k,I=((H0+M0|0)+I|0)-16383|0,f=O0(X0,$,I0,O),t=l0,n=O0(m0,B,e0,O),k=n+f|0,w=l0+t|0,w=k>>>0<n>>>0?w+1|0:w,V=(t|0)==(w|0)&f>>>0>k>>>0|t>>>0>w>>>0,t=O0(f0,B,r0,B),f=t+k|0,n=l0+w|0,n=f>>>0<t>>>0?n+1|0:n,k=(n|0)==(w|0)&f>>>0<k>>>0|n>>>0<w>>>0,w=0,t=k,k=k+V|0,w=t>>>0>k>>>0?1:w,t=k,k=O0(X0,$,m0,B),t=t+k|0,w=l0+w|0,w=k>>>0>t>>>0?w+1|0:w,O=t,t=f,V=n,k=(_|0)==(N0|0)&F>>>0>M>>>0|_>>>0<N0>>>0,n=0,_=(_|0)==(n0|0)&M>>>0>A0>>>0|_>>>0>n0>>>0,F=_,_=k+_|0,k=(F>>>0>_>>>0?1:n)+V|0,f=f+_|0,k=f>>>0<_>>>0?k+1|0:k,_=k,M=f,f=(k|0)==(V|0)&f>>>0<t>>>0|k>>>0<V>>>0,k=f,f=f+O|0,w=k>>>0>f>>>0?w+1|0:w,V=f,F=w,k=O0(f0,B,m0,B),w=l0,t=O0(X0,$,r0,B),f=t+k|0,n=l0+w|0,n=f>>>0<t>>>0?n+1|0:n,t=n,n=(w|0)==(n|0)&f>>>0<k>>>0|n>>>0<w>>>0,$=V+t|0,k=n+F|0,k=t>>>0>$>>>0?k+1|0:k,F=$,w=f,n=0,f=n+M|0,w=w+_|0,w=f>>>0<n>>>0?w+1|0:w,n=k,t=(w|0)==(_|0)&f>>>0<M>>>0|w>>>0<_>>>0,k=t+F|0,n=t>>>0>k>>>0?n+1|0:n,M=k,t=n,_=f,F=w,n=(R|0)==(g0|0)&E>>>0>z>>>0|R>>>0<g0>>>0,k=(o|0)==(U0|0)&N>>>0<a>>>0|o>>>0<U0>>>0,o=(o|0)==(g0|0)&E>>>0<N>>>0|o>>>0>g0>>>0,k=k+o|0,n=k+n|0,o=R,f=o+f|0,k=n+F|0,n=t,k=f>>>0<o>>>0?k+1|0:k,o=(k|0)==(F|0)&f>>>0<_>>>0|k>>>0<F>>>0,t=o+M|0,n=o>>>0>t>>>0?n+1|0:n,z=t,w=n,t=f,o=k,k=(s|0)==(n0|0)&A0>>>0>_0>>>0|s>>>0<n0>>>0,n=0,s=(s|0)==(P|0)&S>>>0<_0>>>0|s>>>0>P>>>0,V=s,s=k+s|0,k=(V>>>0>s>>>0?1:n)+o|0,f=f+s|0,k=f>>>0<s>>>0?k+1|0:k,n=(k|0)==(o|0)&f>>>0<t>>>0|k>>>0<o>>>0,o=n+z|0,w=n>>>0>o>>>0?w+1|0:w,s=w;e:{if(w&65536){I=I+1|0;break e}z=Q>>>31|0,w=s<<1|o>>>31,o=o<<1|k>>>31,s=w,w=k<<1|f>>>31,f=f<<1|r>>>31,k=w,w=Q<<1|X>>>31,X=X<<1,Q=w,w=r<<1|e>>>31,e=e<<1|z,r=w}if((I|0)>=32767){m=m|2147418112,e=0,r=0;break i}e:{if((I|0)<=0){if(t=1-I|0,t>>>0<=127){n=I+127|0,o4(h+48|0,X,Q,e,r,n),o4(h+32|0,f,k,o,s,n),Y6(h+16|0,X,Q,e,r,t),Y6(h,f,k,o,s,t),X=i[h+32>>2]|i[h+16>>2]|(i[h+48>>2]|i[h+56>>2]|(i[h+52>>2]|i[h+60>>2]))!=0,Q=i[h+36>>2]|i[h+20>>2],e=i[h+40>>2]|i[h+24>>2],r=i[h+44>>2]|i[h+28>>2],f=i[h>>2],k=i[h+4>>2],t=i[h+8>>2],n=i[h+12>>2];break e}e=0,r=0;break i}t=o,n=s&65535|I<<16}if(B=t|B,m=n|m,!(!e&(r|0)==-2147483648?!(X|Q):(r|0)>0|(r|0)>=0)){e=f+1|0,w=e?k:k+1|0,k=m,r=w,f=!(w|e),B=f+B|0,m=f>>>0>B>>>0?k+1|0:k;break i}if(e|X|(r^-2147483648|Q)){e=f,r=k;break i}n=m,e=f&1,r=e,e=e+f|0,r=r>>>0>e>>>0?k+1|0:k,f=(k|0)==(r|0)&e>>>0<f>>>0|r>>>0<k>>>0,B=f+B|0,m=f>>>0>B>>>0?n+1|0:n}i[A>>2]=e,i[A+4>>2]=r,i[A+8>>2]=B,i[A+12>>2]=m,v=h+96|0}function iv(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,t=0,o=0,s=0,w=0,h=0,_=0;t=v-48|0,v=t,_=W[i[i[e>>2]+52>>2]](e,r,0)|0,w=t+24|0,o=v-16|0,v=o,l2(r,l[e+100|0]),l2(r,(l[e+103|0]&31|(l[e+102|0]<<5|l[e+101|0]<<6))&255),F0(r,i[e+104>>2]),f=l[e+108|0],k=f>>>6|0,n=f>>>4|0,l2(r,((k&1|((n&1|(f>>>2&2|(f&4|f<<2&8)))<<2|n&2))<<2|k)&254),f=i[e+108>>2],k=f>>>14|0,n=f>>>12|0,s=f>>>10|0,l2(r,((k&1|((n&1|((s&1|f>>>8&2)<<2|s&2))<<2|n&2))<<2|k&2)&254),f=i[e+108>>2],k=f>>>22|0,n=f>>>20|0,s=f>>>18|0,l2(r,((k&1|((n&1|((s&1|f>>>16&2)<<2|s&2))<<2|n&2))<<2|k&2)&254),f=i[e+108>>2],k=f>>>30|0,n=f>>>28|0,s=f>>>26|0,l2(r,((k&1|((n&1|((s&1|f>>>24&2)<<2|s&2))<<2|n&2))<<2|k)&254),f=l[e+112|0],k=f>>>6|0,n=f>>>4|0,l2(r,((k&1|((n&1|(f>>>2&2|(f&4|f<<2&8)))<<2|n&2))<<2|k)&254),f=i[e+112>>2],k=f>>>14|0,n=f>>>12|0,s=f>>>10|0,l2(r,((k&1|((n&1|((s&1|f>>>8&2)<<2|s&2))<<2|n&2))<<2|k&2)&254),l2(r,l[e+116|0]),u2(r,C[e+118>>1]|61440),l2(r,l[e+120|0]|252),l2(r,l[e+121|0]|252),l2(r,l[e+122|0]|248),l2(r,l[e+123|0]|248),u2(r,C[e+124>>1]),l2(r,(l[e+129|0]-1&3|(l[e+128|0]<<2&4|(l[e+127|0]<<3&56|l[e+126|0]<<6)))&255),l2(r,i[e+136>>2]-i[e+132>>2]>>>4&255),f=i[e+132>>2],n=i[e+136>>2];i:{if((f|0)!=(n|0))for(;;){if(l2(r,l[f|0]<<6&64|l[f+1|0]&63),k=(i[f+8>>2]-i[f+4>>2]|0)/12|0,k>>>0>=65536){if(f=p(32),i[o+4>>2]=f,i[o+8>>2]=26,i[o+12>>2]=-2147483616,k=l[19936]|l[19937]<<8|(l[19938]<<16|l[19939]<<24),n=l[19932]|l[19933]<<8|(l[19934]<<16|l[19935]<<24),u[f|0]=n,u[f+1|0]=n>>>8,u[f+2|0]=n>>>16,u[f+3|0]=n>>>24,u[f+4|0]=k,u[f+5|0]=k>>>8,u[f+6|0]=k>>>16,u[f+7|0]=k>>>24,u[f+26|0]=0,k=l[19956]|l[19957]<<8,u[f+24|0]=k,u[f+25|0]=k>>>8,k=l[19952]|l[19953]<<8|(l[19954]<<16|l[19955]<<24),n=l[19948]|l[19949]<<8|(l[19950]<<16|l[19951]<<24),u[f+16|0]=n,u[f+17|0]=n>>>8,u[f+18|0]=n>>>16,u[f+19|0]=n>>>24,u[f+20|0]=k,u[f+21|0]=k>>>8,u[f+22|0]=k>>>16,u[f+23|0]=k>>>24,k=l[19944]|l[19945]<<8|(l[19946]<<16|l[19947]<<24),n=l[19940]|l[19941]<<8|(l[19942]<<16|l[19943]<<24),u[f+8|0]=n,u[f+9|0]=n>>>8,u[f+10|0]=n>>>16,u[f+11|0]=n>>>24,u[f+12|0]=k,u[f+13|0]=k>>>8,u[f+14|0]=k>>>16,u[f+15|0]=k>>>24,q(w,2,0,o+4|0),u[o+15|0]>=0)break i;Z(i[o+4>>2]);break i}if(u2(r,k),k=i[f+4>>2],s=i[f+8>>2],(k|0)!=(s|0))for(;;){if(h=i[k+4>>2]-i[k>>2]|0,h>>>0>=65536){if(f=p(48),i[o+4>>2]=f,i[o+8>>2]=41,i[o+12>>2]=-2147483600,k=l[26589]|l[26590]<<8|(l[26591]<<16|l[26592]<<24),n=l[26585]|l[26586]<<8|(l[26587]<<16|l[26588]<<24),u[f|0]=n,u[f+1|0]=n>>>8,u[f+2|0]=n>>>16,u[f+3|0]=n>>>24,u[f+4|0]=k,u[f+5|0]=k>>>8,u[f+6|0]=k>>>16,u[f+7|0]=k>>>24,u[f+41|0]=0,u[f+40|0]=l[26625],k=l[26621]|l[26622]<<8|(l[26623]<<16|l[26624]<<24),n=l[26617]|l[26618]<<8|(l[26619]<<16|l[26620]<<24),u[f+32|0]=n,u[f+33|0]=n>>>8,u[f+34|0]=n>>>16,u[f+35|0]=n>>>24,u[f+36|0]=k,u[f+37|0]=k>>>8,u[f+38|0]=k>>>16,u[f+39|0]=k>>>24,k=l[26613]|l[26614]<<8|(l[26615]<<16|l[26616]<<24),n=l[26609]|l[26610]<<8|(l[26611]<<16|l[26612]<<24),u[f+24|0]=n,u[f+25|0]=n>>>8,u[f+26|0]=n>>>16,u[f+27|0]=n>>>24,u[f+28|0]=k,u[f+29|0]=k>>>8,u[f+30|0]=k>>>16,u[f+31|0]=k>>>24,k=l[26605]|l[26606]<<8|(l[26607]<<16|l[26608]<<24),n=l[26601]|l[26602]<<8|(l[26603]<<16|l[26604]<<24),u[f+16|0]=n,u[f+17|0]=n>>>8,u[f+18|0]=n>>>16,u[f+19|0]=n>>>24,u[f+20|0]=k,u[f+21|0]=k>>>8,u[f+22|0]=k>>>16,u[f+23|0]=k>>>24,k=l[26597]|l[26598]<<8|(l[26599]<<16|l[26600]<<24),n=l[26593]|l[26594]<<8|(l[26595]<<16|l[26596]<<24),u[f+8|0]=n,u[f+9|0]=n>>>8,u[f+10|0]=n>>>16,u[f+11|0]=n>>>24,u[f+12|0]=k,u[f+13|0]=k>>>8,u[f+14|0]=k>>>16,u[f+15|0]=k>>>24,q(w,2,0,o+4|0),u[o+15|0]>=0)break i;Z(i[o+4>>2]);break i}if(u2(r,h),I4(r,k),k=k+12|0,(s|0)==(k|0))break}if(f=f+16|0,(n|0)==(f|0))break}if(f=i[26917],i[w>>2]=i[26916],i[w+4>>2]=f,f=w+8|0,u[107683]>=0){w=i[26919],i[f>>2]=i[26918],i[f+4>>2]=w,i[f+8>>2]=i[26920];break i}T(f,i[26918],i[26919])}v=o+16|0;i:{if(i[t+24>>2]){e=i[t+28>>2],i[A>>2]=i[t+24>>2],i[A+4>>2]=e,i[A+16>>2]=i[t+40>>2],e=i[t+36>>2],i[A+8>>2]=i[t+32>>2],i[A+12>>2]=e,i[t+40>>2]=0,i[t+32>>2]=0,i[t+36>>2]=0;break i}if(f1(t+4|0,e,r,_),u[t+23|0]<0&&Z(i[t+12>>2]),e=i[26917],i[A>>2]=i[26916],i[A+4>>2]=e,A=A+8|0,u[107683]>=0){e=i[26919],i[A>>2]=i[26918],i[A+4>>2]=e,i[A+8>>2]=i[26920];break i}T(A,i[26918],i[26919])}u[t+43|0]<0&&Z(i[t+32>>2]),v=t+48|0}function ev(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0;var k=0,n=0,t=0,o=0,s=0,w=0,h=0,_=0,B=0,m=0,X=0,Q=0,V=0;k=v-16|0,v=k,Q=e,V=C0(r),i[Q+100>>2]=V,Q=e,V=C0(r),i[Q+104>>2]=V;i:{e:{if(o=i[e+12>>2],t=i[e+8>>2],!o&t>>>0>=8|o&&(n=o-(t>>>0<8)|0,t=t-8|0,w=i[e+32>>2],!n&t>>>0>=w>>>0|n))break e;if(e=p(40),i[k+4>>2]=e,i[k+8>>2]=38,i[k+12>>2]=-2147483608,r=l[26384]|l[26385]<<8|(l[26386]<<16|l[26387]<<24),f=l[26380]|l[26381]<<8|(l[26382]<<16|l[26383]<<24),u[e|0]=f,u[e+1|0]=f>>>8,u[e+2|0]=f>>>16,u[e+3|0]=f>>>24,u[e+4|0]=r,u[e+5|0]=r>>>8,u[e+6|0]=r>>>16,u[e+7|0]=r>>>24,u[e+38|0]=0,r=l[26414]|l[26415]<<8|(l[26416]<<16|l[26417]<<24),f=l[26410]|l[26411]<<8|(l[26412]<<16|l[26413]<<24),u[e+30|0]=f,u[e+31|0]=f>>>8,u[e+32|0]=f>>>16,u[e+33|0]=f>>>24,u[e+34|0]=r,u[e+35|0]=r>>>8,u[e+36|0]=r>>>16,u[e+37|0]=r>>>24,r=l[26408]|l[26409]<<8|(l[26410]<<16|l[26411]<<24),f=l[26404]|l[26405]<<8|(l[26406]<<16|l[26407]<<24),u[e+24|0]=f,u[e+25|0]=f>>>8,u[e+26|0]=f>>>16,u[e+27|0]=f>>>24,u[e+28|0]=r,u[e+29|0]=r>>>8,u[e+30|0]=r>>>16,u[e+31|0]=r>>>24,r=l[26400]|l[26401]<<8|(l[26402]<<16|l[26403]<<24),f=l[26396]|l[26397]<<8|(l[26398]<<16|l[26399]<<24),u[e+16|0]=f,u[e+17|0]=f>>>8,u[e+18|0]=f>>>16,u[e+19|0]=f>>>24,u[e+20|0]=r,u[e+21|0]=r>>>8,u[e+22|0]=r>>>16,u[e+23|0]=r>>>24,r=l[26392]|l[26393]<<8|(l[26394]<<16|l[26395]<<24),f=l[26388]|l[26389]<<8|(l[26390]<<16|l[26391]<<24),u[e+8|0]=f,u[e+9|0]=f>>>8,u[e+10|0]=f>>>16,u[e+11|0]=f>>>24,u[e+12|0]=r,u[e+13|0]=r>>>8,u[e+14|0]=r>>>16,u[e+15|0]=r>>>24,q(A,2,101,k+4|0),u[k+15|0]>=0)break i;Z(i[k+4>>2]);break i}if(m=t-w|0,o=m,t=n-(t>>>0<w>>>0)|0,w=t>>>2|0,m=(t&3)<<30|o>>>2,!w&u0[f+84>>2]>=m>>>0){e:{f=l[r+20|0];r:{if(!(!t&o>>>0<4|f&1)){o=0,t=0;f:{A:{for(;;){_=C0(r),f=i[e+112>>2],s=i[e+116>>2];k:{if(f>>>0<s>>>0){i[f>>2]=_,f=f+4|0;break k}if(B=i[e+108>>2],f=f-B|0,X=f>>2,n=X+1|0,n>>>0>=1073741824)break A;if(s=s-B|0,h=s>>1,s=s>>>0>=2147483644?1073741823:n>>>0<h>>>0?h:n,s){if(s>>>0>=1073741824)break f;n=p(s<<2)}else n=0;if(h=n+f|0,i[h>>2]=_,_=h-(X<<2)|0,f&&x(_,B,f),i[e+116>>2]=n+(s<<2),f=h+4|0,i[e+112>>2]=f,i[e+108>>2]=_,!B)break k;Z(B)}if(i[e+112>>2]=f,f=t,n=u[r+20|0]&1,o=o+1|0,f=o?f:f+1|0,t=f,!(!n&((f|0)==(w|0)&o>>>0<m>>>0|f>>>0<w>>>0)))break}if(n)break r;break e}G0(),H()}z0(),H()}if(!(f&1))break e}if(u[k+4|0]=0,u[k+15|0]=0,q(A,2,100,k+4|0),u[k+15|0]>=0)break i;Z(i[k+4>>2]);break i}if(e=i[26917],i[A>>2]=i[26916],i[A+4>>2]=e,A=A+8|0,u[107683]>=0){e=i[26919],i[A>>2]=i[26918],i[A+4>>2]=e,i[A+8>>2]=i[26920];break i}T(A,i[26918],i[26919]);break i}if(e=p(56),i[k+4>>2]=e,i[k+8>>2]=53,i[k+12>>2]=-2147483592,r=l[3929]|l[3930]<<8|(l[3931]<<16|l[3932]<<24),f=l[3925]|l[3926]<<8|(l[3927]<<16|l[3928]<<24),u[e|0]=f,u[e+1|0]=f>>>8,u[e+2|0]=f>>>16,u[e+3|0]=f>>>24,u[e+4|0]=r,u[e+5|0]=r>>>8,u[e+6|0]=r>>>16,u[e+7|0]=r>>>24,u[e+53|0]=0,r=l[3974]|l[3975]<<8|(l[3976]<<16|l[3977]<<24),f=l[3970]|l[3971]<<8|(l[3972]<<16|l[3973]<<24),u[e+45|0]=f,u[e+46|0]=f>>>8,u[e+47|0]=f>>>16,u[e+48|0]=f>>>24,u[e+49|0]=r,u[e+50|0]=r>>>8,u[e+51|0]=r>>>16,u[e+52|0]=r>>>24,r=l[3969]|l[3970]<<8|(l[3971]<<16|l[3972]<<24),f=l[3965]|l[3966]<<8|(l[3967]<<16|l[3968]<<24),u[e+40|0]=f,u[e+41|0]=f>>>8,u[e+42|0]=f>>>16,u[e+43|0]=f>>>24,u[e+44|0]=r,u[e+45|0]=r>>>8,u[e+46|0]=r>>>16,u[e+47|0]=r>>>24,r=l[3961]|l[3962]<<8|(l[3963]<<16|l[3964]<<24),f=l[3957]|l[3958]<<8|(l[3959]<<16|l[3960]<<24),u[e+32|0]=f,u[e+33|0]=f>>>8,u[e+34|0]=f>>>16,u[e+35|0]=f>>>24,u[e+36|0]=r,u[e+37|0]=r>>>8,u[e+38|0]=r>>>16,u[e+39|0]=r>>>24,r=l[3953]|l[3954]<<8|(l[3955]<<16|l[3956]<<24),f=l[3949]|l[3950]<<8|(l[3951]<<16|l[3952]<<24),u[e+24|0]=f,u[e+25|0]=f>>>8,u[e+26|0]=f>>>16,u[e+27|0]=f>>>24,u[e+28|0]=r,u[e+29|0]=r>>>8,u[e+30|0]=r>>>16,u[e+31|0]=r>>>24,r=l[3945]|l[3946]<<8|(l[3947]<<16|l[3948]<<24),f=l[3941]|l[3942]<<8|(l[3943]<<16|l[3944]<<24),u[e+16|0]=f,u[e+17|0]=f>>>8,u[e+18|0]=f>>>16,u[e+19|0]=f>>>24,u[e+20|0]=r,u[e+21|0]=r>>>8,u[e+22|0]=r>>>16,u[e+23|0]=r>>>24,r=l[3937]|l[3938]<<8|(l[3939]<<16|l[3940]<<24),f=l[3933]|l[3934]<<8|(l[3935]<<16|l[3936]<<24),u[e+8|0]=f,u[e+9|0]=f>>>8,u[e+10|0]=f>>>16,u[e+11|0]=f>>>24,u[e+12|0]=r,u[e+13|0]=r>>>8,u[e+14|0]=r>>>16,u[e+15|0]=r>>>24,q(A,6,1e3,k+4|0),u[k+15|0]>=0)break i;Z(i[k+4>>2])}v=k+16|0}function rv(A,e,r,f,k,n,t,o,s,w){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,t=t|0,o=o|0,s=s|0,w=w|0;var h=0,_=0,B=0,m=0,X=0,Q=0,V=0,F=0,I=0,E=0,R=0,N=0,M=0,z=0,S=0,O=0,P=0;m=w-8|0,B=n+3|0,N=v-((G(B,k)<<1)+15&-16)|0;i:{if((n|0)>=-2){if((k|0)<=0)break i;for(V=r-1|0,R=N+2|0,r=n+2|0,F=(r|0)>0?r:0,S=k&2147483646,O=k&1,I=k-t&3,X=-1,E=k-1|0,P=E-t>>>0<3;;){_=R+(X<<1)|0,w=V+G(f,X)|0;e:{r:{f:switch(t|0){case 0:if(s=0,r=t,I)for(;g[_+(G(r,B)<<1)>>1]=l[w+1|0],r=r+1|0,w=w+1|0,s=s+1|0,(I|0)!=(s|0););if(P)break e;for(;g[_+(G(r,B)<<1)>>1]=l[w+1|0],g[_+(G(r+1|0,B)<<1)>>1]=l[w+2|0],g[_+(G(r+2|0,B)<<1)>>1]=l[w+3|0],g[_+(G(r+3|0,B)<<1)>>1]=l[w+4|0],w=w+4|0,r=r+4|0,(k|0)!=(r|0););break e;default:for(s=l[w|0],r=0;h=l[w+1|0],g[_+(G(r,B)<<1)>>1]=(G(l[w+2|0],58)+G(h,10)|0)-(l[w+3|0]+(s&255)<<1)>>m,w=w+1|0,s=h,r=r+1|0,(k|0)!=(r|0););break e;case 1:for(s=l[w|0],r=0;h=l[w+1|0],g[_+(G(r,B)<<1)>>1]=(G(l[w+2|0],10)+G(h,58)|0)-(l[w+3|0]+(s&255)<<1)>>m,w=w+1|0,s=h,r=r+1|0,(k|0)!=(r|0););break e;case 2:for(s=l[w|0],r=0;h=s&255,s=l[w+1|0],g[_+(G(r,B)<<1)>>1]=G(s,54)+(l[w+2|0]<<4)-((h<<2)+(l[w+3|0]<<1))>>m,w=w+1|0,r=r+1|0,(k|0)!=(r|0););break e;case 3:for(s=l[w|0],r=0;h=s&255,s=l[w+1|0],g[_+(G(r,B)<<1)>>1]=((G(s,46)+G(h,-6)|0)+G(l[w+2|0],28)|0)-(l[w+3|0]<<2)>>m,w=w+1|0,r=r+1|0,(k|0)!=(r|0););break e;case 4:if(s=l[w|0],r=0,Q=0,!E)break r;for(;h=s&255,s=l[w+2|0],M=l[w+1|0],z=l[w+3|0],g[_+(G(r,B)<<1)>>1]=G(s+M|0,36)-(h+z<<2)>>m,g[_+(G(r|1,B)<<1)>>1]=G(s+z|0,36)-(l[w+4|0]+M<<2)>>m,r=r+2|0,w=w+2|0,Q=Q+2|0,(S|0)!=(Q|0););break r;case 5:for(s=l[w|0],r=0;h=s&255,s=l[w+1|0],g[_+(G(r,B)<<1)>>1]=((G(s,28)-(h<<2)|0)+G(l[w+2|0],46)|0)+G(l[w+3|0],-6)>>m,w=w+1|0,r=r+1|0,(k|0)!=(r|0););break e;case 6:break f}for(s=l[w|0],r=0;h=s&255,s=l[w+1|0],g[_+(G(r,B)<<1)>>1]=G(l[w+2|0],54)+(s<<4)-((h<<1)+(l[w+3|0]<<2))>>m,w=w+1|0,r=r+1|0,(k|0)!=(r|0););break e}if(!O)break e;g[_+(G(r,B)<<1)>>1]=G(l[w+2|0]+l[w+1|0]|0,36)-(l[w+3|0]+(s&255)<<2)>>m}if(X=X+1|0,(F|0)==(X|0))break}}if((k|0)<=0|(n|0)<=0)break i;for(h=t?6:m,m=n&2147483646,I=n&1,_=n-o&3,X=0,V=n-1|0,R=V-o>>>0<3;;){t=(X<<1)+A|0,w=(G(B,X)<<1)+N|0;e:{r:{f:switch(o|0){case 0:if(s=0,r=o,_)for(;g[t+(G(e,r)<<1)>>1]=C[w+2>>1],r=r+1|0,w=w+2|0,s=s+1|0,(_|0)!=(s|0););if(R)break e;for(;g[t+(G(e,r)<<1)>>1]=C[w+2>>1],g[t+(G(r+1|0,e)<<1)>>1]=C[w+4>>1],g[t+(G(r+2|0,e)<<1)>>1]=C[w+6>>1],g[t+(G(r+3|0,e)<<1)>>1]=C[w+8>>1],w=w+8|0,r=r+4|0,(n|0)!=(r|0););break e;default:for(s=C[w>>1],r=0;f=g[w+2>>1],g[t+(G(e,r)<<1)>>1]=(G(g[w+4>>1],58)+G(f,10)|0)-(g[w+6>>1]+(s<<16>>16)<<1)>>h,w=w+2|0,s=f,r=r+1|0,(n|0)!=(r|0););break e;case 1:for(s=C[w>>1],r=0;f=g[w+2>>1],g[t+(G(e,r)<<1)>>1]=(G(g[w+4>>1],10)+G(f,58)|0)-(g[w+6>>1]+(s<<16>>16)<<1)>>h,w=w+2|0,s=f,r=r+1|0,(n|0)!=(r|0););break e;case 2:for(s=C[w>>1],r=0;f=s<<16>>16,s=g[w+2>>1],g[t+(G(e,r)<<1)>>1]=G(s,54)+(g[w+4>>1]<<4)-((f<<2)+(g[w+6>>1]<<1))>>h,w=w+2|0,r=r+1|0,(n|0)!=(r|0););break e;case 3:for(s=C[w>>1],r=0;f=s<<16>>16,s=g[w+2>>1],g[t+(G(e,r)<<1)>>1]=((G(s,46)+G(f,-6)|0)+G(g[w+4>>1],28)|0)-(g[w+6>>1]<<2)>>h,w=w+2|0,r=r+1|0,(n|0)!=(r|0););break e;case 4:if(s=C[w>>1],r=0,Q=0,!V)break r;for(;f=s<<16>>16,s=g[w+4>>1],F=g[w+2>>1],E=f,f=g[w+6>>1],g[t+(G(e,r)<<1)>>1]=G(s+F|0,36)-(E+f<<2)>>h,g[t+(G(r|1,e)<<1)>>1]=G(f+s|0,36)-(F+g[w+8>>1]<<2)>>h,r=r+2|0,w=w+4|0,Q=Q+2|0,(m|0)!=(Q|0););break r;case 5:for(s=C[w>>1],r=0;f=s<<16>>16,s=g[w+2>>1],g[t+(G(e,r)<<1)>>1]=((G(s,28)-(f<<2)|0)+G(g[w+4>>1],46)|0)+G(g[w+6>>1],-6)>>h,w=w+2|0,r=r+1|0,(n|0)!=(r|0););break e;case 6:break f}for(s=C[w>>1],r=0;f=s<<16>>16,s=g[w+2>>1],g[t+(G(e,r)<<1)>>1]=G(g[w+4>>1],54)+(s<<4)-((f<<1)+(g[w+6>>1]<<2))>>h,w=w+2|0,r=r+1|0,(n|0)!=(r|0););break e}if(!I)break e;g[t+(G(e,r)<<1)>>1]=G(g[w+4>>1]+g[w+2>>1]|0,36)-(g[w+6>>1]+(s<<16>>16)<<2)>>h}if(X=X+1|0,(X|0)==(k|0))break}}}function fv(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,t=0,o=0,s=0,w=0,h=0,_=0,B=0,m=0;if(n=v-32|0,v=n,_=W[i[i[e>>2]+52>>2]](e,r,0)|0,l2(r,l[e+105|0]|l[e+104|0]<<1&6|248),l[e+105|0]==1){u2(r,(l[e+110|0]|(l[e+108|0]<<4|C[e+106>>1]<<7|l[e+109|0]<<2))&65535),l2(r,(l[e+111|0]<<5|31)&255),l2(r,l[e+112|0]&63),l2(r,l[e+114|0]|l[e+113|0]<<1&254),l2(r,l[e+115|0]);i:{if(!l[e+112|0]||(l2(r,(l[i[e+120>>2]]|(l[e+117|0]<<6|l[e+116|0]<<7))&255),k=1,l[e+112|0]<=1))break i;for(;l2(r,l[i[e+120>>2]+k|0]),k=k+1|0,k>>>0<l[e+112|0];);}f=l[e+108|0];i:{if(f>>>0<=1)break i;t=f-1|0,w=t&1,o=i[e+132>>2],k=f-2|0;e:{if(!k){t=128,f=0;break e}for(B=t&-2,t=128,f=0;s=k-1|0,m=0-(i[o+(s>>>3&536870908)>>2]>>>s&1)|0,s=t&255,f=m&s>>>1|(0-(i[o+(k>>>3&536870908)>>2]>>>k&1)&t|f),k=k-2|0,t=s>>>2|0,h=h+2|0,(h|0)!=(B|0););}if(w&&(f=0-(i[o+(k>>>3&536870908)>>2]>>>k&1)&t|f),l2(r,f&255),f=l[e+108|0],f>>>0<2)break i;for(k=f-2|0;i[i[e+132>>2]+(k>>>3&536870908)>>2]>>>k&1&&l2(r,l[i[e+144>>2]+k|0]),f=(k|0)>0,k=k-1|0,!!f;);}if(f=i[e+160>>2]-i[e+156>>2]>>>2&255,l2(r,f),f)for(k=0;F0(r,i[i[e+156>>2]+(k<<2)>>2]),k=k+1|0,(f|0)!=(k|0););u2(r,C[e+168>>1]),u2(r,C[e+170>>1]),u2(r,C[e+172>>1])}f=i[e+180>>2]-i[e+176>>2]>>4;i:{if(f>>>0>=256){if(e=p(32),i[n+20>>2]=e,i[n+24>>2]=24,i[n+28>>2]=-2147483616,r=l[23634]|l[23635]<<8|(l[23636]<<16|l[23637]<<24),f=l[23630]|l[23631]<<8|(l[23632]<<16|l[23633]<<24),u[e|0]=f,u[e+1|0]=f>>>8,u[e+2|0]=f>>>16,u[e+3|0]=f>>>24,u[e+4|0]=r,u[e+5|0]=r>>>8,u[e+6|0]=r>>>16,u[e+7|0]=r>>>24,u[e+24|0]=0,r=l[23650]|l[23651]<<8|(l[23652]<<16|l[23653]<<24),f=l[23646]|l[23647]<<8|(l[23648]<<16|l[23649]<<24),u[e+16|0]=f,u[e+17|0]=f>>>8,u[e+18|0]=f>>>16,u[e+19|0]=f>>>24,u[e+20|0]=r,u[e+21|0]=r>>>8,u[e+22|0]=r>>>16,u[e+23|0]=r>>>24,r=l[23642]|l[23643]<<8|(l[23644]<<16|l[23645]<<24),f=l[23638]|l[23639]<<8|(l[23640]<<16|l[23641]<<24),u[e+8|0]=f,u[e+9|0]=f>>>8,u[e+10|0]=f>>>16,u[e+11|0]=f>>>24,u[e+12|0]=r,u[e+13|0]=r>>>8,u[e+14|0]=r>>>16,u[e+15|0]=r>>>24,q(A,9,0,n+20|0),u[n+31|0]>=0)break i;Z(i[n+20>>2]);break i}if(l2(r,f),f=i[e+176>>2],t=i[e+180>>2],(f|0)!=(t|0))for(;;){if(l2(r,l[f+1|0]|l[f|0]<<7&128),k=(i[f+8>>2]-i[f+4>>2]|0)/12|0,k>>>0>=65536){if(e=p(24),i[n+20>>2]=e,i[n+24>>2]=23,i[n+28>>2]=-2147483624,r=l[23750]|l[23751]<<8|(l[23752]<<16|l[23753]<<24),f=l[23746]|l[23747]<<8|(l[23748]<<16|l[23749]<<24),u[e|0]=f,u[e+1|0]=f>>>8,u[e+2|0]=f>>>16,u[e+3|0]=f>>>24,u[e+4|0]=r,u[e+5|0]=r>>>8,u[e+6|0]=r>>>16,u[e+7|0]=r>>>24,u[e+23|0]=0,r=l[23765]|l[23766]<<8|(l[23767]<<16|l[23768]<<24),f=l[23761]|l[23762]<<8|(l[23763]<<16|l[23764]<<24),u[e+15|0]=f,u[e+16|0]=f>>>8,u[e+17|0]=f>>>16,u[e+18|0]=f>>>24,u[e+19|0]=r,u[e+20|0]=r>>>8,u[e+21|0]=r>>>16,u[e+22|0]=r>>>24,r=l[23758]|l[23759]<<8|(l[23760]<<16|l[23761]<<24),f=l[23754]|l[23755]<<8|(l[23756]<<16|l[23757]<<24),u[e+8|0]=f,u[e+9|0]=f>>>8,u[e+10|0]=f>>>16,u[e+11|0]=f>>>24,u[e+12|0]=r,u[e+13|0]=r>>>8,u[e+14|0]=r>>>16,u[e+15|0]=r>>>24,q(A,9,0,n+20|0),u[n+31|0]>=0)break i;Z(i[n+20>>2]);break i}if(u2(r,k),k=i[f+4>>2],o=i[f+8>>2],(k|0)!=(o|0))for(;;){if(w=i[k+4>>2]-i[k>>2]|0,w>>>0>=65536){if(e=p(24),i[n+20>>2]=e,i[n+24>>2]=18,i[n+28>>2]=-2147483624,r=l[25149]|l[25150]<<8|(l[25151]<<16|l[25152]<<24),f=l[25145]|l[25146]<<8|(l[25147]<<16|l[25148]<<24),u[e|0]=f,u[e+1|0]=f>>>8,u[e+2|0]=f>>>16,u[e+3|0]=f>>>24,u[e+4|0]=r,u[e+5|0]=r>>>8,u[e+6|0]=r>>>16,u[e+7|0]=r>>>24,u[e+18|0]=0,r=l[25161]|l[25162]<<8,u[e+16|0]=r,u[e+17|0]=r>>>8,r=l[25157]|l[25158]<<8|(l[25159]<<16|l[25160]<<24),f=l[25153]|l[25154]<<8|(l[25155]<<16|l[25156]<<24),u[e+8|0]=f,u[e+9|0]=f>>>8,u[e+10|0]=f>>>16,u[e+11|0]=f>>>24,u[e+12|0]=r,u[e+13|0]=r>>>8,u[e+14|0]=r>>>16,u[e+15|0]=r>>>24,q(A,9,0,n+20|0),u[n+31|0]>=0)break i;Z(i[n+20>>2]);break i}if(u2(r,w),I4(r,k),k=k+12|0,(o|0)==(k|0))break}if(f=f+16|0,(t|0)==(f|0))break}if(f1(n,e,r,_),u[n+19|0]<0&&Z(i[n+8>>2]),e=i[26917],i[A>>2]=i[26916],i[A+4>>2]=e,A=A+8|0,u[107683]>=0){e=i[26919],i[A>>2]=i[26918],i[A+4>>2]=e,i[A+8>>2]=i[26920];break i}T(A,i[26918],i[26919])}v=n+32|0}function Wf(A,e,r,f,k){var n=0,t=0,o=0,s=0,w=0,h=0,_=0,B=0,m=0,X=0,Q=0,V=0,F=0,I=0,E=0,R=0,N=0,M=0,z=0,S=0,O=0,P=0,a=0,$=0,f0=0,A0=0,n0=0,_0=0,m0=0,X0=0,g0=0,I0=0,e0=0,r0=0,N0=0,U0=0,M0=0,H0=0,P0=0,K0=0,$0=0,L0=0,d0=0,n2=0,Z2=0,Q2=0,g2=0,p2=0,H2=0,T2=0,b2=0,e1=0,X1=0,J1=0,z1=0,b1=0,G4=0,X4=0,W4=0,j4=0,O4=0,P4=0,c8=0,b8=0,Ei=0,Yi=0;i:{e:{w=i[A+276>>2],e0=(f|0)<(w|0)?f:w;r:{if((e0|0)<=(r|0)||(_0=i[A+272>>2],r0=(k|0)<(_0|0)?k:_0,(r0|0)<=0))break r;for(a=i[A+124>>2],m0=i[a+16856>>2],H2=m0<<(e^1),X0=i[a+16852>>2],T2=X0<<e,b2=A+4|0,e1=3-m0|0,X1=3-X0|0,f=i[a+16840>>2],J1=f-8|0,s=-1<<f^-1,X=i[A+44>>2],N0=G(X,6),U0=X<<2,R=X<<1,M0=0-R|0,z1=i[A+260>>2],$=G(X,6),b1=0-X<<1,G4=1-X<<1,X4=2-X<<1,W4=3-X<<1;;){for(f=r<<e1,H0=G(f,X),j4=H0+X|0,f0=G(f,m0),O4=f0-1|0,P4=G((f0|0)/4|0,_0)+z1|0,A0=0;;){if(k=A0<<X1,n0=G(k,X0),f=l[((n0|0)/4|0)+P4|0]&3,f>>>0>1)for(w=1,c8=k+j4<<1,b8=(f<<1)-2|0,f=i[A+168>>2],I=n0-1>>f,E=O4>>f,g0=f0>>f,I0=n0>>f,P0=k+H0<<1,Ei=P0+M0|0,Yi=i[A+132>>2],f=1;;){k=i[(f<<2)+b2>>2],_=k+P0|0;f:{if(!e){N=_+6|0,M=_+4|0,z=_+2|0,f=k+c8|0,S=f+6|0,B=f+4|0,k=k+Ei|0,O=k+6|0,n=k+2|0,Q=k+M0|0,t=Q+6|0,V=Q+4|0,F=Q+2|0,P=f+2|0,o=k+4|0;break f}Q=_-4|0,t=$+Q|0,f=_+2|0,S=$+f|0,h=R<<1,V=h+Q|0,B=f+h|0,F=Q+R|0,k=_-2|0,O=$+k|0,n=k+R|0,N=_+$|0,M=h+_|0,z=_+R|0,P=f+R|0,o=k+h|0}if((I0|0)<0||(h=i[A+172>>2],(h|0)<=(I0|0)))break e;if((g0|0)<0||(m=i[A+176>>2],(m|0)<=(g0|0)))break i;K0=C[t>>1],$0=C[V>>1],L0=C[F>>1],d0=C[Q>>1],O=C[O>>1],o=C[o>>1],n=C[n>>1],t=C[k>>1],n2=C[S>>1],Z2=C[B>>1],Q2=C[P>>1],g2=C[f>>1],N=C[N>>1],M=C[M>>1],z=C[z>>1],S=C[_>>1],Q=w,k=i[(w?32:36)+Yi>>2],V=i[A+160>>2],F=V+G(I0,3)|0,P=G(G(h,g0),3),w=F+P|0,B=u[w+2|0];f:{if(!e){if((E|0)<0|(m|0)<=(E|0))break i;f=(F+G(G(h,E),3)|0)+2|0;break f}if((I|0)<0|h>>>0<=I>>>0)break e;f=(P+(V+G(I,3)|0)|0)+2|0}k=k+((B+u[f|0]|0)+1>>1)|0;f:{if(i[a+16848>>2]!=1){k=(k|0)>=51?51:k;break f}if((k|0)<30)break f;if(k>>>0<=42){k=i[(k<<2)+63672>>2];break f}k=k-6|0}if(B=i[A+148>>2],f=n0>>B,(f|0)<0||(p2=i[A+152>>2],(f|0)>=(p2|0)))break e;if(B=f0>>B,(B|0)<0|(B|0)>=i[A+156>>2])break i;f=i[i[i[A+52>>2]+(C[((i[A+140>>2]+G(f,24)|0)+G(G(B,p2),24)|0)+2>>1]<<2)>>2]+768>>2]+(k+b8|0)|0,f=(f|0)>=53?53:f,f=l[((f|0)>0?f:0)+60768|0]<<J1,B=l[a+8812|0];f:{A:{if(!e){if(B){if((E|0)<0|(m|0)<=(E|0))break i;V=!(l[(F+G(G(h,E),3)|0)+1|0]&4)}else V=1;if((E|0)<0|(m|0)<=(E|0))break i;if(k=0-f|0,m=(((S-t<<2)+d0|0)-g2|0)+4>>3,m=(k|0)>(m|0)?k:(f|0)>(m|0)?m:f,w=l[w|0]|l[w+1|0]<<8,w=!(w&2048)&(!B|!(w&1024)),h=V&!(l[(F+G(G(h,E),3)|0)+1|0]&8),h&&(t=t+m|0,g[_+b1>>1]=(t|0)>=0?(t|0)<(s|0)?t:s:0),w&&(t=S-m|0,g[_>>1]=(t|0)>=0?(t|0)<(s|0)?t:s:0),t=(((z-n<<2)+L0|0)-Q2|0)+4>>3,t=(k|0)>(t|0)?k:(f|0)>(t|0)?t:f,h&&(n=n+t|0,g[_+G4>>1]=(n|0)>=0?(n|0)<(s|0)?n:s:0),w&&(n=z-t|0,g[_+2>>1]=(n|0)>=0?(n|0)<(s|0)?n:s:0),n=(((M-o<<2)+$0|0)-Z2|0)+4>>3,n=(k|0)>(n|0)?k:(f|0)>(n|0)?n:f,h&&(o=n+o|0,g[_+X4>>1]=(o|0)>=0?(s|0)>(o|0)?o:s:0),w&&(o=M-n|0,g[_+4>>1]=(o|0)>=0?(s|0)>(o|0)?o:s:0),o=(((N-O<<2)+K0|0)-n2|0)+4>>3,f=(k|0)>(o|0)?k:(f|0)>(o|0)?o:f,h&&(k=f+O|0,g[_+W4>>1]=(k|0)>=0?(k|0)<(s|0)?k:s:0),!w)break f;k=N-f|0,f=6;break A}if(B){if((I|0)<0|h>>>0<=I>>>0)break e;m=!(l[(P+(V+G(I,3)|0)|0)+1|0]&4)}else m=1;if((I|0)<0|h>>>0<=I>>>0)break e;if(k=0-f|0,h=(((S-t<<2)+d0|0)-g2|0)+4>>3,F=(k|0)>(h|0)?k:(f|0)>(h|0)?h:f,w=l[w|0]|l[w+1|0]<<8,w=!(w&2048)&(!B|!(w&1024)),h=_-2|0,B=m&!(l[(P+(V+G(I,3)|0)|0)+1|0]&8),B&&(t=t+F|0,g[h>>1]=(t|0)>=0?(t|0)<(s|0)?t:s:0),w&&(t=S-F|0,g[_>>1]=(t|0)>=0?(t|0)<(s|0)?t:s:0),t=(((z-n<<2)+L0|0)-Q2|0)+4>>3,t=(k|0)>(t|0)?k:(f|0)>(t|0)?t:f,B&&(n=n+t|0,g[h+R>>1]=(n|0)>=0?(n|0)<(s|0)?n:s:0),w&&(n=z-t|0,g[_+R>>1]=(n|0)>=0?(n|0)<(s|0)?n:s:0),n=(((M-o<<2)+$0|0)-Z2|0)+4>>3,n=(k|0)>(n|0)?k:(f|0)>(n|0)?n:f,B&&(o=n+o|0,g[h+U0>>1]=(o|0)>=0?(s|0)>(o|0)?o:s:0),w&&(o=M-n|0,g[_+U0>>1]=(o|0)>=0?(s|0)>(o|0)?o:s:0),o=(((N-O<<2)+K0|0)-n2|0)+4>>3,f=(k|0)>(o|0)?k:(f|0)>(o|0)?o:f,B&&(k=f+O|0,g[h+N0>>1]=(k|0)>=0?(k|0)<(s|0)?k:s:0),!w)break f;k=N-f|0,f=N0}g[f+_>>1]=(k|0)>=0?(k|0)<(s|0)?k:s:0}if(f=2,w=0,!Q)break}if(A0=A0+T2|0,!((r0|0)>(A0|0)))break}if(r=r+H2|0,!((e0|0)>(r|0)))break}}return}D0(4656,10893,118,4231),H()}D0(4618,10893,119,4231),H()}function k9(A,e){var r=0,f=0,k=0,n=0,t=0,o=0,s=0,w=0,h=0,_=0,B=0,m=0,X=0,Q=0,V=0,F=0,I=0,E=0;m=v-6240|0,v=m,Q=e+96|0,V=e+480|0,F=e+2016|0;i:{for(;;){for(_=h?64:16,X=(h|0)==3,I=X?3:1,B=(m+6144|0)+G(h,24)|0,k=0;;){n=k<<10,f=n+m|0;e:{r:{f:{A:{k:{if(!(v0(A,1)&255)){if(r=f2(A),(r|0)==-99999||(r=X?G(r,3):r,(r|0)>(k|0)))break f;if(t=B+(k<<2)|0,i[t>>2]=16,!r){if(!h){r=i[26763],i[f+8>>2]=i[26762],i[f+12>>2]=r,r=i[26761],i[f>>2]=i[26760],i[f+4>>2]=r;break r}if(k>>>0<=2){r=i[26779],i[f+56>>2]=i[26778],i[f+60>>2]=r,r=i[26777],i[f+48>>2]=i[26776],i[f+52>>2]=r,r=i[26775],i[f+40>>2]=i[26774],i[f+44>>2]=r,r=i[26773],i[f+32>>2]=i[26772],i[f+36>>2]=r,r=i[26771],i[f+24>>2]=i[26770],i[f+28>>2]=r,r=16,t=i[26769],i[f+16>>2]=i[26768],i[f+20>>2]=t,t=i[26767],i[f+8>>2]=i[26766],i[f+12>>2]=t,t=i[26765],i[f>>2]=i[26764],i[f+4>>2]=t;break k}r=i[26795],i[f+56>>2]=i[26794],i[f+60>>2]=r,r=i[26793],i[f+48>>2]=i[26792],i[f+52>>2]=r,r=i[26791],i[f+40>>2]=i[26790],i[f+44>>2]=r,r=i[26789],i[f+32>>2]=i[26788],i[f+36>>2]=r,r=i[26787],i[f+24>>2]=i[26786],i[f+28>>2]=r,r=16,t=i[26785],i[f+16>>2]=i[26784],i[f+20>>2]=t,t=i[26783],i[f+8>>2]=i[26782],i[f+12>>2]=t,t=i[26781],i[f>>2]=i[26780],i[f+4>>2]=t;break k}if((h|0)==3&(r|0)!=3)break A;r=k-r|0,_&&x(f,(r<<10)+m|0,_),r=i[B+(r<<2)>>2],i[t>>2]=r;break k}n:{if(h>>>0<2){t=8,r=16;break n}if(r=K1(A),r-248>>>0<4294967041)break f;t=r+8|0,i[B+(k<<2)>>2]=t,r=t}for(s=0;;){if(o=K1(A),o+128>>>0>255)break f;if(t=t+o|0,u[f+s|0]=t,s=s+1|0,(_|0)==(s|0))break}}k:switch(h|0){case 1:for(r=(k<<6)+Q|0,s=0,t=i[i[15774]+12>>2];n=t+(s<<1)|0,u[(r+(l[n+1|0]<<3)|0)+l[n|0]|0]=l[f+s|0],n=s|1,o=t+(n<<1)|0,u[(r+(l[o+1|0]<<3)|0)+l[o|0]|0]=l[f+n|0],s=s+2|0,(s|0)!=64;);break e;case 2:for(n=(k<<8)+V|0,w=n+1|0,t=0,E=i[i[15774]+12>>2];s=(t<<1)+E|0,o=l[f+t|0],u[(n+(l[s|0]<<1)|0)+(l[s+1|0]<<5)|0]=o,u[((l[s|0]<<1)+w|0)+(l[s+1|0]<<5)|0]=o,u[((n+(l[s|0]<<1)|0)+(l[s+1|0]<<5)|0)+16|0]=o,u[(((l[s|0]<<1)+w|0)+(l[s+1|0]<<5)|0)+16|0]=o,t=t+1|0,(t|0)!=64;);u[n|0]=r;break e;case 0:break r;case 3:break k;default:break e}t=n+F|0,G8(t,f,3),u[t|0]=r;break e}D0(21386,18188,934,3595),H()}A=8;break i}G8((k<<4)+e|0,f,0)}if(k=k+I|0,!(k>>>0<6))break}if(h=h+1|0,(h|0)==4)break}for(s=e+96|0,h=e- -64|0,_=e+32|0,B=e+160|0,A=0,t=i[i[15774]+12>>2];r=t+(A<<1)|0,n=l[r+1|0],r=l[r|0],f=((n<<7)+(r<<2)|0)+3040|0,k=f+e|0,r=G(l[r+(B+(n<<3)|0)|0],16843009),u[k|0]=r,n=r>>>8|0,u[k+1|0]=n,o=r>>>16|0,u[k+2|0]=o,w=r>>>24|0,u[k+3|0]=w,k=f+_|0,u[k|0]=r,u[k+1|0]=n,u[k+2|0]=o,u[k+3|0]=w,k=f+h|0,u[k|0]=r,u[k+1|0]=n,u[k+2|0]=o,u[k+3|0]=w,f=f+s|0,u[f|0]=r,u[f+1|0]=n,u[f+2|0]=o,u[f+3|0]=w,A=A+1|0,(A|0)!=64;);for(u[e+3040|0]=l[e+160|0],s=e+96|0,h=e- -64|0,_=e+32|0,B=e+224|0,A=0;r=t+(A<<1)|0,n=l[r+1|0],r=l[r|0],f=((n<<7)+(r<<2)|0)+4064|0,k=f+e|0,r=G(l[r+(B+(n<<3)|0)|0],16843009),u[k|0]=r,n=r>>>8|0,u[k+1|0]=n,o=r>>>16|0,u[k+2|0]=o,w=r>>>24|0,u[k+3|0]=w,k=f+_|0,u[k|0]=r,u[k+1|0]=n,u[k+2|0]=o,u[k+3|0]=w,k=f+h|0,u[k|0]=r,u[k+1|0]=n,u[k+2|0]=o,u[k+3|0]=w,f=f+s|0,u[f|0]=r,u[f+1|0]=n,u[f+2|0]=o,u[f+3|0]=w,A=A+1|0,(A|0)!=64;);for(u[e+4064|0]=l[e+224|0],s=e+96|0,h=e- -64|0,_=e+32|0,B=e+352|0,A=0;r=t+(A<<1)|0,n=l[r+1|0],r=l[r|0],f=((n<<7)+(r<<2)|0)+6112|0,k=f+e|0,r=G(l[r+(B+(n<<3)|0)|0],16843009),u[k|0]=r,n=r>>>8|0,u[k+1|0]=n,o=r>>>16|0,u[k+2|0]=o,w=r>>>24|0,u[k+3|0]=w,k=f+_|0,u[k|0]=r,u[k+1|0]=n,u[k+2|0]=o,u[k+3|0]=w,k=f+h|0,u[k|0]=r,u[k+1|0]=n,u[k+2|0]=o,u[k+3|0]=w,f=f+s|0,u[f|0]=r,u[f+1|0]=n,u[f+2|0]=o,u[f+3|0]=w,A=A+1|0,(A|0)!=64;);for(u[e+6112|0]=l[e+352|0],s=e+96|0,h=e- -64|0,_=e+32|0,B=e+416|0,A=0;r=t+(A<<1)|0,n=l[r+1|0],r=l[r|0],f=((n<<7)+(r<<2)|0)+7136|0,k=f+e|0,r=G(l[r+(B+(n<<3)|0)|0],16843009),u[k|0]=r,n=r>>>8|0,u[k+1|0]=n,o=r>>>16|0,u[k+2|0]=o,w=r>>>24|0,u[k+3|0]=w,k=f+_|0,u[k|0]=r,u[k+1|0]=n,u[k+2|0]=o,u[k+3|0]=w,k=f+h|0,u[k|0]=r,u[k+1|0]=n,u[k+2|0]=o,u[k+3|0]=w,f=f+s|0,u[f|0]=r,u[f+1|0]=n,u[f+2|0]=o,u[f+3|0]=w,A=A+1|0,(A|0)!=64;);u[e+7136|0]=l[e+416|0],A=0}return v=m+6240|0,A}function Av(A,e,r,f,k,n,t,o){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,t=t|0,o=o|0;var s=0,w=0,h=0,_=0;o=v-48|0,v=o,i[o+44>>2]=e,i[k>>2]=0,s=i[f+28>>2],i[o>>2]=s,(s|0)!=129576&&(i[s+4>>2]=i[s+4>>2]+1),s=c0(o,129752),e2(o);i:{e:{r:{f:switch(t-65|0){case 0:case 32:Zl(A,n+24|0,o+44|0,r,k,s);break e;case 1:case 33:case 39:_l(A,n+16|0,o+44|0,r,k,s);break e;case 34:e=W[i[i[A+8>>2]+12>>2]](A+8|0)|0,t=A,w=i[o+44>>2],l[e+11|0]>>>7|0?A=i[e>>2]:A=e,s=A,l[e+11|0]>>>7|0?A=i[e>>2]:A=e,l[e+11|0]>>>7|0?e=i[e+4>>2]:e=l[e+11|0]&127,h=o,_=T8(t,w,r,f,k,n,s,A+(e<<2)|0),i[h+44>>2]=_;break e;case 35:case 36:A=Q8(o+44|0,r,k,s,2),e=i[k>>2];A:{if(!(A-1>>>0>30|e&4)){i[n+12>>2]=A;break A}i[k>>2]=e|4}break e;case 3:t=i[19459],i[o+24>>2]=i[19458],i[o+28>>2]=t,t=i[19457],i[o+16>>2]=i[19456],i[o+20>>2]=t,t=i[19455],i[o+8>>2]=i[19454],i[o+12>>2]=t,t=i[19453],i[o>>2]=i[19452],i[o+4>>2]=t,h=o,_=T8(A,e,r,f,k,n,o,o+32|0),i[h+44>>2]=_;break e;case 5:t=i[19467],i[o+24>>2]=i[19466],i[o+28>>2]=t,t=i[19465],i[o+16>>2]=i[19464],i[o+20>>2]=t,t=i[19463],i[o+8>>2]=i[19462],i[o+12>>2]=t,t=i[19461],i[o>>2]=i[19460],i[o+4>>2]=t,h=o,_=T8(A,e,r,f,k,n,o,o+32|0),i[h+44>>2]=_;break e;case 7:A=Q8(o+44|0,r,k,s,2),e=i[k>>2];A:{if(!((A|0)>23|e&4)){i[n+8>>2]=A;break A}i[k>>2]=e|4}break e;case 8:A=Q8(o+44|0,r,k,s,2),e=i[k>>2];A:{if(!(A-1>>>0>11|e&4)){i[n+8>>2]=A;break A}i[k>>2]=e|4}break e;case 41:A=Q8(o+44|0,r,k,s,3),e=i[k>>2];A:{if(!((A|0)>365|e&4)){i[n+28>>2]=A;break A}i[k>>2]=e|4}break e;case 44:e=Q8(o+44|0,r,k,s,2)-1|0,A=i[k>>2];A:{if(!(e>>>0>11|A&4)){i[n+16>>2]=e;break A}i[k>>2]=A|4}break e;case 12:A=Q8(o+44|0,r,k,s,2),e=i[k>>2];A:{if(!((A|0)>59|e&4)){i[n+4>>2]=A;break A}i[k>>2]=e|4}break e;case 45:case 51:for(A=o+44|0,e=v-16|0,v=e,i[e+12>>2]=r;;){A:{if(K2(A,e+12|0))break A;r=i[A>>2],f=i[r+12>>2];k:{if((f|0)==i[r+16>>2]){r=W[i[i[r>>2]+36>>2]](r)|0;break k}r=i[f>>2]}if(!(W[i[i[s>>2]+12>>2]](s,1,r)|0))break A;a1(A);continue}break}K2(A,e+12|0)&&(i[k>>2]=i[k>>2]|2),v=e+16|0;break e;case 47:t=o+44|0,e=W[i[i[A+8>>2]+8>>2]](A+8|0)|0;A:{if(l[e+11|0]>>>7|0){A=i[e+4>>2];break A}A=l[e+11|0]&127}l[e+23|0]>>>7|0?f=i[e+16>>2]:f=l[e+23|0]&127;A:{if((A|0)==(0-f|0)){i[k>>2]=i[k>>2]|4;break A}if(r=Qr(t,r,e,e+24|0,s,k,0),A=i[n+8>>2],!((r|0)!=(e|0)|(A|0)!=12)){i[n+8>>2]=0;break A}(r-e|0)!=12|(A|0)>11||(i[n+8>>2]=A+12)}break e;case 49:x(o,77872,44),h=o,_=T8(A,e,r,f,k,n,o,o+44|0),i[h+44>>2]=_;break e;case 17:i[o+16>>2]=i[19484],t=i[19483],i[o+8>>2]=i[19482],i[o+12>>2]=t,t=i[19481],i[o>>2]=i[19480],i[o+4>>2]=t,h=o,_=T8(A,e,r,f,k,n,o,o+20|0),i[h+44>>2]=_;break e;case 18:A=Q8(o+44|0,r,k,s,2),e=i[k>>2];A:{if(!((A|0)>60|e&4)){i[n>>2]=A;break A}i[k>>2]=e|4}break e;case 19:t=i[19495],i[o+24>>2]=i[19494],i[o+28>>2]=t,t=i[19493],i[o+16>>2]=i[19492],i[o+20>>2]=t,t=i[19491],i[o+8>>2]=i[19490],i[o+12>>2]=t,t=i[19489],i[o>>2]=i[19488],i[o+4>>2]=t,h=o,_=T8(A,e,r,f,k,n,o,o+32|0),i[h+44>>2]=_;break e;case 54:A=Q8(o+44|0,r,k,s,1),e=i[k>>2];A:{if(!((A|0)>6|e&4)){i[n+24>>2]=A;break A}i[k>>2]=e|4}break e;case 55:A=W[i[i[A>>2]+20>>2]](A,e,r,f,k,n)|0;break i;case 23:e=W[i[i[A+8>>2]+24>>2]](A+8|0)|0,t=A,w=i[o+44>>2],l[e+11|0]>>>7|0?A=i[e>>2]:A=e,s=A,l[e+11|0]>>>7|0?A=i[e>>2]:A=e,l[e+11|0]>>>7|0?e=i[e+4>>2]:e=l[e+11|0]&127,h=o,_=T8(t,w,r,f,k,n,s,A+(e<<2)|0),i[h+44>>2]=_;break e;case 56:Nl(n+20|0,o+44|0,r,k,s);break e;case 24:A=Q8(o+44|0,r,k,s,4),l[k|0]&4||(i[n+20>>2]=A-1900);break e;default:if((t|0)==37)break r;break;case 2:case 4:case 6:case 9:case 10:case 11:case 13:case 14:case 15:case 16:case 20:case 21:case 22:case 25:case 26:case 27:case 28:case 29:case 30:case 31:case 37:case 38:case 40:case 42:case 43:case 46:case 48:case 50:case 52:case 53:break f}i[k>>2]=i[k>>2]|4;break e}A=v-16|0,v=A,i[A+12>>2]=r,r=o+44|0,n=A+12|0,e=6;r:{f:{if(K2(r,n))break f;e=i[r>>2],f=i[e+12>>2];A:{if((f|0)==i[e+16>>2]){f=W[i[i[e>>2]+36>>2]](e)|0;break A}f=i[f>>2]}if(e=4,(W[i[i[s>>2]+52>>2]](s,f,0)|0)!=37)break f;if(!K2(a1(r),n))break r;e=2}i[k>>2]=e|i[k>>2]}v=A+16|0}A=i[o+44>>2]}return v=o+48|0,A|0}function kv(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0;var k=0,n=0,t=0,o=0,s=0;k=v-192|0,v=k,z2(k+172|0,e,r),u[k+191|0]<0&&Z(i[k+180>>2]),o=l[e+97|0];i:{if(o>>>0>=2){t1(A,e,4446);break i}if(n=C0(r),n>>>0>u0[f+80>>2]){if(e=p(64),i[k+24>>2]=e,i[k+28>>2]=61,i[k+32>>2]=-2147483584,r=l[17289]|l[17290]<<8|(l[17291]<<16|l[17292]<<24),f=l[17285]|l[17286]<<8|(l[17287]<<16|l[17288]<<24),u[e|0]=f,u[e+1|0]=f>>>8,u[e+2|0]=f>>>16,u[e+3|0]=f>>>24,u[e+4|0]=r,u[e+5|0]=r>>>8,u[e+6|0]=r>>>16,u[e+7|0]=r>>>24,u[e+61|0]=0,r=l[17342]|l[17343]<<8|(l[17344]<<16|l[17345]<<24),f=l[17338]|l[17339]<<8|(l[17340]<<16|l[17341]<<24),u[e+53|0]=f,u[e+54|0]=f>>>8,u[e+55|0]=f>>>16,u[e+56|0]=f>>>24,u[e+57|0]=r,u[e+58|0]=r>>>8,u[e+59|0]=r>>>16,u[e+60|0]=r>>>24,r=l[17337]|l[17338]<<8|(l[17339]<<16|l[17340]<<24),f=l[17333]|l[17334]<<8|(l[17335]<<16|l[17336]<<24),u[e+48|0]=f,u[e+49|0]=f>>>8,u[e+50|0]=f>>>16,u[e+51|0]=f>>>24,u[e+52|0]=r,u[e+53|0]=r>>>8,u[e+54|0]=r>>>16,u[e+55|0]=r>>>24,r=l[17329]|l[17330]<<8|(l[17331]<<16|l[17332]<<24),f=l[17325]|l[17326]<<8|(l[17327]<<16|l[17328]<<24),u[e+40|0]=f,u[e+41|0]=f>>>8,u[e+42|0]=f>>>16,u[e+43|0]=f>>>24,u[e+44|0]=r,u[e+45|0]=r>>>8,u[e+46|0]=r>>>16,u[e+47|0]=r>>>24,r=l[17321]|l[17322]<<8|(l[17323]<<16|l[17324]<<24),f=l[17317]|l[17318]<<8|(l[17319]<<16|l[17320]<<24),u[e+32|0]=f,u[e+33|0]=f>>>8,u[e+34|0]=f>>>16,u[e+35|0]=f>>>24,u[e+36|0]=r,u[e+37|0]=r>>>8,u[e+38|0]=r>>>16,u[e+39|0]=r>>>24,r=l[17313]|l[17314]<<8|(l[17315]<<16|l[17316]<<24),f=l[17309]|l[17310]<<8|(l[17311]<<16|l[17312]<<24),u[e+24|0]=f,u[e+25|0]=f>>>8,u[e+26|0]=f>>>16,u[e+27|0]=f>>>24,u[e+28|0]=r,u[e+29|0]=r>>>8,u[e+30|0]=r>>>16,u[e+31|0]=r>>>24,r=l[17305]|l[17306]<<8|(l[17307]<<16|l[17308]<<24),f=l[17301]|l[17302]<<8|(l[17303]<<16|l[17304]<<24),u[e+16|0]=f,u[e+17|0]=f>>>8,u[e+18|0]=f>>>16,u[e+19|0]=f>>>24,u[e+20|0]=r,u[e+21|0]=r>>>8,u[e+22|0]=r>>>16,u[e+23|0]=r>>>24,r=l[17297]|l[17298]<<8|(l[17299]<<16|l[17300]<<24),f=l[17293]|l[17294]<<8|(l[17295]<<16|l[17296]<<24),u[e+8|0]=f,u[e+9|0]=f>>>8,u[e+10|0]=f>>>16,u[e+11|0]=f>>>24,u[e+12|0]=r,u[e+13|0]=r>>>8,u[e+14|0]=r>>>16,u[e+15|0]=r>>>24,q(A,6,1e3,k+24|0),u[k+35|0]>=0)break i;Z(i[k+24>>2]);break i}if(q4(A,e+116|0,n<<3,f,13715),i[A>>2])break i;u[A+19|0]<0&&Z(i[A+8>>2]),f=e+104|0;e:{s=i[e+104>>2],t=i[e+108>>2]-s>>3;r:{f:{if(t>>>0<n>>>0){ui(f,n-t|0);break f}if(n>>>0<t>>>0&&(i[e+108>>2]=s+(n<<3)),!n)break r}if(e=0,!o)for(;;){if(!i[r+16>>2])break e;if(t=C0(r),o=C0(r),s=i[f>>2]+(e<<3)|0,i[s+4>>2]=o,i[s>>2]=t,e=e+1|0,(n|0)==(e|0))break r}for(;;){if(!i[r+16>>2])break e;if(t=C0(r),o=C0(r),s=i[f>>2]+(e<<3)|0,i[s+4>>2]=o,i[s>>2]=t,e=e+1|0,(n|0)==(e|0))break}}if(l[r+20|0]==1){if(u[k+24|0]=0,u[k+35|0]=0,q(A,2,100,k+24|0),u[k+35|0]>=0)break i;Z(i[k+24>>2]);break i}if(e=i[26917],i[A>>2]=i[26916],i[A+4>>2]=e,A=A+8|0,u[107683]>=0){e=i[26919],i[A>>2]=i[26918],i[A+4>>2]=e,i[A+8>>2]=i[26920];break i}T(A,i[26918],i[26919]);break i}i[k+116>>2]=0,i[k+88>>2]=72196,i[k+32>>2]=72176,r=i[18053],i[k+24>>2]=r,f=i[r-12>>2],r=k+24|0,i[f+r>>2]=i[18054],i[k+28>>2]=0,f=r+i[i[k+24>>2]-12>>2]|0,t=k+36|0,J0(f,t),u[f+80|0]=0,i[f+72>>2]=0,f=i[18055],i[k+32>>2]=f,o=k+32|0,i[o+i[f-12>>2]>>2]=i[18056],f=i[18052],i[k+24>>2]=f,i[r+i[f-12>>2]>>2]=i[18057],i[k+88>>2]=72196,i[k+24>>2]=72156,i[k+32>>2]=72176,f=R0(t),i[f>>2]=71232,i[k+76>>2]=0,i[k+80>>2]=0,i[k+68>>2]=0,i[k+72>>2]=0,i[k+84>>2]=24,Y(V0(Y(V0(Y(o,28118,24),n),28927,33),e),5504,8),e=i[k+84>>2];e:{r:{if(e&16){r=i[k+80>>2],e=i[k+60>>2],r>>>0<e>>>0&&(i[k+80>>2]=e,r=e),e=k+56|0;break r}if(!(e&8)){r=0,u[k+23|0]=0,e=k+12|0;break e}r=i[k+52>>2],e=k+44|0}r:{if(n=i[e>>2],r=r-n|0,r>>>0<2147483640){if(r>>>0>=11){t=r|7,e=p(t+1|0),i[k+20>>2]=t-2147483647,i[k+12>>2]=e,i[k+16>>2]=r;break r}if(u[k+23|0]=r,e=k+12|0,r)break r;r=0;break e}Q0(),H()}if(!r)break e;x(e,n,r)}u[e+r|0]=0,q(A,2,100,k+12|0),u[k+23|0]<0&&Z(i[k+12>>2]),A=i[18051],i[k+24>>2]=A,i[i[A-12>>2]+(k+24|0)>>2]=i[18059],i[k+32>>2]=i[18060],i[f>>2]=71232,u[k+79|0]<0&&Z(i[k+68>>2]),E0(f),y0(k+88|0)}v=k+192|0}function nv(A,e,r,f,k,n,t,o){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,t=t|0,o=o|0;var s=0,w=0,h=0,_=0,B=0,m=0,X=0,Q=0,V=0,F=0,I=0,E=0,R=0,N=0,M=0,z=0,S=0;t=v-32|0,v=t,s=u1(i[r>>2],6),h=l[k+8|0];i:{e:{r:{if((j0(i[r>>2],3)|0)!=8||(j0(i[r>>2],4)|0)!=8)break r;if((j0(i[r>>2],5)|0)==8)break e}e=i[26922],i[A>>2]=i[26921],i[A+4>>2]=e,r=A+8|0;r:{if(u[107703]>=0){e=i[26924],i[r>>2]=i[26923],i[r+4>>2]=e,i[r+8>>2]=i[26925];break r}T(r,i[26923],i[26924])}u[A+20|0]=1;break i}e:{if(!s||(j0(i[r>>2],6)|0)==8)break e;e=i[26922],i[A>>2]=i[26921],i[A+4>>2]=e,r=A+8|0;r:{if(u[107703]>=0){e=i[26924],i[r>>2]=i[26923],i[r+4>>2]=e,i[r+8>>2]=i[26925];break r}T(r,i[26923],i[26924])}u[A+20|0]=1;break i}n=p(172),i[n+4>>2]=0,i[n+8>>2]=0,i[n>>2]=94812,o0(n+16|0,0,80),e=i[n+4>>2],k=e+1|0,i[n+4>>2]=k,i[n+104>>2]=0,i[n+108>>2]=0,i[n+36>>2]=1,i[n+40>>2]=1,u[n+24|0]=1,g[n+22>>1]=2,g[n+18>>1]=2,g[n+20>>1]=2,i[n+112>>2]=0,i[n+116>>2]=4740,i[n+140>>2]=0,i[n+144>>2]=0,i[n+128>>2]=99,i[n+132>>2]=99,i[n+120>>2]=0,i[n+124>>2]=0,i[n+12>>2]=95160,i[n+148>>2]=0,i[n+152>>2]=0,f=n+140|0,i[n+136>>2]=f,i[n+156>>2]=0,i[n+160>>2]=0,i[n+164>>2]=0,i[n+168>>2]=0,i[n+4>>2]=e,e=i[n+8>>2],Q=n+12|0,i[n+96>>2]=Q,i[n+8>>2]=e+1,i[n+100>>2]=n,k||(W[i[i[n>>2]+8>>2]](n),y(n)),e=i[r>>2],B=i[e+108>>2],k=B,R=i[e+112>>2],e=R,i[Q+120>>2]=h&1?11:10,i[Q+116>>2]=1,i[Q+112>>2]=e,i[Q+108>>2]=k,T0(t+8|0,Q,10,k,e,8,o);e:{if(i[t+8>>2]){if(e=i[t+12>>2],i[A>>2]=i[t+8>>2],i[A+4>>2]=e,r=A+8|0,u[t+27|0]>=0){e=i[t+20>>2],i[r>>2]=i[t+16>>2],i[r+4>>2]=e,i[r+8>>2]=i[t+24>>2],u[A+20|0]=1;break e}if(T(r,i[t+16>>2],i[t+20>>2]),e=u[t+27|0],u[A+20|0]=1,(e|0)>=0)break e;Z(i[t+16>>2]);break e}u[t+27|0]<0&&Z(i[t+16>>2]),r=i[r>>2],e=r+128|0;r:{f:{if(k=i[r+128>>2],k){for(o=e,r=k;w=i[r+16>>2]<3,o=w?o:r,r=i[(w?4:0)+r>>2],!!r;);V=0;A:{if((e|0)==(o|0)||(V=0,i[o+16>>2]>3))break A;N=i[o+44>>2],V=i[o+56>>2]}for(o=e,r=k;w=i[r+16>>2]<4,o=w?o:r,r=i[(w?4:0)+r>>2],!!r;);F=0;A:{if((e|0)==(o|0)||(F=0,i[o+16>>2]>4))break A;M=i[o+56>>2],F=i[o+44>>2]}for(o=e,r=k;w=i[r+16>>2]<5,o=w?o:r,r=i[(w?4:0)+r>>2],!!r;);if((e|0)!=(o|0))break f}E=0;break r}if(E=0,i[o+16>>2]>5)break r;z=i[o+56>>2],E=i[o+44>>2]}r=i[f>>2],w=0;r:{if(!r)break r;for(o=f;w=i[r+16>>2]<10,o=w?o:r,r=i[(w?4:0)+r>>2],!!r;);if((f|0)==(o|0)){w=0;break r}if(w=0,i[o+16>>2]>10)break r;S=i[o+56>>2],w=i[o+44>>2]}o=0,f=0;r:{if(!k|s^1)break r;for(r=e;f=i[k+16>>2]<6,r=f?r:k,k=i[(f?4:0)+k>>2],!!k;);if(f=0,(e|0)==(r|0)||(f=0,i[r+16>>2]>6))break r;o=i[r+56>>2],f=i[r+44>>2]}r:{if(!R)break r;if((s&h)==1){if(!B)break r;for(e=0;;){for(m=f+G(e,o)|0,X=E+G(e,z)|0,s=G(e,M)+F|0,h=G(e,S)+w|0,k=G(e,V)+N|0,r=0;_=h+(r<<2)|0,u[_|0]=l[r+k|0],u[_+1|0]=l[r+s|0],u[_+2|0]=l[r+X|0],u[_+3|0]=l[r+m|0],r=r+1|0,(B|0)!=(r|0););if(e=e+1|0,(R|0)==(e|0))break}break r}if(h&1){if(!B)break r;for(h=B&-2,o=B&1,f=0;;){if(I=E+G(f,z)|0,_=G(f,M)+F|0,m=G(f,S)+w|0,X=G(f,V)+N|0,r=0,e=0,(B|0)!=1)for(;s=m+(r<<2)|0,u[s|0]=l[r+X|0],u[s+1|0]=l[r+_|0],k=l[r+I|0],u[s+3|0]=255,u[s+2|0]=k,k=r|1,s=m+(k<<2)|0,u[s|0]=l[k+X|0],u[s+1|0]=l[k+_|0],k=l[k+I|0],u[s+3|0]=255,u[s+2|0]=k,r=r+2|0,e=e+2|0,(h|0)!=(e|0););if(o&&(k=m+(r<<2)|0,u[k|0]=l[r+X|0],u[k+1|0]=l[r+_|0],e=l[r+I|0],u[k+3|0]=255,u[k+2|0]=e),f=f+1|0,(R|0)==(f|0))break}break r}if(!B)break r;for(o=B&-2,k=B&1,f=0;;){if(I=E+G(f,z)|0,_=G(f,M)+F|0,m=G(f,S)+w|0,X=G(f,V)+N|0,r=0,e=0,(B|0)!=1)for(;h=m+G(r,3)|0,u[h|0]=l[r+X|0],u[h+1|0]=l[r+_|0],u[h+2|0]=l[r+I|0],s=r|1,h=m+G(s,3)|0,u[h|0]=l[s+X|0],u[h+1|0]=l[s+_|0],u[h+2|0]=l[s+I|0],r=r+2|0,e=e+2|0,(o|0)!=(e|0););if(k&&(e=m+G(r,3)|0,u[e|0]=l[r+X|0],u[e+1|0]=l[r+_|0],u[e+2|0]=l[r+I|0]),f=f+1|0,(R|0)==(f|0))break}}u[A+20|0]=0,i[A+4>>2]=n,i[A>>2]=Q;break i}if(A=i[n+4>>2],i[n+4>>2]=A-1,A)break i;W[i[i[n>>2]+8>>2]](n),y(n)}v=t+32|0}function Qf(A,e,r,f,k){var n=0,t=0,o=0,s=0,w=0,h=0,_=0,B=0,m=0,X=0,Q=0,V=0,F=0,I=0,E=0,R=0,N=0,M=0,z=0,S=0,O=0,P=0,a=0,$=0,f0=0,A0=0,n0=0,_0=0,m0=0,X0=0,g0=0,I0=0,e0=0,r0=0,N0=0,U0=0,M0=0,H0=0,P0=0,K0=0,$0=0,L0=0,d0=0,n2=0,Z2=0,Q2=0,g2=0,p2=0,H2=0,T2=0,b2=0,e1=0,X1=0,J1=0,z1=0,b1=0;i:{e:{F=i[A+276>>2],H0=(f|0)<(F|0)?f:F;r:{if((H0|0)<=(r|0)||(f=i[A+272>>2],P0=(f|0)>(k|0)?k:f,(P0|0)<=0))break r;for(M=i[A+124>>2],U0=i[M+16856>>2],Z2=U0<<(e^1),M0=i[M+16852>>2],Q2=M0<<e,g2=A+4|0,p2=3-U0|0,H2=3-M0|0,t=-1<<i[M+16840>>2]^-1,_=i[A+44>>2],z=G(_,3),S=_<<1,T2=3-_|0,b2=2-_|0,e1=1-_|0,X1=0-_|0;;){for(K0=r<<p2,_0=G(K0,U0),$0=_0-1|0,J1=(_0|0)/4|0,m0=0;;){if(X0=m0<<H2,g0=G(M0,X0),f=l[(i[A+260>>2]+((g0|0)/4|0)|0)+G(i[A+272>>2],J1)|0]&3,f>>>0>1)for(z1=X0-_|0,L0=g0-1|0,n=1,b1=(f<<1)-2|0,f=1;;){k=G(i[A+44>>2],K0),o=i[(f<<2)+g2>>2],s=k+(o+X0|0)|0;f:{if(!e){F=k+z1|0,f=F+o|0,N=f+3|0,E=f+1|0,k=o+(k+X0|0)|0,O=k+3|0,h=k+2|0,m=k+1|0,X=o+(F-_|0)|0,a=X+3|0,$=X+2|0,f0=X+1|0,Q=k+_|0,A0=Q+3|0,n0=Q+2|0,I=Q+1|0,F=f+2|0;break f}O=s+z|0,h=s+S|0,m=s+_|0,X=s-2|0,a=z+X|0,Q=s+1|0,A0=z+Q|0,$=X+S|0,n0=Q+S|0,f0=_+X|0,I=_+Q|0,f=s-1|0,N=z+f|0,E=f+_|0,k=s,F=f+S|0}if(P=i[A+168>>2],B=g0>>P,(B|0)<0||(R=i[A+172>>2],(R|0)<=(B|0)))break e;if(o=_0>>P,(o|0)<0||(V=i[A+176>>2],(V|0)<=(o|0)))break i;d0=l[a|0],n2=l[$|0],a=l[f0|0],$=l[X|0],I0=l[N|0],e0=l[F|0],r0=l[E|0],N0=l[f|0],f0=l[A0|0],A0=l[n0|0],n0=l[I|0],I=l[Q|0],O=l[O|0],X=l[h|0],Q=l[m|0],N=l[k|0],F=n,k=i[i[A+132>>2]+(n?32:36)>>2],h=i[A+160>>2],m=h+G(B,3)|0,B=G(G(o,R),3),E=m+B|0,o=u[E+2|0];f:{if(!e){if(n=$0>>P,(n|0)<0|(n|0)>=(V|0))break i;f=(m+G(G(n,R),3)|0)+2|0;break f}if(n=L0>>P,(n|0)<0|n>>>0>=R>>>0)break e;f=(B+(h+G(n,3)|0)|0)+2|0}f=k+((o+u[f|0]|0)+1>>1)|0;f:{if(i[M+16848>>2]!=1){f=(f|0)>=51?51:f;break f}if((f|0)<30)break f;if(f>>>0<=42){f=i[(f<<2)+63672>>2];break f}f=f-6|0}if(n=i[A+148>>2],o=g0>>n,(o|0)<0||(k=i[A+152>>2],(k|0)<=(o|0)))break e;if(n=_0>>n,(n|0)<0|(n|0)>=i[A+156>>2])break i;f=i[i[i[A+52>>2]+(C[((i[A+140>>2]+G(o,24)|0)+G(G(k,n),24)|0)+2>>1]<<2)>>2]+768>>2]+(f+b1|0)|0,f=(f|0)>=53?53:f,w=l[((f|0)>0?f:0)+60768|0]<<i[M+16840>>2]-8,o=l[M+8812|0];f:{A:{if(!e){if(B=$0>>P,o){if((B|0)<0|(B|0)>=(V|0))break i;n=!(l[(m+G(G(B,R),3)|0)+1|0]&4)}else n=1;if((B|0)<0|(B|0)>=(V|0))break i;if(h=0-w|0,f=(((N-N0<<2)+$|0)-I|0)+4>>3,k=(f|0)<(h|0)?h:(f|0)<(w|0)?f:w,f=l[E|0]|l[E+1|0]<<8,o=!(f&2048)&(!o|!(f&1024)),n=n&!(l[(m+G(G(B,R),3)|0)+1|0]&8),n&&(f=k+N0|0,u[s+X1|0]=(f|0)>=0?(f|0)<(t|0)?f:t:0),o&&(f=N-k|0,u[s|0]=(f|0)>=0?(f|0)<(t|0)?f:t:0),f=(((Q-r0<<2)+a|0)-n0|0)+4>>3,k=(f|0)<(h|0)?h:(f|0)<(w|0)?f:w,n&&(f=k+r0|0,u[s+e1|0]=(f|0)>=0?(f|0)<(t|0)?f:t:0),o&&(f=Q-k|0,u[s+1|0]=(f|0)>=0?(f|0)<(t|0)?f:t:0),f=(((X-e0<<2)+n2|0)-A0|0)+4>>3,k=(f|0)<(h|0)?h:(f|0)<(w|0)?f:w,n&&(f=k+e0|0,u[s+b2|0]=(f|0)>=0?(f|0)<(t|0)?f:t:0),o&&(f=X-k|0,u[s+2|0]=(f|0)>=0?(f|0)<(t|0)?f:t:0),f=(((O-I0<<2)+d0|0)-f0|0)+4>>3,f=(f|0)<(h|0)?h:(f|0)<(w|0)?f:w,n&&(k=f+I0|0,u[s+T2|0]=(k|0)>=0?(k|0)<(t|0)?k:t:0),!o)break f;k=3;break A}if(m=L0>>P,o){if((m|0)<0|m>>>0>=R>>>0)break e;n=!(l[(B+(h+G(m,3)|0)|0)+1|0]&4)}else n=1;if((m|0)<0|m>>>0>=R>>>0)break e;if(V=0-w|0,f=(((N-N0<<2)+$|0)-I|0)+4>>3,k=(f|0)<(V|0)?V:(f|0)<(w|0)?f:w,f=l[E|0]|l[E+1|0]<<8,I=!(f&2048)&(!o|!(f&1024)),o=s-1|0,n=n&!(l[(B+(h+G(m,3)|0)|0)+1|0]&8),n&&(f=k+N0|0,u[o|0]=(f|0)>=0?(f|0)<(t|0)?f:t:0),I&&(f=N-k|0,u[s|0]=(f|0)>=0?(f|0)<(t|0)?f:t:0),f=(((Q-r0<<2)+a|0)-n0|0)+4>>3,k=(f|0)<(V|0)?V:(f|0)<(w|0)?f:w,n&&(f=k+r0|0,u[o+_|0]=(f|0)>=0?(f|0)<(t|0)?f:t:0),I&&(f=Q-k|0,u[s+_|0]=(f|0)>=0?(f|0)<(t|0)?f:t:0),f=(((X-e0<<2)+n2|0)-A0|0)+4>>3,k=(f|0)<(V|0)?V:(f|0)<(w|0)?f:w,n&&(f=k+e0|0,u[o+S|0]=(f|0)>=0?(f|0)<(t|0)?f:t:0),I&&(f=X-k|0,u[s+S|0]=(f|0)>=0?(f|0)<(t|0)?f:t:0),f=(((O-I0<<2)+d0|0)-f0|0)+4>>3,f=(f|0)<(V|0)?V:(f|0)<(w|0)?f:w,n&&(k=f+I0|0,u[o+z|0]=(k|0)>=0?(k|0)<(t|0)?k:t:0),!I)break f;k=z}f=O-f|0,u[k+s|0]=(f|0)>=0?(f|0)<(t|0)?f:t:0}if(f=2,n=0,!F)break}if(m0=m0+Q2|0,!((P0|0)>(m0|0)))break}if(r=r+Z2|0,!((H0|0)>(r|0)))break}}return}D0(4656,10893,118,4231),H()}D0(4618,10893,119,4231),H()}function tv(A,e,r,f,k,n,t,o){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,t=t|0,o=o|0;var s=0,w=0,h=0,_=0,B=0,m=0,X=0,Q=0,V=0,F=0,I=0,E=0,R=0,N=0,M=0,z=0,S=0,O=0,P=0,a=0,$=0,f0=0,A0=0,n0=0,_0=U(0),m0=U(0),X0=U(0),g0=U(0);t=v-48|0,v=t;i:{e:{r:{if((j0(i[r>>2],0)|0)!=8||(j0(i[r>>2],1)|0)!=8)break r;if((j0(i[r>>2],2)|0)==8)break e}e=i[26922],i[A>>2]=i[26921],i[A+4>>2]=e,r=A+8|0;r:{if(u[107703]>=0){e=i[26924],i[r>>2]=i[26923],i[r+4>>2]=e,i[r+8>>2]=i[26925];break r}T(r,i[26923],i[26924])}u[A+20|0]=1;break i}n=p(172),i[n+4>>2]=0,i[n+8>>2]=0,i[n>>2]=94812,o0(n+16|0,0,80),e=i[n+4>>2],f=e+1|0,i[n+4>>2]=f,i[n+104>>2]=0,i[n+108>>2]=0,i[n+36>>2]=1,i[n+40>>2]=1,u[n+24|0]=1,g[n+22>>1]=2,g[n+18>>1]=2,g[n+20>>1]=2,i[n+112>>2]=0,i[n+116>>2]=4740,i[n+140>>2]=0,i[n+144>>2]=0,i[n+128>>2]=99,i[n+132>>2]=99,i[n+120>>2]=0,i[n+124>>2]=0,i[n+12>>2]=95160,i[n+148>>2]=0,i[n+152>>2]=0,k=n+140|0,i[n+136>>2]=k,i[n+156>>2]=0,i[n+160>>2]=0,i[n+164>>2]=0,i[n+168>>2]=0,i[n+4>>2]=e,e=i[n+8>>2],h=n+12|0,i[n+96>>2]=h,i[n+8>>2]=e+1,i[n+100>>2]=n,f||(W[i[i[n>>2]+8>>2]](n),y(n)),e=i[r>>2],V=i[e+108>>2],f=V,F=i[e+112>>2],e=F,i[h+120>>2]=11,i[h+116>>2]=1,i[h+112>>2]=e,i[h+108>>2]=f,T0(t+24|0,h,10,f,e,8,o);e:{if(i[t+24>>2]){if(e=i[t+28>>2],i[A>>2]=i[t+24>>2],i[A+4>>2]=e,r=A+8|0,u[t+43|0]>=0){e=i[t+36>>2],i[r>>2]=i[t+32>>2],i[r+4>>2]=e,i[r+8>>2]=i[t+40>>2],u[A+20|0]=1;break e}if(T(r,i[t+32>>2],i[t+36>>2]),e=u[t+43|0],u[A+20|0]=1,(e|0)>=0)break e;Z(i[t+32>>2]);break e}u[t+43|0]<0&&Z(i[t+32>>2]),i[t+36>>2]=-1086926434,i[t+40>>2]=1071829221,i[t+28>>2]=1068725436,i[t+32>>2]=-1095748968,u[t+24|0]=1,S4(i[r>>2])&&(f=i[r>>2],e=C[f+6>>1]|C[f+8>>1]<<16,le(t+4|0,(C[f+10>>1]|C[f+12>>1]<<16)&65535,e&65535),i[t+40>>2]=i[t+20>>2],e=i[t+16>>2],i[t+32>>2]=i[t+12>>2],i[t+36>>2]=e,e=i[t+8>>2],i[t+24>>2]=i[t+4>>2],i[t+28>>2]=e),_0=p0[t+40>>2],m0=p0[t+32>>2],X0=p0[t+36>>2],g0=p0[t+28>>2],s=u1(i[r>>2],6),e=i[r>>2],o=i[e+128>>2],S=u6(U(_0*U(256))),O=u6(U(m0*U(256))),P=u6(U(X0*U(256))),a=u6(U(g0*U(256)));r:{f:{if(o){for(e=e+128|0,f=e,r=o;w=i[r+16>>2],f=(w|0)<0?f:r,r=i[(w>>>29&4)+r>>2],!!r;);B=0;A:{if((e|0)==(f|0)||(B=0,i[f+16>>2]>0))break A;$=i[f+56>>2],B=i[f+44>>2]}for(f=e,r=o;w=i[r+16>>2]<=0,f=w?f:r,r=i[(w?4:0)+r>>2],!!r;);m=0;A:{if((e|0)==(f|0)||(m=0,i[f+16>>2]>1))break A;f0=i[f+44>>2],m=i[f+56>>2]}for(f=e,r=o;w=i[r+16>>2]<2,f=w?f:r,r=i[(w?4:0)+r>>2],!!r;);r=0;A:{if((e|0)==(f|0)||(r=0,i[f+16>>2]>2))break A;A0=i[f+56>>2],r=i[f+44>>2]}if(w=r,f=0,!s)break r;for(r=e;f=i[o+16>>2]<6,r=f?r:o,o=i[(f?4:0)+o>>2],!!o;);if((e|0)!=(r|0))break f}f=0;break r}if(f=0,i[r+16>>2]>6)break r;Q=i[r+56>>2],f=i[r+44>>2]}r=i[k>>2],e=0;r:{if(!r)break r;for(o=k;e=i[r+16>>2]<10,o=e?o:r,r=i[(e?4:0)+r>>2],!!r;);if(e=0,(k|0)==(o|0)||(e=0,i[o+16>>2]>10))break r;n0=i[o+56>>2],e=i[o+44>>2]}k=e;r:{if(!F|!V)break r;if(e=0,s)for(;;){for(X=f+G(e,Q)|0,E=k+G(e,n0)|0,R=G(e,$)+B|0,r=e>>>1|0,N=G(r,A0)+w|0,M=G(r,m)+f0|0,r=0;s=r>>>1|0,o=l[s+N|0],I=E+(r<<2)|0,z=l[r+R|0],s=l[s+M|0]-128|0,_=z+(G(s,S)+128>>8)|0,u[I+2|0]=(_|0)>=0?_>>>0>=255?255:_:0,o=o-128|0,_=z+(G(o,a)+128>>8)|0,u[I|0]=(_|0)>=0?_>>>0>=255?255:_:0,o=z+((G(s,O)+G(o,P)|0)+128>>8)|0,u[I+1|0]=(o|0)>=0?o>>>0>=255?255:o:0,u[I+3|0]=l[r+X|0],r=r+1|0,(V|0)!=(r|0););if(e=e+1|0,(F|0)==(e|0))break r}for(;;){for(E=k+G(e,n0)|0,R=G(e,$)+B|0,r=e>>>1|0,N=G(r,A0)+w|0,M=G(r,m)+f0|0,r=0;f=r>>>1|0,s=l[f+N|0],Q=l[r+R|0],f=l[f+M|0],X=E+(r<<2)|0,u[X+3|0]=255,o=f-128|0,f=Q+(G(o,S)+128>>8)|0,u[X+2|0]=(f|0)>=0?f>>>0>=255?255:f:0,f=s-128|0,s=Q+(G(f,a)+128>>8)|0,u[X|0]=(s|0)>=0?s>>>0>=255?255:s:0,f=Q+((G(o,O)+G(f,P)|0)+128>>8)|0,u[X+1|0]=(f|0)>=0?f>>>0>=255?255:f:0,r=r+1|0,(V|0)!=(r|0););if(e=e+1|0,(F|0)==(e|0))break}}u[A+20|0]=0,i[A+4>>2]=n,i[A>>2]=h;break i}if(A=i[n+4>>2],i[n+4>>2]=A-1,A)break i;W[i[i[n>>2]+8>>2]](n),y(n)}v=t+48|0}function uv(A,e,r,f,k,n){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0;var t=0,o=0,s=0,w=0,h=0,_=0;k=v-144|0,v=k,i[k+104>>2]=0,i[k+108>>2]=0,i[k+112>>2]=0,i[k+116>>2]=0,u[k+119|0]=0,u[k+120|0]=0,u[k+121|0]=0,u[k+122|0]=0,i[k+96>>2]=0,i[k+100>>2]=0,i[k+124>>2]=0,i[k+128>>2]=0,i[k+136>>2]=0,u[k+132|0]=1,t=p(168),i[t>>2]=92284,i[t+4>>2]=0,i[t+8>>2]=0,o=t+16|0,e=o,i[e+8>>2]=0,i[e+12>>2]=0,i[e+16>>2]=0,i[e+20>>2]=0,i[e+24>>2]=0,i[e+28>>2]=0,i[e+32>>2]=0,i[e>>2]=86356,e=t,i[e+60>>2]=0,i[e+64>>2]=0,i[e+52>>2]=0,i[e+56>>2]=0,i[e+72>>2]=-1,i[e+76>>2]=-1,i[e+80>>2]=-1,i[e+84>>2]=-1,i[e+88>>2]=0,i[e+92>>2]=0,i[e+96>>2]=0,i[e+100>>2]=0,i[e+104>>2]=0,i[e+108>>2]=0,u[e+112|0]=0,i[o>>2]=100112,u[e+120|0]=0,i[e+116>>2]=0,i[e+132>>2]=0,i[e+136>>2]=0,g[e+128>>1]=2056,i[e+124>>2]=1,i[e+140>>2]=0,i[e+144>>2]=0,i[e+148>>2]=0,i[e+152>>2]=0,i[e+156>>2]=0,i[e+160>>2]=0,i[e+164>>2]=0,i[e+32>>2]=1635148611,s=i[r>>2],e=i[r+4>>2],e&&(i[e+4>>2]=i[e+4>>2]+1),i[k+92>>2]=e,i[k+88>>2]=s,W[i[i[f>>2]+100>>2]](k+76|0,i[f+4>>2],k+88|0,n);i:{e:{r:{n=i[k+76>>2];f:{if(n){if(r=i[k+80>>2],o=i[k+84>>2],e=h2(o),e>>>0>=2147483640)break r;A:{k:{if(e>>>0>=11){s=e|7,f=p(s+1|0),i[k+52>>2]=s-2147483647,i[k+44>>2]=f,i[k+48>>2]=e;break k}if(u[k+55|0]=e,f=k+44|0,!e)break A}if(!e)break A;x(f,o,e)}u[e+f|0]=0,e=q(k+56|0,n,r,k+44|0),r=i[e+4>>2],i[A>>2]=i[e>>2],i[A+4>>2]=r,r=A+8|0;A:{if(u[e+19|0]>=0){f=i[e+12>>2],i[r>>2]=i[e+8>>2],i[r+4>>2]=f,i[r+8>>2]=i[e+16>>2],u[A+44|0]=1;break A}if(T(r,i[e+8>>2],i[e+12>>2]),r=u[e+19|0],u[A+44|0]=1,(r|0)>=0)break A;Z(i[e+8>>2])}if(u[k+55|0]>=0)break f;Z(i[k+44>>2]);break f}if(i[k+40>>2]=0,i[k+36>>2]=0,W[i[i[f>>2]+104>>2]](k+56|0,i[f+4>>2],k+44|0,k+32|0,0),e=i[k+44>>2],e)for(s=t+116|0;;){n=i[k+32>>2];A:{k:switch((l[e|0]&31)-7|0){case 0:f9(k+12|0,e,n,s,k+40|0,k+36|0),u[k+31|0]<0&&Z(i[k+20>>2]),i[k+124>>2]=i[k+40>>2],i[k+128>>2]=i[k+36>>2],nt(o,i[k+44>>2],i[k+32>>2]);break A;case 6:tt(o,e,n);break A;case 1:ut(o,e,n);break A;default:break k}Xi(k+96|0,e,n)}if(W[i[i[f>>2]+104>>2]](k+56|0,i[f+4>>2],k+44|0,k+32|0,0),e=i[k+44>>2],!e)break}if(!(i[k+36>>2]&&i[k+40>>2])){u[k+44|0]=0,u[k+55|0]=0,e=q(k+56|0,8,129,k+44|0),r=i[e+4>>2],i[A>>2]=i[e>>2],i[A+4>>2]=r,r=A+8|0;A:{if(u[e+19|0]>=0){f=i[e+12>>2],i[r>>2]=i[e+8>>2],i[r+4>>2]=f,i[r+8>>2]=i[e+16>>2],u[A+44|0]=1;break A}if(T(r,i[e+8>>2],i[e+12>>2]),r=u[e+19|0],u[A+44|0]=1,(r|0)>=0)break A;Z(i[e+8>>2])}if(u[k+55|0]>=0)break f;Z(i[k+44>>2]);break f}i[t+4>>2]=i[t+4>>2]+1,e=i[k+100>>2],w=i[k+104>>2];A:{if(e>>>0<w>>>0){i[e+4>>2]=t,i[e>>2]=o,e=e+8|0;break A}if(s=i[k+96>>2],e=e-s|0,_=e>>3,n=_+1|0,n>>>0>=536870912)break e;if(w=w-s|0,h=w>>2,w=w>>>0>=2147483640?536870911:n>>>0<h>>>0?h:n,w){if(w>>>0>=536870912)break i;n=p(w<<3)}else n=0;if(h=n+e|0,i[h+4>>2]=t,i[h>>2]=o,o=h-(_<<3)|0,e&&x(o,s,e),i[k+104>>2]=n+(w<<3),e=h+8|0,i[k+100>>2]=e,i[k+96>>2]=o,!s)break A;Z(s)}i[k+100>>2]=e,n=i[f>>2];A:{if(i[n>>2]<3||(n=i[n+112>>2],!n))break A;e=i[r>>2],r=i[e+108>>2],i[k+56>>2]=r,e=i[e+112>>2],i[k+44>>2]=e,W[n|0](i[f+4>>2],r,e,k+56|0,k+44|0),e=i[k+100>>2]}g[k+120>>1]=257,r=i[k+96>>2],i[k+96>>2]=0,f=i[k+104>>2],n=i[k+108>>2],i[k+100>>2]=0,i[k+104>>2]=0,o=i[k+112>>2],s=i[k+116>>2],i[k+108>>2]=0,i[k+112>>2]=0,i[k+116>>2]=0,i[A+16>>2]=o,i[A+20>>2]=s,i[A+8>>2]=f,i[A+12>>2]=n,i[A+4>>2]=e,i[A>>2]=r,e=i[k+124>>2],i[A+24>>2]=i[k+120>>2],i[A+28>>2]=e,e=i[k+132>>2],i[A+32>>2]=i[k+128>>2],i[A+36>>2]=e,i[A+40>>2]=i[k+136>>2],u[A+44|0]=0}A=i[k+92>>2];f:{if(!A||(e=i[A+4>>2],i[A+4>>2]=e-1,e))break f;W[i[i[A>>2]+8>>2]](A),y(A)}if(A=i[t+4>>2],i[t+4>>2]=A-1,A||(W[i[i[t>>2]+8>>2]](t),y(t)),A=i[k+108>>2],A&&(i[k+112>>2]=A,Z(A)),A=i[k+96>>2],A){if(e=A,r=i[k+100>>2],(e|0)!=(r|0)){for(;;){e=i[r-4>>2];f:{if(!e||(f=i[e+4>>2],i[e+4>>2]=f-1,f))break f;W[i[i[e>>2]+8>>2]](e),y(e)}if(r=r-8|0,(A|0)==(r|0))break}e=i[k+96>>2]}i[k+100>>2]=A,Z(e)}v=k+144|0;return}Q0(),H()}G0(),H()}z0(),H()}function gf(A,e,r,f,k){var n=0,t=0,o=0,s=0,w=0,h=0,_=0,B=0,m=0,X=0,Q=0,V=0,F=0,I=0,E=0,R=0,N=0,M=0,z=0,S=0,O=0,P=0,a=0,$=0,f0=0,A0=0,n0=0;i:{e:{n=i[A+276>>2],M=(f|0)<(n|0)?f:n;r:{if((M|0)<=(r|0)||(f=i[A+272>>2],z=(f|0)>(k|0)?k:f,(z|0)<=0))break r;for(P=e?16:32,a=e?80:160,$=e?1:2,f0=e?2:1,A0=e-1|0,n0=0-e|0;;){for(F=r<<2,I=A0+F|0,S=F>>2,f=0;;){f:{A:{k:{if(k=f<<2,O=k>>2,_=(O+i[A+260>>2]|0)+G(i[A+272>>2],S)|0,t=l[_|0],t&a){if(n=k+n0|0,e=i[A+168>>2],s=n>>e,(s|0)<0||(o=i[A+172>>2],(o|0)<=(s|0)))break e;if(w=I>>e,(w|0)<0||(h=i[A+176>>2],(h|0)<=(w|0)))break i;if(B=k>>e,(B|0)<0|o>>>0<=B>>>0)break e;if(m=F>>e,(m|0)<0|(h|0)<=(m|0))break i;e=2,h=G(s,3),s=i[A+160>>2],w=(h+s|0)+G(G(o,w),3)|0;n:{if(!((l[w|0]|l[w+1|0]<<8)&768)||(o=(s+G(B,3)|0)+G(G(o,m),3)|0,!((l[o|0]|l[o+1|0]<<8)&768)))break n;if(t&P){if(o=i[A+248>>2],w=k>>o,(w|0)<0||(s=i[A+252>>2],(s|0)<=(w|0)))break e;if(B=F>>o,(B|0)<0||(m=i[A+256>>2],(m|0)<=(B|0)))break i;if(e=1,h=i[A+240>>2],u[(h+w|0)+G(s,B)|0]<0)break n;if(w=n>>o,(w|0)<0|s>>>0<=w>>>0)break e;if(o=I>>o,(o|0)<0|(o|0)>=(m|0))break i;if(u[(w+h|0)+G(o,s)|0]<0)break n}if(e=i[A+188>>2],w=n>>e,(w|0)<0||(o=i[A+192>>2],(o|0)<=(w|0)))break e;if(B=I>>e,(B|0)<0||(s=i[A+196>>2],(s|0)<=(B|0)))break i;if(m=k>>e,(m|0)<0|o>>>0<=m>>>0)break e;if(h=F>>e,(h|0)<0|(s|0)<=(h|0))break i;if(e=n,n=i[A+148>>2],X=e>>n,(X|0)<0||(s=i[A+152>>2],(s|0)<=(X|0)))break e;if(Q=I>>n,(Q|0)<0||(E=i[A+156>>2],(E|0)<=(Q|0)))break i;if(e=0,V=i[A+52>>2],R=i[A+56>>2]-V>>2,N=G(X,24),X=i[A+140>>2],Q=C[((N+X|0)+G(G(s,Q),24)|0)+2>>1],R>>>0>Q>>>0&&(e=i[V+(Q<<2)>>2]),k=k>>n,(k|0)<0|k>>>0>=s>>>0)break e;if(n=F>>n,(n|0)<0|(n|0)>=(E|0))break i;if(k=C[((X+G(k,24)|0)+G(G(n,s),24)|0)+2>>1],k>>>0>=R>>>0){e=0;break n}if(!e){e=0;break n}if(X=i[V+(k<<2)>>2],!X){e=0;break n}if(n=i[A+180>>2],k=(n+G(w,12)|0)+G(G(o,B),12)|0,w=u[k+2|0],(w|0)>16||(Q=u[k+3|0],(Q|0)>16)||(n=(n+G(m,12)|0)+G(G(o,h),12)|0,h=u[n+2|0],(h|0)>16)||(V=u[n+3|0],(V|0)>16))break A;if(s=-1,t=-1,m=l[k|0],t=m?i[((w<<2)+e|0)+924>>2]:t,B=l[k+1|0],s=B?i[((Q<<2)+e|0)+988>>2]:s,_=-1,o=-1,w=l[n|0],o=w?i[(X+(h<<2)|0)+924>>2]:o,h=l[n+1|0],_=h?i[(X+(V<<2)|0)+988>>2]:_,!((t|0)==(o|0)&(_|0)==(s|0))&&(e=1,(t|0)!=(_|0)|(o|0)!=(s|0)))break n;e=C[n+8>>1],X=C[n+10>>1],Q=C[n+4>>1],n=C[n+6>>1],V=C[k+8>>1],E=C[k+10>>1],R=C[k+4>>1],N=C[k+6>>1],(B+m|0)!=(w+h|0)&&(F2(i[A+112>>2]+4|0,1013,0),u[A+312|0]=3),e=h?e:0,k=h?X:0,h=w?Q:0,n=w?n:0,w=B?V:0,B=B?E:0,X=m?R:0,m=m?N:0;t:{if((t|0)!=(s|0)){if(s=X<<16>>16,(t|0)!=(o|0)){if(t=s-(e<<16>>16)|0,e=t>>31,(e^t)-e>>>0>3||(k=(m<<16>>16)-(k<<16>>16)|0,e=k>>31,(e^k)-e>>>0>3)||(k=(w<<16>>16)-(h<<16>>16)|0,e=k>>31,(e^k)-e>>>0>3)||(e=0,n=(B<<16>>16)-(n<<16>>16)|0,k=n>>31,(k^n)-k>>>0>=4))break t;break n}if(o=s-(h<<16>>16)|0,t=o>>31,(t^o)-t>>>0>3||(t=(m<<16>>16)-(n<<16>>16)|0,n=t>>31,(n^t)-n>>>0>3)||(n=(w<<16>>16)-(e<<16>>16)|0,e=n>>31,(e^n)-e>>>0>3)||(e=0,n=(B<<16>>16)-(k<<16>>16)|0,k=n>>31,(k^n)-k>>>0>=4))break t;break n}if((o|0)!=(_|0))break k;o=X<<16>>16,s=h<<16>>16,_=o-s|0,t=_>>31;u:{if((t^_)-t>>>0>3||(_=(m<<16>>16)-(n<<16>>16)|0,t=_>>31,(t^_)-t>>>0>3)||(_=(w<<16>>16)-(e<<16>>16)|0,t=_>>31,(t^_)-t>>>0>3)||(_=(B<<16>>16)-(k<<16>>16)|0,t=_>>31,(t^_)-t>>>0>=4))break u;e=0;break n}if(t=o-(e<<16>>16)|0,e=t>>31,(e^t)-e>>>0>3||(k=(m<<16>>16)-(k<<16>>16)|0,e=k>>31,(e^k)-e>>>0>3)||(k=(w<<16>>16)-s|0,e=k>>31,(e^k)-e>>>0>3))break t;if(e=0,n=(B<<16>>16)-(n<<16>>16)|0,k=n>>31,(k^n)-k>>>0<4)break n}e=1}k=(i[A+260>>2]+O|0)+G(i[A+272>>2],S)|0,u[k|0]=l[k|0]&252|e;break f}u[_|0]=t&252;break f}D0(21731,18277,355,10766),H()}u[_|0]=t&252}if(f=f+f0|0,!((z|0)>(f|0)))break}if(r=r+$|0,!((M|0)>(r|0)))break}}return}D0(4656,10893,118,4231),H()}D0(4618,10893,119,4231),H()}function ov(A,e,r,f,k,n){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0;var t=0,o=0,s=0;k=v-192|0,v=k,u[k+167|0]=0,u[k+168|0]=0,u[k+169|0]=0,u[k+170|0]=0,u[k+171|0]=0,u[k+172|0]=0,u[k+173|0]=0,u[k+174|0]=0,i[k+160>>2]=0,i[k+164>>2]=0,i[k+176>>2]=0,i[k+180>>2]=0,i[k+188>>2]=0,u[k+184|0]=1,t=p(208),i[t>>2]=90684,i[t+4>>2]=0,i[t+8>>2]=0,o=t+16|0,e=o,i[e+8>>2]=0,i[e+12>>2]=0,i[e+16>>2]=0,i[e+20>>2]=0,i[e+24>>2]=0,i[e+28>>2]=0,i[e+32>>2]=0,i[e>>2]=86356,i[t+60>>2]=0,i[t+64>>2]=0,i[t+52>>2]=0,i[t+56>>2]=0,i[t+72>>2]=-1,i[t+76>>2]=-1,i[t+80>>2]=-1,i[t+84>>2]=-1,i[t+116>>2]=0,i[t+88>>2]=0,i[t+92>>2]=0,i[t+96>>2]=0,i[t+100>>2]=0,i[t+104>>2]=0,i[t+108>>2]=0,g[t+112>>1]=0,i[e>>2]=99816,i[t+136>>2]=0,i[t+140>>2]=0,g[t+120>>1]=259,i[t+144>>2]=0,i[t+148>>2]=0,i[t+152>>2]=0,i[t+156>>2]=0,i[t+160>>2]=0,i[t+164>>2]=0,i[t+168>>2]=0,i[t+172>>2]=0,i[t+176>>2]=0,i[t+180>>2]=0,i[t+200>>2]=0,i[t+192>>2]=0,i[t+196>>2]=0,i[t+32>>2]=1987470147,i[t+4>>2]=i[t+4>>2]+1,s=p(8),i[s+4>>2]=t,i[s>>2]=e,e=s+8|0,i[k+156>>2]=e,i[k+148>>2]=s,i[k+152>>2]=e,i[k+144>>2]=0,e=i[r>>2],r=i[r+4>>2];i:{if(!r){i[k+140>>2]=e;break i}if(i[r+4>>2]=i[r+4>>2]+1,i[k+140>>2]=e,s=i[k+144>>2],i[k+144>>2]=r,!s||(e=i[s+4>>2],i[s+4>>2]=e-1,e))break i;W[i[i[s>>2]+8>>2]](s),y(s)}W[i[i[f>>2]+100>>2]](k+128|0,i[f+4>>2],k+140|0,n);i:{s=i[k+128>>2];e:{if(s){if(n=i[k+132>>2],r=i[k+136>>2],o=h2(r),o>>>0>=2147483640)break i;r:{f:{if(o>>>0>=11){e=o|7,f=p(e+1|0),i[k+124>>2]=e-2147483647,i[k+116>>2]=f,i[k+120>>2]=o;break f}if(u[k+127|0]=o,f=k+116|0,!o)break r}if(!o)break r;x(f,r,o)}u[f+o|0]=0,f=q(k+32|0,s,n,k+116|0),e=i[f+4>>2],i[A>>2]=i[f>>2],i[A+4>>2]=e,r=A+8|0;r:{if(u[f+19|0]>=0){e=i[f+12>>2],i[r>>2]=i[f+8>>2],i[r+4>>2]=e,i[r+8>>2]=i[f+16>>2],u[A+44|0]=1;break r}if(T(r,i[f+8>>2],i[f+12>>2]),e=u[f+19|0],u[A+44|0]=1,(e|0)>=0)break r;Z(i[f+8>>2])}if(u[k+127|0]>=0)break e;Z(i[k+116>>2]);break e}if(i[k+116>>2]=0,i[k+112>>2]=0,W[i[i[f>>2]+104>>2]](k+32|0,i[f+4>>2],k+108|0,k+104|0,0),e=i[k+108>>2],e)for(;;){r:{f:{if(r=i[k+104>>2],(r|0)<2)break f;A:switch((l[e+1|0]>>>3|0)-14|0){case 1:g[k+32>>1]=259,i[k+88>>2]=0,i[k+92>>2]=0,i[k+80>>2]=0,i[k+84>>2]=0,i[k+72>>2]=0,i[k+76>>2]=0,i[k+64>>2]=0,i[k+68>>2]=0,i[k+56>>2]=0,i[k+60>>2]=0,i[k+48>>2]=0,i[k+52>>2]=0,$7(k+12|0,e,r,k+32|0,k+116|0,k+112|0),u[k+31|0]<0&&Z(i[k+20>>2]),n=k+32|0,e=i[n+4>>2],i[o+104>>2]=i[n>>2],i[o+108>>2]=e,i[o+112>>2]=i[n+8>>2],g[o+116>>1]=C[n+12>>1];k:{if((n|0)==(o+104|0)){Xu(o+132|0,n+28|0);break k}r=i[n+16>>2],e=i[n+20>>2],d4(o+120|0,r,e,e-r|0),Xu(o+132|0,n+28|0),r=i[n+40>>2],e=i[n+44>>2],d4(o+144|0,r,e,e-r|0),r=i[n+52>>2],e=i[n+56>>2],k6(o+156|0,r,e,e-r>>2)}i[o+168>>2]=i[n+64>>2],g[o+172>>1]=C[n+68>>1],e=i[k+84>>2],e&&(i[k+88>>2]=e,Z(e)),e=i[k+72>>2],e&&(i[k+76>>2]=e,Z(e)),e=i[k+60>>2],e&&Z(e),e=i[k+48>>2],e&&(i[k+52>>2]=e,Z(e)),r=i[k+104>>2],e=i[k+108>>2];break;case 0:case 2:break A;default:break f}Vr(o,e,r);break r}Xi(k+148|0,e,r)}if(W[i[i[f>>2]+104>>2]](k+32|0,i[f+4>>2],k+108|0,k+104|0,0),e=i[k+108>>2],!e)break}u[k+174|0]=0,g[k+172>>1]=257,o=i[k+156>>2],s=i[k+160>>2],i[k+156>>2]=0,n=i[k+148>>2],f=i[k+152>>2],i[k+148>>2]=0,i[k+152>>2]=0,r=i[k+164>>2],e=i[k+168>>2],i[k+160>>2]=0,i[k+164>>2]=0,i[k+168>>2]=0,i[A+16>>2]=r,i[A+20>>2]=e,i[A+8>>2]=o,i[A+12>>2]=s,i[A>>2]=n,i[A+4>>2]=f,e=i[k+176>>2],i[A+24>>2]=i[k+172>>2],i[A+28>>2]=e,e=i[k+184>>2],i[A+32>>2]=i[k+180>>2],i[A+36>>2]=e,i[A+40>>2]=i[k+188>>2],u[A+44|0]=0}e=i[k+144>>2];e:{if(!e||(A=i[e+4>>2],i[e+4>>2]=A-1,A))break e;W[i[i[e>>2]+8>>2]](e),y(e)}if(A=i[t+4>>2],i[t+4>>2]=A-1,A||(W[i[i[t>>2]+8>>2]](t),y(t)),A=i[k+160>>2],A&&(i[k+164>>2]=A,Z(A)),A=i[k+148>>2],A){if(e=A,r=i[k+152>>2],(e|0)!=(r|0)){for(;;){f=i[r-4>>2];e:{if(!f||(e=i[f+4>>2],i[f+4>>2]=e-1,e))break e;W[i[i[f>>2]+8>>2]](f),y(f)}if(r=r-8|0,(A|0)==(r|0))break}e=i[k+148>>2]}i[k+152>>2]=A,Z(e)}v=k+192|0;return}Q0(),H()}function lv(A,e,r,f,k,n,t,o){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,t=t|0,o=o|0;var s=0,w=0,h=0,_=0;o=v-16|0,v=o,i[o+12>>2]=e,i[k>>2]=0,s=i[f+28>>2],i[o>>2]=s,(s|0)!=129576&&(i[s+4>>2]=i[s+4>>2]+1),s=c0(o,129760),e2(o);i:{e:{r:{f:switch(t-65|0){case 0:case 32:ml(A,n+24|0,o+12|0,r,k,s);break e;case 1:case 33:case 39:hl(A,n+16|0,o+12|0,r,k,s);break e;case 34:e=W[i[i[A+8>>2]+12>>2]](A+8|0)|0,t=A,w=i[o+12>>2],l[e+11|0]>>>7|0?A=i[e>>2]:A=e,s=A,l[e+11|0]>>>7|0?A=i[e>>2]:A=e,l[e+11|0]>>>7|0?e=i[e+4>>2]:e=l[e+11|0]&127,h=o,_=x8(t,w,r,f,k,n,s,A+e|0),i[h+12>>2]=_;break e;case 35:case 36:A=W8(o+12|0,r,k,s,2),e=i[k>>2];A:{if(!(A-1>>>0>30|e&4)){i[n+12>>2]=A;break A}i[k>>2]=e|4}break e;case 3:i[o>>2]=623865125,i[o+4>>2]=2032480100,h=o,_=x8(A,e,r,f,k,n,o,o+8|0),i[h+12>>2]=_;break e;case 5:i[o>>2]=623728933,i[o+4>>2]=1680158061,h=o,_=x8(A,e,r,f,k,n,o,o+8|0),i[h+12>>2]=_;break e;case 7:A=W8(o+12|0,r,k,s,2),e=i[k>>2];A:{if(!((A|0)>23|e&4)){i[n+8>>2]=A;break A}i[k>>2]=e|4}break e;case 8:A=W8(o+12|0,r,k,s,2),e=i[k>>2];A:{if(!(A-1>>>0>11|e&4)){i[n+8>>2]=A;break A}i[k>>2]=e|4}break e;case 41:A=W8(o+12|0,r,k,s,3),e=i[k>>2];A:{if(!((A|0)>365|e&4)){i[n+28>>2]=A;break A}i[k>>2]=e|4}break e;case 44:e=W8(o+12|0,r,k,s,2)-1|0,A=i[k>>2];A:{if(!(e>>>0>11|A&4)){i[n+16>>2]=e;break A}i[k>>2]=A|4}break e;case 12:A=W8(o+12|0,r,k,s,2),e=i[k>>2];A:{if(!((A|0)>59|e&4)){i[n+4>>2]=A;break A}i[k>>2]=e|4}break e;case 45:case 51:for(A=o+12|0,e=v-16|0,v=e,i[e+12>>2]=r;;){A:{if(L2(A,e+12|0))break A;r=i[A>>2],f=i[r+12>>2];k:{if((f|0)==i[r+16>>2]){r=W[i[i[r>>2]+36>>2]](r)|0;break k}r=u[f|0]}if(r=r<<24>>24,(r|0)>=0?r=i[i[s+8>>2]+(r<<2)>>2]&1:r=0,!r)break A;q1(A);continue}break}L2(A,e+12|0)&&(i[k>>2]=i[k>>2]|2),v=e+16|0;break e;case 47:t=o+12|0,e=W[i[i[A+8>>2]+8>>2]](A+8|0)|0;A:{if(l[e+11|0]>>>7|0){A=i[e+4>>2];break A}A=l[e+11|0]&127}l[e+23|0]>>>7|0?f=i[e+16>>2]:f=l[e+23|0]&127;A:{if((A|0)==(0-f|0)){i[k>>2]=i[k>>2]|4;break A}if(r=Wr(t,r,e,e+24|0,s,k,0),A=i[n+8>>2],!((r|0)!=(e|0)|(A|0)!=12)){i[n+8>>2]=0;break A}(r-e|0)!=12|(A|0)>11||(i[n+8>>2]=A+12)}break e;case 49:t=l[77784]|l[77785]<<8|(l[77786]<<16|l[77787]<<24),u[o+7|0]=t,u[o+8|0]=t>>>8,u[o+9|0]=t>>>16,u[o+10|0]=t>>>24,t=l[77781]|l[77782]<<8|(l[77783]<<16|l[77784]<<24),i[o>>2]=l[77777]|l[77778]<<8|(l[77779]<<16|l[77780]<<24),i[o+4>>2]=t,h=o,_=x8(A,e,r,f,k,n,o,o+11|0),i[h+12>>2]=_;break e;case 17:u[o+4|0]=l[77792],i[o>>2]=l[77788]|l[77789]<<8|(l[77790]<<16|l[77791]<<24),h=o,_=x8(A,e,r,f,k,n,o,o+5|0),i[h+12>>2]=_;break e;case 18:A=W8(o+12|0,r,k,s,2),e=i[k>>2];A:{if(!((A|0)>60|e&4)){i[n>>2]=A;break A}i[k>>2]=e|4}break e;case 19:i[o>>2]=624576549,i[o+4>>2]=1394948685,h=o,_=x8(A,e,r,f,k,n,o,o+8|0),i[h+12>>2]=_;break e;case 54:A=W8(o+12|0,r,k,s,1),e=i[k>>2];A:{if(!((A|0)>6|e&4)){i[n+24>>2]=A;break A}i[k>>2]=e|4}break e;case 55:A=W[i[i[A>>2]+20>>2]](A,e,r,f,k,n)|0;break i;case 23:e=W[i[i[A+8>>2]+24>>2]](A+8|0)|0,t=A,w=i[o+12>>2],l[e+11|0]>>>7|0?A=i[e>>2]:A=e,s=A,l[e+11|0]>>>7|0?A=i[e>>2]:A=e,l[e+11|0]>>>7|0?e=i[e+4>>2]:e=l[e+11|0]&127,h=o,_=x8(t,w,r,f,k,n,s,A+e|0),i[h+12>>2]=_;break e;case 56:Ul(n+20|0,o+12|0,r,k,s);break e;case 24:A=W8(o+12|0,r,k,s,4),l[k|0]&4||(i[n+20>>2]=A-1900);break e;default:if((t|0)==37)break r;break;case 2:case 4:case 6:case 9:case 10:case 11:case 13:case 14:case 15:case 16:case 20:case 21:case 22:case 25:case 26:case 27:case 28:case 29:case 30:case 31:case 37:case 38:case 40:case 42:case 43:case 46:case 48:case 50:case 52:case 53:break f}i[k>>2]=i[k>>2]|4;break e}A=v-16|0,v=A,i[A+12>>2]=r,r=o+12|0,n=A+12|0,e=6;r:{f:{if(L2(r,n))break f;e=i[r>>2],f=i[e+12>>2];A:{if((f|0)==i[e+16>>2]){f=W[i[i[e>>2]+36>>2]](e)|0;break A}f=u[f|0]}if(e=4,(W[i[i[s>>2]+36>>2]](s,f<<24>>24,0)|0)!=37)break f;if(!L2(q1(r),n))break r;e=2}i[k>>2]=e|i[k>>2]}v=A+16|0}A=i[o+12>>2]}return v=o+16|0,A|0}function sv(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0;var k=0,n=0,t=0,o=0,s=0;k=v-192|0,v=k,z2(k+172|0,e,r),u[k+191|0]<0&&Z(i[k+180>>2]);i:{if(l[e+97|0]){t1(A,e,4441);break i}if(n=C0(r),n>>>0>u0[f+80>>2]){if(e=p(64),i[k+24>>2]=e,i[k+28>>2]=61,i[k+32>>2]=-2147483584,r=l[17289]|l[17290]<<8|(l[17291]<<16|l[17292]<<24),f=l[17285]|l[17286]<<8|(l[17287]<<16|l[17288]<<24),u[e|0]=f,u[e+1|0]=f>>>8,u[e+2|0]=f>>>16,u[e+3|0]=f>>>24,u[e+4|0]=r,u[e+5|0]=r>>>8,u[e+6|0]=r>>>16,u[e+7|0]=r>>>24,u[e+61|0]=0,r=l[17342]|l[17343]<<8|(l[17344]<<16|l[17345]<<24),f=l[17338]|l[17339]<<8|(l[17340]<<16|l[17341]<<24),u[e+53|0]=f,u[e+54|0]=f>>>8,u[e+55|0]=f>>>16,u[e+56|0]=f>>>24,u[e+57|0]=r,u[e+58|0]=r>>>8,u[e+59|0]=r>>>16,u[e+60|0]=r>>>24,r=l[17337]|l[17338]<<8|(l[17339]<<16|l[17340]<<24),f=l[17333]|l[17334]<<8|(l[17335]<<16|l[17336]<<24),u[e+48|0]=f,u[e+49|0]=f>>>8,u[e+50|0]=f>>>16,u[e+51|0]=f>>>24,u[e+52|0]=r,u[e+53|0]=r>>>8,u[e+54|0]=r>>>16,u[e+55|0]=r>>>24,r=l[17329]|l[17330]<<8|(l[17331]<<16|l[17332]<<24),f=l[17325]|l[17326]<<8|(l[17327]<<16|l[17328]<<24),u[e+40|0]=f,u[e+41|0]=f>>>8,u[e+42|0]=f>>>16,u[e+43|0]=f>>>24,u[e+44|0]=r,u[e+45|0]=r>>>8,u[e+46|0]=r>>>16,u[e+47|0]=r>>>24,r=l[17321]|l[17322]<<8|(l[17323]<<16|l[17324]<<24),f=l[17317]|l[17318]<<8|(l[17319]<<16|l[17320]<<24),u[e+32|0]=f,u[e+33|0]=f>>>8,u[e+34|0]=f>>>16,u[e+35|0]=f>>>24,u[e+36|0]=r,u[e+37|0]=r>>>8,u[e+38|0]=r>>>16,u[e+39|0]=r>>>24,r=l[17313]|l[17314]<<8|(l[17315]<<16|l[17316]<<24),f=l[17309]|l[17310]<<8|(l[17311]<<16|l[17312]<<24),u[e+24|0]=f,u[e+25|0]=f>>>8,u[e+26|0]=f>>>16,u[e+27|0]=f>>>24,u[e+28|0]=r,u[e+29|0]=r>>>8,u[e+30|0]=r>>>16,u[e+31|0]=r>>>24,r=l[17305]|l[17306]<<8|(l[17307]<<16|l[17308]<<24),f=l[17301]|l[17302]<<8|(l[17303]<<16|l[17304]<<24),u[e+16|0]=f,u[e+17|0]=f>>>8,u[e+18|0]=f>>>16,u[e+19|0]=f>>>24,u[e+20|0]=r,u[e+21|0]=r>>>8,u[e+22|0]=r>>>16,u[e+23|0]=r>>>24,r=l[17297]|l[17298]<<8|(l[17299]<<16|l[17300]<<24),f=l[17293]|l[17294]<<8|(l[17295]<<16|l[17296]<<24),u[e+8|0]=f,u[e+9|0]=f>>>8,u[e+10|0]=f>>>16,u[e+11|0]=f>>>24,u[e+12|0]=r,u[e+13|0]=r>>>8,u[e+14|0]=r>>>16,u[e+15|0]=r>>>24,q(A,6,1e3,k+24|0),u[k+35|0]>=0)break i;Z(i[k+24>>2]);break i}if(q4(A,e+116|0,n<<3,f,13698),i[A>>2])break i;u[A+19|0]<0&&Z(i[A+8>>2]),f=e+104|0;e:{r:{f:{o=i[e+104>>2],t=i[e+108>>2]-o>>3;A:{k:{if(t>>>0<n>>>0){ui(f,n-t|0);break k}if(n>>>0<t>>>0&&(i[e+108>>2]=o+(n<<3)),!n)break A}for(e=0;;){if(!i[r+16>>2]){i[k+116>>2]=0,i[k+88>>2]=72196,i[k+32>>2]=72176,r=i[18053],i[k+24>>2]=r,f=i[r-12>>2],r=k+24|0,i[f+r>>2]=i[18054],i[k+28>>2]=0,f=r+i[i[k+24>>2]-12>>2]|0,t=k+36|0,J0(f,t),u[f+80|0]=0,i[f+72>>2]=0,f=i[18055],i[k+32>>2]=f,o=k+32|0,i[o+i[f-12>>2]>>2]=i[18056],f=i[18052],i[k+24>>2]=f,i[r+i[f-12>>2]>>2]=i[18057],i[k+88>>2]=72196,i[k+24>>2]=72156,i[k+32>>2]=72176,f=R0(t),i[f>>2]=71232,i[k+76>>2]=0,i[k+80>>2]=0,i[k+68>>2]=0,i[k+72>>2]=0,i[k+84>>2]=24,Y(V0(Y(V0(Y(o,28093,24),n),28927,33),e),5504,8),e=i[k+84>>2];k:{if(e&16){r=i[k+80>>2],e=i[k+60>>2],r>>>0<e>>>0&&(i[k+80>>2]=e,r=e),e=k+56|0;break k}if(!(e&8)){r=0,u[k+23|0]=0,e=k+12|0;break e}r=i[k+52>>2],e=k+44|0}if(n=i[e>>2],r=r-n|0,r>>>0>=2147483640)break f;if(r>>>0>=11){t=r|7,e=p(t+1|0),i[k+20>>2]=t-2147483647,i[k+12>>2]=e,i[k+16>>2]=r;break r}if(u[k+23|0]=r,e=k+12|0,r)break r;r=0;break e}if(t=C0(r),o=C0(r),s=i[f>>2]+(e<<3)|0,i[s+4>>2]=o,i[s>>2]=t,e=e+1|0,(n|0)==(e|0))break}}if(l[r+20|0]==1){if(u[k+24|0]=0,u[k+35|0]=0,q(A,2,100,k+24|0),u[k+35|0]>=0)break i;Z(i[k+24>>2]);break i}if(e=i[26917],i[A>>2]=i[26916],i[A+4>>2]=e,A=A+8|0,u[107683]>=0){e=i[26919],i[A>>2]=i[26918],i[A+4>>2]=e,i[A+8>>2]=i[26920];break i}T(A,i[26918],i[26919]);break i}Q0(),H()}if(!r)break e;x(e,n,r)}u[e+r|0]=0,q(A,2,100,k+12|0),u[k+23|0]<0&&Z(i[k+12>>2]),A=i[18051],i[k+24>>2]=A,i[i[A-12>>2]+(k+24|0)>>2]=i[18059],i[k+32>>2]=i[18060],i[f>>2]=71232,u[k+79|0]<0&&Z(i[k+68>>2]),E0(f),y0(k+88|0)}v=k+192|0}function a6(A,e,r){var f=0,k=0,n=0,t=0,o=0,s=0;f=v-96|0,v=f;i:{e:{r:{f:{A:{k:{if(n=i[e+128>>2],!n)break k;for(o=e+128|0,t=o,k=n;s=u0[k+16>>2]<r>>>0,t=s?t:k,k=i[(s?4:0)+k>>2],!!k;);if((t|0)==(o|0)|u0[t+16>>2]>r>>>0)break k;for(k=o;t=u0[n+16>>2]<r>>>0,k=t?k:n,n=i[(t?4:0)+n>>2],!!n;);if(t=0,!((k|0)==(o|0)|u0[k+16>>2]>r>>>0)&&(n=i[k+20>>2],t=i[k+24>>2],t&&(i[t+4>>2]=i[t+4>>2]+1),n))break r;if(u[f+16|0]=0,u[f+27|0]=0,e=q(f+72|0,5,2e3,f+16|0),r=i[e+4>>2],i[A>>2]=i[e>>2],i[A+4>>2]=r,r=A+8|0,u[e+19|0]<0)break A;k=i[e+12>>2],i[r>>2]=i[e+8>>2],i[r+4>>2]=k,i[r+8>>2]=i[e+16>>2],u[A+20|0]=1;break f}u[f+16|0]=0,u[f+27|0]=0,e=q(f+72|0,5,2e3,f+16|0),r=i[e+4>>2],i[A>>2]=i[e>>2],i[A+4>>2]=r,r=A+8|0;k:{if(u[e+19|0]>=0){k=i[e+12>>2],i[r>>2]=i[e+8>>2],i[r+4>>2]=k,i[r+8>>2]=i[e+16>>2],u[A+20|0]=1;break k}if(T(r,i[e+8>>2],i[e+12>>2]),r=u[e+19|0],u[A+20|0]=1,(r|0)>=0)break k;Z(i[e+8>>2])}if(u[f+27|0]>=0)break i;Z(i[f+16>>2]);break i}if(T(r,i[e+8>>2],i[e+12>>2]),r=u[e+19|0],u[A+20|0]=1,(r|0)>=0)break f;Z(i[e+8>>2])}if(u[f+27|0]>=0)break e;Z(i[f+16>>2]);break e}k=i[n+112>>2];r:{if(u[n+139|0]>=0){i[f- -64>>2]=i[n+136>>2],o=i[n+132>>2],i[f+56>>2]=i[n+128>>2],i[f+60>>2]=o;break r}T(f+56|0,i[n+128>>2],i[n+132>>2])}i[f+72>>2]=0,i[f+76>>2]=0,i[f+88>>2]=0,i[f+80>>2]=0,i[f+84>>2]=0;r:{f:{A:{if((k|0)!=1835625829)break A;k:{if(u[n+151|0]>=0){i[f+48>>2]=i[n+148>>2],k=i[n+144>>2],i[f+40>>2]=i[n+140>>2],i[f+44>>2]=k;break k}T(f+40|0,i[n+140>>2],i[n+144>>2])}n=u[f+51|0],k=(n|0)<0;k:{n:{t:{u:{o:switch(o=k?i[f+44>>2]:n,o|0){case 0:break k;case 2:break t;case 7:break u;case 13:break o;default:break n}if(e=f+40|0,N2(k?i[f+40>>2]:e,18347,13))break n;if(e=q(f+16|0,4,3005,e),r=i[e+4>>2],i[A>>2]=i[e>>2],i[A+4>>2]=r,r=A+8|0,u[e+19|0]>=0){k=i[e+12>>2],i[r>>2]=i[e+8>>2],i[r+4>>2]=k,i[r+8>>2]=i[e+16>>2],u[A+20|0]=1;break f}if(T(r,i[e+8>>2],i[e+12>>2]),r=u[e+19|0],u[A+20|0]=1,(r|0)>=0)break f;Z(i[e+8>>2]);break f}if(e=f+40|0,N2(k?i[f+40>>2]:e,12192,o))break n;if(e=q(f+16|0,4,3005,e),r=i[e+4>>2],i[A>>2]=i[e>>2],i[A+4>>2]=r,r=A+8|0,u[e+19|0]>=0){k=i[e+12>>2],i[r>>2]=i[e+8>>2],i[r+4>>2]=k,i[r+8>>2]=i[e+16>>2],u[A+20|0]=1;break f}if(T(r,i[e+8>>2],i[e+12>>2]),r=u[e+19|0],u[A+20|0]=1,(r|0)>=0)break f;Z(i[e+8>>2]);break f}if(e=f+40|0,N2(k?i[f+40>>2]:e,7623,o))break n;if(e=q(f+16|0,4,3005,e),r=i[e+4>>2],i[A>>2]=i[e>>2],i[A+4>>2]=r,r=A+8|0,u[e+19|0]>=0){k=i[e+12>>2],i[r>>2]=i[e+8>>2],i[r+4>>2]=k,i[r+8>>2]=i[e+16>>2],u[A+20|0]=1;break f}if(T(r,i[e+8>>2],i[e+12>>2]),r=u[e+19|0],u[A+20|0]=1,(r|0)>=0)break f;Z(i[e+8>>2]);break f}k=d2(f+4|0,42673),e=q(f+16|0,4,3e3,k),r=i[e+4>>2],i[A>>2]=i[e>>2],i[A+4>>2]=r,r=A+8|0;n:{if(u[e+19|0]>=0){n=i[e+12>>2],i[r>>2]=i[e+8>>2],i[r+4>>2]=n,i[r+8>>2]=i[e+16>>2],u[A+20|0]=1;break n}if(T(r,i[e+8>>2],i[e+12>>2]),r=u[e+19|0],u[A+20|0]=1,(r|0)>=0)break n;Z(i[e+8>>2])}if(u[k+11|0]>=0)break f;Z(i[k>>2]);break f}if((n|0)>=0)break A;Z(i[f+40>>2])}i[f+48>>2]=0,i[f+40>>2]=0,i[f+44>>2]=0,q6(f+16|0,i[e+68>>2],r,e+8|0,e+76|0,f+40|0,0,0,-1,-1,i[e+156>>2]),r=i[f+20>>2],e=i[f+16>>2],i[f+72>>2]=e,i[f+76>>2]=r,u[f+91|0]<0&&(Z(i[f+80>>2]),e=i[f+72>>2]),r=i[f+28>>2],i[f+80>>2]=i[f+24>>2],i[f+84>>2]=r,i[f+88>>2]=i[f+32>>2];A:{k:{if(e){if(e=i[f+76>>2],i[A>>2]=i[f+72>>2],i[A+4>>2]=e,e=A+8|0,u[f+91|0]<0)break k;r=i[f+84>>2],i[e>>2]=i[f+80>>2],i[e+4>>2]=r,i[e+8>>2]=i[f+88>>2];break A}e=i[f+48>>2],i[f+48>>2]=0,r=i[f+44>>2],k=i[f+40>>2],u[A+20|0]=0,i[A+8>>2]=e,i[A>>2]=k,i[A+4>>2]=r;break r}T(e,i[f+80>>2],i[f+84>>2])}if(u[A+20|0]=1,A=i[f+40>>2],!A)break r;i[f+44>>2]=A,Z(A);break r}if(u[f+51|0]>=0)break r;Z(i[f+40>>2])}if(u[f+91|0]<0&&Z(i[f+80>>2]),u[f+67|0]>=0)break e;Z(i[f+56>>2])}if(!t||(A=i[t+4>>2],i[t+4>>2]=A-1,A))break i;W[i[i[t>>2]+8>>2]](t),y(t)}v=f+96|0}function wv(A,e,r,f,k,n){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0;var t=0,o=0,s=0,w=0,h=0,_=0;k=v-144|0,v=k,i[k+104>>2]=0,i[k+108>>2]=0,i[k+112>>2]=0,i[k+116>>2]=0,u[k+119|0]=0,u[k+120|0]=0,u[k+121|0]=0,u[k+122|0]=0,i[k+96>>2]=0,i[k+100>>2]=0,i[k+124>>2]=0,i[k+128>>2]=0,i[k+136>>2]=0,u[k+132|0]=1,e=p(160),i[e>>2]=90364,i[e+4>>2]=0,i[e+8>>2]=0,o=e+16|0,i[o+8>>2]=0,i[o+12>>2]=0,i[o+16>>2]=0,i[o+20>>2]=0,i[o+24>>2]=0,i[o+28>>2]=0,i[o+32>>2]=0,i[o>>2]=86356,i[e+60>>2]=0,i[e+64>>2]=0,i[e+52>>2]=0,i[e+56>>2]=0,i[e+72>>2]=-1,i[e+76>>2]=-1,i[e+80>>2]=-1,i[e+84>>2]=-1,i[e+88>>2]=0,i[e+92>>2]=0,i[e+96>>2]=0,i[e+100>>2]=0,i[e+104>>2]=0,i[e+108>>2]=0,u[e+112|0]=0,i[o>>2]=97504,i[e+156>>2]=0,i[e+148>>2]=0,i[e+152>>2]=0,u[e+145|0]=4,i[e+124>>2]=0,i[e+128>>2]=0,i[e+32>>2]=1752589123,s=i[r>>2],t=i[r+4>>2],t&&(i[t+4>>2]=i[t+4>>2]+1),i[k+92>>2]=t,i[k+88>>2]=s,W[i[i[f>>2]+100>>2]](k+76|0,i[f+4>>2],k+88|0,n);i:{e:{r:{n=i[k+76>>2];f:{if(n){if(t=i[k+80>>2],o=i[k+84>>2],r=h2(o),r>>>0>=2147483640)break r;A:{k:{if(r>>>0>=11){s=r|7,f=p(s+1|0),i[k+52>>2]=s-2147483647,i[k+44>>2]=f,i[k+48>>2]=r;break k}if(u[k+55|0]=r,f=k+44|0,!r)break A}if(!r)break A;x(f,o,r)}u[r+f|0]=0,r=q(k+56|0,n,t,k+44|0),f=i[r+4>>2],i[A>>2]=i[r>>2],i[A+4>>2]=f,f=A+8|0;A:{if(u[r+19|0]>=0){n=i[r+12>>2],i[f>>2]=i[r+8>>2],i[f+4>>2]=n,i[f+8>>2]=i[r+16>>2],u[A+44|0]=1;break A}if(T(f,i[r+8>>2],i[r+12>>2]),f=u[r+19|0],u[A+44|0]=1,(f|0)>=0)break A;Z(i[r+8>>2])}if(u[k+55|0]>=0)break f;Z(i[k+44>>2]);break f}if(i[k+40>>2]=0,i[k+36>>2]=0,W[i[i[f>>2]+104>>2]](k+56|0,i[f+4>>2],k+44|0,k+32|0,0),t=i[k+44>>2],t)for(w=e+116|0;;){n=l[t|0],(n&254)==66&&(K9(k+12|0,t,i[k+32>>2],w,k+40|0,k+36|0),u[k+31|0]<0&&Z(i[k+20>>2]),i[k+124>>2]=i[k+40>>2],i[k+128>>2]=i[k+36>>2],t=i[k+44>>2],n=l[t|0]),s=i[k+32>>2];A:{if((((n&254)>>>1|0)-32&255)>>>0<=2){Gr(o,t,s);break A}Xi(k+96|0,t,s)}if(W[i[i[f>>2]+104>>2]](k+56|0,i[f+4>>2],k+44|0,k+32|0,0),t=i[k+44>>2],!t)break}if(!(i[k+36>>2]&&i[k+40>>2])){u[k+44|0]=0,u[k+55|0]=0,r=q(k+56|0,8,129,k+44|0),f=i[r+4>>2],i[A>>2]=i[r>>2],i[A+4>>2]=f,f=A+8|0;A:{if(u[r+19|0]>=0){n=i[r+12>>2],i[f>>2]=i[r+8>>2],i[f+4>>2]=n,i[f+8>>2]=i[r+16>>2],u[A+44|0]=1;break A}if(T(f,i[r+8>>2],i[r+12>>2]),f=u[r+19|0],u[A+44|0]=1,(f|0)>=0)break A;Z(i[r+8>>2])}if(u[k+55|0]>=0)break f;Z(i[k+44>>2]);break f}i[e+4>>2]=i[e+4>>2]+1,n=i[k+100>>2],w=i[k+104>>2];A:{if(n>>>0<w>>>0){i[n+4>>2]=e,i[n>>2]=o,t=n+8|0;break A}if(s=i[k+96>>2],n=n-s|0,_=n>>3,t=_+1|0,t>>>0>=536870912)break e;if(w=w-s|0,h=w>>2,w=w>>>0>=2147483640?536870911:t>>>0<h>>>0?h:t,w){if(w>>>0>=536870912)break i;t=p(w<<3)}else t=0;if(h=t+n|0,i[h+4>>2]=e,i[h>>2]=o,o=h-(_<<3)|0,n&&x(o,s,n),i[k+104>>2]=t+(w<<3),t=h+8|0,i[k+100>>2]=t,i[k+96>>2]=o,!s)break A;Z(s)}i[k+100>>2]=t,n=i[f>>2];A:{if(i[n>>2]<3||(n=i[n+112>>2],!n))break A;r=i[r>>2],t=i[r+108>>2],i[k+56>>2]=t,r=i[r+112>>2],i[k+44>>2]=r,W[n|0](i[f+4>>2],t,r,k+56|0,k+44|0),t=i[k+100>>2]}g[k+120>>1]=257,r=i[k+96>>2],i[k+96>>2]=0,f=i[k+104>>2],n=i[k+108>>2],i[k+100>>2]=0,i[k+104>>2]=0,o=i[k+112>>2],s=i[k+116>>2],i[k+108>>2]=0,i[k+112>>2]=0,i[k+116>>2]=0,i[A+16>>2]=o,i[A+20>>2]=s,i[A+8>>2]=f,i[A+12>>2]=n,i[A+4>>2]=t,i[A>>2]=r,r=i[k+124>>2],i[A+24>>2]=i[k+120>>2],i[A+28>>2]=r,r=i[k+132>>2],i[A+32>>2]=i[k+128>>2],i[A+36>>2]=r,i[A+40>>2]=i[k+136>>2],u[A+44|0]=0}A=i[k+92>>2];f:{if(!A||(r=i[A+4>>2],i[A+4>>2]=r-1,r))break f;W[i[i[A>>2]+8>>2]](A),y(A)}if(A=i[e+4>>2],i[e+4>>2]=A-1,A||(W[i[i[e>>2]+8>>2]](e),y(e)),A=i[k+108>>2],A&&(i[k+112>>2]=A,Z(A)),A=i[k+96>>2],A){if(e=A,t=i[k+100>>2],(e|0)!=(t|0)){for(;;){e=i[t-4>>2];f:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break f;W[i[i[e>>2]+8>>2]](e),y(e)}if(t=t-8|0,(A|0)==(t|0))break}e=i[k+96>>2]}i[k+100>>2]=A,Z(e)}v=k+144|0;return}Q0(),H()}G0(),H()}z0(),H()}function hv(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0;var k=0,n=0,t=0,o=0,s=0,w=0,h=0,_=0,B=0,m=0,X=0,Q=0,V=0,F=0,I=0;i:{for(f=A,A=0,t=v-32|0,v=t,s=e+100|0,V=s,F=X2(r),u[V|0]=F,e=X2(r),u[s+3|0]=e&31,u[s+1|0]=e>>>6,u[s+2|0]=e>>>5&1,V=s,F=C0(r),i[V+4>>2]=F,w=s+8|0;e=X2(r),o=w+(A&-4)|0,n=i[o>>2],k=A<<3,n=(V=n|1<<k,F=k2(-2,k)&n,I=e<<24>>24<0,I?V:F),h=o,o=2<<k,n=e&64?o|n:n&(o^-1),o=4<<k,n=e&32?n|o:n&(o^-1),o=8<<k,n=e&16?n|o:n&(o^-1),o=16<<k,n=e&8?n|o:n&(o^-1),o=32<<k,n=e&4?n|o:n&(o^-1),o=64<<k,n=e&2?n|o:n&(o^-1),k=128<<k,i[h>>2]=e&1?n|k:n&(k^-1),A=A+1|0,(A|0)!=6;);V=s,F=X2(r),u[V+16|0]=F,V=s,F=o2(r)&4095,g[V+18>>1]=F,V=s,F=X2(r)&3,u[V+20|0]=F,V=s,F=X2(r)&3,u[V+21|0]=F,V=s,F=X2(r)&7|8,u[V+22|0]=F,V=s,F=X2(r)&7|8,u[V+23|0]=F,V=s,F=o2(r),g[V+24>>1]=F,A=X2(r),u[s+26|0]=A>>>6,u[s+29|0]=(A&3)+1,u[s+28|0]=A>>>2&1,u[s+27|0]=A>>>3&7;e:{r:{B=X2(r);f:{A:{if(!B)break A;for(Q=s+32|0;;){if(l[r+20|0])break A;A=X2(r),_=0,i[t+28>>2]=0,i[t+20>>2]=0,i[t+24>>2]=0,u[t+17|0]=A&63,u[t+16|0]=A>>>6&1,m=o2(r);k:{n:{if(!m|u[r+20|0]&1)break n;for(;;){if(k=o2(r),k){e=0,A=0;t:{if(!f4(r,k))break t;e=p(k),k&&o0(e,0,k),A=e+k|0,w=i[r>>2],n=i[r+4>>2];u:{if(!n){if(!(W[i[i[w>>2]+16>>2]](w,e,k)|0))break u;break t}if(i[n+4>>2]=i[n+4>>2]+1,k=W[i[i[w>>2]+16>>2]](w,e,k)|0,w=i[n+4>>2],i[n+4>>2]=w-1,w||(W[i[i[n>>2]+8>>2]](n),y(n)),k)break t}A=p(32),i[t+4>>2]=A,i[t+8>>2]=28,i[t+12>>2]=-2147483616,k=l[2534]|l[2535]<<8|(l[2536]<<16|l[2537]<<24),n=l[2530]|l[2531]<<8|(l[2532]<<16|l[2533]<<24),u[A|0]=n,u[A+1|0]=n>>>8,u[A+2|0]=n>>>16,u[A+3|0]=n>>>24,u[A+4|0]=k,u[A+5|0]=k>>>8,u[A+6|0]=k>>>16,u[A+7|0]=k>>>24,u[A+28|0]=0,k=l[2554]|l[2555]<<8|(l[2556]<<16|l[2557]<<24),u[A+24|0]=k,u[A+25|0]=k>>>8,u[A+26|0]=k>>>16,u[A+27|0]=k>>>24,k=l[2550]|l[2551]<<8|(l[2552]<<16|l[2553]<<24),n=l[2546]|l[2547]<<8|(l[2548]<<16|l[2549]<<24),u[A+16|0]=n,u[A+17|0]=n>>>8,u[A+18|0]=n>>>16,u[A+19|0]=n>>>24,u[A+20|0]=k,u[A+21|0]=k>>>8,u[A+22|0]=k>>>16,u[A+23|0]=k>>>24,k=l[2542]|l[2543]<<8|(l[2544]<<16|l[2545]<<24),n=l[2538]|l[2539]<<8|(l[2540]<<16|l[2541]<<24),u[A+8|0]=n,u[A+9|0]=n>>>8,u[A+10|0]=n>>>16,u[A+11|0]=n>>>24,u[A+12|0]=k,u[A+13|0]=k>>>8,u[A+14|0]=k>>>16,u[A+15|0]=k>>>24,q(f,2,100,t+4|0),u[t+15|0]<0&&Z(i[t+4>>2]),Z(e),n=0;break k}k=i[t+24>>2],o=i[t+28>>2];t:{if(k>>>0<o>>>0){i[k+8>>2]=A,i[k+4>>2]=A,i[k>>2]=e,A=k+12|0;break t}if(w=i[t+20>>2],k=k-w|0,n=((k|0)/12|0)+1|0,n>>>0>=357913942)break r;if(o=(o-w|0)/12|0,h=o<<1,h=o>>>0>=178956970?357913941:n>>>0<h>>>0?h:n,h){if(h>>>0>=357913942)break e;n=p(G(h,12))}else n=0;if(o=n+k|0,i[o+8>>2]=A,i[o+4>>2]=A,i[o>>2]=e,e=o+G((k|0)/-12|0,12)|0,k&&x(e,w,k),i[t+28>>2]=n+G(h,12),A=o+12|0,i[t+24>>2]=A,i[t+20>>2]=e,!w)break t;Z(w)}i[t+24>>2]=A}if(_=_+1|0,m>>>0<=_>>>0)break n;if(u[r+20|0]&1)break}}A=i[s+36>>2];n:{if(A>>>0<u0[s+40>>2]){e=C[t+16>>1],i[A+12>>2]=0,i[A+4>>2]=0,i[A+8>>2]=0,g[A>>1]=e,i[A+4>>2]=i[t+20>>2],i[A+8>>2]=i[t+24>>2],i[A+12>>2]=i[t+28>>2],i[t+28>>2]=0,i[t+20>>2]=0,i[t+24>>2]=0,A=A+16|0;break n}A=Nn(Q,t+16|0)}i[s+36>>2]=A,n=1}if(k=i[t+20>>2],k){if(A=i[t+24>>2],e=k,(A|0)!=(k|0)){for(;e=A-12|0,w=i[e>>2],w&&(i[A-8>>2]=w,Z(w)),A=e,(k|0)!=(A|0););e=i[t+20>>2]}i[t+24>>2]=k,Z(e)}if(!n)break f;if(X=X+1|0,(B|0)==(X|0))break}}if(e=i[r+16>>2],e&&(A=i[r+8>>2],A&&(c1(A,e),e=i[r+16>>2]),A=i[r>>2],k=W[i[i[A>>2]+8>>2]](A)|0,s=l0,n=e,e=e+k|0,s=n>>>0>e>>>0?s+1|0:s,W[i[i[A>>2]+20>>2]](A,e,s)|0,i[r+16>>2]=0),l[r+20|0]==1){if(u[t+16|0]=0,u[t+27|0]=0,q(f,2,100,t+16|0),u[t+27|0]>=0)break f;Z(i[t+16>>2]);break f}if(A=i[26917],i[f>>2]=i[26916],i[f+4>>2]=A,A=f+8|0,u[107683]>=0){e=i[26919],i[A>>2]=i[26918],i[A+4>>2]=e,i[A+8>>2]=i[26920];break f}T(A,i[26918],i[26919])}v=t+32|0;break i}G0(),H()}z0(),H()}}function _v(A,e,r,f,k,n,t,o){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,t=t|0,o=o|0;var s=0,w=0,h=0,_=0,B=0,m=0,X=0,Q=0,V=0,F=0,I=0,E=0,R=0,N=0,M=0,z=0,S=0;t=v-32|0,v=t;i:{e:{r:{if((j0(i[r>>2],3)|0)!=8||(j0(i[r>>2],4)|0)!=8)break r;if((j0(i[r>>2],5)|0)==8)break e}e=i[26922],i[A>>2]=i[26921],i[A+4>>2]=e,r=A+8|0;r:{if(u[107703]>=0){e=i[26924],i[r>>2]=i[26923],i[r+4>>2]=e,i[r+8>>2]=i[26925];break r}T(r,i[26923],i[26924])}u[A+20|0]=1;break i}_=u1(i[r>>2],6),B=l[k+8|0];e:{if(!_||(j0(i[r>>2],6)|0)==8)break e;e=i[26922],i[A>>2]=i[26921],i[A+4>>2]=e,r=A+8|0;r:{if(u[107703]>=0){e=i[26924],i[r>>2]=i[26923],i[r+4>>2]=e,i[r+8>>2]=i[26925];break r}T(r,i[26923],i[26924])}u[A+20|0]=1;break i}n=p(172),i[n+4>>2]=0,i[n+8>>2]=0,i[n>>2]=94812,o0(n+16|0,0,80),e=i[n+4>>2],k=e+1|0,i[n+4>>2]=k,i[n+104>>2]=0,i[n+108>>2]=0,i[n+36>>2]=1,i[n+40>>2]=1,u[n+24|0]=1,g[n+22>>1]=2,g[n+18>>1]=2,g[n+20>>1]=2,i[n+112>>2]=0,i[n+116>>2]=4740,i[n+140>>2]=0,i[n+144>>2]=0,i[n+128>>2]=99,i[n+132>>2]=99,i[n+120>>2]=0,i[n+124>>2]=0,i[n+12>>2]=95160,i[n+148>>2]=0,i[n+152>>2]=0,f=n+140|0,i[n+136>>2]=f,i[n+156>>2]=0,i[n+160>>2]=0,i[n+164>>2]=0,i[n+168>>2]=0,i[n+4>>2]=e,e=i[n+8>>2],Q=n+12|0,i[n+96>>2]=Q,i[n+8>>2]=e+1,i[n+100>>2]=n,k||(W[i[i[n>>2]+8>>2]](n),y(n)),e=i[r>>2],I=i[e+108>>2],k=I,E=i[e+112>>2],e=E,m=_|B,i[Q+120>>2]=m&1?13:12,i[Q+116>>2]=1,i[Q+112>>2]=e,i[Q+108>>2]=k,T0(t+8|0,Q,10,k,e,j0(i[r>>2],3),o);e:{if(i[t+8>>2]){if(e=i[t+12>>2],i[A>>2]=i[t+8>>2],i[A+4>>2]=e,r=A+8|0,u[t+27|0]>=0){e=i[t+20>>2],i[r>>2]=i[t+16>>2],i[r+4>>2]=e,i[r+8>>2]=i[t+24>>2],u[A+20|0]=1;break e}if(T(r,i[t+16>>2],i[t+20>>2]),e=u[t+27|0],u[A+20|0]=1,(e|0)>=0)break e;Z(i[t+16>>2]);break e}u[t+27|0]<0&&Z(i[t+16>>2]),r=i[r>>2],e=r+128|0;r:{f:{if(k=i[r+128>>2],k){for(o=e,r=k;h=i[r+16>>2]<3,o=h?o:r,r=i[(h?4:0)+r>>2],!!r;);V=0;A:{if((e|0)==(o|0)||(V=0,i[o+16>>2]>3))break A;R=i[o+44>>2],V=i[o+56>>2]}for(o=e,r=k;h=i[r+16>>2]<4,o=h?o:r,r=i[(h?4:0)+r>>2],!!r;);F=0;A:{if((e|0)==(o|0)||(F=0,i[o+16>>2]>4))break A;N=i[o+56>>2],F=i[o+44>>2]}for(o=e,r=k;h=i[r+16>>2]<5,o=h?o:r,r=i[(h?4:0)+r>>2],!!r;);if((e|0)!=(o|0))break f}r=0;break r}if(r=0,i[o+16>>2]>5)break r;M=i[o+56>>2],r=i[o+44>>2]}h=r,r=i[f>>2],w=0;r:{if(!r)break r;for(o=f;X=i[r+16>>2]<10,o=X?o:r,r=i[(X?4:0)+r>>2],!!r;);if((f|0)==(o|0)){w=0;break r}if(w=0,i[o+16>>2]>10)break r;z=i[o+56>>2],w=i[o+44>>2]}f=w,o=0;r:{if(!k|_^1)break r;for(r=e;o=i[k+16>>2]<6,r=o?r:k,k=i[(o?4:0)+k>>2],!!k;);if(o=0,(e|0)==(r|0)||(o=0,i[r+16>>2]>6))break r;S=i[r+44>>2],o=i[r+56>>2]}r=o;r:{if(!E)break r;if(_){if(!I)break r;for(e=0;;){for(s=G(e,r)+S|0,_=G(e,M)+h|0,B=G(e,N)+F|0,m=G(e,V)+R|0,X=f+G(e,z)|0,k=0;w=(k<<3)+X|0,u[w|0]=0,o=l[k+m|0],u[w+2|0]=0,u[w+1|0]=o,o=l[k+B|0],u[w+4|0]=0,u[w+3|0]=o,o=l[k+_|0],u[w+6|0]=0,u[w+5|0]=o,u[w+7|0]=l[k+s|0],k=k+1|0,(I|0)!=(k|0););if(e=e+1|0,(E|0)==(e|0))break}break r}if(!I)break r;if(_=m&1?8:6,e=0,B&1)for(;;){for(B=G(e,M)+h|0,m=G(e,N)+F|0,X=G(e,V)+R|0,o=f+G(e,z)|0,k=0;s=o+G(k,_)|0,u[s|0]=0,r=l[k+X|0],u[s+2|0]=0,u[s+1|0]=r,r=l[k+m|0],u[s+4|0]=0,u[s+3|0]=r,r=l[k+B|0],u[s+6|0]=0,u[s+7|0]=255,u[s+5|0]=r,k=k+1|0,(I|0)!=(k|0););if(e=e+1|0,(E|0)==(e|0))break r}for(;;){for(B=G(e,M)+h|0,m=G(e,N)+F|0,X=G(e,V)+R|0,o=f+G(e,z)|0,r=0;s=o+G(r,_)|0,u[s|0]=0,k=l[r+X|0],u[s+2|0]=0,u[s+1|0]=k,k=l[r+m|0],u[s+4|0]=0,u[s+3|0]=k,u[s+5|0]=l[r+B|0],r=r+1|0,(I|0)!=(r|0););if(e=e+1|0,(E|0)==(e|0))break}}u[A+20|0]=0,i[A+4>>2]=n,i[A>>2]=Q;break i}if(A=i[n+4>>2],i[n+4>>2]=A-1,A)break i;W[i[i[n>>2]+8>>2]](n),y(n)}v=t+32|0}function Vf(){var A=0,e=0,r=0,f=0,k=0,n=0,t=0,o=0,s=0,w=0,h=0,_=0;l[108636]||(u[108636]=1),e=i[27152],i[27152]=e+1;i:{if((e|0)>0||(H7(),j7()))break i;return i[27152]=i[27152]-1,0}A=p(3224),i[A+168>>2]=0,i[A+84>>2]=0,i[A>>2]=61256,i[A+384>>2]=1853,i[A+376>>2]=1854,i[A+360>>2]=1855,i[A+356>>2]=1856,i[A+352>>2]=1857,i[A+348>>2]=1858,i[A+344>>2]=1859,i[A+340>>2]=1860,i[A+336>>2]=1861,i[A+332>>2]=1862,i[A+328>>2]=1863,i[A+324>>2]=1864,i[A+320>>2]=1865,i[A+316>>2]=1866,i[A+312>>2]=1867,i[A+308>>2]=1868,i[A+304>>2]=1869,i[A+300>>2]=1870,i[A+296>>2]=1871,i[A+292>>2]=1871,i[A+288>>2]=1871,i[A+284>>2]=1872,i[A+280>>2]=1873,i[A+276>>2]=1874,i[A+272>>2]=1875,i[A+268>>2]=1876,i[A+264>>2]=1877,i[A+260>>2]=1878,i[A+256>>2]=1879,i[A+252>>2]=1880,i[A+248>>2]=1881,i[A+244>>2]=1882,i[A+240>>2]=1883,i[A+236>>2]=1884,i[A+232>>2]=1885,i[A+228>>2]=1886,i[A+224>>2]=1887,i[A+220>>2]=1888,i[A+216>>2]=1889,i[A+212>>2]=1889,i[A+208>>2]=1889,i[A+204>>2]=1890,i[A+200>>2]=1891,i[A+196>>2]=1892,i[A+192>>2]=1893,i[A+188>>2]=1894,i[A+184>>2]=1895,i[A+180>>2]=1896,i[A+176>>2]=1897,i[A+172>>2]=1898,i[A+372>>2]=1899,i[A+380>>2]=1900,i[A+364>>2]=1901,i[A+368>>2]=1902,i[A+388>>2]=1903,i[A+392>>2]=1904,i[A+396>>2]=1905,i[A+400>>2]=1906,i[A+404>>2]=1907,i[A+408>>2]=1908,i[A+412>>2]=1909,i[A+416>>2]=1910,i[A+420>>2]=1911,i[A+424>>2]=1912,i[A+428>>2]=1913,i[A+432>>2]=1914,i[A+456>>2]=1915,i[A+460>>2]=1916,i[A+468>>2]=1917,i[A+472>>2]=1918,i[A+464>>2]=1919,i[A+508>>2]=1920,i[A+504>>2]=1921,i[A+500>>2]=1922,i[A+496>>2]=1923,i[A+492>>2]=1924,i[A+488>>2]=1925,i[A+484>>2]=1926,i[A+480>>2]=1927,i[A+476>>2]=1928,i[A+452>>2]=1929,i[A+448>>2]=1930,i[A+444>>2]=1931,i[A+440>>2]=1932,i[A+436>>2]=1933,i[A>>2]=61280,i[A+552>>2]=0,i[A+556>>2]=0,g[A+548>>1]=0,i[A+560>>2]=0,i[A+564>>2]=0,i[A+568>>2]=0,i[A+572>>2]=0,i[A+576>>2]=0,i[A+580>>2]=0,i[A+584>>2]=0,i[A+588>>2]=0,i[A+592>>2]=0,i[A+596>>2]=0,e=A+1412|0,i[e>>2]=0,i[e+4>>2]=0,e=A+1404|0,i[e>>2]=0,i[e+4>>2]=0,i[A+1396>>2]=0,i[A+1400>>2]=0,o0(A+600|0,0,792),e=A+2140|0,i[e+8>>2]=0,i[e+12>>2]=0,i[e>>2]=30,i[e+4>>2]=30,i[e+48>>2]=0,i[e+52>>2]=0,i[e+40>>2]=0,i[e+44>>2]=0,i[e+32>>2]=0,i[e+36>>2]=0,i[e+24>>2]=0,i[e+28>>2]=0,i[e+16>>2]=0,i[e+20>>2]=0,i[A+3216>>2]=0,i[A+3208>>2]=0,i[A+3212>>2]=0,g[A+532>>1]=0,u[A+514|0]=0,g[A+512>>1]=256,i[A+516>>2]=-1,i[A+520>>2]=-1,i[A+524>>2]=-1,i[A+528>>2]=-1,e=i[26759],r=i[26758],i[A+1368>>2]=0,i[A+544>>2]=0,i[A+536>>2]=r,i[A+540>>2]=e,e=i[A+1372>>2],i[A+1372>>2]=0;i:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break i;W[i[i[e>>2]+8>>2]](e),y(e)}e=i[A+1380>>2],i[A+1376>>2]=0,i[A+1380>>2]=0;i:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break i;W[i[i[e>>2]+8>>2]](e),y(e)}e=i[A+1388>>2],i[A+1384>>2]=0,i[A+1388>>2]=0;i:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break i;W[i[i[e>>2]+8>>2]](e),y(e)}i[A+1892>>2]=100,i[A+1896>>2]=6,i[A+1884>>2]=0,i[A+1888>>2]=6,i[A+1900>>2]=100,i[A+1904>>2]=6,e=i[A+1376>>2];i:{e:{r:{if(e){e=u[e+2|0];break r}if(r=i[A+1368>>2],e=6,!r)break e;e=i[r+8>>2]}if((e|0)<=0)break i;e=e-1|0}for(_=A+2112|0,s=A+1908|0,w=e+1|0;;){r=G(e,100),n=(r+100|0)/(w|0)|0,f=(r|0)/(w|0)|0;e:{if((n|0)<(f|0)){r=e;break e}t=i[A+1888>>2];r:{if(f+n&1){r=e,e=f;break r}r=(f<<1)+s|0,u[r+1|0]=(e|0)>(t|0)?100:0,k=r,r=(e|0)<(t|0)?e:t,u[k|0]=r,e=f+1|0}if(k=e,(f|0)==(n|0))break e;for(h=n-f|0,e=r;o=(k<<1)+s|0,r=(e|0)<(t|0)?e:t,u[o|0]=r,u[o+1|0]=(e|0)>(t|0)?100:(G(k-f|0,100)|0)/(h|0)|0,o=k+1|0,e=(o<<1)+s|0,u[e+1|0]=(G(o-f|0,100)|0)/(h|0),u[e|0]=r,k=k+2|0,e=r,(n|0)!=(o|0););}if(i[(r<<2)+_>>2]=n,e=r-1|0,!((r|0)>0))break}}return i[A+2200>>2]=0,i[A+2204>>2]=0,i[A+2196>>2]=-1,e=A+2216|0,i[e>>2]=0,i[e+4>>2]=0,e=A+2208|0,i[e>>2]=0,i[e+4>>2]=0,u[A+2200|0]=1,A|0}function Bv(A,e,r,f,k,n,t,o){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,t=t|0,o=o|0;var s=0,w=0,h=0,_=0,B=0,m=0,X=0,Q=0,V=0,F=0,I=0,E=0,R=0,N=0,M=0;s=v-48|0,v=s,t=p(172),i[t+4>>2]=0,i[t+8>>2]=0,i[t>>2]=94812,o0(t+16|0,0,80),f=i[t+4>>2],k=f+1|0,i[t+4>>2]=k,i[t+104>>2]=0,i[t+108>>2]=0,i[t+36>>2]=1,i[t+40>>2]=1,u[t+24|0]=1,g[t+22>>1]=2,g[t+18>>1]=2,g[t+20>>1]=2,i[t+112>>2]=0,i[t+116>>2]=4740,i[t+140>>2]=0,i[t+144>>2]=0,i[t+128>>2]=99,i[t+132>>2]=99,i[t+120>>2]=0,i[t+124>>2]=0,i[t+12>>2]=95160,i[t+148>>2]=0,i[t+152>>2]=0,e=t+140|0,i[t+136>>2]=e,i[t+156>>2]=0,i[t+160>>2]=0,i[t+164>>2]=0,i[t+168>>2]=0,i[t+4>>2]=f,f=i[t+8>>2],Q=t+12|0,i[t+96>>2]=Q,i[t+8>>2]=f+1,i[t+100>>2]=t,k||(W[i[i[t>>2]+8>>2]](t),y(t)),f=i[r>>2],k=i[f+108>>2],n=i[f+112>>2],_=i[f+116>>2],i[Q+120>>2]=i[f+120>>2],i[Q+116>>2]=_,i[Q+112>>2]=n,i[Q+108>>2]=k;i:{e:{for(;;){w=i[R+58364>>2];r:{if(!u1(i[r>>2],w))break r;f:{A:{if(B=j0(i[r>>2],w),B>>>0>=9){if(h=o8(i[r>>2],w),V=l8(i[r>>2],w),T0(s+24|0,Q,w,h,V,8,o),i[s+24>>2]){if(e=i[s+28>>2],i[A>>2]=i[s+24>>2],i[A+4>>2]=e,e=A+8|0,u[s+43|0]>=0){r=i[s+36>>2],i[e>>2]=i[s+32>>2],i[e+4>>2]=r,i[e+8>>2]=i[s+40>>2],u[A+20|0]=1;break e}if(T(e,i[s+32>>2],i[s+36>>2]),e=u[s+43|0],u[A+20|0]=1,(e|0)>=0)break e;Z(i[s+32>>2]);break e}if(u[s+43|0]<0&&Z(i[s+32>>2]),I=0,k=i[r>>2],_=k+128|0,f=_,n=i[k+128>>2],!n)break A;for(;k=(w|0)>i[n+16>>2],f=k?f:n,n=i[(k?4:0)+n>>2],!!n;);if((f|0)==(_|0))break A;if(F=0,_=0,(w|0)<i[f+16>>2])break f;F=i[f+44>>2],_=i[f+56>>2]>>>1|0;break f}k:{n:{if((B|0)!=8){if(h=o8(i[r>>2],w),V=l8(i[r>>2],w),T0(s+24|0,Q,w,h,V,8,o),i[s+24>>2]){if(e=i[s+28>>2],i[A>>2]=i[s+24>>2],i[A+4>>2]=e,e=A+8|0,u[s+43|0]>=0){r=i[s+36>>2],i[e>>2]=i[s+32>>2],i[e+4>>2]=r,i[e+8>>2]=i[s+40>>2],u[A+20|0]=1;break e}if(T(e,i[s+32>>2],i[s+36>>2]),e=u[s+43|0],u[A+20|0]=1,(e|0)>=0)break e;Z(i[s+32>>2]);break e}if(u[s+43|0]<0&&Z(i[s+32>>2]),f=1<<16-B,n=(f&65534)>>>B|0,n)for(;f=f|n,n=n>>>B|0,!!n;);if(I=0,n=i[r>>2],_=n+128|0,k=_,n=i[n+128>>2],!n)break n;for(;B=(w|0)>i[n+16>>2],k=B?k:n,n=i[(B?4:0)+n>>2],!!n;);if((k|0)==(_|0))break n;if(F=0,B=0,(w|0)<i[k+16>>2])break k;F=i[k+44>>2],B=i[k+56>>2];break k}if(f6(s+4|0,Q,r,w,w,o),u[s+23|0]>=0)break r;Z(i[s+12>>2]);break r}F=0,B=0}k=e,n=i[k>>2],_=0;k:{if(!n)break k;for(;_=(w|0)>i[n+16>>2],k=_?k:n,n=i[(_?4:0)+n>>2],!!n;);if((e|0)==(k|0)){_=0;break k}if(_=0,(w|0)<i[k+16>>2])break k;I=i[k+56>>2],_=i[k+44>>2]}if(!V|!h)break r;for(N=h&-4,E=h&3,w=0,M=h-1>>>0<3;;){if(h=_+G(w,I)|0,X=G(w,B)+F|0,n=0,k=0,!M)for(;u[n+h|0]=G(l[n+X|0],f)>>>8,m=n|1,u[m+h|0]=G(l[X+m|0],f)>>>8,m=n|2,u[m+h|0]=G(l[X+m|0],f)>>>8,m=n|3,u[m+h|0]=G(l[X+m|0],f)>>>8,n=n+4|0,k=k+4|0,(N|0)!=(k|0););if(k=0,E)for(;u[n+h|0]=G(l[n+X|0],f)>>>8,n=n+1|0,k=k+1|0,(E|0)!=(k|0););if(w=w+1|0,(V|0)==(w|0))break}break r}F=0,_=0}f=e,n=i[f>>2],k=0;f:{if(!n)break f;for(;k=(w|0)>i[n+16>>2],f=k?f:n,n=i[(k?4:0)+n>>2],!!n;);if((e|0)==(f|0)){k=0;break f}if(k=0,(w|0)<i[f+16>>2])break f;I=i[f+56>>2],k=i[f+44>>2]}if(!V|!h)break r;for(f=k,B=B-8|0,N=h&-4,E=h&3,w=0,M=h-1>>>0<3;;){if(h=f+G(w,I)|0,X=(G(w,_)<<1)+F|0,n=0,k=0,!M)for(;u[n+h|0]=C[X+(n<<1)>>1]>>>B,m=n|1,u[m+h|0]=C[X+(m<<1)>>1]>>>B,m=n|2,u[m+h|0]=C[X+(m<<1)>>1]>>>B,m=n|3,u[m+h|0]=C[X+(m<<1)>>1]>>>B,n=n+4|0,k=k+4|0,(N|0)!=(k|0););if(k=0,E)for(;u[n+h|0]=C[X+(n<<1)>>1]>>>B,n=n+1|0,k=k+1|0,(E|0)!=(k|0););if(w=w+1|0,(V|0)==(w|0))break}}if(R=R+4|0,(R|0)==28)break}u[A+20|0]=0,i[A+4>>2]=t,i[A>>2]=Q;break i}if(A=i[t+4>>2],i[t+4>>2]=A-1,A)break i;W[i[i[t>>2]+8>>2]](t),y(t)}v=s+48|0}function vv(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,t=0,o=0,s=0,w=0,h=0,_=0,B=0,m=0;n=v-160|0,v=n,i[n+104>>2]=0,i[n+76>>2]=72196,i[n+20>>2]=72176,t=i[18053],i[n+12>>2]=t,w=n+12|0,i[w+i[t-12>>2]>>2]=i[18054],i[n+16>>2]=0,t=w+i[i[n+12>>2]-12>>2]|0,k=n+24|0,J0(t,k),u[t+80|0]=0,i[t+72>>2]=0,t=i[18055],i[n+20>>2]=t,_=n+20|0,i[_+i[t-12>>2]>>2]=i[18056],t=i[18052],i[n+12>>2]=t,i[w+i[t-12>>2]>>2]=i[18057],i[n+76>>2]=72196,i[n+12>>2]=72156,i[n+20>>2]=72176,B=R0(k),i[B>>2]=71232,t=n- -64|0,i[t>>2]=0,i[t+4>>2]=0,i[n+56>>2]=0,i[n+60>>2]=0,i[n+72>>2]=24,Y2(n,e,r),k=u[n+11|0],t=(k|0)<0,Y(_,t?i[n>>2]:n,t?i[n+4>>2]:k),u[n+11|0]<0&&Z(i[n>>2]),t=n,h=e+100|0,f=v-160|0,v=f,i[f+92>>2]=0,i[f+64>>2]=72196,i[f+8>>2]=72176,k=i[18053],i[f>>2]=k,i[i[k-12>>2]+f>>2]=i[18054],i[f+4>>2]=0,k=i[i[f>>2]-12>>2]+f|0,w=f+12|0,J0(k,w),u[k+80|0]=0,i[k+72>>2]=0,k=i[18055],i[f+8>>2]=k,o=f+8|0,i[o+i[k-12>>2]>>2]=i[18056],k=i[18052],i[f>>2]=k,i[i[k-12>>2]+f>>2]=i[18057],i[f+64>>2]=72196,i[f>>2]=72156,i[f+8>>2]=72176,m=R0(w),i[m>>2]=71232,i[f+52>>2]=0,i[f+56>>2]=0,i[f+44>>2]=0,i[f+48>>2]=0,i[f+60>>2]=24,w=r,k=f+148|0,s0(k,r),s=k,k=u[f+159|0],r=(k|0)<0,Y(o,r?i[f+148>>2]:s,r?i[f+152>>2]:k),u[f+159|0]<0&&Z(i[f+148>>2]),o=Y(V0(Y(o,29510,22),C[h>>1]),42670,1),r=f+148|0,s0(r,w),s=r,k=u[f+159|0],r=(k|0)<0,Y(o,r?i[f+148>>2]:s,r?i[f+152>>2]:k),u[f+159|0]<0&&Z(i[f+148>>2]),o=Y(V0(Y(o,31016,7),C[h+16>>1]),42670,1),r=f+148|0,s0(r,w),s=r,k=u[f+159|0],r=(k|0)<0,Y(o,r?i[f+148>>2]:s,r?i[f+152>>2]:k),u[f+159|0]<0&&Z(i[f+148>>2]),o=Y(V0(Y(o,29701,8),C[h+18>>1]),42670,1),r=f+148|0,s0(r,w),s=r,k=u[f+159|0],r=(k|0)<0,Y(o,r?i[f+148>>2]:s,r?i[f+152>>2]:k),u[f+159|0]<0&&Z(i[f+148>>2]),o=Y(d1(Y(o,30495,19),+u0[h+20>>2]*152587890625e-16),42670,1),r=f+148|0,s0(r,w),s=r,k=u[f+159|0],r=(k|0)<0,Y(o,r?i[f+148>>2]:s,r?i[f+152>>2]:k),u[f+159|0]<0&&Z(i[f+148>>2]),o=Y(d1(Y(o,30515,18),+u0[h+24>>2]*152587890625e-16),42670,1),r=f+148|0,s0(r,w),s=r,k=u[f+159|0],r=(k|0)<0,Y(o,r?i[f+148>>2]:s,r?i[f+152>>2]:k),u[f+159|0]<0&&Z(i[f+148>>2]),o=Y(V0(Y(o,29614,13),C[h+28>>1]),42670,1),r=f+148|0,s0(r,w),s=r,k=u[f+159|0],r=(k|0)<0,Y(o,r?i[f+148>>2]:s,r?i[f+152>>2]:k),u[f+159|0]<0&&Z(i[f+148>>2]),s=Y(o,31832,16),k=u[h+43|0],r=(k|0)<0,o=Y(Y(s,r?i[h+32>>2]:h+32|0,r?i[h+36>>2]:k),42670,1),r=f+148|0,s0(r,w),s=r,k=u[f+159|0],r=(k|0)<0,Y(o,r?i[f+148>>2]:s,r?i[f+152>>2]:k),u[f+159|0]<0&&Z(i[f+148>>2]),Y(V0(Y(o,30970,7),C[h+44>>1]),42670,1),r=i[f+60>>2];i:{e:{if(r&16){r=i[f+56>>2],k=i[f+36>>2],r>>>0<k>>>0&&(i[f+56>>2]=k,r=k),k=f+32|0;break e}if(!(r&8)){r=0,u[t+11|0]=0;break i}r=i[f+28>>2],k=f+20|0}e:{if(h=i[k>>2],r=r-h|0,r>>>0<2147483640){if(r>>>0>=11){o=r|7,k=p(o+1|0),i[t+8>>2]=o-2147483647,i[t>>2]=k,i[t+4>>2]=r,t=k;break e}if(u[t+11|0]=r,r)break e;r=0;break i}Q0(),H()}if(!r)break i;x(t,h,r)}u[r+t|0]=0,r=i[18051],i[f>>2]=r,i[i[r-12>>2]+f>>2]=i[18059],i[f+8>>2]=i[18060],i[m>>2]=71232,u[f+55|0]<0&&Z(i[f+44>>2]),E0(m),y0(f- -64|0),v=f+160|0,t=u[n+11|0],r=(t|0)<0,Y(_,r?i[n>>2]:n,r?i[n+4>>2]:t),u[n+11|0]<0&&Z(i[n>>2]),mr(n,e,w,0),r=u[n+11|0],e=(r|0)<0,Y(_,e?i[n>>2]:n,e?i[n+4>>2]:r),u[n+11|0]<0&&Z(i[n>>2]),e=i[n+72>>2];i:{e:{if(e&16){e=i[n+68>>2],r=i[n+48>>2],e>>>0<r>>>0&&(i[n+68>>2]=r,e=r),r=n+44|0;break e}if(!(e&8)){e=0,u[A+11|0]=0;break i}e=i[n+40>>2],r=n+32|0}e:{if(k=i[r>>2],e=e-k|0,e>>>0<2147483640){if(e>>>0>=11){t=e|7,r=p(t+1|0),i[A+8>>2]=t-2147483647,i[A>>2]=r,i[A+4>>2]=e,A=r;break e}if(u[A+11|0]=e,e)break e;e=0;break i}Q0(),H()}if(!e)break i;x(A,k,e)}u[A+e|0]=0,A=i[18051],i[n+12>>2]=A,i[i[A-12>>2]+(n+12|0)>>2]=i[18059],i[n+20>>2]=i[18060],i[B>>2]=71232,u[n+67|0]<0&&Z(i[n+56>>2]),E0(B),y0(n+76|0),v=n+160|0}function mv(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,t=0,o=0,s=0,w=0,h=0,_=0,B=0,m=0,X=0,Q=0,V=0,F=0,I=0;f=v-160|0,v=f,i[f+84>>2]=0,i[f+56>>2]=72500,n=i[18128],i[f>>2]=n,i[i[n-12>>2]+f>>2]=i[18129],n=i[i[f>>2]-12>>2]+f|0,k=f+4|0,J0(n,k),u[n+80|0]=0,i[n+72>>2]=0,i[f+56>>2]=72500,i[f>>2]=72480,B=R0(k),i[B>>2]=71232,i[f+44>>2]=0,i[f+48>>2]=0,i[f+36>>2]=0,i[f+40>>2]=0,i[f+52>>2]=16,n=f+148|0,U1(n,e,r),t=n,n=u[f+159|0],k=(n|0)<0,Y(f,k?i[f+148>>2]:t,k?i[f+152>>2]:n),u[f+159|0]<0&&Z(i[f+148>>2]),n=f+148|0,s0(n,r),t=n,n=u[f+159|0],k=(n|0)<0,Y(f,k?i[f+148>>2]:t,k?i[f+152>>2]:n),u[f+159|0]<0&&Z(i[f+148>>2]),n=Y(q2(Y(f,32777,19),i[e+104>>2],i[e+108>>2]),42670,1),k=f+148|0,s0(k,r),t=k,k=u[f+159|0],o=(k|0)<0,Y(n,o?i[f+148>>2]:t,o?i[f+152>>2]:k),u[f+159|0]<0&&Z(i[f+148>>2]),n=Y(q2(Y(n,31799,19),i[e+112>>2],i[e+116>>2]),42670,1),k=f+148|0,s0(k,r),t=k,k=u[f+159|0],o=(k|0)<0,Y(n,o?i[f+148>>2]:t,o?i[f+152>>2]:k),u[f+159|0]<0&&Z(i[f+148>>2]),n=Y(V0(Y(n,31914,11),i[e+120>>2]),42670,1),k=f+148|0,s0(k,r),t=k,k=u[f+159|0],o=(k|0)<0,Y(n,o?i[f+148>>2]:t,o?i[f+152>>2]:k),u[f+159|0]<0&&Z(i[f+148>>2]),Y(q2(Y(n,30633,10),i[e+128>>2],i[e+132>>2]),42670,1),n=f+148|0,s0(n,r),t=n,n=u[f+159|0],k=(n|0)<0,Y(f,k?i[f+148>>2]:t,k?i[f+152>>2]:n),u[f+159|0]<0&&Z(i[f+148>>2]),n=Y(d1(Y(f,31492,6),+u0[e+136>>2]*152587890625e-16),42670,1),k=f+148|0,s0(k,r),t=k,k=u[f+159|0],o=(k|0)<0,Y(n,o?i[f+148>>2]:t,o?i[f+152>>2]:k),u[f+159|0]<0&&Z(i[f+148>>2]),n=Y(Zu(Y(n,31777,8),U(U(C[e+140>>1])*U(.00390625))),42670,1),k=f+148|0,s0(k,r),t=k,k=u[f+159|0],o=(k|0)<0,Y(n,o?i[f+148>>2]:t,o?i[f+152>>2]:k),u[f+159|0]<0&&Z(i[f+148>>2]),Y(n,41757,8),F=e+144|0;i:{for(;;){n=f+148|0,s0(n,r),t=n,n=u[f+159|0],k=(n|0)<0,Y(f,k?i[f+148>>2]:t,k?i[f+152>>2]:n),u[f+159|0]<0&&Z(i[f+148>>2]),Y(f,32807,2),I=G(m,3),n=0;e:{for(;;){k=f+140|0,o=n+I|0,(o|0)!=8?X=+u0[(o<<2)+F>>2]*152587890625e-16:X=1,h=d1(f,X),Q=G1(k,h);r:{if(l[Q|0]!=1)break r;o=i[i[h>>2]-12>>2]+h|0,_=i[o+4>>2],w=i[o+24>>2];f:{if(l[o+80|0]==1){k=l[o+76|0]|l[o+77|0]<<8|(l[o+78|0]<<16|l[o+79|0]<<24);break f}t=f+148|0,k=i[o+28>>2],i[t>>2]=k,(k|0)!=129576&&(i[k+4>>2]=i[k+4>>2]+1),k=c0(t,129760),k=W[i[i[k>>2]+28>>2]](k,32)|0,e2(t),u[o+76|0]=k,u[o+77|0]=k>>>8,u[o+78|0]=k>>>16,u[o+79|0]=k>>>24,u[o+80|0]=1}f:{if(!w||(s=i[o+12>>2],_=(_&176)==32?32809:32808,t=_-32808|0,(t|0)>0&&(W[i[i[w>>2]+48>>2]](w,32808,t)|0)!=(t|0)))break f;if((s|0)>=2){if(s>>>0>=2147483641)break e;t=((s|0)<=1?1:s)-1|0;A:{if(s>>>0>=12){V=t|7,s=p(V+1|0),i[f+156>>2]=V-2147483647,i[f+148>>2]=s,i[f+152>>2]=t;break A}u[f+159|0]=t,s=f+148|0}if(t&&o0(s,k,t),u[t+s|0]=0,k=W[i[i[w>>2]+48>>2]](w,u[f+159|0]<0?i[f+148>>2]:f+148|0,t)|0,u[f+159|0]<0&&Z(i[f+148>>2]),(k|0)!=(t|0))break f}if(k=32809-_|0,(k|0)>0&&(W[i[i[w>>2]+48>>2]](w,_,k)|0)!=(k|0))break f;i[o+12>>2]=0;break r}k=i[i[h>>2]-12>>2]+h|0,H1(k,i[k+16>>2]|5)}if(_1(Q),n=n+1|0,(n|0)==3)break}if(Y(f,42670,1),m=m+1|0,(m|0)==3)break i;continue}break}Q0(),H()}n=f+148|0,s0(n,r),k=n,r=u[f+159|0],n=(r|0)<0,Y(f,n?i[f+148>>2]:k,n?i[f+152>>2]:r),u[f+159|0]<0&&Z(i[f+148>>2]),Y(V0(Y(f,32515,15),i[e+180>>2]),42670,1),e=i[f+52>>2];i:{e:{if(e&16){n=i[f+48>>2],e=i[f+28>>2],n>>>0<e>>>0&&(i[f+48>>2]=e,n=e),e=f+24|0;break e}if(!(e&8)){n=0,u[A+11|0]=0;break i}n=i[f+20>>2],e=f+12|0}e:{if(r=i[e>>2],n=n-r|0,n>>>0<2147483640){if(n>>>0>=11){k=n|7,e=p(k+1|0),i[A+8>>2]=k-2147483647,i[A>>2]=e,i[A+4>>2]=n,A=e;break e}if(u[A+11|0]=n,n)break e;n=0;break i}Q0(),H()}if(!n)break i;x(A,r,n)}u[A+n|0]=0,A=i[18127],i[f>>2]=A,i[i[A-12>>2]+f>>2]=i[18130],i[B>>2]=71232,u[f+47|0]<0&&Z(i[f+36>>2]),E0(B),y0(f+56|0),v=f+160|0}function n9(A){var e=0;i:{e:{r:{f:{A:{k:{n:{t:{u:{o:{l:{s:{w:{_:{h:{B:{v:{Z:{G:{m:{X:{W:{F:{V:{C:{g:{I:{y:{U:{D:{M:{J:{p:{E:{$:{Y:{H:{z:{x:{T:{R:{S:{j:{O:{P:{L:{K:{q:{_0:{d:{v0:{c:{b:{i0:{e0:{r0:{f0:{A0:{k0:{n0:{t0:{m0:{u0:{o0:{l0:{s0:{w0:{N:{a:{h0:{Z0:{Q:{G0:{X0:{W0:{Q0:{g0:{V0:{F0:{I0:{if((A|0)<=1999){e=17211;B0:switch(A|0){case 0:break e;case 1:case 2:case 3:case 4:case 5:case 6:case 7:case 8:case 9:case 10:case 11:case 12:case 13:case 14:case 15:case 16:case 17:case 18:case 19:case 20:case 21:case 22:case 23:case 24:case 25:case 26:case 27:case 28:case 29:case 30:case 31:case 32:case 33:case 34:case 35:case 36:case 37:case 38:case 39:case 40:case 41:case 42:case 43:case 44:case 45:case 46:case 47:case 48:case 49:case 50:case 51:case 52:case 53:case 54:case 55:case 56:case 57:case 58:case 59:case 60:case 61:case 62:case 63:case 64:case 65:case 66:case 67:case 68:case 69:case 70:case 71:case 72:case 73:case 74:case 75:case 76:case 77:case 78:case 79:case 80:case 81:case 82:case 83:case 84:case 85:case 86:case 87:case 88:case 89:case 90:case 91:case 92:case 93:case 94:case 95:case 96:case 97:case 98:case 99:case 144:case 145:case 146:case 147:case 148:break r;case 108:break w0;case 109:break s0;case 110:break l0;case 111:break o0;case 112:break u0;case 113:break m0;case 114:break n0;case 115:break k0;case 116:break A0;case 117:break f0;case 100:break I0;case 118:break V0;case 119:break g0;case 120:break r0;case 121:break e0;case 122:break i0;case 123:break b;case 124:break c;case 125:break t0;case 126:break v0;case 127:break d;case 101:break F0;case 128:break _0;case 129:break q;case 130:break K;case 131:break h0;case 132:break L;case 133:break P;case 134:break O;case 135:break j;case 136:break S;case 137:break R;case 102:break Q0;case 138:break T;case 139:break x;case 140:break z;case 141:break Z0;case 142:break $;case 143:break a;case 149:break E;case 150:break H;case 151:break Y;case 103:break W0;case 104:break X0;case 105:break G0;case 106:break Q;case 107:break N;default:break B0}switch(A-1e3|0){case 0:break p;case 1:break J;default:break r}}if((A|0)<=3999){B0:switch(A-2e3|0){case 0:break M;case 1:break D;case 2:break U;case 3:break y;case 4:break I;case 5:break g;case 6:break C;case 7:break V;case 8:break F;default:break B0}switch(A-3e3|0){case 0:break W;case 1:break X;case 2:break m;case 3:break G;case 4:break Z;case 5:break v;case 6:break B;case 7:break h;case 8:break _;default:break r}}B0:switch(A-5e3|0){case 0:break w;case 1:break s;case 2:break l;case 3:break o;case 4:break u;default:break B0}switch(A-6e3|0){case 0:break t;case 1:break n;case 2:break k;case 3:break A;default:break f}}return 13323}return 11481}return 18900}return 5737}return 2615}return 2573}return 2761}return 2587}return 2803}return 2789}return 2831}return 2817}return 2657}return 2643}return 2775}return 2747}return 2705}return 2629}return 2719}return 2733}return 7127}return 1341}return 9556}return 18809}return 8533}return 18682}return 19089}return 17161}return 9529}return 12758}return 4347}return 7569}return 11641}return 2416}return 10737}return 5556}return 6020}return 4585}return 18826}return 1438}return 16952}return 16918}return 9780}return 8447}return 2559}return 2601}return 2671}return 17261}return 6756}return 17789}return 15922}return 17611}return 16078}return 16028}return 6983}return 11976}return 1387}return 13588}return 18133}return 12785}return 8807}return 8613}return 15717}return 15754}return 15792}return 1271}return 12735}return 18703}return 9703}return 9726}return 9687}return 24479}return 17489}return 17444}return 4953}return 9253}if((A|0)==4e3)break i}e=i[23572]}return e}return 10715}function kr(A,e,r,f,k,n,t,o,s){var w=0,h=0,_=0;w=v-160|0,v=w;i:{if(!(f&&r)){if(e=p(24),i[w+12>>2]=e,i[w+16>>2]=18,i[w+20>>2]=-2147483624,r=l[11645]|l[11646]<<8|(l[11647]<<16|l[11648]<<24),f=l[11641]|l[11642]<<8|(l[11643]<<16|l[11644]<<24),u[e|0]=f,u[e+1|0]=f>>>8,u[e+2|0]=f>>>16,u[e+3|0]=f>>>24,u[e+4|0]=r,u[e+5|0]=r>>>8,u[e+6|0]=r>>>16,u[e+7|0]=r>>>24,u[e+18|0]=0,r=l[11657]|l[11658]<<8,u[e+16|0]=r,u[e+17|0]=r>>>8,r=l[11653]|l[11654]<<8|(l[11655]<<16|l[11656]<<24),f=l[11649]|l[11650]<<8|(l[11651]<<16|l[11652]<<24),u[e+8|0]=f,u[e+9|0]=f>>>8,u[e+10|0]=f>>>16,u[e+11|0]=f>>>24,u[e+12|0]=r,u[e+13|0]=r>>>8,u[e+14|0]=r>>>16,u[e+15|0]=r>>>24,q(A,5,0,w+12|0),u[w+23|0]>=0)break i;Z(i[w+12>>2]);break i}i[e+12>>2]=f,i[e+8>>2]=r,u[e+5|0]=t,u[e+4|0]=n,i[e>>2]=k,k=f+1|0,_=(k>>>0<=64?64:k)&-2,i[e+20>>2]=_,k=r+1|0,k=(k>>>0<=64?64:k)&-2,i[e+16>>2]=k,n=n&255,h=1;e:{if(n>>>0<9||(h=2,n>>>0<17)||(h=4,n>>>0<33))break e;h=n>>>0<65?8:16}n=G(h,G(k,t))+15&-16,i[e+36>>2]=n;e:{r:{f:{A:{k:{n:{if(!o||(k=i[o+8>>2],t=i[o+12>>2],!(k|t))||(k=d8(k,t,f,0),t=l0,!t&r>>>0<=k>>>0|t))break n;i[w+104>>2]=0,i[w+76>>2]=72196,i[w+20>>2]=72176,e=i[18053],i[w+12>>2]=e,n=i[e-12>>2],k=w+12|0,e=k,i[n+e>>2]=i[18054],i[w+16>>2]=0,e=e+i[i[w+12>>2]-12>>2]|0,n=w+24|0,J0(e,n),u[e+80|0]=0,i[e+72>>2]=0,e=i[18055],i[w+20>>2]=e,t=i[e-12>>2],e=w+20|0,i[t+e>>2]=i[18056],t=i[18052],i[w+12>>2]=t,i[k+i[t-12>>2]>>2]=i[18057],i[w+76>>2]=72196,i[w+12>>2]=72156,i[w+20>>2]=72176,k=R0(n),i[k>>2]=71232,n=w- -64|0,i[n>>2]=0,i[n+4>>2]=0,i[w+56>>2]=0,i[w+60>>2]=0,i[w+72>>2]=24,Y(q2(Y(V0(Y(V0(Y(e,28711,28),r),2998,1),f),28559,31),i[o+8>>2],i[o+12>>2]),5088,7),e=i[w+72>>2];t:{if(e&16){e=i[w+68>>2],r=i[w+48>>2],e>>>0<r>>>0&&(i[w+68>>2]=r,e=r),r=w+44|0;break t}if(!(e&8)){e=0,u[w+11|0]=0,r=w;break e}e=i[w+40>>2],r=w+32|0}if(f=i[r>>2],e=e-f|0,e>>>0>=2147483640)break k;if(e>>>0>=11){n=e|7,r=p(n+1|0),i[w+8>>2]=n-2147483647,i[w>>2]=r,i[w+4>>2]=e;break r}if(u[w+11|0]=e,r=w,e)break r;e=0;break e}if(r=G(n,_)|15,i[e+32>>2]=r,q4(A,s,r,o,18889),i[A>>2])break i;if(u[A+19|0]<0&&Z(i[A+8>>2]),r=sl(i[e+32>>2]),i[e+28>>2]=r,!r){i[w+104>>2]=0,i[w+76>>2]=72196,i[w+20>>2]=72176,r=i[18053],i[w+12>>2]=r,k=i[r-12>>2],f=w+12|0,r=f,i[k+r>>2]=i[18054],i[w+16>>2]=0,r=r+i[i[w+12>>2]-12>>2]|0,k=w+24|0,J0(r,k),u[r+80|0]=0,i[r+72>>2]=0,r=i[18055],i[w+20>>2]=r,n=i[r-12>>2],r=w+20|0,i[n+r>>2]=i[18056],n=i[18052],i[w+12>>2]=n,i[f+i[n-12>>2]>>2]=i[18057],i[w+76>>2]=72196,i[w+12>>2]=72156,i[w+20>>2]=72176,k=R0(k),i[k>>2]=71232,f=w- -64|0,i[f>>2]=0,i[f+4>>2]=0,i[w+56>>2]=0,i[w+60>>2]=0,i[w+72>>2]=24,Y(V0(Y(r,28376,11),i[e+32>>2]),17030,13),e=i[w+72>>2];n:{if(e&16){f=w+44|0,r=i[w+68>>2],e=i[w+48>>2],r>>>0<e>>>0?i[w+68>>2]=e:e=r;break n}if(!(e&8)){e=0,u[w+11|0]=0,f=w;break f}f=w+32|0,e=i[w+40>>2]}if(r=i[f>>2],e=e-r|0,e>>>0>=2147483640)break k;if(e>>>0>=11){n=e|7,f=p(n+1|0),i[w+8>>2]=n-2147483647,i[w>>2]=f,i[w+4>>2]=e;break A}if(u[w+11|0]=e,f=w,e)break A;e=0;break f}if(f=e,e=r&15,i[f+24>>2]=r+(e?16-e|0:0),e=i[26917],i[A>>2]=i[26916],i[A+4>>2]=e,A=A+8|0,u[107683]>=0){e=i[26919],i[A>>2]=i[26918],i[A+4>>2]=e,i[A+8>>2]=i[26920];break i}T(A,i[26918],i[26919]);break i}Q0(),H()}if(!e)break f;x(f,r,e)}u[e+f|0]=0,q(A,6,0,w),u[w+11|0]<0&&Z(i[w>>2]),A=i[18051],i[w+12>>2]=A,i[i[A-12>>2]+(w+12|0)>>2]=i[18059],i[w+20>>2]=i[18060],i[k>>2]=71232,u[w+67|0]<0&&Z(i[w+56>>2]),E0(k),y0(w+76|0);break i}if(!e)break e;x(r,f,e)}u[e+r|0]=0,q(A,6,1e3,w),u[w+11|0]<0&&Z(i[w>>2]),A=i[18051],i[w+12>>2]=A,i[i[A-12>>2]+(w+12|0)>>2]=i[18059],i[w+20>>2]=i[18060],i[k>>2]=71232,u[w+67|0]<0&&Z(i[w+56>>2]),E0(k),y0(w+76|0)}v=w+160|0}function t9(A,e){var r=0,f=0,k=0,n=0,t=0,o=0,s=0,w=0,h=0,_=0,B=0,m=0,X=0,Q=0,V=0,F=0,I=0,E=0,R=0,N=0,M=0,z=0,S=0,O=0,P=0,a=0,$=0,f0=0,A0=0;if(k=i[A+124>>2],_=i[k+16876>>2],r=i[k+16872>>2],m=e<<_>>r,B=i[k+16896>>2],e=e+1<<_>>r,I=(e|0)>(B|0)?B:e,(m|0)>=(I|0))return 0;i:{e:{if(i[k+16888>>2]>0)for(E=-1<<_^-1,R=i[k+16892>>2],N=i[k+16880>>2],Q=i[A+132>>2];;){if(i[k+16888>>2]>0)for(e=0,w=G(m,N),$=(w|0)!=0&!(w&E),B=w?32:0,M=G(w>>_,R),z=w-1|0,f0=G(z>>_,R)<<2;;){r=(i[A+160>>2]+G(e,3)|0)+G(G(i[A+172>>2],m),3)|0,o=(l[r|0]|l[r+1|0]<<8)&7;r:{if(!o)break r;if(n=G(e,N),s=i[A+148>>2],r=n>>s,(r|0)<0||(h=i[A+152>>2],(h|0)<=(r|0)))break e;if(f=w>>s,(f|0)<0||(S=i[A+156>>2],(f|0)>=(S|0)))break i;if(V=i[A+52>>2],F=i[A+56>>2]-V>>2,X=i[A+140>>2],O=X+G(r,24)|0,P=G(G(f,h),24),r=C[(O+P|0)+2>>1],F>>>0<=r>>>0)return 0;a=n>>_,t=i[V+(r<<2)>>2],f=n?16:0,r=f;f:{if(!n||(r=f,n&E))break f;A:{if(l[t+772|0])break A;if(r=n-1>>s,(r|0)<0|r>>>0>=h>>>0)break e;if(X=C[((G(r,24)+X|0)+P|0)+2>>1],X>>>0>=F>>>0)break A;if(r=0,i[t+808>>2]!=i[i[V+(X<<2)>>2]+808>>2])break f}if(r=f,l[Q+57|0])break f;f=M<<2,r=i[Q+8484>>2],r=i[f+(r+(a<<2)|0)>>2]==i[f+(r+(n-1>>_<<2)|0)>>2]?16:0}f=r,r=B;f:{if(!$)break f;A:{if(l[t+772|0])break A;if(r=z>>s,(r|0)<0|(r|0)>=(S|0))break i;if(s=C[(G(G(r,h),24)+O|0)+2>>1],s>>>0>=F>>>0)break A;if(r=0,i[t+808>>2]!=i[i[V+(s<<2)>>2]+808>>2])break f}if(r=B,l[Q+57|0])break f;r=i[Q+8484>>2]+(a<<2)|0,r=i[r+(M<<2)>>2]==i[r+f0>>2]?32:0}if(l[t+762|0])break r;if(I6(A,n,w,o,0,f,r),r=i[A+168>>2],t=n>>r,(t|0)<0||(h=i[A+172>>2],(h|0)<=(t|0)))break e;if(s=w>>r,(s|0)<0|(s|0)>=i[A+176>>2])break i;r=1<<o,k=1<<o-2,f=1<<o-1;f:{A:{k:{n:{t:{u:{o:{l:switch(t=(i[A+160>>2]+G(t,3)|0)+G(G(s,h),3)|0,((l[t|0]|l[t+1|0]<<8)>>>3&7)-1|0){case 3:break o;case 4:break l;case 5:break t;case 6:break u;case 0:break n;case 1:break k;case 2:break A;default:break f}for(t=(r|0)<=1?1:r,f=(k+(f+w|0)|0)/4|0,r=0;k=(r+n|0)/4|0,o=i[A+272>>2],(k|0)>=(o|0)|(f|0)>=i[A+276>>2]||(k=(k+i[A+260>>2]|0)+G(f,o)|0,u[k|0]=l[k|0]|128),r=r+1|0,(t|0)!=(r|0););break f}for(t=(r|0)<=1?1:r,f=(k+w|0)/4|0,r=0;k=(r+n|0)/4|0,o=i[A+272>>2],(k|0)>=(o|0)|(f|0)>=i[A+276>>2]||(k=(k+i[A+260>>2]|0)+G(f,o)|0,u[k|0]=l[k|0]|128),r=r+1|0,(t|0)!=(r|0););break f}for(t=(r|0)<=1?1:r,f=(k+(f+n|0)|0)/4|0,r=0;k=i[A+272>>2],n=(r+w|0)/4|0,(k|0)<=(f|0)|(n|0)>=i[A+276>>2]||(n=(f+i[A+260>>2]|0)+G(k,n)|0,u[n|0]=l[n|0]|64),r=r+1|0,(t|0)!=(r|0););break f}for(t=(r|0)<=1?1:r,f=(k+n|0)/4|0,r=0;k=i[A+272>>2],n=(r+w|0)/4|0,(k|0)<=(f|0)|(n|0)>=i[A+276>>2]||(n=(f+i[A+260>>2]|0)+G(k,n)|0,u[n|0]=l[n|0]|64),r=r+1|0,(t|0)!=(r|0););break f}for(k=(r|0)<=1?1:r,f=(f+w|0)/4|0,r=0;t=(r+n|0)/4|0,o=i[A+272>>2],(t|0)>=(o|0)|(f|0)>=i[A+276>>2]||(t=(t+i[A+260>>2]|0)+G(f,o)|0,u[t|0]=l[t|0]|128),r=r+1|0,(k|0)!=(r|0););break f}for(k=(r|0)<=1?1:r,f=(f+n|0)/4|0,r=0;t=i[A+272>>2],n=(r+w|0)/4|0,(t|0)<=(f|0)|(n|0)>=i[A+276>>2]||(n=(f+i[A+260>>2]|0)+G(n,t)|0,u[n|0]=l[n|0]|64),r=r+1|0,(k|0)!=(r|0););break f}for(h=(r|0)<=1?1:r,t=(f+w|0)/4|0,o=(f+n|0)/4|0,r=0;f=i[A+276>>2],s=(r+w|0)/4|0,k=i[A+272>>2],(f|0)<=(s|0)|(o|0)>=(k|0)||(f=(o+i[A+260>>2]|0)+G(k,s)|0,u[f|0]=l[f|0]|64,k=i[A+272>>2],f=i[A+276>>2]),s=(r+n|0)/4|0,(f|0)<=(t|0)|(s|0)>=(k|0)||(f=(s+i[A+260>>2]|0)+G(k,t)|0,u[f|0]=l[f|0]|128),r=r+1|0,(h|0)!=(r|0););}k=i[A+124>>2],A0=1}if(e=e+1|0,!((e|0)<i[k+16888>>2]))break}if(m=m+1|0,(I|0)==(m|0))break}return A0}D0(4656,10893,118,4231),H()}D0(4618,10893,119,4231),H()}function Zv(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0;var k=0,n=0,t=0,o=0,s=0,w=0,h=0,_=0,B=0,m=0,X=0;k=v-112|0,v=k,W[i[i[e>>2]+32>>2]](k+80|0,e,1,r,0,f);i:{e:{if(i[k+80>>2]){e=i[k+84>>2],i[A>>2]=i[k+80>>2],i[A+4>>2]=e,r=A+8|0;r:{if(u[k+99|0]>=0){e=i[k+92>>2],i[r>>2]=i[k+88>>2],i[r+4>>2]=e,i[r+8>>2]=i[k+96>>2];break r}T(r,i[k+88>>2],i[k+92>>2])}u[A+20|0]=1;break e}for(W[i[i[e>>2]+36>>2]](k+60|0,e),u[k+79|0]<0&&Z(i[k+68>>2]),h=k+44|0,_=k+51|0,o=k+40|0,m=i[24264],X=i[24265],s=i[24262],w=i[24263];;){u[k+52|0]=0,i[k+32>>2]=0,i[k+36>>2]=0,W[i[i[e>>2]+40>>2]](k+8|0,e,r,0,f),t=l[k+28|0];r:{f:{if(n=l[k+52|0],(n|0)==255){if((t|0)==255)break i;break f}if((t|0)!=255)break f;i[k+104>>2]=s,i[k+108>>2]=w,W[i[(k+104|0)+(n<<2)>>2]](k+100|0,k+32|0),u[k+52|0]=255;break r}n=k+32|0,i[k+100>>2]=n,i[k+104>>2]=m,i[k+108>>2]=X,W[i[(k+104|0)+(t<<2)>>2]](k+100|0,n,k+8|0)}n=l[k+28|0],(n|0)!=255&&(i[k+104>>2]=s,i[k+108>>2]=w,W[i[(k+104|0)+(n<<2)>>2]](k+100|0,k+8|0));r:{f:{A:{k:{n:{if(n=l[k+52|0],n){if((n|0)==1)break n;break i}if(n=107664,!i[26916])break A;h=107676,_=107683,o=107672;break k}if(n=k+32|0,!i[k+32>>2])break i}e=i[n+4>>2],i[A>>2]=i[n>>2],i[A+4>>2]=e,r=A+8|0;k:{if(u[_|0]>=0){e=i[o+4>>2],i[r>>2]=i[o>>2],i[r+4>>2]=e,i[r+8>>2]=i[o+8>>2];break k}T(r,i[o>>2],i[h>>2])}u[A+20|0]=1;break f}if(!i[k+32>>2])break r;u[A+20|0]=255,u[A|0]=0,i[k+8>>2]=A,W[i[24266]](k+8|0,k+32|0),u[A+20|0]=0}if(A=l[k+52|0],(A|0)==255)break e;i[k+8>>2]=s,i[k+12>>2]=w,W[i[(k+8|0)+(A<<2)>>2]](k+104|0,k+32|0);break e}if(t=k+8|0,n=k+32|0,W[s|0](t,n),B=B+1|0,(B|0)==50)break}f=p(64),i[k+8>>2]=f,i[k+12>>2]=58,i[k+16>>2]=-2147483584,e=l[25569]|l[25570]<<8,u[f+56|0]=e,u[f+57|0]=e>>>8,r=l[25565]|l[25566]<<8|(l[25567]<<16|l[25568]<<24),e=l[25561]|l[25562]<<8|(l[25563]<<16|l[25564]<<24),u[f+48|0]=e,u[f+49|0]=e>>>8,u[f+50|0]=e>>>16,u[f+51|0]=e>>>24,u[f+52|0]=r,u[f+53|0]=r>>>8,u[f+54|0]=r>>>16,u[f+55|0]=r>>>24,r=l[25557]|l[25558]<<8|(l[25559]<<16|l[25560]<<24),e=l[25553]|l[25554]<<8|(l[25555]<<16|l[25556]<<24),u[f+40|0]=e,u[f+41|0]=e>>>8,u[f+42|0]=e>>>16,u[f+43|0]=e>>>24,u[f+44|0]=r,u[f+45|0]=r>>>8,u[f+46|0]=r>>>16,u[f+47|0]=r>>>24,r=l[25549]|l[25550]<<8|(l[25551]<<16|l[25552]<<24),e=l[25545]|l[25546]<<8|(l[25547]<<16|l[25548]<<24),u[f+32|0]=e,u[f+33|0]=e>>>8,u[f+34|0]=e>>>16,u[f+35|0]=e>>>24,u[f+36|0]=r,u[f+37|0]=r>>>8,u[f+38|0]=r>>>16,u[f+39|0]=r>>>24,r=l[25541]|l[25542]<<8|(l[25543]<<16|l[25544]<<24),e=l[25537]|l[25538]<<8|(l[25539]<<16|l[25540]<<24),u[f+24|0]=e,u[f+25|0]=e>>>8,u[f+26|0]=e>>>16,u[f+27|0]=e>>>24,u[f+28|0]=r,u[f+29|0]=r>>>8,u[f+30|0]=r>>>16,u[f+31|0]=r>>>24,r=l[25533]|l[25534]<<8|(l[25535]<<16|l[25536]<<24),e=l[25529]|l[25530]<<8|(l[25531]<<16|l[25532]<<24),u[f+16|0]=e,u[f+17|0]=e>>>8,u[f+18|0]=e>>>16,u[f+19|0]=e>>>24,u[f+20|0]=r,u[f+21|0]=r>>>8,u[f+22|0]=r>>>16,u[f+23|0]=r>>>24,r=l[25525]|l[25526]<<8|(l[25527]<<16|l[25528]<<24),e=l[25521]|l[25522]<<8|(l[25523]<<16|l[25524]<<24),u[f+8|0]=e,u[f+9|0]=e>>>8,u[f+10|0]=e>>>16,u[f+11|0]=e>>>24,u[f+12|0]=r,u[f+13|0]=r>>>8,u[f+14|0]=r>>>16,u[f+15|0]=r>>>24,r=l[25517]|l[25518]<<8|(l[25519]<<16|l[25520]<<24),e=l[25513]|l[25514]<<8|(l[25515]<<16|l[25516]<<24),u[f|0]=e,u[f+1|0]=e>>>8,u[f+2|0]=e>>>16,u[f+3|0]=e>>>24,u[f+4|0]=r,u[f+5|0]=r>>>8,u[f+6|0]=r>>>16,u[f+7|0]=r>>>24,u[f+58|0]=0,f=q(n,7,0,t),e=i[f+4>>2],i[A>>2]=i[f>>2],i[A+4>>2]=e,r=A+8|0;r:{if(u[f+19|0]>=0){e=i[f+12>>2],i[r>>2]=i[f+8>>2],i[r+4>>2]=e,i[r+8>>2]=i[f+16>>2],u[A+20|0]=1;break r}if(T(r,i[f+8>>2],i[f+12>>2]),e=u[f+19|0],u[A+20|0]=1,(e|0)>=0)break r;Z(i[f+8>>2])}if(u[k+19|0]>=0)break e;Z(i[k+8>>2])}u[k+99|0]<0&&Z(i[k+88>>2]),v=k+112|0;return}_2(),H()}function Gv(A,e,r,f,k,n){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0;var t=0,o=0,s=0,w=0;e=v-144|0,v=e,i[e+104>>2]=0,i[e+108>>2]=0,i[e+112>>2]=0,i[e+116>>2]=0,u[e+119|0]=0,u[e+120|0]=0,u[e+121|0]=0,u[e+122|0]=0,i[e+96>>2]=0,i[e+100>>2]=0,i[e+124>>2]=0,i[e+128>>2]=0,i[e+136>>2]=0,u[e+132|0]=1,u[e+92|0]=0,u[e+93|0]=0,u[e+94|0]=0,u[e+95|0]=0,u[e+85|0]=0,u[e+86|0]=0,u[e+87|0]=0,u[e+88|0]=0,u[e+89|0]=0,u[e+90|0]=0,u[e+91|0]=0,u[e+92|0]=0,u[e+84|0]=1,Bt(e- -64|0,e+84|0,r),u[e+83|0]<0&&Z(i[e+72>>2]),i[e+60>>2]=0,t=i[r>>2],k=i[r+4>>2];i:{if(!k){i[e+60>>2]=0,i[e+56>>2]=t;break i}if(i[k+4>>2]=i[k+4>>2]+1,i[e+56>>2]=t,r=i[e+60>>2],i[e+60>>2]=k,!r||(k=i[r+4>>2],i[r+4>>2]=k-1,k))break i;W[i[i[r>>2]+8>>2]](r),y(r)}W[i[i[f>>2]+100>>2]](e+44|0,i[f+4>>2],e+56|0,n);i:{e:{r:{f:{A:{if(k=i[e+44>>2],!k)for(;;){if(W[i[i[f>>2]+104>>2]](e+24|0,i[f+4>>2],e+12|0,e+8|0,0),Q9(e+84|0,i[e+12>>2],i[e+8>>2]),r=i[e+12>>2],!r)break A;Ue(e+96|0,r,i[e+8>>2])}if(n=i[e+48>>2],t=i[e+52>>2],f=h2(t),f>>>0>=2147483640)break r;k:{n:{if(f>>>0>=11){o=f|7,r=p(o+1|0),i[e+20>>2]=o-2147483647,i[e+12>>2]=r,i[e+16>>2]=f;break n}if(u[e+23|0]=f,r=e+12|0,!f)break k}if(!f)break k;x(r,t,f)}u[r+f|0]=0,r=q(e+24|0,k,n,e+12|0),f=i[r+4>>2],i[A>>2]=i[r>>2],i[A+4>>2]=f,f=A+8|0;k:{if(u[r+19|0]>=0){k=i[r+12>>2],i[f>>2]=i[r+8>>2],i[f+4>>2]=k,i[f+8>>2]=i[r+16>>2],u[A+44|0]=1;break k}if(T(f,i[r+8>>2],i[r+12>>2]),f=u[r+19|0],u[A+44|0]=1,(f|0)>=0)break k;Z(i[r+8>>2])}if(u[e+23|0]>=0)break f;Z(i[e+12>>2]);break f}f=p(144),i[f>>2]=90524,i[f+4>>2]=0,i[f+8>>2]=0,n=f+16|0,r=n,i[r+8>>2]=0,i[r+12>>2]=0,i[r+16>>2]=0,i[r+20>>2]=0,i[r+24>>2]=0,i[r+28>>2]=0,i[r+32>>2]=0,i[r>>2]=86356,i[f+60>>2]=0,i[f+64>>2]=0,i[f+52>>2]=0,i[f+56>>2]=0,i[f+72>>2]=-1,i[f+76>>2]=-1,i[f+80>>2]=-1,i[f+84>>2]=-1,i[f+88>>2]=0,i[f+92>>2]=0,i[f+96>>2]=0,i[f+100>>2]=0,i[f+104>>2]=0,i[f+108>>2]=0,u[f+112|0]=0,i[r>>2]=98080,i[f+136>>2]=0,i[f+128>>2]=0,i[f+132>>2]=0,i[f+32>>2]=1635135811,r=l[e+88|0]|l[e+89|0]<<8|(l[e+90|0]<<16|l[e+91|0]<<24),k=l[e+84|0]|l[e+85|0]<<8|(l[e+86|0]<<16|l[e+87|0]<<24),u[f+113|0]=k,u[f+114|0]=k>>>8,u[f+115|0]=k>>>16,u[f+116|0]=k>>>24,u[f+117|0]=r,u[f+118|0]=r>>>8,u[f+119|0]=r>>>16,u[f+120|0]=r>>>24,r=l[e+92|0]|l[e+93|0]<<8|(l[e+94|0]<<16|l[e+95|0]<<24),u[f+121|0]=r,u[f+122|0]=r>>>8,u[f+123|0]=r>>>16,u[f+124|0]=r>>>24,i[f+4>>2]=i[f+4>>2]+1,r=i[e+104>>2],k=i[e+100>>2];A:{if(r>>>0>k>>>0){i[k+4>>2]=f,i[k>>2]=n,n=k+8|0;break A}if(t=i[e+96>>2],k=k-t|0,w=k>>3,o=w+1|0,o>>>0>=536870912)break e;if(r=r-t|0,s=r>>2,o=r>>>0>=2147483640?536870911:o>>>0<s>>>0?s:o,o){if(o>>>0>=536870912)break i;r=p(o<<3)}else r=0;if(s=r+k|0,i[s+4>>2]=f,i[s>>2]=n,w=s-(w<<3)|0,k&&x(w,t,k),r=r+(o<<3)|0,i[e+104>>2]=r,n=s+8|0,i[e+100>>2]=n,i[e+96>>2]=w,!t)break A;Z(t),r=i[e+104>>2]}if(g[e+120>>1]=257,k=i[e+96>>2],i[e+96>>2]=0,i[e+100>>2]=0,i[e+104>>2]=0,t=i[e+116>>2],i[e+116>>2]=0,o=i[e+108>>2],s=i[e+112>>2],i[e+108>>2]=0,i[e+112>>2]=0,i[A+20>>2]=t,i[A+12>>2]=o,i[A+16>>2]=s,i[A+8>>2]=r,i[A+4>>2]=n,i[A>>2]=k,r=i[e+124>>2],i[A+24>>2]=i[e+120>>2],i[A+28>>2]=r,r=i[e+132>>2],i[A+32>>2]=i[e+128>>2],i[A+36>>2]=r,i[A+40>>2]=i[e+136>>2],u[A+44|0]=0,A=i[f+4>>2],i[f+4>>2]=A-1,A)break f;W[i[i[f>>2]+8>>2]](f),y(f)}A=i[e+60>>2];f:{if(!A||(r=i[A+4>>2],i[A+4>>2]=r-1,r))break f;W[i[i[A>>2]+8>>2]](A),y(A)}if(A=i[e+108>>2],A&&(i[e+112>>2]=A,Z(A)),A=i[e+96>>2],A){if(r=A,f=i[e+100>>2],(r|0)!=(f|0)){for(;;){r=i[f-4>>2];f:{if(!r||(k=i[r+4>>2],i[r+4>>2]=k-1,k))break f;W[i[i[r>>2]+8>>2]](r),y(r)}if(f=f-8|0,(A|0)==(f|0))break}r=i[e+96>>2]}i[e+100>>2]=A,Z(r)}v=e+144|0;return}Q0(),H()}G0(),H()}z0(),H()}function u9(A,e,r,f){var k=0,n=0,t=0,o=0,s=0;k=v-112|0,v=k,i[k+88>>2]=0,i[k+92>>2]=0,i[k+104>>2]=0,i[k+96>>2]=0,i[k+100>>2]=0;i:{e:{n=i[e+128>>2];r:{if(!n)break r;for(s=e+128|0,t=s;o=u0[n+16>>2]<r>>>0,t=o?t:n,n=i[(o?4:0)+n>>2],!!n;);if(o=0,(t|0)==(s|0)|u0[t+16>>2]>r>>>0)break r;if(n=i[t+20>>2],o=i[t+24>>2],o&&(i[o+4>>2]=i[o+4>>2]+1),n)break e}u[k+48|0]=0,u[k+59|0]=0,e=q(k- -64|0,5,2e3,k+48|0),r=i[e+4>>2],i[A>>2]=i[e>>2],i[A+4>>2]=r,r=A+8|0;r:{if(u[e+19|0]>=0){f=i[e+12>>2],i[r>>2]=i[e+8>>2],i[r+4>>2]=f,i[r+8>>2]=i[e+16>>2],u[A+20|0]=1;break r}if(T(r,i[e+8>>2],i[e+12>>2]),r=u[e+19|0],u[A+20|0]=1,(r|0)>=0)break r;Z(i[e+8>>2])}if(u[k+59|0]>=0)break i;Z(i[k+48>>2]);break i}t=i[n+112>>2];e:{if(u[n+139|0]>=0){i[k+56>>2]=i[n+136>>2],s=i[n+132>>2],i[k+48>>2]=i[n+128>>2],i[k+52>>2]=s;break e}T(k+48|0,i[n+128>>2],i[n+132>>2])}e:{if((t|0)!=1835625829){f&&(i[f>>2]=0),n=0,i[k+40>>2]=0,i[k+32>>2]=0,i[k+36>>2]=0,q6(k- -64|0,i[e+68>>2],r,e+8|0,e+76|0,k+32|0,0,0,-1,-1,i[e+156>>2]);r:{if(i[k+64>>2]){if(e=i[k+68>>2],i[A>>2]=i[k+64>>2],i[A+4>>2]=e,e=A+8|0,u[k+83|0]>=0){r=i[k+76>>2],i[e>>2]=i[k+72>>2],i[e+4>>2]=r,i[e+8>>2]=i[k+80>>2],n=1;break r}T(e,i[k+72>>2],i[k+76>>2]),n=1;break r}e=i[k+40>>2],i[k+40>>2]=0,r=i[k+32>>2],f=i[k+36>>2],i[k+32>>2]=0,i[k+36>>2]=0,i[A+8>>2]=e,i[A>>2]=r,i[A+4>>2]=f}if(u[A+20|0]=n,u[k+83|0]<0&&Z(i[k+72>>2]),A=i[k+32>>2],!A)break e;i[k+36>>2]=A,Z(A);break e}r:{if(u[n+151|0]>=0){i[k+40>>2]=i[n+148>>2],t=i[n+144>>2],i[k+32>>2]=i[n+140>>2],i[k+36>>2]=t;break r}T(k+32|0,i[n+140>>2],i[n+144>>2])}t=2,s=u[k+43|0],n=(s|0)<0;r:{f:{A:{k:{n:{t:switch(s=n?i[k+36>>2]:s,s|0){case 2:break A;case 7:break k;case 13:break n;case 0:break t;default:break f}f&&(i[f>>2]=0),n=0,i[k+28>>2]=0,i[k+20>>2]=0,i[k+24>>2]=0,q6(k- -64|0,i[e+68>>2],r,e+8|0,e+76|0,k+20|0,0,0,-1,-1,i[e+156>>2]);t:{if(i[k+64>>2]){if(e=i[k+68>>2],i[A>>2]=i[k+64>>2],i[A+4>>2]=e,e=A+8|0,u[k+83|0]>=0){r=i[k+76>>2],i[e>>2]=i[k+72>>2],i[e+4>>2]=r,i[e+8>>2]=i[k+80>>2],n=1;break t}T(e,i[k+72>>2],i[k+76>>2]),n=1;break t}e=i[k+28>>2],i[k+28>>2]=0,r=i[k+20>>2],f=i[k+24>>2],i[k+20>>2]=0,i[k+24>>2]=0,i[A+8>>2]=e,i[A>>2]=r,i[A+4>>2]=f}if(u[A+20|0]=n,u[k+83|0]<0&&Z(i[k+72>>2]),A=i[k+20>>2],!A)break r;i[k+24>>2]=A,Z(A);break r}t=N2(n?i[k+32>>2]:k+32|0,18347,13)?2:4;break f}t=N2(n?i[k+32>>2]:k+32|0,12192,s)?2:3;break f}t=N2(n?i[k+32>>2]:k+32|0,7623,s)?2:5}i[k+28>>2]=0,i[k+20>>2]=0,i[k+24>>2]=0,q6(k- -64|0,i[e+68>>2],r,e+8|0,e+76|0,k+20|0,0,0,-1,-1,i[e+156>>2]),r=i[k+68>>2],e=i[k+64>>2],i[k+88>>2]=e,i[k+92>>2]=r,u[k+107|0]<0&&(Z(i[k+96>>2]),e=i[k+88>>2]),r=i[k+76>>2],i[k+96>>2]=i[k+72>>2],i[k+100>>2]=r,i[k+104>>2]=i[k+80>>2];f:{if(e){e=i[k+92>>2],i[A>>2]=i[k+88>>2],i[A+4>>2]=e,e=A+8|0;A:{if(u[k+107|0]>=0){r=i[k+100>>2],i[e>>2]=i[k+96>>2],i[e+4>>2]=r,i[e+8>>2]=i[k+104>>2];break A}T(e,i[k+96>>2],i[k+100>>2])}u[A+20|0]=1;break f}if(f){i[f>>2]=t,e=i[k+28>>2],i[k+28>>2]=0,r=i[k+20>>2],f=i[k+24>>2],i[k+20>>2]=0,u[A+20|0]=0,i[A+8>>2]=e,i[A>>2]=r,i[A+4>>2]=f;break f}u[k+8|0]=0,u[k+19|0]=0,e=q(k- -64|0,3,3005,k+8|0),r=i[e+4>>2],i[A>>2]=i[e>>2],i[A+4>>2]=r,r=A+8|0;A:{if(u[e+19|0]>=0){f=i[e+12>>2],i[r>>2]=i[e+8>>2],i[r+4>>2]=f,i[r+8>>2]=i[e+16>>2],u[A+20|0]=1;break A}if(T(r,i[e+8>>2],i[e+12>>2]),r=u[e+19|0],u[A+20|0]=1,(r|0)>=0)break A;Z(i[e+8>>2])}if(u[k+19|0]>=0)break f;Z(i[k+8>>2])}if(A=i[k+20>>2],!A)break r;i[k+24>>2]=A,Z(A)}if(u[k+43|0]>=0)break e;Z(i[k+32>>2])}if(u[k+59|0]>=0)break i;Z(i[k+48>>2])}i:{if(!o||(A=i[o+4>>2],i[o+4>>2]=A-1,A))break i;W[i[i[o>>2]+8>>2]](o),y(o)}u[k+107|0]<0&&Z(i[k+96>>2]),v=k+112|0}function Xv(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0;var k=0,n=0,t=0,o=0,s=0,w=0,h=0,_=0,B=0,m=0;t=g[e+8>>1],_=v-32|0,o=g[e+16>>1],h=g[e>>1],n=g[e+24>>1],k=((G(o,-74)+G(h,74)|0)+G(n,74)|0)- -64>>7,k=(k|0)>=32767?32767:k,g[_+16>>1]=(k|0)<=-32768?-32768:k,k=(((G(t,-74)+G(h,84)|0)+G(o,55)|0)+G(n,-29)|0)- -64>>7,k=(k|0)>=32767?32767:k,g[_+24>>1]=(k|0)<=-32768?-32768:k,t=G(t,74),k=(((t+G(h,55)|0)+G(o,-29)|0)+G(n,-84)|0)- -64>>7,k=(k|0)>=32767?32767:k,g[_+8>>1]=(k|0)<=-32768?-32768:k,o=(((t+G(h,29)|0)+G(o,84)|0)+G(n,55)|0)- -64>>7,o=(o|0)>=32767?32767:o,g[_>>1]=(o|0)<=-32768?-32768:o,t=g[e+10>>1],o=g[e+18>>1],h=g[e+2>>1],n=g[e+26>>1],k=((G(o,-74)+G(h,74)|0)+G(n,74)|0)- -64>>7,k=(k|0)>=32767?32767:k,g[_+18>>1]=(k|0)<=-32768?-32768:k,k=(((G(t,-74)+G(h,84)|0)+G(o,55)|0)+G(n,-29)|0)- -64>>7,k=(k|0)>=32767?32767:k,g[_+26>>1]=(k|0)<=-32768?-32768:k,t=G(t,74),k=(((t+G(h,55)|0)+G(o,-29)|0)+G(n,-84)|0)- -64>>7,k=(k|0)>=32767?32767:k,g[_+10>>1]=(k|0)<=-32768?-32768:k,o=(((t+G(h,29)|0)+G(o,84)|0)+G(n,55)|0)- -64>>7,o=(o|0)>=32767?32767:o,g[_+2>>1]=(o|0)<=-32768?-32768:o,t=g[e+12>>1],o=g[e+20>>1],h=g[e+4>>1],n=g[e+28>>1],k=((G(o,-74)+G(h,74)|0)+G(n,74)|0)- -64>>7,k=(k|0)>=32767?32767:k,g[_+20>>1]=(k|0)<=-32768?-32768:k,k=(((G(t,-74)+G(h,84)|0)+G(o,55)|0)+G(n,-29)|0)- -64>>7,k=(k|0)>=32767?32767:k,g[_+28>>1]=(k|0)<=-32768?-32768:k,t=G(t,74),k=(((t+G(h,55)|0)+G(o,-29)|0)+G(n,-84)|0)- -64>>7,k=(k|0)>=32767?32767:k,g[_+12>>1]=(k|0)<=-32768?-32768:k,o=(((t+G(h,29)|0)+G(o,84)|0)+G(n,55)|0)- -64>>7,o=(o|0)>=32767?32767:o,g[_+4>>1]=(o|0)<=-32768?-32768:o,n=g[e+14>>1],o=g[e+22>>1],h=g[e+6>>1],e=g[e+30>>1],t=((G(o,-74)+G(h,74)|0)+G(e,74)|0)- -64>>7,t=(t|0)>=32767?32767:t,g[_+22>>1]=(t|0)<=-32768?-32768:t,t=(((G(n,-74)+G(h,84)|0)+G(o,55)|0)+G(e,-29)|0)- -64>>7,t=(t|0)>=32767?32767:t,g[_+30>>1]=(t|0)<=-32768?-32768:t,n=G(n,74),t=(((n+G(h,55)|0)+G(o,-29)|0)+G(e,-84)|0)- -64>>7,t=(t|0)>=32767?32767:t,g[_+14>>1]=(t|0)<=-32768?-32768:t,e=(((n+G(h,29)|0)+G(o,84)|0)+G(e,55)|0)- -64>>7,e=(e|0)>=32767?32767:e,g[_+6>>1]=(e|0)<=-32768?-32768:e,o=20-f|0,e=-1<<f^-1,h=1<<19-f;i:{if((r|0)!=1){for(f=0;t=(f<<3)+_|0,s=g[t+2>>1],n=(G(r,f)<<1)+A|0,k=g[t+4>>1],m=g[t>>1],t=g[t+6>>1],w=h+((G(k,-74)+G(m,74)|0)+G(t,74)|0)>>o,w=(w|0)>=32767?32767:w,w=C[n+4>>1]+((w|0)<=-32768?-32768:w)|0,g[n+4>>1]=(w|0)>=0?(e|0)>(w|0)?w:e:0,B=G(s,74),w=h+(((B+G(m,29)|0)+G(k,84)|0)+G(t,55)|0)>>o,w=(w|0)>=32767?32767:w,w=C[n>>1]+((w|0)<=-32768?-32768:w)|0,g[n>>1]=(w|0)>=0?(e|0)>(w|0)?w:e:0,w=h+(((B+G(m,55)|0)+G(k,-29)|0)+G(t,-84)|0)>>o,w=(w|0)>=32767?32767:w,w=C[n+2>>1]+((w|0)<=-32768?-32768:w)|0,g[n+2>>1]=(w|0)>=0?(e|0)>(w|0)?w:e:0,B=n,w=C[n+6>>1],n=h+(((G(s,-74)+G(m,84)|0)+G(k,55)|0)+G(t,-29)|0)>>o,n=(n|0)>=32767?32767:n,n=w+((n|0)<=-32768?-32768:n)|0,g[B+6>>1]=(n|0)>=0?(e|0)>(n|0)?n:e:0,f=f+1|0,(f|0)!=4;);break i}for(k=C[A+4>>1],f=0;t=(f<<3)+_|0,w=g[t+2>>1],n=(G(r,f)<<1)+A|0,B=k&65535,k=g[t+4>>1],m=g[t>>1],t=g[t+6>>1],s=h+((G(k,-74)+G(m,74)|0)+G(t,74)|0)>>o,s=(s|0)>=32767?32767:s,s=B+((s|0)<=-32768?-32768:s)|0,g[n+4>>1]=(s|0)>=0?(e|0)>(s|0)?s:e:0,B=G(w,74),s=h+(((B+G(m,29)|0)+G(k,84)|0)+G(t,55)|0)>>o,s=(s|0)>=32767?32767:s,s=C[n>>1]+((s|0)<=-32768?-32768:s)|0,g[n>>1]=(s|0)>=0?(e|0)>(s|0)?s:e:0,s=h+(((B+G(m,55)|0)+G(k,-29)|0)+G(t,-84)|0)>>o,s=(s|0)>=32767?32767:s,s=C[n+2>>1]+((s|0)<=-32768?-32768:s)|0,g[n+2>>1]=(s|0)>=0?(e|0)>(s|0)?s:e:0,B=n,s=C[n+6>>1],n=h+(((G(w,-74)+G(m,84)|0)+G(k,55)|0)+G(t,-29)|0)>>o,n=(n|0)>=32767?32767:n,n=s+((n|0)<=-32768?-32768:n)|0,k=(n|0)>=0?(e|0)>(n|0)?n:e:0,g[B+6>>1]=k,f=f+1|0,(f|0)!=4;);}}function o9(A,e){var r=0,f=0,k=0,n=0,t=0,o=0,s=0,w=0,h=0,_=0,B=0;k=v+-64|0,v=k;i:{if(l[e+88|0]==1){if(e=i[26917],i[A>>2]=i[26916],i[A+4>>2]=e,A=A+8|0,u[107683]>=0){e=i[26919],i[A>>2]=i[26918],i[A+4>>2]=e,i[A+8>>2]=i[26920];break i}T(A,i[26918],i[26919]);break i}Br(k+40|0,e,1);e:{r:switch(l[k+60|0]){default:_2(),H();case 1:if(e=i[k+44>>2],i[A>>2]=i[k+40>>2],i[A+4>>2]=e,A=A+8|0,u[k+59|0]>=0){e=i[k+52>>2],i[A>>2]=i[k+48>>2],i[A+4>>2]=e,i[A+8>>2]=i[k+56>>2];break e}T(A,i[k+48>>2],i[k+52>>2]);break e;case 0:break r}f=p(24),i[k+4>>2]=f,i[k+8>>2]=23,i[k+12>>2]=-2147483624,n=l[7429]|l[7430]<<8|(l[7431]<<16|l[7432]<<24),r=l[7425]|l[7426]<<8|(l[7427]<<16|l[7428]<<24),u[f+15|0]=r,u[f+16|0]=r>>>8,u[f+17|0]=r>>>16,u[f+18|0]=r>>>24,u[f+19|0]=n,u[f+20|0]=n>>>8,u[f+21|0]=n>>>16,u[f+22|0]=n>>>24,n=l[7422]|l[7423]<<8|(l[7424]<<16|l[7425]<<24),r=l[7418]|l[7419]<<8|(l[7420]<<16|l[7421]<<24),u[f+8|0]=r,u[f+9|0]=r>>>8,u[f+10|0]=r>>>16,u[f+11|0]=r>>>24,u[f+12|0]=n,u[f+13|0]=n>>>8,u[f+14|0]=n>>>16,u[f+15|0]=n>>>24,n=l[7414]|l[7415]<<8|(l[7416]<<16|l[7417]<<24),r=l[7410]|l[7411]<<8|(l[7412]<<16|l[7413]<<24),u[f|0]=r,u[f+1|0]=r>>>8,u[f+2|0]=r>>>16,u[f+3|0]=r>>>24,u[f+4|0]=n,u[f+5|0]=n>>>8,u[f+6|0]=n>>>16,u[f+7|0]=n>>>24,u[f+23|0]=0,r=q(k+16|0,2,0,k+4|0),u[k+15|0]<0&&Z(i[k+4>>2]);r:{f:{A:{k:{n:{t:{u:{o:{if(o=i[k+40>>2],s=i[k+44>>2]-o|0,s>>>0>=2)for(f=1;;){n=t,t=f;l:{if(w=n+o|0,l[w|0]!=255||(f=l[f+o|0],(f&240)!=192|l[(f&15)+53344|0]!=1))break l;if(t=n+9|0,t>>>0>=s>>>0){if(e=i[r+4>>2],i[A>>2]=i[r>>2],i[A+4>>2]=e,A=A+8|0,u[r+19|0]>=0){e=i[r+12>>2],i[A>>2]=i[r+8>>2],i[A+4>>2]=e,i[A+8>>2]=i[r+16>>2];break r}T(A,i[r+8>>2],i[r+12>>2]);break r}s:{if(h=l[t+o|0],t=n+11|0,s>>>0>G(h,3)+t>>>0){if(!h)break u;if(o=t+o|0,s=l[o|0],n=0,f=0,t=0,(h|0)!=1)break s;break o}if(e=i[r+4>>2],i[A>>2]=i[r>>2],i[A+4>>2]=e,A=A+8|0,u[r+19|0]>=0){e=i[r+12>>2],i[A>>2]=i[r+8>>2],i[A+4>>2]=e,i[A+8>>2]=i[r+16>>2];break r}T(A,i[r+8>>2],i[r+12>>2]);break r}if(t=l[o+3|0],f=t&15,t=t>>>4|0,(h|0)==2)break o;o=l[o+6|0],_=o&15,B=o>>>4|0;break o}if(f=t+1|0,(s|0)==(f|0))break}if(e=i[r+4>>2],i[A>>2]=i[r>>2],i[A+4>>2]=e,A=A+8|0,u[r+19|0]>=0){e=i[r+12>>2],i[A>>2]=i[r+8>>2],i[A+4>>2]=e,i[A+8>>2]=i[r+16>>2];break r}T(A,i[r+8>>2],i[r+12>>2]);break r}switch(w=l[w+4|0],o=s&15,s=s>>>4|0,h-1|0){case 0:break n;case 2:break t;default:break u}}if(e=i[r+4>>2],i[A>>2]=i[r>>2],i[A+4>>2]=e,A=A+8|0,u[r+19|0]>=0){e=i[r+12>>2],i[A>>2]=i[r+8>>2],i[A+4>>2]=e,i[A+8>>2]=i[r+16>>2];break r}T(A,i[r+8>>2],i[r+12>>2]);break r}if(!((t|0)==(B|0)&(f|0)==(_|0))){if(e=i[r+4>>2],i[A>>2]=i[r>>2],i[A+4>>2]=e,A=A+8|0,u[r+19|0]>=0){e=i[r+12>>2],i[A>>2]=i[r+8>>2],i[A+4>>2]=e,i[A+8>>2]=i[r+16>>2];break r}T(A,i[r+8>>2],i[r+12>>2]);break r}if(n=1,!((f|0)!=1|(t|0)!=1|(s|0)!=2)&&(o|0)==2)break n;if(n=(f|0)!=1,!(n|(t|0)!=1|((s|0)!=2|(o|0)!=1))){n=2;break n}if((t|0)!=1|n|((s|0)!=1|(o|0)!=1))break k;n=3}if(l[e+88|0]!=1)break A;u[e+72|0]=w,w=l[k+4|0]|l[k+5|0]<<8,u[e+73|0]=w,u[e+74|0]=w>>>8,u[e+75|0]=l[k+6|0];break f}if(e=i[r+4>>2],i[A>>2]=i[r>>2],i[A+4>>2]=e,A=A+8|0,u[r+19|0]>=0){e=i[r+12>>2],i[A>>2]=i[r+8>>2],i[A+4>>2]=e,i[A+8>>2]=i[r+16>>2];break r}T(A,i[r+8>>2],i[r+12>>2]);break r}u[e+72|0]=w,w=l[k+4|0]|l[k+5|0]<<8,u[e+73|0]=w,u[e+74|0]=w>>>8,u[e+75|0]=l[k+6|0],u[e+88|0]=1}u[e+86|0]=_,u[e+85|0]=f,u[e+84|0]=o,u[e+83|0]=B,u[e+82|0]=t,u[e+81|0]=s,u[e+80|0]=h,i[e+76>>2]=n,k8(A,107664)}if(u[r+19|0]>=0)break e;Z(i[r+8>>2])}if(A=l[k+60|0],(A|0)==255)break i;e=i[24661],i[k+16>>2]=i[24660],i[k+20>>2]=e,W[i[(k+16|0)+(A<<2)>>2]](k+4|0,k+40|0)}v=k- -64|0}function q4(A,e,r,f,k){var n=0,t=0,o=0,s=0,w=0;n=v-160|0,v=n;i:{if(!f){if(e=i[26917],i[A>>2]=i[26916],i[A+4>>2]=e,A=A+8|0,u[107683]>=0){e=i[26919],i[A>>2]=i[26918],i[A+4>>2]=e,i[A+8>>2]=i[26920];break i}T(A,i[26918],i[26919]);break i}e:{r:{f:{A:{k:{if(t=i[f+40>>2],o=i[f+44>>2],!(!(t|o)|(!o&r>>>0<=t>>>0|(o|0)!=0))){i[n+104>>2]=0,i[n+76>>2]=72196,i[n+20>>2]=72176,e=i[18053],i[n+12>>2]=e,t=i[e-12>>2],e=n+12|0,i[t+e>>2]=i[18054],i[n+16>>2]=0,t=e+i[i[n+12>>2]-12>>2]|0,o=n+24|0,J0(t,o),u[t+80|0]=0,i[t+72>>2]=0,t=i[18055],i[n+20>>2]=t,s=i[t-12>>2],t=n+20|0,i[s+t>>2]=i[18056],s=i[18052],i[n+12>>2]=s,i[e+i[s-12>>2]>>2]=i[18057],i[n+76>>2]=72196,i[n+12>>2]=72156,i[n+20>>2]=72176,o=R0(o),i[o>>2]=71232,e=n- -64|0,i[e>>2]=0,i[e+4>>2]=0,i[n+56>>2]=0,i[n+60>>2]=0,i[n+72>>2]=24,e=V0(Y(t,28376,11),r);n:{if(k){e=Y(Y(Y(e,27743,11),k,h2(k)),28559,31);break n}e=Y(e,28508,37)}Y(q2(e,i[f+40>>2],i[f+44>>2]),5240,6),e=i[n+72>>2];n:{if(e&16){t=i[n+68>>2],e=i[n+48>>2],t>>>0<e>>>0&&(i[n+68>>2]=e,t=e),e=n+44|0;break n}if(!(e&8)){t=0,u[n+11|0]=0,f=n;break e}t=i[n+40>>2],e=n+32|0}if(e=i[e>>2],t=t-e|0,t>>>0>=2147483640)break k;if(t>>>0>=11){r=t|7,f=p(r+1|0),i[n+8>>2]=r-2147483647,i[n>>2]=f,i[n+4>>2]=t;break r}if(u[n+11|0]=t,f=n,t)break r;t=0;break e}if(!((f|0)!=95520&(f|0)!=95608)){if(e=i[26917],i[A>>2]=i[26916],i[A+4>>2]=e,A=A+8|0,u[107683]>=0){e=i[26919],i[A>>2]=i[26918],i[A+4>>2]=e,i[A+8>>2]=i[26920];break i}T(A,i[26918],i[26919]);break i}l[107752]||(u[107752]=1);n:{t=i[26940];t:{if(!t)break t;for(o=107760;s=u0[t+16>>2]<f>>>0,o=s?o:t,t=i[(s?4:0)+t>>2],!!t;);if((o|0)==107760)break t;if(u0[o+16>>2]<=f>>>0)break n}if(e=i[26917],i[A>>2]=i[26916],i[A+4>>2]=e,A=A+8|0,u[107683]>=0){e=i[26919],i[A>>2]=i[26918],i[A+4>>2]=e,i[A+8>>2]=i[26920];break i}T(A,i[26918],i[26919]);break i}if(s=i[f+64>>2],w=i[f+68>>2],t=i[o+20>>2]+r|0,!(!(s|w)|(!w&s>>>0>=t>>>0|(w|0)!=0))){i[n+104>>2]=0,i[n+76>>2]=72196,i[n+20>>2]=72176,e=i[18053],i[n+12>>2]=e,t=i[e-12>>2],e=n+12|0,i[t+e>>2]=i[18054],i[n+16>>2]=0,t=e+i[i[n+12>>2]-12>>2]|0,s=n+24|0,J0(t,s),u[t+80|0]=0,i[t+72>>2]=0,t=i[18055],i[n+20>>2]=t,w=n+20|0,i[w+i[t-12>>2]>>2]=i[18056],t=i[18052],i[n+12>>2]=t,i[e+i[t-12>>2]>>2]=i[18057],i[n+76>>2]=72196,i[n+12>>2]=72156,i[n+20>>2]=72176,s=R0(s),i[s>>2]=71232,e=n- -64|0,i[e>>2]=0,i[e+4>>2]=0,i[n+56>>2]=0,i[n+60>>2]=0,i[n+72>>2]=24,e=V0(Y(w,28666,16),i[o+20>>2]+r|0);n:{if(k){e=Y(Y(Y(e,27743,11),k,h2(k)),28559,31);break n}e=Y(e,28508,37)}Y(q2(e,i[f+64>>2],i[f+68>>2]),14118,28),e=i[n+72>>2];n:{if(e&16){t=i[n+68>>2],e=i[n+48>>2],t>>>0<e>>>0&&(i[n+68>>2]=e,t=e),e=n+44|0;break n}if(!(e&8)){t=0,u[n+11|0]=0,f=n;break f}t=i[n+40>>2],e=n+32|0}if(e=i[e>>2],t=t-e|0,t>>>0>=2147483640)break k;if(t>>>0>=11){r=t|7,f=p(r+1|0),i[n+8>>2]=r-2147483647,i[n>>2]=f,i[n+4>>2]=t;break A}if(u[n+11|0]=t,f=n,t)break A;t=0;break f}if(i[e>>2]=f,i[e+4>>2]=i[e+4>>2]+r,i[o+20>>2]=t,t>>>0>u0[o+24>>2]&&(i[o+24>>2]=t),e=i[26917],i[A>>2]=i[26916],i[A+4>>2]=e,A=A+8|0,u[107683]>=0){e=i[26919],i[A>>2]=i[26918],i[A+4>>2]=e,i[A+8>>2]=i[26920];break i}T(A,i[26918],i[26919]);break i}Q0(),H()}if(!t)break f;x(f,e,t)}u[f+t|0]=0,q(A,6,1e3,n),u[n+11|0]<0&&Z(i[n>>2]),A=i[18051],i[n+12>>2]=A,i[i[A-12>>2]+(n+12|0)>>2]=i[18059],i[n+20>>2]=i[18060],i[s>>2]=71232,u[n+67|0]<0&&Z(i[n+56>>2]),E0(s),y0(n+76|0);break i}if(!t)break e;x(f,e,t)}u[f+t|0]=0,q(A,6,1e3,n),u[n+11|0]<0&&Z(i[n>>2]),A=i[18051],i[n+12>>2]=A,i[i[A-12>>2]+(n+12|0)>>2]=i[18059],i[n+20>>2]=i[18060],i[o>>2]=71232,u[n+67|0]<0&&Z(i[n+56>>2]),E0(o),y0(n+76|0)}v=n+160|0}function Ff(A,e,r,f,k,n,t){var o=0,s=0,w=0,h=0,_=0,B=0,m=0,X=0,Q=0,V=0,F=0,I=0,E=0,R=0,N=0,M=0,z=0;w=v+-64|0,v=w;i:{s=i[e+120>>2];e:{if(!(!(r&1&(s|0)==2)&(!((r|k)&1)|(s|0)!=1))){if(i[w+48>>2]=0,i[w+52>>2]=0,i[w+40>>2]=0,i[w+44>>2]=0,u[w+52|0]=1,i[w+44>>2]=2,i[w+48>>2]=2,u[w+40|0]=1,i[w+56>>2]=i[e+84>>2],s=i[e+88>>2],!s||(s=Gi(s),i[w+60>>2]=s,!s))break i;i[w+8>>2]=131074,i[w+12>>2]=65538,_=255,s=i[e+128>>2];r:{if(!s)break r;for(e=e+128|0,h=e;m=i[s+16>>2],h=(m|0)<0?h:s,s=i[(m>>>29&4)+s>>2],!!s;);if((e|0)==(h|0)|i[h+16>>2]>0)break r;_=l[h+24|0]}AA(w+16|0,w+56|0,0,w+8|0,_,w+40|0,0,t),e=i[w+60>>2];r:{if(!e||(s=i[e+4>>2],i[e+4>>2]=s-1,s))break r;W[i[i[e>>2]+8>>2]](e),y(e)}r:{f:switch(l[w+36|0]){default:_2(),H();case 1:e=i[w+20>>2],i[A>>2]=i[w+16>>2],i[A+4>>2]=e,e=A+8|0;A:{if(u[w+35|0]>=0){r=i[w+28>>2],i[e>>2]=i[w+24>>2],i[e+4>>2]=r,i[e+8>>2]=i[w+32>>2];break A}T(e,i[w+24>>2],i[w+28>>2])}u[A+20|0]=1;break r;case 0:break f}Ff(A,i[w+16>>2],r,f,k,n,t)}if(A=l[w+36|0],(A|0)==255)break e;e=i[23819],i[w+56>>2]=i[23818],i[w+60>>2]=e,W[i[(w+56|0)+(A<<2)>>2]](w+8|0,w+16|0);break e}o=p(172),i[o+4>>2]=0,i[o+8>>2]=0,i[o>>2]=94812,o0(o+16|0,0,80),s=i[o+4>>2],_=s+1|0,i[o+4>>2]=_,i[o+104>>2]=0,i[o+108>>2]=0,i[o+36>>2]=1,i[o+40>>2]=1,u[o+24|0]=1,g[o+22>>1]=2,g[o+18>>1]=2,g[o+20>>1]=2,i[o+112>>2]=0,i[o+116>>2]=4740,i[o+140>>2]=0,i[o+144>>2]=0,i[o+128>>2]=99,i[o+132>>2]=99,i[o+120>>2]=0,i[o+124>>2]=0,i[o+12>>2]=95160,i[o+148>>2]=0,i[o+152>>2]=0,m=o+140|0,i[o+136>>2]=m,i[o+156>>2]=0,i[o+160>>2]=0,i[o+164>>2]=0,i[o+168>>2]=0,i[o+4>>2]=s,s=i[o+8>>2],X=o+12|0,i[o+96>>2]=X,i[o+8>>2]=s+1,i[o+100>>2]=o,_||(W[i[i[o>>2]+8>>2]](o),y(o)),s=i[e+120>>2],i[o+128>>2]=i[e+116>>2],i[o+132>>2]=s,i[o+124>>2]=(n-k|0)+1,i[o+120>>2]=(f-r|0)+1;r:{if(s=i[e+124>>2],R=e+128|0,(s|0)!=(R|0))for(Q=A+8|0;;){B=i[s+16>>2],V=po(r,B,i[e+120>>2],2),_=po(f,B,i[e+120>>2],0),F=yo(k,B,i[e+120>>2],2),N=(_-V|0)+1|0,E=yo(n,B,i[e+120>>2],0),Tf(w+16|0,X,B,N,(E-F|0)+1|0,i[s+20>>2],l[s+24|0],t),M=i[w+16>>2];f:{if(M){if(_=i[w+20>>2],i[A>>2]=i[w+16>>2],i[A+4>>2]=_,u[w+35|0]>=0){_=i[w+28>>2],i[Q>>2]=i[w+24>>2],i[Q+4>>2]=_,i[Q+8>>2]=i[w+32>>2],u[A+20|0]=1;break f}T(Q,i[w+24>>2],i[w+28>>2]),u[A+20|0]=1;break f}_=m,h=i[_>>2];A:{k:{if(!h)break k;for(;I=(B|0)>i[h+16>>2],_=I?_:h,h=i[(I?4:0)+h>>2],!!h;);if((_|0)==(m|0))break k;if((B|0)>=i[_+16>>2])break A}_=m}B=l[s+24|0],h=1;A:{if(B>>>0<9||(h=2,B>>>0<17)||(h=4,B>>>0<33))break A;h=B>>>0<65?8:16}if(F>>>0>E>>>0)break f;for(B=i[_+44>>2],I=i[_+56>>2],z=i[s+56>>2],_=G(h,N),V=i[s+44>>2]+G(h,V)|0,h=F;_&&x(G(I,h-F|0)+B|0,V+G(h,z)|0,_),h=h+1|0,E>>>0>=h>>>0;);}if(u[w+35|0]<0&&Z(i[w+24>>2]),M)break r;_=s,h=i[s+4>>2];f:{if(h){for(;;)if(s=h,h=i[s>>2],!h)break f}for(;s=i[_+8>>2],h=i[s>>2]!=(_|0),_=s,!!h;);}if((s|0)==(R|0))break}if(r=C[e+10>>1]|C[e+12>>1]<<16,i[w+16>>2]=C[e+6>>1]|C[e+8>>1]<<16,i[w+20>>2]=r,W[i[i[X>>2]+8>>2]](X,w+16|0),W[i[i[X>>2]+12>>2]](X,e+16|0),h=i[e+148>>2],r=i[e+152>>2],(h|0)!=(r|0))for(f=o+160|0,s=i[o+164>>2];;){f:{if(u0[o+168>>2]>s>>>0){if(e=i[h+4>>2],i[s>>2]=i[h>>2],i[s+4>>2]=e,e=s+8|0,u[h+19|0]>=0){k=i[h+12>>2],i[e>>2]=i[h+8>>2],i[e+4>>2]=k,i[e+8>>2]=i[h+16>>2],s=s+20|0;break f}T(e,i[h+8>>2],i[h+12>>2]),s=s+20|0;break f}s=fi(f,h)}if(i[o+164>>2]=s,h=h+20|0,(r|0)==(h|0))break}u[A+20|0]=0,i[A+4>>2]=o,i[A>>2]=X;break e}if(A=i[o+4>>2],i[o+4>>2]=A-1,A)break e;W[i[i[o>>2]+8>>2]](o),y(o)}v=w- -64|0;return}Q3(),H()}function If(A,e){var r=0,f=0,k=0,n=0,t=0,o=0,s=0;k=v-48|0,v=k;i:{r=i[e>>2],n=i[e+4>>2];e:{if((r|0)==(n|0)){u[A+20|0]=0,i[A+8>>2]=0,i[A>>2]=0,i[A+4>>2]=0;break e}r:{f:{if(o=n-1|0,!l[o|0]){if(t=(r^-1)+n|0,!t)break r;e=0;break f}e=p(32),i[k+12>>2]=e,i[k+16>>2]=30,i[k+20>>2]=-2147483616,r=l[16679]|l[16680]<<8|(l[16681]<<16|l[16682]<<24),f=l[16675]|l[16676]<<8|(l[16677]<<16|l[16678]<<24),u[e+22|0]=f,u[e+23|0]=f>>>8,u[e+24|0]=f>>>16,u[e+25|0]=f>>>24,u[e+26|0]=r,u[e+27|0]=r>>>8,u[e+28|0]=r>>>16,u[e+29|0]=r>>>24,r=l[16673]|l[16674]<<8|(l[16675]<<16|l[16676]<<24),f=l[16669]|l[16670]<<8|(l[16671]<<16|l[16672]<<24),u[e+16|0]=f,u[e+17|0]=f>>>8,u[e+18|0]=f>>>16,u[e+19|0]=f>>>24,u[e+20|0]=r,u[e+21|0]=r>>>8,u[e+22|0]=r>>>16,u[e+23|0]=r>>>24,r=l[16665]|l[16666]<<8|(l[16667]<<16|l[16668]<<24),f=l[16661]|l[16662]<<8|(l[16663]<<16|l[16664]<<24),u[e+8|0]=f,u[e+9|0]=f>>>8,u[e+10|0]=f>>>16,u[e+11|0]=f>>>24,u[e+12|0]=r,u[e+13|0]=r>>>8,u[e+14|0]=r>>>16,u[e+15|0]=r>>>24,r=l[16657]|l[16658]<<8|(l[16659]<<16|l[16660]<<24),f=l[16653]|l[16654]<<8|(l[16655]<<16|l[16656]<<24),u[e|0]=f,u[e+1|0]=f>>>8,u[e+2|0]=f>>>16,u[e+3|0]=f>>>24,u[e+4|0]=r,u[e+5|0]=r>>>8,u[e+6|0]=r>>>16,u[e+7|0]=r>>>24,u[e+30|0]=0,e=q(k+24|0,2,0,k+12|0),r=i[e+4>>2],i[A>>2]=i[e>>2],i[A+4>>2]=r,r=A+8|0;A:{if(u[e+19|0]>=0){f=i[e+12>>2],i[r>>2]=i[e+8>>2],i[r+4>>2]=f,i[r+8>>2]=i[e+16>>2],u[A+20|0]=1;break A}if(T(r,i[e+8>>2],i[e+12>>2]),r=u[e+19|0],u[A+20|0]=1,(r|0)>=0)break A;Z(i[e+8>>2])}if(u[k+23|0]>=0)break e;Z(i[k+12>>2]);break e}for(;;){if(l[e+r|0]){if(e=e+1|0,(t|0)!=(e|0))continue;break r}break}e=p(32),i[k+12>>2]=e,i[k+16>>2]=30,i[k+20>>2]=-2147483616,r=l[7031]|l[7032]<<8|(l[7033]<<16|l[7034]<<24),f=l[7027]|l[7028]<<8|(l[7029]<<16|l[7030]<<24),u[e+22|0]=f,u[e+23|0]=f>>>8,u[e+24|0]=f>>>16,u[e+25|0]=f>>>24,u[e+26|0]=r,u[e+27|0]=r>>>8,u[e+28|0]=r>>>16,u[e+29|0]=r>>>24,r=l[7025]|l[7026]<<8|(l[7027]<<16|l[7028]<<24),f=l[7021]|l[7022]<<8|(l[7023]<<16|l[7024]<<24),u[e+16|0]=f,u[e+17|0]=f>>>8,u[e+18|0]=f>>>16,u[e+19|0]=f>>>24,u[e+20|0]=r,u[e+21|0]=r>>>8,u[e+22|0]=r>>>16,u[e+23|0]=r>>>24,r=l[7017]|l[7018]<<8|(l[7019]<<16|l[7020]<<24),f=l[7013]|l[7014]<<8|(l[7015]<<16|l[7016]<<24),u[e+8|0]=f,u[e+9|0]=f>>>8,u[e+10|0]=f>>>16,u[e+11|0]=f>>>24,u[e+12|0]=r,u[e+13|0]=r>>>8,u[e+14|0]=r>>>16,u[e+15|0]=r>>>24,r=l[7009]|l[7010]<<8|(l[7011]<<16|l[7012]<<24),f=l[7005]|l[7006]<<8|(l[7007]<<16|l[7008]<<24),u[e|0]=f,u[e+1|0]=f>>>8,u[e+2|0]=f>>>16,u[e+3|0]=f>>>24,u[e+4|0]=r,u[e+5|0]=r>>>8,u[e+6|0]=r>>>16,u[e+7|0]=r>>>24,u[e+30|0]=0,e=q(k+24|0,2,0,k+12|0),r=i[e+4>>2],i[A>>2]=i[e>>2],i[A+4>>2]=r,r=A+8|0;f:{if(u[e+19|0]>=0){f=i[e+12>>2],i[r>>2]=i[e+8>>2],i[r+4>>2]=f,i[r+8>>2]=i[e+16>>2],u[A+20|0]=1;break f}if(T(r,i[e+8>>2],i[e+12>>2]),r=u[e+19|0],u[A+20|0]=1,(r|0)>=0)break f;Z(i[e+8>>2])}if(u[k+23|0]>=0)break e;Z(i[k+12>>2]);break e}if(f=o-r|0,f>>>0>=2147483640)break i;r:{if(f>>>0<=10){u[k+11|0]=f,e=k;break r}s=f|7,e=p(s+1|0),i[k+8>>2]=s-2147483647,i[k>>2]=e,i[k+4>>2]=f}r:{if((r|0)==(o|0))break r;if(n=(n-r|0)-2|0,t=t&7,t)for(f=0;u[e|0]=l[r|0],r=r+1|0,e=e+1|0,f=f+1|0,(t|0)!=(f|0););if(n>>>0<7)break r;for(;u[e|0]=l[r|0],u[e+1|0]=l[r+1|0],u[e+2|0]=l[r+2|0],u[e+3|0]=l[r+3|0],u[e+4|0]=l[r+4|0],u[e+5|0]=l[r+5|0],u[e+6|0]=l[r+6|0],u[e+7|0]=l[r+7|0],e=e+8|0,r=r+8|0,(o|0)!=(r|0););}u[e|0]=0,i[A+8>>2]=i[k+8>>2],e=i[k+4>>2],i[A>>2]=i[k>>2],i[A+4>>2]=e,u[A+20|0]=0}v=k+48|0;return}Q0(),H()}function l9(A,e,r){var f=0,k=0,n=0,t=0,o=0,s=0,w=0,h=0;f=v-80|0,v=f,i[f+40>>2]=0,i[f+44>>2]=0,i[f+48>>2]=0,i[f+52>>2]=0,u[f+55|0]=0,u[f+56|0]=0,u[f+57|0]=0,u[f+58|0]=0,i[f+32>>2]=0,i[f+36>>2]=0,i[f+60>>2]=0,i[f+64>>2]=0,i[f+72>>2]=0,u[f+68|0]=1,i[f+16>>2]=0,W[i[i[r>>2]+132>>2]](f+4|0,i[r+4>>2],f+28|0,f+24|0,f+20|0,f+16|0,0),k=i[f+28>>2];i:{if(!k)break i;for(t=e+6|0;;){if(s=l[k|0],Q9(t,k,i[f+24>>2]),Ue(f+32|0,i[f+28>>2],i[f+24>>2]),i[f+72>>2]=i[f+20>>2],n=i[r>>2],i[n>>2]<4|!i[n+136>>2]||(u[f+68|0]=i[f+16>>2]!=0),(s&120)==16)break i;if(i[f+16>>2]=0,W[i[n+132>>2]](f+4|0,i[r+4>>2],f+28|0,f+24|0,f+20|0,f+16|0,0),k=i[f+28>>2],!k)break}}i:{e:{r:{if(l[e+18|0]|l[e+5|0]!=1)break r;n=p(144),r=n,i[r+4>>2]=0,i[r+8>>2]=0,i[r>>2]=90524,s=r+16|0,r=s,i[r+8>>2]=0,i[r+12>>2]=0,i[r+16>>2]=0,i[r+20>>2]=0,i[r+24>>2]=0,i[r+28>>2]=0,i[r+32>>2]=0,i[r>>2]=86356,r=n,i[r+60>>2]=0,i[r+64>>2]=0,i[r+52>>2]=0,i[r+56>>2]=0,i[r+72>>2]=-1,i[r+76>>2]=-1,i[r+80>>2]=-1,i[r+84>>2]=-1,i[r+88>>2]=0,i[r+92>>2]=0,i[r+96>>2]=0,i[r+100>>2]=0,i[r+104>>2]=0,i[r+108>>2]=0,u[r+112|0]=0,i[s>>2]=98080,i[r+136>>2]=0,i[r+128>>2]=0,i[r+132>>2]=0,i[r+32>>2]=1635135811,k=l[e+10|0]|l[e+11|0]<<8|(l[e+12|0]<<16|l[e+13|0]<<24),t=l[e+6|0]|l[e+7|0]<<8|(l[e+8|0]<<16|l[e+9|0]<<24),u[r+113|0]=t,u[r+114|0]=t>>>8,u[r+115|0]=t>>>16,u[r+116|0]=t>>>24,u[r+117|0]=k,u[r+118|0]=k>>>8,u[r+119|0]=k>>>16,u[r+120|0]=k>>>24,k=l[e+14|0]|l[e+15|0]<<8|(l[e+16|0]<<16|l[e+17|0]<<24),u[r+121|0]=k,u[r+122|0]=k>>>8,u[r+123|0]=k>>>16,u[r+124|0]=k>>>24,i[r+4>>2]=i[r+4>>2]+1,k=i[f+36>>2],o=i[f+40>>2];f:{if(k>>>0<o>>>0){i[k+4>>2]=r,i[k>>2]=s,r=k+8|0;break f}if(t=i[f+32>>2],r=k-t|0,h=r>>3,k=h+1|0,k>>>0>=536870912)break e;if(o=o-t|0,w=o>>2,o=o>>>0>=2147483640?536870911:k>>>0<w>>>0?w:k,o){if(o>>>0>=536870912)break i;k=p(o<<3)}else k=0;if(w=k+r|0,i[w+4>>2]=n,i[w>>2]=s,s=w-(h<<3)|0,r&&x(s,t,r),i[f+40>>2]=k+(o<<3),r=w+8|0,i[f+36>>2]=r,i[f+32>>2]=s,!t)break f;Z(t)}if(i[f+36>>2]=r,u[e+18|0]=1,r=i[n+4>>2],i[n+4>>2]=r-1,r)break r;W[i[i[n>>2]+8>>2]](n),y(n)}u[f+57|0]=1,u[f+56|0]=l[e+68|0];r:{if(l[e+64|0]==1){if(n=i[e+20>>2],n){if(r=n,k=i[e+24>>2],(r|0)!=(k|0)){for(;;){r=i[k-4>>2];f:{if(!r||(t=i[r+4>>2],i[r+4>>2]=t-1,t))break f;W[i[i[r>>2]+8>>2]](r),y(r)}if(k=k-8|0,(n|0)==(k|0))break}r=i[e+20>>2]}i[e+24>>2]=n,Z(r)}i[e+20>>2]=i[f+32>>2],i[e+24>>2]=i[f+36>>2],i[e+28>>2]=i[f+40>>2],i[f+40>>2]=0,i[f+32>>2]=0,i[f+36>>2]=0,r=i[e+32>>2],r&&(i[e+36>>2]=r,Z(r)),i[e+32>>2]=i[f+44>>2],i[e+36>>2]=i[f+48>>2],i[e+40>>2]=i[f+52>>2],i[f+52>>2]=0,i[f+44>>2]=0,i[f+48>>2]=0,i[e+60>>2]=i[f+72>>2],r=i[f+68>>2],i[e+52>>2]=i[f+64>>2],i[e+56>>2]=r,r=i[f+60>>2],i[e+44>>2]=i[f+56>>2],i[e+48>>2]=r;break r}i[e+20>>2]=i[f+32>>2],i[e+24>>2]=i[f+36>>2],i[e+28>>2]=i[f+40>>2],i[f+40>>2]=0,i[f+32>>2]=0,i[f+36>>2]=0,i[e+32>>2]=i[f+44>>2],i[e+36>>2]=i[f+48>>2],i[e+40>>2]=i[f+52>>2],i[f+52>>2]=0,i[f+44>>2]=0,i[f+48>>2]=0,i[e+60>>2]=i[f+72>>2],r=i[f+68>>2],i[e+52>>2]=i[f+64>>2],i[e+56>>2]=r,r=i[f+60>>2],i[e+44>>2]=i[f+56>>2],i[e+48>>2]=r,u[e+64|0]=1}if(i[A>>2]=0,i[A+4>>2]=0,i[A+16>>2]=0,i[A+8>>2]=0,i[A+12>>2]=0,A=i[f+44>>2],A&&(i[f+48>>2]=A,Z(A)),A=i[f+32>>2],A){if(r=A,k=i[f+36>>2],(r|0)!=(k|0)){for(;;){e=i[k-4>>2];r:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break r;W[i[i[e>>2]+8>>2]](e),y(e)}if(k=k-8|0,(A|0)==(k|0))break}r=i[f+32>>2]}i[f+36>>2]=A,Z(r)}v=f+80|0;return}G0(),H()}z0(),H()}function s9(A,e,r){var f=0,k=0,n=0,t=0;k=v-160|0,v=k,f=i[r>>2],n=i[r+4>>2]-f|0;i:{if(n>>>0<=7){if(e=p(32),i[k+12>>2]=e,i[k+16>>2]=25,i[k+20>>2]=-2147483616,r=l[18855]|l[18856]<<8|(l[18857]<<16|l[18858]<<24),f=l[18851]|l[18852]<<8|(l[18853]<<16|l[18854]<<24),u[e|0]=f,u[e+1|0]=f>>>8,u[e+2|0]=f>>>16,u[e+3|0]=f>>>24,u[e+4|0]=r,u[e+5|0]=r>>>8,u[e+6|0]=r>>>16,u[e+7|0]=r>>>24,u[e+25|0]=0,u[e+24|0]=l[18875],r=l[18871]|l[18872]<<8|(l[18873]<<16|l[18874]<<24),f=l[18867]|l[18868]<<8|(l[18869]<<16|l[18870]<<24),u[e+16|0]=f,u[e+17|0]=f>>>8,u[e+18|0]=f>>>16,u[e+19|0]=f>>>24,u[e+20|0]=r,u[e+21|0]=r>>>8,u[e+22|0]=r>>>16,u[e+23|0]=r>>>24,r=l[18863]|l[18864]<<8|(l[18865]<<16|l[18866]<<24),f=l[18859]|l[18860]<<8|(l[18861]<<16|l[18862]<<24),u[e+8|0]=f,u[e+9|0]=f>>>8,u[e+10|0]=f>>>16,u[e+11|0]=f>>>24,u[e+12|0]=r,u[e+13|0]=r>>>8,u[e+14|0]=r>>>16,u[e+15|0]=r>>>24,q(A,2,118,k+12|0),u[k+23|0]>=0)break i;Z(i[k+12>>2]);break i}e:{r:{f:{if(t=l[f|0],t){i[k+104>>2]=0,i[k+76>>2]=72196,i[k+20>>2]=72176,e=i[18053],i[k+12>>2]=e,r=i[e-12>>2],e=k+12|0,i[r+e>>2]=i[18054],i[k+16>>2]=0,r=e+i[i[k+12>>2]-12>>2]|0,f=k+24|0,J0(r,f),u[r+80|0]=0,i[r+72>>2]=0,r=i[18055],i[k+20>>2]=r,n=i[r-12>>2],r=k+20|0,i[n+r>>2]=i[18056],n=i[18052],i[k+12>>2]=n,i[e+i[n-12>>2]>>2]=i[18057],i[k+76>>2]=72196,i[k+12>>2]=72156,i[k+20>>2]=72176,n=R0(f),i[n>>2]=71232,e=k- -64|0,i[e>>2]=0,i[e+4>>2]=0,i[k+56>>2]=0,i[k+60>>2]=0,i[k+72>>2]=24,Y(S0(Y(r,27990,19),t),16201,17),e=i[k+72>>2];A:{if(e&16){e=k+44|0,f=i[k+68>>2],r=i[k+48>>2],f>>>0<r>>>0?i[k+68>>2]=r:r=f;break A}if(!(e&8)){r=0,u[k+11|0]=0,e=k;break e}e=k+32|0,r=i[k+40>>2]}if(f=i[e>>2],r=r-f|0,r>>>0>=2147483640)break f;if(r>>>0>=11){t=r|7,e=p(t+1|0),i[k+8>>2]=t-2147483647,i[k>>2]=e,i[k+4>>2]=r;break r}if(u[k+11|0]=r,e=k,r)break r;r=0;break e}t=l[f+1|0],g[e>>1]=l[f+2|0]+1,g[e+2>>1]=l[f+3|0]+1,r=e;A:{if(t&1){if(n>>>0<=11){if(e=p(32),i[k+12>>2]=e,i[k+16>>2]=26,i[k+20>>2]=-2147483616,r=l[12161]|l[12162]<<8|(l[12163]<<16|l[12164]<<24),f=l[12157]|l[12158]<<8|(l[12159]<<16|l[12160]<<24),u[e|0]=f,u[e+1|0]=f>>>8,u[e+2|0]=f>>>16,u[e+3|0]=f>>>24,u[e+4|0]=r,u[e+5|0]=r>>>8,u[e+6|0]=r>>>16,u[e+7|0]=r>>>24,u[e+26|0]=0,r=l[12181]|l[12182]<<8,u[e+24|0]=r,u[e+25|0]=r>>>8,r=l[12177]|l[12178]<<8|(l[12179]<<16|l[12180]<<24),f=l[12173]|l[12174]<<8|(l[12175]<<16|l[12176]<<24),u[e+16|0]=f,u[e+17|0]=f>>>8,u[e+18|0]=f>>>16,u[e+19|0]=f>>>24,u[e+20|0]=r,u[e+21|0]=r>>>8,u[e+22|0]=r>>>16,u[e+23|0]=r>>>24,r=l[12169]|l[12170]<<8|(l[12171]<<16|l[12172]<<24),f=l[12165]|l[12166]<<8|(l[12167]<<16|l[12168]<<24),u[e+8|0]=f,u[e+9|0]=f>>>8,u[e+10|0]=f>>>16,u[e+11|0]=f>>>24,u[e+12|0]=r,u[e+13|0]=r>>>8,u[e+14|0]=r>>>16,u[e+15|0]=r>>>24,q(A,2,118,k+12|0),u[k+23|0]>=0)break i;Z(i[k+12>>2]);break i}n=e,e=l[f+4|0]|l[f+5|0]<<8|(l[f+6|0]<<16|l[f+7|0]<<24),i[n+4>>2]=e<<24|(e&65280)<<8|(e>>>8&65280|e>>>24),e=l[f+9|0]<<16|l[f+8|0]<<24|l[f+10|0]<<8,f=f+11|0;break A}i[e+4>>2]=l[f+5|0]|l[f+4|0]<<8,e=l[f+6|0]<<8,f=f+7|0}if(i[r+8>>2]=l[f|0]|e,e=i[26917],i[A>>2]=i[26916],i[A+4>>2]=e,A=A+8|0,u[107683]>=0){e=i[26919],i[A>>2]=i[26918],i[A+4>>2]=e,i[A+8>>2]=i[26920];break i}T(A,i[26918],i[26919]);break i}Q0(),H()}if(!r)break e;x(e,f,r)}u[e+r|0]=0,q(A,4,3002,k),u[k+11|0]<0&&Z(i[k>>2]),A=i[18051],i[k+12>>2]=A,i[i[A-12>>2]+(k+12|0)>>2]=i[18059],i[k+20>>2]=i[18060],i[n>>2]=71232,u[k+67|0]<0&&Z(i[k+56>>2]),E0(n),y0(k+76|0)}v=k+160|0}function Wv(A,e,r,f,k,n,t){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,t=t|0;var o=0,s=0,w=0,h=0,_=0,B=0;o=v-128|0,v=o,k=t+4|0,w=i[e+116>>2],n=i[t+4>>2];i:{e:{r:{if(!n){f=k;break r}for(_=k,f=n;B=w>>>0>u0[f+16>>2],_=B?_:f,f=i[(B?4:0)+f>>2],!!f;);if(!((k|0)==(_|0)|w>>>0<u0[_+16>>2])){f=p(32),i[o+32>>2]=f,i[o+36>>2]=28,i[o+40>>2]=-2147483616,e=l[5952]|l[5953]<<8|(l[5954]<<16|l[5955]<<24),u[f+24|0]=e,u[f+25|0]=e>>>8,u[f+26|0]=e>>>16,u[f+27|0]=e>>>24,r=l[5948]|l[5949]<<8|(l[5950]<<16|l[5951]<<24),e=l[5944]|l[5945]<<8|(l[5946]<<16|l[5947]<<24),u[f+16|0]=e,u[f+17|0]=e>>>8,u[f+18|0]=e>>>16,u[f+19|0]=e>>>24,u[f+20|0]=r,u[f+21|0]=r>>>8,u[f+22|0]=r>>>16,u[f+23|0]=r>>>24,r=l[5940]|l[5941]<<8|(l[5942]<<16|l[5943]<<24),e=l[5936]|l[5937]<<8|(l[5938]<<16|l[5939]<<24),u[f+8|0]=e,u[f+9|0]=e>>>8,u[f+10|0]=e>>>16,u[f+11|0]=e>>>24,u[f+12|0]=r,u[f+13|0]=r>>>8,u[f+14|0]=r>>>16,u[f+15|0]=r>>>24,r=l[5932]|l[5933]<<8|(l[5934]<<16|l[5935]<<24),e=l[5928]|l[5929]<<8|(l[5930]<<16|l[5931]<<24),u[f|0]=e,u[f+1|0]=e>>>8,u[f+2|0]=e>>>16,u[f+3|0]=e>>>24,u[f+4|0]=r,u[f+5|0]=r>>>8,u[f+6|0]=r>>>16,u[f+7|0]=r>>>24,u[f+28|0]=0,f=q(o- -64|0,2,0,o+32|0),e=i[f+4>>2],i[A>>2]=i[f>>2],i[A+4>>2]=e,r=A+8|0;f:{if(u[f+19|0]>=0){e=i[f+12>>2],i[r>>2]=i[f+8>>2],i[r+4>>2]=e,i[r+8>>2]=i[f+16>>2],u[A+20|0]=1;break f}if(T(r,i[f+8>>2],i[f+12>>2]),e=u[f+19|0],u[A+20|0]=1,(e|0)>=0)break f;Z(i[f+8>>2])}if(u[o+43|0]>=0)break i;Z(i[o+32>>2]);break i}for(;;){if(f=n,k=i[f+16>>2],k>>>0>w>>>0){if(k=f,n=i[f>>2],n)continue;break r}if(k>>>0>=w>>>0)break e;if(n=i[f+4>>2],!n)break}k=f+4|0}n=p(20),i[n+8>>2]=f,i[n>>2]=0,i[n+4>>2]=0,i[n+16>>2]=w,i[k>>2]=n,f=i[i[t>>2]>>2],f&&(i[t>>2]=f),m1(i[t+4>>2],n),i[t+8>>2]=i[t+8>>2]+1}u[o+72|0]=0,i[o+84>>2]=0,i[o+88>>2]=0,i[o+104>>2]=0,i[o+96>>2]=0,i[o+100>>2]=0,i[o+64>>2]=0,i[o+68>>2]=0,i[o+76>>2]=0,i[o+80>>2]=0,f=i[e+100>>2],i[o+56>>2]=i[f+48>>2],f=i[f+52>>2],i[o+60>>2]=f,f&&(i[f+4>>2]=i[f+4>>2]+1),k=i[e+116>>2],f=i[o+60>>2],i[o>>2]=i[o+56>>2],i[o+4>>2]=f,Ku(o- -64|0,o,k),W[i[i[e>>2]+112>>2]](o+32|0,e);e:{r:switch(l[o+52|0]){default:_2(),H();case 1:e=i[o+36>>2],i[A>>2]=i[o+32>>2],i[A+4>>2]=e,r=A+8|0;f:{if(u[o+51|0]>=0){e=i[o+44>>2],i[r>>2]=i[o+40>>2],i[r+4>>2]=e,i[r+8>>2]=i[o+48>>2];break f}T(r,i[o+40>>2],i[o+44>>2])}u[A+20|0]=1;break e;case 0:break r}s=i[o+32>>2],h=i[o+36>>2],h&&(i[h+4>>2]=i[h+4>>2]+1),i[o+24>>2]=i[o+104>>2],f=i[o+100>>2],i[o+16>>2]=i[o+96>>2],i[o+20>>2]=f,f=i[o+92>>2],i[o+8>>2]=i[o+88>>2],i[o+12>>2]=f,B=i[o+68>>2],f=i[o+64>>2],i[o+64>>2]=0,i[o+68>>2]=0,_=i[o+76>>2],t=i[o+80>>2],i[o+76>>2]=0,i[o+80>>2]=0,n=i[o+84>>2],i[o+84>>2]=0,k=l[o+72|0],i[s+8>>2]=f,w=i[s+12>>2],i[s+12>>2]=B;r:{if(!w||(f=i[w+4>>2],i[w+4>>2]=f-1,f))break r;W[i[i[w>>2]+8>>2]](w),y(w)}if(u[s+16|0]=k,f=i[s+20>>2],f&&(i[s+24>>2]=f,Z(f)),i[s+28>>2]=n,i[s+24>>2]=t,i[s+20>>2]=_,f=i[o+12>>2],i[s+32>>2]=i[o+8>>2],i[s+36>>2]=f,f=i[o+20>>2],i[s+40>>2]=i[o+16>>2],i[s+44>>2]=f,i[s+48>>2]=i[o+24>>2],W[i[i[s>>2]+28>>2]](A,s,r,i[e+100>>2]- -64|0),!h||(A=i[h+4>>2],i[h+4>>2]=A-1,A))break e;W[i[i[h>>2]+8>>2]](h),y(h)}if(e=l[o+52|0],(e|0)!=255&&(A=i[25177],i[o+120>>2]=i[25176],i[o+124>>2]=A,W[i[(o+120|0)+(e<<2)>>2]](o+119|0,o+32|0)),A=i[o+76>>2],A&&(i[o+80>>2]=A,Z(A)),e=i[o+68>>2],!e||(A=i[e+4>>2],i[e+4>>2]=A-1,A))break i;W[i[i[e>>2]+8>>2]](e),y(e)}v=o+128|0}function Cf(A){var e=0,r=0,f=0,k=0,n=0,t=0,o=0;l[129744]||(f=v-16|0,v=f,l[129736]||(k=v-16|0,v=k,i[k+12>>2]=1,i[32395]=i[k+12>>2]-1,i[32394]=84672,i[32394]=79472,i[32394]=77992,e=v-16|0,v=e,i[32396]=0,i[32397]=0,i[e+12>>2]=0,i[32398]=0,u[129716]=0,i[e+4>>2]=129584,u[e+10|0]=0,r=v-16|0,v=r,Po()>>>0<30&&(Z4(),H()),wl(r+8|0,129596,30),n=i[r+8>>2],i[32397]=n,i[32396]=n,i[32398]=(i[r+12>>2]<<2)+n,v=r+16|0,Qo(30),u[e+10|0]=1,v=e+16|0,oe(129720,20051),fw(129584),i[32752]=0,i[32751]=84672,i[32751]=79472,i[32751]=80584,v1(131004,l1(129408)),i[32754]=0,i[32753]=84672,i[32753]=79472,i[32753]=80616,v1(131012,l1(129416)),i[32756]=0,i[32755]=84672,i[32755]=79472,u[131032]=0,i[32757]=0,i[32755]=78012,i[32757]=78064,v1(131020,l1(129760)),i[32760]=0,i[32759]=84672,i[32759]=79472,i[32759]=79528,v1(131036,l1(129752)),i[32762]=0,i[32761]=84672,i[32761]=79472,i[32761]=79680,v1(131044,l1(129768)),i[32764]=0,i[32763]=84672,i[32763]=79472,i[32763]=79096,t=131060,o=a2(),i[t>>2]=o,v1(131052,l1(129776)),i[32767]=0,i[32766]=84672,i[32766]=79472,i[32766]=79828,v1(131064,l1(129784)),i[32769]=0,i[32768]=84672,i[32768]=79472,i[32768]=80060,v1(131072,l1(129800)),i[32771]=0,i[32770]=84672,i[32770]=79472,i[32770]=79944,v1(131080,l1(129792)),i[32773]=0,i[32772]=84672,i[32772]=79472,i[32772]=80176,v1(131088,l1(129808)),i[32775]=0,i[32774]=84672,i[32774]=79472,g[65552]=11310,i[32774]=79144,e=v-16|0,v=e,i[32777]=0,i[32778]=0,i[32779]=0,v=e+16|0,v1(131096,l1(129816)),i[32781]=0,i[32780]=84672,i[32780]=79472,i[32782]=46,i[32783]=44,i[32780]=79184,e=v-16|0,v=e,i[32784]=0,i[32785]=0,i[32786]=0,v=e+16|0,v1(131120,l1(129824)),i[32788]=0,i[32787]=84672,i[32787]=79472,i[32787]=80648,v1(131148,l1(129424)),i[32790]=0,i[32789]=84672,i[32789]=79472,i[32789]=80896,v1(131156,l1(129432)),i[32792]=0,i[32791]=84672,i[32791]=79472,i[32791]=81108,v1(131164,l1(129440)),i[32794]=0,i[32793]=84672,i[32793]=79472,i[32793]=81344,v1(131172,l1(129448)),i[32796]=0,i[32795]=84672,i[32795]=79472,i[32795]=82340,v1(131180,l1(129488)),i[32798]=0,i[32797]=84672,i[32797]=79472,i[32797]=82488,v1(131188,l1(129496)),i[32800]=0,i[32799]=84672,i[32799]=79472,i[32799]=82604,v1(131196,l1(129504)),i[32802]=0,i[32801]=84672,i[32801]=79472,i[32801]=82720,v1(131204,l1(129512)),i[32804]=0,i[32803]=84672,i[32803]=79472,i[32803]=82836,v1(131212,l1(129520)),i[32806]=0,i[32805]=84672,i[32805]=79472,i[32805]=83004,v1(131220,l1(129528)),i[32808]=0,i[32807]=84672,i[32807]=79472,i[32807]=83172,v1(131228,l1(129536)),i[32810]=0,i[32809]=84672,i[32809]=79472,i[32809]=83340,v1(131236,l1(129544)),i[32812]=0,i[32811]=84672,i[32811]=79472,i[32813]=84600,i[32811]=81544,i[32813]=81592,v1(131244,l1(129456)),i[32815]=0,i[32814]=84672,i[32814]=79472,i[32816]=84636,i[32814]=81812,i[32816]=81860,v1(131256,l1(129464)),i[32818]=0,i[32817]=84672,i[32817]=79472,Vs(131276),i[32817]=82052,v1(131268,l1(129472)),i[32821]=0,i[32820]=84672,i[32820]=79472,Vs(131288),i[32820]=82212,v1(131280,l1(129480)),i[32824]=0,i[32823]=84672,i[32823]=79472,i[32823]=83508,v1(131292,l1(129552)),i[32826]=0,i[32825]=84672,i[32825]=79472,i[32825]=83628,v1(131300,l1(129560)),v=k+16|0,i[f+8>>2]=129576,i[32433]=i[f+8>>2],u[129736]=1),v=f+16|0,e=i[32433],i[32435]=e,(e|0)!=129576&&(i[e+4>>2]=i[e+4>>2]+1),u[129744]=1),e=A,A=i[32435],i[e>>2]=A,(A|0)!=129576&&(i[A+4>>2]=i[A+4>>2]+1)}function Qv(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,t=0,o=0,s=0;f=v-160|0,v=f,i[f+92>>2]=0,i[f+64>>2]=72500,n=i[18128],i[f+8>>2]=n,k=i[n-12>>2],n=f+8|0,i[k+n>>2]=i[18129],k=n+i[i[f+8>>2]-12>>2]|0,t=f+12|0,J0(k,t),u[k+80|0]=0,i[k+72>>2]=0,i[f+64>>2]=72500,i[f+8>>2]=72480,s=R0(t),i[s>>2]=71232,i[f+52>>2]=0,i[f+56>>2]=0,i[f+44>>2]=0,i[f+48>>2]=0,i[f+60>>2]=16,k=f+148|0,Y2(k,e,r),o=n,t=k,n=u[f+159|0],k=(n|0)<0,Y(o,k?i[f+148>>2]:t,k?i[f+152>>2]:n),u[f+159|0]<0&&Z(i[f+148>>2]),n=f+148|0,s0(n,r),o=n,n=u[f+159|0],k=(n|0)<0,Y(f+8|0,k?i[f+148>>2]:o,k?i[f+152>>2]:n),u[f+159|0]<0&&Z(i[f+148>>2]),n=Y(S0(Y(f+8|0,30776,9),l[e+97|0]),42670,1),k=f+148|0,s0(k,r),o=k,k=u[f+159|0],t=(k|0)<0,Y(n,t?i[f+148>>2]:o,t?i[f+152>>2]:k),u[f+159|0]<0&&Z(i[f+148>>2]),n=Y(S0(Y(n,31861,13),l[e+98|0]),42670,1),k=f+148|0,s0(k,r),o=k,k=u[f+159|0],t=(k|0)<0,Y(n,t?i[f+148>>2]:o,t?i[f+152>>2]:k),u[f+159|0]<0&&Z(i[f+148>>2]),n=Y(S0(Y(n,32655,17),l[e+99|0]),42670,1),k=f+148|0,s0(k,r),o=k,k=u[f+159|0],t=(k|0)<0,Y(n,t?i[f+148>>2]:o,t?i[f+152>>2]:k),u[f+159|0]<0&&Z(i[f+148>>2]),n=Y(S0(Y(n,30950,15),l[e+101|0]),42670,1),k=f+148|0,s0(k,r),o=k,k=u[f+159|0],t=(k|0)<0,Y(n,t?i[f+148>>2]:o,t?i[f+152>>2]:k),u[f+159|0]<0&&Z(i[f+148>>2]),n=Y(S0(Y(n,29661,12),l[e+102|0]),42670,1),k=f+148|0,s0(k,r),o=k,k=u[f+159|0],t=(k|0)<0,Y(n,t?i[f+148>>2]:o,t?i[f+152>>2]:k),u[f+159|0]<0&&Z(i[f+148>>2]),n=Y(S0(Y(n,31786,12),l[e+103|0]),42670,1),k=f+148|0,s0(k,r),o=k,k=u[f+159|0],t=(k|0)<0,Y(n,t?i[f+148>>2]:o,t?i[f+152>>2]:k),u[f+159|0]<0&&Z(i[f+148>>2]),n=Y(S0(Y(n,29551,22),l[e+104|0]),42670,1),k=f+148|0,s0(k,r),o=k,k=u[f+159|0],t=(k|0)<0,Y(n,t?i[f+148>>2]:o,t?i[f+152>>2]:k),u[f+159|0]<0&&Z(i[f+148>>2]),n=Y(S0(Y(n,29294,22),l[e+105|0]),42670,1),k=f+148|0,s0(k,r),o=k,k=u[f+159|0],t=(k|0)<0,Y(n,t?i[f+148>>2]:o,t?i[f+152>>2]:k),u[f+159|0]<0&&Z(i[f+148>>2]),n=Y(S0(Y(n,30548,24),l[e+106|0]),42670,1),k=f+148|0,s0(k,r),o=k,k=u[f+159|0],t=(k|0)<0,Y(n,t?i[f+148>>2]:o,t?i[f+152>>2]:k),u[f+159|0]<0&&Z(i[f+148>>2]),Y(n,29247,28);i:{if(l[e+107|0]){Y(S0(f+8|0,l[e+108|0]+1|0),42670,1);break i}Y(f+8|0,32855,12)}if(n=f+148|0,s0(n,r),k=0,o=n,r=u[f+159|0],n=(r|0)<0,Y(f+8|0,n?i[f+148>>2]:o,n?i[f+152>>2]:r),u[f+159|0]<0&&Z(i[f+148>>2]),Y(f+8|0,21054,12),i[e+116>>2]!=i[e+112>>2])for(;n=Y(f+8|0,32808,1),t=i[n>>2],r=t-12|0,o=i[r>>2]+n|0,i[o+4>>2]=i[o+4>>2]&-75|8,r=n+i[r>>2]|0,l[r+80|0]||(o=f+148|0,t=i[r+28>>2],i[o>>2]=t,(t|0)!=129576&&(i[t+4>>2]=i[t+4>>2]+1),t=c0(o,129760),W[i[i[t>>2]+28>>2]](t,32)|0,e2(o),t=i[n>>2]),u[r+76|0]=48,u[r+77|0]=0,u[r+78|0]=0,u[r+79|0]=0,u[r+80|0]=1,i[(n+i[t-12>>2]|0)+12>>2]=2,S0(n,l[i[e+112>>2]+k|0]),k=k+1|0,k>>>0<i[e+116>>2]-i[e+112>>2]>>>0;);e=f+8|0,r=e+i[i[f+8>>2]-12>>2]|0,i[r+4>>2]=i[r+4>>2]&-75|2,Y(e,42670,1),e=i[f+60>>2];i:{e:{if(e&16){r=i[f+56>>2],e=i[f+36>>2],r>>>0<e>>>0&&(i[f+56>>2]=e,r=e),e=f+32|0;break e}if(!(e&8)){r=0,u[A+11|0]=0;break i}r=i[f+28>>2],e=f+20|0}e:{if(n=i[e>>2],r=r-n|0,r>>>0<2147483640){if(r>>>0>=11){k=r|7,e=p(k+1|0),i[A+8>>2]=k-2147483647,i[A>>2]=e,i[A+4>>2]=r,A=e;break e}if(u[A+11|0]=r,r)break e;r=0;break i}Q0(),H()}if(!r)break i;x(A,n,r)}u[A+r|0]=0,A=i[18127],i[f+8>>2]=A,i[i[A-12>>2]+(f+8|0)>>2]=i[18130],i[s>>2]=71232,u[f+55|0]<0&&Z(i[f+44>>2]),E0(s),y0(f- -64|0),v=f+160|0}function H8(A,e,r,f,k,n,t,o,s,w){var h=0,_=0,B=0,m=0,X=0,Q=0,V=0,F=0,I=0,E=0,R=0;h=s<<2,m=i[h+62784>>2]+n|0,h=i[h+62768>>2],X=m+h|0,V=w-8|0,w=i[(o<<2)+62768>>2];i:{e:switch(o|0){case 0:if(B=0-h|0,(m|0)<=(B|0)|(k|0)<=0)break i;for(F=(h<<1)+t|0,I=r-(w<<1)|0,E=k&2147483644,Q=k&3,R=k>>>0<4;;){if(w=(B<<1)+F|0,h=(G(f,B)<<1)+I|0,_=0,!R)for(;g[w>>1]=C[h>>1],r=X<<1,w=r+w|0,g[w>>1]=C[h+2>>1],w=r+w|0,g[w>>1]=C[h+4>>1],w=r+w|0,g[w>>1]=C[h+6>>1],w=r+w|0,h=h+8|0,_=_+4|0,(E|0)!=(_|0););if(r=0,Q)for(;g[w>>1]=C[h>>1],h=h+2|0,w=(X<<1)+w|0,r=r+1|0,(Q|0)!=(r|0););if(B=B+1|0,(m|0)==(B|0))break}break i;case 1:if(_=0-h|0,(m|0)<=(_|0)|(k|0)<=0)break i;for(B=(h<<1)+t|0,Q=r-(w<<1)|0;;){for(w=B+(_<<1)|0,h=Q+(G(f,_)<<1)|0,r=0;g[w>>1]=C[h+12>>1]+((((((C[h+2>>1]<<2)-C[h>>1]|0)+G(C[h+4>>1],-10)|0)+G(C[h+6>>1],58)|0)+G(C[h+8>>1],17)|0)+G(C[h+10>>1],-5)|0)>>V,h=h+2|0,w=(X<<1)+w|0,r=r+1|0,(k|0)!=(r|0););if(_=_+1|0,(m|0)==(_|0))break}break i;case 2:if(_=0-h|0,(m|0)<=(_|0)|(k|0)<=0)break i;for(B=(h<<1)+t|0,Q=r-(w<<1)|0;;){for(w=B+(_<<1)|0,h=Q+(G(f,_)<<1)|0,r=0;g[w>>1]=(((((C[h+2>>1]<<2)-C[h>>1]|0)+G(C[h+8>>1]+C[h+6>>1]|0,40)|0)+(C[h+12>>1]<<2)|0)-C[h+14>>1]|0)+G(C[h+10>>1]+C[h+4>>1]|0,-11)>>V,h=h+2|0,w=(X<<1)+w|0,r=r+1|0,(k|0)!=(r|0););if(_=_+1|0,(m|0)==(_|0))break}break i;case 3:break e;default:break i}if(_=0-h|0,(m|0)<=(_|0)|(k|0)<=0)break i;for(B=(h<<1)+t|0,Q=r-(w<<1)|0;;){for(w=B+(_<<1)|0,h=Q+(G(f,_)<<1)|0,r=0;g[w>>1]=(((((C[h>>1]+G(C[h+2>>1],-5)|0)+G(C[h+4>>1],17)|0)+G(C[h+6>>1],58)|0)+G(C[h+8>>1],-10)|0)+(C[h+10>>1]<<2)|0)-C[h+12>>1]>>V,h=h+2|0,w=(X<<1)+w|0,r=r+1|0,(k|0)!=(r|0););if(_=_+1|0,(m|0)==(_|0))break}}f=o?6:V;i:{e:switch(s|0){case 3:if((k|0)<=0|(n|0)<=0)break i;for(_=0;;){for(w=(_<<1)+A|0,h=(G(_,X)<<1)+t|0,r=0;g[w>>1]=(((((g[h>>1]+G(g[h+2>>1],-5)|0)+G(g[h+4>>1],17)|0)+G(g[h+6>>1],58)|0)+G(g[h+8>>1],-10)|0)+(g[h+10>>1]<<2)|0)-g[h+12>>1]>>f,h=h+2|0,w=(e<<1)+w|0,r=r+1|0,(n|0)!=(r|0););if(_=_+1|0,(_|0)==(k|0))break}break i;case 2:if((k|0)<=0|(n|0)<=0)break i;for(_=0;;){for(w=(_<<1)+A|0,h=(G(_,X)<<1)+t|0,r=0;g[w>>1]=(((((g[h+2>>1]<<2)-g[h>>1]|0)+G(g[h+8>>1]+g[h+6>>1]|0,40)|0)+(g[h+12>>1]<<2)|0)-g[h+14>>1]|0)+G(g[h+10>>1]+g[h+4>>1]|0,-11)>>f,h=h+2|0,w=(e<<1)+w|0,r=r+1|0,(n|0)!=(r|0););if(_=_+1|0,(_|0)==(k|0))break}break i;case 1:if((k|0)<=0)break i;for(_=0,o=(n|0)<=0;;){if(!o)for(w=(_<<1)+A|0,h=(G(_,X)<<1)+t|0,r=0;g[w>>1]=g[h+12>>1]+((((((g[h+2>>1]<<2)-g[h>>1]|0)+G(g[h+4>>1],-10)|0)+G(g[h+6>>1],58)|0)+G(g[h+8>>1],17)|0)+G(g[h+10>>1],-5)|0)>>f,h=h+2|0,w=(e<<1)+w|0,r=r+1|0,(n|0)!=(r|0););if(_=_+1|0,(_|0)==(k|0))break}break i;case 0:break e;default:break i}if((k|0)<=0)break i;for(_=n&2147483644,s=n&3,f=0,m=(n|0)<=0;;){e:{if(m)break e;if(w=(f<<1)+A|0,h=(G(f,X)<<1)+t|0,r=0,n>>>0>3)for(;g[w>>1]=C[h>>1],o=e<<1,w=o+w|0,g[w>>1]=C[h+2>>1],w=o+w|0,g[w>>1]=C[h+4>>1],w=o+w|0,g[w>>1]=C[h+6>>1],w=o+w|0,h=h+8|0,r=r+4|0,(_|0)!=(r|0););if(r=0,!s)break e;for(;g[w>>1]=C[h>>1],h=h+2|0,w=(e<<1)+w|0,r=r+1|0,(s|0)!=(r|0););}if(f=f+1|0,(k|0)==(f|0))break}}}function gv(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0;var k=0,n=0,t=0,o=0,s=0,w=0,h=0,_=0,B=0,m=0;k=v-192|0,v=k,z2(k+172|0,e,r),u[k+191|0]<0&&Z(i[k+180>>2]);i:{e:{r:{if(l[e+97|0]){t1(A,e,1104);break r}B=e,m=C0(r),i[B+104>>2]=m,n=C0(r),i[e+108>>2]=n;f:{if(i[e+104>>2])break f;if(n>>>0>u0[f+80>>2]){if(e=p(64),i[k+24>>2]=e,i[k+28>>2]=61,i[k+32>>2]=-2147483584,r=l[17289]|l[17290]<<8|(l[17291]<<16|l[17292]<<24),f=l[17285]|l[17286]<<8|(l[17287]<<16|l[17288]<<24),u[e|0]=f,u[e+1|0]=f>>>8,u[e+2|0]=f>>>16,u[e+3|0]=f>>>24,u[e+4|0]=r,u[e+5|0]=r>>>8,u[e+6|0]=r>>>16,u[e+7|0]=r>>>24,u[e+61|0]=0,r=l[17342]|l[17343]<<8|(l[17344]<<16|l[17345]<<24),f=l[17338]|l[17339]<<8|(l[17340]<<16|l[17341]<<24),u[e+53|0]=f,u[e+54|0]=f>>>8,u[e+55|0]=f>>>16,u[e+56|0]=f>>>24,u[e+57|0]=r,u[e+58|0]=r>>>8,u[e+59|0]=r>>>16,u[e+60|0]=r>>>24,r=l[17337]|l[17338]<<8|(l[17339]<<16|l[17340]<<24),f=l[17333]|l[17334]<<8|(l[17335]<<16|l[17336]<<24),u[e+48|0]=f,u[e+49|0]=f>>>8,u[e+50|0]=f>>>16,u[e+51|0]=f>>>24,u[e+52|0]=r,u[e+53|0]=r>>>8,u[e+54|0]=r>>>16,u[e+55|0]=r>>>24,r=l[17329]|l[17330]<<8|(l[17331]<<16|l[17332]<<24),f=l[17325]|l[17326]<<8|(l[17327]<<16|l[17328]<<24),u[e+40|0]=f,u[e+41|0]=f>>>8,u[e+42|0]=f>>>16,u[e+43|0]=f>>>24,u[e+44|0]=r,u[e+45|0]=r>>>8,u[e+46|0]=r>>>16,u[e+47|0]=r>>>24,r=l[17321]|l[17322]<<8|(l[17323]<<16|l[17324]<<24),f=l[17317]|l[17318]<<8|(l[17319]<<16|l[17320]<<24),u[e+32|0]=f,u[e+33|0]=f>>>8,u[e+34|0]=f>>>16,u[e+35|0]=f>>>24,u[e+36|0]=r,u[e+37|0]=r>>>8,u[e+38|0]=r>>>16,u[e+39|0]=r>>>24,r=l[17313]|l[17314]<<8|(l[17315]<<16|l[17316]<<24),f=l[17309]|l[17310]<<8|(l[17311]<<16|l[17312]<<24),u[e+24|0]=f,u[e+25|0]=f>>>8,u[e+26|0]=f>>>16,u[e+27|0]=f>>>24,u[e+28|0]=r,u[e+29|0]=r>>>8,u[e+30|0]=r>>>16,u[e+31|0]=r>>>24,r=l[17305]|l[17306]<<8|(l[17307]<<16|l[17308]<<24),f=l[17301]|l[17302]<<8|(l[17303]<<16|l[17304]<<24),u[e+16|0]=f,u[e+17|0]=f>>>8,u[e+18|0]=f>>>16,u[e+19|0]=f>>>24,u[e+20|0]=r,u[e+21|0]=r>>>8,u[e+22|0]=r>>>16,u[e+23|0]=r>>>24,r=l[17297]|l[17298]<<8|(l[17299]<<16|l[17300]<<24),f=l[17293]|l[17294]<<8|(l[17295]<<16|l[17296]<<24),u[e+8|0]=f,u[e+9|0]=f>>>8,u[e+10|0]=f>>>16,u[e+11|0]=f>>>24,u[e+12|0]=r,u[e+13|0]=r>>>8,u[e+14|0]=r>>>16,u[e+15|0]=r>>>24,q(A,6,1e3,k+24|0),u[k+35|0]>=0)break r;Z(i[k+24>>2]);break r}if(q4(A,e+124|0,n<<2,f,13681),i[A>>2])break r;if(u[A+19|0]<0&&Z(i[A+8>>2]),!i[e+108>>2])break f;for(;;){if(!i[r+16>>2]){r=hA(k+24|0),Y(V0(Y(V0(Y(r+8|0,28068,24),i[e+108>>2]),28927,33),h),5504,8),e=k+12|0,QA(e,r),q(A,2,100,e),u[k+23|0]<0&&Z(i[k+12>>2]),H6(r);break r}s=C0(r),f=i[e+116>>2],t=i[e+120>>2];A:{if(f>>>0<t>>>0){i[f>>2]=s,f=f+4|0;break A}if(w=i[e+112>>2],f=f-w|0,_=f>>2,n=_+1|0,n>>>0>=1073741824)break e;if(t=t-w|0,o=t>>1,t=t>>>0>=2147483644?1073741823:n>>>0<o>>>0?o:n,t){if(t>>>0>=1073741824)break i;n=p(t<<2)}else n=0;if(o=n+f|0,i[o>>2]=s,s=o-(_<<2)|0,f&&x(s,w,f),i[e+120>>2]=n+(t<<2),f=o+4|0,i[e+116>>2]=f,i[e+112>>2]=s,!w)break A;Z(w)}if(i[e+116>>2]=f,l[r+20|0]==1){du(A,r);break r}if(h=h+1|0,!(h>>>0<u0[e+108>>2]))break}}if(l[r+20|0]==1){if(u[k+24|0]=0,u[k+35|0]=0,q(A,2,100,k+24|0),u[k+35|0]>=0)break r;Z(i[k+24>>2]);break r}if(e=i[26917],i[A>>2]=i[26916],i[A+4>>2]=e,A=A+8|0,u[107683]>=0){e=i[26919],i[A>>2]=i[26918],i[A+4>>2]=e,i[A+8>>2]=i[26920];break r}T(A,i[26918],i[26919])}v=k+192|0;return}G0(),H()}z0(),H()}function Vv(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0;var k=0,n=0,t=0,o=0,s=0,w=0;k=v-16|0,v=k;i:{e:{if(!(i[e+8>>2]|i[e+12>>2])){if(e=p(48),i[k+4>>2]=e,i[k+8>>2]=44,i[k+12>>2]=-2147483600,r=l[16369]|l[16370]<<8|(l[16371]<<16|l[16372]<<24),f=l[16365]|l[16366]<<8|(l[16367]<<16|l[16368]<<24),u[e|0]=f,u[e+1|0]=f>>>8,u[e+2|0]=f>>>16,u[e+3|0]=f>>>24,u[e+4|0]=r,u[e+5|0]=r>>>8,u[e+6|0]=r>>>16,u[e+7|0]=r>>>24,u[e+44|0]=0,r=l[16405]|l[16406]<<8|(l[16407]<<16|l[16408]<<24),u[e+40|0]=r,u[e+41|0]=r>>>8,u[e+42|0]=r>>>16,u[e+43|0]=r>>>24,r=l[16401]|l[16402]<<8|(l[16403]<<16|l[16404]<<24),f=l[16397]|l[16398]<<8|(l[16399]<<16|l[16400]<<24),u[e+32|0]=f,u[e+33|0]=f>>>8,u[e+34|0]=f>>>16,u[e+35|0]=f>>>24,u[e+36|0]=r,u[e+37|0]=r>>>8,u[e+38|0]=r>>>16,u[e+39|0]=r>>>24,r=l[16393]|l[16394]<<8|(l[16395]<<16|l[16396]<<24),f=l[16389]|l[16390]<<8|(l[16391]<<16|l[16392]<<24),u[e+24|0]=f,u[e+25|0]=f>>>8,u[e+26|0]=f>>>16,u[e+27|0]=f>>>24,u[e+28|0]=r,u[e+29|0]=r>>>8,u[e+30|0]=r>>>16,u[e+31|0]=r>>>24,r=l[16385]|l[16386]<<8|(l[16387]<<16|l[16388]<<24),f=l[16381]|l[16382]<<8|(l[16383]<<16|l[16384]<<24),u[e+16|0]=f,u[e+17|0]=f>>>8,u[e+18|0]=f>>>16,u[e+19|0]=f>>>24,u[e+20|0]=r,u[e+21|0]=r>>>8,u[e+22|0]=r>>>16,u[e+23|0]=r>>>24,r=l[16377]|l[16378]<<8|(l[16379]<<16|l[16380]<<24),f=l[16373]|l[16374]<<8|(l[16375]<<16|l[16376]<<24),u[e+8|0]=f,u[e+9|0]=f>>>8,u[e+10|0]=f>>>16,u[e+11|0]=f>>>24,u[e+12|0]=r,u[e+13|0]=r>>>8,u[e+14|0]=r>>>16,u[e+15|0]=r>>>24,q(A,4,0,k+4|0),u[k+15|0]>=0)break e;Z(i[k+4>>2]);break e}if(o=i[f+40>>2],f=i[f+44>>2],t=i[r+16>>2],!(!(o|f)|(!f&t>>>0<=o>>>0|(f|0)!=0))){if(e=p(32),i[k+4>>2]=e,i[k+8>>2]=31,i[k+12>>2]=-2147483616,r=l[11591]|l[11592]<<8|(l[11593]<<16|l[11594]<<24),f=l[11587]|l[11588]<<8|(l[11589]<<16|l[11590]<<24),u[e|0]=f,u[e+1|0]=f>>>8,u[e+2|0]=f>>>16,u[e+3|0]=f>>>24,u[e+4|0]=r,u[e+5|0]=r>>>8,u[e+6|0]=r>>>16,u[e+7|0]=r>>>24,u[e+31|0]=0,r=l[11614]|l[11615]<<8|(l[11616]<<16|l[11617]<<24),f=l[11610]|l[11611]<<8|(l[11612]<<16|l[11613]<<24),u[e+23|0]=f,u[e+24|0]=f>>>8,u[e+25|0]=f>>>16,u[e+26|0]=f>>>24,u[e+27|0]=r,u[e+28|0]=r>>>8,u[e+29|0]=r>>>16,u[e+30|0]=r>>>24,r=l[11607]|l[11608]<<8|(l[11609]<<16|l[11610]<<24),f=l[11603]|l[11604]<<8|(l[11605]<<16|l[11606]<<24),u[e+16|0]=f,u[e+17|0]=f>>>8,u[e+18|0]=f>>>16,u[e+19|0]=f>>>24,u[e+20|0]=r,u[e+21|0]=r>>>8,u[e+22|0]=r>>>16,u[e+23|0]=r>>>24,r=l[11599]|l[11600]<<8|(l[11601]<<16|l[11602]<<24),f=l[11595]|l[11596]<<8|(l[11597]<<16|l[11598]<<24),u[e+8|0]=f,u[e+9|0]=f>>>8,u[e+10|0]=f>>>16,u[e+11|0]=f>>>24,u[e+12|0]=r,u[e+13|0]=r>>>8,u[e+14|0]=r>>>16,u[e+15|0]=r>>>24,q(A,2,0,k+4|0),u[k+15|0]>=0)break e;Z(i[k+4>>2]);break e}n=i[e+104>>2],f=i[e+100>>2],o=n-f|0;r:{if(o>>>0<t>>>0){if(w=t-o|0,s=i[e+108>>2],w>>>0<=s-n>>>0){w&&o0(n,0,w),i[e+104>>2]=n+w;break r}if((t|0)<0)break i;if(n=s-f|0,s=n<<1,s=n>>>0>=1073741823?2147483647:t>>>0<s>>>0?s:t,n=p(s),w&&o0(n+o|0,0,w),o&&x(n,f,o),i[e+108>>2]=n+s,i[e+104>>2]=n+t,i[e+100>>2]=n,!f)break r;Z(f);break r}if(t>>>0>=o>>>0)break r;i[e+104>>2]=f+t}if(l6(r,i[e+100>>2],t),l[r+20|0]==1){if(u[k+4|0]=0,u[k+15|0]=0,q(A,2,100,k+4|0),u[k+15|0]>=0)break e;Z(i[k+4>>2]);break e}if(e=i[26917],i[A>>2]=i[26916],i[A+4>>2]=e,A=A+8|0,u[107683]>=0){e=i[26919],i[A>>2]=i[26918],i[A+4>>2]=e,i[A+8>>2]=i[26920];break e}T(A,i[26918],i[26919])}v=k+16|0;return}G0(),H()}function Fv(A,e,r,f,k,n,t,o){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,t=t|0,o=o|0;var s=0,w=0,h=0,_=0,B=0,m=0,X=0,Q=0,V=0,F=0,I=U(0),E=U(0),R=U(0),N=0,M=0,z=0,S=0,O=0,P=0,a=0,$=0,f0=0,A0=0,n0=0,_0=0;t=v-48|0,v=t;i:{e:{r:{if((j0(i[r>>2],0)|0)!=8||(j0(i[r>>2],1)|0)!=8)break r;if((j0(i[r>>2],2)|0)==8)break e}e=i[26922],i[A>>2]=i[26921],i[A+4>>2]=e,r=A+8|0;r:{if(u[107703]>=0){e=i[26924],i[r>>2]=i[26923],i[r+4>>2]=e,i[r+8>>2]=i[26925];break r}T(r,i[26923],i[26924])}u[A+20|0]=1;break i}n=p(172),i[n+4>>2]=0,i[n+8>>2]=0,i[n>>2]=94812,o0(n+16|0,0,80),e=i[n+4>>2],f=e+1|0,i[n+4>>2]=f,i[n+104>>2]=0,i[n+108>>2]=0,i[n+36>>2]=1,i[n+40>>2]=1,u[n+24|0]=1,g[n+22>>1]=2,g[n+18>>1]=2,g[n+20>>1]=2,i[n+112>>2]=0,i[n+116>>2]=4740,i[n+140>>2]=0,i[n+144>>2]=0,i[n+128>>2]=99,i[n+132>>2]=99,i[n+120>>2]=0,i[n+124>>2]=0,i[n+12>>2]=95160,i[n+148>>2]=0,i[n+152>>2]=0,k=n+140|0,i[n+136>>2]=k,i[n+156>>2]=0,i[n+160>>2]=0,i[n+164>>2]=0,i[n+168>>2]=0,i[n+4>>2]=e,e=i[n+8>>2],w=n+12|0,i[n+96>>2]=w,i[n+8>>2]=e+1,i[n+100>>2]=n,f||(W[i[i[n>>2]+8>>2]](n),y(n)),e=i[r>>2],X=i[e+108>>2],f=X,Q=i[e+112>>2],e=Q,i[w+120>>2]=10,i[w+116>>2]=1,i[w+112>>2]=e,i[w+108>>2]=f,T0(t+24|0,w,10,f,e,8,o);e:{if(i[t+24>>2]){if(e=i[t+28>>2],i[A>>2]=i[t+24>>2],i[A+4>>2]=e,r=A+8|0,u[t+43|0]>=0){e=i[t+36>>2],i[r>>2]=i[t+32>>2],i[r+4>>2]=e,i[r+8>>2]=i[t+40>>2],u[A+20|0]=1;break e}if(T(r,i[t+32>>2],i[t+36>>2]),e=u[t+43|0],u[A+20|0]=1,(e|0)>=0)break e;Z(i[t+32>>2]);break e}u[t+43|0]<0&&Z(i[t+32>>2]),i[t+36>>2]=-1086926434,i[t+40>>2]=1071829221,i[t+28>>2]=1068725436,i[t+32>>2]=-1095748968,u[t+24|0]=1,S4(i[r>>2])&&(f=i[r>>2],e=C[f+6>>1]|C[f+8>>1]<<16,le(t+4|0,(C[f+10>>1]|C[f+12>>1]<<16)&65535,e&65535),i[t+40>>2]=i[t+20>>2],e=i[t+16>>2],i[t+32>>2]=i[t+12>>2],i[t+36>>2]=e,e=i[t+8>>2],i[t+24>>2]=i[t+4>>2],i[t+28>>2]=e),I=p0[t+28>>2],E=p0[t+36>>2],R=p0[t+32>>2],e=i[r>>2],r=i[e+128>>2],N=u6(U(p0[t+40>>2]*U(256))),M=u6(U(R*U(256))),z=u6(U(E*U(256))),S=u6(U(I*U(256)));r:{f:{if(r){for(e=e+128|0,f=e,o=r;h=i[o+16>>2],f=(h|0)<0?f:o,o=i[(h>>>29&4)+o>>2],!!o;);_=0;A:{if((e|0)==(f|0)||(_=0,i[f+16>>2]>0))break A;O=i[f+44>>2],_=i[f+56>>2]}for(f=e,o=r;h=i[o+16>>2]<=0,f=h?f:o,o=i[(h?4:0)+o>>2],!!o;);B=0;A:{if((e|0)==(f|0)||(B=0,i[f+16>>2]>1))break A;P=i[f+56>>2],B=i[f+44>>2]}for(o=e;f=i[r+16>>2]<2,o=f?o:r,r=i[(f?4:0)+r>>2],!!r;);if((e|0)!=(o|0))break f}m=0;break r}if(m=0,i[o+16>>2]>2)break r;a=i[o+56>>2],m=i[o+44>>2]}r=i[k>>2],e=0;r:{if(!r)break r;for(o=k;e=i[r+16>>2]<10,o=e?o:r,r=i[(e?4:0)+r>>2],!!r;);if(e=0,(k|0)==(o|0)||(e=0,i[o+16>>2]>10))break r;$=i[o+56>>2],e=i[o+44>>2]}if(h=e,!(!Q|!X))for(e=0;;){for(f0=G(e,$)+h|0,A0=G(e,_)+O|0,r=e>>>1|0,n0=G(r,a)+m|0,_0=G(r,P)+B|0,r=0,k=0,o=0,f=0;r&1||(f=r>>>1|0,k=l[f+_0|0]-128|0,f=l[f+n0|0]-128|0,o=(G(k,M)+G(f,z)|0)+128>>8,k=G(k,N)+128>>8,f=G(f,S)+128>>8),V=G(r,3)+f0|0,F=l[r+A0|0],s=F+k|0,u[V+2|0]=(s|0)>=0?s>>>0>=255?255:s:0,s=o+F|0,u[V+1|0]=(s|0)>=0?s>>>0>=255?255:s:0,s=f+F|0,u[V|0]=(s|0)>=0?s>>>0>=255?255:s:0,r=r+1|0,(X|0)!=(r|0););if(e=e+1|0,(Q|0)==(e|0))break}u[A+20|0]=0,i[A+4>>2]=n,i[A>>2]=w;break i}if(A=i[n+4>>2],i[n+4>>2]=A-1,A)break i;W[i[i[n>>2]+8>>2]](n),y(n)}v=t+48|0}function w9(A,e,r){var f=0,k=0,n=0,t=0,o=0;k=v-16|0,v=k;i:{e:{if(i[e+56>>2])break e;r:{if(!i[r+24>>2])break r;t=W[i[i[e>>2]+8>>2]](e)|0,o=i[r+24>>2],Je(),f=i[26926];f:{if((f|0)!=107708)for(;;){A:{if(n=i[f+16>>2],(W[i[n+16>>2]](t)|0)<=0||n4(o,i[n+40>>2]))break A;f=1;break f}n=i[f+4>>2];A:{if(n){for(;;)if(f=n,n=i[f>>2],!n)break A}for(;n=f,f=i[f+8>>2],(n|0)!=i[f>>2];);}if((f|0)==107708)break}f=0}if(f)break r;if(e=p(32),i[k+4>>2]=e,i[k+8>>2]=30,i[k+12>>2]=-2147483616,r=l[25716]|l[25717]<<8|(l[25718]<<16|l[25719]<<24),f=l[25712]|l[25713]<<8|(l[25714]<<16|l[25715]<<24),u[e|0]=f,u[e+1|0]=f>>>8,u[e+2|0]=f>>>16,u[e+3|0]=f>>>24,u[e+4|0]=r,u[e+5|0]=r>>>8,u[e+6|0]=r>>>16,u[e+7|0]=r>>>24,u[e+30|0]=0,r=l[25738]|l[25739]<<8|(l[25740]<<16|l[25741]<<24),f=l[25734]|l[25735]<<8|(l[25736]<<16|l[25737]<<24),u[e+22|0]=f,u[e+23|0]=f>>>8,u[e+24|0]=f>>>16,u[e+25|0]=f>>>24,u[e+26|0]=r,u[e+27|0]=r>>>8,u[e+28|0]=r>>>16,u[e+29|0]=r>>>24,r=l[25732]|l[25733]<<8|(l[25734]<<16|l[25735]<<24),f=l[25728]|l[25729]<<8|(l[25730]<<16|l[25731]<<24),u[e+16|0]=f,u[e+17|0]=f>>>8,u[e+18|0]=f>>>16,u[e+19|0]=f>>>24,u[e+20|0]=r,u[e+21|0]=r>>>8,u[e+22|0]=r>>>16,u[e+23|0]=r>>>24,r=l[25724]|l[25725]<<8|(l[25726]<<16|l[25727]<<24),f=l[25720]|l[25721]<<8|(l[25722]<<16|l[25723]<<24),u[e+8|0]=f,u[e+9|0]=f>>>8,u[e+10|0]=f>>>16,u[e+11|0]=f>>>24,u[e+12|0]=r,u[e+13|0]=r>>>8,u[e+14|0]=r>>>16,u[e+15|0]=r>>>24,q(A,11,0,k+4|0),u[k+15|0]>=0)break i;Z(i[k+4>>2]);break i}if(f=e,e=wt(W[i[i[e>>2]+8>>2]](e)|0,i[r+24>>2]),i[f+56>>2]=e,!e){if(u[k+4|0]=0,u[k+15|0]=0,q(A,11,6003,k+4|0),u[k+15|0]>=0)break i;Z(i[k+4>>2]);break i}if(i[e>>2]>4)break e;if(e=p(48),i[k+4>>2]=e,i[k+8>>2]=46,i[k+12>>2]=-2147483600,r=l[26029]|l[26030]<<8|(l[26031]<<16|l[26032]<<24),f=l[26025]|l[26026]<<8|(l[26027]<<16|l[26028]<<24),u[e|0]=f,u[e+1|0]=f>>>8,u[e+2|0]=f>>>16,u[e+3|0]=f>>>24,u[e+4|0]=r,u[e+5|0]=r>>>8,u[e+6|0]=r>>>16,u[e+7|0]=r>>>24,u[e+46|0]=0,r=l[26067]|l[26068]<<8|(l[26069]<<16|l[26070]<<24),f=l[26063]|l[26064]<<8|(l[26065]<<16|l[26066]<<24),u[e+38|0]=f,u[e+39|0]=f>>>8,u[e+40|0]=f>>>16,u[e+41|0]=f>>>24,u[e+42|0]=r,u[e+43|0]=r>>>8,u[e+44|0]=r>>>16,u[e+45|0]=r>>>24,r=l[26061]|l[26062]<<8|(l[26063]<<16|l[26064]<<24),f=l[26057]|l[26058]<<8|(l[26059]<<16|l[26060]<<24),u[e+32|0]=f,u[e+33|0]=f>>>8,u[e+34|0]=f>>>16,u[e+35|0]=f>>>24,u[e+36|0]=r,u[e+37|0]=r>>>8,u[e+38|0]=r>>>16,u[e+39|0]=r>>>24,r=l[26053]|l[26054]<<8|(l[26055]<<16|l[26056]<<24),f=l[26049]|l[26050]<<8|(l[26051]<<16|l[26052]<<24),u[e+24|0]=f,u[e+25|0]=f>>>8,u[e+26|0]=f>>>16,u[e+27|0]=f>>>24,u[e+28|0]=r,u[e+29|0]=r>>>8,u[e+30|0]=r>>>16,u[e+31|0]=r>>>24,r=l[26045]|l[26046]<<8|(l[26047]<<16|l[26048]<<24),f=l[26041]|l[26042]<<8|(l[26043]<<16|l[26044]<<24),u[e+16|0]=f,u[e+17|0]=f>>>8,u[e+18|0]=f>>>16,u[e+19|0]=f>>>24,u[e+20|0]=r,u[e+21|0]=r>>>8,u[e+22|0]=r>>>16,u[e+23|0]=r>>>24,r=l[26037]|l[26038]<<8|(l[26039]<<16|l[26040]<<24),f=l[26033]|l[26034]<<8|(l[26035]<<16|l[26036]<<24),u[e+8|0]=f,u[e+9|0]=f>>>8,u[e+10|0]=f>>>16,u[e+11|0]=f>>>24,u[e+12|0]=r,u[e+13|0]=r>>>8,u[e+14|0]=r>>>16,u[e+15|0]=r>>>24,q(A,11,6003,k+4|0),u[k+15|0]>=0)break i;Z(i[k+4>>2]);break i}i[A>>2]=0,i[A+4>>2]=0,i[A+16>>2]=0,i[A+8>>2]=0,i[A+12>>2]=0}v=k+16|0}function Iv(A,e,r,f,k,n,t,o){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,t=t|0,o=o|0;var s=0,w=0,h=0,_=0,B=0,m=0,X=0,Q=0,V=0,F=0,I=0,E=0,R=0,N=0,M=0,z=0,S=0,O=0;h=v-32|0,v=h,e=i[r>>2],V=i[e+112>>2],X=i[e+108>>2];i:{if((j0(e,0)|0)!=8){e=i[26922],i[A>>2]=i[26921],i[A+4>>2]=e,r=A+8|0;e:{if(u[107703]>=0){e=i[26924],i[r>>2]=i[26923],i[r+4>>2]=e,i[r+8>>2]=i[26925];break e}T(r,i[26923],i[26924])}u[A+20|0]=1;break i}t=p(172),i[t+4>>2]=0,i[t+8>>2]=0,i[t>>2]=94812,o0(t+16|0,0,80),e=i[t+4>>2],f=e+1|0,i[t+4>>2]=f,i[t+104>>2]=0,i[t+108>>2]=0,i[t+36>>2]=1,i[t+40>>2]=1,u[t+24|0]=1,g[t+22>>1]=2,g[t+18>>1]=2,g[t+20>>1]=2,i[t+112>>2]=0,i[t+116>>2]=4740,i[t+140>>2]=0,i[t+144>>2]=0,i[t+128>>2]=99,i[t+132>>2]=99,i[t+120>>2]=0,i[t+124>>2]=0,i[t+12>>2]=95160,i[t+148>>2]=0,i[t+152>>2]=0,n=t+140|0,i[t+136>>2]=n,i[t+156>>2]=0,i[t+160>>2]=0,i[t+164>>2]=0,i[t+168>>2]=0,i[t+4>>2]=e,e=i[t+8>>2],Q=t+12|0,i[t+96>>2]=Q,i[t+8>>2]=e+1,i[t+100>>2]=t,f||(W[i[i[t>>2]+8>>2]](t),y(t)),S=u1(i[r>>2],6),i[Q+120>>2]=l[k+8|0]?11:10,i[Q+116>>2]=1,i[Q+112>>2]=V,i[Q+108>>2]=X,T0(h+8|0,Q,10,X,V,8,o);e:{if(i[h+8>>2]){if(e=i[h+12>>2],i[A>>2]=i[h+8>>2],i[A+4>>2]=e,r=A+8|0,u[h+27|0]>=0){e=i[h+20>>2],i[r>>2]=i[h+16>>2],i[r+4>>2]=e,i[r+8>>2]=i[h+24>>2],u[A+20|0]=1;break e}if(T(r,i[h+16>>2],i[h+20>>2]),e=u[h+27|0],u[A+20|0]=1,(e|0)>=0)break e;Z(i[h+16>>2]);break e}u[h+27|0]<0&&Z(i[h+16>>2]);r:{f:{if(e=i[r>>2],o=i[e+128>>2],o){for(f=e+128|0,r=f,e=o;m=i[e+16>>2],r=(m|0)<0?r:e,e=i[(m>>>29&4)+e>>2],!!e;);m=0;A:{if((r|0)==(f|0)||(m=0,i[r+16>>2]>0))break A;F=i[r+56>>2],m=i[r+44>>2]}if(r=0,!S)break r;for(e=f;r=i[o+16>>2]<6,e=r?e:o,o=i[(r?4:0)+o>>2],!!o;);if((e|0)!=(f|0))break f}r=0;break r}if(r=0,i[e+16>>2]>6)break r;O=i[e+56>>2],r=i[e+44>>2]}f=r,e=i[n>>2],o=0;r:{if(!e)break r;for(r=n;o=i[e+16>>2]<10,r=o?r:e,e=i[(o?4:0)+e>>2],!!e;);if(o=0,(r|0)==(n|0)||(o=0,i[r+16>>2]>10))break r;I=i[r+56>>2],o=i[r+44>>2]}if(V)for(E=X&-2,R=X&1,N=X-1|0,r=0;;){r:{if(!l[k+8|0]){if(!X)break r;if(B=o+G(r,I)|0,_=G(r,F)+m|0,e=0,n=0,N)for(;w=B+G(e,3)|0,s=l[e+_|0],u[w|0]=s,u[w+2|0]=s,u[w+1|0]=s,s=e|1,w=B+G(s,3)|0,s=l[s+_|0],u[w+2|0]=s,u[w+1|0]=s,u[w|0]=s,e=e+2|0,n=n+2|0,(E|0)!=(n|0););if(!R)break r;n=B+G(e,3)|0,e=l[e+_|0],u[n|0]=e,u[n+2|0]=e,u[n+1|0]=e;break r}if(!S){if(!X)break r;if(B=o+G(r,I)|0,_=G(r,F)+m|0,e=0,n=0,N)for(;w=B+(e<<2)|0,s=l[e+_|0],u[w|0]=s,u[w+3|0]=255,u[w+2|0]=s,u[w+1|0]=s,s=e|1,w=l[s+_|0],s=B+(s<<2)|0,u[s+3|0]=255,u[s+2|0]=w,u[s+1|0]=w,u[s|0]=w,e=e+2|0,n=n+2|0,(E|0)!=(n|0););if(!R)break r;n=B+(e<<2)|0,e=l[e+_|0],u[n|0]=e,u[n+3|0]=255,u[n+2|0]=e,u[n+1|0]=e;break r}if(!X)break r;if(M=G(r,O)+f|0,z=o+G(r,I)|0,B=G(r,F)+m|0,e=0,w=0,N)for(;s=z+(e<<2)|0,n=l[e+B|0],u[s|0]=n,u[s+2|0]=n,u[s+1|0]=n,u[s+3|0]=l[e+M|0],s=e|1,_=z+(s<<2)|0,n=l[s+B|0],u[_+2|0]=n,u[_+1|0]=n,u[_|0]=n,u[_+3|0]=l[s+M|0],e=e+2|0,w=w+2|0,(E|0)!=(w|0););if(!R)break r;s=z+(e<<2)|0,n=l[e+B|0],u[s|0]=n,u[s+2|0]=n,u[s+1|0]=n,u[s+3|0]=l[e+M|0]}if(r=r+1|0,(V|0)==(r|0))break}u[A+20|0]=0,i[A+4>>2]=t,i[A>>2]=Q;break i}if(A=i[t+4>>2],i[t+4>>2]=A-1,A)break i;W[i[i[t>>2]+8>>2]](t),y(t)}v=h+32|0}function z8(A,e,r,f,k,n,t,o,s){var w=0,h=0,_=0,B=0,m=0,X=0,Q=0,V=0,F=0,I=0,E=0;w=s<<2,m=i[w+62784>>2]+n|0,w=i[w+62768>>2],X=m+w|0,h=i[(o<<2)+62768>>2];i:{e:switch(o|0){case 0:if(B=0-w|0,(m|0)<=(B|0)|(k|0)<=0)break i;for(V=(w<<1)+t|0,F=r-h|0,I=k&2147483644,Q=k&3,E=k>>>0<4;;){if(h=(B<<1)+V|0,w=G(f,B)+F|0,_=0,!E)for(;g[h>>1]=l[w|0],r=X<<1,h=r+h|0,g[h>>1]=l[w+1|0],h=r+h|0,g[h>>1]=l[w+2|0],h=r+h|0,g[h>>1]=l[w+3|0],h=r+h|0,w=w+4|0,_=_+4|0,(I|0)!=(_|0););if(r=0,Q)for(;g[h>>1]=l[w|0],w=w+1|0,h=(X<<1)+h|0,r=r+1|0,(Q|0)!=(r|0););if(B=B+1|0,(m|0)==(B|0))break}break i;case 1:if(_=0-w|0,(m|0)<=(_|0)|(k|0)<=0)break i;for(B=(w<<1)+t|0,Q=r-h|0;;){for(h=B+(_<<1)|0,w=Q+G(f,_)|0,r=0;g[h>>1]=l[w+6|0]+((((((l[w+1|0]<<2)-l[w|0]|0)+G(l[w+2|0],-10)|0)+G(l[w+3|0],58)|0)+G(l[w+4|0],17)|0)+G(l[w+5|0],-5)|0),w=w+1|0,h=(X<<1)+h|0,r=r+1|0,(k|0)!=(r|0););if(_=_+1|0,(m|0)==(_|0))break}break i;case 2:if(_=0-w|0,(m|0)<=(_|0)|(k|0)<=0)break i;for(B=(w<<1)+t|0,Q=r-h|0;;){for(h=B+(_<<1)|0,w=Q+G(f,_)|0,r=0;g[h>>1]=(((((l[w+1|0]<<2)-l[w|0]|0)+G(l[w+4|0]+l[w+3|0]|0,40)|0)+(l[w+6|0]<<2)|0)-l[w+7|0]|0)+G(l[w+5|0]+l[w+2|0]|0,-11),w=w+1|0,h=(X<<1)+h|0,r=r+1|0,(k|0)!=(r|0););if(_=_+1|0,(m|0)==(_|0))break}break i;case 3:break e;default:break i}if(_=0-w|0,(m|0)<=(_|0)|(k|0)<=0)break i;for(B=(w<<1)+t|0,Q=r-h|0;;){for(h=B+(_<<1)|0,w=Q+G(f,_)|0,r=0;g[h>>1]=(((((l[w|0]+G(l[w+1|0],-5)|0)+G(l[w+2|0],17)|0)+G(l[w+3|0],58)|0)+G(l[w+4|0],-10)|0)+(l[w+5|0]<<2)|0)-l[w+6|0],w=w+1|0,h=(X<<1)+h|0,r=r+1|0,(k|0)!=(r|0););if(_=_+1|0,(m|0)==(_|0))break}}f=o?6:0;i:{e:switch(s|0){case 3:if((k|0)<=0|(n|0)<=0)break i;for(_=0;;){for(h=(_<<1)+A|0,w=(G(_,X)<<1)+t|0,r=0;g[h>>1]=(((((g[w>>1]+G(g[w+2>>1],-5)|0)+G(g[w+4>>1],17)|0)+G(g[w+6>>1],58)|0)+G(g[w+8>>1],-10)|0)+(g[w+10>>1]<<2)|0)-g[w+12>>1]>>f,w=w+2|0,h=(e<<1)+h|0,r=r+1|0,(n|0)!=(r|0););if(_=_+1|0,(_|0)==(k|0))break}break i;case 2:if((k|0)<=0|(n|0)<=0)break i;for(_=0;;){for(h=(_<<1)+A|0,w=(G(_,X)<<1)+t|0,r=0;g[h>>1]=(((((g[w+2>>1]<<2)-g[w>>1]|0)+G(g[w+8>>1]+g[w+6>>1]|0,40)|0)+(g[w+12>>1]<<2)|0)-g[w+14>>1]|0)+G(g[w+10>>1]+g[w+4>>1]|0,-11)>>f,w=w+2|0,h=(e<<1)+h|0,r=r+1|0,(n|0)!=(r|0););if(_=_+1|0,(_|0)==(k|0))break}break i;case 1:if((k|0)<=0)break i;for(_=0,o=(n|0)<=0;;){if(!o)for(h=(_<<1)+A|0,w=(G(_,X)<<1)+t|0,r=0;g[h>>1]=g[w+12>>1]+((((((g[w+2>>1]<<2)-g[w>>1]|0)+G(g[w+4>>1],-10)|0)+G(g[w+6>>1],58)|0)+G(g[w+8>>1],17)|0)+G(g[w+10>>1],-5)|0)>>f,w=w+2|0,h=(e<<1)+h|0,r=r+1|0,(n|0)!=(r|0););if(_=_+1|0,(_|0)==(k|0))break}break i;case 0:break e;default:break i}if((k|0)<=0)break i;for(_=n&2147483644,s=n&3,f=0,m=(n|0)<=0;;){e:{if(m)break e;if(h=(f<<1)+A|0,w=(G(f,X)<<1)+t|0,r=0,n>>>0>3)for(;g[h>>1]=C[w>>1],o=e<<1,h=o+h|0,g[h>>1]=C[w+2>>1],h=o+h|0,g[h>>1]=C[w+4>>1],h=o+h|0,g[h>>1]=C[w+6>>1],h=o+h|0,w=w+8|0,r=r+4|0,(_|0)!=(r|0););if(r=0,!s)break e;for(;g[h>>1]=C[w>>1],w=w+2|0,h=(e<<1)+h|0,r=r+1|0,(s|0)!=(r|0););}if(f=f+1|0,(k|0)==(f|0))break}}}function nr(A,e){var r=0,f=0,k=0,n=0,t=0,o=0,s=0,w=0,h=0,_=0;r=v-32|0,v=r,f=i[e>>2],f>>>0>13?f=6623:f=i[(f<<2)+94292>>2],s=n9(i[e+4>>2]);i:{e:{r:{f:{A:{if(t=i[e+8>>2],n=h2(t),n>>>0<2147483640){k:{n:{if(n>>>0>=11){o=n|7,k=p(o+1|0),i[r+24>>2]=o-2147483647,i[r+16>>2]=k,i[r+20>>2]=n;break n}if(u[r+27|0]=n,k=r+16|0,!n)break k}if(!n)break k;x(k,t,n)}if(u[n+k|0]=0,t=h2(f),t>>>0>=2147483640)break i;k:{n:{if(t>>>0>=11){n=t|7,k=p(n+1|0),i[r+12>>2]=n-2147483647,i[r+4>>2]=k,i[r+8>>2]=t;break n}if(u[r+15|0]=t,k=r+4|0,!t)break k}if(!t)break k;x(k,f,t)}if(n=0,u[k+t|0]=0,k=u[r+27|0],o=(k|0)<0,w=u[r+15|0],h=(w|0)<0,t=o?i[r+20>>2]:k,_=h?i[r+8>>2]:w,t>>>0>=_>>>0){if((_|0)==-1)break A;n=!N2(o?i[r+16>>2]:r+16|0,h?i[r+4>>2]:r+4|0,_)}(w|0)<0&&Z(i[r+4>>2]);k:{if(!n)break k;if(o=h2(f),o>>>0>t>>>0)break f;if(f=t-o|0,f>>>0>=2147483640)break i;w=i[r+16>>2];n:{t:{if(f>>>0>=11){t=f|7,n=p(t+1|0),i[r+12>>2]=t-2147483647,i[r+4>>2]=n,i[r+8>>2]=f;break t}if(u[r+15|0]=f,n=r+4|0,(t|0)==(o|0))break n}if(!f)break n;x(n,o+((k|0)<0?w:r+16|0)|0,f)}u[f+n|0]=0,u[r+27|0]<0&&Z(i[r+16>>2]),i[r+24>>2]=i[r+12>>2],f=i[r+8>>2],i[r+16>>2]=i[r+4>>2],i[r+20>>2]=f,g[r+4>>1]=8250,f=u[r+27|0],n=(f|0)<0,f=n?i[r+20>>2]:f;n:{if(f>>>0<=1||(t=i[r+16>>2],k=n?t:r+16|0,C[r+4>>1]!=(l[k|0]|l[k+1|0]<<8)))break n;if(f=f-2|0,f>>>0>=2147483640)break i;t:{u:{if(f>>>0>=11){o=f|7,k=p(o+1|0),i[r+12>>2]=o-2147483647,i[r+4>>2]=k,i[r+8>>2]=f;break u}if(u[r+15|0]=f,k=r+4|0,!f)break t}if(!f)break t;x(k,(n?t:r+16|0)+2|0,f)}u[f+k|0]=0,u[r+27|0]<0&&Z(i[r+16>>2]),i[r+24>>2]=i[r+12>>2],f=i[r+8>>2],i[r+16>>2]=i[r+4>>2],i[r+20>>2]=f}if(f=h2(s),f>>>0>=2147483640)break i;n:{t:{if(f>>>0>=11){n=f|7,k=p(n+1|0),i[r+12>>2]=n-2147483647,i[r+4>>2]=k,i[r+8>>2]=f;break t}if(u[r+15|0]=f,k=r+4|0,!f)break n}if(!f)break n;x(k,s,f)}if(n=0,u[f+k|0]=0,k=u[r+27|0],f=(k|0)<0,o=u[r+15|0],w=(o|0)<0,t=f?i[r+20>>2]:k,h=w?i[r+8>>2]:o,t>>>0>=h>>>0){if((h|0)==-1)break r;n=!N2(f?i[r+16>>2]:r+16|0,w?i[r+4>>2]:r+4|0,h)}if((o|0)<0&&Z(i[r+4>>2]),!n)break k;if(s=h2(s),s>>>0>t>>>0)break e;if(f=t-s|0,f>>>0>=2147483640)break i;o=i[r+16>>2];n:{t:{if(f>>>0>=11){t=f|7,n=p(t+1|0),i[r+12>>2]=t-2147483647,i[r+4>>2]=n,i[r+8>>2]=f;break t}if(u[r+15|0]=f,n=r+4|0,(t|0)==(s|0))break n}if(!f)break n;x(n,s+((k|0)<0?o:r+16|0)|0,f)}if(u[f+n|0]=0,u[r+27|0]<0&&Z(i[r+16>>2]),i[r+24>>2]=i[r+12>>2],f=i[r+8>>2],i[r+16>>2]=i[r+4>>2],i[r+20>>2]=f,g[r+4>>1]=8250,k=u[r+27|0],n=(k|0)<0,f=n?i[r+20>>2]:k,f>>>0<=1||(t=i[r+16>>2],s=n?t:r+16|0,C[r+4>>1]!=(l[s|0]|l[s+1|0]<<8)))break k;if(f=f-2|0,f>>>0>=2147483640)break i;n:{t:{if(f>>>0>=11){s=f|7,k=p(s+1|0),i[r+12>>2]=s-2147483647,i[r+4>>2]=k,i[r+8>>2]=f;break t}if(u[r+15|0]=f,k=r+4|0,!f)break n}if(!f)break n;x(k,(n?t:r+16|0)+2|0,f)}u[f+k|0]=0,u[r+27|0]<0&&Z(i[r+16>>2]),i[r+24>>2]=i[r+12>>2],f=i[r+8>>2],i[r+16>>2]=i[r+4>>2],i[r+20>>2]=f,k=l[r+27|0]}f=i[e+4>>2],i[A>>2]=i[e>>2],i[A+4>>2]=f,A=A+8|0;k:{if(k<<24>>24>=0){e=i[r+20>>2],i[A>>2]=i[r+16>>2],i[A+4>>2]=e,i[A+8>>2]=i[r+24>>2];break k}e=A,A=i[r+16>>2],T(e,A,i[r+20>>2]),Z(A)}v=r+32|0;return}Q0(),H()}W3(),H()}W3(),H()}W3(),H()}W3(),H()}Q0(),H()}function Cv(){var A=0,e=0,r=0,f=0,k=0,n=0;A=v-16|0,v=A;i:{if(R_(A+12|0,A+8|0)|0||(e=y2((i[A+12>>2]<<2)+4|0),i[31325]=e,!e)||(e=y2(i[A+8>>2]),e&&(r=i[31325],i[r+(i[A+12>>2]<<2)>>2]=0,!(Y_(r|0,e|0)|0))))break i;i[31325]=0}v=A+16|0,l[129161]||(r=i[18266],f=v-16|0,v=f,A=R0(128808),i[A+40>>2]=128864,i[A+32>>2]=r,i[A>>2]=73396,u[A+52|0]=0,i[A+48>>2]=-1,k=f+12|0,e=i[A+4>>2],i[k>>2]=e,(e|0)!=129576&&(i[e+4>>2]=i[e+4>>2]+1),W[i[i[A>>2]+8>>2]](A,k),e2(k),v=f+16|0,i[32032]=0,i[32025]=73028,i[32025]=71360,i[32023]=70892,i[32025]=70912,i[32024]=0,I3(i[17720]+128092|0,128808),k=i[16889],_o(128872,k,128920),A5(128276,128872),n=i[16888],_o(128928,n,128976),A5(128452,128928),A5(128628,i[(i[i[32113]-12>>2]+128452|0)+24>>2]),i[(i[i[32023]-12>>2]+128092|0)+72>>2]=128276,A=i[i[32113]-12>>2]+128452|0,i[A+4>>2]=i[A+4>>2]|8192,i[(i[i[32113]-12>>2]+128452|0)+72>>2]=128276,f=v-16|0,v=f,A=vl(128984),i[A+40>>2]=129040,i[A+32>>2]=r,i[A>>2]=73600,u[A+52|0]=0,i[A+48>>2]=-1,r=f+12|0,e=i[A+4>>2],i[r>>2]=e,(e|0)!=129576&&(i[e+4>>2]=i[e+4>>2]+1),W[i[i[A>>2]+8>>2]](A,r),e2(r),v=f+16|0,i[32055]=0,i[32048]=73028,i[32048]=71796,i[32046]=71140,i[32048]=71160,i[32047]=0,I3(i[17782]+128184|0,128984),Bo(129048,k,129096),k5(128364,129048),Bo(129104,n,129152),k5(128540,129104),k5(128716,i[(i[i[32135]-12>>2]+128540|0)+24>>2]),i[(i[i[32046]-12>>2]+128184|0)+72>>2]=128364,A=i[i[32135]-12>>2]+128540|0,i[A+4>>2]=i[A+4>>2]|8192,i[(i[i[32135]-12>>2]+128540|0)+72>>2]=128364,u[129161]=1),i[26916]=0,i[26917]=0,u[107683]=0,u[107672]=0,A=p(16),u[A+14|0]=0,e=l[6739]|l[6740]<<8|(l[6741]<<16|l[6742]<<24),r=l[6735]|l[6736]<<8|(l[6737]<<16|l[6738]<<24),u[A+6|0]=r,u[A+7|0]=r>>>8,u[A+8|0]=r>>>16,u[A+9|0]=r>>>24,u[A+10|0]=e,u[A+11|0]=e>>>8,u[A+12|0]=e>>>16,u[A+13|0]=e>>>24,e=l[6733]|l[6734]<<8|(l[6735]<<16|l[6736]<<24),r=l[6729]|l[6730]<<8|(l[6731]<<16|l[6732]<<24),u[A|0]=r,u[A+1|0]=r>>>8,u[A+2|0]=r>>>16,u[A+3|0]=r>>>24,u[A+4|0]=e,u[A+5|0]=e>>>8,u[A+6|0]=e>>>16,u[A+7|0]=e>>>24,i[26921]=4,i[26922]=0,T(107692,A,14),Z(A),i[26927]=0,i[26928]=0,i[26926]=107708,i[26929]=107720,i[26930]=0,i[26931]=0,iA(),i[26940]=0,i[26941]=0,i[26939]=107760,i[26945]=0,i[26944]=938,r9(),i[26945]=i[31321],i[31321]=107776,A=v-80|0,v=A,i[26949]=0,i[26950]=0,i[26948]=107796,e=i[13035],i[A+48>>2]=i[13034],i[A+52>>2]=e,e=i[13033],i[A+40>>2]=i[13032],i[A+44>>2]=e,e=i[13031],i[A+32>>2]=i[13030],i[A+36>>2]=e,e=i[13029],i[A+24>>2]=i[13028],i[A+28>>2]=e,e=i[13027],i[A+16>>2]=i[13026],i[A+20>>2]=e,e=i[13025],i[A+8>>2]=i[13024],i[A+12>>2]=e,e=A+8|0,fe(107792,e,A+56|0),x(e,52144,68),i[26951]=107808,i[26952]=0,i[26953]=0,fe(107804,e,A+76|0),i[26955]=0,i[26956]=0,i[26954]=107820,r=i[13066],i[A+56>>2]=i[13065],i[A+60>>2]=r,r=i[13064],i[A+48>>2]=i[13063],i[A+52>>2]=r,r=i[13062],i[A+40>>2]=i[13061],i[A+44>>2]=r,r=i[13060],i[A+32>>2]=i[13059],i[A+36>>2]=r,r=i[13058],i[A+24>>2]=i[13057],i[A+28>>2]=r,r=i[13056],i[A+16>>2]=i[13055],i[A+20>>2]=r,r=i[13054],i[A+8>>2]=i[13053],i[A+12>>2]=r,fe(107816,e,A- -64|0),v=A+80|0,i[31322]=1947,i[31323]=0,zn(),i[31323]=i[31321],i[31321]=125288,i[31366]=125344,i[31356]=65536,i[31355]=196848,i[31348]=42,i[31357]=i[26796]}function h9(A,e,r,f){var k=0,n=0,t=0,o=0,s=0,w=0,h=0,_=0,B=0,m=0,X=0,Q=0,V=0,F=0,I=0,E=0,R=0,N=0,M=0,z=0;if(V=v-2176|0,v=V,(e|0)>0){X=e>>>1|0;i:{if(e>>>0>=8){for(w=e>>>2|0,z=e&2,M=X&1073741822,t=V- -64|0,k=V;;){e:{if((e|0)==1)break e;if(h=(G(f,R)<<1)+r|0,n=0,o=0,(X|0)!=1)for(;_=n<<1,s=_+h|0,m=t+_|0,_=n+X<<1,B=_+h|0,g[m>>1]=C[B>>1]+C[s>>1],g[t+_>>1]=C[s>>1]-C[B>>1],s=n|1,_=s<<1,m=_+t|0,s=s+X<<1,B=s+h|0,_=h+_|0,g[m>>1]=C[B>>1]+C[_>>1],g[t+s>>1]=C[_>>1]-C[B>>1],n=n+2|0,o=o+2|0,(M|0)!=(o|0););if(!z)break e;s=n<<1,o=s+h|0,n=n+X<<1,h=n+h|0,g[t+s>>1]=C[h>>1]+C[o>>1],g[n+t>>1]=C[o>>1]-C[h>>1]}for(o=w,h=X;;){e:{if(n=t,t=k,!o)break e;for(F=o&536870910,E=o&1,s=0;;){if(k=0,_=0,(o|0)!=1)for(;B=k+s|0,Q=B<<1,m=Q+t|0,N=o+B<<1,I=C[N+n>>1],Q=C[n+Q>>1],g[m>>1]=I+Q,g[t+N>>1]=Q-I,B=B+1|0,Q=B<<1,m=Q+t|0,B=o+B<<1,N=C[B+n>>1],Q=C[n+Q>>1],g[m>>1]=N+Q,g[t+B>>1]=Q-N,k=k+2|0,_=_+2|0,(F|0)!=(_|0););if(E&&(k=k+s|0,_=k<<1,m=_+t|0,k=k+o<<1,B=C[k+n>>1],_=C[n+_>>1],g[m>>1]=B+_,g[k+t>>1]=_-B),s=s+h|0,!((s|0)<(e|0)))break}if(h=h>>>1|0,s=o>>>0>3,o=o>>>1|0,k=n,s)continue}break}for(o=G(e,R),k=0;h=V+128|0,s=k|1,_=(s<<1)+t|0,B=(k<<1)+t|0,g[h+(k+o<<1)>>1]=C[_>>1]+C[B>>1],g[h+(o+s<<1)>>1]=C[B>>1]-C[_>>1],k=k+2|0,(k|0)<(e|0););if(k=n,R=R+1|0,(R|0)==(e|0))break}break i}for(k=e-1|0,_=k&2,R=(k>>>1|0)+1&-2,B=X<<1,k=V- -64|0,z=B+k|0,M=X+2<<1,F=M+k|0,E=X+1<<1,Q=E+k|0,N=e>>>0<3;;){e:{if((e|0)==1||(k=(G(f,o)<<1)+r|0,n=C[k+B>>1],t=C[k>>1],g[V+64>>1]=n+t,g[z>>1]=t-n,e>>>0<4)||(n=C[k+E>>1],t=C[k+2>>1],g[V+66>>1]=n+t,g[Q>>1]=t-n,(X|0)==2))break e;n=C[k+M>>1],k=C[k+4>>1],g[V+68>>1]=n+k,g[F>>1]=k-n}if(n=G(e,o),t=0,k=0,!N)for(;h=V+128|0,w=V- -64|0,s=t|1,I=C[w+(s<<1)>>1],m=C[w+(t<<1)>>1],g[h+(n+t<<1)>>1]=I+m,g[h+(n+s<<1)>>1]=m-I,I=t|2,s=C[w+(I<<1)>>1],m=h+(n+I<<1)|0,I=t|3,w=C[w+(I<<1)>>1],g[m>>1]=s+w,g[h+(n+I<<1)>>1]=s-w,t=t+4|0,k=k+2|0,(R|0)!=(k|0););if(_||(k=V+128|0,m=k+(n+t<<1)|0,w=V- -64|0,h=t|1,s=C[w+(h<<1)>>1],t=C[w+(t<<1)>>1],g[m>>1]=s+t,g[k+(n+h<<1)>>1]=t-s),o=o+1|0,(o|0)==(e|0))break}n=V,t=n- -64|0}for(r=e>>>1|0,R=r>>>0<=1?1:r,f=e>>>2|0,X=0,B=e>>>0<8;;){k=0;i:{if((e|0)==1){k=n;break i}for(;w=V+128|0,h=r+k|0,o=C[w+(G(h,e)+X<<1)>>1],w=w+(G(e,k)+X<<1)|0,g[(k<<1)+t>>1]=o+C[w>>1],g[(h<<1)+t>>1]=C[w>>1]-o,k=k+1|0,(R|0)!=(k|0););if(o=f,h=r,k=n,B)break i;for(;;){if(k=t,t=n,!o)break i;for(z=o&536870910,M=o&1,s=0;;){if(n=0,_=0,(o|0)!=1)for(;w=n+s|0,F=w<<1,m=F+t|0,E=o+w<<1,Q=C[E+k>>1],F=C[k+F>>1],g[m>>1]=Q+F,g[t+E>>1]=F-Q,w=w+1|0,F=w<<1,m=F+t|0,w=o+w<<1,E=C[w+k>>1],F=C[k+F>>1],g[m>>1]=E+F,g[t+w>>1]=F-E,n=n+2|0,_=_+2|0,(z|0)!=(_|0););if(M&&(n=n+s|0,w=n<<1,m=w+t|0,n=n+o<<1,_=C[n+k>>1],w=C[k+w>>1],g[m>>1]=_+w,g[n+t>>1]=w-_),s=s+h|0,!((s|0)<(e|0)))break}if(h=h>>>1|0,w=o>>>0>3,o=o>>>1|0,n=k,!w)break}}for(o=(X<<1)+A|0,n=0;h=n|1,w=(h<<1)+t|0,s=(n<<1)+t|0,g[o+(G(e,n)<<1)>>1]=C[w>>1]+C[s>>1],g[o+(G(e,h)<<1)>>1]=C[s>>1]-C[w>>1],n=n+2|0,(n|0)<(e|0););if(n=k,X=X+1|0,(X|0)==(e|0))break}}v=V+2176|0}function pv(A){A=A|0;var e=0,r=0,f=0,k=0,n=0,t=0,o=0,s=0,w=0,h=0,_=0,B=0,m=0,X=0,Q=0,V=0,F=0,I=0,E=0,R=0,N=0,M=0,z=0,S=0,O=0,P=0,a=0;X=v-32|0,v=X,h=X+20|0,e=i[A+464>>2],f=((e+i[A+456>>2]|0)-1>>>0)/(e>>>0)|0,e=i[A+460>>2],e=G(f,((e+i[A+452>>2]|0)-1>>>0)/(e>>>0)|0),r=e,f=l[A+474|0];i:{if(!f||(r=G(e,i[A+476>>2]),e=f-1|0,!e)||(r=G(r,i[A+480>>2]),(e|0)==1)||(r=G(r,i[A+484>>2]),(e|0)==2)||(r=G(r,i[A+488>>2]),(e|0)==3)||(r=G(r,i[A+492>>2]),(e|0)==4)||(r=G(r,i[A+496>>2]),(e|0)==5)||(r=G(r,i[A+500>>2]),(e|0)==6))break i;r=G(r,i[A+504>>2])}f=l[A+473|0],n=l[A+472|0],e=0,i[h+8>>2]=0,i[h>>2]=0,i[h+4>>2]=0;i:{e:{if(r=G(r,f+n>>>3|0),r){if((r|0)<0)break e;o=p(r),r&&o0(o,0,r),e=r+o|0,i[h+8>>2]=e,i[h+4>>2]=e,i[h>>2]=o}if(m=i[A+512>>2],E=i[A+516>>2],(m|0)!=(E|0)){for(I=l[A+473|0],_=I>>>3|0,N=_&28,R=_&3,e=l[A+472|0],w=e>>>3|0,M=w&30,z=w&1,S=e>>>0<8,O=_-1>>>0<3,P=(w|0)==1;;){r:{if(S)break r;if(t=i[m>>2],f=i[m+4>>2],V=o+Q|0,e=0,!P)for(a=V+1|0,r=0,k=0,n=0;B=w+(e^-1)<<3,s=B&31,F=e+V|0,(B&63)>>>0>=32?B=f>>>s|0:B=((1<<s)-1&f)<<32-s|t>>>s,u[F|0]=B,B=w+(e^536870910)<<3,s=B&31,F=e+a|0,(B&63)>>>0>=32?B=f>>>s|0:B=((1<<s)-1&f)<<32-s|t>>>s,u[F|0]=B,e=e+2|0,r=e>>>0<2?r+1|0:r,k=k+2|0,n=k>>>0<2?n+1|0:n,!!((k|0)!=(M|0)|n););if(!z)break r;F=e+V|0,n=t,r=w+(e^-1)<<3,e=r&31,(r&63)>>>0>=32?f=f>>>e|0:f=((1<<e)-1&f)<<32-e|n>>>e,u[F|0]=f}if(Q=w+Q|0,I){r:{if(I>>>0<8)break r;if(r=i[m+8>>2],f=o+Q|0,n=0,e=0,!O)for(k=f+3|0,s=f+2|0,V=f+1|0,t=0;u[e+f|0]=r>>>(_+(e^-1)<<3),u[e+V|0]=r>>>(_+(e^536870910)<<3),u[e+s|0]=r>>>(_+(e^536870909)<<3),u[e+k|0]=r>>>(_+(e^536870908)<<3),e=e+4|0,t=t+4|0,(N|0)!=(t|0););if(!R)break r;for(;u[e+f|0]=r>>>(_+(e^-1)<<3),e=e+1|0,n=n+1|0,(n|0)!=(R|0););}Q=_+Q|0}if(m=m+16|0,(E|0)==(m|0))break}e=i[h+4>>2]}i[A+524>>2]=e-o;break i}G0(),H()}e=i[A+100>>2],i[X+12>>2]=i[e+48>>2],e=i[e+52>>2],i[X+16>>2]=e,e&&(i[e+4>>2]=i[e+4>>2]+1),o=i[A+116>>2],e=0,r=0,n=0,t=0,w=v-32|0,v=w,_=w+12|0,A=i[i[X+12>>2]+68>>2],f=i[A+108>>2],k=i[A+104>>2];i:{if((f|0)==(k|0)){A=0;break i}for(A=f-k>>5,f=A>>>0<=1?1:A,A=0;;){if((o|0)==i[k+(A<<5)>>2])break i;if(A=A+1|0,(f|0)==(A|0))break}A=f}f=k+(A<<5)|0,A=i[f+16>>2],m=i[f+20>>2];i:{if((A|0)==(m|0))break i;for(;;){s=i[A+24>>2],k=i[A+28>>2]-s|0;e:{if(!r&e>>>0>=k>>>0|r){f=e-k|0,r=r-(e>>>0<k>>>0)|0;break e}V=i[h>>2],f=i[h+4>>2]-V|0,o=f-n|0,F=o,Q=k-e|0,k=0-((e>>>0>k>>>0)+r|0)|0,f=0-((f>>>0<n>>>0)+t|0)|0,o=(k|0)==(f|0)&o>>>0<Q>>>0|f>>>0<k>>>0,r=o?F:Q,f=o?f:k,r&&x(e+s|0,n+V|0,r),t=f+t|0,n=r+n|0,t=n>>>0<r>>>0?t+1|0:t,f=0,r=0}if(e=f,!t&(i[h+4>>2]-i[h>>2]|0)==(n|0))break i;if(A=A+40|0,(m|0)==(A|0))break}}e=i[26917],A=_,i[A>>2]=i[26916],i[A+4>>2]=e,A=A+8|0;i:{if(u[107683]>=0){e=i[26919],i[A>>2]=i[26918],i[A+4>>2]=e,i[A+8>>2]=i[26920];break i}T(A,i[26918],i[26919])}u[w+31|0]<0&&Z(i[w+20>>2]),v=w+32|0,A=i[X+16>>2];i:{if(!A||(e=i[A+4>>2],i[A+4>>2]=e-1,e))break i;W[i[i[A>>2]+8>>2]](A),y(A)}A=i[X+20>>2],A&&(i[X+24>>2]=A,Z(A)),v=X+32|0}function yv(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0;n=v-48|0,v=n,hf(n+24|0,e,r);i:{if(i[n+24>>2]){e=i[n+28>>2],i[A>>2]=i[n+24>>2],i[A+4>>2]=e,i[A+16>>2]=i[n+40>>2],e=i[n+36>>2],i[A+8>>2]=i[n+32>>2],i[A+12>>2]=e,i[n+40>>2]=0,i[n+32>>2]=0,i[n+36>>2]=0;break i}r=i[e+196>>2],f=i[e+140>>2],i[f+100>>2]=i[f+100>>2]&-7;e:{if(i[r+104>>2]==i[r+108>>2])break e;if(f=xA(i[e+188>>2],1),!f){if(e=p(32),i[n+12>>2]=e,i[n+16>>2]=29,i[n+20>>2]=-2147483616,r=l[21896]|l[21897]<<8|(l[21898]<<16|l[21899]<<24),f=l[21892]|l[21893]<<8|(l[21894]<<16|l[21895]<<24),u[e|0]=f,u[e+1|0]=f>>>8,u[e+2|0]=f>>>16,u[e+3|0]=f>>>24,u[e+4|0]=r,u[e+5|0]=r>>>8,u[e+6|0]=r>>>16,u[e+7|0]=r>>>24,u[e+29|0]=0,r=l[21917]|l[21918]<<8|(l[21919]<<16|l[21920]<<24),f=l[21913]|l[21914]<<8|(l[21915]<<16|l[21916]<<24),u[e+21|0]=f,u[e+22|0]=f>>>8,u[e+23|0]=f>>>16,u[e+24|0]=f>>>24,u[e+25|0]=r,u[e+26|0]=r>>>8,u[e+27|0]=r>>>16,u[e+28|0]=r>>>24,r=l[21912]|l[21913]<<8|(l[21914]<<16|l[21915]<<24),f=l[21908]|l[21909]<<8|(l[21910]<<16|l[21911]<<24),u[e+16|0]=f,u[e+17|0]=f>>>8,u[e+18|0]=f>>>16,u[e+19|0]=f>>>24,u[e+20|0]=r,u[e+21|0]=r>>>8,u[e+22|0]=r>>>16,u[e+23|0]=r>>>24,r=l[21904]|l[21905]<<8|(l[21906]<<16|l[21907]<<24),f=l[21900]|l[21901]<<8|(l[21902]<<16|l[21903]<<24),u[e+8|0]=f,u[e+9|0]=f>>>8,u[e+10|0]=f>>>16,u[e+11|0]=f>>>24,u[e+12|0]=r,u[e+13|0]=r>>>8,u[e+14|0]=r>>>16,u[e+15|0]=r>>>24,q(A,2,0,n+12|0),u[n+23|0]>=0)break i;Z(i[n+12>>2]);break i}r=0,k=i[e+180>>2],e=i[k+104>>2],f=i[f+8>>2]-1|0;r:{if(f>>>0>=i[k+108>>2]-e>>3>>>0)break r;if(r=e+(f<<3)|0,e=i[r>>2],r=i[r+4>>2],r){if(i[r+4>>2]=i[r+4>>2]+1,!e)break r;if(e=i[r+4>>2],i[r+4>>2]=e-1,e)break e;W[i[i[r>>2]+8>>2]](r),y(r);break e}if(r=0,e)break e}if(e=p(48),i[n+12>>2]=e,i[n+16>>2]=40,i[n+20>>2]=-2147483600,f=l[8042]|l[8043]<<8|(l[8044]<<16|l[8045]<<24),k=l[8038]|l[8039]<<8|(l[8040]<<16|l[8041]<<24),u[e|0]=k,u[e+1|0]=k>>>8,u[e+2|0]=k>>>16,u[e+3|0]=k>>>24,u[e+4|0]=f,u[e+5|0]=f>>>8,u[e+6|0]=f>>>16,u[e+7|0]=f>>>24,u[e+40|0]=0,f=l[8074]|l[8075]<<8|(l[8076]<<16|l[8077]<<24),k=l[8070]|l[8071]<<8|(l[8072]<<16|l[8073]<<24),u[e+32|0]=k,u[e+33|0]=k>>>8,u[e+34|0]=k>>>16,u[e+35|0]=k>>>24,u[e+36|0]=f,u[e+37|0]=f>>>8,u[e+38|0]=f>>>16,u[e+39|0]=f>>>24,f=l[8066]|l[8067]<<8|(l[8068]<<16|l[8069]<<24),k=l[8062]|l[8063]<<8|(l[8064]<<16|l[8065]<<24),u[e+24|0]=k,u[e+25|0]=k>>>8,u[e+26|0]=k>>>16,u[e+27|0]=k>>>24,u[e+28|0]=f,u[e+29|0]=f>>>8,u[e+30|0]=f>>>16,u[e+31|0]=f>>>24,f=l[8058]|l[8059]<<8|(l[8060]<<16|l[8061]<<24),k=l[8054]|l[8055]<<8|(l[8056]<<16|l[8057]<<24),u[e+16|0]=k,u[e+17|0]=k>>>8,u[e+18|0]=k>>>16,u[e+19|0]=k>>>24,u[e+20|0]=f,u[e+21|0]=f>>>8,u[e+22|0]=f>>>16,u[e+23|0]=f>>>24,f=l[8050]|l[8051]<<8|(l[8052]<<16|l[8053]<<24),k=l[8046]|l[8047]<<8|(l[8048]<<16|l[8049]<<24),u[e+8|0]=k,u[e+9|0]=k>>>8,u[e+10|0]=k>>>16,u[e+11|0]=k>>>24,u[e+12|0]=f,u[e+13|0]=f>>>8,u[e+14|0]=f>>>16,u[e+15|0]=f>>>24,q(A,2,0,n+12|0),u[n+23|0]<0&&Z(i[n+12>>2]),!r||(A=i[r+4>>2],i[r+4>>2]=A-1,A))break i;W[i[i[r>>2]+8>>2]](r),y(r);break i}i[A>>2]=0,i[A+4>>2]=0,i[A+16>>2]=0,i[A+8>>2]=0,i[A+12>>2]=0}u[n+43|0]<0&&Z(i[n+32>>2]),v=n+48|0}function Ev(A,e,r,f,k){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0;var n=0,t=0,o=0,s=0,w=0,h=0,_=0;n=v+-64|0,v=n;i:{e:{r:{f:{A:{if(!(f&&e)){e=i[23570],i[A>>2]=i[23569],i[A+4>>2]=e,i[A+8>>2]=i[23571];break A}if(o=p(168),i[o+4>>2]=0,i[o+8>>2]=0,i[o>>2]=91604,_=o+16|0,t=_,i[t+8>>2]=0,i[t+12>>2]=0,i[t+16>>2]=0,i[t+20>>2]=0,i[t+24>>2]=0,i[t+28>>2]=0,i[t+32>>2]=0,i[t>>2]=86356,i[o+60>>2]=0,i[o+64>>2]=0,i[o+52>>2]=0,i[o+56>>2]=0,i[o+72>>2]=-1,i[o+76>>2]=-1,i[o+80>>2]=-1,i[o+84>>2]=-1,i[o+116>>2]=0,i[o+88>>2]=0,i[o+92>>2]=0,i[o+96>>2]=0,i[o+100>>2]=0,i[o+104>>2]=0,i[o+108>>2]=0,g[o+112>>1]=0,i[t>>2]=89296,i[o+160>>2]=0,i[o+164>>2]=0,i[o+152>>2]=0,i[o+156>>2]=0,i[o+144>>2]=0,i[o+148>>2]=0,i[o+136>>2]=0,i[o+140>>2]=0,i[o+128>>2]=0,i[o+132>>2]=0,i[o+120>>2]=0,i[o+124>>2]=0,i[o+32>>2]=1969513843,t=i[f+4>>2],w=t||42673,s=h2(w),s>>>0>=2147483640)break f;k:{n:{if(s>>>0>=11){h=s|7,t=p(h+1|0),i[n+60>>2]=h-2147483647,i[n+52>>2]=t,i[n+56>>2]=s;break n}if(u[n+63|0]=s,t=n+52|0,!s)break k}if(!s)break k;x(t,w,s)}w=o+120|0,u[t+s|0]=0,t=u[n+63|0];k:{n:{if(u[o+131|0]>=0){if((t|0)>=0){t=i[n+56>>2],i[w>>2]=i[n+52>>2],i[w+4>>2]=t,i[w+8>>2]=i[n+60>>2];break k}M1(w,i[n+52>>2],i[n+56>>2]);break n}if(s=(t|0)<0,O1(w,s?i[n+52>>2]:n+52|0,s?i[n+56>>2]:t),u[n+63|0]>=0)break k}Z(i[n+52>>2])}if(t=i[f+8>>2],w=t||42673,s=h2(w),s>>>0>=2147483640)break r;k:{n:{if(s>>>0>=11){h=s|7,t=p(h+1|0),i[n+48>>2]=h-2147483647,i[n+40>>2]=t,i[n+44>>2]=s;break n}if(u[n+51|0]=s,t=n+40|0,!s)break k}if(!s)break k;x(t,w,s)}u[t+s|0]=0,t=o+132|0,s=u[n+51|0];k:{n:{if(u[o+143|0]>=0){if((s|0)>=0){s=i[n+44>>2],i[t>>2]=i[n+40>>2],i[t+4>>2]=s,i[t+8>>2]=i[n+48>>2];break k}M1(t,i[n+40>>2],i[n+44>>2]);break n}w=t,t=(s|0)<0,O1(w,t?i[n+40>>2]:n+40|0,t?i[n+44>>2]:s)}if(u[n+51|0]>=0)break k;Z(i[n+40>>2])}if(t=i[f+12>>2],w=t||42673,s=h2(w),s>>>0>=2147483640)break e;k:{n:{if(s>>>0>=11){h=s|7,t=p(h+1|0),i[n+36>>2]=h-2147483647,i[n+28>>2]=t,i[n+32>>2]=s;break n}if(u[n+39|0]=s,t=n+28|0,!s)break k}if(!s)break k;x(t,w,s)}u[t+s|0]=0,t=o+144|0,s=u[n+39|0];k:{n:{if(u[o+155|0]>=0){if((s|0)>=0){s=i[n+32>>2],i[t>>2]=i[n+28>>2],i[t+4>>2]=s,i[t+8>>2]=i[n+36>>2];break k}M1(t,i[n+28>>2],i[n+32>>2]);break n}w=t,t=(s|0)<0,O1(w,t?i[n+28>>2]:n+28|0,t?i[n+32>>2]:s)}if(u[n+39|0]>=0)break k;Z(i[n+28>>2])}if(f=i[f+16>>2],s=f||42673,f=h2(s),f>>>0>=2147483640)break i;k:{n:{if(f>>>0>=11){w=f|7,t=p(w+1|0),i[n+24>>2]=w-2147483647,i[n+16>>2]=t,i[n+20>>2]=f;break n}if(u[n+27|0]=f,t=n+16|0,!f)break k}if(!f)break k;x(t,s,f)}u[f+t|0]=0,f=o+156|0,t=u[n+27|0];k:{n:{if(u[o+167|0]>=0){if((t|0)>=0){t=i[n+20>>2],i[f>>2]=i[n+16>>2],i[f+4>>2]=t,i[f+8>>2]=i[n+24>>2];break k}M1(f,i[n+16>>2],i[n+20>>2]);break n}w=f,f=(t|0)<0,O1(w,f?i[n+16>>2]:n+16|0,f?i[n+20>>2]:t)}if(u[n+27|0]>=0)break k;Z(i[n+16>>2])}if(e=i[e>>2],i[n+12>>2]=o,i[n+8>>2]=_,i[o+4>>2]=i[o+4>>2]+1,f=i[n+12>>2],i[n>>2]=i[n+8>>2],i[n+4>>2]=f,e=re(e,r,n,0),k&&(i[k>>2]=e),e=i[24057],i[A>>2]=i[24056],i[A+4>>2]=e,i[A+8>>2]=i[24058],A=i[o+4>>2],i[o+4>>2]=A-1,A)break A;W[i[i[o>>2]+8>>2]](o),y(o)}v=n- -64|0;return}Q0(),H()}Q0(),H()}Q0(),H()}Q0(),H()}function _9(A,e){var r=0,f=0,k=0,n=0,t=0,o=0;t=v-16|0,v=t,r=p(68),i[r+4>>2]=0,i[r+8>>2]=0,i[r>>2]=106632,n=i[A+20>>2],f=i[A+24>>2],k=r+12|0,i[k+16>>2]=0,i[k+20>>2]=0,i[r+24>>2]=e,i[r+20>>2]=f,i[r+16>>2]=n,i[r+36>>2]=0,i[r+40>>2]=0,i[r+44>>2]=0,i[r+48>>2]=0,i[r+52>>2]=0,i[r+56>>2]=0,i[r+60>>2]=0,i[r+64>>2]=0,i[r+12>>2]=106468;i:{e:{r:switch(e-1|0){case 0:e=p(92),i[e+4>>2]=0,i[e+8>>2]=0,i[e>>2]=97464,o0(e+20|0,0,72),i[e+16>>2]=0,i[e+12>>2]=97712,u[e+20|0]=0,i[e+24>>2]=0,i[e+28>>2]=0,u[e+32|0]=0,i[e+36>>2]=0,i[e+40>>2]=0,u[e+44|0]=0;break e;case 3:e=p(84),i[e+28>>2]=0,i[e+32>>2]=0,i[e+4>>2]=0,i[e+8>>2]=0,u[e+19|0]=0,u[e+20|0]=0,u[e+21|0]=0,u[e+22|0]=0,u[e+23|0]=0,u[e+24|0]=0,u[e+25|0]=0,u[e+26|0]=0,u[e+18|0]=1,g[e+16>>1]=0,i[e+12>>2]=97960,i[e>>2]=97920,u[e+27|0]=0,u[e+28|0]=0,u[e+29|0]=0,u[e+30|0]=0,i[e+36>>2]=0,i[e+40>>2]=0,i[e+44>>2]=0,i[e+48>>2]=0,i[e+52>>2]=0,i[e+56>>2]=0,i[e+60>>2]=0,i[e+64>>2]=0,i[e+68>>2]=0,i[e+72>>2]=0,i[e+76>>2]=0,i[e+80>>2]=0;break e;case 4:e=p(92),i[e+4>>2]=0,i[e+8>>2]=0,i[e>>2]=99640,o0(e+20|0,0,72),i[e+16>>2]=0,i[e+12>>2]=99744,u[e+20|0]=0,i[e+24>>2]=0,i[e+28>>2]=0,u[e+32|0]=0,i[e+36>>2]=0,i[e+40>>2]=0,u[e+44|0]=0;break e;case 1:e=p(92),i[e+28>>2]=0,i[e+32>>2]=0,i[e+36>>2]=0,i[e+40>>2]=0,i[e+4>>2]=0,i[e+8>>2]=0,i[e+16>>2]=0,i[e+20>>2]=0,i[e+12>>2]=100256,i[e>>2]=100072,u[e+21|0]=0,u[e+22|0]=0,u[e+23|0]=0,u[e+24|0]=0,u[e+25|0]=0,u[e+26|0]=0,u[e+27|0]=0,u[e+28|0]=0,i[e+44>>2]=0,i[e+48>>2]=0,i[e+52>>2]=0,i[e+56>>2]=0,i[e+60>>2]=0,i[e+64>>2]=0,i[e+68>>2]=0,i[e+72>>2]=0,i[e+76>>2]=0,i[e+80>>2]=0,i[e+84>>2]=0,i[e+88>>2]=0,i[e+32>>2]=0,i[e+36>>2]=0,u[e+40|0]=0;break e;case 6:e=p(64),i[e+16>>2]=0,i[e+20>>2]=0,i[e+4>>2]=0,i[e+8>>2]=0,i[e+12>>2]=98976,i[e>>2]=98864,i[e+24>>2]=0,i[e+28>>2]=0,i[e+32>>2]=0,i[e+36>>2]=0,i[e+40>>2]=0,i[e+44>>2]=0,i[e+48>>2]=0,i[e+52>>2]=0,i[e+56>>2]=0,i[e+60>>2]=0;break e;case 9:e=p(64),i[e+16>>2]=0,i[e+20>>2]=0,i[e+4>>2]=0,i[e+8>>2]=0,i[e+12>>2]=99032,i[e>>2]=106500,i[e+24>>2]=0,i[e+28>>2]=0,i[e+32>>2]=0,i[e+36>>2]=0,i[e+40>>2]=0,i[e+44>>2]=0,i[e+48>>2]=0,i[e+52>>2]=0,i[e+56>>2]=0,i[e+60>>2]=0;break e;case 2:break r;default:break i}e=p(64),i[e+16>>2]=0,i[e+20>>2]=0,i[e+4>>2]=0,i[e+8>>2]=0,i[e+12>>2]=98656,i[e>>2]=98464,i[e+24>>2]=0,i[e+28>>2]=0,i[e+32>>2]=0,i[e+36>>2]=0,i[e+40>>2]=0,i[e+44>>2]=0,i[e+48>>2]=0,i[e+52>>2]=0,i[e+56>>2]=0,i[e+60>>2]=0}i[r+64>>2]=e,i[r+60>>2]=e+12}i[t+12>>2]=r,i[t+8>>2]=k,r2(A+100|0,t+8|0),o=i[A+104>>2]-i[A+100>>2]>>3;i:{if(r=i[A+188>>2],A=i[r+108>>2],f=i[r+112>>2],A>>>0<f>>>0){i[A+8>>2]=o,i[A>>2]=1,i[A+4>>2]=0,i[r+108>>2]=A+12;break i}e:{if(n=i[r+104>>2],A=A-n|0,e=((A|0)/12|0)+1|0,e>>>0<357913942){if(f=(f-n|0)/12|0,k=f<<1,k=f>>>0>=178956970?357913941:e>>>0<k>>>0?k:e,k){if(k>>>0>=357913942)break e;e=p(G(k,12))}else e=0;f=e+A|0,i[f+8>>2]=o,i[f>>2]=1,i[f+4>>2]=0,o=f+G((A|0)/-12|0,12)|0,A&&x(o,n,A),i[r+112>>2]=e+G(k,12),A=f+12|0,i[r+108>>2]=A,i[r+104>>2]=o,n&&Z(n),i[r+108>>2]=A;break i}G0(),H()}z0(),H()}A=i[t+12>>2];i:{if(!A||(e=i[A+4>>2],i[A+4>>2]=e-1,e))break i;W[i[i[A>>2]+8>>2]](A),y(A)}v=t+16|0}function pf(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0;var k=0,n=0,t=0,o=0,s=0,w=0;k=v-192|0,v=k,z2(k+168|0,e,r);i:{if(i[k+168>>2]!=i[26916]){e=i[k+172>>2],i[A>>2]=i[k+168>>2],i[A+4>>2]=e,i[A+16>>2]=i[k+184>>2],e=i[k+180>>2],i[A+8>>2]=i[k+176>>2],i[A+12>>2]=e,i[k+184>>2]=0,i[k+176>>2]=0,i[k+180>>2]=0;break i}s=e,w=C0(r),i[s+104>>2]=w,t=C0(r);e:{r:{f:{A:{k:{n:{if(t>>>0>i[r+16>>2]>>>2>>>0){i[k+112>>2]=0,i[k+84>>2]=72196,i[k+28>>2]=72176,e=i[18053],i[k+20>>2]=e,f=i[e-12>>2],e=k+20|0,i[f+e>>2]=i[18054],i[k+24>>2]=0,f=e+i[i[k+20>>2]-12>>2]|0,n=k+32|0,J0(f,n),u[f+80|0]=0,i[f+72>>2]=0,f=i[18055],i[k+28>>2]=f,o=k+28|0,i[o+i[f-12>>2]>>2]=i[18056],f=i[18052],i[k+20>>2]=f,i[e+i[f-12>>2]>>2]=i[18057],i[k+84>>2]=72196,i[k+20>>2]=72156,i[k+28>>2]=72176,f=R0(n),i[f>>2]=71232,i[k+72>>2]=0,i[k+76>>2]=0,i[k+64>>2]=0,i[k+68>>2]=0,i[k+80>>2]=24,e=i[r+16>>2],Y(V0(Y(V0(Y(o,28168,32),t),29063,32),e>>>2|0),24145,10),e=i[k+80>>2];t:{if(e&16){e=i[k+76>>2],r=i[k+56>>2],e>>>0<r>>>0&&(i[k+76>>2]=r,e=r),r=k+52|0;break t}if(!(e&8)){e=0,u[k+19|0]=0,r=k+8|0;break e}e=i[k+48>>2],r=k+40|0}if(t=i[r>>2],e=e-t|0,e>>>0>=2147483640)break n;if(e>>>0>=11){n=e|7,r=p(n+1|0),i[k+16>>2]=n-2147483647,i[k+8>>2]=r,i[k+12>>2]=e;break r}if(u[k+19|0]=e,r=k+8|0,e)break r;e=0;break e}if(n=i[f+56>>2],!(!n|n>>>0>=t>>>0)){i[k+112>>2]=0,i[k+84>>2]=72196,i[k+28>>2]=72176,e=i[18053],i[k+20>>2]=e,r=i[e-12>>2],e=k+20|0,i[r+e>>2]=i[18054],i[k+24>>2]=0,r=e+i[i[k+20>>2]-12>>2]|0,n=k+32|0,J0(r,n),u[r+80|0]=0,i[r+72>>2]=0,r=i[18055],i[k+28>>2]=r,o=i[r-12>>2],r=k+28|0,i[o+r>>2]=i[18056],o=i[18052],i[k+20>>2]=o,i[e+i[o-12>>2]>>2]=i[18057],i[k+84>>2]=72196,i[k+20>>2]=72156,i[k+28>>2]=72176,n=R0(n),i[n>>2]=71232,i[k+72>>2]=0,i[k+76>>2]=0,i[k+64>>2]=0,i[k+68>>2]=0,i[k+80>>2]=24,Y(V0(Y(V0(Y(r,27568,26),t),27858,44),i[f+56>>2]),24145,10),e=i[k+80>>2];t:{if(e&16){e=i[k+76>>2],r=i[k+56>>2],e>>>0<r>>>0&&(i[k+76>>2]=r,e=r),r=k+52|0;break t}if(!(e&8)){e=0,u[k+19|0]=0,r=k+8|0;break f}e=i[k+48>>2],r=k+40|0}if(f=i[r>>2],e=e-f|0,e>>>0>=2147483640)break k;if(e>>>0>=11){t=e|7,r=p(t+1|0),i[k+16>>2]=t-2147483647,i[k+8>>2]=r,i[k+12>>2]=e;break A}if(u[k+19|0]=e,r=k+8|0,e)break A;e=0;break f}f=e+108|0,o=i[e+108>>2],n=i[e+112>>2]-o>>2;t:{u:{if(n>>>0<t>>>0){V8(f,t-n|0);break u}if(n>>>0>t>>>0&&(i[e+112>>2]=o+(t<<2)),!t)break t}for(e=0;n=C0(r),i[i[f>>2]+(e<<2)>>2]=n,e=e+1|0,(t|0)!=(e|0););}if(e=i[26917],i[A>>2]=i[26916],i[A+4>>2]=e,A=A+8|0,u[107683]>=0){e=i[26919],i[A>>2]=i[26918],i[A+4>>2]=e,i[A+8>>2]=i[26920];break i}T(A,i[26918],i[26919]);break i}Q0(),H()}Q0(),H()}if(!e)break f;x(r,f,e)}u[e+r|0]=0,q(A,2,1e3,k+8|0),u[k+19|0]<0&&Z(i[k+8>>2]),A=i[18051],i[k+20>>2]=A,i[i[A-12>>2]+(k+20|0)>>2]=i[18059],i[k+28>>2]=i[18060],i[n>>2]=71232,u[k+75|0]<0&&Z(i[k+64>>2]),E0(n),y0(k+84|0);break i}if(!e)break e;x(r,t,e)}u[e+r|0]=0,q(A,2,100,k+8|0),u[k+19|0]<0&&Z(i[k+8>>2]),A=i[18051],i[k+20>>2]=A,i[i[A-12>>2]+(k+20|0)>>2]=i[18059],i[k+28>>2]=i[18060],i[f>>2]=71232,u[k+75|0]<0&&Z(i[k+64>>2]),E0(f),y0(k+84|0)}u[k+187|0]<0&&Z(i[k+176>>2]),v=k+192|0}function $6(A,e,r){var f=0,k=0,n=0,t=0,o=0,s=0,w=0,h=0;f=v-160|0,v=f,k=i[r>>2],n=W[i[i[k>>2]+8>>2]](k)|0,t=i[r>>2],k=l0,n=n+8|0,k=n>>>0<8?k+1|0:k;i:{if(W[i[i[t>>2]+12>>2]](t,n,k)|0){if(u[f+12|0]=0,u[f+23|0]=0,q(A,2,100,f+12|0),u[f+23|0]>=0)break i;Z(i[f+12>>2]);break i}w=e,h=C0(r),i[w+8>>2]=h,i[e+12>>2]=0,k=C0(r),i[e+32>>2]=8,i[e+16>>2]=k;e:{r:{f:{if(!i[e+12>>2]&i[e+8>>2]==1){if(k=i[r>>2],n=W[i[i[k>>2]+8>>2]](k)|0,t=i[r>>2],k=l0,n=n+8|0,k=n>>>0<8?k+1|0:k,W[i[i[t>>2]+12>>2]](t,n,k)|0){if(u[f+12|0]=0,u[f+23|0]=0,q(A,2,100,f+12|0),u[f+23|0]>=0)break i;Z(i[f+12>>2]);break i}if(k=C0(r),w=e,h=C0(r),i[w+8>>2]=h,i[e+12>>2]=k,i[e+32>>2]=i[e+32>>2]+8,i[f+76>>2]=72196,i[f+104>>2]=0,i[f+20>>2]=72176,k=i[18053],i[f+12>>2]=k,n=i[k-12>>2],k=f+12|0,i[n+k>>2]=i[18054],i[f+16>>2]=0,n=k+i[i[f+12>>2]-12>>2]|0,t=f+24|0,J0(n,t),u[n+80|0]=0,i[n+72>>2]=0,n=i[18055],i[f+20>>2]=n,o=i[n-12>>2],n=f+20|0,i[o+n>>2]=i[18056],o=i[18052],i[f+12>>2]=o,i[k+i[o-12>>2]>>2]=i[18057],i[f+76>>2]=72196,i[f+12>>2]=72156,i[f+20>>2]=72176,k=R0(t),i[k>>2]=71232,t=f- -64|0,i[t>>2]=0,i[t+4>>2]=0,i[f+56>>2]=0,i[f+60>>2]=0,i[f+72>>2]=24,Y(q2(Y(n,28701,9),i[e+8>>2],i[e+12>>2]),23474,24),n=f+76|0,t=i[e+12>>2],(t|0)==268435456|t>>>0>268435456){e=i[f+72>>2];A:{if(e&16){r=i[f+68>>2],e=i[f+48>>2],r>>>0<e>>>0&&(i[f+68>>2]=e,r=e),e=f+44|0;break A}if(!(e&8)){r=0,u[f+11|0]=0,e=f;break e}r=i[f+40>>2],e=f+32|0}if(t=i[e>>2],r=r-t|0,r>>>0>=2147483640)break f;if(r>>>0>=11){o=r|7,e=p(o+1|0),i[f+8>>2]=o-2147483647,i[f>>2]=e,i[f+4>>2]=r;break r}if(u[f+11|0]=r,e=f,r)break r;r=0;break e}t=i[18051],i[f+12>>2]=t,i[i[t-12>>2]+(f+12|0)>>2]=i[18059],i[f+20>>2]=i[18060],i[k>>2]=71232,u[f+67|0]<0&&Z(i[f+56>>2]),E0(k),y0(n),k=i[e+16>>2]}if((k|0)==1970628964){if(k=i[r>>2],n=W[i[i[k>>2]+8>>2]](k)|0,t=i[r>>2],k=l0,n=n+16|0,k=n>>>0<16?k+1|0:k,W[i[i[t>>2]+12>>2]](t,n,k)|0){if(u[f+12|0]=0,u[f+23|0]=0,q(A,2,100,f+12|0),u[f+23|0]>=0)break i;Z(i[f+12>>2]);break i}A:{if(!f4(r,16))break A;o=i[e+24>>2],k=i[e+20>>2],n=o-k|0;k:{if(n>>>0<=15){if(t=16-n|0,s=i[e+28>>2],t>>>0<=s-o>>>0){t&&o0(o,0,t),i[e+24>>2]=t+o;break k}if(o=s-k|0,s=o<<1,s=o>>>0>=1073741823?2147483647:s>>>0<=16?16:s,o=p(s),t&&o0(n+o|0,0,t),n&&x(o,k,n),i[e+28>>2]=o+s,i[e+24>>2]=o+16,i[e+20>>2]=o,!k)break k;Z(k);break k}if((n|0)==16)break k;i[e+24>>2]=k+16}if(n=i[r>>2],k=i[r+4>>2],k){if(i[k+4>>2]=i[k+4>>2]+1,W[i[i[n>>2]+16>>2]](n,i[e+20>>2],16)|0,n=i[k+4>>2],i[k+4>>2]=n-1,n)break A;W[i[i[k>>2]+8>>2]](k),y(k);break A}W[i[i[n>>2]+16>>2]](n,i[e+20>>2],16)|0}i[e+32>>2]=i[e+32>>2]+16}if(l[r+20|0]==1){if(u[f+12|0]=0,u[f+23|0]=0,q(A,2,100,f+12|0),u[f+23|0]>=0)break i;Z(i[f+12>>2]);break i}if(e=i[26917],i[A>>2]=i[26916],i[A+4>>2]=e,A=A+8|0,u[107683]>=0){e=i[26919],i[A>>2]=i[26918],i[A+4>>2]=e,i[A+8>>2]=i[26920];break i}T(A,i[26918],i[26919]);break i}Q0(),H()}if(!r)break e;x(e,t,r)}u[e+r|0]=0,q(A,6,1e3,f),u[f+11|0]<0&&Z(i[f>>2]),A=i[18051],i[f+12>>2]=A,i[i[A-12>>2]+(f+12|0)>>2]=i[18059],i[f+20>>2]=i[18060],i[k>>2]=71232,u[f+67|0]<0&&Z(i[f+56>>2]),E0(k),y0(n)}v=f+160|0}function B9(A,e){var r=0,f=0,k=0,n=0,t=0,o=0,s=0,w=0,h=0,_=0,B=0,m=0,X=0,Q=0;n=v-32|0,v=n,s=i[e+104>>2],m=i[e+108>>2];i:{if((s|0)!=(m|0))for(h=n+24|0;;){if(i[n+20>>2]=h,i[n+24>>2]=0,X=h,_=0,w=i[s+44>>2],Q=i[s+48>>2],(w|0)==(Q|0))e=0;else{e:{for(;;){r:{o=i[w>>2],r=h,k=r,e=r,t=i[n+24>>2],f=t;f:{A:{if(!f)break A;for(;k=r,e=f,B=o>>>0>u0[e+16>>2],r=B?r:e,f=i[(B?4:0)+e>>2],!!f;);if((r|0)!=(h|0)&o>>>0>=u0[(B?k:e)+16>>2])break r;for(;;){if(e=t,r=i[e+16>>2],r>>>0>o>>>0){if(k=e,t=i[e>>2],t)continue;break A}if(r>>>0>=o>>>0)break f;if(t=i[e+4>>2],!t)break}k=e+4|0}r=p(20),i[r+8>>2]=e,i[r>>2]=0,i[r+4>>2]=0,i[r+16>>2]=o,i[k>>2]=r,e=i[X>>2],e&&(i[n+20>>2]=e,X=e),t=i[n+24>>2],e=(t|0)==(r|0),u[r+12|0]=e;A:{if(e)break A;for(;;){if(k=i[r+8>>2],l[k+12|0])break A;k:{e=i[k+8>>2],f=i[e>>2];n:{if((k|0)==(f|0)){if(o=i[e+4>>2],!(!o|l[o+12|0])){u[k+12|0]=1,u[e+12|0]=(e|0)==(t|0),u[o+12|0]=1;break n}t:{if(i[k>>2]==(r|0)){r=k;break t}r=i[k+4>>2],f=i[r>>2],i[k+4>>2]=f;u:{if(!f){i[r+8>>2]=e,i[e>>2]=r;break u}if(i[f+8>>2]=k,e=i[k+8>>2],f=i[e>>2],i[r+8>>2]=e,(f|0)==(k|0)){i[e>>2]=r;break u}i[e+4>>2]=r}i[r>>2]=k,i[k+8>>2]=r,e=i[r+8>>2],f=i[e>>2]}u[r+12|0]=1,u[e+12|0]=0,r=i[f+4>>2],i[e>>2]=r,r&&(i[r+8>>2]=e),r=i[e+8>>2],i[f+8>>2]=r;t:{if(i[r>>2]==(e|0)){i[r>>2]=f;break t}i[r+4>>2]=f}i[f+4>>2]=e,i[e+8>>2]=f;break A}if(l[f+12|0]|!f)break k;u[k+12|0]=1,u[e+12|0]=(e|0)==(t|0),u[f+12|0]=1}if(r=e,(e|0)!=(t|0))continue;break A}break}f=i[k>>2];k:{if((f|0)!=(r|0)){f=k;break k}r=i[f+4>>2],i[k>>2]=r,r&&(i[r+8>>2]=k,e=i[k+8>>2]),i[f+8>>2]=e;n:{if((k|0)==i[e>>2]){i[e>>2]=f;break n}i[e+4>>2]=f}i[f+4>>2]=k,i[k+8>>2]=f,e=i[f+8>>2]}u[f+12|0]=1,u[e+12|0]=0,r=i[e+4>>2],f=i[r>>2],i[e+4>>2]=f,f&&(i[f+8>>2]=e),f=i[e+8>>2],i[r+8>>2]=f;k:{if(i[f>>2]==(e|0)){i[f>>2]=r;break k}i[f+4>>2]=r}i[r>>2]=e,i[e+8>>2]=r}_=_+1|0}if(w=w+4|0,(Q|0)!=(w|0))continue;break e}break}i[n+28>>2]=_,e=p(32),i[n+8>>2]=e,i[n+12>>2]=28,i[n+16>>2]=-2147483616,r=l[5853]|l[5854]<<8|(l[5855]<<16|l[5856]<<24),u[e+24|0]=r,u[e+25|0]=r>>>8,u[e+26|0]=r>>>16,u[e+27|0]=r>>>24,r=l[5849]|l[5850]<<8|(l[5851]<<16|l[5852]<<24),f=l[5845]|l[5846]<<8|(l[5847]<<16|l[5848]<<24),u[e+16|0]=f,u[e+17|0]=f>>>8,u[e+18|0]=f>>>16,u[e+19|0]=f>>>24,u[e+20|0]=r,u[e+21|0]=r>>>8,u[e+22|0]=r>>>16,u[e+23|0]=r>>>24,r=l[5841]|l[5842]<<8|(l[5843]<<16|l[5844]<<24),f=l[5837]|l[5838]<<8|(l[5839]<<16|l[5840]<<24),u[e+8|0]=f,u[e+9|0]=f>>>8,u[e+10|0]=f>>>16,u[e+11|0]=f>>>24,u[e+12|0]=r,u[e+13|0]=r>>>8,u[e+14|0]=r>>>16,u[e+15|0]=r>>>24,r=l[5833]|l[5834]<<8|(l[5835]<<16|l[5836]<<24),f=l[5829]|l[5830]<<8|(l[5831]<<16|l[5832]<<24),u[e|0]=f,u[e+1|0]=f>>>8,u[e+2|0]=f>>>16,u[e+3|0]=f>>>24,u[e+4|0]=r,u[e+5|0]=r>>>8,u[e+6|0]=r>>>16,u[e+7|0]=r>>>24,u[e+28|0]=0,q(A,2,0,n+8|0),u[n+19|0]<0&&Z(i[n+8>>2]),Y1(n+20|0,i[n+24>>2]);break i}e=i[n+24>>2]}if(i[n+28>>2]=_,Y1(n+20|0,e),s=s+56|0,(m|0)==(s|0))break}if(e=i[26917],i[A>>2]=i[26916],i[A+4>>2]=e,A=A+8|0,u[107683]>=0){e=i[26919],i[A>>2]=i[26918],i[A+4>>2]=e,i[A+8>>2]=i[26920];break i}T(A,i[26918],i[26919])}v=n+32|0}function v9(A,e){var r=0,f=0,k=0,n=0,t=0,o=0,s=0,w=0,h=0,_=0,B=0,m=0,X=0,Q=0;n=v-32|0,v=n,s=i[e+100>>2],m=i[e+104>>2];i:{if((s|0)!=(m|0))for(h=n+24|0;;){if(i[n+20>>2]=h,i[n+24>>2]=0,X=h,_=0,w=i[s+4>>2],Q=i[s+8>>2],(w|0)==(Q|0))e=0;else{e:{for(;;){r:{o=i[w>>2],r=h,k=r,e=r,t=i[n+24>>2],f=t;f:{A:{if(!f)break A;for(;k=r,e=f,B=o>>>0>u0[e+16>>2],r=B?r:e,f=i[(B?4:0)+e>>2],!!f;);if((r|0)!=(h|0)&o>>>0>=u0[(B?k:e)+16>>2])break r;for(;;){if(e=t,r=i[e+16>>2],r>>>0>o>>>0){if(k=e,t=i[e>>2],t)continue;break A}if(r>>>0>=o>>>0)break f;if(t=i[e+4>>2],!t)break}k=e+4|0}r=p(20),i[r+8>>2]=e,i[r>>2]=0,i[r+4>>2]=0,i[r+16>>2]=o,i[k>>2]=r,e=i[X>>2],e&&(i[n+20>>2]=e,X=e),t=i[n+24>>2],e=(t|0)==(r|0),u[r+12|0]=e;A:{if(e)break A;for(;;){if(k=i[r+8>>2],l[k+12|0])break A;k:{e=i[k+8>>2],f=i[e>>2];n:{if((k|0)==(f|0)){if(o=i[e+4>>2],!(!o|l[o+12|0])){u[k+12|0]=1,u[e+12|0]=(e|0)==(t|0),u[o+12|0]=1;break n}t:{if(i[k>>2]==(r|0)){r=k;break t}r=i[k+4>>2],f=i[r>>2],i[k+4>>2]=f;u:{if(!f){i[r+8>>2]=e,i[e>>2]=r;break u}if(i[f+8>>2]=k,e=i[k+8>>2],f=i[e>>2],i[r+8>>2]=e,(f|0)==(k|0)){i[e>>2]=r;break u}i[e+4>>2]=r}i[r>>2]=k,i[k+8>>2]=r,e=i[r+8>>2],f=i[e>>2]}u[r+12|0]=1,u[e+12|0]=0,r=i[f+4>>2],i[e>>2]=r,r&&(i[r+8>>2]=e),r=i[e+8>>2],i[f+8>>2]=r;t:{if(i[r>>2]==(e|0)){i[r>>2]=f;break t}i[r+4>>2]=f}i[f+4>>2]=e,i[e+8>>2]=f;break A}if(l[f+12|0]|!f)break k;u[k+12|0]=1,u[e+12|0]=(e|0)==(t|0),u[f+12|0]=1}if(r=e,(e|0)!=(t|0))continue;break A}break}f=i[k>>2];k:{if((f|0)!=(r|0)){f=k;break k}r=i[f+4>>2],i[k>>2]=r,r&&(i[r+8>>2]=k,e=i[k+8>>2]),i[f+8>>2]=e;n:{if((k|0)==i[e>>2]){i[e>>2]=f;break n}i[e+4>>2]=f}i[f+4>>2]=k,i[k+8>>2]=f,e=i[f+8>>2]}u[f+12|0]=1,u[e+12|0]=0,r=i[e+4>>2],f=i[r>>2],i[e+4>>2]=f,f&&(i[f+8>>2]=e),f=i[e+8>>2],i[r+8>>2]=f;k:{if(i[f>>2]==(e|0)){i[f>>2]=r;break k}i[f+4>>2]=r}i[r>>2]=e,i[e+8>>2]=r}_=_+1|0}if(w=w+4|0,(Q|0)!=(w|0))continue;break e}break}i[n+28>>2]=_,e=p(32),i[n+8>>2]=e,i[n+12>>2]=28,i[n+16>>2]=-2147483616,r=l[5824]|l[5825]<<8|(l[5826]<<16|l[5827]<<24),u[e+24|0]=r,u[e+25|0]=r>>>8,u[e+26|0]=r>>>16,u[e+27|0]=r>>>24,r=l[5820]|l[5821]<<8|(l[5822]<<16|l[5823]<<24),f=l[5816]|l[5817]<<8|(l[5818]<<16|l[5819]<<24),u[e+16|0]=f,u[e+17|0]=f>>>8,u[e+18|0]=f>>>16,u[e+19|0]=f>>>24,u[e+20|0]=r,u[e+21|0]=r>>>8,u[e+22|0]=r>>>16,u[e+23|0]=r>>>24,r=l[5812]|l[5813]<<8|(l[5814]<<16|l[5815]<<24),f=l[5808]|l[5809]<<8|(l[5810]<<16|l[5811]<<24),u[e+8|0]=f,u[e+9|0]=f>>>8,u[e+10|0]=f>>>16,u[e+11|0]=f>>>24,u[e+12|0]=r,u[e+13|0]=r>>>8,u[e+14|0]=r>>>16,u[e+15|0]=r>>>24,r=l[5804]|l[5805]<<8|(l[5806]<<16|l[5807]<<24),f=l[5800]|l[5801]<<8|(l[5802]<<16|l[5803]<<24),u[e|0]=f,u[e+1|0]=f>>>8,u[e+2|0]=f>>>16,u[e+3|0]=f>>>24,u[e+4|0]=r,u[e+5|0]=r>>>8,u[e+6|0]=r>>>16,u[e+7|0]=r>>>24,u[e+28|0]=0,q(A,2,0,n+8|0),u[n+19|0]<0&&Z(i[n+8>>2]),Y1(n+20|0,i[n+24>>2]);break i}e=i[n+24>>2]}if(i[n+28>>2]=_,Y1(n+20|0,e),s=s+16|0,(m|0)==(s|0))break}if(e=i[26917],i[A>>2]=i[26916],i[A+4>>2]=e,A=A+8|0,u[107683]>=0){e=i[26919],i[A>>2]=i[26918],i[A+4>>2]=e,i[A+8>>2]=i[26920];break i}T(A,i[26918],i[26919])}v=n+32|0}function m9(A,e,r,f,k,n,t){var o=0,s=0,w=0,h=0,_=0,B=0,m=0,X=0,Q=0,V=0;V=v;i:{e:{r:{f:{A:{k:{n:{t:{u:{o:{if(!k||!(v0(r,1)&255))break o;if(t){if(A=0,e=f2(r),(e|0)==-99999|(e|0)>=(k|0))break r;A=e^-1}else A=-1;if(w=A+k|0,(w|0)<0)break t;if(e=v0(r,1),A=f2(r),(A|0)==-99999)break i;for(m=l[(i[n>>2]+G(w,100)|0)+98|0],k=m+16&496,s=V-k|0,t=s,v=t,o=A^-1,_=A+1|0,h=t-k|0,v=h,k=0;A=v0(r,1),u[k+s|0]=A,t=k+h|0,A&255?A=1:A=v0(r,1),u[t|0]=A,A=(k|0)!=(m|0),k=k+1|0,!!A;);o=e?o:_,r=G(w,100),e=r+i[n>>2]|0,A=l[e+96|0],e=l[e+97|0];l:{if(!e){t=0;break l}for(_=f- -64|0,t=0,B=e>>>0<17,k=e;;){if(X=i[n>>2],w>>>0>=(i[n+4>>2]-X|0)/100>>>0)break n;if(!B)break k;k=k-1|0,X=o+g[((r+X|0)+(k<<1)|0)+32>>1]|0;s:{if((X|0)>=0||(Q=A+k|0,!l[Q+h|0]))break s;if((t|0)>15)break i;g[(t<<1)+f>>1]=X,u[t+_|0]=l[s+Q|0],t=t+1|0}if(!k)break}}if(!(!l[h+m|0]|(o|0)>=0)){if((t|0)>15)break i;g[(t<<1)+f>>1]=o,u[(f+t|0)- -64|0]=l[s+m|0],t=t+1|0}l:{if(!A){u[f+96|0]=t,k=0;break l}for(r=f- -64|0,k=0,_=G(w,100);;){if(B=o+g[(_+i[n>>2]|0)+(k<<1)>>1]|0,!(!l[k+h|0]|(B|0)>=0)){if((t|0)>15)break i;g[(t<<1)+f>>1]=B,u[r+t|0]=l[k+s|0],t=t+1|0}if(k=k+1|0,(A|0)==(k|0))break}for(u[f+96|0]=t,_=f+80|0,B=f+32|0,k=0,X=G(w,100),t=A;;){if(r=t,t=t-1|0,Q=o+g[(X+i[n>>2]|0)+(t<<1)>>1]|0,!((Q|0)<=0|!l[t+h|0])){if((k|0)>15)break i;g[B+(k<<1)>>1]=Q,u[k+_|0]=l[t+s|0],k=k+1|0}if(!((r|0)>1))break}}if(!(!l[h+m|0]|(o|0)<=0)){if((k|0)>15)break i;g[((k<<1)+f|0)+32>>1]=o,u[(f+k|0)+80|0]=l[s+m|0],k=k+1|0}if(e)for(r=f+80|0,m=f+32|0,t=0,w=G(w,100);;){_=o+g[((w+i[n>>2]|0)+(t<<1)|0)+32>>1]|0;l:{if((_|0)<=0||(B=A+t|0,!l[B+h|0]))break l;if((k|0)>15)break i;g[m+(k<<1)>>1]=_,u[r+k|0]=l[s+B|0],k=k+1|0}if(t=t+1|0,(e|0)==(t|0))break}u[f+97|0]=k;break u}if(n=f2(r),o=f2(r),!((n|0)!=-99999&(o|0)!=-99999))break e;if(i[((u[e+2|0]<<2)+e|0)+524>>2]<(n+o|0)){g[f+96>>1]=0,g[f+98>>1]=0;break e}if(!((o|0)<17&(n|0)<=16))break e;if(u[f+97|0]=o,u[f+96|0]=n,(n|0)>0)for(t=f- -64|0,A=0,k=0,e=0;;){if(s=f2(r),(s|0)==-99999)break r;if(h=v0(r,1),w=(k<<1)+f|0,g[w>>1]=(s^-1)+e,u[k+t|0]=h,e=C[w>>1],k=k+1|0,(n|0)==(k|0))break}if((o|0)<=0)break u;for(e=f+80|0,n=f+32|0,A=0,k=0,t=0;;){if(s=f2(r),(s|0)==-99999)break r;if(h=v0(r,1),w=n+(k<<1)|0,g[w>>1]=(t+s|0)+1,u[e+k|0]=h,t=C[w>>1],k=k+1|0,(o|0)==(k|0))break}}if(k=0,u[f+99|0]=0,A=l[f+96|0],!A)break f;if(n=A&1,e=f- -64|0,(A|0)==1){r=0;break A}for(o=A&254,r=0,t=0;s=e+r|0,l[s|0]&&(k=k+1|0,u[f+99|0]=k),l[s+1|0]&&(k=k+1|0,u[f+99|0]=k),r=r+2|0,t=t+2|0,(o|0)!=(t|0););break A}D0(21930,18306,129,4203),H()}D0(26867,18306,174,4203),H()}D0(19347,18306,175,4203),H()}if(!n|!l[e+r|0])break f;k=k+1|0,u[f+99|0]=k}e=l[f+97|0];f:{if(!e)break f;if(n=f+80|0,r=0,(e|0)!=1)for(o=e&254,t=0;s=r+n|0,l[s|0]&&(k=k+1|0,u[f+99|0]=k),l[s+1|0]&&(k=k+1|0,u[f+99|0]=k),r=r+2|0,t=t+2|0,(o|0)!=(t|0););if(!(e&1)|!l[r+n|0])break f;u[f+99|0]=k+1}u[f+98|0]=A+e,A=1}return v=V,A}F2(A,1018,0)}return v=V,0}function Yv(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0;var k=0,n=0,t=0,o=0,s=0,w=0;k=v-160|0,v=k,t=o2(r);i:{e:{r:{f:{A:{k:{n:{if(n=i[f+48>>2],!(!n|t>>>0<=n>>>0)){i[k+104>>2]=0,i[k+76>>2]=72196,i[k+20>>2]=72176,e=i[18053],i[k+12>>2]=e,r=i[e-12>>2],e=k+12|0,i[r+e>>2]=i[18054],i[k+16>>2]=0,r=e+i[i[k+12>>2]-12>>2]|0,n=k+24|0,J0(r,n),u[r+80|0]=0,i[r+72>>2]=0,r=i[18055],i[k+20>>2]=r,o=i[r-12>>2],r=k+20|0,i[o+r>>2]=i[18056],o=i[18052],i[k+12>>2]=o,i[e+i[o-12>>2]>>2]=i[18057],i[k+76>>2]=72196,i[k+12>>2]=72156,i[k+20>>2]=72176,n=R0(n),i[n>>2]=71232,e=k- -64|0,i[e>>2]=0,i[e+4>>2]=0,i[k+56>>2]=0,i[k+60>>2]=0,i[k+72>>2]=24,Y(V0(Y(V0(Y(r,28785,25),t),27803,54),i[f+48>>2]),4526,11),e=i[k+72>>2];t:{if(e&16){f=k+44|0,r=i[k+68>>2],e=i[k+48>>2],r>>>0<e>>>0?i[k+68>>2]=e:e=r;break t}if(!(e&8)){r=0,u[k+11|0]=0,f=k;break e}f=k+32|0,e=i[k+40>>2]}if(r=e,e=i[f>>2],r=r-e|0,r>>>0>=2147483640)break n;if(r>>>0>=11){t=r|7,f=p(t+1|0),i[k+8>>2]=t-2147483647,i[k>>2]=f,i[k+4>>2]=r;break r}if(u[k+11|0]=r,f=k,r)break r;r=0;break e}if(t>>>0>u0[r+16>>2]/6>>>0){i[k+104>>2]=0,i[k+76>>2]=72196,i[k+20>>2]=72176,e=i[18053],i[k+12>>2]=e,f=i[e-12>>2],e=k+12|0,i[f+e>>2]=i[18054],i[k+16>>2]=0,f=e+i[i[k+12>>2]-12>>2]|0,n=k+24|0,J0(f,n),u[f+80|0]=0,i[f+72>>2]=0,f=i[18055],i[k+20>>2]=f,o=i[f-12>>2],f=k+20|0,i[o+f>>2]=i[18056],o=i[18052],i[k+12>>2]=o,i[e+i[o-12>>2]>>2]=i[18057],i[k+76>>2]=72196,i[k+12>>2]=72156,i[k+20>>2]=72176,n=R0(n),i[n>>2]=71232,e=k- -64|0,i[e>>2]=0,i[e+4>>2]=0,i[k+56>>2]=0,i[k+60>>2]=0,i[k+72>>2]=24,Y(V0(Y(V0(Y(f,28785,25),t),27523,44),u0[r+16>>2]/6|0),4526,11),e=i[k+72>>2];t:{if(e&16){f=k+44|0,r=i[k+68>>2],e=i[k+48>>2],r>>>0<e>>>0?i[k+68>>2]=e:e=r;break t}if(!(e&8)){r=0,u[k+11|0]=0,f=k;break f}f=k+32|0,e=i[k+40>>2]}if(r=e,e=i[f>>2],r=r-e|0,r>>>0>=2147483640)break n;if(r>>>0>=11){t=r|7,f=p(t+1|0),i[k+8>>2]=t-2147483647,i[k>>2]=f,i[k+4>>2]=r;break A}if(u[k+11|0]=r,f=k,r)break A;r=0;break f}n=e+100|0,o=i[e+100>>2],f=(i[e+104>>2]-o|0)/6|0;t:{if(f>>>0<t>>>0){Ht(n,t-f|0);break t}if(f>>>0<=t>>>0)break t;i[e+104>>2]=o+G(t,6)}e=l[r+20|0];t:{if(!(!i[r+16>>2]|(!t|e&1))){for(f=0;;){u:{if(o=o2(r),s=o2(r),w=o2(r),e=i[n>>2]+G(f,6)|0,g[e+4>>1]=w,g[e+2>>1]=s,g[e>>1]=o,e=l[r+20|0],f=f+1|0,e&1|t>>>0<=f>>>0)break u;if(i[r+16>>2])continue}break}if(e&1)break t;break k}if(!(e&1))break k}if(u[k+12|0]=0,u[k+23|0]=0,q(A,2,100,k+12|0),u[k+23|0]>=0)break i;Z(i[k+12>>2]);break i}Q0(),H()}if(e=i[26917],i[A>>2]=i[26916],i[A+4>>2]=e,A=A+8|0,u[107683]>=0){e=i[26919],i[A>>2]=i[26918],i[A+4>>2]=e,i[A+8>>2]=i[26920];break i}T(A,i[26918],i[26919]);break i}if(!r)break f;x(f,e,r)}u[r+f|0]=0,q(A,2,100,k),u[k+11|0]<0&&Z(i[k>>2]),A=i[18051],i[k+12>>2]=A,i[i[A-12>>2]+(k+12|0)>>2]=i[18059],i[k+20>>2]=i[18060],i[n>>2]=71232,u[k+67|0]<0&&Z(i[k+56>>2]),E0(n),y0(k+76|0);break i}if(!r)break e;x(f,e,r)}u[r+f|0]=0,q(A,2,1e3,k),u[k+11|0]<0&&Z(i[k>>2]),A=i[18051],i[k+12>>2]=A,i[i[A-12>>2]+(k+12|0)>>2]=i[18059],i[k+20>>2]=i[18060],i[n>>2]=71232,u[k+67|0]<0&&Z(i[k+56>>2]),E0(n),y0(k+76|0)}v=k+160|0}function Z9(A,e,r,f){var k=0,n=0,t=0,o=0,s=0;n=v-80|0,v=n,k=n+48|0,Ef(k,e,r);i:{e:{if(t=l[n+68|0],(t|0)==255||(o=i[23601],i[n+32>>2]=i[23600],i[n+36>>2]=o,o=n+32|0,W[i[o+(t<<2)>>2]](n+79|0,k),t))break e;e=p(48),i[n+32>>2]=e,i[n+36>>2]=45,i[n+40>>2]=-2147483600,r=l[22226]|l[22227]<<8|(l[22228]<<16|l[22229]<<24),f=l[22222]|l[22223]<<8|(l[22224]<<16|l[22225]<<24),u[e+37|0]=f,u[e+38|0]=f>>>8,u[e+39|0]=f>>>16,u[e+40|0]=f>>>24,u[e+41|0]=r,u[e+42|0]=r>>>8,u[e+43|0]=r>>>16,u[e+44|0]=r>>>24,r=l[22221]|l[22222]<<8|(l[22223]<<16|l[22224]<<24),f=l[22217]|l[22218]<<8|(l[22219]<<16|l[22220]<<24),u[e+32|0]=f,u[e+33|0]=f>>>8,u[e+34|0]=f>>>16,u[e+35|0]=f>>>24,u[e+36|0]=r,u[e+37|0]=r>>>8,u[e+38|0]=r>>>16,u[e+39|0]=r>>>24,r=l[22213]|l[22214]<<8|(l[22215]<<16|l[22216]<<24),f=l[22209]|l[22210]<<8|(l[22211]<<16|l[22212]<<24),u[e+24|0]=f,u[e+25|0]=f>>>8,u[e+26|0]=f>>>16,u[e+27|0]=f>>>24,u[e+28|0]=r,u[e+29|0]=r>>>8,u[e+30|0]=r>>>16,u[e+31|0]=r>>>24,r=l[22205]|l[22206]<<8|(l[22207]<<16|l[22208]<<24),f=l[22201]|l[22202]<<8|(l[22203]<<16|l[22204]<<24),u[e+16|0]=f,u[e+17|0]=f>>>8,u[e+18|0]=f>>>16,u[e+19|0]=f>>>24,u[e+20|0]=r,u[e+21|0]=r>>>8,u[e+22|0]=r>>>16,u[e+23|0]=r>>>24,r=l[22197]|l[22198]<<8|(l[22199]<<16|l[22200]<<24),f=l[22193]|l[22194]<<8|(l[22195]<<16|l[22196]<<24),u[e+8|0]=f,u[e+9|0]=f>>>8,u[e+10|0]=f>>>16,u[e+11|0]=f>>>24,u[e+12|0]=r,u[e+13|0]=r>>>8,u[e+14|0]=r>>>16,u[e+15|0]=r>>>24,r=l[22189]|l[22190]<<8|(l[22191]<<16|l[22192]<<24),f=l[22185]|l[22186]<<8|(l[22187]<<16|l[22188]<<24),u[e|0]=f,u[e+1|0]=f>>>8,u[e+2|0]=f>>>16,u[e+3|0]=f>>>24,u[e+4|0]=r,u[e+5|0]=r>>>8,u[e+6|0]=r>>>16,u[e+7|0]=r>>>24,u[e+45|0]=0,e=q(k,5,0,o),r=i[e+4>>2],i[A>>2]=i[e>>2],i[A+4>>2]=r,r=A+8|0;r:{if(u[e+19|0]>=0){f=i[e+12>>2],i[r>>2]=i[e+8>>2],i[r+4>>2]=f,i[r+8>>2]=i[e+16>>2],u[A+20|0]=1;break r}if(T(r,i[e+8>>2],i[e+12>>2]),r=u[e+19|0],u[A+20|0]=1,(r|0)>=0)break r;Z(i[e+8>>2])}if(u[n+43|0]>=0)break i;Z(i[n+32>>2]);break i}k=p(136),i[k+4>>2]=0,i[k+8>>2]=0,i[k>>2]=91804,o=k+16|0,t=o,i[t+8>>2]=0,i[t+12>>2]=0,i[t+16>>2]=0,i[t+20>>2]=0,i[t+24>>2]=0,i[t+28>>2]=0,i[t+32>>2]=0,i[t>>2]=86356,i[k+60>>2]=0,i[k+64>>2]=0,i[k+52>>2]=0,i[k+56>>2]=0,i[k+72>>2]=-1,i[k+76>>2]=-1,i[k+80>>2]=-1,i[k+84>>2]=-1,i[k+116>>2]=0,i[k+88>>2]=0,i[k+92>>2]=0,i[k+96>>2]=0,i[k+100>>2]=0,i[k+104>>2]=0,i[k+108>>2]=0,g[k+112>>1]=0,i[t>>2]=89592,i[k+128>>2]=0,i[k+120>>2]=0,i[k+124>>2]=0,i[k+32>>2]=1701604967,t=k+120|0;e:{r:{f:{A:{if(u[f+11|0]>=0){if(i[n+24>>2]=i[f+8>>2],s=i[f+4>>2],i[n+16>>2]=i[f>>2],i[n+20>>2]=s,u[n+27|0]>=0)break A;break r}if(T(n+16|0,i[f>>2],i[f+4>>2]),f=u[n+27|0],u[k+131|0]<0)break f;if((f|0)<0)break r}f=i[n+20>>2],i[t>>2]=i[n+16>>2],i[t+4>>2]=f,i[t+8>>2]=i[n+24>>2];break e}s=t,t=(f|0)<0,O1(s,t?i[n+16>>2]:n+16|0,t?i[n+20>>2]:f);break e}M1(t,i[n+16>>2],i[n+20>>2])}if(u[n+27|0]<0&&Z(i[n+16>>2]),i[n+12>>2]=k,i[n+8>>2]=o,i[k+4>>2]=i[k+4>>2]+1,f=i[n+12>>2],i[n>>2]=i[n+8>>2],i[n+4>>2]=f,e=re(e,r,n,0),u[A+20|0]=0,i[A>>2]=e,A=i[k+4>>2],i[k+4>>2]=A-1,A)break i;W[i[i[k>>2]+8>>2]](k),y(k)}v=n+80|0}function G9(){var A=0,e=0,r=0,f=0,k=0,n=0,t=0,o=0,s=0,w=0,h=0,_=0,B=0,m=0;Je(),h=p(8),w=p(216),i[w>>2]=96864,i[w+4>>2]=0,i[w+8>>2]=0,f=w+16|0,A=f,i[A>>2]=0,i[A+4>>2]=0,i[A+20>>2]=0,i[A+24>>2]=0,i[A+28>>2]=0,i[A+32>>2]=0,i[A+8>>2]=0,i[A+12>>2]=4740,i[A+16>>2]=A+20,i[A+36>>2]=0,i[A+40>>2]=0,i[A+44>>2]=0,i[A+48>>2]=0,i[A+52>>2]=0,i[A+56>>2]=4,i[A+152>>2]=0,l[107752]||(u[107752]=1),k=f- -64|0,A=i[26940];i:{e:{if(!A){r=107760,e=107760;break e}for(;;){if(e=A,r=i[A+16>>2],r>>>0>k>>>0){if(r=A,A=i[A>>2],A)continue;break e}if(r>>>0>=k>>>0)break i;if(A=i[e+4>>2],!A)break}r=e+4|0}A=p(28),i[A+20>>2]=0,i[A+24>>2]=0,i[A+16>>2]=k,i[A+8>>2]=e,i[A>>2]=0,i[A+4>>2]=0,i[r>>2]=A,e=i[i[26939]>>2],e&&(i[26939]=e),m1(i[26940],A),i[26941]=i[26941]+1}i[A+20>>2]=0,i[A+24>>2]=0,i[f+152>>2]=k,i[f+156>>2]=0,i[f+160>>2]=0,i[f+184>>2]=0,i[f+188>>2]=0,i[f+164>>2]=0,i[f+168>>2]=0,i[f+172>>2]=0,i[f+176>>2]=0,i[f+192>>2]=0,i[f+196>>2]=1,i[f+180>>2]=f+184;i:{e:{if(A=Tr(19249),!A||n4(A,11364)&&n4(A,19658))break e;x(k,95608,88);break i}x(k,95520,88)}e=p(172),i[e+4>>2]=0,i[e+8>>2]=0,i[e>>2]=94424,B=f,m=Zr(e+12|0),i[B+48>>2]=m,A=i[f+52>>2],i[f+52>>2]=e;i:{if(!A||(e=i[A+4>>2],i[A+4>>2]=e-1,e))break i;W[i[i[A>>2]+8>>2]](A),y(A)}if(e=i[f+48>>2],i[e+156>>2]=f- -64,A=i[e+20>>2],k=i[e+16>>2],(A|0)!=(k|0))for(;;){r=i[A-4>>2];i:{if(!r||(s=i[r+4>>2],i[r+4>>2]=s-1,s))break i;W[i[i[r>>2]+8>>2]](r),y(r)}if(A=A-8|0,(k|0)==(A|0))break}i[e+20>>2]=k,A=p(136),i[A>>2]=89724,i[A+4>>2]=0,i[A+8>>2]=0,r=A+16|0,i[r+8>>2]=0,i[r+12>>2]=0,i[r+16>>2]=0,i[r+20>>2]=0,i[r+24>>2]=0,i[r+28>>2]=0,i[r+32>>2]=0,i[r>>2]=86356,i[A+60>>2]=0,i[A+64>>2]=0,i[A+52>>2]=0,i[A+56>>2]=0,i[A+72>>2]=-1,i[A+76>>2]=-1,i[A+80>>2]=-1,i[A+84>>2]=-1,i[A+88>>2]=0,i[A+92>>2]=0,i[A+96>>2]=0,i[A+100>>2]=0,i[A+104>>2]=0,i[A+108>>2]=0,u[A+112|0]=0,i[r>>2]=86884,i[A+132>>2]=0,i[A+124>>2]=0,i[A+128>>2]=0,i[A+116>>2]=0,i[A+120>>2]=0,i[A+32>>2]=1718909296,i[e+28>>2]=r,k=i[e+32>>2],i[e+32>>2]=A;i:{e:{if(!k||(A=i[k+4>>2],i[k+4>>2]=A-1,A||(W[i[i[k>>2]+8>>2]](k),y(k)),r=i[e+28>>2],A=i[e+32>>2],A))break e;A=0;break i}i[A+4>>2]=i[A+4>>2]+1}i:{if(k=i[e+20>>2],n=i[e+24>>2],k>>>0<n>>>0){i[k+4>>2]=A,i[k>>2]=r,i[e+20>>2]=k+8;break i}e:{if(t=k,k=i[e+16>>2],s=t-k|0,_=s>>3,o=_+1|0,o>>>0<536870912){if(n=n-k|0,t=n>>2,o=n>>>0>=2147483640?536870911:o>>>0<t>>>0?t:o,o){if(o>>>0>=536870912)break e;t=p(o<<3)}else t=0;n=t+s|0,i[n+4>>2]=A,i[n>>2]=r,A=n-(_<<3)|0,s&&x(A,k,s),i[e+24>>2]=t+(o<<3),r=n+8|0,i[e+20>>2]=r,i[e+16>>2]=A,k&&Z(k),i[e+20>>2]=r;break i}G0(),H()}z0(),H()}if(Ce(f+16|0,i[f+20>>2]),i[f+16>>2]=f+20,i[f+20>>2]=0,i[f+24>>2]=0,A=i[f+32>>2],r=i[f+28>>2],(A|0)!=(r|0))for(;;){e=i[A-4>>2];i:{if(!e||(k=i[e+4>>2],i[e+4>>2]=k-1,k))break i;W[i[i[e>>2]+8>>2]](e),y(e)}if(A=A-8|0,(r|0)==(A|0))break}i[f+32>>2]=r,A=i[f+44>>2],i[f+40>>2]=0,i[f+44>>2]=0;i:{if(!A||(e=i[A+4>>2],i[A+4>>2]=e-1,e))break i;W[i[i[A>>2]+8>>2]](A),y(A)}return i[h+4>>2]=w,i[h>>2]=f,h|0}function X9(A,e,r){var f=0,k=0,n=0,t=0,o=0,s=0,w=0,h=0,_=0,B=0,m=0,X=0,Q=0,V=0,F=0,I=0;n=v-48|0,v=n,f=p(172),i[f+4>>2]=0,i[f+8>>2]=0,i[f>>2]=94812,o0(f+16|0,0,80),k=i[f+4>>2],o=k+1|0,i[f+4>>2]=o,i[f+104>>2]=0,i[f+108>>2]=0,i[f+36>>2]=1,i[f+40>>2]=1,u[f+24|0]=1,g[f+22>>1]=2,g[f+18>>1]=2,g[f+20>>1]=2,i[f+112>>2]=0,i[f+116>>2]=4740,i[f+140>>2]=0,i[f+144>>2]=0,i[f+128>>2]=99,i[f+132>>2]=99,i[f+120>>2]=0,i[f+124>>2]=0,i[f+12>>2]=95160,i[f+148>>2]=0,i[f+152>>2]=0,i[f+136>>2]=f+140,i[f+156>>2]=0,i[f+160>>2]=0,i[f+164>>2]=0,i[f+168>>2]=0,i[f+4>>2]=k,k=i[f+8>>2],s=f+12|0,i[f+96>>2]=s,i[f+8>>2]=k+1,i[f+100>>2]=f,o||(W[i[i[f>>2]+8>>2]](f),y(f)),k=i[e>>2],o=i[k+108>>2],k=i[k+112>>2],i[s+120>>2]=0,i[s+116>>2]=2,i[s+112>>2]=k,i[s+108>>2]=o;i:{e:{r:{if(u1(i[e>>2],6)){if(i[n+8>>2]=i[e>>2],e=i[e+4>>2],i[n+12>>2]=e,e&&(i[e+4>>2]=i[e+4>>2]+1),f6(n+28|0,s,n+8|0,6,0,r),u[n+47|0]<0&&Z(i[n+36>>2]),r=i[n+12>>2],!r||(e=i[r+4>>2],i[r+4>>2]=e-1,e))break r;W[i[i[r>>2]+8>>2]](r),y(r);break r}if(k=i[e>>2],i[k+120>>2]!=11)break r;i[n>>2]=k,e=i[e+4>>2],i[n+4>>2]=e,e&&(i[e+4>>2]=i[e+4>>2]+1),h=n+8|0,k=i[n>>2],X=i[k+112>>2],w=i[k+108>>2],_=255,e=i[k+128>>2];f:{if(!e)break f;for(o=k+128|0,t=o;k=i[e+16>>2]<10,t=k?t:e,e=i[(k?4:0)+e>>2],!!e;);if((t|0)==(o|0)|i[t+16>>2]>10)break f;_=l[t+24|0]}if(T0(h,s,0,w,X,_,r),!i[h>>2])f:{u[h+19|0]<0&&Z(i[h+8>>2]),_=0;A:{k:{if(r=i[n>>2],e=i[r+128>>2],!e)break k;for(k=r+128|0,t=k;r=i[e+16>>2]<10,t=r?t:e,e=i[(r?4:0)+e>>2],!!e;);if((k|0)==(t|0))break k;if(k=0,i[t+16>>2]>10)break A;V=i[t+56>>2],k=i[t+44>>2];break A}k=0}e=i[s+128>>2],r=0;A:{if(!e)break A;for(o=s+128|0,t=o;r=i[e+16>>2],t=(r|0)<0?t:e,e=i[(r>>>29&4)+e>>2],!!e;);if(r=0,(t|0)==(o|0)||(r=0,i[t+16>>2]>0))break A;_=i[t+56>>2],r=i[t+44>>2]}if(!(!X|!w))for(F=k+3|0,I=w&-4,Q=w&3,o=w-1>>>0<3;;){if(B=G(_,m)+r|0,w=G(m,V)+F|0,e=0,t=0,!o)for(;u[e+B|0]=l[w+(e<<2)|0],k=e|1,u[k+B|0]=l[w+(k<<2)|0],k=e|2,u[k+B|0]=l[w+(k<<2)|0],k=e|3,u[k+B|0]=l[w+(k<<2)|0],e=e+4|0,t=t+4|0,(I|0)!=(t|0););if(t=0,Q)for(;u[e+B|0]=l[w+(e<<2)|0],e=e+1|0,t=t+1|0,(Q|0)!=(t|0););if(m=m+1|0,(X|0)==(m|0))break}if(e=i[26917],i[h>>2]=i[26916],i[h+4>>2]=e,r=h+8|0,u[107683]>=0){e=i[26919],i[r>>2]=i[26918],i[r+4>>2]=e,i[r+8>>2]=i[26920];break f}T(r,i[26918],i[26919])}r=i[n+4>>2];f:{if(!r||(e=i[r+4>>2],i[r+4>>2]=e-1,e))break f;W[i[i[r>>2]+8>>2]](r),y(r)}if(i[n+8>>2]){if(e=i[n+12>>2],i[A>>2]=i[n+8>>2],i[A+4>>2]=e,r=A+8|0,u[n+27|0]>=0){e=i[n+20>>2],i[r>>2]=i[n+16>>2],i[r+4>>2]=e,i[r+8>>2]=i[n+24>>2],u[A+20|0]=1;break e}if(T(r,i[n+16>>2],i[n+20>>2]),e=u[n+27|0],u[A+20|0]=1,(e|0)>=0)break e;Z(i[n+16>>2]);break e}if(u[n+27|0]>=0)break r;Z(i[n+16>>2])}u[n+14|0]=1,g[n+12>>1]=2,g[n+8>>1]=2,g[n+10>>1]=2,W[i[i[f+12>>2]+8>>2]](s,n+8|0),u[A+20|0]=0,i[A+4>>2]=f,i[A>>2]=s;break i}if(A=i[f+4>>2],i[f+4>>2]=A-1,A)break i;W[i[i[f>>2]+8>>2]](f),y(f)}v=n+48|0}function tr(A,e,r,f,k){var n=0,t=0,o=0,s=0,w=0,h=0,_=0,B=0,m=0;s=v-32|0,v=s,i[s+28>>2]=0,i[s+20>>2]=0,i[s+24>>2]=0,j1(s,i[e>>2],r,s+20|0);i:{e:{if(i[s>>2]||(r=i[s+20>>2],n=i[s+24>>2],(r|0)==(n|0)))break e;for(;;){r:{if(t=i[r>>2],!t||(t=W0(t,86580,86600),!t))break r;r=i[r+4>>2];f:{if(!r){n=i[t+108>>2],t=i[t+104>>2];break f}if(o=i[r+4>>2],_=o+1|0,i[r+4>>2]=_,n=i[t+108>>2],t=i[t+104>>2],i[r+4>>2]=o,_)break f;W[i[i[r>>2]+8>>2]](r),y(r)}if(!t|!n)break e;if(i[A+8>>2]=0,i[A+12>>2]=0,i[A+32>>2]=0,i[A+36>>2]=0,i[A+16>>2]=0,i[A+20>>2]=0,i[A+40>>2]=0,i[A+44>>2]=0,t0[A+24>>3]=+(n>>>0)/+(k|0),t0[A>>3]=+(t>>>0)/+(f|0),r=i[s+20>>2],_=i[s+24>>2],(r|0)==(_|0))break i;for(;;){f=i[r>>2],k=i[f+16>>2];f:{A:{if((k|0)!=1668047216){if((k|0)!=1769107316){if((k|0)!=1768778098)break f;k=0,o=W0(f,86580,87972);k:{if(!o||(f=i[r+4>>2],!f))break k;i[f+4>>2]=i[f+4>>2]+1,k=f}k:{if(i[o+100>>2]==1){t0[A>>3]=-t0[A>>3],t0[A+8>>3]=-t0[A+8>>3],t0[A+32>>3]=+(t-1>>>0)-t0[A+32>>3];break k}t0[A+16>>3]=-t0[A+16>>3],t0[A+24>>3]=-t0[A+24>>3],t0[A+40>>3]=+(n-1>>>0)-t0[A+40>>3]}if(!k)break f;if(f=i[k+4>>2],i[k+4>>2]=f-1,!f)break A;break f}k=0,o=W0(f,86580,87892);k:{if(!o||(f=i[r+4>>2],!f))break k;i[f+4>>2]=i[f+4>>2]+1,k=f}f=i[o+100>>2];k:{n:{t:{if((f|0)!=270){if((f|0)!=180){if((f|0)!=90){f=n;break k}w=t0[A+32>>3],t0[A+32>>3]=t0[A+40>>3],B=t0[A+8>>3],t0[A+8>>3]=t0[A+24>>3],m=t0[A>>3],t0[A>>3]=t0[A+16>>3],t0[A+24>>3]=-B,t0[A+16>>3]=-m,w=+(t>>>0)-w+-1;break t}t0[A>>3]=-t0[A>>3],t0[A+8>>3]=-t0[A+8>>3],t0[A+16>>3]=-t0[A+16>>3],t0[A+24>>3]=-t0[A+24>>3],t0[A+32>>3]=+(t-1>>>0)-t0[A+32>>3],w=+(n-1>>>0)-t0[A+40>>3],f=n;break n}w=t0[A+24>>3],t0[A+24>>3]=t0[A+8>>3],B=t0[A+16>>3],t0[A+16>>3]=t0[A>>3],t0[A+8>>3]=-w,t0[A>>3]=-B,w=t0[A+32>>3],t0[A+32>>3]=+(n>>>0)-t0[A+40>>3]+-1}f=t,t=n}t0[A+40>>3]=w}if(!k){n=f;break f}if(o=i[k+4>>2],i[k+4>>2]=o-1,n=f,!o)break A;break f}k=0,o=W0(f,86580,88052);k:{if(!o||(f=i[r+4>>2],!f))break k;i[f+4>>2]=i[f+4>>2]+1,k=f}if(f=$i(o,t),n=qi(o,n),t0[A+32>>3]=t0[A+32>>3]-+(f|0),t0[A+40>>3]=t0[A+40>>3]-+(n|0),f=i[o+100>>2],n=i[o+104>>2],h=(n|0)/2|0,t=f+h|0,f=(f>>31)+(h>>31)|0,t=G2(t,t>>>0<h>>>0?f+1|0:f,n,n>>31),f=i[o+108>>2],n=i[o+112>>2],h=(n|0)/2|0,o=f+h|0,f=(f>>31)+(h>>31)|0,n=G2(o,o>>>0<h>>>0?f+1|0:f,n,n>>31),!k||(f=i[k+4>>2],i[k+4>>2]=f-1,f))break f}W[i[i[k>>2]+8>>2]](k),y(k)}if(r=r+8|0,(_|0)==(r|0))break}break i}if(r=r+8|0,(n|0)==(r|0))break}}i[A+8>>2]=0,i[A+12>>2]=0,i[A>>2]=0,i[A+4>>2]=1072693248,i[A+32>>2]=0,i[A+36>>2]=0,i[A+24>>2]=0,i[A+28>>2]=1072693248,i[A+16>>2]=0,i[A+20>>2]=0,i[A+40>>2]=0,i[A+44>>2]=0}if(u[s+19|0]<0&&Z(i[s+8>>2]),f=i[s+20>>2],f){if(A=f,r=i[s+24>>2],(A|0)!=(r|0)){for(;;){A=i[r-4>>2];i:{if(!A||(k=i[A+4>>2],i[A+4>>2]=k-1,k))break i;W[i[i[A>>2]+8>>2]](A),y(A)}if(r=r-8|0,(f|0)==(r|0))break}A=i[s+20>>2]}i[s+24>>2]=f,Z(A)}A=i[e+4>>2];i:{if(!A||(e=i[A+4>>2],i[A+4>>2]=e-1,e))break i;W[i[i[A>>2]+8>>2]](A),y(A)}v=s+32|0}function y4(A,e,r,f,k,n,t,o,s){var w=0,h=0,_=0,B=0,m=0,X=0,Q=0,V=0,F=0,I=0;h=v-112|0,v=h,w=s&2147483647;i:{e:{if(m=k&2147483647,_=2147418112,B=!(e|r),!(f|m?m-_>>>0<2147549184:B)&&(F=w-_|0,!o&(F|0)==-2147418112?n|t:(F|0)==-2147418112&(o|0)!=0|F>>>0>2147549184))break e;if(!(!f&(m|0)==2147418112?B:m>>>0<2147418112)){o=f,s=k|32768,n=e,t=r;break i}if(!(!o&(w|0)==2147418112?!(n|t):w>>>0<2147418112)){s=s|32768;break i}if(!(e|f|(m^2147418112|r))){_=f,f=!(e^n|f^o|(r^t|k^s^-2147483648)),o=f?0:_,s=f?2147450880:k,n=f?0:e,t=f?0:r;break i}if(_=n|o,!(_|(w^2147418112|t)))break i;if(!(e|f|(r|m))){if(t|w|_)break i;n=e&n,t=r&t,o=f&o,s=k&s;break i}if(n|o|(t|w))break e;n=e,t=r,o=f,s=k;break i}_=(w|0)==(m|0),Q=_&(f|0)==(o|0)?(r|0)==(t|0)&e>>>0<n>>>0|r>>>0<t>>>0:_&f>>>0<o>>>0|w>>>0>m>>>0,B=Q,m=B?n:e,F=B?t:r,_=B?s:k,I=_,B=B?o:f,V=_&65535,w=Q?f:o,_=Q?k:s,o=_,_=o>>>16&32767,X=I>>>16&32767,X||(X=!(B|V),f=k1(X?F:V),X=((f|0)==32?k1(X?m:B)+32|0:f)+(X?64:0)|0,o4(h+96|0,m,F,B,V,X-15|0),B=i[h+104>>2],V=i[h+108>>2],F=i[h+100>>2],X=16-X|0,m=i[h+96>>2]),n=Q?e:n,t=Q?r:t,e=w,r=o&65535,_||(w=!(e|r),Q=k1(w?t:r),w=((Q|0)==32?k1(w?n:e)+32|0:Q)+(w?64:0)|0,o4(h+80|0,n,t,e,r,w-15|0),_=16-w|0,n=i[h+80>>2],t=i[h+84>>2],e=i[h+88>>2],r=i[h+92>>2]),f=r<<3,r=e,e=f|e>>>29,w=r<<3,r=e,e=t>>>29|w,r=r|524288,w=V<<3|B>>>29,V=B<<3|F>>>29,Q=w,o=k^s,w=t<<3|n>>>29,f=n<<3;e:{if((_|0)==(X|0))break e;if(k=X-_|0,k>>>0>127){e=0,r=0,w=0,f=1;break e}o4(h- -64|0,f,w,e,r,128-k|0),Y6(h+48|0,f,w,e,r,k),e=i[h+56>>2],r=i[h+60>>2],w=i[h+52>>2],f=i[h+48>>2]|(i[h+64>>2]|i[h+72>>2]|(i[h+68>>2]|i[h+76>>2]))!=0}B=f,_=w,Q=Q|524288,w=F<<3|m>>>29,m=m<<3;e:{if((o|0)<0){if(n=0,t=0,o=0,s=0,!(m^B|e^V|(w^_|r^Q)))break i;if(f=m-B|0,k=w-((m>>>0<B>>>0)+_|0)|0,n=V-e|0,t=(w|0)==(_|0)&m>>>0<B>>>0|w>>>0<_>>>0,o=n-t|0,e=(Q-((e>>>0>V>>>0)+r|0)|0)-(n>>>0<t>>>0)|0,s=e,e>>>0>524287)break e;r=!(e|o),t=k1(r?k:e),r=((t|0)==32?k1(r?f:o)+32|0:t)+(r?64:0)|0,e=r-12|0,o4(h+32|0,f,k,o,s,e),X=X-e|0,o=i[h+40>>2],s=i[h+44>>2],f=i[h+32>>2],k=i[h+36>>2];break e}if(k=w+_|0,f=m+B|0,k=f>>>0<m>>>0?k+1|0:k,n=(_|0)==(k|0)&f>>>0<B>>>0|k>>>0<_>>>0,w=r+Q|0,e=e+V|0,w=e>>>0<V>>>0?w+1|0:w,o=e+n|0,s=o>>>0<e>>>0?w+1|0:w,!(s&1048576))break e;f=B&1|((k&1)<<31|f>>>1),k=o<<31|k>>>1,X=X+1|0,o=(s&1)<<31|o>>>1,s=s>>>1|0}if(n=0,e=I&-2147483648,t=e,(X|0)>=32767){o=n,s=e|2147418112,t=0;break i}_=0;e:{if((X|0)>0){_=X;break e}o4(h+16|0,f,k,o,s,X+127|0),Y6(h,f,k,o,s,1-X|0),f=i[h>>2]|(i[h+16>>2]|i[h+24>>2]|(i[h+20>>2]|i[h+28>>2]))!=0,k=i[h+4>>2],o=i[h+8>>2],s=i[h+12>>2]}r=(k&7)<<29|f>>>3,k=o<<29|k>>>3,n=n|((s&7)<<29|o>>>3),e=t|(s>>>3&65535|_<<16);e:{r:{if(w=f&7,(w|0)!=4){o=n,f=k,n=w>>>0>4,k=n,n=r+n|0,t=k>>>0>n>>>0?f+1|0:f,r=(f|0)==(t|0)&r>>>0>n>>>0|f>>>0>t>>>0,o=r+o|0,s=r>>>0>o>>>0?e+1|0:e;break r}o=n,f=e,e=k,n=r&1,k=n,n=r+n|0,t=k>>>0>n>>>0?e+1|0:e,e=(t|0)==(e|0)&r>>>0>n>>>0|e>>>0>t>>>0,o=e+o|0,s=o>>>0<e>>>0?f+1|0:f;break e}if(!w)break i}}i[A>>2]=n,i[A+4>>2]=t,i[A+8>>2]=o,i[A+12>>2]=s,v=h+112|0}function Z(A){A=A|0;var e=0,r=0,f=0,k=0,n=0,t=0,o=0,s=0,w=0,h=0;i:{if(!A)break i;f=A-8|0,e=i[A-4>>2],A=e&-8,n=f+A|0;e:{if(e&1)break e;if(!(e&2)||(e=i[f>>2],f=f-e|0,f>>>0<u0[31642]))break i;A=A+e|0;r:{f:{A:{if(i[31643]!=(f|0)){if(r=i[f+12>>2],e>>>0<=255){if(k=i[f+8>>2],(k|0)!=(r|0))break A;w=126552,h=i[31638]&k2(-2,e>>>3|0),i[w>>2]=h;break e}if(o=i[f+24>>2],(r|0)!=(f|0)){e=i[f+8>>2],i[e+12>>2]=r,i[r+8>>2]=e;break r}if(k=i[f+20>>2],k)e=f+20|0;else{if(k=i[f+16>>2],!k)break f;e=f+16|0}for(;t=e,r=k,e=r+20|0,k=i[r+20>>2],!(!k&&(e=r+16|0,k=i[r+16>>2],!k)););i[t>>2]=0;break r}if(e=i[n+4>>2],(e&3)!=3)break e;i[31640]=A,i[n+4>>2]=e&-2,i[f+4>>2]=A|1,i[n>>2]=A;return}i[k+12>>2]=r,i[r+8>>2]=k;break e}r=0}if(!o)break e;e=i[f+28>>2],k=(e<<2)+126856|0;r:{if(i[k>>2]==(f|0)){if(i[k>>2]=r,r)break r;w=126556,h=i[31639]&k2(-2,e),i[w>>2]=h;break e}f:{if(i[o+16>>2]==(f|0)){i[o+16>>2]=r;break f}i[o+20>>2]=r}if(!r)break e}if(i[r+24>>2]=o,e=i[f+16>>2],e&&(i[r+16>>2]=e,i[e+24>>2]=r),e=i[f+20>>2],!e)break e;i[r+20>>2]=e,i[e+24>>2]=r}if(f>>>0>=n>>>0||(e=i[n+4>>2],!(e&1)))break i;e:{r:{f:{A:{if(!(e&2)){if(i[31644]==(n|0)){if(i[31644]=f,A=i[31641]+A|0,i[31641]=A,i[f+4>>2]=A|1,i[31643]!=(f|0))break i;i[31640]=0,i[31643]=0;return}if(s=i[31643],(s|0)==(n|0)){i[31643]=f,A=i[31640]+A|0,i[31640]=A,i[f+4>>2]=A|1,i[A+f>>2]=A;return}if(A=(e&-8)+A|0,r=i[n+12>>2],e>>>0<=255){if(k=i[n+8>>2],(k|0)==(r|0)){w=126552,h=i[31638]&k2(-2,e>>>3|0),i[w>>2]=h;break r}i[k+12>>2]=r,i[r+8>>2]=k;break r}if(o=i[n+24>>2],(r|0)!=(n|0)){e=i[n+8>>2],i[e+12>>2]=r,i[r+8>>2]=e;break f}if(k=i[n+20>>2],k)e=n+20|0;else{if(k=i[n+16>>2],!k)break A;e=n+16|0}for(;t=e,r=k,e=r+20|0,k=i[r+20>>2],!(!k&&(e=r+16|0,k=i[r+16>>2],!k)););i[t>>2]=0;break f}i[n+4>>2]=e&-2,i[f+4>>2]=A|1,i[A+f>>2]=A;break e}r=0}if(!o)break r;e=i[n+28>>2],k=(e<<2)+126856|0;f:{if(i[k>>2]==(n|0)){if(i[k>>2]=r,r)break f;w=126556,h=i[31639]&k2(-2,e),i[w>>2]=h;break r}A:{if(i[o+16>>2]==(n|0)){i[o+16>>2]=r;break A}i[o+20>>2]=r}if(!r)break r}if(i[r+24>>2]=o,e=i[n+16>>2],e&&(i[r+16>>2]=e,i[e+24>>2]=r),e=i[n+20>>2],!e)break r;i[r+20>>2]=e,i[e+24>>2]=r}if(i[f+4>>2]=A|1,i[A+f>>2]=A,(f|0)!=(s|0))break e;i[31640]=A;return}if(A>>>0<=255){e=(A&-8)+126592|0,k=i[31638],A=1<<(A>>>3);e:{if(!(k&A)){i[31638]=A|k,A=e;break e}A=i[e+8>>2]}i[e+8>>2]=f,i[A+12>>2]=f,i[f+12>>2]=e,i[f+8>>2]=A;return}r=31,A>>>0<=16777215&&(e=k1(A>>>8|0),r=((A>>>38-e&1)-(e<<1)|0)+62|0),i[f+28>>2]=r,i[f+16>>2]=0,i[f+20>>2]=0,e=(r<<2)+126856|0;e:{r:{k=i[31639],t=1<<r;f:{if(!(k&t)){i[31639]=k|t,i[e>>2]=f,r=24;break f}for(r=A<<((r|0)!=31?25-(r>>>1|0)|0:0),e=i[e>>2];;){if(k=e,(i[e+4>>2]&-8)==(A|0))break r;if(e=r>>>29|0,r=r<<1,t=(e&4)+k|0,e=i[t+16>>2],!e)break}i[t+16>>2]=f,e=k,r=24}k=f,t=f,A=8;break e}e=i[k+8>>2],i[e+12>>2]=f,i[k+8>>2]=f,r=8,t=0,A=24}i[r+f>>2]=e,i[f+12>>2]=k,i[A+f>>2]=t,A=i[31646]-1|0,i[31646]=A||-1}}function W9(A,e,r,f,k){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0;var n=0,t=0,o=0,s=0,w=0,h=0,_=0,B=0,m=0;n=v-128|0,v=n;i:{if(!k||!e|!f){e=i[23570],i[A>>2]=i[23569],i[A+4>>2]=e,i[A+8>>2]=i[23571];break i}if((r|0)<=0){i[A>>2]=5,i[A+4>>2]=2006,i[A+8>>2]=11845;break i}s=p(72),i[s+4>>2]=0,i[s+8>>2]=0,i[s>>2]=95024,t=dr(s+16|0,e,r,0),i[n+100>>2]=s,i[n+96>>2]=t,i[s+4>>2]=i[s+4>>2]+1,t=i[n+100>>2],i[n+8>>2]=i[n+96>>2],i[n+12>>2]=t,o=pe(n+104|0,n+8|0,r,0),t=n+56|0,i[t+8>>2]=0,i[t+12>>2]=0,i[t+16>>2]=0,i[t+20>>2]=0,i[t+24>>2]=0,i[t+28>>2]=0,i[t+32>>2]=0,i[t>>2]=86356,$6(n+36|0,t,o);e:{if(w=i[n+36>>2],w){i[A>>2]=w,i[A+4>>2]=i[n+40>>2],e=7332;break e}if(i[t+16>>2]!=1718909296){i[A>>2]=2,i[A+4>>2]=0,e=22946;break e}u[n+55|0]<0&&Z(i[n+44>>2]),i[t>>2]=86356,w=i[t+20>>2],w&&(i[t+24>>2]=w,Z(w)),t=i[o+4>>2];r:{if(!t||(o=i[t+4>>2],i[t+4>>2]=o-1,o))break r;W[i[i[t>>2]+8>>2]](t),y(t)}t=i[s+4>>2],i[s+4>>2]=t-1,t||(W[i[i[s>>2]+8>>2]](s),y(s)),s=p(72),i[s+4>>2]=0,i[s+8>>2]=0,i[s>>2]=95024,e=dr(s+16|0,e,r,0),i[n+32>>2]=s,i[n+28>>2]=e,i[s+4>>2]=i[s+4>>2]+1,e=i[n+32>>2],i[n>>2]=i[n+28>>2],i[n+4>>2]=e,w=pe(n+56|0,n,r,0),i[n+20>>2]=0,i[n+24>>2]=0,V6(n+104|0,w,n+20|0,95520),r=i[n+104>>2];r:{if(r){if(e=i[n+108>>2],i[A>>2]=r,(e|0)==100){i[A+4>>2]=100,i[A+8>>2]=18728;break r}i[A+4>>2]=e,i[A+8>>2]=2369;break r}f:{if(e=i[n+20>>2],!e||(e=W0(e,86580,86944),!e))break f;t=i[n+24>>2],t&&(i[t+4>>2]=i[t+4>>2]+1),i[n+44>>2]=0,i[n+36>>2]=0,i[n+40>>2]=0;A:{k:{if(o=i[e+112>>2],r=i[e+108>>2],(o|0)!=(r|0)){if(e=o-r|0,(e|0)<0)break k;o=p(e),i[n+36>>2]=o,h=e+o|0,i[n+44>>2]=h,e&&x(o,r,e),i[n+40>>2]=h}break A}G0(),H()}e=i[n+40>>2],r=i[n+36>>2],h=e-r|0,o=h>>2;A:{if(o>>>0>u0[23901]){i[A>>2]=6,i[A+4>>2]=1e3,i[A+8>>2]=23770;break A}_=f,f=y2(h),i[_>>2]=f,i[k>>2]=o;k:{if((e|0)==(r|0))break k;if(_=o>>>0<=1?1:o,h=_&3,k=0,e=0,o>>>0>=4)for(m=_&-4,_=0;o=e<<2,i[o+f>>2]=i[r+o>>2],B=o|4,i[B+f>>2]=i[r+B>>2],B=o|8,i[B+f>>2]=i[r+B>>2],o=o|12,i[o+f>>2]=i[r+o>>2],e=e+4|0,_=_+4|0,(m|0)!=(_|0););if(!h)break k;for(;o=e<<2,i[o+f>>2]=i[r+o>>2],e=e+1|0,k=k+1|0,(h|0)!=(k|0););}e=i[24057],i[A>>2]=i[24056],i[A+4>>2]=e,i[A+8>>2]=i[24058]}if(r&&(i[n+40>>2]=r,Z(r)),!t||(A=i[t+4>>2],i[t+4>>2]=A-1,A))break r;W[i[i[t>>2]+8>>2]](t),y(t);break r}i[A>>2]=2,i[A+4>>2]=102,i[A+8>>2]=2392}u[n+123|0]<0&&Z(i[n+112>>2]),A=i[n+24>>2];r:{if(!A||(e=i[A+4>>2],i[A+4>>2]=e-1,e))break r;W[i[i[A>>2]+8>>2]](A),y(A)}A=i[w+4>>2];r:{if(!A||(e=i[A+4>>2],i[A+4>>2]=e-1,e))break r;W[i[i[A>>2]+8>>2]](A),y(A)}if(A=i[s+4>>2],i[s+4>>2]=A-1,A)break i;W[i[i[s>>2]+8>>2]](s),y(s);break i}i[A+8>>2]=e,u[n+55|0]<0&&Z(i[n+44>>2]),i[t>>2]=86356,A=i[t+20>>2],A&&(i[t+24>>2]=A,Z(A)),A=i[o+4>>2];e:{if(!A||(e=i[A+4>>2],i[A+4>>2]=e-1,e))break e;W[i[i[A>>2]+8>>2]](A),y(A)}if(A=i[s+4>>2],i[s+4>>2]=A-1,A)break i;W[i[i[s>>2]+8>>2]](s),y(s)}v=n+128|0}function d6(A,e,r,f,k){var n=0,t=0,o=0,s=0,w=0,h=0,_=0,B=0,m=0,X=0,Q=0,V=0,F=0,I=0,E=0,R=0,N=0,M=0,z=0,S=0,O=0,P=0,a=0,$=0,f0=0,A0=0;n=v-192|0,v=n,_=A+8|0,m=i[18051],I=m-12|0,E=i[18052]-12|0,R=i[18055]-12|0,X=i[18053],N=X-12|0,M=i[18060],z=i[18059],S=n+32|0,O=n+44|0,P=i[18057],a=i[18056],$=i[18054],Q=n+24|0,V=n+20|0,f0=n+76|0,A0=(f|0)==-1;i:{e:{r:{f:{A:{for(;;){k:{n:{t:{u:{o:{if(o=l[r+20|0],!(!i[r+16>>2]|o&1)){i[n+184>>2]=0,i[n+188>>2]=0,V6(n+160|0,r,n+184|0,k);l:{if(i[n+160>>2]==i[26916]||(o=i[n+184>>2],o&&W[i[i[o>>2]+36>>2]](o)|0))break l;o=i[n+164>>2],i[A>>2]=i[n+160>>2],i[A+4>>2]=o,i[_+8>>2]=i[n+176>>2],o=i[n+172>>2],i[_>>2]=i[n+168>>2],i[_+4>>2]=o,i[n+168>>2]=0,i[n+172>>2]=0,i[n+176>>2]=0,o=1;break k}if(!A0){t=i[e+40>>2];break n}if(o=i[(i[e+16>>2]==1768517222?28:60)+k>>2],t=i[e+40>>2],!o|o>>>0>=t-i[e+36>>2]>>3>>>0)break n;i[n+104>>2]=0,i[n+12>>2]=X,i[n+76>>2]=72196,i[n+20>>2]=72176,t=n+12|0,i[t+i[N>>2]>>2]=$,i[n+16>>2]=0,s=t+i[i[n+12>>2]-12>>2]|0,J0(s,Q),u[s+80|0]=0,i[s+72>>2]=0,i[i[R>>2]+V>>2]=a,i[t+i[E>>2]>>2]=P,i[n+76>>2]=72196,i[n+12>>2]=72156,i[n+20>>2]=72176,w=R0(Q),i[w>>2]=71232,i[n+64>>2]=0,i[n+68>>2]=0,i[n+56>>2]=0,i[n+60>>2]=0,i[n+72>>2]=24,o=Y(V0(Y(V,27028,31),o),27333,6),ie(n,e),s=o,o=u[n+11|0],t=(o|0)<0,Y(Y(s,t?i[n>>2]:n,t?i[n+4>>2]:o),25952,15),u[n+11|0]<0&&Z(i[n>>2]),o=i[n+72>>2];l:{if(o&16){if(t=O,o=i[n+68>>2],s=i[n+48>>2],o>>>0>=s>>>0)break l;i[n+68>>2]=s,o=s;break l}if(!(o&8)){t=0,u[n+11|0]=0,o=n;break t}o=i[n+40>>2],t=S}if(s=i[t>>2],t=o-s|0,t>>>0>=2147483640)break o;if(t>>>0>=11){h=t|7,o=p(h+1|0),i[n+8>>2]=h-2147483647,i[n>>2]=o,i[n+4>>2]=t;break u}if(u[n+11|0]=t,o=n,t)break u;t=0;break t}if(o&1)break A;break f}Q0(),H()}if(!t)break t;x(o,s,t)}u[t+o|0]=0,q(A,6,1e3,n),u[n+11|0]<0&&Z(i[n>>2]),i[n+12>>2]=m,i[i[I>>2]+(n+12|0)>>2]=z,i[n+20>>2]=M,i[w>>2]=71232,u[n+67|0]<0&&Z(i[n+56>>2]),E0(w),y0(f0),o=1;break k}w=i[e+44>>2];n:{if(w>>>0>t>>>0){i[t>>2]=i[n+184>>2],i[t+4>>2]=i[n+188>>2],i[n+184>>2]=0,i[n+188>>2]=0,t=t+8|0;break n}if(s=i[e+36>>2],o=t-s|0,B=o>>3,t=B+1|0,t>>>0>=536870912)break e;if(w=w-s|0,h=w>>2,w=w>>>0>=2147483640?536870911:t>>>0<h>>>0?h:t,w){if(w>>>0>=536870912)break i;t=p(w<<3)}else t=0;if(h=t+o|0,i[h>>2]=i[n+184>>2],i[h+4>>2]=i[n+188>>2],i[n+184>>2]=0,i[n+188>>2]=0,B=h-(B<<3)|0,o&&x(B,s,o),i[e+44>>2]=t+(w<<3),t=h+8|0,i[e+40>>2]=t,i[e+36>>2]=B,!s)break n;Z(s)}i[e+40>>2]=t,F=F+1|0,o=(f|0)!=-1&&(F|0)==(f|0)?3:0}u[n+179|0]<0&&Z(i[n+168>>2]),t=i[n+188>>2];k:{if(!t||(s=i[t+4>>2],i[t+4>>2]=s-1,s))break k;W[i[i[t>>2]+8>>2]](t),y(t)}if(o)break}if((o|0)!=3)break r;if(!(u[r+20|0]&1))break f}if(u[n+12|0]=0,u[n+23|0]=0,q(A,2,100,n+12|0),u[n+23|0]>=0)break r;Z(i[n+12>>2]);break r}if(e=i[26917],i[A>>2]=i[26916],i[A+4>>2]=e,u[107683]>=0){A=i[26919],i[_>>2]=i[26918],i[_+4>>2]=A,i[_+8>>2]=i[26920];break r}T(_,i[26918],i[26919])}v=n+192|0;return}G0(),H()}z0(),H()}function Rv(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0;var k=0,n=0,t=0,o=0,s=0,w=0,h=0,_=0,B=0,m=0;f=v-32|0,v=f,z2(f,e,r),u[f+19|0]<0&&Z(i[f+8>>2]);i:{if(l[e+97|0]){t1(A,e,2946);break i}i[e+120>>2]=0,i[e+124>>2]=0,g[e+116>>1]=1,i[e+112>>2]=0,i[e+104>>2]=0,i[e+108>>2]=0,i[e+152>>2]=0,i[e+156>>2]=0,i[e+144>>2]=0,i[e+148>>2]=1072693248,i[e+128>>2]=0,i[e+132>>2]=0,i[e+136>>2]=0,i[e+140>>2]=0,i[e+160>>2]=0,i[e+164>>2]=0,i[e+168>>2]=0,i[e+172>>2]=0,i[e+176>>2]=0,k=i[e+100>>2],k&1&&(u[e+184|0]=1,_=e,B=C0(r),i[_+104>>2]=B,k=i[e+100>>2]),k&2&&(u[e+185|0]=1,_=e,B=C0(r),i[_+108>>2]=B,k=i[e+100>>2]),k&4&&(u[e+186|0]=1,_=e,B=C0(r),i[_+112>>2]=B,k=i[e+100>>2]);e:{if(!(k&8))break e;u[e+187|0]=1;r:{f:switch(l[e+97|0]){case 0:s=k&16;A:{if(s){k=C0(r),w=C0(r),h=C0(r);break A}k=wi(r),w=wi(r),h=wi(r)}if(u[e+116|0]=1,n=+(16384<<s>>>0),t=+(h|0)/n,t0[e+136>>3]=t,o=+(w|0)/n,t0[e+128>>3]=o,n=+(k|0)/n,t0[e+120>>3]=n,n=t*t+(n*n+o*o),!(n>1))break r;if(e=p(48),i[f+20>>2]=e,i[f+24>>2]=47,i[f+28>>2]=-2147483600,r=l[2849]|l[2850]<<8|(l[2851]<<16|l[2852]<<24),k=l[2845]|l[2846]<<8|(l[2847]<<16|l[2848]<<24),u[e|0]=k,u[e+1|0]=k>>>8,u[e+2|0]=k>>>16,u[e+3|0]=k>>>24,u[e+4|0]=r,u[e+5|0]=r>>>8,u[e+6|0]=r>>>16,u[e+7|0]=r>>>24,u[e+47|0]=0,r=l[2888]|l[2889]<<8|(l[2890]<<16|l[2891]<<24),k=l[2884]|l[2885]<<8|(l[2886]<<16|l[2887]<<24),u[e+39|0]=k,u[e+40|0]=k>>>8,u[e+41|0]=k>>>16,u[e+42|0]=k>>>24,u[e+43|0]=r,u[e+44|0]=r>>>8,u[e+45|0]=r>>>16,u[e+46|0]=r>>>24,r=l[2881]|l[2882]<<8|(l[2883]<<16|l[2884]<<24),k=l[2877]|l[2878]<<8|(l[2879]<<16|l[2880]<<24),u[e+32|0]=k,u[e+33|0]=k>>>8,u[e+34|0]=k>>>16,u[e+35|0]=k>>>24,u[e+36|0]=r,u[e+37|0]=r>>>8,u[e+38|0]=r>>>16,u[e+39|0]=r>>>24,r=l[2873]|l[2874]<<8|(l[2875]<<16|l[2876]<<24),k=l[2869]|l[2870]<<8|(l[2871]<<16|l[2872]<<24),u[e+24|0]=k,u[e+25|0]=k>>>8,u[e+26|0]=k>>>16,u[e+27|0]=k>>>24,u[e+28|0]=r,u[e+29|0]=r>>>8,u[e+30|0]=r>>>16,u[e+31|0]=r>>>24,r=l[2865]|l[2866]<<8|(l[2867]<<16|l[2868]<<24),k=l[2861]|l[2862]<<8|(l[2863]<<16|l[2864]<<24),u[e+16|0]=k,u[e+17|0]=k>>>8,u[e+18|0]=k>>>16,u[e+19|0]=k>>>24,u[e+20|0]=r,u[e+21|0]=r>>>8,u[e+22|0]=r>>>16,u[e+23|0]=r>>>24,r=l[2857]|l[2858]<<8|(l[2859]<<16|l[2860]<<24),k=l[2853]|l[2854]<<8|(l[2855]<<16|l[2856]<<24),u[e+8|0]=k,u[e+9|0]=k>>>8,u[e+10|0]=k>>>16,u[e+11|0]=k>>>24,u[e+12|0]=r,u[e+13|0]=r>>>8,u[e+14|0]=r>>>16,u[e+15|0]=r>>>24,q(A,2,0,f+20|0),u[f+31|0]>=0)break i;Z(i[f+20>>2]);break i;case 1:break f;default:break e}_=e,m=+(C0(r)|0)*152587890625e-16,t0[_+152>>3]=m,_=e,m=+(C0(r)|0)*152587890625e-16,t0[_+160>>3]=m,_=e,m=+(C0(r)|0)*152587890625e-16,t0[_+168>>3]=m;break e}t0[e+144>>3]=X_(1-n)}if(l[e+100|0]&32&&(u[e+188|0]=1,_=e,B=C0(r),i[_+176>>2]=B),l[r+20|0]==1){if(u[f+20|0]=0,u[f+31|0]=0,q(A,2,100,f+20|0),u[f+31|0]>=0)break i;Z(i[f+20>>2]);break i}if(e=i[26917],i[A>>2]=i[26916],i[A+4>>2]=e,A=A+8|0,u[107683]>=0){e=i[26919],i[A>>2]=i[26918],i[A+4>>2]=e,i[A+8>>2]=i[26920];break i}T(A,i[26918],i[26919])}v=f+32|0}function Q9(A,e,r){var f=0,k=0,n=0,t=0,o=0,s=0,w=0,h=0;o=v-48|0,v=o,f=ei(o+16|0,e,r),e=i[f+12>>2],r=e>>31<<3|e>>>29,k=i[f+24>>2],e=k+(e<<3)|0,n=(k>>31)+r|0,n=e>>>0<k>>>0?n+1|0:n;i:{if(!e&(n|0)<=0|(n|0)<0)break i;e:{for(;;){if(V2(f,1),t=i2(f,4),e=i2(f,1),r=i2(f,1),V2(f,1),e&&V2(f,8),r){e=i2(f,8),r=e&127,k=0;r:{if(!(e&128)||(e=i2(f,8),r=r|e<<7&16256,!(e&128))||(e=i2(f,8),r=r|e<<14&2080768,!(e&128))||(e=i2(f,8),r=r|e<<21&266338304,!(e&128))||(e=i2(f,8),n=e>>>4|0,r=r|e<<28&-268435456,k=k|n&7,!(e&128))||(e=i2(f,8),k=k|e<<3&1016,!(e&128))||(e=i2(f,8),k=k|e<<10&130048,!(e&128)))break r;k=k|i2(f,8)<<17&16646144}if((t|0)==1)break e;if(!k&r>>>0>2147483647|k)break i;if(Rt(f,r),e=i[f+24>>2],r=e,k=e>>31,e=i[f+12>>2],n=e>>31<<3|e>>>29,t=e<<3,r=t+r|0,e=k+n|0,e=r>>>0<t>>>0?e+1|0:e,!!r&(e|0)>=0|(e|0)>0)continue;break i}break}if((t|0)!=1)break i}w=A,h=i2(f,3),u[w+1|0]=h,n=1,i2(f,1),s=i2(f,1);e:{if(s){e=i2(f,5),u[A+3|0]=0,u[A+2|0]=e;break e}e=0;r:{if(!i2(f,1)||(Rt(f,8),i2(f,1)&&$2(f,o+12|0),e=0,!i2(f,1)))break r;e=i2(f,5),V2(f,32),V2(f,10),n=e+1|0,e=1}if(k=i2(f,1),t=i2(f,5),(t|0)<0)break e;if(V2(f,12),r=i2(f,5),u[A+2|0]=r,r=r&248,!k){r&&(w=A,h=i2(f,1),u[w+3|0]=h);r:{if(!e||!i2(f,1))break r;V2(f,n),V2(f,n),V2(f,1)}if(!t)break e;for(r=1;;){V2(f,12),i2(f,5)&248&&i2(f,1),k=r;r:{if(!e||!i2(f,1))break r;V2(f,n),V2(f,n),V2(f,1)}if(r=k+1|0,(k|0)==(t|0))break}break e}if(!e){if(r&&(w=A,h=i2(f,1),u[w+3|0]=h),r=1,e=i2(f,1),u[A+10|0]=(e|0)!=0,e&&(w=A,h=i2(f,4),u[w+11|0]=h),!t)break e;for(;V2(f,12),i2(f,5)&248&&i2(f,1),i2(f,1)&&i2(f,4),e=(r|0)!=(t|0),r=r+1|0,!!e;);break e}if(r&&(w=A,h=i2(f,1),u[w+3|0]=h),i2(f,1)&&(V2(f,n),V2(f,n),V2(f,1)),e=i2(f,1),u[A+10|0]=(e|0)!=0,e&&(w=A,h=i2(f,4),u[w+11|0]=h),!t)break e;for(r=1;V2(f,12),i2(f,5)&248&&i2(f,1),i2(f,1)&&(V2(f,n),V2(f,n),V2(f,1)),i2(f,1)&&i2(f,4),e=(r|0)==(t|0),r=r+1|0,!e;);}e=i2(f,4),r=i2(f,4),i2(f,e+1|0),i2(f,r+1|0);e:{if(!s){i2(f,1)&&V2(f,7),V2(f,3),V2(f,4),e=i2(f,1),e&&V2(f,2);r:{if(!i2(f,1)&&(i2(f,1)|0)<=0||i2(f,1))break r;V2(f,1)}if(!e)break e}V2(f,3)}V2(f,3),k=i2(f,1),u[A+4|0]=k,e=l[A+1|0],r=0;e:{if(!(k&255)){n=0;break e}if(n=0,(e&255)!=2)break e;n=i2(f,1),e=l[A+1|0]}u[A+5|0]=n,(e&255)!=1?e=i2(f,1):e=0,u[A+6|0]=e;e:{if(!i2(f,1)){e=0,k=0;break e}e=(i2(f,8)|0)==1,r=(i2(f,8)|0)==13,k=!i2(f,8)}e:{r:{if(l[A+6|0]){V2(f,1),u[A+7|0]=1,u[A+8|0]=1,r=9,e=0;break r}f:{if((k&(e&r))==1)break f;V2(f,1);A:{k:{n:{t:switch(l[A+1|0]){default:if(l[A+5|0]){if(e=i2(f,1),u[A+7|0]=e,e&255)break n;break A}u[A+7|0]=1;break A;case 1:break f;case 0:break t}u[A+7|0]=1,u[A+8|0]=1;break k}if(e=i2(f,1),u[A+8|0]=e,!l[A+7|0]|!(e&255))break e}r=9,e=i2(f,2);break r}r=8,e=0;break r}u[A+7|0]=0,r=8,e=0}u[A+r|0]=e}V2(f,1)}v=o+48|0}function Jv(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,t=0,o=0,s=0,w=0,h=0,_=0,B=0,m=0,X=0;h=v-32|0,v=h;i:{e:{if(n=i[e>>2],!n||(o=W0(n,106564,106792),!o))break e;s=i[e+4>>2],s&&(i[s+4>>2]=i[s+4>>2]+1),_=h+12|0,f=v-80|0,v=f;r:{if(i[o+100>>2]!=i[o+104>>2])break r;n=p(120),i[n+4>>2]=0,i[n+8>>2]=0,i[n>>2]=94044,X=n+16|0,k=X,i[k+8>>2]=0,i[k+12>>2]=0,i[k+16>>2]=0,i[k+20>>2]=0,i[k+24>>2]=0,i[k+28>>2]=0,i[k+32>>2]=0,i[k>>2]=86356,i[n+60>>2]=0,i[n+64>>2]=0,i[n+52>>2]=0,i[n+56>>2]=0,i[n+72>>2]=-1,i[n+76>>2]=-1,i[n+80>>2]=-1,i[n+84>>2]=-1,i[n+88>>2]=0,i[n+92>>2]=0,i[n+96>>2]=0,i[n+100>>2]=0,i[n+104>>2]=0,i[n+108>>2]=0,u[n+112|0]=0,i[k>>2]=105580,i[n+32>>2]=1970432365,k=p(136),i[k>>2]=94084,i[k+4>>2]=0,i[k+8>>2]=0,w=k+16|0,t=w,i[t+8>>2]=0,i[t+12>>2]=0,i[t+16>>2]=0,i[t+20>>2]=0,i[t+24>>2]=0,i[t+28>>2]=0,i[t+32>>2]=0,i[t>>2]=86356,i[k+60>>2]=0,i[k+64>>2]=0,i[k+52>>2]=0,i[k+56>>2]=0,i[k+72>>2]=-1,i[k+76>>2]=-1,i[k+80>>2]=-1,i[k+84>>2]=-1,i[k+116>>2]=0,i[k+88>>2]=0,i[k+92>>2]=0,i[k+96>>2]=0,i[k+100>>2]=0,i[k+104>>2]=0,i[k+108>>2]=0,g[k+112>>1]=0,i[t>>2]=105660,i[k+128>>2]=0,i[k+120>>2]=0,i[k+124>>2]=0,i[k+32>>2]=1970432288,B=k+120|0;f:{A:{k:{n:{if(u[o+299|0]>=0){if(i[f+72>>2]=i[o+296>>2],t=i[o+292>>2],i[f+64>>2]=i[o+288>>2],i[f+68>>2]=t,u[f+75|0]>=0)break n;break A}if(T(f- -64|0,i[o+288>>2],i[o+292>>2]),m=u[f+75|0],u[k+131|0]<0)break k;if((m|0)<0)break A}t=i[f+68>>2],i[B>>2]=i[f+64>>2],i[B+4>>2]=t,i[B+8>>2]=i[f+72>>2];break f}t=(m|0)<0,O1(B,t?i[f+64>>2]:f- -64|0,t?i[f+68>>2]:m);break f}M1(B,i[f+64>>2],i[f+68>>2])}u[f+75|0]<0&&Z(i[f+64>>2]),i[f+36>>2]=k,i[f+32>>2]=w,i[k+4>>2]=i[k+4>>2]+1,r2(n+52|0,f+32|0),w=i[f+36>>2];f:{if(!w||(t=i[w+4>>2],i[w+4>>2]=t-1,t))break f;W[i[i[w>>2]+8>>2]](w),y(w)}if(_9(o,0),i[f+60>>2]=n,i[f+56>>2]=X,i[n+4>>2]=i[n+4>>2]+1,t=i[f+60>>2],i[f+8>>2]=i[f+56>>2],i[f+12>>2]=t,mn(o,f+8|0),t=i[k+4>>2],i[k+4>>2]=t-1,t||(W[i[i[k>>2]+8>>2]](k),y(k)),k=i[n+4>>2],i[n+4>>2]=k-1,k)break r;W[i[i[n>>2]+8>>2]](n),y(n)}t=i[r+16>>2],k=i[r+12>>2];r:{if(u[r+31|0]>=0){i[f+24>>2]=i[r+28>>2],n=i[r+24>>2],i[f+16>>2]=i[r+20>>2],i[f+20>>2]=n;break r}T(f+16|0,i[r+20>>2],i[r+24>>2])}u[f+28|0]=1,a7(f+32|0,o,r,k,0,1,t,f+16|0),l[f+28|0]!=1|u[f+27|0]>=0||Z(i[f+16>>2]),n=_+8|0;r:{if(i[f+32>>2]){r=i[f+36>>2],i[_>>2]=i[f+32>>2],i[_+4>>2]=r,i[n+8>>2]=i[f+48>>2],r=i[f+44>>2],i[n>>2]=i[f+40>>2],i[n+4>>2]=r,i[f+48>>2]=0,i[f+40>>2]=0,i[f+44>>2]=0;break r}if(r=i[26917],i[_>>2]=i[26916],i[_+4>>2]=r,u[107683]>=0){r=i[26919],i[n>>2]=i[26918],i[n+4>>2]=r,i[n+8>>2]=i[26920];break r}T(n,i[26918],i[26919])}u[f+51|0]<0&&Z(i[f+40>>2]),v=f+80|0;r:{if(i[h+12>>2]){b0(A,_,i[e+8>>2]);break r}e=i[24164],i[A>>2]=i[24163],i[A+4>>2]=e,i[A+8>>2]=i[24165]}if(u[h+31|0]<0&&Z(i[h+20>>2]),!s||(A=i[s+4>>2],i[s+4>>2]=A-1,A))break i;W[i[i[s>>2]+8>>2]](s),y(s);break i}i[A>>2]=5,i[A+4>>2]=2006,i[A+8>>2]=24841}v=h+32|0}function Nv(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,t=0,o=0,s=0,w=0,h=0,_=0,B=0;n=v-160|0,v=n,i[n+104>>2]=0,i[n+76>>2]=72500,o=i[18128],i[n+20>>2]=o,k=i[o-12>>2],o=n+20|0,i[k+o>>2]=i[18129],k=o+i[i[n+20>>2]-12>>2]|0,f=n+24|0,J0(k,f),u[k+80|0]=0,i[k+72>>2]=0,i[n+76>>2]=72500,i[n+20>>2]=72480,h=R0(f),i[h>>2]=71232,k=n- -64|0,i[k>>2]=0,i[k+4>>2]=0,i[n+56>>2]=0,i[n+60>>2]=0,i[n+72>>2]=16,k=n+8|0,Y2(k,e,r),s=o,t=k,o=u[n+19|0],k=(o|0)<0,Y(s,k?i[n+8>>2]:t,k?i[n+12>>2]:o),u[n+19|0]<0&&Z(i[n+8>>2]),B=n+8|0,o=B,f=v-160|0,v=f,i[f+92>>2]=0,i[f+64>>2]=72500,k=i[18128],i[f+8>>2]=k,t=i[k-12>>2],k=f+8|0,i[t+k>>2]=i[18129],w=k+i[i[f+8>>2]-12>>2]|0,t=f+12|0,J0(w,t),u[w+80|0]=0,i[w+72>>2]=0,i[f+64>>2]=72500,i[f+8>>2]=72480,w=R0(t),i[w>>2]=71232,i[f+52>>2]=0,i[f+56>>2]=0,i[f+44>>2]=0,i[f+48>>2]=0,i[f+60>>2]=16,t=f+148|0,s0(t,r),_=k,s=t,k=u[f+159|0],t=(k|0)<0,Y(_,t?i[f+148>>2]:s,t?i[f+152>>2]:k),u[f+159|0]<0&&Z(i[f+148>>2]),t=f+8|0,Y(t,29193,18),k=i[e+112>>2],s=i[e+116>>2];i:{if((k&s)==-1){Y(t,33178,8);break i}Y(q2(f+8|0,k,s),42670,1)}k=f+148|0,s0(k,r),s=k,k=u[f+159|0],t=(k|0)<0,Y(f+8|0,t?i[f+148>>2]:s,t?i[f+152>>2]:k),u[f+159|0]<0&&Z(i[f+148>>2]),k=f+8|0,Y(V0(Y(k,30476,18),i[e+120>>2]),42670,1),t=f+148|0,s0(t,r),_=k,s=t,k=u[f+159|0],t=(k|0)<0,Y(_,t?i[f+148>>2]:s,t?i[f+152>>2]:k),u[f+159|0]<0&&Z(i[f+148>>2]),k=f+8|0,Y(k,31419,18),t=i[e+124>>2];i:{if((t|0)==2147483647){Y(k,33443,10);break i}Y(S0(f+8|0,t),42670,1)}k=f+148|0,s0(k,r),t=k,r=u[f+159|0],k=(r|0)<0,Y(f+8|0,k?i[f+148>>2]:t,k?i[f+152>>2]:r),u[f+159|0]<0&&Z(i[f+148>>2]),Y(S0(Y(f+8|0,31671,12),l[e+128|0]),32808,1);i:{e:switch(l[e+128|0]){case 0:Y(f+8|0,42413,10);break i;case 2:Y(f+8|0,42505,32);break i;case 1:Y(f+8|0,42538,36);break i;default:break e}Y(f+8|0,42474,16)}e=i[f+60>>2];i:{e:{if(e&16){e=i[f+56>>2],r=i[f+36>>2],e>>>0<r>>>0&&(i[f+56>>2]=r,e=r),r=f+32|0;break e}if(!(e&8)){e=0,u[o+11|0]=0;break i}e=i[f+28>>2],r=f+20|0}e:{if(k=i[r>>2],e=e-k|0,e>>>0<2147483640){if(e>>>0>=11){t=e|7,r=p(t+1|0),i[o+8>>2]=t-2147483647,i[o>>2]=r,i[o+4>>2]=e,o=r;break e}if(u[o+11|0]=e,e)break e;e=0;break i}Q0(),H()}if(!e)break i;x(o,k,e)}u[e+o|0]=0,e=i[18127],i[f+8>>2]=e,i[i[e-12>>2]+(f+8|0)>>2]=i[18130],i[w>>2]=71232,u[f+55|0]<0&&Z(i[f+44>>2]),E0(w),y0(f- -64|0),v=f+160|0,e=u[n+19|0],r=(e|0)<0,Y(n+20|0,r?i[n+8>>2]:B,r?i[n+12>>2]:e),u[n+19|0]<0&&Z(i[n+8>>2]),e=i[n+72>>2];i:{e:{if(e&16){r=i[n+68>>2],e=i[n+48>>2],r>>>0<e>>>0&&(i[n+68>>2]=e,r=e),e=n+44|0;break e}if(!(e&8)){r=0,u[A+11|0]=0;break i}r=i[n+40>>2],e=n+32|0}e:{if(o=i[e>>2],r=r-o|0,r>>>0<2147483640){if(r>>>0>=11){k=r|7,e=p(k+1|0),i[A+8>>2]=k-2147483647,i[A>>2]=e,i[A+4>>2]=r,A=e;break e}if(u[A+11|0]=r,r)break e;r=0;break i}Q0(),H()}if(!r)break i;x(A,o,r)}u[A+r|0]=0,A=i[18127],i[n+20>>2]=A,i[i[A-12>>2]+(n+20|0)>>2]=i[18130],i[h>>2]=71232,u[n+67|0]<0&&Z(i[n+56>>2]),E0(h),y0(n+76|0),v=n+160|0}function Uv(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0;var k=0,n=0,t=0,o=0,s=0,w=0,h=0,_=0,B=0,m=0,X=0,Q=0,V=0;k=v-192|0,v=k,z2(k+172|0,e,r),u[k+191|0]<0&&Z(i[k+180>>2]);i:{if(l[e+97|0]>=2){t1(A,e,18952);break i}if(_=C0(r),n=i[f+28>>2],!(n>>>0<_>>>0&&n)){e:{f=l[r+20|0];r:{if(!(!i[r+16>>2]|(!_|f&1))){V=e+104|0;f:{for(;;){i[k+36>>2]=0,i[k+28>>2]=0,i[k+32>>2]=0;A:{if(!l[e+97|0]){f=o2(r);break A}f=C0(r)}i[k+24>>2]=f,B=0;A:{if(m=X2(r),!m)break A;k:{for(;;){n:{if(u[e+100|0]&1){n=o2(r),f=n&32767,t=n>>>15|0;break n}n=X2(r),f=n&127,t=n>>>7|0}n:{n=i[k+32>>2],s=i[k+36>>2];t:{if(n>>>0<s>>>0){f=t|f<<16,g[n>>1]=f,g[n+2>>1]=f>>>16,f=n+4|0;break t}if(w=i[k+28>>2],n=n-w|0,X=n>>2,o=X+1|0,o>>>0>=1073741824)break n;if(s=s-w|0,h=s>>1,s=s>>>0>=2147483644?1073741823:o>>>0<h>>>0?h:o,s){if(s>>>0>=1073741824)break k;o=p(s<<2)}else o=0;if(h=o+n|0,f=t|f<<16,g[h>>1]=f,g[h+2>>1]=f>>>16,t=h-(X<<2)|0,n&&x(t,w,n),i[k+36>>2]=o+(s<<2),f=h+4|0,i[k+32>>2]=f,i[k+28>>2]=t,!w)break t;Z(w)}if(i[k+32>>2]=f,B=B+1|0,(m|0)==(B|0))break A;continue}break}G0(),H()}z0(),H()}f=i[e+108>>2];A:{if(f>>>0<u0[e+112>>2]){if(n=i[k+24>>2],i[f+12>>2]=0,i[f+4>>2]=0,i[f+8>>2]=0,i[f>>2]=n,n=i[k+32>>2],o=i[k+28>>2],(n|0)!=(o|0)){if(n=n-o|0,(n|0)<0)break f;t=p(n),i[f+8>>2]=t,i[f+4>>2]=t,w=n+t|0,i[f+12>>2]=w,n&&x(t,o,n),i[f+8>>2]=w}f=f+16|0;break A}f=Yr(V,k+24|0)}if(i[e+108>>2]=f,f=i[k+28>>2],f&&(i[k+32>>2]=f,Z(f)),f=l[r+20|0],Q=Q+1|0,!!(!i[r+16>>2]||f&1|_>>>0<=Q>>>0))break}if(f&1)break r;break e}G0(),H()}if(!(f&1))break e}if(u[k+24|0]=0,u[k+35|0]=0,q(A,2,100,k+24|0),u[k+35|0]>=0)break i;Z(i[k+24>>2]);break i}if(e=i[26917],i[A>>2]=i[26916],i[A+4>>2]=e,A=A+8|0,u[107683]>=0){e=i[26919],i[A>>2]=i[26918],i[A+4>>2]=e,i[A+8>>2]=i[26920];break i}T(A,i[26918],i[26919]);break i}i[k+116>>2]=0,i[k+88>>2]=72196,i[k+32>>2]=72176,e=i[18053],i[k+24>>2]=e,r=i[e-12>>2],e=k+24|0,i[r+e>>2]=i[18054],i[k+28>>2]=0,r=e+i[i[k+24>>2]-12>>2]|0,n=k+36|0,J0(r,n),u[r+80|0]=0,i[r+72>>2]=0,r=i[18055],i[k+32>>2]=r,t=k+32|0,i[t+i[r-12>>2]>>2]=i[18056],r=i[18052],i[k+24>>2]=r,i[e+i[r-12>>2]>>2]=i[18057],i[k+88>>2]=72196,i[k+24>>2]=72156,i[k+32>>2]=72176,r=R0(n),i[r>>2]=71232,i[k+76>>2]=0,i[k+80>>2]=0,i[k+68>>2]=0,i[k+72>>2]=0,i[k+84>>2]=24,Y(V0(Y(V0(Y(t,27755,40),_),27903,47),i[f+28>>2]),5081,6),e=i[k+84>>2];e:{r:{if(e&16){f=i[k+80>>2],e=i[k+60>>2],f>>>0<e>>>0&&(i[k+80>>2]=e,f=e),e=k+56|0;break r}if(!(e&8)){f=0,u[k+23|0]=0,e=k+12|0;break e}f=i[k+52>>2],e=k+44|0}r:{if(n=i[e>>2],f=f-n|0,f>>>0<2147483640){if(f>>>0>=11){t=f|7,e=p(t+1|0),i[k+20>>2]=t-2147483647,i[k+12>>2]=e,i[k+16>>2]=f;break r}if(u[k+23|0]=f,e=k+12|0,f)break r;f=0;break e}Q0(),H()}if(!f)break e;x(e,n,f)}u[e+f|0]=0,q(A,2,1e3,k+12|0),u[k+23|0]<0&&Z(i[k+12>>2]),A=i[18051],i[k+24>>2]=A,i[i[A-12>>2]+(k+24|0)>>2]=i[18059],i[k+32>>2]=i[18060],i[r>>2]=71232,u[k+79|0]<0&&Z(i[k+68>>2]),E0(r),y0(k+88|0)}v=k+192|0}function Dv(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,t=0,o=0,s=0,w=0,h=0,_=0,B=0,m=0,X=0,Q=0,V=0,F=0,I=0,E=0,R=0,N=0,M=0;Q=e+4|0,o=r<<2,N=g[Q+o>>1],s=e+2|0,h=g[s+o>>1],m=e+6|0,_=g[m+o>>1],f=r<<1,V=g[f+Q>>1],w=G(r,6),r=g[w+Q>>1],B=g[e+o>>1],Q=g[Q>>1],o=g[w+m>>1],I=g[f+m>>1],m=g[m>>1],k=G(o,-74)+G(I+m|0,74)>>1,k=(k|0)>=32767?32767:k,k=(k|0)<=-32768?-32768:k,E=g[s+w>>1],R=g[f+s>>1],s=g[s>>1],n=G(E,-74)+G(R+s|0,74)>>1,n=(n|0)>=32767?32767:n,n=(n|0)<=-32768?-32768:n,w=g[e+w>>1],f=g[e+f>>1],e=g[e>>1],t=G(w,-74)+G(f+e|0,74)>>1,t=(t|0)>=32767?32767:t,t=(t|0)<=-32768?-32768:t,g[A+10>>1]=(G(k,16777142)+G(n+t|0,74)|0)+128>>>8,X=G(r,-74)+G(Q+V|0,74)>>1,X=(X|0)>=32767?32767:X,X=(X|0)<=-32768?-32768:X,F=G(X,74),g[A+14>>1]=((F+(G(n,-84)+G(t,55)|0)|0)+G(k,16777187)|0)+128>>>8,g[A+12>>1]=(((G(n,-29)+G(t,84)|0)+G(X,16777142)|0)+G(k,55)|0)+128>>>8,g[A+8>>1]=((F+(G(n,55)+G(t,29)|0)|0)+G(k,84)|0)+128>>>8,X=G(_,74),k=((X+(G(I,-84)+G(m,55)|0)|0)+G(o,-29)|0)+1>>1,k=(k|0)>=32767?32767:k,k=(k|0)<=-32768?-32768:k,F=G(h,74),n=((F+(G(R,-84)+G(s,55)|0)|0)+G(E,-29)|0)+1>>1,n=(n|0)>=32767?32767:n,n=(n|0)<=-32768?-32768:n,M=G(B,74),t=((M+(G(f,-84)+G(e,55)|0)|0)+G(w,-29)|0)+1>>1,t=(t|0)>=32767?32767:t,t=(t|0)<=-32768?-32768:t,g[A+26>>1]=(G(k,16777142)+G(n+t|0,74)|0)+128>>>8,_=(((G(I,-29)+G(m,84)|0)+G(_,-74)|0)+G(o,55)|0)+1>>1,_=(_|0)>=32767?32767:_,_=(_|0)<=-32768?-32768:_,h=(((G(R,-29)+G(s,84)|0)+G(h,-74)|0)+G(E,55)|0)+1>>1,h=(h|0)>=32767?32767:h,h=(h|0)<=-32768?-32768:h,B=(((G(f,-29)+G(e,84)|0)+G(B,-74)|0)+G(w,55)|0)+1>>1,B=(B|0)>=32767?32767:B,B=(B|0)<=-32768?-32768:B,g[A+18>>1]=(G(_,16777142)+G(h+B|0,74)|0)+128>>>8,o=((X+(G(I,55)+G(m,29)|0)|0)+G(o,84)|0)+1>>1,o=(o|0)>=32767?32767:o,o=(o|0)<=-32768?-32768:o,s=((F+(G(R,55)+G(s,29)|0)|0)+G(E,84)|0)+1>>1,s=(s|0)>=32767?32767:s,s=(s|0)<=-32768?-32768:s,e=(((G(f,55)+G(e,29)|0)+M|0)+G(w,84)|0)+1>>1,e=(e|0)>=32767?32767:e,e=(e|0)<=-32768?-32768:e,g[A+2>>1]=(G(o,16777142)+G(s+e|0,74)|0)+128>>>8,m=G(N,74),f=((m+(G(V,-84)+G(Q,55)|0)|0)+G(r,-29)|0)+1>>1,f=(f|0)>=32767?32767:f,f=(f|0)<=-32768?-32768:f,w=G(f,74),g[A+30>>1]=((w+(G(n,-84)+G(t,55)|0)|0)+G(k,16777187)|0)+128>>>8,g[A+28>>1]=(((G(n,-29)+G(t,84)|0)+G(f,16777142)|0)+G(k,55)|0)+128>>>8,g[A+24>>1]=((w+(G(n,55)+G(t,29)|0)|0)+G(k,84)|0)+128>>>8,f=(((G(V,-29)+G(Q,84)|0)+G(N,-74)|0)+G(r,55)|0)+1>>1,f=(f|0)>=32767?32767:f,f=(f|0)<=-32768?-32768:f,w=G(f,74),g[A+22>>1]=((w+(G(h,-84)+G(B,55)|0)|0)+G(_,16777187)|0)+128>>>8,g[A+20>>1]=(((G(h,-29)+G(B,84)|0)+G(f,16777142)|0)+G(_,55)|0)+128>>>8,g[A+16>>1]=((w+(G(h,55)+G(B,29)|0)|0)+G(_,84)|0)+128>>>8,r=((m+(G(V,55)+G(Q,29)|0)|0)+G(r,84)|0)+1>>1,r=(r|0)>=32767?32767:r,r=(r|0)<=-32768?-32768:r,V=G(r,74),g[A+6>>1]=((V+(G(s,-84)+G(e,55)|0)|0)+G(o,16777187)|0)+128>>>8,g[A+4>>1]=(((G(s,-29)+G(e,84)|0)+G(r,16777142)|0)+G(o,55)|0)+128>>>8,g[A>>1]=((V+(G(s,55)+G(e,29)|0)|0)+G(o,84)|0)+128>>>8}function Mv(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0;var k=0,n=0,t=0,o=0,s=0,w=0,h=0,_=0,B=0,m=0,X=0;n=v-48|0,v=n,B=n+24|0,w=v-16|0,v=w,k=i[r+16>>2],o=k>>>0>=6?6:k,k=i[r+8>>2],k&&c1(k,o),t=i[r>>2],k=W[i[i[t>>2]+8>>2]](t)|0,h=l0,k=k+o|0,h=k>>>0<o>>>0?h+1|0:h,W[i[i[t>>2]+20>>2]](t,k,h)|0,i[r+16>>2]=i[r+16>>2]-o,m=e,X=o2(r),g[m+100>>1]=X,m=e,X=o2(r),g[m+102>>1]=X,k=i[r+16>>2],h=k>>>0>=2?2:k,k=i[r+8>>2],k&&c1(k,h),t=i[r>>2],k=W[i[i[t>>2]+8>>2]](t)|0,o=l0,k=k+h|0,o=k>>>0<h>>>0?o+1|0:o,W[i[i[t>>2]+20>>2]](t,k,o)|0,i[r+16>>2]=i[r+16>>2]-h,m=e,X=C0(r),i[m+104>>2]=X,m=e,X=C0(r),i[m+108>>2]=X,m=e,X=C0(r),i[m+112>>2]=X,m=e,X=o2(r),g[m+116>>1]=X,m=e,X=o2(r),g[m+118>>1]=X,m=e,X=C0(r),i[m+120>>2]=X,m=e,X=C0(r),i[m+124>>2]=X,k=i[r+16>>2],h=k>>>0>=4?4:k,k=i[r+8>>2],k&&c1(k,h),t=i[r>>2],k=W[i[i[t>>2]+8>>2]](t)|0,o=l0,k=k+h|0,o=k>>>0<h>>>0?o+1|0:o,W[i[i[t>>2]+20>>2]](t,k,o)|0,i[r+16>>2]=i[r+16>>2]-h,m=e,X=o2(r),g[m+128>>1]=X,s=v-32|0,v=s,i[s+24>>2]=0,i[s+16>>2]=0,i[s+20>>2]=0;i:{if(!f4(r,32)){i[w+4>>2]=0,i[w+8>>2]=0,i[w+12>>2]=0;break i}k=i[r>>2],_=i[r+4>>2],_&&(i[_+4>>2]=i[_+4>>2]+1);e:{r:{f:{A:{k:{if(!(W[i[i[k>>2]+16>>2]](k,s+15|0,1)|0)||(t=l[s+15|0],t>>>0>=32))break k;if(t)break A;t=-1;break f}i[w+4>>2]=0,i[w+8>>2]=0,i[w+12>>2]=0;break e}for(o=0;;){if(!(W[i[i[k>>2]+16>>2]](k,s+14|0,1)|0))break r;if(oi(s+16|0,u[s+14|0]),o=o+1|0,t=l[s+15|0],!(o>>>0<t>>>0))break}t=t^-1}t=t+32|0,o=(W[i[i[k>>2]+8>>2]](k)|0)+t|0,h=l0+(t>>31)|0,W[i[i[k>>2]+20>>2]](k,o,o>>>0<t>>>0?h+1|0:h)|0,i[w+12>>2]=i[s+24>>2],k=i[s+20>>2],i[w+4>>2]=i[s+16>>2],i[w+8>>2]=k,i[s+24>>2]=0,i[s+16>>2]=0,i[s+20>>2]=0;break e}i8(r),i[w+12>>2]=0,i[w+4>>2]=0,i[w+8>>2]=0}if(!_||(k=i[_+4>>2],i[_+4>>2]=k-1,k))break i;W[i[i[_>>2]+8>>2]](_),y(_)}u[s+27|0]<0&&Z(i[s+16>>2]),v=s+32|0,u[e+143|0]<0&&Z(i[e+132>>2]),k=i[w+8>>2],i[e+132>>2]=i[w+4>>2],i[e+136>>2]=k,i[e+140>>2]=i[w+12>>2],m=e,X=o2(r),g[m+144>>1]=X,m=e,X=wi(r),g[m+146>>1]=X,k=i[26917],i[B>>2]=i[26916],i[B+4>>2]=k,B=B+8|0;i:{if(u[107683]>=0){k=i[26919],i[B>>2]=i[26918],i[B+4>>2]=k,i[B+8>>2]=i[26920];break i}T(B,i[26918],i[26919])}v=w+16|0;i:{if(i[n+24>>2]){e=i[n+28>>2],i[A>>2]=i[n+24>>2],i[A+4>>2]=e,i[A+16>>2]=i[n+40>>2],e=i[n+36>>2],i[A+8>>2]=i[n+32>>2],i[A+12>>2]=e,i[n+40>>2]=0,i[n+32>>2]=0,i[n+36>>2]=0;break i}if(d6(n,e,r,-1,f),r=i[n+4>>2],e=i[n>>2],i[n+24>>2]=e,i[n+28>>2]=r,u[n+43|0]<0&&(Z(i[n+32>>2]),e=i[n+24>>2]),r=i[n+12>>2],i[n+32>>2]=i[n+8>>2],i[n+36>>2]=r,i[n+40>>2]=i[n+16>>2],r=A+8|0,e){e=i[n+28>>2],i[A>>2]=i[n+24>>2],i[A+4>>2]=e,i[r+8>>2]=i[n+40>>2],A=i[n+36>>2],i[r>>2]=i[n+32>>2],i[r+4>>2]=A,i[n+32>>2]=0,i[n+36>>2]=0,i[n+40>>2]=0;break i}if(e=i[26917],i[A>>2]=i[26916],i[A+4>>2]=e,u[107683]>=0){A=i[26919],i[r>>2]=i[26918],i[r+4>>2]=A,i[r+8>>2]=i[26920];break i}T(r,i[26918],i[26919])}u[n+43|0]<0&&Z(i[n+32>>2]),v=n+48|0}function Hv(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0;var k=0,n=0,t=0,o=0,s=0,w=0,h=0,_=0,B=0,m=0,X=0,Q=0,V=0,F=0,I=0,E=0,R=0,N=0,M=0,z=0,S=0,O=0,P=0,a=0,$=0;$=g[e+10>>1],X=g[e+26>>1],M=g[e+18>>1],z=g[e+2>>1],E=g[e+14>>1],R=g[e+12>>1],N=g[e+8>>1],w=1<<r-1,n=1<<f,f=0-n|0,_=g[e+22>>1],k=g[e+6>>1],I=g[e+30>>1],t=((G(_,-74)+G(k,74)|0)+G(I,74)|0)- -64>>7,h=n+65535|0,t=((f|0)>(t|0)?f:(n|0)>(t|0)?t:h)<<16>>16,B=g[e+20>>1],S=g[e+4>>1],O=g[e+28>>1],o=((G(B,-74)+G(S,74)|0)+G(O,74)|0)- -64>>7,o=((f|0)>(o|0)?f:(n|0)>(o|0)?o:h)<<16>>16,P=g[e+16>>1],a=g[e>>1],e=g[e+24>>1],s=((G(P,-74)+G(a,74)|0)+G(e,74)|0)- -64>>7,s=((f|0)>(s|0)?f:(n|0)>(s|0)?s:h)<<16>>16,i[A+40>>2]=w+(G(t,74)+(G(o,-74)+G(s,74)|0)|0)>>r,Q=(((G(R,-74)+G(S,84)|0)+G(B,55)|0)+G(O,-29)|0)- -64>>7,Q=((f|0)>(Q|0)?f:(n|0)>(Q|0)?Q:h)<<16>>16,V=(((G(N,-74)+G(a,84)|0)+G(P,55)|0)+G(e,-29)|0)- -64>>7,V=((f|0)>(V|0)?f:(n|0)>(V|0)?V:h)<<16>>16,F=(((G(E,-74)+G(k,84)|0)+G(_,55)|0)+G(I,-29)|0)- -64>>7,F=((f|0)>(F|0)?f:(n|0)>(F|0)?F:h)<<16>>16,i[A+56>>2]=((G(Q,-74)+G(V,74)|0)+G(F,74)|0)+w>>r,m=((G(M,-74)+G(z,74)|0)+G(X,74)|0)- -64>>7,m=((f|0)>(m|0)?f:(n|0)>(m|0)?m:h)<<16>>16,i[A+44>>2]=(((G(m,-74)+G(s,84)|0)+G(o,55)|0)+G(t,-29)|0)+w>>r,m=G(m,74),i[A+36>>2]=(((m+G(s,55)|0)+G(o,-29)|0)+G(t,-84)|0)+w>>r,i[A+32>>2]=(((m+G(s,29)|0)+G(o,84)|0)+G(t,55)|0)+w>>r,R=G(R,74),t=(((R+G(S,55)|0)+G(B,-29)|0)+G(O,-84)|0)- -64>>7,t=((f|0)>(t|0)?f:(n|0)>(t|0)?t:h)<<16>>16,N=G(N,74),o=(((N+G(a,55)|0)+G(P,-29)|0)+G(e,-84)|0)- -64>>7,o=((f|0)>(o|0)?f:(n|0)>(o|0)?o:h)<<16>>16,E=G(E,74),s=(((E+G(k,55)|0)+G(_,-29)|0)+G(I,-84)|0)- -64>>7,s=((f|0)>(s|0)?f:(n|0)>(s|0)?s:h)<<16>>16,i[A+24>>2]=((G(t,-74)+G(o,74)|0)+G(s,74)|0)+w>>r,B=(((R+G(S,29)|0)+G(B,84)|0)+G(O,55)|0)- -64>>7,B=((f|0)>(B|0)?f:(n|0)>(B|0)?B:h)<<16>>16,e=(((N+G(a,29)|0)+G(P,84)|0)+G(e,55)|0)- -64>>7,e=((e|0)<(f|0)?f:(e|0)<(n|0)?e:h)<<16>>16,_=(((E+G(k,29)|0)+G(_,84)|0)+G(I,55)|0)- -64>>7,_=((f|0)>(_|0)?f:(n|0)>(_|0)?_:h)<<16>>16,i[A+8>>2]=((G(B,-74)+G(e,74)|0)+G(_,74)|0)+w>>r,k=(((G($,-74)+G(z,84)|0)+G(M,55)|0)+G(X,-29)|0)- -64>>7,k=((f|0)>(k|0)?f:(n|0)>(k|0)?k:h)<<16>>16,i[A+60>>2]=(((G(k,-74)+G(V,84)|0)+G(Q,55)|0)+G(F,-29)|0)+w>>r,k=G(k,74),i[A+52>>2]=(((k+G(V,55)|0)+G(Q,-29)|0)+G(F,-84)|0)+w>>r,i[A+48>>2]=(((k+G(V,29)|0)+G(Q,84)|0)+G(F,55)|0)+w>>r,I=G($,74),k=(((I+G(z,55)|0)+G(M,-29)|0)+G(X,-84)|0)- -64>>7,k=((f|0)>(k|0)?f:(n|0)>(k|0)?k:h)<<16>>16,i[A+28>>2]=(((G(k,-74)+G(o,84)|0)+G(t,55)|0)+G(s,-29)|0)+w>>r,k=G(k,74),i[A+20>>2]=(((k+G(o,55)|0)+G(t,-29)|0)+G(s,-84)|0)+w>>r,i[A+16>>2]=(((k+G(o,29)|0)+G(t,84)|0)+G(s,55)|0)+w>>r,X=(((I+G(z,29)|0)+G(M,84)|0)+G(X,55)|0)- -64>>7,f=((f|0)>(X|0)?f:(n|0)>(X|0)?X:h)<<16>>16,i[A+12>>2]=(((G(f,-74)+G(e,84)|0)+G(B,55)|0)+G(_,-29)|0)+w>>r,f=G(f,74),i[A+4>>2]=(((f+G(e,55)|0)+G(B,-29)|0)+G(_,-84)|0)+w>>r,i[A>>2]=(((f+G(e,29)|0)+G(B,84)|0)+G(_,55)|0)+w>>r}function ur(A,e){var r=0,f=0,k=0,n=0,t=0,o=0,s=0,w=0,h=0;n=A+e|0,r=i[A+4>>2];i:{e:{if(r&1)break e;if(!(r&2))break i;r=i[A>>2],e=r+e|0;r:{f:{A:{if(A=A-r|0,(A|0)!=i[31643]){if(f=i[A+12>>2],r>>>0<=255){if(k=i[A+8>>2],(k|0)!=(f|0))break A;w=126552,h=i[31638]&k2(-2,r>>>3|0),i[w>>2]=h;break e}if(t=i[A+24>>2],(A|0)!=(f|0)){r=i[A+8>>2],i[r+12>>2]=f,i[f+8>>2]=r;break r}if(k=i[A+20>>2],k)r=A+20|0;else{if(k=i[A+16>>2],!k)break f;r=A+16|0}for(;o=r,f=k,r=f+20|0,k=i[f+20>>2],!(!k&&(r=f+16|0,k=i[f+16>>2],!k)););i[o>>2]=0;break r}if(r=i[n+4>>2],(r&3)!=3)break e;i[31640]=e,i[n+4>>2]=r&-2,i[A+4>>2]=e|1,i[n>>2]=e;return}i[k+12>>2]=f,i[f+8>>2]=k;break e}f=0}if(!t)break e;r=i[A+28>>2],k=(r<<2)+126856|0;r:{if(i[k>>2]==(A|0)){if(i[k>>2]=f,f)break r;w=126556,h=i[31639]&k2(-2,r),i[w>>2]=h;break e}f:{if(i[t+16>>2]==(A|0)){i[t+16>>2]=f;break f}i[t+20>>2]=f}if(!f)break e}if(i[f+24>>2]=t,r=i[A+16>>2],r&&(i[f+16>>2]=r,i[r+24>>2]=f),r=i[A+20>>2],!r)break e;i[f+20>>2]=r,i[r+24>>2]=f}e:{r:{f:{A:{if(r=i[n+4>>2],!(r&2)){if(i[31644]==(n|0)){if(i[31644]=A,e=i[31641]+e|0,i[31641]=e,i[A+4>>2]=e|1,i[31643]!=(A|0))break i;i[31640]=0,i[31643]=0;return}if(s=i[31643],(s|0)==(n|0)){i[31643]=A,e=i[31640]+e|0,i[31640]=e,i[A+4>>2]=e|1,i[A+e>>2]=e;return}if(e=(r&-8)+e|0,f=i[n+12>>2],r>>>0<=255){if(k=i[n+8>>2],(k|0)==(f|0)){w=126552,h=i[31638]&k2(-2,r>>>3|0),i[w>>2]=h;break r}i[k+12>>2]=f,i[f+8>>2]=k;break r}if(t=i[n+24>>2],(f|0)!=(n|0)){r=i[n+8>>2],i[r+12>>2]=f,i[f+8>>2]=r;break f}if(k=i[n+20>>2],k)r=n+20|0;else{if(k=i[n+16>>2],!k)break A;r=n+16|0}for(;o=r,f=k,r=f+20|0,k=i[f+20>>2],!(!k&&(r=f+16|0,k=i[f+16>>2],!k)););i[o>>2]=0;break f}i[n+4>>2]=r&-2,i[A+4>>2]=e|1,i[A+e>>2]=e;break e}f=0}if(!t)break r;r=i[n+28>>2],k=(r<<2)+126856|0;f:{if(i[k>>2]==(n|0)){if(i[k>>2]=f,f)break f;w=126556,h=i[31639]&k2(-2,r),i[w>>2]=h;break r}A:{if(i[t+16>>2]==(n|0)){i[t+16>>2]=f;break A}i[t+20>>2]=f}if(!f)break r}if(i[f+24>>2]=t,r=i[n+16>>2],r&&(i[f+16>>2]=r,i[r+24>>2]=f),r=i[n+20>>2],!r)break r;i[f+20>>2]=r,i[r+24>>2]=f}if(i[A+4>>2]=e|1,i[A+e>>2]=e,(A|0)!=(s|0))break e;i[31640]=e;return}if(e>>>0<=255){r=(e&-8)+126592|0,f=i[31638],e=1<<(e>>>3);e:{if(!(f&e)){i[31638]=e|f,e=r;break e}e=i[r+8>>2]}i[r+8>>2]=A,i[e+12>>2]=A,i[A+12>>2]=r,i[A+8>>2]=e;return}f=31,e>>>0<=16777215&&(r=k1(e>>>8|0),f=((e>>>38-r&1)-(r<<1)|0)+62|0),i[A+28>>2]=f,i[A+16>>2]=0,i[A+20>>2]=0,r=(f<<2)+126856|0;e:{k=i[31639],o=1<<f;r:{if(!(k&o)){i[31639]=k|o,i[r>>2]=A,i[A+24>>2]=r;break r}for(f=e<<((f|0)!=31?25-(f>>>1|0)|0:0),r=i[r>>2];;){if(k=r,(i[r+4>>2]&-8)==(e|0))break e;if(r=f>>>29|0,f=f<<1,o=k+(r&4)|0,r=i[o+16>>2],!r)break}i[o+16>>2]=A,i[A+24>>2]=k}i[A+12>>2]=A,i[A+8>>2]=A;return}e=i[k+8>>2],i[e+12>>2]=A,i[k+8>>2]=A,i[A+24>>2]=0,i[A+12>>2]=k,i[A+8>>2]=e}}function g9(A,e,r,f,k,n){var t=0,o=0,s=0,w=0,h=0,_=0,B=0;t=i[r>>2],s=i[t+116>>2],_=i[t+120>>2],i[e+120>>2]=_,i[e+116>>2]=s,i[e+112>>2]=k,i[e+108>>2]=f;i:{e:{r:{f:switch(s|0){case 2:h=255,o=i[t+128>>2];A:{if(!o)break A;for(w=t+128|0,t=w;s=i[o+16>>2],t=(s|0)<0?t:o,o=i[(s>>>29&4)+o>>2],!!o;);if((t|0)==(w|0)|i[t+16>>2]>0)break A;h=l[t+24|0]}if(T0(A,e,0,f,k,h,n),i[A>>2])break i;if(u[A+19|0]<0)break r;break e;case 0:h=255,o=i[t+128>>2];A:{if(!o)break A;for(w=t+128|0,t=w;s=i[o+16>>2],t=(s|0)<0?t:o,o=i[(s>>>29&4)+o>>2],!!o;);if((t|0)==(w|0)|i[t+16>>2]>0)break A;h=l[t+24|0]}if(T0(A,e,0,f,k,h,n),i[A>>2])break i;u[A+19|0]<0&&Z(i[A+8>>2]),h=(_|0)==1?k+1>>>1|0:k,_=_-1>>>0<2?f+1>>>1|0:f,B=255,s=i[r>>2],o=i[s+128>>2];A:{if(!o)break A;for(w=s+128|0,t=w;s=i[o+16>>2]<=0,t=s?t:o,o=i[(s?4:0)+o>>2],!!o;);if((t|0)==(w|0)|i[t+16>>2]>1)break A;B=l[t+24|0]}if(T0(A,e,1,_,h,B,n),i[A>>2])break i;u[A+19|0]<0&&Z(i[A+8>>2]),B=255,s=i[r>>2],o=i[s+128>>2];A:{if(!o)break A;for(w=s+128|0,t=w;s=i[o+16>>2]<2,t=s?t:o,o=i[(s?4:0)+o>>2],!!o;);if((t|0)==(w|0)|i[t+16>>2]>2)break A;B=l[t+24|0]}if(T0(A,e,2,_,h,B,n),i[A>>2])break i;if(u[A+19|0]<0)break r;break e;case 1:break f;default:break e}if(s=t+128|0,o=i[t+128>>2],(_|0)==3){h=255;f:{if(!o)break f;for(t=s;w=i[o+16>>2]<3,t=w?t:o,o=i[(w?4:0)+o>>2],!!o;);if((t|0)==(s|0)|i[t+16>>2]>3)break f;h=l[t+24|0]}if(T0(A,e,3,f,k,h,n),i[A>>2])break i;u[A+19|0]<0&&Z(i[A+8>>2]),h=255,s=i[r>>2],o=i[s+128>>2];f:{if(!o)break f;for(w=s+128|0,t=w;s=i[o+16>>2]<4,t=s?t:o,o=i[(s?4:0)+o>>2],!!o;);if((t|0)==(w|0)|i[t+16>>2]>4)break f;h=l[t+24|0]}if(T0(A,e,4,f,k,h,n),i[A>>2])break i;u[A+19|0]<0&&Z(i[A+8>>2]),h=255,s=i[r>>2],o=i[s+128>>2];f:{if(!o)break f;for(w=s+128|0,t=w;s=i[o+16>>2]<5,t=s?t:o,o=i[(s?4:0)+o>>2],!!o;);if((t|0)==(w|0)|i[t+16>>2]>5)break f;h=l[t+24|0]}if(T0(A,e,5,f,k,h,n),i[A>>2])break i;if(u[A+19|0]<0)break r;break e}h=255;f:{if(!o)break f;for(t=s;w=i[o+16>>2]<10,t=w?t:o,o=i[(w?4:0)+o>>2],!!o;);if((t|0)==(s|0)|i[t+16>>2]>10)break f;h=l[t+24|0]}if(T0(A,e,10,f,k,h,n),i[A>>2])break i;if(u[A+19|0]>=0)break e}Z(i[A+8>>2])}s=i[r>>2],r=i[s+128>>2];e:{if(!r)break e;for(s=s+128|0,t=s,o=r;w=i[o+16>>2]<6,t=w?t:o,o=i[(w?4:0)+o>>2],!!o;);if((t|0)==(s|0)|i[t+16>>2]>6)break e;for(o=s;t=i[r+16>>2]<6,o=t?o:r,r=i[(t?4:0)+r>>2],!!r;);if(t=255,T0(A,e,6,f,k,(o|0)==(s|0)|i[o+16>>2]>6?t:l[o+24|0],n),i[A>>2])break i;if(u[A+19|0]>=0)break e;Z(i[A+8>>2])}if(e=i[26917],i[A>>2]=i[26916],i[A+4>>2]=e,e=A+8|0,u[107683]>=0){A=i[26919],i[e>>2]=i[26918],i[e+4>>2]=A,i[e+8>>2]=i[26920];return}T(e,i[26918],i[26919])}}function zv(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,t=0,o=0,s=0;f=v-176|0,v=f,i[f+108>>2]=0,i[f+80>>2]=72500,k=i[18128],i[f+24>>2]=k,n=i[k-12>>2],k=f+24|0,i[n+k>>2]=i[18129],s=k+i[i[f+24>>2]-12>>2]|0,n=f+28|0,J0(s,n),u[s+80|0]=0,i[s+72>>2]=0,i[f+80>>2]=72500,i[f+24>>2]=72480,s=R0(n),i[s>>2]=71232,i[f+68>>2]=0,i[f+72>>2]=0,i[f+60>>2]=0,i[f+64>>2]=0,i[f+76>>2]=16,n=f+164|0,Y2(n,e,r),t=k,o=n,k=u[f+175|0],n=(k|0)<0,Y(t,n?i[f+164>>2]:o,n?i[f+168>>2]:k),u[f+175|0]<0&&Z(i[f+164>>2]),k=f+164|0,s0(k,r),t=k,k=u[f+175|0],n=(k|0)<0,Y(f+24|0,n?i[f+164>>2]:t,n?i[f+168>>2]:k),u[f+175|0]<0&&Z(i[f+164>>2]),k=Y(V0(Y(f+24|0,32505,9),i[e+104>>2]),42670,1),n=f+164|0,s0(n,r),t=n,n=u[f+175|0],o=(n|0)<0,Y(k,o?i[f+164>>2]:t,o?i[f+168>>2]:n),u[f+175|0]<0&&Z(i[f+164>>2]),k=Y(V0(Y(k,29376,23),C[e+108>>1]),42670,1),n=f+164|0,s0(n,r),t=n,n=u[f+175|0],o=(n|0)<0,Y(k,o?i[f+164>>2]:t,o?i[f+168>>2]:n),u[f+175|0]<0&&Z(i[f+164>>2]),k=Y(k,31642,11),n=f+12|0,L1(n,i[e+112>>2]),t=k,o=n,k=u[f+23|0],n=(k|0)<0,k=Y(Y(t,n?i[f+12>>2]:o,n?i[f+16>>2]:k),42670,1),n=f+164|0,s0(n,r),t=n,n=u[f+175|0],o=(n|0)<0,Y(k,o?i[f+164>>2]:t,o?i[f+168>>2]:n),u[f+175|0]<0&&Z(i[f+164>>2]),t=Y(k,31849,11),k=u[e+127|0],n=(k|0)<0,Y(Y(t,n?i[e+116>>2]:e+116|0,n?i[e+120>>2]:k),42670,1),u[f+23|0]<0&&Z(i[f+12>>2]),k=i[e+112>>2],(k|0)==1835625829&&(k=f+164|0,s0(k,r),t=k,k=u[f+175|0],n=(k|0)<0,Y(f+24|0,n?i[f+164>>2]:t,n?i[f+168>>2]:k),u[f+175|0]<0&&Z(i[f+164>>2]),t=Y(f+24|0,31547,14),k=u[e+139|0],n=(k|0)<0,k=Y(Y(t,n?i[e+128>>2]:e+128|0,n?i[e+132>>2]:k),42670,1),n=f+164|0,s0(n,r),t=n,n=u[f+175|0],o=(n|0)<0,Y(k,o?i[f+164>>2]:t,o?i[f+168>>2]:n),u[f+175|0]<0&&Z(i[f+164>>2]),t=Y(k,31046,18),k=u[e+151|0],n=(k|0)<0,Y(Y(t,n?i[e+140>>2]:e+140|0,n?i[e+144>>2]:k),42670,1),k=i[e+112>>2]),(k|0)==1970432288&&(k=f+164|0,s0(k,r),t=k,k=u[f+175|0],n=(k|0)<0,Y(f+24|0,n?i[f+164>>2]:t,n?i[f+168>>2]:k),u[f+175|0]<0&&Z(i[f+164>>2]),t=Y(f+24|0,31750,15),k=u[e+163|0],n=(k|0)<0,Y(Y(t,n?i[e+152>>2]:e+152|0,n?i[e+156>>2]:k),42670,1)),k=f+164|0,s0(k,r),n=k,r=u[f+175|0],k=(r|0)<0,Y(f+24|0,k?i[f+164>>2]:n,k?i[f+168>>2]:r),u[f+175|0]<0&&Z(i[f+164>>2]),r=Y(f+24|0,30786,13),k=i[i[r>>2]-12>>2]+r|0,i[k+4>>2]=i[k+4>>2]|1,Y(li(r,l[e+164|0]),42670,1),e=i[f+76>>2];i:{e:{if(e&16){e=i[f+72>>2],r=i[f+52>>2],e>>>0<r>>>0&&(i[f+72>>2]=r,e=r),r=f+48|0;break e}if(!(e&8)){e=0,u[A+11|0]=0;break i}e=i[f+44>>2],r=f+36|0}e:{if(k=i[r>>2],e=e-k|0,e>>>0<2147483640){if(e>>>0>=11){n=e|7,r=p(n+1|0),i[A+8>>2]=n-2147483647,i[A>>2]=r,i[A+4>>2]=e,A=r;break e}if(u[A+11|0]=e,e)break e;e=0;break i}Q0(),H()}if(!e)break i;x(A,k,e)}u[A+e|0]=0,A=i[18127],i[f+24>>2]=A,i[i[A-12>>2]+(f+24|0)>>2]=i[18130],i[s>>2]=71232,u[f+71|0]<0&&Z(i[f+60>>2]),E0(s),y0(f+80|0),v=f+176|0}function xv(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0;var k=0,n=0,t=0,o=0,s=0,w=0,h=0,_=0,B=0,m=0,X=0;f=v-32|0,v=f,h=f+12|0,_=i[e>>2],s=v-32|0,v=s,n=p(172),i[n+4>>2]=0,i[n+8>>2]=0,i[n>>2]=94424,m=_,X=Zr(n+12|0),i[m+48>>2]=X,k=i[_+52>>2],i[_+52>>2]=n;i:{if(!k||(n=i[k+4>>2],i[k+4>>2]=n-1,n))break i;W[i[i[k>>2]+8>>2]](k),y(k)}w=i[_+48>>2],i[w+156>>2]=_- -64,n=v-176|0,v=n,k=p(192),i[k+108>>2]=72680,i[k+136>>2]=0,o=i[18173],i[k>>2]=o,i[k+i[o-12>>2]>>2]=i[18174],i[k+4>>2]=0,o=k+i[i[k>>2]-12>>2]|0,t=k+8|0,J0(o,t),u[o+80|0]=0,i[o+72>>2]=0,i[k+108>>2]=72680,i[k>>2]=72660,p9(jt(t),r,12)||(r=k+i[i[k>>2]-12>>2]|0,H1(r,i[r+16>>2]|4)),o=s+8|0,i[n+172>>2]=k;i:{e:{r:{f:{if(i[(k+i[i[k>>2]-12>>2]|0)+16>>2]){i[n+116>>2]=0,i[n+88>>2]=72196,i[n+32>>2]=72176,r=i[18053],i[n+24>>2]=r,k=i[r-12>>2],r=n+24|0,i[k+r>>2]=i[18054],i[n+28>>2]=0,k=r+i[i[n+24>>2]-12>>2]|0,t=n+36|0,J0(k,t),u[k+80|0]=0,i[k+72>>2]=0,k=i[18055],i[n+32>>2]=k,w=i[k-12>>2],k=n+32|0,i[w+k>>2]=i[18056],w=i[18052],i[n+24>>2]=w,i[r+i[w-12>>2]>>2]=i[18057],i[n+88>>2]=72196,i[n+24>>2]=72156,i[n+32>>2]=72176,t=R0(t),i[t>>2]=71232,i[n+76>>2]=0,i[n+80>>2]=0,i[n+68>>2]=0,i[n+72>>2]=0,i[n+84>>2]=24,k=Y(k,31893,20),r=i[31324],r=C[((r>>>0<=153?r:0)<<1)+69488>>1]+67560|0,Y(S0(Y(Y(k,r,h2(r)),27147,2),i[31324]),42669,2),r=i[n+84>>2];A:{if(r&16){r=i[n+80>>2],k=i[n+60>>2],r>>>0<k>>>0&&(i[n+80>>2]=k,r=k),k=n+56|0;break A}if(!(r&8)){r=0,u[n+23|0]=0,k=n+12|0;break e}r=i[n+52>>2],k=n+44|0}if(w=i[k>>2],r=r-w|0,r>>>0>=2147483640)break f;if(r>>>0>=11){B=r|7,k=p(B+1|0),i[n+20>>2]=B-2147483647,i[n+12>>2]=k,i[n+16>>2]=r;break r}if(u[n+23|0]=r,k=n+12|0,r)break r;r=0;break e}r=p(56),i[r+4>>2]=0,i[r+8>>2]=0,i[r>>2]=94984,k=v-16|0,v=k,B=r+16|0,i[B>>2]=86312,i[r+20>>2]=0,i[r+24>>2]=0,i[r+36>>2]=0,i[r+28>>2]=0,i[r+32>>2]=0,i[r+16>>2]=86136,t=i[n+172>>2],i[n+172>>2]=0,i[r+40>>2]=t,YA(t,0,0,2),au(k,i[r+40>>2]),t=i[k+12>>2],i[r+48>>2]=i[k+8>>2],i[r+52>>2]=t,YA(i[r+40>>2],0,0,0),v=k+16|0,i[n+28>>2]=r,i[n+24>>2]=B,i[r+4>>2]=i[r+4>>2]+1,wf(o,w,n+24|0),k=i[n+28>>2];A:{if(!k||(o=i[k+4>>2],i[k+4>>2]=o-1,o))break A;W[i[i[k>>2]+8>>2]](k),y(k)}if(k=i[r+4>>2],i[r+4>>2]=k-1,k)break i;W[i[i[r>>2]+8>>2]](r),y(r);break i}Q0(),H()}if(!r)break e;x(k,w,r)}u[r+k|0]=0,q(o,1,0,n+12|0),u[n+23|0]<0&&Z(i[n+12>>2]),r=i[18051],i[n+24>>2]=r,i[i[r-12>>2]+(n+24|0)>>2]=i[18059],i[n+32>>2]=i[18060],i[t>>2]=71232,u[n+79|0]<0&&Z(i[n+68>>2]),E0(t),y0(n+88|0)}r=i[n+172>>2],i[n+172>>2]=0,r&&W[i[i[r>>2]+4>>2]](r),v=n+176|0;i:{if(i[s+8>>2]){r=i[s+12>>2],i[h>>2]=i[s+8>>2],i[h+4>>2]=r,r=i[s+20>>2],i[h+8>>2]=i[s+16>>2],i[h+12>>2]=r,i[h+16>>2]=i[s+24>>2];break i}if(sf(h,_),u[s+27|0]>=0)break i;Z(i[s+16>>2])}v=s+32|0,b0(A,h,i[e>>2]),u[f+31|0]<0&&Z(i[f+20>>2]),v=f+32|0}function Tv(A,e,r,f,k,n,t){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,t=t|0;var o=0,s=0,w=0,h=0,_=0;t=v-48|0,v=t;i:{if(f){f=v-96|0,v=f,O9(f+24|0,e,k,n);e:{r:switch(l[f+72|0]){default:_2(),H();case 1:e=i[f+28>>2],i[A>>2]=i[f+24>>2],i[A+4>>2]=e,e=A+8|0;f:{if(u[f+43|0]>=0){r=i[f+36>>2],i[e>>2]=i[f+32>>2],i[e+4>>2]=r,i[e+8>>2]=i[f+40>>2];break f}T(e,i[f+32>>2],i[f+36>>2])}u[A+20|0]=1;break e;case 0:break r}k=i[e+552>>2],i[f+16>>2]=i[f- -64>>2],n=i[f+60>>2],i[f+8>>2]=i[f+56>>2],i[f+12>>2]=n,n=i[f+52>>2],i[f>>2]=i[f+48>>2],i[f+4>>2]=n,o=i[f+28>>2],i[f+28>>2]=0,n=i[f+24>>2],i[f+24>>2]=0,s=i[f+36>>2],w=i[f+40>>2],i[f+36>>2]=0,i[f+40>>2]=0,h=i[f+44>>2],i[f+44>>2]=0,_=l[f+32|0],i[k+8>>2]=n,n=i[k+12>>2],i[k+12>>2]=o;r:{if(!n||(o=i[n+4>>2],i[n+4>>2]=o-1,o))break r;W[i[i[n>>2]+8>>2]](n),y(n)}u[k+16|0]=_,n=i[k+20>>2],n&&(i[k+24>>2]=n,Z(n)),i[k+28>>2]=h,i[k+24>>2]=w,i[k+20>>2]=s,n=i[f+4>>2],i[k+32>>2]=i[f>>2],i[k+36>>2]=n,n=i[f+12>>2],i[k+40>>2]=i[f+8>>2],i[k+44>>2]=n,i[k+48>>2]=i[f+16>>2],k=A,A=i[e+552>>2],W[i[i[A>>2]+28>>2]](k,A,r,i[e+100>>2]- -64|0)}A=l[f+72|0],(A|0)!=255&&(e=i[25471],i[f+88>>2]=i[25470],i[f+92>>2]=e,W[i[(f+88|0)+(A<<2)>>2]](f+87|0,f+24|0)),v=f+96|0;break i}e=p(48),i[t+12>>2]=e,i[t+16>>2]=41,i[t+20>>2]=-2147483600,u[e+40|0]=l[13175],r=l[13171]|l[13172]<<8|(l[13173]<<16|l[13174]<<24),f=l[13167]|l[13168]<<8|(l[13169]<<16|l[13170]<<24),u[e+32|0]=f,u[e+33|0]=f>>>8,u[e+34|0]=f>>>16,u[e+35|0]=f>>>24,u[e+36|0]=r,u[e+37|0]=r>>>8,u[e+38|0]=r>>>16,u[e+39|0]=r>>>24,r=l[13163]|l[13164]<<8|(l[13165]<<16|l[13166]<<24),f=l[13159]|l[13160]<<8|(l[13161]<<16|l[13162]<<24),u[e+24|0]=f,u[e+25|0]=f>>>8,u[e+26|0]=f>>>16,u[e+27|0]=f>>>24,u[e+28|0]=r,u[e+29|0]=r>>>8,u[e+30|0]=r>>>16,u[e+31|0]=r>>>24,r=l[13155]|l[13156]<<8|(l[13157]<<16|l[13158]<<24),f=l[13151]|l[13152]<<8|(l[13153]<<16|l[13154]<<24),u[e+16|0]=f,u[e+17|0]=f>>>8,u[e+18|0]=f>>>16,u[e+19|0]=f>>>24,u[e+20|0]=r,u[e+21|0]=r>>>8,u[e+22|0]=r>>>16,u[e+23|0]=r>>>24,r=l[13147]|l[13148]<<8|(l[13149]<<16|l[13150]<<24),f=l[13143]|l[13144]<<8|(l[13145]<<16|l[13146]<<24),u[e+8|0]=f,u[e+9|0]=f>>>8,u[e+10|0]=f>>>16,u[e+11|0]=f>>>24,u[e+12|0]=r,u[e+13|0]=r>>>8,u[e+14|0]=r>>>16,u[e+15|0]=r>>>24,r=l[13139]|l[13140]<<8|(l[13141]<<16|l[13142]<<24),f=l[13135]|l[13136]<<8|(l[13137]<<16|l[13138]<<24),u[e|0]=f,u[e+1|0]=f>>>8,u[e+2|0]=f>>>16,u[e+3|0]=f>>>24,u[e+4|0]=r,u[e+5|0]=r>>>8,u[e+6|0]=r>>>16,u[e+7|0]=r>>>24,u[e+41|0]=0,e=q(t+24|0,4,0,t+12|0),r=i[e+4>>2],i[A>>2]=i[e>>2],i[A+4>>2]=r,r=A+8|0;e:{if(u[e+19|0]>=0){f=i[e+12>>2],i[r>>2]=i[e+8>>2],i[r+4>>2]=f,i[r+8>>2]=i[e+16>>2],u[A+20|0]=1;break e}if(T(r,i[e+8>>2],i[e+12>>2]),r=u[e+19|0],u[A+20|0]=1,(r|0)>=0)break e;Z(i[e+8>>2])}if(u[t+23|0]>=0)break i;Z(i[t+12>>2])}v=t+48|0}function V9(A,e,r,f,k){var n=0,t=0,o=0,s=0;n=v-160|0,v=n;i:{e:{r:{f:{A:{k:{n:{if(t=i[f>>2],f=i[t+104>>2],t=i[t+108>>2],(f|0)!=(t|0))for(;;){if(i[f>>2]==(r|0))break n;if(f=f+16|0,(t|0)==(f|0))break}i[n+104>>2]=0,i[n+76>>2]=72196,i[n+20>>2]=72176,e=i[18053],i[n+12>>2]=e,f=i[e-12>>2],e=n+12|0,i[f+e>>2]=i[18054],i[n+16>>2]=0,f=e+i[i[n+12>>2]-12>>2]|0,k=n+24|0,J0(f,k),u[f+80|0]=0,i[f+72>>2]=0,f=i[18055],i[n+20>>2]=f,t=i[f-12>>2],f=n+20|0,i[t+f>>2]=i[18056],t=i[18052],i[n+12>>2]=t,i[e+i[t-12>>2]>>2]=i[18057],i[n+76>>2]=72196,i[n+12>>2]=72156,i[n+20>>2]=72176,k=R0(k),i[k>>2]=71232,e=n- -64|0,i[e>>2]=0,i[e+4>>2]=0,i[n+56>>2]=0,i[n+60>>2]=0,i[n+72>>2]=24,Y(V0(Y(f,21008,9),r),2459,46),e=i[n+72>>2];t:{if(e&16){f=i[n+68>>2],e=i[n+48>>2],f>>>0<e>>>0&&(i[n+68>>2]=e,f=e),e=n+44|0;break t}if(!(e&8)){f=0,u[n+11|0]=0,r=n;break e}f=i[n+40>>2],e=n+32|0}if(e=i[e>>2],f=f-e|0,f>>>0>=2147483640)break k;if(f>>>0>=11){t=f|7,r=p(t+1|0),i[n+8>>2]=t-2147483647,i[n>>2]=r,i[n+4>>2]=f;break r}if(u[n+11|0]=f,r=n,f)break r;f=0;break e}if(t=i[f+4>>2],o=i[f+8>>2],(t|0)!=(o|0))for(;;){if(f=C[t+2>>1],s=i[e+36>>2],f>>>0>i[e+40>>2]-s>>3>>>0){i[n+104>>2]=0,i[n+76>>2]=72196,i[n+20>>2]=72176,e=i[18053],i[n+12>>2]=e,f=i[e-12>>2],e=n+12|0,i[f+e>>2]=i[18054],i[n+16>>2]=0,f=e+i[i[n+12>>2]-12>>2]|0,k=n+24|0,J0(f,k),u[f+80|0]=0,i[f+72>>2]=0,f=i[18055],i[n+20>>2]=f,o=i[f-12>>2],f=n+20|0,i[o+f>>2]=i[18056],o=i[18052],i[n+12>>2]=o,i[e+i[o-12>>2]>>2]=i[18057],i[n+76>>2]=72196,i[n+12>>2]=72156,i[n+20>>2]=72176,k=R0(k),i[k>>2]=71232,e=n- -64|0,i[e>>2]=0,i[e+4>>2]=0,i[n+56>>2]=0,i[n+60>>2]=0,i[n+72>>2]=24,Y(V0(Y(Y(V0(Y(f,20880,28),C[t+2>>1]),28302,11),21028,4),r),2506,23),e=i[n+72>>2];n:{if(e&16){f=i[n+68>>2],e=i[n+48>>2],f>>>0<e>>>0&&(i[n+68>>2]=e,f=e),e=n+44|0;break n}if(!(e&8)){f=0,u[n+11|0]=0,r=n;break f}f=i[n+40>>2],e=n+32|0}if(e=i[e>>2],f=f-e|0,f>>>0>=2147483640)break k;if(f>>>0>=11){t=f|7,r=p(t+1|0),i[n+8>>2]=t-2147483647,i[n>>2]=r,i[n+4>>2]=f;break A}if(u[n+11|0]=f,r=n,f)break A;f=0;break f}if(f&&r2(k,((f<<3)+s|0)-8|0),t=t+4|0,(o|0)==(t|0))break}if(e=i[26917],i[A>>2]=i[26916],i[A+4>>2]=e,A=A+8|0,u[107683]>=0){e=i[26919],i[A>>2]=i[26918],i[A+4>>2]=e,i[A+8>>2]=i[26920];break i}T(A,i[26918],i[26919]);break i}Q0(),H()}if(!f)break f;x(r,e,f)}u[r+f|0]=0,q(A,2,115,n),u[n+11|0]<0&&Z(i[n>>2]),A=i[18051],i[n+12>>2]=A,i[i[A-12>>2]+(n+12|0)>>2]=i[18059],i[n+20>>2]=i[18060],i[k>>2]=71232,u[n+67|0]<0&&Z(i[n+56>>2]),E0(k),y0(n+76|0);break i}if(!f)break e;x(r,e,f)}u[r+f|0]=0,q(A,2,116,n),u[n+11|0]<0&&Z(i[n>>2]),A=i[18051],i[n+12>>2]=A,i[i[A-12>>2]+(n+12|0)>>2]=i[18059],i[n+20>>2]=i[18060],i[k>>2]=71232,u[n+67|0]<0&&Z(i[n+56>>2]),E0(k),y0(n+76|0)}v=n+160|0}function Sv(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0;var k=0,n=0,t=0,o=0,s=0,w=0,h=0,_=0,B=0,m=0,X=0,Q=0,V=0,F=0,I=0,E=0;Q=v-80|0,v=Q;i:{if(!(f&&e)){e=i[23570],i[A>>2]=i[23569],i[A+4>>2]=e,i[A+8>>2]=i[23571];break i}if(h=Q+8|0,w=i[e>>2],W[i[i[w>>2]+108>>2]](h,w),x(f,h,72),r){t=f,f=0,n=v-48|0,v=n,bi(n+16|0,i[e>>2]);e:{r:switch(l[n+36|0]){default:_2(),H();case 1:if(r=i[n+20>>2],i[h>>2]=i[n+16>>2],i[h+4>>2]=r,r=h+8|0,u[n+35|0]>=0){f=i[n+28>>2],i[r>>2]=i[n+24>>2],i[r+4>>2]=f,i[r+8>>2]=i[n+32>>2];break e}T(r,i[n+24>>2],i[n+28>>2]);break e;case 0:break r}w=i[t+12>>2],r=0;r:{if(!w||(s=i[t+16>>2],r=0,!s))break r;f=u0[t+20>>2]%(w>>>0)|0,r=u0[t+24>>2]%(s>>>0)|0}if(w=0,_=i[n+16>>2],V=i[n+20>>2],(_|0)!=(V|0))for(;;){s=r,B=f,k=m,o=i[_>>2];r:{if(!o)break r;if(X=W0(o,86580,87892),X){o=i[_+4>>2],o&&(i[o+4>>2]=i[o+4>>2]+1);f:{A:{k:{r=i[X+100>>2],f=(r|0)==270;n:{if(!f){if((r|0)==180)break n;if((r|0)!=90)break A}if(I=t,E=R5(i[t+12>>2],i[t+16>>2]),i[I+12>>2]=E,i[t+16>>2]=l0,I=t,E=R5(i[t+20>>2],i[t+24>>2]),i[I+20>>2]=E,i[t+24>>2]=l0,I=t,E=R5(i[t+4>>2],i[t+8>>2]),i[I+4>>2]=E,i[t+8>>2]=l0,(r|0)==90){r=w,f=s,m=B,w=k;break f}if(f)break k;if((r|0)!=180)break A}r=k,f=w,m=s,w=B;break f}r=B,f=k,m=w,w=s;break f}r=s,f=B,m=k}f:{if(!o||(s=i[o+4>>2],i[o+4>>2]=s-1,s))break f;W[i[i[o>>2]+8>>2]](o),y(o)}if(o=i[_>>2],!o)break r}o=W0(o,86580,87972);f:{if(!o){s=f,B=r;break f}k=i[_+4>>2],k&&(i[k+4>>2]=i[k+4>>2]+1),B=r,s=f;A:{k:switch(i[o+100>>2]){case 1:s=w,w=f;break A;case 0:break k;default:break A}B=m,m=r}if(!k||(r=i[k+4>>2],i[k+4>>2]=r-1,r))break f;W[i[i[k>>2]+8>>2]](k),y(k)}f:{if(r=i[_>>2],!r||(r=W0(r,86580,88052),!r))break f;k=i[_+4>>2],k&&(i[k+4>>2]=i[k+4>>2]+1),f=$i(r,i[t+20>>2]),o=bf(r,i[t+20>>2]),X=qi(r,i[t+24>>2]),r=cf(r,i[t+24>>2]);A:{if(F=(f|0)>0?f:0,f=i[t+20>>2],f=f>>>0>o>>>0?o:f-1|0,(F|0)<=(f|0)&&(o=(X|0)>0?X:0,X=i[t+24>>2],r=r>>>0<X>>>0?r:X-1|0,(o|0)<=(r|0)))break A;if(u[n|0]=0,u[n+11|0]=0,q(h,2,120,n),u[n+11|0]<0&&Z(i[n>>2]),!k||(r=i[k+4>>2],i[k+4>>2]=r-1,r))break e;W[i[i[k>>2]+8>>2]](k),y(k);break e}if(r=r+B|0,m=o+m|0,f=f+s|0,w=w+F|0,!k||(s=i[k+4>>2],i[k+4>>2]=s-1,s))break r;W[i[i[k>>2]+8>>2]](k),y(k);break r}f=s,r=B}if(_=_+8|0,(V|0)==(_|0))break}if(i[t+28>>2]=m,i[t+32>>2]=w,r=i[26917],i[h>>2]=i[26916],i[h+4>>2]=r,r=h+8|0,u[107683]>=0){f=i[26919],i[r>>2]=i[26918],i[r+4>>2]=f,i[r+8>>2]=i[26920];break e}T(r,i[26918],i[26919])}if(r=l[n+36|0],(r|0)!=255&&(f=i[25179],i[n>>2]=i[25178],i[n+4>>2]=f,W[i[n+(r<<2)>>2]](n+47|0,n+16|0)),v=n+48|0,r=i[Q+8>>2],r&&b0(A,h,i[e+8>>2]),u[Q+27|0]<0&&Z(i[Q+16>>2]),r)break i}e=i[24164],i[A>>2]=i[24163],i[A+4>>2]=e,i[A+8>>2]=i[24165]}v=Q+80|0}function F9(A,e,r,f,k){var n=0,t=0,o=0,s=0,w=0,h=0,_=0,B=0,m=0,X=0,Q=0,V=0,F=0,I=0;o=v-48|0,v=o,t=i[e+124>>2],V=e+128|0;i:{if((t|0)!=(V|0))for(F=A+8|0,I=e+136|0;;){OA(r,f,i[t+16>>2],i[e+120>>2],o+44|0,o+40|0),h=i[t+16>>2];e:{if((h|0)==10){if(_=31,s=i[e+120>>2]-10|0,s>>>0>=6)break e;s=s<<3,n=s&31,(s&63)>>>0>=32?_=2054>>>n|0:_=((1<<n)-1&2054)<<32-n|134611971>>>n;break e}if(_=0,n=V,s=i[n>>2],!s)break e;for(;w=(h|0)>i[s+16>>2],n=w?n:s,s=i[(w?4:0)+s>>2],!!s;);if((n|0)==(V|0)|(h|0)<i[n+16>>2])break e;_=(l[n+24|0]+7&248)>>>3|0}s=i[t+32>>2],Q=i[t+28>>2],m=_&255;e:{r:{f:{A:{if(h=i[o+44>>2],w=i[o+40>>2],!(h>>>0<=u0[t+36>>2]&w>>>0<=u0[t+40>>2])){g[o+4>>1]=256,i[o>>2]=1,i[o+32>>2]=0,i[o+36>>2]=0,i[o+24>>2]=0,i[o+28>>2]=0,i[o+16>>2]=0,i[o+20>>2]=0,i[o+8>>2]=0,i[o+12>>2]=0,X=i[t+20>>2],B=l[t+24|0],n=1;k:{n:switch(i[e+120>>2]){case 10:case 12:case 14:n=3;break k;case 11:case 13:case 15:n=4;break k;case 0:case 1:case 2:case 3:case 99:break k;default:break n}n=0}if(kr(A,o,h,w,X,B,n,k,I),i[A>>2])break i;if(u[A+19|0]<0&&Z(i[A+8>>2]),B=i[o+24>>2],!B)break A;if(i[t+32>>2])for(n=0,h=i[o+36>>2];w=G(m,i[t+28>>2]),w&&x(B+G(n,h)|0,i[t+44>>2]+G(i[t+56>>2],n)|0,w),n=n+1|0,n>>>0<u0[t+32>>2];);n=i[t+48>>2],n&&Z(n),n=i[o+4>>2],i[t+20>>2]=i[o>>2],i[t+24>>2]=n,n=i[o+36>>2],i[t+52>>2]=i[o+32>>2],i[t+56>>2]=n,n=i[o+28>>2],i[t+44>>2]=i[o+24>>2],i[t+48>>2]=n,n=i[o+20>>2],i[t+36>>2]=i[o+16>>2],i[t+40>>2]=n,n=i[o+12>>2],i[t+28>>2]=i[o+8>>2],i[t+32>>2]=n}X=0,(m|0)==1&&(X=i[t+16>>2]-1>>>0<2?-128:0);k:{if(!s|(Q|0)==i[o+44>>2])break k;if(B=G(m,Q),n=0,(s|0)!=1)for(h=s&-2,_=0;w=G(m,i[o+44>>2]-Q|0),w&&o0(B+(i[t+44>>2]+G(i[t+56>>2],n)|0)|0,X,w),w=G(m,i[o+44>>2]-Q|0),w&&o0(B+(i[t+44>>2]+G(i[t+56>>2],n|1)|0)|0,X,w),n=n+2|0,_=_+2|0,(h|0)!=(_|0););if(!(s&1)||(w=G(m,i[o+44>>2]-Q|0),!w))break k;o0(B+(i[t+44>>2]+G(i[t+56>>2],n)|0)|0,X,w)}if(n=i[o+40>>2],s>>>0<n>>>0)break f;break e}if(e=i[26922],i[A>>2]=i[26921],i[A+4>>2]=e,u[107703]<0)break r;A=i[26924],i[F>>2]=i[26923],i[F+4>>2]=A,i[F+8>>2]=i[26925];break i}for(;n=G(m,i[o+44>>2]),n&&o0(i[t+44>>2]+G(i[t+56>>2],s)|0,X,n),n=i[o+40>>2],s=s+1|0,n>>>0>s>>>0;);break e}T(F,i[26923],i[26924]);break i}s=i[o+44>>2],i[t+32>>2]=n,i[t+28>>2]=s,n=i[t+4>>2];e:{if(n){for(;;)if(s=n,n=i[n>>2],!n)break e}for(;s=i[t+8>>2],n=i[s>>2]!=(t|0),t=s,!!n;);}if(t=s,(V|0)==(t|0))break}if(i[e+112>>2]=f,i[e+108>>2]=r,e=i[26917],i[A>>2]=i[26916],i[A+4>>2]=e,e=A+8|0,u[107683]>=0){A=i[26919],i[e>>2]=i[26918],i[e+4>>2]=A,i[e+8>>2]=i[26920];break i}T(e,i[26918],i[26919])}v=o+48|0}function jv(A,e,r,f,k,n){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0;var t=0,o=0,s=0,w=0,h=0;n=v-16|0,v=n,w=i[r+4>>2],t=i[k>>2],s=i[r>>2],r=t+s|0;i:{if(w-r>>>0<(f|0)/8<<2>>>0){if(e=p(56),i[n+4>>2]=e,i[n+8>>2]=54,i[n+12>>2]=-2147483592,r=l[9010]|l[9011]<<8|(l[9012]<<16|l[9013]<<24),f=l[9006]|l[9007]<<8|(l[9008]<<16|l[9009]<<24),u[e|0]=f,u[e+1|0]=f>>>8,u[e+2|0]=f>>>16,u[e+3|0]=f>>>24,u[e+4|0]=r,u[e+5|0]=r>>>8,u[e+6|0]=r>>>16,u[e+7|0]=r>>>24,u[e+54|0]=0,r=l[9056]|l[9057]<<8|(l[9058]<<16|l[9059]<<24),f=l[9052]|l[9053]<<8|(l[9054]<<16|l[9055]<<24),u[e+46|0]=f,u[e+47|0]=f>>>8,u[e+48|0]=f>>>16,u[e+49|0]=f>>>24,u[e+50|0]=r,u[e+51|0]=r>>>8,u[e+52|0]=r>>>16,u[e+53|0]=r>>>24,r=l[9050]|l[9051]<<8|(l[9052]<<16|l[9053]<<24),f=l[9046]|l[9047]<<8|(l[9048]<<16|l[9049]<<24),u[e+40|0]=f,u[e+41|0]=f>>>8,u[e+42|0]=f>>>16,u[e+43|0]=f>>>24,u[e+44|0]=r,u[e+45|0]=r>>>8,u[e+46|0]=r>>>16,u[e+47|0]=r>>>24,r=l[9042]|l[9043]<<8|(l[9044]<<16|l[9045]<<24),f=l[9038]|l[9039]<<8|(l[9040]<<16|l[9041]<<24),u[e+32|0]=f,u[e+33|0]=f>>>8,u[e+34|0]=f>>>16,u[e+35|0]=f>>>24,u[e+36|0]=r,u[e+37|0]=r>>>8,u[e+38|0]=r>>>16,u[e+39|0]=r>>>24,r=l[9034]|l[9035]<<8|(l[9036]<<16|l[9037]<<24),f=l[9030]|l[9031]<<8|(l[9032]<<16|l[9033]<<24),u[e+24|0]=f,u[e+25|0]=f>>>8,u[e+26|0]=f>>>16,u[e+27|0]=f>>>24,u[e+28|0]=r,u[e+29|0]=r>>>8,u[e+30|0]=r>>>16,u[e+31|0]=r>>>24,r=l[9026]|l[9027]<<8|(l[9028]<<16|l[9029]<<24),f=l[9022]|l[9023]<<8|(l[9024]<<16|l[9025]<<24),u[e+16|0]=f,u[e+17|0]=f>>>8,u[e+18|0]=f>>>16,u[e+19|0]=f>>>24,u[e+20|0]=r,u[e+21|0]=r>>>8,u[e+22|0]=r>>>16,u[e+23|0]=r>>>24,r=l[9018]|l[9019]<<8|(l[9020]<<16|l[9021]<<24),f=l[9014]|l[9015]<<8|(l[9016]<<16|l[9017]<<24),u[e+8|0]=f,u[e+9|0]=f>>>8,u[e+10|0]=f>>>16,u[e+11|0]=f>>>24,u[e+12|0]=r,u[e+13|0]=r>>>8,u[e+14|0]=r>>>16,u[e+15|0]=r>>>24,q(A,2,136,n+4|0),u[n+15|0]>=0)break i;Z(i[n+4>>2]);break i}o=l[r|0],w=l[r+1|0];e:{if((f|0)==32){h=l[r+3|0],r=l[r+2|0],i[k>>2]=t+4,i[e+4>>2]=w<<16|o<<24|r<<8|h,t=i[k>>2],r=t+s|0,r=l[r|0]|l[r+1|0]<<8|(l[r+2|0]<<16|l[r+3|0]<<24),i[k>>2]=t+4,i[e+8>>2]=r<<24|(r&65280)<<8|(r>>>8&65280|r>>>24),r=i[k>>2],t=s+r|0,o=l[t+1|0]<<16|l[t|0]<<24|l[t+2|0]<<8,t=t+3|0,w=4;break e}i[k>>2]=t+2,i[e+4>>2]=(w<<16|o<<24)>>16,r=i[k>>2],t=r+s|0,o=l[t+1|0],t=l[t|0],i[k>>2]=r+2,i[e+8>>2]=(o<<16|t<<24)>>16,r=i[k>>2],o=s+r|0,t=o+1|0,o=l[o|0]<<8,w=2}t=l[t|0],i[k>>2]=r+w,i[e+12>>2]=t|o,o=i[k>>2],s=o+s|0,t=l[s|0],r=l[s+1|0];e:{if((f|0)==32){f=r<<16|t<<24|l[s+2|0]<<8,r=l[s+3|0],w=4;break e}f=t<<8,w=2}if(i[k>>2]=w+o,i[e+16>>2]=r&255|f,e=i[26917],i[A>>2]=i[26916],i[A+4>>2]=e,A=A+8|0,u[107683]>=0){e=i[26919],i[A>>2]=i[26918],i[A+4>>2]=e,i[A+8>>2]=i[26920];break i}T(A,i[26918],i[26919])}v=n+16|0}function or(A){var e=0,r=0,f=0,k=0,n=0,t=0,o=0,s=0,w=0,h=0,_=0;t=v-32|0,v=t;i:{e=i[A+16>>2];e:{if(e>>>0>=1024){i[A+16>>2]=e-1024,e=i[A+4>>2],s=i[e>>2],e=e+4|0,i[A+4>>2]=e,f=i[A+8>>2];r:{if((f|0)!=i[A+12>>2])break r;if(n=i[A>>2],n>>>0<e>>>0){r=f-e|0,n=((e-n>>2)+1|0)/-2<<2,k=n+e|0,(e|0)!=(f|0)&&(r&&x(k,e,r),e=i[A+4>>2]),i[A+4>>2]=e+n,f=r+k|0;break r}if(r=(f|0)==(n|0)?1:f-n>>1,r>>>0>=1073741824)break i;if(k=r<<2,o=p(k),w=k+o|0,k=o+(r&-4)|0,r=k,(e|0)!=(f|0))for(r=(f-e|0)+r|0,f=k;i[f>>2]=i[e>>2],e=e+4|0,f=f+4|0,(r|0)!=(f|0););i[A+12>>2]=w,i[A+8>>2]=r,i[A+4>>2]=k,i[A>>2]=o,Z(n),f=i[A+8>>2]}i[f>>2]=s,i[A+8>>2]=f+4;break e}if(e=i[A+8>>2],f=i[A+4>>2],n=e-f|0,r=i[A+12>>2],k=i[A>>2],o=r-k|0,n>>>0<o>>>0){if((e|0)!=(r|0)){h=t,_=p(4096),i[h+12>>2]=_;r:{f:{r=i[A+8>>2];A:{if((r|0)!=i[A+12>>2]){f=r;break A}if(e=i[A+4>>2],n=i[A>>2],e>>>0>n>>>0){f=r-e|0,n=((e-n>>2)+1|0)/-2<<2,k=n+e|0,(e|0)!=(r|0)&&(f&&x(k,e,f),e=i[A+4>>2]),i[A+4>>2]=e+n,f=f+k|0;break A}if(f=(r|0)==(n|0)?1:r-n>>1,f>>>0>=1073741824)break f;if(k=f<<2,o=p(k),s=k+o|0,k=o+(f&-4)|0,f=k,(e|0)!=(r|0))for(f=(r-e|0)+f|0,r=k;i[r>>2]=i[e>>2],e=e+4|0,r=r+4|0,(r|0)!=(f|0););if(i[A+12>>2]=s,i[A+8>>2]=f,i[A+4>>2]=k,i[A>>2]=o,!n)break A;Z(n),f=i[A+8>>2]}i[f>>2]=i[t+12>>2],i[A+8>>2]=f+4;break r}z0(),H()}break e}h=t,_=p(4096),i[h+12>>2]=_,Qt(A,t+12|0),e=i[A+4>>2],s=i[e>>2],e=e+4|0,i[A+4>>2]=e,f=i[A+8>>2];r:{if((f|0)!=i[A+12>>2])break r;if(n=i[A>>2],n>>>0<e>>>0){r=f-e|0,n=((e-n>>2)+1|0)/-2<<2,k=n+e|0,(e|0)!=(f|0)&&(r&&x(k,e,r),e=i[A+4>>2]),i[A+4>>2]=e+n,f=r+k|0;break r}if(r=(f|0)==(n|0)?1:f-n>>1,r>>>0>=1073741824)break i;if(k=r<<2,o=p(k),w=k+o|0,k=o+(r&-4)|0,r=k,(e|0)!=(f|0))for(r=(f-e|0)+r|0,f=k;i[f>>2]=i[e>>2],e=e+4|0,f=f+4|0,(r|0)!=(f|0););i[A+12>>2]=w,i[A+8>>2]=r,i[A+4>>2]=k,i[A>>2]=o,Z(n),f=i[A+8>>2]}i[f>>2]=s,i[A+8>>2]=f+4;break e}if(i[t+28>>2]=A+12,r=(r|0)==(k|0)?1:o>>1,r>>>0>=1073741824)break i;s=r<<2,k=p(s),i[t+12>>2]=k,o=k+s|0,i[t+24>>2]=o,r=k+n|0,i[t+16>>2]=r,w=p(4096);r:{if((n|0)!=(s|0))break r;if((e|0)!=(f|0)){r=(((n>>2)+1|0)/-2<<2)+r|0,i[t+16>>2]=r;break r}r=p(4),i[t+16>>2]=r,i[t+12>>2]=r,o=r+4|0,i[t+24>>2]=o,Z(k),f=i[A+4>>2],e=i[A+8>>2],k=r}if(i[r>>2]=w,s=r+4|0,i[t+20>>2]=s,(e|0)!=(f|0)){for(;e=e-4|0,Qt(t+12|0,e),f=i[A+4>>2],(e|0)!=(f|0););o=i[t+24>>2],s=i[t+20>>2],k=i[t+12>>2],r=i[t+16>>2],e=i[A+8>>2]}if(n=i[A>>2],i[A>>2]=k,i[t+12>>2]=n,i[A+4>>2]=r,i[t+16>>2]=f,i[A+8>>2]=s,i[t+20>>2]=e,r=i[A+12>>2],i[A+12>>2]=o,i[t+24>>2]=r,(e|0)!=(f|0)&&(i[t+20>>2]=((f-e|0)+3&-4)+e),!n)break e;Z(n)}v=t+32|0;return}z0(),H()}function I9(A,e,r,f,k,n){var t=0,o=0,s=0,w=0,h=0,_=0,B=0,m=0,X=0,Q=0,V=0,F=0;_=v-16|0,v=_,h=i[r>>2],f=(f|0)==99?i[h+116>>2]:f,t=i[h+116>>2],F=t,Q=i[h+120>>2];i:{e:switch(t|0){case 2:if(B=255,s=i[h+128>>2],!s)break i;for(o=h+128|0,t=o;w=i[s+16>>2],t=(w|0)<0?t:s,s=i[(w>>>29&4)+s>>2],!!s;);if((t|0)==(o|0)|i[t+16>>2]>0)break i;B=l[t+24|0];break i;case 0:B=255,X=255,s=i[h+128>>2],o=255;r:{if(!s)break r;for(w=h+128|0,o=w,t=s;m=i[t+16>>2],o=(m|0)<0?o:t,t=i[(m>>>29&4)+t>>2],!!t;);for(X=(o|0)==(w|0)|i[o+16>>2]>0?X:l[o+24|0],o=w,t=s;m=i[t+16>>2]<=0,o=m?o:t,t=i[(m?4:0)+t>>2],!!t;);for(B=(o|0)==(w|0)|i[o+16>>2]>1?B:l[o+24|0],t=w;o=i[s+16>>2]<2,t=o?t:s,s=i[(o?4:0)+s>>2],!!s;);if(o=255,(t|0)==(w|0)|i[t+16>>2]>2)break r;o=l[t+24|0]}w=B&255,t=o&255,t=t>>>0<w>>>0?w:t,B=t>>>0<X>>>0?X:t;break i;case 1:break e;default:break i}if(w=h+128|0,s=i[h+128>>2],i[h+120>>2]==3){B=255,X=255,o=255;e:{if(!s)break e;for(o=w,t=s;m=i[t+16>>2]<3,o=m?o:t,t=i[(m?4:0)+t>>2],!!t;);for(X=(o|0)==(w|0)|i[o+16>>2]>3?X:l[o+24|0],o=w,t=s;m=i[t+16>>2]<4,o=m?o:t,t=i[(m?4:0)+t>>2],!!t;);for(B=(o|0)==(w|0)|i[o+16>>2]>4?B:l[o+24|0],t=w;o=i[s+16>>2]<5,t=o?t:s,s=i[(o?4:0)+s>>2],!!s;);if(o=255,(t|0)==(w|0)|i[t+16>>2]>5)break e;o=l[t+24|0]}w=B&255,t=o&255,t=t>>>0<w>>>0?w:t,B=t>>>0<X>>>0?X:t;break i}if(B=255,!s)break i;for(t=w;o=i[s+16>>2]<10,t=o?t:s,s=i[(o?4:0)+s>>2],!!s;);if((t|0)==(w|0)|i[t+16>>2]>10)break i;B=l[t+24|0]}m=l[n+20|0],s=_+8|0;i:{e:{if(!(C[h+6>>1]!=2|C[h+8>>1]!=2|C[h+10>>1]!=2)&&l[h+12|0])break e;w=C[h+10>>1]|C[h+12>>1]<<16,t=C[h+6>>1]|C[h+8>>1]<<16,g[s>>1]=t,g[s+2>>1]=t>>>16,g[s+4>>1]=w,g[s+6>>1]=w>>>16;break i}u[s+6|0]=1,g[s+4>>1]=2,g[s>>1]=2,g[s+2>>1]=2,u[s+6|0]=1,g[s+4>>1]=6,g[s>>1]=1,g[s+2>>1]=13}t=i[_+8>>2],w=i[_+12>>2],o=i[n+56>>2],o||(o=B3(),V=o);i:{if(!(i[o+4>>2]!=(t&65535)|i[o+8>>2]!=(t>>>16|0)|i[o+12>>2]!=(w&65535))&&(t=0,l[o+16|0]==(w>>>16&255)))break i;t=1}V&&x2(V);i:{e:{r:{f:{if(w=(m|0)!=0&(B&255)>>>0>8,s=(k|0)==99?Q:k,!((t|(w|((s|0)!=(Q|0)|(f|0)!=(F|0))))&1)&&(!TA(h)||(k=i[n+48>>2],!k|!i[k+4>>2])))break f;if(u[_+6|0]=1,g[_+4>>1]=2,g[_>>1]=2,g[_+2>>1]=2,k=i[n+56>>2],!k)break r;g[_+4>>1]=i[k+12>>2],g[_>>1]=i[k+4>>2],u[_+6|0]=l[k+16|0]!=0;break e}e=i[r+4>>2],u[A+20|0]=0,i[A+4>>2]=e,i[A>>2]=h;break i}u[_+6|0]=1,g[_+4>>1]=6,g[_>>1]=1,g[_+2>>1]=13}if(r6(A,r,f,s,_,w?8:0,n+28|0,i[n+48>>2],e- -64|0),e=i[r+4>>2],!e||(A=i[e+4>>2],i[e+4>>2]=A-1,A))break i;W[i[i[e>>2]+8>>2]](e),y(e)}v=_+16|0}function Ov(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0;var k=0,n=0,t=0,o=0,s=0,w=0,h=0,_=0,B=0,m=0,X=0,Q=0,V=0,F=0;n=v-32|0,v=n,A=i[A>>2],k=i[A+48>>2],A=i[A+52>>2],A&&(i[A+4>>2]=i[A+4>>2]+1),t=i[k+108>>2],w=i[k+112>>2],w&&(i[w+4>>2]=i[w+4>>2]+1);i:{if(!A||(k=i[A+4>>2],i[A+4>>2]=k-1,k))break i;W[i[i[A>>2]+8>>2]](A),y(A)}i:{if(!t){i[f>>2]=0;break i}k=0,i[n+28>>2]=0,i[n+20>>2]=0,i[n+24>>2]=0;e:{r:{f:{if(A=i[t+36>>2],s=i[t+40>>2],(A|0)!=(s|0)){if(k=s-A|0,(k|0)<0)break f;for(t=p(k),i[n+20>>2]=t,i[n+28>>2]=k+t,k=t;i[k>>2]=i[A>>2],h=k,k=i[A+4>>2],i[h+4>>2]=k,k&&(i[k+4>>2]=i[k+4>>2]+1),k=h+8|0,A=A+8|0,(s|0)!=(A|0););for(i[n+24>>2]=k,i[n+16>>2]=0,i[n+8>>2]=0,i[n+12>>2]=0;;){A=i[t>>2];A:{k:{n:{t:{if(e){if(i[A+16>>2]==(e|0))break t;break A}if(!A)break n}if(k=W0(A,86580,88372),!k)break n;if(i[n>>2]=k,A=i[t+4>>2],i[n+4>>2]=A,!A)break k;i[A+4>>2]=i[A+4>>2]+1;break k}i[n>>2]=0,i[n+4>>2]=0,k=0}k:{n:{if(!r)break n;if(A=i[k+108>>2],k=i[k+112>>2],(A|0)==(k|0))break k;for(;;){if(i[A>>2]==(r|0))break n;if(A=A+4|0,(k|0)==(A|0))break}break k}Vt(n+8|0,n)}if(A=i[n+4>>2],!A||(k=i[A+4>>2],i[A+4>>2]=k-1,k))break A;W[i[i[A>>2]+8>>2]](A),y(A)}if(A=(t|0)==(h|0),t=t+8|0,!!A)break}break r}i[f>>2]=0;break e}G0(),H()}s=i[n+12>>2],t=i[n+8>>2],A=s-t|0,h=A>>3,X=p(h>>>0>268435455?-1:A<<1);r:{f:{if((t|0)!=(s|0)){for(V=h>>>0<=1?1:h;;){e=(B<<4)+X|0,A=i[t+(B<<3)>>2],i[e>>2]=i[A+104>>2],i[e+4>>2]=i[A+16>>2],r=i[A+108>>2],k=i[A+112>>2];A:{if((r|0)==(k|0)){k=0,A=r;break A}r=k-r|0,k=p((r|0)<0?-1:r),r=i[A+108>>2],A=i[A+112>>2]}i[e+8>>2]=k,o=e,e=A-r>>2,i[o+12>>2]=e;A:{if(!k|(A|0)==(r|0))break A;if(o=e>>>0<=1?1:e,Q=o&3,m=0,A=0,e>>>0>=4)for(F=o&-4,e=0;o=A<<2,i[o+k>>2]=i[r+o>>2],_=o|4,i[_+k>>2]=i[r+_>>2],_=o|8,i[_+k>>2]=i[r+_>>2],o=o|12,i[o+k>>2]=i[r+o>>2],A=A+4|0,e=e+4|0,(F|0)!=(e|0););if(!Q)break A;for(;e=A<<2,i[e+k>>2]=i[e+r>>2],A=A+1|0,m=m+1|0,(m|0)!=(Q|0););}if(B=B+1|0,(V|0)==(B|0))break}for(i[f>>2]=h;;){A=i[s-4>>2];A:{if(!A||(e=i[A+4>>2],i[A+4>>2]=e-1,e))break A;W[i[i[A>>2]+8>>2]](A),y(A)}if(s=s-8|0,(t|0)==(s|0))break}A=i[n+8>>2];break f}if(i[f>>2]=h,A=t,!A)break r}i[n+12>>2]=t,Z(A)}k=i[n+20>>2]}if(!k)break i;if(r=k,A=i[n+24>>2],(k|0)!=(A|0)){for(;;){e=i[A-4>>2];e:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break e;W[i[i[e>>2]+8>>2]](e),y(e)}if(A=A-8|0,(k|0)==(A|0))break}r=i[n+20>>2]}i[n+24>>2]=k,Z(r)}i:{if(!w||(A=i[w+4>>2],i[w+4>>2]=A-1,A))break i;W[i[i[w>>2]+8>>2]](w),y(w)}return v=n+32|0,X|0}function Pv(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0;var k=0,n=0,t=0,o=0,s=0,w=0,h=0,_=0,B=0,m=0,X=0,Q=0;k=v-192|0,v=k,z2(k+172|0,e,r),u[k+191|0]<0&&Z(i[k+180>>2]),X=e,Q=C0(r),i[X+104>>2]=Q,n=l[e+97|0],(n|0)==1&&(n=C0(r),u[e+112|0]=1,i[e+108>>2]=n,n=l[e+97|0]),n>>>0>=2&&(n=C0(r),u[e+120|0]=1,i[e+116>>2]=n),_=C0(r),n=i[f+76>>2];i:{if(!(n>>>0<_>>>0&&n)){e:{r:{f:{A:{if(_)for(;;){t=0;k:{if(l[e+97|0]!=1||(t=0,i[e+108>>2]))break k;t=C0(r)}B=0,f=0;k:{if(i[e+104>>2]!=1919247987)break k;if(f=p(32),i[f+16>>2]=0,i[f+4>>2]=0,i[f+8>>2]=0,i[f+28>>2]=0,i[f+20>>2]=0,i[f+24>>2]=0,i[f>>2]=106428,i[f+12>>2]=105820,B=f+12|0,an(A,B,r,e),i[A>>2])break A;if(u[A+19|0]>=0)break k;Z(i[A+8>>2])}n=i[e+128>>2],o=i[e+132>>2];k:{if(n>>>0<o>>>0){i[n+8>>2]=f,i[n+4>>2]=B,i[n>>2]=t,f=n+12|0;break k}if(h=i[e+124>>2],n=n-h|0,s=((n|0)/12|0)+1|0,s>>>0>=357913942)break r;if(o=(o-h|0)/12|0,w=o<<1,w=o>>>0>=178956970?357913941:w>>>0>s>>>0?w:s,w){if(w>>>0>=357913942)break e;s=p(G(w,12))}else s=0;if(o=s+n|0,i[o+8>>2]=f,i[o+4>>2]=B,i[o>>2]=t,t=o+G((n|0)/-12|0,12)|0,n&&x(t,h,n),i[e+132>>2]=s+G(w,12),f=o+12|0,i[e+128>>2]=f,i[e+124>>2]=t,!h)break k;Z(h)}if(i[e+128>>2]=f,m=m+1|0,(_|0)==(m|0))break}if(e=i[26917],i[A>>2]=i[26916],i[A+4>>2]=e,A=A+8|0,u[107683]<0)break f;e=i[26919],i[A>>2]=i[26918],i[A+4>>2]=e,i[A+8>>2]=i[26920];break i}if(A=i[f+4>>2],i[f+4>>2]=A-1,A)break i;W[i[i[f>>2]+8>>2]](f),y(f);break i}T(A,i[26918],i[26919]);break i}G0(),H()}z0(),H()}i[k+116>>2]=0,i[k+88>>2]=72196,i[k+32>>2]=72176,e=i[18053],i[k+24>>2]=e,r=i[e-12>>2],e=k+24|0,i[r+e>>2]=i[18054],i[k+28>>2]=0,r=e+i[i[k+24>>2]-12>>2]|0,n=k+36|0,J0(r,n),u[r+80|0]=0,i[r+72>>2]=0,r=i[18055],i[k+32>>2]=r,t=i[r-12>>2],r=k+32|0,i[t+r>>2]=i[18056],t=i[18052],i[k+24>>2]=t,i[e+i[t-12>>2]>>2]=i[18057],i[k+88>>2]=72196,i[k+24>>2]=72156,i[k+32>>2]=72176,n=R0(n),i[n>>2]=71232,i[k+76>>2]=0,i[k+80>>2]=0,i[k+68>>2]=0,i[k+72>>2]=0,i[k+84>>2]=24,Y(V0(Y(q2(Y(r,28376,11),_,0),28388,62),i[f+76>>2]),5081,6),e=i[k+84>>2];e:{r:{if(e&16){f=k+56|0,r=i[k+80>>2],e=i[k+60>>2],r>>>0<e>>>0?i[k+80>>2]=e:e=r;break r}if(!(e&8)){e=0,u[k+23|0]=0,f=k+12|0;break e}f=k+44|0,e=i[k+52>>2]}r:{if(r=i[f>>2],e=e-r|0,e>>>0<2147483640){if(e>>>0>=11){t=e|7,f=p(t+1|0),i[k+20>>2]=t-2147483647,i[k+12>>2]=f,i[k+16>>2]=e;break r}if(u[k+23|0]=e,f=k+12|0,e)break r;e=0;break e}Q0(),H()}if(!e)break e;x(f,r,e)}u[e+f|0]=0,q(A,6,1e3,k+12|0),u[k+23|0]<0&&Z(i[k+12>>2]),A=i[18051],i[k+24>>2]=A,i[i[A-12>>2]+(k+24|0)>>2]=i[18059],i[k+32>>2]=i[18060],i[n>>2]=71232,u[k+79|0]<0&&Z(i[k+68>>2]),E0(n),y0(k+88|0)}v=k+192|0}function Lv(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0;var k=0,n=0,t=0,o=0,s=0,w=0,h=0;k=v-32|0,v=k,z2(k,e,r),u[k+19|0]<0&&Z(i[k+8>>2]);i:{if(l[e+97|0]){t1(A,e,17920);break i}if(n=C0(r),q4(A,e+116|0,G(n,12),f,13811),i[A>>2])break i;u[A+19|0]<0&&Z(i[A+8>>2]),s=e+104|0,t=i[e+104>>2],o=(i[e+108>>2]-t|0)/12|0;e:{r:{if(o>>>0<n>>>0){Dt(s,n-o|0);break r}if(n>>>0<o>>>0&&(i[e+108>>2]=t+G(n,12)),!n)break e}for(e=0;;){if(h=C0(r),o=C0(r),w=C0(r),!w){if(e=p(56),i[k+20>>2]=e,i[k+24>>2]=51,i[k+28>>2]=-2147483592,r=l[26123]|l[26124]<<8|(l[26125]<<16|l[26126]<<24),f=l[26119]|l[26120]<<8|(l[26121]<<16|l[26122]<<24),u[e|0]=f,u[e+1|0]=f>>>8,u[e+2|0]=f>>>16,u[e+3|0]=f>>>24,u[e+4|0]=r,u[e+5|0]=r>>>8,u[e+6|0]=r>>>16,u[e+7|0]=r>>>24,u[e+51|0]=0,r=l[26166]|l[26167]<<8|(l[26168]<<16|l[26169]<<24),u[e+47|0]=r,u[e+48|0]=r>>>8,u[e+49|0]=r>>>16,u[e+50|0]=r>>>24,r=l[26163]|l[26164]<<8|(l[26165]<<16|l[26166]<<24),f=l[26159]|l[26160]<<8|(l[26161]<<16|l[26162]<<24),u[e+40|0]=f,u[e+41|0]=f>>>8,u[e+42|0]=f>>>16,u[e+43|0]=f>>>24,u[e+44|0]=r,u[e+45|0]=r>>>8,u[e+46|0]=r>>>16,u[e+47|0]=r>>>24,r=l[26155]|l[26156]<<8|(l[26157]<<16|l[26158]<<24),f=l[26151]|l[26152]<<8|(l[26153]<<16|l[26154]<<24),u[e+32|0]=f,u[e+33|0]=f>>>8,u[e+34|0]=f>>>16,u[e+35|0]=f>>>24,u[e+36|0]=r,u[e+37|0]=r>>>8,u[e+38|0]=r>>>16,u[e+39|0]=r>>>24,r=l[26147]|l[26148]<<8|(l[26149]<<16|l[26150]<<24),f=l[26143]|l[26144]<<8|(l[26145]<<16|l[26146]<<24),u[e+24|0]=f,u[e+25|0]=f>>>8,u[e+26|0]=f>>>16,u[e+27|0]=f>>>24,u[e+28|0]=r,u[e+29|0]=r>>>8,u[e+30|0]=r>>>16,u[e+31|0]=r>>>24,r=l[26139]|l[26140]<<8|(l[26141]<<16|l[26142]<<24),f=l[26135]|l[26136]<<8|(l[26137]<<16|l[26138]<<24),u[e+16|0]=f,u[e+17|0]=f>>>8,u[e+18|0]=f>>>16,u[e+19|0]=f>>>24,u[e+20|0]=r,u[e+21|0]=r>>>8,u[e+22|0]=r>>>16,u[e+23|0]=r>>>24,r=l[26131]|l[26132]<<8|(l[26133]<<16|l[26134]<<24),f=l[26127]|l[26128]<<8|(l[26129]<<16|l[26130]<<24),u[e+8|0]=f,u[e+9|0]=f>>>8,u[e+10|0]=f>>>16,u[e+11|0]=f>>>24,u[e+12|0]=r,u[e+13|0]=r>>>8,u[e+14|0]=r>>>16,u[e+15|0]=r>>>24,q(A,2,0,k+20|0),u[k+31|0]>=0)break i;Z(i[k+20>>2]);break i}if(o>>>0>u0[f+80>>2]){if(e=p(96),i[k+20>>2]=e,i[k+24>>2]=90,i[k+28>>2]=-2147483552,x(e,23911,90),u[e+90|0]=0,q(A,2,0,k+20|0),u[k+31|0]>=0)break i;Z(i[k+20>>2]);break i}if(t=i[s>>2]+G(e,12)|0,i[t+8>>2]=w,i[t+4>>2]=o,i[t>>2]=h,e=e+1|0,(n|0)==(e|0))break}}if(l[r+20|0]==1){if(u[k+20|0]=0,u[k+31|0]=0,q(A,2,100,k+20|0),u[k+31|0]>=0)break i;Z(i[k+20>>2]);break i}if(e=i[26917],i[A>>2]=i[26916],i[A+4>>2]=e,A=A+8|0,u[107683]>=0){e=i[26919],i[A>>2]=i[26918],i[A+4>>2]=e,i[A+8>>2]=i[26920];break i}T(A,i[26918],i[26919])}v=k+32|0}function Kv(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0;var k=0,n=0,t=0,o=0,s=0,w=0,h=0,_=0,B=0,m=0,X=0,Q=0,V=0,F=0;f=v-192|0,v=f,z2(f+168|0,e,r);i:{if(i[f+168>>2]!=i[26916]){e=i[f+172>>2],i[A>>2]=i[f+168>>2],i[A+4>>2]=e,i[A+16>>2]=i[f+184>>2],e=i[f+180>>2],i[A+8>>2]=i[f+176>>2],i[A+12>>2]=e,i[f+184>>2]=0,i[f+176>>2]=0,i[f+180>>2]=0;break i}if(l[e+97|0]>=2){t1(A,e,4730);break i}B=C0(r),i[e+108>>2]=i[e+104>>2];e:{r:{f:{A:{k:{if(B)for(;;){if(!i[r+16>>2]){i[f+112>>2]=0,i[f+84>>2]=72196,i[f+28>>2]=72176,e=i[18053],i[f+20>>2]=e,r=i[e-12>>2],e=f+20|0,i[r+e>>2]=i[18054],i[f+24>>2]=0,r=e+i[i[f+20>>2]-12>>2]|0,k=f+32|0,J0(r,k),u[r+80|0]=0,i[r+72>>2]=0,r=i[18055],i[f+28>>2]=r,m=i[r-12>>2],r=f+28|0,i[m+r>>2]=i[18056],o=i[18052],i[f+20>>2]=o,i[e+i[o-12>>2]>>2]=i[18057],i[f+84>>2]=72196,i[f+20>>2]=72156,i[f+28>>2]=72176,o=R0(k),i[o>>2]=71232,i[f+72>>2]=0,i[f+76>>2]=0,i[f+64>>2]=0,i[f+68>>2]=0,i[f+80>>2]=24,Y(q2(Y(V0(Y(r,28143,24),B),29096,31),_,s),24180,9),e=i[f+80>>2];n:{if(e&16){k=f+52|0,r=i[f+76>>2],e=i[f+56>>2],r>>>0<e>>>0?i[f+76>>2]=e:e=r;break n}if(!(e&8)){e=0,u[f+19|0]=0,k=f+8|0;break e}k=f+40|0,e=i[f+48>>2]}if(r=i[k>>2],e=e-r|0,e>>>0>=2147483640)break k;if(e>>>0>=11){s=e|7,k=p(s+1|0),i[f+16>>2]=s-2147483647,i[f+8>>2]=k,i[f+12>>2]=e;break r}if(u[f+19|0]=e,k=f+8|0,e)break r;e=0;break e}n:{if(l[e+97|0]==1){o=Y4(r),X=l0,k=Y4(r),Q=l0;break n}o=C0(r),X=0,k=C0(r),Q=k>>31}m=k,V=wi(r),F=wi(r),n=i[e+108>>2],t=i[e+112>>2];n:{if(n>>>0<t>>>0){g[n+18>>1]=F,g[n+16>>1]=V,i[n+8>>2]=k,i[n+12>>2]=Q,i[n>>2]=o,i[n+4>>2]=X,k=n+24|0;break n}if(h=i[e+104>>2],k=n-h|0,n=((k|0)/24|0)+1|0,n>>>0>=178956971)break A;if(t=(t-h|0)/24|0,w=t<<1,w=t>>>0>=89478485?178956970:n>>>0<w>>>0?w:n,w){if(w>>>0>=178956971)break f;n=p(G(w,24))}else n=0;if(t=n+k|0,g[t+18>>1]=F,g[t+16>>1]=V,i[t+8>>2]=m,i[t+12>>2]=Q,i[t>>2]=o,i[t+4>>2]=X,o=t+G((k|0)/-24|0,24)|0,k&&x(o,h,k),i[e+112>>2]=n+G(w,24),k=t+24|0,i[e+108>>2]=k,i[e+104>>2]=o,!h)break n;Z(h)}if(i[e+108>>2]=k,_=_+1|0,s=_?s:s+1|0,!((B|0)!=(_|0)|s))break}if(l[r+20|0]==1){if(u[f+20|0]=0,u[f+31|0]=0,q(A,2,100,f+20|0),u[f+31|0]>=0)break i;Z(i[f+20>>2]);break i}if(e=i[26917],i[A>>2]=i[26916],i[A+4>>2]=e,A=A+8|0,u[107683]>=0){e=i[26919],i[A>>2]=i[26918],i[A+4>>2]=e,i[A+8>>2]=i[26920];break i}T(A,i[26918],i[26919]);break i}Q0(),H()}G0(),H()}z0(),H()}if(!e)break e;x(k,r,e)}u[e+k|0]=0,q(A,2,100,f+8|0),u[f+19|0]<0&&Z(i[f+8>>2]),A=i[18051],i[f+20>>2]=A,i[i[A-12>>2]+(f+20|0)>>2]=i[18059],i[f+28>>2]=i[18060],i[o>>2]=71232,u[f+75|0]<0&&Z(i[f+64>>2]),E0(o),y0(f+84|0)}u[f+187|0]<0&&Z(i[f+176>>2]),v=f+192|0}function qv(A){A=A|0;var e=0,r=0,f=0,k=0,n=0,t=0,o=0,s=0,w=0,h=0,_=0,B=0;i[A+4>>2]=1,e=i[A+12>>2],i[e+324>>2]=i[e+324>>2]-1,i[e+328>>2]=i[e+328>>2]+1,e=i[A+12>>2],_=i[e+124>>2],h=i[_+16876>>2],r=e,B=i[_+16892>>2],e=B-1|0,C8(r,A,e,i[A+8>>2],i[A+24>>2]),r=i[A+8>>2],(r|0)>0&&(C8(i[A+12>>2],A,e,r-1|0,i[A+24>>2]),r=i[A+8>>2]),f=r+1|0,(f|0)<i[_+16900>>2]&&(C8(i[A+12>>2],A,e,f,i[A+24>>2]),r=i[A+8>>2],f=r+1|0),t=i[A+20>>2],k=i[A+16>>2],f=f<<h;i:{e:{if(e=r<<h,!(e&1)){if(r=i[k+28>>2],s=(r|0)>(f|0)?f:r,s&1)break e;r=i[t+124>>2],o=(i[r+16840>>2]+7|0)/8|0,w=(i[r+16832>>2]+7|0)/8|0,r=i[k+40>>2];r:{if((r|0)!=i[t+40>>2]){if((e|0)>=(s|0))break r;for(r=e;n=G(w,i[k+24>>2]),n&&(f=G(r,w),x(i[t+4>>2]+G(f,i[t+40>>2])|0,i[k+4>>2]+G(f,i[k+40>>2])|0,n)),r=r+1|0,(s|0)!=(r|0););break r}if(f=G(s-e|0,G(r,w)),!f)break r;r=G(r,G(e,w)),x(r+i[t+4>>2]|0,r+i[k+4>>2]|0,f)}r=l[k+51|0],f=(s|0)/(r|0)|0,r=(e|0)/(r|0)|0;r:{if(!i[k+20>>2])break r;if(e=i[k+44>>2],(e|0)!=i[t+44>>2]){if((r|0)>=(f|0))break r;for(;n=G(r,o),e=G(o,i[k+32>>2]),e&&x(i[t+8>>2]+G(n,i[t+44>>2])|0,i[k+8>>2]+G(n,i[k+44>>2])|0,e),e=G(o,i[k+32>>2]),e&&x(i[t+12>>2]+G(n,i[t+44>>2])|0,i[k+12>>2]+G(n,i[k+44>>2])|0,e),r=r+1|0,(f|0)!=(r|0););break r}if(n=G(r,o),f=G(o,f-r|0),r=G(f,e),r&&(e=G(e,n),x(e+i[t+8>>2]|0,e+i[k+8>>2]|0,r)),e=i[t+44>>2],r=G(e,f),!r)break r;e=G(e,n),x(e+i[t+12>>2]|0,e+i[k+12>>2]|0,r)}break i}D0(22124,18288,570,9354),H()}D0(22139,18288,571,9354),H()}i:{if(i[_+16892>>2]<=0)break i;for(k=1<<h,r=0;;){if(o=i[A+12>>2],f=i[o+52>>2],s=i[A+8>>2],e=C[((i[o+140>>2]+G(r,24)|0)+G(G(s,i[o+152>>2]),24)|0)+2>>1],e>>>0>=i[o+56>>2]-f>>2>>>0||(w=i[f+(e<<2)>>2],!w))break i;e:{if(!l[w+333|0])break e;if(e=i[A+20>>2],h=i[e+40>>2],n=i[e+4>>2],e=i[A+16>>2],f=i[e+40>>2],e=i[e+4>>2],i[i[o+124>>2]+16832>>2]>=9){Li(o,r,s,0,k,k,e,f,n,h);break e}Ki(o,r,s,0,k,k,e,f,n,h)}e:{if(!l[w+334|0])break e;t=(k|0)/i[_+16856>>2]|0,o=(k|0)/i[_+16852>>2]|0,s=i[A+8>>2],e=i[A+20>>2],w=i[e+44>>2],h=i[e+8>>2],e=i[A+16>>2],n=i[e+44>>2],f=i[e+8>>2],e=i[A+12>>2];r:{if(i[i[e+124>>2]+16840>>2]>=9){Li(e,r,s,1,o,t,f,n,h,w);break r}Ki(e,r,s,1,o,t,f,n,h,w)}if(s=i[A+8>>2],e=i[A+20>>2],w=i[e+44>>2],h=i[e+12>>2],e=i[A+16>>2],n=i[e+44>>2],f=i[e+12>>2],e=i[A+12>>2],i[i[e+124>>2]+16840>>2]>=9){Li(e,r,s,2,o,t,f,n,h,w);break e}Ki(e,r,s,2,o,t,f,n,h,w)}if(r=r+1|0,!((r|0)<i[_+16892>>2]))break}}if(r=0,(B|0)>0)for(;e=(i[i[A+12>>2]+320>>2]+G(r,76)|0)+G(G(i[A+8>>2],i[_+16892>>2]),76)|0,i[e>>2]<4&&(i[e>>2]=4),r=r+1|0,(B|0)!=(r|0););i[A+4>>2]=3,h3(i[A+12>>2])}function C9(A,e,r,f,k,n,t,o,s,w){var h=0,_=0,B=0,m=0,X=0,Q=0,V=0;h=v-96|0,v=h;i:{e:{X=i[e+20>>2];r:{if(!X)break r;for(V=h- -64|0,m=e+20|0,B=m,_=X;Q=u0[_+16>>2]<r>>>0,B=Q?B:_,_=i[(Q?4:0)+_>>2],!!_;);if(_=0,(B|0)==(m|0)|u0[B+16>>2]>r>>>0)break r;for(_=m;B=u0[X+16>>2]<r>>>0,_=B?_:X,X=i[(B?4:0)+X>>2],!!X;);if(_=(_|0)!=(m|0)&u0[_+16>>2]<=r>>>0?_:m,m=i[_+20>>2],_=i[_+24>>2],_&&(i[_+4>>2]=i[_+4>>2]+1),m)break e}u[h+16|0]=0,u[h+27|0]=0,e=q(h+56|0,2,2e3,h+16|0),r=i[e+4>>2],i[A>>2]=i[e>>2],i[A+4>>2]=r,r=A+8|0;r:{if(u[e+19|0]>=0){f=i[e+12>>2],i[r>>2]=i[e+8>>2],i[r+4>>2]=f,i[r+8>>2]=i[e+16>>2],u[A+20|0]=1;break r}if(T(r,i[e+8>>2],i[e+12>>2]),r=u[e+19|0],u[A+20|0]=1,(r|0)>=0)break r;Z(i[e+8>>2])}if(u[h+27|0]>=0)break i;Z(i[h+16>>2]);break i}i[h+48>>2]=0,i[h+52>>2]=0,i[h+44>>2]=h+48,r=h+44|0,t8(r,i[w>>2],w+4|0),W[i[i[m>>2]+100>>2]](h+56|0,m,n,t,o,s,r),Y1(r,i[h+48>>2]);e:{r:{f:{A:{k:{n:switch(l[h+76|0]){case 1:e=i[h+60>>2],i[A>>2]=i[h+56>>2],i[A+4>>2]=e,r=A+8|0;t:{if(u[h+75|0]>=0){e=V,f=i[e+4>>2],i[r>>2]=i[e>>2],i[r+4>>2]=f,i[r+8>>2]=i[e+8>>2];break t}T(r,i[h+64>>2],i[h+68>>2])}u[A+20|0]=1;break e;case 0:break n;default:break k}switch(t=i[h+56>>2],r=i[h+60>>2],r&&(i[r+4>>2]=i[r+4>>2]+1,i[r+4>>2]=i[r+4>>2]+1),i[h+12>>2]=r,i[h+8>>2]=t,t=i[h+12>>2],i[h>>2]=i[h+8>>2],i[h+4>>2]=t,I9(h+16|0,e,h,f,k,n),n=l[h+36|0],n|0){case 0:break f;case 1:break A;default:break k}}_2(),H()}if(e=i[h+20>>2],i[A>>2]=i[h+16>>2],i[A+4>>2]=e,e=A+8|0,u[h+35|0]>=0){f=i[h+28>>2],i[e>>2]=i[h+24>>2],i[e+4>>2]=f,i[e+8>>2]=i[h+32>>2];break r}T(e,i[h+24>>2],i[h+28>>2]);break r}k=i[h+20>>2],k&&(i[k+4>>2]=i[k+4>>2]+1),e=i[h+16>>2];f:{if(!r||(f=i[r+4>>2],i[r+4>>2]=f-1,f))break f;W[i[i[r>>2]+8>>2]](r),y(r)}if(r=i[m+424>>2],t=i[m+428>>2],(r|0)!=(t|0))for(o=e+148|0,B=i[e+152>>2];;){f:{if(u0[e+156>>2]>B>>>0){if(f=i[r+4>>2],i[B>>2]=i[r>>2],i[B+4>>2]=f,f=B+8|0,u[r+19|0]>=0){s=i[r+12>>2],i[f>>2]=i[r+8>>2],i[f+4>>2]=s,i[f+8>>2]=i[r+16>>2],B=B+20|0;break f}T(f,i[r+8>>2],i[r+12>>2]),B=B+20|0;break f}B=fi(o,r)}if(i[e+152>>2]=B,r=r+20|0,(t|0)==(r|0))break}i[A+4>>2]=k,i[A>>2]=e,r=0}if(u[A+20|0]=n,A=l[h+36|0],(A|0)!=255&&(e=i[23595],i[h+88>>2]=i[23594],i[h+92>>2]=e,W[i[(h+88|0)+(A<<2)>>2]](h+87|0,h+16|0)),!r||(A=i[r+4>>2],i[r+4>>2]=A-1,A))break e;W[i[i[r>>2]+8>>2]](r),y(r)}if(A=l[h+76|0],(A|0)==255)break i;e=i[23595],i[h+16>>2]=i[23594],i[h+20>>2]=e,W[i[(h+16|0)+(A<<2)>>2]](h+88|0,h+56|0)}i:{if(!_||(A=i[_+4>>2],i[_+4>>2]=A-1,A))break i;W[i[i[_>>2]+8>>2]](_),y(_)}v=h+96|0}function av(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0;var k=0,n=0,t=0,o=0,s=0,w=0,h=0,_=0,B=0,m=0,X=0,Q=0,V=0,F=0,I=0,E=0;B=v-32|0,v=B,s=B+12|0,V=r,F=f,k=v-48|0,v=k;i:{e:{if(m=i[e>>2],f=i[m+124>>2],X=m+128|0,(f|0)!=(X|0))for(Q=s+8|0,I=m+136|0;;){OA(V,F,i[f+16>>2],i[m+120>>2],k+44|0,k+40|0),h=i[f+32>>2],_=i[f+28>>2],t=i[f+16>>2];r:{if((t|0)==10){if(o=31,r=i[m+120>>2]-10|0,r>>>0>=6)break r;o=i[(r<<2)+50008>>2];break r}if(o=0,n=X,r=i[n>>2],!r)break r;for(;w=(t|0)>i[r+16>>2],n=w?n:r,r=i[(w?4:0)+r>>2],!!r;);if((n|0)==(X|0)|(t|0)<i[n+16>>2])break r;o=(l[n+24|0]+7&248)>>>3|0}if(n=i[k+44>>2],r=i[k+40>>2],!(n>>>0<=u0[f+36>>2]&r>>>0<=u0[f+40>>2])){g[k+4>>1]=256,i[k>>2]=1,i[k+32>>2]=0,i[k+36>>2]=0,i[k+24>>2]=0,i[k+28>>2]=0,i[k+16>>2]=0,i[k+20>>2]=0,i[k+8>>2]=0,i[k+12>>2]=0,t=r,w=i[f+20>>2],E=l[f+24|0],r=1;r:{f:switch(i[m+120>>2]){case 10:case 12:case 14:r=3;break r;case 11:case 13:case 15:r=4;break r;case 0:case 1:case 2:case 3:case 99:break r;default:break f}r=0}if(kr(s,k,n,t,w,E,r,0,I),i[s>>2])break i;if(u[s+19|0]<0&&Z(i[s+8>>2]),n=i[k+24>>2],!n)break e;if(i[f+32>>2])for(r=0,t=i[k+36>>2];w=G(i[f+28>>2],o),w&&x(n+G(r,t)|0,i[f+44>>2]+G(i[f+56>>2],r)|0,w),r=r+1|0,r>>>0<u0[f+32>>2];);r=i[k+4>>2],i[f+20>>2]=i[k>>2],i[f+24>>2]=r,r=i[k+36>>2],i[f+52>>2]=i[k+32>>2],i[f+56>>2]=r,r=i[k+28>>2],i[f+44>>2]=i[k+24>>2],i[f+48>>2]=r,r=i[k+20>>2],i[f+36>>2]=i[k+16>>2],i[f+40>>2]=r,r=i[k+12>>2],i[f+28>>2]=i[k+8>>2],i[f+32>>2]=r,n=i[k+44>>2]}if(!(!h|(n|0)==(_|0)|n>>>0<=_>>>0))for(w=G(_-1|0,o),t=0;;){if(r=_,n>>>0>r>>>0)for(;o&&(n=i[f+44>>2]+G(i[f+56>>2],t)|0,x(n+G(r,o)|0,n+w|0,o)),r=r+1|0,n=i[k+44>>2],r>>>0<n>>>0;);if(t=t+1|0,(h|0)==(t|0))break}if(u0[k+40>>2]>h>>>0)for(r=h-1|0;n=G(i[k+44>>2],o),n&&(t=i[f+44>>2],_=i[f+56>>2],x(t+G(_,h)|0,t+G(r,_)|0,n)),h=h+1|0,h>>>0<u0[k+40>>2];);o=i[f+4>>2];r:{if(o){for(;;)if(r=o,o=i[r>>2],!o)break r}for(;r=i[f+8>>2],n=i[r>>2]!=(f|0),f=r,!!n;);}if(f=r,(X|0)==(r|0))break}if(r=i[26917],i[s>>2]=i[26916],i[s+4>>2]=r,r=s+8|0,u[107683]>=0){f=i[26919],i[r>>2]=i[26918],i[r+4>>2]=f,i[r+8>>2]=i[26920];break i}T(r,i[26918],i[26919]);break i}if(r=i[26922],i[s>>2]=i[26921],i[s+4>>2]=r,u[107703]>=0){r=i[26924],i[Q>>2]=i[26923],i[Q+4>>2]=r,i[Q+8>>2]=i[26925];break i}T(Q,i[26923],i[26924])}v=k+48|0;i:{if(i[B+12>>2]){r=A,A=i[e>>2],b0(r,s,A?A+92|0:0);break i}e=i[24057],i[A>>2]=i[24056],i[A+4>>2]=e,i[A+8>>2]=i[24058]}u[B+31|0]<0&&Z(i[B+20>>2]),v=B+32|0}function $v(A,e,r,f,k){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0;var n=0,t=0,o=0,s=0,w=0,h=0,_=0;if(n=v-80|0,v=n,i[n+52>>2]=0,i[n+56>>2]=0,i[n+60>>2]=0,i[n+64>>2]=0,i[n+44>>2]=0,i[n+48>>2]=0,u[n+40|0]=0,i[n+36>>2]=9e4,w=i[e>>2],o=h2(r),o>>>0<2147483640){t=f||n+36|0;i:{e:{if(o>>>0>=11){s=o|7,f=p(s+1|0),i[n+8>>2]=s-2147483647,i[n>>2]=f,i[n+4>>2]=o;break e}if(u[n+11|0]=o,f=n,!o)break i}if(!o)break i;x(f,r,o)}u[f+o|0]=0,o=v-16|0,v=o,sr(i[w+48>>2]),s=p(320),i[s>>2]=94892,i[s+4>>2]=0,i[s+8>>2]=0,r=s+16|0;i:{if(u[n+11|0]>=0){i[o+8>>2]=i[n+8>>2],f=i[n+4>>2],i[o>>2]=i[n>>2],i[o+4>>2]=f;break i}T(o,i[n>>2],i[n+4>>2])}f=v-16|0,v=f,_=p7(r,w,t,1835365473),i[_>>2]=106768,i[_+296>>2]=i[o+8>>2],r=i[o+4>>2],i[_+288>>2]=i[o>>2],i[_+292>>2]=r,i[o>>2]=0,i[o+4>>2]=0,i[o+8>>2]=0,r=p(120),i[r>>2]=94124,i[r+4>>2]=0,i[r+8>>2]=0,t=r+16|0,i[t+8>>2]=0,i[t+12>>2]=0,i[r+32>>2]=0,i[r+36>>2]=0,i[r+40>>2]=0,i[r+44>>2]=0,i[r+48>>2]=0,i[r+16>>2]=86356,i[r+60>>2]=0,i[r+64>>2]=0,i[r+52>>2]=0,i[r+56>>2]=0,i[r+72>>2]=-1,i[r+76>>2]=-1,i[r+80>>2]=-1,i[r+84>>2]=-1,i[r+88>>2]=0,i[r+92>>2]=0,i[r+96>>2]=0,i[r+100>>2]=0,i[r+104>>2]=0,i[r+108>>2]=0,g[r+112>>1]=0,i[r+16>>2]=104700,i[r+116>>2]=1,i[r+32>>2]=1852663908,h=i[_+148>>2],i[f+12>>2]=r,i[f+8>>2]=t,i[r+4>>2]=i[r+4>>2]+1,r2(h+36|0,f+8|0),t=i[f+12>>2];i:{if(!t||(h=i[t+4>>2],i[t+4>>2]=h-1,h))break i;W[i[i[t>>2]+8>>2]](t),y(t)}t=i[r+4>>2],i[r+4>>2]=t-1,t||(W[i[i[r>>2]+8>>2]](r),y(r)),v=f+16|0,u[o+11|0]<0&&Z(i[o>>2]),i[s+4>>2]=i[s+4>>2]+1,h=i[s+40>>2];i:{e:{t=i[w+184>>2];r:{if(!t){f=w+184|0,r=f;break r}for(;;){if(r=t,f=i[r+16>>2],f>>>0>h>>>0){if(f=r,t=i[r>>2],t)continue;break r}if(f>>>0>=h>>>0)break e;if(t=i[r+4>>2],!t)break}f=r+4|0}t=p(28),i[t+24>>2]=s,i[t+20>>2]=_,i[t+16>>2]=h,i[t+8>>2]=r,i[t>>2]=0,i[t+4>>2]=0,i[f>>2]=t,r=i[i[w+180>>2]>>2],r&&(i[w+180>>2]=r),m1(i[w+184>>2],t),i[w+188>>2]=i[w+188>>2]+1;break i}if(r=i[s+4>>2],i[s+4>>2]=r-1,r)break i;W[i[i[s>>2]+8>>2]](s),y(s)}u[n+32|0]=0,i[n+16>>2]=s,i[n+12>>2]=_,v=o+16|0,u[n+11|0]<0&&Z(i[n>>2]);i:{e:switch(l[n+32|0]){default:_2(),H();case 1:b0(A,n+12|0,i[e>>2]);break i;case 0:break e}k&&(r=p(16),t=i[n+12>>2],f=i[n+16>>2],f&&(i[f+4>>2]=i[f+4>>2]+1),i[r+4>>2]=f,i[r>>2]=t,f=i[e>>2],e=i[e+4>>2],e&&(i[e+4>>2]=i[e+4>>2]+1),i[r+12>>2]=e,i[r+8>>2]=f,i[k>>2]=r),e=i[24164],i[A>>2]=i[24163],i[A+4>>2]=e,i[A+8>>2]=i[24165]}A=l[n+32|0],(A|0)!=255&&(e=i[24199],i[n+72>>2]=i[24198],i[n+76>>2]=e,W[i[(n+72|0)+(A<<2)>>2]](n+71|0,n+12|0)),x2(i[n+48>>2]),u[n+67|0]<0&&Z(i[n+56>>2]),v=n+80|0;return}Q0(),H()}function dv(A,e,r,f,k){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0;var n=0,t=0,o=0,s=0,w=0,h=0,_=0,B=0,m=0,X=0;s=v-32|0,v=s,w=s+12|0,B=i[e>>2],m=r,r=0,t=v-16|0,v=t;i:{if(k>>>0<5)break i;for(n=k-4|0;;){if(o=r+f|0,h=l[o+1|0]<<8,_=l[o+2|0]<<16|l[o+3|0]<<24,(l[o|0]|h|_)==704662861|(_|(h|l[o|0]))==2771273)break i;if(r=r+1|0,(n|0)==(r|0))break}r=n}i:{e:{r:{if(r>>>0>=k>>>0){if(r=p(64),i[t+4>>2]=r,i[t+8>>2]=56,i[t+12>>2]=-2147483584,f=l[25972]|l[25973]<<8|(l[25974]<<16|l[25975]<<24),k=l[25968]|l[25969]<<8|(l[25970]<<16|l[25971]<<24),u[r|0]=k,u[r+1|0]=k>>>8,u[r+2|0]=k>>>16,u[r+3|0]=k>>>24,u[r+4|0]=f,u[r+5|0]=f>>>8,u[r+6|0]=f>>>16,u[r+7|0]=f>>>24,u[r+56|0]=0,f=l[26020]|l[26021]<<8|(l[26022]<<16|l[26023]<<24),k=l[26016]|l[26017]<<8|(l[26018]<<16|l[26019]<<24),u[r+48|0]=k,u[r+49|0]=k>>>8,u[r+50|0]=k>>>16,u[r+51|0]=k>>>24,u[r+52|0]=f,u[r+53|0]=f>>>8,u[r+54|0]=f>>>16,u[r+55|0]=f>>>24,f=l[26012]|l[26013]<<8|(l[26014]<<16|l[26015]<<24),k=l[26008]|l[26009]<<8|(l[26010]<<16|l[26011]<<24),u[r+40|0]=k,u[r+41|0]=k>>>8,u[r+42|0]=k>>>16,u[r+43|0]=k>>>24,u[r+44|0]=f,u[r+45|0]=f>>>8,u[r+46|0]=f>>>16,u[r+47|0]=f>>>24,f=l[26004]|l[26005]<<8|(l[26006]<<16|l[26007]<<24),k=l[26e3]|l[26001]<<8|(l[26002]<<16|l[26003]<<24),u[r+32|0]=k,u[r+33|0]=k>>>8,u[r+34|0]=k>>>16,u[r+35|0]=k>>>24,u[r+36|0]=f,u[r+37|0]=f>>>8,u[r+38|0]=f>>>16,u[r+39|0]=f>>>24,f=l[25996]|l[25997]<<8|(l[25998]<<16|l[25999]<<24),k=l[25992]|l[25993]<<8|(l[25994]<<16|l[25995]<<24),u[r+24|0]=k,u[r+25|0]=k>>>8,u[r+26|0]=k>>>16,u[r+27|0]=k>>>24,u[r+28|0]=f,u[r+29|0]=f>>>8,u[r+30|0]=f>>>16,u[r+31|0]=f>>>24,f=l[25988]|l[25989]<<8|(l[25990]<<16|l[25991]<<24),k=l[25984]|l[25985]<<8|(l[25986]<<16|l[25987]<<24),u[r+16|0]=k,u[r+17|0]=k>>>8,u[r+18|0]=k>>>16,u[r+19|0]=k>>>24,u[r+20|0]=f,u[r+21|0]=f>>>8,u[r+22|0]=f>>>16,u[r+23|0]=f>>>24,f=l[25980]|l[25981]<<8|(l[25982]<<16|l[25983]<<24),k=l[25976]|l[25977]<<8|(l[25978]<<16|l[25979]<<24),u[r+8|0]=k,u[r+9|0]=k>>>8,u[r+10|0]=k>>>16,u[r+11|0]=k>>>24,u[r+12|0]=f,u[r+13|0]=f>>>8,u[r+14|0]=f>>>16,u[r+15|0]=f>>>24,q(w,5,2006,t+4|0),u[t+15|0]>=0)break r;Z(i[t+4>>2]);break r}i[t+12>>2]=0,i[t+4>>2]=0,i[t+8>>2]=0,o=k+4|0;f:{if(!o){n=0;break f}if((k|0)<=-5)break e;n=p(o),o&&o0(n,0,o),X=n+o|0}r=r<<24|(r&65280)<<8|(r>>>8&65280|r>>>24),u[n|0]=r,u[n+1|0]=r>>>8,u[n+2|0]=r>>>16,u[n+3|0]=r>>>24,k&&x(n+4|0,f,k),ci(w,B,m,n,X-n|0,1165519206,0,0,0),Z(n)}v=t+16|0;break i}G0(),H()}i:{if(i[s+12>>2]!=i[26916]){b0(A,w,i[e>>2]);break i}e=i[24057],i[A>>2]=i[24056],i[A+4>>2]=e,i[A+8>>2]=i[24058]}u[s+31|0]<0&&Z(i[s+20>>2]),v=s+32|0}function cv(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,t=0,o=0,s=0,w=0,h=0,_=0,B=0,m=0,X=0,Q=0,V=0;if(f=v-160|0,v=f,i[f+84>>2]=0,i[f+56>>2]=72500,k=i[18128],i[f>>2]=k,i[i[k-12>>2]+f>>2]=i[18129],k=i[i[f>>2]-12>>2]+f|0,n=f+4|0,J0(k,n),u[k+80|0]=0,i[k+72>>2]=0,i[f+56>>2]=72500,i[f>>2]=72480,B=R0(n),i[B>>2]=71232,i[f+44>>2]=0,i[f+48>>2]=0,i[f+36>>2]=0,i[f+40>>2]=0,i[f+52>>2]=16,k=f+148|0,Y2(k,e,r),t=k,k=u[f+159|0],n=(k|0)<0,Y(f,n?i[f+148>>2]:t,n?i[f+152>>2]:k),u[f+159|0]<0&&Z(i[f+148>>2]),s=i[e+104>>2],m=i[e+108>>2],(s|0)!=(m|0))for(;;){e=f+148|0,s0(e,r),t=e,e=u[f+159|0],k=(e|0)<0,Y(f,k?i[f+148>>2]:t,k?i[f+152>>2]:e),u[f+159|0]<0&&Z(i[f+148>>2]),e=Y(f,27378,21),k=f+148|0,ie(k,s),t=e,n=k,e=u[f+159|0],k=(e|0)<0,Y(V0(Y(Y(Y(t,k?i[f+148>>2]:n,k?i[f+152>>2]:e),27419,1),32544,10),i[s+40>>2]),30260,9),u[f+159|0]<0&&Z(i[f+148>>2]);i:{if(e=i[s+44>>2],X=i[s+48>>2],(e|0)==(X|0))break i;for(;;){e:{h=V0(f,i[e>>2]),Q=G1(f+140|0,h);r:{if(l[Q|0]!=1)break r;n=i[i[h>>2]-12>>2]+h|0,_=i[n+4>>2],w=i[n+24>>2];f:{if(l[n+80|0]==1){k=l[n+76|0]|l[n+77|0]<<8|(l[n+78|0]<<16|l[n+79|0]<<24);break f}t=f+148|0,k=i[n+28>>2],i[t>>2]=k,(k|0)!=129576&&(i[k+4>>2]=i[k+4>>2]+1),k=c0(t,129760),k=W[i[i[k>>2]+28>>2]](k,32)|0,e2(t),u[n+76|0]=k,u[n+77|0]=k>>>8,u[n+78|0]=k>>>16,u[n+79|0]=k>>>24,u[n+80|0]=1}f:{if(!w||(o=i[n+12>>2],_=(_&176)==32?32809:32808,t=_-32808|0,(t|0)>0&&(W[i[i[w>>2]+48>>2]](w,32808,t)|0)!=(t|0)))break f;if((o|0)>=2){if(o>>>0>=2147483641)break e;t=((o|0)<=1?1:o)-1|0;A:{if(o>>>0>=12){V=t|7,o=p(V+1|0),i[f+156>>2]=V-2147483647,i[f+148>>2]=o,i[f+152>>2]=t;break A}u[f+159|0]=t,o=f+148|0}if(t&&o0(o,k,t),u[t+o|0]=0,k=W[i[i[w>>2]+48>>2]](w,u[f+159|0]<0?i[f+148>>2]:f+148|0,t)|0,u[f+159|0]<0&&Z(i[f+148>>2]),(k|0)!=(t|0))break f}if(k=32809-_|0,(k|0)>0&&(W[i[i[w>>2]+48>>2]](w,_,k)|0)!=(k|0))break f;i[n+12>>2]=0;break r}k=i[i[h>>2]-12>>2]+h|0,H1(k,i[k+16>>2]|5)}if(_1(Q),e=e+4|0,(X|0)!=(e|0))continue;break i}break}Q0(),H()}if(Y(f,42670,1),s=s+56|0,(m|0)==(s|0))break}e=i[f+52>>2];i:{e:{if(e&16){e=i[f+48>>2],r=i[f+28>>2],e>>>0<r>>>0&&(i[f+48>>2]=r,e=r),r=f+24|0;break e}if(!(e&8)){e=0,u[A+11|0]=0;break i}e=i[f+20>>2],r=f+12|0}e:{if(k=i[r>>2],e=e-k|0,e>>>0<2147483640){if(e>>>0>=11){n=e|7,r=p(n+1|0),i[A+8>>2]=n-2147483647,i[A>>2]=r,i[A+4>>2]=e,A=r;break e}if(u[A+11|0]=e,e)break e;e=0;break i}Q0(),H()}if(!e)break i;x(A,k,e)}u[A+e|0]=0,A=i[18127],i[f>>2]=A,i[i[A-12>>2]+f>>2]=i[18130],i[B>>2]=71232,u[f+47|0]<0&&Z(i[f+36>>2]),E0(B),y0(f+56|0),v=f+160|0}function bv(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,t=0,o=0,s=0,w=0,h=0,_=0,B=0,m=0,X=0,Q=0,V=0;if(f=v-160|0,v=f,i[f+84>>2]=0,i[f+56>>2]=72500,k=i[18128],i[f>>2]=k,i[i[k-12>>2]+f>>2]=i[18129],k=i[i[f>>2]-12>>2]+f|0,n=f+4|0,J0(k,n),u[k+80|0]=0,i[k+72>>2]=0,i[f+56>>2]=72500,i[f>>2]=72480,B=R0(n),i[B>>2]=71232,i[f+44>>2]=0,i[f+48>>2]=0,i[f+36>>2]=0,i[f+40>>2]=0,i[f+52>>2]=16,k=f+148|0,Y2(k,e,r),t=k,k=u[f+159|0],n=(k|0)<0,Y(f,n?i[f+148>>2]:t,n?i[f+152>>2]:k),u[f+159|0]<0&&Z(i[f+148>>2]),s=i[e+100>>2],m=i[e+104>>2],(s|0)!=(m|0))for(;;){e=f+148|0,s0(e,r),t=e,e=u[f+159|0],k=(e|0)<0,Y(f,k?i[f+148>>2]:t,k?i[f+152>>2]:e),u[f+159|0]<0&&Z(i[f+148>>2]),e=Y(f,27378,21),k=f+148|0,L1(k,i[s>>2]),t=e,n=k,e=u[f+159|0],k=(e|0)<0,Y(Y(Y(t,k?i[f+148>>2]:n,k?i[f+152>>2]:e),27419,1),30270,15),u[f+159|0]<0&&Z(i[f+148>>2]);i:{if(e=i[s+4>>2],X=i[s+8>>2],(e|0)==(X|0))break i;for(;;){e:{h=V0(f,i[e>>2]),Q=G1(f+140|0,h);r:{if(l[Q|0]!=1)break r;n=i[i[h>>2]-12>>2]+h|0,_=i[n+4>>2],w=i[n+24>>2];f:{if(l[n+80|0]==1){k=l[n+76|0]|l[n+77|0]<<8|(l[n+78|0]<<16|l[n+79|0]<<24);break f}t=f+148|0,k=i[n+28>>2],i[t>>2]=k,(k|0)!=129576&&(i[k+4>>2]=i[k+4>>2]+1),k=c0(t,129760),k=W[i[i[k>>2]+28>>2]](k,32)|0,e2(t),u[n+76|0]=k,u[n+77|0]=k>>>8,u[n+78|0]=k>>>16,u[n+79|0]=k>>>24,u[n+80|0]=1}f:{if(!w||(o=i[n+12>>2],_=(_&176)==32?32809:32808,t=_-32808|0,(t|0)>0&&(W[i[i[w>>2]+48>>2]](w,32808,t)|0)!=(t|0)))break f;if((o|0)>=2){if(o>>>0>=2147483641)break e;t=((o|0)<=1?1:o)-1|0;A:{if(o>>>0>=12){V=t|7,o=p(V+1|0),i[f+156>>2]=V-2147483647,i[f+148>>2]=o,i[f+152>>2]=t;break A}u[f+159|0]=t,o=f+148|0}if(t&&o0(o,k,t),u[t+o|0]=0,k=W[i[i[w>>2]+48>>2]](w,u[f+159|0]<0?i[f+148>>2]:f+148|0,t)|0,u[f+159|0]<0&&Z(i[f+148>>2]),(k|0)!=(t|0))break f}if(k=32809-_|0,(k|0)>0&&(W[i[i[w>>2]+48>>2]](w,_,k)|0)!=(k|0))break f;i[n+12>>2]=0;break r}k=i[i[h>>2]-12>>2]+h|0,H1(k,i[k+16>>2]|5)}if(_1(Q),e=e+4|0,(X|0)!=(e|0))continue;break i}break}Q0(),H()}if(Y(f,42670,1),s=s+16|0,(m|0)==(s|0))break}e=i[f+52>>2];i:{e:{if(e&16){e=i[f+48>>2],r=i[f+28>>2],e>>>0<r>>>0&&(i[f+48>>2]=r,e=r),r=f+24|0;break e}if(!(e&8)){e=0,u[A+11|0]=0;break i}e=i[f+20>>2],r=f+12|0}e:{if(k=i[r>>2],e=e-k|0,e>>>0<2147483640){if(e>>>0>=11){n=e|7,r=p(n+1|0),i[A+8>>2]=n-2147483647,i[A>>2]=r,i[A+4>>2]=e,A=r;break e}if(u[A+11|0]=e,e)break e;e=0;break i}Q0(),H()}if(!e)break i;x(A,k,e)}u[A+e|0]=0,A=i[18127],i[f>>2]=A,i[i[A-12>>2]+f>>2]=i[18130],i[B>>2]=71232,u[f+47|0]<0&&Z(i[f+36>>2]),E0(B),y0(f+56|0),v=f+160|0}function im(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0;var k=0,n=0,t=0,o=0,s=0,w=0,h=0,_=0,B=0,m=0;k=v-32|0,v=k,o=ir()|0;i:{if(!e){i[A+4>>2]=o,i[A>>2]=125368;break i}xf(k+4|0,e,k+16|0,r,f,0);e:{if(!i[k+4>>2]){r=f8(15042)|0,i[k+24>>2]=i[k+16>>2],f=E1(96400,k+24|0)|0,D4(o|0,r|0,f|0),f>>>0>=9&&o1(f|0),r>>>0>=9&&o1(r|0),f=0;r:{if(!e||(r=i[e>>2],!r))break r;r=i[r+120>>2],f=(r|0)>0?r:0}r=f8(10833)|0,i[k+24>>2]=f,f=E1(85368,k+24|0)|0,D4(o|0,r|0,f|0),f>>>0>=9&&o1(f|0),r>>>0>=9&&o1(r|0),r=0;r:{if(!e||(e=i[e>>2],!e))break r;e=i[e+124>>2],r=(e|0)>0?e:0}for(e=f8(4109)|0,i[k+24>>2]=r,f=E1(85368,k+24|0)|0,D4(o|0,e|0,f|0),f>>>0>=9&&o1(f|0),e>>>0>=9&&o1(e|0),f=i[i[i[k+16>>2]>>2]+120>>2],e=f8(18972)|0,i[k+24>>2]=f,f=E1(96392,k+24|0)|0,D4(o|0,e|0,f|0),f>>>0>=9&&o1(f|0),e>>>0>=9&&o1(e|0),f=i[i[i[k+16>>2]>>2]+116>>2],e=f8(15514)|0,i[k+24>>2]=f,f=E1(96384,k+24|0)|0,D4(o|0,e|0,f|0),f>>>0>=9&&o1(f|0),e>>>0>=9&&o1(e|0),e=r,w=p(32),r=w,f=i[12943],i[r>>2]=i[12942],i[r+4>>2]=f,r=i[12949],i[w+24>>2]=i[12948],i[w+28>>2]=r,r=i[12947],i[w+16>>2]=i[12946],i[w+20>>2]=r,r=i[12945],i[w+8>>2]=i[12944],i[w+12>>2]=r,h=nf()|0,r=0;;){f=i[r+w>>2];r:{if(!p5(i[k+16>>2],f))break r;s=ir()|0,n=f8(15894)|0,i[k+24>>2]=f,t=E1(96424,k+24|0)|0,D4(s|0,n|0,t|0),t>>>0>=9&&o1(t|0),n>>>0>=9&&o1(n|0),_=hi(i[k+16>>2],f,k),n=f8(15181)|0,i[k+24>>2]=i[k>>2],t=E1(85404,k+24|0)|0,D4(s|0,n|0,t|0),t>>>0>=9&&o1(t|0),n>>>0>=9&&o1(n|0),n=i[k>>2],i[k+28>>2]=_,i[k+24>>2]=G(e,n),n=E1(96432,k+24|0)|0,t=f8(18937)|0,D4(s|0,t|0,n|0),t>>>0>=9&&o1(t|0),n>>>0>=9&&o1(n|0),t=ks(i[k+16>>2],f),n=f8(10833)|0,i[k+24>>2]=t,t=E1(85368,k+24|0)|0,D4(s|0,n|0,t|0),t>>>0>=9&&o1(t|0),n>>>0>=9&&o1(n|0),t=ns(i[k+16>>2],f),n=f8(4109)|0,i[k+24>>2]=t,t=E1(85368,k+24|0)|0,D4(s|0,n|0,t|0),t>>>0>=9&&o1(t|0),n>>>0>=9&&o1(n|0),n=Ws(i[k+16>>2],f),f=f8(9910)|0,i[k+24>>2]=n,n=E1(85368,k+24|0)|0,D4(s|0,f|0,n|0),n>>>0>=9&&o1(n|0),f>>>0>=9&&o1(f|0),n=s>>>0<9,n||x_(s|0),i[k+24>>2]=s,i[k+20>>2]=0;f:{if(u[107788]&1){f=i[26946];break f}f=z_(2,96440,0)|0,u[107788]=1,i[26946]=f}if(+H_(f|0,h|0,10839,k+20|0,k+24|0),f=i[k+20>>2],f&&M_(f|0),n)break r;o1(s|0)}if(r=r+4|0,(r|0)==32)break}break e}if(e=p(12),i[e+8>>2]=i[k+12>>2],r=i[k+8>>2],i[e>>2]=i[k+4>>2],i[e+4>>2]=r,i[k+24>>2]=e,B=A,m=E1(96260,k+24|0)|0,i[B+4>>2]=m,i[A>>2]=125368,o>>>0<9)break i;o1(o|0);break i}e=f8(5096)|0,D4(o|0,e|0,h|0),e>>>0>=9&&o1(e|0),i[A+4>>2]=o,i[A>>2]=125368,h>>>0>=9&&o1(h|0),Z(w)}v=k+32|0}function em(A,e,r,f,k,n,t,o){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,t=t|0,o=o|0;var s=0,w=0,h=0,_=0,B=0,m=0,X=0,Q=0,V=0,F=0,I=0;n=v-32|0,v=n,k=p(172),i[k+4>>2]=0,i[k+8>>2]=0,i[k>>2]=94812,o0(k+16|0,0,80),e=i[k+4>>2],f=e+1|0,i[k+4>>2]=f,i[k+104>>2]=0,i[k+108>>2]=0,i[k+36>>2]=1,i[k+40>>2]=1,u[k+24|0]=1,g[k+22>>1]=2,g[k+18>>1]=2,g[k+20>>1]=2,i[k+112>>2]=0,i[k+116>>2]=4740,i[k+140>>2]=0,i[k+144>>2]=0,i[k+128>>2]=99,i[k+132>>2]=99,i[k+120>>2]=0,i[k+124>>2]=0,i[k+12>>2]=95160,i[k+148>>2]=0,i[k+152>>2]=0,h=k+140|0,i[k+136>>2]=h,i[k+156>>2]=0,i[k+160>>2]=0,i[k+164>>2]=0,i[k+168>>2]=0,i[k+4>>2]=e,e=i[k+8>>2],_=k+12|0,i[k+96>>2]=_,i[k+8>>2]=e+1,i[k+100>>2]=k,f||(W[i[i[k>>2]+8>>2]](k),y(k));i:{e:{if(e=i[r>>2],t=i[e+120>>2]-12|0,t>>>0>=4){e=i[26922],i[A>>2]=i[26921],i[A+4>>2]=e,e=A+8|0;r:{if(u[107703]>=0){r=i[26924],i[e>>2]=i[26923],i[e+4>>2]=r,i[e+8>>2]=i[26925];break r}T(e,i[26923],i[26924])}u[A+20|0]=1;break e}if(f=i[e+108>>2],X=i[e+112>>2],e=X,i[_+120>>2]=i[(t<<2)+58304>>2],i[_+116>>2]=1,i[_+112>>2]=e,i[_+108>>2]=f,T0(n+8|0,_,10,f,e,j0(i[r>>2],10),o),i[n+8>>2]){if(e=i[n+12>>2],i[A>>2]=i[n+8>>2],i[A+4>>2]=e,e=A+8|0,u[n+27|0]>=0){r=i[n+20>>2],i[e>>2]=i[n+16>>2],i[e+4>>2]=r,i[e+8>>2]=i[n+24>>2],u[A+20|0]=1;break e}if(T(e,i[n+16>>2],i[n+20>>2]),e=u[n+27|0],u[A+20|0]=1,(e|0)>=0)break e;Z(i[n+16>>2]);break e}u[n+27|0]<0&&Z(i[n+16>>2]),t=0;r:{f:{if(e=i[r>>2],r=i[e+128>>2],!r)break f;for(f=e+128|0,e=f;o=i[r+16>>2]<10,e=o?e:r,r=i[(o?4:0)+r>>2],!!r;);if((e|0)==(f|0))break f;if(B=0,i[e+16>>2]>10)break r;V=i[e+44>>2],B=i[e+56>>2];break r}B=0}r=i[h>>2],f=0;r:{if(!r)break r;for(e=h;f=i[r+16>>2]<10,e=f?e:r,r=i[(f?4:0)+r>>2],!!r;);if((e|0)==(h|0)){f=0;break r}if(f=0,i[e+16>>2]>10)break r;t=i[e+56>>2],f=i[e+44>>2]}r:{if(!X||(e=t>>>0<B>>>0?t:B,!e))break r;for(e=e-1|0,r=(e>>>1|0)+1|0,F=r&-4,Q=r&3,I=e>>>0<6;;){if(e=G(t,m)+f|0,h=G(B,m)+V|0,r=0,o=0,!I)for(;s=e+r|0,w=r+h|0,u[s|0]=l[w+1|0],u[s+1|0]=l[w|0],s=r|2,w=s+e|0,s=s+h|0,u[w|0]=l[s+1|0],u[w+1|0]=l[s|0],s=r|4,w=s+e|0,s=s+h|0,u[w|0]=l[s+1|0],u[w+1|0]=l[s|0],s=r|6,w=s+e|0,s=s+h|0,u[w|0]=l[s+1|0],u[w+1|0]=l[s|0],r=r+8|0,o=o+4|0,(F|0)!=(o|0););if(o=0,Q)for(;s=e+r|0,w=r+h|0,u[s|0]=l[w+1|0],u[s+1|0]=l[w|0],r=r+2|0,o=o+1|0,(Q|0)!=(o|0););if(m=m+1|0,(m|0)==(X|0))break}}u[A+20|0]=0,i[A+4>>2]=k,i[A>>2]=_;break i}if(A=i[k+4>>2],i[k+4>>2]=A-1,A)break i;W[i[i[k>>2]+8>>2]](k),y(k)}v=n+32|0}function rm(A,e,r,f,k,n,t){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,t=t|0;var o=0,s=0,w=0,h=0,_=0,B=0,m=0,X=0;s=v-48|0,v=s,o=i[e>>2],m=i[o+48>>2],_=i[o+52>>2],_&&(i[_+4>>2]=i[_+4>>2]+1);i:{e:{r:{if(w=h2(f),w>>>0<2147483640){f:{A:{if(w>>>0>=11){h=w|7,o=p(h+1|0),i[s+8>>2]=h-2147483647,i[s>>2]=o,i[s+4>>2]=w;break A}if(u[s+11|0]=w,o=s,!w)break f}if(!w)break f;x(o,f,w)}u[o+w|0]=0,f=v+-64|0,v=f,Z8(f+56|0,m,1835625829),h=i[f+56>>2],o=h,u[o+164|0]=1,i[o+100>>2]=i[o+100>>2]&-2|1;f:{if(o=h2(r),o>>>0<2147483640){A:{k:{if(o>>>0>=11){B=o|7,w=p(B+1|0),i[f+52>>2]=B-2147483647,i[f+44>>2]=w,i[f+48>>2]=o;break k}if(u[f+55|0]=o,w=f+44|0,!o)break A}if(!o)break A;x(w,r,o)}u[o+w|0]=0,r=h+128|0;A:{if((r|0)==(f+44|0))break A;if(o=u[f+55|0],u[h+139|0]>=0){if((o|0)>=0){o=i[f+48>>2],i[r>>2]=i[f+44>>2],i[r+4>>2]=o,i[r+8>>2]=i[f+52>>2];break A}M1(r,i[f+44>>2],i[f+48>>2]);break A}h=r,r=(o|0)<0,O1(h,r?i[f+44>>2]:f+44|0,r?i[f+48>>2]:o)}u[f+55|0]<0&&Z(i[f+44>>2]),B=i[i[f+56>>2]+104>>2],i[f+16>>2]=i[s+8>>2],r=i[s+4>>2],i[f+8>>2]=i[s>>2],i[f+12>>2]=r,i[s>>2]=0,i[s+4>>2]=0,i[s+8>>2]=0,r=f+24|0,h=f+8|0,w=0,o=v-32|0,v=o,i[o+8>>2]=0,i[o>>2]=0,i[o+4>>2]=0;A:{k:{if(n){if((n|0)<0)break k;w=p(n),n&&o0(w,0,n),X=n+w|0,i[o+8>>2]=X,i[o+4>>2]=X,i[o>>2]=w}n&&x(w,k,n),w=i[f+56>>2],k=w+140|0;n:{if((k|0)==(h|0))break n;if(n=u[h+11|0],u[w+151|0]>=0){if((n|0)>=0){n=i[h+4>>2],i[k>>2]=i[h>>2],i[k+4>>2]=n,i[k+8>>2]=i[h+8>>2];break n}M1(k,i[h>>2],i[h+4>>2]);break n}w=k,k=(n|0)<0,O1(w,k?i[h>>2]:h,k?i[h+4>>2]:n)}rr(o+12|0,i[m+68>>2],i[i[f+56>>2]+104>>2],o,0),u[o+31|0]<0&&Z(i[o+20>>2]),k=i[26917],i[r>>2]=i[26916],i[r+4>>2]=k,r=r+8|0;n:{if(u[107683]>=0){k=i[26919],i[r>>2]=i[26918],i[r+4>>2]=k,i[r+8>>2]=i[26920];break n}T(r,i[26918],i[26919])}r=i[o>>2],r&&(i[o+4>>2]=r,Z(r)),v=o+32|0;break A}G0(),H()}u[f+43|0]<0&&Z(i[f+32>>2]),u[f+19|0]<0&&Z(i[f+8>>2]),u[s+32|0]=0,i[s+12>>2]=B,r=i[f+60>>2];A:{if(!r||(k=i[r+4>>2],i[r+4>>2]=k-1,k))break A;W[i[i[r>>2]+8>>2]](r),y(r)}v=f- -64|0;break f}Q0(),H()}u[s+11|0]<0&&Z(i[s>>2]);f:{if(!_||(r=i[_+4>>2],i[_+4>>2]=r-1,r))break f;W[i[i[_>>2]+8>>2]](_),y(_)}if(r=l[s+32|0],!(r|!t)){i[t>>2]=1;break r}f:switch(r|0){default:_2(),H();case 0:break r;case 1:break f}if(b0(A,s+12|0,i[e>>2]),A=l[s+32|0],(A|0)==255)break i;break e}Q0(),H()}e=i[24057],i[A>>2]=i[24056],i[A+4>>2]=e,i[A+8>>2]=i[24058],A=0}e=i[24187],i[s+40>>2]=i[24186],i[s+44>>2]=e,W[i[(s+40|0)+(A<<2)>>2]](s+39|0,s+12|0)}v=s+48|0}function fm(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0;var k=0,n=0,t=0,o=0,s=0,w=0;f=v-32|0,v=f,z2(f,e,r),u[f+19|0]<0&&Z(i[f+8>>2]),k=l[e+97|0];i:{if(k>>>0>=2){t1(A,e,15897);break i}e:{if((k|0)==1){s=e,w=Y4(r),i[s+104>>2]=w,i[e+108>>2]=l0,s=e,w=Y4(r),i[s+112>>2]=w,i[e+116>>2]=l0,s=e,w=C0(r),i[s+120>>2]=w,k=Y4(r),n=l0;break e}s=e,w=C0(r),i[s+104>>2]=w,i[e+108>>2]=0,s=e,w=C0(r),i[s+112>>2]=w,i[e+116>>2]=0,s=e,w=C0(r),i[s+120>>2]=w,k=C0(r),n=0}if(i[e+128>>2]=k,i[e+132>>2]=n,s=e,w=C0(r),i[s+136>>2]=w,s=e,w=o2(r),g[s+140>>1]=w,k=i[r+16>>2],n=k>>>0>=2?2:k,k=i[r+8>>2],k&&c1(k,n),t=i[r>>2],o=W[i[i[t>>2]+8>>2]](t)|0,k=l0,o=n+o|0,k=o>>>0<n>>>0?k+1|0:k,W[i[i[t>>2]+20>>2]](t,o,k)|0,k=i[r+16>>2]-n|0,i[r+16>>2]=k,n=k>>>0>=8?8:k,k=i[r+8>>2],k&&c1(k,n),t=i[r>>2],o=W[i[i[t>>2]+8>>2]](t)|0,k=l0,o=n+o|0,k=o>>>0<n>>>0?k+1|0:k,W[i[i[t>>2]+20>>2]](t,o,k)|0,i[r+16>>2]=i[r+16>>2]-n,s=e,w=C0(r),i[s+144>>2]=w,s=e,w=C0(r),i[s+148>>2]=w,s=e,w=C0(r),i[s+152>>2]=w,s=e,w=C0(r),i[s+156>>2]=w,s=e,w=C0(r),i[s+160>>2]=w,s=e,w=C0(r),i[s+164>>2]=w,s=e,w=C0(r),i[s+168>>2]=w,s=e,w=C0(r),i[s+172>>2]=w,s=e,w=C0(r),i[s+176>>2]=w,k=i[r+16>>2],n=k>>>0>=4?4:k,k=i[r+8>>2],k&&c1(k,n),t=i[r>>2],o=W[i[i[t>>2]+8>>2]](t)|0,k=l0,o=n+o|0,k=o>>>0<n>>>0?k+1|0:k,W[i[i[t>>2]+20>>2]](t,o,k)|0,k=i[r+16>>2]-n|0,i[r+16>>2]=k,n=k>>>0>=4?4:k,k=i[r+8>>2],k&&c1(k,n),t=i[r>>2],o=W[i[i[t>>2]+8>>2]](t)|0,k=l0,o=n+o|0,k=o>>>0<n>>>0?k+1|0:k,W[i[i[t>>2]+20>>2]](t,o,k)|0,k=i[r+16>>2]-n|0,i[r+16>>2]=k,n=k>>>0>=4?4:k,k=i[r+8>>2],k&&c1(k,n),t=i[r>>2],o=W[i[i[t>>2]+8>>2]](t)|0,k=l0,o=n+o|0,k=o>>>0<n>>>0?k+1|0:k,W[i[i[t>>2]+20>>2]](t,o,k)|0,k=i[r+16>>2]-n|0,i[r+16>>2]=k,n=k>>>0>=4?4:k,k=i[r+8>>2],k&&c1(k,n),t=i[r>>2],o=W[i[i[t>>2]+8>>2]](t)|0,k=l0,o=n+o|0,k=o>>>0<n>>>0?k+1|0:k,W[i[i[t>>2]+20>>2]](t,o,k)|0,k=i[r+16>>2]-n|0,i[r+16>>2]=k,n=k>>>0>=4?4:k,k=i[r+8>>2],k&&c1(k,n),t=i[r>>2],o=W[i[i[t>>2]+8>>2]](t)|0,k=l0,o=n+o|0,k=o>>>0<n>>>0?k+1|0:k,W[i[i[t>>2]+20>>2]](t,o,k)|0,k=i[r+16>>2]-n|0,i[r+16>>2]=k,n=k>>>0>=4?4:k,k=i[r+8>>2],k&&c1(k,n),t=i[r>>2],o=W[i[i[t>>2]+8>>2]](t)|0,k=l0,o=n+o|0,k=o>>>0<n>>>0?k+1|0:k,W[i[i[t>>2]+20>>2]](t,o,k)|0,i[r+16>>2]=i[r+16>>2]-n,s=e,w=C0(r),i[s+180>>2]=w,l[r+20|0]){if(u[f+20|0]=0,u[f+31|0]=0,q(A,2,100,f+20|0),u[f+31|0]>=0)break i;Z(i[f+20>>2]);break i}if(e=i[26917],i[A>>2]=i[26916],i[A+4>>2]=e,A=A+8|0,u[107683]>=0){e=i[26919],i[A>>2]=i[26918],i[A+4>>2]=e,i[A+8>>2]=i[26920];break i}T(A,i[26918],i[26919])}v=f+32|0}function lr(A,e,r){var f=0,k=0;f=v-656|0,v=f,e=e?10120:6895,l[A|0]&&(i[f+644>>2]=u[A+1|0],i[f+640>>2]=e,k0(r,38139,f+640|0),i[f+628>>2]=u[A+2|0],i[f+624>>2]=e,k0(r,39373,f+624|0),k=i[A+4>>2]-1|0,k>>>0<=3?k=i[(k<<2)+63880>>2]:k=26492,i[f+612>>2]=k,i[f+608>>2]=e,k0(r,33042,f+608|0),i[f+592>>2]=e,k0(r,29948,f+592|0),i[f+576>>2]=u[A+8|0],k0(r,17911,f+576|0),k0(r,26299,0),i[f+560>>2]=u[A+9|0],k0(r,17911,f+560|0),k0(r,26299,0),i[f+544>>2]=u[A+10|0],k0(r,17911,f+544|0),k0(r,26299,0),i[f+528>>2]=u[A+11|0],k0(r,17911,f+528|0),k0(r,26299,0),i[f+512>>2]=u[A+12|0],k0(r,17911,f+512|0),k0(r,26299,0),i[f+496>>2]=u[A+13|0],k0(r,17911,f+496|0),k0(r,26299,0),i[f+480>>2]=u[A+14|0],k0(r,17911,f+480|0),k0(r,26299,0),i[f+464>>2]=u[A+15|0],k0(r,17911,f+464|0),k0(r,26299,0),i[f+448>>2]=u[A+16|0],k0(r,17911,f+448|0),k0(r,26299,0),i[f+432>>2]=u[A+17|0],k0(r,17911,f+432|0),k0(r,26299,0),i[f+416>>2]=u[A+18|0],k0(r,17911,f+416|0),k0(r,26299,0),i[f+400>>2]=u[A+19|0],k0(r,17911,f+400|0),k0(r,26299,0),i[f+384>>2]=u[A+20|0],k0(r,17911,f+384|0),k0(r,26299,0),i[f+368>>2]=u[A+21|0],k0(r,17911,f+368|0),k0(r,26299,0),i[f+352>>2]=u[A+22|0],k0(r,17911,f+352|0),k0(r,26299,0),i[f+336>>2]=u[A+23|0],k0(r,17911,f+336|0),k0(r,26299,0),i[f+320>>2]=u[A+24|0],k0(r,17911,f+320|0),k0(r,26299,0),i[f+304>>2]=u[A+25|0],k0(r,17911,f+304|0),k0(r,26299,0),i[f+288>>2]=u[A+26|0],k0(r,17911,f+288|0),k0(r,26299,0),i[f+272>>2]=u[A+27|0],k0(r,17911,f+272|0),k0(r,26299,0),i[f+256>>2]=u[A+28|0],k0(r,17911,f+256|0),k0(r,26299,0),i[f+240>>2]=u[A+29|0],k0(r,17911,f+240|0),k0(r,26299,0),i[f+224>>2]=u[A+30|0],k0(r,17911,f+224|0),k0(r,26299,0),i[f+208>>2]=u[A+31|0],k0(r,17911,f+208|0),k0(r,26299,0),i[f+192>>2]=u[A+32|0],k0(r,17911,f+192|0),k0(r,26299,0),i[f+176>>2]=u[A+33|0],k0(r,17911,f+176|0),k0(r,26299,0),i[f+160>>2]=u[A+34|0],k0(r,17911,f+160|0),k0(r,26299,0),i[f+144>>2]=u[A+35|0],k0(r,17911,f+144|0),k0(r,26299,0),i[f+128>>2]=u[A+36|0],k0(r,17911,f+128|0),k0(r,26299,0),i[f+112>>2]=u[A+37|0],k0(r,17911,f+112|0),k0(r,26299,0),i[f+96>>2]=u[A+38|0],k0(r,17911,f+96|0),k0(r,26299,0),i[f+80>>2]=u[A+39|0],k0(r,17911,f+80|0),k0(r,42323,0),i[f+68>>2]=u[A+40|0],i[f+64>>2]=e,k0(r,35742,f- -64|0),i[f+52>>2]=u[A+41|0],i[f+48>>2]=e,k0(r,35779,f+48|0),i[f+36>>2]=u[A+42|0],i[f+32>>2]=e,k0(r,34906,f+32|0),i[f+20>>2]=u[A+43|0],i[f+16>>2]=e,k0(r,34866,f+16|0)),l[A+44|0]&&(A=i[A+48>>2],i[f+4>>2]=A,i[f>>2]=e,t0[f+8>>3]=U(U(A|0)/U(30)),k0(r,42437,f)),v=f+656|0}function p9(A,e,r){var f=0,k=0,n=0,t=0,o=0,s=0;i:{if(i[A+64>>2])break i;f=3057;e:{r:{f:{A:{k:{n:{t:{u:{o:{l:{s:{w:{_:{h:{B:{v:{Z:{G:switch(t=r&-3,t-1|0){case 0:case 16:break Z;case 23:break B;case 27:break o;case 1:case 2:case 3:case 5:case 6:case 9:case 10:case 13:case 14:case 17:case 18:case 21:case 22:case 25:case 26:break r;case 15:break e;case 4:case 20:break s;case 7:break v;case 8:case 24:break _;case 11:break l;case 12:case 28:break t;case 19:break w;default:break G}G:switch(t-48|0){case 1:case 2:case 3:break r;case 0:break e;case 4:break w;default:break G}G:switch(t-56|0){case 0:break h;case 4:break u;case 1:case 2:case 3:break r;default:break G}G:switch(t-80|0){case 0:break n;case 4:break A;case 1:case 2:case 3:break r;default:break G}G:switch(t-112|0){case 0:break n;case 4:break A;case 1:case 2:case 3:break r;default:break G}switch(t-120|0){case 0:break k;case 4:break f;default:break r}}f=19124;break e}f=7760;break e}f=26305;break e}f=26302;break e}f=26308;break e}f=18341;break e}f=18365;break e}f=18344;break e}f=18388;break e}f=18384;break e}f=18392;break e}f=1766;break e}f=2996;break e}f=2951;break e}f=2955;break e}f=0}if(t=f,!f)break i;o=v-16|0,v=o;e:{r:{if(!yi(18396,u[f|0])){i[31324]=28;break r}if(k=2,yi(t,43)||(k=l[t|0]!=114),f=yi(t,120)?k|128:k,f=yi(t,101)?f|524288:f,k=f,s=f|64,f=l[t|0],k=(f|0)==114?k:s,k=(f|0)==119?k|512:k,i[o>>2]=438,i[o+4>>2]=0,k=E_(-100,e|0,((f|0)==97?k|1024:k)|32768,o|0)|0,k>>>0>=4294963201&&(i[31324]=0-k,k=-1),(k|0)<0)break e;n=v-32|0,v=n;f:{A:{k:{if(!yi(18396,u[t|0])){i[31324]=28;break k}if(f=y2(1176),f)break A}e=0;break f}Ae(f,0,144),yi(t,43)||(i[f>>2]=l[t|0]==114?8:4);A:{if(l[t|0]!=97){e=i[f>>2];break A}e=Q7(k|0,3,0)|0,e&1024||(e=e|1024,i[n+16>>2]=e,i[n+20>>2]=e>>31,Q7(k|0,4,n+16|0)|0),e=i[f>>2]|128,i[f>>2]=e}i[f+80>>2]=-1,i[f+48>>2]=1024,i[f+60>>2]=k,i[f+44>>2]=f+152;A:{if(e&8||(i[n>>2]=n+24,i[n+4>>2]=0,I_(k|0,21523,n|0)|0))break A;i[f+80>>2]=10}i[f+40>>2]=1950,i[f+36>>2]=1949,i[f+32>>2]=1956,i[f+12>>2]=1948,l[125313]||(i[f+76>>2]=-1),e=i[31327],i[f+56>>2]=e,e&&(i[e+52>>2]=f),i[31327]=f,e=f}if(v=n+32|0,n=e,n)break e;g7(k|0)|0}n=0}v=o+16|0,i[A+64>>2]=n,e=0;e:{if(!n)break e;i[A+88>>2]=r,i[A+92>>2]==34&&(i[n+80>>2]=-1,i[n+48>>2]=0,i[n>>2]=i[n>>2]|64,i[A+92>>2]=0);r:{if(!(r&2)||(i[A+92>>2]=0,!X3(i[A+64>>2],0,0,2)))break r;LA(i[A+64>>2]),i[A+64>>2]=0,e=0;break e}e=A}k=e}return k}function Am(A,e,r,f,k,n){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0;var t=0,o=0,s=0,w=0,h=0;n=v-16|0,v=n,w=i[r+4>>2],t=i[k>>2],s=i[r>>2],r=t+s|0;i:{if(w-r>>>0<(f|0)/8<<2>>>0){if(e=p(56),i[n+4>>2]=e,i[n+8>>2]=48,i[n+12>>2]=-2147483592,r=l[9112]|l[9113]<<8|(l[9114]<<16|l[9115]<<24),f=l[9108]|l[9109]<<8|(l[9110]<<16|l[9111]<<24),u[e|0]=f,u[e+1|0]=f>>>8,u[e+2|0]=f>>>16,u[e+3|0]=f>>>24,u[e+4|0]=r,u[e+5|0]=r>>>8,u[e+6|0]=r>>>16,u[e+7|0]=r>>>24,u[e+48|0]=0,r=l[9152]|l[9153]<<8|(l[9154]<<16|l[9155]<<24),f=l[9148]|l[9149]<<8|(l[9150]<<16|l[9151]<<24),u[e+40|0]=f,u[e+41|0]=f>>>8,u[e+42|0]=f>>>16,u[e+43|0]=f>>>24,u[e+44|0]=r,u[e+45|0]=r>>>8,u[e+46|0]=r>>>16,u[e+47|0]=r>>>24,r=l[9144]|l[9145]<<8|(l[9146]<<16|l[9147]<<24),f=l[9140]|l[9141]<<8|(l[9142]<<16|l[9143]<<24),u[e+32|0]=f,u[e+33|0]=f>>>8,u[e+34|0]=f>>>16,u[e+35|0]=f>>>24,u[e+36|0]=r,u[e+37|0]=r>>>8,u[e+38|0]=r>>>16,u[e+39|0]=r>>>24,r=l[9136]|l[9137]<<8|(l[9138]<<16|l[9139]<<24),f=l[9132]|l[9133]<<8|(l[9134]<<16|l[9135]<<24),u[e+24|0]=f,u[e+25|0]=f>>>8,u[e+26|0]=f>>>16,u[e+27|0]=f>>>24,u[e+28|0]=r,u[e+29|0]=r>>>8,u[e+30|0]=r>>>16,u[e+31|0]=r>>>24,r=l[9128]|l[9129]<<8|(l[9130]<<16|l[9131]<<24),f=l[9124]|l[9125]<<8|(l[9126]<<16|l[9127]<<24),u[e+16|0]=f,u[e+17|0]=f>>>8,u[e+18|0]=f>>>16,u[e+19|0]=f>>>24,u[e+20|0]=r,u[e+21|0]=r>>>8,u[e+22|0]=r>>>16,u[e+23|0]=r>>>24,r=l[9120]|l[9121]<<8|(l[9122]<<16|l[9123]<<24),f=l[9116]|l[9117]<<8|(l[9118]<<16|l[9119]<<24),u[e+8|0]=f,u[e+9|0]=f>>>8,u[e+10|0]=f>>>16,u[e+11|0]=f>>>24,u[e+12|0]=r,u[e+13|0]=r>>>8,u[e+14|0]=r>>>16,u[e+15|0]=r>>>24,q(A,2,136,n+4|0),u[n+15|0]>=0)break i;Z(i[n+4>>2]);break i}o=l[r|0],w=l[r+1|0];e:{if((f|0)==32){h=l[r+3|0],r=l[r+2|0],i[k>>2]=t+4,i[e+4>>2]=w<<16|o<<24|r<<8|h,t=i[k>>2],r=t+s|0,r=l[r|0]|l[r+1|0]<<8|(l[r+2|0]<<16|l[r+3|0]<<24),i[k>>2]=t+4,i[e+8>>2]=r<<24|(r&65280)<<8|(r>>>8&65280|r>>>24),r=i[k>>2],t=s+r|0,o=l[t+1|0]<<16|l[t|0]<<24|l[t+2|0]<<8,t=t+3|0,w=4;break e}i[k>>2]=t+2,i[e+4>>2]=(w<<16|o<<24)>>16,r=i[k>>2],t=r+s|0,o=l[t+1|0],t=l[t|0],i[k>>2]=r+2,i[e+8>>2]=(o<<16|t<<24)>>16,r=i[k>>2],o=s+r|0,t=o+1|0,o=l[o|0]<<8,w=2}t=l[t|0],i[k>>2]=r+w,i[e+12>>2]=t|o,o=i[k>>2],s=o+s|0,t=l[s|0],r=l[s+1|0];e:{if((f|0)==32){f=r<<16|t<<24|l[s+2|0]<<8,r=l[s+3|0],w=4;break e}f=t<<8,w=2}if(i[k>>2]=w+o,i[e+16>>2]=r&255|f,e=i[26917],i[A>>2]=i[26916],i[A+4>>2]=e,A=A+8|0,u[107683]>=0){e=i[26919],i[A>>2]=i[26918],i[A+4>>2]=e,i[A+8>>2]=i[26920];break i}T(A,i[26918],i[26919])}v=n+16|0}function km(A,e,r,f,k,n){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0;var t=0,o=0,s=0,w=0,h=0;n=v-16|0,v=n,w=i[r+4>>2],t=i[k>>2],s=i[r>>2],r=t+s|0;i:{if(w-r>>>0<(f|0)/8<<2>>>0){if(e=p(48),i[n+4>>2]=e,i[n+8>>2]=46,i[n+12>>2]=-2147483600,r=l[9065]|l[9066]<<8|(l[9067]<<16|l[9068]<<24),f=l[9061]|l[9062]<<8|(l[9063]<<16|l[9064]<<24),u[e|0]=f,u[e+1|0]=f>>>8,u[e+2|0]=f>>>16,u[e+3|0]=f>>>24,u[e+4|0]=r,u[e+5|0]=r>>>8,u[e+6|0]=r>>>16,u[e+7|0]=r>>>24,u[e+46|0]=0,r=l[9103]|l[9104]<<8|(l[9105]<<16|l[9106]<<24),f=l[9099]|l[9100]<<8|(l[9101]<<16|l[9102]<<24),u[e+38|0]=f,u[e+39|0]=f>>>8,u[e+40|0]=f>>>16,u[e+41|0]=f>>>24,u[e+42|0]=r,u[e+43|0]=r>>>8,u[e+44|0]=r>>>16,u[e+45|0]=r>>>24,r=l[9097]|l[9098]<<8|(l[9099]<<16|l[9100]<<24),f=l[9093]|l[9094]<<8|(l[9095]<<16|l[9096]<<24),u[e+32|0]=f,u[e+33|0]=f>>>8,u[e+34|0]=f>>>16,u[e+35|0]=f>>>24,u[e+36|0]=r,u[e+37|0]=r>>>8,u[e+38|0]=r>>>16,u[e+39|0]=r>>>24,r=l[9089]|l[9090]<<8|(l[9091]<<16|l[9092]<<24),f=l[9085]|l[9086]<<8|(l[9087]<<16|l[9088]<<24),u[e+24|0]=f,u[e+25|0]=f>>>8,u[e+26|0]=f>>>16,u[e+27|0]=f>>>24,u[e+28|0]=r,u[e+29|0]=r>>>8,u[e+30|0]=r>>>16,u[e+31|0]=r>>>24,r=l[9081]|l[9082]<<8|(l[9083]<<16|l[9084]<<24),f=l[9077]|l[9078]<<8|(l[9079]<<16|l[9080]<<24),u[e+16|0]=f,u[e+17|0]=f>>>8,u[e+18|0]=f>>>16,u[e+19|0]=f>>>24,u[e+20|0]=r,u[e+21|0]=r>>>8,u[e+22|0]=r>>>16,u[e+23|0]=r>>>24,r=l[9073]|l[9074]<<8|(l[9075]<<16|l[9076]<<24),f=l[9069]|l[9070]<<8|(l[9071]<<16|l[9072]<<24),u[e+8|0]=f,u[e+9|0]=f>>>8,u[e+10|0]=f>>>16,u[e+11|0]=f>>>24,u[e+12|0]=r,u[e+13|0]=r>>>8,u[e+14|0]=r>>>16,u[e+15|0]=r>>>24,q(A,2,136,n+4|0),u[n+15|0]>=0)break i;Z(i[n+4>>2]);break i}o=l[r|0],w=l[r+1|0];e:{if((f|0)==32){h=l[r+3|0],r=l[r+2|0],i[k>>2]=t+4,i[e+4>>2]=w<<16|o<<24|r<<8|h,t=i[k>>2],r=t+s|0,r=l[r|0]|l[r+1|0]<<8|(l[r+2|0]<<16|l[r+3|0]<<24),i[k>>2]=t+4,i[e+8>>2]=r<<24|(r&65280)<<8|(r>>>8&65280|r>>>24),r=i[k>>2],t=s+r|0,o=l[t+1|0]<<16|l[t|0]<<24|l[t+2|0]<<8,t=t+3|0,w=4;break e}i[k>>2]=t+2,i[e+4>>2]=(w<<16|o<<24)>>16,r=i[k>>2],t=r+s|0,o=l[t+1|0],t=l[t|0],i[k>>2]=r+2,i[e+8>>2]=(o<<16|t<<24)>>16,r=i[k>>2],o=s+r|0,t=o+1|0,o=l[o|0]<<8,w=2}t=l[t|0],i[k>>2]=r+w,i[e+12>>2]=t|o,o=i[k>>2],s=o+s|0,t=l[s|0],r=l[s+1|0];e:{if((f|0)==32){f=r<<16|t<<24|l[s+2|0]<<8,r=l[s+3|0],w=4;break e}f=t<<8,w=2}if(i[k>>2]=w+o,i[e+16>>2]=r&255|f,e=i[26917],i[A>>2]=i[26916],i[A+4>>2]=e,A=A+8|0,u[107683]>=0){e=i[26919],i[A>>2]=i[26918],i[A+4>>2]=e,i[A+8>>2]=i[26920];break i}T(A,i[26918],i[26919])}v=n+16|0}function nm(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,t=0,o=0,s=0,w=0,h=0,_=0,B=0,m=0,X=0,Q=0,V=0;if(f=v-160|0,v=f,i[f+92>>2]=0,i[f+64>>2]=72500,n=i[18128],i[f+8>>2]=n,k=i[n-12>>2],n=f+8|0,i[k+n>>2]=i[18129],k=n+i[i[f+8>>2]-12>>2]|0,o=f+12|0,J0(k,o),u[k+80|0]=0,i[k+72>>2]=0,i[f+64>>2]=72500,i[f+8>>2]=72480,_=R0(o),i[_>>2]=71232,i[f+52>>2]=0,i[f+56>>2]=0,i[f+44>>2]=0,i[f+48>>2]=0,i[f+60>>2]=16,k=f+148|0,U1(k,e,r),s=n,t=k,n=u[f+159|0],k=(n|0)<0,Y(s,k?i[f+148>>2]:t,k?i[f+152>>2]:n),u[f+159|0]<0&&Z(i[f+148>>2]),n=f+148|0,s0(n,r),t=n,n=u[f+159|0],k=(n|0)<0,Y(f+8|0,k?i[f+148>>2]:t,k?i[f+152>>2]:n),u[f+159|0]<0&&Z(i[f+148>>2]),k=Y(f+8|0,29600,13),n=i[e+100>>2]&1,Y(Y(k,n?5217:7951,n|2),42670,1),n=i[e+104>>2],B=i[e+108>>2],(n|0)!=(B|0))for(;;){e=f+148|0,s0(e,r),t=e,e=u[f+159|0],k=(e|0)<0,Y(f+8|0,k?i[f+148>>2]:t,k?i[f+152>>2]:e),u[f+159|0]<0&&Z(i[f+148>>2]),e=f+8|0,Y(q2(Y(e,30625,18),i[n>>2],i[n+4>>2]),42670,1),k=f+148|0,s0(k,r),s=e,t=k,e=u[f+159|0],k=(e|0)<0,Y(s,k?i[f+148>>2]:t,k?i[f+152>>2]:e),u[f+159|0]<0&&Z(i[f+148>>2]),m=f+8|0,k=Y(m,31819,12),e=i[n+8>>2],s=i[n+12>>2],o=v-16|0,v=o,G1(o+8|0,k);i:{if(!l[o+8|0]||(h=o+4|0,w=i[(k+i[i[k>>2]-12>>2]|0)+28>>2],i[h>>2]=w,(w|0)!=129576&&(i[w+4>>2]=i[w+4>>2]+1),w=c0(h,129440),e2(h),i[o>>2]=i[(k+i[i[k>>2]-12>>2]|0)+24>>2],X=k+i[i[k>>2]-12>>2]|0,t=t6(X),Q=o,V=W[i[i[w>>2]+20>>2]](w,i[o>>2],X,t,e,s)|0,i[Q+4>>2]=V,i[h>>2]))break i;m4(k+i[i[k>>2]-12>>2]|0,5)}if(_1(o+8|0),v=o+16|0,Y(k,42670,1),e=f+148|0,s0(e,r),t=e,e=u[f+159|0],k=(e|0)<0,Y(m,k?i[f+148>>2]:t,k?i[f+152>>2]:e),u[f+159|0]<0&&Z(i[f+148>>2]),e=f+8|0,Y(Ot(Y(e,30392,20),g[n+16>>1]),42670,1),k=f+148|0,s0(k,r),s=e,t=k,e=u[f+159|0],k=(e|0)<0,Y(s,k?i[f+148>>2]:t,k?i[f+152>>2]:e),u[f+159|0]<0&&Z(i[f+148>>2]),Y(Ot(Y(f+8|0,30592,21),g[n+18>>1]),42670,1),n=n+24|0,(B|0)==(n|0))break}e=i[f+60>>2];i:{e:{if(e&16){n=i[f+56>>2],e=i[f+36>>2],n>>>0<e>>>0&&(i[f+56>>2]=e,n=e),e=f+32|0;break e}if(!(e&8)){n=0,u[A+11|0]=0;break i}n=i[f+28>>2],e=f+20|0}e:{if(r=i[e>>2],n=n-r|0,n>>>0<2147483640){if(n>>>0>=11){k=n|7,e=p(k+1|0),i[A+8>>2]=k-2147483647,i[A>>2]=e,i[A+4>>2]=n,A=e;break e}if(u[A+11|0]=n,n)break e;n=0;break i}Q0(),H()}if(!n)break i;x(A,r,n)}u[A+n|0]=0,A=i[18127],i[f+8>>2]=A,i[i[A-12>>2]+(f+8|0)>>2]=i[18130],i[_>>2]=71232,u[f+55|0]<0&&Z(i[f+44>>2]),E0(_),y0(f- -64|0),v=f+160|0}function tm(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,t=0,o=0,s=0;f=v-160|0,v=f,i[f+92>>2]=0,i[f+64>>2]=72500,k=i[18128],i[f+8>>2]=k,n=i[k-12>>2],k=f+8|0,i[n+k>>2]=i[18129],s=k+i[i[f+8>>2]-12>>2]|0,n=f+12|0,J0(s,n),u[s+80|0]=0,i[s+72>>2]=0,i[f+64>>2]=72500,i[f+8>>2]=72480,s=R0(n),i[s>>2]=71232,i[f+52>>2]=0,i[f+56>>2]=0,i[f+44>>2]=0,i[f+48>>2]=0,i[f+60>>2]=16,n=f+148|0,Y2(n,e,r),o=k,t=n,k=u[f+159|0],n=(k|0)<0,Y(o,n?i[f+148>>2]:t,n?i[f+152>>2]:k),u[f+159|0]<0&&Z(i[f+148>>2]),k=f+148|0,s0(k,r),t=k,k=u[f+159|0],n=(k|0)<0,Y(f+8|0,n?i[f+148>>2]:t,n?i[f+152>>2]:k),u[f+159|0]<0&&Z(i[f+148>>2]),k=f+8|0,Y(k,32699,22),Y(S0(k,i[e+104>>2]),29189,3),Y(S0(k,i[e+108>>2]),29189,3),Y(S0(k,i[e+112>>2]),42670,1),n=f+148|0,s0(n,r),o=k,t=n,k=u[f+159|0],n=(k|0)<0,Y(o,n?i[f+148>>2]:t,n?i[f+152>>2]:k),u[f+159|0]<0&&Z(i[f+148>>2]),k=f+8|0,Y(k,27977,12);i:{if(l[e+116|0]==1){Y(k,42424,12),n=f+148|0,s0(n,r),o=k,t=n,k=u[f+159|0],n=(k|0)<0,Y(o,n?i[f+148>>2]:t,n?i[f+152>>2]:k),u[f+159|0]<0&&Z(i[f+148>>2]),Y(d1(Y(d1(Y(d1(Y(d1(Y(f+8|0,19184,7),t0[e+120>>3]),21052,1),t0[e+128>>3]),21052,1),t0[e+136>>3]),21052,1),t0[e+144>>3]),41694,2);break i}k=f+8|0,Y(k,42326,9),n=f+148|0,s0(n,r),o=k,t=n,k=u[f+159|0],n=(k|0)<0,Y(o,n?i[f+148>>2]:t,n?i[f+152>>2]:k),u[f+159|0]<0&&Z(i[f+148>>2]),k=f+8|0,Y(d1(Y(k,32767,9),t0[e+152>>3]),42670,1),n=f+148|0,s0(n,r),o=k,t=n,k=u[f+159|0],n=(k|0)<0,Y(o,n?i[f+148>>2]:t,n?i[f+152>>2]:k),u[f+159|0]<0&&Z(i[f+148>>2]),k=f+8|0,Y(d1(Y(k,31024,9),t0[e+160>>3]),42670,1),n=f+148|0,s0(n,r),o=k,t=n,k=u[f+159|0],n=(k|0)<0,Y(o,n?i[f+148>>2]:t,n?i[f+152>>2]:k),u[f+159|0]<0&&Z(i[f+148>>2]),Y(d1(Y(f+8|0,32736,9),t0[e+168>>3]),42670,1)}k=f+148|0,s0(k,r),n=k,r=u[f+159|0],k=(r|0)<0,Y(f+8|0,k?i[f+148>>2]:n,k?i[f+152>>2]:r),u[f+159|0]<0&&Z(i[f+148>>2]),Y(V0(Y(f+8|0,32131,28),i[e+176>>2]),42670,1),e=i[f+60>>2];i:{e:{if(e&16){e=i[f+56>>2],r=i[f+36>>2],e>>>0<r>>>0&&(i[f+56>>2]=r,e=r),r=f+32|0;break e}if(!(e&8)){e=0,u[A+11|0]=0;break i}e=i[f+28>>2],r=f+20|0}e:{if(k=i[r>>2],e=e-k|0,e>>>0<2147483640){if(e>>>0>=11){n=e|7,r=p(n+1|0),i[A+8>>2]=n-2147483647,i[A>>2]=r,i[A+4>>2]=e,A=r;break e}if(u[A+11|0]=e,e)break e;e=0;break i}Q0(),H()}if(!e)break i;x(A,k,e)}u[A+e|0]=0,A=i[18127],i[f+8>>2]=A,i[i[A-12>>2]+(f+8|0)>>2]=i[18130],i[s>>2]=71232,u[f+55|0]<0&&Z(i[f+44>>2]),E0(s),y0(f- -64|0),v=f+160|0}function yf(A,e){var r=0,f=0,k=0,n=0,t=0,o=0;i:{e:{if(f=e,t=i[f>>2],t){if(r=i[f+4>>2],!r)break e;for(;f=r,r=i[r>>2],!!r;);}if(t=i[f+4>>2],t)break e;n=i[f+8>>2],t=0,k=1;break i}n=i[f+8>>2],i[t+8>>2]=n,k=0}r=i[n>>2];i:{if((f|0)==(r|0)){if(i[n>>2]=t,(A|0)==(f|0)){r=0,A=t;break i}r=i[n+4>>2];break i}i[n+4>>2]=t}if(o=l[f+12|0],(e|0)!=(f|0)){n=i[e+8>>2],i[f+8>>2]=n;i:{if(i[n>>2]==(e|0)){i[n>>2]=f;break i}i[n+4>>2]=f}n=i[e>>2],i[f>>2]=n,i[n+8>>2]=f,n=i[e+4>>2],i[f+4>>2]=n,n&&(i[n+8>>2]=f),u[f+12|0]=l[e+12|0],A=(A|0)==(e|0)?f:A}if(!(!A|!(o&1))){if(k)for(;;){e=l[r+12|0];i:{if(k=i[r+8>>2],f=i[k>>2],(f|0)!=(r|0)){if(!(e&1)){u[r+12|0]=1,u[k+12|0]=0,f=i[k+4>>2],e=i[f>>2],i[k+4>>2]=e,e&&(i[e+8>>2]=k),e=i[k+8>>2],i[f+8>>2]=e;e:{if((k|0)==i[e>>2]){i[e>>2]=f;break e}i[e+4>>2]=f}i[f>>2]=k,i[k+8>>2]=f,e=i[r>>2],A=(e|0)==(A|0)?r:A,r=i[e+4>>2]}e:{r:{f=i[r>>2];f:{if(!(l[f+12|0]!=1&&f)){if(e=i[r+4>>2],l[e+12|0]!=1&&e)break f;if(u[r+12|0]=0,r=i[r+8>>2],l[r+12|0]&&(r|0)!=(A|0))break i;u[r+12|0]=1;return}if(e=i[r+4>>2],!e)break r}if(l[e+12|0]==1)break r;f=r;break e}u[f+12|0]=1,u[r+12|0]=0,A=i[f+4>>2],i[r>>2]=A,A&&(i[A+8>>2]=r),A=i[r+8>>2],i[f+8>>2]=A;r:{if(i[A>>2]==(r|0)){i[A>>2]=f;break r}i[A+4>>2]=f}i[f+4>>2]=r,i[r+8>>2]=f,e=r}r=i[f+8>>2],u[f+12|0]=l[r+12|0],u[r+12|0]=1,u[e+12|0]=1,e=i[r+4>>2],A=i[e>>2],i[r+4>>2]=A,A&&(i[A+8>>2]=r),A=i[r+8>>2],i[e+8>>2]=A;e:{if((r|0)==i[A>>2]){i[A>>2]=e;break e}i[A+4>>2]=e}i[e>>2]=r,i[r+8>>2]=e;return}if(!(e&1)){u[r+12|0]=1,u[k+12|0]=0,e=i[f+4>>2],i[k>>2]=e,e&&(i[e+8>>2]=k),e=i[k+8>>2],i[f+8>>2]=e;e:{if((k|0)==i[e>>2]){i[e>>2]=f;break e}i[e+4>>2]=f}i[f+4>>2]=k,i[k+8>>2]=f,e=i[r+4>>2],A=(e|0)==(A|0)?r:A,r=i[e>>2]}e=i[r>>2];e:{if(!(!e|l[e+12|0]==1)){f=r;break e}if(f=i[r+4>>2],!(l[f+12|0]!=1&&f)){if(u[r+12|0]=0,r=i[r+8>>2],l[r+12|0]==1&(A|0)!=(r|0))break i;u[r+12|0]=1;return}if(e){if(!(u[e+12|0]&1)){f=r;break e}f=i[r+4>>2]}u[f+12|0]=1,u[r+12|0]=0,A=i[f>>2],i[r+4>>2]=A,A&&(i[A+8>>2]=r),A=i[r+8>>2],i[f+8>>2]=A;r:{if(i[A>>2]==(r|0)){i[A>>2]=f;break r}i[A+4>>2]=f}i[f>>2]=r,i[r+8>>2]=f,e=r}r=i[f+8>>2],u[f+12|0]=l[r+12|0],u[r+12|0]=1,u[e+12|0]=1,e=i[r>>2],A=i[e+4>>2],i[r>>2]=A,A&&(i[A+8>>2]=r),A=i[r+8>>2],i[e+8>>2]=A;e:{if((r|0)==i[A>>2]){i[A>>2]=e;break e}i[A+4>>2]=e}i[e+4>>2]=r,i[r+8>>2]=e;return}e=i[r+8>>2],r=i[(i[e>>2]==(r|0)?4:0)+e>>2]}u[t+12|0]=1}}function um(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0;var k=0,n=0,t=0,o=0,s=0,w=0,h=0,_=0,B=0,m=0;f=v-16|0,v=f,B=e,m=X2(r),u[B+100|0]=m,B=e,m=X2(r),u[B+101|0]=m,B=e,m=X2(r),u[B+102|0]=m,B=e,m=X2(r),u[B+103|0]=m,B=e,m=(X2(r)&3)+1|0,u[B+104|0]=m;i:{if(w=X2(r)&31,!w)break i;for(_=e+116|0;;){t=o2(r),i[f+12>>2]=0,i[f+4>>2]=0,i[f+8>>2]=0;e:{if(!t){n=0,k=0;break e}k=p(t),i[f+4>>2]=k,n=k+t|0,i[f+12>>2]=n,t&&o0(k,0,t),i[f+8>>2]=n}l6(r,k,n-k|0);e:{k=i[e+120>>2];r:{if(k>>>0<u0[e+124>>2]){if(i[k+8>>2]=0,i[k>>2]=0,i[k+4>>2]=0,n=i[f+8>>2],o=i[f+4>>2],(n|0)!=(o|0)){if(n=n-o|0,(n|0)<0)break e;t=p(n),i[k+4>>2]=t,i[k>>2]=t,h=n+t|0,i[k+8>>2]=h,n&&x(t,o,n),i[k+4>>2]=h}k=k+12|0;break r}k=y6(_,f+4|0)}if(i[e+120>>2]=k,k=i[f+4>>2],k&&(i[f+8>>2]=k,Z(k)),s=s+1|0,(w|0)!=(s|0))continue;break i}break}G0(),H()}i:{e:{if(w=X2(r),w)for(_=e+128|0,s=0;;){t=o2(r),i[f+12>>2]=0,i[f+4>>2]=0,i[f+8>>2]=0;r:{if(!t){n=0,k=0;break r}k=p(t),i[f+4>>2]=k,n=k+t|0,i[f+12>>2]=n,t&&o0(k,0,t),i[f+8>>2]=n}l6(r,k,n-k|0),k=i[e+132>>2];r:{if(k>>>0<u0[e+136>>2]){if(i[k+8>>2]=0,i[k>>2]=0,i[k+4>>2]=0,n=i[f+8>>2],o=i[f+4>>2],(n|0)!=(o|0)){if(n=n-o|0,(n|0)<0)break e;t=p(n),i[k+4>>2]=t,i[k>>2]=t,h=n+t|0,i[k+8>>2]=h,n&&x(t,o,n),i[k+4>>2]=h}k=k+12|0;break r}k=y6(_,f+4|0)}if(i[e+132>>2]=k,k=i[f+4>>2],k&&(i[f+8>>2]=k,Z(k)),s=s+1|0,(w|0)==(s|0))break}r:{if(!i[r+16>>2]||(k=l[e+101|0]-66|0,1<<k&4196353&&k>>>0<=22)||(B=e,m=X2(r)&3,i[B+108>>2]=m,B=e,m=X2(r)&7|8,u[B+112|0]=m,B=e,m=X2(r)&7|8,u[B+113|0]=m,w=X2(r),!w))break r;for(_=e+140|0,s=0;;){t=o2(r),i[f+12>>2]=0,i[f+4>>2]=0,i[f+8>>2]=0;f:{if(!t){n=0,k=0;break f}k=p(t),i[f+4>>2]=k,n=k+t|0,i[f+12>>2]=n,t&&o0(k,0,t),i[f+8>>2]=n}l6(r,k,n-k|0),k=i[e+144>>2];f:{if(k>>>0<u0[e+148>>2]){if(i[k+8>>2]=0,i[k>>2]=0,i[k+4>>2]=0,n=i[f+8>>2],o=i[f+4>>2],(n|0)!=(o|0)){if(n=n-o|0,(n|0)<0)break i;t=p(n),i[k+4>>2]=t,i[k>>2]=t,h=n+t|0,i[k+8>>2]=h,n&&x(t,o,n),i[k+4>>2]=h}k=k+12|0;break f}k=y6(_,f+4|0)}if(i[e+144>>2]=k,k=i[f+4>>2],k&&(i[f+8>>2]=k,Z(k)),s=s+1|0,(w|0)==(s|0))break}}r:{if(l[r+20|0]==1){if(u[f+4|0]=0,u[f+15|0]=0,q(A,2,100,f+4|0),u[f+15|0]>=0)break r;Z(i[f+4>>2]);break r}if(e=i[26917],i[A>>2]=i[26916],i[A+4>>2]=e,A=A+8|0,u[107683]>=0){e=i[26919],i[A>>2]=i[26918],i[A+4>>2]=e,i[A+8>>2]=i[26920];break r}T(A,i[26918],i[26919])}v=f+16|0;return}G0(),H()}G0(),H()}function y9(A,e,r){var f=0,k=0,n=0,t=0,o=0,s=0,w=0,h=0,_=0,B=0;k=i[A+18588>>2],h=i[k+132>>2],f=-1<<i[h+8268>>2],t=f&r,B=i[A+18592>>2],w=i[k+124>>2],s=e&f,(s|0)==i[A+18524>>2]&(t|0)==i[A+18528>>2]||(i[A+18528>>2]=t,i[A+18524>>2]=s,i[A+18532>>2]=i[A+18520>>2]),o=i[B+808>>2],_=i[w+16892>>2],n=(o|0)/(_|0)|0,k=o-G(n,_)|0,o=i[w+16884>>2],o=(s|0)==(G(k,o)|0)&(t|0)==(G(n,o)|0),n=0,k=i[w+16876>>2],f=-1<<k^-1,!l[h+46|0]|f&(t|s)||(n=Tu(h,s>>k,t>>k));i:{if(!(!l[h+45|0]|(s|f&t))||n|o){k=i[A+18592>>2]+800|0;break i}k=A+18532|0}f=i[k>>2];i:{e:{o=s-1|0;r:{if(!Ct(i[A+18588>>2],s,t,o,t)){n=i[A+18588>>2],k=f;break r}if(n=i[A+18588>>2],_=i[w+16936>>2],k=f,i[A+4>>2]!=i[(i[h+8496>>2]+(o>>_<<2)|0)+(G(i[w+16924>>2],t>>_)<<2)>>2]>>(i[w+16876>>2]-_<<1))break r;if(k=o,o=i[n+168>>2],k=k>>o,(k|0)<0||(_=i[n+172>>2],(_|0)<=(k|0)))break e;if(o=t>>o,(o|0)<0|(o|0)>=i[n+176>>2])break i;k=u[((i[n+160>>2]+G(k,3)|0)+G(G(o,_),3)|0)+2|0]}o=n,n=t-1|0;r:{if(!Ct(o,s,t,s,n)||(t=i[w+16936>>2],i[A+4>>2]!=i[(i[h+8496>>2]+(s>>t<<2)|0)+(G(i[w+16924>>2],n>>t)<<2)>>2]>>(i[w+16876>>2]-t<<1)))break r;if(o=s,f=i[A+18588>>2],s=i[f+168>>2],t=o>>s,(t|0)<0||(o=i[f+172>>2],(o|0)<=(t|0)))break e;if(n=n>>s,(n|0)<0|(n|0)>=i[f+176>>2])break i;f=u[((i[f+160>>2]+G(t,3)|0)+G(G(n,o),3)|0)+2|0]}k=i[A+18504>>2]+((f+k|0)+1>>1)|0,f=i[w+16836>>2],n=((k+(f<<1)|0)+52|0)%(f+52|0)|0,i[A+18536>>2]=(n|0)>0?n:0,s=i[w+16844>>2],k=0-s|0,t=n-f|0,f=i[A+18516>>2]+(i[B+756>>2]+(t+i[h+36>>2]|0)|0)|0,n=(f|0)<(k|0)?k:(f|0)>=57?57:f,f=i[A+18512>>2]+(i[B+752>>2]+(t+i[h+32>>2]|0)|0)|0,f=(f|0)<(k|0)?k:(f|0)>=57?57:f;r:{if(i[w+16848>>2]!=1)break r;f:{if((f|0)<30)break f;if(f>>>0>=43){f=f-6|0;break f}f=i[(f<<2)+63672>>2]}if((n|0)<30)break r;if(n>>>0>=43){n=n-6|0;break r}n=i[(n<<2)+63672>>2]}if(k=n+s|0,i[A+18544>>2]=(k|0)>0?k:0,k=f+s|0,i[A+18540>>2]=(k|0)>0?k:0,f=i[A+18588>>2],n=i[f+168>>2],k=e>>n,(k|0)<0||(w=i[f+172>>2],(w|0)<=(k|0)))break e;if(e=r>>n,(e|0)<0|i[f+176>>2]<=(e|0))break i;if(f=i[f+160>>2],r=(f+G(k,3)|0)+G(G(e,w),3)|0,r=(l[r|0]|l[r+1|0]<<8)&7,r=(r>>>0<=3?3:r)-n|0,(r|0)!=31)for(r=1<<r,n=r+e|0,s=r+k|0;;){for(h=(f+G(G(e,w),3)|0)+2|0,r=k;u[h+G(r,3)|0]=t,r=r+1|0,(s|0)>(r|0););if(e=e+1|0,!((n|0)>(e|0)))break}i[A+18520>>2]=t;return}D0(4656,10893,118,4231),H()}D0(4618,10893,119,4231),H()}function qi(A,e){var r=0,f=0,k=0,n=0,t=0,o=0,s=0,w=0,h=0;k=e-1|0,f=k,r=(k|0)/2|0,k=e+65535>>>0<131073,s=k?f:r,n=i[A+124>>2],t=n>>31,e=k?2:1,r=i[A+128>>2];i:{if((e|0)==(r|0)){if(f=(s>>31)+t|0,t=n+s|0,f=t>>>0<s>>>0?f+1|0:f,r=f,!(t- -2147483648>>>0<2147483648?r+1|0:r))break i;e=r>>31,f=e,e=t+(e|1)|0,f=f+r|0,t=G2(e,e>>>0<t>>>0?f+1|0:f,2,0),e=1;break i}if(e=r,o=e>>31,r=O0(e,o,s,s>>31),w=l0,h=r,s=n,r=k&31,(k&63)>>>0>=32?(f=n<<r,n=0):(f=(1<<r)-1&s>>>32-r|t<<r,n=s<<r),t=h+n|0,r=f+w|0,r=n>>>0>t>>>0?r+1|0:r,w=0-(r+(t>>>0>2147483647)|0)|0,s=e,n=k&31,(k&63)>>>0>=32?(f=e<<n,k=0):(f=(1<<n)-1&s>>>32-n|o<<n,k=s<<n),e=k,n=f,e=0-(f+(e>>>0>2147483647)|0)|w,(e|0)==1|e>>>0>1)for(;e=n>>31,f=e,e=k+(e|1)|0,f=f+n|0,k=G2(e,e>>>0<k>>>0?f+1|0:f,2,0),n=l0,e=r>>31,f=e,e=t+(e|1)|0,r=f+r|0,t=G2(e,e>>>0<t>>>0?r+1|0:r,2,0),e=l0,r=e,(e-(t>>>0<2147483648)|0)!=-1;);e=k}if(n=i[A+108>>2],r=n,k=i[A+112>>2],A=r-k|0,n=k>>31,r=(r>>31)-(n+(r>>>0<k>>>0)|0)|0,f=0-(r+(A>>>0>2147483647)|0)|0-((k>>>0>2147483647)+n|0),(f|0)==1|f>>>0>1){for(;f=n>>31,o=k+(f|1)|0,f=f+n|0,k=G2(o,k>>>0>o>>>0?f+1|0:f,2,0),n=l0,f=r>>31,o=A+(f|1)|0,r=f+r|0,A=G2(o,A>>>0>o>>>0?r+1|0:r,2,0),r=l0,(r-(A>>>0<2147483648)|0)!=-1;);n=k>>31}f=n<<1|k>>>31,k=k<<1,r=f,o=A>>31,f=0-(r+(k>>>0>2147483646)|0)|0-(o+(A>>>0>2147483647)|0),(f|0)==1|f>>>0>1&&(f=n>>31,n=k+(f|1)|0,r=f+r|0,k=G2(n,n>>>0<k>>>0?r+1|0:r,2,0),f=o>>31,n=A+(f|1)|0,f=f+o|0,A=G2(n,A>>>0>n>>>0?f+1|0:f,2,0)),n=t>>31;i:{if((e|0)==(k|0)){if(k=A,r=t-k|0,n=n-((k>>31)+(k>>>0>t>>>0)|0)|0,k=r,A=e,r=e>>31,!(0-(n+(k>>>0>2147483647)|0)|0-(r+(e>>>0>2147483647)|0)))break i;for(;e=r>>31,f=e,e=A+(e|1)|0,f=f+r|0,A=G2(e,A>>>0>e>>>0?f+1|0:f,2,0),r=l0,e=n>>31,t=k+(e|1)|0,e=e+n|0,k=G2(t,k>>>0>t>>>0?e+1|0:e,2,0),e=l0,n=e,(e-(k>>>0<2147483648)|0)!=-1;);e=A;break i}if(r=k>>31,n=O0(k,r,t,n),f=l0,o=e>>31,A=O0(e,o,A,A>>31),t=n-A|0,n=f-(l0+(A>>>0>n>>>0)|0)|0,A=O0(k,r,e,o),k=t,r=l0,e=0-((k>>>0>2147483647)+n|0)|0-(r+(A>>>0>2147483647)|0),(e|0)==1|e>>>0>1)for(;e=r>>31,f=e,e=A+(e|1)|0,f=f+r|0,A=G2(e,A>>>0>e>>>0?f+1|0:f,2,0),t=l0,r=t,f=r-(A>>>0<2147483648)|0,e=n>>31,t=k+(e|1)|0,e=e+n|0,k=G2(t,k>>>0>t>>>0?e+1|0:e,2,0),e=l0,n=e,(e-(k>>>0<2147483648)&f)!=-1;);e=A}return n=(e|0)/2|0,A=k+n|0,r=(n>>31)+(k>>31)|0,G2(A,A>>>0<k>>>0?r+1|0:r,e,e>>31)}function sr(A){var e=0,r=0,f=0,k=0,n=0,t=0,o=0,s=0,w=0,h=0;t=v-16|0,v=t;i:{e:{r:{if(i[A+140>>2])break r;e=p(120),i[e+4>>2]=0,i[e+8>>2]=0,i[e>>2]=92564,f=e+16|0,r=f,i[r+8>>2]=0,i[r+12>>2]=0,i[r+16>>2]=0,i[r+20>>2]=0,i[r+24>>2]=0,i[r+28>>2]=0,i[r+32>>2]=0,i[r>>2]=86356,i[e+60>>2]=0,i[e+64>>2]=0,i[e+52>>2]=0,i[e+56>>2]=0,i[e+72>>2]=-1,i[e+76>>2]=-1,i[e+80>>2]=-1,i[e+84>>2]=-1,i[e+88>>2]=0,i[e+92>>2]=0,i[e+96>>2]=0,i[e+100>>2]=0,i[e+104>>2]=0,i[e+108>>2]=0,u[e+112|0]=0,i[e+32>>2]=1836019574,i[r>>2]=92604,i[A+140>>2]=r,r=i[A+144>>2],i[A+144>>2]=e;f:{A:{if(!r){k=A+16|0;break A}if(e=i[r+4>>2],i[r+4>>2]=e-1,e||(W[i[i[r>>2]+8>>2]](r),y(r)),k=A+16|0,f=i[A+140>>2],e=i[A+144>>2],e)break A;e=0;break f}i[e+4>>2]=i[e+4>>2]+1}r=i[k+4>>2],n=i[k+8>>2];f:{if(r>>>0<n>>>0){i[r+4>>2]=e,i[r>>2]=f,e=r+8|0;break f}if(s=i[k>>2],w=r-s|0,h=w>>3,r=h+1|0,r>>>0>=536870912)break e;if(n=n-s|0,o=n>>2,n=n>>>0>=2147483640?536870911:r>>>0<o>>>0?o:r,n){if(n>>>0>=536870912)break i;r=p(n<<3)}else r=0;if(o=r+w|0,i[o+4>>2]=e,i[o>>2]=f,f=o-(h<<3)|0,w&&x(f,s,w),i[k+8>>2]=r+(n<<3),e=o+8|0,i[k+4>>2]=e,i[k>>2]=f,!s)break f;Z(s)}i[k+4>>2]=e,e=p(200),i[e>>2]=92684,i[e+4>>2]=0,i[e+8>>2]=0,f=e+16|0,r=f,i[r+8>>2]=0,i[r+12>>2]=0,i[e+32>>2]=0,i[e+36>>2]=0,i[e+40>>2]=0,i[e+44>>2]=0,i[e+48>>2]=0,i[e+16>>2]=86356,i[e+60>>2]=0,i[e+64>>2]=0,i[e+52>>2]=0,i[e+56>>2]=0,i[e+72>>2]=-1,i[e+76>>2]=-1,i[e+80>>2]=-1,i[e+84>>2]=-1,i[e+116>>2]=0,i[e+88>>2]=0,i[e+92>>2]=0,i[e+96>>2]=0,i[e+100>>2]=0,i[e+104>>2]=0,i[e+108>>2]=0,g[e+112>>1]=0,i[e+16>>2]=104380,r=i[12437],i[e+160>>2]=i[12436],i[e+164>>2]=r,i[e+120>>2]=0,i[e+124>>2]=0,i[e+144>>2]=0,i[e+148>>2]=0,i[e+128>>2]=0,i[e+132>>2]=0,i[e+136>>2]=0,g[e+156>>1]=256,i[e+152>>2]=65536,r=i[12439],i[e+168>>2]=i[12438],i[e+172>>2]=r,r=i[12441],i[e+176>>2]=i[12440],i[e+180>>2]=r,r=i[12443],i[e+184>>2]=i[12442],i[e+188>>2]=r,i[e+192>>2]=i[12444],i[e+196>>2]=0,i[e+32>>2]=1836476516,i[A+148>>2]=f,r=i[A+152>>2],i[A+152>>2]=e;f:{A:{if(!r){k=i[A+140>>2],i[t+12>>2]=e,i[t+8>>2]=f;break A}if(e=i[r+4>>2],i[r+4>>2]=e-1,e||(W[i[i[r>>2]+8>>2]](r),y(r)),k=i[A+140>>2],r=i[A+148>>2],e=i[A+152>>2],i[t+12>>2]=e,i[t+8>>2]=r,!e)break f}i[e+4>>2]=i[e+4>>2]+1}if(r2(k+36|0,t+8|0),A=i[t+12>>2],!A||(r=i[A+4>>2],i[A+4>>2]=r-1,r))break r;W[i[i[A>>2]+8>>2]](A),y(A)}v=t+16|0;return}G0(),H()}z0(),H()}function om(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0;var k=0,n=0,t=0,o=0,s=0,w=0,h=0,_=0;t=v-32|0,v=t;i:{e:{r:{if(i[e+28>>2]!=1885954932||(s=i[f>>2],h=i[f+4>>2],(s|0)==(h|0)))break r;for(;;){k=i[s>>2],r=i[s+4>>2],r&&(i[r+4>>2]=i[r+4>>2]+1);f:{if(i[k+24>>2]==i[e+24>>2])break f;L1(t+20|0,i[k+28>>2]);A:{if(i[k+28>>2]!=1635088502||(ro(k)|0)!=1)break A;w=i[k+244>>2],o=i[k+248>>2],o&&(i[o+4>>2]=i[o+4>>2]+1);k:{if(!w){if(f=p(32),i[t+8>>2]=f,i[t+12>>2]=30,i[t+16>>2]=-2147483616,k=l[27214]|l[27215]<<8|(l[27216]<<16|l[27217]<<24),n=l[27210]|l[27211]<<8|(l[27212]<<16|l[27213]<<24),u[f|0]=n,u[f+1|0]=n>>>8,u[f+2|0]=n>>>16,u[f+3|0]=n>>>24,u[f+4|0]=k,u[f+5|0]=k>>>8,u[f+6|0]=k>>>16,u[f+7|0]=k>>>24,u[f+30|0]=0,k=l[27236]|l[27237]<<8|(l[27238]<<16|l[27239]<<24),n=l[27232]|l[27233]<<8|(l[27234]<<16|l[27235]<<24),u[f+22|0]=n,u[f+23|0]=n>>>8,u[f+24|0]=n>>>16,u[f+25|0]=n>>>24,u[f+26|0]=k,u[f+27|0]=k>>>8,u[f+28|0]=k>>>16,u[f+29|0]=k>>>24,k=l[27230]|l[27231]<<8|(l[27232]<<16|l[27233]<<24),n=l[27226]|l[27227]<<8|(l[27228]<<16|l[27229]<<24),u[f+16|0]=n,u[f+17|0]=n>>>8,u[f+18|0]=n>>>16,u[f+19|0]=n>>>24,u[f+20|0]=k,u[f+21|0]=k>>>8,u[f+22|0]=k>>>16,u[f+23|0]=k>>>24,k=l[27222]|l[27223]<<8|(l[27224]<<16|l[27225]<<24),n=l[27218]|l[27219]<<8|(l[27220]<<16|l[27221]<<24),u[f+8|0]=n,u[f+9|0]=n>>>8,u[f+10|0]=n>>>16,u[f+11|0]=n>>>24,u[f+12|0]=k,u[f+13|0]=k>>>8,u[f+14|0]=k>>>16,u[f+15|0]=k>>>24,q(A,2,0,t+8|0),u[t+19|0]>=0)break k;Z(i[t+8>>2]);break k}if(gA(t+8|0,w,1635088492),f=i[t+8>>2],n=i[t+12>>2],(f|0)!=(n|0)){_=i[e+24>>2];n:{for(;;){if(i[f>>2]!=(_|0)){if(f=f+4|0,(n|0)!=(f|0))continue;break n}break}if(f=0,k=W0(k,106564,106696),!r|!k||(i[r+4>>2]=i[r+4>>2]+1,f=r),i[e+320>>2]=k,k=i[e+324>>2],i[e+324>>2]=f,!k||(f=i[k+4>>2],i[k+4>>2]=f-1,f))break n;W[i[i[k>>2]+8>>2]](k),y(k)}f=i[t+8>>2]}if(!f)break k;i[t+12>>2]=f,Z(f)}k:{if(!o||(f=i[o+4>>2],i[o+4>>2]=f-1,f))break k;W[i[i[o>>2]+8>>2]](o),y(o)}if(!w)break e}if(u[t+31|0]>=0)break f;Z(i[t+20>>2])}f:{if(!r||(f=i[r+4>>2],i[r+4>>2]=f-1,f))break f;W[i[i[r>>2]+8>>2]](r),y(r)}if(s=s+8|0,(h|0)==(s|0))break}}i[A>>2]=0,i[A+4>>2]=0,i[A+16>>2]=0,i[A+8>>2]=0,i[A+12>>2]=0;break i}if(u[t+31|0]<0&&Z(i[t+20>>2]),!r||(A=i[r+4>>2],i[r+4>>2]=A-1,A))break i;W[i[i[r>>2]+8>>2]](r),y(r)}v=t+32|0}function lm(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,t=0,o=0,s=0,w=0,h=0,_=0,B=0;t=v+-64|0,v=t,B=W[i[i[e>>2]+52>>2]](e,r,0)|0,w=t+40|0,o=v-16|0,v=o,F0(r,0),u2(r,0),u2(r,C[e+100>>1]),u2(r,C[e+102>>1]),u2(r,0),F0(r,i[e+104>>2]),F0(r,i[e+108>>2]),F0(r,i[e+112>>2]),u2(r,C[e+116>>1]),u2(r,C[e+118>>1]),F0(r,i[e+120>>2]),F0(r,i[e+124>>2]),F0(r,0),u2(r,C[e+128>>1]);i:{if(u[e+143|0]>=0){i[o+8>>2]=i[e+140>>2],f=i[e+136>>2],i[o>>2]=i[e+132>>2],i[o+4>>2]=f;break i}T(o,i[e+132>>2],i[e+136>>2])}i:{e:{f=i[r+12>>2]+32|0,k=i[r+4>>2],s=i[r>>2],h=k-s|0;r:{if(f>>>0<=h>>>0)break r;if(n=f-h|0,_=i[r+8>>2],n>>>0<=_-k>>>0){n&&o0(k,0,n),i[r+4>>2]=k+n;break r}if((f|0)<0)break e;if(k=_-s|0,_=k<<1,_=k>>>0>=1073741823?2147483647:f>>>0<_>>>0?_:f,k=p(_),n&&o0(k+h|0,0,n),h&&x(k,s,h),i[r+8>>2]=k+_,i[r+4>>2]=f+k,i[r>>2]=k,!s)break r;Z(s)}if(k=i[o+4>>2],f=u[o+11|0],s=i[r+12>>2],i[r+12>>2]=s+1,n=0,f=(f|0)<0?k:f,u[s+i[r>>2]|0]=f>>>0>31?31:f,k=u[o+11|0],f=(k|0)<0?i[o+4>>2]:k,!f)break i;for(k=k>>>31|0;;){if(f=l[(k?i[o>>2]:o)+n|0],k=i[r+12>>2],i[r+12>>2]=k+1,u[k+i[r>>2]|0]=f,k=u[o+11|0],f=(k|0)<0?i[o+4>>2]:k,n=n+1|0,n>>>0>=31)break i;if(k=k>>>31|0,!(f>>>0>n>>>0))break}break i}G0(),H()}i:{if(f>>>0>=31)break i;if(k=30-f|0,s=(f^-1)+32&3,s)for(n=0;h=i[r+12>>2],i[r+12>>2]=h+1,u[h+i[r>>2]|0]=0,f=f+1|0,n=n+1|0,(s|0)!=(n|0););if(k>>>0<3)break i;for(;n=i[r+12>>2],i[r+12>>2]=n+1,u[n+i[r>>2]|0]=0,n=i[r+12>>2],i[r+12>>2]=n+1,u[n+i[r>>2]|0]=0,n=i[r+12>>2],i[r+12>>2]=n+1,u[n+i[r>>2]|0]=0,n=i[r+12>>2],i[r+12>>2]=n+1,u[n+i[r>>2]|0]=0,f=f+4|0,(f|0)!=31;);}u[o+11|0]<0&&Z(i[o>>2]),u2(r,C[e+144>>1]),u2(r,C[e+146>>1]),f=i[26917],i[w>>2]=i[26916],i[w+4>>2]=f,w=w+8|0;i:{if(u[107683]>=0){f=i[26919],i[w>>2]=i[26918],i[w+4>>2]=f,i[w+8>>2]=i[26920];break i}T(w,i[26918],i[26919])}v=o+16|0;i:{if(i[t+40>>2]){e=i[t+44>>2],i[A>>2]=i[t+40>>2],i[A+4>>2]=e,i[A+16>>2]=i[t+56>>2],e=i[t+52>>2],i[A+8>>2]=i[t+48>>2],i[A+12>>2]=e,i[t+56>>2]=0,i[t+48>>2]=0,i[t+52>>2]=0;break i}if(Du(t+20|0,e,r),u[t+39|0]<0&&Z(i[t+28>>2]),f1(t,e,r,B),u[t+19|0]<0&&Z(i[t+8>>2]),e=i[26917],i[A>>2]=i[26916],i[A+4>>2]=e,A=A+8|0,u[107683]>=0){e=i[26919],i[A>>2]=i[26918],i[A+4>>2]=e,i[A+8>>2]=i[26920];break i}T(A,i[26918],i[26919])}u[t+59|0]<0&&Z(i[t+48>>2]),v=t- -64|0}function sm(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,t=0,o=0,s=0,w=0;if(f=v-160|0,v=f,i[f+92>>2]=0,i[f+64>>2]=72196,i[f+8>>2]=72176,k=i[18053],i[f>>2]=k,i[i[k-12>>2]+f>>2]=i[18054],i[f+4>>2]=0,k=i[i[f>>2]-12>>2]+f|0,n=f+12|0,J0(k,n),u[k+80|0]=0,i[k+72>>2]=0,k=i[18055],i[f+8>>2]=k,o=f+8|0,i[o+i[k-12>>2]>>2]=i[18056],k=i[18052],i[f>>2]=k,i[i[k-12>>2]+f>>2]=i[18057],i[f+64>>2]=72196,i[f>>2]=72156,i[f+8>>2]=72176,w=R0(n),i[w>>2]=71232,i[f+52>>2]=0,i[f+56>>2]=0,i[f+44>>2]=0,i[f+48>>2]=0,i[f+60>>2]=24,k=f+148|0,U1(k,e,r),t=k,k=u[f+159|0],n=(k|0)<0,Y(o,n?i[f+148>>2]:t,n?i[f+152>>2]:k),u[f+159|0]<0&&Z(i[f+148>>2]),k=f+148|0,s0(k,r),t=k,k=u[f+159|0],n=(k|0)<0,Y(o,n?i[f+148>>2]:t,n?i[f+152>>2]:k),u[f+159|0]<0&&Z(i[f+148>>2]),k=Y(o,31684,15),n=f+148|0,L1(n,i[e+104>>2]),t=k,s=n,k=u[f+159|0],n=(k|0)<0,Y(Y(t,n?i[f+148>>2]:s,n?i[f+152>>2]:k),42670,1),u[f+159|0]<0&&Z(i[f+148>>2]),l[e+112|0]==1&&(k=f+148|0,s0(k,r),t=k,k=u[f+159|0],n=(k|0)<0,Y(o,n?i[f+148>>2]:t,n?i[f+152>>2]:k),u[f+159|0]<0&&Z(i[f+148>>2]),Y(V0(Y(o,30978,16),i[e+108>>2]),42670,1)),l[e+120|0]==1&&(k=f+148|0,s0(k,r),t=k,k=u[f+159|0],n=(k|0)<0,Y(o,n?i[f+148>>2]:t,n?i[f+152>>2]:k),u[f+159|0]<0&&Z(i[f+148>>2]),Y(V0(Y(o,29341,34),i[e+116>>2]),42670,1)),i[e+128>>2]!=i[e+124>>2])for(k=0;;){n=f+148|0,s0(n,r),s=n,n=u[f+159|0],t=(n|0)<0,Y(o,t?i[f+148>>2]:s,t?i[f+152>>2]:n),u[f+159|0]<0&&Z(i[f+148>>2]),n=k+1|0,Y(V0(Y(o,19205,1),n),32722,4),t=G(k,12),k=i[(t+i[e+124>>2]|0)+4>>2];i:{if(k){if(t=f+148|0,W[i[i[k>>2]+8>>2]](t,k),s=t,k=u[f+159|0],t=(k|0)<0,Y(Y(o,t?i[f+148>>2]:s,t?i[f+152>>2]:k),42670,1),u[f+159|0]>=0)break i;Z(i[f+148>>2]);break i}Y(V0(Y(o,20956,26),i[t+i[e+124>>2]>>2]),42669,2)}if(k=n,!(k>>>0<(i[e+128>>2]-i[e+124>>2]|0)/12>>>0))break}e=i[f+60>>2];i:{e:{if(e&16){e=i[f+56>>2],r=i[f+36>>2],e>>>0<r>>>0&&(i[f+56>>2]=r,e=r),r=f+32|0;break e}if(!(e&8)){e=0,u[A+11|0]=0;break i}e=i[f+28>>2],r=f+20|0}e:{if(k=i[r>>2],e=e-k|0,e>>>0<2147483640){if(e>>>0>=11){n=e|7,r=p(n+1|0),i[A+8>>2]=n-2147483647,i[A>>2]=r,i[A+4>>2]=e,A=r;break e}if(u[A+11|0]=e,e)break e;e=0;break i}Q0(),H()}if(!e)break i;x(A,k,e)}u[A+e|0]=0,A=i[18051],i[f>>2]=A,i[i[A-12>>2]+f>>2]=i[18059],i[f+8>>2]=i[18060],i[w>>2]=71232,u[f+55|0]<0&&Z(i[f+44>>2]),E0(w),y0(f- -64|0),v=f+160|0}function E9(A,e){var r=0,f=0,k=0,n=0,t=0,o=0,s=0;i:{e:{r:{f:switch(e-A>>3){case 2:if(i[e-4>>2]<=i[A+4>>2])break r;return f=i[A>>2],r=i[A+4>>2],k=e-8|0,e=i[k+4>>2],i[A>>2]=i[k>>2],i[A+4>>2]=e,i[k>>2]=f,i[k+4>>2]=r,1;case 3:if(n=e-8|0,k=e-4|0,f=i[k>>2],r=i[A+12>>2],(r|0)<=i[A+4>>2]){if((r|0)>=(f|0)||(f=i[A+8>>2],r=i[A+12>>2],e=i[n+4>>2],i[A+8>>2]=i[n>>2],i[A+12>>2]=e,i[n>>2]=f,i[n+4>>2]=r,i[A+12>>2]<=i[A+4>>2]))break r;e=i[A+8>>2],r=i[A+12>>2];break e}if(e=i[A>>2],t=i[A+4>>2],(r|0)<(f|0)){r=i[n+4>>2],i[A>>2]=i[n>>2],i[A+4>>2]=r;break i}if(f=i[A+8>>2],r=i[A+12>>2],i[A+8>>2]=e,i[A+12>>2]=t,i[A>>2]=f,i[A+4>>2]=r,(t|0)>=i[k>>2])break r;r=i[n+4>>2],i[A+8>>2]=i[n>>2],i[A+12>>2]=r;break i;case 4:return yr(A,A+8|0,A+16|0,e-8|0),1;case 5:if(yr(A,A+8|0,A+16|0,A+24|0),i[e-4>>2]<=i[A+28>>2]||(f=i[A+24>>2],r=i[A+28>>2],k=e-8|0,e=i[k+4>>2],i[A+24>>2]=i[k>>2],i[A+28>>2]=e,i[k>>2]=f,i[k+4>>2]=r,i[A+28>>2]<=i[A+20>>2])||(e=i[A+24>>2],r=i[A+28>>2],f=i[A+20>>2],i[A+24>>2]=i[A+16>>2],i[A+28>>2]=f,i[A+16>>2]=e,i[A+20>>2]=r,(r|0)<=i[A+12>>2])||(f=i[A+12>>2],i[A+16>>2]=i[A+8>>2],i[A+20>>2]=f,i[A+8>>2]=e,i[A+12>>2]=r,(r|0)<=i[A+4>>2]))break r;break e;case 0:case 1:break r;default:break f}t=i[A+20>>2],f=i[A+12>>2],k=i[A+4>>2];f:{if((f|0)<=(k|0)){if((f|0)>=(t|0)||(r=i[A+16>>2],t=i[A+20>>2],f=i[A+12>>2],i[A+16>>2]=i[A+8>>2],i[A+20>>2]=f,i[A+8>>2]=r,i[A+12>>2]=t,(k|0)>=(t|0)))break f;f=i[A+4>>2],i[A+8>>2]=i[A>>2],i[A+12>>2]=f,i[A>>2]=r,i[A+4>>2]=t;break f}if(r=i[A>>2],n=i[A+4>>2],(f|0)<(t|0)){k=i[A+16>>2],f=i[A+20>>2],i[A+16>>2]=r,i[A+20>>2]=n,i[A>>2]=k,i[A+4>>2]=f;break f}if(k=i[A+8>>2],f=i[A+12>>2],i[A+8>>2]=r,i[A+12>>2]=n,i[A>>2]=k,i[A+4>>2]=f,(n|0)>=(t|0))break f;k=i[A+16>>2],f=i[A+20>>2],i[A+16>>2]=r,i[A+20>>2]=n,i[A+8>>2]=k,i[A+12>>2]=f}if(k=A+24|0,(k|0)==(e|0))break r;for(f=A+16|0;;){f:{if(i[k+4>>2]<=i[f+4>>2])break f;for(s=i[k>>2],n=i[k+4>>2],r=k;;){A:{if(t=r,r=f,f=i[r+4>>2],i[t>>2]=i[r>>2],i[t+4>>2]=f,(A|0)==(r|0)){r=A;break A}if(f=r-8|0,i[r-4>>2]<(n|0))continue}break}if(i[r>>2]=s,i[r+4>>2]=n,o=o+1|0,(o|0)!=8)break f;return(k+8|0)==(e|0)}if(f=k,k=k+8|0,(k|0)==(e|0))break}}return 1}return f=i[A+4>>2],i[A+8>>2]=i[A>>2],i[A+12>>2]=f,i[A>>2]=e,i[A+4>>2]=r,1}return i[n>>2]=e,i[n+4>>2]=t,1}function Y9(A,e){A=A|0,e=e|0;var r=0,f=0,k=0,n=0,t=0,o=0,s=0;k=v-16|0,v=k,r=i[e+20>>2],f=i[r+48>>2],r=i[r+52>>2];i:{if(!r){n=Ie(f,e+112|0);break i}if(i[r+4>>2]=i[r+4>>2]+1,n=Ie(f,e+112|0),f=i[r+4>>2],i[r+4>>2]=f-1,f)break i;W[i[i[r>>2]+8>>2]](r),y(r)}i[e+116>>2]=i[e+112>>2],f=i[e+264>>2];i:{if(!f||(r=i[e+20>>2],o=i[r+48>>2],r=i[r+52>>2],r&&(i[r+4>>2]=i[r+4>>2]+1),i[f+16>>2]==i[f+20>>2]|l[f+28|0]!=1||(o=Ie(o,f+16|0),sA(i[f+8>>2],o),i[f+20>>2]=i[f+16>>2]),!r)||(f=i[r+4>>2],i[r+4>>2]=f-1,f))break i;W[i[i[r>>2]+8>>2]](r),y(r)}f=i[e+268>>2];i:{if(!f||(r=i[e+20>>2],o=i[r+48>>2],r=i[r+52>>2],r&&(i[r+4>>2]=i[r+4>>2]+1),i[f+16>>2]==i[f+20>>2]|l[f+28|0]!=1||(o=Ie(o,f+16|0),sA(i[f+8>>2],o),i[f+20>>2]=i[f+16>>2]),!r)||(f=i[r+4>>2],i[r+4>>2]=f-1,f))break i;W[i[i[r>>2]+8>>2]](r),y(r)}fu(i[e+196>>2],n),n=i[e+264>>2];i:{if(!n)break i;i[k+8>>2]=i[e+172>>2],r=i[e+176>>2],i[k+12>>2]=r,r&&(i[r+4>>2]=i[r+4>>2]+1),f=i[e+20>>2],i[k>>2]=i[f+48>>2],f=i[f+52>>2],i[k+4>>2]=f;e:{if(!f){zr(n,k+8|0,k);break e}if(i[f+4>>2]=i[f+4>>2]+1,zr(n,k+8|0,k),n=i[f+4>>2],i[f+4>>2]=n-1,n)break e;W[i[i[f>>2]+8>>2]](f),y(f)}if(!r||(f=i[r+4>>2],i[r+4>>2]=f-1,f))break i;W[i[i[r>>2]+8>>2]](r),y(r)}n=i[e+268>>2];i:{if(!n)break i;i[k+8>>2]=i[e+172>>2],r=i[e+176>>2],i[k+12>>2]=r,r&&(i[r+4>>2]=i[r+4>>2]+1),f=i[e+20>>2],i[k>>2]=i[f+48>>2],f=i[f+52>>2],i[k+4>>2]=f;e:{if(!f){zr(n,k+8|0,k);break e}if(i[f+4>>2]=i[f+4>>2]+1,zr(n,k+8|0,k),n=i[f+4>>2],i[f+4>>2]=n-1,n)break e;W[i[i[f>>2]+8>>2]](f),y(f)}if(!r||(f=i[r+4>>2],i[r+4>>2]=f-1,f))break i;W[i[i[r>>2]+8>>2]](r),y(r)}if(f=i[e+204>>2],r=i[f+104>>2],f=i[f+108>>2],(r|0)!=(f|0))for(;n=O0(i[r+4>>2],0,i[r>>2],0),t=t+l0|0,o=s,s=n+s|0,t=o>>>0>s>>>0?t+1|0:t,r=r+8|0,(f|0)!=(r|0););r=i[e+156>>2],i[r+128>>2]=s,i[r+132>>2]=t,t=i[e+220>>2],u[t+124|0]=i[i[e+228>>2]+108>>2]==i[t+108>>2]-i[t+104>>2]>>2,t=i[e+212>>2],s=i[t+108>>2],r=i[t+104>>2];i:{if((s|0)==(r|0)|(s-r|0)==8||(s=i[e+172>>2],i[k+8>>2]=t,e=i[e+216>>2],i[k+12>>2]=e,e&&(i[e+4>>2]=i[e+4>>2]+1),r2(s+36|0,k+8|0),e=i[k+12>>2],!e)||(t=i[e+4>>2],i[e+4>>2]=t-1,t))break i;W[i[i[e>>2]+8>>2]](e),y(e)}i[A>>2]=0,i[A+4>>2]=0,i[A+16>>2]=0,i[A+8>>2]=0,i[A+12>>2]=0,v=k+16|0}function ai(A){A=A|0;var e=0,r=0,f=0,k=0;i[A>>2]=106540,e=i[A+284>>2];i:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break i;W[i[i[e>>2]+8>>2]](e),y(e)}_i(A+276|0,0),_i(A+272|0,0),Bi(A+268|0,0),Bi(A+264|0,0),u[A+263|0]<0&&Z(i[A+252>>2]),e=i[A+248>>2];i:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break i;W[i[i[e>>2]+8>>2]](e),y(e)}e=i[A+240>>2];i:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break i;W[i[i[e>>2]+8>>2]](e),y(e)}e=i[A+232>>2];i:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break i;W[i[i[e>>2]+8>>2]](e),y(e)}e=i[A+224>>2];i:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break i;W[i[i[e>>2]+8>>2]](e),y(e)}e=i[A+216>>2];i:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break i;W[i[i[e>>2]+8>>2]](e),y(e)}e=i[A+208>>2];i:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break i;W[i[i[e>>2]+8>>2]](e),y(e)}e=i[A+200>>2];i:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break i;W[i[i[e>>2]+8>>2]](e),y(e)}e=i[A+192>>2];i:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break i;W[i[i[e>>2]+8>>2]](e),y(e)}e=i[A+184>>2];i:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break i;W[i[i[e>>2]+8>>2]](e),y(e)}e=i[A+176>>2];i:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break i;W[i[i[e>>2]+8>>2]](e),y(e)}e=i[A+168>>2];i:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break i;W[i[i[e>>2]+8>>2]](e),y(e)}e=i[A+160>>2];i:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break i;W[i[i[e>>2]+8>>2]](e),y(e)}e=i[A+152>>2];i:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break i;W[i[i[e>>2]+8>>2]](e),y(e)}e=i[A+144>>2];i:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break i;W[i[i[e>>2]+8>>2]](e),y(e)}e=i[A+136>>2];i:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break i;W[i[i[e>>2]+8>>2]](e),y(e)}e=i[A+128>>2];i:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break i;W[i[i[e>>2]+8>>2]](e),y(e)}if(e=i[A+112>>2],e&&(i[A+116>>2]=e,Z(e)),e=i[A+100>>2],e){if(r=e,f=i[A+104>>2],(e|0)!=(f|0)){for(;;){r=i[f-4>>2];i:{if(!r||(k=i[r+4>>2],i[r+4>>2]=k-1,k))break i;W[i[i[r>>2]+8>>2]](r),y(r)}if(f=f-8|0,(e|0)==(f|0))break}r=i[A+100>>2]}i[A+104>>2]=e,Z(r)}return e=i[A+68>>2],e&&(i[A+72>>2]=e,Z(e)),x2(i[A+44>>2]),u[A+63|0]<0&&Z(i[A+52>>2]),u[A+15|0]<0&&Z(i[A+4>>2]),A|0}function $i(A,e){var r=0,f=0,k=0,n=0,t=0,o=0,s=0,w=0,h=0;k=e-1|0,r=k,f=(k|0)/2|0,k=e+65535>>>0<131073,s=k?r:f,n=i[A+116>>2],t=n>>31,e=k?2:1,f=i[A+120>>2];i:{if((e|0)==(f|0)){if(r=(s>>31)+t|0,t=n+s|0,r=t>>>0<s>>>0?r+1|0:r,f=r,!(t- -2147483648>>>0<2147483648?r+1|0:r))break i;e=r>>31,r=e,e=t+(e|1)|0,r=r+f|0,t=G2(e,e>>>0<t>>>0?r+1|0:r,2,0),e=1;break i}if(e=f,o=e>>31,f=O0(e,o,s,s>>31),w=l0,h=f,s=n,f=k&31,(k&63)>>>0>=32?(r=n<<f,n=0):(r=(1<<f)-1&s>>>32-f|t<<f,n=s<<f),t=h+n|0,f=r+w|0,f=n>>>0>t>>>0?f+1|0:f,w=0-(f+(t>>>0>2147483647)|0)|0,s=e,n=k&31,(k&63)>>>0>=32?(r=e<<n,k=0):(r=(1<<n)-1&s>>>32-n|o<<n,k=s<<n),e=k,n=r,e=0-(r+(e>>>0>2147483647)|0)|w,(e|0)==1|e>>>0>1)for(;e=n>>31,r=e,e=k+(e|1)|0,r=r+n|0,k=G2(e,e>>>0<k>>>0?r+1|0:r,2,0),n=l0,e=f>>31,r=e,e=t+(e|1)|0,f=r+f|0,t=G2(e,e>>>0<t>>>0?f+1|0:f,2,0),e=l0,f=e,(e-(t>>>0<2147483648)|0)!=-1;);e=k}if(n=i[A+100>>2],f=n,k=i[A+104>>2],A=f-k|0,n=k>>31,f=(f>>31)-(n+(f>>>0<k>>>0)|0)|0,r=0-(f+(A>>>0>2147483647)|0)|0-((k>>>0>2147483647)+n|0),(r|0)==1|r>>>0>1){for(;r=n>>31,o=k+(r|1)|0,r=r+n|0,k=G2(o,k>>>0>o>>>0?r+1|0:r,2,0),n=l0,r=f>>31,o=A+(r|1)|0,f=r+f|0,A=G2(o,A>>>0>o>>>0?f+1|0:f,2,0),f=l0,(f-(A>>>0<2147483648)|0)!=-1;);n=k>>31}r=n<<1|k>>>31,k=k<<1,f=r,o=A>>31,r=0-(r+(k>>>0>2147483646)|0)|0-(o+(A>>>0>2147483647)|0),(r|0)==1|r>>>0>1&&(r=n>>31,n=k+(r|1)|0,f=r+f|0,k=G2(n,n>>>0<k>>>0?f+1|0:f,2,0),r=o>>31,n=A+(r|1)|0,r=r+o|0,A=G2(n,A>>>0>n>>>0?r+1|0:r,2,0)),n=t>>31;i:{if((e|0)==(k|0)){if(k=A,f=t-k|0,n=n-((k>>31)+(k>>>0>t>>>0)|0)|0,k=f,A=e,f=e>>31,!(0-(n+(k>>>0>2147483647)|0)|0-(f+(e>>>0>2147483647)|0)))break i;for(;e=f>>31,r=e,e=A+(e|1)|0,r=r+f|0,A=G2(e,A>>>0>e>>>0?r+1|0:r,2,0),f=l0,e=n>>31,t=k+(e|1)|0,e=e+n|0,k=G2(t,k>>>0>t>>>0?e+1|0:e,2,0),e=l0,n=e,(e-(k>>>0<2147483648)|0)!=-1;);e=A;break i}if(f=k>>31,n=O0(k,f,t,n),r=l0,o=e>>31,A=O0(e,o,A,A>>31),t=n-A|0,n=r-(l0+(A>>>0>n>>>0)|0)|0,A=O0(k,f,e,o),k=t,f=l0,e=0-((k>>>0>2147483647)+n|0)|0-(f+(A>>>0>2147483647)|0),(e|0)==1|e>>>0>1)for(;e=f>>31,r=e,e=A+(e|1)|0,r=r+f|0,A=G2(e,A>>>0>e>>>0?r+1|0:r,2,0),t=l0,f=t,r=f-(A>>>0<2147483648)|0,e=n>>31,t=k+(e|1)|0,e=e+n|0,k=G2(t,k>>>0>t>>>0?e+1|0:e,2,0),e=l0,n=e,(e-(k>>>0<2147483648)&r)!=-1;);e=A}return(k|0)/(e|0)|0}function wm(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,t=0,o=0,s=0,w=0;f=v-160|0,v=f,i[f+92>>2]=0,i[f+64>>2]=72196,i[f+8>>2]=72176,k=i[18053],i[f>>2]=k,i[i[k-12>>2]+f>>2]=i[18054],i[f+4>>2]=0,k=i[i[f>>2]-12>>2]+f|0,s=f+12|0,J0(k,s),u[k+80|0]=0,i[k+72>>2]=0,k=i[18055],i[f+8>>2]=k,t=f+8|0,i[t+i[k-12>>2]>>2]=i[18056],k=i[18052],i[f>>2]=k,i[i[k-12>>2]+f>>2]=i[18057],i[f+64>>2]=72196,i[f>>2]=72156,i[f+8>>2]=72176,s=R0(s),i[s>>2]=71232,i[f+52>>2]=0,i[f+56>>2]=0,i[f+44>>2]=0,i[f+48>>2]=0,i[f+60>>2]=24,k=f+148|0,U1(k,e,r),o=k,k=u[f+159|0],n=(k|0)<0,Y(t,n?i[f+148>>2]:o,n?i[f+152>>2]:k),u[f+159|0]<0&&Z(i[f+148>>2]),k=f+148|0,s0(k,r),o=k,k=u[f+159|0],n=(k|0)<0,Y(t,n?i[f+148>>2]:o,n?i[f+152>>2]:k),u[f+159|0]<0&&Z(i[f+148>>2]),Y(t,31607,15),k=i[e+104>>2];i:{if(!k){Y(t,41805,2);break i}if(n=f+148|0,L1(n,k),o=n,k=u[f+159|0],n=(k|0)<0,Y(Y(t,n?i[f+148>>2]:o,n?i[f+152>>2]:k),42670,1),u[f+159|0]>=0)break i;Z(i[f+148>>2])}k=f+148|0,s0(k,r),o=k,k=u[f+159|0],n=(k|0)<0,Y(t,n?i[f+148>>2]:o,n?i[f+152>>2]:k),u[f+159|0]<0&&Z(i[f+148>>2]),Y(t,30340,25),k=i[e+108>>2];i:{if(!k){Y(t,41805,2);break i}if(n=f+148|0,L1(n,k),o=n,k=u[f+159|0],n=(k|0)<0,Y(Y(t,n?i[f+148>>2]:o,n?i[f+152>>2]:k),42670,1),u[f+159|0]>=0)break i;Z(i[f+148>>2])}k=f+148|0,s0(k,r),o=k,k=u[f+159|0],n=(k|0)<0,Y(t,n?i[f+148>>2]:o,n?i[f+152>>2]:k),u[f+159|0]<0&&Z(i[f+148>>2]),Y(t,31258,21),k=l[e+112|0];i:{if(!k){Y(t,42491,13);break i}Y(S0(t,k),42670,1)}if(!(l[e+112|0]|i[e+124>>2]==i[e+120>>2]))for(k=0;n=f+148|0,s0(n,r),o=n,n=u[f+159|0],w=(n|0)<0,Y(t,w?i[f+148>>2]:o,w?i[f+152>>2]:n),u[f+159|0]<0&&Z(i[f+148>>2]),Y(S0(Y(V0(Y(t,19205,1),k),32722,4),l[i[e+120>>2]+k|0]),42670,1),k=k+1|0,k>>>0<i[e+124>>2]-i[e+120>>2]>>>0;);e=i[f+60>>2];i:{e:{if(e&16){k=i[f+56>>2],e=i[f+36>>2],k>>>0<e>>>0&&(i[f+56>>2]=e,k=e),e=f+32|0;break e}if(!(e&8)){k=0,u[A+11|0]=0;break i}k=i[f+28>>2],e=f+20|0}e:{if(r=i[e>>2],k=k-r|0,k>>>0<2147483640){if(k>>>0>=11){t=k|7,e=p(t+1|0),i[A+8>>2]=t-2147483647,i[A>>2]=e,i[A+4>>2]=k,A=e;break e}if(u[A+11|0]=k,k)break e;k=0;break i}Q0(),H()}if(!k)break i;x(A,r,k)}u[A+k|0]=0,A=i[18051],i[f>>2]=A,i[i[A-12>>2]+f>>2]=i[18059],i[f+8>>2]=i[18060],i[s>>2]=71232,u[f+55|0]<0&&Z(i[f+44>>2]),E0(s),y0(f- -64|0),v=f+160|0}function G8(A,e,r){var f=0,k=0,n=0,t=0,o=0,s=0,w=0;i:{e:switch(r|0){case 1:for(r=0,k=i[i[15774]+12>>2];n=k+(r<<1)|0,u[((l[n+1|0]<<3)+A|0)+l[n|0]|0]=l[e+r|0],n=r|1,o=k+(n<<1)|0,u[((l[o+1|0]<<3)+A|0)+l[o|0]|0]=l[e+n|0],r=r+2|0,(r|0)!=64;);break i;case 2:for(n=A+1|0,o=i[i[15774]+12>>2];r=o+(k<<1)|0,t=e+k|0,s=l[t|0],u[((l[r|0]<<1)+A|0)+(l[r+1|0]<<5)|0]=s,u[(n+(l[r|0]<<1)|0)+(l[r+1|0]<<5)|0]=s,t=l[t|0],u[(((l[r|0]<<1)+A|0)+(l[r+1|0]<<5)|0)+16|0]=t,u[((n+(l[r|0]<<1)|0)+(l[r+1|0]<<5)|0)+16|0]=t,k=k+1|0,(k|0)!=64;);break i;case 3:for(n=A+3|0,o=A+2|0,t=A+1|0,w=i[i[15774]+12>>2];r=(s<<1)+w|0,k=e+s|0,f=l[k|0],u[((l[r|0]<<2)+A|0)+(l[r+1|0]<<7)|0]=f,u[(t+(l[r|0]<<2)|0)+(l[r+1|0]<<7)|0]=f,f=l[k|0],u[(o+(l[r|0]<<2)|0)+(l[r+1|0]<<7)|0]=f,u[(n+(l[r|0]<<2)|0)+(l[r+1|0]<<7)|0]=f,f=l[k|0],u[(((l[r|0]<<2)+A|0)+(l[r+1|0]<<7)|0)+32|0]=f,u[((t+(l[r|0]<<2)|0)+(l[r+1|0]<<7)|0)+32|0]=f,f=l[k|0],u[((o+(l[r|0]<<2)|0)+(l[r+1|0]<<7)|0)+32|0]=f,u[((n+(l[r|0]<<2)|0)+(l[r+1|0]<<7)|0)+32|0]=f,f=l[k|0],u[(((l[r|0]<<2)+A|0)+(l[r+1|0]<<7)|0)+64|0]=f,u[((t+(l[r|0]<<2)|0)+(l[r+1|0]<<7)|0)+64|0]=f,f=l[k|0],u[((o+(l[r|0]<<2)|0)+(l[r+1|0]<<7)|0)+64|0]=f,u[((n+(l[r|0]<<2)|0)+(l[r+1|0]<<7)|0)+64|0]=f,f=l[k|0],u[(((l[r|0]<<2)+A|0)+(l[r+1|0]<<7)|0)+96|0]=f,u[((t+(l[r|0]<<2)|0)+(l[r+1|0]<<7)|0)+96|0]=f,k=l[k|0],u[((o+(l[r|0]<<2)|0)+(l[r+1|0]<<7)|0)+96|0]=k,u[((n+(l[r|0]<<2)|0)+(l[r+1|0]<<7)|0)+96|0]=k,s=s+1|0,(s|0)!=64;);break i;default:D0(22181,18188,865,6314),H();case 0:break e}r=i[i[15774]+8>>2],u[((l[r+1|0]<<2)+A|0)+l[r|0]|0]=l[e|0],u[l[r+2|0]+((l[r+3|0]<<2)+A|0)|0]=l[e+1|0],u[l[r+4|0]+((l[r+5|0]<<2)+A|0)|0]=l[e+2|0],u[l[r+6|0]+((l[r+7|0]<<2)+A|0)|0]=l[e+3|0],u[l[r+8|0]+((l[r+9|0]<<2)+A|0)|0]=l[e+4|0],u[l[r+10|0]+((l[r+11|0]<<2)+A|0)|0]=l[e+5|0],u[l[r+12|0]+((l[r+13|0]<<2)+A|0)|0]=l[e+6|0],u[l[r+14|0]+((l[r+15|0]<<2)+A|0)|0]=l[e+7|0],u[l[r+16|0]+((l[r+17|0]<<2)+A|0)|0]=l[e+8|0],u[l[r+18|0]+((l[r+19|0]<<2)+A|0)|0]=l[e+9|0],u[l[r+20|0]+((l[r+21|0]<<2)+A|0)|0]=l[e+10|0],u[l[r+22|0]+((l[r+23|0]<<2)+A|0)|0]=l[e+11|0],u[l[r+24|0]+((l[r+25|0]<<2)+A|0)|0]=l[e+12|0],u[l[r+26|0]+((l[r+27|0]<<2)+A|0)|0]=l[e+13|0],u[l[r+28|0]+((l[r+29|0]<<2)+A|0)|0]=l[e+14|0],u[l[r+30|0]+((l[r+31|0]<<2)+A|0)|0]=l[e+15|0]}}function hm(A,e,r,f,k,n,t,o){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,t=t|0,o=o|0;var s=0,w=0,h=0,_=0,B=0,m=0,X=0,Q=0,V=0,F=0,I=0,E=0,R=0,N=0,M=0,z=0,S=0,O=0;s=v-32|0,v=s,n=p(172),i[n+4>>2]=0,i[n+8>>2]=0,i[n>>2]=94812,o0(n+16|0,0,80),e=i[n+4>>2],t=e+1|0,i[n+4>>2]=t,i[n+104>>2]=0,i[n+108>>2]=0,i[n+36>>2]=1,i[n+40>>2]=1,u[n+24|0]=1,g[n+22>>1]=2,g[n+18>>1]=2,g[n+20>>1]=2,i[n+112>>2]=0,i[n+116>>2]=4740,i[n+140>>2]=0,i[n+144>>2]=0,i[n+128>>2]=99,i[n+132>>2]=99,i[n+120>>2]=0,i[n+124>>2]=0,i[n+12>>2]=95160,i[n+148>>2]=0,i[n+152>>2]=0,f=n+140|0,i[n+136>>2]=f,i[n+156>>2]=0,i[n+160>>2]=0,i[n+164>>2]=0,i[n+168>>2]=0,i[n+4>>2]=e,e=i[n+8>>2],B=n+12|0,i[n+96>>2]=B,i[n+8>>2]=e+1,i[n+100>>2]=n,t||(W[i[i[n>>2]+8>>2]](n),y(n)),e=i[r>>2],t=i[e+108>>2],w=i[e+112>>2],_=i[e+116>>2],i[B+120>>2]=i[e+120>>2],i[B+116>>2]=_,i[B+112>>2]=w,i[B+108>>2]=t;i:{e:{for(;;){h=i[V+58364>>2];r:{if(!u1(i[r>>2],h))break r;if(Q=o8(i[r>>2],h),F=l8(i[r>>2],h),T0(s+8|0,B,h,Q,F,i[k+12>>2],o),i[s+8>>2]){if(e=i[s+12>>2],i[A>>2]=i[s+8>>2],i[A+4>>2]=e,e=A+8|0,u[s+27|0]>=0){r=i[s+20>>2],i[e>>2]=i[s+16>>2],i[e+4>>2]=r,i[e+8>>2]=i[s+24>>2],u[A+20|0]=1;break e}if(T(e,i[s+16>>2],i[s+20>>2]),e=u[s+27|0],u[A+20|0]=1,(e|0)>=0)break e;Z(i[s+16>>2]);break e}u[s+27|0]<0&&Z(i[s+16>>2]),X=j0(i[r>>2],h),M=0,t=i[r>>2],w=t+128|0,e=w;f:{A:{if(t=i[t+128>>2],!t)break A;for(;_=(h|0)>i[t+16>>2],e=_?e:t,t=i[(_?4:0)+t>>2],!!t;);if((e|0)==(w|0))break A;if(I=0,_=0,(h|0)<i[e+16>>2])break f;I=i[e+44>>2],_=i[e+56>>2];break f}I=0,_=0}e=f,t=i[e>>2],w=0;f:{if(!t)break f;for(;w=(h|0)>i[t+16>>2],e=w?e:t,t=i[(w?4:0)+t>>2],!!t;);if((e|0)==(f|0)){w=0;break f}if(w=0,(h|0)<i[e+16>>2])break f;M=i[e+56>>2]>>>1|0,w=i[e+44>>2]}if(!F|!Q)break r;for(e=i[k+12>>2],h=(X<<1)-e|0,X=e-X|0,S=Q&-2,O=Q&1,e=0;;){if(E=G(e,_)+I|0,R=(G(e,M)<<1)+w|0,t=0,N=0,(Q|0)!=1)for(;m=l[t+E|0],g[R+(t<<1)>>1]=m<<X|m>>>h,z=t|1,m=l[z+E|0],g[R+(z<<1)>>1]=m<<X|m>>>h,t=t+2|0,N=N+2|0,(S|0)!=(N|0););if(O&&(m=R+(t<<1)|0,t=l[t+E|0],g[m>>1]=t<<X|t>>>h),e=e+1|0,(F|0)==(e|0))break}}if(V=V+4|0,(V|0)==28)break}u[A+20|0]=0,i[A+4>>2]=n,i[A>>2]=B;break i}if(A=i[n+4>>2],i[n+4>>2]=A-1,A)break i;W[i[i[n>>2]+8>>2]](n),y(n)}v=s+32|0}function _m(A,e,r,f,k,n){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0;var t=0,o=0,s=0,w=0;k=v-112|0,v=k,t=i[r>>2],e=i[r+4>>2],e&&(i[e+4>>2]=i[e+4>>2]+1),i[k+108>>2]=e,i[k+104>>2]=t,W[i[i[f>>2]+100>>2]](k+92|0,i[f+4>>2],k+104|0,n);i:{e:{r:{r=i[k+92>>2];f:{if(r){if(f=i[k+96>>2],t=i[k+100>>2],e=h2(t),e>>>0>=2147483640)break r;A:{k:{if(e>>>0>=11){o=e|7,n=p(o+1|0),i[k+68>>2]=o-2147483647,i[k+60>>2]=n,i[k+64>>2]=e;break k}if(u[k+71|0]=e,n=k+60|0,!e)break A}if(!e)break A;x(n,t,e)}u[e+n|0]=0,e=q(k+72|0,r,f,k+60|0),r=i[e+4>>2],i[A>>2]=i[e>>2],i[A+4>>2]=r,r=A+8|0;A:{if(u[e+19|0]>=0){f=i[e+12>>2],i[r>>2]=i[e+8>>2],i[r+4>>2]=f,i[r+8>>2]=i[e+16>>2],u[A+44|0]=1;break A}if(T(r,i[e+8>>2],i[e+12>>2]),r=u[e+19|0],u[A+44|0]=1,(r|0)>=0)break A;Z(i[e+8>>2])}u[k+71|0]<0&&Z(i[k+60>>2]),r=0;break f}i[k+80>>2]=0,i[k+72>>2]=0,i[k+76>>2]=0,W[i[i[f>>2]+104>>2]](k+60|0,i[f+4>>2],k+56|0,k+52|0,0);A:{if(!i[k+56>>2]){t=0,r=0;break A}for(n=0,t=0;;){r=t-n|0,o=i[k+52>>2],s=r+o|0;k:{if(s>>>0>r>>>0){if(e=i[k+80>>2],o>>>0<=e-t>>>0){o&&o0(t,0,o),t=t+o|0,i[k+76>>2]=t,n=i[k+72>>2];break k}if((s|0)<0)break e;if(e=e-n|0,t=e<<1,t=e>>>0>=1073741823?2147483647:t>>>0>s>>>0?t:s,e=p(t),o&&o0(e+r|0,0,o),r&&x(e,n,r),i[k+80>>2]=e+t,t=e+s|0,i[k+76>>2]=t,i[k+72>>2]=e,!n){n=e;break k}Z(n),n=e;break k}if(r>>>0<=s>>>0)break k;t=n+s|0,i[k+76>>2]=t}if(e=i[k+52>>2],e&&x(r+n|0,i[k+56>>2],e),W[i[i[f>>2]+104>>2]](k+60|0,i[f+4>>2],k+56|0,k+52|0,0),!i[k+56>>2])break}r=i[k+72>>2]}if(i[k+16>>2]=0,i[k+20>>2]=0,i[k+24>>2]=0,i[k+28>>2]=0,i[k+8>>2]=0,i[k+12>>2]=0,n=0,(r|0)!=(t|0)){if(e=t-r|0,(e|0)<0)break i;n=p(e),e&&x(n,r,e),w=e+n|0}i[k+48>>2]=0,u[k+47|0]=l[k+62|0],u[k+44|0]=1,i[k+36>>2]=0,i[k+40>>2]=0,u[k+34|0]=0,g[k+32>>1]=1,e=l[k+60|0]|l[k+61|0]<<8,u[k+45|0]=e,u[k+46|0]=e>>>8,i[A+8>>2]=0,i[A>>2]=0,i[A+4>>2]=0,i[k+16>>2]=0,i[k+8>>2]=0,i[k+12>>2]=0,i[A+20>>2]=w,i[A+16>>2]=w,i[A+12>>2]=n,i[k+28>>2]=0,i[k+20>>2]=0,i[k+24>>2]=0,e=i[k+40>>2],f=i[k+44>>2],n=i[k+48>>2],t=i[k+32>>2],o=i[k+36>>2],u[A+44|0]=0,i[A+40>>2]=n,i[A+32>>2]=e,i[A+36>>2]=f,i[A+24>>2]=t,i[A+28>>2]=o}A=i[k+108>>2];f:{if(!A||(e=i[A+4>>2],i[A+4>>2]=e-1,e))break f;W[i[i[A>>2]+8>>2]](A),y(A)}r&&Z(r),v=k+112|0;return}Q0(),H()}G0(),H()}G0(),H()}function Ef(A,e,r){var f=0,k=0,n=0,t=0,o=0;k=v-48|0,v=k,n=i[e+48>>2],t=i[e+52>>2],t&&(i[t+4>>2]=i[t+4>>2]+1),f=v-32|0,v=f,i[f+28>>2]=0,i[f+20>>2]=0,i[f+24>>2]=0,j1(f,n,r,f+20|0);i:{if(i[f>>2]){i[k+40>>2]=0,i[k+44>>2]=0;break i}e:{if(n=i[f+20>>2],r=i[f+24>>2],(n|0)!=(r|0)){if(e=i[n>>2],e&&(o=i[k+44>>2],e=W0(e,86580,89652),e))break e;if(n=n+8|0,(r|0)!=(n|0))for(;;){if(e=i[n>>2],e&&(o=0,e=W0(e,86580,89652),e))break e;if(n=n+8|0,(r|0)==(n|0))break}i[k+40>>2]=0,i[k+44>>2]=0}i[k+40>>2]=0,i[k+44>>2]=0;break i}if(i[k+44>>2]=o,i[k+40>>2]=e,e=i[n+4>>2],i[k+44>>2]=e,!e)break i;i[e+4>>2]=i[e+4>>2]+1}if(u[f+19|0]<0&&Z(i[f+8>>2]),r=i[f+20>>2],r){if(e=r,n=i[f+24>>2],(e|0)!=(n|0)){for(;;){e=i[n-4>>2];i:{if(!e||(o=i[e+4>>2],i[e+4>>2]=o-1,o))break i;W[i[i[e>>2]+8>>2]](e),y(e)}if(n=n-8|0,(r|0)==(n|0))break}e=i[f+20>>2]}i[f+24>>2]=r,Z(e)}v=f+32|0,e=i[k+40>>2];i:{if(!e){e=p(32),i[k+4>>2]=e,i[k+8>>2]=26,i[k+12>>2]=-2147483616,r=l[9611]|l[9612]<<8,u[e+24|0]=r,u[e+25|0]=r>>>8,r=l[9607]|l[9608]<<8|(l[9609]<<16|l[9610]<<24),f=l[9603]|l[9604]<<8|(l[9605]<<16|l[9606]<<24),u[e+16|0]=f,u[e+17|0]=f>>>8,u[e+18|0]=f>>>16,u[e+19|0]=f>>>24,u[e+20|0]=r,u[e+21|0]=r>>>8,u[e+22|0]=r>>>16,u[e+23|0]=r>>>24,r=l[9599]|l[9600]<<8|(l[9601]<<16|l[9602]<<24),f=l[9595]|l[9596]<<8|(l[9597]<<16|l[9598]<<24),u[e+8|0]=f,u[e+9|0]=f>>>8,u[e+10|0]=f>>>16,u[e+11|0]=f>>>24,u[e+12|0]=r,u[e+13|0]=r>>>8,u[e+14|0]=r>>>16,u[e+15|0]=r>>>24,r=l[9591]|l[9592]<<8|(l[9593]<<16|l[9594]<<24),f=l[9587]|l[9588]<<8|(l[9589]<<16|l[9590]<<24),u[e|0]=f,u[e+1|0]=f>>>8,u[e+2|0]=f>>>16,u[e+3|0]=f>>>24,u[e+4|0]=r,u[e+5|0]=r>>>8,u[e+6|0]=r>>>16,u[e+7|0]=r>>>24,u[e+26|0]=0,e=q(k+16|0,2,116,k+4|0),r=i[e+4>>2],i[A>>2]=i[e>>2],i[A+4>>2]=r,r=A+8|0;e:{if(u[e+19|0]>=0){f=i[e+12>>2],i[r>>2]=i[e+8>>2],i[r+4>>2]=f,i[r+8>>2]=i[e+16>>2],u[A+20|0]=1;break e}if(T(r,i[e+8>>2],i[e+12>>2]),r=u[e+19|0],u[A+20|0]=1,(r|0)>=0)break e;Z(i[e+8>>2])}if(u[k+15|0]<0&&Z(i[k+4>>2]),A=i[k+44>>2],!A||(e=i[A+4>>2],i[A+4>>2]=e-1,e))break i;W[i[i[A>>2]+8>>2]](A),y(A);break i}r=i[k+44>>2],u[A+20|0]=0,i[A+4>>2]=r,i[A>>2]=e}i:{if(!t||(A=i[t+4>>2],i[t+4>>2]=A-1,A))break i;W[i[i[t>>2]+8>>2]](t),y(t)}v=k+48|0}function Bm(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0;var k=0,n=0,t=0,o=0,s=0,w=0,h=0;f=v-160|0,v=f,n=o2(r);i:{e:{r:{f:{A:{k:{if(n>>>0>u0[r+16>>2]/5>>>0){i[f+92>>2]=0,i[f+64>>2]=72196,i[f+8>>2]=72176,e=i[18053],i[f>>2]=e,i[i[e-12>>2]+f>>2]=i[18054],i[f+4>>2]=0,e=i[i[f>>2]-12>>2]+f|0,k=f+12|0,J0(e,k),u[e+80|0]=0,i[e+72>>2]=0,e=i[18055],i[f+8>>2]=e,t=i[e-12>>2],e=f+8|0,i[t+e>>2]=i[18056],t=i[18052],i[f>>2]=t,i[i[t-12>>2]+f>>2]=i[18057],i[f+64>>2]=72196,i[f>>2]=72156,i[f+8>>2]=72176,t=R0(k),i[t>>2]=71232,i[f+52>>2]=0,i[f+56>>2]=0,i[f+44>>2]=0,i[f+48>>2]=0,i[f+60>>2]=24,Y(V0(Y(V0(Y(e,28811,25),n),27478,44),u0[r+16>>2]/5|0),5497,15),e=i[f+60>>2];n:{if(e&16){k=f+32|0,r=i[f+56>>2],e=i[f+36>>2],r>>>0<e>>>0?i[f+56>>2]=e:e=r;break n}if(!(e&8)){r=0,u[f+159|0]=0,k=f+148|0;break e}k=f+20|0,e=i[f+28>>2]}if(r=e,e=i[k>>2],r=r-e|0,r>>>0>=2147483640)break k;if(r>>>0>=11){n=r|7,k=p(n+1|0),i[f+156>>2]=n-2147483647,i[f+148>>2]=k,i[f+152>>2]=r;break r}if(u[f+159|0]=r,k=f+148|0,r)break r;r=0;break e}t=e+104|0,o=i[e+104>>2],k=(i[e+108>>2]-o|0)/6|0;n:{if(k>>>0<n>>>0){Ht(t,n-k|0);break n}if(k>>>0<=n>>>0)break n;i[e+108>>2]=o+G(n,6)}k=l[r+20|0];n:{if(!(!i[r+16>>2]|(!n|k&1))){for(k=0;;){t:{if(s=o2(r),w=X2(r),h=o2(r),o=i[t>>2]+G(k,6)|0,g[o+4>>1]=h,u[o+2|0]=w,g[o>>1]=s,o=l[r+20|0],k=k+1|0,o&1|n>>>0<=k>>>0)break t;if(i[r+16>>2])continue}break}if(o&1)break n;break A}if(!(k&1))break A}if(u[f+148|0]=0,u[f+159|0]=0,q(f,2,100,f+148|0),u[f+159|0]>=0)break f;Z(i[f+148>>2]);break f}Q0(),H()}if(k=i[26917],i[f>>2]=i[26916],i[f+4>>2]=k,k=f+8|0,u[107683]>=0){n=i[26919],i[k>>2]=i[26918],i[k+4>>2]=n,i[k+8>>2]=i[26920];break f}T(k,i[26918],i[26919])}if(k=i[f>>2],u[f+19|0]<0&&Z(i[f+8>>2]),k&&(i[e+108>>2]=i[e+104>>2]),l[r+20|0]==1){if(u[f|0]=0,u[f+11|0]=0,q(A,2,100,f),u[f+11|0]>=0)break i;Z(i[f>>2]);break i}if(e=i[26917],i[A>>2]=i[26916],i[A+4>>2]=e,A=A+8|0,u[107683]>=0){e=i[26919],i[A>>2]=i[26918],i[A+4>>2]=e,i[A+8>>2]=i[26920];break i}T(A,i[26918],i[26919]);break i}if(!r)break e;x(k,e,r)}u[r+k|0]=0,q(A,2,100,f+148|0),u[f+159|0]<0&&Z(i[f+148>>2]),A=i[18051],i[f>>2]=A,i[i[A-12>>2]+f>>2]=i[18059],i[f+8>>2]=i[18060],i[t>>2]=71232,u[f+55|0]<0&&Z(i[f+44>>2]),E0(t),y0(f- -64|0)}v=f+160|0}function vm(A,e,r,f,k,n,t){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,t=t|0;var o=0,s=0,w=0,h=0;s=v-32|0,v=s;i:{e:{r:{f:{if(o=i[e+16>>2],(W[i[i[o>>2]+8>>2]](o)|0)==5){A:{if(!(!k|(!r|!f))&&n)break A;e=i[23570],i[A>>2]=i[23569],i[A+4>>2]=e,i[A+8>>2]=i[23571];break i}if(o=i[e+16>>2],!o||(w=W0(o,94756,95960),!w))break f;o=i[e+20>>2],o&&(i[o+4>>2]=i[o+4>>2]+1),i[r>>2]=i[w+4>>2],i[f>>2]=i[w+8>>2],h=i[w+12>>2],i[k>>2]=h,e=n,n=i[w+16>>2],i[e>>2]=n,w=i[w+20>>2],Df(s+16|0,h,n,2,0,t);A:{if(i[s+16>>2]){e=i[s+20>>2],i[A>>2]=i[s+16>>2],i[A+4>>2]=e,i[A+8>>2]=i[s+24>>2];break A}if(uo(s+4|0,i[t>>2],0,h,n,8),i[s+24>>2]=i[s+12>>2],r=i[s+8>>2],e=i[s+4>>2],i[s+16>>2]=e,i[s+20>>2]=r,e){x4(i[t>>2]),i[A+8>>2]=i[s+24>>2],e=i[s+20>>2],i[A>>2]=i[s+16>>2],i[A+4>>2]=e;break A}if(r=0,t=hi(i[t>>2],0,s+4|0),!(!h|!n))for(k=0,f=0;;){for(e=0;u[(t+G(i[s+4>>2],r)|0)+e|0]=(l[((f&7)<<29|k>>>3)+w|0]<<(k&7)&128)>>>7|0?-1:0,k=k+1|0,f=k?f:f+1|0,e=e+1|0,(h|0)!=(e|0););if(r=r+1|0,(n|0)==(r|0))break}e=i[24057],i[A>>2]=i[24056],i[A+4>>2]=e,i[A+8>>2]=i[24058]}if(!o||(A=i[o+4>>2],i[o+4>>2]=A-1,A))break i;W[i[i[o>>2]+8>>2]](o),y(o);break i}if(o=i[e+16>>2],(W[i[i[o>>2]+8>>2]](o)|0)==4){A:{if(!(!k|(!r|!f))&&n)break A;r=i[23570],i[A>>2]=i[23569],i[A+4>>2]=r,i[A+8>>2]=i[23571],r=0;break e}if(o=i[e+16>>2],!o||(w=W0(o,94756,95872),!w))break r;if(o=i[e+20>>2],o&&(i[o+4>>2]=i[o+4>>2]+1),i[r>>2]=i[w+4>>2],i[f>>2]=i[w+8>>2],i[k>>2]=i[w+12>>2],i[n>>2]=i[w+16>>2],r=i[w+20>>2],i[A+8>>2]=i[24058],f=i[24057],i[A>>2]=i[24056],i[A+4>>2]=f,!o||(f=i[o+4>>2],i[o+4>>2]=f-1,f))break e;W[i[i[o>>2]+8>>2]](o),y(o);break e}e=i[24170],i[A>>2]=i[24169],i[A+4>>2]=e,i[A+8>>2]=i[24171];break i}e=i[24170],i[A>>2]=i[24169],i[A+4>>2]=e,i[A+8>>2]=i[24171];break i}r=i[24170],i[A>>2]=i[24169],i[A+4>>2]=r,i[A+8>>2]=i[24171],r=0}if(i[A>>2]||(f=i[e>>2],e=i[e+4>>2],e&&(i[e+4>>2]=i[e+4>>2]+1),i[s+8>>2]=e,i[s+4>>2]=f,qf(A,s+4|0,r,s),i[A>>2]||(xf(s+16|0,i[s>>2],t,2,0,0),i[A+8>>2]=i[s+24>>2],e=i[s+20>>2],i[A>>2]=i[s+16>>2],i[A+4>>2]=e,U6(i[s>>2])),A=i[s+8>>2],!A)||(e=i[A+4>>2],i[A+4>>2]=e-1,e))break i;W[i[i[A>>2]+8>>2]](A),y(A)}v=s+32|0}function mm(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,t=0,o=0,s=0;f=v-176|0,v=f,i[f+108>>2]=0,i[f+80>>2]=72500,n=i[18128],i[f+24>>2]=n,k=i[n-12>>2],n=f+24|0,i[k+n>>2]=i[18129],s=n+i[i[f+24>>2]-12>>2]|0,k=f+28|0,J0(s,k),u[s+80|0]=0,i[s+72>>2]=0,i[f+80>>2]=72500,i[f+24>>2]=72480,s=R0(k),i[s>>2]=71232,i[f+68>>2]=0,i[f+72>>2]=0,i[f+60>>2]=0,i[f+64>>2]=0,i[f+76>>2]=16,k=f+164|0,Xr(k,e,r),t=n,o=k,n=u[f+175|0],k=(n|0)<0,Y(t,k?i[f+164>>2]:o,k?i[f+168>>2]:n),u[f+175|0]<0&&Z(i[f+164>>2]),n=f+164|0,s0(n,r),t=n,n=u[f+175|0],k=(n|0)<0,Y(f+24|0,k?i[f+164>>2]:t,k?i[f+168>>2]:n),u[f+175|0]<0&&Z(i[f+164>>2]),n=Y(f+24|0,32095,13),k=f+12|0,L1(k,i[e+100>>2]),t=n,o=k,n=u[f+23|0],k=(n|0)<0,n=Y(Y(t,k?i[f+12>>2]:o,k?i[f+16>>2]:n),42670,1),k=f+164|0,s0(k,r),t=k,k=u[f+175|0],o=(k|0)<0,Y(n,o?i[f+164>>2]:t,o?i[f+168>>2]:k),u[f+175|0]<0&&Z(i[f+164>>2]),Y(n,30770,15),u[f+23|0]<0&&Z(i[f+12>>2]),n=i[e+104>>2];i:{if(n>>>0<=1090519039){V0(f+24|0,n);break i}if(k=f+164|0,L1(k,n),t=k,n=u[f+175|0],k=(n|0)<0,Y(f+24|0,k?i[f+164>>2]:t,k?i[f+168>>2]:n),u[f+175|0]>=0)break i;Z(i[f+164>>2])}n=Y(f+24|0,42670,1),k=f+164|0,s0(k,r),t=k,r=u[f+175|0],k=(r|0)<0,Y(n,k?i[f+164>>2]:t,k?i[f+168>>2]:r),u[f+175|0]<0&&Z(i[f+164>>2]),Y(n,30200,19),r=i[e+108>>2],n=i[e+112>>2];i:{if((r|0)==(n|0)||(e=f+164|0,L1(e,i[r>>2]),t=e,e=u[f+175|0],k=(e|0)<0,Y(f+24|0,k?i[f+164>>2]:t,k?i[f+168>>2]:e),u[f+175|0]<0&&Z(i[f+164>>2]),e=r+4|0,(n|0)==(e|0)))break i;for(;k=i[e>>2],u[f+164|0]=44,o=f+24|0,r=f+164|0,Y(o,r,1),L1(r,k),t=r,r=u[f+175|0],k=(r|0)<0,Y(o,k?i[f+164>>2]:t,k?i[f+168>>2]:r),u[f+175|0]<0&&Z(i[f+164>>2]),e=e+4|0,(n|0)!=(e|0););}Y(f+24|0,42670,1),e=i[f+76>>2];i:{e:{if(e&16){e=i[f+72>>2],r=i[f+52>>2],e>>>0<r>>>0&&(i[f+72>>2]=r,e=r),r=f+48|0;break e}if(!(e&8)){e=0,u[A+11|0]=0;break i}e=i[f+44>>2],r=f+36|0}e:{if(n=i[r>>2],e=e-n|0,e>>>0<2147483640){if(e>>>0>=11){k=e|7,r=p(k+1|0),i[A+8>>2]=k-2147483647,i[A>>2]=r,i[A+4>>2]=e,A=r;break e}if(u[A+11|0]=e,e)break e;e=0;break i}Q0(),H()}if(!e)break i;x(A,n,e)}u[A+e|0]=0,A=i[18127],i[f+24>>2]=A,i[i[A-12>>2]+(f+24|0)>>2]=i[18130],i[s>>2]=71232,u[f+71|0]<0&&Z(i[f+60>>2]),E0(s),y0(f+80|0),v=f+176|0}function Zm(A,e){A=A|0,e=e|0;var r=0,f=0,k=0,n=0,t=0,o=0,s=0,w=0,h=0,_=0,B=0,m=0;if(k=v-48|0,v=k,i[k+44>>2]=0,i[k+36>>2]=0,i[k+40>>2]=0,e=i[e+64>>2],h=i[e+132>>2],B=i[e+136>>2],(h|0)!=(B|0))for(;;){i:{if(s=i[h+4>>2],m=i[h+8>>2],(s|0)==(m|0))break i;for(;;){e:{o=i[s+4>>2]-i[s>>2]>>>24|0,e=i[k+40>>2],f=i[k+44>>2];r:{if(e>>>0<f>>>0){u[e|0]=o,e=e+1|0;break r}if(n=i[k+36>>2],e=e-n|0,r=e+1|0,(r|0)<0)break e;if(f=f-n|0,t=f<<1,f=f>>>0>=1073741823?2147483647:r>>>0<t>>>0?t:r,f?r=p(f):r=0,t=r+e|0,u[t|0]=o,e&&x(r,n,e),i[k+44>>2]=r+f,e=t+1|0,i[k+40>>2]=e,i[k+36>>2]=r,!n)break r;Z(n)}i[k+40>>2]=e,o=i[s+4>>2]-i[s>>2]>>>16|0,f=i[k+44>>2];r:{if(f>>>0>e>>>0){u[e|0]=o,e=e+1|0;break r}if(n=i[k+36>>2],e=e-n|0,r=e+1|0,(r|0)<0)break e;if(f=f-n|0,t=f<<1,f=f>>>0>=1073741823?2147483647:r>>>0<t>>>0?t:r,f?r=p(f):r=0,t=r+e|0,u[t|0]=o,e&&x(r,n,e),i[k+44>>2]=r+f,e=t+1|0,i[k+40>>2]=e,i[k+36>>2]=r,!n)break r;Z(n)}i[k+40>>2]=e,o=i[s+4>>2]-i[s>>2]>>>8|0,f=i[k+44>>2];r:{if(f>>>0>e>>>0){u[e|0]=o,e=e+1|0;break r}if(n=i[k+36>>2],e=e-n|0,r=e+1|0,(r|0)<0)break e;if(f=f-n|0,t=f<<1,f=f>>>0>=1073741823?2147483647:r>>>0<t>>>0?t:r,f?r=p(f):r=0,t=r+e|0,u[t|0]=o,e&&x(r,n,e),i[k+44>>2]=r+f,e=t+1|0,i[k+40>>2]=e,i[k+36>>2]=r,!n)break r;Z(n)}i[k+40>>2]=e,o=i[s+4>>2]-i[s>>2]|0,f=i[k+44>>2];r:{if(f>>>0>e>>>0){u[e|0]=o,e=e+1|0;break r}if(n=i[k+36>>2],e=e-n|0,r=e+1|0,(r|0)<0)break e;if(f=f-n|0,t=f<<1,f=f>>>0>=1073741823?2147483647:r>>>0<t>>>0?t:r,f?r=p(f):r=0,t=r+e|0,u[t|0]=o,e&&x(r,n,e),i[k+44>>2]=r+f,e=t+1|0,i[k+40>>2]=e,i[k+36>>2]=r,!n)break r;Z(n)}i[k+40>>2]=e,r=i[s+4>>2],t=i[s>>2],o=r-t|0;r:{if((o|0)<=0)break r;if(w=i[k+44>>2],(o|0)<=(w-e|0)){!o|(r|0)==(t|0)||x(e,t,o),i[k+40>>2]=e+o;break r}if(f=i[k+36>>2],r=e-f|0,n=r+o|0,(n|0)<0)break e;if(w=w-f|0,_=w<<1,w=w>>>0>=1073741823?2147483647:n>>>0<_>>>0?_:n,w?n=p(w):n=0,_=n+r|0,o&&x(_,t,o),i[k+40>>2]=e,r&&x(n,f,r),i[k+44>>2]=n+w,i[k+40>>2]=o+_,i[k+36>>2]=n,!f)break r;Z(f)}if(s=s+12|0,(m|0)!=(s|0))continue;break i}break}G0(),H()}if(h=h+16|0,(B|0)==(h|0))break}e=i[k+40>>2],r=i[k+36>>2],n=i[k+44>>2],u[A+20|0]=0,i[A+8>>2]=n,i[A>>2]=r,i[A+4>>2]=e,v=k+48|0}function Gm(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,t=0,o=0,s=0,w=0,h=0;if(f=v-160|0,v=f,i[f+92>>2]=0,i[f+64>>2]=72196,i[f+8>>2]=72176,k=i[18053],i[f>>2]=k,i[i[k-12>>2]+f>>2]=i[18054],i[f+4>>2]=0,k=i[i[f>>2]-12>>2]+f|0,n=f+12|0,J0(k,n),u[k+80|0]=0,i[k+72>>2]=0,k=i[18055],i[f+8>>2]=k,s=f+8|0,i[s+i[k-12>>2]>>2]=i[18056],k=i[18052],i[f>>2]=k,i[i[k-12>>2]+f>>2]=i[18057],i[f+64>>2]=72196,i[f>>2]=72156,i[f+8>>2]=72176,w=R0(n),i[w>>2]=71232,i[f+52>>2]=0,i[f+56>>2]=0,i[f+44>>2]=0,i[f+48>>2]=0,i[f+60>>2]=24,k=f+148|0,U1(k,e,r),t=k,k=u[f+159|0],n=(k|0)<0,Y(s,n?i[f+148>>2]:t,n?i[f+152>>2]:k),u[f+159|0]<0&&Z(i[f+148>>2]),k=f+148|0,s0(k,r),t=k,k=u[f+159|0],n=(k|0)<0,Y(s,n?i[f+148>>2]:t,n?i[f+152>>2]:k),u[f+159|0]<0&&Z(i[f+148>>2]),k=Y(s,31684,15),n=f+148|0,L1(n,i[e+104>>2]),o=k,t=n,k=u[f+159|0],n=(k|0)<0,Y(Y(o,n?i[f+148>>2]:t,n?i[f+152>>2]:k),42670,1),u[f+159|0]<0&&Z(i[f+148>>2]),l[e+112|0]==1&&(k=f+148|0,s0(k,r),t=k,k=u[f+159|0],n=(k|0)<0,Y(s,n?i[f+148>>2]:t,n?i[f+152>>2]:k),u[f+159|0]<0&&Z(i[f+148>>2]),Y(V0(Y(s,30366,25),i[e+108>>2]),42670,1)),i[e+120>>2]!=i[e+116>>2])for(k=0;n=f+148|0,s0(n,r),t=n,n=u[f+159|0],o=(n|0)<0,Y(s,o?i[f+148>>2]:t,o?i[f+152>>2]:n),u[f+159|0]<0&&Z(i[f+148>>2]),n=Y(s,19205,1),i[(i[i[n>>2]-12>>2]+n|0)+12>>2]=2,t=n,n=k+1|0,o=Y(V0(t,n),32722,4),i[(i[i[o>>2]-12>>2]+o|0)+12>>2]=3,k=k<<3,Y(V0(Y(V0(o,i[k+i[e+116>>2]>>2]),27475,2),i[(k+i[e+116>>2]|0)+4>>2]),42670,1),o=i[e+116>>2],h=i[o+k>>2]+h|0,k=n,k>>>0<i[e+120>>2]-o>>3>>>0;);e=f+148|0,s0(e,r),k=e,e=u[f+159|0],r=(e|0)<0,Y(s,r?i[f+148>>2]:k,r?i[f+152>>2]:e),u[f+159|0]<0&&Z(i[f+148>>2]),Y(V0(Y(s,30108,15),h),42670,1),e=i[f+60>>2];i:{e:{if(e&16){e=i[f+56>>2],r=i[f+36>>2],e>>>0<r>>>0&&(i[f+56>>2]=r,e=r),r=f+32|0;break e}if(!(e&8)){e=0,u[A+11|0]=0;break i}e=i[f+28>>2],r=f+20|0}e:{if(k=i[r>>2],e=e-k|0,e>>>0<2147483640){if(e>>>0>=11){n=e|7,r=p(n+1|0),i[A+8>>2]=n-2147483647,i[A>>2]=r,i[A+4>>2]=e,A=r;break e}if(u[A+11|0]=e,e)break e;e=0;break i}Q0(),H()}if(!e)break i;x(A,k,e)}u[A+e|0]=0,A=i[18051],i[f>>2]=A,i[i[A-12>>2]+f>>2]=i[18059],i[f+8>>2]=i[18060],i[w>>2]=71232,u[f+55|0]<0&&Z(i[f+44>>2]),E0(w),y0(f- -64|0),v=f+160|0}function di(A,e,r,f){var k=0,n=0,t=0,o=0,s=0,w=0;k=v-160|0,v=k;i:{e:{r:{f:{A:{k:{n:{if(o=i[e+8>>2],e=i[e+12>>2],!(o|e))break n;if((r|f)>=0){if(!f)break k;if(t=d8(o,e,f,0),n=l0,!n&r>>>0<=t>>>0|n)break n}i[k+104>>2]=0,i[k+76>>2]=72196,i[k+20>>2]=72176,t=i[18053],i[k+12>>2]=t,n=i[t-12>>2],t=k+12|0,i[n+t>>2]=i[18054],i[k+16>>2]=0,n=t+i[i[k+12>>2]-12>>2]|0,s=k+24|0,J0(n,s),u[n+80|0]=0,i[n+72>>2]=0,n=i[18055],i[k+20>>2]=n,w=k+20|0,i[w+i[n-12>>2]>>2]=i[18056],n=i[18052],i[k+12>>2]=n,i[t+i[n-12>>2]>>2]=i[18057],i[k+76>>2]=72196,i[k+12>>2]=72156,i[k+20>>2]=72176,t=R0(s),i[t>>2]=71232,n=k- -64|0,i[n>>2]=0,i[n+4>>2]=0,i[k+56>>2]=0,i[k+60>>2]=0,i[k+72>>2]=24,Y(q2(Y(V0(Y(V0(Y(w,28773,11),r),2998,1),f),28740,32),o,e),42670,1),e=i[k+72>>2];t:{if(e&16){f=i[k+68>>2],e=i[k+48>>2],f>>>0<e>>>0&&(i[k+68>>2]=e,f=e),e=k+44|0;break t}if(!(e&8)){f=0,u[k+11|0]=0,r=k;break e}f=i[k+40>>2],e=k+32|0}if(e=i[e>>2],f=f-e|0,f>>>0>=2147483640)break f;if(f>>>0>=11){o=f|7,r=p(o+1|0),i[k+8>>2]=o-2147483647,i[k>>2]=r,i[k+4>>2]=f;break r}if(u[k+11|0]=f,r=k,f)break r;f=0;break e}if(!r)break k;if(f)break A}if(e=p(24),i[k+12>>2]=e,i[k+16>>2]=20,i[k+20>>2]=-2147483624,r=l[4072]|l[4073]<<8|(l[4074]<<16|l[4075]<<24),f=l[4068]|l[4069]<<8|(l[4070]<<16|l[4071]<<24),u[e|0]=f,u[e+1|0]=f>>>8,u[e+2|0]=f>>>16,u[e+3|0]=f>>>24,u[e+4|0]=r,u[e+5|0]=r>>>8,u[e+6|0]=r>>>16,u[e+7|0]=r>>>24,u[e+20|0]=0,r=l[4084]|l[4085]<<8|(l[4086]<<16|l[4087]<<24),u[e+16|0]=r,u[e+17|0]=r>>>8,u[e+18|0]=r>>>16,u[e+19|0]=r>>>24,r=l[4080]|l[4081]<<8|(l[4082]<<16|l[4083]<<24),f=l[4076]|l[4077]<<8|(l[4078]<<16|l[4079]<<24),u[e+8|0]=f,u[e+9|0]=f>>>8,u[e+10|0]=f>>>16,u[e+11|0]=f>>>24,u[e+12|0]=r,u[e+13|0]=r>>>8,u[e+14|0]=r>>>16,u[e+15|0]=r>>>24,q(A,6,129,k+12|0),u[k+23|0]>=0)break i;Z(i[k+12>>2]);break i}if(e=i[26917],i[A>>2]=i[26916],i[A+4>>2]=e,A=A+8|0,u[107683]>=0){e=i[26919],i[A>>2]=i[26918],i[A+4>>2]=e,i[A+8>>2]=i[26920];break i}T(A,i[26918],i[26919]);break i}Q0(),H()}if(!f)break e;x(r,e,f)}u[r+f|0]=0,q(A,6,1e3,k),u[k+11|0]<0&&Z(i[k>>2]),A=i[18051],i[k+12>>2]=A,i[i[A-12>>2]+(k+12|0)>>2]=i[18059],i[k+20>>2]=i[18060],i[t>>2]=71232,u[k+67|0]<0&&Z(i[k+56>>2]),E0(t),y0(k+76|0)}v=k+160|0}function Yf(A,e,r){var f=0,k=0,n=0,t=0,o=0,s=0,w=0,h=0;f=v-48|0,v=f,i[f+36>>2]=0,i[f+32>>2]=1,W[i[i[r>>2]+132>>2]](f+20|0,i[r+4>>2],f+44|0,f+40|0,f+36|0,0,f+32|0);i:{e:{r:{if(k=i[f+44>>2],k){for(s=e+28|0,o=e+24|0,t=e+32|0;;){f:{A:{k:{n:{t:switch(n=l[k|0],w=n>>>1|0,w-32|0){case 0:break n;case 1:break t;case 2:break k;default:break A}n=i[e+12>>2];t:{if(!n||(K9(f,k,i[f+40>>2],n+100|0,o,s),u[f+19|0]>=0))break t;Z(i[f+8>>2])}k=i[e+12>>2],!k|u[e+7|0]&1||Gr(k,i[f+44>>2],i[f+40>>2]),u[e+7|0]=1;break f}n=i[e+12>>2],!n|u[e+6|0]&1||Gr(n,k,i[f+40>>2]),u[e+6|0]=1;break f}n=i[e+12>>2],!n|u[e+8|0]&1||Gr(n,k,i[f+40>>2]),u[e+8|0]=1;break f}if(l[e+76|0]||(i[e+60>>2]=0,i[e+64>>2]=0,u[t+23|0]=0,u[t+24|0]=0,u[t+25|0]=0,u[t+26|0]=0,i[t+16>>2]=0,i[t+20>>2]=0,i[t+8>>2]=0,i[t+12>>2]=0,i[t>>2]=0,i[t+4>>2]=0,u[e+76|0]=1,i[e+72>>2]=0,u[e+68|0]=1),Xi(t,k,i[f+40>>2]),n>>>0>63)break f;u[e+68|0]=(w-19&255)>>>0<3,i[e+72>>2]=i[f+36>>2]}if(!(i[f+32>>2]&&(i[f+36>>2]=0,i[f+32>>2]=1,W[i[i[r>>2]+132>>2]](f+20|0,i[r+4>>2],f+44|0,f+40|0,f+36|0,0,f+32|0),k=i[f+44>>2],k)))break}f:{if(k=i[o>>2],k&&(r=i[s>>2],r))break f;if(u[f+20|0]=0,u[f+31|0]=0,q(A,8,129,f+20|0),u[f+31|0]>=0)break i;Z(i[f+20>>2]);break i}f:{if(!(u[e+6|0]&1)|i[e+44>>2]==i[e+48>>2]|(!(u[e+7|0]&1)|!(u[e+8|0]&1))||l[e+20|0])break f;w=i[e+12>>2],s=i[e+16>>2],s&&(i[s+4>>2]=i[s+4>>2]+1),r=i[e+36>>2],o=i[e+40>>2];A:{if(r>>>0<o>>>0){i[r+4>>2]=s,i[r>>2]=w,k=r+8|0;break A}if(t=i[t>>2],r=r-t|0,h=r>>3,k=h+1|0,k>>>0>=536870912)break r;if(o=o-t|0,n=o>>2,o=o>>>0>=2147483640?536870911:k>>>0<n>>>0?n:k,o){if(o>>>0>=536870912)break e;k=p(o<<3)}else k=0;if(n=k+r|0,i[n+4>>2]=s,i[n>>2]=w,s=n-(h<<3)|0,r&&x(s,t,r),i[e+40>>2]=k+(o<<3),k=n+8|0,i[e+36>>2]=k,i[e+32>>2]=s,!t)break A;Z(t)}i[e+36>>2]=k,r=i[e+16>>2],i[e+12>>2]=0,i[e+16>>2]=0;A:{if(!r||(k=i[r+4>>2],i[r+4>>2]=k-1,k))break A;W[i[i[r>>2]+8>>2]](r),y(r)}u[e+20|0]=1,r=i[e+28>>2],k=i[e+24>>2]}i[e+64>>2]=r,i[e+60>>2]=k,g[e+56>>1]=257,i[A>>2]=0,i[A+4>>2]=0,i[A+16>>2]=0,i[A+8>>2]=0,i[A+12>>2]=0;break i}i[A>>2]=0,i[A+4>>2]=0,i[A+16>>2]=0,i[A+8>>2]=0,i[A+12>>2]=0;break i}G0(),H()}z0(),H()}v=f+48|0}function Xm(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,t=0,o=0,s=0;f=v-208|0,v=f,i[f+140>>2]=0,i[f+112>>2]=72500,k=i[18128],i[f+56>>2]=k,t=i[k-12>>2],k=f+56|0,i[t+k>>2]=i[18129],o=k+i[i[f+56>>2]-12>>2]|0,n=f+60|0,J0(o,n),u[o+80|0]=0,i[o+72>>2]=0,i[f+112>>2]=72500,i[f+56>>2]=72480,o=R0(n),i[o>>2]=71232,i[f+100>>2]=0,i[f+104>>2]=0,i[f+92>>2]=0,i[f+96>>2]=0,i[f+108>>2]=16,n=f+196|0,Xr(n,e,r),s=k,t=n,k=u[f+207|0],n=(k|0)<0,Y(s,n?i[f+196>>2]:t,n?i[f+200>>2]:k),u[f+207|0]<0&&Z(i[f+196>>2]);i:{e:{r:{f:{if(s=i[e+12>>2],n=i[e+32>>2],k=i[e+8>>2],!s&n>>>0<=k>>>0|s){s=i[e+100>>2],e=f+28|0,s0(e,r),e=pA(e,32344,6),i[f+48>>2]=i[e+8>>2],t=i[e+4>>2],i[f+40>>2]=i[e>>2],i[f+44>>2]=t,i[e>>2]=0,i[e+4>>2]=0,i[e+8>>2]=0,e=f+4|0,s0(e,r),e=pA(e,32803,6),i[f+24>>2]=i[e+8>>2],r=i[e+4>>2],i[f+16>>2]=i[e>>2],i[f+20>>2]=r,i[e>>2]=0,i[e+4>>2]=0,i[e+8>>2]=0,e=f+196|0,S9(e,s,k-n|0,f+40|0,f+16|0),k=e,e=u[f+207|0],r=(e|0)<0,Y(f+56|0,r?i[f+196>>2]:k,r?i[f+200>>2]:e),u[f+207|0]<0&&Z(i[f+196>>2]),u[f+27|0]<0&&Z(i[f+16>>2]),u[f+15|0]<0&&Z(i[f+4>>2]),u[f+51|0]<0&&Z(i[f+40>>2]),u[f+39|0]<0&&Z(i[f+28>>2]),e=i[f+108>>2];A:{if(e&16){e=i[f+104>>2],r=i[f+84>>2],e>>>0<r>>>0&&(i[f+104>>2]=r,e=r),r=f+80|0;break A}if(!(e&8)){e=0,u[A+11|0]=0;break i}e=i[f+76>>2],r=f+68|0}if(k=i[r>>2],e=e-k|0,e>>>0>=2147483640)break f;if(e>>>0>=11){n=e|7,r=p(n+1|0),i[A+8>>2]=n-2147483647,i[A>>2]=r,i[A+4>>2]=e,A=r;break e}if(u[A+11|0]=e,e)break e;e=0;break i}k=f+196|0,s0(k,r),t=k,r=u[f+207|0],k=(r|0)<0,Y(f+56|0,k?i[f+196>>2]:t,k?i[f+200>>2]:r),u[f+207|0]<0&&Z(i[f+196>>2]),Y(q2(Y(f+56|0,28683,17),i[e+8>>2],i[e+12>>2]),42371,23),e=i[f+108>>2];A:{if(e&16){e=i[f+104>>2],r=i[f+84>>2],e>>>0<r>>>0&&(i[f+104>>2]=r,e=r),r=f+80|0;break A}if(!(e&8)){e=0,u[A+11|0]=0;break i}e=i[f+76>>2],r=f+68|0}if(k=i[r>>2],e=e-k|0,e>>>0>=2147483640)break f;if(e>>>0>=11){n=e|7,r=p(n+1|0),i[A+8>>2]=n-2147483647,i[A>>2]=r,i[A+4>>2]=e,A=r;break r}if(u[A+11|0]=e,e)break r;e=0;break i}Q0(),H()}if(!e)break i;x(A,k,e);break i}if(!e)break i;x(A,k,e)}u[A+e|0]=0,A=i[18127],i[f+56>>2]=A,i[i[A-12>>2]+(f+56|0)>>2]=i[18130],i[o>>2]=71232,u[f+103|0]<0&&Z(i[f+92>>2]),E0(o),y0(f+112|0),v=f+208|0}function Wm(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0;var k=0;k=v-48|0,v=k,pf(k+24|0,e,r,f);i:{if(i[k+24>>2]){e=i[k+28>>2],i[A>>2]=i[k+24>>2],i[A+4>>2]=e,i[A+16>>2]=i[k+40>>2],e=i[k+36>>2],i[A+8>>2]=i[k+32>>2],i[A+12>>2]=e,i[k+40>>2]=0,i[k+32>>2]=0,i[k+36>>2]=0;break i}if((i[e+112>>2]-i[e+108>>2]|0)!=8){if(e=p(64),i[k+12>>2]=e,i[k+16>>2]=57,i[k+20>>2]=-2147483584,r=l[5683]|l[5684]<<8|(l[5685]<<16|l[5686]<<24),f=l[5679]|l[5680]<<8|(l[5681]<<16|l[5682]<<24),u[e|0]=f,u[e+1|0]=f>>>8,u[e+2|0]=f>>>16,u[e+3|0]=f>>>24,u[e+4|0]=r,u[e+5|0]=r>>>8,u[e+6|0]=r>>>16,u[e+7|0]=r>>>24,u[e+57|0]=0,u[e+56|0]=l[5735],r=l[5731]|l[5732]<<8|(l[5733]<<16|l[5734]<<24),f=l[5727]|l[5728]<<8|(l[5729]<<16|l[5730]<<24),u[e+48|0]=f,u[e+49|0]=f>>>8,u[e+50|0]=f>>>16,u[e+51|0]=f>>>24,u[e+52|0]=r,u[e+53|0]=r>>>8,u[e+54|0]=r>>>16,u[e+55|0]=r>>>24,r=l[5723]|l[5724]<<8|(l[5725]<<16|l[5726]<<24),f=l[5719]|l[5720]<<8|(l[5721]<<16|l[5722]<<24),u[e+40|0]=f,u[e+41|0]=f>>>8,u[e+42|0]=f>>>16,u[e+43|0]=f>>>24,u[e+44|0]=r,u[e+45|0]=r>>>8,u[e+46|0]=r>>>16,u[e+47|0]=r>>>24,r=l[5715]|l[5716]<<8|(l[5717]<<16|l[5718]<<24),f=l[5711]|l[5712]<<8|(l[5713]<<16|l[5714]<<24),u[e+32|0]=f,u[e+33|0]=f>>>8,u[e+34|0]=f>>>16,u[e+35|0]=f>>>24,u[e+36|0]=r,u[e+37|0]=r>>>8,u[e+38|0]=r>>>16,u[e+39|0]=r>>>24,r=l[5707]|l[5708]<<8|(l[5709]<<16|l[5710]<<24),f=l[5703]|l[5704]<<8|(l[5705]<<16|l[5706]<<24),u[e+24|0]=f,u[e+25|0]=f>>>8,u[e+26|0]=f>>>16,u[e+27|0]=f>>>24,u[e+28|0]=r,u[e+29|0]=r>>>8,u[e+30|0]=r>>>16,u[e+31|0]=r>>>24,r=l[5699]|l[5700]<<8|(l[5701]<<16|l[5702]<<24),f=l[5695]|l[5696]<<8|(l[5697]<<16|l[5698]<<24),u[e+16|0]=f,u[e+17|0]=f>>>8,u[e+18|0]=f>>>16,u[e+19|0]=f>>>24,u[e+20|0]=r,u[e+21|0]=r>>>8,u[e+22|0]=r>>>16,u[e+23|0]=r>>>24,r=l[5691]|l[5692]<<8|(l[5693]<<16|l[5694]<<24),f=l[5687]|l[5688]<<8|(l[5689]<<16|l[5690]<<24),u[e+8|0]=f,u[e+9|0]=f>>>8,u[e+10|0]=f>>>16,u[e+11|0]=f>>>24,u[e+12|0]=r,u[e+13|0]=r>>>8,u[e+14|0]=r>>>16,u[e+15|0]=r>>>24,q(A,2,101,k+12|0),u[k+23|0]>=0)break i;Z(i[k+12>>2]);break i}if(e=i[26917],i[A>>2]=i[26916],i[A+4>>2]=e,A=A+8|0,u[107683]>=0){e=i[26919],i[A>>2]=i[26918],i[A+4>>2]=e,i[A+8>>2]=i[26920];break i}T(A,i[26918],i[26919])}u[k+43|0]<0&&Z(i[k+32>>2]),v=k+48|0}function Qm(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,t=0,o=0,s=0,w=0,h=0,_=0,B=0;if(f=v-160|0,v=f,i[f+92>>2]=0,i[f+64>>2]=72196,i[f+8>>2]=72176,k=i[18053],i[f>>2]=k,i[i[k-12>>2]+f>>2]=i[18054],i[f+4>>2]=0,k=i[i[f>>2]-12>>2]+f|0,t=f+12|0,J0(k,t),u[k+80|0]=0,i[k+72>>2]=0,k=i[18055],i[f+8>>2]=k,h=f+8|0,i[h+i[k-12>>2]>>2]=i[18056],k=i[18052],i[f>>2]=k,i[i[k-12>>2]+f>>2]=i[18057],i[f+64>>2]=72196,i[f>>2]=72156,i[f+8>>2]=72176,_=R0(t),i[_>>2]=71232,i[f+52>>2]=0,i[f+56>>2]=0,i[f+44>>2]=0,i[f+48>>2]=0,i[f+60>>2]=24,k=f+148|0,U1(k,e,r),n=k,k=u[f+159|0],t=(k|0)<0,Y(h,t?i[f+148>>2]:n,t?i[f+152>>2]:k),u[f+159|0]<0&&Z(i[f+148>>2]),i[e+108>>2]!=i[e+104>>2])for(k=0;;){t=f+148|0,s0(t,r),n=t,t=u[f+159|0],o=(t|0)<0,Y(h,o?i[f+148>>2]:n,o?i[f+152>>2]:t),u[f+159|0]<0&&Z(i[f+148>>2]),t=Y(S0(Y(V0(Y(h,19205,1),k),20983,15),l[i[e+104>>2]+k|0]>>>6|0),42670,1),o=f+148|0,s0(o,r),n=o,o=u[f+159|0],s=(o|0)<0,Y(t,s?i[f+148>>2]:n,s?i[f+152>>2]:o),u[f+159|0]<0&&Z(i[f+148>>2]),n=-6;i:{if((k|0)<=9||(n=-7,k>>>0<100)||(n=-8,k>>>0<1e3)||(n=-9,k>>>0<1e4)||(n=-10,k>>>0<1e5))break i;n=k>>>0>999999?-12:-11}if(o=n+32809|0,s=h2(o),t=Y(S0(Y(Y(t,o,s),20928,11),l[i[e+104>>2]+k|0]>>>4&3),42670,1),n=f+148|0,s0(n,r),B=n,n=u[f+159|0],w=(n|0)<0,Y(t,w?i[f+148>>2]:B,w?i[f+152>>2]:n),u[f+159|0]<0&&Z(i[f+148>>2]),t=Y(S0(Y(Y(t,o,s),20940,15),l[i[e+104>>2]+k|0]>>>2&3),42670,1),n=f+148|0,s0(n,r),B=n,n=u[f+159|0],w=(n|0)<0,Y(t,w?i[f+148>>2]:B,w?i[f+152>>2]:n),u[f+159|0]<0&&Z(i[f+148>>2]),Y(S0(Y(Y(t,o,s),20856,15),l[i[e+104>>2]+k|0]&3),42670,1),k=k+1|0,!(k>>>0<i[e+108>>2]-i[e+104>>2]>>>0))break}e=i[f+60>>2];i:{e:{if(e&16){k=i[f+56>>2],e=i[f+36>>2],k>>>0<e>>>0&&(i[f+56>>2]=e,k=e),e=f+32|0;break e}if(!(e&8)){k=0,u[A+11|0]=0;break i}k=i[f+28>>2],e=f+20|0}e:{if(r=i[e>>2],k=k-r|0,k>>>0<2147483640){if(k>>>0>=11){t=k|7,e=p(t+1|0),i[A+8>>2]=t-2147483647,i[A>>2]=e,i[A+4>>2]=k,A=e;break e}if(u[A+11|0]=k,k)break e;k=0;break i}Q0(),H()}if(!k)break i;x(A,r,k)}u[A+k|0]=0,A=i[18051],i[f>>2]=A,i[i[A-12>>2]+f>>2]=i[18059],i[f+8>>2]=i[18060],i[_>>2]=71232,u[f+55|0]<0&&Z(i[f+44>>2]),E0(_),y0(f- -64|0),v=f+160|0}function gm(A,e,r,f,k){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0;var n=0,t=0,o=0,s=0,w=0,h=0,_=0;_=v-16|0,v=_,n=v-48|0,v=n,h=i[e+8>>2],Z8(n+40|0,i[h+48>>2],1835625829),o=i[n+40>>2],u[o+164|0]=1,i[o+100>>2]=i[o+100>>2]&-2|1,s=i[n+40>>2];i:{e:{if(t=h2(r),t>>>0<2147483640){r:{f:{if(t>>>0>=11){w=t|7,o=p(w+1|0),i[n+36>>2]=w-2147483647,i[n+28>>2]=o,i[n+32>>2]=t;break f}if(u[n+39|0]=t,o=n+28|0,!t)break r}if(!t)break r;x(o,r,t)}u[o+t|0]=0,r=s+128|0;r:{if((r|0)==(n+28|0))break r;if(o=u[n+39|0],u[s+139|0]>=0){if((o|0)>=0){o=i[n+32>>2],i[r>>2]=i[n+28>>2],i[r+4>>2]=o,i[r+8>>2]=i[n+36>>2];break r}M1(r,i[n+28>>2],i[n+32>>2]);break r}t=r,r=(o|0)<0,O1(t,r?i[n+28>>2]:n+28|0,r?i[n+32>>2]:o)}if(u[n+39|0]<0&&Z(i[n+28>>2]),o=i[i[n+40>>2]+104>>2],r=p(28),i[r+12>>2]=o,i[r>>2]=94772,i[r+4>>2]=0,i[r+8>>2]=0,o=r+16|0,t=h2(f),t>>>0>=2147483640)break e;s=r+12|0;r:{f:{if(t>>>0>=11){w=t|7,o=p(w+1|0),i[r+24>>2]=w-2147483647,i[r+16>>2]=o,i[r+20>>2]=t;break f}if(u[r+27|0]=t,!t)break r}if(!t)break r;x(o,f,t)}u[o+t|0]=0,i[_+12>>2]=r,i[_+8>>2]=s,i[n+24>>2]=r,i[n+20>>2]=s,i[r+4>>2]=i[r+4>>2]+1,r=i[n+24>>2],i[n+8>>2]=i[n+20>>2],i[n+12>>2]=r;r:{if(r=i[h+172>>2],t=i[h+176>>2],r>>>0<t>>>0){i[r>>2]=i[n+8>>2],i[r+4>>2]=i[n+12>>2],i[h+172>>2]=r+8;break r}f:{if(o=i[h+168>>2],r=r-o|0,w=r>>3,f=w+1|0,f>>>0<536870912){if(t=t-o|0,s=t>>2,t=t>>>0>=2147483640?536870911:f>>>0<s>>>0?s:f,t){if(t>>>0>=536870912)break f;f=p(t<<3)}else f=0;s=f+r|0,i[s>>2]=i[n+8>>2],i[s+4>>2]=i[n+12>>2],w=s-(w<<3)|0,r&&x(w,o,r),i[h+176>>2]=f+(t<<3),r=s+8|0,i[h+172>>2]=r,i[h+168>>2]=w,o&&Z(o),i[h+172>>2]=r;break r}G0(),H()}z0(),H()}r=i[n+44>>2];r:{if(!r||(f=i[r+4>>2],i[r+4>>2]=f-1,f))break r;W[i[i[r>>2]+8>>2]](r),y(r)}v=n+48|0;break i}Q0(),H()}Q0(),H()}ku(i[e>>2],i[i[_+8>>2]>>2]);i:{if(k){r=p(16),f=i[e+8>>2],e=i[e+12>>2],e&&(i[e+4>>2]=i[e+4>>2]+1),i[r+4>>2]=e,i[r>>2]=f,e=i[_+12>>2],i[r+8>>2]=i[_+8>>2],i[r+12>>2]=e,i[k>>2]=r,i[A+8>>2]=i[24058],e=i[24057],i[A>>2]=i[24056],i[A+4>>2]=e;break i}if(e=i[_+12>>2],r=i[24057],i[A>>2]=i[24056],i[A+4>>2]=r,i[A+8>>2]=i[24058],!e||(A=i[e+4>>2],i[e+4>>2]=A-1,A))break i;W[i[i[e>>2]+8>>2]](e),y(e)}v=_+16|0}function f6(A,e,r,f,k,n){var t=0,o=0,s=0,w=0,h=0,_=0,B=0,m=0,X=0,Q=0;h=v-32|0,v=h,t=i[r>>2],o=i[t+128>>2];i:{if(o){for(w=t+128|0,s=w,t=o;_=i[t+16>>2]<(f|0),s=_?s:t,t=i[(_?4:0)+t>>2],!!t;);m=0;e:{if((s|0)==(w|0)||(m=0,i[s+16>>2]>(f|0)))break e;m=i[s+28>>2]}for(s=w,t=o;_=i[t+16>>2]<(f|0),s=_?s:t,t=i[(_?4:0)+t>>2],!!t;);t=0;e:{if((s|0)==(w|0)||(t=0,i[s+16>>2]>(f|0)))break e;t=i[s+32>>2]}for(_=t,s=w,t=o;B=i[t+16>>2]<(f|0),s=B?s:t,t=i[(B?4:0)+t>>2],!!t;);for(t=w,(s|0)!=(t|0)?s=i[s+16>>2]>(f|0)?t:s:s=t,s=i[s+20>>2];B=i[o+16>>2]<(f|0),t=B?t:o,o=i[(B?4:0)+o>>2],!!o;);if(o=255,(t|0)==(w|0)|i[t+16>>2]>(f|0))break i;o=l[t+24|0];break i}s=i[t+148>>2],o=255}Tf(h+8|0,e,k,m,_,s,o,n);i:{if(i[h+8>>2]){e=i[h+12>>2],i[A>>2]=i[h+8>>2],i[A+4>>2]=e,i[A+16>>2]=i[h+24>>2],e=i[h+20>>2],i[A+8>>2]=i[h+16>>2],i[A+12>>2]=e,i[h+24>>2]=0,i[h+16>>2]=0,i[h+20>>2]=0;break i}X=i[r>>2],r=X+128|0;e:{r:{if(t=i[X+128>>2],!t)break r;for(s=r,o=t;n=i[o+16>>2]<(f|0),s=n?s:o,o=i[(n?4:0)+o>>2],!!o;);if((r|0)==(s|0))break r;if(o=0,n=0,i[s+16>>2]>(f|0))break e;o=i[s+56>>2],n=i[s+44>>2];break e}o=0,n=0}B=o,o=i[e+128>>2],w=0;e:{if(!o)break e;for(e=e+128|0,s=e;w=i[o+16>>2]<(k|0),s=w?s:o,o=i[(w?4:0)+o>>2],!!o;);if(w=0,(e|0)==(s|0)||(w=0,i[s+16>>2]>(k|0)))break e;Q=i[s+56>>2],w=i[s+44>>2]}e:{r:{if((f|0)==10){if(e=i[X+120>>2]-10|0,e>>>0<6)break r;e=31;break e}if(e=0,!t)break e;for(o=r;e=i[t+16>>2]<(f|0),o=e?o:t,t=i[(e?4:0)+t>>2],!!t;);if(e=0,(r|0)==(o|0)|i[o+16>>2]>(f|0))break e;e=(l[o+24|0]+7&248)>>>3|0;break e}e=i[(e<<2)+50008>>2]}t=e;e:{if(!_)break e;if(e=G(t,m),f=0,(_|0)!=1)for(r=_&-2,t=0;k=!e,k||x(w+G(f,Q)|0,G(f,B)+n|0,e),k||(k=f|1,x(w+G(k,Q)|0,G(k,B)+n|0,e)),f=f+2|0,t=t+2|0,(r|0)!=(t|0););if(!(_&1)|!e)break e;x(w+G(f,Q)|0,G(f,B)+n|0,e)}if(e=i[26917],i[A>>2]=i[26916],i[A+4>>2]=e,A=A+8|0,u[107683]>=0){e=i[26919],i[A>>2]=i[26918],i[A+4>>2]=e,i[A+8>>2]=i[26920];break i}T(A,i[26918],i[26919])}u[h+27|0]<0&&Z(i[h+16>>2]),v=h+32|0}function Vm(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,t=0,o=0,s=0,w=0;f=v-160|0,v=f,i[f+92>>2]=0,i[f+64>>2]=72196,i[f+8>>2]=72176,k=i[18053],i[f>>2]=k,i[i[k-12>>2]+f>>2]=i[18054],i[f+4>>2]=0,k=i[i[f>>2]-12>>2]+f|0,w=f+12|0,J0(k,w),u[k+80|0]=0,i[k+72>>2]=0,k=i[18055],i[f+8>>2]=k,t=f+8|0,i[t+i[k-12>>2]>>2]=i[18056],k=i[18052],i[f>>2]=k,i[i[k-12>>2]+f>>2]=i[18057],i[f+64>>2]=72196,i[f>>2]=72156,i[f+8>>2]=72176,w=R0(w),i[w>>2]=71232,i[f+52>>2]=0,i[f+56>>2]=0,i[f+44>>2]=0,i[f+48>>2]=0,i[f+60>>2]=24,k=f+148|0,U1(k,e,r),o=k,k=u[f+159|0],n=(k|0)<0,Y(t,n?i[f+148>>2]:o,n?i[f+152>>2]:k),u[f+159|0]<0&&Z(i[f+148>>2]),k=f+148|0,s0(k,r),o=k,k=u[f+159|0],n=(k|0)<0,Y(t,n?i[f+148>>2]:o,n?i[f+152>>2]:k),u[f+159|0]<0&&Z(i[f+148>>2]),Y(t,31607,15),k=i[e+104>>2];i:{if(!k){Y(t,41805,2);break i}if(n=f+148|0,L1(n,k),o=n,k=u[f+159|0],n=(k|0)<0,Y(Y(t,n?i[f+148>>2]:o,n?i[f+152>>2]:k),42670,1),u[f+159|0]>=0)break i;Z(i[f+148>>2])}k=f+148|0,s0(k,r),o=k,k=u[f+159|0],n=(k|0)<0,Y(t,n?i[f+148>>2]:o,n?i[f+152>>2]:k),u[f+159|0]<0&&Z(i[f+148>>2]),Y(t,30340,25),k=i[e+108>>2];i:{if(!k){Y(t,41805,2);break i}if(n=f+148|0,L1(n,k),o=n,k=u[f+159|0],n=(k|0)<0,Y(Y(t,n?i[f+148>>2]:o,n?i[f+152>>2]:k),42670,1),u[f+159|0]>=0)break i;Z(i[f+148>>2])}if(i[e+132>>2]!=i[e+128>>2])for(k=0;n=f+148|0,s0(n,r),o=n,n=u[f+159|0],s=(n|0)<0,Y(t,s?i[f+148>>2]:o,s?i[f+152>>2]:n),u[f+159|0]<0&&Z(i[f+148>>2]),n=Y(V0(Y(t,19205,1),k),2989,6),s=i[i[n>>2]-12>>2]+n|0,i[s+4>>2]=i[s+4>>2]&-75|8,s=i[e+128>>2]+(k<<3)|0,Y(q2(n,i[s>>2],i[s+4>>2]),42670,1),k=k+1|0,k>>>0<i[e+132>>2]-i[e+128>>2]>>3>>>0;);e=i[f+60>>2];i:{e:{if(e&16){k=i[f+56>>2],e=i[f+36>>2],k>>>0<e>>>0&&(i[f+56>>2]=e,k=e),e=f+32|0;break e}if(!(e&8)){k=0,u[A+11|0]=0;break i}k=i[f+28>>2],e=f+20|0}e:{if(r=i[e>>2],k=k-r|0,k>>>0<2147483640){if(k>>>0>=11){t=k|7,e=p(t+1|0),i[A+8>>2]=t-2147483647,i[A>>2]=e,i[A+4>>2]=k,A=e;break e}if(u[A+11|0]=k,k)break e;k=0;break i}Q0(),H()}if(!k)break i;x(A,r,k)}u[A+k|0]=0,A=i[18051],i[f>>2]=A,i[i[A-12>>2]+f>>2]=i[18059],i[f+8>>2]=i[18060],i[w>>2]=71232,u[f+55|0]<0&&Z(i[f+44>>2]),E0(w),y0(f- -64|0),v=f+160|0}function Rf(A,e,r){var f=0,k=0,n=0,t=0,o=0,s=0,w=0,h=0;f=v-48|0,v=f,i[f+36>>2]=0,i[f+32>>2]=1,W[i[i[r>>2]+132>>2]](f+20|0,i[r+4>>2],f+44|0,f+40|0,f+36|0,0,f+32|0),k=i[f+44>>2];i:{if(!k)break i;for(o=e+24|0,s=e+20|0,n=e+28|0;;){t=l[k|0]&31,w=t-1|0,u[e+76|0]=l[e+76|0]|w>>>0<5;e:{r:switch(t-7|0){case 0:t=i[e+8>>2];f:{if(!t||(f9(f,k,i[f+40>>2],t+100|0,s,o),u[f+19|0]>=0))break f;Z(i[f+8>>2])}k=i[e+8>>2],!k|u[e+6|0]&1||nt(k,i[f+44>>2],i[f+40>>2]),u[e+6|0]=1;break e;case 6:if(t=i[e+8>>2],!t)break e;tt(t,k,i[f+40>>2]);break e;case 1:t=i[e+8>>2],!t|u[e+7|0]&1||ut(t,k,i[f+40>>2]),u[e+7|0]=1;break e;default:break r}if(l[e+72|0]||(i[e+56>>2]=0,i[e+60>>2]=0,u[n+23|0]=0,u[n+24|0]=0,u[n+25|0]=0,u[n+26|0]=0,i[n+16>>2]=0,i[n+20>>2]=0,i[n+8>>2]=0,i[n+12>>2]=0,i[n>>2]=0,i[n+4>>2]=0,u[e+72|0]=1,i[e+68>>2]=0,u[e+64|0]=1),Xi(n,k,i[f+40>>2]),w>>>0>4)break e;u[e+64|0]=(t|0)==5,i[e+68>>2]=i[f+36>>2]}if(!i[f+32>>2])break i;if(i[f+36>>2]=0,i[f+32>>2]=1,W[i[i[r>>2]+132>>2]](f+20|0,i[r+4>>2],f+44|0,f+40|0,f+36|0,0,f+32|0),k=i[f+44>>2],!k)break}}i:{e:{r:{if(!l[e+76|0]){i[A>>2]=0,i[A+4>>2]=0,i[A+16>>2]=0,i[A+8>>2]=0,i[A+12>>2]=0;break r}f:{if(k=i[e+20>>2],k&&(r=i[e+24>>2],r))break f;if(u[f+20|0]=0,u[f+31|0]=0,q(A,8,129,f+20|0),u[f+31|0]>=0)break r;Z(i[f+20>>2]);break r}f:{if(l[e+5|0]!=1||(w=i[e+8>>2],l[e+16|0]|!w))break f;n=i[e+12>>2],n&&(i[n+4>>2]=i[n+4>>2]+1),r=i[e+32>>2],o=i[e+36>>2];A:{if(r>>>0<o>>>0){i[r+4>>2]=n,i[r>>2]=w,k=r+8|0;break A}if(t=i[e+28>>2],r=r-t|0,h=r>>3,k=h+1|0,k>>>0>=536870912)break e;if(o=o-t|0,s=o>>2,o=o>>>0>=2147483640?536870911:k>>>0<s>>>0?s:k,o){if(o>>>0>=536870912)break i;k=p(o<<3)}else k=0;if(s=k+r|0,i[s+4>>2]=n,i[s>>2]=w,n=s-(h<<3)|0,r&&x(n,t,r),i[e+36>>2]=k+(o<<3),k=s+8|0,i[e+32>>2]=k,i[e+28>>2]=n,!t)break A;Z(t)}i[e+32>>2]=k,r=i[e+12>>2],i[e+8>>2]=0,i[e+12>>2]=0;A:{if(!r||(k=i[r+4>>2],i[r+4>>2]=k-1,k))break A;W[i[i[r>>2]+8>>2]](r),y(r)}u[e+16|0]=1,r=i[e+24>>2],k=i[e+20>>2]}i[e+60>>2]=r,i[e+56>>2]=k,g[e+52>>1]=257,i[A>>2]=0,i[A+4>>2]=0,i[A+16>>2]=0,i[A+8>>2]=0,i[A+12>>2]=0}v=f+48|0;return}G0(),H()}z0(),H()}function wr(A,e,r,f,k){var n=0,t=0,o=0,s=0,w=0,h=0,_=0,B=0,m=0,X=0,Q=0,V=0,F=0,I=0,E=0,R=0,N=0,M=0;h=v-2048|0,v=h;i:{e:{if((r|0)>=2){for(t=r;n=_,_=n+1|0,o=t>>>0>3,t=t>>>1|0,!!o;);_=4-n|0;break e}if(_=5,(r|0)!=1)break i}for(R=20-k|0,N=1<<19-k,I=r&-4,w=r&3,F=r-1|0;;){B=(s<<1)+f|0,t=0,o=r;e:{for(;;){if(X=t,n=o,(n|0)<=0){if(o=0,t=0,n=0,F>>>0>=3)for(;g[(G(r,t)+s<<1)+h>>1]=0,g[(G(t|1,r)+s<<1)+h>>1]=0,g[(G(t|2,r)+s<<1)+h>>1]=0,g[(G(t|3,r)+s<<1)+h>>1]=0,t=t+4|0,n=n+4|0,(I|0)!=(n|0););if(!w)break e;for(;g[(G(r,t)+s<<1)+h>>1]=0,t=t+1|0,o=o+1|0,(w|0)!=(o|0););break e}if(t=X+1|0,o=n-1|0,!!C[B+(G(o,r)<<1)>>1])break}for(Q=n&2147483646,E=n&1,o=0;;){if(t=0,n=0,m=0,(X|0)!=(F|0))for(;V=G(g[B+(G(r,t)<<1)>>1],u[((t<<_<<5)+o|0)+61744|0])+n|0,n=t|1,n=V+G(g[B+(G(n,r)<<1)>>1],u[((n<<_<<5)+o|0)+61744|0])|0,t=t+2|0,m=m+2|0,(Q|0)!=(m|0););if(m=(G(r,o)+s<<1)+h|0,E&&(n=G(g[B+(G(r,t)<<1)>>1],u[((t<<_<<5)+o|0)+61744|0])+n|0),n=n- -64>>7,n=(n|0)>=32767?32767:n,g[m>>1]=(n|0)<=-32768?-32768:n,o=o+1|0,(o|0)==(r|0))break}}if(s=s+1|0,(s|0)==(r|0))break}for(m=r&-2,I=r&1,B=N>>R,s=-1<<k^-1,k=0;;){w=G(r,k),t=w-1|0,o=0,n=r;e:{r:{for(;;){if(X=o,f=n,(n|0)<=0)break r;if(o=o+1|0,n=n-1|0,!!C[(f+t<<1)+h>>1])break}for(Q=f&2147483646,E=f&1,M=(G(e,k)<<1)+A|0,o=0;;){if(t=0,n=0,f=0,(X|0)!=(F|0))for(;V=G(g[(t+w<<1)+h>>1],u[((t<<_<<5)+o|0)+61744|0])+n|0,n=t|1,n=V+G(g[(n+w<<1)+h>>1],u[((n<<_<<5)+o|0)+61744|0])|0,t=t+2|0,f=f+2|0,(Q|0)!=(f|0););if(f=(o<<1)+M|0,V=C[f>>1],E&&(n=G(g[(t+w<<1)+h>>1],u[((t<<_<<5)+o|0)+61744|0])+n|0),t=f,f=(n+N>>R)+V|0,g[t>>1]=(f|0)>=0?(f|0)<(s|0)?f:s:0,o=o+1|0,(o|0)==(r|0))break}break e}f=(G(e,k)<<1)+A|0;r:{if(!F){t=0;break r}for(X=f+2|0,t=0,n=0;w=t<<1,Q=w+f|0,o=B+C[Q>>1]|0,g[Q>>1]=(o|0)>=0?(o|0)<(s|0)?o:s:0,w=w+X|0,o=B+C[w>>1]|0,g[w>>1]=(o|0)>=0?(o|0)<(s|0)?o:s:0,t=t+2|0,n=n+2|0,(m|0)!=(n|0););}if(!I)break e;n=f+(t<<1)|0,f=B+C[n>>1]|0,g[n>>1]=(f|0)>=0?(f|0)<(s|0)?f:s:0}if(k=k+1|0,(k|0)==(r|0))break}}v=h+2048|0}function Jf(A,e,r,f,k,n){var t=0,o=0,s=0,w=0,h=0,_=0;i:{e:{if(s=A+548|0,!i[s+8>>2]){u[s+1|0]=0,A=7,t=i[s+44>>2];r:{if((t|0)!=i[s+40>>2]){o=t-4|0,t=i[o>>2],i[s+44>>2]=o,o=i[t+32>>2];break r}t=p(48),i[t+40>>2]=0,i[t+32>>2]=0,i[t+36>>2]=0,u[t+2|0]=0,u[t|0]=0,u[t+1|0]=0,o=p(64),i[t+32>>2]=o,w=o- -64|0,i[t+40>>2]=w,i[o+56>>2]=0,i[o+60>>2]=0,i[o+48>>2]=0,i[o+52>>2]=0,i[o+40>>2]=0,i[o+44>>2]=0,i[o+32>>2]=0,i[o+36>>2]=0,i[o+24>>2]=0,i[o+28>>2]=0,i[o+16>>2]=0,i[o+20>>2]=0,i[o+8>>2]=0,i[o+12>>2]=0,i[o>>2]=0,i[o+4>>2]=0,i[t+8>>2]=0,i[t+12>>2]=0,i[t+36>>2]=w,i[t+16>>2]=0,i[t+20>>2]=0,i[t+24>>2]=0,i[t+28>>2]=0}if(i[t+36>>2]=o,i[t+24>>2]=0,i[t+16>>2]=0,i[t+8>>2]=0,i[t+12>>2]=0,u[t+2|0]=0,g[t>>1]=0,i[t+28>>2]<(r|0))r:{if(o=y2(r),o){w=i[t+20>>2],w&&Z(w),i[t+28>>2]=r,i[t+20>>2]=o;break r}R4(s,t),t=0}if(t){r:{if(i[t+28>>2]>=(r|0)){A=i[t+20>>2];break r}if(A=y2(r),!A)break e;o=i[t+20>>2],o&&(w=i[t+24>>2],w&&x(A,o,w),Z(o)),i[t+28>>2]=r,i[t+20>>2]=A}if(r&&x(A,e,r),i[t+16>>2]=n,i[t+8>>2]=f,i[t+12>>2]=k,i[t+24>>2]=r,(r|0)>=3)for(A=i[t+20>>2],n=0;;){e=A+2|0;r:{f:{A:switch(f=l[A+2|0],f|0){case 0:case 3:break f;default:break A}n=n+2|0;break r}if(l[A|0]){e=A;break r}if((f|0)!=3){e=A;break r}if(l[A+1|0]){e=A;break r}r=i[t+36>>2],w=((r-i[t+32>>2]>>2)+n|0)+2|0;f:{if(o=i[t+40>>2],o>>>0>r>>>0){i[r>>2]=w,i[t+36>>2]=r+4;break f}A:{if(k=i[t+32>>2],r=r-k|0,_=r>>2,f=_+1|0,f>>>0<1073741824){if(o=o-k|0,h=o>>1,o=o>>>0>=2147483644?1073741823:f>>>0<h>>>0?h:f,o){if(o>>>0>=1073741824)break A;f=p(o<<2)}else f=0;h=f+r|0,i[h>>2]=w,w=h-(_<<2)|0,r&&x(w,k,r),i[t+40>>2]=f+(o<<2),r=h+4|0,i[t+36>>2]=r,i[t+32>>2]=w,k&&Z(k),i[t+36>>2]=r;break f}G0(),H()}z0(),H()}r=(i[t+24>>2]-n|0)-3|0,r&&x(e,A+3|0,r),e=A+1|0,r=i[t+24>>2]-1|0,i[t+24>>2]=r,n=n+1|0}if(A=e+1|0,n=n+1|0,!((n|0)<(r-2|0)))break}A=0,o=i[s+32>>2],e=o+i[s+28>>2]|0,f=i[s+20>>2],n=i[s+16>>2],(e|0)==(((f|0)!=(n|0)?(f-n<<8)-1|0:0)|0)&&(or(s+12|0),r=i[t+24>>2],n=i[s+16>>2],o=i[s+32>>2],e=o+i[s+28>>2]|0),i[i[(e>>>8&16777212)+n>>2]+((e&1023)<<2)>>2]=t,i[s+32>>2]=o+1,i[s+36>>2]=i[s+36>>2]+r}break i}D0(19522,18202,375,19559),H()}R4(s,t),A=7}return A}function Nf(A,e,r){var f=0,k=0,n=0,t=0,o=0,s=0,w=0,h=0;f=v-48|0,v=f,i[f+36>>2]=0,i[f+32>>2]=1,W[i[i[r>>2]+132>>2]](f+20|0,i[r+4>>2],f+44|0,f+40|0,f+36|0,0,f+32|0);i:{e:{r:{if(k=i[f+44>>2],k){for(s=e+28|0,o=e+24|0,t=e+32|0;;){f:{A:{k:{n:{t:switch(n=l[k+1|0],w=n>>>3|0,w-14|0){case 0:break n;case 1:break t;case 2:break k;default:break A}n=i[e+12>>2];t:{if(!n||($7(f,k,i[f+40>>2],n+104|0,o,s),u[f+19|0]>=0))break t;Z(i[f+8>>2])}k=i[e+12>>2],!k|u[e+7|0]&1||Vr(k,i[f+44>>2],i[f+40>>2]),u[e+7|0]=1;break f}n=i[e+12>>2],!n|u[e+6|0]&1||Vr(n,k,i[f+40>>2]),u[e+6|0]=1;break f}n=i[e+12>>2],!n|u[e+8|0]&1||Vr(n,k,i[f+40>>2]),u[e+8|0]=1;break f}if(l[e+76|0]||(i[e+60>>2]=0,i[e+64>>2]=0,u[t+23|0]=0,u[t+24|0]=0,u[t+25|0]=0,u[t+26|0]=0,i[t+16>>2]=0,i[t+20>>2]=0,i[t+8>>2]=0,i[t+12>>2]=0,i[t>>2]=0,i[t+4>>2]=0,u[e+76|0]=1,i[e+72>>2]=0,u[e+68|0]=1),Xi(t,k,i[f+40>>2]),n>>>0>95)break f;u[e+68|0]=w-7>>>0<3,i[e+72>>2]=i[f+36>>2]}if(!(i[f+32>>2]&&(i[f+36>>2]=0,i[f+32>>2]=1,W[i[i[r>>2]+132>>2]](f+20|0,i[r+4>>2],f+44|0,f+40|0,f+36|0,0,f+32|0),k=i[f+44>>2],k)))break}f:{if(k=i[o>>2],k&&(r=i[s>>2],r))break f;if(u[f+20|0]=0,u[f+31|0]=0,q(A,8,129,f+20|0),u[f+31|0]>=0)break i;Z(i[f+20>>2]);break i}f:{if(l[e+5|0]!=1||(w=i[e+12>>2],l[e+20|0]|!w))break f;s=i[e+16>>2],s&&(i[s+4>>2]=i[s+4>>2]+1),r=i[e+36>>2],o=i[e+40>>2];A:{if(r>>>0<o>>>0){i[r+4>>2]=s,i[r>>2]=w,k=r+8|0;break A}if(t=i[t>>2],r=r-t|0,h=r>>3,k=h+1|0,k>>>0>=536870912)break r;if(o=o-t|0,n=o>>2,o=o>>>0>=2147483640?536870911:k>>>0<n>>>0?n:k,o){if(o>>>0>=536870912)break e;k=p(o<<3)}else k=0;if(n=k+r|0,i[n+4>>2]=s,i[n>>2]=w,s=n-(h<<3)|0,r&&x(s,t,r),i[e+40>>2]=k+(o<<3),k=n+8|0,i[e+36>>2]=k,i[e+32>>2]=s,!t)break A;Z(t)}i[e+36>>2]=k,r=i[e+16>>2],i[e+12>>2]=0,i[e+16>>2]=0;A:{if(!r||(k=i[r+4>>2],i[r+4>>2]=k-1,k))break A;W[i[i[r>>2]+8>>2]](r),y(r)}u[e+20|0]=1,r=i[e+28>>2],k=i[e+24>>2]}i[e+64>>2]=r,i[e+60>>2]=k,g[e+56>>1]=257,i[A>>2]=0,i[A+4>>2]=0,i[A+16>>2]=0,i[A+8>>2]=0,i[A+12>>2]=0;break i}i[A>>2]=0,i[A+4>>2]=0,i[A+16>>2]=0,i[A+8>>2]=0,i[A+12>>2]=0;break i}G0(),H()}z0(),H()}v=f+48|0}function Fm(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0;var k=0,n=0,t=0,o=0,s=0,w=0,h=0,_=0;f=v-16|0,v=f;i:{e:{if(!(i[e+8>>2]|i[e+12>>2])){if(e=p(32),i[f+4>>2]=e,i[f+8>>2]=30,i[f+12>>2]=-2147483616,r=l[11502]|l[11503]<<8|(l[11504]<<16|l[11505]<<24),k=l[11498]|l[11499]<<8|(l[11500]<<16|l[11501]<<24),u[e|0]=k,u[e+1|0]=k>>>8,u[e+2|0]=k>>>16,u[e+3|0]=k>>>24,u[e+4|0]=r,u[e+5|0]=r>>>8,u[e+6|0]=r>>>16,u[e+7|0]=r>>>24,u[e+30|0]=0,r=l[11524]|l[11525]<<8|(l[11526]<<16|l[11527]<<24),k=l[11520]|l[11521]<<8|(l[11522]<<16|l[11523]<<24),u[e+22|0]=k,u[e+23|0]=k>>>8,u[e+24|0]=k>>>16,u[e+25|0]=k>>>24,u[e+26|0]=r,u[e+27|0]=r>>>8,u[e+28|0]=r>>>16,u[e+29|0]=r>>>24,r=l[11518]|l[11519]<<8|(l[11520]<<16|l[11521]<<24),k=l[11514]|l[11515]<<8|(l[11516]<<16|l[11517]<<24),u[e+16|0]=k,u[e+17|0]=k>>>8,u[e+18|0]=k>>>16,u[e+19|0]=k>>>24,u[e+20|0]=r,u[e+21|0]=r>>>8,u[e+22|0]=r>>>16,u[e+23|0]=r>>>24,r=l[11510]|l[11511]<<8|(l[11512]<<16|l[11513]<<24),k=l[11506]|l[11507]<<8|(l[11508]<<16|l[11509]<<24),u[e+8|0]=k,u[e+9|0]=k>>>8,u[e+10|0]=k>>>16,u[e+11|0]=k>>>24,u[e+12|0]=r,u[e+13|0]=r>>>8,u[e+14|0]=r>>>16,u[e+15|0]=r>>>24,q(A,2,0,f+4|0),u[f+15|0]>=0)break e;Z(i[f+4>>2]);break e}h=e,_=X2(r)&127,u[h+97|0]=_,k=X2(r),u[e+99|0]=k&31,u[e+98|0]=k>>>5,k=X2(r),u[e+106|0]=k&3,u[e+100|0]=k>>>7,u[e+105|0]=k>>>2&1,u[e+104|0]=k>>>3&1,u[e+103|0]=k>>>4&1,u[e+102|0]=k>>>5&1,u[e+101|0]=k>>>6&1,k=X2(r),t=k>>>4&1,u[e+107|0]=t,t&&(u[e+108|0]=k&15),n=i[e+116>>2],t=i[e+112>>2],s=n-t|0,k=i[r+16>>2];r:{if(s>>>0<k>>>0){if(w=k-s|0,o=i[e+120>>2],w>>>0<=o-n>>>0){w&&o0(n,0,w),i[e+116>>2]=n+w;break r}if((k|0)<0)break i;if(n=o-t|0,o=n<<1,o=n>>>0>=1073741823?2147483647:k>>>0<o>>>0?o:k,n=p(o),w&&o0(n+s|0,0,w),s&&x(n,t,s),i[e+120>>2]=n+o,i[e+116>>2]=k+n,i[e+112>>2]=n,!t)break r;Z(t);break r}if(k>>>0>=s>>>0)break r;i[e+116>>2]=k+t}if(l6(r,i[e+112>>2],k),l[r+20|0]==1){if(u[f+4|0]=0,u[f+15|0]=0,q(A,2,100,f+4|0),u[f+15|0]>=0)break e;Z(i[f+4>>2]);break e}if(e=i[26917],i[A>>2]=i[26916],i[A+4>>2]=e,A=A+8|0,u[107683]>=0){e=i[26919],i[A>>2]=i[26918],i[A+4>>2]=e,i[A+8>>2]=i[26920];break e}T(A,i[26918],i[26919])}v=f+16|0;return}G0(),H()}function hr(A,e,r,f,k){var n=0,t=0,o=0,s=0,w=0,h=0,_=0,B=0,m=0,X=0,Q=0,V=0,F=0,I=0,E=0,R=0,N=0,M=0;w=v-2048|0,v=w;i:{e:{if((e|0)>=2){for(n=e;o=_,_=o+1|0,t=n>>>0>3,n=n>>>1|0,!!t;);_=4-o|0;break e}if(_=5,(e|0)!=1)break i}for(V=e&-4,I=e&3,E=e-1|0,m=1<<k,Q=0-m|0,F=m+65535|0,M=1<<f-1;;){X=(s<<1)+r|0,n=0,t=e;e:{for(;;){if(h=n,k=t,(k|0)<=0){if(t=0,n=0,o=0,E>>>0>=3)for(;g[(G(e,n)+s<<1)+w>>1]=0,g[(G(n|1,e)+s<<1)+w>>1]=0,g[(G(n|2,e)+s<<1)+w>>1]=0,g[(G(n|3,e)+s<<1)+w>>1]=0,n=n+4|0,o=o+4|0,(V|0)!=(o|0););if(!I)break e;for(;g[(G(e,n)+s<<1)+w>>1]=0,n=n+1|0,t=t+1|0,(I|0)!=(t|0););break e}if(n=h+1|0,t=k-1|0,!!C[X+(G(t,e)<<1)>>1])break}for(R=k&2147483646,N=k&1,t=0;;){if(n=0,o=0,B=0,(h|0)!=(E|0))for(;k=n|1,o=(G(g[X+(G(e,n)<<1)>>1],u[((n<<_<<5)+t|0)+61744|0])+o|0)+G(g[X+(G(k,e)<<1)>>1],u[((k<<_<<5)+t|0)+61744|0])|0,n=n+2|0,B=B+2|0,(R|0)!=(B|0););if(k=(G(e,t)+s<<1)+w|0,N&&(o=G(g[X+(G(e,n)<<1)>>1],u[((n<<_<<5)+t|0)+61744|0])+o|0),n=k,k=o- -64>>7,g[n>>1]=(k|0)<(Q|0)?Q:(k|0)<(m|0)?k:F,t=t+1|0,(t|0)==(e|0))break}}if(s=s+1|0,(s|0)==(e|0))break}for(I=e&-8,X=e&7,h=M>>f,r=0;;){s=G(e,r),n=s-1|0,t=0,o=e;e:{r:{for(;;){if(Q=t,k=o,(k|0)<=0)break r;if(t=t+1|0,o=k-1|0,!!C[(k+n<<1)+w>>1])break}for(B=k&2147483646,m=k&1,V=(s<<2)+A|0,t=0;;){if(n=0,o=0,k=0,(Q|0)!=(E|0))for(;F=G(g[(n+s<<1)+w>>1],u[((n<<_<<5)+t|0)+61744|0])+o|0,o=n|1,o=F+G(g[(o+s<<1)+w>>1],u[((o<<_<<5)+t|0)+61744|0])|0,n=n+2|0,k=k+2|0,(B|0)!=(k|0););if(k=V+(t<<2)|0,m&&(o=G(g[(n+s<<1)+w>>1],u[((n<<_<<5)+t|0)+61744|0])+o|0),i[k>>2]=o+M>>f,t=t+1|0,(t|0)==(e|0))break}break e}if(k=(s<<2)+A|0,o=0,t=0,E>>>0>=7)for(Q=k+28|0,s=k+24|0,m=k+20|0,V=k+16|0,F=k+12|0,R=k+8|0,N=k+4|0,B=0;n=t<<2,i[n+k>>2]=h,i[n+N>>2]=h,i[n+R>>2]=h,i[n+F>>2]=h,i[n+V>>2]=h,i[n+m>>2]=h,i[n+s>>2]=h,i[n+Q>>2]=h,t=t+8|0,B=B+8|0,(I|0)!=(B|0););if(!X)break e;for(;i[k+(t<<2)>>2]=h,t=t+1|0,o=o+1|0,(X|0)!=(o|0););}if(r=r+1|0,(r|0)==(e|0))break}}v=w+2048|0}function R9(A,e,r,f,k,n,t,o,s,w){var h=0,_=0,B=0,m=0,X=0,Q=0,V=0;Q=v-16|0,v=Q;i:{e:{r:{f:{A:{if(W[i[i[A>>2]+12>>2]](A,f)|0){if(_=W[i[i[A>>2]+8>>2]](A,f)|0,!(i[_+24>>2]>(k|0)&i[_+28>>2]>(n|0))){F2(A+4|0,1026,0),u[w|0]=0;break r}k:{if(h=i[_+168>>2],f=k>>h,(f|0)<0||(B=i[_+172>>2],(B|0)<=(f|0)))break k;if(h=n>>h,!((h|0)<0|(h|0)>=i[_+176>>2])){if(!(l[((i[_+160>>2]+G(f,3)|0)+G(G(h,B),3)|0)+1|0]&3)){g[s>>1]=0,g[s+2>>1]=0,u[w|0]=0;break r}if(l[_+312|0]==1){g[s>>1]=0,g[s+2>>1]=0,u[w|0]=0;break r}n:{if(h=i[_+188>>2],f=k>>h,(f|0)<0||(B=i[_+192>>2],(B|0)<=(f|0)))break n;if(h=n>>h,!((h|0)<0|(h|0)>=i[_+196>>2])){if(h=(i[_+180>>2]+G(f,12)|0)+G(G(h,B),12)|0,!l[h|0]){B=h+3|0,f=1,h=h+8|0;break f}if(!l[h+1|0]){B=h+2|0,f=0,h=h+4|0;break f}if(m=i[e+96>>2],B=1,i[r+340>>2]<=0)break A;for(X=r+988|0,f=0;;){if(V=i[(W[i[i[A>>2]+8>>2]](A,i[X+(f<<2)>>2])|0)+96>>2],B=(V|0)<=(m|0),f=f+1|0,(f|0)>=i[r+340>>2])break A;if(!((m|0)>=(V|0)))break}break A}break e}break i}break e}break i}D0(26551,18225,1136,4802),H()}A:{if(!B|i[r+336>>2]<=0)break A;for(X=r+924|0,f=0;;){if(V=i[(W[i[i[A>>2]+8>>2]](A,i[X+(f<<2)>>2])|0)+96>>2],B=(V|0)<=(m|0),f=f+1|0,(f|0)>=i[r+336>>2])break A;if(!((m|0)>=(V|0)))break}}if(B){B=(o+h|0)+2|0,f=o,h=(h+(f<<2)|0)+4|0;break f}f=u[r+380|0],B=(h+f|0)+2|0,h=(h+(f<<2)|0)+4|0}if(m=i[_+148>>2],k=k>>m,(k|0)<0||(X=i[_+152>>2],(X|0)<=(k|0)))break i;if(n=n>>m,(n|0)<0|(n|0)>=i[_+156>>2])break e;if(k=C[((i[_+140>>2]+G(k,24)|0)+G(G(n,X),24)|0)+2>>1],m=i[_+52>>2],k>>>0>=i[_+56>>2]-m>>2>>>0){F2(A+4|0,1033,0),u[w|0]=0,g[s>>1]=0,g[s+2>>1]=0;break r}if(n=(((o<<4)+r|0)+t|0)+1308|0,B=u[B|0],m=i[m+(k<<2)>>2],l[n|0]!=l[(B+(m+(f<<4)|0)|0)+1308|0]){u[w|0]=0,g[s>>1]=0,g[s+2>>1]=0;break r}k=C[h>>1]|C[h+2>>1]<<16,u[w|0]=1;f:{if(!l[n|0]&&(f=i[_+96>>2]-i[((m+(f<<6)|0)+(B<<2)|0)+1052>>2]|0,r=i[e+96>>2]-i[(((o<<6)+r|0)+(t<<2)|0)+1052>>2]|0,(f|0)!=(r|0)))break f;g[s>>1]=k,g[s+2>>1]=k>>>16;break r}if(i[Q+8>>2]=k,i[Q+12>>2]=k,Ut(s,Q+8|0,f,r))break r;F2(A+4|0,1008,0),u[e+312|0]=3}v=Q+16|0;return}D0(4618,10893,119,4231),H()}D0(4656,10893,118,4231),H()}function J9(A,e,r){var f=0,k=0,n=0,t=0,o=0,s=0,w=0,h=0,_=0;n=v+-64|0,v=n,t=i[e>>2],o=i[t+128>>2];i:{e:{if(!o){s=t+128|0,k=s;break e}for(f=o;;){if(k=f,s=i[f+16>>2],(s|0)>(r|0)){if(s=f,f=i[f>>2],f)continue;break e}if((r|0)<=(s|0))break i;if(f=i[k+4>>2],!f)break}s=k+4|0}f=p(60),i[f+16>>2]=r,i[f+28>>2]=0,i[f+32>>2]=0,i[f+20>>2]=1,i[f+24>>2]=256,i[f+8>>2]=k,i[f>>2]=0,i[f+4>>2]=0,i[f+36>>2]=0,i[f+40>>2]=0,i[f+44>>2]=0,i[f+48>>2]=0,i[f+52>>2]=0,i[f+56>>2]=0,i[s>>2]=f,k=i[i[t+124>>2]>>2],k&&(i[t+124>>2]=k),m1(i[t+128>>2],f),i[t+132>>2]=i[t+132>>2]+1,t=i[e>>2],o=i[t+128>>2]}k=i[f+48>>2],i[n+56>>2]=i[f+44>>2],i[n+60>>2]=k,k=i[f+40>>2],i[n+48>>2]=i[f+36>>2],i[n+52>>2]=k,k=i[f+32>>2],i[n+40>>2]=i[f+28>>2],i[n+44>>2]=k,k=i[f+24>>2],i[n+32>>2]=i[f+20>>2],i[n+36>>2]=k,_=i[f+56>>2],s=i[f+52>>2];i:{if(!o)break i;for(w=t+128|0,f=w,k=o;h=i[k+16>>2]<(r|0),f=h?f:k,k=i[(h?4:0)+k>>2],!!k;);if((f|0)==(w|0)|i[f+16>>2]>(r|0))break i;r=i[f+4>>2];e:{if(!r){for(r=f;k=i[r+8>>2],w=i[k>>2]!=(r|0),r=k,!!w;);break e}for(;k=r,r=i[k>>2],!!r;);}i[t+124>>2]==(f|0)&&(i[t+124>>2]=k),i[t+132>>2]=i[t+132>>2]-1,yf(o,f),Z(f),t=i[e>>2]}if(i[t+136>>2]){l[107752]||(u[107752]=1),k=i[26940];i:{if(!k)break i;for(r=107760,f=i[t+136>>2];o=f>>>0>u0[k+16>>2],r=o?r:k,k=i[(o?4:0)+k>>2],!!k;);if((r|0)==107760|f>>>0<u0[r+16>>2])break i;i[r+20>>2]=i[r+20>>2]-s}i[t+140>>2]=i[t+140>>2]-s}f=i[A+128>>2];i:{e:{if(!f){r=A+128|0,k=r;break e}for(;;){if(k=f,r=i[f+16>>2],(r|0)>6){if(r=f,f=i[f>>2],f)continue;break e}if((r|0)>=6)break i;if(f=i[k+4>>2],!f)break}r=k+4|0}f=p(60),i[f+16>>2]=6,o=i[n+36>>2],i[f+20>>2]=i[n+32>>2],i[f+24>>2]=o,o=i[n+44>>2],i[f+28>>2]=i[n+40>>2],i[f+32>>2]=o,o=i[n+52>>2],i[f+36>>2]=i[n+48>>2],i[f+40>>2]=o,o=i[n+60>>2],i[f+44>>2]=i[n+56>>2],i[f+48>>2]=o,i[f+56>>2]=_,i[f+52>>2]=s,i[f+8>>2]=k,i[f>>2]=0,i[f+4>>2]=0,i[r>>2]=f,r=i[i[A+124>>2]>>2],r&&(i[A+124>>2]=r),m1(i[A+128>>2],f),i[A+132>>2]=i[A+132>>2]+1}q4(n+12|0,A+136|0,s,i[i[e>>2]+136>>2],18877),u[n+31|0]<0&&Z(i[n+20>>2]),v=n- -64|0}function Im(A,e,r,f,k,n,t,o,s){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,t=t|0,o=o|0,s=s|0;var w=0,h=0;w=v+-64|0,v=w,h=i[r>>2],r=i[r+4>>2],r&&(i[r+4>>2]=i[r+4>>2]+1),i[w+60>>2]=r,i[w+56>>2]=h;i:{e:{r:{if(!l[e+4|0]){if(W[i[i[f>>2]+120>>2]](w+24|0,i[f+4>>2],w+56|0,n,t,o,k),k=i[w+24>>2],k){if(f=i[w+28>>2],n=i[w+32>>2],r=h2(n),r>>>0>=2147483640)break e;f:{A:{if(r>>>0>=11){t=r|7,e=p(t+1|0),i[w+52>>2]=t-2147483647,i[w+44>>2]=e,i[w+48>>2]=r;break A}if(u[w+55|0]=r,e=w+44|0,!r)break f}if(!r)break f;x(e,n,r)}if(u[e+r|0]=0,q(A,k,f,w+44|0),u[w+55|0]>=0)break r;Z(i[w+44>>2]);break r}r=p(208),i[r+4>>2]=0,i[r+8>>2]=0,i[r>>2]=90684,k=r+16|0,i[k+8>>2]=0,i[k+12>>2]=0,i[r+32>>2]=0,i[r+36>>2]=0,i[r+40>>2]=0,i[r+44>>2]=0,i[r+48>>2]=0,i[r+16>>2]=86356,i[r+60>>2]=0,i[r+64>>2]=0,i[r+52>>2]=0,i[r+56>>2]=0,i[r+72>>2]=-1,i[r+76>>2]=-1,i[r+80>>2]=-1,i[r+84>>2]=-1,i[r+116>>2]=0,i[r+88>>2]=0,i[r+92>>2]=0,i[r+96>>2]=0,i[r+100>>2]=0,i[r+104>>2]=0,i[r+108>>2]=0,g[r+112>>1]=0,i[r+16>>2]=99816,i[r+136>>2]=0,i[r+140>>2]=0,g[r+120>>1]=259,i[r+144>>2]=0,i[r+148>>2]=0,i[r+152>>2]=0,i[r+156>>2]=0,i[r+160>>2]=0,i[r+164>>2]=0,i[r+168>>2]=0,i[r+172>>2]=0,i[r+176>>2]=0,i[r+180>>2]=0,i[r+200>>2]=0,i[r+192>>2]=0,i[r+196>>2]=0,i[r+32>>2]=1987470147,i[e+12>>2]=k,k=i[e+16>>2],i[e+16>>2]=r;f:{if(!k||(r=i[k+4>>2],i[k+4>>2]=r-1,r))break f;W[i[i[k>>2]+8>>2]](k),y(k)}u[e+4|0]=1}if(Nf(w+24|0,e,f),i[w+24>>2]){e=i[w+28>>2],i[A>>2]=i[w+24>>2],i[A+4>>2]=e,e=i[w+36>>2],i[A+8>>2]=i[w+32>>2],i[A+12>>2]=e,i[A+16>>2]=i[w+40>>2];break r}W[i[i[f>>2]+124>>2]](w+44|0,i[f+4>>2],w+56|0,s),k=i[w+44>>2];f:{if(k){if(f=i[w+48>>2],n=i[w+52>>2],r=h2(n),r>>>0>=2147483640)break i;A:{k:{if(r>>>0>=11){t=r|7,e=p(t+1|0),i[w+20>>2]=t-2147483647,i[w+12>>2]=e,i[w+16>>2]=r;break k}if(u[w+23|0]=r,e=w+12|0,!r)break A}if(!r)break A;x(e,n,r)}if(u[e+r|0]=0,q(A,k,f,w+12|0),u[w+23|0]>=0)break f;Z(i[w+12>>2]);break f}Nf(A,e,f)}if(u[w+43|0]>=0)break r;Z(i[w+32>>2])}A=i[w+60>>2];r:{if(!A||(e=i[A+4>>2],i[A+4>>2]=e-1,e))break r;W[i[i[A>>2]+8>>2]](A),y(A)}v=w- -64|0;return}Q0(),H()}Q0(),H()}function N9(A,e,r){var f=0,k=0,n=0;k=v-16|0,v=k,f=i[r+4>>2]-i[r>>2]|0;i:{if(f>>>0>=256){if(e=p(64),i[k+4>>2]=e,i[k+8>>2]=57,i[k+12>>2]=-2147483584,r=l[11533]|l[11534]<<8|(l[11535]<<16|l[11536]<<24),f=l[11529]|l[11530]<<8|(l[11531]<<16|l[11532]<<24),u[e|0]=f,u[e+1|0]=f>>>8,u[e+2|0]=f>>>16,u[e+3|0]=f>>>24,u[e+4|0]=r,u[e+5|0]=r>>>8,u[e+6|0]=r>>>16,u[e+7|0]=r>>>24,u[e+57|0]=0,u[e+56|0]=l[11585],r=l[11581]|l[11582]<<8|(l[11583]<<16|l[11584]<<24),f=l[11577]|l[11578]<<8|(l[11579]<<16|l[11580]<<24),u[e+48|0]=f,u[e+49|0]=f>>>8,u[e+50|0]=f>>>16,u[e+51|0]=f>>>24,u[e+52|0]=r,u[e+53|0]=r>>>8,u[e+54|0]=r>>>16,u[e+55|0]=r>>>24,r=l[11573]|l[11574]<<8|(l[11575]<<16|l[11576]<<24),f=l[11569]|l[11570]<<8|(l[11571]<<16|l[11572]<<24),u[e+40|0]=f,u[e+41|0]=f>>>8,u[e+42|0]=f>>>16,u[e+43|0]=f>>>24,u[e+44|0]=r,u[e+45|0]=r>>>8,u[e+46|0]=r>>>16,u[e+47|0]=r>>>24,r=l[11565]|l[11566]<<8|(l[11567]<<16|l[11568]<<24),f=l[11561]|l[11562]<<8|(l[11563]<<16|l[11564]<<24),u[e+32|0]=f,u[e+33|0]=f>>>8,u[e+34|0]=f>>>16,u[e+35|0]=f>>>24,u[e+36|0]=r,u[e+37|0]=r>>>8,u[e+38|0]=r>>>16,u[e+39|0]=r>>>24,r=l[11557]|l[11558]<<8|(l[11559]<<16|l[11560]<<24),f=l[11553]|l[11554]<<8|(l[11555]<<16|l[11556]<<24),u[e+24|0]=f,u[e+25|0]=f>>>8,u[e+26|0]=f>>>16,u[e+27|0]=f>>>24,u[e+28|0]=r,u[e+29|0]=r>>>8,u[e+30|0]=r>>>16,u[e+31|0]=r>>>24,r=l[11549]|l[11550]<<8|(l[11551]<<16|l[11552]<<24),f=l[11545]|l[11546]<<8|(l[11547]<<16|l[11548]<<24),u[e+16|0]=f,u[e+17|0]=f>>>8,u[e+18|0]=f>>>16,u[e+19|0]=f>>>24,u[e+20|0]=r,u[e+21|0]=r>>>8,u[e+22|0]=r>>>16,u[e+23|0]=r>>>24,r=l[11541]|l[11542]<<8|(l[11543]<<16|l[11544]<<24),f=l[11537]|l[11538]<<8|(l[11539]<<16|l[11540]<<24),u[e+8|0]=f,u[e+9|0]=f>>>8,u[e+10|0]=f>>>16,u[e+11|0]=f>>>24,u[e+12|0]=r,u[e+13|0]=r>>>8,u[e+14|0]=r>>>16,u[e+15|0]=r>>>24,q(A,9,0,k+4|0),u[k+15|0]>=0)break i;Z(i[k+4>>2]);break i}if(Kf(i[e>>2],f),f=e+16|0,n=i[e+20>>2],e=i[r>>2],r=i[r+4>>2],$4(f,n,e,r,r-e|0),e=i[26917],i[A>>2]=i[26916],i[A+4>>2]=e,A=A+8|0,u[107683]>=0){e=i[26919],i[A>>2]=i[26918],i[A+4>>2]=e,i[A+8>>2]=i[26920];break i}T(A,i[26918],i[26919])}v=k+16|0}function U9(A,e,r,f,k,n,t,o,s){var w=0,h=0,_=0,B=0,m=0,X=0,Q=0,V=0,F=0,I=0,E=0;w=v-128|0,v=w;i:{e:{r:{if(!p6(n,t,o,s,0,0,0,0))break r;h=s&65535,B=s>>>16&32767;f:A:{if((B|0)!=32767){if(m=4,B)break A;m=n|o|(t|h)?3:2;break f}m=!(n|o|(t|h))}if(!m)break r;if(I=k>>>16|0,Q=I&32767,(Q|0)!=32767)break e}n1(w+16|0,e,r,f,k,n,t,o,s),e=i[w+16>>2],f=i[w+20>>2],k=i[w+24>>2],r=i[w+28>>2],S7(w,e,f,k,r,e,f,k,r),f=i[w+8>>2],k=i[w+12>>2],o=i[w>>2],s=i[w+4>>2];break i}if(X=f,m=k&2147483647,h=m,B=o,_=s&2147483647,(p6(e,r,X,h,n,t,o,_)|0)<=0){if(p6(e,r,X,h,n,t,o,_)){o=e,s=r;break i}n1(w+112|0,e,r,f,k,0,0,0,0),f=i[w+120>>2],k=i[w+124>>2],o=i[w+112>>2],s=i[w+116>>2];break i}if(V=s>>>16&32767,Q?(s=r,o=e):(n1(w+96|0,e,r,X,m,0,0,0,1081540608),X=i[w+104>>2],o=i[w+108>>2],m=o,Q=(o>>>16|0)-120|0,s=i[w+100>>2],o=i[w+96>>2]),V||(n1(w+80|0,n,t,B,_,0,0,0,1081540608),B=i[w+88>>2],n=i[w+92>>2],_=n,V=(n>>>16|0)-120|0,t=i[w+84>>2],n=i[w+80>>2]),F=B,E=_&65535|65536,m=m&65535|65536,(Q|0)>(V|0)){for(;;){_=X-F|0,h=(t|0)==(s|0)&n>>>0>o>>>0|t>>>0>s>>>0,B=_-h|0,h=(m-((X>>>0<F>>>0)+E|0)|0)-(h>>>0>_>>>0)|0;e:{if((h|0)>=0|(h|0)>0){if(X=o,o=o-n|0,s=s-((n>>>0>X>>>0)+t|0)|0,!(o|B|(s|h))){n1(w+32|0,e,r,f,k,0,0,0,0),f=i[w+40>>2],k=i[w+44>>2],o=i[w+32>>2],s=i[w+36>>2];break i}h=h<<1|B>>>31,X=B<<1|s>>>31;break e}h=m<<1|X>>>31,X=X<<1|s>>>31}if(m=h,h=s<<1|o>>>31,o=o<<1,s=h,Q=Q-1|0,!((V|0)<(Q|0)))break}Q=V}_=X-F|0,h=(t|0)==(s|0)&n>>>0>o>>>0|t>>>0>s>>>0,B=_-h|0,h=(m-((X>>>0<F>>>0)+E|0)|0)-(h>>>0>_>>>0)|0,_=h;e:{if((h|0)<0){B=X,_=m;break e}if(X=o,o=o-n|0,s=s-((n>>>0>X>>>0)+t|0)|0,o|B|(s|_))break e;n1(w+48|0,e,r,f,k,0,0,0,0),f=i[w+56>>2],k=i[w+60>>2],o=i[w+48>>2],s=i[w+52>>2];break i}if((_|0)==65535|_>>>0<65535)for(;e=s>>>31|0,Q=Q-1|0,m=s<<1|o>>>31,o=o<<1,s=m,r=e,e=_<<1|B>>>31,B=r|B<<1,_=e,e>>>0<65536;);if(e=I&32768,(Q|0)<=0){n1(w- -64|0,o,s,B,_&65535|(e|Q+120)<<16,0,0,0,1065811968),f=i[w+72>>2],k=i[w+76>>2],o=i[w+64>>2],s=i[w+68>>2];break i}f=B,k=_&65535|(e|Q)<<16}i[A>>2]=o,i[A+4>>2]=s,i[A+8>>2]=f,i[A+12>>2]=k,v=w+128|0}function Uf(A,e,r,f,k){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0;var n=0,t=0,o=0,s=0,w=0,h=0,_=0,B=0,m=0,X=0,Q=0,V=0,F=0;n=v+-64|0,v=n,i[r>>2]=0,t=i[26720],h=i[26721];i:{e:{for(;;){r:{if(i[n+44>>2]=0,I7(i[e>>2],n+44|0))break r;if(o=Do(i[e>>2]),o){if(t=i[r>>2],t&&x4(t),f&&(i[f>>2]=i[o+288>>2]),f=i[o+20>>2],Q=f,Df(n+52|0,i[i[14774]+o>>2],i[i[14777]+o>>2],f?0:2,f,r),f=i[n+52>>2],f){t=i[n+60>>2],s=i[n+56>>2];break e}for(m=i[i[o+124>>2]+i[14780]>>2],V=(m+7|0)/8|0;;){if(w>>>0<=2?f=i[i[o+124>>2]+i[(w<<2)+59120>>2]>>2]:f=0,(f|0)!=(m|0)){x4(i[r>>2]),t=16245,f=4,s=3003;break e}t=59080,X=Jo(o,w,n+48|0),s=129,f=7;f:{if(_=w>>>0<=2?i[i[(w<<2)+59096>>2]+o>>2]:0,h=w>>>0<=2?i[i[(w<<2)+59108>>2]+o>>2]:0,!((_|0)<=0|(h|0)<=0)){if(s=i[(w<<2)+59084>>2],fo(n+52|0,i[r>>2],s,_,h,m,k),f=i[n+52>>2],!f)break f;s=i[n+56>>2],k=e+8|0,R2(k,i[n+60>>2]),t=u[e+19|0]<0?i[e+8>>2]:k}x4(i[r>>2]);break e}if(t=G(_,V),f=0,_=hi(i[r>>2],s,n+52|0),(h|0)!=1)for(F=h&2147483646,s=0;B=!t,B||x(_+G(i[n+52>>2],f)|0,G(i[n+48>>2],f)+X|0,t),B||(B=f|1,x(_+G(B,i[n+52>>2])|0,G(B,i[n+48>>2])+X|0,t)),f=f+2|0,s=s+2|0,(F|0)!=(s|0););if(!(h&1)|!t||x(_+G(i[n+52>>2],f)|0,G(i[n+48>>2],f)+X|0,t),!(Q&&(f=w>>>0<2,w=w+1|0,f)))break}if(f=B3(),XA(A,f,l[i[o+124>>2]+9018|0]),i[A>>2]){if(l[e+4|0]==1){x2(f),x4(i[r>>2]),i[r>>2]=0;break i}k=i[r>>2],i[n+40>>2]=i[A+8>>2],t=i[A+4>>2],i[n+32>>2]=i[A>>2],i[n+36>>2]=t,jr(k,n+32|0)}if(WA(A,f,l[i[o+124>>2]+9019|0]),i[A>>2]){if(l[e+4|0]==1){x2(f),x4(i[r>>2]),i[r>>2]=0;break i}k=i[r>>2],i[n+24>>2]=i[A+8>>2],t=i[A+4>>2],i[n+16>>2]=i[A>>2],i[n+20>>2]=t,jr(k,n+16|0)}if(GA(A,f,l[i[o+124>>2]+9020|0]),i[A>>2]){if(l[e+4|0]==1){x2(f),x4(i[r>>2]),i[r>>2]=0;break i}k=i[r>>2],i[n+8>>2]=i[A+8>>2],t=i[A+4>>2],i[n>>2]=i[A>>2],i[n+4>>2]=t,jr(k,n)}u[f+16|0]=l[i[o+124>>2]+9016|0]!=0,vo(n+52|0,i[r>>2],f),x2(f),ol(i[e>>2]),i[A+8>>2]=i[24165],e=i[24164],i[A>>2]=i[24163],i[A+4>>2]=e;break i}if(i[n+44>>2])continue}break}i[A+4>>2]=t,i[A+8>>2]=h,i[A>>2]=0;break i}i[A>>2]=f,i[A+4>>2]=s,i[A+8>>2]=t}v=n- -64|0}function D9(A,e,r,f,k){var n=0,t=0,o=0;t=v-16|0,v=t,i[A+8>>2]=0,i[A>>2]=0,i[A+4>>2]=0;i:{e:switch(f-1|0){case 0:case 3:break e;default:break i}e=i[e>>2],o=i[e+16>>2],n=i[e+20>>2],n&&(i[n+4>>2]=i[n+4>>2]+1);e:{if(o){e=p(128),i[e+4>>2]=0,i[e+8>>2]=0,i[e>>2]=91164,f=e+16|0,i[f+8>>2]=0,i[f+12>>2]=0,i[f+16>>2]=0,i[f+20>>2]=0,i[f+24>>2]=0,i[f+28>>2]=0,i[f+32>>2]=0,i[f>>2]=86356,i[e+60>>2]=0,i[e+64>>2]=0,i[e+52>>2]=0,i[e+56>>2]=0,i[e+72>>2]=-1,i[e+76>>2]=-1,i[e+80>>2]=-1,i[e+84>>2]=-1,i[e+88>>2]=0,i[e+92>>2]=0,i[e+96>>2]=0,i[e+100>>2]=0,i[e+104>>2]=0,i[e+108>>2]=0,u[e+112|0]=0,i[f>>2]=95408,i[e+32>>2]=1668246642,i[t+12>>2]=e,i[t+8>>2]=f;r:{if(!n){i[e+120>>2]=n,i[e+116>>2]=o;break r}if(i[n+4>>2]=i[n+4>>2]+2,i[e+120>>2]=n,i[e+116>>2]=o,e=i[n+4>>2],i[n+4>>2]=e-1,e)break r;W[i[i[n>>2]+8>>2]](n),y(n)}r2(A,t+8|0),e=i[t+12>>2];r:{if(!e||(f=i[e+4>>2],i[e+4>>2]=f-1,f))break r;W[i[i[e>>2]+8>>2]](e),y(e)}f=l[r|0],e=l[r+3|0]!=0&i[r+4>>2]!=0&f>>>0>2;break e}f=l[r|0],e=i[r+4>>2]!=0}e:{if(!(!l[r+8|0]|(f&255)>>>0<4)|!e)break e;r=p(24),u[r+22|0]=1,g[r+20>>1]=2,g[r+16>>1]=2,g[r+18>>1]=2,i[r+12>>2]=95368,i[r+4>>2]=0,i[r+8>>2]=0,i[r>>2]=95288,e=r+16|0,u[e+6|0]=1,g[e+4>>1]=6,g[e>>1]=1,g[e+2>>1]=13,Hl(e,k),e=p(128),i[e>>2]=91164,i[e+4>>2]=0,i[e+8>>2]=0,f=e+16|0,i[f+8>>2]=0,i[f+12>>2]=0,i[f+16>>2]=0,i[f+20>>2]=0,i[f+24>>2]=0,i[f+28>>2]=0,i[f+32>>2]=0,i[f>>2]=86356,i[e+60>>2]=0,i[e+64>>2]=0,i[e+52>>2]=0,i[e+56>>2]=0,i[e+72>>2]=-1,i[e+76>>2]=-1,i[e+80>>2]=-1,i[e+84>>2]=-1,i[e+88>>2]=0,i[e+92>>2]=0,i[e+96>>2]=0,i[e+100>>2]=0,i[e+104>>2]=0,i[e+108>>2]=0,u[e+112|0]=0,i[f>>2]=95408,i[e+32>>2]=1668246642,i[t+12>>2]=e,i[t+8>>2]=f,i[r+4>>2]=i[r+4>>2]+2,i[e+120>>2]=r,i[e+116>>2]=r+12,e=i[r+4>>2],i[r+4>>2]=e-1,e||(W[i[i[r>>2]+8>>2]](r),y(r)),r2(A,t+8|0),A=i[t+12>>2];r:{if(!A||(e=i[A+4>>2],i[A+4>>2]=e-1,e))break r;W[i[i[A>>2]+8>>2]](A),y(A)}if(A=i[r+4>>2],i[r+4>>2]=A-1,A)break e;W[i[i[r>>2]+8>>2]](r),y(r)}if(!n||(A=i[n+4>>2],i[n+4>>2]=A-1,A))break i;W[i[i[n>>2]+8>>2]](n),y(n)}v=t+16|0}function Cm(A,e,r,f,k,n){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0;var t=0,o=0,s=0;t=v-128|0,v=t;i:{if(!f){e=i[23570],i[A>>2]=i[23569],i[A+4>>2]=e,i[A+8>>2]=i[23571];break i}n&&(i[n>>2]=0),u[t+85|0]=0,u[t+86|0]=0,u[t+87|0]=0,u[t+88|0]=0,g[t+82>>1]=0,g[t+84>>1]=0,g[t+80>>1]=263,u[t+112|0]=1,u[t+108|0]=0,i[t+100>>2]=2,i[t+104>>2]=2,u[t+96|0]=1,i[t+92>>2]=1;e:{if(!k)break e;r:{f:{A:{k:{n:{t:{u:{o:switch(o=l[k|0],(o>>>0>=7?7:o)-1|0){case 0:break t;case 1:break u;case 2:break o;case 3:break f;case 4:break A;case 5:break k;case 6:break n;default:break r}u[t+83|0]=l[k+3|0],u[t+82|0]=l[k+2|0],u[t+81|0]=l[k+1|0];break r}u[t+82|0]=l[k+2|0],u[t+81|0]=l[k+1|0];break r}u[t+81|0]=l[k+1|0];break r}u[t+112|0]=l[k+32|0]}s=i[k+20>>2],o=t+96|0,i[o>>2]=i[k+16>>2],i[o+4>>2]=s,s=i[k+28>>2],i[o+8>>2]=i[k+24>>2],i[o+12>>2]=s}i[t+92>>2]=i[k+12>>2]}if(o=i[k+4>>2],i[t+84>>2]=o,u[t+88|0]=l[k+8|0],u[t+83|0]=l[k+3|0],u[t+82|0]=l[k+2|0],u[t+81|0]=l[k+1|0],o)break e}if(!S4(i[r>>2]))break e;o=i[r>>2],k=C[o+6>>1]|C[o+8>>1]<<16,o=C[o+10>>1]|C[o+12>>1]<<16,i[t+36>>2]=k>>>16,i[t+32>>2]=k&65535,u[t+28|0]=1,u[t+44|0]=o>>>16&1,i[t+40>>2]=o&65535,i[t+84>>2]=t+28}Oi(t+4|0,i[e>>2],r,f,t+80|0,1);e:{r:switch(l[t+24|0]){default:_2(),H();case 1:b0(A,t+4|0,i[e>>2]);break e;case 0:break r}i[t+120>>2]=i[t+4>>2],r=i[t+8>>2],i[t+124>>2]=r,r&&(i[r+4>>2]=i[r+4>>2]+1),r=i[e>>2],i[r+40>>2]||zf(r,t+120|0);r:{if(!n)break r;if(r=p(16),i[r+8>>2]=0,i[r+12>>2]=0,i[n>>2]=r,f=i[t+120>>2],k=i[t+124>>2],i[t+120>>2]=0,i[t+124>>2]=0,i[r>>2]=f,i[r+4>>2]=k,k=i[e>>2],f=i[e+4>>2],!f){i[r+12>>2]=f,i[r+8>>2]=k;break r}if(i[f+4>>2]=i[f+4>>2]+1,i[r+8>>2]=k,e=i[r+12>>2],i[r+12>>2]=f,!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break r;W[i[i[e>>2]+8>>2]](e),y(e)}if(e=i[24057],i[A>>2]=i[24056],i[A+4>>2]=e,i[A+8>>2]=i[24058],A=i[t+124>>2],!A||(e=i[A+4>>2],i[A+4>>2]=e-1,e))break e;W[i[i[A>>2]+8>>2]](A),y(A)}if(A=l[t+24|0],(A|0)==255)break i;e=i[24209],i[t+120>>2]=i[24208],i[t+124>>2]=e,W[i[(t+120|0)+(A<<2)>>2]](t+119|0,t+4|0)}v=t+128|0}function pm(A,e,r,f,k,n,t,o,s){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,t=t|0,o=o|0,s=s|0;var w=0,h=0;w=v+-64|0,v=w,h=i[r>>2],r=i[r+4>>2],r&&(i[r+4>>2]=i[r+4>>2]+1),i[w+60>>2]=r,i[w+56>>2]=h;i:{e:{r:{if(!l[e+4|0]){if(W[i[i[f>>2]+120>>2]](w+24|0,i[f+4>>2],w+56|0,n,t,o,k),k=i[w+24>>2],k){if(f=i[w+28>>2],n=i[w+32>>2],r=h2(n),r>>>0>=2147483640)break e;f:{A:{if(r>>>0>=11){t=r|7,e=p(t+1|0),i[w+52>>2]=t-2147483647,i[w+44>>2]=e,i[w+48>>2]=r;break A}if(u[w+55|0]=r,e=w+44|0,!r)break f}if(!r)break f;x(e,n,r)}if(u[e+r|0]=0,q(A,k,f,w+44|0),u[w+55|0]>=0)break r;Z(i[w+44>>2]);break r}r=p(168),i[r+4>>2]=0,i[r+8>>2]=0,i[r>>2]=92284,k=r+16|0,i[k+8>>2]=0,i[k+12>>2]=0,i[r+32>>2]=0,i[r+36>>2]=0,i[r+40>>2]=0,i[r+44>>2]=0,i[r+48>>2]=0,i[r+16>>2]=86356,i[r+60>>2]=0,i[r+64>>2]=0,i[r+52>>2]=0,i[r+56>>2]=0,i[r+72>>2]=-1,i[r+76>>2]=-1,i[r+80>>2]=-1,i[r+84>>2]=-1,i[r+88>>2]=0,i[r+92>>2]=0,i[r+96>>2]=0,i[r+100>>2]=0,i[r+104>>2]=0,i[r+108>>2]=0,u[r+112|0]=0,i[r+16>>2]=100112,u[r+120|0]=0,i[r+116>>2]=0,i[r+132>>2]=0,i[r+136>>2]=0,g[r+128>>1]=2056,i[r+124>>2]=1,i[r+140>>2]=0,i[r+144>>2]=0,i[r+148>>2]=0,i[r+152>>2]=0,i[r+156>>2]=0,i[r+160>>2]=0,i[r+164>>2]=0,i[r+32>>2]=1635148611,i[e+8>>2]=k,k=i[e+12>>2],i[e+12>>2]=r;f:{if(!k||(r=i[k+4>>2],i[k+4>>2]=r-1,r))break f;W[i[i[k>>2]+8>>2]](k),y(k)}u[e+4|0]=1}if(Rf(w+24|0,e,f),i[w+24>>2]){e=i[w+28>>2],i[A>>2]=i[w+24>>2],i[A+4>>2]=e,e=i[w+36>>2],i[A+8>>2]=i[w+32>>2],i[A+12>>2]=e,i[A+16>>2]=i[w+40>>2];break r}W[i[i[f>>2]+124>>2]](w+44|0,i[f+4>>2],w+56|0,s),k=i[w+44>>2];f:{if(k){if(f=i[w+48>>2],n=i[w+52>>2],r=h2(n),r>>>0>=2147483640)break i;A:{k:{if(r>>>0>=11){t=r|7,e=p(t+1|0),i[w+20>>2]=t-2147483647,i[w+12>>2]=e,i[w+16>>2]=r;break k}if(u[w+23|0]=r,e=w+12|0,!r)break A}if(!r)break A;x(e,n,r)}if(u[e+r|0]=0,q(A,k,f,w+12|0),u[w+23|0]>=0)break f;Z(i[w+12>>2]);break f}Rf(A,e,f)}if(u[w+43|0]>=0)break r;Z(i[w+32>>2])}A=i[w+60>>2];r:{if(!A||(e=i[A+4>>2],i[A+4>>2]=e-1,e))break r;W[i[i[A>>2]+8>>2]](A),y(A)}v=w- -64|0;return}Q0(),H()}Q0(),H()}function ym(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0;var k=0,n=0,t=0,o=0,s=0;k=v-192|0,v=k,z2(k+172|0,e,r),u[k+191|0]<0&&Z(i[k+180>>2]);i:{if(l[e+97|0]){t1(A,e,15556);break i}o=C0(r);e:{r:{f:{A:{k:{if(n=i[f+72>>2],!(n>>>0<o>>>0&&n)){if(o)for(t=e+104|0,n=0;;){if(i[k+24>>2]=0,i[k+28>>2]=0,e=k+24|0,V6(A,r,e,f),i[A>>2])break k;r2(t,e),u[A+19|0]<0&&Z(i[A+8>>2]),e=i[k+28>>2];n:{if(!e||(s=i[e+4>>2],i[e+4>>2]=s-1,s))break n;W[i[i[e>>2]+8>>2]](e),y(e)}if(n=n+1|0,(o|0)==(n|0))break}if(l[r+20|0]!=1)break A;if(u[k+24|0]=0,u[k+35|0]=0,q(A,2,100,k+24|0),u[k+35|0]>=0)break i;Z(i[k+24>>2]);break i}i[k+116>>2]=0,i[k+88>>2]=72196,i[k+32>>2]=72176,e=i[18053],i[k+24>>2]=e,r=i[e-12>>2],e=k+24|0,i[r+e>>2]=i[18054],i[k+28>>2]=0,r=e+i[i[k+24>>2]-12>>2]|0,n=k+36|0,J0(r,n),u[r+80|0]=0,i[r+72>>2]=0,r=i[18055],i[k+32>>2]=r,t=i[r-12>>2],r=k+32|0,i[t+r>>2]=i[18056],t=i[18052],i[k+24>>2]=t,i[e+i[t-12>>2]>>2]=i[18057],i[k+88>>2]=72196,i[k+24>>2]=72156,i[k+32>>2]=72176,t=R0(n),i[t>>2]=71232,i[k+76>>2]=0,i[k+80>>2]=0,i[k+68>>2]=0,i[k+72>>2]=0,i[k+84>>2]=24,Y(V0(Y(q2(Y(r,28376,11),o,0),28451,56),i[f+72>>2]),5081,6),e=i[k+84>>2];n:{if(e&16){n=k+56|0,r=i[k+80>>2],e=i[k+60>>2],r>>>0<e>>>0?i[k+80>>2]=e:e=r;break n}if(!(e&8)){e=0,u[k+23|0]=0,n=k+12|0;break e}n=k+44|0,e=i[k+52>>2]}if(r=i[n>>2],e=e-r|0,e>>>0>=2147483640)break f;if(e>>>0>=11){f=e|7,n=p(f+1|0),i[k+20>>2]=f-2147483647,i[k+12>>2]=n,i[k+16>>2]=e;break r}if(u[k+23|0]=e,n=k+12|0,e)break r;e=0;break e}if(A=i[k+28>>2],!A||(e=i[A+4>>2],i[A+4>>2]=e-1,e))break i;W[i[i[A>>2]+8>>2]](A),y(A);break i}if(e=i[26917],i[A>>2]=i[26916],i[A+4>>2]=e,A=A+8|0,u[107683]>=0){e=i[26919],i[A>>2]=i[26918],i[A+4>>2]=e,i[A+8>>2]=i[26920];break i}T(A,i[26918],i[26919]);break i}Q0(),H()}if(!e)break e;x(n,r,e)}u[e+n|0]=0,q(A,6,1e3,k+12|0),u[k+23|0]<0&&Z(i[k+12>>2]),A=i[18051],i[k+24>>2]=A,i[i[A-12>>2]+(k+24|0)>>2]=i[18059],i[k+32>>2]=i[18060],i[t>>2]=71232,u[k+79|0]<0&&Z(i[k+68>>2]),E0(t),y0(k+88|0)}v=k+192|0}function _r(A,e,r,f){var k=0,n=0,t=0,o=0,s=0,w=0,h=0,_=0,B=0,m=0,X=0,Q=0,V=0,F=0,I=0;w=v-2048|0,v=w;i:{e:{if((r|0)>=2){for(n=r;k=h,h=k+1|0,t=n>>>0>3,n=n>>>1|0,!!t;);h=4-k|0;break e}if(h=5,(r|0)!=1)break i}for(V=r&-4,X=r&3,Q=r-1|0;;){s=(o<<1)+f|0,n=0,t=r;e:{for(;;){if(B=n,k=t,(k|0)<=0){if(t=0,n=0,k=0,Q>>>0>=3)for(;g[(G(r,n)+o<<1)+w>>1]=0,g[(G(n|1,r)+o<<1)+w>>1]=0,g[(G(n|2,r)+o<<1)+w>>1]=0,g[(G(n|3,r)+o<<1)+w>>1]=0,n=n+4|0,k=k+4|0,(V|0)!=(k|0););if(!X)break e;for(;g[(G(r,n)+o<<1)+w>>1]=0,n=n+1|0,t=t+1|0,(X|0)!=(t|0););break e}if(n=B+1|0,t=k-1|0,!!C[s+(G(t,r)<<1)>>1])break}for(F=k&2147483646,I=k&1,t=0;;){if(n=0,k=0,_=0,(B|0)!=(Q|0))for(;m=G(g[s+(G(r,n)<<1)>>1],u[((n<<h<<5)+t|0)+61744|0])+k|0,k=n|1,k=m+G(g[s+(G(k,r)<<1)>>1],u[((k<<h<<5)+t|0)+61744|0])|0,n=n+2|0,_=_+2|0,(F|0)!=(_|0););if(_=(G(r,t)+o<<1)+w|0,I&&(k=G(g[s+(G(r,n)<<1)>>1],u[((n<<h<<5)+t|0)+61744|0])+k|0),k=k- -64>>7,k=(k|0)>=32767?32767:k,g[_>>1]=(k|0)<=-32768?-32768:k,t=t+1|0,(t|0)==(r|0))break}}if(o=o+1|0,(o|0)==(r|0))break}for(X=r&-2,_=r&1,o=0;;){s=G(r,o),n=s-1|0,t=0,k=r;e:{r:{for(;;){if(B=t,f=k,(k|0)<=0)break r;if(t=t+1|0,k=k-1|0,!!C[(f+n<<1)+w>>1])break}for(V=f&2147483646,F=f&1,I=G(e,o)+A|0,t=0;;){if(n=0,k=0,f=0,(B|0)!=(Q|0))for(;m=G(g[(n+s<<1)+w>>1],u[((n<<h<<5)+t|0)+61744|0])+k|0,k=n|1,k=m+G(g[(k+s<<1)+w>>1],u[((k<<h<<5)+t|0)+61744|0])|0,n=n+2|0,f=f+2|0,(V|0)!=(f|0););if(f=t+I|0,m=l[f|0],F&&(k=G(g[(n+s<<1)+w>>1],u[((n<<h<<5)+t|0)+61744|0])+k|0),n=f,f=(k+2048>>12)+m|0,u[n|0]=(f|0)>=0?(f|0)>=255?255:f:0,t=t+1|0,(t|0)==(r|0))break}break e}f=G(e,o)+A|0;r:{if(!Q){n=0;break r}for(B=f+1|0,n=0,k=0;s=f+n|0,t=l[s|0],u[s|0]=t>>>0>=255?255:t,s=n+B|0,t=l[s|0],u[s|0]=t>>>0>=255?255:t,n=n+2|0,k=k+2|0,(X|0)!=(k|0););}if(!_)break e;k=f+n|0,f=l[k|0],u[k|0]=f>>>0>=255?255:f}if(o=o+1|0,(o|0)==(r|0))break}}v=w+2048|0}function Em(A,e,r,f,k,n){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0;var t=0,o=0,s=0,w=0;n=v-16|0,v=n,t=i[r+4>>2],o=i[k>>2],s=i[r>>2],r=o+s|0;i:{if(t-r>>>0<(f|0)/8<<1>>>0){if(e=p(48),i[n+4>>2]=e,i[n+8>>2]=44,i[n+12>>2]=-2147483600,r=l[8836]|l[8837]<<8|(l[8838]<<16|l[8839]<<24),f=l[8832]|l[8833]<<8|(l[8834]<<16|l[8835]<<24),u[e|0]=f,u[e+1|0]=f>>>8,u[e+2|0]=f>>>16,u[e+3|0]=f>>>24,u[e+4|0]=r,u[e+5|0]=r>>>8,u[e+6|0]=r>>>16,u[e+7|0]=r>>>24,u[e+44|0]=0,r=l[8872]|l[8873]<<8|(l[8874]<<16|l[8875]<<24),u[e+40|0]=r,u[e+41|0]=r>>>8,u[e+42|0]=r>>>16,u[e+43|0]=r>>>24,r=l[8868]|l[8869]<<8|(l[8870]<<16|l[8871]<<24),f=l[8864]|l[8865]<<8|(l[8866]<<16|l[8867]<<24),u[e+32|0]=f,u[e+33|0]=f>>>8,u[e+34|0]=f>>>16,u[e+35|0]=f>>>24,u[e+36|0]=r,u[e+37|0]=r>>>8,u[e+38|0]=r>>>16,u[e+39|0]=r>>>24,r=l[8860]|l[8861]<<8|(l[8862]<<16|l[8863]<<24),f=l[8856]|l[8857]<<8|(l[8858]<<16|l[8859]<<24),u[e+24|0]=f,u[e+25|0]=f>>>8,u[e+26|0]=f>>>16,u[e+27|0]=f>>>24,u[e+28|0]=r,u[e+29|0]=r>>>8,u[e+30|0]=r>>>16,u[e+31|0]=r>>>24,r=l[8852]|l[8853]<<8|(l[8854]<<16|l[8855]<<24),f=l[8848]|l[8849]<<8|(l[8850]<<16|l[8851]<<24),u[e+16|0]=f,u[e+17|0]=f>>>8,u[e+18|0]=f>>>16,u[e+19|0]=f>>>24,u[e+20|0]=r,u[e+21|0]=r>>>8,u[e+22|0]=r>>>16,u[e+23|0]=r>>>24,r=l[8844]|l[8845]<<8|(l[8846]<<16|l[8847]<<24),f=l[8840]|l[8841]<<8|(l[8842]<<16|l[8843]<<24),u[e+8|0]=f,u[e+9|0]=f>>>8,u[e+10|0]=f>>>16,u[e+11|0]=f>>>24,u[e+12|0]=r,u[e+13|0]=r>>>8,u[e+14|0]=r>>>16,u[e+15|0]=r>>>24,q(A,2,136,n+4|0),u[n+15|0]>=0)break i;Z(i[n+4>>2]);break i}t=l[r|0],w=l[r+1|0];e:{if((f|0)==32){f=l[r+3|0],r=l[r+2|0],i[k>>2]=o+4,i[e+4>>2]=f|(w<<16|t<<24|r<<8),f=i[k>>2],r=f+s|0,r=l[r|0]|l[r+1|0]<<8|(l[r+2|0]<<16|l[r+3|0]<<24),r=r<<24|(r&65280)<<8|(r>>>8&65280|r>>>24),f=f+4|0;break e}i[k>>2]=o+2,i[e+4>>2]=(w<<16|t<<24)>>16,f=i[k>>2],r=f+s|0,r=(l[r+1|0]<<16|l[r|0]<<24)>>16,f=f+2|0}if(i[k>>2]=f,i[e+8>>2]=r,e=i[26917],i[A>>2]=i[26916],i[A+4>>2]=e,A=A+8|0,u[107683]>=0){e=i[26919],i[A>>2]=i[26918],i[A+4>>2]=e,i[A+8>>2]=i[26920];break i}T(A,i[26918],i[26919])}v=n+16|0}function Ym(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0;var k=0,n=0,t=0,o=0,s=0,w=0,h=0,_=0;n=v-16|0,v=n,o=C0(r),s=C0(r),w=C0(r),_=C0(r),k=C0(r),f=C0(r),h=C0(r),t=C0(r);i:{if((t|(o|s|w|_|f))<0){if(e=p(32),i[n>>2]=e,i[n+4>>2]=31,i[n+8>>2]=-2147483616,r=l[25286]|l[25287]<<8|(l[25288]<<16|l[25289]<<24),f=l[25282]|l[25283]<<8|(l[25284]<<16|l[25285]<<24),u[e|0]=f,u[e+1|0]=f>>>8,u[e+2|0]=f>>>16,u[e+3|0]=f>>>24,u[e+4|0]=r,u[e+5|0]=r>>>8,u[e+6|0]=r>>>16,u[e+7|0]=r>>>24,u[e+31|0]=0,r=l[25309]|l[25310]<<8|(l[25311]<<16|l[25312]<<24),f=l[25305]|l[25306]<<8|(l[25307]<<16|l[25308]<<24),u[e+23|0]=f,u[e+24|0]=f>>>8,u[e+25|0]=f>>>16,u[e+26|0]=f>>>24,u[e+27|0]=r,u[e+28|0]=r>>>8,u[e+29|0]=r>>>16,u[e+30|0]=r>>>24,r=l[25302]|l[25303]<<8|(l[25304]<<16|l[25305]<<24),f=l[25298]|l[25299]<<8|(l[25300]<<16|l[25301]<<24),u[e+16|0]=f,u[e+17|0]=f>>>8,u[e+18|0]=f>>>16,u[e+19|0]=f>>>24,u[e+20|0]=r,u[e+21|0]=r>>>8,u[e+22|0]=r>>>16,u[e+23|0]=r>>>24,r=l[25294]|l[25295]<<8|(l[25296]<<16|l[25297]<<24),f=l[25290]|l[25291]<<8|(l[25292]<<16|l[25293]<<24),u[e+8|0]=f,u[e+9|0]=f>>>8,u[e+10|0]=f>>>16,u[e+11|0]=f>>>24,u[e+12|0]=r,u[e+13|0]=r>>>8,u[e+14|0]=r>>>16,u[e+15|0]=r>>>24,q(A,2,128,n),u[n+11|0]>=0)break i;Z(i[n>>2]);break i}if(s=ko(n,o,s),o=i[s>>2],s=i[s+4>>2],i[e+100>>2]=o,i[e+104>>2]=s,w=ko(n,w,_),o=i[w>>2],w=i[w+4>>2],i[e+108>>2]=o,i[e+112>>2]=w,f-65537>>>0<4294836223)for(;k=(k|0)/2|0,f=(f|0)/2|0,f-65537>>>0<4294836223;);e:{if((f|0)<=1)break e;for(;;){if(k-65537>>>0>4294836222)break e;if(k=(k|0)/2|0,o=f>>>0>3,f=f>>>1|0,!o)break}}if(i[e+116>>2]=k,i[e+120>>2]=f,t-65537>>>0<4294836223)for(;h=(h|0)/2|0,t=(t|0)/2|0,t-65537>>>0<4294836223;);e:{if((t|0)<=1){k=t;break e}for(;;){if(h-65537>>>0>4294836222){k=t;break e}if(h=(h|0)/2|0,o=t>>>0>3,k=t>>>1|0,t=k,!o)break}}i[e+124>>2]=h,i[e+128>>2]=k;e:{if(!(!f|(!s|!w))&&k)break e;if(e=A,A=d2(n,42673),q(e,2,128,A),u[A+11|0]>=0)break i;Z(i[A>>2]);break i}du(A,r)}v=n+16|0}function Rm(A){A=A|0;var e=0,r=0,f=0,k=0;r=A+12|0,A=i[r+152>>2];i:{if(!A||(e=i[A+4>>2],i[A+4>>2]=e-1,e))break i;W[i[i[A>>2]+8>>2]](A),y(A)}A=i[r+144>>2];i:{if(!A||(e=i[A+4>>2],i[A+4>>2]=e-1,e))break i;W[i[i[A>>2]+8>>2]](A),y(A)}A=i[r+136>>2],i[r+136>>2]=0,A&&W[i[i[A>>2]+4>>2]](A),n3(r+124|0,i[r+128>>2]),A=i[r+120>>2];i:{if(!A||(e=i[A+4>>2],i[A+4>>2]=e-1,e))break i;W[i[i[A>>2]+8>>2]](A),y(A)}A=i[r+112>>2];i:{if(!A||(e=i[A+4>>2],i[A+4>>2]=e-1,e))break i;W[i[i[A>>2]+8>>2]](A),y(A)}A=i[r+104>>2];i:{if(!A||(e=i[A+4>>2],i[A+4>>2]=e-1,e))break i;W[i[i[A>>2]+8>>2]](A),y(A)}A=i[r+96>>2];i:{if(!A||(e=i[A+4>>2],i[A+4>>2]=e-1,e))break i;W[i[i[A>>2]+8>>2]](A),y(A)}A=i[r+88>>2];i:{if(!A||(e=i[A+4>>2],i[A+4>>2]=e-1,e))break i;W[i[i[A>>2]+8>>2]](A),y(A)}A=i[r+80>>2];i:{if(!A||(e=i[A+4>>2],i[A+4>>2]=e-1,e))break i;W[i[i[A>>2]+8>>2]](A),y(A)}A=i[r+72>>2];i:{if(!A||(e=i[A+4>>2],i[A+4>>2]=e-1,e))break i;W[i[i[A>>2]+8>>2]](A),y(A)}A=i[r+64>>2];i:{if(!A||(e=i[A+4>>2],i[A+4>>2]=e-1,e))break i;W[i[i[A>>2]+8>>2]](A),y(A)}A=i[r+56>>2];i:{if(!A||(e=i[A+4>>2],i[A+4>>2]=e-1,e))break i;W[i[i[A>>2]+8>>2]](A),y(A)}A=i[r+48>>2];i:{if(!A||(e=i[A+4>>2],i[A+4>>2]=e-1,e))break i;W[i[i[A>>2]+8>>2]](A),y(A)}A=i[r+40>>2];i:{if(!A||(e=i[A+4>>2],i[A+4>>2]=e-1,e))break i;W[i[i[A>>2]+8>>2]](A),y(A)}A=i[r+32>>2];i:{if(!A||(e=i[A+4>>2],i[A+4>>2]=e-1,e))break i;W[i[i[A>>2]+8>>2]](A),y(A)}if(A=i[r+16>>2],A){if(e=A,f=i[r+20>>2],(A|0)!=(f|0)){for(;;){e=i[f-4>>2];i:{if(!e||(k=i[e+4>>2],i[e+4>>2]=k-1,k))break i;W[i[i[e>>2]+8>>2]](e),y(e)}if(f=f-8|0,(A|0)==(f|0))break}e=i[r+16>>2]}i[r+20>>2]=A,Z(e)}A=i[r+12>>2];i:{if(!A||(e=i[A+4>>2],i[A+4>>2]=e-1,e))break i;W[i[i[A>>2]+8>>2]](A),y(A)}A=i[r+4>>2];i:{if(!A||(e=i[A+4>>2],i[A+4>>2]=e-1,e))break i;W[i[i[A>>2]+8>>2]](A),y(A)}}function M9(A,e,r){var f=0,k=0,n=0,t=0,o=0,s=0,w=0;if(o=v-16|0,v=o,f=i[A+244>>2],!f){f=p(128),i[f+4>>2]=0,i[f+8>>2]=0,i[f>>2]=94164,n=f+16|0,k=n,i[k+8>>2]=0,i[k+12>>2]=0,i[f+32>>2]=0,i[f+36>>2]=0,i[f+40>>2]=0,i[f+44>>2]=0,i[f+48>>2]=0,i[f+16>>2]=86356,i[f+60>>2]=0,i[f+64>>2]=0,i[f+52>>2]=0,i[f+56>>2]=0,i[f+72>>2]=-1,i[f+76>>2]=-1,i[f+80>>2]=-1,i[f+84>>2]=-1,i[f+88>>2]=0,i[f+92>>2]=0,i[f+96>>2]=0,i[f+100>>2]=0,i[f+104>>2]=0,i[f+108>>2]=0,u[f+112|0]=0,i[f+16>>2]=106268,i[f+124>>2]=0,i[f+116>>2]=0,i[f+120>>2]=0,i[f+32>>2]=1953654118,i[A+244>>2]=k,k=i[A+248>>2],i[A+248>>2]=f;i:{e:{if(!k){k=i[A+132>>2],i[o+12>>2]=f,i[o+8>>2]=n;break e}if(f=i[k+4>>2],i[k+4>>2]=f-1,f||(W[i[i[k>>2]+8>>2]](k),y(k)),k=i[A+132>>2],n=i[A+244>>2],f=i[A+248>>2],i[o+12>>2]=f,i[o+8>>2]=n,!f)break i}i[f+4>>2]=i[f+4>>2]+1}r2(k+36|0,o+8|0),f=i[o+12>>2];i:{if(!f||(k=i[f+4>>2],i[f+4>>2]=k-1,k))break i;W[i[i[f>>2]+8>>2]](f),y(f)}f=i[A+244>>2]}k=v-32|0,v=k;i:{e:{r:{f:{n=i[f+100>>2],A=i[f+104>>2];A:{if((n|0)!=(A|0))for(;;){if(i[n>>2]==(e|0)){if(A=i[n+8>>2],t=i[n+12>>2],A>>>0<t>>>0){i[A>>2]=r,i[n+8>>2]=A+4;break A}if(f=i[n+4>>2],A=A-f|0,w=A>>2,e=w+1|0,e>>>0>=1073741824)break f;if(t=t-f|0,s=t>>1,t=t>>>0>=2147483644?1073741823:e>>>0<s>>>0?s:e,t){if(t>>>0>=1073741824)break r;e=p(t<<2)}else e=0;s=e+A|0,i[s>>2]=r,r=s-(w<<2)|0,A&&x(r,f,A),i[n+12>>2]=e+(t<<2),A=s+4|0,i[n+8>>2]=A,i[n+4>>2]=r,f&&Z(f),i[n+8>>2]=A;break A}if(n=n+16|0,(A|0)==(n|0))break}i[k+28>>2]=0,i[k+20>>2]=0,i[k+24>>2]=0,i[k+16>>2]=e,i[k+12>>2]=r,k6(k+20|0,k+12|0,k+16|0,1),A=i[f+104>>2];k:{if(A>>>0<u0[f+108>>2]){if(e=i[k+16>>2],i[A+12>>2]=0,i[A+4>>2]=0,i[A+8>>2]=0,i[A>>2]=e,e=i[k+24>>2],n=i[k+20>>2],(e|0)!=(n|0)){if(e=e-n|0,(e|0)<0)break e;r=p(e),i[A+8>>2]=r,i[A+4>>2]=r,t=e+r|0,i[A+12>>2]=t,e&&x(r,n,e),i[A+8>>2]=t}A=A+16|0;break k}A=Yr(f+100|0,k+16|0)}if(i[f+104>>2]=A,A=i[k+20>>2],!A)break A;i[k+24>>2]=A,Z(A)}v=k+32|0;break i}G0(),H()}z0(),H()}G0(),H()}v=o+16|0}function Br(A,e,r){var f=0,k=0,n=0,t=0;f=v-96|0,v=f,k=f- -64|0;i:{e:{r:{f:{A:{k:{n:{t:{u:{if(r){W[i[i[e>>2]+24>>2]](f+56|0,e);o:{l:switch(l[f+76|0]){case 1:e=i[f+60>>2],i[A>>2]=i[f+56>>2],i[A+4>>2]=e,e=A+8|0;s:{if(u[f+75|0]>=0){r=i[k+4>>2],i[e>>2]=i[k>>2],i[e+4>>2]=r,i[e+8>>2]=i[k+8>>2];break s}T(e,i[f+64>>2],i[f+68>>2])}u[A+20|0]=1;break o;case 0:break l;default:break u}if(i[f+52>>2]=0,i[f+44>>2]=0,i[f+48>>2]=0,r=i[f+60>>2],k=i[f+56>>2],(r|0)!=(k|0)){if(r=r-k|0,(r|0)<0)break A;n=p(r),i[f+44>>2]=n,t=r+n|0,i[f+52>>2]=t,r&&x(n,k,r),i[f+48>>2]=t}rA(f+16|0,e+8|0);l:{s:{w:switch(r=l[f+36|0],r|0){case 0:break s;case 1:break w;default:break u}if(e=i[f+20>>2],i[A>>2]=i[f+16>>2],i[A+4>>2]=e,e=A+8|0,u[f+35|0]>=0){k=i[f+28>>2],i[e>>2]=i[f+24>>2],i[e+4>>2]=k,i[e+8>>2]=i[f+32>>2];break l}T(e,i[f+24>>2],i[f+28>>2]);break l}e=i[f+16>>2],k=i[e>>2],e=i[e+4>>2],$4(f+44|0,i[f+48>>2],k,e,e-k|0),e=i[f+52>>2],i[f+52>>2]=0,k=i[f+44>>2],n=i[f+48>>2],i[f+44>>2]=0,i[f+48>>2]=0,i[A+8>>2]=e,i[A>>2]=k,i[A+4>>2]=n}if(u[A+20|0]=r,A=l[f+36|0],(A|0)!=255&&(e=i[24259],i[f+88>>2]=i[24258],i[f+92>>2]=e,W[i[(f+88|0)+(A<<2)>>2]](f+87|0,f+16|0)),A=i[f+44>>2],!A)break o;i[f+48>>2]=A,Z(A)}if(A=l[f+76|0],(A|0)==255)break i;e=i[24261],i[f+16>>2]=i[24260],i[f+20>>2]=e,W[i[(f+16|0)+(A<<2)>>2]](f+44|0,f+56|0);break i}switch(rA(f+56|0,e+8|0),e=l[f+76|0],e|0){case 0:break n;case 1:break t;default:break u}}_2(),H()}if(r=i[f+60>>2],i[A>>2]=i[f+56>>2],i[A+4>>2]=r,r=A+8|0,u[f+75|0]<0)break r;n=i[k+4>>2],i[r>>2]=i[k>>2],i[r+4>>2]=n,i[r+8>>2]=i[k+8>>2];break k}if(r=0,i[f+12>>2]=0,i[f+4>>2]=0,i[f+8>>2]=0,k=0,n=i[f+56>>2],t=i[n+4>>2],n=i[n>>2],(t|0)!=(n|0)){if(r=t-n|0,(r|0)<0)break f;k=p(r),r&&x(k,n,r),r=r+k|0}i[A+8>>2]=r,i[A+4>>2]=r,i[A>>2]=k}u[A+20|0]=e;break e}G0(),H()}G0(),H()}if(T(r,i[f+64>>2],i[f+68>>2]),e=l[f+76|0],u[A+20|0]=1,(e|0)==255)break i}A=i[24259],i[f+16>>2]=i[24258],i[f+20>>2]=A,W[i[(f+16|0)+(e<<2)>>2]](f+44|0,f+56|0)}v=f+96|0}function H9(A,e,r,f,k,n,t,o,s,w,h,_,B){var m=0,X=0,Q=0,V=0,F=0,I=0,E=0,R=0,N=0,M=0,z=0,S=0,O=0,P=0,a=0,$=0;m=v,z=m,m=m-19808&-32,v=m,Q=i[e+16852>>2],V=G(2/(Q|0)|0,r),r=((k|0)/(Q|0)|0)+(V>>3)|0,k=f,f=i[e+16856>>2],X=G(k,2/(f|0)|0),n=((n|0)/(f|0)|0)+(X>>3)|0,I=i[e+488>>2]/(f|0)|0,k=i[e+484>>2]/(Q|0)|0;i:{if(Q=V&7,f=X&7,!(Q|f)){if(e=i[e+16840>>2],!((r|0)<0|(k|0)<(r+h|0)|((n|0)<0|(I|0)<(n+_|0)))){if(e=((r<<1)+s|0)+(G(n,w)<<1)|0,(B|0)<=8){W[i[A+204>>2]](t,o,e,w,h,_,0,0,0);break i}W[i[A+284>>2]](t,o,e,w,h,_,0,0,0,B);break i}if((_|0)<=0|(h|0)<=0)break i;for(B=14-e|0,E=I-1|0,m=k-1|0,R=h&2147483646,N=h&1,A=0;;){if(e=A+n|0,Q=(G((e|0)>=0?(e|0)<(I|0)?e:E:0,w)<<1)+s|0,V=(G(A,o)<<1)+t|0,e=0,f=0,(h|0)!=1)for(;X=e+r|0,g[V+(e<<1)>>1]=C[Q+(((X|0)>=0?(k|0)>(X|0)?X:m:0)<<1)>>1]<<B,F=e|1,X=F+r|0,g[V+(F<<1)>>1]=C[Q+(((X|0)>=0?(k|0)>(X|0)?X:m:0)<<1)>>1]<<B,e=e+2|0,f=f+2|0,(R|0)!=(f|0););if(N&&(f=V+(e<<1)|0,e=e+r|0,g[f>>1]=C[Q+(((e|0)>=0?(e|0)<(k|0)?e:m:0)<<1)>>1]<<B),A=A+1|0,(_|0)==(A|0))break}break i}e:{if(!((r|0)<=0|(r+h|0)>(k-2|0)|((n|0)<=0|(n+_|0)>(I-2|0)))){e=((r<<1)+s|0)+(G(n,w)<<1)|0;break e}if(!((_|0)<-2|(h|0)<-2))for(V=-1,S=I-1|0,X=k-1|0,e=_+2|0,O=(e|0)>0?e:0,P=r+1|0,e=h+3|0,a=e&-2,$=e&1;;){if(e=n+V|0,E=(G((e|0)>=0?(e|0)<(I|0)?e:S:0,w)<<1)+s|0,R=G(V,80)+81|0,e=-1,(h|0)!=-2)for(M=R+1|0,N=0;F=e+r|0,g[m+(e+R<<1)>>1]=C[E+(((F|0)>=0?(k|0)>(F|0)?F:X:0)<<1)>>1],F=e+P|0,g[m+(e+M<<1)>>1]=C[E+(((F|0)>=0?(k|0)>(F|0)?F:X:0)<<1)>>1],e=e+2|0,N=N+2|0,(a|0)!=(N|0););if($&&(M=m+(e+R<<1)|0,e=e+r|0,g[M>>1]=C[E+(((e|0)>=0?(e|0)<(k|0)?e:X:0)<<1)>>1]),V=V+1|0,(O|0)==(V|0))break}w=80,e=m+162|0}if(!(!Q|!f)){W[i[(((B|0)<9?44:124)+A|0)+172>>2]](t,o,e,w,h,_,Q,f,m+10720|0,B);break i}if(Q){W[i[(((B|0)<9?36:116)+A|0)+172>>2]](t,o,e,w,h,_,Q,f,m+10720|0,B);break i}if(f){W[i[(((B|0)<9?40:120)+A|0)+172>>2]](t,o,e,w,h,_,0,f,m+10720|0,B);break i}D0(12200,18225,269,18969),H()}v=z}function Jm(A,e,r,f,k){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0;var n=0,t=0,o=0,s=0,w=0;o=v-32|0,v=o;i:{if(!(f&&e)){e=i[23570],i[A>>2]=i[23569],i[A+4>>2]=e,i[A+8>>2]=i[23571];break i}n=i[e>>2],t=i[n+48>>2],s=i[n+52>>2],s&&(i[s+4>>2]=i[s+4>>2]+1);e:{if(!e3(t,r)){i[A>>2]=1,i[A+4>>2]=2006,i[A+8>>2]=3550;break e}r4(o+24|0,i[e>>2],r,0),t=i[o+24>>2];r:{if(!t||(n=i[t+104>>2],t=i[t+108>>2],(n|0)==(t|0)))break r;for(;;){f:{if(w=i[n>>2],!w||!W0(w,86580,86624))break f;e=i[n+4>>2];A:{if(!e){i[A>>2]=5,i[A+4>>2]=2006,i[A+8>>2]=1404;break A}if(i[e+4>>2]=i[e+4>>2]+1,i[A+8>>2]=1404,i[A>>2]=5,i[A+4>>2]=2006,A=i[e+4>>2],i[e+4>>2]=A-1,A)break A;W[i[i[e>>2]+8>>2]](e),y(e)}if(A=i[o+28>>2],!A||(e=i[A+4>>2],i[A+4>>2]=e-1,e))break e;W[i[i[A>>2]+8>>2]](A),y(A);break e}if(n=n+8|0,(t|0)==(n|0))break}}n=i[o+28>>2];r:{if(!n||(t=i[n+4>>2],i[n+4>>2]=t-1,t))break r;W[i[i[n>>2]+8>>2]](n),y(n)}if(n=p(152),i[n+4>>2]=0,i[n+8>>2]=0,i[n>>2]=92244,t=n+16|0,i[t+8>>2]=0,i[t+12>>2]=0,i[t+16>>2]=0,i[t+20>>2]=0,i[t+24>>2]=0,i[t+28>>2]=0,i[t+32>>2]=0,i[t>>2]=86356,i[n+60>>2]=0,i[n+64>>2]=0,i[n+52>>2]=0,i[n+56>>2]=0,i[n+72>>2]=-1,i[n+76>>2]=-1,i[n+80>>2]=-1,i[n+84>>2]=-1,i[n+116>>2]=0,i[n+88>>2]=0,i[n+92>>2]=0,i[n+96>>2]=0,i[n+100>>2]=0,i[n+104>>2]=0,i[n+108>>2]=0,g[n+112>>1]=0,i[t>>2]=89376,u[n+144|0]=0,i[n+136>>2]=0,i[n+140>>2]=2147483647,i[n+128>>2]=-1,i[n+132>>2]=-1,u[n+120|0]=1,i[n+32>>2]=1952541027,l[f|0]&&(w=i[f+12>>2],i[n+128>>2]=i[f+8>>2],i[n+132>>2]=w,i[n+136>>2]=i[f+16>>2],i[n+140>>2]=i[f+20>>2],u[n+144|0]=l[f+24|0]),e=i[e>>2],i[o+20>>2]=n,i[o+16>>2]=t,i[n+4>>2]=i[n+4>>2]+1,f=i[o+20>>2],i[o+8>>2]=i[o+16>>2],i[o+12>>2]=f,e=re(e,r,o+8|0,0),k&&(i[k>>2]=e),e=i[24057],i[A>>2]=i[24056],i[A+4>>2]=e,i[A+8>>2]=i[24058],A=i[n+4>>2],i[n+4>>2]=A-1,A)break e;W[i[i[n>>2]+8>>2]](n),y(n)}if(!s||(A=i[s+4>>2],i[s+4>>2]=A-1,A))break i;W[i[i[s>>2]+8>>2]](s),y(s)}v=o+32|0}function Nm(A,e,r,f,k,n,t,o,s){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,t=t|0,o=o|0,s=s|0;var w=0,h=0;w=v+-64|0,v=w,h=i[r>>2],r=i[r+4>>2],r&&(i[r+4>>2]=i[r+4>>2]+1),i[w+60>>2]=r,i[w+56>>2]=h;i:{e:{r:{if(!l[e+4|0]){if(W[i[i[f>>2]+120>>2]](w+24|0,i[f+4>>2],w+56|0,n,t,o,k),r=i[w+24>>2],r){if(k=i[w+28>>2],n=i[w+32>>2],e=h2(n),e>>>0>=2147483640)break e;f:{A:{if(e>>>0>=11){t=e|7,f=p(t+1|0),i[w+52>>2]=t-2147483647,i[w+44>>2]=f,i[w+48>>2]=e;break A}if(u[w+55|0]=e,f=w+44|0,!e)break f}if(!e)break f;x(f,n,e)}if(u[e+f|0]=0,q(A,r,k,w+44|0),u[w+55|0]>=0)break r;Z(i[w+44>>2]);break r}r=p(160),i[r+4>>2]=0,i[r+8>>2]=0,i[r>>2]=90364,k=r+16|0,i[k+8>>2]=0,i[k+12>>2]=0,i[r+32>>2]=0,i[r+36>>2]=0,i[r+40>>2]=0,i[r+44>>2]=0,i[r+48>>2]=0,i[r+16>>2]=86356,i[r+60>>2]=0,i[r+64>>2]=0,i[r+52>>2]=0,i[r+56>>2]=0,i[r+72>>2]=-1,i[r+76>>2]=-1,i[r+80>>2]=-1,i[r+84>>2]=-1,i[r+88>>2]=0,i[r+92>>2]=0,i[r+96>>2]=0,i[r+100>>2]=0,i[r+104>>2]=0,i[r+108>>2]=0,u[r+112|0]=0,i[r+16>>2]=97504,i[r+156>>2]=0,i[r+148>>2]=0,i[r+152>>2]=0,u[r+145|0]=4,i[r+124>>2]=0,i[r+128>>2]=0,i[r+32>>2]=1752589123,i[e+12>>2]=k,k=i[e+16>>2],i[e+16>>2]=r;f:{if(!k||(r=i[k+4>>2],i[k+4>>2]=r-1,r))break f;W[i[i[k>>2]+8>>2]](k),y(k)}u[e+4|0]=1}if(Yf(w+24|0,e,f),i[w+24>>2]){e=i[w+28>>2],i[A>>2]=i[w+24>>2],i[A+4>>2]=e,e=i[w+36>>2],i[A+8>>2]=i[w+32>>2],i[A+12>>2]=e,i[A+16>>2]=i[w+40>>2];break r}W[i[i[f>>2]+124>>2]](w+44|0,i[f+4>>2],w+56|0,s),r=i[w+44>>2];f:{if(r){if(k=i[w+48>>2],n=i[w+52>>2],e=h2(n),e>>>0>=2147483640)break i;A:{k:{if(e>>>0>=11){t=e|7,f=p(t+1|0),i[w+20>>2]=t-2147483647,i[w+12>>2]=f,i[w+16>>2]=e;break k}if(u[w+23|0]=e,f=w+12|0,!e)break A}if(!e)break A;x(f,n,e)}if(u[e+f|0]=0,q(A,r,k,w+12|0),u[w+23|0]>=0)break f;Z(i[w+12>>2]);break f}Yf(A,e,f)}if(u[w+43|0]>=0)break r;Z(i[w+32>>2])}A=i[w+60>>2];r:{if(!A||(e=i[A+4>>2],i[A+4>>2]=e-1,e))break r;W[i[i[A>>2]+8>>2]](A),y(A)}v=w- -64|0;return}Q0(),H()}Q0(),H()}function Um(A,e,r,f,k){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0;var n=0,t=0,o=0,s=0,w=0;o=v-32|0,v=o;i:{if(!e){e=i[23570],i[A>>2]=i[23569],i[A+4>>2]=e,i[A+8>>2]=i[23571];break i}n=i[e>>2],t=i[n+48>>2],s=i[n+52>>2],s&&(i[s+4>>2]=i[s+4>>2]+1);e:{if(!e3(t,r)){i[A>>2]=1,i[A+4>>2]=2006,i[A+8>>2]=3455;break e}r4(o+24|0,i[e>>2],r,0),t=i[o+24>>2];r:{if(!t||(n=i[t+104>>2],t=i[t+108>>2],(n|0)==(t|0)))break r;for(;;){f:{if(w=i[n>>2],!w||!W0(w,86580,86636))break f;e=i[n+4>>2];A:{if(!e){i[A>>2]=5,i[A+4>>2]=2006,i[A+8>>2]=1307;break A}if(i[e+4>>2]=i[e+4>>2]+1,i[A+8>>2]=1307,i[A>>2]=5,i[A+4>>2]=2006,A=i[e+4>>2],i[e+4>>2]=A-1,A)break A;W[i[i[e>>2]+8>>2]](e),y(e)}if(A=i[o+28>>2],!A||(e=i[A+4>>2],i[A+4>>2]=e-1,e))break e;W[i[i[A>>2]+8>>2]](A),y(A);break e}if(n=n+8|0,(t|0)==(n|0))break}}n=i[o+28>>2];r:{if(!n||(t=i[n+4>>2],i[n+4>>2]=t-1,t))break r;W[i[i[n>>2]+8>>2]](n),y(n)}if(n=p(144),i[n+4>>2]=0,i[n+8>>2]=0,i[n>>2]=92204,t=n+16|0,i[t+8>>2]=0,i[t+12>>2]=0,i[t+16>>2]=0,i[t+20>>2]=0,i[t+24>>2]=0,i[t+28>>2]=0,i[t+32>>2]=0,i[t>>2]=86356,i[n+60>>2]=0,i[n+64>>2]=0,i[n+52>>2]=0,i[n+56>>2]=0,i[n+72>>2]=-1,i[n+76>>2]=-1,i[n+80>>2]=-1,i[n+84>>2]=-1,i[n+116>>2]=0,i[n+88>>2]=0,i[n+92>>2]=0,i[n+96>>2]=0,i[n+100>>2]=0,i[n+104>>2]=0,i[n+108>>2]=0,g[n+112>>1]=0,i[t>>2]=89444,i[n+128>>2]=0,i[n+132>>2]=0,u[n+120|0]=1,i[n+32>>2]=1769234793,u[n+135|0]=0,u[n+136|0]=0,u[n+137|0]=0,u[n+138|0]=0,l[f|0]&&(w=i[f+12>>2],i[n+128>>2]=i[f+8>>2],i[n+132>>2]=w,u[n+136|0]=l[f+16|0],u[n+138|0]=l[f+18|0],u[n+137|0]=l[f+17|0]),e=i[e>>2],i[o+20>>2]=n,i[o+16>>2]=t,i[n+4>>2]=i[n+4>>2]+1,f=i[o+20>>2],i[o+8>>2]=i[o+16>>2],i[o+12>>2]=f,e=re(e,r,o+8|0,0),k&&(i[k>>2]=e),e=i[24057],i[A>>2]=i[24056],i[A+4>>2]=e,i[A+8>>2]=i[24058],A=i[n+4>>2],i[n+4>>2]=A-1,A)break e;W[i[i[n>>2]+8>>2]](n),y(n)}if(!s||(A=i[s+4>>2],i[s+4>>2]=A-1,A))break i;W[i[i[s>>2]+8>>2]](s),y(s)}v=o+32|0}function z9(A,e){var r=0,f=0,k=0,n=0,t=0,o=0,s=0,w=0,h=0,_=0,B=0;if(w=i[A+176>>2],_=i[A+180>>2],(w|0)!=(_|0))for(;;){i:{if(A=i[w+4>>2],B=i[w+8>>2],(A|0)==(B|0))break i;for(;;){e:{s=i[A>>2],o=i[A+4>>2],t=i[e+4>>2],r=i[e+8>>2];r:{if(t>>>0<r>>>0){u[t|0]=0,r=t+1|0;break r}if(k=i[e>>2],t=t-k|0,f=t+1|0,(f|0)<0)break e;if(r=r-k|0,n=r<<1,r=r>>>0>=1073741823?2147483647:f>>>0<n>>>0?n:f,r?f=p(r):f=0,n=f+t|0,u[n|0]=0,t&&x(f,k,t),i[e+8>>2]=r+f,r=n+1|0,i[e+4>>2]=r,i[e>>2]=f,!k)break r;Z(k)}i[e+4>>2]=r,n=i[e+8>>2];r:{if(n>>>0>r>>>0){u[r|0]=0,r=r+1|0;break r}if(k=i[e>>2],t=r-k|0,f=t+1|0,(f|0)<0)break e;if(r=n-k|0,n=r<<1,r=r>>>0>=1073741823?2147483647:f>>>0<n>>>0?n:f,r?f=p(r):f=0,n=f+t|0,u[n|0]=0,t&&x(f,k,t),i[e+8>>2]=r+f,r=n+1|0,i[e+4>>2]=r,i[e>>2]=f,!k)break r;Z(k)}i[e+4>>2]=r,s=o-s|0,o=s>>>8|0,n=i[e+8>>2];r:{if(n>>>0>r>>>0){u[r|0]=o,r=r+1|0;break r}if(k=i[e>>2],t=r-k|0,f=t+1|0,(f|0)<0)break e;if(r=n-k|0,n=r<<1,r=r>>>0>=1073741823?2147483647:f>>>0<n>>>0?n:f,r?f=p(r):f=0,n=f+t|0,u[n|0]=o,t&&x(f,k,t),i[e+8>>2]=r+f,r=n+1|0,i[e+4>>2]=r,i[e>>2]=f,!k)break r;Z(k)}i[e+4>>2]=r,o=i[e+8>>2];r:{if(o>>>0>r>>>0){u[r|0]=s,r=r+1|0;break r}if(k=i[e>>2],t=r-k|0,f=t+1|0,(f|0)<0)break e;if(r=o-k|0,o=r<<1,r=r>>>0>=1073741823?2147483647:f>>>0<o>>>0?o:f,r?f=p(r):f=0,o=f+t|0,u[o|0]=s,t&&x(f,k,t),i[e+8>>2]=r+f,r=o+1|0,i[e+4>>2]=r,i[e>>2]=f,!k)break r;Z(k)}i[e+4>>2]=r,t=i[A+4>>2],o=i[A>>2],k=t-o|0;r:{if((k|0)<=0)break r;if(n=i[e+8>>2],(k|0)<=(n-r|0)){!k|(t|0)==(o|0)||x(r,o,k),i[e+4>>2]=r+k;break r}if(s=i[e>>2],t=r-s|0,f=t+k|0,(f|0)<0)break e;if(n=n-s|0,h=n<<1,n=n>>>0>=1073741823?2147483647:f>>>0<h>>>0?h:f,n?f=p(n):f=0,h=f+t|0,k&&x(h,o,k),i[e+4>>2]=r,t&&x(f,s,t),i[e+8>>2]=f+n,i[e+4>>2]=k+h,i[e>>2]=f,!s)break r;Z(s)}if(A=A+12|0,(B|0)!=(A|0))continue;break i}break}G0(),H()}if(w=w+16|0,(_|0)==(w|0))break}return 1}function vr(A,e){var r=0,f=0,k=0,n=0,t=0,o=0,s=0,w=0,h=0,_=0,B=0,m=0,X=0;if(!A)return y2(e);if(e>>>0>=4294967232)return i[31324]=48,0;t=e>>>0<11?16:e+11&-8,s=A-8|0,w=i[s+4>>2],k=w&-8;i:{if(!(w&3)){if(t>>>0<256||k>>>0>=t+4>>>0&&(r=s,k-t>>>0<=i[31758]<<1>>>0))break i;r=0;break i}o=k+s|0;e:{if(k>>>0>=t>>>0){if(f=k-t|0,f>>>0<16)break e;i[s+4>>2]=w&1|t|2,r=t+s|0,i[r+4>>2]=f|3,i[o+4>>2]=i[o+4>>2]|1,ur(r,f);break e}if(i[31644]==(o|0)){if(k=k+i[31641]|0,k>>>0<=t>>>0)break i;i[s+4>>2]=w&1|t|2,f=t+s|0,r=k-t|0,i[f+4>>2]=r|1,i[31641]=r,i[31644]=f;break e}if(i[31643]==(o|0)){if(k=k+i[31640]|0,k>>>0<t>>>0)break i;r=k-t|0;r:{if(r>>>0>=16){i[s+4>>2]=w&1|t|2,f=t+s|0,i[f+4>>2]=r|1,k=k+s|0,i[k>>2]=r,i[k+4>>2]=i[k+4>>2]&-2;break r}i[s+4>>2]=k|w&1|2,r=k+s|0,i[r+4>>2]=i[r+4>>2]|1,r=0}i[31643]=f,i[31640]=r;break e}if(f=i[o+4>>2],f&2||(h=k+(f&-8)|0,h>>>0<t>>>0))break i;B=h-t|0,n=i[o+12>>2];r:{if(f>>>0<=255){if(r=i[o+8>>2],(r|0)==(n|0)){m=126552,X=i[31638]&k2(-2,f>>>3|0),i[m>>2]=X;break r}i[r+12>>2]=n,i[n+8>>2]=r;break r}_=i[o+24>>2];f:{if((n|0)!=(o|0)){r=i[o+8>>2],i[r+12>>2]=n,i[n+8>>2]=r;break f}A:{if(r=i[o+20>>2],r)f=o+20|0;else{if(r=i[o+16>>2],!r)break A;f=o+16|0}for(;k=f,n=r,f=r+20|0,r=i[r+20>>2],!(!r&&(f=n+16|0,r=i[n+16>>2],!r)););i[k>>2]=0;break f}n=0}if(!_)break r;f=i[o+28>>2],r=(f<<2)+126856|0;f:{if(i[r>>2]==(o|0)){if(i[r>>2]=n,n)break f;m=126556,X=i[31639]&k2(-2,f),i[m>>2]=X;break r}A:{if(i[_+16>>2]==(o|0)){i[_+16>>2]=n;break A}i[_+20>>2]=n}if(!n)break r}if(i[n+24>>2]=_,r=i[o+16>>2],r&&(i[n+16>>2]=r,i[r+24>>2]=n),r=i[o+20>>2],!r)break r;i[n+20>>2]=r,i[r+24>>2]=n}if(B>>>0<=15){i[s+4>>2]=w&1|h|2,r=s+h|0,i[r+4>>2]=i[r+4>>2]|1;break e}i[s+4>>2]=w&1|t|2,f=t+s|0,i[f+4>>2]=B|3,r=s+h|0,i[r+4>>2]=i[r+4>>2]|1,ur(f,B)}r=s}return r?r+8|0:(f=y2(e),f?(r=i[A-4>>2],r=(r&3?-4:-8)+(r&-8)|0,A8(f,A,e>>>0>r>>>0?r:e),Z(A),f):0)}function x9(A,e,r,f){var k=0,n=0,t=0,o=0,s=0;k=i[e>>2];i:{e:{r:{f:{A:{k:{n:{t:{u:{o:{l:{s:{if(!f||(t=i[f>>2],!t))break s;if(!A){f=r;break o}i[f>>2]=0,f=r;break l}s:{if(!i[i[31366]>>2]){if(!A)break s;if(!r)break i;for(t=r;;){if(f=u[k|0],f){if(i[A>>2]=f&57343,A=A+4|0,k=k+1|0,t=t-1|0,t)continue;break i}break}return i[A>>2]=0,i[e>>2]=0,r-t|0}if(f=r,!A)break u;break n}return h2(k)}n=1;break n}n=0;break t}n=1}for(;;){if(!n){if(n=l[k|0]>>>3|0,(n-16|n+(t>>26))>>>0>7)break k;n=k+1|0;t:{if(!(t&33554432))break t;if(u[n|0]>=-64){k=k-1|0;break f}if(n=k+2|0,!(t&524288))break t;if(u[n|0]>=-64){k=k-1|0;break f}n=k+3|0}k=n,f=f-1|0,n=1;continue}for(;;){t=u[k|0];t:{if(k&3|(t|0)<=0||(t=i[k>>2],(t|t-16843009)&-2139062144))break t;for(;f=f-4|0,t=i[k+4>>2],k=k+4|0,!((t-16843009|t)&-2139062144););}if(t<<24>>24>0){f=f-1|0,k=k+1|0;continue}break}if(n=(t&255)-194|0,n>>>0>50)break A;k=k+1|0,t=i[(n<<2)+73184>>2],n=0}}for(;;){if(!n){if(!f)break i;for(;;){n:{if(n=l[k|0],t=n<<24>>24,(t|0)<=0)break n;if(!(k&3|f>>>0<5)){t:{for(;;){if(t=i[k>>2],(t|t-16843009)&-2139062144)break t;if(i[A>>2]=t&255,i[A+4>>2]=l[k+1|0],i[A+8>>2]=l[k+2|0],i[A+12>>2]=l[k+3|0],A=A+16|0,k=k+4|0,f=f-4|0,!(f>>>0>4))break}t=l[k|0]}if(n=t&255,t<<24>>24<=0)break n}if(i[A>>2]=n,A=A+4|0,k=k+1|0,f=f-1|0,f)continue;break i}break}if(n=n-194|0,n>>>0>50)break A;k=k+1|0,t=i[(n<<2)+73184>>2],n=1;continue}if(n=l[k|0],o=n>>>3|0,(o-16|o+(t>>26))>>>0>7)break k;n:{t:{o=k+1|0,n=n-128|t<<6;u:{if((n|0)>=0)break u;if(o=l[o|0]-128|0,o>>>0>63)break t;if(s=n<<6,n=o|s,o=k+2|0,(s|0)>=0)break u;if(o=l[o|0]-128|0,o>>>0>63)break t;n=o|n<<6,o=k+3|0}k=o,i[A>>2]=n,f=f-1|0,A=A+4|0;break n}i[31324]=25,k=k-1|0;break r}n=0}}if(k=k-1|0,t)break f;t=l[k|0]}if(t&255)break f;return A&&(i[A>>2]=0,i[e>>2]=0),r-f|0}if(i[31324]=25,!A)break e}i[e>>2]=k}return-1}return i[e>>2]=k,r}function T9(A,e,r,f,k,n,t,o,s,w,h,_,B,m,X){var Q=0,V=0,F=0,I=0,E=0,R=0,N=0,M=0,z=0,S=0,O=0,P=0;for(R=v-16|0,v=R,i[r>>2]=A,M=o?4:0,z=f&512;;){if((N|0)==4)l[m+11|0]>>>7|0?k=i[m+4>>2]:k=l[m+11|0]&127,k>>>0>1&&(O=R,P=T4(m),i[O+12>>2]=P,O=r,P=xt(n5(R+12|0,1),s6(m),i[r>>2]),i[O>>2]=P),f=f&176,(f|0)!=16&&((f|0)==32&&(A=i[r>>2]),i[e>>2]=A),v=R+16|0;else{i:{e:switch(l[s+N|0]){case 0:i[e>>2]=i[r>>2];break i;case 1:i[e>>2]=i[r>>2],V=W[i[i[t>>2]+44>>2]](t,32)|0,o=i[r>>2],i[r>>2]=o+4,i[o>>2]=V;break i;case 3:if(l[m+11|0]>>>7|0?o=i[m+4>>2]:o=l[m+11|0]&127,!o)break i;l[m+11|0]>>>7|0?o=i[m>>2]:o=m,V=i[o>>2],o=i[r>>2],i[r>>2]=o+4,i[o>>2]=V;break i;case 2:if(l[B+11|0]>>>7|0?o=i[B+4>>2]:o=l[B+11|0]&127,o=!o,o|!z)break i;O=r,P=xt(T4(B),s6(B),i[r>>2]),i[O>>2]=P;break i;case 4:break e;default:break i}for(S=i[r>>2],k=k+M|0,o=k;;){e:{if(n>>>0<=o>>>0||!(W[i[i[t>>2]+12>>2]](t,64,i[o>>2])|0))break e;o=o+4|0;continue}break}if((X|0)>0){for(V=i[r>>2],F=X;;){if(!(!F|k>>>0>=o>>>0)){F=F-1|0,o=o-4|0,I=i[o>>2],Q=V+4|0,i[r>>2]=Q,i[V>>2]=I,V=Q;continue}break}for(F?Q=W[i[i[t>>2]+44>>2]](t,48)|0:Q=0,I=Q,V=i[r>>2];;){if((F|0)>0){Q=V+4|0,i[r>>2]=Q,i[V>>2]=I,F=F-1|0,V=Q;continue}break}V=i[r>>2],i[r>>2]=V+4,i[V>>2]=w}e:{if((k|0)==(o|0)){V=W[i[i[t>>2]+44>>2]](t,48)|0,o=i[r>>2],i[r>>2]=o+4,i[o>>2]=V;break e}for(l[_+11|0]>>>7|0?Q=i[_>>2]:Q=_,Q=u[Q|0],l[_+11|0]>>>7|0?V=i[_+4>>2]:V=l[_+11|0]&127,Q=V?Q:-1,F=0,E=0;;){if((k|0)==(o|0))break e;r:{if((F|0)!=(Q|0)){V=F;break r}if(V=i[r>>2],i[r>>2]=V+4,i[V>>2]=h,V=0,l[_+11|0]>>>7|0?Q=i[_+4>>2]:Q=l[_+11|0]&127,E=E+1|0,Q>>>0<=E>>>0){Q=F;break r}if(l[_+11|0]>>>7|0?Q=i[_>>2]:Q=_,l[Q+E|0]==127){Q=-1;break r}l[_+11|0]>>>7|0?Q=i[_>>2]:Q=_,Q=u[Q+E|0]}o=o-4|0,I=i[o>>2],F=i[r>>2],i[r>>2]=F+4,i[F>>2]=I,F=V+1|0}}cr(S,i[r>>2])}N=N+1|0;continue}break}}function S9(A,e,r,f,k){var n=0,t=0,o=0,s=0,w=0,h=0,_=0,B=0;t=v-160|0,v=t,i[t+100>>2]=0,i[t+72>>2]=72196,i[t+16>>2]=72176,n=i[18053],i[t+8>>2]=n,B=i[n-12>>2],o=t+8|0,n=o,i[B+n>>2]=i[18054],i[t+12>>2]=0,n=n+i[i[t+8>>2]-12>>2]|0,h=t+20|0,J0(n,h),u[n+80|0]=0,i[n+72>>2]=0,n=i[18055],i[t+16>>2]=n,s=t+16|0,i[s+i[n-12>>2]>>2]=i[18056],n=i[18052],i[t+8>>2]=n,i[o+i[n-12>>2]>>2]=i[18057],i[t+72>>2]=72196,i[t+8>>2]=72156,i[t+16>>2]=72176,h=R0(h),i[h>>2]=71232,i[t+60>>2]=0,i[t+64>>2]=0,i[t+52>>2]=0,i[t+56>>2]=0,i[t+68>>2]=24,n=i[t+16>>2]-12|0,o=s+i[n>>2]|0,i[o+4>>2]=i[o+4>>2]&-75|8,o=s+i[n>>2]|0,l[o+80|0]||(w=t+156|0,n=i[o+28>>2],i[w>>2]=n,(n|0)!=129576&&(i[n+4>>2]=i[n+4>>2]+1),n=c0(w,129760),W[i[i[n>>2]+28>>2]](n,32)|0,e2(w)),u[o+76|0]=48,u[o+77|0]=0,u[o+78|0]=0,u[o+79|0]=0,n=1,u[o+80|0]=1,o=t+28|0;i:{if(!r)break i;if(w=u[f+11|0],_=(w|0)<0,Y(s,_?i[f>>2]:f,_?i[f+4>>2]:w),i[i[i[t+16>>2]-12>>2]+o>>2]=4,Y(V0(s,0),32729,2),i[i[i[t+16>>2]-12>>2]+o>>2]=2,S0(s,l[e|0]),f=r-1|0,!f){Y(s,42670,1);break i}for(;;){e:{r:{f:{A:switch(w=n&15,w|0){case 0:break A;case 8:break f;default:break r}_=u[k+11|0],B=(_|0)<0,Y(s,B?i[k>>2]:k,B?i[k+4>>2]:_),i[i[i[t+16>>2]-12>>2]+o>>2]=4,Y(V0(s,n),32729,2);break e}Y(s,32807,2);break e}Y(s,32808,1)}if(i[i[i[t+16>>2]-12>>2]+o>>2]=2,S0(s,l[e+n|0]),(f|0)!=(n|0)&(w|0)!=15||Y(s,42670,1),n=n+1|0,(n|0)==(r|0))break}}e=i[t+68>>2];i:{e:{if(e&16){o=t+40|0,r=i[t+64>>2],e=i[t+44>>2],r>>>0<e>>>0?i[t+64>>2]=e:e=r;break e}if(!(e&8)){n=0,u[A+11|0]=0;break i}e=i[t+36>>2]}e:{if(r=i[o>>2],n=e-r|0,n>>>0<2147483640){if(n>>>0>=11){f=n|7,e=p(f+1|0),i[A+8>>2]=f-2147483647,i[A>>2]=e,i[A+4>>2]=n,A=e;break e}if(u[A+11|0]=n,n)break e;n=0;break i}Q0(),H()}if(!n)break i;x(A,r,n)}u[A+n|0]=0,A=i[18051],i[t+8>>2]=A,i[i[A-12>>2]+(t+8|0)>>2]=i[18059],i[t+16>>2]=i[18060],i[h>>2]=71232,u[t+63|0]<0&&Z(i[t+52>>2]),E0(h),y0(t+72|0),v=t+160|0}function Dm(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,t=0,o=0,s=0;n=v-32|0,v=n;i:{if(!r){e=i[23570],i[A>>2]=i[23569],i[A+4>>2]=e,i[A+8>>2]=i[23571];break i}if(i[r>>2]=0,f=i[e>>2],t=u[f+247|0],k=(t|0)<0,t=y2((k?i[f+240>>2]:t)+1|0),!t){if(r=p(48),i[n>>2]=r,i[n+4>>2]=45,i[n+8>>2]=-2147483600,f=l[11139]|l[11140]<<8|(l[11141]<<16|l[11142]<<24),k=l[11135]|l[11136]<<8|(l[11137]<<16|l[11138]<<24),u[r+37|0]=k,u[r+38|0]=k>>>8,u[r+39|0]=k>>>16,u[r+40|0]=k>>>24,u[r+41|0]=f,u[r+42|0]=f>>>8,u[r+43|0]=f>>>16,u[r+44|0]=f>>>24,f=l[11134]|l[11135]<<8|(l[11136]<<16|l[11137]<<24),k=l[11130]|l[11131]<<8|(l[11132]<<16|l[11133]<<24),u[r+32|0]=k,u[r+33|0]=k>>>8,u[r+34|0]=k>>>16,u[r+35|0]=k>>>24,u[r+36|0]=f,u[r+37|0]=f>>>8,u[r+38|0]=f>>>16,u[r+39|0]=f>>>24,f=l[11126]|l[11127]<<8|(l[11128]<<16|l[11129]<<24),k=l[11122]|l[11123]<<8|(l[11124]<<16|l[11125]<<24),u[r+24|0]=k,u[r+25|0]=k>>>8,u[r+26|0]=k>>>16,u[r+27|0]=k>>>24,u[r+28|0]=f,u[r+29|0]=f>>>8,u[r+30|0]=f>>>16,u[r+31|0]=f>>>24,f=l[11118]|l[11119]<<8|(l[11120]<<16|l[11121]<<24),k=l[11114]|l[11115]<<8|(l[11116]<<16|l[11117]<<24),u[r+16|0]=k,u[r+17|0]=k>>>8,u[r+18|0]=k>>>16,u[r+19|0]=k>>>24,u[r+20|0]=f,u[r+21|0]=f>>>8,u[r+22|0]=f>>>16,u[r+23|0]=f>>>24,f=l[11110]|l[11111]<<8|(l[11112]<<16|l[11113]<<24),k=l[11106]|l[11107]<<8|(l[11108]<<16|l[11109]<<24),u[r+8|0]=k,u[r+9|0]=k>>>8,u[r+10|0]=k>>>16,u[r+11|0]=k>>>24,u[r+12|0]=f,u[r+13|0]=f>>>8,u[r+14|0]=f>>>16,u[r+15|0]=f>>>24,f=l[11102]|l[11103]<<8|(l[11104]<<16|l[11105]<<24),k=l[11098]|l[11099]<<8|(l[11100]<<16|l[11101]<<24),u[r|0]=k,u[r+1|0]=k>>>8,u[r+2|0]=k>>>16,u[r+3|0]=k>>>24,u[r+4|0]=f,u[r+5|0]=f>>>8,u[r+6|0]=f>>>16,u[r+7|0]=f>>>24,u[r+45|0]=0,r=A,A=q(n+12|0,6,0,n),e=i[e>>2],b0(r,A,e?e+84|0:0),u[A+19|0]<0&&Z(i[A+8>>2]),u[n+11|0]>=0)break i;Z(i[n>>2]);break i}o=r,s=c4(t,k?i[f+236>>2]:f+236|0),i[o>>2]=s,i[A+8>>2]=i[24058],e=i[24057],i[A>>2]=i[24056],i[A+4>>2]=e}v=n+32|0}function Mm(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,t=0,o=0,s=0;f=v-160|0,v=f,i[f+92>>2]=0,i[f+64>>2]=72500,k=i[18128],i[f+8>>2]=k,n=i[k-12>>2],k=f+8|0,i[n+k>>2]=i[18129],o=k+i[i[f+8>>2]-12>>2]|0,n=f+12|0,J0(o,n),u[o+80|0]=0,i[o+72>>2]=0,i[f+64>>2]=72500,i[f+8>>2]=72480,o=R0(n),i[o>>2]=71232,i[f+52>>2]=0,i[f+56>>2]=0,i[f+44>>2]=0,i[f+48>>2]=0,i[f+60>>2]=16,n=f+148|0,Y2(n,e,r),t=k,s=n,k=u[f+159|0],n=(k|0)<0,Y(t,n?i[f+148>>2]:s,n?i[f+152>>2]:k),u[f+159|0]<0&&Z(i[f+148>>2]),k=f+148|0,s0(k,r),t=k,k=u[f+159|0],n=(k|0)<0,Y(f+8|0,n?i[f+148>>2]:t,n?i[f+152>>2]:k),u[f+159|0]<0&&Z(i[f+148>>2]),k=f+8|0,Y(d1(Y(d1(Y(k,29643,17),t0[e+112>>3]),32733,2),t0[e+120>>3]),42670,1);i:{if(l[e+128|0]==1){n=f+148|0,s0(n,r),t=k,s=n,k=u[f+159|0],n=(k|0)<0,Y(t,n?i[f+148>>2]:s,n?i[f+152>>2]:k),u[f+159|0]<0&&Z(i[f+148>>2]),k=f+8|0,Y(d1(Y(d1(Y(k,30995,14),t0[e+104>>3]),32733,2),t0[e+136>>3]),42670,1),n=f+148|0,s0(n,r),t=k,r=u[f+159|0],k=(r|0)<0,Y(t,k?i[f+148>>2]:n,k?i[f+152>>2]:r),u[f+159|0]<0&&Z(i[f+148>>2]),Y(d1(Y(f+8|0,29574,6),t0[e+144>>3]),42670,1);break i}k=f+148|0,s0(k,r),t=k,k=u[f+159|0],n=(k|0)<0,Y(f+8|0,n?i[f+148>>2]:t,n?i[f+152>>2]:k),u[f+159|0]<0&&Z(i[f+148>>2]),k=f+8|0,Y(d1(Y(k,30995,14),t0[e+104>>3]),42670,1),e=f+148|0,s0(e,r),n=e,e=u[f+159|0],r=(e|0)<0,Y(k,r?i[f+148>>2]:n,r?i[f+152>>2]:e),u[f+159|0]<0&&Z(i[f+148>>2]),Y(f+8|0,32810,8)}e=i[f+60>>2];i:{e:{if(e&16){e=i[f+56>>2],r=i[f+36>>2],e>>>0<r>>>0&&(i[f+56>>2]=r,e=r),r=f+32|0;break e}if(!(e&8)){e=0,u[A+11|0]=0;break i}e=i[f+28>>2],r=f+20|0}e:{if(k=i[r>>2],e=e-k|0,e>>>0<2147483640){if(e>>>0>=11){n=e|7,r=p(n+1|0),i[A+8>>2]=n-2147483647,i[A>>2]=r,i[A+4>>2]=e,A=r;break e}if(u[A+11|0]=e,e)break e;e=0;break i}Q0(),H()}if(!e)break i;x(A,k,e)}u[A+e|0]=0,A=i[18127],i[f+8>>2]=A,i[i[A-12>>2]+(f+8|0)>>2]=i[18130],i[o>>2]=71232,u[f+55|0]<0&&Z(i[f+44>>2]),E0(o),y0(f- -64|0),v=f+160|0}function j9(A,e,r,f,k,n,t,o,s,w,h,_,B){var m=0,X=0,Q=0,V=0,F=0,I=0,E=0,R=0,N=0,M=0,z=0,S=0,O=0,P=0,a=0,$=0,f0=0;m=v,S=m,m=m-14464&-32,v=m,Q=i[e+16852>>2],V=G(2/(Q|0)|0,r),r=((k|0)/(Q|0)|0)+(V>>3)|0,k=f,f=i[e+16856>>2],X=G(k,2/(f|0)|0),n=((n|0)/(f|0)|0)+(X>>3)|0,I=i[e+488>>2]/(f|0)|0,k=i[e+484>>2]/(Q|0)|0;i:{if(Q=V&7,f=X&7,!(Q|f)){if(e=i[e+16840>>2],!((r|0)<0|(k|0)<(r+h|0)|((n|0)<0|(I|0)<(n+_|0)))){if(e=(r+s|0)+G(n,w)|0,(B|0)<=8){W[i[A+204>>2]](t,o,e,w,h,_,0,0,0);break i}W[i[A+284>>2]](t,o,e,w,h,_,0,0,0,B);break i}if((_|0)<=0|(h|0)<=0)break i;for(B=14-e|0,E=I-1|0,m=k-1|0,R=h&2147483646,N=h&1,A=0;;){if(e=A+n|0,Q=G((e|0)>=0?(e|0)<(I|0)?e:E:0,w)+s|0,V=(G(A,o)<<1)+t|0,e=0,f=0,(h|0)!=1)for(;X=e+r|0,g[V+(e<<1)>>1]=l[Q+((X|0)>=0?(k|0)>(X|0)?X:m:0)|0]<<B,F=e|1,X=F+r|0,g[V+(F<<1)>>1]=l[Q+((X|0)>=0?(k|0)>(X|0)?X:m:0)|0]<<B,e=e+2|0,f=f+2|0,(R|0)!=(f|0););if(N&&(f=V+(e<<1)|0,e=e+r|0,g[f>>1]=l[Q+((e|0)>=0?(e|0)<(k|0)?e:m:0)|0]<<B),A=A+1|0,(_|0)==(A|0))break}break i}e:{if(!((r|0)<=0|(r+h|0)>(k-2|0)|((n|0)<=0|(n+_|0)>(I-2|0)))){e=(r+s|0)+G(n,w)|0;break e}if(!((_|0)<-2|(h|0)<-2))for(V=-1,O=I-1|0,X=k-1|0,e=_+2|0,P=(e|0)>0?e:0,a=r+1|0,e=h+3|0,$=e&-2,f0=e&1;;){if(e=n+V|0,E=G((e|0)>=0?(e|0)<(I|0)?e:O:0,w)+s|0,R=G(V,80)+81|0,e=-1,(h|0)!=-2)for(M=R+1|0,N=0;z=m+16|0,F=e+r|0,u[z+(e+R|0)|0]=l[E+((F|0)>=0?(k|0)>(F|0)?F:X:0)|0],F=e+a|0,u[(e+M|0)+z|0]=l[E+((F|0)>=0?(k|0)>(F|0)?F:X:0)|0],e=e+2|0,N=N+2|0,($|0)!=(N|0););if(f0&&(M=m+16+(e+R)|0,e=e+r|0,u[M|0]=l[E+((e|0)>=0?(e|0)<(k|0)?e:X:0)|0]),V=V+1|0,(P|0)==(V|0))break}w=80,e=m+97|0}if(!(!Q|!f)){W[i[(((B|0)<9?44:124)+A|0)+172>>2]](t,o,e,w,h,_,Q,f,m+5376|0,B);break i}if(Q){W[i[(((B|0)<9?36:116)+A|0)+172>>2]](t,o,e,w,h,_,Q,f,m+5376|0,B);break i}if(f){W[i[(((B|0)<9?40:120)+A|0)+172>>2]](t,o,e,w,h,_,0,f,m+5376|0,B);break i}D0(12200,18225,269,18969),H()}v=S}function Hm(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,t=0,o=0;k=v+-64|0,v=k,t=W[i[i[e>>2]+52>>2]](e,r,0)|0,f=i[e+40>>2]-i[e+36>>2]>>3;i:{if(f>>>0>=65536){if(e=p(32),i[k+52>>2]=e,i[k+56>>2]=29,i[k+60>>2]=-2147483616,r=l[23885]|l[23886]<<8|(l[23887]<<16|l[23888]<<24),f=l[23881]|l[23882]<<8|(l[23883]<<16|l[23884]<<24),u[e|0]=f,u[e+1|0]=f>>>8,u[e+2|0]=f>>>16,u[e+3|0]=f>>>24,u[e+4|0]=r,u[e+5|0]=r>>>8,u[e+6|0]=r>>>16,u[e+7|0]=r>>>24,u[e+29|0]=0,r=l[23906]|l[23907]<<8|(l[23908]<<16|l[23909]<<24),f=l[23902]|l[23903]<<8|(l[23904]<<16|l[23905]<<24),u[e+21|0]=f,u[e+22|0]=f>>>8,u[e+23|0]=f>>>16,u[e+24|0]=f>>>24,u[e+25|0]=r,u[e+26|0]=r>>>8,u[e+27|0]=r>>>16,u[e+28|0]=r>>>24,r=l[23901]|l[23902]<<8|(l[23903]<<16|l[23904]<<24),f=l[23897]|l[23898]<<8|(l[23899]<<16|l[23900]<<24),u[e+16|0]=f,u[e+17|0]=f>>>8,u[e+18|0]=f>>>16,u[e+19|0]=f>>>24,u[e+20|0]=r,u[e+21|0]=r>>>8,u[e+22|0]=r>>>16,u[e+23|0]=r>>>24,r=l[23893]|l[23894]<<8|(l[23895]<<16|l[23896]<<24),f=l[23889]|l[23890]<<8|(l[23891]<<16|l[23892]<<24),u[e+8|0]=f,u[e+9|0]=f>>>8,u[e+10|0]=f>>>16,u[e+11|0]=f>>>24,u[e+12|0]=r,u[e+13|0]=r>>>8,u[e+14|0]=r>>>16,u[e+15|0]=r>>>24,q(A,5,0,k+52|0),u[k+63|0]>=0)break i;Z(i[k+52>>2]);break i}F0(r,f),f=i[e+36>>2],n=i[e+40>>2];e:{if((f|0)!=(n|0))for(;;){if(o=i[f>>2],W[i[i[o>>2]+20>>2]](k+32|0,o,r),i[k+32>>2])break e;if(u[k+51|0]<0&&Z(i[k+40>>2]),f=f+8|0,(n|0)==(f|0))break}if(f=i[26917],i[k+32>>2]=i[26916],i[k+36>>2]=f,f=k+40|0,u[107683]>=0){n=i[26919],i[f>>2]=i[26918],i[f+4>>2]=n,i[f+8>>2]=i[26920];break e}T(f,i[26918],i[26919])}if(u[k+51|0]<0&&Z(i[k+40>>2]),i[r+12>>2]=t,W[i[i[e>>2]+56>>2]](k+12|0,e,r,i[r+4>>2]-(i[r>>2]+t|0)|0,0),i[r+12>>2]=i[r+4>>2]-i[r>>2],u[k+31|0]<0&&Z(i[k+20>>2]),e=i[26917],i[A>>2]=i[26916],i[A+4>>2]=e,A=A+8|0,u[107683]>=0){e=i[26919],i[A>>2]=i[26918],i[A+4>>2]=e,i[A+8>>2]=i[26920];break i}T(A,i[26918],i[26919])}v=k- -64|0}function zm(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,t=0,o=0,s=0,w=0;f=v-160|0,v=f,i[f+92>>2]=0,i[f+64>>2]=72500,k=i[18128],i[f+8>>2]=k,n=i[k-12>>2],k=f+8|0,i[n+k>>2]=i[18129],w=k+i[i[f+8>>2]-12>>2]|0,t=f+12|0,J0(w,t),u[w+80|0]=0,i[w+72>>2]=0,i[f+64>>2]=72500,i[f+8>>2]=72480,w=R0(t),i[w>>2]=71232,i[f+52>>2]=0,i[f+56>>2]=0,i[f+44>>2]=0,i[f+48>>2]=0,i[f+60>>2]=16,t=f+148|0,Y2(t,e,r),n=k,o=t,k=u[f+159|0],t=(k|0)<0,Y(n,t?i[f+148>>2]:o,t?i[f+152>>2]:k),u[f+159|0]<0&&Z(i[f+148>>2]),k=f+148|0,s0(k,r),n=k,k=u[f+159|0],t=(k|0)<0,Y(f+8|0,t?i[f+148>>2]:n,t?i[f+152>>2]:k),u[f+159|0]<0&&Z(i[f+148>>2]),k=f+8|0,s=Y(k,31087,6),t=e+104|0,n=u[e+115|0],o=(n|0)<0,Y(Y(s,o?i[e+104>>2]:t,o?i[e+108>>2]:n),42670,1),n=f+148|0,s0(n,r),o=k,s=n,k=u[f+159|0],n=(k|0)<0,Y(o,n?i[f+148>>2]:s,n?i[f+152>>2]:k),u[f+159|0]<0&&Z(i[f+148>>2]),k=f+8|0,s=Y(k,31854,6),n=u[e+127|0],o=(n|0)<0,Y(Y(s,o?i[e+116>>2]:e+116|0,o?i[e+120>>2]:n),42670,1),n=f+148|0,s0(n,r),o=k,s=n,k=u[f+159|0],n=(k|0)<0,Y(o,n?i[f+148>>2]:s,n?i[f+152>>2]:k),u[f+159|0]<0&&Z(i[f+148>>2]),k=f+8|0,s=Y(k,30534,13),n=u[e+139|0],o=(n|0)<0,Y(Y(s,o?i[e+128>>2]:e+128|0,o?i[e+132>>2]:n),42670,1),n=f+148|0,s0(n,r),o=k,r=u[f+159|0],k=(r|0)<0,Y(o,k?i[f+148>>2]:n,k?i[f+152>>2]:r),u[f+159|0]<0&&Z(i[f+148>>2]),n=Y(f+8|0,29941,6),r=u[e+115|0],k=(r|0)<0,Y(Y(n,k?i[e+104>>2]:t,k?i[e+108>>2]:r),42670,1),e=i[f+60>>2];i:{e:{if(e&16){e=i[f+56>>2],r=i[f+36>>2],e>>>0<r>>>0&&(i[f+56>>2]=r,e=r),r=f+32|0;break e}if(!(e&8)){e=0,u[A+11|0]=0;break i}e=i[f+28>>2],r=f+20|0}e:{if(k=i[r>>2],e=e-k|0,e>>>0<2147483640){if(e>>>0>=11){t=e|7,r=p(t+1|0),i[A+8>>2]=t-2147483647,i[A>>2]=r,i[A+4>>2]=e,A=r;break e}if(u[A+11|0]=e,e)break e;e=0;break i}Q0(),H()}if(!e)break i;x(A,k,e)}u[A+e|0]=0,A=i[18127],i[f+8>>2]=A,i[i[A-12>>2]+(f+8|0)>>2]=i[18130],i[w>>2]=71232,u[f+55|0]<0&&Z(i[f+44>>2]),E0(w),y0(f- -64|0),v=f+160|0}function xm(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,t=0,o=0,s=0;f=v-160|0,v=f,i[f+92>>2]=0,i[f+64>>2]=72500,k=i[18128],i[f+8>>2]=k,n=i[k-12>>2],k=f+8|0,i[n+k>>2]=i[18129],o=k+i[i[f+8>>2]-12>>2]|0,n=f+12|0,J0(o,n),u[o+80|0]=0,i[o+72>>2]=0,i[f+64>>2]=72500,i[f+8>>2]=72480,o=R0(n),i[o>>2]=71232,i[f+52>>2]=0,i[f+56>>2]=0,i[f+44>>2]=0,i[f+48>>2]=0,i[f+60>>2]=16,n=f+148|0,Y2(n,e,r),t=k,s=n,k=u[f+159|0],n=(k|0)<0,Y(t,n?i[f+148>>2]:s,n?i[f+152>>2]:k),u[f+159|0]<0&&Z(i[f+148>>2]),k=f+148|0,s0(k,r),t=k,k=u[f+159|0],n=(k|0)<0,Y(f+8|0,n?i[f+148>>2]:t,n?i[f+152>>2]:k),u[f+159|0]<0&&Z(i[f+148>>2]),k=f+8|0,Y(k,32673,25),Y(V0(Y(V0(Y(k,27148,1),C[e+100>>1]),21052,1),C[e+106>>1]),32732,3),Y(V0(Y(V0(Y(k,27148,1),C[e+102>>1]),21052,1),C[e+108>>1]),32732,3),Y(V0(Y(V0(Y(k,27148,1),C[e+104>>1]),21052,1),C[e+110>>1]),42669,2),n=f+148|0,s0(n,r),t=k,s=n,k=u[f+159|0],n=(k|0)<0,Y(t,n?i[f+148>>2]:s,n?i[f+152>>2]:k),u[f+159|0]<0&&Z(i[f+148>>2]),k=f+8|0,Y(V0(Y(V0(Y(k,27120,20),C[e+112>>1]),21052,1),C[e+114>>1]),42669,2),n=f+148|0,s0(n,r),t=k,s=n,k=u[f+159|0],n=(k|0)<0,Y(t,n?i[f+148>>2]:s,n?i[f+152>>2]:k),u[f+159|0]<0&&Z(i[f+148>>2]),k=f+8|0,Y(V0(Y(k,31979,33),i[e+116>>2]),42670,1),n=f+148|0,s0(n,r),t=k,r=u[f+159|0],k=(r|0)<0,Y(t,k?i[f+148>>2]:n,k?i[f+152>>2]:r),u[f+159|0]<0&&Z(i[f+148>>2]),Y(V0(Y(f+8|0,32013,33),i[e+120>>2]),42670,1),e=i[f+60>>2];i:{e:{if(e&16){e=i[f+56>>2],r=i[f+36>>2],e>>>0<r>>>0&&(i[f+56>>2]=r,e=r),r=f+32|0;break e}if(!(e&8)){e=0,u[A+11|0]=0;break i}e=i[f+28>>2],r=f+20|0}e:{if(k=i[r>>2],e=e-k|0,e>>>0<2147483640){if(e>>>0>=11){n=e|7,r=p(n+1|0),i[A+8>>2]=n-2147483647,i[A>>2]=r,i[A+4>>2]=e,A=r;break e}if(u[A+11|0]=e,e)break e;e=0;break i}Q0(),H()}if(!e)break i;x(A,k,e)}u[A+e|0]=0,A=i[18127],i[f+8>>2]=A,i[i[A-12>>2]+(f+8|0)>>2]=i[18130],i[o>>2]=71232,u[f+55|0]<0&&Z(i[f+44>>2]),E0(o),y0(f- -64|0),v=f+160|0}function mr(A,e,r,f){var k=0,n=0,t=0,o=0,s=0,w=0,h=0,_=0;k=v-160|0,v=k,i[k+92>>2]=0,i[k+64>>2]=72500,t=i[18128],i[k+8>>2]=t,n=i[t-12>>2],t=k+8|0,i[n+t>>2]=i[18129],t=t+i[i[k+8>>2]-12>>2]|0,w=k+12|0,J0(t,w),u[t+80|0]=0,i[t+72>>2]=0,i[k+64>>2]=72500,i[k+8>>2]=72480,w=R0(w),i[w>>2]=71232,i[k+52>>2]=0,i[k+56>>2]=0,i[k+44>>2]=0,i[k+48>>2]=0,i[k+60>>2]=16,t=1,n=i[r>>2]+1|0,i[r>>2]=n;i:{e:{r:{h=i[e+40>>2],e=i[e+36>>2];f:{if((h|0)==(e|0)){i[r>>2]=((n|0)<=1?1:n)-1;break f}if(f&&(t=k+148|0,s0(t,r),s=t,t=u[k+159|0],n=(t|0)<0,Y(k+8|0,n?i[k+148>>2]:s,n?i[k+152>>2]:t),u[k+159|0]<0&&Z(i[k+148>>2]),Y(S0(Y(k+8|0,29525,7),1),42670,1),t=2),n=k+148|0,o=i[e>>2],W[i[i[o>>2]+12>>2]](n,o,r),s=n,n=u[k+159|0],o=(n|0)<0,Y(k+8|0,o?i[k+148>>2]:s,o?i[k+152>>2]:n),u[k+159|0]<0&&Z(i[k+148>>2]),e=e+8|0,(h|0)!=(e|0))for(;n=k+148|0,s0(n,r),s=n,n=u[k+159|0],o=(n|0)<0,Y(k+8|0,o?i[k+148>>2]:s,o?i[k+152>>2]:n),u[k+159|0]<0&&Z(i[k+148>>2]),n=k+8|0,Y(n,42670,1),f&&(o=k+148|0,s0(o,r),_=n,s=o,n=u[k+159|0],o=(n|0)<0,Y(_,o?i[k+148>>2]:s,o?i[k+152>>2]:n),u[k+159|0]<0&&Z(i[k+148>>2]),Y(S0(Y(k+8|0,29525,7),t),42670,1),t=t+1|0),n=k+148|0,o=i[e>>2],W[i[i[o>>2]+12>>2]](n,o,r),s=n,n=u[k+159|0],o=(n|0)<0,Y(k+8|0,o?i[k+148>>2]:s,o?i[k+152>>2]:n),u[k+159|0]<0&&Z(i[k+148>>2]),e=e+8|0,(h|0)!=(e|0););if(e=i[k+60>>2],f=r,r=i[r>>2],i[f>>2]=((r|0)<=1?1:r)-1,!(e&16))break r}e=i[k+56>>2],r=i[k+36>>2],e>>>0<r>>>0&&(i[k+56>>2]=r,e=r),r=k+32|0;break e}if(!(e&8)){e=0,u[A+11|0]=0;break i}e=i[k+28>>2],r=k+20|0}e:{if(f=i[r>>2],e=e-f|0,e>>>0<2147483640){if(e>>>0>=11){t=e|7,r=p(t+1|0),i[A+8>>2]=t-2147483647,i[A>>2]=r,i[A+4>>2]=e,A=r;break e}if(u[A+11|0]=e,e)break e;e=0;break i}Q0(),H()}if(!e)break i;x(A,f,e)}u[A+e|0]=0,A=i[18127],i[k+8>>2]=A,i[i[A-12>>2]+(k+8|0)>>2]=i[18130],i[w>>2]=71232,u[k+55|0]<0&&Z(i[k+44>>2]),E0(w),y0(k- -64|0),v=k+160|0}function Df(A,e,r,f,k,n){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0;var t=0,o=0,s=0,w=0,h=0,_=0;s=v-16|0,v=s;i:{if(!n){e=i[23570],i[A>>2]=i[23569],i[A+4>>2]=e,i[A+8>>2]=i[23571];break i}f|k||(Y(128452,41853,136),f=2);e:{r:{f:switch(f|0){case 0:o=p(12),i[s+4>>2]=o,t=o+12|0,i[s+12>>2]=t,i[o+8>>2]=3,i[o>>2]=1,i[o+4>>2]=2;break r;case 1:o=p(28),i[s+4>>2]=o,t=o+28|0,i[s+12>>2]=t,i[o+24>>2]=i[12458],w=i[12457],i[o+16>>2]=i[12456],i[o+20>>2]=w,w=i[12455],i[o+8>>2]=i[12454],i[o+12>>2]=w,w=i[12453],i[o>>2]=i[12452],i[o+4>>2]=w;break r;case 2:o=p(4),i[s+4>>2]=o,t=o+4|0,i[s+12>>2]=t,i[o>>2]=0;break r;case 3:o=p(4),i[s+4>>2]=o,t=o+4|0,i[s+12>>2]=t,i[o>>2]=99;break r;default:break f}i[s+12>>2]=0,i[s+4>>2]=0,i[s+8>>2]=0;break e}i[s+8>>2]=t}e:{r:{f:{A:{if(o=i[s+4>>2],t=o,w=i[s+8>>2],(t|0)==(w|0))break A;for(;;){if(i[t>>2]==(k|0))break A;if(t=t+4|0,(w|0)==(t|0))break}break f}if((t|0)!=(w|0))break r}i[n>>2]=0,i[A+8>>2]=24315,i[A>>2]=5,i[A+4>>2]=2006;break e}w=p(8),t=w,i[t>>2]=0,i[t+4>>2]=0,t=p(172),i[t>>2]=94812,i[t+4>>2]=0,i[t+8>>2]=0,o0(t+16|0,0,80),o=i[t+4>>2],h=o+1|0,i[t+4>>2]=h,i[t+104>>2]=0,i[t+108>>2]=0,i[t+36>>2]=1,i[t+40>>2]=1,u[t+24|0]=1,g[t+22>>1]=2,g[t+18>>1]=2,g[t+20>>1]=2,i[t+112>>2]=0,i[t+116>>2]=4740,i[t+140>>2]=0,i[t+144>>2]=0,i[t+128>>2]=99,i[t+132>>2]=99,i[t+120>>2]=0,i[t+124>>2]=0,i[t+12>>2]=95160,i[t+148>>2]=0,i[t+152>>2]=0,i[t+136>>2]=t+140,i[t+156>>2]=0,i[t+160>>2]=0,i[t+164>>2]=0,i[t+168>>2]=0,i[t+4>>2]=o,o=i[t+8>>2],_=t+12|0,i[t+96>>2]=_,i[t+8>>2]=o+1,i[t+100>>2]=t,h||(W[i[i[t>>2]+8>>2]](t),y(t)),i[w>>2]=_,o=i[w+4>>2],i[w+4>>2]=t;r:{if(!o||(t=i[o+4>>2],i[o+4>>2]=t-1,t))break r;W[i[i[o>>2]+8>>2]](o),y(o)}t=i[w>>2],i[t+120>>2]=k,i[t+116>>2]=f,i[t+112>>2]=r,i[t+108>>2]=e,i[n>>2]=w,i[A+8>>2]=i[24058],e=i[24057],i[A>>2]=i[24056],i[A+4>>2]=e,o=i[s+4>>2]}if(!o)break i;i[s+8>>2]=o,Z(o)}v=s+16|0}function O9(A,e,r,f){var k=0,n=0,t=0,o=0,s=0,w=0,h=0,_=0,B=0;k=v-112|0,v=k,n=i[e+544>>2],W[i[i[n>>2]+92>>2]](k+88|0,n);i:{if(i[k+88>>2]){e=i[k+92>>2],i[A>>2]=i[k+88>>2],i[A+4>>2]=e,e=A+8|0;e:{if(u[k+107|0]>=0){r=i[k+100>>2],i[e>>2]=i[k+96>>2],i[e+4>>2]=r,i[e+8>>2]=i[k+104>>2];break e}T(e,i[k+96>>2],i[k+100>>2])}u[A+48|0]=1;break i}n=i[e+544>>2],W[i[i[n>>2]+60>>2]](k- -64|0,n);e:{r:switch(l[k+84|0]){default:_2(),H();case 1:e=i[k+68>>2],i[A>>2]=i[k+64>>2],i[A+4>>2]=e,e=A+8|0;f:{if(u[k+83|0]>=0){r=i[k+76>>2],i[e>>2]=i[k+72>>2],i[e+4>>2]=r,i[e+8>>2]=i[k+80>>2];break f}T(e,i[k+72>>2],i[k+76>>2])}u[A+48|0]=1;break e;case 0:break r}n=i[k+64>>2],i[k+64>>2]=0,i[k+52>>2]=n,n=i[k+68>>2],t=i[k+72>>2],i[k+68>>2]=0,i[k+72>>2]=0,i[k+56>>2]=n,i[k+60>>2]=t,Hf(k,e,k+52|0,r,f),r=i[k+4>>2],e=i[k>>2],i[k+88>>2]=e,i[k+92>>2]=r,u[k+107|0]<0&&(Z(i[k+96>>2]),e=i[k+88>>2]),r=i[k+12>>2],i[k+96>>2]=i[k+8>>2],i[k+100>>2]=r,i[k+104>>2]=i[k+16>>2];r:{if(e){e=i[k+92>>2],i[A>>2]=i[k+88>>2],i[A+4>>2]=e,e=A+8|0;f:{if(u[k+107|0]>=0){r=i[k+100>>2],i[e>>2]=i[k+96>>2],i[e+4>>2]=r,i[e+8>>2]=i[k+104>>2];break f}T(e,i[k+96>>2],i[k+100>>2])}u[A+48|0]=1;break r}i[k+40>>2]=0,i[k+32>>2]=0,i[k+36>>2]=0,u[k+8|0]=0,i[k+20>>2]=0,i[k+24>>2]=0,i[k>>2]=0,i[k+4>>2]=0,i[k+12>>2]=0,i[k+16>>2]=0,e=i[k+52>>2],r=i[k+56>>2],d4(k+12|0,e,r,r-e|0),e=i[k+20>>2],i[k+20>>2]=0,r=i[k+12>>2],f=i[k+16>>2],i[k+12>>2]=0,i[k+16>>2]=0,n=i[k>>2],t=i[k+4>>2],i[k>>2]=0,i[k+4>>2]=0,o=l[k+8|0],s=i[k+32>>2],w=i[k+36>>2],h=i[k+40>>2],_=i[k+24>>2],B=i[k+28>>2],i[A+12>>2]=r,i[A+16>>2]=f,i[A>>2]=n,i[A+4>>2]=t,i[A+40>>2]=h,i[A+32>>2]=s,i[A+36>>2]=w,i[A+24>>2]=_,i[A+28>>2]=B,u[A+48|0]=0,i[A+20>>2]=e,u[A+8|0]=o}if(A=i[k+52>>2],!A)break e;i[k+56>>2]=A,Z(A)}if(A=l[k+84|0],(A|0)==255)break i;e=i[25469],i[k>>2]=i[25468],i[k+4>>2]=e,W[i[(A<<2)+k>>2]](k+52|0,k- -64|0)}u[k+107|0]<0&&Z(i[k+96>>2]),v=k+112|0}function P9(A,e,r,f,k,n,t,o,s,w,h,_,B,m,X){var Q=0,V=0,F=0,I=0,E=0,R=0,N=0,M=0,z=0,S=0,O=0,P=0;for(R=v-16|0,v=R,i[r>>2]=A,z=f&512;;){if((N|0)==4)l[m+11|0]>>>7|0?k=i[m+4>>2]:k=l[m+11|0]&127,k>>>0>1&&(O=R,P=T4(m),i[O+12>>2]=P,O=r,P=Pt(o5(R+12|0,1),w6(m),i[r>>2]),i[O>>2]=P),f=f&176,(f|0)!=16&&((f|0)==32&&(A=i[r>>2]),i[e>>2]=A),v=R+16|0;else{i:{e:switch(l[s+N|0]){case 0:i[e>>2]=i[r>>2];break i;case 1:i[e>>2]=i[r>>2],Q=W[i[i[t>>2]+28>>2]](t,32)|0,V=i[r>>2],i[r>>2]=V+1,u[V|0]=Q;break i;case 3:if(l[m+11|0]>>>7|0?Q=i[m+4>>2]:Q=l[m+11|0]&127,!Q)break i;l[m+11|0]>>>7|0?Q=i[m>>2]:Q=m,Q=l[Q|0],V=i[r>>2],i[r>>2]=V+1,u[V|0]=Q;break i;case 2:if(l[B+11|0]>>>7|0?Q=i[B+4>>2]:Q=l[B+11|0]&127,Q=!Q,Q|!z)break i;O=r,P=Pt(T4(B),w6(B),i[r>>2]),i[O>>2]=P;break i;case 4:break e;default:break i}for(S=i[r>>2],k=k+o|0,F=k;;){e:{if(n>>>0<=F>>>0||(Q=u[F|0],(Q|0)>=0?Q=(i[i[t+8>>2]+(Q<<2)>>2]&64)!=0:Q=0,!Q))break e;F=F+1|0;continue}break}if(Q=X,(Q|0)>0){for(;;){if(!(!Q|k>>>0>=F>>>0)){Q=Q-1|0,F=F-1|0,V=l[F|0],I=i[r>>2],i[r>>2]=I+1,u[I|0]=V;continue}break}for(Q?V=W[i[i[t>>2]+28>>2]](t,48)|0:V=0;;){if(I=i[r>>2],i[r>>2]=I+1,(Q|0)>0){u[I|0]=V,Q=Q-1|0;continue}break}u[I|0]=w}e:{if((k|0)==(F|0)){Q=W[i[i[t>>2]+28>>2]](t,48)|0,V=i[r>>2],i[r>>2]=V+1,u[V|0]=Q;break e}for(l[_+11|0]>>>7|0?Q=i[_>>2]:Q=_,V=u[Q|0],l[_+11|0]>>>7|0?Q=i[_+4>>2]:Q=l[_+11|0]&127,V=Q?V:-1,Q=0,E=0;;){if((k|0)==(F|0))break e;r:{if((Q|0)!=(V|0)){I=Q;break r}if(V=i[r>>2],i[r>>2]=V+1,u[V|0]=h,I=0,l[_+11|0]>>>7|0?V=i[_+4>>2]:V=l[_+11|0]&127,E=E+1|0,V>>>0<=E>>>0){V=Q;break r}if(l[_+11|0]>>>7|0?Q=i[_>>2]:Q=_,l[Q+E|0]==127){V=-1;break r}l[_+11|0]>>>7|0?Q=i[_>>2]:Q=_,V=u[Q+E|0]}F=F-1|0,Q=l[F|0],M=i[r>>2],i[r>>2]=M+1,u[M|0]=Q,Q=I+1|0}}N6(S,i[r>>2])}N=N+1|0;continue}break}}function Tm(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,t=0,o=0,s=0;f=v-160|0,v=f,i[f+92>>2]=0,i[f+64>>2]=72500,n=i[18128],i[f+8>>2]=n,k=i[n-12>>2],n=f+8|0,i[k+n>>2]=i[18129],s=n+i[i[f+8>>2]-12>>2]|0,k=f+12|0,J0(s,k),u[s+80|0]=0,i[s+72>>2]=0,i[f+64>>2]=72500,i[f+8>>2]=72480,s=R0(k),i[s>>2]=71232,i[f+52>>2]=0,i[f+56>>2]=0,i[f+44>>2]=0,i[f+48>>2]=0,i[f+60>>2]=16,k=f+148|0,U1(k,e,r),t=n,o=k,n=u[f+159|0],k=(n|0)<0,Y(t,k?i[f+148>>2]:o,k?i[f+152>>2]:n),u[f+159|0]<0&&Z(i[f+148>>2]),n=f+148|0,s0(n,r),o=n,n=u[f+159|0],k=(n|0)<0,Y(f+8|0,k?i[f+148>>2]:o,k?i[f+152>>2]:n),u[f+159|0]<0&&Z(i[f+148>>2]),n=Y(q2(Y(f+8|0,32777,19),i[e+104>>2],i[e+108>>2]),42670,1),k=f+148|0,s0(k,r),o=k,k=u[f+159|0],t=(k|0)<0,Y(n,t?i[f+148>>2]:o,t?i[f+152>>2]:k),u[f+159|0]<0&&Z(i[f+148>>2]),n=Y(q2(Y(n,31799,19),i[e+112>>2],i[e+116>>2]),42670,1),k=f+148|0,s0(k,r),o=k,k=u[f+159|0],t=(k|0)<0,Y(n,t?i[f+148>>2]:o,t?i[f+152>>2]:k),u[f+159|0]<0&&Z(i[f+148>>2]),n=Y(V0(Y(n,31914,11),i[e+120>>2]),42670,1),k=f+148|0,s0(k,r),o=k,k=u[f+159|0],t=(k|0)<0,Y(n,t?i[f+148>>2]:o,t?i[f+152>>2]:k),u[f+159|0]<0&&Z(i[f+148>>2]),Y(q2(Y(n,30633,10),i[e+128>>2],i[e+132>>2]),42670,1),n=f+148|0,s0(n,r),k=n,r=u[f+159|0],n=(r|0)<0,Y(f+8|0,n?i[f+148>>2]:k,n?i[f+152>>2]:r),u[f+159|0]<0&&Z(i[f+148>>2]),e=e+136|0,Y(Y(Y(f+8|0,31952,10),e,h2(e)),42670,1),e=i[f+60>>2];i:{e:{if(e&16){r=i[f+56>>2],e=i[f+36>>2],r>>>0<e>>>0&&(i[f+56>>2]=e,r=e),e=f+32|0;break e}if(!(e&8)){r=0,u[A+11|0]=0;break i}r=i[f+28>>2],e=f+20|0}e:{if(n=i[e>>2],r=r-n|0,r>>>0<2147483640){if(r>>>0>=11){k=r|7,e=p(k+1|0),i[A+8>>2]=k-2147483647,i[A>>2]=e,i[A+4>>2]=r,A=e;break e}if(u[A+11|0]=r,r)break e;r=0;break i}Q0(),H()}if(!r)break i;x(A,n,r)}u[A+r|0]=0,A=i[18127],i[f+8>>2]=A,i[i[A-12>>2]+(f+8|0)>>2]=i[18130],i[s>>2]=71232,u[f+55|0]<0&&Z(i[f+44>>2]),E0(s),y0(f- -64|0),v=f+160|0}function Sm(A,e,r,f,k,n,t){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,t=t|0;var o=0,s=0,w=0,h=0,_=0,B=0;if(A=v-448|0,v=A,i[A+440>>2]=r,i[A+444>>2]=e,i[A+20>>2]=2072,w=A+20|0,h=Q1(A+24|0,A+32|0,w),o=A+16|0,e=i[k+28>>2],i[o>>2]=e,(e|0)!=129576&&(i[e+4>>2]=i[e+4>>2]+1),e=c0(o,129752),u[A+15|0]=0,L7(A+444|0,r,f,o,i[k+4>>2],n,A+15|0,e,h,w,A+432|0)){r=v-16|0,v=r;i:if(l[t+11|0]>>>7|0)break i;i:{if(l[t+11|0]>>>7|0){f=i[t>>2],i[r+12>>2]=0,i[f>>2]=i[r+12>>2],i[t+4>>2]=0;break i}i[r+8>>2]=0,i[t>>2]=i[r+8>>2],u[t+11|0]=l[t+11|0]&128,u[t+11|0]=l[t+11|0]&127}for(v=r+16|0,l[A+15|0]==1&&BA(t,W[i[i[e>>2]+44>>2]](e,45)|0),e=W[i[i[e>>2]+44>>2]](e,48)|0,r=i[h>>2],k=i[A+20>>2],f=k-4|0;;){if(!((e|0)!=i[r>>2]|r>>>0>=f>>>0)){r=r+4|0;continue}break}_=v-16|0,v=_,l[t+11|0]>>>7|0?f=i[t+4>>2]:f=l[t+11|0]&127,o=l[t+11|0]>>>7|0?(i[t+8>>2]&2147483647)-1|0:1,s=k-r>>2;i:{if(!s)break i;if(l[t+11|0]>>>7|0?e=i[t>>2]:e=t,w=e,l[t+11|0]>>>7|0?e=i[t>>2]:e=t,l[t+11|0]>>>7|0?B=i[t+4>>2]:B=l[t+11|0]&127,!fl(w,(e+(B<<2)|0)+4|0,r)){s>>>0>o-f>>>0&&st(t,o,s+(f-o|0)|0,f,f),l[t+11|0]>>>7|0?e=i[t>>2]:e=t,e=zl(r,k,e+(f<<2)|0),i[_+4>>2]=0,i[e>>2]=i[_+4>>2],z6(t,f+s|0);break i}e=v-16|0,v=e,f=_+4|0,lu(f,r,k),v=e+16|0,l[f+11|0]>>>7|0?e=i[f>>2]:e=f,o=e,w=v-16|0,v=w,l[f+11|0]>>>7|0?r=i[f+4>>2]:r=l[f+11|0]&127,e=l[t+11|0]>>>7|0?(i[t+8>>2]&2147483647)-1|0:1,l[t+11|0]>>>7|0?k=i[t+4>>2]:k=l[t+11|0]&127;e:{if(r>>>0<=e-k>>>0){if(s=!r,s)break e;l[t+11|0]>>>7|0?e=i[t>>2]:e=t,B=e+(k<<2)|0;r:{if(s||(s=r<<2,!s))break r;x(B,o,s)}r=r+k|0,z6(t,r),i[w+12>>2]=0,i[(r<<2)+e>>2]=i[w+12>>2];break e}Hn(t,e,k+(r-e|0)|0,k,k,0,r,o)}v=w+16|0,R1(f)}v=_+16|0}return K2(A+444|0,A+440|0)&&(i[n>>2]=i[n>>2]|2),r=i[A+444>>2],e2(A+16|0),e=i[h>>2],i[h>>2]=0,e&&W[i[h+4>>2]](e),v=A+448|0,r|0}function L9(A,e,r){var f=0,k=0,n=0,t=0,o=0,s=0,w=0,h=0,_=0;k=v-32|0,v=k,f=p(48),i[k+24>>2]=i[A>>2],A=i[A+4>>2],i[k+28>>2]=A,A&&(i[A+4>>2]=i[A+4>>2]+1),i[k+16>>2]=i[e>>2],A=i[e+4>>2],i[k+20>>2]=A,A&&(i[A+4>>2]=i[A+4>>2]+1),A=i[k+28>>2],i[k+8>>2]=i[k+24>>2],i[k+12>>2]=A,A=i[k+20>>2],i[k>>2]=i[k+16>>2],i[k+4>>2]=A,i[f>>2]=0,i[f+4>>2]=0,i[f+24>>2]=0,i[f+28>>2]=0,u[f+16|0]=0,i[f+8>>2]=0,i[f+12>>2]=0,h=f+32|0,A=h,i[A>>2]=0,i[A+4>>2]=0,i[f+40>>2]=0,A=i[k+8>>2],e=i[k+12>>2];i:{if(!e){i[f+4>>2]=e,i[f>>2]=A;break i}if(i[e+4>>2]=i[e+4>>2]+1,i[f>>2]=A,A=i[f+4>>2],i[f+4>>2]=e,!A||(e=i[A+4>>2],i[A+4>>2]=e-1,e))break i;W[i[i[A>>2]+8>>2]](A),y(A)}A=i[k>>2],e=i[k+4>>2],e&&(i[e+4>>2]=i[e+4>>2]+1),i[f+8>>2]=A,A=i[f+12>>2],i[f+12>>2]=e;i:{if(!A||(e=i[A+4>>2],i[A+4>>2]=e-1,e))break i;W[i[i[A>>2]+8>>2]](A),y(A)}w=i[k>>2],n=i[w+128>>2],t=i[w+132>>2],A=i[w+128>>2],t-A>>3?(e=i[A>>2],A=i[A+4>>2]):(e=0,A=0),_=i[k+8>>2],s=i[_+116>>2],t=t-n|0;i:{e:{if((t|0)==8){if(n=l[i[f>>2]+112|0],u[f+16|0]=(n|0)!=0,!n)break e;i[f+24>>2]=e,i[f+28>>2]=A;break i}u[f+16|0]=0}o=i[f+32>>2],n=i[f+36>>2]-o>>3;e:{if(n>>>0<s>>>0){ui(h,s-n|0);break e}if(n>>>0>s>>>0&&(i[f+36>>2]=o+(s<<3)),!s)break i}if(n=0,(t|0)==8){for(;;)if(r=i[h>>2]+(n<<3)|0,i[r>>2]=e,i[r+4>>2]=A,r=o3(_,n),e=e+r|0,A=r>>>0>e>>>0?A+1|0:A,n=n+1|0,(s|0)==(n|0))break i}for(t=0;u0[i[i[r>>2]+(t<<3)>>2]+20>>2]<n>>>0&&(t=t+1|0,A=i[w+128>>2],t>>>0<i[w+132>>2]-A>>3>>>0?(A=A+(t<<3)|0,e=i[A>>2],A=i[A+4>>2]):(e=0,A=0)),o=i[h>>2]+(n<<3)|0,i[o>>2]=e,i[o+4>>2]=A,o=o3(_,n),e=e+o|0,A=o>>>0>e>>>0?A+1|0:A,n=n+1|0,(s|0)!=(n|0););}A=i[k+4>>2];i:{if(!A||(e=i[A+4>>2],i[A+4>>2]=e-1,e))break i;W[i[i[A>>2]+8>>2]](A),y(A)}A=i[k+12>>2];i:{if(!A||(e=i[A+4>>2],i[A+4>>2]=e-1,e))break i;W[i[i[A>>2]+8>>2]](A),y(A)}return v=k+32|0,f}function K9(A,e,r,f,k,n){var t=0,o=0,s=0,w=0,h=0,_=0,B=0,m=0,X=0,Q=0;if(o=v-80|0,v=o,Sf(o+68|0,e,r),e=i[o+68>>2],t=ei(o+32|0,e,i[o+72>>2]-e|0),V2(t,16),V2(t,4),r=I1(t,3),X=f,Q=I1(t,1),u[X+28|0]=Q,X=f,Q=I1(t,2),u[X+1|0]=Q,X=f,Q=(I1(t,1)|0)!=0,u[X+2|0]=Q,X=f,Q=I1(t,5),u[X+3|0]=Q,X=f,Q=i2(t,32),i[X+4>>2]=Q,V2(t,16),V2(t,16),V2(t,16),X=f,Q=I1(t,8),u[X+16|0]=Q,r){w=r-1>>>5|0,h=w+1<<2,_=p(h);i:{e:{if(r>>>0>=33){i[(w<<2)+_>>2]=0,e=r>>>5|0;break e}if(i[_>>2]=0,e=1,(r|0)==32)break e;e=r>>>5|0;break i}if(s=e<<2,!s)break i;o0(_,0,s)}s=r&31,s&&(e=(e<<2)+_|0,i[e>>2]=i[e>>2]&(-1>>>32-s^-1)),h=p(h);i:{e:{if(r>>>0>=33){i[(w<<2)+h>>2]=0,e=r>>>5|0;break e}if(i[h>>2]=0,e=1,(r|0)==32)break e;e=r>>>5|0;break i}if(w=e<<2,!w)break i;o0(h,0,w)}for(s&&(e=(e<<2)+h|0,i[e>>2]=i[e>>2]&(-1>>>32-s^-1)),e=0;;){s=1<<e,B=e>>>5<<2,w=B+_|0;i:{if(i2(t,1)){m=s|i[w>>2];break i}m=i[w>>2]&(s^-1)}i[w>>2]=m,w=h+B|0;i:{if(i2(t,1)){s=s|i[w>>2];break i}s=i[w>>2]&(s^-1)}if(i[w>>2]=s,e=e+1|0,(r|0)==(e|0))break}if(r>>>0<8)for(e=r;V2(t,2),e=e+1|0,(e|0)!=8;);for(e=0;w=1<<e,s=e>>>5<<2,w&i[s+_>>2]&&(V2(t,8),V2(t,32),V2(t,16)),w&i[s+h>>2]&&V2(t,8),e=e+1|0,(r|0)!=(e|0););}$2(t,o+28|0),$2(t,o+24|0),e=i[o+24>>2],u[f+21|0]=e,(e&255)==3&&V2(t,1),$2(t,k),$2(t,n),i2(t,1)&&($2(t,o+20|0),$2(t,o+16|0),$2(t,o+12|0),$2(t,o+8|0),e=l[f+21|0],i[k>>2]=i[k>>2]-(i[o+16>>2]+i[o+20>>2]<<((e-1&255)>>>0<2)),i[n>>2]=i[n>>2]-(i[o+8>>2]+i[o+12>>2]<<((e|0)==1))),e=o+24|0,$2(t,e),u[f+22|0]=l[o+24|0]+8,$2(t,e),e=l[o+24|0],i[f+24>>2]=16777216,u[f+20|0]=0,g[f+18>>1]=0,u[f|0]=1,u[f+23|0]=e+8,e=i[26917],i[A>>2]=i[26916],i[A+4>>2]=e,A=A+8|0;i:{if(u[107683]>=0){e=i[26919],i[A>>2]=i[26918],i[A+4>>2]=e,i[A+8>>2]=i[26920];break i}T(A,i[26918],i[26919])}h&&Z(h),_&&Z(_),A=i[o+68>>2],A&&(i[o+72>>2]=A,Z(A)),v=o+80|0}function q9(A){A=A|0;var e=0,r=0,f=0,k=0,n=0,t=0,o=0,s=0,w=0;f=i[i[A>>2]+116>>2],e=v-112|0,v=e,n=i[A+8>>2],k=i[n+20>>2];i:{if(!k){k=0;break i}for(o=n+20|0,A=o;t=f>>>0>u0[k+16>>2],A=t?A:k,k=i[(t?4:0)+k>>2],!!k;);if(k=0,(A|0)==(o|0)|f>>>0<u0[A+16>>2])break i;r=i[A+20>>2],t=i[A+24>>2],t&&(i[t+4>>2]=i[t+4>>2]+1),k=1;e:{if(i[r+148>>2]||W[i[i[r>>2]+84>>2]](r)|0)break e;W[i[i[r>>2]+76>>2]](e+80|0,r,e+108|0,e+104|0),k=0;r:{if(i[e+80>>2]||(A=i[e+104>>2],A>>>0<=15&&(k=1,1<<A&43008))||(k=0,(J6(i[n+48>>2],f)|0)!=1735551332))break r;if(r=e+56|0,a6(r,i[n+48>>2],f),A=l[e+76|0],!A){if(i[e+48>>2]=0,i[e+40>>2]=0,i[e+44>>2]=0,s9(e+16|0,e+40|0,r),r=i[e+20>>2],A=i[e+16>>2],i[e+80>>2]=A,i[e+84>>2]=r,u[e+99|0]<0&&(Z(i[e+88>>2]),A=i[e+80>>2]),r=i[e+28>>2],i[e+88>>2]=i[e+24>>2],i[e+92>>2]=r,i[e+96>>2]=i[e+32>>2],!A){A=i[n+48>>2],r=i[A+84>>2],i[e+8>>2]=r,A=i[A+88>>2],i[e+12>>2]=A,A&&(i[A+4>>2]=i[A+4>>2]+1);f:{if(!r)break f;P8(e+16|0,r,f,1684630887),r=i[e+20>>2],f=i[e+16>>2];A:{if((G(C[e+42>>1],C[e+40>>1])|0)!=r-f>>2|(r|0)==(f|0))break A;for(A=f;;){if(!go(n,i[A>>2]))break A;if(A=A+4|0,(r|0)==(A|0))break}for(;;){k:{if(A=i[o>>2],!A){k=0;break k}for(s=i[f>>2],n=o;w=s>>>0>u0[A+16>>2],n=w?n:A,A=i[(w?4:0)+A>>2],!!A;);if((n|0)==(o|0)){k=0;break k}if(s>>>0<u0[n+16>>2]){k=0;break k}if(s=i[n+20>>2],i[e>>2]=s,A=i[n+24>>2],i[e+4>>2]=A,A&&(i[A+4>>2]=i[A+4>>2]+1),k=i[s+148>>2]!=0|k,I2(e),f=f+4|0,(r|0)!=(f|0))continue}break}f=i[e+16>>2]}if(!f)break f;i[e+20>>2]=f,Z(f)}I2(e+8|0)}A=l[e+76|0]}if(A=A&255,(A|0)==255)break r;f=i[23591],i[e+16>>2]=i[23590],i[e+20>>2]=f,W[i[(e+16|0)+(A<<2)>>2]](e+40|0,e+56|0)}if(u[e+99|0]>=0)break e;Z(i[e+88>>2])}if(!t||(A=i[t+4>>2],i[t+4>>2]=A-1,A))break i;W[i[i[t>>2]+8>>2]](t),y(t)}return v=e+112|0,k&1}function jm(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0;var k=0,n=0,t=0,o=0,s=0,w=0;f=v-32|0,v=f,z2(f,e,r),u[f+19|0]<0&&Z(i[f+8>>2]),k=l[e+97|0];i:{if(k>>>0>=2){t1(A,e,15912);break i}e:{if((k|0)==1){s=e,w=Y4(r),i[s+104>>2]=w,i[e+108>>2]=l0,s=e,w=Y4(r),i[s+112>>2]=w,i[e+116>>2]=l0,s=e,w=C0(r),i[s+120>>2]=w,k=i[r+16>>2],k=k>>>0>=4?4:k,n=i[r+8>>2],n&&c1(n,k),n=i[r>>2],t=W[i[i[n>>2]+8>>2]](n)|0,o=l0,t=k+t|0,o=t>>>0<k>>>0?o+1|0:o,W[i[i[n>>2]+20>>2]](n,t,o)|0,i[r+16>>2]=i[r+16>>2]-k,k=Y4(r),n=l0;break e}s=e,w=C0(r),i[s+104>>2]=w,i[e+108>>2]=0,s=e,w=C0(r),i[s+112>>2]=w,i[e+116>>2]=0,s=e,w=C0(r),i[s+120>>2]=w,k=i[r+16>>2],k=k>>>0>=4?4:k,n=i[r+8>>2],n&&c1(n,k),n=i[r>>2],t=W[i[i[n>>2]+8>>2]](n)|0,o=l0,t=k+t|0,o=t>>>0<k>>>0?o+1|0:o,W[i[i[n>>2]+20>>2]](n,t,o)|0,i[r+16>>2]=i[r+16>>2]-k,k=C0(r),n=0}if(i[e+128>>2]=k,i[e+132>>2]=n,k=i[r+16>>2],k=k>>>0>=8?8:k,n=i[r+8>>2],n&&c1(n,k),n=i[r>>2],t=W[i[i[n>>2]+8>>2]](n)|0,o=l0,t=k+t|0,o=t>>>0<k>>>0?o+1|0:o,W[i[i[n>>2]+20>>2]](n,t,o)|0,i[r+16>>2]=i[r+16>>2]-k,s=e,w=o2(r),g[s+136>>1]=w,s=e,w=o2(r),g[s+138>>1]=w,s=e,w=o2(r),g[s+140>>1]=w,k=i[r+16>>2],k=k>>>0>=2?2:k,n=i[r+8>>2],n&&c1(n,k),n=i[r>>2],t=W[i[i[n>>2]+8>>2]](n)|0,o=l0,t=k+t|0,o=t>>>0<k>>>0?o+1|0:o,W[i[i[n>>2]+20>>2]](n,t,o)|0,i[r+16>>2]=i[r+16>>2]-k,s=e,w=C0(r),i[s+144>>2]=w,s=e,w=C0(r),i[s+148>>2]=w,s=e,w=C0(r),i[s+152>>2]=w,s=e,w=C0(r),i[s+156>>2]=w,s=e,w=C0(r),i[s+160>>2]=w,s=e,w=C0(r),i[s+164>>2]=w,s=e,w=C0(r),i[s+168>>2]=w,s=e,w=C0(r),i[s+172>>2]=w,s=e,w=C0(r),i[s+176>>2]=w,s=e,w=C0(r),i[s+180>>2]=w,s=e,w=C0(r),i[s+184>>2]=w,l[r+20|0]==1){if(u[f+20|0]=0,u[f+31|0]=0,q(A,2,100,f+20|0),u[f+31|0]>=0)break i;Z(i[f+20>>2]);break i}if(e=i[26917],i[A>>2]=i[26916],i[A+4>>2]=e,A=A+8|0,u[107683]>=0){e=i[26919],i[A>>2]=i[26918],i[A+4>>2]=e,i[A+8>>2]=i[26920];break i}T(A,i[26918],i[26919])}v=f+32|0}function Om(A,e,r,f,k,n,t,o,s){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,t=t|0,o=o|0,s=s|0;var w=0,h=0,_=0,B=0,m=0,X=0,Q=0;h=v-32|0,v=h;i:{e:{r:{if(!(!e|!n)&&(_=(f|0)!=1970628964,k|_))break r;e=i[23570],i[A>>2]=i[23569],i[A+4>>2]=e,i[A+8>>2]=i[23571];break e}w=p(128),i[w+4>>2]=0,i[w+8>>2]=0,i[w>>2]=92524,B=w+16|0,i[B+8>>2]=0,i[B+12>>2]=0,i[B+16>>2]=0,i[B+20>>2]=0,i[B+24>>2]=0,i[B+28>>2]=0,i[B+32>>2]=0,i[B>>2]=86356,i[w+60>>2]=0,i[w+64>>2]=0,i[w+52>>2]=0,i[w+56>>2]=0,i[w+72>>2]=-1,i[w+76>>2]=-1,i[w+80>>2]=-1,i[w+84>>2]=-1,i[w+88>>2]=0,i[w+92>>2]=0,i[w+96>>2]=0,i[w+100>>2]=0,i[w+104>>2]=0,i[w+108>>2]=0,u[w+112|0]=0,i[B>>2]=86724,i[w+124>>2]=0,i[w+116>>2]=0,i[w+120>>2]=0,i[w+32>>2]=f;r:{if(_||(f=p(16),i[h+20>>2]=f,Q=f+16|0,i[h+28>>2]=Q,_=l[k+12|0]|l[k+13|0]<<8|(l[k+14|0]<<16|l[k+15|0]<<24),m=l[k+8|0]|l[k+9|0]<<8|(l[k+10|0]<<16|l[k+11|0]<<24),u[f+8|0]=m,u[f+9|0]=m>>>8,u[f+10|0]=m>>>16,u[f+11|0]=m>>>24,u[f+12|0]=_,u[f+13|0]=_>>>8,u[f+14|0]=_>>>16,u[f+15|0]=_>>>24,_=l[k+4|0]|l[k+5|0]<<8|(l[k+6|0]<<16|l[k+7|0]<<24),k=l[k|0]|l[k+1|0]<<8|(l[k+2|0]<<16|l[k+3|0]<<24),u[f|0]=k,u[f+1|0]=k>>>8,u[f+2|0]=k>>>16,u[f+3|0]=k>>>24,u[f+4|0]=_,u[f+5|0]=_>>>8,u[f+6|0]=_>>>16,u[f+7|0]=_>>>24,i[h+24>>2]=Q,i[B+16>>2]=1970628964,f=B+20|0,(f|0)!=(h+20|0)&&(_=f,f=i[h+20>>2],k=i[h+24>>2],d4(_,f,k,k-f|0)),f=i[h+20>>2],!f))break r;i[h+24>>2]=f,Z(f)}if(i[h+28>>2]=0,i[h+20>>2]=0,i[h+24>>2]=0,f=0,t){if((t|0)<0)break i;f=p(t),i[h+20>>2]=f,X=f+t|0,i[h+28>>2]=X,t&&x(f,n,t),i[h+24>>2]=X}if(d4(w+116|0,f,X,X-f|0),e=i[e>>2],i[h+16>>2]=w,i[h+12>>2]=B,i[w+4>>2]=i[w+4>>2]+1,k=i[h+16>>2],i[h>>2]=i[h+12>>2],i[h+4>>2]=k,e=re(e,r,h,(o|0)!=0),s&&(i[s>>2]=e),e=i[24057],i[A>>2]=i[24056],i[A+4>>2]=e,i[A+8>>2]=i[24058],f&&Z(f),A=i[w+4>>2],i[w+4>>2]=A-1,A)break e;W[i[i[w>>2]+8>>2]](w),y(w)}v=h+32|0;return}G0(),H()}function Pm(A){A=A|0;var e=0,r=0,f=0,k=0,n=0;if(f=A+16|0,r=i[f+16>>2],k=f+20|0,(r|0)!=(k|0))for(;;){e=i[r+20>>2],A=i[r+24>>2];i:{if(!A){rt(e);break i}if(i[A+4>>2]=i[A+4>>2]+1,rt(e),e=i[A+4>>2],i[A+4>>2]=e-1,e)break i;W[i[i[A>>2]+8>>2]](A),y(A)}A=i[r+4>>2];i:{if(A){for(;;)if(e=A,A=i[A>>2],!A)break i}for(;e=i[r+8>>2],A=i[e>>2]!=(r|0),r=e,!!A;);}if(r=e,(k|0)==(e|0))break}if(k3(f+180|0,i[f+184>>2]),r=i[f+168>>2],r){if(A=r,e=i[f+172>>2],(A|0)!=(e|0)){for(;;){A=i[e-4>>2];i:{if(!A||(k=i[A+4>>2],i[A+4>>2]=k-1,k))break i;W[i[i[A>>2]+8>>2]](A),y(A)}if(e=e-8|0,(r|0)==(e|0))break}A=i[f+168>>2]}i[f+172>>2]=r,Z(A)}if(r=i[f+156>>2],r){if(A=r,e=i[f+160>>2],(A|0)!=(e|0)){for(;;){A=i[e-4>>2];i:{if(!A||(k=i[A+4>>2],i[A+4>>2]=k-1,k))break i;W[i[i[A>>2]+8>>2]](A),y(A)}if(e=e-8|0,(r|0)==(e|0))break}A=i[f+156>>2]}i[f+160>>2]=r,Z(A)}l[107752]||(u[107752]=1),k=i[26940];i:{if(!k)break i;for(r=107760,e=i[f+152>>2],A=k;n=e>>>0>u0[A+16>>2],r=n?r:A,A=i[(n?4:0)+A>>2],!!A;);if((r|0)==107760|e>>>0<u0[r+16>>2])break i;e=i[r+4>>2];e:{if(!e){for(e=r;A=i[e+8>>2],n=i[A>>2]!=(e|0),e=A,!!n;);break e}for(;A=e,e=i[A>>2],!!e;);}i[26939]==(r|0)&&(i[26939]=A),i[26941]=i[26941]-1,yf(k,r),Z(r)}A=i[f+52>>2];i:{if(!A||(e=i[A+4>>2],i[A+4>>2]=e-1,e))break i;W[i[i[A>>2]+8>>2]](A),y(A)}A=i[f+44>>2];i:{if(!A||(e=i[A+4>>2],i[A+4>>2]=e-1,e))break i;W[i[i[A>>2]+8>>2]](A),y(A)}if(r=i[f+28>>2],r){if(A=r,e=i[f+32>>2],(A|0)!=(e|0)){for(;;){A=i[e-4>>2];i:{if(!A||(k=i[A+4>>2],i[A+4>>2]=k-1,k))break i;W[i[i[A>>2]+8>>2]](A),y(A)}if(e=e-8|0,(r|0)==(e|0))break}A=i[f+28>>2]}i[f+32>>2]=r,Z(A)}Ce(f+16|0,i[f+20>>2]),u[f+11|0]<0&&Z(i[f>>2])}function Lm(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,t=0,o=0,s=0,w=0,h=0;if(f=v-160|0,v=f,i[f+92>>2]=0,i[f+64>>2]=72500,k=i[18128],i[f+8>>2]=k,t=i[k-12>>2],k=f+8|0,i[t+k>>2]=i[18129],o=k+i[i[f+8>>2]-12>>2]|0,n=f+12|0,J0(o,n),u[o+80|0]=0,i[o+72>>2]=0,i[f+64>>2]=72500,i[f+8>>2]=72480,o=R0(n),i[o>>2]=71232,i[f+52>>2]=0,i[f+56>>2]=0,i[f+44>>2]=0,i[f+48>>2]=0,i[f+60>>2]=16,n=f+148|0,kn(n,e,r),s=k,t=n,k=u[f+159|0],n=(k|0)<0,Y(s,n?i[f+148>>2]:t,n?i[f+152>>2]:k),u[f+159|0]<0&&Z(i[f+148>>2]),k=f+148|0,s0(k,r),t=k,k=u[f+159|0],n=(k|0)<0,Y(f+8|0,n?i[f+148>>2]:t,n?i[f+152>>2]:k),u[f+159|0]<0&&Z(i[f+148>>2]),Y(V0(Y(V0(Y(f+8|0,31300,11),C[e+120>>1]),2998,1),C[e+122>>1]),42670,1),k=i[e+124>>2],h=i[e+128>>2],(k|0)!=(h|0))for(e=0;n=f+148|0,s0(n,r),s=n,n=u[f+159|0],t=(n|0)<0,Y(f+8|0,t?i[f+148>>2]:s,t?i[f+152>>2]:n),u[f+159|0]<0&&Z(i[f+148>>2]),n=Y(S0(Y(f+8|0,27796,6),e),41777,2),t=f+148|0,s0(t,r),s=t,t=u[f+159|0],w=(t|0)<0,Y(n,w?i[f+148>>2]:s,w?i[f+152>>2]:t),u[f+159|0]<0&&Z(i[f+148>>2]),n=Y(V0(Y(n,31034,11),C[k>>1]),42670,1),t=f+148|0,s0(t,r),s=t,t=u[f+159|0],w=(t|0)<0,Y(n,w?i[f+148>>2]:s,w?i[f+152>>2]:t),u[f+159|0]<0&&Z(i[f+148>>2]),Y(S0(Y(S0(Y(n,30124,9),C[k+2>>1]+1|0),2998,1),C[k+4>>1]+1|0),42670,1),e=e+1|0,k=k+6|0,(h|0)!=(k|0););e=i[f+60>>2];i:{e:{if(e&16){k=i[f+56>>2],e=i[f+36>>2],k>>>0<e>>>0&&(i[f+56>>2]=e,k=e),e=f+32|0;break e}if(!(e&8)){k=0,u[A+11|0]=0;break i}k=i[f+28>>2],e=f+20|0}e:{if(r=i[e>>2],k=k-r|0,k>>>0<2147483640){if(k>>>0>=11){n=k|7,e=p(n+1|0),i[A+8>>2]=n-2147483647,i[A>>2]=e,i[A+4>>2]=k,A=e;break e}if(u[A+11|0]=k,k)break e;k=0;break i}Q0(),H()}if(!k)break i;x(A,r,k)}u[A+k|0]=0,A=i[18127],i[f+8>>2]=A,i[i[A-12>>2]+(f+8|0)>>2]=i[18130],i[o>>2]=71232,u[f+55|0]<0&&Z(i[f+44>>2]),E0(o),y0(f- -64|0),v=f+160|0}function Km(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,t=0,o=0,s=0,w=0,h=0;if(f=v-160|0,v=f,i[f+92>>2]=0,i[f+64>>2]=72500,t=i[18128],i[f+8>>2]=t,k=i[t-12>>2],t=f+8|0,i[k+t>>2]=i[18129],s=t+i[i[f+8>>2]-12>>2]|0,k=f+12|0,J0(s,k),u[s+80|0]=0,i[s+72>>2]=0,i[f+64>>2]=72500,i[f+8>>2]=72480,s=R0(k),i[s>>2]=71232,i[f+52>>2]=0,i[f+56>>2]=0,i[f+44>>2]=0,i[f+48>>2]=0,i[f+60>>2]=16,k=f+148|0,U1(k,e,r),n=t,o=k,t=u[f+159|0],k=(t|0)<0,Y(n,k?i[f+148>>2]:o,k?i[f+152>>2]:t),u[f+159|0]<0&&Z(i[f+148>>2]),i[e+108>>2]!=i[e+104>>2])for(t=0;k=f+148|0,s0(k,r),n=k,k=u[f+159|0],o=(k|0)<0,Y(f+8|0,o?i[f+148>>2]:n,o?i[f+152>>2]:k),u[f+159|0]<0&&Z(i[f+148>>2]),k=Y(V0(Y(f+8|0,19205,1),t),41694,2),o=f+148|0,s0(o,r),w=o,o=u[f+159|0],n=(o|0)<0,Y(k,n?i[f+148>>2]:w,n?i[f+152>>2]:o),u[f+159|0]<0&&Z(i[f+148>>2]),n=Y(k,30906,15),k=G(t,12),o=Y(V0(n,i[k+i[e+104>>2]>>2]),42670,1),n=f+148|0,s0(n,r),w=n,n=u[f+159|0],h=(n|0)<0,Y(o,h?i[f+148>>2]:w,h?i[f+152>>2]:n),u[f+159|0]<0&&Z(i[f+148>>2]),o=Y(V0(Y(o,30922,21),i[(k+i[e+104>>2]|0)+4>>2]),42670,1),n=f+148|0,s0(n,r),w=n,n=u[f+159|0],h=(n|0)<0,Y(o,h?i[f+148>>2]:w,h?i[f+152>>2]:n),u[f+159|0]<0&&Z(i[f+148>>2]),Y(V0(Y(o,29481,28),i[(k+i[e+104>>2]|0)+8>>2]),42670,1),t=t+1|0,t>>>0<(i[e+108>>2]-i[e+104>>2]|0)/12>>>0;);e=i[f+60>>2];i:{e:{if(e&16){e=i[f+56>>2],r=i[f+36>>2],e>>>0<r>>>0&&(i[f+56>>2]=r,e=r),r=f+32|0;break e}if(!(e&8)){e=0,u[A+11|0]=0;break i}e=i[f+28>>2],r=f+20|0}e:{if(t=i[r>>2],e=e-t|0,e>>>0<2147483640){if(e>>>0>=11){k=e|7,r=p(k+1|0),i[A+8>>2]=k-2147483647,i[A>>2]=r,i[A+4>>2]=e,A=r;break e}if(u[A+11|0]=e,e)break e;e=0;break i}Q0(),H()}if(!e)break i;x(A,t,e)}u[A+e|0]=0,A=i[18127],i[f+8>>2]=A,i[i[A-12>>2]+(f+8|0)>>2]=i[18130],i[s>>2]=71232,u[f+55|0]<0&&Z(i[f+44>>2]),E0(s),y0(f- -64|0),v=f+160|0}function qm(A,e,r,f,k,n,t,o,s){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,t=t|0,o=o|0,s=s|0;var w=0,h=0,_=0,B=0,m=0,X=0,Q=0,V=0,F=0;A=v-1056|0,v=A,i[A+16>>2]=n,i[A+20>>2]=t,i[A+24>>2]=o,i[A+28>>2]=s,w=A+944|0,i[A+940>>2]=w,w=a8(w,100,11378,A+16|0),i[A+528>>2]=2071,h=A+528|0,m=Q1(A+520|0,0,h),i[A+528>>2]=2071,_=Q1(A+512|0,0,h);i:{if(w>>>0>=100&&(w=a2(),i[A>>2]=n,i[A+4>>2]=t,i[A+8>>2]=o,i[A+12>>2]=s,w=I8(A+940|0,w,11378,A),(w|0)==-1||(n=i[m>>2],i[m>>2]=i[A+940>>2],n&&W[i[m+4>>2]](n),t=y2(w<<2),n=i[_>>2],i[_>>2]=t,n&&W[i[_+4>>2]](n),h=i[_>>2],!h)))break i;t=A+508|0,n=i[f+28>>2],i[t>>2]=n,(n|0)!=129576&&(i[n+4>>2]=i[n+4>>2]+1),F=c0(t,129752),n=F,t=i[A+940>>2],W[i[i[n>>2]+48>>2]](n,t,t+w|0,h)|0,V=(w|0)>0?l[i[A+940>>2]]==45:V,t=v-16|0,v=t,n=A+484|0,i[n>>2]=0,i[n+4>>2]=0,i[n+8>>2]=0,v=t+16|0,t=v-16|0,v=t,o=A+472|0,i[o>>2]=0,i[o+4>>2]=0,i[o+8>>2]=0,v=t+16|0,t=v-16|0,v=t,s=A+460|0,i[s>>2]=0,i[s+4>>2]=0,i[s+8>>2]=0,v=t+16|0,Zt(r,V,A+508|0,A+504|0,A+500|0,A+496|0,n,o,s,A+456|0),i[A+48>>2]=2071,r=A+48|0,B=Q1(A+40|0,0,r),t=i[A+456>>2];e:{if((t|0)<(w|0)){l[o+11|0]>>>7|0?X=i[o+4>>2]:X=l[o+11|0]&127,l[s+11|0]>>>7|0?Q=i[s+4>>2]:Q=l[s+11|0]&127,t=(t+(X+(Q+(w-t<<1)|0)|0)|0)+1|0;break e}Q=i[A+456>>2],l[s+11|0]>>>7|0?t=i[s+4>>2]:t=l[s+11|0]&127,l[o+11|0]>>>7|0?X=i[o+4>>2]:X=l[o+11|0]&127,t=(Q+(t+X|0)|0)+2|0}if(t>>>0>=101&&(t=y2(t<<2),r=i[B>>2],i[B>>2]=t,r&&W[i[B+4>>2]](r),r=i[B>>2],!r))break i;return T9(r,A+36|0,A+32|0,i[f+4>>2],h,(w<<2)+h|0,F,V,A+504|0,i[A+500>>2],i[A+496>>2],n,o,s,i[A+456>>2]),r=j8(e,r,i[A+36>>2],i[A+32>>2],f,k),e=i[B>>2],i[B>>2]=0,e&&W[i[B+4>>2]](e),R1(s),R1(o),s2(n),e2(A+508|0),e=i[_>>2],i[_>>2]=0,e&&W[i[_+4>>2]](e),e=i[m>>2],i[m>>2]=0,e&&W[i[m+4>>2]](e),v=A+1056|0,r|0}g1(),H()}function am(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,t=0,o=0,s=0,w=0;if(f=v-160|0,v=f,i[f+92>>2]=0,i[f+64>>2]=72500,t=i[18128],i[f+8>>2]=t,n=f+8|0,i[n+i[t-12>>2]>>2]=i[18129],t=n+i[i[f+8>>2]-12>>2]|0,k=f+12|0,J0(t,k),u[t+80|0]=0,i[t+72>>2]=0,i[f+64>>2]=72500,i[f+8>>2]=72480,t=R0(k),i[t>>2]=71232,i[f+52>>2]=0,i[f+56>>2]=0,i[f+44>>2]=0,i[f+48>>2]=0,i[f+60>>2]=16,k=f+148|0,Y2(k,e,r),o=n,s=k,n=u[f+159|0],k=(n|0)<0,Y(o,k?i[f+148>>2]:s,k?i[f+152>>2]:n),u[f+159|0]<0&&Z(i[f+148>>2]),n=f+148|0,s0(n,r),o=n,n=u[f+159|0],k=(n|0)<0,Y(f+8|0,k?i[f+148>>2]:o,k?i[f+152>>2]:n),u[f+159|0]<0&&Z(i[f+148>>2]),o=Y(f+8|0,31717,10),n=u[e+115|0],k=(n|0)<0,n=Y(Y(o,k?i[e+104>>2]:e+104|0,k?i[e+108>>2]:n),42670,1),k=f+148|0,s0(k,r),o=k,r=u[f+159|0],k=(r|0)<0,Y(n,k?i[f+148>>2]:o,k?i[f+152>>2]:r),u[f+159|0]<0&&Z(i[f+148>>2]),Y(n,30093,14),n=f+20|0,r=i[e+116>>2],s=i[e+120>>2],(r|0)!=(s|0))for(;w=l[r|0],e=i[f+8>>2]-12|0,k=t+i[e>>2]|0,i[k>>2]=i[k>>2]&-75|8,i[i[e>>2]+n>>2]=2,e=i[e>>2]+(f+8|0)|0,l[e+80|0]||(o=f+148|0,k=i[e+28>>2],i[o>>2]=k,(k|0)!=129576&&(i[k+4>>2]=i[k+4>>2]+1),k=c0(o,129760),W[i[i[k>>2]+28>>2]](k,32)|0,e2(o)),u[e+76|0]=48,u[e+77|0]=0,u[e+78|0]=0,u[e+79|0]=0,u[e+80|0]=1,Y(S0(f+8|0,w),32808,1),r=r+1|0,(s|0)!=(r|0););Y(f+8|0,42670,1),e=i[f+60>>2];i:{e:{if(e&16){n=f+32|0,r=i[f+56>>2],e=i[f+36>>2],r>>>0<e>>>0?i[f+56>>2]=e:e=r;break e}if(!(e&8)){e=0,u[A+11|0]=0;break i}e=i[f+28>>2]}e:{if(n=i[n>>2],e=e-n|0,e>>>0<2147483640){if(e>>>0>=11){k=e|7,r=p(k+1|0),i[A+8>>2]=k-2147483647,i[A>>2]=r,i[A+4>>2]=e,A=r;break e}if(u[A+11|0]=e,e)break e;e=0;break i}Q0(),H()}if(!e)break i;x(A,n,e)}u[A+e|0]=0,A=i[18127],i[f+8>>2]=A,i[i[A-12>>2]+(f+8|0)>>2]=i[18130],i[t>>2]=71232,u[f+55|0]<0&&Z(i[f+44>>2]),E0(t),y0(f- -64|0),v=f+160|0}function $m(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0;var k=0,n=0,t=0,o=0,s=0,w=0,h=0,_=0,B=0;k=v-144|0,v=k,O9(k+80|0,e,0,0);i:{e:switch(l[k+128|0]){default:_2(),H();case 1:if(e=i[k+84>>2],i[A>>2]=i[k+80>>2],i[A+4>>2]=e,e=A+8|0,u[k+99|0]>=0){A=i[k+92>>2],i[e>>2]=i[k+88>>2],i[e+4>>2]=A,i[e+8>>2]=i[k+96>>2];break i}T(e,i[k+88>>2],i[k+92>>2]);break i;case 0:break e}t=i[e+552>>2],i[k+72>>2]=i[k+120>>2],n=i[k+116>>2],o=k- -64|0,i[o>>2]=i[k+112>>2],i[o+4>>2]=n,n=i[k+108>>2],i[k+56>>2]=i[k+104>>2],i[k+60>>2]=n,w=i[k+84>>2],i[k+84>>2]=0,n=i[k+80>>2],i[k+80>>2]=0,h=i[k+92>>2],_=i[k+96>>2],i[k+92>>2]=0,i[k+96>>2]=0,B=i[k+100>>2],i[k+100>>2]=0,o=l[k+88|0],i[t+8>>2]=n,s=i[t+12>>2],i[t+12>>2]=w;e:{if(!s||(n=i[s+4>>2],i[s+4>>2]=n-1,n))break e;W[i[i[s>>2]+8>>2]](s),y(s)}u[t+16|0]=o,n=i[t+20>>2],n&&(i[t+24>>2]=n,Z(n)),i[t+28>>2]=B,i[t+24>>2]=_,i[t+20>>2]=h,n=i[k+60>>2],i[t+32>>2]=i[k+56>>2],i[t+36>>2]=n,o=k- -64|0,n=i[o+4>>2],i[t+40>>2]=i[o>>2],i[t+44>>2]=n,i[t+48>>2]=i[k+72>>2],n=i[e+552>>2],W[i[i[n>>2]+20>>2]](k+32|0,n,r,f);e:{if(i[k+32>>2]){e=i[k+36>>2],i[A>>2]=i[k+32>>2],i[A+4>>2]=e,i[A+16>>2]=i[k+48>>2],e=i[k+44>>2],i[A+8>>2]=i[k+40>>2],i[A+12>>2]=e,i[k+48>>2]=0,i[k+40>>2]=0,i[k+44>>2]=0;break e}n=k+12|0,i[r>>2]|C[e+10>>1]||(i[r>>2]=1,i[f>>2]=3),e=i[26917],i[n>>2]=i[26916],i[n+4>>2]=e,r=n+8|0;r:{if(u[107683]>=0){e=i[26919],i[r>>2]=i[26918],i[r+4>>2]=e,i[r+8>>2]=i[26920];break r}T(r,i[26918],i[26919])}if(u[k+31|0]<0&&Z(i[k+20>>2]),e=i[26917],i[A>>2]=i[26916],i[A+4>>2]=e,e=A+8|0,u[107683]>=0){A=i[26919],i[e>>2]=i[26918],i[e+4>>2]=A,i[e+8>>2]=i[26920];break e}T(e,i[26918],i[26919])}if(u[k+51|0]>=0)break i;Z(i[k+40>>2])}e=l[k+128|0],(e|0)!=255&&(A=i[25471],i[k+32>>2]=i[25470],i[k+36>>2]=A,W[i[(k+32|0)+(e<<2)>>2]](k+143|0,k+80|0)),v=k+144|0}function a9(A,e,r){var f=0,k=0,n=0,t=0,o=0,s=0;k=v-32|0,v=k,f=180,t=1;i:{e:{r:f:{A:switch(r-2|0){case 2:t=0;break e;case 3:f=270,o=1;break r;case 4:f=270;break f;case 5:f=270,t=0,o=1;break r;case 0:break e;case 1:break r;case 6:break A;default:break i}f=90}r=p(120),i[r+4>>2]=0,i[r+8>>2]=0,i[r>>2]=90204,n=r+16|0,i[n+8>>2]=0,i[n+12>>2]=0,i[n+16>>2]=0,i[n+20>>2]=0,i[n+24>>2]=0,i[n+28>>2]=0,i[n+32>>2]=0,i[n>>2]=86356,i[r+60>>2]=0,i[r+64>>2]=0,i[r+52>>2]=0,i[r+56>>2]=0,i[r+72>>2]=-1,i[r+76>>2]=-1,i[r+80>>2]=-1,i[r+84>>2]=-1,i[r+88>>2]=0,i[r+92>>2]=0,i[r+96>>2]=0,i[r+100>>2]=0,i[r+104>>2]=0,i[r+108>>2]=0,u[r+112|0]=0,i[n>>2]=87832,i[r+116>>2]=f,i[r+32>>2]=1769107316,f=i[A+52>>2],i[k+28>>2]=r,i[k+24>>2]=n,i[r+4>>2]=i[r+4>>2]+1,n=R6(f,k+24|0),f=i[k+28>>2];r:{if(!f||(s=i[f+4>>2],i[f+4>>2]=s-1,s))break r;W[i[i[f>>2]+8>>2]](f),y(f)}if(f=i[A+60>>2],u[k+20|0]=1,g[k+22>>1]=n+1,i[k+12>>2]=C[k+20>>1]|C[k+22>>1]<<16,C6(f,e,k+12|0),f=i[r+4>>2],i[r+4>>2]=f-1,f||(W[i[i[r>>2]+8>>2]](r),y(r)),!o)break i}r=p(120),i[r+4>>2]=0,i[r+8>>2]=0,i[r>>2]=90244,f=r+16|0,i[f+8>>2]=0,i[f+12>>2]=0,i[f+16>>2]=0,i[f+20>>2]=0,i[f+24>>2]=0,i[f+28>>2]=0,i[f+32>>2]=0,i[f>>2]=86356,i[r+60>>2]=0,i[r+64>>2]=0,i[r+52>>2]=0,i[r+56>>2]=0,i[r+72>>2]=-1,i[r+76>>2]=-1,i[r+80>>2]=-1,i[r+84>>2]=-1,i[r+88>>2]=0,i[r+92>>2]=0,i[r+96>>2]=0,i[r+100>>2]=0,i[r+104>>2]=0,i[r+108>>2]=0,u[r+112|0]=0,i[f>>2]=87912,i[r+116>>2]=t,i[r+32>>2]=1768778098,n=i[A+52>>2],i[k+28>>2]=r,i[k+24>>2]=f,i[r+4>>2]=i[r+4>>2]+1,n=R6(n,k+24|0),f=i[k+28>>2];e:{if(!f||(t=i[f+4>>2],i[f+4>>2]=t-1,t))break e;W[i[i[f>>2]+8>>2]](f),y(f)}if(A=i[A+60>>2],u[k+16|0]=1,g[k+18>>1]=n+1,i[k+8>>2]=C[k+16>>1]|C[k+18>>1]<<16,C6(A,e,k+8|0),A=i[r+4>>2],i[r+4>>2]=A-1,A)break i;W[i[i[r>>2]+8>>2]](r),y(r)}v=k+32|0}function dm(A,e,r,f,k,n,t,o,s){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,t=t|0,o=o|0,s=s|0;var w=0,h=0,_=0,B=0,m=0,X=0,Q=0,V=0,F=0;A=v-448|0,v=A,i[A+16>>2]=n,i[A+20>>2]=t,i[A+24>>2]=o,i[A+28>>2]=s,w=A+336|0,i[A+332>>2]=w,w=a8(w,100,11378,A+16|0),i[A+224>>2]=2071,h=A+224|0,m=Q1(A+216|0,0,h),i[A+224>>2]=2071,_=Q1(A+208|0,0,h);i:{if(w>>>0>=100&&(w=a2(),i[A>>2]=n,i[A+4>>2]=t,i[A+8>>2]=o,i[A+12>>2]=s,w=I8(A+332|0,w,11378,A),(w|0)==-1||(n=i[m>>2],i[m>>2]=i[A+332>>2],n&&W[i[m+4>>2]](n),t=y2(w),n=i[_>>2],i[_>>2]=t,n&&W[i[_+4>>2]](n),h=i[_>>2],!h)))break i;t=A+204|0,n=i[f+28>>2],i[t>>2]=n,(n|0)!=129576&&(i[n+4>>2]=i[n+4>>2]+1),F=c0(t,129760),n=F,t=i[A+332>>2],W[i[i[n>>2]+32>>2]](n,t,t+w|0,h)|0,V=(w|0)>0?l[i[A+332>>2]]==45:V,t=v-16|0,v=t,n=A+184|0,i[n>>2]=0,i[n+4>>2]=0,i[n+8>>2]=0,v=t+16|0,t=v-16|0,v=t,o=A+172|0,i[o>>2]=0,i[o+4>>2]=0,i[o+8>>2]=0,v=t+16|0,t=v-16|0,v=t,s=A+160|0,i[s>>2]=0,i[s+4>>2]=0,i[s+8>>2]=0,v=t+16|0,Gt(r,V,A+204|0,A+200|0,A+199|0,A+198|0,n,o,s,A+156|0),i[A+48>>2]=2071,r=A+48|0,B=Q1(A+40|0,0,r),t=i[A+156>>2];e:{if((t|0)<(w|0)){l[o+11|0]>>>7|0?X=i[o+4>>2]:X=l[o+11|0]&127,l[s+11|0]>>>7|0?Q=i[s+4>>2]:Q=l[s+11|0]&127,t=(t+(X+(Q+(w-t<<1)|0)|0)|0)+1|0;break e}Q=i[A+156>>2],l[s+11|0]>>>7|0?t=i[s+4>>2]:t=l[s+11|0]&127,l[o+11|0]>>>7|0?X=i[o+4>>2]:X=l[o+11|0]&127,t=(Q+(t+X|0)|0)+2|0}if(t>>>0>=101&&(t=y2(t),r=i[B>>2],i[B>>2]=t,r&&W[i[B+4>>2]](r),r=i[B>>2],!r))break i;return P9(r,A+36|0,A+32|0,i[f+4>>2],h,w+h|0,F,V,A+200|0,u[A+199|0],u[A+198|0],n,o,s,i[A+156>>2]),r=O8(e,r,i[A+36>>2],i[A+32>>2],f,k),e=i[B>>2],i[B>>2]=0,e&&W[i[B+4>>2]](e),s2(s),s2(o),s2(n),e2(A+204|0),e=i[_>>2],i[_>>2]=0,e&&W[i[_+4>>2]](e),e=i[m>>2],i[m>>2]=0,e&&W[i[m+4>>2]](e),v=A+448|0,r|0}g1(),H()}function $9(A,e){var r=0,f=0,k=0,n=0,t=0;k=v-48|0,v=k,r=i[e>>2];i:{if((i[e+4>>2]-r|0)!=9){e=p(40),i[k+12>>2]=e,i[k+16>>2]=32,i[k+20>>2]=-2147483608,r=l[18804]|l[18805]<<8|(l[18806]<<16|l[18807]<<24),f=l[18800]|l[18801]<<8|(l[18802]<<16|l[18803]<<24),u[e+24|0]=f,u[e+25|0]=f>>>8,u[e+26|0]=f>>>16,u[e+27|0]=f>>>24,u[e+28|0]=r,u[e+29|0]=r>>>8,u[e+30|0]=r>>>16,u[e+31|0]=r>>>24,r=l[18796]|l[18797]<<8|(l[18798]<<16|l[18799]<<24),f=l[18792]|l[18793]<<8|(l[18794]<<16|l[18795]<<24),u[e+16|0]=f,u[e+17|0]=f>>>8,u[e+18|0]=f>>>16,u[e+19|0]=f>>>24,u[e+20|0]=r,u[e+21|0]=r>>>8,u[e+22|0]=r>>>16,u[e+23|0]=r>>>24,r=l[18788]|l[18789]<<8|(l[18790]<<16|l[18791]<<24),f=l[18784]|l[18785]<<8|(l[18786]<<16|l[18787]<<24),u[e+8|0]=f,u[e+9|0]=f>>>8,u[e+10|0]=f>>>16,u[e+11|0]=f>>>24,u[e+12|0]=r,u[e+13|0]=r>>>8,u[e+14|0]=r>>>16,u[e+15|0]=r>>>24,r=l[18780]|l[18781]<<8|(l[18782]<<16|l[18783]<<24),f=l[18776]|l[18777]<<8|(l[18778]<<16|l[18779]<<24),u[e|0]=f,u[e+1|0]=f>>>8,u[e+2|0]=f>>>16,u[e+3|0]=f>>>24,u[e+4|0]=r,u[e+5|0]=r>>>8,u[e+6|0]=r>>>16,u[e+7|0]=r>>>24,u[e+32|0]=0,e=q(k+24|0,2,0,k+12|0),r=i[e+4>>2],i[A>>2]=i[e>>2],i[A+4>>2]=r,r=A+8|0;e:{if(u[e+19|0]>=0){f=i[e+12>>2],i[r>>2]=i[e+8>>2],i[r+4>>2]=f,i[r+8>>2]=i[e+16>>2],u[A+24|0]=1;break e}if(T(r,i[e+8>>2],i[e+12>>2]),r=u[e+19|0],u[A+24|0]=1,(r|0)>=0)break e;Z(i[e+8>>2])}if(u[k+23|0]>=0)break i;Z(i[k+12>>2]);break i}f=l[r|0]|l[r+1|0]<<8|(l[r+2|0]<<16|l[r+3|0]<<24),e=l[r+4|0]|l[r+5|0]<<8|(l[r+6|0]<<16|l[r+7|0]<<24),r=l[r+8|0],u[A+24|0]=0,u[A|0]=1,u[A+16|0]=r>>>7,u[A+18|0]=r>>>5&1,u[A+17|0]=r>>>6&1,r=f,n=r&16711680,f=n>>>8|0,t=n<<24,n=r&-16777216,i[A+8>>2]=t|n<<8|(((e&255)<<24|r>>>8)&-16777216|((e&16777215)<<8|r>>>24)&16711680|(e>>>8&65280|e>>>24)),e=f|n>>>24|(r<<24|(r&65280)<<8),f=0,i[A+12>>2]=e|(f|f)}v=k+48|0}function Mf(A,e,r){var f=0,k=0,n=0,t=0;n=v-48|0,v=n;i:{if(r){e:{k=i[e+184>>2];r:{if(!k)break r;for(e=e+184|0,f=e;t=u0[k+16>>2]<r>>>0,f=t?f:k,k=i[(t?4:0)+k>>2],!!k;);if((e|0)==(f|0))break r;if(u0[f+16>>2]<=r>>>0)break e}e=p(24),i[n+12>>2]=e,i[n+16>>2]=16,i[n+20>>2]=-2147483624,r=l[15892]|l[15893]<<8|(l[15894]<<16|l[15895]<<24),f=l[15888]|l[15889]<<8|(l[15890]<<16|l[15891]<<24),u[e+8|0]=f,u[e+9|0]=f>>>8,u[e+10|0]=f>>>16,u[e+11|0]=f>>>24,u[e+12|0]=r,u[e+13|0]=r>>>8,u[e+14|0]=r>>>16,u[e+15|0]=r>>>24,r=l[15884]|l[15885]<<8|(l[15886]<<16|l[15887]<<24),f=l[15880]|l[15881]<<8|(l[15882]<<16|l[15883]<<24),u[e|0]=f,u[e+1|0]=f>>>8,u[e+2|0]=f>>>16,u[e+3|0]=f>>>24,u[e+4|0]=r,u[e+5|0]=r>>>8,u[e+6|0]=r>>>16,u[e+7|0]=r>>>24,u[e+16|0]=0,e=q(n+24|0,5,0,n+12|0),r=i[e+4>>2],i[A>>2]=i[e>>2],i[A+4>>2]=r,r=A+8|0;r:{if(u[e+19|0]>=0){f=i[e+12>>2],i[r>>2]=i[e+8>>2],i[r+4>>2]=f,i[r+8>>2]=i[e+16>>2],u[A+20|0]=1;break r}if(T(r,i[e+8>>2],i[e+12>>2]),r=u[e+19|0],u[A+20|0]=1,(r|0)>=0)break r;Z(i[e+8>>2])}if(u[n+23|0]>=0)break i;Z(i[n+12>>2]);break i}r=i[f+20>>2],e=i[f+24>>2],e&&(i[e+4>>2]=i[e+4>>2]+1),u[A+20|0]=0,i[A+4>>2]=e,i[A>>2]=r;break i}if(t=i[e+192>>2],t){f=i[e+184>>2];e:{r:{if(!f){r=e+184|0,k=r;break r}for(;;){if(k=f,r=i[f+16>>2],r>>>0>t>>>0){if(r=f,f=i[f>>2],f)continue;break r}if(r>>>0>=t>>>0)break e;if(f=i[k+4>>2],!f)break}r=k+4|0}f=p(28),i[f+20>>2]=0,i[f+24>>2]=0,i[f+16>>2]=t,i[f+8>>2]=k,i[f>>2]=0,i[f+4>>2]=0,i[r>>2]=f,r=i[i[e+180>>2]>>2],r&&(i[e+180>>2]=r),m1(i[e+184>>2],f),i[e+188>>2]=i[e+188>>2]+1}r=i[f+20>>2],e=i[f+24>>2],e&&(i[e+4>>2]=i[e+4>>2]+1),u[A+20|0]=0,i[A+4>>2]=e,i[A>>2]=r;break i}e=i[e+180>>2],r=i[e+20>>2],e=i[e+24>>2],e&&(i[e+4>>2]=i[e+4>>2]+1),u[A+20|0]=0,i[A+4>>2]=e,i[A>>2]=r}v=n+48|0}function cm(A,e,r,f,k,n){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0;var t=0,o=0,s=0;for(A=v-272|0,v=A,i[A+264>>2]=r,i[A+268>>2]=e,MA(A+208|0,f,A+224|0,A+223|0,A+222|0),r=v-16|0,v=r,e=A+196|0,i[e>>2]=0,i[e+4>>2]=0,i[e+8>>2]=0,v=r+16|0,W2(e,l[e+11|0]>>>7|0?(i[e+8>>2]&2147483647)-1|0:10),l[e+11|0]>>>7|0?r=i[e>>2]:r=e,i[A+192>>2]=r,i[A+28>>2]=A+32,i[A+24>>2]=0,u[A+23|0]=1,u[A+22|0]=69,f=0;;){i:{e:{r:{f:{if(L2(A+268|0,A+264|0))break f;o=i[A+192>>2],l[e+11|0]>>>7|0?t=i[e+4>>2]:t=l[e+11|0]&127,(o|0)==(t+r|0)&&(l[e+11|0]>>>7|0?r=i[e+4>>2]:r=l[e+11|0]&127,l[e+11|0]>>>7|0?t=i[e+4>>2]:t=l[e+11|0]&127,W2(e,t<<1),W2(e,l[e+11|0]>>>7|0?(i[e+8>>2]&2147483647)-1|0:10),t=r,l[e+11|0]>>>7|0?r=i[e>>2]:r=e,i[A+192>>2]=t+r),t=i[A+268>>2],o=i[t+12>>2];A:{if((o|0)==i[t+16>>2]){t=W[i[i[t>>2]+36>>2]](t)|0;break A}t=u[o|0]}if(Of(t<<24>>24,A+23|0,A+22|0,r,A+192|0,u[A+223|0],u[A+222|0],A+208|0,A+32|0,A+28|0,A+24|0,A+224|0))break f;if(f)break r;if(f=0,o=i[A+192>>2]-r|0,(o|0)<=0)break e;A:{k:switch(t=l[r|0],s=t-43|0,s|0){case 0:case 2:break A;default:break k}if((t|0)==46)break r;if(f=1,(t-48&255)>>>0<10)break e;break f}if((o|0)==1)break e;A:switch(s|0){case 0:case 2:break A;default:break e}if(t=l[r+1|0],(t|0)==46)break r;if(f=1,(t-48&255)>>>0<=9)break e}l[A+219|0]>>>7|0?f=i[A+212>>2]:f=l[A+219|0]&127;f:{if(!f|!(u[A+23|0]&1)||(f=i[A+28>>2],(f-(A+32|0)|0)>159))break f;i[A+28>>2]=f+4,i[f>>2]=i[A+24>>2]}Sn(A,r,i[A+192>>2],k),r=i[A>>2],f=i[A+4>>2],t=i[A+12>>2],i[n+8>>2]=i[A+8>>2],i[n+12>>2]=t,i[n>>2]=r,i[n+4>>2]=f,l4(A+208|0,A+32|0,i[A+28>>2],k),L2(A+268|0,A+264|0)&&(i[k>>2]=i[k>>2]|2),r=i[A+268>>2],s2(e),s2(A+208|0),v=A+272|0;break i}f=1}q1(A+268|0);continue}break}return r|0}function bm(A,e,r,f,k,n,t,o){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,t=t|0,o=o|0;var s=0,w=0,h=0,_=0,B=0,m=0,X=0,Q=0,V=0,F=0,I=0,E=0,R=0;for(V=v-16|0,v=V,w=r;;){i:{if((f|0)==(w|0)){w=f;break i}if(!l[w|0])break i;w=w+1|0;continue}break}i[o>>2]=n,i[k>>2]=r;i:for(;;){e:{r:{f:{if((r|0)==(f|0)|(n|0)==(t|0))break f;s=i[e+4>>2],i[V+8>>2]=i[e>>2],i[V+12>>2]=s,F=v-16|0,v=F,i[F+12>>2]=i[A+8>>2],R=s8(F+8|0,F+12|0),X=w-r|0,_=0,m=v-1040|0,v=m,s=i[k>>2],i[m+12>>2]=s,Q=n||m+16|0,B=n?t-n>>2:256;A:{k:{n:{if(!(!s|!B)){for(;;){if(h=X>>>2|0,!(X>>>0>131|h>>>0>=B>>>0)){h=s;break k}if(I=x9(Q,m+12|0,h>>>0<B>>>0?h:B,e),h=i[m+12>>2],(I|0)==-1){B=0,_=-1;break n}if(E=(m+16|0)!=(Q|0)?I:0,B=B-E|0,Q=(E<<2)+Q|0,X=h?(s+X|0)-h|0:0,_=_+I|0,!h)break n;if(s=h,!B)break}break n}h=s}if(!h)break A}if(!B|!X)break A;for(s=_;;){k:{_=ne(Q,h,X,e);n:{if(_+2>>>0<=2){t:switch(_+1|0){case 1:i[m+12>>2]=0;break n;case 0:break A;default:break t}i[e>>2]=0;break n}if(h=i[m+12>>2]+_|0,i[m+12>>2]=h,s=s+1|0,B=B-1|0,B)break k}_=s;break A}if(Q=Q+4|0,X=X-_|0,_=s,!X)break}}n&&(i[k>>2]=i[m+12>>2]),v=m+1040|0,s=i[R>>2],s&&(i[31366]=(s|0)==-1?125344:s),v=F+16|0;A:{k:{n:{t:{if((_|0)==-1)for(;;){if(i[o>>2]=n,i[k>>2]==(r|0))break f;t=1;u:{o:{l:switch(e=rl(n,r,w-r|0,V+8|0,i[A+8>>2]),e+2|0){case 0:break k;case 1:break l;case 2:break u;default:break o}i[k>>2]=r;break t}t=e}r=r+t|0,n=i[o>>2]+4|0}if(n=i[o>>2]+(_<<2)|0,i[o>>2]=n,(n|0)==(t|0))break A;if(r=i[k>>2],(f|0)==(w|0))break e;if(!rl(n,r,1,e,i[A+8>>2]))break n}A=2;break r}for(n=i[o>>2]+4|0,i[o>>2]=n,r=i[k>>2]+1|0,i[k>>2]=r,w=r;;){if((f|0)==(w|0))break e;if(!l[w|0])continue i;w=w+1|0}}i[k>>2]=r,A=1;break r}r=i[k>>2]}A=(r|0)!=(f|0)}return v=V+16|0,A|0}w=f}}function b0(A,e,r){var f=0,k=0,n=0,t=0,o=0,s=0;f=v-160|0,v=f,n=i[e>>2];i:{e:{r:{f:{A:{if(r){if(!n){k=48862,i[r+12>>2]=48862,r=0;break e}i[f+104>>2]=0,i[f+76>>2]=72196,i[f+20>>2]=72176,n=i[18053],i[f+12>>2]=n,k=i[n-12>>2],t=f+12|0,n=t,i[k+n>>2]=i[18054],i[f+16>>2]=0,n=n+i[i[f+12>>2]-12>>2]|0,o=f+24|0,J0(n,o),u[n+80|0]=0,i[n+72>>2]=0,n=i[18055],i[f+20>>2]=n,k=i[n-12>>2],n=f+20|0,i[k+n>>2]=i[18056],k=i[18052],i[f+12>>2]=k,i[t+i[k-12>>2]>>2]=i[18057],i[f+76>>2]=72196,i[f+12>>2]=72156,i[f+20>>2]=72176,s=R0(o),i[s>>2]=71232,k=f- -64|0,i[k>>2]=0,i[k+4>>2]=0,i[f+56>>2]=0,i[f+60>>2]=0,i[f+72>>2]=24,k=i[e>>2],k>>>0>13?k=6623:k=i[(k<<2)+94292>>2],t=Y(Y(n,k,h2(k)),32729,2),k=n9(i[e+4>>2]),Y(t,k,h2(k)),k=u[e+19|0],((k|0)<0?i[e+12>>2]:k)&&(t=Y(n,32729,2),k=u[e+19|0],n=(k|0)<0,Y(t,n?i[e+8>>2]:e+8|0,n?i[e+12>>2]:k)),n=i[f+72>>2];k:{if(n&16){k=i[f+68>>2],n=i[f+48>>2],k>>>0<n>>>0&&(i[f+68>>2]=n,k=n),n=f+44|0;break k}if(!(n&8)){k=0,u[f+11|0]=0,n=f;break r}k=i[f+40>>2],n=f+32|0}if(t=i[n>>2],k=k-t|0,k>>>0>=2147483640)break A;if(k>>>0>=11){o=k|7,n=p(o+1|0),i[f+8>>2]=o-2147483647,i[f>>2]=n,i[f+4>>2]=k;break f}if(u[f+11|0]=k,n=f,k)break f;k=0;break r}i[A>>2]=n,i[A+4>>2]=i[e+4>>2],k=i[23572];break i}Q0(),H()}if(!k)break r;x(n,t,k)}u[k+n|0]=0;r:{if((r|0)==(f|0))break r;if(k=u[f+11|0],u[r+11|0]>=0){if((k|0)>=0){n=i[f+4>>2],i[r>>2]=i[f>>2],i[r+4>>2]=n,i[r+8>>2]=i[f+8>>2];break r}M1(r,i[f>>2],i[f+4>>2]);break r}n=(k|0)<0,O1(r,n?i[f>>2]:f,n?i[f+4>>2]:k)}i[r+12>>2]=u[r+11|0]<0?i[r>>2]:r,u[f+11|0]<0&&Z(i[f>>2]),n=i[18051],i[f+12>>2]=n,i[i[n-12>>2]+(f+12|0)>>2]=i[18059],i[f+20>>2]=i[18060],i[s>>2]=71232,u[f+67|0]<0&&Z(i[f+56>>2]),E0(s),y0(f+76|0),k=i[r+12>>2],r=i[e>>2]}i[A>>2]=r,i[A+4>>2]=i[e+4>>2]}i[A+8>>2]=k,v=f+160|0}function iZ(A,e,r,f,k,n){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0;var t=0,o=0,s=0;for(A=v-368|0,v=A,i[A+360>>2]=r,i[A+364>>2]=e,DA(A+220|0,f,A+240|0,A+236|0,A+232|0),r=v-16|0,v=r,e=A+208|0,i[e>>2]=0,i[e+4>>2]=0,i[e+8>>2]=0,v=r+16|0,W2(e,l[e+11|0]>>>7|0?(i[e+8>>2]&2147483647)-1|0:10),l[e+11|0]>>>7|0?r=i[e>>2]:r=e,i[A+204>>2]=r,i[A+28>>2]=A+32,i[A+24>>2]=0,u[A+23|0]=1,u[A+22|0]=69,f=0;;){i:{e:{r:{f:{if(K2(A+364|0,A+360|0))break f;o=i[A+204>>2],l[e+11|0]>>>7|0?t=i[e+4>>2]:t=l[e+11|0]&127,(o|0)==(t+r|0)&&(l[e+11|0]>>>7|0?r=i[e+4>>2]:r=l[e+11|0]&127,l[e+11|0]>>>7|0?t=i[e+4>>2]:t=l[e+11|0]&127,W2(e,t<<1),W2(e,l[e+11|0]>>>7|0?(i[e+8>>2]&2147483647)-1|0:10),t=r,l[e+11|0]>>>7|0?r=i[e>>2]:r=e,i[A+204>>2]=t+r),t=i[A+364>>2],o=i[t+12>>2];A:{if((o|0)==i[t+16>>2]){t=W[i[i[t>>2]+36>>2]](t)|0;break A}t=i[o>>2]}if(jf(t,A+23|0,A+22|0,r,A+204|0,i[A+236>>2],i[A+232>>2],A+220|0,A+32|0,A+28|0,A+24|0,A+240|0))break f;if(f)break r;if(f=0,o=i[A+204>>2]-r|0,(o|0)<=0)break e;A:{k:switch(t=l[r|0],s=t-43|0,s|0){case 0:case 2:break A;default:break k}if((t|0)==46)break r;if(f=1,(t-48&255)>>>0<10)break e;break f}if((o|0)==1)break e;A:switch(s|0){case 0:case 2:break A;default:break e}if(t=l[r+1|0],(t|0)==46)break r;if(f=1,(t-48&255)>>>0<=9)break e}l[A+231|0]>>>7|0?f=i[A+224>>2]:f=l[A+231|0]&127;f:{if(!f|!(u[A+23|0]&1)||(f=i[A+28>>2],(f-(A+32|0)|0)>159))break f;i[A+28>>2]=f+4,i[f>>2]=i[A+24>>2]}Sn(A,r,i[A+204>>2],k),r=i[A>>2],f=i[A+4>>2],t=i[A+12>>2],i[n+8>>2]=i[A+8>>2],i[n+12>>2]=t,i[n>>2]=r,i[n+4>>2]=f,l4(A+220|0,A+32|0,i[A+28>>2],k),K2(A+364|0,A+360|0)&&(i[k>>2]=i[k>>2]|2),r=i[A+364>>2],s2(e),s2(A+220|0),v=A+368|0;break i}f=1}a1(A+364|0);continue}break}return r|0}function d9(A,e,r,f,k){var n=0,t=0,o=0,s=0,w=0,h=0;if(!((k|0)<=0)){i:{if(n=i[A+8>>2],o=i[A+4>>2],n-o>>3>=(k|0)){if(n=o-e|0,s=n>>3,(s|0)>=(k|0)){w=(k<<3)+r|0,n=o;break i}w=r+n|0;e:{if((w|0)==(f|0)){n=o;break e}for(t=w,n=o;i[n>>2]=i[t>>2],h=i[t+4>>2],i[n+4>>2]=h,h&&(i[h+4>>2]=i[h+4>>2]+1),n=n+8|0,t=t+8|0,(t|0)!=(f|0););}if(i[A+4>>2]=n,(s|0)>0)break i;return}e:{if(w=i[A>>2],o=(o-w>>3)+k|0,o>>>0<536870912){if(n=n-w|0,f=n>>2,s=n>>>0>=2147483640?536870911:f>>>0>o>>>0?f:o,s){if(s>>>0>=536870912)break e;f=p(s<<3)}else f=0;if(t=k<<3,o=f+(e-w|0)|0,k&1?(i[o>>2]=i[r>>2],n=i[r+4>>2],i[o+4>>2]=n,n&&(i[n+4>>2]=i[n+4>>2]+1),r=r+8|0,n=o+8|0):n=o,t=t+o|0,(k&536870911)!=1)for(;i[n>>2]=i[r>>2],k=i[r+4>>2],i[n+4>>2]=k,k&&(i[k+4>>2]=i[k+4>>2]+1),i[n+8>>2]=i[r+8>>2],k=i[r+12>>2],i[n+12>>2]=k,k&&(i[k+4>>2]=i[k+4>>2]+1),r=r+16|0,n=n+16|0,(t|0)!=(n|0););k=i[A+4>>2]-e|0,k&&x(t,e,k),i[A+4>>2]=e,n=i[A>>2],r=e-n|0,e=o-r|0,r&&x(e,n,r),i[A+4>>2]=k+t,i[A>>2]=e,i[A+8>>2]=f+(s<<3),n&&Z(n);return}G0(),H()}z0(),H()}if(f=k<<3,s=f+e|0,k=n,t=n-f|0,o>>>0>t>>>0)for(f=t;i[k>>2]=i[f>>2],i[k+4>>2]=i[f+4>>2],i[f>>2]=0,i[f+4>>2]=0,k=k+8|0,f=f+8|0,o>>>0>f>>>0;);if(i[A+4>>2]=k,(n|0)!=(s|0))for(;;){t=t-8|0,f=i[t>>2],A=i[t+4>>2],i[t>>2]=0,i[t+4>>2]=0,k=i[n-4>>2],n=n-8|0,i[n>>2]=f,i[n+4>>2]=A;i:{if(!k||(A=i[k+4>>2],i[k+4>>2]=A-1,A))break i;W[i[i[k>>2]+8>>2]](k),y(k)}if((e|0)==(t|0))break}if((r|0)!=(w|0))for(n=e;;){A=i[r>>2],e=i[r+4>>2],e&&(i[e+4>>2]=i[e+4>>2]+1),i[n>>2]=A,f=i[n+4>>2],i[n+4>>2]=e;i:{if(!f||(A=i[f+4>>2],i[f+4>>2]=A-1,A))break i;W[i[i[f>>2]+8>>2]](f),y(f)}if(n=n+8|0,r=r+8|0,(w|0)==(r|0))break}}}function eZ(A,e,r,f,k,n,t,o,s){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,t=t|0,o=o|0,s=s|0,k=v-96|0,v=k,i[k+80>>2]=0,i[k+72>>2]=0,i[k+76>>2]=0,t=k- -64|0,i[t>>2]=0,i[t+4>>2]=0,i[k+56>>2]=0,i[k+60>>2]=0,i[k+48>>2]=0,i[k+52>>2]=0,W[i[i[e>>2]+12>>2]](k,e,r,f,k+48|0,n);i:{e:{r:{f:{A:switch(l[k+44|0]){case 0:if(n=107664,!i[26916])break e;r=107676,f=107683,e=107672;break f;case 1:break A;default:break r}if(!i[k>>2])break r;r=k+12|0,f=k+19|0,n=k,e=k+8|0}if(t=i[n+4>>2],i[A>>2]=i[n>>2],i[A+4>>2]=t,A=A+8|0,u[f|0]>=0){r=i[e+4>>2],i[A>>2]=i[e>>2],i[A+4>>2]=r,i[A+8>>2]=i[e+8>>2];break i}T(A,i[e>>2],i[r>>2]);break i}_2(),H()}e:{if(l[e+48|0]==1){if(r=i[e+4>>2],r){if(f=r,n=i[e+8>>2],(r|0)!=(n|0)){for(;;){f=i[n-4>>2];r:{if(!f||(t=i[f+4>>2],i[f+4>>2]=t-1,t))break r;W[i[i[f>>2]+8>>2]](f),y(f)}if(n=n-8|0,(r|0)==(n|0))break}f=i[e+4>>2]}i[e+8>>2]=r,Z(f)}i[e+4>>2]=i[k>>2],i[e+8>>2]=i[k+4>>2],i[e+12>>2]=i[k+8>>2],i[k+8>>2]=0,i[k>>2]=0,i[k+4>>2]=0,r=i[e+16>>2],r&&(i[e+20>>2]=r,Z(r)),i[e+16>>2]=i[k+12>>2],i[e+20>>2]=i[k+16>>2],i[e+24>>2]=i[k+20>>2],i[k+20>>2]=0,i[k+12>>2]=0,i[k+16>>2]=0,r=i[k+36>>2],i[e+36>>2]=i[k+32>>2],i[e+40>>2]=r,r=i[k+28>>2],i[e+28>>2]=i[k+24>>2],i[e+32>>2]=r;break e}i[e+4>>2]=i[k>>2],i[e+8>>2]=i[k+4>>2],i[e+12>>2]=i[k+8>>2],i[k+8>>2]=0,i[k>>2]=0,i[k+4>>2]=0,i[e+16>>2]=i[k+12>>2],i[e+20>>2]=i[k+16>>2],i[e+24>>2]=i[k+20>>2],i[k+20>>2]=0,i[k+12>>2]=0,i[k+16>>2]=0,r=i[k+32>>2],f=i[k+36>>2],n=i[k+24>>2],t=i[k+28>>2],u[e+48|0]=1,i[e+36>>2]=r,i[e+40>>2]=f,i[e+28>>2]=n,i[e+32>>2]=t}u[e+40|0]=1,i[e+44>>2]=s,i[A>>2]=0,i[A+4>>2]=0,i[A+16>>2]=0,i[A+8>>2]=0,i[A+12>>2]=0}A=l[k+44|0],(A|0)!=255&&(e=i[24771],i[k+88>>2]=i[24770],i[k+92>>2]=e,W[i[(k+88|0)+(A<<2)>>2]](k+87|0,k)),v=k+96|0}function rZ(A,e,r,f,k,n,t,o,s){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,t=t|0,o=o|0,s=s|0,k=v-96|0,v=k,i[k+80>>2]=0,i[k+72>>2]=0,i[k+76>>2]=0,t=k- -64|0,i[t>>2]=0,i[t+4>>2]=0,i[k+56>>2]=0,i[k+60>>2]=0,i[k+48>>2]=0,i[k+52>>2]=0,W[i[i[e>>2]+12>>2]](k,e,r,f,k+48|0,n);i:{e:{r:{f:{A:switch(l[k+44|0]){case 0:if(n=107664,!i[26916])break e;r=107676,f=107683,e=107672;break f;case 1:break A;default:break r}if(!i[k>>2])break r;r=k+12|0,f=k+19|0,n=k,e=k+8|0}if(t=i[n+4>>2],i[A>>2]=i[n>>2],i[A+4>>2]=t,A=A+8|0,u[f|0]>=0){r=i[e+4>>2],i[A>>2]=i[e>>2],i[A+4>>2]=r,i[A+8>>2]=i[e+8>>2];break i}T(A,i[e>>2],i[r>>2]);break i}_2(),H()}e:{if(l[e+48|0]==1){if(r=i[e+4>>2],r){if(f=r,n=i[e+8>>2],(r|0)!=(n|0)){for(;;){f=i[n-4>>2];r:{if(!f||(t=i[f+4>>2],i[f+4>>2]=t-1,t))break r;W[i[i[f>>2]+8>>2]](f),y(f)}if(n=n-8|0,(r|0)==(n|0))break}f=i[e+4>>2]}i[e+8>>2]=r,Z(f)}i[e+4>>2]=i[k>>2],i[e+8>>2]=i[k+4>>2],i[e+12>>2]=i[k+8>>2],i[k+8>>2]=0,i[k>>2]=0,i[k+4>>2]=0,r=i[e+16>>2],r&&(i[e+20>>2]=r,Z(r)),i[e+16>>2]=i[k+12>>2],i[e+20>>2]=i[k+16>>2],i[e+24>>2]=i[k+20>>2],i[k+20>>2]=0,i[k+12>>2]=0,i[k+16>>2]=0,r=i[k+36>>2],i[e+36>>2]=i[k+32>>2],i[e+40>>2]=r,r=i[k+28>>2],i[e+28>>2]=i[k+24>>2],i[e+32>>2]=r;break e}i[e+4>>2]=i[k>>2],i[e+8>>2]=i[k+4>>2],i[e+12>>2]=i[k+8>>2],i[k+8>>2]=0,i[k>>2]=0,i[k+4>>2]=0,i[e+16>>2]=i[k+12>>2],i[e+20>>2]=i[k+16>>2],i[e+24>>2]=i[k+20>>2],i[k+20>>2]=0,i[k+12>>2]=0,i[k+16>>2]=0,r=i[k+32>>2],f=i[k+36>>2],n=i[k+24>>2],t=i[k+28>>2],u[e+48|0]=1,i[e+36>>2]=r,i[e+40>>2]=f,i[e+28>>2]=n,i[e+32>>2]=t}u[e+40|0]=1,i[e+44>>2]=s,i[A>>2]=0,i[A+4>>2]=0,i[A+16>>2]=0,i[A+8>>2]=0,i[A+12>>2]=0}A=l[k+44|0],(A|0)!=255&&(e=i[24677],i[k+88>>2]=i[24676],i[k+92>>2]=e,W[i[(k+88|0)+(A<<2)>>2]](k+87|0,k)),v=k+96|0}function fZ(A,e){A=A|0,e=e|0;var r=0,f=0,k=0,n=0,t=0,o=0,s=0,w=0,h=0,_=0;o=v-16|0,v=o;i:{if(!A)break i;_=o+4|0,s=_,A=i[i[A>>2]+48>>2],r=v-176|0,v=r,i[r+120>>2]=0,i[r+92>>2]=72196,i[r+36>>2]=72176,f=i[18053],i[r+28>>2]=f,w=r+28|0,i[w+i[f-12>>2]>>2]=i[18054],i[r+32>>2]=0,f=w+i[i[r+28>>2]-12>>2]|0,k=r+40|0,J0(f,k),u[f+80|0]=0,i[f+72>>2]=0,f=i[18055],i[r+36>>2]=f,h=i[f-12>>2],f=r+36|0,i[h+f>>2]=i[18056],t=i[18052],i[r+28>>2]=t,i[w+i[t-12>>2]>>2]=i[18057],i[r+92>>2]=72196,i[r+28>>2]=72156,i[r+36>>2]=72176,w=R0(k),i[w>>2]=71232,i[r+80>>2]=0,i[r+84>>2]=0,i[r+72>>2]=0,i[r+76>>2]=0,i[r+88>>2]=24;e:{r:{f:{if(k=i[A+16>>2],t=i[A+20>>2],(k|0)!=(t|0)){if(A=i[k>>2],n=i[i[A>>2]+12>>2],i[r+24>>2]=0,h=r+12|0,W[n|0](h,A,r+24|0),A=u[r+23|0],n=(A|0)<0,Y(f,n?i[r+12>>2]:h,n?i[r+16>>2]:A),u[r+23|0]<0&&Z(i[r+12>>2]),A=k+8|0,(t|0)!=(A|0))for(;Y(f,42670,1),i[r+24>>2]=0,k=r+12|0,n=i[A>>2],W[i[i[n>>2]+12>>2]](k,n,r+24|0),h=k,k=u[r+23|0],n=(k|0)<0,Y(f,n?i[r+12>>2]:h,n?i[r+16>>2]:k),u[r+23|0]<0&&Z(i[r+12>>2]),A=A+8|0,(t|0)!=(A|0););if(A=i[r+88>>2],!(A&16))break f}A=i[r+84>>2],f=i[r+64>>2],A>>>0<f>>>0&&(i[r+84>>2]=f,A=f),f=r+60|0;break r}if(!(A&8)){A=0,u[s+11|0]=0;break e}A=i[r+56>>2],f=r+48|0}r:{if(k=i[f>>2],A=A-k|0,A>>>0<2147483640){if(A>>>0>=11){t=A|7,f=p(t+1|0),i[s+8>>2]=t-2147483647,i[s>>2]=f,i[s+4>>2]=A,s=f;break r}if(u[s+11|0]=A,A)break r;A=0;break e}Q0(),H()}if(!A)break e;x(s,k,A)}if(u[A+s|0]=0,A=i[18051],i[r+28>>2]=A,i[i[A-12>>2]+(r+28|0)>>2]=i[18059],i[r+36>>2]=i[18060],i[w>>2]=71232,u[r+83|0]<0&&Z(i[r+72>>2]),E0(w),y0(r+92|0),v=r+176|0,f=e,A=u[o+15|0],e=(A|0)<0,el(f,e?i[o+4>>2]:_,e?i[o+8>>2]:A),u[o+15|0]>=0)break i;Z(i[o+4>>2])}v=o+16|0}function AZ(A,e,r,f,k,n,t,o){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,t=t|0,o=o|0;var s=0,w=0,h=0,_=0,B=0,m=0,X=0,Q=0,V=0,F=0,I=0,E=0,R=0,N=0;h=v-16|0,v=h;i:{if(!p5(t,0)){i[A>>2]=5,i[A+4>>2]=2002,i[A+8>>2]=10027;break i}if(s=p(52),i[s+32>>2]=0,i[s+36>>2]=0,i[s+12>>2]=95936,i[s+4>>2]=0,i[s+8>>2]=0,i[s+28>>2]=n,i[s+24>>2]=k,i[s+20>>2]=f,i[s+16>>2]=r,i[s>>2]=96180,i[s+40>>2]=0,i[s+44>>2]=0,i[s+48>>2]=0,f=0,r=G(k,n)+7|0,r>>>0>=8&&(r=r>>>3|0,f=p(r),r&&o0(f,0,r),B=r+f|0,i[s+40>>2]=B,i[s+36>>2]=B,i[s+32>>2]=f),r=B-f|0,r&&o0(f,0,r),Q=s+12|0,r=i[t>>2],m=i[r+108>>2],V=i[r+112>>2],F=hi(t,0,h+12|0),!(!V|!m))for(I=m&-2,E=m&1,k=0,R=i[h+12>>2];;){X=G(k,R)+F|0;e:{if((m|0)==1){t=0;break e}for(N=X+1|0,t=0,n=0;r=((_&7)<<29|w>>>3)+f|0,u[r|0]=l[r|0]|(l[t+X|0]&128)>>>(w&7),r=_,B=w+1|0,r=(((B?r:r+1|0)&7)<<29|B>>>3)+f|0,u[r|0]=l[r|0]|(l[t+N|0]&128)>>>(B&7),t=t+2|0,w=w+2|0,_=w>>>0<2?_+1|0:_,n=n+2|0,(I|0)!=(n|0););}if(E&&(r=((_&7)<<29|w>>>3)+f|0,u[r|0]=l[r|0]|(l[t+X|0]&128)>>>(w&7),w=w+1|0,_=w?_:_+1|0),k=k+1|0,(V|0)==(k|0))break}r=i[e+8>>2],i[h+8>>2]=s,i[h+4>>2]=Q,i[s+4>>2]=i[s+4>>2]+1,r2(r+12|0,h+4|0),r=i[h+8>>2];e:{if(!r||(f=i[r+4>>2],i[r+4>>2]=f-1,f))break e;W[i[i[r>>2]+8>>2]](r),y(r)}e:{if(!o||(i[s+4>>2]=i[s+4>>2]+1,r=p(24),i[s+4>>2]=i[s+4>>2]+1,i[r+20>>2]=s,i[r+16>>2]=Q,k=i[e+8>>2],f=i[e+12>>2],f&&(i[f+4>>2]=i[f+4>>2]+1),i[r+12>>2]=f,i[r+8>>2]=k,f=i[e>>2],e=i[e+4>>2],e&&(i[e+4>>2]=i[e+4>>2]+1),i[r+4>>2]=e,i[r>>2]=f,i[o>>2]=r,e=i[s+4>>2],i[s+4>>2]=e-1,e))break e;W[i[i[s>>2]+8>>2]](s),y(s)}if(e=i[24057],i[A>>2]=i[24056],i[A+4>>2]=e,i[A+8>>2]=i[24058],A=i[s+4>>2],i[s+4>>2]=A-1,A)break i;W[i[i[s>>2]+8>>2]](s),y(s)}v=h+16|0}function kZ(A,e,r,f,k,n){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0;var t=0,o=0,s=0,w=0,h=U(0);for(A=v-256|0,v=A,i[A+248>>2]=r,i[A+252>>2]=e,MA(A+192|0,f,A+208|0,A+207|0,A+206|0),r=v-16|0,v=r,e=A+180|0,i[e>>2]=0,i[e+4>>2]=0,i[e+8>>2]=0,v=r+16|0,W2(e,l[e+11|0]>>>7|0?(i[e+8>>2]&2147483647)-1|0:10),l[e+11|0]>>>7|0?r=i[e>>2]:r=e,i[A+176>>2]=r,i[A+12>>2]=A+16,i[A+8>>2]=0,u[A+7|0]=1,u[A+6|0]=69,f=0;;){i:{e:{r:{f:{if(L2(A+252|0,A+248|0))break f;o=i[A+176>>2],l[e+11|0]>>>7|0?t=i[e+4>>2]:t=l[e+11|0]&127,(o|0)==(t+r|0)&&(l[e+11|0]>>>7|0?r=i[e+4>>2]:r=l[e+11|0]&127,l[e+11|0]>>>7|0?t=i[e+4>>2]:t=l[e+11|0]&127,W2(e,t<<1),W2(e,l[e+11|0]>>>7|0?(i[e+8>>2]&2147483647)-1|0:10),t=r,l[e+11|0]>>>7|0?r=i[e>>2]:r=e,i[A+176>>2]=t+r),t=i[A+252>>2],o=i[t+12>>2];A:{if((o|0)==i[t+16>>2]){t=W[i[i[t>>2]+36>>2]](t)|0;break A}t=u[o|0]}if(Of(t<<24>>24,A+7|0,A+6|0,r,A+176|0,u[A+207|0],u[A+206|0],A+192|0,A+16|0,A+12|0,A+8|0,A+208|0))break f;if(f)break r;if(f=0,o=i[A+176>>2]-r|0,(o|0)<=0)break e;A:{k:switch(t=l[r|0],s=t-43|0,s|0){case 0:case 2:break A;default:break k}if((t|0)==46)break r;if(f=1,(t-48&255)>>>0<10)break e;break f}if((o|0)==1)break e;A:switch(s|0){case 0:case 2:break A;default:break e}if(t=l[r+1|0],(t|0)==46)break r;if(f=1,(t-48&255)>>>0<=9)break e}l[A+203|0]>>>7|0?f=i[A+196>>2]:f=l[A+203|0]&127;f:{if(!f|!(u[A+7|0]&1)||(f=i[A+12>>2],(f-(A+16|0)|0)>159))break f;i[A+12>>2]=f+4,i[f>>2]=i[A+8>>2]}w=n,h=Eu(r,i[A+176>>2],k),p0[w>>2]=h,l4(A+192|0,A+16|0,i[A+12>>2],k),L2(A+252|0,A+248|0)&&(i[k>>2]=i[k>>2]|2),r=i[A+252>>2],s2(e),s2(A+192|0),v=A+256|0;break i}f=1}q1(A+252|0);continue}break}return r|0}function nZ(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,t=0,o=0,s=0;f=v-160|0,v=f,i[f+92>>2]=0,i[f+64>>2]=72500,k=i[18128],i[f+8>>2]=k,n=i[k-12>>2],k=f+8|0,i[n+k>>2]=i[18129],o=k+i[i[f+8>>2]-12>>2]|0,n=f+12|0,J0(o,n),u[o+80|0]=0,i[o+72>>2]=0,i[f+64>>2]=72500,i[f+8>>2]=72480,o=R0(n),i[o>>2]=71232,i[f+52>>2]=0,i[f+56>>2]=0,i[f+44>>2]=0,i[f+48>>2]=0,i[f+60>>2]=16,n=f+148|0,Y2(n,e,r),t=k,s=n,k=u[f+159|0],n=(k|0)<0,Y(t,n?i[f+148>>2]:s,n?i[f+152>>2]:k),u[f+159|0]<0&&Z(i[f+148>>2]),k=f+148|0,s0(k,r),t=k,k=u[f+159|0],n=(k|0)<0,Y(f+8|0,n?i[f+148>>2]:t,n?i[f+152>>2]:k),u[f+159|0]<0&&Z(i[f+148>>2]),k=f+8|0,Y(q2(Y(k,30431,15),i[e+112>>2],i[e+116>>2]),42670,1),n=f+148|0,s0(n,r),t=k,s=n,k=u[f+159|0],n=(k|0)<0,Y(t,n?i[f+148>>2]:s,n?i[f+152>>2]:k),u[f+159|0]<0&&Z(i[f+148>>2]),k=f+8|0,Y(S0(Y(k,31367,23),l[e+120|0]),42670,1),n=f+148|0,s0(n,r),t=k,s=n,k=u[f+159|0],n=(k|0)<0,Y(t,n?i[f+148>>2]:s,n?i[f+152>>2]:k),u[f+159|0]<0&&Z(i[f+148>>2]),k=f+8|0,Y(S0(Y(k,31516,30),l[e+121|0]),42670,1),n=f+148|0,s0(n,r),t=k,r=u[f+159|0],k=(r|0)<0,Y(t,k?i[f+148>>2]:n,k?i[f+152>>2]:r),u[f+159|0]<0&&Z(i[f+148>>2]),Y(S0(Y(f+8|0,32229,23),l[e+122|0]),42670,1),e=i[f+60>>2];i:{e:{if(e&16){r=i[f+56>>2],e=i[f+36>>2],r>>>0<e>>>0&&(i[f+56>>2]=e,r=e),e=f+32|0;break e}if(!(e&8)){r=0,u[A+11|0]=0;break i}r=i[f+28>>2],e=f+20|0}e:{if(k=i[e>>2],r=r-k|0,r>>>0<2147483640){if(r>>>0>=11){n=r|7,e=p(n+1|0),i[A+8>>2]=n-2147483647,i[A>>2]=e,i[A+4>>2]=r,A=e;break e}if(u[A+11|0]=r,r)break e;r=0;break i}Q0(),H()}if(!r)break i;x(A,k,r)}u[A+r|0]=0,A=i[18127],i[f+8>>2]=A,i[i[A-12>>2]+(f+8|0)>>2]=i[18130],i[o>>2]=71232,u[f+55|0]<0&&Z(i[f+44>>2]),E0(o),y0(f- -64|0),v=f+160|0}function tZ(A,e,r,f,k,n){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0;var t=0,o=0,s=0,w=0,h=0;for(A=v-256|0,v=A,i[A+248>>2]=r,i[A+252>>2]=e,MA(A+192|0,f,A+208|0,A+207|0,A+206|0),r=v-16|0,v=r,e=A+180|0,i[e>>2]=0,i[e+4>>2]=0,i[e+8>>2]=0,v=r+16|0,W2(e,l[e+11|0]>>>7|0?(i[e+8>>2]&2147483647)-1|0:10),l[e+11|0]>>>7|0?r=i[e>>2]:r=e,i[A+176>>2]=r,i[A+12>>2]=A+16,i[A+8>>2]=0,u[A+7|0]=1,u[A+6|0]=69,f=0;;){i:{e:{r:{f:{if(L2(A+252|0,A+248|0))break f;o=i[A+176>>2],l[e+11|0]>>>7|0?t=i[e+4>>2]:t=l[e+11|0]&127,(o|0)==(t+r|0)&&(l[e+11|0]>>>7|0?r=i[e+4>>2]:r=l[e+11|0]&127,l[e+11|0]>>>7|0?t=i[e+4>>2]:t=l[e+11|0]&127,W2(e,t<<1),W2(e,l[e+11|0]>>>7|0?(i[e+8>>2]&2147483647)-1|0:10),t=r,l[e+11|0]>>>7|0?r=i[e>>2]:r=e,i[A+176>>2]=t+r),t=i[A+252>>2],o=i[t+12>>2];A:{if((o|0)==i[t+16>>2]){t=W[i[i[t>>2]+36>>2]](t)|0;break A}t=u[o|0]}if(Of(t<<24>>24,A+7|0,A+6|0,r,A+176|0,u[A+207|0],u[A+206|0],A+192|0,A+16|0,A+12|0,A+8|0,A+208|0))break f;if(f)break r;if(f=0,o=i[A+176>>2]-r|0,(o|0)<=0)break e;A:{k:switch(t=l[r|0],s=t-43|0,s|0){case 0:case 2:break A;default:break k}if((t|0)==46)break r;if(f=1,(t-48&255)>>>0<10)break e;break f}if((o|0)==1)break e;A:switch(s|0){case 0:case 2:break A;default:break e}if(t=l[r+1|0],(t|0)==46)break r;if(f=1,(t-48&255)>>>0<=9)break e}l[A+203|0]>>>7|0?f=i[A+196>>2]:f=l[A+203|0]&127;f:{if(!f|!(u[A+7|0]&1)||(f=i[A+12>>2],(f-(A+16|0)|0)>159))break f;i[A+12>>2]=f+4,i[f>>2]=i[A+8>>2]}w=n,h=Nu(r,i[A+176>>2],k),t0[w>>3]=h,l4(A+192|0,A+16|0,i[A+12>>2],k),L2(A+252|0,A+248|0)&&(i[k>>2]=i[k>>2]|2),r=i[A+252>>2],s2(e),s2(A+192|0),v=A+256|0;break i}f=1}q1(A+252|0);continue}break}return r|0}function uZ(A,e,r,f,k,n){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0;var t=0,o=0,s=0,w=0,h=U(0);for(A=v-352|0,v=A,i[A+344>>2]=r,i[A+348>>2]=e,DA(A+204|0,f,A+224|0,A+220|0,A+216|0),r=v-16|0,v=r,e=A+192|0,i[e>>2]=0,i[e+4>>2]=0,i[e+8>>2]=0,v=r+16|0,W2(e,l[e+11|0]>>>7|0?(i[e+8>>2]&2147483647)-1|0:10),l[e+11|0]>>>7|0?r=i[e>>2]:r=e,i[A+188>>2]=r,i[A+12>>2]=A+16,i[A+8>>2]=0,u[A+7|0]=1,u[A+6|0]=69,f=0;;){i:{e:{r:{f:{if(K2(A+348|0,A+344|0))break f;o=i[A+188>>2],l[e+11|0]>>>7|0?t=i[e+4>>2]:t=l[e+11|0]&127,(o|0)==(t+r|0)&&(l[e+11|0]>>>7|0?r=i[e+4>>2]:r=l[e+11|0]&127,l[e+11|0]>>>7|0?t=i[e+4>>2]:t=l[e+11|0]&127,W2(e,t<<1),W2(e,l[e+11|0]>>>7|0?(i[e+8>>2]&2147483647)-1|0:10),t=r,l[e+11|0]>>>7|0?r=i[e>>2]:r=e,i[A+188>>2]=t+r),t=i[A+348>>2],o=i[t+12>>2];A:{if((o|0)==i[t+16>>2]){t=W[i[i[t>>2]+36>>2]](t)|0;break A}t=i[o>>2]}if(jf(t,A+7|0,A+6|0,r,A+188|0,i[A+220>>2],i[A+216>>2],A+204|0,A+16|0,A+12|0,A+8|0,A+224|0))break f;if(f)break r;if(f=0,o=i[A+188>>2]-r|0,(o|0)<=0)break e;A:{k:switch(t=l[r|0],s=t-43|0,s|0){case 0:case 2:break A;default:break k}if((t|0)==46)break r;if(f=1,(t-48&255)>>>0<10)break e;break f}if((o|0)==1)break e;A:switch(s|0){case 0:case 2:break A;default:break e}if(t=l[r+1|0],(t|0)==46)break r;if(f=1,(t-48&255)>>>0<=9)break e}l[A+215|0]>>>7|0?f=i[A+208>>2]:f=l[A+215|0]&127;f:{if(!f|!(u[A+7|0]&1)||(f=i[A+12>>2],(f-(A+16|0)|0)>159))break f;i[A+12>>2]=f+4,i[f>>2]=i[A+8>>2]}w=n,h=Eu(r,i[A+188>>2],k),p0[w>>2]=h,l4(A+204|0,A+16|0,i[A+12>>2],k),K2(A+348|0,A+344|0)&&(i[k>>2]=i[k>>2]|2),r=i[A+348>>2],s2(e),s2(A+204|0),v=A+352|0;break i}f=1}a1(A+348|0);continue}break}return r|0}function oZ(A,e,r,f,k,n){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0;var t=0,o=0,s=0,w=0,h=0;for(A=v-352|0,v=A,i[A+344>>2]=r,i[A+348>>2]=e,DA(A+204|0,f,A+224|0,A+220|0,A+216|0),r=v-16|0,v=r,e=A+192|0,i[e>>2]=0,i[e+4>>2]=0,i[e+8>>2]=0,v=r+16|0,W2(e,l[e+11|0]>>>7|0?(i[e+8>>2]&2147483647)-1|0:10),l[e+11|0]>>>7|0?r=i[e>>2]:r=e,i[A+188>>2]=r,i[A+12>>2]=A+16,i[A+8>>2]=0,u[A+7|0]=1,u[A+6|0]=69,f=0;;){i:{e:{r:{f:{if(K2(A+348|0,A+344|0))break f;o=i[A+188>>2],l[e+11|0]>>>7|0?t=i[e+4>>2]:t=l[e+11|0]&127,(o|0)==(t+r|0)&&(l[e+11|0]>>>7|0?r=i[e+4>>2]:r=l[e+11|0]&127,l[e+11|0]>>>7|0?t=i[e+4>>2]:t=l[e+11|0]&127,W2(e,t<<1),W2(e,l[e+11|0]>>>7|0?(i[e+8>>2]&2147483647)-1|0:10),t=r,l[e+11|0]>>>7|0?r=i[e>>2]:r=e,i[A+188>>2]=t+r),t=i[A+348>>2],o=i[t+12>>2];A:{if((o|0)==i[t+16>>2]){t=W[i[i[t>>2]+36>>2]](t)|0;break A}t=i[o>>2]}if(jf(t,A+7|0,A+6|0,r,A+188|0,i[A+220>>2],i[A+216>>2],A+204|0,A+16|0,A+12|0,A+8|0,A+224|0))break f;if(f)break r;if(f=0,o=i[A+188>>2]-r|0,(o|0)<=0)break e;A:{k:switch(t=l[r|0],s=t-43|0,s|0){case 0:case 2:break A;default:break k}if((t|0)==46)break r;if(f=1,(t-48&255)>>>0<10)break e;break f}if((o|0)==1)break e;A:switch(s|0){case 0:case 2:break A;default:break e}if(t=l[r+1|0],(t|0)==46)break r;if(f=1,(t-48&255)>>>0<=9)break e}l[A+215|0]>>>7|0?f=i[A+208>>2]:f=l[A+215|0]&127;f:{if(!f|!(u[A+7|0]&1)||(f=i[A+12>>2],(f-(A+16|0)|0)>159))break f;i[A+12>>2]=f+4,i[f>>2]=i[A+8>>2]}w=n,h=Nu(r,i[A+188>>2],k),t0[w>>3]=h,l4(A+204|0,A+16|0,i[A+12>>2],k),K2(A+348|0,A+344|0)&&(i[k>>2]=i[k>>2]|2),r=i[A+348>>2],s2(e),s2(A+204|0),v=A+352|0;break i}f=1}a1(A+348|0);continue}break}return r|0}function v1(A,e){var r=0,f=0,k=0,n=0,t=0,o=0,s=0;if(n=v-16|0,v=n,i[A+4>>2]=i[A+4>>2]+1,r=v-16|0,v=r,i[r+12>>2]=A,i[n+12>>2]=i[r+12>>2],v=r+16|0,r=i[32396],i[32397]-r>>2>>>0<=e>>>0)i:{if(A=e+1|0,f=i[32397],r=f-r>>2,A>>>0>r>>>0){s=v-32|0,v=s,t=A-r|0;e:{if(t>>>0<=i[32398]-f>>2>>>0){Qo(t);break e}f=s+12|0,r=v-16|0,v=r,k=t+(i[32397]-i[32396]>>2)|0,i[r+12>>2]=k;r:{if(A=Po(),k>>>0<=A>>>0){k=i[32398]-i[32396]>>2,k>>>0<A>>>1>>>0&&(i[r+8>>2]=k<<1,A=v-16|0,v=A,v=A+16|0,A=r+12|0,k=r+8|0,A=i[(u0[k>>2]<u0[A>>2]?A:k)>>2]),v=r+16|0,r=A;break r}Z4(),H()}for(o=i[32397]-i[32396]>>2,A=0,k=v-16|0,v=k,i[k+12>>2]=0,i[f+12>>2]=0,i[f+16>>2]=129596,r?(wl(k+4|0,i[f+16>>2],r),A=i[k+4>>2],r=i[k+8>>2]):r=0,i[f>>2]=A,o=(o<<2)+A|0,i[f+8>>2]=o,i[f+4>>2]=o,i[f+12>>2]=(r<<2)+A,v=k+16|0,r=v-16|0,v=r,A=i[f+8>>2],i[r+12>>2]=f+8,i[r+4>>2]=A,i[r+8>>2]=A+(t<<2),A=i[r+4>>2];;){if(i[r+8>>2]!=(A|0)){i[i[r+4>>2]>>2]=0,A=i[r+4>>2]+4|0,i[r+4>>2]=A;continue}break}for(i[i[r+12>>2]>>2]=i[r+4>>2],v=r+16|0,A=i[32396],k=i[32397],r=i[f+4>>2]+(A-k|0)|0,k=k-A|0,k&&x(r,A,k),i[f+4>>2]=r,i[32397]=i[32396],A=i[32396],i[32396]=i[f+4>>2],i[f+4>>2]=A,A=i[32397],i[32397]=i[f+8>>2],i[f+8>>2]=A,A=i[32398],i[32398]=i[f+12>>2],i[f+12>>2]=A,i[f>>2]=i[f+4>>2],A=i[f+4>>2];;){if(r=i[f+8>>2],(r|0)!=(A|0)){i[f+8>>2]=r-4;continue}break}A=i[f>>2],A&&Sl(i[f+16>>2],A)}v=s+32|0;break i}A>>>0<r>>>0&&jl(129584,i[32396]+(A<<2)|0)}A=i[i[32396]+(e<<2)>>2],A&&(r=i[A+4>>2]-1|0,i[A+4>>2]=r,(r|0)==-1&&W[i[i[A>>2]+8>>2]](A)),A=i[n+12>>2],i[n+12>>2]=0,i[i[32396]+(e<<2)>>2]=A,A=i[n+12>>2],i[n+12>>2]=0,A&&(e=i[A+4>>2]-1|0,i[A+4>>2]=e,(e|0)==-1&&W[i[i[A>>2]+8>>2]](A)),v=n+16|0}function lZ(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,t=0,o=0,s=0;f=v-160|0,v=f,i[f+92>>2]=0,i[f+64>>2]=72500,k=i[18128],i[f+8>>2]=k,n=i[k-12>>2],k=f+8|0,i[n+k>>2]=i[18129],t=k+i[i[f+8>>2]-12>>2]|0,n=f+12|0,J0(t,n),u[t+80|0]=0,i[t+72>>2]=0,i[f+64>>2]=72500,i[f+8>>2]=72480,t=R0(n),i[t>>2]=71232,i[f+52>>2]=0,i[f+56>>2]=0,i[f+44>>2]=0,i[f+48>>2]=0,i[f+60>>2]=16,n=f+148|0,U1(n,e,r),s=k,o=n,k=u[f+159|0],n=(k|0)<0,Y(s,n?i[f+148>>2]:o,n?i[f+152>>2]:k),u[f+159|0]<0&&Z(i[f+148>>2]),k=f+148|0,s0(k,r),o=k,k=u[f+159|0],n=(k|0)<0,Y(f+8|0,n?i[f+148>>2]:o,n?i[f+152>>2]:k),u[f+159|0]<0&&Z(i[f+148>>2]),Y(V0(Y(f+8|0,29628,14),i[e+108>>2]),42670,1);i:{if(!i[e+104>>2]){if(i[e+116>>2]==i[e+112>>2])break i;for(k=0;n=f+148|0,s0(n,r),o=n,n=u[f+159|0],s=(n|0)<0,Y(f+8|0,s?i[f+148>>2]:o,s?i[f+152>>2]:n),u[f+159|0]<0&&Z(i[f+148>>2]),Y(V0(Y(V0(Y(f+8|0,19205,1),k),32722,4),i[i[e+112>>2]+(k<<2)>>2]),42670,1),k=k+1|0,k>>>0<i[e+116>>2]-i[e+112>>2]>>2>>>0;);break i}k=f+148|0,s0(k,r),n=k,r=u[f+159|0],k=(r|0)<0,Y(f+8|0,k?i[f+148>>2]:n,k?i[f+152>>2]:r),u[f+159|0]<0&&Z(i[f+148>>2]),Y(V0(Y(f+8|0,31280,19),i[e+104>>2]),42670,1)}e=i[f+60>>2];i:{e:{if(e&16){k=i[f+56>>2],e=i[f+36>>2],k>>>0<e>>>0&&(i[f+56>>2]=e,k=e),e=f+32|0;break e}if(!(e&8)){k=0,u[A+11|0]=0;break i}k=i[f+28>>2],e=f+20|0}e:{if(r=i[e>>2],k=k-r|0,k>>>0<2147483640){if(k>>>0>=11){n=k|7,e=p(n+1|0),i[A+8>>2]=n-2147483647,i[A>>2]=e,i[A+4>>2]=k,A=e;break e}if(u[A+11|0]=k,k)break e;k=0;break i}Q0(),H()}if(!k)break i;x(A,r,k)}u[A+k|0]=0,A=i[18127],i[f+8>>2]=A,i[i[A-12>>2]+(f+8|0)>>2]=i[18130],i[t>>2]=71232,u[f+55|0]<0&&Z(i[f+44>>2]),E0(t),y0(f- -64|0),v=f+160|0}function sZ(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,t=0,o=0,s=0,w=0,h=0,_=0,B=0;k=v-48|0,v=k,i[k+44>>2]=0,i[k+36>>2]=0,i[k+40>>2]=0;i:{if(!A){A=i[13084],i[k+24>>2]=i[13083],i[k+28>>2]=A,A=i[13082],i[k+16>>2]=i[13081],i[k+20>>2]=A,A=i[13080],i[k+8>>2]=i[13079],i[k+12>>2]=A,k6(k+36|0,k+8|0,k+32|0,6);break i}n=p(4),i[n>>2]=A,A=n+4|0,i[k+44>>2]=A,i[k+36>>2]=n,i[k+40>>2]=A}Je();i:{if(n=i[26926],(n|0)==107708|i[k+36>>2]==i[k+40>>2])break i;e:{for(;;){r:{A=i[k+36>>2],f=i[k+40>>2];f:{if((A|0)==(f|0))break f;for(h=i[n+16>>2];;){if(_=W[i[h+16>>2]](i[A>>2])|0,!_){if(A=A+4|0,(f|0)!=(A|0))continue;break f}break}if(o>>>0<t>>>0){i[o+4>>2]=_,i[o>>2]=h,o=o+8|0;break f}if(A=o-s|0,B=A>>3,f=B+1|0,f>>>0>=536870912)break r;if(t=t-s|0,o=t>>2,w=t>>>0>=2147483640?536870911:f>>>0<o>>>0?o:f,w){if(w>>>0>=536870912)break e;t=p(w<<3)}else t=0;o=A+t|0,i[o+4>>2]=_,i[o>>2]=h,f=o-(B<<3)|0,A&&x(f,s,A),o=o+8|0,t=(w<<3)+t|0,s&&Z(s),s=f}f=i[n+4>>2];f:{if(f){for(;;)if(A=f,f=i[A>>2],!f)break f}for(;A=i[n+8>>2],f=i[A>>2]!=(n|0),n=A,!!f;);}if(n=A,(A|0)!=107708)continue;break i}break}Q5(6307),H()}z0(),H()}n=o-s>>3;i:{if(!e||(A=0,T7(s,o,(o|0)!=(s|0)?62-(k1(n)<<1)|0:0,1),n=(r|0)>(n|0)?n:r,(n|0)<=0))break i;if(n>>>0>=4)for(r=n&2147483644,f=0;i[(A<<2)+e>>2]=i[(A<<3)+s>>2],t=A|1,i[(t<<2)+e>>2]=i[(t<<3)+s>>2],t=A|2,i[(t<<2)+e>>2]=i[(t<<3)+s>>2],t=A|3,i[(t<<2)+e>>2]=i[(t<<3)+s>>2],A=A+4|0,f=f+4|0,(r|0)!=(f|0););if(r=n&3,!r)break i;for(f=0;i[(A<<2)+e>>2]=i[(A<<3)+s>>2],A=A+1|0,f=f+1|0,(r|0)!=(f|0););}return A=i[k+36>>2],A&&(i[k+40>>2]=A,Z(A)),s&&Z(s),v=k+48|0,n|0}function c9(A,e){var r=0,f=0,k=0,n=0,t=0,o=0;k=v-32|0,v=k;i:{if(n=i[A>>2],t=i[A+4>>2]-n|0,o=(t>>5)+1|0,o>>>0<134217728){if(f=i[A+8>>2],i[k+28>>2]=A+8,n=f-n|0,f=n>>4,f=n>>>0>=2147483616?134217727:f>>>0>o>>>0?f:o,f){if(f>>>0>=134217728)break i;r=p(f<<5)}if(i[k+12>>2]=r,i[k+24>>2]=(f<<5)+r,f=r+t|0,i[k+16>>2]=f,r=i[e+12>>2],i[f+8>>2]=i[e+8>>2],i[f+12>>2]=r,r=i[e+4>>2],i[f>>2]=i[e>>2],i[f+4>>2]=r,i[f+24>>2]=0,i[f+16>>2]=0,i[f+20>>2]=0,r=i[e+16>>2],e=i[e+20>>2],oA(f+16|0,r,e,(e-r|0)/40|0),i[k+20>>2]=f+32,t=A,r=i[A>>2],o=i[A+4>>2],f=i[k+16>>2]+(r-o|0)|0,(r|0)!=(o|0)){for(e=r,A=f;n=i[e+4>>2],i[A>>2]=i[e>>2],i[A+4>>2]=n,n=i[e+12>>2],i[A+8>>2]=i[e+8>>2],i[A+12>>2]=n,i[A+24>>2]=0,i[A+16>>2]=0,i[A+20>>2]=0,i[A+16>>2]=i[e+16>>2],i[A+20>>2]=i[e+20>>2],i[A+24>>2]=i[e+24>>2],i[e+24>>2]=0,i[e+16>>2]=0,i[e+20>>2]=0,A=A+32|0,e=e+32|0,(o|0)!=(e|0););for(;;){if(n=i[r+16>>2],n){if(A=n,e=i[r+20>>2],(A|0)!=(e|0)){for(;A=i[e-16>>2],A&&(i[e-12>>2]=A,Z(A)),e=e-40|0,(n|0)!=(e|0););A=i[r+16>>2]}i[r+20>>2]=n,Z(A)}if(r=r+32|0,(o|0)==(r|0))break}r=i[t>>2]}if(i[k+16>>2]=f,i[t+4>>2]=r,i[t>>2]=i[k+16>>2],i[k+16>>2]=r,A=i[t+4>>2],i[t+4>>2]=i[k+20>>2],i[k+20>>2]=A,A=i[t+8>>2],i[t+8>>2]=i[k+24>>2],i[k+24>>2]=A,i[k+12>>2]=i[k+16>>2],o=i[t+4>>2],e=i[k+20>>2],f=i[k+16>>2],(e|0)!=(f|0))for(;;){if(A=e-32|0,i[k+20>>2]=A,t=e-16|0,n=i[t>>2],n){if(e=e-12|0,A=i[e>>2],r=n,(A|0)!=(r|0)){for(;r=i[A-16>>2],r&&(i[A-12>>2]=r,Z(r)),A=A-40|0,(n|0)!=(A|0););r=i[t>>2]}i[e>>2]=n,Z(r),A=i[k+20>>2]}if(e=A,(f|0)==(e|0))break}return A=i[k+12>>2],A&&Z(A),v=k+32|0,o}G0(),H()}z0(),H()}function wZ(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,t=0,o=0,s=0;f=v-176|0,v=f,i[f+108>>2]=0,i[f+80>>2]=72500,n=i[18128],i[f+24>>2]=n,k=i[n-12>>2],n=f+24|0,i[k+n>>2]=i[18129],o=n+i[i[f+24>>2]-12>>2]|0,k=f+28|0,J0(o,k),u[o+80|0]=0,i[o+72>>2]=0,i[f+80>>2]=72500,i[f+24>>2]=72480,o=R0(k),i[o>>2]=71232,i[f+68>>2]=0,i[f+72>>2]=0,i[f+60>>2]=0,i[f+64>>2]=0,i[f+76>>2]=16,k=f+164|0,Y2(k,e,r),s=n,t=k,n=u[f+175|0],k=(n|0)<0,Y(s,k?i[f+164>>2]:t,k?i[f+168>>2]:n),u[f+175|0]<0&&Z(i[f+164>>2]),n=f+164|0,s0(n,r),t=n,n=u[f+175|0],k=(n|0)<0,Y(f+24|0,k?i[f+164>>2]:t,k?i[f+168>>2]:n),u[f+175|0]<0&&Z(i[f+164>>2]),n=Y(V0(Y(f+24|0,32199,13),i[e+104>>2]),42670,1),k=f+164|0,s0(k,r),t=k,k=u[f+175|0],s=(k|0)<0,Y(n,s?i[f+164>>2]:t,s?i[f+168>>2]:k),u[f+175|0]<0&&Z(i[f+164>>2]),n=Y(n,31592,14),k=f+12|0,L1(k,i[e+108>>2]),s=n,t=k,n=u[f+23|0],k=(n|0)<0,n=Y(Y(s,k?i[f+12>>2]:t,k?i[f+16>>2]:n),42670,1),k=f+164|0,s0(k,r),t=k,r=u[f+175|0],k=(r|0)<0,Y(n,k?i[f+164>>2]:t,k?i[f+168>>2]:r),u[f+175|0]<0&&Z(i[f+164>>2]),k=Y(n,31854,6),r=u[e+135|0],n=(r|0)<0,Y(Y(k,n?i[e+124>>2]:e+124|0,n?i[e+128>>2]:r),42670,1),u[f+23|0]<0&&Z(i[f+12>>2]),e=i[f+76>>2];i:{e:{if(e&16){e=i[f+72>>2],r=i[f+52>>2],e>>>0<r>>>0&&(i[f+72>>2]=r,e=r),r=f+48|0;break e}if(!(e&8)){e=0,u[A+11|0]=0;break i}e=i[f+44>>2],r=f+36|0}e:{if(n=i[r>>2],e=e-n|0,e>>>0<2147483640){if(e>>>0>=11){k=e|7,r=p(k+1|0),i[A+8>>2]=k-2147483647,i[A>>2]=r,i[A+4>>2]=e,A=r;break e}if(u[A+11|0]=e,e)break e;e=0;break i}Q0(),H()}if(!e)break i;x(A,n,e)}u[A+e|0]=0,A=i[18127],i[f+24>>2]=A,i[i[A-12>>2]+(f+24|0)>>2]=i[18130],i[o>>2]=71232,u[f+71|0]<0&&Z(i[f+60>>2]),E0(o),y0(f+80|0),v=f+176|0}function b9(A,e,r,f,k,n,t){var o=0,s=0,w=0,h=0,_=0,B=0,m=0,X=0,Q=0,V=0,F=0;B=v-16|0,v=B,w=c0(t,129752),X=c0(t,129824),t=X,W[i[i[t>>2]+20>>2]](B+4|0,t),i[n>>2]=f;i:{e:switch(s=A,t=l[s|0],t-43|0){case 0:case 2:break e;default:break i}t=W[i[i[w>>2]+44>>2]](w,t<<24>>24)|0,o=i[n>>2],i[n>>2]=o+4,i[o>>2]=t,s=A+1|0}i:{if(t=s,!((r-t|0)<=1|l[t|0]!=48|(l[t+1|0]|32)!=120))for(o=W[i[i[w>>2]+44>>2]](w,48)|0,s=i[n>>2],i[n>>2]=s+4,i[s>>2]=o,o=W[i[i[w>>2]+44>>2]](w,u[t+1|0])|0,s=i[n>>2],i[n>>2]=s+4,i[s>>2]=o,s=t+2|0,t=s;;){if(r>>>0<=t>>>0||(o=u[t|0],a2(),!(o-48>>>0<10|(o|32)-97>>>0<6)))break i;t=t+1|0}for(;;){if(r>>>0<=t>>>0||(o=u[t|0],a2(),o-48>>>0>=10))break i;t=t+1|0}}l[B+15|0]>>>7|0?o=i[B+8>>2]:o=l[B+15|0]&127;i:{if(!o){W[i[i[w>>2]+48>>2]](w,s,t,i[n>>2])|0,i[n>>2]=i[n>>2]+(t-s<<2);break i}for(N6(s,t),V=W[i[i[X>>2]+16>>2]](X)|0,o=s;;){if(t>>>0<=o>>>0)cr((s-A<<2)+f|0,i[n>>2]);else{h=B+4|0;e:{if(l[h+11|0]>>>7|0){m=i[h>>2];break e}m=h}F=u[m+Q|0]<=0,l[h+11|0]>>>7|0?m=i[h>>2]:m=h,F|u[m+Q|0]!=(_|0)||(_=i[n>>2],i[n>>2]=_+4,i[_>>2]=V,l[h+11|0]>>>7|0?h=i[h+4>>2]:h=l[h+11|0]&127,Q=(h-1>>>0>Q>>>0)+Q|0,_=0),h=W[i[i[w>>2]+44>>2]](w,u[o|0])|0,m=i[n>>2],i[n>>2]=m+4,i[m>>2]=h,o=o+1|0,_=_+1|0;continue}break}}i:{e:{for(;;){if(r>>>0<=t>>>0)break e;if(o=t+1|0,t=u[t|0],(t|0)!=46){t=W[i[i[w>>2]+44>>2]](w,t)|0,s=i[n>>2],i[n>>2]=s+4,i[s>>2]=t,t=o;continue}break}t=W[i[i[X>>2]+12>>2]](X)|0,s=i[n>>2],_=s+4|0,i[n>>2]=_,i[s>>2]=t;break i}_=i[n>>2],o=t}W[i[i[w>>2]+48>>2]](w,o,r,_)|0,t=n,n=i[n>>2]+(r-o<<2)|0,i[t>>2]=n,i[k>>2]=(e|0)==(r|0)?n:(e-A<<2)+f|0,s2(B+4|0),v=B+16|0}function Hf(A,e,r,f,k){var n=0,t=0,o=0,s=0,w=0,h=0,_=0,B=0,m=0,X=0,Q=0,V=0,F=0;t=v-32|0,v=t,h=i[e+512>>2],n=f,f=i[e+460>>2],k=n+G(((f+i[e+452>>2]|0)-1>>>0)/(f>>>0)|0,k)|0,B=k<<4,f=h+B|0;i:{e:{if(i[f>>2]!=10|i[f+4>>2])break e;for(_=v-16|0,v=_,V=e+448|0,f=i[e+516>>2]-h>>4,s=u0[e+536>>2]/(l[e+473|0]+l[e+472|0]>>>3>>>0)|0,o=k;;){r:{if(o=o+1|0,m=o-k|0,f>>>0<=o>>>0|s>>>0<=m>>>0)break r;if(n=(o<<4)+h|0,w=i[n>>2],!i[n+4>>2]&(w|0)==10)continue}break}X=k>>>0>s>>>0?s:k,F=k-X|0,n=k;r:{for(;;){f:{if(f=n,!f||(w=k-f|0,w>>>0>=s>>>0))break f;if(n=f-1|0,Q=(n<<4)+h|0,!i[Q+4>>2]&i[Q>>2]==10)continue;break r}break}f=F,w=X}r:{if(o-f>>>0<=s>>>0)break r;if(w>>>0<m>>>0){o=f+s|0;break r}f=o-s|0}n=_+8|0,k=i[e+100>>2],i[n>>2]=i[k+48>>2],k=i[k+52>>2],i[n+4>>2]=k,k&&(i[k+4>>2]=i[k+4>>2]+1),c7(A,V,n,i[e+116>>2],f,o,0),f=i[_+12>>2];r:{if(!f||(k=i[f+4>>2],i[f+4>>2]=k-1,k))break r;W[i[i[f>>2]+8>>2]](f),y(f)}if(v=_+16|0,i[A>>2])break i;if(u[A+19|0]>=0)break e;Z(i[A+8>>2])}n=i[e+512>>2]+B|0,f=i[n+8>>2],k=i[n>>2],o=i[n+4>>2],n=i[e+100>>2],i[t>>2]=i[n+48>>2],n=i[n+52>>2],i[t+4>>2]=n,n&&(i[n+4>>2]=i[n+4>>2]+1),gr(t+8|0,i[t>>2],i[e+116>>2],r,k,o,f,0),e=i[t+4>>2];e:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break e;W[i[i[e>>2]+8>>2]](e),y(e)}e=A+8|0;e:{if(i[t+8>>2]){r=i[t+12>>2],i[A>>2]=i[t+8>>2],i[A+4>>2]=r,i[e+8>>2]=i[t+24>>2],A=i[t+20>>2],i[e>>2]=i[t+16>>2],i[e+4>>2]=A,i[t+24>>2]=0,i[t+16>>2]=0,i[t+20>>2]=0;break e}if(r=i[26917],i[A>>2]=i[26916],i[A+4>>2]=r,u[107683]>=0){A=i[26919],i[e>>2]=i[26918],i[e+4>>2]=A,i[e+8>>2]=i[26920];break e}T(e,i[26918],i[26919])}if(u[t+27|0]>=0)break i;Z(i[t+16>>2])}v=t+32|0}function hZ(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,t=0,o=0,s=0;f=v-160|0,v=f,i[f+92>>2]=0,i[f+64>>2]=72500,k=i[18128],i[f+8>>2]=k,n=i[k-12>>2],k=f+8|0,i[n+k>>2]=i[18129],o=k+i[i[f+8>>2]-12>>2]|0,n=f+12|0,J0(o,n),u[o+80|0]=0,i[o+72>>2]=0,i[f+64>>2]=72500,i[f+8>>2]=72480,o=R0(n),i[o>>2]=71232,i[f+52>>2]=0,i[f+56>>2]=0,i[f+44>>2]=0,i[f+48>>2]=0,i[f+60>>2]=16,n=f+148|0,Y2(n,e,r),s=k,t=n,k=u[f+159|0],n=(k|0)<0,Y(s,n?i[f+148>>2]:t,n?i[f+152>>2]:k),u[f+159|0]<0&&Z(i[f+148>>2]);i:{if(i[e+100>>2]){if(k=f+148|0,s0(k,r),t=k,k=u[f+159|0],n=(k|0)<0,Y(f+8|0,n?i[f+148>>2]:t,n?i[f+152>>2]:k),u[f+159|0]<0&&Z(i[f+148>>2]),k=Y(f+8|0,31578,13),n=f+148|0,t=i[e+100>>2],L1(n,W[i[i[t>>2]+8>>2]](t)|0),s=k,t=n,k=u[f+159|0],n=(k|0)<0,Y(Y(s,n?i[f+148>>2]:t,n?i[f+152>>2]:k),42670,1),u[f+159|0]<0&&Z(i[f+148>>2]),k=f+148|0,e=i[e+100>>2],W[i[i[e>>2]+12>>2]](k,e,r),e=u[f+159|0],r=(e|0)<0,Y(f+8|0,r?i[f+148>>2]:k,r?i[f+152>>2]:e),u[f+159|0]>=0)break i;Z(i[f+148>>2]);break i}e=f+148|0,s0(e,r),k=e,e=u[f+159|0],r=(e|0)<0,Y(f+8|0,r?i[f+148>>2]:k,r?i[f+152>>2]:e),u[f+159|0]<0&&Z(i[f+148>>2]),e=f+8|0,Y(e,42305,17),Y(e,33368,17)}e=i[f+60>>2];i:{e:{if(e&16){e=i[f+56>>2],r=i[f+36>>2],e>>>0<r>>>0&&(i[f+56>>2]=r,e=r),r=f+32|0;break e}if(!(e&8)){e=0,u[A+11|0]=0;break i}e=i[f+28>>2],r=f+20|0}e:{if(k=i[r>>2],e=e-k|0,e>>>0<2147483640){if(e>>>0>=11){n=e|7,r=p(n+1|0),i[A+8>>2]=n-2147483647,i[A>>2]=r,i[A+4>>2]=e,A=r;break e}if(u[A+11|0]=e,e)break e;e=0;break i}Q0(),H()}if(!e)break i;x(A,k,e)}u[A+e|0]=0,A=i[18127],i[f+8>>2]=A,i[i[A-12>>2]+(f+8|0)>>2]=i[18130],i[o>>2]=71232,u[f+55|0]<0&&Z(i[f+44>>2]),E0(o),y0(f- -64|0),v=f+160|0}function Zr(A){var e=0,r=0,f=0,k=0,n=0,t=0,o=0,s=0,w=0,h=0;i[A+128>>2]=0,i[A+132>>2]=0,o0(A,0,124),i[A+136>>2]=0,i[A+140>>2]=0,i[A+124>>2]=A+128,i[A+144>>2]=0,i[A+148>>2]=0,i[A+152>>2]=0,i[A+156>>2]=0,s=p(96),i[s>>2]=94944,i[s+4>>2]=0,i[s+8>>2]=0,f=s+16|0,e=f,i[e+16>>2]=0,i[e+20>>2]=0,i[e+8>>2]=-1,i[e+12>>2]=-1,i[e>>2]=1,i[e+56>>2]=0,i[e+60>>2]=0,i[e+24>>2]=0,i[e+28>>2]=0,i[e+32>>2]=0,i[e+36>>2]=0,i[e+40>>2]=0,i[e+44>>2]=0,i[e+48>>2]=0,e=e- -64|0,i[e>>2]=0,i[e+4>>2]=0,i[f+72>>2]=0,i[f+76>>2]=0,e=p(136),i[e>>2]=89724,i[e+4>>2]=0,i[e+8>>2]=0,o=e+16|0,r=o,i[r+8>>2]=0,i[r+12>>2]=0,i[r+16>>2]=0,i[r+20>>2]=0,i[r+24>>2]=0,i[r+28>>2]=0,i[r+32>>2]=0,i[r>>2]=86356,i[e+60>>2]=0,i[e+64>>2]=0,i[e+52>>2]=0,i[e+56>>2]=0,i[e+88>>2]=0,i[e+92>>2]=0,i[e+72>>2]=-1,i[e+76>>2]=-1,i[e+96>>2]=0,i[e+100>>2]=0,i[e+104>>2]=0,i[e+108>>2]=0,u[e+112|0]=0,i[r>>2]=86884,i[e+132>>2]=0,i[e+124>>2]=0,i[e+128>>2]=0,i[e+116>>2]=0,i[e+120>>2]=0,i[e+80>>2]=0,i[e+84>>2]=0,i[e+32>>2]=1718909296,i[e+4>>2]=i[e+4>>2]+1;i:{e:{r:{r=i[f+20>>2],k=i[f+24>>2];f:{if(r>>>0<k>>>0){i[r+4>>2]=e,i[r>>2]=o,r=r+8|0;break f}if(w=i[f+16>>2],r=r-w|0,h=r>>3,n=h+1|0,n>>>0>=536870912)break r;if(k=k-w|0,t=k>>2,k=k>>>0>=2147483640?536870911:t>>>0>n>>>0?t:n,k){if(k>>>0>=536870912)break e;n=p(k<<3)}else n=0;if(t=n+r|0,i[t+4>>2]=e,i[t>>2]=o,o=t-(h<<3)|0,r&&x(o,w,r),i[f+24>>2]=n+(k<<3),r=t+8|0,i[f+20>>2]=r,i[f+16>>2]=o,!w)break f;Z(w)}i[f+20>>2]=r,r=i[e+4>>2],i[e+4>>2]=r-1,r||(W[i[i[e>>2]+8>>2]](e),y(e));break i}G0(),H()}z0(),H()}i[A>>2]=f,e=i[A+4>>2],i[A+4>>2]=s;i:{if(!e||(f=i[e+4>>2],i[e+4>>2]=f-1,f))break i;W[i[i[e>>2]+8>>2]](e),y(e)}return A}function en(A,e,r,f,k,n,t){var o=0,s=0,w=0,h=0,_=0,B=0,m=0,X=0,Q=0,V=0,F=0;_=v-16|0,v=_,w=c0(t,129760),X=c0(t,129816),t=X,W[i[i[t>>2]+20>>2]](_+4|0,t),i[n>>2]=f;i:{e:switch(s=A,t=l[s|0],t-43|0){case 0:case 2:break e;default:break i}t=W[i[i[w>>2]+28>>2]](w,t<<24>>24)|0,o=i[n>>2],i[n>>2]=o+1,u[o|0]=t,s=A+1|0}i:{if(t=s,!((r-t|0)<=1|l[t|0]!=48|(l[t+1|0]|32)!=120))for(o=W[i[i[w>>2]+28>>2]](w,48)|0,s=i[n>>2],i[n>>2]=s+1,u[s|0]=o,o=W[i[i[w>>2]+28>>2]](w,u[t+1|0])|0,s=i[n>>2],i[n>>2]=s+1,u[s|0]=o,s=t+2|0,t=s;;){if(r>>>0<=t>>>0||(o=u[t|0],a2(),!(o-48>>>0<10|(o|32)-97>>>0<6)))break i;t=t+1|0}for(;;){if(r>>>0<=t>>>0||(o=u[t|0],a2(),o-48>>>0>=10))break i;t=t+1|0}}l[_+15|0]>>>7|0?o=i[_+8>>2]:o=l[_+15|0]&127;i:{if(!o){W[i[i[w>>2]+32>>2]](w,s,t,i[n>>2])|0,i[n>>2]=i[n>>2]+(t-s|0);break i}for(N6(s,t),V=W[i[i[X>>2]+16>>2]](X)|0,o=s;;){if(t>>>0<=o>>>0)N6((s-A|0)+f|0,i[n>>2]);else{h=_+4|0;e:{if(l[h+11|0]>>>7|0){B=i[h>>2];break e}B=h}F=u[B+Q|0]<=0,l[h+11|0]>>>7|0?B=i[h>>2]:B=h,F|u[B+Q|0]!=(m|0)||(m=i[n>>2],i[n>>2]=m+1,u[m|0]=V,l[h+11|0]>>>7|0?h=i[h+4>>2]:h=l[h+11|0]&127,Q=(h-1>>>0>Q>>>0)+Q|0,m=0),h=W[i[i[w>>2]+28>>2]](w,u[o|0])|0,B=i[n>>2],i[n>>2]=B+1,u[B|0]=h,o=o+1|0,m=m+1|0;continue}break}}for(;;){i:{e:{if(r>>>0<=t>>>0){o=t;break e}if(o=t+1|0,t=u[t|0],(t|0)!=46)break i;t=W[i[i[X>>2]+12>>2]](X)|0,s=i[n>>2],i[n>>2]=s+1,u[s|0]=t}W[i[i[w>>2]+32>>2]](w,o,r,i[n>>2])|0,t=n,n=i[n>>2]+(r-o|0)|0,i[t>>2]=n,i[k>>2]=(e|0)==(r|0)?n:(e-A|0)+f|0,s2(_+4|0),v=_+16|0;return}t=W[i[i[w>>2]+28>>2]](w,t)|0,s=i[n>>2],i[n>>2]=s+1,u[s|0]=t,t=o}}function _Z(A,e){A=A|0,e=e|0;var r=0,f=0,k=0,n=0,t=0;n=v-16|0,v=n;i:{e:{r:{if(r=i[e+104>>2],f=i[e+108>>2],(r|0)!=(f|0))for(;;){f:{if(k=i[r>>2],!k||(k=W0(k,86580,99476),!k))break f;f=i[r+4>>2],f&&(i[f+4>>2]=i[f+4>>2]+1),r=p(88),i[r+4>>2]=0,i[r+8>>2]=0,i[r>>2]=97200,f&&(i[f+4>>2]=i[f+4>>2]+1),t=r+16|0,i[r+64>>2]=0,i[r+56>>2]=0,i[r+60>>2]=0,i[r+24>>2]=0,i[r+28>>2]=0,i[r+36>>2]=0,i[r+40>>2]=0,i[r+72>>2]=0,i[r+76>>2]=0,i[r+84>>2]=f,i[r+80>>2]=k,u[r+32|0]=0,i[r+44>>2]=0,i[r+48>>2]=0,i[r+16>>2]=98904,!f|i[f+4>>2]!=-1||(W[i[i[f>>2]+8>>2]](f),y(f)),i[e+448>>2]=t,k=i[e+452>>2],i[e+452>>2]=r;A:{if(!k||(e=i[k+4>>2],i[k+4>>2]=e-1,e))break A;W[i[i[k>>2]+8>>2]](k),y(k)}if(e=i[26917],i[A>>2]=i[26916],i[A+4>>2]=e,A=A+8|0,u[107683]<0)break r;e=i[26919],i[A>>2]=i[26918],i[A+4>>2]=e,i[A+8>>2]=i[26920];break e}if(r=r+8|0,(f|0)==(r|0))break}if(e=p(24),i[n+4>>2]=e,i[n+8>>2]=18,i[n+12>>2]=-2147483624,r=l[25670]|l[25671]<<8|(l[25672]<<16|l[25673]<<24),f=l[25666]|l[25667]<<8|(l[25668]<<16|l[25669]<<24),u[e|0]=f,u[e+1|0]=f>>>8,u[e+2|0]=f>>>16,u[e+3|0]=f>>>24,u[e+4|0]=r,u[e+5|0]=r>>>8,u[e+6|0]=r>>>16,u[e+7|0]=r>>>24,u[e+18|0]=0,r=l[25682]|l[25683]<<8,u[e+16|0]=r,u[e+17|0]=r>>>8,r=l[25678]|l[25679]<<8|(l[25680]<<16|l[25681]<<24),f=l[25674]|l[25675]<<8|(l[25676]<<16|l[25677]<<24),u[e+8|0]=f,u[e+9|0]=f>>>8,u[e+10|0]=f>>>16,u[e+11|0]=f>>>24,u[e+12|0]=r,u[e+13|0]=r>>>8,u[e+14|0]=r>>>16,u[e+15|0]=r>>>24,q(A,2,0,n+4|0),u[n+15|0]>=0)break i;Z(i[n+4>>2]);break i}T(A,i[26918],i[26919])}if(!f||(A=i[f+4>>2],i[f+4>>2]=A-1,A))break i;W[i[i[f>>2]+8>>2]](f),y(f)}v=n+16|0}function BZ(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0;var k=0,n=0,t=0;f=v-32|0,v=f,z2(f,e,r),u[f+19|0]<0&&Z(i[f+8>>2]),k=l[e+97|0];i:{if(k>>>0>=4){t1(A,e,15048);break i}e:{r:{if(k>>>0>=2){i[e+112>>2]=0;break r}if(n=e,t=o2(r),i[n+104>>2]=t,n=e,t=o2(r),g[n+108>>1]=t,B4(f+20|0,r),u[e+127|0]<0&&Z(i[e+116>>2]),k=i[f+24>>2],i[e+116>>2]=i[f+20>>2],i[e+120>>2]=k,i[e+124>>2]=i[f+28>>2],B4(f+20|0,r),u[e+139|0]<0&&Z(i[e+128>>2]),k=i[f+24>>2],i[e+128>>2]=i[f+20>>2],i[e+132>>2]=k,i[e+136>>2]=i[f+28>>2],B4(f+20|0,r),u[e+151|0]<0&&Z(i[e+140>>2]),k=i[f+24>>2],i[e+140>>2]=i[f+20>>2],i[e+144>>2]=k,i[e+148>>2]=i[f+28>>2],i[e+112>>2]=0,k=l[e+97|0],k>>>0<2)break e}u[e+164|0]=u[e+100|0]&1;r:{if((k|0)==2){k=o2(r);break r}k=C0(r)}if(i[e+104>>2]=k,n=e,t=o2(r),g[n+108>>1]=t,n=e,t=C0(r),i[n+112>>2]=t,B4(f+20|0,r),u[e+127|0]<0&&Z(i[e+116>>2]),k=i[f+24>>2],i[e+116>>2]=i[f+20>>2],i[e+120>>2]=k,i[e+124>>2]=i[f+28>>2],k=i[e+112>>2],(k|0)!=1970432288){if((k|0)!=1835625829)break e;B4(f+20|0,r),u[e+139|0]<0&&Z(i[e+128>>2]),k=i[f+24>>2],i[e+128>>2]=i[f+20>>2],i[e+132>>2]=k,i[e+136>>2]=i[f+28>>2],B4(f+20|0,r),u[e+151|0]<0&&Z(i[e+140>>2]),k=i[f+24>>2],i[e+140>>2]=i[f+20>>2],i[e+144>>2]=k,i[e+148>>2]=i[f+28>>2];break e}B4(f+20|0,r),u[e+163|0]<0&&Z(i[e+152>>2]),k=i[f+24>>2],i[e+152>>2]=i[f+20>>2],i[e+156>>2]=k,i[e+160>>2]=i[f+28>>2]}if(l[r+20|0]==1){if(u[f+20|0]=0,u[f+31|0]=0,q(A,2,100,f+20|0),u[f+31|0]>=0)break i;Z(i[f+20>>2]);break i}if(e=i[26917],i[A>>2]=i[26916],i[A+4>>2]=e,A=A+8|0,u[107683]>=0){e=i[26919],i[A>>2]=i[26918],i[A+4>>2]=e,i[A+8>>2]=i[26920];break i}T(A,i[26918],i[26919])}v=f+32|0}function vZ(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,t=0,o=0,s=0;f=v-160|0,v=f,i[f+92>>2]=0,i[f+64>>2]=72196,i[f+8>>2]=72176,n=i[18053],i[f>>2]=n,i[i[n-12>>2]+f>>2]=i[18054],i[f+4>>2]=0,n=i[i[f>>2]-12>>2]+f|0,s=f+12|0,J0(n,s),u[n+80|0]=0,i[n+72>>2]=0,n=i[18055],i[f+8>>2]=n,k=i[n-12>>2],n=f+8|0,i[k+n>>2]=i[18056],k=i[18052],i[f>>2]=k,i[i[k-12>>2]+f>>2]=i[18057],i[f+64>>2]=72196,i[f>>2]=72156,i[f+8>>2]=72176,s=R0(s),i[s>>2]=71232,i[f+52>>2]=0,i[f+56>>2]=0,i[f+44>>2]=0,i[f+48>>2]=0,i[f+60>>2]=24,k=f+148|0,U1(k,e,r),o=k,k=u[f+159|0],t=(k|0)<0,Y(n,t?i[f+148>>2]:o,t?i[f+152>>2]:k),u[f+159|0]<0&&Z(i[f+148>>2]),k=f+148|0,s0(k,r),o=k,k=u[f+159|0],t=(k|0)<0,Y(n,t?i[f+148>>2]:o,t?i[f+152>>2]:k),u[f+159|0]<0&&Z(i[f+148>>2]),Y(V0(Y(n,32634,14),i[e+104>>2]),32902,7),k=f+148|0,s0(k,r),o=k,k=u[f+159|0],t=(k|0)<0,Y(n,t?i[f+148>>2]:o,t?i[f+152>>2]:k),u[f+159|0]<0&&Z(i[f+148>>2]),Y(V0(Y(n,31391,13),i[e+108>>2]),41536,10),k=f+148|0,s0(k,r),o=k,r=u[f+159|0],k=(r|0)<0,Y(n,k?i[f+148>>2]:o,k?i[f+152>>2]:r),u[f+159|0]<0&&Z(i[f+148>>2]),Y(V0(Y(n,31405,13),i[e+112>>2]),41536,10),e=i[f+60>>2];i:{e:{if(e&16){e=i[f+56>>2],r=i[f+36>>2],e>>>0<r>>>0&&(i[f+56>>2]=r,e=r),r=f+32|0;break e}if(!(e&8)){e=0,u[A+11|0]=0;break i}e=i[f+28>>2],r=f+20|0}e:{if(n=i[r>>2],e=e-n|0,e>>>0<2147483640){if(e>>>0>=11){k=e|7,r=p(k+1|0),i[A+8>>2]=k-2147483647,i[A>>2]=r,i[A+4>>2]=e,A=r;break e}if(u[A+11|0]=e,e)break e;e=0;break i}Q0(),H()}if(!e)break i;x(A,n,e)}u[A+e|0]=0,A=i[18051],i[f>>2]=A,i[i[A-12>>2]+f>>2]=i[18059],i[f+8>>2]=i[18060],i[s>>2]=71232,u[f+55|0]<0&&Z(i[f+44>>2]),E0(s),y0(f- -64|0),v=f+160|0}function mZ(A,e,r,f,k,n){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0;var t=0,o=0,s=0,w=0,h=0;t=v-80|0,v=t;i:{if(!r){e=i[23570],i[A>>2]=i[23569],i[A+4>>2]=e,i[A+8>>2]=i[23571];break i}s=i[e>>2],o=i[e+4>>2],o&&(i[o+4>>2]=i[o+4>>2]+1);e:{if(!i[s+84>>2]&u0[s+80>>2]<=u0[s+92>>2]){i[r>>2]=0,i[A+8>>2]=15275,i[A>>2]=13,i[A+4>>2]=0;break e}w=SA(),kA(w,n),n=W0(s,106564,106696);r:{if(n){o&&(i[o+4>>2]=i[o+4>>2]+1),M7(t+44|0,n,w);f:{A:{k:{n:{t:{u:switch(l[t+64|0]){case 1:b0(A,t+44|0,i[e+8>>2]);break f;case 0:break u;default:break t}h=i[t+44>>2],n=i[t+48>>2];u:{if(!n){s=i[e+8>>2];break u}i[n+4>>2]=i[n+4>>2]+1,s=i[e+8>>2],i[n+4>>2]=i[n+4>>2]+1}switch(i[t+12>>2]=n,i[t+8>>2]=h,h=i[t+12>>2],i[t>>2]=i[t+8>>2],i[t+4>>2]=h,I9(t+16|0,s,t,f,k,w),l[t+36|0]){case 0:break k;case 1:break n;default:break t}}_2(),H()}b0(A,t+16|0,i[e+8>>2]);break A}e=i[t+20>>2],e&&(i[e+4>>2]=i[e+4>>2]+1),f=i[t+16>>2];k:{if(!n||(k=i[n+4>>2],i[n+4>>2]=k-1,k))break k;W[i[i[n>>2]+8>>2]](n),y(n)}k=r,r=p(8),i[k>>2]=r,i[r+4>>2]=e,i[r>>2]=f,n=0,i[A+8>>2]=0,i[A>>2]=0,i[A+4>>2]=0}if(A=l[t+36|0],(A|0)!=255&&(e=i[24191],i[t+72>>2]=i[24190],i[t+76>>2]=e,W[i[(t+72|0)+(A<<2)>>2]](t+71|0,t+16|0)),!n||(A=i[n+4>>2],i[n+4>>2]=A-1,A))break f;W[i[i[n>>2]+8>>2]](n),y(n)}if(A=l[t+64|0],(A|0)!=255&&(e=i[24191],i[t+16>>2]=i[24190],i[t+20>>2]=e,W[i[(t+16|0)+(A<<2)>>2]](t+72|0,t+44|0)),!o||(A=i[o+4>>2],i[o+4>>2]=A-1,A))break r;W[i[i[o>>2]+8>>2]](o),y(o);break r}if(i[A>>2]=5,i[A+4>>2]=2006,i[A+8>>2]=24697,!w)break e}x2(w)}if(!o||(A=i[o+4>>2],i[o+4>>2]=A-1,A))break i;W[i[i[o>>2]+8>>2]](o),y(o)}v=t+80|0}function ci(A,e,r,f,k,n,t,o,s){var w=0,h=0,_=0,B=0;w=v-32|0,v=w,Z8(w+24|0,i[e+48>>2],n),n=i[w+24>>2],u[n+164|0]=1,i[n+100>>2]=i[n+100>>2]&-2|1;i:{e:{r:{if(!t)break r;if(_=i[w+24>>2],n=h2(t),n>>>0>=2147483640)break e;f:{A:{if(n>>>0>=11){B=n|7,h=p(B+1|0),i[w+20>>2]=B-2147483647,i[w+12>>2]=h,i[w+16>>2]=n;break A}if(u[w+23|0]=n,h=w+12|0,!n)break f}if(!n)break f;x(h,t,n)}u[n+h|0]=0,n=_+128|0;f:{if((n|0)==(w+12|0))break f;if(t=u[w+23|0],u[_+139|0]>=0){if((t|0)>=0){t=i[w+16>>2],i[n>>2]=i[w+12>>2],i[n+4>>2]=t,i[n+8>>2]=i[w+20>>2];break f}M1(n,i[w+12>>2],i[w+16>>2]);break f}h=n,n=(t|0)<0,O1(h,n?i[w+12>>2]:w+12|0,n?i[w+16>>2]:t)}if(u[w+23|0]>=0)break r;Z(i[w+12>>2])}t=i[i[w+24>>2]+104>>2],s&&(i[s>>2]=t),n=i[e+48>>2],s=i[i[r>>2]+116>>2],r=p(4),i[w+12>>2]=r,h=r+4|0,i[w+20>>2]=h,i[r>>2]=s,i[w+16>>2]=h,a4(n,t,1667527523,w+12|0),r=i[w+12>>2],r&&(i[w+16>>2]=r,Z(r)),n=0,i[w+20>>2]=0,i[w+12>>2]=0,i[w+16>>2]=0;r:{f:switch(o-3|0){case 1:if(u[w|0]=0,u[w+11|0]=0,q(A,4,3005,w),u[w+11|0]>=0)break r;Z(i[w>>2]);break r;case 0:if(u[w|0]=0,u[w+11|0]=0,q(A,4,3005,w),u[w+11|0]>=0)break r;Z(i[w>>2]);break r;default:break f}if(k){if((k|0)<0)break i;n=p(k),k&&o0(n,0,k),r=k+n|0,i[w+20>>2]=r,i[w+16>>2]=r,i[w+12>>2]=n}if(k&&x(n,f,k),q8(i[e+48>>2],t,w+12|0,0),e=i[26917],i[A>>2]=i[26916],i[A+4>>2]=e,A=A+8|0,u[107683]>=0){e=i[26919],i[A>>2]=i[26918],i[A+4>>2]=e,i[A+8>>2]=i[26920];break r}T(A,i[26918],i[26919])}A=i[w+12>>2],A&&(i[w+16>>2]=A,Z(A)),A=i[w+28>>2];r:{if(!A||(e=i[A+4>>2],i[A+4>>2]=e-1,e))break r;W[i[i[A>>2]+8>>2]](A),y(A)}v=w+32|0;return}Q0(),H()}G0(),H()}function ZZ(A){A=A|0;var e=0,r=0,f=0,k=0,n=0,t=0,o=0;k=v-16|0,v=k;i:{e:{if(!i[A+64>>2]){t=-1;break e}r=i[A+92>>2]&8,r||(i[A+28>>2]=0,i[A+20>>2]=0,i[A+24>>2]=0,t=l[A+98|0],e=i[(t?32:56)+A>>2],t=e+i[(t?52:60)+A>>2]|0,i[A+16>>2]=t,i[A+12>>2]=t,i[A+8>>2]=e,i[A+92>>2]=8),i[A+12>>2]||(e=k+16|0,i[A+16>>2]=e,i[A+12>>2]=e,i[A+8>>2]=k+15),r&&(e=i[A+16>>2],r=i[A+8>>2],i[k+4>>2]=4,i[k+8>>2]=(e-r|0)/2,e=v-16|0,v=e,v=e+16|0,e=k+4|0,r=k+8|0,n=i[(u0[e>>2]<u0[r>>2]?e:r)>>2]),t=-1,e=i[A+16>>2];r:{if((e|0)==i[A+12>>2]){if(r=i[A+8>>2],n&&x(r,e-n|0,n),l[A+98|0]==1){if(e=i[A+8>>2],e=qu(e+n|0,i[A+16>>2]-(e+n|0)|0,i[A+64>>2]),!e)break r;r=i[A+8>>2],f=e,e=i[A+8>>2]+n|0,i[A+16>>2]=f+e,i[A+12>>2]=e,i[A+8>>2]=r,t=l[i[A+12>>2]];break r}e=i[A+40>>2],r=i[A+36>>2];f:{if((e|0)==(r|0)){r=e;break f}e=e-r|0,e&&x(i[A+32>>2],r,e),e=i[A+36>>2],r=i[A+40>>2]}if(f=i[A+32>>2],e=r-e|0,i[A+36>>2]=f+e,r=(f|0)==(A+44|0)?8:i[A+52>>2],i[A+40>>2]=r+f,i[k+8>>2]=i[A+60>>2]-n,i[k+4>>2]=r-e,e=v-16|0,v=e,v=e+16|0,r=k+4|0,e=k+8|0,r=i[(u0[r>>2]<u0[e>>2]?r:e)>>2],f=i[A+76>>2],i[A+80>>2]=i[A+72>>2],i[A+84>>2]=f,f=qu(i[A+36>>2],r,i[A+64>>2]),!f)break r;if(r=i[A+68>>2],!r)break i;f=f+i[A+36>>2]|0,i[A+40>>2]=f,o=f,f=i[A+8>>2];f:{if((W[i[i[r>>2]+16>>2]](r,A+72|0,i[A+32>>2],o,A+36|0,f+n|0,f+i[A+60>>2]|0,e)|0)==3){e=i[A+32>>2],i[A+16>>2]=i[A+40>>2],i[A+12>>2]=e,i[A+8>>2]=e;break f}if(e=i[k+8>>2],r=i[A+8>>2],n=r+n|0,(e|0)==(n|0))break r;i[A+16>>2]=e,i[A+12>>2]=n,i[A+8>>2]=r}t=l[i[A+12>>2]];break r}t=l[i[A+12>>2]]}if(i[A+8>>2]!=(k+15|0))break e;i[A+16>>2]=0,i[A+12>>2]=0,i[A+8>>2]=0}return v=k+16|0,t|0}g1(),H()}function GZ(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0;var k=0,n=0,t=0,o=0,s=0,w=0;f=v-16|0,v=f,n=i[e+12>>2],s=n;i:{e:{r:{if(k=i[e+8>>2],n|k){if(n=i[e+32>>2],o=n>>>0>k>>>0,o&!s)break r;if(w=k-n|0,n=s-o|0,k=w,!n&k>>>0>=2147483648|n){if(e=p(24),i[f+4>>2]=e,i[f+8>>2]=18,i[f+12>>2]=-2147483624,r=l[13903]|l[13904]<<8|(l[13905]<<16|l[13906]<<24),k=l[13899]|l[13900]<<8|(l[13901]<<16|l[13902]<<24),u[e|0]=k,u[e+1|0]=k>>>8,u[e+2|0]=k>>>16,u[e+3|0]=k>>>24,u[e+4|0]=r,u[e+5|0]=r>>>8,u[e+6|0]=r>>>16,u[e+7|0]=r>>>24,u[e+18|0]=0,r=l[13915]|l[13916]<<8,u[e+16|0]=r,u[e+17|0]=r>>>8,r=l[13911]|l[13912]<<8|(l[13913]<<16|l[13914]<<24),k=l[13907]|l[13908]<<8|(l[13909]<<16|l[13910]<<24),u[e+8|0]=k,u[e+9|0]=k>>>8,u[e+10|0]=k>>>16,u[e+11|0]=k>>>24,u[e+12|0]=r,u[e+13|0]=r>>>8,u[e+14|0]=r>>>16,u[e+15|0]=r>>>24,q(A,2,1e3,f+4|0),u[f+15|0]>=0)break i;Z(i[f+4>>2]);break i}t=i[e+104>>2],n=i[e+100>>2],w=t-n|0;f:{if(k>>>0>w>>>0){if(s=k-w|0,o=i[e+108>>2],s>>>0<=o-t>>>0){s&&o0(t,0,s),i[e+104>>2]=t+s;break f}if(t=o-n|0,o=t<<1,o=t>>>0>=1073741823?2147483647:k>>>0<o>>>0?o:k,t=p(o),s&&o0(t+w|0,0,s),w&&x(t,n,w),i[e+108>>2]=t+o,i[e+104>>2]=k+t,i[e+100>>2]=t,!n)break f;Z(n);break f}if(k>>>0>=w>>>0)break f;i[e+104>>2]=k+n}l6(r,i[e+100>>2],k)}if(l[r+20|0]!=1)break e;if(u[f+4|0]=0,u[f+15|0]=0,q(A,2,100,f+4|0),u[f+15|0]>=0)break i;Z(i[f+4>>2]);break i}if(u[f+4|0]=0,u[f+15|0]=0,q(A,2,101,f+4|0),u[f+15|0]>=0)break i;Z(i[f+4>>2]);break i}if(e=i[26917],i[A>>2]=i[26916],i[A+4>>2]=e,A=A+8|0,u[107683]>=0){e=i[26919],i[A>>2]=i[26918],i[A+4>>2]=e,i[A+8>>2]=i[26920];break i}T(A,i[26918],i[26919])}v=f+16|0}function XZ(A,e,r,f,k){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0;var n=0,t=0;n=v+-64|0,v=n,w9(n+40|0,e,r);i:{if(i[n+40>>2]){e=i[n+44>>2],i[A>>2]=i[n+40>>2],i[A+4>>2]=e,e=A+8|0;e:{if(u[n+59|0]>=0){r=i[n+52>>2],i[e>>2]=i[n+48>>2],i[e+4>>2]=r,i[e+8>>2]=i[n+56>>2];break e}T(e,i[n+48>>2],i[n+52>>2])}u[A+20|0]=1;break i}i[n+36>>2]=0;e:{r:{r=i[e+56>>2],t=i[r>>2];f:{if((t|0)>=5){if(t=i[r+68>>2],!t)break f;if(r=n+24|0,W[t|0](r,i[e+60>>2],n+36|0,f,k),!i[n+24>>2])break e;if(nr(n,r),e=i[n+4>>2],i[A>>2]=i[n>>2],i[A+4>>2]=e,e=A+8|0,u[n+19|0]>=0){r=i[n+12>>2],i[e>>2]=i[n+8>>2],i[e+4>>2]=r,i[e+8>>2]=i[n+16>>2],u[A+20|0]=1;break i}if(T(e,i[n+8>>2],i[n+12>>2]),e=u[n+19|0],u[A+20|0]=1,(e|0)>=0)break i;Z(i[n+8>>2]);break i}if((t|0)!=4)break r}if(f=i[r+44>>2],!f)break r;if(r=n+24|0,W[f|0](r,i[e+60>>2],n+36|0,k),!i[n+24>>2])break e;if(nr(n,r),e=i[n+4>>2],i[A>>2]=i[n>>2],i[A+4>>2]=e,e=A+8|0,u[n+19|0]>=0){r=i[n+12>>2],i[e>>2]=i[n+8>>2],i[e+4>>2]=r,i[e+8>>2]=i[n+16>>2],u[A+20|0]=1;break i}if(T(e,i[n+8>>2],i[n+12>>2]),e=u[n+19|0],u[A+20|0]=1,(e|0)>=0)break i;Z(i[n+8>>2]);break i}if(f=n+24|0,W[i[r+32>>2]](f,i[e+60>>2],n+36|0),!i[n+24>>2])break e;if(nr(n,f),e=i[n+4>>2],i[A>>2]=i[n>>2],i[A+4>>2]=e,e=A+8|0,u[n+19|0]>=0){r=i[n+12>>2],i[e>>2]=i[n+8>>2],i[e+4>>2]=r,i[e+8>>2]=i[n+16>>2],u[A+20|0]=1;break i}if(T(e,i[n+8>>2],i[n+12>>2]),e=u[n+19|0],u[A+20|0]=1,(e|0)>=0)break i;Z(i[n+8>>2]);break i}if(e=i[n+36>>2],!e){u[A+20|0]=0,i[A>>2]=0,i[A+4>>2]=0;break i}r=i[e>>2],f=i[e+4>>2],i[e>>2]=0,i[e+4>>2]=0,x4(e),u[A+20|0]=0,i[A>>2]=r,i[A+4>>2]=f}u[n+59|0]<0&&Z(i[n+48>>2]),v=n- -64|0}function rn(A,e,r,f,k,n){var t=0,o=0;sr(i[e+48>>2]),t=p(352),i[t>>2]=94852,i[t+4>>2]=0,i[t+8>>2]=0,o=v-16|0,v=o,f=p7(t+16|0,e,r,f),r=f,i[r+308>>2]=0,i[r+312>>2]=0,u[r+300|0]=0,i[r+296>>2]=0,i[r+288>>2]=0,i[r+316>>2]=0,i[r+320>>2]=0,i[r>>2]=106672,i[r+304>>2]=r+308,i[r+324>>2]=0,i[r+328>>2]=0,i[r+332>>2]=0,r=i[r+140>>2],i[r+184>>2]=n<<16,i[r+180>>2]=k<<16,r=p(128),i[r>>2]=93164,i[r+4>>2]=0,i[r+8>>2]=0,k=r+16|0,i[k+8>>2]=0,i[k+12>>2]=0,i[k+16>>2]=0,i[k+20>>2]=0,i[k+24>>2]=0,i[k+28>>2]=0,i[k+32>>2]=0,i[k>>2]=86356,i[r+60>>2]=0,i[r+64>>2]=0,i[r+52>>2]=0,i[r+56>>2]=0,i[r+72>>2]=-1,i[r+76>>2]=-1,i[r+80>>2]=-1,i[r+84>>2]=-1,i[r+88>>2]=0,i[r+92>>2]=0,i[r+96>>2]=0,i[r+100>>2]=0,i[r+104>>2]=0,i[r+108>>2]=0,g[r+112>>1]=0,i[k>>2]=104620,i[r+116>>2]=1,i[r+32>>2]=1986881636,i[r+120>>2]=0,i[r+124>>2]=0,n=i[f+148>>2],i[o+12>>2]=r,i[o+8>>2]=k,i[r+4>>2]=i[r+4>>2]+1,r2(n+36|0,o+8|0),k=i[o+12>>2];i:{if(!k||(n=i[k+4>>2],i[k+4>>2]=n-1,n))break i;W[i[i[k>>2]+8>>2]](k),y(k)}k=i[r+4>>2],i[r+4>>2]=k-1,k||(W[i[i[r>>2]+8>>2]](r),y(r)),v=o+16|0,n=f,i[t+4>>2]=i[t+4>>2]+1,o=i[t+40>>2];i:{e:{r=i[e+184>>2];r:{if(!r){k=e+184|0,f=k;break r}for(;;){if(f=r,r=i[r+16>>2],r>>>0>o>>>0){if(k=f,r=i[k>>2],r)continue;break r}if(r>>>0>=o>>>0)break e;if(r=i[f+4>>2],!r)break}k=f+4|0}r=p(28),i[r+24>>2]=t,i[r+20>>2]=n,i[r+16>>2]=o,i[r+8>>2]=f,i[r>>2]=0,i[r+4>>2]=0,i[k>>2]=r,f=i[i[e+180>>2]>>2],f&&(i[e+180>>2]=f),m1(i[e+184>>2],r),i[e+188>>2]=i[e+188>>2]+1;break i}if(e=i[t+4>>2],i[t+4>>2]=e-1,e)break i;W[i[i[t>>2]+8>>2]](t),y(t)}u[A+20|0]=0,i[A+4>>2]=t,i[A>>2]=n}function E4(A,e,r){return i[A+84>>2]=0,i[A+88>>2]=0,u[A+80|0]=0,u[A+68|0]=0,i[A+64>>2]=0,u[A+60|0]=0,u[A+36|0]=0,i[A+32>>2]=0,i[A+24>>2]=1,i[A+28>>2]=1,i[A+16>>2]=0,i[A+20>>2]=0,u[A+12|0]=1,g[A+10>>1]=2,g[A+6>>1]=2,g[A+8>>1]=2,u[A+4|0]=0,i[A+100>>2]=e,u[A+232|0]=0,i[A+92>>2]=0,i[A+96>>2]=4740,i[A>>2]=100536,g[A+128>>1]=0,i[A+120>>2]=0,i[A+124>>2]=0,i[A+112>>2]=0,i[A+116>>2]=0,i[A+104>>2]=0,i[A+108>>2]=0,i[A+132>>2]=0,i[A+136>>2]=0,g[A+138>>1]=0,g[A+140>>1]=0,g[A+142>>1]=0,g[A+144>>1]=0,i[A+148>>2]=0,i[A+152>>2]=0,u[A+156|0]=0,i[A+160>>2]=0,i[A+164>>2]=0,u[A+168|0]=0,i[A+236>>2]=0,i[A+240>>2]=0,i[A+244>>2]=0,i[A+248>>2]=0,i[A+252>>2]=0,i[A+256>>2]=0,i[A+260>>2]=0,i[A+264>>2]=0,i[A+268>>2]=0,u[A+272|0]=1,i[A+344>>2]=0,i[A+348>>2]=0,i[A+352>>2]=0,u[A+281|0]=0,u[A+282|0]=0,u[A+283|0]=0,u[A+284|0]=0,u[A+285|0]=0,u[A+286|0]=0,u[A+287|0]=0,u[A+288|0]=0,i[A+276>>2]=0,i[A+280>>2]=0,u[A+336|0]=0,i[A+328>>2]=0,i[A+332>>2]=0,i[A+320>>2]=0,i[A+324>>2]=0,i[A+312>>2]=0,i[A+316>>2]=0,i[A+304>>2]=0,i[A+308>>2]=0,i[A+296>>2]=0,i[A+300>>2]=0,i[A+376>>2]=0,i[A+380>>2]=0,g[A+356>>1]=1,i[A+368>>2]=0,i[A+372>>2]=0,i[A+360>>2]=0,i[A+364>>2]=0,i[A+384>>2]=0,i[A+388>>2]=1072693248,i[A+176>>2]=0,i[A+180>>2]=0,i[A+184>>2]=0,i[A+188>>2]=0,i[A+192>>2]=0,i[A+196>>2]=0,i[A+200>>2]=0,i[A+204>>2]=0,i[A+208>>2]=0,i[A+212>>2]=0,i[A+216>>2]=0,i[A+220>>2]=0,i[A+224>>2]=0,i[A+228>>2]=0,i[A+416>>2]=0,i[A+408>>2]=0,i[A+412>>2]=0,i[A+400>>2]=0,i[A+404>>2]=0,i[A+392>>2]=0,i[A+396>>2]=0,i[A+440>>2]=0,i[A+444>>2]=0,i[A+432>>2]=0,i[A+436>>2]=0,i[A+424>>2]=0,i[A+428>>2]=0,i[A+116>>2]=r,A}function WZ(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0;var k=0,n=0,t=0,o=0,s=0;t=v-16|0,v=t;i:{if(!(f&&e)){e=i[23570],i[A>>2]=i[23569],i[A+4>>2]=e,i[A+8>>2]=i[23571];break i}i[f>>2]=0,k=i[e>>2],e=i[k+48>>2],o=i[k+52>>2],o&&(i[o+4>>2]=i[o+4>>2]+1);e:{if(!e3(e,r)){i[A>>2]=1,i[A+4>>2]=2006,i[A+8>>2]=3572;break e}k=v-32|0,v=k,i[k+28>>2]=0,i[k+20>>2]=0,i[k+24>>2]=0,j1(k,e,r,k+20|0);r:{if(i[k>>2]){i[t+8>>2]=0,i[t+12>>2]=0;break r}f:{if(n=i[k+20>>2],r=i[k+24>>2],(n|0)!=(r|0)){if(e=i[n>>2],e&&(s=i[t+12>>2],e=W0(e,86580,86624),e))break f;if(n=n+8|0,(r|0)!=(n|0))for(;;){if(e=i[n>>2],e&&(s=0,e=W0(e,86580,86624),e))break f;if(n=n+8|0,(r|0)==(n|0))break}i[t+8>>2]=0,i[t+12>>2]=0}i[t+8>>2]=0,i[t+12>>2]=0;break r}if(i[t+12>>2]=s,i[t+8>>2]=e,e=i[n+4>>2],i[t+12>>2]=e,!e)break r;i[e+4>>2]=i[e+4>>2]+1}if(u[k+19|0]<0&&Z(i[k+8>>2]),r=i[k+20>>2],r){if(e=r,n=i[k+24>>2],(e|0)!=(n|0)){for(;;){e=i[n-4>>2];r:{if(!e||(s=i[e+4>>2],i[e+4>>2]=s-1,s))break r;W[i[i[e>>2]+8>>2]](e),y(e)}if(n=n-8|0,(r|0)==(n|0))break}e=i[k+20>>2]}i[k+24>>2]=r,Z(e)}if(v=k+32|0,e=i[t+8>>2],e&&(r=p(32),i[f>>2]=r,f=i[e+132>>2],i[r+24>>2]=i[e+128>>2],i[r+28>>2]=f,f=i[e+124>>2],i[r+16>>2]=i[e+120>>2],i[r+20>>2]=f,f=i[e+116>>2],i[r+8>>2]=i[e+112>>2],i[r+12>>2]=f,f=i[e+108>>2],i[r>>2]=i[e+104>>2],i[r+4>>2]=f),e=i[24057],i[A>>2]=i[24056],i[A+4>>2]=e,i[A+8>>2]=i[24058],A=i[t+12>>2],!A||(e=i[A+4>>2],i[A+4>>2]=e-1,e))break e;W[i[i[A>>2]+8>>2]](A),y(A)}if(!o||(A=i[o+4>>2],i[o+4>>2]=A-1,A))break i;W[i[i[o>>2]+8>>2]](o),y(o)}v=t+16|0}function QZ(A,e,r,f,k,n){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0;var t=0,o=0,s=0,w=0,h=0,_=0,B=0,m=0,X=0,Q=0;A=v-480|0,v=A,t=A+476|0,o=i[f+28>>2],i[t>>2]=o,(o|0)!=129576&&(i[o+4>>2]=i[o+4>>2]+1),X=c0(t,129752),l[n+11|0]>>>7|0?t=i[n+4>>2]:t=l[n+11|0]&127,t&&(l[n+11|0]>>>7|0?t=i[n>>2]:t=n,Q=i[t>>2]==(W[i[i[X>>2]+44>>2]](X,45)|0)),t=v-16|0,v=t,_=A+452|0,i[_>>2]=0,i[_+4>>2]=0,i[_+8>>2]=0,v=t+16|0,t=v-16|0,v=t,s=A+440|0,i[s>>2]=0,i[s+4>>2]=0,i[s+8>>2]=0,v=t+16|0,t=v-16|0,v=t,w=A+428|0,i[w>>2]=0,i[w+4>>2]=0,i[w+8>>2]=0,v=t+16|0,Zt(r,Q,A+476|0,A+472|0,A+468|0,A+464|0,_,s,w,A+424|0),i[A+16>>2]=2071,r=A+16|0,h=Q1(A+8|0,0,r);i:{l[n+11|0]>>>7|0?t=i[n+4>>2]:t=l[n+11|0]&127;e:{if((t|0)>i[A+424>>2]){l[n+11|0]>>>7|0?o=i[n+4>>2]:o=l[n+11|0]&127,t=i[A+424>>2],l[s+11|0]>>>7|0?B=i[s+4>>2]:B=l[s+11|0]&127,l[w+11|0]>>>7|0?m=i[w+4>>2]:m=l[w+11|0]&127,t=(t+(B+(m+(o-t<<1)|0)|0)|0)+1|0;break e}B=i[A+424>>2],l[w+11|0]>>>7|0?t=i[w+4>>2]:t=l[w+11|0]&127,l[s+11|0]>>>7|0?o=i[s+4>>2]:o=l[s+11|0]&127,t=(B+(t+o|0)|0)+2|0}if(t>>>0<101||(r=y2(t<<2),t=i[h>>2],i[h>>2]=r,t&&W[i[h+4>>2]](t),r=i[h>>2],r))break i;g1(),H()}return B=A+4|0,m=i[f+4>>2],l[n+11|0]>>>7|0?t=i[n>>2]:t=n,o=t,l[n+11|0]>>>7|0?t=i[n>>2]:t=n,l[n+11|0]>>>7|0?n=i[n+4>>2]:n=l[n+11|0]&127,T9(r,B,A,m,o,t+(n<<2)|0,X,Q,A+472|0,i[A+468>>2],i[A+464>>2],_,s,w,i[A+424>>2]),e=j8(e,r,i[A+4>>2],i[A>>2],f,k),r=i[h>>2],i[h>>2]=0,r&&W[i[h+4>>2]](r),R1(w),R1(s),s2(_),e2(A+476|0),v=A+480|0,e|0}function c6(A,e){return i[A+84>>2]=0,i[A+88>>2]=0,u[A+80|0]=0,u[A+68|0]=0,i[A+64>>2]=0,u[A+60|0]=0,u[A+36|0]=0,i[A+32>>2]=0,i[A+24>>2]=1,i[A+28>>2]=1,i[A+16>>2]=0,i[A+20>>2]=0,u[A+12|0]=1,g[A+10>>1]=2,g[A+6>>1]=2,g[A+8>>1]=2,u[A+4|0]=0,i[A+100>>2]=e,u[A+232|0]=0,i[A+92>>2]=0,i[A+96>>2]=4740,i[A>>2]=100536,g[A+128>>1]=0,i[A+120>>2]=0,i[A+124>>2]=0,i[A+112>>2]=0,i[A+116>>2]=0,i[A+104>>2]=0,i[A+108>>2]=0,i[A+132>>2]=0,i[A+136>>2]=0,g[A+138>>1]=0,g[A+140>>1]=0,g[A+142>>1]=0,g[A+144>>1]=0,i[A+148>>2]=0,i[A+152>>2]=0,u[A+156|0]=0,i[A+160>>2]=0,i[A+164>>2]=0,u[A+168|0]=0,i[A+236>>2]=0,i[A+240>>2]=0,i[A+244>>2]=0,i[A+248>>2]=0,i[A+252>>2]=0,i[A+256>>2]=0,i[A+260>>2]=0,i[A+264>>2]=0,i[A+268>>2]=0,u[A+272|0]=1,i[A+344>>2]=0,i[A+348>>2]=0,i[A+352>>2]=0,u[A+281|0]=0,u[A+282|0]=0,u[A+283|0]=0,u[A+284|0]=0,u[A+285|0]=0,u[A+286|0]=0,u[A+287|0]=0,u[A+288|0]=0,i[A+276>>2]=0,i[A+280>>2]=0,u[A+336|0]=0,i[A+328>>2]=0,i[A+332>>2]=0,i[A+320>>2]=0,i[A+324>>2]=0,i[A+312>>2]=0,i[A+316>>2]=0,i[A+304>>2]=0,i[A+308>>2]=0,i[A+296>>2]=0,i[A+300>>2]=0,i[A+376>>2]=0,i[A+380>>2]=0,g[A+356>>1]=1,i[A+368>>2]=0,i[A+372>>2]=0,i[A+360>>2]=0,i[A+364>>2]=0,i[A+384>>2]=0,i[A+388>>2]=1072693248,i[A+176>>2]=0,i[A+180>>2]=0,i[A+184>>2]=0,i[A+188>>2]=0,i[A+192>>2]=0,i[A+196>>2]=0,i[A+200>>2]=0,i[A+204>>2]=0,i[A+208>>2]=0,i[A+212>>2]=0,i[A+216>>2]=0,i[A+220>>2]=0,i[A+224>>2]=0,i[A+228>>2]=0,i[A+416>>2]=0,i[A+408>>2]=0,i[A+412>>2]=0,i[A+400>>2]=0,i[A+404>>2]=0,i[A+392>>2]=0,i[A+396>>2]=0,i[A+440>>2]=0,i[A+444>>2]=0,i[A+432>>2]=0,i[A+436>>2]=0,i[A+424>>2]=0,i[A+428>>2]=0,A}function gZ(A,e,r,f,k,n){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0;var t=0,o=0,s=0,w=0,h=0,_=0,B=0,m=0,X=0,Q=0;A=v-176|0,v=A,t=A+172|0,o=i[f+28>>2],i[t>>2]=o,(o|0)!=129576&&(i[o+4>>2]=i[o+4>>2]+1),X=c0(t,129760),l[n+11|0]>>>7|0?t=i[n+4>>2]:t=l[n+11|0]&127,t&&(l[n+11|0]>>>7|0?t=i[n>>2]:t=n,Q=l[t|0]==(W[i[i[X>>2]+28>>2]](X,45)&255)),t=v-16|0,v=t,_=A+152|0,i[_>>2]=0,i[_+4>>2]=0,i[_+8>>2]=0,v=t+16|0,t=v-16|0,v=t,s=A+140|0,i[s>>2]=0,i[s+4>>2]=0,i[s+8>>2]=0,v=t+16|0,t=v-16|0,v=t,w=A+128|0,i[w>>2]=0,i[w+4>>2]=0,i[w+8>>2]=0,v=t+16|0,Gt(r,Q,A+172|0,A+168|0,A+167|0,A+166|0,_,s,w,A+124|0),i[A+16>>2]=2071,r=A+16|0,h=Q1(A+8|0,0,r);i:{l[n+11|0]>>>7|0?t=i[n+4>>2]:t=l[n+11|0]&127;e:{if((t|0)>i[A+124>>2]){l[n+11|0]>>>7|0?o=i[n+4>>2]:o=l[n+11|0]&127,t=i[A+124>>2],l[s+11|0]>>>7|0?B=i[s+4>>2]:B=l[s+11|0]&127,l[w+11|0]>>>7|0?m=i[w+4>>2]:m=l[w+11|0]&127,t=(t+(B+(m+(o-t<<1)|0)|0)|0)+1|0;break e}B=i[A+124>>2],l[w+11|0]>>>7|0?t=i[w+4>>2]:t=l[w+11|0]&127,l[s+11|0]>>>7|0?o=i[s+4>>2]:o=l[s+11|0]&127,t=(B+(t+o|0)|0)+2|0}if(t>>>0<101||(r=y2(t),t=i[h>>2],i[h>>2]=r,t&&W[i[h+4>>2]](t),r=i[h>>2],r))break i;g1(),H()}return B=A+4|0,m=i[f+4>>2],l[n+11|0]>>>7|0?t=i[n>>2]:t=n,o=t,l[n+11|0]>>>7|0?t=i[n>>2]:t=n,l[n+11|0]>>>7|0?n=i[n+4>>2]:n=l[n+11|0]&127,P9(r,B,A,m,o,t+n|0,X,Q,A+168|0,u[A+167|0],u[A+166|0],_,s,w,i[A+124>>2]),e=O8(e,r,i[A+4>>2],i[A>>2],f,k),r=i[h>>2],i[h>>2]=0,r&&W[i[h+4>>2]](r),s2(w),s2(s),s2(_),e2(A+172|0),v=A+176|0,e|0}function fn(A,e){var r=0,f=0,k=0,n=0,t=0,o=0,s=0,w=0,h=0,_=0,B=0,m=0,X=0,Q=0;k=v-16|0,v=k;i:{f=i[A+4>>2];e:{if(f>>>0<e>>>0){t=e-f|0,n=i[A+8>>2],r=n<<5;r:{if(!(t>>>0>r>>>0|f>>>0>r-t>>>0)){i[A+4>>2]=e,r=f&31,e=i[A>>2]+(f>>>3&536870908)|0;break r}if(i[k+12>>2]=0,i[k+4>>2]=0,i[k+8>>2]=0,(e|0)<0)break i;f:{if(r>>>0<=1073741822?(r=n<<6,e=e+31&-32,e=e>>>0<r>>>0?r:e):e=2147483647,e>>>0<=i[k+12>>2]<<5>>>0)break f;if((e|0)>=0){m=(e-1>>>5|0)+1|0,n=p(m<<2),r=i[k+4>>2],w=i[k+8>>2];A:{k:{if(w>>>0>=33){i[n+(w-1>>>3&536870908)>>2]=0;break k}if(i[n>>2]=0,!w)break A}for(X=w&31,Q=r+(w>>>3&536870908)|0,e=n,o=r,f=r;s=1<<B,i[f>>2]>>>_&1?s=s|i[e>>2]:s=i[e>>2]&(s^-1),i[e>>2]=s,h=f+4|0,s=(_|0)==31,o=s?h:o,f=s?h:f,h=(B|0)==31,f=h?o:f,B=h?0:B+1|0,e=(h?4:0)+e|0,_=s?0:_+1|0,!!((X|0)!=(_|0)|(f|0)!=(Q|0)););}if(i[k+12>>2]=m,i[k+8>>2]=w,i[k+4>>2]=n,!r)break f;Z(r);break f}G0(),H()}r=i[A+4>>2],i[k+8>>2]=r+t,f=i[A>>2],e=i[k+4>>2];f:{if((r|0)<=0){r=0;break f}n=r>>>5|0;A:{if(r>>>0<32||(o=n<<2,!o))break A;x(e,f,o)}n=n<<2,e=n+e|0,r=r&31,r&&(o=-1>>>32-r|0,i[e>>2]=i[e>>2]&(o^-1)|o&i[f+n>>2]),f=i[A>>2]}if(i[A>>2]=i[k+4>>2],i[k+4>>2]=f,n=i[A+4>>2],i[A+4>>2]=i[k+8>>2],i[k+8>>2]=n,n=i[A+8>>2],i[A+8>>2]=i[k+12>>2],i[k+12>>2]=n,!f)break r;Z(f)}r&&(A=32-r|0,f=A>>>0>t>>>0?t:A,i[e>>2]=i[e>>2]&(-1<<r&-1>>>A-f^-1),t=t-f|0,e=e+4|0),A=t>>>5|0;r:{if(t>>>0<32||(r=A<<2,!r))break r;o0(e,0,r)}if(r=t&31,!r)break e;A=(A<<2)+e|0,i[A>>2]=i[A>>2]&(-1>>>32-r^-1);break e}i[A+4>>2]=e}v=k+16|0;return}G0(),H()}function T1(A){A=A|0;var e=0,r=0,f=0,k=0;if(i[A>>2]=100536,e=i[A+436>>2],e&&(i[A+440>>2]=e,Z(e)),r=i[A+424>>2],r){if(e=r,f=i[A+428>>2],(e|0)!=(f|0)){for(;u[f-1|0]<0&&Z(i[f-12>>2]),f=f-20|0,(r|0)!=(f|0););e=i[A+424>>2]}i[A+428>>2]=r,Z(e)}if(e=i[A+276>>2],e&&(i[A+280>>2]=e,Z(e)),r=i[A+260>>2],r){if(e=r,f=i[A+264>>2],(e|0)!=(f|0)){for(;;){e=i[f-4>>2];i:{if(!e||(k=i[e+4>>2],i[e+4>>2]=k-1,k))break i;W[i[i[e>>2]+8>>2]](e),y(e)}if(f=f-8|0,(r|0)==(f|0))break}e=i[A+260>>2]}i[A+264>>2]=r,Z(e)}if(r=i[A+248>>2],r){if(e=r,f=i[A+252>>2],(e|0)!=(f|0)){for(;;){e=i[f-4>>2];i:{if(!e||(k=i[e+4>>2],i[e+4>>2]=k-1,k))break i;W[i[i[e>>2]+8>>2]](e),y(e)}if(f=f-8|0,(r|0)==(f|0))break}e=i[A+248>>2]}i[A+252>>2]=r,Z(e)}u[A+247|0]<0&&Z(i[A+236>>2]),e=i[A+164>>2];i:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break i;W[i[i[e>>2]+8>>2]](e),y(e)}e=i[A+152>>2];i:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break i;W[i[i[e>>2]+8>>2]](e),y(e)}if(r=i[A+132>>2],r){if(e=r,f=i[A+136>>2],(e|0)!=(f|0)){for(;;){e=i[f-4>>2];i:{if(!e||(k=i[e+4>>2],i[e+4>>2]=k-1,k))break i;W[i[i[e>>2]+8>>2]](e),y(e)}if(f=f-8|0,(r|0)==(f|0))break}e=i[A+132>>2]}i[A+136>>2]=r,Z(e)}if(r=i[A+104>>2],r){if(e=r,f=i[A+108>>2],(e|0)!=(f|0)){for(;;){e=i[f-4>>2];i:{if(!e||(k=i[e+4>>2],i[e+4>>2]=k-1,k))break i;W[i[i[e>>2]+8>>2]](e),y(e)}if(f=f-8|0,(r|0)==(f|0))break}e=i[A+104>>2]}i[A+108>>2]=r,Z(e)}return u[A+95|0]<0&&Z(i[A+84>>2]),PA(A)|0}function zf(A,e){var r=0,f=0,k=0,n=0,t=0,o=0;r=i[A+40>>2],r&&(u[r+128|0]=0),r=i[e>>2],u[r+128|0]=1,f=i[e+4>>2],f&&(i[f+4>>2]=i[f+4>>2]+1),i[A+40>>2]=r,r=i[A+44>>2],i[A+44>>2]=f;i:{if(!r||(f=i[r+4>>2],i[r+4>>2]=f-1,f))break i;W[i[i[r>>2]+8>>2]](r),y(r)}if(o=i[i[e>>2]+116>>2],r=i[A+48>>2],A=i[r+92>>2],!A){k=r+92|0,A=p(128),i[A+4>>2]=0,i[A+8>>2]=0,i[A>>2]=89844,e=A+16|0,i[e+8>>2]=0,i[e+12>>2]=0,i[e+16>>2]=0,i[e+20>>2]=0,i[e+24>>2]=0,i[e+28>>2]=0,i[e+32>>2]=0,i[e>>2]=86356,i[A+60>>2]=0,i[A+64>>2]=0,i[A+52>>2]=0,i[A+56>>2]=0,i[A+72>>2]=-1,i[A+76>>2]=-1,i[A+80>>2]=-1,i[A+84>>2]=-1,i[A+116>>2]=0,i[A+88>>2]=0,i[A+92>>2]=0,i[A+96>>2]=0,i[A+100>>2]=0,i[A+104>>2]=0,i[A+108>>2]=0,g[A+112>>1]=0,i[e>>2]=87204,i[A+32>>2]=1885959277,i[A+120>>2]=0,i[r+92>>2]=e,e=i[r+96>>2],i[r+96>>2]=A;i:{if(!e||(A=i[e+4>>2],i[e+4>>2]=A-1,A))break i;W[i[i[e>>2]+8>>2]](e),y(e)}f=v-16|0,v=f,n=i[r+44>>2],e=i[n+36>>2],A=i[n+40>>2];i:{if((e|0)!=(A|0))for(;;){e:{if(t=i[e>>2],!t||!W0(t,86580,87264))break e;if(A=i[e+4>>2],!A|i[A+4>>2]!=-1||(W[i[i[A>>2]+8>>2]](A),y(A)),A=i[k>>2],k=i[k+4>>2],k&&(i[k+4>>2]=i[k+4>>2]+1),i[e>>2]=A,A=i[e+4>>2],i[e+4>>2]=k,!A||(e=i[A+4>>2],i[A+4>>2]=e-1,e))break i;W[i[i[A>>2]+8>>2]](A),y(A);break i}if(e=e+8|0,(A|0)==(e|0))break}i[f+8>>2]=i[k>>2],A=i[k+4>>2],i[f+12>>2]=A,A&&(i[A+4>>2]=i[A+4>>2]+1),r2(n+36|0,f+8|0),A=i[f+12>>2];e:{if(!A||(e=i[A+4>>2],i[A+4>>2]=e-1,e))break e;W[i[i[A>>2]+8>>2]](A),y(A)}}v=f+16|0,A=i[r+92>>2]}i[A+104>>2]=o}function An(A,e,r,f){var k=0,n=0,t=0,o=0,s=0;k=v-112|0,v=k,bi(k+80|0,e);i:{e:{r:{f:switch(l[k+100|0]){case 1:if(e=i[k+84>>2],i[A>>2]=i[k+80>>2],i[A+4>>2]=e,A=A+8|0,u[k+99|0]<0)break e;e=k+88|0,r=i[e+4>>2],i[A>>2]=i[e>>2],i[A+4>>2]=r,i[A+8>>2]=i[e+8>>2];break i;case 0:break f;default:break r}if(W[i[i[e>>2]+108>>2]](k+8|0,e),l[k+100|0])break r;for(o=i[k+84>>2];;){if(t=o,(t|0)==i[k+80>>2]){if(e=i[26917],i[A>>2]=i[26916],i[A+4>>2]=e,A=A+8|0,u[107683]>=0){e=i[26919],i[A>>2]=i[26918],i[A+4>>2]=e,i[A+8>>2]=i[26920];break i}T(A,i[26918],i[26919]);break i}o=t-8|0,e=i[o>>2];f:{if(!e)break f;if(n=W0(e,86580,87892),n){e=i[t-4>>2],e&&(i[e+4>>2]=i[e+4>>2]+1);A:{k:{if(n=i[n+100>>2],(n|0)!=270){if((n|0)==180)break k;if((n|0)!=90)break A;n=i[f>>2],s=i[k+12>>2],i[f>>2]=i[r>>2],i[r>>2]=(n^-1)+s;break A}n=i[f>>2],i[f>>2]=i[k+16>>2]+(i[r>>2]^-1),i[r>>2]=n;break A}i[r>>2]=i[k+12>>2]+(i[r>>2]^-1),i[f>>2]=i[k+16>>2]+(i[f>>2]^-1)}A:{if(!e||(n=i[e+4>>2],i[e+4>>2]=n-1,n))break A;W[i[i[e>>2]+8>>2]](e),y(e)}if(e=i[o>>2],!e)break f}if(e=W0(e,86580,87972),!e)break f;t=i[t-4>>2],t&&(i[t+4>>2]=i[t+4>>2]+1);A:{k:{n:switch(i[e+100>>2]){case 1:n=i[k+12>>2],e=r;break k;case 0:break n;default:break A}n=i[k+16>>2],e=f}i[e>>2]=(i[e>>2]^-1)+n}if(!t||(e=i[t+4>>2],i[t+4>>2]=e-1,e))break f;W[i[i[t>>2]+8>>2]](t),y(t)}if(l[k+100|0])break}}_2(),H()}T(A,i[k+88>>2],i[k+92>>2])}A=l[k+100|0],(A|0)!=255&&(e=i[25179],i[k+8>>2]=i[25178],i[k+12>>2]=e,W[i[(k+8|0)+(A<<2)>>2]](k+111|0,k+80|0)),v=k+112|0}function VZ(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,t=0,o=0,s=0;f=v-160|0,v=f,i[f+92>>2]=0,i[f+64>>2]=72500,n=i[18128],i[f+8>>2]=n,k=i[n-12>>2],n=f+8|0,i[k+n>>2]=i[18129],t=n+i[i[f+8>>2]-12>>2]|0,k=f+12|0,J0(t,k),u[t+80|0]=0,i[t+72>>2]=0,i[f+64>>2]=72500,i[f+8>>2]=72480,t=R0(k),i[t>>2]=71232,i[f+52>>2]=0,i[f+56>>2]=0,i[f+44>>2]=0,i[f+48>>2]=0,i[f+60>>2]=16,k=f+148|0,U1(k,e,r),o=n,s=k,n=u[f+159|0],k=(n|0)<0,Y(o,k?i[f+148>>2]:s,k?i[f+152>>2]:n),u[f+159|0]<0&&Z(i[f+148>>2]),n=f+148|0,s0(n,r),o=n,n=u[f+159|0],k=(n|0)<0,Y(f+8|0,k?i[f+148>>2]:o,k?i[f+152>>2]:n),u[f+159|0]<0&&Z(i[f+148>>2]),n=Y(f+8|0,32351,20),k=i[i[n>>2]-12>>2]+n|0,i[k+4>>2]=i[k+4>>2]|1,n=Y(li(n,l[e+104|0]),42670,1),k=f+148|0,s0(k,r),o=k,k=u[f+159|0],s=(k|0)<0,Y(n,s?i[f+148>>2]:o,s?i[f+152>>2]:k),u[f+159|0]<0&&Z(i[f+148>>2]),n=Y(li(Y(n,32181,17),l[e+105|0]),42670,1),k=f+148|0,s0(k,r),o=k,r=u[f+159|0],k=(r|0)<0,Y(n,k?i[f+148>>2]:o,k?i[f+152>>2]:r),u[f+159|0]<0&&Z(i[f+148>>2]),Y(S0(Y(n,32253,17),l[e+106|0]),42670,1),e=i[f+60>>2];i:{e:{if(e&16){r=i[f+56>>2],e=i[f+36>>2],r>>>0<e>>>0&&(i[f+56>>2]=e,r=e),e=f+32|0;break e}if(!(e&8)){r=0,u[A+11|0]=0;break i}r=i[f+28>>2],e=f+20|0}e:{if(n=i[e>>2],r=r-n|0,r>>>0<2147483640){if(r>>>0>=11){k=r|7,e=p(k+1|0),i[A+8>>2]=k-2147483647,i[A>>2]=e,i[A+4>>2]=r,A=e;break e}if(u[A+11|0]=r,r)break e;r=0;break i}Q0(),H()}if(!r)break i;x(A,n,r)}u[A+r|0]=0,A=i[18127],i[f+8>>2]=A,i[i[A-12>>2]+(f+8|0)>>2]=i[18130],i[t>>2]=71232,u[f+55|0]<0&&Z(i[f+44>>2]),E0(t),y0(f- -64|0),v=f+160|0}function FZ(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,t=0,o=0,s=0;f=v-160|0,v=f,i[f+92>>2]=0,i[f+64>>2]=72500,k=i[18128],i[f+8>>2]=k,n=i[k-12>>2],k=f+8|0,i[n+k>>2]=i[18129],t=k+i[i[f+8>>2]-12>>2]|0,n=f+12|0,J0(t,n),u[t+80|0]=0,i[t+72>>2]=0,i[f+64>>2]=72500,i[f+8>>2]=72480,t=R0(n),i[t>>2]=71232,i[f+52>>2]=0,i[f+56>>2]=0,i[f+44>>2]=0,i[f+48>>2]=0,i[f+60>>2]=16,n=f+148|0,s0(n,r),o=k,s=n,k=u[f+159|0],n=(k|0)<0,Y(o,n?i[f+148>>2]:s,n?i[f+152>>2]:k),u[f+159|0]<0&&Z(i[f+148>>2]),u[f+148|0]=39,k=f+148|0,n=Y(f+8|0,k,1),L1(k,i[e+100>>2]),o=n,s=k,k=u[f+159|0],n=(k|0)<0,o=Y(Y(o,n?i[f+148>>2]:s,n?i[f+152>>2]:k),30305,15),k=u[e+123|0],n=(k|0)<0,Y(Y(o,n?i[e+112>>2]:e+112|0,n?i[e+116>>2]:k),42670,1),u[f+159|0]<0&&Z(i[f+148>>2]),k=f+148|0,s0(k,r),n=k,r=u[f+159|0],k=(r|0)<0,Y(f+8|0,k?i[f+148>>2]:n,k?i[f+152>>2]:r),u[f+159|0]<0&&Z(i[f+148>>2]),Y(f+8|0,29236,10);i:{e:switch(i[e+124>>2]){case 0:Y(f+8|0,33199,6);break i;case 1:Y(f+8|0,33386,10);break i;case 2:break e;default:break i}Y(f+8|0,33206,9)}e=i[f+60>>2];i:{e:{if(e&16){e=i[f+56>>2],r=i[f+36>>2],e>>>0<r>>>0&&(i[f+56>>2]=r,e=r),r=f+32|0;break e}if(!(e&8)){e=0,u[A+11|0]=0;break i}e=i[f+28>>2],r=f+20|0}e:{if(k=i[r>>2],e=e-k|0,e>>>0<2147483640){if(e>>>0>=11){n=e|7,r=p(n+1|0),i[A+8>>2]=n-2147483647,i[A>>2]=r,i[A+4>>2]=e,A=r;break e}if(u[A+11|0]=e,e)break e;e=0;break i}Q0(),H()}if(!e)break i;x(A,k,e)}u[A+e|0]=0,A=i[18127],i[f+8>>2]=A,i[i[A-12>>2]+(f+8|0)>>2]=i[18130],i[t>>2]=71232,u[f+55|0]<0&&Z(i[f+44>>2]),E0(t),y0(f- -64|0),v=f+160|0}function kn(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,t=0,o=0,s=0;f=v-160|0,v=f,i[f+92>>2]=0,i[f+64>>2]=72500,k=i[18128],i[f+8>>2]=k,n=i[k-12>>2],k=f+8|0,i[n+k>>2]=i[18129],t=k+i[i[f+8>>2]-12>>2]|0,n=f+12|0,J0(t,n),u[t+80|0]=0,i[t+72>>2]=0,i[f+64>>2]=72500,i[f+8>>2]=72480,t=R0(n),i[t>>2]=71232,i[f+52>>2]=0,i[f+56>>2]=0,i[f+44>>2]=0,i[f+48>>2]=0,i[f+60>>2]=16,n=f+148|0,Y2(n,e,r),s=k,o=n,k=u[f+159|0],n=(k|0)<0,Y(s,n?i[f+148>>2]:o,n?i[f+152>>2]:k),u[f+159|0]<0&&Z(i[f+148>>2]),k=f+148|0,s0(k,r),o=k,k=u[f+159|0],n=(k|0)<0,Y(f+8|0,n?i[f+148>>2]:o,n?i[f+152>>2]:k),u[f+159|0]<0&&Z(i[f+148>>2]),k=Y(V0(Y(f+8|0,32120,10),i[e+104>>2]),42670,1),n=f+148|0,s0(n,r),o=n,r=u[f+159|0],n=(r|0)<0,Y(k,n?i[f+148>>2]:o,n?i[f+152>>2]:r),u[f+159|0]<0&&Z(i[f+148>>2]),Y(k,30247,12),r=i[e+108>>2],k=i[e+112>>2];i:{if((r|0)==(k|0)||(V0(f+8|0,i[r>>2]),e=r+4|0,(k|0)==(e|0)))break i;for(;r=i[e>>2],u[f+148|0]=32,n=f+8|0,Y(n,f+148|0,1),V0(n,r),e=e+4|0,(k|0)!=(e|0););}Y(f+8|0,42670,1),e=i[f+60>>2];i:{e:{if(e&16){e=i[f+56>>2],r=i[f+36>>2],e>>>0<r>>>0&&(i[f+56>>2]=r,e=r),r=f+32|0;break e}if(!(e&8)){e=0,u[A+11|0]=0;break i}e=i[f+28>>2],r=f+20|0}e:{if(k=i[r>>2],e=e-k|0,e>>>0<2147483640){if(e>>>0>=11){n=e|7,r=p(n+1|0),i[A+8>>2]=n-2147483647,i[A>>2]=r,i[A+4>>2]=e,A=r;break e}if(u[A+11|0]=e,e)break e;e=0;break i}Q0(),H()}if(!e)break i;x(A,k,e)}u[A+e|0]=0,A=i[18127],i[f+8>>2]=A,i[i[A-12>>2]+(f+8|0)>>2]=i[18130],i[t>>2]=71232,u[f+55|0]<0&&Z(i[f+44>>2]),E0(t),y0(f- -64|0),v=f+160|0}function Gr(A,e,r){var f=0,k=0,n=0,t=0,o=0,s=0,w=0,h=0,_=0,B=0,m=0,X=0;t=v-16|0,v=t,i[t+12>>2]=0,i[t+4>>2]=0,i[t+8>>2]=0;i:{if(r){if((r|0)<0)break i;f=p(r),r&&o0(f,0,r),k=r+f|0,i[t+12>>2]=k,i[t+8>>2]=k,i[t+4>>2]=f}r&&x(f,e,r),f=v-16|0,v=f,k=t+4|0,s=i[k>>2],e=l[s|0]>>>1|0;e:{r:{f:{if(r=i[A+132>>2],n=i[A+136>>2],(r|0)!=(n|0))for(;;){if((e|0)==l[r+1|0]){if(n=i[r+4>>2],e=i[r+8>>2],(n|0)!=(e|0))for(h=i[k+4>>2],o=h-s|0;;){if(A=0,_=i[n>>2],w=i[n+4>>2]-_|0,B=o>>>0<w>>>0?o:w,!B)break r;for(;;){if(l[A+_|0]==l[A+s|0]){if(A=A+1|0,(B|0)!=(A|0))continue;break r}break}if(n=n+12|0,(e|0)==(n|0))break}if(e>>>0<u0[r+12>>2]){if(i[e+8>>2]=0,i[e>>2]=0,i[e+4>>2]=0,A=i[k+4>>2],n=i[k>>2],(A|0)!=(n|0)){if(A=A-n|0,(A|0)<0)break f;k=p(A),i[e+4>>2]=k,i[e>>2]=k,o=A+k|0,i[e+8>>2]=o,A&&x(k,n,A),i[e+4>>2]=o}i[r+8>>2]=e+12;break e}m=r,X=y6(r+4|0,k),i[m+8>>2]=X;break e}if(r=r+16|0,(n|0)==(r|0))break}i[f+12>>2]=0,i[f+4>>2]=0,i[f+8>>2]=0,u[f+1|0]=e,u[f|0]=1,r=y6(f+4|0,k),e=i[A+136>>2],i[f+8>>2]=r;A:{if(e>>>0<u0[A+140>>2]){r=C[f>>1],i[e+12>>2]=0,i[e+4>>2]=0,i[e+8>>2]=0,g[e>>1]=r,r=i[f+4>>2],k=i[f+8>>2],vA(e+4|0,r,k,(k-r|0)/12|0),e=e+16|0;break A}e=Mn(A+132|0,f)}if(i[A+136>>2]=e,e=i[f+4>>2],!e)break e;if(r=i[f+8>>2],A=e,(r|0)!=(e|0)){for(;A=r-12|0,k=i[A>>2],k&&(i[r-8>>2]=k,Z(k)),r=A,(r|0)!=(e|0););A=i[f+4>>2]}i[f+8>>2]=e,Z(A);break e}G0(),H()}if((k|0)==(n|0)|o>>>0>=w>>>0)break e;d4(n,s,h,o)}v=f+16|0,A=i[t+4>>2],A&&(i[t+8>>2]=A,Z(A)),v=t+16|0;return}G0(),H()}function xf(A,e,r,f,k,n){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0;var t=0,o=0,s=0,w=0;t=v-128|0,v=t;i:{if(!(r&&e)){e=i[23570],i[A>>2]=i[23569],i[A+4>>2]=e,i[A+8>>2]=i[23571];break i}i[r>>2]=0,w=i[i[e>>2]+116>>2],i[t+60>>2]=0,i[t+64>>2]=0,g[t+68>>1]=0,i[t+100>>2]=0,i[t+104>>2]=0,i[t+108>>2]=0,i[t+112>>2]=0,i[t+72>>2]=0,g[t+48>>1]=8,i[t+52>>2]=0,i[t+56>>2]=0,i[t+92>>2]=0,i[t+96>>2]=0,u[t+88|0]=0,i[t+80>>2]=2,i[t+84>>2]=2,u[t+76|0]=1;e:{if(!n)break e;r:{f:{A:{k:{n:{t:{u:{o:switch(o=l[n|0],(o>>>0>=8?8:o)-1|0){case 0:break r;case 1:break f;case 2:break A;case 3:break k;case 4:break n;case 5:break t;case 6:break u;case 7:break o;default:break e}i[t+108>>2]=i[n+60>>2],i[t+112>>2]=i[n+64>>2],i[t+104>>2]=i[n+56>>2],i[t+100>>2]=i[n+52>>2]}i[t+96>>2]=i[n+48>>2]}i[t+92>>2]=i[n+44>>2]}s=i[n+32>>2],o=t+76|0,i[o>>2]=i[n+28>>2],i[o+4>>2]=s,s=i[n+40>>2],i[o+8>>2]=i[n+36>>2],i[o+12>>2]=s}i[t+72>>2]=i[n+24>>2]}u[t+69|0]=l[n+21|0]}u[t+68|0]=l[n+20|0]}u[t+49|0]=l[n+1|0],i[t+52>>2]=i[n+4>>2],i[t+56>>2]=i[n+8>>2],i[t+60>>2]=i[n+12>>2],i[t+64>>2]=i[n+16>>2]}o=i[e+8>>2],i[t+12>>2]=t+16,i[t+16>>2]=0,i[t+20>>2]=0,n=t+24|0,s=f,f=t+12|0,C9(n,o,w,s,k,t+48|0,0,0,0,f),Y1(f,i[t+16>>2]);e:switch(l[t+44|0]){default:_2(),H();case 0:k=i[t+24>>2],f=i[t+28>>2],f&&(i[f+4>>2]=i[f+4>>2]+1),n=r,r=p(8),i[n>>2]=r,i[r+4>>2]=f,i[r>>2]=k,n=107664;break;case 1:break e}if(r=A,A=i[e>>2],b0(r,n,A?A+84|0:0),A=l[t+44|0],(A|0)==255)break i;e=i[24213],i[t+120>>2]=i[24212],i[t+124>>2]=e,W[i[(t+120|0)+(A<<2)>>2]](t+119|0,t+24|0)}v=t+128|0}function IZ(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0;var k=0,n=0,t=0,o=0,s=0;t=v-16|0,v=t;i:{if(!(f&&e)){e=i[23570],i[A>>2]=i[23569],i[A+4>>2]=e,i[A+8>>2]=i[23571];break i}i[f>>2]=0,k=i[e>>2],e=i[k+48>>2],o=i[k+52>>2],o&&(i[o+4>>2]=i[o+4>>2]+1);e:{if(!e3(e,r)){i[A>>2]=1,i[A+4>>2]=2006,i[A+8>>2]=3455;break e}k=v-32|0,v=k,i[k+28>>2]=0,i[k+20>>2]=0,i[k+24>>2]=0,j1(k,e,r,k+20|0);r:{if(i[k>>2]){i[t+8>>2]=0,i[t+12>>2]=0;break r}f:{if(n=i[k+20>>2],r=i[k+24>>2],(n|0)!=(r|0)){if(e=i[n>>2],e&&(s=i[t+12>>2],e=W0(e,86580,86636),e))break f;if(n=n+8|0,(r|0)!=(n|0))for(;;){if(e=i[n>>2],e&&(s=0,e=W0(e,86580,86636),e))break f;if(n=n+8|0,(r|0)==(n|0))break}i[t+8>>2]=0,i[t+12>>2]=0}i[t+8>>2]=0,i[t+12>>2]=0;break r}if(i[t+12>>2]=s,i[t+8>>2]=e,e=i[n+4>>2],i[t+12>>2]=e,!e)break r;i[e+4>>2]=i[e+4>>2]+1}if(u[k+19|0]<0&&Z(i[k+8>>2]),r=i[k+20>>2],r){if(e=r,n=i[k+24>>2],(e|0)!=(n|0)){for(;;){e=i[n-4>>2];r:{if(!e||(s=i[e+4>>2],i[e+4>>2]=s-1,s))break r;W[i[i[e>>2]+8>>2]](e),y(e)}if(n=n-8|0,(r|0)==(n|0))break}e=i[k+20>>2]}i[k+24>>2]=r,Z(e)}if(v=k+32|0,e=i[t+8>>2],e&&(r=p(24),i[f>>2]=r,f=i[e+124>>2],i[r+16>>2]=i[e+120>>2],i[r+20>>2]=f,f=i[e+116>>2],i[r+8>>2]=i[e+112>>2],i[r+12>>2]=f,f=i[e+108>>2],i[r>>2]=i[e+104>>2],i[r+4>>2]=f),e=i[24057],i[A>>2]=i[24056],i[A+4>>2]=e,i[A+8>>2]=i[24058],A=i[t+12>>2],!A||(e=i[A+4>>2],i[A+4>>2]=e-1,e))break e;W[i[i[A>>2]+8>>2]](A),y(A)}if(!o||(A=i[o+4>>2],i[o+4>>2]=A-1,A))break i;W[i[i[o>>2]+8>>2]](o),y(o)}v=t+16|0}function CZ(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,t=0,o=0,s=0;f=v-160|0,v=f,i[f+92>>2]=0,i[f+64>>2]=72500,n=i[18128],i[f+8>>2]=n,k=i[n-12>>2],n=f+8|0,i[k+n>>2]=i[18129],t=n+i[i[f+8>>2]-12>>2]|0,k=f+12|0,J0(t,k),u[t+80|0]=0,i[t+72>>2]=0,i[f+64>>2]=72500,i[f+8>>2]=72480,t=R0(k),i[t>>2]=71232,i[f+52>>2]=0,i[f+56>>2]=0,i[f+44>>2]=0,i[f+48>>2]=0,i[f+60>>2]=16,k=f+148|0,s0(k,r),o=n,s=k,n=u[f+159|0],k=(n|0)<0,Y(o,k?i[f+148>>2]:s,k?i[f+152>>2]:n),u[f+159|0]<0&&Z(i[f+148>>2]),n=Y(V0(Y(f+8|0,30134,18),C[e+4>>1]),42670,1),k=f+148|0,s0(k,r),s=k,k=u[f+159|0],o=(k|0)<0,Y(n,o?i[f+148>>2]:s,o?i[f+152>>2]:k),u[f+159|0]<0&&Z(i[f+148>>2]),n=Y(V0(Y(n,30220,26),C[e+6>>1]),42670,1),k=f+148|0,s0(k,r),s=k,k=u[f+159|0],o=(k|0)<0,Y(n,o?i[f+148>>2]:s,o?i[f+152>>2]:k),u[f+159|0]<0&&Z(i[f+148>>2]),n=Y(V0(Y(n,29802,21),C[e+8>>1]),42670,1),k=f+148|0,s0(k,r),s=k,r=u[f+159|0],k=(r|0)<0,Y(n,k?i[f+148>>2]:s,k?i[f+152>>2]:r),u[f+159|0]<0&&Z(i[f+148>>2]),Y(li(Y(n,31114,17),l[e+10|0]),42670,1),e=i[f+60>>2];i:{e:{if(e&16){r=i[f+56>>2],e=i[f+36>>2],r>>>0<e>>>0&&(i[f+56>>2]=e,r=e),e=f+32|0;break e}if(!(e&8)){r=0,u[A+11|0]=0;break i}r=i[f+28>>2],e=f+20|0}e:{if(n=i[e>>2],r=r-n|0,r>>>0<2147483640){if(r>>>0>=11){k=r|7,e=p(k+1|0),i[A+8>>2]=k-2147483647,i[A>>2]=e,i[A+4>>2]=r,A=e;break e}if(u[A+11|0]=r,r)break e;r=0;break i}Q0(),H()}if(!r)break i;x(A,n,r)}u[A+r|0]=0,A=i[18127],i[f+8>>2]=A,i[i[A-12>>2]+(f+8|0)>>2]=i[18130],i[t>>2]=71232,u[f+55|0]<0&&Z(i[f+44>>2]),E0(t),y0(f- -64|0),v=f+160|0}function pZ(A,e,r,f,k,n,t){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,t=t|0;var o=0,s=0,w=0,h=0,_=0,B=0;if(A=v-144|0,v=A,i[A+136>>2]=r,i[A+140>>2]=e,i[A+20>>2]=2072,s=A+20|0,w=Q1(A+24|0,A+32|0,s),o=A+16|0,e=i[k+28>>2],i[o>>2]=e,(e|0)!=129576&&(i[e+4>>2]=i[e+4>>2]+1),e=c0(o,129760),u[A+15|0]=0,P7(A+140|0,r,f,o,i[k+4>>2],n,A+15|0,e,w,s,A+132|0)){r=v-16|0,v=r;i:if(l[t+11|0]>>>7|0)break i;i:{if(l[t+11|0]>>>7|0){f=i[t>>2],u[r+15|0]=0,u[f|0]=l[r+15|0],i[t+4>>2]=0;break i}u[r+14|0]=0,u[t|0]=l[r+14|0],u[t+11|0]=l[t+11|0]&128,u[t+11|0]=l[t+11|0]&127}for(v=r+16|0,l[A+15|0]==1&&oi(t,W[i[i[e>>2]+28>>2]](e,45)|0),e=W[i[i[e>>2]+28>>2]](e,48)|0,r=i[w>>2],s=i[A+20>>2],f=s-1|0,e=e&255;;){if(!((e|0)!=l[r|0]|r>>>0>=f>>>0)){r=r+1|0;continue}break}f=v-16|0,v=f,l[t+11|0]>>>7|0?k=i[t+4>>2]:k=l[t+11|0]&127,o=l[t+11|0]>>>7|0?(i[t+8>>2]&2147483647)-1|0:10,h=s-r|0;i:{if(!h)break i;if(l[t+11|0]>>>7|0?e=i[t>>2]:e=t,B=e,l[t+11|0]>>>7|0?e=i[t>>2]:e=t,l[t+11|0]>>>7|0?_=i[t+4>>2]:_=l[t+11|0]&127,!fl(B,(e+_|0)+1|0,r)){h>>>0>o-k>>>0&&tA(t,o,h+(k-o|0)|0,k,k),l[t+11|0]>>>7|0?e=i[t>>2]:e=t,e=e+k|0,o=s-r|0,s=!o,s|s||x(e,r,o),u[f+15|0]=0,u[e+o|0]=l[f+15|0],z6(t,k+h|0);break i}e=v-16|0,v=e,ru(f,r,s),v=e+16|0,l[f+11|0]>>>7|0?e=i[f>>2]:e=f,l[f+11|0]>>>7|0?r=i[f+4>>2]:r=l[f+11|0]&127,pA(t,e,r),s2(f)}v=f+16|0}return L2(A+140|0,A+136|0)&&(i[n>>2]=i[n>>2]|2),r=i[A+140>>2],e2(A+16|0),e=i[w>>2],i[w>>2]=0,e&&W[i[w+4>>2]](e),v=A+144|0,r|0}function yZ(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,t=0,o=0,s=0;f=v-160|0,v=f,i[f+92>>2]=0,i[f+64>>2]=72500,k=i[18128],i[f+8>>2]=k,n=i[k-12>>2],k=f+8|0,i[n+k>>2]=i[18129],t=k+i[i[f+8>>2]-12>>2]|0,n=f+12|0,J0(t,n),u[t+80|0]=0,i[t+72>>2]=0,i[f+64>>2]=72500,i[f+8>>2]=72480,t=R0(n),i[t>>2]=71232,i[f+52>>2]=0,i[f+56>>2]=0,i[f+44>>2]=0,i[f+48>>2]=0,i[f+60>>2]=16,n=f+148|0,Y2(n,e,r),o=k,s=n,k=u[f+159|0],n=(k|0)<0,Y(o,n?i[f+148>>2]:s,n?i[f+152>>2]:k),u[f+159|0]<0&&Z(i[f+148>>2]),k=f+148|0,s0(k,r),o=k,k=u[f+159|0],n=(k|0)<0,Y(f+8|0,n?i[f+148>>2]:o,n?i[f+152>>2]:k),u[f+159|0]<0&&Z(i[f+148>>2]),k=f+8|0,Y(V0(Y(k,30644,22),i[e+100>>2]),42670,1),n=f+148|0,s0(n,r),o=k,s=n,k=u[f+159|0],n=(k|0)<0,Y(o,n?i[f+148>>2]:s,n?i[f+152>>2]:k),u[f+159|0]<0&&Z(i[f+148>>2]),k=f+8|0,Y(V0(Y(k,29533,17),C[e+104>>1]),42670,1),n=f+148|0,s0(n,r),o=k,r=u[f+159|0],k=(r|0)<0,Y(o,k?i[f+148>>2]:n,k?i[f+152>>2]:r),u[f+159|0]<0&&Z(i[f+148>>2]),Y(V0(Y(f+8|0,29276,17),C[e+106>>1]),42670,1),e=i[f+60>>2];i:{e:{if(e&16){r=i[f+56>>2],e=i[f+36>>2],r>>>0<e>>>0&&(i[f+56>>2]=e,r=e),e=f+32|0;break e}if(!(e&8)){r=0,u[A+11|0]=0;break i}r=i[f+28>>2],e=f+20|0}e:{if(k=i[e>>2],r=r-k|0,r>>>0<2147483640){if(r>>>0>=11){n=r|7,e=p(n+1|0),i[A+8>>2]=n-2147483647,i[A>>2]=e,i[A+4>>2]=r,A=e;break e}if(u[A+11|0]=r,r)break e;r=0;break i}Q0(),H()}if(!r)break i;x(A,k,r)}u[A+r|0]=0,A=i[18127],i[f+8>>2]=A,i[i[A-12>>2]+(f+8|0)>>2]=i[18130],i[t>>2]=71232,u[f+55|0]<0&&Z(i[f+44>>2]),E0(t),y0(f- -64|0),v=f+160|0}function EZ(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,t=0,o=0,s=0;f=v-160|0,v=f,i[f+92>>2]=0,i[f+64>>2]=72500,n=i[18128],i[f+8>>2]=n,k=i[n-12>>2],n=f+8|0,i[k+n>>2]=i[18129],t=n+i[i[f+8>>2]-12>>2]|0,k=f+12|0,J0(t,k),u[t+80|0]=0,i[t+72>>2]=0,i[f+64>>2]=72500,i[f+8>>2]=72480,t=R0(k),i[t>>2]=71232,i[f+52>>2]=0,i[f+56>>2]=0,i[f+44>>2]=0,i[f+48>>2]=0,i[f+60>>2]=16,k=f+148|0,Y2(k,e,r),o=n,s=k,n=u[f+159|0],k=(n|0)<0,Y(o,k?i[f+148>>2]:s,k?i[f+152>>2]:n),u[f+159|0]<0&&Z(i[f+148>>2]),n=f+148|0,s0(n,r),o=n,n=u[f+159|0],k=(n|0)<0,Y(f+8|0,k?i[f+148>>2]:o,k?i[f+152>>2]:n),u[f+159|0]<0&&Z(i[f+148>>2]),n=Y(V0(Y(f+8|0,32120,10),i[e+104>>2]),42670,1),k=f+148|0,s0(k,r),o=k,k=u[f+159|0],s=(k|0)<0,Y(n,s?i[f+148>>2]:o,s?i[f+152>>2]:k),u[f+159|0]<0&&Z(i[f+148>>2]),n=Y(V0(Y(n,32610,15),i[i[e+108>>2]>>2]),42670,1),k=f+148|0,s0(k,r),o=k,r=u[f+159|0],k=(r|0)<0,Y(n,k?i[f+148>>2]:o,k?i[f+152>>2]:r),u[f+159|0]<0&&Z(i[f+148>>2]),Y(V0(Y(n,32593,16),i[i[e+108>>2]+4>>2]),42670,1),e=i[f+60>>2];i:{e:{if(e&16){r=i[f+56>>2],e=i[f+36>>2],r>>>0<e>>>0&&(i[f+56>>2]=e,r=e),e=f+32|0;break e}if(!(e&8)){r=0,u[A+11|0]=0;break i}r=i[f+28>>2],e=f+20|0}e:{if(n=i[e>>2],r=r-n|0,r>>>0<2147483640){if(r>>>0>=11){k=r|7,e=p(k+1|0),i[A+8>>2]=k-2147483647,i[A>>2]=e,i[A+4>>2]=r,A=e;break e}if(u[A+11|0]=r,r)break e;r=0;break i}Q0(),H()}if(!r)break i;x(A,n,r)}u[A+r|0]=0,A=i[18127],i[f+8>>2]=A,i[i[A-12>>2]+(f+8|0)>>2]=i[18130],i[t>>2]=71232,u[f+55|0]<0&&Z(i[f+44>>2]),E0(t),y0(f- -64|0),v=f+160|0}function YZ(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,t=0,o=0,s=0;f=v-160|0,v=f,i[f+92>>2]=0,i[f+64>>2]=72500,k=i[18128],i[f+8>>2]=k,t=i[k-12>>2],k=f+8|0,i[t+k>>2]=i[18129],o=k+i[i[f+8>>2]-12>>2]|0,n=f+12|0,J0(o,n),u[o+80|0]=0,i[o+72>>2]=0,i[f+64>>2]=72500,i[f+8>>2]=72480,o=R0(n),i[o>>2]=71232,i[f+52>>2]=0,i[f+56>>2]=0,i[f+44>>2]=0,i[f+48>>2]=0,i[f+60>>2]=16,n=f+148|0,Y2(n,e,r),s=k,t=n,k=u[f+159|0],n=(k|0)<0,Y(s,n?i[f+148>>2]:t,n?i[f+152>>2]:k),u[f+159|0]<0&&Z(i[f+148>>2]),k=f+148|0,s0(k,r),t=k,k=u[f+159|0],n=(k|0)<0,Y(f+8|0,n?i[f+148>>2]:t,n?i[f+152>>2]:k),u[f+159|0]<0&&Z(i[f+148>>2]),k=f+8|0,Y(S0(Y(S0(Y(S0(Y(S0(Y(k,31499,16),i[e+100>>2]),22183,1),i[e+104>>2]),27474,3),i[e+108>>2]),22183,1),i[e+112>>2]),42670,1),n=f+148|0,s0(n,r),t=k,r=u[f+159|0],k=(r|0)<0,Y(t,k?i[f+148>>2]:n,k?i[f+152>>2]:r),u[f+159|0]<0&&Z(i[f+148>>2]),Y(S0(Y(S0(Y(S0(Y(S0(Y(f+8|0,29717,8),i[e+116>>2]),22183,1),i[e+120>>2]),29189,3),i[e+124>>2]),22183,1),i[e+128>>2]),42670,1),e=i[f+60>>2];i:{e:{if(e&16){e=i[f+56>>2],r=i[f+36>>2],e>>>0<r>>>0&&(i[f+56>>2]=r,e=r),r=f+32|0;break e}if(!(e&8)){e=0,u[A+11|0]=0;break i}e=i[f+28>>2],r=f+20|0}e:{if(k=i[r>>2],e=e-k|0,e>>>0<2147483640){if(e>>>0>=11){n=e|7,r=p(n+1|0),i[A+8>>2]=n-2147483647,i[A>>2]=r,i[A+4>>2]=e,A=r;break e}if(u[A+11|0]=e,e)break e;e=0;break i}Q0(),H()}if(!e)break i;x(A,k,e)}u[A+e|0]=0,A=i[18127],i[f+8>>2]=A,i[i[A-12>>2]+(f+8|0)>>2]=i[18130],i[o>>2]=71232,u[f+55|0]<0&&Z(i[f+44>>2]),E0(o),y0(f- -64|0),v=f+160|0}function RZ(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,t=0,o=0,s=0,w=0;if(f=v-160|0,v=f,i[f+92>>2]=0,i[f+64>>2]=72500,n=i[18128],i[f+8>>2]=n,k=i[n-12>>2],n=f+8|0,i[k+n>>2]=i[18129],s=n+i[i[f+8>>2]-12>>2]|0,k=f+12|0,J0(s,k),u[s+80|0]=0,i[s+72>>2]=0,i[f+64>>2]=72500,i[f+8>>2]=72480,s=R0(k),i[s>>2]=71232,i[f+52>>2]=0,i[f+56>>2]=0,i[f+44>>2]=0,i[f+48>>2]=0,i[f+60>>2]=16,k=f+148|0,U1(k,e,r),t=n,o=k,n=u[f+159|0],k=(n|0)<0,Y(t,k?i[f+148>>2]:o,k?i[f+152>>2]:n),u[f+159|0]<0&&Z(i[f+148>>2]),i[e+108>>2]!=i[e+104>>2])for(n=0;k=f+148|0,s0(k,r),o=k,k=u[f+159|0],t=(k|0)<0,Y(f+8|0,t?i[f+148>>2]:o,t?i[f+152>>2]:k),u[f+159|0]<0&&Z(i[f+148>>2]),k=f+8|0,Y(V0(Y(k,19205,1),n),41694,2),i[r>>2]=i[r>>2]+1,t=f+148|0,o=i[i[e+104>>2]+(n<<3)>>2],W[i[i[o>>2]+12>>2]](t,o,r),o=k,w=t,k=u[f+159|0],t=(k|0)<0,Y(o,t?i[f+148>>2]:w,t?i[f+152>>2]:k),u[f+159|0]<0&&Z(i[f+148>>2]),k=i[r>>2],i[r>>2]=((k|0)<=1?1:k)-1,n=n+1|0,n>>>0<i[e+108>>2]-i[e+104>>2]>>3>>>0;);e=i[f+60>>2];i:{e:{if(e&16){n=f+32|0,r=i[f+56>>2],e=i[f+36>>2],r>>>0<e>>>0?i[f+56>>2]=e:e=r;break e}if(!(e&8)){r=0,u[A+11|0]=0;break i}n=f+20|0,e=i[f+28>>2]}e:{if(n=i[n>>2],r=e-n|0,r>>>0<2147483640){if(r>>>0>=11){k=r|7,e=p(k+1|0),i[A+8>>2]=k-2147483647,i[A>>2]=e,i[A+4>>2]=r,A=e;break e}if(u[A+11|0]=r,r)break e;r=0;break i}Q0(),H()}if(!r)break i;x(A,n,r)}u[A+r|0]=0,A=i[18127],i[f+8>>2]=A,i[i[A-12>>2]+(f+8|0)>>2]=i[18130],i[s>>2]=71232,u[f+55|0]<0&&Z(i[f+44>>2]),E0(s),y0(f- -64|0),v=f+160|0}function JZ(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0;var k=0,n=0,t=0,o=0,s=0,w=0;o=v-48|0,v=o;i:{e:{if(!f){e=i[23570],i[A>>2]=i[23569],i[A+4>>2]=e,i[A+8>>2]=i[23571];break e}i[f>>2]=0,k=i[e>>2],i[o+44>>2]=0,i[o+36>>2]=0,i[o+40>>2]=0,t=i[k+248>>2],s=i[k+252>>2];r:{if((t|0)!=(s|0)){if(k=s-t|0,(k|0)<0)break i;for(n=p(k),i[o+36>>2]=n,i[o+44>>2]=k+n,k=n;i[k>>2]=i[t>>2],w=k,k=i[t+4>>2],i[w+4>>2]=k,k&&(i[k+4>>2]=i[k+4>>2]+1),k=w+8|0,t=t+8|0,(s|0)!=(t|0););for(i[o+40>>2]=k,t=n;;){if(s=i[t>>2],i[s+116>>2]==(r|0)){r=p(16),i[r>>2]=0,i[r+4>>2]=0,i[r+8>>2]=0,i[r+12>>2]=0,i[f>>2]=r,k=i[t+4>>2];f:{if(!k){i[r+4>>2]=k,i[r>>2]=s;break f}if(i[k+4>>2]=i[k+4>>2]+1,i[r>>2]=s,n=i[r+4>>2],i[r+4>>2]=k,!n||(r=i[n+4>>2],i[n+4>>2]=r-1,r))break f;W[i[i[n>>2]+8>>2]](n),y(n)}r=i[e+8>>2],f=i[f>>2],n=i[e+12>>2],n&&(i[n+4>>2]=i[n+4>>2]+1),i[f+8>>2]=r,r=i[f+12>>2],i[f+12>>2]=n;f:{if(!r||(f=i[r+4>>2],i[r+4>>2]=f-1,f))break f;W[i[i[r>>2]+8>>2]](r),y(r)}r=A,A=i[e>>2],b0(r,107664,A?A+84|0:0),n=i[o+36>>2];break r}if(k=(t|0)!=(w|0),t=t+8|0,!k)break}}if(u[o+4|0]=0,u[o+15|0]=0,r=q(o+16|0,5,2e3,o+4|0),u[o+15|0]<0&&Z(i[o+4>>2]),f=A,A=i[e>>2],b0(f,r,A?A+84|0:0),u[r+19|0]>=0)break r;Z(i[r+8>>2])}if(!n)break e;if(A=n,t=i[o+40>>2],(t|0)!=(n|0)){for(;;){A=i[t-4>>2];r:{if(!A||(e=i[A+4>>2],i[A+4>>2]=e-1,e))break r;W[i[i[A>>2]+8>>2]](A),y(A)}if(t=t-8|0,(t|0)==(n|0))break}A=i[o+36>>2]}i[o+40>>2]=n,Z(A)}v=o+48|0;return}G0(),H()}function NZ(A,e,r,f,k){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0;var n=0,t=0,o=0,s=0,w=0,h=0,_=0;w=v-16|0,v=w,t=v-32|0,v=t,s=i[e+8>>2],Z8(t+24|0,i[s+48>>2],1919377774),n=i[t+24>>2],u[n+164|0]=1,i[n+100>>2]=i[n+100>>2]&-2|1,o=i[i[t+24>>2]+104>>2],n=p(36),i[n+32>>2]=0,i[n+24>>2]=0,i[n+28>>2]=0,i[n+20>>2]=f,i[n+16>>2]=r,i[n+12>>2]=o,i[n>>2]=94464,i[n+4>>2]=0,i[n+8>>2]=0,i[w+12>>2]=n,r=n+12|0,i[w+8>>2]=r,i[t+20>>2]=n,i[t+16>>2]=r,i[n+4>>2]=i[n+4>>2]+1,r=i[t+20>>2],i[t+8>>2]=i[t+16>>2],i[t+12>>2]=r;i:{if(r=i[s+160>>2],o=i[s+164>>2],r>>>0<o>>>0){i[r>>2]=i[t+8>>2],i[r+4>>2]=i[t+12>>2],i[s+160>>2]=r+8;break i}e:{if(n=i[s+156>>2],r=r-n|0,_=r>>3,f=_+1|0,f>>>0<536870912){if(o=o-n|0,h=o>>2,o=o>>>0>=2147483640?536870911:f>>>0<h>>>0?h:f,o){if(o>>>0>=536870912)break e;f=p(o<<3)}else f=0;h=f+r|0,i[h>>2]=i[t+8>>2],i[h+4>>2]=i[t+12>>2],_=h-(_<<3)|0,r&&x(_,n,r),i[s+164>>2]=f+(o<<3),r=h+8|0,i[s+160>>2]=r,i[s+156>>2]=_,n&&Z(n),i[s+160>>2]=r;break i}G0(),H()}z0(),H()}r=i[t+28>>2];i:{if(!r||(f=i[r+4>>2],i[r+4>>2]=f-1,f))break i;W[i[i[r>>2]+8>>2]](r),y(r)}v=t+32|0,Au(i[e>>2],i[i[w+8>>2]>>2]);i:{if(k){r=p(16),f=i[e+8>>2],e=i[e+12>>2],e&&(i[e+4>>2]=i[e+4>>2]+1),i[r+4>>2]=e,i[r>>2]=f,e=i[w+12>>2],i[r+8>>2]=i[w+8>>2],i[r+12>>2]=e,i[k>>2]=r,i[A+8>>2]=i[24058],e=i[24057],i[A>>2]=i[24056],i[A+4>>2]=e;break i}if(e=i[w+12>>2],r=i[24057],i[A>>2]=i[24056],i[A+4>>2]=r,i[A+8>>2]=i[24058],!e||(A=i[e+4>>2],i[e+4>>2]=A-1,A))break i;W[i[i[e>>2]+8>>2]](e),y(e)}v=w+16|0}function UZ(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0;var k=0,n=0,t=0,o=0,s=0,w=0;o=v-48|0,v=o;i:{e:{if(!f){e=i[23570],i[A>>2]=i[23569],i[A+4>>2]=e,i[A+8>>2]=i[23571];break e}k=i[e>>2],i[o+44>>2]=0,i[o+36>>2]=0,i[o+40>>2]=0,t=i[k+132>>2],s=i[k+136>>2];r:{if((t|0)!=(s|0)){if(k=s-t|0,(k|0)<0)break i;for(n=p(k),i[o+36>>2]=n,i[o+44>>2]=k+n,k=n;i[k>>2]=i[t>>2],w=k,k=i[t+4>>2],i[w+4>>2]=k,k&&(i[k+4>>2]=i[k+4>>2]+1),k=w+8|0,t=t+8|0,(s|0)!=(t|0););for(i[o+40>>2]=k,t=n;;){if(s=i[t>>2],i[s+116>>2]==(r|0)){r=p(16),i[r>>2]=0,i[r+4>>2]=0,i[r+8>>2]=0,i[r+12>>2]=0,i[f>>2]=r,k=i[t+4>>2];f:{if(!k){i[r+4>>2]=k,i[r>>2]=s;break f}if(i[k+4>>2]=i[k+4>>2]+1,i[r>>2]=s,n=i[r+4>>2],i[r+4>>2]=k,!n||(r=i[n+4>>2],i[n+4>>2]=r-1,r))break f;W[i[i[n>>2]+8>>2]](n),y(n)}r=i[e+8>>2],f=i[f>>2],n=i[e+12>>2],n&&(i[n+4>>2]=i[n+4>>2]+1),i[f+8>>2]=r,r=i[f+12>>2],i[f+12>>2]=n;f:{if(!r||(f=i[r+4>>2],i[r+4>>2]=f-1,f))break f;W[i[i[r>>2]+8>>2]](r),y(r)}r=A,A=i[e>>2],b0(r,107664,A?A+84|0:0),n=i[o+36>>2];break r}if(k=(t|0)!=(w|0),t=t+8|0,!k)break}}if(u[o+4|0]=0,u[o+15|0]=0,r=q(o+16|0,5,2e3,o+4|0),u[o+15|0]<0&&Z(i[o+4>>2]),f=A,A=i[e>>2],b0(f,r,A?A+84|0:0),u[r+19|0]>=0)break r;Z(i[r+8>>2])}if(!n)break e;if(A=n,t=i[o+40>>2],(t|0)!=(n|0)){for(;;){A=i[t-4>>2];r:{if(!A||(e=i[A+4>>2],i[A+4>>2]=e-1,e))break r;W[i[i[A>>2]+8>>2]](A),y(A)}if(t=t-8|0,(t|0)==(n|0))break}A=i[o+36>>2]}i[o+40>>2]=n,Z(A)}v=o+48|0;return}G0(),H()}function DZ(A,e,r,f,k,n,t,o){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,t=t|0,o=o|0;var s=0,w=0,h=0,_=0,B=0,m=0,X=0,Q=0,V=0,F=0,I=0,E=0;for(m=v-16|0,v=m,s=r;;){i:{if((f|0)==(s|0)){s=f;break i}if(!i[s>>2])break i;s=s+4|0;continue}break}i[o>>2]=n,i[k>>2]=r;i:{for(;;){e:{r:{if(!((r|0)==(f|0)|(n|0)==(t|0))){w=i[e+4>>2],i[m+8>>2]=i[e>>2],i[m+12>>2]=w,I=1,X=v-16|0,v=X,i[X+12>>2]=i[A+8>>2],E=s8(X+8|0,X+12|0),w=n,h=t-w|0,Q=0,V=v-16|0,v=V,_=i[k>>2],F=s-r>>2;f:{if(!_|!F)break f;for(h=w?h:0;;){if(B=Or(h>>>0<4?V+12|0:w,i[_>>2]),(B|0)==-1){Q=-1;break f}if(w){if(h>>>0<=3){if(h>>>0<B>>>0)break f;A8(w,V+12|0,B)}h=h-B|0,w=w+B|0}else w=0;if(!i[_>>2]){_=0;break f}if(Q=Q+B|0,_=_+4|0,F=F-1|0,!F)break}}w&&(i[k>>2]=_),v=V+16|0,w=i[E>>2],w&&(i[31366]=(w|0)==-1?125344:w),v=X+16|0;f:{A:{k:switch(Q+1|0){case 0:for(i[o>>2]=n;;){if(i[k>>2]==(r|0)||(e=i5(n,i[r>>2],i[A+8>>2]),(e|0)==-1))break A;n=e+i[o>>2]|0,i[o>>2]=n,r=r+4|0}case 1:break i;default:break k}if(n=i[o>>2]+Q|0,i[o>>2]=n,(n|0)==(t|0))break f;if((f|0)==(s|0)){r=i[k>>2],s=f;continue}if(r=m+4|0,s=i5(r,0,i[A+8>>2]),(s|0)==-1)break e;if(t-i[o>>2]>>>0<s>>>0)break i;for(;;){if(s){n=l[r|0],w=i[o>>2],i[o>>2]=w+1,u[w|0]=n,s=s-1|0,r=r+1|0;continue}break}for(r=i[k>>2]+4|0,i[k>>2]=r,s=r;;){if((f|0)==(s|0)){s=f;break r}if(!i[s>>2])break r;s=s+4|0}}i[k>>2]=r;break e}r=i[k>>2]}I=(r|0)!=(f|0);break i}n=i[o>>2];continue}break}I=2}return v=m+16|0,I|0}function MZ(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,t=0,o=0,s=0;n=v-16|0,v=n,f=p(168),i[f+4>>2]=0,i[f+8>>2]=0,i[f>>2]=92044,e=f+16|0,i[e+8>>2]=0,i[e+12>>2]=0,i[e+16>>2]=0,i[e+20>>2]=0,i[e+24>>2]=0,i[e+28>>2]=0,i[e+32>>2]=0,i[e>>2]=86356,i[f+60>>2]=0,i[f+64>>2]=0,i[f+52>>2]=0,i[f+56>>2]=0,i[f+72>>2]=-1,i[f+76>>2]=-1,i[f+80>>2]=-1,i[f+84>>2]=-1,i[f+88>>2]=0,i[f+92>>2]=0,i[f+96>>2]=0,i[f+100>>2]=0,i[f+104>>2]=0,i[f+108>>2]=0,u[f+112|0]=0,g[f+118>>1]=0,g[f+120>>1]=0,g[f+122>>1]=0,g[f+124>>1]=0,g[f+116>>1]=1,g[f+126>>1]=0,g[f+128>>1]=0,g[f+130>>1]=0,g[f+132>>1]=0,g[f+134>>1]=0,i[f+160>>2]=-65512,i[f+152>>2]=0,i[f+156>>2]=0,g[f+144>>1]=1,i[f+136>>2]=4718592,i[f+140>>2]=4718592,i[e>>2]=92084,u[f+159|0]=5,i[f+32>>2]=1781689193,u[f+152|0]=l[19589],t=l[19585]|l[19586]<<8|(l[19587]<<16|l[19588]<<24),u[f+148|0]=t,u[f+149|0]=t>>>8,u[f+150|0]=t>>>16,u[f+151|0]=t>>>24,o=i[r>>2],s=i[r+4>>2];i:{if((o|0)!=(s|0))for(t=f+52|0;;){r=i[o>>2],i[n+8>>2]=r,k=i[o+4>>2],i[n+12>>2]=k;e:{r:{f:{if(!k){if(i[r+16>>2]==1781689160)break f;break e}if(i[k+4>>2]=i[k+4>>2]+1,i[r+16>>2]!=1781689160)break r}if(r2(t,n+8|0),i[A+4>>2]=f,i[A>>2]=e,e=i[n+12>>2],!e||(A=i[e+4>>2],i[e+4>>2]=A-1,A))break i;W[i[i[e>>2]+8>>2]](e),y(e);break i}if(r=i[k+4>>2],i[k+4>>2]=r-1,r)break e;W[i[i[k>>2]+8>>2]](k),y(k)}if(o=o+8|0,(s|0)==(o|0))break}if(i[A>>2]=0,i[A+4>>2]=0,A=i[f+4>>2],i[f+4>>2]=A-1,A)break i;W[i[i[f>>2]+8>>2]](f),y(f)}v=n+16|0}function nn(A,e){var r=0;i[A>>2]=0,i[A+4>>2]=0,u[A+28|0]=e,i[A+24>>2]=0,i[A+16>>2]=0,i[A+20>>2]=0,i[A+8>>2]=0,i[A+12>>2]=0,e=p(160),i[e>>2]=93964,i[e+4>>2]=0,i[e+8>>2]=0,r=e+16|0,i[r+8>>2]=0,i[r+12>>2]=0,i[r+16>>2]=0,i[r+20>>2]=0,i[r+24>>2]=0,i[r+28>>2]=0,i[r+32>>2]=0,i[r>>2]=86356,i[e+60>>2]=0,i[e+64>>2]=0,i[e+52>>2]=0,i[e+56>>2]=0,i[e+72>>2]=-1,i[e+76>>2]=-1,i[e+80>>2]=-1,i[e+84>>2]=-1,i[e+116>>2]=0,i[e+88>>2]=0,i[e+92>>2]=0,i[e+96>>2]=0,i[e+100>>2]=0,i[e+104>>2]=0,i[e+108>>2]=0,g[e+112>>1]=0,i[r>>2]=106028,u[e+128|0]=0,i[e+120>>2]=0,i[e+124>>2]=0,i[e+132>>2]=0,i[e+136>>2]=0,i[e+140>>2]=0,i[e+144>>2]=0,i[e+148>>2]=0,i[e+152>>2]=0,i[e+32>>2]=1935763834,i[A>>2]=r,r=i[A+4>>2],i[A+4>>2]=e;i:{if(!r||(e=i[r+4>>2],i[r+4>>2]=e-1,e))break i;W[i[i[r>>2]+8>>2]](r),y(r)}e=p(168),i[e+4>>2]=0,i[e+8>>2]=0,i[e>>2]=94004,r=e+16|0,i[r+8>>2]=0,i[r+12>>2]=0,i[r+16>>2]=0,i[r+20>>2]=0,i[r+24>>2]=0,i[r+28>>2]=0,i[r+32>>2]=0,i[r>>2]=86356,i[e+60>>2]=0,i[e+64>>2]=0,i[e+52>>2]=0,i[e+56>>2]=0,i[e+72>>2]=-1,i[e+76>>2]=-1,i[e+80>>2]=-1,i[e+84>>2]=-1,i[e+116>>2]=0,i[e+88>>2]=0,i[e+92>>2]=0,i[e+96>>2]=0,i[e+100>>2]=0,i[e+104>>2]=0,i[e+108>>2]=0,g[e+112>>1]=0,i[r>>2]=106108,u[e+128|0]=0,i[e+120>>2]=0,i[e+124>>2]=0,i[e+144>>2]=0,i[e+148>>2]=0,i[e+152>>2]=0,i[e+156>>2]=0,i[e+160>>2]=0,i[e+32>>2]=1935763823,i[A+8>>2]=r,r=i[A+12>>2],i[A+12>>2]=e;i:{if(!r||(e=i[r+4>>2],i[r+4>>2]=e-1,e))break i;W[i[i[r>>2]+8>>2]](r),y(r)}return A}function tn(A){var e=0,r=0,f=0,k=0,n=0,t=0,o=0,s=0,w=0,h=0,_=0,B=0,m=0,X=0,Q=0,V=0,F=0,I=0,E=0,R=0,N=0,M=0,z=0,S=0,O=0;r=i[A+4>>2],t=i[r+124>>2],i[A+24>>2]=t,h=i[r+132>>2],i[A+28>>2]=h;i:{if(!i[A+12>>2]){_=1,f=1;break i}_=i[t+16852>>2],f=i[t+16856>>2]}i[A+300>>2]=f,i[A+296>>2]=_,V=G(i[A+20>>2],f),F=i[t+16892>>2],o=i[t+16876>>2],e=i[A+16>>2],I=G(e,_),I||(u[A+307|0]=0,u[A+304|0]=0),V||(u[A+307|0]=0,u[A+305|0]=0,u[A+306|0]=0),R=i[A+8>>2],k=G(e+R|0,_),(k|0)>=i[t+484>>2]&&(u[A+306|0]=0),s=i[r+152>>2],B=V>>o,z=G(G(s,B),24),X=I>>o,e=G(X,24),n=i[r+140>>2],N=-1,E=I-1>>o,M=-1,Q=l[A+304|0],M=(Q|0)==1?C[(n+G(E,24)|0)+z>>1]:M,w=e+n|0,m=V-1>>o,r=l[A+305|0],N=(r|0)==1?C[w+G(G(s,m),24)>>1]:N,S=k>>o,O=-1,o=-1,k=l[A+306|0],(k|0)==1&&(o=C[(n+G(S,24)|0)+G(G(s,m),24)>>1]),e=l[A+307|0],(e|0)==1&&(O=C[(n+G(E,24)|0)+G(G(s,m),24)>>1]),s=G(B,F)<<2,n=i[h+8484>>2],h=-1,B=-1,B=Q?i[s+(n+(E<<2)|0)>>2]:B,X=n+(X<<2)|0,h=r?i[X+(G(m,F)<<2)>>2]:h,Q=-1,r=-1,e&&(r=i[(n+(E<<2)|0)+(G(m,F)<<2)>>2]),w=C[w+z>>1],k&&(Q=i[(n+(S<<2)|0)+(G(m,F)<<2)>>2]),e=i[s+X>>2],(w|0)==(M|0)&(e|0)==(B|0)||(u[A+304|0]=0),(w|0)==(N|0)&(e|0)==(h|0)||(u[A+305|0]=0),(w|0)==(O|0)&(e|0)==(r|0)||(u[A+307|0]=0),(o|0)==(w|0)&(e|0)==(Q|0)||(u[A+306|0]=0),f=(i[t+488>>2]+((V^-1)+f|0)|0)/(f|0)|0,k=R<<1,i[A+308>>2]=(k|0)>(f|0)?f:k,e=i[t+484>>2],i[A+316>>2]=0,f=A+160|0,i[A+292>>2]=f,r=A,A=(e+((I^-1)+_|0)|0)/(_|0)|0,i[r+312>>2]=(A|0)<(k|0)?A:k,A=R<<2|1,A&&o0(f-k|0,0,A)}function HZ(A,e){A=A|0,e=e|0;var r=0,f=0,k=0;i:{e:{r:{f:{A:{k:{n:{t:{u:{o:{l:{if((e|0)>=12){if(f=l[A+8|0],!f||(e=l[A+9|0],!e)||(r=l[A+10|0],!r)||(k=l[A+11|0],!k))break u;if(e=e<<16|f<<24|r<<8|k,(e|0)<=1751479906){if(r=e-1751476579|0,r>>>0>21|!(1<<r&2163713))break o;return 18054}if((e|0)<=1781688690){if(e=e-1751479907|0,e>>>0>21)break u;if(1<<e&2163713)break l;break u}s:{if((e|0)<=1835623984){if((e|0)==1781688691)break s;if((e|0)!=1781689193)break u;return 10531}if((e|0)!=1836279345){if((e|0)!=1835623985)break u;return 11353}return 15235}return 5139}if((e|0)<8)break i;e=l[A|0];break e}return 15255}o:switch(e-1635148649|0){case 1:case 2:case 3:case 4:case 5:case 6:case 7:case 8:case 9:break u;case 0:break k;case 10:break A;default:break o}if(e=e-1635150182|0,!e)break t;if((e|0)==13)break n}if(e=l[A|0],(e|0)!=255)break e;if(l[A+1|0]!=216|l[A+2|0]!=255)break i;switch(l[A+3|0]-224|0){case 0:break f;case 1:break r;default:break i}}return 11342}return 15215}return 10562}return 5957}if(l[A+4|0]|l[A+5|0]!=16|(l[A+6|0]!=74|l[A+7|0]!=70)||(f|0)!=73|l[A+9|0]!=70|(l[A+10|0]|l[A+11|0]!=1))break i;return 11266}if(l[A+6|0]!=69|l[A+7|0]!=120|((f|0)!=105|l[A+9|0]!=102)||l[A+10|0]|l[A+11|0])break i;return 11266}if((e&255)!=137|l[A+1|0]!=80|(l[A+2|0]!=78|l[A+3|0]!=71)||l[A+4|0]!=13|l[A+5|0]!=10|(l[A+6|0]!=26|l[A+7|0]!=10))break i;return 10941}return 42673}function Xr(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,t=0,o=0,s=0;f=v-160|0,v=f,i[f+92>>2]=0,i[f+64>>2]=72500,k=i[18128],i[f+8>>2]=k,n=i[k-12>>2],k=f+8|0,i[n+k>>2]=i[18129],t=k+i[i[f+8>>2]-12>>2]|0,n=f+12|0,J0(t,n),u[t+80|0]=0,i[t+72>>2]=0,i[f+64>>2]=72500,i[f+8>>2]=72480,t=R0(n),i[t>>2]=71232,i[f+52>>2]=0,i[f+56>>2]=0,i[f+44>>2]=0,i[f+48>>2]=0,i[f+60>>2]=16,n=f+148|0,s0(n,r),o=k,s=n,k=u[f+159|0],n=(k|0)<0,Y(o,n?i[f+148>>2]:s,n?i[f+152>>2]:k),u[f+159|0]<0&&Z(i[f+148>>2]),k=Y(f+8|0,29317,5),n=f+148|0,ie(n,e),o=k,s=n,k=u[f+159|0],n=(k|0)<0,Y(o,n?i[f+148>>2]:s,n?i[f+152>>2]:k),u[f+159|0]<0&&Z(i[f+148>>2]),k=W[i[i[e>>2]+8>>2]](e)|0;i:{if(k){Y(Y(Y(f+8|0,27141,8),k,h2(k)),42669,2);break i}Y(f+8|0,42297,7)}k=f+148|0,s0(k,r),n=k,r=u[f+159|0],k=(r|0)<0,Y(f+8|0,k?i[f+148>>2]:n,k?i[f+152>>2]:r),u[f+159|0]<0&&Z(i[f+148>>2]),Y(V0(Y(q2(Y(f+8|0,31320,6),i[e+8>>2],i[e+12>>2]),31222,17),i[e+32>>2]),42669,2),e=i[f+60>>2];i:{e:{if(e&16){e=i[f+56>>2],r=i[f+36>>2],e>>>0<r>>>0&&(i[f+56>>2]=r,e=r),r=f+32|0;break e}if(!(e&8)){e=0,u[A+11|0]=0;break i}e=i[f+28>>2],r=f+20|0}e:{if(k=i[r>>2],e=e-k|0,e>>>0<2147483640){if(e>>>0>=11){n=e|7,r=p(n+1|0),i[A+8>>2]=n-2147483647,i[A>>2]=r,i[A+4>>2]=e,A=r;break e}if(u[A+11|0]=e,e)break e;e=0;break i}Q0(),H()}if(!e)break i;x(A,k,e)}u[A+e|0]=0,A=i[18127],i[f+8>>2]=A,i[i[A-12>>2]+(f+8|0)>>2]=i[18130],i[t>>2]=71232,u[f+55|0]<0&&Z(i[f+44>>2]),E0(t),y0(f- -64|0),v=f+160|0}function zZ(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,t=0,o=0,s=0;t=v-16|0,v=t,f=i[A+8>>2],i[t+12>>2]=0,i[t+4>>2]=0,i[t+8>>2]=0;i:{e:{r:{n=i[f+12>>2],s=i[f+16>>2];f:{if((n|0)==(s|0)){f=0;break f}if(f=s-n|0,(f|0)<0)break r;for(k=p(f),i[t+4>>2]=k,i[t+12>>2]=f+k,f=k;i[f>>2]=i[n>>2],o=i[n+4>>2],i[f+4>>2]=o,o&&(i[o+4>>2]=i[o+4>>2]+1),f=f+8|0,n=n+8|0,(s|0)!=(n|0););i[t+8>>2]=f}if(f=f-k>>3,o=(r|0)>(f|0)?f:r,(o|0)<=0)break i;for(n=0;;){r=p(24),i[r>>2]=0,i[r+4>>2]=0,i[r+16>>2]=0,i[r+20>>2]=0,i[r+8>>2]=0,i[r+12>>2]=0,f=i[A>>2],k=i[A+4>>2];f:{if(!k){i[r+4>>2]=k,i[r>>2]=f;break f}if(i[k+4>>2]=i[k+4>>2]+1,i[r>>2]=f,f=i[r+4>>2],i[r+4>>2]=k,!f||(k=i[f+4>>2],i[f+4>>2]=k-1,k))break f;W[i[i[f>>2]+8>>2]](f),y(f)}f=i[A+8>>2],k=i[A+12>>2],k&&(i[k+4>>2]=i[k+4>>2]+1),i[r+8>>2]=f,f=i[r+12>>2],i[r+12>>2]=k;f:{if(!f||(k=i[f+4>>2],i[f+4>>2]=k-1,k))break f;W[i[i[f>>2]+8>>2]](f),y(f)}f=i[t+4>>2]+(n<<3)|0,s=i[f>>2],k=i[f+4>>2],k&&(i[k+4>>2]=i[k+4>>2]+1),i[r+16>>2]=s,f=i[r+20>>2],i[r+20>>2]=k;f:{if(!f||(k=i[f+4>>2],i[f+4>>2]=k-1,k))break f;W[i[i[f>>2]+8>>2]](f),y(f)}if(i[(n<<2)+e>>2]=r,n=n+1|0,(o|0)==(n|0))break}break e}G0(),H()}k=i[t+4>>2]}if(k){if(f=i[t+8>>2],(k|0)!=(f|0)){for(;;){A=i[f-4>>2];i:{if(!A||(e=i[A+4>>2],i[A+4>>2]=e-1,e))break i;W[i[i[A>>2]+8>>2]](A),y(A)}if(f=f-8|0,(k|0)==(f|0))break}k=i[t+4>>2]}Z(k)}return v=t+16|0,o|0}function xZ(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,t=0,o=0,s=0,w=0,h=0,_=0,B=0;f=v-80|0,v=f,i[f+76>>2]=0,i[f+72>>2]=0,W9(f+60|0,e,r,f+76|0,f+72|0);i:{if(i[f+60>>2]){e=i[f+64>>2],i[A>>2]=i[f+60>>2],i[A+4>>2]=e,i[A+8>>2]=i[f+68>>2];break i}e:{if((r|0)<12||(r=l[e+8|0],!r)||(n=l[e+9|0],!n)||(o=l[e+10|0],!o)||(e=l[e+11|0],!e))break e;k=e|(n<<16|r<<24|o<<8)}e=i[13078],i[f+40>>2]=i[13077],i[f+44>>2]=e,e=i[13076],i[f+32>>2]=i[13075],i[f+36>>2]=e,e=i[13074],i[f+24>>2]=i[13073],i[f+28>>2]=e,e=i[13072],i[f+16>>2]=i[13071],i[f+20>>2]=e,e=i[13070],i[f+8>>2]=i[13069],i[f+12>>2]=e,i[f+52>>2]=0,i[f+56>>2]=0,n=f+52|0,i[f+48>>2]=n,e=i[13068],i[f>>2]=i[13067],i[f+4>>2]=e,e=f+48|0,fe(e,f,e);e:{r:{o=i[f+52>>2];f:{A:{k:{if(o){for(r=n,e=o;s=r,w=e,t=u0[e+16>>2]<k>>>0,r=t?r:e,e=i[(t?4:0)+e>>2],!!e;);if((r|0)!=(n|0)&u0[(t?s:w)+16>>2]<=k>>>0)break r;if(k=i[f+76>>2],_=i[f+72>>2],(_|0)<=0)break k;for(t=0;;){for(B=i[(t<<2)+k>>2],r=n,e=o;s=r,w=e,h=u0[e+16>>2]<B>>>0,r=h?r:e,e=i[(h?4:0)+e>>2],!!e;);if(!((r|0)==(n|0)|u0[(h?s:w)+16>>2]>B>>>0)){Z(k),i[A+8>>2]=i[24058],e=i[24057],i[A>>2]=i[24056],i[A+4>>2]=e;break e}if(t=t+1|0,(_|0)==(t|0))break}break A}k=i[f+76>>2]}if(!k)break f}Z(k)}i[A>>2]=2,i[A+4>>2]=3001,i[A+8>>2]=25685;break e}e=i[f+76>>2],e&&Z(e),e=i[24057],i[A>>2]=i[24056],i[A+4>>2]=e,i[A+8>>2]=i[24058]}Y1(f+48|0,i[f+52>>2])}v=f+80|0}function _4(A,e,r,f,k,n,t,o,s,w){var h=0,_=0,B=0,m=0,X=0,Q=0,V=0,F=0;X=i[A+18592>>2],_=A+18548|0,h=v2(_,i[A+18572>>2]+147|0),B=h<<4&16|l[A+26|0]&-17,u[A+26|0]=B,Q=A+16|0;i:{e:{if(h){h=0;r:{if(i[i[A+18592>>2]+812>>2]<2||!v2(_,i[A+18572>>2]+148|0)||(h=32,i[i[A+18592>>2]+812>>2]<3))break r;for(h=1;k4(_)&&(h=h+1|0,(h|0)<(i[i[A+18592>>2]+812>>2]-1|0)););h=h<<5}o=l[A+26|0]&31|h;break e}h=1;r:{f:{A:{if(!i[X+28>>2]){if(h=i[A+18572>>2],(n+t|0)==12||!v2(_,(o+h|0)+156|0))break A;B=l[A+26|0],h=3}u[A+26|0]=B&252|h;break f}if(h=v2(_,h+160|0)+1|0,u[A+26|0]=h&3|l[A+26|0]&252,B=2,(h|0)==2)break r}B=h,h=0,o=i[X+336>>2];f:{if((o|0)<2||!v2(_,i[A+18572>>2]+154|0))break f;if(m=o-2|0,!m){h=1;break f}if(h=1,!v2(_,i[A+18572>>2]+155|0))break f;for(o=o-1|0;;){if((h|0)==(m|0)){h=o;break f}if(h=h+1|0,!k4(_))break}}if(u[A+16|0]=h,Su(A,0),V=A,F=v2(_,i[A+18572>>2]+152|0)<<2&4|l[A+26|0]&251,u[V+26|0]=F,(B|0)==1)break i}h=0,o=i[X+340>>2];r:{if((o|0)<2||!v2(_,i[A+18572>>2]+154|0))break r;if(m=o-2|0,!m){h=1;break r}if(h=1,!v2(_,i[A+18572>>2]+155|0))break r;for(o=o-1|0;;){if((h|0)==(m|0)){h=o;break r}if(h=h+1|0,!k4(_))break}}u[A+17|0]=h;r:{if(!(!l[X+378|0]|(B|0)!=3)){g[A+22>>1]=0,g[A+24>>1]=0;break r}Su(A,1)}o=v2(_,i[A+18572>>2]+152|0)<<3&8|l[A+26|0]&-9}u[A+26|0]=o}E7(i[A+18584>>2],i[A+18592>>2],i[A+18588>>2],Q,e,r,f,k,s,n,t,w)}function T0(A,e,r,f,k,n,t){var o=0,s=0,w=0,h=0;o=v+-64|0,v=o,i[o+40>>2]=0,i[o+44>>2]=0,i[o+48>>2]=0,i[o+52>>2]=0,i[o+56>>2]=0,i[o+60>>2]=0,i[o+32>>2]=0,i[o+36>>2]=0,g[o+28>>1]=256,i[o+24>>2]=1,w=o+24|0,h=k,s=i[e+120>>2],k=(n|0)==24&&(s|0)==10?8:n,n=(s|0)==11&&(k|0)==32?8:k,k=1;i:{e:switch(s|0){case 10:case 12:case 14:k=3;break i;case 11:case 13:case 15:k=4;break i;case 0:case 1:case 2:case 3:case 99:break i;default:break e}k=0}kr(o,w,f,h,1,n,k,t,e+136|0);i:{if(i[o>>2]){e=i[o+4>>2],i[A>>2]=i[o>>2],i[A+4>>2]=e,i[A+16>>2]=i[o+16>>2],e=i[o+12>>2],i[A+8>>2]=i[o+8>>2],i[A+12>>2]=e,i[o+16>>2]=0,i[o+8>>2]=0,i[o+12>>2]=0;break i}f=i[e+128>>2];e:{r:{if(!f){t=e+128|0,n=t;break r}for(;;){if(n=f,f=i[f+16>>2],(f|0)>(r|0)){if(t=n,f=i[n>>2],f)continue;break r}if((r|0)<=(f|0))break e;if(f=i[n+4>>2],!f)break}t=n+4|0}f=p(60),i[f+16>>2]=r,r=i[o+28>>2],i[f+20>>2]=i[o+24>>2],i[f+24>>2]=r,r=i[o+36>>2],i[f+28>>2]=i[o+32>>2],i[f+32>>2]=r,r=i[o+44>>2],i[f+36>>2]=i[o+40>>2],i[f+40>>2]=r,r=i[o+52>>2],i[f+44>>2]=i[o+48>>2],i[f+48>>2]=r,r=i[o+60>>2],i[f+52>>2]=i[o+56>>2],i[f+56>>2]=r,i[f+8>>2]=n,i[f>>2]=0,i[f+4>>2]=0,i[t>>2]=f,r=i[i[e+124>>2]>>2],r&&(i[e+124>>2]=r),m1(i[e+128>>2],f),i[e+132>>2]=i[e+132>>2]+1}if(e=i[26917],i[A>>2]=i[26916],i[A+4>>2]=e,A=A+8|0,u[107683]>=0){e=i[26919],i[A>>2]=i[26918],i[A+4>>2]=e,i[A+8>>2]=i[26920];break i}T(A,i[26918],i[26919])}u[o+19|0]<0&&Z(i[o+8>>2]),v=o- -64|0}function TZ(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,t=0,o=0,s=0;f=v-160|0,v=f,i[f+92>>2]=0,i[f+64>>2]=72500,k=i[18128],i[f+8>>2]=k,n=i[k-12>>2],k=f+8|0,i[n+k>>2]=i[18129],t=k+i[i[f+8>>2]-12>>2]|0,n=f+12|0,J0(t,n),u[t+80|0]=0,i[t+72>>2]=0,i[f+64>>2]=72500,i[f+8>>2]=72480,t=R0(n),i[t>>2]=71232,i[f+52>>2]=0,i[f+56>>2]=0,i[f+44>>2]=0,i[f+48>>2]=0,i[f+60>>2]=16,n=f+148|0,U1(n,e,r),s=k,o=n,k=u[f+159|0],n=(k|0)<0,Y(s,n?i[f+148>>2]:o,n?i[f+152>>2]:k),u[f+159|0]<0&&Z(i[f+148>>2]),k=f+148|0,s0(k,r),o=k,k=u[f+159|0],n=(k|0)<0,Y(f+8|0,n?i[f+148>>2]:o,n?i[f+152>>2]:k),u[f+159|0]<0&&Z(i[f+148>>2]),k=f+8|0,V0(Y(k,31963,15),C[e+104>>1]),C[e+104>>1]||Y(k,26311,7),k=Y(f+8|0,42670,1),n=f+148|0,s0(n,r),o=n,r=u[f+159|0],n=(r|0)<0,Y(k,n?i[f+148>>2]:o,n?i[f+152>>2]:r),u[f+159|0]<0&&Z(i[f+148>>2]),Y(V0(Y(V0(Y(V0(Y(k,30321,10),C[e+106>>1]),29190,2),C[e+108>>1]),29190,2),C[e+110>>1]),42670,1),e=i[f+60>>2];i:{e:{if(e&16){e=i[f+56>>2],r=i[f+36>>2],e>>>0<r>>>0&&(i[f+56>>2]=r,e=r),r=f+32|0;break e}if(!(e&8)){e=0,u[A+11|0]=0;break i}e=i[f+28>>2],r=f+20|0}e:{if(k=i[r>>2],e=e-k|0,e>>>0<2147483640){if(e>>>0>=11){n=e|7,r=p(n+1|0),i[A+8>>2]=n-2147483647,i[A>>2]=r,i[A+4>>2]=e,A=r;break e}if(u[A+11|0]=e,e)break e;e=0;break i}Q0(),H()}if(!e)break i;x(A,k,e)}u[A+e|0]=0,A=i[18127],i[f+8>>2]=A,i[i[A-12>>2]+(f+8|0)>>2]=i[18130],i[t>>2]=71232,u[f+55|0]<0&&Z(i[f+44>>2]),E0(t),y0(f- -64|0),v=f+160|0}function SZ(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,t=0,o=0,s=0;f=v-160|0,v=f,i[f+92>>2]=0,i[f+64>>2]=72196,i[f+8>>2]=72176,n=i[18053],i[f>>2]=n,i[i[n-12>>2]+f>>2]=i[18054],i[f+4>>2]=0,n=i[i[f>>2]-12>>2]+f|0,t=f+12|0,J0(n,t),u[n+80|0]=0,i[n+72>>2]=0,n=i[18055],i[f+8>>2]=n,k=i[n-12>>2],n=f+8|0,i[k+n>>2]=i[18056],k=i[18052],i[f>>2]=k,i[i[k-12>>2]+f>>2]=i[18057],i[f+64>>2]=72196,i[f>>2]=72156,i[f+8>>2]=72176,t=R0(t),i[t>>2]=71232,i[f+52>>2]=0,i[f+56>>2]=0,i[f+44>>2]=0,i[f+48>>2]=0,i[f+60>>2]=24,k=f+148|0,Y2(k,e,r),s=k,k=u[f+159|0],o=(k|0)<0,Y(n,o?i[f+148>>2]:s,o?i[f+152>>2]:k),u[f+159|0]<0&&Z(i[f+148>>2]),k=f+148|0,s0(k,r),s=k,k=u[f+159|0],o=(k|0)<0,Y(n,o?i[f+148>>2]:s,o?i[f+152>>2]:k),u[f+159|0]<0&&Z(i[f+148>>2]),Y(V0(Y(n,29510,22),C[e+98>>1]),42670,1),k=f+148|0,mr(k,e,r,0),e=u[f+159|0],r=(e|0)<0,Y(n,r?i[f+148>>2]:k,r?i[f+152>>2]:e),u[f+159|0]<0&&Z(i[f+148>>2]),e=i[f+60>>2];i:{e:{if(e&16){e=i[f+56>>2],r=i[f+36>>2],e>>>0<r>>>0&&(i[f+56>>2]=r,e=r),r=f+32|0;break e}if(!(e&8)){e=0,u[A+11|0]=0;break i}e=i[f+28>>2],r=f+20|0}e:{if(n=i[r>>2],e=e-n|0,e>>>0<2147483640){if(e>>>0>=11){k=e|7,r=p(k+1|0),i[A+8>>2]=k-2147483647,i[A>>2]=r,i[A+4>>2]=e,A=r;break e}if(u[A+11|0]=e,e)break e;e=0;break i}Q0(),H()}if(!e)break i;x(A,n,e)}u[A+e|0]=0,A=i[18051],i[f>>2]=A,i[i[A-12>>2]+f>>2]=i[18059],i[f+8>>2]=i[18060],i[t>>2]=71232,u[f+55|0]<0&&Z(i[f+44>>2]),E0(t),y0(f- -64|0),v=f+160|0}function jZ(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,t=0,o=0,s=0;n=v-16|0,v=n,f=p(168),i[f+4>>2]=0,i[f+8>>2]=0,i[f>>2]=92044,e=f+16|0,i[e+8>>2]=0,i[e+12>>2]=0,i[e+16>>2]=0,i[e+20>>2]=0,i[e+24>>2]=0,i[e+28>>2]=0,i[e+32>>2]=0,i[e>>2]=86356,i[f+60>>2]=0,i[f+64>>2]=0,i[f+52>>2]=0,i[f+56>>2]=0,i[f+72>>2]=-1,i[f+76>>2]=-1,i[f+80>>2]=-1,i[f+84>>2]=-1,i[f+88>>2]=0,i[f+92>>2]=0,i[f+96>>2]=0,i[f+100>>2]=0,i[f+104>>2]=0,i[f+108>>2]=0,u[f+112|0]=0,g[f+118>>1]=0,g[f+120>>1]=0,g[f+122>>1]=0,g[f+124>>1]=0,g[f+116>>1]=1,g[f+126>>1]=0,g[f+128>>1]=0,g[f+130>>1]=0,g[f+132>>1]=0,g[f+134>>1]=0,i[f+156>>2]=0,i[f+160>>2]=-65512,g[f+144>>1]=1,i[f+136>>2]=4718592,i[f+140>>2]=4718592,i[e>>2]=92084,u[f+159|0]=8,i[f+32>>2]=1781689193,u[f+148|0]=74,u[f+149|0]=80,u[f+150|0]=69,u[f+151|0]=71,u[f+152|0]=50,u[f+153|0]=48,u[f+154|0]=48,u[f+155|0]=48,t=i[r>>2],o=i[r+4>>2];i:{if((t|0)!=(o|0))for(s=f+52|0;;){r=i[t>>2],i[n+8>>2]=r,k=i[t+4>>2],i[n+12>>2]=k;e:{r:{f:{if(!k){if(i[r+16>>2]==1781689160)break f;break e}if(i[k+4>>2]=i[k+4>>2]+1,i[r+16>>2]!=1781689160)break r}if(r2(s,n+8|0),i[A+4>>2]=f,i[A>>2]=e,e=i[n+12>>2],!e||(A=i[e+4>>2],i[e+4>>2]=A-1,A))break i;W[i[i[e>>2]+8>>2]](e),y(e);break i}if(r=i[k+4>>2],i[k+4>>2]=r-1,r)break e;W[i[i[k>>2]+8>>2]](k),y(k)}if(t=t+8|0,(o|0)==(t|0))break}if(i[A>>2]=0,i[A+4>>2]=0,A=i[f+4>>2],i[f+4>>2]=A-1,A)break i;W[i[i[f>>2]+8>>2]](f),y(f)}v=n+16|0}function a4(A,e,r,f){var k=0,n=0,t=0,o=0;if(o=v-16|0,v=o,k=i[A+84>>2],!k){k=p(136),i[k+4>>2]=0,i[k+8>>2]=0,i[k>>2]=90324,n=k+16|0,i[n+8>>2]=0,i[n+12>>2]=0,i[k+32>>2]=0,i[k+36>>2]=0,i[k+40>>2]=0,i[k+44>>2]=0,i[k+48>>2]=0,i[k+16>>2]=86356,i[k+60>>2]=0,i[k+64>>2]=0,i[k+52>>2]=0,i[k+56>>2]=0,i[k+72>>2]=-1,i[k+76>>2]=-1,i[k+80>>2]=-1,i[k+84>>2]=-1,i[k+116>>2]=0,i[k+88>>2]=0,i[k+92>>2]=0,i[k+96>>2]=0,i[k+100>>2]=0,i[k+104>>2]=0,i[k+108>>2]=0,g[k+112>>1]=0,i[k+16>>2]=88072,i[k+128>>2]=0,i[k+120>>2]=0,i[k+124>>2]=0,i[k+32>>2]=1769104742,i[A+84>>2]=n,t=i[A+88>>2],i[A+88>>2]=k;i:{e:{if(!t){t=i[A+44>>2],i[o+12>>2]=k,i[o+8>>2]=n;break e}if(k=i[t+4>>2],i[t+4>>2]=k-1,k||(W[i[i[t>>2]+8>>2]](t),y(t)),t=i[A+44>>2],n=i[A+84>>2],k=i[A+88>>2],i[o+12>>2]=k,i[o+8>>2]=n,!k)break i}i[k+4>>2]=i[k+4>>2]+1}r2(t+36|0,o+8|0),n=i[o+12>>2];i:{if(!n||(k=i[n+4>>2],i[n+4>>2]=k-1,k))break i;W[i[i[n>>2]+8>>2]](n),y(n)}k=i[A+84>>2]}n=v+-64|0,v=n,i[n+24>>2]=0,i[n+28>>2]=0,i[n+32>>2]=0,i[n+36>>2]=0,i[n+40>>2]=0,i[n+24>>2]=r,i[n+16>>2]=0,i[n+20>>2]=0,i[n+60>>2]=0,i[n+52>>2]=0,i[n+56>>2]=0,i[n+48>>2]=e,i[n+8>>2]=86356,A=n+52|0,(A|0)!=(f|0)&&(r=A,e=i[f>>2],A=i[f+4>>2],k6(r,e,A,A-e>>2)),e=i[k+108>>2];i:{if(e>>>0<u0[k+112>>2]){te(e,n+8|0),A=e+56|0;break i}A=nA(k+104|0,n+8|0)}i[k+108>>2]=A,A=i[n+52>>2],A&&(i[n+56>>2]=A,Z(A)),i[n+8>>2]=86356,A=i[n+28>>2],A&&(i[n+32>>2]=A,Z(A)),v=n- -64|0,v=o+16|0}function OZ(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,t=0,o=0,s=0;f=v-160|0,v=f,i[f+92>>2]=0,i[f+64>>2]=72500,k=i[18128],i[f+8>>2]=k,o=i[k-12>>2],k=f+8|0,i[o+k>>2]=i[18129],t=k+i[i[f+8>>2]-12>>2]|0,n=f+12|0,J0(t,n),u[t+80|0]=0,i[t+72>>2]=0,i[f+64>>2]=72500,i[f+8>>2]=72480,t=R0(n),i[t>>2]=71232,i[f+52>>2]=0,i[f+56>>2]=0,i[f+44>>2]=0,i[f+48>>2]=0,i[f+60>>2]=16,n=f+148|0,Y2(n,e,r),s=k,o=n,k=u[f+159|0],n=(k|0)<0,Y(s,n?i[f+148>>2]:o,n?i[f+152>>2]:k),u[f+159|0]<0&&Z(i[f+148>>2]),k=i[e+12>>2];i:{if(!k&u0[e+8>>2]>=u0[e+32>>2]|k){k=f+148|0,s0(k,r),o=k,r=u[f+159|0],k=(r|0)<0,Y(f+8|0,k?i[f+148>>2]:o,k?i[f+152>>2]:r),u[f+159|0]<0&&Z(i[f+148>>2]),r=Y(f+8|0,30070,22),k=i[e+8>>2],n=i[e+32>>2],Y(q2(r,k-n|0,i[e+12>>2]-(k>>>0<n>>>0)|0),42670,1);break i}e=f+148|0,s0(e,r),k=e,e=u[f+159|0],r=(e|0)<0,Y(f+8|0,r?i[f+148>>2]:k,r?i[f+152>>2]:e),u[f+159|0]<0&&Z(i[f+148>>2]),Y(f+8|0,33397,32)}e=i[f+60>>2];i:{e:{if(e&16){e=i[f+56>>2],r=i[f+36>>2],e>>>0<r>>>0&&(i[f+56>>2]=r,e=r),r=f+32|0;break e}if(!(e&8)){e=0,u[A+11|0]=0;break i}e=i[f+28>>2],r=f+20|0}e:{if(k=i[r>>2],e=e-k|0,e>>>0<2147483640){if(e>>>0>=11){n=e|7,r=p(n+1|0),i[A+8>>2]=n-2147483647,i[A>>2]=r,i[A+4>>2]=e,A=r;break e}if(u[A+11|0]=e,e)break e;e=0;break i}Q0(),H()}if(!e)break i;x(A,k,e)}u[A+e|0]=0,A=i[18127],i[f+8>>2]=A,i[i[A-12>>2]+(f+8|0)>>2]=i[18130],i[t>>2]=71232,u[f+55|0]<0&&Z(i[f+44>>2]),E0(t),y0(f- -64|0),v=f+160|0}function PZ(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,t=0,o=0,s=0;if(f=v-160|0,v=f,i[f+92>>2]=0,i[f+64>>2]=72500,k=i[18128],i[f+8>>2]=k,n=i[k-12>>2],k=f+8|0,i[n+k>>2]=i[18129],o=k+i[i[f+8>>2]-12>>2]|0,n=f+12|0,J0(o,n),u[o+80|0]=0,i[o+72>>2]=0,i[f+64>>2]=72500,i[f+8>>2]=72480,o=R0(n),i[o>>2]=71232,i[f+52>>2]=0,i[f+56>>2]=0,i[f+44>>2]=0,i[f+48>>2]=0,i[f+60>>2]=16,n=f+148|0,U1(n,e,r),t=k,s=n,k=u[f+159|0],n=(k|0)<0,Y(t,n?i[f+148>>2]:s,n?i[f+152>>2]:k),u[f+159|0]<0&&Z(i[f+148>>2]),i[e+108>>2]!=i[e+104>>2])for(k=0;n=f+148|0,s0(n,r),s=n,n=u[f+159|0],t=(n|0)<0,Y(f+8|0,t?i[f+148>>2]:s,t?i[f+152>>2]:n),u[f+159|0]<0&&Z(i[f+148>>2]),n=Y(V0(Y(f+8|0,19205,1),k),2989,6),t=i[i[n>>2]-12>>2]+n|0,i[t+4>>2]=i[t+4>>2]&-75|8,n=V0(n,i[i[e+104>>2]+(k<<2)>>2]),t=i[i[n>>2]-12>>2]+n|0,i[t+4>>2]=i[t+4>>2]&-75|2,Y(n,42670,1),k=k+1|0,k>>>0<i[e+108>>2]-i[e+104>>2]>>2>>>0;);e=i[f+60>>2];i:{e:{if(e&16){k=i[f+56>>2],e=i[f+36>>2],k>>>0<e>>>0&&(i[f+56>>2]=e,k=e),e=f+32|0;break e}if(!(e&8)){k=0,u[A+11|0]=0;break i}k=i[f+28>>2],e=f+20|0}e:{if(r=i[e>>2],k=k-r|0,k>>>0<2147483640){if(k>>>0>=11){n=k|7,e=p(n+1|0),i[A+8>>2]=n-2147483647,i[A>>2]=e,i[A+4>>2]=k,A=e;break e}if(u[A+11|0]=k,k)break e;k=0;break i}Q0(),H()}if(!k)break i;x(A,r,k)}u[A+k|0]=0,A=i[18127],i[f+8>>2]=A,i[i[A-12>>2]+(f+8|0)>>2]=i[18130],i[o>>2]=71232,u[f+55|0]<0&&Z(i[f+44>>2]),E0(o),y0(f- -64|0),v=f+160|0}function LZ(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,t=0,o=0,s=0;n=v-16|0,v=n,f=p(168),i[f+4>>2]=0,i[f+8>>2]=0,i[f>>2]=90724,e=f+16|0,i[e+8>>2]=0,i[e+12>>2]=0,i[e+16>>2]=0,i[e+20>>2]=0,i[e+24>>2]=0,i[e+28>>2]=0,i[e+32>>2]=0,i[e>>2]=86356,i[f+60>>2]=0,i[f+64>>2]=0,i[f+52>>2]=0,i[f+56>>2]=0,i[f+72>>2]=-1,i[f+76>>2]=-1,i[f+80>>2]=-1,i[f+84>>2]=-1,i[f+88>>2]=0,i[f+92>>2]=0,i[f+96>>2]=0,i[f+100>>2]=0,i[f+104>>2]=0,i[f+108>>2]=0,u[f+112|0]=0,g[f+118>>1]=0,g[f+120>>1]=0,g[f+122>>1]=0,g[f+124>>1]=0,g[f+116>>1]=1,g[f+126>>1]=0,g[f+128>>1]=0,g[f+130>>1]=0,g[f+132>>1]=0,g[f+134>>1]=0,i[f+160>>2]=-65512,i[f+152>>2]=0,i[f+156>>2]=0,g[f+144>>1]=1,i[f+136>>2]=4718592,i[f+140>>2]=4718592,i[e>>2]=90764,u[f+159|0]=3,i[f+32>>2]=1987470129,u[f+151|0]=0,u[f+150|0]=l[19978],k=l[19976]|l[19977]<<8,u[f+148|0]=k,u[f+149|0]=k>>>8,k=i[r>>2],o=i[r+4>>2];i:{if((k|0)!=(o|0))for(s=f+52|0;;){t=i[k>>2],i[n+8>>2]=t,r=i[k+4>>2],i[n+12>>2]=r;e:{r:{f:{if(!r){if(i[t+16>>2]==1987470147)break f;break e}if(i[r+4>>2]=i[r+4>>2]+1,i[t+16>>2]!=1987470147)break r}if(r2(s,n+8|0),i[A+4>>2]=f,i[A>>2]=e,A=i[n+12>>2],!A||(e=i[A+4>>2],i[A+4>>2]=e-1,e))break i;W[i[i[A>>2]+8>>2]](A),y(A);break i}if(t=i[r+4>>2],i[r+4>>2]=t-1,t)break e;W[i[i[r>>2]+8>>2]](r),y(r)}if(k=k+8|0,(o|0)==(k|0))break}if(i[A>>2]=0,i[A+4>>2]=0,A=i[f+4>>2],i[f+4>>2]=A-1,A)break i;W[i[i[f>>2]+8>>2]](f),y(f)}v=n+16|0}function KZ(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,t=0,o=0,s=0;n=v-16|0,v=n,f=p(168),i[f+4>>2]=0,i[f+8>>2]=0,i[f>>2]=92324,e=f+16|0,i[e+8>>2]=0,i[e+12>>2]=0,i[e+16>>2]=0,i[e+20>>2]=0,i[e+24>>2]=0,i[e+28>>2]=0,i[e+32>>2]=0,i[e>>2]=86356,i[f+60>>2]=0,i[f+64>>2]=0,i[f+52>>2]=0,i[f+56>>2]=0,i[f+72>>2]=-1,i[f+76>>2]=-1,i[f+80>>2]=-1,i[f+84>>2]=-1,i[f+88>>2]=0,i[f+92>>2]=0,i[f+96>>2]=0,i[f+100>>2]=0,i[f+104>>2]=0,i[f+108>>2]=0,u[f+112|0]=0,g[f+118>>1]=0,g[f+120>>1]=0,g[f+122>>1]=0,g[f+124>>1]=0,g[f+116>>1]=1,g[f+126>>1]=0,g[f+128>>1]=0,g[f+130>>1]=0,g[f+132>>1]=0,g[f+134>>1]=0,i[f+160>>2]=-65512,i[f+152>>2]=0,i[f+156>>2]=0,g[f+144>>1]=1,i[f+136>>2]=4718592,i[f+140>>2]=4718592,i[e>>2]=92364,u[f+159|0]=3,i[f+32>>2]=1635148593,u[f+151|0]=0,u[f+150|0]=l[20042],k=l[20040]|l[20041]<<8,u[f+148|0]=k,u[f+149|0]=k>>>8,k=i[r>>2],o=i[r+4>>2];i:{if((k|0)!=(o|0))for(s=f+52|0;;){t=i[k>>2],i[n+8>>2]=t,r=i[k+4>>2],i[n+12>>2]=r;e:{r:{f:{if(!r){if(i[t+16>>2]==1635148611)break f;break e}if(i[r+4>>2]=i[r+4>>2]+1,i[t+16>>2]!=1635148611)break r}if(r2(s,n+8|0),i[A+4>>2]=f,i[A>>2]=e,A=i[n+12>>2],!A||(e=i[A+4>>2],i[A+4>>2]=e-1,e))break i;W[i[i[A>>2]+8>>2]](A),y(A);break i}if(t=i[r+4>>2],i[r+4>>2]=t-1,t)break e;W[i[i[r>>2]+8>>2]](r),y(r)}if(k=k+8|0,(o|0)==(k|0))break}if(i[A>>2]=0,i[A+4>>2]=0,A=i[f+4>>2],i[f+4>>2]=A-1,A)break i;W[i[i[f>>2]+8>>2]](f),y(f)}v=n+16|0}function un(A,e,r,f,k,n,t,o){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,t=t|0,o=o|0;var s=0,w=0,h=0,_=0,B=0;A=v-16|0,v=A,i[A+12>>2]=r,i[A+8>>2]=n;i:if((f-r|0)<3)break i;i:{e:{r:{for(;;){if(!(r>>>0>=f>>>0|n>>>0>=t>>>0)){e=2,B=r,w=l[r|0];f:{if(w<<24>>24>=0){g[n>>1]=w,e=1;break f}if(w>>>0<194)break e;if(w>>>0<=223){if(s=1,(f-r|0)<2)break i;if(s=l[r+1|0],(s&192)!=128)break r;g[n>>1]=s&63|w<<6&1984,e=2;break f}if(w>>>0<=239){if(e=1,h=f-r|0,(h|0)<2)break r;s=u[r+1|0];A:{k:{if((w|0)!=237){if((w|0)!=224)break k;if((s&-32)!=-96)break e;break A}if((s|0)>=-96)break e;break A}if((s|0)>-65)break e}if((h|0)==2)break r;if(e=l[r+2|0],(e&192)!=128)break e;g[n>>1]=e&63|((s&63)<<6|w<<12),e=3;break f}if(w>>>0>244)break e;if(e=1,h=f-r|0,(h|0)<2)break r;_=l[r+1|0],s=_<<24>>24;A:{k:switch(w-240|0){case 0:if((s+112&255)>>>0>=48)break e;break A;case 4:if((s|0)>=-112)break e;break A;default:break k}if((s|0)>-65)break e}if((h|0)==2)break r;if(s=l[r+2|0],(s&192)!=128)break e;if((h|0)==3)break r;if(h=l[r+3|0],(h&192)!=128)break e;if((t-n|0)<3||(e=2,h=h&63,r=s<<6,w=w&7,(h|(r&4032|(_<<12&258048|w<<18)))>>>0>1114111))break r;g[n+2>>1]=h|r&960|56320,e=_<<2,g[n>>1]=(s>>>4&3|(e&192|w<<8|e&60))+16320|55296,n=n+2|0,e=4}r=B+e|0,i[A+12>>2]=r,n=n+2|0,i[A+8>>2]=n;continue}break}e=r>>>0<f>>>0}s=e;break i}s=2}return i[k>>2]=i[A+12>>2],i[o>>2]=i[A+8>>2],v=A+16|0,s|0}function qZ(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,t=0,o=0,s=0;f=v-160|0,v=f,i[f+92>>2]=0,i[f+64>>2]=72500,k=i[18128],i[f+8>>2]=k,o=i[k-12>>2],k=f+8|0,i[o+k>>2]=i[18129],t=k+i[i[f+8>>2]-12>>2]|0,n=f+12|0,J0(t,n),u[t+80|0]=0,i[t+72>>2]=0,i[f+64>>2]=72500,i[f+8>>2]=72480,t=R0(n),i[t>>2]=71232,i[f+52>>2]=0,i[f+56>>2]=0,i[f+44>>2]=0,i[f+48>>2]=0,i[f+60>>2]=16,n=f+148|0,Y2(n,e,r),s=k,o=n,k=u[f+159|0],n=(k|0)<0,Y(s,n?i[f+148>>2]:o,n?i[f+152>>2]:k),u[f+159|0]<0&&Z(i[f+148>>2]),k=f+148|0,s0(k,r),o=k,r=u[f+159|0],k=(r|0)<0,Y(f+8|0,k?i[f+148>>2]:o,k?i[f+152>>2]:r),u[f+159|0]<0&&Z(i[f+148>>2]),r=f+8|0,Y(r,30873,18),k=i[e+104>>2];i:{if((k|0)==i[e+108>>2]||(S0(r,l[k|0]),r=1,i[e+108>>2]-i[e+104>>2]>>>0<=1))break i;for(;k=f+8|0,Y(k,26300,1),S0(k,l[i[e+104>>2]+r|0]),r=r+1|0,r>>>0<i[e+108>>2]-i[e+104>>2]>>>0;);}Y(f+8|0,42670,1),e=i[f+60>>2];i:{e:{if(e&16){e=i[f+56>>2],r=i[f+36>>2],e>>>0<r>>>0&&(i[f+56>>2]=r,e=r),r=f+32|0;break e}if(!(e&8)){e=0,u[A+11|0]=0;break i}e=i[f+28>>2],r=f+20|0}e:{if(k=i[r>>2],e=e-k|0,e>>>0<2147483640){if(e>>>0>=11){n=e|7,r=p(n+1|0),i[A+8>>2]=n-2147483647,i[A>>2]=r,i[A+4>>2]=e,A=r;break e}if(u[A+11|0]=e,e)break e;e=0;break i}Q0(),H()}if(!e)break i;x(A,k,e)}u[A+e|0]=0,A=i[18127],i[f+8>>2]=A,i[i[A-12>>2]+(f+8|0)>>2]=i[18130],i[t>>2]=71232,u[f+55|0]<0&&Z(i[f+44>>2]),E0(t),y0(f- -64|0),v=f+160|0}function aZ(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,t=0,o=0,s=0;if(f=v-160|0,v=f,i[f+92>>2]=0,i[f+64>>2]=72500,k=i[18128],i[f+8>>2]=k,o=i[k-12>>2],k=f+8|0,i[o+k>>2]=i[18129],t=k+i[i[f+8>>2]-12>>2]|0,n=f+12|0,J0(t,n),u[t+80|0]=0,i[t+72>>2]=0,i[f+64>>2]=72500,i[f+8>>2]=72480,t=R0(n),i[t>>2]=71232,i[f+52>>2]=0,i[f+56>>2]=0,i[f+44>>2]=0,i[f+48>>2]=0,i[f+60>>2]=16,n=f+148|0,Y2(n,e,r),s=k,o=n,k=u[f+159|0],n=(k|0)<0,Y(s,n?i[f+148>>2]:o,n?i[f+152>>2]:k),u[f+159|0]<0&&Z(i[f+148>>2]),k=f+148|0,s0(k,r),o=k,r=u[f+159|0],k=(r|0)<0,Y(f+8|0,k?i[f+148>>2]:o,k?i[f+152>>2]:r),u[f+159|0]<0&&Z(i[f+148>>2]),r=f+8|0,V0(Y(r,32500,4),(i[e+116>>2]-i[e+112>>2]|0)/12|0),S0(Y(r,32626,7),i[e+104>>2]-i[e+100>>2]&255),Y(r,32649,5),r=i[e+100>>2],e=i[e+104>>2],(r|0)!=(e|0))for(;Y(S0(f+8|0,l[r|0]),32733,2),r=r+1|0,(e|0)!=(r|0););Y(f+8|0,42670,1),e=i[f+60>>2];i:{e:{if(e&16){r=i[f+56>>2],e=i[f+36>>2],r>>>0<e>>>0&&(i[f+56>>2]=e,r=e),e=f+32|0;break e}if(!(e&8)){r=0,u[A+11|0]=0;break i}r=i[f+28>>2],e=f+20|0}e:{if(k=i[e>>2],r=r-k|0,r>>>0<2147483640){if(r>>>0>=11){n=r|7,e=p(n+1|0),i[A+8>>2]=n-2147483647,i[A>>2]=e,i[A+4>>2]=r,A=e;break e}if(u[A+11|0]=r,r)break e;r=0;break i}Q0(),H()}if(!r)break i;x(A,k,r)}u[A+r|0]=0,A=i[18127],i[f+8>>2]=A,i[i[A-12>>2]+(f+8|0)>>2]=i[18130],i[t>>2]=71232,u[f+55|0]<0&&Z(i[f+44>>2]),E0(t),y0(f- -64|0),v=f+160|0}function $Z(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,t=0;n=v+-64|0,v=n;i:{if(S1(e,85284,0)){i[r>>2]=0,f=1;break i}e:{if(l[A+8|0]&24)k=1;else{if(!e||(t=W0(e,84888,84984),!t))break e;k=(l[t+8|0]&24)!=0}k=S1(A,e,k)}if(k){if(f=1,A=i[r>>2],!A)break i;i[r>>2]=i[A>>2];break i}e:{if(!e)break e;if(t=W0(e,84888,85032),!t||(e=i[r>>2],e&&(i[r>>2]=i[e>>2]),k=i[t+8>>2],e=i[A+8>>2],k&(e^-1)&7|e&(k^-1)&96)||(f=1,S1(i[A+12>>2],i[t+12>>2],0)))break i;if(S1(i[A+12>>2],85272,0)){if(A=i[t+12>>2],!A)break i;f=!W0(A,84888,85080);break i}if(k=i[A+12>>2],!k)break e;if(f=0,e=W0(k,84888,85032),e){if(!(u[A+8|0]&1))break i;A=i[t+12>>2],r=0;r:{f:{for(;;){if(f=0,!A)break r;if(A=W0(A,84888,85032),!A|i[A+8>>2]&(i[e+8>>2]^-1))break f;if(f=1,S1(i[e+12>>2],i[A+12>>2],0))break r;if(!(u[e+8|0]&1)||(f=i[e+12>>2],!f))break f;if(e=W0(f,84888,85032),e){A=i[A+12>>2];continue}break}if(e=W0(f,84888,85132),!e)break f;r=xo(e,i[A+12>>2])}f=r}break i}if(e=W0(k,84888,85132),e){if(!(u[A+8|0]&1))break i;f=xo(e,i[t+12>>2]);break i}if(k=W0(k,84888,84936),!k||(A=i[t+12>>2],!A)||(A=W0(A,84888,84936),!A))break i;e=i[r>>2],o0(n+8|0,0,56),u[n+59|0]=(e|0)!=0,i[n+16>>2]=-1,i[n+12>>2]=k,i[n+4>>2]=A,i[n+52>>2]=1,W[i[i[A>>2]+28>>2]](A,n+4|0,e,1),A=i[n+28>>2],(A|0)==1&&(i[r>>2]=e?i[n+20>>2]:0),f=(A|0)==1;break i}f=0}return v=n- -64|0,f|0}function Wr(A,e,r,f,k,n,t){var o=0,s=0,w=0,h=0,_=0,B=0,m=0,X=0,Q=0,V=0,F=0,I=0,E=0,R=0;B=v-128|0,v=B,i[B+124>>2]=e,i[B+16>>2]=2071,w=B+16|0,m=Q1(B+8|0,0,w);i:{e:{r:{if(_=(f-r|0)/12|0,_>>>0>=101){if(w=y2(_),!w)break r;e=i[m>>2],i[m>>2]=w,e&&W[i[m+4>>2]](e)}for(o=w,e=r;;)if((e|0)==(f|0))f:for(;;){if(e=B+124|0,I=L2(A,e),E=1,R=_,R?I:E)for(L2(A,e)&&(i[n>>2]=i[n>>2]|2);;){if((r|0)==(f|0))break e;if(l[w|0]==2)break i;w=w+1|0,r=r+12|0}e=i[A>>2],o=i[e+12>>2];A:{if((o|0)==i[e+16>>2]){e=W[i[i[e>>2]+36>>2]](e)|0;break A}e=u[o|0]}for(Q=e<<24>>24,t||(Q=W[i[i[k>>2]+12>>2]](k,Q)|0),s=V+1|0,F=0,o=w,e=r;;)if((e|0)==(f|0)){if(V=s,!F||(q1(A),o=w,e=r,_+X>>>0<2))continue f;for(;;){if((e|0)==(f|0))continue f;l[e+11|0]>>>7|0?s=i[e+4>>2]:s=l[e+11|0]&127,(s|0)==(V|0)|l[o|0]!=2||(u[o|0]=0,X=X-1|0),o=o+1|0,e=e+12|0}}else{A:{if(l[o|0]!=1)break A;l[e+11|0]>>>7|0?h=i[e>>2]:h=e,h=u[h+V|0],t||(h=W[i[i[k>>2]+12>>2]](k,h)|0);k:{if((Q|0)==(h|0)){if(F=1,l[e+11|0]>>>7|0?h=i[e+4>>2]:h=l[e+11|0]&127,(h|0)!=(s|0))break A;u[o|0]=2,X=X+1|0;break k}u[o|0]=0}_=_-1|0}o=o+1|0,e=e+12|0;continue}}else{l[e+11|0]>>>7|0?s=i[e+4>>2]:s=l[e+11|0]&127,s=!s,u[o|0]=s?2:1,o=o+1|0,e=e+12|0,X=X+s|0,_=_-s|0;continue}}g1(),H()}i[n>>2]=i[n>>2]|4}return A=i[m>>2],i[m>>2]=0,A&&W[i[m+4>>2]](A),v=B+128|0,r}function dZ(A,e,r,f,k,n,t,o){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,t=t|0,o=o|0;var s=0,w=0;f=v-32|0,v=f,e=i[r>>2],n=i[e+112>>2],t=i[e+108>>2],e=p(172),i[e>>2]=94812,i[e+4>>2]=0,i[e+8>>2]=0,o0(e+16|0,0,80),k=i[e+4>>2],s=k+1|0,i[e+4>>2]=s,i[e+104>>2]=0,i[e+108>>2]=0,i[e+36>>2]=1,i[e+40>>2]=1,u[e+24|0]=1,g[e+22>>1]=2,g[e+18>>1]=2,g[e+20>>1]=2,i[e+112>>2]=0,i[e+116>>2]=4740,i[e+140>>2]=0,i[e+144>>2]=0,i[e+128>>2]=99,i[e+132>>2]=99,i[e+120>>2]=0,i[e+124>>2]=0,i[e+12>>2]=95160,i[e+148>>2]=0,i[e+152>>2]=0,i[e+136>>2]=e+140,i[e+156>>2]=0,i[e+160>>2]=0,i[e+164>>2]=0,i[e+168>>2]=0,i[e+4>>2]=k,w=i[e+8>>2],k=e+12|0,i[e+96>>2]=k,i[e+8>>2]=w+1,i[e+100>>2]=e,s||(W[i[i[e>>2]+8>>2]](e),y(e)),s=i[r>>2],w=i[s+116>>2],i[k+120>>2]=i[s+120>>2],i[k+116>>2]=w,i[k+112>>2]=n,i[k+108>>2]=t;i:{if(!u1(i[r>>2],0)||(f6(f+12|0,k,r,0,0,o),u[f+31|0]>=0))break i;Z(i[f+20>>2])}i:{if(!u1(i[r>>2],1)||(f6(f+12|0,k,r,1,1,o),u[f+31|0]>=0))break i;Z(i[f+20>>2])}i:{if(!u1(i[r>>2],2)||(f6(f+12|0,k,r,2,2,o),u[f+31|0]>=0))break i;Z(i[f+20>>2])}i:{if(!u1(i[r>>2],3)||(f6(f+12|0,k,r,3,3,o),u[f+31|0]>=0))break i;Z(i[f+20>>2])}i:{if(!u1(i[r>>2],4)||(f6(f+12|0,k,r,4,4,o),u[f+31|0]>=0))break i;Z(i[f+20>>2])}i:{if(!u1(i[r>>2],5)||(f6(f+12|0,k,r,5,5,o),u[f+31|0]>=0))break i;Z(i[f+20>>2])}u[A+20|0]=0,i[A+4>>2]=e,i[A>>2]=k,v=f+32|0}function bi(A,e){var r=0,f=0,k=0,n=0,t=0;f=v-48|0,v=f,i[f+44>>2]=0,i[f+36>>2]=0,i[f+40>>2]=0,r=i[e+100>>2],k=i[r+48>>2],r=i[r+52>>2],r&&(i[r+4>>2]=i[r+4>>2]+1),t=i[k+52>>2],k=i[k+56>>2],k&&(i[k+4>>2]=i[k+4>>2]+1);i:{if(!r||(n=i[r+4>>2],i[r+4>>2]=n-1,n))break i;W[i[i[r>>2]+8>>2]](r),y(r)}r=i[e+100>>2],n=i[r+48>>2],r=i[r+52>>2],r&&(i[r+4>>2]=i[r+4>>2]+1),i[f+28>>2]=i[n+60>>2],n=i[n+64>>2],i[f+32>>2]=n,n&&(i[n+4>>2]=i[n+4>>2]+1);i:{if(!r||(n=i[r+4>>2],i[r+4>>2]=n-1,n))break i;W[i[i[r>>2]+8>>2]](r),y(r)}V9(f+8|0,t,i[e+116>>2],f+28|0,f+36|0);i:{if(i[f+8>>2]){if(e=i[f+12>>2],i[A>>2]=i[f+8>>2],i[A+4>>2]=e,e=A+8|0,u[f+27|0]>=0){r=i[f+20>>2],i[e>>2]=i[f+16>>2],i[e+4>>2]=r,i[e+8>>2]=i[f+24>>2],e=1;break i}T(e,i[f+16>>2],i[f+20>>2]),e=1;break i}e=i[f+44>>2],i[f+44>>2]=0,r=i[f+36>>2],n=i[f+40>>2],i[f+36>>2]=0,i[f+40>>2]=0,i[A+8>>2]=e,i[A>>2]=r,i[A+4>>2]=n,e=0}u[A+20|0]=e,u[f+27|0]<0&&Z(i[f+16>>2]),A=i[f+32>>2];i:{if(!A||(e=i[A+4>>2],i[A+4>>2]=e-1,e))break i;W[i[i[A>>2]+8>>2]](A),y(A)}i:{if(!k||(A=i[k+4>>2],i[k+4>>2]=A-1,A))break i;W[i[i[k>>2]+8>>2]](k),y(k)}if(A=i[f+36>>2],A){if(r=i[f+40>>2],e=A,(r|0)!=(A|0)){for(;;){e=i[r-4>>2];i:{if(!e||(k=i[e+4>>2],i[e+4>>2]=k-1,k))break i;W[i[i[e>>2]+8>>2]](e),y(e)}if(r=r-8|0,(A|0)==(r|0))break}e=i[f+36>>2]}i[f+40>>2]=A,Z(e)}v=f+48|0}function Qr(A,e,r,f,k,n,t){var o=0,s=0,w=0,h=0,_=0,B=0,m=0,X=0,Q=0,V=0,F=0,I=0,E=0,R=0;B=v-128|0,v=B,i[B+124>>2]=e,i[B+16>>2]=2071,w=B+16|0,m=Q1(B+8|0,0,w);i:{e:{r:{if(_=(f-r|0)/12|0,_>>>0>=101){if(w=y2(_),!w)break r;e=i[m>>2],i[m>>2]=w,e&&W[i[m+4>>2]](e)}for(o=w,e=r;;)if((e|0)==(f|0))f:for(;;){if(e=B+124|0,I=K2(A,e),E=1,R=_,R?I:E)for(K2(A,e)&&(i[n>>2]=i[n>>2]|2);;){if((r|0)==(f|0))break e;if(l[w|0]==2)break i;w=w+1|0,r=r+12|0}e=i[A>>2],o=i[e+12>>2];A:{if((o|0)==i[e+16>>2]){s=W[i[i[e>>2]+36>>2]](e)|0;break A}s=i[o>>2]}for(t||(s=W[i[i[k>>2]+28>>2]](k,s)|0),V=Q+1|0,F=0,o=w,e=r;;)if((e|0)==(f|0)){if(Q=V,!F||(a1(A),o=w,e=r,_+X>>>0<2))continue f;for(;;){if((e|0)==(f|0))continue f;l[e+11|0]>>>7|0?s=i[e+4>>2]:s=l[e+11|0]&127,(s|0)==(Q|0)|l[o|0]!=2||(u[o|0]=0,X=X-1|0),o=o+1|0,e=e+12|0}}else{A:{if(l[o|0]!=1)break A;l[e+11|0]>>>7|0?h=i[e>>2]:h=e,h=i[h+(Q<<2)>>2],t||(h=W[i[i[k>>2]+28>>2]](k,h)|0);k:{if((s|0)==(h|0)){if(F=1,l[e+11|0]>>>7|0?h=i[e+4>>2]:h=l[e+11|0]&127,(h|0)!=(V|0))break A;u[o|0]=2,X=X+1|0;break k}u[o|0]=0}_=_-1|0}o=o+1|0,e=e+12|0;continue}}else{l[e+11|0]>>>7|0?s=i[e+4>>2]:s=l[e+11|0]&127,s=!s,u[o|0]=s?2:1,o=o+1|0,e=e+12|0,X=s+X|0,_=_-s|0;continue}}g1(),H()}i[n>>2]=i[n>>2]|4}return A=i[m>>2],i[m>>2]=0,A&&W[i[m+4>>2]](A),v=B+128|0,r}function cZ(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,t=0,o=0,s=0;n=v-16|0,v=n,f=p(168),i[f+4>>2]=0,i[f+8>>2]=0,i[f>>2]=90564,e=f+16|0,i[e+8>>2]=0,i[e+12>>2]=0,i[e+16>>2]=0,i[e+20>>2]=0,i[e+24>>2]=0,i[e+28>>2]=0,i[e+32>>2]=0,i[e>>2]=86356,i[f+60>>2]=0,i[f+64>>2]=0,i[f+52>>2]=0,i[f+56>>2]=0,i[f+72>>2]=-1,i[f+76>>2]=-1,i[f+80>>2]=-1,i[f+84>>2]=-1,i[f+88>>2]=0,i[f+92>>2]=0,i[f+96>>2]=0,i[f+100>>2]=0,i[f+104>>2]=0,i[f+108>>2]=0,u[f+112|0]=0,g[f+118>>1]=0,g[f+120>>1]=0,g[f+122>>1]=0,g[f+124>>1]=0,g[f+116>>1]=1,g[f+126>>1]=0,g[f+128>>1]=0,g[f+130>>1]=0,g[f+132>>1]=0,g[f+134>>1]=0,i[f+160>>2]=-65512,i[f+152>>2]=0,i[f+156>>2]=0,g[f+144>>1]=1,i[f+136>>2]=4718592,i[f+140>>2]=4718592,i[e>>2]=90604,u[f+159|0]=4,i[f+32>>2]=1635135537,u[f+148|0]=65,u[f+149|0]=86,u[f+150|0]=73,u[f+151|0]=70,t=i[r>>2],o=i[r+4>>2];i:{if((t|0)!=(o|0))for(s=f+52|0;;){r=i[t>>2],i[n+8>>2]=r,k=i[t+4>>2],i[n+12>>2]=k;e:{r:{f:{if(!k){if(i[r+16>>2]==1635135811)break f;break e}if(i[k+4>>2]=i[k+4>>2]+1,i[r+16>>2]!=1635135811)break r}if(r2(s,n+8|0),i[A+4>>2]=f,i[A>>2]=e,e=i[n+12>>2],!e||(A=i[e+4>>2],i[e+4>>2]=A-1,A))break i;W[i[i[e>>2]+8>>2]](e),y(e);break i}if(r=i[k+4>>2],i[k+4>>2]=r-1,r)break e;W[i[i[k>>2]+8>>2]](k),y(k)}if(t=t+8|0,(o|0)==(t|0))break}if(i[A>>2]=0,i[A+4>>2]=0,A=i[f+4>>2],i[f+4>>2]=A-1,A)break i;W[i[i[f>>2]+8>>2]](f),y(f)}v=n+16|0}function bZ(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,t=0,o=0,s=0;n=v-16|0,v=n,f=p(168),i[f+4>>2]=0,i[f+8>>2]=0,i[f>>2]=90404,e=f+16|0,i[e+8>>2]=0,i[e+12>>2]=0,i[e+16>>2]=0,i[e+20>>2]=0,i[e+24>>2]=0,i[e+28>>2]=0,i[e+32>>2]=0,i[e>>2]=86356,i[f+60>>2]=0,i[f+64>>2]=0,i[f+52>>2]=0,i[f+56>>2]=0,i[f+72>>2]=-1,i[f+76>>2]=-1,i[f+80>>2]=-1,i[f+84>>2]=-1,i[f+88>>2]=0,i[f+92>>2]=0,i[f+96>>2]=0,i[f+100>>2]=0,i[f+104>>2]=0,i[f+108>>2]=0,u[f+112|0]=0,g[f+118>>1]=0,g[f+120>>1]=0,g[f+122>>1]=0,g[f+124>>1]=0,g[f+116>>1]=1,g[f+126>>1]=0,g[f+128>>1]=0,g[f+130>>1]=0,g[f+132>>1]=0,g[f+134>>1]=0,i[f+160>>2]=-65512,i[f+152>>2]=0,i[f+156>>2]=0,g[f+144>>1]=1,i[f+136>>2]=4718592,i[f+140>>2]=4718592,i[e>>2]=90444,u[f+159|0]=4,i[f+32>>2]=1752589105,u[f+148|0]=72,u[f+149|0]=69,u[f+150|0]=86,u[f+151|0]=67,t=i[r>>2],o=i[r+4>>2];i:{if((t|0)!=(o|0))for(s=f+52|0;;){r=i[t>>2],i[n+8>>2]=r,k=i[t+4>>2],i[n+12>>2]=k;e:{r:{f:{if(!k){if(i[r+16>>2]==1752589123)break f;break e}if(i[k+4>>2]=i[k+4>>2]+1,i[r+16>>2]!=1752589123)break r}if(r2(s,n+8|0),i[A+4>>2]=f,i[A>>2]=e,e=i[n+12>>2],!e||(A=i[e+4>>2],i[e+4>>2]=A-1,A))break i;W[i[i[e>>2]+8>>2]](e),y(e);break i}if(r=i[k+4>>2],i[k+4>>2]=r-1,r)break e;W[i[i[k>>2]+8>>2]](k),y(k)}if(t=t+8|0,(o|0)==(t|0))break}if(i[A>>2]=0,i[A+4>>2]=0,A=i[f+4>>2],i[f+4>>2]=A-1,A)break i;W[i[i[f>>2]+8>>2]](f),y(f)}v=n+16|0}function ie(A,e){var r=0,f=0,k=0,n=0,t=0,o=0;r=v-144|0,v=r;i:{e:{if(k=i[e+16>>2],(k|0)==1970628964){for(k=0,i[r+84>>2]=0,i[r+56>>2]=72500,f=i[18128],i[r>>2]=f,i[i[f-12>>2]+r>>2]=i[18129],f=i[i[r>>2]-12>>2]+r|0,n=r+4|0,J0(f,n),u[f+80|0]=0,i[f+72>>2]=0,i[r+56>>2]=72500,i[r>>2]=72480,o=R0(n),i[o>>2]=71232,i[r+44>>2]=0,i[r+48>>2]=0,i[r+36>>2]=0,i[r+40>>2]=0,i[r+52>>2]=16,f=i[r>>2]-12|0,n=i[f>>2]+r|0,i[n+4>>2]=i[n+4>>2]&-75|8,f=i[f>>2]+r|0,l[f+80|0]||(t=r+140|0,n=i[f+28>>2],i[t>>2]=n,(n|0)!=129576&&(i[n+4>>2]=i[n+4>>2]+1),n=c0(t,129760),W[i[i[n>>2]+28>>2]](n,32)|0,e2(t)),n=r+56|0,u[f+76|0]=48,u[f+77|0]=0,u[f+78|0]=0,u[f+79|0]=0,u[f+80|0]=1,f=r+12|0;;){r:switch((k&13)-4|0){case 0:case 4:u[r+140|0]=45,Y(r,r+140|0,1);break;default:break r}if(i[i[i[r>>2]-12>>2]+f>>2]=2,S0(r,l[i[e+20>>2]+k|0]),k=k+1|0,(k|0)==16)break}break e}L1(A,k);break i}e=i[r+52>>2];e:{r:{if(e&16){f=r+24|0,k=i[r+48>>2],e=i[r+28>>2],k>>>0<e>>>0?i[r+48>>2]=e:e=k;break r}if(!(e&8)){k=0,u[A+11|0]=0;break e}e=i[r+20>>2]}r:{if(f=i[f>>2],k=e-f|0,k>>>0<2147483640){if(k>>>0>=11){t=k|7,e=p(t+1|0),i[A+8>>2]=t-2147483647,i[A>>2]=e,i[A+4>>2]=k,A=e;break r}if(u[A+11|0]=k,k)break r;k=0;break e}Q0(),H()}if(!k)break e;x(A,f,k)}u[A+k|0]=0,A=i[18127],i[r>>2]=A,i[i[A-12>>2]+r>>2]=i[18130],i[o>>2]=71232,u[r+47|0]<0&&Z(i[r+36>>2]),E0(o),y0(n)}v=r+144|0}function on(A,e,r,f,k,n,t){var o=0,s=0,w=0,h=0,_=0,B=0,m=0,X=0,Q=0,V=0;B=v-16|0,v=B,s=-9,_=i[A+12>>2],w=i[A+8>>2];i:{if((_|0)==(w|0))break i;for(h=_-w>>2,X=h>>>0<=1?1:h;;){if(m=i[w+(o<<2)>>2],!(l[m+104|0]|i[m+100>>2])){lA(m),_=i[A+12>>2],h=_-i[A+8>>2]>>2,s=o;break i}if(o=o+1|0,(X|0)==(o|0))break}}i:{if((h-1|0)==(s|0)|u0[A+4>>2]>=h>>>0||(o=i[_-4>>2],l[o+104|0]|i[o+100>>2]))break i;Z(uA(o)),_=i[A+12>>2]-4|0,i[A+12>>2]=_}i:{e:{r:{if((s|0)==-9){V=i[A+8>>2],m=Kt(p(416)),o=i[A+12>>2],w=i[A+16>>2];f:{if(o>>>0<w>>>0){i[o>>2]=m,o=o+4|0;break f}if(h=i[A+8>>2],o=o-h|0,Q=o>>2,s=Q+1|0,s>>>0>=1073741824)break r;if(w=w-h|0,X=w>>1,w=w>>>0>=2147483644?1073741823:s>>>0<X>>>0?X:s,w){if(w>>>0>=1073741824)break e;s=p(w<<2)}else s=0;if(X=s+o|0,i[X>>2]=m,m=X-(Q<<2)|0,o&&x(m,h,o),i[A+16>>2]=s+(w<<2),o=X+4|0,i[A+12>>2]=o,i[A+8>>2]=m,!h)break f;Z(h)}i[A+12>>2]=o,s=_-V>>2}f:{if((s|0)<0){o=i[e+4>>2];break f}if(o=i[e>>2],_=i[o+476>>2],_>>>0>=4)break i;if(A=i[i[A+8>>2]+(s<<2)>>2],h=i[o+488>>2],w=i[o+484>>2],i[B+8>>2]=o,o=i[e+4>>2],i[B+12>>2]=o,o&&(i[o+4>>2]=i[o+4>>2]+1),e=i[B+12>>2],i[B>>2]=i[B+8>>2],i[B+4>>2]=e,e=A9(A,w,h,_,B,1,r,f,k,n,t),e){s=0-e|0;break f}u[A+312|0]=0}f:{if(!o||(A=i[o+4>>2],i[o+4>>2]=A-1,A))break f;W[i[i[o>>2]+8>>2]](o),y(o)}return v=B+16|0,s}G0(),H()}z0(),H()}D0(22181,18325,263,14223),H()}function iG(A){A=A|0;var e=0,r=0,f=0,k=0,n=0,t=0,o=0,s=0,w=0,h=0,_=0,B=0,m=0,X=0;k=v-32|0,v=k,e=i[A+104>>2],t=i[A+108>>2];i:{if((e|0)==(t|0))break i;e:{for(;;){r:{if(f=i[e>>2],!f||(w=W0(f,86580,97564),!w))break r;if(n=i[e+4>>2],!n)break e;i[n+4>>2]=i[n+4>>2]+1;break i}if(e=e+8|0,(t|0)==(e|0))break}w=0}n=0}i[k+24>>2]=0,i[k+28>>2]=0,i[k+12>>2]=1768778098,i[k+16>>2]=1668047216,i[k+4>>2]=1752589123,i[k+8>>2]=1769107316,i[k+20>>2]=k+24,s=k+20|0,fe(s,k+4|0,s),f=v-48|0,v=f,bi(f+12|0,A),r=l[f+32|0];i:{e:{if(!r){if(o=i[f+12>>2],h=i[f+16>>2],(o|0)==(h|0)){r=0;break e}t=s+4|0;r:{for(;;){if(r=i[o>>2],e=i[r+16>>2]==1769173093,r=e?A:r,W[i[i[r>>2]+(e?48:40)>>2]](r)|0){if(_=1,r=i[t>>2],!r)break r;for(B=i[i[o>>2]+16>>2],e=t;m=u0[r+16>>2]<B>>>0,e=m?e:r,r=i[(m?4:0)+r>>2],!!r;);if((e|0)==(t|0)|u0[e+16>>2]>B>>>0)break r}if(o=o+8|0,(h|0)==(o|0))break}_=0}r=l[f+32|0]}if((r&255)==255)break i}A=i[25179],i[f+40>>2]=i[25178],i[f+44>>2]=A,W[i[(f+40|0)+((r&255)<<2)>>2]](f+39|0,f+12|0)}v=f+48|0,Y1(s,i[k+24>>2]);i:if(_||(X=1751476579,e=w+100|0,A=i[e+4>>2],A&1073741824|l[e+3|0]==1)||(e=l[e+3|0],A&268435456|(e|0)==3)||(X=1751476600,A&536870912|(e|0)==2))break i;i:{if(!n||(A=i[n+4>>2],i[n+4>>2]=A-1,A))break i;W[i[i[n>>2]+8>>2]](n),y(n)}return v=k+32|0,X|0}function U1(A,e,r){var f=0,k=0,n=0,t=0,o=0,s=0;f=v-160|0,v=f,i[f+92>>2]=0,i[f+64>>2]=72500,k=i[18128],i[f+8>>2]=k,n=i[k-12>>2],k=f+8|0,i[n+k>>2]=i[18129],t=k+i[i[f+8>>2]-12>>2]|0,n=f+12|0,J0(t,n),u[t+80|0]=0,i[t+72>>2]=0,i[f+64>>2]=72500,i[f+8>>2]=72480,t=R0(n),i[t>>2]=71232,i[f+52>>2]=0,i[f+56>>2]=0,i[f+44>>2]=0,i[f+48>>2]=0,i[f+60>>2]=16,n=f+148|0,Y2(n,e,r),s=k,o=n,k=u[f+159|0],n=(k|0)<0,Y(s,n?i[f+148>>2]:o,n?i[f+152>>2]:k),u[f+159|0]<0&&Z(i[f+148>>2]),k=f+148|0,s0(k,r),o=k,k=u[f+159|0],n=(k|0)<0,Y(f+8|0,n?i[f+148>>2]:o,n?i[f+152>>2]:k),u[f+159|0]<0&&Z(i[f+148>>2]),k=Y(S0(Y(f+8|0,30776,9),l[e+97|0]),42670,1),n=f+148|0,s0(n,r),o=n,r=u[f+159|0],n=(r|0)<0,Y(k,n?i[f+148>>2]:o,n?i[f+152>>2]:r),u[f+159|0]<0&&Z(i[f+148>>2]),r=Y(k,30050,7),k=i[i[r>>2]-12>>2]+r|0,i[k+4>>2]=i[k+4>>2]&-75|8,Y(V0(r,i[e+100>>2]),42670,1),e=i[f+60>>2];i:{e:{if(e&16){r=i[f+56>>2],e=i[f+36>>2],r>>>0<e>>>0&&(i[f+56>>2]=e,r=e),e=f+32|0;break e}if(!(e&8)){r=0,u[A+11|0]=0;break i}r=i[f+28>>2],e=f+20|0}e:{if(k=i[e>>2],r=r-k|0,r>>>0<2147483640){if(r>>>0>=11){n=r|7,e=p(n+1|0),i[A+8>>2]=n-2147483647,i[A>>2]=e,i[A+4>>2]=r,A=e;break e}if(u[A+11|0]=r,r)break e;r=0;break i}Q0(),H()}if(!r)break i;x(A,k,r)}u[A+r|0]=0,A=i[18127],i[f+8>>2]=A,i[i[A-12>>2]+(f+8|0)>>2]=i[18130],i[t>>2]=71232,u[f+55|0]<0&&Z(i[f+44>>2]),E0(t),y0(f- -64|0),v=f+160|0}function eG(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,t=0,o=0,s=0,w=0,h=0,_=0,B=0;s=v-32|0,v=s,o=i[e+104>>2],n=i[e+108>>2];i:{if((o|0)==(n|0))break i;for(;;){e:{if(l[o+4|0]!=1||(f=i[o+16>>2],t=i[o+20>>2],(f|0)==(t|0)))break e;for(;k=(i[f+28>>2]+k|0)-i[f+24>>2]|0,f=f+40|0,(t|0)!=(f|0););}if(o=o+32|0,(n|0)==(o|0))break}if(!k||(F0(r,k+8|0),F0(r,1768186228),k=i[e+104>>2],n=i[e+108>>2],(k|0)==(n|0)))break i;for(;;){e:{if(l[k+4|0]!=1||(f=i[k+16>>2],t=i[k+20>>2],(f|0)==(t|0)))break e;for(;I4(r,f+24|0),f=f+40|0,(t|0)!=(f|0););}if(k=k+32|0,(n|0)==(k|0))break}}if(w=W[i[i[e>>2]+52>>2]](e,r,0)|0,i[e+116>>2]=i[r+12>>2],n=l[e+97|0],t=n>>>0<2,k=t?4:6,f=i[e+104>>2],h=i[e+108>>2],(f|0)!=(h|0))for(_=l[e+122|0]+(l[e+121|0]+((n?l[e+124|0]:0)&255)|0)|0,B=l[e+123|0]+((t?6:8)+(n?2:0)|0)|0,o=_+B|0;n=i[f+16>>2],t=i[f+20>>2],(n|0)==(t|0)?k=k+B|0:k=(k+o|0)+G(((t-n|0)-40>>>0)/40|0,_)|0,f=f+32|0,(h|0)!=(f|0););Pr(r,k),i[r+12>>2]=w,W[i[i[e>>2]+56>>2]](s+12|0,e,r,i[r+4>>2]-(w+i[r>>2]|0)|0,0),i[r+12>>2]=i[r+4>>2]-i[r>>2],u[s+31|0]<0&&Z(i[s+20>>2]),qn(e,r),e=i[26917],i[A>>2]=i[26916],i[A+4>>2]=e,e=A+8|0;i:{if(u[107683]>=0){A=i[26919],i[e>>2]=i[26918],i[e+4>>2]=A,i[e+8>>2]=i[26920];break i}T(e,i[26918],i[26919])}v=s+32|0}function rG(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,t=0,o=0,s=0;if(f=v-160|0,v=f,i[f+92>>2]=0,i[f+64>>2]=72500,n=i[18128],i[f+8>>2]=n,k=i[n-12>>2],n=f+8|0,i[k+n>>2]=i[18129],t=n+i[i[f+8>>2]-12>>2]|0,k=f+12|0,J0(t,k),u[t+80|0]=0,i[t+72>>2]=0,i[f+64>>2]=72500,i[f+8>>2]=72480,t=R0(k),i[t>>2]=71232,i[f+52>>2]=0,i[f+56>>2]=0,i[f+44>>2]=0,i[f+48>>2]=0,i[f+60>>2]=16,k=f+148|0,U1(k,e,r),s=n,o=k,n=u[f+159|0],k=(n|0)<0,Y(s,k?i[f+148>>2]:o,k?i[f+152>>2]:n),u[f+159|0]<0&&Z(i[f+148>>2]),i[e+108>>2]!=i[e+104>>2])for(n=0;k=f+148|0,s0(k,r),s=k,k=u[f+159|0],o=(k|0)<0,Y(f+8|0,o?i[f+148>>2]:s,o?i[f+152>>2]:k),u[f+159|0]<0&&Z(i[f+148>>2]),k=n<<3,Y(V0(Y(V0(Y(V0(Y(f+8|0,19205,1),n),20909,8),i[k+i[e+104>>2]>>2]),20999,8),i[(k+i[e+104>>2]|0)+4>>2]),42670,1),n=n+1|0,n>>>0<i[e+108>>2]-i[e+104>>2]>>3>>>0;);e=i[f+60>>2];i:{e:{if(e&16){n=f+32|0,r=i[f+56>>2],e=i[f+36>>2],r>>>0<e>>>0?i[f+56>>2]=e:e=r;break e}if(!(e&8)){e=0,u[A+11|0]=0;break i}n=f+20|0,e=i[f+28>>2]}e:{if(n=i[n>>2],e=e-n|0,e>>>0<2147483640){if(e>>>0>=11){k=e|7,r=p(k+1|0),i[A+8>>2]=k-2147483647,i[A>>2]=r,i[A+4>>2]=e,A=r;break e}if(u[A+11|0]=e,e)break e;e=0;break i}Q0(),H()}if(!e)break i;x(A,n,e)}u[A+e|0]=0,A=i[18127],i[f+8>>2]=A,i[i[A-12>>2]+(f+8|0)>>2]=i[18130],i[t>>2]=71232,u[f+55|0]<0&&Z(i[f+44>>2]),E0(t),y0(f- -64|0),v=f+160|0}function fG(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,t=0,o=0,s=0;if(f=v-160|0,v=f,i[f+92>>2]=0,i[f+64>>2]=72500,n=i[18128],i[f+8>>2]=n,k=i[n-12>>2],n=f+8|0,i[k+n>>2]=i[18129],t=n+i[i[f+8>>2]-12>>2]|0,k=f+12|0,J0(t,k),u[t+80|0]=0,i[t+72>>2]=0,i[f+64>>2]=72500,i[f+8>>2]=72480,t=R0(k),i[t>>2]=71232,i[f+52>>2]=0,i[f+56>>2]=0,i[f+44>>2]=0,i[f+48>>2]=0,i[f+60>>2]=16,k=f+148|0,U1(k,e,r),s=n,o=k,n=u[f+159|0],k=(n|0)<0,Y(s,k?i[f+148>>2]:o,k?i[f+152>>2]:n),u[f+159|0]<0&&Z(i[f+148>>2]),i[e+108>>2]!=i[e+104>>2])for(n=0;k=f+148|0,s0(k,r),s=k,k=u[f+159|0],o=(k|0)<0,Y(f+8|0,o?i[f+148>>2]:s,o?i[f+152>>2]:k),u[f+159|0]<0&&Z(i[f+148>>2]),k=n<<3,Y(S0(Y(V0(Y(V0(Y(f+8|0,19205,1),n),20909,8),i[k+i[e+104>>2]>>2]),20918,9),i[(k+i[e+104>>2]|0)+4>>2]),42670,1),n=n+1|0,n>>>0<i[e+108>>2]-i[e+104>>2]>>3>>>0;);e=i[f+60>>2];i:{e:{if(e&16){n=f+32|0,r=i[f+56>>2],e=i[f+36>>2],r>>>0<e>>>0?i[f+56>>2]=e:e=r;break e}if(!(e&8)){e=0,u[A+11|0]=0;break i}n=f+20|0,e=i[f+28>>2]}e:{if(n=i[n>>2],e=e-n|0,e>>>0<2147483640){if(e>>>0>=11){k=e|7,r=p(k+1|0),i[A+8>>2]=k-2147483647,i[A>>2]=r,i[A+4>>2]=e,A=r;break e}if(u[A+11|0]=e,e)break e;e=0;break i}Q0(),H()}if(!e)break i;x(A,n,e)}u[A+e|0]=0,A=i[18127],i[f+8>>2]=A,i[i[A-12>>2]+(f+8|0)>>2]=i[18130],i[t>>2]=71232,u[f+55|0]<0&&Z(i[f+44>>2]),E0(t),y0(f- -64|0),v=f+160|0}function x8(A,e,r,f,k,n,t,o){var s=0,w=0,h=0,_=0,B=0;s=v-16|0,v=s,i[s+8>>2]=r,i[s+12>>2]=e,r=s+4|0,e=i[f+28>>2],i[r>>2]=e,(e|0)!=129576&&(i[e+4>>2]=i[e+4>>2]+1),w=c0(r,129760),e2(r),i[k>>2]=0,e=0;i:{for(;;){if(e|(t|0)==(o|0))break i;e:{if(L2(s+12|0,s+8|0))break e;r:{if((W[i[i[w>>2]+36>>2]](w,u[t|0],0)|0)==37){if((t+1|0)==(o|0))break e;r=0;f:{A:{if(e=W[i[i[w>>2]+36>>2]](w,u[t+1|0],0)|0,(e|0)==69||(h=1,(e&255)==48))break A;break f}if((t+2|0)==(o|0))break e;h=2,r=e,e=W[i[i[w>>2]+36>>2]](w,u[t+2|0],0)|0}_=s,B=W[i[i[A>>2]+36>>2]](A,i[s+12>>2],i[s+8>>2],f,k,n,e,r)|0,i[_+12>>2]=B,t=(t+h|0)+1|0;break r}if(e=u[t|0],(e|0)>=0?e=i[i[w+8>>2]+(e<<2)>>2]&1:e=0,e){for(;t=t+1|0,!!((o|0)!=(t|0)&&(e=u[t|0],(e|0)>=0?e=i[i[w+8>>2]+(e<<2)>>2]&1:e=0,e)););for(;;){if(r=s+12|0,L2(r,s+8|0))break r;e=i[r>>2],h=i[e+12>>2];f:{if((h|0)==i[e+16>>2]){e=W[i[i[e>>2]+36>>2]](e)|0;break f}e=u[h|0]}if(e=e<<24>>24,(e|0)>=0?e=i[i[w+8>>2]+(e<<2)>>2]&1:e=0,!e)break r;q1(r)}}h=s+12|0,e=i[h>>2],r=i[e+12>>2];f:{if((r|0)==i[e+16>>2]){e=W[i[i[e>>2]+36>>2]](e)|0;break f}e=u[r|0]}if((W[i[i[w>>2]+12>>2]](w,e<<24>>24)|0)==(W[i[i[w>>2]+12>>2]](w,u[t|0])|0)){t=t+1|0,q1(h);break r}i[k>>2]=4}e=i[k>>2];continue}break}i[k>>2]=4}return L2(s+12|0,s+8|0)&&(i[k>>2]=i[k>>2]|2),v=s+16|0,i[s+12>>2]}function AG(A,e,r,f,k,n){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,e=v-48|0,v=e,r=p(32),i[e+12>>2]=r,i[e+16>>2]=29,i[e+20>>2]=-2147483616,f=l[27175]|l[27176]<<8|(l[27177]<<16|l[27178]<<24),k=l[27171]|l[27172]<<8|(l[27173]<<16|l[27174]<<24),u[r+21|0]=k,u[r+22|0]=k>>>8,u[r+23|0]=k>>>16,u[r+24|0]=k>>>24,u[r+25|0]=f,u[r+26|0]=f>>>8,u[r+27|0]=f>>>16,u[r+28|0]=f>>>24,f=l[27170]|l[27171]<<8|(l[27172]<<16|l[27173]<<24),k=l[27166]|l[27167]<<8|(l[27168]<<16|l[27169]<<24),u[r+16|0]=k,u[r+17|0]=k>>>8,u[r+18|0]=k>>>16,u[r+19|0]=k>>>24,u[r+20|0]=f,u[r+21|0]=f>>>8,u[r+22|0]=f>>>16,u[r+23|0]=f>>>24,f=l[27162]|l[27163]<<8|(l[27164]<<16|l[27165]<<24),k=l[27158]|l[27159]<<8|(l[27160]<<16|l[27161]<<24),u[r+8|0]=k,u[r+9|0]=k>>>8,u[r+10|0]=k>>>16,u[r+11|0]=k>>>24,u[r+12|0]=f,u[r+13|0]=f>>>8,u[r+14|0]=f>>>16,u[r+15|0]=f>>>24,f=l[27154]|l[27155]<<8|(l[27156]<<16|l[27157]<<24),k=l[27150]|l[27151]<<8|(l[27152]<<16|l[27153]<<24),u[r|0]=k,u[r+1|0]=k>>>8,u[r+2|0]=k>>>16,u[r+3|0]=k>>>24,u[r+4|0]=f,u[r+5|0]=f>>>8,u[r+6|0]=f>>>16,u[r+7|0]=f>>>24,u[r+29|0]=0,r=q(e+24|0,4,0,e+12|0),f=i[r+4>>2],i[A>>2]=i[r>>2],i[A+4>>2]=f,f=A+8|0;i:{if(u[r+19|0]>=0){k=i[r+12>>2],i[f>>2]=i[r+8>>2],i[f+4>>2]=k,i[f+8>>2]=i[r+16>>2],u[A+44|0]=1;break i}if(T(f,i[r+8>>2],i[r+12>>2]),f=u[r+19|0],u[A+44|0]=1,(f|0)>=0)break i;Z(i[r+8>>2])}u[e+23|0]<0&&Z(i[e+12>>2]),v=e+48|0}function kG(A,e,r,f,k,n){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,e=v-48|0,v=e,r=p(32),i[e+12>>2]=r,i[e+16>>2]=29,i[e+20>>2]=-2147483616,f=l[27266]|l[27267]<<8|(l[27268]<<16|l[27269]<<24),k=l[27262]|l[27263]<<8|(l[27264]<<16|l[27265]<<24),u[r+21|0]=k,u[r+22|0]=k>>>8,u[r+23|0]=k>>>16,u[r+24|0]=k>>>24,u[r+25|0]=f,u[r+26|0]=f>>>8,u[r+27|0]=f>>>16,u[r+28|0]=f>>>24,f=l[27261]|l[27262]<<8|(l[27263]<<16|l[27264]<<24),k=l[27257]|l[27258]<<8|(l[27259]<<16|l[27260]<<24),u[r+16|0]=k,u[r+17|0]=k>>>8,u[r+18|0]=k>>>16,u[r+19|0]=k>>>24,u[r+20|0]=f,u[r+21|0]=f>>>8,u[r+22|0]=f>>>16,u[r+23|0]=f>>>24,f=l[27253]|l[27254]<<8|(l[27255]<<16|l[27256]<<24),k=l[27249]|l[27250]<<8|(l[27251]<<16|l[27252]<<24),u[r+8|0]=k,u[r+9|0]=k>>>8,u[r+10|0]=k>>>16,u[r+11|0]=k>>>24,u[r+12|0]=f,u[r+13|0]=f>>>8,u[r+14|0]=f>>>16,u[r+15|0]=f>>>24,f=l[27245]|l[27246]<<8|(l[27247]<<16|l[27248]<<24),k=l[27241]|l[27242]<<8|(l[27243]<<16|l[27244]<<24),u[r|0]=k,u[r+1|0]=k>>>8,u[r+2|0]=k>>>16,u[r+3|0]=k>>>24,u[r+4|0]=f,u[r+5|0]=f>>>8,u[r+6|0]=f>>>16,u[r+7|0]=f>>>24,u[r+29|0]=0,r=q(e+24|0,4,0,e+12|0),f=i[r+4>>2],i[A>>2]=i[r>>2],i[A+4>>2]=f,f=A+8|0;i:{if(u[r+19|0]>=0){k=i[r+12>>2],i[f>>2]=i[r+8>>2],i[f+4>>2]=k,i[f+8>>2]=i[r+16>>2],u[A+44|0]=1;break i}if(T(f,i[r+8>>2],i[r+12>>2]),f=u[r+19|0],u[A+44|0]=1,(f|0)>=0)break i;Z(i[r+8>>2])}u[e+23|0]<0&&Z(i[e+12>>2]),v=e+48|0}function nG(A,e,r,f,k,n){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,e=v-48|0,v=e,r=p(32),i[e+12>>2]=r,i[e+16>>2]=29,i[e+20>>2]=-2147483616,f=l[27296]|l[27297]<<8|(l[27298]<<16|l[27299]<<24),k=l[27292]|l[27293]<<8|(l[27294]<<16|l[27295]<<24),u[r+21|0]=k,u[r+22|0]=k>>>8,u[r+23|0]=k>>>16,u[r+24|0]=k>>>24,u[r+25|0]=f,u[r+26|0]=f>>>8,u[r+27|0]=f>>>16,u[r+28|0]=f>>>24,f=l[27291]|l[27292]<<8|(l[27293]<<16|l[27294]<<24),k=l[27287]|l[27288]<<8|(l[27289]<<16|l[27290]<<24),u[r+16|0]=k,u[r+17|0]=k>>>8,u[r+18|0]=k>>>16,u[r+19|0]=k>>>24,u[r+20|0]=f,u[r+21|0]=f>>>8,u[r+22|0]=f>>>16,u[r+23|0]=f>>>24,f=l[27283]|l[27284]<<8|(l[27285]<<16|l[27286]<<24),k=l[27279]|l[27280]<<8|(l[27281]<<16|l[27282]<<24),u[r+8|0]=k,u[r+9|0]=k>>>8,u[r+10|0]=k>>>16,u[r+11|0]=k>>>24,u[r+12|0]=f,u[r+13|0]=f>>>8,u[r+14|0]=f>>>16,u[r+15|0]=f>>>24,f=l[27275]|l[27276]<<8|(l[27277]<<16|l[27278]<<24),k=l[27271]|l[27272]<<8|(l[27273]<<16|l[27274]<<24),u[r|0]=k,u[r+1|0]=k>>>8,u[r+2|0]=k>>>16,u[r+3|0]=k>>>24,u[r+4|0]=f,u[r+5|0]=f>>>8,u[r+6|0]=f>>>16,u[r+7|0]=f>>>24,u[r+29|0]=0,r=q(e+24|0,4,0,e+12|0),f=i[r+4>>2],i[A>>2]=i[r>>2],i[A+4>>2]=f,f=A+8|0;i:{if(u[r+19|0]>=0){k=i[r+12>>2],i[f>>2]=i[r+8>>2],i[f+4>>2]=k,i[f+8>>2]=i[r+16>>2],u[A+44|0]=1;break i}if(T(f,i[r+8>>2],i[r+12>>2]),f=u[r+19|0],u[A+44|0]=1,(f|0)>=0)break i;Z(i[r+8>>2])}u[e+23|0]<0&&Z(i[e+12>>2]),v=e+48|0}function tG(A,e,r,f,k,n){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,e=v-48|0,v=e,r=p(32),i[e+12>>2]=r,i[e+16>>2]=29,i[e+20>>2]=-2147483616,f=l[27205]|l[27206]<<8|(l[27207]<<16|l[27208]<<24),k=l[27201]|l[27202]<<8|(l[27203]<<16|l[27204]<<24),u[r+21|0]=k,u[r+22|0]=k>>>8,u[r+23|0]=k>>>16,u[r+24|0]=k>>>24,u[r+25|0]=f,u[r+26|0]=f>>>8,u[r+27|0]=f>>>16,u[r+28|0]=f>>>24,f=l[27200]|l[27201]<<8|(l[27202]<<16|l[27203]<<24),k=l[27196]|l[27197]<<8|(l[27198]<<16|l[27199]<<24),u[r+16|0]=k,u[r+17|0]=k>>>8,u[r+18|0]=k>>>16,u[r+19|0]=k>>>24,u[r+20|0]=f,u[r+21|0]=f>>>8,u[r+22|0]=f>>>16,u[r+23|0]=f>>>24,f=l[27192]|l[27193]<<8|(l[27194]<<16|l[27195]<<24),k=l[27188]|l[27189]<<8|(l[27190]<<16|l[27191]<<24),u[r+8|0]=k,u[r+9|0]=k>>>8,u[r+10|0]=k>>>16,u[r+11|0]=k>>>24,u[r+12|0]=f,u[r+13|0]=f>>>8,u[r+14|0]=f>>>16,u[r+15|0]=f>>>24,f=l[27184]|l[27185]<<8|(l[27186]<<16|l[27187]<<24),k=l[27180]|l[27181]<<8|(l[27182]<<16|l[27183]<<24),u[r|0]=k,u[r+1|0]=k>>>8,u[r+2|0]=k>>>16,u[r+3|0]=k>>>24,u[r+4|0]=f,u[r+5|0]=f>>>8,u[r+6|0]=f>>>16,u[r+7|0]=f>>>24,u[r+29|0]=0,r=q(e+24|0,4,0,e+12|0),f=i[r+4>>2],i[A>>2]=i[r>>2],i[A+4>>2]=f,f=A+8|0;i:{if(u[r+19|0]>=0){k=i[r+12>>2],i[f>>2]=i[r+8>>2],i[f+4>>2]=k,i[f+8>>2]=i[r+16>>2],u[A+44|0]=1;break i}if(T(f,i[r+8>>2],i[r+12>>2]),f=u[r+19|0],u[A+44|0]=1,(f|0)>=0)break i;Z(i[r+8>>2])}u[e+23|0]<0&&Z(i[e+12>>2]),v=e+48|0}function uG(A,e){A=A|0,e=e|0;var r=0,f=0,k=0,n=0,t=0,o=0,s=0,w=0,h=0,_=0;k=v-16|0,v=k,r=i[A>>2],A=i[r+244>>2],o=i[r+248>>2],o&&(i[o+4>>2]=i[o+4>>2]+1);i:{if(!A)break i;i[k+12>>2]=0,i[k+4>>2]=0,i[k+8>>2]=0;e:{r:{f:{if(f=i[A+100>>2],w=i[A+104>>2],(f|0)!=(w|0)){if(A=w-f|0,r=A>>4,r>>>0>=1073741824)break f;for(A=p(A>>2),i[k+8>>2]=A,i[k+4>>2]=A,i[k+12>>2]=(r<<2)+A;;){n=i[k+12>>2];A:{if(n>>>0>A>>>0){i[A>>2]=i[f>>2],A=A+4|0;break A}if(s=i[k+4>>2],A=A-s|0,h=A>>2,r=h+1|0,r>>>0>=1073741824)break f;if(n=n-s|0,t=n>>1,n=n>>>0>=2147483644?1073741823:r>>>0<t>>>0?t:r,n){if(n>>>0>=1073741824)break r;r=p(n<<2)}else r=0;if(t=r+A|0,i[t>>2]=i[f>>2],h=t-(h<<2)|0,A&&x(h,s,A),i[k+12>>2]=r+(n<<2),A=t+4|0,i[k+8>>2]=A,i[k+4>>2]=h,!s)break A;Z(s)}if(i[k+8>>2]=A,f=f+16|0,(w|0)==(f|0))break}}break e}G0(),H()}z0(),H()}A=i[k+8>>2],r=i[k+4>>2];e:{if((A|0)!=(r|0)){if(f=A-r>>2,n=f>>>0<=1?1:f,s=n&3,A=0,f>>>0>=4)for(w=n&-4,n=0;f=A<<2,i[f+e>>2]=i[r+f>>2],t=f|4,i[t+e>>2]=i[r+t>>2],t=f|8,i[t+e>>2]=i[r+t>>2],f=f|12,i[f+e>>2]=i[r+f>>2],A=A+4|0,n=n+4|0,(w|0)!=(n|0););if(!s)break e;for(;f=A<<2,i[f+e>>2]=i[r+f>>2],A=A+1|0,_=_+1|0,(s|0)!=(_|0););break e}if(!r)break i}i[k+8>>2]=r,Z(r)}i:{if(!o||(A=i[o+4>>2],i[o+4>>2]=A-1,A))break i;W[i[i[o>>2]+8>>2]](o),y(o)}v=k+16|0}function gr(A,e,r,f,k,n,t,o){var s=0,w=0,h=0,_=0;s=v-160|0,v=s;i:{e:{if(h=i[e+68>>2],w=i[h+104>>2],_=i[h+108>>2],(w|0)==(_|0))break e;for(;;){if(i[w>>2]!=(r|0)){if(w=w+32|0,(_|0)!=(w|0))continue;break e}break}q6(A,h,r,e+8|0,e+76|0,f,k,n,t,o,i[e+156>>2]);break i}i[s+104>>2]=0,i[s+76>>2]=72196,i[s+20>>2]=72176,e=i[18053],i[s+12>>2]=e,f=i[e-12>>2],e=s+12|0,i[f+e>>2]=i[18054],i[s+16>>2]=0,f=e+i[i[s+12>>2]-12>>2]|0,k=s+24|0,J0(f,k),u[f+80|0]=0,i[f+72>>2]=0,f=i[18055],i[s+20>>2]=f,n=s+20|0,i[n+i[f-12>>2]>>2]=i[18056],f=i[18052],i[s+12>>2]=f,i[e+i[f-12>>2]>>2]=i[18057],i[s+76>>2]=72196,i[s+12>>2]=72156,i[s+20>>2]=72176,f=R0(k),i[f>>2]=71232,e=s- -64|0,i[e>>2]=0,i[e+4>>2]=0,i[s+56>>2]=0,i[s+60>>2]=0,i[s+72>>2]=24,Y(V0(Y(n,29175,13),r),18918,23),e=i[s+72>>2];e:{r:{if(e&16){w=i[s+68>>2],e=i[s+48>>2],w>>>0<e>>>0&&(i[s+68>>2]=e,w=e),e=s+44|0;break r}if(!(e&8)){w=0,u[s+11|0]=0,r=s;break e}w=i[s+40>>2],e=s+32|0}r:{if(e=i[e>>2],w=w-e|0,w>>>0<2147483640){if(w>>>0>=11){k=w|7,r=p(k+1|0),i[s+8>>2]=k-2147483647,i[s>>2]=r,i[s+4>>2]=w;break r}if(u[s+11|0]=w,r=s,w)break r;w=0;break e}Q0(),H()}if(!w)break e;x(r,e,w)}u[r+w|0]=0,q(A,2,117,s),u[s+11|0]<0&&Z(i[s>>2]),A=i[18051],i[s+12>>2]=A,i[i[A-12>>2]+(s+12|0)>>2]=i[18059],i[s+20>>2]=i[18060],i[f>>2]=71232,u[s+67|0]<0&&Z(i[s+56>>2]),E0(f),y0(s+76|0)}v=s+160|0}function oG(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,t=0,o=0,s=0;f=v-160|0,v=f,i[f+92>>2]=0,i[f+64>>2]=72500,k=i[18128],i[f+8>>2]=k,t=i[k-12>>2],k=f+8|0,i[t+k>>2]=i[18129],o=k+i[i[f+8>>2]-12>>2]|0,n=f+12|0,J0(o,n),u[o+80|0]=0,i[o+72>>2]=0,i[f+64>>2]=72500,i[f+8>>2]=72480,o=R0(n),i[o>>2]=71232,i[f+52>>2]=0,i[f+56>>2]=0,i[f+44>>2]=0,i[f+48>>2]=0,i[f+60>>2]=16,n=f+148|0,Y2(n,e,r),s=k,t=n,k=u[f+159|0],n=(k|0)<0,Y(s,n?i[f+148>>2]:t,n?i[f+152>>2]:k),u[f+159|0]<0&&Z(i[f+148>>2]),k=f+148|0,s0(k,r),t=k,k=u[f+159|0],n=(k|0)<0,Y(f+8|0,n?i[f+148>>2]:t,n?i[f+152>>2]:k),u[f+159|0]<0&&Z(i[f+148>>2]),k=f+8|0,Y(V0(Y(k,31076,10),i[e+100>>2]),42670,1),n=f+148|0,s0(n,r),t=k,r=u[f+159|0],k=(r|0)<0,Y(t,k?i[f+148>>2]:n,k?i[f+152>>2]:r),u[f+159|0]<0&&Z(i[f+148>>2]),Y(V0(Y(f+8|0,31065,10),i[e+104>>2]),42670,1),e=i[f+60>>2];i:{e:{if(e&16){r=i[f+56>>2],e=i[f+36>>2],r>>>0<e>>>0&&(i[f+56>>2]=e,r=e),e=f+32|0;break e}if(!(e&8)){r=0,u[A+11|0]=0;break i}r=i[f+28>>2],e=f+20|0}e:{if(k=i[e>>2],r=r-k|0,r>>>0<2147483640){if(r>>>0>=11){n=r|7,e=p(n+1|0),i[A+8>>2]=n-2147483647,i[A>>2]=e,i[A+4>>2]=r,A=e;break e}if(u[A+11|0]=r,r)break e;r=0;break i}Q0(),H()}if(!r)break i;x(A,k,r)}u[A+r|0]=0,A=i[18127],i[f+8>>2]=A,i[i[A-12>>2]+(f+8|0)>>2]=i[18130],i[o>>2]=71232,u[f+55|0]<0&&Z(i[f+44>>2]),E0(o),y0(f- -64|0),v=f+160|0}function lG(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,t=0,o=0,s=0;f=v-160|0,v=f,i[f+92>>2]=0,i[f+64>>2]=72500,k=i[18128],i[f+8>>2]=k,t=i[k-12>>2],k=f+8|0,i[t+k>>2]=i[18129],o=k+i[i[f+8>>2]-12>>2]|0,n=f+12|0,J0(o,n),u[o+80|0]=0,i[o+72>>2]=0,i[f+64>>2]=72500,i[f+8>>2]=72480,o=R0(n),i[o>>2]=71232,i[f+52>>2]=0,i[f+56>>2]=0,i[f+44>>2]=0,i[f+48>>2]=0,i[f+60>>2]=16,n=f+148|0,Y2(n,e,r),s=k,t=n,k=u[f+159|0],n=(k|0)<0,Y(s,n?i[f+148>>2]:t,n?i[f+152>>2]:k),u[f+159|0]<0&&Z(i[f+148>>2]),k=f+148|0,s0(k,r),t=k,k=u[f+159|0],n=(k|0)<0,Y(f+8|0,n?i[f+148>>2]:t,n?i[f+152>>2]:k),u[f+159|0]<0&&Z(i[f+148>>2]),k=f+8|0,Y(V0(Y(k,30817,25),C[e+98>>1]),42670,1),n=f+148|0,s0(n,r),t=k,r=u[f+159|0],k=(r|0)<0,Y(t,k?i[f+148>>2]:n,k?i[f+152>>2]:r),u[f+159|0]<0&&Z(i[f+148>>2]),Y(V0(Y(f+8|0,30843,29),C[e+100>>1]),42670,1),e=i[f+60>>2];i:{e:{if(e&16){r=i[f+56>>2],e=i[f+36>>2],r>>>0<e>>>0&&(i[f+56>>2]=e,r=e),e=f+32|0;break e}if(!(e&8)){r=0,u[A+11|0]=0;break i}r=i[f+28>>2],e=f+20|0}e:{if(k=i[e>>2],r=r-k|0,r>>>0<2147483640){if(r>>>0>=11){n=r|7,e=p(n+1|0),i[A+8>>2]=n-2147483647,i[A>>2]=e,i[A+4>>2]=r,A=e;break e}if(u[A+11|0]=r,r)break e;r=0;break i}Q0(),H()}if(!r)break i;x(A,k,r)}u[A+r|0]=0,A=i[18127],i[f+8>>2]=A,i[i[A-12>>2]+(f+8|0)>>2]=i[18130],i[o>>2]=71232,u[f+55|0]<0&&Z(i[f+44>>2]),E0(o),y0(f- -64|0),v=f+160|0}function sG(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,t=0,o=0,s=0;f=v-160|0,v=f,i[f+92>>2]=0,i[f+64>>2]=72500,n=i[18128],i[f+8>>2]=n,k=i[n-12>>2],n=f+8|0,i[k+n>>2]=i[18129],t=n+i[i[f+8>>2]-12>>2]|0,k=f+12|0,J0(t,k),u[t+80|0]=0,i[t+72>>2]=0,i[f+64>>2]=72500,i[f+8>>2]=72480,t=R0(k),i[t>>2]=71232,i[f+52>>2]=0,i[f+56>>2]=0,i[f+44>>2]=0,i[f+48>>2]=0,i[f+60>>2]=16,k=f+148|0,Y2(k,e,r),s=n,o=k,n=u[f+159|0],k=(n|0)<0,Y(s,k?i[f+148>>2]:o,k?i[f+152>>2]:n),u[f+159|0]<0&&Z(i[f+148>>2]),n=f+148|0,s0(n,r),o=n,n=u[f+159|0],k=(n|0)<0,Y(f+8|0,k?i[f+148>>2]:o,k?i[f+152>>2]:n),u[f+159|0]<0&&Z(i[f+148>>2]),n=Y(V0(Y(f+8|0,31010,13),i[e+104>>2]),42670,1),k=f+148|0,s0(k,r),o=k,r=u[f+159|0],k=(r|0)<0,Y(n,k?i[f+148>>2]:o,k?i[f+152>>2]:r),u[f+159|0]<0&&Z(i[f+148>>2]),Y(V0(Y(n,29695,14),i[e+108>>2]),42670,1),e=i[f+60>>2];i:{e:{if(e&16){r=i[f+56>>2],e=i[f+36>>2],r>>>0<e>>>0&&(i[f+56>>2]=e,r=e),e=f+32|0;break e}if(!(e&8)){r=0,u[A+11|0]=0;break i}r=i[f+28>>2],e=f+20|0}e:{if(n=i[e>>2],r=r-n|0,r>>>0<2147483640){if(r>>>0>=11){k=r|7,e=p(k+1|0),i[A+8>>2]=k-2147483647,i[A>>2]=e,i[A+4>>2]=r,A=e;break e}if(u[A+11|0]=r,r)break e;r=0;break i}Q0(),H()}if(!r)break i;x(A,n,r)}u[A+r|0]=0,A=i[18127],i[f+8>>2]=A,i[i[A-12>>2]+(f+8|0)>>2]=i[18130],i[t>>2]=71232,u[f+55|0]<0&&Z(i[f+44>>2]),E0(t),y0(f- -64|0),v=f+160|0}function wG(A,e){A=A|0,e=e|0;var r=0,f=0,k=0,n=0,t=0,o=0,s=0;f=v-16|0,v=f;i:{e:{if(!i[A+64>>2])break e;if(!(l[A+92|0]&16)){i[A+16>>2]=0,i[A+12>>2]=0,i[A+8>>2]=0,r=i[A+52>>2];r:{if(r>>>0>=9){if(l[A+98|0]==1){n=r,r=i[A+32>>2],i[A+28>>2]=(n+r|0)-1,i[A+20>>2]=r,i[A+24>>2]=r;break r}r=i[A+56>>2],i[A+28>>2]=(r+i[A+60>>2]|0)-1,i[A+20>>2]=r,i[A+24>>2]=r;break r}i[A+28>>2]=0,i[A+20>>2]=0,i[A+24>>2]=0}i[A+92>>2]=16}if(t=i[A+20>>2],o=i[A+28>>2],(e|0)!=-1&&(i[A+24>>2]||(i[A+28>>2]=f+16,r=f+15|0,i[A+20>>2]=r,i[A+24>>2]=r),u[i[A+24>>2]]=e<<24>>24,i[A+24>>2]=i[A+24>>2]+1),k=i[A+24>>2],r=i[A+20>>2],(k|0)!=(r|0)){r:{if(l[A+98|0]==1){if(n=r,r=k-r|0,(P1(n,1,r,i[A+64>>2])|0)!=(r|0))break e;break r}for(i[f+8>>2]=i[A+32>>2],s=A+72|0;;){if(r=i[A+68>>2],r){if(k=i[A+32>>2],r=W[i[i[r>>2]+12>>2]](r,s,i[A+20>>2],i[A+24>>2],f+4|0,k,k+i[A+52>>2]|0,f+8|0)|0,i[A+20>>2]==i[f+4>>2])break e;if((r|0)==3){if(r=i[A+24>>2]-i[A+20>>2]|0,(P1(i[A+20>>2],1,r,i[A+64>>2])|0)!=(r|0))break e;break r}if(r>>>0>1||(n=i[A+32>>2],k=i[f+8>>2]-n|0,(P1(n,1,k,i[A+64>>2])|0)!=(k|0)))break e;if((r|0)!=1)break r;r=i[f+4>>2],i[A+28>>2]=i[A+24>>2],i[A+20>>2]=r,i[A+24>>2]=r,i[A+24>>2]=i[A+24>>2]+(i[A+28>>2]-i[A+20>>2]|0);continue}break}g1(),H()}i[A+28>>2]=o,i[A+20>>2]=t,i[A+24>>2]=t}A=(e|0)!=-1?e:0;break i}A=-1}return v=f+16|0,A|0}function hG(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,t=0,o=0,s=0;if(f=v-160|0,v=f,i[f+92>>2]=0,i[f+64>>2]=72500,k=i[18128],i[f+8>>2]=k,n=i[k-12>>2],k=f+8|0,i[n+k>>2]=i[18129],t=k+i[i[f+8>>2]-12>>2]|0,n=f+12|0,J0(t,n),u[t+80|0]=0,i[t+72>>2]=0,i[f+64>>2]=72500,i[f+8>>2]=72480,t=R0(n),i[t>>2]=71232,i[f+52>>2]=0,i[f+56>>2]=0,i[f+44>>2]=0,i[f+48>>2]=0,i[f+60>>2]=16,n=f+148|0,Y2(n,e,r),o=k,s=n,k=u[f+159|0],n=(k|0)<0,Y(o,n?i[f+148>>2]:s,n?i[f+152>>2]:k),u[f+159|0]<0&&Z(i[f+148>>2]),k=i[e+100>>2],e=i[e+104>>2],(k|0)!=(e|0))for(;n=f+148|0,s0(n,r),s=n,n=u[f+159|0],o=(n|0)<0,Y(f+8|0,o?i[f+148>>2]:s,o?i[f+152>>2]:n),u[f+159|0]<0&&Z(i[f+148>>2]),Y(V0(Y(V0(Y(V0(Y(f+8|0,29400,15),C[k>>1]),31654,16),C[k+2>>1]),30667,23),C[k+4>>1]),42670,1),k=k+6|0,(e|0)!=(k|0););e=i[f+60>>2];i:{e:{if(e&16){k=i[f+56>>2],e=i[f+36>>2],k>>>0<e>>>0&&(i[f+56>>2]=e,k=e),e=f+32|0;break e}if(!(e&8)){k=0,u[A+11|0]=0;break i}k=i[f+28>>2],e=f+20|0}e:{if(r=i[e>>2],k=k-r|0,k>>>0<2147483640){if(k>>>0>=11){n=k|7,e=p(n+1|0),i[A+8>>2]=n-2147483647,i[A>>2]=e,i[A+4>>2]=k,A=e;break e}if(u[A+11|0]=k,k)break e;k=0;break i}Q0(),H()}if(!k)break i;x(A,r,k)}u[A+k|0]=0,A=i[18127],i[f+8>>2]=A,i[i[A-12>>2]+(f+8|0)>>2]=i[18130],i[t>>2]=71232,u[f+55|0]<0&&Z(i[f+44>>2]),E0(t),y0(f- -64|0),v=f+160|0}function _G(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,t=0,o=0,s=0;if(f=v-160|0,v=f,i[f+92>>2]=0,i[f+64>>2]=72500,k=i[18128],i[f+8>>2]=k,n=i[k-12>>2],k=f+8|0,i[n+k>>2]=i[18129],t=k+i[i[f+8>>2]-12>>2]|0,n=f+12|0,J0(t,n),u[t+80|0]=0,i[t+72>>2]=0,i[f+64>>2]=72500,i[f+8>>2]=72480,t=R0(n),i[t>>2]=71232,i[f+52>>2]=0,i[f+56>>2]=0,i[f+44>>2]=0,i[f+48>>2]=0,i[f+60>>2]=16,n=f+148|0,Y2(n,e,r),o=k,s=n,k=u[f+159|0],n=(k|0)<0,Y(o,n?i[f+148>>2]:s,n?i[f+152>>2]:k),u[f+159|0]<0&&Z(i[f+148>>2]),k=i[e+104>>2],e=i[e+108>>2],(k|0)!=(e|0))for(;n=f+148|0,s0(n,r),s=n,n=u[f+159|0],o=(n|0)<0,Y(f+8|0,o?i[f+148>>2]:s,o?i[f+152>>2]:n),u[f+159|0]<0&&Z(i[f+148>>2]),Y(V0(Y(S0(Y(V0(Y(f+8|0,32109,10),C[k>>1]),29922,18),l[k+2|0]),29904,17),C[k+4>>1]),42670,1),k=k+6|0,(e|0)!=(k|0););e=i[f+60>>2];i:{e:{if(e&16){k=i[f+56>>2],e=i[f+36>>2],k>>>0<e>>>0&&(i[f+56>>2]=e,k=e),e=f+32|0;break e}if(!(e&8)){k=0,u[A+11|0]=0;break i}k=i[f+28>>2],e=f+20|0}e:{if(r=i[e>>2],k=k-r|0,k>>>0<2147483640){if(k>>>0>=11){n=k|7,e=p(n+1|0),i[A+8>>2]=n-2147483647,i[A>>2]=e,i[A+4>>2]=k,A=e;break e}if(u[A+11|0]=k,k)break e;k=0;break i}Q0(),H()}if(!k)break i;x(A,r,k)}u[A+k|0]=0,A=i[18127],i[f+8>>2]=A,i[i[A-12>>2]+(f+8|0)>>2]=i[18130],i[t>>2]=71232,u[f+55|0]<0&&Z(i[f+44>>2]),E0(t),y0(f- -64|0),v=f+160|0}function BG(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,t=0,o=0,s=0;if(f=v-160|0,v=f,i[f+92>>2]=0,i[f+64>>2]=72500,k=i[18128],i[f+8>>2]=k,n=i[k-12>>2],k=f+8|0,i[n+k>>2]=i[18129],t=k+i[i[f+8>>2]-12>>2]|0,n=f+12|0,J0(t,n),u[t+80|0]=0,i[t+72>>2]=0,i[f+64>>2]=72500,i[f+8>>2]=72480,t=R0(n),i[t>>2]=71232,i[f+52>>2]=0,i[f+56>>2]=0,i[f+44>>2]=0,i[f+48>>2]=0,i[f+60>>2]=16,n=f+148|0,Y2(n,e,r),o=k,s=n,k=u[f+159|0],n=(k|0)<0,Y(o,n?i[f+148>>2]:s,n?i[f+152>>2]:k),u[f+159|0]<0&&Z(i[f+148>>2]),k=i[e+100>>2],e=i[e+104>>2],(k|0)!=(e|0))for(;n=f+148|0,s0(n,r),s=n,n=u[f+159|0],o=(n|0)<0,Y(f+8|0,o?i[f+148>>2]:s,o?i[f+152>>2]:n),u[f+159|0]<0&&Z(i[f+148>>2]),Y(S0(Y(S0(Y(V0(Y(f+8|0,29323,17),C[k>>1]),31700,16),l[k+2|0]),30286,18),l[k+3|0]),42670,1),k=k+4|0,(e|0)!=(k|0););e=i[f+60>>2];i:{e:{if(e&16){k=i[f+56>>2],e=i[f+36>>2],k>>>0<e>>>0&&(i[f+56>>2]=e,k=e),e=f+32|0;break e}if(!(e&8)){k=0,u[A+11|0]=0;break i}k=i[f+28>>2],e=f+20|0}e:{if(r=i[e>>2],k=k-r|0,k>>>0<2147483640){if(k>>>0>=11){n=k|7,e=p(n+1|0),i[A+8>>2]=n-2147483647,i[A>>2]=e,i[A+4>>2]=k,A=e;break e}if(u[A+11|0]=k,k)break e;k=0;break i}Q0(),H()}if(!k)break i;x(A,r,k)}u[A+k|0]=0,A=i[18127],i[f+8>>2]=A,i[i[A-12>>2]+(f+8|0)>>2]=i[18130],i[t>>2]=71232,u[f+55|0]<0&&Z(i[f+44>>2]),E0(t),y0(f- -64|0),v=f+160|0}function vG(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,t=0;n=v-32|0,v=n,t=W[i[i[e>>2]+52>>2]](e,r,0)|0,l[e+184|0]==1&&F0(r,i[e+104>>2]),l[e+185|0]==1&&F0(r,i[e+108>>2]),l[e+186|0]==1&&F0(r,i[e+112>>2]);i:{if(l[e+187|0]!=1)break i;if(l[e+116|0]==1){if(f=t0[e+120>>3],l[e+117|0]==1){f=f*1073741824,w2(f)<2147483647?k=~~f:k=-2147483648,F0(r,k),f=t0[e+128>>3]*1073741824,w2(f)<2147483647?k=~~f:k=-2147483648,F0(r,k),f=t0[e+136>>3]*1073741824,w2(f)<2147483647?k=~~f:k=-2147483648,F0(r,k);break i}f=f*16384,w2(f)<2147483647?k=~~f:k=-2147483648,Me(r,k),f=t0[e+128>>3]*16384,w2(f)<2147483647?k=~~f:k=-2147483648,Me(r,k),f=t0[e+136>>3]*16384,w2(f)<2147483647?k=~~f:k=-2147483648,Me(r,k);break i}f=t0[e+152>>3]*65536,w2(f)<2147483647?k=~~f:k=-2147483648,F0(r,k),f=t0[e+160>>3]*65536,w2(f)<2147483647?k=~~f:k=-2147483648,F0(r,k),f=t0[e+168>>3]*65536,w2(f)<2147483647?k=~~f:k=-2147483648,F0(r,k)}l[e+188|0]==1&&F0(r,i[e+176>>2]),i[r+12>>2]=t,W[i[i[e>>2]+56>>2]](n+12|0,e,r,i[r+4>>2]-(i[r>>2]+t|0)|0,0),i[r+12>>2]=i[r+4>>2]-i[r>>2],u[n+31|0]<0&&Z(i[n+20>>2]),e=i[26917],i[A>>2]=i[26916],i[A+4>>2]=e,A=A+8|0;i:{if(u[107683]>=0){e=i[26919],i[A>>2]=i[26918],i[A+4>>2]=e,i[A+8>>2]=i[26920];break i}T(A,i[26918],i[26919])}v=n+32|0}function mG(A,e){A=A|0,e=e|0;var r=0,f=0,k=0;e=v-48|0,v=e,r=p(40),i[e+12>>2]=r,i[e+16>>2]=32,i[e+20>>2]=-2147483608,f=l[4342]|l[4343]<<8|(l[4344]<<16|l[4345]<<24),k=l[4338]|l[4339]<<8|(l[4340]<<16|l[4341]<<24),u[r+24|0]=k,u[r+25|0]=k>>>8,u[r+26|0]=k>>>16,u[r+27|0]=k>>>24,u[r+28|0]=f,u[r+29|0]=f>>>8,u[r+30|0]=f>>>16,u[r+31|0]=f>>>24,f=l[4334]|l[4335]<<8|(l[4336]<<16|l[4337]<<24),k=l[4330]|l[4331]<<8|(l[4332]<<16|l[4333]<<24),u[r+16|0]=k,u[r+17|0]=k>>>8,u[r+18|0]=k>>>16,u[r+19|0]=k>>>24,u[r+20|0]=f,u[r+21|0]=f>>>8,u[r+22|0]=f>>>16,u[r+23|0]=f>>>24,f=l[4326]|l[4327]<<8|(l[4328]<<16|l[4329]<<24),k=l[4322]|l[4323]<<8|(l[4324]<<16|l[4325]<<24),u[r+8|0]=k,u[r+9|0]=k>>>8,u[r+10|0]=k>>>16,u[r+11|0]=k>>>24,u[r+12|0]=f,u[r+13|0]=f>>>8,u[r+14|0]=f>>>16,u[r+15|0]=f>>>24,f=l[4318]|l[4319]<<8|(l[4320]<<16|l[4321]<<24),k=l[4314]|l[4315]<<8|(l[4316]<<16|l[4317]<<24),u[r|0]=k,u[r+1|0]=k>>>8,u[r+2|0]=k>>>16,u[r+3|0]=k>>>24,u[r+4|0]=f,u[r+5|0]=f>>>8,u[r+6|0]=f>>>16,u[r+7|0]=f>>>24,u[r+32|0]=0,f=q(e+24|0,4,6003,e+12|0),r=i[f+4>>2],i[A>>2]=i[f>>2],i[A+4>>2]=r,k=A+8|0;i:{if(u[f+19|0]>=0){r=i[f+12>>2],i[k>>2]=i[f+8>>2],i[k+4>>2]=r,i[k+8>>2]=i[f+16>>2],u[A+20|0]=1;break i}if(T(k,i[f+8>>2],i[f+12>>2]),r=u[f+19|0],u[A+20|0]=1,(r|0)>=0)break i;Z(i[f+8>>2])}u[e+23|0]<0&&Z(i[e+12>>2]),v=e+48|0}function ZG(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,t=0,o=0,s=0;if(f=v-160|0,v=f,i[f+92>>2]=0,i[f+64>>2]=72500,k=i[18128],i[f+8>>2]=k,n=i[k-12>>2],k=f+8|0,i[n+k>>2]=i[18129],t=k+i[i[f+8>>2]-12>>2]|0,n=f+12|0,J0(t,n),u[t+80|0]=0,i[t+72>>2]=0,i[f+64>>2]=72500,i[f+8>>2]=72480,t=R0(n),i[t>>2]=71232,i[f+52>>2]=0,i[f+56>>2]=0,i[f+44>>2]=0,i[f+48>>2]=0,i[f+60>>2]=16,n=f+148|0,U1(n,e,r),o=k,s=n,k=u[f+159|0],n=(k|0)<0,Y(o,n?i[f+148>>2]:s,n?i[f+152>>2]:k),u[f+159|0]<0&&Z(i[f+148>>2]),i[e+108>>2]!=i[e+104>>2])for(k=0;n=f+148|0,s0(n,r),s=n,n=u[f+159|0],o=(n|0)<0,Y(f+8|0,o?i[f+148>>2]:s,o?i[f+152>>2]:n),u[f+159|0]<0&&Z(i[f+148>>2]),Y(V0(Y(V0(Y(f+8|0,19205,1),k),32722,4),i[i[e+104>>2]+(k<<2)>>2]),42670,1),k=k+1|0,k>>>0<i[e+108>>2]-i[e+104>>2]>>2>>>0;);e=i[f+60>>2];i:{e:{if(e&16){k=i[f+56>>2],e=i[f+36>>2],k>>>0<e>>>0&&(i[f+56>>2]=e,k=e),e=f+32|0;break e}if(!(e&8)){k=0,u[A+11|0]=0;break i}k=i[f+28>>2],e=f+20|0}e:{if(r=i[e>>2],k=k-r|0,k>>>0<2147483640){if(k>>>0>=11){n=k|7,e=p(n+1|0),i[A+8>>2]=n-2147483647,i[A>>2]=e,i[A+4>>2]=k,A=e;break e}if(u[A+11|0]=k,k)break e;k=0;break i}Q0(),H()}if(!k)break i;x(A,r,k)}u[A+k|0]=0,A=i[18127],i[f+8>>2]=A,i[i[A-12>>2]+(f+8|0)>>2]=i[18130],i[t>>2]=71232,u[f+55|0]<0&&Z(i[f+44>>2]),E0(t),y0(f- -64|0),v=f+160|0}function ln(A,e,r,f,k,n,t,o){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,t=t|0,o=o|0;var s=0,w=0,h=0,_=0;A=v-16|0,v=A,i[A+12>>2]=r,i[A+8>>2]=n;i:if((f-r|0)<3)break i;i:{e:{for(;;){if(!(r>>>0>=f>>>0|n>>>0>=t>>>0)){s=u[r|0],e=s&255;r:{if((s|0)>=0){if(e>>>0>1114111)break e;s=1;break r}if(s>>>0<4294967234)break e;if(s>>>0<=4294967263){if(s=1,(f-r|0)<2||(s=2,w=l[r+1|0],(w&192)!=128))break i;e=w&63|e<<6&1984,s=2;break r}if(s>>>0<=4294967279){if(s=1,h=f-r|0,(h|0)<2)break i;w=u[r+1|0];f:{A:{if((e|0)!=237){if((e|0)!=224)break A;if((w&-32)==-96)break f;break e}if((w|0)<-96)break f;break e}if((w|0)>-65)break e}if((h|0)==2)break i;if(s=l[r+2|0],(s&192)!=128)break e;e=s&63|(e<<12&61440|(w&63)<<6),s=3;break r}if(s>>>0>4294967284)break e;if(s=1,h=f-r|0,(h|0)<2)break i;w=u[r+1|0];f:{A:switch(e-240|0){case 0:if((w+112&255)>>>0>=48)break e;break f;case 4:if((w|0)>=-112)break e;break f;default:break A}if((w|0)>-65)break e}if((h|0)==2)break i;if(_=l[r+2|0],(_&192)!=128)break e;if((h|0)==3)break i;if(h=l[r+3|0],(h&192)!=128)break e;if(s=2,e=h&63|(_<<6&4032|(e<<18&1835008|(w&63)<<12)),e>>>0>1114111)break i;s=4}i[n>>2]=e,r=r+s|0,i[A+12>>2]=r,n=n+4|0,i[A+8>>2]=n;continue}break}s=r>>>0<f>>>0;break i}s=2}return i[k>>2]=i[A+12>>2],i[o>>2]=i[A+8>>2],v=A+16|0,s|0}function GG(A,e,r,f,k){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0;var n=0,t=0,o=0,s=0,w=0,h=0,_=0,B=0,m=0;w=v-16|0,v=w;i:{if((r|0)<0)break i;A=i[A>>2],n=i[A+48>>2],A=i[A+52>>2],A&&(i[A+4>>2]=i[A+4>>2]+1),o=i[n+84>>2],s=i[n+88>>2],s&&(i[s+4>>2]=i[s+4>>2]+1);e:{if(!A||(n=i[A+4>>2],i[A+4>>2]=n-1,n))break e;W[i[i[A>>2]+8>>2]](A),y(A)}e:{if(!o){n=0;break e}i3(w+4|0,o,e),A=i[w+8>>2],o=i[w+4>>2];r:{if(((A-o|0)/56|0)>(r|0)){r=o+G(r,56)|0,f&&(i[f>>2]=i[r+16>>2]);f:{if(!k){e=i[r+44>>2],n=i[r+48>>2];break f}if(e=i[r+48>>2]-i[r+44>>2]|0,h=p((e|0)<0?-1:e),i[k>>2]=h,e=i[r+44>>2],n=i[r+48>>2],(e|0)==(n|0)){e=n;break f}if(f=n-e>>2,t=f>>>0<=1?1:f,B=t&3,k=0,r=0,f>>>0>=4)for(m=t&-4,f=0;t=r<<2,i[t+h>>2]=i[e+t>>2],_=t|4,i[_+h>>2]=i[e+_>>2],_=t|8,i[_+h>>2]=i[e+_>>2],t=t|12,i[t+h>>2]=i[e+t>>2],r=r+4|0,f=f+4|0,(m|0)!=(f|0););if(!B)break f;for(;f=r<<2,i[f+h>>2]=i[e+f>>2],r=r+1|0,k=k+1|0,(B|0)!=(k|0););}n=n-e>>2;break r}if(n=0,!o)break e}if((A|0)==(o|0))A=o;else{for(;e=i[A-12>>2],e&&(i[A-8>>2]=e,Z(e)),e=A-56|0,i[e>>2]=86356,r=i[A-36>>2],r&&(i[A-32>>2]=r,Z(r)),A=e,(o|0)!=(A|0););A=i[w+4>>2]}i[w+8>>2]=o,Z(A)}if(!s||(A=i[s+4>>2],i[s+4>>2]=A-1,A))break i;W[i[i[s>>2]+8>>2]](s),y(s)}return v=w+16|0,n|0}function sn(A,e,r,f,k,n,t,o){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,t=t|0,o=o|0;var s=0,w=0;A=v-16|0,v=A,i[A+12>>2]=r,i[A+8>>2]=n;i:{e:{for(;;){if(r>>>0>=f>>>0){n=0;break i}n=2;r:{e=C[r>>1];f:{if(e>>>0<=127){if(n=1,r=i[A+8>>2],(t-r|0)<=0)break i;i[A+8>>2]=r+1,u[r|0]=e;break f}if(e>>>0<=2047){if(r=i[A+8>>2],(t-r|0)<2)break e;i[A+8>>2]=r+1,u[r|0]=e>>>6|192,r=i[A+8>>2],i[A+8>>2]=r+1,u[r|0]=e&63|128;break f}if(e>>>0<=55295){if(r=i[A+8>>2],(t-r|0)<3)break e;i[A+8>>2]=r+1,u[r|0]=e>>>12|224,r=i[A+8>>2],i[A+8>>2]=r+1,u[r|0]=e>>>6&63|128,r=i[A+8>>2],i[A+8>>2]=r+1,u[r|0]=e&63|128;break f}if(e>>>0<=56319){if(n=1,(f-r|0)<3)break i;if(s=C[r+2>>1],(s&64512)!=56320)break r;if(w=i[A+8>>2],(t-w|0)<4)break i;if(n=e&960,(s&1023|(e<<10&64512|n<<10))>>>0>1048575)break r;i[A+12>>2]=r+2,i[A+8>>2]=w+1,r=(n>>>6|0)+1|0,u[w|0]=r>>>2|240,n=i[A+8>>2],i[A+8>>2]=n+1,u[n|0]=r<<4&48|e>>>2&15|128,r=i[A+8>>2],i[A+8>>2]=r+1,u[r|0]=s>>>6&15|e<<4&48|128,e=i[A+8>>2],i[A+8>>2]=e+1,u[e|0]=s&63|128;break f}if(e>>>0<57344)break i;if(r=i[A+8>>2],(t-r|0)<3)break e;i[A+8>>2]=r+1,u[r|0]=e>>>12|224,r=i[A+8>>2],i[A+8>>2]=r+1,u[r|0]=e>>>6&191,r=i[A+8>>2],i[A+8>>2]=r+1,u[r|0]=e&63|128}r=i[A+12>>2]+2|0,i[A+12>>2]=r;continue}break}n=2;break i}n=1}return i[k>>2]=i[A+12>>2],i[o>>2]=i[A+8>>2],v=A+16|0,n|0}function XG(A,e,r,f,k,n){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0;var t=0,o=0,s=0;for(A=v-256|0,v=A,i[A+248>>2]=r,i[A+252>>2]=e,e=v-16|0,v=e,o=A+196|0,i[o>>2]=0,i[o+4>>2]=0,i[o+8>>2]=0,v=e+16|0,t=A+16|0,e=i[f+28>>2],i[t>>2]=e,(e|0)!=129576&&(i[e+4>>2]=i[e+4>>2]+1),e=c0(t,129760),W[i[i[e>>2]+32>>2]](e,77744,77770,A+208|0)|0,e2(t),e=v-16|0,v=e,r=A+184|0,i[r>>2]=0,i[r+4>>2]=0,i[r+8>>2]=0,v=e+16|0,W2(r,l[r+11|0]>>>7|0?(i[r+8>>2]&2147483647)-1|0:10),l[r+11|0]>>>7|0?e=i[r>>2]:e=r,i[A+180>>2]=e,i[A+12>>2]=t,i[A+8>>2]=0;;){i:{if(L2(A+252|0,A+248|0))break i;t=i[A+180>>2],l[r+11|0]>>>7|0?f=i[r+4>>2]:f=l[r+11|0]&127,(t|0)==(f+e|0)&&(l[r+11|0]>>>7|0?e=i[r+4>>2]:e=l[r+11|0]&127,l[r+11|0]>>>7|0?f=i[r+4>>2]:f=l[r+11|0]&127,W2(r,f<<1),W2(r,l[r+11|0]>>>7|0?(i[r+8>>2]&2147483647)-1|0:10),f=e,l[r+11|0]>>>7|0?e=i[r>>2]:e=r,i[A+180>>2]=f+e),s=A+252|0,f=i[s>>2],t=i[f+12>>2];e:{if((t|0)==i[f+16>>2]){f=W[i[i[f>>2]+36>>2]](f)|0;break e}f=u[t|0]}if(Ai(f<<24>>24,16,e,A+180|0,A+8|0,0,o,A+16|0,A+12|0,A+208|0))break i;q1(s);continue}break}return W2(r,i[A+180>>2]-e|0),l[r+11|0]>>>7|0?e=i[r>>2]:e=r,f=a2(),i[A>>2]=n,(Oo(e,f,A)|0)!=1&&(i[k>>2]=4),L2(A+252|0,A+248|0)&&(i[k>>2]=i[k>>2]|2),e=i[A+252>>2],s2(r),s2(o),v=A+256|0,e|0}function WG(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0;var k=0,n=0,t=0,o=0,s=0,w=0,h=0,_=0,B=0,m=0,X=0,Q=0;k=v-32|0,v=k,z2(k,e,r),u[k+19|0]<0&&Z(i[k+8>>2]);i:{e:{r:{if(l[e+97|0]>=2){t1(A,e,7911);break r}if(X=e,Q=C0(r),i[X+104>>2]=Q,l[e+97|0]==1&&(n=C0(r),u[e+112|0]=1,i[e+108>>2]=n),_=C0(r),q4(A,e+128|0,_<<3,f,13749),i[A>>2])break r;u[A+19|0]<0&&Z(i[A+8>>2]);f:{if(_){for(;;){w=C0(r),f=C0(r),n=i[e+120>>2],t=i[e+124>>2];A:{if(n>>>0<t>>>0){i[n>>2]=w,i[n+4>>2]=f,f=n+8|0;break A}if(h=i[e+116>>2],n=n-h|0,B=n>>3,o=B+1|0,o>>>0>=536870912)break e;if(t=t-h|0,s=t>>2,t=t>>>0>=2147483640?536870911:s>>>0>o>>>0?s:o,t){if(t>>>0>=536870912)break i;o=p(t<<3)}else o=0;if(s=o+n|0,i[s>>2]=w,i[s+4>>2]=f,w=s-(B<<3)|0,n&&x(w,h,n),i[e+124>>2]=o+(t<<3),f=s+8|0,i[e+120>>2]=f,i[e+116>>2]=w,!h)break A;Z(h)}if(i[e+120>>2]=f,l[r+20|0]!=1){if(m=m+1|0,(m|0)==(_|0))break f;continue}break}if(u[k+20|0]=0,u[k+31|0]=0,q(A,2,100,k+20|0),u[k+31|0]>=0)break r;Z(i[k+20>>2]);break r}if(!(u[r+20|0]&1))break f;if(u[k+20|0]=0,u[k+31|0]=0,q(A,2,100,k+20|0),u[k+31|0]>=0)break r;Z(i[k+20>>2]);break r}if(e=i[26917],i[A>>2]=i[26916],i[A+4>>2]=e,A=A+8|0,u[107683]>=0){e=i[26919],i[A>>2]=i[26918],i[A+4>>2]=e,i[A+8>>2]=i[26920];break r}T(A,i[26918],i[26919])}v=k+32|0;return}G0(),H()}z0(),H()}function QG(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,t=0,o=0,s=0;f=v-160|0,v=f,i[f+92>>2]=0,i[f+64>>2]=72500,k=i[18128],i[f+8>>2]=k,o=i[k-12>>2],k=f+8|0,i[o+k>>2]=i[18129],t=k+i[i[f+8>>2]-12>>2]|0,n=f+12|0,J0(t,n),u[t+80|0]=0,i[t+72>>2]=0,i[f+64>>2]=72500,i[f+8>>2]=72480,t=R0(n),i[t>>2]=71232,i[f+52>>2]=0,i[f+56>>2]=0,i[f+44>>2]=0,i[f+48>>2]=0,i[f+60>>2]=16,n=f+148|0,Y2(n,e,r),s=k,o=n,k=u[f+159|0],n=(k|0)<0,Y(s,n?i[f+148>>2]:o,n?i[f+152>>2]:k),u[f+159|0]<0&&Z(i[f+148>>2]),k=f+148|0,s0(k,r),o=k,r=u[f+159|0],k=(r|0)<0,Y(f+8|0,k?i[f+148>>2]:o,k?i[f+152>>2]:r),u[f+159|0]<0&&Z(i[f+148>>2]),Y(f+8|0,30573,18);i:{e:switch(i[e+100>>2]+1|0){case 1:Y(f+8|0,33216,9);break i;case 2:Y(f+8|0,33187,11);break i;case 0:break e;default:break i}Y(f+8|0,33421,8)}e=i[f+60>>2];i:{e:{if(e&16){r=i[f+56>>2],e=i[f+36>>2],r>>>0<e>>>0&&(i[f+56>>2]=e,r=e),e=f+32|0;break e}if(!(e&8)){r=0,u[A+11|0]=0;break i}r=i[f+28>>2],e=f+20|0}e:{if(k=i[e>>2],r=r-k|0,r>>>0<2147483640){if(r>>>0>=11){n=r|7,e=p(n+1|0),i[A+8>>2]=n-2147483647,i[A>>2]=e,i[A+4>>2]=r,A=e;break e}if(u[A+11|0]=r,r)break e;r=0;break i}Q0(),H()}if(!r)break i;x(A,k,r)}u[A+r|0]=0,A=i[18127],i[f+8>>2]=A,i[i[A-12>>2]+(f+8|0)>>2]=i[18130],i[t>>2]=71232,u[f+55|0]<0&&Z(i[f+44>>2]),E0(t),y0(f- -64|0),v=f+160|0}function wn(A,e){var r=0,f=0,k=0,n=0,t=0;f=v-16|0,v=f;i:{e:switch(k2(e-8|0,29)|0){case 0:if(!f4(A,1))break i;k=i[A>>2],e=i[A+4>>2],e&&(i[e+4>>2]=i[e+4>>2]+1);r:{if(!(W[i[i[k>>2]+16>>2]](k,f+6|0,1)|0)){i8(A),k=0;break r}k=l[f+6|0]}if(!e||(A=i[e+4>>2],i[e+4>>2]=A-1,A))break i;W[i[i[e>>2]+8>>2]](e),y(e);break i;case 1:if(!f4(A,2))break i;k=i[A>>2],e=i[A+4>>2],e&&(i[e+4>>2]=i[e+4>>2]+1);r:{if(!(W[i[i[k>>2]+16>>2]](k,f+7|0,2)|0)){i8(A),k=0;break r}A=l[f+7|0],k=l[f+8|0]|A<<8}if(!e||(A=i[e+4>>2],i[e+4>>2]=A-1,A))break i;W[i[i[e>>2]+8>>2]](e),y(e);break i;case 2:if(!f4(A,3))break i;e=i[A>>2],r=i[A+4>>2],r&&(i[r+4>>2]=i[r+4>>2]+1);r:{if(!(W[i[i[e>>2]+16>>2]](e,f+9|0,3)|0)){i8(A),n=0;break r}e=l[f+10|0],A=0,t=e<<8,e=l[f+9|0],k=l[f+11|0]|(e<<16|t),n=A|n}if(!r||(A=i[r+4>>2],i[r+4>>2]=A-1,A))break i;W[i[i[r>>2]+8>>2]](r),y(r);break i;case 3:if(!f4(A,4))break i;e=i[A>>2],r=i[A+4>>2],r&&(i[r+4>>2]=i[r+4>>2]+1);r:{if(!(W[i[i[e>>2]+16>>2]](e,f+12|0,4)|0)){i8(A),n=0;break r}e=l[f+13|0],A=0,t=e<<16,e=l[f+12|0],e=e<<24|t,t=A|k,A=l[f+14|0],k=l[f+15|0]|(A<<8|e),n=n|t}if(!r||(A=i[r+4>>2],i[r+4>>2]=A-1,A))break i;W[i[i[r>>2]+8>>2]](r),y(r);break i;case 7:break e;default:break i}k=Y4(A),n=l0}return v=f+16|0,l0=n,k}function gG(A,e,r,f,k,n){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0;var t=0,o=0,s=0;for(A=v-320|0,v=A,i[A+312>>2]=r,i[A+316>>2]=e,e=v-16|0,v=e,o=A+196|0,i[o>>2]=0,i[o+4>>2]=0,i[o+8>>2]=0,v=e+16|0,t=A+16|0,e=i[f+28>>2],i[t>>2]=e,(e|0)!=129576&&(i[e+4>>2]=i[e+4>>2]+1),e=c0(t,129752),W[i[i[e>>2]+48>>2]](e,77744,77770,A+208|0)|0,e2(t),e=v-16|0,v=e,r=A+184|0,i[r>>2]=0,i[r+4>>2]=0,i[r+8>>2]=0,v=e+16|0,W2(r,l[r+11|0]>>>7|0?(i[r+8>>2]&2147483647)-1|0:10),l[r+11|0]>>>7|0?e=i[r>>2]:e=r,i[A+180>>2]=e,i[A+12>>2]=t,i[A+8>>2]=0;;){i:{if(K2(A+316|0,A+312|0))break i;t=i[A+180>>2],l[r+11|0]>>>7|0?f=i[r+4>>2]:f=l[r+11|0]&127,(t|0)==(f+e|0)&&(l[r+11|0]>>>7|0?e=i[r+4>>2]:e=l[r+11|0]&127,l[r+11|0]>>>7|0?f=i[r+4>>2]:f=l[r+11|0]&127,W2(r,f<<1),W2(r,l[r+11|0]>>>7|0?(i[r+8>>2]&2147483647)-1|0:10),f=e,l[r+11|0]>>>7|0?e=i[r>>2]:e=r,i[A+180>>2]=f+e),s=A+316|0,f=i[s>>2],t=i[f+12>>2];e:{if((t|0)==i[f+16>>2]){f=W[i[i[f>>2]+36>>2]](f)|0;break e}f=i[t>>2]}if(ki(f,16,e,A+180|0,A+8|0,0,o,A+16|0,A+12|0,A+208|0))break i;a1(s);continue}break}return W2(r,i[A+180>>2]-e|0),l[r+11|0]>>>7|0?e=i[r>>2]:e=r,f=a2(),i[A>>2]=n,(Oo(e,f,A)|0)!=1&&(i[k>>2]=4),K2(A+316|0,A+312|0)&&(i[k>>2]=i[k>>2]|2),e=i[A+316>>2],s2(r),s2(o),v=A+320|0,e|0}function VG(A,e,r,f,k,n){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0;var t=0,o=0,s=0,w=0,h=0,_=0;for(A=v-336|0,v=A,i[A+328>>2]=r,i[A+332>>2]=e,o=y8(f),w=Fe(f,A+208|0),ge(A+196|0,f,A+324|0),r=v-16|0,v=r,e=A+184|0,i[e>>2]=0,i[e+4>>2]=0,i[e+8>>2]=0,v=r+16|0,W2(e,l[e+11|0]>>>7|0?(i[e+8>>2]&2147483647)-1|0:10),l[e+11|0]>>>7|0?r=i[e>>2]:r=e,i[A+180>>2]=r,i[A+12>>2]=A+16,i[A+8>>2]=0;;){i:{if(K2(A+332|0,A+328|0))break i;t=i[A+180>>2],l[e+11|0]>>>7|0?f=i[e+4>>2]:f=l[e+11|0]&127,(t|0)==(f+r|0)&&(l[e+11|0]>>>7|0?r=i[e+4>>2]:r=l[e+11|0]&127,l[e+11|0]>>>7|0?f=i[e+4>>2]:f=l[e+11|0]&127,W2(e,f<<1),W2(e,l[e+11|0]>>>7|0?(i[e+8>>2]&2147483647)-1|0:10),f=r,l[e+11|0]>>>7|0?r=i[e>>2]:r=e,i[A+180>>2]=f+r),t=A+332|0,f=i[t>>2],s=i[f+12>>2];e:{if((s|0)==i[f+16>>2]){f=W[i[i[f>>2]+36>>2]](f)|0;break e}f=i[s>>2]}if(ki(f,o,r,A+180|0,A+8|0,i[A+324>>2],A+196|0,A+16|0,A+12|0,w))break i;a1(t);continue}break}l[A+207|0]>>>7|0?f=i[A+200>>2]:f=l[A+207|0]&127;i:{if(!f||(f=i[A+12>>2],(f-(A+16|0)|0)>159))break i;i[A+12>>2]=f+4,i[f>>2]=i[A+8>>2]}return h=n,_=Iu(r,i[A+180>>2],k,o),i[h>>2]=_,i[n+4>>2]=l0,l4(A+196|0,A+16|0,i[A+12>>2],k),K2(A+332|0,A+328|0)&&(i[k>>2]=i[k>>2]|2),r=i[A+332>>2],s2(e),s2(A+196|0),v=A+336|0,r|0}function FG(A,e,r,f,k,n){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0;var t=0,o=0,s=0,w=0,h=0,_=0;for(A=v-336|0,v=A,i[A+328>>2]=r,i[A+332>>2]=e,o=y8(f),w=Fe(f,A+208|0),ge(A+196|0,f,A+324|0),r=v-16|0,v=r,e=A+184|0,i[e>>2]=0,i[e+4>>2]=0,i[e+8>>2]=0,v=r+16|0,W2(e,l[e+11|0]>>>7|0?(i[e+8>>2]&2147483647)-1|0:10),l[e+11|0]>>>7|0?r=i[e>>2]:r=e,i[A+180>>2]=r,i[A+12>>2]=A+16,i[A+8>>2]=0;;){i:{if(K2(A+332|0,A+328|0))break i;t=i[A+180>>2],l[e+11|0]>>>7|0?f=i[e+4>>2]:f=l[e+11|0]&127,(t|0)==(f+r|0)&&(l[e+11|0]>>>7|0?r=i[e+4>>2]:r=l[e+11|0]&127,l[e+11|0]>>>7|0?f=i[e+4>>2]:f=l[e+11|0]&127,W2(e,f<<1),W2(e,l[e+11|0]>>>7|0?(i[e+8>>2]&2147483647)-1|0:10),f=r,l[e+11|0]>>>7|0?r=i[e>>2]:r=e,i[A+180>>2]=f+r),t=A+332|0,f=i[t>>2],s=i[f+12>>2];e:{if((s|0)==i[f+16>>2]){f=W[i[i[f>>2]+36>>2]](f)|0;break e}f=i[s>>2]}if(ki(f,o,r,A+180|0,A+8|0,i[A+324>>2],A+196|0,A+16|0,A+12|0,w))break i;a1(t);continue}break}l[A+207|0]>>>7|0?f=i[A+200>>2]:f=l[A+207|0]&127;i:{if(!f||(f=i[A+12>>2],(f-(A+16|0)|0)>159))break i;i[A+12>>2]=f+4,i[f>>2]=i[A+8>>2]}return h=n,_=dt(r,i[A+180>>2],k,o),i[h>>2]=_,i[n+4>>2]=l0,l4(A+196|0,A+16|0,i[A+12>>2],k),K2(A+332|0,A+328|0)&&(i[k>>2]=i[k>>2]|2),r=i[A+332>>2],s2(e),s2(A+196|0),v=A+336|0,r|0}function IG(A,e,r,f,k,n,t,o){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,t=t|0,o=o|0;var s=0,w=0,h=0,_=0,B=0,m=0;s=v-256|0,v=s,i[s+248>>2]=37,i[s+252>>2]=0,h=s+248|0,_=Kr(h|1,19566,i[r+4>>2]),w=s+208|0,i[s+204>>2]=w,A=a2();i:{if(_){m=i[r+8>>2],B=s- -64|0,i[B>>2]=t,i[B+4>>2]=o,i[s+56>>2]=k,i[s+60>>2]=n,i[s+48>>2]=m,A=h4(w,30,A,h,s+48|0);break i}i[s+80>>2]=k,i[s+84>>2]=n,i[s+88>>2]=t,i[s+92>>2]=o,A=h4(s+208|0,30,A,s+248|0,s+80|0)}i[s+128>>2]=2071,h=Q1(s+196|0,0,s+128|0),w=s+208|0;i:{e:{if((A|0)>=30){A=a2();r:{if(_){w=i[r+8>>2],i[s+16>>2]=t,i[s+20>>2]=o,i[s+8>>2]=k,i[s+12>>2]=n,i[s>>2]=w,A=I8(s+204|0,A,s+248|0,s);break r}i[s+32>>2]=k,i[s+36>>2]=n,i[s+40>>2]=t,i[s+44>>2]=o,A=I8(s+204|0,A,s+248|0,s+32|0)}if((A|0)==-1)break e;k=i[h>>2],i[h>>2]=i[s+204>>2],k&&W[i[h+4>>2]](k),w=i[s+204>>2]}k=w,w=A+w|0,_=z4(k,w,r),i[s+128>>2]=2071,k=s+128|0,n=Q1(s+120|0,0,k),t=i[s+204>>2];r:{if((t|0)==(s+208|0)){A=k;break r}if(A=y2(A<<1),!A)break e;k=i[n>>2],i[n>>2]=A,k&&W[i[n+4>>2]](k),t=i[s+204>>2]}o=s+108|0,k=i[r+28>>2],i[o>>2]=k,(k|0)!=129576&&(i[k+4>>2]=i[k+4>>2]+1),en(t,_,w,A,s+116|0,s+112|0,o),e2(o),A=O8(e,A,i[s+116>>2],i[s+112>>2],r,f),e=i[n>>2],i[n>>2]=0,e&&W[i[n+4>>2]](e),e=i[h>>2],i[h>>2]=0,e&&W[i[h+4>>2]](e),v=s+256|0;break i}g1(),H()}return A|0}function CG(A,e,r,f,k,n,t,o){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,t=t|0,o=o|0;var s=0,w=0,h=0,_=0,B=0,m=0;s=v-416|0,v=s,i[s+408>>2]=37,i[s+412>>2]=0,h=s+408|0,_=Kr(h|1,19566,i[r+4>>2]),w=s+368|0,i[s+364>>2]=w,A=a2();i:{if(_){m=i[r+8>>2],B=s- -64|0,i[B>>2]=t,i[B+4>>2]=o,i[s+56>>2]=k,i[s+60>>2]=n,i[s+48>>2]=m,A=h4(w,30,A,h,s+48|0);break i}i[s+80>>2]=k,i[s+84>>2]=n,i[s+88>>2]=t,i[s+92>>2]=o,A=h4(s+368|0,30,A,s+408|0,s+80|0)}i[s+128>>2]=2071,h=Q1(s+356|0,0,s+128|0),w=s+368|0;i:{e:{if((A|0)>=30){A=a2();r:{if(_){w=i[r+8>>2],i[s+16>>2]=t,i[s+20>>2]=o,i[s+8>>2]=k,i[s+12>>2]=n,i[s>>2]=w,A=I8(s+364|0,A,s+408|0,s);break r}i[s+32>>2]=k,i[s+36>>2]=n,i[s+40>>2]=t,i[s+44>>2]=o,A=I8(s+364|0,A,s+408|0,s+32|0)}if((A|0)==-1)break e;k=i[h>>2],i[h>>2]=i[s+364>>2],k&&W[i[h+4>>2]](k),w=i[s+364>>2]}k=w,w=A+w|0,_=z4(k,w,r),i[s+128>>2]=2071,k=s+128|0,n=Q1(s+120|0,0,k),t=i[s+364>>2];r:{if((t|0)==(s+368|0)){A=k;break r}if(A=y2(A<<3),!A)break e;k=i[n>>2],i[n>>2]=A,k&&W[i[n+4>>2]](k),t=i[s+364>>2]}o=s+108|0,k=i[r+28>>2],i[o>>2]=k,(k|0)!=129576&&(i[k+4>>2]=i[k+4>>2]+1),b9(t,_,w,A,s+116|0,s+112|0,o),e2(o),A=j8(e,A,i[s+116>>2],i[s+112>>2],r,f),e=i[n>>2],i[n>>2]=0,e&&W[i[n+4>>2]](e),e=i[h>>2],i[h>>2]=0,e&&W[i[h+4>>2]](e),v=s+416|0;break i}g1(),H()}return A|0}function T8(A,e,r,f,k,n,t,o){var s=0,w=0,h=0,_=0,B=0;s=v-16|0,v=s,i[s+8>>2]=r,i[s+12>>2]=e,r=s+4|0,e=i[f+28>>2],i[r>>2]=e,(e|0)!=129576&&(i[e+4>>2]=i[e+4>>2]+1),w=c0(r,129752),e2(r),i[k>>2]=0,e=0;i:{for(;;){if(e|(t|0)==(o|0))break i;e:{if(K2(s+12|0,s+8|0))break e;r:{if((W[i[i[w>>2]+52>>2]](w,i[t>>2],0)|0)==37){if((t+4|0)==(o|0))break e;r=0;f:{A:{if(e=W[i[i[w>>2]+52>>2]](w,i[t+4>>2],0)|0,(e|0)==69||(h=4,(e&255)==48))break A;break f}if((t+8|0)==(o|0))break e;h=8,r=e,e=W[i[i[w>>2]+52>>2]](w,i[t+8>>2],0)|0}_=s,B=W[i[i[A>>2]+36>>2]](A,i[s+12>>2],i[s+8>>2],f,k,n,e,r)|0,i[_+12>>2]=B,t=(t+h|0)+4|0;break r}if(W[i[i[w>>2]+12>>2]](w,1,i[t>>2])|0){for(;t=t+4|0,!!((o|0)!=(t|0)&&W[i[i[w>>2]+12>>2]](w,1,i[t>>2])|0););for(;;){if(r=s+12|0,K2(r,s+8|0))break r;e=i[r>>2],h=i[e+12>>2];f:{if((h|0)==i[e+16>>2]){e=W[i[i[e>>2]+36>>2]](e)|0;break f}e=i[h>>2]}if(!(W[i[i[w>>2]+12>>2]](w,1,e)|0))break r;a1(r)}}h=s+12|0,e=i[h>>2],r=i[e+12>>2];f:{if((r|0)==i[e+16>>2]){e=W[i[i[e>>2]+36>>2]](e)|0;break f}e=i[r>>2]}if((W[i[i[w>>2]+28>>2]](w,e)|0)==(W[i[i[w>>2]+28>>2]](w,i[t>>2])|0)){t=t+4|0,a1(h);break r}i[k>>2]=4}e=i[k>>2];continue}break}i[k>>2]=4}return K2(s+12|0,s+8|0)&&(i[k>>2]=i[k>>2]|2),v=s+16|0,i[s+12>>2]}function hn(A,e){var r=0,f=0,k=0,n=0,t=0;i:{e:{r:{f:{A:{r=i[A+4>>2];k:{if((r|0)!=i[A+104>>2]){i[A+4>>2]=r+1,r=l[r|0];break k}r=j2(A)}switch(r-43|0){case 0:case 2:break A;default:break f}}t=(r|0)==45,e=!e,r=i[A+4>>2];A:{if((r|0)!=i[A+104>>2]){i[A+4>>2]=r+1,r=l[r|0];break A}r=j2(A)}if(f=r-58|0,e|f>>>0>4294967285)break r;if(i[A+116>>2]<0)break e;i[A+4>>2]=i[A+4>>2]-1;break e}f=r-58|0}if(f>>>0<4294967286)break e;r:{if(r-48>>>0>=10)break r;for(;;){k=(G(k,10)+r|0)-48|0,n=(k|0)<214748364,r=i[A+4>>2];f:{if((r|0)!=i[A+104>>2]){i[A+4>>2]=r+1,r=l[r|0];break f}r=j2(A)}if(e=r-48|0,!(n&e>>>0<=9))break}if(n=k>>31,e>>>0>=10)break r;for(;;){e=r,r=O0(k,n,10,0),f=e+r|0,e=l0,k=f-48|0,f=(r>>>0>f>>>0?e+1|0:e)-(f>>>0<48)|0,n=f,f=k>>>0<2061584302&(f|0)<=21474836|(f|0)<21474836,r=i[A+4>>2];f:{if((r|0)!=i[A+104>>2]){i[A+4>>2]=r+1,r=l[r|0];break f}r=j2(A)}if(e=r-48|0,!(f&e>>>0<=9))break}if(e>>>0>=10)break r;for(;;){e=i[A+4>>2];f:{if((e|0)!=i[A+104>>2]){i[A+4>>2]=e+1,e=l[e|0];break f}e=j2(A)}if(!(e-48>>>0<10))break}}e=i[A+116>>2],(e|0)>0?e=1:e=(e|0)>=0,e&&(i[A+4>>2]=i[A+4>>2]-1),A=k,k=t?0-A|0:A,n=t?0-(((A|0)!=0)+n|0)|0:n;break i}if(n=-2147483648,i[A+116>>2]<0)break i;return i[A+4>>2]=i[A+4>>2]-1,l0=-2147483648,0}return l0=n,k}function pG(A,e,r,f,k,n){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0;var t=0,o=0,s=0,w=0,h=0;for(A=v-256|0,v=A,i[A+248>>2]=r,i[A+252>>2]=e,o=y8(f),Ve(A+196|0,f,A+247|0),r=v-16|0,v=r,e=A+184|0,i[e>>2]=0,i[e+4>>2]=0,i[e+8>>2]=0,v=r+16|0,W2(e,l[e+11|0]>>>7|0?(i[e+8>>2]&2147483647)-1|0:10),l[e+11|0]>>>7|0?r=i[e>>2]:r=e,i[A+180>>2]=r,i[A+12>>2]=A+16,i[A+8>>2]=0;;){i:{if(L2(A+252|0,A+248|0))break i;t=i[A+180>>2],l[e+11|0]>>>7|0?f=i[e+4>>2]:f=l[e+11|0]&127,(t|0)==(f+r|0)&&(l[e+11|0]>>>7|0?r=i[e+4>>2]:r=l[e+11|0]&127,l[e+11|0]>>>7|0?f=i[e+4>>2]:f=l[e+11|0]&127,W2(e,f<<1),W2(e,l[e+11|0]>>>7|0?(i[e+8>>2]&2147483647)-1|0:10),f=r,l[e+11|0]>>>7|0?r=i[e>>2]:r=e,i[A+180>>2]=f+r),t=A+252|0,f=i[t>>2],s=i[f+12>>2];e:{if((s|0)==i[f+16>>2]){f=W[i[i[f>>2]+36>>2]](f)|0;break e}f=u[s|0]}if(Ai(f<<24>>24,o,r,A+180|0,A+8|0,u[A+247|0],A+196|0,A+16|0,A+12|0,77744))break i;q1(t);continue}break}l[A+207|0]>>>7|0?f=i[A+200>>2]:f=l[A+207|0]&127;i:{if(!f||(f=i[A+12>>2],(f-(A+16|0)|0)>159))break i;i[A+12>>2]=f+4,i[f>>2]=i[A+8>>2]}return w=n,h=Iu(r,i[A+180>>2],k,o),i[w>>2]=h,i[n+4>>2]=l0,l4(A+196|0,A+16|0,i[A+12>>2],k),L2(A+252|0,A+248|0)&&(i[k>>2]=i[k>>2]|2),r=i[A+252>>2],s2(e),s2(A+196|0),v=A+256|0,r|0}function yG(A,e,r,f,k,n){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0;var t=0,o=0,s=0,w=0,h=0;for(A=v-256|0,v=A,i[A+248>>2]=r,i[A+252>>2]=e,o=y8(f),Ve(A+196|0,f,A+247|0),r=v-16|0,v=r,e=A+184|0,i[e>>2]=0,i[e+4>>2]=0,i[e+8>>2]=0,v=r+16|0,W2(e,l[e+11|0]>>>7|0?(i[e+8>>2]&2147483647)-1|0:10),l[e+11|0]>>>7|0?r=i[e>>2]:r=e,i[A+180>>2]=r,i[A+12>>2]=A+16,i[A+8>>2]=0;;){i:{if(L2(A+252|0,A+248|0))break i;t=i[A+180>>2],l[e+11|0]>>>7|0?f=i[e+4>>2]:f=l[e+11|0]&127,(t|0)==(f+r|0)&&(l[e+11|0]>>>7|0?r=i[e+4>>2]:r=l[e+11|0]&127,l[e+11|0]>>>7|0?f=i[e+4>>2]:f=l[e+11|0]&127,W2(e,f<<1),W2(e,l[e+11|0]>>>7|0?(i[e+8>>2]&2147483647)-1|0:10),f=r,l[e+11|0]>>>7|0?r=i[e>>2]:r=e,i[A+180>>2]=f+r),t=A+252|0,f=i[t>>2],s=i[f+12>>2];e:{if((s|0)==i[f+16>>2]){f=W[i[i[f>>2]+36>>2]](f)|0;break e}f=u[s|0]}if(Ai(f<<24>>24,o,r,A+180|0,A+8|0,u[A+247|0],A+196|0,A+16|0,A+12|0,77744))break i;q1(t);continue}break}l[A+207|0]>>>7|0?f=i[A+200>>2]:f=l[A+207|0]&127;i:{if(!f||(f=i[A+12>>2],(f-(A+16|0)|0)>159))break i;i[A+12>>2]=f+4,i[f>>2]=i[A+8>>2]}return w=n,h=dt(r,i[A+180>>2],k,o),i[w>>2]=h,i[n+4>>2]=l0,l4(A+196|0,A+16|0,i[A+12>>2],k),L2(A+252|0,A+248|0)&&(i[k>>2]=i[k>>2]|2),r=i[A+252>>2],s2(e),s2(A+196|0),v=A+256|0,r|0}function EG(A,e,r,f,k,n){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0;var t=0,o=0,s=0,w=0,h=0,_=0;for(A=v-336|0,v=A,i[A+328>>2]=r,i[A+332>>2]=e,o=y8(f),w=Fe(f,A+208|0),ge(A+196|0,f,A+324|0),r=v-16|0,v=r,e=A+184|0,i[e>>2]=0,i[e+4>>2]=0,i[e+8>>2]=0,v=r+16|0,W2(e,l[e+11|0]>>>7|0?(i[e+8>>2]&2147483647)-1|0:10),l[e+11|0]>>>7|0?r=i[e>>2]:r=e,i[A+180>>2]=r,i[A+12>>2]=A+16,i[A+8>>2]=0;;){i:{if(K2(A+332|0,A+328|0))break i;t=i[A+180>>2],l[e+11|0]>>>7|0?f=i[e+4>>2]:f=l[e+11|0]&127,(t|0)==(f+r|0)&&(l[e+11|0]>>>7|0?r=i[e+4>>2]:r=l[e+11|0]&127,l[e+11|0]>>>7|0?f=i[e+4>>2]:f=l[e+11|0]&127,W2(e,f<<1),W2(e,l[e+11|0]>>>7|0?(i[e+8>>2]&2147483647)-1|0:10),f=r,l[e+11|0]>>>7|0?r=i[e>>2]:r=e,i[A+180>>2]=f+r),t=A+332|0,f=i[t>>2],s=i[f+12>>2];e:{if((s|0)==i[f+16>>2]){f=W[i[i[f>>2]+36>>2]](f)|0;break e}f=i[s>>2]}if(ki(f,o,r,A+180|0,A+8|0,i[A+324>>2],A+196|0,A+16|0,A+12|0,w))break i;a1(t);continue}break}l[A+207|0]>>>7|0?f=i[A+200>>2]:f=l[A+207|0]&127;i:{if(!f||(f=i[A+12>>2],(f-(A+16|0)|0)>159))break i;i[A+12>>2]=f+4,i[f>>2]=i[A+8>>2]}return h=n,_=iu(r,i[A+180>>2],k,o),g[h>>1]=_,l4(A+196|0,A+16|0,i[A+12>>2],k),K2(A+332|0,A+328|0)&&(i[k>>2]=i[k>>2]|2),r=i[A+332>>2],s2(e),s2(A+196|0),v=A+336|0,r|0}function YG(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,t=0,o=0,s=0,w=0,h=0,_=0,B=0,m=0,X=0,Q=0,V=0,F=0,I=0,E=0,R=0;Q=v-80|0,v=Q;i:{if(!(r&&e)){e=i[23570],i[A>>2]=i[23569],i[A+4>>2]=e,i[A+8>>2]=i[23571];break i}f=Q+8|0,i[f>>2]=0,i[f+4>>2]=0,i[f+40>>2]=0,i[f+44>>2]=0,i[f+32>>2]=0,i[f+36>>2]=0,i[f+24>>2]=0,i[f+28>>2]=0,i[f+16>>2]=0,i[f+20>>2]=0,i[f+8>>2]=0,i[f+12>>2]=0;e:{if(l[e+12|0]==1){k=t0[e+24>>3],n=t0[e+32>>3],w=k*n,t=t0[e+16>>3],s=t0[e+40>>3],_=t*s,o=w-_,t0[f+40>>3]=o+o,o=t*k,B=n*s,h=o+B,t0[f+24>>3]=h+h,h=t*n,s=k*s,m=h+s,t0[f+16>>3]=m+m,o=o-B,t0[f+8>>3]=o+o,t=t*t,n=n*n,o=t+n,t0[f+32>>3]=1-(o+o),o=k*k,k=o+n,t0[f>>3]=1-(k+k),n=t+o,n=1-(n+n),t=w+_,t=t+t,k=h-s,k=k+k;break e}k=t0[e+56>>3]*.017453292519943295,t=FA(k),s=VA(k),n=t0[e+48>>3]*.017453292519943295,k=FA(n),n=VA(n),w=t0[e+64>>3],o=s*0,F=o+(0-t),_=F*0,B=t*0+(s+0),t0[f+24>>3]=_+(k*B+n*0),t0[f>>3]=_+(n*B+k*-0),w=w*.017453292519943295,_=VA(w),X=t*-0,w=FA(w),h=w*-0,I=s*_+(X+h),E=I*0,h=t*_+(o+h),m=_*0,V=m+(0-w),t0[f+40>>3]=E+(k*h+n*V),X=s*w+(X+m),R=X*0,t=t*w+(o+m),s=w*0+(_+0),t0[f+32>>3]=R+(k*t+n*s),t0[f+16>>3]=E+(n*h-V*k),t0[f+8>>3]=R+(n*t-s*k),n=I+(h*0+V*0),t=X+(t*0+s*0),k=F+(B*0+0)}t0[f+64>>3]=n,t0[f+56>>3]=t,t0[f+48>>3]=k,x(r,f,72),i[A+8>>2]=i[24058],e=i[24057],i[A>>2]=i[24056],i[A+4>>2]=e}v=Q+80|0}function RG(A,e,r,f,k){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0;var n=0,t=0,o=0,s=0,w=0,h=0,_=0,B=0,m=0,X=0;s=v-16|0,v=s,n=p(40),i[n+16>>2]=1,i[n+4>>2]=0,i[n+8>>2]=0,i[n+20>>2]=0,i[n+24>>2]=0,i[n+12>>2]=95892,i[n>>2]=96100,i[n+28>>2]=0,i[n+32>>2]=0,i[n+36>>2]=0,_=n+12|0;i:{if(!f||(ui(n+20|0,f),(f|0)<=0))break i;if(o=i[n+20>>2],(f|0)!=1)for(X=f&2147483646;t=h<<3,w=t+o|0,B=r+t|0,i[w>>2]=i[B>>2],i[w+4>>2]=i[B+4>>2],t=t|8,w=t+o|0,t=r+t|0,i[w>>2]=i[t>>2],i[w+4>>2]=i[t+4>>2],h=h+2|0,m=m+2|0,(X|0)!=(m|0););if(!(f&1))break i;f=h<<3,o=f+o|0,r=r+f|0,i[o>>2]=i[r>>2],i[o+4>>2]=i[r+4>>2]}u[n+16|0]=1,r=i[e+8>>2],i[s+12>>2]=n,i[s+8>>2]=_,i[n+4>>2]=i[n+4>>2]+1,r2(r+12|0,s+8|0),r=i[s+12>>2];i:{if(!r||(f=i[r+4>>2],i[r+4>>2]=f-1,f))break i;W[i[i[r>>2]+8>>2]](r),y(r)}i:{if(!k||(i[n+4>>2]=i[n+4>>2]+1,r=p(24),i[n+4>>2]=i[n+4>>2]+1,i[r+20>>2]=n,i[r+16>>2]=_,o=i[e+8>>2],f=i[e+12>>2],f&&(i[f+4>>2]=i[f+4>>2]+1),i[r+12>>2]=f,i[r+8>>2]=o,f=i[e>>2],e=i[e+4>>2],e&&(i[e+4>>2]=i[e+4>>2]+1),i[r+4>>2]=e,i[r>>2]=f,i[k>>2]=r,e=i[n+4>>2],i[n+4>>2]=e-1,e))break i;W[i[i[n>>2]+8>>2]](n),y(n)}e=i[24057],i[A>>2]=i[24056],i[A+4>>2]=e,i[A+8>>2]=i[24058],A=i[n+4>>2],i[n+4>>2]=A-1,A||(W[i[i[n>>2]+8>>2]](n),y(n)),v=s+16|0}function JG(A,e,r,f,k){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0;var n=0,t=0,o=0,s=0,w=0,h=0,_=0,B=0,m=0,X=0;s=v-16|0,v=s,n=p(40),i[n+16>>2]=1,i[n+4>>2]=0,i[n+8>>2]=0,i[n+20>>2]=0,i[n+24>>2]=0,i[n+12>>2]=95892,i[n>>2]=96100,i[n+28>>2]=0,i[n+32>>2]=0,i[n+36>>2]=0,_=n+12|0;i:{if(!f||(ui(n+20|0,f),(f|0)<=0))break i;if(o=i[n+20>>2],(f|0)!=1)for(X=f&2147483646;t=h<<3,w=t+o|0,B=r+t|0,i[w>>2]=i[B>>2],i[w+4>>2]=i[B+4>>2],t=t|8,w=t+o|0,t=r+t|0,i[w>>2]=i[t>>2],i[w+4>>2]=i[t+4>>2],h=h+2|0,m=m+2|0,(X|0)!=(m|0););if(!(f&1))break i;f=h<<3,o=f+o|0,r=r+f|0,i[o>>2]=i[r>>2],i[o+4>>2]=i[r+4>>2]}u[n+16|0]=0,r=i[e+8>>2],i[s+12>>2]=n,i[s+8>>2]=_,i[n+4>>2]=i[n+4>>2]+1,r2(r+12|0,s+8|0),r=i[s+12>>2];i:{if(!r||(f=i[r+4>>2],i[r+4>>2]=f-1,f))break i;W[i[i[r>>2]+8>>2]](r),y(r)}i:{if(!k||(i[n+4>>2]=i[n+4>>2]+1,r=p(24),i[n+4>>2]=i[n+4>>2]+1,i[r+20>>2]=n,i[r+16>>2]=_,o=i[e+8>>2],f=i[e+12>>2],f&&(i[f+4>>2]=i[f+4>>2]+1),i[r+12>>2]=f,i[r+8>>2]=o,f=i[e>>2],e=i[e+4>>2],e&&(i[e+4>>2]=i[e+4>>2]+1),i[r+4>>2]=e,i[r>>2]=f,i[k>>2]=r,e=i[n+4>>2],i[n+4>>2]=e-1,e))break i;W[i[i[n>>2]+8>>2]](n),y(n)}e=i[24057],i[A>>2]=i[24056],i[A+4>>2]=e,i[A+8>>2]=i[24058],A=i[n+4>>2],i[n+4>>2]=A-1,A||(W[i[i[n>>2]+8>>2]](n),y(n)),v=s+16|0}function _n(A,e,r,f,k,n){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0;var t=0,o=0,s=0,w=0,h=0,_=0;for(A=v-336|0,v=A,i[A+328>>2]=r,i[A+332>>2]=e,o=y8(f),w=Fe(f,A+208|0),ge(A+196|0,f,A+324|0),r=v-16|0,v=r,e=A+184|0,i[e>>2]=0,i[e+4>>2]=0,i[e+8>>2]=0,v=r+16|0,W2(e,l[e+11|0]>>>7|0?(i[e+8>>2]&2147483647)-1|0:10),l[e+11|0]>>>7|0?r=i[e>>2]:r=e,i[A+180>>2]=r,i[A+12>>2]=A+16,i[A+8>>2]=0;;){i:{if(K2(A+332|0,A+328|0))break i;t=i[A+180>>2],l[e+11|0]>>>7|0?f=i[e+4>>2]:f=l[e+11|0]&127,(t|0)==(f+r|0)&&(l[e+11|0]>>>7|0?r=i[e+4>>2]:r=l[e+11|0]&127,l[e+11|0]>>>7|0?f=i[e+4>>2]:f=l[e+11|0]&127,W2(e,f<<1),W2(e,l[e+11|0]>>>7|0?(i[e+8>>2]&2147483647)-1|0:10),f=r,l[e+11|0]>>>7|0?r=i[e>>2]:r=e,i[A+180>>2]=f+r),t=A+332|0,f=i[t>>2],s=i[f+12>>2];e:{if((s|0)==i[f+16>>2]){f=W[i[i[f>>2]+36>>2]](f)|0;break e}f=i[s>>2]}if(ki(f,o,r,A+180|0,A+8|0,i[A+324>>2],A+196|0,A+16|0,A+12|0,w))break i;a1(t);continue}break}l[A+207|0]>>>7|0?f=i[A+200>>2]:f=l[A+207|0]&127;i:{if(!f||(f=i[A+12>>2],(f-(A+16|0)|0)>159))break i;i[A+12>>2]=f+4,i[f>>2]=i[A+8>>2]}return h=n,_=uu(r,i[A+180>>2],k,o),i[h>>2]=_,l4(A+196|0,A+16|0,i[A+12>>2],k),K2(A+332|0,A+328|0)&&(i[k>>2]=i[k>>2]|2),r=i[A+332>>2],s2(e),s2(A+196|0),v=A+336|0,r|0}function NG(A,e,r,f,k,n){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0;var t=0,o=0,s=0,w=0,h=0,_=0;for(A=v-336|0,v=A,i[A+328>>2]=r,i[A+332>>2]=e,o=y8(f),w=Fe(f,A+208|0),ge(A+196|0,f,A+324|0),r=v-16|0,v=r,e=A+184|0,i[e>>2]=0,i[e+4>>2]=0,i[e+8>>2]=0,v=r+16|0,W2(e,l[e+11|0]>>>7|0?(i[e+8>>2]&2147483647)-1|0:10),l[e+11|0]>>>7|0?r=i[e>>2]:r=e,i[A+180>>2]=r,i[A+12>>2]=A+16,i[A+8>>2]=0;;){i:{if(K2(A+332|0,A+328|0))break i;t=i[A+180>>2],l[e+11|0]>>>7|0?f=i[e+4>>2]:f=l[e+11|0]&127,(t|0)==(f+r|0)&&(l[e+11|0]>>>7|0?r=i[e+4>>2]:r=l[e+11|0]&127,l[e+11|0]>>>7|0?f=i[e+4>>2]:f=l[e+11|0]&127,W2(e,f<<1),W2(e,l[e+11|0]>>>7|0?(i[e+8>>2]&2147483647)-1|0:10),f=r,l[e+11|0]>>>7|0?r=i[e>>2]:r=e,i[A+180>>2]=f+r),t=A+332|0,f=i[t>>2],s=i[f+12>>2];e:{if((s|0)==i[f+16>>2]){f=W[i[i[f>>2]+36>>2]](f)|0;break e}f=i[s>>2]}if(ki(f,o,r,A+180|0,A+8|0,i[A+324>>2],A+196|0,A+16|0,A+12|0,w))break i;a1(t);continue}break}l[A+207|0]>>>7|0?f=i[A+200>>2]:f=l[A+207|0]&127;i:{if(!f||(f=i[A+12>>2],(f-(A+16|0)|0)>159))break i;i[A+12>>2]=f+4,i[f>>2]=i[A+8>>2]}return h=n,_=ct(r,i[A+180>>2],k,o),i[h>>2]=_,l4(A+196|0,A+16|0,i[A+12>>2],k),K2(A+332|0,A+328|0)&&(i[k>>2]=i[k>>2]|2),r=i[A+332>>2],s2(e),s2(A+196|0),v=A+336|0,r|0}function UG(A,e,r,f,k,n,t){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,t=t|0;var o=0,s=0,w=0,h=0,_=0;A=v-624|0,v=A,i[A+616>>2]=r,i[A+620>>2]=e,i[A+16>>2]=2072,e=A+16|0,s=Q1(A+200|0,A+208|0,e),w=A+192|0,o=i[k+28>>2],i[w>>2]=o,(o|0)!=129576&&(i[o+4>>2]=i[o+4>>2]+1),o=c0(w,129752),u[A+191|0]=0;i:{if(!L7(A+620|0,r,f,w,i[k+4>>2],n,A+191|0,o,s,A+196|0,A+608|0))break i;r=l[21089]|l[21090]<<8|(l[21091]<<16|l[21092]<<24),u[A+183|0]=r,u[A+184|0]=r>>>8,u[A+185|0]=r>>>16,u[A+186|0]=r>>>24,r=l[21086]|l[21087]<<8|(l[21088]<<16|l[21089]<<24),i[A+176>>2]=l[21082]|l[21083]<<8|(l[21084]<<16|l[21085]<<24),i[A+180>>2]=r,W[i[i[o>>2]+48>>2]](o,A+176|0,A+186|0,A+128|0)|0,i[A+16>>2]=2071,f=Q1(A+8|0,0,e),k=e;e:{if(e=i[A+196>>2]-i[s>>2]|0,(e|0)>=393&&(r=y2((e>>2)+2|0),e=i[f>>2],i[f>>2]=r,e&&W[i[f+4>>2]](e),k=i[f>>2],!k))break e;for(l[A+191|0]==1&&(u[k|0]=45,k=k+1|0),r=i[s>>2];;){if(u0[A+196>>2]<=r>>>0)r:{if(u[k|0]=0,i[A>>2]=t,(cl(A+16|0,A)|0)!=1)break r;e=i[f>>2],i[f>>2]=0,e&&W[i[f+4>>2]](e);break i}else{e=A+128|0,h=k,_=l[(A+176|0)+(_5(e,e+40|0,r)-e>>2)|0],u[h|0]=_,k=k+1|0,r=r+4|0;continue}break}g1(),H()}g1(),H()}return K2(A+620|0,A+616|0)&&(i[n>>2]=i[n>>2]|2),r=i[A+620>>2],e2(A+192|0),e=i[s>>2],i[s>>2]=0,e&&W[i[s+4>>2]](e),v=A+624|0,r|0}function DG(A){A=A|0;var e=0,r=0,f=0,k=0,n=0;k=v-16|0,v=k;i:{if(!i[A+64>>2])break i;e:{if(f=i[A+68>>2],f){if(r=i[A+92>>2],r&16){if(i[A+24>>2]!=i[A+20>>2]&&(e=-1,(W[i[i[A>>2]+52>>2]](A,-1)|0)==-1))break i;for(f=A+72|0;;){if(e=i[A+68>>2],r=i[A+32>>2],r=W[i[i[e>>2]+20>>2]](e,f,r,r+i[A+52>>2]|0,k+12|0)|0,n=i[A+32>>2],e=i[k+12>>2]-n|0,(P1(n,1,e,i[A+64>>2])|0)!=(e|0))break e;r:switch(r-1|0){case 1:break e;case 0:continue;default:break r}break}if(e=0,!n6(i[A+64>>2]))break i;break e}if(!(r&8))break i;e=i[A+84>>2],i[k>>2]=i[A+80>>2],i[k+4>>2]=e;r:{f:{A:{if(l[A+98|0]==1){e=i[A+16>>2]-i[A+12>>2]|0,f=e>>31;break A}if(r=W[i[i[f>>2]+24>>2]](f)|0,e=i[A+40>>2]-i[A+36>>2]|0,f=e>>31,(r|0)>0){r=G(r,i[A+16>>2]-i[A+12>>2]|0),f=f+(r>>31)|0,n=e,e=e+r|0,f=n>>>0>e>>>0?f+1|0:f;break A}if(i[A+12>>2]!=i[A+16>>2])break f}r=0;break r}r=i[A+68>>2],r=W[i[i[r>>2]+32>>2]](r,k,i[A+32>>2],i[A+36>>2],i[A+12>>2]-i[A+8>>2]|0)|0,r=i[A+36>>2]-(r+i[A+32>>2]|0)|0,f=f+(r>>31)|0,n=e,e=e+r|0,f=n>>>0>e>>>0?f+1|0:f,r=1}if(X3(i[A+64>>2],0-e|0,0-(f+((e|0)!=0)|0)|0,1))break e;r&&(e=i[k+4>>2],i[A+72>>2]=i[k>>2],i[A+76>>2]=e),e=i[A+32>>2],i[A+40>>2]=e,i[A+36>>2]=e,e=0,i[A+16>>2]=0,i[A+12>>2]=0,i[A+8>>2]=0,i[A+92>>2]=0;break i}g1(),H()}e=-1}return v=k+16|0,e|0}function MG(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0;var k=0,n=0,t=0;k=v-80|0,v=k,W[i[i[e>>2]+112>>2]](k+48|0,e);i:{e:switch(l[k+68|0]){default:_2(),H();case 1:if(e=i[k+52>>2],i[A>>2]=i[k+48>>2],i[A+4>>2]=e,A=A+8|0,u[k+67|0]>=0){e=i[k+60>>2],i[A>>2]=i[k+56>>2],i[A+4>>2]=e,i[A+8>>2]=i[k+64>>2];break i}T(A,i[k+56>>2],i[k+60>>2]);break i;case 0:break e}t=i[k+48>>2],n=i[k+52>>2],n&&(i[n+4>>2]=i[n+4>>2]+1),W[i[i[t>>2]+20>>2]](k+24|0,t,r,f);e:{if(i[k+24>>2]){e=i[k+28>>2],i[A>>2]=i[k+24>>2],i[A+4>>2]=e,i[A+16>>2]=i[k+40>>2],e=i[k+36>>2],i[A+8>>2]=i[k+32>>2],i[A+12>>2]=e,i[k+40>>2]=0,i[k+32>>2]=0,i[k+36>>2]=0;break e}i[r>>2]|C[e+10>>1]||(i[r>>2]=1,i[f>>2]=3),e=i[26917],i[k>>2]=i[26916],i[k+4>>2]=e,e=k+8|0;r:{if(u[107683]>=0){r=i[26919],i[e>>2]=i[26918],i[e+4>>2]=r,i[e+8>>2]=i[26920];break r}T(e,i[26918],i[26919])}if(u[k+19|0]<0&&Z(i[k+8>>2]),e=i[26917],i[A>>2]=i[26916],i[A+4>>2]=e,A=A+8|0,u[107683]>=0){e=i[26919],i[A>>2]=i[26918],i[A+4>>2]=e,i[A+8>>2]=i[26920];break e}T(A,i[26918],i[26919])}if(u[k+43|0]<0&&Z(i[k+32>>2]),!n||(A=i[n+4>>2],i[n+4>>2]=A-1,A))break i;W[i[i[n>>2]+8>>2]](n),y(n)}A=l[k+68|0],(A|0)!=255&&(e=i[25177],i[k+24>>2]=i[25176],i[k+28>>2]=e,W[i[(k+24|0)+(A<<2)>>2]](k+79|0,k+48|0)),v=k+80|0}function Bn(A,e,r,f,k,n){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0;var t=0,o=0,s=0,w=0,h=0;for(A=v-256|0,v=A,i[A+248>>2]=r,i[A+252>>2]=e,o=y8(f),Ve(A+196|0,f,A+247|0),r=v-16|0,v=r,e=A+184|0,i[e>>2]=0,i[e+4>>2]=0,i[e+8>>2]=0,v=r+16|0,W2(e,l[e+11|0]>>>7|0?(i[e+8>>2]&2147483647)-1|0:10),l[e+11|0]>>>7|0?r=i[e>>2]:r=e,i[A+180>>2]=r,i[A+12>>2]=A+16,i[A+8>>2]=0;;){i:{if(L2(A+252|0,A+248|0))break i;t=i[A+180>>2],l[e+11|0]>>>7|0?f=i[e+4>>2]:f=l[e+11|0]&127,(t|0)==(f+r|0)&&(l[e+11|0]>>>7|0?r=i[e+4>>2]:r=l[e+11|0]&127,l[e+11|0]>>>7|0?f=i[e+4>>2]:f=l[e+11|0]&127,W2(e,f<<1),W2(e,l[e+11|0]>>>7|0?(i[e+8>>2]&2147483647)-1|0:10),f=r,l[e+11|0]>>>7|0?r=i[e>>2]:r=e,i[A+180>>2]=f+r),t=A+252|0,f=i[t>>2],s=i[f+12>>2];e:{if((s|0)==i[f+16>>2]){f=W[i[i[f>>2]+36>>2]](f)|0;break e}f=u[s|0]}if(Ai(f<<24>>24,o,r,A+180|0,A+8|0,u[A+247|0],A+196|0,A+16|0,A+12|0,77744))break i;q1(t);continue}break}l[A+207|0]>>>7|0?f=i[A+200>>2]:f=l[A+207|0]&127;i:{if(!f||(f=i[A+12>>2],(f-(A+16|0)|0)>159))break i;i[A+12>>2]=f+4,i[f>>2]=i[A+8>>2]}return w=n,h=uu(r,i[A+180>>2],k,o),i[w>>2]=h,l4(A+196|0,A+16|0,i[A+12>>2],k),L2(A+252|0,A+248|0)&&(i[k>>2]=i[k>>2]|2),r=i[A+252>>2],s2(e),s2(A+196|0),v=A+256|0,r|0}function HG(A,e,r,f,k,n){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0;var t=0,o=0,s=0,w=0,h=0;for(A=v-256|0,v=A,i[A+248>>2]=r,i[A+252>>2]=e,o=y8(f),Ve(A+196|0,f,A+247|0),r=v-16|0,v=r,e=A+184|0,i[e>>2]=0,i[e+4>>2]=0,i[e+8>>2]=0,v=r+16|0,W2(e,l[e+11|0]>>>7|0?(i[e+8>>2]&2147483647)-1|0:10),l[e+11|0]>>>7|0?r=i[e>>2]:r=e,i[A+180>>2]=r,i[A+12>>2]=A+16,i[A+8>>2]=0;;){i:{if(L2(A+252|0,A+248|0))break i;t=i[A+180>>2],l[e+11|0]>>>7|0?f=i[e+4>>2]:f=l[e+11|0]&127,(t|0)==(f+r|0)&&(l[e+11|0]>>>7|0?r=i[e+4>>2]:r=l[e+11|0]&127,l[e+11|0]>>>7|0?f=i[e+4>>2]:f=l[e+11|0]&127,W2(e,f<<1),W2(e,l[e+11|0]>>>7|0?(i[e+8>>2]&2147483647)-1|0:10),f=r,l[e+11|0]>>>7|0?r=i[e>>2]:r=e,i[A+180>>2]=f+r),t=A+252|0,f=i[t>>2],s=i[f+12>>2];e:{if((s|0)==i[f+16>>2]){f=W[i[i[f>>2]+36>>2]](f)|0;break e}f=u[s|0]}if(Ai(f<<24>>24,o,r,A+180|0,A+8|0,u[A+247|0],A+196|0,A+16|0,A+12|0,77744))break i;q1(t);continue}break}l[A+207|0]>>>7|0?f=i[A+200>>2]:f=l[A+207|0]&127;i:{if(!f||(f=i[A+12>>2],(f-(A+16|0)|0)>159))break i;i[A+12>>2]=f+4,i[f>>2]=i[A+8>>2]}return w=n,h=ct(r,i[A+180>>2],k,o),i[w>>2]=h,l4(A+196|0,A+16|0,i[A+12>>2],k),L2(A+252|0,A+248|0)&&(i[k>>2]=i[k>>2]|2),r=i[A+252>>2],s2(e),s2(A+196|0),v=A+256|0,r|0}function zG(A,e,r,f,k,n){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0;var t=0,o=0,s=0,w=0,h=0;for(A=v-256|0,v=A,i[A+248>>2]=r,i[A+252>>2]=e,o=y8(f),Ve(A+196|0,f,A+247|0),r=v-16|0,v=r,e=A+184|0,i[e>>2]=0,i[e+4>>2]=0,i[e+8>>2]=0,v=r+16|0,W2(e,l[e+11|0]>>>7|0?(i[e+8>>2]&2147483647)-1|0:10),l[e+11|0]>>>7|0?r=i[e>>2]:r=e,i[A+180>>2]=r,i[A+12>>2]=A+16,i[A+8>>2]=0;;){i:{if(L2(A+252|0,A+248|0))break i;t=i[A+180>>2],l[e+11|0]>>>7|0?f=i[e+4>>2]:f=l[e+11|0]&127,(t|0)==(f+r|0)&&(l[e+11|0]>>>7|0?r=i[e+4>>2]:r=l[e+11|0]&127,l[e+11|0]>>>7|0?f=i[e+4>>2]:f=l[e+11|0]&127,W2(e,f<<1),W2(e,l[e+11|0]>>>7|0?(i[e+8>>2]&2147483647)-1|0:10),f=r,l[e+11|0]>>>7|0?r=i[e>>2]:r=e,i[A+180>>2]=f+r),t=A+252|0,f=i[t>>2],s=i[f+12>>2];e:{if((s|0)==i[f+16>>2]){f=W[i[i[f>>2]+36>>2]](f)|0;break e}f=u[s|0]}if(Ai(f<<24>>24,o,r,A+180|0,A+8|0,u[A+247|0],A+196|0,A+16|0,A+12|0,77744))break i;q1(t);continue}break}l[A+207|0]>>>7|0?f=i[A+200>>2]:f=l[A+207|0]&127;i:{if(!f||(f=i[A+12>>2],(f-(A+16|0)|0)>159))break i;i[A+12>>2]=f+4,i[f>>2]=i[A+8>>2]}return w=n,h=iu(r,i[A+180>>2],k,o),g[w>>1]=h,l4(A+196|0,A+16|0,i[A+12>>2],k),L2(A+252|0,A+248|0)&&(i[k>>2]=i[k>>2]|2),r=i[A+252>>2],s2(e),s2(A+196|0),v=A+256|0,r|0}function xG(A,e,r,f,k,n,t){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,t=t|0;var o=0,s=0,w=0,h=0,_=0;A=v-272|0,v=A,i[A+264>>2]=r,i[A+268>>2]=e,i[A+16>>2]=2072,e=A+16|0,s=Q1(A+152|0,A+160|0,e),w=A+144|0,o=i[k+28>>2],i[w>>2]=o,(o|0)!=129576&&(i[o+4>>2]=i[o+4>>2]+1),o=c0(w,129760),u[A+143|0]=0;i:{if(!P7(A+268|0,r,f,w,i[k+4>>2],n,A+143|0,o,s,A+148|0,A+260|0))break i;r=l[21089]|l[21090]<<8|(l[21091]<<16|l[21092]<<24),u[A+135|0]=r,u[A+136|0]=r>>>8,u[A+137|0]=r>>>16,u[A+138|0]=r>>>24,r=l[21086]|l[21087]<<8|(l[21088]<<16|l[21089]<<24),i[A+128>>2]=l[21082]|l[21083]<<8|(l[21084]<<16|l[21085]<<24),i[A+132>>2]=r,W[i[i[o>>2]+32>>2]](o,A+128|0,A+138|0,A+118|0)|0,i[A+16>>2]=2071,f=Q1(A+8|0,0,e),k=e;e:{if(e=i[A+148>>2]-i[s>>2]|0,(e|0)>=99&&(r=y2(e+2|0),e=i[f>>2],i[f>>2]=r,e&&W[i[f+4>>2]](e),k=i[f>>2],!k))break e;for(l[A+143|0]==1&&(u[k|0]=45,k=k+1|0),r=i[s>>2];;){if(u0[A+148>>2]<=r>>>0)r:{if(u[k|0]=0,i[A>>2]=t,(cl(A+16|0,A)|0)!=1)break r;e=i[f>>2],i[f>>2]=0,e&&W[i[f+4>>2]](e);break i}else{e=A+118|0,h=k,_=l[((B5(e,e+10|0,r)-A|0)+A|0)+10|0],u[h|0]=_,k=k+1|0,r=r+1|0;continue}break}g1(),H()}g1(),H()}return L2(A+268|0,A+264|0)&&(i[n>>2]=i[n>>2]|2),r=i[A+268>>2],e2(A+144|0),e=i[s>>2],i[s>>2]=0,e&&W[i[s+4>>2]](e),v=A+272|0,r|0}function TG(A,e){A=A|0,e=e|0;var r=0,f=0,k=0,n=0,t=0;f=v-160|0,v=f,i[f+100>>2]=0,i[f+72>>2]=72196,i[f+16>>2]=72176,r=i[18053],i[f+8>>2]=r,k=i[r-12>>2],t=f+8|0,r=t,i[k+r>>2]=i[18054],i[f+12>>2]=0,r=r+i[i[f+8>>2]-12>>2]|0,k=f+20|0,J0(r,k),u[r+80|0]=0,i[r+72>>2]=0,r=i[18055],i[f+16>>2]=r,n=f+16|0,i[n+i[r-12>>2]>>2]=i[18056],r=i[18052],i[f+8>>2]=r,i[t+i[r-12>>2]>>2]=i[18057],i[f+72>>2]=72196,i[f+8>>2]=72156,i[f+16>>2]=72176,t=R0(k),i[t>>2]=71232,i[f+60>>2]=0,i[f+64>>2]=0,i[f+52>>2]=0,i[f+56>>2]=0,i[f+68>>2]=24,r=i[e+4>>2];i:{if(!r){Y(n,21033,18);break i}Y(V0(n,r),21044,7)}if(r=i[e+8>>2],e=i[e+12>>2],(r|0)!=(e|0))for(;k=i[r>>2],u[f+159|0]=32,V0(Y(n,f+159|0,1),k),r=r+4|0,(e|0)!=(r|0););e=i[f+68>>2];i:{e:{if(e&16){r=i[f+64>>2],e=i[f+44>>2],r>>>0<e>>>0&&(i[f+64>>2]=e,r=e),e=f+40|0;break e}if(!(e&8)){r=0,u[A+11|0]=0;break i}r=i[f+36>>2],e=f+28|0}e:{if(n=i[e>>2],r=r-n|0,r>>>0<2147483640){if(r>>>0>=11){k=r|7,e=p(k+1|0),i[A+8>>2]=k-2147483647,i[A>>2]=e,i[A+4>>2]=r,A=e;break e}if(u[A+11|0]=r,r)break e;r=0;break i}Q0(),H()}if(!r)break i;x(A,n,r)}u[A+r|0]=0,A=i[18051],i[f+8>>2]=A,i[i[A-12>>2]+(f+8|0)>>2]=i[18059],i[f+16>>2]=i[18060],i[t>>2]=71232,u[f+63|0]<0&&Z(i[f+52>>2]),E0(t),y0(f+72|0),v=f+160|0}function SG(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0;var k=0,n=0,t=0,o=0,s=0,w=0,h=0,_=0;k=v-32|0,v=k,z2(k,e,r),u[k+19|0]<0&&Z(i[k+8>>2]),u[e+100|0]&1&&(h=e,_=C0(r),i[h+104>>2]=_,h=e,_=C0(r),i[h+108>>2]=_),h=e,_=X2(r),u[h+112|0]=_,t=C0(r),i[e+116>>2]=t;i:{e:{if(!(!f|t>>>0<=u0[f+80>>2])){if(e=p(72),i[k+20>>2]=e,i[k+24>>2]=71,i[k+28>>2]=-2147483576,x(e,24073,71),u[e+71|0]=0,q(A,6,1e3,k+20|0),u[k+31|0]>=0)break e;Z(i[k+20>>2]);break e}if(!l[e+112|0]){if(q4(A,e+132|0,t,f,13640),i[A>>2])break e;u[A+19|0]<0&&Z(i[A+8>>2]),n=i[e+124>>2],t=i[e+120>>2],s=n-t|0,f=i[e+116>>2];r:{if(s>>>0<f>>>0){if(w=f-s|0,o=i[e+128>>2],w>>>0<=o-n>>>0){w&&o0(n,0,w),i[e+124>>2]=n+w;break r}if((f|0)<0)break i;if(n=o-t|0,o=n<<1,o=n>>>0>=1073741823?2147483647:f>>>0<o>>>0?o:f,n=p(o),w&&o0(n+s|0,0,w),s&&x(n,t,s),i[e+128>>2]=n+o,i[e+124>>2]=f+n,i[e+120>>2]=n,!t)break r;Z(t);break r}if(f>>>0>=s>>>0)break r;i[e+124>>2]=f+t}l6(r,i[e+120>>2],i[e+116>>2])}if(l[r+20|0]==1){if(u[k+20|0]=0,u[k+31|0]=0,q(A,2,100,k+20|0),u[k+31|0]>=0)break e;Z(i[k+20>>2]);break e}if(e=i[26917],i[A>>2]=i[26916],i[A+4>>2]=e,A=A+8|0,u[107683]>=0){e=i[26919],i[A>>2]=i[26918],i[A+4>>2]=e,i[A+8>>2]=i[26920];break e}T(A,i[26918],i[26919])}v=k+32|0;return}G0(),H()}function $2(A,e){var r=0,f=0,k=0,n=0,t=0,o=0,s=0,w=0,h=0,_=0,B=0,m=0,X=0,Q=0;n=i[A+16>>2],k=i[A+20>>2],f=i[A+4>>2],r=i[A+24>>2],_=i[A+12>>2],t=_;i:{for(;;){B=A;e:{if((r|0)>0){w=k;break e}r=64-r|0;r:{f:{if(!t)break f;X=0;A:{for(;;){if(o=f+1|0,i[A+4>>2]=o,w=l[f|0],t=t-1|0,i[A+12>>2]=t,m=r-8|0,f=m&31,(m&63)>>>0>=32?(s=w<<f,f=0):(s=(1<<f)-1&w>>>32-f,f=w<<f),n=f|n,i[A+16>>2]=n,k=k|s,i[A+20>>2]=k,(r|0)<=15)break A;if(X=X-(r>>>0<8)|0,r=r-8|0,f=o,!t)break}_=t;break f}_=t,f=o;break r}t=0,m=r}w=k,r=64-m|0}if(o=r,r=r-1|0,i[B+24>>2]=r,s=w<<1|n>>>31,n=n<<1,i[A+16>>2]=n,k=s,i[A+20>>2]=k,(w|0)>0|(w|0)>=0){if(h=h+1|0,(h|0)!=21)continue;break i}break}if(Q=e,h){if(m=A,!((o|0)>(h|0)|(o|0)>57)){for(r=65-o|0,X=0;;){e:{if(t=r,!_){e=r;break e}if(o=f+1|0,i[A+4>>2]=o,f=l[f|0],_=_-1|0,i[A+12>>2]=_,e=t-8|0,B=e&31,(e&63)>>>0>=32?(s=f<<B,f=0):(s=(1<<B)-1&f>>>32-B,f=f<<B),n=f|n,i[A+16>>2]=n,k=k|s,i[A+20>>2]=k,f=r,r=r-8|0,X=X-(f>>>0<8)|0,f=o,(t|0)>15)continue}break}r=64-e|0}i[m+24>>2]=r-h,r=n,e=h&31,(h&63)>>>0>=32?(s=r<<e,e=0):(s=(1<<e)-1&r>>>32-e|k<<e,e=r<<e),i[A+16>>2]=e,i[A+20>>2]=s,e=64-h|0,A=e&31,(e&63)>>>0>=32?A=k>>>A|0:A=((1<<A)-1&k)<<32-A|r>>>A,A=A+(-1<<h^-1)|0}else A=0;i[Q>>2]=A}return w>>>31|0}function jG(A,e){A=A|0,e=e|0;var r=0,f=0,k=0,n=0;f=v-48|0,v=f;i:{e:{r:{f:{A:{if(r=i[e+104>>2],e=i[e+108>>2],(r|0)!=(e|0))for(;;){k:{if(k=i[r>>2],!k||(k=W0(k,86580,99876),!k))break k;if(r=i[r+4>>2],r&&(i[r+4>>2]=i[r+4>>2]+1),i[f+20>>2]=0,i[f+12>>2]=0,i[f+16>>2]=0,z9(k,f+12|0))break r;if(u[f|0]=0,u[f+11|0]=0,e=q(f+24|0,2,117,f),k=i[e+4>>2],i[A>>2]=i[e>>2],i[A+4>>2]=k,k=A+8|0,u[e+19|0]<0)break A;n=i[e+12>>2],i[k>>2]=i[e+8>>2],i[k+4>>2]=n,i[k+8>>2]=i[e+16>>2],u[A+20|0]=1;break f}if(r=r+8|0,(e|0)==(r|0))break}u[f+12|0]=0,u[f+23|0]=0,e=q(f+24|0,2,141,f+12|0),r=i[e+4>>2],i[A>>2]=i[e>>2],i[A+4>>2]=r,r=A+8|0;k:{if(u[e+19|0]>=0){k=i[e+12>>2],i[r>>2]=i[e+8>>2],i[r+4>>2]=k,i[r+8>>2]=i[e+16>>2],u[A+20|0]=1;break k}if(T(r,i[e+8>>2],i[e+12>>2]),r=u[e+19|0],u[A+20|0]=1,(r|0)>=0)break k;Z(i[e+8>>2])}if(u[f+23|0]>=0)break i;Z(i[f+12>>2]);break i}if(T(k,i[e+8>>2],i[e+12>>2]),k=u[e+19|0],u[A+20|0]=1,(k|0)>=0)break f;Z(i[e+8>>2])}if(u[f+11|0]<0&&Z(i[f>>2]),A=i[f+12>>2],!A)break e;i[f+16>>2]=A,Z(A);break e}e=i[f+16>>2],k=i[f+12>>2],n=i[f+20>>2],u[A+20|0]=0,i[A+8>>2]=n,i[A>>2]=k,i[A+4>>2]=e}if(!r||(A=i[r+4>>2],i[r+4>>2]=A-1,A))break i;W[i[i[r>>2]+8>>2]](r),y(r)}v=f+48|0}function OG(A){A=A|0;var e=0,r=0,f=0,k=0,n=0,t=0,o=0,s=0,w=0,h=0;i[A+4>>2]=1,f=i[A+8>>2],i[f+324>>2]=i[f+324>>2]-1,i[f+328>>2]=i[f+328>>2]+1,f=i[A+12>>2],n=f+1|0,r=i[A+8>>2],e=i[r+124>>2],s=i[e+16884>>2]/4|0,w=i[r+276>>2],o=i[e+16892>>2],k=o-1|0,t=i[r+272>>2],h=l[A+16|0];i:{if(h){e=i[e+16900>>2]-1|0,C8(r,A,k,(e|0)<(n|0)?e:n,1);break i}if((f|0)<=0?e=f:(C8(r,A,k,f-1|0,2),r=i[A+8>>2],e=i[A+12>>2]),C8(r,A,k,e,2),r=i[A+12>>2]+1|0,e=i[A+8>>2],(r|0)>=i[i[e+124>>2]+16900>>2])break i;C8(e,A,k,r,2)}e=i[A+12>>2],r=i[A+8>>2];i:{e:{if(l[A+16|0]==1){if(e=t9(r,e),r=i[A+8>>2],u[(i[r+140>>2]+G(G(i[r+152>>2],i[A+12>>2]),24)|0)+21|0]=e,!e)break i;k=l[A+16|0];break e}if(k=0,l[(i[r+140>>2]+G(G(e,i[r+152>>2]),24)|0)+21|0]!=1)break i}f=G(f,s),e=G(n,s),e=(e|0)<(w|0)?e:w,gf(r,k&1,f,e,t),r=l[A+16|0],k=i[A+8>>2];e:{if(i[i[k+124>>2]+16832>>2]>=9){vf(k,r&1,f,e,t);break e}mf(k,r&1,f,e,t)}if(r=i[A+8>>2],n=i[r+124>>2],!i[n+16848>>2])break i;if(k=l[A+16|0],i[n+16840>>2]>=9){Wf(r,k&1,f,e,t);break i}Qf(r,k&1,f,e,t)}if(r=0,(o|0)>0)for(f=h?2:3;e=i[A+8>>2],e=(i[e+320>>2]+G(r,76)|0)+G(G(i[A+12>>2],i[i[e+124>>2]+16892>>2]),76)|0,(f|0)>i[e>>2]&&(i[e>>2]=f),r=r+1|0,(o|0)!=(r|0););i[A+4>>2]=3,h3(i[A+8>>2])}function PG(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0;var k=0,n=0;k=v-32|0,v=k,z2(k+12|0,e,r),u[k+31|0]<0&&Z(i[k+20>>2]);i:{if(l[e+97|0]){t1(A,e,11373);break i}if(n=C0(r),(n|0)<0){if(e=p(32),i[k>>2]=e,i[k+4>>2]=30,i[k+8>>2]=-2147483616,r=l[22387]|l[22388]<<8|(l[22389]<<16|l[22390]<<24),f=l[22383]|l[22384]<<8|(l[22385]<<16|l[22386]<<24),u[e|0]=f,u[e+1|0]=f>>>8,u[e+2|0]=f>>>16,u[e+3|0]=f>>>24,u[e+4|0]=r,u[e+5|0]=r>>>8,u[e+6|0]=r>>>16,u[e+7|0]=r>>>24,u[e+30|0]=0,r=l[22409]|l[22410]<<8|(l[22411]<<16|l[22412]<<24),f=l[22405]|l[22406]<<8|(l[22407]<<16|l[22408]<<24),u[e+22|0]=f,u[e+23|0]=f>>>8,u[e+24|0]=f>>>16,u[e+25|0]=f>>>24,u[e+26|0]=r,u[e+27|0]=r>>>8,u[e+28|0]=r>>>16,u[e+29|0]=r>>>24,r=l[22403]|l[22404]<<8|(l[22405]<<16|l[22406]<<24),f=l[22399]|l[22400]<<8|(l[22401]<<16|l[22402]<<24),u[e+16|0]=f,u[e+17|0]=f>>>8,u[e+18|0]=f>>>16,u[e+19|0]=f>>>24,u[e+20|0]=r,u[e+21|0]=r>>>8,u[e+22|0]=r>>>16,u[e+23|0]=r>>>24,r=l[22395]|l[22396]<<8|(l[22397]<<16|l[22398]<<24),f=l[22391]|l[22392]<<8|(l[22393]<<16|l[22394]<<24),u[e+8|0]=f,u[e+9|0]=f>>>8,u[e+10|0]=f>>>16,u[e+11|0]=f>>>24,u[e+12|0]=r,u[e+13|0]=r>>>8,u[e+14|0]=r>>>16,u[e+15|0]=r>>>24,q(A,6,1e3,k),u[k+11|0]>=0)break i;Z(i[k>>2]);break i}d6(A,e,r,n,f)}v=k+32|0}function LG(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,t=0,o=0,s=0;f=v-160|0,v=f,i[f+92>>2]=0,i[f+64>>2]=72500,k=i[18128],i[f+8>>2]=k,o=i[k-12>>2],k=f+8|0,i[o+k>>2]=i[18129],t=k+i[i[f+8>>2]-12>>2]|0,n=f+12|0,J0(t,n),u[t+80|0]=0,i[t+72>>2]=0,i[f+64>>2]=72500,i[f+8>>2]=72480,t=R0(n),i[t>>2]=71232,i[f+52>>2]=0,i[f+56>>2]=0,i[f+44>>2]=0,i[f+48>>2]=0,i[f+60>>2]=16,n=f+148|0,Y2(n,e,r),s=k,o=n,k=u[f+159|0],n=(k|0)<0,Y(s,n?i[f+148>>2]:o,n?i[f+152>>2]:k),u[f+159|0]<0&&Z(i[f+148>>2]),k=f+148|0,s0(k,r),o=k,r=u[f+159|0],k=(r|0)<0,Y(f+8|0,k?i[f+148>>2]:o,k?i[f+152>>2]:r),u[f+159|0]<0&&Z(i[f+148>>2]),Y(V0(Y(V0(Y(V0(Y(f+8|0,19192,14),i[e+100>>2]),26300,1),i[e+104>>2]),26300,1),i[e+108>>2]),41694,2),e=i[f+60>>2];i:{e:{if(e&16){e=i[f+56>>2],r=i[f+36>>2],e>>>0<r>>>0&&(i[f+56>>2]=r,e=r),r=f+32|0;break e}if(!(e&8)){e=0,u[A+11|0]=0;break i}e=i[f+28>>2],r=f+20|0}e:{if(k=i[r>>2],e=e-k|0,e>>>0<2147483640){if(e>>>0>=11){n=e|7,r=p(n+1|0),i[A+8>>2]=n-2147483647,i[A>>2]=r,i[A+4>>2]=e,A=r;break e}if(u[A+11|0]=e,e)break e;e=0;break i}Q0(),H()}if(!e)break i;x(A,k,e)}u[A+e|0]=0,A=i[18127],i[f+8>>2]=A,i[i[A-12>>2]+(f+8|0)>>2]=i[18130],i[t>>2]=71232,u[f+55|0]<0&&Z(i[f+44>>2]),E0(t),y0(f- -64|0),v=f+160|0}function KG(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,t=0,o=0,s=0;f=v-160|0,v=f,i[f+92>>2]=0,i[f+64>>2]=72500,k=i[18128],i[f+8>>2]=k,t=i[k-12>>2],k=f+8|0,i[t+k>>2]=i[18129],o=k+i[i[f+8>>2]-12>>2]|0,n=f+12|0,J0(o,n),u[o+80|0]=0,i[o+72>>2]=0,i[f+64>>2]=72500,i[f+8>>2]=72480,o=R0(n),i[o>>2]=71232,i[f+52>>2]=0,i[f+56>>2]=0,i[f+44>>2]=0,i[f+48>>2]=0,i[f+60>>2]=16,n=f+148|0,Y2(n,e,r),s=k,t=n,k=u[f+159|0],n=(k|0)<0,Y(s,n?i[f+148>>2]:t,n?i[f+152>>2]:k),u[f+159|0]<0&&Z(i[f+148>>2]),k=f+148|0,s0(k,r),t=k,r=u[f+159|0],k=(r|0)<0,Y(f+8|0,k?i[f+148>>2]:t,k?i[f+152>>2]:r),u[f+159|0]<0&&Z(i[f+148>>2]),t=Y(f+8|0,30691,10),r=u[e+115|0],k=(r|0)<0,Y(Y(t,k?i[e+104>>2]:e+104|0,k?i[e+108>>2]:r),42670,1),e=i[f+60>>2];i:{e:{if(e&16){e=i[f+56>>2],r=i[f+36>>2],e>>>0<r>>>0&&(i[f+56>>2]=r,e=r),r=f+32|0;break e}if(!(e&8)){e=0,u[A+11|0]=0;break i}e=i[f+28>>2],r=f+20|0}e:{if(k=i[r>>2],e=e-k|0,e>>>0<2147483640){if(e>>>0>=11){n=e|7,r=p(n+1|0),i[A+8>>2]=n-2147483647,i[A>>2]=r,i[A+4>>2]=e,A=r;break e}if(u[A+11|0]=e,e)break e;e=0;break i}Q0(),H()}if(!e)break i;x(A,k,e)}u[A+e|0]=0,A=i[18127],i[f+8>>2]=A,i[i[A-12>>2]+(f+8|0)>>2]=i[18130],i[o>>2]=71232,u[f+55|0]<0&&Z(i[f+44>>2]),E0(o),y0(f- -64|0),v=f+160|0}function qG(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,t=0,o=0,s=0;f=v-160|0,v=f,i[f+92>>2]=0,i[f+64>>2]=72500,k=i[18128],i[f+8>>2]=k,t=i[k-12>>2],k=f+8|0,i[t+k>>2]=i[18129],o=k+i[i[f+8>>2]-12>>2]|0,n=f+12|0,J0(o,n),u[o+80|0]=0,i[o+72>>2]=0,i[f+64>>2]=72500,i[f+8>>2]=72480,o=R0(n),i[o>>2]=71232,i[f+52>>2]=0,i[f+56>>2]=0,i[f+44>>2]=0,i[f+48>>2]=0,i[f+60>>2]=16,n=f+148|0,Y2(n,e,r),s=k,t=n,k=u[f+159|0],n=(k|0)<0,Y(s,n?i[f+148>>2]:t,n?i[f+152>>2]:k),u[f+159|0]<0&&Z(i[f+148>>2]),k=f+148|0,s0(k,r),t=k,r=u[f+159|0],k=(r|0)<0,Y(f+8|0,k?i[f+148>>2]:t,k?i[f+152>>2]:r),u[f+159|0]<0&&Z(i[f+148>>2]),t=Y(f+8|0,32531,12),r=u[e+111|0],k=(r|0)<0,Y(Y(t,k?i[e+100>>2]:e+100|0,k?i[e+104>>2]:r),42670,1),e=i[f+60>>2];i:{e:{if(e&16){e=i[f+56>>2],r=i[f+36>>2],e>>>0<r>>>0&&(i[f+56>>2]=r,e=r),r=f+32|0;break e}if(!(e&8)){e=0,u[A+11|0]=0;break i}e=i[f+28>>2],r=f+20|0}e:{if(k=i[r>>2],e=e-k|0,e>>>0<2147483640){if(e>>>0>=11){n=e|7,r=p(n+1|0),i[A+8>>2]=n-2147483647,i[A>>2]=r,i[A+4>>2]=e,A=r;break e}if(u[A+11|0]=e,e)break e;e=0;break i}Q0(),H()}if(!e)break i;x(A,k,e)}u[A+e|0]=0,A=i[18127],i[f+8>>2]=A,i[i[A-12>>2]+(f+8|0)>>2]=i[18130],i[o>>2]=71232,u[f+55|0]<0&&Z(i[f+44>>2]),E0(o),y0(f- -64|0),v=f+160|0}function aG(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,t=0,o=0,s=0;f=v-160|0,v=f,i[f+92>>2]=0,i[f+64>>2]=72500,k=i[18128],i[f+8>>2]=k,t=i[k-12>>2],k=f+8|0,i[t+k>>2]=i[18129],o=k+i[i[f+8>>2]-12>>2]|0,n=f+12|0,J0(o,n),u[o+80|0]=0,i[o+72>>2]=0,i[f+64>>2]=72500,i[f+8>>2]=72480,o=R0(n),i[o>>2]=71232,i[f+52>>2]=0,i[f+56>>2]=0,i[f+44>>2]=0,i[f+48>>2]=0,i[f+60>>2]=16,n=f+148|0,U1(n,e,r),s=k,t=n,k=u[f+159|0],n=(k|0)<0,Y(s,n?i[f+148>>2]:t,n?i[f+152>>2]:k),u[f+159|0]<0&&Z(i[f+148>>2]),k=f+148|0,s0(k,r),t=k,r=u[f+159|0],k=(r|0)<0,Y(f+8|0,k?i[f+148>>2]:t,k?i[f+152>>2]:r),u[f+159|0]<0&&Z(i[f+148>>2]),t=Y(f+8|0,31728,21),r=u[e+115|0],k=(r|0)<0,Y(Y(t,k?i[e+104>>2]:e+104|0,k?i[e+108>>2]:r),42670,1),e=i[f+60>>2];i:{e:{if(e&16){e=i[f+56>>2],r=i[f+36>>2],e>>>0<r>>>0&&(i[f+56>>2]=r,e=r),r=f+32|0;break e}if(!(e&8)){e=0,u[A+11|0]=0;break i}e=i[f+28>>2],r=f+20|0}e:{if(k=i[r>>2],e=e-k|0,e>>>0<2147483640){if(e>>>0>=11){n=e|7,r=p(n+1|0),i[A+8>>2]=n-2147483647,i[A>>2]=r,i[A+4>>2]=e,A=r;break e}if(u[A+11|0]=e,e)break e;e=0;break i}Q0(),H()}if(!e)break i;x(A,k,e)}u[A+e|0]=0,A=i[18127],i[f+8>>2]=A,i[i[A-12>>2]+(f+8|0)>>2]=i[18130],i[o>>2]=71232,u[f+55|0]<0&&Z(i[f+44>>2]),E0(o),y0(f- -64|0),v=f+160|0}function $G(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,t=0,o=0,s=0;f=v-160|0,v=f,i[f+92>>2]=0,i[f+64>>2]=72500,k=i[18128],i[f+8>>2]=k,t=i[k-12>>2],k=f+8|0,i[t+k>>2]=i[18129],o=k+i[i[f+8>>2]-12>>2]|0,n=f+12|0,J0(o,n),u[o+80|0]=0,i[o+72>>2]=0,i[f+64>>2]=72500,i[f+8>>2]=72480,o=R0(n),i[o>>2]=71232,i[f+52>>2]=0,i[f+56>>2]=0,i[f+44>>2]=0,i[f+48>>2]=0,i[f+60>>2]=16,n=f+148|0,Y2(n,e,r),s=k,t=n,k=u[f+159|0],n=(k|0)<0,Y(s,n?i[f+148>>2]:t,n?i[f+152>>2]:k),u[f+159|0]<0&&Z(i[f+148>>2]),k=f+148|0,s0(k,r),t=k,r=u[f+159|0],k=(r|0)<0,Y(f+8|0,k?i[f+148>>2]:t,k?i[f+152>>2]:r),u[f+159|0]<0&&Z(i[f+148>>2]),t=Y(f+8|0,31943,19),r=u[e+115|0],k=(r|0)<0,Y(Y(t,k?i[e+104>>2]:e+104|0,k?i[e+108>>2]:r),42670,1),e=i[f+60>>2];i:{e:{if(e&16){e=i[f+56>>2],r=i[f+36>>2],e>>>0<r>>>0&&(i[f+56>>2]=r,e=r),r=f+32|0;break e}if(!(e&8)){e=0,u[A+11|0]=0;break i}e=i[f+28>>2],r=f+20|0}e:{if(k=i[r>>2],e=e-k|0,e>>>0<2147483640){if(e>>>0>=11){n=e|7,r=p(n+1|0),i[A+8>>2]=n-2147483647,i[A>>2]=r,i[A+4>>2]=e,A=r;break e}if(u[A+11|0]=e,e)break e;e=0;break i}Q0(),H()}if(!e)break i;x(A,k,e)}u[A+e|0]=0,A=i[18127],i[f+8>>2]=A,i[i[A-12>>2]+(f+8|0)>>2]=i[18130],i[o>>2]=71232,u[f+55|0]<0&&Z(i[f+44>>2]),E0(o),y0(f- -64|0),v=f+160|0}function dG(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,t=0,o=0,s=0;f=v-160|0,v=f,i[f+92>>2]=0,i[f+64>>2]=72500,k=i[18128],i[f+8>>2]=k,t=i[k-12>>2],k=f+8|0,i[t+k>>2]=i[18129],o=k+i[i[f+8>>2]-12>>2]|0,n=f+12|0,J0(o,n),u[o+80|0]=0,i[o+72>>2]=0,i[f+64>>2]=72500,i[f+8>>2]=72480,o=R0(n),i[o>>2]=71232,i[f+52>>2]=0,i[f+56>>2]=0,i[f+44>>2]=0,i[f+48>>2]=0,i[f+60>>2]=16,n=f+148|0,U1(n,e,r),s=k,t=n,k=u[f+159|0],n=(k|0)<0,Y(s,n?i[f+148>>2]:t,n?i[f+152>>2]:k),u[f+159|0]<0&&Z(i[f+148>>2]),k=f+148|0,s0(k,r),t=k,r=u[f+159|0],k=(r|0)<0,Y(f+8|0,k?i[f+148>>2]:t,k?i[f+152>>2]:r),u[f+159|0]<0&&Z(i[f+148>>2]),t=Y(f+8|0,30944,5),r=u[e+115|0],k=(r|0)<0,Y(Y(t,k?i[e+104>>2]:e+104|0,k?i[e+108>>2]:r),42670,1),e=i[f+60>>2];i:{e:{if(e&16){e=i[f+56>>2],r=i[f+36>>2],e>>>0<r>>>0&&(i[f+56>>2]=r,e=r),r=f+32|0;break e}if(!(e&8)){e=0,u[A+11|0]=0;break i}e=i[f+28>>2],r=f+20|0}e:{if(k=i[r>>2],e=e-k|0,e>>>0<2147483640){if(e>>>0>=11){n=e|7,r=p(n+1|0),i[A+8>>2]=n-2147483647,i[A>>2]=r,i[A+4>>2]=e,A=r;break e}if(u[A+11|0]=e,e)break e;e=0;break i}Q0(),H()}if(!e)break i;x(A,k,e)}u[A+e|0]=0,A=i[18127],i[f+8>>2]=A,i[i[A-12>>2]+(f+8|0)>>2]=i[18130],i[o>>2]=71232,u[f+55|0]<0&&Z(i[f+44>>2]),E0(o),y0(f- -64|0),v=f+160|0}function f2(A){var e=0,r=0,f=0,k=0,n=0,t=0,o=0,s=0,w=0,h=0,_=0,B=0;k=i[A+8>>2],r=i[A+12>>2],n=i[A+16>>2];i:{for(;;){e:{if((n|0)>0){e=r,f=n;break e}for(f=64-n|0,h=0,n=i[A+4>>2],e=r;;){r:{if(s=f,!n){t=f;break r}if(r=i[A>>2],i[A>>2]=r+1,r=l[r|0],n=n-1|0,i[A+4>>2]=n,_=A,B=k,t=s-8|0,k=t&31,(t&63)>>>0>=32?(w=r<<k,r=0):(w=(1<<k)-1&r>>>32-k,r=r<<k),k=B|r,r=e|w,e=r,i[_+8>>2]=k,i[_+12>>2]=e,r=f,f=r-8|0,h=h-(r>>>0<8)|0,(s|0)>15)continue}break}f=64-t|0}if(n=f-1|0,i[A+16>>2]=n,w=e<<1|k>>>31,k=k<<1,i[A+8>>2]=k,r=w,i[A+12>>2]=r,(e|0)<0)break i;if(o=o+1|0,(o|0)==21)break}return-99999}if(!o)return 0;if(!((f|0)>(o|0)|(f|0)>57)){for(f=65-f|0,h=0,n=i[A+4>>2];;){i:{if(_=f,!n){t=f;break i}if(e=i[A>>2],i[A>>2]=e+1,e=l[e|0],n=n-1|0,i[A+4>>2]=n,w=A,B=k,t=_-8|0,k=t&31,(t&63)>>>0>=32?(s=e<<k,e=0):(s=(1<<k)-1&e>>>32-k,e=e<<k),k=B|e,i[w+8>>2]=k,r=r|s,i[A+12>>2]=r,e=f,f=e-8|0,h=h-(e>>>0<8)|0,(_|0)>15)continue}break}n=64-t|0}if(i[A+16>>2]=n-o,f=k,e=o&31,(o&63)>>>0>=32?(s=k<<e,f=0):(s=(1<<e)-1&f>>>32-e|r<<e,f=f<<e),i[A+8>>2]=f,i[A+12>>2]=s,A=k,f=64-o|0,e=f&31,(f&63)>>>0>=32?A=r>>>e|0:A=((1<<e)-1&r)<<32-e|A>>>e,A=A+(1<<o)|0,(A|0)>1)return A-1|0;D0(21922,18248,146,18040),H()}function vn(A,e,r,f){var k=0,n=0,t=0,o=0,s=0,w=0,h=0,_=0,B=0,m=0,X=0;i:{e:{r:{f:{A:{k:{n:{t:{u:{o:{if(k=e,k){if(!r)break o;if(!f)break u;if(k=k1(f)-k1(k)|0,k>>>0<=31)break t;break e}if((f|0)==1|f>>>0>1)break e;return e=(A>>>0)/(r>>>0)|0,Q6=A-G(e,r)|0,g6=0,l0=0,e}if(!A)break n;if(!f||(n=f-1|0,n&f))break k;return Q6=A,g6=k&n,A=k>>>e8(f)|0,l0=0,A}if(n=r-1|0,!(n&r))break A;h=(k1(r)+33|0)-k1(k)|0,t=0-h|0;break r}h=k+1|0,t=63-k|0;break r}return Q6=0,A=(k>>>0)/(f>>>0)|0,g6=k-G(A,f)|0,l0=0,A}if(k=k1(f)-k1(k)|0,k>>>0<31)break f;break e}if(Q6=A&n,g6=0,(r|0)==1)break i;return r=e8(r),f=r&31,(r&63)>>>0>=32?(k=0,A=e>>>f|0):(k=e>>>f|0,A=((1<<f)-1&e)<<32-f|A>>>f),l0=k,A}h=k+1|0,t=63-k|0}if(n=A,k=h&63,o=k&31,(k&63)>>>0>=32?(k=0,n=e>>>o|0):(k=e>>>o|0,n=((1<<o)-1&e)<<32-o|n>>>o),o=t&63,t=A,s=o&31,(o&63)>>>0>=32?(w=A<<s,A=0):(w=(1<<s)-1&t>>>32-s|e<<s,A=t<<s),e=w,h)for(t=f-1|0,_=r-1|0,t=(_|0)!=-1?t+1|0:t,o=_;k=k<<1|n>>>31,n=n<<1|e>>>31,_=k,s=t-(k+(n>>>0>o>>>0)|0)|0,B=s>>31,w=B,k=n,s=r&w,n=k-s|0,k=_-((f&w)+(k>>>0<s>>>0)|0)|0,w=e<<1|A>>>31,A=m|A<<1,e=w|X,_=B&1,m=_,h=h-1|0,!!h;);return Q6=n,g6=k,w=e<<1|A>>>31,A=_|A<<1,l0=w|X,A}Q6=A,g6=e,A=0,e=0}return l0=e,A}function cG(A,e){A=A|0,e=e|0;var r=0,f=0,k=0,n=0;r=v+-64|0,v=r,F6(r+40|0,i[e+100>>2],i[e+116>>2],r+60|0);i:{if(i[r+40>>2]){e=i[r+44>>2],i[A>>2]=i[r+40>>2],i[A+4>>2]=e,e=A+8|0;e:{if(u[r+59|0]>=0){k=i[r+52>>2],i[e>>2]=i[r+48>>2],i[e+4>>2]=k,i[e+8>>2]=i[r+56>>2];break e}T(e,i[r+48>>2],i[r+52>>2])}u[A+20|0]=1;break i}f=r+16|0,r4(f,i[e+100>>2],i[r+60>>2],1),k=i[r+20>>2],e=i[r+16>>2];e:{if(!e){u[r+4|0]=0,u[r+15|0]=0,e=q(f,2,2e3,r+4|0),f=i[e+4>>2],i[A>>2]=i[e>>2],i[A+4>>2]=f,f=A+8|0;r:{if(u[e+19|0]>=0){n=i[e+12>>2],i[f>>2]=i[e+8>>2],i[f+4>>2]=n,i[f+8>>2]=i[e+16>>2],u[A+20|0]=1;break r}if(T(f,i[e+8>>2],i[e+12>>2]),f=u[e+19|0],u[A+20|0]=1,(f|0)>=0)break r;Z(i[e+8>>2])}if(u[r+15|0]>=0)break e;Z(i[r+4>>2]);break e}if(W[i[i[e>>2]+52>>2]](r+16|0,e),i[r+16>>2]){if(e=i[r+20>>2],i[A>>2]=i[r+16>>2],i[A+4>>2]=e,e=A+8|0,u[r+35|0]>=0){f=i[r+28>>2],i[e>>2]=i[r+24>>2],i[e+4>>2]=f,i[e+8>>2]=i[r+32>>2],u[A+20|0]=1;break e}if(T(e,i[r+24>>2],i[r+28>>2]),e=u[r+35|0],u[A+20|0]=1,(e|0)>=0)break e;Z(i[r+24>>2]);break e}u[r+35|0]<0&&Z(i[r+24>>2]),W[i[i[e>>2]+112>>2]](A,e)}if(!k||(A=i[k+4>>2],i[k+4>>2]=A-1,A))break i;W[i[i[k>>2]+8>>2]](k),y(k)}u[r+59|0]<0&&Z(i[r+48>>2]),v=r- -64|0}function Vr(A,e,r){var f=0,k=0,n=0,t=0,o=0,s=0,w=0;n=v-16|0,v=n,i[n+12>>2]=0,i[n+4>>2]=0,i[n+8>>2]=0;i:{if(r){if((r|0)<0)break i;f=p(r),r&&o0(f,0,r),k=r+f|0,i[n+12>>2]=k,i[n+8>>2]=k,i[n+4>>2]=f}r&&x(f,e,r),f=v-16|0,v=f,e=n+4|0,k=l[i[e>>2]+1|0]>>>3|0;e:{r:{r=i[A+176>>2],t=i[A+180>>2];f:{if((r|0)!=(t|0))for(;;){if((k|0)==l[r+1|0]){if(A=i[r+8>>2],A>>>0<u0[r+12>>2]){if(i[A+8>>2]=0,i[A>>2]=0,i[A+4>>2]=0,k=i[e+4>>2],t=i[e>>2],(k|0)!=(t|0)){if(e=k-t|0,(e|0)<0)break r;k=p(e),i[A+4>>2]=k,i[A>>2]=k,o=e+k|0,i[A+8>>2]=o,e&&x(k,t,e),i[A+4>>2]=o}i[r+8>>2]=A+12;break f}s=r,w=y6(r+4|0,e),i[s+8>>2]=w;break f}if(r=r+16|0,(t|0)==(r|0))break}i[f+12>>2]=0,i[f+4>>2]=0,i[f+8>>2]=0,u[f+1|0]=k,u[f|0]=1,r=y6(f+4|0,e),e=i[A+180>>2],i[f+8>>2]=r;A:{if(e>>>0<u0[A+184>>2]){r=C[f>>1],i[e+12>>2]=0,i[e+4>>2]=0,i[e+8>>2]=0,g[e>>1]=r,r=i[f+4>>2],k=i[f+8>>2],vA(e+4|0,r,k,(k-r|0)/12|0),e=e+16|0;break A}e=Mn(A+176|0,f)}if(i[A+180>>2]=e,e=i[f+4>>2],!e)break f;if(A=e,r=i[f+8>>2],(e|0)!=(r|0)){for(;A=r-12|0,k=i[A>>2],k&&(i[r-8>>2]=k,Z(k)),r=A,(e|0)!=(r|0););A=i[f+4>>2]}i[f+8>>2]=e,Z(A)}v=f+16|0;break e}G0(),H()}A=i[n+4>>2],A&&(i[n+8>>2]=A,Z(A)),v=n+16|0;return}G0(),H()}function Fr(A,e,r,f){var k=0,n=0,t=0,o=0,s=0,w=0,h=0,_=0,B=0,m=0,X=0,Q=0,V=0,F=0,I=0,E=0,R=0,N=0,M=0;for(m=v-2048|0,v=m,k=e;s=n,n=n+1|0,w=k>>>0>3,k=k>>>1|0,!!w;);for(k=e;w=t,t=t+1|0,n=k>>>0>3,k=k>>>1|0,!!n;);for(h=1<<s-1,t=0,k=e;n=t,t=n+1|0,o=k>>>0>3,k=k>>>1|0,!!o;);for(E=e&62,R=e&1,F=e-1|0,I=4-n|0,N=w+7|0,o=0;;){for(X=(o<<1)+r|0,_=0;;){if(Q=_<<I,k=0,t=0,n=0,F)for(;B=k|1,M=g[X+(G(B,f)<<1)>>1],V=B,B=(Q<<5)+61744|0,t=G(M,u[V+B|0])+(G(g[X+(G(f,k)<<1)>>1],u[k+B|0])+t|0)|0,k=k+2|0,n=n+2|0,(E|0)!=(n|0););if(n=(G(e,_)+o<<1)+m|0,R&&(t=G(g[X+(G(f,k)<<1)>>1],u[((Q<<5)+k|0)+61744|0])+t|0),g[n>>1]=t+h>>s,_=_+1|0,(_|0)==(e|0))break}if(o=o+1|0,(o|0)==(e|0))break}for(o=e&62,_=e&1,X=64<<w,f=0;;){for(s=G(e,f),Q=(s<<1)+A|0,r=0;;){if(w=r<<I,k=0,t=0,n=0,F)for(;h=k|1,B=g[(h+s<<1)+m>>1],V=h,h=(w<<5)+61744|0,t=G(B,u[V+h|0])+(G(g[(k+s<<1)+m>>1],u[k+h|0])+t|0)|0,k=k+2|0,n=n+2|0,(o|0)!=(n|0););if(n=Q+(r<<1)|0,_&&(t=G(g[(k+s<<1)+m>>1],u[((w<<5)+k|0)+61744|0])+t|0),g[n>>1]=t+X>>N,r=r+1|0,(r|0)==(e|0))break}if(f=f+1|0,(f|0)==(e|0))break}v=m+2048|0}function bG(A,e,r,f,k){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0;var n=0,t=0,o=0;if(S1(A,i[e+8>>2],k)){i[e+28>>2]==1|i[e+4>>2]!=(r|0)||(i[e+28>>2]=f);return}i:{e:{if(S1(A,i[e>>2],k)){if(!(i[e+16>>2]!=(r|0)&i[e+20>>2]!=(r|0))){if((f|0)!=1)break i;i[e+32>>2]=1;return}if(i[e+32>>2]=f,i[e+44>>2]==4)break e;for(n=A+16|0,t=n+(i[A+12>>2]<<3)|0,f=0;;){r:{f:{A:{k:{if(n>>>0>=t>>>0||(g[e+52>>1]=0,r5(n,e,r,r,1,k),l[e+54|0]))break k;if(l[e+53|0]!=1)break r;if(l[e+52|0]==1){if(i[e+24>>2]==1||(f=1,o=1,!(l[A+8|0]&2)))break f;break r}if(f=1,u[A+8|0]&1)break r;A=3;break A}A=f?3:4}if(i[e+44>>2]=A,o)break i;break e}i[e+44>>2]=3;break i}n=n+8|0}}if(n=i[A+12>>2],t=A+16|0,s3(t,e,r,f,k),n>>>0<2)break i;if(t=t+(n<<3)|0,n=A+24|0,A=i[A+8>>2],!(!(A&2)&i[e+36>>2]!=1)){for(;;){if(l[e+54|0])break i;if(s3(n,e,r,f,k),n=n+8|0,!(t>>>0>n>>>0))break}break i}if(!(A&1))for(;;){if(l[e+54|0]|i[e+36>>2]==1)break i;if(s3(n,e,r,f,k),n=n+8|0,!(t>>>0>n>>>0))break i}for(;;){if(l[e+54|0]|i[e+36>>2]==1&i[e+24>>2]==1)break i;if(s3(n,e,r,f,k),n=n+8|0,!(t>>>0>n>>>0))break}break i}if(i[e+20>>2]=r,i[e+40>>2]=i[e+40>>2]+1,i[e+36>>2]!=1|i[e+24>>2]!=2)break i;u[e+54|0]=1}}function iX(A,e,r,f,k,n,t,o,s){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,t=t|0,o=o|0,s=s|0;var w=0,h=0;w=v+-64|0,v=w,Bt(w+44|0,e+6|0,r),u[w+63|0]<0&&Z(i[w+52>>2]),h=i[r>>2],r=i[r+4>>2],r&&(i[r+4>>2]=i[r+4>>2]+1),i[w+40>>2]=r,i[w+36>>2]=h,r=i[f>>2];i:{e:{r:{if(!l[e+4|0]){if(W[i[r+120>>2]](w+24|0,i[f+4>>2],w+36|0,n,t,o,k),n=i[w+24>>2],n){if(f=i[w+28>>2],k=i[w+32>>2],r=h2(k),r>>>0>=2147483640)break e;f:{A:{if(r>>>0>=11){t=r|7,e=p(t+1|0),i[w+20>>2]=t-2147483647,i[w+12>>2]=e,i[w+16>>2]=r;break A}if(u[w+23|0]=r,e=w+12|0,!r)break f}if(!r)break f;x(e,k,r)}if(u[e+r|0]=0,q(A,n,f,w+12|0),u[w+23|0]>=0)break r;Z(i[w+12>>2]);break r}u[e+4|0]=1,r=i[f>>2]}if(W[i[r+124>>2]](w+24|0,i[f+4>>2],w+36|0,s),n=i[w+24>>2],n){if(f=i[w+28>>2],k=i[w+32>>2],r=h2(k),r>>>0>=2147483640)break i;f:{A:{if(r>>>0>=11){t=r|7,e=p(t+1|0),i[w+20>>2]=t-2147483647,i[w+12>>2]=e,i[w+16>>2]=r;break A}if(u[w+23|0]=r,e=w+12|0,!r)break f}if(!r)break f;x(e,k,r)}if(u[e+r|0]=0,q(A,n,f,w+12|0),u[w+23|0]>=0)break r;Z(i[w+12>>2]);break r}u[e+68|0]=!i[k+24>>2],l9(A,e,f)}A=i[w+40>>2];r:{if(!A||(e=i[A+4>>2],i[A+4>>2]=e-1,e))break r;W[i[i[A>>2]+8>>2]](A),y(A)}v=w- -64|0;return}Q0(),H()}Q0(),H()}function eX(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0;var k=0,n=0,t=0,o=0,s=0,w=0,h=0,_=0,B=0,m=0,X=0;k=v-32|0,v=k,pf(k+8|0,e,r,f);i:{if(i[k+8>>2]){e=i[k+12>>2],i[A>>2]=i[k+8>>2],i[A+4>>2]=e,i[A+16>>2]=i[k+24>>2],e=i[k+20>>2],i[A+8>>2]=i[k+16>>2],i[A+12>>2]=e,i[k+24>>2]=0,i[k+16>>2]=0,i[k+20>>2]=0;break i}m=e,X=o2(r),g[m+120>>1]=X,m=e,X=o2(r),g[m+122>>1]=X;e:{if(i[e+112>>2]==i[e+108>>2])break e;r:{for(;;){f:{o=o2(r),h=o2(r),_=o2(r),f=i[e+128>>2],n=i[e+132>>2];A:{if(f>>>0<n>>>0){g[f+4>>1]=_,g[f+2>>1]=h,g[f>>1]=o,f=f+6|0;break A}if(s=i[e+124>>2],w=f-s|0,f=((w|0)/6|0)+1|0,f>>>0>=715827883)break f;if(n=(n-s|0)/6|0,t=n<<1,t=n>>>0>=357913941?715827882:f>>>0<t>>>0?t:f,t){if(t>>>0>=715827883)break r;f=p(G(t,6))}else f=0;if(n=f+w|0,g[n+4>>1]=_,g[n+2>>1]=h,g[n>>1]=o,o=n+G((w|0)/-6|0,6)|0,w&&x(o,s,w),i[e+132>>2]=f+G(t,6),f=n+6|0,i[e+128>>2]=f,i[e+124>>2]=o,!s)break A;Z(s)}if(i[e+128>>2]=f,B=B+1|0,B>>>0<i[e+112>>2]-i[e+108>>2]>>2>>>0)continue;break e}break}G0(),H()}z0(),H()}if(e=i[26917],i[A>>2]=i[26916],i[A+4>>2]=e,A=A+8|0,u[107683]>=0){e=i[26919],i[A>>2]=i[26918],i[A+4>>2]=e,i[A+8>>2]=i[26920];break i}T(A,i[26918],i[26919])}u[k+27|0]<0&&Z(i[k+16>>2]),v=k+32|0}function b6(A,e,r,f,k){var n=0,t=0,o=0,s=0,w=0,h=0,_=0,B=0,m=0,X=0,Q=0;_=v-16|0,v=_;i:{e:{r:{if((r|0)<=36){if(t=l[A|0],t)break r;n=A;break e}i[31324]=28,f=0,k=0;break i}n=A;r:{for(;;){if(o=t<<24>>24,!((o|0)==32|o-9>>>0<5))break r;if(t=l[n+1|0],n=n+1|0,!t)break}break e}r:switch(o=t&255,o-43|0){case 0:case 2:break r;default:break e}w=(o|0)==45?-1:0,n=n+1|0}e:{if(!((r|16)!=16|l[n|0]!=48)){if(m=1,(l[n+1|0]&223)==88){n=n+2|0,B=16;break e}n=n+1|0,B=r||8;break e}B=r||10}for(r=0;;){e:{o=l[n|0],t=o-48|0;r:{if((t&255)>>>0<10)break r;if((o-97&255)>>>0<=25){t=o-87|0;break r}if((o-65&255)>>>0>25)break e;t=o-55|0}if(t=t&255,(t|0)>=(B|0))break e;$1(_,B,0,0,0,h,s,0,0),o=1;r:{if(i[_+8>>2]|i[_+12>>2]||(X=O0(h,s,B,0),Q=l0,(Q|0)==-1&(t^-1)>>>0<X>>>0))break r;s=Q,h=t+X|0,s=h>>>0<t>>>0?s+1|0:s,m=1,o=r}n=n+1|0,r=o;continue}break}e&&(i[e>>2]=m?n:A);e:{r:{if(r){i[31324]=68,A=f&1,w=A?0:w,h=f,s=k;break r}if((k|0)==(s|0)&f>>>0>h>>>0|k>>>0>s>>>0)break e;A=f&1}if(!(A|w)){i[31324]=68,A=f,f=A-1|0,k=k-!A|0;break i}if((k|0)==(s|0)&f>>>0>=h>>>0|k>>>0>s>>>0)break e;i[31324]=68;break i}A=w^h,f=A-w|0,e=w>>31,k=(e^s)-((A>>>0<w>>>0)+e|0)|0}return v=_+16|0,l0=k,f}function rX(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,t=0,o=0,s=0;f=v-160|0,v=f,i[f+92>>2]=0,i[f+64>>2]=72500,k=i[18128],i[f+8>>2]=k,o=i[k-12>>2],k=f+8|0,i[o+k>>2]=i[18129],t=k+i[i[f+8>>2]-12>>2]|0,n=f+12|0,J0(t,n),u[t+80|0]=0,i[t+72>>2]=0,i[f+64>>2]=72500,i[f+8>>2]=72480,t=R0(n),i[t>>2]=71232,i[f+52>>2]=0,i[f+56>>2]=0,i[f+44>>2]=0,i[f+48>>2]=0,i[f+60>>2]=16,n=f+148|0,Y2(n,e,r),s=k,o=n,k=u[f+159|0],n=(k|0)<0,Y(s,n?i[f+148>>2]:o,n?i[f+152>>2]:k),u[f+159|0]<0&&Z(i[f+148>>2]),k=f+148|0,s0(k,r),o=k,r=u[f+159|0],k=(r|0)<0,Y(f+8|0,k?i[f+148>>2]:o,k?i[f+152>>2]:r),u[f+159|0]<0&&Z(i[f+148>>2]),Y(V0(Y(f+8|0,30058,11),i[e+104>>2]-i[e+100>>2]|0),42670,1),e=i[f+60>>2];i:{e:{if(e&16){e=i[f+56>>2],r=i[f+36>>2],e>>>0<r>>>0&&(i[f+56>>2]=r,e=r),r=f+32|0;break e}if(!(e&8)){e=0,u[A+11|0]=0;break i}e=i[f+28>>2],r=f+20|0}e:{if(k=i[r>>2],e=e-k|0,e>>>0<2147483640){if(e>>>0>=11){n=e|7,r=p(n+1|0),i[A+8>>2]=n-2147483647,i[A>>2]=r,i[A+4>>2]=e,A=r;break e}if(u[A+11|0]=e,e)break e;e=0;break i}Q0(),H()}if(!e)break i;x(A,k,e)}u[A+e|0]=0,A=i[18127],i[f+8>>2]=A,i[i[A-12>>2]+(f+8|0)>>2]=i[18130],i[t>>2]=71232,u[f+55|0]<0&&Z(i[f+44>>2]),E0(t),y0(f- -64|0),v=f+160|0}function Tf(A,e,r,f,k,n,t,o){var s=0;s=v+-64|0,v=s,i[s+40>>2]=0,i[s+44>>2]=0,i[s+48>>2]=0,i[s+52>>2]=0,i[s+56>>2]=0,i[s+60>>2]=0,i[s+32>>2]=0,i[s+36>>2]=0,g[s+28>>1]=256,i[s+24>>2]=1,kr(s,s+24|0,f,k,n,t,1,o,e+136|0);i:{if(i[s>>2]){e=i[s+4>>2],i[A>>2]=i[s>>2],i[A+4>>2]=e,i[A+16>>2]=i[s+16>>2],e=i[s+12>>2],i[A+8>>2]=i[s+8>>2],i[A+12>>2]=e,i[s+16>>2]=0,i[s+8>>2]=0,i[s+12>>2]=0;break i}t=i[e+128>>2];e:{r:{if(!t){n=e+128|0,o=n;break r}for(;;){if(o=t,f=i[o+16>>2],(f|0)>(r|0)){if(n=o,t=i[o>>2],t)continue;break r}if((r|0)<=(f|0))break e;if(t=i[o+4>>2],!t)break}n=o+4|0}f=p(60),i[f+16>>2]=r,r=i[s+28>>2],i[f+20>>2]=i[s+24>>2],i[f+24>>2]=r,r=i[s+36>>2],i[f+28>>2]=i[s+32>>2],i[f+32>>2]=r,r=i[s+44>>2],i[f+36>>2]=i[s+40>>2],i[f+40>>2]=r,r=i[s+52>>2],i[f+44>>2]=i[s+48>>2],i[f+48>>2]=r,r=i[s+60>>2],i[f+52>>2]=i[s+56>>2],i[f+56>>2]=r,i[f+8>>2]=o,i[f>>2]=0,i[f+4>>2]=0,i[n>>2]=f,r=i[i[e+124>>2]>>2],r&&(i[e+124>>2]=r),m1(i[e+128>>2],f),i[e+132>>2]=i[e+132>>2]+1}if(e=i[26917],i[A>>2]=i[26916],i[A+4>>2]=e,A=A+8|0,u[107683]>=0){e=i[26919],i[A>>2]=i[26918],i[A+4>>2]=e,i[A+8>>2]=i[26920];break i}T(A,i[26918],i[26919])}u[s+19|0]<0&&Z(i[s+8>>2]),v=s- -64|0}function mn(A,e){var r=0,f=0,k=0,n=0;k=v-16|0,v=k;i:{if(!i[A+40>>2])break i;r=p(152),i[r+4>>2]=0,i[r+8>>2]=0,i[r>>2]=92244,n=r+16|0,f=n,i[f+8>>2]=0,i[f+12>>2]=0,i[f+16>>2]=0,i[f+20>>2]=0,i[f+24>>2]=0,i[f+28>>2]=0,i[f+32>>2]=0,i[f>>2]=86356,i[r+60>>2]=0,i[r+64>>2]=0,i[r+52>>2]=0,i[r+56>>2]=0,i[r+72>>2]=-1,i[r+76>>2]=-1,i[r+80>>2]=-1,i[r+84>>2]=-1,i[r+116>>2]=0,i[r+88>>2]=0,i[r+92>>2]=0,i[r+96>>2]=0,i[r+100>>2]=0,i[r+104>>2]=0,i[r+108>>2]=0,g[r+112>>1]=0,i[f>>2]=89376,i[r+32>>2]=1952541027,f=r+120|0,u[f+24|0]=0,i[f+16>>2]=0,i[f+20>>2]=2147483647,i[f+8>>2]=-1,i[f+12>>2]=-1,u[f|0]=1,A3(f,i[A+44>>2]),f=i[e>>2],i[k+12>>2]=r,i[k+8>>2]=n,i[r+4>>2]=i[r+4>>2]+1,r2(f+36|0,k+8|0),f=i[k+12>>2];e:{if(!f||(n=i[f+4>>2],i[f+4>>2]=n-1,n))break e;W[i[i[f>>2]+8>>2]](f),y(f)}if(f=i[r+4>>2],i[r+4>>2]=f-1,f)break i;W[i[i[r>>2]+8>>2]](r),y(r)}r=i[e>>2],f=i[A+180>>2],A=i[e+4>>2],A&&(i[A+4>>2]=i[A+4>>2]+1),i[k+12>>2]=A,i[k+8>>2]=r,r2(f+104|0,k+8|0),A=i[k+12>>2];i:{if(!A||(r=i[A+4>>2],i[A+4>>2]=r-1,r))break i;W[i[i[A>>2]+8>>2]](A),y(A)}A=i[e+4>>2];i:{if(!A||(e=i[A+4>>2],i[A+4>>2]=e-1,e))break i;W[i[i[A>>2]+8>>2]](A),y(A)}v=k+16|0}function fX(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,t=0,o=0,s=0;f=v-160|0,v=f,i[f+92>>2]=0,i[f+64>>2]=72500,k=i[18128],i[f+8>>2]=k,o=i[k-12>>2],k=f+8|0,i[o+k>>2]=i[18129],t=k+i[i[f+8>>2]-12>>2]|0,n=f+12|0,J0(t,n),u[t+80|0]=0,i[t+72>>2]=0,i[f+64>>2]=72500,i[f+8>>2]=72480,t=R0(n),i[t>>2]=71232,i[f+52>>2]=0,i[f+56>>2]=0,i[f+44>>2]=0,i[f+48>>2]=0,i[f+60>>2]=16,n=f+148|0,Y2(n,e,r),s=k,o=n,k=u[f+159|0],n=(k|0)<0,Y(s,n?i[f+148>>2]:o,n?i[f+152>>2]:k),u[f+159|0]<0&&Z(i[f+148>>2]),k=f+148|0,s0(k,r),o=k,r=u[f+159|0],k=(r|0)<0,Y(f+8|0,k?i[f+148>>2]:o,k?i[f+152>>2]:r),u[f+159|0]<0&&Z(i[f+148>>2]),Y(S0(Y(f+8|0,30614,10),i[e+100>>2]),42656,15),e=i[f+60>>2];i:{e:{if(e&16){r=i[f+56>>2],e=i[f+36>>2],r>>>0<e>>>0&&(i[f+56>>2]=e,r=e),e=f+32|0;break e}if(!(e&8)){r=0,u[A+11|0]=0;break i}r=i[f+28>>2],e=f+20|0}e:{if(k=i[e>>2],r=r-k|0,r>>>0<2147483640){if(r>>>0>=11){n=r|7,e=p(n+1|0),i[A+8>>2]=n-2147483647,i[A>>2]=e,i[A+4>>2]=r,A=e;break e}if(u[A+11|0]=r,r)break e;r=0;break i}Q0(),H()}if(!r)break i;x(A,k,r)}u[A+r|0]=0,A=i[18127],i[f+8>>2]=A,i[i[A-12>>2]+(f+8|0)>>2]=i[18130],i[t>>2]=71232,u[f+55|0]<0&&Z(i[f+44>>2]),E0(t),y0(f- -64|0),v=f+160|0}function m1(A,e){var r=0,f=0,k=0,n=0;k=(A|0)==(e|0),u[e+12|0]=k;i:{if(k)break i;for(;;){if(k=i[e+8>>2],l[k+12|0])break i;e:{r=i[k+8>>2],f=i[r>>2];r:{if((k|0)==(f|0)){if(n=i[r+4>>2],!(!n|l[n+12|0])){u[k+12|0]=1,u[r+12|0]=(A|0)==(r|0),u[n+12|0]=1;break r}f:{if(i[k>>2]==(e|0)){e=k;break f}e=i[k+4>>2],A=i[e>>2],i[k+4>>2]=A;A:{if(!A){i[e+8>>2]=r,i[r>>2]=e;break A}if(i[A+8>>2]=k,f=i[k+8>>2],A=i[f>>2],i[e+8>>2]=f,(A|0)==(k|0)){i[f>>2]=e;break A}i[f+4>>2]=e}i[e>>2]=k,i[k+8>>2]=e,r=i[e+8>>2],f=i[r>>2]}u[e+12|0]=1,u[r+12|0]=0,A=i[f+4>>2],i[r>>2]=A,A&&(i[A+8>>2]=r),A=i[r+8>>2],i[f+8>>2]=A;f:{if(i[A>>2]==(r|0)){i[A>>2]=f;break f}i[A+4>>2]=f}i[f+4>>2]=r,i[r+8>>2]=f;return}if(l[f+12|0]|!f)break e;u[k+12|0]=1,u[r+12|0]=(A|0)==(r|0),u[f+12|0]=1}if(e=r,(A|0)!=(r|0))continue;break i}break}f=i[k>>2];e:{if((f|0)!=(e|0)){f=k;break e}A=i[f+4>>2],i[k>>2]=A,A&&(i[A+8>>2]=k,r=i[k+8>>2]),i[f+8>>2]=r;r:{if((k|0)==i[r>>2]){i[r>>2]=f;break r}i[r+4>>2]=f}i[f+4>>2]=k,i[k+8>>2]=f,r=i[f+8>>2]}u[f+12|0]=1,u[r+12|0]=0,e=i[r+4>>2],A=i[e>>2],i[r+4>>2]=A,A&&(i[A+8>>2]=r),A=i[r+8>>2],i[e+8>>2]=A;e:{if(i[A>>2]==(r|0)){i[A>>2]=e;break e}i[A+4>>2]=e}i[e>>2]=r,i[r+8>>2]=e}}function AX(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,t=0,o=0,s=0;f=v-160|0,v=f,i[f+92>>2]=0,i[f+64>>2]=72500,k=i[18128],i[f+8>>2]=k,o=i[k-12>>2],k=f+8|0,i[o+k>>2]=i[18129],t=k+i[i[f+8>>2]-12>>2]|0,n=f+12|0,J0(t,n),u[t+80|0]=0,i[t+72>>2]=0,i[f+64>>2]=72500,i[f+8>>2]=72480,t=R0(n),i[t>>2]=71232,i[f+52>>2]=0,i[f+56>>2]=0,i[f+44>>2]=0,i[f+48>>2]=0,i[f+60>>2]=16,n=f+148|0,Y2(n,e,r),s=k,o=n,k=u[f+159|0],n=(k|0)<0,Y(s,n?i[f+148>>2]:o,n?i[f+152>>2]:k),u[f+159|0]<0&&Z(i[f+148>>2]),k=f+148|0,s0(k,r),o=k,r=u[f+159|0],k=(r|0)<0,Y(f+8|0,k?i[f+148>>2]:o,k?i[f+152>>2]:r),u[f+159|0]<0&&Z(i[f+148>>2]),Y(V0(Y(f+8|0,32109,10),C[e+98>>1]),42670,1),e=i[f+60>>2];i:{e:{if(e&16){r=i[f+56>>2],e=i[f+36>>2],r>>>0<e>>>0&&(i[f+56>>2]=e,r=e),e=f+32|0;break e}if(!(e&8)){r=0,u[A+11|0]=0;break i}r=i[f+28>>2],e=f+20|0}e:{if(k=i[e>>2],r=r-k|0,r>>>0<2147483640){if(r>>>0>=11){n=r|7,e=p(n+1|0),i[A+8>>2]=n-2147483647,i[A>>2]=e,i[A+4>>2]=r,A=e;break e}if(u[A+11|0]=r,r)break e;r=0;break i}Q0(),H()}if(!r)break i;x(A,k,r)}u[A+r|0]=0,A=i[18127],i[f+8>>2]=A,i[i[A-12>>2]+(f+8|0)>>2]=i[18130],i[t>>2]=71232,u[f+55|0]<0&&Z(i[f+44>>2]),E0(t),y0(f- -64|0),v=f+160|0}function kX(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0;var k=0,n=0,t=0,o=0,s=0,w=0,h=0,_=0,B=0;k=v-32|0,v=k,z2(k,e,r),u[k+19|0]<0&&Z(i[k+8>>2]);i:{e:{r:{if(l[e+97|0]){t1(A,e,7973);break r}if(h=C0(r),q4(A,e+116|0,h<<2,f,13794),i[A>>2])break r;u[A+19|0]<0&&Z(i[A+8>>2]);f:{if(h){for(;;){s=C0(r),f=i[e+108>>2],n=i[e+112>>2];A:{if(f>>>0<n>>>0){i[f>>2]=s,f=f+4|0;break A}if(w=i[e+104>>2],f=f-w|0,_=f>>2,t=_+1|0,t>>>0>=1073741824)break e;if(n=n-w|0,o=n>>1,n=n>>>0>=2147483644?1073741823:t>>>0<o>>>0?o:t,n){if(n>>>0>=1073741824)break i;t=p(n<<2)}else t=0;if(o=t+f|0,i[o>>2]=s,s=o-(_<<2)|0,f&&x(s,w,f),i[e+112>>2]=t+(n<<2),f=o+4|0,i[e+108>>2]=f,i[e+104>>2]=s,!w)break A;Z(w)}if(i[e+108>>2]=f,l[r+20|0]!=1){if(B=B+1|0,(B|0)==(h|0))break f;continue}break}if(u[k+20|0]=0,u[k+31|0]=0,q(A,2,100,k+20|0),u[k+31|0]>=0)break r;Z(i[k+20>>2]);break r}if(!(u[r+20|0]&1))break f;if(u[k+20|0]=0,u[k+31|0]=0,q(A,2,100,k+20|0),u[k+31|0]>=0)break r;Z(i[k+20>>2]);break r}if(e=i[26917],i[A>>2]=i[26916],i[A+4>>2]=e,A=A+8|0,u[107683]>=0){e=i[26919],i[A>>2]=i[26918],i[A+4>>2]=e,i[A+8>>2]=i[26920];break r}T(A,i[26918],i[26919])}v=k+32|0;return}G0(),H()}z0(),H()}function nX(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,t=0,o=0,s=0;f=v-160|0,v=f,i[f+92>>2]=0,i[f+64>>2]=72500,k=i[18128],i[f+8>>2]=k,o=i[k-12>>2],k=f+8|0,i[o+k>>2]=i[18129],t=k+i[i[f+8>>2]-12>>2]|0,n=f+12|0,J0(t,n),u[t+80|0]=0,i[t+72>>2]=0,i[f+64>>2]=72500,i[f+8>>2]=72480,t=R0(n),i[t>>2]=71232,i[f+52>>2]=0,i[f+56>>2]=0,i[f+44>>2]=0,i[f+48>>2]=0,i[f+60>>2]=16,n=f+148|0,Y2(n,e,r),s=k,o=n,k=u[f+159|0],n=(k|0)<0,Y(s,n?i[f+148>>2]:o,n?i[f+152>>2]:k),u[f+159|0]<0&&Z(i[f+148>>2]),k=f+148|0,s0(k,r),o=k,r=u[f+159|0],k=(r|0)<0,Y(f+8|0,k?i[f+148>>2]:o,k?i[f+152>>2]:r),u[f+159|0]<0&&Z(i[f+148>>2]),Y(S0(Y(f+8|0,30800,16),l[e+104|0]),42670,1),e=i[f+60>>2];i:{e:{if(e&16){r=i[f+56>>2],e=i[f+36>>2],r>>>0<e>>>0&&(i[f+56>>2]=e,r=e),e=f+32|0;break e}if(!(e&8)){r=0,u[A+11|0]=0;break i}r=i[f+28>>2],e=f+20|0}e:{if(k=i[e>>2],r=r-k|0,r>>>0<2147483640){if(r>>>0>=11){n=r|7,e=p(n+1|0),i[A+8>>2]=n-2147483647,i[A>>2]=e,i[A+4>>2]=r,A=e;break e}if(u[A+11|0]=r,r)break e;r=0;break i}Q0(),H()}if(!r)break i;x(A,k,r)}u[A+r|0]=0,A=i[18127],i[f+8>>2]=A,i[i[A-12>>2]+(f+8|0)>>2]=i[18130],i[t>>2]=71232,u[f+55|0]<0&&Z(i[f+44>>2]),E0(t),y0(f- -64|0),v=f+160|0}function tX(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0;var k=0,n=0,t=0,o=0,s=0,w=0,h=0,_=0,B=0;k=v-32|0,v=k,z2(k,e,r),u[k+19|0]<0&&Z(i[k+8>>2]);i:{e:{r:{if(l[e+97|0]){t1(A,e,4735);break r}if(h=C0(r),q4(A,e+116|0,h<<2,f,13732),i[A>>2])break r;u[A+19|0]<0&&Z(i[A+8>>2]);f:{if(h){for(;;){s=C0(r),f=i[e+108>>2],n=i[e+112>>2];A:{if(f>>>0<n>>>0){i[f>>2]=s,f=f+4|0;break A}if(w=i[e+104>>2],f=f-w|0,_=f>>2,t=_+1|0,t>>>0>=1073741824)break e;if(n=n-w|0,o=n>>1,n=n>>>0>=2147483644?1073741823:t>>>0<o>>>0?o:t,n){if(n>>>0>=1073741824)break i;t=p(n<<2)}else t=0;if(o=t+f|0,i[o>>2]=s,s=o-(_<<2)|0,f&&x(s,w,f),i[e+112>>2]=t+(n<<2),f=o+4|0,i[e+108>>2]=f,i[e+104>>2]=s,!w)break A;Z(w)}if(i[e+108>>2]=f,l[r+20|0]!=1){if(B=B+1|0,(B|0)==(h|0))break f;continue}break}if(u[k+20|0]=0,u[k+31|0]=0,q(A,2,100,k+20|0),u[k+31|0]>=0)break r;Z(i[k+20>>2]);break r}if(!(u[r+20|0]&1))break f;if(u[k+20|0]=0,u[k+31|0]=0,q(A,2,100,k+20|0),u[k+31|0]>=0)break r;Z(i[k+20>>2]);break r}if(e=i[26917],i[A>>2]=i[26916],i[A+4>>2]=e,A=A+8|0,u[107683]>=0){e=i[26919],i[A>>2]=i[26918],i[A+4>>2]=e,i[A+8>>2]=i[26920];break r}T(A,i[26918],i[26919])}v=k+32|0;return}G0(),H()}z0(),H()}function uX(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,t=0,o=0,s=0;f=v-160|0,v=f,i[f+92>>2]=0,i[f+64>>2]=72500,k=i[18128],i[f+8>>2]=k,o=i[k-12>>2],k=f+8|0,i[o+k>>2]=i[18129],t=k+i[i[f+8>>2]-12>>2]|0,n=f+12|0,J0(t,n),u[t+80|0]=0,i[t+72>>2]=0,i[f+64>>2]=72500,i[f+8>>2]=72480,t=R0(n),i[t>>2]=71232,i[f+52>>2]=0,i[f+56>>2]=0,i[f+44>>2]=0,i[f+48>>2]=0,i[f+60>>2]=16,n=f+148|0,Y2(n,e,r),s=k,o=n,k=u[f+159|0],n=(k|0)<0,Y(s,n?i[f+148>>2]:o,n?i[f+152>>2]:k),u[f+159|0]<0&&Z(i[f+148>>2]),k=f+148|0,s0(k,r),o=k,r=u[f+159|0],k=(r|0)<0,Y(f+8|0,k?i[f+148>>2]:o,k?i[f+152>>2]:r),u[f+159|0]<0&&Z(i[f+148>>2]),Y(V0(Y(f+8|0,32505,9),i[e+104>>2]),42670,1),e=i[f+60>>2];i:{e:{if(e&16){r=i[f+56>>2],e=i[f+36>>2],r>>>0<e>>>0&&(i[f+56>>2]=e,r=e),e=f+32|0;break e}if(!(e&8)){r=0,u[A+11|0]=0;break i}r=i[f+28>>2],e=f+20|0}e:{if(k=i[e>>2],r=r-k|0,r>>>0<2147483640){if(r>>>0>=11){n=r|7,e=p(n+1|0),i[A+8>>2]=n-2147483647,i[A>>2]=e,i[A+4>>2]=r,A=e;break e}if(u[A+11|0]=r,r)break e;r=0;break i}Q0(),H()}if(!r)break i;x(A,k,r)}u[A+r|0]=0,A=i[18127],i[f+8>>2]=A,i[i[A-12>>2]+(f+8|0)>>2]=i[18130],i[t>>2]=71232,u[f+55|0]<0&&Z(i[f+44>>2]),E0(t),y0(f- -64|0),v=f+160|0}function oX(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,t=0,o=0,s=0;f=v-160|0,v=f,i[f+92>>2]=0,i[f+64>>2]=72500,k=i[18128],i[f+8>>2]=k,o=i[k-12>>2],k=f+8|0,i[o+k>>2]=i[18129],t=k+i[i[f+8>>2]-12>>2]|0,n=f+12|0,J0(t,n),u[t+80|0]=0,i[t+72>>2]=0,i[f+64>>2]=72500,i[f+8>>2]=72480,t=R0(n),i[t>>2]=71232,i[f+52>>2]=0,i[f+56>>2]=0,i[f+44>>2]=0,i[f+48>>2]=0,i[f+60>>2]=16,n=f+148|0,Y2(n,e,r),s=k,o=n,k=u[f+159|0],n=(k|0)<0,Y(s,n?i[f+148>>2]:o,n?i[f+152>>2]:k),u[f+159|0]<0&&Z(i[f+148>>2]),k=f+148|0,s0(k,r),o=k,r=u[f+159|0],k=(r|0)<0,Y(f+8|0,k?i[f+148>>2]:o,k?i[f+152>>2]:r),u[f+159|0]<0&&Z(i[f+148>>2]),Y(S0(Y(f+8|0,29453,10),l[e+97|0]),42670,1),e=i[f+60>>2];i:{e:{if(e&16){r=i[f+56>>2],e=i[f+36>>2],r>>>0<e>>>0&&(i[f+56>>2]=e,r=e),e=f+32|0;break e}if(!(e&8)){r=0,u[A+11|0]=0;break i}r=i[f+28>>2],e=f+20|0}e:{if(k=i[e>>2],r=r-k|0,r>>>0<2147483640){if(r>>>0>=11){n=r|7,e=p(n+1|0),i[A+8>>2]=n-2147483647,i[A>>2]=e,i[A+4>>2]=r,A=e;break e}if(u[A+11|0]=r,r)break e;r=0;break i}Q0(),H()}if(!r)break i;x(A,k,r)}u[A+r|0]=0,A=i[18127],i[f+8>>2]=A,i[i[A-12>>2]+(f+8|0)>>2]=i[18130],i[t>>2]=71232,u[f+55|0]<0&&Z(i[f+44>>2]),E0(t),y0(f- -64|0),v=f+160|0}function Y(A,e,r){var f=0,k=0,n=0,t=0,o=0,s=0,w=0,h=0,_=0,B=0;o=v-16|0,v=o,_=G1(o+4|0,A);i:{if(l[_|0]!=1)break i;s=e+r|0,k=i[i[A>>2]-12>>2]+A|0,w=(i[k+4>>2]&176)==32?s:e,t=i[k+24>>2];e:{if(l[k+80|0]==1){r=l[k+76|0]|l[k+77|0]<<8|(l[k+78|0]<<16|l[k+79|0]<<24);break e}f=o+12|0,r=i[k+28>>2],i[f>>2]=r,(r|0)!=129576&&(i[r+4>>2]=i[r+4>>2]+1),r=c0(f,129760),r=W[i[i[r>>2]+28>>2]](r,32)|0,e2(f),u[k+76|0]=r,u[k+77|0]=r>>>8,u[k+78|0]=r>>>16,u[k+79|0]=r>>>24,u[k+80|0]=1}B=r<<24>>24,r=0,f=v-16|0,v=f;e:{r:{f:{if(!t||(n=i[k+12>>2],h=w-e|0,(h|0)>0&&(W[i[i[t>>2]+48>>2]](t,e,h)|0)!=(h|0)))break f;if(e=s-e|0,e=(e|0)<(n|0)?n-e|0:0,(e|0)>0){if(e>>>0>=2147483640)break r;A:{if(e>>>0>=11){r=e|7,n=p(r+1|0),i[f+12>>2]=r-2147483647,i[f+4>>2]=n,i[f+8>>2]=e;break A}u[f+15|0]=e,n=f+4|0}if(e&&o0(n,B,e),r=0,u[e+n|0]=0,n=W[i[i[t>>2]+48>>2]](t,u[f+15|0]<0?i[f+4>>2]:f+4|0,e)|0,u[f+15|0]<0&&Z(i[f+4>>2]),(e|0)!=(n|0))break f}A:{if(e=s-w|0,(e|0)<=0||(W[i[i[t>>2]+48>>2]](t,w,e)|0)==(e|0))break A;break f}i[k+12>>2]=0,r=t}v=f+16|0;break e}Q0(),H()}if(r)break i;e=i[i[A>>2]-12>>2]+A|0,H1(e,i[e+16>>2]|5)}return _1(_),v=o+16|0,A}function Sf(A,e,r){var f=0,k=0,n=0,t=0,o=0,s=0,w=0;i[A+8>>2]=0,i[A>>2]=0,i[A+4>>2]=0;i:{if(r)for(;;){e:{r:{if(s=o+2|0,s>>>0>=r>>>0||(k=e+o|0,l[k|0]|l[k+1|0]|l[e+s|0]!=3))break r;n=i[A+8>>2];f:{if(n>>>0>f>>>0){u[f|0]=0,f=f+1|0;break f}if(t=i[A>>2],o=f-t|0,k=o+1|0,(k|0)<0)break i;if(f=n-t|0,n=f<<1,f=f>>>0>=1073741823?2147483647:k>>>0<n>>>0?n:k,f?k=p(f):k=0,n=k+o|0,u[n|0]=0,o&&x(k,t,o),i[A+8>>2]=f+k,f=n+1|0,i[A+4>>2]=f,i[A>>2]=k,!t)break f;Z(t)}if(i[A+4>>2]=f,n=i[A+8>>2],n>>>0>f>>>0){u[f|0]=0,f=f+1|0;break e}if(t=i[A>>2],o=f-t|0,k=o+1|0,(k|0)<0)break i;if(f=n-t|0,n=f<<1,f=f>>>0>=1073741823?2147483647:k>>>0<n>>>0?n:k,f?k=p(f):k=0,n=k+o|0,u[n|0]=0,o&&x(k,t,o),i[A+8>>2]=f+k,f=n+1|0,i[A+4>>2]=f,i[A>>2]=k,!t)break e;Z(t);break e}n=e+o|0,w=i[A+8>>2];r:{if(w>>>0>f>>>0){u[f|0]=l[n|0],f=f+1|0;break r}if(t=i[A>>2],s=f-t|0,k=s+1|0,(k|0)<0)break i;if(f=w-t|0,w=f<<1,f=f>>>0>=1073741823?2147483647:k>>>0<w>>>0?w:k,f?k=p(f):k=0,w=k+s|0,u[w|0]=l[n|0],s&&x(k,t,s),i[A+8>>2]=f+k,f=w+1|0,i[A+4>>2]=f,i[A>>2]=k,!t)break r;Z(t)}s=o}if(i[A+4>>2]=f,o=s+1|0,!(o>>>0<r>>>0))break}return}G0(),H()}function Zn(A,e,r){var f=0,k=0,n=0,t=0,o=U(0),s=U(0),w=U(0),h=U(0),_=U(0),B=U(0),m=U(0),X=U(0);f=v-16|0,v=f,i[r>>2]=0,k=B3();i:{if(!k){if(u[f+4|0]=0,u[f+15|0]=0,q(A,6,0,f+4|0),u[f+15|0]>=0)break i;Z(i[f+4>>2]);break i}if(u[k|0]=1,n=f+4|0,XA(n,k,C[e>>1]),t=i[f+4>>2],t){if(e=i[f+8>>2],x2(k),u[f+4|0]=0,u[f+15|0]=0,q(A,t,e,n),u[f+15|0]>=0)break i;Z(i[f+4>>2]);break i}if(n=f+4|0,WA(n,k,C[e+2>>1]),t=i[f+4>>2],t){if(e=i[f+8>>2],x2(k),u[f+4|0]=0,u[f+15|0]=0,q(A,t,e,n),u[f+15|0]>=0)break i;Z(i[f+4>>2]);break i}if(n=f+4|0,GA(n,k,C[e+4>>1]),t=i[f+4>>2],t){if(e=i[f+8>>2],x2(k),u[f+4|0]=0,u[f+15|0]=0,q(A,t,e,n),u[f+15|0]>=0)break i;Z(i[f+4>>2]);break i}if(u[k+16|0]=l[e+6|0],e=C[k+4>>1]-1|0,(e&65535)>>>0<=21&&(e=e<<2&262140,o=p0[e+50772>>2],s=p0[e+50420>>2],w=p0[e+50332>>2],h=p0[e+50244>>2],_=p0[e+50156>>2],B=p0[e+50684>>2],m=p0[e+50596>>2],X=p0[e+50508>>2]),p0[k+48>>2]=o,p0[k+44>>2]=B,p0[k+40>>2]=s,p0[k+36>>2]=w,p0[k+32>>2]=h,p0[k+28>>2]=_,p0[k+24>>2]=m,p0[k+20>>2]=X,i[r>>2]=k,e=i[26917],i[A>>2]=i[26916],i[A+4>>2]=e,A=A+8|0,u[107683]>=0){e=i[26919],i[A>>2]=i[26918],i[A+4>>2]=e,i[A+8>>2]=i[26920];break i}T(A,i[26918],i[26919])}v=f+16|0}function t1(A,e,r){var f=0,k=0,n=0,t=0,o=0;f=v-160|0,v=f,i[f+104>>2]=0,i[f+76>>2]=72196,i[f+20>>2]=72176,n=i[18053],i[f+12>>2]=n,k=i[n-12>>2],n=f+12|0,i[k+n>>2]=i[18054],i[f+16>>2]=0,k=n+i[i[f+12>>2]-12>>2]|0,t=f+24|0,J0(k,t),u[k+80|0]=0,i[k+72>>2]=0,k=i[18055],i[f+20>>2]=k,o=f+20|0,i[o+i[k-12>>2]>>2]=i[18056],k=i[18052],i[f+12>>2]=k,i[n+i[k-12>>2]>>2]=i[18057],i[f+76>>2]=72196,i[f+12>>2]=72156,i[f+20>>2]=72176,n=R0(t),i[n>>2]=71232,k=f- -64|0,i[k>>2]=0,i[k+4>>2]=0,i[f+56>>2]=0,i[f+60>>2]=0,i[f+72>>2]=24,Y(S0(Y(Y(o,r,h2(r)),28010,18),l[e+97|0]),4165,23),e=i[f+72>>2];i:{e:{if(e&16){e=i[f+68>>2],r=i[f+48>>2],e>>>0<r>>>0&&(i[f+68>>2]=r,e=r),r=f+44|0;break e}if(!(e&8)){e=0,u[f+11|0]=0,r=f;break i}e=i[f+40>>2],r=f+32|0}e:{if(k=i[r>>2],e=e-k|0,e>>>0<2147483640){if(e>>>0>=11){t=e|7,r=p(t+1|0),i[f+8>>2]=t-2147483647,i[f>>2]=r,i[f+4>>2]=e;break e}if(u[f+11|0]=e,r=f,e)break e;e=0;break i}Q0(),H()}if(!e)break i;x(r,k,e)}u[e+r|0]=0,q(A,4,3002,f),u[f+11|0]<0&&Z(i[f>>2]),A=i[18051],i[f+12>>2]=A,i[i[A-12>>2]+(f+12|0)>>2]=i[18059],i[f+20>>2]=i[18060],i[n>>2]=71232,u[f+67|0]<0&&Z(i[f+56>>2]),E0(n),y0(f+76|0),v=f+160|0}function lX(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,t=0,o=0,s=0,w=0,h=0;n=v-32|0,v=n;i:{e:{r:{if(!(i[e+104>>2]-i[e+100>>2]&255)){if(e=i[26917],i[A>>2]=i[26916],i[A+4>>2]=e,A=A+8|0,u[107683]<0)break r;e=i[26919],i[A>>2]=i[26918],i[A+4>>2]=e,i[A+8>>2]=i[26920];break i}if(w=W[i[i[e>>2]+52>>2]](e,r,0)|0,u2(r,(i[e+116>>2]-i[e+112>>2]|0)/12&255),l2(r,i[e+104>>2]-i[e+100>>2]&255),f=i[e+100>>2],k=i[e+104>>2],(f|0)!=(k|0))for(;l2(r,l[f|0]),f=f+1|0,(k|0)!=(f|0););if(k=i[e+112>>2],s=i[e+116>>2],(k|0)==(s|0))break e;for(;;){if(i[n+28>>2]=0,i[n+20>>2]=0,i[n+24>>2]=0,f=i[k+4>>2],t=i[k>>2],(f|0)!=(t|0)){f:{if(f=f-t|0,(f|0)>=0){for(o=p(f),f&&x(o,t,f),f=f>>>1|0,h=f>>>0<=1?1:f,f=0;;){t=C[(f<<1)+o>>1];A:{if(l[i[e+100>>2]+f|0]<=8){l2(r,t&255);break A}u2(r,t)}if(f=f+1|0,(h|0)==(f|0))break}break f}G0(),H()}Z(o)}if(k=k+12|0,(s|0)==(k|0))break}break e}T(A,i[26918],i[26919]);break i}if(f1(n,e,r,w),u[n+19|0]<0&&Z(i[n+8>>2]),e=i[26917],i[A>>2]=i[26916],i[A+4>>2]=e,A=A+8|0,u[107683]>=0){e=i[26919],i[A>>2]=i[26918],i[A+4>>2]=e,i[A+8>>2]=i[26920];break i}T(A,i[26918],i[26919])}v=n+32|0}function s0(A,e){var r=0,f=0,k=0,n=0,t=0,o=0;r=v-160|0,v=r,i[r+104>>2]=0,i[r+76>>2]=72196,i[r+20>>2]=72176,n=i[18053],i[r+12>>2]=n,k=i[n-12>>2],n=r+12|0,i[k+n>>2]=i[18054],i[r+16>>2]=0,k=n+i[i[r+12>>2]-12>>2]|0,t=r+24|0,J0(k,t),u[k+80|0]=0,i[k+72>>2]=0,k=i[18055],i[r+20>>2]=k,o=r+20|0,i[o+i[k-12>>2]>>2]=i[18056],k=i[18052],i[r+12>>2]=k,i[n+i[k-12>>2]>>2]=i[18057],i[r+76>>2]=72196,i[r+12>>2]=72156,i[r+20>>2]=72176,n=R0(t),i[n>>2]=71232,k=r- -64|0,i[k>>2]=0,i[k+4>>2]=0,i[r+56>>2]=0,i[r+60>>2]=0,i[r+72>>2]=24;i:{e:{r:{if(i[e>>2]>0){for(;Y(o,27453,2),f=f+1|0,(f|0)<i[e>>2];);if(e=i[r+72>>2],!(e&16))break r}f=i[r+68>>2],e=i[r+48>>2],f>>>0<e>>>0&&(i[r+68>>2]=e,f=e),e=r+44|0;break e}if(!(e&8)){f=0,u[A+11|0]=0;break i}f=i[r+40>>2],e=r+32|0}e:{if(k=i[e>>2],f=f-k|0,f>>>0<2147483640){if(f>>>0>=11){t=f|7,e=p(t+1|0),i[A+8>>2]=t-2147483647,i[A>>2]=e,i[A+4>>2]=f,A=e;break e}if(u[A+11|0]=f,f)break e;f=0;break i}Q0(),H()}if(!f)break i;x(A,k,f)}u[A+f|0]=0,A=i[18051],i[r+12>>2]=A,i[i[A-12>>2]+(r+12|0)>>2]=i[18059],i[r+20>>2]=i[18060],i[n>>2]=71232,u[r+67|0]<0&&Z(i[r+56>>2]),E0(n),y0(r+76|0),v=r+160|0}function sX(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,t=0,o=0,s=0;if(k=v-16|0,v=k,e=p(168),i[e+4>>2]=0,i[e+8>>2]=0,i[e>>2]=91684,f=e+16|0,i[f+8>>2]=0,i[f+12>>2]=0,i[f+16>>2]=0,i[f+20>>2]=0,i[f+24>>2]=0,i[f+28>>2]=0,i[f+32>>2]=0,i[f>>2]=86356,i[e+60>>2]=0,i[e+64>>2]=0,i[e+52>>2]=0,i[e+56>>2]=0,i[e+72>>2]=-1,i[e+76>>2]=-1,i[e+80>>2]=-1,i[e+84>>2]=-1,i[e+88>>2]=0,i[e+92>>2]=0,i[e+96>>2]=0,i[e+100>>2]=0,i[e+104>>2]=0,i[e+108>>2]=0,u[e+112|0]=0,g[e+118>>1]=0,g[e+120>>1]=0,g[e+122>>1]=0,g[e+124>>1]=0,g[e+116>>1]=1,g[e+126>>1]=0,g[e+128>>1]=0,g[e+130>>1]=0,g[e+132>>1]=0,g[e+134>>1]=0,i[e+160>>2]=-65512,i[e+152>>2]=0,i[e+156>>2]=0,g[e+144>>1]=1,i[e+136>>2]=4718592,i[e+140>>2]=4718592,i[f>>2]=91724,u[e+159|0]=4,i[e+32>>2]=1835692135,u[e+148|0]=74,u[e+149|0]=80,u[e+150|0]=69,u[e+151|0]=71,n=i[r>>2],o=i[r+4>>2],(n|0)!=(o|0))for(s=e+52|0;;){t=i[n>>2],i[k+8>>2]=t,r=i[n+4>>2],i[k+12>>2]=r,r&&(i[r+4>>2]=i[r+4>>2]+1),i[t+16>>2]==1785751363&&r2(s,k+8|0),r=i[k+12>>2];i:{if(!r||(t=i[r+4>>2],i[r+4>>2]=t-1,t))break i;W[i[i[r>>2]+8>>2]](r),y(r)}if(n=n+8|0,(o|0)==(n|0))break}i[A+4>>2]=e,i[A>>2]=f,v=k+16|0}function jf(A,e,r,f,k,n,t,o,s,w,h,_){var B=0;B=v-16|0,v=B,i[B+12>>2]=A;i:{e:{if((A|0)==(n|0)){if(l[e|0]!=1)break e;if(A=0,u[e|0]=0,e=i[k>>2],i[k>>2]=e+1,u[e|0]=46,l[o+11|0]>>>7|0?e=i[o+4>>2]:e=l[o+11|0]&127,!e||(e=i[w>>2],(e-s|0)>159))break i;r=i[h>>2],i[w>>2]=e+4,i[e>>2]=r;break i}r:{if(l[o+11|0]>>>7|0?n=i[o+4>>2]:n=l[o+11|0]&127,!(!n|(A|0)!=(t|0))){if(l[e|0]!=1)break e;if(A=i[w>>2],(A-s|0)>159)break r;e=i[h>>2],i[w>>2]=A+4,i[A>>2]=e,A=0,i[h>>2]=0;break i}if(A=_5(_,_+112|0,B+12|0)-_|0,t=A>>2,(t|0)>27)break e;n=u[t+77744|0];f:{A:{if(A=A&-5,(A|0)!=88){if((A|0)!=96)break A;if(e=i[k>>2],(e|0)!=(f|0)&&(A=-1,f=u[e-1|0],r=u[r|0],((f-97>>>0<26?f&95:f)|0)!=((r-97>>>0<26?r&95:r)|0)))break i;i[k>>2]=e+1,u[e|0]=n;break r}u[r|0]=80;break f}if(A=n-97>>>0<26?n&95:n,(A|0)!=u[r|0]||(u[r|0]=A-65>>>0<26?A|32:A,l[e|0]!=1)||(u[e|0]=0,l[o+11|0]>>>7|0?A=i[o+4>>2]:A=l[o+11|0]&127,!A)||(A=i[w>>2],(A-s|0)>159))break f;e=i[h>>2],i[w>>2]=A+4,i[A>>2]=e}if(A=i[k>>2],i[k>>2]=A+1,u[A|0]=n,A=0,(t|0)>21)break i;i[h>>2]=i[h>>2]+1;break i}A=0;break i}A=-1}return v=B+16|0,A}function Of(A,e,r,f,k,n,t,o,s,w,h,_){var B=0;B=v-16|0,v=B,u[B+15|0]=A;i:{e:{if((A|0)==(n|0)){if(l[e|0]!=1)break e;if(A=0,u[e|0]=0,e=i[k>>2],i[k>>2]=e+1,u[e|0]=46,l[o+11|0]>>>7|0?e=i[o+4>>2]:e=l[o+11|0]&127,!e||(e=i[w>>2],(e-s|0)>159))break i;r=i[h>>2],i[w>>2]=e+4,i[e>>2]=r;break i}r:{if(l[o+11|0]>>>7|0?n=i[o+4>>2]:n=l[o+11|0]&127,!(!n|(A|0)!=(t|0))){if(l[e|0]!=1)break e;if(A=i[w>>2],(A-s|0)>159)break r;e=i[h>>2],i[w>>2]=A+4,i[A>>2]=e,A=0,i[h>>2]=0;break i}if(t=B5(_,_+28|0,B+15|0)-_|0,(t|0)>27)break e;n=u[t+77744|0];f:{A:switch((t&-2)-22|0){case 2:if(e=i[k>>2],(e|0)!=(f|0)&&(A=-1,f=u[e-1|0],r=u[r|0],((f-97>>>0<26?f&95:f)|0)!=((r-97>>>0<26?r&95:r)|0)))break i;i[k>>2]=e+1,u[e|0]=n;break r;case 0:u[r|0]=80;break f;default:break A}if(A=n-97>>>0<26?n&95:n,(A|0)!=u[r|0]||(u[r|0]=A-65>>>0<26?A|32:A,l[e|0]!=1)||(u[e|0]=0,l[o+11|0]>>>7|0?A=i[o+4>>2]:A=l[o+11|0]&127,!A)||(A=i[w>>2],(A-s|0)>159))break f;e=i[h>>2],i[w>>2]=A+4,i[A>>2]=e}if(A=i[k>>2],i[k>>2]=A+1,u[A|0]=n,A=0,(t|0)>21)break i;i[h>>2]=i[h>>2]+1;break i}A=0;break i}A=-1}return v=B+16|0,A}function I6(A,e,r,f,k,n,t){var o=0,s=0,w=0;i:{e:{s=i[A+248>>2],o=e>>s;r:{if((o|0)<0||(w=i[A+252>>2],(w|0)<=(o|0)))break r;if(s=r>>s,(s|0)<0|(s|0)>=i[A+256>>2])break e;if(!(l[(o+i[A+240>>2]|0)+G(s,w)|0]>>>k&1)){o=f,f=e;break i}if(o=f-1|0,s=k+1|0,I6(A,e,r,o,s,n,t),k=1<<f>>1,f=k+e|0,I6(A,f,r,o,s,16,t),r=r+k|0,I6(A,e,r,o,s,n,32),e=i[A+248>>2],k=f>>e,(k|0)<0)break r;for(e=r>>e;;){if(n=i[A+252>>2],(n|0)<=(k|0))break r;if((e|0)<0|i[A+256>>2]<=(e|0))break e;if(!(l[(i[A+240>>2]+k|0)+G(e,n)|0]>>>s&1)){n=16,t=32;break i}if(k=o-1|0,s=s+1|0,I6(A,f,r,k,s,16,32),e=1<<o>>1,n=e+f|0,I6(A,n,r,k,s,16,32),r=e+r|0,I6(A,f,r,k,s,16,32),t=i[A+248>>2],e=r>>t,o=k,f=n,k=n>>t,!((k|0)>=0))break}}D0(4656,10893,118,4231),H()}D0(4618,10893,119,4231),H()}if((o|0)!=31){for(e=1<<o,k=(f|0)/4|0,s=0;w=i[A+272>>2],o=(r+s|0)/4|0,(w|0)<=(k|0)|(o|0)>=i[A+276>>2]||(o=(k+i[A+260>>2]|0)+G(o,w)|0,u[o|0]=l[o|0]|n),s=s+4|0,(e|0)>(s|0););for(k=(r|0)/4|0,r=0;n=(r+f|0)/4|0,o=i[A+272>>2],(n|0)>=(o|0)|(k|0)>=i[A+276>>2]||(n=(n+i[A+260>>2]|0)+G(k,o)|0,u[n|0]=l[n|0]|t),r=r+4|0,(e|0)>(r|0););}}function Gn(A,e){var r=0,f=0,k=0,n=0,t=0,o=0,s=0,w=0,h=0;f=v-32|0,v=f;i:{if(l[A+52|0]==1){if(r=i[A+48>>2],!e)break i;u[A+52|0]=0,i[A+48>>2]=-1;break i}e:{if(l[A+53|0]==1){r=i[A+32>>2];r:{if(i[r+76>>2]<0){r=ot(r);break r}r=ot(r)}if((r|0)!=-1&&(i[f+24>>2]=r),(r|0)==-1)break e;r=i[f+24>>2];r:{if(!e){if(!Gu(r,i[A+32>>2]))break e;break r}i[A+48>>2]=r}r=i[f+24>>2];break i}for(i[f+24>>2]=1,k=v-16|0,v=k,v=k+16|0,k=A+44|0,n=f+24|0,k=i[(i[n>>2]<i[k>>2]?k:n)>>2],n=(k|0)>0?k:0;;){if((r|0)!=(n|0)){if(t=he(i[A+32>>2]),(t|0)==-1)break e;u[(f+24|0)+r|0]=t,r=r+1|0;continue}break}w=f+24|0;r:{for(;;){f:{n=i[A+40>>2],r=i[n>>2],h=i[n+4>>2],o=f+24|0,t=o+k|0;A:switch(s=i[A+36>>2],(W[i[i[s>>2]+16>>2]](s,n,o,t,f+16|0,f+20|0,w,f+12|0)|0)-1|0){case 1:break e;case 0:break A;case 2:break f;default:break r}if(n=i[A+40>>2],i[n>>2]=r,i[n+4>>2]=h,(k|0)==8||(r=he(i[A+32>>2]),(r|0)==-1))break e;u[t|0]=r,k=k+1|0;continue}break}i[f+20>>2]=u[f+24|0]}r:{if(!e)for(;;){if((k|0)<=0)break r;if(k=k-1|0,(Zi(u[k+(f+24|0)|0],i[A+32>>2])|0)==-1)break e}i[A+48>>2]=i[f+20>>2]}r=i[f+20>>2];break i}r=-1}return v=f+32|0,r}function Ir(A,e,r,f,k,n,t){var o=0,s=0,w=0,h=0,_=0,B=0,m=0,X=0,Q=0;m=v-16|0,v=m,h=c0(t,129752),s=m+4|0,t=c0(t,129824),W[i[i[t>>2]+20>>2]](s,t),l[s+11|0]>>>7|0?o=i[s+4>>2]:o=l[s+11|0]&127;i:{if(!o){W[i[i[h>>2]+48>>2]](h,A,r,f)|0,t=(r-A<<2)+f|0,i[n>>2]=t;break i}i[n>>2]=f;e:{r:switch(s=A,o=l[s|0],o-43|0){case 0:case 2:break r;default:break e}s=W[i[i[h>>2]+44>>2]](h,o<<24>>24)|0,o=i[n>>2],i[n>>2]=o+4,i[o>>2]=s,s=A+1|0}for(l[s|0]!=48|(r-s|0)<2|(l[s+1|0]|32)!=120||(o=W[i[i[h>>2]+44>>2]](h,48)|0,w=i[n>>2],i[n>>2]=w+4,i[w>>2]=o,o=W[i[i[h>>2]+44>>2]](h,u[s+1|0])|0,w=i[n>>2],i[n>>2]=w+4,i[w>>2]=o,s=s+2|0),N6(s,r),X=W[i[i[t>>2]+16>>2]](t)|0,w=0,t=s;;){if(r>>>0<=t>>>0)cr((s-A<<2)+f|0,i[n>>2]),t=i[n>>2];else{o=m+4|0;e:{if(l[o+11|0]>>>7|0){_=i[o>>2];break e}_=o}Q=!l[_+w|0],l[o+11|0]>>>7|0?_=i[o>>2]:_=o,Q|u[_+w|0]!=(B|0)||(B=i[n>>2],i[n>>2]=B+4,i[B>>2]=X,l[o+11|0]>>>7|0?o=i[o+4>>2]:o=l[o+11|0]&127,w=(o-1>>>0>w>>>0)+w|0,B=0),o=W[i[i[h>>2]+44>>2]](h,u[t|0])|0,_=i[n>>2],i[n>>2]=_+4,i[_>>2]=o,t=t+1|0,B=B+1|0;continue}break}}i[k>>2]=(e|0)==(r|0)?t:(e-A<<2)+f|0,s2(m+4|0),v=m+16|0}function A8(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0;if(r>>>0>=512)return r&&x(A,e,r),A|0;f=A+r|0;i:{if(!((A^e)&3)){e:{if(!(A&3)){r=A;break e}if(!r){r=A;break e}for(r=A;;){if(u[r|0]=l[e|0],e=e+1|0,r=r+1|0,!(r&3))break e;if(!(r>>>0<f>>>0))break}}k=f&-4;e:{if(f>>>0<64||(n=k+-64|0,n>>>0<r>>>0))break e;for(;i[r>>2]=i[e>>2],i[r+4>>2]=i[e+4>>2],i[r+8>>2]=i[e+8>>2],i[r+12>>2]=i[e+12>>2],i[r+16>>2]=i[e+16>>2],i[r+20>>2]=i[e+20>>2],i[r+24>>2]=i[e+24>>2],i[r+28>>2]=i[e+28>>2],i[r+32>>2]=i[e+32>>2],i[r+36>>2]=i[e+36>>2],i[r+40>>2]=i[e+40>>2],i[r+44>>2]=i[e+44>>2],i[r+48>>2]=i[e+48>>2],i[r+52>>2]=i[e+52>>2],i[r+56>>2]=i[e+56>>2],i[r+60>>2]=i[e+60>>2],e=e- -64|0,r=r- -64|0,n>>>0>=r>>>0;);}if(r>>>0>=k>>>0)break i;for(;i[r>>2]=i[e>>2],e=e+4|0,r=r+4|0,k>>>0>r>>>0;);break i}if(f>>>0<4){r=A;break i}if(k=f-4|0,k>>>0<A>>>0){r=A;break i}for(r=A;u[r|0]=l[e|0],u[r+1|0]=l[e+1|0],u[r+2|0]=l[e+2|0],u[r+3|0]=l[e+3|0],e=e+4|0,r=r+4|0,k>>>0>=r>>>0;);}if(r>>>0<f>>>0)for(;u[r|0]=l[e|0],e=e+1|0,r=r+1|0,(f|0)!=(r|0););return A|0}function ii(A){A=A|0;var e=0,r=0,f=0,k=0,n=0,t=0,o=0;e=v-96|0,v=e,u[e+56|0]=0,i[e+68>>2]=0,i[e+72>>2]=0,i[e+88>>2]=0,i[e+80>>2]=0,i[e+84>>2]=0,i[e+48>>2]=0,i[e+52>>2]=0,i[e+60>>2]=0,i[e+64>>2]=0,r=i[A+100>>2],i[e+40>>2]=i[r+48>>2],r=i[r+52>>2],i[e+44>>2]=r,r&&(i[r+4>>2]=i[r+4>>2]+1),r=i[A+116>>2],f=i[e+44>>2],i[e+8>>2]=i[e+40>>2],i[e+12>>2]=f,Ku(e+48|0,e+8|0,r),A=i[A+448>>2],i[e+32>>2]=i[e+88>>2],r=i[e+84>>2],i[e+24>>2]=i[e+80>>2],i[e+28>>2]=r,r=i[e+76>>2],i[e+16>>2]=i[e+72>>2],i[e+20>>2]=r,f=i[e+52>>2],i[e+52>>2]=0,r=i[e+48>>2],i[e+48>>2]=0,k=i[e+60>>2],i[e+60>>2]=0,n=i[e+64>>2],i[e+64>>2]=0,t=i[e+68>>2],i[e+68>>2]=0,o=l[e+56|0],i[A+8>>2]=r,r=i[A+12>>2],i[A+12>>2]=f;i:{if(!r||(f=i[r+4>>2],i[r+4>>2]=f-1,f))break i;W[i[i[r>>2]+8>>2]](r),y(r)}u[A+16|0]=o,r=i[A+20>>2],r&&(i[A+24>>2]=r,Z(r)),i[A+28>>2]=t,i[A+24>>2]=n,i[A+20>>2]=k,i[A+48>>2]=i[e+32>>2],r=i[e+28>>2],i[A+40>>2]=i[e+24>>2],i[A+44>>2]=r,r=i[e+20>>2],i[A+32>>2]=i[e+16>>2],i[A+36>>2]=r,A=i[e+60>>2],A&&(i[e+64>>2]=A,Z(A)),A=i[e+52>>2];i:{if(!A||(r=i[A+4>>2],i[A+4>>2]=r-1,r))break i;W[i[i[A>>2]+8>>2]](A),y(A)}v=e+96|0}function Cr(A,e,r,f,k,n,t){var o=0,s=0,w=0,h=0,_=0,B=0,m=0,X=0,Q=0;m=v-16|0,v=m,h=c0(t,129760),s=m+4|0,t=c0(t,129816),W[i[i[t>>2]+20>>2]](s,t),l[s+11|0]>>>7|0?o=i[s+4>>2]:o=l[s+11|0]&127;i:{if(!o){W[i[i[h>>2]+32>>2]](h,A,r,f)|0,t=(r-A|0)+f|0,i[n>>2]=t;break i}i[n>>2]=f;e:{r:switch(s=A,o=l[s|0],o-43|0){case 0:case 2:break r;default:break e}s=W[i[i[h>>2]+28>>2]](h,o<<24>>24)|0,o=i[n>>2],i[n>>2]=o+1,u[o|0]=s,s=A+1|0}for(l[s|0]!=48|(r-s|0)<2|(l[s+1|0]|32)!=120||(o=W[i[i[h>>2]+28>>2]](h,48)|0,w=i[n>>2],i[n>>2]=w+1,u[w|0]=o,o=W[i[i[h>>2]+28>>2]](h,u[s+1|0])|0,w=i[n>>2],i[n>>2]=w+1,u[w|0]=o,s=s+2|0),N6(s,r),X=W[i[i[t>>2]+16>>2]](t)|0,w=0,t=s;;){if(r>>>0<=t>>>0)N6((s-A|0)+f|0,i[n>>2]),t=i[n>>2];else{o=m+4|0;e:{if(l[o+11|0]>>>7|0){_=i[o>>2];break e}_=o}Q=!l[_+w|0],l[o+11|0]>>>7|0?_=i[o>>2]:_=o,Q|u[_+w|0]!=(B|0)||(B=i[n>>2],i[n>>2]=B+1,u[B|0]=X,l[o+11|0]>>>7|0?o=i[o+4>>2]:o=l[o+11|0]&127,w=(o-1>>>0>w>>>0)+w|0,B=0),o=W[i[i[h>>2]+28>>2]](h,u[t|0])|0,_=i[n>>2],i[n>>2]=_+1,u[_|0]=o,t=t+1|0,B=B+1|0;continue}break}}i[k>>2]=(e|0)==(r|0)?t:(e-A|0)+f|0,s2(m+4|0),v=m+16|0}function wX(A,e,r,f,k,n){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,e=v-32|0,v=e,n=i[r+12>>2];i:{if((n|0)>=9){i[A+8>>2]=0,i[A>>2]=0,i[A+4>>2]=0;break i}if((n|0)!=8){i[A+8>>2]=0,i[A>>2]=0,i[A+4>>2]=0;break i}if(!(i[r>>2]==1&i[r+4>>2]==3)){i[A+8>>2]=0,i[A>>2]=0,i[A+4>>2]=0;break i}e:switch(C[f+20>>1]-11|0){case 0:case 3:i[A+8>>2]=0,i[A>>2]=0,i[A+4>>2]=0;break i;default:break e}if(i[A+8>>2]=0,i[A>>2]=0,i[A+4>>2]=0,n=i[f+4>>2],!((n|0)==3|(l[k+12|0]?i[k+4>>2]!=1:0))){i[e+12>>2]=n,i[e+8>>2]=0,r=l[r+8|0],i[e+20>>2]=8,u[e+16|0]=r,r=l[f+19|0]|l[f+20|0]<<8|(l[f+21|0]<<16|l[f+22|0]<<24),u[e+27|0]=r,u[e+28|0]=r>>>8,u[e+29|0]=r>>>16,u[e+30|0]=r>>>24,i[e+24>>2]=i[f+16>>2],i[e+4>>2]=11,S8(A,e+8|0,e+4|0);break i}i[e+8>>2]=0,i[e+12>>2]=3,r=l[r+8|0],i[e+20>>2]=8,u[e+16|0]=r,r=l[f+19|0]|l[f+20|0]<<8|(l[f+21|0]<<16|l[f+22|0]<<24),u[e+27|0]=r,u[e+28|0]=r>>>8,u[e+29|0]=r>>>16,u[e+30|0]=r>>>24,i[e+24>>2]=i[f+16>>2],r=p(28),f=i[e+28>>2],i[r+16>>2]=i[e+24>>2],i[r+20>>2]=f,f=i[e+20>>2],i[r+8>>2]=i[e+16>>2],i[r+12>>2]=f,f=i[e+12>>2],i[r>>2]=i[e+8>>2],i[r+4>>2]=f,i[r+24>>2]=11,f=r+28|0,i[A+8>>2]=f,i[A>>2]=r,i[A+4>>2]=f}v=e+32|0}function C6(A,e,r){var f=0,k=0,n=0,t=0,o=0,s=0;o=v-16|0,v=o,n=i[A+108>>2],t=i[A+104>>2],s=n-t>>4;i:{if((t|0)==(n|0))break i;for(k=s>>>0<=1?1:s;;){if(i[t+(f<<4)>>2]==(e|0))break i;if(f=f+1|0,(k|0)==(f|0))break}f=k}if((f|0)==(s|0)){t=A+104|0,i[o+12>>2]=0,i[o+4>>2]=0,i[o+8>>2]=0,i[o>>2]=e;i:{if(n>>>0<u0[A+112>>2]){i[n+12>>2]=0,i[n+4>>2]=0,i[n+8>>2]=0,i[n>>2]=e,i[A+108>>2]=n+16;break i}if(k=Yr(t,o),e=i[o+4>>2],i[A+108>>2]=k,!e)break i;i[o+8>>2]=e,Z(e)}t=i[t>>2]}i:{e:{t=(f<<4)+t|0,A=i[t+4>>2],e=i[t+8>>2];r:{if((A|0)!=(e|0))for(k=C[r+2>>1],f=A;;){if((k|0)==C[f+2>>1])break r;if(f=f+4|0,(e|0)==(f|0))break}k=i[t+12>>2];f:{if(k>>>0>e>>>0){A=C[r>>1]|C[r+2>>1]<<16,g[e>>1]=A,g[e+2>>1]=A>>>16,r=e+4|0;break f}if(e=e-A|0,s=e>>2,f=s+1|0,f>>>0>=1073741824)break e;if(k=k-A|0,n=k>>1,k=k>>>0>=2147483644?1073741823:f>>>0<n>>>0?n:f,k){if(k>>>0>=1073741824)break i;f=p(k<<2)}else f=0;if(n=f+e|0,r=C[r>>1]|C[r+2>>1]<<16,g[n>>1]=r,g[n+2>>1]=r>>>16,s=n-(s<<2)|0,e&&x(s,A,e),i[t+12>>2]=f+(k<<2),r=n+4|0,i[t+8>>2]=r,i[t+4>>2]=s,!A)break f;Z(A)}i[t+8>>2]=r}v=o+16|0;return}G0(),H()}z0(),H()}function Xn(A,e,r,f){var k=0,n=0,t=0,o=0,s=0,w=0,h=0;i:{e:{if((f|0)<=0)break e;if(t=i[A+8>>2],o=i[A+4>>2],(t-o|0)>=(f|0)){r:{if((f|0)<=(o|0)){t=e+f|0,n=o;break r}t=e+o|0;f:{if((t|0)==(r|0)){n=o;break f}for(k=t,n=o;u[n|0]=l[k|0],n=n+1|0,k=k+1|0,(k|0)!=(r|0););}if(i[A+4>>2]=n,(o|0)<=0)break e}s=f,k=n,r=k-f|0;r:{if(o>>>0<=r>>>0)break r;if(w=f+o|0,h=w-k&7,h)for(f=0;u[k|0]=l[r|0],k=k+1|0,r=r+1|0,f=f+1|0,(h|0)!=(f|0););if(n-w>>>0>=4294967289)break r;for(;u[k|0]=l[r|0],u[k+1|0]=l[r+1|0],u[k+2|0]=l[r+2|0],u[k+3|0]=l[r+3|0],u[k+4|0]=l[r+4|0],u[k+5|0]=l[r+5|0],u[k+6|0]=l[r+6|0],u[k+7|0]=l[r+7|0],k=k+8|0,r=r+8|0,(o|0)!=(r|0););}i[A+4>>2]=k;r:{if((n|0)==(s|0)||(A=n-s|0,!A))break r;x(n-A|0,0,A)}if((e|0)==(t|0)||(A=t-e|0,!A))break e;x(0,e,A);return}if(n=i[A>>2],r=(o-n|0)+f|0,(r|0)<0)break i;k=0-n|0,t=t-n|0,s=t<<1,t=t>>>0>=1073741823?2147483647:r>>>0<s>>>0?s:r,t?r=p(t):r=0,s=k+r|0,f&&x(s,e,f),e=f+s|0,o&&x(e,0,o),i[A+4>>2]=0,k&&x(r,n,k),i[A+8>>2]=r+t,i[A+4>>2]=e+o,i[A>>2]=r,n&&Z(n)}return}G0(),H()}function hX(A,e,r,f,k,n,t,o){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,t=t|0,o=o|0;var s=0,w=0;w=v-16|0,v=w,s=p(36),i[s+32>>2]=t,i[s+28>>2]=n,i[s+24>>2]=k,i[s+20>>2]=f,i[s+16>>2]=r,i[s+12>>2]=95848,i[s+4>>2]=0,i[s+8>>2]=0,i[s>>2]=96140,r=i[e+8>>2],i[w+12>>2]=s,f=s+12|0,i[w+8>>2]=f,i[s+4>>2]=i[s+4>>2]+1,r2(r+12|0,w+8|0),r=i[w+12>>2];i:{if(!r||(k=i[r+4>>2],i[r+4>>2]=k-1,k))break i;W[i[i[r>>2]+8>>2]](r),y(r)}i:{if(!o||(i[s+4>>2]=i[s+4>>2]+1,r=p(24),i[s+4>>2]=i[s+4>>2]+1,i[r+20>>2]=s,i[r+16>>2]=f,k=i[e+8>>2],f=i[e+12>>2],f&&(i[f+4>>2]=i[f+4>>2]+1),i[r+12>>2]=f,i[r+8>>2]=k,k=i[e>>2],f=i[e+4>>2],f&&(i[f+4>>2]=i[f+4>>2]+1),i[r+4>>2]=f,i[r>>2]=k,i[o>>2]=r,r=i[s+4>>2],i[s+4>>2]=r-1,r))break i;W[i[i[s>>2]+8>>2]](s),y(s)}f=i[e>>2],r=i[e+4>>2];i:{if(r){if(i[r+4>>2]=i[r+4>>2]+1,Uo(f,i[i[e+8>>2]>>2],t),i[A+8>>2]=i[24058],e=i[24057],i[A>>2]=i[24056],i[A+4>>2]=e,A=i[r+4>>2],i[r+4>>2]=A-1,A)break i;W[i[i[r>>2]+8>>2]](r),y(r);break i}Uo(f,i[i[e+8>>2]>>2],t),i[A+8>>2]=i[24058],e=i[24057],i[A>>2]=i[24056],i[A+4>>2]=e}A=i[s+4>>2],i[s+4>>2]=A-1,A||(W[i[i[s>>2]+8>>2]](s),y(s)),v=w+16|0}function _X(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0;var k=0,n=0,t=0,o=0,s=0,w=0,h=0,_=0,B=0,m=0,X=0,Q=0,V=0;if(k=v+-64|0,v=k,kt(k+48|0,i[A+8>>2]),o=i[k+48>>2],B=i[k+52>>2],(o|0)!=(B|0)){for(X=i[24188],Q=i[24189];;){i:{e:{if(t=i[o>>2],(t|0)==i[i[A>>2]+24>>2])break e;if(Mf(k+24|0,i[A+8>>2],t),t=3,n=l[k+44|0],!n){if(s=i[k+28>>2],s&&(i[s+4>>2]=i[s+4>>2]+1),_=i[k+24>>2],t=i[_+244>>2],w=i[_+248>>2],w&&(i[w+4>>2]=i[w+4>>2]+1),t){gA(k+8|0,t,e),m=i[k+12>>2],n=i[k+8>>2];r:{if((m|0)==(n|0)|f>>>0<=h>>>0)break r;for(V=i[i[A>>2]+24>>2],t=n;;){if(i[t>>2]!=(V|0)){if(t=t+4|0,(m|0)!=(t|0))continue;break r}break}i[(h<<2)+r>>2]=i[_+24>>2],h=h+1|0}n&&(i[k+12>>2]=n,Z(n)),t=(f|0)==(h|0)?2:0}else t=3;r:{if(!w||(n=i[w+4>>2],i[w+4>>2]=n-1,n))break r;W[i[i[w>>2]+8>>2]](w),y(w)}r:{if(!s||(n=i[s+4>>2],i[s+4>>2]=n-1,n))break r;W[i[i[s>>2]+8>>2]](s),y(s)}n=l[k+44|0]}switch((n|0)!=255&&(i[k+8>>2]=X,i[k+12>>2]=Q,W[i[(k+8|0)+(n<<2)>>2]](k+63|0,k+24|0)),t|0){case 0:case 3:break e;default:break i}}if(o=o+4|0,(B|0)!=(o|0))continue}break}o=i[k+48>>2]}return o&&(i[k+52>>2]=o,Z(o)),v=k- -64|0,h|0}function A6(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,t=0,o=0,s=0;f=v-160|0,v=f,i[f+104>>2]=0,i[f+76>>2]=72500,k=i[18128],i[f+20>>2]=k,o=i[k-12>>2],k=f+20|0,i[o+k>>2]=i[18129],t=k+i[i[f+20>>2]-12>>2]|0,n=f+24|0,J0(t,n),u[t+80|0]=0,i[t+72>>2]=0,i[f+76>>2]=72500,i[f+20>>2]=72480,t=R0(n),i[t>>2]=71232,n=f- -64|0,i[n>>2]=0,i[n+4>>2]=0,i[f+56>>2]=0,i[f+60>>2]=0,i[f+72>>2]=16,n=f+8|0,Y2(n,e,r),s=k,o=n,k=u[f+19|0],n=(k|0)<0,Y(s,n?i[f+8>>2]:o,n?i[f+12>>2]:k),u[f+19|0]<0&&Z(i[f+8>>2]),k=f+8|0,mr(k,e,r,0),e=u[f+19|0],r=(e|0)<0,Y(f+20|0,r?i[f+8>>2]:k,r?i[f+12>>2]:e),u[f+19|0]<0&&Z(i[f+8>>2]),e=i[f+72>>2];i:{e:{if(e&16){r=i[f+68>>2],e=i[f+48>>2],r>>>0<e>>>0&&(i[f+68>>2]=e,r=e),e=f+44|0;break e}if(!(e&8)){r=0,u[A+11|0]=0;break i}r=i[f+40>>2],e=f+32|0}e:{if(k=i[e>>2],r=r-k|0,r>>>0<2147483640){if(r>>>0>=11){n=r|7,e=p(n+1|0),i[A+8>>2]=n-2147483647,i[A>>2]=e,i[A+4>>2]=r,A=e;break e}if(u[A+11|0]=r,r)break e;r=0;break i}Q0(),H()}if(!r)break i;x(A,k,r)}u[A+r|0]=0,A=i[18127],i[f+20>>2]=A,i[i[A-12>>2]+(f+20|0)>>2]=i[18130],i[t>>2]=71232,u[f+67|0]<0&&Z(i[f+56>>2]),E0(t),y0(f+76|0),v=f+160|0}function BX(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,t=0,o=0,s=0;f=v-160|0,v=f,i[f+104>>2]=0,i[f+76>>2]=72500,k=i[18128],i[f+20>>2]=k,o=i[k-12>>2],k=f+20|0,i[o+k>>2]=i[18129],t=k+i[i[f+20>>2]-12>>2]|0,n=f+24|0,J0(t,n),u[t+80|0]=0,i[t+72>>2]=0,i[f+76>>2]=72500,i[f+20>>2]=72480,t=R0(n),i[t>>2]=71232,n=f- -64|0,i[n>>2]=0,i[n+4>>2]=0,i[f+56>>2]=0,i[f+60>>2]=0,i[f+72>>2]=16,n=f+8|0,Y2(n,e,r),s=k,o=n,k=u[f+19|0],n=(k|0)<0,Y(s,n?i[f+8>>2]:o,n?i[f+12>>2]:k),u[f+19|0]<0&&Z(i[f+8>>2]),k=f+8|0,mr(k,e,r,1),e=u[f+19|0],r=(e|0)<0,Y(f+20|0,r?i[f+8>>2]:k,r?i[f+12>>2]:e),u[f+19|0]<0&&Z(i[f+8>>2]),e=i[f+72>>2];i:{e:{if(e&16){r=i[f+68>>2],e=i[f+48>>2],r>>>0<e>>>0&&(i[f+68>>2]=e,r=e),e=f+44|0;break e}if(!(e&8)){r=0,u[A+11|0]=0;break i}r=i[f+40>>2],e=f+32|0}e:{if(k=i[e>>2],r=r-k|0,r>>>0<2147483640){if(r>>>0>=11){n=r|7,e=p(n+1|0),i[A+8>>2]=n-2147483647,i[A>>2]=e,i[A+4>>2]=r,A=e;break e}if(u[A+11|0]=r,r)break e;r=0;break i}Q0(),H()}if(!r)break i;x(A,k,r)}u[A+r|0]=0,A=i[18127],i[f+20>>2]=A,i[i[A-12>>2]+(f+20|0)>>2]=i[18130],i[t>>2]=71232,u[f+67|0]<0&&Z(i[f+56>>2]),E0(t),y0(f+76|0),v=f+160|0}function Wn(A,e){var r=0,f=0;l[A|0]&&(r=A,f=v0(e,2),u[r+1|0]=f,r=A,f=v0(e,1),u[r+2|0]=f,r=A,f=v0(e,5),i[r+4>>2]=f,r=A,f=v0(e,1),u[r+8|0]=f,r=A,f=v0(e,1),u[r+9|0]=f,r=A,f=v0(e,1),u[r+10|0]=f,r=A,f=v0(e,1),u[r+11|0]=f,r=A,f=v0(e,1),u[r+12|0]=f,r=A,f=v0(e,1),u[r+13|0]=f,r=A,f=v0(e,1),u[r+14|0]=f,r=A,f=v0(e,1),u[r+15|0]=f,r=A,f=v0(e,1),u[r+16|0]=f,r=A,f=v0(e,1),u[r+17|0]=f,r=A,f=v0(e,1),u[r+18|0]=f,r=A,f=v0(e,1),u[r+19|0]=f,r=A,f=v0(e,1),u[r+20|0]=f,r=A,f=v0(e,1),u[r+21|0]=f,r=A,f=v0(e,1),u[r+22|0]=f,r=A,f=v0(e,1),u[r+23|0]=f,r=A,f=v0(e,1),u[r+24|0]=f,r=A,f=v0(e,1),u[r+25|0]=f,r=A,f=v0(e,1),u[r+26|0]=f,r=A,f=v0(e,1),u[r+27|0]=f,r=A,f=v0(e,1),u[r+28|0]=f,r=A,f=v0(e,1),u[r+29|0]=f,r=A,f=v0(e,1),u[r+30|0]=f,r=A,f=v0(e,1),u[r+31|0]=f,r=A,f=v0(e,1),u[r+32|0]=f,r=A,f=v0(e,1),u[r+33|0]=f,r=A,f=v0(e,1),u[r+34|0]=f,r=A,f=v0(e,1),u[r+35|0]=f,r=A,f=v0(e,1),u[r+36|0]=f,r=A,f=v0(e,1),u[r+37|0]=f,r=A,f=v0(e,1),u[r+38|0]=f,r=A,f=v0(e,1),u[r+39|0]=f,r=A,f=v0(e,1),u[r+40|0]=f,r=A,f=v0(e,1),u[r+41|0]=f,r=A,f=v0(e,1),u[r+42|0]=f,r=A,f=v0(e,1),u[r+43|0]=f,E6(e,44)),l[A+44|0]&&(r=A,f=v0(e,8),i[r+48>>2]=f)}function vX(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0;var k=0,n=0,t=0,o=0,s=0,w=0;f=v-32|0,v=f,z2(f,e,r),u[f+19|0]<0&&Z(i[f+8>>2]);i:{if(l[e+97|0]){t1(A,e,10548);break i}if(o=X2(r),k=i[r>>2],n=W[i[i[k>>2]+8>>2]](k)|0,s=i[r>>2],k=l0,n=o+n|0,k=n>>>0<o>>>0?k+1|0:k,W[i[i[s>>2]+12>>2]](s,n,k)|0){if(u[f+20|0]=0,u[f+31|0]=0,q(A,2,100,f+20|0),u[f+31|0]>=0)break i;Z(i[f+20>>2]);break i}t=i[e+108>>2],k=i[e+104>>2],n=t-k|0;e:{if(n>>>0<o>>>0){if(s=o-n|0,w=i[e+112>>2],s>>>0<=w-t>>>0){s&&o0(t,0,s),i[e+108>>2]=t+s;break e}if(t=w-k|0,w=t<<1,w=t>>>0>=1073741823?2147483647:o>>>0<w>>>0?w:o,t=p(w),s&&o0(n+t|0,0,s),n&&x(t,k,n),i[e+112>>2]=t+w,i[e+108>>2]=o+t,i[e+104>>2]=t,!k)break e;Z(k);break e}if(o>>>0>=n>>>0)break e;i[e+108>>2]=k+o}if(o)for(k=0;n=X2(r),u[i[e+104>>2]+k|0]=n,k=k+1|0,(o|0)!=(k|0););if(l[r+20|0]==1){if(u[f+20|0]=0,u[f+31|0]=0,q(A,2,100,f+20|0),u[f+31|0]>=0)break i;Z(i[f+20>>2]);break i}if(e=i[26917],i[A>>2]=i[26916],i[A+4>>2]=e,A=A+8|0,u[107683]>=0){e=i[26919],i[A>>2]=i[26918],i[A+4>>2]=e,i[A+8>>2]=i[26920];break i}T(A,i[26918],i[26919])}v=f+32|0}function mX(A,e){A=A|0,e=e|0;var r=0,f=0,k=0,n=0;r=i[e+104>>2],f=i[e+108>>2];i:{e:{if((r|0)!=(f|0))for(;;){r:{if(k=i[r>>2],!k||(k=W0(k,86580,98564),!k))break r;if(r=i[r+4>>2],!r)break e;i[r+4>>2]=i[r+4>>2]+1;break i}if(r=r+8|0,(f|0)==(r|0))break}k=0}r=0}f=p(112),i[f+4>>2]=0,i[f+8>>2]=0,i[f>>2]=97280,r&&(i[r+4>>2]=i[r+4>>2]+1),n=f+16|0,i[f+64>>2]=0,i[f+56>>2]=0,i[f+60>>2]=0,i[f+24>>2]=0,i[f+28>>2]=0,i[f+36>>2]=0,i[f+40>>2]=0,i[f+72>>2]=0,i[f+76>>2]=0,i[f+84>>2]=r,i[f+80>>2]=k,u[f+32|0]=0,i[f+44>>2]=0,i[f+48>>2]=0,i[f+16>>2]=98584;i:{if(!r){u[f+104|0]=0,u[f+88|0]=0;break i}if(i[r+4>>2]=i[r+4>>2]+1,u[f+104|0]=0,u[f+88|0]=0,k=i[r+4>>2],i[r+4>>2]=k-1,k)break i;W[i[i[r>>2]+8>>2]](r),y(r)}i[e+448>>2]=n,k=i[e+452>>2],i[e+452>>2]=f;i:{if(!k||(e=i[k+4>>2],i[k+4>>2]=e-1,e))break i;W[i[i[k>>2]+8>>2]](k),y(k)}e=i[26917],i[A>>2]=i[26916],i[A+4>>2]=e,A=A+8|0;i:{if(u[107683]>=0){e=i[26919],i[A>>2]=i[26918],i[A+4>>2]=e,i[A+8>>2]=i[26920];break i}T(A,i[26918],i[26919])}i:{if(!r||(A=i[r+4>>2],i[r+4>>2]=A-1,A))break i;W[i[i[r>>2]+8>>2]](r),y(r)}}function ZX(A,e,r,f,k,n,t,o,s){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,t=t|0,o=o|0,s=s|0;var w=0,h=0;h=v-16|0,v=h,w=p(52),i[w+32>>2]=0,i[w+36>>2]=0,i[w+12>>2]=95936,i[w+4>>2]=0,i[w+8>>2]=0,i[w+28>>2]=n,i[w+24>>2]=k,i[w+20>>2]=f,i[w+16>>2]=r,i[w>>2]=96180,i[w+40>>2]=0,i[w+44>>2]=0,k=0,i[w+48>>2]=0;i:{e:{if(!o){n=0;break e}if((o|0)<0)break i;n=p(o),o&&o0(n,0,o),k=n+o|0,i[w+40>>2]=k,i[w+36>>2]=k,i[w+32>>2]=n}r=k-n|0,r&&x(n,t,r),r=i[e+8>>2],i[h+12>>2]=w,f=w+12|0,i[h+8>>2]=f,i[w+4>>2]=i[w+4>>2]+1,r2(r+12|0,h+8|0),r=i[h+12>>2];e:{if(!r||(k=i[r+4>>2],i[r+4>>2]=k-1,k))break e;W[i[i[r>>2]+8>>2]](r),y(r)}e:{if(!s||(i[w+4>>2]=i[w+4>>2]+1,r=p(24),i[w+4>>2]=i[w+4>>2]+1,i[r+20>>2]=w,i[r+16>>2]=f,k=i[e+8>>2],f=i[e+12>>2],f&&(i[f+4>>2]=i[f+4>>2]+1),i[r+12>>2]=f,i[r+8>>2]=k,f=i[e>>2],e=i[e+4>>2],e&&(i[e+4>>2]=i[e+4>>2]+1),i[r+4>>2]=e,i[r>>2]=f,i[s>>2]=r,e=i[w+4>>2],i[w+4>>2]=e-1,e))break e;W[i[i[w>>2]+8>>2]](w),y(w)}e=i[24057],i[A>>2]=i[24056],i[A+4>>2]=e,i[A+8>>2]=i[24058],A=i[w+4>>2],i[w+4>>2]=A-1,A||(W[i[i[w>>2]+8>>2]](w),y(w)),v=h+16|0;return}G0(),H()}function Qn(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0;f=v-48|0,v=f;i:{if(!r){if(u[f+16|0]=0,u[f+27|0]=0,r=q(f+28|0,5,2001,f+16|0),u[f+27|0]<0&&Z(i[f+16>>2]),b0(A,r,i[e>>2]),u[r+19|0]>=0)break i;Z(i[r+8>>2]);break i}To(f+8|0,i[e>>2]),n=i[f+8>>2];e:{if(!n){if(u[f+16|0]=0,u[f+27|0]=0,r=q(f+28|0,2,124,f+16|0),u[f+27|0]<0&&Z(i[f+16>>2]),b0(A,r,i[e>>2]),u[r+19|0]>=0)break e;Z(i[r+8>>2]);break e}if(k=W0(n,100660,94348),k){if(r=i[f+12>>2],r&&(i[r+4>>2]=i[r+4>>2]+1),n=f+28|0,W[i[i[k>>2]+52>>2]](n,k),b0(A,n,i[e>>2]),u[f+47|0]<0&&Z(i[f+36>>2]),!r||(A=i[r+4>>2],i[r+4>>2]=A-1,A))break e;W[i[i[r>>2]+8>>2]](r),y(r);break e}k=p(16),i[k+8>>2]=0,i[k+12>>2]=0,i[r>>2]=k,r=i[f+12>>2],i[f+8>>2]=0,i[f+12>>2]=0,i[k+4>>2]=r,i[k>>2]=n,r=i[e>>2],n=i[e+4>>2];r:{if(!n){i[k+12>>2]=n,i[k+8>>2]=r;break r}if(i[n+4>>2]=i[n+4>>2]+1,i[k+8>>2]=r,r=i[k+12>>2],i[k+12>>2]=n,!r||(k=i[r+4>>2],i[r+4>>2]=k-1,k))break r;W[i[i[r>>2]+8>>2]](r),y(r)}b0(A,107664,i[e>>2])}if(A=i[f+12>>2],!A||(e=i[A+4>>2],i[A+4>>2]=e-1,e))break i;W[i[i[A>>2]+8>>2]](A),y(A)}v=f+48|0}function GX(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0;var k=0,n=0,t=0,o=0,s=0,w=0;k=v-48|0,v=k;i:{e:{r:{if(!(r&&e)){i[A>>2]=5,i[A+4>>2]=2001,i[A+8>>2]=16735;break r}if(w=i[e>>2],n=i[i[e+8>>2]>>2],t=h2(r),t>>>0>=2147483640)break e;f:{A:{if(t>>>0>=11){s=t|7,o=p(s+1|0),i[k+8>>2]=s-2147483647,i[k>>2]=o,i[k+4>>2]=t;break A}if(u[k+11|0]=t,o=k,!t)break f}if(!t)break f;x(o,r,t)}u[o+t|0]=0,Z9(k+20|0,w,n,k),u[k+11|0]<0&&Z(i[k>>2]),n=107664,w=107676,o=107683,r=107672;f:switch(l[k+40|0]){case 1:w=k+32|0,o=k+39|0,r=k+28|0,n=k+20|0;break;case 0:break f;default:break i}s=i[n>>2],n=i[n+4>>2],i[k>>2]=s,i[k+4>>2]=n,n=k+8|0;f:{if(u[o|0]>=0){o=i[r+4>>2],i[n>>2]=i[r>>2],i[n+4>>2]=o,i[n+8>>2]=i[r+8>>2];break f}T(n,i[r>>2],i[w>>2]),s=i[k>>2]}f:{if(s){if(b0(A,k,i[e>>2]),u[k+19|0]>=0)break f;Z(i[k+8>>2]);break f}if(u[k+19|0]<0&&Z(i[k+8>>2]),f){if(l[k+40|0])break i;i[f>>2]=i[k+20>>2]}e=i[24057],i[A>>2]=i[24056],i[A+4>>2]=e,i[A+8>>2]=i[24058]}if(e=l[k+40|0],(e|0)==255)break r;A=i[24241],i[k>>2]=i[24240],i[k+4>>2]=A,W[i[(e<<2)+k>>2]](k+47|0,k+20|0)}v=k+48|0;return}Q0(),H()}_2(),H()}function XX(A,e){A=A|0,e=e|0;var r=0,f=0,k=0,n=0,t=0;n=v-16|0,v=n;i:{e:{r:{if(r=i[e+104>>2],f=i[e+108>>2],(r|0)!=(f|0))for(;;){f:{if(k=i[r>>2],!k||(k=W0(k,86580,100172),!k))break f;f=i[r+4>>2],f&&(i[f+4>>2]=i[f+4>>2]+1),r=p(88),i[r+4>>2]=0,i[r+8>>2]=0,i[r>>2]=97160,f&&(i[f+4>>2]=i[f+4>>2]+1),t=r+16|0,i[r+64>>2]=0,i[r+56>>2]=0,i[r+60>>2]=0,i[r+24>>2]=0,i[r+28>>2]=0,i[r+36>>2]=0,i[r+40>>2]=0,i[r+72>>2]=0,i[r+76>>2]=0,i[r+84>>2]=f,i[r+80>>2]=k,u[r+32|0]=0,i[r+44>>2]=0,i[r+48>>2]=0,i[r+16>>2]=100192,!f|i[f+4>>2]!=-1||(W[i[i[f>>2]+8>>2]](f),y(f)),i[e+448>>2]=t,k=i[e+452>>2],i[e+452>>2]=r;A:{if(!k||(e=i[k+4>>2],i[k+4>>2]=e-1,e))break A;W[i[i[k>>2]+8>>2]](k),y(k)}if(e=i[26917],i[A>>2]=i[26916],i[A+4>>2]=e,A=A+8|0,u[107683]<0)break r;e=i[26919],i[A>>2]=i[26918],i[A+4>>2]=e,i[A+8>>2]=i[26920];break e}if(r=r+8|0,(f|0)==(r|0))break}if(u[n+4|0]=0,u[n+15|0]=0,q(A,2,131,n+4|0),u[n+15|0]>=0)break i;Z(i[n+4>>2]);break i}T(A,i[26918],i[26919])}if(!f||(A=i[f+4>>2],i[f+4>>2]=A-1,A))break i;W[i[i[f>>2]+8>>2]](f),y(f)}v=n+16|0}function WX(A,e,r,f,k){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0;var n=0,t=0,o=0,s=0,w=0;n=v-32|0,v=n,A=i[A>>2],o=i[A+48>>2],s=i[A+52>>2],s&&(i[s+4>>2]=i[s+4>>2]+1),i[n+28>>2]=0,i[n+20>>2]=0,i[n+24>>2]=0,j1(n,o,e,n+20|0);i:{if(i[n>>2]||(A=i[n+20>>2],w=i[n+24>>2],(A|0)==(w|0)))break i;e=!f;e:{if(!r){if(e)break e;for(o=1;r=e,(k|0)>(t|0)&&(i[(t<<2)+f>>2]=o,r=1),o=o+1|0,t=r+t|0,A=A+8|0,(w|0)!=(A|0););break i}if(!f){for(;;)if(t=(e&i[i[A>>2]+16>>2]==(r|0))+t|0,A=A+8|0,(w|0)==(A|0))break i}for(o=1;;){r:{if(i[i[A>>2]+16>>2]!=(r|0))break r;if((k|0)>(t|0)){i[(t<<2)+f>>2]=o,t=t+1|0;break r}t=e+t|0}if(o=o+1|0,A=A+8|0,(w|0)==(A|0))break}break i}t=((w-A|0)-8>>>3|0)+1|0}if(u[n+19|0]<0&&Z(i[n+8>>2]),r=i[n+20>>2],r){if(A=i[n+24>>2],e=r,(A|0)!=(e|0)){for(;;){e=i[A-4>>2];i:{if(!e||(f=i[e+4>>2],i[e+4>>2]=f-1,f))break i;W[i[i[e>>2]+8>>2]](e),y(e)}if(A=A-8|0,(r|0)==(A|0))break}e=i[n+20>>2]}i[n+24>>2]=r,Z(e)}i:{if(!s||(A=i[s+4>>2],i[s+4>>2]=A-1,A))break i;W[i[i[s>>2]+8>>2]](s),y(s)}return v=n+32|0,t|0}function QX(A,e){A=A|0,e=e|0;var r=0,f=0,k=0,n=0,t=0;n=v-16|0,v=n;i:{e:{r:{if(r=i[e+104>>2],f=i[e+108>>2],(r|0)!=(f|0))for(;;){f:{if(k=i[r>>2],!k||(k=W0(k,86580,97564),!k))break f;f=i[r+4>>2],f&&(i[f+4>>2]=i[f+4>>2]+1),r=p(88),i[r+4>>2]=0,i[r+8>>2]=0,i[r>>2]=97080,f&&(i[f+4>>2]=i[f+4>>2]+1),t=r+16|0,i[r+64>>2]=0,i[r+56>>2]=0,i[r+60>>2]=0,i[r+24>>2]=0,i[r+28>>2]=0,i[r+36>>2]=0,i[r+40>>2]=0,i[r+72>>2]=0,i[r+76>>2]=0,i[r+84>>2]=f,i[r+80>>2]=k,u[r+32|0]=0,i[r+44>>2]=0,i[r+48>>2]=0,i[r+16>>2]=97648,!f|i[f+4>>2]!=-1||(W[i[i[f>>2]+8>>2]](f),y(f)),i[e+448>>2]=t,k=i[e+452>>2],i[e+452>>2]=r;A:{if(!k||(e=i[k+4>>2],i[k+4>>2]=e-1,e))break A;W[i[i[k>>2]+8>>2]](k),y(k)}if(e=i[26917],i[A>>2]=i[26916],i[A+4>>2]=e,A=A+8|0,u[107683]<0)break r;e=i[26919],i[A>>2]=i[26918],i[A+4>>2]=e,i[A+8>>2]=i[26920];break e}if(r=r+8|0,(f|0)==(r|0))break}if(u[n+4|0]=0,u[n+15|0]=0,q(A,2,106,n+4|0),u[n+15|0]>=0)break i;Z(i[n+4>>2]);break i}T(A,i[26918],i[26919])}if(!f||(A=i[f+4>>2],i[f+4>>2]=A-1,A))break i;W[i[i[f>>2]+8>>2]](f),y(f)}v=n+16|0}function gX(A,e){A=A|0,e=e|0;var r=0,f=0,k=0,n=0,t=0;n=v-16|0,v=n;i:{e:{r:{if(r=i[e+104>>2],f=i[e+108>>2],(r|0)!=(f|0))for(;;){f:{if(k=i[r>>2],!k||(k=W0(k,86580,99876),!k))break f;f=i[r+4>>2],f&&(i[f+4>>2]=i[f+4>>2]+1),r=p(88),i[r+4>>2]=0,i[r+8>>2]=0,i[r>>2]=97240,f&&(i[f+4>>2]=i[f+4>>2]+1),t=r+16|0,i[r+64>>2]=0,i[r+56>>2]=0,i[r+60>>2]=0,i[r+24>>2]=0,i[r+28>>2]=0,i[r+36>>2]=0,i[r+40>>2]=0,i[r+72>>2]=0,i[r+76>>2]=0,i[r+84>>2]=f,i[r+80>>2]=k,u[r+32|0]=0,i[r+44>>2]=0,i[r+48>>2]=0,i[r+16>>2]=99680,!f|i[f+4>>2]!=-1||(W[i[i[f>>2]+8>>2]](f),y(f)),i[e+448>>2]=t,k=i[e+452>>2],i[e+452>>2]=r;A:{if(!k||(e=i[k+4>>2],i[k+4>>2]=e-1,e))break A;W[i[i[k>>2]+8>>2]](k),y(k)}if(e=i[26917],i[A>>2]=i[26916],i[A+4>>2]=e,A=A+8|0,u[107683]<0)break r;e=i[26919],i[A>>2]=i[26918],i[A+4>>2]=e,i[A+8>>2]=i[26920];break e}if(r=r+8|0,(f|0)==(r|0))break}if(u[n+4|0]=0,u[n+15|0]=0,q(A,2,131,n+4|0),u[n+15|0]>=0)break i;Z(i[n+4>>2]);break i}T(A,i[26918],i[26919])}if(!f||(A=i[f+4>>2],i[f+4>>2]=A-1,A))break i;W[i[i[f>>2]+8>>2]](f),y(f)}v=n+16|0}function VX(A,e){A=A|0,e=e|0;var r=0,f=0,k=0,n=0,t=0;n=v-16|0,v=n;i:{e:{r:{if(r=i[e+104>>2],f=i[e+108>>2],(r|0)!=(f|0))for(;;){f:{if(k=i[r>>2],!k||(k=W0(k,86580,98140),!k))break f;f=i[r+4>>2],f&&(i[f+4>>2]=i[f+4>>2]+1),r=p(88),i[r+4>>2]=0,i[r+8>>2]=0,i[r>>2]=97120,f&&(i[f+4>>2]=i[f+4>>2]+1),t=r+16|0,i[r+64>>2]=0,i[r+56>>2]=0,i[r+60>>2]=0,i[r+24>>2]=0,i[r+28>>2]=0,i[r+36>>2]=0,i[r+40>>2]=0,i[r+72>>2]=0,i[r+76>>2]=0,i[r+84>>2]=f,i[r+80>>2]=k,u[r+32|0]=0,i[r+44>>2]=0,i[r+48>>2]=0,i[r+16>>2]=98016,!f|i[f+4>>2]!=-1||(W[i[i[f>>2]+8>>2]](f),y(f)),i[e+448>>2]=t,k=i[e+452>>2],i[e+452>>2]=r;A:{if(!k||(e=i[k+4>>2],i[k+4>>2]=e-1,e))break A;W[i[i[k>>2]+8>>2]](k),y(k)}if(e=i[26917],i[A>>2]=i[26916],i[A+4>>2]=e,A=A+8|0,u[107683]<0)break r;e=i[26919],i[A>>2]=i[26918],i[A+4>>2]=e,i[A+8>>2]=i[26920];break e}if(r=r+8|0,(f|0)==(r|0))break}if(u[n+4|0]=0,u[n+15|0]=0,q(A,2,131,n+4|0),u[n+15|0]>=0)break i;Z(i[n+4>>2]);break i}T(A,i[26918],i[26919])}if(!f||(A=i[f+4>>2],i[f+4>>2]=A-1,A))break i;W[i[i[f>>2]+8>>2]](f),y(f)}v=n+16|0}function gn(A,e){var r=0,f=0,k=0,n=0,t=0,o=0,s=0,w=0,h=0;f=v-32|0,v=f;i:{if(l[A+52|0]==1){if(r=i[A+48>>2],!e)break i;u[A+52|0]=0,i[A+48>>2]=-1;break i}e:{if(l[A+53|0]==1){if(r=he(i[A+32>>2]),(r|0)!=-1&&(u[f+24|0]=r),(r|0)==-1)break e;r=l[f+24|0];r:{if(!e){if(!zs(r,i[A+32>>2]))break e;break r}i[A+48>>2]=r}r=l[f+24|0];break i}for(i[f+24>>2]=1,k=v-16|0,v=k,v=k+16|0,k=A+44|0,n=f+24|0,k=i[(i[n>>2]<i[k>>2]?k:n)>>2],n=(k|0)>0?k:0;;){if((r|0)!=(n|0)){if(t=he(i[A+32>>2]),(t|0)==-1)break e;u[(f+24|0)+r|0]=t,r=r+1|0;continue}break}w=f+24|0;r:{for(;;){f:{n=i[A+40>>2],r=i[n>>2],h=i[n+4>>2],o=f+24|0,t=o+k|0;A:switch(s=i[A+36>>2],(W[i[i[s>>2]+16>>2]](s,n,o,t,f+16|0,f+23|0,w,f+12|0)|0)-1|0){case 1:break e;case 0:break A;case 2:break f;default:break r}if(n=i[A+40>>2],i[n>>2]=r,i[n+4>>2]=h,(k|0)==8||(r=he(i[A+32>>2]),(r|0)==-1))break e;u[t|0]=r,k=k+1|0;continue}break}u[f+23|0]=l[f+24|0]}r:{if(!e)for(;;){if((k|0)<=0)break r;if(k=k-1|0,(Zi(l[k+(f+24|0)|0],i[A+32>>2])|0)==-1)break e}i[A+48>>2]=l[f+23|0]}r=l[f+23|0];break i}r=-1}return v=f+32|0,r}function FX(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0;e=v-16|0,v=e,r=p(32),i[e+4>>2]=r,i[e+8>>2]=29,i[e+12>>2]=-2147483616,f=l[22357]|l[22358]<<8|(l[22359]<<16|l[22360]<<24),k=l[22353]|l[22354]<<8|(l[22355]<<16|l[22356]<<24),u[r|0]=k,u[r+1|0]=k>>>8,u[r+2|0]=k>>>16,u[r+3|0]=k>>>24,u[r+4|0]=f,u[r+5|0]=f>>>8,u[r+6|0]=f>>>16,u[r+7|0]=f>>>24,u[r+29|0]=0,f=l[22378]|l[22379]<<8|(l[22380]<<16|l[22381]<<24),k=l[22374]|l[22375]<<8|(l[22376]<<16|l[22377]<<24),u[r+21|0]=k,u[r+22|0]=k>>>8,u[r+23|0]=k>>>16,u[r+24|0]=k>>>24,u[r+25|0]=f,u[r+26|0]=f>>>8,u[r+27|0]=f>>>16,u[r+28|0]=f>>>24,f=l[22373]|l[22374]<<8|(l[22375]<<16|l[22376]<<24),k=l[22369]|l[22370]<<8|(l[22371]<<16|l[22372]<<24),u[r+16|0]=k,u[r+17|0]=k>>>8,u[r+18|0]=k>>>16,u[r+19|0]=k>>>24,u[r+20|0]=f,u[r+21|0]=f>>>8,u[r+22|0]=f>>>16,u[r+23|0]=f>>>24,f=l[22365]|l[22366]<<8|(l[22367]<<16|l[22368]<<24),k=l[22361]|l[22362]<<8|(l[22363]<<16|l[22364]<<24),u[r+8|0]=k,u[r+9|0]=k>>>8,u[r+10|0]=k>>>16,u[r+11|0]=k>>>24,u[r+12|0]=f,u[r+13|0]=f>>>8,u[r+14|0]=f>>>16,u[r+15|0]=f>>>24,q(A,5,0,e+4|0),u[e+15|0]<0&&Z(i[e+4>>2]),v=e+16|0}function Pf(A,e,r,f){var k=0,n=0,t=0,o=0,s=0,w=0;t=v-32|0,v=t,k=f&65535,n=f>>>16&32767,s=n;i:{if(n-15361>>>0<=2045){k=k<<4|r>>>28,r=r<<4,n=k,k=e>>>28|r,r=n,n=s-15360|0,e=e&268435455;e:{if((e|0)==134217728&(A|0)!=0|e>>>0>134217728){k=k+1|0,r=k?r:r+1|0;break e}if(A|(e|0)!=134217728)break e;A=k,k=k+(k&1)|0,r=A>>>0>k>>>0?r+1|0:r}o=r>>>0>1048575,A=o?0:k,e=o?0:r,k=0,r=n+o|0,n=r>>>0<n>>>0?1:k;break i}if(!(!(A|r|(e|k))|((n|0)!=32767|(o|0)!=0))){A=r,r=k<<4|r>>>28,A=A<<4|e>>>28,e=r|524288,r=2047,n=0;break i}if(s>>>0>17406){A=0,e=0,r=2047,n=0;break i}if(o=!(n|o),w=o?15360:15361,n=w-s|0,(n|0)>112){A=0,e=0,r=0,n=0;break i}k=o?k:k|65536,o4(t+16|0,A,e,r,k,128-n|0),Y6(t,A,e,r,k,n),A=i[t+8>>2],o=A<<4,e=i[t+12>>2]<<4|A>>>28,A=i[t+4>>2],n=A,A=A>>>28|o,n=n&268435455,r=i[t>>2]|(s|0)!=(w|0)&(i[t+16>>2]|i[t+24>>2]|(i[t+20>>2]|i[t+28>>2]))!=0;e:{if((n|0)==134217728&(r|0)!=0|n>>>0>134217728){A=A+1|0,e=A?e:e+1|0;break e}if(r|(n|0)!=134217728)break e;k=e,e=A,A=A+(A&1)|0,e=e>>>0>A>>>0?k+1|0:k}r=e>>>0>1048575,e=r?e^1048576:e,n=0}return v=t+32|0,D2(0,A|0),D2(1,e|(f&-2147483648|r<<20)),+r1()}function IX(A,e,r,f,k){A=A|0,e=e|0,r=r|0,f=f|0,k=+k;var n=0,t=0,o=0,s=0,w=0,h=0,_=0,B=0;n=v-208|0,v=n,i[n+200>>2]=37,i[n+204>>2]=0,t=n+200|0,o=Kr(t|1,42673,i[r+4>>2]),s=n+160|0,i[n+156>>2]=s,A=a2();i:{if(o){w=i[r+8>>2],t0[n+40>>3]=k,i[n+32>>2]=w,A=h4(s,30,A,t,n+32|0);break i}t0[n+48>>3]=k,A=h4(n+160|0,30,A,n+200|0,n+48|0)}i[n+80>>2]=2071,s=Q1(n+148|0,0,n+80|0),t=n+160|0;i:{e:{if((A|0)>=30){A=a2();r:{if(o){t=i[r+8>>2],t0[n+8>>3]=k,i[n>>2]=t,A=I8(n+156|0,A,n+200|0,n);break r}t0[n+16>>3]=k,A=I8(n+156|0,A,n+200|0,n+16|0)}if((A|0)==-1)break e;t=i[s>>2],i[s>>2]=i[n+156>>2],t&&W[i[s+4>>2]](t),t=i[n+156>>2]}_=A+t|0,B=z4(t,_,r),i[n+80>>2]=2071,t=n+80|0,o=Q1(n+72|0,0,t),w=i[n+156>>2];r:{if((w|0)==(n+160|0)){A=t;break r}if(A=y2(A<<1),!A)break e;t=i[o>>2],i[o>>2]=A,t&&W[i[o+4>>2]](t),w=i[n+156>>2]}h=n+60|0,t=i[r+28>>2],i[h>>2]=t,(t|0)!=129576&&(i[t+4>>2]=i[t+4>>2]+1),en(w,B,_,A,n+68|0,n- -64|0,h),e2(h),A=O8(e,A,i[n+68>>2],i[n+64>>2],r,f),e=i[o>>2],i[o>>2]=0,e&&W[i[o+4>>2]](e),e=i[s>>2],i[s>>2]=0,e&&W[i[s+4>>2]](e),v=n+208|0;break i}g1(),H()}return A|0}function CX(A,e,r,f,k){A=A|0,e=e|0,r=r|0,f=f|0,k=+k;var n=0,t=0,o=0,s=0,w=0,h=0,_=0,B=0;n=v-368|0,v=n,i[n+360>>2]=37,i[n+364>>2]=0,t=n+360|0,o=Kr(t|1,42673,i[r+4>>2]),s=n+320|0,i[n+316>>2]=s,A=a2();i:{if(o){w=i[r+8>>2],t0[n+40>>3]=k,i[n+32>>2]=w,A=h4(s,30,A,t,n+32|0);break i}t0[n+48>>3]=k,A=h4(n+320|0,30,A,n+360|0,n+48|0)}i[n+80>>2]=2071,s=Q1(n+308|0,0,n+80|0),t=n+320|0;i:{e:{if((A|0)>=30){A=a2();r:{if(o){t=i[r+8>>2],t0[n+8>>3]=k,i[n>>2]=t,A=I8(n+316|0,A,n+360|0,n);break r}t0[n+16>>3]=k,A=I8(n+316|0,A,n+360|0,n+16|0)}if((A|0)==-1)break e;t=i[s>>2],i[s>>2]=i[n+316>>2],t&&W[i[s+4>>2]](t),t=i[n+316>>2]}_=A+t|0,B=z4(t,_,r),i[n+80>>2]=2071,t=n+80|0,o=Q1(n+72|0,0,t),w=i[n+316>>2];r:{if((w|0)==(n+320|0)){A=t;break r}if(A=y2(A<<3),!A)break e;t=i[o>>2],i[o>>2]=A,t&&W[i[o+4>>2]](t),w=i[n+316>>2]}h=n+60|0,t=i[r+28>>2],i[h>>2]=t,(t|0)!=129576&&(i[t+4>>2]=i[t+4>>2]+1),b9(w,B,_,A,n+68|0,n- -64|0,h),e2(h),A=j8(e,A,i[n+68>>2],i[n+64>>2],r,f),e=i[o>>2],i[o>>2]=0,e&&W[i[o+4>>2]](e),e=i[s>>2],i[s>>2]=0,e&&W[i[s+4>>2]](e),v=n+368|0;break i}g1(),H()}return A|0}function pX(A,e,r,f,k){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0;var n=0,t=0,o=0,s=0,w=0;n=v-48|0,v=n;i:{e:{r:{if(!(f&&e)){i[A>>2]=5,i[A+4>>2]=2001,i[A+8>>2]=16735;break r}if(t=i[e>>2],o=h2(f),o>>>0>=2147483640)break e;f:{A:{if(o>>>0>=11){w=o|7,s=p(w+1|0),i[n+8>>2]=w-2147483647,i[n>>2]=s,i[n+4>>2]=o;break A}if(u[n+11|0]=o,s=n,!o)break f}if(!o)break f;x(s,f,o)}u[o+s|0]=0,Z9(n+20|0,t,r,n),u[n+11|0]<0&&Z(i[n>>2]),t=107664,s=107676,r=107683,f=107672;f:switch(l[n+40|0]){case 1:s=n+32|0,r=n+39|0,f=n+28|0,t=n+20|0;break;case 0:break f;default:break i}w=i[t>>2],t=i[t+4>>2],i[n>>2]=w,i[n+4>>2]=t,t=n+8|0;f:{if(u[r|0]>=0){r=i[f+4>>2],i[t>>2]=i[f>>2],i[t+4>>2]=r,i[t+8>>2]=i[f+8>>2];break f}T(t,i[f>>2],i[s>>2]),w=i[n>>2]}f:{if(w){if(b0(A,n,i[e>>2]),u[n+19|0]>=0)break f;Z(i[n+8>>2]);break f}if(u[n+19|0]<0&&Z(i[n+8>>2]),k){if(l[n+40|0])break i;i[k>>2]=i[n+20>>2]}e=i[24057],i[A>>2]=i[24056],i[A+4>>2]=e,i[A+8>>2]=i[24058]}if(e=l[n+40|0],(e|0)==255)break r;A=i[24187],i[n>>2]=i[24186],i[n+4>>2]=A,W[i[(e<<2)+n>>2]](n+47|0,n+20|0)}v=n+48|0;return}Q0(),H()}_2(),H()}function $4(A,e,r,f,k){var n=0,t=0,o=0,s=0,w=0,h=0,_=0;i:{e:{if((k|0)<=0)break e;if(o=i[A+8>>2],s=i[A+4>>2],(o-s|0)>=(k|0)){n=s-e|0;r:{if((n|0)>=(k|0)){o=r+k|0,t=s;break r}if(o=r+n|0,t=f-o|0,!t|(f|0)==(o|0)||x(s,o,t),t=t+s|0,i[A+4>>2]=t,(n|0)<=0)break e}w=e+k|0,f=t,n=f-k|0;r:{if(s>>>0<=n>>>0)break r;if(h=k+s|0,_=h-f&7,_)for(k=0;u[f|0]=l[n|0],f=f+1|0,n=n+1|0,k=k+1|0,(_|0)!=(k|0););if(t-h>>>0>=4294967289)break r;for(;u[f|0]=l[n|0],u[f+1|0]=l[n+1|0],u[f+2|0]=l[n+2|0],u[f+3|0]=l[n+3|0],u[f+4|0]=l[n+4|0],u[f+5|0]=l[n+5|0],u[f+6|0]=l[n+6|0],u[f+7|0]=l[n+7|0],f=f+8|0,n=n+8|0,(s|0)!=(n|0););}i[A+4>>2]=f;r:{if((t|0)==(w|0)||(A=t-w|0,!A))break r;x(t-A|0,e,A)}if((r|0)==(o|0)||(A=o-r|0,!A))break e;x(e,r,A);return}if(t=i[A>>2],f=(s-t|0)+k|0,(f|0)<0)break i;n=e-t|0,o=o-t|0,w=o<<1,o=o>>>0>=1073741823?2147483647:f>>>0<w>>>0?w:f,o?f=p(o):f=0,w=n+f|0,k&&x(w,r,k),r=k+w|0,k=s-e|0,k&&x(r,e,k),i[A+4>>2]=e,n&&x(f,t,n),i[A+8>>2]=f+o,i[A+4>>2]=r+k,i[A>>2]=f,t&&Z(t)}return}G0(),H()}function Lf(A,e,r){var f=0,k=0,n=0,t=0,o=0,s=0;f=v+-64|0,v=f,t=i[i[e+104>>2]-8>>2],W[i[i[t>>2]+12>>2]](f+44|0,t),n=A+8|0,t=i[26686],s=i[26687];i:{for(;;){if(k=i[f+44>>2],W[i[i[k>>2]+24>>2]](f+24|0,k,r),i[f+24>>2]){e=i[f+28>>2],i[A>>2]=i[f+24>>2],i[A+4>>2]=e,i[n+8>>2]=i[f+40>>2],A=i[f+36>>2],i[n>>2]=i[f+32>>2],i[n+4>>2]=A;break i}e9(f,e,r);e:{r:{f:{A:switch(l[f+20|0]){case 1:if(k=i[f+4>>2],i[A>>2]=i[f>>2],i[A+4>>2]=k,u[f+19|0]<0)break f;k=i[f+12>>2],i[n>>2]=i[f+8>>2],i[n+4>>2]=k,i[n+8>>2]=i[f+16>>2],k=1,o=1;break r;default:_2(),H();case 0:break A}o=0,k=l[f|0]?0:2;break r}if(T(n,i[f+8>>2],i[f+12>>2]),k=1,o=l[f+20|0],(o|0)==255)break e}i[f+56>>2]=t,i[f+60>>2]=s,W[i[(f+56|0)+(o<<2)>>2]](f+55|0,f)}if(u[f+43|0]<0&&Z(i[f+32>>2]),!!k)break}if((k|0)!=2)break i;r=i[e+320>>2];e:{if(!r)break e;if(Lf(A,r,i[e+332>>2]),i[A>>2])break i;if(u[A+19|0]>=0)break e;Z(i[A+8>>2])}i[A>>2]=0,i[A+4>>2]=0,i[A+16>>2]=0,i[A+8>>2]=0,i[A+12>>2]=0}A=i[f+48>>2];i:{if(!A||(e=i[A+4>>2],i[A+4>>2]=e-1,e))break i;W[i[i[A>>2]+8>>2]](A),y(A)}v=f- -64|0}function yX(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,t=0,o=0,s=0,w=0;t=v-16|0,v=t;i:{e:{if(!e){r=0;break e}if(A=i[A>>2],i[t+12>>2]=0,i[t+4>>2]=0,i[t+8>>2]=0,f=i[A+132>>2],k=i[A+136>>2],(f|0)!=(k|0)){if(A=k-f|0,(A|0)<0)break i;for(n=p(A),i[t+4>>2]=n,i[t+12>>2]=A+n,A=n;i[A>>2]=i[f>>2],o=i[f+4>>2],i[A+4>>2]=o,o&&(i[o+4>>2]=i[o+4>>2]+1),A=A+8|0,f=f+8|0,(k|0)!=(f|0););i[t+8>>2]=A,f=A-n>>3,r=(r|0)>(f|0)?f:r;r:{if((r|0)<=0)break r;if(o=0,f=0,r>>>0>=4)for(w=r&2147483644,k=0;i[(f<<2)+e>>2]=i[i[(f<<3)+n>>2]+116>>2],s=f|1,i[(s<<2)+e>>2]=i[i[(s<<3)+n>>2]+116>>2],s=f|2,i[(s<<2)+e>>2]=i[i[(s<<3)+n>>2]+116>>2],s=f|3,i[(s<<2)+e>>2]=i[i[(s<<3)+n>>2]+116>>2],f=f+4|0,k=k+4|0,(w|0)!=(k|0););if(k=r&3,!k)break r;for(;i[(f<<2)+e>>2]=i[i[(f<<3)+n>>2]+116>>2],f=f+1|0,o=o+1|0,(k|0)!=(o|0););}for(;;){e=A-8|0,A=i[A-4>>2];r:{if(!A||(f=i[A+4>>2],i[A+4>>2]=f-1,f))break r;W[i[i[A>>2]+8>>2]](A),y(A)}if(A=e,(n|0)==(A|0))break}Z(i[t+4>>2]);break e}r=r>>31&r}return v=t+16|0,r|0}G0(),H()}function EX(A){A=A|0;var e=0,r=0,f=0,k=0,n=0,t=0,o=0,s=0;e=v-96|0,v=e,u[e+56|0]=0,i[e+68>>2]=0,i[e+72>>2]=0,i[e+88>>2]=0,i[e+80>>2]=0,i[e+84>>2]=0,i[e+48>>2]=0,i[e+52>>2]=0,i[e+60>>2]=0,i[e+64>>2]=0,Hf(e+28|0,A,e+60|0,0,0),u[e+47|0]<0&&Z(i[e+36>>2]),f=i[A+552>>2],i[e+24>>2]=i[e+88>>2],r=i[e+84>>2],i[e+16>>2]=i[e+80>>2],i[e+20>>2]=r,r=i[e+76>>2],i[e+8>>2]=i[e+72>>2],i[e+12>>2]=r,k=i[e+52>>2],i[e+52>>2]=0,r=i[e+48>>2],i[e+48>>2]=0,n=i[e+60>>2],t=i[e+64>>2],i[e+60>>2]=0,i[e+64>>2]=0,o=i[e+68>>2],i[e+68>>2]=0,s=l[e+56|0],i[f+8>>2]=r,r=i[f+12>>2],i[f+12>>2]=k;i:{if(!r||(k=i[r+4>>2],i[r+4>>2]=k-1,k))break i;W[i[i[r>>2]+8>>2]](r),y(r)}u[f+16|0]=s,r=i[f+20>>2],r&&(i[f+24>>2]=r,Z(r)),i[f+28>>2]=o,i[f+24>>2]=t,i[f+20>>2]=n,r=i[e+12>>2],i[f+32>>2]=i[e+8>>2],i[f+36>>2]=r,r=i[e+20>>2],i[f+40>>2]=i[e+16>>2],i[f+44>>2]=r,i[f+48>>2]=i[e+24>>2],A=i[A+552>>2],f=W[i[i[A>>2]+12>>2]](A)|0,A=i[e+60>>2],A&&(i[e+64>>2]=A,Z(A)),A=i[e+52>>2];i:{if(!A||(r=i[A+4>>2],i[A+4>>2]=r-1,r))break i;W[i[i[A>>2]+8>>2]](A),y(A)}return v=e+96|0,f|0}function YX(A){A=A|0;var e=0,r=0,f=0,k=0,n=0,t=0,o=0,s=0;e=v-96|0,v=e,u[e+56|0]=0,i[e+68>>2]=0,i[e+72>>2]=0,i[e+88>>2]=0,i[e+80>>2]=0,i[e+84>>2]=0,i[e+48>>2]=0,i[e+52>>2]=0,i[e+60>>2]=0,i[e+64>>2]=0,Hf(e+28|0,A,e+60|0,0,0),u[e+47|0]<0&&Z(i[e+36>>2]),f=i[A+552>>2],i[e+24>>2]=i[e+88>>2],r=i[e+84>>2],i[e+16>>2]=i[e+80>>2],i[e+20>>2]=r,r=i[e+76>>2],i[e+8>>2]=i[e+72>>2],i[e+12>>2]=r,k=i[e+52>>2],i[e+52>>2]=0,r=i[e+48>>2],i[e+48>>2]=0,n=i[e+60>>2],t=i[e+64>>2],i[e+60>>2]=0,i[e+64>>2]=0,o=i[e+68>>2],i[e+68>>2]=0,s=l[e+56|0],i[f+8>>2]=r,r=i[f+12>>2],i[f+12>>2]=k;i:{if(!r||(k=i[r+4>>2],i[r+4>>2]=k-1,k))break i;W[i[i[r>>2]+8>>2]](r),y(r)}u[f+16|0]=s,r=i[f+20>>2],r&&(i[f+24>>2]=r,Z(r)),i[f+28>>2]=o,i[f+24>>2]=t,i[f+20>>2]=n,r=i[e+12>>2],i[f+32>>2]=i[e+8>>2],i[f+36>>2]=r,r=i[e+20>>2],i[f+40>>2]=i[e+16>>2],i[f+44>>2]=r,i[f+48>>2]=i[e+24>>2],A=i[A+552>>2],f=W[i[i[A>>2]+16>>2]](A)|0,A=i[e+60>>2],A&&(i[e+64>>2]=A,Z(A)),A=i[e+52>>2];i:{if(!A||(r=i[A+4>>2],i[A+4>>2]=r-1,r))break i;W[i[i[A>>2]+8>>2]](A),y(A)}return v=e+96|0,f|0}function RX(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,t=0;f=v-80|0,v=f,n=-1;i:{if(!A|(e|0)<=0|(!r|!l[r|0])||!l[r+3|0]|(!l[r+1|0]|!l[r+2|0]))break i;k=p(72),i[k+4>>2]=0,i[k+8>>2]=0,i[k>>2]=95024,A=dr(k+16|0,A,e,0),i[f+52>>2]=k,i[f+48>>2]=A,i[k+4>>2]=i[k+4>>2]+1,A=i[f+52>>2],i[f+8>>2]=i[f+48>>2],i[f+12>>2]=A,t=pe(f+56|0,f+8|0,e,0),i[f+40>>2]=0,i[f+44>>2]=0,V6(f+20|0,t,f+40|0,95520);e:{if(i[f+20>>2]){n=i[f+24>>2]==100?-1:-2;break e}if(n=-2,A=i[f+40>>2],!A||(e=W0(A,86580,86944),!e)||(A=i[f+44>>2],A&&(i[A+4>>2]=i[A+4>>2]+1),n=e,e=l[r|0]|l[r+1|0]<<8|(l[r+2|0]<<16|l[r+3|0]<<24),n=J4(n,e<<24|(e&65280)<<8|(e>>>8&65280|e>>>24)),!A)||(e=i[A+4>>2],i[A+4>>2]=e-1,e))break e;W[i[i[A>>2]+8>>2]](A),y(A)}u[f+39|0]<0&&Z(i[f+28>>2]),A=i[f+44>>2];e:{if(!A||(e=i[A+4>>2],i[A+4>>2]=e-1,e))break e;W[i[i[A>>2]+8>>2]](A),y(A)}A=i[t+4>>2];e:{if(!A||(e=i[A+4>>2],i[A+4>>2]=e-1,e))break e;W[i[i[A>>2]+8>>2]](A),y(A)}if(A=i[k+4>>2],i[k+4>>2]=A-1,A)break i;W[i[i[k>>2]+8>>2]](k),y(k)}return v=f+80|0,n|0}function JX(A,e,r,f,k,n){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0;var t=0,o=0,s=0,w=0,h=0;t=v-48|0,v=t;i:{e:{if(r&&(h2(r)|0)==4)break e;i[A>>2]=5,i[A+4>>2]=2006,i[A+8>>2]=26171;break i}o=i[e>>2],w=i[o+48>>2],o=i[o+52>>2],o&&(i[o+4>>2]=i[o+4>>2]+1),s=v-32|0,v=s,h=s+24|0,r=l[r|0]|l[r+1|0]<<8|(l[r+2|0]<<16|l[r+3|0]<<24),Z8(h,w,r<<24|(r&65280)<<8|(r>>>8&65280|r>>>24)),r=i[s+24>>2],u[r+164|0]=1,i[r+100>>2]=i[r+100>>2]&-2|1,r=i[r+104>>2],$f(s+4|0,w,h,f,k,0),u[s+23|0]<0&&Z(i[s+12>>2]),u[t+32|0]=0,i[t+12>>2]=r,r=i[s+28>>2];e:{if(!r||(f=i[r+4>>2],i[r+4>>2]=f-1,f))break e;W[i[i[r>>2]+8>>2]](r),y(r)}v=s+32|0;e:{if(!o||(r=i[o+4>>2],i[o+4>>2]=r-1,r))break e;W[i[i[o>>2]+8>>2]](o),y(o)}e:{r:{if(r=l[t+32|0],!(r|!n)){i[n>>2]=1;break r}f:switch(r|0){default:_2(),H();case 0:break r;case 1:break f}if(b0(A,t+12|0,i[e>>2]),r=l[t+32|0],(r|0)==255)break i;break e}e=i[24057],i[A>>2]=i[24056],i[A+4>>2]=e,i[A+8>>2]=i[24058],r=0}A=i[24187],i[t+40>>2]=i[24186],i[t+44>>2]=A,W[i[(t+40|0)+(r<<2)>>2]](t+39|0,t+12|0)}v=t+48|0}function Kf(A,e){var r=0,f=0,k=0,n=0,t=0,o=0,s=0;i:{if(!e){t=A+112|0,r=l[A+112|0];break i}if(f=i[A+116>>2],!f){i[A+116>>2]=1,u[A+112|0]=e;return}if(t=A+112|0,r=l[t|0],(r|0)!=(e|0))break i;i[A+116>>2]=f+1;return}k=i[A+116>>2];i:{e:{r:{if(!(r&255)){f=k;break r}if(f=0,k)for(r=i[A+124>>2];;){o=i[A+128>>2];f:{if(o>>>0>r>>>0){u[r|0]=l[t|0],r=r+1|0;break f}if(n=i[A+120>>2],f=r-n|0,k=f+1|0,(k|0)<0)break e;if(r=o-n|0,o=r<<1,r=r>>>0>=1073741823?2147483647:k>>>0<o>>>0?o:k,r?k=p(r):k=0,o=k+f|0,u[o|0]=l[A+112|0],f&&x(k,n,f),i[A+128>>2]=r+k,r=o+1|0,i[A+124>>2]=r,i[A+120>>2]=k,!n)break f;Z(n)}if(i[A+124>>2]=r,f=i[A+116>>2],s=s+1|0,!(f>>>0>s>>>0))break}u[t|0]=0}if(i[A+116>>2]=f+1,f=i[A+124>>2],n=i[A+128>>2],f>>>0<n>>>0){u[f|0]=e,i[A+124>>2]=f+1;return}if(r=i[A+120>>2],f=f-r|0,k=f+1|0,(k|0)<0)break i;n=n-r|0,t=n<<1,n=n>>>0>=1073741823?2147483647:k>>>0<t>>>0?t:k,n?k=p(n):k=0,t=k+f|0,u[t|0]=e,f&&x(k,r,f),i[A+128>>2]=k+n,e=t+1|0,i[A+124>>2]=e,i[A+120>>2]=k,r&&Z(r),i[A+124>>2]=e;return}G0(),H()}G0(),H()}function ei(A,e,r){var f=0,k=0,n=0,t=0,o=0,s=0;i[A+8>>2]=r,i[A>>2]=e,i[A+24>>2]=0,i[A+16>>2]=0,i[A+20>>2]=0,i[A+12>>2]=r,i[A+4>>2]=e,s=-64;i:{if(!r||(i[A+4>>2]=e+1,f=l[e|0],k=r-1|0,i[A+12>>2]=k,f=f<<24,n=f,i[A+16>>2]=0,i[A+20>>2]=f,!k)||(i[A+4>>2]=e+2,f=l[e+1|0],k=r-2|0,i[A+12>>2]=k,f=n|f<<16,t=f,i[A+16>>2]=o,i[A+20>>2]=f,!k)||(i[A+4>>2]=e+3,f=l[e+2|0],k=r-3|0,i[A+12>>2]=k,f=t|f<<8,t=f,i[A+16>>2]=o,i[A+20>>2]=f,!k)||(i[A+4>>2]=e+4,f=l[e+3|0],k=r-4|0,i[A+12>>2]=k,n=o,f=f|t,o=f,i[A+16>>2]=n,i[A+20>>2]=f,!k)||(i[A+4>>2]=e+5,f=l[e+4|0],k=r-5|0,i[A+12>>2]=k,t=n,n=f>>>8|0,f=t|f<<24,n=n|o,o=n,i[A+16>>2]=f,i[A+20>>2]=n,!k)||(i[A+4>>2]=e+6,n=l[e+5|0],k=r-6|0,i[A+12>>2]=k,t=f,f=n>>>16|0,n=t|n<<16,f=f|o,o=f,i[A+16>>2]=n,i[A+20>>2]=f,!k)||(i[A+4>>2]=e+7,f=l[e+6|0],k=r-7|0,i[A+12>>2]=k,t=n,n=f>>>24|0,f=t|f<<8,i[A+16>>2]=f,n=n|o,i[A+20>>2]=n,!k))break i;i[A+4>>2]=e+8,e=l[e+7|0],i[A+12>>2]=r-8,i[A+16>>2]=e|f,i[A+20>>2]=n,s=-56}return i[A+24>>2]=(((r>>>0>=7?7:r)<<3)+s|0)- -64,A}function NX(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0;var k=0,n=0,t=0,o=0,s=0,w=0,h=0,_=0;k=v-32|0,v=k,z2(k,e,r),u[k+19|0]<0&&Z(i[k+8>>2]),u[e+100|0]&1&&(h=e,_=C0(r),i[h+104>>2]=_,h=e,_=C0(r),i[h+108>>2]=_),n=C0(r);i:{if(!(!f|n>>>0<=u0[f+80>>2])){if(e=p(72),i[k+20>>2]=e,i[k+24>>2]=70,i[k+28>>2]=-2147483576,x(e,24002,70),u[e+70|0]=0,q(A,6,1e3,k+20|0),u[k+31|0]>=0)break i;Z(i[k+20>>2]);break i}if(q4(A,e+140|0,n<<3,f,13777),i[A>>2])break i;u[A+19|0]<0&&Z(i[A+8>>2]),o=e+128|0;e:{t=i[e+128>>2],f=i[e+132>>2]-t>>3;r:{if(f>>>0<n>>>0){ui(o,n-f|0);break r}if(f>>>0>n>>>0&&(i[e+132>>2]=(n<<3)+t),!n)break e}for(f=0;;){r:{if(l[e+97|0]==1){t=Y4(r),s=l0;break r}t=C0(r),s=0}if(w=i[o>>2]+(f<<3)|0,i[w>>2]=t,i[w+4>>2]=s,l[r+20|0]!=1){if(f=f+1|0,(n|0)==(f|0))break e;continue}break}if(u[k+20|0]=0,u[k+31|0]=0,q(A,2,100,k+20|0),u[k+31|0]>=0)break i;Z(i[k+20>>2]);break i}if(e=i[26917],i[A>>2]=i[26916],i[A+4>>2]=e,A=A+8|0,u[107683]>=0){e=i[26919],i[A>>2]=i[26918],i[A+4>>2]=e,i[A+8>>2]=i[26920];break i}T(A,i[26918],i[26919])}v=k+32|0}function UX(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,t=0,o=0;f=v-160|0,v=f,i[f+92>>2]=0,i[f+64>>2]=72500,k=i[18128],i[f+8>>2]=k,o=i[k-12>>2],k=f+8|0,i[o+k>>2]=i[18129],t=k+i[i[f+8>>2]-12>>2]|0,n=f+12|0,J0(t,n),u[t+80|0]=0,i[t+72>>2]=0,i[f+64>>2]=72500,i[f+8>>2]=72480,t=R0(n),i[t>>2]=71232,i[f+52>>2]=0,i[f+56>>2]=0,i[f+44>>2]=0,i[f+48>>2]=0,i[f+60>>2]=16,n=f+148|0,s0(n,r),o=k,r=u[f+159|0],k=(r|0)<0,Y(o,k?i[f+148>>2]:n,k?i[f+152>>2]:r),u[f+159|0]<0&&Z(i[f+148>>2]),Y(V0(Y(f+8|0,31312,14),i[e+12>>2]-i[e+8>>2]|0),42670,1),e=i[f+60>>2];i:{e:{if(e&16){e=i[f+56>>2],r=i[f+36>>2],e>>>0<r>>>0&&(i[f+56>>2]=r,e=r),r=f+32|0;break e}if(!(e&8)){e=0,u[A+11|0]=0;break i}e=i[f+28>>2],r=f+20|0}e:{if(k=i[r>>2],e=e-k|0,e>>>0<2147483640){if(e>>>0>=11){n=e|7,r=p(n+1|0),i[A+8>>2]=n-2147483647,i[A>>2]=r,i[A+4>>2]=e,A=r;break e}if(u[A+11|0]=e,e)break e;e=0;break i}Q0(),H()}if(!e)break i;x(A,k,e)}u[A+e|0]=0,A=i[18127],i[f+8>>2]=A,i[i[A-12>>2]+(f+8|0)>>2]=i[18130],i[t>>2]=71232,u[f+55|0]<0&&Z(i[f+44>>2]),E0(t),y0(f- -64|0),v=f+160|0}function DX(A,e,r,f,k,n,t){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,t=t|0;var o=0,s=0,w=0,h=0,_=0;o=v-160|0,v=o;i:{e:{if(s=i[e+16>>2],!s||(h=W0(s,94756,95784),!h))break e;if(s=i[e+20>>2],s&&(i[s+4>>2]=i[s+4>>2]+1),w=i[e>>2],i[o+104>>2]=i[w+48>>2],w=i[w+52>>2],i[o+108>>2]=w,w&&(i[w+4>>2]=i[w+4>>2]+1),e=i[e+8>>2],w=i[e+8>>2],_=i[e+4>>2],e=i[o+108>>2],i[o+32>>2]=i[o+104>>2],i[o+36>>2]=e,e=o+112|0,tr(e,o+32|0,r,_,w),t0[o+72>>3]=i[h+4>>2],t0[o+80>>3]=i[h+8>>2],r=i[o+84>>2],i[o+24>>2]=i[o+80>>2],i[o+28>>2]=r,r=i[o+76>>2],i[o+16>>2]=i[o+72>>2],i[o+20>>2]=r,l3(o+88|0,e,o+16|0),t0[o+40>>3]=u0[h+12>>2],t0[o+48>>3]=u0[h+16>>2],r=i[o+52>>2],i[o+8>>2]=i[o+48>>2],i[o+12>>2]=r,r=i[o+44>>2],i[o>>2]=i[o+40>>2],i[o+4>>2]=r,Il(o+56|0,e,o),t0[f>>3]=t0[o+88>>3],t0[k>>3]=t0[o+96>>3],t0[n>>3]=t0[o+56>>3],t0[t>>3]=t0[o+64>>3],i[A+8>>2]=i[24058],e=i[24057],i[A>>2]=i[24056],i[A+4>>2]=e,!s||(A=i[s+4>>2],i[s+4>>2]=A-1,A))break i;W[i[i[s>>2]+8>>2]](s),y(s);break i}e=i[24170],i[A>>2]=i[24169],i[A+4>>2]=e,i[A+8>>2]=i[24171]}v=o+160|0}function MX(A,e,r,f,k,n,t){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,t=t|0;var o=0,s=0,w=0,h=0,_=0;o=v-160|0,v=o;i:{e:{if(s=i[e+16>>2],!s||(h=W0(s,94756,95828),!h))break e;if(s=i[e+20>>2],s&&(i[s+4>>2]=i[s+4>>2]+1),w=i[e>>2],i[o+104>>2]=i[w+48>>2],w=i[w+52>>2],i[o+108>>2]=w,w&&(i[w+4>>2]=i[w+4>>2]+1),e=i[e+8>>2],w=i[e+8>>2],_=i[e+4>>2],e=i[o+108>>2],i[o+32>>2]=i[o+104>>2],i[o+36>>2]=e,e=o+112|0,tr(e,o+32|0,r,_,w),t0[o+72>>3]=i[h+4>>2],t0[o+80>>3]=i[h+8>>2],r=i[o+84>>2],i[o+24>>2]=i[o+80>>2],i[o+28>>2]=r,r=i[o+76>>2],i[o+16>>2]=i[o+72>>2],i[o+20>>2]=r,l3(o+88|0,e,o+16|0),t0[o+40>>3]=u0[h+12>>2],t0[o+48>>3]=u0[h+16>>2],r=i[o+52>>2],i[o+8>>2]=i[o+48>>2],i[o+12>>2]=r,r=i[o+44>>2],i[o>>2]=i[o+40>>2],i[o+4>>2]=r,Il(o+56|0,e,o),t0[f>>3]=t0[o+88>>3],t0[k>>3]=t0[o+96>>3],t0[n>>3]=t0[o+56>>3],t0[t>>3]=t0[o+64>>3],i[A+8>>2]=i[24058],e=i[24057],i[A>>2]=i[24056],i[A+4>>2]=e,!s||(A=i[s+4>>2],i[s+4>>2]=A-1,A))break i;W[i[i[s>>2]+8>>2]](s),y(s);break i}e=i[24170],i[A>>2]=i[24169],i[A+4>>2]=e,i[A+8>>2]=i[24171]}v=o+160|0}function HX(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0;var k=0,n=0,t=0,o=0,s=0,w=0;k=v-32|0,v=k,A=i[A>>2],o=i[A+48>>2],n=i[A+52>>2],n&&(i[n+4>>2]=i[n+4>>2]+1),i[k+28>>2]=0,i[k+20>>2]=0,i[k+24>>2]=0,j1(k,o,e,k+20|0);i:{if(i[k>>2]||(A=i[k+20>>2],o=i[k+24>>2],(A|0)==(o|0)))break i;if(e=!r,w=e,e){for(;;)if(e=i[i[A>>2]+16>>2],!((e|0)==1668047216|(e|0)==1769107316)&(e|0)!=1768778098||(t=t+w|0),A=A+8|0,(o|0)==(A|0))break i}for(e=1;;){s=i[i[A>>2]+16>>2];e:{if(!((s|0)==1668047216|(s|0)==1769107316)&(s|0)!=1768778098)break e;if((f|0)>(t|0)){i[(t<<2)+r>>2]=e,t=t+1|0;break e}t=t+w|0}if(e=e+1|0,A=A+8|0,(o|0)==(A|0))break}}if(u[k+19|0]<0&&Z(i[k+8>>2]),r=i[k+20>>2],r){if(A=i[k+24>>2],e=r,(A|0)!=(e|0)){for(;;){e=i[A-4>>2];i:{if(!e||(f=i[e+4>>2],i[e+4>>2]=f-1,f))break i;W[i[i[e>>2]+8>>2]](e),y(e)}if(A=A-8|0,(r|0)==(A|0))break}e=i[k+20>>2]}i[k+24>>2]=r,Z(e)}i:{if(!n||(A=i[n+4>>2],i[n+4>>2]=A-1,A))break i;W[i[i[n>>2]+8>>2]](n),y(n)}return v=k+32|0,t|0}function zX(A,e,r,f,k){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0;var n=0,t=0,o=0,s=0,w=0,h=0,_=0;k=v-32|0,v=k,n=p(44),i[n+4>>2]=0,i[n+8>>2]=0,i[n>>2]=96904,t=n+12|0,i[t>>2]=86312,i[n+16>>2]=0,i[n+20>>2]=0,i[n+32>>2]=0,i[n+24>>2]=0,i[n+28>>2]=0,i[n+40>>2]=f,i[n+36>>2]=r,i[n+12>>2]=86224,f=i[e>>2],i[k+8>>2]=n,i[k+4>>2]=t,i[n+4>>2]=i[n+4>>2]+1,t=k+12|0,w=k+4|0,r=v-32|0,v=r,s=p(172),i[s+4>>2]=0,i[s+8>>2]=0,i[s>>2]=94424,h=f,_=Zr(s+12|0),i[h+48>>2]=_,o=i[f+52>>2],i[f+52>>2]=s;i:{if(!o||(s=i[o+4>>2],i[o+4>>2]=s-1,s))break i;W[i[i[o>>2]+8>>2]](o),y(o)}o=i[f+48>>2],i[o+156>>2]=f- -64,wf(r+8|0,o,w);i:{if(i[r+8>>2]){f=i[r+12>>2],i[t>>2]=i[r+8>>2],i[t+4>>2]=f,f=i[r+20>>2],i[t+8>>2]=i[r+16>>2],i[t+12>>2]=f,i[t+16>>2]=i[r+24>>2];break i}if(sf(t,f),u[r+27|0]>=0)break i;Z(i[r+16>>2])}v=r+32|0,r=i[k+8>>2];i:{if(!r||(f=i[r+4>>2],i[r+4>>2]=f-1,f))break i;W[i[i[r>>2]+8>>2]](r),y(r)}b0(A,k+12|0,i[e>>2]),u[k+31|0]<0&&Z(i[k+20>>2]),A=i[n+4>>2],i[n+4>>2]=A-1,A||(W[i[i[n>>2]+8>>2]](n),y(n)),v=k+32|0}function Vn(A,e,r){var f=U(0),k=U(0),n=U(0),t=U(0),o=U(0),s=U(0),w=U(0),h=U(0),_=U(0),B=U(0),m=U(0),X=U(0),Q=U(0),V=U(0),F=U(0);i[A>>2]=0,i[A+4>>2]=0;i:{e:{if((e&65534)==12){if(e=r-1&65535,e>>>0<=21&&(e=e<<2,o=p0[e+50772>>2],_=p0[e+50684>>2],k=p0[e+50596>>2],s=p0[e+50508>>2],n=p0[e+50420>>2],w=p0[e+50332>>2],t=p0[e+50244>>2],f=p0[e+50156>>2]),h=U(U(1)-U(f+t)),B=U(U(1)-U(s+k)),Q=U(U(k*h)-U(t*B)),m=U(U(1)-U(w+n)),V=U(U(t*m)-U(n*h)),X=U(o*U(U(w*Q)+U(U(s*V)+U(f*U(U(n*B)-U(k*m)))))),X==U(0))break i;F=U(U(1)-U(_+o)),p0[A>>2]=U(k*U(U(F*U(U(f*n)-U(w*t)))+U(U(_*V)+U(o*U(U(w*h)+U(f*U(-m)))))))/X,f=U(U(n*U(U(F*U(U(s*t)-U(f*k)))+U(U(_*Q)+U(o*U(U(f*B)+U(s*U(-h)))))))/X);break e}r:switch(e-1|0){case 0:i[A>>2]=1046066128,f=U(.0722000002861023);break e;case 3:i[A>>2]=1050253722,f=U(.10999999940395355);break e;case 4:case 5:i[A>>2]=1050220167,f=U(.11400000005960464);break e;case 6:i[A>>2]=1046025863,f=U(.08699999749660492);break e;case 8:case 9:break r;default:break i}i[A>>2]=1049002141,f=U(.059300001710653305)}p0[A+4>>2]=f}}function pr(A,e,r,f){var k=0,n=0,t=0,o=0,s=0,w=0;if(o=v-16|0,v=o,s=A+2140|0,oo(s,1)){if(k=(u[i[A+1384>>2]+13|0]<<3)+A|0,n=i[k+728>>2],t=i[k+732>>2],t&&(i[t+4>>2]=i[t+4>>2]+2),i[o+12>>2]=t,i[o+8>>2]=n,k=i[o+12>>2],i[o>>2]=i[o+8>>2],i[o+4>>2]=k,k=0,s=on(s,o,A,0,0,0,0),(s|0)>=0){n=i[A+2152>>2],A=i[A+2148>>2],n-A>>2>>>0>s>>>0&&(k=i[A+(s<<2)>>2]),A=1<<i[e+16840>>2]-1,n=1<<i[e+16832>>2]-1;i:{if((n|0)<0||(w=G(i[k+28>>2],i[k+40>>2]),!w))break i;o0(i[k+4>>2],n,w)}i:{if((A|0)<0||(n=G(i[k+36>>2],i[k+44>>2]),!n))break i;o0(i[k+8>>2],A,n)}i:{if((A|0)<0||(n=G(i[k+36>>2],i[k+44>>2]),!n))break i;o0(i[k+12>>2],A,n)}if(i[k+164>>2]>0)for(A=0;n=i[k+160>>2]+G(A,3)|0,w=(l[n|0]|l[n+1|0]<<8)&64767,u[n|0]=w,u[n+1|0]=w>>>8,A=A+1|0,(A|0)<i[k+164>>2];);i[k+96>>2]=r,A=i[e+16868>>2],u[k+104|0]=0,u[k+312|0]=1,i[k+100>>2]=f?2:1,i[k+92>>2]=A-1&r}i:{if(!t||(A=i[t+4>>2],i[t+4>>2]=A-1,A))break i;W[i[i[t>>2]+8>>2]](t),y(t)}return v=o+16|0,s}D0(26509,18155,1425,12303),H()}function Fn(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0;var k=0,n=0,t=0,o=0,s=0;k=v-112|0,v=k;i:{if(!f){e=i[24170],i[A>>2]=i[24169],i[A+4>>2]=e,i[A+8>>2]=i[24171];break i}e:{if(n=i[e+16>>2],!n||(o=W0(n,94756,95916),!o))break e;if(n=i[e+20>>2],n&&(i[n+4>>2]=i[n+4>>2]+1),t=i[e>>2],i[k+56>>2]=i[t+48>>2],t=i[t+52>>2],i[k+60>>2]=t,t&&(i[t+4>>2]=i[t+4>>2]+1),e=i[e+8>>2],t=i[e+8>>2],e=i[e+4>>2],s=i[k+60>>2],i[k+16>>2]=i[k+56>>2],i[k+20>>2]=s,tr(k- -64|0,k+16|0,r,e,t),r=i[o+8>>2],(i[o+12>>2]-r|0)>0)for(e=0;r=(e<<3)+r|0,t0[k+24>>3]=i[r>>2],t0[k+32>>3]=i[r+4>>2],r=i[k+36>>2],i[k+8>>2]=i[k+32>>2],i[k+12>>2]=r,r=i[k+28>>2],i[k>>2]=i[k+24>>2],i[k+4>>2]=r,l3(k+40|0,k- -64|0,k),r=(e<<4)+f|0,t0[r>>3]=t0[k+40>>3],t0[r+8>>3]=t0[k+48>>3],e=e+1|0,r=i[o+8>>2],(e|0)<i[o+12>>2]-r>>3;);if(e=i[24057],i[A>>2]=i[24056],i[A+4>>2]=e,i[A+8>>2]=i[24058],!n||(A=i[n+4>>2],i[n+4>>2]=A-1,A))break i;W[i[i[n>>2]+8>>2]](n),y(n);break i}e=i[24170],i[A>>2]=i[24169],i[A+4>>2]=e,i[A+8>>2]=i[24171]}v=k+112|0}function xX(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0;var k=0,n=0,t=0,o=0,s=0,w=0,h=0,_=0,B=0;f=v-16|0,v=f;i:{e:{r:{f:{k=l[r+20|0];A:{if(!(!i[r+16>>2]|k&1)){for(;;){o=o2(r),h=X2(r),_=X2(r),k=i[e+104>>2],n=i[e+108>>2];k:{if(k>>>0<n>>>0){t=o|(_<<24|h<<16),g[k>>1]=t,g[k+2>>1]=t>>>16,k=k+4|0;break k}if(w=i[e+100>>2],k=k-w|0,B=k>>2,t=B+1|0,t>>>0>=1073741824)break f;if(n=n-w|0,s=n>>1,n=n>>>0>=2147483644?1073741823:t>>>0<s>>>0?s:t,n){if(n>>>0>=1073741824)break r;t=p(n<<2)}else t=0;if(s=t+k|0,o=o|(_<<24|h<<16),g[s>>1]=o,g[s+2>>1]=o>>>16,o=s-(B<<2)|0,k&&x(o,w,k),i[e+108>>2]=t+(n<<2),k=s+4|0,i[e+104>>2]=k,i[e+100>>2]=o,!w)break k;Z(w)}if(i[e+104>>2]=k,k=u[r+20|0]&1,!(!k&&i[r+16>>2]))break}if(k)break A;break e}if(!(k&1))break e}if(u[f+4|0]=0,u[f+15|0]=0,q(A,2,100,f+4|0),u[f+15|0]>=0)break i;Z(i[f+4>>2]);break i}G0(),H()}z0(),H()}if(e=i[26917],i[A>>2]=i[26916],i[A+4>>2]=e,A=A+8|0,u[107683]>=0){e=i[26919],i[A>>2]=i[26918],i[A+4>>2]=e,i[A+8>>2]=i[26920];break i}T(A,i[26918],i[26919])}v=f+16|0}function TX(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0;var k=0,n=0,t=0,o=0,s=0;f=v-32|0,v=f,z2(f,e,r),u[f+19|0]<0&&Z(i[f+8>>2]),k=l[e+97|0];i:{if(k>>>0>=2){t1(A,e,15917);break i}e:{if((k|0)==1){o=e,s=Y4(r),i[o+104>>2]=s,i[e+108>>2]=l0,o=e,s=Y4(r),i[o+112>>2]=s,i[e+116>>2]=l0,o=e,s=C0(r),i[o+120>>2]=s,k=Y4(r),n=l0;break e}o=e,s=C0(r),i[o+104>>2]=s,i[e+108>>2]=0,o=e,s=C0(r),i[o+112>>2]=s,i[e+116>>2]=0,o=e,s=C0(r),i[o+120>>2]=s,k=C0(r),n=0}if(i[e+128>>2]=k,i[e+132>>2]=n,k=o2(r),u[e+139|0]=0,u[e+138|0]=k&31|96,u[e+136|0]=k>>>10|96,u[e+137|0]=k>>>5&31|96,e=i[r+16>>2],e=e>>>0>=2?2:e,k=i[r+8>>2],k&&c1(k,e),k=i[r>>2],t=W[i[i[k>>2]+8>>2]](k)|0,n=l0,t=e+t|0,n=e>>>0>t>>>0?n+1|0:n,W[i[i[k>>2]+20>>2]](k,t,n)|0,i[r+16>>2]=i[r+16>>2]-e,l[r+20|0]==1){if(u[f+20|0]=0,u[f+31|0]=0,q(A,2,100,f+20|0),u[f+31|0]>=0)break i;Z(i[f+20>>2]);break i}if(e=i[26917],i[A>>2]=i[26916],i[A+4>>2]=e,A=A+8|0,u[107683]>=0){e=i[26919],i[A>>2]=i[26918],i[A+4>>2]=e,i[A+8>>2]=i[26920];break i}T(A,i[26918],i[26919])}v=f+32|0}function SX(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0;var k=0,n=0,t=0;k=v-32|0,v=k,e=i[e>>2],n=i[e+48>>2],e=i[e+52>>2];i:{if(!e){s4(k+24|0,n,r);break i}if(i[e+4>>2]=i[e+4>>2]+1,s4(k+24|0,n,r),r=i[e+4>>2],i[e+4>>2]=r-1,r)break i;W[i[i[e>>2]+8>>2]](e),y(e)}i:{n=i[k+24>>2];e:{if(!n){i[A>>2]=1,i[A+4>>2]=2e3,i[A+8>>2]=3475;break e}if(e=h2(f),e>>>0>=2147483640)break i;r:{f:{if(e>>>0>=11){t=e|7,r=p(t+1|0),i[k+20>>2]=t-2147483647,i[k+12>>2]=r,i[k+16>>2]=e;break f}if(u[k+23|0]=e,r=k+12|0,!e)break r}if(!e)break r;x(r,f,e)}u[e+r|0]=0,e=n+116|0;r:{if((e|0)==(k+12|0))break r;if(r=u[k+23|0],u[n+127|0]>=0){if((r|0)>=0){r=i[k+16>>2],i[e>>2]=i[k+12>>2],i[e+4>>2]=r,i[e+8>>2]=i[k+20>>2];break r}M1(e,i[k+12>>2],i[k+16>>2]);break r}f=e,e=(r|0)<0,O1(f,e?i[k+12>>2]:k+12|0,e?i[k+16>>2]:r)}u[k+23|0]<0&&Z(i[k+12>>2]),e=i[24057],i[A>>2]=i[24056],i[A+4>>2]=e,i[A+8>>2]=i[24058]}A=i[k+28>>2];e:{if(!A||(e=i[A+4>>2],i[A+4>>2]=e-1,e))break e;W[i[i[A>>2]+8>>2]](A),y(A)}v=k+32|0;return}Q0(),H()}function jX(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,t=0,o=0,s=0,w=0,h=0,_=0,B=0,m=0,X=0,Q=0,V=0,F=0,I=0,E=0,R=0,N=0,M=0,z=0,S=0,O=0,P=0,a=0,$=0,f0=0,A0=0;f=G(r,6)+e|0,B=C[f+6>>1],s=C[e+6>>1],w=C[e+2>>1],k=s+w|0,m=C[e+4>>1],h=C[e>>1],t=m+h|0,o=k+t|0,n=(r<<2)+e|0,X=C[n+6>>1],Q=C[n+2>>1],V=X+Q|0,I=C[n>>1],n=C[n+4>>1],F=I+n|0,_=V+F|0,E=o-_|0,e=(r<<1)+e|0,r=C[e+6>>1],R=C[e+2>>1],N=r+R|0,M=C[e+4>>1],e=C[e>>1],z=M+e|0,S=N+z|0,O=C[f+2>>1],P=B+O|0,a=C[f+4>>1],f=C[f>>1],$=a+f|0,f0=P+$|0,A0=S-f0|0,g[A+24>>1]=E-A0,g[A+16>>1]=E+A0,o=o+_|0,_=S+f0|0,g[A+8>>1]=o-_,g[A>>1]=o+_,k=t-k|0,t=F-V|0,o=k-t|0,V=z-N|0,F=$-P|0,_=V-F|0,g[A+26>>1]=o-_,g[A+18>>1]=o+_,k=k+t|0,t=V+F|0,g[A+10>>1]=k-t,g[A+2>>1]=k+t,s=w-s|0,w=h-m|0,k=s+w|0,m=Q-X|0,n=I-n|0,h=m+n|0,t=k-h|0,r=R-r|0,e=e-M|0,o=r+e|0,B=O-B|0,f=f-a|0,X=B+f|0,Q=o-X|0,g[A+28>>1]=t-Q,g[A+20>>1]=t+Q,k=k+h|0,h=o+X|0,g[A+12>>1]=k-h,g[A+4>>1]=k+h,s=w-s|0,n=n-m|0,w=s-n|0,e=e-r|0,r=f-B|0,f=e-r|0,g[A+30>>1]=w-f,g[A+22>>1]=f+w,f=n+s|0,e=e+r|0,g[A+14>>1]=f-e,g[A+6>>1]=e+f}function X8(A,e,r,f,k,n,t,o,s,w,h){var _=0;i:{e:{r:{f:{A:{if(!((e+f|0)<=(w|0)|(e|0)>(w|0)|(r|0)>(h|0))&&(r+f|0)>(h|0))break A;if(f=0,(w|h)<0||(e=i[A+124>>2],i[e+484>>2]<=(w|0)|i[e+488>>2]<=(h|0))||(t=i[A+132>>2],o=i[t+8496>>2],r=i[e+16936>>2],s=i[e+16924>>2],i[(o+(w>>>r<<2)|0)+(G(s,h>>>r|0)<<2)>>2]>i[(o+(k>>r<<2)|0)+(G(s,n>>r)<<2)>>2])||(o=i[A+140>>2],r=i[e+16876>>2],k=k>>r,s=i[A+152>>2],n=n>>r,_=w>>>r|0,r=h>>>r|0,C[(o+G(k,24)|0)+G(G(s,n),24)>>1]!=C[(o+G(_,24)|0)+G(G(r,s),24)>>1]))break r;if(o=k<<2,k=i[t+8484>>2],e=i[e+16892>>2],i[(o+k|0)+(G(e,n)<<2)>>2]==i[(k+(_<<2)|0)+(G(e,r)<<2)>>2])break f;break r}if(t<<1!=(f|0)|o<<1!=(f|0)|((s|0)!=1|(r+o|0)>(h|0)))break f;if(f=0,(e+t|0)>(w|0))break r}if(r=i[A+168>>2],e=w>>r,(e|0)<0||(f=i[A+172>>2],(f|0)<=(e|0)))break e;if(r=h>>r,(r|0)<0|(r|0)>=i[A+176>>2])break i;f=(l[((i[A+160>>2]+G(e,3)|0)+G(G(r,f),3)|0)+1|0]&3)!=0}return f}D0(4656,10913,118,4231),H()}D0(4618,10913,119,4231),H()}function OX(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,t=0;f=v-160|0,v=f,i[f+104>>2]=0,i[f+76>>2]=72500,n=i[18128],i[f+20>>2]=n,k=i[n-12>>2],n=f+20|0,i[k+n>>2]=i[18129],t=n+i[i[f+20>>2]-12>>2]|0,k=f+24|0,J0(t,k),u[t+80|0]=0,i[t+72>>2]=0,i[f+76>>2]=72500,i[f+20>>2]=72480,t=R0(k),i[t>>2]=71232,k=f- -64|0,i[k>>2]=0,i[k+4>>2]=0,i[f+56>>2]=0,i[f+60>>2]=0,i[f+72>>2]=16,k=f+8|0,U1(k,e,r),e=u[f+19|0],r=(e|0)<0,Y(n,r?i[f+8>>2]:k,r?i[f+12>>2]:e),u[f+19|0]<0&&Z(i[f+8>>2]),e=i[f+72>>2];i:{e:{if(e&16){e=i[f+68>>2],r=i[f+48>>2],e>>>0<r>>>0&&(i[f+68>>2]=r,e=r),r=f+44|0;break e}if(!(e&8)){e=0,u[A+11|0]=0;break i}e=i[f+40>>2],r=f+32|0}e:{if(n=i[r>>2],e=e-n|0,e>>>0<2147483640){if(e>>>0>=11){k=e|7,r=p(k+1|0),i[A+8>>2]=k-2147483647,i[A>>2]=r,i[A+4>>2]=e,A=r;break e}if(u[A+11|0]=e,e)break e;e=0;break i}Q0(),H()}if(!e)break i;x(A,n,e)}u[A+e|0]=0,A=i[18127],i[f+20>>2]=A,i[i[A-12>>2]+(f+20|0)>>2]=i[18130],i[t>>2]=71232,u[f+67|0]<0&&Z(i[f+56>>2]),E0(t),y0(f+76|0),v=f+160|0}function Y2(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,t=0;f=v-160|0,v=f,i[f+104>>2]=0,i[f+76>>2]=72500,n=i[18128],i[f+20>>2]=n,k=i[n-12>>2],n=f+20|0,i[k+n>>2]=i[18129],t=n+i[i[f+20>>2]-12>>2]|0,k=f+24|0,J0(t,k),u[t+80|0]=0,i[t+72>>2]=0,i[f+76>>2]=72500,i[f+20>>2]=72480,t=R0(k),i[t>>2]=71232,k=f- -64|0,i[k>>2]=0,i[k+4>>2]=0,i[f+56>>2]=0,i[f+60>>2]=0,i[f+72>>2]=16,k=f+8|0,Xr(k,e,r),e=u[f+19|0],r=(e|0)<0,Y(n,r?i[f+8>>2]:k,r?i[f+12>>2]:e),u[f+19|0]<0&&Z(i[f+8>>2]),e=i[f+72>>2];i:{e:{if(e&16){e=i[f+68>>2],r=i[f+48>>2],e>>>0<r>>>0&&(i[f+68>>2]=r,e=r),r=f+44|0;break e}if(!(e&8)){e=0,u[A+11|0]=0;break i}e=i[f+40>>2],r=f+32|0}e:{if(n=i[r>>2],e=e-n|0,e>>>0<2147483640){if(e>>>0>=11){k=e|7,r=p(k+1|0),i[A+8>>2]=k-2147483647,i[A>>2]=r,i[A+4>>2]=e,A=r;break e}if(u[A+11|0]=e,e)break e;e=0;break i}Q0(),H()}if(!e)break i;x(A,n,e)}u[A+e|0]=0,A=i[18127],i[f+20>>2]=A,i[i[A-12>>2]+(f+20|0)>>2]=i[18130],i[t>>2]=71232,u[f+67|0]<0&&Z(i[f+56>>2]),E0(t),y0(f+76|0),v=f+160|0}function qf(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0;var k=0,n=0,t=0;k=v-32|0,v=k;i:{if(!f){i[A>>2]=5,i[A+4>>2]=2001,i[A+8>>2]=42673;break i}r4(k+24|0,i[e>>2],r,1);e:{r:{if(n=i[k+24>>2],n){if(t=W0(n,100660,94348),!t)break r;if(r=i[k+28>>2],r&&(i[r+4>>2]=i[r+4>>2]+1),f=k+4|0,W[i[i[t>>2]+52>>2]](f,t),b0(A,f,i[e>>2]),u[k+23|0]<0&&Z(i[k+12>>2]),!r||(A=i[r+4>>2],i[r+4>>2]=A-1,A))break e;W[i[i[r>>2]+8>>2]](r),y(r);break e}i[f>>2]=0,i[A+8>>2]=42673,i[A>>2]=5,i[A+4>>2]=2e3;break e}r=p(16),i[r+8>>2]=0,i[r+12>>2]=0,i[f>>2]=r,f=i[k+28>>2],i[k+24>>2]=0,i[k+28>>2]=0,i[r+4>>2]=f,i[r>>2]=n,n=i[e>>2],f=i[e+4>>2];r:{if(!f){i[r+12>>2]=f,i[r+8>>2]=n;break r}if(i[f+4>>2]=i[f+4>>2]+1,i[r+8>>2]=n,e=i[r+12>>2],i[r+12>>2]=f,!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break r;W[i[i[e>>2]+8>>2]](e),y(e)}e=i[24057],i[A>>2]=i[24056],i[A+4>>2]=e,i[A+8>>2]=i[24058]}if(A=i[k+28>>2],!A||(e=i[A+4>>2],i[A+4>>2]=e-1,e))break i;W[i[i[A>>2]+8>>2]](A),y(A)}v=k+32|0}function PX(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0;var k=0,n=0,t=0,o=0,s=0,w=0;f=v-32|0,v=f,z2(f,e,r),u[f+19|0]<0&&Z(i[f+8>>2]);i:{e:{if(l[e+97|0]){t1(A,e,19850);break e}if(B4(f+20|0,r),u[e+115|0]<0&&Z(i[e+104>>2]),k=i[f+24>>2],i[e+104>>2]=i[f+20>>2],i[e+108>>2]=k,i[e+112>>2]=i[f+28>>2],i[r+16>>2])for(;;){w=X2(r),k=i[e+120>>2],n=i[e+124>>2];r:{if(k>>>0<n>>>0){u[k|0]=w,k=k+1|0;break r}if(o=i[e+116>>2],k=k-o|0,t=k+1|0,(t|0)<0)break i;if(n=n-o|0,s=n<<1,n=n>>>0>=1073741823?2147483647:t>>>0<s>>>0?s:t,n?t=p(n):t=0,s=t+k|0,u[s|0]=w,k&&x(t,o,k),i[e+124>>2]=n+t,k=s+1|0,i[e+120>>2]=k,i[e+116>>2]=t,!o)break r;Z(o)}if(i[e+120>>2]=k,!i[r+16>>2])break}if(l[r+20|0]==1){if(u[f+20|0]=0,u[f+31|0]=0,q(A,2,100,f+20|0),u[f+31|0]>=0)break e;Z(i[f+20>>2]);break e}if(e=i[26917],i[A>>2]=i[26916],i[A+4>>2]=e,A=A+8|0,u[107683]>=0){e=i[26919],i[A>>2]=i[26918],i[A+4>>2]=e,i[A+8>>2]=i[26920];break e}T(A,i[26918],i[26919])}v=f+32|0;return}G0(),H()}function LX(A,e,r,f,k){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0;var n=0,t=0,o=0;n=v-32|0,v=n;i:{e:{if((h2(r)|0)!=4){e=i[24161],i[A>>2]=i[24160],i[A+4>>2]=e,i[A+8>>2]=i[24162];break e}if(t=l[r|0]|l[r+1|0]<<8|(l[r+2|0]<<16|l[r+3|0]<<24),i[n+28>>2]=0,i[n+20>>2]=0,i[n+24>>2]=0,$4(n+20|0,0,f,f+k|0,k),r=p(32),i[r+28>>2]=0,i[r+20>>2]=0,i[r+24>>2]=0,i[r+16>>2]=t<<24|(t&65280)<<8|(t>>>8&65280|t>>>24),i[r+12>>2]=95328,i[r>>2]=95488,i[r+4>>2]=0,i[r+8>>2]=0,f=i[n+24>>2],k=i[n+20>>2],(f|0)!=(k|0)){if(f=f-k|0,(f|0)<0)break i;t=p(f),i[r+20>>2]=t,o=f+t|0,i[r+28>>2]=o,f&&x(t,k,f),i[r+24>>2]=o}e=i[e>>2],i[n+16>>2]=r,i[n+12>>2]=r+12,i[r+4>>2]=i[r+4>>2]+1,W[i[i[e>>2]+12>>2]](e,n+12|0),e=i[n+16>>2];r:{if(!e||(f=i[e+4>>2],i[e+4>>2]=f-1,f))break r;W[i[i[e>>2]+8>>2]](e),y(e)}if(e=i[24057],i[A>>2]=i[24056],i[A+4>>2]=e,i[A+8>>2]=i[24058],A=i[r+4>>2],i[r+4>>2]=A-1,A||(W[i[i[r>>2]+8>>2]](r),y(r)),A=i[n+20>>2],!A)break e;i[n+24>>2]=A,Z(A)}v=n+32|0;return}G0(),H()}function ri(A,e,r,f){var k=0,n=0,t=0,o=0,s=0,w=0;k=v-32|0,v=k,o=i[e>>2];i:{e:{r:{f:{if(!l[e+16|0]){if(t=o3(o,f),n=0,!t)break r;if(n=i[e+36>>2],e=i[e+32>>2],n-e>>3>>>0<=f>>>0){i[A>>2]=0,i[A+4>>2]=0,i[A+16>>2]=0,i[A+20>>2]=0,i[A+8>>2]=0,i[A+12>>2]=0;break i}e=e+(f<<3)|0,f=i[e>>2],e=i[e+4>>2],i[k+28>>2]=0,i[k+20>>2]=0,i[k+24>>2]=0;break f}if(t=o3(o,0),o=i[e+24>>2],e=i[e+28>>2],i[k+28>>2]=0,i[k+20>>2]=0,i[k+24>>2]=0,n=0,!t)break r;f=G(f,t),n=f,f=f+o|0,e=n>>>0>f>>>0?e+1|0:e}if(yt(k,r,k+20|0,f,e,t),i[k>>2]){if(e=i[k+4>>2],i[A>>2]=i[k>>2],i[A+4>>2]=e,r=A+8|0,u[k+19|0]>=0){e=i[k+12>>2],i[r>>2]=i[k+8>>2],i[r+4>>2]=e,i[r+8>>2]=i[k+16>>2],u[A+20|0]=1;break e}if(T(r,i[k+8>>2],i[k+12>>2]),e=u[k+19|0],u[A+20|0]=1,(e|0)>=0)break e;Z(i[k+8>>2]);break e}u[k+19|0]<0&&Z(i[k+8>>2]),s=i[k+28>>2],w=i[k+20>>2],n=i[k+24>>2]}e=n,i[k+24>>2]=0,i[k+28>>2]=0,u[A+20|0]=0,i[A+8>>2]=s,i[A+4>>2]=e,i[A>>2]=w;break i}if(A=i[k+20>>2],!A)break i;i[k+24>>2]=A,Z(A)}v=k+32|0}function af(A){var e=0,r=0,f=0,k=0,n=0,t=0,o=0;i:{r=i[A+18592>>2];e:{r:{if(l[r+20|0]){if(e=i[A+18588>>2],n=i[e+52>>2],k=i[e+132>>2],r=i[r+24>>2],f=C[(i[e+140>>2]+G(i[(i[k+8460>>2]+(i[i[k+8448>>2]+(r<<2)>>2]<<2)|0)-4>>2],24)|0)+2>>1],f>>>0>=i[e+56>>2]-n>>2>>>0)break e;if(n=i[n+(f<<2)>>2],f=i[i[e+124>>2]+16892>>2],e=(r|0)/(f|0)|0,Tu(k,r-G(e,f)|0,e)){if(e=i[A+18592>>2],r=i[e+804>>2],r>>>0>=3)break i;ji(A+18572|0,r,i[e+800>>2]),u[A+18580|0]=0,u[A+18581|0]=0,u[A+18582|0]=0,u[A+18583|0]=0;break r}if(e=i[A+18596>>2],r=i[e+424>>2],k=i[e+428>>2]-r>>2,k>>>0<2)break e;for(f=i[A+18600>>2],e=1;;){if(t=r+(e<<2)|0,(f|0)!=i[t>>2]){if(e=e+1|0,(k|0)!=(e|0))continue;break e}break}if(e=i[t-4>>2],!e||(is(e+44|0,i[e+120>>2]),l[n+1348|0]!=1))break e;e=A+18572|0,A=n+1340|0,ni(e,A),mo(A);break r}if(e=i[r+804>>2],e>>>0>=3)break i;ji(A+18572|0,e,i[r+800>>2]),u[A+18580|0]=0,u[A+18581|0]=0,u[A+18582|0]=0,u[A+18583|0]=0}o=1}return o}D0(21669,18297,1520,5105),H()}function yr(A,e,r,f){var k=0,n=0,t=0,o=0;k=i[r+4>>2],o=i[e+4>>2];i:{if((o|0)<=i[A+4>>2]){if((k|0)<=(o|0)||(n=i[e>>2],k=i[e+4>>2],t=i[r+4>>2],i[e>>2]=i[r>>2],i[e+4>>2]=t,i[r>>2]=n,i[r+4>>2]=k,i[e+4>>2]<=i[A+4>>2]))break i;n=i[A>>2],k=i[A+4>>2],t=i[e+4>>2],i[A>>2]=i[e>>2],i[A+4>>2]=t,i[e>>2]=n,i[e+4>>2]=k,k=i[r+4>>2];break i}if(t=i[A>>2],n=i[A+4>>2],(k|0)>(o|0)){k=i[r+4>>2],i[A>>2]=i[r>>2],i[A+4>>2]=k,i[r>>2]=t,i[r+4>>2]=n,k=n;break i}if(k=i[e+4>>2],i[A>>2]=i[e>>2],i[A+4>>2]=k,i[e>>2]=t,i[e+4>>2]=n,k=i[r+4>>2],(n|0)>=(k|0))break i;k=i[r+4>>2],i[e>>2]=i[r>>2],i[e+4>>2]=k,i[r>>2]=t,i[r+4>>2]=n,k=n}i:{if(i[f+4>>2]<=(k|0)||(n=i[r>>2],k=i[r+4>>2],t=i[f+4>>2],i[r>>2]=i[f>>2],i[r+4>>2]=t,i[f>>2]=n,i[f+4>>2]=k,i[r+4>>2]<=i[e+4>>2])||(f=i[e>>2],n=i[e+4>>2],k=i[r+4>>2],i[e>>2]=i[r>>2],i[e+4>>2]=k,i[r>>2]=f,i[r+4>>2]=n,i[e+4>>2]<=i[A+4>>2]))break i;r=i[A>>2],f=i[A+4>>2],n=i[e+4>>2],i[A>>2]=i[e>>2],i[A+4>>2]=n,i[e>>2]=r,i[e+4>>2]=f}}function KX(A){A=A|0;var e=0,r=0,f=0,k=0,n=0,t=0,o=0,s=0;r=i[A+16>>2],k=i[r+18588>>2],t=i[k+124>>2],o=i[t+16892>>2],i[A+4>>2]=1,i[k+324>>2]=i[k+324>>2]-1,i[k+328>>2]=i[k+328>>2]+1,f=i[r+18588>>2],n=i[f+124>>2],e=i[n+16908>>2],s=i[r+4>>2],(e|0)>(s|0)&&(e=i[i[i[f+132>>2]+8460>>2]+(s<<2)>>2]),f=i[n+16892>>2],i[r>>2]=e,n=(e|0)/(f|0)|0,i[r+12>>2]=n,i[r+8>>2]=e-G(f,n),f=(e|0)/(o|0)|0;i:{e:{if(l[A+8|0]!=1||af(r))break e;if((o|0)<=0)break i;for(e=0,f=G(G(f,o),76);t=(f+i[k+320>>2]|0)+G(e,76)|0,i[t>>2]<=0&&(i[t>>2]=1),e=e+1|0,(o|0)!=(e|0););break i}if(Ze(r+18548|0),fr(r,1,!(l[A+8|0]!=1||l[i[r+18592>>2]+20|0])),(f|0)!=i[r+12>>2]||(e=i[r+8>>2],n=i[t+16892>>2],(e|0)>=(n|0)))break i;for(o=G(G(f,o),76);i[t+16892>>2]<=(e|0)|(f|0)>=i[t+16900>>2]||(s=(o+i[k+320>>2]|0)+G(e,76)|0,i[s>>2]<=0&&(i[s>>2]=1)),e=e+1|0,(n|0)!=(e|0););}i[A+4>>2]=3,A=i[r+18600>>2],i[A+44>>2]=i[A+44>>2]+1,h3(k)}function qX(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0;if(!(r&&e)){e=i[23570],i[A>>2]=i[23569],i[A+4>>2]=e,i[A+8>>2]=i[23571];return}e=i[e>>2],n=l[r|0],f=l[95520];i:{if(n>>>0>=f>>>0||(k=i[23883],i[e+72>>2]=i[23882],i[e+76>>2]=k,k=i[23885],i[e+80>>2]=i[23884],i[e+84>>2]=k,i[e+88>>2]=i[23886],i[e+92>>2]=i[23887],i[e+96>>2]=i[23888],k=i[23891],i[e+104>>2]=i[23890],i[e+108>>2]=k,i[e+112>>2]=i[23892],i[e+116>>2]=i[23893],i[e+120>>2]=i[23894],i[e+124>>2]=i[23895],f>>>0<2))break i;i[e+136>>2]=i[23898],i[e+140>>2]=i[23899]}f=i[r+12>>2],i[e+72>>2]=i[r+8>>2],i[e+76>>2]=f,f=i[r+20>>2],i[e+80>>2]=i[r+16>>2],i[e+84>>2]=f,i[e+88>>2]=i[r+24>>2],i[e+92>>2]=i[r+28>>2],i[e+96>>2]=i[r+32>>2],f=i[r+44>>2],i[e+104>>2]=i[r+40>>2],i[e+108>>2]=f,i[e+112>>2]=i[r+48>>2],i[e+116>>2]=i[r+52>>2],i[e+120>>2]=i[r+56>>2],i[e+124>>2]=i[r+60>>2],n>>>0>=2&&(i[e+136>>2]=i[r+72>>2],i[e+140>>2]=i[r+76>>2]),i[A+8>>2]=i[24165],e=i[24164],i[A>>2]=i[24163],i[A+4>>2]=e}function aX(){var A=0,e=0,r=0,f=0;i:{e:{r:switch(A=i[26942],A|0){case 0:break i;case 1:break r;default:break e}if(A=i[26926],(A|0)!=107708)for(;;){e=i[i[A+16>>2]+12>>2],e&&W[e|0](),e=i[A+4>>2];r:{if(e){for(;;)if(A=e,e=i[A>>2],!e)break r}for(;e=A,A=i[A+8>>2],(e|0)!=i[A>>2];);}if((A|0)==107708)break}if(V3(107704,i[26927]),i[26926]=107708,i[26927]=0,i[26928]=0,A=i[26929],(A|0)!=107720)for(;;){e=i[i[i[A+16>>2]>>2]+32>>2],e&&W[e|0](),e=i[A+4>>2];r:{if(e){for(;;)if(A=e,e=i[A>>2],!e)break r}for(;e=A,A=i[A+8>>2],(e|0)!=i[A>>2];);}if((A|0)==107720)break}if(m3(107716,i[26930]),i[26929]=107720,i[26930]=0,i[26931]=0,u[107772]=1,A=i[26971],r=i[26970],(A|0)!=(r|0))for(;;){e=i[A-4>>2];r:{if(!e||(f=i[e+4>>2],i[e+4>>2]=f-1,f))break r;W[i[i[e>>2]+8>>2]](e),y(e)}if(A=A-8|0,(r|0)==(A|0))break}i[26971]=r,A=i[26942]}i[26942]=A-1}}function W0(A,e,r){var f=0,k=0,n=0,t=0,o=0;t=v-16|0,v=t,k=i[A>>2],n=i[k-8>>2],i[t+12>>2]=n,i[t+4>>2]=A+n,i[t+8>>2]=i[k-4>>2],n=i[t+8>>2],k=S1(n,r,0),o=i[t+4>>2];i:{if(k){A=v+-64|0,v=A,v=A- -64|0,f=i[t+12>>2]?0:o;break i}if(k=v+-64|0,v=k,(A|0)>=(o|0)&&(i[k+28>>2]=0,i[k+32>>2]=0,i[k+36>>2]=0,i[k+40>>2]=0,i[k+44>>2]=0,i[k+48>>2]=0,i[k+20>>2]=0,i[k+24>>2]=0,i[k+16>>2]=0,i[k+12>>2]=r,i[k+4>>2]=n,i[k+60>>2]=0,i[k+52>>2]=1,i[k+56>>2]=16777216,i[k+8>>2]=A,W[i[i[n>>2]+20>>2]](n,k+4|0,o,o,1,0),f=i[k+28>>2]?A:0),v=k- -64|0,f)break i;f=v+-64|0,v=f,i[f+16>>2]=0,i[f+12>>2]=e,i[f+8>>2]=A,i[f+4>>2]=r,A=0,o0(f+20|0,0,39),i[f+60>>2]=0,u[f+59|0]=1,W[i[i[n>>2]+24>>2]](n,f+4|0,o,1,0);e:{r:switch(i[f+40>>2]){case 0:A=i[f+44>>2]==1&&i[f+32>>2]==1&&i[f+36>>2]==1?i[f+24>>2]:0;break e;case 1:break r;default:break e}if(i[f+28>>2]!=1&&i[f+44>>2]|i[f+32>>2]!=1|i[f+36>>2]!=1)break e;A=i[f+20>>2]}v=f- -64|0,f=A}return v=t+16|0,f}function $X(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0;var k=0,n=0,t=0,o=0,s=0;f=v-16|0,v=f,k=i[e+12>>2],o=k,n=i[e+8>>2];i:{e:{if(!(k|n)){for(e=r;i[e+16>>2]=0,e=i[e+8>>2],!!e;);break e}if(t=i[e+32>>2],k=n-t|0,n=o-(n>>>0<t>>>0)|0,!n&k>>>0>=2147483648|n){if(u[f+4|0]=0,u[f+15|0]=0,q(A,2,101,f+4|0),u[f+15|0]>=0)break i;Z(i[f+4>>2]);break i}if(!f4(r,k)||(n=i[r>>2],k=i[r+4>>2],k&&(i[k+4>>2]=i[k+4>>2]+1),o=i[e+8>>2],t=i[e+32>>2],s=o-t|0,e=i[e+12>>2]-(o>>>0<t>>>0)|0,t=W[i[i[n>>2]+8>>2]](n)|0,o=t+s|0,e=l0+e|0,W[i[i[n>>2]+20>>2]](n,o,o>>>0<t>>>0?e+1|0:e)|0,!k)||(e=i[k+4>>2],i[k+4>>2]=e-1,e))break e;W[i[i[k>>2]+8>>2]](k),y(k)}if(l[r+20|0]==1){if(u[f+4|0]=0,u[f+15|0]=0,q(A,2,100,f+4|0),u[f+15|0]>=0)break i;Z(i[f+4>>2]);break i}if(e=i[26917],i[A>>2]=i[26916],i[A+4>>2]=e,A=A+8|0,u[107683]>=0){e=i[26919],i[A>>2]=i[26918],i[A+4>>2]=e,i[A+8>>2]=i[26920];break i}T(A,i[26918],i[26919])}v=f+16|0}function In(A,e,r,f,k,n,t,o){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,t=t|0,o=o|0,A=v-16|0,v=A,i[A+12>>2]=r,i[A+8>>2]=n;i:{e:{for(;;){r:{if(r>>>0>=f>>>0){n=0;break r}if(n=2,e=i[r>>2],e>>>0>1114111|(e&-2048)==55296)break r;f:{if(e>>>0<=127){if(n=1,r=i[A+8>>2],(t-r|0)<=0)break r;i[A+8>>2]=r+1,u[r|0]=e;break f}if(e>>>0<=2047){if(r=i[A+8>>2],(t-r|0)<2)break e;i[A+8>>2]=r+1,u[r|0]=e>>>6|192,r=i[A+8>>2],i[A+8>>2]=r+1,u[r|0]=e&63|128;break f}if(r=i[A+8>>2],n=t-r|0,e>>>0<=65535){if((n|0)<3)break e;i[A+8>>2]=r+1,u[r|0]=e>>>12|224,r=i[A+8>>2],i[A+8>>2]=r+1,u[r|0]=e>>>6&63|128,r=i[A+8>>2],i[A+8>>2]=r+1,u[r|0]=e&63|128;break f}if((n|0)<4)break e;i[A+8>>2]=r+1,u[r|0]=e>>>18|240,r=i[A+8>>2],i[A+8>>2]=r+1,u[r|0]=e>>>12&63|128,r=i[A+8>>2],i[A+8>>2]=r+1,u[r|0]=e>>>6&63|128,r=i[A+8>>2],i[A+8>>2]=r+1,u[r|0]=e&63|128}r=i[A+12>>2]+4|0,i[A+12>>2]=r;continue}break}break i}n=1}return i[k>>2]=i[A+12>>2],i[o>>2]=i[A+8>>2],v=A+16|0,n|0}function dX(A,e,r,f,k,n){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0;var t=0,o=0;i:{if(i[r>>2]==1&&(f=12,n=i[r+4>>2],(n&-4)==12))break i;i[A+8>>2]=0,i[A>>2]=0,i[A+4>>2]=0;return}e=0,i[A+8>>2]=0,i[A>>2]=0,i[A+4>>2]=0,k=0;i:switch(n-12|0){case 0:f=14;case 2:k=i[r+12>>2],e=p(28),i[e+24>>2]=11,u[e+22|0]=1,g[e+20>>1]=2,i[e+16>>2]=131074,i[e+12>>2]=k,u[e+8|0]=0,i[e+4>>2]=f,i[e>>2]=1,k=e+28|0,i[A+8>>2]=k,i[A>>2]=e,i[A+4>>2]=k;break;default:break i}t=13;i:{e:{r:switch(n-13|0){case 0:t=15;case 2:if(f=k-e|0,k=(f|0)/28|0,n=k+1|0,n>>>0>=153391690)break e;if(o=i[r+12>>2],r=k<<1,n=k>>>0>=76695844?153391689:r>>>0>n>>>0?r:n,n){if(n>>>0>=153391690)break i;r=p(G(n,28))}else r=0;k=r+f|0,i[k+24>>2]=11,u[k+22|0]=1,g[k+20>>1]=2,i[k+16>>2]=131074,i[k+12>>2]=o,u[k+8|0]=1,i[k+4>>2]=t,i[k>>2]=1,t=k+G((f|0)/-28|0,28)|0,f&&x(t,e,f),i[A+8>>2]=r+G(n,28),i[A>>2]=t,e&&Z(e),i[A+4>>2]=k+28;break;default:break r}return}G0(),H()}z0(),H()}function cX(A,e,r,f,k,n,t,o){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,t=t|0,o=o|0;var s=0,w=0,h=0,_=0,B=0,m=0,X=0,Q=0,V=0,F=0,I=0;m=n+7|0,X=n+4|0;i:{if((X|0)>=-2){if((k|0)<=0)break i;for(V=t+6|0,F=k&2147483644,Q=k&3,B=-3,I=k>>>0<4;;){if(w=(B<<1)+V|0,s=(G(f,B)<<1)+r|0,h=0,!I)for(;g[w>>1]=C[s>>1],_=w,w=m<<1,_=_+w|0,g[_>>1]=C[s+2>>1],_=w+_|0,g[_>>1]=C[s+4>>1],_=w+_|0,g[_>>1]=C[s+6>>1],w=w+_|0,s=s+8|0,h=h+4|0,(F|0)!=(h|0););if(h=0,Q)for(;g[w>>1]=C[s>>1],s=s+2|0,w=(m<<1)+w|0,h=h+1|0,(Q|0)!=(h|0););if(B=B+1|0,(X|0)==(B|0))break}}if((k|0)<=0|(n|0)<=0)break i;for(f=o-8|0,r=0,e=e<<1;;){for(w=(r<<1)+A|0,s=(G(r,m)<<1)+t|0,h=0;g[w>>1]=(((((g[s+2>>1]<<2)-g[s>>1]|0)+G(g[s+8>>1]+g[s+6>>1]|0,40)|0)+(g[s+12>>1]<<2)|0)-g[s+14>>1]|0)+G(g[s+10>>1]+g[s+4>>1]|0,-11)>>f,s=s+2|0,w=e+w|0,h=h+1|0,(h|0)!=(n|0););if(r=r+1|0,(k|0)==(r|0))break}}}function bX(A,e,r,f,k,n,t,o){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,t=t|0,o=o|0;var s=0,w=0,h=0,_=0,B=0,m=0,X=0,Q=0,V=0,F=0,I=0;m=n+6|0,X=n+3|0;i:{if((X|0)>=-2){if((k|0)<=0)break i;for(V=t+6|0,F=k&2147483644,Q=k&3,B=-3,I=k>>>0<4;;){if(w=(B<<1)+V|0,s=(G(f,B)<<1)+r|0,h=0,!I)for(;g[w>>1]=C[s>>1],_=w,w=m<<1,_=_+w|0,g[_>>1]=C[s+2>>1],_=w+_|0,g[_>>1]=C[s+4>>1],_=w+_|0,g[_>>1]=C[s+6>>1],w=w+_|0,s=s+8|0,h=h+4|0,(F|0)!=(h|0););if(h=0,Q)for(;g[w>>1]=C[s>>1],s=s+2|0,w=(m<<1)+w|0,h=h+1|0,(Q|0)!=(h|0););if(B=B+1|0,(X|0)==(B|0))break}}if((k|0)<=0|(n|0)<=0)break i;for(f=o-8|0,r=0,e=e<<1;;){for(w=(r<<1)+A|0,s=(G(r,m)<<1)+t|0,h=0;g[w>>1]=g[s+12>>1]+((((((g[s+2>>1]<<2)-g[s>>1]|0)+G(g[s+4>>1],-10)|0)+G(g[s+6>>1],58)|0)+G(g[s+8>>1],17)|0)+G(g[s+10>>1],-5)|0)>>f,s=s+2|0,w=e+w|0,h=h+1|0,(h|0)!=(n|0););if(r=r+1|0,(k|0)==(r|0))break}}}function iW(A,e,r,f,k,n,t,o){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,t=t|0,o=o|0;var s=0,w=0,h=0,_=0,B=0,m=0,X=0,Q=0,V=0,F=0,I=0;m=n+6|0,X=n+4|0;i:{if((X|0)>=-1){if((k|0)<=0)break i;for(V=t+4|0,F=k&2147483644,Q=k&3,B=-2,I=k>>>0<4;;){if(w=(B<<1)+V|0,s=(G(f,B)<<1)+r|0,h=0,!I)for(;g[w>>1]=C[s>>1],_=w,w=m<<1,_=_+w|0,g[_>>1]=C[s+2>>1],_=w+_|0,g[_>>1]=C[s+4>>1],_=w+_|0,g[_>>1]=C[s+6>>1],w=w+_|0,s=s+8|0,h=h+4|0,(F|0)!=(h|0););if(h=0,Q)for(;g[w>>1]=C[s>>1],s=s+2|0,w=(m<<1)+w|0,h=h+1|0,(Q|0)!=(h|0););if(B=B+1|0,(X|0)==(B|0))break}}if((k|0)<=0|(n|0)<=0)break i;for(f=o-8|0,r=0,e=e<<1;;){for(w=(r<<1)+A|0,s=(G(r,m)<<1)+t|0,h=0;g[w>>1]=(((((g[s>>1]+G(g[s+2>>1],-5)|0)+G(g[s+4>>1],17)|0)+G(g[s+6>>1],58)|0)+G(g[s+8>>1],-10)|0)+(g[s+10>>1]<<2)|0)-g[s+12>>1]>>f,s=s+2|0,w=e+w|0,h=h+1|0,(h|0)!=(n|0););if(r=r+1|0,(k|0)==(r|0))break}}}function Cn(A,e,r,f){var k=0,n=0,t=0,o=0,s=0,w=0;t=v-32|0,v=t,n=f&65535,o=f>>>16&32767;i:{if(o-16257>>>0<=253){k=(n&33554431)<<7|r>>>25,n=0,r=r&33554431;e:{if(!(!n&(r|0)==16777216?!(A|e):!n&r>>>0<16777216)){k=k+1|0;break e}if(r^16777216|A|(e|n))break e;k=(k&1)+k|0}A=k>>>0>8388607,k=A?0:k,A=o+(A?-16255:-16256)|0;break i}if(!(!(A|r|(e|n))|((o|0)!=32767|(k|0)!=0))){k=(n&33554431)<<7|r>>>25|4194304,A=255;break i}if(o>>>0>16510){A=255;break i}if(k=!(k|o),w=k?16256:16257,s=w-o|0,(s|0)>112){k=0,A=0;break i}n=k?n:n|65536,o4(t+16|0,A,e,r,n,128-s|0),Y6(t,A,e,r,n,s),A=i[t+8>>2],k=(i[t+12>>2]&33554431)<<7|A>>>25,r=i[t>>2]|(o|0)!=(w|0)&(i[t+16>>2]|i[t+24>>2]|(i[t+20>>2]|i[t+28>>2]))!=0,n=i[t+4>>2],e=0,A=A&33554431;e:{if(!(!e&(A|0)==16777216?!(r|n):!e&A>>>0<16777216)){k=k+1|0;break e}if(A^16777216|r|(e|n))break e;k=(k&1)+k|0}A=k>>>0>8388607,k=A?k^8388608:k}return v=t+32|0,D2(2,f&-2147483648|A<<23|k),K4()}function pn(A,e,r,f,k){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0;var n=0,t=0,o=0,s=0;A=r;i:if((f-A|0)<3)break i;for(;;){i:{if(k>>>0<=o>>>0|A>>>0>=f>>>0)break i;e=u[A|0],t=e&255,n=1;e:{if((e|0)>=0)break e;if(e>>>0<4294967234)break i;if(e>>>0<=4294967263){if((l[A+1|0]&192)!=128|(f-A|0)<2)break i;n=2;break e}if(e>>>0<=4294967279){if((f-A|0)<3)break i;n=l[A+2|0],e=u[A+1|0];r:{f:{if((t|0)!=237){if((t|0)!=224)break f;if((e&-32)==-96)break r;break i}if((e|0)>=-96)break i;break r}if((e|0)>-65)break i}if((n&192)!=128)break i;n=3;break e}if((f-A|0)<4|e>>>0>4294967284)break i;n=l[A+3|0],s=l[A+2|0],e=u[A+1|0];r:{f:switch(t-240|0){case 0:if((e+112&255)>>>0>=48)break i;break r;case 4:if((e|0)>=-112)break i;break r;default:break f}if((e|0)>-65)break i}if((s&192)!=128|(n&192)!=128|(n&63|(s<<6&4032|(t<<18&1835008|(e&63)<<12)))>>>0>1114111)break i;n=4}o=o+1|0,A=A+n|0;continue}break}return A-r|0}function yn(A,e,r,f,k){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0;var n=0,t=0,o=0,s=0;A=r;i:if((f-A|0)<3)break i;for(;;){i:{if(k>>>0<=t>>>0|A>>>0>=f>>>0)break i;e=l[A|0],n=A+1|0;e:{if(e<<24>>24>=0)break e;if(e>>>0<194)break i;if(e>>>0<=223){if((l[A+1|0]&192)!=128|(f-A|0)<2)break i;n=A+2|0;break e}if(e>>>0<=239){if((f-A|0)<3)break i;o=l[A+2|0],n=u[A+1|0];r:{f:{if((e|0)!=237){if((e|0)!=224)break f;if((n&-32)==-96)break r;break i}if((n|0)>=-96)break i;break r}if((n|0)>-65)break i}if((o&192)!=128)break i;n=A+3|0;break e}if((f-A|0)<4|e>>>0>244|k-t>>>0<2)break i;o=l[A+3|0],s=l[A+2|0],n=u[A+1|0];r:{f:switch(e-240|0){case 0:if((n+112&255)>>>0>=48)break i;break r;case 4:if((n|0)>=-112)break i;break r;default:break f}if((n|0)>-65)break i}if((s&192)!=128|(o&192)!=128|(o&63|(s<<6&4032|(e<<18&1835008|(n&63)<<12)))>>>0>1114111)break i;t=t+1|0,n=A+4|0}A=n,t=t+1|0;continue}break}return A-r|0}function eW(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0;var k=0;f=v-32|0,v=f,z2(f,e,r),u[f+19|0]<0&&Z(i[f+8>>2]);i:{if(l[e+97|0]){t1(A,e,5795);break i}if(B4(f+20|0,r),u[e+115|0]<0&&Z(i[e+104>>2]),k=i[f+24>>2],i[e+104>>2]=i[f+20>>2],i[e+108>>2]=k,i[e+112>>2]=i[f+28>>2],B4(f+20|0,r),u[e+127|0]<0&&Z(i[e+116>>2]),k=i[f+24>>2],i[e+116>>2]=i[f+20>>2],i[e+120>>2]=k,i[e+124>>2]=i[f+28>>2],B4(f+20|0,r),u[e+139|0]<0&&Z(i[e+128>>2]),k=i[f+24>>2],i[e+128>>2]=i[f+20>>2],i[e+132>>2]=k,i[e+136>>2]=i[f+28>>2],B4(f+20|0,r),u[e+151|0]<0&&Z(i[e+140>>2]),k=i[f+24>>2],i[e+140>>2]=i[f+20>>2],i[e+144>>2]=k,i[e+148>>2]=i[f+28>>2],l[r+20|0]==1){if(u[f+20|0]=0,u[f+31|0]=0,q(A,2,100,f+20|0),u[f+31|0]>=0)break i;Z(i[f+20>>2]);break i}if(e=i[26917],i[A>>2]=i[26916],i[A+4>>2]=e,A=A+8|0,u[107683]>=0){e=i[26919],i[A>>2]=i[26918],i[A+4>>2]=e,i[A+8>>2]=i[26920];break i}T(A,i[26918],i[26919])}v=f+32|0}function Er(A,e,r){var f=0,k=0,n=0,t=0,o=0;i:{e:{if((e|0)==8){e=y2(r);break e}if(f=28,e&3|e>>>0<4||(n=e>>>2|0,n-1&n))break i;if(-64-e>>>0<r>>>0)return 48;n=16,e=e>>>0<=16?16:e,f=e>>>0<=16?16:e;r:{if(!(f-1&f)){e=f;break r}for(;e=n,n=e<<1,e>>>0<f>>>0;);}r:{if(-64-e>>>0<=r>>>0){i[31324]=48,r=0;break r}if(n=r>>>0<11?16:r+11&-8,k=y2((n+e|0)+12|0),r=0,!k)break r;r=k-8|0;f:{if(!(k&e-1)){e=r;break f}if(t=k-4|0,o=i[t>>2],f=e,e=((e+k|0)-1&0-e)-8|0,e=(e-r>>>0<=15?f:0)+e|0,f=e-r|0,k=(o&-8)-f|0,!(o&3)){r=i[r>>2],i[e+4>>2]=k,i[e>>2]=r+f;break f}i[e+4>>2]=k|i[e+4>>2]&1|2,k=e+k|0,i[k+4>>2]=i[k+4>>2]|1,i[t>>2]=f|i[t>>2]&1|2,k=r+f|0,i[k+4>>2]=i[k+4>>2]|1,ur(r,f)}r=i[e+4>>2];f:{if(!(r&3)||(f=r&-8,f>>>0<=n+16>>>0))break f;i[e+4>>2]=n|r&1|2,r=e+n|0,n=f-n|0,i[r+4>>2]=n|3,f=e+f|0,i[f+4>>2]=i[f+4>>2]|1,ur(r,n)}r=e+8|0}e=r}if(!e)return 48;i[A>>2]=e,f=0}return f}function rW(A,e,r,f,k){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0;var n=0,t=0,o=0,s=0,w=0;n=v-112|0,v=n;i:{if(!(k&&f)){e=i[23570],i[A>>2]=i[23569],i[A+4>>2]=e,i[A+8>>2]=i[23571];break i}e:{if(t=i[e+16>>2],!t||(w=W0(t,94756,95740),!w))break e;if(t=i[e+20>>2],t&&(i[t+4>>2]=i[t+4>>2]+1),o=i[e>>2],i[n+56>>2]=i[o+48>>2],o=i[o+52>>2],i[n+60>>2]=o,o&&(i[o+4>>2]=i[o+4>>2]+1),e=i[e+8>>2],o=i[e+8>>2],e=i[e+4>>2],s=i[n+60>>2],i[n+16>>2]=i[n+56>>2],i[n+20>>2]=s,s=n- -64|0,tr(s,n+16|0,r,e,o),t0[n+24>>3]=i[w+4>>2],t0[n+32>>3]=i[w+8>>2],e=i[n+36>>2],i[n+8>>2]=i[n+32>>2],i[n+12>>2]=e,e=i[n+28>>2],i[n>>2]=i[n+24>>2],i[n+4>>2]=e,l3(n+40|0,s,n),t0[f>>3]=t0[n+40>>3],t0[k>>3]=t0[n+48>>3],i[A+8>>2]=i[24058],e=i[24057],i[A>>2]=i[24056],i[A+4>>2]=e,!t||(A=i[t+4>>2],i[t+4>>2]=A-1,A))break i;W[i[i[t>>2]+8>>2]](t),y(t);break i}e=i[24170],i[A>>2]=i[24169],i[A+4>>2]=e,i[A+8>>2]=i[24171]}v=n+112|0}function fW(A,e,r,f,k,n,t){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,t=t|0;var o=0,s=0,w=0,h=0,_=0,B=0,m=0,X=0,Q=0,V=0,F=0;B=n+7|0,m=n+4|0;i:{if((m|0)>=-2){if((k|0)<=0)break i;for(Q=t+6|0,V=k&2147483644,X=k&3,_=-3,F=k>>>0<4;;){if(s=(_<<1)+Q|0,o=G(f,_)+r|0,w=0,!F)for(;g[s>>1]=l[o|0],h=s,s=B<<1,h=h+s|0,g[h>>1]=l[o+1|0],h=s+h|0,g[h>>1]=l[o+2|0],h=s+h|0,g[h>>1]=l[o+3|0],s=s+h|0,o=o+4|0,w=w+4|0,(V|0)!=(w|0););if(w=0,X)for(;g[s>>1]=l[o|0],o=o+1|0,s=(B<<1)+s|0,w=w+1|0,(X|0)!=(w|0););if(_=_+1|0,(m|0)==(_|0))break}}if((k|0)<=0|(n|0)<=0)break i;for(r=0,e=e<<1;;){for(s=(r<<1)+A|0,o=(G(r,B)<<1)+t|0,w=0;g[s>>1]=(((((C[o+2>>1]<<2)-C[o>>1]|0)+G(C[o+8>>1]+C[o+6>>1]|0,40)|0)+(C[o+12>>1]<<2)|0)-C[o+14>>1]|0)+G(C[o+10>>1]+C[o+4>>1]|0,-11),o=o+2|0,s=e+s|0,w=w+1|0,(w|0)!=(n|0););if(r=r+1|0,(k|0)==(r|0))break}}}function AW(A,e,r,f,k,n,t){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,t=t|0;var o=0,s=0,w=0,h=0,_=0,B=0,m=0,X=0,Q=0,V=0,F=0;B=n+6|0,m=n+3|0;i:{if((m|0)>=-2){if((k|0)<=0)break i;for(Q=t+6|0,V=k&2147483644,X=k&3,_=-3,F=k>>>0<4;;){if(s=(_<<1)+Q|0,o=G(f,_)+r|0,w=0,!F)for(;g[s>>1]=l[o|0],h=s,s=B<<1,h=h+s|0,g[h>>1]=l[o+1|0],h=s+h|0,g[h>>1]=l[o+2|0],h=s+h|0,g[h>>1]=l[o+3|0],s=s+h|0,o=o+4|0,w=w+4|0,(V|0)!=(w|0););if(w=0,X)for(;g[s>>1]=l[o|0],o=o+1|0,s=(B<<1)+s|0,w=w+1|0,(X|0)!=(w|0););if(_=_+1|0,(m|0)==(_|0))break}}if((k|0)<=0|(n|0)<=0)break i;for(r=0,e=e<<1;;){for(s=(r<<1)+A|0,o=(G(r,B)<<1)+t|0,w=0;g[s>>1]=C[o+12>>1]+((((((C[o+2>>1]<<2)-C[o>>1]|0)+G(C[o+4>>1],-10)|0)+G(C[o+6>>1],58)|0)+G(C[o+8>>1],17)|0)+G(C[o+10>>1],-5)|0),o=o+2|0,s=e+s|0,w=w+1|0,(w|0)!=(n|0););if(r=r+1|0,(k|0)==(r|0))break}}}function kW(A,e,r,f,k,n,t){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,t=t|0;var o=0,s=0,w=0,h=0,_=0,B=0,m=0,X=0,Q=0,V=0,F=0;B=n+6|0,m=n+4|0;i:{if((m|0)>=-1){if((k|0)<=0)break i;for(Q=t+4|0,V=k&2147483644,X=k&3,_=-2,F=k>>>0<4;;){if(s=(_<<1)+Q|0,o=G(f,_)+r|0,w=0,!F)for(;g[s>>1]=l[o|0],h=s,s=B<<1,h=h+s|0,g[h>>1]=l[o+1|0],h=s+h|0,g[h>>1]=l[o+2|0],h=s+h|0,g[h>>1]=l[o+3|0],s=s+h|0,o=o+4|0,w=w+4|0,(V|0)!=(w|0););if(w=0,X)for(;g[s>>1]=l[o|0],o=o+1|0,s=(B<<1)+s|0,w=w+1|0,(X|0)!=(w|0););if(_=_+1|0,(m|0)==(_|0))break}}if((k|0)<=0|(n|0)<=0)break i;for(r=0,e=e<<1;;){for(s=(r<<1)+A|0,o=(G(r,B)<<1)+t|0,w=0;g[s>>1]=(((((C[o>>1]+G(C[o+2>>1],-5)|0)+G(C[o+4>>1],17)|0)+G(C[o+6>>1],58)|0)+G(C[o+8>>1],-10)|0)+(C[o+10>>1]<<2)|0)-C[o+12>>1],o=o+2|0,s=e+s|0,w=w+1|0,(w|0)!=(n|0););if(r=r+1|0,(k|0)==(r|0))break}}}function nW(A,e,r,f,k,n){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0;var t=0,o=0;if(n=v-16|0,v=n,t=i[e+68>>2],t){t=W[i[i[t>>2]+24>>2]](t)|0;i:{e:{if(!(!i[e+64>>2]|(r|f)!=0&(t|0)<=0)&&!(W[i[i[e>>2]+24>>2]](e)|0))break e;i[A+8>>2]=-1,i[A+12>>2]=-1,i[A>>2]=0,i[A+4>>2]=0;break i}if(k>>>0>=3){i[A+8>>2]=-1,i[A+12>>2]=-1,i[A>>2]=0,i[A+4>>2]=0;break i}if(o=i[e+64>>2],f=O0(r,f,t,0),r=(t|0)>0,X3(o,r?f:0,r?l0:0,k)){i[A+8>>2]=-1,i[A+12>>2]=-1,i[A>>2]=0,i[A+4>>2]=0;break i}r=i[e+64>>2],f=W[i[r+40>>2]](r,0,0,l[r|0]&128?i[r+20>>2]==i[r+28>>2]?1:2:1)|0,k=l0;e:{if((k|0)<0)break e;if(t=i[r+8>>2],t)o=4;else{if(t=i[r+28>>2],!t)break e;o=20}r=i[o+r>>2]-t|0,f=r+f|0,k=(r>>31)+k|0,k=r>>>0>f>>>0?k+1|0:k}l0=k,i[A+8>>2]=f,i[A+12>>2]=l0,i[A>>2]=0,i[A+4>>2]=0,r=i[e+76>>2],e=i[e+72>>2],i[n>>2]=e,i[n+4>>2]=r,i[n+8>>2]=e,i[n+12>>2]=r,e=i[n+4>>2],i[A>>2]=i[n>>2],i[A+4>>2]=e}v=n+16|0;return}g1(),H()}function fi(A,e){var r=0,f=0,k=0,n=0,t=0,o=0,s=0,w=0;i:{if(t=i[A+4>>2],f=i[A>>2],k=t-f|0,r=((k|0)/20|0)+1|0,r>>>0<214748365){if(o=(i[A+8>>2]-f|0)/20|0,s=o<<1,r=o>>>0>=107374182?214748364:r>>>0<s>>>0?s:r,r>>>0>=214748365)break i;s=G(r,20),w=p(s),o=w+k|0,r=o,n=i[e+4>>2],i[r>>2]=i[e>>2],i[r+4>>2]=n,r=r+8|0;e:{if(u[e+19|0]>=0){n=i[e+12>>2],i[r>>2]=i[e+8>>2],i[r+4>>2]=n,i[r+8>>2]=i[e+16>>2];break e}T(r,i[e+8>>2],i[e+12>>2]),t=i[A+4>>2],f=i[A>>2],k=t-f|0}if(r=o+G((k|0)/-20|0,20)|0,(f|0)!=(t|0)){for(e=f,k=r;n=i[e+4>>2],i[k>>2]=i[e>>2],i[k+4>>2]=n,i[k+16>>2]=i[e+16>>2],n=i[e+12>>2],i[k+8>>2]=i[e+8>>2],i[k+12>>2]=n,i[e+16>>2]=0,i[e+8>>2]=0,i[e+12>>2]=0,k=k+20|0,e=e+20|0,(t|0)!=(e|0););for(;u[f+19|0]<0&&Z(i[f+8>>2]),f=f+20|0,(t|0)!=(f|0););f=i[A>>2]}return e=o+20|0,i[A+4>>2]=e,i[A>>2]=r,i[A+8>>2]=s+w,f&&Z(f),e}G0(),H()}z0(),H()}function En(A,e){var r=0,f=0,k=0,n=0,t=0,o=0,s=0,w=0,h=0;if(f=i[A+8>>2],r=i[A+4>>2],f-r>>3>>>0>=e>>>0){if(e){for(e=(e<<3)+r|0;i[r>>2]=0,i[r+4>>2]=0,r=r+8|0,(e|0)!=(r|0););r=e}i[A+4>>2]=r;return}i:{if(k=i[A>>2],r=r-k|0,n=(r>>3)+e|0,n>>>0<536870912){if(f=f-k|0,k=f>>2,o=f>>>0>=2147483640?536870911:n>>>0<k>>>0?k:n,o){if(o>>>0>=536870912)break i;k=p(o<<3)}else k=0;for(f=k+r|0,h=f+(e<<3)|0,r=f;i[r>>2]=0,i[r+4>>2]=0,r=r+8|0,(h|0)!=(r|0););if(e=i[A>>2],s=i[A+4>>2],f=f+(e-s|0)|0,(e|0)!=(s|0)){for(r=e,n=f;t=v-16|0,v=t,l[108637]==1&&(i[t+4>>2]=r,i[t>>2]=n,E8(33147,t)),w=i[r+4>>2],w&&(i[w>>2]=i[w>>2]+1),i[n+4>>2]=w,i[n>>2]=i[r>>2],v=t+16|0,n=n+8|0,r=r+8|0,(s|0)!=(r|0););for(;e=L8(e)+8|0,(s|0)!=(e|0););e=i[A>>2]}i[A+4>>2]=h,i[A>>2]=f,i[A+8>>2]=k+(o<<3),e&&Z(e);return}G0(),H()}z0(),H()}function t8(A,e,r){var f=0,k=0,n=0,t=0,o=0,s=0,w=0;if((e|0)!=(r|0))for(o=A+4|0;;){n=i[A+4>>2];i:{e:{r:{if(f=o,w=i[A>>2],(f|0)==(w|0))break r;t=f;f:{if(k=n,k){for(;f=k,k=i[f+4>>2],!!k;);if(s=i[e+16>>2],s>>>0<=u0[f+16>>2])break f;break r}for(;f=i[t+8>>2],k=i[f>>2]==(t|0),t=f,!!k;);if(t=o,k=t,u0[f+16>>2]<u0[e+16>>2])break r;break e}for(;;){if(k=n,f=i[k+16>>2],f>>>0>s>>>0){if(t=k,n=i[k>>2],n)continue;break e}if(f>>>0>=s>>>0)break i;if(n=i[k+4>>2],!n)break}t=k+4|0;break e}if(t=n?f+4|0:o,i[t>>2])break i;k=n?f:o}f=p(20),n=i[e+16>>2],i[f+8>>2]=k,i[f>>2]=0,i[f+4>>2]=0,i[f+16>>2]=n,i[t>>2]=f,k=i[w>>2],k&&(i[A>>2]=k),m1(i[A+4>>2],f),i[A+8>>2]=i[A+8>>2]+1}k=i[e+4>>2];i:{if(k){for(;;)if(f=k,k=i[f>>2],!k)break i}for(;f=i[e+8>>2],k=i[f>>2]!=(e|0),e=f,!!k;);}if(e=f,(r|0)==(f|0))break}}function tW(A,e,r){A=A|0,e=e|0,r=r|0;var f=0;if(!(!e|!r)){f=C[e>>1],p0[r>>2]=(f+28535&65535)>>>0<28540?U(0):U(+(f>>>0)*2e-5),f=C[e+6>>1],p0[r+12>>2]=(f+23535&65535)>>>0<23540?U(0):U(+(f>>>0)*2e-5),f=C[e+2>>1],p0[r+4>>2]=(f+28535&65535)>>>0<28540?U(0):U(+(f>>>0)*2e-5),f=C[e+8>>1],p0[r+16>>2]=(f+23535&65535)>>>0<23540?U(0):U(+(f>>>0)*2e-5),f=C[e+4>>1],p0[r+8>>2]=(f+28535&65535)>>>0<28540?U(0):U(+(f>>>0)*2e-5),f=C[e+10>>1],p0[r+20>>2]=(f+23535&65535)>>>0<23540?U(0):U(+(f>>>0)*2e-5),f=C[e+12>>1],p0[r+24>>2]=(f+28535&65535)>>>0<28540?U(0):U(+(f>>>0)*2e-5),f=C[e+14>>1],p0[r+28>>2]=(f+23535&65535)>>>0<23540?U(0):U(+(f>>>0)*2e-5),f=i[e+16>>2],t0[r+32>>3]=f-100000001>>>0<4195017295?0:+(f>>>0)*1e-4,e=i[e+20>>2],t0[r+40>>3]=e-50001>>>0<4294917296?0:+(e>>>0)*1e-4,i[A+8>>2]=i[24058],e=i[24057],i[A>>2]=i[24056],i[A+4>>2]=e;return}e=i[23570],i[A>>2]=i[23569],i[A+4>>2]=e,i[A+8>>2]=i[23571]}function $f(A,e,r,f,k,n){var t=0,o=0,s=0;t=v-32|0,v=t,i[t+8>>2]=0,i[t>>2]=0,i[t+4>>2]=0;i:{e:{r:{if(n>>>0<2)break r;f:switch(n-3|0){case 1:if(u[t+12|0]=0,u[t+23|0]=0,q(A,4,3005,t+12|0),u[t+23|0]>=0)break e;Z(i[t+12>>2]);break e;case 0:if(u[t+12|0]=0,u[t+23|0]=0,q(A,4,3005,t+12|0),u[t+23|0]>=0)break e;Z(i[t+12>>2]);break e;case 2:break f;default:break r}if(u[t+12|0]=0,u[t+23|0]=0,q(A,4,3005,t+12|0),u[t+23|0]>=0)break e;Z(i[t+12>>2]);break e}o=!k;r:{if(o)break r;if((k|0)<0)break i;if(n=p(k),i[t>>2]=n,s=k+n|0,i[t+8>>2]=s,i[t+4>>2]=s,o)break r;x(n,f,k)}if(rr(t+12|0,i[e+68>>2],i[i[r>>2]+104>>2],t,0),u[t+31|0]<0&&Z(i[t+20>>2]),e=i[26917],i[A>>2]=i[26916],i[A+4>>2]=e,A=A+8|0,u[107683]>=0){e=i[26919],i[A>>2]=i[26918],i[A+4>>2]=e,i[A+8>>2]=i[26920];break e}T(A,i[26918],i[26919])}A=i[t>>2],A&&(i[t+4>>2]=A,Z(A)),v=t+32|0;return}G0(),H()}function df(A,e,r,f,k,n,t){var o=0,s=0,w=0,h=0;o=v-16|0,v=o,e=W[i[i[e>>2]+8>>2]](e)|0,s=i[r>>2],i[o+12>>2]=i[s+116>>2],i[o+8>>2]=i[s+120>>2],k=e||k,e=i[f>>2];i:{if(i[e>>2]>=2){W[i[e+108>>2]](i[f+4>>2],o+12|0,o+8|0);break i}W[i[e+96>>2]](o+12|0,o+8|0)}u[o+6|0]=1,g[o+4>>1]=2,i[o>>2]=131074;i:{if(k){Hl(o,k);break i}if(S4(i[r>>2])){f=i[r>>2],e=C[f+6>>1]|C[f+8>>1]<<16,f=C[f+10>>1]|C[f+12>>1]<<16,i[o>>2]=e,u[o+6|0]=f>>>16,g[o+4>>1]=f;break i}u[o+6|0]=1,g[o+4>>1]=2,g[o>>1]=2,g[o+2>>1]=2}Tl(o);i:{e:{if(w=i[o+12>>2],s=i[r>>2],h=i[o+8>>2],(w|0)!=i[s+116>>2]|(h|0)!=i[s+120>>2]||!(w|!k)&&(f=C[s+6>>1]|C[s+8>>1]<<16,e=C[s+10>>1]|C[s+12>>1]<<16,(!l[k+16|0]|0)==((e&65536)>>>16|0)|(i[k+12>>2]!=(e&65535)|i[k+4>>2]!=(f&65535))))break e;e=i[r+4>>2],e&&(i[e+4>>2]=i[e+4>>2]+1),u[A+20|0]=0,i[A+4>>2]=e,i[A>>2]=s;break i}r6(A,r,w,h,o,0,n,0,t)}v=o+16|0}function uW(A,e){A=A|0,e=e|0;var r=0,f=0,k=0,n=0;r=v-96|0,v=r;i:{e:{r:{if(i[A+16>>2]!=i[e+16>>2])break r;i[r+88>>2]=0,i[r+92>>2]=0,i[r+80>>2]=0,i[r+84>>2]=0,i[r+72>>2]=0,i[r+76>>2]=0,i[r+64>>2]=0,i[r+68>>2]=0,W[i[i[A>>2]+20>>2]](r+44|0,A,r+80|0),u[r+63|0]<0&&Z(i[r+52>>2]),W[i[i[e>>2]+20>>2]](r+24|0,e,r- -64|0),u[r+43|0]<0&&Z(i[r+32>>2]),i[r+20>>2]=0,i[r+12>>2]=0,i[r+16>>2]=0,A=i[r+84>>2],f=i[r+80>>2];f:{if((A|0)==(f|0)){e=0,f=0;break f}if(A=A-f|0,(A|0)<0)break e;e=p(A),A&&x(e,f,A),f=A+e|0}i[r+8>>2]=0,i[r>>2]=0,i[r+4>>2]=0,A=i[r+68>>2],n=i[r+64>>2];f:{if((A|0)==(n|0)){A=0;break f}if(k=A-n|0,(k|0)<0)break i;A=p(k),k&&x(A,n,k),k=A+k|0}if(n=0,f=f-e|0,(f|0)==(k-A|0)&&(n=!N2(e,A,f)),A&&Z(A),e&&Z(e),A=i[r+64>>2],A&&(i[r+68>>2]=A,Z(A)),A=i[r+80>>2],!A)break r;i[r+84>>2]=A,Z(A)}return v=r+96|0,n|0}G0(),H()}G0(),H()}function oW(A,e,r,f,k,n,t){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,t=t|0;var o=0,s=0;s=v-16|0,v=s,o=p(32),i[o+28>>2]=n,i[o+24>>2]=k,i[o+20>>2]=f,i[o+16>>2]=r,i[o+12>>2]=95760,i[o+4>>2]=0,i[o+8>>2]=0,i[o>>2]=96020,r=i[e+8>>2],i[s+12>>2]=o,f=o+12|0,i[s+8>>2]=f,i[o+4>>2]=i[o+4>>2]+1,r2(r+12|0,s+8|0),r=i[s+12>>2];i:{if(!r||(k=i[r+4>>2],i[r+4>>2]=k-1,k))break i;W[i[i[r>>2]+8>>2]](r),y(r)}i:{if(!t||(i[o+4>>2]=i[o+4>>2]+1,r=p(24),i[o+4>>2]=i[o+4>>2]+1,i[r+20>>2]=o,i[r+16>>2]=f,k=i[e+8>>2],f=i[e+12>>2],f&&(i[f+4>>2]=i[f+4>>2]+1),i[r+12>>2]=f,i[r+8>>2]=k,f=i[e>>2],e=i[e+4>>2],e&&(i[e+4>>2]=i[e+4>>2]+1),i[r+4>>2]=e,i[r>>2]=f,i[t>>2]=r,e=i[o+4>>2],i[o+4>>2]=e-1,e))break i;W[i[i[o>>2]+8>>2]](o),y(o)}e=i[24057],i[A>>2]=i[24056],i[A+4>>2]=e,i[A+8>>2]=i[24058],A=i[o+4>>2],i[o+4>>2]=A-1,A||(W[i[i[o>>2]+8>>2]](o),y(o)),v=s+16|0}function lW(A,e,r,f,k,n,t){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,t=t|0;var o=0,s=0;s=v-16|0,v=s,o=p(32),i[o+28>>2]=n,i[o+24>>2]=k,i[o+20>>2]=f,i[o+16>>2]=r,i[o+12>>2]=95804,i[o+4>>2]=0,i[o+8>>2]=0,i[o>>2]=96060,r=i[e+8>>2],i[s+12>>2]=o,f=o+12|0,i[s+8>>2]=f,i[o+4>>2]=i[o+4>>2]+1,r2(r+12|0,s+8|0),r=i[s+12>>2];i:{if(!r||(k=i[r+4>>2],i[r+4>>2]=k-1,k))break i;W[i[i[r>>2]+8>>2]](r),y(r)}i:{if(!t||(i[o+4>>2]=i[o+4>>2]+1,r=p(24),i[o+4>>2]=i[o+4>>2]+1,i[r+20>>2]=o,i[r+16>>2]=f,k=i[e+8>>2],f=i[e+12>>2],f&&(i[f+4>>2]=i[f+4>>2]+1),i[r+12>>2]=f,i[r+8>>2]=k,f=i[e>>2],e=i[e+4>>2],e&&(i[e+4>>2]=i[e+4>>2]+1),i[r+4>>2]=e,i[r>>2]=f,i[t>>2]=r,e=i[o+4>>2],i[o+4>>2]=e-1,e))break i;W[i[i[o>>2]+8>>2]](o),y(o)}e=i[24057],i[A>>2]=i[24056],i[A+4>>2]=e,i[A+8>>2]=i[24058],A=i[o+4>>2],i[o+4>>2]=A-1,A||(W[i[i[o>>2]+8>>2]](o),y(o)),v=s+16|0}function ee(A,e){var r=0,f=0,k=0,n=0,t=0,o=0,s=0,w=0;i:{if(f=i[A>>2],n=i[A+4>>2]-f|0,r=((n|0)/20|0)+1|0,r>>>0<214748365){if(f=(i[A+8>>2]-f|0)/20|0,k=f<<1,r=f>>>0>=107374182?214748364:r>>>0<k>>>0?k:r,r>>>0>=214748365)break i;if(s=G(r,20),w=p(s),k=n+w|0,r=k,f=i[e+4>>2],i[r>>2]=i[e>>2],i[r+4>>2]=f,i[r+16>>2]=i[e+16>>2],r=i[e+12>>2],i[k+8>>2]=i[e+8>>2],i[k+12>>2]=r,i[e+16>>2]=0,i[e+8>>2]=0,i[e+12>>2]=0,t=i[A+4>>2],r=i[A>>2],n=k+G((t-r|0)/-20|0,20)|0,(r|0)!=(t|0)){for(e=r,f=n;o=i[e+4>>2],i[f>>2]=i[e>>2],i[f+4>>2]=o,i[f+16>>2]=i[e+16>>2],o=i[e+12>>2],i[f+8>>2]=i[e+8>>2],i[f+12>>2]=o,i[e+16>>2]=0,i[e+8>>2]=0,i[e+12>>2]=0,f=f+20|0,e=e+20|0,(t|0)!=(e|0););for(;u[r+19|0]<0&&Z(i[r+8>>2]),r=r+20|0,(t|0)!=(r|0););r=i[A>>2]}return e=k+20|0,i[A+4>>2]=e,i[A>>2]=n,i[A+8>>2]=s+w,r&&Z(r),e}G0(),H()}z0(),H()}function sW(A,e,r,f,k,n){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0;var t=0,o=0,s=0,w=0,h=0,_=0,B=0;s=i[e+24>>2],s>>>0>u0[e+44>>2]&&(i[e+44>>2]=s),s=-1,B=-1,w=n&24;i:{if(!w|(k|0)==1&(w|0)==24)break i;w=i[e+44>>2],w&&(t=e+32|0,l[t+11|0]>>>7|0&&(t=i[t>>2]),t=w-t|0,h=t>>31);e:{r:switch(k|0){case 1:if(n&8){o=i[e+12>>2]-i[e+8>>2]|0,_=o>>31;break e}o=i[e+24>>2]-i[e+20>>2]|0,_=o>>31;break e;case 0:break e;case 2:break r;default:break i}o=t,_=h}if(f=f+_|0,r=r+o|0,f=o>>>0>r>>>0?f+1|0:f,(f|0)<0|(r>>>0>t>>>0&(f|0)>=(h|0)|(f|0)>(h|0)))break i;k=n&8;e:{if(!(r|f))break e;if(!i[e+12>>2]&&k)break i;if(!(n&16))break e;if(!i[e+24>>2])break i}k&&(k=i[e+8>>2],i[e+16>>2]=i[e+44>>2],i[e+12>>2]=r+k,i[e+8>>2]=k),n&16&&(k=i[e+20>>2],i[e+28>>2]=i[e+28>>2],i[e+20>>2]=k,i[e+24>>2]=k,i[e+24>>2]=r+i[e+24>>2]),s=r,B=f}i[A+8>>2]=s,i[A+12>>2]=B,i[A>>2]=0,i[A+4>>2]=0}function wW(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0;var k=0,n=0,t=0,o=0,s=0,w=0,h=0,_=0;k=v-16|0,v=k,f=i[e+12>>2],A=i[e+4>>2],h=(f+A|0)-1|0,n=(h|0)%(f|0)|0,t=(f+((A|0)/l[r+50|0]|0)|0)-1|0,o=(t|0)%(f|0)|0,s=i[e+8>>2],w=(s|0)/l[r+51|0]|0;i:{e:{r:{if(A=l[r+48|0],(A-8&255)>>>0<9){if(f=l[r+49|0],(f-8&255)>>>0>=9)break r;if(e=0,i[k+4>>2]=0,_=s,s=h-n|0,A=Er(k+4|0,16,G(G(_,s),(A+7&248)>>>3|0)),n=A?0:i[k+4>>2],!i[r+20>>2]){if(w=0,o=0,!n)break i;break e}if(i[k+8>>2]=0,o=t-o|0,A=G(G(w,o),(f+7&248)>>>3|0),f=Er(k+8|0,16,A),e=i[k+8>>2],i[k+12>>2]=0,A=Er(k+12|0,16,A),w=i[k+12>>2],t=A?0:w,A=f?0:e,!(!n||!A|!t))break e;if(n&&Z(n),A&&Z(A),e=0,!t)break i;Z(t);break i}D0(21173,18288,117,7204),H()}D0(21219,18288,118,7204),H()}i[r+292>>2]=0,i[r+4>>2]=n,i[r+40>>2]=s,i[r+8>>2]=e,i[r+296>>2]=0,i[r+300>>2]=0,i[r+12>>2]=w,i[r+44>>2]=o,e=1}return v=k+16|0,e|0}function Yn(A,e,r,f,k,n){var t=0,o=0,s=0,w=0,h=0;if(t=v-48|0,v=t,Z8(t+40|0,e,1835625829),s=i[t+40>>2],o=s,u[o+164|0]=1,i[o+100>>2]=i[o+100>>2]&-2|1,o=h2(r),o>>>0<2147483640){i:{e:{if(o>>>0>=11){h=o|7,w=p(h+1|0),i[t+36>>2]=h-2147483647,i[t+28>>2]=w,i[t+32>>2]=o;break e}if(u[t+39|0]=o,w=t+28|0,!o)break i}if(!o)break i;x(w,r,o)}u[o+w|0]=0,r=s+128|0;i:{if((r|0)==(t+28|0))break i;if(o=u[t+39|0],u[s+139|0]>=0){if((o|0)>=0){o=i[t+32>>2],i[r>>2]=i[t+28>>2],i[r+4>>2]=o,i[r+8>>2]=i[t+36>>2];break i}M1(r,i[t+28>>2],i[t+32>>2]);break i}s=r,r=(o|0)<0,O1(s,r?i[t+28>>2]:t+28|0,r?i[t+32>>2]:o)}u[t+39|0]<0&&Z(i[t+28>>2]),r=i[i[t+40>>2]+104>>2],$f(t+8|0,e,t+40|0,k,n,f),u[t+27|0]<0&&Z(i[t+16>>2]),u[A+20|0]=0,i[A>>2]=r,A=i[t+44>>2];i:{if(!A||(e=i[A+4>>2],i[A+4>>2]=e-1,e))break i;W[i[i[A>>2]+8>>2]](A),y(A)}v=t+48|0;return}Q0(),H()}function Rn(A,e,r,f,k){var n=0,t=0,o=0,s=0,w=0;if(n=v-48|0,v=n,Z8(n+40|0,e,1970432288),o=i[n+40>>2],t=o,u[t+164|0]=1,i[t+100>>2]=i[t+100>>2]&-2|1,t=h2(r),t>>>0<2147483640){i:{e:{if(t>>>0>=11){w=t|7,s=p(w+1|0),i[n+36>>2]=w-2147483647,i[n+28>>2]=s,i[n+32>>2]=t;break e}if(u[n+39|0]=t,s=n+28|0,!t)break i}if(!t)break i;x(s,r,t)}u[t+s|0]=0,r=o+152|0;i:{if((r|0)==(n+28|0))break i;if(t=u[n+39|0],u[o+163|0]>=0){if((t|0)>=0){t=i[n+32>>2],i[r>>2]=i[n+28>>2],i[r+4>>2]=t,i[r+8>>2]=i[n+36>>2];break i}M1(r,i[n+28>>2],i[n+32>>2]);break i}o=r,r=(t|0)<0,O1(o,r?i[n+28>>2]:n+28|0,r?i[n+32>>2]:t)}u[n+39|0]<0&&Z(i[n+28>>2]),r=i[i[n+40>>2]+104>>2],$f(n+8|0,e,n+40|0,f,k,0),u[n+27|0]<0&&Z(i[n+16>>2]),u[A+20|0]=0,i[A>>2]=r,A=i[n+44>>2];i:{if(!A||(e=i[A+4>>2],i[A+4>>2]=e-1,e))break i;W[i[i[A>>2]+8>>2]](A),y(A)}v=n+48|0;return}Q0(),H()}function Yr(A,e){var r=0,f=0,k=0,n=0,t=0,o=0,s=0,w=0,h=0;i:{e:{if(o=i[A+4>>2],f=i[A>>2],k=o-f|0,s=k>>4,r=s+1|0,r>>>0<268435456){if(n=i[A+8>>2]-f|0,t=n>>3,r=n>>>0>=2147483632?268435455:r>>>0<t>>>0?t:r,r>>>0>=268435456)break e;if(w=r<<4,t=p(w),r=i[e>>2],n=k+t|0,i[n+12>>2]=0,i[n+4>>2]=0,i[n+8>>2]=0,i[n>>2]=r,k=i[e+8>>2],r=i[e+4>>2],(k|0)!=(r|0)){if(e=k-r|0,(e|0)<0)break i;k=p(e),i[n+4>>2]=k,h=e+k|0,i[n+12>>2]=h,e&&x(k,r,e),i[n+8>>2]=h}if(k=n-(s<<4)|0,(f|0)!=(o|0)){for(r=f,e=k;i[e>>2]=i[r>>2],i[e+4>>2]=i[r+4>>2],i[e+8>>2]=i[r+8>>2],i[e+12>>2]=i[r+12>>2],i[r+12>>2]=0,i[r+4>>2]=0,i[r+8>>2]=0,e=e+16|0,r=r+16|0,(o|0)!=(r|0););for(;e=i[f+4>>2],e&&(i[f+8>>2]=e,Z(e)),f=f+16|0,(o|0)!=(f|0););f=i[A>>2]}return i[A+8>>2]=t+w,e=n+16|0,i[A+4>>2]=e,i[A>>2]=k,f&&Z(f),e}G0(),H()}z0(),H()}G0(),H()}function cf(A,e){var r=0,f=0,k=0,n=0,t=0,o=0,s=0;f=i[A+108>>2],n=f,k=i[A+112>>2],r=k,o=f-r|0,t=f>>31,f=r>>31,t=t-(f+(r>>>0>n>>>0)|0)|0,s=0-((r>>>0>2147483647)+f|0)|0;i:{if(!(0-(t+(o>>>0>2147483647)|0)|s)){n=f;break i}for(;k=f>>31,n=r+(k|1)|0,f=f+k|0,r=G2(n,r>>>0>n>>>0?f+1|0:f,2,0),f=l0,k=t>>31,n=o+(k|1)|0,k=t+k|0,o=G2(n,n>>>0<o>>>0?k+1|0:k,2,0),t=l0,(t-(o>>>0<2147483648)|0)!=-1;);n=r>>31,s=0-(n+(r>>>0>2147483647)|0)|0,k=r}if(t=r,A=qi(A,e),A=O0(r,n,A,A>>31),r=A+o|0,e=l0+(o>>31)|0,f=A>>>0>r>>>0?e+1|0:e,s|0-(f+(r>>>0>2147483647)|0)){for(;A=n>>31,e=t+(A|1)|0,A=n+A|0,t=G2(e,e>>>0<t>>>0?A+1|0:A,2,0),n=l0,A=f>>31,k=A,A=r+(A|1)|0,f=f+k|0,r=G2(A,A>>>0<r>>>0?f+1|0:f,2,0),A=l0,f=A,(A-(r>>>0<2147483648)|0)!=-1;);k=t,n=k>>31}return A=(k|0)/2|0,e=r+A|0,A=(A>>31)+(r>>31)|0,G2(e,e>>>0<r>>>0?A+1|0:A,t,n)}function hW(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0;k=v-16|0,v=k,i[k+12>>2]=r,i[A+16>>2]=0,i[A+12>>2]=0,i[A+8>>2]=0,i[A+28>>2]=0,i[A+20>>2]=0,i[A+24>>2]=0,e|r|i[A+92>>2]!=32||(f=i[A+64>>2],f?(i[f+80>>2]=-1,i[f+48>>2]=0,i[f>>2]=i[f>>2]|64,f=0):f=34,i[A+92>>2]=f);i:{if(l[A+96|0]!=1||(f=i[A+32>>2],!f))break i;Z(f)}i:{if(l[A+97|0]!=1||(f=i[A+56>>2],!f))break i;Z(f)}i[A+52>>2]=r;i:{e:{r:{f:{if(r>>>0>=9){if(f=l[A+98|0],!e|!(f&1))break f;u[A+96|0]=0,i[A+32>>2]=e;break r}if(u[A+96|0]=0,i[A+52>>2]=8,i[A+32>>2]=A+44,u[A+98|0]&1)break r;break e}if(r=p(r),u[A+96|0]=1,i[A+32>>2]=r,!(f&1))break e}e=0,i[A+60>>2]=0,r=0;break i}if(i[k+8>>2]=8,r=v-16|0,v=r,v=r+16|0,r=k+8|0,f=k+12|0,f=i[(i[f>>2]<i[r>>2]?r:f)>>2],i[A+60>>2]=f,e&&(r=0,f>>>0>8))break i;e=p(f),r=1}return u[A+97|0]=r,i[A+56>>2]=e,v=k+16|0,A|0}function bf(A,e){var r=0,f=0,k=0,n=0,t=0,o=0,s=0;f=i[A+100>>2],n=f,k=i[A+104>>2],r=k,o=f-r|0,t=f>>31,f=r>>31,t=t-(f+(r>>>0>n>>>0)|0)|0,s=0-((r>>>0>2147483647)+f|0)|0;i:{if(!(0-(t+(o>>>0>2147483647)|0)|s)){n=f;break i}for(;k=f>>31,n=r+(k|1)|0,f=f+k|0,r=G2(n,r>>>0>n>>>0?f+1|0:f,2,0),f=l0,k=t>>31,n=o+(k|1)|0,k=t+k|0,o=G2(n,n>>>0<o>>>0?k+1|0:k,2,0),t=l0,(t-(o>>>0<2147483648)|0)!=-1;);n=r>>31,s=0-(n+(r>>>0>2147483647)|0)|0,k=r}if(t=r,A=$i(A,e),A=O0(r,n,A,A>>31),r=A+o|0,e=l0+(o>>31)|0,f=A>>>0>r>>>0?e+1|0:e,s|0-(f+(r>>>0>2147483647)|0)){for(;A=n>>31,e=t+(A|1)|0,A=n+A|0,t=G2(e,e>>>0<t>>>0?A+1|0:A,2,0),n=l0,A=f>>31,k=A,A=r+(A|1)|0,f=f+k|0,r=G2(A,A>>>0<r>>>0?f+1|0:f,2,0),A=l0,f=A,(A-(r>>>0<2147483648)|0)!=-1;);k=t,n=k>>31}return A=(k|0)/2|0,e=r+A|0,A=(A>>31)+(r>>31)|0,G2(e,e>>>0<r>>>0?A+1|0:A,t,n)}function _W(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0;var k=0,n=0,t=0;i:{if(n=W[i[i[e>>2]+68>>2]](i[e+4>>2])|0,k=i[n>>2],!k)break i;for(;;){if(n4(i[k+4>>2],r)){if(k=i[n+4>>2],n=n+4|0,k)continue;break i}break}e:switch(i[k+8>>2]-1|0){case 0:for(k=A,n=e,t=r;A=f,f=f+1|0,e=u[A|0],!!((e|0)==32|e-9>>>0<5););r=1;r:switch((e&255)-43|0){case 2:r=0;case 0:e=u[f|0],A=f;break;default:break r}if(f=0,e=e-48|0,e>>>0<=9)for(;f=G(f,10)-e|0,e=u[A+1|0],A=A+1|0,e=e-48|0,e>>>0<10;);Dn(k,n,t,r?0-f|0:f);return;case 1:k=1;r:{if(!n4(f,11885)||(k=0,!n4(f,12200)|l[f|0]!=49))break r;k=!l[f+1|0]}W[i[i[e>>2]+80>>2]](A,i[e+4>>2],r,k);return;case 2:W[i[i[e>>2]+88>>2]](A,i[e+4>>2],r,f);return;default:break e}e=i[24057],i[A>>2]=i[24056],i[A+4>>2]=e,i[A+8>>2]=i[24058];return}W[i[i[e>>2]+88>>2]](A,i[e+4>>2],r,f)}function Jn(A){var e=0,r=0,f=0,k=0,n=0;if(r=i[A+8>>2],!!r){if(e=i[A+4>>2],(e|0)==6){e=i[r+24>>2];i:{if((e|0)<i[r+28>>2]){f=i[r+20>>2];break i}if(n=e+1|0,f=y2(n),!f)return;k=i[r+20>>2],k&&(e&&x(f,k,e),Z(k),e=i[r+24>>2]),i[r+28>>2]=n,i[r+20>>2]=f}u[e+f|0]=0,i[r+24>>2]=i[r+24>>2]+1,e=i[A+4>>2]}if((e|0)==7){e=i[r+24>>2],k=e+2|0;i:{if((k|0)<=i[r+28>>2]){f=i[r+20>>2];break i}if(f=y2(k),!f)return;n=i[r+20>>2],n&&(e&&x(f,n,e),Z(n),e=i[r+24>>2]),i[r+28>>2]=k,i[r+20>>2]=f}e=e+f|0,u[e|0]=0,u[e+1|0]=0,i[r+24>>2]=i[r+24>>2]+2,e=i[A+4>>2]}(e|0)>=5&&(k=i[A+32>>2],f=k+i[A+28>>2]|0,n=i[A+20>>2],e=i[A+16>>2],(f|0)==(((e|0)!=(n|0)?(n-e<<8)-1|0:0)|0)&&(or(A+12|0),k=i[A+32>>2],f=k+i[A+28>>2]|0,e=i[A+16>>2]),i[i[e+(f>>>8&16777212)>>2]+((f&1023)<<2)>>2]=r,i[A+32>>2]=k+1,e=i[r+24>>2],i[A+8>>2]=0,i[A+36>>2]=e+i[A+36>>2]),i[A+4>>2]=0}}function BW(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,t=0,o=0,s=0,w=0,h=0;n=v-32|0,v=n,B9(A,e);i:{if(i[A>>2])break i;if(u[A+19|0]<0&&Z(i[A+8>>2]),t=W[i[i[e>>2]+52>>2]](e,r,0)|0,f=i[e+104>>2],o=i[e+108>>2],(f|0)!=(o|0))for(k=l[e+97|0],s=k?4:2,h=k?2:1;;){if(F0(r,((i[f+48>>2]-i[f+44>>2]>>2)+1<<h)+10|0),F0(r,i[f+16>>2]),Z1(r,s,i[f+40>>2],0),u2(r,i[f+48>>2]-i[f+44>>2]>>>2&65535),k=i[f+44>>2],w=i[f+48>>2],(k|0)!=(w|0))for(;Z1(r,s,i[k>>2],0),k=k+4|0,(w|0)!=(k|0););if(f=f+56|0,(o|0)==(f|0))break}if(i[r+12>>2]=t,W[i[i[e>>2]+56>>2]](n+12|0,e,r,i[r+4>>2]-(i[r>>2]+t|0)|0,0),i[r+12>>2]=i[r+4>>2]-i[r>>2],u[n+31|0]<0&&Z(i[n+20>>2]),e=i[26917],i[A>>2]=i[26916],i[A+4>>2]=e,A=A+8|0,u[107683]>=0){e=i[26919],i[A>>2]=i[26918],i[A+4>>2]=e,i[A+8>>2]=i[26920];break i}T(A,i[26918],i[26919])}v=n+32|0}function Nn(A,e){var r=0,f=0,k=0,n=0,t=0,o=0,s=0;k=v-32|0,v=k;i:{if(n=i[A>>2],o=i[A+4>>2]-n|0,f=(o>>4)+1|0,f>>>0<268435456){if(t=i[A+8>>2],i[k+28>>2]=A+8,n=t-n|0,t=n>>3,f=n>>>0>=2147483632?268435455:f>>>0<t>>>0?t:f,f){if(f>>>0>=268435456)break i;r=p(f<<4)}if(i[k+12>>2]=r,i[k+24>>2]=(f<<4)+r,r=r+o|0,i[k+16>>2]=r,g[r>>1]=C[e>>1],i[r+4>>2]=i[e+4>>2],i[r+8>>2]=i[e+8>>2],i[r+12>>2]=i[e+12>>2],i[e+12>>2]=0,i[e+4>>2]=0,i[e+8>>2]=0,i[k+20>>2]=r+16,et(A,k+12|0),o=i[A+4>>2],r=i[k+20>>2],n=i[k+16>>2],(r|0)!=(n|0))for(;;){if(A=r-16|0,i[k+20>>2]=A,t=r-12|0,f=i[t>>2],f){if(s=r-8|0,A=i[s>>2],e=f,(A|0)!=(f|0)){for(;e=A-12|0,r=i[e>>2],r&&(i[A-8>>2]=r,Z(r)),A=e,(f|0)!=(A|0););e=i[t>>2]}i[s>>2]=f,Z(e),A=i[k+20>>2]}if(r=A,(n|0)==(r|0))break}return A=i[k+12>>2],A&&Z(A),v=k+32|0,o}G0(),H()}z0(),H()}function vW(A,e,r,f,k,n,t,o){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,t=t|0,o=o|0,t=v-80|0,v=t;i:{if(!((k|0)==1885954932|(k|0)==1986618469)){i[A>>2]=5,i[A+4>>2]=2006,i[A+8>>2]=15291;break i}i[t+52>>2]=0,i[t+56>>2]=0,i[t+60>>2]=0,i[t+64>>2]=0,i[t+44>>2]=0,i[t+48>>2]=0,u[t+40|0]=0,i[t+36>>2]=9e4,rn(t+12|0,i[e>>2],n||t+36|0,k,r,f);e:{r:switch(l[t+32|0]){default:_2(),H();case 1:b0(A,t+12|0,i[e>>2]);break e;case 0:break r}o&&(r=p(16),k=i[t+12>>2],f=i[t+16>>2],f&&(i[f+4>>2]=i[f+4>>2]+1),i[r+4>>2]=f,i[r>>2]=k,f=i[e>>2],e=i[e+4>>2],e&&(i[e+4>>2]=i[e+4>>2]+1),i[r+12>>2]=e,i[r+8>>2]=f,i[o>>2]=r),e=i[24164],i[A>>2]=i[24163],i[A+4>>2]=e,i[A+8>>2]=i[24165]}if(A=l[t+32|0],(A|0)!=255&&(e=i[24197],i[t+72>>2]=i[24196],i[t+76>>2]=e,W[i[(t+72|0)+(A<<2)>>2]](t+71|0,t+12|0)),x2(i[t+48>>2]),u[t+67|0]>=0)break i;Z(i[t+56>>2])}v=t+80|0}function mW(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,t=0,o=0,s=0,w=0;if(n=v-32|0,v=n,t=W[i[i[e>>2]+52>>2]](e,r,0)|0,F0(r,i[e+108>>2]-i[e+104>>2]>>4),k=i[e+104>>2],o=i[e+108>>2],(k|0)!=(o|0))for(;;){f=i[k>>2];i:{if(!l[e+97|0]){u2(r,f&65535);break i}F0(r,f)}if(l2(r,i[k+8>>2]-i[k+4>>2]>>>2&255),f=i[k+4>>2],s=i[k+8>>2],(f|0)!=(s|0))for(;;){w=l[f|0];i:{if(u[e+100|0]&1){u2(r,w<<15&32768|C[f+2>>1]&32767);break i}l2(r,l[f+2|0]&127|w<<7&128)}if(f=f+4|0,(s|0)==(f|0))break}if(k=k+16|0,(o|0)==(k|0))break}i[r+12>>2]=t,W[i[i[e>>2]+56>>2]](n+12|0,e,r,i[r+4>>2]-(i[r>>2]+t|0)|0,0),i[r+12>>2]=i[r+4>>2]-i[r>>2],u[n+31|0]<0&&Z(i[n+20>>2]),e=i[26917],i[A>>2]=i[26916],i[A+4>>2]=e,A=A+8|0;i:{if(u[107683]>=0){e=i[26919],i[A>>2]=i[26918],i[A+4>>2]=e,i[A+8>>2]=i[26920];break i}T(A,i[26918],i[26919])}v=n+32|0}function e4(A,e,r){var f=0,k=0,n=0,t=0,o=0,s=0;i:{k=i[A+4>>2],o=i[A>>2],s=k-o|0,f=i[A+12>>2]+8|0;e:{if(s>>>0>=f>>>0)break e;if(t=f-s|0,n=i[A+8>>2],t>>>0<=n-k>>>0){t&&o0(k,0,t),i[A+4>>2]=k+t;break e}if((f|0)<0)break i;if(k=n-o|0,n=k<<1,n=k>>>0>=1073741823?2147483647:f>>>0<n>>>0?n:f,k=p(n),t&&o0(k+s|0,0,t),s&&x(k,o,s),i[A+8>>2]=k+n,i[A+4>>2]=f+k,i[A>>2]=k,!o)break e;Z(o)}f=i[A+12>>2],i[A+12>>2]=f+1,u[f+i[A>>2]|0]=r>>>24,f=i[A+12>>2],i[A+12>>2]=f+1,u[f+i[A>>2]|0]=r>>>16,f=i[A+12>>2],i[A+12>>2]=f+1,u[f+i[A>>2]|0]=r>>>8,f=i[A+12>>2],i[A+12>>2]=f+1,u[f+i[A>>2]|0]=r,f=i[A+12>>2],i[A+12>>2]=f+1,u[f+i[A>>2]|0]=(r&16777215)<<8|e>>>24,f=i[A+12>>2],i[A+12>>2]=f+1,u[f+i[A>>2]|0]=(r&65535)<<16|e>>>16,f=i[A+12>>2],i[A+12>>2]=f+1,u[f+i[A>>2]|0]=(r&255)<<24|e>>>8,r=i[A+12>>2],i[A+12>>2]=r+1,u[r+i[A>>2]|0]=e;return}G0(),H()}function ZW(A,e,r,f,k,n,t){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,t=t|0;var o=0,s=0;for(o=v-416|0,v=o,f=o+416|0,i[o+12>>2]=f,r=v-144|0,v=r,i[r+28>>2]=r+132,s=r+32|0,Co(A+8|0,s,r+28|0,k,n,t),i[r+16>>2]=0,i[r+20>>2]=0,i[r+12>>2]=s,n=o+16|0,t=i[o+12>>2]-n>>2,k=v-16|0,v=k,i[k+12>>2]=i[A+8>>2],A=s8(k+8|0,k+12|0),t=x9(n,r+12|0,t,r+16|0),A=i[A>>2],A&&(i[31366]=(A|0)==-1?125344:A),v=k+16|0,(t|0)==-1&&(g1(),H()),i[o+12>>2]=n+(t<<2),v=r+144|0,t=v-16|0,v=t,A=v-32|0,v=A,yl(A+24|0,n,i[o+12>>2]),o=i[A+28>>2],k=v-16|0,v=k,r=i[A+24>>2],i[k+8>>2]=r,i[k+12>>2]=e;;){if((r|0)!=(o|0)){Mo(k+12|0,i[r>>2]),r=r+4|0,i[k+8>>2]=r;continue}break}return i[A+16>>2]=i[k+8>>2],i[A+20>>2]=i[k+12>>2],v=k+16|0,i[A+12>>2]=n+(i[A+16>>2]-n|0),i[A+8>>2]=i[A+20>>2],i[t+8>>2]=i[A+12>>2],i[t+12>>2]=i[A+8>>2],v=A+32|0,v=t+16|0,v=f,i[t+12>>2]}function Un(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,t=0,o=0,s=0,w=0;n=v-16|0,v=n;i:{if(!r|(!A|!e))break i;CA(n+4|0,i[A>>2]),t=i[n+8>>2],A=i[n+4>>2],f=t-A>>3,f=(r|0)>(f|0)?f:r;e:{if((f|0)>0){if(r=0,f>>>0>=4)for(o=f&2147483644;i[(r<<2)+e>>2]=i[i[A+(r<<3)>>2]+116>>2],k=r|1,i[(k<<2)+e>>2]=i[i[A+(k<<3)>>2]+116>>2],k=r|2,i[(k<<2)+e>>2]=i[i[A+(k<<3)>>2]+116>>2],k=r|3,i[(k<<2)+e>>2]=i[i[A+(k<<3)>>2]+116>>2],r=r+4|0,s=s+4|0,(o|0)!=(s|0););if(o=f&3,!o)break e;for(;i[(r<<2)+e>>2]=i[i[A+(r<<3)>>2]+116>>2],r=r+1|0,w=w+1|0,(o|0)!=(w|0););break e}if(!A)break i}if((A|0)==(t|0))e=A;else{for(;;){e=i[t-4>>2];e:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break e;W[i[i[e>>2]+8>>2]](e),y(e)}if(t=t-8|0,(A|0)==(t|0))break}e=i[n+4>>2]}i[n+8>>2]=A,Z(e)}return v=n+16|0,f|0}function GW(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0;var k=0,n=0,t=0,o=0,s=0,w=0;t=v-16|0,v=t;i:{if(!r)break i;jn(t+4|0,i[A>>2],e),A=i[t+8>>2],e=i[t+4>>2],k=A-e>>3,k=(f|0)>(k|0)?k:f;e:{if((k|0)>0){if(f=0,k>>>0>=4)for(o=k&2147483644;i[(f<<2)+r>>2]=i[i[e+(f<<3)>>2]+116>>2],n=f|1,i[(n<<2)+r>>2]=i[i[e+(n<<3)>>2]+116>>2],n=f|2,i[(n<<2)+r>>2]=i[i[e+(n<<3)>>2]+116>>2],n=f|3,i[(n<<2)+r>>2]=i[i[e+(n<<3)>>2]+116>>2],f=f+4|0,s=s+4|0,(o|0)!=(s|0););if(o=k&3,!o)break e;for(;i[(f<<2)+r>>2]=i[i[e+(f<<3)>>2]+116>>2],f=f+1|0,w=w+1|0,(o|0)!=(w|0););break e}if(!e)break i}if((A|0)==(e|0))A=e;else{for(;;){r=i[A-4>>2];e:{if(!r||(f=i[r+4>>2],i[r+4>>2]=f-1,f))break e;W[i[i[r>>2]+8>>2]](r),y(r)}if(A=A-8|0,(e|0)==(A|0))break}A=i[t+4>>2]}i[t+8>>2]=e,Z(A)}return v=t+16|0,k|0}function Dn(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0;var k=0,n=0,t=0,o=0,s=0,w=0,h=0;i:{e:{r:{n=W[i[i[e>>2]+68>>2]](i[e+4>>2])|0,k=i[n>>2];f:{if(!k)break f;if(t=i[24056],!t)for(;;){o=n;A:{if(n4(i[k+4>>2],r))break A;if(i[k+8>>2]!=1)break r;if(n=0,t=0,s=0,h=l[k+16|0],h&&(s=i[k+24>>2],t=i[k+20>>2]),w=i[k+32>>2],n=(w|0)>0?i[k+28>>2]:n,(f|0)<(t|0)|(f|0)>(s|0)&&h)break i;if(k=0,(w|0)<=0)break A;for(;;){if(i[(k<<2)+n>>2]==(f|0))break A;if(k=k+1|0,(w|0)==(k|0))break}break i}if(n=o+4|0,k=i[o+4>>2],!k)break f}for(o=i[24057],s=i[24058];;){if(!n4(i[k+4>>2],r)){if(i[k+8>>2]==1)break e;break r}if(k=i[n+4>>2],n=n+4|0,!k)break}}W[i[i[e>>2]+72>>2]](A,i[e+4>>2],r,f);return}o=i[24203],s=i[24204],t=5}i[A+4>>2]=o,i[A+8>>2]=s,i[A>>2]=t;return}e=i[24206],i[A>>2]=i[24205],i[A+4>>2]=e,i[A+8>>2]=i[24207]}function XW(A,e,r,f,k,n,t,o){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,t=t|0,o=o|0;var s=0,w=0,h=0,_=0,B=0;if(!((n|0)<=0|(k|0)<=0)){for(_=o-8|0,B=r-6|0;;){for(r=(h<<1)+t|0,o=B+(G(f,h)<<1)|0,s=0;g[r>>1]=(((((C[o+2>>1]<<2)-C[o>>1]|0)+G(C[o+8>>1]+C[o+6>>1]|0,40)|0)+(C[o+12>>1]<<2)|0)-C[o+14>>1]|0)+G(C[o+10>>1]+C[o+4>>1]|0,-11)>>_,o=o+2|0,r=(n<<1)+r|0,s=s+1|0,(s|0)!=(k|0););if(h=h+1|0,(h|0)==(n|0))break}for(_=n&2147483644,h=n&3,f=0,B=n>>>0<4;;){if(r=(f<<1)+A|0,o=(G(f,n)<<1)+t|0,s=0,!B)for(;g[r>>1]=C[o>>1],w=r,r=e<<1,w=w+r|0,g[w>>1]=C[o+2>>1],w=r+w|0,g[w>>1]=C[o+4>>1],w=r+w|0,g[w>>1]=C[o+6>>1],r=r+w|0,o=o+8|0,s=s+4|0,(_|0)!=(s|0););if(s=0,h)for(;g[r>>1]=C[o>>1],o=o+2|0,r=(e<<1)+r|0,s=s+1|0,(h|0)!=(s|0););if(f=f+1|0,(k|0)==(f|0))break}}}function Mn(A,e){var r=0,f=0,k=0,n=0,t=0,o=0,s=0;k=v-32|0,v=k;i:{if(n=i[A>>2],o=i[A+4>>2]-n|0,f=(o>>4)+1|0,f>>>0<268435456){if(t=i[A+8>>2],i[k+28>>2]=A+8,n=t-n|0,t=n>>3,f=n>>>0>=2147483632?268435455:f>>>0<t>>>0?t:f,f){if(f>>>0>=268435456)break i;r=p(f<<4)}if(i[k+12>>2]=r,i[k+24>>2]=(f<<4)+r,r=r+o|0,i[k+16>>2]=r,f=C[e>>1],i[r+12>>2]=0,i[r+4>>2]=0,i[r+8>>2]=0,g[r>>1]=f,f=i[e+4>>2],e=i[e+8>>2],vA(r+4|0,f,e,(e-f|0)/12|0),i[k+20>>2]=r+16,et(A,k+12|0),o=i[A+4>>2],e=i[k+20>>2],n=i[k+16>>2],(e|0)!=(n|0))for(;;){if(A=e-16|0,i[k+20>>2]=A,t=e-12|0,f=i[t>>2],f){if(s=e-8|0,A=i[s>>2],r=f,(A|0)!=(r|0)){for(;e=A-12|0,r=i[e>>2],r&&(i[A-8>>2]=r,Z(r)),A=e,(A|0)!=(f|0););r=i[t>>2]}i[s>>2]=f,Z(r),A=i[k+20>>2]}if(e=A,(n|0)==(e|0))break}return A=i[k+12>>2],A&&Z(A),v=k+32|0,o}G0(),H()}z0(),H()}function Hn(A,e,r,f,k,n,t,o){var s=0,w=0,h=0,_=0;if(w=v-16|0,v=w,(e^-1)+1073741815>>>0>=r>>>0){if(l[A+11|0]>>>7|0?s=i[A>>2]:s=A,_=s,s=w+4|0,e>>>0<536870899?(i[w+12>>2]=e<<1,i[w+4>>2]=e+r,r=v-16|0,v=r,v=r+16|0,r=w+12|0,r=i[(u0[s>>2]<u0[r>>2]?r:s)>>2],r>>>0>=2?(h=r+2&-2,r=h-1|0,r=(r|0)==2?h:r):r=1,r=r+1|0):r=1073741815,pi(s,r),r=i[w+4>>2],k)i:{if(!k||(s=k<<2,!s))break i;x(r,_,s)}if(t){s=r+(k<<2)|0;i:{if(!t||(h=t<<2,!h))break i;x(s,o,h)}}if(s=k+n|0,o=f-s|0,(f|0)!=(s|0)){f=k<<2,s=(f+r|0)+(t<<2)|0,f=(f+_|0)+(n<<2)|0;i:{if(!o||(n=o<<2,!n))break i;x(s,f,n)}}(e|0)!=1&&$8(_,4),i[A>>2]=r,i[A+8>>2]=i[A+8>>2]&-2147483648|i[w+8>>2]&2147483647,i[A+8>>2]=i[A+8>>2]|-2147483648,e=A,A=o+(k+t|0)|0,i[e+4>>2]=A,i[w+12>>2]=0,i[r+(A<<2)>>2]=i[w+12>>2],v=w+16|0;return}Z4(),H()}function WW(A,e){A=A|0,e=e|0;var r=0,f=0,k=0;f=v-32|0,v=f,i[A+32>>2]=C[e>>1]|C[e+2>>1]<<16,e=0,C[A+32>>1]|C[A+34>>1]&&(r=p(120),e=r,i[e+4>>2]=0,i[e+8>>2]=0,i[e>>2]=91404,e=e+16|0,i[e+8>>2]=0,i[e+12>>2]=0,i[e+16>>2]=0,i[e+20>>2]=0,i[e+24>>2]=0,i[e+28>>2]=0,i[e+32>>2]=0,i[e>>2]=86356,i[r+60>>2]=0,i[r+64>>2]=0,i[r+52>>2]=0,i[r+56>>2]=0,i[r+72>>2]=-1,i[r+76>>2]=-1,i[r+80>>2]=-1,i[r+84>>2]=-1,i[r+88>>2]=0,i[r+92>>2]=0,i[r+96>>2]=0,i[r+100>>2]=0,i[r+104>>2]=0,i[r+108>>2]=0,u[r+112|0]=0,i[e>>2]=89032,i[r+32>>2]=1668050025,k=i[A+32>>2],g[r+114>>1]=k,g[r+116>>1]=k>>>16),i[f+20>>2]=r,i[f+16>>2]=e,r=i[f+20>>2],e=i[f+16>>2],i[f+24>>2]=e,i[f+28>>2]=r,i[f+16>>2]=0,i[f+20>>2]=0,i[f+8>>2]=e,i[f+12>>2]=r,M4(A,f+8|0,0),e=i[f+20>>2];i:{if(!e||(A=i[e+4>>2],i[e+4>>2]=A-1,A))break i;W[i[i[e>>2]+8>>2]](e),y(e)}v=f+32|0}function QW(A,e,r,f,k,n,t,o){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,t=t|0,o=o|0;var s=0,w=0,h=0,_=0,B=0;if(!((n|0)<=0|(k|0)<=0)){for(_=o-8|0,B=r-6|0;;){for(r=(h<<1)+t|0,o=B+(G(f,h)<<1)|0,s=0;g[r>>1]=C[o+12>>1]+((((((C[o+2>>1]<<2)-C[o>>1]|0)+G(C[o+4>>1],-10)|0)+G(C[o+6>>1],58)|0)+G(C[o+8>>1],17)|0)+G(C[o+10>>1],-5)|0)>>_,o=o+2|0,r=(n<<1)+r|0,s=s+1|0,(s|0)!=(k|0););if(h=h+1|0,(h|0)==(n|0))break}for(_=n&2147483644,h=n&3,f=0,B=n>>>0<4;;){if(r=(f<<1)+A|0,o=(G(f,n)<<1)+t|0,s=0,!B)for(;g[r>>1]=C[o>>1],w=r,r=e<<1,w=w+r|0,g[w>>1]=C[o+2>>1],w=r+w|0,g[w>>1]=C[o+4>>1],w=r+w|0,g[w>>1]=C[o+6>>1],r=r+w|0,o=o+8|0,s=s+4|0,(_|0)!=(s|0););if(s=0,h)for(;g[r>>1]=C[o>>1],o=o+2|0,r=(e<<1)+r|0,s=s+1|0,(h|0)!=(s|0););if(f=f+1|0,(k|0)==(f|0))break}}}function gW(A,e,r,f,k,n,t,o){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,t=t|0,o=o|0;var s=0,w=0,h=0,_=0,B=0;if(!((n|0)<=0|(k|0)<=0)){for(_=o-8|0,B=r-4|0;;){for(r=(h<<1)+t|0,o=B+(G(f,h)<<1)|0,s=0;g[r>>1]=(((((C[o>>1]+G(C[o+2>>1],-5)|0)+G(C[o+4>>1],17)|0)+G(C[o+6>>1],58)|0)+G(C[o+8>>1],-10)|0)+(C[o+10>>1]<<2)|0)-C[o+12>>1]>>_,o=o+2|0,r=(n<<1)+r|0,s=s+1|0,(s|0)!=(k|0););if(h=h+1|0,(h|0)==(n|0))break}for(_=n&2147483644,h=n&3,f=0,B=n>>>0<4;;){if(r=(f<<1)+A|0,o=(G(f,n)<<1)+t|0,s=0,!B)for(;g[r>>1]=C[o>>1],w=r,r=e<<1,w=w+r|0,g[w>>1]=C[o+2>>1],w=r+w|0,g[w>>1]=C[o+4>>1],w=r+w|0,g[w>>1]=C[o+6>>1],r=r+w|0,o=o+8|0,s=s+4|0,(_|0)!=(s|0););if(s=0,h)for(;g[r>>1]=C[o>>1],o=o+2|0,r=(e<<1)+r|0,s=s+1|0,(h|0)!=(s|0););if(f=f+1|0,(k|0)==(f|0))break}}}function zn(){D_(85272,15875),U_(85296,9837,1,0),N8(85308,7667,1,-128,127),N8(85332,7660,1,-128,127),N8(85320,7658,1,0,255),N8(85344,3701,2,-32768,32767),N8(85356,3692,2,0,65535),N8(85368,3716,4,-2147483648,2147483647),N8(85380,3707,4,0,-1),N8(85392,10960,4,-2147483648,2147483647),N8(85404,10951,4,0,-1),Qs(85416,4383,-2147483648,2147483647),Qs(85428,4382,0,-1),F7(85440,4239,4),F7(85452,13610,8),N_(96240,11056),lf(63996,4,11030),lf(64068,2,11068),lf(64144,4,11083),J_(96316),i4(64220,0,20649),i4(64260,0,20718),i4(96432,1,20679),i4(64300,2,20214),i4(64340,3,20245),i4(64380,4,20285),i4(64420,5,20314),i4(64460,4,20755),i4(64500,5,20785),i4(64260,0,20416),i4(96432,1,20383),i4(64300,2,20482),i4(64340,3,20448),i4(64380,4,20616),i4(64420,5,20582),i4(64540,8,20549),i4(64580,9,20515),i4(64620,6,20352),i4(64660,7,20824)}function VW(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0;var k=0,n=0,t=0;n=v-32|0,v=n;i:{if(!f){e=i[23570],i[A>>2]=i[23569],i[A+4>>2]=e,i[A+8>>2]=i[23571];break i}k=i[e>>2],t=i[k+160>>2],k=i[k+164>>2],k&&(i[k+4>>2]=i[k+4>>2]+1);e:{if(i[t+116>>2]!=(r|0)){if(i[f>>2]=0,u[n|0]=0,u[n+11|0]=0,r=q(n+12|0,5,2e3,n),u[n+11|0]<0&&Z(i[n>>2]),f=A,A=i[e>>2],b0(f,r,A?A+84|0:0),u[r+19|0]>=0)break e;Z(i[r+8>>2]);break e}r=p(16),i[r+8>>2]=0,i[r+12>>2]=0,i[f>>2]=r,k&&(i[k+4>>2]=i[k+4>>2]+1),i[r+4>>2]=k,i[r>>2]=t,r=i[e+8>>2],f=i[f>>2],t=i[e+12>>2],t&&(i[t+4>>2]=i[t+4>>2]+1),i[f+8>>2]=r,r=i[f+12>>2],i[f+12>>2]=t;r:{if(!r||(f=i[r+4>>2],i[r+4>>2]=f-1,f))break r;W[i[i[r>>2]+8>>2]](r),y(r)}r=A,A=i[e>>2],b0(r,107664,A?A+84|0:0)}if(!k||(A=i[k+4>>2],i[k+4>>2]=A-1,A))break i;W[i[i[k>>2]+8>>2]](k),y(k)}v=n+32|0}function FW(){var A=0,e=0,r=0;return A=l[7288]|l[7289]<<8|(l[7290]<<16|l[7291]<<24),i[26976]=l[7284]|l[7285]<<8|(l[7286]<<16|l[7287]<<24),i[26977]=A,A=l[7302]|l[7303]<<8|(l[7304]<<16|l[7305]<<24),e=l[7298]|l[7299]<<8|(l[7300]<<16|l[7301]<<24),g[53959]=e,g[53960]=e>>>16,g[53961]=A,g[53962]=A>>>16,A=l[7296]|l[7297]<<8|(l[7298]<<16|l[7299]<<24),i[26978]=l[7292]|l[7293]<<8|(l[7294]<<16|l[7295]<<24),i[26979]=A,h2(21340)+10>>>0<=79&&(A=h2(107904)+107904|0,e=l[28061]|l[28062]<<8|(l[28063]<<16|l[28064]<<24),r=l[28057]|l[28058]<<8|(l[28059]<<16|l[28060]<<24),u[A|0]=r,u[A+1|0]=r>>>8,u[A+2|0]=r>>>16,u[A+3|0]=r>>>24,u[A+4|0]=e,u[A+5|0]=e>>>8,u[A+6|0]=e>>>16,u[A+7|0]=e>>>24,e=l[28064]|l[28065]<<8|(l[28066]<<16|l[28067]<<24),u[A+7|0]=e,u[A+8|0]=e>>>8,u[A+9|0]=e>>>16,u[A+10|0]=e>>>24,c4(h2(107904)+107904|0,21340)),107904}function IW(A,e,r){A=A|0,e=e|0,r=r|0;var f=0;f=v-32|0,v=f,i[A+28>>2]=r,i[A+24>>2]=e,r=0,e=0,i[A+24>>2]!=i[A+28>>2]&&(r=p(128),i[r+4>>2]=0,i[r+8>>2]=0,i[r>>2]=91244,e=r+16|0,i[e+8>>2]=0,i[e+12>>2]=0,i[e+16>>2]=0,i[e+20>>2]=0,i[e+24>>2]=0,i[e+28>>2]=0,i[e+32>>2]=0,i[e>>2]=86356,i[r+60>>2]=0,i[r+64>>2]=0,i[r+52>>2]=0,i[r+56>>2]=0,i[r+72>>2]=-1,i[r+76>>2]=-1,i[r+80>>2]=-1,i[r+84>>2]=-1,i[r+88>>2]=0,i[r+92>>2]=0,i[r+96>>2]=0,i[r+100>>2]=0,i[r+104>>2]=0,i[r+108>>2]=0,u[r+112|0]=0,i[e>>2]=88872,i[r+32>>2]=1885434736,i[r+116>>2]=i[A+24>>2],i[r+120>>2]=i[A+28>>2]),i[f+20>>2]=r,i[f+16>>2]=e,r=i[f+20>>2],e=i[f+16>>2],i[f+24>>2]=e,i[f+28>>2]=r,i[f+16>>2]=0,i[f+20>>2]=0,i[f+8>>2]=e,i[f+12>>2]=r,M4(A,f+8|0,0),e=i[f+20>>2];i:{if(!e||(A=i[e+4>>2],i[e+4>>2]=A-1,A))break i;W[i[i[e>>2]+8>>2]](e),y(e)}v=f+32|0}function xn(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,t=0,o=0,s=0,w=0,h=0;if(!r){e=i[24170],i[A>>2]=i[24169],i[A+4>>2]=e,i[A+8>>2]=i[24171];return}i:{if(f=i[e+16>>2],!f||(n=W0(f,94756,95916),!n))break i;f=i[e+20>>2],f&&(i[f+4>>2]=i[f+4>>2]+1),e=i[n+12>>2],n=i[n+8>>2],s=e-n|0,t=s>>3;e:{if((t|0)<=0)break e;if(e=0,(s|0)!=8)for(h=t&2147483646,t=0;k=e<<3,o=k+r|0,w=n+k|0,i[o>>2]=i[w>>2],i[o+4>>2]=i[w+4>>2],k=k|8,o=k+r|0,k=n+k|0,i[o>>2]=i[k>>2],i[o+4>>2]=i[k+4>>2],e=e+2|0,t=t+2|0,(h|0)!=(t|0););if(!(s&8))break e;e=e<<3,r=e+r|0,e=e+n|0,i[r>>2]=i[e>>2],i[r+4>>2]=i[e+4>>2]}e=i[24057],i[A>>2]=i[24056],i[A+4>>2]=e,i[A+8>>2]=i[24058];e:{if(!f||(A=i[f+4>>2],i[f+4>>2]=A-1,A))break e;W[i[i[f>>2]+8>>2]](f),y(f)}return}e=i[24170],i[A>>2]=i[24169],i[A+4>>2]=e,i[A+8>>2]=i[24171]}function CW(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,t=0,o=0;t=v-32|0,v=t,o=W[i[i[e>>2]+52>>2]](e,r,0)|0,k=+(1<<i[e+152>>2]>>>0),n=t0[e+104>>3]*k,w2(n)<2147483647?f=~~n:f=-2147483648,F0(r,f),n=t0[e+112>>3]*k,w2(n)<2147483647?f=~~n:f=-2147483648,F0(r,f),n=t0[e+120>>3]*k,w2(n)<2147483647?f=~~n:f=-2147483648,F0(r,f),u[e+100|0]&1&&(k=t0[e+136>>3]*k,w2(k)<2147483647?f=~~k:f=-2147483648,F0(r,f),k=t0[e+144>>3]*+(1<<i[e+156>>2]>>>0),w2(k)<2147483647?f=~~k:f=-2147483648,F0(r,f)),i[r+12>>2]=o,W[i[i[e>>2]+56>>2]](t+12|0,e,r,i[r+4>>2]-(i[r>>2]+o|0)|0,0),i[r+12>>2]=i[r+4>>2]-i[r>>2],u[t+31|0]<0&&Z(i[t+20>>2]),e=i[26917],i[A>>2]=i[26916],i[A+4>>2]=e,A=A+8|0;i:{if(u[107683]>=0){e=i[26919],i[A>>2]=i[26918],i[A+4>>2]=e,i[A+8>>2]=i[26920];break i}T(A,i[26918],i[26919])}v=t+32|0}function pW(A,e,r,f,k){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0;var n=0,t=0,o=0;t=v-16|0,v=t,n=p(24),i[n+20>>2]=f,i[n+16>>2]=r,i[n+12>>2]=95716,i[n+4>>2]=0,i[n+8>>2]=0,i[n>>2]=95980,r=i[e+8>>2],i[t+12>>2]=n,f=n+12|0,i[t+8>>2]=f,i[n+4>>2]=i[n+4>>2]+1,r2(r+12|0,t+8|0),r=i[t+12>>2];i:{if(!r||(o=i[r+4>>2],i[r+4>>2]=o-1,o))break i;W[i[i[r>>2]+8>>2]](r),y(r)}i:{if(!k||(i[n+4>>2]=i[n+4>>2]+1,r=p(24),i[n+4>>2]=i[n+4>>2]+1,i[r+20>>2]=n,i[r+16>>2]=f,o=i[e+8>>2],f=i[e+12>>2],f&&(i[f+4>>2]=i[f+4>>2]+1),i[r+12>>2]=f,i[r+8>>2]=o,f=i[e>>2],e=i[e+4>>2],e&&(i[e+4>>2]=i[e+4>>2]+1),i[r+4>>2]=e,i[r>>2]=f,i[k>>2]=r,e=i[n+4>>2],i[n+4>>2]=e-1,e))break i;W[i[i[n>>2]+8>>2]](n),y(n)}e=i[24057],i[A>>2]=i[24056],i[A+4>>2]=e,i[A+8>>2]=i[24058],A=i[n+4>>2],i[n+4>>2]=A-1,A||(W[i[i[n>>2]+8>>2]](n),y(n)),v=t+16|0}function yW(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0;k=v-32|0,v=k,n=W[i[i[e>>2]+52>>2]](e,r,0)|0,f=l[e+97|0];i:{if(f>>>0<=1&&(u2(r,C[e+104>>1]),u2(r,C[e+108>>1]),F4(r,e+116|0,1),F4(r,e+128|0,1),F4(r,e+140|0,1),f=l[e+97|0],f>>>0<2))break i;e:{r:switch(f-2|0){case 0:u2(r,C[e+104>>1]);break e;case 1:break r;default:break e}F0(r,i[e+104>>2])}if(u2(r,C[e+108>>1]),F0(r,i[e+112>>2]),F4(r,e+116|0,1),f=i[e+112>>2],(f|0)==1970432288)f=152;else{if((f|0)!=1835625829)break i;F4(r,e+128|0,1),f=140}F4(r,f+e|0,1)}i[r+12>>2]=n,W[i[i[e>>2]+56>>2]](k+12|0,e,r,i[r+4>>2]-(i[r>>2]+n|0)|0,0),i[r+12>>2]=i[r+4>>2]-i[r>>2],u[k+31|0]<0&&Z(i[k+20>>2]),e=i[26917],i[A>>2]=i[26916],i[A+4>>2]=e,A=A+8|0;i:{if(u[107683]>=0){e=i[26919],i[A>>2]=i[26918],i[A+4>>2]=e,i[A+8>>2]=i[26920];break i}T(A,i[26918],i[26919])}v=k+32|0}function Tn(A){var e=0,r=0,f=0,k=0,n=0;if(e=i[A+428>>2],r=i[A+424>>2],(e|0)!=(r|0))for(;;){if(k=i[(f<<2)+r>>2],k){if(R4(i[k+140>>2]+548|0,i[k>>2]),e=i[k+132>>2],e){if(n=e-4|0,r=i[n>>2],r)for(r=e+G(r,18608)|0;L8(r-36|0),r=r-18608|0,(e|0)!=(r|0););Z(n)}Z(k),r=i[A+424>>2],e=i[A+428>>2]}if(f=f+1|0,!(f>>>0<e-r>>2>>>0))break}if(e=i[A+456>>2],f=i[A+460>>2],(e|0)!=(f|0))for(r=0;k=i[(r<<2)+e>>2],k&&(W[i[i[k>>2]+4>>2]](k),f=i[A+460>>2],e=i[A+456>>2]),r=r+1|0,r>>>0<f-e>>2>>>0;);if(f=i[A+468>>2],f){if(e=f,r=i[A+472>>2],(e|0)!=(r|0)){for(;r=L8(r-8|0),(f|0)!=(r|0););e=i[A+468>>2]}i[A+472>>2]=f,Z(e),e=i[A+456>>2]}return e&&(i[A+460>>2]=e,Z(e)),e=i[A+436>>2],e&&(i[A+440>>2]=e,Z(e)),e=i[A+424>>2],e&&(i[A+428>>2]=e,Z(e)),uA(A+8|0),A}function EW(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,t=0;f=v-32|0,v=f,n=W[i[i[e>>2]+52>>2]](e,r,0)|0,k=i[e+104>>2],t=i[e+108>>2];i:{if(l[e+97|0]==1){e4(r,k,t),e4(r,i[e+112>>2],i[e+116>>2]),F0(r,i[e+120>>2]),F0(r,0),e4(r,i[e+128>>2],i[e+132>>2]);break i}F0(r,k),F0(r,i[e+112>>2]),F0(r,i[e+120>>2]),F0(r,0),F0(r,i[e+128>>2])}e4(r,0,0),u2(r,C[e+136>>1]),u2(r,C[e+138>>1]),u2(r,C[e+140>>1]),u2(r,0),F0(r,i[e+144>>2]),F0(r,i[e+148>>2]),F0(r,i[e+152>>2]),F0(r,i[e+156>>2]),F0(r,i[e+160>>2]),F0(r,i[e+164>>2]),F0(r,i[e+168>>2]),F0(r,i[e+172>>2]),F0(r,i[e+176>>2]),F0(r,i[e+180>>2]),F0(r,i[e+184>>2]),f1(f+12|0,e,r,n),u[f+31|0]<0&&Z(i[f+20>>2]),e=i[26917],i[A>>2]=i[26916],i[A+4>>2]=e,A=A+8|0;i:{if(u[107683]>=0){e=i[26919],i[A>>2]=i[26918],i[A+4>>2]=e,i[A+8>>2]=i[26920];break i}T(A,i[26918],i[26919])}v=f+32|0}function YW(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,t=0;f=v-32|0,v=f,A=i[A>>2],n=i[A+48>>2],k=i[A+52>>2],k&&(i[k+4>>2]=i[k+4>>2]+1),i[f+28>>2]=0,i[f+20>>2]=0,i[f+24>>2]=0,j1(f,n,e,f+20|0);i:{if(i[f>>2]|!r||(e=r-1|0,A=i[f+20>>2],e>>>0>=i[f+24>>2]-A>>3>>>0))break i;if(A=A+(e<<3)|0,e=i[A>>2],A=i[A+4>>2],!A){t=i[e+16>>2];break i}if(r=i[A+4>>2],n=r+1|0,i[A+4>>2]=n,t=i[e+16>>2],i[A+4>>2]=r,n)break i;W[i[i[A>>2]+8>>2]](A),y(A)}if(u[f+19|0]<0&&Z(i[f+8>>2]),e=i[f+20>>2],e){if(A=e,r=i[f+24>>2],(A|0)!=(r|0)){for(;;){A=i[r-4>>2];i:{if(!A||(n=i[A+4>>2],i[A+4>>2]=n-1,n))break i;W[i[i[A>>2]+8>>2]](A),y(A)}if(r=r-8|0,(e|0)==(r|0))break}A=i[f+20>>2]}i[f+24>>2]=e,Z(A)}i:{if(!k||(A=i[k+4>>2],i[k+4>>2]=A-1,A))break i;W[i[i[k>>2]+8>>2]](k),y(k)}return v=f+32|0,t|0}function Sn(A,e,r,f){var k=0,n=0,t=0,o=0,s=0,w=0,h=0,_=0,B=0,m=0,X=0;s=v-32|0,v=s;i:{e:{r:{if((e|0)!=(r|0)){if(h=i[31324],i[31324]=0,t=v-16|0,v=t,a2(),n=v-16|0,v=n,k=v-16|0,v=k,zA(k,e,s+28|0,2),o=i[k>>2],w=i[k+4>>2],e=n,n=i[k+12>>2],i[e+8>>2]=i[k+8>>2],i[e+12>>2]=n,i[e>>2]=o,i[e+4>>2]=w,v=k+16|0,n=i[e>>2],o=i[e+4>>2],k=t,t=i[e+12>>2],i[k+8>>2]=i[e+8>>2],i[k+12>>2]=t,i[k>>2]=n,i[k+4>>2]=o,v=e+16|0,t=i[k>>2],n=i[k+4>>2],o=i[k+12>>2],e=s,i[e+16>>2]=i[k+8>>2],i[e+20>>2]=o,i[e+8>>2]=t,i[e+12>>2]=n,v=k+16|0,k=i[e+16>>2],n=i[e+20>>2],t=i[e+8>>2],o=i[e+12>>2],w=i[31324],!w)break r;if(i[e+28>>2]!=(r|0))break e;if(_=t,B=o,m=k,X=n,(w|0)!=68)break i;break e}i[f>>2]=4;break i}if(i[31324]=h,i[s+28>>2]==(r|0))break i}i[f>>2]=4,t=_,o=B,k=m,n=X}i[A>>2]=t,i[A+4>>2]=o,i[A+8>>2]=k,i[A+12>>2]=n,v=s+32|0}function RW(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,t=0;f=v-32|0,v=f,n=W[i[i[e>>2]+52>>2]](e,r,0)|0,k=i[e+104>>2],t=i[e+108>>2];i:{if(l[e+97|0]==1){e4(r,k,t),e4(r,i[e+112>>2],i[e+116>>2]),F0(r,i[e+120>>2]),e4(r,i[e+128>>2],i[e+132>>2]);break i}F0(r,k),F0(r,i[e+112>>2]),F0(r,i[e+120>>2]),F0(r,i[e+128>>2])}F0(r,i[e+136>>2]),u2(r,C[e+140>>1]),u2(r,0),e4(r,0,0),F0(r,i[e+144>>2]),F0(r,i[e+148>>2]),F0(r,i[e+152>>2]),F0(r,i[e+156>>2]),F0(r,i[e+160>>2]),F0(r,i[e+164>>2]),F0(r,i[e+168>>2]),F0(r,i[e+172>>2]),F0(r,i[e+176>>2]),F0(r,0),F0(r,0),F0(r,0),F0(r,0),F0(r,0),F0(r,0),F0(r,i[e+180>>2]),f1(f+12|0,e,r,n),u[f+31|0]<0&&Z(i[f+20>>2]),e=i[26917],i[A>>2]=i[26916],i[A+4>>2]=e,A=A+8|0;i:{if(u[107683]>=0){e=i[26919],i[A>>2]=i[26918],i[A+4>>2]=e,i[A+8>>2]=i[26920];break i}T(A,i[26918],i[26919])}v=f+32|0}function jn(A,e,r){var f=0,k=0;i:{e:{if(!r){if(i[A+8>>2]=0,i[A>>2]=0,i[A+4>>2]=0,r=i[e+252>>2],e=i[e+248>>2],(r|0)==(e|0))break e;if(k=r-e|0,(k|0)<0)break i;for(f=p(k),i[A+4>>2]=f,i[A>>2]=f,i[A+8>>2]=f+k;i[f>>2]=i[e>>2],k=i[e+4>>2],i[f+4>>2]=k,k&&(i[k+4>>2]=i[k+4>>2]+1),f=f+8|0,e=e+8|0,(r|0)!=(e|0););i[A+4>>2]=f;return}if(i[A+8>>2]=0,i[A>>2]=0,i[A+4>>2]=0,f=i[e+248>>2],e=i[e+252>>2],(f|0)==(e|0))break e;if(k=r&4,!(r&2)){if(!k){for(;;)if(r2(A,f),f=f+8|0,(e|0)==(f|0))break e}for(;l[i[f>>2]+156|0]||r2(A,f),f=f+8|0,(e|0)!=(f|0););break e}if(!k){for(;;)if(l[i[f>>2]+144|0]||r2(A,f),f=f+8|0,(e|0)==(f|0))break e}for(;r=i[f>>2],l[r+144|0]|l[r+156|0]||r2(A,f),f=f+8|0,(e|0)!=(f|0););}return}G0(),H()}function On(A,e){var r=0,f=0;if(!(C[e+6>>1]!=2|C[e+8>>1]!=2|(!l[e+12|0]|C[e+10>>1]!=2))){i[A>>2]=0,i[A+4>>2]=0;return}r=p(128),i[r+4>>2]=0,i[r+8>>2]=0,i[r>>2]=91164,f=r+16|0,i[f+8>>2]=0,i[f+12>>2]=0,i[f+16>>2]=0,i[f+20>>2]=0,i[f+24>>2]=0,i[f+28>>2]=0,i[f+32>>2]=0,i[f>>2]=86356,i[r+60>>2]=0,i[r+64>>2]=0,i[r+52>>2]=0,i[r+56>>2]=0,i[r+72>>2]=-1,i[r+76>>2]=-1,i[r+80>>2]=-1,i[r+84>>2]=-1,i[r+88>>2]=0,i[r+92>>2]=0,i[r+96>>2]=0,i[r+100>>2]=0,i[r+104>>2]=0,i[r+108>>2]=0,u[r+112|0]=0,i[f>>2]=95408,i[r+32>>2]=1668246642,i[r+116>>2]=0,i[r+120>>2]=0,i[A+4>>2]=r,i[A>>2]=f,f=C[e+10>>1]|C[e+12>>1]<<16,A=C[e+6>>1]|C[e+8>>1]<<16,e=p(24),i[e+16>>2]=A,i[e+20>>2]=f,i[e+12>>2]=95368,i[e>>2]=95288,i[e+4>>2]=1,i[e+8>>2]=0,i[r+120>>2]=e,i[r+116>>2]=e+12,A=i[e+4>>2],i[e+4>>2]=A-1,A||(W[i[i[e>>2]+8>>2]](e),y(e))}function Pn(A,e){var r=0,f=0;if(!i[e+16>>2]){i[A>>2]=0,i[A+4>>2]=0;return}if(r=p(128),i[r+4>>2]=0,i[r+8>>2]=0,i[r>>2]=91164,f=r+16|0,i[f+8>>2]=0,i[f+12>>2]=0,i[f+16>>2]=0,i[f+20>>2]=0,i[f+24>>2]=0,i[f+28>>2]=0,i[f+32>>2]=0,i[f>>2]=86356,i[r+60>>2]=0,i[r+64>>2]=0,i[r+52>>2]=0,i[r+56>>2]=0,i[r+72>>2]=-1,i[r+76>>2]=-1,i[r+80>>2]=-1,i[r+84>>2]=-1,i[r+88>>2]=0,i[r+92>>2]=0,i[r+96>>2]=0,i[r+100>>2]=0,i[r+104>>2]=0,i[r+108>>2]=0,u[r+112|0]=0,i[f>>2]=95408,i[r+32>>2]=1668246642,i[r+116>>2]=0,i[r+120>>2]=0,i[A+4>>2]=r,i[A>>2]=f,A=i[e+16>>2],f=i[e+20>>2],f){i[f+4>>2]=i[f+4>>2]+2,i[r+116>>2]=A,e=i[r+120>>2],i[r+120>>2]=f;i:{if(!e||(A=i[e+4>>2],i[e+4>>2]=A-1,A))break i;W[i[i[e>>2]+8>>2]](e),y(e)}A=i[f+4>>2],i[f+4>>2]=A-1,A||(W[i[i[f>>2]+8>>2]](f),y(f));return}i[r+120>>2]=f,i[r+116>>2]=A}function Ln(A,e,r,f,k){var n=0,t=0,o=0,s=0,w=0,h=0;o=v-32|0,v=o,t=p(172),i[t+4>>2]=0,i[t+8>>2]=0,i[t>>2]=94424,w=e,h=Zr(t+12|0),i[w+48>>2]=h,n=i[e+52>>2],i[e+52>>2]=t;i:{if(!n||(t=i[n+4>>2],i[n+4>>2]=t-1,t))break i;W[i[i[n>>2]+8>>2]](n),y(n)}s=i[e+48>>2],i[s+156>>2]=e- -64,t=v-16|0,v=t,n=p(72),i[n+4>>2]=0,i[n+8>>2]=0,i[n>>2]=95024,r=dr(n+16|0,r,f,k),i[t+12>>2]=n,i[t+8>>2]=r,i[n+4>>2]=i[n+4>>2]+1,wf(o+8|0,s,t+8|0),r=i[t+12>>2];i:{if(!r||(f=i[r+4>>2],i[r+4>>2]=f-1,f))break i;W[i[i[r>>2]+8>>2]](r),y(r)}r=i[n+4>>2],i[n+4>>2]=r-1,r||(W[i[i[n>>2]+8>>2]](n),y(n)),v=t+16|0;i:{if(i[o+8>>2]){e=i[o+12>>2],i[A>>2]=i[o+8>>2],i[A+4>>2]=e,e=i[o+20>>2],i[A+8>>2]=i[o+16>>2],i[A+12>>2]=e,i[A+16>>2]=i[o+24>>2];break i}if(sf(A,e),u[o+27|0]>=0)break i;Z(i[o+16>>2])}v=o+32|0}function JW(A,e){A=A|0,e=e|0;var r=0,f=0,k=0,n=0;r=v-16|0,v=r;i:{if((e|0)<12||(e=l[A+8|0],!e)||(k=l[A+9|0],!k)||(n=l[A+10|0],!n)||(A=l[A+11|0],!A))break i;if(u[r+15|0]=0,u[r+14|0]=A,u[r+13|0]=n,u[r+12|0]=k,u[r+11|0]=e,!N2(r+11|0,18060,5)){f=1;break i}if(!N2(r+11|0,2941,5)){f=2;break i}if(!N2(r+11|0,17915,5)){f=3;break i}if(!N2(r+11|0,1769,5)){f=4;break i}if(f=5,A=r+11|0,!N2(A,9370,5))break i;if(!N2(A,5134,5)){f=6;break i}if(!N2(r+11|0,9344,5)){f=7;break i}if(!N2(r+11|0,4391,5)){f=8;break i}if(!N2(r+11|0,21705,5)){f=9;break i}if(!N2(r+11|0,21700,5)){f=10;break i}if(!N2(r+11|0,11348,5)){f=11;break i}if(!N2(r+11|0,5129,5)){f=12;break i}if(!N2(r+11|0,18049,5)){f=13;break i}if(!N2(r+11|0,10557,5)){f=17;break i}f=N2(r+11|0,5145,5)?0:18}return v=r+16|0,f|0}function Kn(A){var e=0,r=0,f=0,k=0,n=0,t=0,o=0,s=0,w=0,h=0,_=0,B=0;i:{e:{if(s=i[A+24>>2],r=i[A+20>>2],(s|0)!=(r|0)){if(k=s-r|0,e=k>>2,e>>>0<2)break i;if(f=1,t=e-1|0,_=t&1,e=i[i[r>>2]+96>>2],(k|0)==8){t=0;break e}for(B=t&-2,t=0,k=0;n=i[i[r+(f<<2)>>2]+96>>2],o=(n|0)<(e|0),w=f+1|0,h=i[i[r+(w<<2)>>2]+96>>2],e=o?n:e,n=(h|0)<(e|0),e=n?h:e,t=n?w:o?f:t,f=f+2|0,k=k+2|0,(B|0)!=(k|0););break e}D0(26837,18325,147,7227),H()}if(!_)break i;t=i[i[r+(f<<2)>>2]+96>>2]<(e|0)?f:t}k=r,o=i[A+52>>2],e=o+i[A+48>>2]|0,n=i[A+40>>2],f=i[A+36>>2],(e|0)==(((f|0)!=(n|0)?(n-f<<8)-1|0:0)|0)&&(or(A+32|0),o=i[A+52>>2],e=o+i[A+48>>2]|0,s=i[A+24>>2],f=i[A+36>>2],k=i[A+20>>2]),n=r,r=t<<2,i[i[(e>>>8&16777212)+f>>2]+((e&1023)<<2)>>2]=i[n+r>>2],i[A+52>>2]=o+1,k=r+k|0,r=s-4|0,i[k>>2]=i[r>>2],i[A+24>>2]=r}function NW(A,e,r,f,k,n,t){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,t=t|0;var o=0,s=0,w=0,h=0,_=0,B=0;if(!((n|0)<=0|(k|0)<=0)){for(h=r-3|0;;){for(s=(w<<1)+t|0,r=h+G(f,w)|0,o=0;g[s>>1]=(((((l[r+1|0]<<2)-l[r|0]|0)+G(l[r+4|0]+l[r+3|0]|0,40)|0)+(l[r+6|0]<<2)|0)-l[r+7|0]|0)+G(l[r+5|0]+l[r+2|0]|0,-11),r=r+1|0,s=(n<<1)+s|0,o=o+1|0,(o|0)!=(k|0););if(w=w+1|0,(w|0)==(n|0))break}for(_=n&2147483644,h=n&3,f=0,B=n>>>0<4;;){if(s=(f<<1)+A|0,r=(G(f,n)<<1)+t|0,w=0,!B)for(;g[s>>1]=C[r>>1],o=s,s=e<<1,o=o+s|0,g[o>>1]=C[r+2>>1],o=s+o|0,g[o>>1]=C[r+4>>1],o=s+o|0,g[o>>1]=C[r+6>>1],s=s+o|0,r=r+8|0,w=w+4|0,(_|0)!=(w|0););if(o=0,h)for(;g[s>>1]=C[r>>1],r=r+2|0,s=(e<<1)+s|0,o=o+1|0,(h|0)!=(o|0););if(f=f+1|0,(k|0)==(f|0))break}}}function UW(A,e,r,f,k,n,t){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,t=t|0;var o=0,s=0,w=0,h=0,_=0,B=0;if(!((n|0)<=0|(k|0)<=0)){for(h=r-3|0;;){for(s=(w<<1)+t|0,r=h+G(f,w)|0,o=0;g[s>>1]=l[r+6|0]+((((((l[r+1|0]<<2)-l[r|0]|0)+G(l[r+2|0],-10)|0)+G(l[r+3|0],58)|0)+G(l[r+4|0],17)|0)+G(l[r+5|0],-5)|0),r=r+1|0,s=(n<<1)+s|0,o=o+1|0,(o|0)!=(k|0););if(w=w+1|0,(w|0)==(n|0))break}for(_=n&2147483644,h=n&3,f=0,B=n>>>0<4;;){if(s=(f<<1)+A|0,r=(G(f,n)<<1)+t|0,w=0,!B)for(;g[s>>1]=C[r>>1],o=s,s=e<<1,o=o+s|0,g[o>>1]=C[r+2>>1],o=s+o|0,g[o>>1]=C[r+4>>1],o=s+o|0,g[o>>1]=C[r+6>>1],s=s+o|0,r=r+8|0,w=w+4|0,(_|0)!=(w|0););if(o=0,h)for(;g[s>>1]=C[r>>1],r=r+2|0,s=(e<<1)+s|0,o=o+1|0,(h|0)!=(o|0););if(f=f+1|0,(k|0)==(f|0))break}}}function DW(A,e,r,f,k,n,t){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,t=t|0;var o=0,s=0,w=0,h=0,_=0,B=0;if(!((n|0)<=0|(k|0)<=0)){for(h=r-2|0;;){for(s=(w<<1)+t|0,r=h+G(f,w)|0,o=0;g[s>>1]=(((((l[r|0]+G(l[r+1|0],-5)|0)+G(l[r+2|0],17)|0)+G(l[r+3|0],58)|0)+G(l[r+4|0],-10)|0)+(l[r+5|0]<<2)|0)-l[r+6|0],r=r+1|0,s=(n<<1)+s|0,o=o+1|0,(o|0)!=(k|0););if(w=w+1|0,(w|0)==(n|0))break}for(_=n&2147483644,h=n&3,f=0,B=n>>>0<4;;){if(s=(f<<1)+A|0,r=(G(f,n)<<1)+t|0,w=0,!B)for(;g[s>>1]=C[r>>1],o=s,s=e<<1,o=o+s|0,g[o>>1]=C[r+2>>1],o=s+o|0,g[o>>1]=C[r+4>>1],o=s+o|0,g[o>>1]=C[r+6>>1],s=s+o|0,r=r+8|0,w=w+4|0,(_|0)!=(w|0););if(o=0,h)for(;g[s>>1]=C[r>>1],r=r+2|0,s=(e<<1)+s|0,o=o+1|0,(h|0)!=(o|0););if(f=f+1|0,(k|0)==(f|0))break}}}function qn(A,e){var r=0,f=0,k=0,n=0,t=0,o=0;o=i[e+12>>2],i[e+12>>2]=i[A+116>>2],l2(e,l[A+122|0]|l[A+121|0]<<4&240),l2(e,l[A+124|0]|l[A+123|0]<<4&240),r=i[A+108>>2]-i[A+104>>2]|0;i:{if(l[A+97|0]<=1){u2(e,r>>>5&65535);break i}F0(e,r>>5)}if(r=i[A+104>>2],k=i[A+108>>2],(r|0)!=(k|0))for(;;){f=i[r>>2];i:{if(l[A+97|0]<=1){u2(e,f&65535);break i}F0(e,f)}if(l[A+97|0]&&u2(e,l[r+4|0]),u2(e,C[r+6>>1]),f=l[A+123|0],f&&Z1(e,f,i[r+8>>2],i[r+12>>2]),u2(e,(i[r+20>>2]-i[r+16>>2]|0)/40&65535),f=i[r+16>>2],n=i[r+20>>2],(f|0)!=(n|0))for(;;){i:{if(!l[A+97|0]||(t=l[A+124|0],!t))break i;Z1(e,t,i[f>>2],i[f+4>>2])}if(Z1(e,l[A+121|0],i[f+8>>2],i[f+12>>2]),Z1(e,l[A+122|0],i[f+16>>2],i[f+20>>2]),f=f+40|0,(n|0)==(f|0))break}if(r=r+32|0,(k|0)==(r|0))break}i[e+12>>2]=o}function MW(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,t=0,o=0,s=0,w=0;n=v-32|0,v=n,f=i[A+28>>2],i[n+16>>2]=f,t=i[A+20>>2],i[n+28>>2]=r,i[n+24>>2]=e,e=t-f|0,i[n+20>>2]=e,t=e+r|0,s=2;i:{e:{e=n+16|0,f=of(i[A+60>>2],e|0,2,n+12|0)|0,f?(i[31324]=f,f=-1):f=0;r:{f:{if(f){f=e;break f}for(;;){if(k=i[n+12>>2],(k|0)==(t|0))break r;if((k|0)<0){f=e;break e}if(o=i[e+4>>2],w=o>>>0<k>>>0,f=(w?8:0)+e|0,o=k-(w?o:0)|0,i[f>>2]=o+i[f>>2],e=(w?12:4)+e|0,i[e>>2]=i[e>>2]-o,t=t-k|0,e=f,s=s-w|0,k=of(i[A+60>>2],e|0,s|0,n+12|0)|0,k?(i[31324]=k,k=-1):k=0,!!k)break}}if((t|0)!=-1)break e}e=i[A+44>>2],i[A+28>>2]=e,i[A+20>>2]=e,i[A+16>>2]=e+i[A+48>>2],A=r;break i}if(i[A+28>>2]=0,i[A+16>>2]=0,i[A+20>>2]=0,i[A>>2]=i[A>>2]|32,A=0,(s|0)==2)break i;A=r-i[f+4>>2]|0}return v=n+32|0,A|0}function S8(A,e,r){var f=0,k=0,n=0,t=0,o=0,s=0;i:{e:{f=i[A+4>>2],k=i[A+8>>2];r:{if(f>>>0<k>>>0){n=i[e+8>>2],t=i[e+12>>2],s=i[r>>2],o=i[e>>2],k=i[e+4>>2],r=i[e+20>>2],i[f+16>>2]=i[e+16>>2],i[f+20>>2]=r,i[f+8>>2]=n,i[f+12>>2]=t,i[f>>2]=o,i[f+4>>2]=k,i[f+24>>2]=s,e=f+28|0;break r}if(n=i[A>>2],t=f-n|0,o=((t|0)/28|0)+1|0,o>>>0>=153391690)break e;if(k=(k-n|0)/28|0,f=k<<1,s=k>>>0>=76695844?153391689:f>>>0>o>>>0?f:o,s){if(s>>>0>=153391690)break i;f=p(G(s,28))}else f=0;if(o=i[r>>2],r=f,k=f+t|0,f=i[e+4>>2],i[k>>2]=i[e>>2],i[k+4>>2]=f,f=i[e+20>>2],i[k+16>>2]=i[e+16>>2],i[k+20>>2]=f,f=i[e+12>>2],i[k+8>>2]=i[e+8>>2],i[k+12>>2]=f,i[k+24>>2]=o,f=k+G((t|0)/-28|0,28)|0,t&&x(f,n,t),i[A+8>>2]=r+G(s,28),e=k+28|0,i[A+4>>2]=e,i[A>>2]=f,!n)break r;Z(n)}i[A+4>>2]=e;return}G0(),H()}z0(),H()}function HW(A,e,r,f,k,n){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0;var t=0;i:{if(!(i[r>>2]!=1|i[r+4>>2]!=3)&&(t=i[r+12>>2],(t|0)>8))break i;i[A+8>>2]=0,i[A>>2]=0,i[A+4>>2]=0;return}e=0,i[A+8>>2]=0,i[A>>2]=0,i[A+4>>2]=0,f=0,l[r+8|0]||(e=p(28),i[e+24>>2]=11,u[e+22|0]=1,g[e+20>>1]=2,i[e+16>>2]=131074,i[e+12>>2]=t,u[e+8|0]=0,i[e>>2]=1,i[e+4>>2]=12,f=e+28|0,i[A+8>>2]=f,i[A>>2]=e,i[A+4>>2]=f);i:{if(r=f-e|0,f=(r|0)/28|0,k=f+1|0,k>>>0<153391690){if(n=f<<1,n=f>>>0>=76695844?153391689:k>>>0<n>>>0?n:k,n){if(n>>>0>=153391690)break i;f=p(G(n,28))}else f=0;k=f+r|0,i[k+24>>2]=11,u[k+22|0]=1,g[k+20>>1]=2,i[k+16>>2]=131074,i[k+12>>2]=t,u[k+8|0]=1,i[k>>2]=1,i[k+4>>2]=13,t=k+G((r|0)/-28|0,28)|0,r&&x(t,e,r),i[A+8>>2]=f+G(n,28),i[A>>2]=t,e&&Z(e),i[A+4>>2]=k+28;return}G0(),H()}z0(),H()}function j2(A){var e=0,r=0,f=0,k=0,n=0,t=0,o=0,s=0,w=0;e=i[A+112>>2],f=i[A+116>>2],s=(e|f)!=0,o=e,k=i[A+4>>2],n=i[A+44>>2],e=k-n|0,t=e,r=e+i[A+120>>2]|0,e=i[A+124>>2]+(e>>31)|0;i:{if(e=r>>>0<t>>>0?e+1|0:e,!(((e|0)>=(f|0)&r>>>0>=o>>>0|(e|0)>(f|0))&s)){if(s=u3(A),(s|0)>=0)break i;k=i[A+4>>2],n=i[A+44>>2]}return i[A+112>>2]=-1,i[A+116>>2]=-1,i[A+104>>2]=k,t=r,r=n-k|0,f=t+r|0,e=(r>>31)+e|0,i[A+120>>2]=f,i[A+124>>2]=r>>>0>f>>>0?e+1|0:e,-1}f=r+1|0,e=f?e:e+1|0,o=i[A+4>>2],n=i[A+8>>2],r=i[A+116>>2],t=r,k=i[A+112>>2];i:{if(!(r|k)||(r=k-f|0,k=t-(e+(f>>>0>k>>>0)|0)|0,w=n-o|0,t=w>>31,(k|0)>=(t|0)&r>>>0>=w>>>0|(k|0)>(t|0)))break i;n=r+o|0}return i[A+104>>2]=n,r=i[A+44>>2],n=r-o|0,f=n+f|0,e=(n>>31)+e|0,i[A+120>>2]=f,i[A+124>>2]=f>>>0<n>>>0?e+1|0:e,r>>>0>=o>>>0&&(u[o-1|0]=s),s}function zW(A,e,r,f,k){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0;var n=0,t=0;n=v-48|0,v=n;i:{e:{if(!(k&&e)){e=i[23570],i[A>>2]=i[23569],i[A+4>>2]=e,i[A+8>>2]=i[23571];break e}Zf(n+20|0,i[e>>2],r,f);r:{f:switch(l[n+40|0]){default:_2(),H();case 1:b0(A,n+20|0,i[e>>2]);break r;case 0:break f}if(e=i[n+20>>2],!e){i[A>>2]=5,i[A+4>>2]=2007,i[A+8>>2]=2304;break r}if(i[n+16>>2]=0,i[n+8>>2]=0,i[n+12>>2]=0,r=i[e+104>>2],f=i[e+100>>2],(r|0)!=(f|0)){if(e=r-f|0,(e|0)<0)break i;r=p(e),t=!e,t||x(r,f,e),t||x(k,r,e),i[A+8>>2]=i[24058],e=i[24057],i[A>>2]=i[24056],i[A+4>>2]=e,Z(r);break r}e=i[24057],i[A>>2]=i[24056],i[A+4>>2]=e,i[A+8>>2]=i[24058]}if(A=l[n+40|0],(A|0)==255)break e;e=i[24181],i[n+8>>2]=i[24180],i[n+12>>2]=e,W[i[(n+8|0)+(A<<2)>>2]](n+47|0,n+20|0)}v=n+48|0;return}G0(),H()}function xW(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,t=0;if(n=v-32|0,v=n,t=W[i[i[e>>2]+52>>2]](e,r,0)|0,F0(r,i[e+104>>2]),F0(r,i[e+112>>2]-i[e+108>>2]>>2),f=i[e+108>>2],k=i[e+112>>2],(f|0)!=(k|0))for(;F0(r,i[f>>2]),f=f+4|0,(k|0)!=(f|0););if(u2(r,C[e+120>>1]),u2(r,C[e+122>>1]),i[e+112>>2]!=i[e+108>>2])for(f=0;k=i[e+124>>2]+G(f,6)|0,u2(r,C[k>>1]),u2(r,C[k+2>>1]),u2(r,C[k+4>>1]),f=f+1|0,f>>>0<i[e+112>>2]-i[e+108>>2]>>2>>>0;);i[r+12>>2]=t,W[i[i[e>>2]+56>>2]](n+12|0,e,r,i[r+4>>2]-(i[r>>2]+t|0)|0,0),i[r+12>>2]=i[r+4>>2]-i[r>>2],u[n+31|0]<0&&Z(i[n+20>>2]),e=i[26917],i[A>>2]=i[26916],i[A+4>>2]=e,A=A+8|0;i:{if(u[107683]>=0){e=i[26919],i[A>>2]=i[26918],i[A+4>>2]=e,i[A+8>>2]=i[26920];break i}T(A,i[26918],i[26919])}v=n+32|0}function an(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0;var k=0,n=0,t=0,o=0,s=0,w=0,h=0,_=0,B=0,m=0;B=e,m=C0(r),i[B+4>>2]=m;i:{if(w=X2(r),!w)break i;e:{for(;;){r:{o=C0(r),f=i[e+12>>2],k=i[e+16>>2];f:{if(f>>>0<k>>>0){i[f>>2]=o,f=f+4|0;break f}if(s=i[e+8>>2],f=f-s|0,h=f>>2,n=h+1|0,n>>>0>=1073741824)break r;if(k=k-s|0,t=k>>1,k=k>>>0>=2147483644?1073741823:n>>>0<t>>>0?t:n,k){if(k>>>0>=1073741824)break e;n=p(k<<2)}else n=0;if(t=n+f|0,i[t>>2]=o,o=t-(h<<2)|0,f&&x(o,s,f),i[e+16>>2]=n+(k<<2),f=t+4|0,i[e+12>>2]=f,i[e+8>>2]=o,!s)break f;Z(s)}if(i[e+12>>2]=f,_=_+1|0,(_&255)>>>0<w>>>0)continue;break i}break}G0(),H()}z0(),H()}if(e=i[26917],i[A>>2]=i[26916],i[A+4>>2]=e,A=A+8|0,u[107683]>=0){e=i[26919],i[A>>2]=i[26918],i[A+4>>2]=e,i[A+8>>2]=i[26920];return}T(A,i[26918],i[26919])}function TW(A){A=A|0;var e=0,r=0,f=0,k=0;e=i[A+92>>2];i:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break i;W[i[i[e>>2]+8>>2]](e),y(e)}e=i[A+84>>2];i:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break i;W[i[i[e>>2]+8>>2]](e),y(e)}e=i[A+64>>2];i:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break i;W[i[i[e>>2]+8>>2]](e),y(e)}e=i[A+56>>2];i:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break i;W[i[i[e>>2]+8>>2]](e),y(e)}e=i[A+48>>2];i:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break i;W[i[i[e>>2]+8>>2]](e),y(e)}if(e=i[A+32>>2],e){if(r=e,f=i[A+36>>2],(e|0)!=(f|0)){for(;;){r=i[f-4>>2];i:{if(!r||(k=i[r+4>>2],i[r+4>>2]=k-1,k))break i;W[i[i[r>>2]+8>>2]](r),y(r)}if(f=f-8|0,(e|0)==(f|0))break}r=i[A+32>>2]}i[A+36>>2]=e,Z(r)}}function Ai(A,e,r,f,k,n,t,o,s,w){var h=0,_=0,B=0;h=v-16|0,v=h,u[h+15|0]=A;i:{e:{r:{if(_=i[f>>2],(_|0)!=(r|0))break r;if(B=A&255,(B|0)==l[w+24|0])A=43;else{if(l[w+25|0]!=(B|0))break r;A=45}i[f>>2]=_+1,u[_|0]=A;break e}if(l[t+11|0]>>>7|0?t=i[t+4>>2]:t=l[t+11|0]&127,!(!t|(A|0)!=(n|0))){if(A=0,e=i[s>>2],(e-o|0)>159)break i;A=i[k>>2],i[s>>2]=e+4,i[e>>2]=A;break e}if(A=-1,n=B5(w,w+26|0,h+15|0)-w|0,(n|0)>23)break i;r:{f:switch(e-8|0){case 0:case 2:if((e|0)>(n|0))break r;break i;case 1:break r;default:break f}if((e|0)!=16|(n|0)<22)break r;if(e=i[f>>2],(e|0)==(r|0)|(e-r|0)>2|l[e-1|0]!=48)break i;A=0,i[k>>2]=0,i[f>>2]=e+1,u[e|0]=l[n+77744|0];break i}A=i[f>>2],i[f>>2]=A+1,u[A|0]=l[n+77744|0],i[k>>2]=i[k>>2]+1,A=0;break i}A=0,i[k>>2]=0}return v=h+16|0,A}function re(A,e,r,f){var k=0,n=0,t=0,o=0,s=0;n=v-48|0,v=n;i:{e:{if(k=i[A+20>>2],!k){k=0;break e}for(t=A+20|0,o=t;s=u0[k+16>>2]<e>>>0,o=s?o:k,k=i[(s?4:0)+k>>2],!!k;);if(k=0,(t|0)==(o|0)|u0[o+16>>2]>e>>>0||(t=i[o+20>>2],W[i[i[t>>2]+52>>2]](n+28|0,t),t=i[n+28>>2],u[n+47|0]<0&&Z(i[n+36>>2]),t)||(t=i[o+20>>2],k=i[o+24>>2],k&&(i[k+4>>2]=i[k+4>>2]+1),!t))break e;i[n+20>>2]=i[r>>2],A=i[r+4>>2],i[n+24>>2]=A,A&&(i[A+4>>2]=i[A+4>>2]+1),A=i[n+24>>2],i[n+8>>2]=i[n+20>>2],i[n+12>>2]=A,A=M4(t,n+8|0,f);break i}A=f3(i[A+48>>2],e,r,f)}i:{if(!k||(e=i[k+4>>2],i[k+4>>2]=e-1,e))break i;W[i[i[k>>2]+8>>2]](k),y(k)}e=i[r+4>>2];i:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break i;W[i[i[e>>2]+8>>2]](e),y(e)}return v=n+48|0,A}function $n(A,e){var r=0,f=0,k=0,n=0,t=0;k=v-16|0,v=k,t=i[31366],i[e+72>>2]<=0&&h5(e),i[31366]=i[e+136>>2];i:{e:{r:{if(A>>>0<=127){f:{if(i[e+80>>2]==(A|0)||(r=i[e+20>>2],(r|0)==i[e+16>>2]))break f;i[e+20>>2]=r+1,u[r|0]=A;break i}f=v-16|0,v=f,u[f+15|0]=A,r=i[e+16>>2];f:{if(!r){if(dA(e)){r=-1;break f}r=i[e+16>>2]}A:{if(n=i[e+20>>2],(r|0)==(n|0)||(r=A&255,(r|0)==i[e+80>>2]))break A;i[e+20>>2]=n+1,u[n|0]=A;break f}if((W[i[e+36>>2]](e,f+15|0,1)|0)!=1){r=-1;break f}r=l[f+15|0]}v=f+16|0,A=r;break r}if(r=i[e+20>>2],u0[e+16>>2]>r+4>>>0){if(r=p3(r,A),(r|0)<0)break e;i[e+20>>2]=r+i[e+20>>2];break r}if(f=k+12|0,r=p3(f,A),(r|0)<0||Lr(f,r,e)>>>0<r>>>0)break e}if((A|0)!=-1)break i}i[e>>2]=i[e>>2]|32,A=-1}return i[31366]=t,v=k+16|0,A}function iA(){var A=0,e=0,r=0,f=0,k=0;A=i[26703],A&&W[A|0](),e=i[26927];i:{e:{if(!e){r=107708,A=107708;break e}for(;;){if(A=e,e=i[A+16>>2],e>>>0>106804){if(r=A,e=i[A>>2],e)continue;break e}if(e>>>0>=106804)break i;if(e=i[A+4>>2],!e)break}r=A+4|0}e=p(20),i[e+8>>2]=A,i[e>>2]=0,i[e+4>>2]=0,i[e+16>>2]=106804,i[r>>2]=e,A=i[i[26926]>>2],A&&(i[26926]=A),m1(i[26927],e),i[26928]=i[26928]+1}A=i[26729],A&&W[A|0](),A=p(4),i[A>>2]=106888,f=p(20),i[f+16>>2]=A,e=i[26930];i:{if(!e){A=107720,r=107720;break i}for(k=i[26725];;){if(A=e,i[i[i[A+16>>2]>>2]+12>>2]<(k|0)){if(r=A,e=i[A>>2],e)continue;break i}if(e=i[A+4>>2],!e)break}r=A+4|0}i[f+8>>2]=A,i[f>>2]=0,i[f+4>>2]=0,i[r>>2]=f,A=i[i[26929]>>2],A&&(i[26929]=A),m1(i[26930],f),i[26931]=i[26931]+1}function SW(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0;var k=0,n=0,t=0,o=0,s=0;f=v-32|0,v=f,z2(f,e,r),u[f+19|0]<0&&Z(i[f+8>>2]);i:{if(l[e+97|0]){t1(A,e,9216);break i}k=i[e+100>>2]>>>8|0,i[e+152>>2]=k&31,t=1,n=+(1<<k>>>0),o=e,s=+(C0(r)|0)/n,t0[o+104>>3]=s,o=e,s=+(C0(r)|0)/n,t0[o+112>>3]=s,o=e,s=+(C0(r)|0)/n,t0[o+120>>3]=s,k=i[e+100>>2];e:{if(k&1){k=k>>>16|0,i[e+156>>2]=k&31,o=e,s=+(C0(r)|0)/n,t0[o+136>>3]=s,n=+(C0(r)|0)/+(1<<k>>>0);break e}i[e+136>>2]=0,i[e+140>>2]=0,t=0,n=0}if(t0[e+144>>3]=n,u[e+128|0]=t,l[r+20|0]==1){if(u[f+20|0]=0,u[f+31|0]=0,q(A,2,100,f+20|0),u[f+31|0]>=0)break i;Z(i[f+20>>2]);break i}if(e=i[26917],i[A>>2]=i[26916],i[A+4>>2]=e,A=A+8|0,u[107683]>=0){e=i[26919],i[A>>2]=i[26918],i[A+4>>2]=e,i[A+8>>2]=i[26920];break i}T(A,i[26918],i[26919])}v=f+32|0}function ki(A,e,r,f,k,n,t,o,s,w){var h=0,_=0;h=v-16|0,v=h,i[h+12>>2]=A;i:{e:{r:{if(_=i[f>>2],(_|0)!=(r|0))break r;if(i[w+96>>2]==(A|0))A=43;else{if(i[w+100>>2]!=(A|0))break r;A=45}i[f>>2]=_+1,u[_|0]=A;break e}if(l[t+11|0]>>>7|0?t=i[t+4>>2]:t=l[t+11|0]&127,!(!t|(A|0)!=(n|0))){if(A=0,e=i[s>>2],(e-o|0)>159)break i;A=i[k>>2],i[s>>2]=e+4,i[e>>2]=A;break e}if(A=-1,n=_5(w,w+104|0,h+12|0)-w>>2,(n|0)>23)break i;r:{f:switch(e-8|0){case 0:case 2:if((e|0)>(n|0))break r;break i;case 1:break r;default:break f}if((e|0)!=16|(n|0)<22)break r;if(e=i[f>>2],(e|0)==(r|0)|(e-r|0)>2|l[e-1|0]!=48)break i;A=0,i[k>>2]=0,i[f>>2]=e+1,u[e|0]=l[n+77744|0];break i}A=i[f>>2],i[f>>2]=A+1,u[A|0]=l[n+77744|0],i[k>>2]=i[k>>2]+1,A=0;break i}A=0,i[k>>2]=0}return v=h+16|0,A}function Rr(A,e,r){var f=0,k=0,n=0,t=0,o=0,s=0,w=0,h=0,_=0;Je(),i[A+8>>2]=0,i[A>>2]=0,i[A+4>>2]=0;i:{e:{if(t=i[26929],(t|0)!=107720)for(;;){w=i[t+16>>2],f=i[w>>2];r:{if(i[f+4>>2]!=(e|0)&&e||r&&n4(r,i[f+8>>2]))break r;f:{if(k>>>0<n>>>0){i[k>>2]=w,k=k+4|0;break f}if(f=k-s|0,_=f>>2,o=_+1|0,o>>>0>=1073741824)break e;if(k=n-s|0,n=k>>1,n=k>>>0>=2147483644?1073741823:n>>>0>o>>>0?n:o,n){if(n>>>0>=1073741824)break i;k=p(n<<2)}else k=0;h=k+f|0,i[h>>2]=w,o=h-(_<<2)|0,f&&x(o,s,f),n=k+(n<<2)|0,i[A+8>>2]=n,k=h+4|0,i[A+4>>2]=k,i[A>>2]=o,s&&Z(s),s=o}i[A+4>>2]=k}f=i[t+4>>2];r:{if(f){for(;;)if(t=f,f=i[f>>2],!f)break r}for(;f=t,t=i[t+8>>2],(f|0)!=i[t>>2];);}if((t|0)==107720)break}return}G0(),H()}z0(),H()}function jW(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0;var k=0,n=0,t=0,o=0;f=v-16|0,v=f,t=i[r+16>>2],f4(r,t),k=f+4|0,i[k+8>>2]=0,i[k>>2]=0,i[k+4>>2]=0,t&&$u(k,t),o=i[r>>2],n=i[r+4>>2];i:{if(n){if(i[n+4>>2]=i[n+4>>2]+1,W[i[i[o>>2]+16>>2]](o,u[k+11|0]<0?i[k>>2]:k,t)|0,k=i[n+4>>2],i[n+4>>2]=k-1,k)break i;W[i[i[n>>2]+8>>2]](n),y(n);break i}W[i[i[o>>2]+16>>2]](o,u[k+11|0]<0?i[k>>2]:k,t)|0}u[e+111|0]<0&&Z(i[e+100>>2]),k=i[f+8>>2],i[e+100>>2]=i[f+4>>2],i[e+104>>2]=k,i[e+108>>2]=i[f+12>>2];i:{if(l[r+20|0]==1){if(u[f+4|0]=0,u[f+15|0]=0,q(A,2,100,f+4|0),u[f+15|0]>=0)break i;Z(i[f+4>>2]);break i}if(e=i[26917],i[A>>2]=i[26916],i[A+4>>2]=e,A=A+8|0,u[107683]>=0){e=i[26919],i[A>>2]=i[26918],i[A+4>>2]=e,i[A+8>>2]=i[26920];break i}T(A,i[26918],i[26919])}v=f+16|0}function OW(A,e,r,f,k,n){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0;var t=0,o=0,s=0;t=v-48|0,v=t;i:{if(!(n|!k)){i[A>>2]=5,i[A+4>>2]=2001,i[A+8>>2]=19478;break i}o=i[e>>2],s=i[o+48>>2],o=i[o+52>>2];e:{if(!o){u9(t+12|0,s,r,f);break e}if(i[o+4>>2]=i[o+4>>2]+1,u9(t+12|0,s,r,f),r=i[o+4>>2],i[o+4>>2]=r-1,r)break e;W[i[i[o>>2]+8>>2]](o),y(o)}e:{r:{if(r=l[t+32|0],r){if(i[n>>2]=0,k&&(i[k>>2]=0),(r|0)==1)break r;_2(),H()}n&&(i[n>>2]=i[t+16>>2]-i[t+12>>2]);f:{if(!k||(r=i[t+12>>2],e=i[t+16>>2]-r|0,f=p(e),i[k>>2]=f,!e))break f;x(f,r,e)}e=i[24057],i[A>>2]=i[24056],i[A+4>>2]=e,i[A+8>>2]=i[24058],k=0;break e}if(b0(A,t+12|0,i[e>>2]),k=l[t+32|0],(k|0)==255)break i}A=i[24183],i[t+40>>2]=i[24182],i[t+44>>2]=A,W[i[(t+40|0)+(k<<2)>>2]](t+39|0,t+12|0)}v=t+48|0}function eA(A,e){var r=0,f=0,k=0,n=0,t=0,o=0;o=e+31|0,n=i[A+12>>2]<<7,f=C[A+20>>1],r=i[A+16>>2];i:{for(;;){f=f+1|0,g[A+20>>1]=f,r=r<<1,i[A+16>>2]=r,f=f<<16>>16;e:{if((f|0)<0||(f=65528,g[A+20>>1]=65528,k=i[A+4>>2],k>>>0>=u0[A+8>>2]))break e;i[A+4>>2]=k+1,r=l[k|0]|r,i[A+16>>2]=r}if(r>>>0<n>>>0)break i;if(r=r-n|0,i[A+16>>2]=r,t=(1<<e)+t|0,k=(e|0)==(o|0),e=e+1|0,!!k)break}return 0}if((e|0)<=8){if(!e)return t;f=e+f|0,g[A+20>>1]=f,r=r<<e,i[A+16>>2]=r,f=f<<16>>16;i:{if((f|0)<0||(k=i[A+4>>2],k>>>0>=u0[A+8>>2]))break i;i[A+4>>2]=k+1,k=l[k|0],g[A+20>>1]=f-8,r=k<<f|r}return f=(r>>>0)/(n>>>0)|0,e=1<<e,(f|0)>=(e|0)&&(f=e-1|0),i[A+16>>2]=r-G(f,n),f+t|0}for(r=e-8|0,e=io(A);e=k4(A)|e<<1,r=r-1|0,!!r;);return e+t|0}function PW(A,e){A=A|0,e=e|0;var r=0,f=0,k=0,n=0,t=0;f=v-32|0,v=f,o0(A,0,72),i[A+4>>2]=C[e+450>>1],i[A+8>>2]=C[e+448>>1],i[A+20>>2]=i[e+452>>2],i[A+24>>2]=i[e+456>>2],i[f+28>>2]=0,i[f+20>>2]=0,i[f+24>>2]=0;i:{e:{r:{f:{if(n=i[e+460>>2],r=i[e+464>>2],(n|0)==(r|0))break f;if(r=r-n|0,(r|0)<0)break i;if(k=p(r),i[f+20>>2]=k,t=r+k|0,i[f+28>>2]=t,r&&x(k,n,r),i[f+24>>2]=t,r=i[k>>2],!r)break f;if(r4(f,i[e+100>>2],r,1),e=i[f+4>>2],r=i[f>>2],!r||(W[i[i[r>>2]+52>>2]](f,r),k=i[f>>2],u[f+19|0]<0&&Z(i[f+8>>2]),k))break r;i[A+12>>2]=i[r+120>>2],i[A+16>>2]=i[r+124>>2];break r}i[A+12>>2]=0,i[A+16>>2]=0;break e}if(!e||(A=i[e+4>>2],i[e+4>>2]=A-1,A))break e;W[i[i[e>>2]+8>>2]](e),y(e)}A=i[f+20>>2],A&&Z(A),v=f+32|0;return}G0(),H()}function LW(A,e){A=A|0,e=e|0;var r=0,f=0,k=0,n=0,t=0,o=0,s=0,w=0;k=v-16|0,v=k;i:{if((e|0)!=-1){if(o=i[A+12>>2],s=i[A+8>>2],n=i[A+24>>2],(n|0)==i[A+28>>2]){if(r=-1,!(l[A+48|0]&16))break i;t=i[A+20>>2],w=i[A+44>>2],f=A+32|0,oi(f,0),W2(f,l[f+11|0]>>>7|0?(i[f+8>>2]&2147483647)-1|0:10),l[f+11|0]>>>7|0?r=i[f>>2]:r=f,l[f+11|0]>>>7|0?f=i[f+4>>2]:f=l[f+11|0]&127,i[A+28>>2]=f+r,i[A+20>>2]=r,i[A+24>>2]=r,i[A+24>>2]=i[A+24>>2]+(n-t|0),i[A+44>>2]=i[A+20>>2]+(w-t|0)}i[k+12>>2]=i[A+24>>2]+1,r=v-16|0,v=r,v=r+16|0,f=A+44|0,r=k+12|0,i[A+44>>2]=i[(u0[r>>2]<u0[f>>2]?f:r)>>2],l[A+48|0]&8&&(r=A+32|0,l[r+11|0]>>>7|0&&(r=i[r>>2]),i[A+16>>2]=i[A+44>>2],i[A+12>>2]=r+(o-s|0),i[A+8>>2]=r),r=ll(A,e<<24>>24);break i}r=(e|0)!=-1?e:0}return v=k+16|0,r|0}function KW(A,e,r,f,k,n){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0;var t=0;e=i[r+12>>2],f=i[r+4>>2],k=i[r>>2],i[A+8>>2]=0,i[A>>2]=0,i[A+4>>2]=0;i:{e:{if(!((k|0)!=1|(f|0)!=3|(e|0)!=8)){if(e=0,f=0,l[r+8|0]||(e=p(28),i[e+24>>2]=11,u[e+22|0]=1,g[e+20>>1]=2,i[e+12>>2]=8,i[e+16>>2]=131074,u[e+8|0]=0,i[e>>2]=1,i[e+4>>2]=12,f=e+28|0,i[A+8>>2]=f,i[A>>2]=e,i[A+4>>2]=f),r=f-e|0,f=(r|0)/28|0,k=f+1|0,k>>>0>=153391690)break e;if(n=f<<1,n=f>>>0>=76695844?153391689:k>>>0<n>>>0?n:k,n){if(n>>>0>=153391690)break i;f=p(G(n,28))}else f=0;k=r+f|0,i[k+24>>2]=11,u[k+22|0]=1,g[k+20>>1]=2,i[k+12>>2]=8,i[k+16>>2]=131074,u[k+8|0]=1,i[k>>2]=1,i[k+4>>2]=13,t=k+G((r|0)/-28|0,28)|0,r&&x(t,e,r),i[A+8>>2]=G(n,28)+f,i[A>>2]=t,e&&Z(e),i[A+4>>2]=k+28}return}G0(),H()}z0(),H()}function qW(A,e,r,f,k,n){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0;var t=0,o=0;t=v-32|0,v=t,i[t+24>>2]=k,i[t+28>>2]=f;i:{if(!(n&&e)){e=i[23570],i[A>>2]=i[23569],i[A+4>>2]=e,i[A+8>>2]=i[23571];break i}e:{if(o=i[e>>2],!o||(o=W0(o,100660,101300),!o))break e;e=i[e+4>>2],e&&(i[e+4>>2]=i[e+4>>2]+1);r:{if(!(C[o+450>>1]>f>>>0&C[o+448>>1]>k>>>0)){i[A>>2]=5,i[A+4>>2]=0,i[A+8>>2]=13946;break r}f:{if(!r||(An(t+4|0,o,t+28|0,t+24|0),u[t+23|0]>=0))break f;Z(i[t+12>>2])}i[n>>2]=i[(i[o+460>>2]+(G(i[t+24>>2],C[o+450>>1])<<2)|0)+(i[t+28>>2]<<2)>>2],i[A+8>>2]=i[24165],r=i[24164],i[A>>2]=i[24163],i[A+4>>2]=r}if(!e||(A=i[e+4>>2],i[e+4>>2]=A-1,A))break i;W[i[i[e>>2]+8>>2]](e),y(e);break i}i[A>>2]=5,i[A+4>>2]=0,i[A+8>>2]=14929}v=t+32|0}function aW(A,e,r,f,k,n){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0;var t=0;e=i[r+12>>2],f=i[r+4>>2],k=i[r>>2],i[A+8>>2]=0,i[A>>2]=0,i[A+4>>2]=0;i:{e:{if(!(f|(k|0)!=2|(e|0)!=8)){if(e=0,f=0,l[r+8|0]||(e=p(28),i[e+24>>2]=11,u[e+22|0]=1,g[e+20>>1]=2,i[e+12>>2]=8,i[e+16>>2]=131074,u[e+8|0]=0,i[e>>2]=1,i[e+4>>2]=10,f=e+28|0,i[A+8>>2]=f,i[A>>2]=e,i[A+4>>2]=f),r=f-e|0,f=(r|0)/28|0,k=f+1|0,k>>>0>=153391690)break e;if(n=f<<1,n=f>>>0>=76695844?153391689:k>>>0<n>>>0?n:k,n){if(n>>>0>=153391690)break i;f=p(G(n,28))}else f=0;k=r+f|0,i[k+24>>2]=11,u[k+22|0]=1,g[k+20>>1]=2,i[k+12>>2]=8,i[k+16>>2]=131074,u[k+8|0]=1,i[k>>2]=1,i[k+4>>2]=11,t=k+G((r|0)/-28|0,28)|0,r&&x(t,e,r),i[A+8>>2]=G(n,28)+f,i[A>>2]=t,e&&Z(e),i[A+4>>2]=k+28}return}G0(),H()}z0(),H()}function dn(A){A=A|0;var e=0,r=0,f=0,k=0;if(i[A>>2]=95160,r=i[A+124>>2],k=A+128|0,(r|0)!=(k|0))for(;;){e=i[r+48>>2],e&&Z(e),f=i[r+4>>2];i:{if(f){for(;;)if(e=f,f=i[e>>2],!f)break i}for(;e=i[r+8>>2],f=i[e>>2]!=(r|0),r=e,!!f;);}if(r=e,(k|0)==(e|0))break}if(f=i[A+148>>2],f){if(r=f,e=i[A+152>>2],(r|0)!=(e|0)){for(;u[e-1|0]<0&&Z(i[e-12>>2]),e=e-20|0,(f|0)!=(e|0););r=i[A+148>>2]}i[A+152>>2]=f,Z(r)}D1(A+136|0),V5(A+124|0,i[A+128>>2]),u[A+103|0]<0&&Z(i[A+92>>2]),i[A>>2]=95112,x2(i[A+64>>2]),l[A+80|0]!=1|u[A+79|0]>=0||Z(i[A+68>>2]),r=i[A+20>>2];i:{if(!r||(e=i[r+4>>2],i[r+4>>2]=e-1,e))break i;W[i[i[r>>2]+8>>2]](r),y(r)}return e=i[A+88>>2],e&&y(e),A|0}function rA(A,e){var r=0,f=0,k=0,n=0;r=v-32|0,v=r,k=e+12|0;i:{e:{if(i[e+12>>2]!=i[e+16>>2])break e;if(l[e+8|0]==1){if(gr(r+8|0,i[e>>2],i[e+24>>2],k,0,0,-1,-1),f=i[r+8>>2],f){e=i[r+12>>2],i[A>>2]=i[r+8>>2],i[A+4>>2]=e,e=A+8|0;r:{if(u[r+27|0]>=0){n=i[r+20>>2],i[e>>2]=i[r+16>>2],i[e+4>>2]=n,i[e+8>>2]=i[r+24>>2];break r}T(e,i[r+16>>2],i[r+20>>2])}u[A+20|0]=1}if(u[r+27|0]<0&&Z(i[r+16>>2]),!f)break e;break i}if(yt(r+8|0,i[e>>2],k,i[e+32>>2],i[e+36>>2],i[e+40>>2]),f=i[r+8>>2],f){e=i[r+12>>2],i[A>>2]=i[r+8>>2],i[A+4>>2]=e,e=A+8|0;r:{if(u[r+27|0]>=0){n=i[r+20>>2],i[e>>2]=i[r+16>>2],i[e+4>>2]=n,i[e+8>>2]=i[r+24>>2];break r}T(e,i[r+16>>2],i[r+20>>2])}u[A+20|0]=1}if(u[r+27|0]<0&&Z(i[r+16>>2]),f)break i}u[A+20|0]=0,i[A>>2]=k}v=r+32|0}function cn(A){var e=0;e=p(208),i[e+24>>2]=0,i[e+28>>2]=0,i[e+4>>2]=0,i[e+8>>2]=0,i[e+72>>2]=-1,i[e+76>>2]=-1,i[e+116>>2]=0,i[e+88>>2]=0,i[e+92>>2]=0,g[e+132>>1]=1,i[e+128>>2]=0,i[e+120>>2]=0,i[e+124>>2]=0,i[e>>2]=91564,i[e+32>>2]=0,i[e+36>>2]=0,i[e+40>>2]=0,i[e+44>>2]=0,i[e+48>>2]=0,i[e+52>>2]=0,i[e+56>>2]=0,i[e+60>>2]=0,i[e- -64>>2]=0,i[e+80>>2]=-1,i[e+84>>2]=-1,i[e+96>>2]=0,i[e+100>>2]=0,i[e+104>>2]=0,i[e+108>>2]=0,g[e+112>>1]=0,i[e+16>>2]=89216,i[e+152>>2]=0,i[e+156>>2]=0,i[e+144>>2]=0,i[e+148>>2]=0,i[e+136>>2]=0,i[e+140>>2]=0,i[e+160>>2]=0,i[e+164>>2]=1072693248,i[e+192>>2]=0,i[e+184>>2]=0,i[e+188>>2]=0,i[e+176>>2]=0,i[e+180>>2]=0,i[e+168>>2]=0,i[e+172>>2]=0,u[e+204|0]=0,i[e+200>>2]=0,i[e+32>>2]=1668113784,i[A+4>>2]=e,i[A>>2]=e+16}function fe(A,e,r){var f=0,k=0,n=0,t=0,o=0,s=0,w=0;if((e|0)!=(r|0))for(o=A+4|0;;){k=i[A+4>>2];i:{e:{r:{if(f=o,w=i[A>>2],(f|0)==(w|0))break r;n=f,t=k;f:{if(k){for(;f=t,t=i[f+4>>2],!!t;);if(s=i[e>>2],s>>>0<=u0[f+16>>2])break f;break r}for(;f=i[n+8>>2],t=i[f>>2]==(n|0),n=f,!!t;);if(n=o,t=n,u0[f+16>>2]<u0[e>>2])break r;break e}for(;;){if(t=k,f=i[k+16>>2],f>>>0>s>>>0){if(n=k,k=i[k>>2],k)continue;break e}if(f>>>0>=s>>>0)break i;if(k=i[t+4>>2],!k)break}n=t+4|0;break e}if(n=k?f+4|0:o,i[n>>2])break i;t=k?f:o}f=p(20),k=i[e>>2],i[f+8>>2]=t,i[f>>2]=0,i[f+4>>2]=0,i[f+16>>2]=k,i[n>>2]=f,n=i[w>>2],n&&(i[A>>2]=n),m1(i[A+4>>2],f),i[A+8>>2]=i[A+8>>2]+1}if(e=e+4|0,(r|0)==(e|0))break}}function $W(A,e,r,f,k,n){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0;i:{if(e=i[r+4>>2],!(!l[k+12|0]|((e|0)==3|i[k+8>>2]==1))||i[r>>2]|(e|0)!=1||(k=i[r+12>>2],(k|0)<=8)||(e=C[r+20>>1],!(e>>>0>14|!(1<<e&18689))))break i;f=l[r+8|0],r=p(28),u[r+22|0]=1,g[r+20>>1]=2,i[r+12>>2]=k,i[r+4>>2]=f?15:14,i[r>>2]=1,i[r+24>>2]=11,i[r+16>>2]=131074,u[r+8|0]=f,e=p(56),i[e+52>>2]=11,u[e+50|0]=1,g[e+48>>1]=2,i[e+44>>2]=131074,i[e+40>>2]=k,u[e+36|0]=f,i[e+32>>2]=f?13:12,i[e+28>>2]=1,f=i[r+4>>2],i[e>>2]=i[r>>2],i[e+4>>2]=f,f=i[r+12>>2],i[e+8>>2]=i[r+8>>2],i[e+12>>2]=f,f=i[r+20>>2],i[e+16>>2]=i[r+16>>2],i[e+20>>2]=f,i[e+24>>2]=i[r+24>>2],f=e+56|0,i[A+8>>2]=f,i[A>>2]=e,Z(r),i[A+4>>2]=f;return}i[A+8>>2]=0,i[A>>2]=0,i[A+4>>2]=0}function dW(A,e,r,f,k,n){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0;var t=0;e=v-32|0,v=e,n=i[f+4>>2];i:{if(!(!l[k+12|0]|((n|0)==3|i[k+4>>2]==1))){i[A+8>>2]=0,i[A>>2]=0,i[A+4>>2]=0;break i}e:{if(!(i[r>>2]!=1|(i[r+4>>2]&-4)!=12)&&(k=i[r+12>>2],(k|0)>8))break e;i[A+8>>2]=0,i[A>>2]=0,i[A+4>>2]=0;break i}if(t=C[f+20>>1],!(t>>>0>14|!(1<<t&18689))){i[A+8>>2]=0,i[A>>2]=0,i[A+4>>2]=0;break i}if(!l[f+22|0]){i[A+8>>2]=0,i[A>>2]=0,i[A+4>>2]=0;break i}if(i[A+8>>2]=0,i[A>>2]=0,i[A+4>>2]=0,(n|0)!=1)break i;i[e+8>>2]=0,i[e+12>>2]=1,r=l[r+8|0],i[e+20>>2]=k,u[e+16|0]=r,r=l[f+19|0]|l[f+20|0]<<8|(l[f+21|0]<<16|l[f+22|0]<<24),u[e+27|0]=r,u[e+28|0]=r>>>8,u[e+29|0]=r>>>16,u[e+30|0]=r>>>24,i[e+24>>2]=i[f+16>>2],i[e+4>>2]=11,S8(A,e+8|0,e+4|0)}v=e+32|0}function cW(A,e,r,f,k,n){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0;var t=0,o=0,s=0,w=0;t=v-48|0,v=t;i:{e:{if(o=i[e>>2],s=i[o+108>>2],(s|0)>0&&(w=i[o+112>>2],(w|0)>0))break e;i[A>>2]=5,i[A+4>>2]=129,i[A+8>>2]=11660;break i}Ff(t+12|0,o,r,(f^-1)+s|0,k,(n^-1)+w|0,0);e:{r:switch(l[t+32|0]){default:_2(),H();case 1:r=A,A=i[e>>2],b0(r,t+12|0,A?A+92|0:0);break e;case 0:break r}r=i[t+12>>2],f=i[t+16>>2],f&&(i[f+4>>2]=i[f+4>>2]+1),i[e>>2]=r,r=i[e+4>>2],i[e+4>>2]=f;r:{if(!r||(e=i[r+4>>2],i[r+4>>2]=e-1,e))break r;W[i[i[r>>2]+8>>2]](r),y(r)}e=i[24057],i[A>>2]=i[24056],i[A+4>>2]=e,i[A+8>>2]=i[24058]}if(A=l[t+32|0],(A|0)==255)break i;e=i[24159],i[t+40>>2]=i[24158],i[t+44>>2]=e,W[i[(t+40|0)+(A<<2)>>2]](t+39|0,t+12|0)}v=t+48|0}function bn(A,e,r,f){i:switch(e-9|0){case 0:e=i[r>>2],i[r>>2]=e+4,i[A>>2]=i[e>>2];return;case 6:e=i[r>>2],i[r>>2]=e+4,e=g[e>>1],i[A>>2]=e,i[A+4>>2]=e>>31;return;case 7:e=i[r>>2],i[r>>2]=e+4,i[A>>2]=C[e>>1],i[A+4>>2]=0;return;case 8:e=i[r>>2],i[r>>2]=e+4,e=u[e|0],i[A>>2]=e,i[A+4>>2]=e>>31;return;case 9:e=i[r>>2],i[r>>2]=e+4,i[A>>2]=l[e|0],i[A+4>>2]=0;return;case 16:e=i[r>>2]+7&-8,i[r>>2]=e+8,t0[A>>3]=t0[e>>3];return;case 17:W[f|0](A,r);default:return;case 1:case 4:case 14:e=i[r>>2],i[r>>2]=e+4,e=i[e>>2],i[A>>2]=e,i[A+4>>2]=e>>31;return;case 2:case 5:case 11:case 15:e=i[r>>2],i[r>>2]=e+4,i[A>>2]=i[e>>2],i[A+4>>2]=0;return;case 3:case 10:case 12:case 13:break i}e=i[r>>2]+7&-8,i[r>>2]=e+8,r=i[e+4>>2],i[A>>2]=i[e>>2],i[A+4>>2]=r}function bW(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0;var k=0,n=0,t=0,o=0,s=0,w=0;w=v-32|0,v=w,z2(w+12|0,e,r),u[w+31|0]<0&&Z(i[w+20>>2]);i:{f=i[r+16>>2],k=i[e+108>>2],t=i[e+104>>2],o=k-t|0;e:{if(f>>>0>o>>>0){if(s=f-o|0,n=i[e+112>>2],s>>>0<=n-k>>>0){s&&o0(k,0,s),i[e+108>>2]=k+s;break e}if((f|0)<0)break i;if(k=n-t|0,n=k<<1,n=k>>>0>=1073741823?2147483647:f>>>0<n>>>0?n:f,k=p(n),s&&o0(k+o|0,0,s),o&&x(k,t,o),i[e+112>>2]=k+n,i[e+108>>2]=f+k,i[e+104>>2]=k,!t)break e;Z(t);break e}if(f>>>0>=o>>>0)break e;i[e+108>>2]=f+t}l6(r,i[e+104>>2],f),e=i[26917],i[A>>2]=i[26916],i[A+4>>2]=e,A=A+8|0;e:{if(u[107683]>=0){e=i[26919],i[A>>2]=i[26918],i[A+4>>2]=e,i[A+8>>2]=i[26920];break e}T(A,i[26918],i[26919])}v=w+32|0;return}G0(),H()}function a2(){var A=0,e=0,r=0,f=0,k=0,n=0;if(l[129572])return i[32392];r=v-32|0,v=r;i:{e:{for(;;){if(e=r+8|0,f=ft(A,1<<A&2147483647?20051:42673),i[e+(A<<2)>>2]=f,(f|0)==-1)break e;if(A=A+1|0,(A|0)==6)break}if(A=73128,!N2(e,73128,24)||(A=73152,!N2(e,73152,24)))break i;if(A=0,!l[129220]){for(;k=(A<<2)+129172|0,n=ft(A,42673),i[k>>2]=n,A=A+1|0,(A|0)!=6;);u[129220]=1,i[32299]=i[32293]}if(A=129172,e=r+8|0,!N2(e,129172,24)||(A=129196,!N2(e,129196,24)))break i;if(A=y2(24),!A)break e;e=i[r+12>>2],i[A>>2]=i[r+8>>2],i[A+4>>2]=e,e=i[r+28>>2],i[A+16>>2]=i[r+24>>2],i[A+20>>2]=e,e=i[r+20>>2],i[A+8>>2]=i[r+16>>2],i[A+12>>2]=e;break i}A=0}return v=r+32|0,u[129572]=1,i[32392]=A,A}function Jr(A,e,r,f,k,n,t,o){var s=0,w=0,h=0,_=0;if(w=v-16|0,v=w,(e^-1)+2147483639>>>0>=r>>>0){l[A+11|0]>>>7|0?s=i[A>>2]:s=A,_=s,s=w+4|0,e>>>0<1073741811?(i[w+12>>2]=e<<1,i[w+4>>2]=e+r,r=v-16|0,v=r,v=r+16|0,r=w+12|0,r=i[(u0[s>>2]<u0[r>>2]?r:s)>>2],r>>>0>=11?(h=r+8&-8,r=h-1|0,r=(r|0)==11?h:r):r=10,r=r+1|0):r=2147483639,Ci(s,r),r=i[w+4>>2],k&&(s=!k,s|s||x(r,_,k)),t&&(s=r+k|0,h=!t,h|h||x(s,o,t)),s=k+n|0,o=f-s|0,(f|0)!=(s|0)&&(f=(r+k|0)+t|0,n=(k+_|0)+n|0,s=!o,s|s||x(f,n,o)),(e|0)!=10&&$8(_,1),i[A>>2]=r,i[A+8>>2]=i[A+8>>2]&-2147483648|i[w+8>>2]&2147483647,i[A+8>>2]=i[A+8>>2]|-2147483648,e=A,A=o+(k+t|0)|0,i[e+4>>2]=A,u[w+12|0]=0,u[A+r|0]=l[w+12|0],v=w+16|0;return}Z4(),H()}function it(A,e,r,f,k,n){var t=0;t=v-80|0,v=t;i:{if((n|0)>=16384){if(n1(t+32|0,e,r,f,k,0,0,0,2147352576),f=i[t+40>>2],k=i[t+44>>2],e=i[t+32>>2],r=i[t+36>>2],n>>>0<32767){n=n-16383|0;break i}n1(t+16|0,e,r,f,k,0,0,0,2147352576),n=(n>>>0>=49149?49149:n)-32766|0,f=i[t+24>>2],k=i[t+28>>2],e=i[t+16>>2],r=i[t+20>>2];break i}if((n|0)>-16383)break i;if(n1(t- -64|0,e,r,f,k,0,0,0,7471104),f=i[t+72>>2],k=i[t+76>>2],e=i[t+64>>2],r=i[t+68>>2],n>>>0>4294934644){n=n+16269|0;break i}n1(t+48|0,e,r,f,k,0,0,0,7471104),n=(n>>>0<=4294918376?-48920:n)+32538|0,f=i[t+56>>2],k=i[t+60>>2],e=i[t+48>>2],r=i[t+52>>2]}n1(t,e,r,f,k,0,0,0,n+16383<<16),e=i[t+12>>2],i[A+8>>2]=i[t+8>>2],i[A+12>>2]=e,e=i[t+4>>2],i[A>>2]=i[t>>2],i[A+4>>2]=e,v=t+80|0}function v2(A,e){var r=0,f=0,k=0,n=0;f=i[A+12>>2],r=l[((l[e|0]<<1&508)+(f>>>6|0)|0)+60828|0],f=f-r|0,i[A+12>>2]=f,k=i[A+16>>2],f=f<<7;i:{if(k>>>0<f>>>0){if(k=e,r=l[e|0],e=r&1,u[k|0]=e|l[(r>>>1|0)+61088|0]<<1,f>>>0>32767||(i[A+12>>2]=f>>>6,f=i[A+16>>2]<<1,i[A+16>>2]=f,r=C[A+20>>1]+1|0,g[A+20>>1]=r,(r|0)==(r&65535))||(g[A+20>>1]=65528,r=i[A+4>>2],r>>>0>=u0[A+8>>2]))break i;return i[A+4>>2]=r+1,i[A+16>>2]=f|l[r|0],e}if(n=l[(r>>>3|0)+61152|0],i[A+12>>2]=r<<n,i[A+16>>2]=k-f<<n,r=e,f=l[r|0],k=f&1,e=!k,u[r|0]=l[(f>>>1|0)+61184|0]<<1|(f>>>0<2?e:k),r=n+C[A+20>>1]|0,g[A+20>>1]=r,r=r<<16>>16,(r|0)<0)break i;f=i[A+4>>2],f>>>0<u0[A+8>>2]&&(i[A+4>>2]=f+1,i[A+16>>2]=i[A+16>>2]|l[f|0]<<r),g[A+20>>1]=r-8}return e}function et(A,e){var r=0,f=0,k=0,n=0,t=0,o=0,s=0;if(k=i[A>>2],t=i[A+4>>2],s=i[e+4>>2]+(k-t|0)|0,(k|0)!=(t|0)){for(r=k,f=s;n=C[r>>1],i[f+12>>2]=0,i[f+4>>2]=0,i[f+8>>2]=0,g[f>>1]=n,i[f+4>>2]=i[r+4>>2],i[f+8>>2]=i[r+8>>2],i[f+12>>2]=i[r+12>>2],i[r+12>>2]=0,i[r+4>>2]=0,i[r+8>>2]=0,f=f+16|0,r=r+16|0,(t|0)!=(r|0););for(;;){if(n=i[k+4>>2],n){if(f=n,r=i[k+8>>2],(f|0)!=(r|0)){for(;f=r-12|0,o=i[f>>2],o&&(i[r-8>>2]=o,Z(o)),r=f,(r|0)!=(n|0););f=i[k+4>>2]}i[k+8>>2]=n,Z(f)}if(k=k+16|0,(t|0)==(k|0))break}k=i[A>>2]}i[e+4>>2]=s,i[A+4>>2]=k,i[A>>2]=i[e+4>>2],i[e+4>>2]=k,r=i[A+4>>2],i[A+4>>2]=i[e+8>>2],i[e+8>>2]=r,r=i[A+8>>2],i[A+8>>2]=i[e+12>>2],i[e+12>>2]=r,i[e>>2]=i[e+4>>2]}function iQ(A,e,r,f,k){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0;var n=0,t=0,o=0;n=v-32|0,v=n;i:{e:{if(o=W[i[i[e>>2]+68>>2]](i[e+4>>2])|0,t=i[o>>2],!t)break e;for(;;){if(n4(i[t+4>>2],r)){if(t=i[o+4>>2],o=o+4|0,t)continue;break e}break}r:{f:switch(i[t+8>>2]-1|0){case 0:if(W[i[i[e>>2]+76>>2]](A,i[e+4>>2],r,n+28|0),i[A>>2])break i;i[n>>2]=i[n+28>>2],a8(f,k,17912,n);break r;case 1:if(W[i[i[e>>2]+84>>2]](A,i[e+4>>2],r,n+28|0),i[A>>2])break i;i[n+16>>2]=i[n+28>>2],a8(f,k,17912,n+16|0);break r;case 2:break f;default:break r}if(W[i[i[e>>2]+92>>2]](A,i[e+4>>2],r,f,k),i[A>>2])break i}e=i[24057],i[A>>2]=i[24056],i[A+4>>2]=e,i[A+8>>2]=i[24058];break i}e=i[24203],i[A>>2]=i[24202],i[A+4>>2]=e,i[A+8>>2]=i[24204]}v=n+32|0}function eQ(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0;f=v-48|0,v=f;i:{if(!(r&&e)){i[A>>2]=5,i[A+4>>2]=2006,i[A+8>>2]=16735;break i}Ef(f+20|0,i[e>>2],i[i[e+8>>2]>>2]);e:{r:switch(l[f+40|0]){default:_2(),H();case 1:b0(A,f+20|0,i[e>>2]);break e;case 0:break r}e=i[f+20>>2];r:{if(u[e+115|0]>=0){i[f+16>>2]=i[e+112>>2],k=i[e+108>>2],i[f+8>>2]=i[e+104>>2],i[f+12>>2]=k;break r}T(f+8|0,i[e+104>>2],i[e+108>>2])}if(e=u[f+19|0],k=(e|0)<0,n=r,r=p((k?i[f+12>>2]:e)+1|0),i[n>>2]=r,n=r,r=i[f+8>>2],c4(n,k?r:f+8|0),i[A+8>>2]=i[24058],k=i[24057],i[A>>2]=i[24056],i[A+4>>2]=k,(e|0)>=0)break e;Z(r)}if(A=l[f+40|0],(A|0)==255)break i;e=i[24239],i[f+8>>2]=i[24238],i[f+12>>2]=e,W[i[(f+8|0)+(A<<2)>>2]](f+47|0,f+20|0)}v=f+48|0}function rQ(A,e){A=A|0,e=e|0;var r=0,f=0,k=0;r=v-32|0,v=r,f=i[e+4>>2],i[A+36>>2]=i[e>>2],i[A+40>>2]=f,f=i[e+12>>2],i[A+44>>2]=i[e+8>>2],i[A+48>>2]=f,f=i[e+20>>2],i[A+52>>2]=i[e+16>>2],i[A+56>>2]=f,l[A+60|0]||(u[A+60|0]=1),e=0,l[A+60|0]==1&&(e=p(144),i[e+4>>2]=0,i[e+8>>2]=0,i[e>>2]=91444,k=tu(e+16|0),f=i[A+56>>2],i[e+132>>2]=i[A+52>>2],i[e+136>>2]=f,f=i[A+48>>2],i[e+124>>2]=i[A+44>>2],i[e+128>>2]=f,f=i[A+40>>2],i[e+116>>2]=i[A+36>>2],i[e+120>>2]=f),i[r+20>>2]=e,i[r+16>>2]=k,f=i[r+20>>2],e=i[r+16>>2],i[r+24>>2]=e,i[r+28>>2]=f,i[r+16>>2]=0,i[r+20>>2]=0,i[r+8>>2]=e,i[r+12>>2]=f,M4(A,r+8|0,0),e=i[r+20>>2];i:{if(!e||(A=i[e+4>>2],i[e+4>>2]=A-1,A))break i;W[i[i[e>>2]+8>>2]](e),y(e)}v=r+32|0}function rt(A){var e=0,r=0,f=0,k=0;if(e=i[A+136>>2],f=i[A+132>>2],(e|0)!=(f|0))for(;;){r=i[e-4>>2];i:{if(!r||(k=i[r+4>>2],i[r+4>>2]=k-1,k))break i;W[i[i[r>>2]+8>>2]](r),y(r)}if(e=e-8|0,(f|0)==(e|0))break}i[A+136>>2]=f,e=i[A+152>>2],i[A+148>>2]=0,i[A+152>>2]=0;i:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break i;W[i[i[e>>2]+8>>2]](e),y(e)}e=i[A+164>>2],i[A+160>>2]=0,i[A+164>>2]=0;i:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break i;W[i[i[e>>2]+8>>2]](e),y(e)}if(e=i[A+252>>2],f=i[A+248>>2],(e|0)!=(f|0))for(;;){r=i[e-4>>2];i:{if(!r||(k=i[r+4>>2],i[r+4>>2]=k-1,k))break i;W[i[i[r>>2]+8>>2]](r),y(r)}if(e=e-8|0,(f|0)==(e|0))break}i[A+252>>2]=f}function fA(A,e){var r=0,f=0,k=0,n=0,t=0,o=0,s=0,w=0,h=0;i[A+8>>2]=0,i[A>>2]=0,i[A+4>>2]=0;i:{e:{if(n=i[e+124>>2],s=e+128|0,(n|0)!=(s|0))for(;;){w=i[i[n+20>>2]+104>>2];r:{if(r>>>0<k>>>0){i[r>>2]=w,r=r+4|0;break r}if(e=r-t|0,h=e>>2,f=h+1|0,f>>>0>=1073741824)break e;if(r=k-t|0,k=r>>1,k=r>>>0>=2147483644?1073741823:f>>>0<k>>>0?k:f,k){if(k>>>0>=1073741824)break i;r=p(k<<2)}else r=0;o=r+e|0,i[o>>2]=w,f=o-(h<<2)|0,e&&x(f,t,e),k=r+(k<<2)|0,i[A+8>>2]=k,r=o+4|0,i[A+4>>2]=r,i[A>>2]=f,t&&Z(t),t=f}i[A+4>>2]=r,f=i[n+4>>2];r:{if(f){for(;;)if(e=f,f=i[e>>2],!f)break r}for(;e=i[n+8>>2],f=i[e>>2]!=(n|0),n=e,!!f;);}if(n=e,(e|0)==(s|0))break}return}G0(),H()}z0(),H()}function fQ(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0;var k=0,n=0;k=v-48|0,v=k;i:{if(!(f&&e)){i[A>>2]=5,i[A+4>>2]=2006,i[A+8>>2]=16735;break i}Ef(k+20|0,i[e>>2],r);e:{r:switch(l[k+40|0]){default:_2(),H();case 1:b0(A,k+20|0,i[e>>2]);break e;case 0:break r}e=i[k+20>>2];r:{if(u[e+115|0]>=0){i[k+16>>2]=i[e+112>>2],r=i[e+108>>2],i[k+8>>2]=i[e+104>>2],i[k+12>>2]=r;break r}T(k+8|0,i[e+104>>2],i[e+108>>2])}if(e=u[k+19|0],r=(e|0)<0,n=f,f=p((r?i[k+12>>2]:e)+1|0),i[n>>2]=f,n=f,f=i[k+8>>2],c4(n,r?f:k+8|0),i[A+8>>2]=i[24058],r=i[24057],i[A>>2]=i[24056],i[A+4>>2]=r,(e|0)>=0)break e;Z(f)}if(A=l[k+40|0],(A|0)==255)break i;e=i[24185],i[k+8>>2]=i[24184],i[k+12>>2]=e,W[i[(k+8|0)+(A<<2)>>2]](k+47|0,k+20|0)}v=k+48|0}function AQ(A,e){A=A|0,e=e|0;var r=0,f=0,k=0,n=0,t=0,o=0,s=0,w=0,h=0,_=0;o=v-16|0,v=o,gt(o+4|0,i[A>>2]),k=i[o+4>>2],A=i[o+8>>2];i:{e:{if((k|0)!=(A|0)){if(r=A-k>>3,t=r>>>0<=1?1:r,h=t&3,A=0,r>>>0>=4)for(w=t&-4,t=0;r=A<<3,f=r+e|0,n=r+k|0,s=i[n+4>>2],i[f>>2]=i[n>>2],i[f+4>>2]=s,f=r|8,n=f+e|0,f=f+k|0,s=i[f+4>>2],i[n>>2]=i[f>>2],i[n+4>>2]=s,f=r|16,n=f+e|0,f=f+k|0,s=i[f+4>>2],i[n>>2]=i[f>>2],i[n+4>>2]=s,r=r|24,f=r+e|0,r=r+k|0,n=i[r+4>>2],i[f>>2]=i[r>>2],i[f+4>>2]=n,A=A+4|0,t=t+4|0,(w|0)!=(t|0););if(!h)break e;for(;r=A<<3,t=r+e|0,r=r+k|0,w=i[r+4>>2],i[t>>2]=i[r>>2],i[t+4>>2]=w,A=A+1|0,_=_+1|0,(_|0)!=(h|0););break e}if(!k)break i}i[o+8>>2]=k,Z(k)}v=o+16|0}function ft(A,e){var r=0,f=0,k=0;i:{if(l[e|0]||(e=Tr(19548),l[e|0]&&e)||(e=Tr(G(A,12)+74160|0),l[e|0]&&e)||(e=Tr(19627),l[e|0]&&e))break i;e=21093}i:{for(;;){if(f=l[e+r|0],!(!f|(f|0)==47)){if(f=23,r=r+1|0,(r|0)!=23)continue;break i}break}f=r}k=21093;i:{e:{r=l[e|0];r:{f:{if(!(l[e+f|0]|(r|0)==46)&&(k=e,(r|0)!=67))break f;if(!l[k+1|0])break r}if(!n4(k,21093))break r;if(n4(k,19243))break e}if(!A&&(r=73092,l[k+1|0]==46))break i;return 0}if(r=i[32292],r)for(;;){if(!n4(k,r+8|0))break i;if(r=i[r+32>>2],!r)break}r=y2(36),r&&(e=i[18274],i[r>>2]=i[18273],i[r+4>>2]=e,e=r+8|0,A8(e,k,f),u[e+f|0]=0,i[r+32>>2]=i[32292],i[32292]=r),r=A|r?r:73092}return r}function AA(A,e,r,f,k,n,t,o){var s=0;s=v-48|0,v=s,i[s+28>>2]=i[e>>2],e=i[e+4>>2],i[s+32>>2]=e,e&&(i[e+4>>2]=i[e+4>>2]+1),r6(s,s+28|0,r,3,f,k,n,t,o);i:{e:{r:{f:switch(f=l[s+20|0],f|0){case 0:break e;case 1:break r;default:break f}_2(),H()}if(r=i[s+4>>2],i[A>>2]=i[s>>2],i[A+4>>2]=r,r=A+8|0,u[s+19|0]>=0){k=i[s+12>>2],i[r>>2]=i[s+8>>2],i[r+4>>2]=k,i[r+8>>2]=i[s+16>>2];break i}T(r,i[s+8>>2],i[s+12>>2]);break i}k=i[s>>2],r=i[s+4>>2],r&&(i[r+4>>2]=i[r+4>>2]+1),i[A+4>>2]=r,i[A>>2]=k}u[A+20|0]=f,A=l[s+20|0],(A|0)!=255&&(r=i[25473],i[s+40>>2]=i[25472],i[s+44>>2]=r,W[i[(s+40|0)+(A<<2)>>2]](s+39|0,s));i:{if(!e||(A=i[e+4>>2],i[e+4>>2]=A-1,A))break i;W[i[i[e>>2]+8>>2]](e),y(e)}v=s+48|0}function At(A,e,r){var f=0,k=0,n=0,t=0,o=0;f=v-16|0,v=f,i[A+40>>2]=0,i[A+32>>2]=0,i[A+36>>2]=0,i[A>>2]=0,i[A+4>>2]=0,i[A+12>>2]=0,i[A+16>>2]=0,u[A+8|0]=0,i[A+20>>2]=0,i[A+24>>2]=0,k=i[e+4>>2],i[f+8>>2]=i[k+48>>2],k=i[k+52>>2],i[f+12>>2]=k,k&&(i[k+4>>2]=i[k+4>>2]+1),r=i[e+28>>2]+(r-i[e+16>>2]<<4)|0,k=i[r+8>>2],e=i[r>>2],t=i[r+4>>2],r=i[f+12>>2],i[f>>2]=i[f+8>>2],i[f+4>>2]=r,n=i[f>>2],o=i[f+4>>2],i[f>>2]=0,i[f+4>>2]=0,r=i[A+4>>2],i[A>>2]=n,i[A+4>>2]=o;i:{if(!r||(n=i[r+4>>2],i[r+4>>2]=n-1,n))break i;W[i[i[r>>2]+8>>2]](r),y(r)}i[A+40>>2]=k,i[A+32>>2]=e,i[A+36>>2]=t,u[A+8|0]=2,A=i[f+4>>2];i:{if(!A||(e=i[A+4>>2],i[A+4>>2]=e-1,e))break i;W[i[i[A>>2]+8>>2]](A),y(A)}v=f+16|0}function kQ(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,t=0,o=0,s=0,w=0,h=0,_=0;n=v-16|0,v=n,k=i[A>>2],A=i[k+244>>2],k=i[k+248>>2],k&&(i[k+4>>2]=i[k+4>>2]+1);i:{if(!A)break i;gA(n+4|0,A,e),A=i[n+8>>2],e=i[n+4>>2],o=A-e>>2;e:{if((A|0)!=(e|0)){if(f=o>>>0<=1?1:o,s=f&3,A=0,o>>>0>=4)for(_=f&-4;f=A<<2,i[f+r>>2]=i[e+f>>2],t=f|4,i[t+r>>2]=i[e+t>>2],t=f|8,i[t+r>>2]=i[e+t>>2],f=f|12,i[f+r>>2]=i[e+f>>2],A=A+4|0,w=w+4|0,(w|0)!=(_|0););if(!s)break e;for(;f=A<<2,i[f+r>>2]=i[e+f>>2],A=A+1|0,h=h+1|0,(h|0)!=(s|0););break e}if(!e)break i}i[n+8>>2]=e,Z(e)}i:{if(!k||(A=i[k+4>>2],i[k+4>>2]=A-1,A))break i;W[i[i[k>>2]+8>>2]](k),y(k)}return v=n+16|0,o|0}function F4(A,e,r){var f=0,k=0,n=0,t=0,o=0,s=0,w=0;i:{k=i[A+4>>2],o=i[A>>2],s=k-o|0,f=u[e+11|0],f=(i[A+12>>2]+r|0)+((f|0)<0?i[e+4>>2]:f)|0;e:{if(s>>>0>=f>>>0)break e;if(n=f-s|0,t=i[A+8>>2],n>>>0<=t-k>>>0){n&&o0(k,0,n),i[A+4>>2]=k+n;break e}if((f|0)<0)break i;if(k=t-o|0,t=k<<1,t=k>>>0>=1073741823?2147483647:f>>>0<t>>>0?t:f,k=p(t),n&&o0(k+s|0,0,n),s&&x(k,o,s),i[A+8>>2]=k+t,i[A+4>>2]=f+k,i[A>>2]=k,!o)break e;Z(o)}if(f=u[e+11|0],(f|0)<0?i[e+4>>2]:f)for(f=f>>>31|0;f=l[(f?i[e>>2]:e)+w|0],n=i[A+12>>2],i[A+12>>2]=n+1,u[n+i[A>>2]|0]=f,n=u[e+11|0],f=n>>>31|0,w=w+1|0,w>>>0<((n|0)<0?i[e+4>>2]:n)>>>0;);r&&(e=i[A+12>>2],i[A+12>>2]=e+1,u[e+i[A>>2]|0]=0);return}G0(),H()}function kt(A,e){var r=0,f=0,k=0,n=0,t=0,o=0,s=0,w=0;i[A+8>>2]=0,i[A>>2]=0,i[A+4>>2]=0;i:{e:{if(n=i[e+180>>2],s=e+184|0,(n|0)!=(s|0))for(;;){r:{if(f>>>0<k>>>0){i[f>>2]=i[n+16>>2],f=f+4|0;break r}if(e=f-t|0,w=e>>2,r=w+1|0,r>>>0>=1073741824)break e;if(f=k-t|0,k=f>>1,k=f>>>0>=2147483644?1073741823:r>>>0<k>>>0?k:r,k){if(k>>>0>=1073741824)break i;f=p(k<<2)}else f=0;o=f+e|0,i[o>>2]=i[n+16>>2],r=o-(w<<2)|0,e&&x(r,t,e),k=f+(k<<2)|0,i[A+8>>2]=k,f=o+4|0,i[A+4>>2]=f,i[A>>2]=r,t&&Z(t),t=r}i[A+4>>2]=f,r=i[n+4>>2];r:{if(r){for(;;)if(e=r,r=i[r>>2],!r)break r}for(;e=i[n+8>>2],r=i[e>>2]!=(n|0),n=e,!!r;);}if(n=e,(s|0)==(e|0))break}return}G0(),H()}z0(),H()}function nQ(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0;if(!r)return 0;i:{e:{if(e=i[A>>2],l[e+156|0]==1){if(A=i[A+4>>2],A)break e;A=0;break i}if(A=i[e+164>>2],e=i[e+160>>2],A)break e;A=0;break i}i[A+4>>2]=i[A+4>>2]+1}l[e+168|0]==1&&(f=p(56),k=i[e+228>>2],i[f+48>>2]=i[e+224>>2],i[f+52>>2]=k,k=i[e+220>>2],i[f+40>>2]=i[e+216>>2],i[f+44>>2]=k,k=i[e+212>>2],i[f+32>>2]=i[e+208>>2],i[f+36>>2]=k,k=i[e+204>>2],i[f+24>>2]=i[e+200>>2],i[f+28>>2]=k,k=i[e+196>>2],i[f+16>>2]=i[e+192>>2],i[f+20>>2]=k,k=i[e+188>>2],i[f+8>>2]=i[e+184>>2],i[f+12>>2]=k,k=i[e+180>>2],i[f>>2]=i[e+176>>2],i[f+4>>2]=k,k=1),i[r>>2]=f;i:{if(!A||(e=i[A+4>>2],i[A+4>>2]=e-1,e))break i;W[i[i[A>>2]+8>>2]](A),y(A)}return k|0}function tQ(A,e,r,f,k,n,t,o,s,w,h,_,B){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,t=t|0,o=o|0,s=s|0,w=w|0,h=h|0,_=_|0,B=B|0;var m=0,X=0,Q=0,V=0,F=0,I=0,E=0;if((_|0)>0){if(!((t|0)<=0|(n|0)<=0))for(Q=(s+h|0)+1<<_,V=_+1|0,s=-1<<B^-1,I=n&2147483646,E=n&1;;){if(_=(G(e,X)<<1)+A|0,h=G(k,X)<<1,B=h+f|0,h=r+h|0,F=0,(n|0)!=1)for(;m=(G(g[h>>1],o)+Q|0)+G(g[B>>1],w)>>V,g[_>>1]=(m|0)>=0?(s|0)>(m|0)?m:s:0,m=(G(g[h+2>>1],o)+Q|0)+G(g[B+2>>1],w)>>V,g[_+2>>1]=(m|0)>=0?(s|0)>(m|0)?m:s:0,B=B+4|0,h=h+4|0,_=_+4|0,F=F+2|0,(I|0)!=(F|0););if(E&&(h=(G(g[h>>1],o)+Q|0)+G(g[B>>1],w)>>V,g[_>>1]=(h|0)>=0?(s|0)>(h|0)?h:s:0),X=X+1|0,(X|0)==(t|0))break}return}D0(21760,18216,213,10423),H()}function Ae(A,e,r){var f=0,k=0;i:{if(!r||(u[A|0]=e,f=A+r|0,u[f-1|0]=e,r>>>0<3)||(u[A+2|0]=e,u[A+1|0]=e,u[f-3|0]=e,u[f-2|0]=e,r>>>0<7)||(u[A+3|0]=e,u[f-4|0]=e,r>>>0<9)||(f=0-A&3,k=f+A|0,A=G(e&255,16843009),i[k>>2]=A,r=r-f&-4,e=r+k|0,i[e-4>>2]=A,r>>>0<9)||(i[k+8>>2]=A,i[k+4>>2]=A,i[e-8>>2]=A,i[e-12>>2]=A,r>>>0<25)||(i[k+24>>2]=A,i[k+20>>2]=A,i[k+16>>2]=A,i[k+12>>2]=A,i[e-16>>2]=A,i[e-20>>2]=A,i[e-24>>2]=A,i[e-28>>2]=A,e=k&4|24,r=r-e|0,r>>>0<32))break i;for(A=O0(A,0,1,1),f=l0,e=e+k|0;i[e+24>>2]=A,i[e+28>>2]=f,i[e+16>>2]=A,i[e+20>>2]=f,i[e+8>>2]=A,i[e+12>>2]=f,i[e>>2]=A,i[e+4>>2]=f,e=e+32|0,r=r-32|0,r>>>0>31;);}}function W8(A,e,r,f,k){var n=0,t=0,o=0,s=0;s=v-16|0,v=s,i[s+12>>2]=e,e=0,o=6;i:{e:{if(L2(A,s+12|0))break e;n=i[A>>2],t=i[n+12>>2];r:{if((t|0)==i[n+16>>2]){n=W[i[i[n>>2]+36>>2]](n)|0;break r}n=u[t|0]}if(t=n<<24>>24,(t|0)>=0?n=(i[i[f+8>>2]+(t<<2)>>2]&64)!=0:n=0,o=4,!n)break e;for(e=W[i[i[f>>2]+36>>2]](f,t,0)|0;;){r:{if(q1(A),e=e-48|0,L2(A,s+12|0)|(k|0)<2)break r;n=i[A>>2],t=i[n+12>>2];f:{if((t|0)==i[n+16>>2]){n=W[i[i[n>>2]+36>>2]](n)|0;break f}n=u[t|0]}if(n=n<<24>>24,(n|0)>=0?o=(i[i[f+8>>2]+(n<<2)>>2]&64)!=0:o=0,!o)break i;k=k-1|0,e=(W[i[i[f>>2]+36>>2]](f,n,0)|0)+G(e,10)|0;continue}break}if(!L2(A,s+12|0))break i;o=2}i[r>>2]=o|i[r>>2]}return v=s+16|0,e}function I1(A,e){var r=0,f=0,k=0,n=0,t=0,o=0,s=0,w=0,h=0,_=0,B=0;if(k=i[A+24>>2],!((k|0)>=(e|0)|(k|0)>56)){for(f=64-k|0,n=i[A+16>>2],h=i[A+20>>2],r=i[A+4>>2],k=i[A+12>>2];;){i:{if(t=f,!k){s=f;break i}if(o=r+1|0,i[A+4>>2]=o,r=l[r|0],k=k-1|0,i[A+12>>2]=k,s=t-8|0,w=s&31,(s&63)>>>0>=32?(_=r<<w,r=0):(_=(1<<w)-1&r>>>32-w,r=r<<w),n=r|n,r=h|_,h=r,i[A+16>>2]=n,i[A+20>>2]=r,r=f,f=r-8|0,B=B-(r>>>0<8)|0,r=o,(t|0)>15)continue}break}k=64-s|0}return i[A+24>>2]=k-e,r=i[A+16>>2],f=A,f=A,A=i[A+20>>2],t=r,n=e&31,(e&63)>>>0>=32?(o=r<<n,t=0):(o=(1<<n)-1&t>>>32-n|A<<n,t=t<<n),i[f+16>>2]=t,i[f+20>>2]=o,f=64-e|0,e=r,r=f&31,(f&63)>>>0>=32?A=A>>>r|0:A=((1<<r)-1&A)<<32-r|e>>>r,A&255}function uQ(A,e,r,f,k,n){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,e=v-32|0,v=e;i:{if(i[r>>2]){i[A+8>>2]=0,i[A>>2]=0,i[A+4>>2]=0;break i}if(i[r+4>>2]!=3){i[A+8>>2]=0,i[A>>2]=0,i[A+4>>2]=0;break i}if(i[k+4>>2]!=2){i[A+8>>2]=0,i[A>>2]=0,i[A+4>>2]=0;break i}if(k=i[r+12>>2],(k|0)>=9){i[A+8>>2]=0,i[A>>2]=0,i[A+4>>2]=0;break i}if(!C[r+20>>1]){i[A+8>>2]=0,i[A>>2]=0,i[A+4>>2]=0;break i}if(f=i[f+4>>2],i[A+8>>2]=0,i[A>>2]=0,i[A+4>>2]=0,(f|0)!=1)break i;i[e+8>>2]=0,i[e+12>>2]=1,f=l[r+8|0],i[e+20>>2]=k,u[e+16|0]=f,f=l[r+19|0]|l[r+20|0]<<8|(l[r+21|0]<<16|l[r+22|0]<<24),u[e+27|0]=f,u[e+28|0]=f>>>8,u[e+29|0]=f>>>16,u[e+30|0]=f>>>24,i[e+24>>2]=i[r+16>>2],i[e+4>>2]=11,S8(A,e+8|0,e+4|0)}v=e+32|0}function oQ(A,e,r,f,k,n){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,e=v-32|0,v=e;i:{if(i[r>>2]){i[A+8>>2]=0,i[A>>2]=0,i[A+4>>2]=0;break i}if(i[r+4>>2]!=3){i[A+8>>2]=0,i[A>>2]=0,i[A+4>>2]=0;break i}if(i[k+4>>2]!=2){i[A+8>>2]=0,i[A>>2]=0,i[A+4>>2]=0;break i}if(k=i[r+12>>2],(k|0)<=8){i[A+8>>2]=0,i[A>>2]=0,i[A+4>>2]=0;break i}if(!C[r+20>>1]){i[A+8>>2]=0,i[A>>2]=0,i[A+4>>2]=0;break i}if(f=i[f+4>>2],i[A+8>>2]=0,i[A>>2]=0,i[A+4>>2]=0,(f|0)!=1)break i;i[e+8>>2]=0,i[e+12>>2]=1,f=l[r+8|0],i[e+20>>2]=k,u[e+16|0]=f,f=l[r+19|0]|l[r+20|0]<<8|(l[r+21|0]<<16|l[r+22|0]<<24),u[e+27|0]=f,u[e+28|0]=f>>>8,u[e+29|0]=f>>>16,u[e+30|0]=f>>>24,i[e+24>>2]=i[r+16>>2],i[e+4>>2]=11,S8(A,e+8|0,e+4|0)}v=e+32|0}function lQ(A,e,r,f,k,n){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,e=v-32|0,v=e;i:{if(i[r>>2]){i[A+8>>2]=0,i[A>>2]=0,i[A+4>>2]=0;break i}if(i[r+4>>2]!=3){i[A+8>>2]=0,i[A>>2]=0,i[A+4>>2]=0;break i}if(i[k+4>>2]!=2){i[A+8>>2]=0,i[A>>2]=0,i[A+4>>2]=0;break i}if(k=i[r+12>>2],(k|0)>=9){i[A+8>>2]=0,i[A>>2]=0,i[A+4>>2]=0;break i}if(!C[r+20>>1]){i[A+8>>2]=0,i[A>>2]=0,i[A+4>>2]=0;break i}if(f=i[f+4>>2],i[A+8>>2]=0,i[A>>2]=0,i[A+4>>2]=0,(f|0)!=2)break i;i[e+8>>2]=0,i[e+12>>2]=2,f=l[r+8|0],i[e+20>>2]=k,u[e+16|0]=f,f=l[r+19|0]|l[r+20|0]<<8|(l[r+21|0]<<16|l[r+22|0]<<24),u[e+27|0]=f,u[e+28|0]=f>>>8,u[e+29|0]=f>>>16,u[e+30|0]=f>>>24,i[e+24>>2]=i[r+16>>2],i[e+4>>2]=11,S8(A,e+8|0,e+4|0)}v=e+32|0}function sQ(A,e,r,f,k,n){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,e=v-32|0,v=e;i:{if(i[r>>2]){i[A+8>>2]=0,i[A>>2]=0,i[A+4>>2]=0;break i}if(i[r+4>>2]!=3){i[A+8>>2]=0,i[A>>2]=0,i[A+4>>2]=0;break i}if(i[k+4>>2]!=2){i[A+8>>2]=0,i[A>>2]=0,i[A+4>>2]=0;break i}if(k=i[r+12>>2],(k|0)<=8){i[A+8>>2]=0,i[A>>2]=0,i[A+4>>2]=0;break i}if(!C[r+20>>1]){i[A+8>>2]=0,i[A>>2]=0,i[A+4>>2]=0;break i}if(f=i[f+4>>2],i[A+8>>2]=0,i[A>>2]=0,i[A+4>>2]=0,(f|0)!=2)break i;i[e+8>>2]=0,i[e+12>>2]=2,f=l[r+8|0],i[e+20>>2]=k,u[e+16|0]=f,f=l[r+19|0]|l[r+20|0]<<8|(l[r+21|0]<<16|l[r+22|0]<<24),u[e+27|0]=f,u[e+28|0]=f>>>8,u[e+29|0]=f>>>16,u[e+30|0]=f>>>24,i[e+24>>2]=i[r+16>>2],i[e+4>>2]=11,S8(A,e+8|0,e+4|0)}v=e+32|0}function wQ(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0;var k=0,n=0,t=0,o=0,s=0,w=0,h=0;k=v-32|0,v=k,n=i[r+16>>2],n=n>>>0>=6?6:n,t=i[r+8>>2],t&&c1(t,n),t=i[r>>2],o=W[i[i[t>>2]+8>>2]](t)|0,s=l0,o=n+o|0,s=n>>>0>o>>>0?s+1|0:s,W[i[i[t>>2]+20>>2]](t,o,s)|0,i[r+16>>2]=i[r+16>>2]-n,w=e,h=o2(r),g[w+98>>1]=h,d6(k+8|0,e,r,-1,f),e=A+8|0;i:{if(i[k+8>>2]){r=i[k+12>>2],i[A>>2]=i[k+8>>2],i[A+4>>2]=r,i[e+8>>2]=i[k+24>>2],A=i[k+20>>2],i[e>>2]=i[k+16>>2],i[e+4>>2]=A,i[k+24>>2]=0,i[k+16>>2]=0,i[k+20>>2]=0;break i}if(r=i[26917],i[A>>2]=i[26916],i[A+4>>2]=r,u[107683]>=0){A=i[26919],i[e>>2]=i[26918],i[e+4>>2]=A,i[e+8>>2]=i[26920];break i}T(e,i[26918],i[26919])}u[k+27|0]<0&&Z(i[k+16>>2]),v=k+32|0}function i2(A,e){var r=0,f=0,k=0,n=0,t=0,o=0,s=0,w=0,h=0,_=0,B=0;if(k=i[A+24>>2],!((k|0)>=(e|0)|(k|0)>56)){for(f=64-k|0,n=i[A+16>>2],h=i[A+20>>2],r=i[A+4>>2],k=i[A+12>>2];;){i:{if(t=f,!k){s=f;break i}if(o=r+1|0,i[A+4>>2]=o,r=l[r|0],k=k-1|0,i[A+12>>2]=k,s=t-8|0,w=s&31,(s&63)>>>0>=32?(_=r<<w,r=0):(_=(1<<w)-1&r>>>32-w,r=r<<w),n=r|n,r=h|_,h=r,i[A+16>>2]=n,i[A+20>>2]=r,r=f,f=r-8|0,B=B-(r>>>0<8)|0,r=o,(t|0)>15)continue}break}k=64-s|0}return i[A+24>>2]=k-e,r=i[A+16>>2],f=A,f=A,A=i[A+20>>2],t=r,n=e&31,(e&63)>>>0>=32?(o=r<<n,t=0):(o=(1<<n)-1&t>>>32-n|A<<n,t=t<<n),i[f+16>>2]=t,i[f+20>>2]=o,f=64-e|0,e=r,r=f&31,(f&63)>>>0>=32?A=A>>>r|0:A=((1<<r)-1&A)<<32-r|e>>>r,A}function B4(A,e){var r=0,f=0,k=0,n=0;r=v-32|0,v=r,i[r+24>>2]=0,i[r+16>>2]=0,i[r+20>>2]=0;i:{if(!i[e+16>>2]){i[A>>2]=0,i[A+4>>2]=0,i[A+8>>2]=0;break i}k=i[e>>2],f=i[e+4>>2],f&&(i[f+4>>2]=i[f+4>>2]+1);e:{r:{if(!f4(e,1))break r;for(;;){if(!(W[i[i[k>>2]+16>>2]](k,r+15|0,1)|0)){i8(e),i[A+8>>2]=0,i[A>>2]=0,i[A+4>>2]=0;break e}if(n=u[r+15|0],!(!n|!i[e+16>>2])){if(oi(r+16|0,n),!f4(e,1))break r;continue}break}e=i[r+20>>2],i[A>>2]=i[r+16>>2],i[A+4>>2]=e,i[A+8>>2]=i[r+24>>2],i[r+24>>2]=0,i[r+16>>2]=0,i[r+20>>2]=0;break e}i[A>>2]=0,i[A+4>>2]=0,i[A+8>>2]=0}if(!f||(A=i[f+4>>2],i[f+4>>2]=A-1,A))break i;W[i[i[f>>2]+8>>2]](f),y(f)}u[r+27|0]<0&&Z(i[r+16>>2]),v=r+32|0}function hQ(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,t=0,o=0,s=0,w=0;n=v-32|0,v=n,w=W[i[i[e>>2]+52>>2]](e,r,0)|0;i:{if(l[e+97|0]){k=i[e+104>>2],t=i[e+108>>2];break i}if(o=2147483647,k=i[e+104>>2],t=i[e+108>>2],(k|0)==(t|0)){t=k;break i}for(f=k;s=i[f+4>>2],o=(o|0)>(s|0)?s:o,f=f+8|0,(t|0)!=(f|0););}if(F0(r,t-k>>3),f=i[e+104>>2],k=i[e+108>>2],(f|0)!=(k|0))for(;F0(r,i[f>>2]),F0(r,i[f+4>>2]-o|0),f=f+8|0,(k|0)!=(f|0););f1(n+12|0,e,r,w),u[n+31|0]<0&&Z(i[n+20>>2]),e=i[26917],i[A>>2]=i[26916],i[A+4>>2]=e,A=A+8|0;i:{if(u[107683]>=0){e=i[26919],i[A>>2]=i[26918],i[A+4>>2]=e,i[A+8>>2]=i[26920];break i}T(A,i[26918],i[26919])}v=n+32|0}function _Q(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0;var k=0,n=0,t=0;f=v-32|0,v=f,z2(f,e,r),u[f+19|0]<0&&Z(i[f+8>>2]);i:{if(l[e+97|0]){t1(A,e,6878);break i}if(n=e,t=C0(r),i[n+104>>2]=t,n=e,t=C0(r),i[n+108>>2]=t,n=e,t=C0(r),i[n+112>>2]=t,n=e,t=C0(r),i[n+116>>2]=t,n=e,t=C0(r),i[n+120>>2]=t,B4(f+20|0,r),u[e+135|0]<0&&Z(i[e+124>>2]),k=i[f+24>>2],i[e+124>>2]=i[f+20>>2],i[e+128>>2]=k,i[e+132>>2]=i[f+28>>2],l[r+20|0]==1){if(u[f+20|0]=0,u[f+31|0]=0,q(A,2,100,f+20|0),u[f+31|0]>=0)break i;Z(i[f+20>>2]);break i}if(e=i[26917],i[A>>2]=i[26916],i[A+4>>2]=e,A=A+8|0,u[107683]>=0){e=i[26919],i[A>>2]=i[26918],i[A+4>>2]=e,i[A+8>>2]=i[26920];break i}T(A,i[26918],i[26919])}v=f+32|0}function nt(A,e,r){var f=0,k=0,n=0,t=0,o=0,s=0;t=v-16|0,v=t,i[t+12>>2]=0,i[t+4>>2]=0,i[t+8>>2]=0;i:{e:{r:{if(r){if((r|0)<0)break r;k=p(r),r&&x(k,e,r),s=r+k|0}e=i[A+120>>2],f=i[A+124>>2];f:{if(e>>>0<f>>>0){i[e+8>>2]=s,i[e+4>>2]=s,i[e>>2]=k,r=e+12|0;break f}if(o=i[A+116>>2],e=e-o|0,r=((e|0)/12|0)+1|0,r>>>0>=357913942)break e;if(f=(f-o|0)/12|0,n=f<<1,n=f>>>0>=178956970?357913941:r>>>0<n>>>0?n:r,n){if(n>>>0>=357913942)break i;r=p(G(n,12))}else r=0;if(f=r+e|0,i[f+8>>2]=s,i[f+4>>2]=s,i[f>>2]=k,k=f+G((e|0)/-12|0,12)|0,e&&x(k,o,e),i[A+124>>2]=r+G(n,12),r=f+12|0,i[A+120>>2]=r,i[A+116>>2]=k,!o)break f;Z(o)}i[A+120>>2]=r,v=t+16|0;return}G0(),H()}G0(),H()}z0(),H()}function tt(A,e,r){var f=0,k=0,n=0,t=0,o=0,s=0;t=v-16|0,v=t,i[t+12>>2]=0,i[t+4>>2]=0,i[t+8>>2]=0;i:{e:{r:{if(r){if((r|0)<0)break r;k=p(r),r&&x(k,e,r),s=r+k|0}e=i[A+144>>2],f=i[A+148>>2];f:{if(e>>>0<f>>>0){i[e+8>>2]=s,i[e+4>>2]=s,i[e>>2]=k,r=e+12|0;break f}if(o=i[A+140>>2],e=e-o|0,r=((e|0)/12|0)+1|0,r>>>0>=357913942)break e;if(f=(f-o|0)/12|0,n=f<<1,n=f>>>0>=178956970?357913941:r>>>0<n>>>0?n:r,n){if(n>>>0>=357913942)break i;r=p(G(n,12))}else r=0;if(f=r+e|0,i[f+8>>2]=s,i[f+4>>2]=s,i[f>>2]=k,k=f+G((e|0)/-12|0,12)|0,e&&x(k,o,e),i[A+148>>2]=r+G(n,12),r=f+12|0,i[A+144>>2]=r,i[A+140>>2]=k,!o)break f;Z(o)}i[A+144>>2]=r,v=t+16|0;return}G0(),H()}G0(),H()}z0(),H()}function ut(A,e,r){var f=0,k=0,n=0,t=0,o=0,s=0;t=v-16|0,v=t,i[t+12>>2]=0,i[t+4>>2]=0,i[t+8>>2]=0;i:{e:{r:{if(r){if((r|0)<0)break r;k=p(r),r&&x(k,e,r),s=r+k|0}e=i[A+132>>2],f=i[A+136>>2];f:{if(e>>>0<f>>>0){i[e+8>>2]=s,i[e+4>>2]=s,i[e>>2]=k,r=e+12|0;break f}if(o=i[A+128>>2],e=e-o|0,r=((e|0)/12|0)+1|0,r>>>0>=357913942)break e;if(f=(f-o|0)/12|0,n=f<<1,n=f>>>0>=178956970?357913941:r>>>0<n>>>0?n:r,n){if(n>>>0>=357913942)break i;r=p(G(n,12))}else r=0;if(f=r+e|0,i[f+8>>2]=s,i[f+4>>2]=s,i[f>>2]=k,k=f+G((e|0)/-12|0,12)|0,e&&x(k,o,e),i[A+136>>2]=r+G(n,12),r=f+12|0,i[A+132>>2]=r,i[A+128>>2]=k,!o)break f;Z(o)}i[A+132>>2]=r,v=t+16|0;return}G0(),H()}G0(),H()}z0(),H()}function BQ(A,e,r,f,k,n,t,o,s,w,h,_){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,t=t|0,o=o|0,s=s|0,w=w|0,h=h|0,_=_|0;var B=0,m=0,X=0,Q=0,V=0,F=0,I=0;if((_|0)>0){if(!((t|0)<=0|(n|0)<=0))for(X=(s+h|0)+1<<_,Q=_+1|0,F=n&2147483646,I=n&1;;){if(_=G(e,m)+A|0,s=G(k,m)<<1,h=s+f|0,s=r+s|0,V=0,(n|0)!=1)for(;B=(G(g[s>>1],o)+X|0)+G(g[h>>1],w)>>Q,B=(B|0)>=255?255:B,u[_|0]=(B|0)>0?B:0,B=(G(g[s+2>>1],o)+X|0)+G(g[h+2>>1],w)>>Q,B=(B|0)>=255?255:B,u[_+1|0]=(B|0)>0?B:0,h=h+4|0,s=s+4|0,_=_+2|0,V=V+2|0,(F|0)!=(V|0););if(I&&(s=(G(g[s>>1],o)+X|0)+G(g[h>>1],w)>>Q,s=(s|0)>=255?255:s,u[_|0]=(s|0)>0?s:0),m=m+1|0,(m|0)==(t|0))break}return}D0(21760,18216,80,10271),H()}function vQ(A,e){A=A|0,e=e|0;var r=0,f=0,k=0;r=v-32|0,v=r;i:{if((e|0)==-1){if(l[A+52|0])break i;e=i[A+48>>2],u[A+52|0]=(e|0)!=-1;break i}e:{r:{if(f=l[A+52|0],!(!(f&1)|l[A+53|0]!=1)){if(zs(i[A+48>>2],i[A+32>>2]))break r;break e}if(!(f&1))break r;u[r+19|0]=i[A+48>>2]<<24>>24;f:{A:switch(f=i[A+36>>2],k=r+20|0,(W[i[i[f>>2]+12>>2]](f,i[A+40>>2],r+19|0,k,r+12|0,r+24|0,r+32|0,k)|0)-1|0){case 0:case 1:break e;case 2:break A;default:break f}f=i[A+48>>2],i[r+20>>2]=r+25,u[r+24|0]=f}for(;;){if(f=i[r+20>>2],f>>>0<=r+24>>>0)break r;if(f=f-1|0,i[r+20>>2]=f,(Zi(u[f|0],i[A+32>>2])|0)==-1)break}break e}u[A+52|0]=1,i[A+48>>2]=e;break i}e=-1}return v=r+32|0,e|0}function mQ(A,e,r,f,k,n){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,e=v-32|0,v=e,n=i[f+4>>2];i:{if(!(!l[k+12|0]|((n|0)==3|i[k+4>>2]==1))){i[A+8>>2]=0,i[A>>2]=0,i[A+4>>2]=0;break i}if(!(i[r>>2]==1&(i[r+4>>2]&-2)==10)){i[A+8>>2]=0,i[A>>2]=0,i[A+4>>2]=0;break i}if(n-1>>>0>=3){i[A+8>>2]=0,i[A>>2]=0,i[A+4>>2]=0;break i}if(r=C[f+20>>1],!(r>>>0>14|!(1<<r&18689))){i[A+8>>2]=0,i[A>>2]=0,i[A+4>>2]=0;break i}i[A+8>>2]=0,i[A>>2]=0,i[A+4>>2]=0,i[e+12>>2]=n,i[e+8>>2]=0,r=l[f+8|0],i[e+20>>2]=8,u[e+16|0]=r,r=l[f+19|0]|l[f+20|0]<<8|(l[f+21|0]<<16|l[f+22|0]<<24),u[e+27|0]=r,u[e+28|0]=r>>>8,u[e+29|0]=r>>>16,u[e+30|0]=r>>>24,i[e+24>>2]=i[f+16>>2],i[e+4>>2]=11,S8(A,e+8|0,e+4|0)}v=e+32|0}function ot(A){var e=0,r=0,f=0,k=0,n=0;n=i[31366],i[A+72>>2]<=0&&h5(A),i[31366]=i[A+136>>2],r=v-32|0,v=r;i:{e:{r:{if(e=i[A+4>>2],f=i[A+8>>2],(e|0)==(f|0)||(e=mt(r+28|0,e,f-e|0),(e|0)==-1))break r;i[A+4>>2]=i[A+4>>2]+(e>>>0<=1?1:e);break e}for(i[r+16>>2]=0,i[r+20>>2]=0,e=0;;){f=e;r:{if(e=i[A+4>>2],(e|0)!=i[A+8>>2]){i[A+4>>2]=e+1,u[r+15|0]=l[e|0];break r}if(e=u3(A),u[r+15|0]=e,(e|0)>=0)break r;if(e=-1,!(f&1))break i;i[A>>2]=i[A>>2]|32,i[31324]=25;break i}if(e=1,k=ne(r+28|0,r+15|0,1,r+16|0),(k|0)!=-2)break}if(e=-1,(k|0)!=-1)break e;if(!(f&1))break i;i[A>>2]=i[A>>2]|32,Zi(l[r+15|0],A);break i}e=i[r+28>>2]}return v=r+32|0,i[31366]=n,e}function ZQ(A,e,r,f,k,n,t,o){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,t=t|0,o=o|0;var s=0,w=0,h=0,_=0;s=v-48|0,v=s;i:{if(!e){e=i[23570],i[A>>2]=i[23569],i[A+4>>2]=e,i[A+8>>2]=i[23571];break i}h=i[i[e>>2]+116>>2],w=SA(),kA(w,n),_=i[e+8>>2],i[s>>2]=s+4,i[s+4>>2]=0,i[s+8>>2]=0,n=s+12|0,C9(n,_,h,f,k,w,1,t,o,s),Y1(s,i[s+4>>2]),x2(w),f=n;e:switch(l[s+32|0]){default:_2(),H();case 0:k=i[s+12>>2],f=i[s+16>>2],f&&(i[f+4>>2]=i[f+4>>2]+1),n=r,r=p(8),i[n>>2]=r,i[r+4>>2]=f,i[r>>2]=k,f=107664;break;case 1:break e}if(r=A,A=i[e>>2],b0(r,f,A?A+84|0:0),A=l[s+32|0],(A|0)==255)break i;e=i[24235],i[s+40>>2]=i[24234],i[s+44>>2]=e,W[i[(s+40|0)+(A<<2)>>2]](s+39|0,s+12|0)}v=s+48|0}function lt(A,e){var r=0,f=0,k=0;f=v-16|0,v=f;i:{e:{if(r=i[e>>2],!r||(r=W0(r,94368,95348),!r))break e;i[f+8>>2]=r,r=i[e+4>>2],i[f+12>>2]=r,r&&(i[r+4>>2]=i[r+4>>2]+1),W[i[i[A>>2]+12>>2]](A,f+8|0);break i}i[f+8>>2]=0,i[f+12>>2]=0}r=i[e>>2];i:{if(!r||(r=W0(r,94368,95388),!r))break i;if(e=i[e+4>>2],e){if(i[e+4>>2]=i[e+4>>2]+1,k=i[r+8>>2],i[f>>2]=i[r+4>>2],i[f+4>>2]=k,W[i[i[A>>2]+8>>2]](A,f),A=i[e+4>>2],i[e+4>>2]=A-1,A)break i;W[i[i[e>>2]+8>>2]](e),y(e);break i}e=i[r+8>>2],i[f>>2]=i[r+4>>2],i[f+4>>2]=e,W[i[i[A>>2]+8>>2]](A,f)}A=i[f+12>>2];i:{if(!A||(e=i[A+4>>2],i[A+4>>2]=e-1,e))break i;W[i[i[A>>2]+8>>2]](A),y(A)}v=f+16|0}function GQ(A,e){A=A|0,e=e|0;var r=0,f=0,k=0;r=v-32|0,v=r;i:{if((e|0)==-1){if(l[A+52|0])break i;e=i[A+48>>2],u[A+52|0]=(e|0)!=-1;break i}e:{r:{if(f=l[A+52|0],!(!(f&1)|l[A+53|0]!=1)){if(Gu(i[A+48>>2],i[A+32>>2]))break r;break e}if(!(f&1))break r;i[r+16>>2]=i[A+48>>2];f:{A:switch(f=i[A+36>>2],k=r+20|0,(W[i[i[f>>2]+12>>2]](f,i[A+40>>2],r+16|0,k,r+12|0,r+24|0,r+32|0,k)|0)-1|0){case 0:case 1:break e;case 2:break A;default:break f}f=i[A+48>>2],i[r+20>>2]=r+25,u[r+24|0]=f}for(;;){if(f=i[r+20>>2],f>>>0<=r+24>>>0)break r;if(f=f-1|0,i[r+20>>2]=f,(Zi(u[f|0],i[A+32>>2])|0)==-1)break}break e}u[A+52|0]=1,i[A+48>>2]=e;break i}e=-1}return v=r+32|0,e|0}function st(A,e,r,f,k){var n=0,t=0,o=0,s=0;t=v-16|0,v=t;i:{if(1073741815-e>>>0>=r>>>0){if(l[A+11|0]>>>7|0?n=i[A>>2]:n=A,s=n,n=t+4|0,e>>>0<536870899?(i[t+12>>2]=e<<1,i[t+4>>2]=e+r,r=v-16|0,v=r,v=r+16|0,r=t+12|0,r=i[(u0[n>>2]<u0[r>>2]?r:n)>>2],r>>>0>=2?(o=r+2&-2,r=o-1|0,r=(r|0)==2?o:r):r=1,r=r+1|0):r=1073741815,pi(n,r),r=i[t+4>>2],k)e:{if(!k||(n=k<<2,!n))break e;x(r,s,n)}if((f|0)!=(k|0)){n=k<<2,o=n+r|0,n=n+s|0,k=f-k|0;e:{if(!k||(k=k<<2,!k))break e;x(o,n,k)}}(e|0)!=1&&$8(s,4),i[A>>2]=r,i[A+8>>2]=i[A+8>>2]&-2147483648|i[t+8>>2]&2147483647,i[A+8>>2]=i[A+8>>2]|-2147483648,v=t+16|0;break i}Z4(),H()}i[A+4>>2]=f}function wt(A,e){var r=0,f=0,k=0,n=0,t=0,o=0,s=0;if(Je(),r=i[26926],(r|0)==107708)return 0;i:{if(!e){for(;;){k=i[r+16>>2],n=W[i[k+16>>2]](A)|0,e=(n|0)>(t|0),f=i[r+4>>2];e:{if(f){for(;;)if(r=f,f=i[r>>2],!f)break e}for(;f=r,r=i[r+8>>2],(f|0)!=i[r>>2];);}if(t=e?n:t,o=e?k:o,(r|0)==107708)break}break i}for(;;){e:{if(k=i[r+16>>2],n=W[i[k+16>>2]](A)|0,(n|0)<=0|i[k>>2]<3||n4(e,i[k+40>>2]))break e;return k}s=(t|0)<(n|0),f=i[r+4>>2];e:{if(f){for(;;)if(r=f,f=i[r>>2],!f)break e}for(;f=r,r=i[r+8>>2],(f|0)!=i[r>>2];);}if(t=s?n:t,o=s?k:o,(r|0)==107708)break}}return o}function XQ(A,e,r,f,k){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0;var n=0;n=v-48|0,v=n;i:{if(!(k&&e)){e=i[23570],i[A>>2]=i[23569],i[A+4>>2]=e,i[A+8>>2]=i[23571];break i}Zf(n+20|0,i[e>>2],r,f);e:{r:switch(l[n+40|0]){default:_2(),H();case 1:b0(A,n+20|0,i[e>>2]);break e;case 0:break r}if(e=i[n+20>>2],!e){i[A>>2]=5,i[A+4>>2]=2007,i[A+8>>2]=2304;break e}$r(n+8|0,e),r=i[n+12>>2],e=i[n+8>>2];r:{if((r|0)==(e|0)||(r=r-e|0,!r))break r;x(k,e,r)}if(r=i[24057],i[A>>2]=i[24056],i[A+4>>2]=r,i[A+8>>2]=i[24058],!e)break e;i[n+12>>2]=e,Z(e)}if(A=l[n+40|0],(A|0)==255)break i;e=i[24181],i[n+8>>2]=i[24180],i[n+12>>2]=e,W[i[(n+8|0)+(A<<2)>>2]](n+47|0,n+20|0)}v=n+48|0}function kA(A,e){A=A|0,e=e|0;var r=0,f=0;i:{if(!e)break i;e:{r:{f:{A:{k:{n:{t:{u:switch(r=l[e|0],f=l[A|0],(r>>>0<f>>>0?r:f)-1|0){case 0:break e;case 1:break r;case 2:break f;case 3:break A;case 4:break k;case 5:break n;case 6:break t;case 7:break u;default:break i}i[A+60>>2]=i[e+60>>2],i[A+64>>2]=i[e+64>>2],i[A+56>>2]=i[e+56>>2],i[A+52>>2]=i[e+52>>2]}i[A+48>>2]=i[e+48>>2]}i[A+44>>2]=i[e+44>>2]}r=i[e+32>>2],i[A+28>>2]=i[e+28>>2],i[A+32>>2]=r,r=i[e+40>>2],i[A+36>>2]=i[e+36>>2],i[A+40>>2]=r}i[A+24>>2]=i[e+24>>2]}u[A+21|0]=l[e+21|0]}u[A+20|0]=l[e+20|0]}u[A+1|0]=l[e+1|0],i[A+4>>2]=i[e+4>>2],i[A+8>>2]=i[e+8>>2],i[A+12>>2]=i[e+12>>2],i[A+16>>2]=i[e+16>>2]}}function WQ(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0;var k=0,n=0,t=0,o=0;f=v-16|0,v=f,n=i[r>>2],k=i[r+4>>2];i:{if(k){if(i[k+4>>2]=i[k+4>>2]+1,t=e,o=W[i[i[n>>2]+8>>2]](n)|0,i[t+112>>2]=o,i[e+116>>2]=l0,i[e+104>>2]=0,i[e+108>>2]=0,e=i[k+4>>2],i[k+4>>2]=e-1,e)break i;W[i[i[k>>2]+8>>2]](k),y(k);break i}t=e,o=W[i[i[n>>2]+8>>2]](n)|0,i[t+112>>2]=o,i[e+116>>2]=l0,i[e+104>>2]=0,i[e+108>>2]=0}i:{if(l[r+20|0]==1){if(u[f+4|0]=0,u[f+15|0]=0,q(A,2,100,f+4|0),u[f+15|0]>=0)break i;Z(i[f+4>>2]);break i}if(e=i[26917],i[A>>2]=i[26916],i[A+4>>2]=e,A=A+8|0,u[107683]>=0){e=i[26919],i[A>>2]=i[26918],i[A+4>>2]=e,i[A+8>>2]=i[26920];break i}T(A,i[26918],i[26919])}v=f+16|0}function QQ(A,e,r,f,k,n){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0;var t=0,o=0,s=0;t=v-32|0,v=t,i[t+28>>2]=e;i:{if(!(i[f+4>>2]&1)){i[t>>2]=-1,e=W[i[i[A>>2]+16>>2]](A,e,r,f,k,t)|0;e:switch(i[t>>2]){case 0:u[n|0]=0;break i;case 1:u[n|0]=1;break i;default:break e}u[n|0]=1,i[k>>2]=4;break i}for(A=i[f+28>>2],i[t>>2]=A,(A|0)!=129576&&(i[A+4>>2]=i[A+4>>2]+1),e=c0(t,129760),e2(t),A=i[f+28>>2],i[t>>2]=A,(A|0)!=129576&&(i[A+4>>2]=i[A+4>>2]+1),A=c0(t,129816),e2(t),W[i[i[A>>2]+24>>2]](t,A),W[i[i[A>>2]+28>>2]](t|12,A),f=t+24|0,o=n,s=(Wr(t+28|0,r,t,f,e,k,1)|0)==(t|0),u[o|0]=s,e=i[t+28>>2];f=s2(f-12|0),(t|0)!=(f|0););}return v=t+32|0,e|0}function gQ(A,e,r,f,k,n){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0;var t=0,o=0,s=0;t=v-32|0,v=t,i[t+28>>2]=e;i:{if(!(i[f+4>>2]&1)){i[t>>2]=-1,e=W[i[i[A>>2]+16>>2]](A,e,r,f,k,t)|0;e:switch(i[t>>2]){case 0:u[n|0]=0;break i;case 1:u[n|0]=1;break i;default:break e}u[n|0]=1,i[k>>2]=4;break i}for(A=i[f+28>>2],i[t>>2]=A,(A|0)!=129576&&(i[A+4>>2]=i[A+4>>2]+1),e=c0(t,129752),e2(t),A=i[f+28>>2],i[t>>2]=A,(A|0)!=129576&&(i[A+4>>2]=i[A+4>>2]+1),A=c0(t,129824),e2(t),W[i[i[A>>2]+24>>2]](t,A),W[i[i[A>>2]+28>>2]](t|12,A),f=t+24|0,o=n,s=(Qr(t+28|0,r,t,f,e,k,1)|0)==(t|0),u[o|0]=s,e=i[t+28>>2];f=R1(f-12|0),(t|0)!=(f|0););}return v=t+32|0,e|0}function VQ(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,t=0;f=v-32|0,v=f;i:{e:{if(l[e+124|0]==1){if(e=i[26917],i[A>>2]=i[26916],i[A+4>>2]=e,A=A+8|0,u[107683]<0)break e;e=i[26919],i[A>>2]=i[26918],i[A+4>>2]=e,i[A+8>>2]=i[26920];break i}if(t=W[i[i[e>>2]+52>>2]](e,r,0)|0,F0(r,i[e+108>>2]-i[e+104>>2]>>2),k=i[e+104>>2],n=i[e+108>>2],(k|0)!=(n|0))for(;F0(r,i[k>>2]),k=k+4|0,(n|0)!=(k|0););if(f1(f+12|0,e,r,t),u[f+31|0]<0&&Z(i[f+20>>2]),e=i[26917],i[A>>2]=i[26916],i[A+4>>2]=e,A=A+8|0,u[107683]>=0){e=i[26919],i[A>>2]=i[26918],i[A+4>>2]=e,i[A+8>>2]=i[26920];break i}T(A,i[26918],i[26919]);break i}T(A,i[26918],i[26919])}v=f+32|0}function ht(A,e){var r=0,f=0,k=0,n=0,t=0;n=e+24|0,f=i[e>>2],k=f&63,u[n+k|0]=128,r=k+1|0,t=k^63;i:{if(t>>>0>7){k=r;break i}k=0,t&&o0(r+n|0,0,t),t=64,Ar(e,n,64),f=i[e>>2]}r=t-8|0,r&&o0(k+n|0,0,r),u[e+83|0]=f>>>21,u[e+82|0]=f>>>13,u[e+81|0]=f>>>5,r=f<<3,u[e+80|0]=r,i[e>>2]=r,i[e+84>>2]=i[e+4>>2],Ar(e,n,64),u[A|0]=i[e+8>>2],u[A+1|0]=i[e+8>>2]>>>8,u[A+2|0]=C[e+10>>1],u[A+3|0]=l[e+11|0],u[A+4|0]=i[e+12>>2],u[A+5|0]=i[e+12>>2]>>>8,u[A+6|0]=C[e+14>>1],u[A+7|0]=l[e+15|0],u[A+8|0]=i[e+16>>2],u[A+9|0]=i[e+16>>2]>>>8,u[A+10|0]=C[e+18>>1],u[A+11|0]=l[e+19|0],u[A+12|0]=i[e+20>>2],u[A+13|0]=i[e+20>>2]>>>8,u[A+14|0]=C[e+22>>1],u[A+15|0]=l[e+23|0],o0(e,0,152)}function _t(A,e){var r=0,f=0,k=0,n=0,t=0,o=0,s=0,w=0;if(r=v-48|0,k=r,v=r,t=r-48|0,v=t,u[t+33|0]=0,o0(t,46,33),s=t+16|0,u[s|0]=124,r=l[A+96|0],r)for(w=A- -64|0;;){n=r,r=r-1|0,o=l[w+r|0],f=g[(r<<1)+A>>1];i:{if(!((f|0)>=-16&(f|0)<=16)){i[k+32>>2]=f,i[k+36>>2]=o?88:111,k0(e,29168,k+32|0);break i}if(f=f+s|0,o){u[f|0]=88;break i}u[f|0]=111}if(!(n>>>0>1))break}if(r=l[A+97|0],r)for(o=A+80|0,w=A+32|0;;){A=r,r=r-1|0,f=l[o+r|0],n=g[w+(r<<1)>>1];i:{if(!((n|0)>=-16&(n|0)<=16)){i[k+16>>2]=n,i[k+20>>2]=f?88:111,k0(e,29168,k+16|0);break i}if(n=n+s|0,f){u[n|0]=88;break i}u[n|0]=111}if(!(A>>>0>1))break}i[k>>2]=t,k0(e,32910,k),v=k+48|0}function FQ(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0;var k=0;f=v-32|0,v=f,z2(f,e,r),u[f+19|0]<0&&Z(i[f+8>>2]);i:{if(l[e+97|0]){t1(A,e,9813);break i}e:{if(u[e+100|0]&1){if(u[e+115|0]<0){u[i[e+104>>2]]=0,i[e+108>>2]=0;break e}u[e+115|0]=0,u[e+104|0]=0;break e}B4(f+20|0,r),u[e+115|0]<0&&Z(i[e+104>>2]),k=i[f+24>>2],i[e+104>>2]=i[f+20>>2],i[e+108>>2]=k,i[e+112>>2]=i[f+28>>2]}if(l[r+20|0]==1){if(u[f+20|0]=0,u[f+31|0]=0,q(A,2,100,f+20|0),u[f+31|0]>=0)break i;Z(i[f+20>>2]);break i}if(e=i[26917],i[A>>2]=i[26916],i[A+4>>2]=e,A=A+8|0,u[107683]>=0){e=i[26919],i[A>>2]=i[26918],i[A+4>>2]=e,i[A+8>>2]=i[26920];break i}T(A,i[26918],i[26919])}v=f+32|0}function v0(A,e){var r=0,f=0,k=0,n=0,t=0,o=0,s=0,w=0,h=0,_=0;if(k=i[A+16>>2],!((k|0)>=(e|0)|(k|0)>56)){for(f=64-k|0,k=i[A+4>>2];;){i:{if(o=f,!k){n=f;break i}if(r=i[A>>2],i[A>>2]=r+1,r=l[r|0],k=k-1|0,i[A+4>>2]=k,t=i[A+12>>2],n=o-8|0,s=n&31,h=A,(n&63)>>>0>=32?(w=r<<s,r=0):(w=(1<<s)-1&r>>>32-s,r=r<<s),i[h+8>>2]=r|i[A+8>>2],i[A+12>>2]=t|w,r=f,f=r-8|0,_=_-(r>>>0<8)|0,(o|0)>15)continue}break}k=64-n|0}return i[A+16>>2]=k-e,r=i[A+8>>2],f=A,f=A,A=i[A+12>>2],n=r,t=e&31,(e&63)>>>0>=32?(o=r<<t,n=0):(o=(1<<t)-1&n>>>32-t|A<<t,n=n<<t),i[f+8>>2]=n,i[f+12>>2]=o,f=64-e|0,e=r,r=f&31,(f&63)>>>0>=32?A=A>>>r|0:A=((1<<r)-1&A)<<32-r|e>>>r,A}function IQ(A,e,r,f,k){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0;var n=0,t=0,o=0,s=0;n=v-192|0,v=n,i[n+136>>2]=0,i[n+108>>2]=72836,t=i[18212],i[n+4>>2]=t,o=i[t-12>>2],t=n+4|0,i[o+t>>2]=i[18213],o=t+i[i[n+4>>2]-12>>2]|0,s=n+8|0,J0(o,s),u[o+80|0]=0,i[o+72>>2]=0,i[n+108>>2]=72836,i[n+4>>2]=72816,o=jt(s),p9(o,k,20)||(k=t+i[i[n+4>>2]-12>>2]|0,H1(k,i[k+16>>2]|4)),t=v-16|0,v=t,k=n+4|0,G1(t+8|0,k);i:{if(!f|!l[t+8|0]||(s=i[(k+i[i[k>>2]-12>>2]|0)+24>>2],(W[i[i[s>>2]+48>>2]](s,r,f)|0)==(f|0)))break i;m4(k+i[i[k>>2]-12>>2]|0,1)}_1(t+8|0),v=t+16|0,b0(A,107664,i[e>>2]),A=i[18211],i[n+4>>2]=A,i[k+i[A-12>>2]>>2]=i[18214],se(o),y0(n+108|0),v=n+192|0}function nA(A,e){var r=0,f=0,k=0,n=0,t=0,o=0,s=0;i:{if(k=i[A>>2],n=i[A+4>>2]-k|0,f=((n|0)/56|0)+1|0,f>>>0<76695845){if(r=(i[A+8>>2]-k|0)/56|0,k=r<<1,t=r>>>0>=38347922?76695844:f>>>0<k>>>0?k:f,t){if(t>>>0>=76695845)break i;f=p(G(t,56))}else f=0;if(k=f,s=n+k|0,te(s,e),o=i[A+4>>2],e=i[A>>2],n=G((o-e|0)/-56|0,56)+s|0,(e|0)!=(o|0)){for(f=e,r=n;te(r,f),r=r+56|0,f=f+56|0,(o|0)!=(f|0););for(;r=i[e+44>>2],r&&(i[e+48>>2]=r,Z(r)),i[e>>2]=86356,r=i[e+20>>2],r&&(i[e+24>>2]=r,Z(r)),e=e+56|0,(o|0)!=(e|0););e=i[A>>2]}return r=s+56|0,i[A+4>>2]=r,i[A>>2]=n,i[A+8>>2]=G(t,56)+k,e&&Z(e),r}G0(),H()}z0(),H()}function CQ(A,e){A=A|0,e=e|0;var r=0;if(W[i[i[A>>2]+24>>2]](A)|0,e=c0(e,129768),i[A+68>>2]=e,r=l[A+98|0],e=W[i[i[e>>2]+28>>2]](e)|0,u[A+98|0]=e,(e|0)!=(r|0)){if(i[A+16>>2]=0,i[A+12>>2]=0,i[A+8>>2]=0,i[A+28>>2]=0,i[A+20>>2]=0,i[A+24>>2]=0,e=l[A+96|0],l[A+98|0]==1){i:{if(!(e&1)||(e=i[A+32>>2],!e))break i;Z(e)}u[A+96|0]=l[A+97|0],i[A+52>>2]=i[A+60>>2],e=i[A+56>>2],i[A+56>>2]=0,i[A+60>>2]=0,i[A+32>>2]=e,u[A+97|0]=0;return}i:{if(e&1||(e=i[A+32>>2],(e|0)==(A+44|0)))break i;u[A+97|0]=0,i[A+56>>2]=e,e=i[A+52>>2],i[A+60>>2]=e,e=p(e),u[A+96|0]=1,i[A+32>>2]=e;return}e=i[A+52>>2],i[A+60>>2]=e,e=p(e),u[A+97|0]=1,i[A+56>>2]=e}}function ke(A){var e=0,r=0,f=0,k=0,n=0,t=0,o=0;o0(A+38|0,0,2064),i[A+18524>>2]=-1,i[A+18528>>2]=-1;i:{e:{if(f=i[i[A+18592>>2]+24>>2],(f|0)>0){if(t=i[A+18588>>2],e=i[t+124>>2],k=i[e+484>>2],n=i[t+132>>2],n=i[(i[n+8460>>2]+(i[i[n+8448>>2]+(f<<2)>>2]<<2)|0)-4>>2],r=i[e+16892>>2],f=(n|0)/(r|0)|0,r=(n-G(f,r)|0)+1|0,n=i[e+16876>>2],r=r<<n,k=((k|0)<(r|0)?k:r)-1|0,r=i[t+168>>2],k=k>>r,(k|0)<0||(o=i[t+172>>2],(k|0)>=(o|0)))break e;if(e=i[e+488>>2],f=f+1<<n,e=((e|0)<(f|0)?e:f)-1>>r,(e|0)<0|(e|0)>=i[t+176>>2])break i;i[A+18520>>2]=u[((i[t+160>>2]+G(k,3)|0)+G(G(e,o),3)|0)+2|0]}return}D0(4656,10893,118,4231),H()}D0(4618,10893,119,4231),H()}function pQ(A){A=A|0;var e=0,r=0,f=0,k=0,n=0,t=0;e=i[A+20>>2],k=i[e+18588>>2],i[A+4>>2]=1,i[k+324>>2]=i[k+324>>2]-1,i[k+328>>2]=i[k+328>>2]+1,r=i[e+18588>>2],n=i[r+124>>2],f=i[n+16908>>2],t=i[e+4>>2],(f|0)>(t|0)&&(f=i[i[i[r+132>>2]+8460>>2]+(t<<2)>>2]),r=i[n+16892>>2],i[e>>2]=f,n=(f|0)/(r|0)|0,i[e+12>>2]=n,i[e+8>>2]=f-G(r,n);i:{e:{r:{if(l[A+8|0]==1){if(af(e))break r;break e}if(f=i[e+18592>>2],r=i[f+804>>2],r>>>0>=3)break i;ji(e+18572|0,r,i[f+800>>2]),u[e+18580|0]=0,u[e+18581|0]=0,u[e+18582|0]=0,u[e+18583|0]=0}Ze(e+18548|0),fr(e,0,l[A+8|0])}i[A+4>>2]=3,A=i[e+18600>>2],i[A+44>>2]=i[A+44>>2]+1,h3(k);return}D0(21669,18297,1520,5105),H()}function yQ(A,e,r,f,k,n,t,o,s){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,t=t|0,o=o|0,s=s|0;var w=0;i:{if(w=W[i[i[e>>2]+68>>2]](i[e+4>>2])|0,e=i[w>>2],!e)break i;for(;;){if(n4(i[e+4>>2],r)){if(e=i[w+4>>2],w=w+4|0,e)continue;break i}break}if(i[e+8>>2]!=1){e=i[24203],i[A>>2]=i[24202],i[A+4>>2]=e,i[A+8>>2]=i[24204];return}e:{if(!l[e+16|0]||(n&&(i[n>>2]=i[e+20>>2]),!t))break e;i[t>>2]=i[e+24>>2]}f&&(i[f>>2]=l[e+16|0]),k&&(i[k>>2]=l[e+16|0]),!s|i[e+32>>2]<=0||(i[s>>2]=i[e+28>>2]),o&&(i[o>>2]=i[e+32>>2]),e=i[24057],i[A>>2]=i[24056],i[A+4>>2]=e,i[A+8>>2]=i[24058];return}e=i[24203],i[A>>2]=i[24202],i[A+4>>2]=e,i[A+8>>2]=i[24204]}function EQ(A,e){A=A|0,e=e|0;var r=0,f=0,k=0,n=0,t=0,o=0;r=v-32|0,v=r;i:{e:{r:{if((e|0)==-1)break r;if(f=e<<24>>24,u[r+23|0]=f,l[A+44|0]==1){if(k=i[A+32>>2],A=v-16|0,v=A,u[A+15|0]=f,f=P1(A+15|0,1,1,k),v=A+16|0,(f|0)!=1)break e;break r}for(n=r+24|0,i[r+16>>2]=n,o=r+32|0,f=r+23|0;;){if(k=i[A+36>>2],k=W[i[i[k>>2]+12>>2]](k,i[A+40>>2],f,n,r+12|0,r+24|0,o,r+16|0)|0,i[r+12>>2]==(f|0))break e;if((k|0)==3){if((P1(f,1,1,i[A+32>>2])|0)==1)break r;break e}if(k>>>0>1||(t=r+24|0,f=i[r+16>>2]-t|0,(P1(t,1,f,i[A+32>>2])|0)!=(f|0)))break e;if(f=i[r+12>>2],(k|0)!=1)break}}A=(e|0)!=-1?e:0;break i}A=-1}return v=r+32|0,A|0}function YQ(A,e,r,f,k,n,t){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,t=t|0;var o=0,s=0,w=0,h=0,_=0,B=0,m=0,X=0;if(!((n|0)<=0|(k|0)<=0))for(t=k-1|0,B=t&4,m=(t>>>2|0)+1&2147483646,X=k>>>0<5;;){if(k=G(f,h)+r|0,t=(G(e,h)<<1)+A|0,o=0,!X)for(;s=l[k|0],w=l[k+1|0],_=l[k+2|0],g[t+6>>1]=l[k+3|0]<<6,g[t+4>>1]=_<<6,g[t+2>>1]=w<<6,g[t>>1]=s<<6,s=l[k+4|0],w=l[k+5|0],_=l[k+6|0],g[t+14>>1]=l[k+7|0]<<6,g[t+12>>1]=_<<6,g[t+10>>1]=w<<6,g[t+8>>1]=s<<6,k=k+8|0,t=t+16|0,o=o+2|0,(m|0)!=(o|0););if(B||(o=l[k|0],s=l[k+1|0],w=l[k+2|0],g[t+6>>1]=l[k+3|0]<<6,g[t+4>>1]=w<<6,g[t+2>>1]=s<<6,g[t>>1]=o<<6),h=h+1|0,(h|0)==(n|0))break}}function RQ(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,t=0,o=0;k=v-32|0,v=k,n=W[i[i[e>>2]+52>>2]](e,r,0)|0,Z1(r,l[e+97|0]?4:2,i[e+40>>2]-i[e+36>>2]>>3,0),f=i[e+36>>2],t=i[e+40>>2];i:{if((f|0)!=(t|0))for(;;){if(o=i[f>>2],W[i[i[o>>2]+20>>2]](A,o,r),i[A>>2])break i;if(u[A+19|0]<0&&Z(i[A+8>>2]),f=f+8|0,(t|0)==(f|0))break}if(f=i[26917],i[A>>2]=i[26916],i[A+4>>2]=f,A=A+8|0,u[107683]>=0){f=i[26919],i[A>>2]=i[26918],i[A+4>>2]=f,i[A+8>>2]=i[26920];break i}T(A,i[26918],i[26919])}i[r+12>>2]=n,W[i[i[e>>2]+56>>2]](k+12|0,e,r,i[r+4>>2]-(i[r>>2]+n|0)|0,0),i[r+12>>2]=i[r+4>>2]-i[r>>2],u[k+31|0]<0&&Z(i[k+20>>2]),v=k+32|0}function JQ(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,t=0,o=0,s=0;k=v-32|0,v=k,s=W[i[i[e>>2]+52>>2]](e,r,0)|0,u[e+100|0]&1&&(F0(r,i[e+104>>2]),F0(r,i[e+108>>2])),l2(r,l[e+112|0]);i:{e:{if(!l[e+112|0]){for(t=i[e+120>>2],f=i[e+124>>2]-t|0;;){if(o=f,n=0,!f)break e;if(f=f-1|0,!!l[t+f|0])break}for(F0(r,o),f=0;l2(r,l[i[e+120>>2]+f|0]),f=f+1|0,o>>>0>f>>>0;);break i}n=i[e+116>>2]}F0(r,n)}f1(k+12|0,e,r,s),u[k+31|0]<0&&Z(i[k+20>>2]),e=i[26917],i[A>>2]=i[26916],i[A+4>>2]=e,e=A+8|0;i:{if(u[107683]>=0){A=i[26919],i[e>>2]=i[26918],i[e+4>>2]=A,i[e+8>>2]=i[26920];break i}T(e,i[26918],i[26919])}v=k+32|0}function NQ(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,t=0,o=0,s=0;k=v-32|0,v=k,v9(A,e);i:{if(i[A>>2])break i;if(u[A+19|0]<0&&Z(i[A+8>>2]),s=W[i[i[e>>2]+52>>2]](e,r,0)|0,f=i[e+100>>2],t=i[e+104>>2],(f|0)!=(t|0))for(;;){if(F0(r,(i[f+8>>2]-i[f+4>>2]|0)+8|0),F0(r,i[f>>2]),n=i[f+4>>2],o=i[f+8>>2],(n|0)!=(o|0))for(;F0(r,i[n>>2]),n=n+4|0,(o|0)!=(n|0););if(f=f+16|0,(t|0)==(f|0))break}if(f1(k+12|0,e,r,s),u[k+31|0]<0&&Z(i[k+20>>2]),e=i[26917],i[A>>2]=i[26916],i[A+4>>2]=e,A=A+8|0,u[107683]>=0){e=i[26919],i[A>>2]=i[26918],i[A+4>>2]=e,i[A+8>>2]=i[26920];break i}T(A,i[26918],i[26919])}v=k+32|0}function UQ(A,e,r,f,k,n,t){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,t=t|0;var o=0,s=0,w=0;o=v-48|0,v=o,s=i[e>>2],w=i[s+48>>2],s=i[s+52>>2];i:{if(!s){Yn(o+12|0,w,r,f,k,n);break i}if(i[s+4>>2]=i[s+4>>2]+1,Yn(o+12|0,w,r,f,k,n),r=i[s+4>>2],i[s+4>>2]=r-1,r)break i;W[i[i[s>>2]+8>>2]](s),y(s)}i:{e:{r:{if(r=l[o+32|0],!(r|!t)){i[t>>2]=i[o+12>>2];break r}f:switch(r|0){default:_2(),H();case 0:break r;case 1:break f}if(b0(A,o+12|0,i[e>>2]),A=l[o+32|0],(A|0)==255)break i;break e}e=i[24057],i[A>>2]=i[24056],i[A+4>>2]=e,i[A+8>>2]=i[24058],A=0}e=i[24187],i[o+40>>2]=i[24186],i[o+44>>2]=e,W[i[(o+40|0)+(A<<2)>>2]](o+39|0,o+12|0)}v=o+48|0}function DQ(A,e){A=A|0,e=e|0;var r=0,f=0,k=0,n=0;if(!e){e=i[23570],i[A>>2]=i[23569],i[A+4>>2]=e,i[A+8>>2]=i[23571];return}if(i[e>>2]>=5){e=i[24155],i[A>>2]=i[24154],i[A+4>>2]=e,i[A+8>>2]=i[24156];return}r=i[e+28>>2],r&&W[r|0](),r=p(4),i[r>>2]=e,f=p(20),i[f+16>>2]=r,r=i[26930];i:{if(!r){e=107720,k=107720;break i}for(n=i[e+12>>2];;){if(e=r,i[i[i[e+16>>2]>>2]+12>>2]<(n|0)){if(k=e,r=i[e>>2],r)continue;break i}if(r=i[e+4>>2],!r)break}k=e+4|0}i[f+8>>2]=e,i[f>>2]=0,i[f+4>>2]=0,i[k>>2]=f,e=i[i[26929]>>2],e&&(i[26929]=e),m1(i[26930],f),i[26931]=i[26931]+1,i[A+8>>2]=i[24058],e=i[24057],i[A>>2]=i[24056],i[A+4>>2]=e}function Bt(A,e,r){var f=0,k=0,n=0,t=0,o=0,s=0;f=j0(i[r>>2],0),k=i[i[r>>2]+120>>2],n=(f|0)<11,t=n&&(k|0)==3?1:2,s=n?k>>>0>=2?t:0:t,n=o8(i[r>>2],0),r=l8(i[r>>2],0),t=G(n,r);i:{if(!((n|0)>8192|(r|0)>4352)&&(o=13,(t|0)<8912897))break i;o=(n|0)>=16385||(r|0)>=8705?31:(t|0)<35651585?17:31}if(u[e+2|0]=o,u[e+1|0]=s,u[e+6|0]=!k,u[e+5|0]=f>>>0>11,u[e+4|0]=f>>>0>8,r=k<<3,f=k>>>0<4,u[e+7|0]=((f?16908801>>>r|0:0)&3)>>>1,u[e+9|0]=(k|0)!=1?2:0,u[e+8|0]=((f?16843265>>>r|0:0)&3)>>>1,e=i[26917],i[A>>2]=i[26916],i[A+4>>2]=e,A=A+8|0,u[107683]>=0){e=i[26919],i[A>>2]=i[26918],i[A+4>>2]=e,i[A+8>>2]=i[26920];return}T(A,i[26918],i[26919])}function vt(A){var e=0;e=p(176),i[e+24>>2]=0,i[e+28>>2]=0,i[e+4>>2]=0,i[e+8>>2]=0,i[e+72>>2]=-1,i[e+76>>2]=-1,i[e+116>>2]=0,i[e+88>>2]=0,i[e+92>>2]=0,i[e+120>>2]=0,i[e+124>>2]=0,i[e>>2]=91524,i[e+32>>2]=0,i[e+36>>2]=0,i[e+40>>2]=0,i[e+44>>2]=0,i[e+48>>2]=0,i[e+52>>2]=0,i[e+56>>2]=0,i[e+60>>2]=0,i[e- -64>>2]=0,i[e+80>>2]=-1,i[e+84>>2]=-1,i[e+96>>2]=0,i[e+100>>2]=0,i[e+104>>2]=0,i[e+108>>2]=0,g[e+112>>1]=0,i[e+16>>2]=89136,i[e+128>>2]=0,i[e+132>>2]=0,i[e+136>>2]=0,i[e+140>>2]=0,u[e+144|0]=0,i[e+168>>2]=0,i[e+172>>2]=0,i[e+160>>2]=0,i[e+164>>2]=0,i[e+152>>2]=0,i[e+156>>2]=0,i[e+32>>2]=1668114798,i[A+4>>2]=e,i[A>>2]=e+16}function MQ(A,e){A=A|0,e=e|0;var r=0,f=0,k=0,n=0,t=0,o=0;r=v-32|0,v=r;i:{e:{r:{if((e|0)==-1)break r;if(i[r+20>>2]=e,l[A+44|0]==1){A=i[A+32>>2];f:{if(i[A+76>>2]<0){A=$n(e,A);break f}A=$n(e,A)}if((A|0)==-1)break e;break r}for(n=r+24|0,i[r+16>>2]=n,o=r+32|0,f=r+20|0;;){if(k=i[A+36>>2],k=W[i[i[k>>2]+12>>2]](k,i[A+40>>2],f,n,r+12|0,r+24|0,o,r+16|0)|0,i[r+12>>2]==(f|0))break e;if((k|0)==3){if((P1(f,1,1,i[A+32>>2])|0)==1)break r;break e}if(k>>>0>1||(t=r+24|0,f=i[r+16>>2]-t|0,(P1(t,1,f,i[A+32>>2])|0)!=(f|0)))break e;if(f=i[r+12>>2],(k|0)!=1)break}}A=(e|0)!=-1?e:0;break i}A=-1}return v=r+32|0,A|0}function HQ(A,e,r,f,k,n){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0;var t=0,o=0;f=v-16|0,v=f;i:{if(!(l[n+11|0]>>>7|0)){i[A+8>>2]=i[n+8>>2],e=i[n+4>>2],i[A>>2]=i[n>>2],i[A+4>>2]=e;break i}r=i[n>>2],k=v-16|0,v=k;e:{r:{n=i[n+4>>2];f:{if(n>>>0<2){e=A,u[A+11|0]=l[A+11|0]&128|n&127,u[A+11|0]=l[A+11|0]&127;break f}if(n>>>0>1073741815)break r;o=k+8|0,n>>>0>=2?(t=n+2&-2,e=t-1|0,e=(e|0)==2?t:e):e=1,pi(o,e+1|0),e=i[k+8>>2],i[A>>2]=e,i[A+8>>2]=i[A+8>>2]&-2147483648|i[k+12>>2]&2147483647,i[A+8>>2]=i[A+8>>2]|-2147483648,i[A+4>>2]=n}A=n+1|0;f:{if(!A||(A=A<<2,!A))break f;x(e,r,A)}v=k+16|0;break e}Z4(),H()}}v=f+16|0}function mt(A,e,r){var f=0,k=0;if(!e)return 0;i:{e:{if(!r)break e;if(f=l[e|0],k=f<<24>>24,(k|0)>=0)return A&&(i[A>>2]=f),(k|0)!=0;if(!i[i[31366]>>2]){if(e=1,!A)break i;return i[A>>2]=k&57343,1}if(f=f-194|0,f>>>0>50||(f=i[(f<<2)+73184>>2],r>>>0<=3&&f<<G(r,6)-6<0)||(r=l[e+1|0],k=r>>>3|0,(k-16|k+(f>>26))>>>0>7))break e;if(r=r-128|f<<6,(r|0)>=0){if(e=2,!A)break i;return i[A>>2]=r,2}if(f=l[e+2|0]-128|0,f>>>0>63)break e;if(k=f,f=r<<6,r=k|f,(f|0)>=0){if(e=3,!A)break i;return i[A>>2]=r,3}if(f=l[e+3|0]-128|0,f>>>0>63)break e;if(e=4,!A)break i;return i[A>>2]=f|r<<6,4}i[31324]=25,e=-1}return e}function Zt(A,e,r,f,k,n,t,o,s,w){var h=0,_=0,B=0;h=v-16|0,v=h;i:{if(A){A=c0(r,129512);break i}A=c0(r,129504)}i:{if(e){e=h+4|0,W[i[i[A>>2]+44>>2]](e,A),r=i[h+4>>2],u[f|0]=r,u[f+1|0]=r>>>8,u[f+2|0]=r>>>16,u[f+3|0]=r>>>24,W[i[i[A>>2]+32>>2]](e,A);break i}e=h+4|0,W[i[i[A>>2]+40>>2]](e,A),r=i[h+4>>2],u[f|0]=r,u[f+1|0]=r>>>8,u[f+2|0]=r>>>16,u[f+3|0]=r>>>24,W[i[i[A>>2]+28>>2]](e,A)}me(s,e),R1(e),_=k,B=W[i[i[A>>2]+12>>2]](A)|0,i[_>>2]=B,_=n,B=W[i[i[A>>2]+16>>2]](A)|0,i[_>>2]=B,e=h+4|0,W[i[i[A>>2]+20>>2]](e,A),K8(t,e),s2(e),W[i[i[A>>2]+24>>2]](e,A),me(o,e),R1(e),_=w,B=W[i[i[A>>2]+36>>2]](A)|0,i[_>>2]=B,v=h+16|0}function Y4(A){var e=0,r=0,f=0,k=0,n=0,t=0,o=0,s=0;e=v-16|0,v=e;i:{if(!f4(A,8))break i;k=i[A>>2],r=i[A+4>>2],r&&(i[r+4>>2]=i[r+4>>2]+1);e:{if(!(W[i[i[k>>2]+16>>2]](k,e+8|0,8)|0)){i8(A),k=0;break e}A=0,f=l[e+8|0]|l[e+9|0]<<8|(l[e+10|0]<<16|l[e+11|0]<<24),o=f<<24|(f&65280)<<8,n=f&16711680,k=n>>>8|0,n=n<<24,t=A,s=n,A=f&-16777216,n=A>>>24|0,t=t|(s|A<<8),A=l[e+12|0]|l[e+13|0]<<8|(l[e+14|0]<<16|l[e+15|0]<<24),f=t|(((A&255)<<24|f>>>8)&-16777216|((A&16777215)<<8|f>>>24)&16711680|(A>>>8&65280|A>>>24)),k=o|(k|n)}if(!r||(A=i[r+4>>2],i[r+4>>2]=A-1,A))break i;W[i[i[r>>2]+8>>2]](r),y(r)}return v=e+16|0,l0=k,f}function Gt(A,e,r,f,k,n,t,o,s,w){var h=0,_=0,B=0;h=v-16|0,v=h;i:{if(A){A=c0(r,129496);break i}A=c0(r,129488)}i:{if(e){e=h+4|0,W[i[i[A>>2]+44>>2]](e,A),r=i[h+4>>2],u[f|0]=r,u[f+1|0]=r>>>8,u[f+2|0]=r>>>16,u[f+3|0]=r>>>24,W[i[i[A>>2]+32>>2]](e,A);break i}e=h+4|0,W[i[i[A>>2]+40>>2]](e,A),r=i[h+4>>2],u[f|0]=r,u[f+1|0]=r>>>8,u[f+2|0]=r>>>16,u[f+3|0]=r>>>24,W[i[i[A>>2]+28>>2]](e,A)}K8(s,e),s2(e),_=k,B=W[i[i[A>>2]+12>>2]](A)|0,u[_|0]=B,_=n,B=W[i[i[A>>2]+16>>2]](A)|0,u[_|0]=B,e=h+4|0,W[i[i[A>>2]+20>>2]](e,A),K8(t,e),s2(e),W[i[i[A>>2]+24>>2]](e,A),K8(o,e),s2(e),_=w,B=W[i[i[A>>2]+36>>2]](A)|0,i[_>>2]=B,v=h+16|0}function tA(A,e,r,f,k){var n=0,t=0,o=0,s=0,w=0;t=v-16|0,v=t;i:{if(2147483639-e>>>0>=r>>>0){l[A+11|0]>>>7|0?n=i[A>>2]:n=A,s=n,n=t+4|0,e>>>0<1073741811?(i[t+12>>2]=e<<1,i[t+4>>2]=e+r,r=v-16|0,v=r,v=r+16|0,r=t+12|0,r=i[(u0[n>>2]<u0[r>>2]?r:n)>>2],r>>>0>=11?(o=r+8&-8,r=o-1|0,r=(r|0)==11?o:r):r=10,r=r+1|0):r=2147483639,Ci(n,r),r=i[t+4>>2],k&&(n=!k,n|n||x(r,s,k)),(f|0)!=(k|0)&&(n=r+k|0,o=k+s|0,k=f-k|0,w=!k,w|w||x(n,o,k)),(e|0)!=10&&$8(s,1),i[A>>2]=r,i[A+8>>2]=i[A+8>>2]&-2147483648|i[t+8>>2]&2147483647,i[A+8>>2]=i[A+8>>2]|-2147483648,v=t+16|0;break i}Z4(),H()}i[A+4>>2]=f}function zQ(A,e,r,f,k,n,t){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,t=t|0;var o=0;i:{if(!(!k|(!r|!f))&&n)break i;e=i[23570],i[A>>2]=i[23569],i[A+4>>2]=e,i[A+8>>2]=i[23571];return}i:{if(o=i[e+16>>2],!o||(o=W0(o,94756,95960),!o))break i;e=i[e+20>>2],e&&(i[e+4>>2]=i[e+4>>2]+1),i[r>>2]=i[o+4>>2],i[f>>2]=i[o+8>>2],i[k>>2]=i[o+12>>2],i[n>>2]=i[o+16>>2],r=i[o+20>>2],f=i[o+24>>2]-r|0,f&&x(t,r,f),i[A+8>>2]=i[24058],r=i[24057],i[A>>2]=i[24056],i[A+4>>2]=r;e:{if(!e||(A=i[e+4>>2],i[e+4>>2]=A-1,A))break e;W[i[i[e>>2]+8>>2]](e),y(e)}return}e=i[24170],i[A>>2]=i[24169],i[A+4>>2]=e,i[A+8>>2]=i[24171]}function xQ(A,e,r,f,k){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0;var n=0,t=0,o=0;n=v-48|0,v=n;i:{e:{if(t=i[e>>2],!t||(o=W0(t,106564,106696),!o))break e;t=i[e+4>>2],t&&(i[t+4>>2]=i[t+4>>2]+1),i[n+20>>2]=i[r>>2],r=i[r+4>>2],i[n+24>>2]=r,r&&(i[r+4>>2]=i[r+4>>2]+1),r=i[n+24>>2],i[n+8>>2]=i[n+20>>2],i[n+12>>2]=r,r=n+28|0,N7(r,o,n+8|0,f,k,1);r:{if(i[n+28>>2]){b0(A,r,i[e+8>>2]);break r}e=i[24164],i[A>>2]=i[24163],i[A+4>>2]=e,i[A+8>>2]=i[24165]}if(u[n+47|0]<0&&Z(i[n+36>>2]),!t||(A=i[t+4>>2],i[t+4>>2]=A-1,A))break i;W[i[i[t>>2]+8>>2]](t),y(t);break i}i[A>>2]=5,i[A+4>>2]=2006,i[A+8>>2]=24655}v=n+48|0}function TQ(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,t=0,o=0,s=0;if(k=v-32|0,v=k,o=W[i[i[e>>2]+52>>2]](e,r,0)|0,u[e+100|0]&1&&(F0(r,i[e+104>>2]),F0(r,i[e+108>>2])),F0(r,i[e+132>>2]-i[e+128>>2]>>3),i[e+120>>2]=i[r+12>>2],i[e+124>>2]=0,f=i[e+128>>2],n=i[e+132>>2],(f|0)!=(n|0))for(;;){t=i[f>>2],s=i[f+4>>2];i:{if(l[e+112|0]==1){e4(r,t,s);break i}F0(r,t)}if(f=f+8|0,(n|0)==(f|0))break}f1(k+12|0,e,r,o),u[k+31|0]<0&&Z(i[k+20>>2]),e=i[26917],i[A>>2]=i[26916],i[A+4>>2]=e,A=A+8|0;i:{if(u[107683]>=0){e=i[26919],i[A>>2]=i[26918],i[A+4>>2]=e,i[A+8>>2]=i[26920];break i}T(A,i[26918],i[26919])}v=k+32|0}function Q8(A,e,r,f,k){var n=0,t=0,o=0;o=v-16|0,v=o,i[o+12>>2]=e,e=0,n=6;i:{e:{if(K2(A,o+12|0))break e;n=i[A>>2],t=i[n+12>>2];r:{if((t|0)==i[n+16>>2]){t=W[i[i[n>>2]+36>>2]](n)|0;break r}t=i[t>>2]}if(n=4,!(W[i[i[f>>2]+12>>2]](f,64,t)|0))break e;for(e=W[i[i[f>>2]+52>>2]](f,t,0)|0;;){r:{if(a1(A),e=e-48|0,K2(A,o+12|0)|(k|0)<2)break r;n=i[A>>2],t=i[n+12>>2];f:{if((t|0)==i[n+16>>2]){n=W[i[i[n>>2]+36>>2]](n)|0;break f}n=i[t>>2]}if(!(W[i[i[f>>2]+12>>2]](f,64,n)|0))break i;k=k-1|0,e=(W[i[i[f>>2]+52>>2]](f,n,0)|0)+G(e,10)|0;continue}break}if(!K2(A,o+12|0))break i;n=2}i[r>>2]=n|i[r>>2]}return v=o+16|0,e}function ne(A,e,r,f){var k=0,n=0,t=0,o=0;t=f||128088,f=i[t>>2];i:{e:{r:{if(!e){if(f)break r;return 0}if(k=-2,!r)break e;f:{if(f){k=r;break f}if(f=l[e|0],n=f<<24>>24,(n|0)>=0)return A&&(i[A>>2]=f),(n|0)!=0;if(!i[i[31366]>>2]){if(k=1,!A)break e;return i[A>>2]=n&57343,1}if(f=f-194|0,f>>>0>50)break r;if(f=i[(f<<2)+73184>>2],k=r-1|0,!k)break i;e=e+1|0}if(n=l[e|0],o=n>>>3|0,(o-16|(f>>26)+o)>>>0>7)break r;for(;;){if(k=k-1|0,f=(n&255)-128|f<<6,(f|0)>=0)return i[t>>2]=0,A&&(i[A>>2]=f),r-k|0;if(!k)break i;if(e=e+1|0,n=u[e|0],!((n|0)<-64))break}}i[t>>2]=0,i[31324]=25,k=-1}return k}return i[t>>2]=f,-2}function SQ(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0;f=v-48|0,v=f,n=W[i[i[e>>2]+52>>2]](e,r,0)|0,k=i[e+100>>2],F0(r,W[i[i[k>>2]+8>>2]](k)|0),k=i[e+100>>2],W[i[i[k>>2]+16>>2]](f+24|0,k,r);i:{if(i[f+24>>2]){e=i[f+28>>2],i[A>>2]=i[f+24>>2],i[A+4>>2]=e,i[A+16>>2]=i[f+40>>2],e=i[f+36>>2],i[A+8>>2]=i[f+32>>2],i[A+12>>2]=e,i[f+40>>2]=0,i[f+32>>2]=0,i[f+36>>2]=0;break i}if(f1(f+4|0,e,r,n),u[f+23|0]<0&&Z(i[f+12>>2]),e=i[26917],i[A>>2]=i[26916],i[A+4>>2]=e,A=A+8|0,u[107683]>=0){e=i[26919],i[A>>2]=i[26918],i[A+4>>2]=e,i[A+8>>2]=i[26920];break i}T(A,i[26918],i[26919])}u[f+43|0]<0&&Z(i[f+32>>2]),v=f+48|0}function uA(A){var e=0,r=0,f=0;if(lA(A),e=i[A+320>>2],e){if(f=e-4|0,r=i[f>>2],r)for(r=e+G(r,76)|0;r=r-76|0,(e|0)!=(r|0););Z(f)}Z(i[A+260>>2]),Z(i[A+240>>2]),Z(i[A+220>>2]),Z(i[A+200>>2]),Z(i[A+180>>2]),Z(i[A+160>>2]),Z(i[A+140>>2]),e=i[A+136>>2];i:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break i;W[i[i[e>>2]+8>>2]](e),y(e)}e=i[A+128>>2];i:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break i;W[i[i[e>>2]+8>>2]](e),y(e)}e=i[A+120>>2];i:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break i;W[i[i[e>>2]+8>>2]](e),y(e)}return e=i[A+52>>2],e&&(i[A+56>>2]=e,Z(e)),A}function Xt(A,e,r,f){var k=0,n=0,t=0;if(n=i[A+8>>2],k=i[A>>2],(n-k|0)/48>>>0>=f>>>0){if(t=f,n=i[A+4>>2],f=n-k|0,t>>>0>(f|0)/48>>>0){(k|0)!=(n|0)&&(f&&x(k,e,f),n=i[A+4>>2]),f=e+f|0,e=r-f|0,!e|(r|0)==(f|0)||x(n,f,e),i[A+4>>2]=e+n;return}f=r-e|0,!f|(e|0)==(r|0)||x(k,e,f),i[A+4>>2]=f+k;return}k&&(i[A+4>>2]=k,Z(k),i[A+8>>2]=0,i[A>>2]=0,i[A+4>>2]=0,n=0);i:{if(f>>>0>=89478486||(k=(n|0)/48|0,n=k<<1,f=k>>>0>=44739242?89478485:f>>>0<n>>>0?n:f,f>>>0>=89478486))break i;k=G(f,48),f=p(k),i[A+4>>2]=f,i[A>>2]=f,i[A+8>>2]=f+k,k=r-e|0,!k|(e|0)==(r|0)||x(f,e,k),i[A+4>>2]=f+k;return}G0(),H()}function jQ(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0;var k=0,n=0,t=0;k=v-48|0,v=k,F6(k+24|0,i[e+100>>2],i[e+116>>2],k+44|0);i:{if(i[k+24>>2]){e=i[k+28>>2],i[A>>2]=i[k+24>>2],i[A+4>>2]=e,i[A+16>>2]=i[k+40>>2],e=i[k+36>>2],i[A+8>>2]=i[k+32>>2],i[A+12>>2]=e,i[k+40>>2]=0,i[k+32>>2]=0,i[k+36>>2]=0;break i}t=k+12|0,r4(t,i[e+100>>2],i[k+44>>2],1),e=i[k+16>>2],n=i[k+12>>2];e:{if(!n){if(u[k+12|0]=0,u[k+23|0]=0,q(A,2,2e3,t),u[k+23|0]>=0)break e;Z(i[k+12>>2]);break e}W[i[i[n>>2]+76>>2]](A,n,r,f)}if(!e||(A=i[e+4>>2],i[e+4>>2]=A-1,A))break i;W[i[i[e>>2]+8>>2]](e),y(e)}u[k+43|0]<0&&Z(i[k+32>>2]),v=k+48|0}function ni(A,e){var r=0,f=0,k=0;f=v-48|0,v=f,l[108637]==1&&(i[f+36>>2]=e,i[f+32>>2]=A,E8(33162,f+32|0)),r=i[e+4>>2];i:{if(!r){if(l[108637]==1&&(i[f+4>>2]=i[A+4>>2],i[f>>2]=A,E8(33122,f)),e=i[A+4>>2],!e)break i;r=i[e>>2]-1|0,i[e>>2]=r;e:{if(r||(r=i[A>>2],r&&(Z(r),e=i[A+4>>2],!e)))break e;Z(e)}i[A>>2]=0,i[A+4>>2]=0;break i}if(i[r>>2]=i[r>>2]+1,l[108637]==1&&(i[f+20>>2]=i[A+4>>2],i[f+16>>2]=A,E8(33122,f+16|0)),r=i[A+4>>2],r){k=i[r>>2]-1|0,i[r>>2]=k;e:{if(k||(k=i[A>>2],k&&(Z(k),r=i[A+4>>2],!r)))break e;Z(r)}i[A>>2]=0,i[A+4>>2]=0}i[A>>2]=i[e>>2],i[A+4>>2]=i[e+4>>2]}v=f+48|0}function OQ(A,e,r,f,k,n){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,e=v-32|0,v=e,f=i[r+4>>2];i:{if(!(!l[k+12|0]|((f|0)==3|i[k+8>>2]==1))){i[A+8>>2]=0,i[A>>2]=0,i[A+4>>2]=0;break i}if(!(!i[r>>2]&f-1>>>0<=2)){i[A+8>>2]=0,i[A>>2]=0,i[A+4>>2]=0;break i}e:switch(C[r+20>>1]-11|0){case 0:case 3:i[A+8>>2]=0,i[A>>2]=0,i[A+4>>2]=0;break i;default:break e}if(f=i[r+12>>2],(f|0)>=9){i[A+8>>2]=0,i[A>>2]=0,i[A+4>>2]=0;break i}if(i[A+8>>2]=0,i[A>>2]=0,i[A+4>>2]=0,(f|0)!=8)break i;u[e+30|0]=1,g[e+28>>1]=2,i[e+24>>2]=131074,i[e+8>>2]=1,i[e+12>>2]=3,r=l[r+8|0],i[e+20>>2]=8,u[e+16|0]=r,i[e+4>>2]=11,S8(A,e+8|0,e+4|0)}v=e+32|0}function PQ(A,e,r,f,k,n){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,e=v-32|0,v=e,f=i[r+4>>2];i:{if(!(!l[k+12|0]|((f|0)==3|i[k+8>>2]==1))){i[A+8>>2]=0,i[A>>2]=0,i[A+4>>2]=0;break i}if(!(!i[r>>2]&f-1>>>0<=2)){i[A+8>>2]=0,i[A>>2]=0,i[A+4>>2]=0;break i}e:switch(C[r+20>>1]-11|0){case 0:case 3:i[A+8>>2]=0,i[A>>2]=0,i[A+4>>2]=0;break i;default:break e}if(f=i[r+12>>2],(f|0)<=8){i[A+8>>2]=0,i[A>>2]=0,i[A+4>>2]=0;break i}if(i[A+8>>2]=0,i[A>>2]=0,i[A+4>>2]=0,f>>>0>14)break i;u[e+30|0]=1,g[e+28>>1]=2,i[e+24>>2]=131074,i[e+8>>2]=1,i[e+12>>2]=3,r=l[r+8|0],i[e+20>>2]=f,u[e+16|0]=r,i[e+4>>2]=11,S8(A,e+8|0,e+4|0)}v=e+32|0}function LQ(A,e,r,f,k,n){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0;var t=0,o=0,s=0;t=v-48|0,v=t,o=i[e>>2],s=i[o+48>>2],o=i[o+52>>2];i:{if(!o){Rn(t+12|0,s,r,f,k);break i}if(i[o+4>>2]=i[o+4>>2]+1,Rn(t+12|0,s,r,f,k),r=i[o+4>>2],i[o+4>>2]=r-1,r)break i;W[i[i[o>>2]+8>>2]](o),y(o)}i:{e:{r:{if(r=l[t+32|0],!(r|!n)){i[n>>2]=1;break r}f:switch(r|0){default:_2(),H();case 0:break r;case 1:break f}if(b0(A,t+12|0,i[e>>2]),A=l[t+32|0],(A|0)==255)break i;break e}e=i[24057],i[A>>2]=i[24056],i[A+4>>2]=e,i[A+8>>2]=i[24058],A=0}e=i[24187],i[t+40>>2]=i[24186],i[t+44>>2]=e,W[i[(t+40|0)+(A<<2)>>2]](t+39|0,t+12|0)}v=t+48|0}function p6(A,e,r,f,k,n,t,o){var s=0,w=0,h=0,_=0;h=1,s=f&2147483647,w=s,_=(s|0)==2147418112;i:{if((_&!r?A|e:_&(r|0)!=0|s>>>0>2147418112)||(s=o&2147483647,!t&(s|0)==2147418112?k|n:(s|0)==2147418112&(t|0)!=0|s>>>0>2147418112))break i;if(!(A|k|(r|t)|(e|n|(s|w))))return 0;if(s=f&o,(s|0)>0?w=1:w=(s|0)>=0,w)return((r|0)==(t|0)&(f|0)==(o|0)?(e|0)==(n|0)&A>>>0<k>>>0|e>>>0<n>>>0:r>>>0<t>>>0&(f|0)<=(o|0)|(f|0)<(o|0))?-1:(A^k|r^t|(e^n|f^o))!=0;if((r|0)==(t|0)&(f|0)==(o|0)?(e|0)==(n|0)&A>>>0>k>>>0|e>>>0>n>>>0:r>>>0>t>>>0&(f|0)>=(o|0)|(f|0)>(o|0))return-1;h=(A^k|r^t|(e^n|f^o))!=0}return h}function KQ(A,e,r,f,k,n,t,o,s,w){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,t=t|0,o=o|0,s=s|0,w=w|0;var h=0,_=0,B=0,m=0,X=0,Q=0,V=0,F=0;if((s|0)>0){if(!((n|0)<=0|(k|0)<=0))for(X=1<<s-1,_=-1<<w^-1,V=k&2147483646,F=k&1;;){if(w=(G(e,m)<<1)+A|0,B=(G(f,m)<<1)+r|0,Q=0,(k|0)!=1)for(;h=(G(g[B>>1],t)+X>>s)+o|0,g[w>>1]=(h|0)>=0?(_|0)>(h|0)?h:_:0,h=(G(g[B+2>>1],t)+X>>s)+o|0,g[w+2>>1]=(h|0)>=0?(_|0)>(h|0)?h:_:0,B=B+4|0,w=w+4|0,Q=Q+2|0,(V|0)!=(Q|0););if(F&&(h=w,w=(G(g[B>>1],t)+X>>s)+o|0,g[h>>1]=(w|0)>=0?(w|0)<(_|0)?w:_:0),m=m+1|0,(m|0)==(n|0))break}return}D0(21760,18216,193,10487),H()}function qQ(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,t=0,o=0,s=0;if(k=v-32|0,v=k,o=W[i[i[e>>2]+52>>2]](e,r,0)|0,F0(r,(i[e+108>>2]-i[e+104>>2]|0)/24|0),f=i[e+104>>2],n=i[e+108>>2],(f|0)!=(n|0))for(;;){t=i[f>>2],s=i[f+4>>2];i:{if(l[e+97|0]==1){e4(r,t,s),e4(r,i[f+8>>2],i[f+12>>2]);break i}F0(r,t),F0(r,i[f+8>>2])}if(Me(r,g[f+16>>1]),Me(r,g[f+18>>1]),f=f+24|0,(n|0)==(f|0))break}f1(k+12|0,e,r,o),u[k+31|0]<0&&Z(i[k+20>>2]),e=i[26917],i[A>>2]=i[26916],i[A+4>>2]=e,A=A+8|0;i:{if(u[107683]>=0){e=i[26919],i[A>>2]=i[26918],i[A+4>>2]=e,i[A+8>>2]=i[26920];break i}T(A,i[26918],i[26919])}v=k+32|0}function Nr(A,e,r){var f=U(0),k=U(0),n=0,t=U(0),o=U(0),s=U(0),w=U(0),h=U(0);n=v-16|0,v=n,Vn(n+8|0,e,r),f=p0[n+12>>2],t=p0[n+8>>2];i:{if(!(f!=U(0)|t!=U(0))){h=U(-.41868799924850464),o=U(-.3312639892101288),f=U(.11400000005960464),w=U(.5870000123977661),t=U(.29899999499320984),k=U(-.08131200075149536),s=U(-.16873499751091003);break i}k=U(U(1)-t),w=U(k-f),o=U(-w),h=U(U(o/k)*U(.5)),s=U(U(1)-f),o=U(U(o/s)*U(.5)),k=U(U(U(-f)/k)*U(.5)),s=U(U(U(-t)/s)*U(.5))}p0[A+36>>2]=k,p0[A+32>>2]=h,i[A+24>>2]=1056964608,i[A+28>>2]=1056964608,p0[A+20>>2]=o,p0[A+16>>2]=s,p0[A+12>>2]=f,p0[A+8>>2]=w,p0[A+4>>2]=t,u[A|0]=1,v=n+16|0}function aQ(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0;var k=0,n=0;f=v-16|0,v=f,k=e,n=o2(r),g[k+100>>1]=n,k=e,n=o2(r),g[k+106>>1]=n,k=e,n=o2(r),g[k+102>>1]=n,k=e,n=o2(r),g[k+108>>1]=n,k=e,n=o2(r),g[k+104>>1]=n,k=e,n=o2(r),g[k+110>>1]=n,k=e,n=o2(r),g[k+112>>1]=n,k=e,n=o2(r),g[k+114>>1]=n,k=e,n=C0(r),i[k+116>>2]=n,k=e,n=C0(r),i[k+120>>2]=n;i:{if(l[r+20|0]==1){if(u[f+4|0]=0,u[f+15|0]=0,q(A,2,100,f+4|0),u[f+15|0]>=0)break i;Z(i[f+4>>2]);break i}if(e=i[26917],i[A>>2]=i[26916],i[A+4>>2]=e,A=A+8|0,u[107683]>=0){e=i[26919],i[A>>2]=i[26918],i[A+4>>2]=e,i[A+8>>2]=i[26920];break i}T(A,i[26918],i[26919])}v=f+16|0}function Wt(A){A=A|0;var e=0,r=0,f=0,k=0;if(i[A>>2]=100112,e=i[A+140>>2],e){if(r=e,f=i[A+144>>2],(e|0)!=(f|0)){for(;r=f-12|0,k=i[r>>2],k&&(i[f-8>>2]=k,Z(k)),f=r,(e|0)!=(f|0););r=i[A+140>>2]}i[A+144>>2]=e,Z(r)}if(e=i[A+128>>2],e){if(r=e,f=i[A+132>>2],(e|0)!=(f|0)){for(;r=f-12|0,k=i[r>>2],k&&(i[f-8>>2]=k,Z(k)),f=r,(e|0)!=(f|0););r=i[A+128>>2]}i[A+132>>2]=e,Z(r)}if(e=i[A+116>>2],e){if(r=e,f=i[A+120>>2],(e|0)!=(f|0)){for(;r=f-12|0,k=i[r>>2],k&&(i[f-8>>2]=k,Z(k)),f=r,(e|0)!=(f|0););r=i[A+116>>2]}i[A+120>>2]=e,Z(r)}return A2(A)|0}function Qt(A,e){var r=0,f=0,k=0,n=0,t=0,o=0,s=0,w=0;i:{k=i[A+4>>2],w=i[A>>2];e:{if((k|0)!=(w|0)){r=k;break e}if(f=i[A+8>>2],r=i[A+12>>2],f>>>0<r>>>0){n=((r-f>>2)+1|0)/2<<2,t=f-k|0,r=(n+f|0)-t|0,(f|0)!=(k|0)&&(t&&x(r,k,t),f=i[A+8>>2]),i[A+8>>2]=f+n;break e}if(n=(r|0)==(k|0)?1:r-k>>1,n>>>0>=1073741824)break i;if(r=n<<2,o=p(r),t=o+r|0,r=(n+3&-4)+o|0,s=r,(f|0)!=(k|0))for(s=(f-k|0)+r|0,n=r,f=k;i[n>>2]=i[f>>2],f=f+4|0,n=n+4|0,(s|0)!=(n|0););if(i[A+12>>2]=t,i[A+8>>2]=s,i[A+4>>2]=r,i[A>>2]=o,!k)break e;Z(w),r=i[A+4>>2]}r=r-4|0,i[r>>2]=i[e>>2],i[A+4>>2]=r;return}z0(),H()}function Ur(A,e,r,f,k){var n=0,t=0,o=0,s=0;n=v-208|0,v=n,i[n+204>>2]=r,r=n+160|0,o0(r,0,40),i[n+200>>2]=i[n+204>>2];i:{if((d7(0,e,n+200|0,n+80|0,r,f,k)|0)<0){k=-1;break i}s=i[A+76>>2]<0,t=i[A>>2],i[A>>2]=t&-33;e:{r:{f:{if(!i[A+48>>2]){i[A+48>>2]=80,i[A+28>>2]=0,i[A+16>>2]=0,i[A+20>>2]=0,o=i[A+44>>2],i[A+44>>2]=n;break f}if(i[A+16>>2])break r}if(r=-1,dA(A))break e}r=d7(A,e,n+200|0,n+80|0,n+160|0,f,k)}if(o&&(W[i[A+36>>2]](A,0,0)|0,i[A+48>>2]=0,i[A+44>>2]=o,i[A+28>>2]=0,e=i[A+20>>2],i[A+16>>2]=0,i[A+20>>2]=0,r=e?r:-1),e=A,A=i[A>>2],i[e>>2]=A|t&32,k=A&32?-1:r,s)break i}return v=n+208|0,k}function k6(A,e,r,f){var k=0,n=0,t=0;if(k=i[A+8>>2],n=i[A>>2],k-n>>2>>>0>=f>>>0){if(t=f,k=i[A+4>>2],f=k-n|0,t>>>0>f>>2>>>0){(k|0)!=(n|0)&&(f&&x(n,e,f),k=i[A+4>>2]),f=e+f|0,e=r-f|0,!e|(r|0)==(f|0)||x(k,f,e),i[A+4>>2]=e+k;return}f=r-e|0,!f|(e|0)==(r|0)||x(n,e,f),i[A+4>>2]=f+n;return}n&&(i[A+4>>2]=n,Z(n),i[A+8>>2]=0,i[A>>2]=0,i[A+4>>2]=0,k=0);i:{if(f>>>0>=1073741824||(n=k>>1,f=k>>>0>=2147483644?1073741823:f>>>0<n>>>0?n:f,f>>>0>=1073741824))break i;k=f<<2,f=p(k),i[A+4>>2]=f,i[A>>2]=f,i[A+8>>2]=f+k,k=r-e|0,!k|(e|0)==(r|0)||x(f,e,k),i[A+4>>2]=f+k;return}G0(),H()}function $Q(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,t=0;f=v-32|0,v=f,n=W[i[i[e>>2]+52>>2]](e,r,0)|0,k=i[e+104>>2],t=i[e+108>>2];i:{if(l[e+97|0]==1){e4(r,k,t),e4(r,i[e+112>>2],i[e+116>>2]),F0(r,i[e+120>>2]),e4(r,i[e+128>>2],i[e+132>>2]);break i}F0(r,k),F0(r,i[e+112>>2]),F0(r,i[e+120>>2]),F0(r,i[e+128>>2])}u2(r,l[e+138|0]&31|((l[e+137|0]&31)<<5|(l[e+136|0]&31)<<10)),u2(r,0),f1(f+12|0,e,r,n),u[f+31|0]<0&&Z(i[f+20>>2]),e=i[26917],i[A>>2]=i[26916],i[A+4>>2]=e,A=A+8|0;i:{if(u[107683]>=0){e=i[26919],i[A>>2]=i[26918],i[A+4>>2]=e,i[A+8>>2]=i[26920];break i}T(A,i[26918],i[26919])}v=f+32|0}function dQ(A,e){A=A|0,e=e|0;var r=0,f=0,k=0;r=v-48|0,v=r,i[r+44>>2]=0,i[r+36>>2]=0,i[r+40>>2]=0;i:{if(!z9(i[e+64>>2],r+36|0)){u[r+4|0]=0,u[r+15|0]=0,e=q(r+16|0,2,117,r+4|0),f=i[e+4>>2],i[A>>2]=i[e>>2],i[A+4>>2]=f,f=A+8|0;e:{if(u[e+19|0]>=0){k=i[e+12>>2],i[f>>2]=i[e+8>>2],i[f+4>>2]=k,i[f+8>>2]=i[e+16>>2],u[A+20|0]=1;break e}if(T(f,i[e+8>>2],i[e+12>>2]),f=u[e+19|0],u[A+20|0]=1,(f|0)>=0)break e;Z(i[e+8>>2])}if(u[r+15|0]<0&&Z(i[r+4>>2]),A=i[r+36>>2],!A)break i;i[r+40>>2]=A,Z(A);break i}e=i[r+40>>2],f=i[r+36>>2],k=i[r+44>>2],u[A+20|0]=0,i[A+8>>2]=k,i[A>>2]=f,i[A+4>>2]=e}v=r+48|0}function gt(A,e){var r=0,f=0,k=0,n=0,t=0,o=0,s=0;i[A+8>>2]=0,i[A>>2]=0,i[A+4>>2]=0,r=i[e+272>>2];i:{if(!r){r=0;break i}r=i[r>>2],k=i[r+104>>2],r=i[r+108>>2],f=p(8),i[f>>2]=k,i[f+4>>2]=r,r=f+8|0,i[A+8>>2]=r,i[A>>2]=f,i[A+4>>2]=r}i:{e:{if(e=i[e+276>>2],e){if(k=r-f|0,o=k>>3,n=o+1|0,n>>>0>=536870912)break e;if(r=i[e>>2],e=i[r+108>>2],s=i[r+104>>2],r=k>>>2|0,t=k>>>0>=2147483640?536870911:r>>>0>n>>>0?r:n,t){if(t>>>0>=536870912)break i;r=p(t<<3)}else r=0;n=k+r|0,i[n>>2]=s,i[n+4>>2]=e,e=n-(o<<3)|0,k&&x(e,f,k),i[A+8>>2]=(t<<3)+r,i[A>>2]=e,f&&Z(f),i[A+4>>2]=n+8}return}G0(),H()}z0(),H()}function cQ(A,e,r,f,k,n,t){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,t=t|0;var o=0;i:{if(!(!r|!f|(!k|!n))&&t)break i;e=i[23570],i[A>>2]=i[23569],i[A+4>>2]=e,i[A+8>>2]=i[23571];return}i:{if(o=i[e+16>>2],!o||(o=W0(o,94756,95872),!o))break i;e=i[e+20>>2],e&&(i[e+4>>2]=i[e+4>>2]+1),i[r>>2]=i[o+4>>2],i[f>>2]=i[o+8>>2],i[k>>2]=i[o+12>>2],i[n>>2]=i[o+16>>2],i[t>>2]=i[o+20>>2],i[A+8>>2]=i[24058],r=i[24057],i[A>>2]=i[24056],i[A+4>>2]=r;e:{if(!e||(A=i[e+4>>2],i[e+4>>2]=A-1,A))break e;W[i[i[e>>2]+8>>2]](e),y(e)}return}e=i[24170],i[A>>2]=i[24169],i[A+4>>2]=e,i[A+8>>2]=i[24171]}function bQ(A,e,r,f,k,n,t,o,s){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,t=t|0,o=o|0,s=s|0;var w=0,h=0,_=0,B=0,m=0,X=0,Q=0,V=0;if((s|0)>0){if(!((n|0)<=0|(k|0)<=0))for(X=1<<s-1,Q=k&2147483646,V=k&1;;){if(w=G(e,m)+A|0,_=(G(f,m)<<1)+r|0,B=0,(k|0)!=1)for(;h=(G(g[_>>1],t)+X>>s)+o|0,h=(h|0)>=255?255:h,u[w|0]=(h|0)>0?h:0,h=(G(g[_+2>>1],t)+X>>s)+o|0,h=(h|0)>=255?255:h,u[w+1|0]=(h|0)>0?h:0,_=_+4|0,w=w+2|0,B=B+2|0,(Q|0)!=(B|0););if(V&&(B=w,w=(G(g[_>>1],t)+X>>s)+o|0,w=(w|0)>=255?255:w,u[B|0]=(w|0)>0?w:0),m=m+1|0,(m|0)==(n|0))break}return}D0(21760,18216,60,10333),H()}function F0(A,e){var r=0,f=0,k=0,n=0,t=0,o=0;i:{f=i[A+4>>2],t=i[A>>2],o=f-t|0,r=i[A+12>>2]+4|0;e:{if(o>>>0>=r>>>0)break e;if(n=r-o|0,k=i[A+8>>2],n>>>0<=k-f>>>0){n&&o0(f,0,n),i[A+4>>2]=f+n;break e}if((r|0)<0)break i;if(f=k-t|0,k=f<<1,k=f>>>0>=1073741823?2147483647:r>>>0<k>>>0?k:r,f=p(k),n&&o0(f+o|0,0,n),o&&x(f,t,o),i[A+8>>2]=f+k,i[A+4>>2]=r+f,i[A>>2]=f,!t)break e;Z(t)}r=i[A+12>>2],i[A+12>>2]=r+1,u[r+i[A>>2]|0]=e>>>24,r=i[A+12>>2],i[A+12>>2]=r+1,u[r+i[A>>2]|0]=e>>>16,r=i[A+12>>2],i[A+12>>2]=r+1,u[r+i[A>>2]|0]=e>>>8,r=i[A+12>>2],i[A+12>>2]=r+1,u[r+i[A>>2]|0]=e;return}G0(),H()}function ig(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,t=0,o=0;k=v-32|0,v=k,n=W[i[i[e>>2]+52>>2]](e,r,0)|0,f=i[e+36>>2],t=i[e+40>>2];i:{if((f|0)!=(t|0))for(;;){if(o=i[f>>2],W[i[i[o>>2]+20>>2]](A,o,r),i[A>>2])break i;if(u[A+19|0]<0&&Z(i[A+8>>2]),f=f+8|0,(t|0)==(f|0))break}if(f=i[26917],i[A>>2]=i[26916],i[A+4>>2]=f,A=A+8|0,u[107683]>=0){f=i[26919],i[A>>2]=i[26918],i[A+4>>2]=f,i[A+8>>2]=i[26920];break i}T(A,i[26918],i[26919])}i[r+12>>2]=n,W[i[i[e>>2]+56>>2]](k+12|0,e,r,i[r+4>>2]-(i[r>>2]+n|0)|0,0),i[r+12>>2]=i[r+4>>2]-i[r>>2],u[k+31|0]<0&&Z(i[k+20>>2]),v=k+32|0}function te(A,e){var r=0,f=0,k=0,n=0;i[A>>2]=86356,r=i[e+12>>2],f=i[e+8>>2],i[A+8>>2]=f,i[A+12>>2]=r,i[A+16>>2]=i[e+16>>2],i[A+28>>2]=0,i[A+20>>2]=0,i[A+24>>2]=0;i:{e:{if(r=i[e+24>>2],k=i[e+20>>2],(r|0)!=(k|0)){if(r=r-k|0,(r|0)<0)break e;f=p(r),i[A+24>>2]=f,i[A+20>>2]=f,n=r+f|0,i[A+28>>2]=n,r&&x(f,k,r),i[A+24>>2]=n}if(i[A+32>>2]=i[e+32>>2],r=i[e+40>>2],i[A+52>>2]=0,i[A+44>>2]=0,i[A+48>>2]=0,i[A+40>>2]=r,r=i[e+48>>2],f=i[e+44>>2],(r|0)!=(f|0)){if(e=r-f|0,(e|0)<0)break i;r=p(e),i[A+48>>2]=r,i[A+44>>2]=r,k=e+r|0,i[A+52>>2]=k,e&&x(r,f,e),i[A+48>>2]=k}return}G0(),H()}G0(),H()}function V2(A,e){var r=0,f=0,k=0,n=0,t=0,o=0,s=0,w=0,h=0,_=0,B=0;if(k=i[A+24>>2],(k|0)>=(e|0)|(k|0)>56)r=k;else{for(r=64-k|0,t=i[A+16>>2],s=i[A+20>>2],f=i[A+4>>2],k=i[A+12>>2];;){i:{if(w=r,!k){n=r;break i}if(h=f+1|0,i[A+4>>2]=h,f=l[f|0],k=k-1|0,i[A+12>>2]=k,n=w-8|0,o=n&31,(n&63)>>>0>=32?(_=f<<o,f=0):(_=(1<<o)-1&f>>>32-o,f=f<<o),t=f|t,f=s|_,s=f,i[A+16>>2]=t,i[A+20>>2]=f,f=r,r=f-8|0,B=B-(f>>>0<8)|0,f=h,(w|0)>15)continue}break}r=64-n|0}i[A+24>>2]=r-e,t=i[A+20>>2],n=i[A+16>>2],r=e&31,(e&63)>>>0>=32?(e=n<<r,r=0):(e=(1<<r)-1&n>>>32-r|t<<r,r=n<<r),i[A+16>>2]=r,i[A+20>>2]=e}function eg(A,e,r,f,k,n){if(A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,!(!(i[r>>2]!=1|i[r+4>>2]!=3)&i[r+12>>2]==8)){i[A+8>>2]=0,i[A>>2]=0,i[A+4>>2]=0;return}r=p(28),u[r+22|0]=1,g[r+20>>1]=2,i[r+12>>2]=8,i[r+16>>2]=131074,i[r>>2]=1,i[r+4>>2]=11,i[r+24>>2]=11,u[r+8|0]=1,e=p(56),i[e+52>>2]=11,u[e+50|0]=1,g[e+48>>1]=2,i[e+40>>2]=8,i[e+44>>2]=131074,u[e+36|0]=0,i[e+28>>2]=1,i[e+32>>2]=10,f=i[r+4>>2],i[e>>2]=i[r>>2],i[e+4>>2]=f,f=i[r+12>>2],i[e+8>>2]=i[r+8>>2],i[e+12>>2]=f,f=i[r+20>>2],i[e+16>>2]=i[r+16>>2],i[e+20>>2]=f,i[e+24>>2]=i[r+24>>2],f=e+56|0,i[A+8>>2]=f,i[A>>2]=e,Z(r),i[A+4>>2]=f}function Vt(A,e){var r=0,f=0,k=0,n=0,t=0,o=0;i:{e:{r=i[A+4>>2],k=i[A+8>>2];r:{if(r>>>0<k>>>0){i[r>>2]=i[e>>2],e=i[e+4>>2],i[r+4>>2]=e,e&&(i[e+4>>2]=i[e+4>>2]+1),f=r+8|0;break r}if(n=i[A>>2],f=r-n|0,o=f>>3,r=o+1|0,r>>>0>=536870912)break e;if(k=k-n|0,t=k>>2,r=k>>>0>=2147483640?536870911:r>>>0<t>>>0?t:r,r>>>0>=536870912)break i;if(k=r<<3,t=p(k),r=t+f|0,i[r>>2]=i[e>>2],e=i[e+4>>2],i[r+4>>2]=e,e&&(i[e+4>>2]=i[e+4>>2]+1,n=i[A>>2],f=i[A+4>>2]-n|0,o=f>>3),e=r-(o<<3)|0,f&&x(e,n,f),i[A+8>>2]=k+t,f=r+8|0,i[A+4>>2]=f,i[A>>2]=e,!n)break r;Z(n)}i[A+4>>2]=f;return}G0(),H()}z0(),H()}function rg(A,e,r,f,k,n){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0;var t=0,o=0,s=0,w=0,h=0,_=0;if(S1(A,i[e+8>>2],n)){JA(e,r,f,k);return}o=l[e+53|0],t=i[A+12>>2],u[e+53|0]=0,s=l[e+52|0],u[e+52|0]=0,w=A+16|0,r5(w,e,r,f,k,n),h=l[e+52|0],s=s|h,_=l[e+53|0],o=o|_;i:{if(t>>>0<2)break i;for(w=w+(t<<3)|0,t=A+24|0;;){if(l[e+54|0])break i;e:{if(h&1){if(i[e+24>>2]==1)break i;if(l[A+8|0]&2)break e;break i}if(!(_&1))break e;if(!(u[A+8|0]&1))break i}if(g[e+52>>1]=0,r5(t,e,r,f,k,n),_=l[e+53|0],o=(_|o)&1,h=l[e+52|0],s=(h|s)&1,t=t+8|0,!(w>>>0>t>>>0))break}}u[e+53|0]=o&1,u[e+52|0]=s&1}function Ft(A,e,r,f,k){var n=0,t=0,o=0;if(n=p(24),i[n+20>>2]=e,u[n+8|0]=r,i[n>>2]=63628,i[n+4>>2]=0,i[n+16>>2]=k,i[n+12>>2]=f,i[e+18604>>2]=n,Be(A+1392|0,n),r=i[e+18596>>2],A=i[r+460>>2],k=i[r+464>>2],A>>>0<k>>>0){i[A>>2]=n,i[r+460>>2]=A+4;return}i:{if(f=i[r+456>>2],A=A-f|0,o=A>>2,e=o+1|0,e>>>0<1073741824){if(k=k-f|0,t=k>>1,k=k>>>0>=2147483644?1073741823:e>>>0<t>>>0?t:e,k){if(k>>>0>=1073741824)break i;e=p(k<<2)}else e=0;t=e+A|0,i[t>>2]=n,n=t-(o<<2)|0,A&&x(n,f,A),i[r+464>>2]=e+(k<<2),A=t+4|0,i[r+460>>2]=A,i[r+456>>2]=n,f&&Z(f),i[r+460>>2]=A;return}G0(),H()}z0(),H()}function fg(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0;f=v-32|0,v=f,k=W[i[i[e>>2]+52>>2]](e,r,0)|0,u2(r,C[e+100>>1]),u2(r,C[e+106>>1]),u2(r,C[e+102>>1]),u2(r,C[e+108>>1]),u2(r,C[e+104>>1]),u2(r,C[e+110>>1]),u2(r,C[e+112>>1]),u2(r,C[e+114>>1]),F0(r,i[e+116>>2]),F0(r,i[e+120>>2]),i[r+12>>2]=k,W[i[i[e>>2]+56>>2]](f+12|0,e,r,i[r+4>>2]-(i[r>>2]+k|0)|0,0),i[r+12>>2]=i[r+4>>2]-i[r>>2],u[f+31|0]<0&&Z(i[f+20>>2]),e=i[26917],i[A>>2]=i[26916],i[A+4>>2]=e,A=A+8|0;i:{if(u[107683]>=0){e=i[26919],i[A>>2]=i[26918],i[A+4>>2]=e,i[A+8>>2]=i[26920];break i}T(A,i[26918],i[26919])}v=f+32|0}function It(A){var e=0;return i[A+8>>2]=0,i[A+12>>2]=0,i[A+56>>2]=-1,i[A+60>>2]=-1,i[A+72>>2]=0,i[A+76>>2]=0,i[A+100>>2]=0,i[A+136>>2]=0,i[A+128>>2]=0,i[A+104>>2]=0,i[A+108>>2]=0,i[A+48>>2]=0,i[A+40>>2]=0,i[A+44>>2]=0,i[A+32>>2]=0,i[A+36>>2]=0,i[A+24>>2]=0,i[A+28>>2]=0,i[A+16>>2]=0,i[A+20>>2]=0,e=A- -64|0,i[e>>2]=-1,i[e+4>>2]=-1,i[A+80>>2]=0,i[A+84>>2]=0,i[A+88>>2]=0,i[A+92>>2]=0,g[A+96>>1]=0,i[A+112>>2]=0,i[A+116>>2]=0,u[A+117|0]=0,u[A+118|0]=0,u[A+119|0]=0,u[A+120|0]=0,u[A+121|0]=0,u[A+122|0]=0,u[A+123|0]=0,u[A+124|0]=0,i[A>>2]=86384,u[A+132|0]=0,i[A+16>>2]=1768714083,A}function oA(A,e,r,f){var k=0,n=0,t=0,o=0;i:{e:{if(f){if(f>>>0>=107374183)break e;if(k=G(f,40),f=p(k),i[A+4>>2]=f,i[A>>2]=f,i[A+8>>2]=f+k,(e|0)!=(r|0))for(;;){if(k=i[e+4>>2],i[f>>2]=i[e>>2],i[f+4>>2]=k,k=i[e+20>>2],i[f+16>>2]=i[e+16>>2],i[f+20>>2]=k,k=i[e+12>>2],i[f+8>>2]=i[e+8>>2],i[f+12>>2]=k,i[f+32>>2]=0,i[f+24>>2]=0,i[f+28>>2]=0,t=i[e+24>>2],k=i[e+28>>2],(t|0)!=(k|0)){if(k=k-t|0,(k|0)<0)break i;n=p(k),i[f+28>>2]=n,i[f+24>>2]=n,o=k+n|0,i[f+32>>2]=o,k&&x(n,t,k),i[f+28>>2]=o}if(f=f+40|0,e=e+40|0,(r|0)==(e|0))break}i[A+4>>2]=f}return}G0(),H()}G0(),H()}function Ag(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0;var k=0;if(!(f&&r)){e=i[23570],i[A>>2]=i[23569],i[A+4>>2]=e,i[A+8>>2]=i[23571];return}i:{e:{if(k=i[e+16>>2],!k||(k=W0(k,94756,95740),!k))break e;if(e=i[e+20>>2],e)break i;i[r>>2]=i[k+4>>2],i[f>>2]=i[k+8>>2],i[A+8>>2]=i[24058],e=i[24057],i[A>>2]=i[24056],i[A+4>>2]=e;return}e=i[24170],i[A>>2]=i[24169],i[A+4>>2]=e,i[A+8>>2]=i[24171];return}i[e+4>>2]=i[e+4>>2]+1,i[r>>2]=i[k+4>>2],i[f>>2]=i[k+8>>2],i[A+8>>2]=i[24058],r=i[24057],i[A>>2]=i[24056],i[A+4>>2]=r,A=i[e+4>>2],i[e+4>>2]=A-1,A||(W[i[i[e>>2]+8>>2]](e),y(e))}function Ct(A,e,r,f,k){var n=0,t=0,o=0,s=0,w=0,h=0,_=0;i:{if((f|k)<0||(t=i[A+124>>2],i[t+484>>2]<=(f|0)|i[t+488>>2]<=(k|0))||(w=i[A+132>>2],s=i[w+8496>>2],n=i[t+16936>>2],o=i[t+16924>>2],i[(s+(f>>>n<<2)|0)+(G(o,k>>>n|0)<<2)>>2]>i[(s+(e>>n<<2)|0)+(G(r>>n,o)<<2)>>2])||(s=i[A+140>>2],o=e,e=i[t+16876>>2],n=o>>e,A=i[A+152>>2],r=r>>e,h=C[(s+G(n,24)|0)+G(G(A,r),24)>>1],f=f>>>e|0,o=A,A=k>>>e|0,(h|0)!=C[(s+G(f,24)|0)+G(G(o,A),24)>>1]))break i;e=i[w+8484>>2],k=r,r=i[t+16892>>2],_=i[(e+(n<<2)|0)+(G(k,r)<<2)>>2]==i[(e+(f<<2)|0)+(G(A,r)<<2)>>2]}return _}function kg(A,e,r,f,k){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0;var n=0;n=v-48|0,v=n;i:{if(!(k&&e)){e=i[23570],i[A>>2]=i[23569],i[A+4>>2]=e,i[A+8>>2]=i[23571];break i}Zf(n+12|0,i[e>>2],r,f);e:{r:switch(l[n+32|0]){default:_2(),H();case 0:if(e=i[n+12>>2],!e){i[A>>2]=5,i[A+4>>2]=2007,i[A+8>>2]=2304,e=0;break e}i[k>>2]=i[e+104>>2]-i[e+100>>2],i[A+8>>2]=i[24058],e=i[24057],i[A>>2]=i[24056],i[A+4>>2]=e,e=0;break e;case 1:break r}if(b0(A,n+12|0,i[e>>2]),e=l[n+32|0],(e|0)==255)break i}A=i[24181],i[n+40>>2]=i[24180],i[n+44>>2]=A,W[i[(n+40|0)+(e<<2)>>2]](n+39|0,n+12|0)}v=n+48|0}function ng(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0;var k=0,n=0,t=0,o=0,s=0;k=v-32|0,v=k;i:{e:{if(n=i[e>>2],t=i[n+260>>2],s=i[n+264>>2],(t|0)==(s|0))break e;for(;;){if(o=i[t>>2],i[o>>2]!=(r|0)){if(t=t+8|0,(s|0)!=(t|0))continue;break e}break}if(r=i[o+40>>2],t=i[o+44>>2],(r|0)!=(t|0)){if(!f){e=i[23570],i[A>>2]=i[23569],i[A+4>>2]=e,i[A+8>>2]=i[23571];break i}n=t-r|0,n&&x(f,r,n),n=i[e>>2]}b0(A,107664,n?n+84|0:0);break i}if(u[k|0]=0,u[k+11|0]=0,r=q(k+12|0,5,2e3,k),u[k+11|0]<0&&Z(i[k>>2]),f=A,A=i[e>>2],b0(f,r,A?A+84|0:0),u[r+19|0]>=0)break i;Z(i[r+8>>2])}v=k+32|0}function pt(A,e,r,f){var k=0,n=0,t=0,o=0;if(k=p(20),i[k+16>>2]=e,u[k+8|0]=r,i[k>>2]=63692,i[k+4>>2]=0,i[k+12>>2]=f,i[e+18604>>2]=k,Be(A+1392|0,k),r=i[e+18596>>2],A=i[r+460>>2],n=i[r+464>>2],A>>>0<n>>>0){i[A>>2]=k,i[r+460>>2]=A+4;return}i:{if(f=i[r+456>>2],A=A-f|0,o=A>>2,e=o+1|0,e>>>0<1073741824){if(n=n-f|0,t=n>>1,n=n>>>0>=2147483644?1073741823:e>>>0<t>>>0?t:e,n){if(n>>>0>=1073741824)break i;e=p(n<<2)}else e=0;t=e+A|0,i[t>>2]=k,k=t-(o<<2)|0,A&&x(k,f,A),i[r+464>>2]=e+(n<<2),A=t+4|0,i[r+460>>2]=A,i[r+456>>2]=k,f&&Z(f),i[r+460>>2]=A;return}G0(),H()}z0(),H()}function yt(A,e,r,f,k,n){var t=0,o=0,s=0;o=i[e+8>>2],W[i[i[o>>2]+20>>2]](o,f,k)|0;i:{t=i[r+4>>2],o=i[r>>2],f=t-o|0,k=f+n|0;e:{if(k>>>0>f>>>0){if(s=i[r+8>>2],s-t>>>0>=n>>>0){n&&o0(t,0,n),i[r+4>>2]=n+t;break e}if((k|0)<0)break i;if(t=s-o|0,s=t<<1,s=t>>>0>=1073741823?2147483647:k>>>0<s>>>0?s:k,t=p(s),n&&o0(f+t|0,0,n),f&&x(t,o,f),i[r+8>>2]=t+s,i[r+4>>2]=k+t,i[r>>2]=t,!o)break e;Z(o);break e}if(f>>>0<=k>>>0)break e;i[r+4>>2]=k+o}e=i[e+8>>2],W[i[i[e>>2]+16>>2]](e,f+i[r>>2]|0,n)|0,i[A>>2]=0,i[A+4>>2]=0,i[A+16>>2]=0,i[A+8>>2]=0,i[A+12>>2]=0;return}G0(),H()}function tg(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,t=0;if(f=v-32|0,v=f,t=W[i[i[e>>2]+52>>2]](e,r,0)|0,l2(r,i[e+108>>2]-i[e+104>>2]&255),k=i[e+104>>2],(k|0)!=i[e+108>>2])for(;l2(r,l[k+n|0]),n=n+1|0,k=i[e+104>>2],n>>>0<i[e+108>>2]-k>>>0;);i[r+12>>2]=t,W[i[i[e>>2]+56>>2]](f+12|0,e,r,i[r+4>>2]-(i[r>>2]+t|0)|0,0),i[r+12>>2]=i[r+4>>2]-i[r>>2],u[f+31|0]<0&&Z(i[f+20>>2]),e=i[26917],i[A>>2]=i[26916],i[A+4>>2]=e,A=A+8|0;i:{if(u[107683]>=0){e=i[26919],i[A>>2]=i[26918],i[A+4>>2]=e,i[A+8>>2]=i[26920];break i}T(A,i[26918],i[26919])}v=f+32|0}function ug(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,t=0;if(f=v-32|0,v=f,n=W[i[i[e>>2]+52>>2]](e,r,0)|0,F0(r,i[e+104>>2]),F0(r,i[e+112>>2]-i[e+108>>2]>>2),k=i[e+108>>2],t=i[e+112>>2],(k|0)!=(t|0))for(;F0(r,i[k>>2]),k=k+4|0,(t|0)!=(k|0););i[r+12>>2]=n,W[i[i[e>>2]+56>>2]](f+12|0,e,r,i[r+4>>2]-(i[r>>2]+n|0)|0,0),i[r+12>>2]=i[r+4>>2]-i[r>>2],u[f+31|0]<0&&Z(i[f+20>>2]),e=i[26917],i[A>>2]=i[26916],i[A+4>>2]=e,A=A+8|0;i:{if(u[107683]>=0){e=i[26919],i[A>>2]=i[26918],i[A+4>>2]=e,i[A+8>>2]=i[26920];break i}T(A,i[26918],i[26919])}v=f+32|0}function Et(A,e,r){var f=0,k=0,n=0,t=0,o=0;o=v-16|0,v=o,k=v-16|0,v=k,f=A;i:{if(e>>>0<=1073741815){e:{if(e>>>0<2){u[f+11|0]=l[f+11|0]&128|e&127,u[f+11|0]=l[f+11|0]&127;break e}t=k+8|0,e>>>0>=2?(n=e+2&-2,A=n-1|0,A=(A|0)==2?n:A):A=1,pi(t,A+1|0),A=i[k+8>>2],i[f>>2]=A,i[f+8>>2]=i[f+8>>2]&-2147483648|i[k+12>>2]&2147483647,i[f+8>>2]=i[f+8>>2]|-2147483648,i[f+4>>2]=e}for(n=v-16|0,v=n,i[n+12>>2]=r,r=A,t=e;;){if(t){i[r>>2]=i[n+12>>2],t=t-1|0,r=r+4|0;continue}break}v=n+16|0,i[k+4>>2]=0,i[(e<<2)+A>>2]=i[k+4>>2],v=k+16|0;break i}Z4(),H()}return v=o+16|0,f}function Dr(A,e,r,f,k,n,t,o,s,w,h){var _=0,B=0,m=0,X=0;if(!l[r+332|0]){g[w>>1]=0,g[w+2>>1]=0,u[h|0]=0;return}if(B=i[i[e+124>>2]+16876>>2],i[r+28>>2]|l[r+380|0]?_=924:_=988,_=i[(_+r|0)+(i[r+384>>2]<<2)>>2],!(W[i[i[A>>2]+12>>2]](A,_)|0)){g[w>>1]=0,g[w+2>>1]=0,u[h|0]=0,F2(A+4|0,1012,0);return}i:{e:{r:{m=k+t|0;f:{if(k>>B!=m>>B||(X=f+n|0,B=i[e+124>>2],(X|0)>=i[B+484>>2]))break f;if(i[B+488>>2]>(m|0))break r}g[w>>1]=0,g[w+2>>1]=0,u[h|0]=0;break e}if(R9(A,e,r,_,X&-16,m&-16,o,s,w,h),l[h|0])break i}R9(A,e,r,_,(n>>1)+f&-16,(t>>1)+k&-16,o,s,w,h)}}function r2(A,e){var r=0,f=0,k=0,n=0,t=0,o=0;if(r=i[A+4>>2],f=i[A+8>>2],r>>>0<f>>>0){i[r>>2]=i[e>>2],e=i[e+4>>2],i[r+4>>2]=e,e&&(i[e+4>>2]=i[e+4>>2]+1),i[A+4>>2]=r+8;return}i:{if(k=i[A>>2],n=r-k|0,o=n>>3,r=o+1|0,r>>>0<536870912){if(f=f-k|0,t=f>>2,r=f>>>0>=2147483640?536870911:r>>>0<t>>>0?t:r,r>>>0>=536870912)break i;f=r<<3,t=p(f),r=t+n|0,i[r>>2]=i[e>>2],e=i[e+4>>2],i[r+4>>2]=e,e&&(i[e+4>>2]=i[e+4>>2]+1,k=i[A>>2],n=i[A+4>>2]-k|0,o=n>>3),e=r-(o<<3)|0,n&&x(e,k,n),i[A+8>>2]=f+t,r=r+8|0,i[A+4>>2]=r,i[A>>2]=e,k&&Z(k),i[A+4>>2]=r;return}G0(),H()}z0(),H()}function Yt(A,e,r,f,k){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0;var n=0,t=0;k=v-16|0,v=k,F0(r,f),F0(r,i[e+16>>2]);i:{e:{if(i[e+16>>2]!=1970628964)break e;if(i[k+12>>2]=0,i[k+4>>2]=0,i[k+8>>2]=0,n=i[e+24>>2],f=i[e+20>>2],(n|0)!=(f|0)){if(e=n-f|0,(e|0)<0)break i;n=p(e),i[k+4>>2]=n,t=e+n|0,i[k+12>>2]=t,e&&x(n,f,e),i[k+8>>2]=t}if(I4(r,k+4|0),e=i[k+4>>2],!e)break e;i[k+8>>2]=e,Z(e)}e=i[26917],i[A>>2]=i[26916],i[A+4>>2]=e,A=A+8|0;e:{if(u[107683]>=0){e=i[26919],i[A>>2]=i[26918],i[A+4>>2]=e,i[A+8>>2]=i[26920];break e}T(A,i[26918],i[26919])}v=k+16|0;return}G0(),H()}function og(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,t=0,o=0,s=0,w=0,h=0,_=0,B=0;if((r|0)>0)for(_=r&2147483644,w=r&3,B=r>>>0<4;;){if(h=G(r,s),o=0,f=0,t=0,!B)for(;n=f,f=o+h|0,k=n+g[(f<<1)+e>>1]|0,i[(f<<2)+A>>2]=k,n=f+1|0,k=k+g[(n<<1)+e>>1]|0,i[(n<<2)+A>>2]=k,n=f+2|0,k=k+g[(n<<1)+e>>1]|0,i[(n<<2)+A>>2]=k,n=f+3|0,f=k+g[(n<<1)+e>>1]|0,i[(n<<2)+A>>2]=f,o=o+4|0,t=t+4|0,(_|0)!=(t|0););if(t=0,w)for(;k=o+h|0,f=g[(k<<1)+e>>1]+f|0,i[(k<<2)+A>>2]=f,o=o+1|0,t=t+1|0,(w|0)!=(t|0););if(s=s+1|0,(s|0)==(r|0))break}}function lg(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,t=0,o=0;for(k=v-16|0,v=k;;){i:{if((r|0)<=(o|0))break i;f=i[A+12>>2],t=i[A+16>>2];e:{if(f>>>0<t>>>0){i[k+12>>2]=2147483647,i[k+8>>2]=t-f>>2,i[k+4>>2]=r-o,f=v-16|0,v=f,v=f+16|0,f=v-16|0,v=f,v=f+16|0,t=i[A+12>>2],f=k+4|0,n=k+8|0,f=i[f>>2]<i[n>>2]?f:n,n=k+12|0,f=i[(i[f>>2]<i[n>>2]?f:n)>>2];r:{if(!f||(n=f<<2,!n))break r;x(e,t,n)}t=f<<2,i[A+12>>2]=t+i[A+12>>2],e=e+t|0;break e}if(f=W[i[i[A>>2]+40>>2]](A)|0,(f|0)==-1)break i;i[e>>2]=f,f=1,e=e+4|0}o=f+o|0;continue}break}return v=k+16|0,o|0}function Rt(A,e){var r=0,f=0,k=0,n=0,t=0,o=0,s=0,w=0,h=0,_=0,B=0;if(e)for(f=i[A+16>>2],k=i[A+20>>2],n=i[A+4>>2],t=i[A+12>>2],r=i[A+24>>2];;){if((r|0)<=7){for(o=64-r|0,_=0,r=n;;){i:{if(B=o,!t){t=0,n=r,s=o;break i}if(n=r+1|0,i[A+4>>2]=n,r=l[r|0],t=t-1|0,i[A+12>>2]=t,s=B-8|0,w=s&31,(s&63)>>>0>=32?(h=r<<w,r=0):(h=(1<<w)-1&r>>>32-w,r=r<<w),f=r|f,r=k|h,k=r,i[A+16>>2]=f,i[A+20>>2]=r,r=o,o=r-8|0,_=_-(r>>>0<8)|0,r=n,(B|0)>15)continue}break}r=64-s|0}if(r=r-8|0,i[A+24>>2]=r,h=k<<8|f>>>24,f=f<<8,i[A+16>>2]=f,k=h,i[A+20>>2]=k,e=e-1|0,!e)break}}function sg(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0;f=v-48|0,v=f;i:{if(!r){if(u[f+16|0]=0,u[f+27|0]=0,r=A,A=q(f+28|0,5,2001,f+16|0),b0(r,A,i[e>>2]),u[A+19|0]<0&&Z(i[A+8>>2]),u[f+27|0]>=0)break i;Z(i[f+16>>2]);break i}To(f+8|0,i[e>>2]),k=i[f+8>>2];e:{if(!k){if(u[f+16|0]=0,u[f+27|0]=0,r=A,A=q(f+28|0,2,124,f+16|0),b0(r,A,i[e>>2]),u[A+19|0]<0&&Z(i[A+8>>2]),u[f+27|0]>=0)break e;Z(i[f+16>>2]);break e}i[r>>2]=i[k+116>>2],b0(A,107664,i[e>>2])}if(A=i[f+12>>2],!A||(e=i[A+4>>2],i[A+4>>2]=e-1,e))break i;W[i[i[A>>2]+8>>2]](A),y(A)}v=f+48|0}function Jt(A,e){var r=0,f=0,k=0,n=0,t=0,o=0;i:{e:{if(t=i[A+104>>2],r=i[A+108>>2],!((t|0)!=(r|0)&i[r-4>>2]==(e|0))){if(f=i[A+112>>2],f>>>0>r>>>0){i[r>>2]=1,i[r+4>>2]=e,i[A+108>>2]=r+8;return}if(r=r-t|0,o=r>>3,k=o+1|0,k>>>0>=536870912)break e;if(f=f-t|0,n=f>>2,f=f>>>0>=2147483640?536870911:n>>>0>k>>>0?n:k,f){if(f>>>0>=536870912)break i;k=p(f<<3)}else k=0;n=k+r|0,i[n>>2]=1,i[n+4>>2]=e,e=n-(o<<3)|0,r&&x(e,t,r),i[A+112>>2]=k+(f<<3),r=n+8|0,i[A+108>>2]=r,i[A+104>>2]=e,t&&Z(t),i[A+108>>2]=r;return}A=r-8|0,i[A>>2]=i[A>>2]+1;return}G0(),H()}z0(),H()}function wg(A,e,r,f,k){if(A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,S1(A,i[e+8>>2],k)){i[e+28>>2]==1|i[e+4>>2]!=(r|0)||(i[e+28>>2]=f);return}i:{if(S1(A,i[e>>2],k)){if(!(i[e+16>>2]!=(r|0)&i[e+20>>2]!=(r|0))){if((f|0)!=1)break i;i[e+32>>2]=1;return}i[e+32>>2]=f;e:{if(i[e+44>>2]==4)break e;if(g[e+52>>1]=0,A=i[A+8>>2],W[i[i[A>>2]+20>>2]](A,e,r,r,1,k),l[e+53|0]==1){if(i[e+44>>2]=3,!l[e+52|0])break e;break i}i[e+44>>2]=4}if(i[e+20>>2]=r,i[e+40>>2]=i[e+40>>2]+1,i[e+36>>2]!=1|i[e+24>>2]!=2)break i;u[e+54|0]=1;return}A=i[A+8>>2],W[i[i[A>>2]+24>>2]](A,e,r,f,k)}}function Nt(A,e,r,f,k){var n=0,t=0,o=0;i:{e:{if(n=i[f>>2],f=i[n+104>>2],n=i[n+108>>2],(f|0)!=(n|0))for(;;){if(i[f>>2]==(r|0))break e;if(f=f+16|0,(n|0)==(f|0))break}break i}e:{r:{if(r=i[f+4>>2],f=i[f+8>>2],(r|0)==(f|0))break r;for(n=i[e+36>>2],o=i[e+40>>2]-n>>3;;){if(e=C[r+2>>1],!(e>>>0<=o>>>0&&e))break i;if(e=n+(e<<3)|0,t=i[e-8>>2],i[t+16>>2]!=(k|0)){if(r=r+4|0,(f|0)==(r|0))break r;continue}break}if(i[A>>2]=t,r=A,A=i[e-4>>2],i[r+4>>2]=A,!A)break e;i[A+4>>2]=i[A+4>>2]+1;return}i[A>>2]=0,i[A+4>>2]=0}return}i[A>>2]=0,i[A+4>>2]=0}function Ut(A,e,r,f){var k=0,n=0;i:{if(!r){e=C[e>>1]|C[e+2>>1]<<16,g[A>>1]=e,g[A+2>>1]=e>>>16;break i}k=(r|0)>=127?127:r,k=(k|0)<=-128?-128:k,n=k>>31,f=(f|0)>=127?127:f,f=G(((k^n)-n>>>1|16384)/(k|0)<<16>>16,(f|0)<=-128?-128:f)+32>>6,f=(f|0)>=4095?4095:f,n=(f|0)<=-4096?-4096:f,f=G(n,g[e>>1]),k=f>>31,f=G(((f|0)>0)-((f|0)<0)|0,((f^k)-k|0)+127>>>8|0),f=(f|0)>=32767?32767:f,g[A>>1]=(f|0)<=-32768?-32768:f,e=G(n,g[e+2>>1]),f=e>>31,k=A,A=G(((e|0)>0)-((e|0)<0)|0,((e^f)-f|0)+127>>>8|0),A=(A|0)>=32767?32767:A,g[k+2>>1]=(A|0)<=-32768?-32768:A}return(r|0)!=0}function hg(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,t=0;if(f=v-32|0,v=f,n=W[i[i[e>>2]+52>>2]](e,r,0)|0,F0(r,i[e+100>>2]),F0(r,i[e+104>>2]),k=i[e+108>>2],t=i[e+112>>2],(k|0)!=(t|0))for(;F0(r,i[k>>2]),k=k+4|0,(t|0)!=(k|0););i[r+12>>2]=n,W[i[i[e>>2]+56>>2]](f+12|0,e,r,i[r+4>>2]-(i[r>>2]+n|0)|0,0),i[r+12>>2]=i[r+4>>2]-i[r>>2],u[f+31|0]<0&&Z(i[f+20>>2]),e=i[26917],i[A>>2]=i[26916],i[A+4>>2]=e,A=A+8|0;i:{if(u[107683]>=0){e=i[26919],i[A>>2]=i[26918],i[A+4>>2]=e,i[A+8>>2]=i[26920];break i}T(A,i[26918],i[26919])}v=f+32|0}function Dt(A,e){var r=0,f=0,k=0,n=0,t=0,o=0;if(f=i[A+8>>2],r=i[A+4>>2],(f-r|0)/12>>>0>=e>>>0){e&&(e=G(e,12)-12|0,e=(e-((e>>>0)%12|0)|0)+12|0,e&&o0(r,0,e),r=e+r|0),i[A+4>>2]=r;return}i:{if(n=r,r=i[A>>2],t=n-r|0,k=((t|0)/12|0)+e|0,k>>>0<357913942){if(f=(f-r|0)/12|0,n=f<<1,k=f>>>0>=178956970?357913941:k>>>0<n>>>0?n:k,k){if(k>>>0>=357913942)break i;o=p(G(k,12))}f=t+o|0,e=G(e,12)-12|0,e=(e-((e>>>0)%12|0)|0)+12|0,e&&o0(f,0,e),n=f+G((t|0)/-12|0,12)|0,t&&x(n,r,t),i[A+8>>2]=G(k,12)+o,i[A+4>>2]=e+f,i[A>>2]=n,r&&Z(r);return}G0(),H()}z0(),H()}function y6(A,e){var r=0,f=0,k=0,n=0,t=0,o=0,s=0,w=0;i:{e:{if(n=i[A>>2],t=i[A+4>>2]-n|0,r=((t|0)/12|0)+1|0,r>>>0<357913942){if(k=(i[A+8>>2]-n|0)/12|0,f=k<<1,r=k>>>0>=178956970?357913941:r>>>0<f>>>0?f:r,r>>>0>=357913942)break e;if(o=G(r,12),s=p(o),r=s+t|0,i[r+8>>2]=0,i[r>>2]=0,i[r+4>>2]=0,f=i[e+4>>2],k=i[e>>2],(f|0)!=(k|0)){if(e=f-k|0,(e|0)<0)break i;f=p(e),i[r>>2]=f,w=e+f|0,i[r+8>>2]=w,e&&x(f,k,e),i[r+4>>2]=w}return e=r+G((t|0)/-12|0,12)|0,t&&x(e,n,t),i[A+8>>2]=o+s,r=r+12|0,i[A+4>>2]=r,i[A>>2]=e,n&&Z(n),r}G0(),H()}z0(),H()}G0(),H()}function lA(A){var e=0,r=0,f=0,k=0;if(i[A+4>>2]&&(e=i[A+308>>2],r=i[A+112>>2],r&&(f=i[r+544>>2]),W[e|0](r,A,f),i[A+12>>2]=0,i[A+4>>2]=0,i[A+8>>2]=0,i[A+72>>2]=0,i[A+64>>2]=0,i[A+68>>2]=0),e=i[A+52>>2],k=i[A+56>>2],(e|0)!=(k|0))for(f=0;;){if(r=i[(f<<2)+e>>2],r){e=i[r+1352>>2],e&&(i[r+1356>>2]=e,Z(e)),L8(r+1340|0),e=i[r+784>>2],e&&(i[r+788>>2]=e,Z(e)),e=i[r+8>>2];i:{if(!e||(k=i[e+4>>2],i[e+4>>2]=k-1,k))break i;W[i[i[e>>2]+8>>2]](e),y(e)}Z(r),k=i[A+56>>2],e=i[A+52>>2]}if(f=f+1|0,!(f>>>0<k-e>>2>>>0))break}i[A+56>>2]=e}function _g(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,t=0;k=v-32|0,v=k;i:{if(!r){e=i[23570],i[A>>2]=i[23569],i[A+4>>2]=e,i[A+8>>2]=i[23571];break i}f=i[e>>2],n=i[f+16>>2],f=i[f+20>>2],f&&(i[f+4>>2]=i[f+4>>2]+1);e:{if(n){t=i[n+12>>2],n=i[n+8>>2],t=t-n|0,t&&x(r,n,t),r=A,A=i[e>>2],b0(r,107664,A?A+84|0:0);break e}if(u[k|0]=0,u[k+11|0]=0,r=q(k+12|0,10,0,k),u[k+11|0]<0&&Z(i[k>>2]),n=A,A=i[e>>2],b0(n,r,A?A+84|0:0),u[r+19|0]>=0)break e;Z(i[r+8>>2])}if(!f||(A=i[f+4>>2],i[f+4>>2]=A-1,A))break i;W[i[i[f>>2]+8>>2]](f),y(f)}v=k+32|0}function Bg(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,t=0;k=v-32|0,v=k;i:{if(!r){e=i[23570],i[A>>2]=i[23569],i[A+4>>2]=e,i[A+8>>2]=i[23571];break i}f=i[e>>2],n=i[f+16>>2],f=i[f+20>>2],f&&(i[f+4>>2]=i[f+4>>2]+1);e:{if(n){t=i[n+12>>2],n=i[n+8>>2],t=t-n|0,t&&x(r,n,t),r=A,A=i[e>>2],b0(r,107664,A?A+92|0:0);break e}if(u[k|0]=0,u[k+11|0]=0,r=q(k+12|0,10,0,k),u[k+11|0]<0&&Z(i[k>>2]),n=A,A=i[e>>2],b0(n,r,A?A+92|0:0),u[r+19|0]>=0)break e;Z(i[r+8>>2])}if(!f||(A=i[f+4>>2],i[f+4>>2]=A-1,A))break i;W[i[i[f>>2]+8>>2]](f),y(f)}v=k+32|0}function Mt(A){A=A|0;var e=0,r=0,f=0,k=0,n=0,t=0,o=0,s=0;if(i[A>>2]=99816,n=i[A+176>>2],n){if(e=n,r=i[A+180>>2],(e|0)!=(r|0)){for(;;){if(o=r-12|0,f=i[o>>2],f){if(k=f,s=r-8|0,e=i[s>>2],(f|0)!=(e|0)){for(;k=e-12|0,t=i[k>>2],t&&(i[e-8>>2]=t,Z(t)),e=k,(f|0)!=(e|0););k=i[o>>2]}i[s>>2]=f,Z(k)}if(r=r-16|0,(n|0)==(r|0))break}e=i[A+176>>2]}i[A+180>>2]=n,Z(e)}return e=i[A+156>>2],e&&(i[A+160>>2]=e,Z(e)),e=i[A+144>>2],e&&(i[A+148>>2]=e,Z(e)),e=i[A+132>>2],e&&Z(e),e=i[A+120>>2],e&&(i[A+124>>2]=e,Z(e)),A2(A)|0}function vg(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0;k=v-16|0,v=k,f=i[A>>2],n=l[f+20|0];i:{if((n|0)!=255){if((n|0)==1){A=i[r+4>>2],i[e>>2]=i[r>>2],i[e+4>>2]=A,u[e+19|0]<0&&Z(i[e+8>>2]),A=i[r+12>>2],i[e+8>>2]=i[r+8>>2],i[e+12>>2]=A,i[e+16>>2]=i[r+16>>2],u[r+19|0]=0,u[r+8|0]=0;break i}A=i[23595],i[k+8>>2]=i[23594],i[k+12>>2]=A,W[i[(k+8|0)+(n<<2)>>2]](k+7|0,f)}u[f+20|0]=255,A=i[r+4>>2],i[f>>2]=i[r>>2],i[f+4>>2]=A,i[f+16>>2]=i[r+16>>2],A=i[r+12>>2],i[f+8>>2]=i[r+8>>2],i[f+12>>2]=A,i[r+16>>2]=0,i[r+8>>2]=0,i[r+12>>2]=0,u[f+20|0]=1}v=k+16|0}function Mr(A,e,r){var f=0,k=0,n=0,t=0;t=i[r>>2],k=i[r+4>>2],k&&(i[k+4>>2]=i[k+4>>2]+1);i:{f=i[A+20>>2];e:{if(!f){n=A+20|0,r=n;break e}for(;;){if(r=f,f=i[f+16>>2],f>>>0>e>>>0){if(n=r,f=i[r>>2],f)continue;break e}if(e>>>0<=f>>>0)break i;if(f=i[r+4>>2],!f)break}n=r+4|0}f=p(28),i[f+24>>2]=k,i[f+20>>2]=t,i[f+16>>2]=e,i[f+8>>2]=r,i[f>>2]=0,i[f+4>>2]=0,i[n>>2]=f,e=i[i[A+16>>2]>>2],e&&(i[A+16>>2]=e),m1(i[A+20>>2],f),i[A+24>>2]=i[A+24>>2]+1;return}i:{if(!k||(A=i[k+4>>2],i[k+4>>2]=A-1,A))break i;W[i[i[k>>2]+8>>2]](k),y(k)}}function E6(A,e){var r=0,f=0,k=0,n=0,t=0,o=0,s=0,w=0,h=0,_=0;if(k=i[A+16>>2],!((k|0)>=(e|0)|(k|0)>56)){for(n=64-k|0,k=i[A+4>>2];;){i:{if(f=n,!k){t=f;break i}if(r=i[A>>2],i[A>>2]=r+1,r=l[r|0],k=k-1|0,i[A+4>>2]=k,w=i[A+12>>2],t=f-8|0,o=t&31,h=A,(t&63)>>>0>=32?(s=r<<o,r=0):(s=(1<<o)-1&r>>>32-o,r=r<<o),i[h+8>>2]=r|i[A+8>>2],i[A+12>>2]=s|w,r=n,n=r-8|0,_=_-(r>>>0<8)|0,(f|0)>15)continue}break}k=64-t|0}i[A+16>>2]=k-e,n=i[A+12>>2],r=i[A+8>>2],f=e&31,(e&63)>>>0>=32?(e=r<<f,f=0):(e=(1<<f)-1&r>>>32-f|n<<f,f=r<<f),i[A+8>>2]=f,i[A+12>>2]=e}function mg(A,e,r,f,k){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0;var n=0,t=0,o=0,s=0,w=0,h=0,_=0,B=0,m=0;if((f|0)>0)for(B=f&2147483646,m=f&1,t=-1<<k^-1;;){if(o=(G(f,w)<<2)+r|0,h=(G(e,w)<<1)+A|0,k=0,_=0,(f|0)!=1)for(;s=h+(k<<1)|0,n=i[(k<<2)+o>>2]+C[s>>1]|0,g[s>>1]=(n|0)>=0?(n|0)<(t|0)?n:t:0,n=k|1,s=h+(n<<1)|0,n=i[(n<<2)+o>>2]+C[s>>1]|0,g[s>>1]=(n|0)>=0?(n|0)<(t|0)?n:t:0,k=k+2|0,_=_+2|0,(B|0)!=(_|0););if(m&&(n=i[(k<<2)+o>>2],o=h+(k<<1)|0,k=n+C[o>>1]|0,g[o>>1]=(k|0)>=0?(k|0)<(t|0)?k:t:0),w=w+1|0,(w|0)==(f|0))break}}function Zg(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0;f=v-32|0,v=f,k=W[i[i[e>>2]+52>>2]](e,r,0)|0,F0(r,i[e+100>>2]),F0(r,i[e+104>>2]),F0(r,i[e+108>>2]),F0(r,i[e+112>>2]),F0(r,i[e+116>>2]),F0(r,i[e+120>>2]),F0(r,i[e+124>>2]),F0(r,i[e+128>>2]),i[r+12>>2]=k,W[i[i[e>>2]+56>>2]](f+12|0,e,r,i[r+4>>2]-(i[r>>2]+k|0)|0,0),i[r+12>>2]=i[r+4>>2]-i[r>>2],u[f+31|0]<0&&Z(i[f+20>>2]),e=i[26917],i[A>>2]=i[26916],i[A+4>>2]=e,A=A+8|0;i:{if(u[107683]>=0){e=i[26919],i[A>>2]=i[26918],i[A+4>>2]=e,i[A+8>>2]=i[26920];break i}T(A,i[26918],i[26919])}v=f+32|0}function Hr(A,e){var r=0,f=0,k=0,n=0,t=0,o=0;i:{e:{if(r=i[A+108>>2],f=i[A+112>>2],r=_3(r,e,f-r>>2),r=r||f,f=i[A+112>>2],(r|0)==(f|0)){k=i[A+116>>2];r:{if(k>>>0>r>>>0){i[f>>2]=e,e=f+4|0;break r}if(t=i[A+108>>2],r=r-t|0,o=r>>2,f=o+1|0,f>>>0>=1073741824)break e;if(k=k-t|0,n=k>>1,k=k>>>0>=2147483644?1073741823:f>>>0<n>>>0?n:f,k){if(k>>>0>=1073741824)break i;f=p(k<<2)}else f=0;if(n=f+r|0,i[n>>2]=e,o=n-(o<<2)|0,r&&x(o,t,r),i[A+116>>2]=f+(k<<2),e=n+4|0,i[A+112>>2]=e,i[A+108>>2]=o,!t)break r;Z(t)}i[A+112>>2]=e}return}G0(),H()}z0(),H()}function Gg(A,e,r,f,k){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0;var n=0,t=0,o=0;n=v-32|0,v=n,i[n+28>>2]=e;i:{if(!(i[r+4>>2]&1)){r=W[i[i[A>>2]+24>>2]](A,e,r,f,k)|0;break i}e=n+16|0,A=i[r+28>>2],i[e>>2]=A,(A|0)!=129576&&(i[A+4>>2]=i[A+4>>2]+1),A=c0(e,129824),e2(e);e:{if(k){W[i[i[A>>2]+24>>2]](e,A);break e}W[i[i[A>>2]+28>>2]](n+16|0,A)}for(t=n,o=T4(n+16|0),i[t+12>>2]=o;;){if(A=n+16|0,t=n,o=s6(A),i[t+8>>2]=o,i[n+12>>2]==i[n+8>>2])r=i[n+28>>2],R1(A);else{Mo(n+28|0,i[i[n+12>>2]>>2]),i[n+12>>2]=i[n+12>>2]+4;continue}break}}return v=n+32|0,r|0}function Xg(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0;f=v-32|0,v=f,k=W[i[i[e>>2]+52>>2]](e,r,0)|0,n=i[e+12>>2];i:{if(!n&u0[e+8>>2]>=u0[e+32>>2]|n){if(I4(r,e+100|0),i[r+12>>2]=k,W[i[i[e>>2]+56>>2]](f+12|0,e,r,i[r+4>>2]-(i[r>>2]+k|0)|0,0),i[r+12>>2]=i[r+4>>2]-i[r>>2],u[f+31|0]<0&&Z(i[f+20>>2]),e=i[26917],i[A>>2]=i[26916],i[A+4>>2]=e,A=A+8|0,u[107683]>=0){e=i[26919],i[A>>2]=i[26918],i[A+4>>2]=e,i[A+8>>2]=i[26920];break i}T(A,i[26918],i[26919]);break i}if(u[f|0]=0,u[f+11|0]=0,q(A,2,101,f),u[f+11|0]>=0)break i;Z(i[f>>2])}v=f+32|0}function Wg(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0;var k=0;f=v-32|0,v=f,z2(f,e,r),u[f+19|0]<0&&Z(i[f+8>>2]);i:{if(l[e+97|0]){t1(A,e,28326);break i}if(B4(f+20|0,r),u[e+115|0]<0&&Z(i[e+104>>2]),k=i[f+24>>2],i[e+104>>2]=i[f+20>>2],i[e+108>>2]=k,i[e+112>>2]=i[f+28>>2],l[r+20|0]==1){if(u[f+20|0]=0,u[f+31|0]=0,q(A,2,100,f+20|0),u[f+31|0]>=0)break i;Z(i[f+20>>2]);break i}if(e=i[26917],i[A>>2]=i[26916],i[A+4>>2]=e,A=A+8|0,u[107683]>=0){e=i[26919],i[A>>2]=i[26918],i[A+4>>2]=e,i[A+8>>2]=i[26920];break i}T(A,i[26918],i[26919])}v=f+32|0}function Qg(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0;var k=0;f=v-32|0,v=f,z2(f,e,r),u[f+19|0]<0&&Z(i[f+8>>2]);i:{if(l[e+97|0]){t1(A,e,10543);break i}if(B4(f+20|0,r),u[e+115|0]<0&&Z(i[e+104>>2]),k=i[f+24>>2],i[e+104>>2]=i[f+20>>2],i[e+108>>2]=k,i[e+112>>2]=i[f+28>>2],l[r+20|0]==1){if(u[f+20|0]=0,u[f+31|0]=0,q(A,2,100,f+20|0),u[f+31|0]>=0)break i;Z(i[f+20>>2]);break i}if(e=i[26917],i[A>>2]=i[26916],i[A+4>>2]=e,A=A+8|0,u[107683]>=0){e=i[26919],i[A>>2]=i[26918],i[A+4>>2]=e,i[A+8>>2]=i[26920];break i}T(A,i[26918],i[26919])}v=f+32|0}function gg(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0;var k=0;f=v-32|0,v=f,z2(f,e,r),u[f+19|0]<0&&Z(i[f+8>>2]);i:{if(l[e+97|0]){t1(A,e,10965);break i}if(B4(f+20|0,r),u[e+115|0]<0&&Z(i[e+104>>2]),k=i[f+24>>2],i[e+104>>2]=i[f+20>>2],i[e+108>>2]=k,i[e+112>>2]=i[f+28>>2],l[r+20|0]==1){if(u[f+20|0]=0,u[f+31|0]=0,q(A,2,100,f+20|0),u[f+31|0]>=0)break i;Z(i[f+20>>2]);break i}if(e=i[26917],i[A>>2]=i[26916],i[A+4>>2]=e,A=A+8|0,u[107683]>=0){e=i[26919],i[A>>2]=i[26918],i[A+4>>2]=e,i[A+8>>2]=i[26920];break i}T(A,i[26918],i[26919])}v=f+32|0}function Vg(A,e,r,f,k){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0;var n=0,t=0,o=0;n=v-32|0,v=n,i[n+28>>2]=e;i:{if(!(i[r+4>>2]&1)){r=W[i[i[A>>2]+24>>2]](A,e,r,f,k)|0;break i}e=n+16|0,A=i[r+28>>2],i[e>>2]=A,(A|0)!=129576&&(i[A+4>>2]=i[A+4>>2]+1),A=c0(e,129816),e2(e);e:{if(k){W[i[i[A>>2]+24>>2]](e,A);break e}W[i[i[A>>2]+28>>2]](n+16|0,A)}for(t=n,o=T4(n+16|0),i[t+12>>2]=o;;){if(A=n+16|0,t=n,o=w6(A),i[t+8>>2]=o,i[n+12>>2]==i[n+8>>2])r=i[n+28>>2],s2(A);else{m5(n+28|0,u[i[n+12>>2]]),i[n+12>>2]=i[n+12>>2]+1;continue}break}}return v=n+32|0,r|0}function Fg(A,e,r,f,k,n,t){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,t=t|0;var o=0;for(r=v-128|0,v=r,i[r+12>>2]=r+116,f=r+16|0,Co(A+8|0,f,r+12|0,k,n,t),t=v-16|0,v=t,A=v-32|0,v=A,yl(A+24|0,f,i[r+12>>2]),o=i[A+28>>2],n=v-16|0,v=n,k=i[A+24>>2],i[n+8>>2]=k,i[n+12>>2]=e;;){if((k|0)!=(o|0)){m5(n+12|0,u[k|0]),k=k+1|0,i[n+8>>2]=k;continue}break}return i[A+16>>2]=i[n+8>>2],i[A+20>>2]=i[n+12>>2],v=n+16|0,i[A+12>>2]=(i[A+16>>2]-f|0)+f,i[A+8>>2]=i[A+20>>2],i[t+8>>2]=i[A+12>>2],i[t+12>>2]=i[A+8>>2],v=A+32|0,v=t+16|0,v=r+128|0,i[t+12>>2]}function Ht(A,e){var r=0,f=0,k=0,n=0,t=0,o=0;if(f=i[A+8>>2],r=i[A+4>>2],(f-r|0)/6>>>0>=e>>>0){e&&(e=G(e,6)-6|0,e=(e-((e>>>0)%6|0)|0)+6|0,e&&o0(r,0,e),r=e+r|0),i[A+4>>2]=r;return}i:{if(n=r,r=i[A>>2],t=n-r|0,k=((t|0)/6|0)+e|0,k>>>0<715827883){if(f=(f-r|0)/6|0,n=f<<1,k=f>>>0>=357913941?715827882:k>>>0<n>>>0?n:k,k){if(k>>>0>=715827883)break i;o=p(G(k,6))}f=t+o|0,e=G(e,6)-6|0,e=(e-((e>>>0)%6|0)|0)+6|0,e&&o0(f,0,e),n=f+G((t|0)/-6|0,6)|0,t&&x(n,r,t),i[A+8>>2]=G(k,6)+o,i[A+4>>2]=e+f,i[A>>2]=n,r&&Z(r);return}G0(),H()}z0(),H()}function d4(A,e,r,f){var k=0,n=0,t=0;if(k=i[A+8>>2],n=i[A>>2],k-n>>>0>=f>>>0){if(t=f,k=i[A+4>>2],f=k-n|0,t>>>0>f>>>0){(k|0)!=(n|0)&&(f&&x(n,e,f),k=i[A+4>>2]),f=e+f|0,e=r-f|0,!e|(r|0)==(f|0)||x(k,f,e),i[A+4>>2]=e+k;return}f=r-e|0,!f|(e|0)==(r|0)||x(n,e,f),i[A+4>>2]=f+n;return}if(n&&(i[A+4>>2]=n,Z(n),i[A+8>>2]=0,i[A>>2]=0,i[A+4>>2]=0,k=0),(f|0)>=0){n=k<<1,k=k>>>0>=1073741823?2147483647:f>>>0<n>>>0?n:f,f=p(k),i[A+4>>2]=f,i[A>>2]=f,i[A+8>>2]=f+k,k=r-e|0,!k|(e|0)==(r|0)||x(f,e,k),i[A+4>>2]=f+k;return}G0(),H()}function Ig(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,t=0;if(k=v-32|0,v=k,t=W[i[i[e>>2]+52>>2]](e,r,0)|0,F0(r,i[e+104>>2]),l[e+112|0]==1&&F0(r,i[e+108>>2]),F0(r,i[e+120>>2]-i[e+116>>2]>>3),f=i[e+116>>2],n=i[e+120>>2],(f|0)!=(n|0))for(;F0(r,i[f>>2]),F0(r,i[f+4>>2]),f=f+8|0,(n|0)!=(f|0););f1(k+12|0,e,r,t),u[k+31|0]<0&&Z(i[k+20>>2]),e=i[26917],i[A>>2]=i[26916],i[A+4>>2]=e,A=A+8|0;i:{if(u[107683]>=0){e=i[26919],i[A>>2]=i[26918],i[A+4>>2]=e,i[A+8>>2]=i[26920];break i}T(A,i[26918],i[26919])}v=k+32|0}function Cg(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0;f=v-32|0,v=f,n=W[i[i[e>>2]+52>>2]](e,r,0)|0;i:{e:{if(!(u0[e+100>>2]>65535|u0[e+104>>2]>65535)){if(k=u0[e+108>>2]>65535,l2(r,k),k)break e;u2(r,C[e+100>>1]),u2(r,C[e+104>>1]),u2(r,C[e+108>>1]);break i}l2(r,1)}F0(r,i[e+100>>2]),F0(r,i[e+104>>2]),F0(r,i[e+108>>2])}f1(f+12|0,e,r,n),u[f+31|0]<0&&Z(i[f+20>>2]),e=i[26917],i[A>>2]=i[26916],i[A+4>>2]=e,A=A+8|0;i:{if(u[107683]>=0){e=i[26919],i[A>>2]=i[26918],i[A+4>>2]=e,i[A+8>>2]=i[26920];break i}T(A,i[26918],i[26919])}v=f+32|0}function pg(A,e,r,f,k,n){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0;var t=0,o=0,s=0;t=v-16|0,v=t,i[t+12>>2]=0,i[t+4>>2]=0,i[t+8>>2]=0;i:{if(n){if((n|0)<0)break i;n=n<<2,o=p(n),i[t+4>>2]=o,s=n+o|0,i[t+12>>2]=s,n&&x(o,k,n),i[t+8>>2]=s}e=i[e>>2],k=i[e+48>>2],e=i[e+52>>2];e:{if(!e){a4(k,f,r,t+4|0);break e}if(i[e+4>>2]=i[e+4>>2]+1,a4(k,f,r,t+4|0),r=i[e+4>>2],i[e+4>>2]=r-1,r)break e;W[i[i[e>>2]+8>>2]](e),y(e)}e=i[24057],i[A>>2]=i[24056],i[A+4>>2]=e,i[A+8>>2]=i[24058],A=i[t+4>>2],A&&(i[t+8>>2]=A,Z(A)),v=t+16|0;return}G0(),H()}function yg(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0;var k=0,n=0,t=0,o=0;e=v-16|0,v=e,f=i[r+16>>2],f&&(k=i[r+8>>2],k&&(c1(k,f),f=i[r+16>>2]),k=i[r>>2],t=W[i[i[k>>2]+8>>2]](k)|0,n=l0,o=f,f=f+t|0,n=o>>>0>f>>>0?n+1|0:n,W[i[i[k>>2]+20>>2]](k,f,n)|0,i[r+16>>2]=0);i:{if(l[r+20|0]==1){if(u[e+4|0]=0,u[e+15|0]=0,q(A,2,100,e+4|0),u[e+15|0]>=0)break i;Z(i[e+4>>2]);break i}if(r=i[26917],i[A>>2]=i[26916],i[A+4>>2]=r,A=A+8|0,u[107683]>=0){r=i[26919],i[A>>2]=i[26918],i[A+4>>2]=r,i[A+8>>2]=i[26920];break i}T(A,i[26918],i[26919])}v=e+16|0}function Eg(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,t=0;if(f=v-32|0,v=f,n=W[i[i[e>>2]+52>>2]](e,r,0)|0,F4(r,e+104|0,1),k=i[e+116>>2],t=i[e+120>>2],(k|0)!=(t|0))for(;l2(r,l[k|0]),k=k+1|0,(t|0)!=(k|0););i[r+12>>2]=n,W[i[i[e>>2]+56>>2]](f+12|0,e,r,i[r+4>>2]-(i[r>>2]+n|0)|0,0),i[r+12>>2]=i[r+4>>2]-i[r>>2],u[f+31|0]<0&&Z(i[f+20>>2]),e=i[26917],i[A>>2]=i[26916],i[A+4>>2]=e,A=A+8|0;i:{if(u[107683]>=0){e=i[26919],i[A>>2]=i[26918],i[A+4>>2]=e,i[A+8>>2]=i[26920];break i}T(A,i[26918],i[26919])}v=f+32|0}function zt(A){A=A|0;var e=0,r=0,f=0;if(i[A>>2]=106672,e=i[A+304>>2],f=A+308|0,(e|0)!=(f|0))for(;;){x2(i[e+40>>2]),i[e+40>>2]=0,r=i[e+4>>2];i:{if(r){for(;;)if(e=r,r=i[e>>2],!r)break i}for(;r=e,e=i[e+8>>2],(r|0)!=i[e>>2];);}if((e|0)==(f|0))break}e=i[A+332>>2],i[A+332>>2]=0,e&&(r=i[e+4>>2],r&&(W[i[i[e>>2]+40>>2]](r),i[e+4>>2]=0),Z(e)),r=A+304|0,e=i[A+324>>2];i:{if(!e||(f=i[e+4>>2],i[e+4>>2]=f-1,f))break i;W[i[i[e>>2]+8>>2]](e),y(e)}return s5(r,i[A+308>>2]),ai(A)|0}function Yg(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0;var k=0,n=0;f=v-32|0,v=f,z2(f,e,r),u[f+19|0]<0&&Z(i[f+8>>2]);i:{if(l[e+97|0]){t1(A,e,15902);break i}if(k=e,n=o2(r),g[k+104>>1]=n,k=e,n=o2(r),g[k+106>>1]=n,k=e,n=o2(r),g[k+108>>1]=n,k=e,n=o2(r),g[k+110>>1]=n,l[r+20|0]==1){if(u[f+20|0]=0,u[f+31|0]=0,q(A,2,100,f+20|0),u[f+31|0]>=0)break i;Z(i[f+20>>2]);break i}if(e=i[26917],i[A>>2]=i[26916],i[A+4>>2]=e,A=A+8|0,u[107683]>=0){e=i[26919],i[A>>2]=i[26918],i[A+4>>2]=e,i[A+8>>2]=i[26920];break i}T(A,i[26918],i[26919])}v=f+32|0}function Rg(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0;var k=0,n=0,t=0;if(!f){e=i[23570],i[A>>2]=i[23569],i[A+4>>2]=e,i[A+8>>2]=i[23571];return}if(n=i[e>>2],k=i[n+156>>2],n=i[n+160>>2],(k|0)!=(n|0))for(;;){if(t=i[k>>2],i[t>>2]==(r|0)){k=i[k+4>>2],k&&(i[k+4>>2]=i[k+4>>2]+1),r=p(16),n=i[e>>2],e=i[e+4>>2],e&&(i[e+4>>2]=i[e+4>>2]+1),i[r+12>>2]=k,i[r+8>>2]=t,i[r+4>>2]=e,i[r>>2]=n,i[f>>2]=r,i[A+8>>2]=i[24058],e=i[24057],i[A>>2]=i[24056],i[A+4>>2]=e;return}if(k=k+8|0,(n|0)==(k|0))break}i[A>>2]=5,i[A+4>>2]=2e3,i[A+8>>2]=3448}function Jg(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0;var k=0,n=0,t=0;if(!f){e=i[23570],i[A>>2]=i[23569],i[A+4>>2]=e,i[A+8>>2]=i[23571];return}if(n=i[e>>2],k=i[n+168>>2],n=i[n+172>>2],(k|0)!=(n|0))for(;;){if(t=i[k>>2],i[t>>2]==(r|0)){k=i[k+4>>2],k&&(i[k+4>>2]=i[k+4>>2]+1),r=p(16),n=i[e>>2],e=i[e+4>>2],e&&(i[e+4>>2]=i[e+4>>2]+1),i[r+12>>2]=k,i[r+8>>2]=t,i[r+4>>2]=e,i[r>>2]=n,i[f>>2]=r,i[A+8>>2]=i[24058],e=i[24057],i[A>>2]=i[24056],i[A+4>>2]=e;return}if(k=k+8|0,(n|0)==(k|0))break}i[A>>2]=5,i[A+4>>2]=2e3,i[A+8>>2]=3423}function Ng(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,t=0,o=0;for(k=v-16|0,v=k;;){i:{if((r|0)<=(t|0))break i;f=i[A+12>>2],o=i[A+16>>2];e:{if(f>>>0<o>>>0){i[k+12>>2]=2147483647,i[k+8>>2]=o-f,i[k+4>>2]=r-t,f=v-16|0,v=f,v=f+16|0,f=v-16|0,v=f,v=f+16|0,o=i[A+12>>2],f=k+4|0,n=k+8|0,f=i[f>>2]<i[n>>2]?f:n,n=k+12|0,f=i[(i[f>>2]<i[n>>2]?f:n)>>2],n=!f,n|n||x(e,o,f),i[A+12>>2]=i[A+12>>2]+f;break e}if(f=W[i[i[A>>2]+40>>2]](A)|0,(f|0)==-1)break i;u[e|0]=f<<24>>24,f=1}e=e+f|0,t=f+t|0;continue}break}return v=k+16|0,t|0}function Ug(A,e,r,f,k,n){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0;var t=0;i:{if(t=W[i[i[e>>2]+68>>2]](i[e+4>>2])|0,e=i[t>>2],!e)break i;for(;;){if(n4(i[e+4>>2],r)){if(e=i[t+4>>2],t=t+4|0,e)continue;break i}break}if(i[e+8>>2]!=1){e=i[24203],i[A>>2]=i[24202],i[A+4>>2]=e,i[A+8>>2]=i[24204];return}e:{if(!l[e+16|0]||(k&&(i[k>>2]=i[e+20>>2]),!n))break e;i[n>>2]=i[e+24>>2]}f&&(i[f>>2]=l[e+16|0]),e=i[24057],i[A>>2]=i[24056],i[A+4>>2]=e,i[A+8>>2]=i[24058];return}e=i[24203],i[A>>2]=i[24202],i[A+4>>2]=e,i[A+8>>2]=i[24204]}function Dg(A){return A=A|0,l[129860]?i[32464]:(l[130928]||(u[130928]=1),P2(130640,84048),P2(130652,84080),P2(130664,84116),P2(130676,84140),P2(130688,84164),P2(130700,84180),P2(130712,84200),P2(130724,84220),P2(130736,84248),P2(130748,84288),P2(130760,84320),P2(130772,84356),P2(130784,84392),P2(130796,84408),P2(130808,84424),P2(130820,84440),P2(130832,84164),P2(130844,84456),P2(130856,84472),P2(130868,84488),P2(130880,84504),P2(130892,84520),P2(130904,84536),P2(130916,84552),u[129860]=1,i[32464]=130640,130640)}function Mg(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,t=0,o=0;if(f=v-48|0,v=f,o=W[i[i[e>>2]+52>>2]](e,r,0)|0,F0(r,i[e+108>>2]-i[e+104>>2]>>3),k=i[e+104>>2],n=i[e+108>>2],(k|0)!=(n|0))for(;t=i[k>>2],W[i[i[t>>2]+20>>2]](f+28|0,t,r),u[f+47|0]<0&&Z(i[f+36>>2]),k=k+8|0,(n|0)!=(k|0););f1(f+8|0,e,r,o),u[f+27|0]<0&&Z(i[f+16>>2]),e=i[26917],i[A>>2]=i[26916],i[A+4>>2]=e,A=A+8|0;i:{if(u[107683]>=0){e=i[26919],i[A>>2]=i[26918],i[A+4>>2]=e,i[A+8>>2]=i[26920];break i}T(A,i[26918],i[26919])}v=f+48|0}function Hg(A,e,r,f,k,n,t,o,s,w){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,t=t|0,o=o|0,s=s|0,w=w|0;var h=0,_=0,B=0;if(!((n|0)<=0|(k|0)<=0))for(t=14-w|0,_=k&2147483644,h=k&3,s=0,B=k>>>0<4;;){if(k=(G(f,s)<<1)+r|0,w=(G(e,s)<<1)+A|0,o=0,!B)for(;g[w>>1]=C[k>>1]<<t,g[w+2>>1]=C[k+2>>1]<<t,g[w+4>>1]=C[k+4>>1]<<t,g[w+6>>1]=C[k+6>>1]<<t,k=k+8|0,w=w+8|0,o=o+4|0,(_|0)!=(o|0););if(o=0,h)for(;g[w>>1]=C[k>>1]<<t,k=k+2|0,w=w+2|0,o=o+1|0,(h|0)!=(o|0););if(s=s+1|0,(s|0)==(n|0))break}}function xt(A,e,r){var f=0,k=0,n=0,t=0,o=0;n=v-16|0,v=n,f=v-32|0,v=f,nl(f+24|0,A,e),o=i[f+24>>2],e=v-16|0,v=e,k=i[f+28>>2],i[e+12>>2]=k,k=k-o|0,t=k>>2;i:{if(!t||(t=t<<2,!t))break i;x(r,o,t)}return i[e+8>>2]=r+k,i[f+16>>2]=i[e+12>>2],i[f+20>>2]=i[e+8>>2],v=e+16|0,o=i[f+16>>2],e=v-16|0,v=e,i[e+12>>2]=A,A=v-16|0,v=A,k=e+12|0,i[A+12>>2]=i[k>>2],v=A+16|0,A=n5(k,o-i[A+12>>2]>>2),v=e+16|0,i[f+12>>2]=A,i[f+8>>2]=(i[f+20>>2]-r|0)+r,i[n+8>>2]=i[f+12>>2],i[n+12>>2]=i[f+8>>2],v=f+32|0,v=n+16|0,i[n+12>>2]}function zr(A,e,r){var f=0,k=0,n=0;k=v-16|0,v=k,n=i[e>>2],i[k+8>>2]=i[A>>2],f=i[A+4>>2],i[k+12>>2]=f,f&&(i[f+4>>2]=i[f+4>>2]+1),r2(n+36|0,k+8|0),f=i[k+12>>2];i:{if(!f||(n=i[f+4>>2],i[f+4>>2]=n-1,n))break i;W[i[i[f>>2]+8>>2]](f),y(f)}f=i[e>>2],i[k+8>>2]=i[A+8>>2],e=i[A+12>>2],i[k+12>>2]=e,e&&(i[e+4>>2]=i[e+4>>2]+1),r2(f+36|0,k+8|0),e=i[k+12>>2];i:{if(!e||(f=i[e+4>>2],i[e+4>>2]=f-1,f))break i;W[i[i[e>>2]+8>>2]](e),y(e)}i[A+16>>2]!=i[A+20>>2]&&(e=Ie(i[r>>2],A+16|0),sA(i[A+8>>2],e)),v=k+16|0}function I4(A,e){var r=0,f=0,k=0,n=0,t=0,o=0;i:{r=i[A+4>>2],t=i[A>>2],o=r-t|0,f=i[A+12>>2]+(i[e+4>>2]-i[e>>2]|0)|0;e:{if(o>>>0>=f>>>0)break e;if(k=f-o|0,n=i[A+8>>2],k>>>0<=n-r>>>0){k&&o0(r,0,k),i[A+4>>2]=r+k;break e}if((f|0)<0)break i;if(r=n-t|0,n=r<<1,n=r>>>0>=1073741823?2147483647:f>>>0<n>>>0?n:f,r=p(n),k&&o0(r+o|0,0,k),o&&x(r,t,o),i[A+8>>2]=r+n,i[A+4>>2]=r+f,i[A>>2]=r,!t)break e;Z(t)}f=i[e>>2],k=i[e+4>>2]-f|0,k&&x(i[A>>2]+i[A+12>>2]|0,f,k),i[A+12>>2]=i[A+12>>2]+(i[e+4>>2]-i[e>>2]|0);return}G0(),H()}function zg(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0;var k=0;k=i[e>>2],e=i[e+4>>2],e&&(i[e+4>>2]=i[e+4>>2]+1);i:{e:{r:{if(!k||(k=W0(k,106564,106696),!k))break r;if(e&&(i[e+4>>2]=i[e+4>>2]+1),r&&(g[r>>1]=C[k+288>>1]),f&&(g[f>>1]=C[k+290>>1]),r=i[24164],i[A>>2]=i[24163],i[A+4>>2]=r,i[A+8>>2]=i[24165],!e)break i;if(A=i[e+4>>2],i[e+4>>2]=A-1,A)break e;W[i[i[e>>2]+8>>2]](e),y(e);break e}if(i[A>>2]=5,i[A+4>>2]=2006,i[A+8>>2]=24737,!e)break i}if(A=i[e+4>>2],i[e+4>>2]=A-1,A)break i;W[i[i[e>>2]+8>>2]](e),y(e)}}function xr(A,e){var r=0,f=0,k=0,n=0;if(f=v-16|0,v=f,i[f+12>>2]=0,i[f+4>>2]=0,i[f+8>>2]=0,r=i[A+28>>2],k=i[A+32>>2],(r|0)!=(k|0)){for(;i[r>>2]!=i[e>>2]&&r2(f+4|0,r),r=r+8|0,(k|0)!=(r|0););r=i[A+28>>2]}if(r){if(k=r,e=i[A+32>>2],(r|0)!=(e|0)){for(;;){n=i[e-4>>2];i:{if(!n||(k=i[n+4>>2],i[n+4>>2]=k-1,k))break i;W[i[i[n>>2]+8>>2]](n),y(n)}if(e=e-8|0,(r|0)==(e|0))break}k=i[A+28>>2]}i[A+32>>2]=r,Z(k)}i[A+28>>2]=i[f+4>>2],i[A+32>>2]=i[f+8>>2],i[A+36>>2]=i[f+12>>2],v=f+16|0}function Tt(A,e,r,f){var k=0,n=0,t=0,o=0,s=0;if(k=i[A+24>>2],n=i[A+28>>2],k>>>0<n>>>0){i[k+8>>2]=f,i[k+4>>2]=r,i[k>>2]=e,i[A+24>>2]=k+12;return}i:{if(s=i[A+20>>2],k=k-s|0,t=((k|0)/12|0)+1|0,t>>>0<357913942){if(n=(n-s|0)/12|0,o=n<<1,o=n>>>0>=178956970?357913941:o>>>0>t>>>0?o:t,o){if(o>>>0>=357913942)break i;t=p(G(o,12))}else t=0;n=t+k|0,i[n+8>>2]=f,i[n+4>>2]=r,i[n>>2]=e,e=n+G((k|0)/-12|0,12)|0,k&&x(e,s,k),i[A+28>>2]=t+G(o,12),r=n+12|0,i[A+24>>2]=r,i[A+20>>2]=e,s&&Z(s),i[A+24>>2]=r;return}G0(),H()}z0(),H()}function xg(A,e,r,f,k,n,t,o){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,t=t|0,o=o|0;var s=0,w=0,h=0,_=0,B=0,m=0,X=0,Q=0;if(!(n&1)){if(!((t|0)<=0|(n|0)<=0))for(X=15-o|0,Q=1<<14-o,h=-1<<o^-1;;){for(o=(G(e,_)<<1)+A|0,s=G(k,_)<<1,B=s+f|0,s=r+s|0,m=0;w=g[B>>1]+(g[s>>1]+Q|0)>>X,g[o>>1]=(w|0)>=0?(w|0)<(h|0)?w:h:0,w=g[B+2>>1]+(g[s+2>>1]+Q|0)>>X,g[o+2>>1]=(w|0)>=0?(w|0)<(h|0)?w:h:0,B=B+4|0,s=s+4|0,o=o+4|0,m=m+2|0,(m|0)<(n|0););if(_=_+1|0,(_|0)==(t|0))break}return}D0(21986,18216,238,10389),H()}function Tg(A,e){A=A|0,e=e|0;var r=0,f=0;r=i[A>>2],A=i[r+104>>2],r=i[r+108>>2];i:{if((A|0)!=(r|0))for(;;){e:{if(f=i[A>>2],!f||(f=W0(f,86580,89104),!f))break e;if(r=i[A+4>>2],r&&(i[r+4>>2]=i[r+4>>2]+1),e&&(A=i[f+104>>2],i[e>>2]=i[f+100>>2],i[e+4>>2]=A,A=i[f+120>>2],i[e+16>>2]=i[f+116>>2],i[e+20>>2]=A,A=i[f+112>>2],i[e+8>>2]=i[f+108>>2],i[e+12>>2]=A),A=1,!r||(e=i[r+4>>2],i[r+4>>2]=e-1,e))break i;return W[i[i[r>>2]+8>>2]](r),y(r),1}if(A=A+8|0,(r|0)==(A|0))break}A=0}return A|0}function Sg(A){A=A|0;var e=0,r=0,f=0;if(e=v-128|0,v=e,f=e+104|0,Br(f,A,1),A=-1,r=l[e+124|0],!r){g[e+24>>1]=0,o0(e+28|0,0,72),J7(e+4|0,e+24|0,f),A=-1;i:{if(i[e+4>>2]||(r=i[e+60>>2],A=-1,i[e+64>>2]-r>>>0<5))break i;A=l[r+6|0]}u[e+23|0]<0&&Z(i[e+12>>2]),r=i[e+84>>2],r&&(i[e+88>>2]=r,Z(r)),r=i[e+72>>2],r&&(i[e+76>>2]=r,Z(r)),r=i[e+60>>2],r&&(i[e+64>>2]=r,Z(r)),r=l[e+124|0]}return(r|0)!=255&&(f=i[24741],i[e+24>>2]=i[24740],i[e+28>>2]=f,W[i[(e+24|0)+(r<<2)>>2]](e+4|0,e+104|0)),v=e+128|0,A|0}function jg(A,e){A=A|0,e=e|0;var r=0,f=0,k=0,n=0,t=0,o=0,s=0,w=0,h=0,_=0,B=0,m=0,X=0;if((e|0)>=2)for(h=(e|0)/2|0,_=e&2147483646,B=e&1;;){for(n=(G(e,o)<<1)+A|0,m=n+2|0,s=(G(e-o|0,e)<<1)+A|0,r=0,t=0;f=r<<1,k=f+n|0,X=C[k>>1],w=k,k=((r^-1)<<1)+s|0,g[w>>1]=C[k>>1],g[k>>1]=X,f=f+m|0,k=C[f>>1],w=f,f=((r^2147483646)<<1)+s|0,g[w>>1]=C[f>>1],g[f>>1]=k,r=r+2|0,t=t+2|0,(_|0)!=(t|0););if(B&&(n=n+(r<<1)|0,t=C[n>>1],r=((r^-1)<<1)+s|0,g[n>>1]=C[r>>1],g[r>>1]=t),o=o+1|0,(h|0)==(o|0))break}}function Og(A){A=A|0;var e=0,r=0,f=0;if(e=v-128|0,v=e,f=e+104|0,Br(f,A,1),A=-1,r=l[e+124|0],!r){g[e+24>>1]=0,o0(e+28|0,0,72),J7(e+4|0,e+24|0,f),A=-1;i:{if(i[e+4>>2]||(r=i[e+60>>2],A=-1,(r|0)==i[e+64>>2]))break i;A=l[r+2|0]}u[e+23|0]<0&&Z(i[e+12>>2]),r=i[e+84>>2],r&&(i[e+88>>2]=r,Z(r)),r=i[e+72>>2],r&&(i[e+76>>2]=r,Z(r)),r=i[e+60>>2],r&&(i[e+64>>2]=r,Z(r)),r=l[e+124|0]}return(r|0)!=255&&(f=i[24741],i[e+24>>2]=i[24740],i[e+28>>2]=f,W[i[(e+24|0)+(r<<2)>>2]](e+4|0,e+104|0)),v=e+128|0,A|0}function Pg(A,e,r,f,k){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0;var n=0,t=0,o=0,s=0,w=0,h=0,_=0,B=0,m=0;if((f|0)>0)for(B=f&2147483646,m=f&1,t=-1<<k^-1;;){if(o=G(e,w)+A|0,h=(G(f,w)<<2)+r|0,k=0,_=0,(f|0)!=1)for(;s=k+o|0,n=i[(k<<2)+h>>2]+l[s|0]|0,u[s|0]=(n|0)>=0?(n|0)<(t|0)?n:t:0,n=k|1,s=n+o|0,n=i[(n<<2)+h>>2]+l[s|0]|0,u[s|0]=(n|0)>=0?(n|0)<(t|0)?n:t:0,k=k+2|0,_=_+2|0,(B|0)!=(_|0););if(m&&(o=k+o|0,k=i[(k<<2)+h>>2]+l[o|0]|0,u[o|0]=(k|0)>=0?(k|0)<(t|0)?k:t:0),w=w+1|0,(w|0)==(f|0))break}}function Lg(A,e,r,f,k,n,t,o){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,t=t|0,o=o|0;var s=0,w=0,h=0,_=0,B=0;if(!((n|0)<=0|(k|0)<=0))for(t=14-o|0,_=k&2147483644,h=k&3,B=k>>>0<4;;){if(k=(G(e,w)<<1)+A|0,o=(G(f,w)<<1)+r|0,s=0,!B)for(;g[k>>1]=C[o>>1]<<t,g[k+2>>1]=C[o+2>>1]<<t,g[k+4>>1]=C[o+4>>1]<<t,g[k+6>>1]=C[o+6>>1]<<t,k=k+8|0,o=o+8|0,s=s+4|0,(_|0)!=(s|0););if(s=0,h)for(;g[k>>1]=C[o>>1]<<t,k=k+2|0,o=o+2|0,s=s+1|0,(h|0)!=(s|0););if(w=w+1|0,(w|0)==(n|0))break}}function Kg(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0;f=v-32|0,v=f,k=W[i[i[e>>2]+52>>2]](e,r,0)|0,l2(r,l[e+97|0]|128),l2(r,l[e+99|0]&31|l[e+98|0]<<5&224),l2(r,(l[e+106|0]&3|((l[e+101|0]?64:0)|(l[e+100|0]?-128:0)|(l[e+102|0]?32:0)|(l[e+103|0]?16:0)|(l[e+104|0]?8:0)|(l[e+105|0]?4:0)))&255),l2(r,0),f1(f+12|0,e,r,k),u[f+31|0]<0&&Z(i[f+20>>2]),e=i[26917],i[A>>2]=i[26916],i[A+4>>2]=e,A=A+8|0;i:{if(u[107683]>=0){e=i[26919],i[A>>2]=i[26918],i[A+4>>2]=e,i[A+8>>2]=i[26920];break i}T(A,i[26918],i[26919])}v=f+32|0}function qg(A){A=A|0;var e=0,r=0,f=0;e=v-48|0,v=e,W[i[i[A>>2]+112>>2]](e+12|0,A);i:{e:{r:switch(l[e+32|0]){default:_2(),H();case 1:r=i[e+12>>2]!=0,A=1;break e;case 0:break r}r=i[e+12>>2],A=i[e+16>>2];r:{if(!A){r=W[i[i[r>>2]+12>>2]](r)|0;break r}if(i[A+4>>2]=i[A+4>>2]+1,r=W[i[i[r>>2]+12>>2]](r)|0,f=i[A+4>>2],i[A+4>>2]=f-1,f)break r;W[i[i[A>>2]+8>>2]](A),y(A)}if(A=l[e+32|0],(A|0)==255)break i}f=i[25177],i[e+40>>2]=i[25176],i[e+44>>2]=f,W[i[(e+40|0)+(A<<2)>>2]](e+39|0,e+12|0)}return v=e+48|0,r|0}function ag(A){A=A|0;var e=0,r=0,f=0;e=v-48|0,v=e,W[i[i[A>>2]+112>>2]](e+12|0,A);i:{e:{r:switch(l[e+32|0]){default:_2(),H();case 1:r=i[e+12>>2]!=0,A=1;break e;case 0:break r}r=i[e+12>>2],A=i[e+16>>2];r:{if(!A){r=W[i[i[r>>2]+16>>2]](r)|0;break r}if(i[A+4>>2]=i[A+4>>2]+1,r=W[i[i[r>>2]+16>>2]](r)|0,f=i[A+4>>2],i[A+4>>2]=f-1,f)break r;W[i[i[A>>2]+8>>2]](A),y(A)}if(A=l[e+32|0],(A|0)==255)break i}f=i[25177],i[e+40>>2]=i[25176],i[e+44>>2]=f,W[i[(e+40|0)+(A<<2)>>2]](e+39|0,e+12|0)}return v=e+48|0,r|0}function $g(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,t=0,o=0,s=0,w=0,h=0,_=0;if((r|0)>0)for(h=r&2147483644,s=r&3,_=r>>>0<4;;){if(w=G(r,o),k=0,n=0,!_)for(;f=k+w|0,i[(f<<2)+A>>2]=g[(f<<1)+e>>1],t=f+1|0,i[(t<<2)+A>>2]=g[(t<<1)+e>>1],t=f+2|0,i[(t<<2)+A>>2]=g[(t<<1)+e>>1],f=f+3|0,i[(f<<2)+A>>2]=g[(f<<1)+e>>1],k=k+4|0,n=n+4|0,(h|0)!=(n|0););if(f=0,s)for(;n=k+w|0,i[(n<<2)+A>>2]=g[(n<<1)+e>>1],k=k+1|0,f=f+1|0,(s|0)!=(f|0););if(o=o+1|0,(o|0)==(r|0))break}}function dg(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0;var k=0,n=0,t=0;f=v-32|0,v=f,z2(f,e,r),u[f+19|0]<0&&Z(i[f+8>>2]),u[e+104|0]=1,n=e,t=Y4(r),i[n+112>>2]=t,i[e+116>>2]=l0,k=X2(r),u[e+120|0]=k>>>7,u[e+122|0]=k>>>5&1,u[e+121|0]=k>>>6&1;i:{if(l[r+20|0]==1){if(u[f+20|0]=0,u[f+31|0]=0,q(A,2,100,f+20|0),u[f+31|0]>=0)break i;Z(i[f+20>>2]);break i}if(e=i[26917],i[A>>2]=i[26916],i[A+4>>2]=e,A=A+8|0,u[107683]>=0){e=i[26919],i[A>>2]=i[26918],i[A+4>>2]=e,i[A+8>>2]=i[26920];break i}T(A,i[26918],i[26919])}v=f+32|0}function cg(A){return A=A|0,l[129852]?i[32462]:(l[130624]||(u[130624]=1),R2(130336,1619),R2(130348,1610),R2(130360,10876),R2(130372,9865),R2(130384,1753),R2(130396,12843),R2(130408,1627),R2(130420,3344),R2(130432,7604),R2(130444,7497),R2(130456,7595),R2(130468,7614),R2(130480,9340),R2(130492,18361),R2(130504,7720),R2(130516,6303),R2(130528,1753),R2(130540,7998),R2(130552,9809),R2(130564,10937),R2(130576,7916),R2(130588,4235),R2(130600,3094),R2(130612,18151),u[129852]=1,i[32462]=130336,130336)}function bg(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0;var k=0,n=0;f=v-32|0,v=f,z2(f,e,r),u[f+19|0]<0&&Z(i[f+8>>2]),k=e,n=Y4(r),i[k+112>>2]=n,i[e+116>>2]=l0,k=e,n=C0(r),i[k+120>>2]=n,k=e,n=C0(r),i[k+124>>2]=n,k=e,n=X2(r),u[k+128|0]=n;i:{if(l[r+20|0]==1){if(u[f+20|0]=0,u[f+31|0]=0,q(A,2,100,f+20|0),u[f+31|0]>=0)break i;Z(i[f+20>>2]);break i}if(e=i[26917],i[A>>2]=i[26916],i[A+4>>2]=e,A=A+8|0,u[107683]>=0){e=i[26919],i[A>>2]=i[26918],i[A+4>>2]=e,i[A+8>>2]=i[26920];break i}T(A,i[26918],i[26919])}v=f+32|0}function iV(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0;var k=0,n=0,t=0;f=v-16|0,v=f;i:{if(X2(r)&1){n=e,t=C0(r),i[n+100>>2]=t,n=e,t=C0(r),i[n+104>>2]=t,k=C0(r);break i}n=e,t=o2(r),i[n+100>>2]=t,n=e,t=o2(r),i[n+104>>2]=t,k=o2(r)}i[e+108>>2]=k;i:{if(l[r+20|0]==1){if(u[f+4|0]=0,u[f+15|0]=0,q(A,2,100,f+4|0),u[f+15|0]>=0)break i;Z(i[f+4>>2]);break i}if(e=i[26917],i[A>>2]=i[26916],i[A+4>>2]=e,A=A+8|0,u[107683]>=0){e=i[26919],i[A>>2]=i[26918],i[A+4>>2]=e,i[A+8>>2]=i[26920];break i}T(A,i[26918],i[26919])}v=f+16|0}function eV(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0;var k=0,n=0,t=0,o=0,s=0;k=i[A>>2],A=i[k+260>>2],o=i[k+264>>2];i:{if((A|0)==(o|0))break i;if(e)for(;;){k=i[A>>2],t=u[k+15|0],s=(t|0)<0,t=s?i[k+8>>2]:t;e:{if((t|0)!=(h2(e)|0)||N2(s?i[k+4>>2]:k+4|0,e,t))break e;if((f|0)<=(n|0))break i;i[(n<<2)+r>>2]=i[k>>2],n=n+1|0}if(A=A+8|0,(o|0)==(A|0))break i}for(e=(f|0)>0?f:0;;){if((e|0)==(n|0))return e|0;if(i[(n<<2)+r>>2]=i[i[A>>2]>>2],n=n+1|0,A=A+8|0,(o|0)==(A|0))break}}return n|0}function ti(A,e){var r=0,f=0,k=0,n=0,t=0,o=0;n=v-16|0,v=n,f=ql(e),k=v-16|0,v=k;i:{if(f>>>0<=1073741815){e:{if(f>>>0<2){u[A+11|0]=l[A+11|0]&128|f&127,u[A+11|0]=l[A+11|0]&127,r=A;break e}o=k+8|0,f>>>0>=2?(t=f+2&-2,r=t-1|0,r=(r|0)==2?t:r):r=1,pi(o,r+1|0),r=i[k+8>>2],i[A>>2]=r,i[A+8>>2]=i[A+8>>2]&-2147483648|i[k+12>>2]&2147483647,i[A+8>>2]=i[A+8>>2]|-2147483648,i[A+4>>2]=f}e:{if(!f||(A=f<<2,!A))break e;x(r,e,A)}i[k+4>>2]=0,i[(f<<2)+r>>2]=i[k+4>>2],v=k+16|0;break i}Z4(),H()}v=n+16|0}function rV(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0;f=v-32|0,v=f,k=W[i[i[e>>2]+52>>2]](e,r,0)|0,F0(r,i[e+104>>2]),F0(r,i[e+108>>2]),F0(r,i[e+112>>2]),F0(r,i[e+116>>2]),F0(r,i[e+120>>2]),F4(r,e+124|0,1),i[r+12>>2]=k,W[i[i[e>>2]+56>>2]](f+12|0,e,r,i[r+4>>2]-(i[r>>2]+k|0)|0,0),i[r+12>>2]=i[r+4>>2]-i[r>>2],u[f+31|0]<0&&Z(i[f+20>>2]),e=i[26917],i[A>>2]=i[26916],i[A+4>>2]=e,A=A+8|0;i:{if(u[107683]>=0){e=i[26919],i[A>>2]=i[26918],i[A+4>>2]=e,i[A+8>>2]=i[26920];break i}T(A,i[26918],i[26919])}v=f+32|0}function fV(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,t=0;if(k=v-32|0,v=k,t=W[i[i[e>>2]+52>>2]](e,r,0)|0,u2(r,(i[e+104>>2]-i[e+100>>2]|0)/6&65535),f=i[e+100>>2],n=i[e+104>>2],(f|0)!=(n|0))for(;u2(r,C[f>>1]),u2(r,C[f+2>>1]),u2(r,C[f+4>>1]),f=f+6|0,(n|0)!=(f|0););f1(k+12|0,e,r,t),u[k+31|0]<0&&Z(i[k+20>>2]),e=i[26917],i[A>>2]=i[26916],i[A+4>>2]=e,A=A+8|0;i:{if(u[107683]>=0){e=i[26919],i[A>>2]=i[26918],i[A+4>>2]=e,i[A+8>>2]=i[26920];break i}T(A,i[26918],i[26919])}v=k+32|0}function g8(A,e){var r=0,f=0,k=0,n=0,t=0,o=0,s=0,w=0;t=v-16|0,v=t,M2(+e),r=t2(1)|0,k=t2(0)|0,w=r,n=r&1048575,f=k,r=r>>>20&2047,k=0;i:{if(r|k){if((r|0)!=2047|k){o=(n&15)<<28|f>>>4,s=n>>>4|0,r=r+15360|0,k=f<<28,f=0;break i}o=(n&15)<<28|f>>>4,s=n>>>4|0,r=32767,k=f<<28,f=0;break i}if(!(n|f)){r=0,f=0;break i}k=n,n=k1(n),r=(n|0)==32?k1(f)+32|0:n,o4(t,f,k,0,0,r+49|0),o=i[t+8>>2],s=i[t+12>>2]^65536,r=15372-r|0,k=i[t+4>>2],f=i[t>>2]}i[A>>2]=f,i[A+4>>2]=k,i[A+8>>2]=o,i[A+12>>2]=s|(w&-2147483648|r<<16),v=t+16|0}function AV(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,t=0;if(k=v-32|0,v=k,t=W[i[i[e>>2]+52>>2]](e,r,0)|0,u2(r,(i[e+108>>2]-i[e+104>>2]|0)/6&65535),f=i[e+104>>2],n=i[e+108>>2],(f|0)!=(n|0))for(;u2(r,C[f>>1]),l2(r,l[f+2|0]),u2(r,C[f+4>>1]),f=f+6|0,(n|0)!=(f|0););f1(k+12|0,e,r,t),u[k+31|0]<0&&Z(i[k+20>>2]),e=i[26917],i[A>>2]=i[26916],i[A+4>>2]=e,A=A+8|0;i:{if(u[107683]>=0){e=i[26919],i[A>>2]=i[26918],i[A+4>>2]=e,i[A+8>>2]=i[26920];break i}T(A,i[26918],i[26919])}v=k+32|0}function kV(A,e){A=A|0,e=e|0;var r=0,f=0,k=0,n=0;i:{if(l[e+76|0]==1){if(u[e+76|0]=0,u[A+44|0]=0,u[A|0]=0,l[e+72|0]!=1)break i;i[A>>2]=i[e+28>>2],i[A+4>>2]=i[e+32>>2],i[A+8>>2]=i[e+36>>2],i[e+36>>2]=0,i[e+28>>2]=0,i[e+32>>2]=0,i[A+12>>2]=i[e+40>>2],i[A+16>>2]=i[e+44>>2],i[A+20>>2]=i[e+48>>2],i[e+48>>2]=0,i[e+40>>2]=0,i[e+44>>2]=0,r=i[e+60>>2],f=i[e+64>>2],k=i[e+68>>2],n=i[e+52>>2],e=i[e+56>>2],u[A+44|0]=1,i[A+40>>2]=k,i[A+32>>2]=r,i[A+36>>2]=f,i[A+24>>2]=n,i[A+28>>2]=e;return}u[A+44|0]=0,u[A|0]=0}}function nV(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0;f=v-32|0,v=f;i:{if(!(r&&e)){e=i[23570],i[A>>2]=i[23569],i[A+4>>2]=e,i[A+8>>2]=i[23571];break i}if(k=i[e>>2],!l[k+288|0]){if(u[f|0]=0,u[f+11|0]=0,r=q(f+12|0,5,138,f),u[f+11|0]<0&&Z(i[f>>2]),k=A,A=i[e>>2],b0(k,r,A?A+84|0:0),u[r+19|0]>=0)break i;Z(i[r+8>>2]);break i}t0[r>>3]=t0[k+296>>3],t0[r+8>>3]=t0[k+304>>3],t0[r+16>>3]=t0[k+312>>3],t0[r+24>>3]=t0[k+320>>3],t0[r+32>>3]=t0[k+328>>3],i[A+8>>2]=i[24058],e=i[24057],i[A>>2]=i[24056],i[A+4>>2]=e}v=f+32|0}function tV(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,t=0;if(k=v-32|0,v=k,t=W[i[i[e>>2]+52>>2]](e,r,0)|0,F0(r,(i[e+108>>2]-i[e+104>>2]|0)/12|0),f=i[e+104>>2],n=i[e+108>>2],(f|0)!=(n|0))for(;F0(r,i[f>>2]),F0(r,i[f+4>>2]),F0(r,i[f+8>>2]),f=f+12|0,(n|0)!=(f|0););f1(k+12|0,e,r,t),u[k+31|0]<0&&Z(i[k+20>>2]),e=i[26917],i[A>>2]=i[26916],i[A+4>>2]=e,A=A+8|0;i:{if(u[107683]>=0){e=i[26919],i[A>>2]=i[26918],i[A+4>>2]=e,i[A+8>>2]=i[26920];break i}T(A,i[26918],i[26919])}v=k+32|0}function Y6(A,e,r,f,k,n){var t=0,o=0,s=0,w=0;i:{if(n&64){r=n+-64|0,e=r&31,(r&63)>>>0>=32?(r=0,e=k>>>e|0):(r=k>>>e|0,e=((1<<e)-1&k)<<32-e|f>>>e),f=0,k=0;break i}if(!n)break i;s=f,o=64-n|0,t=o&31,(o&63)>>>0>=32?(o=f<<t,w=0):(o=(1<<t)-1&s>>>32-t|k<<t,w=s<<t),s=e,e=n&31,(n&63)>>>0>=32?(t=0,e=r>>>e|0):(t=r>>>e|0,e=((1<<e)-1&r)<<32-e|s>>>e),e=w|e,r=t|o,t=f,f=n&31,(n&63)>>>0>=32?(o=0,f=k>>>f|0):(o=k>>>f|0,f=((1<<f)-1&k)<<32-f|t>>>f),k=o}i[A>>2]=e,i[A+4>>2]=r,i[A+8>>2]=f,i[A+12>>2]=k}function uV(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,t=0;f=v-32|0,v=f,t=W[i[i[e>>2]+52>>2]](e,r,0)|0,F0(r,i[e+104>>2]),F0(r,i[e+108>>2]);i:{if(i[e+104>>2]||(k=i[e+112>>2],n=i[e+116>>2],(k|0)==(n|0)))break i;for(;F0(r,i[k>>2]),k=k+4|0,(n|0)!=(k|0););}f1(f+12|0,e,r,t),u[f+31|0]<0&&Z(i[f+20>>2]),e=i[26917],i[A>>2]=i[26916],i[A+4>>2]=e,A=A+8|0;i:{if(u[107683]>=0){e=i[26919],i[A>>2]=i[26918],i[A+4>>2]=e,i[A+8>>2]=i[26920];break i}T(A,i[26918],i[26919])}v=f+32|0}function oV(A,e){A=A|0,e=e|0;var r=0,f=0,k=0,n=0;r=v-32|0,v=r,f=i[A>>2];i:{e:{r:{if(e){if(A=h2(e),A>>>0>=2147483640)break i;f:{A:{if(A>>>0>=11){n=A|7,k=p(n+1|0),i[r+28>>2]=n-2147483647,i[r+20>>2]=k,i[r+24>>2]=A;break A}if(u[r+31|0]=A,k=r+20|0,!A)break f}if(!A)break f;x(k,e,A)}if(u[A+k|0]=0,A=r+20|0,W[i[i[f>>2]+36>>2]](f,A),u[r+31|0]>=0)break e;break r}if(i[r+16>>2]=0,i[r+8>>2]=0,i[r+12>>2]=0,A=r+8|0,W[i[i[f>>2]+36>>2]](f,A),u[r+19|0]>=0)break e}Z(i[A>>2])}v=r+32|0;return}Q0(),H()}function ue(A,e,r,f){var k=0,n=0,t=0,o=0;i:{e:{if(!f){k=i[A+12>>2],f=i[A+8>>2],A=k-f>>2;break e}if(f=i[A+8>>2],k=i[A+12>>2],(f|0)==(k|0)){A=0;break e}for(A=k-f>>2,o=A>>>0<=1?1:A;;){if(t=i[(n<<2)+f>>2],!(i[t+96>>2]!=(e|0)|i[t+108>>2]<=(r|0))&i[t+100>>2]==2)break i;if(n=n+1|0,(o|0)==(n|0))break}}if(n=-1,(f|0)==(k|0))break i;for(t=A>>>0<=1?1:A,A=0;;){if(k=i[(A<<2)+f>>2],!(i[k+96>>2]!=(e|0)|i[k+108>>2]<=(r|0)|!i[k+100>>2]))return A;if(A=A+1|0,(t|0)==(A|0))break}}return n}function lV(A,e,r,f,k,n,t,o,s){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,t=t|0,o=o|0,s=s|0;var w=0,h=0,_=0;if(!((n|0)<=0|(k|0)<=0))for(h=k&2147483644,w=k&3,s=0,_=k>>>0<4;;){if(k=G(f,s)+r|0,t=(G(e,s)<<1)+A|0,o=0,!_)for(;g[t>>1]=l[k|0]<<6,g[t+2>>1]=l[k+1|0]<<6,g[t+4>>1]=l[k+2|0]<<6,g[t+6>>1]=l[k+3|0]<<6,k=k+4|0,t=t+8|0,o=o+4|0,(h|0)!=(o|0););if(o=0,w)for(;g[t>>1]=l[k|0]<<6,k=k+1|0,t=t+2|0,o=o+1|0,(w|0)!=(o|0););if(s=s+1|0,(s|0)==(n|0))break}}function sV(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0;f=v-32|0,v=f;i:{if(!r){e=i[23570],i[A>>2]=i[23569],i[A+4>>2]=e,i[A+8>>2]=i[23571];break i}if(!S4(i[e>>2])){if(u[f|0]=0,u[f+11|0]=0,r=q(f+12|0,10,0,f),u[f+11|0]<0&&Z(i[f>>2]),k=A,A=i[e>>2],b0(k,r,A?A+84|0:0),u[r+19|0]>=0)break i;Z(i[r+8>>2]);break i}if(k=i[e>>2],n=C[k+10>>1]|C[k+12>>1]<<16,i[f>>2]=C[k+6>>1]|C[k+8>>1]<<16,i[f+4>>2]=n,k=f+12|0,Zn(k,f,r),r=A,A=i[e>>2],b0(r,k,A?A+84|0:0),u[f+31|0]>=0)break i;Z(i[f+20>>2])}v=f+32|0}function wV(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0;f=v-32|0,v=f;i:{if(!r){e=i[23570],i[A>>2]=i[23569],i[A+4>>2]=e,i[A+8>>2]=i[23571];break i}if(!S4(i[e>>2])){if(u[f|0]=0,u[f+11|0]=0,r=q(f+12|0,10,0,f),u[f+11|0]<0&&Z(i[f>>2]),k=A,A=i[e>>2],b0(k,r,A?A+92|0:0),u[r+19|0]>=0)break i;Z(i[r+8>>2]);break i}if(k=i[e>>2],n=C[k+10>>1]|C[k+12>>1]<<16,i[f>>2]=C[k+6>>1]|C[k+8>>1]<<16,i[f+4>>2]=n,k=f+12|0,Zn(k,f,r),r=A,A=i[e>>2],b0(r,k,A?A+92|0:0),u[f+31|0]>=0)break i;Z(i[f+20>>2])}v=f+32|0}function St(A,e){var r=0,f=0,k=0;i:{e:{r:{if(f=e&255,f){if(A&3)for(;;){if(r=l[A|0],!r|(r|0)==(f|0))break i;if(A=A+1|0,!(A&3))break}if(r=i[A>>2],((r|16843008-r)&-2139062144)!=-2139062144)break r;for(k=G(f,16843009);;){if(f=r^k,((16843008-f|f)&-2139062144)!=-2139062144)break r;if(r=i[A+4>>2],f=A+4|0,A=f,((16843008-r|r)&-2139062144)!=-2139062144)break}break e}return h2(A)+A|0}f=A}for(;;){if(A=f,r=l[A|0],!r)break i;if(f=A+1|0,(r|0)==(e&255))break}}return A}function jt(A){var e=0,r=0,f=0,k=0,n=0;return f=v-16|0,v=f,A=R0(A),i[A+40>>2]=0,i[A+32>>2]=0,i[A+36>>2]=0,i[A>>2]=71296,o0(A+52|0,0,40),u[A+98|0]=0,g[A+96>>1]=0,i[A+92>>2]=32,r=f+12|0,e=i[A+4>>2],i[r>>2]=e,(e|0)!=129576&&(i[e+4>>2]=i[e+4>>2]+1),e=Kl(i[r>>2],l1(129768)),e2(r),e&&(r=f+8|0,e=i[A+4>>2],i[r>>2]=e,(e|0)!=129576&&(i[e+4>>2]=i[e+4>>2]+1),k=A,n=c0(r,129768),i[k+68>>2]=n,e2(r),e=i[A+68>>2],k=A,n=W[i[i[e>>2]+28>>2]](e)|0,u[k+98|0]=n),W[i[i[A>>2]+12>>2]](A,0,4096)|0,v=f+16|0,A}function Ot(A,e){var r=0,f=0,k=0,n=0,t=0,o=0,s=0,w=0,h=0,_=0;f=v-16|0,v=f,G1(f+8|0,A);i:{if(!l[f+8|0]||(r=i[i[A>>2]-12>>2]+A|0,t=i[r+4>>2],n=f+4|0,r=i[r+28>>2],i[n>>2]=r,(r|0)!=129576&&(i[r+4>>2]=i[r+4>>2]+1),r=c0(n,129440),e2(n),i[f>>2]=i[(i[i[A>>2]-12>>2]+A|0)+24>>2],k=i[i[A>>2]-12>>2]+A|0,o=t6(k),s=k,k=e&65535,w=e,e=t&74,h=f,_=W[i[i[r>>2]+16>>2]](r,i[f>>2],s,o,(e|0)==64||(e|0)==8?k:w)|0,i[h+4>>2]=_,i[n>>2]))break i;m4(i[i[A>>2]-12>>2]+A|0,5)}return _1(f+8|0),v=f+16|0,A}function hV(A,e,r,f,k,n){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0;var t=0,o=0;i:{if(t=i[r+12>>2],!(i[r>>2]==1&i[r+4>>2]==3)|(t|0)<=8)break i;e:switch(o=C[f+20>>1],o-11|0){case 0:case 3:break i;default:break e}n=i[f+4>>2],(!l[k+12|0]|i[k+4>>2]==1)&(n|0)!=3||(n=3),r=l[r+8|0],k=i[f+16>>2],f=l[f+22|0],e=p(28),i[e+24>>2]=11,u[e+22|0]=f,g[e+20>>1]=o,i[e+16>>2]=k,i[e+12>>2]=t,u[e+8|0]=r,i[e+4>>2]=n,i[e>>2]=0,r=e+28|0,i[A+8>>2]=r,i[A>>2]=e,i[A+4>>2]=r;return}i[A+8>>2]=0,i[A>>2]=0,i[A+4>>2]=0}function u2(A,e){var r=0,f=0,k=0,n=0,t=0,o=0;i:{r=i[A+4>>2],t=i[A>>2],o=r-t|0,f=i[A+12>>2]+2|0;e:{if(o>>>0>=f>>>0)break e;if(n=f-o|0,k=i[A+8>>2],n>>>0<=k-r>>>0){n&&o0(r,0,n),i[A+4>>2]=r+n;break e}if((f|0)<0)break i;if(r=k-t|0,k=r<<1,k=r>>>0>=1073741823?2147483647:f>>>0<k>>>0?k:f,r=p(k),n&&o0(r+o|0,0,n),o&&x(r,t,o),i[A+8>>2]=r+k,i[A+4>>2]=r+f,i[A>>2]=r,!t)break e;Z(t)}f=i[A+12>>2],i[A+12>>2]=f+1,u[f+i[A>>2]|0]=e>>>8,f=i[A+12>>2],i[A+12>>2]=f+1,u[f+i[A>>2]|0]=e;return}G0(),H()}function Pt(A,e,r){var f=0,k=0,n=0,t=0,o=0;return n=v-16|0,v=n,f=v-32|0,v=f,nl(f+24|0,A,e),t=i[f+24>>2],e=v-16|0,v=e,k=i[f+28>>2],i[e+12>>2]=k,k=k-t|0,o=!k,o|o||x(r,t,k),i[e+8>>2]=r+k,i[f+16>>2]=i[e+12>>2],i[f+20>>2]=i[e+8>>2],v=e+16|0,t=i[f+16>>2],e=v-16|0,v=e,i[e+12>>2]=A,A=v-16|0,v=A,k=e+12|0,i[A+12>>2]=i[k>>2],v=A+16|0,A=o5(k,t-i[A+12>>2]|0),v=e+16|0,i[f+12>>2]=A,i[f+8>>2]=(i[f+20>>2]-r|0)+r,i[n+8>>2]=i[f+12>>2],i[n+12>>2]=i[f+8>>2],v=f+32|0,v=n+16|0,i[n+12>>2]}function _V(A,e,r,f,k){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,k=v-32|0,v=k,Yt(k+8|0,e,r,f,0);i:{if(i[k+8>>2]){e=i[k+12>>2],i[A>>2]=i[k+8>>2],i[A+4>>2]=e,i[A+16>>2]=i[k+24>>2],e=i[k+20>>2],i[A+8>>2]=i[k+16>>2],i[A+12>>2]=e,i[k+24>>2]=0,i[k+16>>2]=0,i[k+20>>2]=0;break i}if(F0(r,i[e+100>>2]|l[e+97|0]<<24),e=i[26917],i[A>>2]=i[26916],i[A+4>>2]=e,A=A+8|0,u[107683]>=0){e=i[26919],i[A>>2]=i[26918],i[A+4>>2]=e,i[A+8>>2]=i[26920];break i}T(A,i[26918],i[26919])}u[k+27|0]<0&&Z(i[k+16>>2]),v=k+32|0}function r4(A,e,r,f){var k=0,n=0,t=0,o=0;k=v-32|0,v=k;i:{e:{n=i[e+20>>2];r:{if(!n)break r;for(t=e+20|0,e=t;o=u0[n+16>>2]<r>>>0,e=o?e:n,n=i[(o?4:0)+n>>2],!!n;);if((e|0)==(t|0))break r;if(u0[e+16>>2]<=r>>>0)break e}i[A>>2]=0,i[A+4>>2]=0;break i}if(r=i[e+20>>2],W[i[i[r>>2]+52>>2]](k+12|0,r),r=!i[k+12>>2]|f,u[k+31|0]<0&&Z(i[k+20>>2]),!r){i[A>>2]=0,i[A+4>>2]=0;break i}if(i[A>>2]=i[e+20>>2],r=A,A=i[e+24>>2],i[r+4>>2]=A,!A)break i;i[A+4>>2]=i[A+4>>2]+1}v=k+32|0}function BV(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0;var k=0;k=v-32|0,v=k,o9(k+8|0,e);i:{if(i[k+8>>2]){e=i[k+12>>2],i[A>>2]=i[k+8>>2],i[A+4>>2]=e,i[A+16>>2]=i[k+24>>2],e=i[k+20>>2],i[A+8>>2]=i[k+16>>2],i[A+12>>2]=e,i[k+24>>2]=0,i[k+16>>2]=0,i[k+20>>2]=0;break i}if(e=i[e+76>>2],i[f>>2]=e,i[r>>2]=e?0:2,e=i[26917],i[A>>2]=i[26916],i[A+4>>2]=e,A=A+8|0,u[107683]>=0){e=i[26919],i[A>>2]=i[26918],i[A+4>>2]=e,i[A+8>>2]=i[26920];break i}T(A,i[26918],i[26919])}u[k+27|0]<0&&Z(i[k+16>>2]),v=k+32|0}function R4(A,e){var r=0,f=0,k=0,n=0,t=0,o=0;i:{if(e){if(r=i[A+44>>2],k=i[A+40>>2],t=r-k|0,o=t>>2,o>>>0<=15){if(f=i[A+48>>2],f>>>0>r>>>0){i[r>>2]=e,i[A+44>>2]=r+4;return}if(r=f-k|0,f=r>>1,n=o+1|0,r=r>>>0>=2147483644?1073741823:f>>>0>n>>>0?f:n,r>>>0>=1073741824)break i;f=r<<2,n=p(f),r=n+t|0,i[r>>2]=e,e=r-(o<<2)|0,t&&x(e,k,t),i[A+48>>2]=f+n,r=r+4|0,i[A+44>>2]=r,i[A+40>>2]=e,k&&Z(k),i[A+44>>2]=r;return}Z(i[e+20>>2]),A=i[e+32>>2],A&&(i[e+36>>2]=A,Z(A)),Z(e)}return}z0(),H()}function Lt(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,t=0;k=v-16|0,v=k;i:{if(!e)break i;A=i[A>>2],f=i[A+48>>2],A=i[A+52>>2];e:{if(!A){fA(k+4|0,f);break e}if(i[A+4>>2]=i[A+4>>2]+1,fA(k+4|0,f),f=i[A+4>>2],i[A+4>>2]=f-1,f)break e;W[i[i[A>>2]+8>>2]](A),y(A)}e:{r:{if(n=i[k+4>>2],f=i[k+8>>2]-n>>2,(f|0)<=0)break r;for(A=0;;){if((A|0)==(r|0)){f=r;break r}if(t=A<<2,i[t+e>>2]=i[n+t>>2],A=A+1|0,(f|0)==(A|0))break}break e}if(!n)break i}i[k+8>>2]=n,Z(n)}return v=k+16|0,f|0}function vV(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0;var k=0;f=v-32|0,v=f,z2(f,e,r),u[f+19|0]<0&&Z(i[f+8>>2]);i:{if(l[e+97|0]){t1(A,e,3635);break i}if(k=C0(r),u[e+104|0]=k>>>31,u[e+106|0]=k>>>26&15,u[e+105|0]=k>>>30&1,l[r+20|0]==1){if(u[f+20|0]=0,u[f+31|0]=0,q(A,2,100,f+20|0),u[f+31|0]>=0)break i;Z(i[f+20>>2]);break i}if(e=i[26917],i[A>>2]=i[26916],i[A+4>>2]=e,A=A+8|0,u[107683]>=0){e=i[26919],i[A>>2]=i[26918],i[A+4>>2]=e,i[A+8>>2]=i[26920];break i}T(A,i[26918],i[26919])}v=f+32|0}function Tr(A){var e=0,r=0,f=0,k=0,n=0,t=0,o=0,s=0;if(e=St(A,61),(e|0)==(A|0))return 0;k=e-A|0;i:{if(l[k+A|0]||(f=i[31325],!f)||(r=i[f>>2],!r))break i;for(;;){e:{n=A,t=k,e=0;r:{if(!k)break r;if(e=l[A|0],e)f:{for(;;){if(o=l[r|0],(o|0)!=(e|0)|!o||(t=t-1|0,!t))break f;if(r=r+1|0,e=l[n+1|0],n=n+1|0,!e)break}e=0}else e=0;e=e-l[r|0]|0}if(!e&&(e=i[f>>2]+k|0,l[e|0]==61))break e;if(r=i[f+4>>2],f=f+4|0,r)continue;break i}break}s=e+1|0}return s}function o4(A,e,r,f,k,n){var t=0,o=0,s=0;i:{if(n&64){k=n+-64|0,n=e,f=k&31,(k&63)>>>0>=32?(k=n<<f,f=0):(k=(1<<f)-1&n>>>32-f|r<<f,f=n<<f),e=0,r=0;break i}if(!n)break i;o=f,t=n&31,(n&63)>>>0>=32?(s=f<<t,o=0):(s=(1<<t)-1&o>>>32-t|k<<t,o=o<<t),t=e,k=64-n|0,f=k&31,(k&63)>>>0>=32?(k=0,f=r>>>f|0):(k=r>>>f|0,f=((1<<f)-1&r)<<32-f|t>>>f),f=o|f,k=k|s,o=e,t=n&31,(n&63)>>>0>=32?(s=e<<t,e=0):(s=(1<<t)-1&o>>>32-t|r<<t,e=o<<t),r=s}i[A>>2]=e,i[A+4>>2]=r,i[A+8>>2]=f,i[A+12>>2]=k}function mV(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,t=0;if(f=v-32|0,v=f,t=W[i[i[e>>2]+52>>2]](e,r,0)|0,F0(r,i[e+108>>2]-i[e+104>>2]>>2),i[e+124>>2]=i[r+12>>2],k=i[e+104>>2],n=i[e+108>>2],(k|0)!=(n|0))for(;F0(r,i[k>>2]),k=k+4|0,(n|0)!=(k|0););f1(f+12|0,e,r,t),u[f+31|0]<0&&Z(i[f+20>>2]),e=i[26917],i[A>>2]=i[26916],i[A+4>>2]=e,A=A+8|0;i:{if(u[107683]>=0){e=i[26919],i[A>>2]=i[26918],i[A+4>>2]=e,i[A+8>>2]=i[26920];break i}T(A,i[26918],i[26919])}v=f+32|0}function Kt(A){return u[A+316|0]=0,g[A+314>>1]=0,i[A+60>>2]=0,i[A+52>>2]=0,i[A+56>>2]=0,o0(A+116|0,0,164),i[A+108>>2]=0,i[A+112>>2]=0,i[A>>2]=-1,i[A+4>>2]=0,i[A+8>>2]=0,i[A+12>>2]=0,i[A+64>>2]=0,i[A+68>>2]=0,i[A+72>>2]=0,i[A+320>>2]=0,i[A+24>>2]=0,i[A+28>>2]=0,i[A+280>>2]=0,i[A+284>>2]=0,i[A+288>>2]=0,i[A+292>>2]=0,i[A+296>>2]=0,i[A+300>>2]=0,u[A+312|0]=2,u[A+104|0]=0,i[A+100>>2]=0,i[A+92>>2]=-1,i[A+96>>2]=-1,i[A+340>>2]=0,i[A+332>>2]=0,i[A+336>>2]=0,i[A+324>>2]=0,i[A+328>>2]=0,A}function n6(A){var e=0,r=0,f=0;if(!A){if(A=i[26872],A&&(e=n6(A)),A=i[26834],A&&(e=n6(A)|e),A=i[31327],A)for(;i[A+20>>2]!=i[A+28>>2]&&(e=n6(A)|e),A=i[A+56>>2],!!A;);return e}f=i[A+76>>2]<0;i:{e:{if(i[A+20>>2]==i[A+28>>2]||(W[i[A+36>>2]](A,0,0)|0,i[A+20>>2]))break e;e=-1;break i}if(e=i[A+8>>2],r=i[A+4>>2],(e|0)!=(r|0)&&(e=r-e|0,W[i[A+40>>2]](A,e,e>>31,1)|0),e=0,i[A+28>>2]=0,i[A+16>>2]=0,i[A+20>>2]=0,i[A+4>>2]=0,i[A+8>>2]=0,f)break i}return e}function ZV(A,e){A=A|0,e=e|0;var r=0,f=0,k=0,n=0;r=v-16|0,v=r,CA(r+4|0,i[A>>2]),A=i[r+8>>2],k=i[r+4>>2];i:{e:{if((A|0)!=(k|0)){f=k;r:{f:{for(;;){if(i[i[f>>2]+116>>2]==(e|0))break f;if(f=f+8|0,(f|0)==(A|0))break}f=0;break r}f=1}if(!k)break i;for(;;){e=i[A-4>>2];r:{if(!e||(n=i[e+4>>2],i[e+4>>2]=n-1,n))break r;W[i[i[e>>2]+8>>2]](e),y(e)}if(A=A-8|0,(k|0)==(A|0))break}A=i[r+4>>2];break e}if(A=k,!A)break i}i[r+8>>2]=k,Z(A)}return v=r+16|0,f|0}function qt(A){var e=0,r=0;e=p(128),r=e+32|0,i[r>>2]=0,i[r+4>>2]=0,i[e+24>>2]=0,i[e+28>>2]=0,i[e+4>>2]=0,i[e+8>>2]=0,i[e+72>>2]=-1,i[e+76>>2]=-1,i[e+116>>2]=0,i[e+88>>2]=0,i[e+92>>2]=0,i[e+120>>2]=0,i[e+124>>2]=0,i[e>>2]=90124,i[e+40>>2]=0,i[e+44>>2]=0,i[e+48>>2]=0,i[e+52>>2]=0,i[e+56>>2]=0,i[e+60>>2]=0,i[e- -64>>2]=0,i[e+80>>2]=-1,i[e+84>>2]=-1,i[e+96>>2]=0,i[e+100>>2]=0,i[e+104>>2]=0,i[e+108>>2]=0,g[e+112>>1]=0,i[e+16>>2]=87604,i[e+32>>2]=1769173093,i[A+4>>2]=e,i[A>>2]=e+16}function GV(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0;f=v-32|0,v=f,k=W[i[i[e>>2]+52>>2]](e,r,0)|0,e4(r,i[e+112>>2],i[e+116>>2]),F0(r,i[e+120>>2]),F0(r,i[e+124>>2]),l2(r,l[e+128|0]),i[r+12>>2]=k,W[i[i[e>>2]+56>>2]](f+12|0,e,r,i[r+4>>2]-(i[r>>2]+k|0)|0,0),i[r+12>>2]=i[r+4>>2]-i[r>>2],u[f+31|0]<0&&Z(i[f+20>>2]),e=i[26917],i[A>>2]=i[26916],i[A+4>>2]=e,A=A+8|0;i:{if(u[107683]>=0){e=i[26919],i[A>>2]=i[26918],i[A+4>>2]=e,i[A+8>>2]=i[26920];break i}T(A,i[26918],i[26919])}v=f+32|0}function XV(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,t=0;k=v-32|0,v=k,i[k+16>>2]=e,f=i[A+48>>2],i[k+20>>2]=r-((f|0)!=0),t=i[A+44>>2],i[k+28>>2]=f,i[k+24>>2]=t;i:{e:{if(f=V7(i[A+60>>2],k+16|0,2,k+12|0)|0,f?(i[31324]=f,f=-1):f=0,f)e=32;else{if(f=i[k+12>>2],(f|0)>0)break e;e=f?32:16}i[A>>2]=e|i[A>>2];break i}if(n=f,t=i[k+20>>2],t>>>0>=f>>>0)break i;n=i[A+44>>2],i[A+4>>2]=n,i[A+8>>2]=n+(f-t|0),i[A+48>>2]&&(i[A+4>>2]=n+1,u[(e+r|0)-1|0]=l[n|0]),n=r}return v=k+32|0,n|0}function Sr(A,e){A=A|0,e=e|0;var r=0,f=0;i:{if(!e)break i;e:{r:{f:{A:{k:{n:{t:switch(r=l[e|0],f=l[A|0],(r>>>0<f>>>0?r:f)-1|0){case 0:break e;case 1:break r;case 2:break f;case 3:break A;case 4:break k;case 5:break n;case 6:break t;default:break i}u[A+32|0]=l[e+32|0]}r=i[e+20>>2],i[A+16>>2]=i[e+16>>2],i[A+20>>2]=r,r=i[e+28>>2],i[A+24>>2]=i[e+24>>2],i[A+28>>2]=r}i[A+12>>2]=i[e+12>>2]}i[A+4>>2]=i[e+4>>2],u[A+8|0]=l[e+8|0]}u[A+3|0]=l[e+3|0]}u[A+2|0]=l[e+2|0]}u[A+1|0]=l[e+1|0]}}function sA(A,e){var r=0,f=0,k=0,n=0,t=0,o=0;if(r=i[A+132>>2],f=i[A+136>>2],r>>>0<f>>>0){i[r>>2]=e,i[r+4>>2]=0,i[A+132>>2]=r+8;return}i:{if(k=r,r=i[A+128>>2],t=k-r|0,o=t>>3,n=o+1|0,n>>>0<536870912){if(f=f-r|0,k=f>>2,n=f>>>0>=2147483640?536870911:n>>>0<k>>>0?k:n,n){if(n>>>0>=536870912)break i;k=p(n<<3)}else k=0;f=k+t|0,i[f>>2]=e,i[f+4>>2]=0,e=f-(o<<3)|0,t&&x(e,r,t),i[A+136>>2]=k+(n<<3),t=f+8|0,i[A+132>>2]=t,i[A+128>>2]=e,r&&Z(r),i[A+132>>2]=t;return}G0(),H()}z0(),H()}function WV(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,t=0;if(k=v-32|0,v=k,t=W[i[i[e>>2]+52>>2]](e,r,0)|0,F0(r,i[e+108>>2]-i[e+104>>2]>>3),f=i[e+104>>2],n=i[e+108>>2],(f|0)!=(n|0))for(;F0(r,i[f>>2]),F0(r,i[f+4>>2]),f=f+8|0,(n|0)!=(f|0););f1(k+12|0,e,r,t),u[k+31|0]<0&&Z(i[k+20>>2]),e=i[26917],i[A>>2]=i[26916],i[A+4>>2]=e,A=A+8|0;i:{if(u[107683]>=0){e=i[26919],i[A>>2]=i[26918],i[A+4>>2]=e,i[A+8>>2]=i[26920];break i}T(A,i[26918],i[26919])}v=k+32|0}function QV(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0;var k=0;f=v-32|0,v=f,z2(f,e,r),u[f+19|0]<0&&Z(i[f+8>>2]),k=l[e+97|0];i:{if(k>>>0>=2){t1(A,e,9349);break i}e:{if(!k){k=o2(r);break e}k=C0(r)}if(i[e+104>>2]=k,l[r+20|0]==1){if(u[f+20|0]=0,u[f+31|0]=0,q(A,2,100,f+20|0),u[f+31|0]>=0)break i;Z(i[f+20>>2]);break i}if(e=i[26917],i[A>>2]=i[26916],i[A+4>>2]=e,A=A+8|0,u[107683]>=0){e=i[26919],i[A>>2]=i[26918],i[A+4>>2]=e,i[A+8>>2]=i[26920];break i}T(A,i[26918],i[26919])}v=f+32|0}function gV(A){A=A|0;var e=0,r=0,f=0,k=0,n=0,t=0,o=0;if(u[A+121|0]=0,u[A+122|0]=0,u[A+123|0]=0,u[A+124|0]=0,e=l[A+120|0],r=e>>>0<=2?2:e,n=e,t=i[A+108>>2],e=i[A+104>>2],r=t-e>>>0>2097120?r:n,(e|0)==(t|0))f=4;else{for(;r=u0[e>>2]>65535&&(r|0)<=2?2:r,r=l[e+4|0]&&(r|0)<=1?1:r,o=i[e+16>>2],f=f+i[o+20>>2]|0,n=k,k=k+i[o+16>>2]|0,f=n>>>0>k>>>0?f+1|0:f,e=e+32|0,(t|0)!=(e|0););f=(f-(k>>>0<4026531840)|0)!=-1?8:4}u[A+121|0]=4,u[A+122|0]=4,u[A+123|0]=f,u[A+97|0]=r}function VV(A,e,r,f,k,n,t){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,t=t|0;var o=0,s=0,w=0,h=0,_=0,B=0;if(!(n&1)){if(!((t|0)<=0|(n|0)<=0))for(;;){for(h=G(e,w)+A|0,s=G(k,w)<<1,_=s+f|0,s=r+s|0,B=0;o=(g[s>>1]+g[_>>1]|0)- -64>>7,o=(o|0)>=255?255:o,u[h|0]=(o|0)>0?o:0,o=(g[s+2>>1]+g[_+2>>1]|0)- -64>>7,o=(o|0)>=255?255:o,u[h+1|0]=(o|0)>0?o:0,_=_+4|0,s=s+4|0,h=h+2|0,B=B+2|0,(B|0)<(n|0););if(w=w+1|0,(w|0)==(t|0))break}return}D0(21986,18216,105,10238),H()}function oe(A,e){var r=0,f=0,k=0,n=0,t=0,o=0;n=v-16|0,v=n,f=h2(e),k=v-16|0,v=k;i:{if(f>>>0<=2147483639){e:{if(f>>>0<11){u[A+11|0]=l[A+11|0]&128|f&127,u[A+11|0]=l[A+11|0]&127,r=A;break e}o=k+8|0,f>>>0>=11?(t=f+8&-8,r=t-1|0,r=(r|0)==11?t:r):r=10,Ci(o,r+1|0),r=i[k+8>>2],i[A>>2]=r,i[A+8>>2]=i[A+8>>2]&-2147483648|i[k+12>>2]&2147483647,i[A+8>>2]=i[A+8>>2]|-2147483648,i[A+4>>2]=f}A=!f,A|A||x(r,e,f),u[k+7|0]=0,u[f+r|0]=l[k+7|0],v=k+16|0;break i}Z4(),H()}v=n+16|0}function FV(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,t=0,o=0;for(n=v-16|0,v=n;;){i:{if((r|0)<=(t|0))break i;if(f=i[A+24>>2],k=i[A+28>>2],f>>>0>=k>>>0){if((W[i[i[A>>2]+52>>2]](A,i[e>>2])|0)==-1)break i;t=t+1|0,e=e+4|0}else{i[n+12>>2]=k-f>>2,i[n+8>>2]=r-t,f=v-16|0,v=f,v=f+16|0,k=i[A+24>>2],f=n+8|0,o=n+12|0,f=i[(i[f>>2]<i[o>>2]?f:o)>>2];e:{if(!f||(o=f<<2,!o))break e;x(k,e,o)}k=f<<2,i[A+24>>2]=k+i[A+24>>2],t=f+t|0,e=e+k|0}continue}break}return v=n+16|0,t|0}function wA(A,e,r){var f=0,k=0;f=(r|0)!=0;i:{e:{r:{if(!(A&3)|!r)break r;for(k=e&255;;){if((k|0)==l[A|0])break e;if(r=r-1|0,f=(r|0)!=0,A=A+1|0,!(A&3))break r;if(!r)break}}if(!f)break i;if(f=e&255,!((f|0)==l[A|0]|r>>>0<4))for(f=G(f,16843009);;){if(k=f^i[A>>2],((16843008-k|k)&-2139062144)!=-2139062144)break e;if(A=A+4|0,r=r-4|0,!(r>>>0>3))break}if(!r)break i}for(e=e&255;;){if((e|0)==l[A|0])return A;if(A=A+1|0,r=r-1|0,!r)break}}return 0}function at(A){A=A|0;var e=0,r=0,f=0,k=0,n=0,t=0,o=0;if(i[A>>2]=86384,l[A+132|0]==1&&(e=y_(-100,A+140|0,0)|0,e>>>0>=4294963201&&(i[31324]=0-e)),k=i[A+104>>2],k){if(e=k,f=i[A+108>>2],(e|0)!=(f|0)){for(;;){if(t=f-16|0,n=i[t>>2],n){if(o=f-12|0,e=i[o>>2],r=n,(e|0)!=(r|0)){for(;r=i[e-16>>2],r&&(i[e-12>>2]=r,Z(r)),e=e-40|0,(n|0)!=(e|0););r=i[t>>2]}i[o>>2]=n,Z(r)}if(f=f-32|0,(k|0)==(f|0))break}e=i[A+104>>2]}i[A+108>>2]=k,Z(e)}return A2(A)|0}function IV(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0;var k=0,n=0;f=v-32|0,v=f,z2(f,e,r),u[f+19|0]<0&&Z(i[f+8>>2]);i:{if(l[e+97|0]){t1(A,e,12838);break i}if(k=e,n=C0(r),i[k+104>>2]=n,k=e,n=C0(r),i[k+108>>2]=n,l[r+20|0]==1){if(u[f+20|0]=0,u[f+31|0]=0,q(A,2,100,f+20|0),u[f+31|0]>=0)break i;Z(i[f+20>>2]);break i}if(e=i[26917],i[A>>2]=i[26916],i[A+4>>2]=e,A=A+8|0,u[107683]>=0){e=i[26919],i[A>>2]=i[26918],i[A+4>>2]=e,i[A+8>>2]=i[26920];break i}T(A,i[26918],i[26919])}v=f+32|0}function CV(A,e,r,f,k,n,t){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,t=t|0;var o=0,s=0,w=0;o=v-32|0,v=o;i:{e:{if(n&&(h2(n)|0)==4)break e;i[A>>2]=5,i[A+4>>2]=2006,i[A+8>>2]=26228;break i}s=o+12|0,w=r,r=l[n|0]|l[n+1|0]<<8|(l[n+2|0]<<16|l[n+3|0]<<24),ci(s,i[e>>2],w,f,k,r<<24|(r&65280)<<8|(r>>>8&65280|r>>>24),t,0,0);e:{if(i[o+12>>2]!=i[26916]){b0(A,s,i[e>>2]);break e}e=i[24057],i[A>>2]=i[24056],i[A+4>>2]=e,i[A+8>>2]=i[24058]}if(u[o+31|0]>=0)break i;Z(i[o+20>>2])}v=o+32|0}function $t(A,e){var r=0;r=p(128),i[r+4>>2]=0,i[r+8>>2]=0,i[r>>2]=92524,e=i[e>>2],i[r+32>>2]=0,i[r+36>>2]=0,i[r- -64>>2]=0,i[r+56>>2]=0,i[r+60>>2]=0,i[r+48>>2]=0,i[r+52>>2]=0,i[r+40>>2]=0,i[r+44>>2]=0,i[r+24>>2]=0,i[r+28>>2]=0,i[r+72>>2]=-1,i[r+76>>2]=-1,i[r+80>>2]=-1,i[r+84>>2]=-1,i[r+88>>2]=0,i[r+92>>2]=0,i[r+96>>2]=0,i[r+100>>2]=0,i[r+104>>2]=0,i[r+108>>2]=0,u[r+112|0]=0,i[r+124>>2]=0,i[r+116>>2]=0,i[r+120>>2]=0,i[r+16>>2]=86724,i[r+32>>2]=e,i[A+4>>2]=r,i[A>>2]=r+16}function pV(A){A=A|0;var e=0,r=0,f=0,k=0;i[A>>2]=100256;i:{if(l[A+72|0]!=1||(e=i[A+40>>2],e&&(i[A+44>>2]=e,Z(e)),e=i[A+28>>2],!e))break i;if(r=e,f=i[A+32>>2],(e|0)!=(f|0)){for(;;){r=i[f-4>>2];e:{if(!r||(k=i[r+4>>2],i[r+4>>2]=k-1,k))break e;W[i[i[r>>2]+8>>2]](r),y(r)}if(f=f-8|0,(e|0)==(f|0))break}r=i[A+28>>2]}i[A+32>>2]=e,Z(r)}e=i[A+12>>2];i:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break i;W[i[i[e>>2]+8>>2]](e),y(e)}return A|0}function yV(A){A=A|0;var e=0,r=0,f=0,k=0;i[A>>2]=99744;i:{if(l[A+76|0]!=1||(e=i[A+44>>2],e&&(i[A+48>>2]=e,Z(e)),e=i[A+32>>2],!e))break i;if(r=e,f=i[A+36>>2],(e|0)!=(f|0)){for(;;){r=i[f-4>>2];e:{if(!r||(k=i[r+4>>2],i[r+4>>2]=k-1,k))break e;W[i[i[r>>2]+8>>2]](r),y(r)}if(f=f-8|0,(e|0)==(f|0))break}r=i[A+32>>2]}i[A+36>>2]=e,Z(r)}e=i[A+16>>2];i:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break i;W[i[i[e>>2]+8>>2]](e),y(e)}return A|0}function EV(A){A=A|0;var e=0,r=0,f=0,k=0;i[A>>2]=97712;i:{if(l[A+76|0]!=1||(e=i[A+44>>2],e&&(i[A+48>>2]=e,Z(e)),e=i[A+32>>2],!e))break i;if(r=e,f=i[A+36>>2],(e|0)!=(f|0)){for(;;){r=i[f-4>>2];e:{if(!r||(k=i[r+4>>2],i[r+4>>2]=k-1,k))break e;W[i[i[r>>2]+8>>2]](r),y(r)}if(f=f-8|0,(e|0)==(f|0))break}r=i[A+32>>2]}i[A+36>>2]=e,Z(r)}e=i[A+16>>2];i:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break i;W[i[i[e>>2]+8>>2]](e),y(e)}return A|0}function YV(A,e,r,f,k,n){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0;var t=0,o=0;i:{if(k=i[r+12>>2],(k|0)>=9||(t=i[r+4>>2],u[f+8|0]&1|(!l[r+8|0]|t>>>0>3))||!i[n+4>>2])break i;f=i[r+20>>2],n=i[r+16>>2],o=i[r>>2],e=p(28),u[e+8|0]=0,i[e+4>>2]=t,i[e>>2]=o,t=l[r+9|0]|l[r+10|0]<<8,u[e+9|0]=t,u[e+10|0]=t>>>8,u[e+11|0]=l[r+11|0],i[e+24>>2]=1,i[e+16>>2]=n,i[e+20>>2]=f,i[e+12>>2]=k,r=e+28|0,i[A+8>>2]=r,i[A>>2]=e,i[A+4>>2]=r;return}i[A+8>>2]=0,i[A>>2]=0,i[A+4>>2]=0}function RV(A,e,r,f,k,n){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0;var t=0,o=0;i:{if(k=i[r+12>>2],(k|0)<=8||(t=i[r+4>>2],u[f+8|0]&1|(!l[r+8|0]|t>>>0>3))||!i[n+4>>2])break i;f=i[r+20>>2],n=i[r+16>>2],o=i[r>>2],e=p(28),u[e+8|0]=0,i[e+4>>2]=t,i[e>>2]=o,t=l[r+9|0]|l[r+10|0]<<8,u[e+9|0]=t,u[e+10|0]=t>>>8,u[e+11|0]=l[r+11|0],i[e+24>>2]=1,i[e+16>>2]=n,i[e+20>>2]=f,i[e+12>>2]=k,r=e+28|0,i[A+8>>2]=r,i[A>>2]=e,i[A+4>>2]=r;return}i[A+8>>2]=0,i[A>>2]=0,i[A+4>>2]=0}function JV(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0;var k=0;f=v-16|0,v=f;i:{e:{if(i[e+64>>2]&&!(W[i[i[e>>2]+24>>2]](e)|0))break e;i[A+8>>2]=-1,i[A+12>>2]=-1,i[A>>2]=0,i[A+4>>2]=0;break i}if(X3(i[e+64>>2],i[r+8>>2],i[r+12>>2],0)){i[A+8>>2]=-1,i[A+12>>2]=-1,i[A>>2]=0,i[A+4>>2]=0;break i}k=i[r+4>>2],i[f+8>>2]=i[r>>2],i[f+12>>2]=k,k=i[f+12>>2],i[e+72>>2]=i[f+8>>2],i[e+76>>2]=k,e=i[r+12>>2],i[A+8>>2]=i[r+8>>2],i[A+12>>2]=e,e=i[r+4>>2],i[A>>2]=i[r>>2],i[A+4>>2]=e}v=f+16|0}function NV(A,e,r,f,k,n,t){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,t=t|0;var o=0,s=0,w=0,h=0,_=0,B=0,m=0;if(!(k&1)){if(!((n|0)<=0|(k|0)<=0))for(B=(t|0)<14?1<<13-t:0,m=14-t|0,s=-1<<t^-1;;){for(t=(G(e,w)<<1)+A|0,h=(G(f,w)<<1)+r|0,_=0;o=g[h>>1]+B>>m,g[t>>1]=(o|0)>=0?(o|0)<(s|0)?o:s:0,o=g[h+2>>1]+B>>m,g[t+2>>1]=(o|0)>=0?(o|0)<(s|0)?o:s:0,h=h+4|0,t=t+4|0,_=_+2|0,(_|0)<(k|0););if(w=w+1|0,(w|0)==(n|0))break}return}D0(21986,18216,172,10455),H()}function UV(A,e){A=A|0,e=e|0;var r=0,f=0;r=v-32|0,v=r,f=i[e>>2],e=i[e+4>>2],e&&(i[e+4>>2]=i[e+4>>2]+1),i[A+16>>2]=f,f=i[A+20>>2],i[A+20>>2]=e;i:{if(!f||(e=i[f+4>>2],i[f+4>>2]=e-1,e))break i;W[i[i[f>>2]+8>>2]](f),y(f)}Pn(r+16|0,A),f=i[r+20>>2],e=i[r+16>>2],i[r+24>>2]=e,i[r+28>>2]=f,i[r+16>>2]=0,i[r+20>>2]=0,i[r+8>>2]=e,i[r+12>>2]=f,M4(A,r+8|0,0),e=i[r+20>>2];i:{if(!e||(A=i[e+4>>2],i[e+4>>2]=A-1,A))break i;W[i[i[e>>2]+8>>2]](e),y(e)}v=r+32|0}function dt(A,e,r,f){var k=0,n=0,t=0,o=0;k=v-16|0,v=k;i:{e:{r:{if((A|0)!=(e|0))f:{A:{if(n=l[A|0],(n|0)!=45||(A=A+1|0,(e|0)!=(A|0)))break A;break f}o=i[31324],i[31324]=0,a2(),A=b6(A,k+12|0,f,-1,-1),f=l0,t=i[31324];A:{if(t){if(i[k+12>>2]!=(e|0))break A;if((t|0)==68)break r;break e}if(i[31324]=o,i[k+12>>2]==(e|0))break e}}i[r>>2]=4,A=0,e=0;break i}i[r>>2]=4,A=-1,e=-1;break i}e=A,r=(n|0)==45,A=r?0-e|0:e,e=r?0-(f+((e|0)!=0)|0)|0:f}return v=k+16|0,l0=e,A}function DV(A){A=A|0;var e=0,r=0,f=0,k=0;i[A>>2]=100256;i:{if(l[A+72|0]!=1||(e=i[A+40>>2],e&&(i[A+44>>2]=e,Z(e)),e=i[A+28>>2],!e))break i;if(r=e,f=i[A+32>>2],(e|0)!=(f|0)){for(;;){r=i[f-4>>2];e:{if(!r||(k=i[r+4>>2],i[r+4>>2]=k-1,k))break e;W[i[i[r>>2]+8>>2]](r),y(r)}if(f=f-8|0,(e|0)==(f|0))break}r=i[A+28>>2]}i[A+32>>2]=e,Z(r)}e=i[A+12>>2];i:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break i;W[i[i[e>>2]+8>>2]](e),y(e)}Z(A)}function MV(A){A=A|0;var e=0,r=0,f=0,k=0;i[A>>2]=99744;i:{if(l[A+76|0]!=1||(e=i[A+44>>2],e&&(i[A+48>>2]=e,Z(e)),e=i[A+32>>2],!e))break i;if(r=e,f=i[A+36>>2],(e|0)!=(f|0)){for(;;){r=i[f-4>>2];e:{if(!r||(k=i[r+4>>2],i[r+4>>2]=k-1,k))break e;W[i[i[r>>2]+8>>2]](r),y(r)}if(f=f-8|0,(e|0)==(f|0))break}r=i[A+32>>2]}i[A+36>>2]=e,Z(r)}e=i[A+16>>2];i:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break i;W[i[i[e>>2]+8>>2]](e),y(e)}Z(A)}function ct(A,e,r,f){var k=0,n=0,t=0;k=v-16|0,v=k;i:{e:{r:{if((A|0)!=(e|0)){t=i[31324],i[31324]=0,a2(),f=b6(A,k+12|0,f,0,-2147483648),A=l0,n=i[31324];f:{if(n){if(i[k+12>>2]!=(e|0))break f;if((n|0)==68)break e;break r}if(i[31324]=t,i[k+12>>2]==(e|0))break r}}i[r>>2]=4,e=0;break i}if((A|0)<0&f>>>0<2147483648|(A|0)<-1|(f>>>0>2147483647&(A|0)>=0|(A|0)>0))break e;e=f;break i}if(i[r>>2]=4,e=2147483647,!!f&(A|0)>=0|(A|0)>0)break i;e=-2147483648}return v=k+16|0,e}function HV(A){A=A|0;var e=0,r=0,f=0,k=0;i[A>>2]=97712;i:{if(l[A+76|0]!=1||(e=i[A+44>>2],e&&(i[A+48>>2]=e,Z(e)),e=i[A+32>>2],!e))break i;if(r=e,f=i[A+36>>2],(e|0)!=(f|0)){for(;;){r=i[f-4>>2];e:{if(!r||(k=i[r+4>>2],i[r+4>>2]=k-1,k))break e;W[i[i[r>>2]+8>>2]](r),y(r)}if(f=f-8|0,(e|0)==(f|0))break}r=i[A+32>>2]}i[A+36>>2]=e,Z(r)}e=i[A+16>>2];i:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break i;W[i[i[e>>2]+8>>2]](e),y(e)}Z(A)}function jr(A,e){A=A|0,e=e|0;var r=0,f=0,k=0;r=v-48|0,v=r,f=i[A>>2],A=i[e+4>>2],e=i[e>>2],u[r+12|0]=0,u[r+23|0]=0,A=q(r+24|0,e,A,r+12|0),e=i[f+152>>2];i:{if(e>>>0<u0[f+156>>2]){k=i[A+4>>2],i[e>>2]=i[A>>2],i[e+4>>2]=k,i[e+16>>2]=i[A+16>>2],k=i[A+12>>2],i[e+8>>2]=i[A+8>>2],i[e+12>>2]=k,i[A+16>>2]=0,i[A+8>>2]=0,i[A+12>>2]=0,i[f+152>>2]=e+20;break i}if(e=ee(f+148|0,A),k=u[A+19|0],i[f+152>>2]=e,(k|0)>=0)break i;Z(i[A+8>>2])}u[r+23|0]<0&&Z(i[r+12>>2]),v=r+48|0}function zV(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0;f=v-32|0,v=f,k=W[i[i[e>>2]+52>>2]](e,r,0)|0,n=f+20|0,gu(n,e+104|0),I4(r,n),i[r+12>>2]=k,W[i[i[e>>2]+56>>2]](f,e,r,i[r+4>>2]-(i[r>>2]+k|0)|0,0),i[r+12>>2]=i[r+4>>2]-i[r>>2],u[f+19|0]<0&&Z(i[f+8>>2]),e=i[26917],i[A>>2]=i[26916],i[A+4>>2]=e,A=A+8|0;i:{if(u[107683]>=0){e=i[26919],i[A>>2]=i[26918],i[A+4>>2]=e,i[A+8>>2]=i[26920];break i}T(A,i[26918],i[26919])}A=i[f+20>>2],A&&(i[f+24>>2]=A,Z(A)),v=f+32|0}function xV(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0;f=v-32|0,v=f,k=W[i[i[e>>2]+52>>2]](e,r,0)|0,n=i[e+104>>2];i:{if(!l[e+97|0]){u2(r,n&65535);break i}F0(r,n)}i[r+12>>2]=k,W[i[i[e>>2]+56>>2]](f+12|0,e,r,i[r+4>>2]-(i[r>>2]+k|0)|0,0),i[r+12>>2]=i[r+4>>2]-i[r>>2],u[f+31|0]<0&&Z(i[f+20>>2]),e=i[26917],i[A>>2]=i[26916],i[A+4>>2]=e,A=A+8|0;i:{if(u[107683]>=0){e=i[26919],i[A>>2]=i[26918],i[A+4>>2]=e,i[A+8>>2]=i[26920];break i}T(A,i[26918],i[26919])}v=f+32|0}function bt(A,e){var r=0,f=0;i:{if(r=l[A+12|0],(r|0)==l[e+12|0]){if(!r|(A|0)==(e|0))break i;if(r=u[e+11|0],u[A+11|0]>=0){if((r|0)>=0){r=i[e+4>>2],i[A>>2]=i[e>>2],i[A+4>>2]=r,i[A+8>>2]=i[e+8>>2];return}M1(A,i[e>>2],i[e+4>>2]);return}f=A,A=(r|0)<0,O1(f,A?i[e>>2]:e,A?i[e+4>>2]:r);return}if(r){u[A+11|0]<0&&Z(i[A>>2]),u[A+12|0]=0;return}e:{if(u[e+11|0]>=0){r=i[e+4>>2],i[A>>2]=i[e>>2],i[A+4>>2]=r,i[A+8>>2]=i[e+8>>2];break e}T(A,i[e>>2],i[e+4>>2])}u[A+12|0]=1}}function iu(A,e,r,f){var k=0,n=0,t=0,o=0;k=v-16|0,v=k;i:{e:{r:{f:{if((A|0)!=(e|0))A:{k:{if(n=l[A|0],(n|0)!=45||(A=A+1|0,(e|0)!=(A|0)))break k;break A}o=i[31324],i[31324]=0,a2(),A=b6(A,k+12|0,f,-1,-1),f=l0,t=i[31324];k:{if(t){if(i[k+12>>2]!=(e|0))break k;if((t|0)==68)break r;break f}if(i[31324]=o,i[k+12>>2]==(e|0))break f}}i[r>>2]=4,A=0;break i}if(!f&A>>>0<=65535)break e}i[r>>2]=4,A=65535;break i}A=(n|0)==45?0-A|0:A}return v=k+16|0,A&65535}function TV(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0;f=v-32|0,v=f,k=W[i[i[e>>2]+52>>2]](e,r,0)|0,F4(r,e+104|0,1),F4(r,e+116|0,1),F4(r,e+128|0,1),F4(r,e+140|0,1),i[r+12>>2]=k,W[i[i[e>>2]+56>>2]](f+12|0,e,r,i[r+4>>2]-(i[r>>2]+k|0)|0,0),i[r+12>>2]=i[r+4>>2]-i[r>>2],u[f+31|0]<0&&Z(i[f+20>>2]),e=i[26917],i[A>>2]=i[26916],i[A+4>>2]=e,A=A+8|0;i:{if(u[107683]>=0){e=i[26919],i[A>>2]=i[26918],i[A+4>>2]=e,i[A+8>>2]=i[26920];break i}T(A,i[26918],i[26919])}v=f+32|0}function SV(A,e,r,f,k,n){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0;var t=0;i:{if(t=i[e+16>>2],!t||(t=W0(t,94756,95784),!t))break i;e=i[e+20>>2],e&&(i[e+4>>2]=i[e+4>>2]+1),i[r>>2]=i[t+4>>2],i[f>>2]=i[t+8>>2],i[k>>2]=i[t+12>>2],i[n>>2]=i[t+16>>2],i[A+8>>2]=i[24058],r=i[24057],i[A>>2]=i[24056],i[A+4>>2]=r;e:{if(!e||(A=i[e+4>>2],i[e+4>>2]=A-1,A))break e;W[i[i[e>>2]+8>>2]](e),y(e)}return}e=i[24170],i[A>>2]=i[24169],i[A+4>>2]=e,i[A+8>>2]=i[24171]}function jV(A,e,r,f,k,n){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0;var t=0;i:{if(t=i[e+16>>2],!t||(t=W0(t,94756,95828),!t))break i;e=i[e+20>>2],e&&(i[e+4>>2]=i[e+4>>2]+1),i[r>>2]=i[t+4>>2],i[f>>2]=i[t+8>>2],i[k>>2]=i[t+12>>2],i[n>>2]=i[t+16>>2],i[A+8>>2]=i[24058],r=i[24057],i[A>>2]=i[24056],i[A+4>>2]=r;e:{if(!e||(A=i[e+4>>2],i[e+4>>2]=A-1,A))break e;W[i[i[e>>2]+8>>2]](e),y(e)}return}e=i[24170],i[A>>2]=i[24169],i[A+4>>2]=e,i[A+8>>2]=i[24171]}function eu(A,e,r){var f=0,k=0,n=0,t=0,o=0;n=v-16|0,v=n,k=v-16|0,v=k;i:{if(e>>>0<=2147483639){e:{if(e>>>0<11){u[A+11|0]=l[A+11|0]&128|e&127,u[A+11|0]=l[A+11|0]&127,f=A;break e}o=k+8|0,e>>>0>=11?(t=e+8&-8,f=t-1|0,f=(f|0)==11?t:f):f=10,Ci(o,f+1|0),f=i[k+8>>2],i[A>>2]=f,i[A+8>>2]=i[A+8>>2]&-2147483648|i[k+12>>2]&2147483647,i[A+8>>2]=i[A+8>>2]|-2147483648,i[A+4>>2]=e}Bl(f,e,r),u[k+7|0]=0,u[e+f|0]=l[k+7|0],v=k+16|0;break i}Z4(),H()}return v=n+16|0,A}function OV(A,e){A=A|0,e=e|0;var r=0,f=0;r=v-32|0,v=r,f=C[e>>1]|C[e+2>>1]<<16,g[A+6>>1]=f,g[A+8>>1]=f>>>16,e=l[e+3|0]|l[e+4|0]<<8|(l[e+5|0]<<16|l[e+6|0]<<24),u[A+9|0]=e,u[A+10|0]=e>>>8,u[A+11|0]=e>>>16,u[A+12|0]=e>>>24,On(r+16|0,A),f=i[r+20>>2],e=i[r+16>>2],i[r+24>>2]=e,i[r+28>>2]=f,i[r+16>>2]=0,i[r+20>>2]=0,i[r+8>>2]=e,i[r+12>>2]=f,M4(A,r+8|0,0),A=i[r+20>>2];i:{if(!A||(e=i[A+4>>2],i[A+4>>2]=e-1,e))break i;W[i[i[A>>2]+8>>2]](A),y(A)}v=r+32|0}function hA(A){var e=0,r=0,f=0,k=0;return i[A+92>>2]=0,i[A+64>>2]=72196,i[A+8>>2]=72176,e=i[18053],i[A>>2]=e,i[i[e-12>>2]+A>>2]=i[18054],i[A+4>>2]=0,e=i[i[A>>2]-12>>2]+A|0,r=A+12|0,J0(e,r),u[e+80|0]=0,i[e+72>>2]=0,e=i[18055],i[A+8>>2]=e,i[i[e-12>>2]+(A+8|0)>>2]=i[18056],e=i[18052],i[A>>2]=e,i[i[e-12>>2]+A>>2]=i[18057],i[A+64>>2]=72196,i[A>>2]=72156,i[A+8>>2]=72176,f=R0(r),k=71232,i[f>>2]=k,i[A+52>>2]=0,i[A+56>>2]=0,i[A+44>>2]=0,i[A+48>>2]=0,i[A+60>>2]=24,A}function PV(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,t=0;if(k=v-32|0,v=k,t=W[i[i[e>>2]+52>>2]](e,r,0)|0,f=i[e+100>>2],n=i[e+104>>2],(f|0)!=(n|0))for(;u2(r,C[f>>1]),l2(r,l[f+2|0]),l2(r,l[f+3|0]),f=f+4|0,(n|0)!=(f|0););f1(k+12|0,e,r,t),u[k+31|0]<0&&Z(i[k+20>>2]),e=i[26917],i[A>>2]=i[26916],i[A+4>>2]=e,A=A+8|0;i:{if(u[107683]>=0){e=i[26919],i[A>>2]=i[26918],i[A+4>>2]=e,i[A+8>>2]=i[26920];break i}T(A,i[26918],i[26919])}v=k+32|0}function _A(A){var e=0,r=0,f=0,k=0;if(i[A+20>>2]=0,r=i[A+8>>2],e=i[A+4>>2],f=r-e>>2,f>>>0>=3)for(;Z(i[e>>2]),e=i[A+4>>2]+4|0,i[A+4>>2]=e,r=i[A+8>>2],f=r-e>>2,f>>>0>2;);k=512;i:switch(f-1|0){case 1:k=1024;case 0:i[A+16>>2]=k;break;default:break i}i:{if((e|0)==(r|0))break i;for(;Z(i[e>>2]),e=e+4|0,(r|0)!=(e|0););if(r=i[A+4>>2],e=i[A+8>>2],(r|0)==(e|0))break i;i[A+8>>2]=e+((r-e|0)+3&-4)}A=i[A>>2],A&&Z(A)}function ru(A,e,r){var f=0,k=0,n=0,t=0,o=0;i:{if(k=v-16|0,v=k,n=r-e|0,n>>>0<=2147483639){e:{if(n>>>0<11){u[A+11|0]=l[A+11|0]&128|n&127,u[A+11|0]=l[A+11|0]&127,f=A;break e}o=k+8|0,n>>>0>=11?(t=n+8&-8,f=t-1|0,f=(f|0)==11?t:f):f=10,Ci(o,f+1|0),f=i[k+8>>2],i[A>>2]=f,i[A+8>>2]=i[A+8>>2]&-2147483648|i[k+12>>2]&2147483647,i[A+8>>2]=i[A+8>>2]|-2147483648,i[A+4>>2]=n}A=r-e|0,r=!A,r|r||x(f,e,A),u[k+7|0]=0,u[A+f|0]=l[k+7|0],v=k+16|0;break i}Z4(),H()}}function LV(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0;f=v-32|0,v=f,k=W[i[i[e>>2]+52>>2]](e,r,0)|0,n=u[e+115|0],((n|0)<0?i[e+108>>2]:n)&&F4(r,e+104|0,1),i[r+12>>2]=k,W[i[i[e>>2]+56>>2]](f+12|0,e,r,i[r+4>>2]-(i[r>>2]+k|0)|0,0),i[r+12>>2]=i[r+4>>2]-i[r>>2],u[f+31|0]<0&&Z(i[f+20>>2]),e=i[26917],i[A>>2]=i[26916],i[A+4>>2]=e,A=A+8|0;i:{if(u[107683]>=0){e=i[26919],i[A>>2]=i[26918],i[A+4>>2]=e,i[A+8>>2]=i[26920];break i}T(A,i[26918],i[26919])}v=f+32|0}function V8(A,e){var r=0,f=0,k=0,n=0,t=0,o=0,s=0;if(f=i[A+8>>2],r=i[A+4>>2],f-r>>2>>>0>=e>>>0){e&&(e=e<<2,e&&o0(r,0,e),r=e+r|0),i[A+4>>2]=r;return}i:{if(t=r,r=i[A>>2],o=t-r|0,n=o>>2,k=n+e|0,k>>>0<1073741824){if(f=f-r|0,t=f>>1,k=f>>>0>=2147483644?1073741823:k>>>0<t>>>0?t:k,k){if(k>>>0>=1073741824)break i;s=p(k<<2)}f=o+s|0,e=e<<2,e&&o0(f,0,e),n=f-(n<<2)|0,o&&x(n,r,o),i[A+8>>2]=(k<<2)+s,i[A+4>>2]=e+f,i[A>>2]=n,r&&Z(r);return}G0(),H()}z0(),H()}function KV(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0;i:{if(f=i[A>>2],A=i[f+104>>2],k=i[f+108>>2],(A|0)!=(k|0))for(;;){e:{if(f=i[A>>2],!f||(f=W0(f,86580,88932),!f))break e;if(A=i[A+4>>2],A)break i;return i[e>>2]=i[f+100>>2],i[r>>2]=i[f+104>>2],1}if(A=A+8|0,(k|0)==(A|0))break}return i[e>>2]=1,i[r>>2]=1,0}return i[A+4>>2]=i[A+4>>2]+1,i[e>>2]=i[f+100>>2],i[r>>2]=i[f+104>>2],e=i[A+4>>2],i[A+4>>2]=e-1,e||(W[i[i[A>>2]+8>>2]](A),y(A)),1}function qV(A,e,r,f,k){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0;var n=0,t=0,o=0,s=0,w=0,h=0,_=0,B=0;if((r|0)>0)for(w=1<<k-1,_=r&2147483646,B=r&1;;){if(n=0,t=0,h=0,(r|0)!=1)for(;s=G(r,n)+o|0,t=((g[(s<<1)+e>>1]<<f)+w>>k)+t|0,i[(s<<2)+A>>2]=t,s=G(n|1,r)+o|0,t=t+((g[(s<<1)+e>>1]<<f)+w>>k)|0,i[(s<<2)+A>>2]=t,n=n+2|0,h=h+2|0,(_|0)!=(h|0););if(B&&(n=G(r,n)+o|0,i[(n<<2)+A>>2]=((g[(n<<1)+e>>1]<<f)+w>>k)+t),o=o+1|0,(o|0)==(r|0))break}}function fu(A,e){var r=0,f=0,k=0,n=0,t=0,o=0;if(r=i[A+108>>2],f=i[A+112>>2],r>>>0<f>>>0){i[r>>2]=e,i[A+108>>2]=r+4;return}i:{if(t=i[A+104>>2],r=r-t|0,o=r>>2,k=o+1|0,k>>>0<1073741824){if(f=f-t|0,n=f>>1,f=f>>>0>=2147483644?1073741823:k>>>0<n>>>0?n:k,f){if(f>>>0>=1073741824)break i;k=p(f<<2)}else k=0;n=k+r|0,i[n>>2]=e,e=n-(o<<2)|0,r&&x(e,t,r),i[A+112>>2]=k+(f<<2),r=n+4|0,i[A+108>>2]=r,i[A+104>>2]=e,t&&Z(t),i[A+108>>2]=r;return}G0(),H()}z0(),H()}function Au(A,e){var r=0,f=0,k=0,n=0,t=0,o=0;if(r=i[A+280>>2],f=i[A+284>>2],r>>>0<f>>>0){i[r>>2]=e,i[A+280>>2]=r+4;return}i:{if(t=i[A+276>>2],r=r-t|0,o=r>>2,k=o+1|0,k>>>0<1073741824){if(f=f-t|0,n=f>>1,f=f>>>0>=2147483644?1073741823:k>>>0<n>>>0?n:k,f){if(f>>>0>=1073741824)break i;k=p(f<<2)}else k=0;n=k+r|0,i[n>>2]=e,e=n-(o<<2)|0,r&&x(e,t,r),i[A+284>>2]=k+(f<<2),r=n+4|0,i[A+280>>2]=r,i[A+276>>2]=e,t&&Z(t),i[A+280>>2]=r;return}G0(),H()}z0(),H()}function ku(A,e){var r=0,f=0,k=0,n=0,t=0,o=0;if(r=i[A+440>>2],f=i[A+444>>2],r>>>0<f>>>0){i[r>>2]=e,i[A+440>>2]=r+4;return}i:{if(t=i[A+436>>2],r=r-t|0,o=r>>2,k=o+1|0,k>>>0<1073741824){if(f=f-t|0,n=f>>1,f=f>>>0>=2147483644?1073741823:k>>>0<n>>>0?n:k,f){if(f>>>0>=1073741824)break i;k=p(f<<2)}else k=0;n=k+r|0,i[n>>2]=e,e=n-(o<<2)|0,r&&x(e,t,r),i[A+444>>2]=k+(f<<2),r=n+4|0,i[A+440>>2]=r,i[A+436>>2]=e,t&&Z(t),i[A+440>>2]=r;return}G0(),H()}z0(),H()}function ui(A,e){var r=0,f=0,k=0,n=0,t=0,o=0,s=0;if(f=i[A+8>>2],r=i[A+4>>2],f-r>>3>>>0>=e>>>0){e&&(e=e<<3,e&&o0(r,0,e),r=e+r|0),i[A+4>>2]=r;return}i:{if(t=r,r=i[A>>2],o=t-r|0,n=o>>3,k=n+e|0,k>>>0<536870912){if(f=f-r|0,t=f>>2,k=f>>>0>=2147483640?536870911:k>>>0<t>>>0?t:k,k){if(k>>>0>=536870912)break i;s=p(k<<3)}f=o+s|0,e=e<<3,e&&o0(f,0,e),n=f-(n<<3)|0,o&&x(n,r,o),i[A+8>>2]=(k<<3)+s,i[A+4>>2]=e+f,i[A>>2]=n,r&&Z(r);return}G0(),H()}z0(),H()}function aV(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0;f=v-32|0,v=f,k=W[i[i[e>>2]+52>>2]](e,r,0)|0,F0(r,i[e+100>>2]),u2(r,C[e+104>>1]),u2(r,C[e+106>>1]),i[r+12>>2]=k,W[i[i[e>>2]+56>>2]](f+12|0,e,r,i[r+4>>2]-(i[r>>2]+k|0)|0,0),i[r+12>>2]=i[r+4>>2]-i[r>>2],u[f+31|0]<0&&Z(i[f+20>>2]),e=i[26917],i[A>>2]=i[26916],i[A+4>>2]=e,A=A+8|0;i:{if(u[107683]>=0){e=i[26919],i[A>>2]=i[26918],i[A+4>>2]=e,i[A+8>>2]=i[26920];break i}T(A,i[26918],i[26919])}v=f+32|0}function $V(A,e,r,f,k){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0;var n=0,t=0,o=0,s=0,w=0,h=0,_=0,B=0,m=0;if((r|0)>0)for(s=1<<k-1,B=r&2147483646,m=r&1;;){if(_=G(r,w),o=0,t=0,h=0,(r|0)!=1)for(;n=o+_|0,t=((g[(n<<1)+e>>1]<<f)+s>>k)+t|0,i[(n<<2)+A>>2]=t,n=n+1|0,t=t+((g[(n<<1)+e>>1]<<f)+s>>k)|0,i[(n<<2)+A>>2]=t,o=o+2|0,h=h+2|0,(B|0)!=(h|0););if(m&&(n=o+_|0,i[(n<<2)+A>>2]=((g[(n<<1)+e>>1]<<f)+s>>k)+t),w=w+1|0,(w|0)==(r|0))break}}function nu(A,e,r){var f=0,k=0,n=0,t=0,o=0;k=i[A+8>>2],f=i[A+12>>2];i:{e:{if((k|0)==(f|0)){A=0;break e}for(A=f-k>>2,o=A>>>0<=1?1:A;;){if(t=i[(n<<2)+k>>2],!(i[t+92>>2]!=(e|0)|i[t+108>>2]<=(r|0))&i[t+100>>2]==2)break i;if(n=n+1|0,(o|0)==(n|0))break}}if(n=-1,(f|0)==(k|0))break i;for(t=A>>>0<=1?1:A,A=0;;){if(f=i[(A<<2)+k>>2],!(i[f+92>>2]!=(e|0)|i[f+108>>2]<=(r|0)|!i[f+100>>2]))return A;if(A=A+1|0,(t|0)==(A|0))break}}return n}function dV(A,e,r,f,k,n){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0;i:{if(e=i[r+4>>2],!(!l[k+12|0]|((e|0)==3|i[k+8>>2]==1))||i[r>>2]|(e|0)!=1|i[r+12>>2]!=8||u[r+8|0]&1||(e=C[r+20>>1],!(e>>>0>14|!(1<<e&18689))|!l[r+22|0]))break i;e=p(28),i[e+24>>2]=11,u[e+22|0]=1,g[e+20>>1]=2,i[e+12>>2]=8,i[e+16>>2]=131074,u[e+8|0]=0,i[e>>2]=1,i[e+4>>2]=10,r=e+28|0,i[A+8>>2]=r,i[A>>2]=e,i[A+4>>2]=r;return}i[A+8>>2]=0,i[A>>2]=0,i[A+4>>2]=0}function cV(A,e,r,f,k,n){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0;var t=0,o=0;i:{if(k=i[r+4>>2],u[f+8|0]&1|(!l[r+8|0]|k>>>0>3)||i[n+4>>2])break i;f=i[r+12>>2],n=i[r+20>>2],t=i[r+16>>2],o=i[r>>2],e=p(28),u[e+8|0]=0,i[e+4>>2]=k,i[e>>2]=o,k=l[r+9|0]|l[r+10|0]<<8,u[e+9|0]=k,u[e+10|0]=k>>>8,u[e+11|0]=l[r+11|0],i[e+24>>2]=1,i[e+16>>2]=t,i[e+20>>2]=n,i[e+12>>2]=f,r=e+28|0,i[A+8>>2]=r,i[A>>2]=e,i[A+4>>2]=r;return}i[A+8>>2]=0,i[A>>2]=0,i[A+4>>2]=0}function bV(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0;var k=0,n=0,t=0,o=0,s=0;o=v-16|0,v=o,s=i[A>>2],k=i[s+148>>2],n=(i[s+152>>2]-k|0)/20|0;i:{if(!f){t=n;break i}if((f|0)<=0|(e|0)>=(n|0))break i;for(;;){if(n=i[A>>2],b0(o+4|0,(G(t,20)+k|0)+G(e,20)|0,n?n+92|0:0),k=G(t,12)+r|0,i[k+8>>2]=i[o+12>>2],n=i[o+8>>2],i[k>>2]=i[o+4>>2],i[k+4>>2]=n,k=i[s+148>>2],t=t+1|0,(t|0)>=(f|0))break i;if(!((e+t|0)<((i[s+152>>2]-k|0)/20|0)))break}}return v=o+16|0,t|0}function l2(A,e){var r=0,f=0,k=0,n=0,t=0;i:{if(k=i[A+12>>2],f=i[A+4>>2],t=i[A>>2],(k|0)==(f-t|0)){r=i[A+8>>2];e:{if(r>>>0>f>>>0){u[f|0]=e,e=f+1|0;break e}if(n=k+1|0,(n|0)<0)break i;if(f=r-t|0,r=f<<1,n=f>>>0>=1073741823?2147483647:r>>>0>n>>>0?r:n,n?r=p(n):r=0,f=r+k|0,u[f|0]=e,k&&x(r,t,k),i[A+8>>2]=r+n,e=f+1|0,i[A+4>>2]=e,i[A>>2]=r,!t)break e;Z(t)}i[A+4>>2]=e,i[A+12>>2]=i[A+12>>2]+1;return}i[A+12>>2]=k+1,u[k+t|0]=e;return}G0(),H()}function j8(A,e,r,f,k,n){var t=0,o=0,s=0;o=v-16|0,v=o;i:{e:{if(!A||(t=i[k+12>>2],s=r-e>>2,(s|0)>0&&(W[i[i[A>>2]+48>>2]](A,e,s)|0)!=(s|0)))break e;if(e=f-e>>2,t=(e|0)<(t|0)?t-e|0:0,(t|0)>0){e=Et(o+4|0,t,n);r:{if(l[e+11|0]>>>7|0){n=i[e>>2];break r}n=e}if(n=W[i[i[A>>2]+48>>2]](A,n,t)|0,R1(e),(n|0)!=(t|0))break e}if(e=f-r>>2,(e|0)>0&&(W[i[i[A>>2]+48>>2]](A,r,e)|0)!=(e|0))break e;i[k+12>>2]=0;break i}A=0}return v=o+16|0,A}function iF(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,t=0,o=0,s=0;return t=W[i[i[A>>2]+8>>2]](A)|0,f=l0,o=r+t|0,f=o>>>0<r>>>0?f+1|0:f,s=i[A+36>>2],k=s,t=i[A+32>>2],(f|0)==(k|0)&o>>>0<=t>>>0|f>>>0<k>>>0&&(k=v-16|0,v=k,A=i[A+24>>2],i[A+4>>2]=0,$A(k+15|0,A),n=4,l[k+15|0]&&(n=i[(A+i[i[A>>2]-12>>2]|0)+24>>2],e=W[i[i[n>>2]+32>>2]](n,e,r)|0,i[A+4>>2]=e,n=(e|0)!=(r|0)?6:0),m4(A+i[i[A>>2]-12>>2]|0,n),v=k+16|0),(f|0)==(s|0)&t>>>0>=o>>>0|f>>>0<s>>>0}function tu(A){var e=0;return i[A+16>>2]=0,i[A+20>>2]=0,i[A+8>>2]=0,i[A+12>>2]=0,i[A+56>>2]=-1,i[A+60>>2]=-1,i[A+72>>2]=0,i[A+76>>2]=0,i[A+100>>2]=0,i[A+104>>2]=0,i[A+48>>2]=0,i[A+40>>2]=0,i[A+44>>2]=0,i[A+32>>2]=0,i[A+36>>2]=0,i[A+24>>2]=0,i[A+28>>2]=0,e=A- -64|0,i[e>>2]=-1,i[e+4>>2]=-1,i[A+80>>2]=0,i[A+84>>2]=0,i[A+88>>2]=0,i[A+92>>2]=0,u[A+96|0]=0,i[A+108>>2]=0,i[A+112>>2]=0,i[A+116>>2]=0,i[A+120>>2]=0,i[A+16>>2]=1835295606,i[A>>2]=86452,A}function O8(A,e,r,f,k,n){var t=0,o=0,s=0;o=v-16|0,v=o;i:{e:{if(!A||(t=i[k+12>>2],s=r-e|0,(s|0)>0&&(W[i[i[A>>2]+48>>2]](A,e,s)|0)!=(s|0)))break e;if(e=f-e|0,t=(e|0)<(t|0)?t-e|0:0,(t|0)>0){e=eu(o+4|0,t,n);r:{if(l[e+11|0]>>>7|0){n=i[e>>2];break r}n=e}if(n=W[i[i[A>>2]+48>>2]](A,n,t)|0,s2(e),(n|0)!=(t|0))break e}if(e=f-r|0,(e|0)>0&&(W[i[i[A>>2]+48>>2]](A,r,e)|0)!=(e|0))break e;i[k+12>>2]=0;break i}A=0}return v=o+16|0,A}function eF(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,t=0,o=0;for(k=v-16|0,v=k;;){i:{if((r|0)<=(n|0))break i;if(f=i[A+24>>2],o=i[A+28>>2],f>>>0>=o>>>0){if((W[i[i[A>>2]+52>>2]](A,l[e|0])|0)==-1)break i;n=n+1|0,e=e+1|0}else i[k+12>>2]=o-f,i[k+8>>2]=r-n,f=v-16|0,v=f,v=f+16|0,o=i[A+24>>2],f=k+8|0,t=k+12|0,f=i[(i[f>>2]<i[t>>2]?f:t)>>2],t=!f,t|t||x(o,e,f),i[A+24>>2]=f+i[A+24>>2],n=f+n|0,e=e+f|0;continue}break}return v=k+16|0,n|0}function BA(A,e){var r=0,f=0,k=0;f=v-16|0,v=f,i[f+12>>2]=e;i:{e:{r=l[A+11|0],k=r>>>7|0;r:{if(!k){r=r&127,e=1;break r}r=i[A+4>>2],e=(i[A+8>>2]&2147483647)-1|0}if((e|0)==(r|0)){st(A,e,1,e,e);r:if(l[A+11|0]>>>7|0)break r;break e}r:if(l[A+11|0]>>>7|0)break r;if(k)break e;e=A,u[A+11|0]=l[A+11|0]&128|r+1&127,u[A+11|0]=l[A+11|0]&127;break i}e=i[A>>2],i[A+4>>2]=r+1}A=(r<<2)+e|0,i[A>>2]=i[f+12>>2],i[f+8>>2]=0,i[A+4>>2]=i[f+8>>2],v=f+16|0}function uu(A,e,r,f){var k=0,n=0,t=0,o=0;k=v-16|0,v=k;i:{e:{r:{f:{if((A|0)!=(e|0))A:{k:{if(n=l[A|0],(n|0)!=45||(A=A+1|0,(e|0)!=(A|0)))break k;break A}o=i[31324],i[31324]=0,a2(),A=b6(A,k+12|0,f,-1,-1),f=l0,t=i[31324];k:{if(t){if(i[k+12>>2]!=(e|0))break k;if((t|0)==68)break r;break f}if(i[31324]=o,i[k+12>>2]==(e|0))break f}}i[r>>2]=4,A=0;break i}if(!f)break e}i[r>>2]=4,A=-1;break i}A=(n|0)==45?0-A|0:A}return v=k+16|0,A}function rF(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0;f=v-16|0,v=f,k=i[A>>2],n=l[k+20|0];i:{if((n|0)!=255){if(!n){if(n=i[r>>2],A=i[r+4>>2],i[r>>2]=0,i[r+4>>2]=0,r=i[e+4>>2],i[e>>2]=n,i[e+4>>2]=A,!r||(A=i[r+4>>2],i[r+4>>2]=A-1,A))break i;W[i[i[r>>2]+8>>2]](r),y(r);break i}A=i[23595],i[f+8>>2]=i[23594],i[f+12>>2]=A,W[i[(f+8|0)+(n<<2)>>2]](f+7|0,k)}i[k>>2]=i[r>>2],i[k+4>>2]=i[r+4>>2],i[r>>2]=0,i[r+4>>2]=0,u[k+20|0]=0}v=f+16|0}function ou(A,e){A=A|0,e=e|0;var r=0,f=0,k=0,n=0;u[A+44|0]=0,u[A|0]=0,l[e+76|0]==1&&(i[A>>2]=i[e+32>>2],i[A+4>>2]=i[e+36>>2],i[A+8>>2]=i[e+40>>2],i[e+40>>2]=0,i[e+32>>2]=0,i[e+36>>2]=0,i[A+12>>2]=i[e+44>>2],i[A+16>>2]=i[e+48>>2],i[A+20>>2]=i[e+52>>2],i[e+52>>2]=0,i[e+44>>2]=0,i[e+48>>2]=0,r=e- -64|0,f=i[r>>2],r=i[r+4>>2],k=i[e+72>>2],n=i[e+56>>2],e=i[e+60>>2],u[A+44|0]=1,i[A+40>>2]=k,i[A+32>>2]=f,i[A+36>>2]=r,i[A+24>>2]=n,i[A+28>>2]=e)}function Or(A,e){i:{if(A){if(e>>>0<=127)break i;e:{if(!i[i[31366]>>2]){if((e&-128)==57216)break i;break e}if(e>>>0<=2047)return u[A+1|0]=e&63|128,u[A|0]=e>>>6|192,2;if(!((e&-8192)!=57344&e>>>0>=55296))return u[A+2|0]=e&63|128,u[A|0]=e>>>12|224,u[A+1|0]=e>>>6&63|128,3;if(e-65536>>>0<=1048575)return u[A+3|0]=e&63|128,u[A|0]=e>>>18|240,u[A+2|0]=e>>>6&63|128,u[A+1|0]=e>>>12&63|128,4}i[31324]=25,A=-1}else A=1;return A}return u[A|0]=e,1}function fF(A,e){A=A|0,e=e|0;var r=0,f=0,k=0,n=0;if((e|0)>0)for(;;){if(k=i[(n<<2)+A>>2],k){r=i[k+20>>2];i:{if(!r||(f=i[r+4>>2],i[r+4>>2]=f-1,f))break i;W[i[i[r>>2]+8>>2]](r),y(r)}r=i[k+12>>2];i:{if(!r||(f=i[r+4>>2],i[r+4>>2]=f-1,f))break i;W[i[i[r>>2]+8>>2]](r),y(r)}r=i[k+4>>2];i:{if(!r||(f=i[r+4>>2],i[r+4>>2]=f-1,f))break i;W[i[i[r>>2]+8>>2]](r),y(r)}Z(k)}if(n=n+1|0,(n|0)==(e|0))break}}function c4(A,e){var r=0,f=0;f=A;i:{e:{if((f^e)&3){r=l[e|0];break e}if(e&3)for(;;){if(r=l[e|0],u[f|0]=r,!r)break i;if(f=f+1|0,e=e+1|0,!(e&3))break}if(r=i[e>>2],((r|16843008-r)&-2139062144)!=-2139062144)break e;for(;i[f>>2]=r,f=f+4|0,r=i[e+4>>2],e=e+4|0,((16843008-r|r)&-2139062144)==-2139062144;);}if(u[f|0]=r,!(r&255))break i;for(;r=l[e+1|0],u[f+1|0]=r,f=f+1|0,e=e+1|0,!!r;);}return A}function Pr(A,e){var r=0,f=0,k=0,n=0,t=0;i:{r=i[A+4>>2],n=i[A>>2],t=r-n|0,k=t+e|0;e:{if(k>>>0>t>>>0){if(f=i[A+8>>2],f-r>>>0>=e>>>0){e&&o0(r,0,e),i[A+4>>2]=e+r;break e}if((k|0)<0)break i;if(r=f-n|0,f=r<<1,f=r>>>0>=1073741823?2147483647:k>>>0<f>>>0?f:k,r=p(f),e&&o0(r+t|0,0,e),t&&x(r,n,t),i[A+8>>2]=r+f,i[A+4>>2]=r+k,i[A>>2]=r,!n)break e;Z(n);break e}if(k>>>0>=t>>>0)break e;i[A+4>>2]=k+n}i[A+12>>2]=i[A+12>>2]+e;return}G0(),H()}function AF(A,e){A=A|0,e=e|0;var r=0,f=0,k=0,n=0,t=0,o=0;f=v-16|0,v=f,o=nf()|0;i:{if(!e||(r=UA(e),(r|0)<=0))break i;if(n=f-((r<<2)+15&-16)|0,v=n,t=Un(e,n,r),t){if(e=0,(t|0)<=0)break i;for(;i[f+8>>2]=e,k=f+8|0,r=E1(85368,k|0)|0,i[f+8>>2]=i[(e<<2)+n>>2],k=E1(85380,k|0)|0,D4(o|0,r|0,k|0),k>>>0>=9&&o1(k|0),r>>>0>=9&&o1(r|0),e=e+1|0,(t|0)!=(e|0););break i}Z(n)}i[A+4>>2]=o,i[A>>2]=125368,v=f+16|0}function lu(A,e,r){var f=0,k=0,n=0,t=0,o=0;i:{if(k=v-16|0,v=k,n=r-e>>2,n>>>0<=1073741815){e:{if(n>>>0<2){u[A+11|0]=l[A+11|0]&128|n&127,u[A+11|0]=l[A+11|0]&127,f=A;break e}o=k+8|0,n>>>0>=2?(t=n+2&-2,f=t-1|0,f=(f|0)==2?t:f):f=1,pi(o,f+1|0),f=i[k+8>>2],i[A>>2]=f,i[A+8>>2]=i[A+8>>2]&-2147483648|i[k+12>>2]&2147483647,i[A+8>>2]=i[A+8>>2]|-2147483648,i[A+4>>2]=n}A=zl(e,r,f),i[k+4>>2]=0,i[A>>2]=i[k+4>>2],v=k+16|0;break i}Z4(),H()}}function kF(A,e,r){A=A|0,e=e|0,r=r|0;var f=0;if(!r){e=i[23570],i[A>>2]=i[23569],i[A+4>>2]=e,i[A+8>>2]=i[23571];return}if(i[r>>2]=0,e=i[i[e>>2]+64>>2],!e){e=i[24057],i[A>>2]=i[24056],i[A+4>>2]=e,i[A+8>>2]=i[24058];return}f=r,r=p(24),i[f>>2]=r,f=i[e+20>>2],i[r+16>>2]=i[e+16>>2],i[r+20>>2]=f,f=i[e+12>>2],i[r+8>>2]=i[e+8>>2],i[r+12>>2]=f,f=i[e+4>>2],i[r>>2]=i[e>>2],i[r+4>>2]=f,i[A+8>>2]=i[24058],e=i[24057],i[A>>2]=i[24056],i[A+4>>2]=e}function nF(A,e){A=A|0,e=e|0;var r=0,f=0,k=0,n=0;u[A+44|0]=0,u[A|0]=0,l[e+64|0]==1&&(i[A>>2]=i[e+20>>2],i[A+4>>2]=i[e+24>>2],i[A+8>>2]=i[e+28>>2],i[e+28>>2]=0,i[e+20>>2]=0,i[e+24>>2]=0,i[A+12>>2]=i[e+32>>2],i[A+16>>2]=i[e+36>>2],i[A+20>>2]=i[e+40>>2],i[e+40>>2]=0,i[e+32>>2]=0,i[e+36>>2]=0,r=i[e+52>>2],f=i[e+56>>2],k=i[e+60>>2],n=i[e+44>>2],e=i[e+48>>2],u[A+44|0]=1,i[A+40>>2]=k,i[A+32>>2]=r,i[A+36>>2]=f,i[A+24>>2]=n,i[A+28>>2]=e)}function tF(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0;f=v-32|0,v=f,k=W[i[i[e>>2]+52>>2]](e,r,0)|0,F0(r,i[e+104>>2]),F0(r,i[e+108>>2]),i[r+12>>2]=k,W[i[i[e>>2]+56>>2]](f+12|0,e,r,i[r+4>>2]-(i[r>>2]+k|0)|0,0),i[r+12>>2]=i[r+4>>2]-i[r>>2],u[f+31|0]<0&&Z(i[f+20>>2]),e=i[26917],i[A>>2]=i[26916],i[A+4>>2]=e,A=A+8|0;i:{if(u[107683]>=0){e=i[26919],i[A>>2]=i[26918],i[A+4>>2]=e,i[A+8>>2]=i[26920];break i}T(A,i[26918],i[26919])}v=f+32|0}function oi(A,e){var r=0,f=0,k=0;f=v-16|0,v=f,u[f+15|0]=e;i:{e:{r=l[A+11|0],k=r>>>7|0;r:{if(!k){r=r&127,e=10;break r}r=i[A+4>>2],e=(i[A+8>>2]&2147483647)-1|0}if((e|0)==(r|0)){tA(A,e,1,e,e);r:if(l[A+11|0]>>>7|0)break r;break e}r:if(l[A+11|0]>>>7|0)break r;if(k)break e;e=A,u[A+11|0]=l[A+11|0]&128|r+1&127,u[A+11|0]=l[A+11|0]&127;break i}e=i[A>>2],i[A+4>>2]=r+1}A=e+r|0,u[A|0]=l[f+15|0],u[f+14|0]=0,u[A+1|0]=l[f+14|0],v=f+16|0}function uF(A,e,r,f,k,n){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0;var t=0;n=v-32|0,v=n,i[n+24>>2]=0,i[n+28>>2]=0,t=n+4|0,Bf(t,i[e>>2],n+24|0,f,k,0),i[n+4>>2]||(k=p(8),i[r>>2]=k,f=i[n+24>>2],r=i[n+28>>2],i[n+24>>2]=0,i[n+28>>2]=0,i[k>>2]=f,i[k+4>>2]=r,t=107664),r=A,A=i[e>>2],b0(r,t,A?A+92|0:0),u[n+23|0]<0&&Z(i[n+12>>2]),e=i[n+28>>2];i:{if(!e||(A=i[e+4>>2],i[e+4>>2]=A-1,A))break i;W[i[i[e>>2]+8>>2]](e),y(e)}v=n+32|0}function su(A,e){A=A|0,e=e|0;var r=0,f=0;r=v-16|0,v=r,A=i[A>>2],f=i[A+48>>2],A=i[A+52>>2];i:{if(!A){s4(r+8|0,f,e);break i}if(i[A+4>>2]=i[A+4>>2]+1,s4(r+8|0,f,e),e=i[A+4>>2],i[A+4>>2]=e-1,e)break i;W[i[i[A>>2]+8>>2]](A),y(A)}e=0,A=i[r+8>>2],!A|i[A+112>>2]!=1835625829||(e=u[A+139|0]<0?i[A+128>>2]:A+128|0),A=i[r+12>>2];i:{if(!A||(f=i[A+4>>2],i[A+4>>2]=f-1,f))break i;W[i[i[A>>2]+8>>2]](A),y(A)}return v=r+16|0,e|0}function wu(A,e){A=A|0,e=e|0;var r=0,f=0;r=v-16|0,v=r,A=i[A>>2],f=i[A+48>>2],A=i[A+52>>2];i:{if(!A){s4(r+8|0,f,e);break i}if(i[A+4>>2]=i[A+4>>2]+1,s4(r+8|0,f,e),e=i[A+4>>2],i[A+4>>2]=e-1,e)break i;W[i[i[A>>2]+8>>2]](A),y(A)}e=0,A=i[r+8>>2],!A|i[A+112>>2]!=1835625829||(e=u[A+151|0]<0?i[A+140>>2]:A+140|0),A=i[r+12>>2];i:{if(!A||(f=i[A+4>>2],i[A+4>>2]=f-1,f))break i;W[i[i[A>>2]+8>>2]](A),y(A)}return v=r+16|0,e|0}function hu(A,e){A=A|0,e=e|0;var r=0,f=0;r=v-16|0,v=r,A=i[A>>2],f=i[A+48>>2],A=i[A+52>>2];i:{if(!A){s4(r+8|0,f,e);break i}if(i[A+4>>2]=i[A+4>>2]+1,s4(r+8|0,f,e),e=i[A+4>>2],i[A+4>>2]=e-1,e)break i;W[i[i[A>>2]+8>>2]](A),y(A)}e=0,A=i[r+8>>2],!A|i[A+112>>2]!=1970432288||(e=u[A+163|0]<0?i[A+152>>2]:A+152|0),A=i[r+12>>2];i:{if(!A||(f=i[A+4>>2],i[A+4>>2]=f-1,f))break i;W[i[i[A>>2]+8>>2]](A),y(A)}return v=r+16|0,e|0}function oF(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0;f=v-32|0,v=f,k=W[i[i[e>>2]+52>>2]](e,r,0)|0,F0(r,i[e+100>>2]),F0(r,i[e+104>>2]),i[r+12>>2]=k,W[i[i[e>>2]+56>>2]](f+12|0,e,r,i[r+4>>2]-(i[r>>2]+k|0)|0,0),i[r+12>>2]=i[r+4>>2]-i[r>>2],u[f+31|0]<0&&Z(i[f+20>>2]),e=i[26917],i[A>>2]=i[26916],i[A+4>>2]=e,A=A+8|0;i:{if(u[107683]>=0){e=i[26919],i[A>>2]=i[26918],i[A+4>>2]=e,i[A+8>>2]=i[26920];break i}T(A,i[26918],i[26919])}v=f+32|0}function lF(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0;f=v-32|0,v=f,k=W[i[i[e>>2]+52>>2]](e,r,0)|0,u2(r,C[e+98>>1]),u2(r,C[e+100>>1]),i[r+12>>2]=k,W[i[i[e>>2]+56>>2]](f+12|0,e,r,i[r+4>>2]-(i[r>>2]+k|0)|0,0),i[r+12>>2]=i[r+4>>2]-i[r>>2],u[f+31|0]<0&&Z(i[f+20>>2]),e=i[26917],i[A>>2]=i[26916],i[A+4>>2]=e,A=A+8|0;i:{if(u[107683]>=0){e=i[26919],i[A>>2]=i[26918],i[A+4>>2]=e,i[A+8>>2]=i[26920];break i}T(A,i[26918],i[26919])}v=f+32|0}function l4(A,e,r,f){var k=0,n=0;i:{if(l[A+11|0]>>>7|0?k=i[A+4>>2]:k=l[A+11|0]&127,!k|(r-e|0)<5)break i;cr(e,r),n=r-4|0,l[A+11|0]>>>7|0?k=i[A+4>>2]:k=l[A+11|0]&127,l[A+11|0]>>>7|0&&(A=i[A>>2]),r=A,A=k+A|0;e:{for(;;){r:{if(k=u[r|0],e>>>0>=n>>>0)break r;if(!((k|0)<=0|(k|0)>=127)&(k|0)!=i[e>>2])break e;e=e+4|0,r=((A-r|0)>1)+r|0;continue}break}if((k|0)<=0|(k|0)>=127|u[r|0]>>>0>i[n>>2]-1>>>0)break i}i[f>>2]=4}}function sF(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0;var k=0,n=0;k=v-32|0,v=k;i:{if(!f){e=i[23570],i[A>>2]=i[23569],i[A+4>>2]=e,i[A+8>>2]=i[23571];break i}Rr(k+12|0,r,0),n=i[k+12>>2];e:{if((n|0)!=i[k+16>>2]){e=p(8),r=i[i[n>>2]>>2],i[e+4>>2]=0,i[e>>2]=r,i[f>>2]=e,w5(A,e);break e}if(i[f>>2]=0,u[k|0]=0,u[k+11|0]=0,r=q(k+12|0,3,0,k),u[k+11|0]<0&&Z(i[k>>2]),b0(A,r,e?i[e>>2]:0),u[r+19|0]<0&&Z(i[r+8>>2]),!n)break i}Z(n)}v=k+32|0}function _u(A,e){A=A|0,e=e|0;var r=0,f=0,k=0,n=0;u[A+44|0]=0,u[A|0]=0,l[e+48|0]==1&&(i[A>>2]=i[e+4>>2],i[A+4>>2]=i[e+8>>2],i[A+8>>2]=i[e+12>>2],i[e+12>>2]=0,i[e+4>>2]=0,i[e+8>>2]=0,i[A+12>>2]=i[e+16>>2],i[A+16>>2]=i[e+20>>2],i[A+20>>2]=i[e+24>>2],i[e+24>>2]=0,i[e+16>>2]=0,i[e+20>>2]=0,r=i[e+36>>2],f=i[e+40>>2],k=i[e+44>>2],n=i[e+28>>2],e=i[e+32>>2],u[A+44|0]=1,i[A+40>>2]=k,i[A+32>>2]=r,i[A+36>>2]=f,i[A+24>>2]=n,i[A+28>>2]=e)}function wF(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,t=0;if(f=v-32|0,v=f,k=i[r>>2],k>>>0<2147483640){i:{e:{if(k>>>0>=11){t=k|7,n=p(t+1|0),i[f+16>>2]=t-2147483647,i[f+8>>2]=n,i[f+12>>2]=k;break e}if(u[f+19|0]=k,n=f+8|0,!k)break i}if(!k)break i;x(n,r+4|0,k)}return u[k+n|0]=0,W[A|0](f+20|0,e,f+8|0),A=p(12),i[A+8>>2]=i[f+28>>2],e=i[f+24>>2],i[A>>2]=i[f+20>>2],i[A+4>>2]=e,u[f+19|0]<0&&Z(i[f+8>>2]),v=f+32|0,A|0}Q0(),H()}function Bu(A,e,r,f,k){var n=0,t=0,o=0;o=-1,t=f&2147483647,n=(t|0)==2147418112;i:{if((n&!r?A|e:n&(r|0)!=0|t>>>0>2147418112)||(n=k&2147483647,n>>>0>2147418112&(n|0)!=2147418112))break i;if(!(A|r|(n|t|e)))return 0;if(n=f&k,(n|0)>0?n=1:n=(n|0)>=0,n){if(((r|0)!=0|(f|0)!=(k|0))&(f|0)<(k|0))break i;return(A|r|(f^k|e))!=0}if(!r&(f|0)==(k|0)?A|e:(r|0)!=0&(f|0)>=(k|0)|(f|0)>(k|0))break i;o=(A|r|(f^k|e))!=0}return o}function hF(A,e){A=A|0,e=e|0;var r=0,f=0,k=0;f=i[A>>2];i:{e:{if((e|0)==10){if(A=i[f+120>>2]-10|0,A>>>0<6)break e;r=255;break i}if(A=i[f+128>>2],r=0,!A)break i;for(k=f+128|0,f=k;r=i[A+16>>2]<(e|0),f=r?f:A,A=i[(r?4:0)+A>>2],!!A;);if(r=0,(f|0)==(k|0)|i[f+16>>2]>(e|0))break i;r=l[f+24|0]+7&-8;break i}e=A<<3,A=e&31,(e&63)>>>0>=32?A=16432>>>A|0:A=((1<<A)-1&16432)<<32-A|1076895768>>>A,r=A}return r&255}function _F(A,e,r,f,k,n){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0;var t=0,o=0;if(k=i[r+4>>2],!(!(i[r+12>>2]!=8&k>>>0<=3)|i[f+12>>2]!=8)){f=i[r+20>>2],t=i[r+16>>2],o=i[r>>2],n=l[r+8|0],e=p(28),u[e+8|0]=n,i[e+4>>2]=k,i[e>>2]=o,k=l[r+9|0]|l[r+10|0]<<8,u[e+9|0]=k,u[e+10|0]=k>>>8,u[e+11|0]=l[r+11|0],i[e+24>>2]=11,i[e+16>>2]=t,i[e+20>>2]=f,i[e+12>>2]=8,r=e+28|0,i[A+8>>2]=r,i[A>>2]=e,i[A+4>>2]=r;return}i[A+8>>2]=0,i[A>>2]=0,i[A+4>>2]=0}function BF(A,e,r,f,k,n){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0;var t=0,o=0,s=0;if(k=i[r+4>>2],!(i[r+12>>2]==8&k>>>0<=3)){i[A+8>>2]=0,i[A>>2]=0,i[A+4>>2]=0;return}f=i[f+12>>2],t=i[r+20>>2],o=i[r+16>>2],n=i[r>>2],s=l[r+8|0],e=p(28),u[e+8|0]=s,i[e+4>>2]=k,i[e>>2]=n,k=l[r+9|0]|l[r+10|0]<<8,u[e+9|0]=k,u[e+10|0]=k>>>8,u[e+11|0]=l[r+11|0],i[e+24>>2]=11,i[e+16>>2]=o,i[e+20>>2]=t,i[e+12>>2]=f,r=e+28|0,i[A+8>>2]=r,i[A>>2]=e,i[A+4>>2]=r}function vF(A,e,r,f,k,n){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0;i:{if(e=i[r+4>>2],!(!l[k+12|0]|((e|0)==3|i[k+8>>2]==1))||i[r>>2]|(e|0)!=1|i[r+12>>2]!=8||(e=C[r+20>>1],!(e>>>0>14|!(1<<e&18689))|!l[r+22|0]))break i;e=p(28),i[e+24>>2]=11,u[e+22|0]=1,g[e+20>>1]=2,i[e+12>>2]=8,i[e+16>>2]=131074,u[e+8|0]=1,i[e>>2]=1,i[e+4>>2]=11,r=e+28|0,i[A+8>>2]=r,i[A>>2]=e,i[A+4>>2]=r;return}i[A+8>>2]=0,i[A>>2]=0,i[A+4>>2]=0}function vA(A,e,r,f){var k=0,n=0,t=0,o=0;i:{e:{if(f){if(f>>>0>=357913942)break e;if(k=G(f,12),f=p(k),i[A+4>>2]=f,i[A>>2]=f,i[A+8>>2]=f+k,(e|0)!=(r|0))for(;;){if(i[f+8>>2]=0,i[f>>2]=0,i[f+4>>2]=0,t=i[e>>2],k=i[e+4>>2],(t|0)!=(k|0)){if(k=k-t|0,(k|0)<0)break i;n=p(k),i[f+4>>2]=n,i[f>>2]=n,o=k+n|0,i[f+8>>2]=o,k&&x(n,t,k),i[f+4>>2]=o}if(f=f+12|0,e=e+12|0,(r|0)==(e|0))break}i[A+4>>2]=f}return}G0(),H()}G0(),H()}function $1(A,e,r,f,k,n,t,o,s){var w=0,h=0,_=0,B=0;s=O0(e,r,o,s),o=l0,k=O0(f,k,n,t),s=k+s|0,f=l0+o|0,o=k>>>0>s>>>0?f+1|0:f,w=t,k=0,h=r,f=0,r=O0(t,k,r,f),t=r+s|0,s=l0+o|0,_=t,r=r>>>0>t>>>0?s+1|0:s,t=O0(n,0,e,0),o=l0,s=0,f=O0(n,s,h,f),o=o+f|0,n=l0+s|0,n=f>>>0>o>>>0?n+1|0:n,s=n+_|0,f=r,n=n>>>0>s>>>0?f+1|0:f,e=O0(e,B,w,k)+o|0,k=l0,k=e>>>0<o>>>0?k+1|0:k,o=k+s|0,s=n,i[A+8>>2]=o,i[A+12>>2]=k>>>0>o>>>0?s+1|0:s,i[A>>2]=t,i[A+4>>2]=e}function mF(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0;var k=0;i:{if(k=W[i[i[e>>2]+68>>2]](i[e+4>>2])|0,e=i[k>>2],!e)break i;for(;;){if(n4(i[e+4>>2],r)){if(e=i[k+4>>2],k=k+4|0,e)continue;break i}break}if(i[e+8>>2]!=3){e=i[24203],i[A>>2]=i[24202],i[A+4>>2]=e,i[A+8>>2]=i[24204];return}f&&(i[f>>2]=i[e+16>>2]),e=i[24057],i[A>>2]=i[24056],i[A+4>>2]=e,i[A+8>>2]=i[24058];return}e=i[24203],i[A>>2]=i[24202],i[A+4>>2]=e,i[A+8>>2]=i[24204]}function vu(A,e){var r=0,f=0;if((A|0)==14)return i[e>>2]?21095:19599;if(r=A&65535,f=A>>16,!((r|0)!=65535|(f|0)>5))return A=i[(f<<2)+e>>2],A?A+8|0:20051;A=42673;i:{e:{r:switch(f-1|0){case 0:if(r>>>0>1)break i;A=74288;break e;case 1:if(r>>>0>49)break i;A=74304;break e;case 4:break r;default:break i}if(r>>>0>3)break i;A=74624}if(!r)return A;for(;e=l[A|0],A=A+1|0,!(!e&&(r=r-1|0,!r)););}return A}function ZF(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0;f=v-32|0,v=f;i:{if(!(r&&e)){e=i[23570],i[A>>2]=i[23569],i[A+4>>2]=e,i[A+8>>2]=i[23571];break i}if(k=i[e>>2],!l[k+336|0]){if(u[f|0]=0,u[f+11|0]=0,r=q(f+12|0,5,139,f),u[f+11|0]<0&&Z(i[f>>2]),k=A,A=i[e>>2],b0(k,r,A?A+84|0:0),u[r+19|0]>=0)break i;Z(i[r+8>>2]);break i}e=p(80),i[r>>2]=e,x(e,k+344|0,76),i[A+8>>2]=i[24058],e=i[24057],i[A>>2]=i[24056],i[A+4>>2]=e}v=f+32|0}function GF(A,e){A=A|0,e=e|0;var r=0,f=0;r=i[A>>2],A=i[r+104>>2],r=i[r+108>>2];i:{if((A|0)!=(r|0))for(;;){e:{if(f=i[A>>2],!f||(f=W0(f,86580,89092),!f))break e;if(r=i[A+4>>2],r&&(i[r+4>>2]=i[r+4>>2]+1),e&&(A=C[f+98>>1]|C[f+100>>1]<<16,g[e>>1]=A,g[e+2>>1]=A>>>16),A=1,!r||(e=i[r+4>>2],i[r+4>>2]=e-1,e))break i;return W[i[i[r>>2]+8>>2]](r),y(r),1}if(A=A+8|0,(r|0)==(A|0))break}A=0}return A|0}function mu(A,e){var r=0,f=0,k=0,n=0;if(r=v-16|0,v=r,i[A+8>>2]=0,i[A>>2]=0,i[A+4>>2]=0,f=i[e+36>>2],k=i[e+40>>2],(f|0)!=(k|0))for(;;){e=i[f>>2];i:{if(!e||(e=W0(e,86580,87344),!e)||(i[r+8>>2]=e,e=i[f+4>>2],i[r+12>>2]=e,e&&(i[e+4>>2]=i[e+4>>2]+1),r2(A,r+8|0),e=i[r+12>>2],!e)||(n=i[e+4>>2],i[e+4>>2]=n-1,n))break i;W[i[i[e>>2]+8>>2]](e),y(e)}if(f=f+8|0,(k|0)==(f|0))break}v=r+16|0}function XF(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0;var k=0,n=0;f=v-16|0,v=f,k=e,n=C0(r),i[k+100>>2]=n,k=e,n=o2(r),g[k+104>>1]=n,k=e,n=o2(r),g[k+106>>1]=n;i:{if(l[r+20|0]==1){if(u[f+4|0]=0,u[f+15|0]=0,q(A,2,100,f+4|0),u[f+15|0]>=0)break i;Z(i[f+4>>2]);break i}if(e=i[26917],i[A>>2]=i[26916],i[A+4>>2]=e,A=A+8|0,u[107683]>=0){e=i[26919],i[A>>2]=i[26918],i[A+4>>2]=e,i[A+8>>2]=i[26920];break i}T(A,i[26918],i[26919])}v=f+16|0}function T(A,e,r){var f=0,k=0,n=0,t=0;k=v-16|0,v=k;i:{e:{if(r>>>0<11){f=A,u[A+11|0]=l[A+11|0]&128|r&127,u[A+11|0]=l[A+11|0]&127;break e}if(r>>>0>2147483639)break i;t=k+8|0,r>>>0>=11?(n=r+8&-8,f=n-1|0,f=(f|0)==11?n:f):f=10,Ci(t,f+1|0),f=i[k+8>>2],i[A>>2]=f,i[A+8>>2]=i[A+8>>2]&-2147483648|i[k+12>>2]&2147483647,i[A+8>>2]=i[A+8>>2]|-2147483648,i[A+4>>2]=r}A=r+1|0,r=!A,r|r||x(f,e,A),v=k+16|0;return}Z4(),H()}function WF(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0;f=v-32|0,v=f,k=W[i[i[e>>2]+52>>2]](e,r,0)|0,l2(r,i[e+100>>2]/90&255),i[r+12>>2]=k,W[i[i[e>>2]+56>>2]](f+12|0,e,r,i[r+4>>2]-(i[r>>2]+k|0)|0,0),i[r+12>>2]=i[r+4>>2]-i[r>>2],u[f+31|0]<0&&Z(i[f+20>>2]),e=i[26917],i[A>>2]=i[26916],i[A+4>>2]=e,A=A+8|0;i:{if(u[107683]>=0){e=i[26919],i[A>>2]=i[26918],i[A+4>>2]=e,i[A+8>>2]=i[26920];break i}T(A,i[26918],i[26919])}v=f+32|0}function QF(A,e,r,f,k){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0;var n=0,t=0,o=0,s=0;n=v-16|0,v=n,e=i[e>>2],s=i[e+48>>2],e=i[e+52>>2],e&&(i[e+4>>2]=i[e+4>>2]+1),t=p(4),i[n+4>>2]=t,o=t+4|0,i[n+12>>2]=o,i[t>>2]=k,i[n+8>>2]=o,a4(s,f,r,n+4|0),r=i[n+4>>2],r&&(i[n+8>>2]=r,Z(r));i:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break i;W[i[i[e>>2]+8>>2]](e),y(e)}e=i[24057],i[A>>2]=i[24056],i[A+4>>2]=e,i[A+8>>2]=i[24058],v=n+16|0}function q2(A,e,r){var f=0,k=0,n=0,t=0,o=0,s=0,w=0;f=v-16|0,v=f,G1(f+8|0,A);i:{if(!l[f+8|0]||(n=f+4|0,k=i[(i[i[A>>2]-12>>2]+A|0)+28>>2],i[n>>2]=k,(k|0)!=129576&&(i[k+4>>2]=i[k+4>>2]+1),k=c0(n,129440),e2(n),i[f>>2]=i[(i[i[A>>2]-12>>2]+A|0)+24>>2],t=i[i[A>>2]-12>>2]+A|0,o=t6(t),s=f,w=W[i[i[k>>2]+28>>2]](k,i[f>>2],t,o,e,r)|0,i[s+4>>2]=w,i[n>>2]))break i;m4(i[i[A>>2]-12>>2]+A|0,5)}return _1(f+8|0),v=f+16|0,A}function gF(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0;f=v-80|0,v=f;i:{k=1;e:{if(S1(A,e,0)||(k=0,!e)||(e=W0(e,84888,84936),k=0,!e))break e;if(k=i[r>>2],!k)break i;o0(f+24|0,0,56),u[f+75|0]=1,i[f+32>>2]=-1,i[f+28>>2]=A,i[f+20>>2]=e,i[f+68>>2]=1,W[i[i[e>>2]+28>>2]](e,f+20|0,k,1),A=i[f+44>>2],(A|0)==1&&(i[r>>2]=i[f+36>>2]),k=(A|0)==1}return v=f+80|0,k|0}i[f+8>>2]=20178,i[f+4>>2]=485,i[f>>2]=7828,g1(),H()}function VF(A,e,r,f,k){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0;var n=0,t=0,o=0,s=0,w=0,h=0,_=0,B=0;if((r|0)>0)for(o=1<<k-1,_=r&2147483646,B=r&1;;){if(h=G(r,s),n=0,w=0,(r|0)!=1)for(;t=n+h|0,i[(t<<2)+A>>2]=(g[(t<<1)+e>>1]<<f)+o>>k,t=t+1|0,i[(t<<2)+A>>2]=(g[(t<<1)+e>>1]<<f)+o>>k,n=n+2|0,w=w+2|0,(_|0)!=(w|0););if(B&&(n=n+h|0,i[(n<<2)+A>>2]=(g[(n<<1)+e>>1]<<f)+o>>k),s=s+1|0,(s|0)==(r|0))break}}function mA(A){var e=0,r=0,f=0,k=0;r=53,k=i[A+24>>2],e=i[A+28>>2],f=k-e|0,e=(((e-((k+6>>>0)%7|0)|0)+7>>>0)/7|0)+((f+369>>>0)%7>>>0<3)|0;i:{if((e|0)!=53){if(r=e,e)break i;r=52;e:switch(((f+6>>>0)%7|0)-4|0){case 1:if(!Cl((i[A+20>>2]%400|0)-1|0))break i;break;case 0:break e;default:break i}return 53}e:switch(((f+371>>>0)%7|0)-3|0){case 0:if(Cl(i[A+20>>2]))break i;break;case 1:break i;default:break e}r=1}return r}function Zu(A,e){var r=0,f=0,k=0,n=0,t=0,o=0,s=0;r=v-16|0,v=r,G1(r+8|0,A);i:{if(!l[r+8|0]||(k=r+4|0,f=i[(i[i[A>>2]-12>>2]+A|0)+28>>2],i[k>>2]=f,(f|0)!=129576&&(i[f+4>>2]=i[f+4>>2]+1),f=c0(k,129440),e2(k),i[r>>2]=i[(i[i[A>>2]-12>>2]+A|0)+24>>2],n=i[i[A>>2]-12>>2]+A|0,t=t6(n),o=r,s=W[i[i[f>>2]+32>>2]](f,i[r>>2],n,t,+e)|0,i[o+4>>2]=s,i[k>>2]))break i;m4(i[i[A>>2]-12>>2]+A|0,5)}return _1(r+8|0),v=r+16|0,A}function FF(A,e,r,f,k,n,t,o){if(A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,t=t|0,o=o|0,i[e+8>>2]!=1){e=i[24203],i[A>>2]=i[24202],i[A+4>>2]=e,i[A+8>>2]=i[24204];return}i:{if(!l[e+16|0]||(k&&(i[k>>2]=i[e+20>>2]),!n))break i;i[n>>2]=i[e+24>>2]}r&&(i[r>>2]=l[e+16|0]),f&&(i[f>>2]=l[e+16|0]),!o|i[e+32>>2]<=0||(i[o>>2]=i[e+28>>2]),t&&(i[t>>2]=i[e+32>>2]),e=i[24057],i[A>>2]=i[24056],i[A+4>>2]=e,i[A+8>>2]=i[24058]}function A2(A){A=A|0;var e=0,r=0,f=0,k=0;if(i[A>>2]=86656,u[A+95|0]<0&&Z(i[A+84>>2]),e=i[A+72>>2],e&&(i[A+76>>2]=e,Z(e)),e=i[A+36>>2],e){if(r=e,f=i[A+40>>2],(e|0)!=(f|0)){for(;;){r=i[f-4>>2];i:{if(!r||(k=i[r+4>>2],i[r+4>>2]=k-1,k))break i;W[i[i[r>>2]+8>>2]](r),y(r)}if(f=f-8|0,(e|0)==(f|0))break}r=i[A+36>>2]}i[A+40>>2]=e,Z(r)}return i[A>>2]=86356,e=i[A+20>>2],e&&(i[A+24>>2]=e,Z(e)),A|0}function IF(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0;f=v-32|0,v=f;i:{e:{if(k=i[e>>2],!k||(k=W0(k,106564,106696),!k))break e;if(e=i[e+4>>2],e&&(i[e+4>>2]=i[e+4>>2]+1),Lf(f+12|0,k,r),u[f+31|0]<0&&Z(i[f+20>>2]),r=i[24164],i[A>>2]=i[24163],i[A+4>>2]=r,i[A+8>>2]=i[24165],!e||(A=i[e+4>>2],i[e+4>>2]=A-1,A))break i;W[i[i[e>>2]+8>>2]](e),y(e);break i}i[A>>2]=5,i[A+4>>2]=2006,i[A+8>>2]=24655}v=f+32|0}function V0(A,e){var r=0,f=0,k=0,n=0,t=0,o=0,s=0;r=v-16|0,v=r,G1(r+8|0,A);i:{if(!l[r+8|0]||(k=r+4|0,f=i[(i[i[A>>2]-12>>2]+A|0)+28>>2],i[k>>2]=f,(f|0)!=129576&&(i[f+4>>2]=i[f+4>>2]+1),f=c0(k,129440),e2(k),i[r>>2]=i[(i[i[A>>2]-12>>2]+A|0)+24>>2],n=i[i[A>>2]-12>>2]+A|0,t=t6(n),o=r,s=W[i[i[f>>2]+24>>2]](f,i[r>>2],n,t,e)|0,i[o+4>>2]=s,i[k>>2]))break i;m4(i[i[A>>2]-12>>2]+A|0,5)}return _1(r+8|0),v=r+16|0,A}function li(A,e){var r=0,f=0,k=0,n=0,t=0,o=0,s=0;r=v-16|0,v=r,G1(r+8|0,A);i:{if(!l[r+8|0]||(k=r+4|0,f=i[(i[i[A>>2]-12>>2]+A|0)+28>>2],i[k>>2]=f,(f|0)!=129576&&(i[f+4>>2]=i[f+4>>2]+1),f=c0(k,129440),e2(k),i[r>>2]=i[(i[i[A>>2]-12>>2]+A|0)+24>>2],n=i[i[A>>2]-12>>2]+A|0,t=t6(n),o=r,s=W[i[i[f>>2]+12>>2]](f,i[r>>2],n,t,e)|0,i[o+4>>2]=s,i[k>>2]))break i;m4(i[i[A>>2]-12>>2]+A|0,5)}return _1(r+8|0),v=r+16|0,A}function d1(A,e){var r=0,f=0,k=0,n=0,t=0,o=0,s=0;r=v-16|0,v=r,G1(r+8|0,A);i:{if(!l[r+8|0]||(k=r+4|0,f=i[(i[i[A>>2]-12>>2]+A|0)+28>>2],i[k>>2]=f,(f|0)!=129576&&(i[f+4>>2]=i[f+4>>2]+1),f=c0(k,129440),e2(k),i[r>>2]=i[(i[i[A>>2]-12>>2]+A|0)+24>>2],n=i[i[A>>2]-12>>2]+A|0,t=t6(n),o=r,s=W[i[i[f>>2]+32>>2]](f,i[r>>2],n,t,e)|0,i[o+4>>2]=s,i[k>>2]))break i;m4(i[i[A>>2]-12>>2]+A|0,5)}return _1(r+8|0),v=r+16|0,A}function S0(A,e){var r=0,f=0,k=0,n=0,t=0,o=0,s=0;r=v-16|0,v=r,G1(r+8|0,A);i:{if(!l[r+8|0]||(k=r+4|0,f=i[(i[i[A>>2]-12>>2]+A|0)+28>>2],i[k>>2]=f,(f|0)!=129576&&(i[f+4>>2]=i[f+4>>2]+1),f=c0(k,129440),e2(k),i[r>>2]=i[(i[i[A>>2]-12>>2]+A|0)+24>>2],n=i[i[A>>2]-12>>2]+A|0,t=t6(n),o=r,s=W[i[i[f>>2]+16>>2]](f,i[r>>2],n,t,e)|0,i[o+4>>2]=s,i[k>>2]))break i;m4(i[i[A>>2]-12>>2]+A|0,5)}return _1(r+8|0),v=r+16|0,A}function CF(A,e){A=A|0,e=e|0;var r=0,f=0,k=0,n=0,t=0,o=0;f=v-16|0,v=f,t=nf()|0;i:{if(!e||(r=qA(e),(r|0)<=0)||(n=f-((r<<2)+15&-16)|0,v=n,o=Lt(e,n,r),(o|0)<=0))break i;for(e=0;i[f+8>>2]=e,k=f+8|0,r=E1(85368,k|0)|0,i[f+8>>2]=i[(e<<2)+n>>2],k=E1(85380,k|0)|0,D4(t|0,r|0,k|0),k>>>0>=9&&o1(k|0),r>>>0>=9&&o1(r|0),e=e+1|0,(o|0)!=(e|0););}i[A+4>>2]=t,i[A>>2]=125368,v=f+16|0}function pF(A,e,r,f,k,n){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0;var t=0,o=0,s=0,w=0,h=0;if(!(k&1)){if(!((n|0)<=0|(k|0)<=0))for(;;){for(s=G(e,o)+A|0,w=(G(f,o)<<1)+r|0,h=0;t=g[w>>1]+32>>6,t=(t|0)>=255?255:t,u[s|0]=(t|0)>0?t:0,t=g[w+2>>1]+32>>6,t=(t|0)>=255?255:t,u[s+1|0]=(t|0)>0?t:0,w=w+4|0,s=s+2|0,h=h+2|0,(h|0)<(k|0););if(o=o+1|0,(o|0)==(n|0))break}return}D0(21986,18216,40,10302),H()}function Gu(A,e){var r=0,f=0,k=0,n=0,t=0;k=v-16|0,v=k,t=i[31366],i[e+72>>2]<=0&&h5(e),i[31366]=i[e+136>>2],r=-1,i[e+4>>2]||(Ge(e),f=!i[e+4>>2]);i:{if(f|(A|0)==-1||(f=Or(k+12|0,A),(f|0)<0)||(n=i[e+4>>2],n>>>0<(f+i[e+44>>2]|0)-8>>>0))break i;e:{if(A>>>0<=127){r=n-1|0,i[e+4>>2]=r,u[r|0]=A;break e}r=n-f|0,i[e+4>>2]=r,A8(r,k+12|0,f)}i[e>>2]=i[e>>2]&-17,r=A}return i[31366]=t,v=k+16|0,(r|0)!=-1}function F8(A,e){var r=0,f=0,k=0;if((e|0)<=8){if(!e)return 0;f=i[A+16>>2]<<e,i[A+16>>2]=f,r=C[A+20>>1]+e|0,g[A+20>>1]=r,r=r<<16>>16;i:{if((r|0)<0||(k=i[A+4>>2],k>>>0>=u0[A+8>>2]))break i;i[A+4>>2]=k+1,k=l[k|0],g[A+20>>1]=r-8,f=k<<r|f}return k=i[A+12>>2]<<7,r=(f>>>0)/(k>>>0)|0,e=1<<e,(r|0)>=(e|0)&&(r=e-1|0),i[A+16>>2]=f-G(r,k),r}for(f=e-8|0,e=io(A);e=k4(A)|e<<1,f=f-1|0,!!f;);return e}function yF(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0;f=v-32|0,v=f,k=W[i[i[e>>2]+52>>2]](e,r,0)|0,u2(r,C[e+98>>1]),i[r+12>>2]=k,W[i[i[e>>2]+56>>2]](f+12|0,e,r,i[r+4>>2]-(i[r>>2]+k|0)|0,0),i[r+12>>2]=i[r+4>>2]-i[r>>2],u[f+31|0]<0&&Z(i[f+20>>2]),e=i[26917],i[A>>2]=i[26916],i[A+4>>2]=e,A=A+8|0;i:{if(u[107683]>=0){e=i[26919],i[A>>2]=i[26918],i[A+4>>2]=e,i[A+8>>2]=i[26920];break i}T(A,i[26918],i[26919])}v=f+32|0}function EF(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0;f=v-32|0,v=f,k=W[i[i[e>>2]+52>>2]](e,r,0)|0,l2(r,l[e+100|0]),i[r+12>>2]=k,W[i[i[e>>2]+56>>2]](f+12|0,e,r,i[r+4>>2]-(i[r>>2]+k|0)|0,0),i[r+12>>2]=i[r+4>>2]-i[r>>2],u[f+31|0]<0&&Z(i[f+20>>2]),e=i[26917],i[A>>2]=i[26916],i[A+4>>2]=e,A=A+8|0;i:{if(u[107683]>=0){e=i[26919],i[A>>2]=i[26918],i[A+4>>2]=e,i[A+8>>2]=i[26920];break i}T(A,i[26918],i[26919])}v=f+32|0}function YF(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0;f=v-32|0,v=f,k=W[i[i[e>>2]+52>>2]](e,r,0)|0,F4(r,e+104|0,1),i[r+12>>2]=k,W[i[i[e>>2]+56>>2]](f+12|0,e,r,i[r+4>>2]-(i[r>>2]+k|0)|0,0),i[r+12>>2]=i[r+4>>2]-i[r>>2],u[f+31|0]<0&&Z(i[f+20>>2]),e=i[26917],i[A>>2]=i[26916],i[A+4>>2]=e,A=A+8|0;i:{if(u[107683]>=0){e=i[26919],i[A>>2]=i[26918],i[A+4>>2]=e,i[A+8>>2]=i[26920];break i}T(A,i[26918],i[26919])}v=f+32|0}function RF(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0;f=v-32|0,v=f,k=W[i[i[e>>2]+52>>2]](e,r,0)|0,F4(r,e+100|0,0),i[r+12>>2]=k,W[i[i[e>>2]+56>>2]](f+12|0,e,r,i[r+4>>2]-(i[r>>2]+k|0)|0,0),i[r+12>>2]=i[r+4>>2]-i[r>>2],u[f+31|0]<0&&Z(i[f+20>>2]),e=i[26917],i[A>>2]=i[26916],i[A+4>>2]=e,A=A+8|0;i:{if(u[107683]>=0){e=i[26919],i[A>>2]=i[26918],i[A+4>>2]=e,i[A+8>>2]=i[26920];break i}T(A,i[26918],i[26919])}v=f+32|0}function ZA(A,e){var r=0,f=0,k=0;i:{e:{if(r=i[e+36>>2],f=i[e+40>>2],(r|0)!=(f|0)){if(e=i[r>>2],e&&(k=i[A+4>>2],e=W0(e,86580,87424),e))break e;if(r=r+8|0,(f|0)!=(r|0))for(;;){if(e=i[r>>2],e&&(k=0,e=W0(e,86580,87424),e))break e;if(r=r+8|0,(f|0)==(r|0))break}i[A>>2]=0,i[A+4>>2]=0}i[A>>2]=0,i[A+4>>2]=0;break i}if(i[A+4>>2]=k,i[A>>2]=e,e=A,A=i[r+4>>2],i[e+4>>2]=A,!A)break i;i[A+4>>2]=i[A+4>>2]+1}}function JF(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0;var k=0,n=0;f=v-32|0,v=f,z2(f,e,r),u[f+19|0]<0&&Z(i[f+8>>2]),k=e,n=X2(r),u[k+104|0]=n;i:{if(l[r+20|0]==1){if(u[f+20|0]=0,u[f+31|0]=0,q(A,2,100,f+20|0),u[f+31|0]>=0)break i;Z(i[f+20>>2]);break i}if(e=i[26917],i[A>>2]=i[26916],i[A+4>>2]=e,A=A+8|0,u[107683]>=0){e=i[26919],i[A>>2]=i[26918],i[A+4>>2]=e,i[A+8>>2]=i[26920];break i}T(A,i[26918],i[26919])}v=f+32|0}function NF(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0;k=i[A>>2],f=i[k+156>>2],k=i[k+160>>2];i:{if((f|0)!=(k|0))for(n=i[i[A+8>>2]>>2];;){if(A=i[f>>2],i[A>>2]==(n|0)){if(f=i[f+4>>2],!f){f=0;break i}i[f+4>>2]=i[f+4>>2]+1;break i}if(f=f+8|0,(k|0)==(f|0))break}f=0,A=0}e&&(i[e>>2]=i[A+4>>2]),r&&(i[r>>2]=i[A+8>>2]);i:{if(!f||(A=i[f+4>>2],i[f+4>>2]=A-1,A))break i;W[i[i[f>>2]+8>>2]](f),y(f)}}function UF(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0,f=v-32|0,v=f,z2(f,e,r),u[f+19|0]<0&&Z(i[f+8>>2]);i:{if(l[e+97|0]){t1(A,e,15907);break i}if(l[r+20|0]==1){if(u[f+20|0]=0,u[f+31|0]=0,q(A,2,100,f+20|0),u[f+31|0]>=0)break i;Z(i[f+20>>2]);break i}if(e=i[26917],i[A>>2]=i[26916],i[A+4>>2]=e,A=A+8|0,u[107683]>=0){e=i[26919],i[A>>2]=i[26918],i[A+4>>2]=e,i[A+8>>2]=i[26920];break i}T(A,i[26918],i[26919])}v=f+32|0}function Xu(A,e){var r=0,f=0,k=0;i:{if((A|0)!=(e|0)){r=i[e+4>>2];e:{if(!r){r=0;break e}if(i[A+8>>2]<<5>>>0<r>>>0){if(f=i[A>>2],f&&(Z(f),i[A+8>>2]=0,i[A>>2]=0,i[A+4>>2]=0,r=i[e+4>>2]),(r|0)<0)break i;r=(r-1>>>5|0)+1|0,f=p(r<<2),i[A+8>>2]=r,i[A+4>>2]=0,i[A>>2]=f,r=i[e+4>>2]}if(f=i[e>>2],k=(f+(r-1>>>3&536870908)|0)+4|0,(k|0)==(f|0))break e;r=k-f|0,r&&x(i[A>>2],f,r),r=i[e+4>>2]}i[A+4>>2]=r}return}G0(),H()}function GA(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,t=0;f=v-32|0,v=f;i:{e:{if(k=i[26955],!k)break e;for(n=107820;t=u0[k+16>>2]<r>>>0,n=t?n:k,k=i[(t?4:0)+k>>2],!!k;);if((n|0)==107820|u0[n+16>>2]>r>>>0)break e;i[e+12>>2]=r,b0(A,107664,0);break i}if(i[e+12>>2]=2,u[f|0]=0,u[f+11|0]=0,e=A,A=q(f+12|0,2,135,f),b0(e,A,0),u[A+19|0]<0&&Z(i[A+8>>2]),u[f+11|0]>=0)break i;Z(i[f>>2])}v=f+32|0}function DF(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0;f=v-32|0,v=f,k=W[i[i[e>>2]+52>>2]](e,r,0)|0,I4(r,e+120|0),i[r+12>>2]=k,W[i[i[e>>2]+56>>2]](f+12|0,e,r,i[r+4>>2]-(i[r>>2]+k|0)|0,0),i[r+12>>2]=i[r+4>>2]-i[r>>2],u[f+31|0]<0&&Z(i[f+20>>2]),e=i[26917],i[A>>2]=i[26916],i[A+4>>2]=e,A=A+8|0;i:{if(u[107683]>=0){e=i[26919],i[A>>2]=i[26918],i[A+4>>2]=e,i[A+8>>2]=i[26920];break i}T(A,i[26918],i[26919])}v=f+32|0}function Wu(A,e){var r=0,f=0,k=0,n=0,t=0;i:{r=i[A+4>>2],k=i[A>>2],n=r-k|0;e:{if(n>>>0<e>>>0){if(t=e-n|0,f=i[A+8>>2],t>>>0<=f-r>>>0){t&&o0(r,0,t),i[A+4>>2]=r+t;return}if((e|0)<0)break i;if(r=f-k|0,f=r<<1,f=r>>>0>=1073741823?2147483647:e>>>0<f>>>0?f:e,r=p(f),t&&o0(r+n|0,0,t),n&&x(r,k,n),i[A+8>>2]=r+f,i[A+4>>2]=e+r,i[A>>2]=r,!k)break e;Z(k);return}if(e>>>0>=n>>>0)break e;i[A+4>>2]=e+k}return}G0(),H()}function le(A,e,r){var f=U(0),k=U(0),n=U(0),t=U(0),o=0,s=U(0);o=v-16|0,v=o,Vn(o+8|0,e,r),f=p0[o+12>>2],k=p0[o+8>>2];i:{if(!(f!=U(0)|k!=U(0))){k=U(-.714136004447937),f=U(-.34413599967956543),n=U(1.7719999551773071),t=U(1.4019999504089355);break i}t=U(U(1)-k),s=U(U(f+k)+U(-1)),k=U(U(U(k+k)*t)/s),n=U(U(1)-f),f=U(U(U(f+f)*n)/s),n=U(n+n),t=U(t+t)}p0[A+16>>2]=n,p0[A+12>>2]=k,p0[A+8>>2]=f,p0[A+4>>2]=t,u[A|0]=1,v=o+16|0}function Qu(A,e){A=A|0,e=e|0;var r=0,f=0;r=v-16|0,v=r,A=i[A>>2],f=i[A+48>>2],A=i[A+52>>2];i:{if(!A){s4(r+8|0,f,e);break i}if(i[A+4>>2]=i[A+4>>2]+1,s4(r+8|0,f,e),e=i[A+4>>2],i[A+4>>2]=e-1,e)break i;W[i[i[A>>2]+8>>2]](A),y(A)}A=i[r+8>>2],A?A=u[A+127|0]<0?i[A+116>>2]:A+116|0:A=0,e=i[r+12>>2];i:{if(!e||(f=i[e+4>>2],i[e+4>>2]=f-1,f))break i;W[i[i[e>>2]+8>>2]](e),y(e)}return v=r+16|0,A|0}function XA(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,t=0;f=v-32|0,v=f;i:{e:{if(k=i[26949],!k)break e;for(n=107796;t=u0[k+16>>2]<r>>>0,n=t?n:k,k=i[(t?4:0)+k>>2],!!k;);if((n|0)==107796|u0[n+16>>2]>r>>>0)break e;i[e+4>>2]=r,b0(A,107664,0);break i}if(i[e+4>>2]=2,u[f|0]=0,u[f+11|0]=0,e=A,A=q(f+12|0,2,133,f),b0(e,A,0),u[A+19|0]<0&&Z(i[A+8>>2]),u[f+11|0]>=0)break i;Z(i[f>>2])}v=f+32|0}function WA(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,t=0;f=v-32|0,v=f;i:{e:{if(k=i[26952],!k)break e;for(n=107808;t=u0[k+16>>2]<r>>>0,n=t?n:k,k=i[(t?4:0)+k>>2],!!k;);if((n|0)==107808|u0[n+16>>2]>r>>>0)break e;i[e+8>>2]=r,b0(A,107664,0);break i}if(i[e+8>>2]=2,u[f|0]=0,u[f+11|0]=0,e=A,A=q(f+12|0,2,134,f),b0(e,A,0),u[A+19|0]<0&&Z(i[A+8>>2]),u[f+11|0]>=0)break i;Z(i[f>>2])}v=f+32|0}function gu(A,e){var r=0,f=0,k=0,n=0;r=v-16|0,v=r,i[r+8>>2]=0,i[r+12>>2]=0,i[r>>2]=0,i[r+4>>2]=0,e4(r,i[e+8>>2],i[e+12>>2]),l2(r,((l[e+17|0]?64:0)|(l[e+16|0]?-128:0)|(l[e+18|0]?32:0))&224),i[A+8>>2]=0,i[A>>2]=0,i[A+4>>2]=0;i:{if(f=i[r+4>>2],e=i[r>>2],(f|0)!=(e|0)){if(f=f-e|0,(f|0)<0)break i;k=p(f),i[A>>2]=k,n=f+k|0,i[A+8>>2]=n,f&&x(k,e,f),i[A+4>>2]=n}e&&(i[r+4>>2]=e,Z(e)),v=r+16|0;return}G0(),H()}function se(A){A=A|0;var e=0,r=0,f=0;i[A>>2]=71296,r=v-16|0,v=r,e=i[A+64>>2],e&&(i[r+4>>2]=1957,e=Q1(r+8|0,e,r+4|0),W[i[i[A>>2]+24>>2]](A)|0,f=i[e>>2],i[e>>2]=0,LA(f),i[A+64>>2]=0,W[i[i[A>>2]+12>>2]](A,0,0)|0,f=i[e>>2],i[e>>2]=0,f&&W[i[e+4>>2]](f)|0),v=r+16|0;i:{if(l[A+96|0]!=1||(e=i[A+32>>2],!e))break i;Z(e)}i:{if(l[A+97|0]!=1||(e=i[A+56>>2],!e))break i;Z(e)}return E0(A)|0}function MF(A,e){A=A|0,e=e|0;var r=0,f=0;r=A+68|0;i:{if(l[A+80|0]==1){if((e|0)==(r|0))break i;if(f=u[e+11|0],u[A+79|0]>=0){if((f|0)>=0){A=i[e+4>>2],i[r>>2]=i[e>>2],i[r+4>>2]=A,i[r+8>>2]=i[e+8>>2];return}M1(r,i[e>>2],i[e+4>>2]);return}A=(f|0)<0,O1(r,A?i[e>>2]:e,A?i[e+4>>2]:f);return}e:{if(u[e+11|0]>=0){f=i[e+4>>2],i[r>>2]=i[e>>2],i[r+4>>2]=f,i[r+8>>2]=i[e+8>>2];break e}T(r,i[e>>2],i[e+4>>2])}u[A+80|0]=1}}function P8(A,e,r,f){var k=0;i:{k=i[e+104>>2],e=i[e+108>>2];e:{if((k|0)!=(e|0))for(;;){if(!(i[k+40>>2]!=(r|0)|i[k+16>>2]!=(f|0))){if(i[A+8>>2]=0,i[A>>2]=0,i[A+4>>2]=0,e=i[k+48>>2],r=i[k+44>>2],(e|0)==(r|0))break e;if(e=e-r|0,(e|0)<0)break i;f=p(e),i[A>>2]=f,k=e+f|0,i[A+8>>2]=k,e&&x(f,r,e),i[A+4>>2]=k;return}if(k=k+56|0,(e|0)==(k|0))break}i[A+8>>2]=0,i[A>>2]=0,i[A+4>>2]=0}return}G0(),H()}function HF(A,e,r,f,k,n){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0;var t=0;i:{if(i[r>>2]|i[r+4>>2]!=2|i[k+8>>2]!=2||(f=i[r+12>>2],(f|0)<=8)||(k=C[r+20>>1],!k))break i;n=l[r+8|0],t=i[r+16>>2],r=l[r+22|0],e=p(28),i[e+24>>2]=11,u[e+22|0]=r,g[e+20>>1]=k,i[e+16>>2]=t,i[e+12>>2]=f,u[e+8|0]=n,i[e>>2]=0,i[e+4>>2]=3,r=e+28|0,i[A+8>>2]=r,i[A>>2]=e,i[A+4>>2]=r;return}i[A+8>>2]=0,i[A>>2]=0,i[A+4>>2]=0}function we(A,e){var r=0,f=0,k=0,n=0,t=0;i:{if((e|0)<=0)break i;for(t=i[A+12>>2]<<7,f=C[A+20>>1],r=i[A+16>>2];;){f=f+1|0,g[A+20>>1]=f,r=r<<1,i[A+16>>2]=r,f=f<<16>>16;e:{if((f|0)<0||(f=65528,g[A+20>>1]=65528,n=i[A+4>>2],n>>>0>=u0[A+8>>2]))break e;i[A+4>>2]=n+1,r=l[n|0]|r,i[A+16>>2]=r}if(r>>>0<t>>>0)break i;if(r=r-t|0,i[A+16>>2]=r,k=k+1|0,(k|0)==(e|0))break}k=e}return(e|0)>(k|0)?k:e}function zF(A,e,r,f,k,n){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0;var t=0;i:{if(i[r>>2]|i[r+4>>2]!=1|i[k+8>>2]!=2||(f=i[r+12>>2],(f|0)>=9)||(k=C[r+20>>1],!k))break i;n=l[r+8|0],t=i[r+16>>2],r=l[r+22|0],e=p(28),i[e+24>>2]=11,u[e+22|0]=r,g[e+20>>1]=k,i[e+16>>2]=t,i[e+12>>2]=f,u[e+8|0]=n,i[e>>2]=0,i[e+4>>2]=3,r=e+28|0,i[A+8>>2]=r,i[A>>2]=e,i[A+4>>2]=r;return}i[A+8>>2]=0,i[A>>2]=0,i[A+4>>2]=0}function xF(A,e,r,f,k,n){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0;var t=0;i:{if(i[r>>2]|i[r+4>>2]!=1|i[k+8>>2]!=2||(f=i[r+12>>2],(f|0)<=8)||(k=C[r+20>>1],!k))break i;n=l[r+8|0],t=i[r+16>>2],r=l[r+22|0],e=p(28),i[e+24>>2]=11,u[e+22|0]=r,g[e+20>>1]=k,i[e+16>>2]=t,i[e+12>>2]=f,u[e+8|0]=n,i[e>>2]=0,i[e+4>>2]=3,r=e+28|0,i[A+8>>2]=r,i[A>>2]=e,i[A+4>>2]=r;return}i[A+8>>2]=0,i[A>>2]=0,i[A+4>>2]=0}function TF(A,e,r,f,k,n){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0;var t=0;i:{if(i[r>>2]|i[r+4>>2]!=2|i[k+8>>2]!=2||(f=i[r+12>>2],(f|0)>=9)||(k=C[r+20>>1],!k))break i;n=l[r+8|0],t=i[r+16>>2],r=l[r+22|0],e=p(28),i[e+24>>2]=11,u[e+22|0]=r,g[e+20>>1]=k,i[e+16>>2]=t,i[e+12>>2]=f,u[e+8|0]=n,i[e>>2]=0,i[e+4>>2]=3,r=e+28|0,i[A+8>>2]=r,i[A>>2]=e,i[A+4>>2]=r;return}i[A+8>>2]=0,i[A>>2]=0,i[A+4>>2]=0}function QA(A,e){var r=0,f=0,k=0;r=i[e+60>>2];i:{e:{if(r&16){f=i[e+56>>2],r=i[e+36>>2],f>>>0<r>>>0&&(i[e+56>>2]=r,f=r),e=e+32|0;break e}if(!(r&8)){e=0,u[A+11|0]=0;break i}f=i[e+28>>2],e=e+20|0}e:{if(k=i[e>>2],e=f-k|0,e>>>0<2147483640){if(e>>>0>=11){f=e|7,r=p(f+1|0),i[A+8>>2]=f-2147483647,i[A>>2]=r,i[A+4>>2]=e,A=r;break e}if(u[A+11|0]=e,e)break e;e=0;break i}Q0(),H()}if(!e)break i;x(A,k,e)}u[A+e|0]=0}function SF(A,e,r,f,k,n){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0;var t=0,o=0,s=0;return A=v-256|0,v=A,i[A+248>>2]=37,i[A+252>>2]=0,t=A+248|0,o6(t|1,9862,1,i[r+4>>2]),o=a2(),i[A>>2]=k,i[A+4>>2]=n,k=A+224|0,t=h4(k,24,o,t,A)+k|0,s=z4(k,t,r),o=A+20|0,n=i[r+28>>2],i[o>>2]=n,(n|0)!=129576&&(i[n+4>>2]=i[n+4>>2]+1),n=k,k=A+32|0,Ir(n,s,t,k,A+28|0,A+24|0,o),e2(o),e=j8(e,k,i[A+28>>2],i[A+24>>2],r,f),v=A+256|0,e|0}function jF(A,e,r,f,k,n){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0;var t=0,o=0,s=0;return A=v-256|0,v=A,i[A+248>>2]=37,i[A+252>>2]=0,t=A+248|0,o6(t|1,9862,0,i[r+4>>2]),o=a2(),i[A>>2]=k,i[A+4>>2]=n,k=A+224|0,t=h4(k,24,o,t,A)+k|0,s=z4(k,t,r),o=A+20|0,n=i[r+28>>2],i[o>>2]=n,(n|0)!=129576&&(i[n+4>>2]=i[n+4>>2]+1),n=k,k=A+32|0,Ir(n,s,t,k,A+28|0,A+24|0,o),e2(o),e=j8(e,k,i[A+28>>2],i[A+24>>2],r,f),v=A+256|0,e|0}function OF(A,e,r,f,k,n){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0;var t=0,o=0,s=0;return A=v-112|0,v=A,i[A+104>>2]=37,i[A+108>>2]=0,t=A+104|0,o6(t|1,9862,1,i[r+4>>2]),o=a2(),i[A>>2]=k,i[A+4>>2]=n,k=A+80|0,t=h4(k,24,o,t,A)+k|0,s=z4(k,t,r),o=A+20|0,n=i[r+28>>2],i[o>>2]=n,(n|0)!=129576&&(i[n+4>>2]=i[n+4>>2]+1),n=k,k=A+32|0,Cr(n,s,t,k,A+28|0,A+24|0,o),e2(o),e=O8(e,k,i[A+28>>2],i[A+24>>2],r,f),v=A+112|0,e|0}function PF(A,e,r,f,k,n){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0;var t=0,o=0,s=0;return A=v-112|0,v=A,i[A+104>>2]=37,i[A+108>>2]=0,t=A+104|0,o6(t|1,9862,0,i[r+4>>2]),o=a2(),i[A>>2]=k,i[A+4>>2]=n,k=A+80|0,t=h4(k,24,o,t,A)+k|0,s=z4(k,t,r),o=A+20|0,n=i[r+28>>2],i[o>>2]=n,(n|0)!=129576&&(i[n+4>>2]=i[n+4>>2]+1),n=k,k=A+32|0,Cr(n,s,t,k,A+28|0,A+24|0,o),e2(o),e=O8(e,k,i[A+28>>2],i[A+24>>2],r,f),v=A+112|0,e|0}function Vu(A,e,r,f){var k=0,n=0;i:{if(f>>>0>=3){i[31324]=28;break i}e:{if((f|0)!=1||(k=i[A+8>>2],!k))break e;n=e,k=k-i[A+4>>2]|0,e=e-k|0,r=r-((k>>31)+(k>>>0>n>>>0)|0)|0}if(i[A+20>>2]!=i[A+28>>2]&&(W[i[A+36>>2]](A,0,0)|0,!i[A+20>>2])||(i[A+28>>2]=0,i[A+16>>2]=0,i[A+20>>2]=0,W[i[A+40>>2]](A,e,r,f)|0,(l0|0)<0))break i;return i[A+4>>2]=0,i[A+8>>2]=0,i[A>>2]=i[A>>2]&-17,0}return-1}function LF(A,e){A=A|0,e=e|0;var r=0,f=0;f=i[e+104>>2],e=i[e+108>>2];i:{if((f|0)==(e|0))break i;for(;;){e:{r:{if(r=i[f>>2],!r||!W0(r,86580,99476))break r;if(r=i[f+4>>2],!r)break e;i[r+4>>2]=i[r+4>>2]+1;break i}if(f=f+8|0,(e|0)!=(f|0))continue}break}r=0}i[A>>2]=0,i[A+4>>2]=0,u[A+20|0]=0,i[A+8>>2]=0;i:{if(!r||(A=i[r+4>>2],i[r+4>>2]=A-1,A))break i;W[i[i[r>>2]+8>>2]](r),y(r)}}function KF(A){A=A|0;var e=0,r=0,f=0,k=0,n=0,t=0,o=0,s=0;if(i[A>>2]=97504,n=i[A+132>>2],n){if(e=n,r=i[A+136>>2],(e|0)!=(r|0)){for(;;){if(o=r-12|0,f=i[o>>2],f){if(k=f,s=r-8|0,e=i[s>>2],(f|0)!=(e|0)){for(;k=e-12|0,t=i[k>>2],t&&(i[e-8>>2]=t,Z(t)),e=k,(f|0)!=(e|0););k=i[o>>2]}i[s>>2]=f,Z(k)}if(r=r-16|0,(n|0)==(r|0))break}e=i[A+132>>2]}i[A+136>>2]=n,Z(e)}return A2(A)|0}function qF(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0;f=v-32|0,v=f,k=W[i[i[e>>2]+52>>2]](e,r,0)|0,i[r+12>>2]=k,W[i[i[e>>2]+56>>2]](f+12|0,e,r,i[r+4>>2]-(i[r>>2]+k|0)|0,0),i[r+12>>2]=i[r+4>>2]-i[r>>2],u[f+31|0]<0&&Z(i[f+20>>2]),e=i[26917],i[A>>2]=i[26916],i[A+4>>2]=e,A=A+8|0;i:{if(u[107683]>=0){e=i[26919],i[A>>2]=i[26918],i[A+4>>2]=e,i[A+8>>2]=i[26920];break i}T(A,i[26918],i[26919])}v=f+32|0}function Lr(A,e,r){var f=0,k=0,n=0;f=i[r+16>>2];i:{if(!f){if(dA(r))break i;f=i[r+16>>2]}if(k=i[r+20>>2],f-k>>>0<e>>>0)return W[i[r+36>>2]](r,A,e)|0;e:{r:{if(!e|i[r+80>>2]<0)break r;for(f=e;;){if(n=A+f|0,l[n-1|0]!=10){if(f=f-1|0,f)continue;break r}break}if(k=W[i[r+36>>2]](r,A,f)|0,k>>>0<f>>>0)break i;e=e-f|0,k=i[r+20>>2];break e}n=A,f=0}A8(k,n,e),i[r+20>>2]=i[r+20>>2]+e,k=e+f|0}return k}function Fu(A,e,r,f){var k=0,n=0,t=0;k=v-16|0,v=k,t=i[e+48>>2],f=i[i[f>>2]+116>>2],r=i[i[r>>2]+116>>2],e=p(4),i[k+4>>2]=e,n=e+4|0,i[k+12>>2]=n,i[e>>2]=r,i[k+8>>2]=n,a4(t,f,1953000802,k+4|0),e=i[k+4>>2],e&&(i[k+8>>2]=e,Z(e)),e=i[26917],i[A>>2]=i[26916],i[A+4>>2]=e,A=A+8|0;i:{if(u[107683]>=0){e=i[26919],i[A>>2]=i[26918],i[A+4>>2]=e,i[A+8>>2]=i[26920];break i}T(A,i[26918],i[26919])}v=k+16|0}function aF(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0;var k=0,n=0;f=v-16|0,v=f,k=e,n=C0(r),i[k+100>>2]=n,k=e,n=C0(r),i[k+104>>2]=n;i:{if(l[r+20|0]==1){if(u[f+4|0]=0,u[f+15|0]=0,q(A,2,100,f+4|0),u[f+15|0]>=0)break i;Z(i[f+4>>2]);break i}if(e=i[26917],i[A>>2]=i[26916],i[A+4>>2]=e,A=A+8|0,u[107683]>=0){e=i[26919],i[A>>2]=i[26918],i[A+4>>2]=e,i[A+8>>2]=i[26920];break i}T(A,i[26918],i[26919])}v=f+16|0}function $F(A){A=A|0;var e=0,r=0,f=0,k=0,n=0,t=0,o=0,s=0;if(i[A>>2]=97504,n=i[A+132>>2],n){if(e=n,r=i[A+136>>2],(e|0)!=(r|0)){for(;;){if(o=r-12|0,f=i[o>>2],f){if(k=f,s=r-8|0,e=i[s>>2],(f|0)!=(e|0)){for(;k=e-12|0,t=i[k>>2],t&&(i[e-8>>2]=t,Z(t)),e=k,(f|0)!=(e|0););k=i[o>>2]}i[s>>2]=f,Z(k)}if(r=r-16|0,(n|0)==(r|0))break}e=i[A+132>>2]}i[A+136>>2]=n,Z(e)}Z(A2(A))}function dF(A,e){A=A|0,e=e|0;var r=0,f=0,k=0;return r=v-48|0,v=r,Mf(r+12|0,i[A>>2],e),e=0,f=l[r+32|0],f||(e=p(16),k=i[r+12>>2],f=i[r+16>>2],f&&(i[f+4>>2]=i[f+4>>2]+1),i[e+4>>2]=f,i[e>>2]=k,f=i[A>>2],A=i[A+4>>2],A&&(i[A+4>>2]=i[A+4>>2]+1),i[e+12>>2]=A,i[e+8>>2]=f,f=l[r+32|0]),(f|0)!=255&&(A=i[24189],i[r+40>>2]=i[24188],i[r+44>>2]=A,W[i[(r+40|0)+(f<<2)>>2]](r+39|0,r+12|0)),v=r+48|0,e|0}function cF(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0;var k=0,n=0;f=v-16|0,v=f,k=e,n=o2(r),g[k+98>>1]=n,k=e,n=o2(r),g[k+100>>1]=n;i:{if(l[r+20|0]==1){if(u[f+4|0]=0,u[f+15|0]=0,q(A,2,100,f+4|0),u[f+15|0]>=0)break i;Z(i[f+4>>2]);break i}if(e=i[26917],i[A>>2]=i[26916],i[A+4>>2]=e,A=A+8|0,u[107683]>=0){e=i[26919],i[A>>2]=i[26918],i[A+4>>2]=e,i[A+8>>2]=i[26920];break i}T(A,i[26918],i[26919])}v=f+16|0}function bF(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0;var k=0,n=0,t=0;n=59072;i:{if(!f)break i;for(;;){if(t=100,f-k>>>0<4){k=7,n=59080;break i}if(n=k+4|0,k=r+k|0,k=l[k|0]|l[k+1|0]<<8|(l[k+2|0]<<16|l[k+3|0]<<24),k=k<<24|(k&65280)<<8|(k>>>8&65280|k>>>24),f-n>>>0<k>>>0){k=7,n=59080;break i}if(t=0,Jf(i[e>>2],r+n|0,k,0,0,0),k=k+n|0,!(k>>>0<f>>>0))break}k=0,n=59072}i[A+8>>2]=n,i[A+4>>2]=t,i[A>>2]=k}function iI(A,e,r,f,k){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0;for(var n=0,t=0,o=0,s=0,w=0,h=0;;){i:{if((r|0)==(f|0)|k>>>0<=s>>>0)break i;o=1,n=v-16|0,v=n,i[n+12>>2]=i[A+8>>2],t=s8(n+8|0,n+12|0),w=ne(0,r,f-r|0,e||129404),t=i[t>>2],t&&(i[31366]=(t|0)==-1?125344:t),v=n+16|0;e:switch(w+2|0){default:o=w;break;case 0:case 1:break i;case 2:break e}s=s+1|0,h=o+h|0,r=r+o|0;continue}break}return h|0}function eI(A,e,r,f,k){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0;var n=0,t=0,o=0,s=0,w=0;i:{if(f)for(;;){if(s=100,w=7,t=59080,f-n>>>0<4||(o=n+4|0,n=r+n|0,n=l[n|0]|l[n+1|0]<<8|(l[n+2|0]<<16|l[n+3|0]<<24),n=n<<24|(n&65280)<<8|(n>>>8&65280|n>>>24),t=59080,f-o>>>0<n>>>0))break i;if(Jf(i[e>>2],r+o|0,n,0,0,k),n=n+o|0,!(n>>>0<f>>>0))break}w=0,s=0,t=59072}i[A+8>>2]=t,i[A+4>>2]=s,i[A>>2]=w}function z2(A,e,r){var f=0,k=0;f=v-16|0,v=f,k=C0(r),i[e+100>>2]=k&16777215,u[e+97|0]=k>>>24,i[e+32>>2]=i[e+32>>2]+4;i:{if(l[r+20|0]==1){if(u[f+4|0]=0,u[f+15|0]=0,q(A,2,100,f+4|0),u[f+15|0]>=0)break i;Z(i[f+4>>2]);break i}if(e=i[26917],i[A>>2]=i[26916],i[A+4>>2]=e,A=A+8|0,u[107683]>=0){e=i[26919],i[A>>2]=i[26918],i[A+4>>2]=e,i[A+8>>2]=i[26920];break i}T(A,i[26918],i[26919])}v=f+16|0}function rI(A,e){A=A|0,e=e|0;var r=0,f=0;r=i[A+24>>2],r>>>0>u0[A+44>>2]&&(i[A+44>>2]=r);i:{if(r=i[A+8>>2],f=i[A+12>>2],r>>>0>=f>>>0)break i;if((e|0)==-1)return i[A+16>>2]=i[A+44>>2],i[A+12>>2]=f-1,i[A+8>>2]=r,((e|0)!=-1?e:0)|0;if(f=i[A+12>>2]-1|0,!(l[A+48|0]&16)&l[f|0]!=(e&255))break i;return r=i[A+8>>2],i[A+16>>2]=i[A+44>>2],i[A+12>>2]=f,i[A+8>>2]=r,u[i[A+12>>2]]=e<<24>>24,e|0}return-1}function fI(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,t=0,o=0,s=0,w=0;if((r|0)>0)for(s=r&2147483646,w=r&1;;){if(f=0,k=0,o=0,(r|0)!=1)for(;t=G(r,f)+n|0,k=g[(t<<1)+e>>1]+k|0,i[(t<<2)+A>>2]=k,t=G(f|1,r)+n|0,k=k+g[(t<<1)+e>>1]|0,i[(t<<2)+A>>2]=k,f=f+2|0,o=o+2|0,(s|0)!=(o|0););if(w&&(f=G(r,f)+n|0,i[(f<<2)+A>>2]=g[(f<<1)+e>>1]+k),n=n+1|0,(n|0)==(r|0))break}}function AI(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0;f=v-48|0,v=f,k=W[i[i[e>>2]+52>>2]](e,r,0)|0,F0(r,0),u2(r,0),u2(r,C[e+98>>1]),Du(f+28|0,e,r),u[f+47|0]<0&&Z(i[f+36>>2]),f1(f+8|0,e,r,k),u[f+27|0]<0&&Z(i[f+16>>2]),e=i[26917],i[A>>2]=i[26916],i[A+4>>2]=e,A=A+8|0;i:{if(u[107683]>=0){e=i[26919],i[A>>2]=i[26918],i[A+4>>2]=e,i[A+8>>2]=i[26920];break i}T(A,i[26918],i[26919])}v=f+48|0}function Iu(A,e,r,f){var k=0,n=0,t=0;k=v-16|0,v=k;i:{e:{if((A|0)!=(e|0)){t=i[31324],i[31324]=0,a2(),A=b6(A,k+12|0,f,0,-2147483648),f=l0,n=i[31324];r:{if(n){if(i[k+12>>2]!=(e|0))break r;if((n|0)==68)break e;break i}if(i[31324]=t,i[k+12>>2]==(e|0))break i}}i[r>>2]=4,A=0,f=0;break i}if(i[r>>2]=4,!!A&(f|0)>=0|(f|0)>0){A=-1,f=2147483647;break i}A=0,f=-2147483648}return v=k+16|0,l0=f,A}function Cu(A,e){A=A|0,e=e|0;var r=0,f=0;r=v-16|0,v=r,A=i[A>>2],f=i[A+48>>2],A=i[A+52>>2];i:{if(!A){s4(r+8|0,f,e);break i}if(i[A+4>>2]=i[A+4>>2]+1,s4(r+8|0,f,e),e=i[A+4>>2],i[A+4>>2]=e-1,e)break i;W[i[i[A>>2]+8>>2]](A),y(A)}A=i[r+8>>2],A?A=l[A+164|0]:A=1,e=i[r+12>>2];i:{if(!e||(f=i[e+4>>2],i[e+4>>2]=f-1,f))break i;W[i[i[e>>2]+8>>2]](e),y(e)}return v=r+16|0,A|0}function pu(A){var e=0,r=0,f=0;r=i[A+8>>2],r&&W[r|0](),e=i[26927];i:{e:{if(!e){f=107708,r=107708;break e}for(;;){if(r=e,e=i[e+16>>2],e>>>0>A>>>0){if(f=r,e=i[r>>2],e)continue;break e}if(A>>>0<=e>>>0)break i;if(e=i[r+4>>2],!e)break}f=r+4|0}e=p(20),i[e+8>>2]=r,i[e>>2]=0,i[e+4>>2]=0,i[e+16>>2]=A,i[f>>2]=e,A=i[i[26926]>>2],A&&(i[26926]=A),m1(i[26927],e),i[26928]=i[26928]+1}}function yu(A,e,r){var f=0,k=0,n=0,t=0,o=0,s=0;k=v-16|0,v=k,n=i[A+4>>2],f=i[r>>2]-i[A>>2]|0;i:{if(f>>>0<2147483647){f=f<<1;break i}f=-1}if(t=f>>>0<=1?1:f,o=i[e>>2],s=i[A>>2],f=vr((n|0)!=2072?i[A>>2]:0,t),f){(n|0)!=2072&&(i[A>>2]=0),i[k+4>>2]=2071,f=Q1(k+8|0,f,k+4|0),El(A,f),n=i[f>>2],i[f>>2]=0,n&&W[i[f+4>>2]](n),i[e>>2]=i[A>>2]+(o-s|0),i[r>>2]=t+i[A>>2],v=k+16|0;return}g1(),H()}function kI(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0;var k=0,n=0,t=0;n=f,e=i[e+64>>2];i:{if(l[e+103|0]){t=2,k=0;break i}if(f=l[e+104|0],e=l[e+105|0],k=1,(f|0)==1&(e|0)==1||(k=2,!(e|(f|0)!=1)))break i;k=e|f?99:3}if(i[n>>2]=k,i[r>>2]=t,e=i[26917],i[A>>2]=i[26916],i[A+4>>2]=e,A=A+8|0,u[107683]>=0){e=i[26919],i[A>>2]=i[26918],i[A+4>>2]=e,i[A+8>>2]=i[26920];return}T(A,i[26918],i[26919])}function nI(A,e,r,f,k){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0;var n=0,t=0,o=0,s=0;return A=v-144|0,v=A,i[A+136>>2]=37,i[A+140>>2]=0,n=A+136|0,o6(n|1,10154,1,i[r+4>>2]),t=a2(),i[A>>2]=k,k=A+123|0,t=h4(k,13,t,n,A)+k|0,s=z4(k,t,r),o=A+4|0,n=i[r+28>>2],i[o>>2]=n,(n|0)!=129576&&(i[n+4>>2]=i[n+4>>2]+1),n=k,k=A+16|0,Ir(n,s,t,k,A+12|0,A+8|0,o),e2(o),e=j8(e,k,i[A+12>>2],i[A+8>>2],r,f),v=A+144|0,e|0}function tI(A,e,r,f,k){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0;var n=0,t=0,o=0,s=0;return A=v-144|0,v=A,i[A+136>>2]=37,i[A+140>>2]=0,n=A+136|0,o6(n|1,10154,0,i[r+4>>2]),t=a2(),i[A>>2]=k,k=A+123|0,t=h4(k,13,t,n,A)+k|0,s=z4(k,t,r),o=A+4|0,n=i[r+28>>2],i[o>>2]=n,(n|0)!=129576&&(i[n+4>>2]=i[n+4>>2]+1),n=k,k=A+16|0,Ir(n,s,t,k,A+12|0,A+8|0,o),e2(o),e=j8(e,k,i[A+12>>2],i[A+8>>2],r,f),v=A+144|0,e|0}function f4(A,e){var r=0,f=0,k=0;if(r=i[A+16>>2],r>>>0<e>>>0){if(r){if(e=i[A+8>>2],e){for(;i[e+16>>2]=i[e+16>>2]-r,e=i[e+8>>2],!!e;);r=i[A+16>>2]}f=i[A>>2],e=W[i[i[f>>2]+8>>2]](f)|0,k=l0,e=e+r|0,k=e>>>0<r>>>0?k+1|0:k,W[i[i[f>>2]+20>>2]](f,e,k)|0,i[A+16>>2]=0}return u[A+20|0]=1,0}f=i[A+8>>2];i:{if(f){if(r=0,!f4(f,e))break i;r=i[A+16>>2]}i[A+16>>2]=r-e,r=1}return r}function Eu(A,e,r){var f=0,k=0,n=U(0),t=0;k=v-16|0,v=k;i:{e:{r:{if((A|0)!=(e|0)){t=i[31324],i[31324]=0,a2(),f=v-16|0,v=f,zA(f,A,k+12|0,0),n=Cn(i[f>>2],i[f+4>>2],i[f+8>>2],i[f+12>>2]),v=f+16|0;f:{if(A=i[31324],A){if(i[k+12>>2]==(e|0))break f;break r}if(i[31324]=t,i[k+12>>2]!=(e|0))break r;break i}if((A|0)!=68)break i;break e}i[r>>2]=4;break i}n=U(0)}i[r>>2]=4}return v=k+16|0,n}function si(A,e,r){var f=0,k=0,n=0,t=0,o=0,s=0;k=v-16|0,v=k,n=i[A+4>>2],f=i[r>>2]-i[A>>2]|0;i:{if(f>>>0<2147483647){f=f<<1;break i}f=-1}if(t=f||4,o=i[e>>2],s=i[A>>2],f=vr((n|0)!=2072?i[A>>2]:0,t),f){(n|0)!=2072&&(i[A>>2]=0),i[k+4>>2]=2071,f=Q1(k+8|0,f,k+4|0),El(A,f),n=i[f>>2],i[f>>2]=0,n&&W[i[f+4>>2]](n),i[e>>2]=i[A>>2]+(o-s|0),i[r>>2]=i[A>>2]+(t&-4),v=k+16|0;return}g1(),H()}function P2(A,e){var r=0,f=0,k=0;i:{if(r=ql(e),f=l[A+11|0]>>>7|0?(i[A+8>>2]&2147483647)-1|0:1,l[A+11|0]>>>7|0?k=i[A+4>>2]:k=l[A+11|0]&127,r>>>0<=f>>>0){l[A+11|0]>>>7|0?f=i[A>>2]:f=A;e:{if(!r||(k=r<<2,!k))break e;x(f,e,k)}e=v-16|0,v=e;e:if(l[A+11|0]>>>7|0)break e;z6(A,r),i[e+12>>2]=0,i[f+(r<<2)>>2]=i[e+12>>2],v=e+16|0;break i}Hn(A,f,r-f|0,k,0,k,r,e)}}function Yu(A,e){var r=0;return i[A+4>>2]=0,i[A+8>>2]=0,i[A+40>>2]=0,i[A+44>>2]=0,u[A+36|0]=0,i[A+32>>2]=9e4,i[A+24>>2]=0,i[A+28>>2]=0,i[A+12>>2]=0,i[A+16>>2]=4740,i[A+48>>2]=0,i[A+52>>2]=0,i[A+56>>2]=0,i[A+60>>2]=0,r=A- -64|0,i[r>>2]=0,i[r+4>>2]=0,i[A+72>>2]=0,i[A+76>>2]=0,i[A+80>>2]=0,i[A+84>>2]=0,i[A+88>>2]=0,i[A+92>>2]=0,u[A+96|0]=0,i[A>>2]=106540,o0(A+100|0,0,188),i[A+20>>2]=e,A}function uI(A,e,r,f,k){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0;var n=0,t=0,o=0,s=0;return A=v+-64|0,v=A,i[A+56>>2]=37,i[A+60>>2]=0,n=A+56|0,o6(n|1,10154,1,i[r+4>>2]),t=a2(),i[A>>2]=k,k=A+43|0,t=h4(k,13,t,n,A)+k|0,s=z4(k,t,r),o=A+4|0,n=i[r+28>>2],i[o>>2]=n,(n|0)!=129576&&(i[n+4>>2]=i[n+4>>2]+1),n=k,k=A+16|0,Cr(n,s,t,k,A+12|0,A+8|0,o),e2(o),e=O8(e,k,i[A+12>>2],i[A+8>>2],r,f),v=A- -64|0,e|0}function oI(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0;f=v-32|0,v=f,k=W[i[i[e>>2]+52>>2]](e,r,0)|0,u2(r,C[e+104>>1]),u2(r,C[e+106>>1]),u2(r,C[e+108>>1]),u2(r,C[e+110>>1]),f1(f+12|0,e,r,k),u[f+31|0]<0&&Z(i[f+20>>2]),e=i[26917],i[A>>2]=i[26916],i[A+4>>2]=e,A=A+8|0;i:{if(u[107683]>=0){e=i[26919],i[A>>2]=i[26918],i[A+4>>2]=e,i[A+8>>2]=i[26920];break i}T(A,i[26918],i[26919])}v=f+32|0}function lI(A,e,r,f,k){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0;var n=0,t=0,o=0,s=0;return A=v+-64|0,v=A,i[A+56>>2]=37,i[A+60>>2]=0,n=A+56|0,o6(n|1,10154,0,i[r+4>>2]),t=a2(),i[A>>2]=k,k=A+43|0,t=h4(k,13,t,n,A)+k|0,s=z4(k,t,r),o=A+4|0,n=i[r+28>>2],i[o>>2]=n,(n|0)!=129576&&(i[n+4>>2]=i[n+4>>2]+1),n=k,k=A+16|0,Cr(n,s,t,k,A+12|0,A+8|0,o),e2(o),e=O8(e,k,i[A+12>>2],i[A+8>>2],r,f),v=A- -64|0,e|0}function Ru(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0;if(!r)return 0;i:{e:{r:{if(!A||(f=i[A>>2],!f)||(A=i[f+128>>2],!A))break r;for(k=f+128|0,f=k;n=i[A+16>>2]<(e|0),f=n?f:A,A=i[(n?4:0)+A>>2],!!A;);if((f|0)==(k|0))break r;if(k=0,A=0,i[f+16>>2]>(e|0))break e;if(A=0,k=i[f+56>>2],(k|0)<0)break i;A=i[f+44>>2];break e}k=0,A=0}i[r>>2]=k}return A|0}function Ju(A,e){A=A|0,e=e|0;var r=0;if((e|0)<8)return 3;i:{e:{if(l[A+4|0]!=102|l[A+5|0]!=116|(l[A+6|0]!=121|l[A+7|0]!=112))break e;if(e>>>0<12)return 3;r=1,A=Yo(A,e);r:{if((A|0)<=1781689192){if((A|0)==1635150182|(A|0)==1751476579)break e;if((A|0)!=1751476600)break r;break e}if(A-1835623985>>>0<2)break i;if((A|0)==1781689193|(A|0)==1785750887)break e}r=2}return r|0}return 3}function gA(A,e,r){var f=0,k=0;i:{f=i[e+100>>2],e=i[e+104>>2];e:{if((f|0)!=(e|0))for(;;){if(i[f>>2]==(r|0)){if(i[A+8>>2]=0,i[A>>2]=0,i[A+4>>2]=0,e=i[f+8>>2],r=i[f+4>>2],(e|0)==(r|0))break e;if(e=e-r|0,(e|0)<0)break i;f=p(e),i[A>>2]=f,k=e+f|0,i[A+8>>2]=k,e&&x(f,r,e),i[A+4>>2]=k;return}if(f=f+16|0,(e|0)==(f|0))break}i[A+8>>2]=0,i[A>>2]=0,i[A+4>>2]=0}return}G0(),H()}function C0(A){var e=0,r=0,f=0;r=v-16|0,v=r;i:{if(!f4(A,4))break i;f=i[A>>2],e=i[A+4>>2],e&&(i[e+4>>2]=i[e+4>>2]+1);e:{if(!(W[i[i[f>>2]+16>>2]](f,r+12|0,4)|0)){i8(A),f=0;break e}A=l[r+12|0]|l[r+13|0]<<8|(l[r+14|0]<<16|l[r+15|0]<<24),f=A<<24|(A&65280)<<8|(A>>>8&65280|A>>>24)}if(!e||(A=i[e+4>>2],i[e+4>>2]=A-1,A))break i;W[i[i[e>>2]+8>>2]](e),y(e)}return v=r+16|0,f}function sI(A,e){A=A|0,e=e|0;var r=0,f=0,k=0;if(A=i[A>>2],f=i[A+244>>2],r=i[A+248>>2],r&&(i[r+4>>2]=i[r+4>>2]+1),f){A=i[f+100>>2],f=i[f+104>>2];i:{if((A|0)!=(f|0))for(;;){if(k=i[A+8>>2]-i[A+4>>2]>>2,i[A>>2]==(e|0))break i;if(A=A+16|0,(f|0)==(A|0))break}k=0}A=k}else A=0;i:{if(!r||(e=i[r+4>>2],i[r+4>>2]=e-1,e))break i;W[i[i[r>>2]+8>>2]](r),y(r)}return A|0}function Nu(A,e,r){var f=0,k=0,n=0,t=0;k=v-16|0,v=k;i:{e:{r:{if((A|0)!=(e|0)){t=i[31324],i[31324]=0,a2(),f=v-16|0,v=f,zA(f,A,k+12|0,1),n=Pf(i[f>>2],i[f+4>>2],i[f+8>>2],i[f+12>>2]),v=f+16|0;f:{if(A=i[31324],A){if(i[k+12>>2]==(e|0))break f;break r}if(i[31324]=t,i[k+12>>2]!=(e|0))break r;break i}if((A|0)!=68)break i;break e}i[r>>2]=4;break i}n=0}i[r>>2]=4}return v=k+16|0,n}function wI(A){A=A|0;var e=0,r=0,f=0,k=0;f=-1,e=i[A+104>>2],A=i[A+108>>2];i:{if((e|0)==(A|0))break i;for(;;){e:{r:{if(r=i[e>>2],!r||(r=W0(r,86580,100372),!r))break r;if(A=i[e+4>>2],A)break e;return l[r+104|0]}if(e=e+8|0,(A|0)!=(e|0))continue;break i}break}if(e=i[A+4>>2],k=e+1|0,i[A+4>>2]=k,f=l[r+104|0],i[A+4>>2]=e,k)break i;W[i[i[A>>2]+8>>2]](A),y(A)}return f|0}function hI(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0;var k=0,n=0;f=v-16|0,v=f,k=e,n=G(X2(r)&3,90),i[k+100>>2]=n;i:{if(l[r+20|0]==1){if(u[f+4|0]=0,u[f+15|0]=0,q(A,2,100,f+4|0),u[f+15|0]>=0)break i;Z(i[f+4>>2]);break i}if(e=i[26917],i[A>>2]=i[26916],i[A+4>>2]=e,A=A+8|0,u[107683]>=0){e=i[26919],i[A>>2]=i[26918],i[A+4>>2]=e,i[A+8>>2]=i[26920];break i}T(A,i[26918],i[26919])}v=f+16|0}function _I(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0;f=v-32|0,v=f,k=ir()|0;i:{if(!e){i[A+4>>2]=k,i[A>>2]=125368;break i}qf(f+8|0,e,r,f+20|0);e:{if(i[f+8>>2]){e=p(12),i[e+8>>2]=i[f+16>>2],r=i[f+12>>2],i[e>>2]=i[f+8>>2],i[e+4>>2]=r,i[f+24>>2]=e,e=E1(96260,f+24|0)|0;break e}i[f+24>>2]=i[f+20>>2],e=E1(96336,f+24|0)|0}if(i[A+4>>2]=e,i[A>>2]=125368,k>>>0<9)break i;o1(k|0)}v=f+32|0}function BI(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0;f=v-32|0,v=f,k=f+12|0,r4(k,i[A+100>>2],i[i[A+460>>2]>>2],1),A=i[f+16>>2],n=k,k=i[f+12>>2],W[i[i[k>>2]+52>>2]](n,k),n=i[f+12>>2],u[f+31|0]<0&&Z(i[f+20>>2]),n&&(i[r>>2]=0,i[e>>2]=0),i[e>>2]=i[k+120>>2],i[r>>2]=i[k+124>>2];i:{if(!A||(e=i[A+4>>2],i[A+4>>2]=e-1,e))break i;W[i[i[A>>2]+8>>2]](A),y(A)}v=f+32|0}function vI(A,e,r,f,k){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0;var n=0,t=0;n=v-16|0,v=n;i:{if(f&&(A=0,(k|0)<=0))break i;Rr(n+4|0,e,r),t=i[n+8>>2],r=i[n+4>>2],e=t-r>>2;e:{r:{if(!f){A=e;break r}if(A=0,(r|0)==(t|0)|(k|0)<=0)break r;for(;;){if(t=A<<2,i[t+f>>2]=i[r+t>>2],A=A+1|0,(k|0)<=(A|0))break e;if(!(A>>>0<e>>>0))break}break e}if(!r)break i}Z(r)}return v=n+16|0,A|0}function mI(A,e,r,f,k){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0;var n=0,t=0,o=0,s=0,w=0;return A=v-208|0,v=A,n=a2(),i[A>>2]=k,t=A+176|0,s=h4(t,20,n,7929,A),o=t+s|0,w=z4(t,o,r),k=A+16|0,n=i[r+28>>2],i[k>>2]=n,(n|0)!=129576&&(i[n+4>>2]=i[n+4>>2]+1),n=c0(k,129752),e2(k),W[i[i[n>>2]+48>>2]](n,t,o,k)|0,n=e,e=k+(s<<2)|0,e=j8(n,k,(o|0)==(w|0)?e:((w-A<<2)+A|0)-688|0,e,r,f),v=A+208|0,e|0}function M4(A,e,r){var f=0,k=0;i:{if(!i[e>>2]){A=0;break i}if(r2(A+104|0,e),f=i[A+100>>2],k=i[f+48>>2],f=i[f+52>>2],!f){A=f3(k,i[A+116>>2],e,r);break i}if(i[f+4>>2]=i[f+4>>2]+1,A=f3(k,i[A+116>>2],e,r),r=i[f+4>>2],i[f+4>>2]=r-1,r)break i;W[i[i[f>>2]+8>>2]](f),y(f)}e=i[e+4>>2];i:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break i;W[i[i[e>>2]+8>>2]](e),y(e)}return A}function VA(A){var e=0,r=0,f=0;f=v-16|0,v=f,M2(+A),r=t2(1)|0,t2(0)|0,r=r&2147483647;i:{if(r>>>0<=1072243195){if(e=1,r>>>0<1044816030)break i;e=Xe(A,0);break i}if(e=A-A,r>>>0>=2146435072)break i;r=q7(A,f),A=t0[f+8>>3],e=t0[f>>3];e:switch((r&3)-1|0){default:e=Xe(e,A);break i;case 0:e=-_e(e,A,1);break i;case 1:e=-Xe(e,A);break i;case 2:break e}e=_e(e,A,1)}return v=f+16|0,e}function ZI(A){A=A|0;var e=0,r=0,f=0,k=0;i[A>>2]=97960;i:{if(l[A+64|0]!=1||(r=i[A+32>>2],r&&(i[A+36>>2]=r,Z(r)),r=i[A+20>>2],!r))break i;if(e=r,f=i[A+24>>2],(e|0)!=(f|0)){for(;;){e=i[f-4>>2];e:{if(!e||(k=i[e+4>>2],i[e+4>>2]=k-1,k))break e;W[i[i[e>>2]+8>>2]](e),y(e)}if(f=f-8|0,(r|0)==(f|0))break}e=i[A+20>>2]}i[A+24>>2]=r,Z(e)}return A|0}function GI(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0;var k=0,n=0;f=v-16|0,v=f,k=e,n=X2(r)&1,i[k+100>>2]=n;i:{if(l[r+20|0]==1){if(u[f+4|0]=0,u[f+15|0]=0,q(A,2,100,f+4|0),u[f+15|0]>=0)break i;Z(i[f+4>>2]);break i}if(e=i[26917],i[A>>2]=i[26916],i[A+4>>2]=e,A=A+8|0,u[107683]>=0){e=i[26919],i[A>>2]=i[26918],i[A+4>>2]=e,i[A+8>>2]=i[26920];break i}T(A,i[26918],i[26919])}v=f+16|0}function XI(A,e){A=A|0,e=e|0;var r=0,f=0,k=0;r=v-32|0,v=r,f=ir()|0;i:{if(!e){i[A+4>>2]=f,i[A>>2]=125368;break i}Qn(r+8|0,e,r+20|0);e:{if(i[r+8>>2]){e=p(12),i[e+8>>2]=i[r+16>>2],k=i[r+12>>2],i[e>>2]=i[r+8>>2],i[e+4>>2]=k,i[r+24>>2]=e,e=E1(96260,r+24|0)|0;break e}i[r+24>>2]=i[r+20>>2],e=E1(96336,r+24|0)|0}if(i[A+4>>2]=e,i[A>>2]=125368,f>>>0<9)break i;o1(f|0)}v=r+32|0}function FA(A){var e=0,r=0,f=0;r=v-16|0,v=r,M2(+A),e=t2(1)|0,t2(0)|0,e=e&2147483647;i:{if(e>>>0<=1072243195){if(e>>>0<1045430272)break i;A=_e(A,0,0);break i}if(e>>>0>=2146435072){A=A-A;break i}e=q7(A,r),A=t0[r+8>>3],f=t0[r>>3];e:switch((e&3)-1|0){default:A=_e(f,A,1);break i;case 0:A=Xe(f,A);break i;case 1:A=-_e(f,A,1);break i;case 2:break e}A=-Xe(f,A)}return v=r+16|0,A}function Uu(A,e,r){var f=0,k=0,n=0,t=0,o=0,s=0;if(u[A+44|0]=1,u[A|0]=1,Wn(A,e),(r|0)>=2){for(k=r-1|0,t=A+52|0;n=G(f,52)+t|0,o=n,s=v0(e,1),u[o|0]=s,o=n,s=v0(e,1),u[o+44|0]=s,f=f+1|0,(k|0)!=(f|0););if(r-2>>>0<7)for(f=k;E6(e,2),f=f+1|0,(f|0)!=8;);for(A=A+52|0,f=0;Wn(A+G(f,52)|0,e),f=f+1|0,(k|0)!=(f|0););}}function WI(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0;var k=0,n=0;f=v-16|0,v=f,k=e,n=o2(r),g[k+98>>1]=n;i:{if(l[r+20|0]==1){if(u[f+4|0]=0,u[f+15|0]=0,q(A,2,100,f+4|0),u[f+15|0]>=0)break i;Z(i[f+4>>2]);break i}if(e=i[26917],i[A>>2]=i[26916],i[A+4>>2]=e,A=A+8|0,u[107683]>=0){e=i[26919],i[A>>2]=i[26918],i[A+4>>2]=e,i[A+8>>2]=i[26920];break i}T(A,i[26918],i[26919])}v=f+16|0}function IA(A,e){var r=0,f=0,k=0,n=0,t=0;if(r=i[A+108>>2],f=i[A+112>>2],r>>>0<f>>>0){u[r|0]=e,i[A+108>>2]=r+1;return}if(n=i[A+104>>2],r=r-n|0,k=r+1|0,(k|0)>=0){f=f-n|0,t=f<<1,f=f>>>0>=1073741823?2147483647:k>>>0<t>>>0?t:k,f?k=p(f):k=0,t=k+r|0,u[t|0]=e,r&&x(k,n,r),i[A+112>>2]=f+k,e=t+1|0,i[A+108>>2]=e,i[A+104>>2]=k,n&&Z(n),i[A+108>>2]=e;return}G0(),H()}function Du(A,e,r){var f=0,k=0;i:{if(f=i[e+36>>2],e=i[e+40>>2],(f|0)!=(e|0))for(;;){if(k=i[f>>2],W[i[i[k>>2]+20>>2]](A,k,r),i[A>>2])break i;if(u[A+19|0]<0&&Z(i[A+8>>2]),f=f+8|0,(e|0)==(f|0))break}if(e=i[26917],i[A>>2]=i[26916],i[A+4>>2]=e,A=A+8|0,u[107683]>=0){e=i[26919],i[A>>2]=i[26918],i[A+4>>2]=e,i[A+8>>2]=i[26920];return}T(A,i[26918],i[26919])}}function QI(A,e){A=A|0,e=e|0;var r=0,f=0;i:{r=i[A>>2],f=i[r+48>>2],A=i[r+52>>2];e:{if(!A){sr(f);break e}if(i[A+4>>2]=i[A+4>>2]+1,sr(f),f=i[A+4>>2],i[A+4>>2]=f-1,f)break e;W[i[i[A>>2]+8>>2]](A),y(A)}if(A=i[r+48>>2],r=i[A+148>>2],A=i[A+152>>2],!A){i[r+120>>2]=e;break i}i[A+4>>2]=i[A+4>>2]+1,i[r+120>>2]=e,e=i[A+4>>2],i[A+4>>2]=e-1,e||(W[i[i[A>>2]+8>>2]](A),y(A))}}function gI(A){A=A|0;var e=0,r=0,f=0,k=0;i[A>>2]=98976;i:{if(l[A+48|0]!=1||(r=i[A+16>>2],r&&(i[A+20>>2]=r,Z(r)),r=i[A+4>>2],!r))break i;if(e=r,f=i[A+8>>2],(e|0)!=(f|0)){for(;;){e=i[f-4>>2];e:{if(!e||(k=i[e+4>>2],i[e+4>>2]=k-1,k))break e;W[i[i[e>>2]+8>>2]](e),y(e)}if(f=f-8|0,(r|0)==(f|0))break}e=i[A+4>>2]}i[A+8>>2]=r,Z(e)}return A|0}function VI(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0;var k=0,n=0;f=v-16|0,v=f,k=e,n=X2(r),u[k+97|0]=n;i:{if(l[r+20|0]==1){if(u[f+4|0]=0,u[f+15|0]=0,q(A,2,100,f+4|0),u[f+15|0]>=0)break i;Z(i[f+4>>2]);break i}if(e=i[26917],i[A>>2]=i[26916],i[A+4>>2]=e,A=A+8|0,u[107683]>=0){e=i[26919],i[A>>2]=i[26918],i[A+4>>2]=e,i[A+8>>2]=i[26920];break i}T(A,i[26918],i[26919])}v=f+16|0}function FI(A){A=A|0;var e=0,r=0,f=0,k=0;i[A>>2]=98656;i:{if(l[A+48|0]!=1||(r=i[A+16>>2],r&&(i[A+20>>2]=r,Z(r)),r=i[A+4>>2],!r))break i;if(e=r,f=i[A+8>>2],(e|0)!=(f|0)){for(;;){e=i[f-4>>2];e:{if(!e||(k=i[e+4>>2],i[e+4>>2]=k-1,k))break e;W[i[i[e>>2]+8>>2]](e),y(e)}if(f=f-8|0,(r|0)==(f|0))break}e=i[A+4>>2]}i[A+8>>2]=r,Z(e)}return A|0}function II(A){A=A|0;var e=0,r=0,f=0,k=0;i[A>>2]=97960;i:{if(l[A+64|0]!=1||(r=i[A+32>>2],r&&(i[A+36>>2]=r,Z(r)),r=i[A+20>>2],!r))break i;if(e=r,f=i[A+24>>2],(e|0)!=(f|0)){for(;;){e=i[f-4>>2];e:{if(!e||(k=i[e+4>>2],i[e+4>>2]=k-1,k))break e;W[i[i[e>>2]+8>>2]](e),y(e)}if(f=f-8|0,(r|0)==(f|0))break}e=i[A+20>>2]}i[A+24>>2]=r,Z(e)}Z(A)}function CI(A,e,r,f,k){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0;var n=0,t=0,o=0,s=0,w=0;return A=v-96|0,v=A,n=a2(),i[A>>2]=k,t=A- -64|0,s=h4(t,20,n,7929,A),o=t+s|0,w=z4(t,o,r),k=A+16|0,n=i[r+28>>2],i[k>>2]=n,(n|0)!=129576&&(i[n+4>>2]=i[n+4>>2]+1),n=c0(k,129760),e2(k),W[i[i[n>>2]+32>>2]](n,t,o,k)|0,n=e,e=k+s|0,e=O8(n,k,(o|0)==(w|0)?e:((w-A|0)+A|0)-48|0,e,r,f),v=A+96|0,e|0}function R6(A,e){var r=0,f=0,k=0,n=0,t=0;k=i[A+36>>2],t=i[A+40>>2];i:{if((k|0)!=(t|0))for(;;){f=i[(r<<3)+k>>2];e:{if(!f||(n=i[e>>2],!n|i[f+36>>2]!=i[f+40>>2]|i[n+36>>2]!=i[n+40>>2]))break e;if(W[i[i[f>>2]+32>>2]](f,n)|0)break i;k=i[A+36>>2],t=i[A+40>>2]}if(r=r+1|0,!(r>>>0<t-k>>3>>>0))break}r2(A+36|0,e),r=(i[A+40>>2]-i[A+36>>2]>>3)-1|0}return r}function CA(A,e){var r=0,f=0,k=0,n=0;n=v-32|0,v=n,i[A+8>>2]=0,i[A>>2]=0,i[A+4>>2]=0,k=i[e+32>>2];i:{if(e=i[e+28>>2],(k|0)!=(e|0)){if(r=k-e|0,(r|0)<0)break i;for(f=p(r),i[A+4>>2]=f,i[A>>2]=f,i[A+8>>2]=f+r;i[f>>2]=i[e>>2],r=i[e+4>>2],i[f+4>>2]=r,r&&(i[r+4>>2]=i[r+4>>2]+1),f=f+8|0,e=e+8|0,(k|0)!=(e|0););i[A+4>>2]=f}v=n+32|0;return}G0(),H()}function pI(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0;f=v-32|0,v=f,k=W[i[i[e>>2]+52>>2]](e,r,0)|0,F0(r,i[e+104>>2]),F0(r,i[e+108>>2]),F0(r,i[e+112>>2]),f1(f+12|0,e,r,k),u[f+31|0]<0&&Z(i[f+20>>2]),e=i[26917],i[A>>2]=i[26916],i[A+4>>2]=e,A=A+8|0;i:{if(u[107683]>=0){e=i[26919],i[A>>2]=i[26918],i[A+4>>2]=e,i[A+8>>2]=i[26920];break i}T(A,i[26918],i[26919])}v=f+32|0}function pA(A,e,r){var f=0,k=0,n=0,t=0,o=0;n=v-16|0,v=n,f=l[A+11|0]>>>7|0?(i[A+8>>2]&2147483647)-1|0:10,l[A+11|0]>>>7|0?k=i[A+4>>2]:k=l[A+11|0]&127;i:{if(f-k>>>0>=r>>>0){if(t=!r,t)break i;l[A+11|0]>>>7|0?f=i[A>>2]:f=A,o=f+k|0,t||x(o,e,r),e=r+k|0,z6(A,e),u[n+15|0]=0,u[e+f|0]=l[n+15|0];break i}Jr(A,f,(r-f|0)+k|0,k,k,0,r,e)}return v=n+16|0,A}function Kr(A,e,r){var f=0,k=0;for(r&2048&&(u[A|0]=43,A=A+1|0),r&1024&&(u[A|0]=35,A=A+1|0),f=r&260,(f|0)!=260&&(u[A|0]=46,u[A+1|0]=42,A=A+2|0),r=r&16384;;){if(k=l[e|0],k){u[A|0]=k,A=A+1|0,e=e+1|0;continue}break}i:{e:{if((f|0)!=256){if((f|0)!=4)break e;e=r?70:102;break i}e=r?69:101;break i}if(e=r?65:97,(f|0)==260)break i;e=r?71:103}return u[A|0]=e,(f|0)!=260}function J6(A,e){var r=0,f=0,k=0;if(r=i[A+128>>2],!r)return 0;for(f=A+128|0,A=f;k=u0[r+16>>2]<e>>>0,A=k?A:r,r=i[(k?4:0)+r>>2],!!r;);r=0;i:{if((A|0)==(f|0)|u0[A+16>>2]>e>>>0||(e=i[A+20>>2],A=i[A+24>>2],A&&(i[A+4>>2]=i[A+4>>2]+1),r=e?i[e+112>>2]:0,!A)||(e=i[A+4>>2],i[A+4>>2]=e-1,e))break i;W[i[i[A>>2]+8>>2]](A),y(A)}return r}function Mu(A){A=A|0;var e=0,r=0,f=0,k=0;i[A>>2]=98976;i:{if(l[A+48|0]!=1||(r=i[A+16>>2],r&&(i[A+20>>2]=r,Z(r)),r=i[A+4>>2],!r))break i;if(e=r,f=i[A+8>>2],(e|0)!=(f|0)){for(;;){e=i[f-4>>2];e:{if(!e||(k=i[e+4>>2],i[e+4>>2]=k-1,k))break e;W[i[i[e>>2]+8>>2]](e),y(e)}if(f=f-8|0,(r|0)==(f|0))break}e=i[A+4>>2]}i[A+8>>2]=r,Z(e)}Z(A)}function yI(A){A=A|0;var e=0,r=0,f=0,k=0;i[A>>2]=98656;i:{if(l[A+48|0]!=1||(r=i[A+16>>2],r&&(i[A+20>>2]=r,Z(r)),r=i[A+4>>2],!r))break i;if(e=r,f=i[A+8>>2],(e|0)!=(f|0)){for(;;){e=i[f-4>>2];e:{if(!e||(k=i[e+4>>2],i[e+4>>2]=k-1,k))break e;W[i[i[e>>2]+8>>2]](e),y(e)}if(f=f-8|0,(r|0)==(f|0))break}e=i[A+4>>2]}i[A+8>>2]=r,Z(e)}Z(A)}function EI(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0;f=v-32|0,v=f,k=W[i[i[e>>2]+52>>2]](e,r,0)|0,F0(r,l[e+105|0]<<30|l[e+104|0]<<31|l[e+106|0]<<26),f1(f+12|0,e,r,k),u[f+31|0]<0&&Z(i[f+20>>2]),e=i[26917],i[A>>2]=i[26916],i[A+4>>2]=e,A=A+8|0;i:{if(u[107683]>=0){e=i[26919],i[A>>2]=i[26918],i[A+4>>2]=e,i[A+8>>2]=i[26920];break i}T(A,i[26918],i[26919])}v=f+32|0}function Hu(A){var e=0;i:{e:{r:{f:{A:{if((A|0)<=1785750886){if((A|0)==1635135537)break f;if((A|0)==1752589105)break A;if((A|0)!=1781689137)break e;return 7}if((A|0)<=1970168680){if(e=3,(A|0)==1785750887)break i;if((A|0)!=1836280681)break e;return 9}if((A|0)==1970168681)break r;if((A|0)!=1987470129)break e;return 5}return 1}return 4}return 8}e=0}return e}function YI(A,e,r,f,k,n){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0;i:{if(C[f+20>>1]|!(i[r>>2]==1&(i[r+4>>2]&-2)==10)||(r=l[f+22|0],!r))break i;k=l[f+8|0],f=i[f+16>>2],e=p(28),i[e+24>>2]=11,u[e+22|0]=r,g[e+20>>1]=0,i[e+16>>2]=f,i[e+12>>2]=8,u[e+8|0]=k,i[e>>2]=0,i[e+4>>2]=3,r=e+28|0,i[A+8>>2]=r,i[A>>2]=e,i[A+4>>2]=r;return}i[A+8>>2]=0,i[A>>2]=0,i[A+4>>2]=0}function RI(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0;var k=0,n=0,t=0;n=v-16|0,v=n;i:{if((f|0)<=0&&r)break i;Rr(n+4|0,A,e),t=i[n+8>>2],e=i[n+4>>2],A=t-e>>2;e:{r:{if(!r){k=A;break r}if((e|0)==(t|0)|(f|0)<=0)break r;for(;;){if(t=k<<2,i[t+r>>2]=i[e+t>>2],k=k+1|0,(k|0)>=(f|0))break e;if(!(A>>>0>k>>>0))break}break e}if(!e)break i}Z(e)}return v=n+16|0,k|0}function JI(A,e){A=A|0,e=e|0;var r=0,f=0,k=0;A=i[A>>2],r=i[A+48>>2],A=i[A+52>>2],A&&(i[A+4>>2]=i[A+4>>2]+1),f=i[r+28>>2],r=i[r+32>>2],r&&(i[r+4>>2]=i[r+4>>2]+1);i:{if(!A||(k=i[A+4>>2],i[A+4>>2]=k-1,k))break i;W[i[i[A>>2]+8>>2]](A),y(A)}i[f+100>>2]=e,Hr(f,e);i:{if(!r||(A=i[r+4>>2],i[r+4>>2]=A-1,A))break i;W[i[i[r>>2]+8>>2]](r),y(r)}}function NI(A,e,r,f,k){if(A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,S1(A,i[e+8>>2],k)){i[e+28>>2]==1|i[e+4>>2]!=(r|0)||(i[e+28>>2]=f);return}i:{if(!S1(A,i[e>>2],k))break i;if(!(i[e+16>>2]!=(r|0)&i[e+20>>2]!=(r|0))){if((f|0)!=1)break i;i[e+32>>2]=1;return}i[e+20>>2]=r,i[e+32>>2]=f,i[e+40>>2]=i[e+40>>2]+1,i[e+36>>2]!=1|i[e+24>>2]!=2||(u[e+54|0]=1),i[e+44>>2]=4}}function UI(A,e){A=A|0,e=e|0;var r=0,f=0,k=0,n=0;f=v-16|0,v=f;i:{r=i[e+64>>2];e:{if(r){if(i[f+12>>2]=0,i[f+4>>2]=0,i[f+8>>2]=0,e=0,n=i[r+104>>2],r=i[r+100>>2],(n|0)!=(r|0)){if(e=n-r|0,(e|0)<0)break i;k=p(e),e&&x(k,r,e),e=e+k|0}u[A+20|0]=0,i[A+8>>2]=e,i[A+4>>2]=e,i[A>>2]=k;break e}i[A>>2]=0,i[A+4>>2]=0,u[A+20|0]=0,i[A+8>>2]=0}v=f+16|0;return}G0(),H()}function DI(A){A=A|0;var e=0,r=0,f=0;e=v-32|0,v=e,F6(e,i[A+100>>2],i[A+116>>2],e+20|0),r=-1;i:{if(i[e>>2]||(r4(e+24|0,i[A+100>>2],i[e+20>>2],1),A=i[e+28>>2],r=i[e+24>>2],r?r=W[i[i[r>>2]+68>>2]](r)|0:r=-1,!A)||(f=i[A+4>>2],i[A+4>>2]=f-1,f))break i;W[i[i[A>>2]+8>>2]](A),y(A)}return u[e+19|0]<0&&Z(i[e+8>>2]),v=e+32|0,r|0}function MI(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0;var k=0,n=0;k=v-32|0,v=k,z2(k+12|0,e,r),u[k+31|0]<0&&Z(i[k+20>>2]);i:{if(!l[e+97|0]){n=o2(r);break i}n=C0(r)}i:{if(!n){if(e=i[26917],i[A>>2]=i[26916],i[A+4>>2]=e,A=A+8|0,u[107683]>=0){e=i[26919],i[A>>2]=i[26918],i[A+4>>2]=e,i[A+8>>2]=i[26920];break i}T(A,i[26918],i[26919]);break i}d6(A,e,r,n,f)}v=k+32|0}function zu(A){A=A|0;var e=0,r=0,f=0;e=v-32|0,v=e,F6(e,i[A+100>>2],i[A+116>>2],e+20|0),r=-1;i:{if(i[e>>2]||(r4(e+24|0,i[A+100>>2],i[e+20>>2],1),A=i[e+28>>2],r=i[e+24>>2],r?r=W[i[i[r>>2]+64>>2]](r)|0:r=-1,!A)||(f=i[A+4>>2],i[A+4>>2]=f-1,f))break i;W[i[i[A>>2]+8>>2]](A),y(A)}return u[e+19|0]<0&&Z(i[e+8>>2]),v=e+32|0,r|0}function yA(A){var e=0,r=0,f=0;if(e=i[A+104>>2],A=i[A+108>>2],(e|0)==(A|0))return 0;i:{for(;;){e:{if(r=i[e>>2],!r||(r=W0(r,86580,86600),!r))break e;if(A=i[e+4>>2],A)break i;return i[r+104>>2]}if(e=e+8|0,(A|0)==(e|0))break}return 0}return e=i[A+4>>2],f=e+1|0,i[A+4>>2]=f,r=i[r+104>>2],i[A+4>>2]=e,f||(W[i[i[A>>2]+8>>2]](A),y(A)),r}function EA(A){var e=0,r=0,f=0;if(e=i[A+104>>2],A=i[A+108>>2],(e|0)==(A|0))return 0;i:{for(;;){e:{if(r=i[e>>2],!r||(r=W0(r,86580,86600),!r))break e;if(A=i[e+4>>2],A)break i;return i[r+108>>2]}if(e=e+8|0,(A|0)==(e|0))break}return 0}return e=i[A+4>>2],f=e+1|0,i[A+4>>2]=f,r=i[r+108>>2],i[A+4>>2]=e,f||(W[i[i[A>>2]+8>>2]](A),y(A)),r}function HI(A){return A=A|0,l[129844]?i[32460]:(l[130328]||(u[130328]=1),P2(130160,83708),P2(130172,83736),P2(130184,83764),P2(130196,83796),P2(130208,83836),P2(130220,83872),P2(130232,83900),P2(130244,83936),P2(130256,83952),P2(130268,83968),P2(130280,83984),P2(130292,84e3),P2(130304,84016),P2(130316,84032),u[129844]=1,i[32460]=130160,130160)}function zI(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,t=0;if(f=v-16|0,v=f,k=i[r>>2],k>>>0<2147483640){t=i[A>>2];i:{e:{if(k>>>0>=11){n=k|7,A=p(n+1|0),i[f+12>>2]=n-2147483647,i[f+4>>2]=A,i[f+8>>2]=k;break e}if(u[f+15|0]=k,A=f+4|0,!k)break i}if(!k)break i;x(A,r+4|0,k)}u[A+k|0]=0,W[t|0](e,f+4|0),u[f+15|0]<0&&Z(i[f+4>>2]),v=f+16|0;return}Q0(),H()}function xu(A){A=A|0;var e=0,r=0,f=0,k=0;for(i[A>>2]=77992,k=A+8|0;;){if(e=i[A+8>>2],i[A+12>>2]-e>>2>>>0>r>>>0){e=i[e+(r<<2)>>2],e&&(f=i[e+4>>2]-1|0,i[e+4>>2]=f,(f|0)==-1&&W[i[i[e>>2]+8>>2]](e)),r=r+1|0;continue}break}return s2(A+144|0),e=v-16|0,v=e,i[e+12>>2]=k,r=i[e+12>>2],i[r>>2]&&(fw(r),Sl(i[e+12>>2]+12|0,i[i[e+12>>2]>>2])),v=e+16|0,A|0}function xI(A){A=A|0;var e=0,r=0;r=A+12|0,e=i[r+8496>>2],e&&(i[r+8500>>2]=e,Z(e)),e=i[r+8484>>2],e&&(i[r+8488>>2]=e,Z(e)),e=i[r+8472>>2],e&&(i[r+8476>>2]=e,Z(e)),e=i[r+8460>>2],e&&(i[r+8464>>2]=e,Z(e)),e=i[r+8448>>2],e&&(i[r+8452>>2]=e,Z(e)),A=i[A+20>>2];i:{if(!A||(r=i[A+4>>2],i[A+4>>2]=r-1,r))break i;W[i[i[A>>2]+8>>2]](A),y(A)}}function Tu(A,e,r){var f=0,k=0,n=0;i:{e:{if(l[A+46|0]){if(k=i[A+48>>2],(k|0)>0)break e;break i}return!(e|r)}for(n=A+8360|0;;){if(i[(f<<2)+n>>2]!=(e|0)){if(f=f+1|0,(k|0)!=(f|0))continue;break i}break}if(f=0,e=i[A+52>>2],(e|0)<=0)return 0;for(A=A+8404|0;k=i[A+(f<<2)>>2]==(r|0),!k&&(f=f+1|0,(e|0)!=(f|0)););return k}return 0}function TI(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,t=0,o=0;return k=i[A+84>>2],n=i[k>>2],f=i[k+4>>2],o=i[A+28>>2],t=i[A+20>>2]-o|0,t=f>>>0<t>>>0?f:t,t&&(A8(n,o,t),n=t+i[k>>2]|0,i[k>>2]=n,f=i[k+4>>2]-t|0,i[k+4>>2]=f),f=r>>>0>f>>>0?f:r,f&&(A8(n,e,f),n=f+i[k>>2]|0,i[k>>2]=n,i[k+4>>2]=i[k+4>>2]-f),u[n|0]=0,e=i[A+44>>2],i[A+28>>2]=e,i[A+20>>2]=e,r|0}function YA(A,e,r,f){var k=0,n=0,t=0,o=0;k=v-48|0,v=k,n=i[i[A>>2]-12>>2]+A|0,t=i[n+16>>2]&-3,H1(n,t),$A(k+47|0,A),l[k+47|0]&&(n=k+24|0,o=i[(i[i[A>>2]-12>>2]+A|0)+24>>2],W[i[i[o>>2]+16>>2]](n,o,e,r,f,8),e=k+8|0,i[e+8>>2]=-1,i[e+12>>2]=-1,i[e>>2]=0,i[e+4>>2]=0,m4(i[i[A>>2]-12>>2]+A|0,i[e+8>>2]==i[n+8>>2]&i[n+12>>2]==i[e+12>>2]?t|4:t)),v=k+48|0}function SI(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0;var k=0,n=0,t=0,o=0,s=0,w=0,h=0,_=0,B=0;if((r|0)!=31)for(h=r+5|0,s=1<<r;;){for(_=A+t|0,B=(t<<1)+e|0,k=0,o=0;o=((g[(k<<r<<1)+B>>1]<<h)+2048>>12)+o|0,w=G(f,k)+_|0,n=o+l[w|0]|0,n=(n|0)>=255?255:n,u[w|0]=(n|0)>0?n:0,k=k+1|0,(s|0)!=(k|0););if(t=t+1|0,(s|0)==(t|0))break}}function jI(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0;var k=0,n=0,t=0,o=0,s=0,w=0,h=0,_=0,B=0;if((r|0)!=31)for(h=r+5|0,s=1<<r;;){for(_=G(f,t)+A|0,B=(t<<r<<1)+e|0,k=0,o=0;o=((g[(k<<1)+B>>1]<<h)+2048>>12)+o|0,w=k+_|0,n=o+l[w|0]|0,n=(n|0)>=255?255:n,u[w|0]=(n|0)>0?n:0,k=k+1|0,(s|0)!=(k|0););if(t=t+1|0,(s|0)==(t|0))break}}function OI(A){return A=A|0,l[129836]?i[32458]:(l[130152]||(u[130152]=1),R2(129984,1732),R2(129996,1739),R2(130008,1705),R2(130020,1713),R2(130032,1696),R2(130044,1746),R2(130056,1723),R2(130068,7994),R2(130080,9212),R2(130092,12072),R2(130104,17821),R2(130116,3098),R2(130128,10553),R2(130140,4378),u[129836]=1,i[32458]=129984,129984)}function PI(A,e){A=A|0,e=e|0;var r=0,f=0,k=0;if(f=v-128|0,v=f,r=i[e+16>>2],i[f>>2]=i[e+12>>2],i[f+4>>2]=r,e=f+16|0,qr(e,17853,f),r=h2(e),r>>>0<2147483640){i:{e:{if(r>>>0>=11){k=r|7,e=p(k+1|0),i[A+8>>2]=k-2147483647,i[A>>2]=e,i[A+4>>2]=r,A=e;break e}if(u[A+11|0]=r,!r)break i}if(!r)break i;x(A,f+16|0,r)}u[A+r|0]=0,v=f+128|0;return}Q0(),H()}function RA(A){var e=0,r=0;if(e=v-16|0,v=e,i[(i[i[A>>2]-12>>2]+A|0)+24>>2]){i[e+12>>2]=A,u[e+8|0]=0,i[(i[i[A>>2]-12>>2]+A|0)+16>>2]||(r=i[(i[i[A>>2]-12>>2]+A|0)+72>>2],r&&RA(r),u[e+8|0]=1);i:{if(!l[e+8|0]||(r=i[(i[i[A>>2]-12>>2]+A|0)+24>>2],(W[i[i[r>>2]+24>>2]](r)|0)!=-1))break i;m4(i[i[A>>2]-12>>2]+A|0,1)}_1(e+8|0)}v=e+16|0}function LI(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,t=0,o=0,s=0;if(s=i[e+12>>2],i[e+12>>2]=i[A+120>>2],f=i[A+128>>2],n=i[A+132>>2],(f|0)!=(n|0))for(;;){k=i[f+4>>2],t=i[f>>2],o=r+t|0,k=r>>>0>o>>>0?k+1|0:k;i:{if(!l[A+97|0]){if((k|0)==1|k>>>0>1){F0(e,0);break i}F0(e,r+t|0);break i}e4(e,o,k)}if(f=f+8|0,(n|0)==(f|0))break}i[e+12>>2]=s}function JA(A,e,r,f){u[A+53|0]=1;i:{if(i[A+4>>2]!=(r|0))break i;u[A+52|0]=1,r=i[A+16>>2];e:{if(!r){if(i[A+36>>2]=1,i[A+24>>2]=f,i[A+16>>2]=e,(f|0)!=1)break i;if(i[A+48>>2]==1)break e;break i}if((e|0)==(r|0)){if(r=i[A+24>>2],(r|0)==2&&(i[A+24>>2]=f,r=f),i[A+48>>2]!=1)break i;if((r|0)==1)break e;break i}i[A+36>>2]=i[A+36>>2]+1}u[A+54|0]=1}}function KI(A){A=A|0;var e=0,r=0;if(A){e=i[A+20>>2];i:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break i;W[i[i[e>>2]+8>>2]](e),y(e)}e=i[A+12>>2];i:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break i;W[i[i[e>>2]+8>>2]](e),y(e)}e=i[A+4>>2];i:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break i;W[i[i[e>>2]+8>>2]](e),y(e)}Z(A)}}function A4(A,e){i:{if((e|0)>=1024){if(A=A*898846567431158e293,e>>>0<2047){e=e-1023|0;break i}A=A*898846567431158e293,e=(e>>>0>=3069?3069:e)-2046|0;break i}if((e|0)>-1023)break i;if(A=A*2004168360008973e-307,e>>>0>4294965304){e=e+969|0;break i}A=A*2004168360008973e-307,e=(e>>>0<=4294964336?-2960:e)+1938|0}return D2(0,0),D2(1,e+1023<<20),A*+r1()}function qI(A,e){A=A|0,e=e|0;var r=0,f=0;A=i[A>>2],r=i[A+48>>2],A=i[A+52>>2],A&&(i[A+4>>2]=i[A+4>>2]+1),f=i[r+28>>2],r=i[r+32>>2];i:{if(!r){Hr(f,e);break i}if(i[r+4>>2]=i[r+4>>2]+1,Hr(f,e),e=i[r+4>>2],i[r+4>>2]=e-1,e)break i;W[i[i[r>>2]+8>>2]](r),y(r)}i:{if(!A||(e=i[A+4>>2],i[A+4>>2]=e-1,e))break i;W[i[i[A>>2]+8>>2]](A),y(A)}}function aI(A,e){A=A|0,e=e|0;var r=0,f=0,k=0,n=0;if(r=v-16|0,v=r,f=i[e>>2],f>>>0<2147483640){i:{e:{if(f>>>0>=11){n=f|7,k=p(n+1|0),i[r+12>>2]=n-2147483647,i[r+4>>2]=k,i[r+8>>2]=f;break e}if(u[r+15|0]=f,k=r+4|0,!f)break i}if(!f)break i;x(k,e+4|0,f)}return u[f+k|0]=0,A=W[A|0](r+4|0)|0,u[r+15|0]<0&&Z(i[r+4>>2]),v=r+16|0,A|0}Q0(),H()}function Su(A,e){var r=0,f=0,k=0,n=0,t=0,o=0;f=A+18548|0,r=v2(f,i[A+18572>>2]+150|0),k=1,n=v2(f,i[A+18572>>2]+150|0),t=1,r&&(t=!v2(f,i[A+18572>>2]+151|0)),n&&(k=!v2(f,i[A+18572>>2]+151|0)),r&&(r=-1,t||(r=eA(f,1)),o=k4(f)?65534-r|0:r+2|0),e=(e<<2)+A|0,n?(r=-1,k||(r=eA(f,1)),A=k4(f)?65534-r|0:r+2|0):A=0,g[e+20>>1]=A,g[e+18>>1]=o}function $I(A,e,r,f,k,n){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0;i:{if(!(i[r>>2]!=1|(i[r+4>>2]&-2)!=12)&&(r=i[r+12>>2],(r|0)>8))break i;i[A+8>>2]=0,i[A>>2]=0,i[A+4>>2]=0;return}f=l[f+8|0],e=p(28),i[e+24>>2]=11,u[e+22|0]=1,g[e+20>>1]=2,i[e+16>>2]=131074,i[e+12>>2]=r,u[e+8|0]=f,i[e>>2]=1,i[e+4>>2]=3,r=e+28|0,i[A+8>>2]=r,i[A>>2]=e,i[A+4>>2]=r}function ju(A){A=A|0;var e=0,r=0,f=0;e=v-32|0,v=e,F6(e,i[A+100>>2],i[A+116>>2],e+20|0),r=-1;i:{if(i[e>>2]||(r4(e+24|0,i[A+100>>2],i[e+20>>2],1),A=i[e+28>>2],r=i[e+24>>2],r=W[i[i[r>>2]+68>>2]](r)|0,!A)||(f=i[A+4>>2],i[A+4>>2]=f-1,f))break i;W[i[i[A>>2]+8>>2]](A),y(A)}return u[e+19|0]<0&&Z(i[e+8>>2]),v=e+32|0,r|0}function dI(A){A=A|0;var e=0,r=0,f=0;e=v-32|0,v=e,F6(e,i[A+100>>2],i[A+116>>2],e+20|0),r=-1;i:{if(i[e>>2]||(r4(e+24|0,i[A+100>>2],i[e+20>>2],1),A=i[e+28>>2],r=i[e+24>>2],r=W[i[i[r>>2]+64>>2]](r)|0,!A)||(f=i[A+4>>2],i[A+4>>2]=f-1,f))break i;W[i[i[A>>2]+8>>2]](A),y(A)}return u[e+19|0]<0&&Z(i[e+8>>2]),v=e+32|0,r|0}function cI(A,e){A=A|0,e=e|0;var r=0,f=0,k=0,n=0;if(r=v-16|0,v=r,jn(r+4|0,i[A>>2],e),k=i[r+8>>2],e=i[r+4>>2],e){if(A=e,(e|0)!=(k|0)){for(A=k;;){f=i[A-4>>2];i:{if(!f||(n=i[f+4>>2],i[f+4>>2]=n-1,n))break i;W[i[i[f>>2]+8>>2]](f),y(f)}if(A=A-8|0,(e|0)==(A|0))break}A=i[r+4>>2]}i[r+8>>2]=e,Z(A)}return v=r+16|0,k-e>>3}function t6(A){var e=0,r=0,f=0;return l[A+80|0]||(r=v-16|0,v=r,f=r+12|0,e=i[A+28>>2],i[f>>2]=e,(e|0)!=129576&&(i[e+4>>2]=i[e+4>>2]+1),e=c0(f,129760),e=W[i[i[e>>2]+28>>2]](e,32)|0,e2(f),v=r+16|0,u[A+76|0]=e,u[A+77|0]=e>>>8,u[A+78|0]=e>>>16,u[A+79|0]=e>>>24,u[A+80|0]=1),(l[A+76|0]|l[A+77|0]<<8|(l[A+78|0]<<16|l[A+79|0]<<24))<<24>>24}function Ou(A){A=A|0;var e=0,r=0,f=0,k=0,n=0,t=0;e=v-16|0,v=e,k=e+16|0;i:{for(;;){if(f=i[A+36>>2],r=e+8|0,n=W[i[i[f>>2]+20>>2]](f,i[A+40>>2],r,k,e+4|0)|0,f=-1,t=r,r=i[e+4>>2]-r|0,(P1(t,1,r,i[A+32>>2])|0)!=(r|0))break i;e:switch(n-1|0){case 1:break i;case 0:continue;default:break e}break}f=n6(i[A+32>>2])?-1:0}return v=e+16|0,f|0}function NA(A){var e=0,r=0,f=0;e=i[A+12>>2]-2|0,i[A+12>>2]=e,f=1,r=i[A+16>>2],e=e<<7;i:{if(r>>>0>=e>>>0||(f=0,e>>>0>32767)||(r=r<<1,i[A+16>>2]=r,i[A+12>>2]=e>>>6,e=C[A+20>>1]+1|0,g[A+20>>1]=e,(e|0)==(e&65535))||(g[A+20>>1]=65528,e=i[A+4>>2],e>>>0>=u0[A+8>>2]))break i;i[A+4>>2]=e+1,i[A+16>>2]=r+l[e|0]}return f}function bI(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,t=0,o=0;return f=i[A+44>>2],k=i[A+40>>2],t=r+k|0,f=t>>>0<r>>>0?f+1|0:f,n=i[A+36>>2],o=i[A+32>>2],(f|0)==(n|0)&o>>>0>=t>>>0|f>>>0<n>>>0&&(r&&x(e,i[A+24>>2]+k|0,r),k=i[A+44>>2],e=r+i[A+40>>2]|0,k=e>>>0<r>>>0?k+1|0:k,i[A+40>>2]=e,i[A+44>>2]=k),(f|0)==(n|0)&t>>>0<=o>>>0|f>>>0<n>>>0}function I8(A,e,r,f){var k=0,n=0,t=0,o=0;k=v-16|0,v=k,i[k+12>>2]=e,i[k+8>>2]=f,t=s8(k+4|0,k+12|0),e=v-16|0,v=e,f=i[k+8>>2],i[e+12>>2]=f,i[e+8>>2]=f,n=-1,f=br(0,0,r,f);i:{if((f|0)<0||(o=A,f=f+1|0,A=y2(f),i[o>>2]=A,!A))break i;n=br(A,f,r,i[e+12>>2])}return v=e+16|0,A=i[t>>2],A&&(i[31366]=(A|0)==-1?125344:A),v=k+16|0,n}function Pu(A){A=A|0;var e=0,r=0,f=0,k=0;e=v-16|0,v=e,A=i[A>>2];i:{if(l[A+80|0]!=1)break i;e:{if(u[A+79|0]>=0){i[e+8>>2]=i[A+76>>2],r=i[A+72>>2],i[e>>2]=i[A+68>>2],i[e+4>>2]=r;break e}T(e,i[A+68>>2],i[A+72>>2])}if(A=u[e+11|0],r=(A|0)<0,k=p((r?i[e+4>>2]:A)+1|0),f=i[e>>2],r=c4(k,r?f:e),(A|0)>=0)break i;Z(f)}return v=e+16|0,r|0}function UA(A){A=A|0;var e=0,r=0,f=0,k=0,n=0;if(e=v-16|0,v=e,CA(e+4|0,i[A>>2]),k=i[e+8>>2],f=i[e+4>>2],f){if(A=f,(k|0)!=(A|0)){for(A=k;;){r=i[A-4>>2];i:{if(!r||(n=i[r+4>>2],i[r+4>>2]=n-1,n))break i;W[i[i[r>>2]+8>>2]](r),y(r)}if(A=A-8|0,(f|0)==(A|0))break}A=i[e+4>>2]}i[e+8>>2]=f,Z(A)}return v=e+16|0,k-f>>3}function iC(A,e){A=A|0,e=e|0;var r=0,f=0,k=0,n=0;o0(A,0,72),f=i[e+460>>2],k=i[e+452>>2],i[A+4>>2]=((f+k|0)-1>>>0)/(f>>>0),r=i[e+464>>2],n=i[e+456>>2],i[A+24>>2]=n,i[A+20>>2]=k,i[A+16>>2]=r,i[A+12>>2]=f,i[A+8>>2]=((r+n|0)-1>>>0)/(r>>>0),r=l[e+474|0],u[A+36|0]=r;i:{if(!r||(r=(r>>>0>=8?8:r)<<2,!r))break i;x(A+40|0,e+476|0,r)}}function wi(A){var e=0,r=0,f=0;r=v-16|0,v=r;i:{if(!f4(A,2))break i;f=i[A>>2],e=i[A+4>>2],e&&(i[e+4>>2]=i[e+4>>2]+1);e:{if(!(W[i[i[f>>2]+16>>2]](f,r+14|0,2)|0)){i8(A),f=0;break e}A=l[r+14|0]|l[r+15|0]<<8,f=A<<8|A>>>8}if(!e||(A=i[e+4>>2],i[e+4>>2]=A-1,A))break i;W[i[i[e>>2]+8>>2]](e),y(e)}return v=r+16|0,f<<16>>16}function eC(A,e){A=A|0,e=e|0;var r=0,f=0,k=0,n=0,t=0,o=0;if(r=i[A>>2],A=i[r+260>>2],k=i[r+264>>2],(A|0)==(k|0))return 0;i:{if(!e){r=((k-A|0)-8>>>3|0)+1|0;break i}for(n=h2(e),r=0;f=i[A>>2],t=u[f+15|0],o=(t|0)<0,((o?i[f+8>>2]:t)|0)==(n|0)&&(r=!N2(o?i[f+4>>2]:f+4|0,e,n)+r|0),A=A+8|0,(k|0)!=(A|0););}return r|0}function rC(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0;f=v-32|0,v=f,k=W[i[i[e>>2]+52>>2]](e,r,0)|0,l2(r,l[e+104|0]),f1(f+12|0,e,r,k),u[f+31|0]<0&&Z(i[f+20>>2]),e=i[26917],i[A>>2]=i[26916],i[A+4>>2]=e,A=A+8|0;i:{if(u[107683]>=0){e=i[26919],i[A>>2]=i[26918],i[A+4>>2]=e,i[A+8>>2]=i[26920];break i}T(A,i[26918],i[26919])}v=f+32|0}function o2(A){var e=0,r=0,f=0;r=v-16|0,v=r;i:{if(!f4(A,2))break i;f=i[A>>2],e=i[A+4>>2],e&&(i[e+4>>2]=i[e+4>>2]+1);e:{if(!(W[i[i[f>>2]+16>>2]](f,r+14|0,2)|0)){i8(A),f=0;break e}A=l[r+14|0]|l[r+15|0]<<8,f=A<<8|A>>>8}if(!e||(A=i[e+4>>2],i[e+4>>2]=A-1,A))break i;W[i[i[e>>2]+8>>2]](e),y(e)}return v=r+16|0,f&65535}function fC(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,t=0;f=v-32|0,v=f,u[f+12|0]=0,u[f+23|0]=0,e=su(e,r),e&&R2(f+12|0,e),e=u[f+23|0],r=(e|0)<0,e=r?i[f+16>>2]:e,k=y2(e+4|0),i[k>>2]=e,e&&x(k+4|0,r?i[f+12>>2]:f+12|0,e),i[f+24>>2]=k,n=A,t=E1(96240,f+24|0)|0,i[n+4>>2]=t,i[A>>2]=125368,u[f+23|0]<0&&Z(i[f+12>>2]),v=f+32|0}function AC(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,t=0;f=v-32|0,v=f,u[f+12|0]=0,u[f+23|0]=0,e=wu(e,r),e&&R2(f+12|0,e),e=u[f+23|0],r=(e|0)<0,e=r?i[f+16>>2]:e,k=y2(e+4|0),i[k>>2]=e,e&&x(k+4|0,r?i[f+12>>2]:f+12|0,e),i[f+24>>2]=k,n=A,t=E1(96240,f+24|0)|0,i[n+4>>2]=t,i[A>>2]=125368,u[f+23|0]<0&&Z(i[f+12>>2]),v=f+32|0}function kC(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,t=0;f=v-32|0,v=f,u[f+12|0]=0,u[f+23|0]=0,e=hu(e,r),e&&R2(f+12|0,e),e=u[f+23|0],r=(e|0)<0,e=r?i[f+16>>2]:e,k=y2(e+4|0),i[k>>2]=e,e&&x(k+4|0,r?i[f+12>>2]:f+12|0,e),i[f+24>>2]=k,n=A,t=E1(96240,f+24|0)|0,i[n+4>>2]=t,i[A>>2]=125368,u[f+23|0]<0&&Z(i[f+12>>2]),v=f+32|0}function nC(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,t=0;f=v-32|0,v=f,u[f+12|0]=0,u[f+23|0]=0,e=Qu(e,r),e&&R2(f+12|0,e),e=u[f+23|0],r=(e|0)<0,e=r?i[f+16>>2]:e,k=y2(e+4|0),i[k>>2]=e,e&&x(k+4|0,r?i[f+12>>2]:f+12|0,e),i[f+24>>2]=k,n=A,t=E1(96240,f+24|0)|0,i[n+4>>2]=t,i[A>>2]=125368,u[f+23|0]<0&&Z(i[f+12>>2]),v=f+32|0}function tC(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0;f=v-32|0,v=f,k=W[i[i[e>>2]+52>>2]](e,r,0)|0,l2(r,l[e+97|0]),f1(f+12|0,e,r,k),u[f+31|0]<0&&Z(i[f+20>>2]),e=i[26917],i[A>>2]=i[26916],i[A+4>>2]=e,A=A+8|0;i:{if(u[107683]>=0){e=i[26919],i[A>>2]=i[26918],i[A+4>>2]=e,i[A+8>>2]=i[26920];break i}T(A,i[26918],i[26919])}v=f+32|0}function Lu(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0;f=v-32|0,v=f,k=W[i[i[e>>2]+52>>2]](e,r,0)|0,F4(r,e+104|0,1),f1(f+12|0,e,r,k),u[f+31|0]<0&&Z(i[f+20>>2]),e=i[26917],i[A>>2]=i[26916],i[A+4>>2]=e,A=A+8|0;i:{if(u[107683]>=0){e=i[26919],i[A>>2]=i[26918],i[A+4>>2]=e,i[A+8>>2]=i[26920];break i}T(A,i[26918],i[26919])}v=f+32|0}function hi(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0;if(!r)return 0;i:{if(!A||(f=i[A>>2],!f)||(A=i[f+128>>2],!A))break i;for(k=f+128|0,f=k;n=i[A+16>>2]<(e|0),f=n?f:A,A=i[(n?4:0)+A>>2],!!A;);if((f|0)==(k|0)|i[f+16>>2]>(e|0))break i;return i[r>>2]=i[f+56>>2],i[f+44>>2]}return i[r>>2]=0,0}function uC(A){A=A|0;var e=0,r=0,f=0,k=0,n=0;if(n=v-16|0,v=n,e=i[A+652>>2],e&&(i[A+656>>2]=e,Z(e)),e=i[A+640>>2],e&&(i[A+644>>2]=e,Z(e)),e=i[A+604>>2],e){if(r=e,f=i[A+608>>2],(e|0)!=(f|0)){for(;r=f-12|0,k=i[r>>2],k&&(i[f-8>>2]=k,Z(k)),f=r,(e|0)!=(f|0););r=i[A+604>>2]}i[A+608>>2]=e,Z(r)}v=n+16|0}function oC(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0;f=v-32|0,v=f,k=W[i[i[e>>2]+52>>2]](e,r,0)|0,I4(r,e+100|0),f1(f+12|0,e,r,k),u[f+31|0]<0&&Z(i[f+20>>2]),e=i[26917],i[A>>2]=i[26916],i[A+4>>2]=e,A=A+8|0;i:{if(u[107683]>=0){e=i[26919],i[A>>2]=i[26918],i[A+4>>2]=e,i[A+8>>2]=i[26920];break i}T(A,i[26918],i[26919])}v=f+32|0}function lC(A){A=A|0;var e=0,r=0,f=0,k=0;e=v-16|0,v=e;i:{if(!A){A=0;break i}A=i[A+8>>2];e:{if(u[A+15|0]>=0){i[e+8>>2]=i[A+12>>2],r=i[A+8>>2],i[e>>2]=i[A+4>>2],i[e+4>>2]=r;break e}T(e,i[A+4>>2],i[A+8>>2])}if(r=u[e+11|0],A=(r|0)<0,k=p((A?i[e+4>>2]:r)+1|0),f=i[e>>2],A=c4(k,A?f:e),(r|0)>=0)break i;Z(f)}return v=e+16|0,A|0}function sC(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0;n=v-16|0,v=n,k=i[A>>2],A=0,i[n+12>>2]=0,i[n+4>>2]=0,i[n+8>>2]=0;i:{if(f=i[k+280>>2],k=i[k+276>>2],(f|0)==(k|0))f=0;else{if(f=f-k|0,(f|0)<0)break i;A=p(f),f&&x(A,k,f),f=A+f|0}return f=f-A>>2,f=(r|0)<(f|0)?r:f,r=f<<2,r&&x(e,A,r),A&&Z(A),v=n+16|0,f|0}G0(),H()}function DA(A,e,r,f,k){var n=0,t=0,o=0,s=0;t=v-16|0,v=t,n=t+12|0,e=i[e+28>>2],i[n>>2]=e,(e|0)!=129576&&(i[e+4>>2]=i[e+4>>2]+1),e=c0(n,129752),W[i[i[e>>2]+48>>2]](e,77744,77772,r)|0,e=c0(n,129824),o=f,s=W[i[i[e>>2]+12>>2]](e)|0,i[o>>2]=s,o=k,s=W[i[i[e>>2]+16>>2]](e)|0,i[o>>2]=s,W[i[i[e>>2]+20>>2]](A,e),e2(n),v=t+16|0}function wC(A){A=A|0;var e=0,r=0,f=0,k=0,n=0;if(e=i[A+104>>2],f=i[A+108>>2],(e|0)!=(f|0))for(;;){if(u0[e+40>>2]>65535){u[A+97|0]=1;return}r=i[e+44>>2],k=i[e+48>>2];i:{if((r|0)==(k|0))break i;for(;;){if(u0[r>>2]<65536){if(r=r+4|0,(k|0)!=(r|0))continue;break i}break}n=1}if(e=e+56|0,(f|0)==(e|0))break}u[A+97|0]=n}function hC(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0;n=v-16|0,v=n,k=i[A>>2],A=0,i[n+12>>2]=0,i[n+4>>2]=0,i[n+8>>2]=0;i:{if(f=i[k+440>>2],k=i[k+436>>2],(f|0)==(k|0))f=0;else{if(f=f-k|0,(f|0)<0)break i;A=p(f),f&&x(A,k,f),f=A+f|0}return f=f-A>>2,f=(r|0)<(f|0)?r:f,r=f<<2,r&&x(e,A,r),A&&Z(A),v=n+16|0,f|0}G0(),H()}function MA(A,e,r,f,k){var n=0,t=0,o=0,s=0;t=v-16|0,v=t,n=t+12|0,e=i[e+28>>2],i[n>>2]=e,(e|0)!=129576&&(i[e+4>>2]=i[e+4>>2]+1),e=c0(n,129760),W[i[i[e>>2]+32>>2]](e,77744,77772,r)|0,e=c0(n,129816),o=f,s=W[i[i[e>>2]+12>>2]](e)|0,u[o|0]=s,o=k,s=W[i[i[e>>2]+16>>2]](e)|0,u[o|0]=s,W[i[i[e>>2]+20>>2]](A,e),e2(n),v=t+16|0}function Ku(A,e,r){var f=0,k=0,n=0;k=i[e>>2],n=i[e+4>>2],i[e>>2]=0,i[e+4>>2]=0,f=i[A+4>>2],i[A>>2]=k,i[A+4>>2]=n;i:{if(!f||(k=i[f+4>>2],i[f+4>>2]=k-1,k))break i;W[i[i[f>>2]+8>>2]](f),y(f)}u[A+8|0]=1,i[A+24>>2]=r,A=i[e+4>>2];i:{if(!A||(e=i[A+4>>2],i[A+4>>2]=e-1,e))break i;W[i[i[A>>2]+8>>2]](A),y(A)}}function qu(A,e,r){var f=0,k=0,n=0;if(f=i[r+72>>2],i[r+72>>2]=f-1|f,f=i[r+4>>2],k=i[r+8>>2],(f|0)==(k|0)?f=e:(n=f,f=k-f|0,f=e>>>0>f>>>0?f:e,A8(A,n,f),i[r+4>>2]=f+i[r+4>>2],A=A+f|0,f=e-f|0),f)for(;;){i:{if(!Ge(r)&&(k=W[i[r+32>>2]](r,A,f)|0,k))break i;return e-f|0}if(A=A+k|0,f=f-k|0,!f)break}return e}function _C(A,e,r,f,k,n){if(A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,!(!(i[r>>2]!=1|(i[r+4>>2]&-2)!=10)&i[r+12>>2]==8)){i[A+8>>2]=0,i[A>>2]=0,i[A+4>>2]=0;return}r=l[f+8|0],e=p(28),i[e+24>>2]=11,u[e+22|0]=1,g[e+20>>1]=2,i[e+12>>2]=8,i[e+16>>2]=131074,u[e+8|0]=r,i[e>>2]=1,i[e+4>>2]=3,r=e+28|0,i[A+8>>2]=r,i[A>>2]=e,i[A+4>>2]=r}function BC(A,e){A=A|0,e=e|0;var r=0,f=0,k=0;if(f=v-128|0,v=f,i[f>>2]=i[e+12>>2],e=f+16|0,qr(e,17873,f),r=h2(e),r>>>0<2147483640){i:{e:{if(r>>>0>=11){k=r|7,e=p(k+1|0),i[A+8>>2]=k-2147483647,i[A>>2]=e,i[A+4>>2]=r,A=e;break e}if(u[A+11|0]=r,!r)break i}if(!r)break i;x(A,f+16|0,r)}u[A+r|0]=0,v=f+128|0;return}Q0(),H()}function vC(A,e){A=A|0,e=e|0;var r=0,f=0,k=0;if(f=v-128|0,v=f,i[f>>2]=i[e+12>>2],e=f+16|0,qr(e,17900,f),r=h2(e),r>>>0<2147483640){i:{e:{if(r>>>0>=11){k=r|7,e=p(k+1|0),i[A+8>>2]=k-2147483647,i[A>>2]=e,i[A+4>>2]=r,A=e;break e}if(u[A+11|0]=r,!r)break i}if(!r)break i;x(A,f+16|0,r)}u[A+r|0]=0,v=f+128|0;return}Q0(),H()}function s4(A,e,r){var f=0,k=0,n=0;i:{f=i[e+128>>2];e:{if(!f)break e;for(k=e+128|0,e=k;n=u0[f+16>>2]<r>>>0,e=n?e:f,f=i[(n?4:0)+f>>2],!!f;);if((e|0)==(k|0))break e;if(u0[e+16>>2]<=r>>>0)break i}i[A>>2]=0,i[A+4>>2]=0;return}i[A>>2]=i[e+20>>2],r=A,A=i[e+24>>2],i[r+4>>2]=A,A&&(i[A+4>>2]=i[A+4>>2]+1)}function mC(A,e){A=A|0,e=e|0;var r=0,f=0,k=0;if(f=v-128|0,v=f,i[f>>2]=i[e+8>>2],e=f+16|0,qr(e,17884,f),r=h2(e),r>>>0<2147483640){i:{e:{if(r>>>0>=11){k=r|7,e=p(k+1|0),i[A+8>>2]=k-2147483647,i[A>>2]=e,i[A+4>>2]=r,A=e;break e}if(u[A+11|0]=r,!r)break i}if(!r)break i;x(A,f+16|0,r)}u[A+r|0]=0,v=f+128|0;return}Q0(),H()}function ZC(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0;i:{e:{if(A=i[A+4>>2],f=i[A+168>>2],e=e>>f,(e|0)<0||(k=i[A+172>>2],(e|0)>=(k|0)))break e;if(r=r>>f,(r|0)<0|(r|0)>=i[A+176>>2])break i;return A=(i[A+160>>2]+G(e,3)|0)+G(G(r,k),3)|0,(l[A|0]|l[A+1|0]<<8)>>>3&7}D0(4656,10893,118,4231),H()}D0(4618,10893,119,4231),H()}function F2(A,e,r){var f=0,k=0;i:{e:{if(!r)break e;if(f=i[A+164>>2],(f|0)>0){for(k=A+84|0,r=0;;){if(i[(r<<2)+k>>2]==(e|0))break i;if(r=r+1|0,(f|0)==(r|0))break}if((f|0)>19)break e}i[A+164>>2]=f+1,i[((f<<2)+A|0)+84>>2]=e}if(r=i[A+80>>2],(r|0)==20){i[A+76>>2]=1001;return}i[A+80>>2]=r+1,i[(r<<2)+A>>2]=e}}function au(A,e){var r=0,f=0;r=v-32|0,v=r,i[A+8>>2]=-1,i[A+12>>2]=-1,i[A>>2]=0,i[A+4>>2]=0,$A(r+31|0,e),l[r+31|0]&&(f=i[(i[i[e>>2]-12>>2]+e|0)+24>>2],W[i[i[f>>2]+16>>2]](r+8|0,f,0,0,1,8),f=i[r+20>>2],i[A+8>>2]=i[r+16>>2],i[A+12>>2]=f,f=i[r+12>>2],i[A>>2]=i[r+8>>2],i[A+4>>2]=f,m4(i[i[e>>2]-12>>2]+e|0,0)),v=r+32|0}function GC(A){A=A|0;var e=0,r=0,f=0,k=0,n=0,t=0,o=0;if(e=i[A+104>>2],k=i[A+108>>2],(e|0)!=(k|0)){for(;;){if(o=u0[e>>2]>65535,r=i[e+4>>2],n=i[e+8>>2],(r|0)!=(n|0))for(;t=C[r+2>>1]>127|t,r=r+4|0,(n|0)!=(r|0););if(f=o?1:f,e=e+16|0,(k|0)==(e|0))break}r=f,f=t&1}i[A+100>>2]=f,u[A+97|0]=r}function $u(A,e){var r=0,f=0,k=0,n=0;k=v-16|0,v=k,e&&(r=l[A+11|0]>>>7|0?(i[A+8>>2]&2147483647)-1|0:10,l[A+11|0]>>>7|0?f=i[A+4>>2]:f=l[A+11|0]&127,r-f>>>0<e>>>0&&tA(A,r,(e-r|0)+f|0,f,f),l[A+11|0]>>>7|0?r=i[A>>2]:r=A,Bl(r+f|0,e,0),n=A,A=e+f|0,z6(n,A),u[k+15|0]=0,u[A+r|0]=l[k+15|0]),v=k+16|0}function H4(A,e){var r=0,f=0,k=0,n=0;f=v-16|0,v=f;i:{if(!e){e=0;break i}r=e>>31,k=(r^e)-r|0,r=k1(k),o4(f,k,0,0,0,r+81|0),k=0+i[f+8>>2]|0,r=(i[f+12>>2]^65536)+(16414-r<<16)|0,r=k>>>0<n>>>0?r+1|0:r,e=(e|0)<0,k=0|k,n=(e?-2147483648:0)|r,r=i[f+4>>2],e=i[f>>2]}i[A>>2]=e,i[A+4>>2]=r,i[A+8>>2]=k,i[A+12>>2]=n,v=f+16|0}function du(A,e){var r=0;r=v-16|0,v=r;i:{if(l[e+20|0]==1){if(u[r+4|0]=0,u[r+15|0]=0,q(A,2,100,r+4|0),u[r+15|0]>=0)break i;Z(i[r+4>>2]);break i}if(e=i[26917],i[A>>2]=i[26916],i[A+4>>2]=e,A=A+8|0,u[107683]>=0){e=i[26919],i[A>>2]=i[26918],i[A+4>>2]=e,i[A+8>>2]=i[26920];break i}T(A,i[26918],i[26919])}v=r+16|0}function XC(A,e){A=A|0,e=e|0;var r=0;i[A+8>>2]=1,i[A>>2]=1,i[A+4>>2]=1,i[A+36>>2]=0,r=i[e+120>>2],i[A+12>>2]=r,e=i[e+124>>2],i[A+40>>2]=0,i[A+44>>2]=0,i[A+24>>2]=e,i[A+20>>2]=r,i[A+16>>2]=e,i[A+48>>2]=0,i[A+52>>2]=0,i[A+56>>2]=0,i[A+60>>2]=0,e=A- -64|0,i[e>>2]=0,i[e+4>>2]=0,i[A+28>>2]=0,i[A+32>>2]=0,u[A+36|0]=0}function HA(A,e,r){var f=0,k=0,n=0;f=i[A>>2],k=f+r&536870911,i[A>>2]=k,i[A+4>>2]=i[A+4>>2]+(f>>>0>k>>>0)+(r>>>29),f=f&63;i:{if(f){if(n=A+24|0,k=f+n|0,f=64-f|0,f>>>0>r>>>0){if(!r)break i;x(k,e,r);return}f&&x(k,e,f),Ar(A,n,64),r=r-f|0,e=e+f|0}if(r>>>0>=64&&(e=Ar(A,e,r&-64),r=r&63),!r)break i;x(A+24|0,e,r)}}function WC(A){A=A|0;var e=0,r=0,f=0,k=0;e=v-16|0,v=e,A=i[A>>2];i:{if(u[A+263|0]>=0){i[e+8>>2]=i[A+260>>2],r=i[A+256>>2],i[e>>2]=i[A+252>>2],i[e+4>>2]=r;break i}T(e,i[A+252>>2],i[A+256>>2])}return A=u[e+11|0],r=(A|0)<0,f=r?i[e+4>>2]:A,f&&(k=c4(p(f+1|0),r?i[e>>2]:e)),(A|0)<0&&Z(i[e>>2]),v=e+16|0,k|0}function QC(A,e,r,f,k,n){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0;var t=0,o=0;return t=v-32|0,v=t,o=i[19495],i[t+24>>2]=i[19494],i[t+28>>2]=o,o=i[19493],i[t+16>>2]=i[19492],i[t+20>>2]=o,o=i[19491],i[t+8>>2]=i[19490],i[t+12>>2]=o,o=i[19489],i[t>>2]=i[19488],i[t+4>>2]=o,o=A,A=t+32|0,e=T8(o,e,r,f,k,n,t,A),v=A,e|0}function cu(A,e){var r=0,f=0,k=0;if(e>>>0>8){for(e=e>>>0<=4?4:e,f=A>>>0<=1?1:A;;){i:{if(A=0,r=(e+f|0)-1&0-e,k=r>>>0<f>>>0?f:r,r=v-16|0,v=r,(k>>>0)%(e>>>0)|e&3||(A=Er(r+12|0,e,k),A=A?0:i[r+12>>2]),v=r+16|0,A||(r=i[32827],!r))break i;W[r|0]();continue}break}return A||Z4(),A}return p(A)}function gC(A){A=A|0;var e=0,r=0,f=0,k=0;if(i[A>>2]=105868,f=i[A+124>>2],f){if(e=f,r=i[A+128>>2],(e|0)!=(r|0)){for(;;){e=i[r-4>>2];i:{if(!e||(k=i[e+4>>2],i[e+4>>2]=k-1,k))break i;W[i[i[e>>2]+8>>2]](e),y(e)}if(r=r-12|0,(r|0)==(f|0))break}e=i[A+124>>2]}i[A+128>>2]=f,Z(e)}return A2(A)|0}function VC(A,e,r,f,k,n){if(A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,!(!i[r+4>>2]&i[r>>2]==2)){i[A+8>>2]=0,i[A>>2]=0,i[A+4>>2]=0;return}f=l[r+8|0],r=i[r+12>>2],e=p(28),i[e+24>>2]=6,u[e+22|0]=1,g[e+20>>1]=2,i[e+16>>2]=131074,i[e+12>>2]=r,u[e+8|0]=f,i[e>>2]=0,i[e+4>>2]=1,r=e+28|0,i[A+8>>2]=r,i[A>>2]=e,i[A+4>>2]=r}function FC(A,e){A=A|0,e=e|0;var r=0,f=0,k=0;if(A=i[e+12>>2],A&&(i[e+16>>2]=A,Z(A)),A=i[e>>2],A){if(r=A,f=i[e+4>>2],(r|0)!=(f|0)){for(;;){r=i[f-4>>2];i:{if(!r||(k=i[r+4>>2],i[r+4>>2]=k-1,k))break i;W[i[i[r>>2]+8>>2]](r),y(r)}if(f=f-8|0,(A|0)==(f|0))break}r=i[e>>2]}i[e+4>>2]=A,Z(r)}}function IC(A){A=A|0;var e=0,r=0,f=0,k=0;if(i[A>>2]=104780,f=i[A+104>>2],f){if(e=f,r=i[A+108>>2],(e|0)!=(r|0)){for(;;){e=i[r-4>>2];i:{if(!e||(k=i[e+4>>2],i[e+4>>2]=k-1,k))break i;W[i[i[e>>2]+8>>2]](e),y(e)}if(r=r-8|0,(r|0)==(f|0))break}e=i[A+104>>2]}i[A+108>>2]=f,Z(e)}return A2(A)|0}function qr(A,e,r){var f=0,k=0,n=0,t=0;n=v-16|0,v=n,i[n+12>>2]=r,f=v-160|0,v=f,t=f+8|0,x(t,70288,144),i[f+52>>2]=A,i[f+28>>2]=A,k=-2-A|0,k=k>>>0>2147483647?2147483647:k,i[f+56>>2]=k,k=A+k|0,i[f+36>>2]=k,i[f+24>>2]=k,Ls(t,e,r),(A|0)!=-2&&(A=i[f+28>>2],u[A-((A|0)==i[f+24>>2])|0]=0),v=f+160|0,v=n+16|0}function u6(A){var e=U(0),r=0,f=0;if(r=(N1(A),t2(2)),f=r>>>23&255,f>>>0<=149)if(f>>>0<=125)A=U(A*U(0));else{A=U(w2(A)),e=U(U(U(A+U(8388608))+U(-8388608))-A);i:{if(e>U(.5)){A=U(U(A+e)+U(-1));break i}if(A=U(A+e),!(e<=U(-.5)))break i;A=U(A+U(1))}A=(r|0)<0?U(-A):A}return U(w2(A))<U(2147483648)?~~A:-2147483648}function CC(A,e,r){A=A|0,e=e|0,r=r|0;var f=0;f=v-32|0,v=f,f1(f+12|0,e,r,W[i[i[e>>2]+52>>2]](e,r,0)|0),u[f+31|0]<0&&Z(i[f+20>>2]),e=i[26917],i[A>>2]=i[26916],i[A+4>>2]=e,A=A+8|0;i:{if(u[107683]>=0){e=i[26919],i[A>>2]=i[26918],i[A+4>>2]=e,i[A+8>>2]=i[26920];break i}T(A,i[26918],i[26919])}v=f+32|0}function pC(A){A=A|0;var e=0,r=0;i[A>>2]=101688,e=i[A+556>>2];i:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break i;W[i[i[e>>2]+8>>2]](e),y(e)}e=i[A+548>>2];i:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break i;W[i[i[e>>2]+8>>2]](e),y(e)}return e=i[A+512>>2],e&&(i[A+516>>2]=e,Z(e)),T1(A)|0}function he(A){var e=0,r=0;e=i[A+76>>2];i:{if(!((e|0)>=0&(!e|i[31348]!=(e&1073741823)))){if(e=i[A+4>>2],(e|0)!=i[A+8>>2]){i[A+4>>2]=e+1,A=l[e|0];break i}A=u3(A);break i}e=A+76|0,r=i[e>>2],i[e>>2]=r||1073741823,r=i[A+4>>2];e:{if((r|0)!=i[A+8>>2]){i[A+4>>2]=r+1,A=l[r|0];break e}A=u3(A)}i[e>>2]=0}return A}function yC(A){A=A|0;var e=0,r=0,f=0,k=0;e=v-16|0,v=e,A=i[A>>2];i:{if(u[A+63|0]>=0){i[e+8>>2]=i[A+60>>2],r=i[A+56>>2],i[e>>2]=i[A+52>>2],i[e+4>>2]=r;break i}T(e,i[A+52>>2],i[A+56>>2])}return A=u[e+11|0],r=(A|0)<0,f=r?i[e+4>>2]:A,f&&(k=c4(p(f+1|0),r?i[e>>2]:e)),(A|0)<0&&Z(i[e>>2]),v=e+16|0,k|0}function EC(A){A=A|0;var e=0,r=0,f=0,k=0;if(i[A>>2]=105868,f=i[A+124>>2],f){if(e=f,r=i[A+128>>2],(e|0)!=(r|0)){for(;;){e=i[r-4>>2];i:{if(!e||(k=i[e+4>>2],i[e+4>>2]=k-1,k))break i;W[i[i[e>>2]+8>>2]](e),y(e)}if(r=r-12|0,(r|0)==(f|0))break}e=i[A+124>>2]}i[A+128>>2]=f,Z(e)}Z(A2(A))}function h2(A){var e=0,r=0,f=0;i:{e:{if(e=A,!(e&3))break e;if(!l[e|0])return 0;for(;;){if(e=e+1|0,!(e&3))break e;if(!l[e|0])break}break i}for(;r=e,e=e+4|0,f=i[r>>2],((f|16843008-f)&-2139062144)==-2139062144;);for(;e=r,r=e+1|0,!!l[e|0];);}return e-A|0}function YC(A,e,r,f,k){if(A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,i[e+8>>2]!=1){e=i[24203],i[A>>2]=i[24202],i[A+4>>2]=e,i[A+8>>2]=i[24204];return}i:{if(!l[e+16|0]||(f&&(i[f>>2]=i[e+20>>2]),!k))break i;i[k>>2]=i[e+24>>2]}r&&(i[r>>2]=l[e+16|0]),e=i[24057],i[A>>2]=i[24056],i[A+4>>2]=e,i[A+8>>2]=i[24058]}function bu(A,e,r){var f=0,k=0,n=0;i:{e:{f=i[A+128>>2];r:{if(!f)break r;for(k=A+128|0,A=k;n=i[f+16>>2]<(e|0),A=n?A:f,f=i[(n?4:0)+f>>2],!!f;);if((A|0)==(k|0))break r;if(i[A+16>>2]<=(e|0))break e}if(A=0,!r)break i;return i[r>>2]=0,0}r&&(i[r>>2]=i[A+56>>2]),A=i[A+44>>2]}return A}function RC(A,e,r,f,k){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0;var n=0,t=0;t=v-16|0,v=t,i[k>>2]=r,n=t+12|0,A=i5(n,0,i[A+8>>2]),e=2;i:{if(A+1>>>0<2||(r=A-1|0,e=1,r>>>0>f-i[k>>2]>>>0))break i;for(;;){if(r){A=l[n|0],e=i[k>>2],i[k>>2]=e+1,u[e|0]=A,r=r-1|0,n=n+1|0;continue}break}e=0}return v=t+16|0,e|0}function JC(A){A=A|0;var e=0,r=0,f=0,k=0;if(i[A>>2]=104780,f=i[A+104>>2],f){if(e=f,r=i[A+108>>2],(e|0)!=(r|0)){for(;;){e=i[r-4>>2];i:{if(!e||(k=i[e+4>>2],i[e+4>>2]=k-1,k))break i;W[i[i[e>>2]+8>>2]](e),y(e)}if(r=r-8|0,(r|0)==(f|0))break}e=i[A+104>>2]}i[A+108>>2]=f,Z(e)}Z(A2(A))}function o6(A,e,r,f){var k=0;i:{if(!(f&2048)|!r||(k=f&74,(k|0)==8|(k|0)==64))break i;u[A|0]=43,A=A+1|0}for(f&512&&(u[A|0]=35,A=A+1|0);;){if(k=l[e|0],k){u[A|0]=k,A=A+1|0,e=e+1|0;continue}break}k=f&74,e=111;i:{if((k|0)==64||(e=f&16384?88:120,(k|0)==8))break i;e=r?100:117}u[A|0]=e}function NC(A){A=A|0;var e=0,r=0,f=0,k=0;if(i[A>>2]=88072,f=i[A+104>>2],f){if(e=f,r=i[A+108>>2],(e|0)!=(r|0)){for(;e=i[r-12>>2],e&&(i[r-8>>2]=e,Z(e)),e=r-56|0,i[e>>2]=86356,k=i[r-36>>2],k&&(i[r-32>>2]=k,Z(k)),r=e,(f|0)!=(e|0););e=i[A+104>>2]}i[A+108>>2]=f,Z(e)}return A2(A)|0}function UC(A){A=A|0;var e=0,r=0;i[A>>2]=101688,e=i[A+556>>2];i:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break i;W[i[i[e>>2]+8>>2]](e),y(e)}e=i[A+548>>2];i:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break i;W[i[i[e>>2]+8>>2]](e),y(e)}e=i[A+512>>2],e&&(i[A+516>>2]=e,Z(e)),Z(T1(A))}function DC(A){A=A|0;var e=0,r=0,f=0,k=0;if(e=i[A+104>>2],f=i[A+108>>2],(e|0)==(f|0)){u[A+97|0]=0;return}i:{for(;;){if(i[e+4>>2]||(k=i[e+8>>2],r=i[e+12>>2],(r|0)>0?r=1:r=(r|0)>=0&k>>>0>=2147483648,r))break i;if(e=e+24|0,(f|0)==(e|0))break}u[A+97|0]=0;return}u[A+97|0]=1}function io(A){var e=0,r=0,f=0;f=i[A+16>>2]<<8,i[A+16>>2]=f,e=C[A+20>>1]+8|0,g[A+20>>1]=e,e=e<<16>>16;i:{if((e|0)<0||(r=i[A+4>>2],r>>>0>=u0[A+8>>2]))break i;i[A+4>>2]=r+1,r=l[r|0],g[A+20>>1]=e-8,f=r<<e|f}return r=i[A+12>>2]<<7,e=(f>>>0)/(r>>>0)|0,(e|0)>=256&&(e=255),i[A+16>>2]=f-G(e,r),e}function ar(A,e){var r=0,f=0,k=0;r=i[A+128>>2];i:{if(!r)break i;for(k=A+128|0,A=k;f=u0[r+16>>2]<e>>>0,A=f?A:r,r=i[(f?4:0)+r>>2],!!r;);if(f=0,(A|0)==(k|0)|u0[A+16>>2]>e>>>0||(f=i[A+20>>2],A=i[A+24>>2],!A|i[A+4>>2]!=-1))break i;W[i[i[A>>2]+8>>2]](A),y(A)}return(f|0)!=0}function MC(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0,t=0,o=0;f=v-32|0,v=f,n=f+12|0,L1(n,Ro(e,r)),e=u[f+23|0],r=(e|0)<0,e=r?i[f+16>>2]:e,k=y2(e+4|0),i[k>>2]=e,e&&x(k+4|0,r?i[f+12>>2]:n,e),i[f+24>>2]=k,t=A,o=E1(96240,f+24|0)|0,i[t+4>>2]=o,i[A>>2]=125368,u[f+23|0]<0&&Z(i[f+12>>2]),v=f+32|0}function HC(A,e,r,f,k,n){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0;var t=0,o=0,s=0;t=A,o=e,A=W[i[i[A+8>>2]+20>>2]](A+8|0)|0;i:{if(l[A+11|0]>>>7|0){e=i[A>>2];break i}e=A}return s=e,l[A+11|0]>>>7|0?e=i[A>>2]:e=A,l[A+11|0]>>>7|0?A=i[A+4>>2]:A=l[A+11|0]&127,T8(t,o,r,f,k,n,s,e+(A<<2)|0)|0}function X2(A){var e=0,r=0,f=0;f=v-16|0,v=f;i:{if(!f4(A,1))break i;r=i[A>>2],e=i[A+4>>2],e&&(i[e+4>>2]=i[e+4>>2]+1);e:{if(!(W[i[i[r>>2]+16>>2]](r,f+15|0,1)|0)){i8(A),r=0;break e}r=l[f+15|0]}if(!e||(A=i[e+4>>2],i[e+4>>2]=A-1,A))break i;W[i[i[e>>2]+8>>2]](e),y(e)}return v=f+16|0,r}function zC(A){A=A|0;var e=0,r=0,f=0,k=0;if(i[A>>2]=88072,f=i[A+104>>2],f){if(e=f,r=i[A+108>>2],(e|0)!=(r|0)){for(;e=i[r-12>>2],e&&(i[r-8>>2]=e,Z(e)),e=r-56|0,i[e>>2]=86356,k=i[r-36>>2],k&&(i[r-32>>2]=k,Z(k)),r=e,(f|0)!=(e|0););e=i[A+104>>2]}i[A+108>>2]=f,Z(e)}Z(A2(A))}function xC(A){A=A|0;var e=0,r=0;i[A>>2]=106468,e=i[A+52>>2];i:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break i;W[i[i[e>>2]+8>>2]](e),y(e)}e=i[A+44>>2];i:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break i;W[i[i[e>>2]+8>>2]](e),y(e)}return e=i[A+28>>2],e&&(i[A+32>>2]=e,Z(e)),A|0}function TC(A){A=A|0;var e=0,r=0,f=0;r=v-16|0,v=r,e=i[A+460>>2];i:{if((e|0)==i[A+464>>2]||(r4(r+8|0,i[A+100>>2],i[e>>2],0),A=i[r+12>>2],e=i[r+8>>2],e&&(f=W[i[i[e>>2]+88>>2]](e)|0),!A)||(e=i[A+4>>2],i[A+4>>2]=e-1,e))break i;W[i[i[A>>2]+8>>2]](A),y(A)}return v=r+16|0,f|0}function SC(A){A=A|0;var e=0,r=0,f=0;r=v-16|0,v=r,e=i[A+480>>2];i:{if((e|0)==i[A+484>>2]||(r4(r+8|0,i[A+100>>2],i[e>>2],0),A=i[r+12>>2],e=i[r+8>>2],e&&(f=W[i[i[e>>2]+88>>2]](e)|0),!A)||(e=i[A+4>>2],i[A+4>>2]=e-1,e))break i;W[i[i[A>>2]+8>>2]](A),y(A)}return v=r+16|0,f|0}function _i(A,e){var r=0;if(r=i[A>>2],i[A>>2]=e,r){A=i[r+32>>2],A&&(i[r+36>>2]=A,Z(A)),A=i[r+12>>2];i:{if(!A||(e=i[A+4>>2],i[A+4>>2]=e-1,e))break i;W[i[i[A>>2]+8>>2]](A),y(A)}A=i[r+4>>2];i:{if(!A||(e=i[A+4>>2],i[A+4>>2]=e-1,e))break i;W[i[i[A>>2]+8>>2]](A),y(A)}Z(r)}}function Bi(A,e){var r=0;if(r=i[A>>2],i[A>>2]=e,r){A=i[r+16>>2],A&&(i[r+20>>2]=A,Z(A)),A=i[r+12>>2];i:{if(!A||(e=i[A+4>>2],i[A+4>>2]=e-1,e))break i;W[i[i[A>>2]+8>>2]](A),y(A)}A=i[r+4>>2];i:{if(!A||(e=i[A+4>>2],i[A+4>>2]=e-1,e))break i;W[i[i[A>>2]+8>>2]](A),y(A)}Z(r)}}function N2(A,e,r){var f=0,k=0;i:{e:{if(r>>>0>=4){if((A|e)&3)break e;for(;;){if(i[A>>2]!=i[e>>2])break e;if(e=e+4|0,A=A+4|0,r=r-4|0,!(r>>>0>3))break}}if(!r)break i}for(;;){if(f=l[A|0],k=l[e|0],(f|0)==(k|0)){if(e=e+1|0,A=A+1|0,r=r-1|0,r)continue;break i}break}return f-k|0}return 0}function D1(A){var e=0,r=0,f=0,k=0;if(i[A>>2]){l[107752]||(u[107752]=1),e=i[26940];i:{if(!e)break i;for(r=107760,f=i[A>>2];k=u0[e+16>>2]<f>>>0,r=k?r:e,e=i[(k?4:0)+e>>2],!!e;);if((r|0)==107760|u0[r+16>>2]>f>>>0)break i;i[r+20>>2]=i[r+20>>2]-i[A+4>>2]}i[A>>2]=0,i[A+4>>2]=0}}function jC(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0;i:{e:{if(A=i[A+4>>2],f=i[A+188>>2],e=e>>f,(e|0)<0||(k=i[A+192>>2],(e|0)>=(k|0)))break e;if(r=r>>f,(r|0)<0|(r|0)>=i[A+196>>2])break i;return(i[A+180>>2]+G(e,12)|0)+G(G(r,k),12)|0}D0(4656,10893,118,4231),H()}D0(4618,10893,119,4231),H()}function OC(A,e,r,f,k,n){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0;var t=0,o=0,s=0;t=A,o=e,A=W[i[i[A+8>>2]+20>>2]](A+8|0)|0;i:{if(l[A+11|0]>>>7|0){e=i[A>>2];break i}e=A}return s=e,l[A+11|0]>>>7|0?e=i[A>>2]:e=A,l[A+11|0]>>>7|0?A=i[A+4>>2]:A=l[A+11|0]&127,x8(t,o,r,f,k,n,s,e+A|0)|0}function PC(A){A=A|0;var e=0,r=0;i[A>>2]=106468,e=i[A+52>>2];i:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break i;W[i[i[e>>2]+8>>2]](e),y(e)}e=i[A+44>>2];i:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break i;W[i[i[e>>2]+8>>2]](e),y(e)}e=i[A+28>>2],e&&(i[A+32>>2]=e,Z(e)),Z(A)}function j1(A,e,r,f){var k=0,n=0;k=v-16|0,v=k,n=i[e+52>>2];i:{if(!n){if(u[k+4|0]=0,u[k+15|0]=0,q(A,2,108,k+4|0),u[k+15|0]>=0)break i;Z(i[k+4>>2]);break i}if(!i[e+60>>2]){if(u[k+4|0]=0,u[k+15|0]=0,q(A,2,109,k+4|0),u[k+15|0]>=0)break i;Z(i[k+4>>2]);break i}V9(A,n,r,e+60|0,f)}v=k+16|0}function zA(A,e,r,f){var k=0,n=0,t=0,o=0;k=v-160|0,v=k,i[k+60>>2]=e,i[k+20>>2]=e,i[k+24>>2]=-1,n=k+16|0,u8(n,0,0),Y7(k,n,f,1),f=i[k+8>>2],t=i[k+12>>2],n=i[k>>2],o=i[k+4>>2],r&&(i[r>>2]=i[k+136>>2]+((i[k+20>>2]-i[k+60>>2]|0)+e|0)),i[A+8>>2]=f,i[A+12>>2]=t,i[A>>2]=n,i[A+4>>2]=o,v=k+160|0}function LC(A){A=A|0;var e=0,r=0,f=0,k=0;if(e=i[A+16>>2],!e)return 0;e=W0(e,94756,95960);i:{if(!e)break i;if(A=i[A+20>>2],!A)return i[e+24>>2]-i[e+20>>2]|0;if(r=i[A+4>>2],f=r+1|0,i[A+4>>2]=f,k=i[e+20>>2],e=i[e+24>>2],i[A+4>>2]=r,r=e-k|0,f)break i;W[i[i[A>>2]+8>>2]](A),y(A)}return r|0}function eo(A){A=A|0;var e=0,r=0,f=0,k=0;if(e=i[A+16>>2],!e)return 0;e=W0(e,94756,95916);i:{if(!e)break i;if(A=i[A+20>>2],!A)return i[e+12>>2]-i[e+8>>2]>>3;if(r=i[A+4>>2],f=r+1|0,i[A+4>>2]=f,k=i[e+8>>2],e=i[e+12>>2],i[A+4>>2]=r,r=e-k>>3,f)break i;W[i[i[A>>2]+8>>2]](A),y(A)}return r|0}function KC(A,e,r,f,k,n,t){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,t=t|0;var o=0;n=v-32|0,v=n,o=n+12|0,ci(o,i[e>>2],r,f,k,1970432288,0,0,t);i:{if(i[n+12>>2]!=i[26916]){b0(A,o,i[e>>2]);break i}e=i[24057],i[A>>2]=i[24056],i[A+4>>2]=e,i[A+8>>2]=i[24058]}u[n+31|0]<0&&Z(i[n+20>>2]),v=n+32|0}function qC(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0;var k=0,n=0;if(k=e,n=C0(r),i[k+104>>2]=n,k=e,n=C0(r),i[k+108>>2]=n,k=e,n=C0(r),i[k+112>>2]=n,e=i[26917],i[A>>2]=i[26916],i[A+4>>2]=e,A=A+8|0,u[107683]>=0){e=i[26919],i[A>>2]=i[26918],i[A+4>>2]=e,i[A+8>>2]=i[26920];return}T(A,i[26918],i[26919])}function $r(A,e){var r=0,f=0,k=0;if(i[e+16>>2]!=1970628964){i[A+8>>2]=0,i[A>>2]=0,i[A+4>>2]=0;return}i[A+8>>2]=0,i[A>>2]=0,i[A+4>>2]=0;i:{if(r=i[e+20>>2],e=i[e+24>>2],(r|0)!=(e|0)){if(e=e-r|0,(e|0)<0)break i;f=p(e),i[A>>2]=f,k=e+f|0,i[A+8>>2]=k,e&&x(f,r,e),i[A+4>>2]=k}return}G0(),H()}function aC(A,e,r,f,k,n){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0;var t=0,o=0;t=v-32|0,v=t,o=t+12|0,ci(o,i[e>>2],r,f,k,1835625829,9842,n,0);i:{if(i[t+12>>2]!=i[26916]){b0(A,o,i[e>>2]);break i}e=i[24057],i[A>>2]=i[24056],i[A+4>>2]=e,i[A+8>>2]=i[24058]}u[t+31|0]<0&&Z(i[t+20>>2]),v=t+32|0}function ro(A){var e=0,r=0,f=0;e=A+252|0;i:{e:{r:{f:switch(r=i[A+256>>2],A=u[A+263|0],r=(A|0)<0?r:A,r-25|0){case 0:break e;case 1:break r;case 18:break f;default:break i}return!N2((A|0)<0?i[e>>2]:e,19026,43)}return!N2((A|0)<0?i[e>>2]:e,21770,r)}f=!N2((A|0)<0?i[e>>2]:e,21797,r)}return f}function fo(A,e,r,f,k,n,t){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,t=t|0;var o=0,s=0;o=v-32|0,v=o,s=o+12|0,T0(s,i[e>>2],r,f,k,n,t);i:{if(i[o+12>>2]){r=A,A=i[e>>2],b0(r,s,A?A+92|0:0);break i}e=i[24057],i[A>>2]=i[24056],i[A+4>>2]=e,i[A+8>>2]=i[24058]}u[o+31|0]<0&&Z(i[o+20>>2]),v=o+32|0}function $C(A){A=A|0;var e=0,r=0,f=0,k=0;if(i[A>>2]=99256,r=i[A+112>>2],r){if(e=r,f=i[A+116>>2],(e|0)!=(f|0)){for(;e=f-12|0,k=i[e>>2],k&&(i[f-8>>2]=k,Z(k)),f=e,(e|0)!=(r|0););e=i[A+112>>2]}i[A+116>>2]=r,Z(e)}return e=i[A+100>>2],e&&(i[A+104>>2]=e,Z(e)),A2(A)|0}function Ao(A,e){A=A|0,e=e|0;var r=0,f=0;i:{if(!e||(r=l[e|0],f=l[A|0],((r>>>0<f>>>0?r:f)|0)!=1))break i;i[A+4>>2]=i[e+4>>2],g[A+8>>1]=C[e+8>>1],g[A+10>>1]=C[e+10>>1],g[A+12>>1]=C[e+12>>1],g[A+14>>1]=C[e+14>>1],g[A+16>>1]=C[e+16>>1],g[A+18>>1]=C[e+18>>1],g[A+20>>1]=C[e+20>>1]}}function dC(A){A=A|0;var e=0,r=0,f=0;e=i[A+24>>2],e>>>0>u0[A+44>>2]&&(i[A+44>>2]=e);i:{if(!(l[A+48|0]&8)||(e=i[A+44>>2],e>>>0>u0[A+16>>2]&&(r=i[A+8>>2],f=i[A+12>>2],i[A+16>>2]=e,i[A+12>>2]=f,i[A+8>>2]=r),e=i[A+16>>2],A=i[A+12>>2],e>>>0<=A>>>0))break i;return l[A|0]}return-1}function L8(A){var e=0,r=0,f=0;r=v-32|0,v=r,l[108637]==1&&(i[r+16>>2]=A,E8(33107,r+16|0)),e=i[A+4>>2];i:{if(!e||(f=e,e=i[e>>2]-1|0,i[f>>2]=e,e)||(l[108637]==1&&(i[r>>2]=i[A>>2],E8(33137,r)),e=i[A>>2],e&&Z(e),e=i[A+4>>2],!e))break i;Z(e)}return v=r+32|0,A}function cC(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0;var k=0,n=0,t=0;k=v-32|0,v=k,n=k+12|0,t=i[e>>2],W[i[i[t>>2]+76>>2]](n,t,r,f);i:{if(i[k+12>>2]){r=A,A=i[e>>2],b0(r,n,A?A+84|0:0);break i}e=i[24057],i[A>>2]=i[24056],i[A+4>>2]=e,i[A+8>>2]=i[24058]}u[k+31|0]<0&&Z(i[k+20>>2]),v=k+32|0}function xA(A,e){var r=0,f=0,k=0,n=0,t=0,o=0;r=i[A+104>>2],A=i[A+108>>2];i:{if((r|0)!=(A|0))for(n=r+12|0,A=(A-r|0)/12|0,t=A>>>0<=1?1:A,o=A-1|0,A=0;;){if(k=G(A,12),f=k+r|0,u0[f>>2]<=e>>>0&((A|0)==(o|0)|u0[n+k>>2]>e>>>0))break i;if(A=A+1|0,(t|0)==(A|0))break}f=0}return f}function ko(A,e,r){var f=0;if(r-65537>>>0<4294836223)for(;e=(e|0)/2|0,r=(r|0)/2|0,r-65537>>>0<4294836223;);i:{if((r|0)<=1)break i;for(;;){if(e-65537>>>0>4294836222)break i;if(e=(e|0)/2|0,f=r>>>0>3,r=r>>>1|0,!f)break}}return i[A>>2]=e,i[A+4>>2]=r,A}function no(A){var e=0,r=0,f=0,k=0;if(e=v-16|0,v=e,l[108637]==1&&(i[e+4>>2]=i[A+4>>2],i[e>>2]=A,E8(42395,e)),r=i[A+4>>2],r){f=i[r>>2],(f|0)>=2&&(i[r>>2]=f-1,r=i[A>>2],f=p(172),i[A>>2]=f,k=A,A=p(4),i[k+4>>2]=A,i[A>>2]=1,x(f,r,172)),v=e+16|0;return}D0(3794,18261,95,13063),H()}function bC(A){A=A|0;var e=0,r=0,f=0,k=0;if(i[A>>2]=99256,r=i[A+112>>2],r){if(e=r,f=i[A+116>>2],(e|0)!=(f|0)){for(;e=f-12|0,k=i[e>>2],k&&(i[f-8>>2]=k,Z(k)),f=e,(e|0)!=(r|0););e=i[A+112>>2]}i[A+116>>2]=r,Z(e)}e=i[A+100>>2],e&&(i[A+104>>2]=e,Z(e)),Z(A2(A))}function to(A,e){var r=0,f=0;r=l[A|0];i:{if((r|0)!=l[e|0]||r&&C[A+4>>1]!=C[e+4>>1]|C[A+6>>1]!=C[e+6>>1]|l[A+2|0]!=l[e+2|0]||(r=l[A+1|0],(r|0)!=l[e+1|0])||r&&C[A+8>>1]!=C[e+8>>1]|C[A+10>>1]!=C[e+10>>1]|l[A+3|0]!=l[e+3|0])break i;f=1}return f}function ip(A,e,r,f,k){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0;var n=0,t=0;n=v-32|0,v=n,t=n+12|0,ci(t,i[e>>2],r,f,k,1835625829,9842,0,0);i:{if(i[n+12>>2]!=i[26916]){b0(A,t,i[e>>2]);break i}e=i[24057],i[A>>2]=i[24056],i[A+4>>2]=e,i[A+8>>2]=i[24058]}u[n+31|0]<0&&Z(i[n+20>>2]),v=n+32|0}function uo(A,e,r,f,k,n){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0;var t=0,o=0;t=v-32|0,v=t,o=t+12|0,T0(o,i[e>>2],r,f,k,n,0);i:{if(i[t+12>>2]){r=A,A=i[e>>2],b0(r,o,A?A+92|0:0);break i}e=i[24057],i[A>>2]=i[24056],i[A+4>>2]=e,i[A+8>>2]=i[24058]}u[t+31|0]<0&&Z(i[t+20>>2]),v=t+32|0}function k4(A){var e=0,r=0;r=i[A+16>>2]<<1,i[A+16>>2]=r,e=C[A+20>>1]+1|0,g[A+20>>1]=e;i:{if(e<<16>>16<0||(g[A+20>>1]=65528,e=i[A+4>>2],e>>>0>=u0[A+8>>2]))break i;i[A+4>>2]=e+1,r=l[e|0]|r,i[A+16>>2]=r}return e=i[A+12>>2]<<7,e>>>0<=r>>>0?(i[A+16>>2]=r-e,A=1):A=0,A}function dr(A,e,r,f){var k=0;return i[A>>2]=86312,k=A+4|0,i[k>>2]=0,i[k+4>>2]=0,i[k+16>>2]=0,i[k+8>>2]=0,i[k+12>>2]=0,i[A+48>>2]=0,i[A+40>>2]=0,i[A+44>>2]=0,i[A+32>>2]=r,i[A+36>>2]=0,i[A>>2]=86180,f?(f=p(r),i[A+48>>2]=f,r&&x(f,e,r),i[A+24>>2]=f,A):(i[A+24>>2]=e,A)}function oo(A,e){var r=0,f=0,k=0;f=1;i:{if(e||(k=i[A>>2],r=i[A+12>>2],e=i[A+8>>2],A=r-e>>2,k>>>0>A>>>0))break i;if((e|0)!=(r|0))for(f=A>>>0<=1?1:A,A=0;;){if(r=i[e+(A<<2)>>2],!(l[r+104|0]|i[r+100>>2]))return 1;if(A=A+1|0,(f|0)==(A|0))break}f=0}return f}function ep(A,e){A=A|0,e=e|0;var r=0;i:{if(!i[A+64>>2]||(r=i[A+12>>2],r>>>0<=u0[A+8>>2]))break i;if((e|0)==-1)return i[A+12>>2]=r-1,((e|0)!=-1?e:0)|0;if(r=i[A+12>>2]-1|0,!(l[A+88|0]&16)&l[r|0]!=(e&255))break i;return i[A+12>>2]=r,u[i[A+12>>2]]=e<<24>>24,e|0}return-1}function rp(A,e){A=A|0,e=e|0;var r=0,f=0,k=0,n=0;r=v-16|0,v=r,i[r+12>>2]=0,i[r+4>>2]=0,i[r+8>>2]=0,e=i[e+64>>2],(e+108|0)!=(r|0)&&(f=i[e+112>>2],e=i[e+116>>2],d4(r+4|0,f,e,e-f|0),k=i[r+4>>2],n=i[r+12>>2],f=i[r+8>>2]),u[A+20|0]=0,i[A+8>>2]=n,i[A+4>>2]=f,i[A>>2]=k,v=r+16|0}function vi(A,e,r){var f=0,k=0,n=0,t=0;i:{if(!e){f=e;break i}for(;r=r-1|0,k=A,A=d8(A,e,10,0),f=l0,n=r,t=k-O0(A,f,10,0)|48,u[n|0]=t,k=e>>>0>9,e=f,!!k;);}if(A|f)for(;r=r-1|0,e=(A>>>0)/10|0,u[r|0]=A-G(e,10)|48,f=A>>>0>9,A=e,!!f;);return r}function fp(A,e,r,f,k,n){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0;var t=0;t=v-16|0,v=t,W[i[i[e>>2]+116>>2]](t+8|0,e),e=A,A=i[t+8>>2],W[i[i[A>>2]+12>>2]](e,A,r,f,k,n),A=i[t+12>>2];i:{if(!A||(e=i[A+4>>2],i[A+4>>2]=e-1,e))break i;W[i[i[A>>2]+8>>2]](A),y(A)}v=t+16|0}function Ap(A){A=A|0;var e=0,r=0,f=0,k=0;if(f=i[A+24>>2],f){if(e=f,r=i[A+28>>2],(e|0)!=(r|0)){for(;;){e=i[r-4>>2];i:{if(!e||(k=i[e+4>>2],i[e+4>>2]=k-1,k))break i;W[i[i[e>>2]+8>>2]](e),y(e)}if(r=r-8|0,(r|0)==(f|0))break}e=i[A+24>>2]}i[A+28>>2]=f,Z(e)}}function lo(A,e,r){var f=0,k=0,n=0,t=0;for(n=v-16|0,v=n,u[n+14|0]=0,f=e-A>>2,e=v-16|0,v=e;;){if(f){i[e+12>>2]=A,k=f>>>1|0,i[e+12>>2]=i[e+12>>2]+(k<<2),t=(k^-1)+f|0,f=k,k=u0[i[e+12>>2]>>2]<u0[r>>2],f=k?t:f,A=k?i[e+12>>2]+4|0:A;continue}break}return v=e+16|0,v=n+16|0,A}function kp(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0;f=v-32|0,v=f,k=f+12|0,n=i[e>>2],W[i[i[n>>2]+32>>2]](k,n,r);i:{if(i[f+12>>2]){r=A,A=i[e>>2],b0(r,k,A?A+92|0:0);break i}e=i[24057],i[A>>2]=i[24056],i[A+4>>2]=e,i[A+8>>2]=i[24058]}u[f+31|0]<0&&Z(i[f+20>>2]),v=f+32|0}function np(A,e,r,f,k){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0;var n=0,t=0,o=0;o=(k-f|0)+e|0;i:{for(;;){if((f|0)!=(k|0)){if(A=-1,(e|0)==(r|0)||(n=u[e|0],t=u[f|0],(n|0)<(t|0)))break i;if((n|0)>(t|0))return 1;f=f+1|0,e=e+1|0;continue}break}A=(r|0)!=(o|0)}return A|0}function tp(A,e){A=A|0,e=e|0;var r=0,f=0,k=0;if(A=i[e>>2],A){if(r=A,f=i[e+4>>2],(r|0)!=(f|0)){for(;;){r=i[f-4>>2];i:{if(!r||(k=i[r+4>>2],i[r+4>>2]=k-1,k))break i;W[i[i[r>>2]+8>>2]](r),y(r)}if(f=f-8|0,(f|0)==(A|0))break}r=i[e>>2]}i[e+4>>2]=A,Z(r)}}function TA(A){var e=0,r=0,f=0,k=0;i:{e:{if(r=i[A+128>>2],!r)break e;for(f=A+128|0,e=f;k=i[r+16>>2]<6,e=k?e:r,r=i[(k?4:0)+r>>2],!!r;);if((e|0)==(f|0)|i[e+16>>2]>=7)break e;e=1;break i}if(A=i[A+120>>2],e=0,A>>>0>15)break i;e=43008>>>A|0}return e&1}function so(A){A=A|0;var e=0,r=0;if(i[A+1884>>2]>0&&(e=A+1392|0,u[e|0]=1,i[e+156>>2]>0))for(;r=r+1|0,(r|0)<i[e+156>>2];);return W[i[i[A>>2]+4>>2]](A),l[108636]||(u[108636]=1),A=i[27152],(A|0)<=0?12:(A=A-1|0,i[27152]=A,A||Ss(),0)}function R2(A,e){var r=0,f=0,k=0;i:{if(f=h2(e),r=l[A+11|0]>>>7|0?(i[A+8>>2]&2147483647)-1|0:10,l[A+11|0]>>>7|0?k=i[A+4>>2]:k=l[A+11|0]&127,f>>>0<=r>>>0){l[A+11|0]>>>7|0?r=i[A>>2]:r=A,k=!f,k|k||x(r,e,f),Xl(A,r,f);break i}Jr(A,r,f-r|0,k,0,k,f,e)}}function _e(A,e,r){var f=0,k=0,n=0;return f=A*A,n=f*(f*f)*(f*158969099521155e-24+-25050760253406863e-24)+(f*(f*27557313707070068e-22+-.0001984126982985795)+.00833333333332249),k=A*f,r?A-(f*(e*.5-k*n)-e+k*.16666666666666632):k*(f*n+-.16666666666666632)+A}function mi(A,e){var r=0,f=0,k=0,n=0;r=v-16|0,v=r;i:{if(!e){e=0;break i}f=e,e=k1(e),o4(r,f,0,0,0,112-(e^31)|0),f=0+i[r+8>>2]|0,e=(i[r+12>>2]^65536)+(16414-e<<16)|0,n=k>>>0>f>>>0?e+1|0:e,k=i[r+4>>2],e=i[r>>2]}i[A>>2]=e,i[A+4>>2]=k,i[A+8>>2]=f,i[A+12>>2]=n,v=r+16|0}function cr(A,e){var r=0,f=0;r=v-16|0,v=r,i[r+12>>2]=A;i:{if((A|0)==(e|0))break i;for(;;){if(e=e-4|0,i[r+8>>2]=e,A>>>0>=e>>>0)break i;A=i[r+12>>2],e=i[A>>2],f=A,A=i[r+8>>2],i[f>>2]=i[A>>2],i[A>>2]=e,A=i[r+12>>2]+4|0,i[r+12>>2]=A,e=i[r+8>>2]}}v=r+16|0}function wo(A){A=A|0;var e=0,r=0;e=i[A>>2],r=i[e+16>>2],e=i[e+20>>2],e&&(i[e+4>>2]=i[e+4>>2]+1);i:{if(r){A=W[i[i[r>>2]+8>>2]](r)|0;break i}A=S4(i[A>>2])?1852009592:0}i:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break i;W[i[i[e>>2]+8>>2]](e),y(e)}return A|0}function up(A){A=A|0;var e=0,r=0;i[A>>2]=98720,e=i[A+460>>2];i:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break i;W[i[i[e>>2]+8>>2]](e),y(e)}e=i[A+452>>2];i:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break i;W[i[i[e>>2]+8>>2]](e),y(e)}return T1(A)|0}function op(A){A=A|0;var e=0,r=0;i[A>>2]=99928,e=i[A+460>>2];i:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break i;W[i[i[e>>2]+8>>2]](e),y(e)}e=i[A+452>>2];i:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break i;W[i[i[e>>2]+8>>2]](e),y(e)}return T1(A)|0}function lp(A){A=A|0;var e=0,r=0;i[A>>2]=97320,e=i[A+460>>2];i:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break i;W[i[i[e>>2]+8>>2]](e),y(e)}e=i[A+452>>2];i:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break i;W[i[i[e>>2]+8>>2]](e),y(e)}return T1(A)|0}function Be(A,e){var r=0,f=0,k=0,n=0;l[A|0]||(r=i[A+24>>2],f=r+i[A+20>>2]|0,n=i[A+12>>2],k=i[A+8>>2],(f|0)==(((k|0)!=(n|0)?(n-k<<8)-1|0:0)|0)&&(or(A+4|0),k=i[A+8>>2],r=i[A+24>>2],f=r+i[A+20>>2]|0),i[i[(f>>>8&16777212)+k>>2]+((f&1023)<<2)>>2]=e,i[A+24>>2]=r+1)}function sp(A){A=A|0;var e=0,r=0,f=0;r=i[i[A>>2]+180>>2],e=i[r+104>>2],A=0;i:{if((e|0)==i[r+108>>2])break i;if(A=i[e>>2],e=i[e+4>>2],!e){A=i[A+16>>2];break i}r=i[e+4>>2],f=r+1|0,i[e+4>>2]=f,A=i[A+16>>2],i[e+4>>2]=r,f||(W[i[i[e>>2]+8>>2]](e),y(e))}return A|0}function wp(A){A=A|0;var e=0,r=0;i[A>>2]=98320,e=i[A+460>>2];i:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break i;W[i[i[e>>2]+8>>2]](e),y(e)}e=i[A+452>>2];i:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break i;W[i[i[e>>2]+8>>2]](e),y(e)}return T1(A)|0}function ho(A,e,r,f,k,n,t){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,t=t|0,r=i[e+456>>2],i[A>>2]=i[e+452>>2],i[A+4>>2]=r,r=A+8|0;i:{if(u[e+471|0]>=0){e=e+460|0,f=i[e+4>>2],i[r>>2]=i[e>>2],i[r+4>>2]=f,i[r+8>>2]=i[e+8>>2];break i}T(r,i[e+460>>2],i[e+464>>2])}u[A+20|0]=1}function C8(A,e,r,f,k){r=G(i[i[A+124>>2]+16892>>2],f)+r|0;i:{if(!e||(r=i[A+320>>2]+G(r,76)|0,i[r>>2]>=(k|0)))break i;i[A+328>>2]=i[A+328>>2]-1,i[A+332>>2]=i[A+332>>2]+1,i[e+4>>2]=2,is(r,k),i[e+4>>2]=1,i[A+332>>2]=i[A+332>>2]-1,i[A+328>>2]=i[A+328>>2]+1}}function hp(A){A=A|0;var e=0,r=0;i[A>>2]=99496,e=i[A+460>>2];i:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break i;W[i[i[e>>2]+8>>2]](e),y(e)}e=i[A+452>>2];i:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break i;W[i[i[e>>2]+8>>2]](e),y(e)}return T1(A)|0}function _p(A){A=A|0;var e=0,r=0;i[A>>2]=97776,e=i[A+460>>2];i:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break i;W[i[i[e>>2]+8>>2]](e),y(e)}e=i[A+452>>2];i:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break i;W[i[i[e>>2]+8>>2]](e),y(e)}return T1(A)|0}function Bp(A,e,r){if(A=A|0,e=e|0,r=r|0,u2(r,C[e+4>>1]),u2(r,C[e+6>>1]),u2(r,C[e+8>>1]),l2(r,l[e+10|0]<<7&128),e=i[26917],i[A>>2]=i[26916],i[A+4>>2]=e,A=A+8|0,u[107683]>=0){e=i[26919],i[A>>2]=i[26918],i[A+4>>2]=e,i[A+8>>2]=i[26920];return}T(A,i[26918],i[26919])}function vp(A){A=A|0;var e=0,r=0,f=0;if(A=i[26970],A){if(e=A,r=i[26971],(e|0)!=(r|0)){for(;;){e=i[r-4>>2];i:{if(!e||(f=i[e+4>>2],i[e+4>>2]=f-1,f))break i;W[i[i[e>>2]+8>>2]](e),y(e)}if(r=r-8|0,(r|0)==(A|0))break}e=i[26970]}i[26971]=A,Z(e)}}function Zi(A,e){var r=0,f=0,k=0;f=-1;i:{if((A|0)==-1)break i;k=i[e+76>>2]<0;e:{r=i[e+4>>2];r:{if(!r&&(Ge(e),r=i[e+4>>2],!r))break r;if(i[e+44>>2]-8>>>0<r>>>0)break e}if(k)break i;return-1}r=r-1|0,i[e+4>>2]=r,u[r|0]=A,i[e>>2]=i[e>>2]&-17,f=A&255}return f}function N6(A,e){var r=0,f=0;r=v-16|0,v=r,i[r+12>>2]=A;i:{if((A|0)==(e|0))break i;for(;;){if(e=e-1|0,i[r+8>>2]=e,A>>>0>=e>>>0)break i;A=i[r+12>>2],e=l[A|0],f=A,A=i[r+8>>2],u[f|0]=l[A|0],u[A|0]=e,A=i[r+12>>2]+1|0,i[r+12>>2]=A,e=i[r+8>>2]}}v=r+16|0}function _o(A,e,r){var f=0,k=0,n=0,t=0;f=v-16|0,v=f,A=R0(A),i[A+32>>2]=e,i[A>>2]=73496,k=f+12|0,e=i[A+4>>2],i[k>>2]=e,(e|0)!=129576&&(i[e+4>>2]=i[e+4>>2]+1),e=c0(k,129768),e2(k),i[A+40>>2]=r,i[A+36>>2]=e,n=A,t=W[i[i[e>>2]+28>>2]](e)|0,u[n+44|0]=t,v=f+16|0}function Bo(A,e,r){var f=0,k=0,n=0,t=0;f=v-16|0,v=f,A=vl(A),i[A+32>>2]=e,i[A>>2]=73700,k=f+12|0,e=i[A+4>>2],i[k>>2]=e,(e|0)!=129576&&(i[e+4>>2]=i[e+4>>2]+1),e=c0(k,129776),e2(k),i[A+40>>2]=r,i[A+36>>2]=e,n=A,t=W[i[i[e>>2]+28>>2]](e)|0,u[n+44|0]=t,v=f+16|0}function ve(A){var e=0,r=0,f=0,k=0;if(f=i[A>>2],f){if(e=f,r=i[A+4>>2],(e|0)!=(r|0)){for(;;){e=i[r-4>>2];i:{if(!e||(k=i[e+4>>2],i[e+4>>2]=k-1,k))break i;W[i[i[e>>2]+8>>2]](e),y(e)}if(r=r-8|0,(r|0)==(f|0))break}e=i[A>>2]}i[A+4>>2]=f,Z(e)}}function mp(A,e){A=A|0,e=e|0;var r=0,f=0,k=0;if(f=i[e+8>>2],r=h2(f),r>>>0<2147483640){i:{e:{if(r>>>0>=11){k=r|7,e=p(k+1|0),i[A+8>>2]=k-2147483647,i[A>>2]=e,i[A+4>>2]=r,A=e;break e}if(u[A+11|0]=r,!r)break i}if(!r)break i;x(A,f,r)}u[A+r|0]=0;return}Q0(),H()}function me(A,e){var r=0,f=0;r=v-16|0,v=r,l[A+11|0]>>>7|0&&$8(i[A>>2],4);i:if(l[e+11|0]>>>7|0)break i;i[A+8>>2]=i[e+8>>2],f=i[e+4>>2],i[A>>2]=i[e>>2],i[A+4>>2]=f,u[e+11|0]=l[e+11|0]&128,u[e+11|0]=l[e+11|0]&127,i[r+12>>2]=0,i[e>>2]=i[r+12>>2],v=r+16|0}function Zp(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0;var k=0,n=0;k=v-32|0,v=k,n=k+12|0,F9(n,i[e>>2],r,f,0);i:{if(i[k+12>>2]){r=A,A=i[e>>2],b0(r,n,A?A+92|0:0);break i}e=i[24164],i[A>>2]=i[24163],i[A+4>>2]=e,i[A+8>>2]=i[24165]}u[k+31|0]<0&&Z(i[k+20>>2]),v=k+32|0}function Gp(A){A=A|0;var e=0,r=0;i[A>>2]=98720,e=i[A+460>>2];i:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break i;W[i[i[e>>2]+8>>2]](e),y(e)}e=i[A+452>>2];i:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break i;W[i[i[e>>2]+8>>2]](e),y(e)}Z(T1(A))}function Xp(A){A=A|0;var e=0,r=0;i[A>>2]=99928,e=i[A+460>>2];i:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break i;W[i[i[e>>2]+8>>2]](e),y(e)}e=i[A+452>>2];i:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break i;W[i[i[e>>2]+8>>2]](e),y(e)}Z(T1(A))}function Ze(A){var e=0,r=0,f=0;g[A+20>>1]=8,i[A+12>>2]=510,i[A+16>>2]=0,e=i[A+4>>2],f=i[A+8>>2]-e|0;i:{if((f|0)<=0||(i[A+4>>2]=e+1,r=l[e|0],g[A+20>>1]=0,r=r<<8,i[A+16>>2]=r,(f|0)==1))break i;i[A+4>>2]=e+2,e=l[e+1|0],g[A+20>>1]=65528,i[A+16>>2]=e|r}}function Wp(A){A=A|0;var e=0,r=0;i[A>>2]=97320,e=i[A+460>>2];i:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break i;W[i[i[e>>2]+8>>2]](e),y(e)}e=i[A+452>>2];i:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break i;W[i[i[e>>2]+8>>2]](e),y(e)}Z(T1(A))}function Qp(A){A=A|0;var e=0,r=0;i[A>>2]=98320,e=i[A+460>>2];i:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break i;W[i[i[e>>2]+8>>2]](e),y(e)}e=i[A+452>>2];i:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break i;W[i[i[e>>2]+8>>2]](e),y(e)}Z(T1(A))}function gp(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0;var k=0,n=0;if(S1(A,i[e+8>>2],0)){jA(e,r,f);return}k=i[A+12>>2],n=A+16|0,Wo(n,e,r,f);i:{if(k>>>0<2)break i;for(k=(k<<3)+n|0,A=A+24|0;;){if(Wo(A,e,r,f),l[e+54|0])break i;if(A=A+8|0,!(k>>>0>A>>>0))break}}}function Vp(A,e,r,f){if(A=A|0,e=e|0,r=r|0,f=f|0,!(!f|r)){i[A>>2]=5,i[A+4>>2]=0,i[A+8>>2]=4843;return}i[e+8>>2]=f,f=i[e+12>>2],f&&Z(f);i:{if(r){f=e,e=f5(),i[f+12>>2]=e,A3(e,r);break i}i[e+12>>2]=0}e=i[24164],i[A>>2]=i[24163],i[A+4>>2]=e,i[A+8>>2]=i[24165]}function Fp(A){A=A|0;var e=0,r=0;i[A>>2]=99496,e=i[A+460>>2];i:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break i;W[i[i[e>>2]+8>>2]](e),y(e)}e=i[A+452>>2];i:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break i;W[i[i[e>>2]+8>>2]](e),y(e)}Z(T1(A))}function Ip(A){A=A|0;var e=0,r=0;i[A>>2]=97776,e=i[A+460>>2];i:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break i;W[i[i[e>>2]+8>>2]](e),y(e)}e=i[A+452>>2];i:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break i;W[i[i[e>>2]+8>>2]](e),y(e)}Z(T1(A))}function Cp(A,e,r){A=A|0,e=e|0,r=r|0;var f=0;if(f=i[e+64>>2],f&&Z(f),f=e,e=ye(),i[f+64>>2]=e,Qi(e,r),e=i[26917],i[A>>2]=i[26916],i[A+4>>2]=e,A=A+8|0,u[107683]>=0){e=i[26919],i[A>>2]=i[26918],i[A+4>>2]=e,i[A+8>>2]=i[26920];return}T(A,i[26918],i[26919])}function l1(A){var e=0,r=0,f=0,k=0;if(r=v-16|0,v=r,i[r+12>>2]=A,f=v-16|0,v=f,i[A>>2]!=-1){for(e=f+12|0,i[e>>2]=r+12,k=f+8|0,i[k>>2]=e;e=i[A>>2],(e|0)==1;);e||(i[A>>2]=1,dl(k),i[A>>2]=-1)}return v=f+16|0,v=r+16|0,i[A+4>>2]-1|0}function K8(A,e){var r=0,f=0;r=v-16|0,v=r,l[A+11|0]>>>7|0&&$8(i[A>>2],1);i:if(l[e+11|0]>>>7|0)break i;i[A+8>>2]=i[e+8>>2],f=i[e+4>>2],i[A>>2]=i[e>>2],i[A+4>>2]=f,u[e+11|0]=l[e+11|0]&128,u[e+11|0]=l[e+11|0]&127,u[r+15|0]=0,u[e|0]=l[r+15|0],v=r+16|0}function pp(A,e,r){if(A=A|0,e=e|0,r=r|0,!r){e=i[23570],i[A>>2]=i[23569],i[A+4>>2]=e,i[A+8>>2]=i[23571];return}if(i[r>>2]>=6){e=i[24155],i[A>>2]=i[24154],i[A+4>>2]=e,i[A+8>>2]=i[24156];return}pu(r),i[A+8>>2]=i[24058],e=i[24057],i[A>>2]=i[24056],i[A+4>>2]=e}function yp(A,e,r,f,k){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0;var n=0,t=0;i:{for(;;){if((f|0)!=(k|0)){if(A=-1,(e|0)==(r|0)||(n=i[e>>2],t=i[f>>2],(n|0)<(t|0)))break i;if((n|0)>(t|0))return 1;f=f+4|0,e=e+4|0;continue}break}A=(e|0)!=(r|0)}return A|0}function SA(){var A=0;return A=p(68),i[A+24>>2]=0,g[A>>1]=8,i[A+4>>2]=0,i[A+8>>2]=0,i[A+44>>2]=0,i[A+48>>2]=0,u[A+40|0]=0,i[A+32>>2]=2,i[A+36>>2]=2,u[A+28|0]=1,i[A+12>>2]=0,i[A+16>>2]=0,g[A+20>>1]=0,i[A+52>>2]=0,i[A+56>>2]=0,i[A+60>>2]=0,i[A+64>>2]=0,A|0}function br(A,e,r,f){var k=0,n=0;return k=v-160|0,v=k,A=e?A:k+158|0,i[k+148>>2]=A,n=e-1|0,i[k+152>>2]=e>>>0>=n>>>0?n:0,o0(k,0,144),i[k+76>>2]=-1,i[k+36>>2]=1955,i[k+80>>2]=-1,i[k+44>>2]=k+159,i[k+84>>2]=k+148,u[A|0]=0,A=Ur(k,r,f,1953,1954),v=k+160|0,A}function vo(A,e,r){A=A|0,e=e|0,r=r|0;var f=0;f=v-16|0,v=f,g[f+8>>1]=i[r+4>>2],g[f+10>>1]=i[r+8>>2],g[f+12>>1]=i[r+12>>2],u[f+14|0]=l[r+16|0]!=0,e=i[e>>2],W[i[i[e>>2]+8>>2]](e,f+8|0),i[A+8>>2]=i[24058],e=i[24057],i[A>>2]=i[24056],i[A+4>>2]=e,v=f+16|0}function Ge(A){var e=0,r=0;return e=i[A+72>>2],i[A+72>>2]=e-1|e,i[A+20>>2]!=i[A+28>>2]&&W[i[A+36>>2]](A,0,0)|0,i[A+28>>2]=0,i[A+16>>2]=0,i[A+20>>2]=0,e=i[A>>2],e&4?(i[A>>2]=e|32,-1):(r=i[A+44>>2]+i[A+48>>2]|0,i[A+8>>2]=r,i[A+4>>2]=r,e<<27>>31)}function u8(A,e,r){var f=0,k=0,n=0,t=0;i[A+112>>2]=e,i[A+116>>2]=r,n=i[A+4>>2],f=i[A+44>>2]-n|0,i[A+120>>2]=f,i[A+124>>2]=f>>31,f=i[A+8>>2];i:{if(!(e|r)||(k=f-n|0,t=e>>>0>=k>>>0,k=k>>31,t&(k|0)<=(r|0)|(r|0)>(k|0)))break i;f=e+n|0}i[A+104>>2]=f}function i3(A,e,r){var f=0,k=0;if(i[A+8>>2]=0,i[A>>2]=0,i[A+4>>2]=0,f=i[e+104>>2],e=i[e+108>>2],(f|0)!=(e|0))for(;;){if(i[f+40>>2]==(r|0)){i:{if(u0[A+8>>2]>k>>>0){te(k,f),k=k+56|0;break i}k=nA(A,f)}i[A+4>>2]=k}if(f=f+56|0,(e|0)==(f|0))break}}function jA(A,e,r){var f=0;if(f=i[A+36>>2],!f){i[A+24>>2]=r,i[A+16>>2]=e,i[A+36>>2]=1,i[A+20>>2]=i[A+56>>2];return}i:{if(!(i[A+20>>2]!=i[A+56>>2]|i[A+16>>2]!=(e|0))){if(i[A+24>>2]!=2)break i;i[A+24>>2]=r;return}u[A+54|0]=1,i[A+24>>2]=2,i[A+36>>2]=f+1}}function mo(A){var e=0,r=0,f=0;if(r=v-16|0,v=r,l[108637]==1&&(i[r+4>>2]=i[A+4>>2],i[r>>2]=A,E8(33122,r)),e=i[A+4>>2],e){f=i[e>>2]-1|0,i[e>>2]=f;i:{if(f||(f=i[A>>2],f&&(Z(f),e=i[A+4>>2],!e)))break i;Z(e)}i[A>>2]=0,i[A+4>>2]=0}v=r+16|0}function Gi(A){var e=0,r=0,f=0,k=0,n=0;for(e=v-16|0,v=e,f=A+4|0,r=i[f>>2],i[e+12>>2]=r;;){i:{if((r|0)==-1){A=0;break i}if(k=i[f>>2],n=(k|0)==i[e+12>>2],i[f>>2]=n?r+1|0:k,n||(i[e+12>>2]=k),n)break i;r=i[e+12>>2];continue}break}return v=e+16|0,A}function Ep(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0;A=i[A>>2],f=i[A+160>>2],A=i[A+164>>2],A&&(i[A+4>>2]=i[A+4>>2]+1),!r|!f||(i[e>>2]=i[f+116>>2],k=1);i:{if(!A||(e=i[A+4>>2],i[A+4>>2]=e-1,e))break i;W[i[i[A>>2]+8>>2]](A),y(A)}return k|0}function Yp(A){A=A|0;var e=0;i:{if(e=i[A+12>>2],A=i[A+8>>2],e-A>>>0>524280)break i;if((A|0)==(e|0))return 0;for(;;){if(i[A>>2]-32768>>>0<4294901760|i[A+4>>2]-32768>>>0<=4294901759)break i;if(A=A+8|0,(e|0)==(A|0))break}return 0}return 1}function y0(A){A=A|0;var e=0,r=0;if(i[A>>2]=73028,i[A+28>>2]){for(e=i[A+40>>2];;){if(e){e=e-1|0,r=e<<2,W[i[i[A+32>>2]+r>>2]](0,A,i[r+i[A+36>>2]>>2]);continue}break}e2(A+28|0),Z(i[A+32>>2]),Z(i[A+36>>2]),Z(i[A+48>>2]),Z(i[A+60>>2])}return A|0}function Rp(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0;if(l2(e,l[A+4|0]?3:6),Z1(e,r,i[A+12>>2]-i[A+8>>2]>>3,0),f=i[A+8>>2],k=i[A+12>>2],(f|0)!=(k|0))for(;A=i[f>>2],Z1(e,r,A,A>>31),A=i[f+4>>2],Z1(e,r,A,A>>31),f=f+8|0,(k|0)!=(f|0););}function Zo(A){var e=0,r=0,f=0,k=0,n=0;if(f=i[A>>2],e=u[f|0]-48|0,e>>>0>9)return 0;for(;k=-1,r>>>0<=214748364&&(r=G(r,10),k=(r^2147483647)>>>0<e>>>0?-1:r+e|0),e=f+1|0,i[A>>2]=e,n=u[f+1|0],r=k,f=e,e=n-48|0,e>>>0<10;);return r}function Jp(A,e){A=A|0,e=e|0;var r=0;e=W0(e,86580,86624);i:{if(!e|l[A+104|0]!=l[e+104|0]|(i[A+112>>2]!=i[e+112>>2]|i[A+116>>2]!=i[e+116>>2]|i[A+120>>2]!=i[e+120>>2])||i[A+124>>2]!=i[e+124>>2])break i;r=l[A+128|0]==l[e+128|0]}return r|0}function Np(A,e){if(A=A|0,e=e|0,!e){e=i[23570],i[A>>2]=i[23569],i[A+4>>2]=e,i[A+8>>2]=i[23571];return}if(i[e>>2]>=6){e=i[24155],i[A>>2]=i[24154],i[A+4>>2]=e,i[A+8>>2]=i[24156];return}pu(e),i[A+8>>2]=i[24058],e=i[24057],i[A>>2]=i[24056],i[A+4>>2]=e}function Up(A,e,r,f,k,n,t,o){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,t=t|0,o=o|0,e=i[26922],i[A>>2]=i[26921],i[A+4>>2]=e,e=A+8|0;i:{if(u[107703]>=0){r=i[26924],i[e>>2]=i[26923],i[e+4>>2]=r,i[e+8>>2]=i[26925];break i}T(e,i[26923],i[26924])}u[A+20|0]=1}function Dp(A){A=A|0;var e=0,r=0,f=0;if(e=h2(21606),e>>>0<2147483640){i:{e:{if(e>>>0>=11){r=e|7,f=p(r+1|0),i[A+8>>2]=r-2147483647,i[A>>2]=f,i[A+4>>2]=e,A=f;break e}if(u[A+11|0]=e,!e)break i}if(!e)break i;x(A,21606,e)}u[A+e|0]=0;return}Q0(),H()}function Go(A){var e=0,r=0,f=0;A=i[A+48>>2],r=i[A+148>>2],e=i[A+152>>2],e&&(i[e+4>>2]=i[e+4>>2]+1),r?(A=i[r+128>>2],r=i[r+132>>2]):(A=0,r=0);i:{if(!e||(f=i[e+4>>2],i[e+4>>2]=f-1,f))break i;W[i[i[e>>2]+8>>2]](e),y(e)}return l0=r,A}function j0(A,e){var r=0,f=0,k=0;f=i[A+128>>2],r=255;i:{if(!f)break i;for(k=A+128|0,A=k;r=i[f+16>>2]<(e|0),A=r?A:f,f=i[(r?4:0)+f>>2],!!f;);if(r=255,(A|0)==(k|0)||(r=255,i[A+16>>2]>(e|0)))break i;r=l[A+24|0]}return r}function Xo(A,e){var r=0,f=0,k=0;if(M2(+A),f=t2(1)|0,k=t2(0)|0,r=f>>>20&2047,(r|0)!=2047){if(!r)return A==0?r=0:(A=Xo(A*18446744073709552e3,e),r=i[e>>2]+-64|0),i[e>>2]=r,A;i[e>>2]=r-1022,D2(0,k|0),D2(1,f&-2146435073|1071644672),A=+r1()}return A}function Mp(A,e,r,f){if(A=A|0,e=e|0,r=r|0,f=f|0,e=i[i[e+64>>2]+108>>2],i[f>>2]=e,i[r>>2]=e?0:2,e=i[26917],i[A>>2]=i[26916],i[A+4>>2]=e,A=A+8|0,u[107683]>=0){e=i[26919],i[A>>2]=i[26918],i[A+4>>2]=e,i[A+8>>2]=i[26920];return}T(A,i[26918],i[26919])}function Hp(A,e,r,f,k,n){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0;var t=0,o=0;return t=v-16|0,v=t,i[t+12>>2]=e,o=t+8|0,e=i[f+28>>2],i[o>>2]=e,(e|0)!=129576&&(i[e+4>>2]=i[e+4>>2]+1),e=c0(o,129760),e2(o),ml(A,n+24|0,t+12|0,r,k,e),v=t+16|0,i[t+12>>2]}function zp(A,e,r,f,k,n){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0;var t=0,o=0;return t=v-16|0,v=t,i[t+12>>2]=e,o=t+8|0,e=i[f+28>>2],i[o>>2]=e,(e|0)!=129576&&(i[e+4>>2]=i[e+4>>2]+1),e=c0(o,129760),e2(o),hl(A,n+16|0,t+12|0,r,k,e),v=t+16|0,i[t+12>>2]}function xp(A,e,r,f,k,n){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0;var t=0,o=0;return t=v-16|0,v=t,i[t+12>>2]=e,o=t+8|0,e=i[f+28>>2],i[o>>2]=e,(e|0)!=129576&&(i[e+4>>2]=i[e+4>>2]+1),e=c0(o,129752),e2(o),Zl(A,n+24|0,t+12|0,r,k,e),v=t+16|0,i[t+12>>2]}function Tp(A,e,r,f,k,n){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0;var t=0,o=0;return t=v-16|0,v=t,i[t+12>>2]=e,o=t+8|0,e=i[f+28>>2],i[o>>2]=e,(e|0)!=129576&&(i[e+4>>2]=i[e+4>>2]+1),e=c0(o,129752),e2(o),_l(A,n+16|0,t+12|0,r,k,e),v=t+16|0,i[t+12>>2]}function U6(A){A=A|0;var e=0,r=0;if(A){e=i[A+12>>2];i:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break i;W[i[i[e>>2]+8>>2]](e),y(e)}e=i[A+4>>2];i:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break i;W[i[i[e>>2]+8>>2]](e),y(e)}Z(A)}}function Sp(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0;f=p(20),i[f>>2]=0,i[f+4>>2]=0,i[f+16>>2]=0,i[f+8>>2]=0,i[f+12>>2]=0,i[A+8>>2]=i[26721],k=i[26720],i[A>>2]=i[26719],i[A+4>>2]=k,A=Vf(),i[f>>2]=A,Qe(A,7,1),Qe(A,8,1),u[f+4|0]=i[r+4>>2]!=0,i[e>>2]=f}function jp(A,e,r,f){if(A=A|0,e=e|0,r=r|0,f=f|0,e=l[i[e+64>>2]+121|0],i[f>>2]=e,i[r>>2]=e?0:2,e=i[26917],i[A>>2]=i[26916],i[A+4>>2]=e,A=A+8|0,u[107683]>=0){e=i[26919],i[A>>2]=i[26918],i[A+4>>2]=e,i[A+8>>2]=i[26920];return}T(A,i[26918],i[26919])}function Op(A,e,r,f){if(A=A|0,e=e|0,r=r|0,f=f|0,e=l[i[e+64>>2]+110|0],i[f>>2]=e,i[r>>2]=e?0:2,e=i[26917],i[A>>2]=i[26916],i[A+4>>2]=e,A=A+8|0,u[107683]>=0){e=i[26919],i[A>>2]=i[26918],i[A+4>>2]=e,i[A+8>>2]=i[26920];return}T(A,i[26918],i[26919])}function Pp(A,e){A=A|0,e=e|0;var r=0;e=W0(e,86580,86636);i:{if(!e|l[A+104|0]!=l[e+104|0]|(i[A+112>>2]!=i[e+112>>2]|i[A+116>>2]!=i[e+116>>2]|l[A+120|0]!=l[e+120|0])||l[A+121|0]!=l[e+121|0])break i;r=l[A+122|0]==l[e+122|0]}return r|0}function Lp(A){A=A|0;var e=0,r=0,f=0;if(i[A>>2]=106268,f=i[A+100>>2],f){if(e=f,r=i[A+104>>2],(e|0)!=(r|0)){for(;e=i[r-12>>2],e&&(i[r-8>>2]=e,Z(e)),r=r-16|0,(f|0)!=(r|0););e=i[A+100>>2]}i[A+104>>2]=f,Z(e)}return A2(A)|0}function Wo(A,e,r,f){var k=0,n=0,t=0;n=i[A+4>>2],t=n&1;i:{if(l[e+55|0]==1){if(k=n>>8,!t)break i;k=i[i[r>>2]+k>>2];break i}if(k=n>>8,!t)break i;i[e+56>>2]=i[i[A>>2]+4>>2],n=i[A+4>>2],r=0,k=0}A=i[A>>2],W[i[i[A>>2]+28>>2]](A,e,r+k|0,n&2?f:2)}function Kp(A){A=A|0;var e=0,r=0,f=0;if(i[A>>2]=87672,f=i[A+104>>2],f){if(e=f,r=i[A+108>>2],(e|0)!=(r|0)){for(;e=i[r-12>>2],e&&(i[r-8>>2]=e,Z(e)),r=r-16|0,(f|0)!=(r|0););e=i[A+104>>2]}i[A+108>>2]=f,Z(e)}return A2(A)|0}function _1(A){var e=0,r=0;i:{if(e=i[A+4>>2],r=i[i[e>>2]-12>>2],r=e+r|0,!i[r+24>>2]|(i[r+16>>2]|!(i[r+4>>2]&8192))||(e=i[(e+i[i[e>>2]-12>>2]|0)+24>>2],(W[i[i[e>>2]+24>>2]](e)|0)!=-1))break i;A=i[A+4>>2],m4(i[i[A>>2]-12>>2]+A|0,1)}}function Qo(A){var e=0,r=0;for(e=v-16|0,v=e,i[e+4>>2]=129584,r=i[32397],i[e+8>>2]=r,i[e+12>>2]=r+(A<<2),A=i[e+8>>2],r=i[e+12>>2];;){if((A|0)==(r|0))i[i[e+4>>2]+4>>2]=i[e+8>>2],v=e+16|0;else{i[A>>2]=0,A=A+4|0,i[e+8>>2]=A;continue}break}}function b4(A){A=A|0;var e=0,r=0;i[A>>2]=96976,e=i[A+60>>2],e&&W[i[i[A+56>>2]+24>>2]](e),e=i[A+20>>2],e&&(i[A+24>>2]=e,Z(e)),e=i[A+12>>2];i:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break i;W[i[i[e>>2]+8>>2]](e),y(e)}return A|0}function Xe(A,e){var r=0,f=0,k=0,n=0;return r=A*A,f=r*.5,k=1-f,n=1-k-f,f=r*r,k+(n+(r*(r*(r*(r*2480158728947673e-20+-.001388888888887411)+.0416666666666666)+f*f*(r*(r*-11359647557788195e-27+2087572321298175e-24)+-27557314351390663e-23))-A*e))}function qp(A,e,r,f,k,n){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0;var t=0;return A=v-16|0,v=A,i[A+12>>2]=e,t=A+8|0,e=i[f+28>>2],i[t>>2]=e,(e|0)!=129576&&(i[e+4>>2]=i[e+4>>2]+1),e=c0(t,129760),e2(t),Ul(n+20|0,A+12|0,r,k,e),v=A+16|0,i[A+12>>2]}function ap(A,e,r,f,k,n){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0;var t=0;return A=v-16|0,v=A,i[A+12>>2]=e,t=A+8|0,e=i[f+28>>2],i[t>>2]=e,(e|0)!=129576&&(i[e+4>>2]=i[e+4>>2]+1),e=c0(t,129752),e2(t),Nl(n+20|0,A+12|0,r,k,e),v=A+16|0,i[A+12>>2]}function $p(A,e){A=A|0,e=e|0;var r=0,f=0,k=0;r=i[A>>2],A=i[r+260>>2],f=i[r+264>>2];i:{if((A|0)==(f|0))break i;for(;;){if(r=i[A>>2],i[r>>2]!=(e|0)){if(A=A+8|0,(f|0)!=(A|0))continue;break i}break}k=u[r+39|0]<0?i[r+28>>2]:r+28|0}return k|0}function We(A){var e=0,r=0;if(e=v-16|0,v=e,i[(i[i[A>>2]-12>>2]+A|0)+24>>2]){G1(e+8|0,A);i:{if(!l[e+8|0]||(r=i[(i[i[A>>2]-12>>2]+A|0)+24>>2],(W[i[i[r>>2]+24>>2]](r)|0)!=-1))break i;m4(i[i[A>>2]-12>>2]+A|0,1)}_1(e+8|0)}v=e+16|0}function dp(A,e){A=A|0,e=e|0;var r=0,f=0,k=0;r=i[A>>2],A=i[r+260>>2],f=i[r+264>>2];i:{if((A|0)==(f|0))break i;for(;;){if(r=i[A>>2],i[r>>2]!=(e|0)){if(A=A+8|0,(f|0)!=(A|0))continue;break i}break}k=u[r+27|0]<0?i[r+16>>2]:r+16|0}return k|0}function d2(A,e){var r=0,f=0,k=0;if(r=h2(e),r>>>0<2147483640){i:{e:{if(r>>>0>=11){k=r|7,f=p(k+1|0),i[A+8>>2]=k-2147483647,i[A>>2]=f,i[A+4>>2]=r;break e}if(u[A+11|0]=r,f=A,!r)break i}if(!r)break i;x(f,e,r)}return u[r+f|0]=0,A}Q0(),H()}function cp(A){A=A|0;var e=0,r=0,f=0;if(i[A>>2]=106268,f=i[A+100>>2],f){if(e=f,r=i[A+104>>2],(e|0)!=(r|0)){for(;e=i[r-12>>2],e&&(i[r-8>>2]=e,Z(e)),r=r-16|0,(f|0)!=(r|0););e=i[A+100>>2]}i[A+104>>2]=f,Z(e)}Z(A2(A))}function bp(A,e){A=A|0,e=e|0;var r=0,f=0,k=0;r=i[A>>2],A=i[r+260>>2],f=i[r+264>>2];i:{if((A|0)==(f|0))break i;for(;;){if(r=i[A>>2],i[r>>2]!=(e|0)){if(A=A+8|0,(f|0)!=(A|0))continue;break i}break}k=u[r+15|0]<0?i[r+4>>2]:r+4|0}return k|0}function iy(A){A=A|0;var e=0,r=0,f=0;if(i[A>>2]=87672,f=i[A+104>>2],f){if(e=f,r=i[A+108>>2],(e|0)!=(r|0)){for(;e=i[r-12>>2],e&&(i[r-8>>2]=e,Z(e)),r=r-16|0,(f|0)!=(r|0););e=i[A+104>>2]}i[A+108>>2]=f,Z(e)}Z(A2(A))}function Xi(A,e,r){var f=0,k=0,n=0;f=v-16|0,v=f,k=r<<24|(r&65280)<<8|(r>>>8&65280|r>>>24),u[f+12|0]=k,u[f+13|0]=k>>>8,u[f+14|0]=k>>>16,u[f+15|0]=k>>>24,k=A+12|0,n=f+12|0,f=f+16|0,$4(k,i[A+16>>2],n,f,4),$4(k,i[A+16>>2],e,e+r|0,r),v=f}function u1(A,e){var r=0,f=0,k=0;f=A+128|0,A=i[A+128>>2];i:{e:{if(!A)break e;for(r=f;k=i[A+16>>2]<(e|0),r=k?r:A,A=i[(k?4:0)+A>>2],!!A;);if((r|0)==(f|0))break e;if(i[r+16>>2]<=(e|0))break i}r=f}return(r|0)!=(f|0)}function e3(A,e){var r=0,f=0,k=0;f=A+128|0,A=i[A+128>>2];i:{e:{if(!A)break e;for(r=f;k=u0[A+16>>2]<e>>>0,r=k?r:A,A=i[(k?4:0)+A>>2],!!A;);if((r|0)==(f|0))break e;if(u0[r+16>>2]<=e>>>0)break i}r=f}return(r|0)!=(f|0)}function go(A,e){var r=0,f=0,k=0;f=A+20|0,A=i[A+20>>2];i:{e:{if(!A)break e;for(r=f;k=u0[A+16>>2]<e>>>0,r=k?r:A,A=i[(k?4:0)+A>>2],!!A;);if((r|0)==(f|0))break e;if(u0[r+16>>2]<=e>>>0)break i}r=f}return(r|0)!=(f|0)}function O1(A,e,r){var f=0,k=0,n=0;k=v-16|0,v=k,f=i[A+4>>2],n=i[A+8>>2]&2147483647;i:{if(n>>>0>r>>>0){f=i[A>>2],i[A+4>>2]=r,A=!r,A|A||x(f,e,r),u[k+15|0]=0,u[r+f|0]=l[k+15|0];break i}Jr(A,n-1|0,(r-n|0)+1|0,f,0,f,r,e)}v=k+16|0}function ey(A,e){A=A|0,e=e|0;var r=0,f=0,k=0;r=i[A>>2],A=i[r+260>>2],f=i[r+264>>2];i:{if((A|0)==(f|0))break i;for(;;){if(r=i[A>>2],i[r>>2]!=(e|0)){if(A=A+8|0,(f|0)!=(A|0))continue;break i}break}k=i[r+44>>2]-i[r+40>>2]|0}return k|0}function ry(A,e){A=A|0,e=e|0;var r=0,f=0;r=W[i[i[A>>2]+68>>2]](i[A+4>>2])|0,A=i[r>>2];i:{if(!A)break i;for(;;){if(n4(i[A+4>>2],e)){if(A=i[r+4>>2],r=r+4|0,A)continue;break i}break}if(f=1,i[A>>2]<2)break i;f=i[A+36>>2]}return f|0}function z4(A,e,r){if(r=i[r+4>>2]&176,(r|0)==32)return e;i:{if((r|0)!=16)break i;e:{r:switch(r=l[A|0],r-43|0){case 0:case 2:break r;default:break e}return A+1|0}if((r|0)!=48|(e-A|0)<2|(l[A+1|0]|32)!=120)break i;A=A+2|0}return A}function l6(A,e,r){var f=0,k=0;i:{if(!f4(A,r)||(k=i[A>>2],f=i[A+4>>2],f&&(i[f+4>>2]=i[f+4>>2]+1),W[i[i[k>>2]+16>>2]](k,e,r)|0||i8(A),!f)||(A=i[f+4>>2],i[f+4>>2]=A-1,A))break i;W[i[i[f>>2]+8>>2]](f),y(f)}}function Vo(A,e){var r=0,f=0;if((A|0)!=(e|0)){if(r=u[e+11|0],u[A+11|0]>=0){if((r|0)>=0){r=i[e+4>>2],i[A>>2]=i[e>>2],i[A+4>>2]=r,i[A+8>>2]=i[e+8>>2];return}M1(A,i[e>>2],i[e+4>>2]);return}f=A,A=(r|0)<0,O1(f,A?i[e>>2]:e,A?i[e+4>>2]:r)}}function M1(A,e,r){var f=0,k=0,n=0;k=v-16|0,v=k,n=l[A+11|0],f=n&127;i:{if(r>>>0<=10){u[A+11|0]=n&128|r&127,u[A+11|0]=l[A+11|0]&127,f=!r,f|f||x(A,e,r),u[k+15|0]=0,u[A+r|0]=l[k+15|0];break i}Jr(A,10,r-10|0,f,0,f,r,e)}v=k+16|0}function fy(A,e,r){A=A|0,e=e|0,r=r|0;var f=0;i:{if(!l[A+44|0])for(r=(r|0)>0?r:0;;){if((r|0)==(f|0))break i;if((W[i[i[A>>2]+52>>2]](A,i[e>>2])|0)==-1)return f|0;e=e+4|0,f=f+1|0}r=P1(e,4,r,i[A+32>>2])}return r|0}function Ay(A,e,r){A=A|0,e=e|0,r=r|0;var f=0;if(!e){e=i[23570],i[A>>2]=i[23569],i[A+4>>2]=e,i[A+8>>2]=i[23571];return}if(f=i[i[e>>2]+60>>2],f){W[f|0](A,i[e+4>>2],r);return}e=i[24057],i[A>>2]=i[24056],i[A+4>>2]=e,i[A+8>>2]=i[24058]}function ky(A,e,r){A=A|0,e=e|0,r=r|0;var f=0;i:{if(!l[A+44|0])for(r=(r|0)>0?r:0;;){if((r|0)==(f|0))break i;if((W[i[i[A>>2]+52>>2]](A,l[e|0])|0)==-1)return f|0;e=e+1|0,f=f+1|0}r=P1(e,1,r,i[A+32>>2])}return r|0}function ny(A){A=A|0;var e=0,r=0;e=i[A>>2],A=i[e+244>>2],e=i[e+248>>2],e&&(i[e+4>>2]=i[e+4>>2]+1),A=A?i[A+104>>2]-i[A+100>>2]>>4:0;i:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break i;W[i[i[e>>2]+8>>2]](e),y(e)}return A|0}function Qe(A,e,r){A=A|0,e=e|0,r=r|0;i:switch(e|0){case 6:u[A+514|0]=(r|0)!=0;return;case 7:u[A+532|0]=(r|0)!=0;return;case 8:u[A+533|0]=(r|0)!=0;return;default:D0(12200,18332,535,9817),H();case 0:break i}u[A+512|0]=(r|0)!=0}function ty(A,e){A=A|0,e=e|0;var r=0,f=0;r=p(20),i[r>>2]=0,i[r+4>>2]=0,i[r+16>>2]=0,i[r+8>>2]=0,i[r+12>>2]=0,i[A+8>>2]=i[26721],f=i[26720],i[A>>2]=i[26719],i[A+4>>2]=f,A=Vf(),i[r>>2]=A,Qe(A,7,1),Qe(A,8,1),u[r+4|0]=0,i[e>>2]=r}function uy(A,e){A=A|0,e=e|0;var r=0,f=0,k=0,n=0,t=0;return r=v-16|0,v=r,k=r+4|0,W[i[A>>2]](k,e),e=u[r+15|0],n=(e|0)<0,A=n?i[r+8>>2]:e,f=y2(A+4|0),i[f>>2]=A,t=i[r+4>>2],A&&x(f+4|0,n?t:k,A),(e|0)<0&&Z(t),v=r+16|0,f|0}function Fo(A,e){var r=0,f=0,k=0;i[A+8>>2]=0,i[A>>2]=0,i[A+4>>2]=0;i:{if(r=i[e+4>>2],r){if(r>>>0>=1073741824)break i;r=r<<2,f=p(r),i[A+4>>2]=f,i[A>>2]=f,k=r+f|0,i[A+8>>2]=k,r&&x(f,i[e>>2],r),i[A+4>>2]=k}return A}G0(),H()}function oy(A,e){A=A|0,e=e|0;var r=0,f=0;i:{if(!A|!e||(r=i[A>>2],f=i[e>>2],(((r|0)<(f|0)?r:f)|0)!=1))break i;i[A+4>>2]=i[e+4>>2],i[A+8>>2]=i[e+8>>2],i[A+12>>2]=i[e+12>>2],i[A+16>>2]=i[e+16>>2],i[A+20>>2]=i[e+20>>2]}}function ge(A,e,r){var f=0,k=0,n=0,t=0;f=v-16|0,v=f,k=f+12|0,e=i[e+28>>2],i[k>>2]=e,(e|0)!=129576&&(i[e+4>>2]=i[e+4>>2]+1),e=c0(k,129824),n=r,t=W[i[i[e>>2]+16>>2]](e)|0,i[n>>2]=t,W[i[i[e>>2]+20>>2]](A,e),e2(k),v=f+16|0}function G2(A,e,r,f){var k=0,n=0,t=0,o=0;return n=e^f,t=n>>31,k=e>>31,A=A^k,o=A-k|0,k=(e^k)-((A>>>0<k>>>0)+k|0)|0,A=f>>31,e=r^A,n=n>>31,A=d8(o,k,e-A|0,(A^f)-((A>>>0>e>>>0)+A|0)|0)^n,e=A-n|0,l0=(t^l0)-((A>>>0<n>>>0)+t|0)|0,e}function Io(A){A=A|0;var e=0,r=0;e=i[A>>2],A=i[e+16>>2],e=i[e+20>>2],e&&(i[e+4>>2]=i[e+4>>2]+1),A=A?i[A+12>>2]-i[A+8>>2]|0:0;i:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break i;W[i[i[e>>2]+8>>2]](e),y(e)}return A|0}function Ve(A,e,r){var f=0,k=0,n=0,t=0;f=v-16|0,v=f,k=f+12|0,e=i[e+28>>2],i[k>>2]=e,(e|0)!=129576&&(i[e+4>>2]=i[e+4>>2]+1),e=c0(k,129816),n=r,t=W[i[i[e>>2]+16>>2]](e)|0,u[n|0]=t,W[i[i[e>>2]+20>>2]](A,e),e2(k),v=f+16|0}function OA(A,e,r,f,k,n){var t=0,o=0,s=0;if(r-1>>>0<=1){r=0,t=f>>>0<4?i[(f<<2)+50860>>2]:t,o=k,s=(t+A|0)-1>>>e8(t)|0,i[o>>2]=s,r=f>>>0<=3?i[(f<<2)+50876>>2]:r,o=n,s=(r+e|0)-1>>>e8(r)|0,i[o>>2]=s;return}i[k>>2]=A,i[n>>2]=e}function ly(A){A=A|0;var e=0,r=0,f=0;return e=v-16|0,v=e,i[e+12>>2]=i[A+8>>2],r=s8(e+8|0,e+12|0),f=mt(0,0,4),r=i[r>>2],r&&(i[31366]=(r|0)==-1?125344:r),v=e+16|0,f?-1:(A=i[A+8>>2],A?(il(A)|0)==1|0:1)}function PA(A){A=A|0;var e=0,r=0;i[A>>2]=95112,x2(i[A+64>>2]),l[A+80|0]!=1|u[A+79|0]>=0||Z(i[A+68>>2]),e=i[A+20>>2];i:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break i;W[i[i[e>>2]+8>>2]](e),y(e)}return A|0}function Co(A,e,r,f,k,n){var t=0,o=0,s=0;t=v-16|0,v=t,u[t+15|0]=0,u[t+14|0]=n,u[t+13|0]=k,u[t+12|0]=37,n&&(k=l[t+13|0],u[t+13|0]=l[t+14|0],u[t+14|0]=k),o=r,s=O7(e,i[r>>2]-e|0,t+12|0,f,i[A>>2])+e|0,i[o>>2]=s,v=t+16|0}function sy(A,e,r,f){if(A=A|0,e=e|0,r=r|0,f=f|0,i[r>>2]=0,i[f>>2]=3,e=i[26917],i[A>>2]=i[26916],i[A+4>>2]=e,A=A+8|0,u[107683]>=0){e=i[26919],i[A>>2]=i[26918],i[A+4>>2]=e,i[A+8>>2]=i[26920];return}T(A,i[26918],i[26919])}function wy(A){A=A|0;var e=0,r=0,f=0;if(e=i[A+12>>2],e){if(r=i[e>>2],r){if(f=r,A=i[e+4>>2],(r|0)!=(A|0)){for(;u[A-1|0]<0&&Z(i[A-12>>2]),A=A-20|0,(r|0)!=(A|0););f=i[e>>2]}i[e+4>>2]=r,Z(f)}Z(e)}}function hy(A,e,r,f){if(A=A|0,e=e|0,r=r|0,f=f|0,i[r>>2]=1,i[f>>2]=3,e=i[26917],i[A>>2]=i[26916],i[A+4>>2]=e,A=A+8|0,u[107683]>=0){e=i[26919],i[A>>2]=i[26918],i[A+4>>2]=e,i[A+8>>2]=i[26920];return}T(A,i[26918],i[26919])}function _y(A,e){A=A|0,e=e|0;var r=0,f=0,k=0;if(r=v-16|0,v=r,kt(r+4|0,i[A>>2]),f=i[r+4>>2],k=i[r+8>>2],(f|0)!=(k|0))for(A=f;i[e>>2]=i[A>>2],e=e+4|0,A=A+4|0,(k|0)!=(A|0););f&&Z(f),v=r+16|0}function By(A){A=A|0;var e=0,r=0,f=0,k=0,n=0,t=0;return e=v-16|0,v=e,k=e+4|0,W[A|0](k),r=u[e+15|0],n=(r|0)<0,A=n?i[e+8>>2]:r,f=y2(A+4|0),i[f>>2]=A,t=i[e+4>>2],A&&x(f+4|0,n?t:k,A),(r|0)<0&&Z(t),v=e+16|0,f|0}function vy(A,e){A=A|0,e=e|0;var r=0;if(r=i[e+456>>2],i[A>>2]=i[e+452>>2],i[A+4>>2]=r,A=A+8|0,u[e+471|0]>=0){e=e+460|0,r=i[e+4>>2],i[A>>2]=i[e>>2],i[A+4>>2]=r,i[A+8>>2]=i[e+8>>2];return}T(A,i[e+460>>2],i[e+464>>2])}function O0(A,e,r,f){var k=0,n=0,t=0,o=0,s=0,w=0;return k=r>>>16|0,n=A>>>16|0,w=G(k,n),t=r&65535,o=A&65535,s=G(t,o),n=(s>>>16|0)+G(n,t)|0,k=(n&65535)+G(k,o)|0,l0=(G(e,r)+w|0)+G(A,f)+(n>>>16)+(k>>>16)|0,s&65535|k<<16}function my(A){A=A|0;var e=0,r=0;i[A>>2]=95112,x2(i[A+64>>2]),l[A+80|0]!=1|u[A+79|0]>=0||Z(i[A+68>>2]),e=i[A+20>>2];i:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break i;W[i[i[e>>2]+8>>2]](e),y(e)}Z(A)}function po(A,e,r,f){var k=0;if(e-1>>>0>1)return A;e=0,e=r>>>0<=3?i[(r<<2)+50860>>2]:e;i:switch(f|0){case 1:return(A+e|0)-1>>>e8(e)|0;case 0:return A>>>e8(e)|0;case 2:k=A>>>e8(e)|0;break;default:break i}return k}function yo(A,e,r,f){var k=0;if(e-1>>>0>1)return A;e=0,e=r>>>0<=3?i[(r<<2)+50876>>2]:e;i:switch(f|0){case 1:return(A+e|0)-1>>>e8(e)|0;case 0:return A>>>e8(e)|0;case 2:k=A>>>e8(e)|0;break;default:break i}return k}function LA(A){A=A|0;var e=0,r=0,f=0,k=0;return f=n6(A),k=W[i[A+12>>2]](A)|0,u[A|0]&1||(e=i[A+56>>2],r=i[A+52>>2],r&&(i[r+56>>2]=e),e&&(i[e+52>>2]=r),i[31327]==(A|0)&&(i[31327]=e),Z(i[A+96>>2]),Z(A)),f|k}function Zy(A,e){A=A|0,e=e|0;var r=0,f=0,k=0;r=v-16|0,v=r,f=i[e+56>>2];i:{if(i[f>>2]>=5){k=r+4|0,W[i[f+64>>2]](k,i[e+60>>2]),nr(A,k);break i}i[A>>2]=0,i[A+4>>2]=0,i[A+16>>2]=0,i[A+8>>2]=0,i[A+12>>2]=0}v=r+16|0}function Gy(A,e){A=A|0,e=e|0;var r=0;r=i[e>>2],e=i[e+4>>2],e&&(i[e+4>>2]=i[e+4>>2]+1),i[A+16>>2]=r,r=i[A+20>>2],i[A+20>>2]=e;i:{if(!r||(A=i[r+4>>2],i[r+4>>2]=A-1,A))break i;W[i[i[r>>2]+8>>2]](r),y(r)}}function Xy(){var A=0;return A=p(40),i[A>>2]=0,i[A+4>>2]=0,i[A+16>>2]=0,i[A+20>>2]=0,i[A+8>>2]=0,i[A+12>>2]=0,i[A+32>>2]=0,i[A+36>>2]=1,i[A+24>>2]=1,i[A+28>>2]=0,u[A|0]=2,i[A+16>>2]=2,i[A+12>>2]=2,u[A+8|0]=1,A|0}function Wy(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0;if(k=i[e+12>>2],i[e+12>>2]=i[A+124>>2],f=i[A+104>>2],A=i[A+108>>2],(f|0)!=(A|0))for(;F0(e,i[f>>2]+r|0),f=f+4|0,(A|0)!=(f|0););i[e+12>>2]=k}function Qy(A,e){A=A|0,e=e|0;var r=0,f=0,k=0;i:{if((e|0)<16||(e=l[A+12|0],!e)||(r=l[A+13|0],!r)||(f=l[A+14|0],!f)||(A=l[A+15|0],!A))break i;k=A|(r<<16|e<<24|f<<8)}return k|0}function gy(A,e){A=A|0,e=e|0;var r=0,f=0,k=0,n=0,t=0;A=i[A>>2],r=i[A+44>>2],f=i[A+48>>2],k=i[A+36>>2],n=i[A+40>>2],t=i[A+56>>2],i[e+16>>2]=i[A+52>>2],i[e+20>>2]=t,i[e+8>>2]=r,i[e+12>>2]=f,i[e>>2]=k,i[e+4>>2]=n}function Eo(A){var e=0,r=0;e=i[A+48>>2],A=i[e+148>>2],e=i[e+152>>2],e&&(i[e+4>>2]=i[e+4>>2]+1),A=A?i[A+120>>2]:0;i:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break i;W[i[i[e>>2]+8>>2]](e),y(e)}return A}function KA(A,e){var r=0,f=0,k=0;i[A+8>>2]=0,i[A>>2]=0,i[A+4>>2]=0;i:{if(r=i[e+4>>2],r){if((r|0)<0)break i;f=p(r),i[A+4>>2]=f,i[A>>2]=f,k=r+f|0,i[A+8>>2]=k,r&&x(f,i[e>>2],r),i[A+4>>2]=k}return A}G0(),H()}function Yo(A,e){A=A|0,e=e|0;var r=0,f=0,k=0;i:{if((e|0)<12||(e=l[A+8|0],!e)||(r=l[A+9|0],!r)||(f=l[A+10|0],!f)||(A=l[A+11|0],!A))break i;k=A|(r<<16|e<<24|f<<8)}return k|0}function D6(A,e){var r=0,f=0;r=i[e+4>>2],i[A>>2]=i[e>>2],i[A+4>>2]=r,r=A+8|0;i:{if(u[e+19|0]>=0){f=i[e+12>>2],i[r>>2]=i[e+8>>2],i[r+4>>2]=f,i[r+8>>2]=i[e+16>>2];break i}T(r,i[e+8>>2],i[e+12>>2])}u[A+20|0]=1}function k8(A,e){var r=0,f=0;return r=i[e+4>>2],i[A>>2]=i[e>>2],i[A+4>>2]=r,r=A+8|0,u[e+19|0]>=0?(e=e+8|0,f=i[e+4>>2],i[r>>2]=i[e>>2],i[r+4>>2]=f,i[r+8>>2]=i[e+8>>2],A):(T(r,i[e+8>>2],i[e+12>>2]),A)}function o8(A,e){var r=0,f=0,k=0;if(r=i[A+128>>2],!r)return 0;for(f=A+128|0,A=f;k=i[r+16>>2]<(e|0),A=k?A:r,r=i[(k?4:0)+r>>2],!!r;);return r=0,(A|0)==(f|0)|i[A+16>>2]>(e|0)?r:i[A+28>>2]}function l8(A,e){var r=0,f=0,k=0;if(r=i[A+128>>2],!r)return 0;for(f=A+128|0,A=f;k=i[r+16>>2]<(e|0),A=k?A:r,r=i[(k?4:0)+r>>2],!!r;);return r=0,(A|0)==(f|0)|i[A+16>>2]>(e|0)?r:i[A+32>>2]}function Vy(A,e,r){if(A=A|0,e=e|0,r=r|0,I4(r,e+8|0),e=i[26917],i[A>>2]=i[26916],i[A+4>>2]=e,A=A+8|0,u[107683]>=0){e=i[26919],i[A>>2]=i[26918],i[A+4>>2]=e,i[A+8>>2]=i[26920];return}T(A,i[26918],i[26919])}function qA(A){A=A|0;var e=0,r=0,f=0;return A=i[A>>2],e=i[A+48>>2],A=i[A+52>>2],A?(r=i[A+4>>2],f=r+1|0,i[A+4>>2]=f,e=i[e+132>>2],i[A+4>>2]=r,f||(W[i[i[A>>2]+8>>2]](A),y(A)),e|0):i[e+132>>2]}function Fy(A,e,r){if(A=A|0,e=e|0,r=r|0,I4(r,e+4|0),e=i[26917],i[A>>2]=i[26916],i[A+4>>2]=e,A=A+8|0,u[107683]>=0){e=i[26919],i[A>>2]=i[26918],i[A+4>>2]=e,i[A+8>>2]=i[26920];return}T(A,i[26918],i[26919])}function Iy(A,e){A=A|0,e=e|0;var r=0;r=i[e+4>>2],i[A+36>>2]=i[e>>2],i[A+40>>2]=r,r=i[e+12>>2],i[A+44>>2]=i[e+8>>2],i[A+48>>2]=r,r=i[e+20>>2],i[A+52>>2]=i[e+16>>2],i[A+56>>2]=r,l[A+60|0]||(u[A+60|0]=1)}function Cy(A,e,r){if(A=A|0,e=e|0,r=r|0,i[e+8>>2]!=3){e=i[24203],i[A>>2]=i[24202],i[A+4>>2]=e,i[A+8>>2]=i[24204];return}r&&(i[r>>2]=i[e+16>>2]),e=i[24057],i[A>>2]=i[24056],i[A+4>>2]=e,i[A+8>>2]=i[24058]}function py(A,e){A=A|0,e=e|0;var r=0;r=C[e>>1]|C[e+2>>1]<<16,g[A+6>>1]=r,g[A+8>>1]=r>>>16,e=l[e+3|0]|l[e+4|0]<<8|(l[e+5|0]<<16|l[e+6|0]<<24),u[A+9|0]=e,u[A+10|0]=e>>>8,u[A+11|0]=e>>>16,u[A+12|0]=e>>>24}function Ro(A,e){A=A|0,e=e|0;var r=0;return A=i[A>>2],r=i[A+48>>2],A=i[A+52>>2],A?(i[A+4>>2]=i[A+4>>2]+1,e=J6(r,e),r=i[A+4>>2],i[A+4>>2]=r-1,r||(W[i[i[A>>2]+8>>2]](A),y(A)),e|0):J6(r,e)|0}function Jo(A,e,r){A=A|0,e=e|0,r=r|0;var f=0;if(e>>>0<3)return f=i[((e<<2)+A|0)+64>>2],r&&(i[r>>2]=G(i[(e?44:40)+A>>2],(i[i[A+124>>2]+(e?16840:16832)>>2]+7|0)/8|0)),f|0;D0(21642,18332,671,12869),H()}function yy(A,e,r,f){if(A=A|0,e=e|0,r=r|0,f=f|0,e=i[26917],i[A>>2]=i[26916],i[A+4>>2]=e,A=A+8|0,u[107683]>=0){e=i[26919],i[A>>2]=i[26918],i[A+4>>2]=e,i[A+8>>2]=i[26920];return}T(A,i[26918],i[26919])}function w4(A,e,r,f,k){var n=0;if(n=v-256|0,v=n,!(k&73728|(r|0)<=(f|0))){if(f=r-f|0,r=f>>>0<256,Ae(n,e,r?f:256),!r)for(;t4(A,n,256),f=f-256|0,f>>>0>255;);t4(A,n,f)}v=n+256|0}function Ey(A,e){A=A|0,e=e|0;var r=0,f=0;e=c0(e,129768),i[A+36>>2]=e,r=A,f=W[i[i[e>>2]+24>>2]](e)|0,i[r+44>>2]=f,e=i[A+36>>2],r=A,f=W[i[i[e>>2]+28>>2]](e)|0,u[r+53|0]=f,i[A+44>>2]>=9&&(g1(),H())}function Yy(A,e){A=A|0,e=e|0;var r=0,f=0;e=c0(e,129776),i[A+36>>2]=e,r=A,f=W[i[i[e>>2]+24>>2]](e)|0,i[r+44>>2]=f,e=i[A+36>>2],r=A,f=W[i[i[e>>2]+28>>2]](e)|0,u[r+53|0]=f,i[A+44>>2]>=9&&(g1(),H())}function No(A,e){var r=0,f=0;if(r=i[A+8>>2],A=i[A+12>>2],(r|0)!=(A|0))for(A=A-r>>2,f=A>>>0<=1?1:A,A=0;;){if(i[i[(A<<2)+r>>2]>>2]==(e|0))return A;if(A=A+1|0,(f|0)==(A|0))break}return-1}function aA(A,e){var r=0,f=0;r=v-16|0,v=r,Z8(r+8|0,A,e),e=i[i[r+8>>2]+104>>2],A=i[r+12>>2];i:{if(!A||(f=i[A+4>>2],i[A+4>>2]=f-1,f))break i;W[i[i[A>>2]+8>>2]](A),y(A)}return v=r+16|0,e}function Ry(A){A=A|0;var e=0,r=0,f=0;e=v-16|0,v=e,Rr(e+4|0,A,0),r=i[e+8>>2],A=i[e+4>>2];i:{e:{if((r|0)!=(A|0)){f=i[i[A>>2]>>2];break e}if(!r)break i}i[e+8>>2]=A,Z(A)}return v=e+16|0,(f|0)!=0|0}function Uo(A,e,r){var f=0,k=0,n=0;f=v-16|0,v=f,n=i[A+48>>2],A=p(4),i[f+4>>2]=A,k=A+4|0,i[f+12>>2]=k,i[A>>2]=r,i[f+8>>2]=k,a4(n,e,1835103083,f+4|0),A=i[f+4>>2],A&&(i[f+8>>2]=A,Z(A)),v=f+16|0}function r3(A,e){var r=0;r=i[e>>2],e=i[e+4>>2],e&&(i[e+4>>2]=i[e+4>>2]+1),i[A>>2]=r,r=i[A+4>>2],i[A+4>>2]=e;i:{if(!r||(A=i[r+4>>2],i[r+4>>2]=A-1,A))break i;W[i[i[r>>2]+8>>2]](r),y(r)}}function M6(){var A=0;return A=p(36),g[A+2>>1]=0,g[A+4>>1]=0,g[A>>1]=263,u[A+32|0]=1,u[A+28|0]=0,i[A+20>>2]=2,i[A+24>>2]=2,u[A+16|0]=1,i[A+12>>2]=1,u[A+5|0]=0,u[A+6|0]=0,u[A+7|0]=0,u[A+8|0]=0,A|0}function Fe(A,e){var r=0,f=0;return r=v-16|0,v=r,f=r+12|0,A=i[A+28>>2],i[f>>2]=A,(A|0)!=129576&&(i[A+4>>2]=i[A+4>>2]+1),A=c0(f,129752),W[i[i[A>>2]+48>>2]](A,77744,77770,e)|0,e2(f),v=r+16|0,e}function Jy(A){A=A|0;var e=0,r=0,f=0,k=0;i:{if(!A||(e=l[A|0],!e)||(r=l[A+1|0],!r)||(f=l[A+2|0],!f)||(A=l[A+3|0],!A))break i;k=A|(r<<16|e<<24|f<<8)}return k|0}function p8(A,e){var r=0,f=0;r=i[e>>2],f=i[e+4>>2],i[e>>2]=0,i[e+4>>2]=0,e=i[A+4>>2],i[A>>2]=r,i[A+4>>2]=f;i:{if(!e||(A=i[e+4>>2],i[e+4>>2]=A-1,A))break i;W[i[i[e>>2]+8>>2]](e),y(e)}}function Ny(A,e){A=A|0,e=e|0;var r=0;r=i[e+4>>2],A=i[A>>2],i[A>>2]=i[e>>2],i[A+4>>2]=r,i[A+16>>2]=i[e+16>>2],r=i[e+12>>2],i[A+8>>2]=i[e+8>>2],i[A+12>>2]=r,i[e+16>>2]=0,i[e+8>>2]=0,i[e+12>>2]=0}function Do(A){A=A|0;var e=0,r=0;i:{if(i[A+2192>>2]<=0||(e=i[A+2188>>2],e=i[i[i[A+2176>>2]+(e>>>8&16777212)>>2]+((e&1023)<<2)>>2],!e))break i;u[e+104|0]=0,Lo(A+2140|0),r=e}return r|0}function $A(A,e){var r=0,f=0;f=v-16|0,v=f,u[A|0]=0,r=i[i[e>>2]-12>>2]+e|0;i:{if(!i[r+16>>2]){i[r+72>>2]&&We(i[r+72>>2]),u[A|0]=!i[(i[i[e>>2]-12>>2]+e|0)+16>>2];break i}m4(r,4)}v=f+16|0}function Mo(A,e){var r=0,f=0;i:{if(r=i[A>>2],!r)break i;f=i[r+24>>2];e:{if((f|0)==i[r+28>>2]){e=W[i[i[r>>2]+52>>2]](r,e)|0;break e}i[r+24>>2]=f+4,i[f>>2]=e}if((e|0)!=-1)break i;i[A>>2]=0}}function Ho(A,e,r,f){i:{if(!A)break i;e:switch(e+2|0){case 0:u[A|0]=r;return;case 1:g[A>>1]=r;return;case 2:case 3:i[A>>2]=r;return;case 5:break e;default:break i}i[A>>2]=r,i[A+4>>2]=f}}function dA(A){var e=0;return e=i[A+72>>2],i[A+72>>2]=e-1|e,e=i[A>>2],e&8?(i[A>>2]=e|32,-1):(i[A+4>>2]=0,i[A+8>>2]=0,e=i[A+44>>2],i[A+28>>2]=e,i[A+20>>2]=e,i[A+16>>2]=e+i[A+48>>2],0)}function cA(A,e,r,f,k,n,t,o,s){var w=0;w=v-16|0,v=w,y4(w,e,r,f,k,n,t,o,s^-2147483648),f=i[w>>2],r=i[w+4>>2],e=i[w+12>>2],i[A+8>>2]=i[w+8>>2],i[A+12>>2]=e,i[A>>2]=f,i[A+4>>2]=r,v=w+16|0}function Uy(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0;return f=i[A+36>>2],k=i[A+32>>2],(r|0)==(f|0)&k>>>0>=e>>>0|r>>>0<f>>>0&&(i[A+40>>2]=e,i[A+44>>2]=r),(r|0)==(f|0)&e>>>0<=k>>>0|r>>>0<f>>>0}function Dy(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0,n=0;return k=i[A+84>>2],f=r+256|0,n=wA(k,0,f),f=n?n-k|0:f,r=r>>>0>f>>>0?f:r,A8(e,k,r),e=k+f|0,i[A+84>>2]=e,i[A+8>>2]=e,i[A+4>>2]=r+k,r|0}function n4(A,e){var r=0,f=0;r=l[A|0],f=l[e|0];i:{if(!r|(r|0)!=(f|0))break i;for(;;){if(f=l[e+1|0],r=l[A+1|0],!r)break i;if(e=e+1|0,A=A+1|0,(r|0)!=(f|0))break}}return r-f|0}function My(A,e,r,f,k,n){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0;var t=0,o=0;return t=v-16|0,v=t,i[t+8>>2]=624576549,i[t+12>>2]=1394948685,o=A,A=t+16|0,e=x8(o,e,r,f,k,n,t+8|0,A),v=A,e|0}function zo(A,e){if(A=A|0,e=e|0,e=i[26917],i[A>>2]=i[26916],i[A+4>>2]=e,A=A+8|0,u[107683]>=0){e=i[26919],i[A>>2]=i[26918],i[A+4>>2]=e,i[A+8>>2]=i[26920];return}T(A,i[26918],i[26919])}function xo(A,e){var r=0;i:{if(!e||(e=W0(e,84888,85132),!e|i[e+8>>2]&(i[A+8>>2]^-1))||!S1(i[A+12>>2],i[e+12>>2],0))break i;r=S1(i[A+16>>2],i[e+16>>2],0)}return r}function To(A,e){var r=0,f=0;f=v-32|0,v=f,r=i[e+40>>2];i:{if(!r){i[A>>2]=0,i[A+4>>2]=0;break i}if(i[A>>2]=r,r=A,A=i[e+44>>2],i[r+4>>2]=A,!A)break i;i[A+4>>2]=i[A+4>>2]+1}v=f+32|0}function Hy(A){return A=A|0,i[A>>2]=87284,u[A+163|0]<0&&Z(i[A+152>>2]),u[A+151|0]<0&&Z(i[A+140>>2]),u[A+139|0]<0&&Z(i[A+128>>2]),u[A+127|0]<0&&Z(i[A+116>>2]),A2(A)|0}function s6(A){var e=0,r=0;return l[A+11|0]>>>7|0?e=i[A>>2]:e=A,l[A+11|0]>>>7|0?r=i[A+4>>2]:r=l[A+11|0]&127,A=v-16|0,v=A,i[A+12>>2]=(r<<2)+e,v=A+16|0,i[A+12>>2]}function zy(A,e,r,f,k){return A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,A=v-16|0,v=A,i[A+12>>2]=k,i[A+8>>2]=f-r,e=v-16|0,v=e,v=e+16|0,v=A+16|0,e=A+8|0,A=A+12|0,i[(u0[e>>2]<u0[A>>2]?e:A)>>2]}function xy(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0;return f=i[A+36>>2],k=i[A+32>>2],(r|0)==(f|0)&k>>>0>=e>>>0|r>>>0<f>>>0&&YA(i[A+24>>2],e,r,0),(r|0)==(f|0)&e>>>0<=k>>>0|r>>>0<f>>>0}function Ty(A,e,r,f){if(A=A|0,e=e|0,r=r|0,f=f|0,!(f&&r)){e=i[23570],i[A>>2]=i[23569],i[A+4>>2]=e,i[A+8>>2]=i[23571];return}e=p(8),r=i[r>>2],i[e+4>>2]=0,i[e>>2]=r,i[f>>2]=e,w5(A,e)}function Sy(A){return A=A|0,i[A>>2]=89296,u[A+151|0]<0&&Z(i[A+140>>2]),u[A+139|0]<0&&Z(i[A+128>>2]),u[A+127|0]<0&&Z(i[A+116>>2]),u[A+115|0]<0&&Z(i[A+104>>2]),A2(A)|0}function H6(A){A=A|0;var e=0;return e=i[18051],i[A>>2]=e,i[i[e-12>>2]+A>>2]=i[18059],i[A+12>>2]=71232,i[A+8>>2]=i[18060],u[A+55|0]<0&&Z(i[A+44>>2]),E0(A+12|0),y0(A- -64|0),A|0}function jy(A,e,r,f){for(A=A|0,e=e|0,r=r|0,f=f|0;;){if((e|0)!=(r|0)){A=i[e>>2],A>>>0<=127?A=i[(A<<2)+78064>>2]:A=0,i[f>>2]=A,f=f+4|0,e=e+4|0;continue}break}return e|0}function Wi(A){var e=0,r=0;e=i[26873],r=A+7&-8,A=e+r|0;i:{if(!(A>>>0<=e>>>0&&r)&&(A>>>0<=Aw()<<16>>>0||p_(A|0)|0))break i;return i[31324]=48,-1}return i[26873]=A,e}function Oy(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0;var k=0;k=v-32|0,v=k,z2(k+12|0,e,r),u[k+31|0]<0&&Z(i[k+20>>2]);i:{if(l[e+97|0]){t1(A,e,18400);break i}d6(A,e,r,-1,f)}v=k+32|0}function f3(A,e,r,f){var k=0;return k=v-16|0,v=k,r=R6(i[A+52>>2],r),A=i[A+60>>2],r=r+1|0,g[k+14>>1]=r,u[k+12|0]=f,i[k+8>>2]=C[k+12>>1]|C[k+14>>1]<<16,C6(A,e,k+8|0),v=k+16|0,r}function Py(A){A=A|0,i[A>>2]=87284,u[A+163|0]<0&&Z(i[A+152>>2]),u[A+151|0]<0&&Z(i[A+140>>2]),u[A+139|0]<0&&Z(i[A+128>>2]),u[A+127|0]<0&&Z(i[A+116>>2]),Z(A2(A))}function w6(A){var e=0,r=0;return l[A+11|0]>>>7|0?e=i[A>>2]:e=A,l[A+11|0]>>>7|0?r=i[A+4>>2]:r=l[A+11|0]&127,A=v-16|0,v=A,i[A+12>>2]=e+r,v=A+16|0,i[A+12>>2]}function Ly(A){A=A|0,i[A>>2]=89296,u[A+151|0]<0&&Z(i[A+140>>2]),u[A+139|0]<0&&Z(i[A+128>>2]),u[A+127|0]<0&&Z(i[A+116>>2]),u[A+115|0]<0&&Z(i[A+104>>2]),Z(A2(A))}function Ie(A,e){var r=0;r=i[A+136>>2];i:{if(r){A=i[r>>2];break i}r=p(16),i[r+12>>2]=0,i[r+4>>2]=0,i[r+8>>2]=0,i[r>>2]=95064,i[A+136>>2]=r,A=95064}return W[i[A+8>>2]](r,e)|0}function So(A){var e=0,r=0;if(e=i[A>>2],e){r=i[e+12>>2];i:{if((r|0)==i[e+16>>2]){e=W[i[i[e>>2]+36>>2]](e)|0;break i}e=i[r>>2]}if((e|0)!=-1)return!i[A>>2];i[A>>2]=0}return 1}function h4(A,e,r,f,k){var n=0;return n=v-16|0,v=n,i[n+12>>2]=r,i[n+8>>2]=k,r=s8(n+4|0,n+12|0),e=br(A,e,f,i[n+8>>2]),A=i[r>>2],A&&(i[31366]=(A|0)==-1?125344:A),v=n+16|0,e}function jo(A){var e=0,r=0;if(e=i[A>>2],e){r=i[e+12>>2];i:{if((r|0)==i[e+16>>2]){e=W[i[i[e>>2]+36>>2]](e)|0;break i}e=l[r|0]}if((e|0)!=-1)return!i[A>>2];i[A>>2]=0}return 1}function Ky(A,e,r,f){for(A=A|0,e=e|0,r=r|0,f=f|0;;){i:{if((r|0)==(f|0)||(A=i[r>>2],i[(A<<2)+78064>>2]&e&&A>>>0<=127))break i;r=r+4|0;continue}break}return r|0}function qy(A,e,r,f){for(A=A|0,e=e|0,r=r|0,f=f|0;;){i:{if((r|0)==(f|0)||(A=i[r>>2],A>>>0>127|!(i[(A<<2)+78064>>2]&e)))break i;r=r+4|0;continue}break}return r|0}function ay(A,e,r){A=A|0,e=e|0,r=r|0;var f=0;l2(e,5),f=i[A+4>>2],Z1(e,r,f,f>>31),f=i[A+8>>2],Z1(e,r,f,f>>31),Z1(e,r,i[A+12>>2],0),Z1(e,r,i[A+16>>2],0),l2(e,0),I4(e,A+20|0)}function Oo(A,e,r){var f=0;return f=v-16|0,v=f,i[f+12>>2]=e,i[f+8>>2]=r,e=s8(f+4|0,f+12|0),r=U7(A,7929,i[f+8>>2]),A=i[e>>2],A&&(i[31366]=(A|0)==-1?125344:A),v=f+16|0,r}function bA(A,e){var r=0,f=0;r=v-16|0,v=r;i:{if(!(l[e+11|0]>>>7|0)){i[A+8>>2]=i[e+8>>2],f=i[e+4>>2],i[A>>2]=i[e>>2],i[A+4>>2]=f;break i}T(A,i[e>>2],i[e+4>>2])}v=r+16|0}function A3(A,e){A=A|0,e=e|0;var r=0;!l[A|0]|!l[e|0]||(r=i[e+12>>2],i[A+8>>2]=i[e+8>>2],i[A+12>>2]=r,i[A+16>>2]=i[e+16>>2],i[A+20>>2]=i[e+20>>2],u[A+24|0]=l[e+24|0])}function Po(){var A=0,e=0;return A=v-16|0,v=A,i[A+12>>2]=1073741823,i[A+8>>2]=2147483647,e=v-16|0,v=e,v=e+16|0,v=A+16|0,e=A+8|0,A=A+12|0,i[(u0[e>>2]<u0[A>>2]?e:A)>>2]}function q(A,e,r,f){return i[A+4>>2]=r,i[A>>2]=e,e=A+8|0,u[f+11|0]>=0?(r=i[f+4>>2],i[e>>2]=i[f>>2],i[e+4>>2]=r,i[e+8>>2]=i[f+8>>2],A):(T(e,i[f>>2],i[f+4>>2]),A)}function $y(A,e){A=A|0,e=e|0;var r=0,f=0;i:{e:{if((e|0)>0){for(;;)if(f=i[((r<<4)+A|0)+8>>2],f&&Z(f),r=r+1|0,(r|0)==(e|0))break e}if(!A)break i}Z(A)}}function k3(A,e){var r=0;if(e){k3(A,i[e>>2]),k3(A,i[e+4>>2]),A=i[e+24>>2];i:{if(!A||(r=i[A+4>>2],i[A+4>>2]=r-1,r))break i;W[i[i[A>>2]+8>>2]](A),y(A)}Z(e)}}function n3(A,e){var r=0;if(e){n3(A,i[e>>2]),n3(A,i[e+4>>2]),A=i[e+24>>2];i:{if(!A||(r=i[A+4>>2],i[A+4>>2]=r-1,r))break i;W[i[i[A>>2]+8>>2]](A),y(A)}Z(e)}}function Ce(A,e){var r=0;if(e){Ce(A,i[e>>2]),Ce(A,i[e+4>>2]),A=i[e+24>>2];i:{if(!A||(r=i[A+4>>2],i[A+4>>2]=r-1,r))break i;W[i[i[A>>2]+8>>2]](A),y(A)}Z(e)}}function Qi(A,e){A=A|0,e=e|0;var r=0;!l[A|0]|!l[e|0]||(r=i[e+12>>2],i[A+8>>2]=i[e+8>>2],i[A+12>>2]=r,u[A+16|0]=l[e+16|0],u[A+18|0]=l[e+18|0],u[A+17|0]=l[e+17|0])}function dy(A,e){A=A|0,e=e|0,A=i[e+12>>2],A&&(i[e+16>>2]=A,Z(A)),A=i[e+4>>2];i:{if(!A||(e=i[A+4>>2],i[A+4>>2]=e-1,e))break i;W[i[i[A>>2]+8>>2]](A),y(A)}}function Lo(A){var e=0;i[A+52>>2]=i[A+52>>2]-1,e=i[A+48>>2]+1|0,i[A+48>>2]=e,e>>>0>=2048&&(Z(i[i[A+36>>2]>>2]),i[A+36>>2]=i[A+36>>2]+4,i[A+48>>2]=i[A+48>>2]-1024)}function Ko(A,e,r){var f=0;if(W[i[i[A>>2]+28>>2]](A,e,r),f=i[A+36>>2],A=i[A+40>>2],(f|0)!=(A|0))for(;Ko(i[f>>2],e,r),f=f+8|0,(A|0)!=(f|0););}function qo(A,e){var r=0,f=0;return i[A>>2]=85840,i[A>>2]=85952,r=h2(e),f=p(r+13|0),i[f+8>>2]=0,i[f+4>>2]=r,i[f>>2]=r,f=f+12|0,r=r+1|0,r&&x(f,e,r),i[A+4>>2]=f,A}function cy(A){A=A|0;var e=0,r=0;i[A>>2]=95408,e=i[A+104>>2];i:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break i;W[i[i[e>>2]+8>>2]](e),y(e)}return A2(A)|0}function by(A){A=A|0;var e=0,r=0;i[A>>2]=100192,e=i[A+68>>2];i:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break i;W[i[i[e>>2]+8>>2]](e),y(e)}return b4(A)|0}function iE(A){A=A|0;var e=0,r=0;i[A>>2]=98904,e=i[A+68>>2];i:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break i;W[i[i[e>>2]+8>>2]](e),y(e)}return b4(A)|0}function eE(A){A=A|0;var e=0,r=0;i[A>>2]=98016,e=i[A+68>>2];i:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break i;W[i[i[e>>2]+8>>2]](e),y(e)}return b4(A)|0}function rE(A,e,r,f,k){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0;var n=0;k=v-32|0,v=k,n=k+12|0,Ln(n,i[e>>2],r,f,0),b0(A,n,i[e>>2]),u[k+31|0]<0&&Z(i[k+20>>2]),v=k+32|0}function t3(A,e,r,f){var k=0;return k=i[e>>2],i[A>>2]=k,e=i[e+4>>2],u[A+20|0]=0,i[A+16>>2]=f,i[A+8>>2]=0,i[A+12>>2]=0,i[A+4>>2]=e,W[i[i[k>>2]+20>>2]](k,r,0)|0,A}function W2(A,e){var r=0;i:{if(l[A+11|0]>>>7|0?r=i[A+4>>2]:r=l[A+11|0]&127,r>>>0<e>>>0){$u(A,e-r|0);break i}r=A,l[A+11|0]>>>7|0&&(A=i[A>>2]),Xl(r,A,e)}}function ao(A,e,r,f,k){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0;var n=0;k=v-32|0,v=k,n=k+12|0,Ln(n,i[e>>2],r,f,1),b0(A,n,i[e>>2]),u[k+31|0]<0&&Z(i[k+20>>2]),v=k+32|0}function fE(A){A=A|0;var e=0,r=0;i[A>>2]=98584,e=i[A+68>>2];i:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break i;W[i[i[e>>2]+8>>2]](e),y(e)}return b4(A)|0}function AE(A){A=A|0;var e=0,r=0;i[A>>2]=97648,e=i[A+68>>2];i:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break i;W[i[i[e>>2]+8>>2]](e),y(e)}return b4(A)|0}function kE(A){A=A|0;var e=0,r=0;i[A>>2]=99680,e=i[A+68>>2];i:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break i;W[i[i[e>>2]+8>>2]](e),y(e)}return b4(A)|0}function nE(A){A=A|0;var e=0;e=i[A+52>>2],e&&(i[A+56>>2]=e,Z(e)),u[A+51|0]<0&&Z(i[A+40>>2]),u[A+39|0]<0&&Z(i[A+28>>2]),u[A+27|0]<0&&Z(i[A+16>>2])}function $o(){var A=0,e=0;l[108636]||(u[108636]=1),A=i[27152],i[27152]=A+1;i:{if((A|0)>0||(H7(),j7()))break i;i[27152]=i[27152]-1,e=11}return e|0}function tE(A){A=A|0;var e=0,r=0;i[A>>2]=95408,e=i[A+104>>2];i:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break i;W[i[i[e>>2]+8>>2]](e),y(e)}Z(A2(A))}function co(A,e,r,f){var k=0;return k=v-16|0,v=k,A=g_(A|0,e|0,r|0,f&255,k+8|0)|0,A?(i[31324]=A,A=-1):A=0,v=k+16|0,l0=A?-1:i[k+12>>2],A?-1:i[k+8>>2]}function bo(){var A=0;return A=p(24),g[A+12>>1]=65535,u[A|0]=1,i[A+4>>2]=0,i[A+8>>2]=-1,g[A+14>>1]=52428,g[A+16>>1]=52428,g[A+18>>1]=52428,g[A+20>>1]=16,A|0}function uE(A){A=A|0;var e=0,r=0;i[A>>2]=100192,e=i[A+68>>2];i:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break i;W[i[i[e>>2]+8>>2]](e),y(e)}Z(b4(A))}function il(A){var e=0,r=0;return e=v-16|0,v=e,i[e+12>>2]=A,A=s8(e+8|0,e+12|0),r=i[i[31366]>>2]?4:1,A=i[A>>2],A&&(i[31366]=(A|0)==-1?125344:A),v=e+16|0,r}function oE(A,e,r){A=A|0,e=e|0,r=r|0;var f=0;for(A=0;;){if((e|0)!=(r|0)){A=i[e>>2]+(A<<4)|0,f=A&-268435456,A=(f|f>>>24)^A,e=e+4|0;continue}break}return A|0}function lE(A){A=A|0;var e=0,r=0;i[A>>2]=98904,e=i[A+68>>2];i:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break i;W[i[i[e>>2]+8>>2]](e),y(e)}Z(b4(A))}function sE(A){A=A|0;var e=0,r=0;i[A>>2]=98016,e=i[A+68>>2];i:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break i;W[i[i[e>>2]+8>>2]](e),y(e)}Z(b4(A))}function wE(A,e,r){A=A|0,e=e|0,r=r|0;var f=0;for(A=0;;){if((e|0)!=(r|0)){A=u[e|0]+(A<<4)|0,f=A&-268435456,A=(f|f>>>24)^A,e=e+1|0;continue}break}return A|0}function hE(A){A=A|0;var e=0,r=0;i[A>>2]=98584,e=i[A+68>>2];i:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break i;W[i[i[e>>2]+8>>2]](e),y(e)}Z(b4(A))}function _E(A){A=A|0;var e=0,r=0;i[A>>2]=97648,e=i[A+68>>2];i:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break i;W[i[i[e>>2]+8>>2]](e),y(e)}Z(b4(A))}function BE(A,e){A=A|0,e=e|0;var r=0;r=-1;i:{if(!A|(e|0)<4||(r=0,l[A|0]!=255|l[A+1|0]!=216|l[A+2|0]!=255))break i;r=(l[A+3|0]&240)==224}return r|0}function vE(A){A=A|0;var e=0,r=0;i[A>>2]=99680,e=i[A+68>>2];i:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break i;W[i[i[e>>2]+8>>2]](e),y(e)}Z(b4(A))}function mE(A,e,r){for(A=A|0,e=e|0,r=r|0;;){if((e|0)!=(r|0)){A=i[e>>2],A>>>0<=127&&(A=i[i[18661]+(A<<2)>>2]),i[e>>2]=A,e=e+4|0;continue}break}return e|0}function ZE(A,e,r){for(A=A|0,e=e|0,r=r|0;;){if((e|0)!=(r|0)){A=i[e>>2],A>>>0<=127&&(A=i[i[19048]+(A<<2)>>2]),i[e>>2]=A,e=e+4|0;continue}break}return e|0}function GE(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0;var k=0,n=0;k=v-32|0,v=k,n=k+12|0,Fu(n,i[e>>2],f,r),b0(A,n,i[e>>2]),u[k+31|0]<0&&Z(i[k+20>>2]),v=k+32|0}function el(A,e,r){var f=0;return f=v-16|0,v=f,i[f+12>>2]=r,i[f+8>>2]=e,A=of(A|0,f+8|0,1,f+4|0)|0,A?(i[31324]=A,A=-1):A=0,v=f+16|0,A?-1:i[f+4>>2]}function Z1(A,e,r,f){i:switch(e-1|0){case 0:l2(A,r&255);return;case 1:u2(A,r&65535);return;case 3:F0(A,r);return;case 7:e4(A,r,f);break;default:break i}}function rl(A,e,r,f,k){var n=0;return n=v-16|0,v=n,i[n+12>>2]=k,k=s8(n+8|0,n+12|0),e=ne(A,e,r,f),A=i[k>>2],A&&(i[31366]=(A|0)==-1?125344:A),v=n+16|0,e}function XE(A){A=A|0;var e=0;return e=i[A+24>>2],i[A+24>>2]=0,i[A>>2]=86136,e&&W[i[i[e>>2]+4>>2]](e),i[A>>2]=86312,u[A+23|0]<0&&Z(i[A+12>>2]),A|0}function fl(A,e,r){var f=0;return f=v-16|0,v=f,i[f+8>>2]=e,i[f+12>>2]=A,i[f+4>>2]=r,e=0,v=f+16|0,A=f+4|0,u0[A>>2]>=u0[f+12>>2]&&(e=u0[A>>2]<u0[f+8>>2]),e}function WE(A){return A=A|0,l[129868]?i[32466]:(l[130968]||(u[130968]=1),R2(130944,19432),R2(130956,19426),u[129868]=1,i[32466]=130944,130944)}function Al(A){var e=0;if(W[i[i[A>>2]+24>>2]](A),e=i[A+36>>2],A=i[A+40>>2],(e|0)!=(A|0))for(;Al(i[e>>2]),e=e+8|0,(A|0)!=(e|0););}function QE(A){return A=A|0,l[129876]?i[32468]:(l[131e3]||(u[131e3]=1),P2(130976,84568),P2(130988,84580),u[129876]=1,i[32468]=130976,130976)}function gE(A,e,r,f,k){for(A=A|0,e=e|0,r=r|0,f=f|0,k=k|0;;){if((e|0)!=(r|0)){A=i[e>>2],u[k|0]=A>>>0<128?A:f,k=k+1|0,e=e+4|0;continue}break}return e|0}function VE(A,e,r){for(A=A|0,e=e|0,r=r|0;;){if((e|0)!=(r|0)){A=u[e|0],(A|0)>=0&&(A=i[i[18661]+(A<<2)>>2]),u[e|0]=A,e=e+1|0;continue}break}return e|0}function FE(A,e,r){for(A=A|0,e=e|0,r=r|0;;){if((e|0)!=(r|0)){A=u[e|0],(A|0)>=0&&(A=i[i[19048]+(A<<2)>>2]),u[e|0]=A,e=e+1|0;continue}break}return e|0}function IE(A){A=A|0;var e=0;return i[A>>2]=88472,e=i[A+124>>2],e&&(i[A+128>>2]=e,Z(e)),i[A>>2]=88312,e=i[A+108>>2],e&&(i[A+112>>2]=e,Z(e)),A2(A)|0}function CE(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0;var k=0;k=i[e>>2],i[e+4>>2]=k,$4(e,k,r,r+f|0,f),i[A+8>>2]=i[24165],e=i[24164],i[A>>2]=i[24163],i[A+4>>2]=e}function pE(A,e,r){A=A|0,e=e|0,r=r|0;var f=0;l2(e,1),f=i[A+4>>2],Z1(e,r,f,f>>31),f=i[A+8>>2],Z1(e,r,f,f>>31),Z1(e,r,i[A+12>>2],0),Z1(e,r,i[A+16>>2],0)}function yE(A,e,r){A=A|0,e=e|0,r=r|0;var f=0;l2(e,4),f=i[A+4>>2],Z1(e,r,f,f>>31),f=i[A+8>>2],Z1(e,r,f,f>>31),Z1(e,r,i[A+12>>2],0),Z1(e,r,i[A+16>>2],0)}function EE(A,e,r){A=A|0,e=e|0,r=r|0;var f=0;l2(e,2),f=i[A+4>>2],Z1(e,r,f,f>>31),f=i[A+8>>2],Z1(e,r,f,f>>31),Z1(e,r,i[A+12>>2],0),Z1(e,r,i[A+16>>2],0)}function YE(A,e){A=A|0,e=e|0;var r=0;i:{r=i[e+328>>2];e:{if(!r)break e;if(Lf(A,e,r),i[A>>2])break i;if(u[A+19|0]>=0)break e;Z(i[A+8>>2])}Y9(A,e)}}function pe(A,e,r,f){return i[A>>2]=i[e>>2],e=i[e+4>>2],u[A+20|0]=0,i[A+16>>2]=r,i[A+12>>2]=0,i[A+8>>2]=f,i[A+4>>2]=e,f&&(i[A+12>>2]=i[f+12>>2]+1),A}function k0(A,e,r){var f=0,k=0,n=0;f=v-16|0,v=f,k=i[16889],n=l[e|0]==42,n||P1(32493,6,1,k),i[f+12>>2]=r,Ur(A,e+n|0,r,1953,1954),n6(k),v=f+16|0}function kl(A){A=A|0;var e=0;return e=1,i[A+4>>2]-32768>>>0<4294901760|i[A+8>>2]-32768>>>0<4294901760|u0[A+12>>2]>65535||(e=u0[A+16>>2]>65535),e|0}function RE(A,e,r,f,k){for(A=A|0,e=e|0,r=r|0,f=f|0,k=k|0;;){if((e|0)!=(r|0)){A=u[e|0],u[k|0]=(A|0)<0?f:A,k=k+1|0,e=e+1|0;continue}break}return e|0}function JE(A){A=A|0;var e=0;e=i[A+24>>2],i[A+24>>2]=0,i[A>>2]=86136,e&&W[i[i[e>>2]+4>>2]](e),i[A>>2]=86312,u[A+23|0]<0&&Z(i[A+12>>2]),Z(A)}function NE(A,e,r,f,k,n,t,o,s,w){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,t=t|0,o=o|0,s=s|0,w=w|0;var h=0;return h=e,e=0,W[A|0](h,r,f,k,n,e|t,o,e|s,w)|0}function UE(A,e,r,f,k,n){if(A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,S1(A,i[e+8>>2],n)){JA(e,r,f,k);return}A=i[A+8>>2],W[i[i[A>>2]+20>>2]](A,e,r,f,k,n)}function nl(A,e,r){var f=0,k=0,n=0;f=v-16|0,v=f,k=f,n=h6(e),i[k+12>>2]=n,k=f,n=h6(r),i[k+8>>2]=n,i[A>>2]=i[f+12>>2],i[A+4>>2]=i[f+8>>2],v=f+16|0}function i5(A,e,r){var f=0;return f=v-16|0,v=f,i[f+12>>2]=r,r=s8(f+8|0,f+12|0),e=Or(A,e),A=i[r>>2],A&&(i[31366]=(A|0)==-1?125344:A),v=f+16|0,e}function DE(A,e,r,f,k){return A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,e=i[A+32>>2],r=e,A=i[A+36>>2],e=(k|0)==(A|0)&e>>>0<f>>>0|A>>>0<k>>>0,l0=e?A:k,(e?r:f)|0}function ME(A){A=A|0;var e=0;i[A>>2]=88472,e=i[A+124>>2],e&&(i[A+128>>2]=e,Z(e)),i[A>>2]=88312,e=i[A+108>>2],e&&(i[A+112>>2]=e,Z(e)),Z(A2(A))}function HE(A,e,r){if(A=A|0,e=e|0,r=r|0,!e){e=i[23570],i[A>>2]=i[23569],i[A+4>>2]=e,i[A+8>>2]=i[23571];return}W[i[i[e>>2]+44>>2]](A,i[e+4>>2],r)}function zE(A,e,r){if(A=A|0,e=e|0,r=r|0,!e){e=i[23570],i[A>>2]=i[23569],i[A+4>>2]=e,i[A+8>>2]=i[23571];return}W[i[i[e>>2]+52>>2]](A,i[e+4>>2],r)}function x4(A){A=A|0;var e=0,r=0;if(A){e=i[A+4>>2];i:{if(!e||(r=i[e+4>>2],i[e+4>>2]=r-1,r))break i;W[i[i[e>>2]+8>>2]](e),y(e)}Z(A)}}function u3(A){var e=0,r=0;e=v-16|0,v=e,r=-1;i:{if(Ge(A)||(W[i[A+32>>2]](A,e+15|0,1)|0)!=1)break i;r=l[e+15|0]}return v=e+16|0,r}function tl(A,e){var r=0;return r=e>>31,A=A^r,vn(A-r|0,(e^r)-((A>>>0<r>>>0)+r|0)|0,100,0),l0=g6,A=r^Q6,e=A-r|0,l0=(r^l0)-((A>>>0<r>>>0)+r|0)|0,e}function ul(A){var e=0,r=0;if(e=i[A+104>>2],A=i[A+108>>2],(e|0)!=(A|0))for(;r=i[e>>2]+r|0,e=e+8|0,(A|0)!=(e|0););return r}function xE(A,e){A=A|0,e=e|0;i:{if(i[26942]||(_f(),!l[107772]))break i;iA()}i[26942]=i[26942]+1,i[A+8>>2]=48862,i[A>>2]=0,i[A+4>>2]=0}function TE(A){A=A|0;var e=0,r=0;return e=v-32|0,v=e,o9(e+12|0,A),A=l[A+72|0],r=i[e+12>>2],u[e+31|0]<0&&Z(i[e+20>>2]),v=e+32|0,(r?-1:A)|0}function P1(A,e,r,f){var k=0;k=G(e,r);i:{if(i[f+76>>2]<0){A=Lr(A,k,f);break i}A=Lr(A,k,f)}return(k|0)==(A|0)?e?r:0:(A>>>0)/(e>>>0)|0}function e5(A,e,r,f,k,n,t,o,s,w,h,_,B,m){if((m|0)<=8){W[i[A+12>>2]](e,r,f,k,n,t,o,s,w,h,_,B);return}W[i[A+28>>2]](e,r,f,k,n,t,o,s,w,h,_,B,m)}function SE(A){A=A|0;var e=0;return A=i[A>>2],e=i[A+280>>2],A=i[A+284>>2],!A|i[A+4>>2]!=-1||(W[i[i[A>>2]+8>>2]](A),y(A)),(e?e+104|0:0)|0}function ol(A){A=A|0;var e=0;i[A+2192>>2]&&(e=i[A+2188>>2],u[i[i[i[A+2176>>2]+(e>>>8&16777212)>>2]+((e&1023)<<2)>>2]+104|0]=0,Lo(A+2140|0))}function jE(){var A=0;return A=p(32),i[A+8>>2]=0,i[A+12>>2]=0,u[A+4|0]=0,i[A>>2]=9e4,i[A+16>>2]=0,i[A+20>>2]=0,i[A+24>>2]=0,i[A+28>>2]=0,A|0}function OE(){var A=0;return A=p(32),i[A>>2]=0,i[A+4>>2]=0,i[A+24>>2]=0,i[A+28>>2]=0,i[A+16>>2]=0,i[A+20>>2]=0,i[A+8>>2]=0,i[A+12>>2]=0,A|0}function PE(A){A=A|0;var e=0;A&&(e=i[A+4>>2],e&&Z(e),e=i[A+8>>2],e&&Z(e),e=i[A+12>>2],e&&Z(e),e=i[A+16>>2],e&&Z(e),Z(A))}function LE(A,e){A=A|0,e=e|0;var r=0,f=0;W[i[i[A>>2]+24>>2]](A)|0,e=c0(e,129768),i[A+36>>2]=e,r=A,f=W[i[i[e>>2]+28>>2]](e)|0,u[r+44|0]=f}function KE(A,e){A=A|0,e=e|0;var r=0,f=0;W[i[i[A>>2]+24>>2]](A)|0,e=c0(e,129776),i[A+36>>2]=e,r=A,f=W[i[i[e>>2]+28>>2]](e)|0,u[r+44|0]=f}function qE(A){A=A|0;var e=0;return i[A>>2]=101384,e=i[A+480>>2],e&&(i[A+484>>2]=e,Z(e)),e=i[A+468>>2],e&&(i[A+472>>2]=e,Z(e)),T1(A)|0}function aE(A,e,r,f,k,n,t,o,s){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,t=t|0,o=o|0,s=s|0;var w=0;return w=e,e=0,W[A|0](w,r,f,k,e|n,t,e|o,s)|0}function $E(A){A=A|0;var e=0,r=0;return e=v-16|0,v=e,gt(e+4|0,i[A>>2]),r=i[e+8>>2],A=i[e+4>>2],A&&(i[e+8>>2]=A,Z(A)),v=e+16|0,r-A>>3}function o3(A,e){var r=0,f=0;r=l[A+112|0];i:{if(r||(r=0,f=i[A+124>>2],A=i[A+120>>2],f-A>>>0<=e>>>0))break i;r=l[A+e|0]}return r}function l3(A,e,r){var f=0;f=t0[r>>3],t0[A>>3]=t0[e+32>>3]+(f*t0[e>>3]+f*t0[e+8>>3]),t0[A+8>>3]=t0[e+40>>3]+(f*t0[e+16>>3]+t0[r+8>>3]*t0[e+24>>3])}function dE(A){A=A|0;var e=0;return A=i[A>>2],e=i[A+160>>2],A=i[A+164>>2],!A|i[A+4>>2]!=-1||(W[i[i[A>>2]+8>>2]](A),y(A)),(e|0)!=0|0}function cE(A,e){A=A|0,e=e|0;var r=0,f=0,k=0;r=e,e=i[e>>2]+7&-8,i[r>>2]=e+16,f=A,k=Pf(i[e>>2],i[e+4>>2],i[e+8>>2],i[e+12>>2]),t0[f>>3]=k}function ll(A,e){var r=0;return r=i[A+24>>2],(r|0)==i[A+28>>2]?W[i[i[A>>2]+52>>2]](A,e&255)|0:(i[A+24>>2]=r+1,u[r|0]=e,e&255)}function r5(A,e,r,f,k,n){var t=0,o=0;t=i[A+4>>2],o=t>>8,A=i[A>>2],t&1&&(o=i[i[f>>2]+o>>2]),W[i[i[A>>2]+20>>2]](A,e,r,f+o|0,t&2?k:2,n)}function sl(A){var e=0,r=0;for(A=A>>>0<=1?1:A;;){i:{if(e=y2(A),e||(r=i[32827],!r))break i;W[r|0]();continue}break}return e}function wl(A,e,r){var f=0;f=v-16|0,v=f;i:{if(!(u[e+120|0]&1|r>>>0>30)){u[e+120|0]=1;break i}e=ss(r)}v=f+16|0,i[A+4>>2]=r,i[A>>2]=e}function bE(A,e){A=A|0,e=e|0,e&&(A=A<<24|(A&65280)<<8|(A>>>8&65280|A>>>24),u[e|0]=A,u[e+1|0]=A>>>8,u[e+2|0]=A>>>16,u[e+3|0]=A>>>24)}function iY(A){A=A|0;var e=0;i[A>>2]=101384,e=i[A+480>>2],e&&(i[A+484>>2]=e,Z(e)),e=i[A+468>>2],e&&(i[A+472>>2]=e,Z(e)),Z(T1(A))}function eY(A,e,r){A=A|0,e=e|0,r=r|0;var f=0;f=v-16|0,v=f,W[i[i[r>>2]+128>>2]](f+4|0,i[r+4>>2]),g[e+4>>1]=256,Nf(A,e,r),v=f+16|0}function rY(A,e,r){A=A|0,e=e|0,r=r|0;var f=0;f=v-16|0,v=f,W[i[i[r>>2]+128>>2]](f+4|0,i[r+4>>2]),g[e+4>>1]=256,l9(A,e,r),v=f+16|0}function fY(A,e,r){A=A|0,e=e|0,r=r|0;var f=0;f=v-16|0,v=f,W[i[i[r>>2]+128>>2]](f+4|0,i[r+4>>2]),g[e+4>>1]=256,Rf(A,e,r),v=f+16|0}function AY(A,e,r){A=A|0,e=e|0,r=r|0;var f=0;f=v-16|0,v=f,W[i[i[r>>2]+128>>2]](f+4|0,i[r+4>>2]),g[e+4>>1]=256,Yf(A,e,r),v=f+16|0}function s3(A,e,r,f,k){var n=0,t=0;n=i[A+4>>2],t=n>>8,A=i[A>>2],n&1&&(t=i[i[r>>2]+t>>2]),W[i[i[A>>2]+24>>2]](A,e,r+t|0,n&2?f:2,k)}function kY(A,e){if(A=A|0,e=e|0,!e){if(u[A+31|0]<0){u[i[A+20>>2]]=0,i[A+24>>2]=0;return}u[A+31|0]=0,u[A+20|0]=0;return}R2(A+20|0,e)}function nY(A,e){if(A=A|0,e=e|0,e){R2(A+20|0,e);return}if(u[A+31|0]<0){u[i[A+20>>2]]=0,i[A+24>>2]=0;return}u[A+31|0]=0,u[A+20|0]=0}function tY(A){A=A|0;var e=0;return i[A>>2]=87752,e=i[A+116>>2],e&&(i[A+120>>2]=e,Z(e)),u[A+115|0]<0&&Z(i[A+104>>2]),A2(A)|0}function uY(A,e){A=A|0,e=e|0;var r=0;return e=W0(e,86580,86600),!e|i[A+104>>2]!=i[e+104>>2]||(r=i[A+108>>2]==i[e+108>>2]),r|0}function oY(A,e){A=A|0,e=e|0;var r=0,f=0,k=0;return f=i[A+4>>2],k=A+4|0,A=i[A+8>>2],r=i[e>>2],e=i[e+4>>2],$4(k,A,r,e,e-r|0),A-f|0}function v4(A,e){A=A|0,e=e|0;i:{if(A=i[e+4>>2],!A||(e=i[A+4>>2],i[A+4>>2]=e-1,e))break i;W[i[i[A>>2]+8>>2]](A),y(A)}}function w3(A,e){var r=0;r=v-16|0,v=r,$2(A,r+12|0)&&(A=i[r+12>>2],A?A=A&1?A+1>>1:0-(A>>1)|0:A=0,i[e>>2]=A),v=r+16|0}function lY(A,e,r,f){for(A=A|0,e=e|0,r=r|0,f=f|0;;){if((e|0)!=(r|0)){i[f>>2]=u[e|0],f=f+4|0,e=e+1|0;continue}break}return e|0}function sY(A,e,r,f,k){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,f&&(i[f>>2]=0),e=i[23925],i[A>>2]=i[23924],i[A+4>>2]=e,i[A+8>>2]=i[23926]}function hl(A,e,r,f,k,n){A=W[i[i[A+8>>2]+4>>2]](A+8|0)|0,A=Wr(r,f,A,A+288|0,n,k,0)-A|0,(A|0)<=287&&(i[e>>2]=((A|0)/12|0)%12)}function _l(A,e,r,f,k,n){A=W[i[i[A+8>>2]+4>>2]](A+8|0)|0,A=Qr(r,f,A,A+288|0,n,k,0)-A|0,(A|0)<=287&&(i[e>>2]=((A|0)/12|0)%12)}function gi(A,e){A=A|0,e=e|0;var r=0;r=i[e+448>>2],e=i[e+452>>2],e&&(i[e+4>>2]=i[e+4>>2]+1),u[A+20|0]=0,i[A+4>>2]=e,i[A>>2]=r}function wY(A,e,r,f){for(A=A|0,e=e|0,r=r|0,f=f|0;;){if((e|0)!=(r|0)){u[f|0]=l[e|0],f=f+1|0,e=e+1|0;continue}break}return e|0}function hY(A){A=A|0;var e=0,r=0;return e=p(8),r=i[A+8>>2],A=i[A+12>>2],A&&(i[A+4>>2]=i[A+4>>2]+1),i[e+4>>2]=A,i[e>>2]=r,e|0}function h3(A){var e=0;e=i[A+328>>2],i[A+328>>2]=e-1,i[A+336>>2]=i[A+336>>2]+1,!((e|0)>0)&&(D0(22103,18288,677,5585),H())}function Bl(A,e,r){var f=0;for(f=v-16|0,v=f,u[f+15|0]=r;;){if(e){u[A|0]=l[f+15|0],e=e-1|0,A=A+1|0;continue}break}v=f+16|0}function _Y(A){A=A|0;var e=0;i[A>>2]=87752,e=i[A+116>>2],e&&(i[A+120>>2]=e,Z(e)),u[A+115|0]<0&&Z(i[A+104>>2]),Z(A2(A))}function h6(A){var e=0;return e=v-16|0,v=e,i[e+12>>2]=A,A=v-16|0,v=A,i[A+12>>2]=i[e+12>>2],v=A+16|0,v=e+16|0,i[A+12>>2]}function y(A){var e=0,r=0;i:{if(e=A+8|0,i[e>>2]&&(r=e,e=i[e>>2]-1|0,i[r>>2]=e,(e|0)!=-1))break i;W[i[i[A>>2]+16>>2]](A)}}function BY(A,e,r,f){if(A=A|0,e=e|0,r=r|0,f=f|0,S1(A,i[e+8>>2],0)){jA(e,r,f);return}A=i[A+8>>2],W[i[i[A>>2]+28>>2]](A,e,r,f)}function R0(A){return i[A>>2]=70824,Cf(A+4|0),i[A+24>>2]=0,i[A+28>>2]=0,i[A+16>>2]=0,i[A+20>>2]=0,i[A+8>>2]=0,i[A+12>>2]=0,A}function vY(A,e,r,f,k){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0;var n=0;n=i[A+24>>2],i[n>>2]>=2&&W[i[n+28>>2]](e,r,f,k,i[A+28>>2])}function f5(){var A=0;return A=p(32),u[A+24|0]=0,i[A+16>>2]=0,i[A+20>>2]=2147483647,i[A+8>>2]=-1,i[A+12>>2]=-1,u[A|0]=1,A|0}function mY(A,e,r,f,k){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0;var n=0;n=i[A+24>>2],i[n>>2]>=2&&W[i[n+24>>2]](e,r,f,k,i[A+28>>2])}function vl(A){return i[A>>2]=71072,Cf(A+4|0),i[A+24>>2]=0,i[A+28>>2]=0,i[A+16>>2]=0,i[A+20>>2]=0,i[A+8>>2]=0,i[A+12>>2]=0,A}function ml(A,e,r,f,k,n){A=W[i[i[A+8>>2]>>2]](A+8|0)|0,A=Wr(r,f,A,A+168|0,n,k,0)-A|0,(A|0)<=167&&(i[e>>2]=((A|0)/12|0)%7)}function ZY(A,e){A=A|0,e=e|0;var r=0;return r=i[A+2152>>2],A=i[A+2148>>2],r-A>>2>>>0>e>>>0?A=i[A+(e<<2)>>2]:A=0,A|0}function Zl(A,e,r,f,k,n){A=W[i[i[A+8>>2]>>2]](A+8|0)|0,A=Qr(r,f,A,A+168|0,n,k,0)-A|0,(A|0)<=167&&(i[e>>2]=((A|0)/12|0)%7)}function ye(){var A=0;return A=p(24),i[A+8>>2]=0,i[A+12>>2]=0,u[A|0]=1,u[A+15|0]=0,u[A+16|0]=0,u[A+17|0]=0,u[A+18|0]=0,A|0}function GY(A){A=A|0;var e=0;return i[A>>2]=86180,e=i[A+48>>2],e&&Z(e),i[A>>2]=86312,u[A+23|0]<0&&Z(i[A+12>>2]),A|0}function J0(A,e){i[A+20>>2]=0,i[A+24>>2]=e,i[A+12>>2]=0,i[A+4>>2]=4098,i[A+8>>2]=6,i[A+16>>2]=!e,o0(A+32|0,0,40),Cf(A+28|0)}function Gl(){var A=0;return l[108636]||(u[108636]=1),A=i[27152],(A|0)<=0?12:(A=A-1|0,i[27152]=A,A||Ss(),0)}function I2(A){var e=0;i:{if(A=i[A+4>>2],!A||(e=i[A+4>>2],i[A+4>>2]=e-1,e))break i;W[i[i[A>>2]+8>>2]](A),y(A)}}function Xl(A,e,r){var f=0;f=v-16|0,v=f;i:if(l[A+11|0]>>>7|0)break i;z6(A,r),u[f+15|0]=0,u[e+r|0]=l[f+15|0],v=f+16|0}function XY(A,e,r){A=A|0,e=e|0,r=r|0;var f=0;return f=i[e+12>>2],A=i[A+16>>2]==1970628964?24:8,Pr(e,r?A+8|0:A),Pr(e,4),f|0}function WY(A){A=A|0;var e=0;A&&(x2(i[A+16>>2]),u[A+31|0]<0&&Z(i[A+20>>2]),e=i[A>>2],e&&(i[A+4>>2]=e,Z(e)),Z(A))}function Wl(A,e,r){A=A|0,e=e|0,r=r|0;var f=0;return f=i[A+32>>2],A=i[A+36>>2],((A|0)==(r|0)&e>>>0>f>>>0|A>>>0<r>>>0?2:0)|0}function Ql(A){A=A|0;var e=0,r=0;return i[A>>2]=85952,e=i[A+4>>2]-12|0,r=i[e+8>>2]-1|0,i[e+8>>2]=r,(r|0)<0&&Z(e),A|0}function A5(A,e){var r=0;r=A+4|0,i[r+28>>2]=0,i[r>>2]=73028,i[r>>2]=71360,i[A>>2]=70940,i[r>>2]=70960,I3(i[17732]+A|0,e)}function k5(A,e){var r=0;r=A+4|0,i[r+28>>2]=0,i[r>>2]=73028,i[r>>2]=71796,i[A>>2]=71188,i[r>>2]=71208,I3(i[17794]+A|0,e)}function gl(A){var e=0;i[A+8>>2]=0,i[A+12>>2]=0,e=i[A+16>>2],i[A+16>>2]=0,e=e>>3,i[A>>2]=i[A>>2]-e,i[A+4>>2]=e+i[A+4>>2]}function QY(A){A=A|0;var e=0;return(W[i[i[A>>2]+36>>2]](A)|0)==-1?-1:(e=A,A=i[A+12>>2],i[e+12>>2]=A+4,i[A>>2])}function Vl(A){var e=0;return e=i[A+12>>2],(e|0)==i[A+16>>2]?W[i[i[A>>2]+40>>2]](A)|0:(i[A+12>>2]=e+4,i[e>>2])}function G1(A,e){return i[A+4>>2]=e,u[A|0]=0,e=i[i[e>>2]-12>>2]+e|0,i[e+16>>2]||(e=i[e+72>>2],e&&We(e),u[A|0]=1),A}function gY(A){A=A|0;var e=0;return(W[i[i[A>>2]+36>>2]](A)|0)==-1?-1:(e=A,A=i[A+12>>2],i[e+12>>2]=A+1,l[A|0])}function Fl(A){var e=0;return e=i[A+12>>2],(e|0)==i[A+16>>2]?W[i[i[A>>2]+40>>2]](A)|0:(i[A+12>>2]=e+1,l[e|0])}function Il(A,e,r){var f=0,k=0;f=t0[r>>3],k=t0[r+8>>3],t0[A>>3]=f*t0[e>>3]+k*t0[e+8>>3],t0[A+8>>3]=f*t0[e+16>>3]+k*t0[e+24>>3]}function f1(A,e,r,f){i[r+12>>2]=f,W[i[i[e>>2]+56>>2]](A,e,r,i[r+4>>2]-(i[r>>2]+f|0)|0,0),i[r+12>>2]=i[r+4>>2]-i[r>>2]}function VY(A){A=A|0;var e=0;i[A>>2]=86180,e=i[A+48>>2],e&&Z(e),i[A>>2]=86312,u[A+23|0]<0&&Z(i[A+12>>2]),Z(A)}function Cl(A){return A=(A|0)>2147481747?A-2e3|0:A,A&3?0:(A=A+1900|0,(A|0)%100|0?1:!((A|0)%400|0))}function FY(A){A=A|0;var e=0;return A=i[A>>2],i[A+116>>2]==1&&(e=i[A+120>>2]==3?4:10),A=o8(A,e),(A?(A|0)<0?-1:A:-1)|0}function IY(A){A=A|0;var e=0;return A=i[A>>2],i[A+116>>2]==1&&(e=i[A+120>>2]==3?4:10),A=l8(A,e),(A?(A|0)<0?-1:A:-1)|0}function e2(A){var e=0;A=i[A>>2],(A|0)!=129576&&(e=i[A+4>>2]-1|0,i[A+4>>2]=e,(e|0)==-1&&W[i[i[A>>2]+8>>2]](A))}function CY(A,e){A=A|0,e=e|0;var r=0,f=0;r=p(1),i[A+8>>2]=i[24165],f=i[24164],i[A>>2]=i[24163],i[A+4>>2]=f,i[e>>2]=r}function pY(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0;var k=0;return k=v-16|0,v=k,W[A|0](k+8|0,e,r,f),v=k+16|0,i[k+12>>2]}function pl(A,e,r,f,k,n){i[A>>2]=e,i[A+4>>2]=r,i[A+8>>2]=f,i[A+12>>2]=k&65535|(n>>>16&32768|(k&2147418112)>>>16)<<16}function yY(A){A=A|0;var e=0,r=0;if(e=i[A>>2],e)for(;Z(e),r=r+1|0,e=i[(r<<2)+A>>2],!!e;);Z(A)}function Vi(A,e){A=A|0,e=e|0;var r=0;i[A>>2]=i[e+456>>2],r=A,A=i[e+460>>2],i[r+4>>2]=A,A&&(i[A+4>>2]=i[A+4>>2]+1)}function n5(A,e){var r=0;return r=v-16|0,v=r,i[r+12>>2]=i[A>>2],i[r+12>>2]=i[r+12>>2]+(e<<2),v=r+16|0,i[r+12>>2]}function yl(A,e,r){var f=0;f=v-16|0,v=f,i[f+12>>2]=e,i[f+8>>2]=r,i[A>>2]=i[f+12>>2],i[A+4>>2]=i[f+8>>2],v=f+16|0}function s8(A,e){var r=0;return r=i[31366],e=i[e>>2],e&&(i[31366]=(e|0)==-1?125344:e),i[A>>2]=(r|0)==125344?-1:r,A}function EY(){var A=0;return A=p(24),i[A+4>>2]=0,i[A+8>>2]=0,i[A>>2]=1,i[A+12>>2]=0,i[A+16>>2]=0,i[A+20>>2]=0,A|0}function YY(A,e,r){A=A|0,e=e|0,r=r|0;var f=0,k=0;f=A,k=e,A=u[r+11|0],e=(A|0)<0,ao(f,k,e?i[r>>2]:r,e?i[r+4>>2]:A,0)}function RY(A){A=A|0;var e=0;return i[A>>2]=101176,x2(i[A+472>>2]),e=i[A+460>>2],e&&(i[A+464>>2]=e,Z(e)),T1(A)|0}function JY(A,e,r){A=A|0,e=e|0,r=r|0;var f=0;return f=i[e+12>>2],A=i[A+16>>2]==1970628964?24:8,Pr(e,r?A+8|0:A),f|0}function NY(A,e){A=A|0,e=e|0;var r=0;i[A>>2]=i[e+40>>2],r=A,A=i[e+44>>2],i[r+4>>2]=A,A&&(i[A+4>>2]=i[A+4>>2]+1)}function UY(A,e){A=A|0,e=e|0;var r=0;i[A>>2]=i[e+48>>2],r=A,A=i[e+52>>2],i[r+4>>2]=A,A&&(i[A+4>>2]=i[A+4>>2]+1)}function DY(A){A=A|0;var e=0,r=0;return e=u[A+31|0],r=(e|0)<0,c4(p((r?i[A+24>>2]:e)+1|0),r?i[A+20>>2]:A+20|0)|0}function q8(A,e,r,f){var k=0;k=v-32|0,v=k,rr(k+12|0,i[A+68>>2],e,r,f),u[k+31|0]<0&&Z(i[k+20>>2]),v=k+32|0}function MY(A,e,r){A=A|0,e=e|0,r=r|0;var f=0;f=v-16|0,v=f,i[f+8>>2]=1,i[f+12>>2]=964,C7(A,e,f+8|0,r),v=f+16|0}function El(A,e){var r=0,f=0;f=i[e>>2],i[e>>2]=0,r=i[A>>2],i[A>>2]=f,r&&W[i[A+4>>2]](r),i[A+4>>2]=i[e+4>>2]}function HY(A,e,r,f,k){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,e=i[24167],i[A>>2]=i[24166],i[A+4>>2]=e,i[A+8>>2]=i[24168]}function zY(A,e,r,f,k){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,e=i[24164],i[A>>2]=i[24163],i[A+4>>2]=e,i[A+8>>2]=i[24165]}function y8(A){i:{if(A=i[A+4>>2]&74,A){if((A|0)==64)return 8;if((A|0)!=8)break i;return 16}return 0}return 10}function xY(A){A=A|0;var e=0;return i[A>>2]=105260,D1(A+116|0),e=i[A+104>>2],e&&(i[A+108>>2]=e,Z(e)),A2(A)|0}function Q1(A,e,r){var f=0;return f=v-16|0,v=f,i[f+12>>2]=e,i[A>>2]=i[f+12>>2],i[A+4>>2]=i[r>>2],v=f+16|0,A}function t5(A){A=A|0;var e=0;return e=i[18172],i[A>>2]=e,i[i[e-12>>2]+A>>2]=i[18175],se(A+8|0),y0(A+108|0),A|0}function u5(A){A=A|0;var e=0;return e=i[18211],i[A>>2]=e,i[i[e-12>>2]+A>>2]=i[18214],se(A+4|0),y0(A+104|0),A|0}function TY(A){A=A|0;var e=0;return i[A>>2]=105740,D1(A+128|0),e=i[A+116>>2],e&&(i[A+120>>2]=e,Z(e)),A2(A)|0}function SY(A){A=A|0;var e=0;return i[A>>2]=106028,D1(A+132|0),e=i[A+120>>2],e&&(i[A+124>>2]=e,Z(e)),A2(A)|0}function o5(A,e){var r=0;return r=v-16|0,v=r,i[r+12>>2]=i[A>>2],i[r+12>>2]=i[r+12>>2]+e,v=r+16|0,i[r+12>>2]}function Yl(A){A=A|0;var e=0;i:{if(!A||(A=i[A>>2],!A))break i;A=i[A+120>>2],e=(A|0)>0?A:0}return e|0}function Rl(A){A=A|0;var e=0;i:{if(!A||(A=i[A>>2],!A))break i;A=i[A+124>>2],e=(A|0)>0?A:0}return e|0}function jY(A){A=A|0;var e=0;return i[A>>2]=104860,D1(A+116|0),e=i[A+104>>2],e&&(i[A+108>>2]=e,Z(e)),A2(A)|0}function OY(A){A=A|0;var e=0;return i[A>>2]=104940,D1(A+116|0),e=i[A+104>>2],e&&(i[A+108>>2]=e,Z(e)),A2(A)|0}function PY(A,e,r){A=A|0,e=e|0,r=r|0,A=i[e+4>>2],A&&Z(A),A=i[e+8>>2],A&&Z(A),A=i[e+12>>2],A&&Z(A)}function LY(A){A=A|0;var e=0;return i[A>>2]=105020,D1(A+116|0),e=i[A+104>>2],e&&(i[A+108>>2]=e,Z(e)),A2(A)|0}function S1(A,e,r){return r?(A|0)==(e|0)?1:!n4(i[A+4>>2],i[e+4>>2]):i[A+4>>2]==i[e+4>>2]}function KY(A){A=A|0;var e=0;return i[A>>2]=105100,D1(A+116|0),e=i[A+104>>2],e&&(i[A+108>>2]=e,Z(e)),A2(A)|0}function qY(A){A=A|0;var e=0;return i[A>>2]=105180,D1(A+124|0),e=i[A+112>>2],e&&(i[A+116>>2]=e,Z(e)),A2(A)|0}function aY(A){A=A|0;var e=0;return i[A>>2]=106108,D1(A+140|0),e=i[A+128>>2],e&&(i[A+132>>2]=e,Z(e)),A2(A)|0}function $Y(A,e,r){A=A|0,e=e|0,r=r|0,zf(i[e>>2],r),i[A+8>>2]=i[24058],e=i[24057],i[A>>2]=i[24056],i[A+4>>2]=e}function l5(A){A=A|0;var e=0;return e=i[18127],i[A>>2]=e,i[i[e-12>>2]+A>>2]=i[18130],g5(A+4|0),y0(A+56|0),A|0}function Jl(A,e,r,f,k,n){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,i[A+8>>2]=-1,i[A+12>>2]=-1,i[A>>2]=0,i[A+4>>2]=0}function dY(A){A=A|0;var e=0;i[A>>2]=101176,x2(i[A+472>>2]),e=i[A+460>>2],e&&(i[A+464>>2]=e,Z(e)),Z(T1(A))}function z6(A,e){if(l[A+11|0]>>>7|0){i[A+4>>2]=e;return}u[A+11|0]=l[A+11|0]&128|e&127,u[A+11|0]=l[A+11|0]&127}function Nl(A,e,r,f,k){e=Q8(e,r,f,k,4),l[f|0]&4||(i[A>>2]=((e|0)<69?e+2e3|0:e>>>0<100?e+1900|0:e)-1900)}function _3(A,e,r){if(r)for(;;){if(i[A>>2]==(e|0))return A;if(A=A+4|0,r=r-1|0,!r)break}return 0}function T4(A){var e=0;return l[A+11|0]>>>7|0&&(A=i[A>>2]),e=v-16|0,v=e,i[e+12>>2]=A,v=e+16|0,i[e+12>>2]}function J4(A,e){var r=0,f=0;return r=i[A+108>>2],f=e,e=i[A+112>>2],r=_3(r,f,e-r>>2),((r||e)|0)!=i[A+112>>2]}function cY(A,e,r){A=A|0,e=e|0,r=r|0;var f=0;l2(e,0),f=i[A+4>>2],Z1(e,r,f,f>>31),A=i[A+8>>2],Z1(e,r,A,A>>31)}function bY(A,e,r,f,k,n){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0;var t=0;return t=e,e=0,W[A|0](t,e|r,f,e|k,n)|0}function Ul(A,e,r,f,k){e=W8(e,r,f,k,4),l[f|0]&4||(i[A>>2]=((e|0)<69?e+2e3|0:e>>>0<100?e+1900|0:e)-1900)}function iR(A,e,r){return A=A|0,e=e|0,r=r|0,A=W[i[i[A+24>>2]+16>>2]](e,r,i[A+28>>2])|0,(A?(A|0)==1?1:2:0)|0}function s5(A,e){e&&(s5(A,i[e>>2]),s5(A,i[e+4>>2]),l[e+36|0]!=1|u[e+35|0]>=0||Z(i[e+24>>2]),Z(e))}function eR(A,e,r){A=A|0,e=e|0,r=r|0,i[r>>2]=100,i[A+8>>2]=i[24165],e=i[24164],i[A>>2]=i[24163],i[A+4>>2]=e}function rR(A,e){A=A|0,e=e|0;var r=0,f=0,k=0;A=i[A>>2],r=e>>31,f=A,k=O0(e,r,e,r),i[f+72>>2]=k,i[A+76>>2]=l0}function fR(A){if(A=A|0,l[A+112|0]==1){u[A+97|0]=1;return}if(l[A+120|0]==1){u[A+97|0]=2;return}u[A+97|0]=0}function Dl(A,e,r){A=A|0,e=e|0,r=r|0;var f=0;return f=v-16|0,v=f,W[A|0](f+8|0,e,r),v=f+16|0,i[f+12>>2]}function w5(A,e){if(!i[e+4>>2]){W[i[i[e>>2]+36>>2]](A,e+4|0);return}i[A+8>>2]=48862,i[A>>2]=0,i[A+4>>2]=0}function AR(A){A=A|0;var e=0;i[A>>2]=105260,D1(A+116|0),e=i[A+104>>2],e&&(i[A+108>>2]=e,Z(e)),Z(A2(A))}function kR(A){A=A|0;var e=0;i[A>>2]=105740,D1(A+128|0),e=i[A+116>>2],e&&(i[A+120>>2]=e,Z(e)),Z(A2(A))}function nR(A){A=A|0;var e=0;i[A>>2]=106028,D1(A+132|0),e=i[A+120>>2],e&&(i[A+124>>2]=e,Z(e)),Z(A2(A))}function tR(A){A=A|0;var e=0;i[A>>2]=106108,D1(A+140|0),e=i[A+128>>2],e&&(i[A+132>>2]=e,Z(e)),Z(A2(A))}function Ml(A,e,r,f,k,n,t,o){return A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,t=t|0,o=o|0,i[k>>2]=r,i[o>>2]=n,3}function uR(A,e,r){A=A|0,e=e|0,r=r|0,i[r>>2]=1,i[A+8>>2]=i[24165],e=i[24164],i[A>>2]=i[24163],i[A+4>>2]=e}function oR(A,e,r){A=A|0,e=e|0,r=r|0,i[r>>2]=0,i[A+8>>2]=i[24165],e=i[24164],i[A>>2]=i[24163],i[A+4>>2]=e}function lR(A){A=A|0;var e=0;i[A>>2]=104860,D1(A+116|0),e=i[A+104>>2],e&&(i[A+108>>2]=e,Z(e)),Z(A2(A))}function sR(A){A=A|0;var e=0;i[A>>2]=104940,D1(A+116|0),e=i[A+104>>2],e&&(i[A+108>>2]=e,Z(e)),Z(A2(A))}function wR(A){A=A|0;var e=0;i[A>>2]=105020,D1(A+116|0),e=i[A+104>>2],e&&(i[A+108>>2]=e,Z(e)),Z(A2(A))}function hR(A){A=A|0;var e=0;i[A>>2]=105100,D1(A+116|0),e=i[A+104>>2],e&&(i[A+108>>2]=e,Z(e)),Z(A2(A))}function _R(A){A=A|0;var e=0;i[A>>2]=105180,D1(A+124|0),e=i[A+112>>2],e&&(i[A+116>>2]=e,Z(e)),Z(A2(A))}function BR(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0,i[A>>2]=0,i[A+4>>2]=0,i[A+16>>2]=0,i[A+8>>2]=0,i[A+12>>2]=0}function Hl(A,e){e&&(g[A>>1]=i[e+4>>2],g[A+2>>1]=i[e+8>>2],g[A+4>>1]=i[e+12>>2],u[A+6|0]=l[e+16|0]!=0)}function Ee(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0,e=i[24167],i[A>>2]=i[24166],i[A+4>>2]=e,i[A+8>>2]=i[24168]}function zl(A,e,r){var f=0;e=e-A|0,f=e>>2;i:{if(!f||(f=f<<2,!f))break i;x(r,A,f)}return e+r|0}function vR(A){A=A|0;var e=0;e=u0[A+104>>2]>65535?3:l[A+164|0]<<1&2,u[A+97|0]=i[A+112>>2]&&e>>>0<=2?2:e}function mR(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0,e=i[24164],i[A>>2]=i[24163],i[A+4>>2]=e,i[A+8>>2]=i[24165]}function ZR(A){A=A|0;var e=0,r=0;return A=i[A+4>>2],e=h2(A)+1|0,r=y2(e),r?A=A8(r,A,e):A=0,A|0}function GR(){i[27021]=1,i[27015]=7626,i[27014]=3,i[27013]=11874,i[27012]=2,i[26997]=0,i[26996]=108048}function XR(A){A=A|0;var e=0;return i[A>>2]=95936,D1(A+32|0),e=i[A+20>>2],e&&(i[A+24>>2]=e,Z(e)),A|0}function WR(A){A=A|0;var e=0;return e=v-16|0,v=e,au(e,i[A+24>>2]),v=e+16|0,l0=i[e+12>>2],i[e+8>>2]}function QR(A){A=A|0;var e=0;return i[A>>2]=95892,D1(A+20|0),e=i[A+8>>2],e&&(i[A+12>>2]=e,Z(e)),A|0}function B3(){var A=0;return A=p(52),u[A+16|0]=1,i[A+12>>2]=6,i[A+4>>2]=1,i[A+8>>2]=13,u[A|0]=1,A|0}function h5(A){i[A+136>>2]||(i[A+136>>2]=i[i[31366]>>2]?73152:73128),i[A+72>>2]||(i[A+72>>2]=1)}function gR(A,e,r,f,k,n,t,o){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,t=t|0,o=o|0,H8(A,e,r,f,k,n,t,1,1,o)}function VR(A,e,r,f,k,n,t,o){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,t=t|0,o=o|0,H8(A,e,r,f,k,n,t,1,2,o)}function FR(A,e,r,f,k,n,t,o){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,t=t|0,o=o|0,H8(A,e,r,f,k,n,t,1,3,o)}function IR(A,e,r,f,k,n,t,o){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,t=t|0,o=o|0,H8(A,e,r,f,k,n,t,2,1,o)}function CR(A,e,r,f,k,n,t,o){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,t=t|0,o=o|0,H8(A,e,r,f,k,n,t,2,2,o)}function pR(A,e,r,f,k,n,t,o){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,t=t|0,o=o|0,H8(A,e,r,f,k,n,t,2,3,o)}function yR(A,e,r,f,k,n,t,o){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,t=t|0,o=o|0,H8(A,e,r,f,k,n,t,3,1,o)}function xl(A){if(i[A+20>>2]!=i[A+24>>2])for(;Kn(A),i[A+20>>2]!=i[A+24>>2];);}function ER(A,e,r,f,k,n,t,o){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,t=t|0,o=o|0,H8(A,e,r,f,k,n,t,3,2,o)}function YR(A,e,r,f,k,n,t,o){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,t=t|0,o=o|0,H8(A,e,r,f,k,n,t,3,3,o)}function RR(A,e){return A=A|0,e=e|0,e>>>0<=2?A=i[i[A+124>>2]+i[(e<<2)+59120>>2]>>2]:A=0,A|0}function Tl(A){C[A+4>>1]==2&&(g[A+4>>1]=6),C[A>>1]==2&&(g[A>>1]=1),C[A+2>>1]==2&&(g[A+2>>1]=13)}function JR(A,e,r){return A=A|0,e=e|0,r=r|0,r>>>0<=127?A=(i[(r<<2)+78064>>2]&e)!=0:A=0,A|0}function NR(A,e){A=A|0,e=e|0,As(i[e>>2]),i[A+8>>2]=i[24165],e=i[24164],i[A>>2]=i[24163],i[A+4>>2]=e}function UR(A,e,r,f,k,n){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0;var t=0;t=e,e=0,W[A|0](t,e|r,f,e|k,n)}function _5(A,e,r){var f=0;return f=v-16|0,v=f,r=_3(A,i[r>>2],e-A>>2),v=f+16|0,((r||e)-A|0)+A|0}function DR(A){A=A|0;var e=0;return i[A>>2]=106188,e=i[A+104>>2],e&&(i[A+108>>2]=e,Z(e)),A2(A)|0}function MR(A){A=A|0;var e=0;return i[A>>2]=106348,e=i[A+104>>2],e&&(i[A+108>>2]=e,Z(e)),A2(A)|0}function HR(A,e,r,f,k,n){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,i[A>>2]=4,i[A+4>>2]=0,i[A+8>>2]=25887}function Sl(A,e){var r=0;r=v-16|0,v=r;i:{if((A|0)==(e|0)){u[A+120|0]=0;break i}$8(e,4)}v=r+16|0}function v3(A){if(i[A+336>>2]!=i[A+340>>2])for(;i[A+336>>2]!=i[A+340>>2];);}function zR(A,e,r,f,k,n,t){return A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,t=t|0,W[A|0](e,r,f,k,n,t)|0}function xR(A){A=A|0;var e=0;return i[A>>2]=86884,e=i[A+108>>2],e&&(i[A+112>>2]=e,Z(e)),A2(A)|0}function TR(A){A=A|0;var e=0;return i[A>>2]=86724,e=i[A+100>>2],e&&(i[A+104>>2]=e,Z(e)),A2(A)|0}function SR(A){A=A|0;var e=0;return i[A>>2]=88152,e=i[A+120>>2],e&&(i[A+124>>2]=e,Z(e)),A2(A)|0}function jR(A){A=A|0;var e=0;return i[A>>2]=88312,e=i[A+108>>2],e&&(i[A+112>>2]=e,Z(e)),A2(A)|0}function OR(A){A=A|0;var e=0;return i[A>>2]=99096,e=i[A+100>>2],e&&(i[A+104>>2]=e,Z(e)),A2(A)|0}function PR(A){A=A|0;var e=0;return i[A>>2]=99176,e=i[A+100>>2],e&&(i[A+104>>2]=e,Z(e)),A2(A)|0}function LR(A){A=A|0;var e=0;return i[A>>2]=88792,e=i[A+104>>2],e&&(i[A+108>>2]=e,Z(e)),A2(A)|0}function KR(A){A=A|0;var e=0;return i[A>>2]=98504,e=i[A+100>>2],e&&(i[A+104>>2]=e,Z(e)),A2(A)|0}function qR(A){A=A|0;var e=0;return i[A>>2]=99336,e=i[A+104>>2],e&&(i[A+108>>2]=e,Z(e)),A2(A)|0}function aR(A){A=A|0;var e=0;i[A>>2]=95936,D1(A+32|0),e=i[A+20>>2],e&&(i[A+24>>2]=e,Z(e)),Z(A)}function jl(A,e){var r=0;for(r=i[A+4>>2];;){if((e|0)!=(r|0)){r=r-4|0;continue}break}i[A+4>>2]=e}function m3(A,e){e&&(m3(A,i[e>>2]),m3(A,i[e+4>>2]),A=i[e+16>>2],i[e+16>>2]=0,A&&Z(A),Z(e))}function $R(A){A=A|0;var e=0;return i[A>>2]=98080,e=i[A+112>>2],e&&(i[A+116>>2]=e,Z(e)),A2(A)|0}function dR(A,e){A=A|0,e=e|0;var r=0;return r=v-16|0,v=r,W[A|0](r+8|0,e),v=r+16|0,i[r+12>>2]}function cR(A,e){A=A|0,e=e|0,A=i[A>>2],i[A>>2]=i[e>>2],i[A+4>>2]=i[e+4>>2],i[e>>2]=0,i[e+4>>2]=0}function B5(A,e,r){var f=0;return f=v-16|0,v=f,r=wA(A,u[r|0],e-A|0),v=f+16|0,((r||e)-A|0)+A|0}function Ol(A){A=A|0;var e=0;return i[A>>2]=78012,e=i[A+8>>2],!e|!(u[A+12|0]&1)||Z(e),A|0}function Z3(A,e,r){A=A|0,e=e|0,r=r|0,i[A>>2]=0,i[A+4>>2]=0,i[A+16>>2]=0,i[A+8>>2]=0,i[A+12>>2]=0}function bR(A){A=A|0;var e=0;i[A>>2]=95892,D1(A+20|0),e=i[A+8>>2],e&&(i[A+12>>2]=e,Z(e)),Z(A)}function S4(A){var e=0;return e=1,C[A+6>>1]!=2|C[A+8>>1]!=2|C[A+10>>1]!=2||(e=!l[A+12|0]),e}function iJ(A,e,r){A=A|0,e=e|0,r=r|0,e=i[23925],i[A>>2]=i[23924],i[A+4>>2]=e,i[A+8>>2]=i[23926]}function Ye(A,e,r){(r|0)<0&&(D0(22091,18316,138,7265),H()),i[A+4>>2]=e,i[A>>2]=e,i[A+8>>2]=e+r}function v5(A,e,r){A=A|0,e=e|0,r=r|0,e=i[24164],i[A>>2]=i[24163],i[A+4>>2]=e,i[A+8>>2]=i[24165]}function eJ(A){A=A|0;var e=0;A&&(e=i[A+4>>2],e&&(W[i[i[A>>2]+40>>2]](e),i[A+4>>2]=0),Z(A))}function rJ(A,e,r,f,k,n){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,S1(A,i[e+8>>2],n)&&JA(e,r,f,k)}function L1(A,e){u[A+4|0]=0,u[A+11|0]=4,u[A+3|0]=e,u[A+2|0]=e>>>8,u[A+1|0]=e>>>16,u[A|0]=e>>>24}function fJ(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0,W[i[i[e>>2]+16>>2]](A,e,i[r+8>>2],i[r+12>>2],0,f)}function AJ(A,e,r,f,k,n){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,i[A+8>>2]=0,i[A>>2]=0,i[A+4>>2]=0}function kJ(A){A=A|0;var e=0,r=0;return e=u[A+11|0],r=(e|0)<0,Ju(r?i[A>>2]:A,r?i[A+4>>2]:e)|0}function nJ(A){A=A|0;var e=0;i[A>>2]=106188,e=i[A+104>>2],e&&(i[A+108>>2]=e,Z(e)),Z(A2(A))}function Pl(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0,i[A+8>>2]=-1,i[A+12>>2]=-1,i[A>>2]=0,i[A+4>>2]=0}function tJ(A){A=A|0;var e=0;i[A>>2]=106348,e=i[A+104>>2],e&&(i[A+108>>2]=e,Z(e)),Z(A2(A))}function z0(){var A=0;A=De(4),i[A>>2]=85840,i[A>>2]=85800,i[A>>2]=85820,Si(A|0,85904,32),H()}function Ll(A){A=A|0;var e=0;i[A>>2]=88312,e=i[A+108>>2],e&&(i[A+112>>2]=e,Z(e)),Z(A2(A))}function uJ(A){A=A|0;var e=0;i[A>>2]=86884,e=i[A+108>>2],e&&(i[A+112>>2]=e,Z(e)),Z(A2(A))}function oJ(A){A=A|0;var e=0;i[A>>2]=88152,e=i[A+120>>2],e&&(i[A+124>>2]=e,Z(e)),Z(A2(A))}function lJ(A){A=A|0;var e=0;i[A>>2]=86724,e=i[A+100>>2],e&&(i[A+104>>2]=e,Z(e)),Z(A2(A))}function Kl(A,e){var r=0;return r=A+8|0,A=i[r>>2],i[A+(e<<2)>>2]!=0&i[r+4>>2]-A>>2>>>0>e>>>0}function sJ(A){A=A|0;var e=0;i[A>>2]=98080,e=i[A+112>>2],e&&(i[A+116>>2]=e,Z(e)),Z(A2(A))}function wJ(A){A=A|0;var e=0;i[A>>2]=99096,e=i[A+100>>2],e&&(i[A+104>>2]=e,Z(e)),Z(A2(A))}function hJ(A){A=A|0;var e=0;i[A>>2]=99176,e=i[A+100>>2],e&&(i[A+104>>2]=e,Z(e)),Z(A2(A))}function _J(A){A=A|0;var e=0;i[A>>2]=88792,e=i[A+104>>2],e&&(i[A+108>>2]=e,Z(e)),Z(A2(A))}function BJ(A){A=A|0;var e=0;i[A>>2]=98504,e=i[A+100>>2],e&&(i[A+104>>2]=e,Z(e)),Z(A2(A))}function vJ(A){A=A|0;var e=0;i[A>>2]=99336,e=i[A+104>>2],e&&(i[A+108>>2]=e,Z(e)),Z(A2(A))}function ql(A){var e=0,r=0;for(r=A;e=r,r=e+4|0,!!i[e>>2];);return e-A>>2}function mJ(A,e,r,f,k){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,W[i[i[e>>2]+92>>2]](A,i[e+4>>2],r,f,k)}function m5(A,e){var r=0;i:{if(r=i[A>>2],!r||(ll(r,e)|0)!=-1)break i;i[A>>2]=0}}function ZJ(A){A=A|0;var e=0;return i[A>>2]=105820,e=i[A+8>>2],e&&(i[A+12>>2]=e,Z(e)),A|0}function GJ(A){return A=A|0,i[26960]=6,u[107828]=1,u[107844]=1,i[26958]=6,i[26959]=6,107828}function XJ(A){A=A|0;var e=0;return i[A>>2]=86356,e=i[A+20>>2],e&&(i[A+24>>2]=e,Z(e)),A|0}function G3(A,e){var r=0;return C[A+4>>1]!=C[e+4>>1]|C[A>>1]!=C[e>>1]?r:l[A+6|0]==l[e+6|0]}function WJ(A){A=A|0;var e=0;return i[A>>2]=95328,e=i[A+8>>2],e&&(i[A+12>>2]=e,Z(e)),A|0}function QJ(A,e,r,f,k,n,t){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,t=t|0,z8(A,e,r,f,k,n,t,1,1)}function gJ(A,e,r,f,k,n,t){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,t=t|0,z8(A,e,r,f,k,n,t,1,2)}function VJ(A,e,r,f,k,n,t){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,t=t|0,z8(A,e,r,f,k,n,t,1,3)}function FJ(A,e,r,f,k,n,t){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,t=t|0,z8(A,e,r,f,k,n,t,2,1)}function IJ(A,e,r,f,k,n,t){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,t=t|0,z8(A,e,r,f,k,n,t,2,2)}function CJ(A,e,r,f,k,n,t){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,t=t|0,z8(A,e,r,f,k,n,t,2,3)}function pJ(A){A=A|0;var e=0;i:{if(!A||(A=i[A>>2],!A))break i;e=yA(A)}return e|0}function yJ(A){A=A|0;var e=0;i:{if(!A||(A=i[A>>2],!A))break i;e=EA(A)}return e|0}function EJ(A,e,r,f,k,n,t){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,t=t|0,z8(A,e,r,f,k,n,t,3,1)}function YJ(A,e,r,f,k,n,t){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,t=t|0,z8(A,e,r,f,k,n,t,3,2)}function RJ(A,e,r,f,k,n,t){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,t=t|0,z8(A,e,r,f,k,n,t,3,3)}function JJ(A){return A=A|0,i[A+4>>2]-32768>>>0<4294901760|i[A+8>>2]-32768>>>0<4294901760}function a8(A,e,r,f){var k=0;return k=v-16|0,v=k,i[k+12>>2]=f,A=br(A,e,r,f),v=k+16|0,A}function NJ(A){A=A|0;var e=0;return i[A>>2]=95064,e=i[A+4>>2],e&&(i[A+8>>2]=e,Z(e)),A|0}function UJ(A,e,r){return A=A|0,e=e|0,r=r|0,!(W[i[i[A+24>>2]+12>>2]](e,r,i[A+28>>2])|0)|0}function DJ(A,e,r,f,k,n,t){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,t=t|0,W[A|0](e,r,f,k,n,t)}function MJ(A,e,r){return A=A|0,e=e|0,r=r|0,!(W[i[i[A+24>>2]+8>>2]](e,r,i[A+28>>2])|0)|0}function al(A,e){A=A|0,e=e|0;i:{if(!e||(A=i[e>>2],!A))break i;Z(A),i[e>>2]=0}}function $l(A){(A|0)!=0&(A|0)!=73128&(A|0)!=73152&(A|0)!=129172&(A|0)!=129196&&Z(A)}function dl(A){A=A|0;var e=0;A=i[i[i[A>>2]>>2]>>2],e=i[32437]+1|0,i[32437]=e,i[A+4>>2]=e}function HJ(A,e){A=A|0,e=e|0,e=i[23925],i[A>>2]=i[23924],i[A+4>>2]=e,i[A+8>>2]=i[23926]}function k2(A,e){var r=0,f=0;return r=e&31,f=(-1>>>r&A)<<r,r=A,A=0-e&31,f|(r&-1<<A)>>>A}function cl(A,e){var r=0;return r=v-16|0,v=r,i[r+12>>2]=e,A=U7(A,11384,e),v=r+16|0,A}function n8(A,e){A=A|0,e=e|0,e=v-16|0,v=e,i[A>>2]=0,i[A+4>>2]=0,i[A+8>>2]=0,v=e+16|0}function zJ(A){A=A|0;var e=0;i[A>>2]=105820,e=i[A+8>>2],e&&(i[A+12>>2]=e,Z(e)),Z(A)}function xJ(A){A=A|0;var e=0;i[A>>2]=86356,e=i[A+20>>2],e&&(i[A+24>>2]=e,Z(e)),Z(A)}function c0(A,e){return A=i[A>>2],e=l1(e),Kl(A,e)||(g1(),H()),i[i[A+8>>2]+(e<<2)>>2]}function TJ(A){for(A=A|0,A=130968;A=s2(A-12|0),(A|0)!=130944;);}function SJ(A){A=A|0;var e=0;i[A>>2]=95328,e=i[A+8>>2],e&&(i[A+12>>2]=e,Z(e)),Z(A)}function jJ(A,e,r,f,k,n){return A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,Jf(A,e,r,f,k,n)|0}function OJ(A){for(A=A|0,A=130152;A=s2(A-12|0),(A|0)!=129984;);}function PJ(A){for(A=A|0,A=130328;A=R1(A-12|0),(A|0)!=130160;);}function LJ(A){for(A=A|0,A=130624;A=s2(A-12|0),(A|0)!=130336;);}function KJ(A){for(A=A|0,A=130928;A=R1(A-12|0),(A|0)!=130640;);}function qJ(A){for(A=A|0,A=131e3;A=R1(A-12|0),(A|0)!=130976;);}function aJ(A){A=A|0;var e=0;i[A>>2]=95064,e=i[A+4>>2],e&&(i[A+8>>2]=e,Z(e)),Z(A)}function $J(A,e,r){A=A|0,e=e|0,r=r|0,A=i[A>>2],i[e>>2]=i[A+24>>2],i[r>>2]=i[A+28>>2]}function dJ(A,e,r,f,k){return A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,l0=i[A+36>>2],i[A+32>>2]}function cJ(A){return A=A|0,i[A>>2]=105420,u[A+115|0]<0&&Z(i[A+104>>2]),A2(A)|0}function bJ(A){return A=A|0,i[A>>2]=106768,u[A+299|0]<0&&Z(i[A+288>>2]),ai(A)|0}function iN(A){return A=A|0,i[A>>2]=105660,u[A+115|0]<0&&Z(i[A+104>>2]),A2(A)|0}function eN(A,e){A=A|0,e=e|0;var r=0;x2(i[A+16>>2]),r=A,A=ye(),i[r+16>>2]=A,Qi(A,e)}function rN(A){return A=A|0,i[A>>2]=105500,u[A+143|0]<0&&Z(i[A+132>>2]),A2(A)|0}function bl(A){return A=A|0,i[A>>2]=79096,i[A+8>>2]!=(a2()|0)&&$l(i[A+8>>2]),A|0}function fN(A,e){A=A|0,e=e|0;var r=0;return r=i[A>>2],e&&(i[e>>2]=i[A+4>>2]-r),r|0}function c1(A,e){for(;i[A+16>>2]=i[A+16>>2]-e,A=i[A+8>>2],!!A;);}function AN(A){return A=A|0,i[A>>2]=94544,u[A+471|0]<0&&Z(i[A+460>>2]),T1(A)|0}function kN(A,e){return A=A|0,e=e|0,(e|0)>=0&&(e=i[i[18661]+(e<<2)>>2]),e<<24>>24}function nN(A,e){return A=A|0,e=e|0,(e|0)>=0&&(e=i[i[19048]+(e<<2)>>2]),e<<24>>24}function tN(A){return A=A|0,i[A>>2]=87124,u[A+135|0]<0&&Z(i[A+124>>2]),A2(A)|0}function uN(A){return A=A|0,i[A>>2]=86804,u[A+123|0]<0&&Z(i[A+112>>2]),A2(A)|0}function oN(A){return A=A|0,i[A>>2]=88712,u[A+115|0]<0&&Z(i[A+104>>2]),A2(A)|0}function lN(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0,W[i[i[e>>2]+76>>2]](A,i[e+4>>2],r,f)}function sN(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0,W[i[i[e>>2]+80>>2]](A,i[e+4>>2],r,f)}function wN(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0,W[i[i[e>>2]+84>>2]](A,i[e+4>>2],r,f)}function hN(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0,W[i[i[e>>2]+88>>2]](A,i[e+4>>2],r,f)}function _N(A){return A=A|0,i[A>>2]=89512,u[A+111|0]<0&&Z(i[A+100>>2]),A2(A)|0}function BN(A){return A=A|0,i[A>>2]=89592,u[A+115|0]<0&&Z(i[A+104>>2]),A2(A)|0}function vN(A,e){A=A|0,e=e|0,e&&(A=i[i[A>>2]+32>>2],g[e>>1]=A,g[e+2>>1]=A>>>16)}function mN(A){return A=A|0,A=g7(i[A+60>>2])|0,A?(i[31324]=A,A=-1):A=0,A|0}function Z5(A,e){A=A|0,e=e|0;var r=0;r=A,A=i[e+448>>2],W[i[i[A>>2]+24>>2]](r,A)}function ZN(A){A=A|0;var e=0;e=A+12|0,A=i[e+8816>>2],A&&(i[e+8820>>2]=A,Z(A))}function GN(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0,e=v-16|0,v=e,ru(A,r,f),v=e+16|0}function XN(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0,e=v-16|0,v=e,lu(A,r,f),v=e+16|0}function WN(A){A=A|0,A&&(x2(i[A+12>>2]),u[A+31|0]<0&&Z(i[A+20>>2]),Z(A))}function K1(A){return A=f2(A),(A|0)==-99999|!A||(A=A&1?A+1>>1:0-(A>>1)|0),A}function QN(A,e){return A=A|0,e=e|0,i[A+2152>>2]-i[A+2148>>2]>>2>(e|0)&(e|0)>=0}function gN(A){return A=A|0,l[129892]||(ti(129880,79260),u[129892]=1),129880}function VN(A){A=A|0,i[A>>2]=105420,u[A+115|0]<0&&Z(i[A+104>>2]),Z(A2(A))}function FN(A,e,r,f){return A=A|0,e=e|0,r=r|0,f=f|0,A=co(i[A+60>>2],e,r,f),A|0}function IN(A,e){return A=A|0,e=e|0,e>>>0<=127&&(e=i[i[18661]+(e<<2)>>2]),e|0}function CN(A,e){return A=A|0,e=e|0,e>>>0<=127&&(e=i[i[19048]+(e<<2)>>2]),e|0}function pN(A){A=A|0,i[A>>2]=106768,u[A+299|0]<0&&Z(i[A+288>>2]),Z(ai(A))}function yN(A){return A=A|0,l[129908]||(ti(129896,79296),u[129908]=1),129896}function is(A,e){if(i[A>>2]<(e|0))for(;i[A>>2]<(e|0););}function EN(A){A=A|0,i[A>>2]=105660,u[A+115|0]<0&&Z(i[A+104>>2]),Z(A2(A))}function YN(A){return A=A|0,l[129924]||(oe(129912,19222),u[129924]=1),129912}function RN(A){return A=A|0,l[129940]||(ti(129928,79332),u[129940]=1),129928}function JN(A){return A=A|0,l[129972]||(ti(129960,79416),u[129972]=1),129960}function NN(A,e){A=A|0,e=e|0,A&&(A=i[A>>2],W[i[i[A>>2]+16>>2]](A,(e|0)!=0))}function x6(A){A=A|0,i[A>>2]=105500,u[A+143|0]<0&&Z(i[A+132>>2]),Z(A2(A))}function UN(A,e,r,f,k){return A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,W[A|0](e,r,f,k)|0}function DN(A){A=A|0,i[A>>2]=94544,u[A+471|0]<0&&Z(i[A+460>>2]),Z(T1(A))}function MN(A){return A=A|0,l[129956]||(oe(129944,7920),u[129956]=1),129944}function Re(A){for(var e=0;;){if(A){A=A-1&A,e=e+1|0;continue}break}return e}function HN(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0,S1(A,i[e+8>>2],0)&&jA(e,r,f)}function zN(A){A=A|0,i[A>>2]=88712,u[A+115|0]<0&&Z(i[A+104>>2]),Z(A2(A))}function xN(A){A=A|0,i[A>>2]=86804,u[A+123|0]<0&&Z(i[A+112>>2]),Z(A2(A))}function TN(A){A=A|0,i[A>>2]=87124,u[A+135|0]<0&&Z(i[A+124>>2]),Z(A2(A))}function E8(A,e){var r=0;r=v-16|0,v=r,i[r+12>>2]=e,Ls(107344,A,e),v=r+16|0}function SN(A){A=A|0,i[A>>2]=89512,u[A+111|0]<0&&Z(i[A+100>>2]),Z(A2(A))}function jN(A){A=A|0,i[A>>2]=89592,u[A+115|0]<0&&Z(i[A+104>>2]),Z(A2(A))}function ON(A,e,r){A=A|0,e=e|0,r=r|0,i[e>>2]=i[A+460>>2],i[r>>2]=i[A+464>>2]}function PN(A,e){return A=A|0,e=e|0,(e>>>0<=2?i[i[(e<<2)+59096>>2]+A>>2]:0)|0}function LN(A,e){return A=A|0,e=e|0,(e>>>0<=2?i[i[(e<<2)+59108>>2]+A>>2]:0)|0}function KN(A){return A=A|0,i[A>>2]=86312,u[A+23|0]<0&&Z(i[A+12>>2]),A|0}function qN(A,e,r){A=A|0,e=e|0,r=r|0,i[e>>2]=i[A+120>>2],i[r>>2]=i[A+124>>2]}function X3(A,e,r,f){return i[A+76>>2]<0,Vu(A,e,r,f)}function aN(){var A=0;return A=p(12),i[A>>2]=0,i[A+4>>2]=0,i[A+8>>2]=0,A|0}function es(A,e,r){A=A|0,e=e|0,r=r|0,A=i[A>>2],W[i[i[A>>2]+20>>2]](A,e,r)}function rs(A,e){A=A|0,e=e|0,i[A>>2]=0,i[A+4>>2]=0,u[A+20|0]=0,i[A+8>>2]=0}function fs(A,e){var r=0;r=Fl(i[e>>2]),i[A+4>>2]=i[e>>2],u[A|0]=r<<24>>24}function $N(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0,D0(22181,18165,68,10362),H()}function dN(A){return A=A|0,A=i[A+64>>2],(l[A+101|0]?l[A+102|0]?12:10:8)|0}function W3(){var A=0;A=qo(De(8),11043),i[A>>2]=86052,Si(A|0,86064,1),H()}function As(A){A=A|0;var e=0;return e=A+548|0,Jn(e),Jn(e),u[A+548|0]=1,0}function ks(A,e){return A=A|0,e=e|0,A=o8(i[A>>2],e),(A?(A|0)<0?-1:A:-1)|0}function ns(A,e){return A=A|0,e=e|0,A=l8(i[A>>2],e),(A?(A|0)<0?-1:A:-1)|0}function H1(A,e){e=!i[A+24>>2]|e,i[A+16>>2]=e,e&i[A+20>>2]&&(g1(),H())}function Je(){i[26942]||(_f(),l[107772]&&iA(),i[26942]=i[26942]+1)}function cN(A){A=A|0,i[A>>2]=86312,u[A+23|0]<0&&Z(i[A+12>>2]),Z(A)}function i8(A){var e=0;i[A+16>>2]=0,e=i[A+8>>2],e&&i8(e),u[A+20|0]=1}function G5(A){A=A|0,u[A+97|0]=(i[A+108>>2]|i[A+116>>2]|i[A+132>>2])!=0}function ts(A,e){A=A|0,e=e|0,e&&(A=i[A>>2],W[i[i[A>>2]+24>>2]](A,e))}function us(A,e){A=A|0,e=e|0,e&&(A=i[A>>2],W[i[i[A>>2]+28>>2]](A,e))}function Ne(A,e,r,f,k){return A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,i[k>>2]=r,3}function bN(A){return A=A|0,A=i[A+64>>2],(l[A+105|0]?l[A+111|0]+8|0:8)|0}function iU(A){return A=A|0,A=W[i[i[A+24>>2]+4>>2]](i[A+28>>2])|0,A|0}function _6(A,e){A=A|0,e=e|0,u[A|0]=2,u[A+1|0]=3,u[A+2|0]=0,u[A+3|0]=4}function X5(A){return A=A|0,i[A+8>>2]!=(a2()|0)&&$l(i[A+8>>2]),A|0}function eU(A){A=A|0,so(i[A>>2]),u[A+19|0]<0&&Z(i[A+8>>2]),Z(A)}function rU(A,e,r,f){return A=A|0,e=e|0,r=r|0,f=f|0,W[A|0](e,r,f)|0}function fU(A,e,r,f,k,n){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,n=n|0,bA(A,n)}function AU(A,e,r,f,k){return A=A|0,e=e|0,r=r|0,f=f|0,k=k|0,l0=-1,-1}function kU(A,e,r){A=A|0,e=e|0,r=r|0,M9(i[A>>2],e,i[i[r>>2]+24>>2])}function os(A,e){A=A|0,e=e|0,e&&(A=i[e>>2],A&&Z(A),i[e>>2]=0)}function ls(A,e){var r=0;r=Vl(i[e>>2]),i[A+4>>2]=i[e>>2],i[A>>2]=r}function nU(A,e,r){return A=A|0,e=e|0,r=r|0,(e>>>0<128?e:r)<<24>>24}function tU(A){return A=A|0,A=i[A>>2],(C[A+32>>1]|C[A+34>>1])!=0|0}function uU(A,e,r){A=A|0,e=e|0,r=r|0,D0(22181,18165,51,10212),H()}function oU(A){return A=A|0,A=i[A+16>>2],W[i[i[A>>2]+8>>2]](A)|0}function lU(A){A=A|0,u[A+12|0]=1,i[A+4>>2]=2,i[A+8>>2]=2,u[A|0]=1}function Q3(){var A=0;A=De(4),i[A>>2]=84784,Si(A|0,84796,783),H()}function sU(A){return A=A|0,A=i[A>>2],i[A+280>>2]-i[A+276>>2]>>2}function wU(A){return A=A|0,A=i[A>>2],i[A+136>>2]-i[A+132>>2]>>3}function hU(A){return A=A|0,A=i[A+8>>2],i[A+16>>2]-i[A+12>>2]>>3}function _U(A){A=A|0,We(128276),We(128628),RA(128364),RA(128716)}function BU(A){A=A|0,u[A+97|0]=i[A+40>>2]-i[A+36>>2]>>>0>524280}function _2(){var A=0;A=De(4),i[A>>2]=84840,Si(A|0,84852,32),H()}function vU(A,e){return A=A|0,e=e|0,(i[e+4>>2]==54817?A+12|0:0)|0}function mU(A){return A=A|0,A=i[A>>2],i[A+440>>2]-i[A+436>>2]>>2}function ZU(A){return A=A|0,A=i[A>>2],W[i[i[A>>2]+64>>2]](A)|0}function GU(A){return A=A|0,A=i[A>>2],W[i[i[A>>2]+68>>2]](A)|0}function XU(A){return A=A|0,A=i[A>>2],W[i[i[A>>2]+16>>2]](A)|0}function WU(A){return A=A|0,A=i[A+8>>2],A?il(A)|0:1}function QU(A,e){A=A|0,e=e|0,A=i[e>>2],A&&(i[e+4>>2]=A,Z(A))}function gU(A,e,r){A=A|0,e=e|0,r=r|0,i[A+28>>2]=r,i[A+24>>2]=e}function ss(A){return A>>>0>1073741823&&(g1(),H()),cu(A<<2,4)}function VU(A){return A=A|0,l[129877]||(u[129877]=1),107640}function FU(A){return A=A|0,l[129893]||(u[129893]=1),107652}function W5(A){x2(i[A+12>>2]),u[A+31|0]<0&&Z(i[A+20>>2])}function IU(A){return A=A|0,W[i[i[A>>2]+68>>2]](i[A+4>>2])|0}function CU(A,e){A=A|0,e=e|0,i[A+32>>2]=C[e>>1]|C[e+2>>1]<<16}function Q5(A){A=qo(De(8),A),i[A>>2]=86e3,Si(A|0,86012,1),H()}function pU(A){return A=A|0,A?l[i[A>>2]+336|0]:0}function Fi(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0,d6(A,e,r,-1,f)}function g5(A){return A=A|0,i[A>>2]=71232,s2(A+32|0),E0(A)|0}function yU(A,e){A=A|0,e=e|0,i[A+8>>2]=u[e+11|0]<0?i[e>>2]:e}function EU(A){return A=A|0,A?l[i[A>>2]+288|0]:0}function Y1(A,e){e&&(Y1(A,i[e>>2]),Y1(A,i[e+4>>2]),Z(e))}function V5(A,e){e&&(V5(A,i[e>>2]),V5(A,i[e+4>>2]),Z(e))}function C1(A,e){A=A|0,e=e|0,u[e+19|0]<0&&Z(i[e+8>>2])}function F5(A,e){e&&(F5(A,i[e>>2]),F5(A,i[e+4>>2]),Z(e))}function YU(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0,hr(A,16,e,r,f)}function RU(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0,hr(A,32,e,r,f)}function ws(A){return A=A|0,A?i[i[A+8>>2]>>2]:0}function Ii(A,e){e&&(Ii(A,i[e>>2]),Ii(A,i[e+4>>2]),Z(e))}function g3(A,e){e&&(g3(A,i[e>>2]),g3(A,i[e+4>>2]),Z(e))}function JU(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0,wr(A,r,16,e,f)}function NU(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0,wr(A,r,32,e,f)}function V3(A,e){e&&(V3(A,i[e>>2]),V3(A,i[e+4>>2]),Z(e))}function UU(A,e,r,f){return A=A|0,e=e|0,r=r|0,f=f|0,l0=0,0}function DU(A,e,r){return A=A|0,e=e|0,r=r|0,W[A|0](e,r)|0}function MU(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0,Uf(A,e,r,0,f)}function HU(A,e,r){return A=A|0,e=e|0,r=r|0,((e|0)<0?r:e)|0}function zU(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0,hr(A,8,e,r,f)}function xU(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0,wr(A,r,4,e,f)}function TU(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0,wr(A,r,8,e,f)}function SU(A){return A=A|0,A?l[i[A>>2]+4|0]:0}function jU(A){return A=A|0,A?i[A>>2]- -64|0:0}function OU(A,e,r,f){A=A|0,e=e|0,r=r|0,f=f|0,hr(A,4,e,r,f)}function R1(A){return l[A+11|0]>>>7|0&&$8(i[A>>2],4),A}function PU(A,e){A=A|0,e=e|0,u[e+11|0]<0&&Z(i[e>>2])}function s2(A){return l[A+11|0]>>>7|0&&$8(i[A>>2],1),A}function Ci(A,e){var r=0;r=cu(e,1),i[A+4>>2]=e,i[A>>2]=r}function hs(A){return A=A|0,i[A>>2]=79144,s2(A+12|0),A|0}function _s(A){return A=A|0,i[A>>2]=79184,s2(A+16|0),A|0}function Bs(A,e,r){return A=A|0,e=e|0,r=r|0,S1(A,e,0)|0}function E0(A){return A=A|0,i[A>>2]=70824,e2(A+4|0),A|0}function I5(A){return A=A|0,i[A>>2]=71072,e2(A+4|0),A|0}function LU(A){return A=A|0,i[i[i[A>>2]+156>>2]+120>>2]}function KU(A){return A=A|0,H6(i[i[A>>2]-12>>2]+A|0)|0}function qU(A){return A=A|0,l5(i[i[A>>2]-12>>2]+A|0)|0}function aU(A){return A=A|0,t5(i[i[A>>2]-12>>2]+A|0)|0}function $U(A){return A=A|0,u5(i[i[A>>2]-12>>2]+A|0)|0}function vs(A,e,r){A=A|0,e=e|0,r=r|0,i[i[A>>2]+e>>2]=r}function dU(A){return A=A|0,(i[A>>2]>=3?i[A+40>>2]:0)|0}function cU(A,e,r){A=A|0,e=e|0,r=r|0,Uf(A,e,r,0,95520)}function pi(A,e){var r=0;r=ss(e),i[A+4>>2]=e,i[A>>2]=r}function ms(A){return A=A|0,E3(i[i[A>>2]-12>>2]+A|0)|0}function Zs(A){return A=A|0,Y3(i[i[A>>2]-12>>2]+A|0)|0}function bU(A){return A=A|0,y3(i[i[A>>2]-12>>2]+A|0)|0}function C5(A){return A=A|0,W[i[i[A>>2]+12>>2]](A)|0}function yi(A,e){return A=St(A,e),l[A|0]==(e&255)?A:0}function iD(A){A=A|0,u[A+27|0]<0&&Z(i[A+16>>2])}function eD(A){return A=A|0,l0=i[A+44>>2],i[A+40>>2]}function F3(A,e,r,f,k){A=A|0,e=e|0,r=r|0,f=f|0,k=k|0}function Gs(A){return A=A|0,W[i[i[A>>2]+24>>2]]()|0}function x0(A){A=A|0,W[i[i[A+16>>2]>>2]](A+16|0)|0}function Xs(A,e){return A=A|0,e=e|0,i[i[A>>2]+e>>2]}function p5(A,e){return A=A|0,e=e|0,u1(i[A>>2],e)|0}function Ws(A,e){return A=A|0,e=e|0,j0(i[A>>2],e)|0}function E2(A){A=A|0,W[i[i[A+12>>2]>>2]](A+12|0)|0}function e8(A){return A?31-k1(A-1^A)|0:32}function rD(A){return A=A|0,i[i[A>>2]+160>>2]!=0|0}function Ue(A,e,r){$4(A+12|0,i[A+16>>2],e,e+r|0,r)}function fD(A,e){A=A|0,e=e|0,i[A>>2]=0,i[A+4>>2]=0}function AD(A){return A=A|0,i[i[A>>2]+188>>2]!=0|0}function kD(){var A=0;return A=p(4),i[A>>2]=0,A|0}function nD(A){A=A|0,u[107683]<0&&Z(i[26918])}function tD(A){A=A|0,u[107703]<0&&Z(i[26923])}function uD(A,e,r){A=A|0,e=e|0,r=r|0,h9(A,16,e,r)}function I3(A,e){J0(A,e),i[A+72>>2]=0,u[A+80|0]=0}function oD(A,e,r){A=A|0,e=e|0,r=r|0,_r(A,r,16,e)}function lD(A){return A=A|0,i[A+8>>2]-i[A+4>>2]|0}function sD(A,e,r){A=A|0,e=e|0,r=r|0,_r(A,r,32,e)}function wD(A,e,r){A=A|0,e=e|0,r=r|0,Fr(A,16,e,r)}function hD(A){return A=A|0,l[i[A+124>>2]+9016|0]}function _D(A,e,r){A=A|0,e=e|0,r=r|0,Fr(A,32,e,r)}function BD(A){return A=A|0,l[i[A+124>>2]+9018|0]}function vD(A){return A=A|0,l[i[A+124>>2]+9019|0]}function mD(A){return A=A|0,l[i[A+124>>2]+9020|0]}function ZD(A,e,r){A=A|0,e=e|0,r=r|0,h9(A,32,e,r)}function C3(A,e){return A=A|0,e=e|0,W[A|0](e)|0}function GD(A,e,r){A=A|0,e=e|0,r=r|0,_r(A,r,4,e)}function XD(A,e,r){A=A|0,e=e|0,r=r|0,_r(A,r,8,e)}function WD(A,e){A=A|0,e=e|0,i[i[A>>2]+196>>2]=e}function QD(A,e,r){A=A|0,e=e|0,r=r|0,Fr(A,4,e,r)}function gD(A,e,r){A=A|0,e=e|0,r=r|0,Fr(A,8,e,r)}function VD(A,e){A=A|0,e=e|0,i[i[A>>2]+144>>2]=e}function FD(A){A=A|0,u[A+97|0]=u0[A+104>>2]>65535}function Qs(A,e,r,f){V_(A|0,e|0,8,0,r|0,-1,f|0)}function p3(A,e){return A?Or(A,e):0}function ID(A,e){A=A|0,e=e|0,i[i[A>>2]+56>>2]=e}function CD(A){return A=A|0,(i[A>>2]==1?100:0)|0}function pD(A){return A=A|0,l[i[A+64>>2]+112|0]}function yD(A){return A=A|0,l[i[A+64>>2]+113|0]}function $8(A,e){if(e>>>0>8){Z(A);return}Z(A)}function gs(A,e,r){return A=A|0,e=e|0,r=r|0,A|0}function ED(A){return A=A|0,i[A+4>>2]-i[A>>2]|0}function YD(A){return A=A|0,l[i[A+64>>2]+122|0]}function RD(A){return A=A|0,l[i[A+64>>2]+123|0]}function Vs(A){var e=0,r=0;e=A,r=a2(),i[e>>2]=r}function JD(A){return A=A|0,i[A>>2]=102620,A|0}function ND(A){return A=A|0,i[A>>2]=102696,A|0}function UD(A){return A=A|0,i[A>>2]=100736,A|0}function DD(A){return A=A|0,i[A>>2]=102736,A|0}function MD(A){return A=A|0,i[A>>2]=100776,A|0}function HD(A){return A=A|0,i[A>>2]=102776,A|0}function zD(A){return A=A|0,i[A>>2]=102816,A|0}function xD(A){return A=A|0,i[A>>2]=100816,A|0}function TD(A){return A=A|0,i[A>>2]=102892,A|0}function SD(A){return A=A|0,i[A>>2]=100856,A|0}function jD(A){return A=A|0,i[A>>2]=102968,A|0}function OD(A){return A=A|0,i[A>>2]=100072,A|0}function PD(A){return A=A|0,i[A>>2]=100896,A|0}function LD(A){return A=A|0,i[A>>2]=103008,A|0}function KD(A){return A=A|0,i[A>>2]=100936,A|0}function qD(A){return A=A|0,i[A>>2]=103048,A|0}function aD(A){return A=A|0,i[A>>2]=100976,A|0}function $D(A){return A=A|0,i[A>>2]=103124,A|0}function dD(A){return A=A|0,i[A>>2]=101016,A|0}function cD(A){return A=A|0,i[A>>2]=101904,A|0}function bD(A){return A=A|0,i[A>>2]=103200,A|0}function iM(A){return A=A|0,i[A>>2]=101056,A|0}function eM(A){return A=A|0,i[A>>2]=101952,A|0}function rM(A){return A=A|0,i[A>>2]=103276,A|0}function fM(A){return A=A|0,i[A>>2]=101992,A|0}function AM(A){return A=A|0,i[A>>2]=103352,A|0}function kM(A){return A=A|0,i[A>>2]=101136,A|0}function nM(A){return A=A|0,i[A>>2]=102068,A|0}function tM(A){return A=A|0,i[A>>2]=103428,A|0}function uM(A){return A=A|0,i[A>>2]=102144,A|0}function oM(A){return A=A|0,i[A>>2]=103504,A|0}function lM(A){return A=A|0,i[A>>2]=102184,A|0}function sM(A){return A=A|0,i[A>>2]=103580,A|0}function t4(A,e,r){l[A|0]&32||Lr(e,r,A)}function wM(A){return A=A|0,i[A>>2]=102224,A|0}function hM(A){return A=A|0,i[A>>2]=103656,A|0}function _M(A){return A=A|0,i[A>>2]=102264,A|0}function BM(A){return A=A|0,i[A>>2]=106428,A|0}function vM(A){return A=A|0,i[A>>2]=102304,A|0}function mM(A){return A=A|0,i[A>>2]=102344,A|0}function ZM(A){return A=A|0,i[A>>2]=102384,A|0}function GM(A){return A=A|0,i[A>>2]=106500,A|0}function XM(A){return A=A|0,i[A>>2]=102424,A|0}function Fs(A,e){A=A|0,e=e|0,u[A+4|0]=(e|0)!=0}function WM(A){return A=A|0,i[A>>2]=102464,A|0}function QM(A){return A=A|0,i[A>>2]=94464,A|0}function gM(A){return A=A|0,i[A>>2]=102504,A|0}function VM(A){return A=A|0,i[A>>2]=106632,A|0}function FM(A){return A=A|0,i[A>>2]=102544,A|0}function IM(A){return A=A|0,i[A>>2]=101096,A|0}function CM(A){return A=A|0,i[A>>2]=92164,A|0}function pM(A){return A=A|0,i[A>>2]=90964,A|0}function yM(A){return A=A|0,i[A>>2]=93524,A|0}function EM(A){return A=A|0,i[A>>2]=97920,A|0}function YM(A){A=A|0,D5(i[i[A>>2]-12>>2]+A|0)}function RM(A){return A=A|0,i[A>>2]=61516,A|0}function JM(A){return A=A|0,i[A>>2]=89684,A|0}function NM(A){return A=A|0,i[A>>2]=91004,A|0}function UM(A){return A=A|0,i[A>>2]=92204,A|0}function DM(A){return A=A|0,i[A>>2]=93564,A|0}function MM(A){return A=A|0,i[A>>2]=98864,A|0}function HM(A){A=A|0,ds(i[i[A>>2]-12>>2]+A|0)}function zM(A){return A=A|0,i[A>>2]=89724,A|0}function xM(A){return A=A|0,i[A>>2]=91044,A|0}function TM(A){return A=A|0,i[A>>2]=92244,A|0}function SM(A){return A=A|0,i[A>>2]=93604,A|0}function jM(A){return A=A|0,i[A>>2]=61628,A|0}function OM(A){return A=A|0,Hu(i[A+468>>2])|0}function PM(A){A=A|0,cs(i[i[A>>2]-12>>2]+A|0)}function LM(A){return A=A|0,i[A>>2]=89764,A|0}function KM(A){return A=A|0,i[A>>2]=91084,A|0}function qM(A){return A=A|0,i[A>>2]=92284,A|0}function aM(A){return A=A|0,i[A>>2]=93644,A|0}function $M(A){A=A|0,bs(i[i[A>>2]-12>>2]+A|0)}function dM(A){return A=A|0,i[A>>2]=89804,A|0}function cM(A){return A=A|0,i[A>>2]=91124,A|0}function bM(A){return A=A|0,i[A>>2]=92324,A|0}function iH(A){return A=A|0,i[A>>2]=93684,A|0}function eH(A){return A=A|0,i[A>>2]=95488,A|0}function rH(A){return A=A|0,i[A>>2]=97080,A|0}function fH(A){return A=A|0,i[A>>2]=89844,A|0}function AH(A){return A=A|0,i[A>>2]=91164,A|0}function kH(A){return A=A|0,i[A>>2]=94724,A|0}function nH(A){return A=A|0,i[A>>2]=97120,A|0}function tH(A){return A=A|0,i[A>>2]=93804,A|0}function uH(A){return A=A|0,i[A>>2]=89884,A|0}function oH(A){return A=A|0,i[A>>2]=91204,A|0}function lH(A){return A=A|0,i[A>>2]=92444,A|0}function sH(A){return A=A|0,W[i[A+4>>2]]()|0}function wH(A){return A=A|0,i[A>>2]=97160,A|0}function hH(A){return A=A|0,i[A>>2]=93844,A|0}function _H(A){return A=A|0,i[A>>2]=94772,A|0}function BH(A){return A=A|0,i[A>>2]=89924,A|0}function vH(A){return A=A|0,i[A>>2]=91244,A|0}function mH(A){return A=A|0,i[A>>2]=92484,A|0}function ZH(A){return A=A|0,((A|0)==1?100:0)|0}function GH(A){return A=A|0,i[A>>2]=93884,A|0}function XH(A){return A=A|0,i[i[A>>2]+188>>2]}function Is(A){return A=A|0,i[i[A>>2]+116>>2]}function WH(A){return A=A|0,i[A>>2]=97200,A|0}function QH(A){return A=A|0,i[A>>2]=89964,A|0}function gH(A){return A=A|0,i[A>>2]=91284,A|0}function VH(A){return A=A|0,i[A>>2]=92524,A|0}function FH(A){return A=A|0,i[A>>2]=94812,A|0}function IH(A){return A=A|0,i[A>>2]=93924,A|0}function CH(A){return A=A|0,i[A>>2]=97240,A|0}function pH(A){return A=A|0,i[A>>2]=90004,A|0}function yH(A){return A=A|0,i[A>>2]=91324,A|0}function EH(A){return A=A|0,i[A>>2]=92564,A|0}function YH(A){return A=A|0,i[A>>2]=94852,A|0}function RH(A){return A=A|0,i[A>>2]=93964,A|0}function Cs(A,e,r){return A=A|0,e=e|0,r=r|0,-1}function JH(A){return A=A|0,i[A>>2]=97280,A|0}function NH(A){return A=A|0,i[A>>2]=90044,A|0}function UH(A){return A=A|0,i[A>>2]=91364,A|0}function DH(A){return A=A|0,i[A>>2]=92684,A|0}function MH(A){return A=A|0,i[A>>2]=94892,A|0}function HH(A){return A=A|0,i[A>>2]=90084,A|0}function zH(A){return A=A|0,i[A>>2]=91404,A|0}function xH(A){return A=A|0,i[A>>2]=94004,A|0}function TH(A){return A=A|0,i[A>>2]=94944,A|0}function SH(A){return A=A|0,i[A>>2]=90124,A|0}function jH(A){return A=A|0,i[A>>2]=92724,A|0}function OH(A){return A=A|0,i[A>>2]=94044,A|0}function PH(A){return A=A|0,i[A>>2]=91444,A|0}function LH(A){return A=A|0,i[A>>2]=91484,A|0}function KH(A){return A=A|0,i[A>>2]=94084,A|0}function qH(A){return A=A|0,i[A>>2]=94984,A|0}function aH(A){return A=A|0,i[A>>2]=92844,A|0}function $H(A){return A=A|0,i[i[A>>2]+144>>2]}function dH(A){return A=A|0,i[A>>2]=97464,A|0}function cH(A){A=A|0,U5(i[i[A>>2]-12>>2]+A|0)}function bH(A){return A=A|0,i[A>>2]=90204,A|0}function iz(A){return A=A|0,i[A>>2]=91524,A|0}function ez(A){return A=A|0,i[A>>2]=94124,A|0}function rz(A){return A=A|0,i[A>>2]=95024,A|0}function fz(A){return A=A|0,i[A>>2]=92884,A|0}function Az(A){return A=A|0,i[A>>2]=90244,A|0}function kz(A){return A=A|0,i[A>>2]=91564,A|0}function nz(A){return A=A|0,i[A>>2]=94164,A|0}function tz(A){return A=A|0,i[A>>2]=98464,A|0}function uz(A){return A=A|0,i[i[A>>2]+120>>2]}function oz(A){return A=A|0,i[A>>2]=90284,A|0}function lz(A){return A=A|0,i[A>>2]=91604,A|0}function sz(A){return A=A|0,i[A>>2]=93004,A|0}function wz(A){return A=A|0,i[A>>2]=96864,A|0}function hz(A){return A=A|0,i[A>>2]=94204,A|0}function _z(A){return A=A|0,i[A>>2]=90324,A|0}function Bz(A){return A=A|0,i[A>>2]=91644,A|0}function ps(A){A=A|0,J5(i[i[A>>2]-12>>2]+A|0)}function vz(A){return A=A|0,i[A>>2]=93044,A|0}function mz(A){return A=A|0,i[A>>2]=94244,A|0}function Zz(A){return A=A|0,i[A>>2]=96904,A|0}function Gz(A){return A=A|0,i[A>>2]=97584,A|0}function Xz(A){return A=A|0,i[A>>2]=90364,A|0}function Wz(A){return A=A|0,i[A>>2]=91684,A|0}function Qz(A,e){return A=A|0,e=e|0,I7(A,e)|0}function gz(A){return A=A|0,i[A>>2]=90404,A|0}function Vz(A){return A=A|0,i[A>>2]=91804,A|0}function Fz(A){return A=A|0,i[A>>2]=93164,A|0}function Iz(A){return A=A|0,i[A>>2]=95980,A|0}function ys(A){A=A|0,N5(i[i[A>>2]-12>>2]+A|0)}function Cz(A){return A=A|0,i[A>>2]=90524,A|0}function pz(A){return A=A|0,i[A>>2]=91844,A|0}function yz(A){return A=A|0,i[A>>2]=93204,A|0}function Ez(A){return A=A|0,i[A>>2]=96020,A|0}function Yz(A){return A=A|0,i[A>>2]=90564,A|0}function Rz(A){return A=A|0,i[A>>2]=91884,A|0}function Jz(A){return A=A|0,i[A>>2]=96060,A|0}function Nz(A){return A=A|0,i[A>>2]=93324,A|0}function Uz(A){return A=A|0,i[A>>2]=95288,A|0}function Dz(A){return A=A|0,i[A>>2]=90684,A|0}function Mz(A){return A=A|0,i[A>>2]=96100,A|0}function Hz(A){return A=A|0,i[A>>2]=99640,A|0}function zz(A){return A=A|0,i[A>>2]=91924,A|0}function xz(A){return A=A|0,i[A>>2]=90724,A|0}function Tz(A){return A=A|0,i[A>>2]=93364,A|0}function Sz(A){return A=A|0,i[A>>2]=94424,A|0}function jz(A){return A=A|0,i[A>>2]=96140,A|0}function Oz(A){return A=A|0,i[A>>2]=91964,A|0}function Pz(A){return A=A|0,i[A>>2]=90844,A|0}function Lz(A){return A=A|0,i[A>>2]=93404,A|0}function Kz(A){return A=A|0,i[A>>2]=96180,A|0}function qz(A){return A=A|0,i[A>>2]=92004,A|0}function az(A){return A=A|0,i[A>>2]=90884,A|0}function $z(A){return A=A|0,i[A>>2]=93444,A|0}function dz(A){return A=A|0,i[A>>2]=92044,A|0}function cz(A){return A=A|0,i[A>>2]=90924,A|0}function bz(A){return A=A|0,i[A>>2]=93484,A|0}function ix(A){return A=A|0,i[A>>2]=94504,A|0}function ex(A){return A=A|0,i[A>>2]=61400,A|0}function rx(A){return A=A|0,i[A>>2]=90164,A|0}function fx(A){return A=A|0,i[A+320>>2]!=0|0}function Ax(A){return A=A|0,i[i[A>>2]+24>>2]}function kx(A){return A=A|0,i[i[A>>2]+28>>2]}function Es(A){return A=A|0,i[i[A>>2]+16>>2]}function Ys(A){return A=A|0,i[i[A>>2]+20>>2]}function Rs(A){return A=A|0,l[i[A>>2]+128|0]}function Js(A){return A=A|0,l[i[A>>2]+145|0]}function nx(A){A=A|0,W[i[i[A>>2]+4>>2]](A)}function tx(A){return A=A|0,l[i[A>>2]+60|0]}function ux(A){return A=A|0,i[A+16>>2]!=0|0}function ox(A){return A=A|0,(wt(A,0)|0)!=0|0}function p(A){return A=sl(A),A||Z4(),A}function d8(A,e,r,f){return A=vn(A,e,r,f),A}function lx(A){return A=A|0,i[i[A>>2]+8>>2]}function sx(A){return A=A|0,i[i[A>>2]+4>>2]}function wx(A){return A=A|0,(l[A+4|0]?3:6)|0}function hx(A){A=A|0,i[A>>2]=102696,Z(A)}function y3(A){return A=A|0,y0(A+12|0),A|0}function _x(A){A=A|0,i[A>>2]=102544,Z(A)}function Bx(A){A=A|0,i[A>>2]=106632,Z(A)}function vx(A){A=A|0,u[A+97|0]=l[A+112|0]}function mx(A){A=A|0,i[A>>2]=102620,Z(A)}function Zx(A){A=A|0,i[A>>2]=100736,Z(A)}function Gx(A){A=A|0,i[A>>2]=102736,Z(A)}function Xx(A){A=A|0,i[A>>2]=100776,Z(A)}function Wx(A){A=A|0,i[A>>2]=102776,Z(A)}function Qx(A){A=A|0,i[A>>2]=102816,Z(A)}function gx(A){A=A|0,i[A>>2]=100816,Z(A)}function E3(A){return A=A|0,y0(A+8|0),A|0}function Vx(A){A=A|0,i[A>>2]=102892,Z(A)}function Y3(A){return A=A|0,y0(A+4|0),A|0}function Fx(A){A=A|0,i[A>>2]=100856,Z(A)}function Ix(A){return A=A|0,Eo(i[A>>2])|0}function Cx(A){A=A|0,i[A>>2]=102968,Z(A)}function px(A){A=A|0,i[A>>2]=100072,Z(A)}function yx(A){A=A|0,i[A>>2]=100896,Z(A)}function Ex(A){A=A|0,i[A>>2]=103008,Z(A)}function Yx(A){A=A|0,i[A>>2]=100936,Z(A)}function Rx(A){A=A|0,i[A>>2]=103048,Z(A)}function Jx(A){A=A|0,i[A>>2]=100976,Z(A)}function Nx(A){return A=A|0,ro(i[A>>2])|0}function Ux(A){A=A|0,i[A>>2]=103124,Z(A)}function Dx(A){A=A|0,i[A>>2]=101016,Z(A)}function Mx(A){A=A|0,i[A>>2]=101904,Z(A)}function Hx(A){A=A|0,i[A>>2]=103200,Z(A)}function zx(A){A=A|0,i[A>>2]=101056,Z(A)}function xx(A){A=A|0,i[A>>2]=101096,Z(A)}function Tx(A){A=A|0,i[A>>2]=101992,Z(A)}function Sx(A){A=A|0,i[A>>2]=103352,Z(A)}function jx(A){A=A|0,i[A>>2]=101136,Z(A)}function Ox(A){A=A|0,i[A>>2]=102068,Z(A)}function Px(A){A=A|0,i[A>>2]=103428,Z(A)}function Lx(A){A=A|0,i[A>>2]=102144,Z(A)}function Kx(A){A=A|0,i[A>>2]=103504,Z(A)}function qx(A){A=A|0,i[A>>2]=102184,Z(A)}function ax(A){A=A|0,i[A>>2]=103580,Z(A)}function $x(A){A=A|0,i[A>>2]=102224,Z(A)}function dx(A){A=A|0,i[A>>2]=103656,Z(A)}function cx(A,e){A=A|0,e=e|0,bA(A,e+12|0)}function bx(A,e){A=A|0,e=e|0,bA(A,e+16|0)}function iT(A){A=A|0,i[A>>2]=102264,Z(A)}function eT(A){A=A|0,i[A>>2]=106428,Z(A)}function rT(A){A=A|0,i[A>>2]=102304,Z(A)}function fT(A,e){A=A|0,e=e|0,i[A+16>>2]=e}function AT(A){A=A|0,i[A>>2]=102344,Z(A)}function kT(A){return A=A|0,Go(i[A>>2])|0}function nT(A){A=A|0,i[A>>2]=102384,Z(A)}function tT(A){A=A|0,i[A>>2]=106500,Z(A)}function uT(A){A=A|0,i[A>>2]=102424,Z(A)}function oT(A){A=A|0,i[A>>2]=102464,Z(A)}function lT(A){A=A|0,i[A>>2]=102504,Z(A)}function sT(A,e){A=A|0,e=e|0,i[A+12>>2]=e}function wT(A){A=A|0,i[A>>2]=101952,Z(A)}function hT(A){A=A|0,i[A>>2]=103276,Z(A)}function _T(A){A=A|0,i[A>>2]=93484,Z(A)}function BT(A){A=A|0,i[A>>2]=94504,Z(A)}function vT(A){A=A|0,i[A>>2]=61400,Z(A)}function mT(A){A=A|0,i[A>>2]=90964,Z(A)}function ZT(A){A=A|0,i[A>>2]=92164,Z(A)}function GT(A){A=A|0,i[A>>2]=93524,Z(A)}function XT(A){A=A|0,i[A>>2]=97920,Z(A)}function WT(A){A=A|0,i[A>>2]=61516,Z(A)}function QT(A){A=A|0,i[A>>2]=89684,Z(A)}function gT(A){A=A|0,i[A>>2]=91004,Z(A)}function VT(A){A=A|0,i[A>>2]=92204,Z(A)}function FT(A){A=A|0,i[A>>2]=93564,Z(A)}function IT(A){A=A|0,i[A>>2]=98864,Z(A)}function CT(A){A=A|0,i[A>>2]=89724,Z(A)}function pT(A){A=A|0,i[A>>2]=91044,Z(A)}function yT(A){A=A|0,i[A>>2]=92244,Z(A)}function ET(A){A=A|0,i[A>>2]=93604,Z(A)}function YT(A){A=A|0,i[A>>2]=61628,Z(A)}function RT(A){A=A|0,i[A>>2]=89764,Z(A)}function JT(A){A=A|0,i[A>>2]=91084,Z(A)}function NT(A){A=A|0,i[A>>2]=92284,Z(A)}function UT(A){A=A|0,i[A>>2]=93644,Z(A)}function DT(A){A=A|0,i[A>>2]=89804,Z(A)}function MT(A){A=A|0,i[A>>2]=91124,Z(A)}function HT(A){A=A|0,i[A>>2]=92324,Z(A)}function zT(A){A=A|0,i[A>>2]=93684,Z(A)}function xT(A){A=A|0,i[A>>2]=95488,Z(A)}function TT(A){A=A|0,i[A>>2]=97080,Z(A)}function ST(A){A=A|0,F5(107756,i[26940])}function jT(A){A=A|0,i[A>>2]=89844,Z(A)}function OT(A){A=A|0,i[A>>2]=91164,Z(A)}function PT(A){A=A|0,i[A>>2]=94724,Z(A)}function LT(A){A=A|0,i[A>>2]=97120,Z(A)}function KT(A){A=A|0,i[A>>2]=93804,Z(A)}function qT(A){A=A|0,i[A>>2]=89884,Z(A)}function aT(A){A=A|0,i[A>>2]=91204,Z(A)}function $T(A){A=A|0,i[A>>2]=92444,Z(A)}function dT(A){A=A|0,i[A>>2]=93844,Z(A)}function cT(A){A=A|0,i[A>>2]=94772,Z(A)}function bT(A){A=A|0,i[A>>2]=97160,Z(A)}function iS(A){A=A|0,i[A>>2]=89924,Z(A)}function eS(A){A=A|0,i[A>>2]=91244,Z(A)}function rS(A){A=A|0,i[A>>2]=92484,Z(A)}function fS(A){A=A|0,i[A>>2]=93884,Z(A)}function AS(A){A=A|0,i[A>>2]=97200,Z(A)}function kS(A){A=A|0,i[A>>2]=89964,Z(A)}function nS(A){A=A|0,i[A>>2]=91284,Z(A)}function tS(A){A=A|0,i[A>>2]=92524,Z(A)}function uS(A){A=A|0,i[A>>2]=94812,Z(A)}function oS(A){A=A|0,i[A>>2]=93924,Z(A)}function lS(A){A=A|0,i[A>>2]=97240,Z(A)}function sS(A){A=A|0,i[A>>2]=90004,Z(A)}function wS(A){A=A|0,i[A>>2]=91324,Z(A)}function hS(A){A=A|0,i[A>>2]=92564,Z(A)}function _S(A){A=A|0,i[A>>2]=93964,Z(A)}function BS(A){A=A|0,i[A>>2]=94852,Z(A)}function vS(A){A=A|0,i[A>>2]=97280,Z(A)}function mS(A){A=A|0,i[A>>2]=90044,Z(A)}function ZS(A){A=A|0,i[A>>2]=91364,Z(A)}function GS(A){A=A|0,i[A>>2]=94892,Z(A)}function XS(A){A=A|0,i[A>>2]=90084,Z(A)}function WS(A){A=A|0,i[A>>2]=92684,Z(A)}function QS(A){A=A|0,i[A>>2]=94004,Z(A)}function gS(A){A=A|0,i[A>>2]=91404,Z(A)}function VS(A){A=A|0,i[A>>2]=94944,Z(A)}function FS(A){A=A|0,i[A>>2]=90124,Z(A)}function IS(A){A=A|0,i[A>>2]=90164,Z(A)}function CS(A){A=A|0,i[A>>2]=91484,Z(A)}function pS(A){A=A|0,i[A>>2]=94084,Z(A)}function yS(A){A=A|0,i[A>>2]=94984,Z(A)}function ES(A){A=A|0,i[A>>2]=92844,Z(A)}function YS(A){A=A|0,i[A>>2]=97464,Z(A)}function RS(A){A=A|0,i[A>>2]=90204,Z(A)}function JS(A){A=A|0,i[A>>2]=91524,Z(A)}function NS(A){A=A|0,i[A>>2]=94124,Z(A)}function US(A){A=A|0,i[A>>2]=95024,Z(A)}function DS(A){A=A|0,i[A>>2]=92884,Z(A)}function MS(A){A=A|0,i[A>>2]=90244,Z(A)}function HS(A){A=A|0,i[A>>2]=91564,Z(A)}function zS(A){A=A|0,i[A>>2]=94164,Z(A)}function xS(A){A=A|0,i[A>>2]=98464,Z(A)}function TS(A){A=A|0,i[A>>2]=90284,Z(A)}function SS(A){A=A|0,i[A>>2]=91604,Z(A)}function jS(A){A=A|0,i[A>>2]=96864,Z(A)}function OS(A){A=A|0,i[A>>2]=93004,Z(A)}function PS(A){A=A|0,i[A>>2]=94204,Z(A)}function LS(A){A=A|0,i[A>>2]=90324,Z(A)}function KS(A){A=A|0,i[A>>2]=91644,Z(A)}function qS(A){A=A|0,i[A>>2]=93044,Z(A)}function aS(A){A=A|0,i[A>>2]=94244,Z(A)}function $S(A){A=A|0,i[A>>2]=96904,Z(A)}function dS(A){A=A|0,i[A>>2]=97584,Z(A)}function cS(A){A=A|0,i[A>>2]=90364,Z(A)}function bS(A){A=A|0,i[A>>2]=91684,Z(A)}function ij(A,e){A=A|0,e=e|0,oe(A,11885)}function ej(A){A=A|0,i[A>>2]=90404,Z(A)}function rj(A){A=A|0,i[A>>2]=91804,Z(A)}function fj(A){A=A|0,i[A>>2]=93164,Z(A)}function Aj(A){A=A|0,i[A>>2]=95980,Z(A)}function kj(A,e){A=A|0,e=e|0,ti(A,79216)}function nj(A,e){A=A|0,e=e|0,oe(A,12200)}function tj(A){A=A|0,i[A>>2]=90524,Z(A)}function uj(A){A=A|0,i[A>>2]=91844,Z(A)}function oj(A){A=A|0,i[A>>2]=93204,Z(A)}function lj(A){A=A|0,i[A>>2]=96020,Z(A)}function sj(A,e){A=A|0,e=e|0,ti(A,79236)}function wj(A){A=A|0,i[A>>2]=90564,Z(A)}function hj(A){A=A|0,i[A>>2]=96060,Z(A)}function _j(A){A=A|0,i[A>>2]=91884,Z(A)}function Bj(A){A=A|0,i[A>>2]=95288,Z(A)}function vj(A){A=A|0,i[A>>2]=90684,Z(A)}function mj(A){A=A|0,i[A>>2]=93324,Z(A)}function Zj(A){A=A|0,V3(107704,i[26927])}function Gj(A){A=A|0,i[A>>2]=96100,Z(A)}function Xj(A){A=A|0,i[A>>2]=99640,Z(A)}function Wj(A){A=A|0,i[A>>2]=91924,Z(A)}function Qj(A){A=A|0,m3(107716,i[26930])}function gj(A){A=A|0,i[A>>2]=90724,Z(A)}function Vj(A){A=A|0,i[A>>2]=93364,Z(A)}function Fj(A){A=A|0,i[A>>2]=94424,Z(A)}function Ij(A){A=A|0,i[A>>2]=96140,Z(A)}function Cj(A){A=A|0,Y1(107792,i[26949])}function pj(A){A=A|0,i[A>>2]=91964,Z(A)}function yj(A){A=A|0,Y1(107804,i[26952])}function Ej(A){A=A|0,i[A>>2]=90844,Z(A)}function Yj(A){A=A|0,i[A>>2]=93404,Z(A)}function Rj(A){A=A|0,i[A>>2]=96180,Z(A)}function Jj(A){A=A|0,Y1(107816,i[26955])}function Nj(A){A=A|0,i[A>>2]=92004,Z(A)}function Uj(A){A=A|0,i[A>>2]=94464,Z(A)}function Dj(A){A=A|0,i[A>>2]=90884,Z(A)}function Mj(A){A=A|0,i[A>>2]=93444,Z(A)}function Hj(A){A=A|0,i[A>>2]=92044,Z(A)}function zj(A){A=A|0,i[A>>2]=90924,Z(A)}function xj(A){A=A|0,i[A>>2]=91444,Z(A)}function Tj(A){A=A|0,i[A>>2]=92724,Z(A)}function Sj(A){A=A|0,i[A>>2]=94044,Z(A)}function Ns(A,e){A=A|0,e=e|0,eu(A,1,45)}function jj(A,e){A=A|0,e=e|0,u[A+4|0]=e}function Us(A,e){A=A|0,e=e|0,Et(A,1,45)}function Oj(A){return A=A|0,i[A+448>>2]}function Ds(A){return A=A|0,W[A|0]()|0}function Pj(A){return A=A|0,i[A+124>>2]}function y5(A,e){A=A|0,e=e|0,W[A|0](e)}function Lj(A){return A=A|0,y3(A-8|0)|0}function Kj(A){return A=A|0,i[A+288>>2]}function qj(A){return A=A|0,H6(A-8|0)|0}function Ms(A,e){return A=A|0,e=e|0,e|0}function aj(A){return A=A|0,1635150182}function Hs(A){return A=A|0,1785750887}function $j(A){return A=A|0,1781689137}function dj(A){return A=A|0,1768187246}function cj(A){return A=A|0,1852009592}function zs(A,e){return(Zi(A,e)|0)!=-1}function bj(A){return A=A|0,i[A+16>>2]}function iO(A){return A=A|0,1635148593}function eO(A){return A=A|0,1635148649}function rO(A){return A=A|0,1953066089}function R3(A){return A=A|0,2147483647}function fO(A,e){A=A|0,e=e|0,i[A>>2]=e}function AO(A){return A=A|0,1987471715}function kO(A){return A=A|0,1735551332}function nO(A){return A=A|0,i[A+20>>2]}function tO(A){return A=A|0,1836280681}function uO(A){return A=A|0,1987470129}function xs(A){return A=A|0,i[A+12>>2]}function oO(A){return A=A|0,1768912492}function lO(A){return A=A|0,1635135537}function sO(A){return A=A|0,1781689193}function wO(A){return A=A|0,1752589105}function hO(A,e){return A=A|0,e=e|0,0}function Ts(A){return A=A|0,l[A+48|0]}function Ss(){Z(i[31252]),i[31252]=0}function E5(A){return A=A|0,i[A+4>>2]}function J3(A,e){return A=A|0,e=e|0,-1}function _O(A){return A=A|0,gn(A,0)|0}function BO(A){return A=A|0,gn(A,1)|0}function L2(A,e){return jo(A)^jo(e)^1}function K2(A,e){return So(A)^So(e)^1}function vO(A){return A=A|0,Gn(A,0)|0}function mO(A){return A=A|0,Gn(A,1)|0}function js(A){return A=A|0,i[A+8>>2]}function De(A){return y2(A+80|0)+80|0}function ZO(A){return A=A|0,l[A+96|0]}function GO(A){return A=A|0,A>>>0<2|0}function Os(A,e,r){A=A|0,e=e|0,r=r|0}function N3(A){return A=A|0,l[A+4|0]}function XO(A){return A=A|0,u[A+8|0]}function WO(A){return A=A|0,u[A+9|0]}function m4(A,e){H1(A,i[A+16>>2]|e)}function Ps(A){return A=A|0,y0(A)|0}function q1(A){return Fl(i[A>>2]),A}function a1(A){return Vl(i[A>>2]),A}function QO(A){return A=A|0,107984}function gO(A){return A=A|0,11833}function VO(A){return A=A|0,14100}function FO(A){return A=A|0,13123}function IO(A){return A=A|0,12808}function CO(A){return A=A|0,19591}function pO(A){return A=A|0,11144}function yO(A){return A=A|0,12288}function EO(A){return A=A|0,96284}function YO(A){return A=A|0,96352}function RO(A){return A=A|0,96416}function JO(A){return A=A|0,15463}function NO(A){return A=A|0,13893}function UO(A){return A=A|0,12828}function DO(A){return A=A|0,18942}function MO(A){return A=A|0,12184}function HO(A){return A=A|0,15525}function zO(A){return A=A|0,18405}function xO(A){return A=A|0,10206}function TO(A){return A=A|0,21770}function x2(A){A=A|0,A&&Z(A)}function SO(A){return A=A|0,15494}function jO(A){return A=A|0,18979}function OO(A){return A=A|0,19441}function PO(A){return A=A|0,15478}function U3(A){return A=A|0,19026}function LO(A){return A=A|0,13099}function KO(A){return A=A|0,17944}function qO(A){return A=A|0,12960}function aO(A){return A=A|0,10790}function $O(A){return A=A|0,15445}function dO(A){return A=A|0,13880}function cO(A){return A=A|0,13072}function bO(A){return A=A|0,10190}function iP(A){return A=A|0,19834}function eP(A){return A=A|0,8519}function rP(A){A=A|0,u[A+97|0]=0}function fP(A){return A=A|0,1499}function AP(A){return A=A|0,8323}function kP(A){return A=A|0,4485}function nP(A){return A=A|0,5481}function tP(A){return A=A|0,7053}function uP(A){return A=A|0,4504}function oP(A){return A=A|0,1515}function lP(A){return A=A|0,8493}function sP(A){return A=A|0,7077}function wP(A){return A=A|0,5757}function hP(A){return A=A|0,8280}function _P(A){return A=A|0,7782}function BP(A){A=A|0,E0(A),Z(A)}function vP(A){return A=A|0,8096}function Ls(A,e,r){Ur(A,e,r,0,0)}function mP(A){return A=A|0,6290}function ZP(A){return A=A|0,3623}function GP(A){return A=A|0,6883}function XP(A){A=A|0,u[A+97|0]=1}function WP(A){return A=A|0,5182}function QP(A){return A=A|0,4748}function gP(A){return A=A|0,7762}function VP(A){return A=A|0,4693}function FP(A){return A=A|0,8412}function IP(A){return A=A|0,7447}function Ks(A){A=A|0,y0(A),Z(A)}function CP(A){return A=A|0,7434}function pP(A){A=A|0,I5(A),Z(A)}function yP(A){return A=A|0,5422}function EP(A){return A=A|0,7484}function YP(A){return A=A|0,7460}function RP(A){return A=A|0,7479}function JP(A){return A=A|0,9663}function NP(A){return A=A|0,8340}function UP(A){return A=A|0,8121}function DP(A){return A=A|0,7954}function MP(A){return A=A|0,8429}function Y5(A){A=A|0,Ql(A),Z(A)}function HP(A){return A=A|0,3613}function zP(A){return A=A|0,8227}function xP(A){return A=A|0,8140}function TP(A){return A=A|0,8358}function SP(A){A=A|0,se(A),Z(A)}function jP(A){return A=A|0,3766}function OP(A){return A=A|0,2917}function PP(A){return A=A|0,2893}function LP(A){return A=A|0,8079}function KP(A){return A=A|0,8390}function qP(A){return A=A|0,9650}function aP(A){return A=A|0,7892}function $P(A){return A=A|0,4189}function dP(A){A=A|0,s2(107640)}function cP(A){A=A|0,R1(129880)}function bP(A){A=A|0,s2(107652)}function iL(A){A=A|0,R1(129896)}function eL(A){A=A|0,s2(129912)}function rL(A){A=A|0,R1(129928)}function fL(A){A=A|0,s2(129944)}function N4(A){return A=A|0,A|0}function R5(A,e){return l0=A,e}function AL(A){A=A|0,R1(129960)}function D3(A){return A=A|0,127}function J5(A){A=A|0,Z(E3(A))}function kL(A){A=A|0,Z(zt(A))}function nL(A){A=A|0,Z(at(A))}function N5(A){A=A|0,Z(Y3(A))}function qs(A){A=A|0,Z(E0(A))}function U5(A){A=A|0,Z(y3(A))}function tL(A){A=A|0,Z(Mt(A))}function as(A){A=A|0,Z(I5(A))}function D5(A){A=A|0,Z(H6(A))}function uL(A){A=A|0,Z(y0(A))}function M5(A){A=A|0,Z(T1(A))}function H5(A){return A=A|0,5}function oL(A){A=A|0,Z(Ol(A))}function lL(A){A=A|0,Z(Wt(A))}function sL(A){A=A|0,Z(bl(A))}function wL(A){A=A|0,U5(A-8|0)}function hL(A){A=A|0,Z(hs(A))}function _L(A){A=A|0,Z(_s(A))}function BL(A){A=A|0,Z(dn(A))}function $s(A){A=A|0,Z(X5(A))}function Me(A,e){u2(A,e&65535)}function ds(A){A=A|0,Z(l5(A))}function cs(A){A=A|0,Z(t5(A))}function vL(A){A=A|0,Z(ai(A))}function mL(A){A=A|0,Z(b7(A))}function ZL(A){A=A|0,Z(g5(A))}function bs(A){A=A|0,Z(u5(A))}function GL(A){A=A|0,D5(A-8|0)}function XL(A){A=A|0,Z(xu(A))}function O2(A){A=A|0,Z(A2(A))}function y1(A){return A=A|0,1}function iw(A){return A=A|0,3}function ew(A){return A=A|0,7}function rw(){return 18153984}function U4(A){return A=A|0,2}function c2(A){return A=A|0,0}function M3(A){return A=A|0,-1}function WL(A){return A=A|0,9}function T6(A){return A=A|0,4}function fw(A){jl(A,i[A>>2])}function w8(A,e){A=A|0,e=e|0}function Q0(){Q5(11043),H()}function G0(){Q5(6307),H()}function w0(A){A=A|0,Z(A)}function QL(){return 95520}function gL(){return 21606}function VL(){return 95608}function FL(){return 10185}function IL(){return 21340}function H3(A){A=A|0,H()}function CL(){return 21}function g1(){C_(),H()}function Z4(){g1(),H()}function pL(){return 2}function yL(){return 1}function B6(A){A=A|0}function EL(){$o()}function YL(){Gl()}function RL(){}c=l,q0(h1);var W=i0([null,Ql,XE,JE,WR,Wl,iF,xy,DE,F3,F3,GY,VY,eD,Wl,bI,Uy,dJ,F3,F3,KN,cN,iU,iR,MJ,UJ,ZB,vY,mY,H3,Z4,AU,N4,XJ,xJ,c2,Xr,c2,at,nL,eP,DB,y1,eG,gV,Os,uW,c2,ZO,c2,b_,XY,_V,A2,O2,qO,xm,fg,B6,U4,aQ,JY,Yt,O2,jP,yZ,aV,U4,XF,O2,Y2,ig,$X,TR,lJ,Xm,Xg,GZ,uN,xN,FZ,FX,Pj,yy,xR,uJ,UO,mm,hg,ev,O2,HO,Y2,qF,yg,O2,zO,A6,rP,Oy,tN,TN,$O,wZ,rV,_Q,O2,qP,uX,xV,FD,QV,Hy,Py,fP,zv,yW,vR,BZ,O2,AP,A6,RQ,BU,MI,O2,nP,A6,Fi,O2,tP,BX,Fi,O2,uP,sG,tF,uY,c2,IV,Kp,iy,lP,FB,mW,GC,Uv,tY,_Y,wP,am,Eg,y1,PX,O2,hP,fX,WF,y1,y1,y1,hI,O2,pO,QG,EF,y1,y1,y1,GI,O2,yO,YZ,Zg,y1,y1,y1,Ym,NC,zC,JO,cv,BW,wC,pB,SR,oJ,DO,OZ,DF,WQ,O2,ZP,A6,Fi,jR,Ll,kn,ug,pf,Ll,GP,EZ,Wm,IE,ME,gP,Lm,xW,y1,eX,O2,FP,A6,Fi,O2,SO,A6,Hm,PG,oN,zN,OO,KG,LV,FQ,LR,_J,NP,qZ,tg,U4,vX,O2,DP,oG,oF,U4,aF,O2,zP,AX,yF,U4,WI,O2,TP,lG,lF,U4,cF,O2,OP,Mm,CW,U4,SW,O2,PP,tm,vG,U4,Rv,Sy,Ly,LP,zm,TV,U4,eW,O2,KP,Nv,GV,Jp,bg,O2,aP,nZ,zV,Pp,dg,_N,SN,iP,qG,RF,y1,c2,c2,jW,BN,jN,VO,$G,YF,U4,gg,JM,QT,x0,hO,w0,zM,CT,x0,w0,LM,RT,x0,w0,dM,DT,x0,w0,fH,jT,x0,w0,uH,qT,x0,w0,BH,iS,x0,w0,QH,kS,x0,w0,pH,sS,x0,w0,NH,mS,x0,w0,HH,XS,x0,w0,SH,FS,x0,w0,rx,IS,x0,w0,bH,RS,x0,w0,Az,MS,x0,w0,oz,TS,x0,w0,_z,LS,x0,w0,Xz,cS,x0,w0,gz,ej,x0,w0,rN,x6,vv,lm,Mv,Cz,tj,x0,w0,Yz,wj,x0,w0,x6,Dz,vj,x0,w0,xz,gj,x0,w0,x6,Pz,Ej,x0,w0,az,Dj,x0,w0,cz,zj,x0,w0,pM,mT,x0,w0,NM,gT,x0,w0,xM,pT,x0,w0,KM,JT,x0,w0,cM,MT,x0,w0,AH,OT,x0,w0,oH,aT,x0,w0,vH,eS,x0,w0,gH,nS,x0,w0,yH,wS,x0,w0,UH,ZS,x0,w0,zH,gS,x0,w0,PH,xj,x0,w0,LH,CS,x0,w0,iz,JS,x0,w0,kz,HS,x0,w0,lz,SS,x0,w0,Bz,KS,x0,w0,Wz,bS,x0,w0,x6,Vz,rj,x0,w0,pz,uj,x0,w0,Rz,_j,x0,w0,zz,Wj,x0,w0,Oz,pj,x0,w0,qz,Nj,x0,w0,dz,Hj,x0,w0,x6,CM,ZT,x0,w0,UM,VT,x0,w0,TM,yT,x0,w0,qM,NT,x0,w0,bM,HT,x0,w0,x6,lH,$T,x0,w0,mH,rS,x0,w0,VH,tS,x0,w0,EH,hS,x0,w0,O2,NO,A6,Fi,DH,WS,x0,w0,jH,Tj,x0,w0,O2,xO,aH,ES,x0,w0,fz,DS,x0,w0,O2,jO,sz,OS,x0,w0,vz,qS,x0,w0,O2,MP,Fz,fj,x0,w0,yz,oj,x0,w0,O2,dO,Nz,mj,x0,w0,Tz,Vj,x0,w0,Lz,Yj,x0,w0,$z,Mj,x0,w0,bz,_T,x0,w0,yM,GT,x0,w0,DM,FT,x0,w0,SM,ET,x0,w0,aM,UT,x0,w0,iH,zT,x0,w0,O2,sP,tH,KT,x0,w0,hH,dT,x0,w0,GH,fS,x0,w0,IH,oS,x0,w0,RH,_S,x0,w0,xH,QS,x0,w0,OH,Sj,x0,w0,KH,pS,x0,w0,ez,NS,x0,w0,nz,zS,x0,w0,hz,PS,x0,w0,mz,aS,x0,w0,nD,tD,QU,C1,v4,C1,rF,vg,v4,C1,v4,C1,v4,C1,Sz,Fj,Rm,w0,QM,Uj,Ap,w0,ix,BT,x0,w0,AN,DN,OV,UV,jj,IW,WW,rQ,Cp,MF,Oj,U3,c2,vy,c2,rs,M3,M3,qN,MG,B6,c2,c2,zo,B6,ho,ho,XC,mG,fD,fp,kH,PT,nE,w0,_H,cT,iD,w0,FH,uS,E2,w0,YH,BS,x0,w0,MH,GS,x0,w0,w8,C1,TH,VS,TW,w0,qH,yS,x0,w0,rz,US,x0,w0,NJ,aJ,oY,lD,Fy,N4,PA,my,py,Gy,gU,CU,Iy,dn,BL,v4,C1,Uz,Bj,E2,w0,Zj,Qj,WJ,SJ,E5,UX,Vy,N4,w0,cj,CZ,Bp,cy,tE,hZ,SQ,hB,eH,xT,E2,w0,B6,ST,N4,w0,c2,Em,JJ,cY,w0,y1,Am,kl,pE,w0,U4,km,kl,EE,w0,T6,jv,c2,yE,QR,bR,wx,rB,Yp,Rp,XR,aR,H5,sB,ay,Iz,Aj,E2,w0,Ez,lj,E2,w0,Jz,hj,E2,w0,Mz,Gj,E2,w0,jz,Ij,E2,w0,Kz,Rj,E2,w0,v4,C1,By,Dp,wF,YY,aI,kJ,dR,AF,Dl,_I,XI,pY,im,Ds,rw,Ds,G9,y5,x4,C3,UA,y5,U6,C3,Yl,Rl,Rs,y5,x4,q9,Js,CF,Dl,MC,fC,AC,kC,nC,C3,qA,DU,Cu,EO,x4,YO,U6,RO,x4,aN,x2,Xs,vs,Xs,vs,mp,yU,uy,zI,r9,Cj,yj,Jj,v4,C1,v4,C1,v4,C1,v4,C1,v4,C1,w8,C1,PU,C1,w8,C1,v4,C1,v4,C1,v4,C1,IQ,wz,jS,Pm,w0,Zz,$S,E2,w0,v4,C1,b4,H3,Zv,qB,Zy,XZ,w8,C1,cR,Ny,rH,TT,x0,w0,nH,LT,x0,w0,wH,bT,x0,w0,WH,AS,x0,w0,CH,lS,x0,w0,JH,vS,x0,w0,lp,Wp,wO,TO,zo,y1,Z5,qg,ag,iG,QX,ii,O_,Wv,gi,Vi,dH,YS,E2,w0,KF,$F,JP,iB,iv,y1,hv,Gz,dS,x0,w0,N4,w0,v4,C1,AE,_E,y1,YD,RD,jp,Zm,EV,HV,c2,wv,N3,Nm,AY,ou,bZ,_p,Ip,lO,U3,T6,Z5,aj,VX,ii,gi,Vi,EM,XT,E2,w0,ZI,II,Gv,N3,iX,rY,nF,cZ,eE,sE,T6,dN,C5,kI,rp,$R,sJ,Qv,Kg,y1,Fm,O2,oX,tC,VI,O2,LG,Cg,iV,wp,Qp,Hs,iw,Z5,Hs,mX,ii,gi,Vi,tz,xS,E2,w0,KR,BJ,rX,oC,Vv,fE,hE,iw,TE,C5,BV,UI,FI,yI,GJ,_m,Ts,rZ,Z3,_u,sX,FC,C1,up,Gp,$j,ew,LF,sO,_Z,ii,gi,Vi,MM,IT,E2,w0,iE,lE,ew,Og,Sg,sy,rs,gI,Mu,vB,Ts,eZ,Z3,_u,jZ,Mu,MZ,OR,wJ,hG,fV,Yv,PR,hJ,BG,PV,xX,$C,bC,aZ,lX,HB,qR,vJ,_G,AV,Bm,O2,A6,y1,Fi,hp,Fp,uO,U3,H5,jG,AO,gX,ii,gi,Vi,Hz,Xj,E2,w0,kE,vE,H5,bN,C5,Op,dQ,yV,MV,ov,N3,Im,eY,ou,LZ,Mt,tL,IB,fv,y1,tB,op,Xp,iO,U3,U4,eO,XX,ii,gi,Vi,OD,px,E2,w0,Wt,lL,P_,a_,y1,um,by,uE,U4,pD,yD,Mp,LB,pV,DV,uv,N3,pm,fY,kV,KZ,O2,nX,rC,y1,JF,T1,M5,tO,y1,WL,wI,c2,lB,CB,M5,c2,v4,C1,tp,C1,UD,Zx,x0,w0,MD,Xx,x0,w0,xD,gx,x0,w0,SD,Fx,x0,w0,PD,yx,x0,w0,KD,Yx,x0,w0,aD,Jx,x0,w0,dD,Dx,x0,w0,iM,zx,x0,w0,IM,xx,x0,w0,kM,jx,x0,w0,RY,dY,kO,zu,ju,BI,TC,aB,T_,PW,cG,nG,N4,w0,wy,vU,w0,qE,iY,oO,dI,ju,hy,SC,$_,j_,tG,M5,dj,zu,DI,jQ,c2,q_,AG,pC,UC,rO,OM,EX,YX,ON,$m,pv,c2,S_,Tv,iC,kG,dy,C1,vp,cD,Mx,E2,w0,eM,wT,E2,w0,fM,Tx,E2,w0,N4,w0,PQ,fB,nM,Ox,E2,w0,w0,OQ,uB,uM,Lx,E2,w0,lM,qx,E2,w0,wM,$x,E2,w0,_M,iT,E2,w0,vM,rT,E2,w0,mM,AT,E2,w0,ZM,nT,E2,w0,XM,uT,E2,w0,WM,oT,E2,w0,gM,lT,E2,w0,FM,_x,E2,w0,w0,wX,eB,JD,mx,E2,w0,w0,hV,c_,ND,hx,E2,w0,DD,Gx,E2,w0,HD,Wx,E2,w0,zD,Qx,E2,w0,w0,YV,KB,TD,Vx,E2,w0,w0,RV,jB,jD,Cx,E2,w0,LD,Ex,E2,w0,qD,Rx,E2,w0,w0,zF,nB,$D,Ux,E2,w0,w0,xF,AB,bD,Hx,E2,w0,w0,TF,gB,rM,hT,E2,w0,w0,HF,GB,AM,Sx,E2,w0,w0,uQ,WB,tM,Px,E2,w0,w0,oQ,mB,oM,Kx,E2,w0,w0,lQ,EB,sM,ax,E2,w0,w0,sQ,VB,hM,dx,E2,w0,w0,dW,wB,w0,mQ,L_,w0,YI,TB,w0,AJ,Up,w0,dV,Fv,w0,vF,tv,w0,$W,MB,w0,eg,nv,w0,HW,dB,w0,KW,_v,w0,$I,OB,w0,_C,PB,w0,dX,em,w0,VC,XB,w0,aW,Iv,w0,BF,hm,w0,_F,Bv,w0,cV,dZ,O2,IP,mv,RW,G5,fm,O2,CP,xB,EW,G5,jm,O2,EP,Tm,$Q,G5,TX,O2,YP,TZ,oI,Yg,O2,RP,OX,CC,UF,IC,JC,UP,RZ,Mg,ym,jY,lR,LO,rG,WV,sv,OY,sR,cO,fG,hQ,XP,kv,LY,wR,bO,Km,tV,Lv,KY,hR,$P,PZ,mV,Wy,kX,qY,_R,gO,lZ,uV,gv,xY,AR,FO,ZG,VQ,tX,O2,kP,VZ,EI,vV,cJ,VN,IO,aG,Lu,Qg,x6,O2,oP,SZ,AI,wQ,iN,EN,CO,dG,Lu,Wg,TY,kR,_P,Gm,Ig,vx,WG,ZJ,zJ,TG,Z3,an,gC,EC,vP,sm,Z3,fR,Pv,O2,MO,vZ,pI,qC,SY,nR,WP,wm,JQ,SG,aY,tR,VP,Vm,TQ,LI,NX,DR,nJ,yP,Qm,bW,Lp,cp,PO,bv,NQ,kB,MR,tJ,HP,nm,qQ,DC,Kv,BM,eT,E2,w0,xC,PC,NY,UY,GM,tT,E2,w0,ai,vL,hf,BR,c2,Y9,w8,C1,VM,Bx,E2,w0,zt,kL,zB,om,fx,YE,w8,C1,bJ,pN,yv,FW,EL,YL,ZH,ty,eU,bF,cU,Fs,MU,CD,Sp,eI,NR,Uf,FL,GR,RL,CY,x2,v5,eR,v5,uR,v5,oR,QO,Ee,Ee,Ee,Ee,Ee,HY,w8,mR,zY,Os,B6,N4,w0,OG,vC,N4,H3,b7,mL,ZY,QN,ex,vT,uC,w0,RM,WT,ZN,w0,jM,YT,xI,w0,jI,uU,YR,ER,yR,gW,pR,CR,IR,XW,FR,VR,gR,QW,iW,cX,bX,Lg,bB,Hg,RJ,YJ,EJ,DW,CJ,IJ,FJ,NW,VJ,gJ,QJ,UW,kW,fW,AW,YQ,rv,lV,tQ,KQ,NV,xg,BQ,bQ,pF,VV,og,SI,$g,fI,NB,GD,XD,oD,sD,$N,Xv,xU,TU,JU,NU,jg,Pg,mg,$V,VF,qV,ZD,uD,UB,jX,_D,wD,gD,QD,Dv,RU,YU,zU,OU,Hv,wW,PY,w0,qv,mC,ZC,jC,w0,pQ,PI,w0,KX,BC,zn,mN,MW,FN,c2,UU,yB,cE,TI,XV,LA,E0,BP,w8,gs,Jl,Pl,c2,c2,Ng,M3,gY,J3,eF,J3,E3,J5,ms,ps,Y3,N5,Zs,ys,y3,U5,Lj,wL,bU,cH,I5,pP,w8,gs,Jl,Pl,c2,c2,lg,M3,QY,J3,FV,J3,E3,J5,ms,ps,Y3,N5,Zs,ys,g5,ZL,sW,fJ,dC,rI,LW,se,SP,CQ,hW,nW,JV,DG,ZZ,ep,wG,Ps,Ks,Ps,Ks,H6,D5,qj,GL,KU,YM,l5,ds,qU,HM,t5,cs,aU,PM,u5,bs,$U,$M,y0,uL,_U,qs,Ey,_O,BO,vQ,qs,LE,Ou,ky,EQ,as,Yy,vO,mO,GQ,as,KE,Ou,fy,MQ,Dy,Z,B6,dl,OJ,PJ,LJ,KJ,TJ,qJ,dP,cP,bP,iL,eL,rL,fL,AL,xu,XL,nx,Ol,oL,kN,VE,nN,FE,Ms,wY,HU,RE,bl,sL,DZ,bm,RC,ly,c2,iI,WU,hs,hL,XO,WO,cx,ij,nj,_s,_L,js,xs,bx,kj,sj,N4,w0,w0,JR,jy,Ky,qy,IN,mE,CN,ZE,Ms,lY,nU,gE,w0,Ml,Ml,Ne,y1,y1,zy,y1,w0,sn,un,Ne,c2,c2,yn,T6,w0,sn,un,Ne,c2,c2,yn,T6,w0,In,ln,Ne,c2,c2,pn,T6,w0,In,ln,Ne,c2,c2,pn,T6,N4,w0,np,GN,wE,N4,w0,yp,XN,oE,w0,QQ,HG,pG,zG,Bn,Bn,yG,kZ,tZ,cm,XG,w0,gQ,NG,VG,EG,_n,_n,FG,uZ,oZ,iZ,gG,w0,Vg,uI,OF,lI,PF,IX,IG,CI,w0,Gg,nI,SF,tI,jF,CX,CG,mI,N4,w0,U4,My,OC,Hp,zp,qp,lv,OI,cg,WE,YN,MN,VU,FU,N4,w0,U4,QC,HC,xp,Tp,ap,Av,HI,Dg,QE,RN,JN,gN,yN,X5,$s,Fg,X5,$s,ZW,w0,D3,D3,n8,n8,n8,Ns,c2,_6,_6,w0,D3,D3,n8,n8,n8,Ns,c2,_6,_6,w0,R3,R3,n8,n8,n8,Us,c2,_6,_6,w0,R3,R3,n8,n8,n8,Us,c2,_6,_6,w0,xG,pZ,w0,UG,Sm,w0,dm,gZ,w0,qm,QZ,w0,Cs,fU,w8,w0,Cs,HQ,w8,H3,w0,mP,w0,QP,N4,w0,B6,B6,Bs,w0,Bs,w0,gF,rJ,NI,HN,w0,UE,wg,BY,w0,rg,bG,gp,w0,$Z,w0,KO,w0,aO,w0,xP,Y5,E5,Y5,Y5]);function Aw(){return W1.byteLength/65536|0}function JL(A){A=A|0;var e=Aw()|0,r=e+A|0;if(e<r&&r<65536){var f=new ArrayBuffer(G(r,65536)),k=new Int8Array(f);k.set(u),u=new Int8Array(f),g=new Int16Array(f),i=new Int32Array(f),l=new Uint8Array(f),C=new Uint16Array(f),u0=new Uint32Array(f),p0=new Float32Array(f),t0=new Float64Array(f),W1=f,c=l}return e}return{P:Object.create(Object.prototype,{grow:{value:JL},buffer:{get:function(){return W1}}}),Q:Cv,R:W,S:B3,T:x2,U:ye,V:Qi,W:x2,X:lU,Y:XA,Z:WA,_:GA,$:xE,aa:aX,ba:iJ,ca:HJ,da:sY,ea:kD,fa:yY,ga:rw,ha:G9,ia:x4,ja:UA,ka:U6,la:Yl,ma:Rl,na:Rs,oa:x4,pa:q9,qa:Js,ra:qA,sa:Cu,ta:gL,ua:ao,va:Ju,wa:Un,xa:Z,ya:qf,za:Qn,Aa:xf,Ba:uz,Ca:Is,Da:p5,Ea:hi,Fa:ks,Ga:ns,Ha:Ws,Ia:Lt,Ja:Ro,Ka:y2,La:su,Ma:wu,Na:hu,Oa:Qu,Pa:yL,Qa:CL,Ra:pL,Sa:Np,Ta:DQ,Ua:x2,Va:pp,Wa:FY,Xa:IY,Ya:cW,Za:YB,_a:hF,$a:Ru,ab:Ru,bb:hi,cb:uF,db:Zp,eb:bV,fb:jr,gb:$J,hb:es,ib:es,jb:Df,kb:uo,lb:fo,mb:NN,nb:SU,ob:av,pb:bo,qb:Ao,rb:x2,sb:wo,tb:Io,ub:_g,vb:sV,wb:wo,xb:Io,yb:Bg,zb:wV,Ab:LX,Bb:vo,Cb:tU,Db:vN,Eb:GF,Fb:ts,Gb:ts,Hb:tx,Ib:gy,Jb:Tg,Kb:us,Lb:us,Mb:tW,Nb:sU,Ob:sC,Pb:Rg,Qb:ws,Rb:U6,Sb:NF,Tb:hU,Ub:zZ,Vb:KI,Wb:fF,Xb:oU,Yb:Ag,Zb:rW,_b:SV,$b:DX,ac:jV,bc:MX,cc:eo,dc:xn,ec:Fn,fc:eo,gc:xn,hc:Fn,ic:cQ,jc:LC,kc:ZX,lc:vm,mc:NZ,nc:pW,oc:oW,pc:lW,qc:RG,rc:JG,sc:hX,tc:zQ,uc:AZ,vc:WX,wc:HX,xc:YW,yc:oB,zc:Ev,Ac:PE,Bc:RB,Cc:JB,Dc:QB,Ec:Om,Fc:kg,Gc:zW,Hc:XQ,Ic:EU,Jc:nV,Kc:pU,Lc:ZF,Mc:x2,Nc:YG,Oc:SX,Pc:OW,Qc:os,Rc:fQ,Sc:pX,Tc:GG,Uc:os,Vc:QF,Wc:pg,Xc:JX,Yc:UQ,Zc:rm,_c:LQ,$c:AD,ad:Ix,bd:kT,cd:U6,dd:XH,ed:_y,fd:Ax,gd:dF,hd:kx,id:Nx,jd:WC,kd:XU,ld:LU,md:zg,nd:mZ,od:SA,pd:kA,qd:x2,rd:$H,sd:sp,td:_B,ud:$B,vd:WY,wd:fN,xd:ED,yd:xs,zd:QI,Ad:WD,Bd:jE,Cd:WN,Dd:x2,Ed:fO,Fd:Fs,Gd:Vp,Hd:f5,Id:A3,Jd:fT,Kd:kY,Ld:Xy,Md:x2,Nd:vW,Od:VD,Pd:IF,Qd:xQ,Rd:$v,Sd:OE,Td:CE,Ud:sT,Vd:Jv,Wd:$E,Xd:AQ,Yd:yC,Zd:Pu,_d:DY,$d:oV,ae:nY,be:ux,ce:bj,de:eN,ee:SE,fe:kU,ge:ny,he:uG,ie:sI,je:kQ,ke:_X,le:Jm,me:WZ,ne:Um,oe:IZ,pe:kp,qe:kF,re:Yo,se:Jy,te:Qy,ue:bE,ve:RX,we:QL,xe:W9,ye:x2,ze:HZ,Ae:xZ,Be:BE,Ce:JW,De:GO,Ee:eC,Fe:eV,Ge:bp,He:dp,Ie:ey,Je:ng,Ke:$p,Le:dv,Me:ip,Ne:aC,Oe:CV,Pe:KC,Qe:rD,Re:dE,Se:Ep,Te:VW,Ue:x2,Ve:nQ,We:wU,Xe:yX,Ye:UZ,Ze:cB,_e:M6,$e:Sr,af:x2,bf:GE,cf:cI,df:GW,ef:Dm,ff:al,gf:JZ,hf:al,jf:Ov,kf:$y,lf:VL,mf:jU,nf:qX,of:rR,pf:Ry,qf:RI,rf:Gs,sf:lx,tf:sx,uf:Es,vf:Ys,wf:Ty,xf:sF,yf:eJ,zf:Gs,Af:HE,Bf:zE,Cf:Ay,Df:IU,Ef:E5,Ff:js,Gf:YC,Hf:FF,If:Cy,Jf:Dn,Kf:lN,Lf:Ug,Mf:sN,Nf:wN,Of:hN,Pf:mJ,Qf:mF,Rf:yQ,Sf:_W,Tf:iQ,Uf:ry,Vf:Cm,Wf:K_,Xf:$Y,Yf:JI,Zf:qI,_f:Es,$f:Ys,ag:vI,bg:ID,cg:ox,dg:sZ,eg:sH,fg:dU,gg:Is,hg:ZU,ig:GU,jg:cC,kg:pJ,lg:yJ,mg:KV,ng:hY,og:Pu,pg:xv,qg:rE,rg:zX,sg:ZV,tg:sg,ug:fZ,vg:MY,wg:C7,xg:Sv,yg:qW,zg:ZQ,Ag:BB,Bg:SB,Cg:d_,Dg:EY,Eg:oy,Fg:x2,Gg:HR,Hg:gm,Ig:U6,Jg:mU,Kg:hC,Lg:Jg,Mg:ws,Ng:lC,Og:eQ,Pg:GX,Qg:Vf,Rg:Qe,Sg:IL,Tg:$o,Ug:Gl,Vg:so,Wg:jJ,Xg:As,Yg:Qz,Zg:Do,_g:Kj,$g:nO,ah:PN,bh:LN,ch:RR,dh:Jo,eh:BD,fh:vD,gh:mD,hh:hD,ih:ol,jh:ZR,kh:A8,lh:C3,mh:rU,nh:bY,oh:UR,ph:UN,qh:DJ,rh:zR,sh:aE,th:NE}}return x1(K)})(D)},instantiate:function(J,D){return{then:function(j){var K=new S6.Module(J);j({instance:new S6.Instance(K,D)})}}},RuntimeError:Error,isWasm2js:!0};S6.isWasm2js&&(xe=[]);var Te,Ok=!1,Q4,p4,Y8,Ui,J2,A1,Pk,Lk,lw=!1,S3=J=>J.startsWith("file://");function Kk(){var J=Te.buffer;Q4=new Int8Array(J),Y8=new Int16Array(J),p4=new Uint8Array(J),Ui=new Uint16Array(J),J2=new Int32Array(J),A1=new Uint32Array(J),Pk=new Float32Array(J),Lk=new Float64Array(J)}function sw(){if(L.preRun)for(typeof L.preRun=="function"&&(L.preRun=[L.preRun]);L.preRun.length;)Xw(L.preRun.shift());ak(dk)}function ww(){lw=!0,!L.noFSInit&&!b.initialized&&b.init(),i6.init(),d.Q(),b.ignorePermissions=!1}function hw(){if(L.postRun)for(typeof L.postRun=="function"&&(L.postRun=[L.postRun]);L.postRun.length;)Gw(L.postRun.shift());ak($k)}var X6=0,Di=null;function SL(J){return J}function qk(J){var D;X6++,(D=L.monitorRunDependencies)==null||D.call(L,X6)}function j3(J){var j;if(X6--,(j=L.monitorRunDependencies)==null||j.call(L,X6),X6==0&&Di){var D=Di;Di=null,D()}}function Se(J){var j;(j=L.onAbort)==null||j.call(L,J),J="Aborted("+J+")",Ni(J),Ok=!0,J+=". Build with -sASSERTIONS for more info.";var D=new S6.RuntimeError(J);throw Z6(D),D}var Mi;function _w(){return ow("libheif.wasm")}function Bw(J){if(J==Mi&&xe)return new Uint8Array(xe);if(Ji)return Ji(J);throw\'sync fetching of the wasm failed: you can preload it to Module["wasmBinary"] manually, or emcc.py will do that for you when generating HTML (but not JS)\'}function vw(J,D){var j,K=Bw(J);j=new S6.Module(K);var i0=new S6.Instance(j,D);return[i0,j]}function mw(){return{a:__}}function Zw(){function J(K,i0){return d=K.exports,Te=d.P,Kk(),w7=d.R,j3("wasm-instantiate"),d}qk("wasm-instantiate");var D=mw();if(L.instantiateWasm)return new Promise((K,i0)=>{L.instantiateWasm(D,(c,h0)=>{K(J(c,h0))})});Mi!=null||(Mi=_w());var j=vw(Mi,D);return J(j[0])}var i1,u4;class jL{constructor(D){h8(this,"name","ExitStatus");this.message=`Program terminated with exit(${D})`,this.status=D}}var ak=J=>{for(;J.length>0;)J.shift()(L)},$k=[],Gw=J=>$k.push(J),dk=[],Xw=J=>dk.push(J),Ww=!0,ck=typeof TextDecoder!="undefined"?new TextDecoder:void 0,j6=(J,D=0,j=NaN)=>{for(var K=D+j,i0=D;J[i0]&&!(i0>=K);)++i0;if(i0-D>16&&J.buffer&&ck)return ck.decode(J.subarray(D,i0));for(var c="";D<i0;){var h0=J[D++];if(!(h0&128)){c+=String.fromCharCode(h0);continue}var Z0=J[D++]&63;if((h0&224)==192){c+=String.fromCharCode((h0&31)<<6|Z0);continue}var B0=J[D++]&63;if((h0&240)==224?h0=(h0&15)<<12|Z0<<6|B0:h0=(h0&7)<<18|Z0<<12|B0<<6|J[D++]&63,h0<65536)c+=String.fromCharCode(h0);else{var q0=h0-65536;c+=String.fromCharCode(55296|q0>>10,56320|q0&1023)}}return c},Hi=(J,D)=>J?j6(p4,J,D):"",Qw=(J,D,j,K)=>Se(`Assertion failed: ${Hi(J)}, at: `+[D?Hi(D):"unknown filename",j,K?Hi(K):"unknown function"]);class gw{constructor(D){this.excPtr=D,this.ptr=D-24}set_type(D){A1[this.ptr+4>>2]=D}get_type(){return A1[this.ptr+4>>2]}set_destructor(D){A1[this.ptr+8>>2]=D}get_destructor(){return A1[this.ptr+8>>2]}set_caught(D){D=D?1:0,Q4[this.ptr+12]=D}get_caught(){return Q4[this.ptr+12]!=0}set_rethrown(D){D=D?1:0,Q4[this.ptr+13]=D}get_rethrown(){return Q4[this.ptr+13]!=0}init(D,j){this.set_adjusted_ptr(0),this.set_type(D),this.set_destructor(j)}set_adjusted_ptr(D){A1[this.ptr+16>>2]=D}get_adjusted_ptr(){return A1[this.ptr+16>>2]}}var bk=0,Vw=0,Fw=(J,D,j)=>{var K=new gw(J);throw K.init(D,j),bk=J,Vw++,bk},je=()=>{var J=J2[+g4.varargs>>2];return g4.varargs+=4,J},O6=je,F1={isAbs:J=>J.charAt(0)==="/",splitPath:J=>{var D=/^(\\/?|)([\\s\\S]*?)((?:\\.{1,2}|[^\\/]+?|)(\\.[^.\\/]*|))(?:[\\/]*)$/;return D.exec(J).slice(1)},normalizeArray:(J,D)=>{for(var j=0,K=J.length-1;K>=0;K--){var i0=J[K];i0==="."?J.splice(K,1):i0===".."?(J.splice(K,1),j++):j&&(J.splice(K,1),j--)}if(D)for(;j;j--)J.unshift("..");return J},normalize:J=>{var D=F1.isAbs(J),j=J.slice(-1)==="/";return J=F1.normalizeArray(J.split("/").filter(K=>!!K),!D).join("/"),!J&&!D&&(J="."),J&&j&&(J+="/"),(D?"/":"")+J},dirname:J=>{var D=F1.splitPath(J),j=D[0],K=D[1];return!j&&!K?".":(K&&(K=K.slice(0,-1)),j+K)},basename:J=>J&&J.match(/([^\\/]+|\\/)\\/*$/)[1],join:(...J)=>F1.normalize(J.join("/")),join2:(J,D)=>F1.normalize(J+"/"+D)},Iw=()=>{if(G6){var J=Tk("crypto");return D=>J.randomFillSync(D)}return D=>crypto.getRandomValues(D)},i7=J=>{(i7=Iw())(J)},P6={resolve:(...J)=>{for(var D="",j=!1,K=J.length-1;K>=-1&&!j;K--){var i0=K>=0?J[K]:b.cwd();if(typeof i0!="string")throw new TypeError("Arguments to path.resolve must be strings");if(!i0)return"";D=i0+"/"+D,j=F1.isAbs(i0)}return D=F1.normalizeArray(D.split("/").filter(c=>!!c),!j).join("/"),(j?"/":"")+D||"."},relative:(J,D)=>{J=P6.resolve(J).slice(1),D=P6.resolve(D).slice(1);function j(q0){for(var a0=0;a0<q0.length&&q0[a0]==="";a0++);for(var m2=q0.length-1;m2>=0&&q0[m2]==="";m2--);return a0>m2?[]:q0.slice(a0,m2-a0+1)}for(var K=j(J.split("/")),i0=j(D.split("/")),c=Math.min(K.length,i0.length),h0=c,Z0=0;Z0<c;Z0++)if(K[Z0]!==i0[Z0]){h0=Z0;break}for(var B0=[],Z0=h0;Z0<K.length;Z0++)B0.push("..");return B0=B0.concat(i0.slice(h0)),B0.join("/")}},O3=[],Oe=J=>{for(var D=0,j=0;j<J.length;++j){var K=J.charCodeAt(j);K<=127?D++:K<=2047?D+=2:K>=55296&&K<=57343?(D+=4,++j):D+=3}return D},P3=(J,D,j,K)=>{if(!(K>0))return 0;for(var i0=j,c=j+K-1,h0=0;h0<J.length;++h0){var Z0=J.charCodeAt(h0);if(Z0>=55296&&Z0<=57343){var B0=J.charCodeAt(++h0);Z0=65536+((Z0&1023)<<10)|B0&1023}if(Z0<=127){if(j>=c)break;D[j++]=Z0}else if(Z0<=2047){if(j+1>=c)break;D[j++]=192|Z0>>6,D[j++]=128|Z0&63}else if(Z0<=65535){if(j+2>=c)break;D[j++]=224|Z0>>12,D[j++]=128|Z0>>6&63,D[j++]=128|Z0&63}else{if(j+3>=c)break;D[j++]=240|Z0>>18,D[j++]=128|Z0>>12&63,D[j++]=128|Z0>>6&63,D[j++]=128|Z0&63}}return D[j]=0,j-i0},e7=(J,D,j)=>{var K=j>0?j:Oe(J)+1,i0=new Array(K),c=P3(J,i0,0,i0.length);return D&&(i0.length=c),i0},Cw=()=>{if(!O3.length){var J=null;if(G6){var D=256,j=Buffer.alloc(D),K=0,i0=process.stdin.fd;try{K=T3.readSync(i0,j,0,D)}catch(c){if(c.toString().includes("EOF"))K=0;else throw c}K>0&&(J=j.slice(0,K).toString("utf-8"))}else typeof window!="undefined"&&typeof window.prompt=="function"&&(J=window.prompt("Input: "),J!==null&&(J+=`\n`));if(!J)return null;O3=e7(J,!0)}return O3.shift()},i6={ttys:[],init(){},shutdown(){},register(J,D){i6.ttys[J]={input:[],output:[],ops:D},b.registerDevice(J,i6.stream_ops)},stream_ops:{open(J){var D=i6.ttys[J.node.rdev];if(!D)throw new b.ErrnoError(43);J.tty=D,J.seekable=!1},close(J){J.tty.ops.fsync(J.tty)},fsync(J){J.tty.ops.fsync(J.tty)},read(J,D,j,K,i0){if(!J.tty||!J.tty.ops.get_char)throw new b.ErrnoError(60);for(var c=0,h0=0;h0<K;h0++){var Z0;try{Z0=J.tty.ops.get_char(J.tty)}catch(B0){throw new b.ErrnoError(29)}if(Z0===void 0&&c===0)throw new b.ErrnoError(6);if(Z0==null)break;c++,D[j+h0]=Z0}return c&&(J.node.atime=Date.now()),c},write(J,D,j,K,i0){if(!J.tty||!J.tty.ops.put_char)throw new b.ErrnoError(60);try{for(var c=0;c<K;c++)J.tty.ops.put_char(J.tty,D[j+c])}catch(h0){throw new b.ErrnoError(29)}return K&&(J.node.mtime=J.node.ctime=Date.now()),c}},default_tty_ops:{get_char(J){return Cw()},put_char(J,D){D===null||D===10?(ze(j6(J.output)),J.output=[]):D!=0&&J.output.push(D)},fsync(J){var D;((D=J.output)==null?void 0:D.length)>0&&(ze(j6(J.output)),J.output=[])},ioctl_tcgets(J){return{c_iflag:25856,c_oflag:5,c_cflag:191,c_lflag:35387,c_cc:[3,28,127,21,4,0,1,0,17,19,26,0,18,15,23,22,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0]}},ioctl_tcsets(J,D,j){return 0},ioctl_tiocgwinsz(J){return[24,80]}},default_tty1_ops:{put_char(J,D){D===null||D===10?(Ni(j6(J.output)),J.output=[]):D!=0&&J.output.push(D)},fsync(J){var D;((D=J.output)==null?void 0:D.length)>0&&(Ni(j6(J.output)),J.output=[])}}},r7=J=>{Se()},U2={ops_table:null,mount(J){return U2.createNode(null,"/",16895,0)},createNode(J,D,j,K){if(b.isBlkdev(j)||b.isFIFO(j))throw new b.ErrnoError(63);U2.ops_table||(U2.ops_table={dir:{node:{getattr:U2.node_ops.getattr,setattr:U2.node_ops.setattr,lookup:U2.node_ops.lookup,mknod:U2.node_ops.mknod,rename:U2.node_ops.rename,unlink:U2.node_ops.unlink,rmdir:U2.node_ops.rmdir,readdir:U2.node_ops.readdir,symlink:U2.node_ops.symlink},stream:{llseek:U2.stream_ops.llseek}},file:{node:{getattr:U2.node_ops.getattr,setattr:U2.node_ops.setattr},stream:{llseek:U2.stream_ops.llseek,read:U2.stream_ops.read,write:U2.stream_ops.write,mmap:U2.stream_ops.mmap,msync:U2.stream_ops.msync}},link:{node:{getattr:U2.node_ops.getattr,setattr:U2.node_ops.setattr,readlink:U2.node_ops.readlink},stream:{}},chrdev:{node:{getattr:U2.node_ops.getattr,setattr:U2.node_ops.setattr},stream:b.chrdev_stream_ops}});var i0=b.createNode(J,D,j,K);return b.isDir(i0.mode)?(i0.node_ops=U2.ops_table.dir.node,i0.stream_ops=U2.ops_table.dir.stream,i0.contents={}):b.isFile(i0.mode)?(i0.node_ops=U2.ops_table.file.node,i0.stream_ops=U2.ops_table.file.stream,i0.usedBytes=0,i0.contents=null):b.isLink(i0.mode)?(i0.node_ops=U2.ops_table.link.node,i0.stream_ops=U2.ops_table.link.stream):b.isChrdev(i0.mode)&&(i0.node_ops=U2.ops_table.chrdev.node,i0.stream_ops=U2.ops_table.chrdev.stream),i0.atime=i0.mtime=i0.ctime=Date.now(),J&&(J.contents[D]=i0,J.atime=J.mtime=J.ctime=i0.atime),i0},getFileDataAsTypedArray(J){return J.contents?J.contents.subarray?J.contents.subarray(0,J.usedBytes):new Uint8Array(J.contents):new Uint8Array(0)},expandFileStorage(J,D){var j=J.contents?J.contents.length:0;if(!(j>=D)){var K=1024*1024;D=Math.max(D,j*(j<K?2:1.125)>>>0),j!=0&&(D=Math.max(D,256));var i0=J.contents;J.contents=new Uint8Array(D),J.usedBytes>0&&J.contents.set(i0.subarray(0,J.usedBytes),0)}},resizeFileStorage(J,D){if(J.usedBytes!=D)if(D==0)J.contents=null,J.usedBytes=0;else{var j=J.contents;J.contents=new Uint8Array(D),j&&J.contents.set(j.subarray(0,Math.min(D,J.usedBytes))),J.usedBytes=D}},node_ops:{getattr(J){var D={};return D.dev=b.isChrdev(J.mode)?J.id:1,D.ino=J.id,D.mode=J.mode,D.nlink=1,D.uid=0,D.gid=0,D.rdev=J.rdev,b.isDir(J.mode)?D.size=4096:b.isFile(J.mode)?D.size=J.usedBytes:b.isLink(J.mode)?D.size=J.link.length:D.size=0,D.atime=new Date(J.atime),D.mtime=new Date(J.mtime),D.ctime=new Date(J.ctime),D.blksize=4096,D.blocks=Math.ceil(D.size/D.blksize),D},setattr(J,D){for(let j of["mode","atime","mtime","ctime"])D[j]!=null&&(J[j]=D[j]);D.size!==void 0&&U2.resizeFileStorage(J,D.size)},lookup(J,D){throw U2.doesNotExistError},mknod(J,D,j,K){return U2.createNode(J,D,j,K)},rename(J,D,j){var K;try{K=b.lookupNode(D,j)}catch(c){}if(K){if(b.isDir(J.mode))for(var i0 in K.contents)throw new b.ErrnoError(55);b.hashRemoveNode(K)}delete J.parent.contents[J.name],D.contents[j]=J,J.name=j,D.ctime=D.mtime=J.parent.ctime=J.parent.mtime=Date.now()},unlink(J,D){delete J.contents[D],J.ctime=J.mtime=Date.now()},rmdir(J,D){var j=b.lookupNode(J,D);for(var K in j.contents)throw new b.ErrnoError(55);delete J.contents[D],J.ctime=J.mtime=Date.now()},readdir(J){return[".","..",...Object.keys(J.contents)]},symlink(J,D,j){var K=U2.createNode(J,D,41471,0);return K.link=j,K},readlink(J){if(!b.isLink(J.mode))throw new b.ErrnoError(28);return J.link}},stream_ops:{read(J,D,j,K,i0){var c=J.node.contents;if(i0>=J.node.usedBytes)return 0;var h0=Math.min(J.node.usedBytes-i0,K);if(h0>8&&c.subarray)D.set(c.subarray(i0,i0+h0),j);else for(var Z0=0;Z0<h0;Z0++)D[j+Z0]=c[i0+Z0];return h0},write(J,D,j,K,i0,c){if(D.buffer===Q4.buffer&&(c=!1),!K)return 0;var h0=J.node;if(h0.mtime=h0.ctime=Date.now(),D.subarray&&(!h0.contents||h0.contents.subarray)){if(c)return h0.contents=D.subarray(j,j+K),h0.usedBytes=K,K;if(h0.usedBytes===0&&i0===0)return h0.contents=D.slice(j,j+K),h0.usedBytes=K,K;if(i0+K<=h0.usedBytes)return h0.contents.set(D.subarray(j,j+K),i0),K}if(U2.expandFileStorage(h0,i0+K),h0.contents.subarray&&D.subarray)h0.contents.set(D.subarray(j,j+K),i0);else for(var Z0=0;Z0<K;Z0++)h0.contents[i0+Z0]=D[j+Z0];return h0.usedBytes=Math.max(h0.usedBytes,i0+K),K},llseek(J,D,j){var K=D;if(j===1?K+=J.position:j===2&&b.isFile(J.node.mode)&&(K+=J.node.usedBytes),K<0)throw new b.ErrnoError(28);return K},mmap(J,D,j,K,i0){if(!b.isFile(J.node.mode))throw new b.ErrnoError(43);var c,h0,Z0=J.node.contents;if(!(i0&2)&&Z0&&Z0.buffer===Q4.buffer)h0=!1,c=Z0.byteOffset;else{if(h0=!0,c=r7(D),!c)throw new b.ErrnoError(48);Z0&&((j>0||j+D<Z0.length)&&(Z0.subarray?Z0=Z0.subarray(j,j+D):Z0=Array.prototype.slice.call(Z0,j,j+D)),Q4.set(Z0,c))}return{ptr:c,allocated:h0}},msync(J,D,j,K,i0){return U2.stream_ops.write(J,D,0,K,j,!1),0}}},pw=J=>v6(null,null,function*(){var D=yield x3(J);return new Uint8Array(D)}),yw=(...J)=>b.createDataFile(...J),f7=[],Ew=(J,D,j,K)=>{typeof Browser!="undefined"&&Browser.init();var i0=!1;return f7.forEach(c=>{i0||c.canHandle(D)&&(c.handle(J,D,j,K),i0=!0)}),i0},Yw=(J,D,j,K,i0,c,h0,Z0,B0,q0)=>{var a0=D?P6.resolve(F1.join2(J,D)):J,m2=`cp ${a0}`;function C2(B2){function t2(D2){q0==null||q0(),Z0||yw(J,D,D2,K,i0,B0),c==null||c(),j3(m2)}Ew(B2,a0,t2,()=>{h0==null||h0(),j3(m2)})||t2(B2)}qk(m2),typeof j=="string"?pw(j).then(C2,h0):C2(j)},Rw=J=>{var D={r:0,"r+":2,w:577,"w+":578,a:1089,"a+":1090},j=D[J];if(typeof j=="undefined")throw new Error(`Unknown file open mode: ${J}`);return j},L3=(J,D)=>{var j=0;return J&&(j|=365),D&&(j|=146),j},b={root:null,mounts:[],devices:{},streams:[],nextInode:1,nameTable:null,currentPath:"/",initialized:!1,ignorePermissions:!0,filesystems:null,syncFSRequests:0,readFiles:{},ErrnoError:class{constructor(J){h8(this,"name","ErrnoError");this.errno=J}},FSStream:class{constructor(){h8(this,"shared",{})}get object(){return this.node}set object(J){this.node=J}get isRead(){return(this.flags&2097155)!==1}get isWrite(){return(this.flags&2097155)!==0}get isAppend(){return this.flags&1024}get flags(){return this.shared.flags}set flags(J){this.shared.flags=J}get position(){return this.shared.position}set position(J){this.shared.position=J}},FSNode:class{constructor(J,D,j,K){h8(this,"node_ops",{});h8(this,"stream_ops",{});h8(this,"readMode",365);h8(this,"writeMode",146);h8(this,"mounted",null);J||(J=this),this.parent=J,this.mount=J.mount,this.id=b.nextInode++,this.name=D,this.mode=j,this.rdev=K,this.atime=this.mtime=this.ctime=Date.now()}get read(){return(this.mode&this.readMode)===this.readMode}set read(J){J?this.mode|=this.readMode:this.mode&=~this.readMode}get write(){return(this.mode&this.writeMode)===this.writeMode}set write(J){J?this.mode|=this.writeMode:this.mode&=~this.writeMode}get isFolder(){return b.isDir(this.mode)}get isDevice(){return b.isChrdev(this.mode)}},lookupPath(J,D={}){var q0;if(!J)throw new b.ErrnoError(44);(q0=D.follow_mount)!=null||(D.follow_mount=!0),F1.isAbs(J)||(J=b.cwd()+"/"+J);i:for(var j=0;j<40;j++){for(var K=J.split("/").filter(a0=>!!a0),i0=b.root,c="/",h0=0;h0<K.length;h0++){var Z0=h0===K.length-1;if(Z0&&D.parent)break;if(K[h0]!=="."){if(K[h0]===".."){if(c=F1.dirname(c),b.isRoot(i0)){J=c+"/"+K.slice(h0+1).join("/");continue i}else i0=i0.parent;continue}c=F1.join2(c,K[h0]);try{i0=b.lookupNode(i0,K[h0])}catch(a0){if((a0==null?void 0:a0.errno)===44&&Z0&&D.noent_okay)return{path:c};throw a0}if(b.isMountpoint(i0)&&(!Z0||D.follow_mount)&&(i0=i0.mounted.root),b.isLink(i0.mode)&&(!Z0||D.follow)){if(!i0.node_ops.readlink)throw new b.ErrnoError(52);var B0=i0.node_ops.readlink(i0);F1.isAbs(B0)||(B0=F1.dirname(c)+"/"+B0),J=B0+"/"+K.slice(h0+1).join("/");continue i}}}return{path:c,node:i0}}throw new b.ErrnoError(32)},getPath(J){for(var D;;){if(b.isRoot(J)){var j=J.mount.mountpoint;return D?j[j.length-1]!=="/"?`${j}/${D}`:j+D:j}D=D?`${J.name}/${D}`:J.name,J=J.parent}},hashName(J,D){for(var j=0,K=0;K<D.length;K++)j=(j<<5)-j+D.charCodeAt(K)|0;return(J+j>>>0)%b.nameTable.length},hashAddNode(J){var D=b.hashName(J.parent.id,J.name);J.name_next=b.nameTable[D],b.nameTable[D]=J},hashRemoveNode(J){var D=b.hashName(J.parent.id,J.name);if(b.nameTable[D]===J)b.nameTable[D]=J.name_next;else for(var j=b.nameTable[D];j;){if(j.name_next===J){j.name_next=J.name_next;break}j=j.name_next}},lookupNode(J,D){var j=b.mayLookup(J);if(j)throw new b.ErrnoError(j);for(var K=b.hashName(J.id,D),i0=b.nameTable[K];i0;i0=i0.name_next){var c=i0.name;if(i0.parent.id===J.id&&c===D)return i0}return b.lookup(J,D)},createNode(J,D,j,K){var i0=new b.FSNode(J,D,j,K);return b.hashAddNode(i0),i0},destroyNode(J){b.hashRemoveNode(J)},isRoot(J){return J===J.parent},isMountpoint(J){return!!J.mounted},isFile(J){return(J&61440)===32768},isDir(J){return(J&61440)===16384},isLink(J){return(J&61440)===40960},isChrdev(J){return(J&61440)===8192},isBlkdev(J){return(J&61440)===24576},isFIFO(J){return(J&61440)===4096},isSocket(J){return(J&49152)===49152},flagsToPermissionString(J){var D=["r","w","rw"][J&3];return J&512&&(D+="w"),D},nodePermissions(J,D){return b.ignorePermissions?0:D.includes("r")&&!(J.mode&292)||D.includes("w")&&!(J.mode&146)||D.includes("x")&&!(J.mode&73)?2:0},mayLookup(J){if(!b.isDir(J.mode))return 54;var D=b.nodePermissions(J,"x");return D||(J.node_ops.lookup?0:2)},mayCreate(J,D){if(!b.isDir(J.mode))return 54;try{var j=b.lookupNode(J,D);return 20}catch(K){}return b.nodePermissions(J,"wx")},mayDelete(J,D,j){var K;try{K=b.lookupNode(J,D)}catch(c){return c.errno}var i0=b.nodePermissions(J,"wx");if(i0)return i0;if(j){if(!b.isDir(K.mode))return 54;if(b.isRoot(K)||b.getPath(K)===b.cwd())return 10}else if(b.isDir(K.mode))return 31;return 0},mayOpen(J,D){return J?b.isLink(J.mode)?32:b.isDir(J.mode)&&(b.flagsToPermissionString(D)!=="r"||D&576)?31:b.nodePermissions(J,b.flagsToPermissionString(D)):44},checkOpExists(J,D){if(!J)throw new b.ErrnoError(D);return J},MAX_OPEN_FDS:4096,nextfd(){for(var J=0;J<=b.MAX_OPEN_FDS;J++)if(!b.streams[J])return J;throw new b.ErrnoError(33)},getStreamChecked(J){var D=b.getStream(J);if(!D)throw new b.ErrnoError(8);return D},getStream:J=>b.streams[J],createStream(J,D=-1){return J=Object.assign(new b.FSStream,J),D==-1&&(D=b.nextfd()),J.fd=D,b.streams[D]=J,J},closeStream(J){b.streams[J]=null},dupStream(J,D=-1){var K,i0;var j=b.createStream(J,D);return(i0=(K=j.stream_ops)==null?void 0:K.dup)==null||i0.call(K,j),j},doSetAttr(J,D,j){var K=J==null?void 0:J.stream_ops.setattr,i0=K?J:D;K!=null||(K=D.node_ops.setattr),b.checkOpExists(K,63),K(i0,j)},chrdev_stream_ops:{open(J){var j,K;var D=b.getDevice(J.node.rdev);J.stream_ops=D.stream_ops,(K=(j=J.stream_ops).open)==null||K.call(j,J)},llseek(){throw new b.ErrnoError(70)}},major:J=>J>>8,minor:J=>J&255,makedev:(J,D)=>J<<8|D,registerDevice(J,D){b.devices[J]={stream_ops:D}},getDevice:J=>b.devices[J],getMounts(J){for(var D=[],j=[J];j.length;){var K=j.pop();D.push(K),j.push(...K.mounts)}return D},syncfs(J,D){typeof J=="function"&&(D=J,J=!1),b.syncFSRequests++,b.syncFSRequests>1&&Ni(`warning: ${b.syncFSRequests} FS.syncfs operations in flight at once, probably just doing extra work`);var j=b.getMounts(b.root.mount),K=0;function i0(h0){return b.syncFSRequests--,D(h0)}function c(h0){if(h0)return c.errored?void 0:(c.errored=!0,i0(h0));++K>=j.length&&i0(null)}j.forEach(h0=>{if(!h0.type.syncfs)return c(null);h0.type.syncfs(h0,J,c)})},mount(J,D,j){var K=j==="/",i0=!j,c;if(K&&b.root)throw new b.ErrnoError(10);if(!K&&!i0){var h0=b.lookupPath(j,{follow_mount:!1});if(j=h0.path,c=h0.node,b.isMountpoint(c))throw new b.ErrnoError(10);if(!b.isDir(c.mode))throw new b.ErrnoError(54)}var Z0={type:J,opts:D,mountpoint:j,mounts:[]},B0=J.mount(Z0);return B0.mount=Z0,Z0.root=B0,K?b.root=B0:c&&(c.mounted=Z0,c.mount&&c.mount.mounts.push(Z0)),B0},unmount(J){var D=b.lookupPath(J,{follow_mount:!1});if(!b.isMountpoint(D.node))throw new b.ErrnoError(28);var j=D.node,K=j.mounted,i0=b.getMounts(K);Object.keys(b.nameTable).forEach(h0=>{for(var Z0=b.nameTable[h0];Z0;){var B0=Z0.name_next;i0.includes(Z0.mount)&&b.destroyNode(Z0),Z0=B0}}),j.mounted=null;var c=j.mount.mounts.indexOf(K);j.mount.mounts.splice(c,1)},lookup(J,D){return J.node_ops.lookup(J,D)},mknod(J,D,j){var K=b.lookupPath(J,{parent:!0}),i0=K.node,c=F1.basename(J);if(!c)throw new b.ErrnoError(28);if(c==="."||c==="..")throw new b.ErrnoError(20);var h0=b.mayCreate(i0,c);if(h0)throw new b.ErrnoError(h0);if(!i0.node_ops.mknod)throw new b.ErrnoError(63);return i0.node_ops.mknod(i0,c,D,j)},statfs(J){return b.statfsNode(b.lookupPath(J,{follow:!0}).node)},statfsStream(J){return b.statfsNode(J.node)},statfsNode(J){var D={bsize:4096,frsize:4096,blocks:1e6,bfree:5e5,bavail:5e5,files:b.nextInode,ffree:b.nextInode-1,fsid:42,flags:2,namelen:255};return J.node_ops.statfs&&Object.assign(D,J.node_ops.statfs(J.mount.opts.root)),D},create(J,D=438){return D&=4095,D|=32768,b.mknod(J,D,0)},mkdir(J,D=511){return D&=1023,D|=16384,b.mknod(J,D,0)},mkdirTree(J,D){var j=J.split("/"),K="";for(var i0 of j)if(i0){(K||F1.isAbs(J))&&(K+="/"),K+=i0;try{b.mkdir(K,D)}catch(c){if(c.errno!=20)throw c}}},mkdev(J,D,j){return typeof j=="undefined"&&(j=D,D=438),D|=8192,b.mknod(J,D,j)},symlink(J,D){if(!P6.resolve(J))throw new b.ErrnoError(44);var j=b.lookupPath(D,{parent:!0}),K=j.node;if(!K)throw new b.ErrnoError(44);var i0=F1.basename(D),c=b.mayCreate(K,i0);if(c)throw new b.ErrnoError(c);if(!K.node_ops.symlink)throw new b.ErrnoError(63);return K.node_ops.symlink(K,i0,J)},rename(J,D){var j=F1.dirname(J),K=F1.dirname(D),i0=F1.basename(J),c=F1.basename(D),h0,Z0,B0;if(h0=b.lookupPath(J,{parent:!0}),Z0=h0.node,h0=b.lookupPath(D,{parent:!0}),B0=h0.node,!Z0||!B0)throw new b.ErrnoError(44);if(Z0.mount!==B0.mount)throw new b.ErrnoError(75);var q0=b.lookupNode(Z0,i0),a0=P6.relative(J,K);if(a0.charAt(0)!==".")throw new b.ErrnoError(28);if(a0=P6.relative(D,j),a0.charAt(0)!==".")throw new b.ErrnoError(55);var m2;try{m2=b.lookupNode(B0,c)}catch(t2){}if(q0!==m2){var C2=b.isDir(q0.mode),B2=b.mayDelete(Z0,i0,C2);if(B2)throw new b.ErrnoError(B2);if(B2=m2?b.mayDelete(B0,c,C2):b.mayCreate(B0,c),B2)throw new b.ErrnoError(B2);if(!Z0.node_ops.rename)throw new b.ErrnoError(63);if(b.isMountpoint(q0)||m2&&b.isMountpoint(m2))throw new b.ErrnoError(10);if(B0!==Z0&&(B2=b.nodePermissions(Z0,"w"),B2))throw new b.ErrnoError(B2);b.hashRemoveNode(q0);try{Z0.node_ops.rename(q0,B0,c),q0.parent=B0}catch(t2){throw t2}finally{b.hashAddNode(q0)}}},rmdir(J){var D=b.lookupPath(J,{parent:!0}),j=D.node,K=F1.basename(J),i0=b.lookupNode(j,K),c=b.mayDelete(j,K,!0);if(c)throw new b.ErrnoError(c);if(!j.node_ops.rmdir)throw new b.ErrnoError(63);if(b.isMountpoint(i0))throw new b.ErrnoError(10);j.node_ops.rmdir(j,K),b.destroyNode(i0)},readdir(J){var D=b.lookupPath(J,{follow:!0}),j=D.node,K=b.checkOpExists(j.node_ops.readdir,54);return K(j)},unlink(J){var D=b.lookupPath(J,{parent:!0}),j=D.node;if(!j)throw new b.ErrnoError(44);var K=F1.basename(J),i0=b.lookupNode(j,K),c=b.mayDelete(j,K,!1);if(c)throw new b.ErrnoError(c);if(!j.node_ops.unlink)throw new b.ErrnoError(63);if(b.isMountpoint(i0))throw new b.ErrnoError(10);j.node_ops.unlink(j,K),b.destroyNode(i0)},readlink(J){var D=b.lookupPath(J),j=D.node;if(!j)throw new b.ErrnoError(44);if(!j.node_ops.readlink)throw new b.ErrnoError(28);return j.node_ops.readlink(j)},stat(J,D){var j=b.lookupPath(J,{follow:!D}),K=j.node,i0=b.checkOpExists(K.node_ops.getattr,63);return i0(K)},fstat(J){var D=b.getStreamChecked(J),j=D.node,K=D.stream_ops.getattr,i0=K?D:j;return K!=null||(K=j.node_ops.getattr),b.checkOpExists(K,63),K(i0)},lstat(J){return b.stat(J,!0)},doChmod(J,D,j,K){b.doSetAttr(J,D,{mode:j&4095|D.mode&-4096,ctime:Date.now(),dontFollow:K})},chmod(J,D,j){var K;if(typeof J=="string"){var i0=b.lookupPath(J,{follow:!j});K=i0.node}else K=J;b.doChmod(null,K,D,j)},lchmod(J,D){b.chmod(J,D,!0)},fchmod(J,D){var j=b.getStreamChecked(J);b.doChmod(j,j.node,D,!1)},doChown(J,D,j){b.doSetAttr(J,D,{timestamp:Date.now(),dontFollow:j})},chown(J,D,j,K){var i0;if(typeof J=="string"){var c=b.lookupPath(J,{follow:!K});i0=c.node}else i0=J;b.doChown(null,i0,K)},lchown(J,D,j){b.chown(J,D,j,!0)},fchown(J,D,j){var K=b.getStreamChecked(J);b.doChown(K,K.node,!1)},doTruncate(J,D,j){if(b.isDir(D.mode))throw new b.ErrnoError(31);if(!b.isFile(D.mode))throw new b.ErrnoError(28);var K=b.nodePermissions(D,"w");if(K)throw new b.ErrnoError(K);b.doSetAttr(J,D,{size:j,timestamp:Date.now()})},truncate(J,D){if(D<0)throw new b.ErrnoError(28);var j;if(typeof J=="string"){var K=b.lookupPath(J,{follow:!0});j=K.node}else j=J;b.doTruncate(null,j,D)},ftruncate(J,D){var j=b.getStreamChecked(J);if(D<0||(j.flags&2097155)===0)throw new b.ErrnoError(28);b.doTruncate(j,j.node,D)},utime(J,D,j){var K=b.lookupPath(J,{follow:!0}),i0=K.node,c=b.checkOpExists(i0.node_ops.setattr,63);c(i0,{atime:D,mtime:j})},open(J,D,j=438){if(J==="")throw new b.ErrnoError(44);D=typeof D=="string"?Rw(D):D,D&64?j=j&4095|32768:j=0;var K,i0;if(typeof J=="object")K=J;else{i0=J.endsWith("/");var c=b.lookupPath(J,{follow:!(D&131072),noent_okay:!0});K=c.node,J=c.path}var h0=!1;if(D&64)if(K){if(D&128)throw new b.ErrnoError(20)}else{if(i0)throw new b.ErrnoError(31);K=b.mknod(J,j|511,0),h0=!0}if(!K)throw new b.ErrnoError(44);if(b.isChrdev(K.mode)&&(D&=-513),D&65536&&!b.isDir(K.mode))throw new b.ErrnoError(54);if(!h0){var Z0=b.mayOpen(K,D);if(Z0)throw new b.ErrnoError(Z0)}D&512&&!h0&&b.truncate(K,0),D&=-131713;var B0=b.createStream({node:K,path:b.getPath(K),flags:D,seekable:!0,position:0,stream_ops:K.stream_ops,ungotten:[],error:!1});return B0.stream_ops.open&&B0.stream_ops.open(B0),h0&&b.chmod(K,j&511),L.logReadFiles&&!(D&1)&&(J in b.readFiles||(b.readFiles[J]=1)),B0},close(J){if(b.isClosed(J))throw new b.ErrnoError(8);J.getdents&&(J.getdents=null);try{J.stream_ops.close&&J.stream_ops.close(J)}catch(D){throw D}finally{b.closeStream(J.fd)}J.fd=null},isClosed(J){return J.fd===null},llseek(J,D,j){if(b.isClosed(J))throw new b.ErrnoError(8);if(!J.seekable||!J.stream_ops.llseek)throw new b.ErrnoError(70);if(j!=0&&j!=1&&j!=2)throw new b.ErrnoError(28);return J.position=J.stream_ops.llseek(J,D,j),J.ungotten=[],J.position},read(J,D,j,K,i0){if(K<0||i0<0)throw new b.ErrnoError(28);if(b.isClosed(J))throw new b.ErrnoError(8);if((J.flags&2097155)===1)throw new b.ErrnoError(8);if(b.isDir(J.node.mode))throw new b.ErrnoError(31);if(!J.stream_ops.read)throw new b.ErrnoError(28);var c=typeof i0!="undefined";if(!c)i0=J.position;else if(!J.seekable)throw new b.ErrnoError(70);var h0=J.stream_ops.read(J,D,j,K,i0);return c||(J.position+=h0),h0},write(J,D,j,K,i0,c){if(K<0||i0<0)throw new b.ErrnoError(28);if(b.isClosed(J))throw new b.ErrnoError(8);if((J.flags&2097155)===0)throw new b.ErrnoError(8);if(b.isDir(J.node.mode))throw new b.ErrnoError(31);if(!J.stream_ops.write)throw new b.ErrnoError(28);J.seekable&&J.flags&1024&&b.llseek(J,0,2);var h0=typeof i0!="undefined";if(!h0)i0=J.position;else if(!J.seekable)throw new b.ErrnoError(70);var Z0=J.stream_ops.write(J,D,j,K,i0,c);return h0||(J.position+=Z0),Z0},mmap(J,D,j,K,i0){if((K&2)!==0&&(i0&2)===0&&(J.flags&2097155)!==2)throw new b.ErrnoError(2);if((J.flags&2097155)===1)throw new b.ErrnoError(2);if(!J.stream_ops.mmap)throw new b.ErrnoError(43);if(!D)throw new b.ErrnoError(28);return J.stream_ops.mmap(J,D,j,K,i0)},msync(J,D,j,K,i0){return J.stream_ops.msync?J.stream_ops.msync(J,D,j,K,i0):0},ioctl(J,D,j){if(!J.stream_ops.ioctl)throw new b.ErrnoError(59);return J.stream_ops.ioctl(J,D,j)},readFile(J,D={}){if(D.flags=D.flags||0,D.encoding=D.encoding||"binary",D.encoding!=="utf8"&&D.encoding!=="binary")throw new Error(`Invalid encoding type "${D.encoding}"`);var j,K=b.open(J,D.flags),i0=b.stat(J),c=i0.size,h0=new Uint8Array(c);return b.read(K,h0,0,c,0),D.encoding==="utf8"?j=j6(h0):D.encoding==="binary"&&(j=h0),b.close(K),j},writeFile(J,D,j={}){j.flags=j.flags||577;var K=b.open(J,j.flags,j.mode);if(typeof D=="string"){var i0=new Uint8Array(Oe(D)+1),c=P3(D,i0,0,i0.length);b.write(K,i0,0,c,void 0,j.canOwn)}else if(ArrayBuffer.isView(D))b.write(K,D,0,D.byteLength,void 0,j.canOwn);else throw new Error("Unsupported data type");b.close(K)},cwd:()=>b.currentPath,chdir(J){var D=b.lookupPath(J,{follow:!0});if(D.node===null)throw new b.ErrnoError(44);if(!b.isDir(D.node.mode))throw new b.ErrnoError(54);var j=b.nodePermissions(D.node,"x");if(j)throw new b.ErrnoError(j);b.currentPath=D.path},createDefaultDirectories(){b.mkdir("/tmp"),b.mkdir("/home"),b.mkdir("/home/web_user")},createDefaultDevices(){b.mkdir("/dev"),b.registerDevice(b.makedev(1,3),{read:()=>0,write:(K,i0,c,h0,Z0)=>h0,llseek:()=>0}),b.mkdev("/dev/null",b.makedev(1,3)),i6.register(b.makedev(5,0),i6.default_tty_ops),i6.register(b.makedev(6,0),i6.default_tty1_ops),b.mkdev("/dev/tty",b.makedev(5,0)),b.mkdev("/dev/tty1",b.makedev(6,0));var J=new Uint8Array(1024),D=0,j=()=>(D===0&&(i7(J),D=J.byteLength),J[--D]);b.createDevice("/dev","random",j),b.createDevice("/dev","urandom",j),b.mkdir("/dev/shm"),b.mkdir("/dev/shm/tmp")},createSpecialDirectories(){b.mkdir("/proc");var J=b.mkdir("/proc/self");b.mkdir("/proc/self/fd"),b.mount({mount(){var D=b.createNode(J,"fd",16895,73);return D.stream_ops={llseek:U2.stream_ops.llseek},D.node_ops={lookup(j,K){var i0=+K,c=b.getStreamChecked(i0),h0={parent:null,mount:{mountpoint:"fake"},node_ops:{readlink:()=>c.path},id:i0+1};return h0.parent=h0,h0},readdir(){return Array.from(b.streams.entries()).filter(([j,K])=>K).map(([j,K])=>j.toString())}},D}},{},"/proc/self/fd")},createStandardStreams(J,D,j){J?b.createDevice("/dev","stdin",J):b.symlink("/dev/tty","/dev/stdin"),D?b.createDevice("/dev","stdout",null,D):b.symlink("/dev/tty","/dev/stdout"),j?b.createDevice("/dev","stderr",null,j):b.symlink("/dev/tty1","/dev/stderr");var K=b.open("/dev/stdin",0),i0=b.open("/dev/stdout",1),c=b.open("/dev/stderr",1)},staticInit(){b.nameTable=new Array(4096),b.mount(U2,{},"/"),b.createDefaultDirectories(),b.createDefaultDevices(),b.createSpecialDirectories(),b.filesystems={MEMFS:U2}},init(J,D,j){b.initialized=!0,J!=null||(J=L.stdin),D!=null||(D=L.stdout),j!=null||(j=L.stderr),b.createStandardStreams(J,D,j)},quit(){b.initialized=!1;for(var J of b.streams)J&&b.close(J)},findObject(J,D){var j=b.analyzePath(J,D);return j.exists?j.object:null},analyzePath(J,D){try{var j=b.lookupPath(J,{follow:!D});J=j.path}catch(i0){}var K={isRoot:!1,exists:!1,error:0,name:null,path:null,object:null,parentExists:!1,parentPath:null,parentObject:null};try{var j=b.lookupPath(J,{parent:!0});K.parentExists=!0,K.parentPath=j.path,K.parentObject=j.node,K.name=F1.basename(J),j=b.lookupPath(J,{follow:!D}),K.exists=!0,K.path=j.path,K.object=j.node,K.name=j.node.name,K.isRoot=j.path==="/"}catch(i0){K.error=i0.errno}return K},createPath(J,D,j,K){J=typeof J=="string"?J:b.getPath(J);for(var i0=D.split("/").reverse();i0.length;){var c=i0.pop();if(c){var h0=F1.join2(J,c);try{b.mkdir(h0)}catch(Z0){if(Z0.errno!=20)throw Z0}J=h0}}return h0},createFile(J,D,j,K,i0){var c=F1.join2(typeof J=="string"?J:b.getPath(J),D),h0=L3(K,i0);return b.create(c,h0)},createDataFile(J,D,j,K,i0,c){var h0=D;J&&(J=typeof J=="string"?J:b.getPath(J),h0=D?F1.join2(J,D):J);var Z0=L3(K,i0),B0=b.create(h0,Z0);if(j){if(typeof j=="string"){for(var q0=new Array(j.length),a0=0,m2=j.length;a0<m2;++a0)q0[a0]=j.charCodeAt(a0);j=q0}b.chmod(B0,Z0|146);var C2=b.open(B0,577);b.write(C2,j,0,j.length,0,c),b.close(C2),b.chmod(B0,Z0)}},createDevice(J,D,j,K){var Z0,B0;var i0=F1.join2(typeof J=="string"?J:b.getPath(J),D),c=L3(!!j,!!K);(B0=(Z0=b.createDevice).major)!=null||(Z0.major=64);var h0=b.makedev(b.createDevice.major++,0);return b.registerDevice(h0,{open(q0){q0.seekable=!1},close(q0){var a0;(a0=K==null?void 0:K.buffer)!=null&&a0.length&&K(10)},read(q0,a0,m2,C2,B2){for(var t2=0,D2=0;D2<C2;D2++){var r1;try{r1=j()}catch(M2){throw new b.ErrnoError(29)}if(r1===void 0&&t2===0)throw new b.ErrnoError(6);if(r1==null)break;t2++,a0[m2+D2]=r1}return t2&&(q0.node.atime=Date.now()),t2},write(q0,a0,m2,C2,B2){for(var t2=0;t2<C2;t2++)try{K(a0[m2+t2])}catch(D2){throw new b.ErrnoError(29)}return C2&&(q0.node.mtime=q0.node.ctime=Date.now()),t2}}),b.mkdev(i0,c,h0)},forceLoadFile(J){if(J.isDevice||J.isFolder||J.link||J.contents)return!0;if(typeof XMLHttpRequest!="undefined")throw new Error("Lazy loading should have been performed (contents set) in createLazyFile, but it was not. Lazy loading only works in web workers. Use --embed-file or --preload-file in emcc on the main thread.");try{J.contents=Ji(J.url),J.usedBytes=J.contents.length}catch(D){throw new b.ErrnoError(29)}},createLazyFile(J,D,j,K,i0){class c{constructor(){h8(this,"lengthKnown",!1);h8(this,"chunks",[])}get(B2){if(!(B2>this.length-1||B2<0)){var t2=B2%this.chunkSize,D2=B2/this.chunkSize|0;return this.getter(D2)[t2]}}setDataGetter(B2){this.getter=B2}cacheLength(){var B2=new XMLHttpRequest;if(B2.open("HEAD",j,!1),B2.send(null),!(B2.status>=200&&B2.status<300||B2.status===304))throw new Error("Couldn\'t load "+j+". Status: "+B2.status);var t2=Number(B2.getResponseHeader("Content-length")),D2,r1=(D2=B2.getResponseHeader("Accept-Ranges"))&&D2==="bytes",M2=(D2=B2.getResponseHeader("Content-Encoding"))&&D2==="gzip",o0=1024*1024;r1||(o0=t2);var H=(N1,K4)=>{if(N1>K4)throw new Error("invalid range ("+N1+", "+K4+") or no bytes requested!");if(K4>t2-1)throw new Error("only "+t2+" bytes available! programmer error!");var x1=new XMLHttpRequest;if(x1.open("GET",j,!1),t2!==o0&&x1.setRequestHeader("Range","bytes="+N1+"-"+K4),x1.responseType="arraybuffer",x1.overrideMimeType&&x1.overrideMimeType("text/plain; charset=x-user-defined"),x1.send(null),!(x1.status>=200&&x1.status<300||x1.status===304))throw new Error("Couldn\'t load "+j+". Status: "+x1.status);return x1.response!==void 0?new Uint8Array(x1.response||[]):e7(x1.responseText||"",!0)},x=this;x.setDataGetter(N1=>{var K4=N1*o0,x1=(N1+1)*o0-1;if(x1=Math.min(x1,t2-1),typeof x.chunks[N1]=="undefined"&&(x.chunks[N1]=H(K4,x1)),typeof x.chunks[N1]=="undefined")throw new Error("doXHR failed!");return x.chunks[N1]}),(M2||!t2)&&(o0=t2=1,t2=this.getter(0).length,o0=t2,ze("LazyFiles on gzip forces download of the whole file when length is accessed")),this._length=t2,this._chunkSize=o0,this.lengthKnown=!0}get length(){return this.lengthKnown||this.cacheLength(),this._length}get chunkSize(){return this.lengthKnown||this.cacheLength(),this._chunkSize}}if(typeof XMLHttpRequest!="undefined"){if(!_8)throw"Cannot do synchronous binary XHRs outside webworkers in modern browsers. Use --embed-file or --preload-file in emcc";var h0=new c,Z0={isDevice:!1,contents:h0}}else var Z0={isDevice:!1,url:j};var B0=b.createFile(J,D,Z0,K,i0);Z0.contents?B0.contents=Z0.contents:Z0.url&&(B0.contents=null,B0.url=Z0.url),Object.defineProperties(B0,{usedBytes:{get:function(){return this.contents.length}}});var q0={},a0=Object.keys(B0.stream_ops);a0.forEach(C2=>{var B2=B0.stream_ops[C2];q0[C2]=(...t2)=>(b.forceLoadFile(B0),B2(...t2))});function m2(C2,B2,t2,D2,r1){var M2=C2.node.contents;if(r1>=M2.length)return 0;var o0=Math.min(M2.length-r1,D2);if(M2.slice)for(var H=0;H<o0;H++)B2[t2+H]=M2[r1+H];else for(var H=0;H<o0;H++)B2[t2+H]=M2.get(r1+H);return o0}return q0.read=(C2,B2,t2,D2,r1)=>(b.forceLoadFile(B0),m2(C2,B2,t2,D2,r1)),q0.mmap=(C2,B2,t2,D2,r1)=>{b.forceLoadFile(B0);var M2=r7(B2);if(!M2)throw new b.ErrnoError(48);return m2(C2,Q4,M2,B2,t2),{ptr:M2,allocated:!0}},B0.stream_ops=q0,B0}},g4={DEFAULT_POLLMASK:5,calculateAt(J,D,j){if(F1.isAbs(D))return D;var K;if(J===-100)K=b.cwd();else{var i0=g4.getStreamFromFD(J);K=i0.path}if(D.length==0){if(!j)throw new b.ErrnoError(44);return K}return K+"/"+D},writeStat(J,D){J2[J>>2]=D.dev,J2[J+4>>2]=D.mode,A1[J+8>>2]=D.nlink,J2[J+12>>2]=D.uid,J2[J+16>>2]=D.gid,J2[J+20>>2]=D.rdev,u4=[D.size>>>0,(i1=D.size,+Math.abs(i1)>=1?i1>0?+Math.floor(i1/4294967296)>>>0:~~+Math.ceil((i1-+(~~i1>>>0))/4294967296)>>>0:0)],J2[J+24>>2]=u4[0],J2[J+28>>2]=u4[1],J2[J+32>>2]=4096,J2[J+36>>2]=D.blocks;var j=D.atime.getTime(),K=D.mtime.getTime(),i0=D.ctime.getTime();return u4=[Math.floor(j/1e3)>>>0,(i1=Math.floor(j/1e3),+Math.abs(i1)>=1?i1>0?+Math.floor(i1/4294967296)>>>0:~~+Math.ceil((i1-+(~~i1>>>0))/4294967296)>>>0:0)],J2[J+40>>2]=u4[0],J2[J+44>>2]=u4[1],A1[J+48>>2]=j%1e3*1e3*1e3,u4=[Math.floor(K/1e3)>>>0,(i1=Math.floor(K/1e3),+Math.abs(i1)>=1?i1>0?+Math.floor(i1/4294967296)>>>0:~~+Math.ceil((i1-+(~~i1>>>0))/4294967296)>>>0:0)],J2[J+56>>2]=u4[0],J2[J+60>>2]=u4[1],A1[J+64>>2]=K%1e3*1e3*1e3,u4=[Math.floor(i0/1e3)>>>0,(i1=Math.floor(i0/1e3),+Math.abs(i1)>=1?i1>0?+Math.floor(i1/4294967296)>>>0:~~+Math.ceil((i1-+(~~i1>>>0))/4294967296)>>>0:0)],J2[J+72>>2]=u4[0],J2[J+76>>2]=u4[1],A1[J+80>>2]=i0%1e3*1e3*1e3,u4=[D.ino>>>0,(i1=D.ino,+Math.abs(i1)>=1?i1>0?+Math.floor(i1/4294967296)>>>0:~~+Math.ceil((i1-+(~~i1>>>0))/4294967296)>>>0:0)],J2[J+88>>2]=u4[0],J2[J+92>>2]=u4[1],0},writeStatFs(J,D){J2[J+4>>2]=D.bsize,J2[J+40>>2]=D.bsize,J2[J+8>>2]=D.blocks,J2[J+12>>2]=D.bfree,J2[J+16>>2]=D.bavail,J2[J+20>>2]=D.files,J2[J+24>>2]=D.ffree,J2[J+28>>2]=D.fsid,J2[J+44>>2]=D.flags,J2[J+36>>2]=D.namelen},doMsync(J,D,j,K,i0){if(!b.isFile(D.node.mode))throw new b.ErrnoError(43);if(K&2)return 0;var c=p4.slice(J,J+j);b.msync(D,c,i0,j,K)},getStreamFromFD(J){var D=b.getStreamChecked(J);return D},varargs:void 0,getStr(J){var D=Hi(J);return D}};function Jw(J,D,j){g4.varargs=j;try{var K=g4.getStreamFromFD(J);switch(D){case 0:{var i0=je();if(i0<0)return-28;for(;b.streams[i0];)i0++;var c;return c=b.dupStream(K,i0),c.fd}case 1:case 2:return 0;case 3:return K.flags;case 4:{var i0=je();return K.flags|=i0,0}case 12:{var i0=O6(),h0=0;return Y8[i0+h0>>1]=2,0}case 13:case 14:return 0}return-28}catch(Z0){if(typeof b=="undefined"||Z0.name!=="ErrnoError")throw Z0;return-Z0.errno}}function Nw(J,D,j){g4.varargs=j;try{var K=g4.getStreamFromFD(J);switch(D){case 21509:return K.tty?0:-59;case 21505:{if(!K.tty)return-59;if(K.tty.ops.ioctl_tcgets){var i0=K.tty.ops.ioctl_tcgets(K),c=O6();J2[c>>2]=i0.c_iflag||0,J2[c+4>>2]=i0.c_oflag||0,J2[c+8>>2]=i0.c_cflag||0,J2[c+12>>2]=i0.c_lflag||0;for(var h0=0;h0<32;h0++)Q4[c+h0+17]=i0.c_cc[h0]||0;return 0}return 0}case 21510:case 21511:case 21512:return K.tty?0:-59;case 21506:case 21507:case 21508:{if(!K.tty)return-59;if(K.tty.ops.ioctl_tcsets){for(var c=O6(),Z0=J2[c>>2],B0=J2[c+4>>2],q0=J2[c+8>>2],a0=J2[c+12>>2],m2=[],h0=0;h0<32;h0++)m2.push(Q4[c+h0+17]);return K.tty.ops.ioctl_tcsets(K.tty,D,{c_iflag:Z0,c_oflag:B0,c_cflag:q0,c_lflag:a0,c_cc:m2})}return 0}case 21519:{if(!K.tty)return-59;var c=O6();return J2[c>>2]=0,0}case 21520:return K.tty?-28:-59;case 21531:{var c=O6();return b.ioctl(K,D,c)}case 21523:{if(!K.tty)return-59;if(K.tty.ops.ioctl_tiocgwinsz){var C2=K.tty.ops.ioctl_tiocgwinsz(K.tty),c=O6();Y8[c>>1]=C2[0],Y8[c+2>>1]=C2[1]}return 0}case 21524:return K.tty?0:-59;case 21515:return K.tty?0:-59;default:return-28}}catch(B2){if(typeof b=="undefined"||B2.name!=="ErrnoError")throw B2;return-B2.errno}}function Uw(J,D,j,K){g4.varargs=K;try{D=g4.getStr(D),D=g4.calculateAt(J,D);var i0=K?je():0;return b.open(D,j,i0).fd}catch(c){if(typeof b=="undefined"||c.name!=="ErrnoError")throw c;return-c.errno}}function Dw(J,D,j){try{return D=g4.getStr(D),D=g4.calculateAt(J,D),j===0?b.unlink(D):j===512?b.rmdir(D):Se("Invalid flags passed to unlinkat"),0}catch(K){if(typeof b=="undefined"||K.name!=="ErrnoError")throw K;return-K.errno}}var Mw=()=>Se(""),Pe={},K3=J=>{for(;J.length;){var D=J.pop(),j=J.pop();j(D)}};function zi(J){return this.fromWireType(A1[J>>2])}var L6={},W6={},Le={},Hw=L.InternalError=class extends Error{constructor(D){super(D),this.name="InternalError"}},Ke=J=>{throw new Hw(J)},q3=(J,D,j)=>{J.forEach(Z0=>Le[Z0]=D);function K(Z0){var B0=j(Z0);B0.length!==J.length&&Ke("Mismatched type converter count");for(var q0=0;q0<J.length;++q0)B8(J[q0],B0[q0])}var i0=new Array(D.length),c=[],h0=0;D.forEach((Z0,B0)=>{W6.hasOwnProperty(Z0)?i0[B0]=W6[Z0]:(c.push(Z0),L6.hasOwnProperty(Z0)||(L6[Z0]=[]),L6[Z0].push(()=>{i0[B0]=W6[Z0],++h0,h0===c.length&&K(i0)}))}),c.length===0&&K(i0)},zw=J=>{var D=Pe[J];delete Pe[J];var j=D.rawConstructor,K=D.rawDestructor,i0=D.fields,c=i0.map(h0=>h0.getterReturnType).concat(i0.map(h0=>h0.setterArgumentType));q3([J],c,h0=>{var Z0={};return i0.forEach((B0,q0)=>{var a0=B0.fieldName,m2=h0[q0],C2=h0[q0].optional,B2=B0.getter,t2=B0.getterContext,D2=h0[q0+i0.length],r1=B0.setter,M2=B0.setterContext;Z0[a0]={read:o0=>m2.fromWireType(B2(t2,o0)),write:(o0,H)=>{var x=[];r1(M2,o0,D2.toWireType(x,H)),K3(x)},optional:C2}}),[{name:D.name,fromWireType:B0=>{var q0={};for(var a0 in Z0)q0[a0]=Z0[a0].read(B0);return K(B0),q0},toWireType:(B0,q0)=>{for(var a0 in Z0)if(!(a0 in q0)&&!Z0[a0].optional)throw new TypeError(`Missing field: "${a0}"`);var m2=j();for(a0 in Z0)Z0[a0].write(m2,q0[a0]);return B0!==null&&B0.push(K,m2),m2},argPackAdvance:v8,readValueFromPointer:zi,destructorFunction:K}]})},xw=(J,D,j,K,i0)=>{},Tw=()=>{for(var J=new Array(256),D=0;D<256;++D)J[D]=String.fromCharCode(D);A7=J},A7,V4=J=>{for(var D="",j=J;p4[j];)D+=A7[p4[j++]];return D},qe=L.BindingError=class extends Error{constructor(D){super(D),this.name="BindingError"}},w1=J=>{throw new qe(J)};function Sw(J,D,j={}){var K=D.name;if(J||w1(`type "${K}" must have a positive integer typeid pointer`),W6.hasOwnProperty(J)){if(j.ignoreDuplicateRegistrations)return;w1(`Cannot register type \'${K}\' twice`)}if(W6[J]=D,delete Le[J],L6.hasOwnProperty(J)){var i0=L6[J];delete L6[J],i0.forEach(c=>c())}}function B8(J,D,j={}){return Sw(J,D,j)}var v8=8,jw=(J,D,j,K)=>{D=V4(D),B8(J,{name:D,fromWireType:function(i0){return!!i0},toWireType:function(i0,c){return c?j:K},argPackAdvance:v8,readValueFromPointer:function(i0){return this.fromWireType(p4[i0])},destructorFunction:null})},Ow=J=>({count:J.count,deleteScheduled:J.deleteScheduled,preservePointerOnDelete:J.preservePointerOnDelete,ptr:J.ptr,ptrType:J.ptrType,smartPtr:J.smartPtr,smartPtrType:J.smartPtrType}),a3=J=>{function D(j){return j.$$.ptrType.registeredClass.name}w1(D(J)+" instance already deleted")},$3=!1,k7=J=>{},Pw=J=>{J.smartPtr?J.smartPtrType.rawDestructor(J.smartPtr):J.ptrType.registeredClass.rawDestructor(J.ptr)},n7=J=>{J.count.value-=1;var D=J.count.value===0;D&&Pw(J)},xi=J=>typeof FinalizationRegistry=="undefined"?(xi=D=>D,J):($3=new FinalizationRegistry(D=>{n7(D.$$)}),xi=D=>{var j=D.$$,K=!!j.smartPtr;if(K){var i0={$$:j};$3.register(D,i0,D)}return D},k7=D=>$3.unregister(D),xi(J)),ae=[],Lw=()=>{for(;ae.length;){var J=ae.pop();J.$$.deleteScheduled=!1,J.delete()}},t7,Kw=()=>{let J=$e.prototype;Object.assign(J,{isAliasOf(j){if(!(this instanceof $e)||!(j instanceof $e))return!1;var K=this.$$.ptrType.registeredClass,i0=this.$$.ptr;j.$$=j.$$;for(var c=j.$$.ptrType.registeredClass,h0=j.$$.ptr;K.baseClass;)i0=K.upcast(i0),K=K.baseClass;for(;c.baseClass;)h0=c.upcast(h0),c=c.baseClass;return K===c&&i0===h0},clone(){if(this.$$.ptr||a3(this),this.$$.preservePointerOnDelete)return this.$$.count.value+=1,this;var j=xi(Object.create(Object.getPrototypeOf(this),{$$:{value:Ow(this.$$)}}));return j.$$.count.value+=1,j.$$.deleteScheduled=!1,j},delete(){this.$$.ptr||a3(this),this.$$.deleteScheduled&&!this.$$.preservePointerOnDelete&&w1("Object already scheduled for deletion"),k7(this),n7(this.$$),this.$$.preservePointerOnDelete||(this.$$.smartPtr=void 0,this.$$.ptr=void 0)},isDeleted(){return!this.$$.ptr},deleteLater(){return this.$$.ptr||a3(this),this.$$.deleteScheduled&&!this.$$.preservePointerOnDelete&&w1("Object already scheduled for deletion"),ae.push(this),ae.length===1&&t7&&t7(Lw),this.$$.deleteScheduled=!0,this}});let D=Symbol.dispose;D&&(J[D]=J.delete)};function $e(){}var de=(J,D)=>Object.defineProperty(D,"name",{value:J}),u7={},qw=(J,D,j)=>{if(J[D].overloadTable===void 0){var K=J[D];J[D]=function(...i0){return J[D].overloadTable.hasOwnProperty(i0.length)||w1(`Function \'${j}\' called with an invalid number of arguments (${i0.length}) - expects one of (${J[D].overloadTable})!`),J[D].overloadTable[i0.length].apply(this,i0)},J[D].overloadTable=[],J[D].overloadTable[K.argCount]=K}},d3=(J,D,j)=>{L.hasOwnProperty(J)?((j===void 0||L[J].overloadTable!==void 0&&L[J].overloadTable[j]!==void 0)&&w1(`Cannot register public name \'${J}\' twice`),qw(L,J,J),L[J].overloadTable.hasOwnProperty(j)&&w1(`Cannot register multiple overloads of a function with the same number of arguments (${j})!`),L[J].overloadTable[j]=D):(L[J]=D,L[J].argCount=j)},aw=48,$w=57,dw=J=>{J=J.replace(/[^a-zA-Z0-9_]/g,"$");var D=J.charCodeAt(0);return D>=aw&&D<=$w?`_${J}`:J};function cw(J,D,j,K,i0,c,h0,Z0){this.name=J,this.constructor=D,this.instancePrototype=j,this.rawDestructor=K,this.baseClass=i0,this.getActualType=c,this.upcast=h0,this.downcast=Z0,this.pureVirtualFunctions=[]}var c3=(J,D,j)=>{for(;D!==j;)D.upcast||w1(`Expected null or instance of ${j.name}, got an instance of ${D.name}`),J=D.upcast(J),D=D.baseClass;return J};function bw(J,D){if(D===null)return this.isReference&&w1(`null is not a valid ${this.name}`),0;D.$$||w1(`Cannot pass "${embindRepr(D)}" as a ${this.name}`),D.$$.ptr||w1(`Cannot pass deleted object as a pointer of type ${this.name}`);var j=D.$$.ptrType.registeredClass,K=c3(D.$$.ptr,j,this.registeredClass);return K}function ih(J,D){var j;if(D===null)return this.isReference&&w1(`null is not a valid ${this.name}`),this.isSmartPointer?(j=this.rawConstructor(),J!==null&&J.push(this.rawDestructor,j),j):0;(!D||!D.$$)&&w1(`Cannot pass "${embindRepr(D)}" as a ${this.name}`),D.$$.ptr||w1(`Cannot pass deleted object as a pointer of type ${this.name}`),!this.isConst&&D.$$.ptrType.isConst&&w1(`Cannot convert argument of type ${D.$$.smartPtrType?D.$$.smartPtrType.name:D.$$.ptrType.name} to parameter type ${this.name}`);var K=D.$$.ptrType.registeredClass;if(j=c3(D.$$.ptr,K,this.registeredClass),this.isSmartPointer)switch(D.$$.smartPtr===void 0&&w1("Passing raw pointer to smart pointer is illegal"),this.sharingPolicy){case 0:D.$$.smartPtrType===this?j=D.$$.smartPtr:w1(`Cannot convert argument of type ${D.$$.smartPtrType?D.$$.smartPtrType.name:D.$$.ptrType.name} to parameter type ${this.name}`);break;case 1:j=D.$$.smartPtr;break;case 2:if(D.$$.smartPtrType===this)j=D.$$.smartPtr;else{var i0=D.clone();j=this.rawShare(j,L4.toHandle(()=>i0.delete())),J!==null&&J.push(this.rawDestructor,j)}break;default:w1("Unsupporting sharing policy")}return j}function eh(J,D){if(D===null)return this.isReference&&w1(`null is not a valid ${this.name}`),0;D.$$||w1(`Cannot pass "${embindRepr(D)}" as a ${this.name}`),D.$$.ptr||w1(`Cannot pass deleted object as a pointer of type ${this.name}`),D.$$.ptrType.isConst&&w1(`Cannot convert argument of type ${D.$$.ptrType.name} to parameter type ${this.name}`);var j=D.$$.ptrType.registeredClass,K=c3(D.$$.ptr,j,this.registeredClass);return K}var o7=(J,D,j)=>{if(D===j)return J;if(j.baseClass===void 0)return null;var K=o7(J,D,j.baseClass);return K===null?null:j.downcast(K)},rh={},fh=(J,D)=>{for(D===void 0&&w1("ptr should not be undefined");J.baseClass;)D=J.upcast(D),J=J.baseClass;return D},Ah=(J,D)=>(D=fh(J,D),rh[D]),ce=(J,D)=>{(!D.ptrType||!D.ptr)&&Ke("makeClassHandle requires ptr and ptrType");var j=!!D.smartPtrType,K=!!D.smartPtr;return j!==K&&Ke("Both smartPtrType and smartPtr must be specified"),D.count={value:1},xi(Object.create(J,{$$:{value:D,writable:!0}}))};function kh(J){var D=this.getPointee(J);if(!D)return this.destructor(J),null;var j=Ah(this.registeredClass,D);if(j!==void 0){if(j.$$.count.value===0)return j.$$.ptr=D,j.$$.smartPtr=J,j.clone();var K=j.clone();return this.destructor(J),K}function i0(){return this.isSmartPointer?ce(this.registeredClass.instancePrototype,{ptrType:this.pointeeType,ptr:D,smartPtrType:this,smartPtr:J}):ce(this.registeredClass.instancePrototype,{ptrType:this,ptr:J})}var c=this.registeredClass.getActualType(D),h0=u7[c];if(!h0)return i0.call(this);var Z0;this.isConst?Z0=h0.constPointerType:Z0=h0.pointerType;var B0=o7(D,this.registeredClass,Z0.registeredClass);return B0===null?i0.call(this):this.isSmartPointer?ce(Z0.registeredClass.instancePrototype,{ptrType:Z0,ptr:B0,smartPtrType:this,smartPtr:J}):ce(Z0.registeredClass.instancePrototype,{ptrType:Z0,ptr:B0})}var nh=()=>{Object.assign(be.prototype,{getPointee(J){return this.rawGetPointee&&(J=this.rawGetPointee(J)),J},destructor(J){var D;(D=this.rawDestructor)==null||D.call(this,J)},argPackAdvance:v8,readValueFromPointer:zi,fromWireType:kh})};function be(J,D,j,K,i0,c,h0,Z0,B0,q0,a0){this.name=J,this.registeredClass=D,this.isReference=j,this.isConst=K,this.isSmartPointer=i0,this.pointeeType=c,this.sharingPolicy=h0,this.rawGetPointee=Z0,this.rawConstructor=B0,this.rawShare=q0,this.rawDestructor=a0,!i0&&D.baseClass===void 0?K?(this.toWireType=bw,this.destructorFunction=null):(this.toWireType=eh,this.destructorFunction=null):this.toWireType=ih}var l7=(J,D,j)=>{L.hasOwnProperty(J)||Ke("Replacing nonexistent public symbol"),L[J].overloadTable!==void 0&&j!==void 0?L[J].overloadTable[j]=D:(L[J]=D,L[J].argCount=j)},s7=[],w7,h7=J=>{var D=s7[J];return D||(s7[J]=D=w7.get(J)),D},th=(J,D,j=[],K=!1)=>{if(J.includes("j"))return dynCallLegacy(J,D,j);var i0=h7(D),c=i0(...j);return c},uh=(J,D,j=!1)=>(...K)=>th(J,D,K,j),R8=(J,D,j=!1)=>{J=V4(J);function K(){if(J.includes("j"))return uh(J,D);var c=h7(D);return c}var i0=K();return typeof i0!="function"&&w1(`unknown function pointer with signature ${J}: ${D}`),i0};class oh extends Error{}var _7=J=>{var D=B_(J),j=V4(D);return e6(D),j},B7=(J,D)=>{var j=[],K={};function i0(c){if(!K[c]&&!W6[c]){if(Le[c]){Le[c].forEach(i0);return}j.push(c),K[c]=!0}}throw D.forEach(i0),new oh(`${J}: `+j.map(_7).join([", "]))},lh=(J,D,j,K,i0,c,h0,Z0,B0,q0,a0,m2,C2)=>{a0=V4(a0),c=R8(i0,c),Z0&&(Z0=R8(h0,Z0)),q0&&(q0=R8(B0,q0)),C2=R8(m2,C2);var B2=dw(a0);d3(B2,function(){B7(`Cannot construct ${a0} due to unbound types`,[K])}),q3([J,D,j],K?[K]:[],t2=>{var x1,h1;t2=t2[0];var D2,r1;K?(D2=t2.registeredClass,r1=D2.instancePrototype):r1=$e.prototype;var M2=de(a0,function(...W1){if(Object.getPrototypeOf(this)!==o0)throw new qe(`Use \'new\' to construct ${a0}`);if(H.constructor_body===void 0)throw new qe(`${a0} has no accessible constructor`);var u=H.constructor_body[W1.length];if(u===void 0)throw new qe(`Tried to invoke ctor of ${a0} with invalid number of parameters (${W1.length}) - expected (${Object.keys(H.constructor_body).toString()}) parameters instead!`);return u.apply(this,W1)}),o0=Object.create(r1,{constructor:{value:M2}});M2.prototype=o0;var H=new cw(a0,M2,o0,C2,D2,c,Z0,q0);H.baseClass&&((h1=(x1=H.baseClass).__derivedClasses)!=null||(x1.__derivedClasses=[]),H.baseClass.__derivedClasses.push(H));var x=new be(a0,H,!0,!1,!1),N1=new be(a0+"*",H,!1,!1,!1),K4=new be(a0+" const*",H,!1,!0,!1);return u7[J]={pointerType:N1,constPointerType:K4},l7(B2,M2),[x,N1,K4]})},b3=[],J8=[],ef=J=>{J>9&&--J8[J+1]===0&&(J8[J]=void 0,b3.push(J))},sh=()=>J8.length/2-5-b3.length,wh=()=>{J8.push(0,1,void 0,1,null,1,!0,1,!1,1),L.count_emval_handles=sh},L4={toValue:J=>(J||w1(`Cannot use deleted val. handle = ${J}`),J8[J]),toHandle:J=>{switch(J){case void 0:return 2;case null:return 4;case!0:return 6;case!1:return 8;default:{let D=b3.pop()||J8.length;return J8[D]=J,J8[D+1]=1,D}}}},hh={name:"emscripten::val",fromWireType:J=>{var D=L4.toValue(J);return ef(J),D},toWireType:(J,D)=>L4.toHandle(D),argPackAdvance:v8,readValueFromPointer:zi,destructorFunction:null},_h=J=>B8(J,hh),Bh=(J,D,j)=>{switch(D){case 1:return j?function(K){return this.fromWireType(Q4[K])}:function(K){return this.fromWireType(p4[K])};case 2:return j?function(K){return this.fromWireType(Y8[K>>1])}:function(K){return this.fromWireType(Ui[K>>1])};case 4:return j?function(K){return this.fromWireType(J2[K>>2])}:function(K){return this.fromWireType(A1[K>>2])};default:throw new TypeError(`invalid integer width (${D}): ${J}`)}},vh=(J,D,j,K)=>{D=V4(D);function i0(){}i0.values={},B8(J,{name:D,constructor:i0,fromWireType:function(c){return this.constructor.values[c]},toWireType:(c,h0)=>h0.value,argPackAdvance:v8,readValueFromPointer:Bh(D,j,K),destructorFunction:null}),d3(D,i0)},rf=(J,D)=>{var j=W6[J];return j===void 0&&w1(`${D} has unknown type ${_7(J)}`),j},mh=(J,D,j)=>{var K=rf(J,"enum");D=V4(D);var i0=K.constructor,c=Object.create(K.constructor.prototype,{value:{value:j},constructor:{value:de(`${K.name}_${D}`,function(){})}});i0.values[j]=c,i0[D]=c},Zh=(J,D)=>{switch(D){case 4:return function(j){return this.fromWireType(Pk[j>>2])};case 8:return function(j){return this.fromWireType(Lk[j>>3])};default:throw new TypeError(`invalid float width (${D}): ${J}`)}},Gh=(J,D,j)=>{D=V4(D),B8(J,{name:D,fromWireType:K=>K,toWireType:(K,i0)=>i0,argPackAdvance:v8,readValueFromPointer:Zh(D,j),destructorFunction:null})};function Xh(J){for(var D=1;D<J.length;++D)if(J[D]!==null&&J[D].destructorFunction===void 0)return!0;return!1}function Wh(J,D,j,K,i0,c){var h0=D.length;h0<2&&w1("argTypes array size mismatch! Must at least get return value and \'this\' types!");var Z0=D[1]!==null&&j!==null,B0=Xh(D),q0=D[0].name!=="void",a0=h0-2,m2=new Array(a0),C2=[],B2=[],t2=function(...D2){B2.length=0;var r1;C2.length=Z0?2:1,C2[0]=i0,Z0&&(r1=D[1].toWireType(B2,this),C2[1]=r1);for(var M2=0;M2<a0;++M2)m2[M2]=D[M2+2].toWireType(B2,D2[M2]),C2.push(m2[M2]);var o0=K(...C2);function H(x){if(B0)K3(B2);else for(var N1=Z0?1:2;N1<D.length;N1++){var K4=N1===1?r1:m2[N1-2];D[N1].destructorFunction!==null&&D[N1].destructorFunction(K4)}if(q0)return D[0].fromWireType(x)}return H(o0)};return de(J,t2)}var Qh=(J,D)=>{for(var j=[],K=0;K<J;K++)j.push(A1[D+K*4>>2]);return j},gh=J=>{J=J.trim();let D=J.indexOf("(");return D===-1?J:J.slice(0,D)},Vh=(J,D,j,K,i0,c,h0,Z0)=>{var B0=Qh(D,j);J=V4(J),J=gh(J),i0=R8(K,i0,h0),d3(J,function(){B7(`Cannot call ${J} due to unbound types`,B0)},D-1),q3([],B0,q0=>{var a0=[q0[0],null].concat(q0.slice(1));return l7(J,Wh(J,a0,null,i0,c,h0),D-1),[]})},Fh=(J,D,j)=>{switch(D){case 1:return j?K=>Q4[K]:K=>p4[K];case 2:return j?K=>Y8[K>>1]:K=>Ui[K>>1];case 4:return j?K=>J2[K>>2]:K=>A1[K>>2];default:throw new TypeError(`invalid integer width (${D}): ${J}`)}},Ih=(J,D,j,K,i0)=>{D=V4(D),i0===-1&&(i0=4294967295);var c=a0=>a0;if(K===0){var h0=32-8*j;c=a0=>a0<<h0>>>h0}var Z0=D.includes("unsigned"),B0=(a0,m2)=>{},q0;Z0?q0=function(a0,m2){return B0(m2,this.name),m2>>>0}:q0=function(a0,m2){return B0(m2,this.name),m2},B8(J,{name:D,fromWireType:c,toWireType:q0,argPackAdvance:v8,readValueFromPointer:Fh(D,j,K!==0),destructorFunction:null})},Ch=(J,D,j)=>{var K=[Int8Array,Uint8Array,Int16Array,Uint16Array,Int32Array,Uint32Array,Float32Array,Float64Array],i0=K[D];function c(h0){var Z0=A1[h0>>2],B0=A1[h0+4>>2];return new i0(Q4.buffer,B0,Z0)}j=V4(j),B8(J,{name:j,fromWireType:c,argPackAdvance:v8,readValueFromPointer:c},{ignoreDuplicateRegistrations:!0})},K6=(J,D,j)=>P3(J,p4,D,j),ph=(J,D)=>{D=V4(D);var j=!0;B8(J,{name:D,fromWireType(K){var i0=A1[K>>2],c=K+4,h0;if(j)for(var Z0=c,B0=0;B0<=i0;++B0){var q0=c+B0;if(B0==i0||p4[q0]==0){var a0=q0-Z0,m2=Hi(Z0,a0);h0===void 0?h0=m2:(h0+="\\0",h0+=m2),Z0=q0+1}}else{for(var C2=new Array(i0),B0=0;B0<i0;++B0)C2[B0]=String.fromCharCode(p4[c+B0]);h0=C2.join("")}return e6(K),h0},toWireType(K,i0){i0 instanceof ArrayBuffer&&(i0=new Uint8Array(i0));var c,h0=typeof i0=="string";h0||ArrayBuffer.isView(i0)&&i0.BYTES_PER_ELEMENT==1||w1("Cannot pass non-string to std::string"),j&&h0?c=Oe(i0):c=i0.length;var Z0=Z7(4+c+1),B0=Z0+4;if(A1[Z0>>2]=c,h0)if(j)K6(i0,B0,c+1);else for(var q0=0;q0<c;++q0){var a0=i0.charCodeAt(q0);a0>255&&(e6(Z0),w1("String has UTF-16 code units that do not fit in 8 bits")),p4[B0+q0]=a0}else p4.set(i0,B0);return K!==null&&K.push(e6,Z0),Z0},argPackAdvance:v8,readValueFromPointer:zi,destructorFunction(K){e6(K)}})},v7=typeof TextDecoder!="undefined"?new TextDecoder("utf-16le"):void 0,yh=(J,D)=>{for(var j=J,K=j>>1,i0=K+D/2;!(K>=i0)&&Ui[K];)++K;if(j=K<<1,j-J>32&&v7)return v7.decode(p4.subarray(J,j));for(var c="",h0=0;!(h0>=D/2);++h0){var Z0=Y8[J+h0*2>>1];if(Z0==0)break;c+=String.fromCharCode(Z0)}return c},Eh=(J,D,j)=>{if(j!=null||(j=2147483647),j<2)return 0;j-=2;for(var K=D,i0=j<J.length*2?j/2:J.length,c=0;c<i0;++c){var h0=J.charCodeAt(c);Y8[D>>1]=h0,D+=2}return Y8[D>>1]=0,D-K},Yh=J=>J.length*2,Rh=(J,D)=>{for(var j=0,K="";!(j>=D/4);){var i0=J2[J+j*4>>2];if(i0==0)break;if(++j,i0>=65536){var c=i0-65536;K+=String.fromCharCode(55296|c>>10,56320|c&1023)}else K+=String.fromCharCode(i0)}return K},Jh=(J,D,j)=>{if(j!=null||(j=2147483647),j<4)return 0;for(var K=D,i0=K+j-4,c=0;c<J.length;++c){var h0=J.charCodeAt(c);if(h0>=55296&&h0<=57343){var Z0=J.charCodeAt(++c);h0=65536+((h0&1023)<<10)|Z0&1023}if(J2[D>>2]=h0,D+=4,D+4>i0)break}return J2[D>>2]=0,D-K},Nh=J=>{for(var D=0,j=0;j<J.length;++j){var K=J.charCodeAt(j);K>=55296&&K<=57343&&++j,D+=4}return D},Uh=(J,D,j)=>{j=V4(j);var K,i0,c,h0;D===2?(K=yh,i0=Eh,h0=Yh,c=Z0=>Ui[Z0>>1]):D===4&&(K=Rh,i0=Jh,h0=Nh,c=Z0=>A1[Z0>>2]),B8(J,{name:j,fromWireType:Z0=>{for(var B0=A1[Z0>>2],q0,a0=Z0+4,m2=0;m2<=B0;++m2){var C2=Z0+4+m2*D;if(m2==B0||c(C2)==0){var B2=C2-a0,t2=K(a0,B2);q0===void 0?q0=t2:(q0+="\\0",q0+=t2),a0=C2+D}}return e6(Z0),q0},toWireType:(Z0,B0)=>{typeof B0!="string"&&w1(`Cannot pass non-string to C++ string type ${j}`);var q0=h0(B0),a0=Z7(4+q0+D);return A1[a0>>2]=q0/D,i0(B0,a0+4,q0+D),Z0!==null&&Z0.push(e6,a0),a0},argPackAdvance:v8,readValueFromPointer:zi,destructorFunction(Z0){e6(Z0)}})},Dh=(J,D,j,K,i0,c)=>{Pe[J]={name:V4(D),rawConstructor:R8(j,K),rawDestructor:R8(i0,c),fields:[]}},Mh=(J,D,j,K,i0,c,h0,Z0,B0,q0)=>{Pe[J].fields.push({fieldName:V4(D),getterReturnType:j,getter:R8(K,i0),getterContext:c,setterArgumentType:h0,setter:R8(Z0,B0),setterContext:q0})},Hh=(J,D)=>{D=V4(D),B8(J,{isVoid:!0,name:D,argPackAdvance:0,fromWireType:()=>{},toWireType:(j,K)=>{}})},zh={},m7=J=>{var D=zh[J];return D===void 0?V4(J):D},ff=[],xh=(J,D,j,K,i0)=>(J=ff[J],D=L4.toValue(D),j=m7(j),J(D,D[j],K,i0)),Th=J=>{var D=ff.length;return ff.push(J),D},Sh=(J,D)=>{for(var j=new Array(J),K=0;K<J;++K)j[K]=rf(A1[D+K*4>>2],`parameter ${K}`);return j},jh=(J,D,j)=>{var K=[],i0=J.toWireType(K,j);return K.length&&(A1[D>>2]=L4.toHandle(K)),i0},Oh=Reflect.construct,Ph=(J,D,j)=>{var K=Sh(J,D),i0=K.shift();J--;var c=new Array(J),h0=(B0,q0,a0,m2)=>{for(var C2=0,B2=0;B2<J;++B2)c[B2]=K[B2].readValueFromPointer(m2+C2),C2+=K[B2].argPackAdvance;var t2=j===1?Oh(q0,c):q0.apply(B0,c);return jh(i0,a0,t2)},Z0=`methodCaller<(${K.map(B0=>B0.name).join(", ")}) => ${i0.name}>`;return Th(de(Z0,h0))},Lh=J=>{J>9&&(J8[J+1]+=1)},Kh=()=>L4.toHandle([]),qh=J=>L4.toHandle(m7(J)),ah=()=>L4.toHandle({}),$h=J=>{var D=L4.toValue(J);K3(D),ef(J)},dh=(J,D,j)=>{J=L4.toValue(J),D=L4.toValue(D),j=L4.toValue(j),J[D]=j},ch=(J,D)=>{J=rf(J,"_emval_take_value");var j=J.readValueFromPointer(D);return L4.toHandle(j)},bh=(J,D,j,K)=>{var i0=new Date().getFullYear(),c=new Date(i0,0,1),h0=new Date(i0,6,1),Z0=c.getTimezoneOffset(),B0=h0.getTimezoneOffset(),q0=Math.max(Z0,B0);A1[J>>2]=q0*60,J2[D>>2]=+(Z0!=B0);var a0=B2=>{var t2=B2>=0?"-":"+",D2=Math.abs(B2),r1=String(Math.floor(D2/60)).padStart(2,"0"),M2=String(D2%60).padStart(2,"0");return`UTC${t2}${r1}${M2}`},m2=a0(Z0),C2=a0(B0);B0<Z0?(K6(m2,j,17),K6(C2,K,17)):(K6(m2,K,17),K6(C2,j,17))},i_=()=>2147483648,e_=(J,D)=>Math.ceil(J/D)*D,r_=J=>{var D=Te.buffer,j=(J-D.byteLength+65535)/65536|0;try{return Te.grow(j),Kk(),1}catch(K){}},f_=J=>{var D=p4.length;J>>>=0;var j=i_();if(J>j)return!1;for(var K=1;K<=4;K*=2){var i0=D*(1+.2/K);i0=Math.min(i0,J+100663296);var c=Math.min(j,e_(Math.max(J,i0),65536)),h0=r_(c);if(h0)return!0}return!1},Af={},A_=()=>z3||"./this.program",Ti=()=>{if(!Ti.strings){var J=(typeof navigator=="object"&&navigator.languages&&navigator.languages[0]||"C").replace("-","_")+".UTF-8",D={USER:"web_user",LOGNAME:"web_user",PATH:"/",PWD:"/",HOME:"/home/web_user",LANG:J,_:A_()};for(var j in Af)Af[j]===void 0?delete D[j]:D[j]=Af[j];var K=[];for(var j in D)K.push(`${j}=${D[j]}`);Ti.strings=K}return Ti.strings},k_=(J,D)=>{var j=0,K=0;for(var i0 of Ti()){var c=D+j;A1[J+K>>2]=c,j+=K6(i0,c,1/0)+1,K+=4}return 0},n_=(J,D)=>{var j=Ti();A1[J>>2]=j.length;var K=0;for(var i0 of j)K+=Oe(i0)+1;return A1[D>>2]=K,0};function t_(J){try{var D=g4.getStreamFromFD(J);return b.close(D),0}catch(j){if(typeof b=="undefined"||j.name!=="ErrnoError")throw j;return j.errno}}var u_=(J,D,j,K)=>{for(var i0=0,c=0;c<j;c++){var h0=A1[D>>2],Z0=A1[D+4>>2];D+=8;var B0=b.read(J,Q4,h0,Z0,K);if(B0<0)return-1;if(i0+=B0,B0<Z0)break;typeof K!="undefined"&&(K+=B0)}return i0};function o_(J,D,j,K){try{var i0=g4.getStreamFromFD(J),c=u_(i0,D,j);return A1[K>>2]=c,0}catch(h0){if(typeof b=="undefined"||h0.name!=="ErrnoError")throw h0;return h0.errno}}var l_=(J,D)=>D+2097152>>>0<4194305-!!J?(J>>>0)+D*4294967296:NaN;function s_(J,D,j,K,i0){var c=l_(D,j);try{if(isNaN(c))return 61;var h0=g4.getStreamFromFD(J);return b.llseek(h0,c,K),u4=[h0.position>>>0,(i1=h0.position,+Math.abs(i1)>=1?i1>0?+Math.floor(i1/4294967296)>>>0:~~+Math.ceil((i1-+(~~i1>>>0))/4294967296)>>>0:0)],J2[i0>>2]=u4[0],J2[i0+4>>2]=u4[1],h0.getdents&&c===0&&K===0&&(h0.getdents=null),0}catch(Z0){if(typeof b=="undefined"||Z0.name!=="ErrnoError")throw Z0;return Z0.errno}}var w_=(J,D,j,K)=>{for(var i0=0,c=0;c<j;c++){var h0=A1[D>>2],Z0=A1[D+4>>2];D+=8;var B0=b.write(J,Q4,h0,Z0,K);if(B0<0)return-1;if(i0+=B0,B0<Z0)break;typeof K!="undefined"&&(K+=B0)}return i0};function h_(J,D,j,K){try{var i0=g4.getStreamFromFD(J),c=w_(i0,D,j);return A1[K>>2]=c,0}catch(h0){if(typeof b=="undefined"||h0.name!=="ErrnoError")throw h0;return h0.errno}}b.createPreloadedFile=Yw,b.staticInit(),U2.doesNotExistError=new b.ErrnoError(44),U2.doesNotExistError.stack="<generic error, no stack>",Tw(),Kw(),nh(),wh(),L.noExitRuntime&&(Ww=L.noExitRuntime),L.preloadPlugins&&(f7=L.preloadPlugins),L.print&&(ze=L.print),L.printErr&&(Ni=L.printErr),L.wasmBinary&&(xe=L.wasmBinary),L.arguments&&(jk=L.arguments),L.thisProgram&&(z3=L.thisProgram);var __={b:Qw,k:Fw,r:Jw,A:Nw,E:Uw,D:Dw,B:Mw,v:zw,y:xw,J:jw,o:lh,H:_h,j:vh,a:mh,u:Gh,d:Vh,i:Ih,f:Ch,I:ph,q:Uh,w:Dh,n:Mh,K:Hh,M:xh,c:ef,N:Ph,O:Lh,m:Kh,h:qh,l:ah,L:$h,g:dh,e:ch,z:bh,C:f_,F:k_,G:n_,s:t_,t:o_,x:s_,p:h_},d=Zw(),OL=d.Q,PL=L._heif_nclx_color_profile_alloc=d.S,LL=L._heif_nclx_color_profile_free=d.T,KL=L._heif_tai_timestamp_packet_alloc=d.U,qL=L._heif_tai_timestamp_packet_copy=d.V,aL=L._heif_tai_timestamp_packet_release=d.W,$L=L._heif_color_conversion_options_set_defaults=d.X,dL=L._heif_nclx_color_profile_set_color_primaries=d.Y,cL=L._heif_nclx_color_profile_set_transfer_characteristics=d.Z,bL=L._heif_nclx_color_profile_set_matrix_coefficients=d._,iK=L._heif_init=d.$,eK=L._heif_deinit=d.aa,rK=L._heif_load_plugin=d.ba,fK=L._heif_unload_plugin=d.ca,AK=L._heif_load_plugins=d.da,kK=L._heif_get_plugin_directories=d.ea,nK=L._heif_free_plugin_directories=d.fa,tK=L._heif_get_version_number=d.ga,uK=L._heif_context_alloc=d.ha,oK=L._heif_context_free=d.ia,lK=L._heif_context_get_number_of_top_level_images=d.ja,sK=L._heif_image_handle_release=d.ka,wK=L._heif_image_handle_get_width=d.la,hK=L._heif_image_handle_get_height=d.ma,_K=L._heif_image_handle_is_primary_image=d.na,BK=L._heif_image_release=d.oa,vK=L._heif_image_handle_has_alpha_channel=d.pa,mK=L._heif_image_handle_is_premultiplied_alpha=d.qa,ZK=L._heif_context_get_number_of_items=d.ra,GK=L._heif_item_is_item_hidden=d.sa,XK=L._heif_get_version=d.ta,WK=L._heif_context_read_from_memory=d.ua,QK=L._heif_check_filetype=d.va,gK=L._heif_context_get_list_of_top_level_image_IDs=d.wa,e6=L._free=d.xa,VK=L._heif_context_get_image_handle=d.ya,FK=L._heif_context_get_primary_image_handle=d.za,IK=L._heif_decode_image=d.Aa,CK=L._heif_image_get_chroma_format=d.Ba,pK=L._heif_image_get_colorspace=d.Ca,yK=L._heif_image_has_channel=d.Da,EK=L._heif_image_get_plane_readonly2=d.Ea,YK=L._heif_image_get_width=d.Fa,RK=L._heif_image_get_height=d.Ga,JK=L._heif_image_get_bits_per_pixel_range=d.Ha,NK=L._heif_context_get_list_of_item_IDs=d.Ia,UK=L._heif_item_get_item_type=d.Ja,Z7=L._malloc=d.Ka,DK=L._heif_item_get_mime_item_content_type=d.La,MK=L._heif_item_get_mime_item_content_encoding=d.Ma,HK=L._heif_item_get_uri_item_uri_type=d.Na,zK=L._heif_item_get_item_name=d.Oa,xK=L._heif_get_version_number_major=d.Pa,TK=L._heif_get_version_number_minor=d.Qa,SK=L._heif_get_version_number_maintenance=d.Ra,jK=L._heif_register_decoder_plugin=d.Sa,OK=L._heif_register_encoder_plugin=d.Ta,PK=L._heif_string_release=d.Ua,LK=L._heif_register_decoder=d.Va,KK=L._heif_image_get_primary_width=d.Wa,qK=L._heif_image_get_primary_height=d.Xa,aK=L._heif_image_crop=d.Ya,$K=L._heif_image_extract_area=d.Za,dK=L._heif_image_get_bits_per_pixel=d._a,cK=L._heif_image_get_plane_readonly=d.$a,bK=L._heif_image_get_plane=d.ab,iq=L._heif_image_get_plane2=d.bb,eq=L._heif_image_scale_image=d.cb,rq=L._heif_image_extend_to_size_fill_with_zero=d.db,fq=L._heif_image_get_decoding_warnings=d.eb,Aq=L._heif_image_add_decoding_warning=d.fb,kq=L._heif_image_get_pixel_aspect_ratio=d.gb,nq=L._heif_image_set_pixel_aspect_ratio=d.hb,tq=L._heif_image_handle_set_pixel_aspect_ratio=d.ib,uq=L._heif_image_create=d.jb,oq=L._heif_image_add_plane=d.kb,lq=L._heif_image_add_plane_safe=d.lb,sq=L._heif_image_set_premultiplied_alpha=d.mb,wq=L._heif_image_is_premultiplied_alpha=d.nb,hq=L._heif_image_extend_padding_to_size=d.ob,_q=L._heif_color_conversion_options_ext_alloc=d.pb,Bq=L._heif_color_conversion_options_ext_copy=d.qb,vq=L._heif_color_conversion_options_ext_free=d.rb,mq=L._heif_image_handle_get_color_profile_type=d.sb,Zq=L._heif_image_handle_get_raw_color_profile_size=d.tb,Gq=L._heif_image_handle_get_raw_color_profile=d.ub,Xq=L._heif_image_handle_get_nclx_color_profile=d.vb,Wq=L._heif_image_get_color_profile_type=d.wb,Qq=L._heif_image_get_raw_color_profile_size=d.xb,gq=L._heif_image_get_raw_color_profile=d.yb,Vq=L._heif_image_get_nclx_color_profile=d.zb,Fq=L._heif_image_set_raw_color_profile=d.Ab,Iq=L._heif_image_set_nclx_color_profile=d.Bb,Cq=L._heif_image_has_content_light_level=d.Cb,pq=L._heif_image_get_content_light_level=d.Db,yq=L._heif_image_handle_get_content_light_level=d.Eb,Eq=L._heif_image_set_content_light_level=d.Fb,Yq=L._heif_image_handle_set_content_light_level=d.Gb,Rq=L._heif_image_has_mastering_display_colour_volume=d.Hb,Jq=L._heif_image_get_mastering_display_colour_volume=d.Ib,Nq=L._heif_image_handle_get_mastering_display_colour_volume=d.Jb,Uq=L._heif_image_set_mastering_display_colour_volume=d.Kb,Dq=L._heif_image_handle_set_mastering_display_colour_volume=d.Lb,Mq=L._heif_mastering_display_colour_volume_decode=d.Mb,Hq=L._heif_image_handle_get_number_of_region_items=d.Nb,zq=L._heif_image_handle_get_list_of_region_item_ids=d.Ob,xq=L._heif_context_get_region_item=d.Pb,Tq=L._heif_region_item_get_id=d.Qb,Sq=L._heif_region_item_release=d.Rb,jq=L._heif_region_item_get_reference_size=d.Sb,Oq=L._heif_region_item_get_number_of_regions=d.Tb,Pq=L._heif_region_item_get_list_of_regions=d.Ub,Lq=L._heif_region_release=d.Vb,Kq=L._heif_region_release_many=d.Wb,qq=L._heif_region_get_type=d.Xb,aq=L._heif_region_get_point=d.Yb,$q=L._heif_region_get_point_transformed=d.Zb,dq=L._heif_region_get_rectangle=d._b,cq=L._heif_region_get_rectangle_transformed=d.$b,bq=L._heif_region_get_ellipse=d.ac,ia=L._heif_region_get_ellipse_transformed=d.bc,ea=L._heif_region_get_polygon_num_points=d.cc,ra=L._heif_region_get_polygon_points=d.dc,fa=L._heif_region_get_polygon_points_transformed=d.ec,Aa=L._heif_region_get_polyline_num_points=d.fc,ka=L._heif_region_get_polyline_points=d.gc,na=L._heif_region_get_polyline_points_transformed=d.hc,ta=L._heif_region_get_referenced_mask_ID=d.ic,ua=L._heif_region_get_inline_mask_data_len=d.jc,oa=L._heif_region_item_add_region_inline_mask_data=d.kc,la=L._heif_region_get_mask_image=d.lc,sa=L._heif_image_handle_add_region_item=d.mc,wa=L._heif_region_item_add_region_point=d.nc,ha=L._heif_region_item_add_region_rectangle=d.oc,_a=L._heif_region_item_add_region_ellipse=d.pc,Ba=L._heif_region_item_add_region_polygon=d.qc,va=L._heif_region_item_add_region_polyline=d.rc,ma=L._heif_region_item_add_region_referenced_mask=d.sc,Za=L._heif_region_get_inline_mask_data=d.tc,Ga=L._heif_region_item_add_region_inline_mask=d.uc,Xa=L._heif_item_get_properties_of_type=d.vc,Wa=L._heif_item_get_transformation_properties=d.wc,Qa=L._heif_item_get_property_type=d.xc,ga=L._heif_item_get_property_user_description=d.yc,Va=L._heif_item_add_property_user_description=d.zc,Fa=L._heif_property_user_description_release=d.Ac,Ia=L._heif_item_get_property_transform_mirror=d.Bc,Ca=L._heif_item_get_property_transform_rotation_ccw=d.Cc,pa=L._heif_item_get_property_transform_crop_borders=d.Dc,ya=L._heif_item_add_raw_property=d.Ec,Ea=L._heif_item_get_property_raw_size=d.Fc,Ya=L._heif_item_get_property_raw_data=d.Gc,Ra=L._heif_item_get_property_uuid_type=d.Hc,Ja=L._heif_image_handle_has_camera_intrinsic_matrix=d.Ic,Na=L._heif_image_handle_get_camera_intrinsic_matrix=d.Jc,Ua=L._heif_image_handle_has_camera_extrinsic_matrix=d.Kc,Da=L._heif_image_handle_get_camera_extrinsic_matrix=d.Lc,Ma=L._heif_camera_extrinsic_matrix_release=d.Mc,Ha=L._heif_camera_extrinsic_matrix_get_rotation_matrix=d.Nc,za=L._heif_item_set_item_name=d.Oc,xa=L._heif_item_get_item_data=d.Pc,Ta=L._heif_release_item_data=d.Qc,Sa=L._heif_item_get_property_extended_language=d.Rc,ja=L._heif_item_set_property_extended_language=d.Sc,Oa=L._heif_context_get_item_references=d.Tc,Pa=L._heif_release_item_references=d.Uc,La=L._heif_context_add_item_reference=d.Vc,Ka=L._heif_context_add_item_references=d.Wc,qa=L._heif_context_add_item=d.Xc,aa=L._heif_context_add_mime_item=d.Yc,$a=L._heif_context_add_precompressed_mime_item=d.Zc,da=L._heif_context_add_uri_item=d._c,ca=L._heif_context_has_sequence=d.$c,ba=L._heif_context_get_sequence_timescale=d.ad,i$=L._heif_context_get_sequence_duration=d.bd,e$=L._heif_track_release=d.cd,r$=L._heif_context_number_of_sequence_tracks=d.dd,f$=L._heif_context_get_track_ids=d.ed,A$=L._heif_track_get_id=d.fd,k$=L._heif_context_get_track=d.gd,n$=L._heif_track_get_track_handler_type=d.hd,t$=L._heif_track_get_auxiliary_info_type=d.id,u$=L._heif_track_get_auxiliary_info_type_urn=d.jd,o$=L._heif_track_has_alpha_channel=d.kd,l$=L._heif_track_get_timescale=d.ld,s$=L._heif_track_get_image_resolution=d.md,w$=L._heif_track_decode_next_image=d.nd,h$=L._heif_decoding_options_alloc=d.od,_$=L._heif_decoding_options_copy=d.pd,B$=L._heif_decoding_options_free=d.qd,v$=L._heif_image_get_duration=d.rd,m$=L._heif_track_get_sample_entry_type_of_first_cluster=d.sd,Z$=L._heif_track_get_urim_sample_entry_uri_of_first_cluster=d.td,G$=L._heif_track_get_next_raw_sequence_sample=d.ud,X$=L._heif_raw_sequence_sample_release=d.vd,W$=L._heif_raw_sequence_sample_get_data=d.wd,Q$=L._heif_raw_sequence_sample_get_data_size=d.xd,g$=L._heif_raw_sequence_sample_get_duration=d.yd,V$=L._heif_context_set_sequence_timescale=d.zd,F$=L._heif_context_set_number_of_sequence_repetitions=d.Ad,I$=L._heif_track_options_alloc=d.Bd,C$=L._heif_track_options_release=d.Cd,p$=L._heif_tai_clock_info_release=d.Dd,y$=L._heif_track_options_set_timescale=d.Ed,E$=L._heif_track_options_set_interleaved_sample_aux_infos=d.Fd,Y$=L._heif_track_options_enable_sample_tai_timestamps=d.Gd,R$=L._heif_tai_clock_info_alloc=d.Hd,J$=L._heif_tai_clock_info_copy=d.Id,N$=L._heif_track_options_enable_sample_gimi_content_ids=d.Jd,U$=L._heif_track_options_set_gimi_track_id=d.Kd,D$=L._heif_sequence_encoding_options_alloc=d.Ld,M$=L._heif_sequence_encoding_options_release=d.Md,H$=L._heif_context_add_visual_sequence_track=d.Nd,z$=L._heif_image_set_duration=d.Od,x$=L._heif_track_encode_end_of_sequence=d.Pd,T$=L._heif_track_encode_sequence_image=d.Qd,S$=L._heif_context_add_uri_metadata_sequence_track=d.Rd,j$=L._heif_raw_sequence_sample_alloc=d.Sd,O$=L._heif_raw_sequence_sample_set_data=d.Td,P$=L._heif_raw_sequence_sample_set_duration=d.Ud,L$=L._heif_track_add_raw_sequence_sample=d.Vd,K$=L._heif_track_get_number_of_sample_aux_infos=d.Wd,q$=L._heif_track_get_sample_aux_info_types=d.Xd,a$=L._heif_track_get_gimi_track_content_id=d.Yd,$$=L._heif_image_get_gimi_sample_content_id=d.Zd,d$=L._heif_raw_sequence_sample_get_gimi_sample_content_id=d._d,c$=L._heif_image_set_gimi_sample_content_id=d.$d,b$=L._heif_raw_sequence_sample_set_gimi_sample_content_id=d.ae,id=L._heif_raw_sequence_sample_has_tai_timestamp=d.be,ed=L._heif_raw_sequence_sample_get_tai_timestamp=d.ce,rd=L._heif_raw_sequence_sample_set_tai_timestamp=d.de,fd=L._heif_track_get_tai_clock_info_of_first_cluster=d.ee,Ad=L._heif_track_add_reference_to_track=d.fe,kd=L._heif_track_get_number_of_track_reference_types=d.ge,nd=L._heif_track_get_track_reference_types=d.he,td=L._heif_track_get_number_of_track_reference_of_type=d.ie,ud=L._heif_track_get_references_from_track=d.je,od=L._heif_track_find_referring_tracks=d.ke,ld=L._heif_item_set_property_tai_clock_info=d.le,sd=L._heif_item_get_property_tai_clock_info=d.me,wd=L._heif_item_set_property_tai_timestamp=d.ne,hd=L._heif_item_get_property_tai_timestamp=d.oe,_d=L._heif_image_set_tai_timestamp=d.pe,Bd=L._heif_image_get_tai_timestamp=d.qe,vd=L._heif_read_main_brand=d.re,md=L._heif_fourcc_to_brand=d.se,Zd=L._heif_read_minor_version_brand=d.te,Gd=L._heif_brand_to_fourcc=d.ue,Xd=L._heif_has_compatible_brand=d.ve,Wd=L._heif_get_global_security_limits=d.we,Qd=L._heif_list_compatible_brands=d.xe,gd=L._heif_free_list_of_compatible_brands=d.ye,Vd=L._heif_get_file_mime_type=d.ze,Fd=L._heif_has_compatible_filetype=d.Ae,Id=L._heif_check_jpeg_filetype=d.Be,Cd=L._heif_main_brand=d.Ce,pd=L._heif_metadata_compression_method_supported=d.De,yd=L._heif_image_handle_get_number_of_metadata_blocks=d.Ee,Ed=L._heif_image_handle_get_list_of_metadata_block_IDs=d.Fe,Yd=L._heif_image_handle_get_metadata_type=d.Ge,Rd=L._heif_image_handle_get_metadata_content_type=d.He,Jd=L._heif_image_handle_get_metadata_size=d.Ie,Nd=L._heif_image_handle_get_metadata=d.Je,Ud=L._heif_image_handle_get_metadata_item_uri_type=d.Ke,Dd=L._heif_context_add_exif_metadata=d.Le,Md=L._heif_context_add_XMP_metadata=d.Me,Hd=L._heif_context_add_XMP_metadata2=d.Ne,zd=L._heif_context_add_generic_metadata=d.Oe,xd=L._heif_context_add_generic_uri_metadata=d.Pe,Td=L._heif_image_handle_has_depth_image=d.Qe,Sd=L._heif_image_handle_get_number_of_depth_images=d.Re,jd=L._heif_image_handle_get_list_of_depth_image_IDs=d.Se,Od=L._heif_image_handle_get_depth_image_handle=d.Te,Pd=L._heif_depth_representation_info_free=d.Ue,Ld=L._heif_image_handle_get_depth_image_representation_info=d.Ve,Kd=L._heif_image_handle_get_number_of_thumbnails=d.We,qd=L._heif_image_handle_get_list_of_thumbnail_IDs=d.Xe,ad=L._heif_image_handle_get_thumbnail=d.Ye,$d=L._heif_context_encode_thumbnail=d.Ze,dd=L._heif_encoding_options_alloc=d._e,cd=L._heif_encoding_options_copy=d.$e,bd=L._heif_encoding_options_free=d.af,ic=L._heif_context_assign_thumbnail=d.bf,ec=L._heif_image_handle_get_number_of_auxiliary_images=d.cf,rc=L._heif_image_handle_get_list_of_auxiliary_image_IDs=d.df,fc=L._heif_image_handle_get_auxiliary_type=d.ef,Ac=L._heif_image_handle_release_auxiliary_type=d.ff,kc=L._heif_image_handle_get_auxiliary_image_handle=d.gf,nc=L._heif_image_handle_free_auxiliary_types=d.hf,tc=L._heif_context_get_entity_groups=d.jf,uc=L._heif_entity_groups_release=d.kf,oc=L._heif_get_disabled_security_limits=d.lf,lc=L._heif_context_get_security_limits=d.mf,sc=L._heif_context_set_security_limits=d.nf,wc=L._heif_context_set_maximum_image_size_limit=d.of,hc=L._heif_have_encoder_for_format=d.pf,_c=L._heif_get_encoder_descriptors=d.qf,Bc=L._heif_encoder_descriptor_get_name=d.rf,vc=L._heif_encoder_descriptor_get_id_name=d.sf,mc=L._heif_encoder_descriptor_get_compression_format=d.tf,Zc=L._heif_encoder_descriptor_supports_lossy_compression=d.uf,Gc=L._heif_encoder_descriptor_supports_lossless_compression=d.vf,Xc=L._heif_context_get_encoder=d.wf,Wc=L._heif_context_get_encoder_for_format=d.xf,Qc=L._heif_encoder_release=d.yf,gc=L._heif_encoder_get_name=d.zf,Vc=L._heif_encoder_set_lossy_quality=d.Af,Fc=L._heif_encoder_set_lossless=d.Bf,Ic=L._heif_encoder_set_logging_level=d.Cf,Cc=L._heif_encoder_list_parameters=d.Df,pc=L._heif_encoder_parameter_get_name=d.Ef,yc=L._heif_encoder_parameter_get_type=d.Ff,Ec=L._heif_encoder_parameter_get_valid_integer_range=d.Gf,Yc=L._heif_encoder_parameter_get_valid_integer_values=d.Hf,Rc=L._heif_encoder_parameter_get_valid_string_values=d.If,Jc=L._heif_encoder_set_parameter_integer=d.Jf,Nc=L._heif_encoder_get_parameter_integer=d.Kf,Uc=L._heif_encoder_parameter_integer_valid_range=d.Lf,Dc=L._heif_encoder_set_parameter_boolean=d.Mf,Mc=L._heif_encoder_get_parameter_boolean=d.Nf,Hc=L._heif_encoder_set_parameter_string=d.Of,zc=L._heif_encoder_get_parameter_string=d.Pf,xc=L._heif_encoder_parameter_string_valid_values=d.Qf,Tc=L._heif_encoder_parameter_integer_valid_values=d.Rf,Sc=L._heif_encoder_set_parameter=d.Sf,jc=L._heif_encoder_get_parameter=d.Tf,Oc=L._heif_encoder_has_default=d.Uf,Pc=L._heif_context_encode_image=d.Vf,Lc=L._heif_context_add_overlay_image=d.Wf,Kc=L._heif_context_set_primary_image=d.Xf,qc=L._heif_context_set_major_brand=d.Yf,ac=L._heif_context_add_compatible_brand=d.Zf,$c=L._heif_encoder_descriptor_supportes_lossy_compression=d._f,dc=L._heif_encoder_descriptor_supportes_lossless_compression=d.$f,cc=L._heif_context_get_encoder_descriptors=d.ag,bc=L._heif_context_set_max_decoding_threads=d.bg,ib=L._heif_have_decoder_for_format=d.cg,eb=L._heif_get_decoder_descriptors=d.dg,rb=L._heif_decoder_descriptor_get_name=d.eg,fb=L._heif_decoder_descriptor_get_id_name=d.fg,Ab=L._heif_image_handle_get_item_id=d.gg,kb=L._heif_image_handle_get_luma_bits_per_pixel=d.hg,nb=L._heif_image_handle_get_chroma_bits_per_pixel=d.ig,tb=L._heif_image_handle_get_preferred_decoding_colorspace=d.jg,ub=L._heif_image_handle_get_ispe_width=d.kg,ob=L._heif_image_handle_get_ispe_height=d.lg,lb=L._heif_image_handle_get_pixel_aspect_ratio=d.mg,sb=L._heif_image_handle_get_context=d.ng,wb=L._heif_image_handle_get_gimi_content_id=d.og,hb=L._heif_context_read_from_file=d.pg,_b=L._heif_context_read_from_memory_without_copy=d.qg,Bb=L._heif_context_read_from_reader=d.rg,vb=L._heif_context_is_top_level_image_ID=d.sg,mb=L._heif_context_get_primary_image_ID=d.tg,Zb=L._heif_context_debug_dump_boxes_to_file=d.ug,Gb=L._heif_context_write_to_file=d.vg,Xb=L._heif_context_write=d.wg,Wb=L._heif_image_handle_get_image_tiling=d.xg,Qb=L._heif_image_handle_get_grid_image_tile_id=d.yg,gb=L._heif_image_handle_decode_image_tile=d.zg,Vb=L._heif_context_encode_grid=d.Ag,Fb=L._heif_context_add_grid_image=d.Bg,Ib=L._heif_context_add_image_tile=d.Cg,Cb=L._heif_unci_image_parameters_alloc=d.Dg,pb=L._heif_unci_image_parameters_copy=d.Eg,yb=L._heif_unci_image_parameters_release=d.Fg,Eb=L._heif_context_add_empty_unci_image=d.Gg,Yb=L._heif_image_handle_add_text_item=d.Hg,Rb=L._heif_text_item_release=d.Ig,Jb=L._heif_image_handle_get_number_of_text_items=d.Jg,Nb=L._heif_image_handle_get_list_of_text_item_ids=d.Kg,Ub=L._heif_context_get_text_item=d.Lg,Db=L._heif_text_item_get_id=d.Mg,Mb=L._heif_text_item_get_content=d.Ng,Hb=L._heif_text_item_get_property_extended_language=d.Og,zb=L._heif_text_item_set_extended_language=d.Pg,xb=L._de265_new_decoder=d.Qg,Tb=L._de265_set_parameter_bool=d.Rg,Sb=L._de265_get_version=d.Sg,jb=L._de265_init=d.Tg,Ob=L._de265_free=d.Ug,Pb=L._de265_free_decoder=d.Vg,Lb=L._de265_push_NAL=d.Wg,Kb=L._de265_flush_data=d.Xg,qb=L._de265_decode=d.Yg,ab=L._de265_get_next_picture=d.Zg,$b=L._de265_get_image_user_data=d._g,db=L._de265_get_chroma_format=d.$g,cb=L._de265_get_image_width=d.ah,bb=L._de265_get_image_height=d.bh,i00=L._de265_get_bits_per_pixel=d.ch,e00=L._de265_get_image_plane=d.dh,r00=L._de265_get_image_colour_primaries=d.eh,f00=L._de265_get_image_transfer_characteristics=d.fh,A00=L._de265_get_image_matrix_coefficients=d.gh,k00=L._de265_get_image_full_range_flag=d.hh,n00=L._de265_release_next_picture=d.ih,B_=d.jh,t00=L._memcpy=d.kh,u00=L.dynCall_ji=d.lh,o00=L.dynCall_iij=d.mh,l00=L.dynCall_jijj=d.nh,s00=L.dynCall_vijj=d.oh,w00=L.dynCall_jiji=d.ph,h00=L.dynCall_viijii=d.qh,_00=L.dynCall_iiiiij=d.rh,B00=L.dynCall_iiiiijj=d.sh,v00=L.dynCall_iiiiiijj=d.th,m00=L._heif_error_null_pointer_argument=94276,Z00=L._heif_error_success=96224,G00=L._heif_error_ok=96652,X00=L._heif_error_invalid_parameter_value=96676,W00=L._heif_error_unsupported_parameter=96664;function kf(){if(X6>0){Di=kf;return}if(sw(),X6>0){Di=kf;return}function J(){var D;L.calledRun=!0,!Ok&&(ww(),m6(L),(D=L.onRuntimeInitialized)==null||D.call(L),hw())}L.setStatus?(L.setStatus("Running..."),setTimeout(()=>{setTimeout(()=>L.setStatus(""),1),J()},1)):J()}function v_(){if(L.preInit)for(typeof L.preInit=="function"&&(L.preInit=[L.preInit]);L.preInit.length>0;)L.preInit.shift()()}v_(),kf();function G7(J){for(var D=new ArrayBuffer(J.length),j=new Uint8Array(D),K=0,i0=J.length;K<i0;K++)j[K]=J.charCodeAt(K);return D}var m8=function(J){this.handle=J,this.img=null};m8.prototype.free=function(){this.handle&&(L.heif_image_handle_release(this.handle),this.handle=null)},m8.prototype._ensureImage=function(){if(!this.img){var J=L.heif_js_decode_image(this.handle,L.heif_colorspace.heif_colorspace_YCbCr,L.heif_chroma.heif_chroma_420);if(!J||J.code){console.log("Decoding image failed",this.handle,J);return}this.data=new Uint8Array(G7(J.data)),delete J.data,this.img=J,J.alpha!==void 0&&(this.alpha=new Uint8Array(G7(J.alpha)),delete J.alpha)}},m8.prototype.get_width=function(){return L.heif_image_handle_get_width(this.handle)},m8.prototype.get_height=function(){return L.heif_image_handle_get_height(this.handle)},m8.prototype.is_primary=function(){return!!L.heif_image_handle_is_primary_image(this.handle)},m8.prototype.has_alpha_channel=function(){return!!L.heif_image_handle_has_alpha_channel(this.handle)},m8.prototype.is_premultiplied_alpha=function(){return!!L.heif_image_handle_is_premultiplied_alpha(this.handle)},m8.prototype.display=function(J,D){var j=this.get_width(),K=this.get_height();setTimeout(function(){return v6(this,null,function*(){if(!this.img){var i0=yield L.heif_js_decode_image2(this.handle,L.heif_colorspace.heif_colorspace_RGB,L.heif_chroma.heif_chroma_interleaved_RGBA);if(!i0||i0.code){console.log("Decoding image failed",this.handle,i0),D(null);return}for(let c of i0.channels)if(c.id==L.heif_channel.heif_channel_interleaved)if(c.stride==c.width*4)J.data.set(c.data);else for(let h0=0;h0<c.height;h0++){let Z0=c.data.slice(h0*c.stride,h0*c.stride+c.width*4),B0=h0*c.width*4;J.data.set(Z0,B0)}L.heif_image_release(i0.image)}D(J)})}.bind(this),0)};var X7=function(){this.decoder=null};X7.prototype.decode=function(J){if(this.decoder&&L.heif_context_free(this.decoder),this.decoder=L.heif_context_alloc(),!this.decoder)return console.log("Could not create HEIF context"),[];var D=L.heif_context_read_from_memory(this.decoder,J);if(D.code!==L.heif_error_code.heif_error_Ok)return console.log("Could not parse HEIF file",D.message),[];var j=L.heif_js_context_get_list_of_top_level_image_IDs(this.decoder);if(!j||j.code)return console.log("Error loading image ids",j),[];if(!j.length)return console.log("No images found"),[];for(var K=[],i0=0;i0<j.length;i0++){var c=L.heif_js_context_get_image_handle(this.decoder,j[i0]);if(!c||c.code){console.log("Could not get image data for id",j[i0],c);continue}K.push(new m8(c))}return K};var m_=function(J){return J.charCodeAt(0)<<24|J.charCodeAt(1)<<16|J.charCodeAt(2)<<8|J.charCodeAt(3)};L.HeifImage=m8,L.HeifDecoder=X7,L.fourcc=m_;let Z_=["heif_error_code","heif_suberror_code","heif_compression_format","heif_chroma","heif_colorspace","heif_channel"];for(let J of Z_)for(let D in L[J])!L[J].hasOwnProperty(D)||D==="values"||(L[D]=L[J][D]);for(let J in L)J.indexOf("_heif_")!==0||L[J.slice(1)]!==void 0||(L[J.slice(1)]=L[J]);return r8=L,r8})})(),kw=HL});var xL=ML(Sk=>{nw();var tw=kw(),zL=p1=>v6(null,null,function*(){let s1,V1;try{if(s1=new tw.HeifDecoder,V1=s1.decode(p1),!V1.length)throw new Error("HEIF image not found");let r8=V1[0],L=r8.get_width(),m6=r8.get_height(),Z6=new ImageData(L,m6);for(let C4=0;C4<L*m6;C4++)Z6.data[C4*4+3]=255;return yield new Promise((C4,_8)=>{r8.display(Z6,G6=>{if(!G6)return _8(new Error("HEIF processing error"));C4(G6)})})}finally{if(V1&&V1.length)for(let r8=0;r8<V1.length;r8++)V1[r8].free();s1&&s1.decoder&&tw.heif_context_free(s1.decoder)}});onmessage=p1=>v6(null,null,function*(){let s1=p1.data.id;try{let V1=yield zL(p1.data.buffer);postMessage({id:s1,imageData:V1,error:""})}catch(V1){postMessage({id:s1,imageData:null,error:V1&&V1.toString?V1.toString():V1})}})});xL();})();\n', t = new Blob([
            r
        ], {
            type: "application/javascript"
        });
        $c513f619e4da868b$var$i = new Worker(URL.createObjectURL(t)), $c513f619e4da868b$var$i.onerror = (e)=>console.error("Worker error:", e);
    }
    return $c513f619e4da868b$var$i;
}, $c513f619e4da868b$var$m = (r)=>$c513f619e4da868b$var$d(null, null, function*() {
        return new Promise((t, e)=>{
            $c513f619e4da868b$var$g();
            let c = (Math.random() * new Date().getTime()).toString(), f = {
                id: c,
                buffer: r
            };
            $c513f619e4da868b$var$i.postMessage(f);
            let o = (a)=>{
                if (a.data.id === c) return a.currentTarget.removeEventListener("message", o), a.currentTarget.removeEventListener("error", n), a.data.error ? e(a.data.error) : t(a.data.imageData);
            }, n = (a)=>(a.currentTarget.removeEventListener("message", o), a.currentTarget.removeEventListener("error", n), e(a.data));
            $c513f619e4da868b$var$i.addEventListener("message", o), $c513f619e4da868b$var$i.addEventListener("error", n);
        });
    }), $c513f619e4da868b$var$l = (r)=>$c513f619e4da868b$var$d(null, null, function*() {
        let t = yield $c513f619e4da868b$var$m(r), e = document.createElement("canvas");
        return e.width = t.width, e.height = t.height, e.getContext("2d").putImageData(t, 0, 0), e;
    }), $c513f619e4da868b$var$w = (r)=>{
    r.width = 1, r.height = 1;
    let t = r.getContext("2d");
    t && t.clearRect(0, 0, 1, 1);
}, $c513f619e4da868b$export$abdd76339270e372 = (f)=>$c513f619e4da868b$var$d(null, [
        f
    ], function*({ blob: r, type: t, quality: e, options: c }) {
        if (t == "bitmap") {
            let o = yield r.arrayBuffer(), n = yield $c513f619e4da868b$var$m(o);
            return createImageBitmap(n, c);
        } else {
            let o = yield r.arrayBuffer(), n;
            try {
                return n = yield $c513f619e4da868b$var$l(o), yield new Promise((a, s)=>n.toBlob((u)=>{
                        u != null ? a(u) : s("Can't convert canvas to blob.");
                    }, t, e));
            } finally{
                n && $c513f619e4da868b$var$w(n);
            }
        }
    });


var $5ce5aeca99e3b2a2$require$heicTo = $c513f619e4da868b$export$abdd76339270e372;
const $5ce5aeca99e3b2a2$var$FilePreviewMediaPort = {
    add: function(app) {
        const layoutObserver = new ResizeObserver((entries)=>{
            for (const entry of entries){
                const requestId = entry.target.getAttribute("data-fp-request-id");
                if (!requestId || !app.ports.previewLayoutSized) continue;
                const cr = entry.contentRect;
                app.ports.previewLayoutSized.send({
                    requestId: requestId,
                    width: cr.width,
                    height: cr.height
                });
            }
        });
        const observedLayoutElements = new Map();
        if (app.ports.convertHeicFromUrl) app.ports.convertHeicFromUrl.subscribe(async ({ requestId: requestId, url: url })=>{
            try {
                const res = await fetch(url);
                if (!res.ok) throw new Error("fetch failed");
                const blob = await res.blob();
                const outBlob = await $5ce5aeca99e3b2a2$require$heicTo({
                    blob: blob,
                    type: "image/jpeg",
                    quality: 0.9
                });
                const objectUrl = URL.createObjectURL(outBlob);
                app.ports.heicPreviewResult.send({
                    requestId: requestId,
                    url: objectUrl
                });
            } catch  {
                app.ports.heicPreviewResult.send({
                    requestId: requestId,
                    url: null
                });
            }
        });
        if (app.ports.observePreviewLayout) app.ports.observePreviewLayout.subscribe(({ elementId: elementId, requestId: requestId })=>{
            const el = document.getElementById(elementId);
            if (!el) return;
            const prev = observedLayoutElements.get(elementId);
            if (prev) layoutObserver.unobserve(prev);
            el.setAttribute("data-fp-request-id", requestId);
            layoutObserver.observe(el);
            observedLayoutElements.set(elementId, el);
            const r = el.getBoundingClientRect();
            if (app.ports.previewLayoutSized) app.ports.previewLayoutSized.send({
                requestId: requestId,
                width: r.width,
                height: r.height
            });
        });
        if (app.ports.revokePreviewObjectUrl) app.ports.revokePreviewObjectUrl.subscribe((u)=>{
            try {
                if (u && String(u).startsWith("blob:")) URL.revokeObjectURL(u);
            } catch  {}
        });
        if (app.ports.mediaPlay) app.ports.mediaPlay.subscribe(({ elementId: elementId })=>{
            const el = document.getElementById(elementId);
            if (el && (el.tagName === "AUDIO" || el.tagName === "VIDEO")) el.play().catch(()=>{});
        });
        if (app.ports.mediaTogglePlayPause) app.ports.mediaTogglePlayPause.subscribe(({ elementId: elementId })=>{
            const el = document.getElementById(elementId);
            if (!el || el.tagName !== "AUDIO" && el.tagName !== "VIDEO") return;
            if (el.paused) el.play().catch(()=>{});
            else el.pause();
        });
        if (app.ports.mediaSetCurrentTime) app.ports.mediaSetCurrentTime.subscribe(({ elementId: elementId, seconds: seconds })=>{
            const el = document.getElementById(elementId);
            if (!el || el.tagName !== "AUDIO") return;
            const t = Number.isFinite(seconds) ? seconds : 0;
            el.currentTime = Math.max(0, t);
        });
        if (app.ports.videoSeekPreview) app.ports.videoSeekPreview.subscribe(({ videoElementId: videoElementId })=>{
            const v = document.getElementById(videoElementId);
            if (!v || v.tagName !== "VIDEO") return;
            const run = ()=>{
                requestAnimationFrame(()=>{
                    requestAnimationFrame(()=>{
                        const d = v.duration;
                        if (d && !Number.isNaN(d) && d > 0) {
                            const t = Math.min(0.5, d * 0.1);
                            v.currentTime = t > 0 ? t : 0;
                        }
                    });
                });
            };
            if (v.readyState >= 1 && Number.isFinite(v.duration) && v.duration > 0) run();
            else v.addEventListener("loadedmetadata", run, {
                once: true
            });
        });
        return function cleanup() {
            observedLayoutElements.forEach((element)=>{
                layoutObserver.unobserve(element);
            });
            observedLayoutElements.clear();
            layoutObserver.disconnect();
        };
    }
};
$5ce5aeca99e3b2a2$exports = $5ce5aeca99e3b2a2$var$FilePreviewMediaPort;


var $73cbf435bf470aed$exports = {};
var $f489ff3da7c10b03$export$7b82ddf1ba8788ff;
var $f489ff3da7c10b03$export$16c74263c98473fb;
var $f489ff3da7c10b03$export$9c68d69a4c5bbcf9;
var $f489ff3da7c10b03$export$a1ba744cb18565b5;
var $f489ff3da7c10b03$export$6c746a5570b8b35c;
var $f489ff3da7c10b03$export$63e4f03d302d3e40;
var $f489ff3da7c10b03$export$425327af25286e5e;
var $f489ff3da7c10b03$export$7d85d7e73199d20c;
var $f489ff3da7c10b03$export$3d6d846391b5780c;
var $f489ff3da7c10b03$export$65b53a1b2f72fd4c;

var $f489ff3da7c10b03$require$Buffer = $13b630ad92b827c2$export$a143d493d941bafc;
parcelRequire("9jAvV");
var $5yjjJ = parcelRequire("5yjjJ");
var $bae7c73ea3cda3cb$export$aafa59e2e03f2942;
var $bae7c73ea3cda3cb$export$2404ec9a8c74f37d;
$bae7c73ea3cda3cb$export$aafa59e2e03f2942 = $bae7c73ea3cda3cb$var$read;
$bae7c73ea3cda3cb$export$2404ec9a8c74f37d = $bae7c73ea3cda3cb$var$findPartPaths;

var $d93yU = parcelRequire("d93yU");
var $fcf129b7bd4ce72f$export$b14ad400b1d09e0f;
var $fcf129b7bd4ce72f$export$5a7bfc01df82fcd1;
var $fcf129b7bd4ce72f$export$b34a105447964f9f;
var $fcf129b7bd4ce72f$export$9c206ddddb32a9b;
var $fcf129b7bd4ce72f$export$358a232cca1ab2ac;
var $fcf129b7bd4ce72f$export$889ea624f2cb2c57;
var $fcf129b7bd4ce72f$export$ddae37e51c7979e2;
var $fcf129b7bd4ce72f$export$6f093cfa640b7166;
var $fcf129b7bd4ce72f$export$5f1af8db9871e1d6;
var $fcf129b7bd4ce72f$export$62d58b1c91e8e902;
var $fcf129b7bd4ce72f$export$3e41faf802a29e71;
var $fcf129b7bd4ce72f$export$b07e517d22efa1ca;
var $fcf129b7bd4ce72f$export$48513f6b9f8ce62d;
var $fcf129b7bd4ce72f$export$de48447bf377cd47;
var $fcf129b7bd4ce72f$export$bc6e927f6446fee8;
var $fcf129b7bd4ce72f$export$e67f182a50c27e10;
var $fcf129b7bd4ce72f$export$aa31b211d2f4c3af;
var $fcf129b7bd4ce72f$export$6c88bf799aca3d2b;
var $fcf129b7bd4ce72f$export$841d4c6db70c1a65;
var $fcf129b7bd4ce72f$export$4a34f930e789283c;
var $fcf129b7bd4ce72f$export$3e431a229df88919;
var $fcf129b7bd4ce72f$export$54ec01a60f47d33d;
var $fcf129b7bd4ce72f$export$b05581f4e764e162;
var $fcf129b7bd4ce72f$export$1e4baea7053fc0e3;
var $fcf129b7bd4ce72f$export$a1aa2dd4ad0d3f6;
var $fcf129b7bd4ce72f$export$1b438cdd7ed26c35;
var $fcf129b7bd4ce72f$export$5a38f5b463e49b91;
var $fcf129b7bd4ce72f$export$ad0c5cb04e0f1440;
var $fcf129b7bd4ce72f$export$983b95e2e3722091;

var $fcf129b7bd4ce72f$require$Buffer = $13b630ad92b827c2$export$a143d493d941bafc;
parcelRequire("9jAvV");
var $bJcvr = parcelRequire("bJcvr");
var $fcf129b7bd4ce72f$var$types = $fcf129b7bd4ce72f$export$b14ad400b1d09e0f = {
    document: "document",
    paragraph: "paragraph",
    run: "run",
    text: "text",
    tab: "tab",
    checkbox: "checkbox",
    hyperlink: "hyperlink",
    noteReference: "noteReference",
    image: "image",
    note: "note",
    commentReference: "commentReference",
    comment: "comment",
    table: "table",
    tableRow: "tableRow",
    tableCell: "tableCell",
    "break": "break",
    bookmarkStart: "bookmarkStart"
};
function $fcf129b7bd4ce72f$var$Document(children, options) {
    options = options || {};
    return {
        type: $fcf129b7bd4ce72f$var$types.document,
        children: children,
        notes: options.notes || new $fcf129b7bd4ce72f$var$Notes({}),
        comments: options.comments || []
    };
}
function $fcf129b7bd4ce72f$var$Paragraph(children, properties) {
    properties = properties || {};
    var indent = properties.indent || {};
    return {
        type: $fcf129b7bd4ce72f$var$types.paragraph,
        children: children,
        styleId: properties.styleId || null,
        styleName: properties.styleName || null,
        numbering: properties.numbering || null,
        alignment: properties.alignment || null,
        indent: {
            start: indent.start || null,
            end: indent.end || null,
            firstLine: indent.firstLine || null,
            hanging: indent.hanging || null
        }
    };
}
function $fcf129b7bd4ce72f$var$Run(children, properties) {
    properties = properties || {};
    return {
        type: $fcf129b7bd4ce72f$var$types.run,
        children: children,
        styleId: properties.styleId || null,
        styleName: properties.styleName || null,
        isBold: !!properties.isBold,
        isUnderline: !!properties.isUnderline,
        isItalic: !!properties.isItalic,
        isStrikethrough: !!properties.isStrikethrough,
        isAllCaps: !!properties.isAllCaps,
        isSmallCaps: !!properties.isSmallCaps,
        verticalAlignment: properties.verticalAlignment || $fcf129b7bd4ce72f$var$verticalAlignment.baseline,
        font: properties.font || null,
        fontSize: properties.fontSize || null,
        highlight: properties.highlight || null
    };
}
var $fcf129b7bd4ce72f$var$verticalAlignment = {
    baseline: "baseline",
    superscript: "superscript",
    subscript: "subscript"
};
function $fcf129b7bd4ce72f$var$Text(value) {
    return {
        type: $fcf129b7bd4ce72f$var$types.text,
        value: value
    };
}
function $fcf129b7bd4ce72f$var$Tab() {
    return {
        type: $fcf129b7bd4ce72f$var$types.tab
    };
}
function $fcf129b7bd4ce72f$var$Checkbox(options) {
    return {
        type: $fcf129b7bd4ce72f$var$types.checkbox,
        checked: options.checked
    };
}
function $fcf129b7bd4ce72f$var$Hyperlink(children, options) {
    return {
        type: $fcf129b7bd4ce72f$var$types.hyperlink,
        children: children,
        href: options.href,
        anchor: options.anchor,
        targetFrame: options.targetFrame
    };
}
function $fcf129b7bd4ce72f$var$NoteReference(options) {
    return {
        type: $fcf129b7bd4ce72f$var$types.noteReference,
        noteType: options.noteType,
        noteId: options.noteId
    };
}
function $fcf129b7bd4ce72f$var$Notes(notes) {
    this._notes = $bJcvr.default(notes, function(note) {
        return $fcf129b7bd4ce72f$var$noteKey(note.noteType, note.noteId);
    });
}
$fcf129b7bd4ce72f$var$Notes.prototype.resolve = function(reference) {
    return this.findNoteByKey($fcf129b7bd4ce72f$var$noteKey(reference.noteType, reference.noteId));
};
$fcf129b7bd4ce72f$var$Notes.prototype.findNoteByKey = function(key) {
    return this._notes[key] || null;
};
function $fcf129b7bd4ce72f$var$Note(options) {
    return {
        type: $fcf129b7bd4ce72f$var$types.note,
        noteType: options.noteType,
        noteId: options.noteId,
        body: options.body
    };
}
function $fcf129b7bd4ce72f$var$commentReference(options) {
    return {
        type: $fcf129b7bd4ce72f$var$types.commentReference,
        commentId: options.commentId
    };
}
function $fcf129b7bd4ce72f$var$comment(options) {
    return {
        type: $fcf129b7bd4ce72f$var$types.comment,
        commentId: options.commentId,
        body: options.body,
        authorName: options.authorName,
        authorInitials: options.authorInitials
    };
}
function $fcf129b7bd4ce72f$var$noteKey(noteType, id) {
    return noteType + "-" + id;
}
function $fcf129b7bd4ce72f$var$Image(options) {
    return {
        type: $fcf129b7bd4ce72f$var$types.image,
        // `read` is retained for backwards compatibility, but other read
        // methods should be preferred.
        read: function(encoding) {
            if (encoding) return options.readImage(encoding);
            else return options.readImage().then(function(arrayBuffer) {
                return $fcf129b7bd4ce72f$require$Buffer.from(arrayBuffer);
            });
        },
        readAsArrayBuffer: function() {
            return options.readImage();
        },
        readAsBase64String: function() {
            return options.readImage("base64");
        },
        readAsBuffer: function() {
            return options.readImage().then(function(arrayBuffer) {
                return $fcf129b7bd4ce72f$require$Buffer.from(arrayBuffer);
            });
        },
        altText: options.altText,
        contentType: options.contentType
    };
}
function $fcf129b7bd4ce72f$var$Table(children, properties) {
    properties = properties || {};
    return {
        type: $fcf129b7bd4ce72f$var$types.table,
        children: children,
        styleId: properties.styleId || null,
        styleName: properties.styleName || null
    };
}
function $fcf129b7bd4ce72f$var$TableRow(children, options) {
    options = options || {};
    return {
        type: $fcf129b7bd4ce72f$var$types.tableRow,
        children: children,
        isHeader: options.isHeader || false
    };
}
function $fcf129b7bd4ce72f$var$TableCell(children, options) {
    options = options || {};
    return {
        type: $fcf129b7bd4ce72f$var$types.tableCell,
        children: children,
        colSpan: options.colSpan == null ? 1 : options.colSpan,
        rowSpan: options.rowSpan == null ? 1 : options.rowSpan
    };
}
function $fcf129b7bd4ce72f$var$Break(breakType) {
    return {
        type: $fcf129b7bd4ce72f$var$types["break"],
        breakType: breakType
    };
}
function $fcf129b7bd4ce72f$var$BookmarkStart(options) {
    return {
        type: $fcf129b7bd4ce72f$var$types.bookmarkStart,
        name: options.name
    };
}
$fcf129b7bd4ce72f$export$5a7bfc01df82fcd1 = $fcf129b7bd4ce72f$export$b34a105447964f9f = $fcf129b7bd4ce72f$var$Document;
$fcf129b7bd4ce72f$export$9c206ddddb32a9b = $fcf129b7bd4ce72f$export$358a232cca1ab2ac = $fcf129b7bd4ce72f$var$Paragraph;
$fcf129b7bd4ce72f$export$889ea624f2cb2c57 = $fcf129b7bd4ce72f$export$ddae37e51c7979e2 = $fcf129b7bd4ce72f$var$Run;
$fcf129b7bd4ce72f$export$6f093cfa640b7166 = $fcf129b7bd4ce72f$export$5f1af8db9871e1d6 = $fcf129b7bd4ce72f$var$Text;
$fcf129b7bd4ce72f$export$62d58b1c91e8e902 = $fcf129b7bd4ce72f$export$3e41faf802a29e71 = $fcf129b7bd4ce72f$var$Tab;
$fcf129b7bd4ce72f$export$b07e517d22efa1ca = $fcf129b7bd4ce72f$export$48513f6b9f8ce62d = $fcf129b7bd4ce72f$var$Checkbox;
$fcf129b7bd4ce72f$export$de48447bf377cd47 = $fcf129b7bd4ce72f$var$Hyperlink;
$fcf129b7bd4ce72f$export$bc6e927f6446fee8 = $fcf129b7bd4ce72f$export$e67f182a50c27e10 = $fcf129b7bd4ce72f$var$NoteReference;
$fcf129b7bd4ce72f$export$aa31b211d2f4c3af = $fcf129b7bd4ce72f$var$Notes;
$fcf129b7bd4ce72f$export$6c88bf799aca3d2b = $fcf129b7bd4ce72f$var$Note;
$fcf129b7bd4ce72f$export$841d4c6db70c1a65 = $fcf129b7bd4ce72f$var$commentReference;
$fcf129b7bd4ce72f$export$4a34f930e789283c = $fcf129b7bd4ce72f$var$comment;
$fcf129b7bd4ce72f$export$3e431a229df88919 = $fcf129b7bd4ce72f$var$Image;
$fcf129b7bd4ce72f$export$54ec01a60f47d33d = $fcf129b7bd4ce72f$var$Table;
$fcf129b7bd4ce72f$export$b05581f4e764e162 = $fcf129b7bd4ce72f$var$TableRow;
$fcf129b7bd4ce72f$export$1e4baea7053fc0e3 = $fcf129b7bd4ce72f$var$TableCell;
$fcf129b7bd4ce72f$export$a1aa2dd4ad0d3f6 = $fcf129b7bd4ce72f$var$Break("line");
$fcf129b7bd4ce72f$export$1b438cdd7ed26c35 = $fcf129b7bd4ce72f$var$Break("page");
$fcf129b7bd4ce72f$export$5a38f5b463e49b91 = $fcf129b7bd4ce72f$var$Break("column");
$fcf129b7bd4ce72f$export$ad0c5cb04e0f1440 = $fcf129b7bd4ce72f$var$BookmarkStart;
$fcf129b7bd4ce72f$export$983b95e2e3722091 = $fcf129b7bd4ce72f$var$verticalAlignment;


var $11d28a8fc8838027$export$8fdcabde73f49165;
var $11d28a8fc8838027$export$fe7c49d056ea1d88;
var $11d28a8fc8838027$export$491112666e282270;
var $11d28a8fc8838027$export$a3bc9b8ed74fc;
parcelRequire("9jAvV");
var $bss2W = parcelRequire("bss2W");
var $1TwZj = parcelRequire("1TwZj");
var $gS9W9 = parcelRequire("gS9W9");
$11d28a8fc8838027$export$8fdcabde73f49165 = $11d28a8fc8838027$var$Result;
$11d28a8fc8838027$export$fe7c49d056ea1d88 = $11d28a8fc8838027$var$success;
$11d28a8fc8838027$export$491112666e282270 = $11d28a8fc8838027$var$warning;
$11d28a8fc8838027$export$a3bc9b8ed74fc = $11d28a8fc8838027$var$error;
function $11d28a8fc8838027$var$Result(value, messages) {
    this.value = value;
    this.messages = messages || [];
}
$11d28a8fc8838027$var$Result.prototype.map = function(func) {
    return new $11d28a8fc8838027$var$Result(func(this.value), this.messages);
};
$11d28a8fc8838027$var$Result.prototype.flatMap = function(func) {
    var funcResult = func(this.value);
    return new $11d28a8fc8838027$var$Result(funcResult.value, $11d28a8fc8838027$var$combineMessages([
        this,
        funcResult
    ]));
};
$11d28a8fc8838027$var$Result.prototype.flatMapThen = function(func) {
    var that = this;
    return func(this.value).then(function(otherResult) {
        return new $11d28a8fc8838027$var$Result(otherResult.value, $11d28a8fc8838027$var$combineMessages([
            that,
            otherResult
        ]));
    });
};
$11d28a8fc8838027$var$Result.combine = function(results) {
    var values = $1TwZj.default($gS9W9.default(results, "value"));
    var messages = $11d28a8fc8838027$var$combineMessages(results);
    return new $11d28a8fc8838027$var$Result(values, messages);
};
function $11d28a8fc8838027$var$success(value) {
    return new $11d28a8fc8838027$var$Result(value, []);
}
function $11d28a8fc8838027$var$warning(message) {
    return {
        type: "warning",
        message: message
    };
}
function $11d28a8fc8838027$var$error(exception) {
    return {
        type: "error",
        message: exception.message,
        error: exception
    };
}
function $11d28a8fc8838027$var$combineMessages(results) {
    var messages = [];
    $1TwZj.default($gS9W9.default(results, "messages"), true).forEach(function(message) {
        if (!$11d28a8fc8838027$var$containsMessage(messages, message)) messages.push(message);
    });
    return messages;
}
function $11d28a8fc8838027$var$containsMessage(messages, message) {
    return $bss2W.default(messages, $11d28a8fc8838027$var$isSameMessage.bind(null, message)) !== undefined;
}
function $11d28a8fc8838027$var$isSameMessage(first, second) {
    return first.type === second.type && first.message === second.message;
}


var $bae7c73ea3cda3cb$require$Result = $11d28a8fc8838027$export$8fdcabde73f49165;
var $3e56e634a929bca6$export$94ea64f322e5a37c;
var $3e56e634a929bca6$export$824c337f43f2b64d;
var $3e56e634a929bca6$export$b891921babc70093;

var $921d13038eff58c9$exports = {};
/*!

JSZip v3.10.1 - A JavaScript class for generating and reading zip files
<http://stuartk.com/jszip>

(c) 2009-2016 Stuart Knightley <stuart [at] stuartk.com>
Dual licenced under the MIT license or GPLv3. See https://raw.github.com/Stuk/jszip/main/LICENSE.markdown.

JSZip uses the library pako released under the MIT license :
https://github.com/nodeca/pako/blob/main/LICENSE
*/ 
var $921d13038eff58c9$require$Buffer = $13b630ad92b827c2$export$a143d493d941bafc;

var $4TZ3D = parcelRequire("4TZ3D");
!function(e) {
    $921d13038eff58c9$exports = e();
}(function() {
    return (function s(a, o, h) {
        function u(r, e) {
            if (!o[r]) {
                if (!a[r]) {
                    var t = undefined;
                    if (!e && t) return t(r, !0);
                    if (l) return l(r, !0);
                    var n = new Error("Cannot find module '" + r + "'");
                    throw n.code = "MODULE_NOT_FOUND", n;
                }
                var i = o[r] = {
                    exports: {}
                };
                a[r][0].call(i.exports, function(e) {
                    var t = a[r][1][e];
                    return u(t || e);
                }, i, i.exports, s, a, o, h);
            }
            return o[r].exports;
        }
        for(var l = undefined, e = 0; e < h.length; e++)u(h[e]);
        return u;
    })({
        1: [
            function(e, t, r) {
                "use strict";
                var d = e("./utils"), c = e("./support"), p = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
                r.encode = function(e) {
                    for(var t, r, n, i, s, a, o, h = [], u = 0, l = e.length, f = l, c = "string" !== d.getTypeOf(e); u < e.length;)f = l - u, n = c ? (t = e[u++], r = u < l ? e[u++] : 0, u < l ? e[u++] : 0) : (t = e.charCodeAt(u++), r = u < l ? e.charCodeAt(u++) : 0, u < l ? e.charCodeAt(u++) : 0), i = t >> 2, s = (3 & t) << 4 | r >> 4, a = 1 < f ? (15 & r) << 2 | n >> 6 : 64, o = 2 < f ? 63 & n : 64, h.push(p.charAt(i) + p.charAt(s) + p.charAt(a) + p.charAt(o));
                    return h.join("");
                }, r.decode = function(e) {
                    var t, r, n, i, s, a, o = 0, h = 0, u = "data:";
                    if (e.substr(0, u.length) === u) throw new Error("Invalid base64 input, it looks like a data url.");
                    var l, f = 3 * (e = e.replace(/[^A-Za-z0-9+/=]/g, "")).length / 4;
                    if (e.charAt(e.length - 1) === p.charAt(64) && f--, e.charAt(e.length - 2) === p.charAt(64) && f--, f % 1 != 0) throw new Error("Invalid base64 input, bad content length.");
                    for(l = c.uint8array ? new Uint8Array(0 | f) : new Array(0 | f); o < e.length;)t = p.indexOf(e.charAt(o++)) << 2 | (i = p.indexOf(e.charAt(o++))) >> 4, r = (15 & i) << 4 | (s = p.indexOf(e.charAt(o++))) >> 2, n = (3 & s) << 6 | (a = p.indexOf(e.charAt(o++))), l[h++] = t, 64 !== s && (l[h++] = r), 64 !== a && (l[h++] = n);
                    return l;
                };
            },
            {
                "./support": 30,
                "./utils": 32
            }
        ],
        2: [
            function(e, t, r) {
                "use strict";
                var n = e("./external"), i = e("./stream/DataWorker"), s = e("./stream/Crc32Probe"), a = e("./stream/DataLengthProbe");
                function o(e, t, r, n, i) {
                    this.compressedSize = e, this.uncompressedSize = t, this.crc32 = r, this.compression = n, this.compressedContent = i;
                }
                o.prototype = {
                    getContentWorker: function() {
                        var e = new i(n.Promise.resolve(this.compressedContent)).pipe(this.compression.uncompressWorker()).pipe(new a("data_length")), t = this;
                        return e.on("end", function() {
                            if (this.streamInfo.data_length !== t.uncompressedSize) throw new Error("Bug : uncompressed data size mismatch");
                        }), e;
                    },
                    getCompressedWorker: function() {
                        return new i(n.Promise.resolve(this.compressedContent)).withStreamInfo("compressedSize", this.compressedSize).withStreamInfo("uncompressedSize", this.uncompressedSize).withStreamInfo("crc32", this.crc32).withStreamInfo("compression", this.compression);
                    }
                }, o.createWorkerFrom = function(e, t, r) {
                    return e.pipe(new s).pipe(new a("uncompressedSize")).pipe(t.compressWorker(r)).pipe(new a("compressedSize")).withStreamInfo("compression", t);
                }, t.exports = o;
            },
            {
                "./external": 6,
                "./stream/Crc32Probe": 25,
                "./stream/DataLengthProbe": 26,
                "./stream/DataWorker": 27
            }
        ],
        3: [
            function(e, t, r) {
                "use strict";
                var n = e("./stream/GenericWorker");
                r.STORE = {
                    magic: "\0\0",
                    compressWorker: function() {
                        return new n("STORE compression");
                    },
                    uncompressWorker: function() {
                        return new n("STORE decompression");
                    }
                }, r.DEFLATE = e("./flate");
            },
            {
                "./flate": 7,
                "./stream/GenericWorker": 28
            }
        ],
        4: [
            function(e, t, r) {
                "use strict";
                var n = e("./utils");
                var o = function() {
                    for(var e, t = [], r = 0; r < 256; r++){
                        e = r;
                        for(var n = 0; n < 8; n++)e = 1 & e ? 3988292384 ^ e >>> 1 : e >>> 1;
                        t[r] = e;
                    }
                    return t;
                }();
                t.exports = function(e, t) {
                    return void 0 !== e && e.length ? "string" !== n.getTypeOf(e) ? function(e, t, r, n) {
                        var i = o, s = n + r;
                        e ^= -1;
                        for(var a = n; a < s; a++)e = e >>> 8 ^ i[255 & (e ^ t[a])];
                        return -1 ^ e;
                    }(0 | t, e, e.length, 0) : function(e, t, r, n) {
                        var i = o, s = n + r;
                        e ^= -1;
                        for(var a = n; a < s; a++)e = e >>> 8 ^ i[255 & (e ^ t.charCodeAt(a))];
                        return -1 ^ e;
                    }(0 | t, e, e.length, 0) : 0;
                };
            },
            {
                "./utils": 32
            }
        ],
        5: [
            function(e, t, r) {
                "use strict";
                r.base64 = !1, r.binary = !1, r.dir = !1, r.createFolders = !0, r.date = null, r.compression = null, r.compressionOptions = null, r.comment = null, r.unixPermissions = null, r.dosPermissions = null;
            },
            {}
        ],
        6: [
            function(e, t, r) {
                "use strict";
                var n = null;
                n = "undefined" != typeof Promise ? Promise : e("lie"), t.exports = {
                    Promise: n
                };
            },
            {
                lie: 37
            }
        ],
        7: [
            function(e, t, r) {
                "use strict";
                var n = "undefined" != typeof Uint8Array && "undefined" != typeof Uint16Array && "undefined" != typeof Uint32Array, i = e("pako"), s = e("./utils"), a = e("./stream/GenericWorker"), o = n ? "uint8array" : "array";
                function h(e, t) {
                    a.call(this, "FlateWorker/" + e), this._pako = null, this._pakoAction = e, this._pakoOptions = t, this.meta = {};
                }
                r.magic = "\b\0", s.inherits(h, a), h.prototype.processChunk = function(e) {
                    this.meta = e.meta, null === this._pako && this._createPako(), this._pako.push(s.transformTo(o, e.data), !1);
                }, h.prototype.flush = function() {
                    a.prototype.flush.call(this), null === this._pako && this._createPako(), this._pako.push([], !0);
                }, h.prototype.cleanUp = function() {
                    a.prototype.cleanUp.call(this), this._pako = null;
                }, h.prototype._createPako = function() {
                    this._pako = new i[this._pakoAction]({
                        raw: !0,
                        level: this._pakoOptions.level || -1
                    });
                    var t = this;
                    this._pako.onData = function(e) {
                        t.push({
                            data: e,
                            meta: t.meta
                        });
                    };
                }, r.compressWorker = function(e) {
                    return new h("Deflate", e);
                }, r.uncompressWorker = function() {
                    return new h("Inflate", {});
                };
            },
            {
                "./stream/GenericWorker": 28,
                "./utils": 32,
                pako: 38
            }
        ],
        8: [
            function(e, t, r) {
                "use strict";
                function A(e, t) {
                    var r, n = "";
                    for(r = 0; r < t; r++)n += String.fromCharCode(255 & e), e >>>= 8;
                    return n;
                }
                function n(e, t, r, n, i, s) {
                    var a, o, h = e.file, u = e.compression, l = s !== O.utf8encode, f = I.transformTo("string", s(h.name)), c = I.transformTo("string", O.utf8encode(h.name)), d = h.comment, p = I.transformTo("string", s(d)), m = I.transformTo("string", O.utf8encode(d)), _ = c.length !== h.name.length, g = m.length !== d.length, b = "", v = "", y = "", w = h.dir, k = h.date, x = {
                        crc32: 0,
                        compressedSize: 0,
                        uncompressedSize: 0
                    };
                    t && !r || (x.crc32 = e.crc32, x.compressedSize = e.compressedSize, x.uncompressedSize = e.uncompressedSize);
                    var S = 0;
                    t && (S |= 8), l || !_ && !g || (S |= 2048);
                    var z = 0, C = 0;
                    w && (z |= 16), "UNIX" === i ? (C = 798, z |= function(e, t) {
                        var r = e;
                        return e || (r = t ? 16893 : 33204), (65535 & r) << 16;
                    }(h.unixPermissions, w)) : (C = 20, z |= function(e) {
                        return 63 & (e || 0);
                    }(h.dosPermissions)), a = k.getUTCHours(), a <<= 6, a |= k.getUTCMinutes(), a <<= 5, a |= k.getUTCSeconds() / 2, o = k.getUTCFullYear() - 1980, o <<= 4, o |= k.getUTCMonth() + 1, o <<= 5, o |= k.getUTCDate(), _ && (v = A(1, 1) + A(B(f), 4) + c, b += "up" + A(v.length, 2) + v), g && (y = A(1, 1) + A(B(p), 4) + m, b += "uc" + A(y.length, 2) + y);
                    var E = "";
                    return E += "\n\0", E += A(S, 2), E += u.magic, E += A(a, 2), E += A(o, 2), E += A(x.crc32, 4), E += A(x.compressedSize, 4), E += A(x.uncompressedSize, 4), E += A(f.length, 2), E += A(b.length, 2), {
                        fileRecord: R.LOCAL_FILE_HEADER + E + f + b,
                        dirRecord: R.CENTRAL_FILE_HEADER + A(C, 2) + E + A(p.length, 2) + "\0\0\0\0" + A(z, 4) + A(n, 4) + f + b + p
                    };
                }
                var I = e("../utils"), i = e("../stream/GenericWorker"), O = e("../utf8"), B = e("../crc32"), R = e("../signature");
                function s(e, t, r, n) {
                    i.call(this, "ZipFileWorker"), this.bytesWritten = 0, this.zipComment = t, this.zipPlatform = r, this.encodeFileName = n, this.streamFiles = e, this.accumulate = !1, this.contentBuffer = [], this.dirRecords = [], this.currentSourceOffset = 0, this.entriesCount = 0, this.currentFile = null, this._sources = [];
                }
                I.inherits(s, i), s.prototype.push = function(e) {
                    var t = e.meta.percent || 0, r = this.entriesCount, n = this._sources.length;
                    this.accumulate ? this.contentBuffer.push(e) : (this.bytesWritten += e.data.length, i.prototype.push.call(this, {
                        data: e.data,
                        meta: {
                            currentFile: this.currentFile,
                            percent: r ? (t + 100 * (r - n - 1)) / r : 100
                        }
                    }));
                }, s.prototype.openedSource = function(e) {
                    this.currentSourceOffset = this.bytesWritten, this.currentFile = e.file.name;
                    var t = this.streamFiles && !e.file.dir;
                    if (t) {
                        var r = n(e, t, !1, this.currentSourceOffset, this.zipPlatform, this.encodeFileName);
                        this.push({
                            data: r.fileRecord,
                            meta: {
                                percent: 0
                            }
                        });
                    } else this.accumulate = !0;
                }, s.prototype.closedSource = function(e) {
                    this.accumulate = !1;
                    var t = this.streamFiles && !e.file.dir, r = n(e, t, !0, this.currentSourceOffset, this.zipPlatform, this.encodeFileName);
                    if (this.dirRecords.push(r.dirRecord), t) this.push({
                        data: function(e) {
                            return R.DATA_DESCRIPTOR + A(e.crc32, 4) + A(e.compressedSize, 4) + A(e.uncompressedSize, 4);
                        }(e),
                        meta: {
                            percent: 100
                        }
                    });
                    else for(this.push({
                        data: r.fileRecord,
                        meta: {
                            percent: 0
                        }
                    }); this.contentBuffer.length;)this.push(this.contentBuffer.shift());
                    this.currentFile = null;
                }, s.prototype.flush = function() {
                    for(var e = this.bytesWritten, t = 0; t < this.dirRecords.length; t++)this.push({
                        data: this.dirRecords[t],
                        meta: {
                            percent: 100
                        }
                    });
                    var r = this.bytesWritten - e, n = function(e, t, r, n, i) {
                        var s = I.transformTo("string", i(n));
                        return R.CENTRAL_DIRECTORY_END + "\0\0\0\0" + A(e, 2) + A(e, 2) + A(t, 4) + A(r, 4) + A(s.length, 2) + s;
                    }(this.dirRecords.length, r, e, this.zipComment, this.encodeFileName);
                    this.push({
                        data: n,
                        meta: {
                            percent: 100
                        }
                    });
                }, s.prototype.prepareNextSource = function() {
                    this.previous = this._sources.shift(), this.openedSource(this.previous.streamInfo), this.isPaused ? this.previous.pause() : this.previous.resume();
                }, s.prototype.registerPrevious = function(e) {
                    this._sources.push(e);
                    var t = this;
                    return e.on("data", function(e) {
                        t.processChunk(e);
                    }), e.on("end", function() {
                        t.closedSource(t.previous.streamInfo), t._sources.length ? t.prepareNextSource() : t.end();
                    }), e.on("error", function(e) {
                        t.error(e);
                    }), this;
                }, s.prototype.resume = function() {
                    return !!i.prototype.resume.call(this) && (!this.previous && this._sources.length ? (this.prepareNextSource(), !0) : this.previous || this._sources.length || this.generatedError ? void 0 : (this.end(), !0));
                }, s.prototype.error = function(e) {
                    var t = this._sources;
                    if (!i.prototype.error.call(this, e)) return !1;
                    for(var r = 0; r < t.length; r++)try {
                        t[r].error(e);
                    } catch (e) {}
                    return !0;
                }, s.prototype.lock = function() {
                    i.prototype.lock.call(this);
                    for(var e = this._sources, t = 0; t < e.length; t++)e[t].lock();
                }, t.exports = s;
            },
            {
                "../crc32": 4,
                "../signature": 23,
                "../stream/GenericWorker": 28,
                "../utf8": 31,
                "../utils": 32
            }
        ],
        9: [
            function(e, t, r) {
                "use strict";
                var u = e("../compressions"), n = e("./ZipFileWorker");
                r.generateWorker = function(e, a, t) {
                    var o = new n(a.streamFiles, t, a.platform, a.encodeFileName), h = 0;
                    try {
                        e.forEach(function(e, t) {
                            h++;
                            var r = function(e, t) {
                                var r = e || t, n = u[r];
                                if (!n) throw new Error(r + " is not a valid compression method !");
                                return n;
                            }(t.options.compression, a.compression), n = t.options.compressionOptions || a.compressionOptions || {}, i = t.dir, s = t.date;
                            t._compressWorker(r, n).withStreamInfo("file", {
                                name: e,
                                dir: i,
                                date: s,
                                comment: t.comment || "",
                                unixPermissions: t.unixPermissions,
                                dosPermissions: t.dosPermissions
                            }).pipe(o);
                        }), o.entriesCount = h;
                    } catch (e) {
                        o.error(e);
                    }
                    return o;
                };
            },
            {
                "../compressions": 3,
                "./ZipFileWorker": 8
            }
        ],
        10: [
            function(e, t, r) {
                "use strict";
                function n() {
                    if (!(this instanceof n)) return new n;
                    if (arguments.length) throw new Error("The constructor with parameters has been removed in JSZip 3.0, please check the upgrade guide.");
                    this.files = Object.create(null), this.comment = null, this.root = "", this.clone = function() {
                        var e = new n;
                        for(var t in this)"function" != typeof this[t] && (e[t] = this[t]);
                        return e;
                    };
                }
                (n.prototype = e("./object")).loadAsync = e("./load"), n.support = e("./support"), n.defaults = e("./defaults"), n.version = "3.10.1", n.loadAsync = function(e, t) {
                    return (new n).loadAsync(e, t);
                }, n.external = e("./external"), t.exports = n;
            },
            {
                "./defaults": 5,
                "./external": 6,
                "./load": 11,
                "./object": 15,
                "./support": 30
            }
        ],
        11: [
            function(e, t, r) {
                "use strict";
                var u = e("./utils"), i = e("./external"), n = e("./utf8"), s = e("./zipEntries"), a = e("./stream/Crc32Probe"), l = e("./nodejsUtils");
                function f(n) {
                    return new i.Promise(function(e, t) {
                        var r = n.decompressed.getContentWorker().pipe(new a);
                        r.on("error", function(e) {
                            t(e);
                        }).on("end", function() {
                            r.streamInfo.crc32 !== n.decompressed.crc32 ? t(new Error("Corrupted zip : CRC32 mismatch")) : e();
                        }).resume();
                    });
                }
                t.exports = function(e, o) {
                    var h = this;
                    return o = u.extend(o || {}, {
                        base64: !1,
                        checkCRC32: !1,
                        optimizedBinaryString: !1,
                        createFolders: !1,
                        decodeFileName: n.utf8decode
                    }), l.isNode && l.isStream(e) ? i.Promise.reject(new Error("JSZip can't accept a stream when loading a zip file.")) : u.prepareContent("the loaded zip file", e, !0, o.optimizedBinaryString, o.base64).then(function(e) {
                        var t = new s(o);
                        return t.load(e), t;
                    }).then(function(e) {
                        var t = [
                            i.Promise.resolve(e)
                        ], r = e.files;
                        if (o.checkCRC32) for(var n = 0; n < r.length; n++)t.push(f(r[n]));
                        return i.Promise.all(t);
                    }).then(function(e) {
                        for(var t = e.shift(), r = t.files, n = 0; n < r.length; n++){
                            var i = r[n], s = i.fileNameStr, a = u.resolve(i.fileNameStr);
                            h.file(a, i.decompressed, {
                                binary: !0,
                                optimizedBinaryString: !0,
                                date: i.date,
                                dir: i.dir,
                                comment: i.fileCommentStr.length ? i.fileCommentStr : null,
                                unixPermissions: i.unixPermissions,
                                dosPermissions: i.dosPermissions,
                                createFolders: o.createFolders
                            }), i.dir || (h.file(a).unsafeOriginalName = s);
                        }
                        return t.zipComment.length && (h.comment = t.zipComment), h;
                    });
                };
            },
            {
                "./external": 6,
                "./nodejsUtils": 14,
                "./stream/Crc32Probe": 25,
                "./utf8": 31,
                "./utils": 32,
                "./zipEntries": 33
            }
        ],
        12: [
            function(e, t, r) {
                "use strict";
                var n = e("../utils"), i = e("../stream/GenericWorker");
                function s(e, t) {
                    i.call(this, "Nodejs stream input adapter for " + e), this._upstreamEnded = !1, this._bindStream(t);
                }
                n.inherits(s, i), s.prototype._bindStream = function(e) {
                    var t = this;
                    (this._stream = e).pause(), e.on("data", function(e) {
                        t.push({
                            data: e,
                            meta: {
                                percent: 0
                            }
                        });
                    }).on("error", function(e) {
                        t.isPaused ? this.generatedError = e : t.error(e);
                    }).on("end", function() {
                        t.isPaused ? t._upstreamEnded = !0 : t.end();
                    });
                }, s.prototype.pause = function() {
                    return !!i.prototype.pause.call(this) && (this._stream.pause(), !0);
                }, s.prototype.resume = function() {
                    return !!i.prototype.resume.call(this) && (this._upstreamEnded ? this.end() : this._stream.resume(), !0);
                }, t.exports = s;
            },
            {
                "../stream/GenericWorker": 28,
                "../utils": 32
            }
        ],
        13: [
            function(e, t, r) {
                "use strict";
                var i = e("readable-stream").Readable;
                function n(e, t, r) {
                    i.call(this, t), this._helper = e;
                    var n = this;
                    e.on("data", function(e, t) {
                        n.push(e) || n._helper.pause(), r && r(t);
                    }).on("error", function(e) {
                        n.emit("error", e);
                    }).on("end", function() {
                        n.push(null);
                    });
                }
                e("../utils").inherits(n, i), n.prototype._read = function() {
                    this._helper.resume();
                }, t.exports = n;
            },
            {
                "../utils": 32,
                "readable-stream": 16
            }
        ],
        14: [
            function(e, t, r) {
                "use strict";
                t.exports = {
                    isNode: "undefined" != typeof $921d13038eff58c9$require$Buffer,
                    newBufferFrom: function(e, t) {
                        if ($921d13038eff58c9$require$Buffer.from && $921d13038eff58c9$require$Buffer.from !== Uint8Array.from) return $921d13038eff58c9$require$Buffer.from(e, t);
                        if ("number" == typeof e) throw new Error('The "data" argument must not be a number');
                        return new $921d13038eff58c9$require$Buffer(e, t);
                    },
                    allocBuffer: function(e) {
                        if ($921d13038eff58c9$require$Buffer.alloc) return $921d13038eff58c9$require$Buffer.alloc(e);
                        var t = new $921d13038eff58c9$require$Buffer(e);
                        return t.fill(0), t;
                    },
                    isBuffer: function(e) {
                        return $921d13038eff58c9$require$Buffer.isBuffer(e);
                    },
                    isStream: function(e) {
                        return e && "function" == typeof e.on && "function" == typeof e.pause && "function" == typeof e.resume;
                    }
                };
            },
            {}
        ],
        15: [
            function(e, t, r) {
                "use strict";
                function s(e, t, r) {
                    var n, i = u.getTypeOf(t), s = u.extend(r || {}, f);
                    s.date = s.date || new Date, null !== s.compression && (s.compression = s.compression.toUpperCase()), "string" == typeof s.unixPermissions && (s.unixPermissions = parseInt(s.unixPermissions, 8)), s.unixPermissions && 16384 & s.unixPermissions && (s.dir = !0), s.dosPermissions && 16 & s.dosPermissions && (s.dir = !0), s.dir && (e = g(e)), s.createFolders && (n = _(e)) && b.call(this, n, !0);
                    var a = "string" === i && !1 === s.binary && !1 === s.base64;
                    r && void 0 !== r.binary || (s.binary = !a), (t instanceof c && 0 === t.uncompressedSize || s.dir || !t || 0 === t.length) && (s.base64 = !1, s.binary = !0, t = "", s.compression = "STORE", i = "string");
                    var o = null;
                    o = t instanceof c || t instanceof l ? t : p.isNode && p.isStream(t) ? new m(e, t) : u.prepareContent(e, t, s.binary, s.optimizedBinaryString, s.base64);
                    var h = new d(e, o, s);
                    this.files[e] = h;
                }
                var i = e("./utf8"), u = e("./utils"), l = e("./stream/GenericWorker"), a = e("./stream/StreamHelper"), f = e("./defaults"), c = e("./compressedObject"), d = e("./zipObject"), o = e("./generate"), p = e("./nodejsUtils"), m = e("./nodejs/NodejsStreamInputAdapter"), _ = function(e) {
                    "/" === e.slice(-1) && (e = e.substring(0, e.length - 1));
                    var t = e.lastIndexOf("/");
                    return 0 < t ? e.substring(0, t) : "";
                }, g = function(e) {
                    return "/" !== e.slice(-1) && (e += "/"), e;
                }, b = function(e, t) {
                    return t = void 0 !== t ? t : f.createFolders, e = g(e), this.files[e] || s.call(this, e, null, {
                        dir: !0,
                        createFolders: t
                    }), this.files[e];
                };
                function h(e) {
                    return "[object RegExp]" === Object.prototype.toString.call(e);
                }
                var n = {
                    load: function() {
                        throw new Error("This method has been removed in JSZip 3.0, please check the upgrade guide.");
                    },
                    forEach: function(e) {
                        var t, r, n;
                        for(t in this.files)n = this.files[t], (r = t.slice(this.root.length, t.length)) && t.slice(0, this.root.length) === this.root && e(r, n);
                    },
                    filter: function(r) {
                        var n = [];
                        return this.forEach(function(e, t) {
                            r(e, t) && n.push(t);
                        }), n;
                    },
                    file: function(e, t, r) {
                        if (1 !== arguments.length) return e = this.root + e, s.call(this, e, t, r), this;
                        if (h(e)) {
                            var n = e;
                            return this.filter(function(e, t) {
                                return !t.dir && n.test(e);
                            });
                        }
                        var i = this.files[this.root + e];
                        return i && !i.dir ? i : null;
                    },
                    folder: function(r) {
                        if (!r) return this;
                        if (h(r)) return this.filter(function(e, t) {
                            return t.dir && r.test(e);
                        });
                        var e = this.root + r, t = b.call(this, e), n = this.clone();
                        return n.root = t.name, n;
                    },
                    remove: function(r) {
                        r = this.root + r;
                        var e = this.files[r];
                        if (e || ("/" !== r.slice(-1) && (r += "/"), e = this.files[r]), e && !e.dir) delete this.files[r];
                        else for(var t = this.filter(function(e, t) {
                            return t.name.slice(0, r.length) === r;
                        }), n = 0; n < t.length; n++)delete this.files[t[n].name];
                        return this;
                    },
                    generate: function() {
                        throw new Error("This method has been removed in JSZip 3.0, please check the upgrade guide.");
                    },
                    generateInternalStream: function(e) {
                        var t, r = {};
                        try {
                            if ((r = u.extend(e || {}, {
                                streamFiles: !1,
                                compression: "STORE",
                                compressionOptions: null,
                                type: "",
                                platform: "DOS",
                                comment: null,
                                mimeType: "application/zip",
                                encodeFileName: i.utf8encode
                            })).type = r.type.toLowerCase(), r.compression = r.compression.toUpperCase(), "binarystring" === r.type && (r.type = "string"), !r.type) throw new Error("No output type specified.");
                            u.checkSupport(r.type), "darwin" !== r.platform && "freebsd" !== r.platform && "linux" !== r.platform && "sunos" !== r.platform || (r.platform = "UNIX"), "win32" === r.platform && (r.platform = "DOS");
                            var n = r.comment || this.comment || "";
                            t = o.generateWorker(this, r, n);
                        } catch (e) {
                            (t = new l("error")).error(e);
                        }
                        return new a(t, r.type || "string", r.mimeType);
                    },
                    generateAsync: function(e, t) {
                        return this.generateInternalStream(e).accumulate(t);
                    },
                    generateNodeStream: function(e, t) {
                        return (e = e || {}).type || (e.type = "nodebuffer"), this.generateInternalStream(e).toNodejsStream(t);
                    }
                };
                t.exports = n;
            },
            {
                "./compressedObject": 2,
                "./defaults": 5,
                "./generate": 9,
                "./nodejs/NodejsStreamInputAdapter": 12,
                "./nodejsUtils": 14,
                "./stream/GenericWorker": 28,
                "./stream/StreamHelper": 29,
                "./utf8": 31,
                "./utils": 32,
                "./zipObject": 35
            }
        ],
        16: [
            function(e, t, r) {
                "use strict";
                t.exports = e("stream");
            },
            {
                stream: void 0
            }
        ],
        17: [
            function(e, t, r) {
                "use strict";
                var n = e("./DataReader");
                function i(e) {
                    n.call(this, e);
                    for(var t = 0; t < this.data.length; t++)e[t] = 255 & e[t];
                }
                e("../utils").inherits(i, n), i.prototype.byteAt = function(e) {
                    return this.data[this.zero + e];
                }, i.prototype.lastIndexOfSignature = function(e) {
                    for(var t = e.charCodeAt(0), r = e.charCodeAt(1), n = e.charCodeAt(2), i = e.charCodeAt(3), s = this.length - 4; 0 <= s; --s)if (this.data[s] === t && this.data[s + 1] === r && this.data[s + 2] === n && this.data[s + 3] === i) return s - this.zero;
                    return -1;
                }, i.prototype.readAndCheckSignature = function(e) {
                    var t = e.charCodeAt(0), r = e.charCodeAt(1), n = e.charCodeAt(2), i = e.charCodeAt(3), s = this.readData(4);
                    return t === s[0] && r === s[1] && n === s[2] && i === s[3];
                }, i.prototype.readData = function(e) {
                    if (this.checkOffset(e), 0 === e) return [];
                    var t = this.data.slice(this.zero + this.index, this.zero + this.index + e);
                    return this.index += e, t;
                }, t.exports = i;
            },
            {
                "../utils": 32,
                "./DataReader": 18
            }
        ],
        18: [
            function(e, t, r) {
                "use strict";
                var n = e("../utils");
                function i(e) {
                    this.data = e, this.length = e.length, this.index = 0, this.zero = 0;
                }
                i.prototype = {
                    checkOffset: function(e) {
                        this.checkIndex(this.index + e);
                    },
                    checkIndex: function(e) {
                        if (this.length < this.zero + e || e < 0) throw new Error("End of data reached (data length = " + this.length + ", asked index = " + e + "). Corrupted zip ?");
                    },
                    setIndex: function(e) {
                        this.checkIndex(e), this.index = e;
                    },
                    skip: function(e) {
                        this.setIndex(this.index + e);
                    },
                    byteAt: function() {},
                    readInt: function(e) {
                        var t, r = 0;
                        for(this.checkOffset(e), t = this.index + e - 1; t >= this.index; t--)r = (r << 8) + this.byteAt(t);
                        return this.index += e, r;
                    },
                    readString: function(e) {
                        return n.transformTo("string", this.readData(e));
                    },
                    readData: function() {},
                    lastIndexOfSignature: function() {},
                    readAndCheckSignature: function() {},
                    readDate: function() {
                        var e = this.readInt(4);
                        return new Date(Date.UTC(1980 + (e >> 25 & 127), (e >> 21 & 15) - 1, e >> 16 & 31, e >> 11 & 31, e >> 5 & 63, (31 & e) << 1));
                    }
                }, t.exports = i;
            },
            {
                "../utils": 32
            }
        ],
        19: [
            function(e, t, r) {
                "use strict";
                var n = e("./Uint8ArrayReader");
                function i(e) {
                    n.call(this, e);
                }
                e("../utils").inherits(i, n), i.prototype.readData = function(e) {
                    this.checkOffset(e);
                    var t = this.data.slice(this.zero + this.index, this.zero + this.index + e);
                    return this.index += e, t;
                }, t.exports = i;
            },
            {
                "../utils": 32,
                "./Uint8ArrayReader": 21
            }
        ],
        20: [
            function(e, t, r) {
                "use strict";
                var n = e("./DataReader");
                function i(e) {
                    n.call(this, e);
                }
                e("../utils").inherits(i, n), i.prototype.byteAt = function(e) {
                    return this.data.charCodeAt(this.zero + e);
                }, i.prototype.lastIndexOfSignature = function(e) {
                    return this.data.lastIndexOf(e) - this.zero;
                }, i.prototype.readAndCheckSignature = function(e) {
                    return e === this.readData(4);
                }, i.prototype.readData = function(e) {
                    this.checkOffset(e);
                    var t = this.data.slice(this.zero + this.index, this.zero + this.index + e);
                    return this.index += e, t;
                }, t.exports = i;
            },
            {
                "../utils": 32,
                "./DataReader": 18
            }
        ],
        21: [
            function(e, t, r) {
                "use strict";
                var n = e("./ArrayReader");
                function i(e) {
                    n.call(this, e);
                }
                e("../utils").inherits(i, n), i.prototype.readData = function(e) {
                    if (this.checkOffset(e), 0 === e) return new Uint8Array(0);
                    var t = this.data.subarray(this.zero + this.index, this.zero + this.index + e);
                    return this.index += e, t;
                }, t.exports = i;
            },
            {
                "../utils": 32,
                "./ArrayReader": 17
            }
        ],
        22: [
            function(e, t, r) {
                "use strict";
                var n = e("../utils"), i = e("../support"), s = e("./ArrayReader"), a = e("./StringReader"), o = e("./NodeBufferReader"), h = e("./Uint8ArrayReader");
                t.exports = function(e) {
                    var t = n.getTypeOf(e);
                    return n.checkSupport(t), "string" !== t || i.uint8array ? "nodebuffer" === t ? new o(e) : i.uint8array ? new h(n.transformTo("uint8array", e)) : new s(n.transformTo("array", e)) : new a(e);
                };
            },
            {
                "../support": 30,
                "../utils": 32,
                "./ArrayReader": 17,
                "./NodeBufferReader": 19,
                "./StringReader": 20,
                "./Uint8ArrayReader": 21
            }
        ],
        23: [
            function(e, t, r) {
                "use strict";
                r.LOCAL_FILE_HEADER = "PK", r.CENTRAL_FILE_HEADER = "PK", r.CENTRAL_DIRECTORY_END = "PK", r.ZIP64_CENTRAL_DIRECTORY_LOCATOR = "PK", r.ZIP64_CENTRAL_DIRECTORY_END = "PK", r.DATA_DESCRIPTOR = "PK\b";
            },
            {}
        ],
        24: [
            function(e, t, r) {
                "use strict";
                var n = e("./GenericWorker"), i = e("../utils");
                function s(e) {
                    n.call(this, "ConvertWorker to " + e), this.destType = e;
                }
                i.inherits(s, n), s.prototype.processChunk = function(e) {
                    this.push({
                        data: i.transformTo(this.destType, e.data),
                        meta: e.meta
                    });
                }, t.exports = s;
            },
            {
                "../utils": 32,
                "./GenericWorker": 28
            }
        ],
        25: [
            function(e, t, r) {
                "use strict";
                var n = e("./GenericWorker"), i = e("../crc32");
                function s() {
                    n.call(this, "Crc32Probe"), this.withStreamInfo("crc32", 0);
                }
                e("../utils").inherits(s, n), s.prototype.processChunk = function(e) {
                    this.streamInfo.crc32 = i(e.data, this.streamInfo.crc32 || 0), this.push(e);
                }, t.exports = s;
            },
            {
                "../crc32": 4,
                "../utils": 32,
                "./GenericWorker": 28
            }
        ],
        26: [
            function(e, t, r) {
                "use strict";
                var n = e("../utils"), i = e("./GenericWorker");
                function s(e) {
                    i.call(this, "DataLengthProbe for " + e), this.propName = e, this.withStreamInfo(e, 0);
                }
                n.inherits(s, i), s.prototype.processChunk = function(e) {
                    if (e) {
                        var t = this.streamInfo[this.propName] || 0;
                        this.streamInfo[this.propName] = t + e.data.length;
                    }
                    i.prototype.processChunk.call(this, e);
                }, t.exports = s;
            },
            {
                "../utils": 32,
                "./GenericWorker": 28
            }
        ],
        27: [
            function(e, t, r) {
                "use strict";
                var n = e("../utils"), i = e("./GenericWorker");
                function s(e) {
                    i.call(this, "DataWorker");
                    var t = this;
                    this.dataIsReady = !1, this.index = 0, this.max = 0, this.data = null, this.type = "", this._tickScheduled = !1, e.then(function(e) {
                        t.dataIsReady = !0, t.data = e, t.max = e && e.length || 0, t.type = n.getTypeOf(e), t.isPaused || t._tickAndRepeat();
                    }, function(e) {
                        t.error(e);
                    });
                }
                n.inherits(s, i), s.prototype.cleanUp = function() {
                    i.prototype.cleanUp.call(this), this.data = null;
                }, s.prototype.resume = function() {
                    return !!i.prototype.resume.call(this) && (!this._tickScheduled && this.dataIsReady && (this._tickScheduled = !0, n.delay(this._tickAndRepeat, [], this)), !0);
                }, s.prototype._tickAndRepeat = function() {
                    this._tickScheduled = !1, this.isPaused || this.isFinished || (this._tick(), this.isFinished || (n.delay(this._tickAndRepeat, [], this), this._tickScheduled = !0));
                }, s.prototype._tick = function() {
                    if (this.isPaused || this.isFinished) return !1;
                    var e = null, t = Math.min(this.max, this.index + 16384);
                    if (this.index >= this.max) return this.end();
                    switch(this.type){
                        case "string":
                            e = this.data.substring(this.index, t);
                            break;
                        case "uint8array":
                            e = this.data.subarray(this.index, t);
                            break;
                        case "array":
                        case "nodebuffer":
                            e = this.data.slice(this.index, t);
                    }
                    return this.index = t, this.push({
                        data: e,
                        meta: {
                            percent: this.max ? this.index / this.max * 100 : 0
                        }
                    });
                }, t.exports = s;
            },
            {
                "../utils": 32,
                "./GenericWorker": 28
            }
        ],
        28: [
            function(e, t, r) {
                "use strict";
                function n(e) {
                    this.name = e || "default", this.streamInfo = {}, this.generatedError = null, this.extraStreamInfo = {}, this.isPaused = !0, this.isFinished = !1, this.isLocked = !1, this._listeners = {
                        data: [],
                        end: [],
                        error: []
                    }, this.previous = null;
                }
                n.prototype = {
                    push: function(e) {
                        this.emit("data", e);
                    },
                    end: function() {
                        if (this.isFinished) return !1;
                        this.flush();
                        try {
                            this.emit("end"), this.cleanUp(), this.isFinished = !0;
                        } catch (e) {
                            this.emit("error", e);
                        }
                        return !0;
                    },
                    error: function(e) {
                        return !this.isFinished && (this.isPaused ? this.generatedError = e : (this.isFinished = !0, this.emit("error", e), this.previous && this.previous.error(e), this.cleanUp()), !0);
                    },
                    on: function(e, t) {
                        return this._listeners[e].push(t), this;
                    },
                    cleanUp: function() {
                        this.streamInfo = this.generatedError = this.extraStreamInfo = null, this._listeners = [];
                    },
                    emit: function(e, t) {
                        if (this._listeners[e]) for(var r = 0; r < this._listeners[e].length; r++)this._listeners[e][r].call(this, t);
                    },
                    pipe: function(e) {
                        return e.registerPrevious(this);
                    },
                    registerPrevious: function(e) {
                        if (this.isLocked) throw new Error("The stream '" + this + "' has already been used.");
                        this.streamInfo = e.streamInfo, this.mergeStreamInfo(), this.previous = e;
                        var t = this;
                        return e.on("data", function(e) {
                            t.processChunk(e);
                        }), e.on("end", function() {
                            t.end();
                        }), e.on("error", function(e) {
                            t.error(e);
                        }), this;
                    },
                    pause: function() {
                        return !this.isPaused && !this.isFinished && (this.isPaused = !0, this.previous && this.previous.pause(), !0);
                    },
                    resume: function() {
                        if (!this.isPaused || this.isFinished) return !1;
                        var e = this.isPaused = !1;
                        return this.generatedError && (this.error(this.generatedError), e = !0), this.previous && this.previous.resume(), !e;
                    },
                    flush: function() {},
                    processChunk: function(e) {
                        this.push(e);
                    },
                    withStreamInfo: function(e, t) {
                        return this.extraStreamInfo[e] = t, this.mergeStreamInfo(), this;
                    },
                    mergeStreamInfo: function() {
                        for(var e in this.extraStreamInfo)Object.prototype.hasOwnProperty.call(this.extraStreamInfo, e) && (this.streamInfo[e] = this.extraStreamInfo[e]);
                    },
                    lock: function() {
                        if (this.isLocked) throw new Error("The stream '" + this + "' has already been used.");
                        this.isLocked = !0, this.previous && this.previous.lock();
                    },
                    toString: function() {
                        var e = "Worker " + this.name;
                        return this.previous ? this.previous + " -> " + e : e;
                    }
                }, t.exports = n;
            },
            {}
        ],
        29: [
            function(e, t, r) {
                "use strict";
                var h = e("../utils"), i = e("./ConvertWorker"), s = e("./GenericWorker"), u = e("../base64"), n = e("../support"), a = e("../external"), o = null;
                if (n.nodestream) try {
                    o = e("../nodejs/NodejsStreamOutputAdapter");
                } catch (e) {}
                function l(e, o) {
                    return new a.Promise(function(t, r) {
                        var n = [], i = e._internalType, s = e._outputType, a = e._mimeType;
                        e.on("data", function(e, t) {
                            n.push(e), o && o(t);
                        }).on("error", function(e) {
                            n = [], r(e);
                        }).on("end", function() {
                            try {
                                var e = function(e, t, r) {
                                    switch(e){
                                        case "blob":
                                            return h.newBlob(h.transformTo("arraybuffer", t), r);
                                        case "base64":
                                            return u.encode(t);
                                        default:
                                            return h.transformTo(e, t);
                                    }
                                }(s, function(e, t) {
                                    var r, n = 0, i = null, s = 0;
                                    for(r = 0; r < t.length; r++)s += t[r].length;
                                    switch(e){
                                        case "string":
                                            return t.join("");
                                        case "array":
                                            return Array.prototype.concat.apply([], t);
                                        case "uint8array":
                                            for(i = new Uint8Array(s), r = 0; r < t.length; r++)i.set(t[r], n), n += t[r].length;
                                            return i;
                                        case "nodebuffer":
                                            return $921d13038eff58c9$require$Buffer.concat(t);
                                        default:
                                            throw new Error("concat : unsupported type '" + e + "'");
                                    }
                                }(i, n), a);
                                t(e);
                            } catch (e) {
                                r(e);
                            }
                            n = [];
                        }).resume();
                    });
                }
                function f(e, t, r) {
                    var n = t;
                    switch(t){
                        case "blob":
                        case "arraybuffer":
                            n = "uint8array";
                            break;
                        case "base64":
                            n = "string";
                    }
                    try {
                        this._internalType = n, this._outputType = t, this._mimeType = r, h.checkSupport(n), this._worker = e.pipe(new i(n)), e.lock();
                    } catch (e) {
                        this._worker = new s("error"), this._worker.error(e);
                    }
                }
                f.prototype = {
                    accumulate: function(e) {
                        return l(this, e);
                    },
                    on: function(e, t) {
                        var r = this;
                        return "data" === e ? this._worker.on(e, function(e) {
                            t.call(r, e.data, e.meta);
                        }) : this._worker.on(e, function() {
                            h.delay(t, arguments, r);
                        }), this;
                    },
                    resume: function() {
                        return h.delay(this._worker.resume, [], this._worker), this;
                    },
                    pause: function() {
                        return this._worker.pause(), this;
                    },
                    toNodejsStream: function(e) {
                        if (h.checkSupport("nodestream"), "nodebuffer" !== this._outputType) throw new Error(this._outputType + " is not supported by this method");
                        return new o(this, {
                            objectMode: "nodebuffer" !== this._outputType
                        }, e);
                    }
                }, t.exports = f;
            },
            {
                "../base64": 1,
                "../external": 6,
                "../nodejs/NodejsStreamOutputAdapter": 13,
                "../support": 30,
                "../utils": 32,
                "./ConvertWorker": 24,
                "./GenericWorker": 28
            }
        ],
        30: [
            function(e, t, r) {
                "use strict";
                if (r.base64 = !0, r.array = !0, r.string = !0, r.arraybuffer = "undefined" != typeof ArrayBuffer && "undefined" != typeof Uint8Array, r.nodebuffer = "undefined" != typeof $921d13038eff58c9$require$Buffer, r.uint8array = "undefined" != typeof Uint8Array, "undefined" == typeof ArrayBuffer) r.blob = !1;
                else {
                    var n = new ArrayBuffer(0);
                    try {
                        r.blob = 0 === new Blob([
                            n
                        ], {
                            type: "application/zip"
                        }).size;
                    } catch (e) {
                        try {
                            var i = new (self.BlobBuilder || self.WebKitBlobBuilder || self.MozBlobBuilder || self.MSBlobBuilder);
                            i.append(n), r.blob = 0 === i.getBlob("application/zip").size;
                        } catch (e) {
                            r.blob = !1;
                        }
                    }
                }
                try {
                    r.nodestream = !!e("readable-stream").Readable;
                } catch (e) {
                    r.nodestream = !1;
                }
            },
            {
                "readable-stream": 16
            }
        ],
        31: [
            function(e, t, s) {
                "use strict";
                for(var o = e("./utils"), h = e("./support"), r = e("./nodejsUtils"), n = e("./stream/GenericWorker"), u = new Array(256), i = 0; i < 256; i++)u[i] = 252 <= i ? 6 : 248 <= i ? 5 : 240 <= i ? 4 : 224 <= i ? 3 : 192 <= i ? 2 : 1;
                u[254] = u[254] = 1;
                function a() {
                    n.call(this, "utf-8 decode"), this.leftOver = null;
                }
                function l() {
                    n.call(this, "utf-8 encode");
                }
                s.utf8encode = function(e) {
                    return h.nodebuffer ? r.newBufferFrom(e, "utf-8") : function(e) {
                        var t, r, n, i, s, a = e.length, o = 0;
                        for(i = 0; i < a; i++)55296 == (64512 & (r = e.charCodeAt(i))) && i + 1 < a && 56320 == (64512 & (n = e.charCodeAt(i + 1))) && (r = 65536 + (r - 55296 << 10) + (n - 56320), i++), o += r < 128 ? 1 : r < 2048 ? 2 : r < 65536 ? 3 : 4;
                        for(t = h.uint8array ? new Uint8Array(o) : new Array(o), i = s = 0; s < o; i++)55296 == (64512 & (r = e.charCodeAt(i))) && i + 1 < a && 56320 == (64512 & (n = e.charCodeAt(i + 1))) && (r = 65536 + (r - 55296 << 10) + (n - 56320), i++), r < 128 ? t[s++] = r : (r < 2048 ? t[s++] = 192 | r >>> 6 : (r < 65536 ? t[s++] = 224 | r >>> 12 : (t[s++] = 240 | r >>> 18, t[s++] = 128 | r >>> 12 & 63), t[s++] = 128 | r >>> 6 & 63), t[s++] = 128 | 63 & r);
                        return t;
                    }(e);
                }, s.utf8decode = function(e) {
                    return h.nodebuffer ? o.transformTo("nodebuffer", e).toString("utf-8") : function(e) {
                        var t, r, n, i, s = e.length, a = new Array(2 * s);
                        for(t = r = 0; t < s;)if ((n = e[t++]) < 128) a[r++] = n;
                        else if (4 < (i = u[n])) a[r++] = 65533, t += i - 1;
                        else {
                            for(n &= 2 === i ? 31 : 3 === i ? 15 : 7; 1 < i && t < s;)n = n << 6 | 63 & e[t++], i--;
                            1 < i ? a[r++] = 65533 : n < 65536 ? a[r++] = n : (n -= 65536, a[r++] = 55296 | n >> 10 & 1023, a[r++] = 56320 | 1023 & n);
                        }
                        return a.length !== r && (a.subarray ? a = a.subarray(0, r) : a.length = r), o.applyFromCharCode(a);
                    }(e = o.transformTo(h.uint8array ? "uint8array" : "array", e));
                }, o.inherits(a, n), a.prototype.processChunk = function(e) {
                    var t = o.transformTo(h.uint8array ? "uint8array" : "array", e.data);
                    if (this.leftOver && this.leftOver.length) {
                        if (h.uint8array) {
                            var r = t;
                            (t = new Uint8Array(r.length + this.leftOver.length)).set(this.leftOver, 0), t.set(r, this.leftOver.length);
                        } else t = this.leftOver.concat(t);
                        this.leftOver = null;
                    }
                    var n = function(e, t) {
                        var r;
                        for((t = t || e.length) > e.length && (t = e.length), r = t - 1; 0 <= r && 128 == (192 & e[r]);)r--;
                        return r < 0 ? t : 0 === r ? t : r + u[e[r]] > t ? r : t;
                    }(t), i = t;
                    n !== t.length && (h.uint8array ? (i = t.subarray(0, n), this.leftOver = t.subarray(n, t.length)) : (i = t.slice(0, n), this.leftOver = t.slice(n, t.length))), this.push({
                        data: s.utf8decode(i),
                        meta: e.meta
                    });
                }, a.prototype.flush = function() {
                    this.leftOver && this.leftOver.length && (this.push({
                        data: s.utf8decode(this.leftOver),
                        meta: {}
                    }), this.leftOver = null);
                }, s.Utf8DecodeWorker = a, o.inherits(l, n), l.prototype.processChunk = function(e) {
                    this.push({
                        data: s.utf8encode(e.data),
                        meta: e.meta
                    });
                }, s.Utf8EncodeWorker = l;
            },
            {
                "./nodejsUtils": 14,
                "./stream/GenericWorker": 28,
                "./support": 30,
                "./utils": 32
            }
        ],
        32: [
            function(e, t, a) {
                "use strict";
                var o = e("./support"), h = e("./base64"), r = e("./nodejsUtils"), u = e("./external");
                function n(e) {
                    return e;
                }
                function l(e, t) {
                    for(var r = 0; r < e.length; ++r)t[r] = 255 & e.charCodeAt(r);
                    return t;
                }
                e("setimmediate"), a.newBlob = function(t, r) {
                    a.checkSupport("blob");
                    try {
                        return new Blob([
                            t
                        ], {
                            type: r
                        });
                    } catch (e) {
                        try {
                            var n = new (self.BlobBuilder || self.WebKitBlobBuilder || self.MozBlobBuilder || self.MSBlobBuilder);
                            return n.append(t), n.getBlob(r);
                        } catch (e) {
                            throw new Error("Bug : can't construct the Blob.");
                        }
                    }
                };
                var i = {
                    stringifyByChunk: function(e, t, r) {
                        var n = [], i = 0, s = e.length;
                        if (s <= r) return String.fromCharCode.apply(null, e);
                        for(; i < s;)"array" === t || "nodebuffer" === t ? n.push(String.fromCharCode.apply(null, e.slice(i, Math.min(i + r, s)))) : n.push(String.fromCharCode.apply(null, e.subarray(i, Math.min(i + r, s)))), i += r;
                        return n.join("");
                    },
                    stringifyByChar: function(e) {
                        for(var t = "", r = 0; r < e.length; r++)t += String.fromCharCode(e[r]);
                        return t;
                    },
                    applyCanBeUsed: {
                        uint8array: function() {
                            try {
                                return o.uint8array && 1 === String.fromCharCode.apply(null, new Uint8Array(1)).length;
                            } catch (e) {
                                return !1;
                            }
                        }(),
                        nodebuffer: function() {
                            try {
                                return o.nodebuffer && 1 === String.fromCharCode.apply(null, r.allocBuffer(1)).length;
                            } catch (e) {
                                return !1;
                            }
                        }()
                    }
                };
                function s(e) {
                    var t = 65536, r = a.getTypeOf(e), n = !0;
                    if ("uint8array" === r ? n = i.applyCanBeUsed.uint8array : "nodebuffer" === r && (n = i.applyCanBeUsed.nodebuffer), n) for(; 1 < t;)try {
                        return i.stringifyByChunk(e, r, t);
                    } catch (e) {
                        t = Math.floor(t / 2);
                    }
                    return i.stringifyByChar(e);
                }
                function f(e, t) {
                    for(var r = 0; r < e.length; r++)t[r] = e[r];
                    return t;
                }
                a.applyFromCharCode = s;
                var c = {};
                c.string = {
                    string: n,
                    array: function(e) {
                        return l(e, new Array(e.length));
                    },
                    arraybuffer: function(e) {
                        return c.string.uint8array(e).buffer;
                    },
                    uint8array: function(e) {
                        return l(e, new Uint8Array(e.length));
                    },
                    nodebuffer: function(e) {
                        return l(e, r.allocBuffer(e.length));
                    }
                }, c.array = {
                    string: s,
                    array: n,
                    arraybuffer: function(e) {
                        return new Uint8Array(e).buffer;
                    },
                    uint8array: function(e) {
                        return new Uint8Array(e);
                    },
                    nodebuffer: function(e) {
                        return r.newBufferFrom(e);
                    }
                }, c.arraybuffer = {
                    string: function(e) {
                        return s(new Uint8Array(e));
                    },
                    array: function(e) {
                        return f(new Uint8Array(e), new Array(e.byteLength));
                    },
                    arraybuffer: n,
                    uint8array: function(e) {
                        return new Uint8Array(e);
                    },
                    nodebuffer: function(e) {
                        return r.newBufferFrom(new Uint8Array(e));
                    }
                }, c.uint8array = {
                    string: s,
                    array: function(e) {
                        return f(e, new Array(e.length));
                    },
                    arraybuffer: function(e) {
                        return e.buffer;
                    },
                    uint8array: n,
                    nodebuffer: function(e) {
                        return r.newBufferFrom(e);
                    }
                }, c.nodebuffer = {
                    string: s,
                    array: function(e) {
                        return f(e, new Array(e.length));
                    },
                    arraybuffer: function(e) {
                        return c.nodebuffer.uint8array(e).buffer;
                    },
                    uint8array: function(e) {
                        return f(e, new Uint8Array(e.length));
                    },
                    nodebuffer: n
                }, a.transformTo = function(e, t) {
                    if (t = t || "", !e) return t;
                    a.checkSupport(e);
                    var r = a.getTypeOf(t);
                    return c[r][e](t);
                }, a.resolve = function(e) {
                    for(var t = e.split("/"), r = [], n = 0; n < t.length; n++){
                        var i = t[n];
                        "." === i || "" === i && 0 !== n && n !== t.length - 1 || (".." === i ? r.pop() : r.push(i));
                    }
                    return r.join("/");
                }, a.getTypeOf = function(e) {
                    return "string" == typeof e ? "string" : "[object Array]" === Object.prototype.toString.call(e) ? "array" : o.nodebuffer && r.isBuffer(e) ? "nodebuffer" : o.uint8array && e instanceof Uint8Array ? "uint8array" : o.arraybuffer && e instanceof ArrayBuffer ? "arraybuffer" : void 0;
                }, a.checkSupport = function(e) {
                    if (!o[e.toLowerCase()]) throw new Error(e + " is not supported by this platform");
                }, a.MAX_VALUE_16BITS = 65535, a.MAX_VALUE_32BITS = -1, a.pretty = function(e) {
                    var t, r, n = "";
                    for(r = 0; r < (e || "").length; r++)n += "\\x" + ((t = e.charCodeAt(r)) < 16 ? "0" : "") + t.toString(16).toUpperCase();
                    return n;
                }, a.delay = function(e, t, r) {
                    setImmediate(function() {
                        e.apply(r || null, t || []);
                    });
                }, a.inherits = function(e, t) {
                    function r() {}
                    r.prototype = t.prototype, e.prototype = new r;
                }, a.extend = function() {
                    var e, t, r = {};
                    for(e = 0; e < arguments.length; e++)for(t in arguments[e])Object.prototype.hasOwnProperty.call(arguments[e], t) && void 0 === r[t] && (r[t] = arguments[e][t]);
                    return r;
                }, a.prepareContent = function(r, e, n, i, s) {
                    return u.Promise.resolve(e).then(function(n) {
                        return o.blob && (n instanceof Blob || -1 !== [
                            "[object File]",
                            "[object Blob]"
                        ].indexOf(Object.prototype.toString.call(n))) && "undefined" != typeof FileReader ? new u.Promise(function(t, r) {
                            var e = new FileReader;
                            e.onload = function(e) {
                                t(e.target.result);
                            }, e.onerror = function(e) {
                                r(e.target.error);
                            }, e.readAsArrayBuffer(n);
                        }) : n;
                    }).then(function(e) {
                        var t = a.getTypeOf(e);
                        return t ? ("arraybuffer" === t ? e = a.transformTo("uint8array", e) : "string" === t && (s ? e = h.decode(e) : n && !0 !== i && (e = function(e) {
                            return l(e, o.uint8array ? new Uint8Array(e.length) : new Array(e.length));
                        }(e))), e) : u.Promise.reject(new Error("Can't read the data of '" + r + "'. Is it in a supported JavaScript type (String, Blob, ArrayBuffer, etc) ?"));
                    });
                };
            },
            {
                "./base64": 1,
                "./external": 6,
                "./nodejsUtils": 14,
                "./support": 30,
                setimmediate: 54
            }
        ],
        33: [
            function(e, t, r) {
                "use strict";
                var n = e("./reader/readerFor"), i = e("./utils"), s = e("./signature"), a = e("./zipEntry"), o = e("./support");
                function h(e) {
                    this.files = [], this.loadOptions = e;
                }
                h.prototype = {
                    checkSignature: function(e) {
                        if (!this.reader.readAndCheckSignature(e)) {
                            this.reader.index -= 4;
                            var t = this.reader.readString(4);
                            throw new Error("Corrupted zip or bug: unexpected signature (" + i.pretty(t) + ", expected " + i.pretty(e) + ")");
                        }
                    },
                    isSignature: function(e, t) {
                        var r = this.reader.index;
                        this.reader.setIndex(e);
                        var n = this.reader.readString(4) === t;
                        return this.reader.setIndex(r), n;
                    },
                    readBlockEndOfCentral: function() {
                        this.diskNumber = this.reader.readInt(2), this.diskWithCentralDirStart = this.reader.readInt(2), this.centralDirRecordsOnThisDisk = this.reader.readInt(2), this.centralDirRecords = this.reader.readInt(2), this.centralDirSize = this.reader.readInt(4), this.centralDirOffset = this.reader.readInt(4), this.zipCommentLength = this.reader.readInt(2);
                        var e = this.reader.readData(this.zipCommentLength), t = o.uint8array ? "uint8array" : "array", r = i.transformTo(t, e);
                        this.zipComment = this.loadOptions.decodeFileName(r);
                    },
                    readBlockZip64EndOfCentral: function() {
                        this.zip64EndOfCentralSize = this.reader.readInt(8), this.reader.skip(4), this.diskNumber = this.reader.readInt(4), this.diskWithCentralDirStart = this.reader.readInt(4), this.centralDirRecordsOnThisDisk = this.reader.readInt(8), this.centralDirRecords = this.reader.readInt(8), this.centralDirSize = this.reader.readInt(8), this.centralDirOffset = this.reader.readInt(8), this.zip64ExtensibleData = {};
                        for(var e, t, r, n = this.zip64EndOfCentralSize - 44; 0 < n;)e = this.reader.readInt(2), t = this.reader.readInt(4), r = this.reader.readData(t), this.zip64ExtensibleData[e] = {
                            id: e,
                            length: t,
                            value: r
                        };
                    },
                    readBlockZip64EndOfCentralLocator: function() {
                        if (this.diskWithZip64CentralDirStart = this.reader.readInt(4), this.relativeOffsetEndOfZip64CentralDir = this.reader.readInt(8), this.disksCount = this.reader.readInt(4), 1 < this.disksCount) throw new Error("Multi-volumes zip are not supported");
                    },
                    readLocalFiles: function() {
                        var e, t;
                        for(e = 0; e < this.files.length; e++)t = this.files[e], this.reader.setIndex(t.localHeaderOffset), this.checkSignature(s.LOCAL_FILE_HEADER), t.readLocalPart(this.reader), t.handleUTF8(), t.processAttributes();
                    },
                    readCentralDir: function() {
                        var e;
                        for(this.reader.setIndex(this.centralDirOffset); this.reader.readAndCheckSignature(s.CENTRAL_FILE_HEADER);)(e = new a({
                            zip64: this.zip64
                        }, this.loadOptions)).readCentralPart(this.reader), this.files.push(e);
                        if (this.centralDirRecords !== this.files.length && 0 !== this.centralDirRecords && 0 === this.files.length) throw new Error("Corrupted zip or bug: expected " + this.centralDirRecords + " records in central dir, got " + this.files.length);
                    },
                    readEndOfCentral: function() {
                        var e = this.reader.lastIndexOfSignature(s.CENTRAL_DIRECTORY_END);
                        if (e < 0) throw !this.isSignature(0, s.LOCAL_FILE_HEADER) ? new Error("Can't find end of central directory : is this a zip file ? If it is, see https://stuk.github.io/jszip/documentation/howto/read_zip.html") : new Error("Corrupted zip: can't find end of central directory");
                        this.reader.setIndex(e);
                        var t = e;
                        if (this.checkSignature(s.CENTRAL_DIRECTORY_END), this.readBlockEndOfCentral(), this.diskNumber === i.MAX_VALUE_16BITS || this.diskWithCentralDirStart === i.MAX_VALUE_16BITS || this.centralDirRecordsOnThisDisk === i.MAX_VALUE_16BITS || this.centralDirRecords === i.MAX_VALUE_16BITS || this.centralDirSize === i.MAX_VALUE_32BITS || this.centralDirOffset === i.MAX_VALUE_32BITS) {
                            if (this.zip64 = !0, (e = this.reader.lastIndexOfSignature(s.ZIP64_CENTRAL_DIRECTORY_LOCATOR)) < 0) throw new Error("Corrupted zip: can't find the ZIP64 end of central directory locator");
                            if (this.reader.setIndex(e), this.checkSignature(s.ZIP64_CENTRAL_DIRECTORY_LOCATOR), this.readBlockZip64EndOfCentralLocator(), !this.isSignature(this.relativeOffsetEndOfZip64CentralDir, s.ZIP64_CENTRAL_DIRECTORY_END) && (this.relativeOffsetEndOfZip64CentralDir = this.reader.lastIndexOfSignature(s.ZIP64_CENTRAL_DIRECTORY_END), this.relativeOffsetEndOfZip64CentralDir < 0)) throw new Error("Corrupted zip: can't find the ZIP64 end of central directory");
                            this.reader.setIndex(this.relativeOffsetEndOfZip64CentralDir), this.checkSignature(s.ZIP64_CENTRAL_DIRECTORY_END), this.readBlockZip64EndOfCentral();
                        }
                        var r = this.centralDirOffset + this.centralDirSize;
                        this.zip64 && (r += 20, r += 12 + this.zip64EndOfCentralSize);
                        var n = t - r;
                        if (0 < n) this.isSignature(t, s.CENTRAL_FILE_HEADER) || (this.reader.zero = n);
                        else if (n < 0) throw new Error("Corrupted zip: missing " + Math.abs(n) + " bytes.");
                    },
                    prepareReader: function(e) {
                        this.reader = n(e);
                    },
                    load: function(e) {
                        this.prepareReader(e), this.readEndOfCentral(), this.readCentralDir(), this.readLocalFiles();
                    }
                }, t.exports = h;
            },
            {
                "./reader/readerFor": 22,
                "./signature": 23,
                "./support": 30,
                "./utils": 32,
                "./zipEntry": 34
            }
        ],
        34: [
            function(e, t, r) {
                "use strict";
                var n = e("./reader/readerFor"), s = e("./utils"), i = e("./compressedObject"), a = e("./crc32"), o = e("./utf8"), h = e("./compressions"), u = e("./support");
                function l(e, t) {
                    this.options = e, this.loadOptions = t;
                }
                l.prototype = {
                    isEncrypted: function() {
                        return 1 == (1 & this.bitFlag);
                    },
                    useUTF8: function() {
                        return 2048 == (2048 & this.bitFlag);
                    },
                    readLocalPart: function(e) {
                        var t, r;
                        if (e.skip(22), this.fileNameLength = e.readInt(2), r = e.readInt(2), this.fileName = e.readData(this.fileNameLength), e.skip(r), -1 === this.compressedSize || -1 === this.uncompressedSize) throw new Error("Bug or corrupted zip : didn't get enough information from the central directory (compressedSize === -1 || uncompressedSize === -1)");
                        if (null === (t = function(e) {
                            for(var t in h)if (Object.prototype.hasOwnProperty.call(h, t) && h[t].magic === e) return h[t];
                            return null;
                        }(this.compressionMethod))) throw new Error("Corrupted zip : compression " + s.pretty(this.compressionMethod) + " unknown (inner file : " + s.transformTo("string", this.fileName) + ")");
                        this.decompressed = new i(this.compressedSize, this.uncompressedSize, this.crc32, t, e.readData(this.compressedSize));
                    },
                    readCentralPart: function(e) {
                        this.versionMadeBy = e.readInt(2), e.skip(2), this.bitFlag = e.readInt(2), this.compressionMethod = e.readString(2), this.date = e.readDate(), this.crc32 = e.readInt(4), this.compressedSize = e.readInt(4), this.uncompressedSize = e.readInt(4);
                        var t = e.readInt(2);
                        if (this.extraFieldsLength = e.readInt(2), this.fileCommentLength = e.readInt(2), this.diskNumberStart = e.readInt(2), this.internalFileAttributes = e.readInt(2), this.externalFileAttributes = e.readInt(4), this.localHeaderOffset = e.readInt(4), this.isEncrypted()) throw new Error("Encrypted zip are not supported");
                        e.skip(t), this.readExtraFields(e), this.parseZIP64ExtraField(e), this.fileComment = e.readData(this.fileCommentLength);
                    },
                    processAttributes: function() {
                        this.unixPermissions = null, this.dosPermissions = null;
                        var e = this.versionMadeBy >> 8;
                        this.dir = !!(16 & this.externalFileAttributes), 0 == e && (this.dosPermissions = 63 & this.externalFileAttributes), 3 == e && (this.unixPermissions = this.externalFileAttributes >> 16 & 65535), this.dir || "/" !== this.fileNameStr.slice(-1) || (this.dir = !0);
                    },
                    parseZIP64ExtraField: function() {
                        if (this.extraFields[1]) {
                            var e = n(this.extraFields[1].value);
                            this.uncompressedSize === s.MAX_VALUE_32BITS && (this.uncompressedSize = e.readInt(8)), this.compressedSize === s.MAX_VALUE_32BITS && (this.compressedSize = e.readInt(8)), this.localHeaderOffset === s.MAX_VALUE_32BITS && (this.localHeaderOffset = e.readInt(8)), this.diskNumberStart === s.MAX_VALUE_32BITS && (this.diskNumberStart = e.readInt(4));
                        }
                    },
                    readExtraFields: function(e) {
                        var t, r, n, i = e.index + this.extraFieldsLength;
                        for(this.extraFields || (this.extraFields = {}); e.index + 4 < i;)t = e.readInt(2), r = e.readInt(2), n = e.readData(r), this.extraFields[t] = {
                            id: t,
                            length: r,
                            value: n
                        };
                        e.setIndex(i);
                    },
                    handleUTF8: function() {
                        var e = u.uint8array ? "uint8array" : "array";
                        if (this.useUTF8()) this.fileNameStr = o.utf8decode(this.fileName), this.fileCommentStr = o.utf8decode(this.fileComment);
                        else {
                            var t = this.findExtraFieldUnicodePath();
                            if (null !== t) this.fileNameStr = t;
                            else {
                                var r = s.transformTo(e, this.fileName);
                                this.fileNameStr = this.loadOptions.decodeFileName(r);
                            }
                            var n = this.findExtraFieldUnicodeComment();
                            if (null !== n) this.fileCommentStr = n;
                            else {
                                var i = s.transformTo(e, this.fileComment);
                                this.fileCommentStr = this.loadOptions.decodeFileName(i);
                            }
                        }
                    },
                    findExtraFieldUnicodePath: function() {
                        var e = this.extraFields[28789];
                        if (e) {
                            var t = n(e.value);
                            return 1 !== t.readInt(1) ? null : a(this.fileName) !== t.readInt(4) ? null : o.utf8decode(t.readData(e.length - 5));
                        }
                        return null;
                    },
                    findExtraFieldUnicodeComment: function() {
                        var e = this.extraFields[25461];
                        if (e) {
                            var t = n(e.value);
                            return 1 !== t.readInt(1) ? null : a(this.fileComment) !== t.readInt(4) ? null : o.utf8decode(t.readData(e.length - 5));
                        }
                        return null;
                    }
                }, t.exports = l;
            },
            {
                "./compressedObject": 2,
                "./compressions": 3,
                "./crc32": 4,
                "./reader/readerFor": 22,
                "./support": 30,
                "./utf8": 31,
                "./utils": 32
            }
        ],
        35: [
            function(e, t, r) {
                "use strict";
                function n(e, t, r) {
                    this.name = e, this.dir = r.dir, this.date = r.date, this.comment = r.comment, this.unixPermissions = r.unixPermissions, this.dosPermissions = r.dosPermissions, this._data = t, this._dataBinary = r.binary, this.options = {
                        compression: r.compression,
                        compressionOptions: r.compressionOptions
                    };
                }
                var s = e("./stream/StreamHelper"), i = e("./stream/DataWorker"), a = e("./utf8"), o = e("./compressedObject"), h = e("./stream/GenericWorker");
                n.prototype = {
                    internalStream: function(e) {
                        var t = null, r = "string";
                        try {
                            if (!e) throw new Error("No output type specified.");
                            var n = "string" === (r = e.toLowerCase()) || "text" === r;
                            "binarystring" !== r && "text" !== r || (r = "string"), t = this._decompressWorker();
                            var i = !this._dataBinary;
                            i && !n && (t = t.pipe(new a.Utf8EncodeWorker)), !i && n && (t = t.pipe(new a.Utf8DecodeWorker));
                        } catch (e) {
                            (t = new h("error")).error(e);
                        }
                        return new s(t, r, "");
                    },
                    async: function(e, t) {
                        return this.internalStream(e).accumulate(t);
                    },
                    nodeStream: function(e, t) {
                        return this.internalStream(e || "nodebuffer").toNodejsStream(t);
                    },
                    _compressWorker: function(e, t) {
                        if (this._data instanceof o && this._data.compression.magic === e.magic) return this._data.getCompressedWorker();
                        var r = this._decompressWorker();
                        return this._dataBinary || (r = r.pipe(new a.Utf8EncodeWorker)), o.createWorkerFrom(r, e, t);
                    },
                    _decompressWorker: function() {
                        return this._data instanceof o ? this._data.getContentWorker() : this._data instanceof h ? this._data : new i(this._data);
                    }
                };
                for(var u = [
                    "asText",
                    "asBinary",
                    "asNodeBuffer",
                    "asUint8Array",
                    "asArrayBuffer"
                ], l = function() {
                    throw new Error("This method has been removed in JSZip 3.0, please check the upgrade guide.");
                }, f = 0; f < u.length; f++)n.prototype[u[f]] = l;
                t.exports = n;
            },
            {
                "./compressedObject": 2,
                "./stream/DataWorker": 27,
                "./stream/GenericWorker": 28,
                "./stream/StreamHelper": 29,
                "./utf8": 31
            }
        ],
        36: [
            function(e, l, t) {
                (function(t) {
                    "use strict";
                    var r, n, e = t.MutationObserver || t.WebKitMutationObserver;
                    if (e) {
                        var i = 0, s = new e(u), a = t.document.createTextNode("");
                        s.observe(a, {
                            characterData: !0
                        }), r = function() {
                            a.data = i = ++i % 2;
                        };
                    } else if (t.setImmediate || void 0 === t.MessageChannel) r = "document" in t && "onreadystatechange" in t.document.createElement("script") ? function() {
                        var e = t.document.createElement("script");
                        e.onreadystatechange = function() {
                            u(), e.onreadystatechange = null, e.parentNode.removeChild(e), e = null;
                        }, t.document.documentElement.appendChild(e);
                    } : function() {
                        setTimeout(u, 0);
                    };
                    else {
                        var o = new t.MessageChannel;
                        o.port1.onmessage = u, r = function() {
                            o.port2.postMessage(0);
                        };
                    }
                    var h = [];
                    function u() {
                        var e, t;
                        n = !0;
                        for(var r = h.length; r;){
                            for(t = h, h = [], e = -1; ++e < r;)t[e]();
                            r = h.length;
                        }
                        n = !1;
                    }
                    l.exports = function(e) {
                        1 !== h.push(e) || n || r();
                    };
                }).call(this, "undefined" != typeof $parcel$global ? $parcel$global : "undefined" != typeof self ? self : "undefined" != typeof window ? window : {});
            },
            {}
        ],
        37: [
            function(e, t, r) {
                "use strict";
                var i = e("immediate");
                function u() {}
                var l = {}, s = [
                    "REJECTED"
                ], a = [
                    "FULFILLED"
                ], n = [
                    "PENDING"
                ];
                function o(e) {
                    if ("function" != typeof e) throw new TypeError("resolver must be a function");
                    this.state = n, this.queue = [], this.outcome = void 0, e !== u && d(this, e);
                }
                function h(e, t, r) {
                    this.promise = e, "function" == typeof t && (this.onFulfilled = t, this.callFulfilled = this.otherCallFulfilled), "function" == typeof r && (this.onRejected = r, this.callRejected = this.otherCallRejected);
                }
                function f(t, r, n) {
                    i(function() {
                        var e;
                        try {
                            e = r(n);
                        } catch (e) {
                            return l.reject(t, e);
                        }
                        e === t ? l.reject(t, new TypeError("Cannot resolve promise with itself")) : l.resolve(t, e);
                    });
                }
                function c(e) {
                    var t = e && e.then;
                    if (e && ("object" == typeof e || "function" == typeof e) && "function" == typeof t) return function() {
                        t.apply(e, arguments);
                    };
                }
                function d(t, e) {
                    var r = !1;
                    function n(e) {
                        r || (r = !0, l.reject(t, e));
                    }
                    function i(e) {
                        r || (r = !0, l.resolve(t, e));
                    }
                    var s = p(function() {
                        e(i, n);
                    });
                    "error" === s.status && n(s.value);
                }
                function p(e, t) {
                    var r = {};
                    try {
                        r.value = e(t), r.status = "success";
                    } catch (e) {
                        r.status = "error", r.value = e;
                    }
                    return r;
                }
                (t.exports = o).prototype.finally = function(t) {
                    if ("function" != typeof t) return this;
                    var r = this.constructor;
                    return this.then(function(e) {
                        return r.resolve(t()).then(function() {
                            return e;
                        });
                    }, function(e) {
                        return r.resolve(t()).then(function() {
                            throw e;
                        });
                    });
                }, o.prototype.catch = function(e) {
                    return this.then(null, e);
                }, o.prototype.then = function(e, t) {
                    if ("function" != typeof e && this.state === a || "function" != typeof t && this.state === s) return this;
                    var r = new this.constructor(u);
                    this.state !== n ? f(r, this.state === a ? e : t, this.outcome) : this.queue.push(new h(r, e, t));
                    return r;
                }, h.prototype.callFulfilled = function(e) {
                    l.resolve(this.promise, e);
                }, h.prototype.otherCallFulfilled = function(e) {
                    f(this.promise, this.onFulfilled, e);
                }, h.prototype.callRejected = function(e) {
                    l.reject(this.promise, e);
                }, h.prototype.otherCallRejected = function(e) {
                    f(this.promise, this.onRejected, e);
                }, l.resolve = function(e, t) {
                    var r = p(c, t);
                    if ("error" === r.status) return l.reject(e, r.value);
                    var n = r.value;
                    if (n) d(e, n);
                    else {
                        e.state = a, e.outcome = t;
                        for(var i = -1, s = e.queue.length; ++i < s;)e.queue[i].callFulfilled(t);
                    }
                    return e;
                }, l.reject = function(e, t) {
                    e.state = s, e.outcome = t;
                    for(var r = -1, n = e.queue.length; ++r < n;)e.queue[r].callRejected(t);
                    return e;
                }, o.resolve = function(e) {
                    if (e instanceof this) return e;
                    return l.resolve(new this(u), e);
                }, o.reject = function(e) {
                    var t = new this(u);
                    return l.reject(t, e);
                }, o.all = function(e) {
                    var r = this;
                    if ("[object Array]" !== Object.prototype.toString.call(e)) return this.reject(new TypeError("must be an array"));
                    var n = e.length, i = !1;
                    if (!n) return this.resolve([]);
                    var s = new Array(n), a = 0, t = -1, o = new this(u);
                    for(; ++t < n;)h(e[t], t);
                    return o;
                    function h(e, t) {
                        r.resolve(e).then(function(e) {
                            s[t] = e, ++a !== n || i || (i = !0, l.resolve(o, s));
                        }, function(e) {
                            i || (i = !0, l.reject(o, e));
                        });
                    }
                }, o.race = function(e) {
                    var t = this;
                    if ("[object Array]" !== Object.prototype.toString.call(e)) return this.reject(new TypeError("must be an array"));
                    var r = e.length, n = !1;
                    if (!r) return this.resolve([]);
                    var i = -1, s = new this(u);
                    for(; ++i < r;)a = e[i], t.resolve(a).then(function(e) {
                        n || (n = !0, l.resolve(s, e));
                    }, function(e) {
                        n || (n = !0, l.reject(s, e));
                    });
                    var a;
                    return s;
                };
            },
            {
                immediate: 36
            }
        ],
        38: [
            function(e, t, r) {
                "use strict";
                var n = {};
                (0, e("./lib/utils/common").assign)(n, e("./lib/deflate"), e("./lib/inflate"), e("./lib/zlib/constants")), t.exports = n;
            },
            {
                "./lib/deflate": 39,
                "./lib/inflate": 40,
                "./lib/utils/common": 41,
                "./lib/zlib/constants": 44
            }
        ],
        39: [
            function(e, t, r) {
                "use strict";
                var a = e("./zlib/deflate"), o = e("./utils/common"), h = e("./utils/strings"), i = e("./zlib/messages"), s = e("./zlib/zstream"), u = Object.prototype.toString, l = 0, f = -1, c = 0, d = 8;
                function p(e) {
                    if (!(this instanceof p)) return new p(e);
                    this.options = o.assign({
                        level: f,
                        method: d,
                        chunkSize: 16384,
                        windowBits: 15,
                        memLevel: 8,
                        strategy: c,
                        to: ""
                    }, e || {});
                    var t = this.options;
                    t.raw && 0 < t.windowBits ? t.windowBits = -t.windowBits : t.gzip && 0 < t.windowBits && t.windowBits < 16 && (t.windowBits += 16), this.err = 0, this.msg = "", this.ended = !1, this.chunks = [], this.strm = new s, this.strm.avail_out = 0;
                    var r = a.deflateInit2(this.strm, t.level, t.method, t.windowBits, t.memLevel, t.strategy);
                    if (r !== l) throw new Error(i[r]);
                    if (t.header && a.deflateSetHeader(this.strm, t.header), t.dictionary) {
                        var n;
                        if (n = "string" == typeof t.dictionary ? h.string2buf(t.dictionary) : "[object ArrayBuffer]" === u.call(t.dictionary) ? new Uint8Array(t.dictionary) : t.dictionary, (r = a.deflateSetDictionary(this.strm, n)) !== l) throw new Error(i[r]);
                        this._dict_set = !0;
                    }
                }
                function n(e, t) {
                    var r = new p(t);
                    if (r.push(e, !0), r.err) throw r.msg || i[r.err];
                    return r.result;
                }
                p.prototype.push = function(e, t) {
                    var r, n, i = this.strm, s = this.options.chunkSize;
                    if (this.ended) return !1;
                    n = t === ~~t ? t : !0 === t ? 4 : 0, "string" == typeof e ? i.input = h.string2buf(e) : "[object ArrayBuffer]" === u.call(e) ? i.input = new Uint8Array(e) : i.input = e, i.next_in = 0, i.avail_in = i.input.length;
                    do {
                        if (0 === i.avail_out && (i.output = new o.Buf8(s), i.next_out = 0, i.avail_out = s), 1 !== (r = a.deflate(i, n)) && r !== l) return this.onEnd(r), this.ended = !0, false;
                        0 !== i.avail_out && (0 !== i.avail_in || 4 !== n && 2 !== n) || ("string" === this.options.to ? this.onData(h.buf2binstring(o.shrinkBuf(i.output, i.next_out))) : this.onData(o.shrinkBuf(i.output, i.next_out)));
                    }while ((0 < i.avail_in || 0 === i.avail_out) && 1 !== r);
                    return 4 === n ? (r = a.deflateEnd(this.strm), this.onEnd(r), this.ended = !0, r === l) : 2 !== n || (this.onEnd(l), i.avail_out = 0, true);
                }, p.prototype.onData = function(e) {
                    this.chunks.push(e);
                }, p.prototype.onEnd = function(e) {
                    e === l && ("string" === this.options.to ? this.result = this.chunks.join("") : this.result = o.flattenChunks(this.chunks)), this.chunks = [], this.err = e, this.msg = this.strm.msg;
                }, r.Deflate = p, r.deflate = n, r.deflateRaw = function(e, t) {
                    return (t = t || {}).raw = !0, n(e, t);
                }, r.gzip = function(e, t) {
                    return (t = t || {}).gzip = !0, n(e, t);
                };
            },
            {
                "./utils/common": 41,
                "./utils/strings": 42,
                "./zlib/deflate": 46,
                "./zlib/messages": 51,
                "./zlib/zstream": 53
            }
        ],
        40: [
            function(e, t, r) {
                "use strict";
                var c = e("./zlib/inflate"), d = e("./utils/common"), p = e("./utils/strings"), m = e("./zlib/constants"), n = e("./zlib/messages"), i = e("./zlib/zstream"), s = e("./zlib/gzheader"), _ = Object.prototype.toString;
                function a(e) {
                    if (!(this instanceof a)) return new a(e);
                    this.options = d.assign({
                        chunkSize: 16384,
                        windowBits: 0,
                        to: ""
                    }, e || {});
                    var t = this.options;
                    t.raw && 0 <= t.windowBits && t.windowBits < 16 && (t.windowBits = -t.windowBits, 0 === t.windowBits && (t.windowBits = -15)), !(0 <= t.windowBits && t.windowBits < 16) || e && e.windowBits || (t.windowBits += 32), 15 < t.windowBits && t.windowBits < 48 && 0 == (15 & t.windowBits) && (t.windowBits |= 15), this.err = 0, this.msg = "", this.ended = !1, this.chunks = [], this.strm = new i, this.strm.avail_out = 0;
                    var r = c.inflateInit2(this.strm, t.windowBits);
                    if (r !== m.Z_OK) throw new Error(n[r]);
                    this.header = new s, c.inflateGetHeader(this.strm, this.header);
                }
                function o(e, t) {
                    var r = new a(t);
                    if (r.push(e, !0), r.err) throw r.msg || n[r.err];
                    return r.result;
                }
                a.prototype.push = function(e, t) {
                    var r, n, i, s, a, o, h = this.strm, u = this.options.chunkSize, l = this.options.dictionary, f = !1;
                    if (this.ended) return !1;
                    n = t === ~~t ? t : !0 === t ? m.Z_FINISH : m.Z_NO_FLUSH, "string" == typeof e ? h.input = p.binstring2buf(e) : "[object ArrayBuffer]" === _.call(e) ? h.input = new Uint8Array(e) : h.input = e, h.next_in = 0, h.avail_in = h.input.length;
                    do {
                        if (0 === h.avail_out && (h.output = new d.Buf8(u), h.next_out = 0, h.avail_out = u), (r = c.inflate(h, m.Z_NO_FLUSH)) === m.Z_NEED_DICT && l && (o = "string" == typeof l ? p.string2buf(l) : "[object ArrayBuffer]" === _.call(l) ? new Uint8Array(l) : l, r = c.inflateSetDictionary(this.strm, o)), r === m.Z_BUF_ERROR && !0 === f && (r = m.Z_OK, f = !1), r !== m.Z_STREAM_END && r !== m.Z_OK) return this.onEnd(r), this.ended = !0, false;
                        h.next_out && (0 !== h.avail_out && r !== m.Z_STREAM_END && (0 !== h.avail_in || n !== m.Z_FINISH && n !== m.Z_SYNC_FLUSH) || ("string" === this.options.to ? (i = p.utf8border(h.output, h.next_out), s = h.next_out - i, a = p.buf2string(h.output, i), h.next_out = s, h.avail_out = u - s, s && d.arraySet(h.output, h.output, i, s, 0), this.onData(a)) : this.onData(d.shrinkBuf(h.output, h.next_out)))), 0 === h.avail_in && 0 === h.avail_out && (f = !0);
                    }while ((0 < h.avail_in || 0 === h.avail_out) && r !== m.Z_STREAM_END);
                    return r === m.Z_STREAM_END && (n = m.Z_FINISH), n === m.Z_FINISH ? (r = c.inflateEnd(this.strm), this.onEnd(r), this.ended = !0, r === m.Z_OK) : n !== m.Z_SYNC_FLUSH || (this.onEnd(m.Z_OK), h.avail_out = 0, true);
                }, a.prototype.onData = function(e) {
                    this.chunks.push(e);
                }, a.prototype.onEnd = function(e) {
                    e === m.Z_OK && ("string" === this.options.to ? this.result = this.chunks.join("") : this.result = d.flattenChunks(this.chunks)), this.chunks = [], this.err = e, this.msg = this.strm.msg;
                }, r.Inflate = a, r.inflate = o, r.inflateRaw = function(e, t) {
                    return (t = t || {}).raw = !0, o(e, t);
                }, r.ungzip = o;
            },
            {
                "./utils/common": 41,
                "./utils/strings": 42,
                "./zlib/constants": 44,
                "./zlib/gzheader": 47,
                "./zlib/inflate": 49,
                "./zlib/messages": 51,
                "./zlib/zstream": 53
            }
        ],
        41: [
            function(e, t, r) {
                "use strict";
                var n = "undefined" != typeof Uint8Array && "undefined" != typeof Uint16Array && "undefined" != typeof Int32Array;
                r.assign = function(e) {
                    for(var t = Array.prototype.slice.call(arguments, 1); t.length;){
                        var r = t.shift();
                        if (r) {
                            if ("object" != typeof r) throw new TypeError(r + "must be non-object");
                            for(var n in r)r.hasOwnProperty(n) && (e[n] = r[n]);
                        }
                    }
                    return e;
                }, r.shrinkBuf = function(e, t) {
                    return e.length === t ? e : e.subarray ? e.subarray(0, t) : (e.length = t, e);
                };
                var i = {
                    arraySet: function(e, t, r, n, i) {
                        if (t.subarray && e.subarray) e.set(t.subarray(r, r + n), i);
                        else for(var s = 0; s < n; s++)e[i + s] = t[r + s];
                    },
                    flattenChunks: function(e) {
                        var t, r, n, i, s, a;
                        for(t = n = 0, r = e.length; t < r; t++)n += e[t].length;
                        for(a = new Uint8Array(n), t = i = 0, r = e.length; t < r; t++)s = e[t], a.set(s, i), i += s.length;
                        return a;
                    }
                }, s = {
                    arraySet: function(e, t, r, n, i) {
                        for(var s = 0; s < n; s++)e[i + s] = t[r + s];
                    },
                    flattenChunks: function(e) {
                        return [].concat.apply([], e);
                    }
                };
                r.setTyped = function(e) {
                    e ? (r.Buf8 = Uint8Array, r.Buf16 = Uint16Array, r.Buf32 = Int32Array, r.assign(r, i)) : (r.Buf8 = Array, r.Buf16 = Array, r.Buf32 = Array, r.assign(r, s));
                }, r.setTyped(n);
            },
            {}
        ],
        42: [
            function(e, t, r) {
                "use strict";
                var h = e("./common"), i = !0, s = !0;
                try {
                    String.fromCharCode.apply(null, [
                        0
                    ]);
                } catch (e) {
                    i = !1;
                }
                try {
                    String.fromCharCode.apply(null, new Uint8Array(1));
                } catch (e) {
                    s = !1;
                }
                for(var u = new h.Buf8(256), n = 0; n < 256; n++)u[n] = 252 <= n ? 6 : 248 <= n ? 5 : 240 <= n ? 4 : 224 <= n ? 3 : 192 <= n ? 2 : 1;
                function l(e, t) {
                    if (t < 65537 && (e.subarray && s || !e.subarray && i)) return String.fromCharCode.apply(null, h.shrinkBuf(e, t));
                    for(var r = "", n = 0; n < t; n++)r += String.fromCharCode(e[n]);
                    return r;
                }
                u[254] = u[254] = 1, r.string2buf = function(e) {
                    var t, r, n, i, s, a = e.length, o = 0;
                    for(i = 0; i < a; i++)55296 == (64512 & (r = e.charCodeAt(i))) && i + 1 < a && 56320 == (64512 & (n = e.charCodeAt(i + 1))) && (r = 65536 + (r - 55296 << 10) + (n - 56320), i++), o += r < 128 ? 1 : r < 2048 ? 2 : r < 65536 ? 3 : 4;
                    for(t = new h.Buf8(o), i = s = 0; s < o; i++)55296 == (64512 & (r = e.charCodeAt(i))) && i + 1 < a && 56320 == (64512 & (n = e.charCodeAt(i + 1))) && (r = 65536 + (r - 55296 << 10) + (n - 56320), i++), r < 128 ? t[s++] = r : (r < 2048 ? t[s++] = 192 | r >>> 6 : (r < 65536 ? t[s++] = 224 | r >>> 12 : (t[s++] = 240 | r >>> 18, t[s++] = 128 | r >>> 12 & 63), t[s++] = 128 | r >>> 6 & 63), t[s++] = 128 | 63 & r);
                    return t;
                }, r.buf2binstring = function(e) {
                    return l(e, e.length);
                }, r.binstring2buf = function(e) {
                    for(var t = new h.Buf8(e.length), r = 0, n = t.length; r < n; r++)t[r] = e.charCodeAt(r);
                    return t;
                }, r.buf2string = function(e, t) {
                    var r, n, i, s, a = t || e.length, o = new Array(2 * a);
                    for(r = n = 0; r < a;)if ((i = e[r++]) < 128) o[n++] = i;
                    else if (4 < (s = u[i])) o[n++] = 65533, r += s - 1;
                    else {
                        for(i &= 2 === s ? 31 : 3 === s ? 15 : 7; 1 < s && r < a;)i = i << 6 | 63 & e[r++], s--;
                        1 < s ? o[n++] = 65533 : i < 65536 ? o[n++] = i : (i -= 65536, o[n++] = 55296 | i >> 10 & 1023, o[n++] = 56320 | 1023 & i);
                    }
                    return l(o, n);
                }, r.utf8border = function(e, t) {
                    var r;
                    for((t = t || e.length) > e.length && (t = e.length), r = t - 1; 0 <= r && 128 == (192 & e[r]);)r--;
                    return r < 0 ? t : 0 === r ? t : r + u[e[r]] > t ? r : t;
                };
            },
            {
                "./common": 41
            }
        ],
        43: [
            function(e, t, r) {
                "use strict";
                t.exports = function(e, t, r, n) {
                    for(var i = 65535 & e | 0, s = e >>> 16 & 65535 | 0, a = 0; 0 !== r;){
                        for(r -= a = 2e3 < r ? 2e3 : r; s = s + (i = i + t[n++] | 0) | 0, --a;);
                        i %= 65521, s %= 65521;
                    }
                    return i | s << 16 | 0;
                };
            },
            {}
        ],
        44: [
            function(e, t, r) {
                "use strict";
                t.exports = {
                    Z_NO_FLUSH: 0,
                    Z_PARTIAL_FLUSH: 1,
                    Z_SYNC_FLUSH: 2,
                    Z_FULL_FLUSH: 3,
                    Z_FINISH: 4,
                    Z_BLOCK: 5,
                    Z_TREES: 6,
                    Z_OK: 0,
                    Z_STREAM_END: 1,
                    Z_NEED_DICT: 2,
                    Z_ERRNO: -1,
                    Z_STREAM_ERROR: -2,
                    Z_DATA_ERROR: -3,
                    Z_BUF_ERROR: -5,
                    Z_NO_COMPRESSION: 0,
                    Z_BEST_SPEED: 1,
                    Z_BEST_COMPRESSION: 9,
                    Z_DEFAULT_COMPRESSION: -1,
                    Z_FILTERED: 1,
                    Z_HUFFMAN_ONLY: 2,
                    Z_RLE: 3,
                    Z_FIXED: 4,
                    Z_DEFAULT_STRATEGY: 0,
                    Z_BINARY: 0,
                    Z_TEXT: 1,
                    Z_UNKNOWN: 2,
                    Z_DEFLATED: 8
                };
            },
            {}
        ],
        45: [
            function(e, t, r) {
                "use strict";
                var o = function() {
                    for(var e, t = [], r = 0; r < 256; r++){
                        e = r;
                        for(var n = 0; n < 8; n++)e = 1 & e ? 3988292384 ^ e >>> 1 : e >>> 1;
                        t[r] = e;
                    }
                    return t;
                }();
                t.exports = function(e, t, r, n) {
                    var i = o, s = n + r;
                    e ^= -1;
                    for(var a = n; a < s; a++)e = e >>> 8 ^ i[255 & (e ^ t[a])];
                    return -1 ^ e;
                };
            },
            {}
        ],
        46: [
            function(e, t, r) {
                "use strict";
                var h, c = e("../utils/common"), u = e("./trees"), d = e("./adler32"), p = e("./crc32"), n = e("./messages"), l = 0, f = 4, m = 0, _ = -2, g = -1, b = 4, i = 2, v = 8, y = 9, s = 286, a = 30, o = 19, w = 2 * s + 1, k = 15, x = 3, S = 258, z = S + x + 1, C = 42, E = 113, A = 1, I = 2, O = 3, B = 4;
                function R(e, t) {
                    return e.msg = n[t], t;
                }
                function T(e) {
                    return (e << 1) - (4 < e ? 9 : 0);
                }
                function D(e) {
                    for(var t = e.length; 0 <= --t;)e[t] = 0;
                }
                function F(e) {
                    var t = e.state, r = t.pending;
                    r > e.avail_out && (r = e.avail_out), 0 !== r && (c.arraySet(e.output, t.pending_buf, t.pending_out, r, e.next_out), e.next_out += r, t.pending_out += r, e.total_out += r, e.avail_out -= r, t.pending -= r, 0 === t.pending && (t.pending_out = 0));
                }
                function N(e, t) {
                    u._tr_flush_block(e, 0 <= e.block_start ? e.block_start : -1, e.strstart - e.block_start, t), e.block_start = e.strstart, F(e.strm);
                }
                function U(e, t) {
                    e.pending_buf[e.pending++] = t;
                }
                function P(e, t) {
                    e.pending_buf[e.pending++] = t >>> 8 & 255, e.pending_buf[e.pending++] = 255 & t;
                }
                function L(e, t) {
                    var r, n, i = e.max_chain_length, s = e.strstart, a = e.prev_length, o = e.nice_match, h = e.strstart > e.w_size - z ? e.strstart - (e.w_size - z) : 0, u = e.window, l = e.w_mask, f = e.prev, c = e.strstart + S, d = u[s + a - 1], p = u[s + a];
                    e.prev_length >= e.good_match && (i >>= 2), o > e.lookahead && (o = e.lookahead);
                    do if (u[(r = t) + a] === p && u[r + a - 1] === d && u[r] === u[s] && u[++r] === u[s + 1]) {
                        s += 2, r++;
                        do ;
                        while (u[++s] === u[++r] && u[++s] === u[++r] && u[++s] === u[++r] && u[++s] === u[++r] && u[++s] === u[++r] && u[++s] === u[++r] && u[++s] === u[++r] && u[++s] === u[++r] && s < c);
                        if (n = S - (c - s), s = c - S, a < n) {
                            if (e.match_start = t, o <= (a = n)) break;
                            d = u[s + a - 1], p = u[s + a];
                        }
                    }
                    while ((t = f[t & l]) > h && 0 != --i);
                    return a <= e.lookahead ? a : e.lookahead;
                }
                function j(e) {
                    var t, r, n, i, s, a, o, h, u, l, f = e.w_size;
                    do {
                        if (i = e.window_size - e.lookahead - e.strstart, e.strstart >= f + (f - z)) {
                            for(c.arraySet(e.window, e.window, f, f, 0), e.match_start -= f, e.strstart -= f, e.block_start -= f, t = r = e.hash_size; n = e.head[--t], e.head[t] = f <= n ? n - f : 0, --r;);
                            for(t = r = f; n = e.prev[--t], e.prev[t] = f <= n ? n - f : 0, --r;);
                            i += f;
                        }
                        if (0 === e.strm.avail_in) break;
                        if (a = e.strm, o = e.window, h = e.strstart + e.lookahead, u = i, l = void 0, l = a.avail_in, u < l && (l = u), r = 0 === l ? 0 : (a.avail_in -= l, c.arraySet(o, a.input, a.next_in, l, h), 1 === a.state.wrap ? a.adler = d(a.adler, o, l, h) : 2 === a.state.wrap && (a.adler = p(a.adler, o, l, h)), a.next_in += l, a.total_in += l, l), e.lookahead += r, e.lookahead + e.insert >= x) for(s = e.strstart - e.insert, e.ins_h = e.window[s], e.ins_h = (e.ins_h << e.hash_shift ^ e.window[s + 1]) & e.hash_mask; e.insert && (e.ins_h = (e.ins_h << e.hash_shift ^ e.window[s + x - 1]) & e.hash_mask, e.prev[s & e.w_mask] = e.head[e.ins_h], e.head[e.ins_h] = s, s++, e.insert--, !(e.lookahead + e.insert < x)););
                    }while (e.lookahead < z && 0 !== e.strm.avail_in);
                }
                function Z(e, t) {
                    for(var r, n;;){
                        if (e.lookahead < z) {
                            if (j(e), e.lookahead < z && t === l) return A;
                            if (0 === e.lookahead) break;
                        }
                        if (r = 0, e.lookahead >= x && (e.ins_h = (e.ins_h << e.hash_shift ^ e.window[e.strstart + x - 1]) & e.hash_mask, r = e.prev[e.strstart & e.w_mask] = e.head[e.ins_h], e.head[e.ins_h] = e.strstart), 0 !== r && e.strstart - r <= e.w_size - z && (e.match_length = L(e, r)), e.match_length >= x) {
                            if (n = u._tr_tally(e, e.strstart - e.match_start, e.match_length - x), e.lookahead -= e.match_length, e.match_length <= e.max_lazy_match && e.lookahead >= x) {
                                for(e.match_length--; e.strstart++, e.ins_h = (e.ins_h << e.hash_shift ^ e.window[e.strstart + x - 1]) & e.hash_mask, r = e.prev[e.strstart & e.w_mask] = e.head[e.ins_h], e.head[e.ins_h] = e.strstart, 0 != --e.match_length;);
                                e.strstart++;
                            } else e.strstart += e.match_length, e.match_length = 0, e.ins_h = e.window[e.strstart], e.ins_h = (e.ins_h << e.hash_shift ^ e.window[e.strstart + 1]) & e.hash_mask;
                        } else n = u._tr_tally(e, 0, e.window[e.strstart]), e.lookahead--, e.strstart++;
                        if (n && (N(e, !1), 0 === e.strm.avail_out)) return A;
                    }
                    return e.insert = e.strstart < x - 1 ? e.strstart : x - 1, t === f ? (N(e, !0), 0 === e.strm.avail_out ? O : B) : e.last_lit && (N(e, !1), 0 === e.strm.avail_out) ? A : I;
                }
                function W(e, t) {
                    for(var r, n, i;;){
                        if (e.lookahead < z) {
                            if (j(e), e.lookahead < z && t === l) return A;
                            if (0 === e.lookahead) break;
                        }
                        if (r = 0, e.lookahead >= x && (e.ins_h = (e.ins_h << e.hash_shift ^ e.window[e.strstart + x - 1]) & e.hash_mask, r = e.prev[e.strstart & e.w_mask] = e.head[e.ins_h], e.head[e.ins_h] = e.strstart), e.prev_length = e.match_length, e.prev_match = e.match_start, e.match_length = x - 1, 0 !== r && e.prev_length < e.max_lazy_match && e.strstart - r <= e.w_size - z && (e.match_length = L(e, r), e.match_length <= 5 && (1 === e.strategy || e.match_length === x && 4096 < e.strstart - e.match_start) && (e.match_length = x - 1)), e.prev_length >= x && e.match_length <= e.prev_length) {
                            for(i = e.strstart + e.lookahead - x, n = u._tr_tally(e, e.strstart - 1 - e.prev_match, e.prev_length - x), e.lookahead -= e.prev_length - 1, e.prev_length -= 2; ++e.strstart <= i && (e.ins_h = (e.ins_h << e.hash_shift ^ e.window[e.strstart + x - 1]) & e.hash_mask, r = e.prev[e.strstart & e.w_mask] = e.head[e.ins_h], e.head[e.ins_h] = e.strstart), 0 != --e.prev_length;);
                            if (e.match_available = 0, e.match_length = x - 1, e.strstart++, n && (N(e, !1), 0 === e.strm.avail_out)) return A;
                        } else if (e.match_available) {
                            if ((n = u._tr_tally(e, 0, e.window[e.strstart - 1])) && N(e, !1), e.strstart++, e.lookahead--, 0 === e.strm.avail_out) return A;
                        } else e.match_available = 1, e.strstart++, e.lookahead--;
                    }
                    return e.match_available && (n = u._tr_tally(e, 0, e.window[e.strstart - 1]), e.match_available = 0), e.insert = e.strstart < x - 1 ? e.strstart : x - 1, t === f ? (N(e, !0), 0 === e.strm.avail_out ? O : B) : e.last_lit && (N(e, !1), 0 === e.strm.avail_out) ? A : I;
                }
                function M(e, t, r, n, i) {
                    this.good_length = e, this.max_lazy = t, this.nice_length = r, this.max_chain = n, this.func = i;
                }
                function H() {
                    this.strm = null, this.status = 0, this.pending_buf = null, this.pending_buf_size = 0, this.pending_out = 0, this.pending = 0, this.wrap = 0, this.gzhead = null, this.gzindex = 0, this.method = v, this.last_flush = -1, this.w_size = 0, this.w_bits = 0, this.w_mask = 0, this.window = null, this.window_size = 0, this.prev = null, this.head = null, this.ins_h = 0, this.hash_size = 0, this.hash_bits = 0, this.hash_mask = 0, this.hash_shift = 0, this.block_start = 0, this.match_length = 0, this.prev_match = 0, this.match_available = 0, this.strstart = 0, this.match_start = 0, this.lookahead = 0, this.prev_length = 0, this.max_chain_length = 0, this.max_lazy_match = 0, this.level = 0, this.strategy = 0, this.good_match = 0, this.nice_match = 0, this.dyn_ltree = new c.Buf16(2 * w), this.dyn_dtree = new c.Buf16(2 * (2 * a + 1)), this.bl_tree = new c.Buf16(2 * (2 * o + 1)), D(this.dyn_ltree), D(this.dyn_dtree), D(this.bl_tree), this.l_desc = null, this.d_desc = null, this.bl_desc = null, this.bl_count = new c.Buf16(k + 1), this.heap = new c.Buf16(2 * s + 1), D(this.heap), this.heap_len = 0, this.heap_max = 0, this.depth = new c.Buf16(2 * s + 1), D(this.depth), this.l_buf = 0, this.lit_bufsize = 0, this.last_lit = 0, this.d_buf = 0, this.opt_len = 0, this.static_len = 0, this.matches = 0, this.insert = 0, this.bi_buf = 0, this.bi_valid = 0;
                }
                function G(e) {
                    var t;
                    return e && e.state ? (e.total_in = e.total_out = 0, e.data_type = i, (t = e.state).pending = 0, t.pending_out = 0, t.wrap < 0 && (t.wrap = -t.wrap), t.status = t.wrap ? C : E, e.adler = 2 === t.wrap ? 0 : 1, t.last_flush = l, u._tr_init(t), m) : R(e, _);
                }
                function K(e) {
                    var t = G(e);
                    return t === m && function(e) {
                        e.window_size = 2 * e.w_size, D(e.head), e.max_lazy_match = h[e.level].max_lazy, e.good_match = h[e.level].good_length, e.nice_match = h[e.level].nice_length, e.max_chain_length = h[e.level].max_chain, e.strstart = 0, e.block_start = 0, e.lookahead = 0, e.insert = 0, e.match_length = e.prev_length = x - 1, e.match_available = 0, e.ins_h = 0;
                    }(e.state), t;
                }
                function Y(e, t, r, n, i, s) {
                    if (!e) return _;
                    var a = 1;
                    if (t === g && (t = 6), n < 0 ? (a = 0, n = -n) : 15 < n && (a = 2, n -= 16), i < 1 || y < i || r !== v || n < 8 || 15 < n || t < 0 || 9 < t || s < 0 || b < s) return R(e, _);
                    8 === n && (n = 9);
                    var o = new H;
                    return (e.state = o).strm = e, o.wrap = a, o.gzhead = null, o.w_bits = n, o.w_size = 1 << o.w_bits, o.w_mask = o.w_size - 1, o.hash_bits = i + 7, o.hash_size = 1 << o.hash_bits, o.hash_mask = o.hash_size - 1, o.hash_shift = ~~((o.hash_bits + x - 1) / x), o.window = new c.Buf8(2 * o.w_size), o.head = new c.Buf16(o.hash_size), o.prev = new c.Buf16(o.w_size), o.lit_bufsize = 1 << i + 6, o.pending_buf_size = 4 * o.lit_bufsize, o.pending_buf = new c.Buf8(o.pending_buf_size), o.d_buf = 1 * o.lit_bufsize, o.l_buf = 3 * o.lit_bufsize, o.level = t, o.strategy = s, o.method = r, K(e);
                }
                h = [
                    new M(0, 0, 0, 0, function(e, t) {
                        var r = 65535;
                        for(r > e.pending_buf_size - 5 && (r = e.pending_buf_size - 5);;){
                            if (e.lookahead <= 1) {
                                if (j(e), 0 === e.lookahead && t === l) return A;
                                if (0 === e.lookahead) break;
                            }
                            e.strstart += e.lookahead, e.lookahead = 0;
                            var n = e.block_start + r;
                            if ((0 === e.strstart || e.strstart >= n) && (e.lookahead = e.strstart - n, e.strstart = n, N(e, !1), 0 === e.strm.avail_out)) return A;
                            if (e.strstart - e.block_start >= e.w_size - z && (N(e, !1), 0 === e.strm.avail_out)) return A;
                        }
                        return e.insert = 0, t === f ? (N(e, !0), 0 === e.strm.avail_out ? O : B) : (e.strstart > e.block_start && (N(e, !1), e.strm.avail_out), A);
                    }),
                    new M(4, 4, 8, 4, Z),
                    new M(4, 5, 16, 8, Z),
                    new M(4, 6, 32, 32, Z),
                    new M(4, 4, 16, 16, W),
                    new M(8, 16, 32, 32, W),
                    new M(8, 16, 128, 128, W),
                    new M(8, 32, 128, 256, W),
                    new M(32, 128, 258, 1024, W),
                    new M(32, 258, 258, 4096, W)
                ], r.deflateInit = function(e, t) {
                    return Y(e, t, v, 15, 8, 0);
                }, r.deflateInit2 = Y, r.deflateReset = K, r.deflateResetKeep = G, r.deflateSetHeader = function(e, t) {
                    return e && e.state ? 2 !== e.state.wrap ? _ : (e.state.gzhead = t, m) : _;
                }, r.deflate = function(e, t) {
                    var r, n, i, s;
                    if (!e || !e.state || 5 < t || t < 0) return e ? R(e, _) : _;
                    if (n = e.state, !e.output || !e.input && 0 !== e.avail_in || 666 === n.status && t !== f) return R(e, 0 === e.avail_out ? -5 : _);
                    if (n.strm = e, r = n.last_flush, n.last_flush = t, n.status === C) {
                        if (2 === n.wrap) e.adler = 0, U(n, 31), U(n, 139), U(n, 8), n.gzhead ? (U(n, (n.gzhead.text ? 1 : 0) + (n.gzhead.hcrc ? 2 : 0) + (n.gzhead.extra ? 4 : 0) + (n.gzhead.name ? 8 : 0) + (n.gzhead.comment ? 16 : 0)), U(n, 255 & n.gzhead.time), U(n, n.gzhead.time >> 8 & 255), U(n, n.gzhead.time >> 16 & 255), U(n, n.gzhead.time >> 24 & 255), U(n, 9 === n.level ? 2 : 2 <= n.strategy || n.level < 2 ? 4 : 0), U(n, 255 & n.gzhead.os), n.gzhead.extra && n.gzhead.extra.length && (U(n, 255 & n.gzhead.extra.length), U(n, n.gzhead.extra.length >> 8 & 255)), n.gzhead.hcrc && (e.adler = p(e.adler, n.pending_buf, n.pending, 0)), n.gzindex = 0, n.status = 69) : (U(n, 0), U(n, 0), U(n, 0), U(n, 0), U(n, 0), U(n, 9 === n.level ? 2 : 2 <= n.strategy || n.level < 2 ? 4 : 0), U(n, 3), n.status = E);
                        else {
                            var a = v + (n.w_bits - 8 << 4) << 8;
                            a |= (2 <= n.strategy || n.level < 2 ? 0 : n.level < 6 ? 1 : 6 === n.level ? 2 : 3) << 6, 0 !== n.strstart && (a |= 32), a += 31 - a % 31, n.status = E, P(n, a), 0 !== n.strstart && (P(n, e.adler >>> 16), P(n, 65535 & e.adler)), e.adler = 1;
                        }
                    }
                    if (69 === n.status) {
                        if (n.gzhead.extra) {
                            for(i = n.pending; n.gzindex < (65535 & n.gzhead.extra.length) && (n.pending !== n.pending_buf_size || (n.gzhead.hcrc && n.pending > i && (e.adler = p(e.adler, n.pending_buf, n.pending - i, i)), F(e), i = n.pending, n.pending !== n.pending_buf_size));)U(n, 255 & n.gzhead.extra[n.gzindex]), n.gzindex++;
                            n.gzhead.hcrc && n.pending > i && (e.adler = p(e.adler, n.pending_buf, n.pending - i, i)), n.gzindex === n.gzhead.extra.length && (n.gzindex = 0, n.status = 73);
                        } else n.status = 73;
                    }
                    if (73 === n.status) {
                        if (n.gzhead.name) {
                            i = n.pending;
                            do {
                                if (n.pending === n.pending_buf_size && (n.gzhead.hcrc && n.pending > i && (e.adler = p(e.adler, n.pending_buf, n.pending - i, i)), F(e), i = n.pending, n.pending === n.pending_buf_size)) {
                                    s = 1;
                                    break;
                                }
                                s = n.gzindex < n.gzhead.name.length ? 255 & n.gzhead.name.charCodeAt(n.gzindex++) : 0, U(n, s);
                            }while (0 !== s);
                            n.gzhead.hcrc && n.pending > i && (e.adler = p(e.adler, n.pending_buf, n.pending - i, i)), 0 === s && (n.gzindex = 0, n.status = 91);
                        } else n.status = 91;
                    }
                    if (91 === n.status) {
                        if (n.gzhead.comment) {
                            i = n.pending;
                            do {
                                if (n.pending === n.pending_buf_size && (n.gzhead.hcrc && n.pending > i && (e.adler = p(e.adler, n.pending_buf, n.pending - i, i)), F(e), i = n.pending, n.pending === n.pending_buf_size)) {
                                    s = 1;
                                    break;
                                }
                                s = n.gzindex < n.gzhead.comment.length ? 255 & n.gzhead.comment.charCodeAt(n.gzindex++) : 0, U(n, s);
                            }while (0 !== s);
                            n.gzhead.hcrc && n.pending > i && (e.adler = p(e.adler, n.pending_buf, n.pending - i, i)), 0 === s && (n.status = 103);
                        } else n.status = 103;
                    }
                    if (103 === n.status && (n.gzhead.hcrc ? (n.pending + 2 > n.pending_buf_size && F(e), n.pending + 2 <= n.pending_buf_size && (U(n, 255 & e.adler), U(n, e.adler >> 8 & 255), e.adler = 0, n.status = E)) : n.status = E), 0 !== n.pending) {
                        if (F(e), 0 === e.avail_out) return n.last_flush = -1, m;
                    } else if (0 === e.avail_in && T(t) <= T(r) && t !== f) return R(e, -5);
                    if (666 === n.status && 0 !== e.avail_in) return R(e, -5);
                    if (0 !== e.avail_in || 0 !== n.lookahead || t !== l && 666 !== n.status) {
                        var o = 2 === n.strategy ? function(e, t) {
                            for(var r;;){
                                if (0 === e.lookahead && (j(e), 0 === e.lookahead)) {
                                    if (t === l) return A;
                                    break;
                                }
                                if (e.match_length = 0, r = u._tr_tally(e, 0, e.window[e.strstart]), e.lookahead--, e.strstart++, r && (N(e, !1), 0 === e.strm.avail_out)) return A;
                            }
                            return e.insert = 0, t === f ? (N(e, !0), 0 === e.strm.avail_out ? O : B) : e.last_lit && (N(e, !1), 0 === e.strm.avail_out) ? A : I;
                        }(n, t) : 3 === n.strategy ? function(e, t) {
                            for(var r, n, i, s, a = e.window;;){
                                if (e.lookahead <= S) {
                                    if (j(e), e.lookahead <= S && t === l) return A;
                                    if (0 === e.lookahead) break;
                                }
                                if (e.match_length = 0, e.lookahead >= x && 0 < e.strstart && (n = a[i = e.strstart - 1]) === a[++i] && n === a[++i] && n === a[++i]) {
                                    s = e.strstart + S;
                                    do ;
                                    while (n === a[++i] && n === a[++i] && n === a[++i] && n === a[++i] && n === a[++i] && n === a[++i] && n === a[++i] && n === a[++i] && i < s);
                                    e.match_length = S - (s - i), e.match_length > e.lookahead && (e.match_length = e.lookahead);
                                }
                                if (e.match_length >= x ? (r = u._tr_tally(e, 1, e.match_length - x), e.lookahead -= e.match_length, e.strstart += e.match_length, e.match_length = 0) : (r = u._tr_tally(e, 0, e.window[e.strstart]), e.lookahead--, e.strstart++), r && (N(e, !1), 0 === e.strm.avail_out)) return A;
                            }
                            return e.insert = 0, t === f ? (N(e, !0), 0 === e.strm.avail_out ? O : B) : e.last_lit && (N(e, !1), 0 === e.strm.avail_out) ? A : I;
                        }(n, t) : h[n.level].func(n, t);
                        if (o !== O && o !== B || (n.status = 666), o === A || o === O) return 0 === e.avail_out && (n.last_flush = -1), m;
                        if (o === I && (1 === t ? u._tr_align(n) : 5 !== t && (u._tr_stored_block(n, 0, 0, !1), 3 === t && (D(n.head), 0 === n.lookahead && (n.strstart = 0, n.block_start = 0, n.insert = 0))), F(e), 0 === e.avail_out)) return n.last_flush = -1, m;
                    }
                    return t !== f ? m : n.wrap <= 0 ? 1 : (2 === n.wrap ? (U(n, 255 & e.adler), U(n, e.adler >> 8 & 255), U(n, e.adler >> 16 & 255), U(n, e.adler >> 24 & 255), U(n, 255 & e.total_in), U(n, e.total_in >> 8 & 255), U(n, e.total_in >> 16 & 255), U(n, e.total_in >> 24 & 255)) : (P(n, e.adler >>> 16), P(n, 65535 & e.adler)), F(e), 0 < n.wrap && (n.wrap = -n.wrap), 0 !== n.pending ? m : 1);
                }, r.deflateEnd = function(e) {
                    var t;
                    return e && e.state ? (t = e.state.status) !== C && 69 !== t && 73 !== t && 91 !== t && 103 !== t && t !== E && 666 !== t ? R(e, _) : (e.state = null, t === E ? R(e, -3) : m) : _;
                }, r.deflateSetDictionary = function(e, t) {
                    var r, n, i, s, a, o, h, u, l = t.length;
                    if (!e || !e.state) return _;
                    if (2 === (s = (r = e.state).wrap) || 1 === s && r.status !== C || r.lookahead) return _;
                    for(1 === s && (e.adler = d(e.adler, t, l, 0)), r.wrap = 0, l >= r.w_size && (0 === s && (D(r.head), r.strstart = 0, r.block_start = 0, r.insert = 0), u = new c.Buf8(r.w_size), c.arraySet(u, t, l - r.w_size, r.w_size, 0), t = u, l = r.w_size), a = e.avail_in, o = e.next_in, h = e.input, e.avail_in = l, e.next_in = 0, e.input = t, j(r); r.lookahead >= x;){
                        for(n = r.strstart, i = r.lookahead - (x - 1); r.ins_h = (r.ins_h << r.hash_shift ^ r.window[n + x - 1]) & r.hash_mask, r.prev[n & r.w_mask] = r.head[r.ins_h], r.head[r.ins_h] = n, n++, --i;);
                        r.strstart = n, r.lookahead = x - 1, j(r);
                    }
                    return r.strstart += r.lookahead, r.block_start = r.strstart, r.insert = r.lookahead, r.lookahead = 0, r.match_length = r.prev_length = x - 1, r.match_available = 0, e.next_in = o, e.input = h, e.avail_in = a, r.wrap = s, m;
                }, r.deflateInfo = "pako deflate (from Nodeca project)";
            },
            {
                "../utils/common": 41,
                "./adler32": 43,
                "./crc32": 45,
                "./messages": 51,
                "./trees": 52
            }
        ],
        47: [
            function(e, t, r) {
                "use strict";
                t.exports = function() {
                    this.text = 0, this.time = 0, this.xflags = 0, this.os = 0, this.extra = null, this.extra_len = 0, this.name = "", this.comment = "", this.hcrc = 0, this.done = !1;
                };
            },
            {}
        ],
        48: [
            function(e, t, r) {
                "use strict";
                t.exports = function(e, t) {
                    var r, n, i, s, a, o, h, u, l, f, c, d, p, m, _, g, b, v, y, w, k, x, S, z, C;
                    r = e.state, n = e.next_in, z = e.input, i = n + (e.avail_in - 5), s = e.next_out, C = e.output, a = s - (t - e.avail_out), o = s + (e.avail_out - 257), h = r.dmax, u = r.wsize, l = r.whave, f = r.wnext, c = r.window, d = r.hold, p = r.bits, m = r.lencode, _ = r.distcode, g = (1 << r.lenbits) - 1, b = (1 << r.distbits) - 1;
                    e: do {
                        p < 15 && (d += z[n++] << p, p += 8, d += z[n++] << p, p += 8), v = m[d & g];
                        t: for(;;){
                            if (d >>>= y = v >>> 24, p -= y, 0 === (y = v >>> 16 & 255)) C[s++] = 65535 & v;
                            else {
                                if (!(16 & y)) {
                                    if (0 == (64 & y)) {
                                        v = m[(65535 & v) + (d & (1 << y) - 1)];
                                        continue t;
                                    }
                                    if (32 & y) {
                                        r.mode = 12;
                                        break e;
                                    }
                                    e.msg = "invalid literal/length code", r.mode = 30;
                                    break e;
                                }
                                w = 65535 & v, (y &= 15) && (p < y && (d += z[n++] << p, p += 8), w += d & (1 << y) - 1, d >>>= y, p -= y), p < 15 && (d += z[n++] << p, p += 8, d += z[n++] << p, p += 8), v = _[d & b];
                                r: for(;;){
                                    if (d >>>= y = v >>> 24, p -= y, !(16 & (y = v >>> 16 & 255))) {
                                        if (0 == (64 & y)) {
                                            v = _[(65535 & v) + (d & (1 << y) - 1)];
                                            continue r;
                                        }
                                        e.msg = "invalid distance code", r.mode = 30;
                                        break e;
                                    }
                                    if (k = 65535 & v, p < (y &= 15) && (d += z[n++] << p, (p += 8) < y && (d += z[n++] << p, p += 8)), h < (k += d & (1 << y) - 1)) {
                                        e.msg = "invalid distance too far back", r.mode = 30;
                                        break e;
                                    }
                                    if (d >>>= y, p -= y, (y = s - a) < k) {
                                        if (l < (y = k - y) && r.sane) {
                                            e.msg = "invalid distance too far back", r.mode = 30;
                                            break e;
                                        }
                                        if (S = c, (x = 0) === f) {
                                            if (x += u - y, y < w) {
                                                for(w -= y; C[s++] = c[x++], --y;);
                                                x = s - k, S = C;
                                            }
                                        } else if (f < y) {
                                            if (x += u + f - y, (y -= f) < w) {
                                                for(w -= y; C[s++] = c[x++], --y;);
                                                if (x = 0, f < w) {
                                                    for(w -= y = f; C[s++] = c[x++], --y;);
                                                    x = s - k, S = C;
                                                }
                                            }
                                        } else if (x += f - y, y < w) {
                                            for(w -= y; C[s++] = c[x++], --y;);
                                            x = s - k, S = C;
                                        }
                                        for(; 2 < w;)C[s++] = S[x++], C[s++] = S[x++], C[s++] = S[x++], w -= 3;
                                        w && (C[s++] = S[x++], 1 < w && (C[s++] = S[x++]));
                                    } else {
                                        for(x = s - k; C[s++] = C[x++], C[s++] = C[x++], C[s++] = C[x++], 2 < (w -= 3););
                                        w && (C[s++] = C[x++], 1 < w && (C[s++] = C[x++]));
                                    }
                                    break;
                                }
                            }
                            break;
                        }
                    }while (n < i && s < o);
                    n -= w = p >> 3, d &= (1 << (p -= w << 3)) - 1, e.next_in = n, e.next_out = s, e.avail_in = n < i ? i - n + 5 : 5 - (n - i), e.avail_out = s < o ? o - s + 257 : 257 - (s - o), r.hold = d, r.bits = p;
                };
            },
            {}
        ],
        49: [
            function(e, t, r) {
                "use strict";
                var I = e("../utils/common"), O = e("./adler32"), B = e("./crc32"), R = e("./inffast"), T = e("./inftrees"), D = 1, F = 2, N = 0, U = -2, P = 1, n = 852, i = 592;
                function L(e) {
                    return (e >>> 24 & 255) + (e >>> 8 & 65280) + ((65280 & e) << 8) + ((255 & e) << 24);
                }
                function s() {
                    this.mode = 0, this.last = !1, this.wrap = 0, this.havedict = !1, this.flags = 0, this.dmax = 0, this.check = 0, this.total = 0, this.head = null, this.wbits = 0, this.wsize = 0, this.whave = 0, this.wnext = 0, this.window = null, this.hold = 0, this.bits = 0, this.length = 0, this.offset = 0, this.extra = 0, this.lencode = null, this.distcode = null, this.lenbits = 0, this.distbits = 0, this.ncode = 0, this.nlen = 0, this.ndist = 0, this.have = 0, this.next = null, this.lens = new I.Buf16(320), this.work = new I.Buf16(288), this.lendyn = null, this.distdyn = null, this.sane = 0, this.back = 0, this.was = 0;
                }
                function a(e) {
                    var t;
                    return e && e.state ? (t = e.state, e.total_in = e.total_out = t.total = 0, e.msg = "", t.wrap && (e.adler = 1 & t.wrap), t.mode = P, t.last = 0, t.havedict = 0, t.dmax = 32768, t.head = null, t.hold = 0, t.bits = 0, t.lencode = t.lendyn = new I.Buf32(n), t.distcode = t.distdyn = new I.Buf32(i), t.sane = 1, t.back = -1, N) : U;
                }
                function o(e) {
                    var t;
                    return e && e.state ? ((t = e.state).wsize = 0, t.whave = 0, t.wnext = 0, a(e)) : U;
                }
                function h(e, t) {
                    var r, n;
                    return e && e.state ? (n = e.state, t < 0 ? (r = 0, t = -t) : (r = 1 + (t >> 4), t < 48 && (t &= 15)), t && (t < 8 || 15 < t) ? U : (null !== n.window && n.wbits !== t && (n.window = null), n.wrap = r, n.wbits = t, o(e))) : U;
                }
                function u(e, t) {
                    var r, n;
                    return e ? (n = new s, (e.state = n).window = null, (r = h(e, t)) !== N && (e.state = null), r) : U;
                }
                var l, f, c = !0;
                function j(e) {
                    if (c) {
                        var t;
                        for(l = new I.Buf32(512), f = new I.Buf32(32), t = 0; t < 144;)e.lens[t++] = 8;
                        for(; t < 256;)e.lens[t++] = 9;
                        for(; t < 280;)e.lens[t++] = 7;
                        for(; t < 288;)e.lens[t++] = 8;
                        for(T(D, e.lens, 0, 288, l, 0, e.work, {
                            bits: 9
                        }), t = 0; t < 32;)e.lens[t++] = 5;
                        T(F, e.lens, 0, 32, f, 0, e.work, {
                            bits: 5
                        }), c = !1;
                    }
                    e.lencode = l, e.lenbits = 9, e.distcode = f, e.distbits = 5;
                }
                function Z(e, t, r, n) {
                    var i, s = e.state;
                    return null === s.window && (s.wsize = 1 << s.wbits, s.wnext = 0, s.whave = 0, s.window = new I.Buf8(s.wsize)), n >= s.wsize ? (I.arraySet(s.window, t, r - s.wsize, s.wsize, 0), s.wnext = 0, s.whave = s.wsize) : (n < (i = s.wsize - s.wnext) && (i = n), I.arraySet(s.window, t, r - n, i, s.wnext), (n -= i) ? (I.arraySet(s.window, t, r - n, n, 0), s.wnext = n, s.whave = s.wsize) : (s.wnext += i, s.wnext === s.wsize && (s.wnext = 0), s.whave < s.wsize && (s.whave += i))), 0;
                }
                r.inflateReset = o, r.inflateReset2 = h, r.inflateResetKeep = a, r.inflateInit = function(e) {
                    return u(e, 15);
                }, r.inflateInit2 = u, r.inflate = function(e, t) {
                    var r, n, i, s, a, o, h, u, l, f, c, d, p, m, _, g, b, v, y, w, k, x, S, z, C = 0, E = new I.Buf8(4), A = [
                        16,
                        17,
                        18,
                        0,
                        8,
                        7,
                        9,
                        6,
                        10,
                        5,
                        11,
                        4,
                        12,
                        3,
                        13,
                        2,
                        14,
                        1,
                        15
                    ];
                    if (!e || !e.state || !e.output || !e.input && 0 !== e.avail_in) return U;
                    12 === (r = e.state).mode && (r.mode = 13), a = e.next_out, i = e.output, h = e.avail_out, s = e.next_in, n = e.input, o = e.avail_in, u = r.hold, l = r.bits, f = o, c = h, x = N;
                    e: for(;;)switch(r.mode){
                        case P:
                            if (0 === r.wrap) {
                                r.mode = 13;
                                break;
                            }
                            for(; l < 16;){
                                if (0 === o) break e;
                                o--, u += n[s++] << l, l += 8;
                            }
                            if (2 & r.wrap && 35615 === u) {
                                E[r.check = 0] = 255 & u, E[1] = u >>> 8 & 255, r.check = B(r.check, E, 2, 0), l = u = 0, r.mode = 2;
                                break;
                            }
                            if (r.flags = 0, r.head && (r.head.done = !1), !(1 & r.wrap) || (((255 & u) << 8) + (u >> 8)) % 31) {
                                e.msg = "incorrect header check", r.mode = 30;
                                break;
                            }
                            if (8 != (15 & u)) {
                                e.msg = "unknown compression method", r.mode = 30;
                                break;
                            }
                            if (l -= 4, k = 8 + (15 & (u >>>= 4)), 0 === r.wbits) r.wbits = k;
                            else if (k > r.wbits) {
                                e.msg = "invalid window size", r.mode = 30;
                                break;
                            }
                            r.dmax = 1 << k, e.adler = r.check = 1, r.mode = 512 & u ? 10 : 12, l = u = 0;
                            break;
                        case 2:
                            for(; l < 16;){
                                if (0 === o) break e;
                                o--, u += n[s++] << l, l += 8;
                            }
                            if (r.flags = u, 8 != (255 & r.flags)) {
                                e.msg = "unknown compression method", r.mode = 30;
                                break;
                            }
                            if (57344 & r.flags) {
                                e.msg = "unknown header flags set", r.mode = 30;
                                break;
                            }
                            r.head && (r.head.text = u >> 8 & 1), 512 & r.flags && (E[0] = 255 & u, E[1] = u >>> 8 & 255, r.check = B(r.check, E, 2, 0)), l = u = 0, r.mode = 3;
                        case 3:
                            for(; l < 32;){
                                if (0 === o) break e;
                                o--, u += n[s++] << l, l += 8;
                            }
                            r.head && (r.head.time = u), 512 & r.flags && (E[0] = 255 & u, E[1] = u >>> 8 & 255, E[2] = u >>> 16 & 255, E[3] = u >>> 24 & 255, r.check = B(r.check, E, 4, 0)), l = u = 0, r.mode = 4;
                        case 4:
                            for(; l < 16;){
                                if (0 === o) break e;
                                o--, u += n[s++] << l, l += 8;
                            }
                            r.head && (r.head.xflags = 255 & u, r.head.os = u >> 8), 512 & r.flags && (E[0] = 255 & u, E[1] = u >>> 8 & 255, r.check = B(r.check, E, 2, 0)), l = u = 0, r.mode = 5;
                        case 5:
                            if (1024 & r.flags) {
                                for(; l < 16;){
                                    if (0 === o) break e;
                                    o--, u += n[s++] << l, l += 8;
                                }
                                r.length = u, r.head && (r.head.extra_len = u), 512 & r.flags && (E[0] = 255 & u, E[1] = u >>> 8 & 255, r.check = B(r.check, E, 2, 0)), l = u = 0;
                            } else r.head && (r.head.extra = null);
                            r.mode = 6;
                        case 6:
                            if (1024 & r.flags && (o < (d = r.length) && (d = o), d && (r.head && (k = r.head.extra_len - r.length, r.head.extra || (r.head.extra = new Array(r.head.extra_len)), I.arraySet(r.head.extra, n, s, d, k)), 512 & r.flags && (r.check = B(r.check, n, d, s)), o -= d, s += d, r.length -= d), r.length)) break e;
                            r.length = 0, r.mode = 7;
                        case 7:
                            if (2048 & r.flags) {
                                if (0 === o) break e;
                                for(d = 0; k = n[s + d++], r.head && k && r.length < 65536 && (r.head.name += String.fromCharCode(k)), k && d < o;);
                                if (512 & r.flags && (r.check = B(r.check, n, d, s)), o -= d, s += d, k) break e;
                            } else r.head && (r.head.name = null);
                            r.length = 0, r.mode = 8;
                        case 8:
                            if (4096 & r.flags) {
                                if (0 === o) break e;
                                for(d = 0; k = n[s + d++], r.head && k && r.length < 65536 && (r.head.comment += String.fromCharCode(k)), k && d < o;);
                                if (512 & r.flags && (r.check = B(r.check, n, d, s)), o -= d, s += d, k) break e;
                            } else r.head && (r.head.comment = null);
                            r.mode = 9;
                        case 9:
                            if (512 & r.flags) {
                                for(; l < 16;){
                                    if (0 === o) break e;
                                    o--, u += n[s++] << l, l += 8;
                                }
                                if (u !== (65535 & r.check)) {
                                    e.msg = "header crc mismatch", r.mode = 30;
                                    break;
                                }
                                l = u = 0;
                            }
                            r.head && (r.head.hcrc = r.flags >> 9 & 1, r.head.done = !0), e.adler = r.check = 0, r.mode = 12;
                            break;
                        case 10:
                            for(; l < 32;){
                                if (0 === o) break e;
                                o--, u += n[s++] << l, l += 8;
                            }
                            e.adler = r.check = L(u), l = u = 0, r.mode = 11;
                        case 11:
                            if (0 === r.havedict) return e.next_out = a, e.avail_out = h, e.next_in = s, e.avail_in = o, r.hold = u, r.bits = l, 2;
                            e.adler = r.check = 1, r.mode = 12;
                        case 12:
                            if (5 === t || 6 === t) break e;
                        case 13:
                            if (r.last) {
                                u >>>= 7 & l, l -= 7 & l, r.mode = 27;
                                break;
                            }
                            for(; l < 3;){
                                if (0 === o) break e;
                                o--, u += n[s++] << l, l += 8;
                            }
                            switch(r.last = 1 & u, l -= 1, 3 & (u >>>= 1)){
                                case 0:
                                    r.mode = 14;
                                    break;
                                case 1:
                                    if (j(r), r.mode = 20, 6 !== t) break;
                                    u >>>= 2, l -= 2;
                                    break e;
                                case 2:
                                    r.mode = 17;
                                    break;
                                case 3:
                                    e.msg = "invalid block type", r.mode = 30;
                            }
                            u >>>= 2, l -= 2;
                            break;
                        case 14:
                            for(u >>>= 7 & l, l -= 7 & l; l < 32;){
                                if (0 === o) break e;
                                o--, u += n[s++] << l, l += 8;
                            }
                            if ((65535 & u) != (u >>> 16 ^ 65535)) {
                                e.msg = "invalid stored block lengths", r.mode = 30;
                                break;
                            }
                            if (r.length = 65535 & u, l = u = 0, r.mode = 15, 6 === t) break e;
                        case 15:
                            r.mode = 16;
                        case 16:
                            if (d = r.length) {
                                if (o < d && (d = o), h < d && (d = h), 0 === d) break e;
                                I.arraySet(i, n, s, d, a), o -= d, s += d, h -= d, a += d, r.length -= d;
                                break;
                            }
                            r.mode = 12;
                            break;
                        case 17:
                            for(; l < 14;){
                                if (0 === o) break e;
                                o--, u += n[s++] << l, l += 8;
                            }
                            if (r.nlen = 257 + (31 & u), u >>>= 5, l -= 5, r.ndist = 1 + (31 & u), u >>>= 5, l -= 5, r.ncode = 4 + (15 & u), u >>>= 4, l -= 4, 286 < r.nlen || 30 < r.ndist) {
                                e.msg = "too many length or distance symbols", r.mode = 30;
                                break;
                            }
                            r.have = 0, r.mode = 18;
                        case 18:
                            for(; r.have < r.ncode;){
                                for(; l < 3;){
                                    if (0 === o) break e;
                                    o--, u += n[s++] << l, l += 8;
                                }
                                r.lens[A[r.have++]] = 7 & u, u >>>= 3, l -= 3;
                            }
                            for(; r.have < 19;)r.lens[A[r.have++]] = 0;
                            if (r.lencode = r.lendyn, r.lenbits = 7, S = {
                                bits: r.lenbits
                            }, x = T(0, r.lens, 0, 19, r.lencode, 0, r.work, S), r.lenbits = S.bits, x) {
                                e.msg = "invalid code lengths set", r.mode = 30;
                                break;
                            }
                            r.have = 0, r.mode = 19;
                        case 19:
                            for(; r.have < r.nlen + r.ndist;){
                                for(; g = (C = r.lencode[u & (1 << r.lenbits) - 1]) >>> 16 & 255, b = 65535 & C, !((_ = C >>> 24) <= l);){
                                    if (0 === o) break e;
                                    o--, u += n[s++] << l, l += 8;
                                }
                                if (b < 16) u >>>= _, l -= _, r.lens[r.have++] = b;
                                else {
                                    if (16 === b) {
                                        for(z = _ + 2; l < z;){
                                            if (0 === o) break e;
                                            o--, u += n[s++] << l, l += 8;
                                        }
                                        if (u >>>= _, l -= _, 0 === r.have) {
                                            e.msg = "invalid bit length repeat", r.mode = 30;
                                            break;
                                        }
                                        k = r.lens[r.have - 1], d = 3 + (3 & u), u >>>= 2, l -= 2;
                                    } else if (17 === b) {
                                        for(z = _ + 3; l < z;){
                                            if (0 === o) break e;
                                            o--, u += n[s++] << l, l += 8;
                                        }
                                        l -= _, k = 0, d = 3 + (7 & (u >>>= _)), u >>>= 3, l -= 3;
                                    } else {
                                        for(z = _ + 7; l < z;){
                                            if (0 === o) break e;
                                            o--, u += n[s++] << l, l += 8;
                                        }
                                        l -= _, k = 0, d = 11 + (127 & (u >>>= _)), u >>>= 7, l -= 7;
                                    }
                                    if (r.have + d > r.nlen + r.ndist) {
                                        e.msg = "invalid bit length repeat", r.mode = 30;
                                        break;
                                    }
                                    for(; d--;)r.lens[r.have++] = k;
                                }
                            }
                            if (30 === r.mode) break;
                            if (0 === r.lens[256]) {
                                e.msg = "invalid code -- missing end-of-block", r.mode = 30;
                                break;
                            }
                            if (r.lenbits = 9, S = {
                                bits: r.lenbits
                            }, x = T(D, r.lens, 0, r.nlen, r.lencode, 0, r.work, S), r.lenbits = S.bits, x) {
                                e.msg = "invalid literal/lengths set", r.mode = 30;
                                break;
                            }
                            if (r.distbits = 6, r.distcode = r.distdyn, S = {
                                bits: r.distbits
                            }, x = T(F, r.lens, r.nlen, r.ndist, r.distcode, 0, r.work, S), r.distbits = S.bits, x) {
                                e.msg = "invalid distances set", r.mode = 30;
                                break;
                            }
                            if (r.mode = 20, 6 === t) break e;
                        case 20:
                            r.mode = 21;
                        case 21:
                            if (6 <= o && 258 <= h) {
                                e.next_out = a, e.avail_out = h, e.next_in = s, e.avail_in = o, r.hold = u, r.bits = l, R(e, c), a = e.next_out, i = e.output, h = e.avail_out, s = e.next_in, n = e.input, o = e.avail_in, u = r.hold, l = r.bits, 12 === r.mode && (r.back = -1);
                                break;
                            }
                            for(r.back = 0; g = (C = r.lencode[u & (1 << r.lenbits) - 1]) >>> 16 & 255, b = 65535 & C, !((_ = C >>> 24) <= l);){
                                if (0 === o) break e;
                                o--, u += n[s++] << l, l += 8;
                            }
                            if (g && 0 == (240 & g)) {
                                for(v = _, y = g, w = b; g = (C = r.lencode[w + ((u & (1 << v + y) - 1) >> v)]) >>> 16 & 255, b = 65535 & C, !(v + (_ = C >>> 24) <= l);){
                                    if (0 === o) break e;
                                    o--, u += n[s++] << l, l += 8;
                                }
                                u >>>= v, l -= v, r.back += v;
                            }
                            if (u >>>= _, l -= _, r.back += _, r.length = b, 0 === g) {
                                r.mode = 26;
                                break;
                            }
                            if (32 & g) {
                                r.back = -1, r.mode = 12;
                                break;
                            }
                            if (64 & g) {
                                e.msg = "invalid literal/length code", r.mode = 30;
                                break;
                            }
                            r.extra = 15 & g, r.mode = 22;
                        case 22:
                            if (r.extra) {
                                for(z = r.extra; l < z;){
                                    if (0 === o) break e;
                                    o--, u += n[s++] << l, l += 8;
                                }
                                r.length += u & (1 << r.extra) - 1, u >>>= r.extra, l -= r.extra, r.back += r.extra;
                            }
                            r.was = r.length, r.mode = 23;
                        case 23:
                            for(; g = (C = r.distcode[u & (1 << r.distbits) - 1]) >>> 16 & 255, b = 65535 & C, !((_ = C >>> 24) <= l);){
                                if (0 === o) break e;
                                o--, u += n[s++] << l, l += 8;
                            }
                            if (0 == (240 & g)) {
                                for(v = _, y = g, w = b; g = (C = r.distcode[w + ((u & (1 << v + y) - 1) >> v)]) >>> 16 & 255, b = 65535 & C, !(v + (_ = C >>> 24) <= l);){
                                    if (0 === o) break e;
                                    o--, u += n[s++] << l, l += 8;
                                }
                                u >>>= v, l -= v, r.back += v;
                            }
                            if (u >>>= _, l -= _, r.back += _, 64 & g) {
                                e.msg = "invalid distance code", r.mode = 30;
                                break;
                            }
                            r.offset = b, r.extra = 15 & g, r.mode = 24;
                        case 24:
                            if (r.extra) {
                                for(z = r.extra; l < z;){
                                    if (0 === o) break e;
                                    o--, u += n[s++] << l, l += 8;
                                }
                                r.offset += u & (1 << r.extra) - 1, u >>>= r.extra, l -= r.extra, r.back += r.extra;
                            }
                            if (r.offset > r.dmax) {
                                e.msg = "invalid distance too far back", r.mode = 30;
                                break;
                            }
                            r.mode = 25;
                        case 25:
                            if (0 === h) break e;
                            if (d = c - h, r.offset > d) {
                                if ((d = r.offset - d) > r.whave && r.sane) {
                                    e.msg = "invalid distance too far back", r.mode = 30;
                                    break;
                                }
                                p = d > r.wnext ? (d -= r.wnext, r.wsize - d) : r.wnext - d, d > r.length && (d = r.length), m = r.window;
                            } else m = i, p = a - r.offset, d = r.length;
                            for(h < d && (d = h), h -= d, r.length -= d; i[a++] = m[p++], --d;);
                            0 === r.length && (r.mode = 21);
                            break;
                        case 26:
                            if (0 === h) break e;
                            i[a++] = r.length, h--, r.mode = 21;
                            break;
                        case 27:
                            if (r.wrap) {
                                for(; l < 32;){
                                    if (0 === o) break e;
                                    o--, u |= n[s++] << l, l += 8;
                                }
                                if (c -= h, e.total_out += c, r.total += c, c && (e.adler = r.check = r.flags ? B(r.check, i, c, a - c) : O(r.check, i, c, a - c)), c = h, (r.flags ? u : L(u)) !== r.check) {
                                    e.msg = "incorrect data check", r.mode = 30;
                                    break;
                                }
                                l = u = 0;
                            }
                            r.mode = 28;
                        case 28:
                            if (r.wrap && r.flags) {
                                for(; l < 32;){
                                    if (0 === o) break e;
                                    o--, u += n[s++] << l, l += 8;
                                }
                                if (u !== (4294967295 & r.total)) {
                                    e.msg = "incorrect length check", r.mode = 30;
                                    break;
                                }
                                l = u = 0;
                            }
                            r.mode = 29;
                        case 29:
                            x = 1;
                            break e;
                        case 30:
                            x = -3;
                            break e;
                        case 31:
                            return -4;
                        case 32:
                        default:
                            return U;
                    }
                    return e.next_out = a, e.avail_out = h, e.next_in = s, e.avail_in = o, r.hold = u, r.bits = l, (r.wsize || c !== e.avail_out && r.mode < 30 && (r.mode < 27 || 4 !== t)) && Z(e, e.output, e.next_out, c - e.avail_out) ? (r.mode = 31, -4) : (f -= e.avail_in, c -= e.avail_out, e.total_in += f, e.total_out += c, r.total += c, r.wrap && c && (e.adler = r.check = r.flags ? B(r.check, i, c, e.next_out - c) : O(r.check, i, c, e.next_out - c)), e.data_type = r.bits + (r.last ? 64 : 0) + (12 === r.mode ? 128 : 0) + (20 === r.mode || 15 === r.mode ? 256 : 0), (0 == f && 0 === c || 4 === t) && x === N && (x = -5), x);
                }, r.inflateEnd = function(e) {
                    if (!e || !e.state) return U;
                    var t = e.state;
                    return t.window && (t.window = null), e.state = null, N;
                }, r.inflateGetHeader = function(e, t) {
                    var r;
                    return e && e.state ? 0 == (2 & (r = e.state).wrap) ? U : ((r.head = t).done = !1, N) : U;
                }, r.inflateSetDictionary = function(e, t) {
                    var r, n = t.length;
                    return e && e.state ? 0 !== (r = e.state).wrap && 11 !== r.mode ? U : 11 === r.mode && O(1, t, n, 0) !== r.check ? -3 : Z(e, t, n, n) ? (r.mode = 31, -4) : (r.havedict = 1, N) : U;
                }, r.inflateInfo = "pako inflate (from Nodeca project)";
            },
            {
                "../utils/common": 41,
                "./adler32": 43,
                "./crc32": 45,
                "./inffast": 48,
                "./inftrees": 50
            }
        ],
        50: [
            function(e, t, r) {
                "use strict";
                var D = e("../utils/common"), F = [
                    3,
                    4,
                    5,
                    6,
                    7,
                    8,
                    9,
                    10,
                    11,
                    13,
                    15,
                    17,
                    19,
                    23,
                    27,
                    31,
                    35,
                    43,
                    51,
                    59,
                    67,
                    83,
                    99,
                    115,
                    131,
                    163,
                    195,
                    227,
                    258,
                    0,
                    0
                ], N = [
                    16,
                    16,
                    16,
                    16,
                    16,
                    16,
                    16,
                    16,
                    17,
                    17,
                    17,
                    17,
                    18,
                    18,
                    18,
                    18,
                    19,
                    19,
                    19,
                    19,
                    20,
                    20,
                    20,
                    20,
                    21,
                    21,
                    21,
                    21,
                    16,
                    72,
                    78
                ], U = [
                    1,
                    2,
                    3,
                    4,
                    5,
                    7,
                    9,
                    13,
                    17,
                    25,
                    33,
                    49,
                    65,
                    97,
                    129,
                    193,
                    257,
                    385,
                    513,
                    769,
                    1025,
                    1537,
                    2049,
                    3073,
                    4097,
                    6145,
                    8193,
                    12289,
                    16385,
                    24577,
                    0,
                    0
                ], P = [
                    16,
                    16,
                    16,
                    16,
                    17,
                    17,
                    18,
                    18,
                    19,
                    19,
                    20,
                    20,
                    21,
                    21,
                    22,
                    22,
                    23,
                    23,
                    24,
                    24,
                    25,
                    25,
                    26,
                    26,
                    27,
                    27,
                    28,
                    28,
                    29,
                    29,
                    64,
                    64
                ];
                t.exports = function(e, t, r, n, i, s, a, o) {
                    var h, u, l, f, c, d, p, m, _, g = o.bits, b = 0, v = 0, y = 0, w = 0, k = 0, x = 0, S = 0, z = 0, C = 0, E = 0, A = null, I = 0, O = new D.Buf16(16), B = new D.Buf16(16), R = null, T = 0;
                    for(b = 0; b <= 15; b++)O[b] = 0;
                    for(v = 0; v < n; v++)O[t[r + v]]++;
                    for(k = g, w = 15; 1 <= w && 0 === O[w]; w--);
                    if (w < k && (k = w), 0 === w) return i[s++] = 20971520, i[s++] = 20971520, o.bits = 1, 0;
                    for(y = 1; y < w && 0 === O[y]; y++);
                    for(k < y && (k = y), b = z = 1; b <= 15; b++)if (z <<= 1, (z -= O[b]) < 0) return -1;
                    if (0 < z && (0 === e || 1 !== w)) return -1;
                    for(B[1] = 0, b = 1; b < 15; b++)B[b + 1] = B[b] + O[b];
                    for(v = 0; v < n; v++)0 !== t[r + v] && (a[B[t[r + v]]++] = v);
                    if (d = 0 === e ? (A = R = a, 19) : 1 === e ? (A = F, I -= 257, R = N, T -= 257, 256) : (A = U, R = P, -1), b = y, c = s, S = v = E = 0, l = -1, f = (C = 1 << (x = k)) - 1, 1 === e && 852 < C || 2 === e && 592 < C) return 1;
                    for(;;){
                        for(p = b - S, _ = a[v] < d ? (m = 0, a[v]) : a[v] > d ? (m = R[T + a[v]], A[I + a[v]]) : (m = 96, 0), h = 1 << b - S, y = u = 1 << x; i[c + (E >> S) + (u -= h)] = p << 24 | m << 16 | _ | 0, 0 !== u;);
                        for(h = 1 << b - 1; E & h;)h >>= 1;
                        if (0 !== h ? (E &= h - 1, E += h) : E = 0, v++, 0 == --O[b]) {
                            if (b === w) break;
                            b = t[r + a[v]];
                        }
                        if (k < b && (E & f) !== l) {
                            for(0 === S && (S = k), c += y, z = 1 << (x = b - S); x + S < w && !((z -= O[x + S]) <= 0);)x++, z <<= 1;
                            if (C += 1 << x, 1 === e && 852 < C || 2 === e && 592 < C) return 1;
                            i[l = E & f] = k << 24 | x << 16 | c - s | 0;
                        }
                    }
                    return 0 !== E && (i[c + E] = b - S << 24 | 4194304), o.bits = k, 0;
                };
            },
            {
                "../utils/common": 41
            }
        ],
        51: [
            function(e, t, r) {
                "use strict";
                t.exports = {
                    2: "need dictionary",
                    1: "stream end",
                    0: "",
                    "-1": "file error",
                    "-2": "stream error",
                    "-3": "data error",
                    "-4": "insufficient memory",
                    "-5": "buffer error",
                    "-6": "incompatible version"
                };
            },
            {}
        ],
        52: [
            function(e, t, r) {
                "use strict";
                var i = e("../utils/common"), o = 0, h = 1;
                function n(e) {
                    for(var t = e.length; 0 <= --t;)e[t] = 0;
                }
                var s = 0, a = 29, u = 256, l = u + 1 + a, f = 30, c = 19, _ = 2 * l + 1, g = 15, d = 16, p = 7, m = 256, b = 16, v = 17, y = 18, w = [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    1,
                    1,
                    1,
                    1,
                    2,
                    2,
                    2,
                    2,
                    3,
                    3,
                    3,
                    3,
                    4,
                    4,
                    4,
                    4,
                    5,
                    5,
                    5,
                    5,
                    0
                ], k = [
                    0,
                    0,
                    0,
                    0,
                    1,
                    1,
                    2,
                    2,
                    3,
                    3,
                    4,
                    4,
                    5,
                    5,
                    6,
                    6,
                    7,
                    7,
                    8,
                    8,
                    9,
                    9,
                    10,
                    10,
                    11,
                    11,
                    12,
                    12,
                    13,
                    13
                ], x = [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    2,
                    3,
                    7
                ], S = [
                    16,
                    17,
                    18,
                    0,
                    8,
                    7,
                    9,
                    6,
                    10,
                    5,
                    11,
                    4,
                    12,
                    3,
                    13,
                    2,
                    14,
                    1,
                    15
                ], z = new Array(2 * (l + 2));
                n(z);
                var C = new Array(2 * f);
                n(C);
                var E = new Array(512);
                n(E);
                var A = new Array(256);
                n(A);
                var I = new Array(a);
                n(I);
                var O, B, R, T = new Array(f);
                function D(e, t, r, n, i) {
                    this.static_tree = e, this.extra_bits = t, this.extra_base = r, this.elems = n, this.max_length = i, this.has_stree = e && e.length;
                }
                function F(e, t) {
                    this.dyn_tree = e, this.max_code = 0, this.stat_desc = t;
                }
                function N(e) {
                    return e < 256 ? E[e] : E[256 + (e >>> 7)];
                }
                function U(e, t) {
                    e.pending_buf[e.pending++] = 255 & t, e.pending_buf[e.pending++] = t >>> 8 & 255;
                }
                function P(e, t, r) {
                    e.bi_valid > d - r ? (e.bi_buf |= t << e.bi_valid & 65535, U(e, e.bi_buf), e.bi_buf = t >> d - e.bi_valid, e.bi_valid += r - d) : (e.bi_buf |= t << e.bi_valid & 65535, e.bi_valid += r);
                }
                function L(e, t, r) {
                    P(e, r[2 * t], r[2 * t + 1]);
                }
                function j(e, t) {
                    for(var r = 0; r |= 1 & e, e >>>= 1, r <<= 1, 0 < --t;);
                    return r >>> 1;
                }
                function Z(e, t, r) {
                    var n, i, s = new Array(g + 1), a = 0;
                    for(n = 1; n <= g; n++)s[n] = a = a + r[n - 1] << 1;
                    for(i = 0; i <= t; i++){
                        var o = e[2 * i + 1];
                        0 !== o && (e[2 * i] = j(s[o]++, o));
                    }
                }
                function W(e) {
                    var t;
                    for(t = 0; t < l; t++)e.dyn_ltree[2 * t] = 0;
                    for(t = 0; t < f; t++)e.dyn_dtree[2 * t] = 0;
                    for(t = 0; t < c; t++)e.bl_tree[2 * t] = 0;
                    e.dyn_ltree[2 * m] = 1, e.opt_len = e.static_len = 0, e.last_lit = e.matches = 0;
                }
                function M(e) {
                    8 < e.bi_valid ? U(e, e.bi_buf) : 0 < e.bi_valid && (e.pending_buf[e.pending++] = e.bi_buf), e.bi_buf = 0, e.bi_valid = 0;
                }
                function H(e, t, r, n) {
                    var i = 2 * t, s = 2 * r;
                    return e[i] < e[s] || e[i] === e[s] && n[t] <= n[r];
                }
                function G(e, t, r) {
                    for(var n = e.heap[r], i = r << 1; i <= e.heap_len && (i < e.heap_len && H(t, e.heap[i + 1], e.heap[i], e.depth) && i++, !H(t, n, e.heap[i], e.depth));)e.heap[r] = e.heap[i], r = i, i <<= 1;
                    e.heap[r] = n;
                }
                function K(e, t, r) {
                    var n, i, s, a, o = 0;
                    if (0 !== e.last_lit) for(; n = e.pending_buf[e.d_buf + 2 * o] << 8 | e.pending_buf[e.d_buf + 2 * o + 1], i = e.pending_buf[e.l_buf + o], o++, 0 === n ? L(e, i, t) : (L(e, (s = A[i]) + u + 1, t), 0 !== (a = w[s]) && P(e, i -= I[s], a), L(e, s = N(--n), r), 0 !== (a = k[s]) && P(e, n -= T[s], a)), o < e.last_lit;);
                    L(e, m, t);
                }
                function Y(e, t) {
                    var r, n, i, s = t.dyn_tree, a = t.stat_desc.static_tree, o = t.stat_desc.has_stree, h = t.stat_desc.elems, u = -1;
                    for(e.heap_len = 0, e.heap_max = _, r = 0; r < h; r++)0 !== s[2 * r] ? (e.heap[++e.heap_len] = u = r, e.depth[r] = 0) : s[2 * r + 1] = 0;
                    for(; e.heap_len < 2;)s[2 * (i = e.heap[++e.heap_len] = u < 2 ? ++u : 0)] = 1, e.depth[i] = 0, e.opt_len--, o && (e.static_len -= a[2 * i + 1]);
                    for(t.max_code = u, r = e.heap_len >> 1; 1 <= r; r--)G(e, s, r);
                    for(i = h; r = e.heap[1], e.heap[1] = e.heap[e.heap_len--], G(e, s, 1), n = e.heap[1], e.heap[--e.heap_max] = r, e.heap[--e.heap_max] = n, s[2 * i] = s[2 * r] + s[2 * n], e.depth[i] = (e.depth[r] >= e.depth[n] ? e.depth[r] : e.depth[n]) + 1, s[2 * r + 1] = s[2 * n + 1] = i, e.heap[1] = i++, G(e, s, 1), 2 <= e.heap_len;);
                    e.heap[--e.heap_max] = e.heap[1], function(e, t) {
                        var r, n, i, s, a, o, h = t.dyn_tree, u = t.max_code, l = t.stat_desc.static_tree, f = t.stat_desc.has_stree, c = t.stat_desc.extra_bits, d = t.stat_desc.extra_base, p = t.stat_desc.max_length, m = 0;
                        for(s = 0; s <= g; s++)e.bl_count[s] = 0;
                        for(h[2 * e.heap[e.heap_max] + 1] = 0, r = e.heap_max + 1; r < _; r++)p < (s = h[2 * h[2 * (n = e.heap[r]) + 1] + 1] + 1) && (s = p, m++), h[2 * n + 1] = s, u < n || (e.bl_count[s]++, a = 0, d <= n && (a = c[n - d]), o = h[2 * n], e.opt_len += o * (s + a), f && (e.static_len += o * (l[2 * n + 1] + a)));
                        if (0 !== m) {
                            do {
                                for(s = p - 1; 0 === e.bl_count[s];)s--;
                                e.bl_count[s]--, e.bl_count[s + 1] += 2, e.bl_count[p]--, m -= 2;
                            }while (0 < m);
                            for(s = p; 0 !== s; s--)for(n = e.bl_count[s]; 0 !== n;)u < (i = e.heap[--r]) || (h[2 * i + 1] !== s && (e.opt_len += (s - h[2 * i + 1]) * h[2 * i], h[2 * i + 1] = s), n--);
                        }
                    }(e, t), Z(s, u, e.bl_count);
                }
                function X(e, t, r) {
                    var n, i, s = -1, a = t[1], o = 0, h = 7, u = 4;
                    for(0 === a && (h = 138, u = 3), t[2 * (r + 1) + 1] = 65535, n = 0; n <= r; n++)i = a, a = t[2 * (n + 1) + 1], ++o < h && i === a || (o < u ? e.bl_tree[2 * i] += o : 0 !== i ? (i !== s && e.bl_tree[2 * i]++, e.bl_tree[2 * b]++) : o <= 10 ? e.bl_tree[2 * v]++ : e.bl_tree[2 * y]++, s = i, u = (o = 0) === a ? (h = 138, 3) : i === a ? (h = 6, 3) : (h = 7, 4));
                }
                function V(e, t, r) {
                    var n, i, s = -1, a = t[1], o = 0, h = 7, u = 4;
                    for(0 === a && (h = 138, u = 3), n = 0; n <= r; n++)if (i = a, a = t[2 * (n + 1) + 1], !(++o < h && i === a)) {
                        if (o < u) for(; L(e, i, e.bl_tree), 0 != --o;);
                        else 0 !== i ? (i !== s && (L(e, i, e.bl_tree), o--), L(e, b, e.bl_tree), P(e, o - 3, 2)) : o <= 10 ? (L(e, v, e.bl_tree), P(e, o - 3, 3)) : (L(e, y, e.bl_tree), P(e, o - 11, 7));
                        s = i, u = (o = 0) === a ? (h = 138, 3) : i === a ? (h = 6, 3) : (h = 7, 4);
                    }
                }
                n(T);
                var q = !1;
                function J(e, t, r, n) {
                    P(e, (s << 1) + (n ? 1 : 0), 3), function(e, t, r, n) {
                        M(e), n && (U(e, r), U(e, ~r)), i.arraySet(e.pending_buf, e.window, t, r, e.pending), e.pending += r;
                    }(e, t, r, !0);
                }
                r._tr_init = function(e) {
                    q || (function() {
                        var e, t, r, n, i, s = new Array(g + 1);
                        for(n = r = 0; n < a - 1; n++)for(I[n] = r, e = 0; e < 1 << w[n]; e++)A[r++] = n;
                        for(A[r - 1] = n, n = i = 0; n < 16; n++)for(T[n] = i, e = 0; e < 1 << k[n]; e++)E[i++] = n;
                        for(i >>= 7; n < f; n++)for(T[n] = i << 7, e = 0; e < 1 << k[n] - 7; e++)E[256 + i++] = n;
                        for(t = 0; t <= g; t++)s[t] = 0;
                        for(e = 0; e <= 143;)z[2 * e + 1] = 8, e++, s[8]++;
                        for(; e <= 255;)z[2 * e + 1] = 9, e++, s[9]++;
                        for(; e <= 279;)z[2 * e + 1] = 7, e++, s[7]++;
                        for(; e <= 287;)z[2 * e + 1] = 8, e++, s[8]++;
                        for(Z(z, l + 1, s), e = 0; e < f; e++)C[2 * e + 1] = 5, C[2 * e] = j(e, 5);
                        O = new D(z, w, u + 1, l, g), B = new D(C, k, 0, f, g), R = new D(new Array(0), x, 0, c, p);
                    }(), q = !0), e.l_desc = new F(e.dyn_ltree, O), e.d_desc = new F(e.dyn_dtree, B), e.bl_desc = new F(e.bl_tree, R), e.bi_buf = 0, e.bi_valid = 0, W(e);
                }, r._tr_stored_block = J, r._tr_flush_block = function(e, t, r, n) {
                    var i, s, a = 0;
                    0 < e.level ? (2 === e.strm.data_type && (e.strm.data_type = function(e) {
                        var t, r = 4093624447;
                        for(t = 0; t <= 31; t++, r >>>= 1)if (1 & r && 0 !== e.dyn_ltree[2 * t]) return o;
                        if (0 !== e.dyn_ltree[18] || 0 !== e.dyn_ltree[20] || 0 !== e.dyn_ltree[26]) return h;
                        for(t = 32; t < u; t++)if (0 !== e.dyn_ltree[2 * t]) return h;
                        return o;
                    }(e)), Y(e, e.l_desc), Y(e, e.d_desc), a = function(e) {
                        var t;
                        for(X(e, e.dyn_ltree, e.l_desc.max_code), X(e, e.dyn_dtree, e.d_desc.max_code), Y(e, e.bl_desc), t = c - 1; 3 <= t && 0 === e.bl_tree[2 * S[t] + 1]; t--);
                        return e.opt_len += 3 * (t + 1) + 5 + 5 + 4, t;
                    }(e), i = e.opt_len + 3 + 7 >>> 3, (s = e.static_len + 3 + 7 >>> 3) <= i && (i = s)) : i = s = r + 5, r + 4 <= i && -1 !== t ? J(e, t, r, n) : 4 === e.strategy || s === i ? (P(e, 2 + (n ? 1 : 0), 3), K(e, z, C)) : (P(e, 4 + (n ? 1 : 0), 3), function(e, t, r, n) {
                        var i;
                        for(P(e, t - 257, 5), P(e, r - 1, 5), P(e, n - 4, 4), i = 0; i < n; i++)P(e, e.bl_tree[2 * S[i] + 1], 3);
                        V(e, e.dyn_ltree, t - 1), V(e, e.dyn_dtree, r - 1);
                    }(e, e.l_desc.max_code + 1, e.d_desc.max_code + 1, a + 1), K(e, e.dyn_ltree, e.dyn_dtree)), W(e), n && M(e);
                }, r._tr_tally = function(e, t, r) {
                    return e.pending_buf[e.d_buf + 2 * e.last_lit] = t >>> 8 & 255, e.pending_buf[e.d_buf + 2 * e.last_lit + 1] = 255 & t, e.pending_buf[e.l_buf + e.last_lit] = 255 & r, e.last_lit++, 0 === t ? e.dyn_ltree[2 * r]++ : (e.matches++, t--, e.dyn_ltree[2 * (A[r] + u + 1)]++, e.dyn_dtree[2 * N(t)]++), e.last_lit === e.lit_bufsize - 1;
                }, r._tr_align = function(e) {
                    P(e, 2, 3), L(e, m, z), function(e) {
                        16 === e.bi_valid ? (U(e, e.bi_buf), e.bi_buf = 0, e.bi_valid = 0) : 8 <= e.bi_valid && (e.pending_buf[e.pending++] = 255 & e.bi_buf, e.bi_buf >>= 8, e.bi_valid -= 8);
                    }(e);
                };
            },
            {
                "../utils/common": 41
            }
        ],
        53: [
            function(e, t, r) {
                "use strict";
                t.exports = function() {
                    this.input = null, this.next_in = 0, this.avail_in = 0, this.total_in = 0, this.output = null, this.next_out = 0, this.avail_out = 0, this.total_out = 0, this.msg = "", this.state = null, this.data_type = 2, this.adler = 0;
                };
            },
            {}
        ],
        54: [
            function(e, t, r) {
                (function(e) {
                    !function(r, n) {
                        "use strict";
                        if (!r.setImmediate) {
                            var i, s, t, a, o = 1, h = {}, u = !1, l = r.document, e = Object.getPrototypeOf && Object.getPrototypeOf(r);
                            e = e && e.setTimeout ? e : r, i = "[object process]" === ({}).toString.call(r.process) ? function(e) {
                                $4TZ3D.nextTick(function() {
                                    c(e);
                                });
                            } : function() {
                                if (r.postMessage && !r.importScripts) {
                                    var e = !0, t = r.onmessage;
                                    return r.onmessage = function() {
                                        e = !1;
                                    }, r.postMessage("", "*"), r.onmessage = t, e;
                                }
                            }() ? (a = "setImmediate$" + Math.random() + "$", r.addEventListener ? r.addEventListener("message", d, !1) : r.attachEvent("onmessage", d), function(e) {
                                r.postMessage(a + e, "*");
                            }) : r.MessageChannel ? ((t = new MessageChannel).port1.onmessage = function(e) {
                                c(e.data);
                            }, function(e) {
                                t.port2.postMessage(e);
                            }) : l && "onreadystatechange" in l.createElement("script") ? (s = l.documentElement, function(e) {
                                var t = l.createElement("script");
                                t.onreadystatechange = function() {
                                    c(e), t.onreadystatechange = null, s.removeChild(t), t = null;
                                }, s.appendChild(t);
                            }) : function(e) {
                                setTimeout(c, 0, e);
                            }, e.setImmediate = function(e) {
                                "function" != typeof e && (e = new Function("" + e));
                                for(var t = new Array(arguments.length - 1), r = 0; r < t.length; r++)t[r] = arguments[r + 1];
                                var n = {
                                    callback: e,
                                    args: t
                                };
                                return h[o] = n, i(o), o++;
                            }, e.clearImmediate = f;
                        }
                        function f(e) {
                            delete h[e];
                        }
                        function c(e) {
                            if (u) setTimeout(c, 0, e);
                            else {
                                var t = h[e];
                                if (t) {
                                    u = !0;
                                    try {
                                        !function(e) {
                                            var t = e.callback, r = e.args;
                                            switch(r.length){
                                                case 0:
                                                    t();
                                                    break;
                                                case 1:
                                                    t(r[0]);
                                                    break;
                                                case 2:
                                                    t(r[0], r[1]);
                                                    break;
                                                case 3:
                                                    t(r[0], r[1], r[2]);
                                                    break;
                                                default:
                                                    t.apply(n, r);
                                            }
                                        }(t);
                                    } finally{
                                        f(e), u = !1;
                                    }
                                }
                            }
                        }
                        function d(e) {
                            e.source === r && "string" == typeof e.data && 0 === e.data.indexOf(a) && c(+e.data.slice(a.length));
                        }
                    }("undefined" == typeof self ? void 0 === e ? this : e : self);
                }).call(this, "undefined" != typeof $parcel$global ? $parcel$global : "undefined" != typeof self ? self : "undefined" != typeof window ? window : {});
            },
            {}
        ]
    }, {}, [
        10
    ])(10);
});


$3e56e634a929bca6$export$94ea64f322e5a37c = $3e56e634a929bca6$var$openArrayBuffer;
$3e56e634a929bca6$export$824c337f43f2b64d = $3e56e634a929bca6$var$splitPath;
$3e56e634a929bca6$export$b891921babc70093 = $3e56e634a929bca6$var$joinPath;
function $3e56e634a929bca6$var$openArrayBuffer(arrayBuffer) {
    return $921d13038eff58c9$exports.loadAsync(arrayBuffer).then(function(zipFile) {
        function exists(name) {
            return zipFile.file(name) !== null;
        }
        function read(name, encoding) {
            return zipFile.file(name).async("uint8array").then(function(array) {
                if (encoding === "base64") return $441c3b20dbacff63$export$6100ba28696e12de(array);
                else if (encoding) {
                    var decoder = new TextDecoder(encoding);
                    return decoder.decode(array);
                } else return array;
            });
        }
        function write(name, contents) {
            zipFile.file(name, contents);
        }
        function toArrayBuffer() {
            return zipFile.generateAsync({
                type: "arraybuffer"
            });
        }
        return {
            exists: exists,
            read: read,
            write: write,
            toArrayBuffer: toArrayBuffer
        };
    });
}
function $3e56e634a929bca6$var$splitPath(path) {
    var lastIndex = path.lastIndexOf("/");
    if (lastIndex === -1) return {
        dirname: "",
        basename: path
    };
    else return {
        dirname: path.substring(0, lastIndex),
        basename: path.substring(lastIndex + 1)
    };
}
function $3e56e634a929bca6$var$joinPath() {
    var nonEmptyPaths = Array.prototype.filter.call(arguments, function(path) {
        return path;
    });
    var relevantPaths = [];
    nonEmptyPaths.forEach(function(path) {
        if (/^\//.test(path)) relevantPaths = [
            path
        ];
        else relevantPaths.push(path);
    });
    return relevantPaths.join("/");
}


var $78a3b14bfaef3ebb$export$aafa59e2e03f2942;
var $78a3b14bfaef3ebb$export$27eef0075cdf2763;
parcelRequire("9jAvV");
var $1TwZj = parcelRequire("1TwZj");

var $d93yU = parcelRequire("d93yU");
var $aea06b742aa725d8$export$db77ccec0bb4ccac;
var $aea06b742aa725d8$export$8454457683f90105;
var $aea06b742aa725d8$export$ae6de35c16b306df;
var $aea06b742aa725d8$export$6f093cfa640b7166;
var $aea06b742aa725d8$export$dda73877cb166cd3;
var $aea06b742aa725d8$export$48a3ce3d8cfe0ce1;

var $doJbW = parcelRequire("doJbW");
$aea06b742aa725d8$export$db77ccec0bb4ccac = $doJbW.Element;
$aea06b742aa725d8$export$8454457683f90105 = $doJbW.element;
$aea06b742aa725d8$export$ae6de35c16b306df = $doJbW.emptyElement;
$aea06b742aa725d8$export$6f093cfa640b7166 = $doJbW.text;

$aea06b742aa725d8$export$dda73877cb166cd3 = (parcelRequire("jxEQL")).readString;

$aea06b742aa725d8$export$48a3ce3d8cfe0ce1 = (parcelRequire("42JRH")).writeString;


$78a3b14bfaef3ebb$export$aafa59e2e03f2942 = $78a3b14bfaef3ebb$var$read;
$78a3b14bfaef3ebb$export$27eef0075cdf2763 = $78a3b14bfaef3ebb$var$readXmlFromZipFile;
var $78a3b14bfaef3ebb$var$xmlNamespaceMap = {
    // Transitional format
    "http://schemas.openxmlformats.org/wordprocessingml/2006/main": "w",
    "http://schemas.openxmlformats.org/officeDocument/2006/relationships": "r",
    "http://schemas.openxmlformats.org/drawingml/2006/wordprocessingDrawing": "wp",
    "http://schemas.openxmlformats.org/drawingml/2006/main": "a",
    "http://schemas.openxmlformats.org/drawingml/2006/picture": "pic",
    // Strict format
    "http://purl.oclc.org/ooxml/wordprocessingml/main": "w",
    "http://purl.oclc.org/ooxml/officeDocument/relationships": "r",
    "http://purl.oclc.org/ooxml/drawingml/wordprocessingDrawing": "wp",
    "http://purl.oclc.org/ooxml/drawingml/main": "a",
    "http://purl.oclc.org/ooxml/drawingml/picture": "pic",
    // Common
    "http://schemas.openxmlformats.org/package/2006/content-types": "content-types",
    "http://schemas.openxmlformats.org/package/2006/relationships": "relationships",
    "http://schemas.openxmlformats.org/markup-compatibility/2006": "mc",
    "urn:schemas-microsoft-com:vml": "v",
    "urn:schemas-microsoft-com:office:word": "office-word",
    // [MS-DOCX]: Word Extensions to the Office Open XML (.docx) File Format
    // https://learn.microsoft.com/en-us/openspecs/office_standards/ms-docx/b839fe1f-e1ca-4fa6-8c26-5954d0abbccd
    "http://schemas.microsoft.com/office/word/2010/wordml": "wordml"
};
function $78a3b14bfaef3ebb$var$read(xmlString) {
    return $aea06b742aa725d8$export$dda73877cb166cd3(xmlString, $78a3b14bfaef3ebb$var$xmlNamespaceMap).then(function(document) {
        return $78a3b14bfaef3ebb$var$collapseAlternateContent(document)[0];
    });
}
function $78a3b14bfaef3ebb$var$readXmlFromZipFile(docxFile, path) {
    if (docxFile.exists(path)) return docxFile.read(path, "utf-8").then($78a3b14bfaef3ebb$var$stripUtf8Bom).then($78a3b14bfaef3ebb$var$read);
    else return $d93yU.resolve(null);
}
function $78a3b14bfaef3ebb$var$stripUtf8Bom(xmlString) {
    return xmlString.replace(/^\uFEFF/g, '');
}
function $78a3b14bfaef3ebb$var$collapseAlternateContent(node) {
    if (node.type === "element") {
        if (node.name === "mc:AlternateContent") return node.firstOrEmpty("mc:Fallback").children;
        else {
            node.children = $1TwZj.default(node.children.map($78a3b14bfaef3ebb$var$collapseAlternateContent, true));
            return [
                node
            ];
        }
    } else return [
        node
    ];
}


var $bae7c73ea3cda3cb$require$readXmlFromZipFile = $78a3b14bfaef3ebb$export$27eef0075cdf2763;
var $5347e5b2a03f8fdd$export$ca2bb6f0ea38a00f;
var $5347e5b2a03f8fdd$export$fbfda8999a345a11;
$5347e5b2a03f8fdd$export$ca2bb6f0ea38a00f = $5347e5b2a03f8fdd$var$createBodyReader;
$5347e5b2a03f8fdd$export$fbfda8999a345a11 = $5347e5b2a03f8fdd$var$readNumberingProperties;
var $b5f977ccce5a84c6$exports = {};
"use strict";
var $b5f977ccce5a84c6$var$__importDefault = $b5f977ccce5a84c6$exports && $b5f977ccce5a84c6$exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty($b5f977ccce5a84c6$exports, "__esModule", {
    value: true
});
$b5f977ccce5a84c6$exports.hex = $b5f977ccce5a84c6$exports.dec = $b5f977ccce5a84c6$exports.codePoint = void 0;

var $b5f977ccce5a84c6$var$dingbats_1 = $b5f977ccce5a84c6$var$__importDefault((parcelRequire("jKsvD")));
var $b5f977ccce5a84c6$var$dingbatsByCodePoint = {};
var $b5f977ccce5a84c6$var$fromCodePoint = String.fromCodePoint ? String.fromCodePoint : $b5f977ccce5a84c6$var$fromCodePointPolyfill;
for(var $b5f977ccce5a84c6$var$_i = 0, $b5f977ccce5a84c6$var$dingbats_2 = $b5f977ccce5a84c6$var$dingbats_1.default; $b5f977ccce5a84c6$var$_i < $b5f977ccce5a84c6$var$dingbats_2.length; $b5f977ccce5a84c6$var$_i++){
    var $b5f977ccce5a84c6$var$dingbat = $b5f977ccce5a84c6$var$dingbats_2[$b5f977ccce5a84c6$var$_i];
    var $b5f977ccce5a84c6$var$codePoint_1 = parseInt($b5f977ccce5a84c6$var$dingbat["Unicode dec"], 10);
    var $b5f977ccce5a84c6$var$scalarValue = {
        codePoint: $b5f977ccce5a84c6$var$codePoint_1,
        string: $b5f977ccce5a84c6$var$fromCodePoint($b5f977ccce5a84c6$var$codePoint_1)
    };
    $b5f977ccce5a84c6$var$dingbatsByCodePoint[$b5f977ccce5a84c6$var$dingbat["Typeface name"].toUpperCase() + "_" + $b5f977ccce5a84c6$var$dingbat["Dingbat dec"]] = $b5f977ccce5a84c6$var$scalarValue;
}
function $b5f977ccce5a84c6$var$codePoint(typeface, codePoint) {
    return $b5f977ccce5a84c6$var$dingbatsByCodePoint[typeface.toUpperCase() + "_" + codePoint];
}
$b5f977ccce5a84c6$exports.codePoint = $b5f977ccce5a84c6$var$codePoint;
function $b5f977ccce5a84c6$var$dec(typeface, dec) {
    return $b5f977ccce5a84c6$var$codePoint(typeface, parseInt(dec, 10));
}
$b5f977ccce5a84c6$exports.dec = $b5f977ccce5a84c6$var$dec;
function $b5f977ccce5a84c6$var$hex(typeface, hex) {
    return $b5f977ccce5a84c6$var$codePoint(typeface, parseInt(hex, 16));
}
$b5f977ccce5a84c6$exports.hex = $b5f977ccce5a84c6$var$hex;
function $b5f977ccce5a84c6$var$fromCodePointPolyfill(codePoint) {
    if (codePoint <= 0xFFFF) // BMP
    return String.fromCharCode(codePoint);
    else {
        // Astral
        // https://mathiasbynens.be/notes/javascript-encoding#surrogate-formulae
        var highSurrogate = Math.floor((codePoint - 0x10000) / 0x400) + 0xD800;
        var lowSurrogate = (codePoint - 0x10000) % 0x400 + 0xDC00;
        return String.fromCharCode(highSurrogate, lowSurrogate);
    }
}


parcelRequire("9jAvV");
var $ctpBH = parcelRequire("ctpBH");
var $5yjjJ = parcelRequire("5yjjJ");
var $efEt3 = parcelRequire("efEt3");
var $1TwZj = parcelRequire("1TwZj");
var $hB3Xt = parcelRequire("hB3Xt");
var $gS9W9 = parcelRequire("gS9W9");


var $5347e5b2a03f8fdd$require$Result = $11d28a8fc8838027$export$8fdcabde73f49165;

var $5347e5b2a03f8fdd$require$warning = $11d28a8fc8838027$export$491112666e282270;


var $kUMgi = parcelRequire("kUMgi");
var $bff8c0b142852ddd$export$483b6ae7cde9cd77;
var $bff8c0b142852ddd$export$75a2182ba6144c1c;
$bff8c0b142852ddd$export$483b6ae7cde9cd77 = $bff8c0b142852ddd$var$uriToZipEntryName;
$bff8c0b142852ddd$export$75a2182ba6144c1c = $bff8c0b142852ddd$var$replaceFragment;
function $bff8c0b142852ddd$var$uriToZipEntryName(base, uri) {
    if (uri.charAt(0) === "/") return uri.substr(1);
    else // In general, we should check first and second for trailing and leading slashes,
    // but in our specific case this seems to be sufficient
    return base + "/" + uri;
}
function $bff8c0b142852ddd$var$replaceFragment(uri, fragment) {
    var hashIndex = uri.indexOf("#");
    if (hashIndex !== -1) uri = uri.substring(0, hashIndex);
    return uri + "#" + fragment;
}


function $5347e5b2a03f8fdd$var$createBodyReader(options) {
    return {
        readXmlElement: function(element) {
            return new $5347e5b2a03f8fdd$var$BodyReader(options).readXmlElement(element);
        },
        readXmlElements: function(elements) {
            return new $5347e5b2a03f8fdd$var$BodyReader(options).readXmlElements(elements);
        }
    };
}
function $5347e5b2a03f8fdd$var$BodyReader(options) {
    var complexFieldStack = [];
    var currentInstrText = [];
    // When a paragraph is marked as deleted, its contents should be combined
    // with the following paragraph. See 17.13.5.15 del (Deleted Paragraph) of
    // ECMA-376 4th edition Part 1.
    var deletedParagraphContents = [];
    var relationships = options.relationships;
    var contentTypes = options.contentTypes;
    var docxFile = options.docxFile;
    var files = options.files;
    var numbering = options.numbering;
    var styles = options.styles;
    function readXmlElements(elements) {
        var results = elements.map(readXmlElement);
        return $5347e5b2a03f8fdd$var$combineResults(results);
    }
    function readXmlElement(element) {
        if (element.type === "element") {
            var handler = xmlElementReaders[element.name];
            if (handler) return handler(element);
            else if (!Object.prototype.hasOwnProperty.call($5347e5b2a03f8fdd$var$ignoreElements, element.name)) {
                var message = $5347e5b2a03f8fdd$require$warning("An unrecognised element was ignored: " + element.name);
                return $5347e5b2a03f8fdd$var$emptyResultWithMessages([
                    message
                ]);
            }
        }
        return $5347e5b2a03f8fdd$var$emptyResult();
    }
    function readParagraphProperties(element) {
        return readParagraphStyle(element).map(function(style) {
            return {
                type: "paragraphProperties",
                styleId: style.styleId,
                styleName: style.name,
                alignment: element.firstOrEmpty("w:jc").attributes["w:val"],
                numbering: $5347e5b2a03f8fdd$var$readNumberingProperties(style.styleId, element.firstOrEmpty("w:numPr"), numbering),
                indent: readParagraphIndent(element.firstOrEmpty("w:ind"))
            };
        });
    }
    function readParagraphIndent(element) {
        return {
            start: element.attributes["w:start"] || element.attributes["w:left"],
            end: element.attributes["w:end"] || element.attributes["w:right"],
            firstLine: element.attributes["w:firstLine"],
            hanging: element.attributes["w:hanging"]
        };
    }
    function readRunProperties(element) {
        return readRunStyle(element).map(function(style) {
            var fontSizeString = element.firstOrEmpty("w:sz").attributes["w:val"];
            // w:sz gives the font size in half points, so halve the value to get the size in points
            var fontSize = /^[0-9]+$/.test(fontSizeString) ? parseInt(fontSizeString, 10) / 2 : null;
            return {
                type: "runProperties",
                styleId: style.styleId,
                styleName: style.name,
                verticalAlignment: element.firstOrEmpty("w:vertAlign").attributes["w:val"],
                font: element.firstOrEmpty("w:rFonts").attributes["w:ascii"],
                fontSize: fontSize,
                isBold: readBooleanElement(element.first("w:b")),
                isUnderline: readUnderline(element.first("w:u")),
                isItalic: readBooleanElement(element.first("w:i")),
                isStrikethrough: readBooleanElement(element.first("w:strike")),
                isAllCaps: readBooleanElement(element.first("w:caps")),
                isSmallCaps: readBooleanElement(element.first("w:smallCaps")),
                highlight: readHighlightValue(element.firstOrEmpty("w:highlight").attributes["w:val"])
            };
        });
    }
    function readUnderline(element) {
        if (element) {
            var value = element.attributes["w:val"];
            return value !== undefined && value !== "false" && value !== "0" && value !== "none";
        } else return false;
    }
    function readBooleanElement(element) {
        if (element) {
            var value = element.attributes["w:val"];
            return value !== "false" && value !== "0";
        } else return false;
    }
    function readBooleanAttributeValue(value) {
        return value !== "false" && value !== "0";
    }
    function readHighlightValue(value) {
        if (!value || value === "none") return null;
        else return value;
    }
    function readParagraphStyle(element) {
        return readStyle(element, "w:pStyle", "Paragraph", styles.findParagraphStyleById);
    }
    function readRunStyle(element) {
        return readStyle(element, "w:rStyle", "Run", styles.findCharacterStyleById);
    }
    function readTableStyle(element) {
        return readStyle(element, "w:tblStyle", "Table", styles.findTableStyleById);
    }
    function readStyle(element, styleTagName, styleType, findStyleById) {
        var messages = [];
        var styleElement = element.first(styleTagName);
        var styleId = null;
        var name = null;
        if (styleElement) {
            styleId = styleElement.attributes["w:val"];
            if (styleId) {
                var style = findStyleById(styleId);
                if (style) name = style.name;
                else messages.push(undefinedStyleWarning(styleType, styleId));
            }
        }
        return $5347e5b2a03f8fdd$var$elementResultWithMessages({
            styleId: styleId,
            name: name
        }, messages);
    }
    function readFldChar(element) {
        var type = element.attributes["w:fldCharType"];
        if (type === "begin") {
            complexFieldStack.push({
                type: "begin",
                fldChar: element
            });
            currentInstrText = [];
        } else if (type === "end") {
            var complexFieldEnd = complexFieldStack.pop();
            if (complexFieldEnd.type === "begin") complexFieldEnd = parseCurrentInstrText(complexFieldEnd);
            if (complexFieldEnd.type === "checkbox") return $5347e5b2a03f8fdd$var$elementResult($fcf129b7bd4ce72f$export$b07e517d22efa1ca({
                checked: complexFieldEnd.checked
            }));
        } else if (type === "separate") {
            var complexFieldSeparate = complexFieldStack.pop();
            var complexField = parseCurrentInstrText(complexFieldSeparate);
            complexFieldStack.push(complexField);
        }
        return $5347e5b2a03f8fdd$var$emptyResult();
    }
    function currentHyperlinkOptions() {
        var topHyperlink = $hB3Xt.default(complexFieldStack.filter(function(complexField) {
            return complexField.type === "hyperlink";
        }));
        return topHyperlink ? topHyperlink.options : null;
    }
    function parseCurrentInstrText(complexField) {
        return parseInstrText(currentInstrText.join(''), complexField.type === "begin" ? complexField.fldChar : $aea06b742aa725d8$export$ae6de35c16b306df);
    }
    function parseInstrText(instrText, fldChar) {
        var linkResult = /^\s*HYPERLINK\s+(\\l\s+)?(?:"(.*)"|([^\\]\S*))/.exec(instrText);
        if (linkResult) {
            var location = linkResult[2] === undefined ? linkResult[3] : linkResult[2];
            var options = linkResult[1] === undefined ? {
                href: location
            } : {
                anchor: location
            };
            return {
                type: "hyperlink",
                options: options
            };
        }
        var checkboxResult = /\s*FORMCHECKBOX\s*/.exec(instrText);
        if (checkboxResult) {
            var checkboxElement = fldChar.firstOrEmpty("w:ffData").firstOrEmpty("w:checkBox");
            var checkedElement = checkboxElement.first("w:checked");
            var checked = checkedElement == null ? readBooleanElement(checkboxElement.first("w:default")) : readBooleanElement(checkedElement);
            return {
                type: "checkbox",
                checked: checked
            };
        }
        return {
            type: "unknown"
        };
    }
    function readInstrText(element) {
        currentInstrText.push(element.text());
        return $5347e5b2a03f8fdd$var$emptyResult();
    }
    function readSymbol(element) {
        // See 17.3.3.30 sym (Symbol Character) of ECMA-376 4th edition Part 1
        var font = element.attributes["w:font"];
        var char = element.attributes["w:char"];
        var unicodeCharacter = $b5f977ccce5a84c6$exports.hex(font, char);
        if (unicodeCharacter == null && /^F0..$/.test(char)) unicodeCharacter = $b5f977ccce5a84c6$exports.hex(font, char.substring(2));
        if (unicodeCharacter == null) return $5347e5b2a03f8fdd$var$emptyResultWithMessages([
            $5347e5b2a03f8fdd$require$warning("A w:sym element with an unsupported character was ignored: char " + char + " in font " + font)
        ]);
        else return $5347e5b2a03f8fdd$var$elementResult(new $fcf129b7bd4ce72f$export$5f1af8db9871e1d6(unicodeCharacter.string));
    }
    function noteReferenceReader(noteType) {
        return function(element) {
            var noteId = element.attributes["w:id"];
            return $5347e5b2a03f8fdd$var$elementResult(new $fcf129b7bd4ce72f$export$e67f182a50c27e10({
                noteType: noteType,
                noteId: noteId
            }));
        };
    }
    function readCommentReference(element) {
        return $5347e5b2a03f8fdd$var$elementResult($fcf129b7bd4ce72f$export$841d4c6db70c1a65({
            commentId: element.attributes["w:id"]
        }));
    }
    function readChildElements(element) {
        return readXmlElements(element.children);
    }
    var xmlElementReaders = {
        "w:p": function(element) {
            var paragraphPropertiesElement = element.firstOrEmpty("w:pPr");
            var isDeleted = !!paragraphPropertiesElement.firstOrEmpty("w:rPr").first("w:del");
            if (isDeleted) {
                element.children.forEach(function(child) {
                    deletedParagraphContents.push(child);
                });
                return $5347e5b2a03f8fdd$var$emptyResult();
            } else {
                var childrenXml = element.children;
                if (deletedParagraphContents.length > 0) {
                    childrenXml = deletedParagraphContents.concat(childrenXml);
                    deletedParagraphContents = [];
                }
                return $5347e5b2a03f8fdd$var$ReadResult.map(readParagraphProperties(paragraphPropertiesElement), readXmlElements(childrenXml), function(properties, children) {
                    return new $fcf129b7bd4ce72f$export$358a232cca1ab2ac(children, properties);
                }).insertExtra();
            }
        },
        "w:r": function(element) {
            return $5347e5b2a03f8fdd$var$ReadResult.map(readRunProperties(element.firstOrEmpty("w:rPr")), readXmlElements(element.children), function(properties, children) {
                var hyperlinkOptions = currentHyperlinkOptions();
                if (hyperlinkOptions !== null) children = [
                    new $fcf129b7bd4ce72f$export$de48447bf377cd47(children, hyperlinkOptions)
                ];
                return new $fcf129b7bd4ce72f$export$ddae37e51c7979e2(children, properties);
            });
        },
        "w:fldChar": readFldChar,
        "w:instrText": readInstrText,
        "w:t": function(element) {
            return $5347e5b2a03f8fdd$var$elementResult(new $fcf129b7bd4ce72f$export$5f1af8db9871e1d6(element.text()));
        },
        "w:tab": function(element) {
            return $5347e5b2a03f8fdd$var$elementResult(new $fcf129b7bd4ce72f$export$3e41faf802a29e71());
        },
        "w:noBreakHyphen": function() {
            return $5347e5b2a03f8fdd$var$elementResult(new $fcf129b7bd4ce72f$export$5f1af8db9871e1d6("\u2011"));
        },
        "w:softHyphen": function(element) {
            return $5347e5b2a03f8fdd$var$elementResult(new $fcf129b7bd4ce72f$export$5f1af8db9871e1d6("\u00AD"));
        },
        "w:sym": readSymbol,
        "w:hyperlink": function(element) {
            var relationshipId = element.attributes["r:id"];
            var anchor = element.attributes["w:anchor"];
            return readXmlElements(element.children).map(function(children) {
                function create(options) {
                    var targetFrame = element.attributes["w:tgtFrame"] || null;
                    return new $fcf129b7bd4ce72f$export$de48447bf377cd47(children, $5yjjJ.default({
                        targetFrame: targetFrame
                    }, options));
                }
                if (relationshipId) {
                    var href = relationships.findTargetByRelationshipId(relationshipId);
                    if (anchor) href = $bff8c0b142852ddd$export$75a2182ba6144c1c(href, anchor);
                    return create({
                        href: href
                    });
                } else if (anchor) return create({
                    anchor: anchor
                });
                else return children;
            });
        },
        "w:tbl": readTable,
        "w:tr": readTableRow,
        "w:tc": readTableCell,
        "w:footnoteReference": noteReferenceReader("footnote"),
        "w:endnoteReference": noteReferenceReader("endnote"),
        "w:commentReference": readCommentReference,
        "w:br": function(element) {
            var breakType = element.attributes["w:type"];
            if (breakType == null || breakType === "textWrapping") return $5347e5b2a03f8fdd$var$elementResult($fcf129b7bd4ce72f$export$a1aa2dd4ad0d3f6);
            else if (breakType === "page") return $5347e5b2a03f8fdd$var$elementResult($fcf129b7bd4ce72f$export$1b438cdd7ed26c35);
            else if (breakType === "column") return $5347e5b2a03f8fdd$var$elementResult($fcf129b7bd4ce72f$export$5a38f5b463e49b91);
            else return $5347e5b2a03f8fdd$var$emptyResultWithMessages([
                $5347e5b2a03f8fdd$require$warning("Unsupported break type: " + breakType)
            ]);
        },
        "w:bookmarkStart": function(element) {
            var name = element.attributes["w:name"];
            if (name === "_GoBack") return $5347e5b2a03f8fdd$var$emptyResult();
            else return $5347e5b2a03f8fdd$var$elementResult(new $fcf129b7bd4ce72f$export$ad0c5cb04e0f1440({
                name: name
            }));
        },
        "mc:AlternateContent": function(element) {
            return readChildElements(element.firstOrEmpty("mc:Fallback"));
        },
        "w:sdt": function(element) {
            var contentResult = readXmlElements(element.firstOrEmpty("w:sdtContent").children);
            return contentResult.map(function(content) {
                // From the WordML standard: https://learn.microsoft.com/en-us/openspecs/office_standards/ms-docx/3350cb64-931f-41f7-8824-f18b2568ce66
                //
                // > A CT_SdtCheckbox element that specifies that the parent
                // > structured document tag is a checkbox when displayed in the
                // > document. The parent structured document tag contents MUST
                // > contain a single character and optionally an additional
                // > character in a deleted run.
                var checkbox = element.firstOrEmpty("w:sdtPr").first("wordml:checkbox");
                if (checkbox) {
                    var checkedElement = checkbox.first("wordml:checked");
                    var isChecked = !!checkedElement && readBooleanAttributeValue(checkedElement.attributes["wordml:val"]);
                    var documentCheckbox = $fcf129b7bd4ce72f$export$b07e517d22efa1ca({
                        checked: isChecked
                    });
                    var hasCheckbox = false;
                    var replacedContent = content.map($kUMgi._elementsOfType($fcf129b7bd4ce72f$export$b14ad400b1d09e0f.text, function(text) {
                        if (text.value.length > 0 && !hasCheckbox) {
                            hasCheckbox = true;
                            return documentCheckbox;
                        } else return text;
                    }));
                    if (hasCheckbox) return replacedContent;
                    else return documentCheckbox;
                } else return content;
            });
        },
        "w:ins": readChildElements,
        "w:object": readChildElements,
        "w:smartTag": readChildElements,
        "w:drawing": readChildElements,
        "w:pict": function(element) {
            return readChildElements(element).toExtra();
        },
        "v:roundrect": readChildElements,
        "v:shape": readChildElements,
        "v:textbox": readChildElements,
        "w:txbxContent": readChildElements,
        "wp:inline": readDrawingElement,
        "wp:anchor": readDrawingElement,
        "v:imagedata": readImageData,
        "v:group": readChildElements,
        "v:rect": readChildElements
    };
    return {
        readXmlElement: readXmlElement,
        readXmlElements: readXmlElements
    };
    function readTable(element) {
        var propertiesResult = readTableProperties(element.firstOrEmpty("w:tblPr"));
        return readXmlElements(element.children).flatMap(calculateRowSpans).flatMap(function(children) {
            return propertiesResult.map(function(properties) {
                return $fcf129b7bd4ce72f$export$54ec01a60f47d33d(children, properties);
            });
        });
    }
    function readTableProperties(element) {
        return readTableStyle(element).map(function(style) {
            return {
                styleId: style.styleId,
                styleName: style.name
            };
        });
    }
    function readTableRow(element) {
        var properties = element.firstOrEmpty("w:trPr");
        // See 17.13.5.12 del (Deleted Table Row) of ECMA-376 4th edition Part 1
        var isDeleted = !!properties.first("w:del");
        if (isDeleted) return $5347e5b2a03f8fdd$var$emptyResult();
        var isHeader = !!properties.first("w:tblHeader");
        return readXmlElements(element.children).map(function(children) {
            return $fcf129b7bd4ce72f$export$b05581f4e764e162(children, {
                isHeader: isHeader
            });
        });
    }
    function readTableCell(element) {
        return readXmlElements(element.children).map(function(children) {
            var properties = element.firstOrEmpty("w:tcPr");
            var gridSpan = properties.firstOrEmpty("w:gridSpan").attributes["w:val"];
            var colSpan = gridSpan ? parseInt(gridSpan, 10) : 1;
            var cell = $fcf129b7bd4ce72f$export$1e4baea7053fc0e3(children, {
                colSpan: colSpan
            });
            cell._vMerge = readVMerge(properties);
            return cell;
        });
    }
    function readVMerge(properties) {
        var element = properties.first("w:vMerge");
        if (element) {
            var val = element.attributes["w:val"];
            return val === "continue" || !val;
        } else return null;
    }
    function calculateRowSpans(rows) {
        var unexpectedNonRows = $ctpBH.default(rows, function(row) {
            return row.type !== $fcf129b7bd4ce72f$export$b14ad400b1d09e0f.tableRow;
        });
        if (unexpectedNonRows) {
            removeVMergeProperties(rows);
            return $5347e5b2a03f8fdd$var$elementResultWithMessages(rows, [
                $5347e5b2a03f8fdd$require$warning("unexpected non-row element in table, cell merging may be incorrect")
            ]);
        }
        var unexpectedNonCells = $ctpBH.default(rows, function(row) {
            return $ctpBH.default(row.children, function(cell) {
                return cell.type !== $fcf129b7bd4ce72f$export$b14ad400b1d09e0f.tableCell;
            });
        });
        if (unexpectedNonCells) {
            removeVMergeProperties(rows);
            return $5347e5b2a03f8fdd$var$elementResultWithMessages(rows, [
                $5347e5b2a03f8fdd$require$warning("unexpected non-cell element in table row, cell merging may be incorrect")
            ]);
        }
        var columns = {};
        rows.forEach(function(row) {
            var cellIndex = 0;
            row.children.forEach(function(cell) {
                if (cell._vMerge && columns[cellIndex]) columns[cellIndex].rowSpan++;
                else {
                    columns[cellIndex] = cell;
                    cell._vMerge = false;
                }
                cellIndex += cell.colSpan;
            });
        });
        rows.forEach(function(row) {
            row.children = row.children.filter(function(cell) {
                return !cell._vMerge;
            });
            row.children.forEach(function(cell) {
                delete cell._vMerge;
            });
        });
        return $5347e5b2a03f8fdd$var$elementResult(rows);
    }
    function removeVMergeProperties(rows) {
        rows.forEach(function(row) {
            var cells = $kUMgi.getDescendantsOfType(row, $fcf129b7bd4ce72f$export$b14ad400b1d09e0f.tableCell);
            cells.forEach(function(cell) {
                delete cell._vMerge;
            });
        });
    }
    function readDrawingElement(element) {
        var blips = element.getElementsByTagName("a:graphic").getElementsByTagName("a:graphicData").getElementsByTagName("pic:pic").getElementsByTagName("pic:blipFill").getElementsByTagName("a:blip");
        return $5347e5b2a03f8fdd$var$combineResults(blips.map(readBlip.bind(null, element)));
    }
    function readBlip(element, blip) {
        var propertiesElement = element.firstOrEmpty("wp:docPr");
        var properties = propertiesElement.attributes;
        var altText = isBlank(properties.descr) ? properties.title : properties.descr;
        var blipImageFile = findBlipImageFile(blip);
        if (blipImageFile === null) return $5347e5b2a03f8fdd$var$emptyResultWithMessages([
            $5347e5b2a03f8fdd$require$warning("Could not find image file for a:blip element")
        ]);
        return readImage(blipImageFile, altText).map(function(imageElement) {
            var hlinkClickElement = propertiesElement.firstOrEmpty("a:hlinkClick");
            var relationshipId = hlinkClickElement.attributes["r:id"];
            if (relationshipId) {
                var href = relationships.findTargetByRelationshipId(relationshipId);
                return new $fcf129b7bd4ce72f$export$de48447bf377cd47([
                    imageElement
                ], {
                    href: href
                });
            } else return imageElement;
        });
    }
    function isBlank(value) {
        return value == null || /^\s*$/.test(value);
    }
    function findBlipImageFile(blip) {
        var embedRelationshipId = blip.attributes["r:embed"];
        var linkRelationshipId = blip.attributes["r:link"];
        if (embedRelationshipId) return findEmbeddedImageFile(embedRelationshipId);
        else if (linkRelationshipId) {
            var imagePath = relationships.findTargetByRelationshipId(linkRelationshipId);
            return {
                path: imagePath,
                read: files.read.bind(files, imagePath)
            };
        } else return null;
    }
    function readImageData(element) {
        var relationshipId = element.attributes['r:id'];
        if (relationshipId) return readImage(findEmbeddedImageFile(relationshipId), element.attributes["o:title"]);
        else return $5347e5b2a03f8fdd$var$emptyResultWithMessages([
            $5347e5b2a03f8fdd$require$warning("A v:imagedata element without a relationship ID was ignored")
        ]);
    }
    function findEmbeddedImageFile(relationshipId) {
        var path = $bff8c0b142852ddd$export$483b6ae7cde9cd77("word", relationships.findTargetByRelationshipId(relationshipId));
        return {
            path: path,
            read: docxFile.read.bind(docxFile, path)
        };
    }
    function readImage(imageFile, altText) {
        var contentType = contentTypes.findContentType(imageFile.path);
        var image = $fcf129b7bd4ce72f$export$3e431a229df88919({
            readImage: imageFile.read,
            altText: altText,
            contentType: contentType
        });
        var warnings = $5347e5b2a03f8fdd$var$supportedImageTypes[contentType] ? [] : $5347e5b2a03f8fdd$require$warning("Image of type " + contentType + " is unlikely to display in web browsers");
        return $5347e5b2a03f8fdd$var$elementResultWithMessages(image, warnings);
    }
    function undefinedStyleWarning(type, styleId) {
        return $5347e5b2a03f8fdd$require$warning(type + " style with ID " + styleId + " was referenced but not defined in the document");
    }
}
function $5347e5b2a03f8fdd$var$readNumberingProperties(styleId, element, numbering) {
    var level = element.firstOrEmpty("w:ilvl").attributes["w:val"];
    var numId = element.firstOrEmpty("w:numId").attributes["w:val"];
    if (level !== undefined && numId !== undefined) return numbering.findLevel(numId, level);
    if (styleId != null) {
        var levelByStyleId = numbering.findLevelByParagraphStyleId(styleId);
        if (levelByStyleId != null) return levelByStyleId;
    }
    // Some malformed documents define numbering levels without an index, and
    // reference the numbering using a w:numPr element without a w:ilvl child.
    // To handle such cases, we assume a level of 0 as a fallback.
    if (numId !== undefined) return numbering.findLevel(numId, "0");
    return null;
}
var $5347e5b2a03f8fdd$var$supportedImageTypes = {
    "image/png": true,
    "image/gif": true,
    "image/jpeg": true,
    "image/svg+xml": true,
    "image/tiff": true
};
var $5347e5b2a03f8fdd$var$ignoreElements = {
    "office-word:wrap": true,
    "v:shadow": true,
    "v:shapetype": true,
    "w:annotationRef": true,
    "w:bookmarkEnd": true,
    "w:sectPr": true,
    "w:proofErr": true,
    "w:lastRenderedPageBreak": true,
    "w:commentRangeStart": true,
    "w:commentRangeEnd": true,
    "w:del": true,
    "w:footnoteRef": true,
    "w:endnoteRef": true,
    "w:pPr": true,
    "w:rPr": true,
    "w:tblPr": true,
    "w:tblGrid": true,
    "w:trPr": true,
    "w:tcPr": true
};
function $5347e5b2a03f8fdd$var$emptyResultWithMessages(messages) {
    return new $5347e5b2a03f8fdd$var$ReadResult(null, null, messages);
}
function $5347e5b2a03f8fdd$var$emptyResult() {
    return new $5347e5b2a03f8fdd$var$ReadResult(null);
}
function $5347e5b2a03f8fdd$var$elementResult(element) {
    return new $5347e5b2a03f8fdd$var$ReadResult(element);
}
function $5347e5b2a03f8fdd$var$elementResultWithMessages(element, messages) {
    return new $5347e5b2a03f8fdd$var$ReadResult(element, null, messages);
}
function $5347e5b2a03f8fdd$var$ReadResult(element, extra, messages) {
    this.value = element || [];
    this.extra = extra || [];
    this._result = new $5347e5b2a03f8fdd$require$Result({
        element: this.value,
        extra: extra
    }, messages);
    this.messages = this._result.messages;
}
$5347e5b2a03f8fdd$var$ReadResult.prototype.toExtra = function() {
    return new $5347e5b2a03f8fdd$var$ReadResult(null, $5347e5b2a03f8fdd$var$joinElements(this.extra, this.value), this.messages);
};
$5347e5b2a03f8fdd$var$ReadResult.prototype.insertExtra = function() {
    var extra = this.extra;
    if (extra && extra.length) return new $5347e5b2a03f8fdd$var$ReadResult($5347e5b2a03f8fdd$var$joinElements(this.value, extra), null, this.messages);
    else return this;
};
$5347e5b2a03f8fdd$var$ReadResult.prototype.map = function(func) {
    var result = this._result.map(function(value) {
        return func(value.element);
    });
    return new $5347e5b2a03f8fdd$var$ReadResult(result.value, this.extra, result.messages);
};
$5347e5b2a03f8fdd$var$ReadResult.prototype.flatMap = function(func) {
    var result = this._result.flatMap(function(value) {
        return func(value.element)._result;
    });
    return new $5347e5b2a03f8fdd$var$ReadResult(result.value.element, $5347e5b2a03f8fdd$var$joinElements(this.extra, result.value.extra), result.messages);
};
$5347e5b2a03f8fdd$var$ReadResult.map = function(first, second, func) {
    return new $5347e5b2a03f8fdd$var$ReadResult(func(first.value, second.value), $5347e5b2a03f8fdd$var$joinElements(first.extra, second.extra), first.messages.concat(second.messages));
};
function $5347e5b2a03f8fdd$var$combineResults(results) {
    var result = $5347e5b2a03f8fdd$require$Result.combine($gS9W9.default(results, "_result"));
    return new $5347e5b2a03f8fdd$var$ReadResult($1TwZj.default($gS9W9.default(result.value, "element")), $efEt3.default($1TwZj.default($gS9W9.default(result.value, "extra")), $5347e5b2a03f8fdd$var$identity), result.messages);
}
function $5347e5b2a03f8fdd$var$joinElements(first, second) {
    return $1TwZj.default([
        first,
        second
    ]);
}
function $5347e5b2a03f8fdd$var$identity(value) {
    return value;
}


var $bae7c73ea3cda3cb$require$createBodyReader = $5347e5b2a03f8fdd$export$ca2bb6f0ea38a00f;
var $a83ff935f6e84a85$export$ff28ea179c35f727;
$a83ff935f6e84a85$export$ff28ea179c35f727 = $a83ff935f6e84a85$var$DocumentXmlReader;


var $a83ff935f6e84a85$require$Result = $11d28a8fc8838027$export$8fdcabde73f49165;
function $a83ff935f6e84a85$var$DocumentXmlReader(options) {
    var bodyReader = options.bodyReader;
    function convertXmlToDocument(element) {
        var body = element.first("w:body");
        if (body == null) throw new Error("Could not find the body element: are you sure this is a docx file?");
        var result = bodyReader.readXmlElements(body.children).map(function(children) {
            return new $fcf129b7bd4ce72f$export$b34a105447964f9f(children, {
                notes: options.notes,
                comments: options.comments
            });
        });
        return new $a83ff935f6e84a85$require$Result(result.value, result.messages);
    }
    return {
        convertXmlToDocument: convertXmlToDocument
    };
}


var $bae7c73ea3cda3cb$require$DocumentXmlReader = $a83ff935f6e84a85$export$ff28ea179c35f727;
var $b695b801102bb06f$export$caf6d0f1ae2fd4d5;
var $b695b801102bb06f$export$1a01ae0705bafd37;
var $b695b801102bb06f$export$ddbf7887bc0aa836;
$b695b801102bb06f$export$caf6d0f1ae2fd4d5 = $b695b801102bb06f$var$readRelationships;
$b695b801102bb06f$export$1a01ae0705bafd37 = new $b695b801102bb06f$var$Relationships([]);
$b695b801102bb06f$export$ddbf7887bc0aa836 = $b695b801102bb06f$var$Relationships;
function $b695b801102bb06f$var$readRelationships(element) {
    var relationships = [];
    element.children.forEach(function(child) {
        if (child.name === "relationships:Relationship") {
            var relationship = {
                relationshipId: child.attributes.Id,
                target: child.attributes.Target,
                type: child.attributes.Type
            };
            relationships.push(relationship);
        }
    });
    return new $b695b801102bb06f$var$Relationships(relationships);
}
function $b695b801102bb06f$var$Relationships(relationships) {
    var targetsByRelationshipId = {};
    relationships.forEach(function(relationship) {
        targetsByRelationshipId[relationship.relationshipId] = relationship.target;
    });
    var targetsByType = {};
    relationships.forEach(function(relationship) {
        if (!targetsByType[relationship.type]) targetsByType[relationship.type] = [];
        targetsByType[relationship.type].push(relationship.target);
    });
    return {
        findTargetByRelationshipId: function(relationshipId) {
            return targetsByRelationshipId[relationshipId];
        },
        findTargetsByType: function(type) {
            return targetsByType[type] || [];
        }
    };
}


var $db8eecfa38181f3c$export$c97a5c0bc99ab2ff;
var $db8eecfa38181f3c$export$dcc72562f777bfbb;
$db8eecfa38181f3c$export$c97a5c0bc99ab2ff = $db8eecfa38181f3c$var$readContentTypesFromXml;
var $db8eecfa38181f3c$var$fallbackContentTypes = {
    "png": "png",
    "gif": "gif",
    "jpeg": "jpeg",
    "jpg": "jpeg",
    "tif": "tiff",
    "tiff": "tiff",
    "bmp": "bmp"
};
$db8eecfa38181f3c$export$dcc72562f777bfbb = $db8eecfa38181f3c$var$contentTypes({}, {});
function $db8eecfa38181f3c$var$readContentTypesFromXml(element) {
    var extensionDefaults = {};
    var overrides = {};
    element.children.forEach(function(child) {
        if (child.name === "content-types:Default") extensionDefaults[child.attributes.Extension] = child.attributes.ContentType;
        if (child.name === "content-types:Override") {
            var name = child.attributes.PartName;
            if (name.charAt(0) === "/") name = name.substring(1);
            overrides[name] = child.attributes.ContentType;
        }
    });
    return $db8eecfa38181f3c$var$contentTypes(overrides, extensionDefaults);
}
function $db8eecfa38181f3c$var$contentTypes(overrides, extensionDefaults) {
    return {
        findContentType: function(path) {
            var overrideContentType = overrides[path];
            if (overrideContentType) return overrideContentType;
            else {
                var pathParts = path.split(".");
                var extension = pathParts[pathParts.length - 1];
                if (extensionDefaults.hasOwnProperty(extension)) return extensionDefaults[extension];
                else {
                    var fallback = $db8eecfa38181f3c$var$fallbackContentTypes[extension.toLowerCase()];
                    if (fallback) return "image/" + fallback;
                    else return null;
                }
            }
        }
    };
}


var $51193c930ee97617$export$740149d4d5c5888e;
var $51193c930ee97617$export$521a466b2293b1d9;
var $51193c930ee97617$export$4a4adb64dd5d0f9b;
parcelRequire("9jAvV");
var $1TwZj = parcelRequire("1TwZj");
var $bJcvr = parcelRequire("bJcvr");
var $gNJrf = parcelRequire("gNJrf");
$51193c930ee97617$export$740149d4d5c5888e = $51193c930ee97617$var$readNumberingXml;
$51193c930ee97617$export$521a466b2293b1d9 = $51193c930ee97617$var$Numbering;
$51193c930ee97617$export$4a4adb64dd5d0f9b = new $51193c930ee97617$var$Numbering({}, {});
function $51193c930ee97617$var$Numbering(nums, abstractNums, styles) {
    var allLevels = $1TwZj.default($gNJrf.default(abstractNums).map(function(abstractNum) {
        return $gNJrf.default(abstractNum.levels);
    }));
    var levelsByParagraphStyleId = $bJcvr.default(allLevels.filter(function(level) {
        return level.paragraphStyleId != null;
    }), "paragraphStyleId");
    function findLevel(numId, level) {
        var num = nums[numId];
        if (num) {
            var abstractNum = abstractNums[num.abstractNumId];
            if (!abstractNum) return null;
            else if (abstractNum.numStyleLink == null) return abstractNums[num.abstractNumId].levels[level];
            else {
                var style = styles.findNumberingStyleById(abstractNum.numStyleLink);
                return findLevel(style.numId, level);
            }
        } else return null;
    }
    function findLevelByParagraphStyleId(styleId) {
        return levelsByParagraphStyleId[styleId] || null;
    }
    return {
        findLevel: findLevel,
        findLevelByParagraphStyleId: findLevelByParagraphStyleId
    };
}
function $51193c930ee97617$var$readNumberingXml(root, options) {
    if (!options || !options.styles) throw new Error("styles is missing");
    var abstractNums = $51193c930ee97617$var$readAbstractNums(root);
    var nums = $51193c930ee97617$var$readNums(root, abstractNums);
    return new $51193c930ee97617$var$Numbering(nums, abstractNums, options.styles);
}
function $51193c930ee97617$var$readAbstractNums(root) {
    var abstractNums = {};
    root.getElementsByTagName("w:abstractNum").forEach(function(element) {
        var id = element.attributes["w:abstractNumId"];
        abstractNums[id] = $51193c930ee97617$var$readAbstractNum(element);
    });
    return abstractNums;
}
function $51193c930ee97617$var$readAbstractNum(element) {
    var levels = {};
    // Some malformed documents define numbering levels without an index, and
    // reference the numbering using a w:numPr element without a w:ilvl child.
    // To handle such cases, we assume a level of 0 as a fallback.
    var levelWithoutIndex = null;
    element.getElementsByTagName("w:lvl").forEach(function(levelElement) {
        var levelIndex = levelElement.attributes["w:ilvl"];
        var numFmt = levelElement.firstOrEmpty("w:numFmt").attributes["w:val"];
        var isOrdered = numFmt !== "bullet";
        var paragraphStyleId = levelElement.firstOrEmpty("w:pStyle").attributes["w:val"];
        if (levelIndex === undefined) levelWithoutIndex = {
            isOrdered: isOrdered,
            level: "0",
            paragraphStyleId: paragraphStyleId
        };
        else levels[levelIndex] = {
            isOrdered: isOrdered,
            level: levelIndex,
            paragraphStyleId: paragraphStyleId
        };
    });
    if (levelWithoutIndex !== null && levels[levelWithoutIndex.level] === undefined) levels[levelWithoutIndex.level] = levelWithoutIndex;
    var numStyleLink = element.firstOrEmpty("w:numStyleLink").attributes["w:val"];
    return {
        levels: levels,
        numStyleLink: numStyleLink
    };
}
function $51193c930ee97617$var$readNums(root) {
    var nums = {};
    root.getElementsByTagName("w:num").forEach(function(element) {
        var numId = element.attributes["w:numId"];
        var abstractNumId = element.first("w:abstractNumId").attributes["w:val"];
        nums[numId] = {
            abstractNumId: abstractNumId
        };
    });
    return nums;
}


var $b032473a280dcb14$export$b4a897ae7d66dcc8;
var $b032473a280dcb14$export$e155666bf54a9f18;
var $b032473a280dcb14$export$214b055320e0bf32;
$b032473a280dcb14$export$b4a897ae7d66dcc8 = $b032473a280dcb14$var$readStylesXml;
$b032473a280dcb14$export$e155666bf54a9f18 = $b032473a280dcb14$var$Styles;
$b032473a280dcb14$export$214b055320e0bf32 = new $b032473a280dcb14$var$Styles({}, {});
function $b032473a280dcb14$var$Styles(paragraphStyles, characterStyles, tableStyles, numberingStyles) {
    return {
        findParagraphStyleById: function(styleId) {
            return paragraphStyles[styleId];
        },
        findCharacterStyleById: function(styleId) {
            return characterStyles[styleId];
        },
        findTableStyleById: function(styleId) {
            return tableStyles[styleId];
        },
        findNumberingStyleById: function(styleId) {
            return numberingStyles[styleId];
        }
    };
}
$b032473a280dcb14$var$Styles.EMPTY = new $b032473a280dcb14$var$Styles({}, {}, {}, {});
function $b032473a280dcb14$var$readStylesXml(root) {
    var paragraphStyles = {};
    var characterStyles = {};
    var tableStyles = {};
    var numberingStyles = {};
    var styles = {
        "paragraph": paragraphStyles,
        "character": characterStyles,
        "table": tableStyles,
        "numbering": numberingStyles
    };
    root.getElementsByTagName("w:style").forEach(function(styleElement) {
        var style = $b032473a280dcb14$var$readStyleElement(styleElement);
        var styleSet = styles[style.type];
        // Per 17.7.4.17 style (Style Definition) of ECMA-376 4th edition Part 1:
        //
        // > If multiple style definitions each declare the same value for their
        // > styleId, then the first such instance shall keep its current
        // > identifier with all other instances being reassigned in any manner
        // > desired.
        //
        // For the purpose of conversion, there's no point holding onto styles
        // with reassigned style IDs, so we ignore such style definitions.
        if (styleSet && styleSet[style.styleId] === undefined) styleSet[style.styleId] = style;
    });
    return new $b032473a280dcb14$var$Styles(paragraphStyles, characterStyles, tableStyles, numberingStyles);
}
function $b032473a280dcb14$var$readStyleElement(styleElement) {
    var type = styleElement.attributes["w:type"];
    if (type === "numbering") return $b032473a280dcb14$var$readNumberingStyleElement(type, styleElement);
    else {
        var styleId = $b032473a280dcb14$var$readStyleId(styleElement);
        var name = $b032473a280dcb14$var$styleName(styleElement);
        return {
            type: type,
            styleId: styleId,
            name: name
        };
    }
}
function $b032473a280dcb14$var$styleName(styleElement) {
    var nameElement = styleElement.first("w:name");
    return nameElement ? nameElement.attributes["w:val"] : null;
}
function $b032473a280dcb14$var$readNumberingStyleElement(type, styleElement) {
    var styleId = $b032473a280dcb14$var$readStyleId(styleElement);
    var numId = styleElement.firstOrEmpty("w:pPr").firstOrEmpty("w:numPr").firstOrEmpty("w:numId").attributes["w:val"];
    return {
        type: type,
        numId: numId,
        styleId: styleId
    };
}
function $b032473a280dcb14$var$readStyleId(styleElement) {
    return styleElement.attributes["w:styleId"];
}


var $1c34a1a3e6be79f6$exports = {};


var $1c34a1a3e6be79f6$require$Result = $11d28a8fc8838027$export$8fdcabde73f49165;
$1c34a1a3e6be79f6$exports.createFootnotesReader = $1c34a1a3e6be79f6$var$createReader.bind($1c34a1a3e6be79f6$exports, "footnote");
$1c34a1a3e6be79f6$exports.createEndnotesReader = $1c34a1a3e6be79f6$var$createReader.bind($1c34a1a3e6be79f6$exports, "endnote");
function $1c34a1a3e6be79f6$var$createReader(noteType, bodyReader) {
    function readNotesXml(element) {
        return $1c34a1a3e6be79f6$require$Result.combine(element.getElementsByTagName("w:" + noteType).filter(isFootnoteElement).map(readFootnoteElement));
    }
    function isFootnoteElement(element) {
        var type = element.attributes["w:type"];
        return type !== "continuationSeparator" && type !== "separator";
    }
    function readFootnoteElement(footnoteElement) {
        var id = footnoteElement.attributes["w:id"];
        return bodyReader.readXmlElements(footnoteElement.children).map(function(body) {
            return $fcf129b7bd4ce72f$export$6c88bf799aca3d2b({
                noteType: noteType,
                noteId: id,
                body: body
            });
        });
    }
    return readNotesXml;
}


var $e810972ec6083c30$export$b170a9283c83e921;


var $e810972ec6083c30$require$Result = $11d28a8fc8838027$export$8fdcabde73f49165;
function $e810972ec6083c30$var$createCommentsReader(bodyReader) {
    function readCommentsXml(element) {
        return $e810972ec6083c30$require$Result.combine(element.getElementsByTagName("w:comment").map(readCommentElement));
    }
    function readCommentElement(element) {
        var id = element.attributes["w:id"];
        function readOptionalAttribute(name) {
            return (element.attributes[name] || "").trim() || null;
        }
        return bodyReader.readXmlElements(element.children).map(function(body) {
            return $fcf129b7bd4ce72f$export$4a34f930e789283c({
                commentId: id,
                body: body,
                authorName: readOptionalAttribute("w:author"),
                authorInitials: readOptionalAttribute("w:initials")
            });
        });
    }
    return readCommentsXml;
}
$e810972ec6083c30$export$b170a9283c83e921 = $e810972ec6083c30$var$createCommentsReader;


var $9dc11ffa63e79aa5$export$9330ab61a7e5c11b;

var $d93yU = parcelRequire("d93yU");
$9dc11ffa63e79aa5$export$9330ab61a7e5c11b = $9dc11ffa63e79aa5$var$Files;
function $9dc11ffa63e79aa5$var$Files() {
    function read(uri) {
        return $d93yU.reject(new Error("could not open external image: '" + uri + "'\ncannot open linked files from a web browser"));
    }
    return {
        read: read
    };
}


var $bae7c73ea3cda3cb$require$Files = $9dc11ffa63e79aa5$export$9330ab61a7e5c11b;
function $bae7c73ea3cda3cb$var$read(docxFile, input, options) {
    input = input || {};
    options = options || {};
    var files = new $bae7c73ea3cda3cb$require$Files({
        externalFileAccess: options.externalFileAccess,
        relativeToFile: input.path
    });
    return $d93yU.props({
        contentTypes: $bae7c73ea3cda3cb$var$readContentTypesFromZipFile(docxFile),
        partPaths: $bae7c73ea3cda3cb$var$findPartPaths(docxFile),
        docxFile: docxFile,
        files: files
    }).also(function(result) {
        return {
            styles: $bae7c73ea3cda3cb$var$readStylesFromZipFile(docxFile, result.partPaths.styles)
        };
    }).also(function(result) {
        return {
            numbering: $bae7c73ea3cda3cb$var$readNumberingFromZipFile(docxFile, result.partPaths.numbering, result.styles)
        };
    }).also(function(result) {
        return {
            footnotes: $bae7c73ea3cda3cb$var$readXmlFileWithBody(result.partPaths.footnotes, result, function(bodyReader, xml) {
                if (xml) return $1c34a1a3e6be79f6$exports.createFootnotesReader(bodyReader)(xml);
                else return new $bae7c73ea3cda3cb$require$Result([]);
            }),
            endnotes: $bae7c73ea3cda3cb$var$readXmlFileWithBody(result.partPaths.endnotes, result, function(bodyReader, xml) {
                if (xml) return $1c34a1a3e6be79f6$exports.createEndnotesReader(bodyReader)(xml);
                else return new $bae7c73ea3cda3cb$require$Result([]);
            }),
            comments: $bae7c73ea3cda3cb$var$readXmlFileWithBody(result.partPaths.comments, result, function(bodyReader, xml) {
                if (xml) return $e810972ec6083c30$export$b170a9283c83e921(bodyReader)(xml);
                else return new $bae7c73ea3cda3cb$require$Result([]);
            })
        };
    }).also(function(result) {
        return {
            notes: result.footnotes.flatMap(function(footnotes) {
                return result.endnotes.map(function(endnotes) {
                    return new $fcf129b7bd4ce72f$export$aa31b211d2f4c3af(footnotes.concat(endnotes));
                });
            })
        };
    }).then(function(result) {
        return $bae7c73ea3cda3cb$var$readXmlFileWithBody(result.partPaths.mainDocument, result, function(bodyReader, xml) {
            return result.notes.flatMap(function(notes) {
                return result.comments.flatMap(function(comments) {
                    var reader = new $bae7c73ea3cda3cb$require$DocumentXmlReader({
                        bodyReader: bodyReader,
                        notes: notes,
                        comments: comments
                    });
                    return reader.convertXmlToDocument(xml);
                });
            });
        });
    });
}
function $bae7c73ea3cda3cb$var$findPartPaths(docxFile) {
    return $bae7c73ea3cda3cb$var$readPackageRelationships(docxFile).then(function(packageRelationships) {
        var mainDocumentPath = $bae7c73ea3cda3cb$var$findPartPath({
            docxFile: docxFile,
            relationships: packageRelationships,
            relationshipType: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/officeDocument",
            basePath: "",
            fallbackPath: "word/document.xml"
        });
        if (!docxFile.exists(mainDocumentPath)) throw new Error("Could not find main document part. Are you sure this is a valid .docx file?");
        return $bae7c73ea3cda3cb$var$xmlFileReader({
            filename: $bae7c73ea3cda3cb$var$relationshipsFilename(mainDocumentPath),
            readElement: $b695b801102bb06f$export$caf6d0f1ae2fd4d5,
            defaultValue: $b695b801102bb06f$export$1a01ae0705bafd37
        })(docxFile).then(function(documentRelationships) {
            function findPartRelatedToMainDocument(name) {
                return $bae7c73ea3cda3cb$var$findPartPath({
                    docxFile: docxFile,
                    relationships: documentRelationships,
                    relationshipType: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/" + name,
                    basePath: $3e56e634a929bca6$export$824c337f43f2b64d(mainDocumentPath).dirname,
                    fallbackPath: "word/" + name + ".xml"
                });
            }
            return {
                mainDocument: mainDocumentPath,
                comments: findPartRelatedToMainDocument("comments"),
                endnotes: findPartRelatedToMainDocument("endnotes"),
                footnotes: findPartRelatedToMainDocument("footnotes"),
                numbering: findPartRelatedToMainDocument("numbering"),
                styles: findPartRelatedToMainDocument("styles")
            };
        });
    });
}
function $bae7c73ea3cda3cb$var$findPartPath(options) {
    var docxFile = options.docxFile;
    var relationships = options.relationships;
    var relationshipType = options.relationshipType;
    var basePath = options.basePath;
    var fallbackPath = options.fallbackPath;
    var targets = relationships.findTargetsByType(relationshipType);
    var normalisedTargets = targets.map(function(target) {
        return $bae7c73ea3cda3cb$var$stripPrefix($3e56e634a929bca6$export$b891921babc70093(basePath, target), "/");
    });
    var validTargets = normalisedTargets.filter(function(target) {
        return docxFile.exists(target);
    });
    if (validTargets.length === 0) return fallbackPath;
    else return validTargets[0];
}
function $bae7c73ea3cda3cb$var$stripPrefix(value, prefix) {
    if (value.substring(0, prefix.length) === prefix) return value.substring(prefix.length);
    else return value;
}
function $bae7c73ea3cda3cb$var$xmlFileReader(options) {
    return function(zipFile) {
        return $bae7c73ea3cda3cb$require$readXmlFromZipFile(zipFile, options.filename).then(function(element) {
            return element ? options.readElement(element) : options.defaultValue;
        });
    };
}
function $bae7c73ea3cda3cb$var$readXmlFileWithBody(filename, options, func) {
    var readRelationshipsFromZipFile = $bae7c73ea3cda3cb$var$xmlFileReader({
        filename: $bae7c73ea3cda3cb$var$relationshipsFilename(filename),
        readElement: $b695b801102bb06f$export$caf6d0f1ae2fd4d5,
        defaultValue: $b695b801102bb06f$export$1a01ae0705bafd37
    });
    return readRelationshipsFromZipFile(options.docxFile).then(function(relationships) {
        var bodyReader = new $bae7c73ea3cda3cb$require$createBodyReader({
            relationships: relationships,
            contentTypes: options.contentTypes,
            docxFile: options.docxFile,
            numbering: options.numbering,
            styles: options.styles,
            files: options.files
        });
        return $bae7c73ea3cda3cb$require$readXmlFromZipFile(options.docxFile, filename).then(function(xml) {
            return func(bodyReader, xml);
        });
    });
}
function $bae7c73ea3cda3cb$var$relationshipsFilename(filename) {
    var split = $3e56e634a929bca6$export$824c337f43f2b64d(filename);
    return $3e56e634a929bca6$export$b891921babc70093(split.dirname, "_rels", split.basename + ".rels");
}
var $bae7c73ea3cda3cb$var$readContentTypesFromZipFile = $bae7c73ea3cda3cb$var$xmlFileReader({
    filename: "[Content_Types].xml",
    readElement: $db8eecfa38181f3c$export$c97a5c0bc99ab2ff,
    defaultValue: $db8eecfa38181f3c$export$dcc72562f777bfbb
});
function $bae7c73ea3cda3cb$var$readNumberingFromZipFile(zipFile, path, styles) {
    return $bae7c73ea3cda3cb$var$xmlFileReader({
        filename: path,
        readElement: function(element) {
            return $51193c930ee97617$export$740149d4d5c5888e(element, {
                styles: styles
            });
        },
        defaultValue: $51193c930ee97617$export$4a4adb64dd5d0f9b
    })(zipFile);
}
function $bae7c73ea3cda3cb$var$readStylesFromZipFile(zipFile, path) {
    return $bae7c73ea3cda3cb$var$xmlFileReader({
        filename: path,
        readElement: $b032473a280dcb14$export$b4a897ae7d66dcc8,
        defaultValue: $b032473a280dcb14$export$214b055320e0bf32
    })(zipFile);
}
var $bae7c73ea3cda3cb$var$readPackageRelationships = $bae7c73ea3cda3cb$var$xmlFileReader({
    filename: "_rels/.rels",
    readElement: $b695b801102bb06f$export$caf6d0f1ae2fd4d5,
    defaultValue: $b695b801102bb06f$export$1a01ae0705bafd37
});


var $8adee3ad65dc46ae$export$f183c412da6b1c0;
var $8adee3ad65dc46ae$export$98fd944a2c837b93;
parcelRequire("9jAvV");
var $bss2W = parcelRequire("bss2W");

var $d93yU = parcelRequire("d93yU");

$8adee3ad65dc46ae$export$f183c412da6b1c0 = $8adee3ad65dc46ae$var$writeStyleMap;
$8adee3ad65dc46ae$export$98fd944a2c837b93 = $8adee3ad65dc46ae$var$readStyleMap;
var $8adee3ad65dc46ae$var$schema = "http://schemas.zwobble.org/mammoth/style-map";
var $8adee3ad65dc46ae$var$styleMapPath = "mammoth/style-map";
var $8adee3ad65dc46ae$var$styleMapAbsolutePath = "/" + $8adee3ad65dc46ae$var$styleMapPath;
function $8adee3ad65dc46ae$var$writeStyleMap(docxFile, styleMap) {
    docxFile.write($8adee3ad65dc46ae$var$styleMapPath, styleMap);
    return $8adee3ad65dc46ae$var$updateRelationships(docxFile).then(function() {
        return $8adee3ad65dc46ae$var$updateContentTypes(docxFile);
    });
}
function $8adee3ad65dc46ae$var$updateRelationships(docxFile) {
    var path = "word/_rels/document.xml.rels";
    var relationshipsUri = "http://schemas.openxmlformats.org/package/2006/relationships";
    var relationshipElementName = "{" + relationshipsUri + "}Relationship";
    return docxFile.read(path, "utf8").then($aea06b742aa725d8$export$dda73877cb166cd3).then(function(relationshipsContainer) {
        var relationships = relationshipsContainer.children;
        $8adee3ad65dc46ae$var$addOrUpdateElement(relationships, relationshipElementName, "Id", {
            "Id": "rMammothStyleMap",
            "Type": $8adee3ad65dc46ae$var$schema,
            "Target": $8adee3ad65dc46ae$var$styleMapAbsolutePath
        });
        var namespaces = {
            "": relationshipsUri
        };
        return docxFile.write(path, $aea06b742aa725d8$export$48a3ce3d8cfe0ce1(relationshipsContainer, namespaces));
    });
}
function $8adee3ad65dc46ae$var$updateContentTypes(docxFile) {
    var path = "[Content_Types].xml";
    var contentTypesUri = "http://schemas.openxmlformats.org/package/2006/content-types";
    var overrideName = "{" + contentTypesUri + "}Override";
    return docxFile.read(path, "utf8").then($aea06b742aa725d8$export$dda73877cb166cd3).then(function(typesElement) {
        var children = typesElement.children;
        $8adee3ad65dc46ae$var$addOrUpdateElement(children, overrideName, "PartName", {
            "PartName": $8adee3ad65dc46ae$var$styleMapAbsolutePath,
            "ContentType": "text/prs.mammoth.style-map"
        });
        var namespaces = {
            "": contentTypesUri
        };
        return docxFile.write(path, $aea06b742aa725d8$export$48a3ce3d8cfe0ce1(typesElement, namespaces));
    });
}
function $8adee3ad65dc46ae$var$addOrUpdateElement(elements, name, identifyingAttribute, attributes) {
    var existingElement = $bss2W.default(elements, function(element) {
        return element.name === name && element.attributes[identifyingAttribute] === attributes[identifyingAttribute];
    });
    if (existingElement) existingElement.attributes = attributes;
    else elements.push($aea06b742aa725d8$export$8454457683f90105(name, attributes));
}
function $8adee3ad65dc46ae$var$readStyleMap(docxFile) {
    if (docxFile.exists($8adee3ad65dc46ae$var$styleMapPath)) return docxFile.read($8adee3ad65dc46ae$var$styleMapPath, "utf8");
    else return $d93yU.resolve(null);
}


var $67e37fd9055aa0c3$export$d10d7ab91c778d60;
var $67e37fd9055aa0c3$export$6e29e379a5b99e3b;
parcelRequire("9jAvV");
var $5yjjJ = parcelRequire("5yjjJ");
var $e2Yic = parcelRequire("e2Yic");
var $1TwZj = parcelRequire("1TwZj");
var $bJcvr = parcelRequire("bJcvr");

var $d93yU = parcelRequire("d93yU");


var $hEvL6 = parcelRequire("hEvL6");


var $gOpjt = parcelRequire("gOpjt");

var $8eobO = parcelRequire("8eobO");
var $748ebd993e5bc6b9$export$47a3d634abc09f70;
var $6c31025a874fb8d1$export$47a3d634abc09f70;
parcelRequire("9jAvV");
var $gfTwJ = parcelRequire("gfTwJ");
var $ctpBH = parcelRequire("ctpBH");
$6c31025a874fb8d1$export$47a3d634abc09f70 = $6c31025a874fb8d1$var$writer;
function $6c31025a874fb8d1$var$writer(options) {
    options = options || {};
    if (options.prettyPrint) return $6c31025a874fb8d1$var$prettyWriter();
    else return $6c31025a874fb8d1$var$simpleWriter();
}
var $6c31025a874fb8d1$var$indentedElements = {
    div: true,
    p: true,
    ul: true,
    li: true
};
function $6c31025a874fb8d1$var$prettyWriter() {
    var indentationLevel = 0;
    var indentation = "  ";
    var stack = [];
    var start = true;
    var inText = false;
    var writer = $6c31025a874fb8d1$var$simpleWriter();
    function open(tagName, attributes) {
        if ($6c31025a874fb8d1$var$indentedElements[tagName]) indent();
        stack.push(tagName);
        writer.open(tagName, attributes);
        if ($6c31025a874fb8d1$var$indentedElements[tagName]) indentationLevel++;
        start = false;
    }
    function close(tagName) {
        if ($6c31025a874fb8d1$var$indentedElements[tagName]) {
            indentationLevel--;
            indent();
        }
        stack.pop();
        writer.close(tagName);
    }
    function text(value) {
        startText();
        var text = isInPre() ? value : value.replace("\n", "\n" + indentation);
        writer.text(text);
    }
    function selfClosing(tagName, attributes) {
        indent();
        writer.selfClosing(tagName, attributes);
    }
    function insideIndentedElement() {
        return stack.length === 0 || $6c31025a874fb8d1$var$indentedElements[stack[stack.length - 1]];
    }
    function startText() {
        if (!inText) {
            indent();
            inText = true;
        }
    }
    function indent() {
        inText = false;
        if (!start && insideIndentedElement() && !isInPre()) {
            writer._append("\n");
            for(var i = 0; i < indentationLevel; i++)writer._append(indentation);
        }
    }
    function isInPre() {
        return $ctpBH.default(stack, function(tagName) {
            return tagName === "pre";
        });
    }
    return {
        asString: writer.asString,
        open: open,
        close: close,
        text: text,
        selfClosing: selfClosing
    };
}
function $6c31025a874fb8d1$var$simpleWriter() {
    var fragments = [];
    function open(tagName, attributes) {
        var attributeString = generateAttributeString(attributes);
        fragments.push("<" + tagName + attributeString + ">");
    }
    function close(tagName) {
        fragments.push("</" + tagName + ">");
    }
    function selfClosing(tagName, attributes) {
        var attributeString = generateAttributeString(attributes);
        fragments.push("<" + tagName + attributeString + " />");
    }
    function generateAttributeString(attributes) {
        return $gfTwJ.default(attributes, function(value, key) {
            return " " + key + '="' + $6c31025a874fb8d1$var$escapeHtmlAttribute(value) + '"';
        }).join("");
    }
    function text(value) {
        fragments.push($6c31025a874fb8d1$var$escapeHtmlText(value));
    }
    function append(html) {
        fragments.push(html);
    }
    function asString() {
        return fragments.join("");
    }
    return {
        asString: asString,
        open: open,
        close: close,
        text: text,
        selfClosing: selfClosing,
        _append: append
    };
}
function $6c31025a874fb8d1$var$escapeHtmlText(value) {
    return value.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
}
function $6c31025a874fb8d1$var$escapeHtmlAttribute(value) {
    return value.replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
}


var $8b2cdf0352c3ba1f$export$47a3d634abc09f70;
parcelRequire("9jAvV");
var $ciHuQ = parcelRequire("ciHuQ");
function $8b2cdf0352c3ba1f$var$symmetricMarkdownElement(end) {
    return $8b2cdf0352c3ba1f$var$markdownElement(end, end);
}
function $8b2cdf0352c3ba1f$var$markdownElement(start, end) {
    return function() {
        return {
            start: start,
            end: end
        };
    };
}
function $8b2cdf0352c3ba1f$var$markdownLink(attributes) {
    var href = attributes.href || "";
    if (href) return {
        start: "[",
        end: "](" + href + ")",
        anchorPosition: "before"
    };
    else return {};
}
function $8b2cdf0352c3ba1f$var$markdownImage(attributes) {
    var src = attributes.src || "";
    var altText = attributes.alt || "";
    if (src || altText) return {
        start: "![" + altText + "](" + src + ")"
    };
    else return {};
}
function $8b2cdf0352c3ba1f$var$markdownList(options) {
    return function(attributes, list) {
        return {
            start: list ? "\n" : "",
            end: list ? "" : "\n",
            list: {
                isOrdered: options.isOrdered,
                indent: list ? list.indent + 1 : 0,
                count: 0
            }
        };
    };
}
function $8b2cdf0352c3ba1f$var$markdownListItem(attributes, list, listItem) {
    list = list || {
        indent: 0,
        isOrdered: false,
        count: 0
    };
    list.count++;
    listItem.hasClosed = false;
    var bullet = list.isOrdered ? list.count + "." : "-";
    var start = $8b2cdf0352c3ba1f$var$repeatString("\t", list.indent) + bullet + " ";
    return {
        start: start,
        end: function() {
            if (!listItem.hasClosed) {
                listItem.hasClosed = true;
                return "\n";
            }
        }
    };
}
var $8b2cdf0352c3ba1f$var$htmlToMarkdown = {
    "p": $8b2cdf0352c3ba1f$var$markdownElement("", "\n\n"),
    "br": $8b2cdf0352c3ba1f$var$markdownElement("", "  \n"),
    "ul": $8b2cdf0352c3ba1f$var$markdownList({
        isOrdered: false
    }),
    "ol": $8b2cdf0352c3ba1f$var$markdownList({
        isOrdered: true
    }),
    "li": $8b2cdf0352c3ba1f$var$markdownListItem,
    "strong": $8b2cdf0352c3ba1f$var$symmetricMarkdownElement("__"),
    "em": $8b2cdf0352c3ba1f$var$symmetricMarkdownElement("*"),
    "a": $8b2cdf0352c3ba1f$var$markdownLink,
    "img": $8b2cdf0352c3ba1f$var$markdownImage
};
(function() {
    for(var i = 1; i <= 6; i++)$8b2cdf0352c3ba1f$var$htmlToMarkdown["h" + i] = $8b2cdf0352c3ba1f$var$markdownElement($8b2cdf0352c3ba1f$var$repeatString("#", i) + " ", "\n\n");
})();
function $8b2cdf0352c3ba1f$var$repeatString(value, count) {
    return new Array(count + 1).join(value);
}
function $8b2cdf0352c3ba1f$var$markdownWriter() {
    var fragments = [];
    var elementStack = [];
    var list = null;
    var listItem = {};
    function open(tagName, attributes) {
        attributes = attributes || {};
        var createElement = $8b2cdf0352c3ba1f$var$htmlToMarkdown[tagName] || function() {
            return {};
        };
        var element = createElement(attributes, list, listItem);
        elementStack.push({
            end: element.end,
            list: list
        });
        if (element.list) list = element.list;
        var anchorBeforeStart = element.anchorPosition === "before";
        if (anchorBeforeStart) writeAnchor(attributes);
        fragments.push(element.start || "");
        if (!anchorBeforeStart) writeAnchor(attributes);
    }
    function writeAnchor(attributes) {
        if (attributes.id) fragments.push('<a id="' + attributes.id + '"></a>');
    }
    function close(tagName) {
        var element = elementStack.pop();
        list = element.list;
        var end = $ciHuQ.default(element.end) ? element.end() : element.end;
        fragments.push(end || "");
    }
    function selfClosing(tagName, attributes) {
        open(tagName, attributes);
        close(tagName);
    }
    function text(value) {
        fragments.push($8b2cdf0352c3ba1f$var$escapeMarkdown(value));
    }
    function asString() {
        return fragments.join("");
    }
    return {
        asString: asString,
        open: open,
        close: close,
        text: text,
        selfClosing: selfClosing
    };
}
$8b2cdf0352c3ba1f$export$47a3d634abc09f70 = $8b2cdf0352c3ba1f$var$markdownWriter;
function $8b2cdf0352c3ba1f$var$escapeMarkdown(value) {
    return value.replace(/\\/g, '\\\\').replace(/([\`\*_\{\}\[\]\(\)\#\+\-\.\!])/g, '\\$1');
}


$748ebd993e5bc6b9$export$47a3d634abc09f70 = $748ebd993e5bc6b9$var$writer;
function $748ebd993e5bc6b9$var$writer(options) {
    options = options || {};
    if (options.outputFormat === "markdown") return $8b2cdf0352c3ba1f$export$47a3d634abc09f70();
    else return $6c31025a874fb8d1$export$47a3d634abc09f70(options);
}


$67e37fd9055aa0c3$export$d10d7ab91c778d60 = $67e37fd9055aa0c3$var$DocumentConverter;
function $67e37fd9055aa0c3$var$DocumentConverter(options) {
    return {
        convertToHtml: function(element) {
            var comments = $bJcvr.default(element.type === $fcf129b7bd4ce72f$export$b14ad400b1d09e0f.document ? element.comments : [], "commentId");
            var conversion = new $67e37fd9055aa0c3$var$DocumentConversion(options, comments);
            return conversion.convertToHtml(element);
        }
    };
}
function $67e37fd9055aa0c3$var$DocumentConversion(options, comments) {
    var noteNumber = 1;
    var noteReferences = [];
    var referencedComments = [];
    options = $5yjjJ.default({
        ignoreEmptyParagraphs: true
    }, options);
    var idPrefix = options.idPrefix === undefined ? "" : options.idPrefix;
    var ignoreEmptyParagraphs = options.ignoreEmptyParagraphs;
    var defaultParagraphStyle = $hEvL6.topLevelElement("p");
    var styleMap = options.styleMap || [];
    function convertToHtml(document) {
        var messages = [];
        var html = elementToHtml(document, messages, {});
        var deferredNodes = [];
        $67e37fd9055aa0c3$var$walkHtml(html, function(node) {
            if (node.type === "deferred") deferredNodes.push(node);
        });
        var deferredValues = {};
        return $d93yU.mapSeries(deferredNodes, function(deferred) {
            return deferred.value().then(function(value) {
                deferredValues[deferred.id] = value;
            });
        }).then(function() {
            function replaceDeferred(nodes) {
                return $67e37fd9055aa0c3$var$flatMap(nodes, function(node) {
                    if (node.type === "deferred") return deferredValues[node.id];
                    else if (node.children) return [
                        $5yjjJ.default({}, node, {
                            children: replaceDeferred(node.children)
                        })
                    ];
                    else return [
                        node
                    ];
                });
            }
            var writer = $748ebd993e5bc6b9$export$47a3d634abc09f70({
                prettyPrint: options.prettyPrint,
                outputFormat: options.outputFormat
            });
            $8eobO.write(writer, $8eobO.simplify(replaceDeferred(html)));
            return new $11d28a8fc8838027$export$8fdcabde73f49165(writer.asString(), messages);
        });
    }
    function convertElements(elements, messages, options) {
        return $67e37fd9055aa0c3$var$flatMap(elements, function(element) {
            return elementToHtml(element, messages, options);
        });
    }
    function elementToHtml(element, messages, options) {
        if (!options) throw new Error("options not set");
        var handler = elementConverters[element.type];
        if (handler) return handler(element, messages, options);
        else return [];
    }
    function convertParagraph(element, messages, options) {
        return htmlPathForParagraph(element, messages).wrap(function() {
            var content = convertElements(element.children, messages, options);
            if (ignoreEmptyParagraphs) return content;
            else return [
                $8eobO.forceWrite
            ].concat(content);
        });
    }
    function htmlPathForParagraph(element, messages) {
        var style = findStyle(element);
        if (style) return style.to;
        else {
            if (element.styleId) messages.push($67e37fd9055aa0c3$var$unrecognisedStyleWarning("paragraph", element));
            return defaultParagraphStyle;
        }
    }
    function convertRun(run, messages, options) {
        var nodes = function() {
            return convertElements(run.children, messages, options);
        };
        var paths = [];
        if (run.highlight !== null) {
            var path = findHtmlPath({
                type: "highlight",
                color: run.highlight
            });
            if (path) paths.push(path);
        }
        if (run.isSmallCaps) paths.push(findHtmlPathForRunProperty("smallCaps"));
        if (run.isAllCaps) paths.push(findHtmlPathForRunProperty("allCaps"));
        if (run.isStrikethrough) paths.push(findHtmlPathForRunProperty("strikethrough", "s"));
        if (run.isUnderline) paths.push(findHtmlPathForRunProperty("underline"));
        if (run.verticalAlignment === $fcf129b7bd4ce72f$export$983b95e2e3722091.subscript) paths.push($hEvL6.element("sub", {}, {
            fresh: false
        }));
        if (run.verticalAlignment === $fcf129b7bd4ce72f$export$983b95e2e3722091.superscript) paths.push($hEvL6.element("sup", {}, {
            fresh: false
        }));
        if (run.isItalic) paths.push(findHtmlPathForRunProperty("italic", "em"));
        if (run.isBold) paths.push(findHtmlPathForRunProperty("bold", "strong"));
        var stylePath = $hEvL6.empty;
        var style = findStyle(run);
        if (style) stylePath = style.to;
        else if (run.styleId) messages.push($67e37fd9055aa0c3$var$unrecognisedStyleWarning("run", run));
        paths.push(stylePath);
        paths.forEach(function(path) {
            nodes = path.wrap.bind(path, nodes);
        });
        return nodes();
    }
    function findHtmlPathForRunProperty(elementType, defaultTagName) {
        var path = findHtmlPath({
            type: elementType
        });
        if (path) return path;
        else if (defaultTagName) return $hEvL6.element(defaultTagName, {}, {
            fresh: false
        });
        else return $hEvL6.empty;
    }
    function findHtmlPath(element, defaultPath) {
        var style = findStyle(element);
        return style ? style.to : defaultPath;
    }
    function findStyle(element) {
        for(var i = 0; i < styleMap.length; i++){
            if (styleMap[i].from.matches(element)) return styleMap[i];
        }
    }
    function recoveringConvertImage(convertImage) {
        return function(image, messages) {
            return $d93yU.attempt(function() {
                return convertImage(image, messages);
            }).caught(function(error) {
                messages.push($11d28a8fc8838027$export$a3bc9b8ed74fc(error));
                return [];
            });
        };
    }
    function noteHtmlId(note) {
        return referentHtmlId(note.noteType, note.noteId);
    }
    function noteRefHtmlId(note) {
        return referenceHtmlId(note.noteType, note.noteId);
    }
    function referentHtmlId(referenceType, referenceId) {
        return htmlId(referenceType + "-" + referenceId);
    }
    function referenceHtmlId(referenceType, referenceId) {
        return htmlId(referenceType + "-ref-" + referenceId);
    }
    function htmlId(suffix) {
        return idPrefix + suffix;
    }
    var defaultTablePath = $hEvL6.elements([
        $hEvL6.element("table", {}, {
            fresh: true
        })
    ]);
    function convertTable(element, messages, options) {
        return findHtmlPath(element, defaultTablePath).wrap(function() {
            return convertTableChildren(element, messages, options);
        });
    }
    function convertTableChildren(element, messages, options) {
        var bodyIndex = $e2Yic.default(element.children, function(child) {
            return !child.type === $fcf129b7bd4ce72f$export$b14ad400b1d09e0f.tableRow || !child.isHeader;
        });
        if (bodyIndex === -1) bodyIndex = element.children.length;
        var children;
        if (bodyIndex === 0) children = convertElements(element.children, messages, $5yjjJ.default({}, options, {
            isTableHeader: false
        }));
        else {
            var headRows = convertElements(element.children.slice(0, bodyIndex), messages, $5yjjJ.default({}, options, {
                isTableHeader: true
            }));
            var bodyRows = convertElements(element.children.slice(bodyIndex), messages, $5yjjJ.default({}, options, {
                isTableHeader: false
            }));
            children = [
                $8eobO.freshElement("thead", {}, headRows),
                $8eobO.freshElement("tbody", {}, bodyRows)
            ];
        }
        return [
            $8eobO.forceWrite
        ].concat(children);
    }
    function convertTableRow(element, messages, options) {
        var children = convertElements(element.children, messages, options);
        return [
            $8eobO.freshElement("tr", {}, [
                $8eobO.forceWrite
            ].concat(children))
        ];
    }
    function convertTableCell(element, messages, options) {
        var tagName = options.isTableHeader ? "th" : "td";
        var children = convertElements(element.children, messages, options);
        var attributes = {};
        if (element.colSpan !== 1) attributes.colspan = element.colSpan.toString();
        if (element.rowSpan !== 1) attributes.rowspan = element.rowSpan.toString();
        return [
            $8eobO.freshElement(tagName, attributes, [
                $8eobO.forceWrite
            ].concat(children))
        ];
    }
    function convertCommentReference(reference, messages, options) {
        return findHtmlPath(reference, $hEvL6.ignore).wrap(function() {
            var comment = comments[reference.commentId];
            var count = referencedComments.length + 1;
            var label = "[" + $67e37fd9055aa0c3$var$commentAuthorLabel(comment) + count + "]";
            referencedComments.push({
                label: label,
                comment: comment
            });
            // TODO: remove duplication with note references
            return [
                $8eobO.freshElement("a", {
                    href: "#" + referentHtmlId("comment", reference.commentId),
                    id: referenceHtmlId("comment", reference.commentId)
                }, [
                    $8eobO.text(label)
                ])
            ];
        });
    }
    function convertComment(referencedComment, messages, options) {
        // TODO: remove duplication with note references
        var label = referencedComment.label;
        var comment = referencedComment.comment;
        var body = convertElements(comment.body, messages, options).concat([
            $8eobO.nonFreshElement("p", {}, [
                $8eobO.text(" "),
                $8eobO.freshElement("a", {
                    "href": "#" + referenceHtmlId("comment", comment.commentId)
                }, [
                    $8eobO.text("\u2191")
                ])
            ])
        ]);
        return [
            $8eobO.freshElement("dt", {
                "id": referentHtmlId("comment", comment.commentId)
            }, [
                $8eobO.text("Comment " + label)
            ]),
            $8eobO.freshElement("dd", {}, body)
        ];
    }
    function convertBreak(element, messages, options) {
        return htmlPathForBreak(element).wrap(function() {
            return [];
        });
    }
    function htmlPathForBreak(element) {
        var style = findStyle(element);
        if (style) return style.to;
        else if (element.breakType === "line") return $hEvL6.topLevelElement("br");
        else return $hEvL6.empty;
    }
    var elementConverters = {
        "document": function(document, messages, options) {
            var children = convertElements(document.children, messages, options);
            var notes = noteReferences.map(function(noteReference) {
                return document.notes.resolve(noteReference);
            });
            var notesNodes = convertElements(notes, messages, options);
            return children.concat([
                $8eobO.freshElement("ol", {}, notesNodes),
                $8eobO.freshElement("dl", {}, $67e37fd9055aa0c3$var$flatMap(referencedComments, function(referencedComment) {
                    return convertComment(referencedComment, messages, options);
                }))
            ]);
        },
        "paragraph": convertParagraph,
        "run": convertRun,
        "text": function(element, messages, options) {
            return [
                $8eobO.text(element.value)
            ];
        },
        "tab": function(element, messages, options) {
            return [
                $8eobO.text("\t")
            ];
        },
        "hyperlink": function(element, messages, options) {
            var href = element.anchor ? "#" + htmlId(element.anchor) : element.href;
            var attributes = {
                href: href
            };
            if (element.targetFrame != null) attributes.target = element.targetFrame;
            var children = convertElements(element.children, messages, options);
            return [
                $8eobO.nonFreshElement("a", attributes, children)
            ];
        },
        "checkbox": function(element) {
            var attributes = {
                type: "checkbox"
            };
            if (element.checked) attributes["checked"] = "checked";
            return [
                $8eobO.freshElement("input", attributes)
            ];
        },
        "bookmarkStart": function(element, messages, options) {
            var anchor = $8eobO.freshElement("a", {
                id: htmlId(element.name)
            }, [
                $8eobO.forceWrite
            ]);
            return [
                anchor
            ];
        },
        "noteReference": function(element, messages, options) {
            noteReferences.push(element);
            var anchor = $8eobO.freshElement("a", {
                href: "#" + noteHtmlId(element),
                id: noteRefHtmlId(element)
            }, [
                $8eobO.text("[" + noteNumber++ + "]")
            ]);
            return [
                $8eobO.freshElement("sup", {}, [
                    anchor
                ])
            ];
        },
        "note": function(element, messages, options) {
            var children = convertElements(element.body, messages, options);
            var backLink = $8eobO.elementWithTag($hEvL6.element("p", {}, {
                fresh: false
            }), [
                $8eobO.text(" "),
                $8eobO.freshElement("a", {
                    href: "#" + noteRefHtmlId(element)
                }, [
                    $8eobO.text("\u2191")
                ])
            ]);
            var body = children.concat([
                backLink
            ]);
            return $8eobO.freshElement("li", {
                id: noteHtmlId(element)
            }, body);
        },
        "commentReference": convertCommentReference,
        "comment": convertComment,
        "image": $67e37fd9055aa0c3$var$deferredConversion(recoveringConvertImage(options.convertImage || $gOpjt.dataUri)),
        "table": convertTable,
        "tableRow": convertTableRow,
        "tableCell": convertTableCell,
        "break": convertBreak
    };
    return {
        convertToHtml: convertToHtml
    };
}
var $67e37fd9055aa0c3$var$deferredId = 1;
function $67e37fd9055aa0c3$var$deferredConversion(func) {
    return function(element, messages, options) {
        return [
            {
                type: "deferred",
                id: $67e37fd9055aa0c3$var$deferredId++,
                value: function() {
                    return func(element, messages, options);
                }
            }
        ];
    };
}
function $67e37fd9055aa0c3$var$unrecognisedStyleWarning(type, element) {
    return $11d28a8fc8838027$export$491112666e282270("Unrecognised " + type + " style: '" + element.styleName + "'" + " (Style ID: " + element.styleId + ")");
}
function $67e37fd9055aa0c3$var$flatMap(values, func) {
    return $1TwZj.default(values.map(func), true);
}
function $67e37fd9055aa0c3$var$walkHtml(nodes, callback) {
    nodes.forEach(function(node) {
        callback(node);
        if (node.children) $67e37fd9055aa0c3$var$walkHtml(node.children, callback);
    });
}
var $67e37fd9055aa0c3$var$commentAuthorLabel = $67e37fd9055aa0c3$export$6e29e379a5b99e3b = function commentAuthorLabel(comment) {
    return comment.authorInitials || "";
};


var $f489ff3da7c10b03$require$DocumentConverter = $67e37fd9055aa0c3$export$d10d7ab91c778d60;
var $7f9c344ce0507ba2$export$f04031f791975cf1;

function $7f9c344ce0507ba2$var$convertElementToRawText(element) {
    if (element.type === "text") return element.value;
    else if (element.type === $fcf129b7bd4ce72f$export$b14ad400b1d09e0f.tab) return "\t";
    else {
        var tail = element.type === "paragraph" ? "\n\n" : "";
        return (element.children || []).map($7f9c344ce0507ba2$var$convertElementToRawText).join("") + tail;
    }
}
$7f9c344ce0507ba2$export$f04031f791975cf1 = $7f9c344ce0507ba2$var$convertElementToRawText;


var $f489ff3da7c10b03$require$convertElementToRawText = $7f9c344ce0507ba2$export$f04031f791975cf1;
var $185ecd02a4e67434$export$c013b05e5703966c;
var $185ecd02a4e67434$export$8355e188a552b07e;
var $185ecd02a4e67434$export$433ccb34ac23a8e9;
parcelRequire("9jAvV");
var $5yjjJ = parcelRequire("5yjjJ");
var $7a863c37b872de91$export$7acfa6ed01010e37;
var $7a863c37b872de91$export$354076178bdef094;
var $7a863c37b872de91$export$30f3b02011db23c0;
var $7a863c37b872de91$export$5be82eb8d376fece;
var $7a863c37b872de91$export$7799bd957249d7a0;
var $7a863c37b872de91$export$50792b0e93539fde;
var $7a863c37b872de91$export$66e1bcdf7cde41a0;
var $7a863c37b872de91$export$74d15b5d79bf9ea;
var $7a863c37b872de91$export$fbeb3a3956e8a3c7;

$7a863c37b872de91$export$7acfa6ed01010e37 = (parcelRequire("17glP")).Parser;

$7a863c37b872de91$export$354076178bdef094 = (parcelRequire("moeVv"));

$7a863c37b872de91$export$30f3b02011db23c0 = (parcelRequire("5wxOh"));

$7a863c37b872de91$export$5be82eb8d376fece = (parcelRequire("cB0qU"));

$7a863c37b872de91$export$7799bd957249d7a0 = (parcelRequire("8kl1m"));

$7a863c37b872de91$export$50792b0e93539fde = (parcelRequire("7f4pG"));

$7a863c37b872de91$export$66e1bcdf7cde41a0 = (parcelRequire("fqgYr"));

$7a863c37b872de91$export$74d15b5d79bf9ea = (parcelRequire("FZqT4")).RegexTokeniser;
$7a863c37b872de91$export$fbeb3a3956e8a3c7 = function(ruleBuilder) {
    var rule;
    return function(input) {
        if (!rule) rule = ruleBuilder();
        return rule(input);
    };
};


var $70d33b994ac62e43$export$9c206ddddb32a9b;
var $70d33b994ac62e43$export$889ea624f2cb2c57;
var $70d33b994ac62e43$export$9852986a3ec5f6a0;
var $70d33b994ac62e43$export$73ba5813cda80a49;
var $70d33b994ac62e43$export$5540da1282cbf565;
var $70d33b994ac62e43$export$425327af25286e5e;
var $70d33b994ac62e43$export$19426ff118fe8be;
var $70d33b994ac62e43$export$dc07c1d187ec2934;
var $70d33b994ac62e43$export$394ff16a4cefe989;
var $70d33b994ac62e43$export$e4043f67d36cbb26;
var $70d33b994ac62e43$export$841d4c6db70c1a65;
var $70d33b994ac62e43$export$a1aa2dd4ad0d3f6;
var $70d33b994ac62e43$export$1b438cdd7ed26c35;
var $70d33b994ac62e43$export$5a38f5b463e49b91;
var $70d33b994ac62e43$export$bdcdec1f91f16dff;
var $70d33b994ac62e43$export$68326237475e9a7d;
$70d33b994ac62e43$export$9c206ddddb32a9b = $70d33b994ac62e43$var$paragraph;
$70d33b994ac62e43$export$889ea624f2cb2c57 = $70d33b994ac62e43$var$run;
$70d33b994ac62e43$export$9852986a3ec5f6a0 = $70d33b994ac62e43$var$table;
$70d33b994ac62e43$export$73ba5813cda80a49 = new $70d33b994ac62e43$var$Matcher("bold");
$70d33b994ac62e43$export$5540da1282cbf565 = new $70d33b994ac62e43$var$Matcher("italic");
$70d33b994ac62e43$export$425327af25286e5e = new $70d33b994ac62e43$var$Matcher("underline");
$70d33b994ac62e43$export$19426ff118fe8be = new $70d33b994ac62e43$var$Matcher("strikethrough");
$70d33b994ac62e43$export$dc07c1d187ec2934 = new $70d33b994ac62e43$var$Matcher("allCaps");
$70d33b994ac62e43$export$394ff16a4cefe989 = new $70d33b994ac62e43$var$Matcher("smallCaps");
$70d33b994ac62e43$export$e4043f67d36cbb26 = $70d33b994ac62e43$var$highlight;
$70d33b994ac62e43$export$841d4c6db70c1a65 = new $70d33b994ac62e43$var$Matcher("commentReference");
$70d33b994ac62e43$export$a1aa2dd4ad0d3f6 = new $70d33b994ac62e43$var$BreakMatcher({
    breakType: "line"
});
$70d33b994ac62e43$export$1b438cdd7ed26c35 = new $70d33b994ac62e43$var$BreakMatcher({
    breakType: "page"
});
$70d33b994ac62e43$export$5a38f5b463e49b91 = new $70d33b994ac62e43$var$BreakMatcher({
    breakType: "column"
});
$70d33b994ac62e43$export$bdcdec1f91f16dff = $70d33b994ac62e43$var$equalTo;
$70d33b994ac62e43$export$68326237475e9a7d = $70d33b994ac62e43$var$startsWith;
function $70d33b994ac62e43$var$paragraph(options) {
    return new $70d33b994ac62e43$var$Matcher("paragraph", options);
}
function $70d33b994ac62e43$var$run(options) {
    return new $70d33b994ac62e43$var$Matcher("run", options);
}
function $70d33b994ac62e43$var$table(options) {
    return new $70d33b994ac62e43$var$Matcher("table", options);
}
function $70d33b994ac62e43$var$highlight(options) {
    return new $70d33b994ac62e43$var$HighlightMatcher(options);
}
function $70d33b994ac62e43$var$Matcher(elementType, options) {
    options = options || {};
    this._elementType = elementType;
    this._styleId = options.styleId;
    this._styleName = options.styleName;
    if (options.list) {
        this._listIndex = options.list.levelIndex;
        this._listIsOrdered = options.list.isOrdered;
    }
}
$70d33b994ac62e43$var$Matcher.prototype.matches = function(element) {
    return element.type === this._elementType && (this._styleId === undefined || element.styleId === this._styleId) && (this._styleName === undefined || element.styleName && this._styleName.operator(this._styleName.operand, element.styleName)) && (this._listIndex === undefined || $70d33b994ac62e43$var$isList(element, this._listIndex, this._listIsOrdered)) && (this._breakType === undefined || this._breakType === element.breakType);
};
function $70d33b994ac62e43$var$HighlightMatcher(options) {
    options = options || {};
    this._color = options.color;
}
$70d33b994ac62e43$var$HighlightMatcher.prototype.matches = function(element) {
    return element.type === "highlight" && (this._color === undefined || element.color === this._color);
};
function $70d33b994ac62e43$var$BreakMatcher(options) {
    options = options || {};
    this._breakType = options.breakType;
}
$70d33b994ac62e43$var$BreakMatcher.prototype.matches = function(element) {
    return element.type === "break" && (this._breakType === undefined || element.breakType === this._breakType);
};
function $70d33b994ac62e43$var$isList(element, levelIndex, isOrdered) {
    return element.numbering && element.numbering.level == levelIndex && element.numbering.isOrdered == isOrdered;
}
function $70d33b994ac62e43$var$equalTo(value) {
    return {
        operator: $70d33b994ac62e43$var$operatorEqualTo,
        operand: value
    };
}
function $70d33b994ac62e43$var$startsWith(value) {
    return {
        operator: $70d33b994ac62e43$var$operatorStartsWith,
        operand: value
    };
}
function $70d33b994ac62e43$var$operatorEqualTo(first, second) {
    return first.toUpperCase() === second.toUpperCase();
}
function $70d33b994ac62e43$var$operatorStartsWith(first, second) {
    return second.toUpperCase().indexOf(first.toUpperCase()) === 0;
}



var $hEvL6 = parcelRequire("hEvL6");
var $95d4e788901bc43b$export$3e101593fe008f79;

var $95d4e788901bc43b$var$RegexTokeniser = $7a863c37b872de91$export$74d15b5d79bf9ea;
$95d4e788901bc43b$export$3e101593fe008f79 = $95d4e788901bc43b$var$tokenise;
var $95d4e788901bc43b$var$stringPrefix = "'((?:\\\\.|[^'])*)";
function $95d4e788901bc43b$var$tokenise(string) {
    var identifierCharacter = "(?:[a-zA-Z\\-_]|\\\\.)";
    var tokeniser = new $95d4e788901bc43b$var$RegexTokeniser([
        {
            name: "identifier",
            regex: new RegExp("(" + identifierCharacter + "(?:" + identifierCharacter + "|[0-9])*)")
        },
        {
            name: "dot",
            regex: /\./
        },
        {
            name: "colon",
            regex: /:/
        },
        {
            name: "gt",
            regex: />/
        },
        {
            name: "whitespace",
            regex: /\s+/
        },
        {
            name: "arrow",
            regex: /=>/
        },
        {
            name: "equals",
            regex: /=/
        },
        {
            name: "startsWith",
            regex: /\^=/
        },
        {
            name: "open-paren",
            regex: /\(/
        },
        {
            name: "close-paren",
            regex: /\)/
        },
        {
            name: "open-square-bracket",
            regex: /\[/
        },
        {
            name: "close-square-bracket",
            regex: /\]/
        },
        {
            name: "string",
            regex: new RegExp($95d4e788901bc43b$var$stringPrefix + "'")
        },
        {
            name: "unterminated-string",
            regex: new RegExp($95d4e788901bc43b$var$stringPrefix)
        },
        {
            name: "integer",
            regex: /([0-9]+)/
        },
        {
            name: "choice",
            regex: /\|/
        },
        {
            name: "bang",
            regex: /(!)/
        }
    ]);
    return tokeniser.tokenise(string);
}


var $185ecd02a4e67434$require$tokenise = $95d4e788901bc43b$export$3e101593fe008f79;

$185ecd02a4e67434$export$c013b05e5703966c = $185ecd02a4e67434$var$readHtmlPath;
$185ecd02a4e67434$export$8355e188a552b07e = $185ecd02a4e67434$var$readDocumentMatcher;
$185ecd02a4e67434$export$433ccb34ac23a8e9 = $185ecd02a4e67434$var$readStyle;
function $185ecd02a4e67434$var$readStyle(string) {
    return $185ecd02a4e67434$var$parseString($185ecd02a4e67434$var$styleRule, string);
}
function $185ecd02a4e67434$var$createStyleRule() {
    return $7a863c37b872de91$export$354076178bdef094.sequence($7a863c37b872de91$export$354076178bdef094.sequence.capture($185ecd02a4e67434$var$documentMatcherRule()), $7a863c37b872de91$export$354076178bdef094.tokenOfType("whitespace"), $7a863c37b872de91$export$354076178bdef094.tokenOfType("arrow"), $7a863c37b872de91$export$354076178bdef094.sequence.capture($7a863c37b872de91$export$354076178bdef094.optional($7a863c37b872de91$export$354076178bdef094.sequence($7a863c37b872de91$export$354076178bdef094.tokenOfType("whitespace"), $7a863c37b872de91$export$354076178bdef094.sequence.capture($185ecd02a4e67434$var$htmlPathRule())).head())), $7a863c37b872de91$export$354076178bdef094.tokenOfType("end")).map(function(documentMatcher, htmlPath) {
        return {
            from: documentMatcher,
            to: htmlPath.valueOrElse($hEvL6.empty)
        };
    });
}
function $185ecd02a4e67434$var$readDocumentMatcher(string) {
    return $185ecd02a4e67434$var$parseString($185ecd02a4e67434$var$documentMatcherRule(), string);
}
function $185ecd02a4e67434$var$documentMatcherRule() {
    var sequence = $7a863c37b872de91$export$354076178bdef094.sequence;
    var identifierToConstant = function(identifier, constant) {
        return $7a863c37b872de91$export$354076178bdef094.then($7a863c37b872de91$export$354076178bdef094.token("identifier", identifier), function() {
            return constant;
        });
    };
    var paragraphRule = identifierToConstant("p", $70d33b994ac62e43$export$9c206ddddb32a9b);
    var runRule = identifierToConstant("r", $70d33b994ac62e43$export$889ea624f2cb2c57);
    var elementTypeRule = $7a863c37b872de91$export$354076178bdef094.firstOf("p or r or table", paragraphRule, runRule);
    var styleIdRule = $7a863c37b872de91$export$354076178bdef094.sequence($7a863c37b872de91$export$354076178bdef094.tokenOfType("dot"), $7a863c37b872de91$export$354076178bdef094.sequence.cut(), $7a863c37b872de91$export$354076178bdef094.sequence.capture($185ecd02a4e67434$var$identifierRule)).map(function(styleId) {
        return {
            styleId: styleId
        };
    });
    var styleNameMatcherRule = $7a863c37b872de91$export$354076178bdef094.firstOf("style name matcher", $7a863c37b872de91$export$354076178bdef094.then($7a863c37b872de91$export$354076178bdef094.sequence($7a863c37b872de91$export$354076178bdef094.tokenOfType("equals"), $7a863c37b872de91$export$354076178bdef094.sequence.cut(), $7a863c37b872de91$export$354076178bdef094.sequence.capture($185ecd02a4e67434$var$stringRule)).head(), function(styleName) {
        return {
            styleName: $70d33b994ac62e43$export$bdcdec1f91f16dff(styleName)
        };
    }), $7a863c37b872de91$export$354076178bdef094.then($7a863c37b872de91$export$354076178bdef094.sequence($7a863c37b872de91$export$354076178bdef094.tokenOfType("startsWith"), $7a863c37b872de91$export$354076178bdef094.sequence.cut(), $7a863c37b872de91$export$354076178bdef094.sequence.capture($185ecd02a4e67434$var$stringRule)).head(), function(styleName) {
        return {
            styleName: $70d33b994ac62e43$export$68326237475e9a7d(styleName)
        };
    }));
    var styleNameRule = $7a863c37b872de91$export$354076178bdef094.sequence($7a863c37b872de91$export$354076178bdef094.tokenOfType("open-square-bracket"), $7a863c37b872de91$export$354076178bdef094.sequence.cut(), $7a863c37b872de91$export$354076178bdef094.token("identifier", "style-name"), $7a863c37b872de91$export$354076178bdef094.sequence.capture(styleNameMatcherRule), $7a863c37b872de91$export$354076178bdef094.tokenOfType("close-square-bracket")).head();
    var listTypeRule = $7a863c37b872de91$export$354076178bdef094.firstOf("list type", identifierToConstant("ordered-list", {
        isOrdered: true
    }), identifierToConstant("unordered-list", {
        isOrdered: false
    }));
    var listRule = sequence($7a863c37b872de91$export$354076178bdef094.tokenOfType("colon"), sequence.capture(listTypeRule), sequence.cut(), $7a863c37b872de91$export$354076178bdef094.tokenOfType("open-paren"), sequence.capture($185ecd02a4e67434$var$integerRule), $7a863c37b872de91$export$354076178bdef094.tokenOfType("close-paren")).map(function(listType, levelNumber) {
        return {
            list: {
                isOrdered: listType.isOrdered,
                levelIndex: levelNumber - 1
            }
        };
    });
    function createMatcherSuffixesRule(rules) {
        var matcherSuffix = $7a863c37b872de91$export$354076178bdef094.firstOf.apply($7a863c37b872de91$export$354076178bdef094.firstOf, [
            "matcher suffix"
        ].concat(rules));
        var matcherSuffixes = $7a863c37b872de91$export$354076178bdef094.zeroOrMore(matcherSuffix);
        return $7a863c37b872de91$export$354076178bdef094.then(matcherSuffixes, function(suffixes) {
            var matcherOptions = {};
            suffixes.forEach(function(suffix) {
                $5yjjJ.default(matcherOptions, suffix);
            });
            return matcherOptions;
        });
    }
    var paragraphOrRun = sequence(sequence.capture(elementTypeRule), sequence.capture(createMatcherSuffixesRule([
        styleIdRule,
        styleNameRule,
        listRule
    ]))).map(function(createMatcher, matcherOptions) {
        return createMatcher(matcherOptions);
    });
    var table = sequence($7a863c37b872de91$export$354076178bdef094.token("identifier", "table"), sequence.capture(createMatcherSuffixesRule([
        styleIdRule,
        styleNameRule
    ]))).map(function(options) {
        return $70d33b994ac62e43$export$9852986a3ec5f6a0(options);
    });
    var bold = identifierToConstant("b", $70d33b994ac62e43$export$73ba5813cda80a49);
    var italic = identifierToConstant("i", $70d33b994ac62e43$export$5540da1282cbf565);
    var underline = identifierToConstant("u", $70d33b994ac62e43$export$425327af25286e5e);
    var strikethrough = identifierToConstant("strike", $70d33b994ac62e43$export$19426ff118fe8be);
    var allCaps = identifierToConstant("all-caps", $70d33b994ac62e43$export$dc07c1d187ec2934);
    var smallCaps = identifierToConstant("small-caps", $70d33b994ac62e43$export$394ff16a4cefe989);
    var highlight = sequence($7a863c37b872de91$export$354076178bdef094.token("identifier", "highlight"), $7a863c37b872de91$export$354076178bdef094.sequence.capture($7a863c37b872de91$export$354076178bdef094.optional($7a863c37b872de91$export$354076178bdef094.sequence($7a863c37b872de91$export$354076178bdef094.tokenOfType("open-square-bracket"), $7a863c37b872de91$export$354076178bdef094.sequence.cut(), $7a863c37b872de91$export$354076178bdef094.token("identifier", "color"), $7a863c37b872de91$export$354076178bdef094.tokenOfType("equals"), $7a863c37b872de91$export$354076178bdef094.sequence.capture($185ecd02a4e67434$var$stringRule), $7a863c37b872de91$export$354076178bdef094.tokenOfType("close-square-bracket")).head()))).map(function(color) {
        return $70d33b994ac62e43$export$e4043f67d36cbb26({
            color: color.valueOrElse(undefined)
        });
    });
    var commentReference = identifierToConstant("comment-reference", $70d33b994ac62e43$export$841d4c6db70c1a65);
    var breakMatcher = sequence($7a863c37b872de91$export$354076178bdef094.token("identifier", "br"), sequence.cut(), $7a863c37b872de91$export$354076178bdef094.tokenOfType("open-square-bracket"), $7a863c37b872de91$export$354076178bdef094.token("identifier", "type"), $7a863c37b872de91$export$354076178bdef094.tokenOfType("equals"), sequence.capture($185ecd02a4e67434$var$stringRule), $7a863c37b872de91$export$354076178bdef094.tokenOfType("close-square-bracket")).map(function(breakType) {
        switch(breakType){
            case "line":
                return $70d33b994ac62e43$export$a1aa2dd4ad0d3f6;
            case "page":
                return $70d33b994ac62e43$export$1b438cdd7ed26c35;
            case "column":
                return $70d33b994ac62e43$export$5a38f5b463e49b91;
            default:
        }
    });
    return $7a863c37b872de91$export$354076178bdef094.firstOf("element type", paragraphOrRun, table, bold, italic, underline, strikethrough, allCaps, smallCaps, highlight, commentReference, breakMatcher);
}
function $185ecd02a4e67434$var$readHtmlPath(string) {
    return $185ecd02a4e67434$var$parseString($185ecd02a4e67434$var$htmlPathRule(), string);
}
function $185ecd02a4e67434$var$htmlPathRule() {
    var capture = $7a863c37b872de91$export$354076178bdef094.sequence.capture;
    var whitespaceRule = $7a863c37b872de91$export$354076178bdef094.tokenOfType("whitespace");
    var freshRule = $7a863c37b872de91$export$354076178bdef094.then($7a863c37b872de91$export$354076178bdef094.optional($7a863c37b872de91$export$354076178bdef094.sequence($7a863c37b872de91$export$354076178bdef094.tokenOfType("colon"), $7a863c37b872de91$export$354076178bdef094.token("identifier", "fresh"))), function(option) {
        return option.map(function() {
            return true;
        }).valueOrElse(false);
    });
    var separatorRule = $7a863c37b872de91$export$354076178bdef094.then($7a863c37b872de91$export$354076178bdef094.optional($7a863c37b872de91$export$354076178bdef094.sequence($7a863c37b872de91$export$354076178bdef094.tokenOfType("colon"), $7a863c37b872de91$export$354076178bdef094.token("identifier", "separator"), $7a863c37b872de91$export$354076178bdef094.tokenOfType("open-paren"), capture($185ecd02a4e67434$var$stringRule), $7a863c37b872de91$export$354076178bdef094.tokenOfType("close-paren")).head()), function(option) {
        return option.valueOrElse("");
    });
    var tagNamesRule = $7a863c37b872de91$export$354076178bdef094.oneOrMoreWithSeparator($185ecd02a4e67434$var$identifierRule, $7a863c37b872de91$export$354076178bdef094.tokenOfType("choice"));
    var styleElementRule = $7a863c37b872de91$export$354076178bdef094.sequence(capture(tagNamesRule), capture($7a863c37b872de91$export$354076178bdef094.zeroOrMore($185ecd02a4e67434$var$attributeOrClassRule)), capture(freshRule), capture(separatorRule)).map(function(tagName, attributesList, fresh, separator) {
        var attributes = {};
        var options = {};
        attributesList.forEach(function(attribute) {
            if (attribute.append && attributes[attribute.name]) attributes[attribute.name] += " " + attribute.value;
            else attributes[attribute.name] = attribute.value;
        });
        if (fresh) options.fresh = true;
        if (separator) options.separator = separator;
        return $hEvL6.element(tagName, attributes, options);
    });
    return $7a863c37b872de91$export$354076178bdef094.firstOf("html path", $7a863c37b872de91$export$354076178bdef094.then($7a863c37b872de91$export$354076178bdef094.tokenOfType("bang"), function() {
        return $hEvL6.ignore;
    }), $7a863c37b872de91$export$354076178bdef094.then($7a863c37b872de91$export$354076178bdef094.zeroOrMoreWithSeparator(styleElementRule, $7a863c37b872de91$export$354076178bdef094.sequence(whitespaceRule, $7a863c37b872de91$export$354076178bdef094.tokenOfType("gt"), whitespaceRule)), $hEvL6.elements));
}
var $185ecd02a4e67434$var$identifierRule = $7a863c37b872de91$export$354076178bdef094.then($7a863c37b872de91$export$354076178bdef094.tokenOfType("identifier"), $185ecd02a4e67434$var$decodeEscapeSequences);
var $185ecd02a4e67434$var$integerRule = $7a863c37b872de91$export$354076178bdef094.tokenOfType("integer");
var $185ecd02a4e67434$var$stringRule = $7a863c37b872de91$export$354076178bdef094.then($7a863c37b872de91$export$354076178bdef094.tokenOfType("string"), $185ecd02a4e67434$var$decodeEscapeSequences);
var $185ecd02a4e67434$var$escapeSequences = {
    "n": "\n",
    "r": "\r",
    "t": "\t"
};
function $185ecd02a4e67434$var$decodeEscapeSequences(value) {
    return value.replace(/\\(.)/g, function(match, code) {
        return $185ecd02a4e67434$var$escapeSequences[code] || code;
    });
}
var $185ecd02a4e67434$var$attributeRule = $7a863c37b872de91$export$354076178bdef094.sequence($7a863c37b872de91$export$354076178bdef094.tokenOfType("open-square-bracket"), $7a863c37b872de91$export$354076178bdef094.sequence.cut(), $7a863c37b872de91$export$354076178bdef094.sequence.capture($185ecd02a4e67434$var$identifierRule), $7a863c37b872de91$export$354076178bdef094.tokenOfType("equals"), $7a863c37b872de91$export$354076178bdef094.sequence.capture($185ecd02a4e67434$var$stringRule), $7a863c37b872de91$export$354076178bdef094.tokenOfType("close-square-bracket")).map(function(name, value) {
    return {
        name: name,
        value: value,
        append: false
    };
});
var $185ecd02a4e67434$var$classRule = $7a863c37b872de91$export$354076178bdef094.sequence($7a863c37b872de91$export$354076178bdef094.tokenOfType("dot"), $7a863c37b872de91$export$354076178bdef094.sequence.cut(), $7a863c37b872de91$export$354076178bdef094.sequence.capture($185ecd02a4e67434$var$identifierRule)).map(function(className) {
    return {
        name: "class",
        value: className,
        append: true
    };
});
var $185ecd02a4e67434$var$attributeOrClassRule = $7a863c37b872de91$export$354076178bdef094.firstOf("attribute or class", $185ecd02a4e67434$var$attributeRule, $185ecd02a4e67434$var$classRule);
function $185ecd02a4e67434$var$parseString(rule, string) {
    var tokens = $185ecd02a4e67434$require$tokenise(string);
    var parser = $7a863c37b872de91$export$7acfa6ed01010e37();
    var parseResult = parser.parseTokens(rule, tokens);
    if (parseResult.isSuccess()) return $11d28a8fc8838027$export$fe7c49d056ea1d88(parseResult.value());
    else return new $11d28a8fc8838027$export$8fdcabde73f49165(null, [
        $11d28a8fc8838027$export$491112666e282270($185ecd02a4e67434$var$describeFailure(string, parseResult))
    ]);
}
function $185ecd02a4e67434$var$describeFailure(input, parseResult) {
    return "Did not understand this style mapping, so ignored it: " + input + "\n" + parseResult.errors().map($185ecd02a4e67434$var$describeError).join("\n");
}
function $185ecd02a4e67434$var$describeError(error) {
    return "Error was at character number " + error.characterNumber() + ": " + "Expected " + error.expected + " but got " + error.actual;
}
var $185ecd02a4e67434$var$styleRule = $185ecd02a4e67434$var$createStyleRule();


var $f489ff3da7c10b03$require$readStyle = $185ecd02a4e67434$export$433ccb34ac23a8e9;
var $85dd06109b9e0944$export$78af9b5fc65e58de;
var $85dd06109b9e0944$export$eb9991766a046a21;
var $85dd06109b9e0944$export$635424202fde079c;
$85dd06109b9e0944$export$78af9b5fc65e58de = $85dd06109b9e0944$var$readOptions;
parcelRequire("9jAvV");
var $5yjjJ = parcelRequire("5yjjJ");
var $jmGFg = parcelRequire("jmGFg");
var $85dd06109b9e0944$var$defaultStyleMap = $85dd06109b9e0944$export$eb9991766a046a21 = [
    "p.Heading1 => h1:fresh",
    "p.Heading2 => h2:fresh",
    "p.Heading3 => h3:fresh",
    "p.Heading4 => h4:fresh",
    "p.Heading5 => h5:fresh",
    "p.Heading6 => h6:fresh",
    "p[style-name='Heading 1'] => h1:fresh",
    "p[style-name='Heading 2'] => h2:fresh",
    "p[style-name='Heading 3'] => h3:fresh",
    "p[style-name='Heading 4'] => h4:fresh",
    "p[style-name='Heading 5'] => h5:fresh",
    "p[style-name='Heading 6'] => h6:fresh",
    "p[style-name='heading 1'] => h1:fresh",
    "p[style-name='heading 2'] => h2:fresh",
    "p[style-name='heading 3'] => h3:fresh",
    "p[style-name='heading 4'] => h4:fresh",
    "p[style-name='heading 5'] => h5:fresh",
    "p[style-name='heading 6'] => h6:fresh",
    // Apple Pages
    "p.Heading => h1:fresh",
    "p[style-name='Heading'] => h1:fresh",
    "r[style-name='Strong'] => strong",
    "p[style-name='footnote text'] => p:fresh",
    "r[style-name='footnote reference'] =>",
    "p[style-name='endnote text'] => p:fresh",
    "r[style-name='endnote reference'] =>",
    "p[style-name='annotation text'] => p:fresh",
    "r[style-name='annotation reference'] =>",
    // LibreOffice
    "p[style-name='Footnote'] => p:fresh",
    "r[style-name='Footnote anchor'] =>",
    "p[style-name='Endnote'] => p:fresh",
    "r[style-name='Endnote anchor'] =>",
    "p:unordered-list(1) => ul > li:fresh",
    "p:unordered-list(2) => ul|ol > li > ul > li:fresh",
    "p:unordered-list(3) => ul|ol > li > ul|ol > li > ul > li:fresh",
    "p:unordered-list(4) => ul|ol > li > ul|ol > li > ul|ol > li > ul > li:fresh",
    "p:unordered-list(5) => ul|ol > li > ul|ol > li > ul|ol > li > ul|ol > li > ul > li:fresh",
    "p:ordered-list(1) => ol > li:fresh",
    "p:ordered-list(2) => ul|ol > li > ol > li:fresh",
    "p:ordered-list(3) => ul|ol > li > ul|ol > li > ol > li:fresh",
    "p:ordered-list(4) => ul|ol > li > ul|ol > li > ul|ol > li > ol > li:fresh",
    "p:ordered-list(5) => ul|ol > li > ul|ol > li > ul|ol > li > ul|ol > li > ol > li:fresh",
    "r[style-name='Hyperlink'] =>",
    "p[style-name='Normal'] => p:fresh",
    // Apple Pages
    "p.Body => p:fresh",
    "p[style-name='Body'] => p:fresh"
];
var $85dd06109b9e0944$var$standardOptions = $85dd06109b9e0944$export$635424202fde079c = {
    externalFileAccess: false,
    transformDocument: $85dd06109b9e0944$var$identity,
    includeDefaultStyleMap: true,
    includeEmbeddedStyleMap: true
};
function $85dd06109b9e0944$var$readOptions(options) {
    options = options || {};
    return $5yjjJ.default({}, $85dd06109b9e0944$var$standardOptions, options, {
        customStyleMap: $85dd06109b9e0944$var$readStyleMap(options.styleMap),
        readStyleMap: function() {
            var styleMap = this.customStyleMap;
            if (this.includeEmbeddedStyleMap) styleMap = styleMap.concat($85dd06109b9e0944$var$readStyleMap(this.embeddedStyleMap));
            if (this.includeDefaultStyleMap) styleMap = styleMap.concat($85dd06109b9e0944$var$defaultStyleMap);
            return styleMap;
        }
    });
}
function $85dd06109b9e0944$var$readStyleMap(styleMap) {
    if (!styleMap) return [];
    else if ($jmGFg.default(styleMap)) return styleMap.split("\n").map(function(line) {
        return line.trim();
    }).filter(function(line) {
        return line !== "" && line.charAt(0) !== "#";
    });
    else return styleMap;
}
function $85dd06109b9e0944$var$identity(value) {
    return value;
}


var $f489ff3da7c10b03$require$readOptions = $85dd06109b9e0944$export$78af9b5fc65e58de;
var $06ba6368d49e55c3$export$dabc29ca0a11e3cc;

var $d93yU = parcelRequire("d93yU");

$06ba6368d49e55c3$export$dabc29ca0a11e3cc = $06ba6368d49e55c3$var$openZip;
function $06ba6368d49e55c3$var$openZip(options) {
    if (options.arrayBuffer) return $d93yU.resolve($3e56e634a929bca6$export$94ea64f322e5a37c(options.arrayBuffer));
    else return $d93yU.reject(new Error("Could not find file in options"));
}



var $f489ff3da7c10b03$require$Result = $11d28a8fc8838027$export$8fdcabde73f49165;
$f489ff3da7c10b03$export$7b82ddf1ba8788ff = $f489ff3da7c10b03$var$convertToHtml;
$f489ff3da7c10b03$export$16c74263c98473fb = $f489ff3da7c10b03$var$convertToMarkdown;
$f489ff3da7c10b03$export$9c68d69a4c5bbcf9 = $f489ff3da7c10b03$var$convert;
$f489ff3da7c10b03$export$a1ba744cb18565b5 = $f489ff3da7c10b03$var$extractRawText;

$f489ff3da7c10b03$export$6c746a5570b8b35c = (parcelRequire("gOpjt"));

$f489ff3da7c10b03$export$63e4f03d302d3e40 = (parcelRequire("kUMgi"));

$f489ff3da7c10b03$export$425327af25286e5e = (parcelRequire("1OnEJ"));
$f489ff3da7c10b03$export$7d85d7e73199d20c = $f489ff3da7c10b03$var$embedStyleMap;
$f489ff3da7c10b03$export$3d6d846391b5780c = $f489ff3da7c10b03$var$readEmbeddedStyleMap;
function $f489ff3da7c10b03$var$convertToHtml(input, options) {
    return $f489ff3da7c10b03$var$convert(input, options);
}
function $f489ff3da7c10b03$var$convertToMarkdown(input, options) {
    var markdownOptions = Object.create(options || {});
    markdownOptions.outputFormat = "markdown";
    return $f489ff3da7c10b03$var$convert(input, markdownOptions);
}
function $f489ff3da7c10b03$var$convert(input, options) {
    options = $f489ff3da7c10b03$require$readOptions(options);
    return $06ba6368d49e55c3$export$dabc29ca0a11e3cc(input).tap(function(docxFile) {
        return $8adee3ad65dc46ae$export$98fd944a2c837b93(docxFile).then(function(styleMap) {
            options.embeddedStyleMap = styleMap;
        });
    }).then(function(docxFile) {
        return $bae7c73ea3cda3cb$export$aafa59e2e03f2942(docxFile, input, options).then(function(documentResult) {
            return documentResult.map(options.transformDocument);
        }).then(function(documentResult) {
            return $f489ff3da7c10b03$var$convertDocumentToHtml(documentResult, options);
        });
    });
}
function $f489ff3da7c10b03$var$readEmbeddedStyleMap(input) {
    return $06ba6368d49e55c3$export$dabc29ca0a11e3cc(input).then($8adee3ad65dc46ae$export$98fd944a2c837b93);
}
function $f489ff3da7c10b03$var$convertDocumentToHtml(documentResult, options) {
    var styleMapResult = $f489ff3da7c10b03$var$parseStyleMap(options.readStyleMap());
    var parsedOptions = $5yjjJ.default({}, options, {
        styleMap: styleMapResult.value
    });
    var documentConverter = new $f489ff3da7c10b03$require$DocumentConverter(parsedOptions);
    return documentResult.flatMapThen(function(document) {
        return styleMapResult.flatMapThen(function(styleMap) {
            return documentConverter.convertToHtml(document);
        });
    });
}
function $f489ff3da7c10b03$var$parseStyleMap(styleMap) {
    return $f489ff3da7c10b03$require$Result.combine((styleMap || []).map($f489ff3da7c10b03$require$readStyle)).map(function(styleMap) {
        return styleMap.filter(function(styleMapping) {
            return !!styleMapping;
        });
    });
}
function $f489ff3da7c10b03$var$extractRawText(input) {
    return $06ba6368d49e55c3$export$dabc29ca0a11e3cc(input).then($bae7c73ea3cda3cb$export$aafa59e2e03f2942).then(function(documentResult) {
        return documentResult.map($f489ff3da7c10b03$require$convertElementToRawText);
    });
}
function $f489ff3da7c10b03$var$embedStyleMap(input, styleMap) {
    return $06ba6368d49e55c3$export$dabc29ca0a11e3cc(input).tap(function(docxFile) {
        return $8adee3ad65dc46ae$export$f183c412da6b1c0(docxFile, styleMap);
    }).then(function(docxFile) {
        return docxFile.toArrayBuffer();
    }).then(function(arrayBuffer) {
        return {
            toArrayBuffer: function() {
                return arrayBuffer;
            },
            toBuffer: function() {
                return $f489ff3da7c10b03$require$Buffer.from(arrayBuffer);
            }
        };
    });
}
$f489ff3da7c10b03$export$65b53a1b2f72fd4c = function() {
    throw new Error('Use a raw string instead of mammoth.styleMapping e.g. "p[style-name=\'Title\'] => h1" instead of mammoth.styleMapping("p[style-name=\'Title\'] => h1")');
};


var $9fbb89d62e8a72ae$exports = {};
/*! @license DOMPurify 3.4.1 | (c) Cure53 and other contributors | Released under the Apache license 2.0 and Mozilla Public License 2.0 | github.com/cure53/DOMPurify/blob/3.4.1/LICENSE */ (function(global, factory) {
    $9fbb89d62e8a72ae$exports = factory();
})($9fbb89d62e8a72ae$exports, function() {
    'use strict';
    const { entries: entries, setPrototypeOf: setPrototypeOf, isFrozen: isFrozen, getPrototypeOf: getPrototypeOf, getOwnPropertyDescriptor: getOwnPropertyDescriptor } = Object;
    let { freeze: freeze, seal: seal, create: create } = Object; // eslint-disable-line import/no-mutable-exports
    let { apply: apply, construct: construct } = typeof Reflect !== 'undefined' && Reflect;
    if (!freeze) freeze = function freeze(x) {
        return x;
    };
    if (!seal) seal = function seal(x) {
        return x;
    };
    if (!apply) apply = function apply(func, thisArg) {
        for(var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++)args[_key - 2] = arguments[_key];
        return func.apply(thisArg, args);
    };
    if (!construct) construct = function construct(Func) {
        for(var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)args[_key2 - 1] = arguments[_key2];
        return new Func(...args);
    };
    const arrayForEach = unapply(Array.prototype.forEach);
    const arrayLastIndexOf = unapply(Array.prototype.lastIndexOf);
    const arrayPop = unapply(Array.prototype.pop);
    const arrayPush = unapply(Array.prototype.push);
    const arraySplice = unapply(Array.prototype.splice);
    const arrayIsArray = Array.isArray;
    const stringToLowerCase = unapply(String.prototype.toLowerCase);
    const stringToString = unapply(String.prototype.toString);
    const stringMatch = unapply(String.prototype.match);
    const stringReplace = unapply(String.prototype.replace);
    const stringIndexOf = unapply(String.prototype.indexOf);
    const stringTrim = unapply(String.prototype.trim);
    const numberToString = unapply(Number.prototype.toString);
    const booleanToString = unapply(Boolean.prototype.toString);
    const bigintToString = typeof BigInt === 'undefined' ? null : unapply(BigInt.prototype.toString);
    const symbolToString = typeof Symbol === 'undefined' ? null : unapply(Symbol.prototype.toString);
    const objectHasOwnProperty = unapply(Object.prototype.hasOwnProperty);
    const objectToString = unapply(Object.prototype.toString);
    const regExpTest = unapply(RegExp.prototype.test);
    const typeErrorCreate = unconstruct(TypeError);
    /**
     * Creates a new function that calls the given function with a specified thisArg and arguments.
     *
     * @param func - The function to be wrapped and called.
     * @returns A new function that calls the given function with a specified thisArg and arguments.
     */ function unapply(func) {
        return function(thisArg) {
            if (thisArg instanceof RegExp) thisArg.lastIndex = 0;
            for(var _len3 = arguments.length, args = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++)args[_key3 - 1] = arguments[_key3];
            return apply(func, thisArg, args);
        };
    }
    /**
     * Creates a new function that constructs an instance of the given constructor function with the provided arguments.
     *
     * @param func - The constructor function to be wrapped and called.
     * @returns A new function that constructs an instance of the given constructor function with the provided arguments.
     */ function unconstruct(Func) {
        return function() {
            for(var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++)args[_key4] = arguments[_key4];
            return construct(Func, args);
        };
    }
    /**
     * Add properties to a lookup table
     *
     * @param set - The set to which elements will be added.
     * @param array - The array containing elements to be added to the set.
     * @param transformCaseFunc - An optional function to transform the case of each element before adding to the set.
     * @returns The modified set with added elements.
     */ function addToSet(set, array) {
        let transformCaseFunc = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : stringToLowerCase;
        if (setPrototypeOf) // Make 'in' and truthy checks like Boolean(set.constructor)
        // independent of any properties defined on Object.prototype.
        // Prevent prototype setters from intercepting set as a this value.
        setPrototypeOf(set, null);
        if (!arrayIsArray(array)) return set;
        let l = array.length;
        while(l--){
            let element = array[l];
            if (typeof element === 'string') {
                const lcElement = transformCaseFunc(element);
                if (lcElement !== element) {
                    // Config presets (e.g. tags.js, attrs.js) are immutable.
                    if (!isFrozen(array)) array[l] = lcElement;
                    element = lcElement;
                }
            }
            set[element] = true;
        }
        return set;
    }
    /**
     * Clean up an array to harden against CSPP
     *
     * @param array - The array to be cleaned.
     * @returns The cleaned version of the array
     */ function cleanArray(array) {
        for(let index = 0; index < array.length; index++){
            const isPropertyExist = objectHasOwnProperty(array, index);
            if (!isPropertyExist) array[index] = null;
        }
        return array;
    }
    /**
     * Shallow clone an object
     *
     * @param object - The object to be cloned.
     * @returns A new object that copies the original.
     */ function clone(object) {
        const newObject = create(null);
        for (const [property, value] of entries(object)){
            const isPropertyExist = objectHasOwnProperty(object, property);
            if (isPropertyExist) {
                if (arrayIsArray(value)) newObject[property] = cleanArray(value);
                else if (value && typeof value === 'object' && value.constructor === Object) newObject[property] = clone(value);
                else newObject[property] = value;
            }
        }
        return newObject;
    }
    /**
     * Convert non-node values into strings without depending on direct property access.
     *
     * @param value - The value to stringify.
     * @returns A string representation of the provided value.
     */ function stringifyValue(value) {
        switch(typeof value){
            case 'string':
                return value;
            case 'number':
                return numberToString(value);
            case 'boolean':
                return booleanToString(value);
            case 'bigint':
                return bigintToString ? bigintToString(value) : '0';
            case 'symbol':
                return symbolToString ? symbolToString(value) : 'Symbol()';
            case 'undefined':
                return objectToString(value);
            case 'function':
            case 'object':
                {
                    if (value === null) return objectToString(value);
                    const valueAsRecord = value;
                    const valueToString = lookupGetter(valueAsRecord, 'toString');
                    if (typeof valueToString === 'function') {
                        const stringified = valueToString(valueAsRecord);
                        return typeof stringified === 'string' ? stringified : objectToString(stringified);
                    }
                    return objectToString(value);
                }
            default:
                return objectToString(value);
        }
    }
    /**
     * This method automatically checks if the prop is function or getter and behaves accordingly.
     *
     * @param object - The object to look up the getter function in its prototype chain.
     * @param prop - The property name for which to find the getter function.
     * @returns The getter function found in the prototype chain or a fallback function.
     */ function lookupGetter(object, prop) {
        while(object !== null){
            const desc = getOwnPropertyDescriptor(object, prop);
            if (desc) {
                if (desc.get) return unapply(desc.get);
                if (typeof desc.value === 'function') return unapply(desc.value);
            }
            object = getPrototypeOf(object);
        }
        function fallbackValue() {
            return null;
        }
        return fallbackValue;
    }
    function isRegex(value) {
        try {
            regExpTest(value, '');
            return true;
        } catch (_unused) {
            return false;
        }
    }
    const html$1 = freeze([
        'a',
        'abbr',
        'acronym',
        'address',
        'area',
        'article',
        'aside',
        'audio',
        'b',
        'bdi',
        'bdo',
        'big',
        'blink',
        'blockquote',
        'body',
        'br',
        'button',
        'canvas',
        'caption',
        'center',
        'cite',
        'code',
        'col',
        'colgroup',
        'content',
        'data',
        'datalist',
        'dd',
        'decorator',
        'del',
        'details',
        'dfn',
        'dialog',
        'dir',
        'div',
        'dl',
        'dt',
        'element',
        'em',
        'fieldset',
        'figcaption',
        'figure',
        'font',
        'footer',
        'form',
        'h1',
        'h2',
        'h3',
        'h4',
        'h5',
        'h6',
        'head',
        'header',
        'hgroup',
        'hr',
        'html',
        'i',
        'img',
        'input',
        'ins',
        'kbd',
        'label',
        'legend',
        'li',
        'main',
        'map',
        'mark',
        'marquee',
        'menu',
        'menuitem',
        'meter',
        'nav',
        'nobr',
        'ol',
        'optgroup',
        'option',
        'output',
        'p',
        'picture',
        'pre',
        'progress',
        'q',
        'rp',
        'rt',
        'ruby',
        's',
        'samp',
        'search',
        'section',
        'select',
        'shadow',
        'slot',
        'small',
        'source',
        'spacer',
        'span',
        'strike',
        'strong',
        'style',
        'sub',
        'summary',
        'sup',
        'table',
        'tbody',
        'td',
        'template',
        'textarea',
        'tfoot',
        'th',
        'thead',
        'time',
        'tr',
        'track',
        'tt',
        'u',
        'ul',
        'var',
        'video',
        'wbr'
    ]);
    const svg$1 = freeze([
        'svg',
        'a',
        'altglyph',
        'altglyphdef',
        'altglyphitem',
        'animatecolor',
        'animatemotion',
        'animatetransform',
        'circle',
        'clippath',
        'defs',
        'desc',
        'ellipse',
        'enterkeyhint',
        'exportparts',
        'filter',
        'font',
        'g',
        'glyph',
        'glyphref',
        'hkern',
        'image',
        'inputmode',
        'line',
        'lineargradient',
        'marker',
        'mask',
        'metadata',
        'mpath',
        'part',
        'path',
        'pattern',
        'polygon',
        'polyline',
        'radialgradient',
        'rect',
        'stop',
        'style',
        'switch',
        'symbol',
        'text',
        'textpath',
        'title',
        'tref',
        'tspan',
        'view',
        'vkern'
    ]);
    const svgFilters = freeze([
        'feBlend',
        'feColorMatrix',
        'feComponentTransfer',
        'feComposite',
        'feConvolveMatrix',
        'feDiffuseLighting',
        'feDisplacementMap',
        'feDistantLight',
        'feDropShadow',
        'feFlood',
        'feFuncA',
        'feFuncB',
        'feFuncG',
        'feFuncR',
        'feGaussianBlur',
        'feImage',
        'feMerge',
        'feMergeNode',
        'feMorphology',
        'feOffset',
        'fePointLight',
        'feSpecularLighting',
        'feSpotLight',
        'feTile',
        'feTurbulence'
    ]);
    // List of SVG elements that are disallowed by default.
    // We still need to know them so that we can do namespace
    // checks properly in case one wants to add them to
    // allow-list.
    const svgDisallowed = freeze([
        'animate',
        'color-profile',
        'cursor',
        'discard',
        'font-face',
        'font-face-format',
        'font-face-name',
        'font-face-src',
        'font-face-uri',
        'foreignobject',
        'hatch',
        'hatchpath',
        'mesh',
        'meshgradient',
        'meshpatch',
        'meshrow',
        'missing-glyph',
        'script',
        'set',
        'solidcolor',
        'unknown',
        'use'
    ]);
    const mathMl$1 = freeze([
        'math',
        'menclose',
        'merror',
        'mfenced',
        'mfrac',
        'mglyph',
        'mi',
        'mlabeledtr',
        'mmultiscripts',
        'mn',
        'mo',
        'mover',
        'mpadded',
        'mphantom',
        'mroot',
        'mrow',
        'ms',
        'mspace',
        'msqrt',
        'mstyle',
        'msub',
        'msup',
        'msubsup',
        'mtable',
        'mtd',
        'mtext',
        'mtr',
        'munder',
        'munderover',
        'mprescripts'
    ]);
    // Similarly to SVG, we want to know all MathML elements,
    // even those that we disallow by default.
    const mathMlDisallowed = freeze([
        'maction',
        'maligngroup',
        'malignmark',
        'mlongdiv',
        'mscarries',
        'mscarry',
        'msgroup',
        'mstack',
        'msline',
        'msrow',
        'semantics',
        'annotation',
        'annotation-xml',
        'mprescripts',
        'none'
    ]);
    const text = freeze([
        '#text'
    ]);
    const html = freeze([
        'accept',
        'action',
        'align',
        'alt',
        'autocapitalize',
        'autocomplete',
        'autopictureinpicture',
        'autoplay',
        'background',
        'bgcolor',
        'border',
        'capture',
        'cellpadding',
        'cellspacing',
        'checked',
        'cite',
        'class',
        'clear',
        'color',
        'cols',
        'colspan',
        'controls',
        'controlslist',
        'coords',
        'crossorigin',
        'datetime',
        'decoding',
        'default',
        'dir',
        'disabled',
        'disablepictureinpicture',
        'disableremoteplayback',
        'download',
        'draggable',
        'enctype',
        'enterkeyhint',
        'exportparts',
        'face',
        'for',
        'headers',
        'height',
        'hidden',
        'high',
        'href',
        'hreflang',
        'id',
        'inert',
        'inputmode',
        'integrity',
        'ismap',
        'kind',
        'label',
        'lang',
        'list',
        'loading',
        'loop',
        'low',
        'max',
        'maxlength',
        'media',
        'method',
        'min',
        'minlength',
        'multiple',
        'muted',
        'name',
        'nonce',
        'noshade',
        'novalidate',
        'nowrap',
        'open',
        'optimum',
        'part',
        'pattern',
        'placeholder',
        'playsinline',
        'popover',
        'popovertarget',
        'popovertargetaction',
        'poster',
        'preload',
        'pubdate',
        'radiogroup',
        'readonly',
        'rel',
        'required',
        'rev',
        'reversed',
        'role',
        'rows',
        'rowspan',
        'spellcheck',
        'scope',
        'selected',
        'shape',
        'size',
        'sizes',
        'slot',
        'span',
        'srclang',
        'start',
        'src',
        'srcset',
        'step',
        'style',
        'summary',
        'tabindex',
        'title',
        'translate',
        'type',
        'usemap',
        'valign',
        'value',
        'width',
        'wrap',
        'xmlns'
    ]);
    const svg = freeze([
        'accent-height',
        'accumulate',
        'additive',
        'alignment-baseline',
        'amplitude',
        'ascent',
        'attributename',
        'attributetype',
        'azimuth',
        'basefrequency',
        'baseline-shift',
        'begin',
        'bias',
        'by',
        'class',
        'clip',
        'clippathunits',
        'clip-path',
        'clip-rule',
        'color',
        'color-interpolation',
        'color-interpolation-filters',
        'color-profile',
        'color-rendering',
        'cx',
        'cy',
        'd',
        'dx',
        'dy',
        'diffuseconstant',
        'direction',
        'display',
        'divisor',
        'dur',
        'edgemode',
        'elevation',
        'end',
        'exponent',
        'fill',
        'fill-opacity',
        'fill-rule',
        'filter',
        'filterunits',
        'flood-color',
        'flood-opacity',
        'font-family',
        'font-size',
        'font-size-adjust',
        'font-stretch',
        'font-style',
        'font-variant',
        'font-weight',
        'fx',
        'fy',
        'g1',
        'g2',
        'glyph-name',
        'glyphref',
        'gradientunits',
        'gradienttransform',
        'height',
        'href',
        'id',
        'image-rendering',
        'in',
        'in2',
        'intercept',
        'k',
        'k1',
        'k2',
        'k3',
        'k4',
        'kerning',
        'keypoints',
        'keysplines',
        'keytimes',
        'lang',
        'lengthadjust',
        'letter-spacing',
        'kernelmatrix',
        'kernelunitlength',
        'lighting-color',
        'local',
        'marker-end',
        'marker-mid',
        'marker-start',
        'markerheight',
        'markerunits',
        'markerwidth',
        'maskcontentunits',
        'maskunits',
        'max',
        'mask',
        'mask-type',
        'media',
        'method',
        'mode',
        'min',
        'name',
        'numoctaves',
        'offset',
        'operator',
        'opacity',
        'order',
        'orient',
        'orientation',
        'origin',
        'overflow',
        'paint-order',
        'path',
        'pathlength',
        'patterncontentunits',
        'patterntransform',
        'patternunits',
        'points',
        'preservealpha',
        'preserveaspectratio',
        'primitiveunits',
        'r',
        'rx',
        'ry',
        'radius',
        'refx',
        'refy',
        'repeatcount',
        'repeatdur',
        'restart',
        'result',
        'rotate',
        'scale',
        'seed',
        'shape-rendering',
        'slope',
        'specularconstant',
        'specularexponent',
        'spreadmethod',
        'startoffset',
        'stddeviation',
        'stitchtiles',
        'stop-color',
        'stop-opacity',
        'stroke-dasharray',
        'stroke-dashoffset',
        'stroke-linecap',
        'stroke-linejoin',
        'stroke-miterlimit',
        'stroke-opacity',
        'stroke',
        'stroke-width',
        'style',
        'surfacescale',
        'systemlanguage',
        'tabindex',
        'tablevalues',
        'targetx',
        'targety',
        'transform',
        'transform-origin',
        'text-anchor',
        'text-decoration',
        'text-rendering',
        'textlength',
        'type',
        'u1',
        'u2',
        'unicode',
        'values',
        'viewbox',
        'visibility',
        'version',
        'vert-adv-y',
        'vert-origin-x',
        'vert-origin-y',
        'width',
        'word-spacing',
        'wrap',
        'writing-mode',
        'xchannelselector',
        'ychannelselector',
        'x',
        'x1',
        'x2',
        'xmlns',
        'y',
        'y1',
        'y2',
        'z',
        'zoomandpan'
    ]);
    const mathMl = freeze([
        'accent',
        'accentunder',
        'align',
        'bevelled',
        'close',
        'columnalign',
        'columnlines',
        'columnspacing',
        'columnspan',
        'denomalign',
        'depth',
        'dir',
        'display',
        'displaystyle',
        'encoding',
        'fence',
        'frame',
        'height',
        'href',
        'id',
        'largeop',
        'length',
        'linethickness',
        'lquote',
        'lspace',
        'mathbackground',
        'mathcolor',
        'mathsize',
        'mathvariant',
        'maxsize',
        'minsize',
        'movablelimits',
        'notation',
        'numalign',
        'open',
        'rowalign',
        'rowlines',
        'rowspacing',
        'rowspan',
        'rspace',
        'rquote',
        'scriptlevel',
        'scriptminsize',
        'scriptsizemultiplier',
        'selection',
        'separator',
        'separators',
        'stretchy',
        'subscriptshift',
        'supscriptshift',
        'symmetric',
        'voffset',
        'width',
        'xmlns'
    ]);
    const xml = freeze([
        'xlink:href',
        'xml:id',
        'xlink:title',
        'xml:space',
        'xmlns:xlink'
    ]);
    // eslint-disable-next-line unicorn/better-regex
    const MUSTACHE_EXPR = seal(/\{\{[\w\W]*|[\w\W]*\}\}/gm); // Specify template detection regex for SAFE_FOR_TEMPLATES mode
    const ERB_EXPR = seal(/<%[\w\W]*|[\w\W]*%>/gm);
    const TMPLIT_EXPR = seal(/\$\{[\w\W]*/gm); // eslint-disable-line unicorn/better-regex
    const DATA_ATTR = seal(/^data-[\-\w.\u00B7-\uFFFF]+$/); // eslint-disable-line no-useless-escape
    const ARIA_ATTR = seal(/^aria-[\-\w]+$/); // eslint-disable-line no-useless-escape
    const IS_ALLOWED_URI = seal(/^(?:(?:(?:f|ht)tps?|mailto|tel|callto|sms|cid|xmpp|matrix):|[^a-z]|[a-z+.\-]+(?:[^a-z+.\-:]|$))/i // eslint-disable-line no-useless-escape
    );
    const IS_SCRIPT_OR_DATA = seal(/^(?:\w+script|data):/i);
    const ATTR_WHITESPACE = seal(/[\u0000-\u0020\u00A0\u1680\u180E\u2000-\u2029\u205F\u3000]/g // eslint-disable-line no-control-regex
    );
    const DOCTYPE_NAME = seal(/^html$/i);
    const CUSTOM_ELEMENT = seal(/^[a-z][.\w]*(-[.\w]+)+$/i);
    var EXPRESSIONS = /*#__PURE__*/ Object.freeze({
        __proto__: null,
        ARIA_ATTR: ARIA_ATTR,
        ATTR_WHITESPACE: ATTR_WHITESPACE,
        CUSTOM_ELEMENT: CUSTOM_ELEMENT,
        DATA_ATTR: DATA_ATTR,
        DOCTYPE_NAME: DOCTYPE_NAME,
        ERB_EXPR: ERB_EXPR,
        IS_ALLOWED_URI: IS_ALLOWED_URI,
        IS_SCRIPT_OR_DATA: IS_SCRIPT_OR_DATA,
        MUSTACHE_EXPR: MUSTACHE_EXPR,
        TMPLIT_EXPR: TMPLIT_EXPR
    });
    /* eslint-disable @typescript-eslint/indent */ // https://developer.mozilla.org/en-US/docs/Web/API/Node/nodeType
    const NODE_TYPE = {
        element: 1,
        text: 3,
        // Deprecated
        progressingInstruction: 7,
        comment: 8,
        document: 9
    };
    const getGlobal = function getGlobal() {
        return typeof window === 'undefined' ? null : window;
    };
    /**
     * Creates a no-op policy for internal use only.
     * Don't export this function outside this module!
     * @param trustedTypes The policy factory.
     * @param purifyHostElement The Script element used to load DOMPurify (to determine policy name suffix).
     * @return The policy created (or null, if Trusted Types
     * are not supported or creating the policy failed).
     */ const _createTrustedTypesPolicy = function _createTrustedTypesPolicy(trustedTypes, purifyHostElement) {
        if (typeof trustedTypes !== 'object' || typeof trustedTypes.createPolicy !== 'function') return null;
        // Allow the callers to control the unique policy name
        // by adding a data-tt-policy-suffix to the script element with the DOMPurify.
        // Policy creation with duplicate names throws in Trusted Types.
        let suffix = null;
        const ATTR_NAME = 'data-tt-policy-suffix';
        if (purifyHostElement && purifyHostElement.hasAttribute(ATTR_NAME)) suffix = purifyHostElement.getAttribute(ATTR_NAME);
        const policyName = 'dompurify' + (suffix ? '#' + suffix : '');
        try {
            return trustedTypes.createPolicy(policyName, {
                createHTML (html) {
                    return html;
                },
                createScriptURL (scriptUrl) {
                    return scriptUrl;
                }
            });
        } catch (_) {
            // Policy creation failed (most likely another DOMPurify script has
            // already run). Skip creating the policy, as this will only cause errors
            // if TT are enforced.
            console.warn('TrustedTypes policy ' + policyName + ' could not be created.');
            return null;
        }
    };
    const _createHooksMap = function _createHooksMap() {
        return {
            afterSanitizeAttributes: [],
            afterSanitizeElements: [],
            afterSanitizeShadowDOM: [],
            beforeSanitizeAttributes: [],
            beforeSanitizeElements: [],
            beforeSanitizeShadowDOM: [],
            uponSanitizeAttribute: [],
            uponSanitizeElement: [],
            uponSanitizeShadowNode: []
        };
    };
    function createDOMPurify() {
        let window1 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : getGlobal();
        const DOMPurify = (root)=>createDOMPurify(root);
        DOMPurify.version = '3.4.1';
        DOMPurify.removed = [];
        if (!window1 || !window1.document || window1.document.nodeType !== NODE_TYPE.document || !window1.Element) {
            // Not running in a browser, provide a factory function
            // so that you can pass your own Window
            DOMPurify.isSupported = false;
            return DOMPurify;
        }
        let { document: document } = window1;
        const originalDocument = document;
        const currentScript = originalDocument.currentScript;
        const { DocumentFragment: DocumentFragment, HTMLTemplateElement: HTMLTemplateElement, Node: Node, Element: Element, NodeFilter: NodeFilter, NamedNodeMap: NamedNodeMap = window1.NamedNodeMap || window1.MozNamedAttrMap, HTMLFormElement: HTMLFormElement, DOMParser: DOMParser, trustedTypes: trustedTypes } = window1;
        const ElementPrototype = Element.prototype;
        const cloneNode = lookupGetter(ElementPrototype, 'cloneNode');
        const remove = lookupGetter(ElementPrototype, 'remove');
        const getNextSibling = lookupGetter(ElementPrototype, 'nextSibling');
        const getChildNodes = lookupGetter(ElementPrototype, 'childNodes');
        const getParentNode = lookupGetter(ElementPrototype, 'parentNode');
        // As per issue #47, the web-components registry is inherited by a
        // new document created via createHTMLDocument. As per the spec
        // (http://w3c.github.io/webcomponents/spec/custom/#creating-and-passing-registries)
        // a new empty registry is used when creating a template contents owner
        // document, so we use that as our parent document to ensure nothing
        // is inherited.
        if (typeof HTMLTemplateElement === 'function') {
            const template = document.createElement('template');
            if (template.content && template.content.ownerDocument) document = template.content.ownerDocument;
        }
        let trustedTypesPolicy;
        let emptyHTML = '';
        const { implementation: implementation, createNodeIterator: createNodeIterator, createDocumentFragment: createDocumentFragment, getElementsByTagName: getElementsByTagName } = document;
        const { importNode: importNode } = originalDocument;
        let hooks = _createHooksMap();
        /**
       * Expose whether this browser supports running the full DOMPurify.
       */ DOMPurify.isSupported = typeof entries === 'function' && typeof getParentNode === 'function' && implementation && implementation.createHTMLDocument !== undefined;
        const { MUSTACHE_EXPR: MUSTACHE_EXPR, ERB_EXPR: ERB_EXPR, TMPLIT_EXPR: TMPLIT_EXPR, DATA_ATTR: DATA_ATTR, ARIA_ATTR: ARIA_ATTR, IS_SCRIPT_OR_DATA: IS_SCRIPT_OR_DATA, ATTR_WHITESPACE: ATTR_WHITESPACE, CUSTOM_ELEMENT: CUSTOM_ELEMENT } = EXPRESSIONS;
        let { IS_ALLOWED_URI: IS_ALLOWED_URI$1 } = EXPRESSIONS;
        /**
       * We consider the elements and attributes below to be safe. Ideally
       * don't add any new ones but feel free to remove unwanted ones.
       */ /* allowed element names */ let ALLOWED_TAGS = null;
        const DEFAULT_ALLOWED_TAGS = addToSet({}, [
            ...html$1,
            ...svg$1,
            ...svgFilters,
            ...mathMl$1,
            ...text
        ]);
        /* Allowed attribute names */ let ALLOWED_ATTR = null;
        const DEFAULT_ALLOWED_ATTR = addToSet({}, [
            ...html,
            ...svg,
            ...mathMl,
            ...xml
        ]);
        /*
       * Configure how DOMPurify should handle custom elements and their attributes as well as customized built-in elements.
       * @property {RegExp|Function|null} tagNameCheck one of [null, regexPattern, predicate]. Default: `null` (disallow any custom elements)
       * @property {RegExp|Function|null} attributeNameCheck one of [null, regexPattern, predicate]. Default: `null` (disallow any attributes not on the allow list)
       * @property {boolean} allowCustomizedBuiltInElements allow custom elements derived from built-ins if they pass CUSTOM_ELEMENT_HANDLING.tagNameCheck. Default: `false`.
       */ let CUSTOM_ELEMENT_HANDLING = Object.seal(create(null, {
            tagNameCheck: {
                writable: true,
                configurable: false,
                enumerable: true,
                value: null
            },
            attributeNameCheck: {
                writable: true,
                configurable: false,
                enumerable: true,
                value: null
            },
            allowCustomizedBuiltInElements: {
                writable: true,
                configurable: false,
                enumerable: true,
                value: false
            }
        }));
        /* Explicitly forbidden tags (overrides ALLOWED_TAGS/ADD_TAGS) */ let FORBID_TAGS = null;
        /* Explicitly forbidden attributes (overrides ALLOWED_ATTR/ADD_ATTR) */ let FORBID_ATTR = null;
        /* Config object to store ADD_TAGS/ADD_ATTR functions (when used as functions) */ const EXTRA_ELEMENT_HANDLING = Object.seal(create(null, {
            tagCheck: {
                writable: true,
                configurable: false,
                enumerable: true,
                value: null
            },
            attributeCheck: {
                writable: true,
                configurable: false,
                enumerable: true,
                value: null
            }
        }));
        /* Decide if ARIA attributes are okay */ let ALLOW_ARIA_ATTR = true;
        /* Decide if custom data attributes are okay */ let ALLOW_DATA_ATTR = true;
        /* Decide if unknown protocols are okay */ let ALLOW_UNKNOWN_PROTOCOLS = false;
        /* Decide if self-closing tags in attributes are allowed.
       * Usually removed due to a mXSS issue in jQuery 3.0 */ let ALLOW_SELF_CLOSE_IN_ATTR = true;
        /* Output should be safe for common template engines.
       * This means, DOMPurify removes data attributes, mustaches and ERB
       */ let SAFE_FOR_TEMPLATES = false;
        /* Output should be safe even for XML used within HTML and alike.
       * This means, DOMPurify removes comments when containing risky content.
       */ let SAFE_FOR_XML = true;
        /* Decide if document with <html>... should be returned */ let WHOLE_DOCUMENT = false;
        /* Track whether config is already set on this instance of DOMPurify. */ let SET_CONFIG = false;
        /* Decide if all elements (e.g. style, script) must be children of
       * document.body. By default, browsers might move them to document.head */ let FORCE_BODY = false;
        /* Decide if a DOM `HTMLBodyElement` should be returned, instead of a html
       * string (or a TrustedHTML object if Trusted Types are supported).
       * If `WHOLE_DOCUMENT` is enabled a `HTMLHtmlElement` will be returned instead
       */ let RETURN_DOM = false;
        /* Decide if a DOM `DocumentFragment` should be returned, instead of a html
       * string  (or a TrustedHTML object if Trusted Types are supported) */ let RETURN_DOM_FRAGMENT = false;
        /* Try to return a Trusted Type object instead of a string, return a string in
       * case Trusted Types are not supported  */ let RETURN_TRUSTED_TYPE = false;
        /* Output should be free from DOM clobbering attacks?
       * This sanitizes markups named with colliding, clobberable built-in DOM APIs.
       */ let SANITIZE_DOM = true;
        /* Achieve full DOM Clobbering protection by isolating the namespace of named
       * properties and JS variables, mitigating attacks that abuse the HTML/DOM spec rules.
       *
       * HTML/DOM spec rules that enable DOM Clobbering:
       *   - Named Access on Window (§7.3.3)
       *   - DOM Tree Accessors (§3.1.5)
       *   - Form Element Parent-Child Relations (§4.10.3)
       *   - Iframe srcdoc / Nested WindowProxies (§4.8.5)
       *   - HTMLCollection (§4.2.10.2)
       *
       * Namespace isolation is implemented by prefixing `id` and `name` attributes
       * with a constant string, i.e., `user-content-`
       */ let SANITIZE_NAMED_PROPS = false;
        const SANITIZE_NAMED_PROPS_PREFIX = 'user-content-';
        /* Keep element content when removing element? */ let KEEP_CONTENT = true;
        /* If a `Node` is passed to sanitize(), then performs sanitization in-place instead
       * of importing it into a new Document and returning a sanitized copy */ let IN_PLACE = false;
        /* Allow usage of profiles like html, svg and mathMl */ let USE_PROFILES = {};
        /* Tags to ignore content of when KEEP_CONTENT is true */ let FORBID_CONTENTS = null;
        const DEFAULT_FORBID_CONTENTS = addToSet({}, [
            'annotation-xml',
            'audio',
            'colgroup',
            'desc',
            'foreignobject',
            'head',
            'iframe',
            'math',
            'mi',
            'mn',
            'mo',
            'ms',
            'mtext',
            'noembed',
            'noframes',
            'noscript',
            'plaintext',
            'script',
            'style',
            'svg',
            'template',
            'thead',
            'title',
            'video',
            'xmp'
        ]);
        /* Tags that are safe for data: URIs */ let DATA_URI_TAGS = null;
        const DEFAULT_DATA_URI_TAGS = addToSet({}, [
            'audio',
            'video',
            'img',
            'source',
            'image',
            'track'
        ]);
        /* Attributes safe for values like "javascript:" */ let URI_SAFE_ATTRIBUTES = null;
        const DEFAULT_URI_SAFE_ATTRIBUTES = addToSet({}, [
            'alt',
            'class',
            'for',
            'id',
            'label',
            'name',
            'pattern',
            'placeholder',
            'role',
            'summary',
            'title',
            'value',
            'style',
            'xmlns'
        ]);
        const MATHML_NAMESPACE = 'http://www.w3.org/1998/Math/MathML';
        const SVG_NAMESPACE = 'http://www.w3.org/2000/svg';
        const HTML_NAMESPACE = 'http://www.w3.org/1999/xhtml';
        /* Document namespace */ let NAMESPACE = HTML_NAMESPACE;
        let IS_EMPTY_INPUT = false;
        /* Allowed XHTML+XML namespaces */ let ALLOWED_NAMESPACES = null;
        const DEFAULT_ALLOWED_NAMESPACES = addToSet({}, [
            MATHML_NAMESPACE,
            SVG_NAMESPACE,
            HTML_NAMESPACE
        ], stringToString);
        let MATHML_TEXT_INTEGRATION_POINTS = addToSet({}, [
            'mi',
            'mo',
            'mn',
            'ms',
            'mtext'
        ]);
        let HTML_INTEGRATION_POINTS = addToSet({}, [
            'annotation-xml'
        ]);
        // Certain elements are allowed in both SVG and HTML
        // namespace. We need to specify them explicitly
        // so that they don't get erroneously deleted from
        // HTML namespace.
        const COMMON_SVG_AND_HTML_ELEMENTS = addToSet({}, [
            'title',
            'style',
            'font',
            'a',
            'script'
        ]);
        /* Parsing of strict XHTML documents */ let PARSER_MEDIA_TYPE = null;
        const SUPPORTED_PARSER_MEDIA_TYPES = [
            'application/xhtml+xml',
            'text/html'
        ];
        const DEFAULT_PARSER_MEDIA_TYPE = 'text/html';
        let transformCaseFunc = null;
        /* Keep a reference to config to pass to hooks */ let CONFIG = null;
        /* Ideally, do not touch anything below this line */ /* ______________________________________________ */ const formElement = document.createElement('form');
        const isRegexOrFunction = function isRegexOrFunction(testValue) {
            return testValue instanceof RegExp || testValue instanceof Function;
        };
        /**
       * _parseConfig
       *
       * @param cfg optional config literal
       */ // eslint-disable-next-line complexity
        const _parseConfig = function _parseConfig() {
            let cfg = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
            if (CONFIG && CONFIG === cfg) return;
            /* Shield configuration object from tampering */ if (!cfg || typeof cfg !== 'object') cfg = {};
            /* Shield configuration object from prototype pollution */ cfg = clone(cfg);
            PARSER_MEDIA_TYPE = // eslint-disable-next-line unicorn/prefer-includes
            SUPPORTED_PARSER_MEDIA_TYPES.indexOf(cfg.PARSER_MEDIA_TYPE) === -1 ? DEFAULT_PARSER_MEDIA_TYPE : cfg.PARSER_MEDIA_TYPE;
            // HTML tags and attributes are not case-sensitive, converting to lowercase. Keeping XHTML as is.
            transformCaseFunc = PARSER_MEDIA_TYPE === 'application/xhtml+xml' ? stringToString : stringToLowerCase;
            /* Set configuration parameters */ ALLOWED_TAGS = objectHasOwnProperty(cfg, 'ALLOWED_TAGS') && arrayIsArray(cfg.ALLOWED_TAGS) ? addToSet({}, cfg.ALLOWED_TAGS, transformCaseFunc) : DEFAULT_ALLOWED_TAGS;
            ALLOWED_ATTR = objectHasOwnProperty(cfg, 'ALLOWED_ATTR') && arrayIsArray(cfg.ALLOWED_ATTR) ? addToSet({}, cfg.ALLOWED_ATTR, transformCaseFunc) : DEFAULT_ALLOWED_ATTR;
            ALLOWED_NAMESPACES = objectHasOwnProperty(cfg, 'ALLOWED_NAMESPACES') && arrayIsArray(cfg.ALLOWED_NAMESPACES) ? addToSet({}, cfg.ALLOWED_NAMESPACES, stringToString) : DEFAULT_ALLOWED_NAMESPACES;
            URI_SAFE_ATTRIBUTES = objectHasOwnProperty(cfg, 'ADD_URI_SAFE_ATTR') && arrayIsArray(cfg.ADD_URI_SAFE_ATTR) ? addToSet(clone(DEFAULT_URI_SAFE_ATTRIBUTES), cfg.ADD_URI_SAFE_ATTR, transformCaseFunc) : DEFAULT_URI_SAFE_ATTRIBUTES;
            DATA_URI_TAGS = objectHasOwnProperty(cfg, 'ADD_DATA_URI_TAGS') && arrayIsArray(cfg.ADD_DATA_URI_TAGS) ? addToSet(clone(DEFAULT_DATA_URI_TAGS), cfg.ADD_DATA_URI_TAGS, transformCaseFunc) : DEFAULT_DATA_URI_TAGS;
            FORBID_CONTENTS = objectHasOwnProperty(cfg, 'FORBID_CONTENTS') && arrayIsArray(cfg.FORBID_CONTENTS) ? addToSet({}, cfg.FORBID_CONTENTS, transformCaseFunc) : DEFAULT_FORBID_CONTENTS;
            FORBID_TAGS = objectHasOwnProperty(cfg, 'FORBID_TAGS') && arrayIsArray(cfg.FORBID_TAGS) ? addToSet({}, cfg.FORBID_TAGS, transformCaseFunc) : clone({});
            FORBID_ATTR = objectHasOwnProperty(cfg, 'FORBID_ATTR') && arrayIsArray(cfg.FORBID_ATTR) ? addToSet({}, cfg.FORBID_ATTR, transformCaseFunc) : clone({});
            USE_PROFILES = objectHasOwnProperty(cfg, 'USE_PROFILES') ? cfg.USE_PROFILES && typeof cfg.USE_PROFILES === 'object' ? clone(cfg.USE_PROFILES) : cfg.USE_PROFILES : false;
            ALLOW_ARIA_ATTR = cfg.ALLOW_ARIA_ATTR !== false; // Default true
            ALLOW_DATA_ATTR = cfg.ALLOW_DATA_ATTR !== false; // Default true
            ALLOW_UNKNOWN_PROTOCOLS = cfg.ALLOW_UNKNOWN_PROTOCOLS || false; // Default false
            ALLOW_SELF_CLOSE_IN_ATTR = cfg.ALLOW_SELF_CLOSE_IN_ATTR !== false; // Default true
            SAFE_FOR_TEMPLATES = cfg.SAFE_FOR_TEMPLATES || false; // Default false
            SAFE_FOR_XML = cfg.SAFE_FOR_XML !== false; // Default true
            WHOLE_DOCUMENT = cfg.WHOLE_DOCUMENT || false; // Default false
            RETURN_DOM = cfg.RETURN_DOM || false; // Default false
            RETURN_DOM_FRAGMENT = cfg.RETURN_DOM_FRAGMENT || false; // Default false
            RETURN_TRUSTED_TYPE = cfg.RETURN_TRUSTED_TYPE || false; // Default false
            FORCE_BODY = cfg.FORCE_BODY || false; // Default false
            SANITIZE_DOM = cfg.SANITIZE_DOM !== false; // Default true
            SANITIZE_NAMED_PROPS = cfg.SANITIZE_NAMED_PROPS || false; // Default false
            KEEP_CONTENT = cfg.KEEP_CONTENT !== false; // Default true
            IN_PLACE = cfg.IN_PLACE || false; // Default false
            IS_ALLOWED_URI$1 = isRegex(cfg.ALLOWED_URI_REGEXP) ? cfg.ALLOWED_URI_REGEXP : IS_ALLOWED_URI; // Default regexp
            NAMESPACE = typeof cfg.NAMESPACE === 'string' ? cfg.NAMESPACE : HTML_NAMESPACE; // Default HTML namespace
            MATHML_TEXT_INTEGRATION_POINTS = objectHasOwnProperty(cfg, 'MATHML_TEXT_INTEGRATION_POINTS') && cfg.MATHML_TEXT_INTEGRATION_POINTS && typeof cfg.MATHML_TEXT_INTEGRATION_POINTS === 'object' ? clone(cfg.MATHML_TEXT_INTEGRATION_POINTS) : addToSet({}, [
                'mi',
                'mo',
                'mn',
                'ms',
                'mtext'
            ]); // Default built-in map
            HTML_INTEGRATION_POINTS = objectHasOwnProperty(cfg, 'HTML_INTEGRATION_POINTS') && cfg.HTML_INTEGRATION_POINTS && typeof cfg.HTML_INTEGRATION_POINTS === 'object' ? clone(cfg.HTML_INTEGRATION_POINTS) : addToSet({}, [
                'annotation-xml'
            ]); // Default built-in map
            const customElementHandling = objectHasOwnProperty(cfg, 'CUSTOM_ELEMENT_HANDLING') && cfg.CUSTOM_ELEMENT_HANDLING && typeof cfg.CUSTOM_ELEMENT_HANDLING === 'object' ? clone(cfg.CUSTOM_ELEMENT_HANDLING) : create(null);
            CUSTOM_ELEMENT_HANDLING = create(null);
            if (objectHasOwnProperty(customElementHandling, 'tagNameCheck') && isRegexOrFunction(customElementHandling.tagNameCheck)) CUSTOM_ELEMENT_HANDLING.tagNameCheck = customElementHandling.tagNameCheck; // Default undefined
            if (objectHasOwnProperty(customElementHandling, 'attributeNameCheck') && isRegexOrFunction(customElementHandling.attributeNameCheck)) CUSTOM_ELEMENT_HANDLING.attributeNameCheck = customElementHandling.attributeNameCheck; // Default undefined
            if (objectHasOwnProperty(customElementHandling, 'allowCustomizedBuiltInElements') && typeof customElementHandling.allowCustomizedBuiltInElements === 'boolean') CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements = customElementHandling.allowCustomizedBuiltInElements; // Default undefined
            if (SAFE_FOR_TEMPLATES) ALLOW_DATA_ATTR = false;
            if (RETURN_DOM_FRAGMENT) RETURN_DOM = true;
            /* Parse profile info */ if (USE_PROFILES) {
                ALLOWED_TAGS = addToSet({}, text);
                ALLOWED_ATTR = create(null);
                if (USE_PROFILES.html === true) {
                    addToSet(ALLOWED_TAGS, html$1);
                    addToSet(ALLOWED_ATTR, html);
                }
                if (USE_PROFILES.svg === true) {
                    addToSet(ALLOWED_TAGS, svg$1);
                    addToSet(ALLOWED_ATTR, svg);
                    addToSet(ALLOWED_ATTR, xml);
                }
                if (USE_PROFILES.svgFilters === true) {
                    addToSet(ALLOWED_TAGS, svgFilters);
                    addToSet(ALLOWED_ATTR, svg);
                    addToSet(ALLOWED_ATTR, xml);
                }
                if (USE_PROFILES.mathMl === true) {
                    addToSet(ALLOWED_TAGS, mathMl$1);
                    addToSet(ALLOWED_ATTR, mathMl);
                    addToSet(ALLOWED_ATTR, xml);
                }
            }
            /* Always reset function-based ADD_TAGS / ADD_ATTR checks to prevent
         * leaking across calls when switching from function to array config */ EXTRA_ELEMENT_HANDLING.tagCheck = null;
            EXTRA_ELEMENT_HANDLING.attributeCheck = null;
            /* Merge configuration parameters */ if (objectHasOwnProperty(cfg, 'ADD_TAGS')) {
                if (typeof cfg.ADD_TAGS === 'function') EXTRA_ELEMENT_HANDLING.tagCheck = cfg.ADD_TAGS;
                else if (arrayIsArray(cfg.ADD_TAGS)) {
                    if (ALLOWED_TAGS === DEFAULT_ALLOWED_TAGS) ALLOWED_TAGS = clone(ALLOWED_TAGS);
                    addToSet(ALLOWED_TAGS, cfg.ADD_TAGS, transformCaseFunc);
                }
            }
            if (objectHasOwnProperty(cfg, 'ADD_ATTR')) {
                if (typeof cfg.ADD_ATTR === 'function') EXTRA_ELEMENT_HANDLING.attributeCheck = cfg.ADD_ATTR;
                else if (arrayIsArray(cfg.ADD_ATTR)) {
                    if (ALLOWED_ATTR === DEFAULT_ALLOWED_ATTR) ALLOWED_ATTR = clone(ALLOWED_ATTR);
                    addToSet(ALLOWED_ATTR, cfg.ADD_ATTR, transformCaseFunc);
                }
            }
            if (objectHasOwnProperty(cfg, 'ADD_URI_SAFE_ATTR') && arrayIsArray(cfg.ADD_URI_SAFE_ATTR)) addToSet(URI_SAFE_ATTRIBUTES, cfg.ADD_URI_SAFE_ATTR, transformCaseFunc);
            if (objectHasOwnProperty(cfg, 'FORBID_CONTENTS') && arrayIsArray(cfg.FORBID_CONTENTS)) {
                if (FORBID_CONTENTS === DEFAULT_FORBID_CONTENTS) FORBID_CONTENTS = clone(FORBID_CONTENTS);
                addToSet(FORBID_CONTENTS, cfg.FORBID_CONTENTS, transformCaseFunc);
            }
            if (objectHasOwnProperty(cfg, 'ADD_FORBID_CONTENTS') && arrayIsArray(cfg.ADD_FORBID_CONTENTS)) {
                if (FORBID_CONTENTS === DEFAULT_FORBID_CONTENTS) FORBID_CONTENTS = clone(FORBID_CONTENTS);
                addToSet(FORBID_CONTENTS, cfg.ADD_FORBID_CONTENTS, transformCaseFunc);
            }
            /* Add #text in case KEEP_CONTENT is set to true */ if (KEEP_CONTENT) ALLOWED_TAGS['#text'] = true;
            /* Add html, head and body to ALLOWED_TAGS in case WHOLE_DOCUMENT is true */ if (WHOLE_DOCUMENT) addToSet(ALLOWED_TAGS, [
                'html',
                'head',
                'body'
            ]);
            /* Add tbody to ALLOWED_TAGS in case tables are permitted, see #286, #365 */ if (ALLOWED_TAGS.table) {
                addToSet(ALLOWED_TAGS, [
                    'tbody'
                ]);
                delete FORBID_TAGS.tbody;
            }
            if (cfg.TRUSTED_TYPES_POLICY) {
                if (typeof cfg.TRUSTED_TYPES_POLICY.createHTML !== 'function') throw typeErrorCreate('TRUSTED_TYPES_POLICY configuration option must provide a "createHTML" hook.');
                if (typeof cfg.TRUSTED_TYPES_POLICY.createScriptURL !== 'function') throw typeErrorCreate('TRUSTED_TYPES_POLICY configuration option must provide a "createScriptURL" hook.');
                // Overwrite existing TrustedTypes policy.
                trustedTypesPolicy = cfg.TRUSTED_TYPES_POLICY;
                // Sign local variables required by `sanitize`.
                emptyHTML = trustedTypesPolicy.createHTML('');
            } else {
                // Uninitialized policy, attempt to initialize the internal dompurify policy.
                if (trustedTypesPolicy === undefined) trustedTypesPolicy = _createTrustedTypesPolicy(trustedTypes, currentScript);
                // If creating the internal policy succeeded sign internal variables.
                if (trustedTypesPolicy !== null && typeof emptyHTML === 'string') emptyHTML = trustedTypesPolicy.createHTML('');
            }
            // Prevent further manipulation of configuration.
            // Not available in IE8, Safari 5, etc.
            if (freeze) freeze(cfg);
            CONFIG = cfg;
        };
        /* Keep track of all possible SVG and MathML tags
       * so that we can perform the namespace checks
       * correctly. */ const ALL_SVG_TAGS = addToSet({}, [
            ...svg$1,
            ...svgFilters,
            ...svgDisallowed
        ]);
        const ALL_MATHML_TAGS = addToSet({}, [
            ...mathMl$1,
            ...mathMlDisallowed
        ]);
        /**
       * @param element a DOM element whose namespace is being checked
       * @returns Return false if the element has a
       *  namespace that a spec-compliant parser would never
       *  return. Return true otherwise.
       */ const _checkValidNamespace = function _checkValidNamespace(element) {
            let parent = getParentNode(element);
            // In JSDOM, if we're inside shadow DOM, then parentNode
            // can be null. We just simulate parent in this case.
            if (!parent || !parent.tagName) parent = {
                namespaceURI: NAMESPACE,
                tagName: 'template'
            };
            const tagName = stringToLowerCase(element.tagName);
            const parentTagName = stringToLowerCase(parent.tagName);
            if (!ALLOWED_NAMESPACES[element.namespaceURI]) return false;
            if (element.namespaceURI === SVG_NAMESPACE) {
                // The only way to switch from HTML namespace to SVG
                // is via <svg>. If it happens via any other tag, then
                // it should be killed.
                if (parent.namespaceURI === HTML_NAMESPACE) return tagName === 'svg';
                // The only way to switch from MathML to SVG is via`
                // svg if parent is either <annotation-xml> or MathML
                // text integration points.
                if (parent.namespaceURI === MATHML_NAMESPACE) return tagName === 'svg' && (parentTagName === 'annotation-xml' || MATHML_TEXT_INTEGRATION_POINTS[parentTagName]);
                // We only allow elements that are defined in SVG
                // spec. All others are disallowed in SVG namespace.
                return Boolean(ALL_SVG_TAGS[tagName]);
            }
            if (element.namespaceURI === MATHML_NAMESPACE) {
                // The only way to switch from HTML namespace to MathML
                // is via <math>. If it happens via any other tag, then
                // it should be killed.
                if (parent.namespaceURI === HTML_NAMESPACE) return tagName === 'math';
                // The only way to switch from SVG to MathML is via
                // <math> and HTML integration points
                if (parent.namespaceURI === SVG_NAMESPACE) return tagName === 'math' && HTML_INTEGRATION_POINTS[parentTagName];
                // We only allow elements that are defined in MathML
                // spec. All others are disallowed in MathML namespace.
                return Boolean(ALL_MATHML_TAGS[tagName]);
            }
            if (element.namespaceURI === HTML_NAMESPACE) {
                // The only way to switch from SVG to HTML is via
                // HTML integration points, and from MathML to HTML
                // is via MathML text integration points
                if (parent.namespaceURI === SVG_NAMESPACE && !HTML_INTEGRATION_POINTS[parentTagName]) return false;
                if (parent.namespaceURI === MATHML_NAMESPACE && !MATHML_TEXT_INTEGRATION_POINTS[parentTagName]) return false;
                // We disallow tags that are specific for MathML
                // or SVG and should never appear in HTML namespace
                return !ALL_MATHML_TAGS[tagName] && (COMMON_SVG_AND_HTML_ELEMENTS[tagName] || !ALL_SVG_TAGS[tagName]);
            }
            // For XHTML and XML documents that support custom namespaces
            if (PARSER_MEDIA_TYPE === 'application/xhtml+xml' && ALLOWED_NAMESPACES[element.namespaceURI]) return true;
            // The code should never reach this place (this means
            // that the element somehow got namespace that is not
            // HTML, SVG, MathML or allowed via ALLOWED_NAMESPACES).
            // Return false just in case.
            return false;
        };
        /**
       * _forceRemove
       *
       * @param node a DOM node
       */ const _forceRemove = function _forceRemove(node) {
            arrayPush(DOMPurify.removed, {
                element: node
            });
            try {
                // eslint-disable-next-line unicorn/prefer-dom-node-remove
                getParentNode(node).removeChild(node);
            } catch (_) {
                remove(node);
            }
        };
        /**
       * _removeAttribute
       *
       * @param name an Attribute name
       * @param element a DOM node
       */ const _removeAttribute = function _removeAttribute(name, element) {
            try {
                arrayPush(DOMPurify.removed, {
                    attribute: element.getAttributeNode(name),
                    from: element
                });
            } catch (_) {
                arrayPush(DOMPurify.removed, {
                    attribute: null,
                    from: element
                });
            }
            element.removeAttribute(name);
            // We void attribute values for unremovable "is" attributes
            if (name === 'is') {
                if (RETURN_DOM || RETURN_DOM_FRAGMENT) try {
                    _forceRemove(element);
                } catch (_) {}
                else try {
                    element.setAttribute(name, '');
                } catch (_) {}
            }
        };
        /**
       * _initDocument
       *
       * @param dirty - a string of dirty markup
       * @return a DOM, filled with the dirty markup
       */ const _initDocument = function _initDocument(dirty) {
            /* Create a HTML document */ let doc = null;
            let leadingWhitespace = null;
            if (FORCE_BODY) dirty = '<remove></remove>' + dirty;
            else {
                /* If FORCE_BODY isn't used, leading whitespace needs to be preserved manually */ const matches = stringMatch(dirty, /^[\r\n\t ]+/);
                leadingWhitespace = matches && matches[0];
            }
            if (PARSER_MEDIA_TYPE === 'application/xhtml+xml' && NAMESPACE === HTML_NAMESPACE) // Root of XHTML doc must contain xmlns declaration (see https://www.w3.org/TR/xhtml1/normative.html#strict)
            dirty = '<html xmlns="http://www.w3.org/1999/xhtml"><head></head><body>' + dirty + '</body></html>';
            const dirtyPayload = trustedTypesPolicy ? trustedTypesPolicy.createHTML(dirty) : dirty;
            /*
         * Use the DOMParser API by default, fallback later if needs be
         * DOMParser not work for svg when has multiple root element.
         */ if (NAMESPACE === HTML_NAMESPACE) try {
                doc = new DOMParser().parseFromString(dirtyPayload, PARSER_MEDIA_TYPE);
            } catch (_) {}
            /* Use createHTMLDocument in case DOMParser is not available */ if (!doc || !doc.documentElement) {
                doc = implementation.createDocument(NAMESPACE, 'template', null);
                try {
                    doc.documentElement.innerHTML = IS_EMPTY_INPUT ? emptyHTML : dirtyPayload;
                } catch (_) {
                // Syntax error if dirtyPayload is invalid xml
                }
            }
            const body = doc.body || doc.documentElement;
            if (dirty && leadingWhitespace) body.insertBefore(document.createTextNode(leadingWhitespace), body.childNodes[0] || null);
            /* Work on whole document or just its body */ if (NAMESPACE === HTML_NAMESPACE) return getElementsByTagName.call(doc, WHOLE_DOCUMENT ? 'html' : 'body')[0];
            return WHOLE_DOCUMENT ? doc.documentElement : body;
        };
        /**
       * Creates a NodeIterator object that you can use to traverse filtered lists of nodes or elements in a document.
       *
       * @param root The root element or node to start traversing on.
       * @return The created NodeIterator
       */ const _createNodeIterator = function _createNodeIterator(root) {
            return createNodeIterator.call(root.ownerDocument || root, root, // eslint-disable-next-line no-bitwise
            NodeFilter.SHOW_ELEMENT | NodeFilter.SHOW_COMMENT | NodeFilter.SHOW_TEXT | NodeFilter.SHOW_PROCESSING_INSTRUCTION | NodeFilter.SHOW_CDATA_SECTION, null);
        };
        /**
       * _isClobbered
       *
       * @param element element to check for clobbering attacks
       * @return true if clobbered, false if safe
       */ const _isClobbered = function _isClobbered(element) {
            return element instanceof HTMLFormElement && (typeof element.nodeName !== 'string' || typeof element.textContent !== 'string' || typeof element.removeChild !== 'function' || !(element.attributes instanceof NamedNodeMap) || typeof element.removeAttribute !== 'function' || typeof element.setAttribute !== 'function' || typeof element.namespaceURI !== 'string' || typeof element.insertBefore !== 'function' || typeof element.hasChildNodes !== 'function');
        };
        /**
       * Checks whether the given object is a DOM node.
       *
       * @param value object to check whether it's a DOM node
       * @return true is object is a DOM node
       */ const _isNode = function _isNode(value) {
            return typeof Node === 'function' && value instanceof Node;
        };
        function _executeHooks(hooks, currentNode, data) {
            arrayForEach(hooks, (hook)=>{
                hook.call(DOMPurify, currentNode, data, CONFIG);
            });
        }
        /**
       * _sanitizeElements
       *
       * @protect nodeName
       * @protect textContent
       * @protect removeChild
       * @param currentNode to check for permission to exist
       * @return true if node was killed, false if left alive
       */ const _sanitizeElements = function _sanitizeElements(currentNode) {
            let content = null;
            /* Execute a hook if present */ _executeHooks(hooks.beforeSanitizeElements, currentNode, null);
            /* Check if element is clobbered or can clobber */ if (_isClobbered(currentNode)) {
                _forceRemove(currentNode);
                return true;
            }
            /* Now let's check the element's type and name */ const tagName = transformCaseFunc(currentNode.nodeName);
            /* Execute a hook if present */ _executeHooks(hooks.uponSanitizeElement, currentNode, {
                tagName: tagName,
                allowedTags: ALLOWED_TAGS
            });
            /* Detect mXSS attempts abusing namespace confusion */ if (SAFE_FOR_XML && currentNode.hasChildNodes() && !_isNode(currentNode.firstElementChild) && regExpTest(/<[/\w!]/g, currentNode.innerHTML) && regExpTest(/<[/\w!]/g, currentNode.textContent)) {
                _forceRemove(currentNode);
                return true;
            }
            /* Remove risky CSS construction leading to mXSS */ if (SAFE_FOR_XML && currentNode.namespaceURI === HTML_NAMESPACE && tagName === 'style' && _isNode(currentNode.firstElementChild)) {
                _forceRemove(currentNode);
                return true;
            }
            /* Remove any occurrence of processing instructions */ if (currentNode.nodeType === NODE_TYPE.progressingInstruction) {
                _forceRemove(currentNode);
                return true;
            }
            /* Remove any kind of possibly harmful comments */ if (SAFE_FOR_XML && currentNode.nodeType === NODE_TYPE.comment && regExpTest(/<[/\w]/g, currentNode.data)) {
                _forceRemove(currentNode);
                return true;
            }
            /* Remove element if anything forbids its presence */ if (FORBID_TAGS[tagName] || !(EXTRA_ELEMENT_HANDLING.tagCheck instanceof Function && EXTRA_ELEMENT_HANDLING.tagCheck(tagName)) && !ALLOWED_TAGS[tagName]) {
                /* Check if we have a custom element to handle */ if (!FORBID_TAGS[tagName] && _isBasicCustomElement(tagName)) {
                    if (CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof RegExp && regExpTest(CUSTOM_ELEMENT_HANDLING.tagNameCheck, tagName)) return false;
                    if (CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof Function && CUSTOM_ELEMENT_HANDLING.tagNameCheck(tagName)) return false;
                }
                /* Keep content except for bad-listed elements */ if (KEEP_CONTENT && !FORBID_CONTENTS[tagName]) {
                    const parentNode = getParentNode(currentNode) || currentNode.parentNode;
                    const childNodes = getChildNodes(currentNode) || currentNode.childNodes;
                    if (childNodes && parentNode) {
                        const childCount = childNodes.length;
                        for(let i = childCount - 1; i >= 0; --i){
                            const childClone = cloneNode(childNodes[i], true);
                            parentNode.insertBefore(childClone, getNextSibling(currentNode));
                        }
                    }
                }
                _forceRemove(currentNode);
                return true;
            }
            /* Check whether element has a valid namespace */ if (currentNode instanceof Element && !_checkValidNamespace(currentNode)) {
                _forceRemove(currentNode);
                return true;
            }
            /* Make sure that older browsers don't get fallback-tag mXSS */ if ((tagName === 'noscript' || tagName === 'noembed' || tagName === 'noframes') && regExpTest(/<\/no(script|embed|frames)/i, currentNode.innerHTML)) {
                _forceRemove(currentNode);
                return true;
            }
            /* Sanitize element content to be template-safe */ if (SAFE_FOR_TEMPLATES && currentNode.nodeType === NODE_TYPE.text) {
                /* Get the element's text content */ content = currentNode.textContent;
                arrayForEach([
                    MUSTACHE_EXPR,
                    ERB_EXPR,
                    TMPLIT_EXPR
                ], (expr)=>{
                    content = stringReplace(content, expr, ' ');
                });
                if (currentNode.textContent !== content) {
                    arrayPush(DOMPurify.removed, {
                        element: currentNode.cloneNode()
                    });
                    currentNode.textContent = content;
                }
            }
            /* Execute a hook if present */ _executeHooks(hooks.afterSanitizeElements, currentNode, null);
            return false;
        };
        /**
       * _isValidAttribute
       *
       * @param lcTag Lowercase tag name of containing element.
       * @param lcName Lowercase attribute name.
       * @param value Attribute value.
       * @return Returns true if `value` is valid, otherwise false.
       */ // eslint-disable-next-line complexity
        const _isValidAttribute = function _isValidAttribute(lcTag, lcName, value) {
            /* FORBID_ATTR must always win, even if ADD_ATTR predicate would allow it */ if (FORBID_ATTR[lcName]) return false;
            /* Make sure attribute cannot clobber */ if (SANITIZE_DOM && (lcName === 'id' || lcName === 'name') && (value in document || value in formElement)) return false;
            /* Allow valid data-* attributes: At least one character after "-"
            (https://html.spec.whatwg.org/multipage/dom.html#embedding-custom-non-visible-data-with-the-data-*-attributes)
            XML-compatible (https://html.spec.whatwg.org/multipage/infrastructure.html#xml-compatible and http://www.w3.org/TR/xml/#d0e804)
            We don't need to check the value; it's always URI safe. */ if (ALLOW_DATA_ATTR && !FORBID_ATTR[lcName] && regExpTest(DATA_ATTR, lcName)) ;
            else if (ALLOW_ARIA_ATTR && regExpTest(ARIA_ATTR, lcName)) ;
            else if (EXTRA_ELEMENT_HANDLING.attributeCheck instanceof Function && EXTRA_ELEMENT_HANDLING.attributeCheck(lcName, lcTag)) ;
            else if (!ALLOWED_ATTR[lcName] || FORBID_ATTR[lcName]) {
                if (// First condition does a very basic check if a) it's basically a valid custom element tagname AND
                // b) if the tagName passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.tagNameCheck
                // and c) if the attribute name passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.attributeNameCheck
                _isBasicCustomElement(lcTag) && (CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof RegExp && regExpTest(CUSTOM_ELEMENT_HANDLING.tagNameCheck, lcTag) || CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof Function && CUSTOM_ELEMENT_HANDLING.tagNameCheck(lcTag)) && (CUSTOM_ELEMENT_HANDLING.attributeNameCheck instanceof RegExp && regExpTest(CUSTOM_ELEMENT_HANDLING.attributeNameCheck, lcName) || CUSTOM_ELEMENT_HANDLING.attributeNameCheck instanceof Function && CUSTOM_ELEMENT_HANDLING.attributeNameCheck(lcName, lcTag)) || // Alternative, second condition checks if it's an `is`-attribute, AND
                // the value passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.tagNameCheck
                lcName === 'is' && CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements && (CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof RegExp && regExpTest(CUSTOM_ELEMENT_HANDLING.tagNameCheck, value) || CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof Function && CUSTOM_ELEMENT_HANDLING.tagNameCheck(value))) ;
                else return false;
            /* Check value is safe. First, is attr inert? If so, is safe */ } else if (URI_SAFE_ATTRIBUTES[lcName]) ;
            else if (regExpTest(IS_ALLOWED_URI$1, stringReplace(value, ATTR_WHITESPACE, ''))) ;
            else if ((lcName === 'src' || lcName === 'xlink:href' || lcName === 'href') && lcTag !== 'script' && stringIndexOf(value, 'data:') === 0 && DATA_URI_TAGS[lcTag]) ;
            else if (ALLOW_UNKNOWN_PROTOCOLS && !regExpTest(IS_SCRIPT_OR_DATA, stringReplace(value, ATTR_WHITESPACE, ''))) ;
            else if (value) return false;
            return true;
        };
        /* Names the HTML spec reserves from valid-custom-element-name; these must
       * never be treated as basic custom elements even when a permissive
       * CUSTOM_ELEMENT_HANDLING.tagNameCheck is configured. */ const RESERVED_CUSTOM_ELEMENT_NAMES = addToSet({}, [
            'annotation-xml',
            'color-profile',
            'font-face',
            'font-face-format',
            'font-face-name',
            'font-face-src',
            'font-face-uri',
            'missing-glyph'
        ]);
        /**
       * _isBasicCustomElement
       * checks if at least one dash is included in tagName, and it's not the first char
       * for more sophisticated checking see https://github.com/sindresorhus/validate-element-name
       *
       * @param tagName name of the tag of the node to sanitize
       * @returns Returns true if the tag name meets the basic criteria for a custom element, otherwise false.
       */ const _isBasicCustomElement = function _isBasicCustomElement(tagName) {
            return !RESERVED_CUSTOM_ELEMENT_NAMES[stringToLowerCase(tagName)] && regExpTest(CUSTOM_ELEMENT, tagName);
        };
        /**
       * _sanitizeAttributes
       *
       * @protect attributes
       * @protect nodeName
       * @protect removeAttribute
       * @protect setAttribute
       *
       * @param currentNode to sanitize
       */ const _sanitizeAttributes = function _sanitizeAttributes(currentNode) {
            /* Execute a hook if present */ _executeHooks(hooks.beforeSanitizeAttributes, currentNode, null);
            const { attributes: attributes } = currentNode;
            /* Check if we have attributes; if not we might have a text node */ if (!attributes || _isClobbered(currentNode)) return;
            const hookEvent = {
                attrName: '',
                attrValue: '',
                keepAttr: true,
                allowedAttributes: ALLOWED_ATTR,
                forceKeepAttr: undefined
            };
            let l = attributes.length;
            /* Go backwards over all attributes; safely remove bad ones */ while(l--){
                const attr = attributes[l];
                const { name: name, namespaceURI: namespaceURI, value: attrValue } = attr;
                const lcName = transformCaseFunc(name);
                const initValue = attrValue;
                let value = name === 'value' ? initValue : stringTrim(initValue);
                /* Execute a hook if present */ hookEvent.attrName = lcName;
                hookEvent.attrValue = value;
                hookEvent.keepAttr = true;
                hookEvent.forceKeepAttr = undefined; // Allows developers to see this is a property they can set
                _executeHooks(hooks.uponSanitizeAttribute, currentNode, hookEvent);
                value = hookEvent.attrValue;
                /* Full DOM Clobbering protection via namespace isolation,
           * Prefix id and name attributes with `user-content-`
           */ if (SANITIZE_NAMED_PROPS && (lcName === 'id' || lcName === 'name') && stringIndexOf(value, SANITIZE_NAMED_PROPS_PREFIX) !== 0) {
                    // Remove the attribute with this value
                    _removeAttribute(name, currentNode);
                    // Prefix the value and later re-create the attribute with the sanitized value
                    value = SANITIZE_NAMED_PROPS_PREFIX + value;
                }
                // Else: already prefixed, leave the attribute alone — the prefix is
                // itself the clobbering protection, and re-applying it is incorrect.
                /* Work around a security issue with comments inside attributes */ if (SAFE_FOR_XML && regExpTest(/((--!?|])>)|<\/(style|script|title|xmp|textarea|noscript|iframe|noembed|noframes)/i, value)) {
                    _removeAttribute(name, currentNode);
                    continue;
                }
                /* Make sure we cannot easily use animated hrefs, even if animations are allowed */ if (lcName === 'attributename' && stringMatch(value, 'href')) {
                    _removeAttribute(name, currentNode);
                    continue;
                }
                /* Did the hooks approve of the attribute? */ if (hookEvent.forceKeepAttr) continue;
                /* Did the hooks approve of the attribute? */ if (!hookEvent.keepAttr) {
                    _removeAttribute(name, currentNode);
                    continue;
                }
                /* Work around a security issue in jQuery 3.0 */ if (!ALLOW_SELF_CLOSE_IN_ATTR && regExpTest(/\/>/i, value)) {
                    _removeAttribute(name, currentNode);
                    continue;
                }
                /* Sanitize attribute content to be template-safe */ if (SAFE_FOR_TEMPLATES) arrayForEach([
                    MUSTACHE_EXPR,
                    ERB_EXPR,
                    TMPLIT_EXPR
                ], (expr)=>{
                    value = stringReplace(value, expr, ' ');
                });
                /* Is `value` valid for this attribute? */ const lcTag = transformCaseFunc(currentNode.nodeName);
                if (!_isValidAttribute(lcTag, lcName, value)) {
                    _removeAttribute(name, currentNode);
                    continue;
                }
                /* Handle attributes that require Trusted Types */ if (trustedTypesPolicy && typeof trustedTypes === 'object' && typeof trustedTypes.getAttributeType === 'function') {
                    if (namespaceURI) ;
                    else switch(trustedTypes.getAttributeType(lcTag, lcName)){
                        case 'TrustedHTML':
                            value = trustedTypesPolicy.createHTML(value);
                            break;
                        case 'TrustedScriptURL':
                            value = trustedTypesPolicy.createScriptURL(value);
                            break;
                    }
                }
                /* Handle invalid data-* attribute set by try-catching it */ if (value !== initValue) try {
                    if (namespaceURI) currentNode.setAttributeNS(namespaceURI, name, value);
                    else /* Fallback to setAttribute() for browser-unrecognized namespaces e.g. "x-schema". */ currentNode.setAttribute(name, value);
                    if (_isClobbered(currentNode)) _forceRemove(currentNode);
                    else arrayPop(DOMPurify.removed);
                } catch (_) {
                    _removeAttribute(name, currentNode);
                }
            }
            /* Execute a hook if present */ _executeHooks(hooks.afterSanitizeAttributes, currentNode, null);
        };
        /**
       * _sanitizeShadowDOM
       *
       * @param fragment to iterate over recursively
       */ const _sanitizeShadowDOM2 = function _sanitizeShadowDOM(fragment) {
            let shadowNode = null;
            const shadowIterator = _createNodeIterator(fragment);
            /* Execute a hook if present */ _executeHooks(hooks.beforeSanitizeShadowDOM, fragment, null);
            while(shadowNode = shadowIterator.nextNode()){
                /* Execute a hook if present */ _executeHooks(hooks.uponSanitizeShadowNode, shadowNode, null);
                /* Sanitize tags and elements */ _sanitizeElements(shadowNode);
                /* Check attributes next */ _sanitizeAttributes(shadowNode);
                /* Deep shadow DOM detected */ if (shadowNode.content instanceof DocumentFragment) _sanitizeShadowDOM2(shadowNode.content);
            }
            /* Execute a hook if present */ _executeHooks(hooks.afterSanitizeShadowDOM, fragment, null);
        };
        // eslint-disable-next-line complexity
        DOMPurify.sanitize = function(dirty) {
            let cfg = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
            let body = null;
            let importedNode = null;
            let currentNode = null;
            let returnNode = null;
            /* Make sure we have a string to sanitize.
          DO NOT return early, as this will return the wrong type if
          the user has requested a DOM object rather than a string */ IS_EMPTY_INPUT = !dirty;
            if (IS_EMPTY_INPUT) dirty = '<!-->';
            /* Stringify, in case dirty is an object */ if (typeof dirty !== 'string' && !_isNode(dirty)) {
                dirty = stringifyValue(dirty);
                if (typeof dirty !== 'string') throw typeErrorCreate('dirty is not a string, aborting');
            }
            /* Return dirty HTML if DOMPurify cannot run */ if (!DOMPurify.isSupported) return dirty;
            /* Assign config vars */ if (!SET_CONFIG) _parseConfig(cfg);
            /* Clean up removed elements */ DOMPurify.removed = [];
            /* Check if dirty is correctly typed for IN_PLACE */ if (typeof dirty === 'string') IN_PLACE = false;
            if (IN_PLACE) {
                /* Do some early pre-sanitization to avoid unsafe root nodes */ const nn = dirty.nodeName;
                if (typeof nn === 'string') {
                    const tagName = transformCaseFunc(nn);
                    if (!ALLOWED_TAGS[tagName] || FORBID_TAGS[tagName]) throw typeErrorCreate('root node is forbidden and cannot be sanitized in-place');
                }
            } else if (dirty instanceof Node) {
                /* If dirty is a DOM element, append to an empty document to avoid
             elements being stripped by the parser */ body = _initDocument('<!---->');
                importedNode = body.ownerDocument.importNode(dirty, true);
                if (importedNode.nodeType === NODE_TYPE.element && importedNode.nodeName === 'BODY') /* Node is already a body, use as is */ body = importedNode;
                else if (importedNode.nodeName === 'HTML') body = importedNode;
                else // eslint-disable-next-line unicorn/prefer-dom-node-append
                body.appendChild(importedNode);
            } else {
                /* Exit directly if we have nothing to do */ if (!RETURN_DOM && !SAFE_FOR_TEMPLATES && !WHOLE_DOCUMENT && // eslint-disable-next-line unicorn/prefer-includes
                dirty.indexOf('<') === -1) return trustedTypesPolicy && RETURN_TRUSTED_TYPE ? trustedTypesPolicy.createHTML(dirty) : dirty;
                /* Initialize the document to work on */ body = _initDocument(dirty);
                /* Check we have a DOM node from the data */ if (!body) return RETURN_DOM ? null : RETURN_TRUSTED_TYPE ? emptyHTML : '';
            }
            /* Remove first element node (ours) if FORCE_BODY is set */ if (body && FORCE_BODY) _forceRemove(body.firstChild);
            /* Get node iterator */ const nodeIterator = _createNodeIterator(IN_PLACE ? dirty : body);
            /* Now start iterating over the created document */ while(currentNode = nodeIterator.nextNode()){
                /* Sanitize tags and elements */ _sanitizeElements(currentNode);
                /* Check attributes next */ _sanitizeAttributes(currentNode);
                /* Shadow DOM detected, sanitize it */ if (currentNode.content instanceof DocumentFragment) _sanitizeShadowDOM2(currentNode.content);
            }
            /* If we sanitized `dirty` in-place, return it. */ if (IN_PLACE) return dirty;
            /* Return sanitized string or DOM */ if (RETURN_DOM) {
                if (SAFE_FOR_TEMPLATES) {
                    body.normalize();
                    let html = body.innerHTML;
                    arrayForEach([
                        MUSTACHE_EXPR,
                        ERB_EXPR,
                        TMPLIT_EXPR
                    ], (expr)=>{
                        html = stringReplace(html, expr, ' ');
                    });
                    body.innerHTML = html;
                }
                if (RETURN_DOM_FRAGMENT) {
                    returnNode = createDocumentFragment.call(body.ownerDocument);
                    while(body.firstChild)// eslint-disable-next-line unicorn/prefer-dom-node-append
                    returnNode.appendChild(body.firstChild);
                } else returnNode = body;
                if (ALLOWED_ATTR.shadowroot || ALLOWED_ATTR.shadowrootmode) /*
              AdoptNode() is not used because internal state is not reset
              (e.g. the past names map of a HTMLFormElement), this is safe
              in theory but we would rather not risk another attack vector.
              The state that is cloned by importNode() is explicitly defined
              by the specs.
            */ returnNode = importNode.call(originalDocument, returnNode, true);
                return returnNode;
            }
            let serializedHTML = WHOLE_DOCUMENT ? body.outerHTML : body.innerHTML;
            /* Serialize doctype if allowed */ if (WHOLE_DOCUMENT && ALLOWED_TAGS['!doctype'] && body.ownerDocument && body.ownerDocument.doctype && body.ownerDocument.doctype.name && regExpTest(DOCTYPE_NAME, body.ownerDocument.doctype.name)) serializedHTML = '<!DOCTYPE ' + body.ownerDocument.doctype.name + '>\n' + serializedHTML;
            /* Sanitize final string template-safe */ if (SAFE_FOR_TEMPLATES) arrayForEach([
                MUSTACHE_EXPR,
                ERB_EXPR,
                TMPLIT_EXPR
            ], (expr)=>{
                serializedHTML = stringReplace(serializedHTML, expr, ' ');
            });
            return trustedTypesPolicy && RETURN_TRUSTED_TYPE ? trustedTypesPolicy.createHTML(serializedHTML) : serializedHTML;
        };
        DOMPurify.setConfig = function() {
            let cfg = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
            _parseConfig(cfg);
            SET_CONFIG = true;
        };
        DOMPurify.clearConfig = function() {
            CONFIG = null;
            SET_CONFIG = false;
        };
        DOMPurify.isValidAttribute = function(tag, attr, value) {
            /* Initialize shared config vars if necessary. */ if (!CONFIG) _parseConfig({});
            const lcTag = transformCaseFunc(tag);
            const lcName = transformCaseFunc(attr);
            return _isValidAttribute(lcTag, lcName, value);
        };
        DOMPurify.addHook = function(entryPoint, hookFunction) {
            if (typeof hookFunction !== 'function') return;
            arrayPush(hooks[entryPoint], hookFunction);
        };
        DOMPurify.removeHook = function(entryPoint, hookFunction) {
            if (hookFunction !== undefined) {
                const index = arrayLastIndexOf(hooks[entryPoint], hookFunction);
                return index === -1 ? undefined : arraySplice(hooks[entryPoint], index, 1)[0];
            }
            return arrayPop(hooks[entryPoint]);
        };
        DOMPurify.removeHooks = function(entryPoint) {
            hooks[entryPoint] = [];
        };
        DOMPurify.removeAllHooks = function() {
            hooks = _createHooksMap();
        };
        return DOMPurify;
    }
    var purify = createDOMPurify();
    return purify;
});


function $73cbf435bf470aed$var$sanitizeDocxHtml(html) {
    if (typeof html !== "string") return "";
    if (!$9fbb89d62e8a72ae$exports.isSupported) return "";
    return $9fbb89d62e8a72ae$exports.sanitize(html);
}
function $73cbf435bf470aed$var$scheduleDocxHtmlMount(elementId, html) {
    const safeHtml = $73cbf435bf470aed$var$sanitizeDocxHtml(html);
    const paint = ()=>{
        const el = document.getElementById(elementId);
        if (el) el.innerHTML = safeHtml;
    };
    requestAnimationFrame(()=>{
        requestAnimationFrame(paint);
    });
}
const $73cbf435bf470aed$var$DocxPreviewPort = {
    add: function(app) {
        if (app.ports.mountDocxHtml) app.ports.mountDocxHtml.subscribe(({ elementId: elementId, html: html })=>{
            if (elementId && typeof html === "string") $73cbf435bf470aed$var$scheduleDocxHtmlMount(elementId, html);
        });
        if (app.ports.clearDocxMount) app.ports.clearDocxMount.subscribe((elementId)=>{
            if (!elementId) return;
            const el = document.getElementById(elementId);
            if (el) el.replaceChildren();
        });
        if (app.ports.convertDocxFromUrl) app.ports.convertDocxFromUrl.subscribe(async ({ requestId: requestId, url: url })=>{
            if (!app.ports.docxPreviewHtmlResult) return;
            const fail = ()=>app.ports.docxPreviewHtmlResult.send({
                    requestId: requestId,
                    ok: false,
                    html: null
                });
            try {
                const res = await fetch(url);
                if (!res.ok) {
                    fail();
                    return;
                }
                const arrayBuffer = await res.arrayBuffer();
                const result = await $f489ff3da7c10b03$export$7b82ddf1ba8788ff({
                    arrayBuffer: arrayBuffer
                });
                const rawHtml = result.value || "";
                app.ports.docxPreviewHtmlResult.send({
                    requestId: requestId,
                    ok: true,
                    html: $73cbf435bf470aed$var$sanitizeDocxHtml(rawHtml)
                });
            } catch  {
                fail();
            }
        });
    }
};
$73cbf435bf470aed$exports = $73cbf435bf470aed$var$DocxPreviewPort;


var $78b00d0027f221e5$exports = {};
var $8f784678e653c95f$exports = {};
/* @license
Papa Parse
v5.5.3
https://github.com/mholt/PapaParse
License: MIT
*/ ((e, t)=>{
    "function" == typeof define && define.amd ? define([], t) : $8f784678e653c95f$exports = t();
})($8f784678e653c95f$exports, function r() {
    var n = "undefined" != typeof self ? self : "undefined" != typeof window ? window : void 0 !== n ? n : {};
    var d, s = !n.document && !!n.postMessage, a = n.IS_PAPA_WORKER || !1, o = {}, h = 0, v = {};
    function u(e) {
        this._handle = null, this._finished = !1, this._completed = !1, this._halted = !1, this._input = null, this._baseIndex = 0, this._partialLine = "", this._rowCount = 0, this._start = 0, this._nextChunk = null, this.isFirstChunk = !0, this._completeResults = {
            data: [],
            errors: [],
            meta: {}
        }, (function(e) {
            var t = b(e);
            t.chunkSize = parseInt(t.chunkSize), e.step || e.chunk || (t.chunkSize = null);
            this._handle = new i(t), (this._handle.streamer = this)._config = t;
        }).call(this, e), this.parseChunk = function(t, e) {
            var i = parseInt(this._config.skipFirstNLines) || 0;
            if (this.isFirstChunk && 0 < i) {
                let e = this._config.newline;
                e || (r = this._config.quoteChar || '"', e = this._handle.guessLineEndings(t, r)), t = [
                    ...t.split(e).slice(i)
                ].join(e);
            }
            this.isFirstChunk && U(this._config.beforeFirstChunk) && void 0 !== (r = this._config.beforeFirstChunk(t)) && (t = r), this.isFirstChunk = !1, this._halted = !1;
            var i = this._partialLine + t, r = (this._partialLine = "", this._handle.parse(i, this._baseIndex, !this._finished));
            if (!this._handle.paused() && !this._handle.aborted()) {
                t = r.meta.cursor, i = (this._finished || (this._partialLine = i.substring(t - this._baseIndex), this._baseIndex = t), r && r.data && (this._rowCount += r.data.length), this._finished || this._config.preview && this._rowCount >= this._config.preview);
                if (a) n.postMessage({
                    results: r,
                    workerId: v.WORKER_ID,
                    finished: i
                });
                else if (U(this._config.chunk) && !e) {
                    if (this._config.chunk(r, this._handle), this._handle.paused() || this._handle.aborted()) return void (this._halted = !0);
                    this._completeResults = r = void 0;
                }
                return this._config.step || this._config.chunk || (this._completeResults.data = this._completeResults.data.concat(r.data), this._completeResults.errors = this._completeResults.errors.concat(r.errors), this._completeResults.meta = r.meta), this._completed || !i || !U(this._config.complete) || r && r.meta.aborted || (this._config.complete(this._completeResults, this._input), this._completed = !0), i || r && r.meta.paused || this._nextChunk(), r;
            }
            this._halted = !0;
        }, this._sendError = function(e) {
            U(this._config.error) ? this._config.error(e) : a && this._config.error && n.postMessage({
                workerId: v.WORKER_ID,
                error: e,
                finished: !1
            });
        };
    }
    function f(e) {
        var r;
        (e = e || {}).chunkSize || (e.chunkSize = v.RemoteChunkSize), u.call(this, e), this._nextChunk = s ? function() {
            this._readChunk(), this._chunkLoaded();
        } : function() {
            this._readChunk();
        }, this.stream = function(e) {
            this._input = e, this._nextChunk();
        }, this._readChunk = function() {
            if (this._finished) this._chunkLoaded();
            else {
                if (r = new XMLHttpRequest, this._config.withCredentials && (r.withCredentials = this._config.withCredentials), s || (r.onload = y(this._chunkLoaded, this), r.onerror = y(this._chunkError, this)), r.open(this._config.downloadRequestBody ? "POST" : "GET", this._input, !s), this._config.downloadRequestHeaders) {
                    var e, t = this._config.downloadRequestHeaders;
                    for(e in t)r.setRequestHeader(e, t[e]);
                }
                var i;
                this._config.chunkSize && (i = this._start + this._config.chunkSize - 1, r.setRequestHeader("Range", "bytes=" + this._start + "-" + i));
                try {
                    r.send(this._config.downloadRequestBody);
                } catch (e) {
                    this._chunkError(e.message);
                }
                s && 0 === r.status && this._chunkError();
            }
        }, this._chunkLoaded = function() {
            4 === r.readyState && (r.status < 200 || 400 <= r.status ? this._chunkError() : (this._start += this._config.chunkSize || r.responseText.length, this._finished = !this._config.chunkSize || this._start >= ((e)=>null !== (e = e.getResponseHeader("Content-Range")) ? parseInt(e.substring(e.lastIndexOf("/") + 1)) : -1)(r), this.parseChunk(r.responseText)));
        }, this._chunkError = function(e) {
            e = r.statusText || e;
            this._sendError(new Error(e));
        };
    }
    function l(e) {
        (e = e || {}).chunkSize || (e.chunkSize = v.LocalChunkSize), u.call(this, e);
        var i, r, n = "undefined" != typeof FileReader;
        this.stream = function(e) {
            this._input = e, r = e.slice || e.webkitSlice || e.mozSlice, n ? ((i = new FileReader).onload = y(this._chunkLoaded, this), i.onerror = y(this._chunkError, this)) : i = new FileReaderSync, this._nextChunk();
        }, this._nextChunk = function() {
            this._finished || this._config.preview && !(this._rowCount < this._config.preview) || this._readChunk();
        }, this._readChunk = function() {
            var e = this._input, t = (this._config.chunkSize && (t = Math.min(this._start + this._config.chunkSize, this._input.size), e = r.call(e, this._start, t)), i.readAsText(e, this._config.encoding));
            n || this._chunkLoaded({
                target: {
                    result: t
                }
            });
        }, this._chunkLoaded = function(e) {
            this._start += this._config.chunkSize, this._finished = !this._config.chunkSize || this._start >= this._input.size, this.parseChunk(e.target.result);
        }, this._chunkError = function() {
            this._sendError(i.error);
        };
    }
    function c(e) {
        var i;
        u.call(this, e = e || {}), this.stream = function(e) {
            return i = e, this._nextChunk();
        }, this._nextChunk = function() {
            var e, t;
            if (!this._finished) return e = this._config.chunkSize, i = e ? (t = i.substring(0, e), i.substring(e)) : (t = i, ""), this._finished = !i, this.parseChunk(t);
        };
    }
    function p(e) {
        u.call(this, e = e || {});
        var t = [], i = !0, r = !1;
        this.pause = function() {
            u.prototype.pause.apply(this, arguments), this._input.pause();
        }, this.resume = function() {
            u.prototype.resume.apply(this, arguments), this._input.resume();
        }, this.stream = function(e) {
            this._input = e, this._input.on("data", this._streamData), this._input.on("end", this._streamEnd), this._input.on("error", this._streamError);
        }, this._checkIsFinished = function() {
            r && 1 === t.length && (this._finished = !0);
        }, this._nextChunk = function() {
            this._checkIsFinished(), t.length ? this.parseChunk(t.shift()) : i = !0;
        }, this._streamData = y(function(e) {
            try {
                t.push("string" == typeof e ? e : e.toString(this._config.encoding)), i && (i = !1, this._checkIsFinished(), this.parseChunk(t.shift()));
            } catch (e) {
                this._streamError(e);
            }
        }, this), this._streamError = y(function(e) {
            this._streamCleanUp(), this._sendError(e);
        }, this), this._streamEnd = y(function() {
            this._streamCleanUp(), r = !0, this._streamData("");
        }, this), this._streamCleanUp = y(function() {
            this._input.removeListener("data", this._streamData), this._input.removeListener("end", this._streamEnd), this._input.removeListener("error", this._streamError);
        }, this);
    }
    function i(m) {
        var n, s, a, t, o = Math.pow(2, 53), h = -o, u = /^\s*-?(\d+\.?|\.\d+|\d+\.\d+)([eE][-+]?\d+)?\s*$/, d = /^((\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d:[0-5]\d\.\d+([+-][0-2]\d:[0-5]\d|Z))|(\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d:[0-5]\d([+-][0-2]\d:[0-5]\d|Z))|(\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d([+-][0-2]\d:[0-5]\d|Z)))$/, i = this, r = 0, f = 0, l = !1, e = !1, c = [], p = {
            data: [],
            errors: [],
            meta: {}
        };
        function y(e) {
            return "greedy" === m.skipEmptyLines ? "" === e.join("").trim() : 1 === e.length && 0 === e[0].length;
        }
        function g() {
            if (p && a && (k("Delimiter", "UndetectableDelimiter", "Unable to auto-detect delimiting character; defaulted to '" + v.DefaultDelimiter + "'"), a = !1), m.skipEmptyLines && (p.data = p.data.filter(function(e) {
                return !y(e);
            })), _()) {
                if (p) {
                    if (Array.isArray(p.data[0])) {
                        for(var e = 0; _() && e < p.data.length; e++)p.data[e].forEach(t);
                        p.data.splice(0, 1);
                    } else p.data.forEach(t);
                }
                function t(e, t) {
                    U(m.transformHeader) && (e = m.transformHeader(e, t)), c.push(e);
                }
            }
            function i(e, t) {
                for(var i = m.header ? {} : [], r = 0; r < e.length; r++){
                    var n = r, s = e[r], s = ((e, t)=>((e)=>(m.dynamicTypingFunction && void 0 === m.dynamicTyping[e] && (m.dynamicTyping[e] = m.dynamicTypingFunction(e)), !0 === (m.dynamicTyping[e] || m.dynamicTyping)))(e) ? "true" === t || "TRUE" === t || "false" !== t && "FALSE" !== t && (((e)=>{
                            if (u.test(e)) {
                                e = parseFloat(e);
                                if (h < e && e < o) return 1;
                            }
                        })(t) ? parseFloat(t) : d.test(t) ? new Date(t) : "" === t ? null : t) : t)(n = m.header ? r >= c.length ? "__parsed_extra" : c[r] : n, s = m.transform ? m.transform(s, n) : s);
                    "__parsed_extra" === n ? (i[n] = i[n] || [], i[n].push(s)) : i[n] = s;
                }
                return m.header && (r > c.length ? k("FieldMismatch", "TooManyFields", "Too many fields: expected " + c.length + " fields but parsed " + r, f + t) : r < c.length && k("FieldMismatch", "TooFewFields", "Too few fields: expected " + c.length + " fields but parsed " + r, f + t)), i;
            }
            var r;
            p && (m.header || m.dynamicTyping || m.transform) && (r = 1, !p.data.length || Array.isArray(p.data[0]) ? (p.data = p.data.map(i), r = p.data.length) : p.data = i(p.data, 0), m.header && p.meta && (p.meta.fields = c), f += r);
        }
        function _() {
            return m.header && 0 === c.length;
        }
        function k(e, t, i, r) {
            e = {
                type: e,
                code: t,
                message: i
            };
            void 0 !== r && (e.row = r), p.errors.push(e);
        }
        U(m.step) && (t = m.step, m.step = function(e) {
            p = e, _() ? g() : (g(), 0 !== p.data.length && (r += e.data.length, m.preview && r > m.preview ? s.abort() : (p.data = p.data[0], t(p, i))));
        }), this.parse = function(e, t, i) {
            var r = m.quoteChar || '"', r = (m.newline || (m.newline = this.guessLineEndings(e, r)), a = !1, m.delimiter ? U(m.delimiter) && (m.delimiter = m.delimiter(e), p.meta.delimiter = m.delimiter) : ((r = ((e, t, i, r, n)=>{
                var s, a, o, h;
                n = n || [
                    ",",
                    "\t",
                    "|",
                    ";",
                    v.RECORD_SEP,
                    v.UNIT_SEP
                ];
                for(var u = 0; u < n.length; u++){
                    for(var d, f = n[u], l = 0, c = 0, p = 0, g = (o = void 0, new E({
                        comments: r,
                        delimiter: f,
                        newline: t,
                        preview: 10
                    }).parse(e)), _ = 0; _ < g.data.length; _++)i && y(g.data[_]) ? p++ : (d = g.data[_].length, c += d, void 0 === o ? o = d : 0 < d && (l += Math.abs(d - o), o = d));
                    0 < g.data.length && (c /= g.data.length - p), (void 0 === a || l <= a) && (void 0 === h || h < c) && 1.99 < c && (a = l, s = f, h = c);
                }
                return {
                    successful: !!(m.delimiter = s),
                    bestDelimiter: s
                };
            })(e, m.newline, m.skipEmptyLines, m.comments, m.delimitersToGuess)).successful ? m.delimiter = r.bestDelimiter : (a = !0, m.delimiter = v.DefaultDelimiter), p.meta.delimiter = m.delimiter), b(m));
            return m.preview && m.header && r.preview++, n = e, s = new E(r), p = s.parse(n, t, i), g(), l ? {
                meta: {
                    paused: !0
                }
            } : p || {
                meta: {
                    paused: !1
                }
            };
        }, this.paused = function() {
            return l;
        }, this.pause = function() {
            l = !0, s.abort(), n = U(m.chunk) ? "" : n.substring(s.getCharIndex());
        }, this.resume = function() {
            i.streamer._halted ? (l = !1, i.streamer.parseChunk(n, !0)) : setTimeout(i.resume, 3);
        }, this.aborted = function() {
            return e;
        }, this.abort = function() {
            e = !0, s.abort(), p.meta.aborted = !0, U(m.complete) && m.complete(p), n = "";
        }, this.guessLineEndings = function(e, t) {
            e = e.substring(0, 1048576);
            var t = new RegExp(P(t) + "([^]*?)" + P(t), "gm"), i = (e = e.replace(t, "")).split("\r"), t = e.split("\n"), e = 1 < t.length && t[0].length < i[0].length;
            if (1 === i.length || e) return "\n";
            for(var r = 0, n = 0; n < i.length; n++)"\n" === i[n][0] && r++;
            return r >= i.length / 2 ? "\r\n" : "\r";
        };
    }
    function P(e) {
        return e.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
    }
    function E(C) {
        var S = (C = C || {}).delimiter, O = C.newline, x = C.comments, I = C.step, A = C.preview, T = C.fastMode, D = null, L = !1, F = null == C.quoteChar ? '"' : C.quoteChar, j = F;
        if (void 0 !== C.escapeChar && (j = C.escapeChar), ("string" != typeof S || -1 < v.BAD_DELIMITERS.indexOf(S)) && (S = ","), x === S) throw new Error("Comment character same as delimiter");
        !0 === x ? x = "#" : ("string" != typeof x || -1 < v.BAD_DELIMITERS.indexOf(x)) && (x = !1), "\n" !== O && "\r" !== O && "\r\n" !== O && (O = "\n");
        var z = 0, M = !1;
        this.parse = function(i, t, r) {
            if ("string" != typeof i) throw new Error("Input must be a string");
            var n = i.length, e = S.length, s = O.length, a = x.length, o = U(I), h = [], u = [], d = [], f = z = 0;
            if (!i) return w();
            if (T || !1 !== T && -1 === i.indexOf(F)) {
                for(var l = i.split(O), c = 0; c < l.length; c++){
                    if (d = l[c], z += d.length, c !== l.length - 1) z += O.length;
                    else if (r) return w();
                    if (!x || d.substring(0, a) !== x) {
                        if (o) {
                            if (h = [], k(d.split(S)), R(), M) return w();
                        } else k(d.split(S));
                        if (A && A <= c) return h = h.slice(0, A), w(!0);
                    }
                }
                return w();
            }
            for(var p = i.indexOf(S, z), g = i.indexOf(O, z), _ = new RegExp(P(j) + P(F), "g"), m = i.indexOf(F, z);;)if (i[z] === F) for(m = z, z++;;){
                if (-1 === (m = i.indexOf(F, m + 1))) return r || u.push({
                    type: "Quotes",
                    code: "MissingQuotes",
                    message: "Quoted field unterminated",
                    row: h.length,
                    index: z
                }), E();
                if (m === n - 1) return E(i.substring(z, m).replace(_, F));
                if (F === j && i[m + 1] === j) m++;
                else if (F === j || 0 === m || i[m - 1] !== j) {
                    -1 !== p && p < m + 1 && (p = i.indexOf(S, m + 1));
                    var y = v(-1 === (g = -1 !== g && g < m + 1 ? i.indexOf(O, m + 1) : g) ? p : Math.min(p, g));
                    if (i.substr(m + 1 + y, e) === S) {
                        d.push(i.substring(z, m).replace(_, F)), i[z = m + 1 + y + e] !== F && (m = i.indexOf(F, z)), p = i.indexOf(S, z), g = i.indexOf(O, z);
                        break;
                    }
                    y = v(g);
                    if (i.substring(m + 1 + y, m + 1 + y + s) === O) {
                        if (d.push(i.substring(z, m).replace(_, F)), b(m + 1 + y + s), p = i.indexOf(S, z), m = i.indexOf(F, z), o && (R(), M)) return w();
                        if (A && h.length >= A) return w(!0);
                        break;
                    }
                    u.push({
                        type: "Quotes",
                        code: "InvalidQuotes",
                        message: "Trailing quote on quoted field is malformed",
                        row: h.length,
                        index: z
                    }), m++;
                }
            }
            else if (x && 0 === d.length && i.substring(z, z + a) === x) {
                if (-1 === g) return w();
                z = g + s, g = i.indexOf(O, z), p = i.indexOf(S, z);
            } else if (-1 !== p && (p < g || -1 === g)) d.push(i.substring(z, p)), z = p + e, p = i.indexOf(S, z);
            else {
                if (-1 === g) break;
                if (d.push(i.substring(z, g)), b(g + s), o && (R(), M)) return w();
                if (A && h.length >= A) return w(!0);
            }
            return E();
            function k(e) {
                h.push(e), f = z;
            }
            function v(e) {
                var t = 0;
                return t = -1 !== e && (e = i.substring(m + 1, e)) && "" === e.trim() ? e.length : t;
            }
            function E(e) {
                return r || (void 0 === e && (e = i.substring(z)), d.push(e), z = n, k(d), o && R()), w();
            }
            function b(e) {
                z = e, k(d), d = [], g = i.indexOf(O, z);
            }
            function w(e) {
                if (C.header && !t && h.length && !L) {
                    var s = h[0], a = Object.create(null), o = new Set(s);
                    let n = !1;
                    for(let r = 0; r < s.length; r++){
                        let i = s[r];
                        if (a[i = U(C.transformHeader) ? C.transformHeader(i, r) : i]) {
                            let e, t = a[i];
                            for(; e = i + "_" + t, t++, o.has(e););
                            o.add(e), s[r] = e, a[i]++, n = !0, (D = null === D ? {} : D)[e] = i;
                        } else a[i] = 1, s[r] = i;
                        o.add(i);
                    }
                    n && console.warn("Duplicate headers found and renamed."), L = !0;
                }
                return {
                    data: h,
                    errors: u,
                    meta: {
                        delimiter: S,
                        linebreak: O,
                        aborted: M,
                        truncated: !!e,
                        cursor: f + (t || 0),
                        renamedHeaders: D
                    }
                };
            }
            function R() {
                I(w()), h = [], u = [];
            }
        }, this.abort = function() {
            M = !0;
        }, this.getCharIndex = function() {
            return z;
        };
    }
    function g(e) {
        var t = e.data, i = o[t.workerId], r = !1;
        if (t.error) i.userError(t.error, t.file);
        else if (t.results && t.results.data) {
            var n = {
                abort: function() {
                    r = !0, _(t.workerId, {
                        data: [],
                        errors: [],
                        meta: {
                            aborted: !0
                        }
                    });
                },
                pause: m,
                resume: m
            };
            if (U(i.userStep)) {
                for(var s = 0; s < t.results.data.length && (i.userStep({
                    data: t.results.data[s],
                    errors: t.results.errors,
                    meta: t.results.meta
                }, n), !r); s++);
                delete t.results;
            } else U(i.userChunk) && (i.userChunk(t.results, n, t.file), delete t.results);
        }
        t.finished && !r && _(t.workerId, t.results);
    }
    function _(e, t) {
        var i = o[e];
        U(i.userComplete) && i.userComplete(t), i.terminate(), delete o[e];
    }
    function m() {
        throw new Error("Not implemented.");
    }
    function b(e) {
        if ("object" != typeof e || null === e) return e;
        var t, i = Array.isArray(e) ? [] : {};
        for(t in e)i[t] = b(e[t]);
        return i;
    }
    function y(e, t) {
        return function() {
            e.apply(t, arguments);
        };
    }
    function U(e) {
        return "function" == typeof e;
    }
    return v.parse = function(e, t) {
        var i = (t = t || {}).dynamicTyping || !1;
        U(i) && (t.dynamicTypingFunction = i, i = {});
        if (t.dynamicTyping = i, t.transform = !!U(t.transform) && t.transform, !t.worker || !v.WORKERS_SUPPORTED) return i = null, v.NODE_STREAM_INPUT, "string" == typeof e ? (e = ((e)=>65279 !== e.charCodeAt(0) ? e : e.slice(1))(e), i = new (t.download ? f : c)(t)) : !0 === e.readable && U(e.read) && U(e.on) ? i = new p(t) : (n.File && e instanceof File || e instanceof Object) && (i = new l(t)), i.stream(e);
        (i = (()=>{
            var e;
            return !!v.WORKERS_SUPPORTED && (e = (()=>{
                var e = n.URL || n.webkitURL || null, t = r.toString();
                return v.BLOB_URL || (v.BLOB_URL = e.createObjectURL(new Blob([
                    "var global = (function() { if (typeof self !== 'undefined') { return self; } if (typeof window !== 'undefined') { return window; } if (typeof global !== 'undefined') { return global; } return {}; })(); global.IS_PAPA_WORKER=true; ",
                    "(",
                    t,
                    ")();"
                ], {
                    type: "text/javascript"
                })));
            })(), (e = new n.Worker(e)).onmessage = g, e.id = h++, o[e.id] = e);
        })()).userStep = t.step, i.userChunk = t.chunk, i.userComplete = t.complete, i.userError = t.error, t.step = U(t.step), t.chunk = U(t.chunk), t.complete = U(t.complete), t.error = U(t.error), delete t.worker, i.postMessage({
            input: e,
            config: t,
            workerId: i.id
        });
    }, v.unparse = function(e, t) {
        var n = !1, _ = !0, m = ",", y = "\r\n", s = '"', a = s + s, i = !1, r = null, o = !1, h = ((()=>{
            if ("object" == typeof t) {
                if ("string" != typeof t.delimiter || v.BAD_DELIMITERS.filter(function(e) {
                    return -1 !== t.delimiter.indexOf(e);
                }).length || (m = t.delimiter), "boolean" != typeof t.quotes && "function" != typeof t.quotes && !Array.isArray(t.quotes) || (n = t.quotes), "boolean" != typeof t.skipEmptyLines && "string" != typeof t.skipEmptyLines || (i = t.skipEmptyLines), "string" == typeof t.newline && (y = t.newline), "string" == typeof t.quoteChar && (s = t.quoteChar), "boolean" == typeof t.header && (_ = t.header), Array.isArray(t.columns)) {
                    if (0 === t.columns.length) throw new Error("Option columns is empty");
                    r = t.columns;
                }
                void 0 !== t.escapeChar && (a = t.escapeChar + s), t.escapeFormulae instanceof RegExp ? o = t.escapeFormulae : "boolean" == typeof t.escapeFormulae && t.escapeFormulae && (o = /^[=+\-@\t\r].*$/);
            }
        })(), new RegExp(P(s), "g"));
        "string" == typeof e && (e = JSON.parse(e));
        if (Array.isArray(e)) {
            if (!e.length || Array.isArray(e[0])) return u(null, e, i);
            if ("object" == typeof e[0]) return u(r || Object.keys(e[0]), e, i);
        } else if ("object" == typeof e) return "string" == typeof e.data && (e.data = JSON.parse(e.data)), Array.isArray(e.data) && (e.fields || (e.fields = e.meta && e.meta.fields || r), e.fields || (e.fields = Array.isArray(e.data[0]) ? e.fields : "object" == typeof e.data[0] ? Object.keys(e.data[0]) : []), Array.isArray(e.data[0]) || "object" == typeof e.data[0] || (e.data = [
            e.data
        ])), u(e.fields || [], e.data || [], i);
        throw new Error("Unable to serialize unrecognized input");
        function u(e, t, i) {
            var r = "", n = ("string" == typeof e && (e = JSON.parse(e)), "string" == typeof t && (t = JSON.parse(t)), Array.isArray(e) && 0 < e.length), s = !Array.isArray(t[0]);
            if (n && _) {
                for(var a = 0; a < e.length; a++)0 < a && (r += m), r += k(e[a], a);
                0 < t.length && (r += y);
            }
            for(var o = 0; o < t.length; o++){
                var h = (n ? e : t[o]).length, u = !1, d = n ? 0 === Object.keys(t[o]).length : 0 === t[o].length;
                if (i && !n && (u = "greedy" === i ? "" === t[o].join("").trim() : 1 === t[o].length && 0 === t[o][0].length), "greedy" === i && n) {
                    for(var f = [], l = 0; l < h; l++){
                        var c = s ? e[l] : l;
                        f.push(t[o][c]);
                    }
                    u = "" === f.join("").trim();
                }
                if (!u) {
                    for(var p = 0; p < h; p++){
                        0 < p && !d && (r += m);
                        var g = n && s ? e[p] : p;
                        r += k(t[o][g], p);
                    }
                    o < t.length - 1 && (!i || 0 < h && !d) && (r += y);
                }
            }
            return r;
        }
        function k(e, t) {
            var i, r;
            return null == e ? "" : e.constructor === Date ? JSON.stringify(e).slice(1, 25) : (r = !1, o && "string" == typeof e && o.test(e) && (e = "'" + e, r = !0), i = e.toString().replace(h, a), (r = r || !0 === n || "function" == typeof n && n(e, t) || Array.isArray(n) && n[t] || ((e, t)=>{
                for(var i = 0; i < t.length; i++)if (-1 < e.indexOf(t[i])) return !0;
                return !1;
            })(i, v.BAD_DELIMITERS) || -1 < i.indexOf(m) || " " === i.charAt(0) || " " === i.charAt(i.length - 1)) ? s + i + s : i);
        }
    }, v.RECORD_SEP = String.fromCharCode(30), v.UNIT_SEP = String.fromCharCode(31), v.BYTE_ORDER_MARK = "\ufeff", v.BAD_DELIMITERS = [
        "\r",
        "\n",
        '"',
        v.BYTE_ORDER_MARK
    ], v.WORKERS_SUPPORTED = !s && !!n.Worker, v.NODE_STREAM_INPUT = 1, v.LocalChunkSize = 10485760, v.RemoteChunkSize = 5242880, v.DefaultDelimiter = ",", v.Parser = E, v.ParserHandle = i, v.NetworkStreamer = f, v.FileStreamer = l, v.StringStreamer = c, v.ReadableStreamStreamer = p, n.jQuery && ((d = n.jQuery).fn.parse = function(o) {
        var i = o.config || {}, h = [];
        return this.each(function(e) {
            if (!("INPUT" === d(this).prop("tagName").toUpperCase() && "file" === d(this).attr("type").toLowerCase() && n.FileReader) || !this.files || 0 === this.files.length) return !0;
            for(var t = 0; t < this.files.length; t++)h.push({
                file: this.files[t],
                inputElem: this,
                instanceConfig: d.extend({}, i)
            });
        }), e(), this;
        function e() {
            if (0 === h.length) U(o.complete) && o.complete();
            else {
                var e, t, i, r, n = h[0];
                if (U(o.before)) {
                    var s = o.before(n.file, n.inputElem);
                    if ("object" == typeof s) {
                        if ("abort" === s.action) return e = "AbortError", t = n.file, i = n.inputElem, r = s.reason, void (U(o.error) && o.error({
                            name: e
                        }, t, i, r));
                        if ("skip" === s.action) return void u();
                        "object" == typeof s.config && (n.instanceConfig = d.extend(n.instanceConfig, s.config));
                    } else if ("skip" === s) return void u();
                }
                var a = n.instanceConfig.complete;
                n.instanceConfig.complete = function(e) {
                    U(a) && a(e, n.file, n.inputElem), u();
                }, v.parse(n.file, n.instanceConfig);
            }
        }
        function u() {
            h.splice(0, 1), e();
        }
    }), a && (n.onmessage = function(e) {
        e = e.data;
        void 0 === v.WORKER_ID && e && (v.WORKER_ID = e.workerId);
        "string" == typeof e.input ? n.postMessage({
            workerId: v.WORKER_ID,
            results: v.parse(e.input, e.config),
            finished: !0
        }) : (n.File && e.input instanceof File || e.input instanceof Object) && (e = v.parse(e.input, e.config)) && n.postMessage({
            workerId: v.WORKER_ID,
            results: e,
            finished: !0
        });
    }), (f.prototype = Object.create(u.prototype)).constructor = f, (l.prototype = Object.create(u.prototype)).constructor = l, (c.prototype = Object.create(c.prototype)).constructor = c, (p.prototype = Object.create(u.prototype)).constructor = p, v;
});


var $c5a62d48f5fefafb$exports = {};
/*! ExcelJS 19-10-2023 */ !function(e) {
    $c5a62d48f5fefafb$exports = e();
}(function() {
    return (function e(t, r, n) {
        function i(o, a) {
            if (!r[o]) {
                if (!t[o]) {
                    var l = undefined;
                    if (!a && l) return l(o, !0);
                    if (s) return s(o, !0);
                    var c = new Error("Cannot find module '" + o + "'");
                    throw c.code = "MODULE_NOT_FOUND", c;
                }
                var u = r[o] = {
                    exports: {}
                };
                t[o][0].call(u.exports, function(e) {
                    return i(t[o][1][e] || e);
                }, u, u.exports, e, t, r, n);
            }
            return r[o].exports;
        }
        for(var s = undefined, o = 0; o < n.length; o++)i(n[o]);
        return i;
    })({
        1: [
            function(e, t, r) {
                "use strict";
                const n = e("fs"), i = e("fast-csv"), s = e("dayjs/plugin/customParseFormat"), o = e("dayjs/plugin/utc"), a = e("dayjs").extend(s).extend(o), l = e("../utils/stream-buf"), { fs: { exists: c } } = e("../utils/utils"), u = {
                    true: !0,
                    false: !1,
                    "#N/A": {
                        error: "#N/A"
                    },
                    "#REF!": {
                        error: "#REF!"
                    },
                    "#NAME?": {
                        error: "#NAME?"
                    },
                    "#DIV/0!": {
                        error: "#DIV/0!"
                    },
                    "#NULL!": {
                        error: "#NULL!"
                    },
                    "#VALUE!": {
                        error: "#VALUE!"
                    },
                    "#NUM!": {
                        error: "#NUM!"
                    }
                };
                t.exports = class {
                    constructor(e){
                        this.workbook = e, this.worksheet = null;
                    }
                    async readFile(e, t) {
                        if (t = t || {}, !await c(e)) throw new Error("File not found: " + e);
                        const r = n.createReadStream(e), i = await this.read(r, t);
                        return r.close(), i;
                    }
                    read(e, t) {
                        return t = t || {}, new Promise((r, n)=>{
                            const s = this.workbook.addWorksheet(t.sheetName), o = t.dateFormats || [
                                "YYYY-MM-DD[T]HH:mm:ssZ",
                                "YYYY-MM-DD[T]HH:mm:ss",
                                "MM-DD-YYYY",
                                "YYYY-MM-DD"
                            ], l = t.map || function(e) {
                                if ("" === e) return null;
                                const t = Number(e);
                                if (!Number.isNaN(t) && t !== 1 / 0) return t;
                                const r = o.reduce((t, r)=>{
                                    if (t) return t;
                                    const n = a(e, r, !0);
                                    return n.isValid() ? n : null;
                                }, null);
                                if (r) return new Date(r.valueOf());
                                const n = u[e];
                                return void 0 !== n ? n : e;
                            }, c = i.parse(t.parserOptions).on("data", (e)=>{
                                s.addRow(e.map(l));
                            }).on("end", ()=>{
                                c.emit("worksheet", s);
                            });
                            c.on("worksheet", r).on("error", n), e.pipe(c);
                        });
                    }
                    createInputStream() {
                        throw new Error("`CSV#createInputStream` is deprecated. You should use `CSV#read` instead. This method will be removed in version 5.0. Please follow upgrade instruction: https://github.com/exceljs/exceljs/blob/master/UPGRADE-4.0.md");
                    }
                    write(e, t) {
                        return new Promise((r, n)=>{
                            t = t || {};
                            const s = this.workbook.getWorksheet(t.sheetName || t.sheetId), o = i.format(t.formatterOptions);
                            e.on("finish", ()=>{
                                r();
                            }), o.on("error", n), o.pipe(e);
                            const { dateFormat: l, dateUTC: c } = t, u = t.map || ((e)=>{
                                if (e) {
                                    if (e.text || e.hyperlink) return e.hyperlink || e.text || "";
                                    if (e.formula || e.result) return e.result || "";
                                    if (e instanceof Date) return l ? c ? a.utc(e).format(l) : a(e).format(l) : c ? a.utc(e).format() : a(e).format();
                                    if (e.error) return e.error;
                                    if ("object" == typeof e) return JSON.stringify(e);
                                }
                                return e;
                            }), h = void 0 === t.includeEmptyRows || t.includeEmptyRows;
                            let f = 1;
                            s && s.eachRow((e, t)=>{
                                if (h) for(; f++ < t - 1;)o.write([]);
                                const { values: r } = e;
                                r.shift(), o.write(r.map(u)), f = t;
                            }), o.end();
                        });
                    }
                    writeFile(e, t) {
                        const r = {
                            encoding: (t = t || {}).encoding || "utf8"
                        }, i = n.createWriteStream(e, r);
                        return this.write(i, t);
                    }
                    async writeBuffer(e) {
                        const t = new l;
                        return await this.write(t, e), t.read();
                    }
                };
            },
            {
                "../utils/stream-buf": 24,
                "../utils/utils": 27,
                dayjs: 391,
                "dayjs/plugin/customParseFormat": 392,
                "dayjs/plugin/utc": 393,
                "fast-csv": 424,
                fs: 216
            }
        ],
        2: [
            function(e, t, r) {
                "use strict";
                const n = e("../utils/col-cache");
                class i {
                    constructor(e, t){
                        let r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 0;
                        if (this.worksheet = e, t) {
                            if ("string" == typeof t) {
                                const e = n.decodeAddress(t);
                                this.nativeCol = e.col + r, this.nativeColOff = 0, this.nativeRow = e.row + r, this.nativeRowOff = 0;
                            } else void 0 !== t.nativeCol ? (this.nativeCol = t.nativeCol || 0, this.nativeColOff = t.nativeColOff || 0, this.nativeRow = t.nativeRow || 0, this.nativeRowOff = t.nativeRowOff || 0) : void 0 !== t.col ? (this.col = t.col + r, this.row = t.row + r) : (this.nativeCol = 0, this.nativeColOff = 0, this.nativeRow = 0, this.nativeRowOff = 0);
                        } else this.nativeCol = 0, this.nativeColOff = 0, this.nativeRow = 0, this.nativeRowOff = 0;
                    }
                    static asInstance(e) {
                        return e instanceof i || null == e ? e : new i(e);
                    }
                    get col() {
                        return this.nativeCol + Math.min(this.colWidth - 1, this.nativeColOff) / this.colWidth;
                    }
                    set col(e) {
                        this.nativeCol = Math.floor(e), this.nativeColOff = Math.floor((e - this.nativeCol) * this.colWidth);
                    }
                    get row() {
                        return this.nativeRow + Math.min(this.rowHeight - 1, this.nativeRowOff) / this.rowHeight;
                    }
                    set row(e) {
                        this.nativeRow = Math.floor(e), this.nativeRowOff = Math.floor((e - this.nativeRow) * this.rowHeight);
                    }
                    get colWidth() {
                        return this.worksheet && this.worksheet.getColumn(this.nativeCol + 1) && this.worksheet.getColumn(this.nativeCol + 1).isCustomWidth ? Math.floor(1e4 * this.worksheet.getColumn(this.nativeCol + 1).width) : 64e4;
                    }
                    get rowHeight() {
                        return this.worksheet && this.worksheet.getRow(this.nativeRow + 1) && this.worksheet.getRow(this.nativeRow + 1).height ? Math.floor(1e4 * this.worksheet.getRow(this.nativeRow + 1).height) : 18e4;
                    }
                    get model() {
                        return {
                            nativeCol: this.nativeCol,
                            nativeColOff: this.nativeColOff,
                            nativeRow: this.nativeRow,
                            nativeRowOff: this.nativeRowOff
                        };
                    }
                    set model(e) {
                        this.nativeCol = e.nativeCol, this.nativeColOff = e.nativeColOff, this.nativeRow = e.nativeRow, this.nativeRowOff = e.nativeRowOff;
                    }
                }
                t.exports = i;
            },
            {
                "../utils/col-cache": 19
            }
        ],
        3: [
            function(e, t, r) {
                "use strict";
                const n = e("../utils/col-cache"), i = e("../utils/under-dash"), s = e("./enums"), { slideFormula: o } = e("../utils/shared-formula"), a = e("./note");
                class l {
                    constructor(e, t, r){
                        if (!e || !t) throw new Error("A Cell needs a Row");
                        this._row = e, this._column = t, n.validateAddress(r), this._address = r, this._value = c.create(l.Types.Null, this), this.style = this._mergeStyle(e.style, t.style, {}), this._mergeCount = 0;
                    }
                    get worksheet() {
                        return this._row.worksheet;
                    }
                    get workbook() {
                        return this._row.worksheet.workbook;
                    }
                    destroy() {
                        delete this.style, delete this._value, delete this._row, delete this._column, delete this._address;
                    }
                    get numFmt() {
                        return this.style.numFmt;
                    }
                    set numFmt(e) {
                        this.style.numFmt = e;
                    }
                    get font() {
                        return this.style.font;
                    }
                    set font(e) {
                        this.style.font = e;
                    }
                    get alignment() {
                        return this.style.alignment;
                    }
                    set alignment(e) {
                        this.style.alignment = e;
                    }
                    get border() {
                        return this.style.border;
                    }
                    set border(e) {
                        this.style.border = e;
                    }
                    get fill() {
                        return this.style.fill;
                    }
                    set fill(e) {
                        this.style.fill = e;
                    }
                    get protection() {
                        return this.style.protection;
                    }
                    set protection(e) {
                        this.style.protection = e;
                    }
                    _mergeStyle(e, t, r) {
                        const n = e && e.numFmt || t && t.numFmt;
                        n && (r.numFmt = n);
                        const i = e && e.font || t && t.font;
                        i && (r.font = i);
                        const s = e && e.alignment || t && t.alignment;
                        s && (r.alignment = s);
                        const o = e && e.border || t && t.border;
                        o && (r.border = o);
                        const a = e && e.fill || t && t.fill;
                        a && (r.fill = a);
                        const l = e && e.protection || t && t.protection;
                        return l && (r.protection = l), r;
                    }
                    get address() {
                        return this._address;
                    }
                    get row() {
                        return this._row.number;
                    }
                    get col() {
                        return this._column.number;
                    }
                    get $col$row() {
                        return `$${this._column.letter}$${this.row}`;
                    }
                    get type() {
                        return this._value.type;
                    }
                    get effectiveType() {
                        return this._value.effectiveType;
                    }
                    toCsvString() {
                        return this._value.toCsvString();
                    }
                    addMergeRef() {
                        this._mergeCount++;
                    }
                    releaseMergeRef() {
                        this._mergeCount--;
                    }
                    get isMerged() {
                        return this._mergeCount > 0 || this.type === l.Types.Merge;
                    }
                    merge(e, t) {
                        this._value.release(), this._value = c.create(l.Types.Merge, this, e), t || (this.style = e.style);
                    }
                    unmerge() {
                        this.type === l.Types.Merge && (this._value.release(), this._value = c.create(l.Types.Null, this), this.style = this._mergeStyle(this._row.style, this._column.style, {}));
                    }
                    isMergedTo(e) {
                        return this._value.type === l.Types.Merge && this._value.isMergedTo(e);
                    }
                    get master() {
                        return this.type === l.Types.Merge ? this._value.master : this;
                    }
                    get isHyperlink() {
                        return this._value.type === l.Types.Hyperlink;
                    }
                    get hyperlink() {
                        return this._value.hyperlink;
                    }
                    get value() {
                        return this._value.value;
                    }
                    set value(e) {
                        this.type !== l.Types.Merge ? (this._value.release(), this._value = c.create(c.getType(e), this, e)) : this._value.master.value = e;
                    }
                    get note() {
                        return this._comment && this._comment.note;
                    }
                    set note(e) {
                        this._comment = new a(e);
                    }
                    get text() {
                        return this._value.toString();
                    }
                    get html() {
                        return i.escapeHtml(this.text);
                    }
                    toString() {
                        return this.text;
                    }
                    _upgradeToHyperlink(e) {
                        this.type === l.Types.String && (this._value = c.create(l.Types.Hyperlink, this, {
                            text: this._value.value,
                            hyperlink: e
                        }));
                    }
                    get formula() {
                        return this._value.formula;
                    }
                    get result() {
                        return this._value.result;
                    }
                    get formulaType() {
                        return this._value.formulaType;
                    }
                    get fullAddress() {
                        const { worksheet: e } = this._row;
                        return {
                            sheetName: e.name,
                            address: this.address,
                            row: this.row,
                            col: this.col
                        };
                    }
                    get name() {
                        return this.names[0];
                    }
                    set name(e) {
                        this.names = [
                            e
                        ];
                    }
                    get names() {
                        return this.workbook.definedNames.getNamesEx(this.fullAddress);
                    }
                    set names(e) {
                        const { definedNames: t } = this.workbook;
                        t.removeAllNames(this.fullAddress), e.forEach((e)=>{
                            t.addEx(this.fullAddress, e);
                        });
                    }
                    addName(e) {
                        this.workbook.definedNames.addEx(this.fullAddress, e);
                    }
                    removeName(e) {
                        this.workbook.definedNames.removeEx(this.fullAddress, e);
                    }
                    removeAllNames() {
                        this.workbook.definedNames.removeAllNames(this.fullAddress);
                    }
                    get _dataValidations() {
                        return this.worksheet.dataValidations;
                    }
                    get dataValidation() {
                        return this._dataValidations.find(this.address);
                    }
                    set dataValidation(e) {
                        this._dataValidations.add(this.address, e);
                    }
                    get model() {
                        const { model: e } = this._value;
                        return e.style = this.style, this._comment && (e.comment = this._comment.model), e;
                    }
                    set model(e) {
                        if (this._value.release(), this._value = c.create(e.type, this), this._value.model = e, e.comment) switch(e.comment.type){
                            case "note":
                                this._comment = a.fromModel(e.comment);
                        }
                        e.style ? this.style = e.style : this.style = {};
                    }
                }
                l.Types = s.ValueType;
                const c = {
                    getType: (e)=>null == e ? l.Types.Null : e instanceof String || "string" == typeof e ? l.Types.String : "number" == typeof e ? l.Types.Number : "boolean" == typeof e ? l.Types.Boolean : e instanceof Date ? l.Types.Date : e.text && e.hyperlink ? l.Types.Hyperlink : e.formula || e.sharedFormula ? l.Types.Formula : e.richText ? l.Types.RichText : e.sharedString ? l.Types.SharedString : e.error ? l.Types.Error : l.Types.JSON,
                    types: [
                        {
                            t: l.Types.Null,
                            f: class {
                                constructor(e){
                                    this.model = {
                                        address: e.address,
                                        type: l.Types.Null
                                    };
                                }
                                get value() {
                                    return null;
                                }
                                set value(e) {}
                                get type() {
                                    return l.Types.Null;
                                }
                                get effectiveType() {
                                    return l.Types.Null;
                                }
                                get address() {
                                    return this.model.address;
                                }
                                set address(e) {
                                    this.model.address = e;
                                }
                                toCsvString() {
                                    return "";
                                }
                                release() {}
                                toString() {
                                    return "";
                                }
                            }
                        },
                        {
                            t: l.Types.Number,
                            f: class {
                                constructor(e, t){
                                    this.model = {
                                        address: e.address,
                                        type: l.Types.Number,
                                        value: t
                                    };
                                }
                                get value() {
                                    return this.model.value;
                                }
                                set value(e) {
                                    this.model.value = e;
                                }
                                get type() {
                                    return l.Types.Number;
                                }
                                get effectiveType() {
                                    return l.Types.Number;
                                }
                                get address() {
                                    return this.model.address;
                                }
                                set address(e) {
                                    this.model.address = e;
                                }
                                toCsvString() {
                                    return this.model.value.toString();
                                }
                                release() {}
                                toString() {
                                    return this.model.value.toString();
                                }
                            }
                        },
                        {
                            t: l.Types.String,
                            f: class {
                                constructor(e, t){
                                    this.model = {
                                        address: e.address,
                                        type: l.Types.String,
                                        value: t
                                    };
                                }
                                get value() {
                                    return this.model.value;
                                }
                                set value(e) {
                                    this.model.value = e;
                                }
                                get type() {
                                    return l.Types.String;
                                }
                                get effectiveType() {
                                    return l.Types.String;
                                }
                                get address() {
                                    return this.model.address;
                                }
                                set address(e) {
                                    this.model.address = e;
                                }
                                toCsvString() {
                                    return `"${this.model.value.replace(/"/g, '""')}"`;
                                }
                                release() {}
                                toString() {
                                    return this.model.value;
                                }
                            }
                        },
                        {
                            t: l.Types.Date,
                            f: class {
                                constructor(e, t){
                                    this.model = {
                                        address: e.address,
                                        type: l.Types.Date,
                                        value: t
                                    };
                                }
                                get value() {
                                    return this.model.value;
                                }
                                set value(e) {
                                    this.model.value = e;
                                }
                                get type() {
                                    return l.Types.Date;
                                }
                                get effectiveType() {
                                    return l.Types.Date;
                                }
                                get address() {
                                    return this.model.address;
                                }
                                set address(e) {
                                    this.model.address = e;
                                }
                                toCsvString() {
                                    return this.model.value.toISOString();
                                }
                                release() {}
                                toString() {
                                    return this.model.value.toString();
                                }
                            }
                        },
                        {
                            t: l.Types.Hyperlink,
                            f: class {
                                constructor(e, t){
                                    this.model = {
                                        address: e.address,
                                        type: l.Types.Hyperlink,
                                        text: t ? t.text : void 0,
                                        hyperlink: t ? t.hyperlink : void 0
                                    }, t && t.tooltip && (this.model.tooltip = t.tooltip);
                                }
                                get value() {
                                    const e = {
                                        text: this.model.text,
                                        hyperlink: this.model.hyperlink
                                    };
                                    return this.model.tooltip && (e.tooltip = this.model.tooltip), e;
                                }
                                set value(e) {
                                    this.model = {
                                        text: e.text,
                                        hyperlink: e.hyperlink
                                    }, e.tooltip && (this.model.tooltip = e.tooltip);
                                }
                                get text() {
                                    return this.model.text;
                                }
                                set text(e) {
                                    this.model.text = e;
                                }
                                get hyperlink() {
                                    return this.model.hyperlink;
                                }
                                set hyperlink(e) {
                                    this.model.hyperlink = e;
                                }
                                get type() {
                                    return l.Types.Hyperlink;
                                }
                                get effectiveType() {
                                    return l.Types.Hyperlink;
                                }
                                get address() {
                                    return this.model.address;
                                }
                                set address(e) {
                                    this.model.address = e;
                                }
                                toCsvString() {
                                    return this.model.hyperlink;
                                }
                                release() {}
                                toString() {
                                    return this.model.text;
                                }
                            }
                        },
                        {
                            t: l.Types.Formula,
                            f: class {
                                constructor(e, t){
                                    this.cell = e, this.model = {
                                        address: e.address,
                                        type: l.Types.Formula,
                                        shareType: t ? t.shareType : void 0,
                                        ref: t ? t.ref : void 0,
                                        formula: t ? t.formula : void 0,
                                        sharedFormula: t ? t.sharedFormula : void 0,
                                        result: t ? t.result : void 0
                                    };
                                }
                                _copyModel(e) {
                                    const t = {}, r = (r)=>{
                                        const n = e[r];
                                        n && (t[r] = n);
                                    };
                                    return r("formula"), r("result"), r("ref"), r("shareType"), r("sharedFormula"), t;
                                }
                                get value() {
                                    return this._copyModel(this.model);
                                }
                                set value(e) {
                                    this.model = this._copyModel(e);
                                }
                                validate(e) {
                                    switch(c.getType(e)){
                                        case l.Types.Null:
                                        case l.Types.String:
                                        case l.Types.Number:
                                        case l.Types.Date:
                                            break;
                                        case l.Types.Hyperlink:
                                        case l.Types.Formula:
                                        default:
                                            throw new Error("Cannot process that type of result value");
                                    }
                                }
                                get dependencies() {
                                    return {
                                        ranges: this.formula.match(/([a-zA-Z0-9]+!)?[A-Z]{1,3}\d{1,4}:[A-Z]{1,3}\d{1,4}/g),
                                        cells: this.formula.replace(/([a-zA-Z0-9]+!)?[A-Z]{1,3}\d{1,4}:[A-Z]{1,3}\d{1,4}/g, "").match(/([a-zA-Z0-9]+!)?[A-Z]{1,3}\d{1,4}/g)
                                    };
                                }
                                get formula() {
                                    return this.model.formula || this._getTranslatedFormula();
                                }
                                set formula(e) {
                                    this.model.formula = e;
                                }
                                get formulaType() {
                                    return this.model.formula ? s.FormulaType.Master : this.model.sharedFormula ? s.FormulaType.Shared : s.FormulaType.None;
                                }
                                get result() {
                                    return this.model.result;
                                }
                                set result(e) {
                                    this.model.result = e;
                                }
                                get type() {
                                    return l.Types.Formula;
                                }
                                get effectiveType() {
                                    const e = this.model.result;
                                    return null == e ? s.ValueType.Null : e instanceof String || "string" == typeof e ? s.ValueType.String : "number" == typeof e ? s.ValueType.Number : e instanceof Date ? s.ValueType.Date : e.text && e.hyperlink ? s.ValueType.Hyperlink : e.formula ? s.ValueType.Formula : s.ValueType.Null;
                                }
                                get address() {
                                    return this.model.address;
                                }
                                set address(e) {
                                    this.model.address = e;
                                }
                                _getTranslatedFormula() {
                                    if (!this._translatedFormula && this.model.sharedFormula) {
                                        const { worksheet: e } = this.cell, t = e.findCell(this.model.sharedFormula);
                                        this._translatedFormula = t && o(t.formula, t.address, this.model.address);
                                    }
                                    return this._translatedFormula;
                                }
                                toCsvString() {
                                    return "" + (this.model.result || "");
                                }
                                release() {}
                                toString() {
                                    return this.model.result ? this.model.result.toString() : "";
                                }
                            }
                        },
                        {
                            t: l.Types.Merge,
                            f: class {
                                constructor(e, t){
                                    this.model = {
                                        address: e.address,
                                        type: l.Types.Merge,
                                        master: t ? t.address : void 0
                                    }, this._master = t, t && t.addMergeRef();
                                }
                                get value() {
                                    return this._master.value;
                                }
                                set value(e) {
                                    e instanceof l ? (this._master && this._master.releaseMergeRef(), e.addMergeRef(), this._master = e) : this._master.value = e;
                                }
                                isMergedTo(e) {
                                    return e === this._master;
                                }
                                get master() {
                                    return this._master;
                                }
                                get type() {
                                    return l.Types.Merge;
                                }
                                get effectiveType() {
                                    return this._master.effectiveType;
                                }
                                get address() {
                                    return this.model.address;
                                }
                                set address(e) {
                                    this.model.address = e;
                                }
                                toCsvString() {
                                    return "";
                                }
                                release() {
                                    this._master.releaseMergeRef();
                                }
                                toString() {
                                    return this.value.toString();
                                }
                            }
                        },
                        {
                            t: l.Types.JSON,
                            f: class {
                                constructor(e, t){
                                    this.model = {
                                        address: e.address,
                                        type: l.Types.String,
                                        value: JSON.stringify(t),
                                        rawValue: t
                                    };
                                }
                                get value() {
                                    return this.model.rawValue;
                                }
                                set value(e) {
                                    this.model.rawValue = e, this.model.value = JSON.stringify(e);
                                }
                                get type() {
                                    return l.Types.String;
                                }
                                get effectiveType() {
                                    return l.Types.String;
                                }
                                get address() {
                                    return this.model.address;
                                }
                                set address(e) {
                                    this.model.address = e;
                                }
                                toCsvString() {
                                    return this.model.value;
                                }
                                release() {}
                                toString() {
                                    return this.model.value;
                                }
                            }
                        },
                        {
                            t: l.Types.SharedString,
                            f: class {
                                constructor(e, t){
                                    this.model = {
                                        address: e.address,
                                        type: l.Types.SharedString,
                                        value: t
                                    };
                                }
                                get value() {
                                    return this.model.value;
                                }
                                set value(e) {
                                    this.model.value = e;
                                }
                                get type() {
                                    return l.Types.SharedString;
                                }
                                get effectiveType() {
                                    return l.Types.SharedString;
                                }
                                get address() {
                                    return this.model.address;
                                }
                                set address(e) {
                                    this.model.address = e;
                                }
                                toCsvString() {
                                    return this.model.value.toString();
                                }
                                release() {}
                                toString() {
                                    return this.model.value.toString();
                                }
                            }
                        },
                        {
                            t: l.Types.RichText,
                            f: class {
                                constructor(e, t){
                                    this.model = {
                                        address: e.address,
                                        type: l.Types.String,
                                        value: t
                                    };
                                }
                                get value() {
                                    return this.model.value;
                                }
                                set value(e) {
                                    this.model.value = e;
                                }
                                toString() {
                                    return this.model.value.richText.map((e)=>e.text).join("");
                                }
                                get type() {
                                    return l.Types.RichText;
                                }
                                get effectiveType() {
                                    return l.Types.RichText;
                                }
                                get address() {
                                    return this.model.address;
                                }
                                set address(e) {
                                    this.model.address = e;
                                }
                                toCsvString() {
                                    return `"${this.text.replace(/"/g, '""')}"`;
                                }
                                release() {}
                            }
                        },
                        {
                            t: l.Types.Boolean,
                            f: class {
                                constructor(e, t){
                                    this.model = {
                                        address: e.address,
                                        type: l.Types.Boolean,
                                        value: t
                                    };
                                }
                                get value() {
                                    return this.model.value;
                                }
                                set value(e) {
                                    this.model.value = e;
                                }
                                get type() {
                                    return l.Types.Boolean;
                                }
                                get effectiveType() {
                                    return l.Types.Boolean;
                                }
                                get address() {
                                    return this.model.address;
                                }
                                set address(e) {
                                    this.model.address = e;
                                }
                                toCsvString() {
                                    return this.model.value ? 1 : 0;
                                }
                                release() {}
                                toString() {
                                    return this.model.value.toString();
                                }
                            }
                        },
                        {
                            t: l.Types.Error,
                            f: class {
                                constructor(e, t){
                                    this.model = {
                                        address: e.address,
                                        type: l.Types.Error,
                                        value: t
                                    };
                                }
                                get value() {
                                    return this.model.value;
                                }
                                set value(e) {
                                    this.model.value = e;
                                }
                                get type() {
                                    return l.Types.Error;
                                }
                                get effectiveType() {
                                    return l.Types.Error;
                                }
                                get address() {
                                    return this.model.address;
                                }
                                set address(e) {
                                    this.model.address = e;
                                }
                                toCsvString() {
                                    return this.toString();
                                }
                                release() {}
                                toString() {
                                    return this.model.value.error.toString();
                                }
                            }
                        }
                    ].reduce((e, t)=>(e[t.t] = t.f, e), []),
                    create (e, t, r) {
                        const n = this.types[e];
                        if (!n) throw new Error("Could not create Value of type " + e);
                        return new n(t, r);
                    }
                };
                t.exports = l;
            },
            {
                "../utils/col-cache": 19,
                "../utils/shared-formula": 23,
                "../utils/under-dash": 26,
                "./enums": 7,
                "./note": 9
            }
        ],
        4: [
            function(e, t, r) {
                "use strict";
                const n = e("../utils/under-dash"), i = e("./enums"), s = e("../utils/col-cache");
                class o {
                    constructor(e, t, r){
                        this._worksheet = e, this._number = t, !1 !== r && (this.defn = r);
                    }
                    get number() {
                        return this._number;
                    }
                    get worksheet() {
                        return this._worksheet;
                    }
                    get letter() {
                        return s.n2l(this._number);
                    }
                    get isCustomWidth() {
                        return void 0 !== this.width && 9 !== this.width;
                    }
                    get defn() {
                        return {
                            header: this._header,
                            key: this.key,
                            width: this.width,
                            style: this.style,
                            hidden: this.hidden,
                            outlineLevel: this.outlineLevel
                        };
                    }
                    set defn(e) {
                        e ? (this.key = e.key, this.width = void 0 !== e.width ? e.width : 9, this.outlineLevel = e.outlineLevel, e.style ? this.style = e.style : this.style = {}, this.header = e.header, this._hidden = !!e.hidden) : (delete this._header, delete this._key, delete this.width, this.style = {}, this.outlineLevel = 0);
                    }
                    get headers() {
                        return this._header && this._header instanceof Array ? this._header : [
                            this._header
                        ];
                    }
                    get header() {
                        return this._header;
                    }
                    set header(e) {
                        void 0 !== e ? (this._header = e, this.headers.forEach((e, t)=>{
                            this._worksheet.getCell(t + 1, this.number).value = e;
                        })) : this._header = void 0;
                    }
                    get key() {
                        return this._key;
                    }
                    set key(e) {
                        (this._key && this._worksheet.getColumnKey(this._key)) === this && this._worksheet.deleteColumnKey(this._key), this._key = e, e && this._worksheet.setColumnKey(this._key, this);
                    }
                    get hidden() {
                        return !!this._hidden;
                    }
                    set hidden(e) {
                        this._hidden = e;
                    }
                    get outlineLevel() {
                        return this._outlineLevel || 0;
                    }
                    set outlineLevel(e) {
                        this._outlineLevel = e;
                    }
                    get collapsed() {
                        return !!(this._outlineLevel && this._outlineLevel >= this._worksheet.properties.outlineLevelCol);
                    }
                    toString() {
                        return JSON.stringify({
                            key: this.key,
                            width: this.width,
                            headers: this.headers.length ? this.headers : void 0
                        });
                    }
                    equivalentTo(e) {
                        return this.width === e.width && this.hidden === e.hidden && this.outlineLevel === e.outlineLevel && n.isEqual(this.style, e.style);
                    }
                    get isDefault() {
                        if (this.isCustomWidth) return !1;
                        if (this.hidden) return !1;
                        if (this.outlineLevel) return !1;
                        const e = this.style;
                        return !e || !(e.font || e.numFmt || e.alignment || e.border || e.fill || e.protection);
                    }
                    get headerCount() {
                        return this.headers.length;
                    }
                    eachCell(e, t) {
                        const r = this.number;
                        t || (t = e, e = null), this._worksheet.eachRow(e, (e, n)=>{
                            t(e.getCell(r), n);
                        });
                    }
                    get values() {
                        const e = [];
                        return this.eachCell((t, r)=>{
                            t && t.type !== i.ValueType.Null && (e[r] = t.value);
                        }), e;
                    }
                    set values(e) {
                        if (!e) return;
                        const t = this.number;
                        let r = 0;
                        e.hasOwnProperty("0") && (r = 1), e.forEach((e, n)=>{
                            this._worksheet.getCell(n + r, t).value = e;
                        });
                    }
                    _applyStyle(e, t) {
                        return this.style[e] = t, this.eachCell((r)=>{
                            r[e] = t;
                        }), t;
                    }
                    get numFmt() {
                        return this.style.numFmt;
                    }
                    set numFmt(e) {
                        this._applyStyle("numFmt", e);
                    }
                    get font() {
                        return this.style.font;
                    }
                    set font(e) {
                        this._applyStyle("font", e);
                    }
                    get alignment() {
                        return this.style.alignment;
                    }
                    set alignment(e) {
                        this._applyStyle("alignment", e);
                    }
                    get protection() {
                        return this.style.protection;
                    }
                    set protection(e) {
                        this._applyStyle("protection", e);
                    }
                    get border() {
                        return this.style.border;
                    }
                    set border(e) {
                        this._applyStyle("border", e);
                    }
                    get fill() {
                        return this.style.fill;
                    }
                    set fill(e) {
                        this._applyStyle("fill", e);
                    }
                    static toModel(e) {
                        const t = [];
                        let r = null;
                        return e && e.forEach((e, n)=>{
                            e.isDefault ? r && (r = null) : r && e.equivalentTo(r) ? r.max = n + 1 : (r = {
                                min: n + 1,
                                max: n + 1,
                                width: void 0 !== e.width ? e.width : 9,
                                style: e.style,
                                isCustomWidth: e.isCustomWidth,
                                hidden: e.hidden,
                                outlineLevel: e.outlineLevel,
                                collapsed: e.collapsed
                            }, t.push(r));
                        }), t.length ? t : void 0;
                    }
                    static fromModel(e, t) {
                        const r = [];
                        let n = 1, i = 0;
                        for(t = (t = t || []).sort(function(e, t) {
                            return e.min - t.min;
                        }); i < t.length;){
                            const s = t[i++];
                            for(; n < s.min;)r.push(new o(e, n++));
                            for(; n <= s.max;)r.push(new o(e, n++, s));
                        }
                        return r.length ? r : null;
                    }
                }
                t.exports = o;
            },
            {
                "../utils/col-cache": 19,
                "../utils/under-dash": 26,
                "./enums": 7
            }
        ],
        5: [
            function(e, t, r) {
                "use strict";
                t.exports = class {
                    constructor(e){
                        this.model = e || {};
                    }
                    add(e, t) {
                        return this.model[e] = t;
                    }
                    find(e) {
                        return this.model[e];
                    }
                    remove(e) {
                        this.model[e] = void 0;
                    }
                };
            },
            {}
        ],
        6: [
            function(e, t, r) {
                "use strict";
                const n = e("../utils/under-dash"), i = e("../utils/col-cache"), s = e("../utils/cell-matrix"), o = e("./range"), a = /[$](\w+)[$](\d+)(:[$](\w+)[$](\d+))?/;
                t.exports = class {
                    constructor(){
                        this.matrixMap = {};
                    }
                    getMatrix(e) {
                        return this.matrixMap[e] || (this.matrixMap[e] = new s);
                    }
                    add(e, t) {
                        const r = i.decodeEx(e);
                        this.addEx(r, t);
                    }
                    addEx(e, t) {
                        const r = this.getMatrix(t);
                        if (e.top) for(let t = e.left; t <= e.right; t++)for(let n = e.top; n <= e.bottom; n++){
                            const s = {
                                sheetName: e.sheetName,
                                address: i.n2l(t) + n,
                                row: n,
                                col: t
                            };
                            r.addCellEx(s);
                        }
                        else r.addCellEx(e);
                    }
                    remove(e, t) {
                        const r = i.decodeEx(e);
                        this.removeEx(r, t);
                    }
                    removeEx(e, t) {
                        this.getMatrix(t).removeCellEx(e);
                    }
                    removeAllNames(e) {
                        n.each(this.matrixMap, (t)=>{
                            t.removeCellEx(e);
                        });
                    }
                    forEach(e) {
                        n.each(this.matrixMap, (t, r)=>{
                            t.forEach((t)=>{
                                e(r, t);
                            });
                        });
                    }
                    getNames(e) {
                        return this.getNamesEx(i.decodeEx(e));
                    }
                    getNamesEx(e) {
                        return n.map(this.matrixMap, (t, r)=>t.findCellEx(e) && r).filter(Boolean);
                    }
                    _explore(e, t) {
                        t.mark = !1;
                        const { sheetName: r } = t, n = new o(t.row, t.col, t.row, t.col, r);
                        let i, s;
                        function a(i, s) {
                            const o = e.findCellAt(r, i, t.col);
                            return !(!o || !o.mark) && (n[s] = i, o.mark = !1, !0);
                        }
                        for(s = t.row - 1; a(s, "top"); s--);
                        for(s = t.row + 1; a(s, "bottom"); s++);
                        function l(t, i) {
                            const o = [];
                            for(s = n.top; s <= n.bottom; s++){
                                const n = e.findCellAt(r, s, t);
                                if (!n || !n.mark) return !1;
                                o.push(n);
                            }
                            n[i] = t;
                            for(let e = 0; e < o.length; e++)o[e].mark = !1;
                            return !0;
                        }
                        for(i = t.col - 1; l(i, "left"); i--);
                        for(i = t.col + 1; l(i, "right"); i++);
                        return n;
                    }
                    getRanges(e, t) {
                        if (!(t = t || this.matrixMap[e])) return {
                            name: e,
                            ranges: []
                        };
                        t.forEach((e)=>{
                            e.mark = !0;
                        });
                        return {
                            name: e,
                            ranges: t.map((e)=>e.mark && this._explore(t, e)).filter(Boolean).map((e)=>e.$shortRange)
                        };
                    }
                    normaliseMatrix(e, t) {
                        e.forEachInSheet(t, (e, t, r)=>{
                            e && (e.row === t && e.col === r || (e.row = t, e.col = r, e.address = i.n2l(r) + t));
                        });
                    }
                    spliceRows(e, t, r, i) {
                        n.each(this.matrixMap, (n)=>{
                            n.spliceRows(e, t, r, i), this.normaliseMatrix(n, e);
                        });
                    }
                    spliceColumns(e, t, r, i) {
                        n.each(this.matrixMap, (n)=>{
                            n.spliceColumns(e, t, r, i), this.normaliseMatrix(n, e);
                        });
                    }
                    get model() {
                        return n.map(this.matrixMap, (e, t)=>this.getRanges(t, e)).filter((e)=>e.ranges.length);
                    }
                    set model(e) {
                        const t = this.matrixMap = {};
                        e.forEach((e)=>{
                            const r = t[e.name] = new s;
                            e.ranges.forEach((e)=>{
                                a.test(e.split("!").pop() || "") && r.addCell(e);
                            });
                        });
                    }
                };
            },
            {
                "../utils/cell-matrix": 18,
                "../utils/col-cache": 19,
                "../utils/under-dash": 26,
                "./range": 10
            }
        ],
        7: [
            function(e, t, r) {
                "use strict";
                t.exports = {
                    ValueType: {
                        Null: 0,
                        Merge: 1,
                        Number: 2,
                        String: 3,
                        Date: 4,
                        Hyperlink: 5,
                        Formula: 6,
                        SharedString: 7,
                        RichText: 8,
                        Boolean: 9,
                        Error: 10
                    },
                    FormulaType: {
                        None: 0,
                        Master: 1,
                        Shared: 2
                    },
                    RelationshipType: {
                        None: 0,
                        OfficeDocument: 1,
                        Worksheet: 2,
                        CalcChain: 3,
                        SharedStrings: 4,
                        Styles: 5,
                        Theme: 6,
                        Hyperlink: 7
                    },
                    DocumentType: {
                        Xlsx: 1
                    },
                    ReadingOrder: {
                        LeftToRight: 1,
                        RightToLeft: 2
                    },
                    ErrorValue: {
                        NotApplicable: "#N/A",
                        Ref: "#REF!",
                        Name: "#NAME?",
                        DivZero: "#DIV/0!",
                        Null: "#NULL!",
                        Value: "#VALUE!",
                        Num: "#NUM!"
                    }
                };
            },
            {}
        ],
        8: [
            function(e, t, r) {
                "use strict";
                const n = e("../utils/col-cache"), i = e("./anchor");
                t.exports = class {
                    constructor(e, t){
                        this.worksheet = e, this.model = t;
                    }
                    get model() {
                        switch(this.type){
                            case "background":
                                return {
                                    type: this.type,
                                    imageId: this.imageId
                                };
                            case "image":
                                return {
                                    type: this.type,
                                    imageId: this.imageId,
                                    hyperlinks: this.range.hyperlinks,
                                    range: {
                                        tl: this.range.tl.model,
                                        br: this.range.br && this.range.br.model,
                                        ext: this.range.ext,
                                        editAs: this.range.editAs
                                    }
                                };
                            default:
                                throw new Error("Invalid Image Type");
                        }
                    }
                    set model(e) {
                        let { type: t, imageId: r, range: s, hyperlinks: o } = e;
                        if (this.type = t, this.imageId = r, "image" === t) {
                            if ("string" == typeof s) {
                                const e = n.decode(s);
                                this.range = {
                                    tl: new i(this.worksheet, {
                                        col: e.left,
                                        row: e.top
                                    }, -1),
                                    br: new i(this.worksheet, {
                                        col: e.right,
                                        row: e.bottom
                                    }, 0),
                                    editAs: "oneCell"
                                };
                            } else this.range = {
                                tl: new i(this.worksheet, s.tl, 0),
                                br: s.br && new i(this.worksheet, s.br, 0),
                                ext: s.ext,
                                editAs: s.editAs,
                                hyperlinks: o || s.hyperlinks
                            };
                        }
                    }
                };
            },
            {
                "../utils/col-cache": 19,
                "./anchor": 2
            }
        ],
        9: [
            function(e, t, r) {
                "use strict";
                const n = e("../utils/under-dash");
                class i {
                    constructor(e){
                        this.note = e;
                    }
                    get model() {
                        let e = null;
                        switch(typeof this.note){
                            case "string":
                                e = {
                                    type: "note",
                                    note: {
                                        texts: [
                                            {
                                                text: this.note
                                            }
                                        ]
                                    }
                                };
                                break;
                            default:
                                e = {
                                    type: "note",
                                    note: this.note
                                };
                        }
                        return n.deepMerge({}, i.DEFAULT_CONFIGS, e);
                    }
                    set model(e) {
                        const { note: t } = e, { texts: r } = t;
                        1 === r.length && 1 === Object.keys(r[0]).length ? this.note = r[0].text : this.note = t;
                    }
                    static fromModel(e) {
                        const t = new i;
                        return t.model = e, t;
                    }
                }
                i.DEFAULT_CONFIGS = {
                    note: {
                        margins: {
                            insetmode: "auto",
                            inset: [
                                .13,
                                .13,
                                .25,
                                .25
                            ]
                        },
                        protection: {
                            locked: "True",
                            lockText: "True"
                        },
                        editAs: "absolute"
                    }
                }, t.exports = i;
            },
            {
                "../utils/under-dash": 26
            }
        ],
        10: [
            function(e, t, r) {
                "use strict";
                const n = e("../utils/col-cache");
                class i {
                    constructor(){
                        this.decode(arguments);
                    }
                    setTLBR(e, t, r, i, s) {
                        if (arguments.length < 4) {
                            const i = n.decodeAddress(e), o = n.decodeAddress(t);
                            this.model = {
                                top: Math.min(i.row, o.row),
                                left: Math.min(i.col, o.col),
                                bottom: Math.max(i.row, o.row),
                                right: Math.max(i.col, o.col),
                                sheetName: r
                            }, this.setTLBR(i.row, i.col, o.row, o.col, s);
                        } else this.model = {
                            top: Math.min(e, r),
                            left: Math.min(t, i),
                            bottom: Math.max(e, r),
                            right: Math.max(t, i),
                            sheetName: s
                        };
                    }
                    decode(e) {
                        switch(e.length){
                            case 5:
                                this.setTLBR(e[0], e[1], e[2], e[3], e[4]);
                                break;
                            case 4:
                                this.setTLBR(e[0], e[1], e[2], e[3]);
                                break;
                            case 3:
                                this.setTLBR(e[0], e[1], e[2]);
                                break;
                            case 2:
                                this.setTLBR(e[0], e[1]);
                                break;
                            case 1:
                                {
                                    const t = e[0];
                                    if (t instanceof i) this.model = {
                                        top: t.model.top,
                                        left: t.model.left,
                                        bottom: t.model.bottom,
                                        right: t.model.right,
                                        sheetName: t.sheetName
                                    };
                                    else if (t instanceof Array) this.decode(t);
                                    else if (t.top && t.left && t.bottom && t.right) this.model = {
                                        top: t.top,
                                        left: t.left,
                                        bottom: t.bottom,
                                        right: t.right,
                                        sheetName: t.sheetName
                                    };
                                    else {
                                        const e = n.decodeEx(t);
                                        e.top ? this.model = {
                                            top: e.top,
                                            left: e.left,
                                            bottom: e.bottom,
                                            right: e.right,
                                            sheetName: e.sheetName
                                        } : this.model = {
                                            top: e.row,
                                            left: e.col,
                                            bottom: e.row,
                                            right: e.col,
                                            sheetName: e.sheetName
                                        };
                                    }
                                    break;
                                }
                            case 0:
                                this.model = {
                                    top: 0,
                                    left: 0,
                                    bottom: 0,
                                    right: 0
                                };
                                break;
                            default:
                                throw new Error("Invalid number of arguments to _getDimensions() - " + e.length);
                        }
                    }
                    get top() {
                        return this.model.top || 1;
                    }
                    set top(e) {
                        this.model.top = e;
                    }
                    get left() {
                        return this.model.left || 1;
                    }
                    set left(e) {
                        this.model.left = e;
                    }
                    get bottom() {
                        return this.model.bottom || 1;
                    }
                    set bottom(e) {
                        this.model.bottom = e;
                    }
                    get right() {
                        return this.model.right || 1;
                    }
                    set right(e) {
                        this.model.right = e;
                    }
                    get sheetName() {
                        return this.model.sheetName;
                    }
                    set sheetName(e) {
                        this.model.sheetName = e;
                    }
                    get _serialisedSheetName() {
                        const { sheetName: e } = this.model;
                        return e ? /^[a-zA-Z0-9]*$/.test(e) ? e + "!" : `'${e}'!` : "";
                    }
                    expand(e, t, r, n) {
                        (!this.model.top || e < this.top) && (this.top = e), (!this.model.left || t < this.left) && (this.left = t), (!this.model.bottom || r > this.bottom) && (this.bottom = r), (!this.model.right || n > this.right) && (this.right = n);
                    }
                    expandRow(e) {
                        if (e) {
                            const { dimensions: t, number: r } = e;
                            t && this.expand(r, t.min, r, t.max);
                        }
                    }
                    expandToAddress(e) {
                        const t = n.decodeEx(e);
                        this.expand(t.row, t.col, t.row, t.col);
                    }
                    get tl() {
                        return n.n2l(this.left) + this.top;
                    }
                    get $t$l() {
                        return `$${n.n2l(this.left)}$${this.top}`;
                    }
                    get br() {
                        return n.n2l(this.right) + this.bottom;
                    }
                    get $b$r() {
                        return `$${n.n2l(this.right)}$${this.bottom}`;
                    }
                    get range() {
                        return `${this._serialisedSheetName + this.tl}:${this.br}`;
                    }
                    get $range() {
                        return `${this._serialisedSheetName + this.$t$l}:${this.$b$r}`;
                    }
                    get shortRange() {
                        return this.count > 1 ? this.range : this._serialisedSheetName + this.tl;
                    }
                    get $shortRange() {
                        return this.count > 1 ? this.$range : this._serialisedSheetName + this.$t$l;
                    }
                    get count() {
                        return (1 + this.bottom - this.top) * (1 + this.right - this.left);
                    }
                    toString() {
                        return this.range;
                    }
                    intersects(e) {
                        return (!e.sheetName || !this.sheetName || e.sheetName === this.sheetName) && !(e.bottom < this.top) && !(e.top > this.bottom) && !(e.right < this.left) && !(e.left > this.right);
                    }
                    contains(e) {
                        const t = n.decodeEx(e);
                        return this.containsEx(t);
                    }
                    containsEx(e) {
                        return (!e.sheetName || !this.sheetName || e.sheetName === this.sheetName) && e.row >= this.top && e.row <= this.bottom && e.col >= this.left && e.col <= this.right;
                    }
                    forEachAddress(e) {
                        for(let t = this.left; t <= this.right; t++)for(let r = this.top; r <= this.bottom; r++)e(n.encodeAddress(r, t), r, t);
                    }
                }
                t.exports = i;
            },
            {
                "../utils/col-cache": 19
            }
        ],
        11: [
            function(e, t, r) {
                "use strict";
                const n = e("../utils/under-dash"), i = e("./enums"), s = e("../utils/col-cache"), o = e("./cell");
                t.exports = class {
                    constructor(e, t){
                        this._worksheet = e, this._number = t, this._cells = [], this.style = {}, this.outlineLevel = 0;
                    }
                    get number() {
                        return this._number;
                    }
                    get worksheet() {
                        return this._worksheet;
                    }
                    commit() {
                        this._worksheet._commitRow(this);
                    }
                    destroy() {
                        delete this._worksheet, delete this._cells, delete this.style;
                    }
                    findCell(e) {
                        return this._cells[e - 1];
                    }
                    getCellEx(e) {
                        let t = this._cells[e.col - 1];
                        if (!t) {
                            const r = this._worksheet.getColumn(e.col);
                            t = new o(this, r, e.address), this._cells[e.col - 1] = t;
                        }
                        return t;
                    }
                    getCell(e) {
                        if ("string" == typeof e) {
                            const t = this._worksheet.getColumnKey(e);
                            e = t ? t.number : s.l2n(e);
                        }
                        return this._cells[e - 1] || this.getCellEx({
                            address: s.encodeAddress(this._number, e),
                            row: this._number,
                            col: e
                        });
                    }
                    splice(e, t) {
                        const r = e + t;
                        for(var n = arguments.length, i = new Array(n > 2 ? n - 2 : 0), s = 2; s < n; s++)i[s - 2] = arguments[s];
                        const o = i.length - t, a = this._cells.length;
                        let l, c, u;
                        if (o < 0) for(l = e + i.length; l <= a; l++)u = this._cells[l - 1], c = this._cells[l - o - 1], c ? (u = this.getCell(l), u.value = c.value, u.style = c.style, u._comment = c._comment) : u && (u.value = null, u.style = {}, u._comment = void 0);
                        else if (o > 0) for(l = a; l >= r; l--)c = this._cells[l - 1], c ? (u = this.getCell(l + o), u.value = c.value, u.style = c.style, u._comment = c._comment) : this._cells[l + o - 1] = void 0;
                        for(l = 0; l < i.length; l++)u = this.getCell(e + l), u.value = i[l], u.style = {}, u._comment = void 0;
                    }
                    eachCell(e, t) {
                        if (t || (t = e, e = null), e && e.includeEmpty) {
                            const e = this._cells.length;
                            for(let r = 1; r <= e; r++)t(this.getCell(r), r);
                        } else this._cells.forEach((e, r)=>{
                            e && e.type !== i.ValueType.Null && t(e, r + 1);
                        });
                    }
                    addPageBreak(e, t) {
                        const r = this._worksheet, n = Math.max(0, e - 1) || 0, i = Math.max(0, t - 1) || 16838, s = {
                            id: this._number,
                            max: i,
                            man: 1
                        };
                        n && (s.min = n), r.rowBreaks.push(s);
                    }
                    get values() {
                        const e = [];
                        return this._cells.forEach((t)=>{
                            t && t.type !== i.ValueType.Null && (e[t.col] = t.value);
                        }), e;
                    }
                    set values(e) {
                        if (this._cells = [], e) {
                            if (e instanceof Array) {
                                let t = 0;
                                e.hasOwnProperty("0") && (t = 1), e.forEach((e, r)=>{
                                    void 0 !== e && (this.getCellEx({
                                        address: s.encodeAddress(this._number, r + t),
                                        row: this._number,
                                        col: r + t
                                    }).value = e);
                                });
                            } else this._worksheet.eachColumnKey((t, r)=>{
                                void 0 !== e[r] && (this.getCellEx({
                                    address: s.encodeAddress(this._number, t.number),
                                    row: this._number,
                                    col: t.number
                                }).value = e[r]);
                            });
                        } else ;
                    }
                    get hasValues() {
                        return n.some(this._cells, (e)=>e && e.type !== i.ValueType.Null);
                    }
                    get cellCount() {
                        return this._cells.length;
                    }
                    get actualCellCount() {
                        let e = 0;
                        return this.eachCell(()=>{
                            e++;
                        }), e;
                    }
                    get dimensions() {
                        let e = 0, t = 0;
                        return this._cells.forEach((r)=>{
                            r && r.type !== i.ValueType.Null && ((!e || e > r.col) && (e = r.col), t < r.col && (t = r.col));
                        }), e > 0 ? {
                            min: e,
                            max: t
                        } : null;
                    }
                    _applyStyle(e, t) {
                        return this.style[e] = t, this._cells.forEach((r)=>{
                            r && (r[e] = t);
                        }), t;
                    }
                    get numFmt() {
                        return this.style.numFmt;
                    }
                    set numFmt(e) {
                        this._applyStyle("numFmt", e);
                    }
                    get font() {
                        return this.style.font;
                    }
                    set font(e) {
                        this._applyStyle("font", e);
                    }
                    get alignment() {
                        return this.style.alignment;
                    }
                    set alignment(e) {
                        this._applyStyle("alignment", e);
                    }
                    get protection() {
                        return this.style.protection;
                    }
                    set protection(e) {
                        this._applyStyle("protection", e);
                    }
                    get border() {
                        return this.style.border;
                    }
                    set border(e) {
                        this._applyStyle("border", e);
                    }
                    get fill() {
                        return this.style.fill;
                    }
                    set fill(e) {
                        this._applyStyle("fill", e);
                    }
                    get hidden() {
                        return !!this._hidden;
                    }
                    set hidden(e) {
                        this._hidden = e;
                    }
                    get outlineLevel() {
                        return this._outlineLevel || 0;
                    }
                    set outlineLevel(e) {
                        this._outlineLevel = e;
                    }
                    get collapsed() {
                        return !!(this._outlineLevel && this._outlineLevel >= this._worksheet.properties.outlineLevelRow);
                    }
                    get model() {
                        const e = [];
                        let t = 0, r = 0;
                        return this._cells.forEach((n)=>{
                            if (n) {
                                const i = n.model;
                                i && ((!t || t > n.col) && (t = n.col), r < n.col && (r = n.col), e.push(i));
                            }
                        }), this.height || e.length ? {
                            cells: e,
                            number: this.number,
                            min: t,
                            max: r,
                            height: this.height,
                            style: this.style,
                            hidden: this.hidden,
                            outlineLevel: this.outlineLevel,
                            collapsed: this.collapsed
                        } : null;
                    }
                    set model(e) {
                        if (e.number !== this._number) throw new Error("Invalid row number in model");
                        let t;
                        this._cells = [], e.cells.forEach((e)=>{
                            switch(e.type){
                                case o.Types.Merge:
                                    break;
                                default:
                                    {
                                        let r;
                                        if (e.address) r = s.decodeAddress(e.address);
                                        else if (t) {
                                            const { row: e } = t, n = t.col + 1;
                                            r = {
                                                row: e,
                                                col: n,
                                                address: s.encodeAddress(e, n),
                                                $col$row: `$${s.n2l(n)}$${e}`
                                            };
                                        }
                                        t = r;
                                        this.getCellEx(r).model = e;
                                        break;
                                    }
                            }
                        }), e.height ? this.height = e.height : delete this.height, this.hidden = e.hidden, this.outlineLevel = e.outlineLevel || 0, this.style = e.style && JSON.parse(JSON.stringify(e.style)) || {};
                    }
                };
            },
            {
                "../utils/col-cache": 19,
                "../utils/under-dash": 26,
                "./cell": 3,
                "./enums": 7
            }
        ],
        12: [
            function(e, t, r) {
                "use strict";
                const n = e("../utils/col-cache");
                class i {
                    constructor(e, t, r){
                        this.table = e, this.column = t, this.index = r;
                    }
                    _set(e, t) {
                        this.table.cacheState(), this.column[e] = t;
                    }
                    get name() {
                        return this.column.name;
                    }
                    set name(e) {
                        this._set("name", e);
                    }
                    get filterButton() {
                        return this.column.filterButton;
                    }
                    set filterButton(e) {
                        this.column.filterButton = e;
                    }
                    get style() {
                        return this.column.style;
                    }
                    set style(e) {
                        this.column.style = e;
                    }
                    get totalsRowLabel() {
                        return this.column.totalsRowLabel;
                    }
                    set totalsRowLabel(e) {
                        this._set("totalsRowLabel", e);
                    }
                    get totalsRowFunction() {
                        return this.column.totalsRowFunction;
                    }
                    set totalsRowFunction(e) {
                        this._set("totalsRowFunction", e);
                    }
                    get totalsRowResult() {
                        return this.column.totalsRowResult;
                    }
                    set totalsRowResult(e) {
                        this._set("totalsRowResult", e);
                    }
                    get totalsRowFormula() {
                        return this.column.totalsRowFormula;
                    }
                    set totalsRowFormula(e) {
                        this._set("totalsRowFormula", e);
                    }
                }
                t.exports = class {
                    constructor(e, t){
                        this.worksheet = e, t && (this.table = t, this.validate(), this.store());
                    }
                    getFormula(e) {
                        switch(e.totalsRowFunction){
                            case "none":
                                return null;
                            case "average":
                                return `SUBTOTAL(101,${this.table.name}[${e.name}])`;
                            case "countNums":
                                return `SUBTOTAL(102,${this.table.name}[${e.name}])`;
                            case "count":
                                return `SUBTOTAL(103,${this.table.name}[${e.name}])`;
                            case "max":
                                return `SUBTOTAL(104,${this.table.name}[${e.name}])`;
                            case "min":
                                return `SUBTOTAL(105,${this.table.name}[${e.name}])`;
                            case "stdDev":
                                return `SUBTOTAL(106,${this.table.name}[${e.name}])`;
                            case "var":
                                return `SUBTOTAL(107,${this.table.name}[${e.name}])`;
                            case "sum":
                                return `SUBTOTAL(109,${this.table.name}[${e.name}])`;
                            case "custom":
                                return e.totalsRowFormula;
                            default:
                                throw new Error("Invalid Totals Row Function: " + e.totalsRowFunction);
                        }
                    }
                    get width() {
                        return this.table.columns.length;
                    }
                    get height() {
                        return this.table.rows.length;
                    }
                    get filterHeight() {
                        return this.height + (this.table.headerRow ? 1 : 0);
                    }
                    get tableHeight() {
                        return this.filterHeight + (this.table.totalsRow ? 1 : 0);
                    }
                    validate() {
                        const { table: e } = this, t = (e, t, r)=>{
                            void 0 === e[t] && (e[t] = r);
                        };
                        t(e, "headerRow", !0), t(e, "totalsRow", !1), t(e, "style", {}), t(e.style, "theme", "TableStyleMedium2"), t(e.style, "showFirstColumn", !1), t(e.style, "showLastColumn", !1), t(e.style, "showRowStripes", !1), t(e.style, "showColumnStripes", !1);
                        const r = (e, t)=>{
                            if (!e) throw new Error(t);
                        };
                        r(e.ref, "Table must have ref"), r(e.columns, "Table must have column definitions"), r(e.rows, "Table must have row definitions"), e.tl = n.decodeAddress(e.ref);
                        const { row: i, col: s } = e.tl;
                        r(i > 0, "Table must be on valid row"), r(s > 0, "Table must be on valid col");
                        const { width: o, filterHeight: a, tableHeight: l } = this;
                        e.autoFilterRef = n.encode(i, s, i + a - 1, s + o - 1), e.tableRef = n.encode(i, s, i + l - 1, s + o - 1), e.columns.forEach((e, n)=>{
                            r(e.name, `Column ${n} must have a name`), 0 === n ? t(e, "totalsRowLabel", "Total") : (t(e, "totalsRowFunction", "none"), e.totalsRowFormula = this.getFormula(e));
                        });
                    }
                    store() {
                        const e = (e, t)=>{
                            t && Object.keys(t).forEach((r)=>{
                                e[r] = t[r];
                            });
                        }, { worksheet: t, table: r } = this, { row: n, col: i } = r.tl;
                        let s = 0;
                        if (r.headerRow) {
                            const o = t.getRow(n + s++);
                            r.columns.forEach((t, r)=>{
                                const { style: n, name: s } = t, a = o.getCell(i + r);
                                a.value = s, e(a, n);
                            });
                        }
                        if (r.rows.forEach((o)=>{
                            const a = t.getRow(n + s++);
                            o.forEach((t, n)=>{
                                const s = a.getCell(i + n);
                                s.value = t, e(s, r.columns[n].style);
                            });
                        }), r.totalsRow) {
                            const o = t.getRow(n + s++);
                            r.columns.forEach((t, r)=>{
                                const n = o.getCell(i + r);
                                if (0 === r) n.value = t.totalsRowLabel;
                                else {
                                    const e = this.getFormula(t);
                                    n.value = e ? {
                                        formula: t.totalsRowFormula,
                                        result: t.totalsRowResult
                                    } : null;
                                }
                                e(n, t.style);
                            });
                        }
                    }
                    load(e) {
                        const { table: t } = this, { row: r, col: n } = t.tl;
                        let i = 0;
                        if (t.headerRow) {
                            const s = e.getRow(r + i++);
                            t.columns.forEach((e, t)=>{
                                s.getCell(n + t).value = e.name;
                            });
                        }
                        if (t.rows.forEach((t)=>{
                            const s = e.getRow(r + i++);
                            t.forEach((e, t)=>{
                                s.getCell(n + t).value = e;
                            });
                        }), t.totalsRow) {
                            const s = e.getRow(r + i++);
                            t.columns.forEach((e, t)=>{
                                const r = s.getCell(n + t);
                                if (0 === t) r.value = e.totalsRowLabel;
                                else this.getFormula(e) && (r.value = {
                                    formula: e.totalsRowFormula,
                                    result: e.totalsRowResult
                                });
                            });
                        }
                    }
                    get model() {
                        return this.table;
                    }
                    set model(e) {
                        this.table = e;
                    }
                    cacheState() {
                        this._cache || (this._cache = {
                            ref: this.ref,
                            width: this.width,
                            tableHeight: this.tableHeight
                        });
                    }
                    commit() {
                        if (!this._cache) return;
                        this.validate();
                        const e = n.decodeAddress(this._cache.ref);
                        if (this.ref !== this._cache.ref) for(let t = 0; t < this._cache.tableHeight; t++){
                            const r = this.worksheet.getRow(e.row + t);
                            for(let t = 0; t < this._cache.width; t++)r.getCell(e.col + t).value = null;
                        }
                        else {
                            for(let t = this.tableHeight; t < this._cache.tableHeight; t++){
                                const r = this.worksheet.getRow(e.row + t);
                                for(let t = 0; t < this._cache.width; t++)r.getCell(e.col + t).value = null;
                            }
                            for(let t = 0; t < this.tableHeight; t++){
                                const r = this.worksheet.getRow(e.row + t);
                                for(let t = this.width; t < this._cache.width; t++)r.getCell(e.col + t).value = null;
                            }
                        }
                        this.store();
                    }
                    addRow(e, t) {
                        this.cacheState(), void 0 === t ? this.table.rows.push(e) : this.table.rows.splice(t, 0, e);
                    }
                    removeRows(e) {
                        let t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 1;
                        this.cacheState(), this.table.rows.splice(e, t);
                    }
                    getColumn(e) {
                        const t = this.table.columns[e];
                        return new i(this, t, e);
                    }
                    addColumn(e, t, r) {
                        this.cacheState(), void 0 === r ? (this.table.columns.push(e), this.table.rows.forEach((e, r)=>{
                            e.push(t[r]);
                        })) : (this.table.columns.splice(r, 0, e), this.table.rows.forEach((e, n)=>{
                            e.splice(r, 0, t[n]);
                        }));
                    }
                    removeColumns(e) {
                        let t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 1;
                        this.cacheState(), this.table.columns.splice(e, t), this.table.rows.forEach((r)=>{
                            r.splice(e, t);
                        });
                    }
                    _assign(e, t, r) {
                        this.cacheState(), e[t] = r;
                    }
                    get ref() {
                        return this.table.ref;
                    }
                    set ref(e) {
                        this._assign(this.table, "ref", e);
                    }
                    get name() {
                        return this.table.name;
                    }
                    set name(e) {
                        this.table.name = e;
                    }
                    get displayName() {
                        return this.table.displyName || this.table.name;
                    }
                    set displayNamename(e) {
                        this.table.displayName = e;
                    }
                    get headerRow() {
                        return this.table.headerRow;
                    }
                    set headerRow(e) {
                        this._assign(this.table, "headerRow", e);
                    }
                    get totalsRow() {
                        return this.table.totalsRow;
                    }
                    set totalsRow(e) {
                        this._assign(this.table, "totalsRow", e);
                    }
                    get theme() {
                        return this.table.style.name;
                    }
                    set theme(e) {
                        this.table.style.name = e;
                    }
                    get showFirstColumn() {
                        return this.table.style.showFirstColumn;
                    }
                    set showFirstColumn(e) {
                        this.table.style.showFirstColumn = e;
                    }
                    get showLastColumn() {
                        return this.table.style.showLastColumn;
                    }
                    set showLastColumn(e) {
                        this.table.style.showLastColumn = e;
                    }
                    get showRowStripes() {
                        return this.table.style.showRowStripes;
                    }
                    set showRowStripes(e) {
                        this.table.style.showRowStripes = e;
                    }
                    get showColumnStripes() {
                        return this.table.style.showColumnStripes;
                    }
                    set showColumnStripes(e) {
                        this.table.style.showColumnStripes = e;
                    }
                };
            },
            {
                "../utils/col-cache": 19
            }
        ],
        13: [
            function(e, t, r) {
                "use strict";
                const n = e("./worksheet"), i = e("./defined-names"), s = e("../xlsx/xlsx"), o = e("../csv/csv");
                t.exports = class {
                    constructor(){
                        this.category = "", this.company = "", this.created = new Date, this.description = "", this.keywords = "", this.manager = "", this.modified = this.created, this.properties = {}, this.calcProperties = {}, this._worksheets = [], this.subject = "", this.title = "", this.views = [], this.media = [], this._definedNames = new i;
                    }
                    get xlsx() {
                        return this._xlsx || (this._xlsx = new s(this)), this._xlsx;
                    }
                    get csv() {
                        return this._csv || (this._csv = new o(this)), this._csv;
                    }
                    get nextId() {
                        for(let e = 1; e < this._worksheets.length; e++)if (!this._worksheets[e]) return e;
                        return this._worksheets.length || 1;
                    }
                    addWorksheet(e, t) {
                        const r = this.nextId;
                        t && ("string" == typeof t ? (console.trace('tabColor argument is now deprecated. Please use workbook.addWorksheet(name, {properties: { tabColor: { argb: "rbg value" } }'), t = {
                            properties: {
                                tabColor: {
                                    argb: t
                                }
                            }
                        }) : (t.argb || t.theme || t.indexed) && (console.trace("tabColor argument is now deprecated. Please use workbook.addWorksheet(name, {properties: { tabColor: { ... } }"), t = {
                            properties: {
                                tabColor: t
                            }
                        }));
                        const i = this._worksheets.reduce((e, t)=>(t && t.orderNo) > e ? t.orderNo : e, 0), s = Object.assign({}, t, {
                            id: r,
                            name: e,
                            orderNo: i + 1,
                            workbook: this
                        }), o = new n(s);
                        return this._worksheets[r] = o, o;
                    }
                    removeWorksheetEx(e) {
                        delete this._worksheets[e.id];
                    }
                    removeWorksheet(e) {
                        const t = this.getWorksheet(e);
                        t && t.destroy();
                    }
                    getWorksheet(e) {
                        return void 0 === e ? this._worksheets.find(Boolean) : "number" == typeof e ? this._worksheets[e] : "string" == typeof e ? this._worksheets.find((t)=>t && t.name === e) : void 0;
                    }
                    get worksheets() {
                        return this._worksheets.slice(1).sort((e, t)=>e.orderNo - t.orderNo).filter(Boolean);
                    }
                    eachSheet(e) {
                        this.worksheets.forEach((t)=>{
                            e(t, t.id);
                        });
                    }
                    get definedNames() {
                        return this._definedNames;
                    }
                    clearThemes() {
                        this._themes = void 0;
                    }
                    addImage(e) {
                        const t = this.media.length;
                        return this.media.push(Object.assign({}, e, {
                            type: "image"
                        })), t;
                    }
                    getImage(e) {
                        return this.media[e];
                    }
                    get model() {
                        return {
                            creator: this.creator || "Unknown",
                            lastModifiedBy: this.lastModifiedBy || "Unknown",
                            lastPrinted: this.lastPrinted,
                            created: this.created,
                            modified: this.modified,
                            properties: this.properties,
                            worksheets: this.worksheets.map((e)=>e.model),
                            sheets: this.worksheets.map((e)=>e.model).filter(Boolean),
                            definedNames: this._definedNames.model,
                            views: this.views,
                            company: this.company,
                            manager: this.manager,
                            title: this.title,
                            subject: this.subject,
                            keywords: this.keywords,
                            category: this.category,
                            description: this.description,
                            language: this.language,
                            revision: this.revision,
                            contentStatus: this.contentStatus,
                            themes: this._themes,
                            media: this.media,
                            calcProperties: this.calcProperties
                        };
                    }
                    set model(e) {
                        this.creator = e.creator, this.lastModifiedBy = e.lastModifiedBy, this.lastPrinted = e.lastPrinted, this.created = e.created, this.modified = e.modified, this.company = e.company, this.manager = e.manager, this.title = e.title, this.subject = e.subject, this.keywords = e.keywords, this.category = e.category, this.description = e.description, this.language = e.language, this.revision = e.revision, this.contentStatus = e.contentStatus, this.properties = e.properties, this.calcProperties = e.calcProperties, this._worksheets = [], e.worksheets.forEach((t)=>{
                            const { id: r, name: i, state: s } = t, o = e.sheets && e.sheets.findIndex((e)=>e.id === r);
                            (this._worksheets[r] = new n({
                                id: r,
                                name: i,
                                orderNo: o,
                                state: s,
                                workbook: this
                            })).model = t;
                        }), this._definedNames.model = e.definedNames, this.views = e.views, this._themes = e.themes, this.media = e.media || [];
                    }
                };
            },
            {
                "../csv/csv": 1,
                "../xlsx/xlsx": 144,
                "./defined-names": 6,
                "./worksheet": 14
            }
        ],
        14: [
            function(e, t, r) {
                "use strict";
                const n = e("../utils/under-dash"), i = e("../utils/col-cache"), s = e("./range"), o = e("./row"), a = e("./column"), l = e("./enums"), c = e("./image"), u = e("./table"), h = e("./data-validations"), f = e("../utils/encryptor"), { copyStyle: d } = e("../utils/copy-style");
                t.exports = class {
                    constructor(e){
                        e = e || {}, this._workbook = e.workbook, this.id = e.id, this.orderNo = e.orderNo, this.name = e.name, this.state = e.state || "visible", this._rows = [], this._columns = null, this._keys = {}, this._merges = {}, this.rowBreaks = [], this.properties = Object.assign({}, {
                            defaultRowHeight: 15,
                            dyDescent: 55,
                            outlineLevelCol: 0,
                            outlineLevelRow: 0
                        }, e.properties), this.pageSetup = Object.assign({}, {
                            margins: {
                                left: .7,
                                right: .7,
                                top: .75,
                                bottom: .75,
                                header: .3,
                                footer: .3
                            },
                            orientation: "portrait",
                            horizontalDpi: 4294967295,
                            verticalDpi: 4294967295,
                            fitToPage: !(!e.pageSetup || !e.pageSetup.fitToWidth && !e.pageSetup.fitToHeight || e.pageSetup.scale),
                            pageOrder: "downThenOver",
                            blackAndWhite: !1,
                            draft: !1,
                            cellComments: "None",
                            errors: "displayed",
                            scale: 100,
                            fitToWidth: 1,
                            fitToHeight: 1,
                            paperSize: void 0,
                            showRowColHeaders: !1,
                            showGridLines: !1,
                            firstPageNumber: void 0,
                            horizontalCentered: !1,
                            verticalCentered: !1,
                            rowBreaks: null,
                            colBreaks: null
                        }, e.pageSetup), this.headerFooter = Object.assign({}, {
                            differentFirst: !1,
                            differentOddEven: !1,
                            oddHeader: null,
                            oddFooter: null,
                            evenHeader: null,
                            evenFooter: null,
                            firstHeader: null,
                            firstFooter: null
                        }, e.headerFooter), this.dataValidations = new h, this.views = e.views || [], this.autoFilter = e.autoFilter || null, this._media = [], this.sheetProtection = null, this.tables = {}, this.conditionalFormattings = [];
                    }
                    get name() {
                        return this._name;
                    }
                    set name(e) {
                        if (void 0 === e && (e = "sheet" + this.id), this._name !== e) {
                            if ("string" != typeof e) throw new Error("The name has to be a string.");
                            if ("" === e) throw new Error("The name can't be empty.");
                            if ("History" === e) throw new Error('The name "History" is protected. Please use a different name.');
                            if (/[*?:/\\[\]]/.test(e)) throw new Error(`Worksheet name ${e} cannot include any of the following characters: * ? : \\ / [ ]`);
                            if (/(^')|('$)/.test(e)) throw new Error("The first or last character of worksheet name cannot be a single quotation mark: " + e);
                            if (e && e.length > 31 && (console.warn(`Worksheet name ${e} exceeds 31 chars. This will be truncated`), e = e.substring(0, 31)), this._workbook._worksheets.find((t)=>t && t.name.toLowerCase() === e.toLowerCase())) throw new Error("Worksheet name already exists: " + e);
                            this._name = e;
                        }
                    }
                    get workbook() {
                        return this._workbook;
                    }
                    destroy() {
                        this._workbook.removeWorksheetEx(this);
                    }
                    get dimensions() {
                        const e = new s;
                        return this._rows.forEach((t)=>{
                            if (t) {
                                const r = t.dimensions;
                                r && e.expand(t.number, r.min, t.number, r.max);
                            }
                        }), e;
                    }
                    get columns() {
                        return this._columns;
                    }
                    set columns(e) {
                        this._headerRowCount = e.reduce((e, t)=>{
                            const r = (t.header ? 1 : t.headers && t.headers.length) || 0;
                            return Math.max(e, r);
                        }, 0);
                        let t = 1;
                        const r = this._columns = [];
                        e.forEach((e)=>{
                            const n = new a(this, t++, !1);
                            r.push(n), n.defn = e;
                        });
                    }
                    getColumnKey(e) {
                        return this._keys[e];
                    }
                    setColumnKey(e, t) {
                        this._keys[e] = t;
                    }
                    deleteColumnKey(e) {
                        delete this._keys[e];
                    }
                    eachColumnKey(e) {
                        n.each(this._keys, e);
                    }
                    getColumn(e) {
                        if ("string" == typeof e) {
                            const t = this._keys[e];
                            if (t) return t;
                            e = i.l2n(e);
                        }
                        if (this._columns || (this._columns = []), e > this._columns.length) {
                            let t = this._columns.length + 1;
                            for(; t <= e;)this._columns.push(new a(this, t++));
                        }
                        return this._columns[e - 1];
                    }
                    spliceColumns(e, t) {
                        const r = this._rows.length;
                        for(var n = arguments.length, i = new Array(n > 2 ? n - 2 : 0), s = 2; s < n; s++)i[s - 2] = arguments[s];
                        if (i.length > 0) for(let n = 0; n < r; n++){
                            const r = [
                                e,
                                t
                            ];
                            i.forEach((e)=>{
                                r.push(e[n] || null);
                            });
                            const s = this.getRow(n + 1);
                            s.splice.apply(s, r);
                        }
                        else this._rows.forEach((r)=>{
                            r && r.splice(e, t);
                        });
                        const o = i.length - t, a = e + t, l = this._columns.length;
                        if (o < 0) for(let t = e + i.length; t <= l; t++)this.getColumn(t).defn = this.getColumn(t - o).defn;
                        else if (o > 0) for(let e = l; e >= a; e--)this.getColumn(e + o).defn = this.getColumn(e).defn;
                        for(let t = e; t < e + i.length; t++)this.getColumn(t).defn = null;
                        this.workbook.definedNames.spliceColumns(this.name, e, t, i.length);
                    }
                    get lastColumn() {
                        return this.getColumn(this.columnCount);
                    }
                    get columnCount() {
                        let e = 0;
                        return this.eachRow((t)=>{
                            e = Math.max(e, t.cellCount);
                        }), e;
                    }
                    get actualColumnCount() {
                        const e = [];
                        let t = 0;
                        return this.eachRow((r)=>{
                            r.eachCell((r)=>{
                                let { col: n } = r;
                                e[n] || (e[n] = !0, t++);
                            });
                        }), t;
                    }
                    _commitRow() {}
                    get _lastRowNumber() {
                        const e = this._rows;
                        let t = e.length;
                        for(; t > 0 && void 0 === e[t - 1];)t--;
                        return t;
                    }
                    get _nextRow() {
                        return this._lastRowNumber + 1;
                    }
                    get lastRow() {
                        if (this._rows.length) return this._rows[this._rows.length - 1];
                    }
                    findRow(e) {
                        return this._rows[e - 1];
                    }
                    findRows(e, t) {
                        return this._rows.slice(e - 1, e - 1 + t);
                    }
                    get rowCount() {
                        return this._lastRowNumber;
                    }
                    get actualRowCount() {
                        let e = 0;
                        return this.eachRow(()=>{
                            e++;
                        }), e;
                    }
                    getRow(e) {
                        let t = this._rows[e - 1];
                        return t || (t = this._rows[e - 1] = new o(this, e)), t;
                    }
                    getRows(e, t) {
                        if (t < 1) return;
                        const r = [];
                        for(let n = e; n < e + t; n++)r.push(this.getRow(n));
                        return r;
                    }
                    addRow(e) {
                        let t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "n";
                        const r = this._nextRow, n = this.getRow(r);
                        return n.values = e, this._setStyleOption(r, "i" === t[0] ? t : "n"), n;
                    }
                    addRows(e) {
                        let t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "n";
                        const r = [];
                        return e.forEach((e)=>{
                            r.push(this.addRow(e, t));
                        }), r;
                    }
                    insertRow(e, t) {
                        let r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : "n";
                        return this.spliceRows(e, 0, t), this._setStyleOption(e, r), this.getRow(e);
                    }
                    insertRows(e, t) {
                        let r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : "n";
                        if (this.spliceRows(e, 0, ...t), "n" !== r) for(let n = 0; n < t.length; n++)"o" === r[0] && void 0 !== this.findRow(t.length + e + n) ? this._copyStyle(t.length + e + n, e + n, "+" === r[1]) : "i" === r[0] && void 0 !== this.findRow(e - 1) && this._copyStyle(e - 1, e + n, "+" === r[1]);
                        return this.getRows(e, t.length);
                    }
                    _setStyleOption(e) {
                        let t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "n";
                        "o" === t[0] && void 0 !== this.findRow(e + 1) ? this._copyStyle(e + 1, e, "+" === t[1]) : "i" === t[0] && void 0 !== this.findRow(e - 1) && this._copyStyle(e - 1, e, "+" === t[1]);
                    }
                    _copyStyle(e, t) {
                        let r = arguments.length > 2 && void 0 !== arguments[2] && arguments[2];
                        const n = this.getRow(e), i = this.getRow(t);
                        i.style = d(n.style), n.eachCell({
                            includeEmpty: r
                        }, (e, t)=>{
                            i.getCell(t).style = d(e.style);
                        }), i.height = n.height;
                    }
                    duplicateRow(e, t) {
                        let r = arguments.length > 2 && void 0 !== arguments[2] && arguments[2];
                        const n = this._rows[e - 1], i = new Array(t).fill(n.values);
                        this.spliceRows(e + 1, r ? 0 : t, ...i);
                        for(let r = 0; r < t; r++){
                            const t = this._rows[e + r];
                            t.style = n.style, t.height = n.height, n.eachCell({
                                includeEmpty: !0
                            }, (e, r)=>{
                                t.getCell(r).style = e.style;
                            });
                        }
                    }
                    spliceRows(e, t) {
                        const r = e + t;
                        for(var n = arguments.length, i = new Array(n > 2 ? n - 2 : 0), s = 2; s < n; s++)i[s - 2] = arguments[s];
                        const o = i.length, a = o - t, l = this._rows.length;
                        let c, u;
                        if (a < 0) for(e === l && (this._rows[l - 1] = void 0), c = r; c <= l; c++)if (u = this._rows[c - 1], u) {
                            const e = this.getRow(c + a);
                            e.values = u.values, e.style = u.style, e.height = u.height, u.eachCell({
                                includeEmpty: !0
                            }, (t, r)=>{
                                e.getCell(r).style = t.style;
                            }), this._rows[c - 1] = void 0;
                        } else this._rows[c + a - 1] = void 0;
                        else if (a > 0) for(c = l; c >= r; c--)if (u = this._rows[c - 1], u) {
                            const e = this.getRow(c + a);
                            e.values = u.values, e.style = u.style, e.height = u.height, u.eachCell({
                                includeEmpty: !0
                            }, (t, r)=>{
                                if (e.getCell(r).style = t.style, "MergeValue" === t._value.constructor.name) {
                                    const e = this.getRow(t._row._number + o).getCell(r), n = t._value._master, i = this.getRow(n._row._number + o).getCell(n._column._number);
                                    e.merge(i);
                                }
                            });
                        } else this._rows[c + a - 1] = void 0;
                        for(c = 0; c < o; c++){
                            const t = this.getRow(e + c);
                            t.style = {}, t.values = i[c];
                        }
                        this.workbook.definedNames.spliceRows(this.name, e, t, o);
                    }
                    eachRow(e, t) {
                        if (t || (t = e, e = void 0), e && e.includeEmpty) {
                            const e = this._rows.length;
                            for(let r = 1; r <= e; r++)t(this.getRow(r), r);
                        } else this._rows.forEach((e)=>{
                            e && e.hasValues && t(e, e.number);
                        });
                    }
                    getSheetValues() {
                        const e = [];
                        return this._rows.forEach((t)=>{
                            t && (e[t.number] = t.values);
                        }), e;
                    }
                    findCell(e, t) {
                        const r = i.getAddress(e, t), n = this._rows[r.row - 1];
                        return n ? n.findCell(r.col) : void 0;
                    }
                    getCell(e, t) {
                        const r = i.getAddress(e, t);
                        return this.getRow(r.row).getCellEx(r);
                    }
                    mergeCells() {
                        for(var e = arguments.length, t = new Array(e), r = 0; r < e; r++)t[r] = arguments[r];
                        const n = new s(t);
                        this._mergeCellsInternal(n);
                    }
                    mergeCellsWithoutStyle() {
                        for(var e = arguments.length, t = new Array(e), r = 0; r < e; r++)t[r] = arguments[r];
                        const n = new s(t);
                        this._mergeCellsInternal(n, !0);
                    }
                    _mergeCellsInternal(e, t) {
                        n.each(this._merges, (t)=>{
                            if (t.intersects(e)) throw new Error("Cannot merge already merged cells");
                        });
                        const r = this.getCell(e.top, e.left);
                        for(let n = e.top; n <= e.bottom; n++)for(let i = e.left; i <= e.right; i++)(n > e.top || i > e.left) && this.getCell(n, i).merge(r, t);
                        this._merges[r.address] = e;
                    }
                    _unMergeMaster(e) {
                        const t = this._merges[e.address];
                        if (t) {
                            for(let e = t.top; e <= t.bottom; e++)for(let r = t.left; r <= t.right; r++)this.getCell(e, r).unmerge();
                            delete this._merges[e.address];
                        }
                    }
                    get hasMerges() {
                        return n.some(this._merges, Boolean);
                    }
                    unMergeCells() {
                        for(var e = arguments.length, t = new Array(e), r = 0; r < e; r++)t[r] = arguments[r];
                        const n = new s(t);
                        for(let e = n.top; e <= n.bottom; e++)for(let t = n.left; t <= n.right; t++){
                            const r = this.findCell(e, t);
                            r && (r.type === l.ValueType.Merge ? this._unMergeMaster(r.master) : this._merges[r.address] && this._unMergeMaster(r));
                        }
                    }
                    fillFormula(e, t, r) {
                        let n = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : "shared";
                        const s = i.decode(e), { top: o, left: a, bottom: l, right: c } = s, u = c - a + 1, h = i.encodeAddress(o, a), f = "shared" === n;
                        let d;
                        d = "function" == typeof r ? r : Array.isArray(r) ? Array.isArray(r[0]) ? (e, t)=>r[e - o][t - a] : (e, t)=>r[(e - o) * u + (t - a)] : ()=>{};
                        let p = !0;
                        for(let r = o; r <= l; r++)for(let i = a; i <= c; i++)p ? (this.getCell(r, i).value = {
                            shareType: n,
                            formula: t,
                            ref: e,
                            result: d(r, i)
                        }, p = !1) : this.getCell(r, i).value = f ? {
                            sharedFormula: h,
                            result: d(r, i)
                        } : d(r, i);
                    }
                    addImage(e, t) {
                        const r = {
                            type: "image",
                            imageId: e,
                            range: t
                        };
                        this._media.push(new c(this, r));
                    }
                    getImages() {
                        return this._media.filter((e)=>"image" === e.type);
                    }
                    addBackgroundImage(e) {
                        const t = {
                            type: "background",
                            imageId: e
                        };
                        this._media.push(new c(this, t));
                    }
                    getBackgroundImageId() {
                        const e = this._media.find((e)=>"background" === e.type);
                        return e && e.imageId;
                    }
                    protect(e, t) {
                        return new Promise((r)=>{
                            this.sheetProtection = {
                                sheet: !0
                            }, t && "spinCount" in t && (t.spinCount = Number.isFinite(t.spinCount) ? Math.round(Math.max(0, t.spinCount)) : 1e5), e && (this.sheetProtection.algorithmName = "SHA-512", this.sheetProtection.saltValue = f.randomBytes(16).toString("base64"), this.sheetProtection.spinCount = t && "spinCount" in t ? t.spinCount : 1e5, this.sheetProtection.hashValue = f.convertPasswordToHash(e, "SHA512", this.sheetProtection.saltValue, this.sheetProtection.spinCount)), t && (this.sheetProtection = Object.assign(this.sheetProtection, t), !e && "spinCount" in t && delete this.sheetProtection.spinCount), r();
                        });
                    }
                    unprotect() {
                        this.sheetProtection = null;
                    }
                    addTable(e) {
                        const t = new u(this, e);
                        return this.tables[e.name] = t, t;
                    }
                    getTable(e) {
                        return this.tables[e];
                    }
                    removeTable(e) {
                        delete this.tables[e];
                    }
                    getTables() {
                        return Object.values(this.tables);
                    }
                    addConditionalFormatting(e) {
                        this.conditionalFormattings.push(e);
                    }
                    removeConditionalFormatting(e) {
                        "number" == typeof e ? this.conditionalFormattings.splice(e, 1) : this.conditionalFormattings = e instanceof Function ? this.conditionalFormattings.filter(e) : [];
                    }
                    get tabColor() {
                        return console.trace("worksheet.tabColor property is now deprecated. Please use worksheet.properties.tabColor"), this.properties.tabColor;
                    }
                    set tabColor(e) {
                        console.trace("worksheet.tabColor property is now deprecated. Please use worksheet.properties.tabColor"), this.properties.tabColor = e;
                    }
                    get model() {
                        const e = {
                            id: this.id,
                            name: this.name,
                            dataValidations: this.dataValidations.model,
                            properties: this.properties,
                            state: this.state,
                            pageSetup: this.pageSetup,
                            headerFooter: this.headerFooter,
                            rowBreaks: this.rowBreaks,
                            views: this.views,
                            autoFilter: this.autoFilter,
                            media: this._media.map((e)=>e.model),
                            sheetProtection: this.sheetProtection,
                            tables: Object.values(this.tables).map((e)=>e.model),
                            conditionalFormattings: this.conditionalFormattings
                        };
                        e.cols = a.toModel(this.columns);
                        const t = e.rows = [], r = e.dimensions = new s;
                        return this._rows.forEach((e)=>{
                            const n = e && e.model;
                            n && (r.expand(n.number, n.min, n.number, n.max), t.push(n));
                        }), e.merges = [], n.each(this._merges, (t)=>{
                            e.merges.push(t.range);
                        }), e;
                    }
                    _parseRows(e) {
                        this._rows = [], e.rows.forEach((e)=>{
                            const t = new o(this, e.number);
                            this._rows[t.number - 1] = t, t.model = e;
                        });
                    }
                    _parseMergeCells(e) {
                        n.each(e.mergeCells, (e)=>{
                            this.mergeCellsWithoutStyle(e);
                        });
                    }
                    set model(e) {
                        this.name = e.name, this._columns = a.fromModel(this, e.cols), this._parseRows(e), this._parseMergeCells(e), this.dataValidations = new h(e.dataValidations), this.properties = e.properties, this.pageSetup = e.pageSetup, this.headerFooter = e.headerFooter, this.views = e.views, this.autoFilter = e.autoFilter, this._media = e.media.map((e)=>new c(this, e)), this.sheetProtection = e.sheetProtection, this.tables = e.tables.reduce((e, t)=>{
                            const r = new u;
                            return r.model = t, e[t.name] = r, e;
                        }, {}), this.conditionalFormattings = e.conditionalFormattings;
                    }
                };
            },
            {
                "../utils/col-cache": 19,
                "../utils/copy-style": 20,
                "../utils/encryptor": 21,
                "../utils/under-dash": 26,
                "./column": 4,
                "./data-validations": 5,
                "./enums": 7,
                "./image": 8,
                "./range": 10,
                "./row": 11,
                "./table": 12
            }
        ],
        15: [
            function(e, t, r) {
                "use strict";
                e("core-js/modules/es.promise"), e("core-js/modules/es.promise.finally"), e("core-js/modules/es.object.assign"), e("core-js/modules/es.object.keys"), e("core-js/modules/es.object.values"), e("core-js/modules/es.symbol"), e("core-js/modules/es.symbol.async-iterator"), e("core-js/modules/es.array.iterator"), e("core-js/modules/es.array.includes"), e("core-js/modules/es.array.find-index"), e("core-js/modules/es.array.find"), e("core-js/modules/es.string.from-code-point"), e("core-js/modules/es.string.includes"), e("core-js/modules/es.number.is-nan"), e("regenerator-runtime/runtime");
                const n = {
                    Workbook: e("./doc/workbook")
                }, i = e("./doc/enums");
                Object.keys(i).forEach((e)=>{
                    n[e] = i[e];
                }), t.exports = n;
            },
            {
                "./doc/enums": 7,
                "./doc/workbook": 13,
                "core-js/modules/es.array.find": 359,
                "core-js/modules/es.array.find-index": 358,
                "core-js/modules/es.array.includes": 360,
                "core-js/modules/es.array.iterator": 361,
                "core-js/modules/es.number.is-nan": 363,
                "core-js/modules/es.object.assign": 364,
                "core-js/modules/es.object.keys": 366,
                "core-js/modules/es.object.values": 367,
                "core-js/modules/es.promise": 372,
                "core-js/modules/es.promise.finally": 371,
                "core-js/modules/es.string.from-code-point": 376,
                "core-js/modules/es.string.includes": 377,
                "core-js/modules/es.symbol": 381,
                "core-js/modules/es.symbol.async-iterator": 378,
                "regenerator-runtime/runtime": 492
            }
        ],
        16: [
            function(e, t, r) {
                "use strict";
                const n = "undefined" == typeof TextDecoder ? null : new TextDecoder("utf-8");
                r.bufferToString = function(e) {
                    return "string" == typeof e ? e : n ? n.decode(e) : e.toString();
                };
            },
            {}
        ],
        17: [
            function(e, t, r) {
                "use strict";
                const n = "undefined" == typeof TextEncoder ? null : new TextEncoder("utf-8"), { Buffer: i } = e("buffer");
                r.stringToBuffer = function(e) {
                    return "string" != typeof e ? e : n ? i.from(n.encode(e).buffer) : i.from(e);
                };
            },
            {
                buffer: 220
            }
        ],
        18: [
            function(e, t, r) {
                "use strict";
                const n = e("./under-dash"), i = e("./col-cache");
                t.exports = class {
                    constructor(e){
                        this.template = e, this.sheets = {};
                    }
                    addCell(e) {
                        this.addCellEx(i.decodeEx(e));
                    }
                    getCell(e) {
                        return this.findCellEx(i.decodeEx(e), !0);
                    }
                    findCell(e) {
                        return this.findCellEx(i.decodeEx(e), !1);
                    }
                    findCellAt(e, t, r) {
                        const n = this.sheets[e], i = n && n[t];
                        return i && i[r];
                    }
                    addCellEx(e) {
                        if (e.top) for(let t = e.top; t <= e.bottom; t++)for(let r = e.left; r <= e.right; r++)this.getCellAt(e.sheetName, t, r);
                        else this.findCellEx(e, !0);
                    }
                    getCellEx(e) {
                        return this.findCellEx(e, !0);
                    }
                    findCellEx(e, t) {
                        const r = this.findSheet(e, t), n = this.findSheetRow(r, e, t);
                        return this.findRowCell(n, e, t);
                    }
                    getCellAt(e, t, r) {
                        const n = this.sheets[e] || (this.sheets[e] = []), s = n[t] || (n[t] = []);
                        return s[r] || (s[r] = {
                            sheetName: e,
                            address: i.n2l(r) + t,
                            row: t,
                            col: r
                        });
                    }
                    removeCellEx(e) {
                        const t = this.findSheet(e);
                        if (!t) return;
                        const r = this.findSheetRow(t, e);
                        r && delete r[e.col];
                    }
                    forEachInSheet(e, t) {
                        const r = this.sheets[e];
                        r && r.forEach((e, r)=>{
                            e && e.forEach((e, n)=>{
                                e && t(e, r, n);
                            });
                        });
                    }
                    forEach(e) {
                        n.each(this.sheets, (t, r)=>{
                            this.forEachInSheet(r, e);
                        });
                    }
                    map(e) {
                        const t = [];
                        return this.forEach((r)=>{
                            t.push(e(r));
                        }), t;
                    }
                    findSheet(e, t) {
                        const r = e.sheetName;
                        return this.sheets[r] ? this.sheets[r] : t ? this.sheets[r] = [] : void 0;
                    }
                    findSheetRow(e, t, r) {
                        const { row: n } = t;
                        return e && e[n] ? e[n] : r ? e[n] = [] : void 0;
                    }
                    findRowCell(e, t, r) {
                        const { col: n } = t;
                        return e && e[n] ? e[n] : r ? e[n] = this.template ? Object.assign(t, JSON.parse(JSON.stringify(this.template))) : t : void 0;
                    }
                    spliceRows(e, t, r, n) {
                        const i = this.sheets[e];
                        if (i) {
                            const e = [];
                            for(let t = 0; t < n; t++)e.push([]);
                            i.splice(t, r, ...e);
                        }
                    }
                    spliceColumns(e, t, r, i) {
                        const s = this.sheets[e];
                        if (s) {
                            const e = [];
                            for(let t = 0; t < i; t++)e.push(null);
                            n.each(s, (n)=>{
                                n.splice(t, r, ...e);
                            });
                        }
                    }
                };
            },
            {
                "./col-cache": 19,
                "./under-dash": 26
            }
        ],
        19: [
            function(e, t, r) {
                "use strict";
                const n = /^[A-Z]+\d+$/, i = {
                    _dictionary: [
                        "A",
                        "B",
                        "C",
                        "D",
                        "E",
                        "F",
                        "G",
                        "H",
                        "I",
                        "J",
                        "K",
                        "L",
                        "M",
                        "N",
                        "O",
                        "P",
                        "Q",
                        "R",
                        "S",
                        "T",
                        "U",
                        "V",
                        "W",
                        "X",
                        "Y",
                        "Z"
                    ],
                    _l2nFill: 0,
                    _l2n: {},
                    _n2l: [],
                    _level: (e)=>e <= 26 ? 1 : e <= 676 ? 2 : 3,
                    _fill (e) {
                        let t, r, n, i, s, o = 1;
                        if (e >= 4) throw new Error("Out of bounds. Excel supports columns from 1 to 16384");
                        if (this._l2nFill < 1 && e >= 1) {
                            for(; o <= 26;)t = this._dictionary[o - 1], this._n2l[o] = t, this._l2n[t] = o, o++;
                            this._l2nFill = 1;
                        }
                        if (this._l2nFill < 2 && e >= 2) {
                            for(o = 27; o <= 702;)r = o - 27, n = r % 26, i = Math.floor(r / 26), t = this._dictionary[i] + this._dictionary[n], this._n2l[o] = t, this._l2n[t] = o, o++;
                            this._l2nFill = 2;
                        }
                        if (this._l2nFill < 3 && e >= 3) {
                            for(o = 703; o <= 16384;)r = o - 703, n = r % 26, i = Math.floor(r / 26) % 26, s = Math.floor(r / 676), t = this._dictionary[s] + this._dictionary[i] + this._dictionary[n], this._n2l[o] = t, this._l2n[t] = o, o++;
                            this._l2nFill = 3;
                        }
                    },
                    l2n (e) {
                        if (this._l2n[e] || this._fill(e.length), !this._l2n[e]) throw new Error("Out of bounds. Invalid column letter: " + e);
                        return this._l2n[e];
                    },
                    n2l (e) {
                        if (e < 1 || e > 16384) throw new Error(e + " is out of bounds. Excel supports columns from 1 to 16384");
                        return this._n2l[e] || this._fill(this._level(e)), this._n2l[e];
                    },
                    _hash: {},
                    validateAddress (e) {
                        if (!n.test(e)) throw new Error("Invalid Address: " + e);
                        return !0;
                    },
                    decodeAddress (e) {
                        const t = e.length < 5 && this._hash[e];
                        if (t) return t;
                        let r = !1, n = "", i = 0, s = !1, o = "", a = 0;
                        for(let t, l = 0; l < e.length; l++)if (t = e.charCodeAt(l), !s && t >= 65 && t <= 90) r = !0, n += e[l], i = 26 * i + t - 64;
                        else if (t >= 48 && t <= 57) s = !0, o += e[l], a = 10 * a + t - 48;
                        else if (s && r && 36 !== t) break;
                        if (r) {
                            if (i > 16384) throw new Error("Out of bounds. Invalid column letter: " + n);
                        } else i = void 0;
                        s || (a = void 0);
                        const l = {
                            address: e = n + o,
                            col: i,
                            row: a,
                            $col$row: `$${n}$${o}`
                        };
                        return i <= 100 && a <= 100 && (this._hash[e] = l, this._hash[l.$col$row] = l), l;
                    },
                    getAddress (e, t) {
                        if (t) {
                            const r = this.n2l(t) + e;
                            return this.decodeAddress(r);
                        }
                        return this.decodeAddress(e);
                    },
                    decode (e) {
                        const t = e.split(":");
                        if (2 === t.length) {
                            const e = this.decodeAddress(t[0]), r = this.decodeAddress(t[1]), n = {
                                top: Math.min(e.row, r.row),
                                left: Math.min(e.col, r.col),
                                bottom: Math.max(e.row, r.row),
                                right: Math.max(e.col, r.col)
                            };
                            return n.tl = this.n2l(n.left) + n.top, n.br = this.n2l(n.right) + n.bottom, n.dimensions = `${n.tl}:${n.br}`, n;
                        }
                        return this.decodeAddress(e);
                    },
                    decodeEx (e) {
                        const t = e.match(/(?:(?:(?:'((?:[^']|'')*)')|([^'^ !]*))!)?(.*)/), r = t[1] || t[2], n = t[3], i = n.split(":");
                        if (i.length > 1) {
                            let e = this.decodeAddress(i[0]), t = this.decodeAddress(i[1]);
                            const n = Math.min(e.row, t.row), s = Math.min(e.col, t.col), o = Math.max(e.row, t.row), a = Math.max(e.col, t.col);
                            return e = this.n2l(s) + n, t = this.n2l(a) + o, {
                                top: n,
                                left: s,
                                bottom: o,
                                right: a,
                                sheetName: r,
                                tl: {
                                    address: e,
                                    col: s,
                                    row: n,
                                    $col$row: `$${this.n2l(s)}$${n}`,
                                    sheetName: r
                                },
                                br: {
                                    address: t,
                                    col: a,
                                    row: o,
                                    $col$row: `$${this.n2l(a)}$${o}`,
                                    sheetName: r
                                },
                                dimensions: `${e}:${t}`
                            };
                        }
                        if (n.startsWith("#")) return r ? {
                            sheetName: r,
                            error: n
                        } : {
                            error: n
                        };
                        const s = this.decodeAddress(n);
                        return r ? {
                            sheetName: r,
                            ...s
                        } : s;
                    },
                    encodeAddress: (e, t)=>i.n2l(t) + e,
                    encode () {
                        switch(arguments.length){
                            case 2:
                                return i.encodeAddress(arguments[0], arguments[1]);
                            case 4:
                                return `${i.encodeAddress(arguments[0], arguments[1])}:${i.encodeAddress(arguments[2], arguments[3])}`;
                            default:
                                throw new Error("Can only encode with 2 or 4 arguments");
                        }
                    },
                    inRange (e, t) {
                        const [r, n, , i, s] = e, [o, a] = t;
                        return o >= r && o <= i && a >= n && a <= s;
                    }
                };
                t.exports = i;
            },
            {}
        ],
        20: [
            function(e, t, r) {
                "use strict";
                const n = (e, t)=>({
                        ...e,
                        ...t.reduce((t, r)=>(e[r] && (t[r] = {
                                ...e[r]
                            }), t), {})
                    }), i = function(e, t, r) {
                    let i = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : [];
                    e[r] && (t[r] = n(e[r], i));
                };
                r.copyStyle = (e)=>{
                    if (!e) return e;
                    if (t = e, 0 === Object.keys(t).length) return {};
                    var t;
                    const r = {
                        ...e
                    };
                    return i(e, r, "font", [
                        "color"
                    ]), i(e, r, "alignment"), i(e, r, "protection"), e.border && (i(e, r, "border"), i(e.border, r.border, "top", [
                        "color"
                    ]), i(e.border, r.border, "left", [
                        "color"
                    ]), i(e.border, r.border, "bottom", [
                        "color"
                    ]), i(e.border, r.border, "right", [
                        "color"
                    ]), i(e.border, r.border, "diagonal", [
                        "color"
                    ])), e.fill && (i(e, r, "fill", [
                        "fgColor",
                        "bgColor",
                        "center"
                    ]), e.fill.stops && (r.fill.stops = e.fill.stops.map((e)=>n(e, [
                            "color"
                        ])))), r;
                };
            },
            {}
        ],
        21: [
            function(e, t, r) {
                (function(r) {
                    (function() {
                        "use strict";
                        const n = e("crypto"), i = {
                            hash (e) {
                                const t = n.createHash(e);
                                for(var i = arguments.length, s = new Array(i > 1 ? i - 1 : 0), o = 1; o < i; o++)s[o - 1] = arguments[o];
                                return t.update(r.concat(s)), t.digest();
                            },
                            convertPasswordToHash (e, t, i, s) {
                                t = t.toLowerCase();
                                if (n.getHashes().indexOf(t) < 0) throw new Error(`Hash algorithm '${t}' not supported!`);
                                const o = r.from(e, "utf16le");
                                let a = this.hash(t, r.from(i, "base64"), o);
                                for(let e = 0; e < s; e++){
                                    const n = r.alloc(4);
                                    n.writeUInt32LE(e, 0), a = this.hash(t, a, n);
                                }
                                return a.toString("base64");
                            },
                            randomBytes: (e)=>n.randomBytes(e)
                        };
                        t.exports = i;
                    }).call(this);
                }).call(this, e("buffer").Buffer);
            },
            {
                buffer: 220,
                crypto: 390
            }
        ],
        22: [
            function(e, t, r) {
                "use strict";
                const { SaxesParser: n } = e("saxes"), { PassThrough: i } = e("readable-stream"), { bufferToString: s } = e("./browser-buffer-decode");
                t.exports = async function*(e) {
                    e.pipe && !e[Symbol.asyncIterator] && (e = e.pipe(new i));
                    const t = new n;
                    let r;
                    t.on("error", (e)=>{
                        r = e;
                    });
                    let o = [];
                    t.on("opentag", (e)=>o.push({
                            eventType: "opentag",
                            value: e
                        })), t.on("text", (e)=>o.push({
                            eventType: "text",
                            value: e
                        })), t.on("closetag", (e)=>o.push({
                            eventType: "closetag",
                            value: e
                        }));
                    for await (const n of e){
                        if (t.write(s(n)), r) throw r;
                        yield o, o = [];
                    }
                };
            },
            {
                "./browser-buffer-decode": 16,
                "readable-stream": 491,
                saxes: 496
            }
        ],
        23: [
            function(e, t, r) {
                "use strict";
                const n = e("./col-cache"), i = /(([a-z_\-0-9]*)!)?([a-z0-9_$]{2,})([(])?/gi, s = /^([$])?([a-z]+)([$])?([1-9][0-9]*)$/i;
                t.exports = {
                    slideFormula: function(e, t, r) {
                        const o = n.decode(t), a = n.decode(r);
                        return e.replace(i, (e, t, r, i, l)=>{
                            if (l) return e;
                            const c = s.exec(i);
                            if (c) {
                                const r = c[1], i = c[2].toUpperCase(), s = c[3], l = c[4];
                                if (i.length > 3 || 3 === i.length && i > "XFD") return e;
                                let u = n.l2n(i), h = parseInt(l, 10);
                                r || (u += a.col - o.col), s || (h += a.row - o.row);
                                return (t || "") + (r || "") + n.n2l(u) + (s || "") + h;
                            }
                            return e;
                        });
                    }
                };
            },
            {
                "./col-cache": 19
            }
        ],
        24: [
            function(e, t, r) {
                (function(r, n) {
                    (function() {
                        "use strict";
                        const i = e("readable-stream"), s = e("./utils"), o = e("./string-buf");
                        class a {
                            constructor(e, t){
                                this._data = e, this._encoding = t;
                            }
                            get length() {
                                return this.toBuffer().length;
                            }
                            copy(e, t, r, n) {
                                return this.toBuffer().copy(e, t, r, n);
                            }
                            toBuffer() {
                                return this._buffer || (this._buffer = n.from(this._data, this._encoding)), this._buffer;
                            }
                        }
                        class l {
                            constructor(e){
                                this._data = e;
                            }
                            get length() {
                                return this._data.length;
                            }
                            copy(e, t, r, n) {
                                return this._data._buf.copy(e, t, r, n);
                            }
                            toBuffer() {
                                return this._data.toBuffer();
                            }
                        }
                        class c {
                            constructor(e){
                                this._data = e;
                            }
                            get length() {
                                return this._data.length;
                            }
                            copy(e, t, r, n) {
                                this._data.copy(e, t, r, n);
                            }
                            toBuffer() {
                                return this._data;
                            }
                        }
                        class u {
                            constructor(e){
                                this.size = e, this.buffer = n.alloc(e), this.iRead = 0, this.iWrite = 0;
                            }
                            toBuffer() {
                                if (0 === this.iRead && this.iWrite === this.size) return this.buffer;
                                const e = n.alloc(this.iWrite - this.iRead);
                                return this.buffer.copy(e, 0, this.iRead, this.iWrite), e;
                            }
                            get length() {
                                return this.iWrite - this.iRead;
                            }
                            get eod() {
                                return this.iRead === this.iWrite;
                            }
                            get full() {
                                return this.iWrite === this.size;
                            }
                            read(e) {
                                let t;
                                return 0 === e ? null : void 0 === e || e >= this.length ? (t = this.toBuffer(), this.iRead = this.iWrite, t) : (t = n.alloc(e), this.buffer.copy(t, 0, this.iRead, e), this.iRead += e, t);
                            }
                            write(e, t, r) {
                                const n = Math.min(r, this.size - this.iWrite);
                                return e.copy(this.buffer, this.iWrite, t, t + n), this.iWrite += n, n;
                            }
                        }
                        const h = function(e) {
                            e = e || {}, this.bufSize = e.bufSize || 1048576, this.buffers = [], this.batch = e.batch || !1, this.corked = !1, this.inPos = 0, this.outPos = 0, this.pipes = [], this.paused = !1, this.encoding = null;
                        };
                        s.inherits(h, i.Duplex, {
                            toBuffer () {
                                switch(this.buffers.length){
                                    case 0:
                                        return null;
                                    case 1:
                                        return this.buffers[0].toBuffer();
                                    default:
                                        return n.concat(this.buffers.map((e)=>e.toBuffer()));
                                }
                            },
                            _getWritableBuffer () {
                                if (this.buffers.length) {
                                    const e = this.buffers[this.buffers.length - 1];
                                    if (!e.full) return e;
                                }
                                const e = new u(this.bufSize);
                                return this.buffers.push(e), e;
                            },
                            async _pipe (e) {
                                await Promise.all(this.pipes.map(function(t) {
                                    return new Promise((r)=>{
                                        t.write(e.toBuffer(), ()=>{
                                            r();
                                        });
                                    });
                                }));
                            },
                            _writeToBuffers (e) {
                                let t = 0;
                                const r = e.length;
                                for(; t < r;)t += this._getWritableBuffer().write(e, t, r - t);
                            },
                            async write (e, t, i) {
                                let u;
                                if (t instanceof Function && (i = t, t = "utf8"), i = i || s.nop, e instanceof o) u = new l(e);
                                else if (e instanceof n) u = new c(e);
                                else {
                                    if (!("string" == typeof e || e instanceof String || e instanceof ArrayBuffer)) throw new Error("Chunk must be one of type String, Buffer or StringBuf.");
                                    u = new a(e, t);
                                }
                                if (this.pipes.length) {
                                    if (this.batch) for(this._writeToBuffers(u); !this.corked && this.buffers.length > 1;)this._pipe(this.buffers.shift());
                                    else this.corked ? (this._writeToBuffers(u), r.nextTick(i)) : (await this._pipe(u), i());
                                } else this.paused || this.emit("data", u.toBuffer()), this._writeToBuffers(u), this.emit("readable");
                                return !0;
                            },
                            cork () {
                                this.corked = !0;
                            },
                            _flush () {
                                if (this.pipes.length) for(; this.buffers.length;)this._pipe(this.buffers.shift());
                            },
                            uncork () {
                                this.corked = !1, this._flush();
                            },
                            end (e, t, r) {
                                const n = (e)=>{
                                    e ? r(e) : (this._flush(), this.pipes.forEach((e)=>{
                                        e.end();
                                    }), this.emit("finish"));
                                };
                                e ? this.write(e, t, n) : n();
                            },
                            read (e) {
                                let t;
                                if (e) {
                                    for(t = []; e && this.buffers.length && !this.buffers[0].eod;){
                                        const r = this.buffers[0], n = r.read(e);
                                        e -= n.length, t.push(n), r.eod && r.full && this.buffers.shift();
                                    }
                                    return n.concat(t);
                                }
                                return t = this.buffers.map((e)=>e.toBuffer()).filter(Boolean), this.buffers = [], n.concat(t);
                            },
                            setEncoding (e) {
                                this.encoding = e;
                            },
                            pause () {
                                this.paused = !0;
                            },
                            resume () {
                                this.paused = !1;
                            },
                            isPaused () {
                                return !!this.paused;
                            },
                            pipe (e) {
                                this.pipes.push(e), !this.paused && this.buffers.length && this.end();
                            },
                            unpipe (e) {
                                this.pipes = this.pipes.filter((t)=>t !== e);
                            },
                            unshift () {
                                throw new Error("Not Implemented");
                            },
                            wrap () {
                                throw new Error("Not Implemented");
                            }
                        }), t.exports = h;
                    }).call(this);
                }).call(this, e("_process"), e("buffer").Buffer);
            },
            {
                "./string-buf": 25,
                "./utils": 27,
                _process: 467,
                buffer: 220,
                "readable-stream": 491
            }
        ],
        25: [
            function(e, t, r) {
                (function(e) {
                    (function() {
                        "use strict";
                        t.exports = class {
                            constructor(t){
                                this._buf = e.alloc(t && t.size || 16384), this._encoding = t && t.encoding || "utf8", this._inPos = 0, this._buffer = void 0;
                            }
                            get length() {
                                return this._inPos;
                            }
                            get capacity() {
                                return this._buf.length;
                            }
                            get buffer() {
                                return this._buf;
                            }
                            toBuffer() {
                                return this._buffer || (this._buffer = e.alloc(this.length), this._buf.copy(this._buffer, 0, 0, this.length)), this._buffer;
                            }
                            reset(e) {
                                e = e || 0, this._buffer = void 0, this._inPos = e;
                            }
                            _grow(t) {
                                let r = 2 * this._buf.length;
                                for(; r < t;)r *= 2;
                                const n = e.alloc(r);
                                this._buf.copy(n, 0), this._buf = n;
                            }
                            addText(e) {
                                this._buffer = void 0;
                                let t = this._inPos + this._buf.write(e, this._inPos, this._encoding);
                                for(; t >= this._buf.length - 4;)this._grow(this._inPos + e.length), t = this._inPos + this._buf.write(e, this._inPos, this._encoding);
                                this._inPos = t;
                            }
                            addStringBuf(e) {
                                e.length && (this._buffer = void 0, this.length + e.length > this.capacity && this._grow(this.length + e.length), e._buf.copy(this._buf, this._inPos, 0, e.length), this._inPos += e.length);
                            }
                        };
                    }).call(this);
                }).call(this, e("buffer").Buffer);
            },
            {
                buffer: 220
            }
        ],
        26: [
            function(e, t, r) {
                "use strict";
                const { toString: n } = Object.prototype, i = /["&<>]/, s = {
                    each: function(e, t) {
                        e && (Array.isArray(e) ? e.forEach(t) : Object.keys(e).forEach((r)=>{
                            t(e[r], r);
                        }));
                    },
                    some: function(e, t) {
                        return !!e && (Array.isArray(e) ? e.some(t) : Object.keys(e).some((r)=>t(e[r], r)));
                    },
                    every: function(e, t) {
                        return !e || (Array.isArray(e) ? e.every(t) : Object.keys(e).every((r)=>t(e[r], r)));
                    },
                    map: function(e, t) {
                        return e ? Array.isArray(e) ? e.map(t) : Object.keys(e).map((r)=>t(e[r], r)) : [];
                    },
                    keyBy: (e, t)=>e.reduce((e, r)=>(e[r[t]] = r, e), {}),
                    isEqual: function(e, t) {
                        const r = typeof e, n = typeof t, i = Array.isArray(e), o = Array.isArray(t);
                        let a;
                        if (r !== n) return !1;
                        switch(typeof e){
                            case "object":
                                if (i || o) return !(!i || !o) && e.length === t.length && e.every((e, r)=>{
                                    const n = t[r];
                                    return s.isEqual(e, n);
                                });
                                if (null === e || null === t) return e === t;
                                if (a = Object.keys(e), Object.keys(t).length !== a.length) return !1;
                                for (const e of a)if (!t.hasOwnProperty(e)) return !1;
                                return s.every(e, (e, r)=>{
                                    const n = t[r];
                                    return s.isEqual(e, n);
                                });
                            default:
                                return e === t;
                        }
                    },
                    escapeHtml (e) {
                        const t = i.exec(e);
                        if (!t) return e;
                        let r = "", n = "", s = 0, o = t.index;
                        for(; o < e.length; o++){
                            switch(e.charAt(o)){
                                case '"':
                                    n = "&quot;";
                                    break;
                                case "&":
                                    n = "&amp;";
                                    break;
                                case "'":
                                    n = "&apos;";
                                    break;
                                case "<":
                                    n = "&lt;";
                                    break;
                                case ">":
                                    n = "&gt;";
                                    break;
                                default:
                                    continue;
                            }
                            s !== o && (r += e.substring(s, o)), s = o + 1, r += n;
                        }
                        return s !== o ? r + e.substring(s, o) : r;
                    },
                    strcmp: (e, t)=>e < t ? -1 : e > t ? 1 : 0,
                    isUndefined: (e)=>"[object Undefined]" === n.call(e),
                    isObject: (e)=>"[object Object]" === n.call(e),
                    deepMerge () {
                        const e = arguments[0] || {}, { length: t } = arguments;
                        let r, n, i;
                        function o(t, o) {
                            r = e[o], i = Array.isArray(t), s.isObject(t) || i ? (i ? (i = !1, n = r && Array.isArray(r) ? r : []) : n = r && s.isObject(r) ? r : {}, e[o] = s.deepMerge(n, t)) : s.isUndefined(t) || (e[o] = t);
                        }
                        for(let e = 0; e < t; e++)s.each(arguments[e], o);
                        return e;
                    }
                };
                t.exports = s;
            },
            {}
        ],
        27: [
            function(e, t, r) {
                (function(r, n) {
                    (function() {
                        "use strict";
                        const i = e("fs"), s = /[<>&'"\x7F\x00-\x08\x0B-\x0C\x0E-\x1F]/, o = {
                            nop () {},
                            promiseImmediate: (e)=>new Promise((t)=>{
                                    r.setImmediate ? n(()=>{
                                        t(e);
                                    }) : setTimeout(()=>{
                                        t(e);
                                    }, 1);
                                }),
                            inherits: function(e, t, r, n) {
                                e.super_ = t, n || (n = r, r = null), r && Object.keys(r).forEach((t)=>{
                                    Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
                                });
                                const i = {
                                    constructor: {
                                        value: e,
                                        enumerable: !1,
                                        writable: !1,
                                        configurable: !0
                                    }
                                };
                                n && Object.keys(n).forEach((e)=>{
                                    i[e] = Object.getOwnPropertyDescriptor(n, e);
                                }), e.prototype = Object.create(t.prototype, i);
                            },
                            dateToExcel: (e, t)=>25569 + e.getTime() / 864e5 - (t ? 1462 : 0),
                            excelToDate (e, t) {
                                const r = Math.round(24 * (e - 25569 + (t ? 1462 : 0)) * 3600000);
                                return new Date(r);
                            },
                            parsePath (e) {
                                const t = e.lastIndexOf("/");
                                return {
                                    path: e.substring(0, t),
                                    name: e.substring(t + 1)
                                };
                            },
                            getRelsPath (e) {
                                const t = o.parsePath(e);
                                return `${t.path}/_rels/${t.name}.rels`;
                            },
                            xmlEncode (e) {
                                const t = s.exec(e);
                                if (!t) return e;
                                let r = "", n = "", i = 0, o = t.index;
                                for(; o < e.length; o++){
                                    const t = e.charCodeAt(o);
                                    switch(t){
                                        case 34:
                                            n = "&quot;";
                                            break;
                                        case 38:
                                            n = "&amp;";
                                            break;
                                        case 39:
                                            n = "&apos;";
                                            break;
                                        case 60:
                                            n = "&lt;";
                                            break;
                                        case 62:
                                            n = "&gt;";
                                            break;
                                        case 127:
                                            n = "";
                                            break;
                                        default:
                                            if (t <= 31 && (t <= 8 || t >= 11 && 13 !== t)) {
                                                n = "";
                                                break;
                                            }
                                            continue;
                                    }
                                    i !== o && (r += e.substring(i, o)), i = o + 1, n && (r += n);
                                }
                                return i !== o ? r + e.substring(i, o) : r;
                            },
                            xmlDecode: (e)=>e.replace(/&([a-z]*);/g, (e)=>{
                                    switch(e){
                                        case "&lt;":
                                            return "<";
                                        case "&gt;":
                                            return ">";
                                        case "&amp;":
                                            return "&";
                                        case "&apos;":
                                            return "'";
                                        case "&quot;":
                                            return '"';
                                        default:
                                            return e;
                                    }
                                }),
                            validInt (e) {
                                const t = parseInt(e, 10);
                                return Number.isNaN(t) ? 0 : t;
                            },
                            isDateFmt (e) {
                                if (!e) return !1;
                                return null !== (e = (e = e.replace(/\[[^\]]*]/g, "")).replace(/"[^"]*"/g, "")).match(/[ymdhMsb]+/);
                            },
                            fs: {
                                exists: (e)=>new Promise((t)=>{
                                        i.access(e, i.constants.F_OK, (e)=>{
                                            t(!e);
                                        });
                                    })
                            },
                            toIsoDateString: (e)=>e.toIsoString().subsstr(0, 10),
                            parseBoolean: (e)=>!0 === e || "true" === e || 1 === e || "1" === e
                        };
                        t.exports = o;
                    }).call(this);
                }).call(this, "undefined" != typeof $parcel$global ? $parcel$global : "undefined" != typeof self ? self : "undefined" != typeof window ? window : {}, e("timers").setImmediate);
            },
            {
                fs: 216,
                timers: 523
            }
        ],
        28: [
            function(e, t, r) {
                "use strict";
                const n = e("./under-dash"), i = e("./utils");
                function s(e, t, r) {
                    e.push(` ${t}="${i.xmlEncode(r.toString())}"`);
                }
                function o(e, t) {
                    if (t) {
                        const r = [];
                        n.each(t, (e, t)=>{
                            void 0 !== e && s(r, t, e);
                        }), e.push(r.join(""));
                    }
                }
                class a {
                    constructor(){
                        this._xml = [], this._stack = [], this._rollbacks = [];
                    }
                    get tos() {
                        return this._stack.length ? this._stack[this._stack.length - 1] : void 0;
                    }
                    get cursor() {
                        return this._xml.length;
                    }
                    openXml(e) {
                        const t = this._xml;
                        t.push("<?xml"), o(t, e), t.push("?>\n");
                    }
                    openNode(e, t) {
                        const r = this.tos, n = this._xml;
                        r && this.open && n.push(">"), this._stack.push(e), n.push("<"), n.push(e), o(n, t), this.leaf = !0, this.open = !0;
                    }
                    addAttribute(e, t) {
                        if (!this.open) throw new Error("Cannot write attributes to node if it is not open");
                        void 0 !== t && s(this._xml, e, t);
                    }
                    addAttributes(e) {
                        if (!this.open) throw new Error("Cannot write attributes to node if it is not open");
                        o(this._xml, e);
                    }
                    writeText(e) {
                        const t = this._xml;
                        this.open && (t.push(">"), this.open = !1), this.leaf = !1, t.push(i.xmlEncode(e.toString()));
                    }
                    writeXml(e) {
                        this.open && (this._xml.push(">"), this.open = !1), this.leaf = !1, this._xml.push(e);
                    }
                    closeNode() {
                        const e = this._stack.pop(), t = this._xml;
                        this.leaf ? t.push("/>") : (t.push("</"), t.push(e), t.push(">")), this.open = !1, this.leaf = !1;
                    }
                    leafNode(e, t, r) {
                        this.openNode(e, t), void 0 !== r && this.writeText(r), this.closeNode();
                    }
                    closeAll() {
                        for(; this._stack.length;)this.closeNode();
                    }
                    addRollback() {
                        return this._rollbacks.push({
                            xml: this._xml.length,
                            stack: this._stack.length,
                            leaf: this.leaf,
                            open: this.open
                        }), this.cursor;
                    }
                    commit() {
                        this._rollbacks.pop();
                    }
                    rollback() {
                        const e = this._rollbacks.pop();
                        this._xml.length > e.xml && this._xml.splice(e.xml, this._xml.length - e.xml), this._stack.length > e.stack && this._stack.splice(e.stack, this._stack.length - e.stack), this.leaf = e.leaf, this.open = e.open;
                    }
                    get xml() {
                        return this.closeAll(), this._xml.join("");
                    }
                }
                a.StdDocAttributes = {
                    version: "1.0",
                    encoding: "UTF-8",
                    standalone: "yes"
                }, t.exports = a;
            },
            {
                "./under-dash": 26,
                "./utils": 27
            }
        ],
        29: [
            function(e, t, r) {
                (function(r) {
                    (function() {
                        "use strict";
                        const n = e("events"), i = e("jszip"), s = e("./stream-buf"), { stringToBuffer: o } = e("./browser-buffer-encode");
                        class a extends n.EventEmitter {
                            constructor(e){
                                super(), this.options = Object.assign({
                                    type: "nodebuffer",
                                    compression: "DEFLATE"
                                }, e), this.zip = new i, this.stream = new s;
                            }
                            append(e, t) {
                                t.hasOwnProperty("base64") && t.base64 ? this.zip.file(t.name, e, {
                                    base64: !0
                                }) : (r.browser && "string" == typeof e && (e = o(e)), this.zip.file(t.name, e));
                            }
                            async finalize() {
                                const e = await this.zip.generateAsync(this.options);
                                this.stream.end(e), this.emit("finish");
                            }
                            read(e) {
                                return this.stream.read(e);
                            }
                            setEncoding(e) {
                                return this.stream.setEncoding(e);
                            }
                            pause() {
                                return this.stream.pause();
                            }
                            resume() {
                                return this.stream.resume();
                            }
                            isPaused() {
                                return this.stream.isPaused();
                            }
                            pipe(e, t) {
                                return this.stream.pipe(e, t);
                            }
                            unpipe(e) {
                                return this.stream.unpipe(e);
                            }
                            unshift(e) {
                                return this.stream.unshift(e);
                            }
                            wrap(e) {
                                return this.stream.wrap(e);
                            }
                        }
                        t.exports = {
                            ZipWriter: a
                        };
                    }).call(this);
                }).call(this, e("_process"));
            },
            {
                "./browser-buffer-encode": 17,
                "./stream-buf": 24,
                _process: 467,
                events: 422,
                jszip: 441
            }
        ],
        30: [
            function(e, t, r) {
                "use strict";
                t.exports = {
                    0: {
                        f: "General"
                    },
                    1: {
                        f: "0"
                    },
                    2: {
                        f: "0.00"
                    },
                    3: {
                        f: "#,##0"
                    },
                    4: {
                        f: "#,##0.00"
                    },
                    9: {
                        f: "0%"
                    },
                    10: {
                        f: "0.00%"
                    },
                    11: {
                        f: "0.00E+00"
                    },
                    12: {
                        f: "# ?/?"
                    },
                    13: {
                        f: "# ??/??"
                    },
                    14: {
                        f: "mm-dd-yy"
                    },
                    15: {
                        f: "d-mmm-yy"
                    },
                    16: {
                        f: "d-mmm"
                    },
                    17: {
                        f: "mmm-yy"
                    },
                    18: {
                        f: "h:mm AM/PM"
                    },
                    19: {
                        f: "h:mm:ss AM/PM"
                    },
                    20: {
                        f: "h:mm"
                    },
                    21: {
                        f: "h:mm:ss"
                    },
                    22: {
                        f: 'm/d/yy "h":mm'
                    },
                    27: {
                        "zh-tw": "[$-404]e/m/d",
                        "zh-cn": 'yyyy"\u5e74"m"\u6708"',
                        "ja-jp": "[$-411]ge.m.d",
                        "ko-kr": 'yyyy"\u5e74" mm"\u6708" dd"\u65e5"'
                    },
                    28: {
                        "zh-tw": '[$-404]e"\u5e74"m"\u6708"d"\u65e5"',
                        "zh-cn": 'm"\u6708"d"\u65e5"',
                        "ja-jp": '[$-411]ggge"\u5e74"m"\u6708"d"\u65e5"',
                        "ko-kr": "mm-dd"
                    },
                    29: {
                        "zh-tw": '[$-404]e"\u5e74"m"\u6708"d"\u65e5"',
                        "zh-cn": 'm"\u6708"d"\u65e5"',
                        "ja-jp": '[$-411]ggge"\u5e74"m"\u6708"d"\u65e5"',
                        "ko-kr": "mm-dd"
                    },
                    30: {
                        "zh-tw": "m/d/yy ",
                        "zh-cn": "m-d-yy",
                        "ja-jp": "m/d/yy",
                        "ko-kr": "mm-dd-yy"
                    },
                    31: {
                        "zh-tw": 'yyyy"\u5e74"m"\u6708"d"\u65e5"',
                        "zh-cn": 'yyyy"\u5e74"m"\u6708"d"\u65e5"',
                        "ja-jp": 'yyyy"\u5e74"m"\u6708"d"\u65e5"',
                        "ko-kr": 'yyyy"\ub144" mm"\uc6d4" dd"\uc77c"'
                    },
                    32: {
                        "zh-tw": 'hh"\u6642"mm"\u5206"',
                        "zh-cn": 'h"\u65f6"mm"\u5206"',
                        "ja-jp": 'h"\u6642"mm"\u5206"',
                        "ko-kr": 'h"\uc2dc" mm"\ubd84"'
                    },
                    33: {
                        "zh-tw": 'hh"\u6642"mm"\u5206"ss"\u79d2"',
                        "zh-cn": 'h"\u65f6"mm"\u5206"ss"\u79d2"',
                        "ja-jp": 'h"\u6642"mm"\u5206"ss"\u79d2"',
                        "ko-kr": 'h"\uc2dc" mm"\ubd84" ss"\ucd08"'
                    },
                    34: {
                        "zh-tw": '\u4e0a\u5348/\u4e0b\u5348 hh"\u6642"mm"\u5206"',
                        "zh-cn": '\u4e0a\u5348/\u4e0b\u5348 h"\u65f6"mm"\u5206"',
                        "ja-jp": 'yyyy"\u5e74"m"\u6708"',
                        "ko-kr": "yyyy-mm-dd"
                    },
                    35: {
                        "zh-tw": '\u4e0a\u5348/\u4e0b\u5348 hh"\u6642"mm"\u5206"ss"\u79d2"',
                        "zh-cn": '\u4e0a\u5348/\u4e0b\u5348 h"\u65f6"mm"\u5206"ss"\u79d2"',
                        "ja-jp": 'm"\u6708"d"\u65e5"',
                        "ko-kr": "yyyy-mm-dd"
                    },
                    36: {
                        "zh-tw": "[$-404]e/m/d",
                        "zh-cn": 'yyyy"\u5e74"m"\u6708"',
                        "ja-jp": "[$-411]ge.m.d",
                        "ko-kr": 'yyyy"\u5e74" mm"\u6708" dd"\u65e5"'
                    },
                    37: {
                        f: "#,##0 ;(#,##0)"
                    },
                    38: {
                        f: "#,##0 ;[Red](#,##0)"
                    },
                    39: {
                        f: "#,##0.00 ;(#,##0.00)"
                    },
                    40: {
                        f: "#,##0.00 ;[Red](#,##0.00)"
                    },
                    45: {
                        f: "mm:ss"
                    },
                    46: {
                        f: "[h]:mm:ss"
                    },
                    47: {
                        f: "mmss.0"
                    },
                    48: {
                        f: "##0.0E+0"
                    },
                    49: {
                        f: "@"
                    },
                    50: {
                        "zh-tw": "[$-404]e/m/d",
                        "zh-cn": 'yyyy"\u5e74"m"\u6708"',
                        "ja-jp": "[$-411]ge.m.d",
                        "ko-kr": 'yyyy"\u5e74" mm"\u6708" dd"\u65e5"'
                    },
                    51: {
                        "zh-tw": '[$-404]e"\u5e74"m"\u6708"d"\u65e5"',
                        "zh-cn": 'm"\u6708"d"\u65e5"',
                        "ja-jp": '[$-411]ggge"\u5e74"m"\u6708"d"\u65e5"',
                        "ko-kr": "mm-dd"
                    },
                    52: {
                        "zh-tw": '\u4e0a\u5348/\u4e0b\u5348 hh"\u6642"mm"\u5206"',
                        "zh-cn": 'yyyy"\u5e74"m"\u6708"',
                        "ja-jp": 'yyyy"\u5e74"m"\u6708"',
                        "ko-kr": "yyyy-mm-dd"
                    },
                    53: {
                        "zh-tw": '\u4e0a\u5348/\u4e0b\u5348 hh"\u6642"mm"\u5206"ss"\u79d2"',
                        "zh-cn": 'm"\u6708"d"\u65e5"',
                        "ja-jp": 'm"\u6708"d"\u65e5"',
                        "ko-kr": "yyyy-mm-dd"
                    },
                    54: {
                        "zh-tw": '[$-404]e"\u5e74"m"\u6708"d"\u65e5"',
                        "zh-cn": 'm"\u6708"d"\u65e5"',
                        "ja-jp": '[$-411]ggge"\u5e74"m"\u6708"d"\u65e5"',
                        "ko-kr": "mm-dd"
                    },
                    55: {
                        "zh-tw": '\u4e0a\u5348/\u4e0b\u5348 hh"\u6642"mm"\u5206"',
                        "zh-cn": '\u4e0a\u5348/\u4e0b\u5348 h"\u65f6"mm"\u5206"',
                        "ja-jp": 'yyyy"\u5e74"m"\u6708"',
                        "ko-kr": "yyyy-mm-dd"
                    },
                    56: {
                        "zh-tw": '\u4e0a\u5348/\u4e0b\u5348 hh"\u6642"mm"\u5206"ss"\u79d2"',
                        "zh-cn": '\u4e0a\u5348/\u4e0b\u5348 h"\u65f6"mm"\u5206"ss"\u79d2"',
                        "ja-jp": 'm"\u6708"d"\u65e5"',
                        "ko-kr": "yyyy-mm-dd"
                    },
                    57: {
                        "zh-tw": "[$-404]e/m/d",
                        "zh-cn": 'yyyy"\u5e74"m"\u6708"',
                        "ja-jp": "[$-411]ge.m.d",
                        "ko-kr": 'yyyy"\u5e74" mm"\u6708" dd"\u65e5"'
                    },
                    58: {
                        "zh-tw": '[$-404]e"\u5e74"m"\u6708"d"\u65e5"',
                        "zh-cn": 'm"\u6708"d"\u65e5"',
                        "ja-jp": '[$-411]ggge"\u5e74"m"\u6708"d"\u65e5"',
                        "ko-kr": "mm-dd"
                    },
                    59: {
                        "th-th": "t0"
                    },
                    60: {
                        "th-th": "t0.00"
                    },
                    61: {
                        "th-th": "t#,##0"
                    },
                    62: {
                        "th-th": "t#,##0.00"
                    },
                    67: {
                        "th-th": "t0%"
                    },
                    68: {
                        "th-th": "t0.00%"
                    },
                    69: {
                        "th-th": "t# ?/?"
                    },
                    70: {
                        "th-th": "t# ??/??"
                    },
                    81: {
                        "th-th": "d/m/bb"
                    }
                };
            },
            {}
        ],
        31: [
            function(e, t, r) {
                "use strict";
                t.exports = {
                    OfficeDocument: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/officeDocument",
                    Worksheet: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/worksheet",
                    CalcChain: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/calcChain",
                    SharedStrings: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/sharedStrings",
                    Styles: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/styles",
                    Theme: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/theme",
                    Hyperlink: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/hyperlink",
                    Image: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/image",
                    CoreProperties: "http://schemas.openxmlformats.org/package/2006/relationships/metadata/core-properties",
                    ExtenderProperties: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/extended-properties",
                    Comments: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/comments",
                    VmlDrawing: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/vmlDrawing",
                    Table: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/table"
                };
            },
            {}
        ],
        32: [
            function(e, t, r) {
                "use strict";
                const n = e("../../utils/parse-sax"), i = e("../../utils/xml-stream");
                class s {
                    prepare() {}
                    render() {}
                    parseOpen(e) {}
                    parseText(e) {}
                    parseClose(e) {}
                    reconcile(e, t) {}
                    reset() {
                        this.model = null, this.map && Object.values(this.map).forEach((e)=>{
                            e instanceof s ? e.reset() : e.xform && e.xform.reset();
                        });
                    }
                    mergeModel(e) {
                        this.model = Object.assign(this.model || {}, e);
                    }
                    async parse(e) {
                        for await (const t of e)for (const { eventType: e, value: r } of t)if ("opentag" === e) this.parseOpen(r);
                        else if ("text" === e) this.parseText(r);
                        else if ("closetag" === e && !this.parseClose(r.name)) return this.model;
                        return this.model;
                    }
                    async parseStream(e) {
                        return this.parse(n(e));
                    }
                    get xml() {
                        return this.toXml(this.model);
                    }
                    toXml(e) {
                        const t = new i;
                        return this.render(t, e), t.xml;
                    }
                    static toAttribute(e, t) {
                        let r = arguments.length > 2 && void 0 !== arguments[2] && arguments[2];
                        if (void 0 === e) {
                            if (r) return t;
                        } else if (r || e !== t) return e.toString();
                    }
                    static toStringAttribute(e, t) {
                        let r = arguments.length > 2 && void 0 !== arguments[2] && arguments[2];
                        return s.toAttribute(e, t, r);
                    }
                    static toStringValue(e, t) {
                        return void 0 === e ? t : e;
                    }
                    static toBoolAttribute(e, t) {
                        let r = arguments.length > 2 && void 0 !== arguments[2] && arguments[2];
                        if (void 0 === e) {
                            if (r) return t;
                        } else if (r || e !== t) return e ? "1" : "0";
                    }
                    static toBoolValue(e, t) {
                        return void 0 === e ? t : "1" === e;
                    }
                    static toIntAttribute(e, t) {
                        let r = arguments.length > 2 && void 0 !== arguments[2] && arguments[2];
                        return s.toAttribute(e, t, r);
                    }
                    static toIntValue(e, t) {
                        return void 0 === e ? t : parseInt(e, 10);
                    }
                    static toFloatAttribute(e, t) {
                        let r = arguments.length > 2 && void 0 !== arguments[2] && arguments[2];
                        return s.toAttribute(e, t, r);
                    }
                    static toFloatValue(e, t) {
                        return void 0 === e ? t : parseFloat(e);
                    }
                }
                t.exports = s;
            },
            {
                "../../utils/parse-sax": 22,
                "../../utils/xml-stream": 28
            }
        ],
        33: [
            function(e, t, r) {
                "use strict";
                const n = e("../base-xform"), i = e("../../../utils/col-cache");
                function s(e) {
                    try {
                        return i.decodeEx(e), !0;
                    } catch (e) {
                        return !1;
                    }
                }
                function o(e) {
                    const t = [];
                    let r = !1, n = "";
                    return e.split(",").forEach((e)=>{
                        if (!e) return;
                        const i = (e.match(/'/g) || []).length;
                        if (!i) return void (r ? n += e + "," : s(e) && t.push(e));
                        const o = i % 2 == 0;
                        !r && o && s(e) ? t.push(e) : r && !o ? (r = !1, s(n + e) && t.push(n + e), n = "") : (r = !0, n += e + ",");
                    }), t;
                }
                t.exports = class extends n {
                    render(e, t) {
                        e.openNode("definedName", {
                            name: t.name,
                            localSheetId: t.localSheetId
                        }), e.writeText(t.ranges.join(",")), e.closeNode();
                    }
                    parseOpen(e) {
                        switch(e.name){
                            case "definedName":
                                return this._parsedName = e.attributes.name, this._parsedLocalSheetId = e.attributes.localSheetId, this._parsedText = [], !0;
                            default:
                                return !1;
                        }
                    }
                    parseText(e) {
                        this._parsedText.push(e);
                    }
                    parseClose() {
                        return this.model = {
                            name: this._parsedName,
                            ranges: o(this._parsedText.join(""))
                        }, void 0 !== this._parsedLocalSheetId && (this.model.localSheetId = parseInt(this._parsedLocalSheetId, 10)), !1;
                    }
                };
            },
            {
                "../../../utils/col-cache": 19,
                "../base-xform": 32
            }
        ],
        34: [
            function(e, t, r) {
                "use strict";
                const n = e("../../../utils/utils"), i = e("../base-xform");
                t.exports = class extends i {
                    render(e, t) {
                        e.leafNode("sheet", {
                            sheetId: t.id,
                            name: t.name,
                            state: t.state,
                            "r:id": t.rId
                        });
                    }
                    parseOpen(e) {
                        return "sheet" === e.name && (this.model = {
                            name: n.xmlDecode(e.attributes.name),
                            id: parseInt(e.attributes.sheetId, 10),
                            state: e.attributes.state,
                            rId: e.attributes["r:id"]
                        }, !0);
                    }
                    parseText() {}
                    parseClose() {
                        return !1;
                    }
                };
            },
            {
                "../../../utils/utils": 27,
                "../base-xform": 32
            }
        ],
        35: [
            function(e, t, r) {
                "use strict";
                const n = e("../base-xform");
                t.exports = class extends n {
                    render(e, t) {
                        e.leafNode("calcPr", {
                            calcId: 171027,
                            fullCalcOnLoad: t.fullCalcOnLoad ? 1 : void 0
                        });
                    }
                    parseOpen(e) {
                        return "calcPr" === e.name && (this.model = {}, !0);
                    }
                    parseText() {}
                    parseClose() {
                        return !1;
                    }
                };
            },
            {
                "../base-xform": 32
            }
        ],
        36: [
            function(e, t, r) {
                "use strict";
                const n = e("../base-xform");
                t.exports = class extends n {
                    render(e, t) {
                        e.leafNode("workbookPr", {
                            date1904: t.date1904 ? 1 : void 0,
                            defaultThemeVersion: 164011,
                            filterPrivacy: 1
                        });
                    }
                    parseOpen(e) {
                        return "workbookPr" === e.name && (this.model = {
                            date1904: "1" === e.attributes.date1904
                        }, !0);
                    }
                    parseText() {}
                    parseClose() {
                        return !1;
                    }
                };
            },
            {
                "../base-xform": 32
            }
        ],
        37: [
            function(e, t, r) {
                "use strict";
                const n = e("../base-xform");
                t.exports = class extends n {
                    render(e, t) {
                        const r = {
                            xWindow: t.x || 0,
                            yWindow: t.y || 0,
                            windowWidth: t.width || 12e3,
                            windowHeight: t.height || 24e3,
                            firstSheet: t.firstSheet,
                            activeTab: t.activeTab
                        };
                        t.visibility && "visible" !== t.visibility && (r.visibility = t.visibility), e.leafNode("workbookView", r);
                    }
                    parseOpen(e) {
                        if ("workbookView" === e.name) {
                            const t = this.model = {}, r = function(e, r, n) {
                                const i = void 0 !== r ? t[e] = r : n;
                                void 0 !== i && (t[e] = i);
                            }, n = function(e, r, n) {
                                const i = void 0 !== r ? t[e] = parseInt(r, 10) : n;
                                void 0 !== i && (t[e] = i);
                            };
                            return n("x", e.attributes.xWindow, 0), n("y", e.attributes.yWindow, 0), n("width", e.attributes.windowWidth, 25e3), n("height", e.attributes.windowHeight, 1e4), r("visibility", e.attributes.visibility, "visible"), n("activeTab", e.attributes.activeTab, void 0), n("firstSheet", e.attributes.firstSheet, void 0), !0;
                        }
                        return !1;
                    }
                    parseText() {}
                    parseClose() {
                        return !1;
                    }
                };
            },
            {
                "../base-xform": 32
            }
        ],
        38: [
            function(e, t, r) {
                "use strict";
                const n = e("../../../utils/under-dash"), i = e("../../../utils/col-cache"), s = e("../../../utils/xml-stream"), o = e("../base-xform"), a = e("../static-xform"), l = e("../list-xform"), c = e("./defined-name-xform"), u = e("./sheet-xform"), h = e("./workbook-view-xform"), f = e("./workbook-properties-xform"), d = e("./workbook-calc-properties-xform");
                class p extends o {
                    constructor(){
                        super(), this.map = {
                            fileVersion: p.STATIC_XFORMS.fileVersion,
                            workbookPr: new f,
                            bookViews: new l({
                                tag: "bookViews",
                                count: !1,
                                childXform: new h
                            }),
                            sheets: new l({
                                tag: "sheets",
                                count: !1,
                                childXform: new u
                            }),
                            definedNames: new l({
                                tag: "definedNames",
                                count: !1,
                                childXform: new c
                            }),
                            calcPr: new d
                        };
                    }
                    prepare(e) {
                        e.sheets = e.worksheets;
                        const t = [];
                        let r = 0;
                        e.sheets.forEach((e)=>{
                            if (e.pageSetup && e.pageSetup.printArea && e.pageSetup.printArea.split("&&").forEach((n)=>{
                                const i = n.split(":"), s = {
                                    name: "_xlnm.Print_Area",
                                    ranges: [
                                        `'${e.name}'!$${i[0]}:$${i[1]}`
                                    ],
                                    localSheetId: r
                                };
                                t.push(s);
                            }), e.pageSetup && (e.pageSetup.printTitlesRow || e.pageSetup.printTitlesColumn)) {
                                const n = [];
                                if (e.pageSetup.printTitlesColumn) {
                                    const t = e.pageSetup.printTitlesColumn.split(":");
                                    n.push(`'${e.name}'!$${t[0]}:$${t[1]}`);
                                }
                                if (e.pageSetup.printTitlesRow) {
                                    const t = e.pageSetup.printTitlesRow.split(":");
                                    n.push(`'${e.name}'!$${t[0]}:$${t[1]}`);
                                }
                                const i = {
                                    name: "_xlnm.Print_Titles",
                                    ranges: n,
                                    localSheetId: r
                                };
                                t.push(i);
                            }
                            r++;
                        }), t.length && (e.definedNames = e.definedNames.concat(t)), (e.media || []).forEach((e, t)=>{
                            e.name = e.type + (t + 1);
                        });
                    }
                    render(e, t) {
                        e.openXml(s.StdDocAttributes), e.openNode("workbook", p.WORKBOOK_ATTRIBUTES), this.map.fileVersion.render(e), this.map.workbookPr.render(e, t.properties), this.map.bookViews.render(e, t.views), this.map.sheets.render(e, t.sheets), this.map.definedNames.render(e, t.definedNames), this.map.calcPr.render(e, t.calcProperties), e.closeNode();
                    }
                    parseOpen(e) {
                        if (this.parser) return this.parser.parseOpen(e), !0;
                        switch(e.name){
                            case "workbook":
                                return !0;
                            default:
                                return this.parser = this.map[e.name], this.parser && this.parser.parseOpen(e), !0;
                        }
                    }
                    parseText(e) {
                        this.parser && this.parser.parseText(e);
                    }
                    parseClose(e) {
                        if (this.parser) return this.parser.parseClose(e) || (this.parser = void 0), !0;
                        switch(e){
                            case "workbook":
                                return this.model = {
                                    sheets: this.map.sheets.model,
                                    properties: this.map.workbookPr.model || {},
                                    views: this.map.bookViews.model,
                                    calcProperties: {}
                                }, this.map.definedNames.model && (this.model.definedNames = this.map.definedNames.model), !1;
                            default:
                                return !0;
                        }
                    }
                    reconcile(e) {
                        const t = (e.workbookRels || []).reduce((e, t)=>(e[t.Id] = t, e), {}), r = [];
                        let s, o = 0;
                        (e.sheets || []).forEach((n)=>{
                            const i = t[n.rId];
                            i && (s = e.worksheetHash["xl/" + i.Target.replace(/^(\s|\/xl\/)+/, "")], s && (s.name = n.name, s.id = n.id, s.state = n.state, r[o++] = s));
                        });
                        const a = [];
                        n.each(e.definedNames, (e)=>{
                            if ("_xlnm.Print_Area" === e.name) {
                                if (s = r[e.localSheetId], s) {
                                    s.pageSetup || (s.pageSetup = {});
                                    const t = i.decodeEx(e.ranges[0]);
                                    s.pageSetup.printArea = s.pageSetup.printArea ? `${s.pageSetup.printArea}&&${t.dimensions}` : t.dimensions;
                                }
                            } else if ("_xlnm.Print_Titles" === e.name) {
                                if (s = r[e.localSheetId], s) {
                                    s.pageSetup || (s.pageSetup = {});
                                    const t = e.ranges.join(","), r = /\$/g, n = /\$\d+:\$\d+/, i = t.match(n);
                                    if (i && i.length) {
                                        const e = i[0];
                                        s.pageSetup.printTitlesRow = e.replace(r, "");
                                    }
                                    const o = /\$[A-Z]+:\$[A-Z]+/, a = t.match(o);
                                    if (a && a.length) {
                                        const e = a[0];
                                        s.pageSetup.printTitlesColumn = e.replace(r, "");
                                    }
                                }
                            } else a.push(e);
                        }), e.definedNames = a, e.media.forEach((e, t)=>{
                            e.index = t;
                        });
                    }
                }
                p.WORKBOOK_ATTRIBUTES = {
                    xmlns: "http://schemas.openxmlformats.org/spreadsheetml/2006/main",
                    "xmlns:r": "http://schemas.openxmlformats.org/officeDocument/2006/relationships",
                    "xmlns:mc": "http://schemas.openxmlformats.org/markup-compatibility/2006",
                    "mc:Ignorable": "x15",
                    "xmlns:x15": "http://schemas.microsoft.com/office/spreadsheetml/2010/11/main"
                }, p.STATIC_XFORMS = {
                    fileVersion: new a({
                        tag: "fileVersion",
                        $: {
                            appName: "xl",
                            lastEdited: 5,
                            lowestEdited: 5,
                            rupBuild: 9303
                        }
                    })
                }, t.exports = p;
            },
            {
                "../../../utils/col-cache": 19,
                "../../../utils/under-dash": 26,
                "../../../utils/xml-stream": 28,
                "../base-xform": 32,
                "../list-xform": 71,
                "../static-xform": 120,
                "./defined-name-xform": 33,
                "./sheet-xform": 34,
                "./workbook-calc-properties-xform": 35,
                "./workbook-properties-xform": 36,
                "./workbook-view-xform": 37
            }
        ],
        39: [
            function(e, t, r) {
                "use strict";
                const n = e("../strings/rich-text-xform"), i = e("../../../utils/utils"), s = e("../base-xform"), o = t.exports = function(e) {
                    this.model = e;
                };
                i.inherits(o, s, {
                    get tag () {
                        return "r";
                    },
                    get richTextXform () {
                        return this._richTextXform || (this._richTextXform = new n), this._richTextXform;
                    },
                    render (e, t) {
                        t = t || this.model, e.openNode("comment", {
                            ref: t.ref,
                            authorId: 0
                        }), e.openNode("text"), t && t.note && t.note.texts && t.note.texts.forEach((t)=>{
                            this.richTextXform.render(e, t);
                        }), e.closeNode(), e.closeNode();
                    },
                    parseOpen (e) {
                        if (this.parser) return this.parser.parseOpen(e), !0;
                        switch(e.name){
                            case "comment":
                                return this.model = {
                                    type: "note",
                                    note: {
                                        texts: []
                                    },
                                    ...e.attributes
                                }, !0;
                            case "r":
                                return this.parser = this.richTextXform, this.parser.parseOpen(e), !0;
                            default:
                                return !1;
                        }
                    },
                    parseText (e) {
                        this.parser && this.parser.parseText(e);
                    },
                    parseClose (e) {
                        switch(e){
                            case "comment":
                                return !1;
                            case "r":
                                return this.model.note.texts.push(this.parser.model), this.parser = void 0, !0;
                            default:
                                return this.parser && this.parser.parseClose(e), !0;
                        }
                    }
                });
            },
            {
                "../../../utils/utils": 27,
                "../base-xform": 32,
                "../strings/rich-text-xform": 122
            }
        ],
        40: [
            function(e, t, r) {
                "use strict";
                const n = e("../../../utils/xml-stream"), i = e("../../../utils/utils"), s = e("../base-xform"), o = e("./comment-xform"), a = t.exports = function() {
                    this.map = {
                        comment: new o
                    };
                };
                i.inherits(a, s, {
                    COMMENTS_ATTRIBUTES: {
                        xmlns: "http://schemas.openxmlformats.org/spreadsheetml/2006/main"
                    }
                }, {
                    render (e, t) {
                        t = t || this.model, e.openXml(n.StdDocAttributes), e.openNode("comments", a.COMMENTS_ATTRIBUTES), e.openNode("authors"), e.leafNode("author", null, "Author"), e.closeNode(), e.openNode("commentList"), t.comments.forEach((t)=>{
                            this.map.comment.render(e, t);
                        }), e.closeNode(), e.closeNode();
                    },
                    parseOpen (e) {
                        if (this.parser) return this.parser.parseOpen(e), !0;
                        switch(e.name){
                            case "commentList":
                                return this.model = {
                                    comments: []
                                }, !0;
                            case "comment":
                                return this.parser = this.map.comment, this.parser.parseOpen(e), !0;
                            default:
                                return !1;
                        }
                    },
                    parseText (e) {
                        this.parser && this.parser.parseText(e);
                    },
                    parseClose (e) {
                        switch(e){
                            case "commentList":
                                return !1;
                            case "comment":
                                return this.model.comments.push(this.parser.model), this.parser = void 0, !0;
                            default:
                                return this.parser && this.parser.parseClose(e), !0;
                        }
                    }
                });
            },
            {
                "../../../utils/utils": 27,
                "../../../utils/xml-stream": 28,
                "../base-xform": 32,
                "./comment-xform": 39
            }
        ],
        41: [
            function(e, t, r) {
                "use strict";
                const n = e("../../base-xform");
                t.exports = class extends n {
                    constructor(e){
                        super(), this._model = e;
                    }
                    get tag() {
                        return this._model && this._model.tag;
                    }
                    render(e, t, r) {
                        (t === r[2] || "x:SizeWithCells" === this.tag && t === r[1]) && e.leafNode(this.tag);
                    }
                    parseOpen(e) {
                        switch(e.name){
                            case this.tag:
                                return this.model = {}, this.model[this.tag] = !0, !0;
                            default:
                                return !1;
                        }
                    }
                    parseText() {}
                    parseClose() {
                        return !1;
                    }
                };
            },
            {
                "../../base-xform": 32
            }
        ],
        42: [
            function(e, t, r) {
                "use strict";
                const n = e("../../base-xform");
                t.exports = class extends n {
                    constructor(e){
                        super(), this._model = e;
                    }
                    get tag() {
                        return this._model && this._model.tag;
                    }
                    render(e, t) {
                        e.leafNode(this.tag, null, t);
                    }
                    parseOpen(e) {
                        switch(e.name){
                            case this.tag:
                                return this.text = "", !0;
                            default:
                                return !1;
                        }
                    }
                    parseText(e) {
                        this.text = e;
                    }
                    parseClose() {
                        return !1;
                    }
                };
            },
            {
                "../../base-xform": 32
            }
        ],
        43: [
            function(e, t, r) {
                "use strict";
                const n = e("../base-xform");
                t.exports = class extends n {
                    get tag() {
                        return "x:Anchor";
                    }
                    getAnchorRect(e) {
                        const t = Math.floor(e.left), r = Math.floor(68 * (e.left - t)), n = Math.floor(e.top), i = Math.floor(18 * (e.top - n)), s = Math.floor(e.right), o = Math.floor(68 * (e.right - s)), a = Math.floor(e.bottom);
                        return [
                            t,
                            r,
                            n,
                            i,
                            s,
                            o,
                            a,
                            Math.floor(18 * (e.bottom - a))
                        ];
                    }
                    getDefaultRect(e) {
                        const t = e.col, r = Math.max(e.row - 2, 0);
                        return [
                            t,
                            6,
                            r,
                            14,
                            t + 2,
                            2,
                            r + 4,
                            16
                        ];
                    }
                    render(e, t) {
                        const r = t.anchor ? this.getAnchorRect(t.anchor) : this.getDefaultRect(t.refAddress);
                        e.leafNode("x:Anchor", null, r.join(", "));
                    }
                    parseOpen(e) {
                        switch(e.name){
                            case this.tag:
                                return this.text = "", !0;
                            default:
                                return !1;
                        }
                    }
                    parseText(e) {
                        this.text = e;
                    }
                    parseClose() {
                        return !1;
                    }
                };
            },
            {
                "../base-xform": 32
            }
        ],
        44: [
            function(e, t, r) {
                "use strict";
                const n = e("../base-xform"), i = e("./vml-anchor-xform"), s = e("./style/vml-protection-xform"), o = e("./style/vml-position-xform"), a = [
                    "twoCells",
                    "oneCells",
                    "absolute"
                ];
                t.exports = class extends n {
                    constructor(){
                        super(), this.map = {
                            "x:Anchor": new i,
                            "x:Locked": new s({
                                tag: "x:Locked"
                            }),
                            "x:LockText": new s({
                                tag: "x:LockText"
                            }),
                            "x:SizeWithCells": new o({
                                tag: "x:SizeWithCells"
                            }),
                            "x:MoveWithCells": new o({
                                tag: "x:MoveWithCells"
                            })
                        };
                    }
                    get tag() {
                        return "x:ClientData";
                    }
                    render(e, t) {
                        const { protection: r, editAs: n } = t.note;
                        e.openNode(this.tag, {
                            ObjectType: "Note"
                        }), this.map["x:MoveWithCells"].render(e, n, a), this.map["x:SizeWithCells"].render(e, n, a), this.map["x:Anchor"].render(e, t), this.map["x:Locked"].render(e, r.locked), e.leafNode("x:AutoFill", null, "False"), this.map["x:LockText"].render(e, r.lockText), e.leafNode("x:Row", null, t.refAddress.row - 1), e.leafNode("x:Column", null, t.refAddress.col - 1), e.closeNode();
                    }
                    parseOpen(e) {
                        switch(e.name){
                            case this.tag:
                                this.reset(), this.model = {
                                    anchor: [],
                                    protection: {},
                                    editAs: ""
                                };
                                break;
                            default:
                                this.parser = this.map[e.name], this.parser && this.parser.parseOpen(e);
                        }
                        return !0;
                    }
                    parseText(e) {
                        this.parser && this.parser.parseText(e);
                    }
                    parseClose(e) {
                        if (this.parser) return this.parser.parseClose(e) || (this.parser = void 0), !0;
                        switch(e){
                            case this.tag:
                                return this.normalizeModel(), !1;
                            default:
                                return !0;
                        }
                    }
                    normalizeModel() {
                        const e = Object.assign({}, this.map["x:MoveWithCells"].model, this.map["x:SizeWithCells"].model), t = Object.keys(e).length;
                        this.model.editAs = a[t], this.model.anchor = this.map["x:Anchor"].text, this.model.protection.locked = this.map["x:Locked"].text, this.model.protection.lockText = this.map["x:LockText"].text;
                    }
                };
            },
            {
                "../base-xform": 32,
                "./style/vml-position-xform": 41,
                "./style/vml-protection-xform": 42,
                "./vml-anchor-xform": 43
            }
        ],
        45: [
            function(e, t, r) {
                "use strict";
                const n = e("../../../utils/xml-stream"), i = e("../base-xform"), s = e("./vml-shape-xform");
                class o extends i {
                    constructor(){
                        super(), this.map = {
                            "v:shape": new s
                        };
                    }
                    get tag() {
                        return "xml";
                    }
                    render(e, t) {
                        e.openXml(n.StdDocAttributes), e.openNode(this.tag, o.DRAWING_ATTRIBUTES), e.openNode("o:shapelayout", {
                            "v:ext": "edit"
                        }), e.leafNode("o:idmap", {
                            "v:ext": "edit",
                            data: 1
                        }), e.closeNode(), e.openNode("v:shapetype", {
                            id: "_x0000_t202",
                            coordsize: "21600,21600",
                            "o:spt": 202,
                            path: "m,l,21600r21600,l21600,xe"
                        }), e.leafNode("v:stroke", {
                            joinstyle: "miter"
                        }), e.leafNode("v:path", {
                            gradientshapeok: "t",
                            "o:connecttype": "rect"
                        }), e.closeNode(), t.comments.forEach((t, r)=>{
                            this.map["v:shape"].render(e, t, r);
                        }), e.closeNode();
                    }
                    parseOpen(e) {
                        if (this.parser) return this.parser.parseOpen(e), !0;
                        switch(e.name){
                            case this.tag:
                                this.reset(), this.model = {
                                    comments: []
                                };
                                break;
                            default:
                                this.parser = this.map[e.name], this.parser && this.parser.parseOpen(e);
                        }
                        return !0;
                    }
                    parseText(e) {
                        this.parser && this.parser.parseText(e);
                    }
                    parseClose(e) {
                        if (this.parser) return this.parser.parseClose(e) || (this.model.comments.push(this.parser.model), this.parser = void 0), !0;
                        switch(e){
                            case this.tag:
                                return !1;
                            default:
                                return !0;
                        }
                    }
                    reconcile(e, t) {
                        e.anchors.forEach((e)=>{
                            e.br ? this.map["xdr:twoCellAnchor"].reconcile(e, t) : this.map["xdr:oneCellAnchor"].reconcile(e, t);
                        });
                    }
                }
                o.DRAWING_ATTRIBUTES = {
                    "xmlns:v": "urn:schemas-microsoft-com:vml",
                    "xmlns:o": "urn:schemas-microsoft-com:office:office",
                    "xmlns:x": "urn:schemas-microsoft-com:office:excel"
                }, t.exports = o;
            },
            {
                "../../../utils/xml-stream": 28,
                "../base-xform": 32,
                "./vml-shape-xform": 46
            }
        ],
        46: [
            function(e, t, r) {
                "use strict";
                const n = e("../base-xform"), i = e("./vml-textbox-xform"), s = e("./vml-client-data-xform");
                class o extends n {
                    constructor(){
                        super(), this.map = {
                            "v:textbox": new i,
                            "x:ClientData": new s
                        };
                    }
                    get tag() {
                        return "v:shape";
                    }
                    render(e, t, r) {
                        e.openNode("v:shape", o.V_SHAPE_ATTRIBUTES(t, r)), e.leafNode("v:fill", {
                            color2: "infoBackground [80]"
                        }), e.leafNode("v:shadow", {
                            color: "none [81]",
                            obscured: "t"
                        }), e.leafNode("v:path", {
                            "o:connecttype": "none"
                        }), this.map["v:textbox"].render(e, t), this.map["x:ClientData"].render(e, t), e.closeNode();
                    }
                    parseOpen(e) {
                        if (this.parser) return this.parser.parseOpen(e), !0;
                        switch(e.name){
                            case this.tag:
                                this.reset(), this.model = {
                                    margins: {
                                        insetmode: e.attributes["o:insetmode"]
                                    },
                                    anchor: "",
                                    editAs: "",
                                    protection: {}
                                };
                                break;
                            default:
                                this.parser = this.map[e.name], this.parser && this.parser.parseOpen(e);
                        }
                        return !0;
                    }
                    parseText(e) {
                        this.parser && this.parser.parseText(e);
                    }
                    parseClose(e) {
                        if (this.parser) return this.parser.parseClose(e) || (this.parser = void 0), !0;
                        switch(e){
                            case this.tag:
                                return this.model.margins.inset = this.map["v:textbox"].model && this.map["v:textbox"].model.inset, this.model.protection = this.map["x:ClientData"].model && this.map["x:ClientData"].model.protection, this.model.anchor = this.map["x:ClientData"].model && this.map["x:ClientData"].model.anchor, this.model.editAs = this.map["x:ClientData"].model && this.map["x:ClientData"].model.editAs, !1;
                            default:
                                return !0;
                        }
                    }
                }
                o.V_SHAPE_ATTRIBUTES = (e, t)=>({
                        id: "_x0000_s" + (1025 + t),
                        type: "#_x0000_t202",
                        style: "position:absolute; margin-left:105.3pt;margin-top:10.5pt;width:97.8pt;height:59.1pt;z-index:1;visibility:hidden",
                        fillcolor: "infoBackground [80]",
                        strokecolor: "none [81]",
                        "o:insetmode": e.note.margins && e.note.margins.insetmode
                    }), t.exports = o;
            },
            {
                "../base-xform": 32,
                "./vml-client-data-xform": 44,
                "./vml-textbox-xform": 47
            }
        ],
        47: [
            function(e, t, r) {
                "use strict";
                const n = e("../base-xform");
                t.exports = class extends n {
                    get tag() {
                        return "v:textbox";
                    }
                    conversionUnit(e, t, r) {
                        return `${parseFloat(e) * t.toFixed(2)}${r}`;
                    }
                    reverseConversionUnit(e) {
                        return (e || "").split(",").map((e)=>Number(parseFloat(this.conversionUnit(parseFloat(e), .1, "")).toFixed(2)));
                    }
                    render(e, t) {
                        const r = {
                            style: "mso-direction-alt:auto"
                        };
                        if (t && t.note) {
                            let { inset: e } = t.note && t.note.margins;
                            Array.isArray(e) && (e = e.map((e)=>this.conversionUnit(e, 10, "mm")).join(",")), e && (r.inset = e);
                        }
                        e.openNode("v:textbox", r), e.leafNode("div", {
                            style: "text-align:left"
                        }), e.closeNode();
                    }
                    parseOpen(e) {
                        switch(e.name){
                            case this.tag:
                                return this.model = {
                                    inset: this.reverseConversionUnit(e.attributes.inset)
                                }, !0;
                            default:
                                return !0;
                        }
                    }
                    parseText() {}
                    parseClose(e) {
                        switch(e){
                            case this.tag:
                                return !1;
                            default:
                                return !0;
                        }
                    }
                };
            },
            {
                "../base-xform": 32
            }
        ],
        48: [
            function(e, t, r) {
                "use strict";
                const n = e("./base-xform");
                t.exports = class extends n {
                    createNewModel(e) {
                        return {};
                    }
                    parseOpen(e) {
                        return this.parser = this.parser || this.map[e.name], this.parser ? (this.parser.parseOpen(e), !0) : e.name === this.tag && (this.model = this.createNewModel(e), !0);
                    }
                    parseText(e) {
                        this.parser && this.parser.parseText(e);
                    }
                    onParserClose(e, t) {
                        this.model[e] = t.model;
                    }
                    parseClose(e) {
                        return this.parser ? (this.parser.parseClose(e) || (this.onParserClose(e, this.parser), this.parser = void 0), !0) : e !== this.tag;
                    }
                };
            },
            {
                "./base-xform": 32
            }
        ],
        49: [
            function(e, t, r) {
                "use strict";
                const n = e("../base-xform");
                t.exports = class extends n {
                    render(e, t) {
                        e.openNode("HeadingPairs"), e.openNode("vt:vector", {
                            size: 2,
                            baseType: "variant"
                        }), e.openNode("vt:variant"), e.leafNode("vt:lpstr", void 0, "Worksheets"), e.closeNode(), e.openNode("vt:variant"), e.leafNode("vt:i4", void 0, t.length), e.closeNode(), e.closeNode(), e.closeNode();
                    }
                    parseOpen(e) {
                        return "HeadingPairs" === e.name;
                    }
                    parseText() {}
                    parseClose(e) {
                        return "HeadingPairs" !== e;
                    }
                };
            },
            {
                "../base-xform": 32
            }
        ],
        50: [
            function(e, t, r) {
                "use strict";
                const n = e("../base-xform");
                t.exports = class extends n {
                    render(e, t) {
                        e.openNode("TitlesOfParts"), e.openNode("vt:vector", {
                            size: t.length,
                            baseType: "lpstr"
                        }), t.forEach((t)=>{
                            e.leafNode("vt:lpstr", void 0, t.name);
                        }), e.closeNode(), e.closeNode();
                    }
                    parseOpen(e) {
                        return "TitlesOfParts" === e.name;
                    }
                    parseText() {}
                    parseClose(e) {
                        return "TitlesOfParts" !== e;
                    }
                };
            },
            {
                "../base-xform": 32
            }
        ],
        51: [
            function(e, t, r) {
                "use strict";
                const n = e("../../../utils/xml-stream"), i = e("../base-xform"), s = e("../simple/string-xform"), o = e("./app-heading-pairs-xform"), a = e("./app-titles-of-parts-xform");
                class l extends i {
                    constructor(){
                        super(), this.map = {
                            Company: new s({
                                tag: "Company"
                            }),
                            Manager: new s({
                                tag: "Manager"
                            }),
                            HeadingPairs: new o,
                            TitleOfParts: new a
                        };
                    }
                    render(e, t) {
                        e.openXml(n.StdDocAttributes), e.openNode("Properties", l.PROPERTY_ATTRIBUTES), e.leafNode("Application", void 0, "Microsoft Excel"), e.leafNode("DocSecurity", void 0, "0"), e.leafNode("ScaleCrop", void 0, "false"), this.map.HeadingPairs.render(e, t.worksheets), this.map.TitleOfParts.render(e, t.worksheets), this.map.Company.render(e, t.company || ""), this.map.Manager.render(e, t.manager), e.leafNode("LinksUpToDate", void 0, "false"), e.leafNode("SharedDoc", void 0, "false"), e.leafNode("HyperlinksChanged", void 0, "false"), e.leafNode("AppVersion", void 0, "16.0300"), e.closeNode();
                    }
                    parseOpen(e) {
                        if (this.parser) return this.parser.parseOpen(e), !0;
                        switch(e.name){
                            case "Properties":
                                return !0;
                            default:
                                return this.parser = this.map[e.name], !!this.parser && (this.parser.parseOpen(e), !0);
                        }
                    }
                    parseText(e) {
                        this.parser && this.parser.parseText(e);
                    }
                    parseClose(e) {
                        if (this.parser) return this.parser.parseClose(e) || (this.parser = void 0), !0;
                        switch(e){
                            case "Properties":
                                return this.model = {
                                    worksheets: this.map.TitleOfParts.model,
                                    company: this.map.Company.model,
                                    manager: this.map.Manager.model
                                }, !1;
                            default:
                                return !0;
                        }
                    }
                }
                l.DateFormat = function(e) {
                    return e.toISOString().replace(/[.]\d{3,6}/, "");
                }, l.DateAttrs = {
                    "xsi:type": "dcterms:W3CDTF"
                }, l.PROPERTY_ATTRIBUTES = {
                    xmlns: "http://schemas.openxmlformats.org/officeDocument/2006/extended-properties",
                    "xmlns:vt": "http://schemas.openxmlformats.org/officeDocument/2006/docPropsVTypes"
                }, t.exports = l;
            },
            {
                "../../../utils/xml-stream": 28,
                "../base-xform": 32,
                "../simple/string-xform": 119,
                "./app-heading-pairs-xform": 49,
                "./app-titles-of-parts-xform": 50
            }
        ],
        52: [
            function(e, t, r) {
                "use strict";
                const n = e("../../../utils/xml-stream"), i = e("../base-xform");
                class s extends i {
                    render(e, t) {
                        e.openXml(n.StdDocAttributes), e.openNode("Types", s.PROPERTY_ATTRIBUTES);
                        const r = {};
                        (t.media || []).forEach((t)=>{
                            if ("image" === t.type) {
                                const n = t.extension;
                                r[n] || (r[n] = !0, e.leafNode("Default", {
                                    Extension: n,
                                    ContentType: "image/" + n
                                }));
                            }
                        }), e.leafNode("Default", {
                            Extension: "rels",
                            ContentType: "application/vnd.openxmlformats-package.relationships+xml"
                        }), e.leafNode("Default", {
                            Extension: "xml",
                            ContentType: "application/xml"
                        }), e.leafNode("Override", {
                            PartName: "/xl/workbook.xml",
                            ContentType: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet.main+xml"
                        }), t.worksheets.forEach((t)=>{
                            const r = `/xl/worksheets/sheet${t.id}.xml`;
                            e.leafNode("Override", {
                                PartName: r,
                                ContentType: "application/vnd.openxmlformats-officedocument.spreadsheetml.worksheet+xml"
                            });
                        }), e.leafNode("Override", {
                            PartName: "/xl/theme/theme1.xml",
                            ContentType: "application/vnd.openxmlformats-officedocument.theme+xml"
                        }), e.leafNode("Override", {
                            PartName: "/xl/styles.xml",
                            ContentType: "application/vnd.openxmlformats-officedocument.spreadsheetml.styles+xml"
                        });
                        t.sharedStrings && t.sharedStrings.count && e.leafNode("Override", {
                            PartName: "/xl/sharedStrings.xml",
                            ContentType: "application/vnd.openxmlformats-officedocument.spreadsheetml.sharedStrings+xml"
                        }), t.tables && t.tables.forEach((t)=>{
                            e.leafNode("Override", {
                                PartName: "/xl/tables/" + t.target,
                                ContentType: "application/vnd.openxmlformats-officedocument.spreadsheetml.table+xml"
                            });
                        }), t.drawings && t.drawings.forEach((t)=>{
                            e.leafNode("Override", {
                                PartName: `/xl/drawings/${t.name}.xml`,
                                ContentType: "application/vnd.openxmlformats-officedocument.drawing+xml"
                            });
                        }), t.commentRefs && (e.leafNode("Default", {
                            Extension: "vml",
                            ContentType: "application/vnd.openxmlformats-officedocument.vmlDrawing"
                        }), t.commentRefs.forEach((t)=>{
                            let { commentName: r } = t;
                            e.leafNode("Override", {
                                PartName: `/xl/${r}.xml`,
                                ContentType: "application/vnd.openxmlformats-officedocument.spreadsheetml.comments+xml"
                            });
                        })), e.leafNode("Override", {
                            PartName: "/docProps/core.xml",
                            ContentType: "application/vnd.openxmlformats-package.core-properties+xml"
                        }), e.leafNode("Override", {
                            PartName: "/docProps/app.xml",
                            ContentType: "application/vnd.openxmlformats-officedocument.extended-properties+xml"
                        }), e.closeNode();
                    }
                    parseOpen() {
                        return !1;
                    }
                    parseText() {}
                    parseClose() {
                        return !1;
                    }
                }
                s.PROPERTY_ATTRIBUTES = {
                    xmlns: "http://schemas.openxmlformats.org/package/2006/content-types"
                }, t.exports = s;
            },
            {
                "../../../utils/xml-stream": 28,
                "../base-xform": 32
            }
        ],
        53: [
            function(e, t, r) {
                "use strict";
                const n = e("../../../utils/xml-stream"), i = e("../base-xform"), s = e("../simple/date-xform"), o = e("../simple/string-xform"), a = e("../simple/integer-xform");
                class l extends i {
                    constructor(){
                        super(), this.map = {
                            "dc:creator": new o({
                                tag: "dc:creator"
                            }),
                            "dc:title": new o({
                                tag: "dc:title"
                            }),
                            "dc:subject": new o({
                                tag: "dc:subject"
                            }),
                            "dc:description": new o({
                                tag: "dc:description"
                            }),
                            "dc:identifier": new o({
                                tag: "dc:identifier"
                            }),
                            "dc:language": new o({
                                tag: "dc:language"
                            }),
                            "cp:keywords": new o({
                                tag: "cp:keywords"
                            }),
                            "cp:category": new o({
                                tag: "cp:category"
                            }),
                            "cp:lastModifiedBy": new o({
                                tag: "cp:lastModifiedBy"
                            }),
                            "cp:lastPrinted": new s({
                                tag: "cp:lastPrinted",
                                format: l.DateFormat
                            }),
                            "cp:revision": new a({
                                tag: "cp:revision"
                            }),
                            "cp:version": new o({
                                tag: "cp:version"
                            }),
                            "cp:contentStatus": new o({
                                tag: "cp:contentStatus"
                            }),
                            "cp:contentType": new o({
                                tag: "cp:contentType"
                            }),
                            "dcterms:created": new s({
                                tag: "dcterms:created",
                                attrs: l.DateAttrs,
                                format: l.DateFormat
                            }),
                            "dcterms:modified": new s({
                                tag: "dcterms:modified",
                                attrs: l.DateAttrs,
                                format: l.DateFormat
                            })
                        };
                    }
                    render(e, t) {
                        e.openXml(n.StdDocAttributes), e.openNode("cp:coreProperties", l.CORE_PROPERTY_ATTRIBUTES), this.map["dc:creator"].render(e, t.creator), this.map["dc:title"].render(e, t.title), this.map["dc:subject"].render(e, t.subject), this.map["dc:description"].render(e, t.description), this.map["dc:identifier"].render(e, t.identifier), this.map["dc:language"].render(e, t.language), this.map["cp:keywords"].render(e, t.keywords), this.map["cp:category"].render(e, t.category), this.map["cp:lastModifiedBy"].render(e, t.lastModifiedBy), this.map["cp:lastPrinted"].render(e, t.lastPrinted), this.map["cp:revision"].render(e, t.revision), this.map["cp:version"].render(e, t.version), this.map["cp:contentStatus"].render(e, t.contentStatus), this.map["cp:contentType"].render(e, t.contentType), this.map["dcterms:created"].render(e, t.created), this.map["dcterms:modified"].render(e, t.modified), e.closeNode();
                    }
                    parseOpen(e) {
                        if (this.parser) return this.parser.parseOpen(e), !0;
                        switch(e.name){
                            case "cp:coreProperties":
                            case "coreProperties":
                                return !0;
                            default:
                                if (this.parser = this.map[e.name], this.parser) return this.parser.parseOpen(e), !0;
                                throw new Error("Unexpected xml node in parseOpen: " + JSON.stringify(e));
                        }
                    }
                    parseText(e) {
                        this.parser && this.parser.parseText(e);
                    }
                    parseClose(e) {
                        if (this.parser) return this.parser.parseClose(e) || (this.parser = void 0), !0;
                        switch(e){
                            case "cp:coreProperties":
                            case "coreProperties":
                                return this.model = {
                                    creator: this.map["dc:creator"].model,
                                    title: this.map["dc:title"].model,
                                    subject: this.map["dc:subject"].model,
                                    description: this.map["dc:description"].model,
                                    identifier: this.map["dc:identifier"].model,
                                    language: this.map["dc:language"].model,
                                    keywords: this.map["cp:keywords"].model,
                                    category: this.map["cp:category"].model,
                                    lastModifiedBy: this.map["cp:lastModifiedBy"].model,
                                    lastPrinted: this.map["cp:lastPrinted"].model,
                                    revision: this.map["cp:revision"].model,
                                    contentStatus: this.map["cp:contentStatus"].model,
                                    contentType: this.map["cp:contentType"].model,
                                    created: this.map["dcterms:created"].model,
                                    modified: this.map["dcterms:modified"].model
                                }, !1;
                            default:
                                throw new Error("Unexpected xml node in parseClose: " + e);
                        }
                    }
                }
                l.DateFormat = function(e) {
                    return e.toISOString().replace(/[.]\d{3}/, "");
                }, l.DateAttrs = {
                    "xsi:type": "dcterms:W3CDTF"
                }, l.CORE_PROPERTY_ATTRIBUTES = {
                    "xmlns:cp": "http://schemas.openxmlformats.org/package/2006/metadata/core-properties",
                    "xmlns:dc": "http://purl.org/dc/elements/1.1/",
                    "xmlns:dcterms": "http://purl.org/dc/terms/",
                    "xmlns:dcmitype": "http://purl.org/dc/dcmitype/",
                    "xmlns:xsi": "http://www.w3.org/2001/XMLSchema-instance"
                }, t.exports = l;
            },
            {
                "../../../utils/xml-stream": 28,
                "../base-xform": 32,
                "../simple/date-xform": 117,
                "../simple/integer-xform": 118,
                "../simple/string-xform": 119
            }
        ],
        54: [
            function(e, t, r) {
                "use strict";
                const n = e("../base-xform");
                t.exports = class extends n {
                    render(e, t) {
                        e.leafNode("Relationship", t);
                    }
                    parseOpen(e) {
                        switch(e.name){
                            case "Relationship":
                                return this.model = e.attributes, !0;
                            default:
                                return !1;
                        }
                    }
                    parseText() {}
                    parseClose() {
                        return !1;
                    }
                };
            },
            {
                "../base-xform": 32
            }
        ],
        55: [
            function(e, t, r) {
                "use strict";
                const n = e("../../../utils/xml-stream"), i = e("../base-xform"), s = e("./relationship-xform");
                class o extends i {
                    constructor(){
                        super(), this.map = {
                            Relationship: new s
                        };
                    }
                    render(e, t) {
                        t = t || this._values, e.openXml(n.StdDocAttributes), e.openNode("Relationships", o.RELATIONSHIPS_ATTRIBUTES), t.forEach((t)=>{
                            this.map.Relationship.render(e, t);
                        }), e.closeNode();
                    }
                    parseOpen(e) {
                        if (this.parser) return this.parser.parseOpen(e), !0;
                        switch(e.name){
                            case "Relationships":
                                return this.model = [], !0;
                            default:
                                if (this.parser = this.map[e.name], this.parser) return this.parser.parseOpen(e), !0;
                                throw new Error("Unexpected xml node in parseOpen: " + JSON.stringify(e));
                        }
                    }
                    parseText(e) {
                        this.parser && this.parser.parseText(e);
                    }
                    parseClose(e) {
                        if (this.parser) return this.parser.parseClose(e) || (this.model.push(this.parser.model), this.parser = void 0), !0;
                        switch(e){
                            case "Relationships":
                                return !1;
                            default:
                                throw new Error("Unexpected xml node in parseClose: " + e);
                        }
                    }
                }
                o.RELATIONSHIPS_ATTRIBUTES = {
                    xmlns: "http://schemas.openxmlformats.org/package/2006/relationships"
                }, t.exports = o;
            },
            {
                "../../../utils/xml-stream": 28,
                "../base-xform": 32,
                "./relationship-xform": 54
            }
        ],
        56: [
            function(e, t, r) {
                "use strict";
                const n = e("../base-xform");
                t.exports = class extends n {
                    parseOpen(e) {
                        if (this.parser) return this.parser.parseOpen(e), !0;
                        switch(e.name){
                            case this.tag:
                                this.reset(), this.model = {
                                    range: {
                                        editAs: e.attributes.editAs || "oneCell"
                                    }
                                };
                                break;
                            default:
                                this.parser = this.map[e.name], this.parser && this.parser.parseOpen(e);
                        }
                        return !0;
                    }
                    parseText(e) {
                        this.parser && this.parser.parseText(e);
                    }
                    reconcilePicture(e, t) {
                        if (e && e.rId) {
                            const r = t.rels[e.rId].Target.match(/.*\/media\/(.+[.][a-zA-Z]{3,4})/);
                            if (r) {
                                const e = r[1], n = t.mediaIndex[e];
                                return t.media[n];
                            }
                        }
                    }
                };
            },
            {
                "../base-xform": 32
            }
        ],
        57: [
            function(e, t, r) {
                "use strict";
                const n = e("../base-xform"), i = e("./blip-xform");
                t.exports = class extends n {
                    constructor(){
                        super(), this.map = {
                            "a:blip": new i
                        };
                    }
                    get tag() {
                        return "xdr:blipFill";
                    }
                    render(e, t) {
                        e.openNode(this.tag), this.map["a:blip"].render(e, t), e.openNode("a:stretch"), e.leafNode("a:fillRect"), e.closeNode(), e.closeNode();
                    }
                    parseOpen(e) {
                        if (this.parser) return this.parser.parseOpen(e), !0;
                        switch(e.name){
                            case this.tag:
                                this.reset();
                                break;
                            default:
                                this.parser = this.map[e.name], this.parser && this.parser.parseOpen(e);
                        }
                        return !0;
                    }
                    parseText() {}
                    parseClose(e) {
                        if (this.parser) return this.parser.parseClose(e) || (this.parser = void 0), !0;
                        switch(e){
                            case this.tag:
                                return this.model = this.map["a:blip"].model, !1;
                            default:
                                return !0;
                        }
                    }
                };
            },
            {
                "../base-xform": 32,
                "./blip-xform": 58
            }
        ],
        58: [
            function(e, t, r) {
                "use strict";
                const n = e("../base-xform");
                t.exports = class extends n {
                    get tag() {
                        return "a:blip";
                    }
                    render(e, t) {
                        e.leafNode(this.tag, {
                            "xmlns:r": "http://schemas.openxmlformats.org/officeDocument/2006/relationships",
                            "r:embed": t.rId,
                            cstate: "print"
                        });
                    }
                    parseOpen(e) {
                        switch(e.name){
                            case this.tag:
                                return this.model = {
                                    rId: e.attributes["r:embed"]
                                }, !0;
                            default:
                                return !0;
                        }
                    }
                    parseText() {}
                    parseClose(e) {
                        switch(e){
                            case this.tag:
                                return !1;
                            default:
                                return !0;
                        }
                    }
                };
            },
            {
                "../base-xform": 32
            }
        ],
        59: [
            function(e, t, r) {
                "use strict";
                const n = e("../base-xform");
                t.exports = class extends n {
                    get tag() {
                        return "xdr:cNvPicPr";
                    }
                    render(e) {
                        e.openNode(this.tag), e.leafNode("a:picLocks", {
                            noChangeAspect: "1"
                        }), e.closeNode();
                    }
                    parseOpen(e) {
                        switch(e.name){
                            case this.tag:
                            default:
                                return !0;
                        }
                    }
                    parseText() {}
                    parseClose(e) {
                        switch(e){
                            case this.tag:
                                return !1;
                            default:
                                return !0;
                        }
                    }
                };
            },
            {
                "../base-xform": 32
            }
        ],
        60: [
            function(e, t, r) {
                "use strict";
                const n = e("../base-xform"), i = e("./hlink-click-xform"), s = e("./ext-lst-xform");
                t.exports = class extends n {
                    constructor(){
                        super(), this.map = {
                            "a:hlinkClick": new i,
                            "a:extLst": new s
                        };
                    }
                    get tag() {
                        return "xdr:cNvPr";
                    }
                    render(e, t) {
                        e.openNode(this.tag, {
                            id: t.index,
                            name: "Picture " + t.index
                        }), this.map["a:hlinkClick"].render(e, t), this.map["a:extLst"].render(e, t), e.closeNode();
                    }
                    parseOpen(e) {
                        if (this.parser) return this.parser.parseOpen(e), !0;
                        switch(e.name){
                            case this.tag:
                                this.reset();
                                break;
                            default:
                                this.parser = this.map[e.name], this.parser && this.parser.parseOpen(e);
                        }
                        return !0;
                    }
                    parseText() {}
                    parseClose(e) {
                        if (this.parser) return this.parser.parseClose(e) || (this.parser = void 0), !0;
                        switch(e){
                            case this.tag:
                                return this.model = this.map["a:hlinkClick"].model, !1;
                            default:
                                return !0;
                        }
                    }
                };
            },
            {
                "../base-xform": 32,
                "./ext-lst-xform": 63,
                "./hlink-click-xform": 65
            }
        ],
        61: [
            function(e, t, r) {
                "use strict";
                const n = e("../base-xform"), i = e("../simple/integer-xform");
                t.exports = class extends n {
                    constructor(e){
                        super(), this.tag = e.tag, this.map = {
                            "xdr:col": new i({
                                tag: "xdr:col",
                                zero: !0
                            }),
                            "xdr:colOff": new i({
                                tag: "xdr:colOff",
                                zero: !0
                            }),
                            "xdr:row": new i({
                                tag: "xdr:row",
                                zero: !0
                            }),
                            "xdr:rowOff": new i({
                                tag: "xdr:rowOff",
                                zero: !0
                            })
                        };
                    }
                    render(e, t) {
                        e.openNode(this.tag), this.map["xdr:col"].render(e, t.nativeCol), this.map["xdr:colOff"].render(e, t.nativeColOff), this.map["xdr:row"].render(e, t.nativeRow), this.map["xdr:rowOff"].render(e, t.nativeRowOff), e.closeNode();
                    }
                    parseOpen(e) {
                        if (this.parser) return this.parser.parseOpen(e), !0;
                        switch(e.name){
                            case this.tag:
                                this.reset();
                                break;
                            default:
                                this.parser = this.map[e.name], this.parser && this.parser.parseOpen(e);
                        }
                        return !0;
                    }
                    parseText(e) {
                        this.parser && this.parser.parseText(e);
                    }
                    parseClose(e) {
                        if (this.parser) return this.parser.parseClose(e) || (this.parser = void 0), !0;
                        switch(e){
                            case this.tag:
                                return this.model = {
                                    nativeCol: this.map["xdr:col"].model,
                                    nativeColOff: this.map["xdr:colOff"].model,
                                    nativeRow: this.map["xdr:row"].model,
                                    nativeRowOff: this.map["xdr:rowOff"].model
                                }, !1;
                            default:
                                return !0;
                        }
                    }
                };
            },
            {
                "../base-xform": 32,
                "../simple/integer-xform": 118
            }
        ],
        62: [
            function(e, t, r) {
                "use strict";
                const n = e("../../../utils/col-cache"), i = e("../../../utils/xml-stream"), s = e("../base-xform"), o = e("./two-cell-anchor-xform"), a = e("./one-cell-anchor-xform");
                class l extends s {
                    constructor(){
                        super(), this.map = {
                            "xdr:twoCellAnchor": new o,
                            "xdr:oneCellAnchor": new a
                        };
                    }
                    prepare(e) {
                        e.anchors.forEach((e, t)=>{
                            e.anchorType = function(e) {
                                return ("string" == typeof e.range ? n.decode(e.range) : e.range).br ? "xdr:twoCellAnchor" : "xdr:oneCellAnchor";
                            }(e);
                            this.map[e.anchorType].prepare(e, {
                                index: t
                            });
                        });
                    }
                    get tag() {
                        return "xdr:wsDr";
                    }
                    render(e, t) {
                        e.openXml(i.StdDocAttributes), e.openNode(this.tag, l.DRAWING_ATTRIBUTES), t.anchors.forEach((t)=>{
                            this.map[t.anchorType].render(e, t);
                        }), e.closeNode();
                    }
                    parseOpen(e) {
                        if (this.parser) return this.parser.parseOpen(e), !0;
                        switch(e.name){
                            case this.tag:
                                this.reset(), this.model = {
                                    anchors: []
                                };
                                break;
                            default:
                                this.parser = this.map[e.name], this.parser && this.parser.parseOpen(e);
                        }
                        return !0;
                    }
                    parseText(e) {
                        this.parser && this.parser.parseText(e);
                    }
                    parseClose(e) {
                        if (this.parser) return this.parser.parseClose(e) || (this.model.anchors.push(this.parser.model), this.parser = void 0), !0;
                        switch(e){
                            case this.tag:
                                return !1;
                            default:
                                return !0;
                        }
                    }
                    reconcile(e, t) {
                        e.anchors.forEach((e)=>{
                            e.br ? this.map["xdr:twoCellAnchor"].reconcile(e, t) : this.map["xdr:oneCellAnchor"].reconcile(e, t);
                        });
                    }
                }
                l.DRAWING_ATTRIBUTES = {
                    "xmlns:xdr": "http://schemas.openxmlformats.org/drawingml/2006/spreadsheetDrawing",
                    "xmlns:a": "http://schemas.openxmlformats.org/drawingml/2006/main"
                }, t.exports = l;
            },
            {
                "../../../utils/col-cache": 19,
                "../../../utils/xml-stream": 28,
                "../base-xform": 32,
                "./one-cell-anchor-xform": 67,
                "./two-cell-anchor-xform": 70
            }
        ],
        63: [
            function(e, t, r) {
                "use strict";
                const n = e("../base-xform");
                t.exports = class extends n {
                    get tag() {
                        return "a:extLst";
                    }
                    render(e) {
                        e.openNode(this.tag), e.openNode("a:ext", {
                            uri: "{FF2B5EF4-FFF2-40B4-BE49-F238E27FC236}"
                        }), e.leafNode("a16:creationId", {
                            "xmlns:a16": "http://schemas.microsoft.com/office/drawing/2014/main",
                            id: "{00000000-0008-0000-0000-000002000000}"
                        }), e.closeNode(), e.closeNode();
                    }
                    parseOpen(e) {
                        switch(e.name){
                            case this.tag:
                            default:
                                return !0;
                        }
                    }
                    parseText() {}
                    parseClose(e) {
                        switch(e){
                            case this.tag:
                                return !1;
                            default:
                                return !0;
                        }
                    }
                };
            },
            {
                "../base-xform": 32
            }
        ],
        64: [
            function(e, t, r) {
                "use strict";
                const n = e("../base-xform");
                t.exports = class extends n {
                    constructor(e){
                        super(), this.tag = e.tag, this.map = {};
                    }
                    render(e, t) {
                        e.openNode(this.tag);
                        const r = Math.floor(9525 * t.width), n = Math.floor(9525 * t.height);
                        e.addAttribute("cx", r), e.addAttribute("cy", n), e.closeNode();
                    }
                    parseOpen(e) {
                        return e.name === this.tag && (this.model = {
                            width: parseInt(e.attributes.cx || "0", 10) / 9525,
                            height: parseInt(e.attributes.cy || "0", 10) / 9525
                        }, !0);
                    }
                    parseText() {}
                    parseClose() {
                        return !1;
                    }
                };
            },
            {
                "../base-xform": 32
            }
        ],
        65: [
            function(e, t, r) {
                "use strict";
                const n = e("../base-xform");
                t.exports = class extends n {
                    get tag() {
                        return "a:hlinkClick";
                    }
                    render(e, t) {
                        t.hyperlinks && t.hyperlinks.rId && e.leafNode(this.tag, {
                            "xmlns:r": "http://schemas.openxmlformats.org/officeDocument/2006/relationships",
                            "r:id": t.hyperlinks.rId,
                            tooltip: t.hyperlinks.tooltip
                        });
                    }
                    parseOpen(e) {
                        switch(e.name){
                            case this.tag:
                                return this.model = {
                                    hyperlinks: {
                                        rId: e.attributes["r:id"],
                                        tooltip: e.attributes.tooltip
                                    }
                                }, !0;
                            default:
                                return !0;
                        }
                    }
                    parseText() {}
                    parseClose() {
                        return !1;
                    }
                };
            },
            {
                "../base-xform": 32
            }
        ],
        66: [
            function(e, t, r) {
                "use strict";
                const n = e("../base-xform"), i = e("./c-nv-pr-xform"), s = e("./c-nv-pic-pr-xform");
                t.exports = class extends n {
                    constructor(){
                        super(), this.map = {
                            "xdr:cNvPr": new i,
                            "xdr:cNvPicPr": new s
                        };
                    }
                    get tag() {
                        return "xdr:nvPicPr";
                    }
                    render(e, t) {
                        e.openNode(this.tag), this.map["xdr:cNvPr"].render(e, t), this.map["xdr:cNvPicPr"].render(e, t), e.closeNode();
                    }
                    parseOpen(e) {
                        if (this.parser) return this.parser.parseOpen(e), !0;
                        switch(e.name){
                            case this.tag:
                                this.reset();
                                break;
                            default:
                                this.parser = this.map[e.name], this.parser && this.parser.parseOpen(e);
                        }
                        return !0;
                    }
                    parseText() {}
                    parseClose(e) {
                        if (this.parser) return this.parser.parseClose(e) || (this.parser = void 0), !0;
                        switch(e){
                            case this.tag:
                                return this.model = this.map["xdr:cNvPr"].model, !1;
                            default:
                                return !0;
                        }
                    }
                };
            },
            {
                "../base-xform": 32,
                "./c-nv-pic-pr-xform": 59,
                "./c-nv-pr-xform": 60
            }
        ],
        67: [
            function(e, t, r) {
                "use strict";
                const n = e("./base-cell-anchor-xform"), i = e("../static-xform"), s = e("./cell-position-xform"), o = e("./ext-xform"), a = e("./pic-xform");
                t.exports = class extends n {
                    constructor(){
                        super(), this.map = {
                            "xdr:from": new s({
                                tag: "xdr:from"
                            }),
                            "xdr:ext": new o({
                                tag: "xdr:ext"
                            }),
                            "xdr:pic": new a,
                            "xdr:clientData": new i({
                                tag: "xdr:clientData"
                            })
                        };
                    }
                    get tag() {
                        return "xdr:oneCellAnchor";
                    }
                    prepare(e, t) {
                        this.map["xdr:pic"].prepare(e.picture, t);
                    }
                    render(e, t) {
                        e.openNode(this.tag, {
                            editAs: t.range.editAs || "oneCell"
                        }), this.map["xdr:from"].render(e, t.range.tl), this.map["xdr:ext"].render(e, t.range.ext), this.map["xdr:pic"].render(e, t.picture), this.map["xdr:clientData"].render(e, {}), e.closeNode();
                    }
                    parseClose(e) {
                        if (this.parser) return this.parser.parseClose(e) || (this.parser = void 0), !0;
                        switch(e){
                            case this.tag:
                                return this.model.range.tl = this.map["xdr:from"].model, this.model.range.ext = this.map["xdr:ext"].model, this.model.picture = this.map["xdr:pic"].model, !1;
                            default:
                                return !0;
                        }
                    }
                    reconcile(e, t) {
                        e.medium = this.reconcilePicture(e.picture, t);
                    }
                };
            },
            {
                "../static-xform": 120,
                "./base-cell-anchor-xform": 56,
                "./cell-position-xform": 61,
                "./ext-xform": 64,
                "./pic-xform": 68
            }
        ],
        68: [
            function(e, t, r) {
                "use strict";
                const n = e("../base-xform"), i = e("../static-xform"), s = e("./blip-fill-xform"), o = e("./nv-pic-pr-xform"), a = e("./sp-pr");
                t.exports = class extends n {
                    constructor(){
                        super(), this.map = {
                            "xdr:nvPicPr": new o,
                            "xdr:blipFill": new s,
                            "xdr:spPr": new i(a)
                        };
                    }
                    get tag() {
                        return "xdr:pic";
                    }
                    prepare(e, t) {
                        e.index = t.index + 1;
                    }
                    render(e, t) {
                        e.openNode(this.tag), this.map["xdr:nvPicPr"].render(e, t), this.map["xdr:blipFill"].render(e, t), this.map["xdr:spPr"].render(e, t), e.closeNode();
                    }
                    parseOpen(e) {
                        if (this.parser) return this.parser.parseOpen(e), !0;
                        switch(e.name){
                            case this.tag:
                                this.reset();
                                break;
                            default:
                                this.parser = this.map[e.name], this.parser && this.parser.parseOpen(e);
                        }
                        return !0;
                    }
                    parseText() {}
                    parseClose(e) {
                        if (this.parser) return this.parser.parseClose(e) || (this.mergeModel(this.parser.model), this.parser = void 0), !0;
                        switch(e){
                            case this.tag:
                                return !1;
                            default:
                                return !0;
                        }
                    }
                };
            },
            {
                "../base-xform": 32,
                "../static-xform": 120,
                "./blip-fill-xform": 57,
                "./nv-pic-pr-xform": 66,
                "./sp-pr": 69
            }
        ],
        69: [
            function(e, t, r) {
                "use strict";
                t.exports = {
                    tag: "xdr:spPr",
                    c: [
                        {
                            tag: "a:xfrm",
                            c: [
                                {
                                    tag: "a:off",
                                    $: {
                                        x: "0",
                                        y: "0"
                                    }
                                },
                                {
                                    tag: "a:ext",
                                    $: {
                                        cx: "0",
                                        cy: "0"
                                    }
                                }
                            ]
                        },
                        {
                            tag: "a:prstGeom",
                            $: {
                                prst: "rect"
                            },
                            c: [
                                {
                                    tag: "a:avLst"
                                }
                            ]
                        }
                    ]
                };
            },
            {}
        ],
        70: [
            function(e, t, r) {
                "use strict";
                const n = e("./base-cell-anchor-xform"), i = e("../static-xform"), s = e("./cell-position-xform"), o = e("./pic-xform");
                t.exports = class extends n {
                    constructor(){
                        super(), this.map = {
                            "xdr:from": new s({
                                tag: "xdr:from"
                            }),
                            "xdr:to": new s({
                                tag: "xdr:to"
                            }),
                            "xdr:pic": new o,
                            "xdr:clientData": new i({
                                tag: "xdr:clientData"
                            })
                        };
                    }
                    get tag() {
                        return "xdr:twoCellAnchor";
                    }
                    prepare(e, t) {
                        this.map["xdr:pic"].prepare(e.picture, t);
                    }
                    render(e, t) {
                        e.openNode(this.tag, {
                            editAs: t.range.editAs || "oneCell"
                        }), this.map["xdr:from"].render(e, t.range.tl), this.map["xdr:to"].render(e, t.range.br), this.map["xdr:pic"].render(e, t.picture), this.map["xdr:clientData"].render(e, {}), e.closeNode();
                    }
                    parseClose(e) {
                        if (this.parser) return this.parser.parseClose(e) || (this.parser = void 0), !0;
                        switch(e){
                            case this.tag:
                                return this.model.range.tl = this.map["xdr:from"].model, this.model.range.br = this.map["xdr:to"].model, this.model.picture = this.map["xdr:pic"].model, !1;
                            default:
                                return !0;
                        }
                    }
                    reconcile(e, t) {
                        e.medium = this.reconcilePicture(e.picture, t);
                    }
                };
            },
            {
                "../static-xform": 120,
                "./base-cell-anchor-xform": 56,
                "./cell-position-xform": 61,
                "./pic-xform": 68
            }
        ],
        71: [
            function(e, t, r) {
                "use strict";
                const n = e("./base-xform");
                t.exports = class extends n {
                    constructor(e){
                        super(), this.tag = e.tag, this.always = !!e.always, this.count = e.count, this.empty = e.empty, this.$count = e.$count || "count", this.$ = e.$, this.childXform = e.childXform, this.maxItems = e.maxItems;
                    }
                    prepare(e, t) {
                        const { childXform: r } = this;
                        e && e.forEach((e, n)=>{
                            t.index = n, r.prepare(e, t);
                        });
                    }
                    render(e, t) {
                        if (this.always || t && t.length) {
                            e.openNode(this.tag, this.$), this.count && e.addAttribute(this.$count, t && t.length || 0);
                            const { childXform: r } = this;
                            (t || []).forEach((t, n)=>{
                                r.render(e, t, n);
                            }), e.closeNode();
                        } else this.empty && e.leafNode(this.tag);
                    }
                    parseOpen(e) {
                        if (this.parser) return this.parser.parseOpen(e), !0;
                        switch(e.name){
                            case this.tag:
                                return this.model = [], !0;
                            default:
                                return !!this.childXform.parseOpen(e) && (this.parser = this.childXform, !0);
                        }
                    }
                    parseText(e) {
                        this.parser && this.parser.parseText(e);
                    }
                    parseClose(e) {
                        if (this.parser) {
                            if (!this.parser.parseClose(e) && (this.model.push(this.parser.model), this.parser = void 0, this.maxItems && this.model.length > this.maxItems)) throw new Error(`Max ${this.childXform.tag} count (${this.maxItems}) exceeded`);
                            return !0;
                        }
                        return !1;
                    }
                    reconcile(e, t) {
                        if (e) {
                            const { childXform: r } = this;
                            e.forEach((e)=>{
                                r.reconcile(e, t);
                            });
                        }
                    }
                };
            },
            {
                "./base-xform": 32
            }
        ],
        72: [
            function(e, t, r) {
                "use strict";
                const n = e("../../../utils/col-cache"), i = e("../base-xform");
                t.exports = class extends i {
                    get tag() {
                        return "autoFilter";
                    }
                    render(e, t) {
                        if (t) {
                            if ("string" == typeof t) e.leafNode("autoFilter", {
                                ref: t
                            });
                            else {
                                const r = function(e) {
                                    return "string" == typeof e ? e : n.getAddress(e.row, e.column).address;
                                }, i = r(t.from), s = r(t.to);
                                i && s && e.leafNode("autoFilter", {
                                    ref: `${i}:${s}`
                                });
                            }
                        }
                    }
                    parseOpen(e) {
                        "autoFilter" === e.name && (this.model = e.attributes.ref);
                    }
                };
            },
            {
                "../../../utils/col-cache": 19,
                "../base-xform": 32
            }
        ],
        73: [
            function(e, t, r) {
                "use strict";
                const n = e("../../../utils/utils"), i = e("../base-xform"), s = e("../../../doc/range"), o = e("../../../doc/enums"), a = e("../strings/rich-text-xform");
                function l(e) {
                    if (null == e) return o.ValueType.Null;
                    if (e instanceof String || "string" == typeof e) return o.ValueType.String;
                    if ("number" == typeof e) return o.ValueType.Number;
                    if ("boolean" == typeof e) return o.ValueType.Boolean;
                    if (e instanceof Date) return o.ValueType.Date;
                    if (e.text && e.hyperlink) return o.ValueType.Hyperlink;
                    if (e.formula) return o.ValueType.Formula;
                    if (e.error) return o.ValueType.Error;
                    throw new Error("I could not understand type of value");
                }
                t.exports = class extends i {
                    constructor(){
                        super(), this.richTextXForm = new a;
                    }
                    get tag() {
                        return "c";
                    }
                    prepare(e, t) {
                        const r = t.styles.addStyleModel(e.style || {}, function(e) {
                            switch(e.type){
                                case o.ValueType.Formula:
                                    return l(e.result);
                                default:
                                    return e.type;
                            }
                        }(e));
                        switch(r && (e.styleId = r), e.comment && t.comments.push({
                            ...e.comment,
                            ref: e.address
                        }), e.type){
                            case o.ValueType.String:
                            case o.ValueType.RichText:
                                t.sharedStrings && (e.ssId = t.sharedStrings.add(e.value));
                                break;
                            case o.ValueType.Date:
                                t.date1904 && (e.date1904 = !0);
                                break;
                            case o.ValueType.Hyperlink:
                                t.sharedStrings && void 0 !== e.text && null !== e.text && (e.ssId = t.sharedStrings.add(e.text)), t.hyperlinks.push({
                                    address: e.address,
                                    target: e.hyperlink,
                                    tooltip: e.tooltip
                                });
                                break;
                            case o.ValueType.Merge:
                                t.merges.add(e);
                                break;
                            case o.ValueType.Formula:
                                if (t.date1904 && (e.date1904 = !0), "shared" === e.shareType && (e.si = t.siFormulae++), e.formula) t.formulae[e.address] = e;
                                else if (e.sharedFormula) {
                                    const r = t.formulae[e.sharedFormula];
                                    if (!r) throw new Error("Shared Formula master must exist above and or left of clone for cell " + e.address);
                                    void 0 === r.si ? (r.shareType = "shared", r.si = t.siFormulae++, r.range = new s(r.address, e.address)) : r.range && r.range.expandToAddress(e.address), e.si = r.si;
                                }
                        }
                    }
                    renderFormula(e, t) {
                        let r = null;
                        switch(t.shareType){
                            case "shared":
                                r = {
                                    t: "shared",
                                    ref: t.ref || t.range.range,
                                    si: t.si
                                };
                                break;
                            case "array":
                                r = {
                                    t: "array",
                                    ref: t.ref
                                };
                                break;
                            default:
                                void 0 !== t.si && (r = {
                                    t: "shared",
                                    si: t.si
                                });
                        }
                        switch(l(t.result)){
                            case o.ValueType.Null:
                                e.leafNode("f", r, t.formula);
                                break;
                            case o.ValueType.String:
                                e.addAttribute("t", "str"), e.leafNode("f", r, t.formula), e.leafNode("v", null, t.result);
                                break;
                            case o.ValueType.Number:
                                e.leafNode("f", r, t.formula), e.leafNode("v", null, t.result);
                                break;
                            case o.ValueType.Boolean:
                                e.addAttribute("t", "b"), e.leafNode("f", r, t.formula), e.leafNode("v", null, t.result ? 1 : 0);
                                break;
                            case o.ValueType.Error:
                                e.addAttribute("t", "e"), e.leafNode("f", r, t.formula), e.leafNode("v", null, t.result.error);
                                break;
                            case o.ValueType.Date:
                                e.leafNode("f", r, t.formula), e.leafNode("v", null, n.dateToExcel(t.result, t.date1904));
                                break;
                            default:
                                throw new Error("I could not understand type of value");
                        }
                    }
                    render(e, t) {
                        if (t.type !== o.ValueType.Null || t.styleId) {
                            switch(e.openNode("c"), e.addAttribute("r", t.address), t.styleId && e.addAttribute("s", t.styleId), t.type){
                                case o.ValueType.Null:
                                    break;
                                case o.ValueType.Number:
                                    e.leafNode("v", null, t.value);
                                    break;
                                case o.ValueType.Boolean:
                                    e.addAttribute("t", "b"), e.leafNode("v", null, t.value ? "1" : "0");
                                    break;
                                case o.ValueType.Error:
                                    e.addAttribute("t", "e"), e.leafNode("v", null, t.value.error);
                                    break;
                                case o.ValueType.String:
                                case o.ValueType.RichText:
                                    void 0 !== t.ssId ? (e.addAttribute("t", "s"), e.leafNode("v", null, t.ssId)) : t.value && t.value.richText ? (e.addAttribute("t", "inlineStr"), e.openNode("is"), t.value.richText.forEach((t)=>{
                                        this.richTextXForm.render(e, t);
                                    }), e.closeNode("is")) : (e.addAttribute("t", "str"), e.leafNode("v", null, t.value));
                                    break;
                                case o.ValueType.Date:
                                    e.leafNode("v", null, n.dateToExcel(t.value, t.date1904));
                                    break;
                                case o.ValueType.Hyperlink:
                                    void 0 !== t.ssId ? (e.addAttribute("t", "s"), e.leafNode("v", null, t.ssId)) : (e.addAttribute("t", "str"), e.leafNode("v", null, t.text));
                                    break;
                                case o.ValueType.Formula:
                                    this.renderFormula(e, t);
                                    break;
                                case o.ValueType.Merge:
                            }
                            e.closeNode();
                        }
                    }
                    parseOpen(e) {
                        if (this.parser) return this.parser.parseOpen(e), !0;
                        switch(e.name){
                            case "c":
                                return this.model = {
                                    address: e.attributes.r
                                }, this.t = e.attributes.t, e.attributes.s && (this.model.styleId = parseInt(e.attributes.s, 10)), !0;
                            case "f":
                                return this.currentNode = "f", this.model.si = e.attributes.si, this.model.shareType = e.attributes.t, this.model.ref = e.attributes.ref, !0;
                            case "v":
                                return this.currentNode = "v", !0;
                            case "t":
                                return this.currentNode = "t", !0;
                            case "r":
                                return this.parser = this.richTextXForm, this.parser.parseOpen(e), !0;
                            default:
                                return !1;
                        }
                    }
                    parseText(e) {
                        if (this.parser) this.parser.parseText(e);
                        else switch(this.currentNode){
                            case "f":
                                this.model.formula = this.model.formula ? this.model.formula + e : e;
                                break;
                            case "v":
                            case "t":
                                this.model.value && this.model.value.richText ? this.model.value.richText.text = this.model.value.richText.text ? this.model.value.richText.text + e : e : this.model.value = this.model.value ? this.model.value + e : e;
                        }
                    }
                    parseClose(e) {
                        switch(e){
                            case "c":
                                {
                                    const { model: e } = this;
                                    if (e.formula || e.shareType) e.type = o.ValueType.Formula, e.value && ("str" === this.t ? e.result = n.xmlDecode(e.value) : "b" === this.t ? e.result = 0 !== parseInt(e.value, 10) : "e" === this.t ? e.result = {
                                        error: e.value
                                    } : e.result = parseFloat(e.value), e.value = void 0);
                                    else if (void 0 !== e.value) switch(this.t){
                                        case "s":
                                            e.type = o.ValueType.String, e.value = parseInt(e.value, 10);
                                            break;
                                        case "str":
                                            e.type = o.ValueType.String, e.value = n.xmlDecode(e.value);
                                            break;
                                        case "inlineStr":
                                            e.type = o.ValueType.String;
                                            break;
                                        case "b":
                                            e.type = o.ValueType.Boolean, e.value = 0 !== parseInt(e.value, 10);
                                            break;
                                        case "e":
                                            e.type = o.ValueType.Error, e.value = {
                                                error: e.value
                                            };
                                            break;
                                        default:
                                            e.type = o.ValueType.Number, e.value = parseFloat(e.value);
                                    }
                                    else e.styleId ? e.type = o.ValueType.Null : e.type = o.ValueType.Merge;
                                    return !1;
                                }
                            case "f":
                            case "v":
                            case "is":
                                return this.currentNode = void 0, !0;
                            case "t":
                                return this.parser ? (this.parser.parseClose(e), !0) : (this.currentNode = void 0, !0);
                            case "r":
                                return this.model.value = this.model.value || {}, this.model.value.richText = this.model.value.richText || [], this.model.value.richText.push(this.parser.model), this.parser = void 0, this.currentNode = void 0, !0;
                            default:
                                return !!this.parser && (this.parser.parseClose(e), !0);
                        }
                    }
                    reconcile(e, t) {
                        const r = e.styleId && t.styles && t.styles.getStyleModel(e.styleId);
                        switch(r && (e.style = r), void 0 !== e.styleId && (e.styleId = void 0), e.type){
                            case o.ValueType.String:
                                "number" == typeof e.value && t.sharedStrings && (e.value = t.sharedStrings.getString(e.value)), e.value.richText && (e.type = o.ValueType.RichText);
                                break;
                            case o.ValueType.Number:
                                r && n.isDateFmt(r.numFmt) && (e.type = o.ValueType.Date, e.value = n.excelToDate(e.value, t.date1904));
                                break;
                            case o.ValueType.Formula:
                                void 0 !== e.result && r && n.isDateFmt(r.numFmt) && (e.result = n.excelToDate(e.result, t.date1904)), "shared" === e.shareType && (e.ref ? t.formulae[e.si] = e.address : (e.sharedFormula = t.formulae[e.si], delete e.shareType), delete e.si);
                        }
                        const i = t.hyperlinkMap[e.address];
                        i && (e.type === o.ValueType.Formula ? (e.text = e.result, e.result = void 0) : (e.text = e.value, e.value = void 0), e.type = o.ValueType.Hyperlink, e.hyperlink = i);
                        const s = t.commentsMap && t.commentsMap[e.address];
                        s && (e.comment = s);
                    }
                };
            },
            {
                "../../../doc/enums": 7,
                "../../../doc/range": 10,
                "../../../utils/utils": 27,
                "../base-xform": 32,
                "../strings/rich-text-xform": 122
            }
        ],
        74: [
            function(e, t, r) {
                "use strict";
                const n = e("../../base-xform");
                t.exports = class extends n {
                    get tag() {
                        return "x14:cfIcon";
                    }
                    render(e, t) {
                        e.leafNode(this.tag, {
                            iconSet: t.iconSet,
                            iconId: t.iconId
                        });
                    }
                    parseOpen(e) {
                        let { attributes: t } = e;
                        this.model = {
                            iconSet: t.iconSet,
                            iconId: n.toIntValue(t.iconId)
                        };
                    }
                    parseClose(e) {
                        return e !== this.tag;
                    }
                };
            },
            {
                "../../base-xform": 32
            }
        ],
        75: [
            function(e, t, r) {
                "use strict";
                const { v4: n } = e("uuid"), i = e("../../base-xform"), s = e("../../composite-xform"), o = e("./databar-ext-xform"), a = e("./icon-set-ext-xform"), l = {
                    "3Triangles": !0,
                    "3Stars": !0,
                    "5Boxes": !0
                };
                class c extends s {
                    constructor(){
                        super(), this.map = {
                            "x14:dataBar": this.databarXform = new o,
                            "x14:iconSet": this.iconSetXform = new a
                        };
                    }
                    get tag() {
                        return "x14:cfRule";
                    }
                    static isExt(e) {
                        return "dataBar" === e.type ? o.isExt(e) : !("iconSet" !== e.type || !e.custom && !l[e.iconSet]);
                    }
                    prepare(e) {
                        c.isExt(e) && (e.x14Id = `{${n()}}`.toUpperCase());
                    }
                    render(e, t) {
                        if (c.isExt(t)) switch(t.type){
                            case "dataBar":
                                this.renderDataBar(e, t);
                                break;
                            case "iconSet":
                                this.renderIconSet(e, t);
                        }
                    }
                    renderDataBar(e, t) {
                        e.openNode(this.tag, {
                            type: "dataBar",
                            id: t.x14Id
                        }), this.databarXform.render(e, t), e.closeNode();
                    }
                    renderIconSet(e, t) {
                        e.openNode(this.tag, {
                            type: "iconSet",
                            priority: t.priority,
                            id: t.x14Id || `{${n()}}`
                        }), this.iconSetXform.render(e, t), e.closeNode();
                    }
                    createNewModel(e) {
                        let { attributes: t } = e;
                        return {
                            type: t.type,
                            x14Id: t.id,
                            priority: i.toIntValue(t.priority)
                        };
                    }
                    onParserClose(e, t) {
                        Object.assign(this.model, t.model);
                    }
                }
                t.exports = c;
            },
            {
                "../../base-xform": 32,
                "../../composite-xform": 48,
                "./databar-ext-xform": 79,
                "./icon-set-ext-xform": 81,
                uuid: 528
            }
        ],
        76: [
            function(e, t, r) {
                "use strict";
                const n = e("../../composite-xform"), i = e("./f-ext-xform");
                t.exports = class extends n {
                    constructor(){
                        super(), this.map = {
                            "xm:f": this.fExtXform = new i
                        };
                    }
                    get tag() {
                        return "x14:cfvo";
                    }
                    render(e, t) {
                        e.openNode(this.tag, {
                            type: t.type
                        }), void 0 !== t.value && this.fExtXform.render(e, t.value), e.closeNode();
                    }
                    createNewModel(e) {
                        return {
                            type: e.attributes.type
                        };
                    }
                    onParserClose(e, t) {
                        switch(e){
                            case "xm:f":
                                this.model.value = t.model ? parseFloat(t.model) : 0;
                        }
                    }
                };
            },
            {
                "../../composite-xform": 48,
                "./f-ext-xform": 80
            }
        ],
        77: [
            function(e, t, r) {
                "use strict";
                const n = e("../../composite-xform"), i = e("./sqref-ext-xform"), s = e("./cf-rule-ext-xform");
                t.exports = class extends n {
                    constructor(){
                        super(), this.map = {
                            "xm:sqref": this.sqRef = new i,
                            "x14:cfRule": this.cfRule = new s
                        };
                    }
                    get tag() {
                        return "x14:conditionalFormatting";
                    }
                    prepare(e, t) {
                        e.rules.forEach((e)=>{
                            this.cfRule.prepare(e, t);
                        });
                    }
                    render(e, t) {
                        t.rules.some(s.isExt) && (e.openNode(this.tag, {
                            "xmlns:xm": "http://schemas.microsoft.com/office/excel/2006/main"
                        }), t.rules.filter(s.isExt).forEach((t)=>this.cfRule.render(e, t)), this.sqRef.render(e, t.ref), e.closeNode());
                    }
                    createNewModel() {
                        return {
                            rules: []
                        };
                    }
                    onParserClose(e, t) {
                        switch(e){
                            case "xm:sqref":
                                this.model.ref = t.model;
                                break;
                            case "x14:cfRule":
                                this.model.rules.push(t.model);
                        }
                    }
                };
            },
            {
                "../../composite-xform": 48,
                "./cf-rule-ext-xform": 75,
                "./sqref-ext-xform": 82
            }
        ],
        78: [
            function(e, t, r) {
                "use strict";
                const n = e("../../composite-xform"), i = e("./cf-rule-ext-xform"), s = e("./conditional-formatting-ext-xform");
                t.exports = class extends n {
                    constructor(){
                        super(), this.map = {
                            "x14:conditionalFormatting": this.cfXform = new s
                        };
                    }
                    get tag() {
                        return "x14:conditionalFormattings";
                    }
                    hasContent(e) {
                        return void 0 === e.hasExtContent && (e.hasExtContent = e.some((e)=>e.rules.some(i.isExt))), e.hasExtContent;
                    }
                    prepare(e, t) {
                        e.forEach((e)=>{
                            this.cfXform.prepare(e, t);
                        });
                    }
                    render(e, t) {
                        this.hasContent(t) && (e.openNode(this.tag), t.forEach((t)=>this.cfXform.render(e, t)), e.closeNode());
                    }
                    createNewModel() {
                        return [];
                    }
                    onParserClose(e, t) {
                        this.model.push(t.model);
                    }
                };
            },
            {
                "../../composite-xform": 48,
                "./cf-rule-ext-xform": 75,
                "./conditional-formatting-ext-xform": 77
            }
        ],
        79: [
            function(e, t, r) {
                "use strict";
                const n = e("../../base-xform"), i = e("../../composite-xform"), s = e("../../style/color-xform"), o = e("./cfvo-ext-xform");
                t.exports = class extends i {
                    constructor(){
                        super(), this.map = {
                            "x14:cfvo": this.cfvoXform = new o,
                            "x14:borderColor": this.borderColorXform = new s("x14:borderColor"),
                            "x14:negativeBorderColor": this.negativeBorderColorXform = new s("x14:negativeBorderColor"),
                            "x14:negativeFillColor": this.negativeFillColorXform = new s("x14:negativeFillColor"),
                            "x14:axisColor": this.axisColorXform = new s("x14:axisColor")
                        };
                    }
                    static isExt(e) {
                        return !e.gradient;
                    }
                    get tag() {
                        return "x14:dataBar";
                    }
                    render(e, t) {
                        e.openNode(this.tag, {
                            minLength: n.toIntAttribute(t.minLength, 0, !0),
                            maxLength: n.toIntAttribute(t.maxLength, 100, !0),
                            border: n.toBoolAttribute(t.border, !1),
                            gradient: n.toBoolAttribute(t.gradient, !0),
                            negativeBarColorSameAsPositive: n.toBoolAttribute(t.negativeBarColorSameAsPositive, !0),
                            negativeBarBorderColorSameAsPositive: n.toBoolAttribute(t.negativeBarBorderColorSameAsPositive, !0),
                            axisPosition: n.toAttribute(t.axisPosition, "auto"),
                            direction: n.toAttribute(t.direction, "leftToRight")
                        }), t.cfvo.forEach((t)=>{
                            this.cfvoXform.render(e, t);
                        }), this.borderColorXform.render(e, t.borderColor), this.negativeBorderColorXform.render(e, t.negativeBorderColor), this.negativeFillColorXform.render(e, t.negativeFillColor), this.axisColorXform.render(e, t.axisColor), e.closeNode();
                    }
                    createNewModel(e) {
                        let { attributes: t } = e;
                        return {
                            cfvo: [],
                            minLength: n.toIntValue(t.minLength, 0),
                            maxLength: n.toIntValue(t.maxLength, 100),
                            border: n.toBoolValue(t.border, !1),
                            gradient: n.toBoolValue(t.gradient, !0),
                            negativeBarColorSameAsPositive: n.toBoolValue(t.negativeBarColorSameAsPositive, !0),
                            negativeBarBorderColorSameAsPositive: n.toBoolValue(t.negativeBarBorderColorSameAsPositive, !0),
                            axisPosition: n.toStringValue(t.axisPosition, "auto"),
                            direction: n.toStringValue(t.direction, "leftToRight")
                        };
                    }
                    onParserClose(e, t) {
                        const [, r] = e.split(":");
                        switch(r){
                            case "cfvo":
                                this.model.cfvo.push(t.model);
                                break;
                            default:
                                this.model[r] = t.model;
                        }
                    }
                };
            },
            {
                "../../base-xform": 32,
                "../../composite-xform": 48,
                "../../style/color-xform": 128,
                "./cfvo-ext-xform": 76
            }
        ],
        80: [
            function(e, t, r) {
                "use strict";
                const n = e("../../base-xform");
                t.exports = class extends n {
                    get tag() {
                        return "xm:f";
                    }
                    render(e, t) {
                        e.leafNode(this.tag, null, t);
                    }
                    parseOpen() {
                        this.model = "";
                    }
                    parseText(e) {
                        this.model += e;
                    }
                    parseClose(e) {
                        return e !== this.tag;
                    }
                };
            },
            {
                "../../base-xform": 32
            }
        ],
        81: [
            function(e, t, r) {
                "use strict";
                const n = e("../../base-xform"), i = e("../../composite-xform"), s = e("./cfvo-ext-xform"), o = e("./cf-icon-ext-xform");
                t.exports = class extends i {
                    constructor(){
                        super(), this.map = {
                            "x14:cfvo": this.cfvoXform = new s,
                            "x14:cfIcon": this.cfIconXform = new o
                        };
                    }
                    get tag() {
                        return "x14:iconSet";
                    }
                    render(e, t) {
                        e.openNode(this.tag, {
                            iconSet: n.toStringAttribute(t.iconSet),
                            reverse: n.toBoolAttribute(t.reverse, !1),
                            showValue: n.toBoolAttribute(t.showValue, !0),
                            custom: n.toBoolAttribute(t.icons, !1)
                        }), t.cfvo.forEach((t)=>{
                            this.cfvoXform.render(e, t);
                        }), t.icons && t.icons.forEach((t, r)=>{
                            t.iconId = r, this.cfIconXform.render(e, t);
                        }), e.closeNode();
                    }
                    createNewModel(e) {
                        let { attributes: t } = e;
                        return {
                            cfvo: [],
                            iconSet: n.toStringValue(t.iconSet, "3TrafficLights"),
                            reverse: n.toBoolValue(t.reverse, !1),
                            showValue: n.toBoolValue(t.showValue, !0)
                        };
                    }
                    onParserClose(e, t) {
                        const [, r] = e.split(":");
                        switch(r){
                            case "cfvo":
                                this.model.cfvo.push(t.model);
                                break;
                            case "cfIcon":
                                this.model.icons || (this.model.icons = []), this.model.icons.push(t.model);
                                break;
                            default:
                                this.model[r] = t.model;
                        }
                    }
                };
            },
            {
                "../../base-xform": 32,
                "../../composite-xform": 48,
                "./cf-icon-ext-xform": 74,
                "./cfvo-ext-xform": 76
            }
        ],
        82: [
            function(e, t, r) {
                "use strict";
                const n = e("../../base-xform");
                t.exports = class extends n {
                    get tag() {
                        return "xm:sqref";
                    }
                    render(e, t) {
                        e.leafNode(this.tag, null, t);
                    }
                    parseOpen() {
                        this.model = "";
                    }
                    parseText(e) {
                        this.model += e;
                    }
                    parseClose(e) {
                        return e !== this.tag;
                    }
                };
            },
            {
                "../../base-xform": 32
            }
        ],
        83: [
            function(e, t, r) {
                "use strict";
                const n = e("../../base-xform"), i = e("../../composite-xform"), s = e("../../../../doc/range"), o = e("./databar-xform"), a = e("./ext-lst-ref-xform"), l = e("./formula-xform"), c = e("./color-scale-xform"), u = e("./icon-set-xform"), h = {
                    "3Triangles": !0,
                    "3Stars": !0,
                    "5Boxes": !0
                }, f = (e)=>{
                    const { type: t, operator: r } = e;
                    switch(t){
                        case "containsText":
                        case "containsBlanks":
                        case "notContainsBlanks":
                        case "containsErrors":
                        case "notContainsErrors":
                            return {
                                type: "containsText",
                                operator: t
                            };
                        default:
                            return {
                                type: t,
                                operator: r
                            };
                    }
                };
                class d extends i {
                    constructor(){
                        super(), this.map = {
                            dataBar: this.databarXform = new o,
                            extLst: this.extLstRefXform = new a,
                            formula: this.formulaXform = new l,
                            colorScale: this.colorScaleXform = new c,
                            iconSet: this.iconSetXform = new u
                        };
                    }
                    get tag() {
                        return "cfRule";
                    }
                    static isPrimitive(e) {
                        return "iconSet" !== e.type || !e.custom && !h[e.iconSet];
                    }
                    render(e, t) {
                        switch(t.type){
                            case "expression":
                                this.renderExpression(e, t);
                                break;
                            case "cellIs":
                                this.renderCellIs(e, t);
                                break;
                            case "top10":
                                this.renderTop10(e, t);
                                break;
                            case "aboveAverage":
                                this.renderAboveAverage(e, t);
                                break;
                            case "dataBar":
                                this.renderDataBar(e, t);
                                break;
                            case "colorScale":
                                this.renderColorScale(e, t);
                                break;
                            case "iconSet":
                                this.renderIconSet(e, t);
                                break;
                            case "containsText":
                                this.renderText(e, t);
                                break;
                            case "timePeriod":
                                this.renderTimePeriod(e, t);
                        }
                    }
                    renderExpression(e, t) {
                        e.openNode(this.tag, {
                            type: "expression",
                            dxfId: t.dxfId,
                            priority: t.priority
                        }), this.formulaXform.render(e, t.formulae[0]), e.closeNode();
                    }
                    renderCellIs(e, t) {
                        e.openNode(this.tag, {
                            type: "cellIs",
                            dxfId: t.dxfId,
                            priority: t.priority,
                            operator: t.operator
                        }), t.formulae.forEach((t)=>{
                            this.formulaXform.render(e, t);
                        }), e.closeNode();
                    }
                    renderTop10(e, t) {
                        e.leafNode(this.tag, {
                            type: "top10",
                            dxfId: t.dxfId,
                            priority: t.priority,
                            percent: n.toBoolAttribute(t.percent, !1),
                            bottom: n.toBoolAttribute(t.bottom, !1),
                            rank: n.toIntValue(t.rank, 10, !0)
                        });
                    }
                    renderAboveAverage(e, t) {
                        e.leafNode(this.tag, {
                            type: "aboveAverage",
                            dxfId: t.dxfId,
                            priority: t.priority,
                            aboveAverage: n.toBoolAttribute(t.aboveAverage, !0)
                        });
                    }
                    renderDataBar(e, t) {
                        e.openNode(this.tag, {
                            type: "dataBar",
                            priority: t.priority
                        }), this.databarXform.render(e, t), this.extLstRefXform.render(e, t), e.closeNode();
                    }
                    renderColorScale(e, t) {
                        e.openNode(this.tag, {
                            type: "colorScale",
                            priority: t.priority
                        }), this.colorScaleXform.render(e, t), e.closeNode();
                    }
                    renderIconSet(e, t) {
                        d.isPrimitive(t) && (e.openNode(this.tag, {
                            type: "iconSet",
                            priority: t.priority
                        }), this.iconSetXform.render(e, t), e.closeNode());
                    }
                    renderText(e, t) {
                        e.openNode(this.tag, {
                            type: t.operator,
                            dxfId: t.dxfId,
                            priority: t.priority,
                            operator: n.toStringAttribute(t.operator, "containsText")
                        });
                        const r = ((e)=>{
                            if (e.formulae && e.formulae[0]) return e.formulae[0];
                            const t = new s(e.ref), { tl: r } = t;
                            switch(e.operator){
                                case "containsText":
                                    return `NOT(ISERROR(SEARCH("${e.text}",${r})))`;
                                case "containsBlanks":
                                    return `LEN(TRIM(${r}))=0`;
                                case "notContainsBlanks":
                                    return `LEN(TRIM(${r}))>0`;
                                case "containsErrors":
                                    return `ISERROR(${r})`;
                                case "notContainsErrors":
                                    return `NOT(ISERROR(${r}))`;
                                default:
                                    return;
                            }
                        })(t);
                        r && this.formulaXform.render(e, r), e.closeNode();
                    }
                    renderTimePeriod(e, t) {
                        e.openNode(this.tag, {
                            type: "timePeriod",
                            dxfId: t.dxfId,
                            priority: t.priority,
                            timePeriod: t.timePeriod
                        });
                        const r = ((e)=>{
                            if (e.formulae && e.formulae[0]) return e.formulae[0];
                            const t = new s(e.ref), { tl: r } = t;
                            switch(e.timePeriod){
                                case "thisWeek":
                                    return `AND(TODAY()-ROUNDDOWN(${r},0)<=WEEKDAY(TODAY())-1,ROUNDDOWN(${r},0)-TODAY()<=7-WEEKDAY(TODAY()))`;
                                case "lastWeek":
                                    return `AND(TODAY()-ROUNDDOWN(${r},0)>=(WEEKDAY(TODAY())),TODAY()-ROUNDDOWN(${r},0)<(WEEKDAY(TODAY())+7))`;
                                case "nextWeek":
                                    return `AND(ROUNDDOWN(${r},0)-TODAY()>(7-WEEKDAY(TODAY())),ROUNDDOWN(${r},0)-TODAY()<(15-WEEKDAY(TODAY())))`;
                                case "yesterday":
                                    return `FLOOR(${r},1)=TODAY()-1`;
                                case "today":
                                    return `FLOOR(${r},1)=TODAY()`;
                                case "tomorrow":
                                    return `FLOOR(${r},1)=TODAY()+1`;
                                case "last7Days":
                                    return `AND(TODAY()-FLOOR(${r},1)<=6,FLOOR(${r},1)<=TODAY())`;
                                case "lastMonth":
                                    return `AND(MONTH(${r})=MONTH(EDATE(TODAY(),0-1)),YEAR(${r})=YEAR(EDATE(TODAY(),0-1)))`;
                                case "thisMonth":
                                    return `AND(MONTH(${r})=MONTH(TODAY()),YEAR(${r})=YEAR(TODAY()))`;
                                case "nextMonth":
                                    return `AND(MONTH(${r})=MONTH(EDATE(TODAY(),0+1)),YEAR(${r})=YEAR(EDATE(TODAY(),0+1)))`;
                                default:
                                    return;
                            }
                        })(t);
                        r && this.formulaXform.render(e, r), e.closeNode();
                    }
                    createNewModel(e) {
                        let { attributes: t } = e;
                        return {
                            ...f(t),
                            dxfId: n.toIntValue(t.dxfId),
                            priority: n.toIntValue(t.priority),
                            timePeriod: t.timePeriod,
                            percent: n.toBoolValue(t.percent),
                            bottom: n.toBoolValue(t.bottom),
                            rank: n.toIntValue(t.rank),
                            aboveAverage: n.toBoolValue(t.aboveAverage)
                        };
                    }
                    onParserClose(e, t) {
                        switch(e){
                            case "dataBar":
                            case "extLst":
                            case "colorScale":
                            case "iconSet":
                                Object.assign(this.model, t.model);
                                break;
                            case "formula":
                                this.model.formulae = this.model.formulae || [], this.model.formulae.push(t.model);
                        }
                    }
                }
                t.exports = d;
            },
            {
                "../../../../doc/range": 10,
                "../../base-xform": 32,
                "../../composite-xform": 48,
                "./color-scale-xform": 85,
                "./databar-xform": 88,
                "./ext-lst-ref-xform": 89,
                "./formula-xform": 90,
                "./icon-set-xform": 91
            }
        ],
        84: [
            function(e, t, r) {
                "use strict";
                const n = e("../../base-xform");
                t.exports = class extends n {
                    get tag() {
                        return "cfvo";
                    }
                    render(e, t) {
                        e.leafNode(this.tag, {
                            type: t.type,
                            val: t.value
                        });
                    }
                    parseOpen(e) {
                        this.model = {
                            type: e.attributes.type,
                            value: n.toFloatValue(e.attributes.val)
                        };
                    }
                    parseClose(e) {
                        return e !== this.tag;
                    }
                };
            },
            {
                "../../base-xform": 32
            }
        ],
        85: [
            function(e, t, r) {
                "use strict";
                const n = e("../../composite-xform"), i = e("../../style/color-xform"), s = e("./cfvo-xform");
                t.exports = class extends n {
                    constructor(){
                        super(), this.map = {
                            cfvo: this.cfvoXform = new s,
                            color: this.colorXform = new i
                        };
                    }
                    get tag() {
                        return "colorScale";
                    }
                    render(e, t) {
                        e.openNode(this.tag), t.cfvo.forEach((t)=>{
                            this.cfvoXform.render(e, t);
                        }), t.color.forEach((t)=>{
                            this.colorXform.render(e, t);
                        }), e.closeNode();
                    }
                    createNewModel(e) {
                        return {
                            cfvo: [],
                            color: []
                        };
                    }
                    onParserClose(e, t) {
                        this.model[e].push(t.model);
                    }
                };
            },
            {
                "../../composite-xform": 48,
                "../../style/color-xform": 128,
                "./cfvo-xform": 84
            }
        ],
        86: [
            function(e, t, r) {
                "use strict";
                const n = e("../../composite-xform"), i = e("./cf-rule-xform");
                t.exports = class extends n {
                    constructor(){
                        super(), this.map = {
                            cfRule: new i
                        };
                    }
                    get tag() {
                        return "conditionalFormatting";
                    }
                    render(e, t) {
                        t.rules.some(i.isPrimitive) && (e.openNode(this.tag, {
                            sqref: t.ref
                        }), t.rules.forEach((r)=>{
                            i.isPrimitive(r) && (r.ref = t.ref, this.map.cfRule.render(e, r));
                        }), e.closeNode());
                    }
                    createNewModel(e) {
                        let { attributes: t } = e;
                        return {
                            ref: t.sqref,
                            rules: []
                        };
                    }
                    onParserClose(e, t) {
                        this.model.rules.push(t.model);
                    }
                };
            },
            {
                "../../composite-xform": 48,
                "./cf-rule-xform": 83
            }
        ],
        87: [
            function(e, t, r) {
                "use strict";
                const n = e("../../base-xform"), i = e("./conditional-formatting-xform");
                t.exports = class extends n {
                    constructor(){
                        super(), this.cfXform = new i;
                    }
                    get tag() {
                        return "conditionalFormatting";
                    }
                    reset() {
                        this.model = [];
                    }
                    prepare(e, t) {
                        let r = e.reduce((e, t)=>Math.max(e, ...t.rules.map((e)=>e.priority || 0)), 1);
                        e.forEach((e)=>{
                            e.rules.forEach((e)=>{
                                e.priority || (e.priority = r++), e.style && (e.dxfId = t.styles.addDxfStyle(e.style));
                            });
                        });
                    }
                    render(e, t) {
                        t.forEach((t)=>{
                            this.cfXform.render(e, t);
                        });
                    }
                    parseOpen(e) {
                        if (this.parser) return this.parser.parseOpen(e), !0;
                        switch(e.name){
                            case "conditionalFormatting":
                                return this.parser = this.cfXform, this.parser.parseOpen(e), !0;
                            default:
                                return !1;
                        }
                    }
                    parseText(e) {
                        this.parser && this.parser.parseText(e);
                    }
                    parseClose(e) {
                        return !!this.parser && (!!this.parser.parseClose(e) || (this.model.push(this.parser.model), this.parser = void 0, !1));
                    }
                    reconcile(e, t) {
                        e.forEach((e)=>{
                            e.rules.forEach((e)=>{
                                void 0 !== e.dxfId && (e.style = t.styles.getDxfStyle(e.dxfId), delete e.dxfId);
                            });
                        });
                    }
                };
            },
            {
                "../../base-xform": 32,
                "./conditional-formatting-xform": 86
            }
        ],
        88: [
            function(e, t, r) {
                "use strict";
                const n = e("../../composite-xform"), i = e("../../style/color-xform"), s = e("./cfvo-xform");
                t.exports = class extends n {
                    constructor(){
                        super(), this.map = {
                            cfvo: this.cfvoXform = new s,
                            color: this.colorXform = new i
                        };
                    }
                    get tag() {
                        return "dataBar";
                    }
                    render(e, t) {
                        e.openNode(this.tag), t.cfvo.forEach((t)=>{
                            this.cfvoXform.render(e, t);
                        }), this.colorXform.render(e, t.color), e.closeNode();
                    }
                    createNewModel() {
                        return {
                            cfvo: []
                        };
                    }
                    onParserClose(e, t) {
                        switch(e){
                            case "cfvo":
                                this.model.cfvo.push(t.model);
                                break;
                            case "color":
                                this.model.color = t.model;
                        }
                    }
                };
            },
            {
                "../../composite-xform": 48,
                "../../style/color-xform": 128,
                "./cfvo-xform": 84
            }
        ],
        89: [
            function(e, t, r) {
                "use strict";
                const n = e("../../base-xform"), i = e("../../composite-xform");
                class s extends n {
                    get tag() {
                        return "x14:id";
                    }
                    render(e, t) {
                        e.leafNode(this.tag, null, t);
                    }
                    parseOpen() {
                        this.model = "";
                    }
                    parseText(e) {
                        this.model += e;
                    }
                    parseClose(e) {
                        return e !== this.tag;
                    }
                }
                class o extends i {
                    constructor(){
                        super(), this.map = {
                            "x14:id": this.idXform = new s
                        };
                    }
                    get tag() {
                        return "ext";
                    }
                    render(e, t) {
                        e.openNode(this.tag, {
                            uri: "{B025F937-C7B1-47D3-B67F-A62EFF666E3E}",
                            "xmlns:x14": "http://schemas.microsoft.com/office/spreadsheetml/2009/9/main"
                        }), this.idXform.render(e, t.x14Id), e.closeNode();
                    }
                    createNewModel() {
                        return {};
                    }
                    onParserClose(e, t) {
                        this.model.x14Id = t.model;
                    }
                }
                t.exports = class extends i {
                    constructor(){
                        super(), this.map = {
                            ext: new o
                        };
                    }
                    get tag() {
                        return "extLst";
                    }
                    render(e, t) {
                        e.openNode(this.tag), this.map.ext.render(e, t), e.closeNode();
                    }
                    createNewModel() {
                        return {};
                    }
                    onParserClose(e, t) {
                        Object.assign(this.model, t.model);
                    }
                };
            },
            {
                "../../base-xform": 32,
                "../../composite-xform": 48
            }
        ],
        90: [
            function(e, t, r) {
                "use strict";
                const n = e("../../base-xform");
                t.exports = class extends n {
                    get tag() {
                        return "formula";
                    }
                    render(e, t) {
                        e.leafNode(this.tag, null, t);
                    }
                    parseOpen() {
                        this.model = "";
                    }
                    parseText(e) {
                        this.model += e;
                    }
                    parseClose(e) {
                        return e !== this.tag;
                    }
                };
            },
            {
                "../../base-xform": 32
            }
        ],
        91: [
            function(e, t, r) {
                "use strict";
                const n = e("../../base-xform"), i = e("../../composite-xform"), s = e("./cfvo-xform");
                t.exports = class extends i {
                    constructor(){
                        super(), this.map = {
                            cfvo: this.cfvoXform = new s
                        };
                    }
                    get tag() {
                        return "iconSet";
                    }
                    render(e, t) {
                        e.openNode(this.tag, {
                            iconSet: n.toStringAttribute(t.iconSet, "3TrafficLights"),
                            reverse: n.toBoolAttribute(t.reverse, !1),
                            showValue: n.toBoolAttribute(t.showValue, !0)
                        }), t.cfvo.forEach((t)=>{
                            this.cfvoXform.render(e, t);
                        }), e.closeNode();
                    }
                    createNewModel(e) {
                        let { attributes: t } = e;
                        return {
                            iconSet: n.toStringValue(t.iconSet, "3TrafficLights"),
                            reverse: n.toBoolValue(t.reverse),
                            showValue: n.toBoolValue(t.showValue),
                            cfvo: []
                        };
                    }
                    onParserClose(e, t) {
                        this.model[e].push(t.model);
                    }
                };
            },
            {
                "../../base-xform": 32,
                "../../composite-xform": 48,
                "./cfvo-xform": 84
            }
        ],
        92: [
            function(e, t, r) {
                "use strict";
                const n = e("../../../utils/utils"), i = e("../base-xform");
                t.exports = class extends i {
                    get tag() {
                        return "col";
                    }
                    prepare(e, t) {
                        const r = t.styles.addStyleModel(e.style || {});
                        r && (e.styleId = r);
                    }
                    render(e, t) {
                        e.openNode("col"), e.addAttribute("min", t.min), e.addAttribute("max", t.max), t.width && e.addAttribute("width", t.width), t.styleId && e.addAttribute("style", t.styleId), t.hidden && e.addAttribute("hidden", "1"), t.bestFit && e.addAttribute("bestFit", "1"), t.outlineLevel && e.addAttribute("outlineLevel", t.outlineLevel), t.collapsed && e.addAttribute("collapsed", "1"), e.addAttribute("customWidth", "1"), e.closeNode();
                    }
                    parseOpen(e) {
                        if ("col" === e.name) {
                            const t = this.model = {
                                min: parseInt(e.attributes.min || "0", 10),
                                max: parseInt(e.attributes.max || "0", 10),
                                width: void 0 === e.attributes.width ? void 0 : parseFloat(e.attributes.width || "0")
                            };
                            return e.attributes.style && (t.styleId = parseInt(e.attributes.style, 10)), n.parseBoolean(e.attributes.hidden) && (t.hidden = !0), n.parseBoolean(e.attributes.bestFit) && (t.bestFit = !0), e.attributes.outlineLevel && (t.outlineLevel = parseInt(e.attributes.outlineLevel, 10)), n.parseBoolean(e.attributes.collapsed) && (t.collapsed = !0), !0;
                        }
                        return !1;
                    }
                    parseText() {}
                    parseClose() {
                        return !1;
                    }
                    reconcile(e, t) {
                        e.styleId && (e.style = t.styles.getStyleModel(e.styleId));
                    }
                };
            },
            {
                "../../../utils/utils": 27,
                "../base-xform": 32
            }
        ],
        93: [
            function(e, t, r) {
                "use strict";
                const n = e("../../../utils/under-dash"), i = e("../../../utils/utils"), s = e("../../../utils/col-cache"), o = e("../base-xform"), a = e("../../../doc/range");
                function l(e, t, r, n) {
                    const i = t[r];
                    void 0 !== i ? e[r] = i : void 0 !== n && (e[r] = n);
                }
                function c(e, t, r, n) {
                    const s = t[r];
                    void 0 !== s ? e[r] = i.parseBoolean(s) : void 0 !== n && (e[r] = n);
                }
                t.exports = class extends o {
                    get tag() {
                        return "dataValidations";
                    }
                    render(e, t) {
                        const r = function(e) {
                            const t = n.map(e, (e, t)=>({
                                    address: t,
                                    dataValidation: e,
                                    marked: !1
                                })).sort((e, t)=>n.strcmp(e.address, t.address)), r = n.keyBy(t, "address"), i = (t, r, i)=>{
                                for(let o = 0; o < r; o++){
                                    const r = s.encodeAddress(t.row + o, i);
                                    if (!e[r] || !n.isEqual(e[t.address], e[r])) return !1;
                                }
                                return !0;
                            };
                            return t.map((t)=>{
                                if (!t.marked) {
                                    const o = s.decodeEx(t.address);
                                    if (o.dimensions) return r[o.dimensions].marked = !0, {
                                        ...t.dataValidation,
                                        sqref: t.address
                                    };
                                    let a = 1, l = s.encodeAddress(o.row + a, o.col);
                                    for(; e[l] && n.isEqual(t.dataValidation, e[l]);)a++, l = s.encodeAddress(o.row + a, o.col);
                                    let c = 1;
                                    for(; i(o, a, o.col + c);)c++;
                                    for(let e = 0; e < a; e++)for(let t = 0; t < c; t++)l = s.encodeAddress(o.row + e, o.col + t), r[l].marked = !0;
                                    if (a > 1 || c > 1) {
                                        const e = o.row + (a - 1), r = o.col + (c - 1);
                                        return {
                                            ...t.dataValidation,
                                            sqref: `${t.address}:${s.encodeAddress(e, r)}`
                                        };
                                    }
                                    return {
                                        ...t.dataValidation,
                                        sqref: t.address
                                    };
                                }
                                return null;
                            }).filter(Boolean);
                        }(t);
                        r.length && (e.openNode("dataValidations", {
                            count: r.length
                        }), r.forEach((t)=>{
                            e.openNode("dataValidation"), "any" !== t.type && (e.addAttribute("type", t.type), t.operator && "list" !== t.type && "between" !== t.operator && e.addAttribute("operator", t.operator), t.allowBlank && e.addAttribute("allowBlank", "1")), t.showInputMessage && e.addAttribute("showInputMessage", "1"), t.promptTitle && e.addAttribute("promptTitle", t.promptTitle), t.prompt && e.addAttribute("prompt", t.prompt), t.showErrorMessage && e.addAttribute("showErrorMessage", "1"), t.errorStyle && e.addAttribute("errorStyle", t.errorStyle), t.errorTitle && e.addAttribute("errorTitle", t.errorTitle), t.error && e.addAttribute("error", t.error), e.addAttribute("sqref", t.sqref), (t.formulae || []).forEach((r, n)=>{
                                e.openNode("formula" + (n + 1)), "date" === t.type ? e.writeText(i.dateToExcel(new Date(r))) : e.writeText(r), e.closeNode();
                            }), e.closeNode();
                        }), e.closeNode());
                    }
                    parseOpen(e) {
                        switch(e.name){
                            case "dataValidations":
                                return this.model = {}, !0;
                            case "dataValidation":
                                {
                                    this._address = e.attributes.sqref;
                                    const t = {
                                        type: e.attributes.type || "any",
                                        formulae: []
                                    };
                                    switch(e.attributes.type && c(t, e.attributes, "allowBlank"), c(t, e.attributes, "showInputMessage"), c(t, e.attributes, "showErrorMessage"), t.type){
                                        case "any":
                                        case "list":
                                        case "custom":
                                            break;
                                        default:
                                            l(t, e.attributes, "operator", "between");
                                    }
                                    return l(t, e.attributes, "promptTitle"), l(t, e.attributes, "prompt"), l(t, e.attributes, "errorStyle"), l(t, e.attributes, "errorTitle"), l(t, e.attributes, "error"), this._dataValidation = t, !0;
                                }
                            case "formula1":
                            case "formula2":
                                return this._formula = [], !0;
                            default:
                                return !1;
                        }
                    }
                    parseText(e) {
                        this._formula && this._formula.push(e);
                    }
                    parseClose(e) {
                        switch(e){
                            case "dataValidations":
                                return !1;
                            case "dataValidation":
                                this._dataValidation.formulae && this._dataValidation.formulae.length || (delete this._dataValidation.formulae, delete this._dataValidation.operator);
                                return (this._address.split(/\s+/g) || []).forEach((e)=>{
                                    if (e.includes(":")) new a(e).forEachAddress((e)=>{
                                        this.model[e] = this._dataValidation;
                                    });
                                    else this.model[e] = this._dataValidation;
                                }), !0;
                            case "formula1":
                            case "formula2":
                                {
                                    let e = this._formula.join("");
                                    switch(this._dataValidation.type){
                                        case "whole":
                                        case "textLength":
                                            e = parseInt(e, 10);
                                            break;
                                        case "decimal":
                                            e = parseFloat(e);
                                            break;
                                        case "date":
                                            e = i.excelToDate(parseFloat(e));
                                    }
                                    return this._dataValidation.formulae.push(e), this._formula = void 0, !0;
                                }
                            default:
                                return !0;
                        }
                    }
                };
            },
            {
                "../../../doc/range": 10,
                "../../../utils/col-cache": 19,
                "../../../utils/under-dash": 26,
                "../../../utils/utils": 27,
                "../base-xform": 32
            }
        ],
        94: [
            function(e, t, r) {
                "use strict";
                const n = e("../base-xform");
                t.exports = class extends n {
                    get tag() {
                        return "dimension";
                    }
                    render(e, t) {
                        t && e.leafNode("dimension", {
                            ref: t
                        });
                    }
                    parseOpen(e) {
                        return "dimension" === e.name && (this.model = e.attributes.ref, !0);
                    }
                    parseText() {}
                    parseClose() {
                        return !1;
                    }
                };
            },
            {
                "../base-xform": 32
            }
        ],
        95: [
            function(e, t, r) {
                "use strict";
                const n = e("../base-xform");
                t.exports = class extends n {
                    get tag() {
                        return "drawing";
                    }
                    render(e, t) {
                        t && e.leafNode(this.tag, {
                            "r:id": t.rId
                        });
                    }
                    parseOpen(e) {
                        switch(e.name){
                            case this.tag:
                                return this.model = {
                                    rId: e.attributes["r:id"]
                                }, !0;
                            default:
                                return !1;
                        }
                    }
                    parseText() {}
                    parseClose() {
                        return !1;
                    }
                };
            },
            {
                "../base-xform": 32
            }
        ],
        96: [
            function(e, t, r) {
                "use strict";
                const n = e("../composite-xform"), i = e("./cf-ext/conditional-formattings-ext-xform");
                class s extends n {
                    constructor(){
                        super(), this.map = {
                            "x14:conditionalFormattings": this.conditionalFormattings = new i
                        };
                    }
                    get tag() {
                        return "ext";
                    }
                    hasContent(e) {
                        return this.conditionalFormattings.hasContent(e.conditionalFormattings);
                    }
                    prepare(e, t) {
                        this.conditionalFormattings.prepare(e.conditionalFormattings, t);
                    }
                    render(e, t) {
                        e.openNode("ext", {
                            uri: "{78C0D931-6437-407d-A8EE-F0AAD7539E65}",
                            "xmlns:x14": "http://schemas.microsoft.com/office/spreadsheetml/2009/9/main"
                        }), this.conditionalFormattings.render(e, t.conditionalFormattings), e.closeNode();
                    }
                    createNewModel() {
                        return {};
                    }
                    onParserClose(e, t) {
                        this.model[e] = t.model;
                    }
                }
                t.exports = class extends n {
                    constructor(){
                        super(), this.map = {
                            ext: this.ext = new s
                        };
                    }
                    get tag() {
                        return "extLst";
                    }
                    prepare(e, t) {
                        this.ext.prepare(e, t);
                    }
                    hasContent(e) {
                        return this.ext.hasContent(e);
                    }
                    render(e, t) {
                        this.hasContent(t) && (e.openNode("extLst"), this.ext.render(e, t), e.closeNode());
                    }
                    createNewModel() {
                        return {};
                    }
                    onParserClose(e, t) {
                        Object.assign(this.model, t.model);
                    }
                };
            },
            {
                "../composite-xform": 48,
                "./cf-ext/conditional-formattings-ext-xform": 78
            }
        ],
        97: [
            function(e, t, r) {
                "use strict";
                const n = e("../base-xform");
                t.exports = class extends n {
                    get tag() {
                        return "headerFooter";
                    }
                    render(e, t) {
                        if (t) {
                            e.addRollback();
                            let r = !1;
                            e.openNode("headerFooter"), t.differentFirst && (e.addAttribute("differentFirst", "1"), r = !0), t.differentOddEven && (e.addAttribute("differentOddEven", "1"), r = !0), t.oddHeader && "string" == typeof t.oddHeader && (e.leafNode("oddHeader", null, t.oddHeader), r = !0), t.oddFooter && "string" == typeof t.oddFooter && (e.leafNode("oddFooter", null, t.oddFooter), r = !0), t.evenHeader && "string" == typeof t.evenHeader && (e.leafNode("evenHeader", null, t.evenHeader), r = !0), t.evenFooter && "string" == typeof t.evenFooter && (e.leafNode("evenFooter", null, t.evenFooter), r = !0), t.firstHeader && "string" == typeof t.firstHeader && (e.leafNode("firstHeader", null, t.firstHeader), r = !0), t.firstFooter && "string" == typeof t.firstFooter && (e.leafNode("firstFooter", null, t.firstFooter), r = !0), r ? (e.closeNode(), e.commit()) : e.rollback();
                        }
                    }
                    parseOpen(e) {
                        switch(e.name){
                            case "headerFooter":
                                return this.model = {}, e.attributes.differentFirst && (this.model.differentFirst = 1 === parseInt(e.attributes.differentFirst, 0)), e.attributes.differentOddEven && (this.model.differentOddEven = 1 === parseInt(e.attributes.differentOddEven, 0)), !0;
                            case "oddHeader":
                                return this.currentNode = "oddHeader", !0;
                            case "oddFooter":
                                return this.currentNode = "oddFooter", !0;
                            case "evenHeader":
                                return this.currentNode = "evenHeader", !0;
                            case "evenFooter":
                                return this.currentNode = "evenFooter", !0;
                            case "firstHeader":
                                return this.currentNode = "firstHeader", !0;
                            case "firstFooter":
                                return this.currentNode = "firstFooter", !0;
                            default:
                                return !1;
                        }
                    }
                    parseText(e) {
                        switch(this.currentNode){
                            case "oddHeader":
                                this.model.oddHeader = e;
                                break;
                            case "oddFooter":
                                this.model.oddFooter = e;
                                break;
                            case "evenHeader":
                                this.model.evenHeader = e;
                                break;
                            case "evenFooter":
                                this.model.evenFooter = e;
                                break;
                            case "firstHeader":
                                this.model.firstHeader = e;
                                break;
                            case "firstFooter":
                                this.model.firstFooter = e;
                        }
                    }
                    parseClose() {
                        switch(this.currentNode){
                            case "oddHeader":
                            case "oddFooter":
                            case "evenHeader":
                            case "evenFooter":
                            case "firstHeader":
                            case "firstFooter":
                                return this.currentNode = void 0, !0;
                            default:
                                return !1;
                        }
                    }
                };
            },
            {
                "../base-xform": 32
            }
        ],
        98: [
            function(e, t, r) {
                "use strict";
                const n = e("../base-xform");
                t.exports = class extends n {
                    get tag() {
                        return "hyperlink";
                    }
                    render(e, t) {
                        this.isInternalLink(t) ? e.leafNode("hyperlink", {
                            ref: t.address,
                            "r:id": t.rId,
                            tooltip: t.tooltip,
                            location: t.target
                        }) : e.leafNode("hyperlink", {
                            ref: t.address,
                            "r:id": t.rId,
                            tooltip: t.tooltip
                        });
                    }
                    parseOpen(e) {
                        return "hyperlink" === e.name && (this.model = {
                            address: e.attributes.ref,
                            rId: e.attributes["r:id"],
                            tooltip: e.attributes.tooltip
                        }, e.attributes.location && (this.model.target = e.attributes.location), !0);
                    }
                    parseText() {}
                    parseClose() {
                        return !1;
                    }
                    isInternalLink(e) {
                        return e.target && /^[^!]+![a-zA-Z]+[\d]+$/.test(e.target);
                    }
                };
            },
            {
                "../base-xform": 32
            }
        ],
        99: [
            function(e, t, r) {
                "use strict";
                const n = e("../base-xform");
                t.exports = class extends n {
                    get tag() {
                        return "mergeCell";
                    }
                    render(e, t) {
                        e.leafNode("mergeCell", {
                            ref: t
                        });
                    }
                    parseOpen(e) {
                        return "mergeCell" === e.name && (this.model = e.attributes.ref, !0);
                    }
                    parseText() {}
                    parseClose() {
                        return !1;
                    }
                };
            },
            {
                "../base-xform": 32
            }
        ],
        100: [
            function(e, t, r) {
                "use strict";
                const n = e("../../../utils/under-dash"), i = e("../../../doc/range"), s = e("../../../utils/col-cache"), o = e("../../../doc/enums");
                t.exports = class {
                    constructor(){
                        this.merges = {};
                    }
                    add(e) {
                        if (this.merges[e.master]) this.merges[e.master].expandToAddress(e.address);
                        else {
                            const t = `${e.master}:${e.address}`;
                            this.merges[e.master] = new i(t);
                        }
                    }
                    get mergeCells() {
                        return n.map(this.merges, (e)=>e.range);
                    }
                    reconcile(e, t) {
                        n.each(e, (e)=>{
                            const r = s.decode(e);
                            for(let e = r.top; e <= r.bottom; e++){
                                const n = t[e - 1];
                                for(let t = r.left; t <= r.right; t++){
                                    const i = n.cells[t - 1];
                                    i ? i.type === o.ValueType.Merge && (i.master = r.tl) : n.cells[t] = {
                                        type: o.ValueType.Null,
                                        address: s.encodeAddress(e, t)
                                    };
                                }
                            }
                        });
                    }
                    getMasterAddress(e) {
                        const t = this.hash[e];
                        return t && t.tl;
                    }
                };
            },
            {
                "../../../doc/enums": 7,
                "../../../doc/range": 10,
                "../../../utils/col-cache": 19,
                "../../../utils/under-dash": 26
            }
        ],
        101: [
            function(e, t, r) {
                "use strict";
                const n = e("../base-xform"), i = (e)=>void 0 !== e;
                t.exports = class extends n {
                    get tag() {
                        return "outlinePr";
                    }
                    render(e, t) {
                        return !(!t || !i(t.summaryBelow) && !i(t.summaryRight)) && (e.leafNode(this.tag, {
                            summaryBelow: i(t.summaryBelow) ? Number(t.summaryBelow) : void 0,
                            summaryRight: i(t.summaryRight) ? Number(t.summaryRight) : void 0
                        }), !0);
                    }
                    parseOpen(e) {
                        return e.name === this.tag && (this.model = {
                            summaryBelow: i(e.attributes.summaryBelow) ? Boolean(Number(e.attributes.summaryBelow)) : void 0,
                            summaryRight: i(e.attributes.summaryRight) ? Boolean(Number(e.attributes.summaryRight)) : void 0
                        }, !0);
                    }
                    parseText() {}
                    parseClose() {
                        return !1;
                    }
                };
            },
            {
                "../base-xform": 32
            }
        ],
        102: [
            function(e, t, r) {
                "use strict";
                const n = e("../base-xform");
                t.exports = class extends n {
                    get tag() {
                        return "brk";
                    }
                    render(e, t) {
                        e.leafNode("brk", t);
                    }
                    parseOpen(e) {
                        return "brk" === e.name && (this.model = e.attributes.ref, !0);
                    }
                    parseText() {}
                    parseClose() {
                        return !1;
                    }
                };
            },
            {
                "../base-xform": 32
            }
        ],
        103: [
            function(e, t, r) {
                "use strict";
                const n = e("../../../utils/under-dash"), i = e("../base-xform");
                t.exports = class extends i {
                    get tag() {
                        return "pageMargins";
                    }
                    render(e, t) {
                        if (t) {
                            const r = {
                                left: t.left,
                                right: t.right,
                                top: t.top,
                                bottom: t.bottom,
                                header: t.header,
                                footer: t.footer
                            };
                            n.some(r, (e)=>void 0 !== e) && e.leafNode(this.tag, r);
                        }
                    }
                    parseOpen(e) {
                        switch(e.name){
                            case this.tag:
                                return this.model = {
                                    left: parseFloat(e.attributes.left || .7),
                                    right: parseFloat(e.attributes.right || .7),
                                    top: parseFloat(e.attributes.top || .75),
                                    bottom: parseFloat(e.attributes.bottom || .75),
                                    header: parseFloat(e.attributes.header || .3),
                                    footer: parseFloat(e.attributes.footer || .3)
                                }, !0;
                            default:
                                return !1;
                        }
                    }
                    parseText() {}
                    parseClose() {
                        return !1;
                    }
                };
            },
            {
                "../../../utils/under-dash": 26,
                "../base-xform": 32
            }
        ],
        104: [
            function(e, t, r) {
                "use strict";
                const n = e("../base-xform");
                t.exports = class extends n {
                    get tag() {
                        return "pageSetUpPr";
                    }
                    render(e, t) {
                        return !(!t || !t.fitToPage) && (e.leafNode(this.tag, {
                            fitToPage: t.fitToPage ? "1" : void 0
                        }), !0);
                    }
                    parseOpen(e) {
                        return e.name === this.tag && (this.model = {
                            fitToPage: "1" === e.attributes.fitToPage
                        }, !0);
                    }
                    parseText() {}
                    parseClose() {
                        return !1;
                    }
                };
            },
            {
                "../base-xform": 32
            }
        ],
        105: [
            function(e, t, r) {
                "use strict";
                const n = e("../../../utils/under-dash"), i = e("../base-xform");
                function s(e) {
                    return e ? "1" : void 0;
                }
                function o(e) {
                    switch(e){
                        case "overThenDown":
                            return e;
                        default:
                            return;
                    }
                }
                function a(e) {
                    switch(e){
                        case "atEnd":
                        case "asDisplyed":
                            return e;
                        default:
                            return;
                    }
                }
                function l(e) {
                    switch(e){
                        case "dash":
                        case "blank":
                        case "NA":
                            return e;
                        default:
                            return;
                    }
                }
                t.exports = class extends i {
                    get tag() {
                        return "pageSetup";
                    }
                    render(e, t) {
                        if (t) {
                            const r = {
                                paperSize: t.paperSize,
                                orientation: t.orientation,
                                horizontalDpi: t.horizontalDpi,
                                verticalDpi: t.verticalDpi,
                                pageOrder: o(t.pageOrder),
                                blackAndWhite: s(t.blackAndWhite),
                                draft: s(t.draft),
                                cellComments: a(t.cellComments),
                                errors: l(t.errors),
                                scale: t.scale,
                                fitToWidth: t.fitToWidth,
                                fitToHeight: t.fitToHeight,
                                firstPageNumber: t.firstPageNumber,
                                useFirstPageNumber: s(t.firstPageNumber),
                                usePrinterDefaults: s(t.usePrinterDefaults),
                                copies: t.copies
                            };
                            n.some(r, (e)=>void 0 !== e) && e.leafNode(this.tag, r);
                        }
                    }
                    parseOpen(e) {
                        switch(e.name){
                            case this.tag:
                                return this.model = {
                                    paperSize: (t = e.attributes.paperSize, void 0 !== t ? parseInt(t, 10) : void 0),
                                    orientation: e.attributes.orientation || "portrait",
                                    horizontalDpi: parseInt(e.attributes.horizontalDpi || "4294967295", 10),
                                    verticalDpi: parseInt(e.attributes.verticalDpi || "4294967295", 10),
                                    pageOrder: e.attributes.pageOrder || "downThenOver",
                                    blackAndWhite: "1" === e.attributes.blackAndWhite,
                                    draft: "1" === e.attributes.draft,
                                    cellComments: e.attributes.cellComments || "None",
                                    errors: e.attributes.errors || "displayed",
                                    scale: parseInt(e.attributes.scale || "100", 10),
                                    fitToWidth: parseInt(e.attributes.fitToWidth || "1", 10),
                                    fitToHeight: parseInt(e.attributes.fitToHeight || "1", 10),
                                    firstPageNumber: parseInt(e.attributes.firstPageNumber || "1", 10),
                                    useFirstPageNumber: "1" === e.attributes.useFirstPageNumber,
                                    usePrinterDefaults: "1" === e.attributes.usePrinterDefaults,
                                    copies: parseInt(e.attributes.copies || "1", 10)
                                }, !0;
                            default:
                                return !1;
                        }
                        var t;
                    }
                    parseText() {}
                    parseClose() {
                        return !1;
                    }
                };
            },
            {
                "../../../utils/under-dash": 26,
                "../base-xform": 32
            }
        ],
        106: [
            function(e, t, r) {
                "use strict";
                const n = e("../base-xform");
                t.exports = class extends n {
                    get tag() {
                        return "picture";
                    }
                    render(e, t) {
                        t && e.leafNode(this.tag, {
                            "r:id": t.rId
                        });
                    }
                    parseOpen(e) {
                        switch(e.name){
                            case this.tag:
                                return this.model = {
                                    rId: e.attributes["r:id"]
                                }, !0;
                            default:
                                return !1;
                        }
                    }
                    parseText() {}
                    parseClose() {
                        return !1;
                    }
                };
            },
            {
                "../base-xform": 32
            }
        ],
        107: [
            function(e, t, r) {
                "use strict";
                const n = e("../../../utils/under-dash"), i = e("../base-xform");
                function s(e) {
                    return e ? "1" : void 0;
                }
                t.exports = class extends i {
                    get tag() {
                        return "printOptions";
                    }
                    render(e, t) {
                        if (t) {
                            const r = {
                                headings: s(t.showRowColHeaders),
                                gridLines: s(t.showGridLines),
                                horizontalCentered: s(t.horizontalCentered),
                                verticalCentered: s(t.verticalCentered)
                            };
                            n.some(r, (e)=>void 0 !== e) && e.leafNode(this.tag, r);
                        }
                    }
                    parseOpen(e) {
                        switch(e.name){
                            case this.tag:
                                return this.model = {
                                    showRowColHeaders: "1" === e.attributes.headings,
                                    showGridLines: "1" === e.attributes.gridLines,
                                    horizontalCentered: "1" === e.attributes.horizontalCentered,
                                    verticalCentered: "1" === e.attributes.verticalCentered
                                }, !0;
                            default:
                                return !1;
                        }
                    }
                    parseText() {}
                    parseClose() {
                        return !1;
                    }
                };
            },
            {
                "../../../utils/under-dash": 26,
                "../base-xform": 32
            }
        ],
        108: [
            function(e, t, r) {
                "use strict";
                const n = e("./page-breaks-xform"), i = e("../list-xform");
                t.exports = class extends i {
                    constructor(){
                        super({
                            tag: "rowBreaks",
                            count: !0,
                            childXform: new n
                        });
                    }
                    render(e, t) {
                        if (t && t.length) {
                            e.openNode(this.tag, this.$), this.count && (e.addAttribute(this.$count, t.length), e.addAttribute("manualBreakCount", t.length));
                            const { childXform: r } = this;
                            t.forEach((t)=>{
                                r.render(e, t);
                            }), e.closeNode();
                        } else this.empty && e.leafNode(this.tag);
                    }
                };
            },
            {
                "../list-xform": 71,
                "./page-breaks-xform": 102
            }
        ],
        109: [
            function(e, t, r) {
                "use strict";
                const n = e("../base-xform"), i = e("../../../utils/utils"), s = e("./cell-xform");
                t.exports = class extends n {
                    constructor(e){
                        super(), this.maxItems = e && e.maxItems, this.map = {
                            c: new s
                        };
                    }
                    get tag() {
                        return "row";
                    }
                    prepare(e, t) {
                        const r = t.styles.addStyleModel(e.style);
                        r && (e.styleId = r);
                        const n = this.map.c;
                        e.cells.forEach((e)=>{
                            n.prepare(e, t);
                        });
                    }
                    render(e, t, r) {
                        e.openNode("row"), e.addAttribute("r", t.number), t.height && (e.addAttribute("ht", t.height), e.addAttribute("customHeight", "1")), t.hidden && e.addAttribute("hidden", "1"), t.min > 0 && t.max > 0 && t.min <= t.max && e.addAttribute("spans", `${t.min}:${t.max}`), t.styleId && (e.addAttribute("s", t.styleId), e.addAttribute("customFormat", "1")), e.addAttribute("x14ac:dyDescent", "0.25"), t.outlineLevel && e.addAttribute("outlineLevel", t.outlineLevel), t.collapsed && e.addAttribute("collapsed", "1");
                        const n = this.map.c;
                        t.cells.forEach((t)=>{
                            n.render(e, t, r);
                        }), e.closeNode();
                    }
                    parseOpen(e) {
                        if (this.parser) return this.parser.parseOpen(e), !0;
                        if ("row" === e.name) {
                            this.numRowsSeen += 1;
                            const t = e.attributes.spans ? e.attributes.spans.split(":").map((e)=>parseInt(e, 10)) : [
                                void 0,
                                void 0
                            ], r = this.model = {
                                number: parseInt(e.attributes.r, 10),
                                min: t[0],
                                max: t[1],
                                cells: []
                            };
                            return e.attributes.s && (r.styleId = parseInt(e.attributes.s, 10)), i.parseBoolean(e.attributes.hidden) && (r.hidden = !0), i.parseBoolean(e.attributes.bestFit) && (r.bestFit = !0), e.attributes.ht && (r.height = parseFloat(e.attributes.ht)), e.attributes.outlineLevel && (r.outlineLevel = parseInt(e.attributes.outlineLevel, 10)), i.parseBoolean(e.attributes.collapsed) && (r.collapsed = !0), !0;
                        }
                        return this.parser = this.map[e.name], !!this.parser && (this.parser.parseOpen(e), !0);
                    }
                    parseText(e) {
                        this.parser && this.parser.parseText(e);
                    }
                    parseClose(e) {
                        if (this.parser) {
                            if (!this.parser.parseClose(e)) {
                                if (this.model.cells.push(this.parser.model), this.maxItems && this.model.cells.length > this.maxItems) throw new Error(`Max column count (${this.maxItems}) exceeded`);
                                this.parser = void 0;
                            }
                            return !0;
                        }
                        return !1;
                    }
                    reconcile(e, t) {
                        e.style = e.styleId ? t.styles.getStyleModel(e.styleId) : {}, void 0 !== e.styleId && (e.styleId = void 0);
                        const r = this.map.c;
                        e.cells.forEach((e)=>{
                            r.reconcile(e, t);
                        });
                    }
                };
            },
            {
                "../../../utils/utils": 27,
                "../base-xform": 32,
                "./cell-xform": 73
            }
        ],
        110: [
            function(e, t, r) {
                "use strict";
                const n = e("../../../utils/under-dash"), i = e("../base-xform");
                t.exports = class extends i {
                    get tag() {
                        return "sheetFormatPr";
                    }
                    render(e, t) {
                        if (t) {
                            const r = {
                                defaultRowHeight: t.defaultRowHeight,
                                outlineLevelRow: t.outlineLevelRow,
                                outlineLevelCol: t.outlineLevelCol,
                                "x14ac:dyDescent": t.dyDescent
                            };
                            t.defaultColWidth && (r.defaultColWidth = t.defaultColWidth), t.defaultRowHeight && 15 === t.defaultRowHeight || (r.customHeight = "1"), n.some(r, (e)=>void 0 !== e) && e.leafNode("sheetFormatPr", r);
                        }
                    }
                    parseOpen(e) {
                        return "sheetFormatPr" === e.name && (this.model = {
                            defaultRowHeight: parseFloat(e.attributes.defaultRowHeight || "0"),
                            dyDescent: parseFloat(e.attributes["x14ac:dyDescent"] || "0"),
                            outlineLevelRow: parseInt(e.attributes.outlineLevelRow || "0", 10),
                            outlineLevelCol: parseInt(e.attributes.outlineLevelCol || "0", 10)
                        }, e.attributes.defaultColWidth && (this.model.defaultColWidth = parseFloat(e.attributes.defaultColWidth)), !0);
                    }
                    parseText() {}
                    parseClose() {
                        return !1;
                    }
                };
            },
            {
                "../../../utils/under-dash": 26,
                "../base-xform": 32
            }
        ],
        111: [
            function(e, t, r) {
                "use strict";
                const n = e("../base-xform"), i = e("../style/color-xform"), s = e("./page-setup-properties-xform"), o = e("./outline-properties-xform");
                t.exports = class extends n {
                    constructor(){
                        super(), this.map = {
                            tabColor: new i("tabColor"),
                            pageSetUpPr: new s,
                            outlinePr: new o
                        };
                    }
                    get tag() {
                        return "sheetPr";
                    }
                    render(e, t) {
                        if (t) {
                            e.addRollback(), e.openNode("sheetPr");
                            let r = !1;
                            r = this.map.tabColor.render(e, t.tabColor) || r, r = this.map.pageSetUpPr.render(e, t.pageSetup) || r, r = this.map.outlinePr.render(e, t.outlineProperties) || r, r ? (e.closeNode(), e.commit()) : e.rollback();
                        }
                    }
                    parseOpen(e) {
                        return this.parser ? (this.parser.parseOpen(e), !0) : e.name === this.tag ? (this.reset(), !0) : !!this.map[e.name] && (this.parser = this.map[e.name], this.parser.parseOpen(e), !0);
                    }
                    parseText(e) {
                        return !!this.parser && (this.parser.parseText(e), !0);
                    }
                    parseClose(e) {
                        return this.parser ? (this.parser.parseClose(e) || (this.parser = void 0), !0) : (this.map.tabColor.model || this.map.pageSetUpPr.model || this.map.outlinePr.model ? (this.model = {}, this.map.tabColor.model && (this.model.tabColor = this.map.tabColor.model), this.map.pageSetUpPr.model && (this.model.pageSetup = this.map.pageSetUpPr.model), this.map.outlinePr.model && (this.model.outlineProperties = this.map.outlinePr.model)) : this.model = null, !1);
                    }
                };
            },
            {
                "../base-xform": 32,
                "../style/color-xform": 128,
                "./outline-properties-xform": 101,
                "./page-setup-properties-xform": 104
            }
        ],
        112: [
            function(e, t, r) {
                "use strict";
                const n = e("../../../utils/under-dash"), i = e("../base-xform");
                function s(e, t) {
                    return e ? t : void 0;
                }
                function o(e, t) {
                    return e === t || void 0;
                }
                t.exports = class extends i {
                    get tag() {
                        return "sheetProtection";
                    }
                    render(e, t) {
                        if (t) {
                            const r = {
                                sheet: s(t.sheet, "1"),
                                selectLockedCells: !1 === t.selectLockedCells ? "1" : void 0,
                                selectUnlockedCells: !1 === t.selectUnlockedCells ? "1" : void 0,
                                formatCells: s(t.formatCells, "0"),
                                formatColumns: s(t.formatColumns, "0"),
                                formatRows: s(t.formatRows, "0"),
                                insertColumns: s(t.insertColumns, "0"),
                                insertRows: s(t.insertRows, "0"),
                                insertHyperlinks: s(t.insertHyperlinks, "0"),
                                deleteColumns: s(t.deleteColumns, "0"),
                                deleteRows: s(t.deleteRows, "0"),
                                sort: s(t.sort, "0"),
                                autoFilter: s(t.autoFilter, "0"),
                                pivotTables: s(t.pivotTables, "0")
                            };
                            t.sheet && (r.algorithmName = t.algorithmName, r.hashValue = t.hashValue, r.saltValue = t.saltValue, r.spinCount = t.spinCount, r.objects = s(!1 === t.objects, "1"), r.scenarios = s(!1 === t.scenarios, "1")), n.some(r, (e)=>void 0 !== e) && e.leafNode(this.tag, r);
                        }
                    }
                    parseOpen(e) {
                        switch(e.name){
                            case this.tag:
                                return this.model = {
                                    sheet: o(e.attributes.sheet, "1"),
                                    objects: "1" !== e.attributes.objects && void 0,
                                    scenarios: "1" !== e.attributes.scenarios && void 0,
                                    selectLockedCells: "1" !== e.attributes.selectLockedCells && void 0,
                                    selectUnlockedCells: "1" !== e.attributes.selectUnlockedCells && void 0,
                                    formatCells: o(e.attributes.formatCells, "0"),
                                    formatColumns: o(e.attributes.formatColumns, "0"),
                                    formatRows: o(e.attributes.formatRows, "0"),
                                    insertColumns: o(e.attributes.insertColumns, "0"),
                                    insertRows: o(e.attributes.insertRows, "0"),
                                    insertHyperlinks: o(e.attributes.insertHyperlinks, "0"),
                                    deleteColumns: o(e.attributes.deleteColumns, "0"),
                                    deleteRows: o(e.attributes.deleteRows, "0"),
                                    sort: o(e.attributes.sort, "0"),
                                    autoFilter: o(e.attributes.autoFilter, "0"),
                                    pivotTables: o(e.attributes.pivotTables, "0")
                                }, e.attributes.algorithmName && (this.model.algorithmName = e.attributes.algorithmName, this.model.hashValue = e.attributes.hashValue, this.model.saltValue = e.attributes.saltValue, this.model.spinCount = parseInt(e.attributes.spinCount, 10)), !0;
                            default:
                                return !1;
                        }
                    }
                    parseText() {}
                    parseClose() {
                        return !1;
                    }
                };
            },
            {
                "../../../utils/under-dash": 26,
                "../base-xform": 32
            }
        ],
        113: [
            function(e, t, r) {
                "use strict";
                const n = e("../../../utils/col-cache"), i = e("../base-xform"), s = {
                    frozen: "frozen",
                    frozenSplit: "frozen",
                    split: "split"
                };
                t.exports = class extends i {
                    get tag() {
                        return "sheetView";
                    }
                    prepare(e) {
                        switch(e.state){
                            case "frozen":
                            case "split":
                                break;
                            default:
                                e.state = "normal";
                        }
                    }
                    render(e, t) {
                        e.openNode("sheetView", {
                            workbookViewId: t.workbookViewId || 0
                        });
                        const r = function(t, r, n) {
                            n && e.addAttribute(t, r);
                        };
                        let i, s, o, a;
                        switch(r("rightToLeft", "1", !0 === t.rightToLeft), r("tabSelected", "1", t.tabSelected), r("showRuler", "0", !1 === t.showRuler), r("showRowColHeaders", "0", !1 === t.showRowColHeaders), r("showGridLines", "0", !1 === t.showGridLines), r("zoomScale", t.zoomScale, t.zoomScale), r("zoomScaleNormal", t.zoomScaleNormal, t.zoomScaleNormal), r("view", t.style, t.style), t.state){
                            case "frozen":
                                s = t.xSplit || 0, o = t.ySplit || 0, i = t.topLeftCell || n.getAddress(o + 1, s + 1).address, a = (t.xSplit && t.ySplit ? "bottomRight" : t.xSplit && "topRight") || "bottomLeft", e.leafNode("pane", {
                                    xSplit: t.xSplit || void 0,
                                    ySplit: t.ySplit || void 0,
                                    topLeftCell: i,
                                    activePane: a,
                                    state: "frozen"
                                }), e.leafNode("selection", {
                                    pane: a,
                                    activeCell: t.activeCell,
                                    sqref: t.activeCell
                                });
                                break;
                            case "split":
                                "topLeft" === t.activePane && (t.activePane = void 0), e.leafNode("pane", {
                                    xSplit: t.xSplit || void 0,
                                    ySplit: t.ySplit || void 0,
                                    topLeftCell: t.topLeftCell,
                                    activePane: t.activePane
                                }), e.leafNode("selection", {
                                    pane: t.activePane,
                                    activeCell: t.activeCell,
                                    sqref: t.activeCell
                                });
                                break;
                            case "normal":
                                t.activeCell && e.leafNode("selection", {
                                    activeCell: t.activeCell,
                                    sqref: t.activeCell
                                });
                        }
                        e.closeNode();
                    }
                    parseOpen(e) {
                        switch(e.name){
                            case "sheetView":
                                return this.sheetView = {
                                    workbookViewId: parseInt(e.attributes.workbookViewId, 10),
                                    rightToLeft: "1" === e.attributes.rightToLeft,
                                    tabSelected: "1" === e.attributes.tabSelected,
                                    showRuler: !("0" === e.attributes.showRuler),
                                    showRowColHeaders: !("0" === e.attributes.showRowColHeaders),
                                    showGridLines: !("0" === e.attributes.showGridLines),
                                    zoomScale: parseInt(e.attributes.zoomScale || "100", 10),
                                    zoomScaleNormal: parseInt(e.attributes.zoomScaleNormal || "100", 10),
                                    style: e.attributes.view
                                }, this.pane = void 0, this.selections = {}, !0;
                            case "pane":
                                return this.pane = {
                                    xSplit: parseInt(e.attributes.xSplit || "0", 10),
                                    ySplit: parseInt(e.attributes.ySplit || "0", 10),
                                    topLeftCell: e.attributes.topLeftCell,
                                    activePane: e.attributes.activePane || "topLeft",
                                    state: e.attributes.state
                                }, !0;
                            case "selection":
                                {
                                    const t = e.attributes.pane || "topLeft";
                                    return this.selections[t] = {
                                        pane: t,
                                        activeCell: e.attributes.activeCell
                                    }, !0;
                                }
                            default:
                                return !1;
                        }
                    }
                    parseText() {}
                    parseClose(e) {
                        let t, r;
                        switch(e){
                            case "sheetView":
                                return this.sheetView && this.pane ? (t = this.model = {
                                    workbookViewId: this.sheetView.workbookViewId,
                                    rightToLeft: this.sheetView.rightToLeft,
                                    state: s[this.pane.state] || "split",
                                    xSplit: this.pane.xSplit,
                                    ySplit: this.pane.ySplit,
                                    topLeftCell: this.pane.topLeftCell,
                                    showRuler: this.sheetView.showRuler,
                                    showRowColHeaders: this.sheetView.showRowColHeaders,
                                    showGridLines: this.sheetView.showGridLines,
                                    zoomScale: this.sheetView.zoomScale,
                                    zoomScaleNormal: this.sheetView.zoomScaleNormal
                                }, "split" === this.model.state && (t.activePane = this.pane.activePane), r = this.selections[this.pane.activePane], r && r.activeCell && (t.activeCell = r.activeCell), this.sheetView.style && (t.style = this.sheetView.style)) : (t = this.model = {
                                    workbookViewId: this.sheetView.workbookViewId,
                                    rightToLeft: this.sheetView.rightToLeft,
                                    state: "normal",
                                    showRuler: this.sheetView.showRuler,
                                    showRowColHeaders: this.sheetView.showRowColHeaders,
                                    showGridLines: this.sheetView.showGridLines,
                                    zoomScale: this.sheetView.zoomScale,
                                    zoomScaleNormal: this.sheetView.zoomScaleNormal
                                }, r = this.selections.topLeft, r && r.activeCell && (t.activeCell = r.activeCell), this.sheetView.style && (t.style = this.sheetView.style)), !1;
                            default:
                                return !0;
                        }
                    }
                    reconcile() {}
                };
            },
            {
                "../../../utils/col-cache": 19,
                "../base-xform": 32
            }
        ],
        114: [
            function(e, t, r) {
                "use strict";
                const n = e("../base-xform");
                t.exports = class extends n {
                    get tag() {
                        return "tablePart";
                    }
                    render(e, t) {
                        t && e.leafNode(this.tag, {
                            "r:id": t.rId
                        });
                    }
                    parseOpen(e) {
                        switch(e.name){
                            case this.tag:
                                return this.model = {
                                    rId: e.attributes["r:id"]
                                }, !0;
                            default:
                                return !1;
                        }
                    }
                    parseText() {}
                    parseClose() {
                        return !1;
                    }
                };
            },
            {
                "../base-xform": 32
            }
        ],
        115: [
            function(e, t, r) {
                "use strict";
                const n = e("../../../utils/under-dash"), i = e("../../../utils/col-cache"), s = e("../../../utils/xml-stream"), o = e("../../rel-type"), a = e("./merges"), l = e("../base-xform"), c = e("../list-xform"), u = e("./row-xform"), h = e("./col-xform"), f = e("./dimension-xform"), d = e("./hyperlink-xform"), p = e("./merge-cell-xform"), m = e("./data-validations-xform"), b = e("./sheet-properties-xform"), g = e("./sheet-format-properties-xform"), y = e("./sheet-view-xform"), v = e("./sheet-protection-xform"), w = e("./page-margins-xform"), _ = e("./page-setup-xform"), x = e("./print-options-xform"), k = e("./auto-filter-xform"), S = e("./picture-xform"), M = e("./drawing-xform"), C = e("./table-part-xform"), T = e("./row-breaks-xform"), E = e("./header-footer-xform"), A = e("./cf/conditional-formattings-xform"), R = e("./ext-lst-xform"), O = (e, t)=>{
                    if (!t || !t.length) return e;
                    if (!e || !e.length) return t;
                    const r = {}, n = {};
                    return e.forEach((e)=>{
                        r[e.ref] = e, e.rules.forEach((e)=>{
                            const { x14Id: t } = e;
                            t && (n[t] = e);
                        });
                    }), t.forEach((t)=>{
                        t.rules.forEach((i)=>{
                            const s = n[i.x14Id];
                            s ? ((e, t)=>{
                                Object.keys(t).forEach((r)=>{
                                    const n = e[r], i = t[r];
                                    void 0 === n && void 0 !== i && (e[r] = i);
                                });
                            })(s, i) : r[t.ref] ? r[t.ref].rules.push(i) : e.push({
                                ref: t.ref,
                                rules: [
                                    i
                                ]
                            });
                        });
                    }), e;
                };
                class j extends l {
                    constructor(e){
                        super();
                        const { maxRows: t, maxCols: r, ignoreNodes: n } = e || {};
                        this.ignoreNodes = n || [], this.map = {
                            sheetPr: new b,
                            dimension: new f,
                            sheetViews: new c({
                                tag: "sheetViews",
                                count: !1,
                                childXform: new y
                            }),
                            sheetFormatPr: new g,
                            cols: new c({
                                tag: "cols",
                                count: !1,
                                childXform: new h
                            }),
                            sheetData: new c({
                                tag: "sheetData",
                                count: !1,
                                empty: !0,
                                childXform: new u({
                                    maxItems: r
                                }),
                                maxItems: t
                            }),
                            autoFilter: new k,
                            mergeCells: new c({
                                tag: "mergeCells",
                                count: !0,
                                childXform: new p
                            }),
                            rowBreaks: new T,
                            hyperlinks: new c({
                                tag: "hyperlinks",
                                count: !1,
                                childXform: new d
                            }),
                            pageMargins: new w,
                            dataValidations: new m,
                            pageSetup: new _,
                            headerFooter: new E,
                            printOptions: new x,
                            picture: new S,
                            drawing: new M,
                            sheetProtection: new v,
                            tableParts: new c({
                                tag: "tableParts",
                                count: !0,
                                childXform: new C
                            }),
                            conditionalFormatting: new A,
                            extLst: new R
                        };
                    }
                    prepare(e, t) {
                        t.merges = new a, e.hyperlinks = t.hyperlinks = [], e.comments = t.comments = [], t.formulae = {}, t.siFormulae = 0, this.map.cols.prepare(e.cols, t), this.map.sheetData.prepare(e.rows, t), this.map.conditionalFormatting.prepare(e.conditionalFormattings, t), e.mergeCells = t.merges.mergeCells;
                        const r = e.rels = [];
                        function n(e) {
                            return "rId" + (e.length + 1);
                        }
                        if (e.hyperlinks.forEach((e)=>{
                            const t = n(r);
                            e.rId = t, r.push({
                                Id: t,
                                Type: o.Hyperlink,
                                Target: e.target,
                                TargetMode: "External"
                            });
                        }), e.comments.length > 0) {
                            const s = {
                                Id: n(r),
                                Type: o.Comments,
                                Target: `../comments${e.id}.xml`
                            };
                            r.push(s);
                            const a = {
                                Id: n(r),
                                Type: o.VmlDrawing,
                                Target: `../drawings/vmlDrawing${e.id}.vml`
                            };
                            r.push(a), e.comments.forEach((e)=>{
                                e.refAddress = i.decodeAddress(e.ref);
                            }), t.commentRefs.push({
                                commentName: "comments" + e.id,
                                vmlDrawing: "vmlDrawing" + e.id
                            });
                        }
                        const s = [];
                        let l;
                        e.media.forEach((i)=>{
                            if ("background" === i.type) {
                                const s = n(r);
                                l = t.media[i.imageId], r.push({
                                    Id: s,
                                    Type: o.Image,
                                    Target: `../media/${l.name}.${l.extension}`
                                }), e.background = {
                                    rId: s
                                }, e.image = t.media[i.imageId];
                            } else if ("image" === i.type) {
                                let { drawing: a } = e;
                                l = t.media[i.imageId], a || (a = e.drawing = {
                                    rId: n(r),
                                    name: "drawing" + ++t.drawingsCount,
                                    anchors: [],
                                    rels: []
                                }, t.drawings.push(a), r.push({
                                    Id: a.rId,
                                    Type: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/drawing",
                                    Target: `../drawings/${a.name}.xml`
                                }));
                                let c = this.preImageId === i.imageId ? s[i.imageId] : s[a.rels.length];
                                c || (c = n(a.rels), s[a.rels.length] = c, a.rels.push({
                                    Id: c,
                                    Type: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/image",
                                    Target: `../media/${l.name}.${l.extension}`
                                }));
                                const u = {
                                    picture: {
                                        rId: c
                                    },
                                    range: i.range
                                };
                                if (i.hyperlinks && i.hyperlinks.hyperlink) {
                                    const e = n(a.rels);
                                    s[a.rels.length] = e, u.picture.hyperlinks = {
                                        tooltip: i.hyperlinks.tooltip,
                                        rId: e
                                    }, a.rels.push({
                                        Id: e,
                                        Type: o.Hyperlink,
                                        Target: i.hyperlinks.hyperlink,
                                        TargetMode: "External"
                                    });
                                }
                                this.preImageId = i.imageId, a.anchors.push(u);
                            }
                        }), e.tables.forEach((e)=>{
                            const i = n(r);
                            e.rId = i, r.push({
                                Id: i,
                                Type: o.Table,
                                Target: "../tables/" + e.target
                            }), e.columns.forEach((e)=>{
                                const { style: r } = e;
                                r && (e.dxfId = t.styles.addDxfStyle(r));
                            });
                        }), this.map.extLst.prepare(e, t);
                    }
                    render(e, t) {
                        e.openXml(s.StdDocAttributes), e.openNode("worksheet", j.WORKSHEET_ATTRIBUTES);
                        const r = t.properties ? {
                            defaultRowHeight: t.properties.defaultRowHeight,
                            dyDescent: t.properties.dyDescent,
                            outlineLevelCol: t.properties.outlineLevelCol,
                            outlineLevelRow: t.properties.outlineLevelRow
                        } : void 0;
                        t.properties && t.properties.defaultColWidth && (r.defaultColWidth = t.properties.defaultColWidth);
                        const n = {
                            outlineProperties: t.properties && t.properties.outlineProperties,
                            tabColor: t.properties && t.properties.tabColor,
                            pageSetup: t.pageSetup && t.pageSetup.fitToPage ? {
                                fitToPage: t.pageSetup.fitToPage
                            } : void 0
                        }, i = t.pageSetup && t.pageSetup.margins, a = {
                            showRowColHeaders: t.pageSetup && t.pageSetup.showRowColHeaders,
                            showGridLines: t.pageSetup && t.pageSetup.showGridLines,
                            horizontalCentered: t.pageSetup && t.pageSetup.horizontalCentered,
                            verticalCentered: t.pageSetup && t.pageSetup.verticalCentered
                        }, l = t.sheetProtection;
                        this.map.sheetPr.render(e, n), this.map.dimension.render(e, t.dimensions), this.map.sheetViews.render(e, t.views), this.map.sheetFormatPr.render(e, r), this.map.cols.render(e, t.cols), this.map.sheetData.render(e, t.rows), this.map.sheetProtection.render(e, l), this.map.autoFilter.render(e, t.autoFilter), this.map.mergeCells.render(e, t.mergeCells), this.map.conditionalFormatting.render(e, t.conditionalFormattings), this.map.dataValidations.render(e, t.dataValidations), this.map.hyperlinks.render(e, t.hyperlinks), this.map.printOptions.render(e, a), this.map.pageMargins.render(e, i), this.map.pageSetup.render(e, t.pageSetup), this.map.headerFooter.render(e, t.headerFooter), this.map.rowBreaks.render(e, t.rowBreaks), this.map.drawing.render(e, t.drawing), this.map.picture.render(e, t.background), this.map.tableParts.render(e, t.tables), this.map.extLst.render(e, t), t.rels && t.rels.forEach((t)=>{
                            t.Type === o.VmlDrawing && e.leafNode("legacyDrawing", {
                                "r:id": t.Id
                            });
                        }), e.closeNode();
                    }
                    parseOpen(e) {
                        return this.parser ? (this.parser.parseOpen(e), !0) : "worksheet" === e.name ? (n.each(this.map, (e)=>{
                            e.reset();
                        }), !0) : (this.map[e.name] && !this.ignoreNodes.includes(e.name) && (this.parser = this.map[e.name], this.parser.parseOpen(e)), !0);
                    }
                    parseText(e) {
                        this.parser && this.parser.parseText(e);
                    }
                    parseClose(e) {
                        if (this.parser) return this.parser.parseClose(e) || (this.parser = void 0), !0;
                        switch(e){
                            case "worksheet":
                                {
                                    const e = this.map.sheetFormatPr.model || {};
                                    this.map.sheetPr.model && this.map.sheetPr.model.tabColor && (e.tabColor = this.map.sheetPr.model.tabColor), this.map.sheetPr.model && this.map.sheetPr.model.outlineProperties && (e.outlineProperties = this.map.sheetPr.model.outlineProperties);
                                    const t = {
                                        fitToPage: this.map.sheetPr.model && this.map.sheetPr.model.pageSetup && this.map.sheetPr.model.pageSetup.fitToPage || !1,
                                        margins: this.map.pageMargins.model
                                    }, r = Object.assign(t, this.map.pageSetup.model, this.map.printOptions.model), n = O(this.map.conditionalFormatting.model, this.map.extLst.model && this.map.extLst.model["x14:conditionalFormattings"]);
                                    return this.model = {
                                        dimensions: this.map.dimension.model,
                                        cols: this.map.cols.model,
                                        rows: this.map.sheetData.model,
                                        mergeCells: this.map.mergeCells.model,
                                        hyperlinks: this.map.hyperlinks.model,
                                        dataValidations: this.map.dataValidations.model,
                                        properties: e,
                                        views: this.map.sheetViews.model,
                                        pageSetup: r,
                                        headerFooter: this.map.headerFooter.model,
                                        background: this.map.picture.model,
                                        drawing: this.map.drawing.model,
                                        tables: this.map.tableParts.model,
                                        conditionalFormattings: n
                                    }, this.map.autoFilter.model && (this.model.autoFilter = this.map.autoFilter.model), this.map.sheetProtection.model && (this.model.sheetProtection = this.map.sheetProtection.model), !1;
                                }
                            default:
                                return !0;
                        }
                    }
                    reconcile(e, t) {
                        const r = (e.relationships || []).reduce((r, n)=>{
                            if (r[n.Id] = n, n.Type === o.Comments && (e.comments = t.comments[n.Target].comments), n.Type === o.VmlDrawing && e.comments && e.comments.length) {
                                const r = t.vmlDrawings[n.Target].comments;
                                e.comments.forEach((e, t)=>{
                                    e.note = Object.assign({}, e.note, r[t]);
                                });
                            }
                            return r;
                        }, {});
                        if (t.commentsMap = (e.comments || []).reduce((e, t)=>(t.ref && (e[t.ref] = t), e), {}), t.hyperlinkMap = (e.hyperlinks || []).reduce((e, t)=>(t.rId && (e[t.address] = r[t.rId].Target), e), {}), t.formulae = {}, e.rows = e.rows && e.rows.filter(Boolean) || [], e.rows.forEach((e)=>{
                            e.cells = e.cells && e.cells.filter(Boolean) || [];
                        }), this.map.cols.reconcile(e.cols, t), this.map.sheetData.reconcile(e.rows, t), this.map.conditionalFormatting.reconcile(e.conditionalFormattings, t), e.media = [], e.drawing) {
                            const n = r[e.drawing.rId].Target.match(/\/drawings\/([a-zA-Z0-9]+)[.][a-zA-Z]{3,4}$/);
                            if (n) {
                                const r = n[1];
                                t.drawings[r].anchors.forEach((t)=>{
                                    if (t.medium) {
                                        const r = {
                                            type: "image",
                                            imageId: t.medium.index,
                                            range: t.range,
                                            hyperlinks: t.picture.hyperlinks
                                        };
                                        e.media.push(r);
                                    }
                                });
                            }
                        }
                        const n = e.background && r[e.background.rId];
                        if (n) {
                            const r = n.Target.split("/media/")[1], i = t.mediaIndex && t.mediaIndex[r];
                            void 0 !== i && e.media.push({
                                type: "background",
                                imageId: i
                            });
                        }
                        e.tables = (e.tables || []).map((e)=>{
                            const n = r[e.rId];
                            return t.tables[n.Target];
                        }), delete e.relationships, delete e.hyperlinks, delete e.comments;
                    }
                }
                j.WORKSHEET_ATTRIBUTES = {
                    xmlns: "http://schemas.openxmlformats.org/spreadsheetml/2006/main",
                    "xmlns:r": "http://schemas.openxmlformats.org/officeDocument/2006/relationships",
                    "xmlns:mc": "http://schemas.openxmlformats.org/markup-compatibility/2006",
                    "mc:Ignorable": "x14ac",
                    "xmlns:x14ac": "http://schemas.microsoft.com/office/spreadsheetml/2009/9/ac"
                }, t.exports = j;
            },
            {
                "../../../utils/col-cache": 19,
                "../../../utils/under-dash": 26,
                "../../../utils/xml-stream": 28,
                "../../rel-type": 31,
                "../base-xform": 32,
                "../list-xform": 71,
                "./auto-filter-xform": 72,
                "./cf/conditional-formattings-xform": 87,
                "./col-xform": 92,
                "./data-validations-xform": 93,
                "./dimension-xform": 94,
                "./drawing-xform": 95,
                "./ext-lst-xform": 96,
                "./header-footer-xform": 97,
                "./hyperlink-xform": 98,
                "./merge-cell-xform": 99,
                "./merges": 100,
                "./page-margins-xform": 103,
                "./page-setup-xform": 105,
                "./picture-xform": 106,
                "./print-options-xform": 107,
                "./row-breaks-xform": 108,
                "./row-xform": 109,
                "./sheet-format-properties-xform": 110,
                "./sheet-properties-xform": 111,
                "./sheet-protection-xform": 112,
                "./sheet-view-xform": 113,
                "./table-part-xform": 114
            }
        ],
        116: [
            function(e, t, r) {
                "use strict";
                const n = e("../base-xform");
                t.exports = class extends n {
                    constructor(e){
                        super(), this.tag = e.tag, this.attr = e.attr;
                    }
                    render(e, t) {
                        t && (e.openNode(this.tag), e.closeNode());
                    }
                    parseOpen(e) {
                        e.name === this.tag && (this.model = !0);
                    }
                    parseText() {}
                    parseClose() {
                        return !1;
                    }
                };
            },
            {
                "../base-xform": 32
            }
        ],
        117: [
            function(e, t, r) {
                "use strict";
                const n = e("../base-xform");
                t.exports = class extends n {
                    constructor(e){
                        super(), this.tag = e.tag, this.attr = e.attr, this.attrs = e.attrs, this._format = e.format || function(e) {
                            try {
                                return Number.isNaN(e.getTime()) ? "" : e.toISOString();
                            } catch (e) {
                                return "";
                            }
                        }, this._parse = e.parse || function(e) {
                            return new Date(e);
                        };
                    }
                    render(e, t) {
                        t && (e.openNode(this.tag), this.attrs && e.addAttributes(this.attrs), this.attr ? e.addAttribute(this.attr, this._format(t)) : e.writeText(this._format(t)), e.closeNode());
                    }
                    parseOpen(e) {
                        e.name === this.tag && (this.attr ? this.model = this._parse(e.attributes[this.attr]) : this.text = []);
                    }
                    parseText(e) {
                        this.attr || this.text.push(e);
                    }
                    parseClose() {
                        return this.attr || (this.model = this._parse(this.text.join(""))), !1;
                    }
                };
            },
            {
                "../base-xform": 32
            }
        ],
        118: [
            function(e, t, r) {
                "use strict";
                const n = e("../base-xform");
                t.exports = class extends n {
                    constructor(e){
                        super(), this.tag = e.tag, this.attr = e.attr, this.attrs = e.attrs, this.zero = e.zero;
                    }
                    render(e, t) {
                        (t || this.zero) && (e.openNode(this.tag), this.attrs && e.addAttributes(this.attrs), this.attr ? e.addAttribute(this.attr, t) : e.writeText(t), e.closeNode());
                    }
                    parseOpen(e) {
                        return e.name === this.tag && (this.attr ? this.model = parseInt(e.attributes[this.attr], 10) : this.text = [], !0);
                    }
                    parseText(e) {
                        this.attr || this.text.push(e);
                    }
                    parseClose() {
                        return this.attr || (this.model = parseInt(this.text.join("") || 0, 10)), !1;
                    }
                };
            },
            {
                "../base-xform": 32
            }
        ],
        119: [
            function(e, t, r) {
                "use strict";
                const n = e("../base-xform");
                t.exports = class extends n {
                    constructor(e){
                        super(), this.tag = e.tag, this.attr = e.attr, this.attrs = e.attrs;
                    }
                    render(e, t) {
                        void 0 !== t && (e.openNode(this.tag), this.attrs && e.addAttributes(this.attrs), this.attr ? e.addAttribute(this.attr, t) : e.writeText(t), e.closeNode());
                    }
                    parseOpen(e) {
                        e.name === this.tag && (this.attr ? this.model = e.attributes[this.attr] : this.text = []);
                    }
                    parseText(e) {
                        this.attr || this.text.push(e);
                    }
                    parseClose() {
                        return this.attr || (this.model = this.text.join("")), !1;
                    }
                };
            },
            {
                "../base-xform": 32
            }
        ],
        120: [
            function(e, t, r) {
                "use strict";
                const n = e("./base-xform"), i = e("../../utils/xml-stream");
                t.exports = class extends n {
                    constructor(e){
                        super(), this._model = e;
                    }
                    render(e) {
                        if (!this._xml) {
                            const e = new i;
                            !function e(t, r) {
                                t.openNode(r.tag, r.$), r.c && r.c.forEach((r)=>{
                                    e(t, r);
                                }), r.t && t.writeText(r.t), t.closeNode();
                            }(e, this._model), this._xml = e.xml;
                        }
                        e.writeXml(this._xml);
                    }
                    parseOpen() {
                        return !0;
                    }
                    parseText() {}
                    parseClose(e) {
                        switch(e){
                            case this._model.tag:
                                return !1;
                            default:
                                return !0;
                        }
                    }
                };
            },
            {
                "../../utils/xml-stream": 28,
                "./base-xform": 32
            }
        ],
        121: [
            function(e, t, r) {
                "use strict";
                const n = e("./text-xform"), i = e("./rich-text-xform"), s = e("../base-xform");
                t.exports = class extends s {
                    constructor(){
                        super(), this.map = {
                            r: new i,
                            t: new n
                        };
                    }
                    get tag() {
                        return "rPh";
                    }
                    render(e, t) {
                        if (e.openNode(this.tag, {
                            sb: t.sb || 0,
                            eb: t.eb || 0
                        }), t && t.hasOwnProperty("richText") && t.richText) {
                            const { r: r } = this.map;
                            t.richText.forEach((t)=>{
                                r.render(e, t);
                            });
                        } else t && this.map.t.render(e, t.text);
                        e.closeNode();
                    }
                    parseOpen(e) {
                        const { name: t } = e;
                        return this.parser ? (this.parser.parseOpen(e), !0) : t === this.tag ? (this.model = {
                            sb: parseInt(e.attributes.sb, 10),
                            eb: parseInt(e.attributes.eb, 10)
                        }, !0) : (this.parser = this.map[t], !!this.parser && (this.parser.parseOpen(e), !0));
                    }
                    parseText(e) {
                        this.parser && this.parser.parseText(e);
                    }
                    parseClose(e) {
                        if (this.parser) {
                            if (!this.parser.parseClose(e)) {
                                switch(e){
                                    case "r":
                                        {
                                            let e = this.model.richText;
                                            e || (e = this.model.richText = []), e.push(this.parser.model);
                                            break;
                                        }
                                    case "t":
                                        this.model.text = this.parser.model;
                                }
                                this.parser = void 0;
                            }
                            return !0;
                        }
                        switch(e){
                            case this.tag:
                                return !1;
                            default:
                                return !0;
                        }
                    }
                };
            },
            {
                "../base-xform": 32,
                "./rich-text-xform": 122,
                "./text-xform": 125
            }
        ],
        122: [
            function(e, t, r) {
                "use strict";
                const n = e("./text-xform"), i = e("../style/font-xform"), s = e("../base-xform");
                class o extends s {
                    constructor(e){
                        super(), this.model = e;
                    }
                    get tag() {
                        return "r";
                    }
                    get textXform() {
                        return this._textXform || (this._textXform = new n);
                    }
                    get fontXform() {
                        return this._fontXform || (this._fontXform = new i(o.FONT_OPTIONS));
                    }
                    render(e, t) {
                        t = t || this.model, e.openNode("r"), t.font && this.fontXform.render(e, t.font), this.textXform.render(e, t.text), e.closeNode();
                    }
                    parseOpen(e) {
                        if (this.parser) return this.parser.parseOpen(e), !0;
                        switch(e.name){
                            case "r":
                                return this.model = {}, !0;
                            case "t":
                                return this.parser = this.textXform, this.parser.parseOpen(e), !0;
                            case "rPr":
                                return this.parser = this.fontXform, this.parser.parseOpen(e), !0;
                            default:
                                return !1;
                        }
                    }
                    parseText(e) {
                        this.parser && this.parser.parseText(e);
                    }
                    parseClose(e) {
                        switch(e){
                            case "r":
                                return !1;
                            case "t":
                                return this.model.text = this.parser.model, this.parser = void 0, !0;
                            case "rPr":
                                return this.model.font = this.parser.model, this.parser = void 0, !0;
                            default:
                                return this.parser && this.parser.parseClose(e), !0;
                        }
                    }
                }
                o.FONT_OPTIONS = {
                    tagName: "rPr",
                    fontNameTag: "rFont"
                }, t.exports = o;
            },
            {
                "../base-xform": 32,
                "../style/font-xform": 131,
                "./text-xform": 125
            }
        ],
        123: [
            function(e, t, r) {
                "use strict";
                const n = e("./text-xform"), i = e("./rich-text-xform"), s = e("./phonetic-text-xform"), o = e("../base-xform");
                t.exports = class extends o {
                    constructor(e){
                        super(), this.model = e, this.map = {
                            r: new i,
                            t: new n,
                            rPh: new s
                        };
                    }
                    get tag() {
                        return "si";
                    }
                    render(e, t) {
                        e.openNode(this.tag), t && t.hasOwnProperty("richText") && t.richText ? t.richText.length ? t.richText.forEach((t)=>{
                            this.map.r.render(e, t);
                        }) : this.map.t.render(e, "") : null != t && this.map.t.render(e, t), e.closeNode();
                    }
                    parseOpen(e) {
                        const { name: t } = e;
                        return this.parser ? (this.parser.parseOpen(e), !0) : t === this.tag ? (this.model = {}, !0) : (this.parser = this.map[t], !!this.parser && (this.parser.parseOpen(e), !0));
                    }
                    parseText(e) {
                        this.parser && this.parser.parseText(e);
                    }
                    parseClose(e) {
                        if (this.parser) {
                            if (!this.parser.parseClose(e)) {
                                switch(e){
                                    case "r":
                                        {
                                            let e = this.model.richText;
                                            e || (e = this.model.richText = []), e.push(this.parser.model);
                                            break;
                                        }
                                    case "t":
                                        this.model = this.parser.model;
                                }
                                this.parser = void 0;
                            }
                            return !0;
                        }
                        switch(e){
                            case this.tag:
                                return !1;
                            default:
                                return !0;
                        }
                    }
                };
            },
            {
                "../base-xform": 32,
                "./phonetic-text-xform": 121,
                "./rich-text-xform": 122,
                "./text-xform": 125
            }
        ],
        124: [
            function(e, t, r) {
                "use strict";
                const n = e("../../../utils/xml-stream"), i = e("../base-xform"), s = e("./shared-string-xform");
                t.exports = class extends i {
                    constructor(e){
                        super(), this.model = e || {
                            values: [],
                            count: 0
                        }, this.hash = Object.create(null), this.rich = Object.create(null);
                    }
                    get sharedStringXform() {
                        return this._sharedStringXform || (this._sharedStringXform = new s);
                    }
                    get values() {
                        return this.model.values;
                    }
                    get uniqueCount() {
                        return this.model.values.length;
                    }
                    get count() {
                        return this.model.count;
                    }
                    getString(e) {
                        return this.model.values[e];
                    }
                    add(e) {
                        return e.richText ? this.addRichText(e) : this.addText(e);
                    }
                    addText(e) {
                        let t = this.hash[e];
                        return void 0 === t && (t = this.hash[e] = this.model.values.length, this.model.values.push(e)), this.model.count++, t;
                    }
                    addRichText(e) {
                        const t = this.sharedStringXform.toXml(e);
                        let r = this.rich[t];
                        return void 0 === r && (r = this.rich[t] = this.model.values.length, this.model.values.push(e)), this.model.count++, r;
                    }
                    render(e, t) {
                        t = t || this._values, e.openXml(n.StdDocAttributes), e.openNode("sst", {
                            xmlns: "http://schemas.openxmlformats.org/spreadsheetml/2006/main",
                            count: t.count,
                            uniqueCount: t.values.length
                        });
                        const r = this.sharedStringXform;
                        t.values.forEach((t)=>{
                            r.render(e, t);
                        }), e.closeNode();
                    }
                    parseOpen(e) {
                        if (this.parser) return this.parser.parseOpen(e), !0;
                        switch(e.name){
                            case "sst":
                                return !0;
                            case "si":
                                return this.parser = this.sharedStringXform, this.parser.parseOpen(e), !0;
                            default:
                                throw new Error("Unexpected xml node in parseOpen: " + JSON.stringify(e));
                        }
                    }
                    parseText(e) {
                        this.parser && this.parser.parseText(e);
                    }
                    parseClose(e) {
                        if (this.parser) return this.parser.parseClose(e) || (this.model.values.push(this.parser.model), this.model.count++, this.parser = void 0), !0;
                        switch(e){
                            case "sst":
                                return !1;
                            default:
                                throw new Error("Unexpected xml node in parseClose: " + e);
                        }
                    }
                };
            },
            {
                "../../../utils/xml-stream": 28,
                "../base-xform": 32,
                "./shared-string-xform": 123
            }
        ],
        125: [
            function(e, t, r) {
                "use strict";
                const n = e("../base-xform");
                t.exports = class extends n {
                    get tag() {
                        return "t";
                    }
                    render(e, t) {
                        e.openNode("t"), /^\s|\n|\s$/.test(t) && e.addAttribute("xml:space", "preserve"), e.writeText(t), e.closeNode();
                    }
                    get model() {
                        return this._text.join("").replace(/_x([0-9A-F]{4})_/g, (e, t)=>String.fromCharCode(parseInt(t, 16)));
                    }
                    parseOpen(e) {
                        switch(e.name){
                            case "t":
                                return this._text = [], !0;
                            default:
                                return !1;
                        }
                    }
                    parseText(e) {
                        this._text.push(e);
                    }
                    parseClose() {
                        return !1;
                    }
                };
            },
            {
                "../base-xform": 32
            }
        ],
        126: [
            function(e, t, r) {
                "use strict";
                const n = e("../../../doc/enums"), i = e("../../../utils/utils"), s = e("../base-xform"), o = {
                    horizontalValues: [
                        "left",
                        "center",
                        "right",
                        "fill",
                        "centerContinuous",
                        "distributed",
                        "justify"
                    ].reduce((e, t)=>(e[t] = !0, e), {}),
                    horizontal (e) {
                        return this.horizontalValues[e] ? e : void 0;
                    },
                    verticalValues: [
                        "top",
                        "middle",
                        "bottom",
                        "distributed",
                        "justify"
                    ].reduce((e, t)=>(e[t] = !0, e), {}),
                    vertical (e) {
                        return "middle" === e ? "center" : this.verticalValues[e] ? e : void 0;
                    },
                    wrapText: (e)=>!!e || void 0,
                    shrinkToFit: (e)=>!!e || void 0,
                    textRotation (e) {
                        switch(e){
                            case "vertical":
                                return e;
                            default:
                                return (e = i.validInt(e)) >= -90 && e <= 90 ? e : void 0;
                        }
                    },
                    indent: (e)=>(e = i.validInt(e), Math.max(0, e)),
                    readingOrder (e) {
                        switch(e){
                            case "ltr":
                                return n.ReadingOrder.LeftToRight;
                            case "rtl":
                                return n.ReadingOrder.RightToLeft;
                            default:
                                return;
                        }
                    }
                }, a = {
                    toXml (e) {
                        if (e = o.textRotation(e)) {
                            if ("vertical" === e) return 255;
                            const t = Math.round(e);
                            if (t >= 0 && t <= 90) return t;
                            if (t < 0 && t >= -90) return 90 - t;
                        }
                    },
                    toModel (e) {
                        const t = i.validInt(e);
                        if (void 0 !== t) {
                            if (255 === t) return "vertical";
                            if (t >= 0 && t <= 90) return t;
                            if (t > 90 && t <= 180) return 90 - t;
                        }
                    }
                };
                t.exports = class extends s {
                    get tag() {
                        return "alignment";
                    }
                    render(e, t) {
                        e.addRollback(), e.openNode("alignment");
                        let r = !1;
                        function n(t, n) {
                            n && (e.addAttribute(t, n), r = !0);
                        }
                        n("horizontal", o.horizontal(t.horizontal)), n("vertical", o.vertical(t.vertical)), n("wrapText", !!o.wrapText(t.wrapText) && "1"), n("shrinkToFit", !!o.shrinkToFit(t.shrinkToFit) && "1"), n("indent", o.indent(t.indent)), n("textRotation", a.toXml(t.textRotation)), n("readingOrder", o.readingOrder(t.readingOrder)), e.closeNode(), r ? e.commit() : e.rollback();
                    }
                    parseOpen(e) {
                        const t = {};
                        let r = !1;
                        function n(e, n, i) {
                            e && (t[n] = i, r = !0);
                        }
                        n(e.attributes.horizontal, "horizontal", e.attributes.horizontal), n(e.attributes.vertical, "vertical", "center" === e.attributes.vertical ? "middle" : e.attributes.vertical), n(e.attributes.wrapText, "wrapText", i.parseBoolean(e.attributes.wrapText)), n(e.attributes.shrinkToFit, "shrinkToFit", i.parseBoolean(e.attributes.shrinkToFit)), n(e.attributes.indent, "indent", parseInt(e.attributes.indent, 10)), n(e.attributes.textRotation, "textRotation", a.toModel(e.attributes.textRotation)), n(e.attributes.readingOrder, "readingOrder", "2" === e.attributes.readingOrder ? "rtl" : "ltr"), this.model = r ? t : null;
                    }
                    parseText() {}
                    parseClose() {
                        return !1;
                    }
                };
            },
            {
                "../../../doc/enums": 7,
                "../../../utils/utils": 27,
                "../base-xform": 32
            }
        ],
        127: [
            function(e, t, r) {
                "use strict";
                const n = e("../base-xform"), i = e("../../../utils/utils"), s = e("./color-xform");
                class o extends n {
                    constructor(e){
                        super(), this.name = e, this.map = {
                            color: new s
                        };
                    }
                    get tag() {
                        return this.name;
                    }
                    render(e, t, r) {
                        const n = t && t.color || r || this.defaultColor;
                        e.openNode(this.name), t && t.style && (e.addAttribute("style", t.style), n && this.map.color.render(e, n)), e.closeNode();
                    }
                    parseOpen(e) {
                        if (this.parser) return this.parser.parseOpen(e), !0;
                        switch(e.name){
                            case this.name:
                                {
                                    const { style: t } = e.attributes;
                                    return this.model = t ? {
                                        style: t
                                    } : void 0, !0;
                                }
                            case "color":
                                return this.parser = this.map.color, this.parser.parseOpen(e), !0;
                            default:
                                return !1;
                        }
                    }
                    parseText(e) {
                        this.parser && this.parser.parseText(e);
                    }
                    parseClose(e) {
                        return this.parser ? (this.parser.parseClose(e) || (this.parser = void 0), !0) : (e === this.name && this.map.color.model && (this.model || (this.model = {}), this.model.color = this.map.color.model), !1);
                    }
                    validStyle(e) {
                        return o.validStyleValues[e];
                    }
                }
                o.validStyleValues = [
                    "thin",
                    "dashed",
                    "dotted",
                    "dashDot",
                    "hair",
                    "dashDotDot",
                    "slantDashDot",
                    "mediumDashed",
                    "mediumDashDotDot",
                    "mediumDashDot",
                    "medium",
                    "double",
                    "thick"
                ].reduce((e, t)=>(e[t] = !0, e), {});
                t.exports = class extends n {
                    constructor(){
                        super(), this.map = {
                            top: new o("top"),
                            left: new o("left"),
                            bottom: new o("bottom"),
                            right: new o("right"),
                            diagonal: new o("diagonal")
                        };
                    }
                    render(e, t) {
                        const { color: r } = t;
                        function n(n, i) {
                            n && !n.color && t.color && (n = {
                                ...n,
                                color: t.color
                            }), i.render(e, n, r);
                        }
                        e.openNode("border"), t.diagonal && t.diagonal.style && (t.diagonal.up && e.addAttribute("diagonalUp", "1"), t.diagonal.down && e.addAttribute("diagonalDown", "1")), n(t.left, this.map.left), n(t.right, this.map.right), n(t.top, this.map.top), n(t.bottom, this.map.bottom), n(t.diagonal, this.map.diagonal), e.closeNode();
                    }
                    parseOpen(e) {
                        if (this.parser) return this.parser.parseOpen(e), !0;
                        switch(e.name){
                            case "border":
                                return this.reset(), this.diagonalUp = i.parseBoolean(e.attributes.diagonalUp), this.diagonalDown = i.parseBoolean(e.attributes.diagonalDown), !0;
                            default:
                                return this.parser = this.map[e.name], !!this.parser && (this.parser.parseOpen(e), !0);
                        }
                    }
                    parseText(e) {
                        this.parser && this.parser.parseText(e);
                    }
                    parseClose(e) {
                        if (this.parser) return this.parser.parseClose(e) || (this.parser = void 0), !0;
                        if ("border" === e) {
                            const e = this.model = {}, t = function(t, r, n) {
                                r && (n && Object.assign(r, n), e[t] = r);
                            };
                            t("left", this.map.left.model), t("right", this.map.right.model), t("top", this.map.top.model), t("bottom", this.map.bottom.model), t("diagonal", this.map.diagonal.model, {
                                up: this.diagonalUp,
                                down: this.diagonalDown
                            });
                        }
                        return !1;
                    }
                };
            },
            {
                "../../../utils/utils": 27,
                "../base-xform": 32,
                "./color-xform": 128
            }
        ],
        128: [
            function(e, t, r) {
                "use strict";
                const n = e("../base-xform");
                t.exports = class extends n {
                    constructor(e){
                        super(), this.name = e || "color";
                    }
                    get tag() {
                        return this.name;
                    }
                    render(e, t) {
                        return !!t && (e.openNode(this.name), t.argb ? e.addAttribute("rgb", t.argb) : void 0 !== t.theme ? (e.addAttribute("theme", t.theme), void 0 !== t.tint && e.addAttribute("tint", t.tint)) : void 0 !== t.indexed ? e.addAttribute("indexed", t.indexed) : e.addAttribute("auto", "1"), e.closeNode(), !0);
                    }
                    parseOpen(e) {
                        return e.name === this.name && (e.attributes.rgb ? this.model = {
                            argb: e.attributes.rgb
                        } : e.attributes.theme ? (this.model = {
                            theme: parseInt(e.attributes.theme, 10)
                        }, e.attributes.tint && (this.model.tint = parseFloat(e.attributes.tint))) : e.attributes.indexed ? this.model = {
                            indexed: parseInt(e.attributes.indexed, 10)
                        } : this.model = void 0, !0);
                    }
                    parseText() {}
                    parseClose() {
                        return !1;
                    }
                };
            },
            {
                "../base-xform": 32
            }
        ],
        129: [
            function(e, t, r) {
                "use strict";
                const n = e("../base-xform"), i = e("./alignment-xform"), s = e("./border-xform"), o = e("./fill-xform"), a = e("./font-xform"), l = e("./numfmt-xform"), c = e("./protection-xform");
                t.exports = class extends n {
                    constructor(){
                        super(), this.map = {
                            alignment: new i,
                            border: new s,
                            fill: new o,
                            font: new a,
                            numFmt: new l,
                            protection: new c
                        };
                    }
                    get tag() {
                        return "dxf";
                    }
                    render(e, t) {
                        if (e.openNode(this.tag), t.font && this.map.font.render(e, t.font), t.numFmt && t.numFmtId) {
                            const r = {
                                id: t.numFmtId,
                                formatCode: t.numFmt
                            };
                            this.map.numFmt.render(e, r);
                        }
                        t.fill && this.map.fill.render(e, t.fill), t.alignment && this.map.alignment.render(e, t.alignment), t.border && this.map.border.render(e, t.border), t.protection && this.map.protection.render(e, t.protection), e.closeNode();
                    }
                    parseOpen(e) {
                        if (this.parser) return this.parser.parseOpen(e), !0;
                        switch(e.name){
                            case this.tag:
                                return this.reset(), !0;
                            default:
                                return this.parser = this.map[e.name], this.parser && this.parser.parseOpen(e), !0;
                        }
                    }
                    parseText(e) {
                        this.parser && this.parser.parseText(e);
                    }
                    parseClose(e) {
                        return this.parser ? (this.parser.parseClose(e) || (this.parser = void 0), !0) : e !== this.tag || (this.model = {
                            alignment: this.map.alignment.model,
                            border: this.map.border.model,
                            fill: this.map.fill.model,
                            font: this.map.font.model,
                            numFmt: this.map.numFmt.model,
                            protection: this.map.protection.model
                        }, !1);
                    }
                };
            },
            {
                "../base-xform": 32,
                "./alignment-xform": 126,
                "./border-xform": 127,
                "./fill-xform": 130,
                "./font-xform": 131,
                "./numfmt-xform": 132,
                "./protection-xform": 133
            }
        ],
        130: [
            function(e, t, r) {
                "use strict";
                const n = e("../base-xform"), i = e("./color-xform");
                class s extends n {
                    constructor(){
                        super(), this.map = {
                            color: new i
                        };
                    }
                    get tag() {
                        return "stop";
                    }
                    render(e, t) {
                        e.openNode("stop"), e.addAttribute("position", t.position), this.map.color.render(e, t.color), e.closeNode();
                    }
                    parseOpen(e) {
                        if (this.parser) return this.parser.parseOpen(e), !0;
                        switch(e.name){
                            case "stop":
                                return this.model = {
                                    position: parseFloat(e.attributes.position)
                                }, !0;
                            case "color":
                                return this.parser = this.map.color, this.parser.parseOpen(e), !0;
                            default:
                                return !1;
                        }
                    }
                    parseText() {}
                    parseClose(e) {
                        return !!this.parser && (this.parser.parseClose(e) || (this.model.color = this.parser.model, this.parser = void 0), !0);
                    }
                }
                class o extends n {
                    constructor(){
                        super(), this.map = {
                            fgColor: new i("fgColor"),
                            bgColor: new i("bgColor")
                        };
                    }
                    get name() {
                        return "pattern";
                    }
                    get tag() {
                        return "patternFill";
                    }
                    render(e, t) {
                        e.openNode("patternFill"), e.addAttribute("patternType", t.pattern), t.fgColor && this.map.fgColor.render(e, t.fgColor), t.bgColor && this.map.bgColor.render(e, t.bgColor), e.closeNode();
                    }
                    parseOpen(e) {
                        if (this.parser) return this.parser.parseOpen(e), !0;
                        switch(e.name){
                            case "patternFill":
                                return this.model = {
                                    type: "pattern",
                                    pattern: e.attributes.patternType
                                }, !0;
                            default:
                                return this.parser = this.map[e.name], !!this.parser && (this.parser.parseOpen(e), !0);
                        }
                    }
                    parseText(e) {
                        this.parser && this.parser.parseText(e);
                    }
                    parseClose(e) {
                        return !!this.parser && (this.parser.parseClose(e) || (this.parser.model && (this.model[e] = this.parser.model), this.parser = void 0), !0);
                    }
                }
                class a extends n {
                    constructor(){
                        super(), this.map = {
                            stop: new s
                        };
                    }
                    get name() {
                        return "gradient";
                    }
                    get tag() {
                        return "gradientFill";
                    }
                    render(e, t) {
                        switch(e.openNode("gradientFill"), t.gradient){
                            case "angle":
                                e.addAttribute("degree", t.degree);
                                break;
                            case "path":
                                e.addAttribute("type", "path"), t.center.left && (e.addAttribute("left", t.center.left), void 0 === t.center.right && e.addAttribute("right", t.center.left)), t.center.right && e.addAttribute("right", t.center.right), t.center.top && (e.addAttribute("top", t.center.top), void 0 === t.center.bottom && e.addAttribute("bottom", t.center.top)), t.center.bottom && e.addAttribute("bottom", t.center.bottom);
                        }
                        const r = this.map.stop;
                        t.stops.forEach((t)=>{
                            r.render(e, t);
                        }), e.closeNode();
                    }
                    parseOpen(e) {
                        if (this.parser) return this.parser.parseOpen(e), !0;
                        switch(e.name){
                            case "gradientFill":
                                {
                                    const t = this.model = {
                                        stops: []
                                    };
                                    return e.attributes.degree ? (t.gradient = "angle", t.degree = parseInt(e.attributes.degree, 10)) : "path" === e.attributes.type && (t.gradient = "path", t.center = {
                                        left: e.attributes.left ? parseFloat(e.attributes.left) : 0,
                                        top: e.attributes.top ? parseFloat(e.attributes.top) : 0
                                    }, e.attributes.right !== e.attributes.left && (t.center.right = e.attributes.right ? parseFloat(e.attributes.right) : 0), e.attributes.bottom !== e.attributes.top && (t.center.bottom = e.attributes.bottom ? parseFloat(e.attributes.bottom) : 0)), !0;
                                }
                            case "stop":
                                return this.parser = this.map.stop, this.parser.parseOpen(e), !0;
                            default:
                                return !1;
                        }
                    }
                    parseText(e) {
                        this.parser && this.parser.parseText(e);
                    }
                    parseClose(e) {
                        return !!this.parser && (this.parser.parseClose(e) || (this.model.stops.push(this.parser.model), this.parser = void 0), !0);
                    }
                }
                class l extends n {
                    constructor(){
                        super(), this.map = {
                            patternFill: new o,
                            gradientFill: new a
                        };
                    }
                    get tag() {
                        return "fill";
                    }
                    render(e, t) {
                        switch(e.addRollback(), e.openNode("fill"), t.type){
                            case "pattern":
                                this.map.patternFill.render(e, t);
                                break;
                            case "gradient":
                                this.map.gradientFill.render(e, t);
                                break;
                            default:
                                return void e.rollback();
                        }
                        e.closeNode(), e.commit();
                    }
                    parseOpen(e) {
                        if (this.parser) return this.parser.parseOpen(e), !0;
                        switch(e.name){
                            case "fill":
                                return this.model = {}, !0;
                            default:
                                return this.parser = this.map[e.name], !!this.parser && (this.parser.parseOpen(e), !0);
                        }
                    }
                    parseText(e) {
                        this.parser && this.parser.parseText(e);
                    }
                    parseClose(e) {
                        return !!this.parser && (this.parser.parseClose(e) || (this.model = this.parser.model, this.model.type = this.parser.name, this.parser = void 0), !0);
                    }
                    validStyle(e) {
                        return l.validPatternValues[e];
                    }
                }
                l.validPatternValues = [
                    "none",
                    "solid",
                    "darkVertical",
                    "darkGray",
                    "mediumGray",
                    "lightGray",
                    "gray125",
                    "gray0625",
                    "darkHorizontal",
                    "darkVertical",
                    "darkDown",
                    "darkUp",
                    "darkGrid",
                    "darkTrellis",
                    "lightHorizontal",
                    "lightVertical",
                    "lightDown",
                    "lightUp",
                    "lightGrid",
                    "lightTrellis",
                    "lightGrid"
                ].reduce((e, t)=>(e[t] = !0, e), {}), l.StopXform = s, l.PatternFillXform = o, l.GradientFillXform = a, t.exports = l;
            },
            {
                "../base-xform": 32,
                "./color-xform": 128
            }
        ],
        131: [
            function(e, t, r) {
                "use strict";
                const n = e("./color-xform"), i = e("../simple/boolean-xform"), s = e("../simple/integer-xform"), o = e("../simple/string-xform"), a = e("./underline-xform"), l = e("../../../utils/under-dash"), c = e("../base-xform");
                class u extends c {
                    constructor(e){
                        super(), this.options = e || u.OPTIONS, this.map = {
                            b: {
                                prop: "bold",
                                xform: new i({
                                    tag: "b",
                                    attr: "val"
                                })
                            },
                            i: {
                                prop: "italic",
                                xform: new i({
                                    tag: "i",
                                    attr: "val"
                                })
                            },
                            u: {
                                prop: "underline",
                                xform: new a
                            },
                            charset: {
                                prop: "charset",
                                xform: new s({
                                    tag: "charset",
                                    attr: "val"
                                })
                            },
                            color: {
                                prop: "color",
                                xform: new n
                            },
                            condense: {
                                prop: "condense",
                                xform: new i({
                                    tag: "condense",
                                    attr: "val"
                                })
                            },
                            extend: {
                                prop: "extend",
                                xform: new i({
                                    tag: "extend",
                                    attr: "val"
                                })
                            },
                            family: {
                                prop: "family",
                                xform: new s({
                                    tag: "family",
                                    attr: "val"
                                })
                            },
                            outline: {
                                prop: "outline",
                                xform: new i({
                                    tag: "outline",
                                    attr: "val"
                                })
                            },
                            vertAlign: {
                                prop: "vertAlign",
                                xform: new o({
                                    tag: "vertAlign",
                                    attr: "val"
                                })
                            },
                            scheme: {
                                prop: "scheme",
                                xform: new o({
                                    tag: "scheme",
                                    attr: "val"
                                })
                            },
                            shadow: {
                                prop: "shadow",
                                xform: new i({
                                    tag: "shadow",
                                    attr: "val"
                                })
                            },
                            strike: {
                                prop: "strike",
                                xform: new i({
                                    tag: "strike",
                                    attr: "val"
                                })
                            },
                            sz: {
                                prop: "size",
                                xform: new s({
                                    tag: "sz",
                                    attr: "val"
                                })
                            }
                        }, this.map[this.options.fontNameTag] = {
                            prop: "name",
                            xform: new o({
                                tag: this.options.fontNameTag,
                                attr: "val"
                            })
                        };
                    }
                    get tag() {
                        return this.options.tagName;
                    }
                    render(e, t) {
                        const { map: r } = this;
                        e.openNode(this.options.tagName), l.each(this.map, (n, i)=>{
                            r[i].xform.render(e, t[n.prop]);
                        }), e.closeNode();
                    }
                    parseOpen(e) {
                        if (this.parser) return this.parser.parseOpen(e), !0;
                        if (this.map[e.name]) return this.parser = this.map[e.name].xform, this.parser.parseOpen(e);
                        switch(e.name){
                            case this.options.tagName:
                                return this.model = {}, !0;
                            default:
                                return !1;
                        }
                    }
                    parseText(e) {
                        this.parser && this.parser.parseText(e);
                    }
                    parseClose(e) {
                        if (this.parser && !this.parser.parseClose(e)) {
                            const t = this.map[e];
                            return this.parser.model && (this.model[t.prop] = this.parser.model), this.parser = void 0, !0;
                        }
                        switch(e){
                            case this.options.tagName:
                                return !1;
                            default:
                                return !0;
                        }
                    }
                }
                u.OPTIONS = {
                    tagName: "font",
                    fontNameTag: "name"
                }, t.exports = u;
            },
            {
                "../../../utils/under-dash": 26,
                "../base-xform": 32,
                "../simple/boolean-xform": 116,
                "../simple/integer-xform": 118,
                "../simple/string-xform": 119,
                "./color-xform": 128,
                "./underline-xform": 136
            }
        ],
        132: [
            function(e, t, r) {
                "use strict";
                const n = e("../../../utils/under-dash"), i = e("../../defaultnumformats"), s = e("../base-xform");
                const o = function() {
                    const e = {};
                    return n.each(i, (t, r)=>{
                        t.f && (e[t.f] = parseInt(r, 10));
                    }), e;
                }();
                class a extends s {
                    constructor(e, t){
                        super(), this.id = e, this.formatCode = t;
                    }
                    get tag() {
                        return "numFmt";
                    }
                    render(e, t) {
                        e.leafNode("numFmt", {
                            numFmtId: t.id,
                            formatCode: t.formatCode
                        });
                    }
                    parseOpen(e) {
                        switch(e.name){
                            case "numFmt":
                                return this.model = {
                                    id: parseInt(e.attributes.numFmtId, 10),
                                    formatCode: e.attributes.formatCode.replace(/[\\](.)/g, "$1")
                                }, !0;
                            default:
                                return !1;
                        }
                    }
                    parseText() {}
                    parseClose() {
                        return !1;
                    }
                }
                a.getDefaultFmtId = function(e) {
                    return o[e];
                }, a.getDefaultFmtCode = function(e) {
                    return i[e] && i[e].f;
                }, t.exports = a;
            },
            {
                "../../../utils/under-dash": 26,
                "../../defaultnumformats": 30,
                "../base-xform": 32
            }
        ],
        133: [
            function(e, t, r) {
                "use strict";
                const n = e("../base-xform"), i = {
                    boolean: (e, t)=>void 0 === e ? t : e
                };
                t.exports = class extends n {
                    get tag() {
                        return "protection";
                    }
                    render(e, t) {
                        e.addRollback(), e.openNode("protection");
                        let r = !1;
                        function n(t, n) {
                            void 0 !== n && (e.addAttribute(t, n), r = !0);
                        }
                        n("locked", i.boolean(t.locked, !0) ? void 0 : "0"), n("hidden", i.boolean(t.hidden, !1) ? "1" : void 0), e.closeNode(), r ? e.commit() : e.rollback();
                    }
                    parseOpen(e) {
                        const t = {
                            locked: !("0" === e.attributes.locked),
                            hidden: "1" === e.attributes.hidden
                        }, r = !t.locked || t.hidden;
                        this.model = r ? t : null;
                    }
                    parseText() {}
                    parseClose() {
                        return !1;
                    }
                };
            },
            {
                "../base-xform": 32
            }
        ],
        134: [
            function(e, t, r) {
                "use strict";
                const n = e("../base-xform"), i = e("./alignment-xform"), s = e("./protection-xform");
                t.exports = class extends n {
                    constructor(e){
                        super(), this.xfId = !(!e || !e.xfId), this.map = {
                            alignment: new i,
                            protection: new s
                        };
                    }
                    get tag() {
                        return "xf";
                    }
                    render(e, t) {
                        e.openNode("xf", {
                            numFmtId: t.numFmtId || 0,
                            fontId: t.fontId || 0,
                            fillId: t.fillId || 0,
                            borderId: t.borderId || 0
                        }), this.xfId && e.addAttribute("xfId", t.xfId || 0), t.numFmtId && e.addAttribute("applyNumberFormat", "1"), t.fontId && e.addAttribute("applyFont", "1"), t.fillId && e.addAttribute("applyFill", "1"), t.borderId && e.addAttribute("applyBorder", "1"), t.alignment && e.addAttribute("applyAlignment", "1"), t.protection && e.addAttribute("applyProtection", "1"), t.alignment && this.map.alignment.render(e, t.alignment), t.protection && this.map.protection.render(e, t.protection), e.closeNode();
                    }
                    parseOpen(e) {
                        if (this.parser) return this.parser.parseOpen(e), !0;
                        switch(e.name){
                            case "xf":
                                return this.model = {
                                    numFmtId: parseInt(e.attributes.numFmtId, 10),
                                    fontId: parseInt(e.attributes.fontId, 10),
                                    fillId: parseInt(e.attributes.fillId, 10),
                                    borderId: parseInt(e.attributes.borderId, 10)
                                }, this.xfId && (this.model.xfId = parseInt(e.attributes.xfId, 10)), !0;
                            case "alignment":
                                return this.parser = this.map.alignment, this.parser.parseOpen(e), !0;
                            case "protection":
                                return this.parser = this.map.protection, this.parser.parseOpen(e), !0;
                            default:
                                return !1;
                        }
                    }
                    parseText(e) {
                        this.parser && this.parser.parseText(e);
                    }
                    parseClose(e) {
                        return this.parser ? (this.parser.parseClose(e) || (this.map.protection === this.parser ? this.model.protection = this.parser.model : this.model.alignment = this.parser.model, this.parser = void 0), !0) : "xf" !== e;
                    }
                };
            },
            {
                "../base-xform": 32,
                "./alignment-xform": 126,
                "./protection-xform": 133
            }
        ],
        135: [
            function(e, t, r) {
                "use strict";
                const n = e("../../../doc/enums"), i = e("../../../utils/xml-stream"), s = e("../base-xform"), o = e("../static-xform"), a = e("../list-xform"), l = e("./font-xform"), c = e("./fill-xform"), u = e("./border-xform"), h = e("./numfmt-xform"), f = e("./style-xform"), d = e("./dxf-xform");
                class p extends s {
                    constructor(e){
                        super(), this.map = {
                            numFmts: new a({
                                tag: "numFmts",
                                count: !0,
                                childXform: new h
                            }),
                            fonts: new a({
                                tag: "fonts",
                                count: !0,
                                childXform: new l,
                                $: {
                                    "x14ac:knownFonts": 1
                                }
                            }),
                            fills: new a({
                                tag: "fills",
                                count: !0,
                                childXform: new c
                            }),
                            borders: new a({
                                tag: "borders",
                                count: !0,
                                childXform: new u
                            }),
                            cellStyleXfs: new a({
                                tag: "cellStyleXfs",
                                count: !0,
                                childXform: new f
                            }),
                            cellXfs: new a({
                                tag: "cellXfs",
                                count: !0,
                                childXform: new f({
                                    xfId: !0
                                })
                            }),
                            dxfs: new a({
                                tag: "dxfs",
                                always: !0,
                                count: !0,
                                childXform: new d
                            }),
                            numFmt: new h,
                            font: new l,
                            fill: new c,
                            border: new u,
                            style: new f({
                                xfId: !0
                            }),
                            cellStyles: p.STATIC_XFORMS.cellStyles,
                            tableStyles: p.STATIC_XFORMS.tableStyles,
                            extLst: p.STATIC_XFORMS.extLst
                        }, e && this.init();
                    }
                    initIndex() {
                        this.index = {
                            style: {},
                            numFmt: {},
                            numFmtNextId: 164,
                            font: {},
                            border: {},
                            fill: {}
                        };
                    }
                    init() {
                        this.model = {
                            styles: [],
                            numFmts: [],
                            fonts: [],
                            borders: [],
                            fills: [],
                            dxfs: []
                        }, this.initIndex(), this._addBorder({}), this._addStyle({
                            numFmtId: 0,
                            fontId: 0,
                            fillId: 0,
                            borderId: 0,
                            xfId: 0
                        }), this._addFill({
                            type: "pattern",
                            pattern: "none"
                        }), this._addFill({
                            type: "pattern",
                            pattern: "gray125"
                        }), this.weakMap = new WeakMap;
                    }
                    render(e, t) {
                        t = t || this.model, e.openXml(i.StdDocAttributes), e.openNode("styleSheet", p.STYLESHEET_ATTRIBUTES), this.index ? (t.numFmts && t.numFmts.length && (e.openNode("numFmts", {
                            count: t.numFmts.length
                        }), t.numFmts.forEach((t)=>{
                            e.writeXml(t);
                        }), e.closeNode()), t.fonts.length || this._addFont({
                            size: 11,
                            color: {
                                theme: 1
                            },
                            name: "Calibri",
                            family: 2,
                            scheme: "minor"
                        }), e.openNode("fonts", {
                            count: t.fonts.length,
                            "x14ac:knownFonts": 1
                        }), t.fonts.forEach((t)=>{
                            e.writeXml(t);
                        }), e.closeNode(), e.openNode("fills", {
                            count: t.fills.length
                        }), t.fills.forEach((t)=>{
                            e.writeXml(t);
                        }), e.closeNode(), e.openNode("borders", {
                            count: t.borders.length
                        }), t.borders.forEach((t)=>{
                            e.writeXml(t);
                        }), e.closeNode(), this.map.cellStyleXfs.render(e, [
                            {
                                numFmtId: 0,
                                fontId: 0,
                                fillId: 0,
                                borderId: 0,
                                xfId: 0
                            }
                        ]), e.openNode("cellXfs", {
                            count: t.styles.length
                        }), t.styles.forEach((t)=>{
                            e.writeXml(t);
                        }), e.closeNode()) : (this.map.numFmts.render(e, t.numFmts), this.map.fonts.render(e, t.fonts), this.map.fills.render(e, t.fills), this.map.borders.render(e, t.borders), this.map.cellStyleXfs.render(e, [
                            {
                                numFmtId: 0,
                                fontId: 0,
                                fillId: 0,
                                borderId: 0,
                                xfId: 0
                            }
                        ]), this.map.cellXfs.render(e, t.styles)), p.STATIC_XFORMS.cellStyles.render(e), this.map.dxfs.render(e, t.dxfs), p.STATIC_XFORMS.tableStyles.render(e), p.STATIC_XFORMS.extLst.render(e), e.closeNode();
                    }
                    parseOpen(e) {
                        if (this.parser) return this.parser.parseOpen(e), !0;
                        switch(e.name){
                            case "styleSheet":
                                return this.initIndex(), !0;
                            default:
                                return this.parser = this.map[e.name], this.parser && this.parser.parseOpen(e), !0;
                        }
                    }
                    parseText(e) {
                        this.parser && this.parser.parseText(e);
                    }
                    parseClose(e) {
                        if (this.parser) return this.parser.parseClose(e) || (this.parser = void 0), !0;
                        switch(e){
                            case "styleSheet":
                                {
                                    this.model = {};
                                    const e = (e, t)=>{
                                        t.model && t.model.length && (this.model[e] = t.model);
                                    };
                                    if (e("numFmts", this.map.numFmts), e("fonts", this.map.fonts), e("fills", this.map.fills), e("borders", this.map.borders), e("styles", this.map.cellXfs), e("dxfs", this.map.dxfs), this.index = {
                                        model: [],
                                        numFmt: []
                                    }, this.model.numFmts) {
                                        const e = this.index.numFmt;
                                        this.model.numFmts.forEach((t)=>{
                                            e[t.id] = t.formatCode;
                                        });
                                    }
                                    return !1;
                                }
                            default:
                                return !0;
                        }
                    }
                    addStyleModel(e, t) {
                        if (!e) return 0;
                        if (this.model.fonts.length || this._addFont({
                            size: 11,
                            color: {
                                theme: 1
                            },
                            name: "Calibri",
                            family: 2,
                            scheme: "minor"
                        }), this.weakMap && this.weakMap.has(e)) return this.weakMap.get(e);
                        const r = {};
                        if (t = t || n.ValueType.Number, e.numFmt) r.numFmtId = this._addNumFmtStr(e.numFmt);
                        else switch(t){
                            case n.ValueType.Number:
                                r.numFmtId = this._addNumFmtStr("General");
                                break;
                            case n.ValueType.Date:
                                r.numFmtId = this._addNumFmtStr("mm-dd-yy");
                        }
                        e.font && (r.fontId = this._addFont(e.font)), e.border && (r.borderId = this._addBorder(e.border)), e.fill && (r.fillId = this._addFill(e.fill)), e.alignment && (r.alignment = e.alignment), e.protection && (r.protection = e.protection);
                        const i = this._addStyle(r);
                        return this.weakMap && this.weakMap.set(e, i), i;
                    }
                    getStyleModel(e) {
                        const t = this.model.styles[e];
                        if (!t) return null;
                        let r = this.index.model[e];
                        if (r) return r;
                        if (r = this.index.model[e] = {}, t.numFmtId) {
                            const e = this.index.numFmt[t.numFmtId] || h.getDefaultFmtCode(t.numFmtId);
                            e && (r.numFmt = e);
                        }
                        function n(e, t, n) {
                            if (n || 0 === n) {
                                const i = t[n];
                                i && (r[e] = i);
                            }
                        }
                        return n("font", this.model.fonts, t.fontId), n("border", this.model.borders, t.borderId), n("fill", this.model.fills, t.fillId), t.alignment && (r.alignment = t.alignment), t.protection && (r.protection = t.protection), r;
                    }
                    addDxfStyle(e) {
                        return e.numFmt && (e.numFmtId = this._addNumFmtStr(e.numFmt)), this.model.dxfs.push(e), this.model.dxfs.length - 1;
                    }
                    getDxfStyle(e) {
                        return this.model.dxfs[e];
                    }
                    _addStyle(e) {
                        const t = this.map.style.toXml(e);
                        let r = this.index.style[t];
                        return void 0 === r && (r = this.index.style[t] = this.model.styles.length, this.model.styles.push(t)), r;
                    }
                    _addNumFmtStr(e) {
                        let t = h.getDefaultFmtId(e);
                        if (void 0 !== t) return t;
                        if (t = this.index.numFmt[e], void 0 !== t) return t;
                        t = this.index.numFmt[e] = 164 + this.model.numFmts.length;
                        const r = this.map.numFmt.toXml({
                            id: t,
                            formatCode: e
                        });
                        return this.model.numFmts.push(r), t;
                    }
                    _addFont(e) {
                        const t = this.map.font.toXml(e);
                        let r = this.index.font[t];
                        return void 0 === r && (r = this.index.font[t] = this.model.fonts.length, this.model.fonts.push(t)), r;
                    }
                    _addBorder(e) {
                        const t = this.map.border.toXml(e);
                        let r = this.index.border[t];
                        return void 0 === r && (r = this.index.border[t] = this.model.borders.length, this.model.borders.push(t)), r;
                    }
                    _addFill(e) {
                        const t = this.map.fill.toXml(e);
                        let r = this.index.fill[t];
                        return void 0 === r && (r = this.index.fill[t] = this.model.fills.length, this.model.fills.push(t)), r;
                    }
                }
                p.STYLESHEET_ATTRIBUTES = {
                    xmlns: "http://schemas.openxmlformats.org/spreadsheetml/2006/main",
                    "xmlns:mc": "http://schemas.openxmlformats.org/markup-compatibility/2006",
                    "mc:Ignorable": "x14ac x16r2",
                    "xmlns:x14ac": "http://schemas.microsoft.com/office/spreadsheetml/2009/9/ac",
                    "xmlns:x16r2": "http://schemas.microsoft.com/office/spreadsheetml/2015/02/main"
                }, p.STATIC_XFORMS = {
                    cellStyles: new o({
                        tag: "cellStyles",
                        $: {
                            count: 1
                        },
                        c: [
                            {
                                tag: "cellStyle",
                                $: {
                                    name: "Normal",
                                    xfId: 0,
                                    builtinId: 0
                                }
                            }
                        ]
                    }),
                    dxfs: new o({
                        tag: "dxfs",
                        $: {
                            count: 0
                        }
                    }),
                    tableStyles: new o({
                        tag: "tableStyles",
                        $: {
                            count: 0,
                            defaultTableStyle: "TableStyleMedium2",
                            defaultPivotStyle: "PivotStyleLight16"
                        }
                    }),
                    extLst: new o({
                        tag: "extLst",
                        c: [
                            {
                                tag: "ext",
                                $: {
                                    uri: "{EB79DEF2-80B8-43e5-95BD-54CBDDF9020C}",
                                    "xmlns:x14": "http://schemas.microsoft.com/office/spreadsheetml/2009/9/main"
                                },
                                c: [
                                    {
                                        tag: "x14:slicerStyles",
                                        $: {
                                            defaultSlicerStyle: "SlicerStyleLight1"
                                        }
                                    }
                                ]
                            },
                            {
                                tag: "ext",
                                $: {
                                    uri: "{9260A510-F301-46a8-8635-F512D64BE5F5}",
                                    "xmlns:x15": "http://schemas.microsoft.com/office/spreadsheetml/2010/11/main"
                                },
                                c: [
                                    {
                                        tag: "x15:timelineStyles",
                                        $: {
                                            defaultTimelineStyle: "TimeSlicerStyleLight1"
                                        }
                                    }
                                ]
                            }
                        ]
                    })
                };
                p.Mock = class extends p {
                    constructor(){
                        super(), this.model = {
                            styles: [
                                {
                                    numFmtId: 0,
                                    fontId: 0,
                                    fillId: 0,
                                    borderId: 0,
                                    xfId: 0
                                }
                            ],
                            numFmts: [],
                            fonts: [
                                {
                                    size: 11,
                                    color: {
                                        theme: 1
                                    },
                                    name: "Calibri",
                                    family: 2,
                                    scheme: "minor"
                                }
                            ],
                            borders: [
                                {}
                            ],
                            fills: [
                                {
                                    type: "pattern",
                                    pattern: "none"
                                },
                                {
                                    type: "pattern",
                                    pattern: "gray125"
                                }
                            ]
                        };
                    }
                    parseStream(e) {
                        return e.autodrain(), Promise.resolve();
                    }
                    addStyleModel(e, t) {
                        switch(t){
                            case n.ValueType.Date:
                                return this.dateStyleId;
                            default:
                                return 0;
                        }
                    }
                    get dateStyleId() {
                        if (!this._dateStyleId) {
                            const e = {
                                numFmtId: h.getDefaultFmtId("mm-dd-yy")
                            };
                            this._dateStyleId = this.model.styles.length, this.model.styles.push(e);
                        }
                        return this._dateStyleId;
                    }
                    getStyleModel() {
                        return {};
                    }
                }, t.exports = p;
            },
            {
                "../../../doc/enums": 7,
                "../../../utils/xml-stream": 28,
                "../base-xform": 32,
                "../list-xform": 71,
                "../static-xform": 120,
                "./border-xform": 127,
                "./dxf-xform": 129,
                "./fill-xform": 130,
                "./font-xform": 131,
                "./numfmt-xform": 132,
                "./style-xform": 134
            }
        ],
        136: [
            function(e, t, r) {
                "use strict";
                const n = e("../base-xform");
                class i extends n {
                    constructor(e){
                        super(), this.model = e;
                    }
                    get tag() {
                        return "u";
                    }
                    render(e, t) {
                        if (!0 === (t = t || this.model)) e.leafNode("u");
                        else {
                            const r = i.Attributes[t];
                            r && e.leafNode("u", r);
                        }
                    }
                    parseOpen(e) {
                        "u" === e.name && (this.model = e.attributes.val || !0);
                    }
                    parseText() {}
                    parseClose() {
                        return !1;
                    }
                }
                i.Attributes = {
                    single: {},
                    double: {
                        val: "double"
                    },
                    singleAccounting: {
                        val: "singleAccounting"
                    },
                    doubleAccounting: {
                        val: "doubleAccounting"
                    }
                }, t.exports = i;
            },
            {
                "../base-xform": 32
            }
        ],
        137: [
            function(e, t, r) {
                "use strict";
                const n = e("../base-xform"), i = e("./filter-column-xform");
                t.exports = class extends n {
                    constructor(){
                        super(), this.map = {
                            filterColumn: new i
                        };
                    }
                    get tag() {
                        return "autoFilter";
                    }
                    prepare(e) {
                        e.columns.forEach((e, t)=>{
                            this.map.filterColumn.prepare(e, {
                                index: t
                            });
                        });
                    }
                    render(e, t) {
                        return e.openNode(this.tag, {
                            ref: t.autoFilterRef
                        }), t.columns.forEach((t)=>{
                            this.map.filterColumn.render(e, t);
                        }), e.closeNode(), !0;
                    }
                    parseOpen(e) {
                        if (this.parser) return this.parser.parseOpen(e), !0;
                        switch(e.name){
                            case this.tag:
                                return this.model = {
                                    autoFilterRef: e.attributes.ref,
                                    columns: []
                                }, !0;
                            default:
                                if (this.parser = this.map[e.name], this.parser) return this.parseOpen(e), !0;
                                throw new Error("Unexpected xml node in parseOpen: " + JSON.stringify(e));
                        }
                    }
                    parseText(e) {
                        this.parser && this.parser.parseText(e);
                    }
                    parseClose(e) {
                        if (this.parser) return this.parser.parseClose(e) || (this.model.columns.push(this.parser.model), this.parser = void 0), !0;
                        switch(e){
                            case this.tag:
                                return !1;
                            default:
                                throw new Error("Unexpected xml node in parseClose: " + e);
                        }
                    }
                };
            },
            {
                "../base-xform": 32,
                "./filter-column-xform": 139
            }
        ],
        138: [
            function(e, t, r) {
                "use strict";
                const n = e("../base-xform");
                t.exports = class extends n {
                    get tag() {
                        return "customFilter";
                    }
                    render(e, t) {
                        e.leafNode(this.tag, {
                            val: t.val,
                            operator: t.operator
                        });
                    }
                    parseOpen(e) {
                        return e.name === this.tag && (this.model = {
                            val: e.attributes.val,
                            operator: e.attributes.operator
                        }, !0);
                    }
                    parseText() {}
                    parseClose() {
                        return !1;
                    }
                };
            },
            {
                "../base-xform": 32
            }
        ],
        139: [
            function(e, t, r) {
                "use strict";
                const n = e("../base-xform"), i = e("../list-xform"), s = e("./custom-filter-xform"), o = e("./filter-xform");
                t.exports = class extends n {
                    constructor(){
                        super(), this.map = {
                            customFilters: new i({
                                tag: "customFilters",
                                count: !1,
                                empty: !0,
                                childXform: new s
                            }),
                            filters: new i({
                                tag: "filters",
                                count: !1,
                                empty: !0,
                                childXform: new o
                            })
                        };
                    }
                    get tag() {
                        return "filterColumn";
                    }
                    prepare(e, t) {
                        e.colId = t.index.toString();
                    }
                    render(e, t) {
                        return t.customFilters ? (e.openNode(this.tag, {
                            colId: t.colId,
                            hiddenButton: t.filterButton ? "0" : "1"
                        }), this.map.customFilters.render(e, t.customFilters), e.closeNode(), !0) : (e.leafNode(this.tag, {
                            colId: t.colId,
                            hiddenButton: t.filterButton ? "0" : "1"
                        }), !0);
                    }
                    parseOpen(e) {
                        if (this.parser) return this.parser.parseOpen(e), !0;
                        const { attributes: t } = e;
                        switch(e.name){
                            case this.tag:
                                return this.model = {
                                    filterButton: "0" === t.hiddenButton
                                }, !0;
                            default:
                                if (this.parser = this.map[e.name], this.parser) return this.parseOpen(e), !0;
                                throw new Error("Unexpected xml node in parseOpen: " + JSON.stringify(e));
                        }
                    }
                    parseText() {}
                    parseClose(e) {
                        if (this.parser) return this.parser.parseClose(e) || (this.parser = void 0), !0;
                        switch(e){
                            case this.tag:
                                return this.model.customFilters = this.map.customFilters.model, !1;
                            default:
                                return !0;
                        }
                    }
                };
            },
            {
                "../base-xform": 32,
                "../list-xform": 71,
                "./custom-filter-xform": 138,
                "./filter-xform": 140
            }
        ],
        140: [
            function(e, t, r) {
                "use strict";
                const n = e("../base-xform");
                t.exports = class extends n {
                    get tag() {
                        return "filter";
                    }
                    render(e, t) {
                        e.leafNode(this.tag, {
                            val: t.val
                        });
                    }
                    parseOpen(e) {
                        return e.name === this.tag && (this.model = {
                            val: e.attributes.val
                        }, !0);
                    }
                    parseText() {}
                    parseClose() {
                        return !1;
                    }
                };
            },
            {
                "../base-xform": 32
            }
        ],
        141: [
            function(e, t, r) {
                "use strict";
                const n = e("../base-xform");
                t.exports = class extends n {
                    get tag() {
                        return "tableColumn";
                    }
                    prepare(e, t) {
                        e.id = t.index + 1;
                    }
                    render(e, t) {
                        return e.leafNode(this.tag, {
                            id: t.id.toString(),
                            name: t.name,
                            totalsRowLabel: t.totalsRowLabel,
                            totalsRowFunction: t.totalsRowFunction,
                            dxfId: t.dxfId
                        }), !0;
                    }
                    parseOpen(e) {
                        if (e.name === this.tag) {
                            const { attributes: t } = e;
                            return this.model = {
                                name: t.name,
                                totalsRowLabel: t.totalsRowLabel,
                                totalsRowFunction: t.totalsRowFunction,
                                dxfId: t.dxfId
                            }, !0;
                        }
                        return !1;
                    }
                    parseText() {}
                    parseClose() {
                        return !1;
                    }
                };
            },
            {
                "../base-xform": 32
            }
        ],
        142: [
            function(e, t, r) {
                "use strict";
                const n = e("../base-xform");
                t.exports = class extends n {
                    get tag() {
                        return "tableStyleInfo";
                    }
                    render(e, t) {
                        return e.leafNode(this.tag, {
                            name: t.theme ? t.theme : void 0,
                            showFirstColumn: t.showFirstColumn ? "1" : "0",
                            showLastColumn: t.showLastColumn ? "1" : "0",
                            showRowStripes: t.showRowStripes ? "1" : "0",
                            showColumnStripes: t.showColumnStripes ? "1" : "0"
                        }), !0;
                    }
                    parseOpen(e) {
                        if (e.name === this.tag) {
                            const { attributes: t } = e;
                            return this.model = {
                                theme: t.name ? t.name : null,
                                showFirstColumn: "1" === t.showFirstColumn,
                                showLastColumn: "1" === t.showLastColumn,
                                showRowStripes: "1" === t.showRowStripes,
                                showColumnStripes: "1" === t.showColumnStripes
                            }, !0;
                        }
                        return !1;
                    }
                    parseText() {}
                    parseClose() {
                        return !1;
                    }
                };
            },
            {
                "../base-xform": 32
            }
        ],
        143: [
            function(e, t, r) {
                "use strict";
                const n = e("../../../utils/xml-stream"), i = e("../base-xform"), s = e("../list-xform"), o = e("./auto-filter-xform"), a = e("./table-column-xform"), l = e("./table-style-info-xform");
                class c extends i {
                    constructor(){
                        super(), this.map = {
                            autoFilter: new o,
                            tableColumns: new s({
                                tag: "tableColumns",
                                count: !0,
                                empty: !0,
                                childXform: new a
                            }),
                            tableStyleInfo: new l
                        };
                    }
                    prepare(e, t) {
                        this.map.autoFilter.prepare(e), this.map.tableColumns.prepare(e.columns, t);
                    }
                    get tag() {
                        return "table";
                    }
                    render(e, t) {
                        e.openXml(n.StdDocAttributes), e.openNode(this.tag, {
                            ...c.TABLE_ATTRIBUTES,
                            id: t.id,
                            name: t.name,
                            displayName: t.displayName || t.name,
                            ref: t.tableRef,
                            totalsRowCount: t.totalsRow ? "1" : void 0,
                            totalsRowShown: t.totalsRow ? void 0 : "1",
                            headerRowCount: t.headerRow ? "1" : "0"
                        }), this.map.autoFilter.render(e, t), this.map.tableColumns.render(e, t.columns), this.map.tableStyleInfo.render(e, t.style), e.closeNode();
                    }
                    parseOpen(e) {
                        if (this.parser) return this.parser.parseOpen(e), !0;
                        const { name: t, attributes: r } = e;
                        switch(t){
                            case this.tag:
                                this.reset(), this.model = {
                                    name: r.name,
                                    displayName: r.displayName || r.name,
                                    tableRef: r.ref,
                                    totalsRow: "1" === r.totalsRowCount,
                                    headerRow: "1" === r.headerRowCount
                                };
                                break;
                            default:
                                this.parser = this.map[e.name], this.parser && this.parser.parseOpen(e);
                        }
                        return !0;
                    }
                    parseText(e) {
                        this.parser && this.parser.parseText(e);
                    }
                    parseClose(e) {
                        if (this.parser) return this.parser.parseClose(e) || (this.parser = void 0), !0;
                        switch(e){
                            case this.tag:
                                return this.model.columns = this.map.tableColumns.model, this.map.autoFilter.model && (this.model.autoFilterRef = this.map.autoFilter.model.autoFilterRef, this.map.autoFilter.model.columns.forEach((e, t)=>{
                                    this.model.columns[t].filterButton = e.filterButton;
                                })), this.model.style = this.map.tableStyleInfo.model, !1;
                            default:
                                return !0;
                        }
                    }
                    reconcile(e, t) {
                        e.columns.forEach((e)=>{
                            void 0 !== e.dxfId && (e.style = t.styles.getDxfStyle(e.dxfId));
                        });
                    }
                }
                c.TABLE_ATTRIBUTES = {
                    xmlns: "http://schemas.openxmlformats.org/spreadsheetml/2006/main",
                    "xmlns:mc": "http://schemas.openxmlformats.org/markup-compatibility/2006",
                    "mc:Ignorable": "xr xr3",
                    "xmlns:xr": "http://schemas.microsoft.com/office/spreadsheetml/2014/revision",
                    "xmlns:xr3": "http://schemas.microsoft.com/office/spreadsheetml/2016/revision3"
                }, t.exports = c;
            },
            {
                "../../../utils/xml-stream": 28,
                "../base-xform": 32,
                "../list-xform": 71,
                "./auto-filter-xform": 137,
                "./table-column-xform": 141,
                "./table-style-info-xform": 142
            }
        ],
        144: [
            function(e, t, r) {
                (function(r, n) {
                    (function() {
                        "use strict";
                        const i = e("fs"), s = e("jszip"), { PassThrough: o } = e("readable-stream"), a = e("../utils/zip-stream"), l = e("../utils/stream-buf"), c = e("../utils/utils"), u = e("../utils/xml-stream"), { bufferToString: h } = e("../utils/browser-buffer-decode"), f = e("./xform/style/styles-xform"), d = e("./xform/core/core-xform"), p = e("./xform/strings/shared-strings-xform"), m = e("./xform/core/relationships-xform"), b = e("./xform/core/content-types-xform"), g = e("./xform/core/app-xform"), y = e("./xform/book/workbook-xform"), v = e("./xform/sheet/worksheet-xform"), w = e("./xform/drawing/drawing-xform"), _ = e("./xform/table/table-xform"), x = e("./xform/comment/comments-xform"), k = e("./xform/comment/vml-notes-xform"), S = e("./xml/theme1");
                        class M {
                            constructor(e){
                                this.workbook = e;
                            }
                            async readFile(e, t) {
                                if (!await c.fs.exists(e)) throw new Error("File not found: " + e);
                                const r = i.createReadStream(e);
                                try {
                                    const e = await this.read(r, t);
                                    return r.close(), e;
                                } catch (e) {
                                    throw r.close(), e;
                                }
                            }
                            parseRels(e) {
                                return (new m).parseStream(e);
                            }
                            parseWorkbook(e) {
                                return (new y).parseStream(e);
                            }
                            parseSharedStrings(e) {
                                return (new p).parseStream(e);
                            }
                            reconcile(e, t) {
                                const r = new y, n = new v(t), i = new w, s = new _;
                                r.reconcile(e);
                                const o = {
                                    media: e.media,
                                    mediaIndex: e.mediaIndex
                                };
                                Object.keys(e.drawings).forEach((t)=>{
                                    const r = e.drawings[t], n = e.drawingRels[t];
                                    n && (o.rels = n.reduce((e, t)=>(e[t.Id] = t, e), {}), (r.anchors || []).forEach((e)=>{
                                        const t = e.picture && e.picture.hyperlinks;
                                        t && o.rels[t.rId] && (t.hyperlink = o.rels[t.rId].Target, delete t.rId);
                                    }), i.reconcile(r, o));
                                });
                                const a = {
                                    styles: e.styles
                                };
                                Object.values(e.tables).forEach((e)=>{
                                    s.reconcile(e, a);
                                });
                                const l = {
                                    styles: e.styles,
                                    sharedStrings: e.sharedStrings,
                                    media: e.media,
                                    mediaIndex: e.mediaIndex,
                                    date1904: e.properties && e.properties.date1904,
                                    drawings: e.drawings,
                                    comments: e.comments,
                                    tables: e.tables,
                                    vmlDrawings: e.vmlDrawings
                                };
                                e.worksheets.forEach((t)=>{
                                    t.relationships = e.worksheetRels[t.sheetNo], n.reconcile(t, l);
                                }), delete e.worksheetHash, delete e.worksheetRels, delete e.globalRels, delete e.sharedStrings, delete e.workbookRels, delete e.sheetDefs, delete e.styles, delete e.mediaIndex, delete e.drawings, delete e.drawingRels, delete e.vmlDrawings;
                            }
                            async _processWorksheetEntry(e, t, r, n, i) {
                                const s = new v(n), o = await s.parseStream(e);
                                o.sheetNo = r, t.worksheetHash[i] = o, t.worksheets.push(o);
                            }
                            async _processCommentEntry(e, t, r) {
                                const n = new x, i = await n.parseStream(e);
                                t.comments[`../${r}.xml`] = i;
                            }
                            async _processTableEntry(e, t, r) {
                                const n = new _, i = await n.parseStream(e);
                                t.tables[`../tables/${r}.xml`] = i;
                            }
                            async _processWorksheetRelsEntry(e, t, r) {
                                const n = new m, i = await n.parseStream(e);
                                t.worksheetRels[r] = i;
                            }
                            async _processMediaEntry(e, t, r) {
                                const n = r.lastIndexOf(".");
                                if (n >= 1) {
                                    const i = r.substr(n + 1), s = r.substr(0, n);
                                    await new Promise((n, o)=>{
                                        const a = new l;
                                        a.on("finish", ()=>{
                                            t.mediaIndex[r] = t.media.length, t.mediaIndex[s] = t.media.length;
                                            const e = {
                                                type: "image",
                                                name: s,
                                                extension: i,
                                                buffer: a.toBuffer()
                                            };
                                            t.media.push(e), n();
                                        }), e.on("error", (e)=>{
                                            o(e);
                                        }), e.pipe(a);
                                    });
                                }
                            }
                            async _processDrawingEntry(e, t, r) {
                                const n = new w, i = await n.parseStream(e);
                                t.drawings[r] = i;
                            }
                            async _processDrawingRelsEntry(e, t, r) {
                                const n = new m, i = await n.parseStream(e);
                                t.drawingRels[r] = i;
                            }
                            async _processVmlDrawingEntry(e, t, r) {
                                const n = new k, i = await n.parseStream(e);
                                t.vmlDrawings[`../drawings/${r}.vml`] = i;
                            }
                            async _processThemeEntry(e, t, r) {
                                await new Promise((n, i)=>{
                                    const s = new l;
                                    e.on("error", i), s.on("error", i), s.on("finish", ()=>{
                                        t.themes[r] = s.read().toString(), n();
                                    }), e.pipe(s);
                                });
                            }
                            createInputStream() {
                                throw new Error("`XLSX#createInputStream` is deprecated. You should use `XLSX#read` instead. This method will be removed in version 5.0. Please follow upgrade instruction: https://github.com/exceljs/exceljs/blob/master/UPGRADE-4.0.md");
                            }
                            async read(e, t) {
                                !e[Symbol.asyncIterator] && e.pipe && (e = e.pipe(new o));
                                const r = [];
                                for await (const t of e)r.push(t);
                                return this.load(n.concat(r), t);
                            }
                            async load(e, t) {
                                let i;
                                i = t && t.base64 ? n.from(e.toString(), "base64") : e;
                                const a = {
                                    worksheets: [],
                                    worksheetHash: {},
                                    worksheetRels: [],
                                    themes: {},
                                    media: [],
                                    mediaIndex: {},
                                    drawings: {},
                                    drawingRels: {},
                                    comments: {},
                                    tables: {},
                                    vmlDrawings: {}
                                }, l = await s.loadAsync(i);
                                for (const e of Object.values(l.files))if (!e.dir) {
                                    let n, i = e.name;
                                    if ("/" === i[0] && (i = i.substr(1)), i.match(/xl\/media\//) || i.match(/xl\/theme\/([a-zA-Z0-9]+)[.]xml/)) n = new o, n.write(await e.async("nodebuffer"));
                                    else {
                                        let t;
                                        n = new o({
                                            writableObjectMode: !0,
                                            readableObjectMode: !0
                                        }), t = r.browser ? h(await e.async("nodebuffer")) : await e.async("string");
                                        const i = 16384;
                                        for(let e = 0; e < t.length; e += i)n.write(t.substring(e, e + i));
                                    }
                                    switch(n.end(), i){
                                        case "_rels/.rels":
                                            a.globalRels = await this.parseRels(n);
                                            break;
                                        case "xl/workbook.xml":
                                            {
                                                const e = await this.parseWorkbook(n);
                                                a.sheets = e.sheets, a.definedNames = e.definedNames, a.views = e.views, a.properties = e.properties, a.calcProperties = e.calcProperties;
                                                break;
                                            }
                                        case "xl/_rels/workbook.xml.rels":
                                            a.workbookRels = await this.parseRels(n);
                                            break;
                                        case "xl/sharedStrings.xml":
                                            a.sharedStrings = new p, await a.sharedStrings.parseStream(n);
                                            break;
                                        case "xl/styles.xml":
                                            a.styles = new f, await a.styles.parseStream(n);
                                            break;
                                        case "docProps/app.xml":
                                            {
                                                const e = new g, t = await e.parseStream(n);
                                                a.company = t.company, a.manager = t.manager;
                                                break;
                                            }
                                        case "docProps/core.xml":
                                            {
                                                const e = new d, t = await e.parseStream(n);
                                                Object.assign(a, t);
                                                break;
                                            }
                                        default:
                                            {
                                                let e = i.match(/xl\/worksheets\/sheet(\d+)[.]xml/);
                                                if (e) {
                                                    await this._processWorksheetEntry(n, a, e[1], t, i);
                                                    break;
                                                }
                                                if (e = i.match(/xl\/worksheets\/_rels\/sheet(\d+)[.]xml.rels/), e) {
                                                    await this._processWorksheetRelsEntry(n, a, e[1]);
                                                    break;
                                                }
                                                if (e = i.match(/xl\/theme\/([a-zA-Z0-9]+)[.]xml/), e) {
                                                    await this._processThemeEntry(n, a, e[1]);
                                                    break;
                                                }
                                                if (e = i.match(/xl\/media\/([a-zA-Z0-9]+[.][a-zA-Z0-9]{3,4})$/), e) {
                                                    await this._processMediaEntry(n, a, e[1]);
                                                    break;
                                                }
                                                if (e = i.match(/xl\/drawings\/([a-zA-Z0-9]+)[.]xml/), e) {
                                                    await this._processDrawingEntry(n, a, e[1]);
                                                    break;
                                                }
                                                if (e = i.match(/xl\/(comments\d+)[.]xml/), e) {
                                                    await this._processCommentEntry(n, a, e[1]);
                                                    break;
                                                }
                                                if (e = i.match(/xl\/tables\/(table\d+)[.]xml/), e) {
                                                    await this._processTableEntry(n, a, e[1]);
                                                    break;
                                                }
                                                if (e = i.match(/xl\/drawings\/_rels\/([a-zA-Z0-9]+)[.]xml[.]rels/), e) {
                                                    await this._processDrawingRelsEntry(n, a, e[1]);
                                                    break;
                                                }
                                                if (e = i.match(/xl\/drawings\/(vmlDrawing\d+)[.]vml/), e) {
                                                    await this._processVmlDrawingEntry(n, a, e[1]);
                                                    break;
                                                }
                                            }
                                    }
                                }
                                return this.reconcile(a, t), this.workbook.model = a, this.workbook;
                            }
                            async addMedia(e, t) {
                                await Promise.all(t.media.map(async (t)=>{
                                    if ("image" === t.type) {
                                        const r = `xl/media/${t.name}.${t.extension}`;
                                        if (t.filename) {
                                            const n = await function(e, t) {
                                                return new Promise((r, n)=>{
                                                    i.readFile(e, t, (e, t)=>{
                                                        e ? n(e) : r(t);
                                                    });
                                                });
                                            }(t.filename);
                                            return e.append(n, {
                                                name: r
                                            });
                                        }
                                        if (t.buffer) return e.append(t.buffer, {
                                            name: r
                                        });
                                        if (t.base64) {
                                            const n = t.base64, i = n.substring(n.indexOf(",") + 1);
                                            return e.append(i, {
                                                name: r,
                                                base64: !0
                                            });
                                        }
                                    }
                                    throw new Error("Unsupported media");
                                }));
                            }
                            addDrawings(e, t) {
                                const r = new w, n = new m;
                                t.worksheets.forEach((t)=>{
                                    const { drawing: i } = t;
                                    if (i) {
                                        r.prepare(i, {});
                                        let t = r.toXml(i);
                                        e.append(t, {
                                            name: `xl/drawings/${i.name}.xml`
                                        }), t = n.toXml(i.rels), e.append(t, {
                                            name: `xl/drawings/_rels/${i.name}.xml.rels`
                                        });
                                    }
                                });
                            }
                            addTables(e, t) {
                                const r = new _;
                                t.worksheets.forEach((t)=>{
                                    const { tables: n } = t;
                                    n.forEach((t)=>{
                                        r.prepare(t, {});
                                        const n = r.toXml(t);
                                        e.append(n, {
                                            name: "xl/tables/" + t.target
                                        });
                                    });
                                });
                            }
                            async addContentTypes(e, t) {
                                const r = (new b).toXml(t);
                                e.append(r, {
                                    name: "[Content_Types].xml"
                                });
                            }
                            async addApp(e, t) {
                                const r = (new g).toXml(t);
                                e.append(r, {
                                    name: "docProps/app.xml"
                                });
                            }
                            async addCore(e, t) {
                                const r = new d;
                                e.append(r.toXml(t), {
                                    name: "docProps/core.xml"
                                });
                            }
                            async addThemes(e, t) {
                                const r = t.themes || {
                                    theme1: S
                                };
                                Object.keys(r).forEach((t)=>{
                                    const n = r[t], i = `xl/theme/${t}.xml`;
                                    e.append(n, {
                                        name: i
                                    });
                                });
                            }
                            async addOfficeRels(e) {
                                const t = (new m).toXml([
                                    {
                                        Id: "rId1",
                                        Type: M.RelType.OfficeDocument,
                                        Target: "xl/workbook.xml"
                                    },
                                    {
                                        Id: "rId2",
                                        Type: M.RelType.CoreProperties,
                                        Target: "docProps/core.xml"
                                    },
                                    {
                                        Id: "rId3",
                                        Type: M.RelType.ExtenderProperties,
                                        Target: "docProps/app.xml"
                                    }
                                ]);
                                e.append(t, {
                                    name: "_rels/.rels"
                                });
                            }
                            async addWorkbookRels(e, t) {
                                let r = 1;
                                const n = [
                                    {
                                        Id: "rId" + r++,
                                        Type: M.RelType.Styles,
                                        Target: "styles.xml"
                                    },
                                    {
                                        Id: "rId" + r++,
                                        Type: M.RelType.Theme,
                                        Target: "theme/theme1.xml"
                                    }
                                ];
                                t.sharedStrings.count && n.push({
                                    Id: "rId" + r++,
                                    Type: M.RelType.SharedStrings,
                                    Target: "sharedStrings.xml"
                                }), t.worksheets.forEach((e)=>{
                                    e.rId = "rId" + r++, n.push({
                                        Id: e.rId,
                                        Type: M.RelType.Worksheet,
                                        Target: `worksheets/sheet${e.id}.xml`
                                    });
                                });
                                const i = (new m).toXml(n);
                                e.append(i, {
                                    name: "xl/_rels/workbook.xml.rels"
                                });
                            }
                            async addSharedStrings(e, t) {
                                t.sharedStrings && t.sharedStrings.count && e.append(t.sharedStrings.xml, {
                                    name: "xl/sharedStrings.xml"
                                });
                            }
                            async addStyles(e, t) {
                                const { xml: r } = t.styles;
                                r && e.append(r, {
                                    name: "xl/styles.xml"
                                });
                            }
                            async addWorkbook(e, t) {
                                const r = new y;
                                e.append(r.toXml(t), {
                                    name: "xl/workbook.xml"
                                });
                            }
                            async addWorksheets(e, t) {
                                const r = new v, n = new m, i = new x, s = new k;
                                t.worksheets.forEach((t)=>{
                                    let o = new u;
                                    r.render(o, t), e.append(o.xml, {
                                        name: `xl/worksheets/sheet${t.id}.xml`
                                    }), t.rels && t.rels.length && (o = new u, n.render(o, t.rels), e.append(o.xml, {
                                        name: `xl/worksheets/_rels/sheet${t.id}.xml.rels`
                                    })), t.comments.length > 0 && (o = new u, i.render(o, t), e.append(o.xml, {
                                        name: `xl/comments${t.id}.xml`
                                    }), o = new u, s.render(o, t), e.append(o.xml, {
                                        name: `xl/drawings/vmlDrawing${t.id}.vml`
                                    }));
                                });
                            }
                            _finalize(e) {
                                return new Promise((t, r)=>{
                                    e.on("finish", ()=>{
                                        t(this);
                                    }), e.on("error", r), e.finalize();
                                });
                            }
                            prepareModel(e, t) {
                                e.creator = e.creator || "ExcelJS", e.lastModifiedBy = e.lastModifiedBy || "ExcelJS", e.created = e.created || new Date, e.modified = e.modified || new Date, e.useSharedStrings = void 0 === t.useSharedStrings || t.useSharedStrings, e.useStyles = void 0 === t.useStyles || t.useStyles, e.sharedStrings = new p, e.styles = e.useStyles ? new f(!0) : new f.Mock;
                                const r = new y, n = new v;
                                r.prepare(e);
                                const i = {
                                    sharedStrings: e.sharedStrings,
                                    styles: e.styles,
                                    date1904: e.properties.date1904,
                                    drawingsCount: 0,
                                    media: e.media
                                };
                                i.drawings = e.drawings = [], i.commentRefs = e.commentRefs = [];
                                let s = 0;
                                e.tables = [], e.worksheets.forEach((t)=>{
                                    t.tables.forEach((t)=>{
                                        s++, t.target = `table${s}.xml`, t.id = s, e.tables.push(t);
                                    }), n.prepare(t, i);
                                });
                            }
                            async write(e, t) {
                                t = t || {};
                                const { model: r } = this.workbook, n = new a.ZipWriter(t.zip);
                                return n.pipe(e), this.prepareModel(r, t), await this.addContentTypes(n, r), await this.addOfficeRels(n, r), await this.addWorkbookRels(n, r), await this.addWorksheets(n, r), await this.addSharedStrings(n, r), await this.addDrawings(n, r), await this.addTables(n, r), await Promise.all([
                                    this.addThemes(n, r),
                                    this.addStyles(n, r)
                                ]), await this.addMedia(n, r), await Promise.all([
                                    this.addApp(n, r),
                                    this.addCore(n, r)
                                ]), await this.addWorkbook(n, r), this._finalize(n);
                            }
                            writeFile(e, t) {
                                const r = i.createWriteStream(e);
                                return new Promise((e, n)=>{
                                    r.on("finish", ()=>{
                                        e();
                                    }), r.on("error", (e)=>{
                                        n(e);
                                    }), this.write(r, t).then(()=>{
                                        r.end();
                                    }).catch((e)=>{
                                        n(e);
                                    });
                                });
                            }
                            async writeBuffer(e) {
                                const t = new l;
                                return await this.write(t, e), t.read();
                            }
                        }
                        M.RelType = e("./rel-type"), t.exports = M;
                    }).call(this);
                }).call(this, e("_process"), e("buffer").Buffer);
            },
            {
                "../utils/browser-buffer-decode": 16,
                "../utils/stream-buf": 24,
                "../utils/utils": 27,
                "../utils/xml-stream": 28,
                "../utils/zip-stream": 29,
                "./rel-type": 31,
                "./xform/book/workbook-xform": 38,
                "./xform/comment/comments-xform": 40,
                "./xform/comment/vml-notes-xform": 45,
                "./xform/core/app-xform": 51,
                "./xform/core/content-types-xform": 52,
                "./xform/core/core-xform": 53,
                "./xform/core/relationships-xform": 55,
                "./xform/drawing/drawing-xform": 62,
                "./xform/sheet/worksheet-xform": 115,
                "./xform/strings/shared-strings-xform": 124,
                "./xform/style/styles-xform": 135,
                "./xform/table/table-xform": 143,
                "./xml/theme1": 145,
                _process: 467,
                buffer: 220,
                fs: 216,
                jszip: 441,
                "readable-stream": 491
            }
        ],
        145: [
            function(e, t, r) {
                "use strict";
                t.exports = '<?xml version="1.0" encoding="UTF-8" standalone="yes"?>\n<a:theme xmlns:a="http://schemas.openxmlformats.org/drawingml/2006/main" name="Office Theme"> <a:themeElements> <a:clrScheme name="Office"> <a:dk1> <a:sysClr val="windowText" lastClr="000000"/> </a:dk1> <a:lt1> <a:sysClr val="window" lastClr="FFFFFF"/> </a:lt1> <a:dk2> <a:srgbClr val="1F497D"/> </a:dk2> <a:lt2> <a:srgbClr val="EEECE1"/> </a:lt2> <a:accent1> <a:srgbClr val="4F81BD"/> </a:accent1> <a:accent2> <a:srgbClr val="C0504D"/> </a:accent2> <a:accent3> <a:srgbClr val="9BBB59"/> </a:accent3> <a:accent4> <a:srgbClr val="8064A2"/> </a:accent4> <a:accent5> <a:srgbClr val="4BACC6"/> </a:accent5> <a:accent6> <a:srgbClr val="F79646"/> </a:accent6> <a:hlink> <a:srgbClr val="0000FF"/> </a:hlink> <a:folHlink> <a:srgbClr val="800080"/> </a:folHlink> </a:clrScheme> <a:fontScheme name="Office"> <a:majorFont> <a:latin typeface="Cambria"/> <a:ea typeface=""/> <a:cs typeface=""/> <a:font script="Jpan" typeface="\uff2d\uff33 \uff30\u30b4\u30b7\u30c3\u30af"/> <a:font script="Hang" typeface="\ub9d1\uc740 \uace0\ub515"/> <a:font script="Hans" typeface="\u5b8b\u4f53"/> <a:font script="Hant" typeface="\u65b0\u7d30\u660e\u9ad4"/> <a:font script="Arab" typeface="Times New Roman"/> <a:font script="Hebr" typeface="Times New Roman"/> <a:font script="Thai" typeface="Tahoma"/> <a:font script="Ethi" typeface="Nyala"/> <a:font script="Beng" typeface="Vrinda"/> <a:font script="Gujr" typeface="Shruti"/> <a:font script="Khmr" typeface="MoolBoran"/> <a:font script="Knda" typeface="Tunga"/> <a:font script="Guru" typeface="Raavi"/> <a:font script="Cans" typeface="Euphemia"/> <a:font script="Cher" typeface="Plantagenet Cherokee"/> <a:font script="Yiii" typeface="Microsoft Yi Baiti"/> <a:font script="Tibt" typeface="Microsoft Himalaya"/> <a:font script="Thaa" typeface="MV Boli"/> <a:font script="Deva" typeface="Mangal"/> <a:font script="Telu" typeface="Gautami"/> <a:font script="Taml" typeface="Latha"/> <a:font script="Syrc" typeface="Estrangelo Edessa"/> <a:font script="Orya" typeface="Kalinga"/> <a:font script="Mlym" typeface="Kartika"/> <a:font script="Laoo" typeface="DokChampa"/> <a:font script="Sinh" typeface="Iskoola Pota"/> <a:font script="Mong" typeface="Mongolian Baiti"/> <a:font script="Viet" typeface="Times New Roman"/> <a:font script="Uigh" typeface="Microsoft Uighur"/> <a:font script="Geor" typeface="Sylfaen"/> </a:majorFont> <a:minorFont> <a:latin typeface="Calibri"/> <a:ea typeface=""/> <a:cs typeface=""/> <a:font script="Jpan" typeface="\uff2d\uff33 \uff30\u30b4\u30b7\u30c3\u30af"/> <a:font script="Hang" typeface="\ub9d1\uc740 \uace0\ub515"/> <a:font script="Hans" typeface="\u5b8b\u4f53"/> <a:font script="Hant" typeface="\u65b0\u7d30\u660e\u9ad4"/> <a:font script="Arab" typeface="Arial"/> <a:font script="Hebr" typeface="Arial"/> <a:font script="Thai" typeface="Tahoma"/> <a:font script="Ethi" typeface="Nyala"/> <a:font script="Beng" typeface="Vrinda"/> <a:font script="Gujr" typeface="Shruti"/> <a:font script="Khmr" typeface="DaunPenh"/> <a:font script="Knda" typeface="Tunga"/> <a:font script="Guru" typeface="Raavi"/> <a:font script="Cans" typeface="Euphemia"/> <a:font script="Cher" typeface="Plantagenet Cherokee"/> <a:font script="Yiii" typeface="Microsoft Yi Baiti"/> <a:font script="Tibt" typeface="Microsoft Himalaya"/> <a:font script="Thaa" typeface="MV Boli"/> <a:font script="Deva" typeface="Mangal"/> <a:font script="Telu" typeface="Gautami"/> <a:font script="Taml" typeface="Latha"/> <a:font script="Syrc" typeface="Estrangelo Edessa"/> <a:font script="Orya" typeface="Kalinga"/> <a:font script="Mlym" typeface="Kartika"/> <a:font script="Laoo" typeface="DokChampa"/> <a:font script="Sinh" typeface="Iskoola Pota"/> <a:font script="Mong" typeface="Mongolian Baiti"/> <a:font script="Viet" typeface="Arial"/> <a:font script="Uigh" typeface="Microsoft Uighur"/> <a:font script="Geor" typeface="Sylfaen"/> </a:minorFont> </a:fontScheme> <a:fmtScheme name="Office"> <a:fillStyleLst> <a:solidFill> <a:schemeClr val="phClr"/> </a:solidFill> <a:gradFill rotWithShape="1"> <a:gsLst> <a:gs pos="0"> <a:schemeClr val="phClr"> <a:tint val="50000"/> <a:satMod val="300000"/> </a:schemeClr> </a:gs> <a:gs pos="35000"> <a:schemeClr val="phClr"> <a:tint val="37000"/> <a:satMod val="300000"/> </a:schemeClr> </a:gs> <a:gs pos="100000"> <a:schemeClr val="phClr"> <a:tint val="15000"/> <a:satMod val="350000"/> </a:schemeClr> </a:gs> </a:gsLst> <a:lin ang="16200000" scaled="1"/> </a:gradFill> <a:gradFill rotWithShape="1"> <a:gsLst> <a:gs pos="0"> <a:schemeClr val="phClr"> <a:tint val="100000"/> <a:shade val="100000"/> <a:satMod val="130000"/> </a:schemeClr> </a:gs> <a:gs pos="100000"> <a:schemeClr val="phClr"> <a:tint val="50000"/> <a:shade val="100000"/> <a:satMod val="350000"/> </a:schemeClr> </a:gs> </a:gsLst> <a:lin ang="16200000" scaled="0"/> </a:gradFill> </a:fillStyleLst> <a:lnStyleLst> <a:ln w="9525" cap="flat" cmpd="sng" algn="ctr"> <a:solidFill> <a:schemeClr val="phClr"> <a:shade val="95000"/> <a:satMod val="105000"/> </a:schemeClr> </a:solidFill> <a:prstDash val="solid"/> </a:ln> <a:ln w="25400" cap="flat" cmpd="sng" algn="ctr"> <a:solidFill> <a:schemeClr val="phClr"/> </a:solidFill> <a:prstDash val="solid"/> </a:ln> <a:ln w="38100" cap="flat" cmpd="sng" algn="ctr"> <a:solidFill> <a:schemeClr val="phClr"/> </a:solidFill> <a:prstDash val="solid"/> </a:ln> </a:lnStyleLst> <a:effectStyleLst> <a:effectStyle> <a:effectLst> <a:outerShdw blurRad="40000" dist="20000" dir="5400000" rotWithShape="0"> <a:srgbClr val="000000"> <a:alpha val="38000"/> </a:srgbClr> </a:outerShdw> </a:effectLst> </a:effectStyle> <a:effectStyle> <a:effectLst> <a:outerShdw blurRad="40000" dist="23000" dir="5400000" rotWithShape="0"> <a:srgbClr val="000000"> <a:alpha val="35000"/> </a:srgbClr> </a:outerShdw> </a:effectLst> </a:effectStyle> <a:effectStyle> <a:effectLst> <a:outerShdw blurRad="40000" dist="23000" dir="5400000" rotWithShape="0"> <a:srgbClr val="000000"> <a:alpha val="35000"/> </a:srgbClr> </a:outerShdw> </a:effectLst> <a:scene3d> <a:camera prst="orthographicFront"> <a:rot lat="0" lon="0" rev="0"/> </a:camera> <a:lightRig rig="threePt" dir="t"> <a:rot lat="0" lon="0" rev="1200000"/> </a:lightRig> </a:scene3d> <a:sp3d> <a:bevelT w="63500" h="25400"/> </a:sp3d> </a:effectStyle> </a:effectStyleLst> <a:bgFillStyleLst> <a:solidFill> <a:schemeClr val="phClr"/> </a:solidFill> <a:gradFill rotWithShape="1"> <a:gsLst> <a:gs pos="0"> <a:schemeClr val="phClr"> <a:tint val="40000"/> <a:satMod val="350000"/> </a:schemeClr> </a:gs> <a:gs pos="40000"> <a:schemeClr val="phClr"> <a:tint val="45000"/> <a:shade val="99000"/> <a:satMod val="350000"/> </a:schemeClr> </a:gs> <a:gs pos="100000"> <a:schemeClr val="phClr"> <a:shade val="20000"/> <a:satMod val="255000"/> </a:schemeClr> </a:gs> </a:gsLst> <a:path path="circle"> <a:fillToRect l="50000" t="-80000" r="50000" b="180000"/> </a:path> </a:gradFill> <a:gradFill rotWithShape="1"> <a:gsLst> <a:gs pos="0"> <a:schemeClr val="phClr"> <a:tint val="80000"/> <a:satMod val="300000"/> </a:schemeClr> </a:gs> <a:gs pos="100000"> <a:schemeClr val="phClr"> <a:shade val="30000"/> <a:satMod val="200000"/> </a:schemeClr> </a:gs> </a:gsLst> <a:path path="circle"> <a:fillToRect l="50000" t="50000" r="50000" b="50000"/> </a:path> </a:gradFill> </a:bgFillStyleLst> </a:fmtScheme> </a:themeElements> <a:objectDefaults> <a:spDef> <a:spPr/> <a:bodyPr/> <a:lstStyle/> <a:style> <a:lnRef idx="1"> <a:schemeClr val="accent1"/> </a:lnRef> <a:fillRef idx="3"> <a:schemeClr val="accent1"/> </a:fillRef> <a:effectRef idx="2"> <a:schemeClr val="accent1"/> </a:effectRef> <a:fontRef idx="minor"> <a:schemeClr val="lt1"/> </a:fontRef> </a:style> </a:spDef> <a:lnDef> <a:spPr/> <a:bodyPr/> <a:lstStyle/> <a:style> <a:lnRef idx="2"> <a:schemeClr val="accent1"/> </a:lnRef> <a:fillRef idx="0"> <a:schemeClr val="accent1"/> </a:fillRef> <a:effectRef idx="1"> <a:schemeClr val="accent1"/> </a:effectRef> <a:fontRef idx="minor"> <a:schemeClr val="tx1"/> </a:fontRef> </a:style> </a:lnDef> </a:objectDefaults> <a:extraClrSchemeLst/> </a:theme>';
            },
            {}
        ],
        146: [
            function(e, t, r) {
                (function(t) {
                    (function() {
                        "use strict";
                        Object.defineProperty(r, "__esModule", {
                            value: !0
                        }), r.CsvFormatterStream = void 0;
                        const n = e("stream"), i = e("./formatter");
                        class s extends n.Transform {
                            constructor(e){
                                super({
                                    writableObjectMode: e.objectMode
                                }), this.hasWrittenBOM = !1, this.formatterOptions = e, this.rowFormatter = new i.RowFormatter(e), this.hasWrittenBOM = !e.writeBOM;
                            }
                            transform(e) {
                                return this.rowFormatter.rowTransform = e, this;
                            }
                            _transform(e, r, n) {
                                let i = !1;
                                try {
                                    this.hasWrittenBOM || (this.push(this.formatterOptions.BOM), this.hasWrittenBOM = !0), this.rowFormatter.format(e, (e, r)=>e ? (i = !0, n(e)) : (r && r.forEach((e)=>{
                                            this.push(t.from(e, "utf8"));
                                        }), i = !0, n()));
                                } catch (e) {
                                    if (i) throw e;
                                    n(e);
                                }
                            }
                            _flush(e) {
                                this.rowFormatter.finish((r, n)=>r ? e(r) : (n && n.forEach((e)=>{
                                        this.push(t.from(e, "utf8"));
                                    }), e()));
                            }
                        }
                        r.CsvFormatterStream = s;
                    }).call(this);
                }).call(this, e("buffer").Buffer);
            },
            {
                "./formatter": 150,
                buffer: 220,
                stream: 505
            }
        ],
        147: [
            function(e, t, r) {
                "use strict";
                Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.FormatterOptions = void 0;
                r.FormatterOptions = class {
                    constructor(){
                        let e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
                        var t;
                        this.objectMode = !0, this.delimiter = ",", this.rowDelimiter = "\n", this.quote = '"', this.escape = this.quote, this.quoteColumns = !1, this.quoteHeaders = this.quoteColumns, this.headers = null, this.includeEndRowDelimiter = !1, this.writeBOM = !1, this.BOM = "\ufeff", this.alwaysWriteHeaders = !1, Object.assign(this, e || {}), void 0 === (null == e ? void 0 : e.quoteHeaders) && (this.quoteHeaders = this.quoteColumns), !0 === (null == e ? void 0 : e.quote) ? this.quote = '"' : !1 === (null == e ? void 0 : e.quote) && (this.quote = ""), "string" != typeof (null == e ? void 0 : e.escape) && (this.escape = this.quote), this.shouldWriteHeaders = !!this.headers && (null === (t = e.writeHeaders) || void 0 === t || t), this.headers = Array.isArray(this.headers) ? this.headers : null, this.escapedQuote = `${this.escape}${this.quote}`;
                    }
                };
            },
            {}
        ],
        148: [
            function(e, t, r) {
                "use strict";
                var n = function(e) {
                    return e && e.__esModule ? e : {
                        default: e
                    };
                };
                Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.FieldFormatter = void 0;
                const i = n(e("lodash.isboolean")), s = n(e("lodash.isnil")), o = n(e("lodash.escaperegexp"));
                r.FieldFormatter = class {
                    constructor(e){
                        this._headers = null, this.formatterOptions = e, null !== e.headers && (this.headers = e.headers), this.REPLACE_REGEXP = new RegExp(e.quote, "g");
                        const t = `[${e.delimiter}${o.default(e.rowDelimiter)}|\r|\n]`;
                        this.ESCAPE_REGEXP = new RegExp(t);
                    }
                    set headers(e) {
                        this._headers = e;
                    }
                    shouldQuote(e, t) {
                        const r = t ? this.formatterOptions.quoteHeaders : this.formatterOptions.quoteColumns;
                        return i.default(r) ? r : Array.isArray(r) ? r[e] : null !== this._headers && r[this._headers[e]];
                    }
                    format(e, t, r) {
                        const n = ("" + (s.default(e) ? "" : e)).replace(/\0/g, ""), { formatterOptions: i } = this;
                        if ("" !== i.quote) {
                            if (-1 !== n.indexOf(i.quote)) return this.quoteField(n.replace(this.REPLACE_REGEXP, i.escapedQuote));
                        }
                        return -1 !== n.search(this.ESCAPE_REGEXP) || this.shouldQuote(t, r) ? this.quoteField(n) : n;
                    }
                    quoteField(e) {
                        const { quote: t } = this.formatterOptions;
                        return `${t}${e}${t}`;
                    }
                };
            },
            {
                "lodash.escaperegexp": 442,
                "lodash.isboolean": 444,
                "lodash.isnil": 447
            }
        ],
        149: [
            function(e, t, r) {
                "use strict";
                var n = function(e) {
                    return e && e.__esModule ? e : {
                        default: e
                    };
                };
                Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.RowFormatter = void 0;
                const i = n(e("lodash.isfunction")), s = n(e("lodash.isequal")), o = e("./FieldFormatter"), a = e("../types");
                class l {
                    constructor(e){
                        this.rowCount = 0, this.formatterOptions = e, this.fieldFormatter = new o.FieldFormatter(e), this.headers = e.headers, this.shouldWriteHeaders = e.shouldWriteHeaders, this.hasWrittenHeaders = !1, null !== this.headers && (this.fieldFormatter.headers = this.headers), e.transform && (this.rowTransform = e.transform);
                    }
                    static isRowHashArray(e) {
                        return !!Array.isArray(e) && Array.isArray(e[0]) && 2 === e[0].length;
                    }
                    static isRowArray(e) {
                        return Array.isArray(e) && !this.isRowHashArray(e);
                    }
                    static gatherHeaders(e) {
                        return l.isRowHashArray(e) ? e.map((e)=>e[0]) : Array.isArray(e) ? e : Object.keys(e);
                    }
                    static createTransform(e) {
                        return a.isSyncTransform(e) ? (t, r)=>{
                            let n = null;
                            try {
                                n = e(t);
                            } catch (e) {
                                return r(e);
                            }
                            return r(null, n);
                        } : (t, r)=>{
                            e(t, r);
                        };
                    }
                    set rowTransform(e) {
                        if (!i.default(e)) throw new TypeError("The transform should be a function");
                        this._rowTransform = l.createTransform(e);
                    }
                    format(e, t) {
                        this.callTransformer(e, (r, n)=>{
                            if (r) return t(r);
                            if (!e) return t(null);
                            const i = [];
                            if (n) {
                                const { shouldFormatColumns: e, headers: t } = this.checkHeaders(n);
                                if (this.shouldWriteHeaders && t && !this.hasWrittenHeaders && (i.push(this.formatColumns(t, !0)), this.hasWrittenHeaders = !0), e) {
                                    const e = this.gatherColumns(n);
                                    i.push(this.formatColumns(e, !1));
                                }
                            }
                            return t(null, i);
                        });
                    }
                    finish(e) {
                        const t = [];
                        if (this.formatterOptions.alwaysWriteHeaders && 0 === this.rowCount) {
                            if (!this.headers) return e(new Error("`alwaysWriteHeaders` option is set to true but `headers` option not provided."));
                            t.push(this.formatColumns(this.headers, !0));
                        }
                        return this.formatterOptions.includeEndRowDelimiter && t.push(this.formatterOptions.rowDelimiter), e(null, t);
                    }
                    checkHeaders(e) {
                        if (this.headers) return {
                            shouldFormatColumns: !0,
                            headers: this.headers
                        };
                        const t = l.gatherHeaders(e);
                        return this.headers = t, this.fieldFormatter.headers = t, this.shouldWriteHeaders ? {
                            shouldFormatColumns: !s.default(t, e),
                            headers: t
                        } : {
                            shouldFormatColumns: !0,
                            headers: null
                        };
                    }
                    gatherColumns(e) {
                        if (null === this.headers) throw new Error("Headers is currently null");
                        return Array.isArray(e) ? l.isRowHashArray(e) ? this.headers.map((t, r)=>{
                            const n = e[r];
                            return n ? n[1] : "";
                        }) : l.isRowArray(e) && !this.shouldWriteHeaders ? e : this.headers.map((t, r)=>e[r]) : this.headers.map((t)=>e[t]);
                    }
                    callTransformer(e, t) {
                        return this._rowTransform ? this._rowTransform(e, t) : t(null, e);
                    }
                    formatColumns(e, t) {
                        const r = e.map((e, r)=>this.fieldFormatter.format(e, r, t)).join(this.formatterOptions.delimiter), { rowCount: n } = this;
                        return this.rowCount += 1, n ? [
                            this.formatterOptions.rowDelimiter,
                            r
                        ].join("") : r;
                    }
                }
                r.RowFormatter = l;
            },
            {
                "../types": 152,
                "./FieldFormatter": 148,
                "lodash.isequal": 445,
                "lodash.isfunction": 446
            }
        ],
        150: [
            function(e, t, r) {
                "use strict";
                Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.FieldFormatter = r.RowFormatter = void 0;
                var n = e("./RowFormatter");
                Object.defineProperty(r, "RowFormatter", {
                    enumerable: !0,
                    get: function() {
                        return n.RowFormatter;
                    }
                });
                var i = e("./FieldFormatter");
                Object.defineProperty(r, "FieldFormatter", {
                    enumerable: !0,
                    get: function() {
                        return i.FieldFormatter;
                    }
                });
            },
            {
                "./FieldFormatter": 148,
                "./RowFormatter": 149
            }
        ],
        151: [
            function(e, t, r) {
                (function(t) {
                    (function() {
                        "use strict";
                        var n = Object.create ? function(e, t, r, n) {
                            void 0 === n && (n = r), Object.defineProperty(e, n, {
                                enumerable: !0,
                                get: function() {
                                    return t[r];
                                }
                            });
                        } : function(e, t, r, n) {
                            void 0 === n && (n = r), e[n] = t[r];
                        }, i = Object.create ? function(e, t) {
                            Object.defineProperty(e, "default", {
                                enumerable: !0,
                                value: t
                            });
                        } : function(e, t) {
                            e.default = t;
                        }, s = function(e) {
                            if (e && e.__esModule) return e;
                            var t = {};
                            if (null != e) for(var r in e)"default" !== r && Object.prototype.hasOwnProperty.call(e, r) && n(t, e, r);
                            return i(t, e), t;
                        }, o = function(e, t) {
                            for(var r in e)"default" === r || Object.prototype.hasOwnProperty.call(t, r) || n(t, e, r);
                        };
                        Object.defineProperty(r, "__esModule", {
                            value: !0
                        }), r.writeToPath = r.writeToString = r.writeToBuffer = r.writeToStream = r.write = r.format = r.FormatterOptions = r.CsvFormatterStream = void 0;
                        const a = e("util"), l = e("stream"), c = s(e("fs")), u = e("./FormatterOptions"), h = e("./CsvFormatterStream");
                        o(e("./types"), r);
                        var f = e("./CsvFormatterStream");
                        Object.defineProperty(r, "CsvFormatterStream", {
                            enumerable: !0,
                            get: function() {
                                return f.CsvFormatterStream;
                            }
                        });
                        var d = e("./FormatterOptions");
                        Object.defineProperty(r, "FormatterOptions", {
                            enumerable: !0,
                            get: function() {
                                return d.FormatterOptions;
                            }
                        }), r.format = (e)=>new h.CsvFormatterStream(new u.FormatterOptions(e)), r.write = (e, t)=>{
                            const n = r.format(t), i = a.promisify((e, t)=>{
                                n.write(e, void 0, t);
                            });
                            return e.reduce((e, t)=>e.then(()=>i(t)), Promise.resolve()).then(()=>n.end()).catch((e)=>{
                                n.emit("error", e);
                            }), n;
                        }, r.writeToStream = (e, t, n)=>r.write(t, n).pipe(e), r.writeToBuffer = function(e) {
                            let n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
                            const i = [], s = new l.Writable({
                                write (e, t, r) {
                                    i.push(e), r();
                                }
                            });
                            return new Promise((o, a)=>{
                                s.on("error", a).on("finish", ()=>o(t.concat(i))), r.write(e, n).pipe(s);
                            });
                        }, r.writeToString = (e, t)=>r.writeToBuffer(e, t).then((e)=>e.toString()), r.writeToPath = (e, t, n)=>{
                            const i = c.createWriteStream(e, {
                                encoding: "utf8"
                            });
                            return r.write(t, n).pipe(i);
                        };
                    }).call(this);
                }).call(this, e("buffer").Buffer);
            },
            {
                "./CsvFormatterStream": 146,
                "./FormatterOptions": 147,
                "./types": 152,
                buffer: 220,
                fs: 216,
                stream: 505,
                util: 527
            }
        ],
        152: [
            function(e, t, r) {
                "use strict";
                Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.isSyncTransform = void 0, r.isSyncTransform = (e)=>1 === e.length;
            },
            {}
        ],
        153: [
            function(e, t, r) {
                (function(t) {
                    (function() {
                        "use strict";
                        Object.defineProperty(r, "__esModule", {
                            value: !0
                        }), r.CsvParserStream = void 0;
                        const n = e("string_decoder"), i = e("stream"), s = e("./transforms"), o = e("./parser");
                        class a extends i.Transform {
                            constructor(e){
                                super({
                                    objectMode: e.objectMode
                                }), this.lines = "", this.rowCount = 0, this.parsedRowCount = 0, this.parsedLineCount = 0, this.endEmitted = !1, this.headersEmitted = !1, this.parserOptions = e, this.parser = new o.Parser(e), this.headerTransformer = new s.HeaderTransformer(e), this.decoder = new n.StringDecoder(e.encoding), this.rowTransformerValidator = new s.RowTransformerValidator;
                            }
                            get hasHitRowLimit() {
                                return this.parserOptions.limitRows && this.rowCount >= this.parserOptions.maxRows;
                            }
                            get shouldEmitRows() {
                                return this.parsedRowCount > this.parserOptions.skipRows;
                            }
                            get shouldSkipLine() {
                                return this.parsedLineCount <= this.parserOptions.skipLines;
                            }
                            transform(e) {
                                return this.rowTransformerValidator.rowTransform = e, this;
                            }
                            validate(e) {
                                return this.rowTransformerValidator.rowValidator = e, this;
                            }
                            emit(e) {
                                if ("end" === e) return this.endEmitted || (this.endEmitted = !0, super.emit("end", this.rowCount)), !1;
                                for(var t = arguments.length, r = new Array(t > 1 ? t - 1 : 0), n = 1; n < t; n++)r[n - 1] = arguments[n];
                                return super.emit(e, ...r);
                            }
                            _transform(e, t, r) {
                                if (this.hasHitRowLimit) return r();
                                const n = a.wrapDoneCallback(r);
                                try {
                                    const { lines: t } = this, r = t + this.decoder.write(e), i = this.parse(r, !0);
                                    return this.processRows(i, n);
                                } catch (e) {
                                    return n(e);
                                }
                            }
                            _flush(e) {
                                const t = a.wrapDoneCallback(e);
                                if (this.hasHitRowLimit) return t();
                                try {
                                    const e = this.lines + this.decoder.end(), r = this.parse(e, !1);
                                    return this.processRows(r, t);
                                } catch (e) {
                                    return t(e);
                                }
                            }
                            parse(e, t) {
                                if (!e) return [];
                                const { line: r, rows: n } = this.parser.parse(e, t);
                                return this.lines = r, n;
                            }
                            processRows(e, r) {
                                const n = e.length, i = (s)=>{
                                    const o = (e)=>e ? r(e) : s % 100 != 0 ? i(s + 1) : void t(()=>i(s + 1));
                                    if (this.checkAndEmitHeaders(), s >= n || this.hasHitRowLimit) return r();
                                    if (this.parsedLineCount += 1, this.shouldSkipLine) return o();
                                    const a = e[s];
                                    this.rowCount += 1, this.parsedRowCount += 1;
                                    const l = this.rowCount;
                                    return this.transformRow(a, (e, t)=>{
                                        if (e) return this.rowCount -= 1, o(e);
                                        if (!t) return o(new Error("expected transform result"));
                                        if (t.isValid) {
                                            if (t.row) return this.pushRow(t.row, o);
                                        } else this.emit("data-invalid", t.row, l, t.reason);
                                        return o();
                                    });
                                };
                                i(0);
                            }
                            transformRow(e, t) {
                                try {
                                    this.headerTransformer.transform(e, (r, n)=>r ? t(r) : n ? n.isValid ? n.row ? this.shouldEmitRows ? this.rowTransformerValidator.transformAndValidate(n.row, t) : this.skipRow(t) : (this.rowCount -= 1, this.parsedRowCount -= 1, t(null, {
                                            row: null,
                                            isValid: !0
                                        })) : this.shouldEmitRows ? t(null, {
                                            isValid: !1,
                                            row: e
                                        }) : this.skipRow(t) : t(new Error("Expected result from header transform")));
                                } catch (e) {
                                    t(e);
                                }
                            }
                            checkAndEmitHeaders() {
                                !this.headersEmitted && this.headerTransformer.headers && (this.headersEmitted = !0, this.emit("headers", this.headerTransformer.headers));
                            }
                            skipRow(e) {
                                return this.rowCount -= 1, e(null, {
                                    row: null,
                                    isValid: !0
                                });
                            }
                            pushRow(e, t) {
                                try {
                                    this.parserOptions.objectMode ? this.push(e) : this.push(JSON.stringify(e)), t();
                                } catch (e) {
                                    t(e);
                                }
                            }
                            static wrapDoneCallback(e) {
                                let t = !1;
                                return function(r) {
                                    if (r) {
                                        if (t) throw r;
                                        return t = !0, void e(r);
                                    }
                                    for(var n = arguments.length, i = new Array(n > 1 ? n - 1 : 0), s = 1; s < n; s++)i[s - 1] = arguments[s];
                                    e(...i);
                                };
                            }
                        }
                        r.CsvParserStream = a;
                    }).call(this);
                }).call(this, e("timers").setImmediate);
            },
            {
                "./parser": 165,
                "./transforms": 168,
                stream: 505,
                string_decoder: 218,
                timers: 523
            }
        ],
        154: [
            function(e, t, r) {
                "use strict";
                var n = function(e) {
                    return e && e.__esModule ? e : {
                        default: e
                    };
                };
                Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.ParserOptions = void 0;
                const i = n(e("lodash.escaperegexp")), s = n(e("lodash.isnil"));
                r.ParserOptions = class {
                    constructor(e){
                        var t;
                        if (this.objectMode = !0, this.delimiter = ",", this.ignoreEmpty = !1, this.quote = '"', this.escape = null, this.escapeChar = this.quote, this.comment = null, this.supportsComments = !1, this.ltrim = !1, this.rtrim = !1, this.trim = !1, this.headers = null, this.renameHeaders = !1, this.strictColumnHandling = !1, this.discardUnmappedColumns = !1, this.carriageReturn = "\r", this.encoding = "utf8", this.limitRows = !1, this.maxRows = 0, this.skipLines = 0, this.skipRows = 0, Object.assign(this, e || {}), this.delimiter.length > 1) throw new Error("delimiter option must be one character long");
                        this.escapedDelimiter = i.default(this.delimiter), this.escapeChar = null !== (t = this.escape) && void 0 !== t ? t : this.quote, this.supportsComments = !s.default(this.comment), this.NEXT_TOKEN_REGEXP = new RegExp(`([^\\s]|\\r\\n|\\n|\\r|${this.escapedDelimiter})`), this.maxRows > 0 && (this.limitRows = !0);
                    }
                };
            },
            {
                "lodash.escaperegexp": 442,
                "lodash.isnil": 447
            }
        ],
        155: [
            function(e, t, r) {
                "use strict";
                var n = Object.create ? function(e, t, r, n) {
                    void 0 === n && (n = r), Object.defineProperty(e, n, {
                        enumerable: !0,
                        get: function() {
                            return t[r];
                        }
                    });
                } : function(e, t, r, n) {
                    void 0 === n && (n = r), e[n] = t[r];
                }, i = Object.create ? function(e, t) {
                    Object.defineProperty(e, "default", {
                        enumerable: !0,
                        value: t
                    });
                } : function(e, t) {
                    e.default = t;
                }, s = function(e) {
                    if (e && e.__esModule) return e;
                    var t = {};
                    if (null != e) for(var r in e)"default" !== r && Object.prototype.hasOwnProperty.call(e, r) && n(t, e, r);
                    return i(t, e), t;
                }, o = function(e, t) {
                    for(var r in e)"default" === r || Object.prototype.hasOwnProperty.call(t, r) || n(t, e, r);
                };
                Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.parseString = r.parseFile = r.parseStream = r.parse = r.ParserOptions = r.CsvParserStream = void 0;
                const a = s(e("fs")), l = e("stream"), c = e("./ParserOptions"), u = e("./CsvParserStream");
                o(e("./types"), r);
                var h = e("./CsvParserStream");
                Object.defineProperty(r, "CsvParserStream", {
                    enumerable: !0,
                    get: function() {
                        return h.CsvParserStream;
                    }
                });
                var f = e("./ParserOptions");
                Object.defineProperty(r, "ParserOptions", {
                    enumerable: !0,
                    get: function() {
                        return f.ParserOptions;
                    }
                }), r.parse = (e)=>new u.CsvParserStream(new c.ParserOptions(e)), r.parseStream = (e, t)=>e.pipe(new u.CsvParserStream(new c.ParserOptions(t))), r.parseFile = function(e) {
                    let t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
                    return a.createReadStream(e).pipe(new u.CsvParserStream(new c.ParserOptions(t)));
                }, r.parseString = (e, t)=>{
                    const r = new l.Readable;
                    return r.push(e), r.push(null), r.pipe(new u.CsvParserStream(new c.ParserOptions(t)));
                };
            },
            {
                "./CsvParserStream": 153,
                "./ParserOptions": 154,
                "./types": 169,
                fs: 216,
                stream: 505
            }
        ],
        156: [
            function(e, t, r) {
                "use strict";
                Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.Parser = void 0;
                const n = e("./Scanner"), i = e("./RowParser"), s = e("./Token");
                class o {
                    constructor(e){
                        this.parserOptions = e, this.rowParser = new i.RowParser(this.parserOptions);
                    }
                    static removeBOM(e) {
                        return e && 65279 === e.charCodeAt(0) ? e.slice(1) : e;
                    }
                    parse(e, t) {
                        const r = new n.Scanner({
                            line: o.removeBOM(e),
                            parserOptions: this.parserOptions,
                            hasMoreData: t
                        });
                        return this.parserOptions.supportsComments ? this.parseWithComments(r) : this.parseWithoutComments(r);
                    }
                    parseWithoutComments(e) {
                        const t = [];
                        let r = !0;
                        for(; r;)r = this.parseRow(e, t);
                        return {
                            line: e.line,
                            rows: t
                        };
                    }
                    parseWithComments(e) {
                        const { parserOptions: t } = this, r = [];
                        for(let n = e.nextCharacterToken; null !== n; n = e.nextCharacterToken)if (s.Token.isTokenComment(n, t)) {
                            if (null === e.advancePastLine()) return {
                                line: e.lineFromCursor,
                                rows: r
                            };
                            if (!e.hasMoreCharacters) return {
                                line: e.lineFromCursor,
                                rows: r
                            };
                            e.truncateToCursor();
                        } else if (!this.parseRow(e, r)) break;
                        return {
                            line: e.line,
                            rows: r
                        };
                    }
                    parseRow(e, t) {
                        if (!e.nextNonSpaceToken) return !1;
                        const r = this.rowParser.parse(e);
                        return null !== r && (this.parserOptions.ignoreEmpty && i.RowParser.isEmptyRow(r) || t.push(r), !0);
                    }
                }
                r.Parser = o;
            },
            {
                "./RowParser": 157,
                "./Scanner": 158,
                "./Token": 159
            }
        ],
        157: [
            function(e, t, r) {
                "use strict";
                Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.RowParser = void 0;
                const n = e("./column"), i = e("./Token");
                r.RowParser = class {
                    constructor(e){
                        this.parserOptions = e, this.columnParser = new n.ColumnParser(e);
                    }
                    static isEmptyRow(e) {
                        return "" === e.join("").replace(/\s+/g, "");
                    }
                    parse(e) {
                        const { parserOptions: t } = this, { hasMoreData: r } = e, n = e, s = [];
                        let o = this.getStartToken(n, s);
                        for(; o;){
                            if (i.Token.isTokenRowDelimiter(o)) return n.advancePastToken(o), !n.hasMoreCharacters && i.Token.isTokenCarriageReturn(o, t) && r ? null : (n.truncateToCursor(), s);
                            if (!this.shouldSkipColumnParse(n, o, s)) {
                                const e = this.columnParser.parse(n);
                                if (null === e) return null;
                                s.push(e);
                            }
                            o = n.nextNonSpaceToken;
                        }
                        return r ? null : (n.truncateToCursor(), s);
                    }
                    getStartToken(e, t) {
                        const r = e.nextNonSpaceToken;
                        return null !== r && i.Token.isTokenDelimiter(r, this.parserOptions) ? (t.push(""), e.nextNonSpaceToken) : r;
                    }
                    shouldSkipColumnParse(e, t, r) {
                        const { parserOptions: n } = this;
                        if (i.Token.isTokenDelimiter(t, n)) {
                            e.advancePastToken(t);
                            const s = e.nextCharacterToken;
                            if (!e.hasMoreCharacters || null !== s && i.Token.isTokenRowDelimiter(s)) return r.push(""), !0;
                            if (null !== s && i.Token.isTokenDelimiter(s, n)) return r.push(""), !0;
                        }
                        return !1;
                    }
                };
            },
            {
                "./Token": 159,
                "./column": 164
            }
        ],
        158: [
            function(e, t, r) {
                "use strict";
                Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.Scanner = void 0;
                const n = e("./Token"), i = /((?:\r\n)|\n|\r)/;
                r.Scanner = class {
                    constructor(e){
                        this.cursor = 0, this.line = e.line, this.lineLength = this.line.length, this.parserOptions = e.parserOptions, this.hasMoreData = e.hasMoreData, this.cursor = e.cursor || 0;
                    }
                    get hasMoreCharacters() {
                        return this.lineLength > this.cursor;
                    }
                    get nextNonSpaceToken() {
                        const { lineFromCursor: e } = this, t = this.parserOptions.NEXT_TOKEN_REGEXP;
                        if (-1 === e.search(t)) return null;
                        const r = t.exec(e);
                        if (null == r) return null;
                        const i = r[1], s = this.cursor + (r.index || 0);
                        return new n.Token({
                            token: i,
                            startCursor: s,
                            endCursor: s + i.length - 1
                        });
                    }
                    get nextCharacterToken() {
                        const { cursor: e, lineLength: t } = this;
                        return t <= e ? null : new n.Token({
                            token: this.line[e],
                            startCursor: e,
                            endCursor: e
                        });
                    }
                    get lineFromCursor() {
                        return this.line.substr(this.cursor);
                    }
                    advancePastLine() {
                        const e = i.exec(this.lineFromCursor);
                        return e ? (this.cursor += (e.index || 0) + e[0].length, this) : this.hasMoreData ? null : (this.cursor = this.lineLength, this);
                    }
                    advanceTo(e) {
                        return this.cursor = e, this;
                    }
                    advanceToToken(e) {
                        return this.cursor = e.startCursor, this;
                    }
                    advancePastToken(e) {
                        return this.cursor = e.endCursor + 1, this;
                    }
                    truncateToCursor() {
                        return this.line = this.lineFromCursor, this.lineLength = this.line.length, this.cursor = 0, this;
                    }
                };
            },
            {
                "./Token": 159
            }
        ],
        159: [
            function(e, t, r) {
                "use strict";
                Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.Token = void 0;
                r.Token = class {
                    constructor(e){
                        this.token = e.token, this.startCursor = e.startCursor, this.endCursor = e.endCursor;
                    }
                    static isTokenRowDelimiter(e) {
                        const t = e.token;
                        return "\r" === t || "\n" === t || "\r\n" === t;
                    }
                    static isTokenCarriageReturn(e, t) {
                        return e.token === t.carriageReturn;
                    }
                    static isTokenComment(e, t) {
                        return t.supportsComments && !!e && e.token === t.comment;
                    }
                    static isTokenEscapeCharacter(e, t) {
                        return e.token === t.escapeChar;
                    }
                    static isTokenQuote(e, t) {
                        return e.token === t.quote;
                    }
                    static isTokenDelimiter(e, t) {
                        return e.token === t.delimiter;
                    }
                };
            },
            {}
        ],
        160: [
            function(e, t, r) {
                "use strict";
                Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.ColumnFormatter = void 0;
                r.ColumnFormatter = class {
                    constructor(e){
                        e.trim ? this.format = (e)=>e.trim() : e.ltrim ? this.format = (e)=>e.trimLeft() : e.rtrim ? this.format = (e)=>e.trimRight() : this.format = (e)=>e;
                    }
                };
            },
            {}
        ],
        161: [
            function(e, t, r) {
                "use strict";
                Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.ColumnParser = void 0;
                const n = e("./NonQuotedColumnParser"), i = e("./QuotedColumnParser"), s = e("../Token");
                r.ColumnParser = class {
                    constructor(e){
                        this.parserOptions = e, this.quotedColumnParser = new i.QuotedColumnParser(e), this.nonQuotedColumnParser = new n.NonQuotedColumnParser(e);
                    }
                    parse(e) {
                        const { nextNonSpaceToken: t } = e;
                        return null !== t && s.Token.isTokenQuote(t, this.parserOptions) ? (e.advanceToToken(t), this.quotedColumnParser.parse(e)) : this.nonQuotedColumnParser.parse(e);
                    }
                };
            },
            {
                "../Token": 159,
                "./NonQuotedColumnParser": 162,
                "./QuotedColumnParser": 163
            }
        ],
        162: [
            function(e, t, r) {
                "use strict";
                Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.NonQuotedColumnParser = void 0;
                const n = e("./ColumnFormatter"), i = e("../Token");
                r.NonQuotedColumnParser = class {
                    constructor(e){
                        this.parserOptions = e, this.columnFormatter = new n.ColumnFormatter(e);
                    }
                    parse(e) {
                        if (!e.hasMoreCharacters) return null;
                        const { parserOptions: t } = this, r = [];
                        let n = e.nextCharacterToken;
                        for(; n && !i.Token.isTokenDelimiter(n, t) && !i.Token.isTokenRowDelimiter(n); n = e.nextCharacterToken)r.push(n.token), e.advancePastToken(n);
                        return this.columnFormatter.format(r.join(""));
                    }
                };
            },
            {
                "../Token": 159,
                "./ColumnFormatter": 160
            }
        ],
        163: [
            function(e, t, r) {
                "use strict";
                Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.QuotedColumnParser = void 0;
                const n = e("./ColumnFormatter"), i = e("../Token");
                r.QuotedColumnParser = class {
                    constructor(e){
                        this.parserOptions = e, this.columnFormatter = new n.ColumnFormatter(e);
                    }
                    parse(e) {
                        if (!e.hasMoreCharacters) return null;
                        const t = e.cursor, { foundClosingQuote: r, col: n } = this.gatherDataBetweenQuotes(e);
                        if (!r) {
                            if (e.advanceTo(t), !e.hasMoreData) throw new Error(`Parse Error: missing closing: '${this.parserOptions.quote || ""}' in line: at '${e.lineFromCursor.replace(/[\r\n]/g, "\\n'")}'`);
                            return null;
                        }
                        return this.checkForMalformedColumn(e), n;
                    }
                    gatherDataBetweenQuotes(e) {
                        const { parserOptions: t } = this;
                        let r = !1, n = !1;
                        const s = [];
                        let o = e.nextCharacterToken;
                        for(; !n && null !== o; o = e.nextCharacterToken){
                            const a = i.Token.isTokenQuote(o, t);
                            if (!r && a) r = !0;
                            else if (r) {
                                if (i.Token.isTokenEscapeCharacter(o, t)) {
                                    e.advancePastToken(o);
                                    const r = e.nextCharacterToken;
                                    null !== r && (i.Token.isTokenQuote(r, t) || i.Token.isTokenEscapeCharacter(r, t)) ? (s.push(r.token), o = r) : a ? n = !0 : s.push(o.token);
                                } else a ? n = !0 : s.push(o.token);
                            }
                            e.advancePastToken(o);
                        }
                        return {
                            col: this.columnFormatter.format(s.join("")),
                            foundClosingQuote: n
                        };
                    }
                    checkForMalformedColumn(e) {
                        const { parserOptions: t } = this, { nextNonSpaceToken: r } = e;
                        if (r) {
                            const n = i.Token.isTokenDelimiter(r, t), s = i.Token.isTokenRowDelimiter(r);
                            if (!n && !s) {
                                const n = e.lineFromCursor.substr(0, 10).replace(/[\r\n]/g, "\\n'");
                                throw new Error(`Parse Error: expected: '${t.escapedDelimiter}' OR new line got: '${r.token}'. at '${n}`);
                            }
                            e.advanceToToken(r);
                        } else e.hasMoreData || e.advancePastLine();
                    }
                };
            },
            {
                "../Token": 159,
                "./ColumnFormatter": 160
            }
        ],
        164: [
            function(e, t, r) {
                "use strict";
                Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.ColumnFormatter = r.QuotedColumnParser = r.NonQuotedColumnParser = r.ColumnParser = void 0;
                var n = e("./ColumnParser");
                Object.defineProperty(r, "ColumnParser", {
                    enumerable: !0,
                    get: function() {
                        return n.ColumnParser;
                    }
                });
                var i = e("./NonQuotedColumnParser");
                Object.defineProperty(r, "NonQuotedColumnParser", {
                    enumerable: !0,
                    get: function() {
                        return i.NonQuotedColumnParser;
                    }
                });
                var s = e("./QuotedColumnParser");
                Object.defineProperty(r, "QuotedColumnParser", {
                    enumerable: !0,
                    get: function() {
                        return s.QuotedColumnParser;
                    }
                });
                var o = e("./ColumnFormatter");
                Object.defineProperty(r, "ColumnFormatter", {
                    enumerable: !0,
                    get: function() {
                        return o.ColumnFormatter;
                    }
                });
            },
            {
                "./ColumnFormatter": 160,
                "./ColumnParser": 161,
                "./NonQuotedColumnParser": 162,
                "./QuotedColumnParser": 163
            }
        ],
        165: [
            function(e, t, r) {
                "use strict";
                Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.QuotedColumnParser = r.NonQuotedColumnParser = r.ColumnParser = r.Token = r.Scanner = r.RowParser = r.Parser = void 0;
                var n = e("./Parser");
                Object.defineProperty(r, "Parser", {
                    enumerable: !0,
                    get: function() {
                        return n.Parser;
                    }
                });
                var i = e("./RowParser");
                Object.defineProperty(r, "RowParser", {
                    enumerable: !0,
                    get: function() {
                        return i.RowParser;
                    }
                });
                var s = e("./Scanner");
                Object.defineProperty(r, "Scanner", {
                    enumerable: !0,
                    get: function() {
                        return s.Scanner;
                    }
                });
                var o = e("./Token");
                Object.defineProperty(r, "Token", {
                    enumerable: !0,
                    get: function() {
                        return o.Token;
                    }
                });
                var a = e("./column");
                Object.defineProperty(r, "ColumnParser", {
                    enumerable: !0,
                    get: function() {
                        return a.ColumnParser;
                    }
                }), Object.defineProperty(r, "NonQuotedColumnParser", {
                    enumerable: !0,
                    get: function() {
                        return a.NonQuotedColumnParser;
                    }
                }), Object.defineProperty(r, "QuotedColumnParser", {
                    enumerable: !0,
                    get: function() {
                        return a.QuotedColumnParser;
                    }
                });
            },
            {
                "./Parser": 156,
                "./RowParser": 157,
                "./Scanner": 158,
                "./Token": 159,
                "./column": 164
            }
        ],
        166: [
            function(e, t, r) {
                "use strict";
                var n = function(e) {
                    return e && e.__esModule ? e : {
                        default: e
                    };
                };
                Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.HeaderTransformer = void 0;
                const i = n(e("lodash.isundefined")), s = n(e("lodash.isfunction")), o = n(e("lodash.uniq")), a = n(e("lodash.groupby"));
                r.HeaderTransformer = class {
                    constructor(e){
                        this.headers = null, this.receivedHeaders = !1, this.shouldUseFirstRow = !1, this.processedFirstRow = !1, this.headersLength = 0, this.parserOptions = e, !0 === e.headers ? this.shouldUseFirstRow = !0 : Array.isArray(e.headers) ? this.setHeaders(e.headers) : s.default(e.headers) && (this.headersTransform = e.headers);
                    }
                    transform(e, t) {
                        return this.shouldMapRow(e) ? t(null, this.processRow(e)) : t(null, {
                            row: null,
                            isValid: !0
                        });
                    }
                    shouldMapRow(e) {
                        const { parserOptions: t } = this;
                        if (!this.headersTransform && t.renameHeaders && !this.processedFirstRow) {
                            if (!this.receivedHeaders) throw new Error("Error renaming headers: new headers must be provided in an array");
                            return this.processedFirstRow = !0, !1;
                        }
                        if (!this.receivedHeaders && Array.isArray(e)) {
                            if (this.headersTransform) this.setHeaders(this.headersTransform(e));
                            else {
                                if (!this.shouldUseFirstRow) return !0;
                                this.setHeaders(e);
                            }
                            return !1;
                        }
                        return !0;
                    }
                    processRow(e) {
                        if (!this.headers) return {
                            row: e,
                            isValid: !0
                        };
                        const { parserOptions: t } = this;
                        if (!t.discardUnmappedColumns && e.length > this.headersLength) {
                            if (!t.strictColumnHandling) throw new Error(`Unexpected Error: column header mismatch expected: ${this.headersLength} columns got: ${e.length}`);
                            return {
                                row: e,
                                isValid: !1,
                                reason: `Column header mismatch expected: ${this.headersLength} columns got: ${e.length}`
                            };
                        }
                        return t.strictColumnHandling && e.length < this.headersLength ? {
                            row: e,
                            isValid: !1,
                            reason: `Column header mismatch expected: ${this.headersLength} columns got: ${e.length}`
                        } : {
                            row: this.mapHeaders(e),
                            isValid: !0
                        };
                    }
                    mapHeaders(e) {
                        const t = {}, { headers: r, headersLength: n } = this;
                        for(let s = 0; s < n; s += 1){
                            const n = r[s];
                            if (!i.default(n)) {
                                const r = e[s];
                                i.default(r) ? t[n] = "" : t[n] = r;
                            }
                        }
                        return t;
                    }
                    setHeaders(e) {
                        var t;
                        const r = e.filter((e)=>!!e);
                        if (o.default(r).length !== r.length) {
                            const e = a.default(r), t = Object.keys(e).filter((t)=>e[t].length > 1);
                            throw new Error("Duplicate headers found " + JSON.stringify(t));
                        }
                        this.headers = e, this.receivedHeaders = !0, this.headersLength = (null === (t = this.headers) || void 0 === t ? void 0 : t.length) || 0;
                    }
                };
            },
            {
                "lodash.groupby": 443,
                "lodash.isfunction": 446,
                "lodash.isundefined": 448,
                "lodash.uniq": 449
            }
        ],
        167: [
            function(e, t, r) {
                "use strict";
                var n = function(e) {
                    return e && e.__esModule ? e : {
                        default: e
                    };
                };
                Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.RowTransformerValidator = void 0;
                const i = n(e("lodash.isfunction")), s = e("../types");
                class o {
                    constructor(){
                        this._rowTransform = null, this._rowValidator = null;
                    }
                    static createTransform(e) {
                        return s.isSyncTransform(e) ? (t, r)=>{
                            let n = null;
                            try {
                                n = e(t);
                            } catch (e) {
                                return r(e);
                            }
                            return r(null, n);
                        } : e;
                    }
                    static createValidator(e) {
                        return s.isSyncValidate(e) ? (t, r)=>{
                            r(null, {
                                row: t,
                                isValid: e(t)
                            });
                        } : (t, r)=>{
                            e(t, (e, n, i)=>e ? r(e) : r(null, n ? {
                                    row: t,
                                    isValid: n,
                                    reason: i
                                } : {
                                    row: t,
                                    isValid: !1,
                                    reason: i
                                }));
                        };
                    }
                    set rowTransform(e) {
                        if (!i.default(e)) throw new TypeError("The transform should be a function");
                        this._rowTransform = o.createTransform(e);
                    }
                    set rowValidator(e) {
                        if (!i.default(e)) throw new TypeError("The validate should be a function");
                        this._rowValidator = o.createValidator(e);
                    }
                    transformAndValidate(e, t) {
                        return this.callTransformer(e, (e, r)=>e ? t(e) : r ? this.callValidator(r, (e, n)=>e ? t(e) : n && !n.isValid ? t(null, {
                                    row: r,
                                    isValid: !1,
                                    reason: n.reason
                                }) : t(null, {
                                    row: r,
                                    isValid: !0
                                })) : t(null, {
                                row: null,
                                isValid: !0
                            }));
                    }
                    callTransformer(e, t) {
                        return this._rowTransform ? this._rowTransform(e, t) : t(null, e);
                    }
                    callValidator(e, t) {
                        return this._rowValidator ? this._rowValidator(e, t) : t(null, {
                            row: e,
                            isValid: !0
                        });
                    }
                }
                r.RowTransformerValidator = o;
            },
            {
                "../types": 169,
                "lodash.isfunction": 446
            }
        ],
        168: [
            function(e, t, r) {
                "use strict";
                Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.HeaderTransformer = r.RowTransformerValidator = void 0;
                var n = e("./RowTransformerValidator");
                Object.defineProperty(r, "RowTransformerValidator", {
                    enumerable: !0,
                    get: function() {
                        return n.RowTransformerValidator;
                    }
                });
                var i = e("./HeaderTransformer");
                Object.defineProperty(r, "HeaderTransformer", {
                    enumerable: !0,
                    get: function() {
                        return i.HeaderTransformer;
                    }
                });
            },
            {
                "./HeaderTransformer": 166,
                "./RowTransformerValidator": 167
            }
        ],
        169: [
            function(e, t, r) {
                "use strict";
                Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.isSyncValidate = r.isSyncTransform = void 0, r.isSyncTransform = (e)=>1 === e.length, r.isSyncValidate = (e)=>1 === e.length;
            },
            {}
        ],
        170: [
            function(e, t, r) {
                "use strict";
                const n = r;
                n.bignum = e("bn.js"), n.define = e("./asn1/api").define, n.base = e("./asn1/base"), n.constants = e("./asn1/constants"), n.decoders = e("./asn1/decoders"), n.encoders = e("./asn1/encoders");
            },
            {
                "./asn1/api": 171,
                "./asn1/base": 173,
                "./asn1/constants": 177,
                "./asn1/decoders": 179,
                "./asn1/encoders": 182,
                "bn.js": 184
            }
        ],
        171: [
            function(e, t, r) {
                "use strict";
                const n = e("./encoders"), i = e("./decoders"), s = e("inherits");
                function o(e, t) {
                    this.name = e, this.body = t, this.decoders = {}, this.encoders = {};
                }
                r.define = function(e, t) {
                    return new o(e, t);
                }, o.prototype._createNamed = function(e) {
                    const t = this.name;
                    function r(e) {
                        this._initNamed(e, t);
                    }
                    return s(r, e), r.prototype._initNamed = function(t, r) {
                        e.call(this, t, r);
                    }, new r(this);
                }, o.prototype._getDecoder = function(e) {
                    return e = e || "der", this.decoders.hasOwnProperty(e) || (this.decoders[e] = this._createNamed(i[e])), this.decoders[e];
                }, o.prototype.decode = function(e, t, r) {
                    return this._getDecoder(t).decode(e, r);
                }, o.prototype._getEncoder = function(e) {
                    return e = e || "der", this.encoders.hasOwnProperty(e) || (this.encoders[e] = this._createNamed(n[e])), this.encoders[e];
                }, o.prototype.encode = function(e, t, r) {
                    return this._getEncoder(t).encode(e, r);
                };
            },
            {
                "./decoders": 179,
                "./encoders": 182,
                inherits: 440
            }
        ],
        172: [
            function(e, t, r) {
                "use strict";
                const n = e("inherits"), i = e("../base/reporter").Reporter, s = e("safer-buffer").Buffer;
                function o(e, t) {
                    i.call(this, t), s.isBuffer(e) ? (this.base = e, this.offset = 0, this.length = e.length) : this.error("Input not Buffer");
                }
                function a(e, t) {
                    if (Array.isArray(e)) this.length = 0, this.value = e.map(function(e) {
                        return a.isEncoderBuffer(e) || (e = new a(e, t)), this.length += e.length, e;
                    }, this);
                    else if ("number" == typeof e) {
                        if (!(0 <= e && e <= 255)) return t.error("non-byte EncoderBuffer value");
                        this.value = e, this.length = 1;
                    } else if ("string" == typeof e) this.value = e, this.length = s.byteLength(e);
                    else {
                        if (!s.isBuffer(e)) return t.error("Unsupported type: " + typeof e);
                        this.value = e, this.length = e.length;
                    }
                }
                n(o, i), r.DecoderBuffer = o, o.isDecoderBuffer = function(e) {
                    if (e instanceof o) return !0;
                    return "object" == typeof e && s.isBuffer(e.base) && "DecoderBuffer" === e.constructor.name && "number" == typeof e.offset && "number" == typeof e.length && "function" == typeof e.save && "function" == typeof e.restore && "function" == typeof e.isEmpty && "function" == typeof e.readUInt8 && "function" == typeof e.skip && "function" == typeof e.raw;
                }, o.prototype.save = function() {
                    return {
                        offset: this.offset,
                        reporter: i.prototype.save.call(this)
                    };
                }, o.prototype.restore = function(e) {
                    const t = new o(this.base);
                    return t.offset = e.offset, t.length = this.offset, this.offset = e.offset, i.prototype.restore.call(this, e.reporter), t;
                }, o.prototype.isEmpty = function() {
                    return this.offset === this.length;
                }, o.prototype.readUInt8 = function(e) {
                    return this.offset + 1 <= this.length ? this.base.readUInt8(this.offset++, !0) : this.error(e || "DecoderBuffer overrun");
                }, o.prototype.skip = function(e, t) {
                    if (!(this.offset + e <= this.length)) return this.error(t || "DecoderBuffer overrun");
                    const r = new o(this.base);
                    return r._reporterState = this._reporterState, r.offset = this.offset, r.length = this.offset + e, this.offset += e, r;
                }, o.prototype.raw = function(e) {
                    return this.base.slice(e ? e.offset : this.offset, this.length);
                }, r.EncoderBuffer = a, a.isEncoderBuffer = function(e) {
                    if (e instanceof a) return !0;
                    return "object" == typeof e && "EncoderBuffer" === e.constructor.name && "number" == typeof e.length && "function" == typeof e.join;
                }, a.prototype.join = function(e, t) {
                    return e || (e = s.alloc(this.length)), t || (t = 0), 0 === this.length || (Array.isArray(this.value) ? this.value.forEach(function(r) {
                        r.join(e, t), t += r.length;
                    }) : ("number" == typeof this.value ? e[t] = this.value : "string" == typeof this.value ? e.write(this.value, t) : s.isBuffer(this.value) && this.value.copy(e, t), t += this.length)), e;
                };
            },
            {
                "../base/reporter": 175,
                inherits: 440,
                "safer-buffer": 495
            }
        ],
        173: [
            function(e, t, r) {
                "use strict";
                const n = r;
                n.Reporter = e("./reporter").Reporter, n.DecoderBuffer = e("./buffer").DecoderBuffer, n.EncoderBuffer = e("./buffer").EncoderBuffer, n.Node = e("./node");
            },
            {
                "./buffer": 172,
                "./node": 174,
                "./reporter": 175
            }
        ],
        174: [
            function(e, t, r) {
                "use strict";
                const n = e("../base/reporter").Reporter, i = e("../base/buffer").EncoderBuffer, s = e("../base/buffer").DecoderBuffer, o = e("minimalistic-assert"), a = [
                    "seq",
                    "seqof",
                    "set",
                    "setof",
                    "objid",
                    "bool",
                    "gentime",
                    "utctime",
                    "null_",
                    "enum",
                    "int",
                    "objDesc",
                    "bitstr",
                    "bmpstr",
                    "charstr",
                    "genstr",
                    "graphstr",
                    "ia5str",
                    "iso646str",
                    "numstr",
                    "octstr",
                    "printstr",
                    "t61str",
                    "unistr",
                    "utf8str",
                    "videostr"
                ], l = [
                    "key",
                    "obj",
                    "use",
                    "optional",
                    "explicit",
                    "implicit",
                    "def",
                    "choice",
                    "any",
                    "contains"
                ].concat(a);
                function c(e, t, r) {
                    const n = {};
                    this._baseState = n, n.name = r, n.enc = e, n.parent = t || null, n.children = null, n.tag = null, n.args = null, n.reverseArgs = null, n.choice = null, n.optional = !1, n.any = !1, n.obj = !1, n.use = null, n.useDecoder = null, n.key = null, n.default = null, n.explicit = null, n.implicit = null, n.contains = null, n.parent || (n.children = [], this._wrap());
                }
                t.exports = c;
                const u = [
                    "enc",
                    "parent",
                    "children",
                    "tag",
                    "args",
                    "reverseArgs",
                    "choice",
                    "optional",
                    "any",
                    "obj",
                    "use",
                    "alteredUse",
                    "key",
                    "default",
                    "explicit",
                    "implicit",
                    "contains"
                ];
                c.prototype.clone = function() {
                    const e = this._baseState, t = {};
                    u.forEach(function(r) {
                        t[r] = e[r];
                    });
                    const r = new this.constructor(t.parent);
                    return r._baseState = t, r;
                }, c.prototype._wrap = function() {
                    const e = this._baseState;
                    l.forEach(function(t) {
                        this[t] = function() {
                            const r = new this.constructor(this);
                            return e.children.push(r), r[t].apply(r, arguments);
                        };
                    }, this);
                }, c.prototype._init = function(e) {
                    const t = this._baseState;
                    o(null === t.parent), e.call(this), t.children = t.children.filter(function(e) {
                        return e._baseState.parent === this;
                    }, this), o.equal(t.children.length, 1, "Root node can have only one child");
                }, c.prototype._useArgs = function(e) {
                    const t = this._baseState, r = e.filter(function(e) {
                        return e instanceof this.constructor;
                    }, this);
                    e = e.filter(function(e) {
                        return !(e instanceof this.constructor);
                    }, this), 0 !== r.length && (o(null === t.children), t.children = r, r.forEach(function(e) {
                        e._baseState.parent = this;
                    }, this)), 0 !== e.length && (o(null === t.args), t.args = e, t.reverseArgs = e.map(function(e) {
                        if ("object" != typeof e || e.constructor !== Object) return e;
                        const t = {};
                        return Object.keys(e).forEach(function(r) {
                            r == (0 | r) && (r |= 0);
                            const n = e[r];
                            t[n] = r;
                        }), t;
                    }));
                }, [
                    "_peekTag",
                    "_decodeTag",
                    "_use",
                    "_decodeStr",
                    "_decodeObjid",
                    "_decodeTime",
                    "_decodeNull",
                    "_decodeInt",
                    "_decodeBool",
                    "_decodeList",
                    "_encodeComposite",
                    "_encodeStr",
                    "_encodeObjid",
                    "_encodeTime",
                    "_encodeNull",
                    "_encodeInt",
                    "_encodeBool"
                ].forEach(function(e) {
                    c.prototype[e] = function() {
                        const t = this._baseState;
                        throw new Error(e + " not implemented for encoding: " + t.enc);
                    };
                }), a.forEach(function(e) {
                    c.prototype[e] = function() {
                        const t = this._baseState, r = Array.prototype.slice.call(arguments);
                        return o(null === t.tag), t.tag = e, this._useArgs(r), this;
                    };
                }), c.prototype.use = function(e) {
                    o(e);
                    const t = this._baseState;
                    return o(null === t.use), t.use = e, this;
                }, c.prototype.optional = function() {
                    return this._baseState.optional = !0, this;
                }, c.prototype.def = function(e) {
                    const t = this._baseState;
                    return o(null === t.default), t.default = e, t.optional = !0, this;
                }, c.prototype.explicit = function(e) {
                    const t = this._baseState;
                    return o(null === t.explicit && null === t.implicit), t.explicit = e, this;
                }, c.prototype.implicit = function(e) {
                    const t = this._baseState;
                    return o(null === t.explicit && null === t.implicit), t.implicit = e, this;
                }, c.prototype.obj = function() {
                    const e = this._baseState, t = Array.prototype.slice.call(arguments);
                    return e.obj = !0, 0 !== t.length && this._useArgs(t), this;
                }, c.prototype.key = function(e) {
                    const t = this._baseState;
                    return o(null === t.key), t.key = e, this;
                }, c.prototype.any = function() {
                    return this._baseState.any = !0, this;
                }, c.prototype.choice = function(e) {
                    const t = this._baseState;
                    return o(null === t.choice), t.choice = e, this._useArgs(Object.keys(e).map(function(t) {
                        return e[t];
                    })), this;
                }, c.prototype.contains = function(e) {
                    const t = this._baseState;
                    return o(null === t.use), t.contains = e, this;
                }, c.prototype._decode = function(e, t) {
                    const r = this._baseState;
                    if (null === r.parent) return e.wrapResult(r.children[0]._decode(e, t));
                    let n, i = r.default, o = !0, a = null;
                    if (null !== r.key && (a = e.enterKey(r.key)), r.optional) {
                        let n = null;
                        if (null !== r.explicit ? n = r.explicit : null !== r.implicit ? n = r.implicit : null !== r.tag && (n = r.tag), null !== n || r.any) {
                            if (o = this._peekTag(e, n, r.any), e.isError(o)) return o;
                        } else {
                            const n = e.save();
                            try {
                                null === r.choice ? this._decodeGeneric(r.tag, e, t) : this._decodeChoice(e, t), o = !0;
                            } catch (e) {
                                o = !1;
                            }
                            e.restore(n);
                        }
                    }
                    if (r.obj && o && (n = e.enterObject()), o) {
                        if (null !== r.explicit) {
                            const t = this._decodeTag(e, r.explicit);
                            if (e.isError(t)) return t;
                            e = t;
                        }
                        const n = e.offset;
                        if (null === r.use && null === r.choice) {
                            let t;
                            r.any && (t = e.save());
                            const n = this._decodeTag(e, null !== r.implicit ? r.implicit : r.tag, r.any);
                            if (e.isError(n)) return n;
                            r.any ? i = e.raw(t) : e = n;
                        }
                        if (t && t.track && null !== r.tag && t.track(e.path(), n, e.length, "tagged"), t && t.track && null !== r.tag && t.track(e.path(), e.offset, e.length, "content"), r.any || (i = null === r.choice ? this._decodeGeneric(r.tag, e, t) : this._decodeChoice(e, t)), e.isError(i)) return i;
                        if (r.any || null !== r.choice || null === r.children || r.children.forEach(function(r) {
                            r._decode(e, t);
                        }), r.contains && ("octstr" === r.tag || "bitstr" === r.tag)) {
                            const n = new s(i);
                            i = this._getUse(r.contains, e._reporterState.obj)._decode(n, t);
                        }
                    }
                    return r.obj && o && (i = e.leaveObject(n)), null === r.key || null === i && !0 !== o ? null !== a && e.exitKey(a) : e.leaveKey(a, r.key, i), i;
                }, c.prototype._decodeGeneric = function(e, t, r) {
                    const n = this._baseState;
                    return "seq" === e || "set" === e ? null : "seqof" === e || "setof" === e ? this._decodeList(t, e, n.args[0], r) : /str$/.test(e) ? this._decodeStr(t, e, r) : "objid" === e && n.args ? this._decodeObjid(t, n.args[0], n.args[1], r) : "objid" === e ? this._decodeObjid(t, null, null, r) : "gentime" === e || "utctime" === e ? this._decodeTime(t, e, r) : "null_" === e ? this._decodeNull(t, r) : "bool" === e ? this._decodeBool(t, r) : "objDesc" === e ? this._decodeStr(t, e, r) : "int" === e || "enum" === e ? this._decodeInt(t, n.args && n.args[0], r) : null !== n.use ? this._getUse(n.use, t._reporterState.obj)._decode(t, r) : t.error("unknown tag: " + e);
                }, c.prototype._getUse = function(e, t) {
                    const r = this._baseState;
                    return r.useDecoder = this._use(e, t), o(null === r.useDecoder._baseState.parent), r.useDecoder = r.useDecoder._baseState.children[0], r.implicit !== r.useDecoder._baseState.implicit && (r.useDecoder = r.useDecoder.clone(), r.useDecoder._baseState.implicit = r.implicit), r.useDecoder;
                }, c.prototype._decodeChoice = function(e, t) {
                    const r = this._baseState;
                    let n = null, i = !1;
                    return Object.keys(r.choice).some(function(s) {
                        const o = e.save(), a = r.choice[s];
                        try {
                            const r = a._decode(e, t);
                            if (e.isError(r)) return !1;
                            n = {
                                type: s,
                                value: r
                            }, i = !0;
                        } catch (t) {
                            return e.restore(o), !1;
                        }
                        return !0;
                    }, this), i ? n : e.error("Choice not matched");
                }, c.prototype._createEncoderBuffer = function(e) {
                    return new i(e, this.reporter);
                }, c.prototype._encode = function(e, t, r) {
                    const n = this._baseState;
                    if (null !== n.default && n.default === e) return;
                    const i = this._encodeValue(e, t, r);
                    return void 0 === i || this._skipDefault(i, t, r) ? void 0 : i;
                }, c.prototype._encodeValue = function(e, t, r) {
                    const i = this._baseState;
                    if (null === i.parent) return i.children[0]._encode(e, t || new n);
                    let s = null;
                    if (this.reporter = t, i.optional && void 0 === e) {
                        if (null === i.default) return;
                        e = i.default;
                    }
                    let o = null, a = !1;
                    if (i.any) s = this._createEncoderBuffer(e);
                    else if (i.choice) s = this._encodeChoice(e, t);
                    else if (i.contains) o = this._getUse(i.contains, r)._encode(e, t), a = !0;
                    else if (i.children) o = i.children.map(function(r) {
                        if ("null_" === r._baseState.tag) return r._encode(null, t, e);
                        if (null === r._baseState.key) return t.error("Child should have a key");
                        const n = t.enterKey(r._baseState.key);
                        if ("object" != typeof e) return t.error("Child expected, but input is not object");
                        const i = r._encode(e[r._baseState.key], t, e);
                        return t.leaveKey(n), i;
                    }, this).filter(function(e) {
                        return e;
                    }), o = this._createEncoderBuffer(o);
                    else if ("seqof" === i.tag || "setof" === i.tag) {
                        if (!i.args || 1 !== i.args.length) return t.error("Too many args for : " + i.tag);
                        if (!Array.isArray(e)) return t.error("seqof/setof, but data is not Array");
                        const r = this.clone();
                        r._baseState.implicit = null, o = this._createEncoderBuffer(e.map(function(r) {
                            const n = this._baseState;
                            return this._getUse(n.args[0], e)._encode(r, t);
                        }, r));
                    } else null !== i.use ? s = this._getUse(i.use, r)._encode(e, t) : (o = this._encodePrimitive(i.tag, e), a = !0);
                    if (!i.any && null === i.choice) {
                        const e = null !== i.implicit ? i.implicit : i.tag, r = null === i.implicit ? "universal" : "context";
                        null === e ? null === i.use && t.error("Tag could be omitted only for .use()") : null === i.use && (s = this._encodeComposite(e, a, r, o));
                    }
                    return null !== i.explicit && (s = this._encodeComposite(i.explicit, !1, "context", s)), s;
                }, c.prototype._encodeChoice = function(e, t) {
                    const r = this._baseState, n = r.choice[e.type];
                    return n || o(!1, e.type + " not found in " + JSON.stringify(Object.keys(r.choice))), n._encode(e.value, t);
                }, c.prototype._encodePrimitive = function(e, t) {
                    const r = this._baseState;
                    if (/str$/.test(e)) return this._encodeStr(t, e);
                    if ("objid" === e && r.args) return this._encodeObjid(t, r.reverseArgs[0], r.args[1]);
                    if ("objid" === e) return this._encodeObjid(t, null, null);
                    if ("gentime" === e || "utctime" === e) return this._encodeTime(t, e);
                    if ("null_" === e) return this._encodeNull();
                    if ("int" === e || "enum" === e) return this._encodeInt(t, r.args && r.reverseArgs[0]);
                    if ("bool" === e) return this._encodeBool(t);
                    if ("objDesc" === e) return this._encodeStr(t, e);
                    throw new Error("Unsupported tag: " + e);
                }, c.prototype._isNumstr = function(e) {
                    return /^[0-9 ]*$/.test(e);
                }, c.prototype._isPrintstr = function(e) {
                    return /^[A-Za-z0-9 '()+,-./:=?]*$/.test(e);
                };
            },
            {
                "../base/buffer": 172,
                "../base/reporter": 175,
                "minimalistic-assert": 453
            }
        ],
        175: [
            function(e, t, r) {
                "use strict";
                const n = e("inherits");
                function i(e) {
                    this._reporterState = {
                        obj: null,
                        path: [],
                        options: e || {},
                        errors: []
                    };
                }
                function s(e, t) {
                    this.path = e, this.rethrow(t);
                }
                r.Reporter = i, i.prototype.isError = function(e) {
                    return e instanceof s;
                }, i.prototype.save = function() {
                    const e = this._reporterState;
                    return {
                        obj: e.obj,
                        pathLen: e.path.length
                    };
                }, i.prototype.restore = function(e) {
                    const t = this._reporterState;
                    t.obj = e.obj, t.path = t.path.slice(0, e.pathLen);
                }, i.prototype.enterKey = function(e) {
                    return this._reporterState.path.push(e);
                }, i.prototype.exitKey = function(e) {
                    const t = this._reporterState;
                    t.path = t.path.slice(0, e - 1);
                }, i.prototype.leaveKey = function(e, t, r) {
                    const n = this._reporterState;
                    this.exitKey(e), null !== n.obj && (n.obj[t] = r);
                }, i.prototype.path = function() {
                    return this._reporterState.path.join("/");
                }, i.prototype.enterObject = function() {
                    const e = this._reporterState, t = e.obj;
                    return e.obj = {}, t;
                }, i.prototype.leaveObject = function(e) {
                    const t = this._reporterState, r = t.obj;
                    return t.obj = e, r;
                }, i.prototype.error = function(e) {
                    let t;
                    const r = this._reporterState, n = e instanceof s;
                    if (t = n ? e : new s(r.path.map(function(e) {
                        return "[" + JSON.stringify(e) + "]";
                    }).join(""), e.message || e, e.stack), !r.options.partial) throw t;
                    return n || r.errors.push(t), t;
                }, i.prototype.wrapResult = function(e) {
                    const t = this._reporterState;
                    return t.options.partial ? {
                        result: this.isError(e) ? null : e,
                        errors: t.errors
                    } : e;
                }, n(s, Error), s.prototype.rethrow = function(e) {
                    if (this.message = e + " at: " + (this.path || "(shallow)"), Error.captureStackTrace && Error.captureStackTrace(this, s), !this.stack) try {
                        throw new Error(this.message);
                    } catch (e) {
                        this.stack = e.stack;
                    }
                    return this;
                };
            },
            {
                inherits: 440
            }
        ],
        176: [
            function(e, t, r) {
                "use strict";
                function n(e) {
                    const t = {};
                    return Object.keys(e).forEach(function(r) {
                        (0 | r) == r && (r |= 0);
                        const n = e[r];
                        t[n] = r;
                    }), t;
                }
                r.tagClass = {
                    0: "universal",
                    1: "application",
                    2: "context",
                    3: "private"
                }, r.tagClassByName = n(r.tagClass), r.tag = {
                    0: "end",
                    1: "bool",
                    2: "int",
                    3: "bitstr",
                    4: "octstr",
                    5: "null_",
                    6: "objid",
                    7: "objDesc",
                    8: "external",
                    9: "real",
                    10: "enum",
                    11: "embed",
                    12: "utf8str",
                    13: "relativeOid",
                    16: "seq",
                    17: "set",
                    18: "numstr",
                    19: "printstr",
                    20: "t61str",
                    21: "videostr",
                    22: "ia5str",
                    23: "utctime",
                    24: "gentime",
                    25: "graphstr",
                    26: "iso646str",
                    27: "genstr",
                    28: "unistr",
                    29: "charstr",
                    30: "bmpstr"
                }, r.tagByName = n(r.tag);
            },
            {}
        ],
        177: [
            function(e, t, r) {
                "use strict";
                const n = r;
                n._reverse = function(e) {
                    const t = {};
                    return Object.keys(e).forEach(function(r) {
                        (0 | r) == r && (r |= 0);
                        const n = e[r];
                        t[n] = r;
                    }), t;
                }, n.der = e("./der");
            },
            {
                "./der": 176
            }
        ],
        178: [
            function(e, t, r) {
                "use strict";
                const n = e("inherits"), i = e("bn.js"), s = e("../base/buffer").DecoderBuffer, o = e("../base/node"), a = e("../constants/der");
                function l(e) {
                    this.enc = "der", this.name = e.name, this.entity = e, this.tree = new c, this.tree._init(e.body);
                }
                function c(e) {
                    o.call(this, "der", e);
                }
                function u(e, t) {
                    let r = e.readUInt8(t);
                    if (e.isError(r)) return r;
                    const n = a.tagClass[r >> 6], i = 0 == (32 & r);
                    if (31 == (31 & r)) {
                        let n = r;
                        for(r = 0; 128 == (128 & n);){
                            if (n = e.readUInt8(t), e.isError(n)) return n;
                            r <<= 7, r |= 127 & n;
                        }
                    } else r &= 31;
                    return {
                        cls: n,
                        primitive: i,
                        tag: r,
                        tagStr: a.tag[r]
                    };
                }
                function h(e, t, r) {
                    let n = e.readUInt8(r);
                    if (e.isError(n)) return n;
                    if (!t && 128 === n) return null;
                    if (0 == (128 & n)) return n;
                    const i = 127 & n;
                    if (i > 4) return e.error("length octect is too long");
                    n = 0;
                    for(let t = 0; t < i; t++){
                        n <<= 8;
                        const t = e.readUInt8(r);
                        if (e.isError(t)) return t;
                        n |= t;
                    }
                    return n;
                }
                t.exports = l, l.prototype.decode = function(e, t) {
                    return s.isDecoderBuffer(e) || (e = new s(e, t)), this.tree._decode(e, t);
                }, n(c, o), c.prototype._peekTag = function(e, t, r) {
                    if (e.isEmpty()) return !1;
                    const n = e.save(), i = u(e, 'Failed to peek tag: "' + t + '"');
                    return e.isError(i) ? i : (e.restore(n), i.tag === t || i.tagStr === t || i.tagStr + "of" === t || r);
                }, c.prototype._decodeTag = function(e, t, r) {
                    const n = u(e, 'Failed to decode tag of "' + t + '"');
                    if (e.isError(n)) return n;
                    let i = h(e, n.primitive, 'Failed to get length of "' + t + '"');
                    if (e.isError(i)) return i;
                    if (!r && n.tag !== t && n.tagStr !== t && n.tagStr + "of" !== t) return e.error('Failed to match tag: "' + t + '"');
                    if (n.primitive || null !== i) return e.skip(i, 'Failed to match body of: "' + t + '"');
                    const s = e.save(), o = this._skipUntilEnd(e, 'Failed to skip indefinite length body: "' + this.tag + '"');
                    return e.isError(o) ? o : (i = e.offset - s.offset, e.restore(s), e.skip(i, 'Failed to match body of: "' + t + '"'));
                }, c.prototype._skipUntilEnd = function(e, t) {
                    for(;;){
                        const r = u(e, t);
                        if (e.isError(r)) return r;
                        const n = h(e, r.primitive, t);
                        if (e.isError(n)) return n;
                        let i;
                        if (i = r.primitive || null !== n ? e.skip(n) : this._skipUntilEnd(e, t), e.isError(i)) return i;
                        if ("end" === r.tagStr) break;
                    }
                }, c.prototype._decodeList = function(e, t, r, n) {
                    const i = [];
                    for(; !e.isEmpty();){
                        const t = this._peekTag(e, "end");
                        if (e.isError(t)) return t;
                        const s = r.decode(e, "der", n);
                        if (e.isError(s) && t) break;
                        i.push(s);
                    }
                    return i;
                }, c.prototype._decodeStr = function(e, t) {
                    if ("bitstr" === t) {
                        const t = e.readUInt8();
                        return e.isError(t) ? t : {
                            unused: t,
                            data: e.raw()
                        };
                    }
                    if ("bmpstr" === t) {
                        const t = e.raw();
                        if (t.length % 2 == 1) return e.error("Decoding of string type: bmpstr length mismatch");
                        let r = "";
                        for(let e = 0; e < t.length / 2; e++)r += String.fromCharCode(t.readUInt16BE(2 * e));
                        return r;
                    }
                    if ("numstr" === t) {
                        const t = e.raw().toString("ascii");
                        return this._isNumstr(t) ? t : e.error("Decoding of string type: numstr unsupported characters");
                    }
                    if ("octstr" === t) return e.raw();
                    if ("objDesc" === t) return e.raw();
                    if ("printstr" === t) {
                        const t = e.raw().toString("ascii");
                        return this._isPrintstr(t) ? t : e.error("Decoding of string type: printstr unsupported characters");
                    }
                    return /str$/.test(t) ? e.raw().toString() : e.error("Decoding of string type: " + t + " unsupported");
                }, c.prototype._decodeObjid = function(e, t, r) {
                    let n;
                    const i = [];
                    let s = 0, o = 0;
                    for(; !e.isEmpty();)o = e.readUInt8(), s <<= 7, s |= 127 & o, 0 == (128 & o) && (i.push(s), s = 0);
                    128 & o && i.push(s);
                    const a = i[0] / 40 | 0, l = i[0] % 40;
                    if (n = r ? i : [
                        a,
                        l
                    ].concat(i.slice(1)), t) {
                        let e = t[n.join(" ")];
                        void 0 === e && (e = t[n.join(".")]), void 0 !== e && (n = e);
                    }
                    return n;
                }, c.prototype._decodeTime = function(e, t) {
                    const r = e.raw().toString();
                    let n, i, s, o, a, l;
                    if ("gentime" === t) n = 0 | r.slice(0, 4), i = 0 | r.slice(4, 6), s = 0 | r.slice(6, 8), o = 0 | r.slice(8, 10), a = 0 | r.slice(10, 12), l = 0 | r.slice(12, 14);
                    else {
                        if ("utctime" !== t) return e.error("Decoding " + t + " time is not supported yet");
                        n = 0 | r.slice(0, 2), i = 0 | r.slice(2, 4), s = 0 | r.slice(4, 6), o = 0 | r.slice(6, 8), a = 0 | r.slice(8, 10), l = 0 | r.slice(10, 12), n = n < 70 ? 2e3 + n : 1900 + n;
                    }
                    return Date.UTC(n, i - 1, s, o, a, l, 0);
                }, c.prototype._decodeNull = function() {
                    return null;
                }, c.prototype._decodeBool = function(e) {
                    const t = e.readUInt8();
                    return e.isError(t) ? t : 0 !== t;
                }, c.prototype._decodeInt = function(e, t) {
                    const r = e.raw();
                    let n = new i(r);
                    return t && (n = t[n.toString(10)] || n), n;
                }, c.prototype._use = function(e, t) {
                    return "function" == typeof e && (e = e(t)), e._getDecoder("der").tree;
                };
            },
            {
                "../base/buffer": 172,
                "../base/node": 174,
                "../constants/der": 176,
                "bn.js": 184,
                inherits: 440
            }
        ],
        179: [
            function(e, t, r) {
                "use strict";
                const n = r;
                n.der = e("./der"), n.pem = e("./pem");
            },
            {
                "./der": 178,
                "./pem": 180
            }
        ],
        180: [
            function(e, t, r) {
                "use strict";
                const n = e("inherits"), i = e("safer-buffer").Buffer, s = e("./der");
                function o(e) {
                    s.call(this, e), this.enc = "pem";
                }
                n(o, s), t.exports = o, o.prototype.decode = function(e, t) {
                    const r = e.toString().split(/[\r\n]+/g), n = t.label.toUpperCase(), o = /^-----(BEGIN|END) ([^-]+)-----$/;
                    let a = -1, l = -1;
                    for(let e = 0; e < r.length; e++){
                        const t = r[e].match(o);
                        if (null !== t && t[2] === n) {
                            if (-1 !== a) {
                                if ("END" !== t[1]) break;
                                l = e;
                                break;
                            }
                            if ("BEGIN" !== t[1]) break;
                            a = e;
                        }
                    }
                    if (-1 === a || -1 === l) throw new Error("PEM section not found for: " + n);
                    const c = r.slice(a + 1, l).join("");
                    c.replace(/[^a-z0-9+/=]+/gi, "");
                    const u = i.from(c, "base64");
                    return s.prototype.decode.call(this, u, t);
                };
            },
            {
                "./der": 178,
                inherits: 440,
                "safer-buffer": 495
            }
        ],
        181: [
            function(e, t, r) {
                "use strict";
                const n = e("inherits"), i = e("safer-buffer").Buffer, s = e("../base/node"), o = e("../constants/der");
                function a(e) {
                    this.enc = "der", this.name = e.name, this.entity = e, this.tree = new l, this.tree._init(e.body);
                }
                function l(e) {
                    s.call(this, "der", e);
                }
                function c(e) {
                    return e < 10 ? "0" + e : e;
                }
                t.exports = a, a.prototype.encode = function(e, t) {
                    return this.tree._encode(e, t).join();
                }, n(l, s), l.prototype._encodeComposite = function(e, t, r, n) {
                    const s = function(e, t, r, n) {
                        let i;
                        "seqof" === e ? e = "seq" : "setof" === e && (e = "set");
                        if (o.tagByName.hasOwnProperty(e)) i = o.tagByName[e];
                        else {
                            if ("number" != typeof e || (0 | e) !== e) return n.error("Unknown tag: " + e);
                            i = e;
                        }
                        if (i >= 31) return n.error("Multi-octet tag encoding unsupported");
                        t || (i |= 32);
                        return i |= o.tagClassByName[r || "universal"] << 6, i;
                    }(e, t, r, this.reporter);
                    if (n.length < 128) {
                        const e = i.alloc(2);
                        return e[0] = s, e[1] = n.length, this._createEncoderBuffer([
                            e,
                            n
                        ]);
                    }
                    let a = 1;
                    for(let e = n.length; e >= 256; e >>= 8)a++;
                    const l = i.alloc(2 + a);
                    l[0] = s, l[1] = 128 | a;
                    for(let e = 1 + a, t = n.length; t > 0; e--, t >>= 8)l[e] = 255 & t;
                    return this._createEncoderBuffer([
                        l,
                        n
                    ]);
                }, l.prototype._encodeStr = function(e, t) {
                    if ("bitstr" === t) return this._createEncoderBuffer([
                        0 | e.unused,
                        e.data
                    ]);
                    if ("bmpstr" === t) {
                        const t = i.alloc(2 * e.length);
                        for(let r = 0; r < e.length; r++)t.writeUInt16BE(e.charCodeAt(r), 2 * r);
                        return this._createEncoderBuffer(t);
                    }
                    return "numstr" === t ? this._isNumstr(e) ? this._createEncoderBuffer(e) : this.reporter.error("Encoding of string type: numstr supports only digits and space") : "printstr" === t ? this._isPrintstr(e) ? this._createEncoderBuffer(e) : this.reporter.error("Encoding of string type: printstr supports only latin upper and lower case letters, digits, space, apostrophe, left and rigth parenthesis, plus sign, comma, hyphen, dot, slash, colon, equal sign, question mark") : /str$/.test(t) || "objDesc" === t ? this._createEncoderBuffer(e) : this.reporter.error("Encoding of string type: " + t + " unsupported");
                }, l.prototype._encodeObjid = function(e, t, r) {
                    if ("string" == typeof e) {
                        if (!t) return this.reporter.error("string objid given, but no values map found");
                        if (!t.hasOwnProperty(e)) return this.reporter.error("objid not found in values map");
                        e = t[e].split(/[\s.]+/g);
                        for(let t = 0; t < e.length; t++)e[t] |= 0;
                    } else if (Array.isArray(e)) {
                        e = e.slice();
                        for(let t = 0; t < e.length; t++)e[t] |= 0;
                    }
                    if (!Array.isArray(e)) return this.reporter.error("objid() should be either array or string, got: " + JSON.stringify(e));
                    if (!r) {
                        if (e[1] >= 40) return this.reporter.error("Second objid identifier OOB");
                        e.splice(0, 2, 40 * e[0] + e[1]);
                    }
                    let n = 0;
                    for(let t = 0; t < e.length; t++){
                        let r = e[t];
                        for(n++; r >= 128; r >>= 7)n++;
                    }
                    const s = i.alloc(n);
                    let o = s.length - 1;
                    for(let t = e.length - 1; t >= 0; t--){
                        let r = e[t];
                        for(s[o--] = 127 & r; (r >>= 7) > 0;)s[o--] = 128 | 127 & r;
                    }
                    return this._createEncoderBuffer(s);
                }, l.prototype._encodeTime = function(e, t) {
                    let r;
                    const n = new Date(e);
                    return "gentime" === t ? r = [
                        c(n.getUTCFullYear()),
                        c(n.getUTCMonth() + 1),
                        c(n.getUTCDate()),
                        c(n.getUTCHours()),
                        c(n.getUTCMinutes()),
                        c(n.getUTCSeconds()),
                        "Z"
                    ].join("") : "utctime" === t ? r = [
                        c(n.getUTCFullYear() % 100),
                        c(n.getUTCMonth() + 1),
                        c(n.getUTCDate()),
                        c(n.getUTCHours()),
                        c(n.getUTCMinutes()),
                        c(n.getUTCSeconds()),
                        "Z"
                    ].join("") : this.reporter.error("Encoding " + t + " time is not supported yet"), this._encodeStr(r, "octstr");
                }, l.prototype._encodeNull = function() {
                    return this._createEncoderBuffer("");
                }, l.prototype._encodeInt = function(e, t) {
                    if ("string" == typeof e) {
                        if (!t) return this.reporter.error("String int or enum given, but no values map");
                        if (!t.hasOwnProperty(e)) return this.reporter.error("Values map doesn't contain: " + JSON.stringify(e));
                        e = t[e];
                    }
                    if ("number" != typeof e && !i.isBuffer(e)) {
                        const t = e.toArray();
                        !e.sign && 128 & t[0] && t.unshift(0), e = i.from(t);
                    }
                    if (i.isBuffer(e)) {
                        let t = e.length;
                        0 === e.length && t++;
                        const r = i.alloc(t);
                        return e.copy(r), 0 === e.length && (r[0] = 0), this._createEncoderBuffer(r);
                    }
                    if (e < 128) return this._createEncoderBuffer(e);
                    if (e < 256) return this._createEncoderBuffer([
                        0,
                        e
                    ]);
                    let r = 1;
                    for(let t = e; t >= 256; t >>= 8)r++;
                    const n = new Array(r);
                    for(let t = n.length - 1; t >= 0; t--)n[t] = 255 & e, e >>= 8;
                    return 128 & n[0] && n.unshift(0), this._createEncoderBuffer(i.from(n));
                }, l.prototype._encodeBool = function(e) {
                    return this._createEncoderBuffer(e ? 255 : 0);
                }, l.prototype._use = function(e, t) {
                    return "function" == typeof e && (e = e(t)), e._getEncoder("der").tree;
                }, l.prototype._skipDefault = function(e, t, r) {
                    const n = this._baseState;
                    let i;
                    if (null === n.default) return !1;
                    const s = e.join();
                    if (void 0 === n.defaultBuffer && (n.defaultBuffer = this._encodeValue(n.default, t, r).join()), s.length !== n.defaultBuffer.length) return !1;
                    for(i = 0; i < s.length; i++)if (s[i] !== n.defaultBuffer[i]) return !1;
                    return !0;
                };
            },
            {
                "../base/node": 174,
                "../constants/der": 176,
                inherits: 440,
                "safer-buffer": 495
            }
        ],
        182: [
            function(e, t, r) {
                "use strict";
                const n = r;
                n.der = e("./der"), n.pem = e("./pem");
            },
            {
                "./der": 181,
                "./pem": 183
            }
        ],
        183: [
            function(e, t, r) {
                "use strict";
                const n = e("inherits"), i = e("./der");
                function s(e) {
                    i.call(this, e), this.enc = "pem";
                }
                n(s, i), t.exports = s, s.prototype.encode = function(e, t) {
                    const r = i.prototype.encode.call(this, e).toString("base64"), n = [
                        "-----BEGIN " + t.label + "-----"
                    ];
                    for(let e = 0; e < r.length; e += 64)n.push(r.slice(e, e + 64));
                    return n.push("-----END " + t.label + "-----"), n.join("\n");
                };
            },
            {
                "./der": 181,
                inherits: 440
            }
        ],
        184: [
            function(e, t, r) {
                "use strict";
                !function(t, r) {
                    function n(e, t) {
                        if (!e) throw new Error(t || "Assertion failed");
                    }
                    function i(e, t) {
                        e.super_ = t;
                        var r = function() {};
                        r.prototype = t.prototype, e.prototype = new r, e.prototype.constructor = e;
                    }
                    function s(e, t, r) {
                        if (s.isBN(e)) return e;
                        this.negative = 0, this.words = null, this.length = 0, this.red = null, null !== e && ("le" !== t && "be" !== t || (r = t, t = 10), this._init(e || 0, t || 10, r || "be"));
                    }
                    var o;
                    "object" == typeof t ? t.exports = s : (void 0).BN = s, s.BN = s, s.wordSize = 26;
                    try {
                        o = "undefined" != typeof window && void 0 !== window.Buffer ? window.Buffer : e("buffer").Buffer;
                    } catch (e) {}
                    function a(e, t) {
                        var r = e.charCodeAt(t);
                        return r >= 65 && r <= 70 ? r - 55 : r >= 97 && r <= 102 ? r - 87 : r - 48 & 15;
                    }
                    function l(e, t, r) {
                        var n = a(e, r);
                        return r - 1 >= t && (n |= a(e, r - 1) << 4), n;
                    }
                    function c(e, t, r, n) {
                        for(var i = 0, s = Math.min(e.length, r), o = t; o < s; o++){
                            var a = e.charCodeAt(o) - 48;
                            i *= n, i += a >= 49 ? a - 49 + 10 : a >= 17 ? a - 17 + 10 : a;
                        }
                        return i;
                    }
                    s.isBN = function(e) {
                        return e instanceof s || null !== e && "object" == typeof e && e.constructor.wordSize === s.wordSize && Array.isArray(e.words);
                    }, s.max = function(e, t) {
                        return e.cmp(t) > 0 ? e : t;
                    }, s.min = function(e, t) {
                        return e.cmp(t) < 0 ? e : t;
                    }, s.prototype._init = function(e, t, r) {
                        if ("number" == typeof e) return this._initNumber(e, t, r);
                        if ("object" == typeof e) return this._initArray(e, t, r);
                        "hex" === t && (t = 16), n(t === (0 | t) && t >= 2 && t <= 36);
                        var i = 0;
                        "-" === (e = e.toString().replace(/\s+/g, ""))[0] && (i++, this.negative = 1), i < e.length && (16 === t ? this._parseHex(e, i, r) : (this._parseBase(e, t, i), "le" === r && this._initArray(this.toArray(), t, r)));
                    }, s.prototype._initNumber = function(e, t, r) {
                        e < 0 && (this.negative = 1, e = -e), e < 67108864 ? (this.words = [
                            67108863 & e
                        ], this.length = 1) : e < 4503599627370496 ? (this.words = [
                            67108863 & e,
                            e / 67108864 & 67108863
                        ], this.length = 2) : (n(e < 9007199254740992), this.words = [
                            67108863 & e,
                            e / 67108864 & 67108863,
                            1
                        ], this.length = 3), "le" === r && this._initArray(this.toArray(), t, r);
                    }, s.prototype._initArray = function(e, t, r) {
                        if (n("number" == typeof e.length), e.length <= 0) return this.words = [
                            0
                        ], this.length = 1, this;
                        this.length = Math.ceil(e.length / 3), this.words = new Array(this.length);
                        for(var i = 0; i < this.length; i++)this.words[i] = 0;
                        var s, o, a = 0;
                        if ("be" === r) for(i = e.length - 1, s = 0; i >= 0; i -= 3)o = e[i] | e[i - 1] << 8 | e[i - 2] << 16, this.words[s] |= o << a & 67108863, this.words[s + 1] = o >>> 26 - a & 67108863, (a += 24) >= 26 && (a -= 26, s++);
                        else if ("le" === r) for(i = 0, s = 0; i < e.length; i += 3)o = e[i] | e[i + 1] << 8 | e[i + 2] << 16, this.words[s] |= o << a & 67108863, this.words[s + 1] = o >>> 26 - a & 67108863, (a += 24) >= 26 && (a -= 26, s++);
                        return this.strip();
                    }, s.prototype._parseHex = function(e, t, r) {
                        this.length = Math.ceil((e.length - t) / 6), this.words = new Array(this.length);
                        for(var n = 0; n < this.length; n++)this.words[n] = 0;
                        var i, s = 0, o = 0;
                        if ("be" === r) for(n = e.length - 1; n >= t; n -= 2)i = l(e, t, n) << s, this.words[o] |= 67108863 & i, s >= 18 ? (s -= 18, o += 1, this.words[o] |= i >>> 26) : s += 8;
                        else for(n = (e.length - t) % 2 == 0 ? t + 1 : t; n < e.length; n += 2)i = l(e, t, n) << s, this.words[o] |= 67108863 & i, s >= 18 ? (s -= 18, o += 1, this.words[o] |= i >>> 26) : s += 8;
                        this.strip();
                    }, s.prototype._parseBase = function(e, t, r) {
                        this.words = [
                            0
                        ], this.length = 1;
                        for(var n = 0, i = 1; i <= 67108863; i *= t)n++;
                        n--, i = i / t | 0;
                        for(var s = e.length - r, o = s % n, a = Math.min(s, s - o) + r, l = 0, u = r; u < a; u += n)l = c(e, u, u + n, t), this.imuln(i), this.words[0] + l < 67108864 ? this.words[0] += l : this._iaddn(l);
                        if (0 !== o) {
                            var h = 1;
                            for(l = c(e, u, e.length, t), u = 0; u < o; u++)h *= t;
                            this.imuln(h), this.words[0] + l < 67108864 ? this.words[0] += l : this._iaddn(l);
                        }
                        this.strip();
                    }, s.prototype.copy = function(e) {
                        e.words = new Array(this.length);
                        for(var t = 0; t < this.length; t++)e.words[t] = this.words[t];
                        e.length = this.length, e.negative = this.negative, e.red = this.red;
                    }, s.prototype.clone = function() {
                        var e = new s(null);
                        return this.copy(e), e;
                    }, s.prototype._expand = function(e) {
                        for(; this.length < e;)this.words[this.length++] = 0;
                        return this;
                    }, s.prototype.strip = function() {
                        for(; this.length > 1 && 0 === this.words[this.length - 1];)this.length--;
                        return this._normSign();
                    }, s.prototype._normSign = function() {
                        return 1 === this.length && 0 === this.words[0] && (this.negative = 0), this;
                    }, s.prototype.inspect = function() {
                        return (this.red ? "<BN-R: " : "<BN: ") + this.toString(16) + ">";
                    };
                    var u = [
                        "",
                        "0",
                        "00",
                        "000",
                        "0000",
                        "00000",
                        "000000",
                        "0000000",
                        "00000000",
                        "000000000",
                        "0000000000",
                        "00000000000",
                        "000000000000",
                        "0000000000000",
                        "00000000000000",
                        "000000000000000",
                        "0000000000000000",
                        "00000000000000000",
                        "000000000000000000",
                        "0000000000000000000",
                        "00000000000000000000",
                        "000000000000000000000",
                        "0000000000000000000000",
                        "00000000000000000000000",
                        "000000000000000000000000",
                        "0000000000000000000000000"
                    ], h = [
                        0,
                        0,
                        25,
                        16,
                        12,
                        11,
                        10,
                        9,
                        8,
                        8,
                        7,
                        7,
                        7,
                        7,
                        6,
                        6,
                        6,
                        6,
                        6,
                        6,
                        6,
                        5,
                        5,
                        5,
                        5,
                        5,
                        5,
                        5,
                        5,
                        5,
                        5,
                        5,
                        5,
                        5,
                        5,
                        5,
                        5
                    ], f = [
                        0,
                        0,
                        33554432,
                        43046721,
                        16777216,
                        48828125,
                        60466176,
                        40353607,
                        16777216,
                        43046721,
                        1e7,
                        19487171,
                        35831808,
                        62748517,
                        7529536,
                        11390625,
                        16777216,
                        24137569,
                        34012224,
                        47045881,
                        64e6,
                        4084101,
                        5153632,
                        6436343,
                        7962624,
                        9765625,
                        11881376,
                        14348907,
                        17210368,
                        20511149,
                        243e5,
                        28629151,
                        33554432,
                        39135393,
                        45435424,
                        52521875,
                        60466176
                    ];
                    function d(e, t, r) {
                        r.negative = t.negative ^ e.negative;
                        var n = e.length + t.length | 0;
                        r.length = n, n = n - 1 | 0;
                        var i = 0 | e.words[0], s = 0 | t.words[0], o = i * s, a = 67108863 & o, l = o / 67108864 | 0;
                        r.words[0] = a;
                        for(var c = 1; c < n; c++){
                            for(var u = l >>> 26, h = 67108863 & l, f = Math.min(c, t.length - 1), d = Math.max(0, c - e.length + 1); d <= f; d++){
                                var p = c - d | 0;
                                u += (o = (i = 0 | e.words[p]) * (s = 0 | t.words[d]) + h) / 67108864 | 0, h = 67108863 & o;
                            }
                            r.words[c] = 0 | h, l = 0 | u;
                        }
                        return 0 !== l ? r.words[c] = 0 | l : r.length--, r.strip();
                    }
                    s.prototype.toString = function(e, t) {
                        var r;
                        if (t = 0 | t || 1, 16 === (e = e || 10) || "hex" === e) {
                            r = "";
                            for(var i = 0, s = 0, o = 0; o < this.length; o++){
                                var a = this.words[o], l = (16777215 & (a << i | s)).toString(16);
                                r = 0 !== (s = a >>> 24 - i & 16777215) || o !== this.length - 1 ? u[6 - l.length] + l + r : l + r, (i += 2) >= 26 && (i -= 26, o--);
                            }
                            for(0 !== s && (r = s.toString(16) + r); r.length % t != 0;)r = "0" + r;
                            return 0 !== this.negative && (r = "-" + r), r;
                        }
                        if (e === (0 | e) && e >= 2 && e <= 36) {
                            var c = h[e], d = f[e];
                            r = "";
                            var p = this.clone();
                            for(p.negative = 0; !p.isZero();){
                                var m = p.modn(d).toString(e);
                                r = (p = p.idivn(d)).isZero() ? m + r : u[c - m.length] + m + r;
                            }
                            for(this.isZero() && (r = "0" + r); r.length % t != 0;)r = "0" + r;
                            return 0 !== this.negative && (r = "-" + r), r;
                        }
                        n(!1, "Base should be between 2 and 36");
                    }, s.prototype.toNumber = function() {
                        var e = this.words[0];
                        return 2 === this.length ? e += 67108864 * this.words[1] : 3 === this.length && 1 === this.words[2] ? e += 4503599627370496 + 67108864 * this.words[1] : this.length > 2 && n(!1, "Number can only safely store up to 53 bits"), 0 !== this.negative ? -e : e;
                    }, s.prototype.toJSON = function() {
                        return this.toString(16);
                    }, s.prototype.toBuffer = function(e, t) {
                        return n(void 0 !== o), this.toArrayLike(o, e, t);
                    }, s.prototype.toArray = function(e, t) {
                        return this.toArrayLike(Array, e, t);
                    }, s.prototype.toArrayLike = function(e, t, r) {
                        var i = this.byteLength(), s = r || Math.max(1, i);
                        n(i <= s, "byte array longer than desired length"), n(s > 0, "Requested array length <= 0"), this.strip();
                        var o, a, l = "le" === t, c = new e(s), u = this.clone();
                        if (l) {
                            for(a = 0; !u.isZero(); a++)o = u.andln(255), u.iushrn(8), c[a] = o;
                            for(; a < s; a++)c[a] = 0;
                        } else {
                            for(a = 0; a < s - i; a++)c[a] = 0;
                            for(a = 0; !u.isZero(); a++)o = u.andln(255), u.iushrn(8), c[s - a - 1] = o;
                        }
                        return c;
                    }, Math.clz32 ? s.prototype._countBits = function(e) {
                        return 32 - Math.clz32(e);
                    } : s.prototype._countBits = function(e) {
                        var t = e, r = 0;
                        return t >= 4096 && (r += 13, t >>>= 13), t >= 64 && (r += 7, t >>>= 7), t >= 8 && (r += 4, t >>>= 4), t >= 2 && (r += 2, t >>>= 2), r + t;
                    }, s.prototype._zeroBits = function(e) {
                        if (0 === e) return 26;
                        var t = e, r = 0;
                        return 0 == (8191 & t) && (r += 13, t >>>= 13), 0 == (127 & t) && (r += 7, t >>>= 7), 0 == (15 & t) && (r += 4, t >>>= 4), 0 == (3 & t) && (r += 2, t >>>= 2), 0 == (1 & t) && r++, r;
                    }, s.prototype.bitLength = function() {
                        var e = this.words[this.length - 1], t = this._countBits(e);
                        return 26 * (this.length - 1) + t;
                    }, s.prototype.zeroBits = function() {
                        if (this.isZero()) return 0;
                        for(var e = 0, t = 0; t < this.length; t++){
                            var r = this._zeroBits(this.words[t]);
                            if (e += r, 26 !== r) break;
                        }
                        return e;
                    }, s.prototype.byteLength = function() {
                        return Math.ceil(this.bitLength() / 8);
                    }, s.prototype.toTwos = function(e) {
                        return 0 !== this.negative ? this.abs().inotn(e).iaddn(1) : this.clone();
                    }, s.prototype.fromTwos = function(e) {
                        return this.testn(e - 1) ? this.notn(e).iaddn(1).ineg() : this.clone();
                    }, s.prototype.isNeg = function() {
                        return 0 !== this.negative;
                    }, s.prototype.neg = function() {
                        return this.clone().ineg();
                    }, s.prototype.ineg = function() {
                        return this.isZero() || (this.negative ^= 1), this;
                    }, s.prototype.iuor = function(e) {
                        for(; this.length < e.length;)this.words[this.length++] = 0;
                        for(var t = 0; t < e.length; t++)this.words[t] = this.words[t] | e.words[t];
                        return this.strip();
                    }, s.prototype.ior = function(e) {
                        return n(0 == (this.negative | e.negative)), this.iuor(e);
                    }, s.prototype.or = function(e) {
                        return this.length > e.length ? this.clone().ior(e) : e.clone().ior(this);
                    }, s.prototype.uor = function(e) {
                        return this.length > e.length ? this.clone().iuor(e) : e.clone().iuor(this);
                    }, s.prototype.iuand = function(e) {
                        var t;
                        t = this.length > e.length ? e : this;
                        for(var r = 0; r < t.length; r++)this.words[r] = this.words[r] & e.words[r];
                        return this.length = t.length, this.strip();
                    }, s.prototype.iand = function(e) {
                        return n(0 == (this.negative | e.negative)), this.iuand(e);
                    }, s.prototype.and = function(e) {
                        return this.length > e.length ? this.clone().iand(e) : e.clone().iand(this);
                    }, s.prototype.uand = function(e) {
                        return this.length > e.length ? this.clone().iuand(e) : e.clone().iuand(this);
                    }, s.prototype.iuxor = function(e) {
                        var t, r;
                        this.length > e.length ? (t = this, r = e) : (t = e, r = this);
                        for(var n = 0; n < r.length; n++)this.words[n] = t.words[n] ^ r.words[n];
                        if (this !== t) for(; n < t.length; n++)this.words[n] = t.words[n];
                        return this.length = t.length, this.strip();
                    }, s.prototype.ixor = function(e) {
                        return n(0 == (this.negative | e.negative)), this.iuxor(e);
                    }, s.prototype.xor = function(e) {
                        return this.length > e.length ? this.clone().ixor(e) : e.clone().ixor(this);
                    }, s.prototype.uxor = function(e) {
                        return this.length > e.length ? this.clone().iuxor(e) : e.clone().iuxor(this);
                    }, s.prototype.inotn = function(e) {
                        n("number" == typeof e && e >= 0);
                        var t = 0 | Math.ceil(e / 26), r = e % 26;
                        this._expand(t), r > 0 && t--;
                        for(var i = 0; i < t; i++)this.words[i] = 67108863 & ~this.words[i];
                        return r > 0 && (this.words[i] = ~this.words[i] & 67108863 >> 26 - r), this.strip();
                    }, s.prototype.notn = function(e) {
                        return this.clone().inotn(e);
                    }, s.prototype.setn = function(e, t) {
                        n("number" == typeof e && e >= 0);
                        var r = e / 26 | 0, i = e % 26;
                        return this._expand(r + 1), this.words[r] = t ? this.words[r] | 1 << i : this.words[r] & ~(1 << i), this.strip();
                    }, s.prototype.iadd = function(e) {
                        var t, r, n;
                        if (0 !== this.negative && 0 === e.negative) return this.negative = 0, t = this.isub(e), this.negative ^= 1, this._normSign();
                        if (0 === this.negative && 0 !== e.negative) return e.negative = 0, t = this.isub(e), e.negative = 1, t._normSign();
                        this.length > e.length ? (r = this, n = e) : (r = e, n = this);
                        for(var i = 0, s = 0; s < n.length; s++)t = (0 | r.words[s]) + (0 | n.words[s]) + i, this.words[s] = 67108863 & t, i = t >>> 26;
                        for(; 0 !== i && s < r.length; s++)t = (0 | r.words[s]) + i, this.words[s] = 67108863 & t, i = t >>> 26;
                        if (this.length = r.length, 0 !== i) this.words[this.length] = i, this.length++;
                        else if (r !== this) for(; s < r.length; s++)this.words[s] = r.words[s];
                        return this;
                    }, s.prototype.add = function(e) {
                        var t;
                        return 0 !== e.negative && 0 === this.negative ? (e.negative = 0, t = this.sub(e), e.negative ^= 1, t) : 0 === e.negative && 0 !== this.negative ? (this.negative = 0, t = e.sub(this), this.negative = 1, t) : this.length > e.length ? this.clone().iadd(e) : e.clone().iadd(this);
                    }, s.prototype.isub = function(e) {
                        if (0 !== e.negative) {
                            e.negative = 0;
                            var t = this.iadd(e);
                            return e.negative = 1, t._normSign();
                        }
                        if (0 !== this.negative) return this.negative = 0, this.iadd(e), this.negative = 1, this._normSign();
                        var r, n, i = this.cmp(e);
                        if (0 === i) return this.negative = 0, this.length = 1, this.words[0] = 0, this;
                        i > 0 ? (r = this, n = e) : (r = e, n = this);
                        for(var s = 0, o = 0; o < n.length; o++)s = (t = (0 | r.words[o]) - (0 | n.words[o]) + s) >> 26, this.words[o] = 67108863 & t;
                        for(; 0 !== s && o < r.length; o++)s = (t = (0 | r.words[o]) + s) >> 26, this.words[o] = 67108863 & t;
                        if (0 === s && o < r.length && r !== this) for(; o < r.length; o++)this.words[o] = r.words[o];
                        return this.length = Math.max(this.length, o), r !== this && (this.negative = 1), this.strip();
                    }, s.prototype.sub = function(e) {
                        return this.clone().isub(e);
                    };
                    var p = function(e, t, r) {
                        var n, i, s, o = e.words, a = t.words, l = r.words, c = 0, u = 0 | o[0], h = 8191 & u, f = u >>> 13, d = 0 | o[1], p = 8191 & d, m = d >>> 13, b = 0 | o[2], g = 8191 & b, y = b >>> 13, v = 0 | o[3], w = 8191 & v, _ = v >>> 13, x = 0 | o[4], k = 8191 & x, S = x >>> 13, M = 0 | o[5], C = 8191 & M, T = M >>> 13, E = 0 | o[6], A = 8191 & E, R = E >>> 13, O = 0 | o[7], j = 8191 & O, I = O >>> 13, N = 0 | o[8], P = 8191 & N, B = N >>> 13, D = 0 | o[9], F = 8191 & D, L = D >>> 13, z = 0 | a[0], U = 8191 & z, $ = z >>> 13, H = 0 | a[1], V = 8191 & H, q = H >>> 13, W = 0 | a[2], X = 8191 & W, K = W >>> 13, Y = 0 | a[3], Z = 8191 & Y, G = Y >>> 13, J = 0 | a[4], Q = 8191 & J, ee = J >>> 13, te = 0 | a[5], re = 8191 & te, ne = te >>> 13, ie = 0 | a[6], se = 8191 & ie, oe = ie >>> 13, ae = 0 | a[7], le = 8191 & ae, ce = ae >>> 13, ue = 0 | a[8], he = 8191 & ue, fe = ue >>> 13, de = 0 | a[9], pe = 8191 & de, me = de >>> 13;
                        r.negative = e.negative ^ t.negative, r.length = 19;
                        var be = (c + (n = Math.imul(h, U)) | 0) + ((8191 & (i = (i = Math.imul(h, $)) + Math.imul(f, U) | 0)) << 13) | 0;
                        c = ((s = Math.imul(f, $)) + (i >>> 13) | 0) + (be >>> 26) | 0, be &= 67108863, n = Math.imul(p, U), i = (i = Math.imul(p, $)) + Math.imul(m, U) | 0, s = Math.imul(m, $);
                        var ge = (c + (n = n + Math.imul(h, V) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(h, q) | 0) + Math.imul(f, V) | 0)) << 13) | 0;
                        c = ((s = s + Math.imul(f, q) | 0) + (i >>> 13) | 0) + (ge >>> 26) | 0, ge &= 67108863, n = Math.imul(g, U), i = (i = Math.imul(g, $)) + Math.imul(y, U) | 0, s = Math.imul(y, $), n = n + Math.imul(p, V) | 0, i = (i = i + Math.imul(p, q) | 0) + Math.imul(m, V) | 0, s = s + Math.imul(m, q) | 0;
                        var ye = (c + (n = n + Math.imul(h, X) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(h, K) | 0) + Math.imul(f, X) | 0)) << 13) | 0;
                        c = ((s = s + Math.imul(f, K) | 0) + (i >>> 13) | 0) + (ye >>> 26) | 0, ye &= 67108863, n = Math.imul(w, U), i = (i = Math.imul(w, $)) + Math.imul(_, U) | 0, s = Math.imul(_, $), n = n + Math.imul(g, V) | 0, i = (i = i + Math.imul(g, q) | 0) + Math.imul(y, V) | 0, s = s + Math.imul(y, q) | 0, n = n + Math.imul(p, X) | 0, i = (i = i + Math.imul(p, K) | 0) + Math.imul(m, X) | 0, s = s + Math.imul(m, K) | 0;
                        var ve = (c + (n = n + Math.imul(h, Z) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(h, G) | 0) + Math.imul(f, Z) | 0)) << 13) | 0;
                        c = ((s = s + Math.imul(f, G) | 0) + (i >>> 13) | 0) + (ve >>> 26) | 0, ve &= 67108863, n = Math.imul(k, U), i = (i = Math.imul(k, $)) + Math.imul(S, U) | 0, s = Math.imul(S, $), n = n + Math.imul(w, V) | 0, i = (i = i + Math.imul(w, q) | 0) + Math.imul(_, V) | 0, s = s + Math.imul(_, q) | 0, n = n + Math.imul(g, X) | 0, i = (i = i + Math.imul(g, K) | 0) + Math.imul(y, X) | 0, s = s + Math.imul(y, K) | 0, n = n + Math.imul(p, Z) | 0, i = (i = i + Math.imul(p, G) | 0) + Math.imul(m, Z) | 0, s = s + Math.imul(m, G) | 0;
                        var we = (c + (n = n + Math.imul(h, Q) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(h, ee) | 0) + Math.imul(f, Q) | 0)) << 13) | 0;
                        c = ((s = s + Math.imul(f, ee) | 0) + (i >>> 13) | 0) + (we >>> 26) | 0, we &= 67108863, n = Math.imul(C, U), i = (i = Math.imul(C, $)) + Math.imul(T, U) | 0, s = Math.imul(T, $), n = n + Math.imul(k, V) | 0, i = (i = i + Math.imul(k, q) | 0) + Math.imul(S, V) | 0, s = s + Math.imul(S, q) | 0, n = n + Math.imul(w, X) | 0, i = (i = i + Math.imul(w, K) | 0) + Math.imul(_, X) | 0, s = s + Math.imul(_, K) | 0, n = n + Math.imul(g, Z) | 0, i = (i = i + Math.imul(g, G) | 0) + Math.imul(y, Z) | 0, s = s + Math.imul(y, G) | 0, n = n + Math.imul(p, Q) | 0, i = (i = i + Math.imul(p, ee) | 0) + Math.imul(m, Q) | 0, s = s + Math.imul(m, ee) | 0;
                        var _e = (c + (n = n + Math.imul(h, re) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(h, ne) | 0) + Math.imul(f, re) | 0)) << 13) | 0;
                        c = ((s = s + Math.imul(f, ne) | 0) + (i >>> 13) | 0) + (_e >>> 26) | 0, _e &= 67108863, n = Math.imul(A, U), i = (i = Math.imul(A, $)) + Math.imul(R, U) | 0, s = Math.imul(R, $), n = n + Math.imul(C, V) | 0, i = (i = i + Math.imul(C, q) | 0) + Math.imul(T, V) | 0, s = s + Math.imul(T, q) | 0, n = n + Math.imul(k, X) | 0, i = (i = i + Math.imul(k, K) | 0) + Math.imul(S, X) | 0, s = s + Math.imul(S, K) | 0, n = n + Math.imul(w, Z) | 0, i = (i = i + Math.imul(w, G) | 0) + Math.imul(_, Z) | 0, s = s + Math.imul(_, G) | 0, n = n + Math.imul(g, Q) | 0, i = (i = i + Math.imul(g, ee) | 0) + Math.imul(y, Q) | 0, s = s + Math.imul(y, ee) | 0, n = n + Math.imul(p, re) | 0, i = (i = i + Math.imul(p, ne) | 0) + Math.imul(m, re) | 0, s = s + Math.imul(m, ne) | 0;
                        var xe = (c + (n = n + Math.imul(h, se) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(h, oe) | 0) + Math.imul(f, se) | 0)) << 13) | 0;
                        c = ((s = s + Math.imul(f, oe) | 0) + (i >>> 13) | 0) + (xe >>> 26) | 0, xe &= 67108863, n = Math.imul(j, U), i = (i = Math.imul(j, $)) + Math.imul(I, U) | 0, s = Math.imul(I, $), n = n + Math.imul(A, V) | 0, i = (i = i + Math.imul(A, q) | 0) + Math.imul(R, V) | 0, s = s + Math.imul(R, q) | 0, n = n + Math.imul(C, X) | 0, i = (i = i + Math.imul(C, K) | 0) + Math.imul(T, X) | 0, s = s + Math.imul(T, K) | 0, n = n + Math.imul(k, Z) | 0, i = (i = i + Math.imul(k, G) | 0) + Math.imul(S, Z) | 0, s = s + Math.imul(S, G) | 0, n = n + Math.imul(w, Q) | 0, i = (i = i + Math.imul(w, ee) | 0) + Math.imul(_, Q) | 0, s = s + Math.imul(_, ee) | 0, n = n + Math.imul(g, re) | 0, i = (i = i + Math.imul(g, ne) | 0) + Math.imul(y, re) | 0, s = s + Math.imul(y, ne) | 0, n = n + Math.imul(p, se) | 0, i = (i = i + Math.imul(p, oe) | 0) + Math.imul(m, se) | 0, s = s + Math.imul(m, oe) | 0;
                        var ke = (c + (n = n + Math.imul(h, le) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(h, ce) | 0) + Math.imul(f, le) | 0)) << 13) | 0;
                        c = ((s = s + Math.imul(f, ce) | 0) + (i >>> 13) | 0) + (ke >>> 26) | 0, ke &= 67108863, n = Math.imul(P, U), i = (i = Math.imul(P, $)) + Math.imul(B, U) | 0, s = Math.imul(B, $), n = n + Math.imul(j, V) | 0, i = (i = i + Math.imul(j, q) | 0) + Math.imul(I, V) | 0, s = s + Math.imul(I, q) | 0, n = n + Math.imul(A, X) | 0, i = (i = i + Math.imul(A, K) | 0) + Math.imul(R, X) | 0, s = s + Math.imul(R, K) | 0, n = n + Math.imul(C, Z) | 0, i = (i = i + Math.imul(C, G) | 0) + Math.imul(T, Z) | 0, s = s + Math.imul(T, G) | 0, n = n + Math.imul(k, Q) | 0, i = (i = i + Math.imul(k, ee) | 0) + Math.imul(S, Q) | 0, s = s + Math.imul(S, ee) | 0, n = n + Math.imul(w, re) | 0, i = (i = i + Math.imul(w, ne) | 0) + Math.imul(_, re) | 0, s = s + Math.imul(_, ne) | 0, n = n + Math.imul(g, se) | 0, i = (i = i + Math.imul(g, oe) | 0) + Math.imul(y, se) | 0, s = s + Math.imul(y, oe) | 0, n = n + Math.imul(p, le) | 0, i = (i = i + Math.imul(p, ce) | 0) + Math.imul(m, le) | 0, s = s + Math.imul(m, ce) | 0;
                        var Se = (c + (n = n + Math.imul(h, he) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(h, fe) | 0) + Math.imul(f, he) | 0)) << 13) | 0;
                        c = ((s = s + Math.imul(f, fe) | 0) + (i >>> 13) | 0) + (Se >>> 26) | 0, Se &= 67108863, n = Math.imul(F, U), i = (i = Math.imul(F, $)) + Math.imul(L, U) | 0, s = Math.imul(L, $), n = n + Math.imul(P, V) | 0, i = (i = i + Math.imul(P, q) | 0) + Math.imul(B, V) | 0, s = s + Math.imul(B, q) | 0, n = n + Math.imul(j, X) | 0, i = (i = i + Math.imul(j, K) | 0) + Math.imul(I, X) | 0, s = s + Math.imul(I, K) | 0, n = n + Math.imul(A, Z) | 0, i = (i = i + Math.imul(A, G) | 0) + Math.imul(R, Z) | 0, s = s + Math.imul(R, G) | 0, n = n + Math.imul(C, Q) | 0, i = (i = i + Math.imul(C, ee) | 0) + Math.imul(T, Q) | 0, s = s + Math.imul(T, ee) | 0, n = n + Math.imul(k, re) | 0, i = (i = i + Math.imul(k, ne) | 0) + Math.imul(S, re) | 0, s = s + Math.imul(S, ne) | 0, n = n + Math.imul(w, se) | 0, i = (i = i + Math.imul(w, oe) | 0) + Math.imul(_, se) | 0, s = s + Math.imul(_, oe) | 0, n = n + Math.imul(g, le) | 0, i = (i = i + Math.imul(g, ce) | 0) + Math.imul(y, le) | 0, s = s + Math.imul(y, ce) | 0, n = n + Math.imul(p, he) | 0, i = (i = i + Math.imul(p, fe) | 0) + Math.imul(m, he) | 0, s = s + Math.imul(m, fe) | 0;
                        var Me = (c + (n = n + Math.imul(h, pe) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(h, me) | 0) + Math.imul(f, pe) | 0)) << 13) | 0;
                        c = ((s = s + Math.imul(f, me) | 0) + (i >>> 13) | 0) + (Me >>> 26) | 0, Me &= 67108863, n = Math.imul(F, V), i = (i = Math.imul(F, q)) + Math.imul(L, V) | 0, s = Math.imul(L, q), n = n + Math.imul(P, X) | 0, i = (i = i + Math.imul(P, K) | 0) + Math.imul(B, X) | 0, s = s + Math.imul(B, K) | 0, n = n + Math.imul(j, Z) | 0, i = (i = i + Math.imul(j, G) | 0) + Math.imul(I, Z) | 0, s = s + Math.imul(I, G) | 0, n = n + Math.imul(A, Q) | 0, i = (i = i + Math.imul(A, ee) | 0) + Math.imul(R, Q) | 0, s = s + Math.imul(R, ee) | 0, n = n + Math.imul(C, re) | 0, i = (i = i + Math.imul(C, ne) | 0) + Math.imul(T, re) | 0, s = s + Math.imul(T, ne) | 0, n = n + Math.imul(k, se) | 0, i = (i = i + Math.imul(k, oe) | 0) + Math.imul(S, se) | 0, s = s + Math.imul(S, oe) | 0, n = n + Math.imul(w, le) | 0, i = (i = i + Math.imul(w, ce) | 0) + Math.imul(_, le) | 0, s = s + Math.imul(_, ce) | 0, n = n + Math.imul(g, he) | 0, i = (i = i + Math.imul(g, fe) | 0) + Math.imul(y, he) | 0, s = s + Math.imul(y, fe) | 0;
                        var Ce = (c + (n = n + Math.imul(p, pe) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(p, me) | 0) + Math.imul(m, pe) | 0)) << 13) | 0;
                        c = ((s = s + Math.imul(m, me) | 0) + (i >>> 13) | 0) + (Ce >>> 26) | 0, Ce &= 67108863, n = Math.imul(F, X), i = (i = Math.imul(F, K)) + Math.imul(L, X) | 0, s = Math.imul(L, K), n = n + Math.imul(P, Z) | 0, i = (i = i + Math.imul(P, G) | 0) + Math.imul(B, Z) | 0, s = s + Math.imul(B, G) | 0, n = n + Math.imul(j, Q) | 0, i = (i = i + Math.imul(j, ee) | 0) + Math.imul(I, Q) | 0, s = s + Math.imul(I, ee) | 0, n = n + Math.imul(A, re) | 0, i = (i = i + Math.imul(A, ne) | 0) + Math.imul(R, re) | 0, s = s + Math.imul(R, ne) | 0, n = n + Math.imul(C, se) | 0, i = (i = i + Math.imul(C, oe) | 0) + Math.imul(T, se) | 0, s = s + Math.imul(T, oe) | 0, n = n + Math.imul(k, le) | 0, i = (i = i + Math.imul(k, ce) | 0) + Math.imul(S, le) | 0, s = s + Math.imul(S, ce) | 0, n = n + Math.imul(w, he) | 0, i = (i = i + Math.imul(w, fe) | 0) + Math.imul(_, he) | 0, s = s + Math.imul(_, fe) | 0;
                        var Te = (c + (n = n + Math.imul(g, pe) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(g, me) | 0) + Math.imul(y, pe) | 0)) << 13) | 0;
                        c = ((s = s + Math.imul(y, me) | 0) + (i >>> 13) | 0) + (Te >>> 26) | 0, Te &= 67108863, n = Math.imul(F, Z), i = (i = Math.imul(F, G)) + Math.imul(L, Z) | 0, s = Math.imul(L, G), n = n + Math.imul(P, Q) | 0, i = (i = i + Math.imul(P, ee) | 0) + Math.imul(B, Q) | 0, s = s + Math.imul(B, ee) | 0, n = n + Math.imul(j, re) | 0, i = (i = i + Math.imul(j, ne) | 0) + Math.imul(I, re) | 0, s = s + Math.imul(I, ne) | 0, n = n + Math.imul(A, se) | 0, i = (i = i + Math.imul(A, oe) | 0) + Math.imul(R, se) | 0, s = s + Math.imul(R, oe) | 0, n = n + Math.imul(C, le) | 0, i = (i = i + Math.imul(C, ce) | 0) + Math.imul(T, le) | 0, s = s + Math.imul(T, ce) | 0, n = n + Math.imul(k, he) | 0, i = (i = i + Math.imul(k, fe) | 0) + Math.imul(S, he) | 0, s = s + Math.imul(S, fe) | 0;
                        var Ee = (c + (n = n + Math.imul(w, pe) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(w, me) | 0) + Math.imul(_, pe) | 0)) << 13) | 0;
                        c = ((s = s + Math.imul(_, me) | 0) + (i >>> 13) | 0) + (Ee >>> 26) | 0, Ee &= 67108863, n = Math.imul(F, Q), i = (i = Math.imul(F, ee)) + Math.imul(L, Q) | 0, s = Math.imul(L, ee), n = n + Math.imul(P, re) | 0, i = (i = i + Math.imul(P, ne) | 0) + Math.imul(B, re) | 0, s = s + Math.imul(B, ne) | 0, n = n + Math.imul(j, se) | 0, i = (i = i + Math.imul(j, oe) | 0) + Math.imul(I, se) | 0, s = s + Math.imul(I, oe) | 0, n = n + Math.imul(A, le) | 0, i = (i = i + Math.imul(A, ce) | 0) + Math.imul(R, le) | 0, s = s + Math.imul(R, ce) | 0, n = n + Math.imul(C, he) | 0, i = (i = i + Math.imul(C, fe) | 0) + Math.imul(T, he) | 0, s = s + Math.imul(T, fe) | 0;
                        var Ae = (c + (n = n + Math.imul(k, pe) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(k, me) | 0) + Math.imul(S, pe) | 0)) << 13) | 0;
                        c = ((s = s + Math.imul(S, me) | 0) + (i >>> 13) | 0) + (Ae >>> 26) | 0, Ae &= 67108863, n = Math.imul(F, re), i = (i = Math.imul(F, ne)) + Math.imul(L, re) | 0, s = Math.imul(L, ne), n = n + Math.imul(P, se) | 0, i = (i = i + Math.imul(P, oe) | 0) + Math.imul(B, se) | 0, s = s + Math.imul(B, oe) | 0, n = n + Math.imul(j, le) | 0, i = (i = i + Math.imul(j, ce) | 0) + Math.imul(I, le) | 0, s = s + Math.imul(I, ce) | 0, n = n + Math.imul(A, he) | 0, i = (i = i + Math.imul(A, fe) | 0) + Math.imul(R, he) | 0, s = s + Math.imul(R, fe) | 0;
                        var Re = (c + (n = n + Math.imul(C, pe) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(C, me) | 0) + Math.imul(T, pe) | 0)) << 13) | 0;
                        c = ((s = s + Math.imul(T, me) | 0) + (i >>> 13) | 0) + (Re >>> 26) | 0, Re &= 67108863, n = Math.imul(F, se), i = (i = Math.imul(F, oe)) + Math.imul(L, se) | 0, s = Math.imul(L, oe), n = n + Math.imul(P, le) | 0, i = (i = i + Math.imul(P, ce) | 0) + Math.imul(B, le) | 0, s = s + Math.imul(B, ce) | 0, n = n + Math.imul(j, he) | 0, i = (i = i + Math.imul(j, fe) | 0) + Math.imul(I, he) | 0, s = s + Math.imul(I, fe) | 0;
                        var Oe = (c + (n = n + Math.imul(A, pe) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(A, me) | 0) + Math.imul(R, pe) | 0)) << 13) | 0;
                        c = ((s = s + Math.imul(R, me) | 0) + (i >>> 13) | 0) + (Oe >>> 26) | 0, Oe &= 67108863, n = Math.imul(F, le), i = (i = Math.imul(F, ce)) + Math.imul(L, le) | 0, s = Math.imul(L, ce), n = n + Math.imul(P, he) | 0, i = (i = i + Math.imul(P, fe) | 0) + Math.imul(B, he) | 0, s = s + Math.imul(B, fe) | 0;
                        var je = (c + (n = n + Math.imul(j, pe) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(j, me) | 0) + Math.imul(I, pe) | 0)) << 13) | 0;
                        c = ((s = s + Math.imul(I, me) | 0) + (i >>> 13) | 0) + (je >>> 26) | 0, je &= 67108863, n = Math.imul(F, he), i = (i = Math.imul(F, fe)) + Math.imul(L, he) | 0, s = Math.imul(L, fe);
                        var Ie = (c + (n = n + Math.imul(P, pe) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(P, me) | 0) + Math.imul(B, pe) | 0)) << 13) | 0;
                        c = ((s = s + Math.imul(B, me) | 0) + (i >>> 13) | 0) + (Ie >>> 26) | 0, Ie &= 67108863;
                        var Ne = (c + (n = Math.imul(F, pe)) | 0) + ((8191 & (i = (i = Math.imul(F, me)) + Math.imul(L, pe) | 0)) << 13) | 0;
                        return c = ((s = Math.imul(L, me)) + (i >>> 13) | 0) + (Ne >>> 26) | 0, Ne &= 67108863, l[0] = be, l[1] = ge, l[2] = ye, l[3] = ve, l[4] = we, l[5] = _e, l[6] = xe, l[7] = ke, l[8] = Se, l[9] = Me, l[10] = Ce, l[11] = Te, l[12] = Ee, l[13] = Ae, l[14] = Re, l[15] = Oe, l[16] = je, l[17] = Ie, l[18] = Ne, 0 !== c && (l[19] = c, r.length++), r;
                    };
                    function m(e, t, r) {
                        return (new b).mulp(e, t, r);
                    }
                    function b(e, t) {
                        this.x = e, this.y = t;
                    }
                    Math.imul || (p = d), s.prototype.mulTo = function(e, t) {
                        var r = this.length + e.length;
                        return 10 === this.length && 10 === e.length ? p(this, e, t) : r < 63 ? d(this, e, t) : r < 1024 ? function(e, t, r) {
                            r.negative = t.negative ^ e.negative, r.length = e.length + t.length;
                            for(var n = 0, i = 0, s = 0; s < r.length - 1; s++){
                                var o = i;
                                i = 0;
                                for(var a = 67108863 & n, l = Math.min(s, t.length - 1), c = Math.max(0, s - e.length + 1); c <= l; c++){
                                    var u = s - c, h = (0 | e.words[u]) * (0 | t.words[c]), f = 67108863 & h;
                                    a = 67108863 & (f = f + a | 0), i += (o = (o = o + (h / 67108864 | 0) | 0) + (f >>> 26) | 0) >>> 26, o &= 67108863;
                                }
                                r.words[s] = a, n = o, o = i;
                            }
                            return 0 !== n ? r.words[s] = n : r.length--, r.strip();
                        }(this, e, t) : m(this, e, t);
                    }, b.prototype.makeRBT = function(e) {
                        for(var t = new Array(e), r = s.prototype._countBits(e) - 1, n = 0; n < e; n++)t[n] = this.revBin(n, r, e);
                        return t;
                    }, b.prototype.revBin = function(e, t, r) {
                        if (0 === e || e === r - 1) return e;
                        for(var n = 0, i = 0; i < t; i++)n |= (1 & e) << t - i - 1, e >>= 1;
                        return n;
                    }, b.prototype.permute = function(e, t, r, n, i, s) {
                        for(var o = 0; o < s; o++)n[o] = t[e[o]], i[o] = r[e[o]];
                    }, b.prototype.transform = function(e, t, r, n, i, s) {
                        this.permute(s, e, t, r, n, i);
                        for(var o = 1; o < i; o <<= 1)for(var a = o << 1, l = Math.cos(2 * Math.PI / a), c = Math.sin(2 * Math.PI / a), u = 0; u < i; u += a)for(var h = l, f = c, d = 0; d < o; d++){
                            var p = r[u + d], m = n[u + d], b = r[u + d + o], g = n[u + d + o], y = h * b - f * g;
                            g = h * g + f * b, b = y, r[u + d] = p + b, n[u + d] = m + g, r[u + d + o] = p - b, n[u + d + o] = m - g, d !== a && (y = l * h - c * f, f = l * f + c * h, h = y);
                        }
                    }, b.prototype.guessLen13b = function(e, t) {
                        var r = 1 | Math.max(t, e), n = 1 & r, i = 0;
                        for(r = r / 2 | 0; r; r >>>= 1)i++;
                        return 1 << i + 1 + n;
                    }, b.prototype.conjugate = function(e, t, r) {
                        if (!(r <= 1)) for(var n = 0; n < r / 2; n++){
                            var i = e[n];
                            e[n] = e[r - n - 1], e[r - n - 1] = i, i = t[n], t[n] = -t[r - n - 1], t[r - n - 1] = -i;
                        }
                    }, b.prototype.normalize13b = function(e, t) {
                        for(var r = 0, n = 0; n < t / 2; n++){
                            var i = 8192 * Math.round(e[2 * n + 1] / t) + Math.round(e[2 * n] / t) + r;
                            e[n] = 67108863 & i, r = i < 67108864 ? 0 : i / 67108864 | 0;
                        }
                        return e;
                    }, b.prototype.convert13b = function(e, t, r, i) {
                        for(var s = 0, o = 0; o < t; o++)s += 0 | e[o], r[2 * o] = 8191 & s, s >>>= 13, r[2 * o + 1] = 8191 & s, s >>>= 13;
                        for(o = 2 * t; o < i; ++o)r[o] = 0;
                        n(0 === s), n(0 == (-8192 & s));
                    }, b.prototype.stub = function(e) {
                        for(var t = new Array(e), r = 0; r < e; r++)t[r] = 0;
                        return t;
                    }, b.prototype.mulp = function(e, t, r) {
                        var n = 2 * this.guessLen13b(e.length, t.length), i = this.makeRBT(n), s = this.stub(n), o = new Array(n), a = new Array(n), l = new Array(n), c = new Array(n), u = new Array(n), h = new Array(n), f = r.words;
                        f.length = n, this.convert13b(e.words, e.length, o, n), this.convert13b(t.words, t.length, c, n), this.transform(o, s, a, l, n, i), this.transform(c, s, u, h, n, i);
                        for(var d = 0; d < n; d++){
                            var p = a[d] * u[d] - l[d] * h[d];
                            l[d] = a[d] * h[d] + l[d] * u[d], a[d] = p;
                        }
                        return this.conjugate(a, l, n), this.transform(a, l, f, s, n, i), this.conjugate(f, s, n), this.normalize13b(f, n), r.negative = e.negative ^ t.negative, r.length = e.length + t.length, r.strip();
                    }, s.prototype.mul = function(e) {
                        var t = new s(null);
                        return t.words = new Array(this.length + e.length), this.mulTo(e, t);
                    }, s.prototype.mulf = function(e) {
                        var t = new s(null);
                        return t.words = new Array(this.length + e.length), m(this, e, t);
                    }, s.prototype.imul = function(e) {
                        return this.clone().mulTo(e, this);
                    }, s.prototype.imuln = function(e) {
                        n("number" == typeof e), n(e < 67108864);
                        for(var t = 0, r = 0; r < this.length; r++){
                            var i = (0 | this.words[r]) * e, s = (67108863 & i) + (67108863 & t);
                            t >>= 26, t += i / 67108864 | 0, t += s >>> 26, this.words[r] = 67108863 & s;
                        }
                        return 0 !== t && (this.words[r] = t, this.length++), this;
                    }, s.prototype.muln = function(e) {
                        return this.clone().imuln(e);
                    }, s.prototype.sqr = function() {
                        return this.mul(this);
                    }, s.prototype.isqr = function() {
                        return this.imul(this.clone());
                    }, s.prototype.pow = function(e) {
                        var t = function(e) {
                            for(var t = new Array(e.bitLength()), r = 0; r < t.length; r++){
                                var n = r / 26 | 0, i = r % 26;
                                t[r] = (e.words[n] & 1 << i) >>> i;
                            }
                            return t;
                        }(e);
                        if (0 === t.length) return new s(1);
                        for(var r = this, n = 0; n < t.length && 0 === t[n]; n++, r = r.sqr());
                        if (++n < t.length) for(var i = r.sqr(); n < t.length; n++, i = i.sqr())0 !== t[n] && (r = r.mul(i));
                        return r;
                    }, s.prototype.iushln = function(e) {
                        n("number" == typeof e && e >= 0);
                        var t, r = e % 26, i = (e - r) / 26, s = 67108863 >>> 26 - r << 26 - r;
                        if (0 !== r) {
                            var o = 0;
                            for(t = 0; t < this.length; t++){
                                var a = this.words[t] & s, l = (0 | this.words[t]) - a << r;
                                this.words[t] = l | o, o = a >>> 26 - r;
                            }
                            o && (this.words[t] = o, this.length++);
                        }
                        if (0 !== i) {
                            for(t = this.length - 1; t >= 0; t--)this.words[t + i] = this.words[t];
                            for(t = 0; t < i; t++)this.words[t] = 0;
                            this.length += i;
                        }
                        return this.strip();
                    }, s.prototype.ishln = function(e) {
                        return n(0 === this.negative), this.iushln(e);
                    }, s.prototype.iushrn = function(e, t, r) {
                        var i;
                        n("number" == typeof e && e >= 0), i = t ? (t - t % 26) / 26 : 0;
                        var s = e % 26, o = Math.min((e - s) / 26, this.length), a = 67108863 ^ 67108863 >>> s << s, l = r;
                        if (i -= o, i = Math.max(0, i), l) {
                            for(var c = 0; c < o; c++)l.words[c] = this.words[c];
                            l.length = o;
                        }
                        if (0 === o) ;
                        else if (this.length > o) for(this.length -= o, c = 0; c < this.length; c++)this.words[c] = this.words[c + o];
                        else this.words[0] = 0, this.length = 1;
                        var u = 0;
                        for(c = this.length - 1; c >= 0 && (0 !== u || c >= i); c--){
                            var h = 0 | this.words[c];
                            this.words[c] = u << 26 - s | h >>> s, u = h & a;
                        }
                        return l && 0 !== u && (l.words[l.length++] = u), 0 === this.length && (this.words[0] = 0, this.length = 1), this.strip();
                    }, s.prototype.ishrn = function(e, t, r) {
                        return n(0 === this.negative), this.iushrn(e, t, r);
                    }, s.prototype.shln = function(e) {
                        return this.clone().ishln(e);
                    }, s.prototype.ushln = function(e) {
                        return this.clone().iushln(e);
                    }, s.prototype.shrn = function(e) {
                        return this.clone().ishrn(e);
                    }, s.prototype.ushrn = function(e) {
                        return this.clone().iushrn(e);
                    }, s.prototype.testn = function(e) {
                        n("number" == typeof e && e >= 0);
                        var t = e % 26, r = (e - t) / 26, i = 1 << t;
                        return !(this.length <= r) && !!(this.words[r] & i);
                    }, s.prototype.imaskn = function(e) {
                        n("number" == typeof e && e >= 0);
                        var t = e % 26, r = (e - t) / 26;
                        if (n(0 === this.negative, "imaskn works only with positive numbers"), this.length <= r) return this;
                        if (0 !== t && r++, this.length = Math.min(r, this.length), 0 !== t) {
                            var i = 67108863 ^ 67108863 >>> t << t;
                            this.words[this.length - 1] &= i;
                        }
                        return this.strip();
                    }, s.prototype.maskn = function(e) {
                        return this.clone().imaskn(e);
                    }, s.prototype.iaddn = function(e) {
                        return n("number" == typeof e), n(e < 67108864), e < 0 ? this.isubn(-e) : 0 !== this.negative ? 1 === this.length && (0 | this.words[0]) < e ? (this.words[0] = e - (0 | this.words[0]), this.negative = 0, this) : (this.negative = 0, this.isubn(e), this.negative = 1, this) : this._iaddn(e);
                    }, s.prototype._iaddn = function(e) {
                        this.words[0] += e;
                        for(var t = 0; t < this.length && this.words[t] >= 67108864; t++)this.words[t] -= 67108864, t === this.length - 1 ? this.words[t + 1] = 1 : this.words[t + 1]++;
                        return this.length = Math.max(this.length, t + 1), this;
                    }, s.prototype.isubn = function(e) {
                        if (n("number" == typeof e), n(e < 67108864), e < 0) return this.iaddn(-e);
                        if (0 !== this.negative) return this.negative = 0, this.iaddn(e), this.negative = 1, this;
                        if (this.words[0] -= e, 1 === this.length && this.words[0] < 0) this.words[0] = -this.words[0], this.negative = 1;
                        else for(var t = 0; t < this.length && this.words[t] < 0; t++)this.words[t] += 67108864, this.words[t + 1] -= 1;
                        return this.strip();
                    }, s.prototype.addn = function(e) {
                        return this.clone().iaddn(e);
                    }, s.prototype.subn = function(e) {
                        return this.clone().isubn(e);
                    }, s.prototype.iabs = function() {
                        return this.negative = 0, this;
                    }, s.prototype.abs = function() {
                        return this.clone().iabs();
                    }, s.prototype._ishlnsubmul = function(e, t, r) {
                        var i, s, o = e.length + r;
                        this._expand(o);
                        var a = 0;
                        for(i = 0; i < e.length; i++){
                            s = (0 | this.words[i + r]) + a;
                            var l = (0 | e.words[i]) * t;
                            a = ((s -= 67108863 & l) >> 26) - (l / 67108864 | 0), this.words[i + r] = 67108863 & s;
                        }
                        for(; i < this.length - r; i++)a = (s = (0 | this.words[i + r]) + a) >> 26, this.words[i + r] = 67108863 & s;
                        if (0 === a) return this.strip();
                        for(n(-1 === a), a = 0, i = 0; i < this.length; i++)a = (s = -(0 | this.words[i]) + a) >> 26, this.words[i] = 67108863 & s;
                        return this.negative = 1, this.strip();
                    }, s.prototype._wordDiv = function(e, t) {
                        var r = (this.length, e.length), n = this.clone(), i = e, o = 0 | i.words[i.length - 1];
                        0 !== (r = 26 - this._countBits(o)) && (i = i.ushln(r), n.iushln(r), o = 0 | i.words[i.length - 1]);
                        var a, l = n.length - i.length;
                        if ("mod" !== t) {
                            (a = new s(null)).length = l + 1, a.words = new Array(a.length);
                            for(var c = 0; c < a.length; c++)a.words[c] = 0;
                        }
                        var u = n.clone()._ishlnsubmul(i, 1, l);
                        0 === u.negative && (n = u, a && (a.words[l] = 1));
                        for(var h = l - 1; h >= 0; h--){
                            var f = 67108864 * (0 | n.words[i.length + h]) + (0 | n.words[i.length + h - 1]);
                            for(f = Math.min(f / o | 0, 67108863), n._ishlnsubmul(i, f, h); 0 !== n.negative;)f--, n.negative = 0, n._ishlnsubmul(i, 1, h), n.isZero() || (n.negative ^= 1);
                            a && (a.words[h] = f);
                        }
                        return a && a.strip(), n.strip(), "div" !== t && 0 !== r && n.iushrn(r), {
                            div: a || null,
                            mod: n
                        };
                    }, s.prototype.divmod = function(e, t, r) {
                        var i, o, a;
                        return n(!e.isZero()), this.isZero() ? {
                            div: new s(0),
                            mod: new s(0)
                        } : 0 !== this.negative && 0 === e.negative ? (a = this.neg().divmod(e, t), "mod" !== t && (i = a.div.neg()), "div" !== t && (o = a.mod.neg(), r && 0 !== o.negative && o.iadd(e)), {
                            div: i,
                            mod: o
                        }) : 0 === this.negative && 0 !== e.negative ? (a = this.divmod(e.neg(), t), "mod" !== t && (i = a.div.neg()), {
                            div: i,
                            mod: a.mod
                        }) : 0 != (this.negative & e.negative) ? (a = this.neg().divmod(e.neg(), t), "div" !== t && (o = a.mod.neg(), r && 0 !== o.negative && o.isub(e)), {
                            div: a.div,
                            mod: o
                        }) : e.length > this.length || this.cmp(e) < 0 ? {
                            div: new s(0),
                            mod: this
                        } : 1 === e.length ? "div" === t ? {
                            div: this.divn(e.words[0]),
                            mod: null
                        } : "mod" === t ? {
                            div: null,
                            mod: new s(this.modn(e.words[0]))
                        } : {
                            div: this.divn(e.words[0]),
                            mod: new s(this.modn(e.words[0]))
                        } : this._wordDiv(e, t);
                    }, s.prototype.div = function(e) {
                        return this.divmod(e, "div", !1).div;
                    }, s.prototype.mod = function(e) {
                        return this.divmod(e, "mod", !1).mod;
                    }, s.prototype.umod = function(e) {
                        return this.divmod(e, "mod", !0).mod;
                    }, s.prototype.divRound = function(e) {
                        var t = this.divmod(e);
                        if (t.mod.isZero()) return t.div;
                        var r = 0 !== t.div.negative ? t.mod.isub(e) : t.mod, n = e.ushrn(1), i = e.andln(1), s = r.cmp(n);
                        return s < 0 || 1 === i && 0 === s ? t.div : 0 !== t.div.negative ? t.div.isubn(1) : t.div.iaddn(1);
                    }, s.prototype.modn = function(e) {
                        n(e <= 67108863);
                        for(var t = 67108864 % e, r = 0, i = this.length - 1; i >= 0; i--)r = (t * r + (0 | this.words[i])) % e;
                        return r;
                    }, s.prototype.idivn = function(e) {
                        n(e <= 67108863);
                        for(var t = 0, r = this.length - 1; r >= 0; r--){
                            var i = (0 | this.words[r]) + 67108864 * t;
                            this.words[r] = i / e | 0, t = i % e;
                        }
                        return this.strip();
                    }, s.prototype.divn = function(e) {
                        return this.clone().idivn(e);
                    }, s.prototype.egcd = function(e) {
                        n(0 === e.negative), n(!e.isZero());
                        var t = this, r = e.clone();
                        t = 0 !== t.negative ? t.umod(e) : t.clone();
                        for(var i = new s(1), o = new s(0), a = new s(0), l = new s(1), c = 0; t.isEven() && r.isEven();)t.iushrn(1), r.iushrn(1), ++c;
                        for(var u = r.clone(), h = t.clone(); !t.isZero();){
                            for(var f = 0, d = 1; 0 == (t.words[0] & d) && f < 26; ++f, d <<= 1);
                            if (f > 0) for(t.iushrn(f); f-- > 0;)(i.isOdd() || o.isOdd()) && (i.iadd(u), o.isub(h)), i.iushrn(1), o.iushrn(1);
                            for(var p = 0, m = 1; 0 == (r.words[0] & m) && p < 26; ++p, m <<= 1);
                            if (p > 0) for(r.iushrn(p); p-- > 0;)(a.isOdd() || l.isOdd()) && (a.iadd(u), l.isub(h)), a.iushrn(1), l.iushrn(1);
                            t.cmp(r) >= 0 ? (t.isub(r), i.isub(a), o.isub(l)) : (r.isub(t), a.isub(i), l.isub(o));
                        }
                        return {
                            a: a,
                            b: l,
                            gcd: r.iushln(c)
                        };
                    }, s.prototype._invmp = function(e) {
                        n(0 === e.negative), n(!e.isZero());
                        var t = this, r = e.clone();
                        t = 0 !== t.negative ? t.umod(e) : t.clone();
                        for(var i, o = new s(1), a = new s(0), l = r.clone(); t.cmpn(1) > 0 && r.cmpn(1) > 0;){
                            for(var c = 0, u = 1; 0 == (t.words[0] & u) && c < 26; ++c, u <<= 1);
                            if (c > 0) for(t.iushrn(c); c-- > 0;)o.isOdd() && o.iadd(l), o.iushrn(1);
                            for(var h = 0, f = 1; 0 == (r.words[0] & f) && h < 26; ++h, f <<= 1);
                            if (h > 0) for(r.iushrn(h); h-- > 0;)a.isOdd() && a.iadd(l), a.iushrn(1);
                            t.cmp(r) >= 0 ? (t.isub(r), o.isub(a)) : (r.isub(t), a.isub(o));
                        }
                        return (i = 0 === t.cmpn(1) ? o : a).cmpn(0) < 0 && i.iadd(e), i;
                    }, s.prototype.gcd = function(e) {
                        if (this.isZero()) return e.abs();
                        if (e.isZero()) return this.abs();
                        var t = this.clone(), r = e.clone();
                        t.negative = 0, r.negative = 0;
                        for(var n = 0; t.isEven() && r.isEven(); n++)t.iushrn(1), r.iushrn(1);
                        for(;;){
                            for(; t.isEven();)t.iushrn(1);
                            for(; r.isEven();)r.iushrn(1);
                            var i = t.cmp(r);
                            if (i < 0) {
                                var s = t;
                                t = r, r = s;
                            } else if (0 === i || 0 === r.cmpn(1)) break;
                            t.isub(r);
                        }
                        return r.iushln(n);
                    }, s.prototype.invm = function(e) {
                        return this.egcd(e).a.umod(e);
                    }, s.prototype.isEven = function() {
                        return 0 == (1 & this.words[0]);
                    }, s.prototype.isOdd = function() {
                        return 1 == (1 & this.words[0]);
                    }, s.prototype.andln = function(e) {
                        return this.words[0] & e;
                    }, s.prototype.bincn = function(e) {
                        n("number" == typeof e);
                        var t = e % 26, r = (e - t) / 26, i = 1 << t;
                        if (this.length <= r) return this._expand(r + 1), this.words[r] |= i, this;
                        for(var s = i, o = r; 0 !== s && o < this.length; o++){
                            var a = 0 | this.words[o];
                            s = (a += s) >>> 26, a &= 67108863, this.words[o] = a;
                        }
                        return 0 !== s && (this.words[o] = s, this.length++), this;
                    }, s.prototype.isZero = function() {
                        return 1 === this.length && 0 === this.words[0];
                    }, s.prototype.cmpn = function(e) {
                        var t, r = e < 0;
                        if (0 !== this.negative && !r) return -1;
                        if (0 === this.negative && r) return 1;
                        if (this.strip(), this.length > 1) t = 1;
                        else {
                            r && (e = -e), n(e <= 67108863, "Number is too big");
                            var i = 0 | this.words[0];
                            t = i === e ? 0 : i < e ? -1 : 1;
                        }
                        return 0 !== this.negative ? 0 | -t : t;
                    }, s.prototype.cmp = function(e) {
                        if (0 !== this.negative && 0 === e.negative) return -1;
                        if (0 === this.negative && 0 !== e.negative) return 1;
                        var t = this.ucmp(e);
                        return 0 !== this.negative ? 0 | -t : t;
                    }, s.prototype.ucmp = function(e) {
                        if (this.length > e.length) return 1;
                        if (this.length < e.length) return -1;
                        for(var t = 0, r = this.length - 1; r >= 0; r--){
                            var n = 0 | this.words[r], i = 0 | e.words[r];
                            if (n !== i) {
                                n < i ? t = -1 : n > i && (t = 1);
                                break;
                            }
                        }
                        return t;
                    }, s.prototype.gtn = function(e) {
                        return 1 === this.cmpn(e);
                    }, s.prototype.gt = function(e) {
                        return 1 === this.cmp(e);
                    }, s.prototype.gten = function(e) {
                        return this.cmpn(e) >= 0;
                    }, s.prototype.gte = function(e) {
                        return this.cmp(e) >= 0;
                    }, s.prototype.ltn = function(e) {
                        return -1 === this.cmpn(e);
                    }, s.prototype.lt = function(e) {
                        return -1 === this.cmp(e);
                    }, s.prototype.lten = function(e) {
                        return this.cmpn(e) <= 0;
                    }, s.prototype.lte = function(e) {
                        return this.cmp(e) <= 0;
                    }, s.prototype.eqn = function(e) {
                        return 0 === this.cmpn(e);
                    }, s.prototype.eq = function(e) {
                        return 0 === this.cmp(e);
                    }, s.red = function(e) {
                        return new k(e);
                    }, s.prototype.toRed = function(e) {
                        return n(!this.red, "Already a number in reduction context"), n(0 === this.negative, "red works only with positives"), e.convertTo(this)._forceRed(e);
                    }, s.prototype.fromRed = function() {
                        return n(this.red, "fromRed works only with numbers in reduction context"), this.red.convertFrom(this);
                    }, s.prototype._forceRed = function(e) {
                        return this.red = e, this;
                    }, s.prototype.forceRed = function(e) {
                        return n(!this.red, "Already a number in reduction context"), this._forceRed(e);
                    }, s.prototype.redAdd = function(e) {
                        return n(this.red, "redAdd works only with red numbers"), this.red.add(this, e);
                    }, s.prototype.redIAdd = function(e) {
                        return n(this.red, "redIAdd works only with red numbers"), this.red.iadd(this, e);
                    }, s.prototype.redSub = function(e) {
                        return n(this.red, "redSub works only with red numbers"), this.red.sub(this, e);
                    }, s.prototype.redISub = function(e) {
                        return n(this.red, "redISub works only with red numbers"), this.red.isub(this, e);
                    }, s.prototype.redShl = function(e) {
                        return n(this.red, "redShl works only with red numbers"), this.red.shl(this, e);
                    }, s.prototype.redMul = function(e) {
                        return n(this.red, "redMul works only with red numbers"), this.red._verify2(this, e), this.red.mul(this, e);
                    }, s.prototype.redIMul = function(e) {
                        return n(this.red, "redMul works only with red numbers"), this.red._verify2(this, e), this.red.imul(this, e);
                    }, s.prototype.redSqr = function() {
                        return n(this.red, "redSqr works only with red numbers"), this.red._verify1(this), this.red.sqr(this);
                    }, s.prototype.redISqr = function() {
                        return n(this.red, "redISqr works only with red numbers"), this.red._verify1(this), this.red.isqr(this);
                    }, s.prototype.redSqrt = function() {
                        return n(this.red, "redSqrt works only with red numbers"), this.red._verify1(this), this.red.sqrt(this);
                    }, s.prototype.redInvm = function() {
                        return n(this.red, "redInvm works only with red numbers"), this.red._verify1(this), this.red.invm(this);
                    }, s.prototype.redNeg = function() {
                        return n(this.red, "redNeg works only with red numbers"), this.red._verify1(this), this.red.neg(this);
                    }, s.prototype.redPow = function(e) {
                        return n(this.red && !e.red, "redPow(normalNum)"), this.red._verify1(this), this.red.pow(this, e);
                    };
                    var g = {
                        k256: null,
                        p224: null,
                        p192: null,
                        p25519: null
                    };
                    function y(e, t) {
                        this.name = e, this.p = new s(t, 16), this.n = this.p.bitLength(), this.k = new s(1).iushln(this.n).isub(this.p), this.tmp = this._tmp();
                    }
                    function v() {
                        y.call(this, "k256", "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f");
                    }
                    function w() {
                        y.call(this, "p224", "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001");
                    }
                    function _() {
                        y.call(this, "p192", "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff");
                    }
                    function x() {
                        y.call(this, "25519", "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed");
                    }
                    function k(e) {
                        if ("string" == typeof e) {
                            var t = s._prime(e);
                            this.m = t.p, this.prime = t;
                        } else n(e.gtn(1), "modulus must be greater than 1"), this.m = e, this.prime = null;
                    }
                    function S(e) {
                        k.call(this, e), this.shift = this.m.bitLength(), this.shift % 26 != 0 && (this.shift += 26 - this.shift % 26), this.r = new s(1).iushln(this.shift), this.r2 = this.imod(this.r.sqr()), this.rinv = this.r._invmp(this.m), this.minv = this.rinv.mul(this.r).isubn(1).div(this.m), this.minv = this.minv.umod(this.r), this.minv = this.r.sub(this.minv);
                    }
                    y.prototype._tmp = function() {
                        var e = new s(null);
                        return e.words = new Array(Math.ceil(this.n / 13)), e;
                    }, y.prototype.ireduce = function(e) {
                        var t, r = e;
                        do this.split(r, this.tmp), t = (r = (r = this.imulK(r)).iadd(this.tmp)).bitLength();
                        while (t > this.n);
                        var n = t < this.n ? -1 : r.ucmp(this.p);
                        return 0 === n ? (r.words[0] = 0, r.length = 1) : n > 0 ? r.isub(this.p) : void 0 !== r.strip ? r.strip() : r._strip(), r;
                    }, y.prototype.split = function(e, t) {
                        e.iushrn(this.n, 0, t);
                    }, y.prototype.imulK = function(e) {
                        return e.imul(this.k);
                    }, i(v, y), v.prototype.split = function(e, t) {
                        for(var r = Math.min(e.length, 9), n = 0; n < r; n++)t.words[n] = e.words[n];
                        if (t.length = r, e.length <= 9) return e.words[0] = 0, void (e.length = 1);
                        var i = e.words[9];
                        for(t.words[t.length++] = 4194303 & i, n = 10; n < e.length; n++){
                            var s = 0 | e.words[n];
                            e.words[n - 10] = (4194303 & s) << 4 | i >>> 22, i = s;
                        }
                        i >>>= 22, e.words[n - 10] = i, 0 === i && e.length > 10 ? e.length -= 10 : e.length -= 9;
                    }, v.prototype.imulK = function(e) {
                        e.words[e.length] = 0, e.words[e.length + 1] = 0, e.length += 2;
                        for(var t = 0, r = 0; r < e.length; r++){
                            var n = 0 | e.words[r];
                            t += 977 * n, e.words[r] = 67108863 & t, t = 64 * n + (t / 67108864 | 0);
                        }
                        return 0 === e.words[e.length - 1] && (e.length--, 0 === e.words[e.length - 1] && e.length--), e;
                    }, i(w, y), i(_, y), i(x, y), x.prototype.imulK = function(e) {
                        for(var t = 0, r = 0; r < e.length; r++){
                            var n = 19 * (0 | e.words[r]) + t, i = 67108863 & n;
                            n >>>= 26, e.words[r] = i, t = n;
                        }
                        return 0 !== t && (e.words[e.length++] = t), e;
                    }, s._prime = function(e) {
                        if (g[e]) return g[e];
                        var t;
                        if ("k256" === e) t = new v;
                        else if ("p224" === e) t = new w;
                        else if ("p192" === e) t = new _;
                        else {
                            if ("p25519" !== e) throw new Error("Unknown prime " + e);
                            t = new x;
                        }
                        return g[e] = t, t;
                    }, k.prototype._verify1 = function(e) {
                        n(0 === e.negative, "red works only with positives"), n(e.red, "red works only with red numbers");
                    }, k.prototype._verify2 = function(e, t) {
                        n(0 == (e.negative | t.negative), "red works only with positives"), n(e.red && e.red === t.red, "red works only with red numbers");
                    }, k.prototype.imod = function(e) {
                        return this.prime ? this.prime.ireduce(e)._forceRed(this) : e.umod(this.m)._forceRed(this);
                    }, k.prototype.neg = function(e) {
                        return e.isZero() ? e.clone() : this.m.sub(e)._forceRed(this);
                    }, k.prototype.add = function(e, t) {
                        this._verify2(e, t);
                        var r = e.add(t);
                        return r.cmp(this.m) >= 0 && r.isub(this.m), r._forceRed(this);
                    }, k.prototype.iadd = function(e, t) {
                        this._verify2(e, t);
                        var r = e.iadd(t);
                        return r.cmp(this.m) >= 0 && r.isub(this.m), r;
                    }, k.prototype.sub = function(e, t) {
                        this._verify2(e, t);
                        var r = e.sub(t);
                        return r.cmpn(0) < 0 && r.iadd(this.m), r._forceRed(this);
                    }, k.prototype.isub = function(e, t) {
                        this._verify2(e, t);
                        var r = e.isub(t);
                        return r.cmpn(0) < 0 && r.iadd(this.m), r;
                    }, k.prototype.shl = function(e, t) {
                        return this._verify1(e), this.imod(e.ushln(t));
                    }, k.prototype.imul = function(e, t) {
                        return this._verify2(e, t), this.imod(e.imul(t));
                    }, k.prototype.mul = function(e, t) {
                        return this._verify2(e, t), this.imod(e.mul(t));
                    }, k.prototype.isqr = function(e) {
                        return this.imul(e, e.clone());
                    }, k.prototype.sqr = function(e) {
                        return this.mul(e, e);
                    }, k.prototype.sqrt = function(e) {
                        if (e.isZero()) return e.clone();
                        var t = this.m.andln(3);
                        if (n(t % 2 == 1), 3 === t) {
                            var r = this.m.add(new s(1)).iushrn(2);
                            return this.pow(e, r);
                        }
                        for(var i = this.m.subn(1), o = 0; !i.isZero() && 0 === i.andln(1);)o++, i.iushrn(1);
                        n(!i.isZero());
                        var a = new s(1).toRed(this), l = a.redNeg(), c = this.m.subn(1).iushrn(1), u = this.m.bitLength();
                        for(u = new s(2 * u * u).toRed(this); 0 !== this.pow(u, c).cmp(l);)u.redIAdd(l);
                        for(var h = this.pow(u, i), f = this.pow(e, i.addn(1).iushrn(1)), d = this.pow(e, i), p = o; 0 !== d.cmp(a);){
                            for(var m = d, b = 0; 0 !== m.cmp(a); b++)m = m.redSqr();
                            n(b < p);
                            var g = this.pow(h, new s(1).iushln(p - b - 1));
                            f = f.redMul(g), h = g.redSqr(), d = d.redMul(h), p = b;
                        }
                        return f;
                    }, k.prototype.invm = function(e) {
                        var t = e._invmp(this.m);
                        return 0 !== t.negative ? (t.negative = 0, this.imod(t).redNeg()) : this.imod(t);
                    }, k.prototype.pow = function(e, t) {
                        if (t.isZero()) return new s(1).toRed(this);
                        if (0 === t.cmpn(1)) return e.clone();
                        var r = new Array(16);
                        r[0] = new s(1).toRed(this), r[1] = e;
                        for(var n = 2; n < r.length; n++)r[n] = this.mul(r[n - 1], e);
                        var i = r[0], o = 0, a = 0, l = t.bitLength() % 26;
                        for(0 === l && (l = 26), n = t.length - 1; n >= 0; n--){
                            for(var c = t.words[n], u = l - 1; u >= 0; u--){
                                var h = c >> u & 1;
                                i !== r[0] && (i = this.sqr(i)), 0 !== h || 0 !== o ? (o <<= 1, o |= h, (4 === ++a || 0 === n && 0 === u) && (i = this.mul(i, r[o]), a = 0, o = 0)) : a = 0;
                            }
                            l = 26;
                        }
                        return i;
                    }, k.prototype.convertTo = function(e) {
                        var t = e.umod(this.m);
                        return t === e ? t.clone() : t;
                    }, k.prototype.convertFrom = function(e) {
                        var t = e.clone();
                        return t.red = null, t;
                    }, s.mont = function(e) {
                        return new S(e);
                    }, i(S, k), S.prototype.convertTo = function(e) {
                        return this.imod(e.ushln(this.shift));
                    }, S.prototype.convertFrom = function(e) {
                        var t = this.imod(e.mul(this.rinv));
                        return t.red = null, t;
                    }, S.prototype.imul = function(e, t) {
                        if (e.isZero() || t.isZero()) return e.words[0] = 0, e.length = 1, e;
                        var r = e.imul(t), n = r.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m), i = r.isub(n).iushrn(this.shift), s = i;
                        return i.cmp(this.m) >= 0 ? s = i.isub(this.m) : i.cmpn(0) < 0 && (s = i.iadd(this.m)), s._forceRed(this);
                    }, S.prototype.mul = function(e, t) {
                        if (e.isZero() || t.isZero()) return new s(0)._forceRed(this);
                        var r = e.mul(t), n = r.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m), i = r.isub(n).iushrn(this.shift), o = i;
                        return i.cmp(this.m) >= 0 ? o = i.isub(this.m) : i.cmpn(0) < 0 && (o = i.iadd(this.m)), o._forceRed(this);
                    }, S.prototype.invm = function(e) {
                        return this.imod(e._invmp(this.m).mul(this.r2))._forceRed(this);
                    };
                }(void 0 === t || t);
            },
            {
                buffer: 188
            }
        ],
        185: [
            function(e, t, r) {
                "use strict";
                r.byteLength = function(e) {
                    var t = c(e), r = t[0], n = t[1];
                    return 3 * (r + n) / 4 - n;
                }, r.toByteArray = function(e) {
                    var t, r, n = c(e), o = n[0], a = n[1], l = new s(function(e, t, r) {
                        return 3 * (t + r) / 4 - r;
                    }(0, o, a)), u = 0, h = a > 0 ? o - 4 : o;
                    for(r = 0; r < h; r += 4)t = i[e.charCodeAt(r)] << 18 | i[e.charCodeAt(r + 1)] << 12 | i[e.charCodeAt(r + 2)] << 6 | i[e.charCodeAt(r + 3)], l[u++] = t >> 16 & 255, l[u++] = t >> 8 & 255, l[u++] = 255 & t;
                    2 === a && (t = i[e.charCodeAt(r)] << 2 | i[e.charCodeAt(r + 1)] >> 4, l[u++] = 255 & t);
                    1 === a && (t = i[e.charCodeAt(r)] << 10 | i[e.charCodeAt(r + 1)] << 4 | i[e.charCodeAt(r + 2)] >> 2, l[u++] = t >> 8 & 255, l[u++] = 255 & t);
                    return l;
                }, r.fromByteArray = function(e) {
                    for(var t, r = e.length, i = r % 3, s = [], o = 0, a = r - i; o < a; o += 16383)s.push(u(e, o, o + 16383 > a ? a : o + 16383));
                    1 === i ? (t = e[r - 1], s.push(n[t >> 2] + n[t << 4 & 63] + "==")) : 2 === i && (t = (e[r - 2] << 8) + e[r - 1], s.push(n[t >> 10] + n[t >> 4 & 63] + n[t << 2 & 63] + "="));
                    return s.join("");
                };
                for(var n = [], i = [], s = "undefined" != typeof Uint8Array ? Uint8Array : Array, o = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", a = 0, l = o.length; a < l; ++a)n[a] = o[a], i[o.charCodeAt(a)] = a;
                function c(e) {
                    var t = e.length;
                    if (t % 4 > 0) throw new Error("Invalid string. Length must be a multiple of 4");
                    var r = e.indexOf("=");
                    return -1 === r && (r = t), [
                        r,
                        r === t ? 0 : 4 - r % 4
                    ];
                }
                function u(e, t, r) {
                    for(var i, s, o = [], a = t; a < r; a += 3)i = (e[a] << 16 & 16711680) + (e[a + 1] << 8 & 65280) + (255 & e[a + 2]), o.push(n[(s = i) >> 18 & 63] + n[s >> 12 & 63] + n[s >> 6 & 63] + n[63 & s]);
                    return o.join("");
                }
                i["-".charCodeAt(0)] = 62, i["_".charCodeAt(0)] = 63;
            },
            {}
        ],
        186: [
            function(e, t, r) {
                "use strict";
                !function(t, r) {
                    function n(e, t) {
                        if (!e) throw new Error(t || "Assertion failed");
                    }
                    function i(e, t) {
                        e.super_ = t;
                        var r = function() {};
                        r.prototype = t.prototype, e.prototype = new r, e.prototype.constructor = e;
                    }
                    function s(e, t, r) {
                        if (s.isBN(e)) return e;
                        this.negative = 0, this.words = null, this.length = 0, this.red = null, null !== e && ("le" !== t && "be" !== t || (r = t, t = 10), this._init(e || 0, t || 10, r || "be"));
                    }
                    var o;
                    "object" == typeof t ? t.exports = s : (void 0).BN = s, s.BN = s, s.wordSize = 26;
                    try {
                        o = "undefined" != typeof window && void 0 !== window.Buffer ? window.Buffer : e("buffer").Buffer;
                    } catch (e) {}
                    function a(e, t) {
                        var r = e.charCodeAt(t);
                        return r >= 48 && r <= 57 ? r - 48 : r >= 65 && r <= 70 ? r - 55 : r >= 97 && r <= 102 ? r - 87 : void n(!1, "Invalid character in " + e);
                    }
                    function l(e, t, r) {
                        var n = a(e, r);
                        return r - 1 >= t && (n |= a(e, r - 1) << 4), n;
                    }
                    function c(e, t, r, i) {
                        for(var s = 0, o = 0, a = Math.min(e.length, r), l = t; l < a; l++){
                            var c = e.charCodeAt(l) - 48;
                            s *= i, o = c >= 49 ? c - 49 + 10 : c >= 17 ? c - 17 + 10 : c, n(c >= 0 && o < i, "Invalid character"), s += o;
                        }
                        return s;
                    }
                    function u(e, t) {
                        e.words = t.words, e.length = t.length, e.negative = t.negative, e.red = t.red;
                    }
                    if (s.isBN = function(e) {
                        return e instanceof s || null !== e && "object" == typeof e && e.constructor.wordSize === s.wordSize && Array.isArray(e.words);
                    }, s.max = function(e, t) {
                        return e.cmp(t) > 0 ? e : t;
                    }, s.min = function(e, t) {
                        return e.cmp(t) < 0 ? e : t;
                    }, s.prototype._init = function(e, t, r) {
                        if ("number" == typeof e) return this._initNumber(e, t, r);
                        if ("object" == typeof e) return this._initArray(e, t, r);
                        "hex" === t && (t = 16), n(t === (0 | t) && t >= 2 && t <= 36);
                        var i = 0;
                        "-" === (e = e.toString().replace(/\s+/g, ""))[0] && (i++, this.negative = 1), i < e.length && (16 === t ? this._parseHex(e, i, r) : (this._parseBase(e, t, i), "le" === r && this._initArray(this.toArray(), t, r)));
                    }, s.prototype._initNumber = function(e, t, r) {
                        e < 0 && (this.negative = 1, e = -e), e < 67108864 ? (this.words = [
                            67108863 & e
                        ], this.length = 1) : e < 4503599627370496 ? (this.words = [
                            67108863 & e,
                            e / 67108864 & 67108863
                        ], this.length = 2) : (n(e < 9007199254740992), this.words = [
                            67108863 & e,
                            e / 67108864 & 67108863,
                            1
                        ], this.length = 3), "le" === r && this._initArray(this.toArray(), t, r);
                    }, s.prototype._initArray = function(e, t, r) {
                        if (n("number" == typeof e.length), e.length <= 0) return this.words = [
                            0
                        ], this.length = 1, this;
                        this.length = Math.ceil(e.length / 3), this.words = new Array(this.length);
                        for(var i = 0; i < this.length; i++)this.words[i] = 0;
                        var s, o, a = 0;
                        if ("be" === r) for(i = e.length - 1, s = 0; i >= 0; i -= 3)o = e[i] | e[i - 1] << 8 | e[i - 2] << 16, this.words[s] |= o << a & 67108863, this.words[s + 1] = o >>> 26 - a & 67108863, (a += 24) >= 26 && (a -= 26, s++);
                        else if ("le" === r) for(i = 0, s = 0; i < e.length; i += 3)o = e[i] | e[i + 1] << 8 | e[i + 2] << 16, this.words[s] |= o << a & 67108863, this.words[s + 1] = o >>> 26 - a & 67108863, (a += 24) >= 26 && (a -= 26, s++);
                        return this._strip();
                    }, s.prototype._parseHex = function(e, t, r) {
                        this.length = Math.ceil((e.length - t) / 6), this.words = new Array(this.length);
                        for(var n = 0; n < this.length; n++)this.words[n] = 0;
                        var i, s = 0, o = 0;
                        if ("be" === r) for(n = e.length - 1; n >= t; n -= 2)i = l(e, t, n) << s, this.words[o] |= 67108863 & i, s >= 18 ? (s -= 18, o += 1, this.words[o] |= i >>> 26) : s += 8;
                        else for(n = (e.length - t) % 2 == 0 ? t + 1 : t; n < e.length; n += 2)i = l(e, t, n) << s, this.words[o] |= 67108863 & i, s >= 18 ? (s -= 18, o += 1, this.words[o] |= i >>> 26) : s += 8;
                        this._strip();
                    }, s.prototype._parseBase = function(e, t, r) {
                        this.words = [
                            0
                        ], this.length = 1;
                        for(var n = 0, i = 1; i <= 67108863; i *= t)n++;
                        n--, i = i / t | 0;
                        for(var s = e.length - r, o = s % n, a = Math.min(s, s - o) + r, l = 0, u = r; u < a; u += n)l = c(e, u, u + n, t), this.imuln(i), this.words[0] + l < 67108864 ? this.words[0] += l : this._iaddn(l);
                        if (0 !== o) {
                            var h = 1;
                            for(l = c(e, u, e.length, t), u = 0; u < o; u++)h *= t;
                            this.imuln(h), this.words[0] + l < 67108864 ? this.words[0] += l : this._iaddn(l);
                        }
                        this._strip();
                    }, s.prototype.copy = function(e) {
                        e.words = new Array(this.length);
                        for(var t = 0; t < this.length; t++)e.words[t] = this.words[t];
                        e.length = this.length, e.negative = this.negative, e.red = this.red;
                    }, s.prototype._move = function(e) {
                        u(e, this);
                    }, s.prototype.clone = function() {
                        var e = new s(null);
                        return this.copy(e), e;
                    }, s.prototype._expand = function(e) {
                        for(; this.length < e;)this.words[this.length++] = 0;
                        return this;
                    }, s.prototype._strip = function() {
                        for(; this.length > 1 && 0 === this.words[this.length - 1];)this.length--;
                        return this._normSign();
                    }, s.prototype._normSign = function() {
                        return 1 === this.length && 0 === this.words[0] && (this.negative = 0), this;
                    }, "undefined" != typeof Symbol && "function" == typeof Symbol.for) try {
                        s.prototype[Symbol.for("nodejs.util.inspect.custom")] = h;
                    } catch (e) {
                        s.prototype.inspect = h;
                    }
                    else s.prototype.inspect = h;
                    function h() {
                        return (this.red ? "<BN-R: " : "<BN: ") + this.toString(16) + ">";
                    }
                    var f = [
                        "",
                        "0",
                        "00",
                        "000",
                        "0000",
                        "00000",
                        "000000",
                        "0000000",
                        "00000000",
                        "000000000",
                        "0000000000",
                        "00000000000",
                        "000000000000",
                        "0000000000000",
                        "00000000000000",
                        "000000000000000",
                        "0000000000000000",
                        "00000000000000000",
                        "000000000000000000",
                        "0000000000000000000",
                        "00000000000000000000",
                        "000000000000000000000",
                        "0000000000000000000000",
                        "00000000000000000000000",
                        "000000000000000000000000",
                        "0000000000000000000000000"
                    ], d = [
                        0,
                        0,
                        25,
                        16,
                        12,
                        11,
                        10,
                        9,
                        8,
                        8,
                        7,
                        7,
                        7,
                        7,
                        6,
                        6,
                        6,
                        6,
                        6,
                        6,
                        6,
                        5,
                        5,
                        5,
                        5,
                        5,
                        5,
                        5,
                        5,
                        5,
                        5,
                        5,
                        5,
                        5,
                        5,
                        5,
                        5
                    ], p = [
                        0,
                        0,
                        33554432,
                        43046721,
                        16777216,
                        48828125,
                        60466176,
                        40353607,
                        16777216,
                        43046721,
                        1e7,
                        19487171,
                        35831808,
                        62748517,
                        7529536,
                        11390625,
                        16777216,
                        24137569,
                        34012224,
                        47045881,
                        64e6,
                        4084101,
                        5153632,
                        6436343,
                        7962624,
                        9765625,
                        11881376,
                        14348907,
                        17210368,
                        20511149,
                        243e5,
                        28629151,
                        33554432,
                        39135393,
                        45435424,
                        52521875,
                        60466176
                    ];
                    s.prototype.toString = function(e, t) {
                        var r;
                        if (t = 0 | t || 1, 16 === (e = e || 10) || "hex" === e) {
                            r = "";
                            for(var i = 0, s = 0, o = 0; o < this.length; o++){
                                var a = this.words[o], l = (16777215 & (a << i | s)).toString(16);
                                s = a >>> 24 - i & 16777215, (i += 2) >= 26 && (i -= 26, o--), r = 0 !== s || o !== this.length - 1 ? f[6 - l.length] + l + r : l + r;
                            }
                            for(0 !== s && (r = s.toString(16) + r); r.length % t != 0;)r = "0" + r;
                            return 0 !== this.negative && (r = "-" + r), r;
                        }
                        if (e === (0 | e) && e >= 2 && e <= 36) {
                            var c = d[e], u = p[e];
                            r = "";
                            var h = this.clone();
                            for(h.negative = 0; !h.isZero();){
                                var m = h.modrn(u).toString(e);
                                r = (h = h.idivn(u)).isZero() ? m + r : f[c - m.length] + m + r;
                            }
                            for(this.isZero() && (r = "0" + r); r.length % t != 0;)r = "0" + r;
                            return 0 !== this.negative && (r = "-" + r), r;
                        }
                        n(!1, "Base should be between 2 and 36");
                    }, s.prototype.toNumber = function() {
                        var e = this.words[0];
                        return 2 === this.length ? e += 67108864 * this.words[1] : 3 === this.length && 1 === this.words[2] ? e += 4503599627370496 + 67108864 * this.words[1] : this.length > 2 && n(!1, "Number can only safely store up to 53 bits"), 0 !== this.negative ? -e : e;
                    }, s.prototype.toJSON = function() {
                        return this.toString(16, 2);
                    }, o && (s.prototype.toBuffer = function(e, t) {
                        return this.toArrayLike(o, e, t);
                    }), s.prototype.toArray = function(e, t) {
                        return this.toArrayLike(Array, e, t);
                    };
                    function m(e, t, r) {
                        r.negative = t.negative ^ e.negative;
                        var n = e.length + t.length | 0;
                        r.length = n, n = n - 1 | 0;
                        var i = 0 | e.words[0], s = 0 | t.words[0], o = i * s, a = 67108863 & o, l = o / 67108864 | 0;
                        r.words[0] = a;
                        for(var c = 1; c < n; c++){
                            for(var u = l >>> 26, h = 67108863 & l, f = Math.min(c, t.length - 1), d = Math.max(0, c - e.length + 1); d <= f; d++){
                                var p = c - d | 0;
                                u += (o = (i = 0 | e.words[p]) * (s = 0 | t.words[d]) + h) / 67108864 | 0, h = 67108863 & o;
                            }
                            r.words[c] = 0 | h, l = 0 | u;
                        }
                        return 0 !== l ? r.words[c] = 0 | l : r.length--, r._strip();
                    }
                    s.prototype.toArrayLike = function(e, t, r) {
                        this._strip();
                        var i = this.byteLength(), s = r || Math.max(1, i);
                        n(i <= s, "byte array longer than desired length"), n(s > 0, "Requested array length <= 0");
                        var o = function(e, t) {
                            return e.allocUnsafe ? e.allocUnsafe(t) : new e(t);
                        }(e, s);
                        return this["_toArrayLike" + ("le" === t ? "LE" : "BE")](o, i), o;
                    }, s.prototype._toArrayLikeLE = function(e, t) {
                        for(var r = 0, n = 0, i = 0, s = 0; i < this.length; i++){
                            var o = this.words[i] << s | n;
                            e[r++] = 255 & o, r < e.length && (e[r++] = o >> 8 & 255), r < e.length && (e[r++] = o >> 16 & 255), 6 === s ? (r < e.length && (e[r++] = o >> 24 & 255), n = 0, s = 0) : (n = o >>> 24, s += 2);
                        }
                        if (r < e.length) for(e[r++] = n; r < e.length;)e[r++] = 0;
                    }, s.prototype._toArrayLikeBE = function(e, t) {
                        for(var r = e.length - 1, n = 0, i = 0, s = 0; i < this.length; i++){
                            var o = this.words[i] << s | n;
                            e[r--] = 255 & o, r >= 0 && (e[r--] = o >> 8 & 255), r >= 0 && (e[r--] = o >> 16 & 255), 6 === s ? (r >= 0 && (e[r--] = o >> 24 & 255), n = 0, s = 0) : (n = o >>> 24, s += 2);
                        }
                        if (r >= 0) for(e[r--] = n; r >= 0;)e[r--] = 0;
                    }, Math.clz32 ? s.prototype._countBits = function(e) {
                        return 32 - Math.clz32(e);
                    } : s.prototype._countBits = function(e) {
                        var t = e, r = 0;
                        return t >= 4096 && (r += 13, t >>>= 13), t >= 64 && (r += 7, t >>>= 7), t >= 8 && (r += 4, t >>>= 4), t >= 2 && (r += 2, t >>>= 2), r + t;
                    }, s.prototype._zeroBits = function(e) {
                        if (0 === e) return 26;
                        var t = e, r = 0;
                        return 0 == (8191 & t) && (r += 13, t >>>= 13), 0 == (127 & t) && (r += 7, t >>>= 7), 0 == (15 & t) && (r += 4, t >>>= 4), 0 == (3 & t) && (r += 2, t >>>= 2), 0 == (1 & t) && r++, r;
                    }, s.prototype.bitLength = function() {
                        var e = this.words[this.length - 1], t = this._countBits(e);
                        return 26 * (this.length - 1) + t;
                    }, s.prototype.zeroBits = function() {
                        if (this.isZero()) return 0;
                        for(var e = 0, t = 0; t < this.length; t++){
                            var r = this._zeroBits(this.words[t]);
                            if (e += r, 26 !== r) break;
                        }
                        return e;
                    }, s.prototype.byteLength = function() {
                        return Math.ceil(this.bitLength() / 8);
                    }, s.prototype.toTwos = function(e) {
                        return 0 !== this.negative ? this.abs().inotn(e).iaddn(1) : this.clone();
                    }, s.prototype.fromTwos = function(e) {
                        return this.testn(e - 1) ? this.notn(e).iaddn(1).ineg() : this.clone();
                    }, s.prototype.isNeg = function() {
                        return 0 !== this.negative;
                    }, s.prototype.neg = function() {
                        return this.clone().ineg();
                    }, s.prototype.ineg = function() {
                        return this.isZero() || (this.negative ^= 1), this;
                    }, s.prototype.iuor = function(e) {
                        for(; this.length < e.length;)this.words[this.length++] = 0;
                        for(var t = 0; t < e.length; t++)this.words[t] = this.words[t] | e.words[t];
                        return this._strip();
                    }, s.prototype.ior = function(e) {
                        return n(0 == (this.negative | e.negative)), this.iuor(e);
                    }, s.prototype.or = function(e) {
                        return this.length > e.length ? this.clone().ior(e) : e.clone().ior(this);
                    }, s.prototype.uor = function(e) {
                        return this.length > e.length ? this.clone().iuor(e) : e.clone().iuor(this);
                    }, s.prototype.iuand = function(e) {
                        var t;
                        t = this.length > e.length ? e : this;
                        for(var r = 0; r < t.length; r++)this.words[r] = this.words[r] & e.words[r];
                        return this.length = t.length, this._strip();
                    }, s.prototype.iand = function(e) {
                        return n(0 == (this.negative | e.negative)), this.iuand(e);
                    }, s.prototype.and = function(e) {
                        return this.length > e.length ? this.clone().iand(e) : e.clone().iand(this);
                    }, s.prototype.uand = function(e) {
                        return this.length > e.length ? this.clone().iuand(e) : e.clone().iuand(this);
                    }, s.prototype.iuxor = function(e) {
                        var t, r;
                        this.length > e.length ? (t = this, r = e) : (t = e, r = this);
                        for(var n = 0; n < r.length; n++)this.words[n] = t.words[n] ^ r.words[n];
                        if (this !== t) for(; n < t.length; n++)this.words[n] = t.words[n];
                        return this.length = t.length, this._strip();
                    }, s.prototype.ixor = function(e) {
                        return n(0 == (this.negative | e.negative)), this.iuxor(e);
                    }, s.prototype.xor = function(e) {
                        return this.length > e.length ? this.clone().ixor(e) : e.clone().ixor(this);
                    }, s.prototype.uxor = function(e) {
                        return this.length > e.length ? this.clone().iuxor(e) : e.clone().iuxor(this);
                    }, s.prototype.inotn = function(e) {
                        n("number" == typeof e && e >= 0);
                        var t = 0 | Math.ceil(e / 26), r = e % 26;
                        this._expand(t), r > 0 && t--;
                        for(var i = 0; i < t; i++)this.words[i] = 67108863 & ~this.words[i];
                        return r > 0 && (this.words[i] = ~this.words[i] & 67108863 >> 26 - r), this._strip();
                    }, s.prototype.notn = function(e) {
                        return this.clone().inotn(e);
                    }, s.prototype.setn = function(e, t) {
                        n("number" == typeof e && e >= 0);
                        var r = e / 26 | 0, i = e % 26;
                        return this._expand(r + 1), this.words[r] = t ? this.words[r] | 1 << i : this.words[r] & ~(1 << i), this._strip();
                    }, s.prototype.iadd = function(e) {
                        var t, r, n;
                        if (0 !== this.negative && 0 === e.negative) return this.negative = 0, t = this.isub(e), this.negative ^= 1, this._normSign();
                        if (0 === this.negative && 0 !== e.negative) return e.negative = 0, t = this.isub(e), e.negative = 1, t._normSign();
                        this.length > e.length ? (r = this, n = e) : (r = e, n = this);
                        for(var i = 0, s = 0; s < n.length; s++)t = (0 | r.words[s]) + (0 | n.words[s]) + i, this.words[s] = 67108863 & t, i = t >>> 26;
                        for(; 0 !== i && s < r.length; s++)t = (0 | r.words[s]) + i, this.words[s] = 67108863 & t, i = t >>> 26;
                        if (this.length = r.length, 0 !== i) this.words[this.length] = i, this.length++;
                        else if (r !== this) for(; s < r.length; s++)this.words[s] = r.words[s];
                        return this;
                    }, s.prototype.add = function(e) {
                        var t;
                        return 0 !== e.negative && 0 === this.negative ? (e.negative = 0, t = this.sub(e), e.negative ^= 1, t) : 0 === e.negative && 0 !== this.negative ? (this.negative = 0, t = e.sub(this), this.negative = 1, t) : this.length > e.length ? this.clone().iadd(e) : e.clone().iadd(this);
                    }, s.prototype.isub = function(e) {
                        if (0 !== e.negative) {
                            e.negative = 0;
                            var t = this.iadd(e);
                            return e.negative = 1, t._normSign();
                        }
                        if (0 !== this.negative) return this.negative = 0, this.iadd(e), this.negative = 1, this._normSign();
                        var r, n, i = this.cmp(e);
                        if (0 === i) return this.negative = 0, this.length = 1, this.words[0] = 0, this;
                        i > 0 ? (r = this, n = e) : (r = e, n = this);
                        for(var s = 0, o = 0; o < n.length; o++)s = (t = (0 | r.words[o]) - (0 | n.words[o]) + s) >> 26, this.words[o] = 67108863 & t;
                        for(; 0 !== s && o < r.length; o++)s = (t = (0 | r.words[o]) + s) >> 26, this.words[o] = 67108863 & t;
                        if (0 === s && o < r.length && r !== this) for(; o < r.length; o++)this.words[o] = r.words[o];
                        return this.length = Math.max(this.length, o), r !== this && (this.negative = 1), this._strip();
                    }, s.prototype.sub = function(e) {
                        return this.clone().isub(e);
                    };
                    var b = function(e, t, r) {
                        var n, i, s, o = e.words, a = t.words, l = r.words, c = 0, u = 0 | o[0], h = 8191 & u, f = u >>> 13, d = 0 | o[1], p = 8191 & d, m = d >>> 13, b = 0 | o[2], g = 8191 & b, y = b >>> 13, v = 0 | o[3], w = 8191 & v, _ = v >>> 13, x = 0 | o[4], k = 8191 & x, S = x >>> 13, M = 0 | o[5], C = 8191 & M, T = M >>> 13, E = 0 | o[6], A = 8191 & E, R = E >>> 13, O = 0 | o[7], j = 8191 & O, I = O >>> 13, N = 0 | o[8], P = 8191 & N, B = N >>> 13, D = 0 | o[9], F = 8191 & D, L = D >>> 13, z = 0 | a[0], U = 8191 & z, $ = z >>> 13, H = 0 | a[1], V = 8191 & H, q = H >>> 13, W = 0 | a[2], X = 8191 & W, K = W >>> 13, Y = 0 | a[3], Z = 8191 & Y, G = Y >>> 13, J = 0 | a[4], Q = 8191 & J, ee = J >>> 13, te = 0 | a[5], re = 8191 & te, ne = te >>> 13, ie = 0 | a[6], se = 8191 & ie, oe = ie >>> 13, ae = 0 | a[7], le = 8191 & ae, ce = ae >>> 13, ue = 0 | a[8], he = 8191 & ue, fe = ue >>> 13, de = 0 | a[9], pe = 8191 & de, me = de >>> 13;
                        r.negative = e.negative ^ t.negative, r.length = 19;
                        var be = (c + (n = Math.imul(h, U)) | 0) + ((8191 & (i = (i = Math.imul(h, $)) + Math.imul(f, U) | 0)) << 13) | 0;
                        c = ((s = Math.imul(f, $)) + (i >>> 13) | 0) + (be >>> 26) | 0, be &= 67108863, n = Math.imul(p, U), i = (i = Math.imul(p, $)) + Math.imul(m, U) | 0, s = Math.imul(m, $);
                        var ge = (c + (n = n + Math.imul(h, V) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(h, q) | 0) + Math.imul(f, V) | 0)) << 13) | 0;
                        c = ((s = s + Math.imul(f, q) | 0) + (i >>> 13) | 0) + (ge >>> 26) | 0, ge &= 67108863, n = Math.imul(g, U), i = (i = Math.imul(g, $)) + Math.imul(y, U) | 0, s = Math.imul(y, $), n = n + Math.imul(p, V) | 0, i = (i = i + Math.imul(p, q) | 0) + Math.imul(m, V) | 0, s = s + Math.imul(m, q) | 0;
                        var ye = (c + (n = n + Math.imul(h, X) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(h, K) | 0) + Math.imul(f, X) | 0)) << 13) | 0;
                        c = ((s = s + Math.imul(f, K) | 0) + (i >>> 13) | 0) + (ye >>> 26) | 0, ye &= 67108863, n = Math.imul(w, U), i = (i = Math.imul(w, $)) + Math.imul(_, U) | 0, s = Math.imul(_, $), n = n + Math.imul(g, V) | 0, i = (i = i + Math.imul(g, q) | 0) + Math.imul(y, V) | 0, s = s + Math.imul(y, q) | 0, n = n + Math.imul(p, X) | 0, i = (i = i + Math.imul(p, K) | 0) + Math.imul(m, X) | 0, s = s + Math.imul(m, K) | 0;
                        var ve = (c + (n = n + Math.imul(h, Z) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(h, G) | 0) + Math.imul(f, Z) | 0)) << 13) | 0;
                        c = ((s = s + Math.imul(f, G) | 0) + (i >>> 13) | 0) + (ve >>> 26) | 0, ve &= 67108863, n = Math.imul(k, U), i = (i = Math.imul(k, $)) + Math.imul(S, U) | 0, s = Math.imul(S, $), n = n + Math.imul(w, V) | 0, i = (i = i + Math.imul(w, q) | 0) + Math.imul(_, V) | 0, s = s + Math.imul(_, q) | 0, n = n + Math.imul(g, X) | 0, i = (i = i + Math.imul(g, K) | 0) + Math.imul(y, X) | 0, s = s + Math.imul(y, K) | 0, n = n + Math.imul(p, Z) | 0, i = (i = i + Math.imul(p, G) | 0) + Math.imul(m, Z) | 0, s = s + Math.imul(m, G) | 0;
                        var we = (c + (n = n + Math.imul(h, Q) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(h, ee) | 0) + Math.imul(f, Q) | 0)) << 13) | 0;
                        c = ((s = s + Math.imul(f, ee) | 0) + (i >>> 13) | 0) + (we >>> 26) | 0, we &= 67108863, n = Math.imul(C, U), i = (i = Math.imul(C, $)) + Math.imul(T, U) | 0, s = Math.imul(T, $), n = n + Math.imul(k, V) | 0, i = (i = i + Math.imul(k, q) | 0) + Math.imul(S, V) | 0, s = s + Math.imul(S, q) | 0, n = n + Math.imul(w, X) | 0, i = (i = i + Math.imul(w, K) | 0) + Math.imul(_, X) | 0, s = s + Math.imul(_, K) | 0, n = n + Math.imul(g, Z) | 0, i = (i = i + Math.imul(g, G) | 0) + Math.imul(y, Z) | 0, s = s + Math.imul(y, G) | 0, n = n + Math.imul(p, Q) | 0, i = (i = i + Math.imul(p, ee) | 0) + Math.imul(m, Q) | 0, s = s + Math.imul(m, ee) | 0;
                        var _e = (c + (n = n + Math.imul(h, re) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(h, ne) | 0) + Math.imul(f, re) | 0)) << 13) | 0;
                        c = ((s = s + Math.imul(f, ne) | 0) + (i >>> 13) | 0) + (_e >>> 26) | 0, _e &= 67108863, n = Math.imul(A, U), i = (i = Math.imul(A, $)) + Math.imul(R, U) | 0, s = Math.imul(R, $), n = n + Math.imul(C, V) | 0, i = (i = i + Math.imul(C, q) | 0) + Math.imul(T, V) | 0, s = s + Math.imul(T, q) | 0, n = n + Math.imul(k, X) | 0, i = (i = i + Math.imul(k, K) | 0) + Math.imul(S, X) | 0, s = s + Math.imul(S, K) | 0, n = n + Math.imul(w, Z) | 0, i = (i = i + Math.imul(w, G) | 0) + Math.imul(_, Z) | 0, s = s + Math.imul(_, G) | 0, n = n + Math.imul(g, Q) | 0, i = (i = i + Math.imul(g, ee) | 0) + Math.imul(y, Q) | 0, s = s + Math.imul(y, ee) | 0, n = n + Math.imul(p, re) | 0, i = (i = i + Math.imul(p, ne) | 0) + Math.imul(m, re) | 0, s = s + Math.imul(m, ne) | 0;
                        var xe = (c + (n = n + Math.imul(h, se) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(h, oe) | 0) + Math.imul(f, se) | 0)) << 13) | 0;
                        c = ((s = s + Math.imul(f, oe) | 0) + (i >>> 13) | 0) + (xe >>> 26) | 0, xe &= 67108863, n = Math.imul(j, U), i = (i = Math.imul(j, $)) + Math.imul(I, U) | 0, s = Math.imul(I, $), n = n + Math.imul(A, V) | 0, i = (i = i + Math.imul(A, q) | 0) + Math.imul(R, V) | 0, s = s + Math.imul(R, q) | 0, n = n + Math.imul(C, X) | 0, i = (i = i + Math.imul(C, K) | 0) + Math.imul(T, X) | 0, s = s + Math.imul(T, K) | 0, n = n + Math.imul(k, Z) | 0, i = (i = i + Math.imul(k, G) | 0) + Math.imul(S, Z) | 0, s = s + Math.imul(S, G) | 0, n = n + Math.imul(w, Q) | 0, i = (i = i + Math.imul(w, ee) | 0) + Math.imul(_, Q) | 0, s = s + Math.imul(_, ee) | 0, n = n + Math.imul(g, re) | 0, i = (i = i + Math.imul(g, ne) | 0) + Math.imul(y, re) | 0, s = s + Math.imul(y, ne) | 0, n = n + Math.imul(p, se) | 0, i = (i = i + Math.imul(p, oe) | 0) + Math.imul(m, se) | 0, s = s + Math.imul(m, oe) | 0;
                        var ke = (c + (n = n + Math.imul(h, le) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(h, ce) | 0) + Math.imul(f, le) | 0)) << 13) | 0;
                        c = ((s = s + Math.imul(f, ce) | 0) + (i >>> 13) | 0) + (ke >>> 26) | 0, ke &= 67108863, n = Math.imul(P, U), i = (i = Math.imul(P, $)) + Math.imul(B, U) | 0, s = Math.imul(B, $), n = n + Math.imul(j, V) | 0, i = (i = i + Math.imul(j, q) | 0) + Math.imul(I, V) | 0, s = s + Math.imul(I, q) | 0, n = n + Math.imul(A, X) | 0, i = (i = i + Math.imul(A, K) | 0) + Math.imul(R, X) | 0, s = s + Math.imul(R, K) | 0, n = n + Math.imul(C, Z) | 0, i = (i = i + Math.imul(C, G) | 0) + Math.imul(T, Z) | 0, s = s + Math.imul(T, G) | 0, n = n + Math.imul(k, Q) | 0, i = (i = i + Math.imul(k, ee) | 0) + Math.imul(S, Q) | 0, s = s + Math.imul(S, ee) | 0, n = n + Math.imul(w, re) | 0, i = (i = i + Math.imul(w, ne) | 0) + Math.imul(_, re) | 0, s = s + Math.imul(_, ne) | 0, n = n + Math.imul(g, se) | 0, i = (i = i + Math.imul(g, oe) | 0) + Math.imul(y, se) | 0, s = s + Math.imul(y, oe) | 0, n = n + Math.imul(p, le) | 0, i = (i = i + Math.imul(p, ce) | 0) + Math.imul(m, le) | 0, s = s + Math.imul(m, ce) | 0;
                        var Se = (c + (n = n + Math.imul(h, he) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(h, fe) | 0) + Math.imul(f, he) | 0)) << 13) | 0;
                        c = ((s = s + Math.imul(f, fe) | 0) + (i >>> 13) | 0) + (Se >>> 26) | 0, Se &= 67108863, n = Math.imul(F, U), i = (i = Math.imul(F, $)) + Math.imul(L, U) | 0, s = Math.imul(L, $), n = n + Math.imul(P, V) | 0, i = (i = i + Math.imul(P, q) | 0) + Math.imul(B, V) | 0, s = s + Math.imul(B, q) | 0, n = n + Math.imul(j, X) | 0, i = (i = i + Math.imul(j, K) | 0) + Math.imul(I, X) | 0, s = s + Math.imul(I, K) | 0, n = n + Math.imul(A, Z) | 0, i = (i = i + Math.imul(A, G) | 0) + Math.imul(R, Z) | 0, s = s + Math.imul(R, G) | 0, n = n + Math.imul(C, Q) | 0, i = (i = i + Math.imul(C, ee) | 0) + Math.imul(T, Q) | 0, s = s + Math.imul(T, ee) | 0, n = n + Math.imul(k, re) | 0, i = (i = i + Math.imul(k, ne) | 0) + Math.imul(S, re) | 0, s = s + Math.imul(S, ne) | 0, n = n + Math.imul(w, se) | 0, i = (i = i + Math.imul(w, oe) | 0) + Math.imul(_, se) | 0, s = s + Math.imul(_, oe) | 0, n = n + Math.imul(g, le) | 0, i = (i = i + Math.imul(g, ce) | 0) + Math.imul(y, le) | 0, s = s + Math.imul(y, ce) | 0, n = n + Math.imul(p, he) | 0, i = (i = i + Math.imul(p, fe) | 0) + Math.imul(m, he) | 0, s = s + Math.imul(m, fe) | 0;
                        var Me = (c + (n = n + Math.imul(h, pe) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(h, me) | 0) + Math.imul(f, pe) | 0)) << 13) | 0;
                        c = ((s = s + Math.imul(f, me) | 0) + (i >>> 13) | 0) + (Me >>> 26) | 0, Me &= 67108863, n = Math.imul(F, V), i = (i = Math.imul(F, q)) + Math.imul(L, V) | 0, s = Math.imul(L, q), n = n + Math.imul(P, X) | 0, i = (i = i + Math.imul(P, K) | 0) + Math.imul(B, X) | 0, s = s + Math.imul(B, K) | 0, n = n + Math.imul(j, Z) | 0, i = (i = i + Math.imul(j, G) | 0) + Math.imul(I, Z) | 0, s = s + Math.imul(I, G) | 0, n = n + Math.imul(A, Q) | 0, i = (i = i + Math.imul(A, ee) | 0) + Math.imul(R, Q) | 0, s = s + Math.imul(R, ee) | 0, n = n + Math.imul(C, re) | 0, i = (i = i + Math.imul(C, ne) | 0) + Math.imul(T, re) | 0, s = s + Math.imul(T, ne) | 0, n = n + Math.imul(k, se) | 0, i = (i = i + Math.imul(k, oe) | 0) + Math.imul(S, se) | 0, s = s + Math.imul(S, oe) | 0, n = n + Math.imul(w, le) | 0, i = (i = i + Math.imul(w, ce) | 0) + Math.imul(_, le) | 0, s = s + Math.imul(_, ce) | 0, n = n + Math.imul(g, he) | 0, i = (i = i + Math.imul(g, fe) | 0) + Math.imul(y, he) | 0, s = s + Math.imul(y, fe) | 0;
                        var Ce = (c + (n = n + Math.imul(p, pe) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(p, me) | 0) + Math.imul(m, pe) | 0)) << 13) | 0;
                        c = ((s = s + Math.imul(m, me) | 0) + (i >>> 13) | 0) + (Ce >>> 26) | 0, Ce &= 67108863, n = Math.imul(F, X), i = (i = Math.imul(F, K)) + Math.imul(L, X) | 0, s = Math.imul(L, K), n = n + Math.imul(P, Z) | 0, i = (i = i + Math.imul(P, G) | 0) + Math.imul(B, Z) | 0, s = s + Math.imul(B, G) | 0, n = n + Math.imul(j, Q) | 0, i = (i = i + Math.imul(j, ee) | 0) + Math.imul(I, Q) | 0, s = s + Math.imul(I, ee) | 0, n = n + Math.imul(A, re) | 0, i = (i = i + Math.imul(A, ne) | 0) + Math.imul(R, re) | 0, s = s + Math.imul(R, ne) | 0, n = n + Math.imul(C, se) | 0, i = (i = i + Math.imul(C, oe) | 0) + Math.imul(T, se) | 0, s = s + Math.imul(T, oe) | 0, n = n + Math.imul(k, le) | 0, i = (i = i + Math.imul(k, ce) | 0) + Math.imul(S, le) | 0, s = s + Math.imul(S, ce) | 0, n = n + Math.imul(w, he) | 0, i = (i = i + Math.imul(w, fe) | 0) + Math.imul(_, he) | 0, s = s + Math.imul(_, fe) | 0;
                        var Te = (c + (n = n + Math.imul(g, pe) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(g, me) | 0) + Math.imul(y, pe) | 0)) << 13) | 0;
                        c = ((s = s + Math.imul(y, me) | 0) + (i >>> 13) | 0) + (Te >>> 26) | 0, Te &= 67108863, n = Math.imul(F, Z), i = (i = Math.imul(F, G)) + Math.imul(L, Z) | 0, s = Math.imul(L, G), n = n + Math.imul(P, Q) | 0, i = (i = i + Math.imul(P, ee) | 0) + Math.imul(B, Q) | 0, s = s + Math.imul(B, ee) | 0, n = n + Math.imul(j, re) | 0, i = (i = i + Math.imul(j, ne) | 0) + Math.imul(I, re) | 0, s = s + Math.imul(I, ne) | 0, n = n + Math.imul(A, se) | 0, i = (i = i + Math.imul(A, oe) | 0) + Math.imul(R, se) | 0, s = s + Math.imul(R, oe) | 0, n = n + Math.imul(C, le) | 0, i = (i = i + Math.imul(C, ce) | 0) + Math.imul(T, le) | 0, s = s + Math.imul(T, ce) | 0, n = n + Math.imul(k, he) | 0, i = (i = i + Math.imul(k, fe) | 0) + Math.imul(S, he) | 0, s = s + Math.imul(S, fe) | 0;
                        var Ee = (c + (n = n + Math.imul(w, pe) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(w, me) | 0) + Math.imul(_, pe) | 0)) << 13) | 0;
                        c = ((s = s + Math.imul(_, me) | 0) + (i >>> 13) | 0) + (Ee >>> 26) | 0, Ee &= 67108863, n = Math.imul(F, Q), i = (i = Math.imul(F, ee)) + Math.imul(L, Q) | 0, s = Math.imul(L, ee), n = n + Math.imul(P, re) | 0, i = (i = i + Math.imul(P, ne) | 0) + Math.imul(B, re) | 0, s = s + Math.imul(B, ne) | 0, n = n + Math.imul(j, se) | 0, i = (i = i + Math.imul(j, oe) | 0) + Math.imul(I, se) | 0, s = s + Math.imul(I, oe) | 0, n = n + Math.imul(A, le) | 0, i = (i = i + Math.imul(A, ce) | 0) + Math.imul(R, le) | 0, s = s + Math.imul(R, ce) | 0, n = n + Math.imul(C, he) | 0, i = (i = i + Math.imul(C, fe) | 0) + Math.imul(T, he) | 0, s = s + Math.imul(T, fe) | 0;
                        var Ae = (c + (n = n + Math.imul(k, pe) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(k, me) | 0) + Math.imul(S, pe) | 0)) << 13) | 0;
                        c = ((s = s + Math.imul(S, me) | 0) + (i >>> 13) | 0) + (Ae >>> 26) | 0, Ae &= 67108863, n = Math.imul(F, re), i = (i = Math.imul(F, ne)) + Math.imul(L, re) | 0, s = Math.imul(L, ne), n = n + Math.imul(P, se) | 0, i = (i = i + Math.imul(P, oe) | 0) + Math.imul(B, se) | 0, s = s + Math.imul(B, oe) | 0, n = n + Math.imul(j, le) | 0, i = (i = i + Math.imul(j, ce) | 0) + Math.imul(I, le) | 0, s = s + Math.imul(I, ce) | 0, n = n + Math.imul(A, he) | 0, i = (i = i + Math.imul(A, fe) | 0) + Math.imul(R, he) | 0, s = s + Math.imul(R, fe) | 0;
                        var Re = (c + (n = n + Math.imul(C, pe) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(C, me) | 0) + Math.imul(T, pe) | 0)) << 13) | 0;
                        c = ((s = s + Math.imul(T, me) | 0) + (i >>> 13) | 0) + (Re >>> 26) | 0, Re &= 67108863, n = Math.imul(F, se), i = (i = Math.imul(F, oe)) + Math.imul(L, se) | 0, s = Math.imul(L, oe), n = n + Math.imul(P, le) | 0, i = (i = i + Math.imul(P, ce) | 0) + Math.imul(B, le) | 0, s = s + Math.imul(B, ce) | 0, n = n + Math.imul(j, he) | 0, i = (i = i + Math.imul(j, fe) | 0) + Math.imul(I, he) | 0, s = s + Math.imul(I, fe) | 0;
                        var Oe = (c + (n = n + Math.imul(A, pe) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(A, me) | 0) + Math.imul(R, pe) | 0)) << 13) | 0;
                        c = ((s = s + Math.imul(R, me) | 0) + (i >>> 13) | 0) + (Oe >>> 26) | 0, Oe &= 67108863, n = Math.imul(F, le), i = (i = Math.imul(F, ce)) + Math.imul(L, le) | 0, s = Math.imul(L, ce), n = n + Math.imul(P, he) | 0, i = (i = i + Math.imul(P, fe) | 0) + Math.imul(B, he) | 0, s = s + Math.imul(B, fe) | 0;
                        var je = (c + (n = n + Math.imul(j, pe) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(j, me) | 0) + Math.imul(I, pe) | 0)) << 13) | 0;
                        c = ((s = s + Math.imul(I, me) | 0) + (i >>> 13) | 0) + (je >>> 26) | 0, je &= 67108863, n = Math.imul(F, he), i = (i = Math.imul(F, fe)) + Math.imul(L, he) | 0, s = Math.imul(L, fe);
                        var Ie = (c + (n = n + Math.imul(P, pe) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(P, me) | 0) + Math.imul(B, pe) | 0)) << 13) | 0;
                        c = ((s = s + Math.imul(B, me) | 0) + (i >>> 13) | 0) + (Ie >>> 26) | 0, Ie &= 67108863;
                        var Ne = (c + (n = Math.imul(F, pe)) | 0) + ((8191 & (i = (i = Math.imul(F, me)) + Math.imul(L, pe) | 0)) << 13) | 0;
                        return c = ((s = Math.imul(L, me)) + (i >>> 13) | 0) + (Ne >>> 26) | 0, Ne &= 67108863, l[0] = be, l[1] = ge, l[2] = ye, l[3] = ve, l[4] = we, l[5] = _e, l[6] = xe, l[7] = ke, l[8] = Se, l[9] = Me, l[10] = Ce, l[11] = Te, l[12] = Ee, l[13] = Ae, l[14] = Re, l[15] = Oe, l[16] = je, l[17] = Ie, l[18] = Ne, 0 !== c && (l[19] = c, r.length++), r;
                    };
                    function g(e, t, r) {
                        r.negative = t.negative ^ e.negative, r.length = e.length + t.length;
                        for(var n = 0, i = 0, s = 0; s < r.length - 1; s++){
                            var o = i;
                            i = 0;
                            for(var a = 67108863 & n, l = Math.min(s, t.length - 1), c = Math.max(0, s - e.length + 1); c <= l; c++){
                                var u = s - c, h = (0 | e.words[u]) * (0 | t.words[c]), f = 67108863 & h;
                                a = 67108863 & (f = f + a | 0), i += (o = (o = o + (h / 67108864 | 0) | 0) + (f >>> 26) | 0) >>> 26, o &= 67108863;
                            }
                            r.words[s] = a, n = o, o = i;
                        }
                        return 0 !== n ? r.words[s] = n : r.length--, r._strip();
                    }
                    function y(e, t, r) {
                        return g(e, t, r);
                    }
                    function v(e, t) {
                        this.x = e, this.y = t;
                    }
                    Math.imul || (b = m), s.prototype.mulTo = function(e, t) {
                        var r = this.length + e.length;
                        return 10 === this.length && 10 === e.length ? b(this, e, t) : r < 63 ? m(this, e, t) : r < 1024 ? g(this, e, t) : y(this, e, t);
                    }, v.prototype.makeRBT = function(e) {
                        for(var t = new Array(e), r = s.prototype._countBits(e) - 1, n = 0; n < e; n++)t[n] = this.revBin(n, r, e);
                        return t;
                    }, v.prototype.revBin = function(e, t, r) {
                        if (0 === e || e === r - 1) return e;
                        for(var n = 0, i = 0; i < t; i++)n |= (1 & e) << t - i - 1, e >>= 1;
                        return n;
                    }, v.prototype.permute = function(e, t, r, n, i, s) {
                        for(var o = 0; o < s; o++)n[o] = t[e[o]], i[o] = r[e[o]];
                    }, v.prototype.transform = function(e, t, r, n, i, s) {
                        this.permute(s, e, t, r, n, i);
                        for(var o = 1; o < i; o <<= 1)for(var a = o << 1, l = Math.cos(2 * Math.PI / a), c = Math.sin(2 * Math.PI / a), u = 0; u < i; u += a)for(var h = l, f = c, d = 0; d < o; d++){
                            var p = r[u + d], m = n[u + d], b = r[u + d + o], g = n[u + d + o], y = h * b - f * g;
                            g = h * g + f * b, b = y, r[u + d] = p + b, n[u + d] = m + g, r[u + d + o] = p - b, n[u + d + o] = m - g, d !== a && (y = l * h - c * f, f = l * f + c * h, h = y);
                        }
                    }, v.prototype.guessLen13b = function(e, t) {
                        var r = 1 | Math.max(t, e), n = 1 & r, i = 0;
                        for(r = r / 2 | 0; r; r >>>= 1)i++;
                        return 1 << i + 1 + n;
                    }, v.prototype.conjugate = function(e, t, r) {
                        if (!(r <= 1)) for(var n = 0; n < r / 2; n++){
                            var i = e[n];
                            e[n] = e[r - n - 1], e[r - n - 1] = i, i = t[n], t[n] = -t[r - n - 1], t[r - n - 1] = -i;
                        }
                    }, v.prototype.normalize13b = function(e, t) {
                        for(var r = 0, n = 0; n < t / 2; n++){
                            var i = 8192 * Math.round(e[2 * n + 1] / t) + Math.round(e[2 * n] / t) + r;
                            e[n] = 67108863 & i, r = i < 67108864 ? 0 : i / 67108864 | 0;
                        }
                        return e;
                    }, v.prototype.convert13b = function(e, t, r, i) {
                        for(var s = 0, o = 0; o < t; o++)s += 0 | e[o], r[2 * o] = 8191 & s, s >>>= 13, r[2 * o + 1] = 8191 & s, s >>>= 13;
                        for(o = 2 * t; o < i; ++o)r[o] = 0;
                        n(0 === s), n(0 == (-8192 & s));
                    }, v.prototype.stub = function(e) {
                        for(var t = new Array(e), r = 0; r < e; r++)t[r] = 0;
                        return t;
                    }, v.prototype.mulp = function(e, t, r) {
                        var n = 2 * this.guessLen13b(e.length, t.length), i = this.makeRBT(n), s = this.stub(n), o = new Array(n), a = new Array(n), l = new Array(n), c = new Array(n), u = new Array(n), h = new Array(n), f = r.words;
                        f.length = n, this.convert13b(e.words, e.length, o, n), this.convert13b(t.words, t.length, c, n), this.transform(o, s, a, l, n, i), this.transform(c, s, u, h, n, i);
                        for(var d = 0; d < n; d++){
                            var p = a[d] * u[d] - l[d] * h[d];
                            l[d] = a[d] * h[d] + l[d] * u[d], a[d] = p;
                        }
                        return this.conjugate(a, l, n), this.transform(a, l, f, s, n, i), this.conjugate(f, s, n), this.normalize13b(f, n), r.negative = e.negative ^ t.negative, r.length = e.length + t.length, r._strip();
                    }, s.prototype.mul = function(e) {
                        var t = new s(null);
                        return t.words = new Array(this.length + e.length), this.mulTo(e, t);
                    }, s.prototype.mulf = function(e) {
                        var t = new s(null);
                        return t.words = new Array(this.length + e.length), y(this, e, t);
                    }, s.prototype.imul = function(e) {
                        return this.clone().mulTo(e, this);
                    }, s.prototype.imuln = function(e) {
                        var t = e < 0;
                        t && (e = -e), n("number" == typeof e), n(e < 67108864);
                        for(var r = 0, i = 0; i < this.length; i++){
                            var s = (0 | this.words[i]) * e, o = (67108863 & s) + (67108863 & r);
                            r >>= 26, r += s / 67108864 | 0, r += o >>> 26, this.words[i] = 67108863 & o;
                        }
                        return 0 !== r && (this.words[i] = r, this.length++), t ? this.ineg() : this;
                    }, s.prototype.muln = function(e) {
                        return this.clone().imuln(e);
                    }, s.prototype.sqr = function() {
                        return this.mul(this);
                    }, s.prototype.isqr = function() {
                        return this.imul(this.clone());
                    }, s.prototype.pow = function(e) {
                        var t = function(e) {
                            for(var t = new Array(e.bitLength()), r = 0; r < t.length; r++){
                                var n = r / 26 | 0, i = r % 26;
                                t[r] = e.words[n] >>> i & 1;
                            }
                            return t;
                        }(e);
                        if (0 === t.length) return new s(1);
                        for(var r = this, n = 0; n < t.length && 0 === t[n]; n++, r = r.sqr());
                        if (++n < t.length) for(var i = r.sqr(); n < t.length; n++, i = i.sqr())0 !== t[n] && (r = r.mul(i));
                        return r;
                    }, s.prototype.iushln = function(e) {
                        n("number" == typeof e && e >= 0);
                        var t, r = e % 26, i = (e - r) / 26, s = 67108863 >>> 26 - r << 26 - r;
                        if (0 !== r) {
                            var o = 0;
                            for(t = 0; t < this.length; t++){
                                var a = this.words[t] & s, l = (0 | this.words[t]) - a << r;
                                this.words[t] = l | o, o = a >>> 26 - r;
                            }
                            o && (this.words[t] = o, this.length++);
                        }
                        if (0 !== i) {
                            for(t = this.length - 1; t >= 0; t--)this.words[t + i] = this.words[t];
                            for(t = 0; t < i; t++)this.words[t] = 0;
                            this.length += i;
                        }
                        return this._strip();
                    }, s.prototype.ishln = function(e) {
                        return n(0 === this.negative), this.iushln(e);
                    }, s.prototype.iushrn = function(e, t, r) {
                        var i;
                        n("number" == typeof e && e >= 0), i = t ? (t - t % 26) / 26 : 0;
                        var s = e % 26, o = Math.min((e - s) / 26, this.length), a = 67108863 ^ 67108863 >>> s << s, l = r;
                        if (i -= o, i = Math.max(0, i), l) {
                            for(var c = 0; c < o; c++)l.words[c] = this.words[c];
                            l.length = o;
                        }
                        if (0 === o) ;
                        else if (this.length > o) for(this.length -= o, c = 0; c < this.length; c++)this.words[c] = this.words[c + o];
                        else this.words[0] = 0, this.length = 1;
                        var u = 0;
                        for(c = this.length - 1; c >= 0 && (0 !== u || c >= i); c--){
                            var h = 0 | this.words[c];
                            this.words[c] = u << 26 - s | h >>> s, u = h & a;
                        }
                        return l && 0 !== u && (l.words[l.length++] = u), 0 === this.length && (this.words[0] = 0, this.length = 1), this._strip();
                    }, s.prototype.ishrn = function(e, t, r) {
                        return n(0 === this.negative), this.iushrn(e, t, r);
                    }, s.prototype.shln = function(e) {
                        return this.clone().ishln(e);
                    }, s.prototype.ushln = function(e) {
                        return this.clone().iushln(e);
                    }, s.prototype.shrn = function(e) {
                        return this.clone().ishrn(e);
                    }, s.prototype.ushrn = function(e) {
                        return this.clone().iushrn(e);
                    }, s.prototype.testn = function(e) {
                        n("number" == typeof e && e >= 0);
                        var t = e % 26, r = (e - t) / 26, i = 1 << t;
                        return !(this.length <= r) && !!(this.words[r] & i);
                    }, s.prototype.imaskn = function(e) {
                        n("number" == typeof e && e >= 0);
                        var t = e % 26, r = (e - t) / 26;
                        if (n(0 === this.negative, "imaskn works only with positive numbers"), this.length <= r) return this;
                        if (0 !== t && r++, this.length = Math.min(r, this.length), 0 !== t) {
                            var i = 67108863 ^ 67108863 >>> t << t;
                            this.words[this.length - 1] &= i;
                        }
                        return this._strip();
                    }, s.prototype.maskn = function(e) {
                        return this.clone().imaskn(e);
                    }, s.prototype.iaddn = function(e) {
                        return n("number" == typeof e), n(e < 67108864), e < 0 ? this.isubn(-e) : 0 !== this.negative ? 1 === this.length && (0 | this.words[0]) <= e ? (this.words[0] = e - (0 | this.words[0]), this.negative = 0, this) : (this.negative = 0, this.isubn(e), this.negative = 1, this) : this._iaddn(e);
                    }, s.prototype._iaddn = function(e) {
                        this.words[0] += e;
                        for(var t = 0; t < this.length && this.words[t] >= 67108864; t++)this.words[t] -= 67108864, t === this.length - 1 ? this.words[t + 1] = 1 : this.words[t + 1]++;
                        return this.length = Math.max(this.length, t + 1), this;
                    }, s.prototype.isubn = function(e) {
                        if (n("number" == typeof e), n(e < 67108864), e < 0) return this.iaddn(-e);
                        if (0 !== this.negative) return this.negative = 0, this.iaddn(e), this.negative = 1, this;
                        if (this.words[0] -= e, 1 === this.length && this.words[0] < 0) this.words[0] = -this.words[0], this.negative = 1;
                        else for(var t = 0; t < this.length && this.words[t] < 0; t++)this.words[t] += 67108864, this.words[t + 1] -= 1;
                        return this._strip();
                    }, s.prototype.addn = function(e) {
                        return this.clone().iaddn(e);
                    }, s.prototype.subn = function(e) {
                        return this.clone().isubn(e);
                    }, s.prototype.iabs = function() {
                        return this.negative = 0, this;
                    }, s.prototype.abs = function() {
                        return this.clone().iabs();
                    }, s.prototype._ishlnsubmul = function(e, t, r) {
                        var i, s, o = e.length + r;
                        this._expand(o);
                        var a = 0;
                        for(i = 0; i < e.length; i++){
                            s = (0 | this.words[i + r]) + a;
                            var l = (0 | e.words[i]) * t;
                            a = ((s -= 67108863 & l) >> 26) - (l / 67108864 | 0), this.words[i + r] = 67108863 & s;
                        }
                        for(; i < this.length - r; i++)a = (s = (0 | this.words[i + r]) + a) >> 26, this.words[i + r] = 67108863 & s;
                        if (0 === a) return this._strip();
                        for(n(-1 === a), a = 0, i = 0; i < this.length; i++)a = (s = -(0 | this.words[i]) + a) >> 26, this.words[i] = 67108863 & s;
                        return this.negative = 1, this._strip();
                    }, s.prototype._wordDiv = function(e, t) {
                        var r = (this.length, e.length), n = this.clone(), i = e, o = 0 | i.words[i.length - 1];
                        0 !== (r = 26 - this._countBits(o)) && (i = i.ushln(r), n.iushln(r), o = 0 | i.words[i.length - 1]);
                        var a, l = n.length - i.length;
                        if ("mod" !== t) {
                            (a = new s(null)).length = l + 1, a.words = new Array(a.length);
                            for(var c = 0; c < a.length; c++)a.words[c] = 0;
                        }
                        var u = n.clone()._ishlnsubmul(i, 1, l);
                        0 === u.negative && (n = u, a && (a.words[l] = 1));
                        for(var h = l - 1; h >= 0; h--){
                            var f = 67108864 * (0 | n.words[i.length + h]) + (0 | n.words[i.length + h - 1]);
                            for(f = Math.min(f / o | 0, 67108863), n._ishlnsubmul(i, f, h); 0 !== n.negative;)f--, n.negative = 0, n._ishlnsubmul(i, 1, h), n.isZero() || (n.negative ^= 1);
                            a && (a.words[h] = f);
                        }
                        return a && a._strip(), n._strip(), "div" !== t && 0 !== r && n.iushrn(r), {
                            div: a || null,
                            mod: n
                        };
                    }, s.prototype.divmod = function(e, t, r) {
                        var i, o, a;
                        return n(!e.isZero()), this.isZero() ? {
                            div: new s(0),
                            mod: new s(0)
                        } : 0 !== this.negative && 0 === e.negative ? (a = this.neg().divmod(e, t), "mod" !== t && (i = a.div.neg()), "div" !== t && (o = a.mod.neg(), r && 0 !== o.negative && o.iadd(e)), {
                            div: i,
                            mod: o
                        }) : 0 === this.negative && 0 !== e.negative ? (a = this.divmod(e.neg(), t), "mod" !== t && (i = a.div.neg()), {
                            div: i,
                            mod: a.mod
                        }) : 0 != (this.negative & e.negative) ? (a = this.neg().divmod(e.neg(), t), "div" !== t && (o = a.mod.neg(), r && 0 !== o.negative && o.isub(e)), {
                            div: a.div,
                            mod: o
                        }) : e.length > this.length || this.cmp(e) < 0 ? {
                            div: new s(0),
                            mod: this
                        } : 1 === e.length ? "div" === t ? {
                            div: this.divn(e.words[0]),
                            mod: null
                        } : "mod" === t ? {
                            div: null,
                            mod: new s(this.modrn(e.words[0]))
                        } : {
                            div: this.divn(e.words[0]),
                            mod: new s(this.modrn(e.words[0]))
                        } : this._wordDiv(e, t);
                    }, s.prototype.div = function(e) {
                        return this.divmod(e, "div", !1).div;
                    }, s.prototype.mod = function(e) {
                        return this.divmod(e, "mod", !1).mod;
                    }, s.prototype.umod = function(e) {
                        return this.divmod(e, "mod", !0).mod;
                    }, s.prototype.divRound = function(e) {
                        var t = this.divmod(e);
                        if (t.mod.isZero()) return t.div;
                        var r = 0 !== t.div.negative ? t.mod.isub(e) : t.mod, n = e.ushrn(1), i = e.andln(1), s = r.cmp(n);
                        return s < 0 || 1 === i && 0 === s ? t.div : 0 !== t.div.negative ? t.div.isubn(1) : t.div.iaddn(1);
                    }, s.prototype.modrn = function(e) {
                        var t = e < 0;
                        t && (e = -e), n(e <= 67108863);
                        for(var r = 67108864 % e, i = 0, s = this.length - 1; s >= 0; s--)i = (r * i + (0 | this.words[s])) % e;
                        return t ? -i : i;
                    }, s.prototype.modn = function(e) {
                        return this.modrn(e);
                    }, s.prototype.idivn = function(e) {
                        var t = e < 0;
                        t && (e = -e), n(e <= 67108863);
                        for(var r = 0, i = this.length - 1; i >= 0; i--){
                            var s = (0 | this.words[i]) + 67108864 * r;
                            this.words[i] = s / e | 0, r = s % e;
                        }
                        return this._strip(), t ? this.ineg() : this;
                    }, s.prototype.divn = function(e) {
                        return this.clone().idivn(e);
                    }, s.prototype.egcd = function(e) {
                        n(0 === e.negative), n(!e.isZero());
                        var t = this, r = e.clone();
                        t = 0 !== t.negative ? t.umod(e) : t.clone();
                        for(var i = new s(1), o = new s(0), a = new s(0), l = new s(1), c = 0; t.isEven() && r.isEven();)t.iushrn(1), r.iushrn(1), ++c;
                        for(var u = r.clone(), h = t.clone(); !t.isZero();){
                            for(var f = 0, d = 1; 0 == (t.words[0] & d) && f < 26; ++f, d <<= 1);
                            if (f > 0) for(t.iushrn(f); f-- > 0;)(i.isOdd() || o.isOdd()) && (i.iadd(u), o.isub(h)), i.iushrn(1), o.iushrn(1);
                            for(var p = 0, m = 1; 0 == (r.words[0] & m) && p < 26; ++p, m <<= 1);
                            if (p > 0) for(r.iushrn(p); p-- > 0;)(a.isOdd() || l.isOdd()) && (a.iadd(u), l.isub(h)), a.iushrn(1), l.iushrn(1);
                            t.cmp(r) >= 0 ? (t.isub(r), i.isub(a), o.isub(l)) : (r.isub(t), a.isub(i), l.isub(o));
                        }
                        return {
                            a: a,
                            b: l,
                            gcd: r.iushln(c)
                        };
                    }, s.prototype._invmp = function(e) {
                        n(0 === e.negative), n(!e.isZero());
                        var t = this, r = e.clone();
                        t = 0 !== t.negative ? t.umod(e) : t.clone();
                        for(var i, o = new s(1), a = new s(0), l = r.clone(); t.cmpn(1) > 0 && r.cmpn(1) > 0;){
                            for(var c = 0, u = 1; 0 == (t.words[0] & u) && c < 26; ++c, u <<= 1);
                            if (c > 0) for(t.iushrn(c); c-- > 0;)o.isOdd() && o.iadd(l), o.iushrn(1);
                            for(var h = 0, f = 1; 0 == (r.words[0] & f) && h < 26; ++h, f <<= 1);
                            if (h > 0) for(r.iushrn(h); h-- > 0;)a.isOdd() && a.iadd(l), a.iushrn(1);
                            t.cmp(r) >= 0 ? (t.isub(r), o.isub(a)) : (r.isub(t), a.isub(o));
                        }
                        return (i = 0 === t.cmpn(1) ? o : a).cmpn(0) < 0 && i.iadd(e), i;
                    }, s.prototype.gcd = function(e) {
                        if (this.isZero()) return e.abs();
                        if (e.isZero()) return this.abs();
                        var t = this.clone(), r = e.clone();
                        t.negative = 0, r.negative = 0;
                        for(var n = 0; t.isEven() && r.isEven(); n++)t.iushrn(1), r.iushrn(1);
                        for(;;){
                            for(; t.isEven();)t.iushrn(1);
                            for(; r.isEven();)r.iushrn(1);
                            var i = t.cmp(r);
                            if (i < 0) {
                                var s = t;
                                t = r, r = s;
                            } else if (0 === i || 0 === r.cmpn(1)) break;
                            t.isub(r);
                        }
                        return r.iushln(n);
                    }, s.prototype.invm = function(e) {
                        return this.egcd(e).a.umod(e);
                    }, s.prototype.isEven = function() {
                        return 0 == (1 & this.words[0]);
                    }, s.prototype.isOdd = function() {
                        return 1 == (1 & this.words[0]);
                    }, s.prototype.andln = function(e) {
                        return this.words[0] & e;
                    }, s.prototype.bincn = function(e) {
                        n("number" == typeof e);
                        var t = e % 26, r = (e - t) / 26, i = 1 << t;
                        if (this.length <= r) return this._expand(r + 1), this.words[r] |= i, this;
                        for(var s = i, o = r; 0 !== s && o < this.length; o++){
                            var a = 0 | this.words[o];
                            s = (a += s) >>> 26, a &= 67108863, this.words[o] = a;
                        }
                        return 0 !== s && (this.words[o] = s, this.length++), this;
                    }, s.prototype.isZero = function() {
                        return 1 === this.length && 0 === this.words[0];
                    }, s.prototype.cmpn = function(e) {
                        var t, r = e < 0;
                        if (0 !== this.negative && !r) return -1;
                        if (0 === this.negative && r) return 1;
                        if (this._strip(), this.length > 1) t = 1;
                        else {
                            r && (e = -e), n(e <= 67108863, "Number is too big");
                            var i = 0 | this.words[0];
                            t = i === e ? 0 : i < e ? -1 : 1;
                        }
                        return 0 !== this.negative ? 0 | -t : t;
                    }, s.prototype.cmp = function(e) {
                        if (0 !== this.negative && 0 === e.negative) return -1;
                        if (0 === this.negative && 0 !== e.negative) return 1;
                        var t = this.ucmp(e);
                        return 0 !== this.negative ? 0 | -t : t;
                    }, s.prototype.ucmp = function(e) {
                        if (this.length > e.length) return 1;
                        if (this.length < e.length) return -1;
                        for(var t = 0, r = this.length - 1; r >= 0; r--){
                            var n = 0 | this.words[r], i = 0 | e.words[r];
                            if (n !== i) {
                                n < i ? t = -1 : n > i && (t = 1);
                                break;
                            }
                        }
                        return t;
                    }, s.prototype.gtn = function(e) {
                        return 1 === this.cmpn(e);
                    }, s.prototype.gt = function(e) {
                        return 1 === this.cmp(e);
                    }, s.prototype.gten = function(e) {
                        return this.cmpn(e) >= 0;
                    }, s.prototype.gte = function(e) {
                        return this.cmp(e) >= 0;
                    }, s.prototype.ltn = function(e) {
                        return -1 === this.cmpn(e);
                    }, s.prototype.lt = function(e) {
                        return -1 === this.cmp(e);
                    }, s.prototype.lten = function(e) {
                        return this.cmpn(e) <= 0;
                    }, s.prototype.lte = function(e) {
                        return this.cmp(e) <= 0;
                    }, s.prototype.eqn = function(e) {
                        return 0 === this.cmpn(e);
                    }, s.prototype.eq = function(e) {
                        return 0 === this.cmp(e);
                    }, s.red = function(e) {
                        return new C(e);
                    }, s.prototype.toRed = function(e) {
                        return n(!this.red, "Already a number in reduction context"), n(0 === this.negative, "red works only with positives"), e.convertTo(this)._forceRed(e);
                    }, s.prototype.fromRed = function() {
                        return n(this.red, "fromRed works only with numbers in reduction context"), this.red.convertFrom(this);
                    }, s.prototype._forceRed = function(e) {
                        return this.red = e, this;
                    }, s.prototype.forceRed = function(e) {
                        return n(!this.red, "Already a number in reduction context"), this._forceRed(e);
                    }, s.prototype.redAdd = function(e) {
                        return n(this.red, "redAdd works only with red numbers"), this.red.add(this, e);
                    }, s.prototype.redIAdd = function(e) {
                        return n(this.red, "redIAdd works only with red numbers"), this.red.iadd(this, e);
                    }, s.prototype.redSub = function(e) {
                        return n(this.red, "redSub works only with red numbers"), this.red.sub(this, e);
                    }, s.prototype.redISub = function(e) {
                        return n(this.red, "redISub works only with red numbers"), this.red.isub(this, e);
                    }, s.prototype.redShl = function(e) {
                        return n(this.red, "redShl works only with red numbers"), this.red.shl(this, e);
                    }, s.prototype.redMul = function(e) {
                        return n(this.red, "redMul works only with red numbers"), this.red._verify2(this, e), this.red.mul(this, e);
                    }, s.prototype.redIMul = function(e) {
                        return n(this.red, "redMul works only with red numbers"), this.red._verify2(this, e), this.red.imul(this, e);
                    }, s.prototype.redSqr = function() {
                        return n(this.red, "redSqr works only with red numbers"), this.red._verify1(this), this.red.sqr(this);
                    }, s.prototype.redISqr = function() {
                        return n(this.red, "redISqr works only with red numbers"), this.red._verify1(this), this.red.isqr(this);
                    }, s.prototype.redSqrt = function() {
                        return n(this.red, "redSqrt works only with red numbers"), this.red._verify1(this), this.red.sqrt(this);
                    }, s.prototype.redInvm = function() {
                        return n(this.red, "redInvm works only with red numbers"), this.red._verify1(this), this.red.invm(this);
                    }, s.prototype.redNeg = function() {
                        return n(this.red, "redNeg works only with red numbers"), this.red._verify1(this), this.red.neg(this);
                    }, s.prototype.redPow = function(e) {
                        return n(this.red && !e.red, "redPow(normalNum)"), this.red._verify1(this), this.red.pow(this, e);
                    };
                    var w = {
                        k256: null,
                        p224: null,
                        p192: null,
                        p25519: null
                    };
                    function _(e, t) {
                        this.name = e, this.p = new s(t, 16), this.n = this.p.bitLength(), this.k = new s(1).iushln(this.n).isub(this.p), this.tmp = this._tmp();
                    }
                    function x() {
                        _.call(this, "k256", "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f");
                    }
                    function k() {
                        _.call(this, "p224", "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001");
                    }
                    function S() {
                        _.call(this, "p192", "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff");
                    }
                    function M() {
                        _.call(this, "25519", "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed");
                    }
                    function C(e) {
                        if ("string" == typeof e) {
                            var t = s._prime(e);
                            this.m = t.p, this.prime = t;
                        } else n(e.gtn(1), "modulus must be greater than 1"), this.m = e, this.prime = null;
                    }
                    function T(e) {
                        C.call(this, e), this.shift = this.m.bitLength(), this.shift % 26 != 0 && (this.shift += 26 - this.shift % 26), this.r = new s(1).iushln(this.shift), this.r2 = this.imod(this.r.sqr()), this.rinv = this.r._invmp(this.m), this.minv = this.rinv.mul(this.r).isubn(1).div(this.m), this.minv = this.minv.umod(this.r), this.minv = this.r.sub(this.minv);
                    }
                    _.prototype._tmp = function() {
                        var e = new s(null);
                        return e.words = new Array(Math.ceil(this.n / 13)), e;
                    }, _.prototype.ireduce = function(e) {
                        var t, r = e;
                        do this.split(r, this.tmp), t = (r = (r = this.imulK(r)).iadd(this.tmp)).bitLength();
                        while (t > this.n);
                        var n = t < this.n ? -1 : r.ucmp(this.p);
                        return 0 === n ? (r.words[0] = 0, r.length = 1) : n > 0 ? r.isub(this.p) : void 0 !== r.strip ? r.strip() : r._strip(), r;
                    }, _.prototype.split = function(e, t) {
                        e.iushrn(this.n, 0, t);
                    }, _.prototype.imulK = function(e) {
                        return e.imul(this.k);
                    }, i(x, _), x.prototype.split = function(e, t) {
                        for(var r = Math.min(e.length, 9), n = 0; n < r; n++)t.words[n] = e.words[n];
                        if (t.length = r, e.length <= 9) return e.words[0] = 0, void (e.length = 1);
                        var i = e.words[9];
                        for(t.words[t.length++] = 4194303 & i, n = 10; n < e.length; n++){
                            var s = 0 | e.words[n];
                            e.words[n - 10] = (4194303 & s) << 4 | i >>> 22, i = s;
                        }
                        i >>>= 22, e.words[n - 10] = i, 0 === i && e.length > 10 ? e.length -= 10 : e.length -= 9;
                    }, x.prototype.imulK = function(e) {
                        e.words[e.length] = 0, e.words[e.length + 1] = 0, e.length += 2;
                        for(var t = 0, r = 0; r < e.length; r++){
                            var n = 0 | e.words[r];
                            t += 977 * n, e.words[r] = 67108863 & t, t = 64 * n + (t / 67108864 | 0);
                        }
                        return 0 === e.words[e.length - 1] && (e.length--, 0 === e.words[e.length - 1] && e.length--), e;
                    }, i(k, _), i(S, _), i(M, _), M.prototype.imulK = function(e) {
                        for(var t = 0, r = 0; r < e.length; r++){
                            var n = 19 * (0 | e.words[r]) + t, i = 67108863 & n;
                            n >>>= 26, e.words[r] = i, t = n;
                        }
                        return 0 !== t && (e.words[e.length++] = t), e;
                    }, s._prime = function(e) {
                        if (w[e]) return w[e];
                        var t;
                        if ("k256" === e) t = new x;
                        else if ("p224" === e) t = new k;
                        else if ("p192" === e) t = new S;
                        else {
                            if ("p25519" !== e) throw new Error("Unknown prime " + e);
                            t = new M;
                        }
                        return w[e] = t, t;
                    }, C.prototype._verify1 = function(e) {
                        n(0 === e.negative, "red works only with positives"), n(e.red, "red works only with red numbers");
                    }, C.prototype._verify2 = function(e, t) {
                        n(0 == (e.negative | t.negative), "red works only with positives"), n(e.red && e.red === t.red, "red works only with red numbers");
                    }, C.prototype.imod = function(e) {
                        return this.prime ? this.prime.ireduce(e)._forceRed(this) : (u(e, e.umod(this.m)._forceRed(this)), e);
                    }, C.prototype.neg = function(e) {
                        return e.isZero() ? e.clone() : this.m.sub(e)._forceRed(this);
                    }, C.prototype.add = function(e, t) {
                        this._verify2(e, t);
                        var r = e.add(t);
                        return r.cmp(this.m) >= 0 && r.isub(this.m), r._forceRed(this);
                    }, C.prototype.iadd = function(e, t) {
                        this._verify2(e, t);
                        var r = e.iadd(t);
                        return r.cmp(this.m) >= 0 && r.isub(this.m), r;
                    }, C.prototype.sub = function(e, t) {
                        this._verify2(e, t);
                        var r = e.sub(t);
                        return r.cmpn(0) < 0 && r.iadd(this.m), r._forceRed(this);
                    }, C.prototype.isub = function(e, t) {
                        this._verify2(e, t);
                        var r = e.isub(t);
                        return r.cmpn(0) < 0 && r.iadd(this.m), r;
                    }, C.prototype.shl = function(e, t) {
                        return this._verify1(e), this.imod(e.ushln(t));
                    }, C.prototype.imul = function(e, t) {
                        return this._verify2(e, t), this.imod(e.imul(t));
                    }, C.prototype.mul = function(e, t) {
                        return this._verify2(e, t), this.imod(e.mul(t));
                    }, C.prototype.isqr = function(e) {
                        return this.imul(e, e.clone());
                    }, C.prototype.sqr = function(e) {
                        return this.mul(e, e);
                    }, C.prototype.sqrt = function(e) {
                        if (e.isZero()) return e.clone();
                        var t = this.m.andln(3);
                        if (n(t % 2 == 1), 3 === t) {
                            var r = this.m.add(new s(1)).iushrn(2);
                            return this.pow(e, r);
                        }
                        for(var i = this.m.subn(1), o = 0; !i.isZero() && 0 === i.andln(1);)o++, i.iushrn(1);
                        n(!i.isZero());
                        var a = new s(1).toRed(this), l = a.redNeg(), c = this.m.subn(1).iushrn(1), u = this.m.bitLength();
                        for(u = new s(2 * u * u).toRed(this); 0 !== this.pow(u, c).cmp(l);)u.redIAdd(l);
                        for(var h = this.pow(u, i), f = this.pow(e, i.addn(1).iushrn(1)), d = this.pow(e, i), p = o; 0 !== d.cmp(a);){
                            for(var m = d, b = 0; 0 !== m.cmp(a); b++)m = m.redSqr();
                            n(b < p);
                            var g = this.pow(h, new s(1).iushln(p - b - 1));
                            f = f.redMul(g), h = g.redSqr(), d = d.redMul(h), p = b;
                        }
                        return f;
                    }, C.prototype.invm = function(e) {
                        var t = e._invmp(this.m);
                        return 0 !== t.negative ? (t.negative = 0, this.imod(t).redNeg()) : this.imod(t);
                    }, C.prototype.pow = function(e, t) {
                        if (t.isZero()) return new s(1).toRed(this);
                        if (0 === t.cmpn(1)) return e.clone();
                        var r = new Array(16);
                        r[0] = new s(1).toRed(this), r[1] = e;
                        for(var n = 2; n < r.length; n++)r[n] = this.mul(r[n - 1], e);
                        var i = r[0], o = 0, a = 0, l = t.bitLength() % 26;
                        for(0 === l && (l = 26), n = t.length - 1; n >= 0; n--){
                            for(var c = t.words[n], u = l - 1; u >= 0; u--){
                                var h = c >> u & 1;
                                i !== r[0] && (i = this.sqr(i)), 0 !== h || 0 !== o ? (o <<= 1, o |= h, (4 === ++a || 0 === n && 0 === u) && (i = this.mul(i, r[o]), a = 0, o = 0)) : a = 0;
                            }
                            l = 26;
                        }
                        return i;
                    }, C.prototype.convertTo = function(e) {
                        var t = e.umod(this.m);
                        return t === e ? t.clone() : t;
                    }, C.prototype.convertFrom = function(e) {
                        var t = e.clone();
                        return t.red = null, t;
                    }, s.mont = function(e) {
                        return new T(e);
                    }, i(T, C), T.prototype.convertTo = function(e) {
                        return this.imod(e.ushln(this.shift));
                    }, T.prototype.convertFrom = function(e) {
                        var t = this.imod(e.mul(this.rinv));
                        return t.red = null, t;
                    }, T.prototype.imul = function(e, t) {
                        if (e.isZero() || t.isZero()) return e.words[0] = 0, e.length = 1, e;
                        var r = e.imul(t), n = r.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m), i = r.isub(n).iushrn(this.shift), s = i;
                        return i.cmp(this.m) >= 0 ? s = i.isub(this.m) : i.cmpn(0) < 0 && (s = i.iadd(this.m)), s._forceRed(this);
                    }, T.prototype.mul = function(e, t) {
                        if (e.isZero() || t.isZero()) return new s(0)._forceRed(this);
                        var r = e.mul(t), n = r.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m), i = r.isub(n).iushrn(this.shift), o = i;
                        return i.cmp(this.m) >= 0 ? o = i.isub(this.m) : i.cmpn(0) < 0 && (o = i.iadd(this.m)), o._forceRed(this);
                    }, T.prototype.invm = function(e) {
                        return this.imod(e._invmp(this.m).mul(this.r2))._forceRed(this);
                    };
                }(void 0 === t || t);
            },
            {
                buffer: 188
            }
        ],
        187: [
            function(e, t, r) {
                "use strict";
                var n;
                function i(e) {
                    this.rand = e;
                }
                if (t.exports = function(e) {
                    return n || (n = new i(null)), n.generate(e);
                }, t.exports.Rand = i, i.prototype.generate = function(e) {
                    return this._rand(e);
                }, i.prototype._rand = function(e) {
                    if (this.rand.getBytes) return this.rand.getBytes(e);
                    for(var t = new Uint8Array(e), r = 0; r < t.length; r++)t[r] = this.rand.getByte();
                    return t;
                }, "object" == typeof self) self.crypto && self.crypto.getRandomValues ? i.prototype._rand = function(e) {
                    var t = new Uint8Array(e);
                    return self.crypto.getRandomValues(t), t;
                } : self.msCrypto && self.msCrypto.getRandomValues ? i.prototype._rand = function(e) {
                    var t = new Uint8Array(e);
                    return self.msCrypto.getRandomValues(t), t;
                } : "object" == typeof window && (i.prototype._rand = function() {
                    throw new Error("Not implemented yet");
                });
                else try {
                    var s = e("crypto");
                    if ("function" != typeof s.randomBytes) throw new Error("Not supported");
                    i.prototype._rand = function(e) {
                        return s.randomBytes(e);
                    };
                } catch (e) {}
            },
            {
                crypto: 188
            }
        ],
        188: [
            function(e, t, r) {},
            {}
        ],
        189: [
            function(e, t, r) {
                "use strict";
                var n = e("safe-buffer").Buffer;
                function i(e) {
                    n.isBuffer(e) || (e = n.from(e));
                    for(var t = e.length / 4 | 0, r = new Array(t), i = 0; i < t; i++)r[i] = e.readUInt32BE(4 * i);
                    return r;
                }
                function s(e) {
                    for(; 0 < e.length; e++)e[0] = 0;
                }
                function o(e, t, r, n, i) {
                    for(var s, o, a, l, c = r[0], u = r[1], h = r[2], f = r[3], d = e[0] ^ t[0], p = e[1] ^ t[1], m = e[2] ^ t[2], b = e[3] ^ t[3], g = 4, y = 1; y < i; y++)s = c[d >>> 24] ^ u[p >>> 16 & 255] ^ h[m >>> 8 & 255] ^ f[255 & b] ^ t[g++], o = c[p >>> 24] ^ u[m >>> 16 & 255] ^ h[b >>> 8 & 255] ^ f[255 & d] ^ t[g++], a = c[m >>> 24] ^ u[b >>> 16 & 255] ^ h[d >>> 8 & 255] ^ f[255 & p] ^ t[g++], l = c[b >>> 24] ^ u[d >>> 16 & 255] ^ h[p >>> 8 & 255] ^ f[255 & m] ^ t[g++], d = s, p = o, m = a, b = l;
                    return s = (n[d >>> 24] << 24 | n[p >>> 16 & 255] << 16 | n[m >>> 8 & 255] << 8 | n[255 & b]) ^ t[g++], o = (n[p >>> 24] << 24 | n[m >>> 16 & 255] << 16 | n[b >>> 8 & 255] << 8 | n[255 & d]) ^ t[g++], a = (n[m >>> 24] << 24 | n[b >>> 16 & 255] << 16 | n[d >>> 8 & 255] << 8 | n[255 & p]) ^ t[g++], l = (n[b >>> 24] << 24 | n[d >>> 16 & 255] << 16 | n[p >>> 8 & 255] << 8 | n[255 & m]) ^ t[g++], [
                        s >>>= 0,
                        o >>>= 0,
                        a >>>= 0,
                        l >>>= 0
                    ];
                }
                var a = [
                    0,
                    1,
                    2,
                    4,
                    8,
                    16,
                    32,
                    64,
                    128,
                    27,
                    54
                ], l = function() {
                    for(var e = new Array(256), t = 0; t < 256; t++)e[t] = t < 128 ? t << 1 : t << 1 ^ 283;
                    for(var r = [], n = [], i = [
                        [],
                        [],
                        [],
                        []
                    ], s = [
                        [],
                        [],
                        [],
                        []
                    ], o = 0, a = 0, l = 0; l < 256; ++l){
                        var c = a ^ a << 1 ^ a << 2 ^ a << 3 ^ a << 4;
                        c = c >>> 8 ^ 255 & c ^ 99, r[o] = c, n[c] = o;
                        var u = e[o], h = e[u], f = e[h], d = 257 * e[c] ^ 16843008 * c;
                        i[0][o] = d << 24 | d >>> 8, i[1][o] = d << 16 | d >>> 16, i[2][o] = d << 8 | d >>> 24, i[3][o] = d, d = 16843009 * f ^ 65537 * h ^ 257 * u ^ 16843008 * o, s[0][c] = d << 24 | d >>> 8, s[1][c] = d << 16 | d >>> 16, s[2][c] = d << 8 | d >>> 24, s[3][c] = d, 0 === o ? o = a = 1 : (o = u ^ e[e[e[f ^ u]]], a ^= e[e[a]]);
                    }
                    return {
                        SBOX: r,
                        INV_SBOX: n,
                        SUB_MIX: i,
                        INV_SUB_MIX: s
                    };
                }();
                function c(e) {
                    this._key = i(e), this._reset();
                }
                c.blockSize = 16, c.keySize = 32, c.prototype.blockSize = c.blockSize, c.prototype.keySize = c.keySize, c.prototype._reset = function() {
                    for(var e = this._key, t = e.length, r = t + 6, n = 4 * (r + 1), i = [], s = 0; s < t; s++)i[s] = e[s];
                    for(s = t; s < n; s++){
                        var o = i[s - 1];
                        s % t == 0 ? (o = o << 8 | o >>> 24, o = l.SBOX[o >>> 24] << 24 | l.SBOX[o >>> 16 & 255] << 16 | l.SBOX[o >>> 8 & 255] << 8 | l.SBOX[255 & o], o ^= a[s / t | 0] << 24) : t > 6 && s % t == 4 && (o = l.SBOX[o >>> 24] << 24 | l.SBOX[o >>> 16 & 255] << 16 | l.SBOX[o >>> 8 & 255] << 8 | l.SBOX[255 & o]), i[s] = i[s - t] ^ o;
                    }
                    for(var c = [], u = 0; u < n; u++){
                        var h = n - u, f = i[h - (u % 4 ? 0 : 4)];
                        c[u] = u < 4 || h <= 4 ? f : l.INV_SUB_MIX[0][l.SBOX[f >>> 24]] ^ l.INV_SUB_MIX[1][l.SBOX[f >>> 16 & 255]] ^ l.INV_SUB_MIX[2][l.SBOX[f >>> 8 & 255]] ^ l.INV_SUB_MIX[3][l.SBOX[255 & f]];
                    }
                    this._nRounds = r, this._keySchedule = i, this._invKeySchedule = c;
                }, c.prototype.encryptBlockRaw = function(e) {
                    return o(e = i(e), this._keySchedule, l.SUB_MIX, l.SBOX, this._nRounds);
                }, c.prototype.encryptBlock = function(e) {
                    var t = this.encryptBlockRaw(e), r = n.allocUnsafe(16);
                    return r.writeUInt32BE(t[0], 0), r.writeUInt32BE(t[1], 4), r.writeUInt32BE(t[2], 8), r.writeUInt32BE(t[3], 12), r;
                }, c.prototype.decryptBlock = function(e) {
                    var t = (e = i(e))[1];
                    e[1] = e[3], e[3] = t;
                    var r = o(e, this._invKeySchedule, l.INV_SUB_MIX, l.INV_SBOX, this._nRounds), s = n.allocUnsafe(16);
                    return s.writeUInt32BE(r[0], 0), s.writeUInt32BE(r[3], 4), s.writeUInt32BE(r[2], 8), s.writeUInt32BE(r[1], 12), s;
                }, c.prototype.scrub = function() {
                    s(this._keySchedule), s(this._invKeySchedule), s(this._key);
                }, t.exports.AES = c;
            },
            {
                "safe-buffer": 494
            }
        ],
        190: [
            function(e, t, r) {
                "use strict";
                var n = e("./aes"), i = e("safe-buffer").Buffer, s = e("cipher-base"), o = e("inherits"), a = e("./ghash"), l = e("buffer-xor"), c = e("./incr32");
                function u(e, t, r, o) {
                    s.call(this);
                    var l = i.alloc(4, 0);
                    this._cipher = new n.AES(t);
                    var u = this._cipher.encryptBlock(l);
                    this._ghash = new a(u), r = function(e, t, r) {
                        if (12 === t.length) return e._finID = i.concat([
                            t,
                            i.from([
                                0,
                                0,
                                0,
                                1
                            ])
                        ]), i.concat([
                            t,
                            i.from([
                                0,
                                0,
                                0,
                                2
                            ])
                        ]);
                        var n = new a(r), s = t.length, o = s % 16;
                        n.update(t), o && (o = 16 - o, n.update(i.alloc(o, 0))), n.update(i.alloc(8, 0));
                        var l = 8 * s, u = i.alloc(8);
                        u.writeUIntBE(l, 0, 8), n.update(u), e._finID = n.state;
                        var h = i.from(e._finID);
                        return c(h), h;
                    }(this, r, u), this._prev = i.from(r), this._cache = i.allocUnsafe(0), this._secCache = i.allocUnsafe(0), this._decrypt = o, this._alen = 0, this._len = 0, this._mode = e, this._authTag = null, this._called = !1;
                }
                o(u, s), u.prototype._update = function(e) {
                    if (!this._called && this._alen) {
                        var t = 16 - this._alen % 16;
                        t < 16 && (t = i.alloc(t, 0), this._ghash.update(t));
                    }
                    this._called = !0;
                    var r = this._mode.encrypt(this, e);
                    return this._decrypt ? this._ghash.update(e) : this._ghash.update(r), this._len += e.length, r;
                }, u.prototype._final = function() {
                    if (this._decrypt && !this._authTag) throw new Error("Unsupported state or unable to authenticate data");
                    var e = l(this._ghash.final(8 * this._alen, 8 * this._len), this._cipher.encryptBlock(this._finID));
                    if (this._decrypt && function(e, t) {
                        var r = 0;
                        e.length !== t.length && r++;
                        for(var n = Math.min(e.length, t.length), i = 0; i < n; ++i)r += e[i] ^ t[i];
                        return r;
                    }(e, this._authTag)) throw new Error("Unsupported state or unable to authenticate data");
                    this._authTag = e, this._cipher.scrub();
                }, u.prototype.getAuthTag = function() {
                    if (this._decrypt || !i.isBuffer(this._authTag)) throw new Error("Attempting to get auth tag in unsupported state");
                    return this._authTag;
                }, u.prototype.setAuthTag = function(e) {
                    if (!this._decrypt) throw new Error("Attempting to set auth tag in unsupported state");
                    this._authTag = e;
                }, u.prototype.setAAD = function(e) {
                    if (this._called) throw new Error("Attempting to set AAD in unsupported state");
                    this._ghash.update(e), this._alen += e.length;
                }, t.exports = u;
            },
            {
                "./aes": 189,
                "./ghash": 194,
                "./incr32": 195,
                "buffer-xor": 219,
                "cipher-base": 221,
                inherits: 440,
                "safe-buffer": 494
            }
        ],
        191: [
            function(e, t, r) {
                "use strict";
                var n = e("./encrypter"), i = e("./decrypter"), s = e("./modes/list.json");
                r.createCipher = r.Cipher = n.createCipher, r.createCipheriv = r.Cipheriv = n.createCipheriv, r.createDecipher = r.Decipher = i.createDecipher, r.createDecipheriv = r.Decipheriv = i.createDecipheriv, r.listCiphers = r.getCiphers = function() {
                    return Object.keys(s);
                };
            },
            {
                "./decrypter": 192,
                "./encrypter": 193,
                "./modes/list.json": 203
            }
        ],
        192: [
            function(e, t, r) {
                "use strict";
                var n = e("./authCipher"), i = e("safe-buffer").Buffer, s = e("./modes"), o = e("./streamCipher"), a = e("cipher-base"), l = e("./aes"), c = e("evp_bytestokey");
                function u(e, t, r) {
                    a.call(this), this._cache = new h, this._last = void 0, this._cipher = new l.AES(t), this._prev = i.from(r), this._mode = e, this._autopadding = !0;
                }
                function h() {
                    this.cache = i.allocUnsafe(0);
                }
                function f(e, t, r) {
                    var a = s[e.toLowerCase()];
                    if (!a) throw new TypeError("invalid suite type");
                    if ("string" == typeof r && (r = i.from(r)), "GCM" !== a.mode && r.length !== a.iv) throw new TypeError("invalid iv length " + r.length);
                    if ("string" == typeof t && (t = i.from(t)), t.length !== a.key / 8) throw new TypeError("invalid key length " + t.length);
                    return "stream" === a.type ? new o(a.module, t, r, !0) : "auth" === a.type ? new n(a.module, t, r, !0) : new u(a.module, t, r);
                }
                e("inherits")(u, a), u.prototype._update = function(e) {
                    var t, r;
                    this._cache.add(e);
                    for(var n = []; t = this._cache.get(this._autopadding);)r = this._mode.decrypt(this, t), n.push(r);
                    return i.concat(n);
                }, u.prototype._final = function() {
                    var e = this._cache.flush();
                    if (this._autopadding) return function(e) {
                        var t = e[15];
                        if (t < 1 || t > 16) throw new Error("unable to decrypt data");
                        var r = -1;
                        for(; ++r < t;)if (e[r + (16 - t)] !== t) throw new Error("unable to decrypt data");
                        if (16 === t) return;
                        return e.slice(0, 16 - t);
                    }(this._mode.decrypt(this, e));
                    if (e) throw new Error("data not multiple of block length");
                }, u.prototype.setAutoPadding = function(e) {
                    return this._autopadding = !!e, this;
                }, h.prototype.add = function(e) {
                    this.cache = i.concat([
                        this.cache,
                        e
                    ]);
                }, h.prototype.get = function(e) {
                    var t;
                    if (e) {
                        if (this.cache.length > 16) return t = this.cache.slice(0, 16), this.cache = this.cache.slice(16), t;
                    } else if (this.cache.length >= 16) return t = this.cache.slice(0, 16), this.cache = this.cache.slice(16), t;
                    return null;
                }, h.prototype.flush = function() {
                    if (this.cache.length) return this.cache;
                }, r.createDecipher = function(e, t) {
                    var r = s[e.toLowerCase()];
                    if (!r) throw new TypeError("invalid suite type");
                    var n = c(t, !1, r.key, r.iv);
                    return f(e, n.key, n.iv);
                }, r.createDecipheriv = f;
            },
            {
                "./aes": 189,
                "./authCipher": 190,
                "./modes": 202,
                "./streamCipher": 205,
                "cipher-base": 221,
                evp_bytestokey: 423,
                inherits: 440,
                "safe-buffer": 494
            }
        ],
        193: [
            function(e, t, r) {
                "use strict";
                var n = e("./modes"), i = e("./authCipher"), s = e("safe-buffer").Buffer, o = e("./streamCipher"), a = e("cipher-base"), l = e("./aes"), c = e("evp_bytestokey");
                function u(e, t, r) {
                    a.call(this), this._cache = new f, this._cipher = new l.AES(t), this._prev = s.from(r), this._mode = e, this._autopadding = !0;
                }
                e("inherits")(u, a), u.prototype._update = function(e) {
                    var t, r;
                    this._cache.add(e);
                    for(var n = []; t = this._cache.get();)r = this._mode.encrypt(this, t), n.push(r);
                    return s.concat(n);
                };
                var h = s.alloc(16, 16);
                function f() {
                    this.cache = s.allocUnsafe(0);
                }
                function d(e, t, r) {
                    var a = n[e.toLowerCase()];
                    if (!a) throw new TypeError("invalid suite type");
                    if ("string" == typeof t && (t = s.from(t)), t.length !== a.key / 8) throw new TypeError("invalid key length " + t.length);
                    if ("string" == typeof r && (r = s.from(r)), "GCM" !== a.mode && r.length !== a.iv) throw new TypeError("invalid iv length " + r.length);
                    return "stream" === a.type ? new o(a.module, t, r) : "auth" === a.type ? new i(a.module, t, r) : new u(a.module, t, r);
                }
                u.prototype._final = function() {
                    var e = this._cache.flush();
                    if (this._autopadding) return e = this._mode.encrypt(this, e), this._cipher.scrub(), e;
                    if (!e.equals(h)) throw this._cipher.scrub(), new Error("data not multiple of block length");
                }, u.prototype.setAutoPadding = function(e) {
                    return this._autopadding = !!e, this;
                }, f.prototype.add = function(e) {
                    this.cache = s.concat([
                        this.cache,
                        e
                    ]);
                }, f.prototype.get = function() {
                    if (this.cache.length > 15) {
                        var e = this.cache.slice(0, 16);
                        return this.cache = this.cache.slice(16), e;
                    }
                    return null;
                }, f.prototype.flush = function() {
                    for(var e = 16 - this.cache.length, t = s.allocUnsafe(e), r = -1; ++r < e;)t.writeUInt8(e, r);
                    return s.concat([
                        this.cache,
                        t
                    ]);
                }, r.createCipheriv = d, r.createCipher = function(e, t) {
                    var r = n[e.toLowerCase()];
                    if (!r) throw new TypeError("invalid suite type");
                    var i = c(t, !1, r.key, r.iv);
                    return d(e, i.key, i.iv);
                };
            },
            {
                "./aes": 189,
                "./authCipher": 190,
                "./modes": 202,
                "./streamCipher": 205,
                "cipher-base": 221,
                evp_bytestokey: 423,
                inherits: 440,
                "safe-buffer": 494
            }
        ],
        194: [
            function(e, t, r) {
                "use strict";
                var n = e("safe-buffer").Buffer, i = n.alloc(16, 0);
                function s(e) {
                    var t = n.allocUnsafe(16);
                    return t.writeUInt32BE(e[0] >>> 0, 0), t.writeUInt32BE(e[1] >>> 0, 4), t.writeUInt32BE(e[2] >>> 0, 8), t.writeUInt32BE(e[3] >>> 0, 12), t;
                }
                function o(e) {
                    this.h = e, this.state = n.alloc(16, 0), this.cache = n.allocUnsafe(0);
                }
                o.prototype.ghash = function(e) {
                    for(var t = -1; ++t < e.length;)this.state[t] ^= e[t];
                    this._multiply();
                }, o.prototype._multiply = function() {
                    for(var e, t, r, n = [
                        (e = this.h).readUInt32BE(0),
                        e.readUInt32BE(4),
                        e.readUInt32BE(8),
                        e.readUInt32BE(12)
                    ], i = [
                        0,
                        0,
                        0,
                        0
                    ], o = -1; ++o < 128;){
                        for(0 != (this.state[~~(o / 8)] & 1 << 7 - o % 8) && (i[0] ^= n[0], i[1] ^= n[1], i[2] ^= n[2], i[3] ^= n[3]), r = 0 != (1 & n[3]), t = 3; t > 0; t--)n[t] = n[t] >>> 1 | (1 & n[t - 1]) << 31;
                        n[0] = n[0] >>> 1, r && (n[0] = n[0] ^ -520093696);
                    }
                    this.state = s(i);
                }, o.prototype.update = function(e) {
                    var t;
                    for(this.cache = n.concat([
                        this.cache,
                        e
                    ]); this.cache.length >= 16;)t = this.cache.slice(0, 16), this.cache = this.cache.slice(16), this.ghash(t);
                }, o.prototype.final = function(e, t) {
                    return this.cache.length && this.ghash(n.concat([
                        this.cache,
                        i
                    ], 16)), this.ghash(s([
                        0,
                        e,
                        0,
                        t
                    ])), this.state;
                }, t.exports = o;
            },
            {
                "safe-buffer": 494
            }
        ],
        195: [
            function(e, t, r) {
                "use strict";
                t.exports = function(e) {
                    for(var t, r = e.length; r--;){
                        if (255 !== (t = e.readUInt8(r))) {
                            t++, e.writeUInt8(t, r);
                            break;
                        }
                        e.writeUInt8(0, r);
                    }
                };
            },
            {}
        ],
        196: [
            function(e, t, r) {
                "use strict";
                var n = e("buffer-xor");
                r.encrypt = function(e, t) {
                    var r = n(t, e._prev);
                    return e._prev = e._cipher.encryptBlock(r), e._prev;
                }, r.decrypt = function(e, t) {
                    var r = e._prev;
                    e._prev = t;
                    var i = e._cipher.decryptBlock(t);
                    return n(i, r);
                };
            },
            {
                "buffer-xor": 219
            }
        ],
        197: [
            function(e, t, r) {
                "use strict";
                var n = e("safe-buffer").Buffer, i = e("buffer-xor");
                function s(e, t, r) {
                    var s = t.length, o = i(t, e._cache);
                    return e._cache = e._cache.slice(s), e._prev = n.concat([
                        e._prev,
                        r ? t : o
                    ]), o;
                }
                r.encrypt = function(e, t, r) {
                    for(var i, o = n.allocUnsafe(0); t.length;){
                        if (0 === e._cache.length && (e._cache = e._cipher.encryptBlock(e._prev), e._prev = n.allocUnsafe(0)), !(e._cache.length <= t.length)) {
                            o = n.concat([
                                o,
                                s(e, t, r)
                            ]);
                            break;
                        }
                        i = e._cache.length, o = n.concat([
                            o,
                            s(e, t.slice(0, i), r)
                        ]), t = t.slice(i);
                    }
                    return o;
                };
            },
            {
                "buffer-xor": 219,
                "safe-buffer": 494
            }
        ],
        198: [
            function(e, t, r) {
                "use strict";
                var n = e("safe-buffer").Buffer;
                function i(e, t, r) {
                    for(var n, i, o = -1, a = 0; ++o < 8;)n = t & 1 << 7 - o ? 128 : 0, a += (128 & (i = e._cipher.encryptBlock(e._prev)[0] ^ n)) >> o % 8, e._prev = s(e._prev, r ? n : i);
                    return a;
                }
                function s(e, t) {
                    var r = e.length, i = -1, s = n.allocUnsafe(e.length);
                    for(e = n.concat([
                        e,
                        n.from([
                            t
                        ])
                    ]); ++i < r;)s[i] = e[i] << 1 | e[i + 1] >> 7;
                    return s;
                }
                r.encrypt = function(e, t, r) {
                    for(var s = t.length, o = n.allocUnsafe(s), a = -1; ++a < s;)o[a] = i(e, t[a], r);
                    return o;
                };
            },
            {
                "safe-buffer": 494
            }
        ],
        199: [
            function(e, t, r) {
                "use strict";
                var n = e("safe-buffer").Buffer;
                function i(e, t, r) {
                    var i = e._cipher.encryptBlock(e._prev)[0] ^ t;
                    return e._prev = n.concat([
                        e._prev.slice(1),
                        n.from([
                            r ? t : i
                        ])
                    ]), i;
                }
                r.encrypt = function(e, t, r) {
                    for(var s = t.length, o = n.allocUnsafe(s), a = -1; ++a < s;)o[a] = i(e, t[a], r);
                    return o;
                };
            },
            {
                "safe-buffer": 494
            }
        ],
        200: [
            function(e, t, r) {
                "use strict";
                var n = e("buffer-xor"), i = e("safe-buffer").Buffer, s = e("../incr32");
                function o(e) {
                    var t = e._cipher.encryptBlockRaw(e._prev);
                    return s(e._prev), t;
                }
                r.encrypt = function(e, t) {
                    var r = Math.ceil(t.length / 16), s = e._cache.length;
                    e._cache = i.concat([
                        e._cache,
                        i.allocUnsafe(16 * r)
                    ]);
                    for(var a = 0; a < r; a++){
                        var l = o(e), c = s + 16 * a;
                        e._cache.writeUInt32BE(l[0], c + 0), e._cache.writeUInt32BE(l[1], c + 4), e._cache.writeUInt32BE(l[2], c + 8), e._cache.writeUInt32BE(l[3], c + 12);
                    }
                    var u = e._cache.slice(0, t.length);
                    return e._cache = e._cache.slice(t.length), n(t, u);
                };
            },
            {
                "../incr32": 195,
                "buffer-xor": 219,
                "safe-buffer": 494
            }
        ],
        201: [
            function(e, t, r) {
                "use strict";
                r.encrypt = function(e, t) {
                    return e._cipher.encryptBlock(t);
                }, r.decrypt = function(e, t) {
                    return e._cipher.decryptBlock(t);
                };
            },
            {}
        ],
        202: [
            function(e, t, r) {
                "use strict";
                var n = {
                    ECB: e("./ecb"),
                    CBC: e("./cbc"),
                    CFB: e("./cfb"),
                    CFB8: e("./cfb8"),
                    CFB1: e("./cfb1"),
                    OFB: e("./ofb"),
                    CTR: e("./ctr"),
                    GCM: e("./ctr")
                }, i = e("./list.json");
                for(var s in i)i[s].module = n[i[s].mode];
                t.exports = i;
            },
            {
                "./cbc": 196,
                "./cfb": 197,
                "./cfb1": 198,
                "./cfb8": 199,
                "./ctr": 200,
                "./ecb": 201,
                "./list.json": 203,
                "./ofb": 204
            }
        ],
        203: [
            function(e, t, r) {
                t.exports = {
                    "aes-128-ecb": {
                        cipher: "AES",
                        key: 128,
                        iv: 0,
                        mode: "ECB",
                        type: "block"
                    },
                    "aes-192-ecb": {
                        cipher: "AES",
                        key: 192,
                        iv: 0,
                        mode: "ECB",
                        type: "block"
                    },
                    "aes-256-ecb": {
                        cipher: "AES",
                        key: 256,
                        iv: 0,
                        mode: "ECB",
                        type: "block"
                    },
                    "aes-128-cbc": {
                        cipher: "AES",
                        key: 128,
                        iv: 16,
                        mode: "CBC",
                        type: "block"
                    },
                    "aes-192-cbc": {
                        cipher: "AES",
                        key: 192,
                        iv: 16,
                        mode: "CBC",
                        type: "block"
                    },
                    "aes-256-cbc": {
                        cipher: "AES",
                        key: 256,
                        iv: 16,
                        mode: "CBC",
                        type: "block"
                    },
                    aes128: {
                        cipher: "AES",
                        key: 128,
                        iv: 16,
                        mode: "CBC",
                        type: "block"
                    },
                    aes192: {
                        cipher: "AES",
                        key: 192,
                        iv: 16,
                        mode: "CBC",
                        type: "block"
                    },
                    aes256: {
                        cipher: "AES",
                        key: 256,
                        iv: 16,
                        mode: "CBC",
                        type: "block"
                    },
                    "aes-128-cfb": {
                        cipher: "AES",
                        key: 128,
                        iv: 16,
                        mode: "CFB",
                        type: "stream"
                    },
                    "aes-192-cfb": {
                        cipher: "AES",
                        key: 192,
                        iv: 16,
                        mode: "CFB",
                        type: "stream"
                    },
                    "aes-256-cfb": {
                        cipher: "AES",
                        key: 256,
                        iv: 16,
                        mode: "CFB",
                        type: "stream"
                    },
                    "aes-128-cfb8": {
                        cipher: "AES",
                        key: 128,
                        iv: 16,
                        mode: "CFB8",
                        type: "stream"
                    },
                    "aes-192-cfb8": {
                        cipher: "AES",
                        key: 192,
                        iv: 16,
                        mode: "CFB8",
                        type: "stream"
                    },
                    "aes-256-cfb8": {
                        cipher: "AES",
                        key: 256,
                        iv: 16,
                        mode: "CFB8",
                        type: "stream"
                    },
                    "aes-128-cfb1": {
                        cipher: "AES",
                        key: 128,
                        iv: 16,
                        mode: "CFB1",
                        type: "stream"
                    },
                    "aes-192-cfb1": {
                        cipher: "AES",
                        key: 192,
                        iv: 16,
                        mode: "CFB1",
                        type: "stream"
                    },
                    "aes-256-cfb1": {
                        cipher: "AES",
                        key: 256,
                        iv: 16,
                        mode: "CFB1",
                        type: "stream"
                    },
                    "aes-128-ofb": {
                        cipher: "AES",
                        key: 128,
                        iv: 16,
                        mode: "OFB",
                        type: "stream"
                    },
                    "aes-192-ofb": {
                        cipher: "AES",
                        key: 192,
                        iv: 16,
                        mode: "OFB",
                        type: "stream"
                    },
                    "aes-256-ofb": {
                        cipher: "AES",
                        key: 256,
                        iv: 16,
                        mode: "OFB",
                        type: "stream"
                    },
                    "aes-128-ctr": {
                        cipher: "AES",
                        key: 128,
                        iv: 16,
                        mode: "CTR",
                        type: "stream"
                    },
                    "aes-192-ctr": {
                        cipher: "AES",
                        key: 192,
                        iv: 16,
                        mode: "CTR",
                        type: "stream"
                    },
                    "aes-256-ctr": {
                        cipher: "AES",
                        key: 256,
                        iv: 16,
                        mode: "CTR",
                        type: "stream"
                    },
                    "aes-128-gcm": {
                        cipher: "AES",
                        key: 128,
                        iv: 12,
                        mode: "GCM",
                        type: "auth"
                    },
                    "aes-192-gcm": {
                        cipher: "AES",
                        key: 192,
                        iv: 12,
                        mode: "GCM",
                        type: "auth"
                    },
                    "aes-256-gcm": {
                        cipher: "AES",
                        key: 256,
                        iv: 12,
                        mode: "GCM",
                        type: "auth"
                    }
                };
            },
            {}
        ],
        204: [
            function(e, t, r) {
                (function(t) {
                    (function() {
                        "use strict";
                        var n = e("buffer-xor");
                        function i(e) {
                            return e._prev = e._cipher.encryptBlock(e._prev), e._prev;
                        }
                        r.encrypt = function(e, r) {
                            for(; e._cache.length < r.length;)e._cache = t.concat([
                                e._cache,
                                i(e)
                            ]);
                            var s = e._cache.slice(0, r.length);
                            return e._cache = e._cache.slice(r.length), n(r, s);
                        };
                    }).call(this);
                }).call(this, e("buffer").Buffer);
            },
            {
                buffer: 220,
                "buffer-xor": 219
            }
        ],
        205: [
            function(e, t, r) {
                "use strict";
                var n = e("./aes"), i = e("safe-buffer").Buffer, s = e("cipher-base");
                function o(e, t, r, o) {
                    s.call(this), this._cipher = new n.AES(t), this._prev = i.from(r), this._cache = i.allocUnsafe(0), this._secCache = i.allocUnsafe(0), this._decrypt = o, this._mode = e;
                }
                e("inherits")(o, s), o.prototype._update = function(e) {
                    return this._mode.encrypt(this, e, this._decrypt);
                }, o.prototype._final = function() {
                    this._cipher.scrub();
                }, t.exports = o;
            },
            {
                "./aes": 189,
                "cipher-base": 221,
                inherits: 440,
                "safe-buffer": 494
            }
        ],
        206: [
            function(e, t, r) {
                "use strict";
                var n = e("browserify-des"), i = e("browserify-aes/browser"), s = e("browserify-aes/modes"), o = e("browserify-des/modes"), a = e("evp_bytestokey");
                function l(e, t, r) {
                    if (e = e.toLowerCase(), s[e]) return i.createCipheriv(e, t, r);
                    if (o[e]) return new n({
                        key: t,
                        iv: r,
                        mode: e
                    });
                    throw new TypeError("invalid suite type");
                }
                function c(e, t, r) {
                    if (e = e.toLowerCase(), s[e]) return i.createDecipheriv(e, t, r);
                    if (o[e]) return new n({
                        key: t,
                        iv: r,
                        mode: e,
                        decrypt: !0
                    });
                    throw new TypeError("invalid suite type");
                }
                r.createCipher = r.Cipher = function(e, t) {
                    var r, n;
                    if (e = e.toLowerCase(), s[e]) r = s[e].key, n = s[e].iv;
                    else {
                        if (!o[e]) throw new TypeError("invalid suite type");
                        r = 8 * o[e].key, n = o[e].iv;
                    }
                    var i = a(t, !1, r, n);
                    return l(e, i.key, i.iv);
                }, r.createCipheriv = r.Cipheriv = l, r.createDecipher = r.Decipher = function(e, t) {
                    var r, n;
                    if (e = e.toLowerCase(), s[e]) r = s[e].key, n = s[e].iv;
                    else {
                        if (!o[e]) throw new TypeError("invalid suite type");
                        r = 8 * o[e].key, n = o[e].iv;
                    }
                    var i = a(t, !1, r, n);
                    return c(e, i.key, i.iv);
                }, r.createDecipheriv = r.Decipheriv = c, r.listCiphers = r.getCiphers = function() {
                    return Object.keys(o).concat(i.getCiphers());
                };
            },
            {
                "browserify-aes/browser": 191,
                "browserify-aes/modes": 202,
                "browserify-des": 207,
                "browserify-des/modes": 208,
                evp_bytestokey: 423
            }
        ],
        207: [
            function(e, t, r) {
                "use strict";
                var n = e("cipher-base"), i = e("des.js"), s = e("inherits"), o = e("safe-buffer").Buffer, a = {
                    "des-ede3-cbc": i.CBC.instantiate(i.EDE),
                    "des-ede3": i.EDE,
                    "des-ede-cbc": i.CBC.instantiate(i.EDE),
                    "des-ede": i.EDE,
                    "des-cbc": i.CBC.instantiate(i.DES),
                    "des-ecb": i.DES
                };
                function l(e) {
                    n.call(this);
                    var t, r = e.mode.toLowerCase(), i = a[r];
                    t = e.decrypt ? "decrypt" : "encrypt";
                    var s = e.key;
                    o.isBuffer(s) || (s = o.from(s)), "des-ede" !== r && "des-ede-cbc" !== r || (s = o.concat([
                        s,
                        s.slice(0, 8)
                    ]));
                    var l = e.iv;
                    o.isBuffer(l) || (l = o.from(l)), this._des = i.create({
                        key: s,
                        iv: l,
                        type: t
                    });
                }
                a.des = a["des-cbc"], a.des3 = a["des-ede3-cbc"], t.exports = l, s(l, n), l.prototype._update = function(e) {
                    return o.from(this._des.update(e));
                }, l.prototype._final = function() {
                    return o.from(this._des.final());
                };
            },
            {
                "cipher-base": 221,
                "des.js": 394,
                inherits: 440,
                "safe-buffer": 494
            }
        ],
        208: [
            function(e, t, r) {
                "use strict";
                r["des-ecb"] = {
                    key: 8,
                    iv: 0
                }, r["des-cbc"] = r.des = {
                    key: 8,
                    iv: 8
                }, r["des-ede3-cbc"] = r.des3 = {
                    key: 24,
                    iv: 8
                }, r["des-ede3"] = {
                    key: 24,
                    iv: 0
                }, r["des-ede-cbc"] = {
                    key: 16,
                    iv: 8
                }, r["des-ede"] = {
                    key: 16,
                    iv: 0
                };
            },
            {}
        ],
        209: [
            function(e, t, r) {
                (function(r) {
                    (function() {
                        "use strict";
                        var n = e("bn.js"), i = e("randombytes");
                        function s(e) {
                            var t, r = e.modulus.byteLength();
                            do t = new n(i(r));
                            while (t.cmp(e.modulus) >= 0 || !t.umod(e.prime1) || !t.umod(e.prime2));
                            return t;
                        }
                        function o(e, t) {
                            var i = function(e) {
                                var t = s(e);
                                return {
                                    blinder: t.toRed(n.mont(e.modulus)).redPow(new n(e.publicExponent)).fromRed(),
                                    unblinder: t.invm(e.modulus)
                                };
                            }(t), o = t.modulus.byteLength(), a = new n(e).mul(i.blinder).umod(t.modulus), l = a.toRed(n.mont(t.prime1)), c = a.toRed(n.mont(t.prime2)), u = t.coefficient, h = t.prime1, f = t.prime2, d = l.redPow(t.exponent1).fromRed(), p = c.redPow(t.exponent2).fromRed(), m = d.isub(p).imul(u).umod(h).imul(f);
                            return p.iadd(m).imul(i.unblinder).umod(t.modulus).toArrayLike(r, "be", o);
                        }
                        o.getr = s, t.exports = o;
                    }).call(this);
                }).call(this, e("buffer").Buffer);
            },
            {
                "bn.js": 186,
                buffer: 220,
                randombytes: 475
            }
        ],
        210: [
            function(e, t, r) {
                "use strict";
                t.exports = e("./browser/algorithms.json");
            },
            {
                "./browser/algorithms.json": 211
            }
        ],
        211: [
            function(e, t, r) {
                t.exports = {
                    sha224WithRSAEncryption: {
                        sign: "rsa",
                        hash: "sha224",
                        id: "302d300d06096086480165030402040500041c"
                    },
                    "RSA-SHA224": {
                        sign: "ecdsa/rsa",
                        hash: "sha224",
                        id: "302d300d06096086480165030402040500041c"
                    },
                    sha256WithRSAEncryption: {
                        sign: "rsa",
                        hash: "sha256",
                        id: "3031300d060960864801650304020105000420"
                    },
                    "RSA-SHA256": {
                        sign: "ecdsa/rsa",
                        hash: "sha256",
                        id: "3031300d060960864801650304020105000420"
                    },
                    sha384WithRSAEncryption: {
                        sign: "rsa",
                        hash: "sha384",
                        id: "3041300d060960864801650304020205000430"
                    },
                    "RSA-SHA384": {
                        sign: "ecdsa/rsa",
                        hash: "sha384",
                        id: "3041300d060960864801650304020205000430"
                    },
                    sha512WithRSAEncryption: {
                        sign: "rsa",
                        hash: "sha512",
                        id: "3051300d060960864801650304020305000440"
                    },
                    "RSA-SHA512": {
                        sign: "ecdsa/rsa",
                        hash: "sha512",
                        id: "3051300d060960864801650304020305000440"
                    },
                    "RSA-SHA1": {
                        sign: "rsa",
                        hash: "sha1",
                        id: "3021300906052b0e03021a05000414"
                    },
                    "ecdsa-with-SHA1": {
                        sign: "ecdsa",
                        hash: "sha1",
                        id: ""
                    },
                    sha256: {
                        sign: "ecdsa",
                        hash: "sha256",
                        id: ""
                    },
                    sha224: {
                        sign: "ecdsa",
                        hash: "sha224",
                        id: ""
                    },
                    sha384: {
                        sign: "ecdsa",
                        hash: "sha384",
                        id: ""
                    },
                    sha512: {
                        sign: "ecdsa",
                        hash: "sha512",
                        id: ""
                    },
                    "DSA-SHA": {
                        sign: "dsa",
                        hash: "sha1",
                        id: ""
                    },
                    "DSA-SHA1": {
                        sign: "dsa",
                        hash: "sha1",
                        id: ""
                    },
                    DSA: {
                        sign: "dsa",
                        hash: "sha1",
                        id: ""
                    },
                    "DSA-WITH-SHA224": {
                        sign: "dsa",
                        hash: "sha224",
                        id: ""
                    },
                    "DSA-SHA224": {
                        sign: "dsa",
                        hash: "sha224",
                        id: ""
                    },
                    "DSA-WITH-SHA256": {
                        sign: "dsa",
                        hash: "sha256",
                        id: ""
                    },
                    "DSA-SHA256": {
                        sign: "dsa",
                        hash: "sha256",
                        id: ""
                    },
                    "DSA-WITH-SHA384": {
                        sign: "dsa",
                        hash: "sha384",
                        id: ""
                    },
                    "DSA-SHA384": {
                        sign: "dsa",
                        hash: "sha384",
                        id: ""
                    },
                    "DSA-WITH-SHA512": {
                        sign: "dsa",
                        hash: "sha512",
                        id: ""
                    },
                    "DSA-SHA512": {
                        sign: "dsa",
                        hash: "sha512",
                        id: ""
                    },
                    "DSA-RIPEMD160": {
                        sign: "dsa",
                        hash: "rmd160",
                        id: ""
                    },
                    ripemd160WithRSA: {
                        sign: "rsa",
                        hash: "rmd160",
                        id: "3021300906052b2403020105000414"
                    },
                    "RSA-RIPEMD160": {
                        sign: "rsa",
                        hash: "rmd160",
                        id: "3021300906052b2403020105000414"
                    },
                    md5WithRSAEncryption: {
                        sign: "rsa",
                        hash: "md5",
                        id: "3020300c06082a864886f70d020505000410"
                    },
                    "RSA-MD5": {
                        sign: "rsa",
                        hash: "md5",
                        id: "3020300c06082a864886f70d020505000410"
                    }
                };
            },
            {}
        ],
        212: [
            function(e, t, r) {
                t.exports = {
                    "1.3.132.0.10": "secp256k1",
                    "1.3.132.0.33": "p224",
                    "1.2.840.10045.3.1.1": "p192",
                    "1.2.840.10045.3.1.7": "p256",
                    "1.3.132.0.34": "p384",
                    "1.3.132.0.35": "p521"
                };
            },
            {}
        ],
        213: [
            function(e, t, r) {
                "use strict";
                var n = e("safe-buffer").Buffer, i = e("create-hash"), s = e("readable-stream"), o = e("inherits"), a = e("./sign"), l = e("./verify"), c = e("./algorithms.json");
                function u(e) {
                    s.Writable.call(this);
                    var t = c[e];
                    if (!t) throw new Error("Unknown message digest");
                    this._hashType = t.hash, this._hash = i(t.hash), this._tag = t.id, this._signType = t.sign;
                }
                function h(e) {
                    s.Writable.call(this);
                    var t = c[e];
                    if (!t) throw new Error("Unknown message digest");
                    this._hash = i(t.hash), this._tag = t.id, this._signType = t.sign;
                }
                function f(e) {
                    return new u(e);
                }
                function d(e) {
                    return new h(e);
                }
                Object.keys(c).forEach(function(e) {
                    c[e].id = n.from(c[e].id, "hex"), c[e.toLowerCase()] = c[e];
                }), o(u, s.Writable), u.prototype._write = function(e, t, r) {
                    this._hash.update(e), r();
                }, u.prototype.update = function(e, t) {
                    return "string" == typeof e && (e = n.from(e, t)), this._hash.update(e), this;
                }, u.prototype.sign = function(e, t) {
                    this.end();
                    var r = this._hash.digest(), n = a(r, e, this._hashType, this._signType, this._tag);
                    return t ? n.toString(t) : n;
                }, o(h, s.Writable), h.prototype._write = function(e, t, r) {
                    this._hash.update(e), r();
                }, h.prototype.update = function(e, t) {
                    return "string" == typeof e && (e = n.from(e, t)), this._hash.update(e), this;
                }, h.prototype.verify = function(e, t, r) {
                    "string" == typeof t && (t = n.from(t, r)), this.end();
                    var i = this._hash.digest();
                    return l(t, i, e, this._signType, this._tag);
                }, t.exports = {
                    Sign: f,
                    Verify: d,
                    createSign: f,
                    createVerify: d
                };
            },
            {
                "./algorithms.json": 211,
                "./sign": 214,
                "./verify": 215,
                "create-hash": 386,
                inherits: 440,
                "readable-stream": 491,
                "safe-buffer": 494
            }
        ],
        214: [
            function(e, t, r) {
                "use strict";
                var n = e("safe-buffer").Buffer, i = e("create-hmac"), s = e("browserify-rsa"), o = e("elliptic").ec, a = e("bn.js"), l = e("parse-asn1"), c = e("./curves.json");
                function u(e, t, r, s) {
                    if ((e = n.from(e.toArray())).length < t.byteLength()) {
                        var o = n.alloc(t.byteLength() - e.length);
                        e = n.concat([
                            o,
                            e
                        ]);
                    }
                    var a = r.length, l = function(e, t) {
                        e = (e = h(e, t)).mod(t);
                        var r = n.from(e.toArray());
                        if (r.length < t.byteLength()) {
                            var i = n.alloc(t.byteLength() - r.length);
                            r = n.concat([
                                i,
                                r
                            ]);
                        }
                        return r;
                    }(r, t), c = n.alloc(a);
                    c.fill(1);
                    var u = n.alloc(a);
                    return u = i(s, u).update(c).update(n.from([
                        0
                    ])).update(e).update(l).digest(), c = i(s, u).update(c).digest(), {
                        k: u = i(s, u).update(c).update(n.from([
                            1
                        ])).update(e).update(l).digest(),
                        v: c = i(s, u).update(c).digest()
                    };
                }
                function h(e, t) {
                    var r = new a(e), n = (e.length << 3) - t.bitLength();
                    return n > 0 && r.ishrn(n), r;
                }
                function f(e, t, r) {
                    var s, o;
                    do {
                        for(s = n.alloc(0); 8 * s.length < e.bitLength();)t.v = i(r, t.k).update(t.v).digest(), s = n.concat([
                            s,
                            t.v
                        ]);
                        o = h(s, e), t.k = i(r, t.k).update(t.v).update(n.from([
                            0
                        ])).digest(), t.v = i(r, t.k).update(t.v).digest();
                    }while (-1 !== o.cmp(e));
                    return o;
                }
                function d(e, t, r, n) {
                    return e.toRed(a.mont(r)).redPow(t).fromRed().mod(n);
                }
                t.exports = function(e, t, r, i, p) {
                    var m = l(t);
                    if (m.curve) {
                        if ("ecdsa" !== i && "ecdsa/rsa" !== i) throw new Error("wrong private key type");
                        return function(e, t) {
                            var r = c[t.curve.join(".")];
                            if (!r) throw new Error("unknown curve " + t.curve.join("."));
                            var i = new o(r).keyFromPrivate(t.privateKey).sign(e);
                            return n.from(i.toDER());
                        }(e, m);
                    }
                    if ("dsa" === m.type) {
                        if ("dsa" !== i) throw new Error("wrong private key type");
                        return function(e, t, r) {
                            var i, s = t.params.priv_key, o = t.params.p, l = t.params.q, c = t.params.g, p = new a(0), m = h(e, l).mod(l), b = !1, g = u(s, l, e, r);
                            for(; !1 === b;)i = f(l, g, r), p = d(c, i, o, l), 0 === (b = i.invm(l).imul(m.add(s.mul(p))).mod(l)).cmpn(0) && (b = !1, p = new a(0));
                            return function(e, t) {
                                e = e.toArray(), t = t.toArray(), 128 & e[0] && (e = [
                                    0
                                ].concat(e));
                                128 & t[0] && (t = [
                                    0
                                ].concat(t));
                                var r = [
                                    48,
                                    e.length + t.length + 4,
                                    2,
                                    e.length
                                ];
                                return r = r.concat(e, [
                                    2,
                                    t.length
                                ], t), n.from(r);
                            }(p, b);
                        }(e, m, r);
                    }
                    if ("rsa" !== i && "ecdsa/rsa" !== i) throw new Error("wrong private key type");
                    e = n.concat([
                        p,
                        e
                    ]);
                    for(var b = m.modulus.byteLength(), g = [
                        0,
                        1
                    ]; e.length + g.length + 1 < b;)g.push(255);
                    g.push(0);
                    for(var y = -1; ++y < e.length;)g.push(e[y]);
                    return s(g, m);
                }, t.exports.getKey = u, t.exports.makeKey = f;
            },
            {
                "./curves.json": 212,
                "bn.js": 186,
                "browserify-rsa": 209,
                "create-hmac": 388,
                elliptic: 405,
                "parse-asn1": 459,
                "safe-buffer": 494
            }
        ],
        215: [
            function(e, t, r) {
                "use strict";
                var n = e("safe-buffer").Buffer, i = e("bn.js"), s = e("elliptic").ec, o = e("parse-asn1"), a = e("./curves.json");
                function l(e, t) {
                    if (e.cmpn(0) <= 0) throw new Error("invalid sig");
                    if (e.cmp(t) >= t) throw new Error("invalid sig");
                }
                t.exports = function(e, t, r, c, u) {
                    var h = o(r);
                    if ("ec" === h.type) {
                        if ("ecdsa" !== c && "ecdsa/rsa" !== c) throw new Error("wrong public key type");
                        return function(e, t, r) {
                            var n = a[r.data.algorithm.curve.join(".")];
                            if (!n) throw new Error("unknown curve " + r.data.algorithm.curve.join("."));
                            var i = new s(n), o = r.data.subjectPrivateKey.data;
                            return i.verify(t, e, o);
                        }(e, t, h);
                    }
                    if ("dsa" === h.type) {
                        if ("dsa" !== c) throw new Error("wrong public key type");
                        return function(e, t, r) {
                            var n = r.data.p, s = r.data.q, a = r.data.g, c = r.data.pub_key, u = o.signature.decode(e, "der"), h = u.s, f = u.r;
                            l(h, s), l(f, s);
                            var d = i.mont(n), p = h.invm(s);
                            return 0 === a.toRed(d).redPow(new i(t).mul(p).mod(s)).fromRed().mul(c.toRed(d).redPow(f.mul(p).mod(s)).fromRed()).mod(n).mod(s).cmp(f);
                        }(e, t, h);
                    }
                    if ("rsa" !== c && "ecdsa/rsa" !== c) throw new Error("wrong public key type");
                    t = n.concat([
                        u,
                        t
                    ]);
                    for(var f = h.modulus.byteLength(), d = [
                        1
                    ], p = 0; t.length + d.length + 2 < f;)d.push(255), p++;
                    d.push(0);
                    for(var m = -1; ++m < t.length;)d.push(t[m]);
                    d = n.from(d);
                    var b = i.mont(h.modulus);
                    e = (e = new i(e).toRed(b)).redPow(new i(h.publicExponent)), e = n.from(e.fromRed().toArray());
                    var g = p < 8 ? 1 : 0;
                    for(f = Math.min(e.length, d.length), e.length !== d.length && (g = 1), m = -1; ++m < f;)g |= e[m] ^ d[m];
                    return 0 === g;
                };
            },
            {
                "./curves.json": 212,
                "bn.js": 186,
                elliptic: 405,
                "parse-asn1": 459,
                "safe-buffer": 494
            }
        ],
        216: [
            function(e, t, r) {},
            {}
        ],
        217: [
            function(e, t, r) {
                "use strict";
                var n = e("buffer"), i = n.Buffer;
                function s(e, t) {
                    for(var r in e)t[r] = e[r];
                }
                function o(e, t, r) {
                    return i(e, t, r);
                }
                i.from && i.alloc && i.allocUnsafe && i.allocUnsafeSlow ? t.exports = n : (s(n, r), r.Buffer = o), s(i, o), o.from = function(e, t, r) {
                    if ("number" == typeof e) throw new TypeError("Argument must not be a number");
                    return i(e, t, r);
                }, o.alloc = function(e, t, r) {
                    if ("number" != typeof e) throw new TypeError("Argument must be a number");
                    var n = i(e);
                    return void 0 !== t ? "string" == typeof r ? n.fill(t, r) : n.fill(t) : n.fill(0), n;
                }, o.allocUnsafe = function(e) {
                    if ("number" != typeof e) throw new TypeError("Argument must be a number");
                    return i(e);
                }, o.allocUnsafeSlow = function(e) {
                    if ("number" != typeof e) throw new TypeError("Argument must be a number");
                    return n.SlowBuffer(e);
                };
            },
            {
                buffer: 220
            }
        ],
        218: [
            function(e, t, r) {
                "use strict";
                var n = e("safe-buffer").Buffer, i = n.isEncoding || function(e) {
                    switch((e = "" + e) && e.toLowerCase()){
                        case "hex":
                        case "utf8":
                        case "utf-8":
                        case "ascii":
                        case "binary":
                        case "base64":
                        case "ucs2":
                        case "ucs-2":
                        case "utf16le":
                        case "utf-16le":
                        case "raw":
                            return !0;
                        default:
                            return !1;
                    }
                };
                function s(e) {
                    var t;
                    switch(this.encoding = function(e) {
                        var t = function(e) {
                            if (!e) return "utf8";
                            for(var t;;)switch(e){
                                case "utf8":
                                case "utf-8":
                                    return "utf8";
                                case "ucs2":
                                case "ucs-2":
                                case "utf16le":
                                case "utf-16le":
                                    return "utf16le";
                                case "latin1":
                                case "binary":
                                    return "latin1";
                                case "base64":
                                case "ascii":
                                case "hex":
                                    return e;
                                default:
                                    if (t) return;
                                    e = ("" + e).toLowerCase(), t = !0;
                            }
                        }(e);
                        if ("string" != typeof t && (n.isEncoding === i || !i(e))) throw new Error("Unknown encoding: " + e);
                        return t || e;
                    }(e), this.encoding){
                        case "utf16le":
                            this.text = l, this.end = c, t = 4;
                            break;
                        case "utf8":
                            this.fillLast = a, t = 4;
                            break;
                        case "base64":
                            this.text = u, this.end = h, t = 3;
                            break;
                        default:
                            return this.write = f, void (this.end = d);
                    }
                    this.lastNeed = 0, this.lastTotal = 0, this.lastChar = n.allocUnsafe(t);
                }
                function o(e) {
                    return e <= 127 ? 0 : e >> 5 == 6 ? 2 : e >> 4 == 14 ? 3 : e >> 3 == 30 ? 4 : e >> 6 == 2 ? -1 : -2;
                }
                function a(e) {
                    var t = this.lastTotal - this.lastNeed, r = function(e, t, r) {
                        if (128 != (192 & t[0])) return e.lastNeed = 0, "\ufffd";
                        if (e.lastNeed > 1 && t.length > 1) {
                            if (128 != (192 & t[1])) return e.lastNeed = 1, "\ufffd";
                            if (e.lastNeed > 2 && t.length > 2 && 128 != (192 & t[2])) return e.lastNeed = 2, "\ufffd";
                        }
                    }(this, e);
                    return void 0 !== r ? r : this.lastNeed <= e.length ? (e.copy(this.lastChar, t, 0, this.lastNeed), this.lastChar.toString(this.encoding, 0, this.lastTotal)) : (e.copy(this.lastChar, t, 0, e.length), void (this.lastNeed -= e.length));
                }
                function l(e, t) {
                    if ((e.length - t) % 2 == 0) {
                        var r = e.toString("utf16le", t);
                        if (r) {
                            var n = r.charCodeAt(r.length - 1);
                            if (n >= 55296 && n <= 56319) return this.lastNeed = 2, this.lastTotal = 4, this.lastChar[0] = e[e.length - 2], this.lastChar[1] = e[e.length - 1], r.slice(0, -1);
                        }
                        return r;
                    }
                    return this.lastNeed = 1, this.lastTotal = 2, this.lastChar[0] = e[e.length - 1], e.toString("utf16le", t, e.length - 1);
                }
                function c(e) {
                    var t = e && e.length ? this.write(e) : "";
                    if (this.lastNeed) {
                        var r = this.lastTotal - this.lastNeed;
                        return t + this.lastChar.toString("utf16le", 0, r);
                    }
                    return t;
                }
                function u(e, t) {
                    var r = (e.length - t) % 3;
                    return 0 === r ? e.toString("base64", t) : (this.lastNeed = 3 - r, this.lastTotal = 3, 1 === r ? this.lastChar[0] = e[e.length - 1] : (this.lastChar[0] = e[e.length - 2], this.lastChar[1] = e[e.length - 1]), e.toString("base64", t, e.length - r));
                }
                function h(e) {
                    var t = e && e.length ? this.write(e) : "";
                    return this.lastNeed ? t + this.lastChar.toString("base64", 0, 3 - this.lastNeed) : t;
                }
                function f(e) {
                    return e.toString(this.encoding);
                }
                function d(e) {
                    return e && e.length ? this.write(e) : "";
                }
                r.StringDecoder = s, s.prototype.write = function(e) {
                    if (0 === e.length) return "";
                    var t, r;
                    if (this.lastNeed) {
                        if (void 0 === (t = this.fillLast(e))) return "";
                        r = this.lastNeed, this.lastNeed = 0;
                    } else r = 0;
                    return r < e.length ? t ? t + this.text(e, r) : this.text(e, r) : t || "";
                }, s.prototype.end = function(e) {
                    var t = e && e.length ? this.write(e) : "";
                    return this.lastNeed ? t + "\ufffd" : t;
                }, s.prototype.text = function(e, t) {
                    var r = function(e, t, r) {
                        var n = t.length - 1;
                        if (n < r) return 0;
                        var i = o(t[n]);
                        if (i >= 0) return i > 0 && (e.lastNeed = i - 1), i;
                        if (--n < r || -2 === i) return 0;
                        if ((i = o(t[n])) >= 0) return i > 0 && (e.lastNeed = i - 2), i;
                        if (--n < r || -2 === i) return 0;
                        if ((i = o(t[n])) >= 0) return i > 0 && (2 === i ? i = 0 : e.lastNeed = i - 3), i;
                        return 0;
                    }(this, e, t);
                    if (!this.lastNeed) return e.toString("utf8", t);
                    this.lastTotal = r;
                    var n = e.length - (r - this.lastNeed);
                    return e.copy(this.lastChar, 0, n), e.toString("utf8", t, n);
                }, s.prototype.fillLast = function(e) {
                    if (this.lastNeed <= e.length) return e.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, this.lastNeed), this.lastChar.toString(this.encoding, 0, this.lastTotal);
                    e.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, e.length), this.lastNeed -= e.length;
                };
            },
            {
                "safe-buffer": 217
            }
        ],
        219: [
            function(e, t, r) {
                (function(e) {
                    (function() {
                        "use strict";
                        t.exports = function(t, r) {
                            for(var n = Math.min(t.length, r.length), i = new e(n), s = 0; s < n; ++s)i[s] = t[s] ^ r[s];
                            return i;
                        };
                    }).call(this);
                }).call(this, e("buffer").Buffer);
            },
            {
                buffer: 220
            }
        ],
        220: [
            function(e, t, r) {
                (function(t) {
                    (function() {
                        /*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ "use strict";
                        var t = e("base64-js"), n = e("ieee754");
                        r.Buffer = s, r.SlowBuffer = function(e) {
                            +e != e && (e = 0);
                            return s.alloc(+e);
                        }, r.INSPECT_MAX_BYTES = 50;
                        function i(e) {
                            if (e > 2147483647) throw new RangeError('The value "' + e + '" is invalid for option "size"');
                            var t = new Uint8Array(e);
                            return t.__proto__ = s.prototype, t;
                        }
                        function s(e, t, r) {
                            if ("number" == typeof e) {
                                if ("string" == typeof t) throw new TypeError('The "string" argument must be of type string. Received type number');
                                return l(e);
                            }
                            return o(e, t, r);
                        }
                        function o(e, t, r) {
                            if ("string" == typeof e) return function(e, t) {
                                "string" == typeof t && "" !== t || (t = "utf8");
                                if (!s.isEncoding(t)) throw new TypeError("Unknown encoding: " + t);
                                var r = 0 | h(e, t), n = i(r), o = n.write(e, t);
                                o !== r && (n = n.slice(0, o));
                                return n;
                            }(e, t);
                            if (ArrayBuffer.isView(e)) return c(e);
                            if (null == e) throw TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof e);
                            if (F(e, ArrayBuffer) || e && F(e.buffer, ArrayBuffer)) return function(e, t, r) {
                                if (t < 0 || e.byteLength < t) throw new RangeError('"offset" is outside of buffer bounds');
                                if (e.byteLength < t + (r || 0)) throw new RangeError('"length" is outside of buffer bounds');
                                var n;
                                n = void 0 === t && void 0 === r ? new Uint8Array(e) : void 0 === r ? new Uint8Array(e, t) : new Uint8Array(e, t, r);
                                return n.__proto__ = s.prototype, n;
                            }(e, t, r);
                            if ("number" == typeof e) throw new TypeError('The "value" argument must not be of type number. Received type number');
                            var n = e.valueOf && e.valueOf();
                            if (null != n && n !== e) return s.from(n, t, r);
                            var o = function(e) {
                                if (s.isBuffer(e)) {
                                    var t = 0 | u(e.length), r = i(t);
                                    return 0 === r.length || e.copy(r, 0, 0, t), r;
                                }
                                if (void 0 !== e.length) return "number" != typeof e.length || L(e.length) ? i(0) : c(e);
                                if ("Buffer" === e.type && Array.isArray(e.data)) return c(e.data);
                            }(e);
                            if (o) return o;
                            if ("undefined" != typeof Symbol && null != Symbol.toPrimitive && "function" == typeof e[Symbol.toPrimitive]) return s.from(e[Symbol.toPrimitive]("string"), t, r);
                            throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof e);
                        }
                        function a(e) {
                            if ("number" != typeof e) throw new TypeError('"size" argument must be of type number');
                            if (e < 0) throw new RangeError('The value "' + e + '" is invalid for option "size"');
                        }
                        function l(e) {
                            return a(e), i(e < 0 ? 0 : 0 | u(e));
                        }
                        function c(e) {
                            for(var t = e.length < 0 ? 0 : 0 | u(e.length), r = i(t), n = 0; n < t; n += 1)r[n] = 255 & e[n];
                            return r;
                        }
                        function u(e) {
                            if (e >= 2147483647) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + 2147483647..toString(16) + " bytes");
                            return 0 | e;
                        }
                        function h(e, t) {
                            if (s.isBuffer(e)) return e.length;
                            if (ArrayBuffer.isView(e) || F(e, ArrayBuffer)) return e.byteLength;
                            if ("string" != typeof e) throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof e);
                            var r = e.length, n = arguments.length > 2 && !0 === arguments[2];
                            if (!n && 0 === r) return 0;
                            for(var i = !1;;)switch(t){
                                case "ascii":
                                case "latin1":
                                case "binary":
                                    return r;
                                case "utf8":
                                case "utf-8":
                                    return P(e).length;
                                case "ucs2":
                                case "ucs-2":
                                case "utf16le":
                                case "utf-16le":
                                    return 2 * r;
                                case "hex":
                                    return r >>> 1;
                                case "base64":
                                    return B(e).length;
                                default:
                                    if (i) return n ? -1 : P(e).length;
                                    t = ("" + t).toLowerCase(), i = !0;
                            }
                        }
                        function f(e, t, r) {
                            var n = !1;
                            if ((void 0 === t || t < 0) && (t = 0), t > this.length) return "";
                            if ((void 0 === r || r > this.length) && (r = this.length), r <= 0) return "";
                            if ((r >>>= 0) <= (t >>>= 0)) return "";
                            for(e || (e = "utf8");;)switch(e){
                                case "hex":
                                    return C(this, t, r);
                                case "utf8":
                                case "utf-8":
                                    return k(this, t, r);
                                case "ascii":
                                    return S(this, t, r);
                                case "latin1":
                                case "binary":
                                    return M(this, t, r);
                                case "base64":
                                    return x(this, t, r);
                                case "ucs2":
                                case "ucs-2":
                                case "utf16le":
                                case "utf-16le":
                                    return T(this, t, r);
                                default:
                                    if (n) throw new TypeError("Unknown encoding: " + e);
                                    e = (e + "").toLowerCase(), n = !0;
                            }
                        }
                        function d(e, t, r) {
                            var n = e[t];
                            e[t] = e[r], e[r] = n;
                        }
                        function p(e, t, r, n, i) {
                            if (0 === e.length) return -1;
                            if ("string" == typeof r ? (n = r, r = 0) : r > 2147483647 ? r = 2147483647 : r < -2147483648 && (r = -2147483648), L(r = +r) && (r = i ? 0 : e.length - 1), r < 0 && (r = e.length + r), r >= e.length) {
                                if (i) return -1;
                                r = e.length - 1;
                            } else if (r < 0) {
                                if (!i) return -1;
                                r = 0;
                            }
                            if ("string" == typeof t && (t = s.from(t, n)), s.isBuffer(t)) return 0 === t.length ? -1 : m(e, t, r, n, i);
                            if ("number" == typeof t) return t &= 255, "function" == typeof Uint8Array.prototype.indexOf ? i ? Uint8Array.prototype.indexOf.call(e, t, r) : Uint8Array.prototype.lastIndexOf.call(e, t, r) : m(e, [
                                t
                            ], r, n, i);
                            throw new TypeError("val must be string, number or Buffer");
                        }
                        function m(e, t, r, n, i) {
                            var s, o = 1, a = e.length, l = t.length;
                            if (void 0 !== n && ("ucs2" === (n = String(n).toLowerCase()) || "ucs-2" === n || "utf16le" === n || "utf-16le" === n)) {
                                if (e.length < 2 || t.length < 2) return -1;
                                o = 2, a /= 2, l /= 2, r /= 2;
                            }
                            function c(e, t) {
                                return 1 === o ? e[t] : e.readUInt16BE(t * o);
                            }
                            if (i) {
                                var u = -1;
                                for(s = r; s < a; s++)if (c(e, s) === c(t, -1 === u ? 0 : s - u)) {
                                    if (-1 === u && (u = s), s - u + 1 === l) return u * o;
                                } else -1 !== u && (s -= s - u), u = -1;
                            } else for(r + l > a && (r = a - l), s = r; s >= 0; s--){
                                for(var h = !0, f = 0; f < l; f++)if (c(e, s + f) !== c(t, f)) {
                                    h = !1;
                                    break;
                                }
                                if (h) return s;
                            }
                            return -1;
                        }
                        function b(e, t, r, n) {
                            r = Number(r) || 0;
                            var i = e.length - r;
                            n ? (n = Number(n)) > i && (n = i) : n = i;
                            var s = t.length;
                            n > s / 2 && (n = s / 2);
                            for(var o = 0; o < n; ++o){
                                var a = parseInt(t.substr(2 * o, 2), 16);
                                if (L(a)) return o;
                                e[r + o] = a;
                            }
                            return o;
                        }
                        function g(e, t, r, n) {
                            return D(P(t, e.length - r), e, r, n);
                        }
                        function y(e, t, r, n) {
                            return D(function(e) {
                                for(var t = [], r = 0; r < e.length; ++r)t.push(255 & e.charCodeAt(r));
                                return t;
                            }(t), e, r, n);
                        }
                        function v(e, t, r, n) {
                            return y(e, t, r, n);
                        }
                        function w(e, t, r, n) {
                            return D(B(t), e, r, n);
                        }
                        function _(e, t, r, n) {
                            return D(function(e, t) {
                                for(var r, n, i, s = [], o = 0; o < e.length && !((t -= 2) < 0); ++o)r = e.charCodeAt(o), n = r >> 8, i = r % 256, s.push(i), s.push(n);
                                return s;
                            }(t, e.length - r), e, r, n);
                        }
                        function x(e, r, n) {
                            return 0 === r && n === e.length ? t.fromByteArray(e) : t.fromByteArray(e.slice(r, n));
                        }
                        function k(e, t, r) {
                            r = Math.min(e.length, r);
                            for(var n = [], i = t; i < r;){
                                var s, o, a, l, c = e[i], u = null, h = c > 239 ? 4 : c > 223 ? 3 : c > 191 ? 2 : 1;
                                if (i + h <= r) switch(h){
                                    case 1:
                                        c < 128 && (u = c);
                                        break;
                                    case 2:
                                        128 == (192 & (s = e[i + 1])) && (l = (31 & c) << 6 | 63 & s) > 127 && (u = l);
                                        break;
                                    case 3:
                                        s = e[i + 1], o = e[i + 2], 128 == (192 & s) && 128 == (192 & o) && (l = (15 & c) << 12 | (63 & s) << 6 | 63 & o) > 2047 && (l < 55296 || l > 57343) && (u = l);
                                        break;
                                    case 4:
                                        s = e[i + 1], o = e[i + 2], a = e[i + 3], 128 == (192 & s) && 128 == (192 & o) && 128 == (192 & a) && (l = (15 & c) << 18 | (63 & s) << 12 | (63 & o) << 6 | 63 & a) > 65535 && l < 1114112 && (u = l);
                                }
                                null === u ? (u = 65533, h = 1) : u > 65535 && (u -= 65536, n.push(u >>> 10 & 1023 | 55296), u = 56320 | 1023 & u), n.push(u), i += h;
                            }
                            return function(e) {
                                var t = e.length;
                                if (t <= 4096) return String.fromCharCode.apply(String, e);
                                var r = "", n = 0;
                                for(; n < t;)r += String.fromCharCode.apply(String, e.slice(n, n += 4096));
                                return r;
                            }(n);
                        }
                        r.kMaxLength = 2147483647, s.TYPED_ARRAY_SUPPORT = function() {
                            try {
                                var e = new Uint8Array(1);
                                return e.__proto__ = {
                                    __proto__: Uint8Array.prototype,
                                    foo: function() {
                                        return 42;
                                    }
                                }, 42 === e.foo();
                            } catch (e) {
                                return !1;
                            }
                        }(), s.TYPED_ARRAY_SUPPORT || "undefined" == typeof console || "function" != typeof console.error || console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support."), Object.defineProperty(s.prototype, "parent", {
                            enumerable: !0,
                            get: function() {
                                if (s.isBuffer(this)) return this.buffer;
                            }
                        }), Object.defineProperty(s.prototype, "offset", {
                            enumerable: !0,
                            get: function() {
                                if (s.isBuffer(this)) return this.byteOffset;
                            }
                        }), "undefined" != typeof Symbol && null != Symbol.species && s[Symbol.species] === s && Object.defineProperty(s, Symbol.species, {
                            value: null,
                            configurable: !0,
                            enumerable: !1,
                            writable: !1
                        }), s.poolSize = 8192, s.from = function(e, t, r) {
                            return o(e, t, r);
                        }, s.prototype.__proto__ = Uint8Array.prototype, s.__proto__ = Uint8Array, s.alloc = function(e, t, r) {
                            return function(e, t, r) {
                                return a(e), e <= 0 ? i(e) : void 0 !== t ? "string" == typeof r ? i(e).fill(t, r) : i(e).fill(t) : i(e);
                            }(e, t, r);
                        }, s.allocUnsafe = function(e) {
                            return l(e);
                        }, s.allocUnsafeSlow = function(e) {
                            return l(e);
                        }, s.isBuffer = function(e) {
                            return null != e && !0 === e._isBuffer && e !== s.prototype;
                        }, s.compare = function(e, t) {
                            if (F(e, Uint8Array) && (e = s.from(e, e.offset, e.byteLength)), F(t, Uint8Array) && (t = s.from(t, t.offset, t.byteLength)), !s.isBuffer(e) || !s.isBuffer(t)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
                            if (e === t) return 0;
                            for(var r = e.length, n = t.length, i = 0, o = Math.min(r, n); i < o; ++i)if (e[i] !== t[i]) {
                                r = e[i], n = t[i];
                                break;
                            }
                            return r < n ? -1 : n < r ? 1 : 0;
                        }, s.isEncoding = function(e) {
                            switch(String(e).toLowerCase()){
                                case "hex":
                                case "utf8":
                                case "utf-8":
                                case "ascii":
                                case "latin1":
                                case "binary":
                                case "base64":
                                case "ucs2":
                                case "ucs-2":
                                case "utf16le":
                                case "utf-16le":
                                    return !0;
                                default:
                                    return !1;
                            }
                        }, s.concat = function(e, t) {
                            if (!Array.isArray(e)) throw new TypeError('"list" argument must be an Array of Buffers');
                            if (0 === e.length) return s.alloc(0);
                            var r;
                            if (void 0 === t) for(t = 0, r = 0; r < e.length; ++r)t += e[r].length;
                            var n = s.allocUnsafe(t), i = 0;
                            for(r = 0; r < e.length; ++r){
                                var o = e[r];
                                if (F(o, Uint8Array) && (o = s.from(o)), !s.isBuffer(o)) throw new TypeError('"list" argument must be an Array of Buffers');
                                o.copy(n, i), i += o.length;
                            }
                            return n;
                        }, s.byteLength = h, s.prototype._isBuffer = !0, s.prototype.swap16 = function() {
                            var e = this.length;
                            if (e % 2 != 0) throw new RangeError("Buffer size must be a multiple of 16-bits");
                            for(var t = 0; t < e; t += 2)d(this, t, t + 1);
                            return this;
                        }, s.prototype.swap32 = function() {
                            var e = this.length;
                            if (e % 4 != 0) throw new RangeError("Buffer size must be a multiple of 32-bits");
                            for(var t = 0; t < e; t += 4)d(this, t, t + 3), d(this, t + 1, t + 2);
                            return this;
                        }, s.prototype.swap64 = function() {
                            var e = this.length;
                            if (e % 8 != 0) throw new RangeError("Buffer size must be a multiple of 64-bits");
                            for(var t = 0; t < e; t += 8)d(this, t, t + 7), d(this, t + 1, t + 6), d(this, t + 2, t + 5), d(this, t + 3, t + 4);
                            return this;
                        }, s.prototype.toString = function() {
                            var e = this.length;
                            return 0 === e ? "" : 0 === arguments.length ? k(this, 0, e) : f.apply(this, arguments);
                        }, s.prototype.toLocaleString = s.prototype.toString, s.prototype.equals = function(e) {
                            if (!s.isBuffer(e)) throw new TypeError("Argument must be a Buffer");
                            return this === e || 0 === s.compare(this, e);
                        }, s.prototype.inspect = function() {
                            var e = "", t = r.INSPECT_MAX_BYTES;
                            return e = this.toString("hex", 0, t).replace(/(.{2})/g, "$1 ").trim(), this.length > t && (e += " ... "), "<Buffer " + e + ">";
                        }, s.prototype.compare = function(e, t, r, n, i) {
                            if (F(e, Uint8Array) && (e = s.from(e, e.offset, e.byteLength)), !s.isBuffer(e)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof e);
                            if (void 0 === t && (t = 0), void 0 === r && (r = e ? e.length : 0), void 0 === n && (n = 0), void 0 === i && (i = this.length), t < 0 || r > e.length || n < 0 || i > this.length) throw new RangeError("out of range index");
                            if (n >= i && t >= r) return 0;
                            if (n >= i) return -1;
                            if (t >= r) return 1;
                            if (this === e) return 0;
                            for(var o = (i >>>= 0) - (n >>>= 0), a = (r >>>= 0) - (t >>>= 0), l = Math.min(o, a), c = this.slice(n, i), u = e.slice(t, r), h = 0; h < l; ++h)if (c[h] !== u[h]) {
                                o = c[h], a = u[h];
                                break;
                            }
                            return o < a ? -1 : a < o ? 1 : 0;
                        }, s.prototype.includes = function(e, t, r) {
                            return -1 !== this.indexOf(e, t, r);
                        }, s.prototype.indexOf = function(e, t, r) {
                            return p(this, e, t, r, !0);
                        }, s.prototype.lastIndexOf = function(e, t, r) {
                            return p(this, e, t, r, !1);
                        }, s.prototype.write = function(e, t, r, n) {
                            if (void 0 === t) n = "utf8", r = this.length, t = 0;
                            else if (void 0 === r && "string" == typeof t) n = t, r = this.length, t = 0;
                            else {
                                if (!isFinite(t)) throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported");
                                t >>>= 0, isFinite(r) ? (r >>>= 0, void 0 === n && (n = "utf8")) : (n = r, r = void 0);
                            }
                            var i = this.length - t;
                            if ((void 0 === r || r > i) && (r = i), e.length > 0 && (r < 0 || t < 0) || t > this.length) throw new RangeError("Attempt to write outside buffer bounds");
                            n || (n = "utf8");
                            for(var s = !1;;)switch(n){
                                case "hex":
                                    return b(this, e, t, r);
                                case "utf8":
                                case "utf-8":
                                    return g(this, e, t, r);
                                case "ascii":
                                    return y(this, e, t, r);
                                case "latin1":
                                case "binary":
                                    return v(this, e, t, r);
                                case "base64":
                                    return w(this, e, t, r);
                                case "ucs2":
                                case "ucs-2":
                                case "utf16le":
                                case "utf-16le":
                                    return _(this, e, t, r);
                                default:
                                    if (s) throw new TypeError("Unknown encoding: " + n);
                                    n = ("" + n).toLowerCase(), s = !0;
                            }
                        }, s.prototype.toJSON = function() {
                            return {
                                type: "Buffer",
                                data: Array.prototype.slice.call(this._arr || this, 0)
                            };
                        };
                        function S(e, t, r) {
                            var n = "";
                            r = Math.min(e.length, r);
                            for(var i = t; i < r; ++i)n += String.fromCharCode(127 & e[i]);
                            return n;
                        }
                        function M(e, t, r) {
                            var n = "";
                            r = Math.min(e.length, r);
                            for(var i = t; i < r; ++i)n += String.fromCharCode(e[i]);
                            return n;
                        }
                        function C(e, t, r) {
                            var n = e.length;
                            (!t || t < 0) && (t = 0), (!r || r < 0 || r > n) && (r = n);
                            for(var i = "", s = t; s < r; ++s)i += N(e[s]);
                            return i;
                        }
                        function T(e, t, r) {
                            for(var n = e.slice(t, r), i = "", s = 0; s < n.length; s += 2)i += String.fromCharCode(n[s] + 256 * n[s + 1]);
                            return i;
                        }
                        function E(e, t, r) {
                            if (e % 1 != 0 || e < 0) throw new RangeError("offset is not uint");
                            if (e + t > r) throw new RangeError("Trying to access beyond buffer length");
                        }
                        function A(e, t, r, n, i, o) {
                            if (!s.isBuffer(e)) throw new TypeError('"buffer" argument must be a Buffer instance');
                            if (t > i || t < o) throw new RangeError('"value" argument is out of bounds');
                            if (r + n > e.length) throw new RangeError("Index out of range");
                        }
                        function R(e, t, r, n, i, s) {
                            if (r + n > e.length) throw new RangeError("Index out of range");
                            if (r < 0) throw new RangeError("Index out of range");
                        }
                        function O(e, t, r, i, s) {
                            return t = +t, r >>>= 0, s || R(e, 0, r, 4), n.write(e, t, r, i, 23, 4), r + 4;
                        }
                        function j(e, t, r, i, s) {
                            return t = +t, r >>>= 0, s || R(e, 0, r, 8), n.write(e, t, r, i, 52, 8), r + 8;
                        }
                        s.prototype.slice = function(e, t) {
                            var r = this.length;
                            (e = ~~e) < 0 ? (e += r) < 0 && (e = 0) : e > r && (e = r), (t = void 0 === t ? r : ~~t) < 0 ? (t += r) < 0 && (t = 0) : t > r && (t = r), t < e && (t = e);
                            var n = this.subarray(e, t);
                            return n.__proto__ = s.prototype, n;
                        }, s.prototype.readUIntLE = function(e, t, r) {
                            e >>>= 0, t >>>= 0, r || E(e, t, this.length);
                            for(var n = this[e], i = 1, s = 0; ++s < t && (i *= 256);)n += this[e + s] * i;
                            return n;
                        }, s.prototype.readUIntBE = function(e, t, r) {
                            e >>>= 0, t >>>= 0, r || E(e, t, this.length);
                            for(var n = this[e + --t], i = 1; t > 0 && (i *= 256);)n += this[e + --t] * i;
                            return n;
                        }, s.prototype.readUInt8 = function(e, t) {
                            return e >>>= 0, t || E(e, 1, this.length), this[e];
                        }, s.prototype.readUInt16LE = function(e, t) {
                            return e >>>= 0, t || E(e, 2, this.length), this[e] | this[e + 1] << 8;
                        }, s.prototype.readUInt16BE = function(e, t) {
                            return e >>>= 0, t || E(e, 2, this.length), this[e] << 8 | this[e + 1];
                        }, s.prototype.readUInt32LE = function(e, t) {
                            return e >>>= 0, t || E(e, 4, this.length), (this[e] | this[e + 1] << 8 | this[e + 2] << 16) + 16777216 * this[e + 3];
                        }, s.prototype.readUInt32BE = function(e, t) {
                            return e >>>= 0, t || E(e, 4, this.length), 16777216 * this[e] + (this[e + 1] << 16 | this[e + 2] << 8 | this[e + 3]);
                        }, s.prototype.readIntLE = function(e, t, r) {
                            e >>>= 0, t >>>= 0, r || E(e, t, this.length);
                            for(var n = this[e], i = 1, s = 0; ++s < t && (i *= 256);)n += this[e + s] * i;
                            return n >= (i *= 128) && (n -= Math.pow(2, 8 * t)), n;
                        }, s.prototype.readIntBE = function(e, t, r) {
                            e >>>= 0, t >>>= 0, r || E(e, t, this.length);
                            for(var n = t, i = 1, s = this[e + --n]; n > 0 && (i *= 256);)s += this[e + --n] * i;
                            return s >= (i *= 128) && (s -= Math.pow(2, 8 * t)), s;
                        }, s.prototype.readInt8 = function(e, t) {
                            return e >>>= 0, t || E(e, 1, this.length), 128 & this[e] ? -1 * (255 - this[e] + 1) : this[e];
                        }, s.prototype.readInt16LE = function(e, t) {
                            e >>>= 0, t || E(e, 2, this.length);
                            var r = this[e] | this[e + 1] << 8;
                            return 32768 & r ? 4294901760 | r : r;
                        }, s.prototype.readInt16BE = function(e, t) {
                            e >>>= 0, t || E(e, 2, this.length);
                            var r = this[e + 1] | this[e] << 8;
                            return 32768 & r ? 4294901760 | r : r;
                        }, s.prototype.readInt32LE = function(e, t) {
                            return e >>>= 0, t || E(e, 4, this.length), this[e] | this[e + 1] << 8 | this[e + 2] << 16 | this[e + 3] << 24;
                        }, s.prototype.readInt32BE = function(e, t) {
                            return e >>>= 0, t || E(e, 4, this.length), this[e] << 24 | this[e + 1] << 16 | this[e + 2] << 8 | this[e + 3];
                        }, s.prototype.readFloatLE = function(e, t) {
                            return e >>>= 0, t || E(e, 4, this.length), n.read(this, e, !0, 23, 4);
                        }, s.prototype.readFloatBE = function(e, t) {
                            return e >>>= 0, t || E(e, 4, this.length), n.read(this, e, !1, 23, 4);
                        }, s.prototype.readDoubleLE = function(e, t) {
                            return e >>>= 0, t || E(e, 8, this.length), n.read(this, e, !0, 52, 8);
                        }, s.prototype.readDoubleBE = function(e, t) {
                            return e >>>= 0, t || E(e, 8, this.length), n.read(this, e, !1, 52, 8);
                        }, s.prototype.writeUIntLE = function(e, t, r, n) {
                            (e = +e, t >>>= 0, r >>>= 0, n) || A(this, e, t, r, Math.pow(2, 8 * r) - 1, 0);
                            var i = 1, s = 0;
                            for(this[t] = 255 & e; ++s < r && (i *= 256);)this[t + s] = e / i & 255;
                            return t + r;
                        }, s.prototype.writeUIntBE = function(e, t, r, n) {
                            (e = +e, t >>>= 0, r >>>= 0, n) || A(this, e, t, r, Math.pow(2, 8 * r) - 1, 0);
                            var i = r - 1, s = 1;
                            for(this[t + i] = 255 & e; --i >= 0 && (s *= 256);)this[t + i] = e / s & 255;
                            return t + r;
                        }, s.prototype.writeUInt8 = function(e, t, r) {
                            return e = +e, t >>>= 0, r || A(this, e, t, 1, 255, 0), this[t] = 255 & e, t + 1;
                        }, s.prototype.writeUInt16LE = function(e, t, r) {
                            return e = +e, t >>>= 0, r || A(this, e, t, 2, 65535, 0), this[t] = 255 & e, this[t + 1] = e >>> 8, t + 2;
                        }, s.prototype.writeUInt16BE = function(e, t, r) {
                            return e = +e, t >>>= 0, r || A(this, e, t, 2, 65535, 0), this[t] = e >>> 8, this[t + 1] = 255 & e, t + 2;
                        }, s.prototype.writeUInt32LE = function(e, t, r) {
                            return e = +e, t >>>= 0, r || A(this, e, t, 4, 4294967295, 0), this[t + 3] = e >>> 24, this[t + 2] = e >>> 16, this[t + 1] = e >>> 8, this[t] = 255 & e, t + 4;
                        }, s.prototype.writeUInt32BE = function(e, t, r) {
                            return e = +e, t >>>= 0, r || A(this, e, t, 4, 4294967295, 0), this[t] = e >>> 24, this[t + 1] = e >>> 16, this[t + 2] = e >>> 8, this[t + 3] = 255 & e, t + 4;
                        }, s.prototype.writeIntLE = function(e, t, r, n) {
                            if (e = +e, t >>>= 0, !n) {
                                var i = Math.pow(2, 8 * r - 1);
                                A(this, e, t, r, i - 1, -i);
                            }
                            var s = 0, o = 1, a = 0;
                            for(this[t] = 255 & e; ++s < r && (o *= 256);)e < 0 && 0 === a && 0 !== this[t + s - 1] && (a = 1), this[t + s] = (e / o >> 0) - a & 255;
                            return t + r;
                        }, s.prototype.writeIntBE = function(e, t, r, n) {
                            if (e = +e, t >>>= 0, !n) {
                                var i = Math.pow(2, 8 * r - 1);
                                A(this, e, t, r, i - 1, -i);
                            }
                            var s = r - 1, o = 1, a = 0;
                            for(this[t + s] = 255 & e; --s >= 0 && (o *= 256);)e < 0 && 0 === a && 0 !== this[t + s + 1] && (a = 1), this[t + s] = (e / o >> 0) - a & 255;
                            return t + r;
                        }, s.prototype.writeInt8 = function(e, t, r) {
                            return e = +e, t >>>= 0, r || A(this, e, t, 1, 127, -128), e < 0 && (e = 255 + e + 1), this[t] = 255 & e, t + 1;
                        }, s.prototype.writeInt16LE = function(e, t, r) {
                            return e = +e, t >>>= 0, r || A(this, e, t, 2, 32767, -32768), this[t] = 255 & e, this[t + 1] = e >>> 8, t + 2;
                        }, s.prototype.writeInt16BE = function(e, t, r) {
                            return e = +e, t >>>= 0, r || A(this, e, t, 2, 32767, -32768), this[t] = e >>> 8, this[t + 1] = 255 & e, t + 2;
                        }, s.prototype.writeInt32LE = function(e, t, r) {
                            return e = +e, t >>>= 0, r || A(this, e, t, 4, 2147483647, -2147483648), this[t] = 255 & e, this[t + 1] = e >>> 8, this[t + 2] = e >>> 16, this[t + 3] = e >>> 24, t + 4;
                        }, s.prototype.writeInt32BE = function(e, t, r) {
                            return e = +e, t >>>= 0, r || A(this, e, t, 4, 2147483647, -2147483648), e < 0 && (e = 4294967295 + e + 1), this[t] = e >>> 24, this[t + 1] = e >>> 16, this[t + 2] = e >>> 8, this[t + 3] = 255 & e, t + 4;
                        }, s.prototype.writeFloatLE = function(e, t, r) {
                            return O(this, e, t, !0, r);
                        }, s.prototype.writeFloatBE = function(e, t, r) {
                            return O(this, e, t, !1, r);
                        }, s.prototype.writeDoubleLE = function(e, t, r) {
                            return j(this, e, t, !0, r);
                        }, s.prototype.writeDoubleBE = function(e, t, r) {
                            return j(this, e, t, !1, r);
                        }, s.prototype.copy = function(e, t, r, n) {
                            if (!s.isBuffer(e)) throw new TypeError("argument should be a Buffer");
                            if (r || (r = 0), n || 0 === n || (n = this.length), t >= e.length && (t = e.length), t || (t = 0), n > 0 && n < r && (n = r), n === r) return 0;
                            if (0 === e.length || 0 === this.length) return 0;
                            if (t < 0) throw new RangeError("targetStart out of bounds");
                            if (r < 0 || r >= this.length) throw new RangeError("Index out of range");
                            if (n < 0) throw new RangeError("sourceEnd out of bounds");
                            n > this.length && (n = this.length), e.length - t < n - r && (n = e.length - t + r);
                            var i = n - r;
                            if (this === e && "function" == typeof Uint8Array.prototype.copyWithin) this.copyWithin(t, r, n);
                            else if (this === e && r < t && t < n) for(var o = i - 1; o >= 0; --o)e[o + t] = this[o + r];
                            else Uint8Array.prototype.set.call(e, this.subarray(r, n), t);
                            return i;
                        }, s.prototype.fill = function(e, t, r, n) {
                            if ("string" == typeof e) {
                                if ("string" == typeof t ? (n = t, t = 0, r = this.length) : "string" == typeof r && (n = r, r = this.length), void 0 !== n && "string" != typeof n) throw new TypeError("encoding must be a string");
                                if ("string" == typeof n && !s.isEncoding(n)) throw new TypeError("Unknown encoding: " + n);
                                if (1 === e.length) {
                                    var i = e.charCodeAt(0);
                                    ("utf8" === n && i < 128 || "latin1" === n) && (e = i);
                                }
                            } else "number" == typeof e && (e &= 255);
                            if (t < 0 || this.length < t || this.length < r) throw new RangeError("Out of range index");
                            if (r <= t) return this;
                            var o;
                            if (t >>>= 0, r = void 0 === r ? this.length : r >>> 0, e || (e = 0), "number" == typeof e) for(o = t; o < r; ++o)this[o] = e;
                            else {
                                var a = s.isBuffer(e) ? e : s.from(e, n), l = a.length;
                                if (0 === l) throw new TypeError('The value "' + e + '" is invalid for argument "value"');
                                for(o = 0; o < r - t; ++o)this[o + t] = a[o % l];
                            }
                            return this;
                        };
                        var I = /[^+/0-9A-Za-z-_]/g;
                        function N(e) {
                            return e < 16 ? "0" + e.toString(16) : e.toString(16);
                        }
                        function P(e, t) {
                            var r;
                            t = t || 1 / 0;
                            for(var n = e.length, i = null, s = [], o = 0; o < n; ++o){
                                if ((r = e.charCodeAt(o)) > 55295 && r < 57344) {
                                    if (!i) {
                                        if (r > 56319) {
                                            (t -= 3) > -1 && s.push(239, 191, 189);
                                            continue;
                                        }
                                        if (o + 1 === n) {
                                            (t -= 3) > -1 && s.push(239, 191, 189);
                                            continue;
                                        }
                                        i = r;
                                        continue;
                                    }
                                    if (r < 56320) {
                                        (t -= 3) > -1 && s.push(239, 191, 189), i = r;
                                        continue;
                                    }
                                    r = 65536 + (i - 55296 << 10 | r - 56320);
                                } else i && (t -= 3) > -1 && s.push(239, 191, 189);
                                if (i = null, r < 128) {
                                    if ((t -= 1) < 0) break;
                                    s.push(r);
                                } else if (r < 2048) {
                                    if ((t -= 2) < 0) break;
                                    s.push(r >> 6 | 192, 63 & r | 128);
                                } else if (r < 65536) {
                                    if ((t -= 3) < 0) break;
                                    s.push(r >> 12 | 224, r >> 6 & 63 | 128, 63 & r | 128);
                                } else {
                                    if (!(r < 1114112)) throw new Error("Invalid code point");
                                    if ((t -= 4) < 0) break;
                                    s.push(r >> 18 | 240, r >> 12 & 63 | 128, r >> 6 & 63 | 128, 63 & r | 128);
                                }
                            }
                            return s;
                        }
                        function B(e) {
                            return t.toByteArray(function(e) {
                                if ((e = (e = e.split("=")[0]).trim().replace(I, "")).length < 2) return "";
                                for(; e.length % 4 != 0;)e += "=";
                                return e;
                            }(e));
                        }
                        function D(e, t, r, n) {
                            for(var i = 0; i < n && !(i + r >= t.length || i >= e.length); ++i)t[i + r] = e[i];
                            return i;
                        }
                        function F(e, t) {
                            return e instanceof t || null != e && null != e.constructor && null != e.constructor.name && e.constructor.name === t.name;
                        }
                        function L(e) {
                            return e != e;
                        }
                    }).call(this);
                }).call(this, e("buffer").Buffer);
            },
            {
                "base64-js": 185,
                buffer: 220,
                ieee754: 439
            }
        ],
        221: [
            function(e, t, r) {
                "use strict";
                var n = e("safe-buffer").Buffer, i = e("stream").Transform, s = e("string_decoder").StringDecoder;
                function o(e) {
                    i.call(this), this.hashMode = "string" == typeof e, this.hashMode ? this[e] = this._finalOrDigest : this.final = this._finalOrDigest, this._final && (this.__final = this._final, this._final = null), this._decoder = null, this._encoding = null;
                }
                e("inherits")(o, i), o.prototype.update = function(e, t, r) {
                    "string" == typeof e && (e = n.from(e, t));
                    var i = this._update(e);
                    return this.hashMode ? this : (r && (i = this._toString(i, r)), i);
                }, o.prototype.setAutoPadding = function() {}, o.prototype.getAuthTag = function() {
                    throw new Error("trying to get auth tag in unsupported state");
                }, o.prototype.setAuthTag = function() {
                    throw new Error("trying to set auth tag in unsupported state");
                }, o.prototype.setAAD = function() {
                    throw new Error("trying to set aad in unsupported state");
                }, o.prototype._transform = function(e, t, r) {
                    var n;
                    try {
                        this.hashMode ? this._update(e) : this.push(this._update(e));
                    } catch (e) {
                        n = e;
                    } finally{
                        r(n);
                    }
                }, o.prototype._flush = function(e) {
                    var t;
                    try {
                        this.push(this.__final());
                    } catch (e) {
                        t = e;
                    }
                    e(t);
                }, o.prototype._finalOrDigest = function(e) {
                    var t = this.__final() || n.alloc(0);
                    return e && (t = this._toString(t, e, !0)), t;
                }, o.prototype._toString = function(e, t, r) {
                    if (this._decoder || (this._decoder = new s(t), this._encoding = t), this._encoding !== t) throw new Error("can't switch encodings");
                    var n = this._decoder.write(e);
                    return r && (n += this._decoder.end()), n;
                }, t.exports = o;
            },
            {
                inherits: 440,
                "safe-buffer": 494,
                stream: 505,
                string_decoder: 218
            }
        ],
        222: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/is-callable"), i = e("../internals/try-to-string"), s = TypeError;
                t.exports = function(e) {
                    if (n(e)) return e;
                    throw new s(i(e) + " is not a function");
                };
            },
            {
                "../internals/is-callable": 285,
                "../internals/try-to-string": 349
            }
        ],
        223: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/is-constructor"), i = e("../internals/try-to-string"), s = TypeError;
                t.exports = function(e) {
                    if (n(e)) return e;
                    throw new s(i(e) + " is not a constructor");
                };
            },
            {
                "../internals/is-constructor": 286,
                "../internals/try-to-string": 349
            }
        ],
        224: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/is-callable"), i = String, s = TypeError;
                t.exports = function(e) {
                    if ("object" == typeof e || n(e)) return e;
                    throw new s("Can't set " + i(e) + " as a prototype");
                };
            },
            {
                "../internals/is-callable": 285
            }
        ],
        225: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/well-known-symbol"), i = e("../internals/object-create"), s = e("../internals/object-define-property").f, o = n("unscopables"), a = Array.prototype;
                void 0 === a[o] && s(a, o, {
                    configurable: !0,
                    value: i(null)
                }), t.exports = function(e) {
                    a[o][e] = !0;
                };
            },
            {
                "../internals/object-create": 306,
                "../internals/object-define-property": 308,
                "../internals/well-known-symbol": 357
            }
        ],
        226: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/object-is-prototype-of"), i = TypeError;
                t.exports = function(e, t) {
                    if (n(t, e)) return e;
                    throw new i("Incorrect invocation");
                };
            },
            {
                "../internals/object-is-prototype-of": 314
            }
        ],
        227: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/is-object"), i = String, s = TypeError;
                t.exports = function(e) {
                    if (n(e)) return e;
                    throw new s(i(e) + " is not an object");
                };
            },
            {
                "../internals/is-object": 289
            }
        ],
        228: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/to-indexed-object"), i = e("../internals/to-absolute-index"), s = e("../internals/length-of-array-like"), o = function(e) {
                    return function(t, r, o) {
                        var a, l = n(t), c = s(l), u = i(o, c);
                        if (e && r != r) {
                            for(; c > u;)if ((a = l[u++]) != a) return !0;
                        } else for(; c > u; u++)if ((e || u in l) && l[u] === r) return e || u || 0;
                        return !e && -1;
                    };
                };
                t.exports = {
                    includes: o(!0),
                    indexOf: o(!1)
                };
            },
            {
                "../internals/length-of-array-like": 299,
                "../internals/to-absolute-index": 340,
                "../internals/to-indexed-object": 341
            }
        ],
        229: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/function-bind-context"), i = e("../internals/function-uncurry-this"), s = e("../internals/indexed-object"), o = e("../internals/to-object"), a = e("../internals/length-of-array-like"), l = e("../internals/array-species-create"), c = i([].push), u = function(e) {
                    var t = 1 === e, r = 2 === e, i = 3 === e, u = 4 === e, h = 6 === e, f = 7 === e, d = 5 === e || h;
                    return function(p, m, b, g) {
                        for(var y, v, w = o(p), _ = s(w), x = n(m, b), k = a(_), S = 0, M = g || l, C = t ? M(p, k) : r || f ? M(p, 0) : void 0; k > S; S++)if ((d || S in _) && (v = x(y = _[S], S, w), e)) {
                            if (t) C[S] = v;
                            else if (v) switch(e){
                                case 3:
                                    return !0;
                                case 5:
                                    return y;
                                case 6:
                                    return S;
                                case 2:
                                    c(C, y);
                            }
                            else switch(e){
                                case 4:
                                    return !1;
                                case 7:
                                    c(C, y);
                            }
                        }
                        return h ? -1 : i || u ? u : C;
                    };
                };
                t.exports = {
                    forEach: u(0),
                    map: u(1),
                    filter: u(2),
                    some: u(3),
                    every: u(4),
                    find: u(5),
                    findIndex: u(6),
                    filterReject: u(7)
                };
            },
            {
                "../internals/array-species-create": 233,
                "../internals/function-bind-context": 262,
                "../internals/function-uncurry-this": 268,
                "../internals/indexed-object": 280,
                "../internals/length-of-array-like": 299,
                "../internals/to-object": 344
            }
        ],
        230: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/to-absolute-index"), i = e("../internals/length-of-array-like"), s = e("../internals/create-property"), o = Array, a = Math.max;
                t.exports = function(e, t, r) {
                    for(var l = i(e), c = n(t, l), u = n(void 0 === r ? l : r, l), h = o(a(u - c, 0)), f = 0; c < u; c++, f++)s(h, f, e[c]);
                    return h.length = f, h;
                };
            },
            {
                "../internals/create-property": 243,
                "../internals/length-of-array-like": 299,
                "../internals/to-absolute-index": 340
            }
        ],
        231: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/function-uncurry-this");
                t.exports = n([].slice);
            },
            {
                "../internals/function-uncurry-this": 268
            }
        ],
        232: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/is-array"), i = e("../internals/is-constructor"), s = e("../internals/is-object"), o = e("../internals/well-known-symbol")("species"), a = Array;
                t.exports = function(e) {
                    var t;
                    return n(e) && (t = e.constructor, (i(t) && (t === a || n(t.prototype)) || s(t) && null === (t = t[o])) && (t = void 0)), void 0 === t ? a : t;
                };
            },
            {
                "../internals/is-array": 284,
                "../internals/is-constructor": 286,
                "../internals/is-object": 289,
                "../internals/well-known-symbol": 357
            }
        ],
        233: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/array-species-constructor");
                t.exports = function(e, t) {
                    return new (n(e))(0 === t ? 0 : t);
                };
            },
            {
                "../internals/array-species-constructor": 232
            }
        ],
        234: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/well-known-symbol")("iterator"), i = !1;
                try {
                    var s = 0, o = {
                        next: function() {
                            return {
                                done: !!s++
                            };
                        },
                        return: function() {
                            i = !0;
                        }
                    };
                    o[n] = function() {
                        return this;
                    }, Array.from(o, function() {
                        throw 2;
                    });
                } catch (e) {}
                t.exports = function(e, t) {
                    try {
                        if (!t && !i) return !1;
                    } catch (e) {
                        return !1;
                    }
                    var r = !1;
                    try {
                        var s = {};
                        s[n] = function() {
                            return {
                                next: function() {
                                    return {
                                        done: r = !0
                                    };
                                }
                            };
                        }, e(s);
                    } catch (e) {}
                    return r;
                };
            },
            {
                "../internals/well-known-symbol": 357
            }
        ],
        235: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/function-uncurry-this"), i = n({}.toString), s = n("".slice);
                t.exports = function(e) {
                    return s(i(e), 8, -1);
                };
            },
            {
                "../internals/function-uncurry-this": 268
            }
        ],
        236: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/to-string-tag-support"), i = e("../internals/is-callable"), s = e("../internals/classof-raw"), o = e("../internals/well-known-symbol")("toStringTag"), a = Object, l = "Arguments" === s(function() {
                    return arguments;
                }());
                t.exports = n ? s : function(e) {
                    var t, r, n;
                    return void 0 === e ? "Undefined" : null === e ? "Null" : "string" == typeof (r = function(e, t) {
                        try {
                            return e[t];
                        } catch (e) {}
                    }(t = a(e), o)) ? r : l ? s(t) : "Object" === (n = s(t)) && i(t.callee) ? "Arguments" : n;
                };
            },
            {
                "../internals/classof-raw": 235,
                "../internals/is-callable": 285,
                "../internals/to-string-tag-support": 347,
                "../internals/well-known-symbol": 357
            }
        ],
        237: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/has-own-property"), i = e("../internals/own-keys"), s = e("../internals/object-get-own-property-descriptor"), o = e("../internals/object-define-property");
                t.exports = function(e, t, r) {
                    for(var a = i(t), l = o.f, c = s.f, u = 0; u < a.length; u++){
                        var h = a[u];
                        n(e, h) || r && n(r, h) || l(e, h, c(t, h));
                    }
                };
            },
            {
                "../internals/has-own-property": 275,
                "../internals/object-define-property": 308,
                "../internals/object-get-own-property-descriptor": 309,
                "../internals/own-keys": 321
            }
        ],
        238: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/well-known-symbol")("match");
                t.exports = function(e) {
                    var t = /./;
                    try {
                        "/./"[e](t);
                    } catch (r) {
                        try {
                            return t[n] = !1, "/./"[e](t);
                        } catch (e) {}
                    }
                    return !1;
                };
            },
            {
                "../internals/well-known-symbol": 357
            }
        ],
        239: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/fails");
                t.exports = !n(function() {
                    function e() {}
                    return e.prototype.constructor = null, Object.getPrototypeOf(new e) !== e.prototype;
                });
            },
            {
                "../internals/fails": 260
            }
        ],
        240: [
            function(e, t, r) {
                "use strict";
                t.exports = function(e, t) {
                    return {
                        value: e,
                        done: t
                    };
                };
            },
            {}
        ],
        241: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/descriptors"), i = e("../internals/object-define-property"), s = e("../internals/create-property-descriptor");
                t.exports = n ? function(e, t, r) {
                    return i.f(e, t, s(1, r));
                } : function(e, t, r) {
                    return e[t] = r, e;
                };
            },
            {
                "../internals/create-property-descriptor": 242,
                "../internals/descriptors": 247,
                "../internals/object-define-property": 308
            }
        ],
        242: [
            function(e, t, r) {
                "use strict";
                t.exports = function(e, t) {
                    return {
                        enumerable: !(1 & e),
                        configurable: !(2 & e),
                        writable: !(4 & e),
                        value: t
                    };
                };
            },
            {}
        ],
        243: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/to-property-key"), i = e("../internals/object-define-property"), s = e("../internals/create-property-descriptor");
                t.exports = function(e, t, r) {
                    var o = n(t);
                    o in e ? i.f(e, o, s(0, r)) : e[o] = r;
                };
            },
            {
                "../internals/create-property-descriptor": 242,
                "../internals/object-define-property": 308,
                "../internals/to-property-key": 346
            }
        ],
        244: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/make-built-in"), i = e("../internals/object-define-property");
                t.exports = function(e, t, r) {
                    return r.get && n(r.get, t, {
                        getter: !0
                    }), r.set && n(r.set, t, {
                        setter: !0
                    }), i.f(e, t, r);
                };
            },
            {
                "../internals/make-built-in": 300,
                "../internals/object-define-property": 308
            }
        ],
        245: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/is-callable"), i = e("../internals/object-define-property"), s = e("../internals/make-built-in"), o = e("../internals/define-global-property");
                t.exports = function(e, t, r, a) {
                    a || (a = {});
                    var l = a.enumerable, c = void 0 !== a.name ? a.name : t;
                    if (n(r) && s(r, c, a), a.global) l ? e[t] = r : o(t, r);
                    else {
                        try {
                            a.unsafe ? e[t] && (l = !0) : delete e[t];
                        } catch (e) {}
                        l ? e[t] = r : i.f(e, t, {
                            value: r,
                            enumerable: !1,
                            configurable: !a.nonConfigurable,
                            writable: !a.nonWritable
                        });
                    }
                    return e;
                };
            },
            {
                "../internals/define-global-property": 246,
                "../internals/is-callable": 285,
                "../internals/make-built-in": 300,
                "../internals/object-define-property": 308
            }
        ],
        246: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/global"), i = Object.defineProperty;
                t.exports = function(e, t) {
                    try {
                        i(n, e, {
                            value: t,
                            configurable: !0,
                            writable: !0
                        });
                    } catch (r) {
                        n[e] = t;
                    }
                    return t;
                };
            },
            {
                "../internals/global": 274
            }
        ],
        247: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/fails");
                t.exports = !n(function() {
                    return 7 !== Object.defineProperty({}, 1, {
                        get: function() {
                            return 7;
                        }
                    })[1];
                });
            },
            {
                "../internals/fails": 260
            }
        ],
        248: [
            function(e, t, r) {
                "use strict";
                var n = "object" == typeof document && document.all, i = void 0 === n && void 0 !== n;
                t.exports = {
                    all: n,
                    IS_HTMLDDA: i
                };
            },
            {}
        ],
        249: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/global"), i = e("../internals/is-object"), s = n.document, o = i(s) && i(s.createElement);
                t.exports = function(e) {
                    return o ? s.createElement(e) : {};
                };
            },
            {
                "../internals/global": 274,
                "../internals/is-object": 289
            }
        ],
        250: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/engine-is-deno"), i = e("../internals/engine-is-node");
                t.exports = !n && !i && "object" == typeof window && "object" == typeof document;
            },
            {
                "../internals/engine-is-deno": 251,
                "../internals/engine-is-node": 254
            }
        ],
        251: [
            function(e, t, r) {
                "use strict";
                t.exports = "object" == typeof Deno && Deno && "object" == typeof Deno.version;
            },
            {}
        ],
        252: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/engine-user-agent");
                t.exports = /ipad|iphone|ipod/i.test(n) && "undefined" != typeof Pebble;
            },
            {
                "../internals/engine-user-agent": 256
            }
        ],
        253: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/engine-user-agent");
                t.exports = /(?:ipad|iphone|ipod).*applewebkit/i.test(n);
            },
            {
                "../internals/engine-user-agent": 256
            }
        ],
        254: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/global"), i = e("../internals/classof-raw");
                t.exports = "process" === i(n.process);
            },
            {
                "../internals/classof-raw": 235,
                "../internals/global": 274
            }
        ],
        255: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/engine-user-agent");
                t.exports = /web0s(?!.*chrome)/i.test(n);
            },
            {
                "../internals/engine-user-agent": 256
            }
        ],
        256: [
            function(e, t, r) {
                "use strict";
                t.exports = "undefined" != typeof navigator && String(navigator.userAgent) || "";
            },
            {}
        ],
        257: [
            function(e, t, r) {
                "use strict";
                var n, i, s = e("../internals/global"), o = e("../internals/engine-user-agent"), a = s.process, l = s.Deno, c = a && a.versions || l && l.version, u = c && c.v8;
                u && (i = (n = u.split("."))[0] > 0 && n[0] < 4 ? 1 : +(n[0] + n[1])), !i && o && (!(n = o.match(/Edge\/(\d+)/)) || n[1] >= 74) && (n = o.match(/Chrome\/(\d+)/)) && (i = +n[1]), t.exports = i;
            },
            {
                "../internals/engine-user-agent": 256,
                "../internals/global": 274
            }
        ],
        258: [
            function(e, t, r) {
                "use strict";
                t.exports = [
                    "constructor",
                    "hasOwnProperty",
                    "isPrototypeOf",
                    "propertyIsEnumerable",
                    "toLocaleString",
                    "toString",
                    "valueOf"
                ];
            },
            {}
        ],
        259: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/global"), i = e("../internals/object-get-own-property-descriptor").f, s = e("../internals/create-non-enumerable-property"), o = e("../internals/define-built-in"), a = e("../internals/define-global-property"), l = e("../internals/copy-constructor-properties"), c = e("../internals/is-forced");
                t.exports = function(e, t) {
                    var r, u, h, f, d, p = e.target, m = e.global, b = e.stat;
                    if (r = m ? n : b ? n[p] || a(p, {}) : (n[p] || {}).prototype) for(u in t){
                        if (f = t[u], h = e.dontCallGetSet ? (d = i(r, u)) && d.value : r[u], !c(m ? u : p + (b ? "." : "#") + u, e.forced) && void 0 !== h) {
                            if (typeof f == typeof h) continue;
                            l(f, h);
                        }
                        (e.sham || h && h.sham) && s(f, "sham", !0), o(r, u, f, e);
                    }
                };
            },
            {
                "../internals/copy-constructor-properties": 237,
                "../internals/create-non-enumerable-property": 241,
                "../internals/define-built-in": 245,
                "../internals/define-global-property": 246,
                "../internals/global": 274,
                "../internals/is-forced": 287,
                "../internals/object-get-own-property-descriptor": 309
            }
        ],
        260: [
            function(e, t, r) {
                "use strict";
                t.exports = function(e) {
                    try {
                        return !!e();
                    } catch (e) {
                        return !0;
                    }
                };
            },
            {}
        ],
        261: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/function-bind-native"), i = Function.prototype, s = i.apply, o = i.call;
                t.exports = "object" == typeof Reflect && Reflect.apply || (n ? o.bind(s) : function() {
                    return o.apply(s, arguments);
                });
            },
            {
                "../internals/function-bind-native": 263
            }
        ],
        262: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/function-uncurry-this-clause"), i = e("../internals/a-callable"), s = e("../internals/function-bind-native"), o = n(n.bind);
                t.exports = function(e, t) {
                    return i(e), void 0 === t ? e : s ? o(e, t) : function() {
                        return e.apply(t, arguments);
                    };
                };
            },
            {
                "../internals/a-callable": 222,
                "../internals/function-bind-native": 263,
                "../internals/function-uncurry-this-clause": 267
            }
        ],
        263: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/fails");
                t.exports = !n(function() {
                    var e = (function() {}).bind();
                    return "function" != typeof e || e.hasOwnProperty("prototype");
                });
            },
            {
                "../internals/fails": 260
            }
        ],
        264: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/function-bind-native"), i = Function.prototype.call;
                t.exports = n ? i.bind(i) : function() {
                    return i.apply(i, arguments);
                };
            },
            {
                "../internals/function-bind-native": 263
            }
        ],
        265: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/descriptors"), i = e("../internals/has-own-property"), s = Function.prototype, o = n && Object.getOwnPropertyDescriptor, a = i(s, "name"), l = a && "something" === (function() {}).name, c = a && (!n || n && o(s, "name").configurable);
                t.exports = {
                    EXISTS: a,
                    PROPER: l,
                    CONFIGURABLE: c
                };
            },
            {
                "../internals/descriptors": 247,
                "../internals/has-own-property": 275
            }
        ],
        266: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/function-uncurry-this"), i = e("../internals/a-callable");
                t.exports = function(e, t, r) {
                    try {
                        return n(i(Object.getOwnPropertyDescriptor(e, t)[r]));
                    } catch (e) {}
                };
            },
            {
                "../internals/a-callable": 222,
                "../internals/function-uncurry-this": 268
            }
        ],
        267: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/classof-raw"), i = e("../internals/function-uncurry-this");
                t.exports = function(e) {
                    if ("Function" === n(e)) return i(e);
                };
            },
            {
                "../internals/classof-raw": 235,
                "../internals/function-uncurry-this": 268
            }
        ],
        268: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/function-bind-native"), i = Function.prototype, s = i.call, o = n && i.bind.bind(s, s);
                t.exports = n ? o : function(e) {
                    return function() {
                        return s.apply(e, arguments);
                    };
                };
            },
            {
                "../internals/function-bind-native": 263
            }
        ],
        269: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/global"), i = e("../internals/is-callable"), s = function(e) {
                    return i(e) ? e : void 0;
                };
                t.exports = function(e, t) {
                    return arguments.length < 2 ? s(n[e]) : n[e] && n[e][t];
                };
            },
            {
                "../internals/global": 274,
                "../internals/is-callable": 285
            }
        ],
        270: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/classof"), i = e("../internals/get-method"), s = e("../internals/is-null-or-undefined"), o = e("../internals/iterators"), a = e("../internals/well-known-symbol")("iterator");
                t.exports = function(e) {
                    if (!s(e)) return i(e, a) || i(e, "@@iterator") || o[n(e)];
                };
            },
            {
                "../internals/classof": 236,
                "../internals/get-method": 273,
                "../internals/is-null-or-undefined": 288,
                "../internals/iterators": 298,
                "../internals/well-known-symbol": 357
            }
        ],
        271: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/function-call"), i = e("../internals/a-callable"), s = e("../internals/an-object"), o = e("../internals/try-to-string"), a = e("../internals/get-iterator-method"), l = TypeError;
                t.exports = function(e, t) {
                    var r = arguments.length < 2 ? a(e) : t;
                    if (i(r)) return s(n(r, e));
                    throw new l(o(e) + " is not iterable");
                };
            },
            {
                "../internals/a-callable": 222,
                "../internals/an-object": 227,
                "../internals/function-call": 264,
                "../internals/get-iterator-method": 270,
                "../internals/try-to-string": 349
            }
        ],
        272: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/function-uncurry-this"), i = e("../internals/is-array"), s = e("../internals/is-callable"), o = e("../internals/classof-raw"), a = e("../internals/to-string"), l = n([].push);
                t.exports = function(e) {
                    if (s(e)) return e;
                    if (i(e)) {
                        for(var t = e.length, r = [], n = 0; n < t; n++){
                            var c = e[n];
                            "string" == typeof c ? l(r, c) : "number" != typeof c && "Number" !== o(c) && "String" !== o(c) || l(r, a(c));
                        }
                        var u = r.length, h = !0;
                        return function(e, t) {
                            if (h) return h = !1, t;
                            if (i(this)) return t;
                            for(var n = 0; n < u; n++)if (r[n] === e) return t;
                        };
                    }
                };
            },
            {
                "../internals/classof-raw": 235,
                "../internals/function-uncurry-this": 268,
                "../internals/is-array": 284,
                "../internals/is-callable": 285,
                "../internals/to-string": 348
            }
        ],
        273: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/a-callable"), i = e("../internals/is-null-or-undefined");
                t.exports = function(e, t) {
                    var r = e[t];
                    return i(r) ? void 0 : n(r);
                };
            },
            {
                "../internals/a-callable": 222,
                "../internals/is-null-or-undefined": 288
            }
        ],
        274: [
            function(e, t, r) {
                (function(e) {
                    (function() {
                        "use strict";
                        var r = function(e) {
                            return e && e.Math === Math && e;
                        };
                        t.exports = r("object" == typeof globalThis && globalThis) || r("object" == typeof window && window) || r("object" == typeof self && self) || r("object" == typeof e && e) || function() {
                            return this;
                        }() || this || Function("return this")();
                    }).call(this);
                }).call(this, "undefined" != typeof $parcel$global ? $parcel$global : "undefined" != typeof self ? self : "undefined" != typeof window ? window : {});
            },
            {}
        ],
        275: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/function-uncurry-this"), i = e("../internals/to-object"), s = n({}.hasOwnProperty);
                t.exports = Object.hasOwn || function(e, t) {
                    return s(i(e), t);
                };
            },
            {
                "../internals/function-uncurry-this": 268,
                "../internals/to-object": 344
            }
        ],
        276: [
            function(e, t, r) {
                "use strict";
                t.exports = {};
            },
            {}
        ],
        277: [
            function(e, t, r) {
                "use strict";
                t.exports = function(e, t) {
                    try {
                        1 === arguments.length ? console.error(e) : console.error(e, t);
                    } catch (e) {}
                };
            },
            {}
        ],
        278: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/get-built-in");
                t.exports = n("document", "documentElement");
            },
            {
                "../internals/get-built-in": 269
            }
        ],
        279: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/descriptors"), i = e("../internals/fails"), s = e("../internals/document-create-element");
                t.exports = !n && !i(function() {
                    return 7 !== Object.defineProperty(s("div"), "a", {
                        get: function() {
                            return 7;
                        }
                    }).a;
                });
            },
            {
                "../internals/descriptors": 247,
                "../internals/document-create-element": 249,
                "../internals/fails": 260
            }
        ],
        280: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/function-uncurry-this"), i = e("../internals/fails"), s = e("../internals/classof-raw"), o = Object, a = n("".split);
                t.exports = i(function() {
                    return !o("z").propertyIsEnumerable(0);
                }) ? function(e) {
                    return "String" === s(e) ? a(e, "") : o(e);
                } : o;
            },
            {
                "../internals/classof-raw": 235,
                "../internals/fails": 260,
                "../internals/function-uncurry-this": 268
            }
        ],
        281: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/function-uncurry-this"), i = e("../internals/is-callable"), s = e("../internals/shared-store"), o = n(Function.toString);
                i(s.inspectSource) || (s.inspectSource = function(e) {
                    return o(e);
                }), t.exports = s.inspectSource;
            },
            {
                "../internals/function-uncurry-this": 268,
                "../internals/is-callable": 285,
                "../internals/shared-store": 333
            }
        ],
        282: [
            function(e, t, r) {
                "use strict";
                var n, i, s, o = e("../internals/weak-map-basic-detection"), a = e("../internals/global"), l = e("../internals/is-object"), c = e("../internals/create-non-enumerable-property"), u = e("../internals/has-own-property"), h = e("../internals/shared-store"), f = e("../internals/shared-key"), d = e("../internals/hidden-keys"), p = a.TypeError, m = a.WeakMap;
                if (o || h.state) {
                    var b = h.state || (h.state = new m);
                    b.get = b.get, b.has = b.has, b.set = b.set, n = function(e, t) {
                        if (b.has(e)) throw new p("Object already initialized");
                        return t.facade = e, b.set(e, t), t;
                    }, i = function(e) {
                        return b.get(e) || {};
                    }, s = function(e) {
                        return b.has(e);
                    };
                } else {
                    var g = f("state");
                    d[g] = !0, n = function(e, t) {
                        if (u(e, g)) throw new p("Object already initialized");
                        return t.facade = e, c(e, g, t), t;
                    }, i = function(e) {
                        return u(e, g) ? e[g] : {};
                    }, s = function(e) {
                        return u(e, g);
                    };
                }
                t.exports = {
                    set: n,
                    get: i,
                    has: s,
                    enforce: function(e) {
                        return s(e) ? i(e) : n(e, {});
                    },
                    getterFor: function(e) {
                        return function(t) {
                            var r;
                            if (!l(t) || (r = i(t)).type !== e) throw new p("Incompatible receiver, " + e + " required");
                            return r;
                        };
                    }
                };
            },
            {
                "../internals/create-non-enumerable-property": 241,
                "../internals/global": 274,
                "../internals/has-own-property": 275,
                "../internals/hidden-keys": 276,
                "../internals/is-object": 289,
                "../internals/shared-key": 332,
                "../internals/shared-store": 333,
                "../internals/weak-map-basic-detection": 354
            }
        ],
        283: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/well-known-symbol"), i = e("../internals/iterators"), s = n("iterator"), o = Array.prototype;
                t.exports = function(e) {
                    return void 0 !== e && (i.Array === e || o[s] === e);
                };
            },
            {
                "../internals/iterators": 298,
                "../internals/well-known-symbol": 357
            }
        ],
        284: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/classof-raw");
                t.exports = Array.isArray || function(e) {
                    return "Array" === n(e);
                };
            },
            {
                "../internals/classof-raw": 235
            }
        ],
        285: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/document-all"), i = n.all;
                t.exports = n.IS_HTMLDDA ? function(e) {
                    return "function" == typeof e || e === i;
                } : function(e) {
                    return "function" == typeof e;
                };
            },
            {
                "../internals/document-all": 248
            }
        ],
        286: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/function-uncurry-this"), i = e("../internals/fails"), s = e("../internals/is-callable"), o = e("../internals/classof"), a = e("../internals/get-built-in"), l = e("../internals/inspect-source"), c = function() {}, u = [], h = a("Reflect", "construct"), f = /^\s*(?:class|function)\b/, d = n(f.exec), p = !f.test(c), m = function(e) {
                    if (!s(e)) return !1;
                    try {
                        return h(c, u, e), !0;
                    } catch (e) {
                        return !1;
                    }
                }, b = function(e) {
                    if (!s(e)) return !1;
                    switch(o(e)){
                        case "AsyncFunction":
                        case "GeneratorFunction":
                        case "AsyncGeneratorFunction":
                            return !1;
                    }
                    try {
                        return p || !!d(f, l(e));
                    } catch (e) {
                        return !0;
                    }
                };
                b.sham = !0, t.exports = !h || i(function() {
                    var e;
                    return m(m.call) || !m(Object) || !m(function() {
                        e = !0;
                    }) || e;
                }) ? b : m;
            },
            {
                "../internals/classof": 236,
                "../internals/fails": 260,
                "../internals/function-uncurry-this": 268,
                "../internals/get-built-in": 269,
                "../internals/inspect-source": 281,
                "../internals/is-callable": 285
            }
        ],
        287: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/fails"), i = e("../internals/is-callable"), s = /#|\.prototype\./, o = function(e, t) {
                    var r = l[a(e)];
                    return r === u || r !== c && (i(t) ? n(t) : !!t);
                }, a = o.normalize = function(e) {
                    return String(e).replace(s, ".").toLowerCase();
                }, l = o.data = {}, c = o.NATIVE = "N", u = o.POLYFILL = "P";
                t.exports = o;
            },
            {
                "../internals/fails": 260,
                "../internals/is-callable": 285
            }
        ],
        288: [
            function(e, t, r) {
                "use strict";
                t.exports = function(e) {
                    return null == e;
                };
            },
            {}
        ],
        289: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/is-callable"), i = e("../internals/document-all"), s = i.all;
                t.exports = i.IS_HTMLDDA ? function(e) {
                    return "object" == typeof e ? null !== e : n(e) || e === s;
                } : function(e) {
                    return "object" == typeof e ? null !== e : n(e);
                };
            },
            {
                "../internals/document-all": 248,
                "../internals/is-callable": 285
            }
        ],
        290: [
            function(e, t, r) {
                "use strict";
                t.exports = !1;
            },
            {}
        ],
        291: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/is-object"), i = e("../internals/classof-raw"), s = e("../internals/well-known-symbol")("match");
                t.exports = function(e) {
                    var t;
                    return n(e) && (void 0 !== (t = e[s]) ? !!t : "RegExp" === i(e));
                };
            },
            {
                "../internals/classof-raw": 235,
                "../internals/is-object": 289,
                "../internals/well-known-symbol": 357
            }
        ],
        292: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/get-built-in"), i = e("../internals/is-callable"), s = e("../internals/object-is-prototype-of"), o = e("../internals/use-symbol-as-uid"), a = Object;
                t.exports = o ? function(e) {
                    return "symbol" == typeof e;
                } : function(e) {
                    var t = n("Symbol");
                    return i(t) && s(t.prototype, a(e));
                };
            },
            {
                "../internals/get-built-in": 269,
                "../internals/is-callable": 285,
                "../internals/object-is-prototype-of": 314,
                "../internals/use-symbol-as-uid": 351
            }
        ],
        293: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/function-bind-context"), i = e("../internals/function-call"), s = e("../internals/an-object"), o = e("../internals/try-to-string"), a = e("../internals/is-array-iterator-method"), l = e("../internals/length-of-array-like"), c = e("../internals/object-is-prototype-of"), u = e("../internals/get-iterator"), h = e("../internals/get-iterator-method"), f = e("../internals/iterator-close"), d = TypeError, p = function(e, t) {
                    this.stopped = e, this.result = t;
                }, m = p.prototype;
                t.exports = function(e, t, r) {
                    var b, g, y, v, w, _, x, k = r && r.that, S = !(!r || !r.AS_ENTRIES), M = !(!r || !r.IS_RECORD), C = !(!r || !r.IS_ITERATOR), T = !(!r || !r.INTERRUPTED), E = n(t, k), A = function(e) {
                        return b && f(b, "normal", e), new p(!0, e);
                    }, R = function(e) {
                        return S ? (s(e), T ? E(e[0], e[1], A) : E(e[0], e[1])) : T ? E(e, A) : E(e);
                    };
                    if (M) b = e.iterator;
                    else if (C) b = e;
                    else {
                        if (!(g = h(e))) throw new d(o(e) + " is not iterable");
                        if (a(g)) {
                            for(y = 0, v = l(e); v > y; y++)if ((w = R(e[y])) && c(m, w)) return w;
                            return new p(!1);
                        }
                        b = u(e, g);
                    }
                    for(_ = M ? e.next : b.next; !(x = i(_, b)).done;){
                        try {
                            w = R(x.value);
                        } catch (e) {
                            f(b, "throw", e);
                        }
                        if ("object" == typeof w && w && c(m, w)) return w;
                    }
                    return new p(!1);
                };
            },
            {
                "../internals/an-object": 227,
                "../internals/function-bind-context": 262,
                "../internals/function-call": 264,
                "../internals/get-iterator": 271,
                "../internals/get-iterator-method": 270,
                "../internals/is-array-iterator-method": 283,
                "../internals/iterator-close": 294,
                "../internals/length-of-array-like": 299,
                "../internals/object-is-prototype-of": 314,
                "../internals/try-to-string": 349
            }
        ],
        294: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/function-call"), i = e("../internals/an-object"), s = e("../internals/get-method");
                t.exports = function(e, t, r) {
                    var o, a;
                    i(e);
                    try {
                        if (!(o = s(e, "return"))) {
                            if ("throw" === t) throw r;
                            return r;
                        }
                        o = n(o, e);
                    } catch (e) {
                        a = !0, o = e;
                    }
                    if ("throw" === t) throw r;
                    if (a) throw o;
                    return i(o), r;
                };
            },
            {
                "../internals/an-object": 227,
                "../internals/function-call": 264,
                "../internals/get-method": 273
            }
        ],
        295: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/iterators-core").IteratorPrototype, i = e("../internals/object-create"), s = e("../internals/create-property-descriptor"), o = e("../internals/set-to-string-tag"), a = e("../internals/iterators"), l = function() {
                    return this;
                };
                t.exports = function(e, t, r, c) {
                    var u = t + " Iterator";
                    return e.prototype = i(n, {
                        next: s(+!c, r)
                    }), o(e, u, !1, !0), a[u] = l, e;
                };
            },
            {
                "../internals/create-property-descriptor": 242,
                "../internals/iterators": 298,
                "../internals/iterators-core": 297,
                "../internals/object-create": 306,
                "../internals/set-to-string-tag": 331
            }
        ],
        296: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/export"), i = e("../internals/function-call"), s = e("../internals/is-pure"), o = e("../internals/function-name"), a = e("../internals/is-callable"), l = e("../internals/iterator-create-constructor"), c = e("../internals/object-get-prototype-of"), u = e("../internals/object-set-prototype-of"), h = e("../internals/set-to-string-tag"), f = e("../internals/create-non-enumerable-property"), d = e("../internals/define-built-in"), p = e("../internals/well-known-symbol"), m = e("../internals/iterators"), b = e("../internals/iterators-core"), g = o.PROPER, y = o.CONFIGURABLE, v = b.IteratorPrototype, w = b.BUGGY_SAFARI_ITERATORS, _ = p("iterator"), x = function() {
                    return this;
                };
                t.exports = function(e, t, r, o, p, b, k) {
                    l(r, t, o);
                    var S, M, C, T = function(e) {
                        if (e === p && j) return j;
                        if (!w && e && e in R) return R[e];
                        switch(e){
                            case "keys":
                            case "values":
                            case "entries":
                                return function() {
                                    return new r(this, e);
                                };
                        }
                        return function() {
                            return new r(this);
                        };
                    }, E = t + " Iterator", A = !1, R = e.prototype, O = R[_] || R["@@iterator"] || p && R[p], j = !w && O || T(p), I = "Array" === t && R.entries || O;
                    if (I && (S = c(I.call(new e))) !== Object.prototype && S.next && (s || c(S) === v || (u ? u(S, v) : a(S[_]) || d(S, _, x)), h(S, E, !0, !0), s && (m[E] = x)), g && "values" === p && O && "values" !== O.name && (!s && y ? f(R, "name", "values") : (A = !0, j = function() {
                        return i(O, this);
                    })), p) {
                        if (M = {
                            values: T("values"),
                            keys: b ? j : T("keys"),
                            entries: T("entries")
                        }, k) for(C in M)(w || A || !(C in R)) && d(R, C, M[C]);
                        else n({
                            target: t,
                            proto: !0,
                            forced: w || A
                        }, M);
                    }
                    return s && !k || R[_] === j || d(R, _, j, {
                        name: p
                    }), m[t] = j, M;
                };
            },
            {
                "../internals/create-non-enumerable-property": 241,
                "../internals/define-built-in": 245,
                "../internals/export": 259,
                "../internals/function-call": 264,
                "../internals/function-name": 265,
                "../internals/is-callable": 285,
                "../internals/is-pure": 290,
                "../internals/iterator-create-constructor": 295,
                "../internals/iterators": 298,
                "../internals/iterators-core": 297,
                "../internals/object-get-prototype-of": 313,
                "../internals/object-set-prototype-of": 318,
                "../internals/set-to-string-tag": 331,
                "../internals/well-known-symbol": 357
            }
        ],
        297: [
            function(e, t, r) {
                "use strict";
                var n, i, s, o = e("../internals/fails"), a = e("../internals/is-callable"), l = e("../internals/is-object"), c = e("../internals/object-create"), u = e("../internals/object-get-prototype-of"), h = e("../internals/define-built-in"), f = e("../internals/well-known-symbol"), d = e("../internals/is-pure"), p = f("iterator"), m = !1;
                [].keys && ("next" in (s = [].keys()) ? (i = u(u(s))) !== Object.prototype && (n = i) : m = !0), !l(n) || o(function() {
                    var e = {};
                    return n[p].call(e) !== e;
                }) ? n = {} : d && (n = c(n)), a(n[p]) || h(n, p, function() {
                    return this;
                }), t.exports = {
                    IteratorPrototype: n,
                    BUGGY_SAFARI_ITERATORS: m
                };
            },
            {
                "../internals/define-built-in": 245,
                "../internals/fails": 260,
                "../internals/is-callable": 285,
                "../internals/is-object": 289,
                "../internals/is-pure": 290,
                "../internals/object-create": 306,
                "../internals/object-get-prototype-of": 313,
                "../internals/well-known-symbol": 357
            }
        ],
        298: [
            function(e, t, r) {
                arguments[4][276][0].apply(r, arguments);
            },
            {
                dup: 276
            }
        ],
        299: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/to-length");
                t.exports = function(e) {
                    return n(e.length);
                };
            },
            {
                "../internals/to-length": 343
            }
        ],
        300: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/function-uncurry-this"), i = e("../internals/fails"), s = e("../internals/is-callable"), o = e("../internals/has-own-property"), a = e("../internals/descriptors"), l = e("../internals/function-name").CONFIGURABLE, c = e("../internals/inspect-source"), u = e("../internals/internal-state"), h = u.enforce, f = u.get, d = String, p = Object.defineProperty, m = n("".slice), b = n("".replace), g = n([].join), y = a && !i(function() {
                    return 8 !== p(function() {}, "length", {
                        value: 8
                    }).length;
                }), v = String(String).split("String"), w = t.exports = function(e, t, r) {
                    "Symbol(" === m(d(t), 0, 7) && (t = "[" + b(d(t), /^Symbol\(([^)]*)\)/, "$1") + "]"), r && r.getter && (t = "get " + t), r && r.setter && (t = "set " + t), (!o(e, "name") || l && e.name !== t) && (a ? p(e, "name", {
                        value: t,
                        configurable: !0
                    }) : e.name = t), y && r && o(r, "arity") && e.length !== r.arity && p(e, "length", {
                        value: r.arity
                    });
                    try {
                        r && o(r, "constructor") && r.constructor ? a && p(e, "prototype", {
                            writable: !1
                        }) : e.prototype && (e.prototype = void 0);
                    } catch (e) {}
                    var n = h(e);
                    return o(n, "source") || (n.source = g(v, "string" == typeof t ? t : "")), e;
                };
                Function.prototype.toString = w(function() {
                    return s(this) && f(this).source || c(this);
                }, "toString");
            },
            {
                "../internals/descriptors": 247,
                "../internals/fails": 260,
                "../internals/function-name": 265,
                "../internals/function-uncurry-this": 268,
                "../internals/has-own-property": 275,
                "../internals/inspect-source": 281,
                "../internals/internal-state": 282,
                "../internals/is-callable": 285
            }
        ],
        301: [
            function(e, t, r) {
                "use strict";
                var n = Math.ceil, i = Math.floor;
                t.exports = Math.trunc || function(e) {
                    var t = +e;
                    return (t > 0 ? i : n)(t);
                };
            },
            {}
        ],
        302: [
            function(e, t, r) {
                "use strict";
                var n, i, s, o, a, l = e("../internals/global"), c = e("../internals/function-bind-context"), u = e("../internals/object-get-own-property-descriptor").f, h = e("../internals/task").set, f = e("../internals/queue"), d = e("../internals/engine-is-ios"), p = e("../internals/engine-is-ios-pebble"), m = e("../internals/engine-is-webos-webkit"), b = e("../internals/engine-is-node"), g = l.MutationObserver || l.WebKitMutationObserver, y = l.document, v = l.process, w = l.Promise, _ = u(l, "queueMicrotask"), x = _ && _.value;
                if (!x) {
                    var k = new f, S = function() {
                        var e, t;
                        for(b && (e = v.domain) && e.exit(); t = k.get();)try {
                            t();
                        } catch (e) {
                            throw k.head && n(), e;
                        }
                        e && e.enter();
                    };
                    d || b || m || !g || !y ? !p && w && w.resolve ? ((o = w.resolve(void 0)).constructor = w, a = c(o.then, o), n = function() {
                        a(S);
                    }) : b ? n = function() {
                        v.nextTick(S);
                    } : (h = c(h, l), n = function() {
                        h(S);
                    }) : (i = !0, s = y.createTextNode(""), new g(S).observe(s, {
                        characterData: !0
                    }), n = function() {
                        s.data = i = !i;
                    }), x = function(e) {
                        k.head || n(), k.add(e);
                    };
                }
                t.exports = x;
            },
            {
                "../internals/engine-is-ios": 253,
                "../internals/engine-is-ios-pebble": 252,
                "../internals/engine-is-node": 254,
                "../internals/engine-is-webos-webkit": 255,
                "../internals/function-bind-context": 262,
                "../internals/global": 274,
                "../internals/object-get-own-property-descriptor": 309,
                "../internals/queue": 328,
                "../internals/task": 339
            }
        ],
        303: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/a-callable"), i = TypeError, s = function(e) {
                    var t, r;
                    this.promise = new e(function(e, n) {
                        if (void 0 !== t || void 0 !== r) throw new i("Bad Promise constructor");
                        t = e, r = n;
                    }), this.resolve = n(t), this.reject = n(r);
                };
                t.exports.f = function(e) {
                    return new s(e);
                };
            },
            {
                "../internals/a-callable": 222
            }
        ],
        304: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/is-regexp"), i = TypeError;
                t.exports = function(e) {
                    if (n(e)) throw new i("The method doesn't accept regular expressions");
                    return e;
                };
            },
            {
                "../internals/is-regexp": 291
            }
        ],
        305: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/descriptors"), i = e("../internals/function-uncurry-this"), s = e("../internals/function-call"), o = e("../internals/fails"), a = e("../internals/object-keys"), l = e("../internals/object-get-own-property-symbols"), c = e("../internals/object-property-is-enumerable"), u = e("../internals/to-object"), h = e("../internals/indexed-object"), f = Object.assign, d = Object.defineProperty, p = i([].concat);
                t.exports = !f || o(function() {
                    if (n && 1 !== f({
                        b: 1
                    }, f(d({}, "a", {
                        enumerable: !0,
                        get: function() {
                            d(this, "b", {
                                value: 3,
                                enumerable: !1
                            });
                        }
                    }), {
                        b: 2
                    })).b) return !0;
                    var e = {}, t = {}, r = Symbol("assign detection");
                    return e[r] = 7, "abcdefghijklmnopqrst".split("").forEach(function(e) {
                        t[e] = e;
                    }), 7 !== f({}, e)[r] || "abcdefghijklmnopqrst" !== a(f({}, t)).join("");
                }) ? function(e, t) {
                    for(var r = u(e), i = arguments.length, o = 1, f = l.f, d = c.f; i > o;)for(var m, b = h(arguments[o++]), g = f ? p(a(b), f(b)) : a(b), y = g.length, v = 0; y > v;)m = g[v++], n && !s(d, b, m) || (r[m] = b[m]);
                    return r;
                } : f;
            },
            {
                "../internals/descriptors": 247,
                "../internals/fails": 260,
                "../internals/function-call": 264,
                "../internals/function-uncurry-this": 268,
                "../internals/indexed-object": 280,
                "../internals/object-get-own-property-symbols": 312,
                "../internals/object-keys": 316,
                "../internals/object-property-is-enumerable": 317,
                "../internals/to-object": 344
            }
        ],
        306: [
            function(e, t, r) {
                "use strict";
                var n, i = e("../internals/an-object"), s = e("../internals/object-define-properties"), o = e("../internals/enum-bug-keys"), a = e("../internals/hidden-keys"), l = e("../internals/html"), c = e("../internals/document-create-element"), u = e("../internals/shared-key"), h = u("IE_PROTO"), f = function() {}, d = function(e) {
                    return "<script>" + e + "<\/script>";
                }, p = function(e) {
                    e.write(d("")), e.close();
                    var t = e.parentWindow.Object;
                    return e = null, t;
                }, m = function() {
                    try {
                        n = new ActiveXObject("htmlfile");
                    } catch (e) {}
                    var e, t;
                    m = "undefined" != typeof document ? document.domain && n ? p(n) : ((t = c("iframe")).style.display = "none", l.appendChild(t), t.src = String("javascript:"), (e = t.contentWindow.document).open(), e.write(d("document.F=Object")), e.close(), e.F) : p(n);
                    for(var r = o.length; r--;)delete m.prototype[o[r]];
                    return m();
                };
                a[h] = !0, t.exports = Object.create || function(e, t) {
                    var r;
                    return null !== e ? (f.prototype = i(e), r = new f, f.prototype = null, r[h] = e) : r = m(), void 0 === t ? r : s.f(r, t);
                };
            },
            {
                "../internals/an-object": 227,
                "../internals/document-create-element": 249,
                "../internals/enum-bug-keys": 258,
                "../internals/hidden-keys": 276,
                "../internals/html": 278,
                "../internals/object-define-properties": 307,
                "../internals/shared-key": 332
            }
        ],
        307: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/descriptors"), i = e("../internals/v8-prototype-define-bug"), s = e("../internals/object-define-property"), o = e("../internals/an-object"), a = e("../internals/to-indexed-object"), l = e("../internals/object-keys");
                r.f = n && !i ? Object.defineProperties : function(e, t) {
                    o(e);
                    for(var r, n = a(t), i = l(t), c = i.length, u = 0; c > u;)s.f(e, r = i[u++], n[r]);
                    return e;
                };
            },
            {
                "../internals/an-object": 227,
                "../internals/descriptors": 247,
                "../internals/object-define-property": 308,
                "../internals/object-keys": 316,
                "../internals/to-indexed-object": 341,
                "../internals/v8-prototype-define-bug": 352
            }
        ],
        308: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/descriptors"), i = e("../internals/ie8-dom-define"), s = e("../internals/v8-prototype-define-bug"), o = e("../internals/an-object"), a = e("../internals/to-property-key"), l = TypeError, c = Object.defineProperty, u = Object.getOwnPropertyDescriptor;
                r.f = n ? s ? function(e, t, r) {
                    if (o(e), t = a(t), o(r), "function" == typeof e && "prototype" === t && "value" in r && "writable" in r && !r.writable) {
                        var n = u(e, t);
                        n && n.writable && (e[t] = r.value, r = {
                            configurable: "configurable" in r ? r.configurable : n.configurable,
                            enumerable: "enumerable" in r ? r.enumerable : n.enumerable,
                            writable: !1
                        });
                    }
                    return c(e, t, r);
                } : c : function(e, t, r) {
                    if (o(e), t = a(t), o(r), i) try {
                        return c(e, t, r);
                    } catch (e) {}
                    if ("get" in r || "set" in r) throw new l("Accessors not supported");
                    return "value" in r && (e[t] = r.value), e;
                };
            },
            {
                "../internals/an-object": 227,
                "../internals/descriptors": 247,
                "../internals/ie8-dom-define": 279,
                "../internals/to-property-key": 346,
                "../internals/v8-prototype-define-bug": 352
            }
        ],
        309: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/descriptors"), i = e("../internals/function-call"), s = e("../internals/object-property-is-enumerable"), o = e("../internals/create-property-descriptor"), a = e("../internals/to-indexed-object"), l = e("../internals/to-property-key"), c = e("../internals/has-own-property"), u = e("../internals/ie8-dom-define"), h = Object.getOwnPropertyDescriptor;
                r.f = n ? h : function(e, t) {
                    if (e = a(e), t = l(t), u) try {
                        return h(e, t);
                    } catch (e) {}
                    if (c(e, t)) return o(!i(s.f, e, t), e[t]);
                };
            },
            {
                "../internals/create-property-descriptor": 242,
                "../internals/descriptors": 247,
                "../internals/function-call": 264,
                "../internals/has-own-property": 275,
                "../internals/ie8-dom-define": 279,
                "../internals/object-property-is-enumerable": 317,
                "../internals/to-indexed-object": 341,
                "../internals/to-property-key": 346
            }
        ],
        310: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/classof-raw"), i = e("../internals/to-indexed-object"), s = e("../internals/object-get-own-property-names").f, o = e("../internals/array-slice-simple"), a = "object" == typeof window && window && Object.getOwnPropertyNames ? Object.getOwnPropertyNames(window) : [];
                t.exports.f = function(e) {
                    return a && "Window" === n(e) ? function(e) {
                        try {
                            return s(e);
                        } catch (e) {
                            return o(a);
                        }
                    }(e) : s(i(e));
                };
            },
            {
                "../internals/array-slice-simple": 230,
                "../internals/classof-raw": 235,
                "../internals/object-get-own-property-names": 311,
                "../internals/to-indexed-object": 341
            }
        ],
        311: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/object-keys-internal"), i = e("../internals/enum-bug-keys").concat("length", "prototype");
                r.f = Object.getOwnPropertyNames || function(e) {
                    return n(e, i);
                };
            },
            {
                "../internals/enum-bug-keys": 258,
                "../internals/object-keys-internal": 315
            }
        ],
        312: [
            function(e, t, r) {
                "use strict";
                r.f = Object.getOwnPropertySymbols;
            },
            {}
        ],
        313: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/has-own-property"), i = e("../internals/is-callable"), s = e("../internals/to-object"), o = e("../internals/shared-key"), a = e("../internals/correct-prototype-getter"), l = o("IE_PROTO"), c = Object, u = c.prototype;
                t.exports = a ? c.getPrototypeOf : function(e) {
                    var t = s(e);
                    if (n(t, l)) return t[l];
                    var r = t.constructor;
                    return i(r) && t instanceof r ? r.prototype : t instanceof c ? u : null;
                };
            },
            {
                "../internals/correct-prototype-getter": 239,
                "../internals/has-own-property": 275,
                "../internals/is-callable": 285,
                "../internals/shared-key": 332,
                "../internals/to-object": 344
            }
        ],
        314: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/function-uncurry-this");
                t.exports = n({}.isPrototypeOf);
            },
            {
                "../internals/function-uncurry-this": 268
            }
        ],
        315: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/function-uncurry-this"), i = e("../internals/has-own-property"), s = e("../internals/to-indexed-object"), o = e("../internals/array-includes").indexOf, a = e("../internals/hidden-keys"), l = n([].push);
                t.exports = function(e, t) {
                    var r, n = s(e), c = 0, u = [];
                    for(r in n)!i(a, r) && i(n, r) && l(u, r);
                    for(; t.length > c;)i(n, r = t[c++]) && (~o(u, r) || l(u, r));
                    return u;
                };
            },
            {
                "../internals/array-includes": 228,
                "../internals/function-uncurry-this": 268,
                "../internals/has-own-property": 275,
                "../internals/hidden-keys": 276,
                "../internals/to-indexed-object": 341
            }
        ],
        316: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/object-keys-internal"), i = e("../internals/enum-bug-keys");
                t.exports = Object.keys || function(e) {
                    return n(e, i);
                };
            },
            {
                "../internals/enum-bug-keys": 258,
                "../internals/object-keys-internal": 315
            }
        ],
        317: [
            function(e, t, r) {
                "use strict";
                var n = {}.propertyIsEnumerable, i = Object.getOwnPropertyDescriptor, s = i && !n.call({
                    1: 2
                }, 1);
                r.f = s ? function(e) {
                    var t = i(this, e);
                    return !!t && t.enumerable;
                } : n;
            },
            {}
        ],
        318: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/function-uncurry-this-accessor"), i = e("../internals/an-object"), s = e("../internals/a-possible-prototype");
                t.exports = Object.setPrototypeOf || ("__proto__" in {} ? function() {
                    var e, t = !1, r = {};
                    try {
                        (e = n(Object.prototype, "__proto__", "set"))(r, []), t = r instanceof Array;
                    } catch (e) {}
                    return function(r, n) {
                        return i(r), s(n), t ? e(r, n) : r.__proto__ = n, r;
                    };
                }() : void 0);
            },
            {
                "../internals/a-possible-prototype": 224,
                "../internals/an-object": 227,
                "../internals/function-uncurry-this-accessor": 266
            }
        ],
        319: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/descriptors"), i = e("../internals/fails"), s = e("../internals/function-uncurry-this"), o = e("../internals/object-get-prototype-of"), a = e("../internals/object-keys"), l = e("../internals/to-indexed-object"), c = s(e("../internals/object-property-is-enumerable").f), u = s([].push), h = n && i(function() {
                    var e = Object.create(null);
                    return e[2] = 2, !c(e, 2);
                }), f = function(e) {
                    return function(t) {
                        for(var r, i = l(t), s = a(i), f = h && null === o(i), d = s.length, p = 0, m = []; d > p;)r = s[p++], n && !(f ? r in i : c(i, r)) || u(m, e ? [
                            r,
                            i[r]
                        ] : i[r]);
                        return m;
                    };
                };
                t.exports = {
                    entries: f(!0),
                    values: f(!1)
                };
            },
            {
                "../internals/descriptors": 247,
                "../internals/fails": 260,
                "../internals/function-uncurry-this": 268,
                "../internals/object-get-prototype-of": 313,
                "../internals/object-keys": 316,
                "../internals/object-property-is-enumerable": 317,
                "../internals/to-indexed-object": 341
            }
        ],
        320: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/function-call"), i = e("../internals/is-callable"), s = e("../internals/is-object"), o = TypeError;
                t.exports = function(e, t) {
                    var r, a;
                    if ("string" === t && i(r = e.toString) && !s(a = n(r, e))) return a;
                    if (i(r = e.valueOf) && !s(a = n(r, e))) return a;
                    if ("string" !== t && i(r = e.toString) && !s(a = n(r, e))) return a;
                    throw new o("Can't convert object to primitive value");
                };
            },
            {
                "../internals/function-call": 264,
                "../internals/is-callable": 285,
                "../internals/is-object": 289
            }
        ],
        321: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/get-built-in"), i = e("../internals/function-uncurry-this"), s = e("../internals/object-get-own-property-names"), o = e("../internals/object-get-own-property-symbols"), a = e("../internals/an-object"), l = i([].concat);
                t.exports = n("Reflect", "ownKeys") || function(e) {
                    var t = s.f(a(e)), r = o.f;
                    return r ? l(t, r(e)) : t;
                };
            },
            {
                "../internals/an-object": 227,
                "../internals/function-uncurry-this": 268,
                "../internals/get-built-in": 269,
                "../internals/object-get-own-property-names": 311,
                "../internals/object-get-own-property-symbols": 312
            }
        ],
        322: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/global");
                t.exports = n;
            },
            {
                "../internals/global": 274
            }
        ],
        323: [
            function(e, t, r) {
                "use strict";
                t.exports = function(e) {
                    try {
                        return {
                            error: !1,
                            value: e()
                        };
                    } catch (e) {
                        return {
                            error: !0,
                            value: e
                        };
                    }
                };
            },
            {}
        ],
        324: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/global"), i = e("../internals/promise-native-constructor"), s = e("../internals/is-callable"), o = e("../internals/is-forced"), a = e("../internals/inspect-source"), l = e("../internals/well-known-symbol"), c = e("../internals/engine-is-browser"), u = e("../internals/engine-is-deno"), h = e("../internals/is-pure"), f = e("../internals/engine-v8-version"), d = i && i.prototype, p = l("species"), m = !1, b = s(n.PromiseRejectionEvent), g = o("Promise", function() {
                    var e = a(i), t = e !== String(i);
                    if (!t && 66 === f) return !0;
                    if (h && (!d.catch || !d.finally)) return !0;
                    if (!f || f < 51 || !/native code/.test(e)) {
                        var r = new i(function(e) {
                            e(1);
                        }), n = function(e) {
                            e(function() {}, function() {});
                        };
                        if ((r.constructor = {})[p] = n, !(m = r.then(function() {}) instanceof n)) return !0;
                    }
                    return !t && (c || u) && !b;
                });
                t.exports = {
                    CONSTRUCTOR: g,
                    REJECTION_EVENT: b,
                    SUBCLASSING: m
                };
            },
            {
                "../internals/engine-is-browser": 250,
                "../internals/engine-is-deno": 251,
                "../internals/engine-v8-version": 257,
                "../internals/global": 274,
                "../internals/inspect-source": 281,
                "../internals/is-callable": 285,
                "../internals/is-forced": 287,
                "../internals/is-pure": 290,
                "../internals/promise-native-constructor": 325,
                "../internals/well-known-symbol": 357
            }
        ],
        325: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/global");
                t.exports = n.Promise;
            },
            {
                "../internals/global": 274
            }
        ],
        326: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/an-object"), i = e("../internals/is-object"), s = e("../internals/new-promise-capability");
                t.exports = function(e, t) {
                    if (n(e), i(t) && t.constructor === e) return t;
                    var r = s.f(e);
                    return (0, r.resolve)(t), r.promise;
                };
            },
            {
                "../internals/an-object": 227,
                "../internals/is-object": 289,
                "../internals/new-promise-capability": 303
            }
        ],
        327: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/promise-native-constructor"), i = e("../internals/check-correctness-of-iteration"), s = e("../internals/promise-constructor-detection").CONSTRUCTOR;
                t.exports = s || !i(function(e) {
                    n.all(e).then(void 0, function() {});
                });
            },
            {
                "../internals/check-correctness-of-iteration": 234,
                "../internals/promise-constructor-detection": 324,
                "../internals/promise-native-constructor": 325
            }
        ],
        328: [
            function(e, t, r) {
                "use strict";
                var n = function() {
                    this.head = null, this.tail = null;
                };
                n.prototype = {
                    add: function(e) {
                        var t = {
                            item: e,
                            next: null
                        }, r = this.tail;
                        r ? r.next = t : this.head = t, this.tail = t;
                    },
                    get: function() {
                        var e = this.head;
                        if (e) return null === (this.head = e.next) && (this.tail = null), e.item;
                    }
                }, t.exports = n;
            },
            {}
        ],
        329: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/is-null-or-undefined"), i = TypeError;
                t.exports = function(e) {
                    if (n(e)) throw new i("Can't call method on " + e);
                    return e;
                };
            },
            {
                "../internals/is-null-or-undefined": 288
            }
        ],
        330: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/get-built-in"), i = e("../internals/define-built-in-accessor"), s = e("../internals/well-known-symbol"), o = e("../internals/descriptors"), a = s("species");
                t.exports = function(e) {
                    var t = n(e);
                    o && t && !t[a] && i(t, a, {
                        configurable: !0,
                        get: function() {
                            return this;
                        }
                    });
                };
            },
            {
                "../internals/define-built-in-accessor": 244,
                "../internals/descriptors": 247,
                "../internals/get-built-in": 269,
                "../internals/well-known-symbol": 357
            }
        ],
        331: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/object-define-property").f, i = e("../internals/has-own-property"), s = e("../internals/well-known-symbol")("toStringTag");
                t.exports = function(e, t, r) {
                    e && !r && (e = e.prototype), e && !i(e, s) && n(e, s, {
                        configurable: !0,
                        value: t
                    });
                };
            },
            {
                "../internals/has-own-property": 275,
                "../internals/object-define-property": 308,
                "../internals/well-known-symbol": 357
            }
        ],
        332: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/shared"), i = e("../internals/uid"), s = n("keys");
                t.exports = function(e) {
                    return s[e] || (s[e] = i(e));
                };
            },
            {
                "../internals/shared": 334,
                "../internals/uid": 350
            }
        ],
        333: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/global"), i = e("../internals/define-global-property"), s = n["__core-js_shared__"] || i("__core-js_shared__", {});
                t.exports = s;
            },
            {
                "../internals/define-global-property": 246,
                "../internals/global": 274
            }
        ],
        334: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/is-pure"), i = e("../internals/shared-store");
                (t.exports = function(e, t) {
                    return i[e] || (i[e] = void 0 !== t ? t : {});
                })("versions", []).push({
                    version: "3.33.0",
                    mode: n ? "pure" : "global",
                    copyright: "\xa9 2014-2023 Denis Pushkarev (zloirock.ru)",
                    license: "https://github.com/zloirock/core-js/blob/v3.33.0/LICENSE",
                    source: "https://github.com/zloirock/core-js"
                });
            },
            {
                "../internals/is-pure": 290,
                "../internals/shared-store": 333
            }
        ],
        335: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/an-object"), i = e("../internals/a-constructor"), s = e("../internals/is-null-or-undefined"), o = e("../internals/well-known-symbol")("species");
                t.exports = function(e, t) {
                    var r, a = n(e).constructor;
                    return void 0 === a || s(r = n(a)[o]) ? t : i(r);
                };
            },
            {
                "../internals/a-constructor": 223,
                "../internals/an-object": 227,
                "../internals/is-null-or-undefined": 288,
                "../internals/well-known-symbol": 357
            }
        ],
        336: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/engine-v8-version"), i = e("../internals/fails"), s = e("../internals/global").String;
                t.exports = !!Object.getOwnPropertySymbols && !i(function() {
                    var e = Symbol("symbol detection");
                    return !s(e) || !(Object(e) instanceof Symbol) || !Symbol.sham && n && n < 41;
                });
            },
            {
                "../internals/engine-v8-version": 257,
                "../internals/fails": 260,
                "../internals/global": 274
            }
        ],
        337: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/function-call"), i = e("../internals/get-built-in"), s = e("../internals/well-known-symbol"), o = e("../internals/define-built-in");
                t.exports = function() {
                    var e = i("Symbol"), t = e && e.prototype, r = t && t.valueOf, a = s("toPrimitive");
                    t && !t[a] && o(t, a, function(e) {
                        return n(r, this);
                    }, {
                        arity: 1
                    });
                };
            },
            {
                "../internals/define-built-in": 245,
                "../internals/function-call": 264,
                "../internals/get-built-in": 269,
                "../internals/well-known-symbol": 357
            }
        ],
        338: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/symbol-constructor-detection");
                t.exports = n && !!Symbol.for && !!Symbol.keyFor;
            },
            {
                "../internals/symbol-constructor-detection": 336
            }
        ],
        339: [
            function(e, t, r) {
                "use strict";
                var n, i, s, o, a = e("../internals/global"), l = e("../internals/function-apply"), c = e("../internals/function-bind-context"), u = e("../internals/is-callable"), h = e("../internals/has-own-property"), f = e("../internals/fails"), d = e("../internals/html"), p = e("../internals/array-slice"), m = e("../internals/document-create-element"), b = e("../internals/validate-arguments-length"), g = e("../internals/engine-is-ios"), y = e("../internals/engine-is-node"), v = a.setImmediate, w = a.clearImmediate, _ = a.process, x = a.Dispatch, k = a.Function, S = a.MessageChannel, M = a.String, C = 0, T = {};
                f(function() {
                    n = a.location;
                });
                var E = function(e) {
                    if (h(T, e)) {
                        var t = T[e];
                        delete T[e], t();
                    }
                }, A = function(e) {
                    return function() {
                        E(e);
                    };
                }, R = function(e) {
                    E(e.data);
                }, O = function(e) {
                    a.postMessage(M(e), n.protocol + "//" + n.host);
                };
                v && w || (v = function(e) {
                    b(arguments.length, 1);
                    var t = u(e) ? e : k(e), r = p(arguments, 1);
                    return T[++C] = function() {
                        l(t, void 0, r);
                    }, i(C), C;
                }, w = function(e) {
                    delete T[e];
                }, y ? i = function(e) {
                    _.nextTick(A(e));
                } : x && x.now ? i = function(e) {
                    x.now(A(e));
                } : S && !g ? (o = (s = new S).port2, s.port1.onmessage = R, i = c(o.postMessage, o)) : a.addEventListener && u(a.postMessage) && !a.importScripts && n && "file:" !== n.protocol && !f(O) ? (i = O, a.addEventListener("message", R, !1)) : i = "onreadystatechange" in m("script") ? function(e) {
                    d.appendChild(m("script")).onreadystatechange = function() {
                        d.removeChild(this), E(e);
                    };
                } : function(e) {
                    setTimeout(A(e), 0);
                }), t.exports = {
                    set: v,
                    clear: w
                };
            },
            {
                "../internals/array-slice": 231,
                "../internals/document-create-element": 249,
                "../internals/engine-is-ios": 253,
                "../internals/engine-is-node": 254,
                "../internals/fails": 260,
                "../internals/function-apply": 261,
                "../internals/function-bind-context": 262,
                "../internals/global": 274,
                "../internals/has-own-property": 275,
                "../internals/html": 278,
                "../internals/is-callable": 285,
                "../internals/validate-arguments-length": 353
            }
        ],
        340: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/to-integer-or-infinity"), i = Math.max, s = Math.min;
                t.exports = function(e, t) {
                    var r = n(e);
                    return r < 0 ? i(r + t, 0) : s(r, t);
                };
            },
            {
                "../internals/to-integer-or-infinity": 342
            }
        ],
        341: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/indexed-object"), i = e("../internals/require-object-coercible");
                t.exports = function(e) {
                    return n(i(e));
                };
            },
            {
                "../internals/indexed-object": 280,
                "../internals/require-object-coercible": 329
            }
        ],
        342: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/math-trunc");
                t.exports = function(e) {
                    var t = +e;
                    return t != t || 0 === t ? 0 : n(t);
                };
            },
            {
                "../internals/math-trunc": 301
            }
        ],
        343: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/to-integer-or-infinity"), i = Math.min;
                t.exports = function(e) {
                    return e > 0 ? i(n(e), 9007199254740991) : 0;
                };
            },
            {
                "../internals/to-integer-or-infinity": 342
            }
        ],
        344: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/require-object-coercible"), i = Object;
                t.exports = function(e) {
                    return i(n(e));
                };
            },
            {
                "../internals/require-object-coercible": 329
            }
        ],
        345: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/function-call"), i = e("../internals/is-object"), s = e("../internals/is-symbol"), o = e("../internals/get-method"), a = e("../internals/ordinary-to-primitive"), l = e("../internals/well-known-symbol"), c = TypeError, u = l("toPrimitive");
                t.exports = function(e, t) {
                    if (!i(e) || s(e)) return e;
                    var r, l = o(e, u);
                    if (l) {
                        if (void 0 === t && (t = "default"), r = n(l, e, t), !i(r) || s(r)) return r;
                        throw new c("Can't convert object to primitive value");
                    }
                    return void 0 === t && (t = "number"), a(e, t);
                };
            },
            {
                "../internals/function-call": 264,
                "../internals/get-method": 273,
                "../internals/is-object": 289,
                "../internals/is-symbol": 292,
                "../internals/ordinary-to-primitive": 320,
                "../internals/well-known-symbol": 357
            }
        ],
        346: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/to-primitive"), i = e("../internals/is-symbol");
                t.exports = function(e) {
                    var t = n(e, "string");
                    return i(t) ? t : t + "";
                };
            },
            {
                "../internals/is-symbol": 292,
                "../internals/to-primitive": 345
            }
        ],
        347: [
            function(e, t, r) {
                "use strict";
                var n = {};
                n[e("../internals/well-known-symbol")("toStringTag")] = "z", t.exports = "[object z]" === String(n);
            },
            {
                "../internals/well-known-symbol": 357
            }
        ],
        348: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/classof"), i = String;
                t.exports = function(e) {
                    if ("Symbol" === n(e)) throw new TypeError("Cannot convert a Symbol value to a string");
                    return i(e);
                };
            },
            {
                "../internals/classof": 236
            }
        ],
        349: [
            function(e, t, r) {
                "use strict";
                var n = String;
                t.exports = function(e) {
                    try {
                        return n(e);
                    } catch (e) {
                        return "Object";
                    }
                };
            },
            {}
        ],
        350: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/function-uncurry-this"), i = 0, s = Math.random(), o = n(1..toString);
                t.exports = function(e) {
                    return "Symbol(" + (void 0 === e ? "" : e) + ")_" + o(++i + s, 36);
                };
            },
            {
                "../internals/function-uncurry-this": 268
            }
        ],
        351: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/symbol-constructor-detection");
                t.exports = n && !Symbol.sham && "symbol" == typeof Symbol.iterator;
            },
            {
                "../internals/symbol-constructor-detection": 336
            }
        ],
        352: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/descriptors"), i = e("../internals/fails");
                t.exports = n && i(function() {
                    return 42 !== Object.defineProperty(function() {}, "prototype", {
                        value: 42,
                        writable: !1
                    }).prototype;
                });
            },
            {
                "../internals/descriptors": 247,
                "../internals/fails": 260
            }
        ],
        353: [
            function(e, t, r) {
                "use strict";
                var n = TypeError;
                t.exports = function(e, t) {
                    if (e < t) throw new n("Not enough arguments");
                    return e;
                };
            },
            {}
        ],
        354: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/global"), i = e("../internals/is-callable"), s = n.WeakMap;
                t.exports = i(s) && /native code/.test(String(s));
            },
            {
                "../internals/global": 274,
                "../internals/is-callable": 285
            }
        ],
        355: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/path"), i = e("../internals/has-own-property"), s = e("../internals/well-known-symbol-wrapped"), o = e("../internals/object-define-property").f;
                t.exports = function(e) {
                    var t = n.Symbol || (n.Symbol = {});
                    i(t, e) || o(t, e, {
                        value: s.f(e)
                    });
                };
            },
            {
                "../internals/has-own-property": 275,
                "../internals/object-define-property": 308,
                "../internals/path": 322,
                "../internals/well-known-symbol-wrapped": 356
            }
        ],
        356: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/well-known-symbol");
                r.f = n;
            },
            {
                "../internals/well-known-symbol": 357
            }
        ],
        357: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/global"), i = e("../internals/shared"), s = e("../internals/has-own-property"), o = e("../internals/uid"), a = e("../internals/symbol-constructor-detection"), l = e("../internals/use-symbol-as-uid"), c = n.Symbol, u = i("wks"), h = l ? c.for || c : c && c.withoutSetter || o;
                t.exports = function(e) {
                    return s(u, e) || (u[e] = a && s(c, e) ? c[e] : h("Symbol." + e)), u[e];
                };
            },
            {
                "../internals/global": 274,
                "../internals/has-own-property": 275,
                "../internals/shared": 334,
                "../internals/symbol-constructor-detection": 336,
                "../internals/uid": 350,
                "../internals/use-symbol-as-uid": 351
            }
        ],
        358: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/export"), i = e("../internals/array-iteration").findIndex, s = e("../internals/add-to-unscopables"), o = !0;
                "findIndex" in [] && Array(1).findIndex(function() {
                    o = !1;
                }), n({
                    target: "Array",
                    proto: !0,
                    forced: o
                }, {
                    findIndex: function(e) {
                        return i(this, e, arguments.length > 1 ? arguments[1] : void 0);
                    }
                }), s("findIndex");
            },
            {
                "../internals/add-to-unscopables": 225,
                "../internals/array-iteration": 229,
                "../internals/export": 259
            }
        ],
        359: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/export"), i = e("../internals/array-iteration").find, s = e("../internals/add-to-unscopables"), o = !0;
                "find" in [] && Array(1).find(function() {
                    o = !1;
                }), n({
                    target: "Array",
                    proto: !0,
                    forced: o
                }, {
                    find: function(e) {
                        return i(this, e, arguments.length > 1 ? arguments[1] : void 0);
                    }
                }), s("find");
            },
            {
                "../internals/add-to-unscopables": 225,
                "../internals/array-iteration": 229,
                "../internals/export": 259
            }
        ],
        360: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/export"), i = e("../internals/array-includes").includes, s = e("../internals/fails"), o = e("../internals/add-to-unscopables");
                n({
                    target: "Array",
                    proto: !0,
                    forced: s(function() {
                        return !Array(1).includes();
                    })
                }, {
                    includes: function(e) {
                        return i(this, e, arguments.length > 1 ? arguments[1] : void 0);
                    }
                }), o("includes");
            },
            {
                "../internals/add-to-unscopables": 225,
                "../internals/array-includes": 228,
                "../internals/export": 259,
                "../internals/fails": 260
            }
        ],
        361: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/to-indexed-object"), i = e("../internals/add-to-unscopables"), s = e("../internals/iterators"), o = e("../internals/internal-state"), a = e("../internals/object-define-property").f, l = e("../internals/iterator-define"), c = e("../internals/create-iter-result-object"), u = e("../internals/is-pure"), h = e("../internals/descriptors"), f = o.set, d = o.getterFor("Array Iterator");
                t.exports = l(Array, "Array", function(e, t) {
                    f(this, {
                        type: "Array Iterator",
                        target: n(e),
                        index: 0,
                        kind: t
                    });
                }, function() {
                    var e = d(this), t = e.target, r = e.kind, n = e.index++;
                    if (!t || n >= t.length) return e.target = void 0, c(void 0, !0);
                    switch(r){
                        case "keys":
                            return c(n, !1);
                        case "values":
                            return c(t[n], !1);
                    }
                    return c([
                        n,
                        t[n]
                    ], !1);
                }, "values");
                var p = s.Arguments = s.Array;
                if (i("keys"), i("values"), i("entries"), !u && h && "values" !== p.name) try {
                    a(p, "name", {
                        value: "values"
                    });
                } catch (e) {}
            },
            {
                "../internals/add-to-unscopables": 225,
                "../internals/create-iter-result-object": 240,
                "../internals/descriptors": 247,
                "../internals/internal-state": 282,
                "../internals/is-pure": 290,
                "../internals/iterator-define": 296,
                "../internals/iterators": 298,
                "../internals/object-define-property": 308,
                "../internals/to-indexed-object": 341
            }
        ],
        362: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/export"), i = e("../internals/get-built-in"), s = e("../internals/function-apply"), o = e("../internals/function-call"), a = e("../internals/function-uncurry-this"), l = e("../internals/fails"), c = e("../internals/is-callable"), u = e("../internals/is-symbol"), h = e("../internals/array-slice"), f = e("../internals/get-json-replacer-function"), d = e("../internals/symbol-constructor-detection"), p = String, m = i("JSON", "stringify"), b = a(/./.exec), g = a("".charAt), y = a("".charCodeAt), v = a("".replace), w = a(1..toString), _ = /[\uD800-\uDFFF]/g, x = /^[\uD800-\uDBFF]$/, k = /^[\uDC00-\uDFFF]$/, S = !d || l(function() {
                    var e = i("Symbol")("stringify detection");
                    return "[null]" !== m([
                        e
                    ]) || "{}" !== m({
                        a: e
                    }) || "{}" !== m(Object(e));
                }), M = l(function() {
                    return '"\\udf06\\ud834"' !== m("\udf06\ud834") || '"\\udead"' !== m("\udead");
                }), C = function(e, t) {
                    var r = h(arguments), n = f(t);
                    if (c(n) || void 0 !== e && !u(e)) return r[1] = function(e, t) {
                        if (c(n) && (t = o(n, this, p(e), t)), !u(t)) return t;
                    }, s(m, null, r);
                }, T = function(e, t, r) {
                    var n = g(r, t - 1), i = g(r, t + 1);
                    return b(x, e) && !b(k, i) || b(k, e) && !b(x, n) ? "\\u" + w(y(e, 0), 16) : e;
                };
                m && n({
                    target: "JSON",
                    stat: !0,
                    arity: 3,
                    forced: S || M
                }, {
                    stringify: function(e, t, r) {
                        var n = h(arguments), i = s(S ? C : m, null, n);
                        return M && "string" == typeof i ? v(i, _, T) : i;
                    }
                });
            },
            {
                "../internals/array-slice": 231,
                "../internals/export": 259,
                "../internals/fails": 260,
                "../internals/function-apply": 261,
                "../internals/function-call": 264,
                "../internals/function-uncurry-this": 268,
                "../internals/get-built-in": 269,
                "../internals/get-json-replacer-function": 272,
                "../internals/is-callable": 285,
                "../internals/is-symbol": 292,
                "../internals/symbol-constructor-detection": 336
            }
        ],
        363: [
            function(e, t, r) {
                "use strict";
                e("../internals/export")({
                    target: "Number",
                    stat: !0
                }, {
                    isNaN: function(e) {
                        return e != e;
                    }
                });
            },
            {
                "../internals/export": 259
            }
        ],
        364: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/export"), i = e("../internals/object-assign");
                n({
                    target: "Object",
                    stat: !0,
                    arity: 2,
                    forced: Object.assign !== i
                }, {
                    assign: i
                });
            },
            {
                "../internals/export": 259,
                "../internals/object-assign": 305
            }
        ],
        365: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/export"), i = e("../internals/symbol-constructor-detection"), s = e("../internals/fails"), o = e("../internals/object-get-own-property-symbols"), a = e("../internals/to-object");
                n({
                    target: "Object",
                    stat: !0,
                    forced: !i || s(function() {
                        o.f(1);
                    })
                }, {
                    getOwnPropertySymbols: function(e) {
                        var t = o.f;
                        return t ? t(a(e)) : [];
                    }
                });
            },
            {
                "../internals/export": 259,
                "../internals/fails": 260,
                "../internals/object-get-own-property-symbols": 312,
                "../internals/symbol-constructor-detection": 336,
                "../internals/to-object": 344
            }
        ],
        366: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/export"), i = e("../internals/to-object"), s = e("../internals/object-keys");
                n({
                    target: "Object",
                    stat: !0,
                    forced: e("../internals/fails")(function() {
                        s(1);
                    })
                }, {
                    keys: function(e) {
                        return s(i(e));
                    }
                });
            },
            {
                "../internals/export": 259,
                "../internals/fails": 260,
                "../internals/object-keys": 316,
                "../internals/to-object": 344
            }
        ],
        367: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/export"), i = e("../internals/object-to-array").values;
                n({
                    target: "Object",
                    stat: !0
                }, {
                    values: function(e) {
                        return i(e);
                    }
                });
            },
            {
                "../internals/export": 259,
                "../internals/object-to-array": 319
            }
        ],
        368: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/export"), i = e("../internals/function-call"), s = e("../internals/a-callable"), o = e("../internals/new-promise-capability"), a = e("../internals/perform"), l = e("../internals/iterate");
                n({
                    target: "Promise",
                    stat: !0,
                    forced: e("../internals/promise-statics-incorrect-iteration")
                }, {
                    all: function(e) {
                        var t = this, r = o.f(t), n = r.resolve, c = r.reject, u = a(function() {
                            var r = s(t.resolve), o = [], a = 0, u = 1;
                            l(e, function(e) {
                                var s = a++, l = !1;
                                u++, i(r, t, e).then(function(e) {
                                    l || (l = !0, o[s] = e, --u || n(o));
                                }, c);
                            }), --u || n(o);
                        });
                        return u.error && c(u.value), r.promise;
                    }
                });
            },
            {
                "../internals/a-callable": 222,
                "../internals/export": 259,
                "../internals/function-call": 264,
                "../internals/iterate": 293,
                "../internals/new-promise-capability": 303,
                "../internals/perform": 323,
                "../internals/promise-statics-incorrect-iteration": 327
            }
        ],
        369: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/export"), i = e("../internals/is-pure"), s = e("../internals/promise-constructor-detection").CONSTRUCTOR, o = e("../internals/promise-native-constructor"), a = e("../internals/get-built-in"), l = e("../internals/is-callable"), c = e("../internals/define-built-in"), u = o && o.prototype;
                if (n({
                    target: "Promise",
                    proto: !0,
                    forced: s,
                    real: !0
                }, {
                    catch: function(e) {
                        return this.then(void 0, e);
                    }
                }), !i && l(o)) {
                    var h = a("Promise").prototype.catch;
                    u.catch !== h && c(u, "catch", h, {
                        unsafe: !0
                    });
                }
            },
            {
                "../internals/define-built-in": 245,
                "../internals/export": 259,
                "../internals/get-built-in": 269,
                "../internals/is-callable": 285,
                "../internals/is-pure": 290,
                "../internals/promise-constructor-detection": 324,
                "../internals/promise-native-constructor": 325
            }
        ],
        370: [
            function(e, t, r) {
                "use strict";
                var n, i, s, o = e("../internals/export"), a = e("../internals/is-pure"), l = e("../internals/engine-is-node"), c = e("../internals/global"), u = e("../internals/function-call"), h = e("../internals/define-built-in"), f = e("../internals/object-set-prototype-of"), d = e("../internals/set-to-string-tag"), p = e("../internals/set-species"), m = e("../internals/a-callable"), b = e("../internals/is-callable"), g = e("../internals/is-object"), y = e("../internals/an-instance"), v = e("../internals/species-constructor"), w = e("../internals/task").set, _ = e("../internals/microtask"), x = e("../internals/host-report-errors"), k = e("../internals/perform"), S = e("../internals/queue"), M = e("../internals/internal-state"), C = e("../internals/promise-native-constructor"), T = e("../internals/promise-constructor-detection"), E = e("../internals/new-promise-capability"), A = T.CONSTRUCTOR, R = T.REJECTION_EVENT, O = T.SUBCLASSING, j = M.getterFor("Promise"), I = M.set, N = C && C.prototype, P = C, B = N, D = c.TypeError, F = c.document, L = c.process, z = E.f, U = z, $ = !!(F && F.createEvent && c.dispatchEvent), H = function(e) {
                    var t;
                    return !(!g(e) || !b(t = e.then)) && t;
                }, V = function(e, t) {
                    var r, n, i, s = t.value, o = 1 === t.state, a = o ? e.ok : e.fail, l = e.resolve, c = e.reject, h = e.domain;
                    try {
                        a ? (o || (2 === t.rejection && Y(t), t.rejection = 1), !0 === a ? r = s : (h && h.enter(), r = a(s), h && (h.exit(), i = !0)), r === e.promise ? c(new D("Promise-chain cycle")) : (n = H(r)) ? u(n, r, l, c) : l(r)) : c(s);
                    } catch (e) {
                        h && !i && h.exit(), c(e);
                    }
                }, q = function(e, t) {
                    e.notified || (e.notified = !0, _(function() {
                        for(var r, n = e.reactions; r = n.get();)V(r, e);
                        e.notified = !1, t && !e.rejection && X(e);
                    }));
                }, W = function(e, t, r) {
                    var n, i;
                    $ ? ((n = F.createEvent("Event")).promise = t, n.reason = r, n.initEvent(e, !1, !0), c.dispatchEvent(n)) : n = {
                        promise: t,
                        reason: r
                    }, !R && (i = c["on" + e]) ? i(n) : "unhandledrejection" === e && x("Unhandled promise rejection", r);
                }, X = function(e) {
                    u(w, c, function() {
                        var t, r = e.facade, n = e.value;
                        if (K(e) && (t = k(function() {
                            l ? L.emit("unhandledRejection", n, r) : W("unhandledrejection", r, n);
                        }), e.rejection = l || K(e) ? 2 : 1, t.error)) throw t.value;
                    });
                }, K = function(e) {
                    return 1 !== e.rejection && !e.parent;
                }, Y = function(e) {
                    u(w, c, function() {
                        var t = e.facade;
                        l ? L.emit("rejectionHandled", t) : W("rejectionhandled", t, e.value);
                    });
                }, Z = function(e, t, r) {
                    return function(n) {
                        e(t, n, r);
                    };
                }, G = function(e, t, r) {
                    e.done || (e.done = !0, r && (e = r), e.value = t, e.state = 2, q(e, !0));
                }, J = function(e, t, r) {
                    if (!e.done) {
                        e.done = !0, r && (e = r);
                        try {
                            if (e.facade === t) throw new D("Promise can't be resolved itself");
                            var n = H(t);
                            n ? _(function() {
                                var r = {
                                    done: !1
                                };
                                try {
                                    u(n, t, Z(J, r, e), Z(G, r, e));
                                } catch (t) {
                                    G(r, t, e);
                                }
                            }) : (e.value = t, e.state = 1, q(e, !1));
                        } catch (t) {
                            G({
                                done: !1
                            }, t, e);
                        }
                    }
                };
                if (A && (B = (P = function(e) {
                    y(this, B), m(e), u(n, this);
                    var t = j(this);
                    try {
                        e(Z(J, t), Z(G, t));
                    } catch (e) {
                        G(t, e);
                    }
                }).prototype, (n = function(e) {
                    I(this, {
                        type: "Promise",
                        done: !1,
                        notified: !1,
                        parent: !1,
                        reactions: new S,
                        rejection: !1,
                        state: 0,
                        value: void 0
                    });
                }).prototype = h(B, "then", function(e, t) {
                    var r = j(this), n = z(v(this, P));
                    return r.parent = !0, n.ok = !b(e) || e, n.fail = b(t) && t, n.domain = l ? L.domain : void 0, 0 === r.state ? r.reactions.add(n) : _(function() {
                        V(n, r);
                    }), n.promise;
                }), i = function() {
                    var e = new n, t = j(e);
                    this.promise = e, this.resolve = Z(J, t), this.reject = Z(G, t);
                }, E.f = z = function(e) {
                    return e === P || void 0 === e ? new i(e) : U(e);
                }, !a && b(C) && N !== Object.prototype)) {
                    s = N.then, O || h(N, "then", function(e, t) {
                        var r = this;
                        return new P(function(e, t) {
                            u(s, r, e, t);
                        }).then(e, t);
                    }, {
                        unsafe: !0
                    });
                    try {
                        delete N.constructor;
                    } catch (e) {}
                    f && f(N, B);
                }
                o({
                    global: !0,
                    constructor: !0,
                    wrap: !0,
                    forced: A
                }, {
                    Promise: P
                }), d(P, "Promise", !1, !0), p("Promise");
            },
            {
                "../internals/a-callable": 222,
                "../internals/an-instance": 226,
                "../internals/define-built-in": 245,
                "../internals/engine-is-node": 254,
                "../internals/export": 259,
                "../internals/function-call": 264,
                "../internals/global": 274,
                "../internals/host-report-errors": 277,
                "../internals/internal-state": 282,
                "../internals/is-callable": 285,
                "../internals/is-object": 289,
                "../internals/is-pure": 290,
                "../internals/microtask": 302,
                "../internals/new-promise-capability": 303,
                "../internals/object-set-prototype-of": 318,
                "../internals/perform": 323,
                "../internals/promise-constructor-detection": 324,
                "../internals/promise-native-constructor": 325,
                "../internals/queue": 328,
                "../internals/set-species": 330,
                "../internals/set-to-string-tag": 331,
                "../internals/species-constructor": 335,
                "../internals/task": 339
            }
        ],
        371: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/export"), i = e("../internals/is-pure"), s = e("../internals/promise-native-constructor"), o = e("../internals/fails"), a = e("../internals/get-built-in"), l = e("../internals/is-callable"), c = e("../internals/species-constructor"), u = e("../internals/promise-resolve"), h = e("../internals/define-built-in"), f = s && s.prototype;
                if (n({
                    target: "Promise",
                    proto: !0,
                    real: !0,
                    forced: !!s && o(function() {
                        f.finally.call({
                            then: function() {}
                        }, function() {});
                    })
                }, {
                    finally: function(e) {
                        var t = c(this, a("Promise")), r = l(e);
                        return this.then(r ? function(r) {
                            return u(t, e()).then(function() {
                                return r;
                            });
                        } : e, r ? function(r) {
                            return u(t, e()).then(function() {
                                throw r;
                            });
                        } : e);
                    }
                }), !i && l(s)) {
                    var d = a("Promise").prototype.finally;
                    f.finally !== d && h(f, "finally", d, {
                        unsafe: !0
                    });
                }
            },
            {
                "../internals/define-built-in": 245,
                "../internals/export": 259,
                "../internals/fails": 260,
                "../internals/get-built-in": 269,
                "../internals/is-callable": 285,
                "../internals/is-pure": 290,
                "../internals/promise-native-constructor": 325,
                "../internals/promise-resolve": 326,
                "../internals/species-constructor": 335
            }
        ],
        372: [
            function(e, t, r) {
                "use strict";
                e("../modules/es.promise.constructor"), e("../modules/es.promise.all"), e("../modules/es.promise.catch"), e("../modules/es.promise.race"), e("../modules/es.promise.reject"), e("../modules/es.promise.resolve");
            },
            {
                "../modules/es.promise.all": 368,
                "../modules/es.promise.catch": 369,
                "../modules/es.promise.constructor": 370,
                "../modules/es.promise.race": 373,
                "../modules/es.promise.reject": 374,
                "../modules/es.promise.resolve": 375
            }
        ],
        373: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/export"), i = e("../internals/function-call"), s = e("../internals/a-callable"), o = e("../internals/new-promise-capability"), a = e("../internals/perform"), l = e("../internals/iterate");
                n({
                    target: "Promise",
                    stat: !0,
                    forced: e("../internals/promise-statics-incorrect-iteration")
                }, {
                    race: function(e) {
                        var t = this, r = o.f(t), n = r.reject, c = a(function() {
                            var o = s(t.resolve);
                            l(e, function(e) {
                                i(o, t, e).then(r.resolve, n);
                            });
                        });
                        return c.error && n(c.value), r.promise;
                    }
                });
            },
            {
                "../internals/a-callable": 222,
                "../internals/export": 259,
                "../internals/function-call": 264,
                "../internals/iterate": 293,
                "../internals/new-promise-capability": 303,
                "../internals/perform": 323,
                "../internals/promise-statics-incorrect-iteration": 327
            }
        ],
        374: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/export"), i = e("../internals/function-call"), s = e("../internals/new-promise-capability");
                n({
                    target: "Promise",
                    stat: !0,
                    forced: e("../internals/promise-constructor-detection").CONSTRUCTOR
                }, {
                    reject: function(e) {
                        var t = s.f(this);
                        return i(t.reject, void 0, e), t.promise;
                    }
                });
            },
            {
                "../internals/export": 259,
                "../internals/function-call": 264,
                "../internals/new-promise-capability": 303,
                "../internals/promise-constructor-detection": 324
            }
        ],
        375: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/export"), i = e("../internals/get-built-in"), s = e("../internals/is-pure"), o = e("../internals/promise-native-constructor"), a = e("../internals/promise-constructor-detection").CONSTRUCTOR, l = e("../internals/promise-resolve"), c = i("Promise"), u = s && !a;
                n({
                    target: "Promise",
                    stat: !0,
                    forced: s || a
                }, {
                    resolve: function(e) {
                        return l(u && this === c ? o : this, e);
                    }
                });
            },
            {
                "../internals/export": 259,
                "../internals/get-built-in": 269,
                "../internals/is-pure": 290,
                "../internals/promise-constructor-detection": 324,
                "../internals/promise-native-constructor": 325,
                "../internals/promise-resolve": 326
            }
        ],
        376: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/export"), i = e("../internals/function-uncurry-this"), s = e("../internals/to-absolute-index"), o = RangeError, a = String.fromCharCode, l = String.fromCodePoint, c = i([].join);
                n({
                    target: "String",
                    stat: !0,
                    arity: 1,
                    forced: !!l && 1 !== l.length
                }, {
                    fromCodePoint: function(e) {
                        for(var t, r = [], n = arguments.length, i = 0; n > i;){
                            if (t = +arguments[i++], s(t, 1114111) !== t) throw new o(t + " is not a valid code point");
                            r[i] = t < 65536 ? a(t) : a(55296 + ((t -= 65536) >> 10), t % 1024 + 56320);
                        }
                        return c(r, "");
                    }
                });
            },
            {
                "../internals/export": 259,
                "../internals/function-uncurry-this": 268,
                "../internals/to-absolute-index": 340
            }
        ],
        377: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/export"), i = e("../internals/function-uncurry-this"), s = e("../internals/not-a-regexp"), o = e("../internals/require-object-coercible"), a = e("../internals/to-string"), l = e("../internals/correct-is-regexp-logic"), c = i("".indexOf);
                n({
                    target: "String",
                    proto: !0,
                    forced: !l("includes")
                }, {
                    includes: function(e) {
                        return !!~c(a(o(this)), a(s(e)), arguments.length > 1 ? arguments[1] : void 0);
                    }
                });
            },
            {
                "../internals/correct-is-regexp-logic": 238,
                "../internals/export": 259,
                "../internals/function-uncurry-this": 268,
                "../internals/not-a-regexp": 304,
                "../internals/require-object-coercible": 329,
                "../internals/to-string": 348
            }
        ],
        378: [
            function(e, t, r) {
                "use strict";
                e("../internals/well-known-symbol-define")("asyncIterator");
            },
            {
                "../internals/well-known-symbol-define": 355
            }
        ],
        379: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/export"), i = e("../internals/global"), s = e("../internals/function-call"), o = e("../internals/function-uncurry-this"), a = e("../internals/is-pure"), l = e("../internals/descriptors"), c = e("../internals/symbol-constructor-detection"), u = e("../internals/fails"), h = e("../internals/has-own-property"), f = e("../internals/object-is-prototype-of"), d = e("../internals/an-object"), p = e("../internals/to-indexed-object"), m = e("../internals/to-property-key"), b = e("../internals/to-string"), g = e("../internals/create-property-descriptor"), y = e("../internals/object-create"), v = e("../internals/object-keys"), w = e("../internals/object-get-own-property-names"), _ = e("../internals/object-get-own-property-names-external"), x = e("../internals/object-get-own-property-symbols"), k = e("../internals/object-get-own-property-descriptor"), S = e("../internals/object-define-property"), M = e("../internals/object-define-properties"), C = e("../internals/object-property-is-enumerable"), T = e("../internals/define-built-in"), E = e("../internals/define-built-in-accessor"), A = e("../internals/shared"), R = e("../internals/shared-key"), O = e("../internals/hidden-keys"), j = e("../internals/uid"), I = e("../internals/well-known-symbol"), N = e("../internals/well-known-symbol-wrapped"), P = e("../internals/well-known-symbol-define"), B = e("../internals/symbol-define-to-primitive"), D = e("../internals/set-to-string-tag"), F = e("../internals/internal-state"), L = e("../internals/array-iteration").forEach, z = R("hidden"), U = F.set, $ = F.getterFor("Symbol"), H = Object.prototype, V = i.Symbol, q = V && V.prototype, W = i.RangeError, X = i.TypeError, K = i.QObject, Y = k.f, Z = S.f, G = _.f, J = C.f, Q = o([].push), ee = A("symbols"), te = A("op-symbols"), re = A("wks"), ne = !K || !K.prototype || !K.prototype.findChild, ie = function(e, t, r) {
                    var n = Y(H, t);
                    n && delete H[t], Z(e, t, r), n && e !== H && Z(H, t, n);
                }, se = l && u(function() {
                    return 7 !== y(Z({}, "a", {
                        get: function() {
                            return Z(this, "a", {
                                value: 7
                            }).a;
                        }
                    })).a;
                }) ? ie : Z, oe = function(e, t) {
                    var r = ee[e] = y(q);
                    return U(r, {
                        type: "Symbol",
                        tag: e,
                        description: t
                    }), l || (r.description = t), r;
                }, ae = function(e, t, r) {
                    e === H && ae(te, t, r), d(e);
                    var n = m(t);
                    return d(r), h(ee, n) ? (r.enumerable ? (h(e, z) && e[z][n] && (e[z][n] = !1), r = y(r, {
                        enumerable: g(0, !1)
                    })) : (h(e, z) || Z(e, z, g(1, {})), e[z][n] = !0), se(e, n, r)) : Z(e, n, r);
                }, le = function(e, t) {
                    d(e);
                    var r = p(t), n = v(r).concat(fe(r));
                    return L(n, function(t) {
                        l && !s(ce, r, t) || ae(e, t, r[t]);
                    }), e;
                }, ce = function(e) {
                    var t = m(e), r = s(J, this, t);
                    return !(this === H && h(ee, t) && !h(te, t)) && (!(r || !h(this, t) || !h(ee, t) || h(this, z) && this[z][t]) || r);
                }, ue = function(e, t) {
                    var r = p(e), n = m(t);
                    if (r !== H || !h(ee, n) || h(te, n)) {
                        var i = Y(r, n);
                        return !i || !h(ee, n) || h(r, z) && r[z][n] || (i.enumerable = !0), i;
                    }
                }, he = function(e) {
                    var t = G(p(e)), r = [];
                    return L(t, function(e) {
                        h(ee, e) || h(O, e) || Q(r, e);
                    }), r;
                }, fe = function(e) {
                    var t = e === H, r = G(t ? te : p(e)), n = [];
                    return L(r, function(e) {
                        !h(ee, e) || t && !h(H, e) || Q(n, ee[e]);
                    }), n;
                };
                c || (T(q = (V = function() {
                    if (f(q, this)) throw new X("Symbol is not a constructor");
                    var e = arguments.length && void 0 !== arguments[0] ? b(arguments[0]) : void 0, t = j(e), r = function(e) {
                        this === H && s(r, te, e), h(this, z) && h(this[z], t) && (this[z][t] = !1);
                        var n = g(1, e);
                        try {
                            se(this, t, n);
                        } catch (e) {
                            if (!(e instanceof W)) throw e;
                            ie(this, t, n);
                        }
                    };
                    return l && ne && se(H, t, {
                        configurable: !0,
                        set: r
                    }), oe(t, e);
                }).prototype, "toString", function() {
                    return $(this).tag;
                }), T(V, "withoutSetter", function(e) {
                    return oe(j(e), e);
                }), C.f = ce, S.f = ae, M.f = le, k.f = ue, w.f = _.f = he, x.f = fe, N.f = function(e) {
                    return oe(I(e), e);
                }, l && (E(q, "description", {
                    configurable: !0,
                    get: function() {
                        return $(this).description;
                    }
                }), a || T(H, "propertyIsEnumerable", ce, {
                    unsafe: !0
                }))), n({
                    global: !0,
                    constructor: !0,
                    wrap: !0,
                    forced: !c,
                    sham: !c
                }, {
                    Symbol: V
                }), L(v(re), function(e) {
                    P(e);
                }), n({
                    target: "Symbol",
                    stat: !0,
                    forced: !c
                }, {
                    useSetter: function() {
                        ne = !0;
                    },
                    useSimple: function() {
                        ne = !1;
                    }
                }), n({
                    target: "Object",
                    stat: !0,
                    forced: !c,
                    sham: !l
                }, {
                    create: function(e, t) {
                        return void 0 === t ? y(e) : le(y(e), t);
                    },
                    defineProperty: ae,
                    defineProperties: le,
                    getOwnPropertyDescriptor: ue
                }), n({
                    target: "Object",
                    stat: !0,
                    forced: !c
                }, {
                    getOwnPropertyNames: he
                }), B(), D(V, "Symbol"), O[z] = !0;
            },
            {
                "../internals/an-object": 227,
                "../internals/array-iteration": 229,
                "../internals/create-property-descriptor": 242,
                "../internals/define-built-in": 245,
                "../internals/define-built-in-accessor": 244,
                "../internals/descriptors": 247,
                "../internals/export": 259,
                "../internals/fails": 260,
                "../internals/function-call": 264,
                "../internals/function-uncurry-this": 268,
                "../internals/global": 274,
                "../internals/has-own-property": 275,
                "../internals/hidden-keys": 276,
                "../internals/internal-state": 282,
                "../internals/is-pure": 290,
                "../internals/object-create": 306,
                "../internals/object-define-properties": 307,
                "../internals/object-define-property": 308,
                "../internals/object-get-own-property-descriptor": 309,
                "../internals/object-get-own-property-names": 311,
                "../internals/object-get-own-property-names-external": 310,
                "../internals/object-get-own-property-symbols": 312,
                "../internals/object-is-prototype-of": 314,
                "../internals/object-keys": 316,
                "../internals/object-property-is-enumerable": 317,
                "../internals/set-to-string-tag": 331,
                "../internals/shared": 334,
                "../internals/shared-key": 332,
                "../internals/symbol-constructor-detection": 336,
                "../internals/symbol-define-to-primitive": 337,
                "../internals/to-indexed-object": 341,
                "../internals/to-property-key": 346,
                "../internals/to-string": 348,
                "../internals/uid": 350,
                "../internals/well-known-symbol": 357,
                "../internals/well-known-symbol-define": 355,
                "../internals/well-known-symbol-wrapped": 356
            }
        ],
        380: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/export"), i = e("../internals/get-built-in"), s = e("../internals/has-own-property"), o = e("../internals/to-string"), a = e("../internals/shared"), l = e("../internals/symbol-registry-detection"), c = a("string-to-symbol-registry"), u = a("symbol-to-string-registry");
                n({
                    target: "Symbol",
                    stat: !0,
                    forced: !l
                }, {
                    for: function(e) {
                        var t = o(e);
                        if (s(c, t)) return c[t];
                        var r = i("Symbol")(t);
                        return c[t] = r, u[r] = t, r;
                    }
                });
            },
            {
                "../internals/export": 259,
                "../internals/get-built-in": 269,
                "../internals/has-own-property": 275,
                "../internals/shared": 334,
                "../internals/symbol-registry-detection": 338,
                "../internals/to-string": 348
            }
        ],
        381: [
            function(e, t, r) {
                "use strict";
                e("../modules/es.symbol.constructor"), e("../modules/es.symbol.for"), e("../modules/es.symbol.key-for"), e("../modules/es.json.stringify"), e("../modules/es.object.get-own-property-symbols");
            },
            {
                "../modules/es.json.stringify": 362,
                "../modules/es.object.get-own-property-symbols": 365,
                "../modules/es.symbol.constructor": 379,
                "../modules/es.symbol.for": 380,
                "../modules/es.symbol.key-for": 382
            }
        ],
        382: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/export"), i = e("../internals/has-own-property"), s = e("../internals/is-symbol"), o = e("../internals/try-to-string"), a = e("../internals/shared"), l = e("../internals/symbol-registry-detection"), c = a("symbol-to-string-registry");
                n({
                    target: "Symbol",
                    stat: !0,
                    forced: !l
                }, {
                    keyFor: function(e) {
                        if (!s(e)) throw new TypeError(o(e) + " is not a symbol");
                        if (i(c, e)) return c[e];
                    }
                });
            },
            {
                "../internals/export": 259,
                "../internals/has-own-property": 275,
                "../internals/is-symbol": 292,
                "../internals/shared": 334,
                "../internals/symbol-registry-detection": 338,
                "../internals/try-to-string": 349
            }
        ],
        383: [
            function(e, t, r) {
                "use strict";
                function n(e) {
                    return Object.prototype.toString.call(e);
                }
                r.isArray = function(e) {
                    return Array.isArray ? Array.isArray(e) : "[object Array]" === n(e);
                }, r.isBoolean = function(e) {
                    return "boolean" == typeof e;
                }, r.isNull = function(e) {
                    return null === e;
                }, r.isNullOrUndefined = function(e) {
                    return null == e;
                }, r.isNumber = function(e) {
                    return "number" == typeof e;
                }, r.isString = function(e) {
                    return "string" == typeof e;
                }, r.isSymbol = function(e) {
                    return "symbol" == typeof e;
                }, r.isUndefined = function(e) {
                    return void 0 === e;
                }, r.isRegExp = function(e) {
                    return "[object RegExp]" === n(e);
                }, r.isObject = function(e) {
                    return "object" == typeof e && null !== e;
                }, r.isDate = function(e) {
                    return "[object Date]" === n(e);
                }, r.isError = function(e) {
                    return "[object Error]" === n(e) || e instanceof Error;
                }, r.isFunction = function(e) {
                    return "function" == typeof e;
                }, r.isPrimitive = function(e) {
                    return null === e || "boolean" == typeof e || "number" == typeof e || "string" == typeof e || "symbol" == typeof e || void 0 === e;
                }, r.isBuffer = e("buffer").Buffer.isBuffer;
            },
            {
                buffer: 220
            }
        ],
        384: [
            function(e, t, r) {
                (function(r) {
                    (function() {
                        "use strict";
                        var n = e("elliptic"), i = e("bn.js");
                        t.exports = function(e) {
                            return new o(e);
                        };
                        var s = {
                            secp256k1: {
                                name: "secp256k1",
                                byteLength: 32
                            },
                            secp224r1: {
                                name: "p224",
                                byteLength: 28
                            },
                            prime256v1: {
                                name: "p256",
                                byteLength: 32
                            },
                            prime192v1: {
                                name: "p192",
                                byteLength: 24
                            },
                            ed25519: {
                                name: "ed25519",
                                byteLength: 32
                            },
                            secp384r1: {
                                name: "p384",
                                byteLength: 48
                            },
                            secp521r1: {
                                name: "p521",
                                byteLength: 66
                            }
                        };
                        function o(e) {
                            this.curveType = s[e], this.curveType || (this.curveType = {
                                name: e
                            }), this.curve = new n.ec(this.curveType.name), this.keys = void 0;
                        }
                        function a(e, t, n) {
                            Array.isArray(e) || (e = e.toArray());
                            var i = new r(e);
                            if (n && i.length < n) {
                                var s = new r(n - i.length);
                                s.fill(0), i = r.concat([
                                    s,
                                    i
                                ]);
                            }
                            return t ? i.toString(t) : i;
                        }
                        s.p224 = s.secp224r1, s.p256 = s.secp256r1 = s.prime256v1, s.p192 = s.secp192r1 = s.prime192v1, s.p384 = s.secp384r1, s.p521 = s.secp521r1, o.prototype.generateKeys = function(e, t) {
                            return this.keys = this.curve.genKeyPair(), this.getPublicKey(e, t);
                        }, o.prototype.computeSecret = function(e, t, n) {
                            return t = t || "utf8", r.isBuffer(e) || (e = new r(e, t)), a(this.curve.keyFromPublic(e).getPublic().mul(this.keys.getPrivate()).getX(), n, this.curveType.byteLength);
                        }, o.prototype.getPublicKey = function(e, t) {
                            var r = this.keys.getPublic("compressed" === t, !0);
                            return "hybrid" === t && (r[r.length - 1] % 2 ? r[0] = 7 : r[0] = 6), a(r, e);
                        }, o.prototype.getPrivateKey = function(e) {
                            return a(this.keys.getPrivate(), e);
                        }, o.prototype.setPublicKey = function(e, t) {
                            return t = t || "utf8", r.isBuffer(e) || (e = new r(e, t)), this.keys._importPublic(e), this;
                        }, o.prototype.setPrivateKey = function(e, t) {
                            t = t || "utf8", r.isBuffer(e) || (e = new r(e, t));
                            var n = new i(e);
                            return n = n.toString(16), this.keys = this.curve.genKeyPair(), this.keys._importPrivate(n), this;
                        };
                    }).call(this);
                }).call(this, e("buffer").Buffer);
            },
            {
                "bn.js": 385,
                buffer: 220,
                elliptic: 405
            }
        ],
        385: [
            function(e, t, r) {
                arguments[4][184][0].apply(r, arguments);
            },
            {
                buffer: 188,
                dup: 184
            }
        ],
        386: [
            function(e, t, r) {
                "use strict";
                var n = e("inherits"), i = e("md5.js"), s = e("ripemd160"), o = e("sha.js"), a = e("cipher-base");
                function l(e) {
                    a.call(this, "digest"), this._hash = e;
                }
                n(l, a), l.prototype._update = function(e) {
                    this._hash.update(e);
                }, l.prototype._final = function() {
                    return this._hash.digest();
                }, t.exports = function(e) {
                    return "md5" === (e = e.toLowerCase()) ? new i : "rmd160" === e || "ripemd160" === e ? new s : new l(o(e));
                };
            },
            {
                "cipher-base": 221,
                inherits: 440,
                "md5.js": 450,
                ripemd160: 493,
                "sha.js": 498
            }
        ],
        387: [
            function(e, t, r) {
                "use strict";
                var n = e("md5.js");
                t.exports = function(e) {
                    return (new n).update(e).digest();
                };
            },
            {
                "md5.js": 450
            }
        ],
        388: [
            function(e, t, r) {
                "use strict";
                var n = e("inherits"), i = e("./legacy"), s = e("cipher-base"), o = e("safe-buffer").Buffer, a = e("create-hash/md5"), l = e("ripemd160"), c = e("sha.js"), u = o.alloc(128);
                function h(e, t) {
                    s.call(this, "digest"), "string" == typeof t && (t = o.from(t));
                    var r = "sha512" === e || "sha384" === e ? 128 : 64;
                    (this._alg = e, this._key = t, t.length > r) ? t = ("rmd160" === e ? new l : c(e)).update(t).digest() : t.length < r && (t = o.concat([
                        t,
                        u
                    ], r));
                    for(var n = this._ipad = o.allocUnsafe(r), i = this._opad = o.allocUnsafe(r), a = 0; a < r; a++)n[a] = 54 ^ t[a], i[a] = 92 ^ t[a];
                    this._hash = "rmd160" === e ? new l : c(e), this._hash.update(n);
                }
                n(h, s), h.prototype._update = function(e) {
                    this._hash.update(e);
                }, h.prototype._final = function() {
                    var e = this._hash.digest();
                    return ("rmd160" === this._alg ? new l : c(this._alg)).update(this._opad).update(e).digest();
                }, t.exports = function(e, t) {
                    return "rmd160" === (e = e.toLowerCase()) || "ripemd160" === e ? new h("rmd160", t) : "md5" === e ? new i(a, t) : new h(e, t);
                };
            },
            {
                "./legacy": 389,
                "cipher-base": 221,
                "create-hash/md5": 387,
                inherits: 440,
                ripemd160: 493,
                "safe-buffer": 494,
                "sha.js": 498
            }
        ],
        389: [
            function(e, t, r) {
                "use strict";
                var n = e("inherits"), i = e("safe-buffer").Buffer, s = e("cipher-base"), o = i.alloc(128);
                function a(e, t) {
                    s.call(this, "digest"), "string" == typeof t && (t = i.from(t)), this._alg = e, this._key = t, t.length > 64 ? t = e(t) : t.length < 64 && (t = i.concat([
                        t,
                        o
                    ], 64));
                    for(var r = this._ipad = i.allocUnsafe(64), n = this._opad = i.allocUnsafe(64), a = 0; a < 64; a++)r[a] = 54 ^ t[a], n[a] = 92 ^ t[a];
                    this._hash = [
                        r
                    ];
                }
                n(a, s), a.prototype._update = function(e) {
                    this._hash.push(e);
                }, a.prototype._final = function() {
                    var e = this._alg(i.concat(this._hash));
                    return this._alg(i.concat([
                        this._opad,
                        e
                    ]));
                }, t.exports = a;
            },
            {
                "cipher-base": 221,
                inherits: 440,
                "safe-buffer": 494
            }
        ],
        390: [
            function(e, t, r) {
                "use strict";
                r.randomBytes = r.rng = r.pseudoRandomBytes = r.prng = e("randombytes"), r.createHash = r.Hash = e("create-hash"), r.createHmac = r.Hmac = e("create-hmac");
                var n = e("browserify-sign/algos"), i = Object.keys(n), s = [
                    "sha1",
                    "sha224",
                    "sha256",
                    "sha384",
                    "sha512",
                    "md5",
                    "rmd160"
                ].concat(i);
                r.getHashes = function() {
                    return s;
                };
                var o = e("pbkdf2");
                r.pbkdf2 = o.pbkdf2, r.pbkdf2Sync = o.pbkdf2Sync;
                var a = e("browserify-cipher");
                r.Cipher = a.Cipher, r.createCipher = a.createCipher, r.Cipheriv = a.Cipheriv, r.createCipheriv = a.createCipheriv, r.Decipher = a.Decipher, r.createDecipher = a.createDecipher, r.Decipheriv = a.Decipheriv, r.createDecipheriv = a.createDecipheriv, r.getCiphers = a.getCiphers, r.listCiphers = a.listCiphers;
                var l = e("diffie-hellman");
                r.DiffieHellmanGroup = l.DiffieHellmanGroup, r.createDiffieHellmanGroup = l.createDiffieHellmanGroup, r.getDiffieHellman = l.getDiffieHellman, r.createDiffieHellman = l.createDiffieHellman, r.DiffieHellman = l.DiffieHellman;
                var c = e("browserify-sign");
                r.createSign = c.createSign, r.Sign = c.Sign, r.createVerify = c.createVerify, r.Verify = c.Verify, r.createECDH = e("create-ecdh");
                var u = e("public-encrypt");
                r.publicEncrypt = u.publicEncrypt, r.privateEncrypt = u.privateEncrypt, r.publicDecrypt = u.publicDecrypt, r.privateDecrypt = u.privateDecrypt;
                var h = e("randomfill");
                r.randomFill = h.randomFill, r.randomFillSync = h.randomFillSync, r.createCredentials = function() {
                    throw new Error([
                        "sorry, createCredentials is not implemented yet",
                        "we accept pull requests",
                        "https://github.com/crypto-browserify/crypto-browserify"
                    ].join("\n"));
                }, r.constants = {
                    DH_CHECK_P_NOT_SAFE_PRIME: 2,
                    DH_CHECK_P_NOT_PRIME: 1,
                    DH_UNABLE_TO_CHECK_GENERATOR: 4,
                    DH_NOT_SUITABLE_GENERATOR: 8,
                    NPN_ENABLED: 1,
                    ALPN_ENABLED: 1,
                    RSA_PKCS1_PADDING: 1,
                    RSA_SSLV23_PADDING: 2,
                    RSA_NO_PADDING: 3,
                    RSA_PKCS1_OAEP_PADDING: 4,
                    RSA_X931_PADDING: 5,
                    RSA_PKCS1_PSS_PADDING: 6,
                    POINT_CONVERSION_COMPRESSED: 2,
                    POINT_CONVERSION_UNCOMPRESSED: 4,
                    POINT_CONVERSION_HYBRID: 6
                };
            },
            {
                "browserify-cipher": 206,
                "browserify-sign": 213,
                "browserify-sign/algos": 210,
                "create-ecdh": 384,
                "create-hash": 386,
                "create-hmac": 388,
                "diffie-hellman": 400,
                pbkdf2: 460,
                "public-encrypt": 468,
                randombytes: 475,
                randomfill: 476
            }
        ],
        391: [
            function(e, t, r) {
                "use strict";
                !function(e, n) {
                    "object" == typeof r && void 0 !== t ? t.exports = n() : (e = "undefined" != typeof globalThis ? globalThis : e || self).dayjs = n();
                }(void 0, function() {
                    var e = 6e4, t = 36e5, r = "millisecond", n = "second", i = "minute", s = "hour", o = "day", a = "week", l = "month", c = "quarter", u = "year", h = "date", f = "Invalid Date", d = /^(\d{4})[-/]?(\d{1,2})?[-/]?(\d{0,2})[Tt\s]*(\d{1,2})?:?(\d{1,2})?:?(\d{1,2})?[.:]?(\d+)?$/, p = /\[([^\]]+)]|Y{1,4}|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g, m = {
                        name: "en",
                        weekdays: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"),
                        months: "January_February_March_April_May_June_July_August_September_October_November_December".split("_"),
                        ordinal: function(e) {
                            var t = [
                                "th",
                                "st",
                                "nd",
                                "rd"
                            ], r = e % 100;
                            return "[" + e + (t[(r - 20) % 10] || t[r] || t[0]) + "]";
                        }
                    }, b = function(e, t, r) {
                        var n = String(e);
                        return !n || n.length >= t ? e : "" + Array(t + 1 - n.length).join(r) + e;
                    }, g = {
                        s: b,
                        z: function(e) {
                            var t = -e.utcOffset(), r = Math.abs(t), n = Math.floor(r / 60), i = r % 60;
                            return (t <= 0 ? "+" : "-") + b(n, 2, "0") + ":" + b(i, 2, "0");
                        },
                        m: function e(t, r) {
                            if (t.date() < r.date()) return -e(r, t);
                            var n = 12 * (r.year() - t.year()) + (r.month() - t.month()), i = t.clone().add(n, l), s = r - i < 0, o = t.clone().add(n + (s ? -1 : 1), l);
                            return +(-(n + (r - i) / (s ? i - o : o - i)) || 0);
                        },
                        a: function(e) {
                            return e < 0 ? Math.ceil(e) || 0 : Math.floor(e);
                        },
                        p: function(e) {
                            return ({
                                M: l,
                                y: u,
                                w: a,
                                d: o,
                                D: h,
                                h: s,
                                m: i,
                                s: n,
                                ms: r,
                                Q: c
                            })[e] || String(e || "").toLowerCase().replace(/s$/, "");
                        },
                        u: function(e) {
                            return void 0 === e;
                        }
                    }, y = "en", v = {};
                    v[y] = m;
                    var w = "$isDayjsObject", _ = function(e) {
                        return e instanceof M || !(!e || !e[w]);
                    }, x = function e(t, r, n) {
                        var i;
                        if (!t) return y;
                        if ("string" == typeof t) {
                            var s = t.toLowerCase();
                            v[s] && (i = s), r && (v[s] = r, i = s);
                            var o = t.split("-");
                            if (!i && o.length > 1) return e(o[0]);
                        } else {
                            var a = t.name;
                            v[a] = t, i = a;
                        }
                        return !n && i && (y = i), i || !n && y;
                    }, k = function(e, t) {
                        if (_(e)) return e.clone();
                        var r = "object" == typeof t ? t : {};
                        return r.date = e, r.args = arguments, new M(r);
                    }, S = g;
                    S.l = x, S.i = _, S.w = function(e, t) {
                        return k(e, {
                            locale: t.$L,
                            utc: t.$u,
                            x: t.$x,
                            $offset: t.$offset
                        });
                    };
                    var M = function() {
                        function m(e) {
                            this.$L = x(e.locale, null, !0), this.parse(e), this.$x = this.$x || e.x || {}, this[w] = !0;
                        }
                        var b = m.prototype;
                        return b.parse = function(e) {
                            this.$d = function(e) {
                                var t = e.date, r = e.utc;
                                if (null === t) return new Date(NaN);
                                if (S.u(t)) return new Date;
                                if (t instanceof Date) return new Date(t);
                                if ("string" == typeof t && !/Z$/i.test(t)) {
                                    var n = t.match(d);
                                    if (n) {
                                        var i = n[2] - 1 || 0, s = (n[7] || "0").substring(0, 3);
                                        return r ? new Date(Date.UTC(n[1], i, n[3] || 1, n[4] || 0, n[5] || 0, n[6] || 0, s)) : new Date(n[1], i, n[3] || 1, n[4] || 0, n[5] || 0, n[6] || 0, s);
                                    }
                                }
                                return new Date(t);
                            }(e), this.init();
                        }, b.init = function() {
                            var e = this.$d;
                            this.$y = e.getFullYear(), this.$M = e.getMonth(), this.$D = e.getDate(), this.$W = e.getDay(), this.$H = e.getHours(), this.$m = e.getMinutes(), this.$s = e.getSeconds(), this.$ms = e.getMilliseconds();
                        }, b.$utils = function() {
                            return S;
                        }, b.isValid = function() {
                            return !(this.$d.toString() === f);
                        }, b.isSame = function(e, t) {
                            var r = k(e);
                            return this.startOf(t) <= r && r <= this.endOf(t);
                        }, b.isAfter = function(e, t) {
                            return k(e) < this.startOf(t);
                        }, b.isBefore = function(e, t) {
                            return this.endOf(t) < k(e);
                        }, b.$g = function(e, t, r) {
                            return S.u(e) ? this[t] : this.set(r, e);
                        }, b.unix = function() {
                            return Math.floor(this.valueOf() / 1e3);
                        }, b.valueOf = function() {
                            return this.$d.getTime();
                        }, b.startOf = function(e, t) {
                            var r = this, c = !!S.u(t) || t, f = S.p(e), d = function(e, t) {
                                var n = S.w(r.$u ? Date.UTC(r.$y, t, e) : new Date(r.$y, t, e), r);
                                return c ? n : n.endOf(o);
                            }, p = function(e, t) {
                                return S.w(r.toDate()[e].apply(r.toDate("s"), (c ? [
                                    0,
                                    0,
                                    0,
                                    0
                                ] : [
                                    23,
                                    59,
                                    59,
                                    999
                                ]).slice(t)), r);
                            }, m = this.$W, b = this.$M, g = this.$D, y = "set" + (this.$u ? "UTC" : "");
                            switch(f){
                                case u:
                                    return c ? d(1, 0) : d(31, 11);
                                case l:
                                    return c ? d(1, b) : d(0, b + 1);
                                case a:
                                    var v = this.$locale().weekStart || 0, w = (m < v ? m + 7 : m) - v;
                                    return d(c ? g - w : g + (6 - w), b);
                                case o:
                                case h:
                                    return p(y + "Hours", 0);
                                case s:
                                    return p(y + "Minutes", 1);
                                case i:
                                    return p(y + "Seconds", 2);
                                case n:
                                    return p(y + "Milliseconds", 3);
                                default:
                                    return this.clone();
                            }
                        }, b.endOf = function(e) {
                            return this.startOf(e, !1);
                        }, b.$set = function(e, t) {
                            var a, c = S.p(e), f = "set" + (this.$u ? "UTC" : ""), d = (a = {}, a[o] = f + "Date", a[h] = f + "Date", a[l] = f + "Month", a[u] = f + "FullYear", a[s] = f + "Hours", a[i] = f + "Minutes", a[n] = f + "Seconds", a[r] = f + "Milliseconds", a)[c], p = c === o ? this.$D + (t - this.$W) : t;
                            if (c === l || c === u) {
                                var m = this.clone().set(h, 1);
                                m.$d[d](p), m.init(), this.$d = m.set(h, Math.min(this.$D, m.daysInMonth())).$d;
                            } else d && this.$d[d](p);
                            return this.init(), this;
                        }, b.set = function(e, t) {
                            return this.clone().$set(e, t);
                        }, b.get = function(e) {
                            return this[S.p(e)]();
                        }, b.add = function(r, c) {
                            var h, f = this;
                            r = Number(r);
                            var d = S.p(c), p = function(e) {
                                var t = k(f);
                                return S.w(t.date(t.date() + Math.round(e * r)), f);
                            };
                            if (d === l) return this.set(l, this.$M + r);
                            if (d === u) return this.set(u, this.$y + r);
                            if (d === o) return p(1);
                            if (d === a) return p(7);
                            var m = (h = {}, h[i] = e, h[s] = t, h[n] = 1e3, h)[d] || 1, b = this.$d.getTime() + r * m;
                            return S.w(b, this);
                        }, b.subtract = function(e, t) {
                            return this.add(-1 * e, t);
                        }, b.format = function(e) {
                            var t = this, r = this.$locale();
                            if (!this.isValid()) return r.invalidDate || f;
                            var n = e || "YYYY-MM-DDTHH:mm:ssZ", i = S.z(this), s = this.$H, o = this.$m, a = this.$M, l = r.weekdays, c = r.months, u = r.meridiem, h = function(e, r, i, s) {
                                return e && (e[r] || e(t, n)) || i[r].slice(0, s);
                            }, d = function(e) {
                                return S.s(s % 12 || 12, e, "0");
                            }, m = u || function(e, t, r) {
                                var n = e < 12 ? "AM" : "PM";
                                return r ? n.toLowerCase() : n;
                            };
                            return n.replace(p, function(e, n) {
                                return n || function(e) {
                                    switch(e){
                                        case "YY":
                                            return String(t.$y).slice(-2);
                                        case "YYYY":
                                            return S.s(t.$y, 4, "0");
                                        case "M":
                                            return a + 1;
                                        case "MM":
                                            return S.s(a + 1, 2, "0");
                                        case "MMM":
                                            return h(r.monthsShort, a, c, 3);
                                        case "MMMM":
                                            return h(c, a);
                                        case "D":
                                            return t.$D;
                                        case "DD":
                                            return S.s(t.$D, 2, "0");
                                        case "d":
                                            return String(t.$W);
                                        case "dd":
                                            return h(r.weekdaysMin, t.$W, l, 2);
                                        case "ddd":
                                            return h(r.weekdaysShort, t.$W, l, 3);
                                        case "dddd":
                                            return l[t.$W];
                                        case "H":
                                            return String(s);
                                        case "HH":
                                            return S.s(s, 2, "0");
                                        case "h":
                                            return d(1);
                                        case "hh":
                                            return d(2);
                                        case "a":
                                            return m(s, o, !0);
                                        case "A":
                                            return m(s, o, !1);
                                        case "m":
                                            return String(o);
                                        case "mm":
                                            return S.s(o, 2, "0");
                                        case "s":
                                            return String(t.$s);
                                        case "ss":
                                            return S.s(t.$s, 2, "0");
                                        case "SSS":
                                            return S.s(t.$ms, 3, "0");
                                        case "Z":
                                            return i;
                                    }
                                    return null;
                                }(e) || i.replace(":", "");
                            });
                        }, b.utcOffset = function() {
                            return 15 * -Math.round(this.$d.getTimezoneOffset() / 15);
                        }, b.diff = function(r, h, f) {
                            var d, p = this, m = S.p(h), b = k(r), g = (b.utcOffset() - this.utcOffset()) * e, y = this - b, v = function() {
                                return S.m(p, b);
                            };
                            switch(m){
                                case u:
                                    d = v() / 12;
                                    break;
                                case l:
                                    d = v();
                                    break;
                                case c:
                                    d = v() / 3;
                                    break;
                                case a:
                                    d = (y - g) / 6048e5;
                                    break;
                                case o:
                                    d = (y - g) / 864e5;
                                    break;
                                case s:
                                    d = y / t;
                                    break;
                                case i:
                                    d = y / e;
                                    break;
                                case n:
                                    d = y / 1e3;
                                    break;
                                default:
                                    d = y;
                            }
                            return f ? d : S.a(d);
                        }, b.daysInMonth = function() {
                            return this.endOf(l).$D;
                        }, b.$locale = function() {
                            return v[this.$L];
                        }, b.locale = function(e, t) {
                            if (!e) return this.$L;
                            var r = this.clone(), n = x(e, t, !0);
                            return n && (r.$L = n), r;
                        }, b.clone = function() {
                            return S.w(this.$d, this);
                        }, b.toDate = function() {
                            return new Date(this.valueOf());
                        }, b.toJSON = function() {
                            return this.isValid() ? this.toISOString() : null;
                        }, b.toISOString = function() {
                            return this.$d.toISOString();
                        }, b.toString = function() {
                            return this.$d.toUTCString();
                        }, m;
                    }(), C = M.prototype;
                    return k.prototype = C, [
                        [
                            "$ms",
                            r
                        ],
                        [
                            "$s",
                            n
                        ],
                        [
                            "$m",
                            i
                        ],
                        [
                            "$H",
                            s
                        ],
                        [
                            "$W",
                            o
                        ],
                        [
                            "$M",
                            l
                        ],
                        [
                            "$y",
                            u
                        ],
                        [
                            "$D",
                            h
                        ]
                    ].forEach(function(e) {
                        C[e[1]] = function(t) {
                            return this.$g(t, e[0], e[1]);
                        };
                    }), k.extend = function(e, t) {
                        return e.$i || (e(t, M, k), e.$i = !0), k;
                    }, k.locale = x, k.isDayjs = _, k.unix = function(e) {
                        return k(1e3 * e);
                    }, k.en = v[y], k.Ls = v, k.p = {}, k;
                });
            },
            {}
        ],
        392: [
            function(e, t, r) {
                "use strict";
                !function(e, n) {
                    "object" == typeof r && void 0 !== t ? t.exports = n() : (e = "undefined" != typeof globalThis ? globalThis : e || self).dayjs_plugin_customParseFormat = n();
                }(void 0, function() {
                    var e = {
                        LTS: "h:mm:ss A",
                        LT: "h:mm A",
                        L: "MM/DD/YYYY",
                        LL: "MMMM D, YYYY",
                        LLL: "MMMM D, YYYY h:mm A",
                        LLLL: "dddd, MMMM D, YYYY h:mm A"
                    }, t = /(\[[^[]*\])|([-_:/.,()\s]+)|(A|a|YYYY|YY?|MM?M?M?|Do|DD?|hh?|HH?|mm?|ss?|S{1,3}|z|ZZ?)/g, r = /\d\d/, n = /\d\d?/, i = /\d*[^-_:/,()\s\d]+/, s = {}, o = function(e) {
                        return (e = +e) + (e > 68 ? 1900 : 2e3);
                    }, a = function(e) {
                        return function(t) {
                            this[e] = +t;
                        };
                    }, l = [
                        /[+-]\d\d:?(\d\d)?|Z/,
                        function(e) {
                            (this.zone || (this.zone = {})).offset = function(e) {
                                if (!e) return 0;
                                if ("Z" === e) return 0;
                                var t = e.match(/([+-]|\d\d)/g), r = 60 * t[1] + (+t[2] || 0);
                                return 0 === r ? 0 : "+" === t[0] ? -r : r;
                            }(e);
                        }
                    ], c = function(e) {
                        var t = s[e];
                        return t && (t.indexOf ? t : t.s.concat(t.f));
                    }, u = function(e, t) {
                        var r, n = s.meridiem;
                        if (n) {
                            for(var i = 1; i <= 24; i += 1)if (e.indexOf(n(i, 0, t)) > -1) {
                                r = i > 12;
                                break;
                            }
                        } else r = e === (t ? "pm" : "PM");
                        return r;
                    }, h = {
                        A: [
                            i,
                            function(e) {
                                this.afternoon = u(e, !1);
                            }
                        ],
                        a: [
                            i,
                            function(e) {
                                this.afternoon = u(e, !0);
                            }
                        ],
                        S: [
                            /\d/,
                            function(e) {
                                this.milliseconds = 100 * +e;
                            }
                        ],
                        SS: [
                            r,
                            function(e) {
                                this.milliseconds = 10 * +e;
                            }
                        ],
                        SSS: [
                            /\d{3}/,
                            function(e) {
                                this.milliseconds = +e;
                            }
                        ],
                        s: [
                            n,
                            a("seconds")
                        ],
                        ss: [
                            n,
                            a("seconds")
                        ],
                        m: [
                            n,
                            a("minutes")
                        ],
                        mm: [
                            n,
                            a("minutes")
                        ],
                        H: [
                            n,
                            a("hours")
                        ],
                        h: [
                            n,
                            a("hours")
                        ],
                        HH: [
                            n,
                            a("hours")
                        ],
                        hh: [
                            n,
                            a("hours")
                        ],
                        D: [
                            n,
                            a("day")
                        ],
                        DD: [
                            r,
                            a("day")
                        ],
                        Do: [
                            i,
                            function(e) {
                                var t = s.ordinal, r = e.match(/\d+/);
                                if (this.day = r[0], t) for(var n = 1; n <= 31; n += 1)t(n).replace(/\[|\]/g, "") === e && (this.day = n);
                            }
                        ],
                        M: [
                            n,
                            a("month")
                        ],
                        MM: [
                            r,
                            a("month")
                        ],
                        MMM: [
                            i,
                            function(e) {
                                var t = c("months"), r = (c("monthsShort") || t.map(function(e) {
                                    return e.slice(0, 3);
                                })).indexOf(e) + 1;
                                if (r < 1) throw new Error;
                                this.month = r % 12 || r;
                            }
                        ],
                        MMMM: [
                            i,
                            function(e) {
                                var t = c("months").indexOf(e) + 1;
                                if (t < 1) throw new Error;
                                this.month = t % 12 || t;
                            }
                        ],
                        Y: [
                            /[+-]?\d+/,
                            a("year")
                        ],
                        YY: [
                            r,
                            function(e) {
                                this.year = o(e);
                            }
                        ],
                        YYYY: [
                            /\d{4}/,
                            a("year")
                        ],
                        Z: l,
                        ZZ: l
                    };
                    function f(r) {
                        var n, i;
                        n = r, i = s && s.formats;
                        for(var o = (r = n.replace(/(\[[^\]]+])|(LTS?|l{1,4}|L{1,4})/g, function(t, r, n) {
                            var s = n && n.toUpperCase();
                            return r || i[n] || e[n] || i[s].replace(/(\[[^\]]+])|(MMMM|MM|DD|dddd)/g, function(e, t, r) {
                                return t || r.slice(1);
                            });
                        })).match(t), a = o.length, l = 0; l < a; l += 1){
                            var c = o[l], u = h[c], f = u && u[0], d = u && u[1];
                            o[l] = d ? {
                                regex: f,
                                parser: d
                            } : c.replace(/^\[|\]$/g, "");
                        }
                        return function(e) {
                            for(var t = {}, r = 0, n = 0; r < a; r += 1){
                                var i = o[r];
                                if ("string" == typeof i) n += i.length;
                                else {
                                    var s = i.regex, l = i.parser, c = e.slice(n), u = s.exec(c)[0];
                                    l.call(t, u), e = e.replace(u, "");
                                }
                            }
                            return function(e) {
                                var t = e.afternoon;
                                if (void 0 !== t) {
                                    var r = e.hours;
                                    t ? r < 12 && (e.hours += 12) : 12 === r && (e.hours = 0), delete e.afternoon;
                                }
                            }(t), t;
                        };
                    }
                    return function(e, t, r) {
                        r.p.customParseFormat = !0, e && e.parseTwoDigitYear && (o = e.parseTwoDigitYear);
                        var n = t.prototype, i = n.parse;
                        n.parse = function(e) {
                            var t = e.date, n = e.utc, o = e.args;
                            this.$u = n;
                            var a = o[1];
                            if ("string" == typeof a) {
                                var l = !0 === o[2], c = !0 === o[3], u = l || c, h = o[2];
                                c && (h = o[2]), s = this.$locale(), !l && h && (s = r.Ls[h]), this.$d = function(e, t, r) {
                                    try {
                                        if ([
                                            "x",
                                            "X"
                                        ].indexOf(t) > -1) return new Date(("X" === t ? 1e3 : 1) * e);
                                        var n = f(t)(e), i = n.year, s = n.month, o = n.day, a = n.hours, l = n.minutes, c = n.seconds, u = n.milliseconds, h = n.zone, d = new Date, p = o || (i || s ? 1 : d.getDate()), m = i || d.getFullYear(), b = 0;
                                        i && !s || (b = s > 0 ? s - 1 : d.getMonth());
                                        var g = a || 0, y = l || 0, v = c || 0, w = u || 0;
                                        return h ? new Date(Date.UTC(m, b, p, g, y, v, w + 60 * h.offset * 1e3)) : r ? new Date(Date.UTC(m, b, p, g, y, v, w)) : new Date(m, b, p, g, y, v, w);
                                    } catch (e) {
                                        return new Date("");
                                    }
                                }(t, a, n), this.init(), h && !0 !== h && (this.$L = this.locale(h).$L), u && t != this.format(a) && (this.$d = new Date("")), s = {};
                            } else if (a instanceof Array) for(var d = a.length, p = 1; p <= d; p += 1){
                                o[1] = a[p - 1];
                                var m = r.apply(this, o);
                                if (m.isValid()) {
                                    this.$d = m.$d, this.$L = m.$L, this.init();
                                    break;
                                }
                                p === d && (this.$d = new Date(""));
                            }
                            else i.call(this, e);
                        };
                    };
                });
            },
            {}
        ],
        393: [
            function(e, t, r) {
                "use strict";
                !function(e, n) {
                    "object" == typeof r && void 0 !== t ? t.exports = n() : (e = "undefined" != typeof globalThis ? globalThis : e || self).dayjs_plugin_utc = n();
                }(void 0, function() {
                    var e = "minute", t = /[+-]\d\d(?::?\d\d)?/g, r = /([+-]|\d\d)/g;
                    return function(n, i, s) {
                        var o = i.prototype;
                        s.utc = function(e) {
                            var t = {
                                date: e,
                                utc: !0,
                                args: arguments
                            };
                            return new i(t);
                        }, o.utc = function(t) {
                            var r = s(this.toDate(), {
                                locale: this.$L,
                                utc: !0
                            });
                            return t ? r.add(this.utcOffset(), e) : r;
                        }, o.local = function() {
                            return s(this.toDate(), {
                                locale: this.$L,
                                utc: !1
                            });
                        };
                        var a = o.parse;
                        o.parse = function(e) {
                            e.utc && (this.$u = !0), this.$utils().u(e.$offset) || (this.$offset = e.$offset), a.call(this, e);
                        };
                        var l = o.init;
                        o.init = function() {
                            if (this.$u) {
                                var e = this.$d;
                                this.$y = e.getUTCFullYear(), this.$M = e.getUTCMonth(), this.$D = e.getUTCDate(), this.$W = e.getUTCDay(), this.$H = e.getUTCHours(), this.$m = e.getUTCMinutes(), this.$s = e.getUTCSeconds(), this.$ms = e.getUTCMilliseconds();
                            } else l.call(this);
                        };
                        var c = o.utcOffset;
                        o.utcOffset = function(n, i) {
                            var s = this.$utils().u;
                            if (s(n)) return this.$u ? 0 : s(this.$offset) ? c.call(this) : this.$offset;
                            if ("string" == typeof n && null === (n = function(e) {
                                void 0 === e && (e = "");
                                var n = e.match(t);
                                if (!n) return null;
                                var i = ("" + n[0]).match(r) || [
                                    "-",
                                    0,
                                    0
                                ], s = i[0], o = 60 * +i[1] + +i[2];
                                return 0 === o ? 0 : "+" === s ? o : -o;
                            }(n))) return this;
                            var o = Math.abs(n) <= 16 ? 60 * n : n, a = this;
                            if (i) return a.$offset = o, a.$u = 0 === n, a;
                            if (0 !== n) {
                                var l = this.$u ? this.toDate().getTimezoneOffset() : -1 * this.utcOffset();
                                (a = this.local().add(o + l, e)).$offset = o, a.$x.$localOffset = l;
                            } else a = this.utc();
                            return a;
                        };
                        var u = o.format;
                        o.format = function(e) {
                            var t = e || (this.$u ? "YYYY-MM-DDTHH:mm:ss[Z]" : "");
                            return u.call(this, t);
                        }, o.valueOf = function() {
                            var e = this.$utils().u(this.$offset) ? 0 : this.$offset + (this.$x.$localOffset || this.$d.getTimezoneOffset());
                            return this.$d.valueOf() - 6e4 * e;
                        }, o.isUTC = function() {
                            return !!this.$u;
                        }, o.toISOString = function() {
                            return this.toDate().toISOString();
                        }, o.toString = function() {
                            return this.toDate().toUTCString();
                        };
                        var h = o.toDate;
                        o.toDate = function(e) {
                            return "s" === e && this.$offset ? s(this.format("YYYY-MM-DD HH:mm:ss:SSS")).toDate() : h.call(this);
                        };
                        var f = o.diff;
                        o.diff = function(e, t, r) {
                            if (e && this.$u === e.$u) return f.call(this, e, t, r);
                            var n = this.local(), i = s(e).local();
                            return f.call(n, i, t, r);
                        };
                    };
                });
            },
            {}
        ],
        394: [
            function(e, t, r) {
                "use strict";
                r.utils = e("./des/utils"), r.Cipher = e("./des/cipher"), r.DES = e("./des/des"), r.CBC = e("./des/cbc"), r.EDE = e("./des/ede");
            },
            {
                "./des/cbc": 395,
                "./des/cipher": 396,
                "./des/des": 397,
                "./des/ede": 398,
                "./des/utils": 399
            }
        ],
        395: [
            function(e, t, r) {
                "use strict";
                var n = e("minimalistic-assert"), i = e("inherits"), s = {};
                function o(e) {
                    n.equal(e.length, 8, "Invalid IV length"), this.iv = new Array(8);
                    for(var t = 0; t < this.iv.length; t++)this.iv[t] = e[t];
                }
                r.instantiate = function(e) {
                    function t(t) {
                        e.call(this, t), this._cbcInit();
                    }
                    i(t, e);
                    for(var r = Object.keys(s), n = 0; n < r.length; n++){
                        var o = r[n];
                        t.prototype[o] = s[o];
                    }
                    return t.create = function(e) {
                        return new t(e);
                    }, t;
                }, s._cbcInit = function() {
                    var e = new o(this.options.iv);
                    this._cbcState = e;
                }, s._update = function(e, t, r, n) {
                    var i = this._cbcState, s = this.constructor.super_.prototype, o = i.iv;
                    if ("encrypt" === this.type) {
                        for(var a = 0; a < this.blockSize; a++)o[a] ^= e[t + a];
                        s._update.call(this, o, 0, r, n);
                        for(a = 0; a < this.blockSize; a++)o[a] = r[n + a];
                    } else {
                        s._update.call(this, e, t, r, n);
                        for(a = 0; a < this.blockSize; a++)r[n + a] ^= o[a];
                        for(a = 0; a < this.blockSize; a++)o[a] = e[t + a];
                    }
                };
            },
            {
                inherits: 440,
                "minimalistic-assert": 453
            }
        ],
        396: [
            function(e, t, r) {
                "use strict";
                var n = e("minimalistic-assert");
                function i(e) {
                    this.options = e, this.type = this.options.type, this.blockSize = 8, this._init(), this.buffer = new Array(this.blockSize), this.bufferOff = 0, this.padding = !1 !== e.padding;
                }
                t.exports = i, i.prototype._init = function() {}, i.prototype.update = function(e) {
                    return 0 === e.length ? [] : "decrypt" === this.type ? this._updateDecrypt(e) : this._updateEncrypt(e);
                }, i.prototype._buffer = function(e, t) {
                    for(var r = Math.min(this.buffer.length - this.bufferOff, e.length - t), n = 0; n < r; n++)this.buffer[this.bufferOff + n] = e[t + n];
                    return this.bufferOff += r, r;
                }, i.prototype._flushBuffer = function(e, t) {
                    return this._update(this.buffer, 0, e, t), this.bufferOff = 0, this.blockSize;
                }, i.prototype._updateEncrypt = function(e) {
                    var t = 0, r = 0, n = (this.bufferOff + e.length) / this.blockSize | 0, i = new Array(n * this.blockSize);
                    0 !== this.bufferOff && (t += this._buffer(e, t), this.bufferOff === this.buffer.length && (r += this._flushBuffer(i, r)));
                    for(var s = e.length - (e.length - t) % this.blockSize; t < s; t += this.blockSize)this._update(e, t, i, r), r += this.blockSize;
                    for(; t < e.length; t++, this.bufferOff++)this.buffer[this.bufferOff] = e[t];
                    return i;
                }, i.prototype._updateDecrypt = function(e) {
                    for(var t = 0, r = 0, n = Math.ceil((this.bufferOff + e.length) / this.blockSize) - 1, i = new Array(n * this.blockSize); n > 0; n--)t += this._buffer(e, t), r += this._flushBuffer(i, r);
                    return t += this._buffer(e, t), i;
                }, i.prototype.final = function(e) {
                    var t, r;
                    return e && (t = this.update(e)), r = "encrypt" === this.type ? this._finalEncrypt() : this._finalDecrypt(), t ? t.concat(r) : r;
                }, i.prototype._pad = function(e, t) {
                    if (0 === t) return !1;
                    for(; t < e.length;)e[t++] = 0;
                    return !0;
                }, i.prototype._finalEncrypt = function() {
                    if (!this._pad(this.buffer, this.bufferOff)) return [];
                    var e = new Array(this.blockSize);
                    return this._update(this.buffer, 0, e, 0), e;
                }, i.prototype._unpad = function(e) {
                    return e;
                }, i.prototype._finalDecrypt = function() {
                    n.equal(this.bufferOff, this.blockSize, "Not enough data to decrypt");
                    var e = new Array(this.blockSize);
                    return this._flushBuffer(e, 0), this._unpad(e);
                };
            },
            {
                "minimalistic-assert": 453
            }
        ],
        397: [
            function(e, t, r) {
                "use strict";
                var n = e("minimalistic-assert"), i = e("inherits"), s = e("./utils"), o = e("./cipher");
                function a() {
                    this.tmp = new Array(2), this.keys = null;
                }
                function l(e) {
                    o.call(this, e);
                    var t = new a;
                    this._desState = t, this.deriveKeys(t, e.key);
                }
                i(l, o), t.exports = l, l.create = function(e) {
                    return new l(e);
                };
                var c = [
                    1,
                    1,
                    2,
                    2,
                    2,
                    2,
                    2,
                    2,
                    1,
                    2,
                    2,
                    2,
                    2,
                    2,
                    2,
                    1
                ];
                l.prototype.deriveKeys = function(e, t) {
                    e.keys = new Array(32), n.equal(t.length, this.blockSize, "Invalid key length");
                    var r = s.readUInt32BE(t, 0), i = s.readUInt32BE(t, 4);
                    s.pc1(r, i, e.tmp, 0), r = e.tmp[0], i = e.tmp[1];
                    for(var o = 0; o < e.keys.length; o += 2){
                        var a = c[o >>> 1];
                        r = s.r28shl(r, a), i = s.r28shl(i, a), s.pc2(r, i, e.keys, o);
                    }
                }, l.prototype._update = function(e, t, r, n) {
                    var i = this._desState, o = s.readUInt32BE(e, t), a = s.readUInt32BE(e, t + 4);
                    s.ip(o, a, i.tmp, 0), o = i.tmp[0], a = i.tmp[1], "encrypt" === this.type ? this._encrypt(i, o, a, i.tmp, 0) : this._decrypt(i, o, a, i.tmp, 0), o = i.tmp[0], a = i.tmp[1], s.writeUInt32BE(r, o, n), s.writeUInt32BE(r, a, n + 4);
                }, l.prototype._pad = function(e, t) {
                    if (!1 === this.padding) return !1;
                    for(var r = e.length - t, n = t; n < e.length; n++)e[n] = r;
                    return !0;
                }, l.prototype._unpad = function(e) {
                    if (!1 === this.padding) return e;
                    for(var t = e[e.length - 1], r = e.length - t; r < e.length; r++)n.equal(e[r], t);
                    return e.slice(0, e.length - t);
                }, l.prototype._encrypt = function(e, t, r, n, i) {
                    for(var o = t, a = r, l = 0; l < e.keys.length; l += 2){
                        var c = e.keys[l], u = e.keys[l + 1];
                        s.expand(a, e.tmp, 0), c ^= e.tmp[0], u ^= e.tmp[1];
                        var h = s.substitute(c, u), f = a;
                        a = (o ^ s.permute(h)) >>> 0, o = f;
                    }
                    s.rip(a, o, n, i);
                }, l.prototype._decrypt = function(e, t, r, n, i) {
                    for(var o = r, a = t, l = e.keys.length - 2; l >= 0; l -= 2){
                        var c = e.keys[l], u = e.keys[l + 1];
                        s.expand(o, e.tmp, 0), c ^= e.tmp[0], u ^= e.tmp[1];
                        var h = s.substitute(c, u), f = o;
                        o = (a ^ s.permute(h)) >>> 0, a = f;
                    }
                    s.rip(o, a, n, i);
                };
            },
            {
                "./cipher": 396,
                "./utils": 399,
                inherits: 440,
                "minimalistic-assert": 453
            }
        ],
        398: [
            function(e, t, r) {
                "use strict";
                var n = e("minimalistic-assert"), i = e("inherits"), s = e("./cipher"), o = e("./des");
                function a(e, t) {
                    n.equal(t.length, 24, "Invalid key length");
                    var r = t.slice(0, 8), i = t.slice(8, 16), s = t.slice(16, 24);
                    this.ciphers = "encrypt" === e ? [
                        o.create({
                            type: "encrypt",
                            key: r
                        }),
                        o.create({
                            type: "decrypt",
                            key: i
                        }),
                        o.create({
                            type: "encrypt",
                            key: s
                        })
                    ] : [
                        o.create({
                            type: "decrypt",
                            key: s
                        }),
                        o.create({
                            type: "encrypt",
                            key: i
                        }),
                        o.create({
                            type: "decrypt",
                            key: r
                        })
                    ];
                }
                function l(e) {
                    s.call(this, e);
                    var t = new a(this.type, this.options.key);
                    this._edeState = t;
                }
                i(l, s), t.exports = l, l.create = function(e) {
                    return new l(e);
                }, l.prototype._update = function(e, t, r, n) {
                    var i = this._edeState;
                    i.ciphers[0]._update(e, t, r, n), i.ciphers[1]._update(r, n, r, n), i.ciphers[2]._update(r, n, r, n);
                }, l.prototype._pad = o.prototype._pad, l.prototype._unpad = o.prototype._unpad;
            },
            {
                "./cipher": 396,
                "./des": 397,
                inherits: 440,
                "minimalistic-assert": 453
            }
        ],
        399: [
            function(e, t, r) {
                "use strict";
                r.readUInt32BE = function(e, t) {
                    return (e[0 + t] << 24 | e[1 + t] << 16 | e[2 + t] << 8 | e[3 + t]) >>> 0;
                }, r.writeUInt32BE = function(e, t, r) {
                    e[0 + r] = t >>> 24, e[1 + r] = t >>> 16 & 255, e[2 + r] = t >>> 8 & 255, e[3 + r] = 255 & t;
                }, r.ip = function(e, t, r, n) {
                    for(var i = 0, s = 0, o = 6; o >= 0; o -= 2){
                        for(var a = 0; a <= 24; a += 8)i <<= 1, i |= t >>> a + o & 1;
                        for(a = 0; a <= 24; a += 8)i <<= 1, i |= e >>> a + o & 1;
                    }
                    for(o = 6; o >= 0; o -= 2){
                        for(a = 1; a <= 25; a += 8)s <<= 1, s |= t >>> a + o & 1;
                        for(a = 1; a <= 25; a += 8)s <<= 1, s |= e >>> a + o & 1;
                    }
                    r[n + 0] = i >>> 0, r[n + 1] = s >>> 0;
                }, r.rip = function(e, t, r, n) {
                    for(var i = 0, s = 0, o = 0; o < 4; o++)for(var a = 24; a >= 0; a -= 8)i <<= 1, i |= t >>> a + o & 1, i <<= 1, i |= e >>> a + o & 1;
                    for(o = 4; o < 8; o++)for(a = 24; a >= 0; a -= 8)s <<= 1, s |= t >>> a + o & 1, s <<= 1, s |= e >>> a + o & 1;
                    r[n + 0] = i >>> 0, r[n + 1] = s >>> 0;
                }, r.pc1 = function(e, t, r, n) {
                    for(var i = 0, s = 0, o = 7; o >= 5; o--){
                        for(var a = 0; a <= 24; a += 8)i <<= 1, i |= t >> a + o & 1;
                        for(a = 0; a <= 24; a += 8)i <<= 1, i |= e >> a + o & 1;
                    }
                    for(a = 0; a <= 24; a += 8)i <<= 1, i |= t >> a + o & 1;
                    for(o = 1; o <= 3; o++){
                        for(a = 0; a <= 24; a += 8)s <<= 1, s |= t >> a + o & 1;
                        for(a = 0; a <= 24; a += 8)s <<= 1, s |= e >> a + o & 1;
                    }
                    for(a = 0; a <= 24; a += 8)s <<= 1, s |= e >> a + o & 1;
                    r[n + 0] = i >>> 0, r[n + 1] = s >>> 0;
                }, r.r28shl = function(e, t) {
                    return e << t & 268435455 | e >>> 28 - t;
                };
                var n = [
                    14,
                    11,
                    17,
                    4,
                    27,
                    23,
                    25,
                    0,
                    13,
                    22,
                    7,
                    18,
                    5,
                    9,
                    16,
                    24,
                    2,
                    20,
                    12,
                    21,
                    1,
                    8,
                    15,
                    26,
                    15,
                    4,
                    25,
                    19,
                    9,
                    1,
                    26,
                    16,
                    5,
                    11,
                    23,
                    8,
                    12,
                    7,
                    17,
                    0,
                    22,
                    3,
                    10,
                    14,
                    6,
                    20,
                    27,
                    24
                ];
                r.pc2 = function(e, t, r, i) {
                    for(var s = 0, o = 0, a = n.length >>> 1, l = 0; l < a; l++)s <<= 1, s |= e >>> n[l] & 1;
                    for(l = a; l < n.length; l++)o <<= 1, o |= t >>> n[l] & 1;
                    r[i + 0] = s >>> 0, r[i + 1] = o >>> 0;
                }, r.expand = function(e, t, r) {
                    var n = 0, i = 0;
                    n = (1 & e) << 5 | e >>> 27;
                    for(var s = 23; s >= 15; s -= 4)n <<= 6, n |= e >>> s & 63;
                    for(s = 11; s >= 3; s -= 4)i |= e >>> s & 63, i <<= 6;
                    i |= (31 & e) << 1 | e >>> 31, t[r + 0] = n >>> 0, t[r + 1] = i >>> 0;
                };
                var i = [
                    14,
                    0,
                    4,
                    15,
                    13,
                    7,
                    1,
                    4,
                    2,
                    14,
                    15,
                    2,
                    11,
                    13,
                    8,
                    1,
                    3,
                    10,
                    10,
                    6,
                    6,
                    12,
                    12,
                    11,
                    5,
                    9,
                    9,
                    5,
                    0,
                    3,
                    7,
                    8,
                    4,
                    15,
                    1,
                    12,
                    14,
                    8,
                    8,
                    2,
                    13,
                    4,
                    6,
                    9,
                    2,
                    1,
                    11,
                    7,
                    15,
                    5,
                    12,
                    11,
                    9,
                    3,
                    7,
                    14,
                    3,
                    10,
                    10,
                    0,
                    5,
                    6,
                    0,
                    13,
                    15,
                    3,
                    1,
                    13,
                    8,
                    4,
                    14,
                    7,
                    6,
                    15,
                    11,
                    2,
                    3,
                    8,
                    4,
                    14,
                    9,
                    12,
                    7,
                    0,
                    2,
                    1,
                    13,
                    10,
                    12,
                    6,
                    0,
                    9,
                    5,
                    11,
                    10,
                    5,
                    0,
                    13,
                    14,
                    8,
                    7,
                    10,
                    11,
                    1,
                    10,
                    3,
                    4,
                    15,
                    13,
                    4,
                    1,
                    2,
                    5,
                    11,
                    8,
                    6,
                    12,
                    7,
                    6,
                    12,
                    9,
                    0,
                    3,
                    5,
                    2,
                    14,
                    15,
                    9,
                    10,
                    13,
                    0,
                    7,
                    9,
                    0,
                    14,
                    9,
                    6,
                    3,
                    3,
                    4,
                    15,
                    6,
                    5,
                    10,
                    1,
                    2,
                    13,
                    8,
                    12,
                    5,
                    7,
                    14,
                    11,
                    12,
                    4,
                    11,
                    2,
                    15,
                    8,
                    1,
                    13,
                    1,
                    6,
                    10,
                    4,
                    13,
                    9,
                    0,
                    8,
                    6,
                    15,
                    9,
                    3,
                    8,
                    0,
                    7,
                    11,
                    4,
                    1,
                    15,
                    2,
                    14,
                    12,
                    3,
                    5,
                    11,
                    10,
                    5,
                    14,
                    2,
                    7,
                    12,
                    7,
                    13,
                    13,
                    8,
                    14,
                    11,
                    3,
                    5,
                    0,
                    6,
                    6,
                    15,
                    9,
                    0,
                    10,
                    3,
                    1,
                    4,
                    2,
                    7,
                    8,
                    2,
                    5,
                    12,
                    11,
                    1,
                    12,
                    10,
                    4,
                    14,
                    15,
                    9,
                    10,
                    3,
                    6,
                    15,
                    9,
                    0,
                    0,
                    6,
                    12,
                    10,
                    11,
                    1,
                    7,
                    13,
                    13,
                    8,
                    15,
                    9,
                    1,
                    4,
                    3,
                    5,
                    14,
                    11,
                    5,
                    12,
                    2,
                    7,
                    8,
                    2,
                    4,
                    14,
                    2,
                    14,
                    12,
                    11,
                    4,
                    2,
                    1,
                    12,
                    7,
                    4,
                    10,
                    7,
                    11,
                    13,
                    6,
                    1,
                    8,
                    5,
                    5,
                    0,
                    3,
                    15,
                    15,
                    10,
                    13,
                    3,
                    0,
                    9,
                    14,
                    8,
                    9,
                    6,
                    4,
                    11,
                    2,
                    8,
                    1,
                    12,
                    11,
                    7,
                    10,
                    1,
                    13,
                    14,
                    7,
                    2,
                    8,
                    13,
                    15,
                    6,
                    9,
                    15,
                    12,
                    0,
                    5,
                    9,
                    6,
                    10,
                    3,
                    4,
                    0,
                    5,
                    14,
                    3,
                    12,
                    10,
                    1,
                    15,
                    10,
                    4,
                    15,
                    2,
                    9,
                    7,
                    2,
                    12,
                    6,
                    9,
                    8,
                    5,
                    0,
                    6,
                    13,
                    1,
                    3,
                    13,
                    4,
                    14,
                    14,
                    0,
                    7,
                    11,
                    5,
                    3,
                    11,
                    8,
                    9,
                    4,
                    14,
                    3,
                    15,
                    2,
                    5,
                    12,
                    2,
                    9,
                    8,
                    5,
                    12,
                    15,
                    3,
                    10,
                    7,
                    11,
                    0,
                    14,
                    4,
                    1,
                    10,
                    7,
                    1,
                    6,
                    13,
                    0,
                    11,
                    8,
                    6,
                    13,
                    4,
                    13,
                    11,
                    0,
                    2,
                    11,
                    14,
                    7,
                    15,
                    4,
                    0,
                    9,
                    8,
                    1,
                    13,
                    10,
                    3,
                    14,
                    12,
                    3,
                    9,
                    5,
                    7,
                    12,
                    5,
                    2,
                    10,
                    15,
                    6,
                    8,
                    1,
                    6,
                    1,
                    6,
                    4,
                    11,
                    11,
                    13,
                    13,
                    8,
                    12,
                    1,
                    3,
                    4,
                    7,
                    10,
                    14,
                    7,
                    10,
                    9,
                    15,
                    5,
                    6,
                    0,
                    8,
                    15,
                    0,
                    14,
                    5,
                    2,
                    9,
                    3,
                    2,
                    12,
                    13,
                    1,
                    2,
                    15,
                    8,
                    13,
                    4,
                    8,
                    6,
                    10,
                    15,
                    3,
                    11,
                    7,
                    1,
                    4,
                    10,
                    12,
                    9,
                    5,
                    3,
                    6,
                    14,
                    11,
                    5,
                    0,
                    0,
                    14,
                    12,
                    9,
                    7,
                    2,
                    7,
                    2,
                    11,
                    1,
                    4,
                    14,
                    1,
                    7,
                    9,
                    4,
                    12,
                    10,
                    14,
                    8,
                    2,
                    13,
                    0,
                    15,
                    6,
                    12,
                    10,
                    9,
                    13,
                    0,
                    15,
                    3,
                    3,
                    5,
                    5,
                    6,
                    8,
                    11
                ];
                r.substitute = function(e, t) {
                    for(var r = 0, n = 0; n < 4; n++)r <<= 4, r |= i[64 * n + (e >>> 18 - 6 * n & 63)];
                    for(n = 0; n < 4; n++)r <<= 4, r |= i[256 + 64 * n + (t >>> 18 - 6 * n & 63)];
                    return r >>> 0;
                };
                var s = [
                    16,
                    25,
                    12,
                    11,
                    3,
                    20,
                    4,
                    15,
                    31,
                    17,
                    9,
                    6,
                    27,
                    14,
                    1,
                    22,
                    30,
                    24,
                    8,
                    18,
                    0,
                    5,
                    29,
                    23,
                    13,
                    19,
                    2,
                    26,
                    10,
                    21,
                    28,
                    7
                ];
                r.permute = function(e) {
                    for(var t = 0, r = 0; r < s.length; r++)t <<= 1, t |= e >>> s[r] & 1;
                    return t >>> 0;
                }, r.padSplit = function(e, t, r) {
                    for(var n = e.toString(2); n.length < t;)n = "0" + n;
                    for(var i = [], s = 0; s < t; s += r)i.push(n.slice(s, s + r));
                    return i.join(" ");
                };
            },
            {}
        ],
        400: [
            function(e, t, r) {
                (function(t) {
                    (function() {
                        "use strict";
                        var n = e("./lib/generatePrime"), i = e("./lib/primes.json"), s = e("./lib/dh");
                        var o = {
                            binary: !0,
                            hex: !0,
                            base64: !0
                        };
                        r.DiffieHellmanGroup = r.createDiffieHellmanGroup = r.getDiffieHellman = function(e) {
                            var r = new t(i[e].prime, "hex"), n = new t(i[e].gen, "hex");
                            return new s(r, n);
                        }, r.createDiffieHellman = r.DiffieHellman = function e(r, i, a, l) {
                            return t.isBuffer(i) || void 0 === o[i] ? e(r, "binary", i, a) : (i = i || "binary", l = l || "binary", a = a || new t([
                                2
                            ]), t.isBuffer(a) || (a = new t(a, l)), "number" == typeof r ? new s(n(r, a), a, !0) : (t.isBuffer(r) || (r = new t(r, i)), new s(r, a, !0)));
                        };
                    }).call(this);
                }).call(this, e("buffer").Buffer);
            },
            {
                "./lib/dh": 401,
                "./lib/generatePrime": 402,
                "./lib/primes.json": 403,
                buffer: 220
            }
        ],
        401: [
            function(e, t, r) {
                (function(r) {
                    (function() {
                        "use strict";
                        var n = e("bn.js"), i = new (e("miller-rabin")), s = new n(24), o = new n(11), a = new n(10), l = new n(3), c = new n(7), u = e("./generatePrime"), h = e("randombytes");
                        function f(e, t) {
                            return t = t || "utf8", r.isBuffer(e) || (e = new r(e, t)), this._pub = new n(e), this;
                        }
                        function d(e, t) {
                            return t = t || "utf8", r.isBuffer(e) || (e = new r(e, t)), this._priv = new n(e), this;
                        }
                        t.exports = m;
                        var p = {};
                        function m(e, t, r) {
                            this.setGenerator(t), this.__prime = new n(e), this._prime = n.mont(this.__prime), this._primeLen = e.length, this._pub = void 0, this._priv = void 0, this._primeCode = void 0, r ? (this.setPublicKey = f, this.setPrivateKey = d) : this._primeCode = 8;
                        }
                        function b(e, t) {
                            var n = new r(e.toArray());
                            return t ? n.toString(t) : n;
                        }
                        Object.defineProperty(m.prototype, "verifyError", {
                            enumerable: !0,
                            get: function() {
                                return "number" != typeof this._primeCode && (this._primeCode = function(e, t) {
                                    var r = t.toString("hex"), n = [
                                        r,
                                        e.toString(16)
                                    ].join("_");
                                    if (n in p) return p[n];
                                    var h, f = 0;
                                    if (e.isEven() || !u.simpleSieve || !u.fermatTest(e) || !i.test(e)) return f += 1, f += "02" === r || "05" === r ? 8 : 4, p[n] = f, f;
                                    switch(i.test(e.shrn(1)) || (f += 2), r){
                                        case "02":
                                            e.mod(s).cmp(o) && (f += 8);
                                            break;
                                        case "05":
                                            (h = e.mod(a)).cmp(l) && h.cmp(c) && (f += 8);
                                            break;
                                        default:
                                            f += 4;
                                    }
                                    return p[n] = f, f;
                                }(this.__prime, this.__gen)), this._primeCode;
                            }
                        }), m.prototype.generateKeys = function() {
                            return this._priv || (this._priv = new n(h(this._primeLen))), this._pub = this._gen.toRed(this._prime).redPow(this._priv).fromRed(), this.getPublicKey();
                        }, m.prototype.computeSecret = function(e) {
                            var t = (e = (e = new n(e)).toRed(this._prime)).redPow(this._priv).fromRed(), i = new r(t.toArray()), s = this.getPrime();
                            if (i.length < s.length) {
                                var o = new r(s.length - i.length);
                                o.fill(0), i = r.concat([
                                    o,
                                    i
                                ]);
                            }
                            return i;
                        }, m.prototype.getPublicKey = function(e) {
                            return b(this._pub, e);
                        }, m.prototype.getPrivateKey = function(e) {
                            return b(this._priv, e);
                        }, m.prototype.getPrime = function(e) {
                            return b(this.__prime, e);
                        }, m.prototype.getGenerator = function(e) {
                            return b(this._gen, e);
                        }, m.prototype.setGenerator = function(e, t) {
                            return t = t || "utf8", r.isBuffer(e) || (e = new r(e, t)), this.__gen = e, this._gen = new n(e), this;
                        };
                    }).call(this);
                }).call(this, e("buffer").Buffer);
            },
            {
                "./generatePrime": 402,
                "bn.js": 404,
                buffer: 220,
                "miller-rabin": 451,
                randombytes: 475
            }
        ],
        402: [
            function(e, t, r) {
                "use strict";
                var n = e("randombytes");
                t.exports = y, y.simpleSieve = b, y.fermatTest = g;
                var i = e("bn.js"), s = new i(24), o = new (e("miller-rabin")), a = new i(1), l = new i(2), c = new i(5), u = (new i(16), new i(8), new i(10)), h = new i(3), f = (new i(7), new i(11)), d = new i(4), p = (new i(12), null);
                function m() {
                    if (null !== p) return p;
                    var e = [];
                    e[0] = 2;
                    for(var t = 1, r = 3; r < 1048576; r += 2){
                        for(var n = Math.ceil(Math.sqrt(r)), i = 0; i < t && e[i] <= n && r % e[i] != 0; i++);
                        t !== i && e[i] <= n || (e[t++] = r);
                    }
                    return p = e, e;
                }
                function b(e) {
                    for(var t = m(), r = 0; r < t.length; r++)if (0 === e.modn(t[r])) return 0 === e.cmpn(t[r]);
                    return !0;
                }
                function g(e) {
                    var t = i.mont(e);
                    return 0 === l.toRed(t).redPow(e.subn(1)).fromRed().cmpn(1);
                }
                function y(e, t) {
                    if (e < 16) return new i(2 === t || 5 === t ? [
                        140,
                        123
                    ] : [
                        140,
                        39
                    ]);
                    var r, p;
                    for(t = new i(t);;){
                        for(r = new i(n(Math.ceil(e / 8))); r.bitLength() > e;)r.ishrn(1);
                        if (r.isEven() && r.iadd(a), r.testn(1) || r.iadd(l), t.cmp(l)) {
                            if (!t.cmp(c)) for(; r.mod(u).cmp(h);)r.iadd(d);
                        } else for(; r.mod(s).cmp(f);)r.iadd(d);
                        if (b(p = r.shrn(1)) && b(r) && g(p) && g(r) && o.test(p) && o.test(r)) return r;
                    }
                }
            },
            {
                "bn.js": 404,
                "miller-rabin": 451,
                randombytes: 475
            }
        ],
        403: [
            function(e, t, r) {
                t.exports = {
                    modp1: {
                        gen: "02",
                        prime: "ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a63a3620ffffffffffffffff"
                    },
                    modp2: {
                        gen: "02",
                        prime: "ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece65381ffffffffffffffff"
                    },
                    modp5: {
                        gen: "02",
                        prime: "ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca237327ffffffffffffffff"
                    },
                    modp14: {
                        gen: "02",
                        prime: "ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aacaa68ffffffffffffffff"
                    },
                    modp15: {
                        gen: "02",
                        prime: "ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a93ad2caffffffffffffffff"
                    },
                    modp16: {
                        gen: "02",
                        prime: "ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a92108011a723c12a787e6d788719a10bdba5b2699c327186af4e23c1a946834b6150bda2583e9ca2ad44ce8dbbbc2db04de8ef92e8efc141fbecaa6287c59474e6bc05d99b2964fa090c3a2233ba186515be7ed1f612970cee2d7afb81bdd762170481cd0069127d5b05aa993b4ea988d8fddc186ffb7dc90a6c08f4df435c934063199ffffffffffffffff"
                    },
                    modp17: {
                        gen: "02",
                        prime: "ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a92108011a723c12a787e6d788719a10bdba5b2699c327186af4e23c1a946834b6150bda2583e9ca2ad44ce8dbbbc2db04de8ef92e8efc141fbecaa6287c59474e6bc05d99b2964fa090c3a2233ba186515be7ed1f612970cee2d7afb81bdd762170481cd0069127d5b05aa993b4ea988d8fddc186ffb7dc90a6c08f4df435c93402849236c3fab4d27c7026c1d4dcb2602646dec9751e763dba37bdf8ff9406ad9e530ee5db382f413001aeb06a53ed9027d831179727b0865a8918da3edbebcf9b14ed44ce6cbaced4bb1bdb7f1447e6cc254b332051512bd7af426fb8f401378cd2bf5983ca01c64b92ecf032ea15d1721d03f482d7ce6e74fef6d55e702f46980c82b5a84031900b1c9e59e7c97fbec7e8f323a97a7e36cc88be0f1d45b7ff585ac54bd407b22b4154aacc8f6d7ebf48e1d814cc5ed20f8037e0a79715eef29be32806a1d58bb7c5da76f550aa3d8a1fbff0eb19ccb1a313d55cda56c9ec2ef29632387fe8d76e3c0468043e8f663f4860ee12bf2d5b0b7474d6e694f91e6dcc4024ffffffffffffffff"
                    },
                    modp18: {
                        gen: "02",
                        prime: "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"
                    }
                };
            },
            {}
        ],
        404: [
            function(e, t, r) {
                arguments[4][184][0].apply(r, arguments);
            },
            {
                buffer: 188,
                dup: 184
            }
        ],
        405: [
            function(e, t, r) {
                "use strict";
                var n = r;
                n.version = e("../package.json").version, n.utils = e("./elliptic/utils"), n.rand = e("brorand"), n.curve = e("./elliptic/curve"), n.curves = e("./elliptic/curves"), n.ec = e("./elliptic/ec"), n.eddsa = e("./elliptic/eddsa");
            },
            {
                "../package.json": 421,
                "./elliptic/curve": 408,
                "./elliptic/curves": 411,
                "./elliptic/ec": 412,
                "./elliptic/eddsa": 415,
                "./elliptic/utils": 419,
                brorand: 187
            }
        ],
        406: [
            function(e, t, r) {
                "use strict";
                var n = e("bn.js"), i = e("../utils"), s = i.getNAF, o = i.getJSF, a = i.assert;
                function l(e, t) {
                    this.type = e, this.p = new n(t.p, 16), this.red = t.prime ? n.red(t.prime) : n.mont(this.p), this.zero = new n(0).toRed(this.red), this.one = new n(1).toRed(this.red), this.two = new n(2).toRed(this.red), this.n = t.n && new n(t.n, 16), this.g = t.g && this.pointFromJSON(t.g, t.gRed), this._wnafT1 = new Array(4), this._wnafT2 = new Array(4), this._wnafT3 = new Array(4), this._wnafT4 = new Array(4), this._bitLength = this.n ? this.n.bitLength() : 0;
                    var r = this.n && this.p.div(this.n);
                    !r || r.cmpn(100) > 0 ? this.redN = null : (this._maxwellTrick = !0, this.redN = this.n.toRed(this.red));
                }
                function c(e, t) {
                    this.curve = e, this.type = t, this.precomputed = null;
                }
                t.exports = l, l.prototype.point = function() {
                    throw new Error("Not implemented");
                }, l.prototype.validate = function() {
                    throw new Error("Not implemented");
                }, l.prototype._fixedNafMul = function(e, t) {
                    a(e.precomputed);
                    var r = e._getDoubles(), n = s(t, 1, this._bitLength), i = (1 << r.step + 1) - (r.step % 2 == 0 ? 2 : 1);
                    i /= 3;
                    var o, l, c = [];
                    for(o = 0; o < n.length; o += r.step){
                        l = 0;
                        for(var u = o + r.step - 1; u >= o; u--)l = (l << 1) + n[u];
                        c.push(l);
                    }
                    for(var h = this.jpoint(null, null, null), f = this.jpoint(null, null, null), d = i; d > 0; d--){
                        for(o = 0; o < c.length; o++)(l = c[o]) === d ? f = f.mixedAdd(r.points[o]) : l === -d && (f = f.mixedAdd(r.points[o].neg()));
                        h = h.add(f);
                    }
                    return h.toP();
                }, l.prototype._wnafMul = function(e, t) {
                    var r = 4, n = e._getNAFPoints(r);
                    r = n.wnd;
                    for(var i = n.points, o = s(t, r, this._bitLength), l = this.jpoint(null, null, null), c = o.length - 1; c >= 0; c--){
                        for(var u = 0; c >= 0 && 0 === o[c]; c--)u++;
                        if (c >= 0 && u++, l = l.dblp(u), c < 0) break;
                        var h = o[c];
                        a(0 !== h), l = "affine" === e.type ? h > 0 ? l.mixedAdd(i[h - 1 >> 1]) : l.mixedAdd(i[-h - 1 >> 1].neg()) : h > 0 ? l.add(i[h - 1 >> 1]) : l.add(i[-h - 1 >> 1].neg());
                    }
                    return "affine" === e.type ? l.toP() : l;
                }, l.prototype._wnafMulAdd = function(e, t, r, n, i) {
                    var a, l, c, u = this._wnafT1, h = this._wnafT2, f = this._wnafT3, d = 0;
                    for(a = 0; a < n; a++){
                        var p = (c = t[a])._getNAFPoints(e);
                        u[a] = p.wnd, h[a] = p.points;
                    }
                    for(a = n - 1; a >= 1; a -= 2){
                        var m = a - 1, b = a;
                        if (1 === u[m] && 1 === u[b]) {
                            var g = [
                                t[m],
                                null,
                                null,
                                t[b]
                            ];
                            0 === t[m].y.cmp(t[b].y) ? (g[1] = t[m].add(t[b]), g[2] = t[m].toJ().mixedAdd(t[b].neg())) : 0 === t[m].y.cmp(t[b].y.redNeg()) ? (g[1] = t[m].toJ().mixedAdd(t[b]), g[2] = t[m].add(t[b].neg())) : (g[1] = t[m].toJ().mixedAdd(t[b]), g[2] = t[m].toJ().mixedAdd(t[b].neg()));
                            var y = [
                                -3,
                                -1,
                                -5,
                                -7,
                                0,
                                7,
                                5,
                                1,
                                3
                            ], v = o(r[m], r[b]);
                            for(d = Math.max(v[0].length, d), f[m] = new Array(d), f[b] = new Array(d), l = 0; l < d; l++){
                                var w = 0 | v[0][l], _ = 0 | v[1][l];
                                f[m][l] = y[3 * (w + 1) + (_ + 1)], f[b][l] = 0, h[m] = g;
                            }
                        } else f[m] = s(r[m], u[m], this._bitLength), f[b] = s(r[b], u[b], this._bitLength), d = Math.max(f[m].length, d), d = Math.max(f[b].length, d);
                    }
                    var x = this.jpoint(null, null, null), k = this._wnafT4;
                    for(a = d; a >= 0; a--){
                        for(var S = 0; a >= 0;){
                            var M = !0;
                            for(l = 0; l < n; l++)k[l] = 0 | f[l][a], 0 !== k[l] && (M = !1);
                            if (!M) break;
                            S++, a--;
                        }
                        if (a >= 0 && S++, x = x.dblp(S), a < 0) break;
                        for(l = 0; l < n; l++){
                            var C = k[l];
                            0 !== C && (C > 0 ? c = h[l][C - 1 >> 1] : C < 0 && (c = h[l][-C - 1 >> 1].neg()), x = "affine" === c.type ? x.mixedAdd(c) : x.add(c));
                        }
                    }
                    for(a = 0; a < n; a++)h[a] = null;
                    return i ? x : x.toP();
                }, l.BasePoint = c, c.prototype.eq = function() {
                    throw new Error("Not implemented");
                }, c.prototype.validate = function() {
                    return this.curve.validate(this);
                }, l.prototype.decodePoint = function(e, t) {
                    e = i.toArray(e, t);
                    var r = this.p.byteLength();
                    if ((4 === e[0] || 6 === e[0] || 7 === e[0]) && e.length - 1 == 2 * r) return 6 === e[0] ? a(e[e.length - 1] % 2 == 0) : 7 === e[0] && a(e[e.length - 1] % 2 == 1), this.point(e.slice(1, 1 + r), e.slice(1 + r, 1 + 2 * r));
                    if ((2 === e[0] || 3 === e[0]) && e.length - 1 === r) return this.pointFromX(e.slice(1, 1 + r), 3 === e[0]);
                    throw new Error("Unknown point format");
                }, c.prototype.encodeCompressed = function(e) {
                    return this.encode(e, !0);
                }, c.prototype._encode = function(e) {
                    var t = this.curve.p.byteLength(), r = this.getX().toArray("be", t);
                    return e ? [
                        this.getY().isEven() ? 2 : 3
                    ].concat(r) : [
                        4
                    ].concat(r, this.getY().toArray("be", t));
                }, c.prototype.encode = function(e, t) {
                    return i.encode(this._encode(t), e);
                }, c.prototype.precompute = function(e) {
                    if (this.precomputed) return this;
                    var t = {
                        doubles: null,
                        naf: null,
                        beta: null
                    };
                    return t.naf = this._getNAFPoints(8), t.doubles = this._getDoubles(4, e), t.beta = this._getBeta(), this.precomputed = t, this;
                }, c.prototype._hasDoubles = function(e) {
                    if (!this.precomputed) return !1;
                    var t = this.precomputed.doubles;
                    return !!t && t.points.length >= Math.ceil((e.bitLength() + 1) / t.step);
                }, c.prototype._getDoubles = function(e, t) {
                    if (this.precomputed && this.precomputed.doubles) return this.precomputed.doubles;
                    for(var r = [
                        this
                    ], n = this, i = 0; i < t; i += e){
                        for(var s = 0; s < e; s++)n = n.dbl();
                        r.push(n);
                    }
                    return {
                        step: e,
                        points: r
                    };
                }, c.prototype._getNAFPoints = function(e) {
                    if (this.precomputed && this.precomputed.naf) return this.precomputed.naf;
                    for(var t = [
                        this
                    ], r = (1 << e) - 1, n = 1 === r ? null : this.dbl(), i = 1; i < r; i++)t[i] = t[i - 1].add(n);
                    return {
                        wnd: e,
                        points: t
                    };
                }, c.prototype._getBeta = function() {
                    return null;
                }, c.prototype.dblp = function(e) {
                    for(var t = this, r = 0; r < e; r++)t = t.dbl();
                    return t;
                };
            },
            {
                "../utils": 419,
                "bn.js": 420
            }
        ],
        407: [
            function(e, t, r) {
                "use strict";
                var n = e("../utils"), i = e("bn.js"), s = e("inherits"), o = e("./base"), a = n.assert;
                function l(e) {
                    this.twisted = 1 != (0 | e.a), this.mOneA = this.twisted && -1 == (0 | e.a), this.extended = this.mOneA, o.call(this, "edwards", e), this.a = new i(e.a, 16).umod(this.red.m), this.a = this.a.toRed(this.red), this.c = new i(e.c, 16).toRed(this.red), this.c2 = this.c.redSqr(), this.d = new i(e.d, 16).toRed(this.red), this.dd = this.d.redAdd(this.d), a(!this.twisted || 0 === this.c.fromRed().cmpn(1)), this.oneC = 1 == (0 | e.c);
                }
                function c(e, t, r, n, s) {
                    o.BasePoint.call(this, e, "projective"), null === t && null === r && null === n ? (this.x = this.curve.zero, this.y = this.curve.one, this.z = this.curve.one, this.t = this.curve.zero, this.zOne = !0) : (this.x = new i(t, 16), this.y = new i(r, 16), this.z = n ? new i(n, 16) : this.curve.one, this.t = s && new i(s, 16), this.x.red || (this.x = this.x.toRed(this.curve.red)), this.y.red || (this.y = this.y.toRed(this.curve.red)), this.z.red || (this.z = this.z.toRed(this.curve.red)), this.t && !this.t.red && (this.t = this.t.toRed(this.curve.red)), this.zOne = this.z === this.curve.one, this.curve.extended && !this.t && (this.t = this.x.redMul(this.y), this.zOne || (this.t = this.t.redMul(this.z.redInvm()))));
                }
                s(l, o), t.exports = l, l.prototype._mulA = function(e) {
                    return this.mOneA ? e.redNeg() : this.a.redMul(e);
                }, l.prototype._mulC = function(e) {
                    return this.oneC ? e : this.c.redMul(e);
                }, l.prototype.jpoint = function(e, t, r, n) {
                    return this.point(e, t, r, n);
                }, l.prototype.pointFromX = function(e, t) {
                    (e = new i(e, 16)).red || (e = e.toRed(this.red));
                    var r = e.redSqr(), n = this.c2.redSub(this.a.redMul(r)), s = this.one.redSub(this.c2.redMul(this.d).redMul(r)), o = n.redMul(s.redInvm()), a = o.redSqrt();
                    if (0 !== a.redSqr().redSub(o).cmp(this.zero)) throw new Error("invalid point");
                    var l = a.fromRed().isOdd();
                    return (t && !l || !t && l) && (a = a.redNeg()), this.point(e, a);
                }, l.prototype.pointFromY = function(e, t) {
                    (e = new i(e, 16)).red || (e = e.toRed(this.red));
                    var r = e.redSqr(), n = r.redSub(this.c2), s = r.redMul(this.d).redMul(this.c2).redSub(this.a), o = n.redMul(s.redInvm());
                    if (0 === o.cmp(this.zero)) {
                        if (t) throw new Error("invalid point");
                        return this.point(this.zero, e);
                    }
                    var a = o.redSqrt();
                    if (0 !== a.redSqr().redSub(o).cmp(this.zero)) throw new Error("invalid point");
                    return a.fromRed().isOdd() !== t && (a = a.redNeg()), this.point(a, e);
                }, l.prototype.validate = function(e) {
                    if (e.isInfinity()) return !0;
                    e.normalize();
                    var t = e.x.redSqr(), r = e.y.redSqr(), n = t.redMul(this.a).redAdd(r), i = this.c2.redMul(this.one.redAdd(this.d.redMul(t).redMul(r)));
                    return 0 === n.cmp(i);
                }, s(c, o.BasePoint), l.prototype.pointFromJSON = function(e) {
                    return c.fromJSON(this, e);
                }, l.prototype.point = function(e, t, r, n) {
                    return new c(this, e, t, r, n);
                }, c.fromJSON = function(e, t) {
                    return new c(e, t[0], t[1], t[2]);
                }, c.prototype.inspect = function() {
                    return this.isInfinity() ? "<EC Point Infinity>" : "<EC Point x: " + this.x.fromRed().toString(16, 2) + " y: " + this.y.fromRed().toString(16, 2) + " z: " + this.z.fromRed().toString(16, 2) + ">";
                }, c.prototype.isInfinity = function() {
                    return 0 === this.x.cmpn(0) && (0 === this.y.cmp(this.z) || this.zOne && 0 === this.y.cmp(this.curve.c));
                }, c.prototype._extDbl = function() {
                    var e = this.x.redSqr(), t = this.y.redSqr(), r = this.z.redSqr();
                    r = r.redIAdd(r);
                    var n = this.curve._mulA(e), i = this.x.redAdd(this.y).redSqr().redISub(e).redISub(t), s = n.redAdd(t), o = s.redSub(r), a = n.redSub(t), l = i.redMul(o), c = s.redMul(a), u = i.redMul(a), h = o.redMul(s);
                    return this.curve.point(l, c, h, u);
                }, c.prototype._projDbl = function() {
                    var e, t, r, n, i, s, o = this.x.redAdd(this.y).redSqr(), a = this.x.redSqr(), l = this.y.redSqr();
                    if (this.curve.twisted) {
                        var c = (n = this.curve._mulA(a)).redAdd(l);
                        this.zOne ? (e = o.redSub(a).redSub(l).redMul(c.redSub(this.curve.two)), t = c.redMul(n.redSub(l)), r = c.redSqr().redSub(c).redSub(c)) : (i = this.z.redSqr(), s = c.redSub(i).redISub(i), e = o.redSub(a).redISub(l).redMul(s), t = c.redMul(n.redSub(l)), r = c.redMul(s));
                    } else n = a.redAdd(l), i = this.curve._mulC(this.z).redSqr(), s = n.redSub(i).redSub(i), e = this.curve._mulC(o.redISub(n)).redMul(s), t = this.curve._mulC(n).redMul(a.redISub(l)), r = n.redMul(s);
                    return this.curve.point(e, t, r);
                }, c.prototype.dbl = function() {
                    return this.isInfinity() ? this : this.curve.extended ? this._extDbl() : this._projDbl();
                }, c.prototype._extAdd = function(e) {
                    var t = this.y.redSub(this.x).redMul(e.y.redSub(e.x)), r = this.y.redAdd(this.x).redMul(e.y.redAdd(e.x)), n = this.t.redMul(this.curve.dd).redMul(e.t), i = this.z.redMul(e.z.redAdd(e.z)), s = r.redSub(t), o = i.redSub(n), a = i.redAdd(n), l = r.redAdd(t), c = s.redMul(o), u = a.redMul(l), h = s.redMul(l), f = o.redMul(a);
                    return this.curve.point(c, u, f, h);
                }, c.prototype._projAdd = function(e) {
                    var t, r, n = this.z.redMul(e.z), i = n.redSqr(), s = this.x.redMul(e.x), o = this.y.redMul(e.y), a = this.curve.d.redMul(s).redMul(o), l = i.redSub(a), c = i.redAdd(a), u = this.x.redAdd(this.y).redMul(e.x.redAdd(e.y)).redISub(s).redISub(o), h = n.redMul(l).redMul(u);
                    return this.curve.twisted ? (t = n.redMul(c).redMul(o.redSub(this.curve._mulA(s))), r = l.redMul(c)) : (t = n.redMul(c).redMul(o.redSub(s)), r = this.curve._mulC(l).redMul(c)), this.curve.point(h, t, r);
                }, c.prototype.add = function(e) {
                    return this.isInfinity() ? e : e.isInfinity() ? this : this.curve.extended ? this._extAdd(e) : this._projAdd(e);
                }, c.prototype.mul = function(e) {
                    return this._hasDoubles(e) ? this.curve._fixedNafMul(this, e) : this.curve._wnafMul(this, e);
                }, c.prototype.mulAdd = function(e, t, r) {
                    return this.curve._wnafMulAdd(1, [
                        this,
                        t
                    ], [
                        e,
                        r
                    ], 2, !1);
                }, c.prototype.jmulAdd = function(e, t, r) {
                    return this.curve._wnafMulAdd(1, [
                        this,
                        t
                    ], [
                        e,
                        r
                    ], 2, !0);
                }, c.prototype.normalize = function() {
                    if (this.zOne) return this;
                    var e = this.z.redInvm();
                    return this.x = this.x.redMul(e), this.y = this.y.redMul(e), this.t && (this.t = this.t.redMul(e)), this.z = this.curve.one, this.zOne = !0, this;
                }, c.prototype.neg = function() {
                    return this.curve.point(this.x.redNeg(), this.y, this.z, this.t && this.t.redNeg());
                }, c.prototype.getX = function() {
                    return this.normalize(), this.x.fromRed();
                }, c.prototype.getY = function() {
                    return this.normalize(), this.y.fromRed();
                }, c.prototype.eq = function(e) {
                    return this === e || 0 === this.getX().cmp(e.getX()) && 0 === this.getY().cmp(e.getY());
                }, c.prototype.eqXToP = function(e) {
                    var t = e.toRed(this.curve.red).redMul(this.z);
                    if (0 === this.x.cmp(t)) return !0;
                    for(var r = e.clone(), n = this.curve.redN.redMul(this.z);;){
                        if (r.iadd(this.curve.n), r.cmp(this.curve.p) >= 0) return !1;
                        if (t.redIAdd(n), 0 === this.x.cmp(t)) return !0;
                    }
                }, c.prototype.toP = c.prototype.normalize, c.prototype.mixedAdd = c.prototype.add;
            },
            {
                "../utils": 419,
                "./base": 406,
                "bn.js": 420,
                inherits: 440
            }
        ],
        408: [
            function(e, t, r) {
                "use strict";
                var n = r;
                n.base = e("./base"), n.short = e("./short"), n.mont = e("./mont"), n.edwards = e("./edwards");
            },
            {
                "./base": 406,
                "./edwards": 407,
                "./mont": 409,
                "./short": 410
            }
        ],
        409: [
            function(e, t, r) {
                "use strict";
                var n = e("bn.js"), i = e("inherits"), s = e("./base"), o = e("../utils");
                function a(e) {
                    s.call(this, "mont", e), this.a = new n(e.a, 16).toRed(this.red), this.b = new n(e.b, 16).toRed(this.red), this.i4 = new n(4).toRed(this.red).redInvm(), this.two = new n(2).toRed(this.red), this.a24 = this.i4.redMul(this.a.redAdd(this.two));
                }
                function l(e, t, r) {
                    s.BasePoint.call(this, e, "projective"), null === t && null === r ? (this.x = this.curve.one, this.z = this.curve.zero) : (this.x = new n(t, 16), this.z = new n(r, 16), this.x.red || (this.x = this.x.toRed(this.curve.red)), this.z.red || (this.z = this.z.toRed(this.curve.red)));
                }
                i(a, s), t.exports = a, a.prototype.validate = function(e) {
                    var t = e.normalize().x, r = t.redSqr(), n = r.redMul(t).redAdd(r.redMul(this.a)).redAdd(t);
                    return 0 === n.redSqrt().redSqr().cmp(n);
                }, i(l, s.BasePoint), a.prototype.decodePoint = function(e, t) {
                    return this.point(o.toArray(e, t), 1);
                }, a.prototype.point = function(e, t) {
                    return new l(this, e, t);
                }, a.prototype.pointFromJSON = function(e) {
                    return l.fromJSON(this, e);
                }, l.prototype.precompute = function() {}, l.prototype._encode = function() {
                    return this.getX().toArray("be", this.curve.p.byteLength());
                }, l.fromJSON = function(e, t) {
                    return new l(e, t[0], t[1] || e.one);
                }, l.prototype.inspect = function() {
                    return this.isInfinity() ? "<EC Point Infinity>" : "<EC Point x: " + this.x.fromRed().toString(16, 2) + " z: " + this.z.fromRed().toString(16, 2) + ">";
                }, l.prototype.isInfinity = function() {
                    return 0 === this.z.cmpn(0);
                }, l.prototype.dbl = function() {
                    var e = this.x.redAdd(this.z).redSqr(), t = this.x.redSub(this.z).redSqr(), r = e.redSub(t), n = e.redMul(t), i = r.redMul(t.redAdd(this.curve.a24.redMul(r)));
                    return this.curve.point(n, i);
                }, l.prototype.add = function() {
                    throw new Error("Not supported on Montgomery curve");
                }, l.prototype.diffAdd = function(e, t) {
                    var r = this.x.redAdd(this.z), n = this.x.redSub(this.z), i = e.x.redAdd(e.z), s = e.x.redSub(e.z).redMul(r), o = i.redMul(n), a = t.z.redMul(s.redAdd(o).redSqr()), l = t.x.redMul(s.redISub(o).redSqr());
                    return this.curve.point(a, l);
                }, l.prototype.mul = function(e) {
                    for(var t = e.clone(), r = this, n = this.curve.point(null, null), i = []; 0 !== t.cmpn(0); t.iushrn(1))i.push(t.andln(1));
                    for(var s = i.length - 1; s >= 0; s--)0 === i[s] ? (r = r.diffAdd(n, this), n = n.dbl()) : (n = r.diffAdd(n, this), r = r.dbl());
                    return n;
                }, l.prototype.mulAdd = function() {
                    throw new Error("Not supported on Montgomery curve");
                }, l.prototype.jumlAdd = function() {
                    throw new Error("Not supported on Montgomery curve");
                }, l.prototype.eq = function(e) {
                    return 0 === this.getX().cmp(e.getX());
                }, l.prototype.normalize = function() {
                    return this.x = this.x.redMul(this.z.redInvm()), this.z = this.curve.one, this;
                }, l.prototype.getX = function() {
                    return this.normalize(), this.x.fromRed();
                };
            },
            {
                "../utils": 419,
                "./base": 406,
                "bn.js": 420,
                inherits: 440
            }
        ],
        410: [
            function(e, t, r) {
                "use strict";
                var n = e("../utils"), i = e("bn.js"), s = e("inherits"), o = e("./base"), a = n.assert;
                function l(e) {
                    o.call(this, "short", e), this.a = new i(e.a, 16).toRed(this.red), this.b = new i(e.b, 16).toRed(this.red), this.tinv = this.two.redInvm(), this.zeroA = 0 === this.a.fromRed().cmpn(0), this.threeA = 0 === this.a.fromRed().sub(this.p).cmpn(-3), this.endo = this._getEndomorphism(e), this._endoWnafT1 = new Array(4), this._endoWnafT2 = new Array(4);
                }
                function c(e, t, r, n) {
                    o.BasePoint.call(this, e, "affine"), null === t && null === r ? (this.x = null, this.y = null, this.inf = !0) : (this.x = new i(t, 16), this.y = new i(r, 16), n && (this.x.forceRed(this.curve.red), this.y.forceRed(this.curve.red)), this.x.red || (this.x = this.x.toRed(this.curve.red)), this.y.red || (this.y = this.y.toRed(this.curve.red)), this.inf = !1);
                }
                function u(e, t, r, n) {
                    o.BasePoint.call(this, e, "jacobian"), null === t && null === r && null === n ? (this.x = this.curve.one, this.y = this.curve.one, this.z = new i(0)) : (this.x = new i(t, 16), this.y = new i(r, 16), this.z = new i(n, 16)), this.x.red || (this.x = this.x.toRed(this.curve.red)), this.y.red || (this.y = this.y.toRed(this.curve.red)), this.z.red || (this.z = this.z.toRed(this.curve.red)), this.zOne = this.z === this.curve.one;
                }
                s(l, o), t.exports = l, l.prototype._getEndomorphism = function(e) {
                    if (this.zeroA && this.g && this.n && 1 === this.p.modn(3)) {
                        var t, r;
                        if (e.beta) t = new i(e.beta, 16).toRed(this.red);
                        else {
                            var n = this._getEndoRoots(this.p);
                            t = (t = n[0].cmp(n[1]) < 0 ? n[0] : n[1]).toRed(this.red);
                        }
                        if (e.lambda) r = new i(e.lambda, 16);
                        else {
                            var s = this._getEndoRoots(this.n);
                            0 === this.g.mul(s[0]).x.cmp(this.g.x.redMul(t)) ? r = s[0] : (r = s[1], a(0 === this.g.mul(r).x.cmp(this.g.x.redMul(t))));
                        }
                        return {
                            beta: t,
                            lambda: r,
                            basis: e.basis ? e.basis.map(function(e) {
                                return {
                                    a: new i(e.a, 16),
                                    b: new i(e.b, 16)
                                };
                            }) : this._getEndoBasis(r)
                        };
                    }
                }, l.prototype._getEndoRoots = function(e) {
                    var t = e === this.p ? this.red : i.mont(e), r = new i(2).toRed(t).redInvm(), n = r.redNeg(), s = new i(3).toRed(t).redNeg().redSqrt().redMul(r);
                    return [
                        n.redAdd(s).fromRed(),
                        n.redSub(s).fromRed()
                    ];
                }, l.prototype._getEndoBasis = function(e) {
                    for(var t, r, n, s, o, a, l, c, u, h = this.n.ushrn(Math.floor(this.n.bitLength() / 2)), f = e, d = this.n.clone(), p = new i(1), m = new i(0), b = new i(0), g = new i(1), y = 0; 0 !== f.cmpn(0);){
                        var v = d.div(f);
                        c = d.sub(v.mul(f)), u = b.sub(v.mul(p));
                        var w = g.sub(v.mul(m));
                        if (!n && c.cmp(h) < 0) t = l.neg(), r = p, n = c.neg(), s = u;
                        else if (n && 2 == ++y) break;
                        l = c, d = f, f = c, b = p, p = u, g = m, m = w;
                    }
                    o = c.neg(), a = u;
                    var _ = n.sqr().add(s.sqr());
                    return o.sqr().add(a.sqr()).cmp(_) >= 0 && (o = t, a = r), n.negative && (n = n.neg(), s = s.neg()), o.negative && (o = o.neg(), a = a.neg()), [
                        {
                            a: n,
                            b: s
                        },
                        {
                            a: o,
                            b: a
                        }
                    ];
                }, l.prototype._endoSplit = function(e) {
                    var t = this.endo.basis, r = t[0], n = t[1], i = n.b.mul(e).divRound(this.n), s = r.b.neg().mul(e).divRound(this.n), o = i.mul(r.a), a = s.mul(n.a), l = i.mul(r.b), c = s.mul(n.b);
                    return {
                        k1: e.sub(o).sub(a),
                        k2: l.add(c).neg()
                    };
                }, l.prototype.pointFromX = function(e, t) {
                    (e = new i(e, 16)).red || (e = e.toRed(this.red));
                    var r = e.redSqr().redMul(e).redIAdd(e.redMul(this.a)).redIAdd(this.b), n = r.redSqrt();
                    if (0 !== n.redSqr().redSub(r).cmp(this.zero)) throw new Error("invalid point");
                    var s = n.fromRed().isOdd();
                    return (t && !s || !t && s) && (n = n.redNeg()), this.point(e, n);
                }, l.prototype.validate = function(e) {
                    if (e.inf) return !0;
                    var t = e.x, r = e.y, n = this.a.redMul(t), i = t.redSqr().redMul(t).redIAdd(n).redIAdd(this.b);
                    return 0 === r.redSqr().redISub(i).cmpn(0);
                }, l.prototype._endoWnafMulAdd = function(e, t, r) {
                    for(var n = this._endoWnafT1, i = this._endoWnafT2, s = 0; s < e.length; s++){
                        var o = this._endoSplit(t[s]), a = e[s], l = a._getBeta();
                        o.k1.negative && (o.k1.ineg(), a = a.neg(!0)), o.k2.negative && (o.k2.ineg(), l = l.neg(!0)), n[2 * s] = a, n[2 * s + 1] = l, i[2 * s] = o.k1, i[2 * s + 1] = o.k2;
                    }
                    for(var c = this._wnafMulAdd(1, n, i, 2 * s, r), u = 0; u < 2 * s; u++)n[u] = null, i[u] = null;
                    return c;
                }, s(c, o.BasePoint), l.prototype.point = function(e, t, r) {
                    return new c(this, e, t, r);
                }, l.prototype.pointFromJSON = function(e, t) {
                    return c.fromJSON(this, e, t);
                }, c.prototype._getBeta = function() {
                    if (this.curve.endo) {
                        var e = this.precomputed;
                        if (e && e.beta) return e.beta;
                        var t = this.curve.point(this.x.redMul(this.curve.endo.beta), this.y);
                        if (e) {
                            var r = this.curve, n = function(e) {
                                return r.point(e.x.redMul(r.endo.beta), e.y);
                            };
                            e.beta = t, t.precomputed = {
                                beta: null,
                                naf: e.naf && {
                                    wnd: e.naf.wnd,
                                    points: e.naf.points.map(n)
                                },
                                doubles: e.doubles && {
                                    step: e.doubles.step,
                                    points: e.doubles.points.map(n)
                                }
                            };
                        }
                        return t;
                    }
                }, c.prototype.toJSON = function() {
                    return this.precomputed ? [
                        this.x,
                        this.y,
                        this.precomputed && {
                            doubles: this.precomputed.doubles && {
                                step: this.precomputed.doubles.step,
                                points: this.precomputed.doubles.points.slice(1)
                            },
                            naf: this.precomputed.naf && {
                                wnd: this.precomputed.naf.wnd,
                                points: this.precomputed.naf.points.slice(1)
                            }
                        }
                    ] : [
                        this.x,
                        this.y
                    ];
                }, c.fromJSON = function(e, t, r) {
                    "string" == typeof t && (t = JSON.parse(t));
                    var n = e.point(t[0], t[1], r);
                    if (!t[2]) return n;
                    function i(t) {
                        return e.point(t[0], t[1], r);
                    }
                    var s = t[2];
                    return n.precomputed = {
                        beta: null,
                        doubles: s.doubles && {
                            step: s.doubles.step,
                            points: [
                                n
                            ].concat(s.doubles.points.map(i))
                        },
                        naf: s.naf && {
                            wnd: s.naf.wnd,
                            points: [
                                n
                            ].concat(s.naf.points.map(i))
                        }
                    }, n;
                }, c.prototype.inspect = function() {
                    return this.isInfinity() ? "<EC Point Infinity>" : "<EC Point x: " + this.x.fromRed().toString(16, 2) + " y: " + this.y.fromRed().toString(16, 2) + ">";
                }, c.prototype.isInfinity = function() {
                    return this.inf;
                }, c.prototype.add = function(e) {
                    if (this.inf) return e;
                    if (e.inf) return this;
                    if (this.eq(e)) return this.dbl();
                    if (this.neg().eq(e)) return this.curve.point(null, null);
                    if (0 === this.x.cmp(e.x)) return this.curve.point(null, null);
                    var t = this.y.redSub(e.y);
                    0 !== t.cmpn(0) && (t = t.redMul(this.x.redSub(e.x).redInvm()));
                    var r = t.redSqr().redISub(this.x).redISub(e.x), n = t.redMul(this.x.redSub(r)).redISub(this.y);
                    return this.curve.point(r, n);
                }, c.prototype.dbl = function() {
                    if (this.inf) return this;
                    var e = this.y.redAdd(this.y);
                    if (0 === e.cmpn(0)) return this.curve.point(null, null);
                    var t = this.curve.a, r = this.x.redSqr(), n = e.redInvm(), i = r.redAdd(r).redIAdd(r).redIAdd(t).redMul(n), s = i.redSqr().redISub(this.x.redAdd(this.x)), o = i.redMul(this.x.redSub(s)).redISub(this.y);
                    return this.curve.point(s, o);
                }, c.prototype.getX = function() {
                    return this.x.fromRed();
                }, c.prototype.getY = function() {
                    return this.y.fromRed();
                }, c.prototype.mul = function(e) {
                    return e = new i(e, 16), this.isInfinity() ? this : this._hasDoubles(e) ? this.curve._fixedNafMul(this, e) : this.curve.endo ? this.curve._endoWnafMulAdd([
                        this
                    ], [
                        e
                    ]) : this.curve._wnafMul(this, e);
                }, c.prototype.mulAdd = function(e, t, r) {
                    var n = [
                        this,
                        t
                    ], i = [
                        e,
                        r
                    ];
                    return this.curve.endo ? this.curve._endoWnafMulAdd(n, i) : this.curve._wnafMulAdd(1, n, i, 2);
                }, c.prototype.jmulAdd = function(e, t, r) {
                    var n = [
                        this,
                        t
                    ], i = [
                        e,
                        r
                    ];
                    return this.curve.endo ? this.curve._endoWnafMulAdd(n, i, !0) : this.curve._wnafMulAdd(1, n, i, 2, !0);
                }, c.prototype.eq = function(e) {
                    return this === e || this.inf === e.inf && (this.inf || 0 === this.x.cmp(e.x) && 0 === this.y.cmp(e.y));
                }, c.prototype.neg = function(e) {
                    if (this.inf) return this;
                    var t = this.curve.point(this.x, this.y.redNeg());
                    if (e && this.precomputed) {
                        var r = this.precomputed, n = function(e) {
                            return e.neg();
                        };
                        t.precomputed = {
                            naf: r.naf && {
                                wnd: r.naf.wnd,
                                points: r.naf.points.map(n)
                            },
                            doubles: r.doubles && {
                                step: r.doubles.step,
                                points: r.doubles.points.map(n)
                            }
                        };
                    }
                    return t;
                }, c.prototype.toJ = function() {
                    return this.inf ? this.curve.jpoint(null, null, null) : this.curve.jpoint(this.x, this.y, this.curve.one);
                }, s(u, o.BasePoint), l.prototype.jpoint = function(e, t, r) {
                    return new u(this, e, t, r);
                }, u.prototype.toP = function() {
                    if (this.isInfinity()) return this.curve.point(null, null);
                    var e = this.z.redInvm(), t = e.redSqr(), r = this.x.redMul(t), n = this.y.redMul(t).redMul(e);
                    return this.curve.point(r, n);
                }, u.prototype.neg = function() {
                    return this.curve.jpoint(this.x, this.y.redNeg(), this.z);
                }, u.prototype.add = function(e) {
                    if (this.isInfinity()) return e;
                    if (e.isInfinity()) return this;
                    var t = e.z.redSqr(), r = this.z.redSqr(), n = this.x.redMul(t), i = e.x.redMul(r), s = this.y.redMul(t.redMul(e.z)), o = e.y.redMul(r.redMul(this.z)), a = n.redSub(i), l = s.redSub(o);
                    if (0 === a.cmpn(0)) return 0 !== l.cmpn(0) ? this.curve.jpoint(null, null, null) : this.dbl();
                    var c = a.redSqr(), u = c.redMul(a), h = n.redMul(c), f = l.redSqr().redIAdd(u).redISub(h).redISub(h), d = l.redMul(h.redISub(f)).redISub(s.redMul(u)), p = this.z.redMul(e.z).redMul(a);
                    return this.curve.jpoint(f, d, p);
                }, u.prototype.mixedAdd = function(e) {
                    if (this.isInfinity()) return e.toJ();
                    if (e.isInfinity()) return this;
                    var t = this.z.redSqr(), r = this.x, n = e.x.redMul(t), i = this.y, s = e.y.redMul(t).redMul(this.z), o = r.redSub(n), a = i.redSub(s);
                    if (0 === o.cmpn(0)) return 0 !== a.cmpn(0) ? this.curve.jpoint(null, null, null) : this.dbl();
                    var l = o.redSqr(), c = l.redMul(o), u = r.redMul(l), h = a.redSqr().redIAdd(c).redISub(u).redISub(u), f = a.redMul(u.redISub(h)).redISub(i.redMul(c)), d = this.z.redMul(o);
                    return this.curve.jpoint(h, f, d);
                }, u.prototype.dblp = function(e) {
                    if (0 === e) return this;
                    if (this.isInfinity()) return this;
                    if (!e) return this.dbl();
                    var t;
                    if (this.curve.zeroA || this.curve.threeA) {
                        var r = this;
                        for(t = 0; t < e; t++)r = r.dbl();
                        return r;
                    }
                    var n = this.curve.a, i = this.curve.tinv, s = this.x, o = this.y, a = this.z, l = a.redSqr().redSqr(), c = o.redAdd(o);
                    for(t = 0; t < e; t++){
                        var u = s.redSqr(), h = c.redSqr(), f = h.redSqr(), d = u.redAdd(u).redIAdd(u).redIAdd(n.redMul(l)), p = s.redMul(h), m = d.redSqr().redISub(p.redAdd(p)), b = p.redISub(m), g = d.redMul(b);
                        g = g.redIAdd(g).redISub(f);
                        var y = c.redMul(a);
                        t + 1 < e && (l = l.redMul(f)), s = m, a = y, c = g;
                    }
                    return this.curve.jpoint(s, c.redMul(i), a);
                }, u.prototype.dbl = function() {
                    return this.isInfinity() ? this : this.curve.zeroA ? this._zeroDbl() : this.curve.threeA ? this._threeDbl() : this._dbl();
                }, u.prototype._zeroDbl = function() {
                    var e, t, r;
                    if (this.zOne) {
                        var n = this.x.redSqr(), i = this.y.redSqr(), s = i.redSqr(), o = this.x.redAdd(i).redSqr().redISub(n).redISub(s);
                        o = o.redIAdd(o);
                        var a = n.redAdd(n).redIAdd(n), l = a.redSqr().redISub(o).redISub(o), c = s.redIAdd(s);
                        c = (c = c.redIAdd(c)).redIAdd(c), e = l, t = a.redMul(o.redISub(l)).redISub(c), r = this.y.redAdd(this.y);
                    } else {
                        var u = this.x.redSqr(), h = this.y.redSqr(), f = h.redSqr(), d = this.x.redAdd(h).redSqr().redISub(u).redISub(f);
                        d = d.redIAdd(d);
                        var p = u.redAdd(u).redIAdd(u), m = p.redSqr(), b = f.redIAdd(f);
                        b = (b = b.redIAdd(b)).redIAdd(b), e = m.redISub(d).redISub(d), t = p.redMul(d.redISub(e)).redISub(b), r = (r = this.y.redMul(this.z)).redIAdd(r);
                    }
                    return this.curve.jpoint(e, t, r);
                }, u.prototype._threeDbl = function() {
                    var e, t, r;
                    if (this.zOne) {
                        var n = this.x.redSqr(), i = this.y.redSqr(), s = i.redSqr(), o = this.x.redAdd(i).redSqr().redISub(n).redISub(s);
                        o = o.redIAdd(o);
                        var a = n.redAdd(n).redIAdd(n).redIAdd(this.curve.a), l = a.redSqr().redISub(o).redISub(o);
                        e = l;
                        var c = s.redIAdd(s);
                        c = (c = c.redIAdd(c)).redIAdd(c), t = a.redMul(o.redISub(l)).redISub(c), r = this.y.redAdd(this.y);
                    } else {
                        var u = this.z.redSqr(), h = this.y.redSqr(), f = this.x.redMul(h), d = this.x.redSub(u).redMul(this.x.redAdd(u));
                        d = d.redAdd(d).redIAdd(d);
                        var p = f.redIAdd(f), m = (p = p.redIAdd(p)).redAdd(p);
                        e = d.redSqr().redISub(m), r = this.y.redAdd(this.z).redSqr().redISub(h).redISub(u);
                        var b = h.redSqr();
                        b = (b = (b = b.redIAdd(b)).redIAdd(b)).redIAdd(b), t = d.redMul(p.redISub(e)).redISub(b);
                    }
                    return this.curve.jpoint(e, t, r);
                }, u.prototype._dbl = function() {
                    var e = this.curve.a, t = this.x, r = this.y, n = this.z, i = n.redSqr().redSqr(), s = t.redSqr(), o = r.redSqr(), a = s.redAdd(s).redIAdd(s).redIAdd(e.redMul(i)), l = t.redAdd(t), c = (l = l.redIAdd(l)).redMul(o), u = a.redSqr().redISub(c.redAdd(c)), h = c.redISub(u), f = o.redSqr();
                    f = (f = (f = f.redIAdd(f)).redIAdd(f)).redIAdd(f);
                    var d = a.redMul(h).redISub(f), p = r.redAdd(r).redMul(n);
                    return this.curve.jpoint(u, d, p);
                }, u.prototype.trpl = function() {
                    if (!this.curve.zeroA) return this.dbl().add(this);
                    var e = this.x.redSqr(), t = this.y.redSqr(), r = this.z.redSqr(), n = t.redSqr(), i = e.redAdd(e).redIAdd(e), s = i.redSqr(), o = this.x.redAdd(t).redSqr().redISub(e).redISub(n), a = (o = (o = (o = o.redIAdd(o)).redAdd(o).redIAdd(o)).redISub(s)).redSqr(), l = n.redIAdd(n);
                    l = (l = (l = l.redIAdd(l)).redIAdd(l)).redIAdd(l);
                    var c = i.redIAdd(o).redSqr().redISub(s).redISub(a).redISub(l), u = t.redMul(c);
                    u = (u = u.redIAdd(u)).redIAdd(u);
                    var h = this.x.redMul(a).redISub(u);
                    h = (h = h.redIAdd(h)).redIAdd(h);
                    var f = this.y.redMul(c.redMul(l.redISub(c)).redISub(o.redMul(a)));
                    f = (f = (f = f.redIAdd(f)).redIAdd(f)).redIAdd(f);
                    var d = this.z.redAdd(o).redSqr().redISub(r).redISub(a);
                    return this.curve.jpoint(h, f, d);
                }, u.prototype.mul = function(e, t) {
                    return e = new i(e, t), this.curve._wnafMul(this, e);
                }, u.prototype.eq = function(e) {
                    if ("affine" === e.type) return this.eq(e.toJ());
                    if (this === e) return !0;
                    var t = this.z.redSqr(), r = e.z.redSqr();
                    if (0 !== this.x.redMul(r).redISub(e.x.redMul(t)).cmpn(0)) return !1;
                    var n = t.redMul(this.z), i = r.redMul(e.z);
                    return 0 === this.y.redMul(i).redISub(e.y.redMul(n)).cmpn(0);
                }, u.prototype.eqXToP = function(e) {
                    var t = this.z.redSqr(), r = e.toRed(this.curve.red).redMul(t);
                    if (0 === this.x.cmp(r)) return !0;
                    for(var n = e.clone(), i = this.curve.redN.redMul(t);;){
                        if (n.iadd(this.curve.n), n.cmp(this.curve.p) >= 0) return !1;
                        if (r.redIAdd(i), 0 === this.x.cmp(r)) return !0;
                    }
                }, u.prototype.inspect = function() {
                    return this.isInfinity() ? "<EC JPoint Infinity>" : "<EC JPoint x: " + this.x.toString(16, 2) + " y: " + this.y.toString(16, 2) + " z: " + this.z.toString(16, 2) + ">";
                }, u.prototype.isInfinity = function() {
                    return 0 === this.z.cmpn(0);
                };
            },
            {
                "../utils": 419,
                "./base": 406,
                "bn.js": 420,
                inherits: 440
            }
        ],
        411: [
            function(e, t, r) {
                "use strict";
                var n, i = r, s = e("hash.js"), o = e("./curve"), a = e("./utils").assert;
                function l(e) {
                    "short" === e.type ? this.curve = new o.short(e) : "edwards" === e.type ? this.curve = new o.edwards(e) : this.curve = new o.mont(e), this.g = this.curve.g, this.n = this.curve.n, this.hash = e.hash, a(this.g.validate(), "Invalid curve"), a(this.g.mul(this.n).isInfinity(), "Invalid curve, G*N != O");
                }
                function c(e, t) {
                    Object.defineProperty(i, e, {
                        configurable: !0,
                        enumerable: !0,
                        get: function() {
                            var r = new l(t);
                            return Object.defineProperty(i, e, {
                                configurable: !0,
                                enumerable: !0,
                                value: r
                            }), r;
                        }
                    });
                }
                i.PresetCurve = l, c("p192", {
                    type: "short",
                    prime: "p192",
                    p: "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff",
                    a: "ffffffff ffffffff ffffffff fffffffe ffffffff fffffffc",
                    b: "64210519 e59c80e7 0fa7e9ab 72243049 feb8deec c146b9b1",
                    n: "ffffffff ffffffff ffffffff 99def836 146bc9b1 b4d22831",
                    hash: s.sha256,
                    gRed: !1,
                    g: [
                        "188da80e b03090f6 7cbf20eb 43a18800 f4ff0afd 82ff1012",
                        "07192b95 ffc8da78 631011ed 6b24cdd5 73f977a1 1e794811"
                    ]
                }), c("p224", {
                    type: "short",
                    prime: "p224",
                    p: "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001",
                    a: "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff fffffffe",
                    b: "b4050a85 0c04b3ab f5413256 5044b0b7 d7bfd8ba 270b3943 2355ffb4",
                    n: "ffffffff ffffffff ffffffff ffff16a2 e0b8f03e 13dd2945 5c5c2a3d",
                    hash: s.sha256,
                    gRed: !1,
                    g: [
                        "b70e0cbd 6bb4bf7f 321390b9 4a03c1d3 56c21122 343280d6 115c1d21",
                        "bd376388 b5f723fb 4c22dfe6 cd4375a0 5a074764 44d58199 85007e34"
                    ]
                }), c("p256", {
                    type: "short",
                    prime: null,
                    p: "ffffffff 00000001 00000000 00000000 00000000 ffffffff ffffffff ffffffff",
                    a: "ffffffff 00000001 00000000 00000000 00000000 ffffffff ffffffff fffffffc",
                    b: "5ac635d8 aa3a93e7 b3ebbd55 769886bc 651d06b0 cc53b0f6 3bce3c3e 27d2604b",
                    n: "ffffffff 00000000 ffffffff ffffffff bce6faad a7179e84 f3b9cac2 fc632551",
                    hash: s.sha256,
                    gRed: !1,
                    g: [
                        "6b17d1f2 e12c4247 f8bce6e5 63a440f2 77037d81 2deb33a0 f4a13945 d898c296",
                        "4fe342e2 fe1a7f9b 8ee7eb4a 7c0f9e16 2bce3357 6b315ece cbb64068 37bf51f5"
                    ]
                }), c("p384", {
                    type: "short",
                    prime: null,
                    p: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe ffffffff 00000000 00000000 ffffffff",
                    a: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe ffffffff 00000000 00000000 fffffffc",
                    b: "b3312fa7 e23ee7e4 988e056b e3f82d19 181d9c6e fe814112 0314088f 5013875a c656398d 8a2ed19d 2a85c8ed d3ec2aef",
                    n: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff c7634d81 f4372ddf 581a0db2 48b0a77a ecec196a ccc52973",
                    hash: s.sha384,
                    gRed: !1,
                    g: [
                        "aa87ca22 be8b0537 8eb1c71e f320ad74 6e1d3b62 8ba79b98 59f741e0 82542a38 5502f25d bf55296c 3a545e38 72760ab7",
                        "3617de4a 96262c6f 5d9e98bf 9292dc29 f8f41dbd 289a147c e9da3113 b5f0b8c0 0a60b1ce 1d7e819d 7a431d7c 90ea0e5f"
                    ]
                }), c("p521", {
                    type: "short",
                    prime: null,
                    p: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff",
                    a: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffc",
                    b: "00000051 953eb961 8e1c9a1f 929a21a0 b68540ee a2da725b 99b315f3 b8b48991 8ef109e1 56193951 ec7e937b 1652c0bd 3bb1bf07 3573df88 3d2c34f1 ef451fd4 6b503f00",
                    n: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffa 51868783 bf2f966b 7fcc0148 f709a5d0 3bb5c9b8 899c47ae bb6fb71e 91386409",
                    hash: s.sha512,
                    gRed: !1,
                    g: [
                        "000000c6 858e06b7 0404e9cd 9e3ecb66 2395b442 9c648139 053fb521 f828af60 6b4d3dba a14b5e77 efe75928 fe1dc127 a2ffa8de 3348b3c1 856a429b f97e7e31 c2e5bd66",
                        "00000118 39296a78 9a3bc004 5c8a5fb4 2c7d1bd9 98f54449 579b4468 17afbd17 273e662c 97ee7299 5ef42640 c550b901 3fad0761 353c7086 a272c240 88be9476 9fd16650"
                    ]
                }), c("curve25519", {
                    type: "mont",
                    prime: "p25519",
                    p: "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed",
                    a: "76d06",
                    b: "1",
                    n: "1000000000000000 0000000000000000 14def9dea2f79cd6 5812631a5cf5d3ed",
                    hash: s.sha256,
                    gRed: !1,
                    g: [
                        "9"
                    ]
                }), c("ed25519", {
                    type: "edwards",
                    prime: "p25519",
                    p: "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed",
                    a: "-1",
                    c: "1",
                    d: "52036cee2b6ffe73 8cc740797779e898 00700a4d4141d8ab 75eb4dca135978a3",
                    n: "1000000000000000 0000000000000000 14def9dea2f79cd6 5812631a5cf5d3ed",
                    hash: s.sha256,
                    gRed: !1,
                    g: [
                        "216936d3cd6e53fec0a4e231fdd6dc5c692cc7609525a7b2c9562d608f25d51a",
                        "6666666666666666666666666666666666666666666666666666666666666658"
                    ]
                });
                try {
                    n = e("./precomputed/secp256k1");
                } catch (e) {
                    n = void 0;
                }
                c("secp256k1", {
                    type: "short",
                    prime: "k256",
                    p: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f",
                    a: "0",
                    b: "7",
                    n: "ffffffff ffffffff ffffffff fffffffe baaedce6 af48a03b bfd25e8c d0364141",
                    h: "1",
                    hash: s.sha256,
                    beta: "7ae96a2b657c07106e64479eac3434e99cf0497512f58995c1396c28719501ee",
                    lambda: "5363ad4cc05c30e0a5261c028812645a122e22ea20816678df02967c1b23bd72",
                    basis: [
                        {
                            a: "3086d221a7d46bcde86c90e49284eb15",
                            b: "-e4437ed6010e88286f547fa90abfe4c3"
                        },
                        {
                            a: "114ca50f7a8e2f3f657c1108d9d44cfd8",
                            b: "3086d221a7d46bcde86c90e49284eb15"
                        }
                    ],
                    gRed: !1,
                    g: [
                        "79be667ef9dcbbac55a06295ce870b07029bfcdb2dce28d959f2815b16f81798",
                        "483ada7726a3c4655da4fbfc0e1108a8fd17b448a68554199c47d08ffb10d4b8",
                        n
                    ]
                });
            },
            {
                "./curve": 408,
                "./precomputed/secp256k1": 418,
                "./utils": 419,
                "hash.js": 426
            }
        ],
        412: [
            function(e, t, r) {
                "use strict";
                var n = e("bn.js"), i = e("hmac-drbg"), s = e("../utils"), o = e("../curves"), a = e("brorand"), l = s.assert, c = e("./key"), u = e("./signature");
                function h(e) {
                    if (!(this instanceof h)) return new h(e);
                    "string" == typeof e && (l(Object.prototype.hasOwnProperty.call(o, e), "Unknown curve " + e), e = o[e]), e instanceof o.PresetCurve && (e = {
                        curve: e
                    }), this.curve = e.curve.curve, this.n = this.curve.n, this.nh = this.n.ushrn(1), this.g = this.curve.g, this.g = e.curve.g, this.g.precompute(e.curve.n.bitLength() + 1), this.hash = e.hash || e.curve.hash;
                }
                t.exports = h, h.prototype.keyPair = function(e) {
                    return new c(this, e);
                }, h.prototype.keyFromPrivate = function(e, t) {
                    return c.fromPrivate(this, e, t);
                }, h.prototype.keyFromPublic = function(e, t) {
                    return c.fromPublic(this, e, t);
                }, h.prototype.genKeyPair = function(e) {
                    e || (e = {});
                    for(var t = new i({
                        hash: this.hash,
                        pers: e.pers,
                        persEnc: e.persEnc || "utf8",
                        entropy: e.entropy || a(this.hash.hmacStrength),
                        entropyEnc: e.entropy && e.entropyEnc || "utf8",
                        nonce: this.n.toArray()
                    }), r = this.n.byteLength(), s = this.n.sub(new n(2));;){
                        var o = new n(t.generate(r));
                        if (!(o.cmp(s) > 0)) return o.iaddn(1), this.keyFromPrivate(o);
                    }
                }, h.prototype._truncateToN = function(e, t) {
                    var r = 8 * e.byteLength() - this.n.bitLength();
                    return r > 0 && (e = e.ushrn(r)), !t && e.cmp(this.n) >= 0 ? e.sub(this.n) : e;
                }, h.prototype.sign = function(e, t, r, s) {
                    "object" == typeof r && (s = r, r = null), s || (s = {}), t = this.keyFromPrivate(t, r), e = this._truncateToN(new n(e, 16));
                    for(var o = this.n.byteLength(), a = t.getPrivate().toArray("be", o), l = e.toArray("be", o), c = new i({
                        hash: this.hash,
                        entropy: a,
                        nonce: l,
                        pers: s.pers,
                        persEnc: s.persEnc || "utf8"
                    }), h = this.n.sub(new n(1)), f = 0;; f++){
                        var d = s.k ? s.k(f) : new n(c.generate(this.n.byteLength()));
                        if (!((d = this._truncateToN(d, !0)).cmpn(1) <= 0 || d.cmp(h) >= 0)) {
                            var p = this.g.mul(d);
                            if (!p.isInfinity()) {
                                var m = p.getX(), b = m.umod(this.n);
                                if (0 !== b.cmpn(0)) {
                                    var g = d.invm(this.n).mul(b.mul(t.getPrivate()).iadd(e));
                                    if (0 !== (g = g.umod(this.n)).cmpn(0)) {
                                        var y = (p.getY().isOdd() ? 1 : 0) | (0 !== m.cmp(b) ? 2 : 0);
                                        return s.canonical && g.cmp(this.nh) > 0 && (g = this.n.sub(g), y ^= 1), new u({
                                            r: b,
                                            s: g,
                                            recoveryParam: y
                                        });
                                    }
                                }
                            }
                        }
                    }
                }, h.prototype.verify = function(e, t, r, i) {
                    e = this._truncateToN(new n(e, 16)), r = this.keyFromPublic(r, i);
                    var s = (t = new u(t, "hex")).r, o = t.s;
                    if (s.cmpn(1) < 0 || s.cmp(this.n) >= 0) return !1;
                    if (o.cmpn(1) < 0 || o.cmp(this.n) >= 0) return !1;
                    var a, l = o.invm(this.n), c = l.mul(e).umod(this.n), h = l.mul(s).umod(this.n);
                    return this.curve._maxwellTrick ? !(a = this.g.jmulAdd(c, r.getPublic(), h)).isInfinity() && a.eqXToP(s) : !(a = this.g.mulAdd(c, r.getPublic(), h)).isInfinity() && 0 === a.getX().umod(this.n).cmp(s);
                }, h.prototype.recoverPubKey = function(e, t, r, i) {
                    l((3 & r) === r, "The recovery param is more than two bits"), t = new u(t, i);
                    var s = this.n, o = new n(e), a = t.r, c = t.s, h = 1 & r, f = r >> 1;
                    if (a.cmp(this.curve.p.umod(this.curve.n)) >= 0 && f) throw new Error("Unable to find sencond key candinate");
                    a = f ? this.curve.pointFromX(a.add(this.curve.n), h) : this.curve.pointFromX(a, h);
                    var d = t.r.invm(s), p = s.sub(o).mul(d).umod(s), m = c.mul(d).umod(s);
                    return this.g.mulAdd(p, a, m);
                }, h.prototype.getKeyRecoveryParam = function(e, t, r, n) {
                    if (null !== (t = new u(t, n)).recoveryParam) return t.recoveryParam;
                    for(var i = 0; i < 4; i++){
                        var s;
                        try {
                            s = this.recoverPubKey(e, t, i);
                        } catch (e) {
                            continue;
                        }
                        if (s.eq(r)) return i;
                    }
                    throw new Error("Unable to find valid recovery factor");
                };
            },
            {
                "../curves": 411,
                "../utils": 419,
                "./key": 413,
                "./signature": 414,
                "bn.js": 420,
                brorand: 187,
                "hmac-drbg": 438
            }
        ],
        413: [
            function(e, t, r) {
                "use strict";
                var n = e("bn.js"), i = e("../utils").assert;
                function s(e, t) {
                    this.ec = e, this.priv = null, this.pub = null, t.priv && this._importPrivate(t.priv, t.privEnc), t.pub && this._importPublic(t.pub, t.pubEnc);
                }
                t.exports = s, s.fromPublic = function(e, t, r) {
                    return t instanceof s ? t : new s(e, {
                        pub: t,
                        pubEnc: r
                    });
                }, s.fromPrivate = function(e, t, r) {
                    return t instanceof s ? t : new s(e, {
                        priv: t,
                        privEnc: r
                    });
                }, s.prototype.validate = function() {
                    var e = this.getPublic();
                    return e.isInfinity() ? {
                        result: !1,
                        reason: "Invalid public key"
                    } : e.validate() ? e.mul(this.ec.curve.n).isInfinity() ? {
                        result: !0,
                        reason: null
                    } : {
                        result: !1,
                        reason: "Public key * N != O"
                    } : {
                        result: !1,
                        reason: "Public key is not a point"
                    };
                }, s.prototype.getPublic = function(e, t) {
                    return "string" == typeof e && (t = e, e = null), this.pub || (this.pub = this.ec.g.mul(this.priv)), t ? this.pub.encode(t, e) : this.pub;
                }, s.prototype.getPrivate = function(e) {
                    return "hex" === e ? this.priv.toString(16, 2) : this.priv;
                }, s.prototype._importPrivate = function(e, t) {
                    this.priv = new n(e, t || 16), this.priv = this.priv.umod(this.ec.curve.n);
                }, s.prototype._importPublic = function(e, t) {
                    if (e.x || e.y) return "mont" === this.ec.curve.type ? i(e.x, "Need x coordinate") : "short" !== this.ec.curve.type && "edwards" !== this.ec.curve.type || i(e.x && e.y, "Need both x and y coordinate"), void (this.pub = this.ec.curve.point(e.x, e.y));
                    this.pub = this.ec.curve.decodePoint(e, t);
                }, s.prototype.derive = function(e) {
                    return e.validate() || i(e.validate(), "public point not validated"), e.mul(this.priv).getX();
                }, s.prototype.sign = function(e, t, r) {
                    return this.ec.sign(e, this, t, r);
                }, s.prototype.verify = function(e, t) {
                    return this.ec.verify(e, t, this);
                }, s.prototype.inspect = function() {
                    return "<Key priv: " + (this.priv && this.priv.toString(16, 2)) + " pub: " + (this.pub && this.pub.inspect()) + " >";
                };
            },
            {
                "../utils": 419,
                "bn.js": 420
            }
        ],
        414: [
            function(e, t, r) {
                "use strict";
                var n = e("bn.js"), i = e("../utils"), s = i.assert;
                function o(e, t) {
                    if (e instanceof o) return e;
                    this._importDER(e, t) || (s(e.r && e.s, "Signature without r or s"), this.r = new n(e.r, 16), this.s = new n(e.s, 16), void 0 === e.recoveryParam ? this.recoveryParam = null : this.recoveryParam = e.recoveryParam);
                }
                function a() {
                    this.place = 0;
                }
                function l(e, t) {
                    var r = e[t.place++];
                    if (!(128 & r)) return r;
                    var n = 15 & r;
                    if (0 === n || n > 4) return !1;
                    for(var i = 0, s = 0, o = t.place; s < n; s++, o++)i <<= 8, i |= e[o], i >>>= 0;
                    return !(i <= 127) && (t.place = o, i);
                }
                function c(e) {
                    for(var t = 0, r = e.length - 1; !e[t] && !(128 & e[t + 1]) && t < r;)t++;
                    return 0 === t ? e : e.slice(t);
                }
                function u(e, t) {
                    if (t < 128) e.push(t);
                    else {
                        var r = 1 + (Math.log(t) / Math.LN2 >>> 3);
                        for(e.push(128 | r); --r;)e.push(t >>> (r << 3) & 255);
                        e.push(t);
                    }
                }
                t.exports = o, o.prototype._importDER = function(e, t) {
                    e = i.toArray(e, t);
                    var r = new a;
                    if (48 !== e[r.place++]) return !1;
                    var s = l(e, r);
                    if (!1 === s) return !1;
                    if (s + r.place !== e.length) return !1;
                    if (2 !== e[r.place++]) return !1;
                    var o = l(e, r);
                    if (!1 === o) return !1;
                    var c = e.slice(r.place, o + r.place);
                    if (r.place += o, 2 !== e[r.place++]) return !1;
                    var u = l(e, r);
                    if (!1 === u) return !1;
                    if (e.length !== u + r.place) return !1;
                    var h = e.slice(r.place, u + r.place);
                    if (0 === c[0]) {
                        if (!(128 & c[1])) return !1;
                        c = c.slice(1);
                    }
                    if (0 === h[0]) {
                        if (!(128 & h[1])) return !1;
                        h = h.slice(1);
                    }
                    return this.r = new n(c), this.s = new n(h), this.recoveryParam = null, !0;
                }, o.prototype.toDER = function(e) {
                    var t = this.r.toArray(), r = this.s.toArray();
                    for(128 & t[0] && (t = [
                        0
                    ].concat(t)), 128 & r[0] && (r = [
                        0
                    ].concat(r)), t = c(t), r = c(r); !(r[0] || 128 & r[1]);)r = r.slice(1);
                    var n = [
                        2
                    ];
                    u(n, t.length), (n = n.concat(t)).push(2), u(n, r.length);
                    var s = n.concat(r), o = [
                        48
                    ];
                    return u(o, s.length), o = o.concat(s), i.encode(o, e);
                };
            },
            {
                "../utils": 419,
                "bn.js": 420
            }
        ],
        415: [
            function(e, t, r) {
                "use strict";
                var n = e("hash.js"), i = e("../curves"), s = e("../utils"), o = s.assert, a = s.parseBytes, l = e("./key"), c = e("./signature");
                function u(e) {
                    if (o("ed25519" === e, "only tested with ed25519 so far"), !(this instanceof u)) return new u(e);
                    e = i[e].curve, this.curve = e, this.g = e.g, this.g.precompute(e.n.bitLength() + 1), this.pointClass = e.point().constructor, this.encodingLength = Math.ceil(e.n.bitLength() / 8), this.hash = n.sha512;
                }
                t.exports = u, u.prototype.sign = function(e, t) {
                    e = a(e);
                    var r = this.keyFromSecret(t), n = this.hashInt(r.messagePrefix(), e), i = this.g.mul(n), s = this.encodePoint(i), o = this.hashInt(s, r.pubBytes(), e).mul(r.priv()), l = n.add(o).umod(this.curve.n);
                    return this.makeSignature({
                        R: i,
                        S: l,
                        Rencoded: s
                    });
                }, u.prototype.verify = function(e, t, r) {
                    e = a(e), t = this.makeSignature(t);
                    var n = this.keyFromPublic(r), i = this.hashInt(t.Rencoded(), n.pubBytes(), e), s = this.g.mul(t.S());
                    return t.R().add(n.pub().mul(i)).eq(s);
                }, u.prototype.hashInt = function() {
                    for(var e = this.hash(), t = 0; t < arguments.length; t++)e.update(arguments[t]);
                    return s.intFromLE(e.digest()).umod(this.curve.n);
                }, u.prototype.keyFromPublic = function(e) {
                    return l.fromPublic(this, e);
                }, u.prototype.keyFromSecret = function(e) {
                    return l.fromSecret(this, e);
                }, u.prototype.makeSignature = function(e) {
                    return e instanceof c ? e : new c(this, e);
                }, u.prototype.encodePoint = function(e) {
                    var t = e.getY().toArray("le", this.encodingLength);
                    return t[this.encodingLength - 1] |= e.getX().isOdd() ? 128 : 0, t;
                }, u.prototype.decodePoint = function(e) {
                    var t = (e = s.parseBytes(e)).length - 1, r = e.slice(0, t).concat(-129 & e[t]), n = 0 != (128 & e[t]), i = s.intFromLE(r);
                    return this.curve.pointFromY(i, n);
                }, u.prototype.encodeInt = function(e) {
                    return e.toArray("le", this.encodingLength);
                }, u.prototype.decodeInt = function(e) {
                    return s.intFromLE(e);
                }, u.prototype.isPoint = function(e) {
                    return e instanceof this.pointClass;
                };
            },
            {
                "../curves": 411,
                "../utils": 419,
                "./key": 416,
                "./signature": 417,
                "hash.js": 426
            }
        ],
        416: [
            function(e, t, r) {
                "use strict";
                var n = e("../utils"), i = n.assert, s = n.parseBytes, o = n.cachedProperty;
                function a(e, t) {
                    this.eddsa = e, this._secret = s(t.secret), e.isPoint(t.pub) ? this._pub = t.pub : this._pubBytes = s(t.pub);
                }
                a.fromPublic = function(e, t) {
                    return t instanceof a ? t : new a(e, {
                        pub: t
                    });
                }, a.fromSecret = function(e, t) {
                    return t instanceof a ? t : new a(e, {
                        secret: t
                    });
                }, a.prototype.secret = function() {
                    return this._secret;
                }, o(a, "pubBytes", function() {
                    return this.eddsa.encodePoint(this.pub());
                }), o(a, "pub", function() {
                    return this._pubBytes ? this.eddsa.decodePoint(this._pubBytes) : this.eddsa.g.mul(this.priv());
                }), o(a, "privBytes", function() {
                    var e = this.eddsa, t = this.hash(), r = e.encodingLength - 1, n = t.slice(0, e.encodingLength);
                    return n[0] &= 248, n[r] &= 127, n[r] |= 64, n;
                }), o(a, "priv", function() {
                    return this.eddsa.decodeInt(this.privBytes());
                }), o(a, "hash", function() {
                    return this.eddsa.hash().update(this.secret()).digest();
                }), o(a, "messagePrefix", function() {
                    return this.hash().slice(this.eddsa.encodingLength);
                }), a.prototype.sign = function(e) {
                    return i(this._secret, "KeyPair can only verify"), this.eddsa.sign(e, this);
                }, a.prototype.verify = function(e, t) {
                    return this.eddsa.verify(e, t, this);
                }, a.prototype.getSecret = function(e) {
                    return i(this._secret, "KeyPair is public only"), n.encode(this.secret(), e);
                }, a.prototype.getPublic = function(e) {
                    return n.encode(this.pubBytes(), e);
                }, t.exports = a;
            },
            {
                "../utils": 419
            }
        ],
        417: [
            function(e, t, r) {
                "use strict";
                var n = e("bn.js"), i = e("../utils"), s = i.assert, o = i.cachedProperty, a = i.parseBytes;
                function l(e, t) {
                    this.eddsa = e, "object" != typeof t && (t = a(t)), Array.isArray(t) && (t = {
                        R: t.slice(0, e.encodingLength),
                        S: t.slice(e.encodingLength)
                    }), s(t.R && t.S, "Signature without R or S"), e.isPoint(t.R) && (this._R = t.R), t.S instanceof n && (this._S = t.S), this._Rencoded = Array.isArray(t.R) ? t.R : t.Rencoded, this._Sencoded = Array.isArray(t.S) ? t.S : t.Sencoded;
                }
                o(l, "S", function() {
                    return this.eddsa.decodeInt(this.Sencoded());
                }), o(l, "R", function() {
                    return this.eddsa.decodePoint(this.Rencoded());
                }), o(l, "Rencoded", function() {
                    return this.eddsa.encodePoint(this.R());
                }), o(l, "Sencoded", function() {
                    return this.eddsa.encodeInt(this.S());
                }), l.prototype.toBytes = function() {
                    return this.Rencoded().concat(this.Sencoded());
                }, l.prototype.toHex = function() {
                    return i.encode(this.toBytes(), "hex").toUpperCase();
                }, t.exports = l;
            },
            {
                "../utils": 419,
                "bn.js": 420
            }
        ],
        418: [
            function(e, t, r) {
                "use strict";
                t.exports = {
                    doubles: {
                        step: 4,
                        points: [
                            [
                                "e60fce93b59e9ec53011aabc21c23e97b2a31369b87a5ae9c44ee89e2a6dec0a",
                                "f7e3507399e595929db99f34f57937101296891e44d23f0be1f32cce69616821"
                            ],
                            [
                                "8282263212c609d9ea2a6e3e172de238d8c39cabd5ac1ca10646e23fd5f51508",
                                "11f8a8098557dfe45e8256e830b60ace62d613ac2f7b17bed31b6eaff6e26caf"
                            ],
                            [
                                "175e159f728b865a72f99cc6c6fc846de0b93833fd2222ed73fce5b551e5b739",
                                "d3506e0d9e3c79eba4ef97a51ff71f5eacb5955add24345c6efa6ffee9fed695"
                            ],
                            [
                                "363d90d447b00c9c99ceac05b6262ee053441c7e55552ffe526bad8f83ff4640",
                                "4e273adfc732221953b445397f3363145b9a89008199ecb62003c7f3bee9de9"
                            ],
                            [
                                "8b4b5f165df3c2be8c6244b5b745638843e4a781a15bcd1b69f79a55dffdf80c",
                                "4aad0a6f68d308b4b3fbd7813ab0da04f9e336546162ee56b3eff0c65fd4fd36"
                            ],
                            [
                                "723cbaa6e5db996d6bf771c00bd548c7b700dbffa6c0e77bcb6115925232fcda",
                                "96e867b5595cc498a921137488824d6e2660a0653779494801dc069d9eb39f5f"
                            ],
                            [
                                "eebfa4d493bebf98ba5feec812c2d3b50947961237a919839a533eca0e7dd7fa",
                                "5d9a8ca3970ef0f269ee7edaf178089d9ae4cdc3a711f712ddfd4fdae1de8999"
                            ],
                            [
                                "100f44da696e71672791d0a09b7bde459f1215a29b3c03bfefd7835b39a48db0",
                                "cdd9e13192a00b772ec8f3300c090666b7ff4a18ff5195ac0fbd5cd62bc65a09"
                            ],
                            [
                                "e1031be262c7ed1b1dc9227a4a04c017a77f8d4464f3b3852c8acde6e534fd2d",
                                "9d7061928940405e6bb6a4176597535af292dd419e1ced79a44f18f29456a00d"
                            ],
                            [
                                "feea6cae46d55b530ac2839f143bd7ec5cf8b266a41d6af52d5e688d9094696d",
                                "e57c6b6c97dce1bab06e4e12bf3ecd5c981c8957cc41442d3155debf18090088"
                            ],
                            [
                                "da67a91d91049cdcb367be4be6ffca3cfeed657d808583de33fa978bc1ec6cb1",
                                "9bacaa35481642bc41f463f7ec9780e5dec7adc508f740a17e9ea8e27a68be1d"
                            ],
                            [
                                "53904faa0b334cdda6e000935ef22151ec08d0f7bb11069f57545ccc1a37b7c0",
                                "5bc087d0bc80106d88c9eccac20d3c1c13999981e14434699dcb096b022771c8"
                            ],
                            [
                                "8e7bcd0bd35983a7719cca7764ca906779b53a043a9b8bcaeff959f43ad86047",
                                "10b7770b2a3da4b3940310420ca9514579e88e2e47fd68b3ea10047e8460372a"
                            ],
                            [
                                "385eed34c1cdff21e6d0818689b81bde71a7f4f18397e6690a841e1599c43862",
                                "283bebc3e8ea23f56701de19e9ebf4576b304eec2086dc8cc0458fe5542e5453"
                            ],
                            [
                                "6f9d9b803ecf191637c73a4413dfa180fddf84a5947fbc9c606ed86c3fac3a7",
                                "7c80c68e603059ba69b8e2a30e45c4d47ea4dd2f5c281002d86890603a842160"
                            ],
                            [
                                "3322d401243c4e2582a2147c104d6ecbf774d163db0f5e5313b7e0e742d0e6bd",
                                "56e70797e9664ef5bfb019bc4ddaf9b72805f63ea2873af624f3a2e96c28b2a0"
                            ],
                            [
                                "85672c7d2de0b7da2bd1770d89665868741b3f9af7643397721d74d28134ab83",
                                "7c481b9b5b43b2eb6374049bfa62c2e5e77f17fcc5298f44c8e3094f790313a6"
                            ],
                            [
                                "948bf809b1988a46b06c9f1919413b10f9226c60f668832ffd959af60c82a0a",
                                "53a562856dcb6646dc6b74c5d1c3418c6d4dff08c97cd2bed4cb7f88d8c8e589"
                            ],
                            [
                                "6260ce7f461801c34f067ce0f02873a8f1b0e44dfc69752accecd819f38fd8e8",
                                "bc2da82b6fa5b571a7f09049776a1ef7ecd292238051c198c1a84e95b2b4ae17"
                            ],
                            [
                                "e5037de0afc1d8d43d8348414bbf4103043ec8f575bfdc432953cc8d2037fa2d",
                                "4571534baa94d3b5f9f98d09fb990bddbd5f5b03ec481f10e0e5dc841d755bda"
                            ],
                            [
                                "e06372b0f4a207adf5ea905e8f1771b4e7e8dbd1c6a6c5b725866a0ae4fce725",
                                "7a908974bce18cfe12a27bb2ad5a488cd7484a7787104870b27034f94eee31dd"
                            ],
                            [
                                "213c7a715cd5d45358d0bbf9dc0ce02204b10bdde2a3f58540ad6908d0559754",
                                "4b6dad0b5ae462507013ad06245ba190bb4850f5f36a7eeddff2c27534b458f2"
                            ],
                            [
                                "4e7c272a7af4b34e8dbb9352a5419a87e2838c70adc62cddf0cc3a3b08fbd53c",
                                "17749c766c9d0b18e16fd09f6def681b530b9614bff7dd33e0b3941817dcaae6"
                            ],
                            [
                                "fea74e3dbe778b1b10f238ad61686aa5c76e3db2be43057632427e2840fb27b6",
                                "6e0568db9b0b13297cf674deccb6af93126b596b973f7b77701d3db7f23cb96f"
                            ],
                            [
                                "76e64113f677cf0e10a2570d599968d31544e179b760432952c02a4417bdde39",
                                "c90ddf8dee4e95cf577066d70681f0d35e2a33d2b56d2032b4b1752d1901ac01"
                            ],
                            [
                                "c738c56b03b2abe1e8281baa743f8f9a8f7cc643df26cbee3ab150242bcbb891",
                                "893fb578951ad2537f718f2eacbfbbbb82314eef7880cfe917e735d9699a84c3"
                            ],
                            [
                                "d895626548b65b81e264c7637c972877d1d72e5f3a925014372e9f6588f6c14b",
                                "febfaa38f2bc7eae728ec60818c340eb03428d632bb067e179363ed75d7d991f"
                            ],
                            [
                                "b8da94032a957518eb0f6433571e8761ceffc73693e84edd49150a564f676e03",
                                "2804dfa44805a1e4d7c99cc9762808b092cc584d95ff3b511488e4e74efdf6e7"
                            ],
                            [
                                "e80fea14441fb33a7d8adab9475d7fab2019effb5156a792f1a11778e3c0df5d",
                                "eed1de7f638e00771e89768ca3ca94472d155e80af322ea9fcb4291b6ac9ec78"
                            ],
                            [
                                "a301697bdfcd704313ba48e51d567543f2a182031efd6915ddc07bbcc4e16070",
                                "7370f91cfb67e4f5081809fa25d40f9b1735dbf7c0a11a130c0d1a041e177ea1"
                            ],
                            [
                                "90ad85b389d6b936463f9d0512678de208cc330b11307fffab7ac63e3fb04ed4",
                                "e507a3620a38261affdcbd9427222b839aefabe1582894d991d4d48cb6ef150"
                            ],
                            [
                                "8f68b9d2f63b5f339239c1ad981f162ee88c5678723ea3351b7b444c9ec4c0da",
                                "662a9f2dba063986de1d90c2b6be215dbbea2cfe95510bfdf23cbf79501fff82"
                            ],
                            [
                                "e4f3fb0176af85d65ff99ff9198c36091f48e86503681e3e6686fd5053231e11",
                                "1e63633ad0ef4f1c1661a6d0ea02b7286cc7e74ec951d1c9822c38576feb73bc"
                            ],
                            [
                                "8c00fa9b18ebf331eb961537a45a4266c7034f2f0d4e1d0716fb6eae20eae29e",
                                "efa47267fea521a1a9dc343a3736c974c2fadafa81e36c54e7d2a4c66702414b"
                            ],
                            [
                                "e7a26ce69dd4829f3e10cec0a9e98ed3143d084f308b92c0997fddfc60cb3e41",
                                "2a758e300fa7984b471b006a1aafbb18d0a6b2c0420e83e20e8a9421cf2cfd51"
                            ],
                            [
                                "b6459e0ee3662ec8d23540c223bcbdc571cbcb967d79424f3cf29eb3de6b80ef",
                                "67c876d06f3e06de1dadf16e5661db3c4b3ae6d48e35b2ff30bf0b61a71ba45"
                            ],
                            [
                                "d68a80c8280bb840793234aa118f06231d6f1fc67e73c5a5deda0f5b496943e8",
                                "db8ba9fff4b586d00c4b1f9177b0e28b5b0e7b8f7845295a294c84266b133120"
                            ],
                            [
                                "324aed7df65c804252dc0270907a30b09612aeb973449cea4095980fc28d3d5d",
                                "648a365774b61f2ff130c0c35aec1f4f19213b0c7e332843967224af96ab7c84"
                            ],
                            [
                                "4df9c14919cde61f6d51dfdbe5fee5dceec4143ba8d1ca888e8bd373fd054c96",
                                "35ec51092d8728050974c23a1d85d4b5d506cdc288490192ebac06cad10d5d"
                            ],
                            [
                                "9c3919a84a474870faed8a9c1cc66021523489054d7f0308cbfc99c8ac1f98cd",
                                "ddb84f0f4a4ddd57584f044bf260e641905326f76c64c8e6be7e5e03d4fc599d"
                            ],
                            [
                                "6057170b1dd12fdf8de05f281d8e06bb91e1493a8b91d4cc5a21382120a959e5",
                                "9a1af0b26a6a4807add9a2daf71df262465152bc3ee24c65e899be932385a2a8"
                            ],
                            [
                                "a576df8e23a08411421439a4518da31880cef0fba7d4df12b1a6973eecb94266",
                                "40a6bf20e76640b2c92b97afe58cd82c432e10a7f514d9f3ee8be11ae1b28ec8"
                            ],
                            [
                                "7778a78c28dec3e30a05fe9629de8c38bb30d1f5cf9a3a208f763889be58ad71",
                                "34626d9ab5a5b22ff7098e12f2ff580087b38411ff24ac563b513fc1fd9f43ac"
                            ],
                            [
                                "928955ee637a84463729fd30e7afd2ed5f96274e5ad7e5cb09eda9c06d903ac",
                                "c25621003d3f42a827b78a13093a95eeac3d26efa8a8d83fc5180e935bcd091f"
                            ],
                            [
                                "85d0fef3ec6db109399064f3a0e3b2855645b4a907ad354527aae75163d82751",
                                "1f03648413a38c0be29d496e582cf5663e8751e96877331582c237a24eb1f962"
                            ],
                            [
                                "ff2b0dce97eece97c1c9b6041798b85dfdfb6d8882da20308f5404824526087e",
                                "493d13fef524ba188af4c4dc54d07936c7b7ed6fb90e2ceb2c951e01f0c29907"
                            ],
                            [
                                "827fbbe4b1e880ea9ed2b2e6301b212b57f1ee148cd6dd28780e5e2cf856e241",
                                "c60f9c923c727b0b71bef2c67d1d12687ff7a63186903166d605b68baec293ec"
                            ],
                            [
                                "eaa649f21f51bdbae7be4ae34ce6e5217a58fdce7f47f9aa7f3b58fa2120e2b3",
                                "be3279ed5bbbb03ac69a80f89879aa5a01a6b965f13f7e59d47a5305ba5ad93d"
                            ],
                            [
                                "e4a42d43c5cf169d9391df6decf42ee541b6d8f0c9a137401e23632dda34d24f",
                                "4d9f92e716d1c73526fc99ccfb8ad34ce886eedfa8d8e4f13a7f7131deba9414"
                            ],
                            [
                                "1ec80fef360cbdd954160fadab352b6b92b53576a88fea4947173b9d4300bf19",
                                "aeefe93756b5340d2f3a4958a7abbf5e0146e77f6295a07b671cdc1cc107cefd"
                            ],
                            [
                                "146a778c04670c2f91b00af4680dfa8bce3490717d58ba889ddb5928366642be",
                                "b318e0ec3354028add669827f9d4b2870aaa971d2f7e5ed1d0b297483d83efd0"
                            ],
                            [
                                "fa50c0f61d22e5f07e3acebb1aa07b128d0012209a28b9776d76a8793180eef9",
                                "6b84c6922397eba9b72cd2872281a68a5e683293a57a213b38cd8d7d3f4f2811"
                            ],
                            [
                                "da1d61d0ca721a11b1a5bf6b7d88e8421a288ab5d5bba5220e53d32b5f067ec2",
                                "8157f55a7c99306c79c0766161c91e2966a73899d279b48a655fba0f1ad836f1"
                            ],
                            [
                                "a8e282ff0c9706907215ff98e8fd416615311de0446f1e062a73b0610d064e13",
                                "7f97355b8db81c09abfb7f3c5b2515888b679a3e50dd6bd6cef7c73111f4cc0c"
                            ],
                            [
                                "174a53b9c9a285872d39e56e6913cab15d59b1fa512508c022f382de8319497c",
                                "ccc9dc37abfc9c1657b4155f2c47f9e6646b3a1d8cb9854383da13ac079afa73"
                            ],
                            [
                                "959396981943785c3d3e57edf5018cdbe039e730e4918b3d884fdff09475b7ba",
                                "2e7e552888c331dd8ba0386a4b9cd6849c653f64c8709385e9b8abf87524f2fd"
                            ],
                            [
                                "d2a63a50ae401e56d645a1153b109a8fcca0a43d561fba2dbb51340c9d82b151",
                                "e82d86fb6443fcb7565aee58b2948220a70f750af484ca52d4142174dcf89405"
                            ],
                            [
                                "64587e2335471eb890ee7896d7cfdc866bacbdbd3839317b3436f9b45617e073",
                                "d99fcdd5bf6902e2ae96dd6447c299a185b90a39133aeab358299e5e9faf6589"
                            ],
                            [
                                "8481bde0e4e4d885b3a546d3e549de042f0aa6cea250e7fd358d6c86dd45e458",
                                "38ee7b8cba5404dd84a25bf39cecb2ca900a79c42b262e556d64b1b59779057e"
                            ],
                            [
                                "13464a57a78102aa62b6979ae817f4637ffcfed3c4b1ce30bcd6303f6caf666b",
                                "69be159004614580ef7e433453ccb0ca48f300a81d0942e13f495a907f6ecc27"
                            ],
                            [
                                "bc4a9df5b713fe2e9aef430bcc1dc97a0cd9ccede2f28588cada3a0d2d83f366",
                                "d3a81ca6e785c06383937adf4b798caa6e8a9fbfa547b16d758d666581f33c1"
                            ],
                            [
                                "8c28a97bf8298bc0d23d8c749452a32e694b65e30a9472a3954ab30fe5324caa",
                                "40a30463a3305193378fedf31f7cc0eb7ae784f0451cb9459e71dc73cbef9482"
                            ],
                            [
                                "8ea9666139527a8c1dd94ce4f071fd23c8b350c5a4bb33748c4ba111faccae0",
                                "620efabbc8ee2782e24e7c0cfb95c5d735b783be9cf0f8e955af34a30e62b945"
                            ],
                            [
                                "dd3625faef5ba06074669716bbd3788d89bdde815959968092f76cc4eb9a9787",
                                "7a188fa3520e30d461da2501045731ca941461982883395937f68d00c644a573"
                            ],
                            [
                                "f710d79d9eb962297e4f6232b40e8f7feb2bc63814614d692c12de752408221e",
                                "ea98e67232d3b3295d3b535532115ccac8612c721851617526ae47a9c77bfc82"
                            ]
                        ]
                    },
                    naf: {
                        wnd: 7,
                        points: [
                            [
                                "f9308a019258c31049344f85f89d5229b531c845836f99b08601f113bce036f9",
                                "388f7b0f632de8140fe337e62a37f3566500a99934c2231b6cb9fd7584b8e672"
                            ],
                            [
                                "2f8bde4d1a07209355b4a7250a5c5128e88b84bddc619ab7cba8d569b240efe4",
                                "d8ac222636e5e3d6d4dba9dda6c9c426f788271bab0d6840dca87d3aa6ac62d6"
                            ],
                            [
                                "5cbdf0646e5db4eaa398f365f2ea7a0e3d419b7e0330e39ce92bddedcac4f9bc",
                                "6aebca40ba255960a3178d6d861a54dba813d0b813fde7b5a5082628087264da"
                            ],
                            [
                                "acd484e2f0c7f65309ad178a9f559abde09796974c57e714c35f110dfc27ccbe",
                                "cc338921b0a7d9fd64380971763b61e9add888a4375f8e0f05cc262ac64f9c37"
                            ],
                            [
                                "774ae7f858a9411e5ef4246b70c65aac5649980be5c17891bbec17895da008cb",
                                "d984a032eb6b5e190243dd56d7b7b365372db1e2dff9d6a8301d74c9c953c61b"
                            ],
                            [
                                "f28773c2d975288bc7d1d205c3748651b075fbc6610e58cddeeddf8f19405aa8",
                                "ab0902e8d880a89758212eb65cdaf473a1a06da521fa91f29b5cb52db03ed81"
                            ],
                            [
                                "d7924d4f7d43ea965a465ae3095ff41131e5946f3c85f79e44adbcf8e27e080e",
                                "581e2872a86c72a683842ec228cc6defea40af2bd896d3a5c504dc9ff6a26b58"
                            ],
                            [
                                "defdea4cdb677750a420fee807eacf21eb9898ae79b9768766e4faa04a2d4a34",
                                "4211ab0694635168e997b0ead2a93daeced1f4a04a95c0f6cfb199f69e56eb77"
                            ],
                            [
                                "2b4ea0a797a443d293ef5cff444f4979f06acfebd7e86d277475656138385b6c",
                                "85e89bc037945d93b343083b5a1c86131a01f60c50269763b570c854e5c09b7a"
                            ],
                            [
                                "352bbf4a4cdd12564f93fa332ce333301d9ad40271f8107181340aef25be59d5",
                                "321eb4075348f534d59c18259dda3e1f4a1b3b2e71b1039c67bd3d8bcf81998c"
                            ],
                            [
                                "2fa2104d6b38d11b0230010559879124e42ab8dfeff5ff29dc9cdadd4ecacc3f",
                                "2de1068295dd865b64569335bd5dd80181d70ecfc882648423ba76b532b7d67"
                            ],
                            [
                                "9248279b09b4d68dab21a9b066edda83263c3d84e09572e269ca0cd7f5453714",
                                "73016f7bf234aade5d1aa71bdea2b1ff3fc0de2a887912ffe54a32ce97cb3402"
                            ],
                            [
                                "daed4f2be3a8bf278e70132fb0beb7522f570e144bf615c07e996d443dee8729",
                                "a69dce4a7d6c98e8d4a1aca87ef8d7003f83c230f3afa726ab40e52290be1c55"
                            ],
                            [
                                "c44d12c7065d812e8acf28d7cbb19f9011ecd9e9fdf281b0e6a3b5e87d22e7db",
                                "2119a460ce326cdc76c45926c982fdac0e106e861edf61c5a039063f0e0e6482"
                            ],
                            [
                                "6a245bf6dc698504c89a20cfded60853152b695336c28063b61c65cbd269e6b4",
                                "e022cf42c2bd4a708b3f5126f16a24ad8b33ba48d0423b6efd5e6348100d8a82"
                            ],
                            [
                                "1697ffa6fd9de627c077e3d2fe541084ce13300b0bec1146f95ae57f0d0bd6a5",
                                "b9c398f186806f5d27561506e4557433a2cf15009e498ae7adee9d63d01b2396"
                            ],
                            [
                                "605bdb019981718b986d0f07e834cb0d9deb8360ffb7f61df982345ef27a7479",
                                "2972d2de4f8d20681a78d93ec96fe23c26bfae84fb14db43b01e1e9056b8c49"
                            ],
                            [
                                "62d14dab4150bf497402fdc45a215e10dcb01c354959b10cfe31c7e9d87ff33d",
                                "80fc06bd8cc5b01098088a1950eed0db01aa132967ab472235f5642483b25eaf"
                            ],
                            [
                                "80c60ad0040f27dade5b4b06c408e56b2c50e9f56b9b8b425e555c2f86308b6f",
                                "1c38303f1cc5c30f26e66bad7fe72f70a65eed4cbe7024eb1aa01f56430bd57a"
                            ],
                            [
                                "7a9375ad6167ad54aa74c6348cc54d344cc5dc9487d847049d5eabb0fa03c8fb",
                                "d0e3fa9eca8726909559e0d79269046bdc59ea10c70ce2b02d499ec224dc7f7"
                            ],
                            [
                                "d528ecd9b696b54c907a9ed045447a79bb408ec39b68df504bb51f459bc3ffc9",
                                "eecf41253136e5f99966f21881fd656ebc4345405c520dbc063465b521409933"
                            ],
                            [
                                "49370a4b5f43412ea25f514e8ecdad05266115e4a7ecb1387231808f8b45963",
                                "758f3f41afd6ed428b3081b0512fd62a54c3f3afbb5b6764b653052a12949c9a"
                            ],
                            [
                                "77f230936ee88cbbd73df930d64702ef881d811e0e1498e2f1c13eb1fc345d74",
                                "958ef42a7886b6400a08266e9ba1b37896c95330d97077cbbe8eb3c7671c60d6"
                            ],
                            [
                                "f2dac991cc4ce4b9ea44887e5c7c0bce58c80074ab9d4dbaeb28531b7739f530",
                                "e0dedc9b3b2f8dad4da1f32dec2531df9eb5fbeb0598e4fd1a117dba703a3c37"
                            ],
                            [
                                "463b3d9f662621fb1b4be8fbbe2520125a216cdfc9dae3debcba4850c690d45b",
                                "5ed430d78c296c3543114306dd8622d7c622e27c970a1de31cb377b01af7307e"
                            ],
                            [
                                "f16f804244e46e2a09232d4aff3b59976b98fac14328a2d1a32496b49998f247",
                                "cedabd9b82203f7e13d206fcdf4e33d92a6c53c26e5cce26d6579962c4e31df6"
                            ],
                            [
                                "caf754272dc84563b0352b7a14311af55d245315ace27c65369e15f7151d41d1",
                                "cb474660ef35f5f2a41b643fa5e460575f4fa9b7962232a5c32f908318a04476"
                            ],
                            [
                                "2600ca4b282cb986f85d0f1709979d8b44a09c07cb86d7c124497bc86f082120",
                                "4119b88753c15bd6a693b03fcddbb45d5ac6be74ab5f0ef44b0be9475a7e4b40"
                            ],
                            [
                                "7635ca72d7e8432c338ec53cd12220bc01c48685e24f7dc8c602a7746998e435",
                                "91b649609489d613d1d5e590f78e6d74ecfc061d57048bad9e76f302c5b9c61"
                            ],
                            [
                                "754e3239f325570cdbbf4a87deee8a66b7f2b33479d468fbc1a50743bf56cc18",
                                "673fb86e5bda30fb3cd0ed304ea49a023ee33d0197a695d0c5d98093c536683"
                            ],
                            [
                                "e3e6bd1071a1e96aff57859c82d570f0330800661d1c952f9fe2694691d9b9e8",
                                "59c9e0bba394e76f40c0aa58379a3cb6a5a2283993e90c4167002af4920e37f5"
                            ],
                            [
                                "186b483d056a033826ae73d88f732985c4ccb1f32ba35f4b4cc47fdcf04aa6eb",
                                "3b952d32c67cf77e2e17446e204180ab21fb8090895138b4a4a797f86e80888b"
                            ],
                            [
                                "df9d70a6b9876ce544c98561f4be4f725442e6d2b737d9c91a8321724ce0963f",
                                "55eb2dafd84d6ccd5f862b785dc39d4ab157222720ef9da217b8c45cf2ba2417"
                            ],
                            [
                                "5edd5cc23c51e87a497ca815d5dce0f8ab52554f849ed8995de64c5f34ce7143",
                                "efae9c8dbc14130661e8cec030c89ad0c13c66c0d17a2905cdc706ab7399a868"
                            ],
                            [
                                "290798c2b6476830da12fe02287e9e777aa3fba1c355b17a722d362f84614fba",
                                "e38da76dcd440621988d00bcf79af25d5b29c094db2a23146d003afd41943e7a"
                            ],
                            [
                                "af3c423a95d9f5b3054754efa150ac39cd29552fe360257362dfdecef4053b45",
                                "f98a3fd831eb2b749a93b0e6f35cfb40c8cd5aa667a15581bc2feded498fd9c6"
                            ],
                            [
                                "766dbb24d134e745cccaa28c99bf274906bb66b26dcf98df8d2fed50d884249a",
                                "744b1152eacbe5e38dcc887980da38b897584a65fa06cedd2c924f97cbac5996"
                            ],
                            [
                                "59dbf46f8c94759ba21277c33784f41645f7b44f6c596a58ce92e666191abe3e",
                                "c534ad44175fbc300f4ea6ce648309a042ce739a7919798cd85e216c4a307f6e"
                            ],
                            [
                                "f13ada95103c4537305e691e74e9a4a8dd647e711a95e73cb62dc6018cfd87b8",
                                "e13817b44ee14de663bf4bc808341f326949e21a6a75c2570778419bdaf5733d"
                            ],
                            [
                                "7754b4fa0e8aced06d4167a2c59cca4cda1869c06ebadfb6488550015a88522c",
                                "30e93e864e669d82224b967c3020b8fa8d1e4e350b6cbcc537a48b57841163a2"
                            ],
                            [
                                "948dcadf5990e048aa3874d46abef9d701858f95de8041d2a6828c99e2262519",
                                "e491a42537f6e597d5d28a3224b1bc25df9154efbd2ef1d2cbba2cae5347d57e"
                            ],
                            [
                                "7962414450c76c1689c7b48f8202ec37fb224cf5ac0bfa1570328a8a3d7c77ab",
                                "100b610ec4ffb4760d5c1fc133ef6f6b12507a051f04ac5760afa5b29db83437"
                            ],
                            [
                                "3514087834964b54b15b160644d915485a16977225b8847bb0dd085137ec47ca",
                                "ef0afbb2056205448e1652c48e8127fc6039e77c15c2378b7e7d15a0de293311"
                            ],
                            [
                                "d3cc30ad6b483e4bc79ce2c9dd8bc54993e947eb8df787b442943d3f7b527eaf",
                                "8b378a22d827278d89c5e9be8f9508ae3c2ad46290358630afb34db04eede0a4"
                            ],
                            [
                                "1624d84780732860ce1c78fcbfefe08b2b29823db913f6493975ba0ff4847610",
                                "68651cf9b6da903e0914448c6cd9d4ca896878f5282be4c8cc06e2a404078575"
                            ],
                            [
                                "733ce80da955a8a26902c95633e62a985192474b5af207da6df7b4fd5fc61cd4",
                                "f5435a2bd2badf7d485a4d8b8db9fcce3e1ef8e0201e4578c54673bc1dc5ea1d"
                            ],
                            [
                                "15d9441254945064cf1a1c33bbd3b49f8966c5092171e699ef258dfab81c045c",
                                "d56eb30b69463e7234f5137b73b84177434800bacebfc685fc37bbe9efe4070d"
                            ],
                            [
                                "a1d0fcf2ec9de675b612136e5ce70d271c21417c9d2b8aaaac138599d0717940",
                                "edd77f50bcb5a3cab2e90737309667f2641462a54070f3d519212d39c197a629"
                            ],
                            [
                                "e22fbe15c0af8ccc5780c0735f84dbe9a790badee8245c06c7ca37331cb36980",
                                "a855babad5cd60c88b430a69f53a1a7a38289154964799be43d06d77d31da06"
                            ],
                            [
                                "311091dd9860e8e20ee13473c1155f5f69635e394704eaa74009452246cfa9b3",
                                "66db656f87d1f04fffd1f04788c06830871ec5a64feee685bd80f0b1286d8374"
                            ],
                            [
                                "34c1fd04d301be89b31c0442d3e6ac24883928b45a9340781867d4232ec2dbdf",
                                "9414685e97b1b5954bd46f730174136d57f1ceeb487443dc5321857ba73abee"
                            ],
                            [
                                "f219ea5d6b54701c1c14de5b557eb42a8d13f3abbcd08affcc2a5e6b049b8d63",
                                "4cb95957e83d40b0f73af4544cccf6b1f4b08d3c07b27fb8d8c2962a400766d1"
                            ],
                            [
                                "d7b8740f74a8fbaab1f683db8f45de26543a5490bca627087236912469a0b448",
                                "fa77968128d9c92ee1010f337ad4717eff15db5ed3c049b3411e0315eaa4593b"
                            ],
                            [
                                "32d31c222f8f6f0ef86f7c98d3a3335ead5bcd32abdd94289fe4d3091aa824bf",
                                "5f3032f5892156e39ccd3d7915b9e1da2e6dac9e6f26e961118d14b8462e1661"
                            ],
                            [
                                "7461f371914ab32671045a155d9831ea8793d77cd59592c4340f86cbc18347b5",
                                "8ec0ba238b96bec0cbdddcae0aa442542eee1ff50c986ea6b39847b3cc092ff6"
                            ],
                            [
                                "ee079adb1df1860074356a25aa38206a6d716b2c3e67453d287698bad7b2b2d6",
                                "8dc2412aafe3be5c4c5f37e0ecc5f9f6a446989af04c4e25ebaac479ec1c8c1e"
                            ],
                            [
                                "16ec93e447ec83f0467b18302ee620f7e65de331874c9dc72bfd8616ba9da6b5",
                                "5e4631150e62fb40d0e8c2a7ca5804a39d58186a50e497139626778e25b0674d"
                            ],
                            [
                                "eaa5f980c245f6f038978290afa70b6bd8855897f98b6aa485b96065d537bd99",
                                "f65f5d3e292c2e0819a528391c994624d784869d7e6ea67fb18041024edc07dc"
                            ],
                            [
                                "78c9407544ac132692ee1910a02439958ae04877151342ea96c4b6b35a49f51",
                                "f3e0319169eb9b85d5404795539a5e68fa1fbd583c064d2462b675f194a3ddb4"
                            ],
                            [
                                "494f4be219a1a77016dcd838431aea0001cdc8ae7a6fc688726578d9702857a5",
                                "42242a969283a5f339ba7f075e36ba2af925ce30d767ed6e55f4b031880d562c"
                            ],
                            [
                                "a598a8030da6d86c6bc7f2f5144ea549d28211ea58faa70ebf4c1e665c1fe9b5",
                                "204b5d6f84822c307e4b4a7140737aec23fc63b65b35f86a10026dbd2d864e6b"
                            ],
                            [
                                "c41916365abb2b5d09192f5f2dbeafec208f020f12570a184dbadc3e58595997",
                                "4f14351d0087efa49d245b328984989d5caf9450f34bfc0ed16e96b58fa9913"
                            ],
                            [
                                "841d6063a586fa475a724604da03bc5b92a2e0d2e0a36acfe4c73a5514742881",
                                "73867f59c0659e81904f9a1c7543698e62562d6744c169ce7a36de01a8d6154"
                            ],
                            [
                                "5e95bb399a6971d376026947f89bde2f282b33810928be4ded112ac4d70e20d5",
                                "39f23f366809085beebfc71181313775a99c9aed7d8ba38b161384c746012865"
                            ],
                            [
                                "36e4641a53948fd476c39f8a99fd974e5ec07564b5315d8bf99471bca0ef2f66",
                                "d2424b1b1abe4eb8164227b085c9aa9456ea13493fd563e06fd51cf5694c78fc"
                            ],
                            [
                                "336581ea7bfbbb290c191a2f507a41cf5643842170e914faeab27c2c579f726",
                                "ead12168595fe1be99252129b6e56b3391f7ab1410cd1e0ef3dcdcabd2fda224"
                            ],
                            [
                                "8ab89816dadfd6b6a1f2634fcf00ec8403781025ed6890c4849742706bd43ede",
                                "6fdcef09f2f6d0a044e654aef624136f503d459c3e89845858a47a9129cdd24e"
                            ],
                            [
                                "1e33f1a746c9c5778133344d9299fcaa20b0938e8acff2544bb40284b8c5fb94",
                                "60660257dd11b3aa9c8ed618d24edff2306d320f1d03010e33a7d2057f3b3b6"
                            ],
                            [
                                "85b7c1dcb3cec1b7ee7f30ded79dd20a0ed1f4cc18cbcfcfa410361fd8f08f31",
                                "3d98a9cdd026dd43f39048f25a8847f4fcafad1895d7a633c6fed3c35e999511"
                            ],
                            [
                                "29df9fbd8d9e46509275f4b125d6d45d7fbe9a3b878a7af872a2800661ac5f51",
                                "b4c4fe99c775a606e2d8862179139ffda61dc861c019e55cd2876eb2a27d84b"
                            ],
                            [
                                "a0b1cae06b0a847a3fea6e671aaf8adfdfe58ca2f768105c8082b2e449fce252",
                                "ae434102edde0958ec4b19d917a6a28e6b72da1834aff0e650f049503a296cf2"
                            ],
                            [
                                "4e8ceafb9b3e9a136dc7ff67e840295b499dfb3b2133e4ba113f2e4c0e121e5",
                                "cf2174118c8b6d7a4b48f6d534ce5c79422c086a63460502b827ce62a326683c"
                            ],
                            [
                                "d24a44e047e19b6f5afb81c7ca2f69080a5076689a010919f42725c2b789a33b",
                                "6fb8d5591b466f8fc63db50f1c0f1c69013f996887b8244d2cdec417afea8fa3"
                            ],
                            [
                                "ea01606a7a6c9cdd249fdfcfacb99584001edd28abbab77b5104e98e8e3b35d4",
                                "322af4908c7312b0cfbfe369f7a7b3cdb7d4494bc2823700cfd652188a3ea98d"
                            ],
                            [
                                "af8addbf2b661c8a6c6328655eb96651252007d8c5ea31be4ad196de8ce2131f",
                                "6749e67c029b85f52a034eafd096836b2520818680e26ac8f3dfbcdb71749700"
                            ],
                            [
                                "e3ae1974566ca06cc516d47e0fb165a674a3dabcfca15e722f0e3450f45889",
                                "2aeabe7e4531510116217f07bf4d07300de97e4874f81f533420a72eeb0bd6a4"
                            ],
                            [
                                "591ee355313d99721cf6993ffed1e3e301993ff3ed258802075ea8ced397e246",
                                "b0ea558a113c30bea60fc4775460c7901ff0b053d25ca2bdeee98f1a4be5d196"
                            ],
                            [
                                "11396d55fda54c49f19aa97318d8da61fa8584e47b084945077cf03255b52984",
                                "998c74a8cd45ac01289d5833a7beb4744ff536b01b257be4c5767bea93ea57a4"
                            ],
                            [
                                "3c5d2a1ba39c5a1790000738c9e0c40b8dcdfd5468754b6405540157e017aa7a",
                                "b2284279995a34e2f9d4de7396fc18b80f9b8b9fdd270f6661f79ca4c81bd257"
                            ],
                            [
                                "cc8704b8a60a0defa3a99a7299f2e9c3fbc395afb04ac078425ef8a1793cc030",
                                "bdd46039feed17881d1e0862db347f8cf395b74fc4bcdc4e940b74e3ac1f1b13"
                            ],
                            [
                                "c533e4f7ea8555aacd9777ac5cad29b97dd4defccc53ee7ea204119b2889b197",
                                "6f0a256bc5efdf429a2fb6242f1a43a2d9b925bb4a4b3a26bb8e0f45eb596096"
                            ],
                            [
                                "c14f8f2ccb27d6f109f6d08d03cc96a69ba8c34eec07bbcf566d48e33da6593",
                                "c359d6923bb398f7fd4473e16fe1c28475b740dd098075e6c0e8649113dc3a38"
                            ],
                            [
                                "a6cbc3046bc6a450bac24789fa17115a4c9739ed75f8f21ce441f72e0b90e6ef",
                                "21ae7f4680e889bb130619e2c0f95a360ceb573c70603139862afd617fa9b9f"
                            ],
                            [
                                "347d6d9a02c48927ebfb86c1359b1caf130a3c0267d11ce6344b39f99d43cc38",
                                "60ea7f61a353524d1c987f6ecec92f086d565ab687870cb12689ff1e31c74448"
                            ],
                            [
                                "da6545d2181db8d983f7dcb375ef5866d47c67b1bf31c8cf855ef7437b72656a",
                                "49b96715ab6878a79e78f07ce5680c5d6673051b4935bd897fea824b77dc208a"
                            ],
                            [
                                "c40747cc9d012cb1a13b8148309c6de7ec25d6945d657146b9d5994b8feb1111",
                                "5ca560753be2a12fc6de6caf2cb489565db936156b9514e1bb5e83037e0fa2d4"
                            ],
                            [
                                "4e42c8ec82c99798ccf3a610be870e78338c7f713348bd34c8203ef4037f3502",
                                "7571d74ee5e0fb92a7a8b33a07783341a5492144cc54bcc40a94473693606437"
                            ],
                            [
                                "3775ab7089bc6af823aba2e1af70b236d251cadb0c86743287522a1b3b0dedea",
                                "be52d107bcfa09d8bcb9736a828cfa7fac8db17bf7a76a2c42ad961409018cf7"
                            ],
                            [
                                "cee31cbf7e34ec379d94fb814d3d775ad954595d1314ba8846959e3e82f74e26",
                                "8fd64a14c06b589c26b947ae2bcf6bfa0149ef0be14ed4d80f448a01c43b1c6d"
                            ],
                            [
                                "b4f9eaea09b6917619f6ea6a4eb5464efddb58fd45b1ebefcdc1a01d08b47986",
                                "39e5c9925b5a54b07433a4f18c61726f8bb131c012ca542eb24a8ac07200682a"
                            ],
                            [
                                "d4263dfc3d2df923a0179a48966d30ce84e2515afc3dccc1b77907792ebcc60e",
                                "62dfaf07a0f78feb30e30d6295853ce189e127760ad6cf7fae164e122a208d54"
                            ],
                            [
                                "48457524820fa65a4f8d35eb6930857c0032acc0a4a2de422233eeda897612c4",
                                "25a748ab367979d98733c38a1fa1c2e7dc6cc07db2d60a9ae7a76aaa49bd0f77"
                            ],
                            [
                                "dfeeef1881101f2cb11644f3a2afdfc2045e19919152923f367a1767c11cceda",
                                "ecfb7056cf1de042f9420bab396793c0c390bde74b4bbdff16a83ae09a9a7517"
                            ],
                            [
                                "6d7ef6b17543f8373c573f44e1f389835d89bcbc6062ced36c82df83b8fae859",
                                "cd450ec335438986dfefa10c57fea9bcc521a0959b2d80bbf74b190dca712d10"
                            ],
                            [
                                "e75605d59102a5a2684500d3b991f2e3f3c88b93225547035af25af66e04541f",
                                "f5c54754a8f71ee540b9b48728473e314f729ac5308b06938360990e2bfad125"
                            ],
                            [
                                "eb98660f4c4dfaa06a2be453d5020bc99a0c2e60abe388457dd43fefb1ed620c",
                                "6cb9a8876d9cb8520609af3add26cd20a0a7cd8a9411131ce85f44100099223e"
                            ],
                            [
                                "13e87b027d8514d35939f2e6892b19922154596941888336dc3563e3b8dba942",
                                "fef5a3c68059a6dec5d624114bf1e91aac2b9da568d6abeb2570d55646b8adf1"
                            ],
                            [
                                "ee163026e9fd6fe017c38f06a5be6fc125424b371ce2708e7bf4491691e5764a",
                                "1acb250f255dd61c43d94ccc670d0f58f49ae3fa15b96623e5430da0ad6c62b2"
                            ],
                            [
                                "b268f5ef9ad51e4d78de3a750c2dc89b1e626d43505867999932e5db33af3d80",
                                "5f310d4b3c99b9ebb19f77d41c1dee018cf0d34fd4191614003e945a1216e423"
                            ],
                            [
                                "ff07f3118a9df035e9fad85eb6c7bfe42b02f01ca99ceea3bf7ffdba93c4750d",
                                "438136d603e858a3a5c440c38eccbaddc1d2942114e2eddd4740d098ced1f0d8"
                            ],
                            [
                                "8d8b9855c7c052a34146fd20ffb658bea4b9f69e0d825ebec16e8c3ce2b526a1",
                                "cdb559eedc2d79f926baf44fb84ea4d44bcf50fee51d7ceb30e2e7f463036758"
                            ],
                            [
                                "52db0b5384dfbf05bfa9d472d7ae26dfe4b851ceca91b1eba54263180da32b63",
                                "c3b997d050ee5d423ebaf66a6db9f57b3180c902875679de924b69d84a7b375"
                            ],
                            [
                                "e62f9490d3d51da6395efd24e80919cc7d0f29c3f3fa48c6fff543becbd43352",
                                "6d89ad7ba4876b0b22c2ca280c682862f342c8591f1daf5170e07bfd9ccafa7d"
                            ],
                            [
                                "7f30ea2476b399b4957509c88f77d0191afa2ff5cb7b14fd6d8e7d65aaab1193",
                                "ca5ef7d4b231c94c3b15389a5f6311e9daff7bb67b103e9880ef4bff637acaec"
                            ],
                            [
                                "5098ff1e1d9f14fb46a210fada6c903fef0fb7b4a1dd1d9ac60a0361800b7a00",
                                "9731141d81fc8f8084d37c6e7542006b3ee1b40d60dfe5362a5b132fd17ddc0"
                            ],
                            [
                                "32b78c7de9ee512a72895be6b9cbefa6e2f3c4ccce445c96b9f2c81e2778ad58",
                                "ee1849f513df71e32efc3896ee28260c73bb80547ae2275ba497237794c8753c"
                            ],
                            [
                                "e2cb74fddc8e9fbcd076eef2a7c72b0ce37d50f08269dfc074b581550547a4f7",
                                "d3aa2ed71c9dd2247a62df062736eb0baddea9e36122d2be8641abcb005cc4a4"
                            ],
                            [
                                "8438447566d4d7bedadc299496ab357426009a35f235cb141be0d99cd10ae3a8",
                                "c4e1020916980a4da5d01ac5e6ad330734ef0d7906631c4f2390426b2edd791f"
                            ],
                            [
                                "4162d488b89402039b584c6fc6c308870587d9c46f660b878ab65c82c711d67e",
                                "67163e903236289f776f22c25fb8a3afc1732f2b84b4e95dbda47ae5a0852649"
                            ],
                            [
                                "3fad3fa84caf0f34f0f89bfd2dcf54fc175d767aec3e50684f3ba4a4bf5f683d",
                                "cd1bc7cb6cc407bb2f0ca647c718a730cf71872e7d0d2a53fa20efcdfe61826"
                            ],
                            [
                                "674f2600a3007a00568c1a7ce05d0816c1fb84bf1370798f1c69532faeb1a86b",
                                "299d21f9413f33b3edf43b257004580b70db57da0b182259e09eecc69e0d38a5"
                            ],
                            [
                                "d32f4da54ade74abb81b815ad1fb3b263d82d6c692714bcff87d29bd5ee9f08f",
                                "f9429e738b8e53b968e99016c059707782e14f4535359d582fc416910b3eea87"
                            ],
                            [
                                "30e4e670435385556e593657135845d36fbb6931f72b08cb1ed954f1e3ce3ff6",
                                "462f9bce619898638499350113bbc9b10a878d35da70740dc695a559eb88db7b"
                            ],
                            [
                                "be2062003c51cc3004682904330e4dee7f3dcd10b01e580bf1971b04d4cad297",
                                "62188bc49d61e5428573d48a74e1c655b1c61090905682a0d5558ed72dccb9bc"
                            ],
                            [
                                "93144423ace3451ed29e0fb9ac2af211cb6e84a601df5993c419859fff5df04a",
                                "7c10dfb164c3425f5c71a3f9d7992038f1065224f72bb9d1d902a6d13037b47c"
                            ],
                            [
                                "b015f8044f5fcbdcf21ca26d6c34fb8197829205c7b7d2a7cb66418c157b112c",
                                "ab8c1e086d04e813744a655b2df8d5f83b3cdc6faa3088c1d3aea1454e3a1d5f"
                            ],
                            [
                                "d5e9e1da649d97d89e4868117a465a3a4f8a18de57a140d36b3f2af341a21b52",
                                "4cb04437f391ed73111a13cc1d4dd0db1693465c2240480d8955e8592f27447a"
                            ],
                            [
                                "d3ae41047dd7ca065dbf8ed77b992439983005cd72e16d6f996a5316d36966bb",
                                "bd1aeb21ad22ebb22a10f0303417c6d964f8cdd7df0aca614b10dc14d125ac46"
                            ],
                            [
                                "463e2763d885f958fc66cdd22800f0a487197d0a82e377b49f80af87c897b065",
                                "bfefacdb0e5d0fd7df3a311a94de062b26b80c61fbc97508b79992671ef7ca7f"
                            ],
                            [
                                "7985fdfd127c0567c6f53ec1bb63ec3158e597c40bfe747c83cddfc910641917",
                                "603c12daf3d9862ef2b25fe1de289aed24ed291e0ec6708703a5bd567f32ed03"
                            ],
                            [
                                "74a1ad6b5f76e39db2dd249410eac7f99e74c59cb83d2d0ed5ff1543da7703e9",
                                "cc6157ef18c9c63cd6193d83631bbea0093e0968942e8c33d5737fd790e0db08"
                            ],
                            [
                                "30682a50703375f602d416664ba19b7fc9bab42c72747463a71d0896b22f6da3",
                                "553e04f6b018b4fa6c8f39e7f311d3176290d0e0f19ca73f17714d9977a22ff8"
                            ],
                            [
                                "9e2158f0d7c0d5f26c3791efefa79597654e7a2b2464f52b1ee6c1347769ef57",
                                "712fcdd1b9053f09003a3481fa7762e9ffd7c8ef35a38509e2fbf2629008373"
                            ],
                            [
                                "176e26989a43c9cfeba4029c202538c28172e566e3c4fce7322857f3be327d66",
                                "ed8cc9d04b29eb877d270b4878dc43c19aefd31f4eee09ee7b47834c1fa4b1c3"
                            ],
                            [
                                "75d46efea3771e6e68abb89a13ad747ecf1892393dfc4f1b7004788c50374da8",
                                "9852390a99507679fd0b86fd2b39a868d7efc22151346e1a3ca4726586a6bed8"
                            ],
                            [
                                "809a20c67d64900ffb698c4c825f6d5f2310fb0451c869345b7319f645605721",
                                "9e994980d9917e22b76b061927fa04143d096ccc54963e6a5ebfa5f3f8e286c1"
                            ],
                            [
                                "1b38903a43f7f114ed4500b4eac7083fdefece1cf29c63528d563446f972c180",
                                "4036edc931a60ae889353f77fd53de4a2708b26b6f5da72ad3394119daf408f9"
                            ]
                        ]
                    }
                };
            },
            {}
        ],
        419: [
            function(e, t, r) {
                "use strict";
                var n = r, i = e("bn.js"), s = e("minimalistic-assert"), o = e("minimalistic-crypto-utils");
                n.assert = s, n.toArray = o.toArray, n.zero2 = o.zero2, n.toHex = o.toHex, n.encode = o.encode, n.getNAF = function(e, t, r) {
                    var n = new Array(Math.max(e.bitLength(), r) + 1);
                    n.fill(0);
                    for(var i = 1 << t + 1, s = e.clone(), o = 0; o < n.length; o++){
                        var a, l = s.andln(i - 1);
                        s.isOdd() ? (a = l > (i >> 1) - 1 ? (i >> 1) - l : l, s.isubn(a)) : a = 0, n[o] = a, s.iushrn(1);
                    }
                    return n;
                }, n.getJSF = function(e, t) {
                    var r = [
                        [],
                        []
                    ];
                    e = e.clone(), t = t.clone();
                    for(var n, i = 0, s = 0; e.cmpn(-i) > 0 || t.cmpn(-s) > 0;){
                        var o, a, l = e.andln(3) + i & 3, c = t.andln(3) + s & 3;
                        3 === l && (l = -1), 3 === c && (c = -1), o = 0 == (1 & l) ? 0 : 3 !== (n = e.andln(7) + i & 7) && 5 !== n || 2 !== c ? l : -l, r[0].push(o), a = 0 == (1 & c) ? 0 : 3 !== (n = t.andln(7) + s & 7) && 5 !== n || 2 !== l ? c : -c, r[1].push(a), 2 * i === o + 1 && (i = 1 - i), 2 * s === a + 1 && (s = 1 - s), e.iushrn(1), t.iushrn(1);
                    }
                    return r;
                }, n.cachedProperty = function(e, t, r) {
                    var n = "_" + t;
                    e.prototype[t] = function() {
                        return void 0 !== this[n] ? this[n] : this[n] = r.call(this);
                    };
                }, n.parseBytes = function(e) {
                    return "string" == typeof e ? n.toArray(e, "hex") : e;
                }, n.intFromLE = function(e) {
                    return new i(e, "hex", "le");
                };
            },
            {
                "bn.js": 420,
                "minimalistic-assert": 453,
                "minimalistic-crypto-utils": 454
            }
        ],
        420: [
            function(e, t, r) {
                arguments[4][184][0].apply(r, arguments);
            },
            {
                buffer: 188,
                dup: 184
            }
        ],
        421: [
            function(e, t, r) {
                t.exports = {
                    name: "elliptic",
                    version: "6.5.4",
                    description: "EC cryptography",
                    main: "lib/elliptic.js",
                    files: [
                        "lib"
                    ],
                    scripts: {
                        lint: "eslint lib test",
                        "lint:fix": "npm run lint -- --fix",
                        unit: "istanbul test _mocha --reporter=spec test/index.js",
                        test: "npm run lint && npm run unit",
                        version: "grunt dist && git add dist/"
                    },
                    repository: {
                        type: "git",
                        url: "git@github.com:indutny/elliptic"
                    },
                    keywords: [
                        "EC",
                        "Elliptic",
                        "curve",
                        "Cryptography"
                    ],
                    author: "Fedor Indutny <fedor@indutny.com>",
                    license: "MIT",
                    bugs: {
                        url: "https://github.com/indutny/elliptic/issues"
                    },
                    homepage: "https://github.com/indutny/elliptic",
                    devDependencies: {
                        brfs: "^2.0.2",
                        coveralls: "^3.1.0",
                        eslint: "^7.6.0",
                        grunt: "^1.2.1",
                        "grunt-browserify": "^5.3.0",
                        "grunt-cli": "^1.3.2",
                        "grunt-contrib-connect": "^3.0.0",
                        "grunt-contrib-copy": "^1.0.0",
                        "grunt-contrib-uglify": "^5.0.0",
                        "grunt-mocha-istanbul": "^5.0.2",
                        "grunt-saucelabs": "^9.0.1",
                        istanbul: "^0.4.5",
                        mocha: "^8.0.1"
                    },
                    dependencies: {
                        "bn.js": "^4.11.9",
                        brorand: "^1.1.0",
                        "hash.js": "^1.0.0",
                        "hmac-drbg": "^1.0.1",
                        inherits: "^2.0.4",
                        "minimalistic-assert": "^1.0.1",
                        "minimalistic-crypto-utils": "^1.0.1"
                    }
                };
            },
            {}
        ],
        422: [
            function(e, t, r) {
                "use strict";
                var n = Object.create || function(e) {
                    var t = function() {};
                    return t.prototype = e, new t;
                }, i = Object.keys || function(e) {
                    var t = [];
                    for(var r in e)Object.prototype.hasOwnProperty.call(e, r) && t.push(r);
                    return r;
                }, s = Function.prototype.bind || function(e) {
                    var t = this;
                    return function() {
                        return t.apply(e, arguments);
                    };
                };
                function o() {
                    this._events && Object.prototype.hasOwnProperty.call(this, "_events") || (this._events = n(null), this._eventsCount = 0), this._maxListeners = this._maxListeners || void 0;
                }
                t.exports = o, o.EventEmitter = o, o.prototype._events = void 0, o.prototype._maxListeners = void 0;
                var a, l = 10;
                try {
                    var c = {};
                    Object.defineProperty && Object.defineProperty(c, "x", {
                        value: 0
                    }), a = 0 === c.x;
                } catch (e) {
                    a = !1;
                }
                function u(e) {
                    return void 0 === e._maxListeners ? o.defaultMaxListeners : e._maxListeners;
                }
                function h(e, t, r) {
                    if (t) e.call(r);
                    else for(var n = e.length, i = _(e, n), s = 0; s < n; ++s)i[s].call(r);
                }
                function f(e, t, r, n) {
                    if (t) e.call(r, n);
                    else for(var i = e.length, s = _(e, i), o = 0; o < i; ++o)s[o].call(r, n);
                }
                function d(e, t, r, n, i) {
                    if (t) e.call(r, n, i);
                    else for(var s = e.length, o = _(e, s), a = 0; a < s; ++a)o[a].call(r, n, i);
                }
                function p(e, t, r, n, i, s) {
                    if (t) e.call(r, n, i, s);
                    else for(var o = e.length, a = _(e, o), l = 0; l < o; ++l)a[l].call(r, n, i, s);
                }
                function m(e, t, r, n) {
                    if (t) e.apply(r, n);
                    else for(var i = e.length, s = _(e, i), o = 0; o < i; ++o)s[o].apply(r, n);
                }
                function b(e, t, r, i) {
                    var s, o, a;
                    if ("function" != typeof r) throw new TypeError('"listener" argument must be a function');
                    if ((o = e._events) ? (o.newListener && (e.emit("newListener", t, r.listener ? r.listener : r), o = e._events), a = o[t]) : (o = e._events = n(null), e._eventsCount = 0), a) {
                        if ("function" == typeof a ? a = o[t] = i ? [
                            r,
                            a
                        ] : [
                            a,
                            r
                        ] : i ? a.unshift(r) : a.push(r), !a.warned && (s = u(e)) && s > 0 && a.length > s) {
                            a.warned = !0;
                            var l = new Error("Possible EventEmitter memory leak detected. " + a.length + ' "' + String(t) + '" listeners added. Use emitter.setMaxListeners() to increase limit.');
                            l.name = "MaxListenersExceededWarning", l.emitter = e, l.type = t, l.count = a.length, "object" == typeof console && console.warn && console.warn("%s: %s", l.name, l.message);
                        }
                    } else a = o[t] = r, ++e._eventsCount;
                    return e;
                }
                function g() {
                    if (!this.fired) switch(this.target.removeListener(this.type, this.wrapFn), this.fired = !0, arguments.length){
                        case 0:
                            return this.listener.call(this.target);
                        case 1:
                            return this.listener.call(this.target, arguments[0]);
                        case 2:
                            return this.listener.call(this.target, arguments[0], arguments[1]);
                        case 3:
                            return this.listener.call(this.target, arguments[0], arguments[1], arguments[2]);
                        default:
                            for(var e = new Array(arguments.length), t = 0; t < e.length; ++t)e[t] = arguments[t];
                            this.listener.apply(this.target, e);
                    }
                }
                function y(e, t, r) {
                    var n = {
                        fired: !1,
                        wrapFn: void 0,
                        target: e,
                        type: t,
                        listener: r
                    }, i = s.call(g, n);
                    return i.listener = r, n.wrapFn = i, i;
                }
                function v(e, t, r) {
                    var n = e._events;
                    if (!n) return [];
                    var i = n[t];
                    return i ? "function" == typeof i ? r ? [
                        i.listener || i
                    ] : [
                        i
                    ] : r ? function(e) {
                        for(var t = new Array(e.length), r = 0; r < t.length; ++r)t[r] = e[r].listener || e[r];
                        return t;
                    }(i) : _(i, i.length) : [];
                }
                function w(e) {
                    var t = this._events;
                    if (t) {
                        var r = t[e];
                        if ("function" == typeof r) return 1;
                        if (r) return r.length;
                    }
                    return 0;
                }
                function _(e, t) {
                    for(var r = new Array(t), n = 0; n < t; ++n)r[n] = e[n];
                    return r;
                }
                a ? Object.defineProperty(o, "defaultMaxListeners", {
                    enumerable: !0,
                    get: function() {
                        return l;
                    },
                    set: function(e) {
                        if ("number" != typeof e || e < 0 || e != e) throw new TypeError('"defaultMaxListeners" must be a positive number');
                        l = e;
                    }
                }) : o.defaultMaxListeners = l, o.prototype.setMaxListeners = function(e) {
                    if ("number" != typeof e || e < 0 || isNaN(e)) throw new TypeError('"n" argument must be a positive number');
                    return this._maxListeners = e, this;
                }, o.prototype.getMaxListeners = function() {
                    return u(this);
                }, o.prototype.emit = function(e) {
                    var t, r, n, i, s, o, a = "error" === e;
                    if (o = this._events) a = a && null == o.error;
                    else if (!a) return !1;
                    if (a) {
                        if (arguments.length > 1 && (t = arguments[1]), t instanceof Error) throw t;
                        var l = new Error('Unhandled "error" event. (' + t + ")");
                        throw l.context = t, l;
                    }
                    if (!(r = o[e])) return !1;
                    var c = "function" == typeof r;
                    switch(n = arguments.length){
                        case 1:
                            h(r, c, this);
                            break;
                        case 2:
                            f(r, c, this, arguments[1]);
                            break;
                        case 3:
                            d(r, c, this, arguments[1], arguments[2]);
                            break;
                        case 4:
                            p(r, c, this, arguments[1], arguments[2], arguments[3]);
                            break;
                        default:
                            for(i = new Array(n - 1), s = 1; s < n; s++)i[s - 1] = arguments[s];
                            m(r, c, this, i);
                    }
                    return !0;
                }, o.prototype.addListener = function(e, t) {
                    return b(this, e, t, !1);
                }, o.prototype.on = o.prototype.addListener, o.prototype.prependListener = function(e, t) {
                    return b(this, e, t, !0);
                }, o.prototype.once = function(e, t) {
                    if ("function" != typeof t) throw new TypeError('"listener" argument must be a function');
                    return this.on(e, y(this, e, t)), this;
                }, o.prototype.prependOnceListener = function(e, t) {
                    if ("function" != typeof t) throw new TypeError('"listener" argument must be a function');
                    return this.prependListener(e, y(this, e, t)), this;
                }, o.prototype.removeListener = function(e, t) {
                    var r, i, s, o, a;
                    if ("function" != typeof t) throw new TypeError('"listener" argument must be a function');
                    if (!(i = this._events)) return this;
                    if (!(r = i[e])) return this;
                    if (r === t || r.listener === t) 0 == --this._eventsCount ? this._events = n(null) : (delete i[e], i.removeListener && this.emit("removeListener", e, r.listener || t));
                    else if ("function" != typeof r) {
                        for(s = -1, o = r.length - 1; o >= 0; o--)if (r[o] === t || r[o].listener === t) {
                            a = r[o].listener, s = o;
                            break;
                        }
                        if (s < 0) return this;
                        0 === s ? r.shift() : function(e, t) {
                            for(var r = t, n = r + 1, i = e.length; n < i; r += 1, n += 1)e[r] = e[n];
                            e.pop();
                        }(r, s), 1 === r.length && (i[e] = r[0]), i.removeListener && this.emit("removeListener", e, a || t);
                    }
                    return this;
                }, o.prototype.removeAllListeners = function(e) {
                    var t, r, s;
                    if (!(r = this._events)) return this;
                    if (!r.removeListener) return 0 === arguments.length ? (this._events = n(null), this._eventsCount = 0) : r[e] && (0 == --this._eventsCount ? this._events = n(null) : delete r[e]), this;
                    if (0 === arguments.length) {
                        var o, a = i(r);
                        for(s = 0; s < a.length; ++s)"removeListener" !== (o = a[s]) && this.removeAllListeners(o);
                        return this.removeAllListeners("removeListener"), this._events = n(null), this._eventsCount = 0, this;
                    }
                    if ("function" == typeof (t = r[e])) this.removeListener(e, t);
                    else if (t) for(s = t.length - 1; s >= 0; s--)this.removeListener(e, t[s]);
                    return this;
                }, o.prototype.listeners = function(e) {
                    return v(this, e, !0);
                }, o.prototype.rawListeners = function(e) {
                    return v(this, e, !1);
                }, o.listenerCount = function(e, t) {
                    return "function" == typeof e.listenerCount ? e.listenerCount(t) : w.call(e, t);
                }, o.prototype.listenerCount = w, o.prototype.eventNames = function() {
                    return this._eventsCount > 0 ? Reflect.ownKeys(this._events) : [];
                };
            },
            {}
        ],
        423: [
            function(e, t, r) {
                "use strict";
                var n = e("safe-buffer").Buffer, i = e("md5.js");
                t.exports = function(e, t, r, s) {
                    if (n.isBuffer(e) || (e = n.from(e, "binary")), t && (n.isBuffer(t) || (t = n.from(t, "binary")), 8 !== t.length)) throw new RangeError("salt should be Buffer with 8 byte length");
                    for(var o = r / 8, a = n.alloc(o), l = n.alloc(s || 0), c = n.alloc(0); o > 0 || s > 0;){
                        var u = new i;
                        u.update(c), u.update(e), t && u.update(t), c = u.digest();
                        var h = 0;
                        if (o > 0) {
                            var f = a.length - o;
                            h = Math.min(o, c.length), c.copy(a, f, 0, h), o -= h;
                        }
                        if (h < c.length && s > 0) {
                            var d = l.length - s, p = Math.min(s, c.length - h);
                            c.copy(l, d, h, h + p), s -= p;
                        }
                    }
                    return c.fill(0), {
                        key: a,
                        iv: l
                    };
                };
            },
            {
                "md5.js": 450,
                "safe-buffer": 494
            }
        ],
        424: [
            function(e, t, r) {
                "use strict";
                Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.CsvParserStream = r.ParserOptions = r.parseFile = r.parseStream = r.parseString = r.parse = r.FormatterOptions = r.CsvFormatterStream = r.writeToPath = r.writeToString = r.writeToBuffer = r.writeToStream = r.write = r.format = void 0;
                var n = e("@fast-csv/format");
                Object.defineProperty(r, "format", {
                    enumerable: !0,
                    get: function() {
                        return n.format;
                    }
                }), Object.defineProperty(r, "write", {
                    enumerable: !0,
                    get: function() {
                        return n.write;
                    }
                }), Object.defineProperty(r, "writeToStream", {
                    enumerable: !0,
                    get: function() {
                        return n.writeToStream;
                    }
                }), Object.defineProperty(r, "writeToBuffer", {
                    enumerable: !0,
                    get: function() {
                        return n.writeToBuffer;
                    }
                }), Object.defineProperty(r, "writeToString", {
                    enumerable: !0,
                    get: function() {
                        return n.writeToString;
                    }
                }), Object.defineProperty(r, "writeToPath", {
                    enumerable: !0,
                    get: function() {
                        return n.writeToPath;
                    }
                }), Object.defineProperty(r, "CsvFormatterStream", {
                    enumerable: !0,
                    get: function() {
                        return n.CsvFormatterStream;
                    }
                }), Object.defineProperty(r, "FormatterOptions", {
                    enumerable: !0,
                    get: function() {
                        return n.FormatterOptions;
                    }
                });
                var i = e("@fast-csv/parse");
                Object.defineProperty(r, "parse", {
                    enumerable: !0,
                    get: function() {
                        return i.parse;
                    }
                }), Object.defineProperty(r, "parseString", {
                    enumerable: !0,
                    get: function() {
                        return i.parseString;
                    }
                }), Object.defineProperty(r, "parseStream", {
                    enumerable: !0,
                    get: function() {
                        return i.parseStream;
                    }
                }), Object.defineProperty(r, "parseFile", {
                    enumerable: !0,
                    get: function() {
                        return i.parseFile;
                    }
                }), Object.defineProperty(r, "ParserOptions", {
                    enumerable: !0,
                    get: function() {
                        return i.ParserOptions;
                    }
                }), Object.defineProperty(r, "CsvParserStream", {
                    enumerable: !0,
                    get: function() {
                        return i.CsvParserStream;
                    }
                });
            },
            {
                "@fast-csv/format": 151,
                "@fast-csv/parse": 155
            }
        ],
        425: [
            function(e, t, r) {
                "use strict";
                var n = e("safe-buffer").Buffer, i = e("readable-stream").Transform;
                function s(e) {
                    i.call(this), this._block = n.allocUnsafe(e), this._blockSize = e, this._blockOffset = 0, this._length = [
                        0,
                        0,
                        0,
                        0
                    ], this._finalized = !1;
                }
                e("inherits")(s, i), s.prototype._transform = function(e, t, r) {
                    var n = null;
                    try {
                        this.update(e, t);
                    } catch (e) {
                        n = e;
                    }
                    r(n);
                }, s.prototype._flush = function(e) {
                    var t = null;
                    try {
                        this.push(this.digest());
                    } catch (e) {
                        t = e;
                    }
                    e(t);
                }, s.prototype.update = function(e, t) {
                    if (function(e, t) {
                        if (!n.isBuffer(e) && "string" != typeof e) throw new TypeError(t + " must be a string or a buffer");
                    }(e, "Data"), this._finalized) throw new Error("Digest already called");
                    n.isBuffer(e) || (e = n.from(e, t));
                    for(var r = this._block, i = 0; this._blockOffset + e.length - i >= this._blockSize;){
                        for(var s = this._blockOffset; s < this._blockSize;)r[s++] = e[i++];
                        this._update(), this._blockOffset = 0;
                    }
                    for(; i < e.length;)r[this._blockOffset++] = e[i++];
                    for(var o = 0, a = 8 * e.length; a > 0; ++o)this._length[o] += a, (a = this._length[o] / 4294967296 | 0) > 0 && (this._length[o] -= 4294967296 * a);
                    return this;
                }, s.prototype._update = function() {
                    throw new Error("_update is not implemented");
                }, s.prototype.digest = function(e) {
                    if (this._finalized) throw new Error("Digest already called");
                    this._finalized = !0;
                    var t = this._digest();
                    void 0 !== e && (t = t.toString(e)), this._block.fill(0), this._blockOffset = 0;
                    for(var r = 0; r < 4; ++r)this._length[r] = 0;
                    return t;
                }, s.prototype._digest = function() {
                    throw new Error("_digest is not implemented");
                }, t.exports = s;
            },
            {
                inherits: 440,
                "readable-stream": 491,
                "safe-buffer": 494
            }
        ],
        426: [
            function(e, t, r) {
                "use strict";
                var n = r;
                n.utils = e("./hash/utils"), n.common = e("./hash/common"), n.sha = e("./hash/sha"), n.ripemd = e("./hash/ripemd"), n.hmac = e("./hash/hmac"), n.sha1 = n.sha.sha1, n.sha256 = n.sha.sha256, n.sha224 = n.sha.sha224, n.sha384 = n.sha.sha384, n.sha512 = n.sha.sha512, n.ripemd160 = n.ripemd.ripemd160;
            },
            {
                "./hash/common": 427,
                "./hash/hmac": 428,
                "./hash/ripemd": 429,
                "./hash/sha": 430,
                "./hash/utils": 437
            }
        ],
        427: [
            function(e, t, r) {
                "use strict";
                var n = e("./utils"), i = e("minimalistic-assert");
                function s() {
                    this.pending = null, this.pendingTotal = 0, this.blockSize = this.constructor.blockSize, this.outSize = this.constructor.outSize, this.hmacStrength = this.constructor.hmacStrength, this.padLength = this.constructor.padLength / 8, this.endian = "big", this._delta8 = this.blockSize / 8, this._delta32 = this.blockSize / 32;
                }
                r.BlockHash = s, s.prototype.update = function(e, t) {
                    if (e = n.toArray(e, t), this.pending ? this.pending = this.pending.concat(e) : this.pending = e, this.pendingTotal += e.length, this.pending.length >= this._delta8) {
                        var r = (e = this.pending).length % this._delta8;
                        this.pending = e.slice(e.length - r, e.length), 0 === this.pending.length && (this.pending = null), e = n.join32(e, 0, e.length - r, this.endian);
                        for(var i = 0; i < e.length; i += this._delta32)this._update(e, i, i + this._delta32);
                    }
                    return this;
                }, s.prototype.digest = function(e) {
                    return this.update(this._pad()), i(null === this.pending), this._digest(e);
                }, s.prototype._pad = function() {
                    var e = this.pendingTotal, t = this._delta8, r = t - (e + this.padLength) % t, n = new Array(r + this.padLength);
                    n[0] = 128;
                    for(var i = 1; i < r; i++)n[i] = 0;
                    if (e <<= 3, "big" === this.endian) {
                        for(var s = 8; s < this.padLength; s++)n[i++] = 0;
                        n[i++] = 0, n[i++] = 0, n[i++] = 0, n[i++] = 0, n[i++] = e >>> 24 & 255, n[i++] = e >>> 16 & 255, n[i++] = e >>> 8 & 255, n[i++] = 255 & e;
                    } else for(n[i++] = 255 & e, n[i++] = e >>> 8 & 255, n[i++] = e >>> 16 & 255, n[i++] = e >>> 24 & 255, n[i++] = 0, n[i++] = 0, n[i++] = 0, n[i++] = 0, s = 8; s < this.padLength; s++)n[i++] = 0;
                    return n;
                };
            },
            {
                "./utils": 437,
                "minimalistic-assert": 453
            }
        ],
        428: [
            function(e, t, r) {
                "use strict";
                var n = e("./utils"), i = e("minimalistic-assert");
                function s(e, t, r) {
                    if (!(this instanceof s)) return new s(e, t, r);
                    this.Hash = e, this.blockSize = e.blockSize / 8, this.outSize = e.outSize / 8, this.inner = null, this.outer = null, this._init(n.toArray(t, r));
                }
                t.exports = s, s.prototype._init = function(e) {
                    e.length > this.blockSize && (e = (new this.Hash).update(e).digest()), i(e.length <= this.blockSize);
                    for(var t = e.length; t < this.blockSize; t++)e.push(0);
                    for(t = 0; t < e.length; t++)e[t] ^= 54;
                    for(this.inner = (new this.Hash).update(e), t = 0; t < e.length; t++)e[t] ^= 106;
                    this.outer = (new this.Hash).update(e);
                }, s.prototype.update = function(e, t) {
                    return this.inner.update(e, t), this;
                }, s.prototype.digest = function(e) {
                    return this.outer.update(this.inner.digest()), this.outer.digest(e);
                };
            },
            {
                "./utils": 437,
                "minimalistic-assert": 453
            }
        ],
        429: [
            function(e, t, r) {
                "use strict";
                var n = e("./utils"), i = e("./common"), s = n.rotl32, o = n.sum32, a = n.sum32_3, l = n.sum32_4, c = i.BlockHash;
                function u() {
                    if (!(this instanceof u)) return new u;
                    c.call(this), this.h = [
                        1732584193,
                        4023233417,
                        2562383102,
                        271733878,
                        3285377520
                    ], this.endian = "little";
                }
                function h(e, t, r, n) {
                    return e <= 15 ? t ^ r ^ n : e <= 31 ? t & r | ~t & n : e <= 47 ? (t | ~r) ^ n : e <= 63 ? t & n | r & ~n : t ^ (r | ~n);
                }
                function f(e) {
                    return e <= 15 ? 0 : e <= 31 ? 1518500249 : e <= 47 ? 1859775393 : e <= 63 ? 2400959708 : 2840853838;
                }
                function d(e) {
                    return e <= 15 ? 1352829926 : e <= 31 ? 1548603684 : e <= 47 ? 1836072691 : e <= 63 ? 2053994217 : 0;
                }
                n.inherits(u, c), r.ripemd160 = u, u.blockSize = 512, u.outSize = 160, u.hmacStrength = 192, u.padLength = 64, u.prototype._update = function(e, t) {
                    for(var r = this.h[0], n = this.h[1], i = this.h[2], c = this.h[3], u = this.h[4], y = r, v = n, w = i, _ = c, x = u, k = 0; k < 80; k++){
                        var S = o(s(l(r, h(k, n, i, c), e[p[k] + t], f(k)), b[k]), u);
                        r = u, u = c, c = s(i, 10), i = n, n = S, S = o(s(l(y, h(79 - k, v, w, _), e[m[k] + t], d(k)), g[k]), x), y = x, x = _, _ = s(w, 10), w = v, v = S;
                    }
                    S = a(this.h[1], i, _), this.h[1] = a(this.h[2], c, x), this.h[2] = a(this.h[3], u, y), this.h[3] = a(this.h[4], r, v), this.h[4] = a(this.h[0], n, w), this.h[0] = S;
                }, u.prototype._digest = function(e) {
                    return "hex" === e ? n.toHex32(this.h, "little") : n.split32(this.h, "little");
                };
                var p = [
                    0,
                    1,
                    2,
                    3,
                    4,
                    5,
                    6,
                    7,
                    8,
                    9,
                    10,
                    11,
                    12,
                    13,
                    14,
                    15,
                    7,
                    4,
                    13,
                    1,
                    10,
                    6,
                    15,
                    3,
                    12,
                    0,
                    9,
                    5,
                    2,
                    14,
                    11,
                    8,
                    3,
                    10,
                    14,
                    4,
                    9,
                    15,
                    8,
                    1,
                    2,
                    7,
                    0,
                    6,
                    13,
                    11,
                    5,
                    12,
                    1,
                    9,
                    11,
                    10,
                    0,
                    8,
                    12,
                    4,
                    13,
                    3,
                    7,
                    15,
                    14,
                    5,
                    6,
                    2,
                    4,
                    0,
                    5,
                    9,
                    7,
                    12,
                    2,
                    10,
                    14,
                    1,
                    3,
                    8,
                    11,
                    6,
                    15,
                    13
                ], m = [
                    5,
                    14,
                    7,
                    0,
                    9,
                    2,
                    11,
                    4,
                    13,
                    6,
                    15,
                    8,
                    1,
                    10,
                    3,
                    12,
                    6,
                    11,
                    3,
                    7,
                    0,
                    13,
                    5,
                    10,
                    14,
                    15,
                    8,
                    12,
                    4,
                    9,
                    1,
                    2,
                    15,
                    5,
                    1,
                    3,
                    7,
                    14,
                    6,
                    9,
                    11,
                    8,
                    12,
                    2,
                    10,
                    0,
                    4,
                    13,
                    8,
                    6,
                    4,
                    1,
                    3,
                    11,
                    15,
                    0,
                    5,
                    12,
                    2,
                    13,
                    9,
                    7,
                    10,
                    14,
                    12,
                    15,
                    10,
                    4,
                    1,
                    5,
                    8,
                    7,
                    6,
                    2,
                    13,
                    14,
                    0,
                    3,
                    9,
                    11
                ], b = [
                    11,
                    14,
                    15,
                    12,
                    5,
                    8,
                    7,
                    9,
                    11,
                    13,
                    14,
                    15,
                    6,
                    7,
                    9,
                    8,
                    7,
                    6,
                    8,
                    13,
                    11,
                    9,
                    7,
                    15,
                    7,
                    12,
                    15,
                    9,
                    11,
                    7,
                    13,
                    12,
                    11,
                    13,
                    6,
                    7,
                    14,
                    9,
                    13,
                    15,
                    14,
                    8,
                    13,
                    6,
                    5,
                    12,
                    7,
                    5,
                    11,
                    12,
                    14,
                    15,
                    14,
                    15,
                    9,
                    8,
                    9,
                    14,
                    5,
                    6,
                    8,
                    6,
                    5,
                    12,
                    9,
                    15,
                    5,
                    11,
                    6,
                    8,
                    13,
                    12,
                    5,
                    12,
                    13,
                    14,
                    11,
                    8,
                    5,
                    6
                ], g = [
                    8,
                    9,
                    9,
                    11,
                    13,
                    15,
                    15,
                    5,
                    7,
                    7,
                    8,
                    11,
                    14,
                    14,
                    12,
                    6,
                    9,
                    13,
                    15,
                    7,
                    12,
                    8,
                    9,
                    11,
                    7,
                    7,
                    12,
                    7,
                    6,
                    15,
                    13,
                    11,
                    9,
                    7,
                    15,
                    11,
                    8,
                    6,
                    6,
                    14,
                    12,
                    13,
                    5,
                    14,
                    13,
                    13,
                    7,
                    5,
                    15,
                    5,
                    8,
                    11,
                    14,
                    14,
                    6,
                    14,
                    6,
                    9,
                    12,
                    9,
                    12,
                    5,
                    15,
                    8,
                    8,
                    5,
                    12,
                    9,
                    12,
                    5,
                    14,
                    6,
                    8,
                    13,
                    6,
                    5,
                    15,
                    13,
                    11,
                    11
                ];
            },
            {
                "./common": 427,
                "./utils": 437
            }
        ],
        430: [
            function(e, t, r) {
                "use strict";
                r.sha1 = e("./sha/1"), r.sha224 = e("./sha/224"), r.sha256 = e("./sha/256"), r.sha384 = e("./sha/384"), r.sha512 = e("./sha/512");
            },
            {
                "./sha/1": 431,
                "./sha/224": 432,
                "./sha/256": 433,
                "./sha/384": 434,
                "./sha/512": 435
            }
        ],
        431: [
            function(e, t, r) {
                "use strict";
                var n = e("../utils"), i = e("../common"), s = e("./common"), o = n.rotl32, a = n.sum32, l = n.sum32_5, c = s.ft_1, u = i.BlockHash, h = [
                    1518500249,
                    1859775393,
                    2400959708,
                    3395469782
                ];
                function f() {
                    if (!(this instanceof f)) return new f;
                    u.call(this), this.h = [
                        1732584193,
                        4023233417,
                        2562383102,
                        271733878,
                        3285377520
                    ], this.W = new Array(80);
                }
                n.inherits(f, u), t.exports = f, f.blockSize = 512, f.outSize = 160, f.hmacStrength = 80, f.padLength = 64, f.prototype._update = function(e, t) {
                    for(var r = this.W, n = 0; n < 16; n++)r[n] = e[t + n];
                    for(; n < r.length; n++)r[n] = o(r[n - 3] ^ r[n - 8] ^ r[n - 14] ^ r[n - 16], 1);
                    var i = this.h[0], s = this.h[1], u = this.h[2], f = this.h[3], d = this.h[4];
                    for(n = 0; n < r.length; n++){
                        var p = ~~(n / 20), m = l(o(i, 5), c(p, s, u, f), d, r[n], h[p]);
                        d = f, f = u, u = o(s, 30), s = i, i = m;
                    }
                    this.h[0] = a(this.h[0], i), this.h[1] = a(this.h[1], s), this.h[2] = a(this.h[2], u), this.h[3] = a(this.h[3], f), this.h[4] = a(this.h[4], d);
                }, f.prototype._digest = function(e) {
                    return "hex" === e ? n.toHex32(this.h, "big") : n.split32(this.h, "big");
                };
            },
            {
                "../common": 427,
                "../utils": 437,
                "./common": 436
            }
        ],
        432: [
            function(e, t, r) {
                "use strict";
                var n = e("../utils"), i = e("./256");
                function s() {
                    if (!(this instanceof s)) return new s;
                    i.call(this), this.h = [
                        3238371032,
                        914150663,
                        812702999,
                        4144912697,
                        4290775857,
                        1750603025,
                        1694076839,
                        3204075428
                    ];
                }
                n.inherits(s, i), t.exports = s, s.blockSize = 512, s.outSize = 224, s.hmacStrength = 192, s.padLength = 64, s.prototype._digest = function(e) {
                    return "hex" === e ? n.toHex32(this.h.slice(0, 7), "big") : n.split32(this.h.slice(0, 7), "big");
                };
            },
            {
                "../utils": 437,
                "./256": 433
            }
        ],
        433: [
            function(e, t, r) {
                "use strict";
                var n = e("../utils"), i = e("../common"), s = e("./common"), o = e("minimalistic-assert"), a = n.sum32, l = n.sum32_4, c = n.sum32_5, u = s.ch32, h = s.maj32, f = s.s0_256, d = s.s1_256, p = s.g0_256, m = s.g1_256, b = i.BlockHash, g = [
                    1116352408,
                    1899447441,
                    3049323471,
                    3921009573,
                    961987163,
                    1508970993,
                    2453635748,
                    2870763221,
                    3624381080,
                    310598401,
                    607225278,
                    1426881987,
                    1925078388,
                    2162078206,
                    2614888103,
                    3248222580,
                    3835390401,
                    4022224774,
                    264347078,
                    604807628,
                    770255983,
                    1249150122,
                    1555081692,
                    1996064986,
                    2554220882,
                    2821834349,
                    2952996808,
                    3210313671,
                    3336571891,
                    3584528711,
                    113926993,
                    338241895,
                    666307205,
                    773529912,
                    1294757372,
                    1396182291,
                    1695183700,
                    1986661051,
                    2177026350,
                    2456956037,
                    2730485921,
                    2820302411,
                    3259730800,
                    3345764771,
                    3516065817,
                    3600352804,
                    4094571909,
                    275423344,
                    430227734,
                    506948616,
                    659060556,
                    883997877,
                    958139571,
                    1322822218,
                    1537002063,
                    1747873779,
                    1955562222,
                    2024104815,
                    2227730452,
                    2361852424,
                    2428436474,
                    2756734187,
                    3204031479,
                    3329325298
                ];
                function y() {
                    if (!(this instanceof y)) return new y;
                    b.call(this), this.h = [
                        1779033703,
                        3144134277,
                        1013904242,
                        2773480762,
                        1359893119,
                        2600822924,
                        528734635,
                        1541459225
                    ], this.k = g, this.W = new Array(64);
                }
                n.inherits(y, b), t.exports = y, y.blockSize = 512, y.outSize = 256, y.hmacStrength = 192, y.padLength = 64, y.prototype._update = function(e, t) {
                    for(var r = this.W, n = 0; n < 16; n++)r[n] = e[t + n];
                    for(; n < r.length; n++)r[n] = l(m(r[n - 2]), r[n - 7], p(r[n - 15]), r[n - 16]);
                    var i = this.h[0], s = this.h[1], b = this.h[2], g = this.h[3], y = this.h[4], v = this.h[5], w = this.h[6], _ = this.h[7];
                    for(o(this.k.length === r.length), n = 0; n < r.length; n++){
                        var x = c(_, d(y), u(y, v, w), this.k[n], r[n]), k = a(f(i), h(i, s, b));
                        _ = w, w = v, v = y, y = a(g, x), g = b, b = s, s = i, i = a(x, k);
                    }
                    this.h[0] = a(this.h[0], i), this.h[1] = a(this.h[1], s), this.h[2] = a(this.h[2], b), this.h[3] = a(this.h[3], g), this.h[4] = a(this.h[4], y), this.h[5] = a(this.h[5], v), this.h[6] = a(this.h[6], w), this.h[7] = a(this.h[7], _);
                }, y.prototype._digest = function(e) {
                    return "hex" === e ? n.toHex32(this.h, "big") : n.split32(this.h, "big");
                };
            },
            {
                "../common": 427,
                "../utils": 437,
                "./common": 436,
                "minimalistic-assert": 453
            }
        ],
        434: [
            function(e, t, r) {
                "use strict";
                var n = e("../utils"), i = e("./512");
                function s() {
                    if (!(this instanceof s)) return new s;
                    i.call(this), this.h = [
                        3418070365,
                        3238371032,
                        1654270250,
                        914150663,
                        2438529370,
                        812702999,
                        355462360,
                        4144912697,
                        1731405415,
                        4290775857,
                        2394180231,
                        1750603025,
                        3675008525,
                        1694076839,
                        1203062813,
                        3204075428
                    ];
                }
                n.inherits(s, i), t.exports = s, s.blockSize = 1024, s.outSize = 384, s.hmacStrength = 192, s.padLength = 128, s.prototype._digest = function(e) {
                    return "hex" === e ? n.toHex32(this.h.slice(0, 12), "big") : n.split32(this.h.slice(0, 12), "big");
                };
            },
            {
                "../utils": 437,
                "./512": 435
            }
        ],
        435: [
            function(e, t, r) {
                "use strict";
                var n = e("../utils"), i = e("../common"), s = e("minimalistic-assert"), o = n.rotr64_hi, a = n.rotr64_lo, l = n.shr64_hi, c = n.shr64_lo, u = n.sum64, h = n.sum64_hi, f = n.sum64_lo, d = n.sum64_4_hi, p = n.sum64_4_lo, m = n.sum64_5_hi, b = n.sum64_5_lo, g = i.BlockHash, y = [
                    1116352408,
                    3609767458,
                    1899447441,
                    602891725,
                    3049323471,
                    3964484399,
                    3921009573,
                    2173295548,
                    961987163,
                    4081628472,
                    1508970993,
                    3053834265,
                    2453635748,
                    2937671579,
                    2870763221,
                    3664609560,
                    3624381080,
                    2734883394,
                    310598401,
                    1164996542,
                    607225278,
                    1323610764,
                    1426881987,
                    3590304994,
                    1925078388,
                    4068182383,
                    2162078206,
                    991336113,
                    2614888103,
                    633803317,
                    3248222580,
                    3479774868,
                    3835390401,
                    2666613458,
                    4022224774,
                    944711139,
                    264347078,
                    2341262773,
                    604807628,
                    2007800933,
                    770255983,
                    1495990901,
                    1249150122,
                    1856431235,
                    1555081692,
                    3175218132,
                    1996064986,
                    2198950837,
                    2554220882,
                    3999719339,
                    2821834349,
                    766784016,
                    2952996808,
                    2566594879,
                    3210313671,
                    3203337956,
                    3336571891,
                    1034457026,
                    3584528711,
                    2466948901,
                    113926993,
                    3758326383,
                    338241895,
                    168717936,
                    666307205,
                    1188179964,
                    773529912,
                    1546045734,
                    1294757372,
                    1522805485,
                    1396182291,
                    2643833823,
                    1695183700,
                    2343527390,
                    1986661051,
                    1014477480,
                    2177026350,
                    1206759142,
                    2456956037,
                    344077627,
                    2730485921,
                    1290863460,
                    2820302411,
                    3158454273,
                    3259730800,
                    3505952657,
                    3345764771,
                    106217008,
                    3516065817,
                    3606008344,
                    3600352804,
                    1432725776,
                    4094571909,
                    1467031594,
                    275423344,
                    851169720,
                    430227734,
                    3100823752,
                    506948616,
                    1363258195,
                    659060556,
                    3750685593,
                    883997877,
                    3785050280,
                    958139571,
                    3318307427,
                    1322822218,
                    3812723403,
                    1537002063,
                    2003034995,
                    1747873779,
                    3602036899,
                    1955562222,
                    1575990012,
                    2024104815,
                    1125592928,
                    2227730452,
                    2716904306,
                    2361852424,
                    442776044,
                    2428436474,
                    593698344,
                    2756734187,
                    3733110249,
                    3204031479,
                    2999351573,
                    3329325298,
                    3815920427,
                    3391569614,
                    3928383900,
                    3515267271,
                    566280711,
                    3940187606,
                    3454069534,
                    4118630271,
                    4000239992,
                    116418474,
                    1914138554,
                    174292421,
                    2731055270,
                    289380356,
                    3203993006,
                    460393269,
                    320620315,
                    685471733,
                    587496836,
                    852142971,
                    1086792851,
                    1017036298,
                    365543100,
                    1126000580,
                    2618297676,
                    1288033470,
                    3409855158,
                    1501505948,
                    4234509866,
                    1607167915,
                    987167468,
                    1816402316,
                    1246189591
                ];
                function v() {
                    if (!(this instanceof v)) return new v;
                    g.call(this), this.h = [
                        1779033703,
                        4089235720,
                        3144134277,
                        2227873595,
                        1013904242,
                        4271175723,
                        2773480762,
                        1595750129,
                        1359893119,
                        2917565137,
                        2600822924,
                        725511199,
                        528734635,
                        4215389547,
                        1541459225,
                        327033209
                    ], this.k = y, this.W = new Array(160);
                }
                function w(e, t, r, n, i) {
                    var s = e & r ^ ~e & i;
                    return s < 0 && (s += 4294967296), s;
                }
                function _(e, t, r, n, i, s) {
                    var o = t & n ^ ~t & s;
                    return o < 0 && (o += 4294967296), o;
                }
                function x(e, t, r, n, i) {
                    var s = e & r ^ e & i ^ r & i;
                    return s < 0 && (s += 4294967296), s;
                }
                function k(e, t, r, n, i, s) {
                    var o = t & n ^ t & s ^ n & s;
                    return o < 0 && (o += 4294967296), o;
                }
                function S(e, t) {
                    var r = o(e, t, 28) ^ o(t, e, 2) ^ o(t, e, 7);
                    return r < 0 && (r += 4294967296), r;
                }
                function M(e, t) {
                    var r = a(e, t, 28) ^ a(t, e, 2) ^ a(t, e, 7);
                    return r < 0 && (r += 4294967296), r;
                }
                function C(e, t) {
                    var r = o(e, t, 14) ^ o(e, t, 18) ^ o(t, e, 9);
                    return r < 0 && (r += 4294967296), r;
                }
                function T(e, t) {
                    var r = a(e, t, 14) ^ a(e, t, 18) ^ a(t, e, 9);
                    return r < 0 && (r += 4294967296), r;
                }
                function E(e, t) {
                    var r = o(e, t, 1) ^ o(e, t, 8) ^ l(e, t, 7);
                    return r < 0 && (r += 4294967296), r;
                }
                function A(e, t) {
                    var r = a(e, t, 1) ^ a(e, t, 8) ^ c(e, t, 7);
                    return r < 0 && (r += 4294967296), r;
                }
                function R(e, t) {
                    var r = o(e, t, 19) ^ o(t, e, 29) ^ l(e, t, 6);
                    return r < 0 && (r += 4294967296), r;
                }
                function O(e, t) {
                    var r = a(e, t, 19) ^ a(t, e, 29) ^ c(e, t, 6);
                    return r < 0 && (r += 4294967296), r;
                }
                n.inherits(v, g), t.exports = v, v.blockSize = 1024, v.outSize = 512, v.hmacStrength = 192, v.padLength = 128, v.prototype._prepareBlock = function(e, t) {
                    for(var r = this.W, n = 0; n < 32; n++)r[n] = e[t + n];
                    for(; n < r.length; n += 2){
                        var i = R(r[n - 4], r[n - 3]), s = O(r[n - 4], r[n - 3]), o = r[n - 14], a = r[n - 13], l = E(r[n - 30], r[n - 29]), c = A(r[n - 30], r[n - 29]), u = r[n - 32], h = r[n - 31];
                        r[n] = d(i, s, o, a, l, c, u, h), r[n + 1] = p(i, s, o, a, l, c, u, h);
                    }
                }, v.prototype._update = function(e, t) {
                    this._prepareBlock(e, t);
                    var r = this.W, n = this.h[0], i = this.h[1], o = this.h[2], a = this.h[3], l = this.h[4], c = this.h[5], d = this.h[6], p = this.h[7], g = this.h[8], y = this.h[9], v = this.h[10], E = this.h[11], A = this.h[12], R = this.h[13], O = this.h[14], j = this.h[15];
                    s(this.k.length === r.length);
                    for(var I = 0; I < r.length; I += 2){
                        var N = O, P = j, B = C(g, y), D = T(g, y), F = w(g, y, v, E, A), L = _(g, y, v, E, A, R), z = this.k[I], U = this.k[I + 1], $ = r[I], H = r[I + 1], V = m(N, P, B, D, F, L, z, U, $, H), q = b(N, P, B, D, F, L, z, U, $, H);
                        N = S(n, i), P = M(n, i), B = x(n, i, o, a, l), D = k(n, i, o, a, l, c);
                        var W = h(N, P, B, D), X = f(N, P, B, D);
                        O = A, j = R, A = v, R = E, v = g, E = y, g = h(d, p, V, q), y = f(p, p, V, q), d = l, p = c, l = o, c = a, o = n, a = i, n = h(V, q, W, X), i = f(V, q, W, X);
                    }
                    u(this.h, 0, n, i), u(this.h, 2, o, a), u(this.h, 4, l, c), u(this.h, 6, d, p), u(this.h, 8, g, y), u(this.h, 10, v, E), u(this.h, 12, A, R), u(this.h, 14, O, j);
                }, v.prototype._digest = function(e) {
                    return "hex" === e ? n.toHex32(this.h, "big") : n.split32(this.h, "big");
                };
            },
            {
                "../common": 427,
                "../utils": 437,
                "minimalistic-assert": 453
            }
        ],
        436: [
            function(e, t, r) {
                "use strict";
                var n = e("../utils").rotr32;
                function i(e, t, r) {
                    return e & t ^ ~e & r;
                }
                function s(e, t, r) {
                    return e & t ^ e & r ^ t & r;
                }
                function o(e, t, r) {
                    return e ^ t ^ r;
                }
                r.ft_1 = function(e, t, r, n) {
                    return 0 === e ? i(t, r, n) : 1 === e || 3 === e ? o(t, r, n) : 2 === e ? s(t, r, n) : void 0;
                }, r.ch32 = i, r.maj32 = s, r.p32 = o, r.s0_256 = function(e) {
                    return n(e, 2) ^ n(e, 13) ^ n(e, 22);
                }, r.s1_256 = function(e) {
                    return n(e, 6) ^ n(e, 11) ^ n(e, 25);
                }, r.g0_256 = function(e) {
                    return n(e, 7) ^ n(e, 18) ^ e >>> 3;
                }, r.g1_256 = function(e) {
                    return n(e, 17) ^ n(e, 19) ^ e >>> 10;
                };
            },
            {
                "../utils": 437
            }
        ],
        437: [
            function(e, t, r) {
                "use strict";
                var n = e("minimalistic-assert"), i = e("inherits");
                function s(e, t) {
                    return 55296 == (64512 & e.charCodeAt(t)) && !(t < 0 || t + 1 >= e.length) && 56320 == (64512 & e.charCodeAt(t + 1));
                }
                function o(e) {
                    return (e >>> 24 | e >>> 8 & 65280 | e << 8 & 16711680 | (255 & e) << 24) >>> 0;
                }
                function a(e) {
                    return 1 === e.length ? "0" + e : e;
                }
                function l(e) {
                    return 7 === e.length ? "0" + e : 6 === e.length ? "00" + e : 5 === e.length ? "000" + e : 4 === e.length ? "0000" + e : 3 === e.length ? "00000" + e : 2 === e.length ? "000000" + e : 1 === e.length ? "0000000" + e : e;
                }
                r.inherits = i, r.toArray = function(e, t) {
                    if (Array.isArray(e)) return e.slice();
                    if (!e) return [];
                    var r = [];
                    if ("string" == typeof e) {
                        if (t) {
                            if ("hex" === t) for((e = e.replace(/[^a-z0-9]+/gi, "")).length % 2 != 0 && (e = "0" + e), i = 0; i < e.length; i += 2)r.push(parseInt(e[i] + e[i + 1], 16));
                        } else for(var n = 0, i = 0; i < e.length; i++){
                            var o = e.charCodeAt(i);
                            o < 128 ? r[n++] = o : o < 2048 ? (r[n++] = o >> 6 | 192, r[n++] = 63 & o | 128) : s(e, i) ? (o = 65536 + ((1023 & o) << 10) + (1023 & e.charCodeAt(++i)), r[n++] = o >> 18 | 240, r[n++] = o >> 12 & 63 | 128, r[n++] = o >> 6 & 63 | 128, r[n++] = 63 & o | 128) : (r[n++] = o >> 12 | 224, r[n++] = o >> 6 & 63 | 128, r[n++] = 63 & o | 128);
                        }
                    } else for(i = 0; i < e.length; i++)r[i] = 0 | e[i];
                    return r;
                }, r.toHex = function(e) {
                    for(var t = "", r = 0; r < e.length; r++)t += a(e[r].toString(16));
                    return t;
                }, r.htonl = o, r.toHex32 = function(e, t) {
                    for(var r = "", n = 0; n < e.length; n++){
                        var i = e[n];
                        "little" === t && (i = o(i)), r += l(i.toString(16));
                    }
                    return r;
                }, r.zero2 = a, r.zero8 = l, r.join32 = function(e, t, r, i) {
                    var s = r - t;
                    n(s % 4 == 0);
                    for(var o = new Array(s / 4), a = 0, l = t; a < o.length; a++, l += 4){
                        var c;
                        c = "big" === i ? e[l] << 24 | e[l + 1] << 16 | e[l + 2] << 8 | e[l + 3] : e[l + 3] << 24 | e[l + 2] << 16 | e[l + 1] << 8 | e[l], o[a] = c >>> 0;
                    }
                    return o;
                }, r.split32 = function(e, t) {
                    for(var r = new Array(4 * e.length), n = 0, i = 0; n < e.length; n++, i += 4){
                        var s = e[n];
                        "big" === t ? (r[i] = s >>> 24, r[i + 1] = s >>> 16 & 255, r[i + 2] = s >>> 8 & 255, r[i + 3] = 255 & s) : (r[i + 3] = s >>> 24, r[i + 2] = s >>> 16 & 255, r[i + 1] = s >>> 8 & 255, r[i] = 255 & s);
                    }
                    return r;
                }, r.rotr32 = function(e, t) {
                    return e >>> t | e << 32 - t;
                }, r.rotl32 = function(e, t) {
                    return e << t | e >>> 32 - t;
                }, r.sum32 = function(e, t) {
                    return e + t >>> 0;
                }, r.sum32_3 = function(e, t, r) {
                    return e + t + r >>> 0;
                }, r.sum32_4 = function(e, t, r, n) {
                    return e + t + r + n >>> 0;
                }, r.sum32_5 = function(e, t, r, n, i) {
                    return e + t + r + n + i >>> 0;
                }, r.sum64 = function(e, t, r, n) {
                    var i = e[t], s = n + e[t + 1] >>> 0, o = (s < n ? 1 : 0) + r + i;
                    e[t] = o >>> 0, e[t + 1] = s;
                }, r.sum64_hi = function(e, t, r, n) {
                    return (t + n >>> 0 < t ? 1 : 0) + e + r >>> 0;
                }, r.sum64_lo = function(e, t, r, n) {
                    return t + n >>> 0;
                }, r.sum64_4_hi = function(e, t, r, n, i, s, o, a) {
                    var l = 0, c = t;
                    return l += (c = c + n >>> 0) < t ? 1 : 0, l += (c = c + s >>> 0) < s ? 1 : 0, e + r + i + o + (l += (c = c + a >>> 0) < a ? 1 : 0) >>> 0;
                }, r.sum64_4_lo = function(e, t, r, n, i, s, o, a) {
                    return t + n + s + a >>> 0;
                }, r.sum64_5_hi = function(e, t, r, n, i, s, o, a, l, c) {
                    var u = 0, h = t;
                    return u += (h = h + n >>> 0) < t ? 1 : 0, u += (h = h + s >>> 0) < s ? 1 : 0, u += (h = h + a >>> 0) < a ? 1 : 0, e + r + i + o + l + (u += (h = h + c >>> 0) < c ? 1 : 0) >>> 0;
                }, r.sum64_5_lo = function(e, t, r, n, i, s, o, a, l, c) {
                    return t + n + s + a + c >>> 0;
                }, r.rotr64_hi = function(e, t, r) {
                    return (t << 32 - r | e >>> r) >>> 0;
                }, r.rotr64_lo = function(e, t, r) {
                    return (e << 32 - r | t >>> r) >>> 0;
                }, r.shr64_hi = function(e, t, r) {
                    return e >>> r;
                }, r.shr64_lo = function(e, t, r) {
                    return (e << 32 - r | t >>> r) >>> 0;
                };
            },
            {
                inherits: 440,
                "minimalistic-assert": 453
            }
        ],
        438: [
            function(e, t, r) {
                "use strict";
                var n = e("hash.js"), i = e("minimalistic-crypto-utils"), s = e("minimalistic-assert");
                function o(e) {
                    if (!(this instanceof o)) return new o(e);
                    this.hash = e.hash, this.predResist = !!e.predResist, this.outLen = this.hash.outSize, this.minEntropy = e.minEntropy || this.hash.hmacStrength, this._reseed = null, this.reseedInterval = null, this.K = null, this.V = null;
                    var t = i.toArray(e.entropy, e.entropyEnc || "hex"), r = i.toArray(e.nonce, e.nonceEnc || "hex"), n = i.toArray(e.pers, e.persEnc || "hex");
                    s(t.length >= this.minEntropy / 8, "Not enough entropy. Minimum is: " + this.minEntropy + " bits"), this._init(t, r, n);
                }
                t.exports = o, o.prototype._init = function(e, t, r) {
                    var n = e.concat(t).concat(r);
                    this.K = new Array(this.outLen / 8), this.V = new Array(this.outLen / 8);
                    for(var i = 0; i < this.V.length; i++)this.K[i] = 0, this.V[i] = 1;
                    this._update(n), this._reseed = 1, this.reseedInterval = 281474976710656;
                }, o.prototype._hmac = function() {
                    return new n.hmac(this.hash, this.K);
                }, o.prototype._update = function(e) {
                    var t = this._hmac().update(this.V).update([
                        0
                    ]);
                    e && (t = t.update(e)), this.K = t.digest(), this.V = this._hmac().update(this.V).digest(), e && (this.K = this._hmac().update(this.V).update([
                        1
                    ]).update(e).digest(), this.V = this._hmac().update(this.V).digest());
                }, o.prototype.reseed = function(e, t, r, n) {
                    "string" != typeof t && (n = r, r = t, t = null), e = i.toArray(e, t), r = i.toArray(r, n), s(e.length >= this.minEntropy / 8, "Not enough entropy. Minimum is: " + this.minEntropy + " bits"), this._update(e.concat(r || [])), this._reseed = 1;
                }, o.prototype.generate = function(e, t, r, n) {
                    if (this._reseed > this.reseedInterval) throw new Error("Reseed is required");
                    "string" != typeof t && (n = r, r = t, t = null), r && (r = i.toArray(r, n || "hex"), this._update(r));
                    for(var s = []; s.length < e;)this.V = this._hmac().update(this.V).digest(), s = s.concat(this.V);
                    var o = s.slice(0, e);
                    return this._update(r), this._reseed++, i.encode(o, t);
                };
            },
            {
                "hash.js": 426,
                "minimalistic-assert": 453,
                "minimalistic-crypto-utils": 454
            }
        ],
        439: [
            function(e, t, r) {
                "use strict";
                /*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ r.read = function(e, t, r, n, i) {
                    var s, o, a = 8 * i - n - 1, l = (1 << a) - 1, c = l >> 1, u = -7, h = r ? i - 1 : 0, f = r ? -1 : 1, d = e[t + h];
                    for(h += f, s = d & (1 << -u) - 1, d >>= -u, u += a; u > 0; s = 256 * s + e[t + h], h += f, u -= 8);
                    for(o = s & (1 << -u) - 1, s >>= -u, u += n; u > 0; o = 256 * o + e[t + h], h += f, u -= 8);
                    if (0 === s) s = 1 - c;
                    else {
                        if (s === l) return o ? NaN : 1 / 0 * (d ? -1 : 1);
                        o += Math.pow(2, n), s -= c;
                    }
                    return (d ? -1 : 1) * o * Math.pow(2, s - n);
                }, r.write = function(e, t, r, n, i, s) {
                    var o, a, l, c = 8 * s - i - 1, u = (1 << c) - 1, h = u >> 1, f = 23 === i ? Math.pow(2, -24) - Math.pow(2, -77) : 0, d = n ? 0 : s - 1, p = n ? 1 : -1, m = t < 0 || 0 === t && 1 / t < 0 ? 1 : 0;
                    for(t = Math.abs(t), isNaN(t) || t === 1 / 0 ? (a = isNaN(t) ? 1 : 0, o = u) : (o = Math.floor(Math.log(t) / Math.LN2), t * (l = Math.pow(2, -o)) < 1 && (o--, l *= 2), (t += o + h >= 1 ? f / l : f * Math.pow(2, 1 - h)) * l >= 2 && (o++, l /= 2), o + h >= u ? (a = 0, o = u) : o + h >= 1 ? (a = (t * l - 1) * Math.pow(2, i), o += h) : (a = t * Math.pow(2, h - 1) * Math.pow(2, i), o = 0)); i >= 8; e[r + d] = 255 & a, d += p, a /= 256, i -= 8);
                    for(o = o << i | a, c += i; c > 0; e[r + d] = 255 & o, d += p, o /= 256, c -= 8);
                    e[r + d - p] |= 128 * m;
                };
            },
            {}
        ],
        440: [
            function(e, t, r) {
                "use strict";
                "function" == typeof Object.create ? t.exports = function(e, t) {
                    t && (e.super_ = t, e.prototype = Object.create(t.prototype, {
                        constructor: {
                            value: e,
                            enumerable: !1,
                            writable: !0,
                            configurable: !0
                        }
                    }));
                } : t.exports = function(e, t) {
                    if (t) {
                        e.super_ = t;
                        var r = function() {};
                        r.prototype = t.prototype, e.prototype = new r, e.prototype.constructor = e;
                    }
                };
            },
            {}
        ],
        441: [
            function(e, t, r) {
                (function(n, i, s, o, a, l, c, u) {
                    (function() {
                        "use strict";
                        /*!

JSZip v3.10.1 - A JavaScript class for generating and reading zip files
<http://stuartk.com/jszip>

(c) 2009-2016 Stuart Knightley <stuart [at] stuartk.com>
Dual licenced under the MIT license or GPLv3. See https://raw.github.com/Stuk/jszip/main/LICENSE.markdown.

JSZip uses the library pako released under the MIT license :
https://github.com/nodeca/pako/blob/main/LICENSE
*/ !function(e) {
                            "object" == typeof r && void 0 !== t ? t.exports = e() : ("undefined" != typeof window ? window : void 0 !== i ? i : "undefined" != typeof self ? self : this).JSZip = e();
                        }(function() {
                            return (function t(r, n, i) {
                                function s(a, l) {
                                    if (!n[a]) {
                                        if (!r[a]) {
                                            var c = "function" == typeof e && e;
                                            if (!l && c) return c(a, !0);
                                            if (o) return o(a, !0);
                                            var u = new Error("Cannot find module '" + a + "'");
                                            throw u.code = "MODULE_NOT_FOUND", u;
                                        }
                                        var h = n[a] = {
                                            exports: {}
                                        };
                                        r[a][0].call(h.exports, function(e) {
                                            return s(r[a][1][e] || e);
                                        }, h, h.exports, t, r, n, i);
                                    }
                                    return n[a].exports;
                                }
                                for(var o = "function" == typeof e && e, a = 0; a < i.length; a++)s(i[a]);
                                return s;
                            })({
                                1: [
                                    function(e, t, r) {
                                        var n = e("./utils"), i = e("./support"), s = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
                                        r.encode = function(e) {
                                            for(var t, r, i, o, a, l, c, u = [], h = 0, f = e.length, d = f, p = "string" !== n.getTypeOf(e); h < e.length;)d = f - h, i = p ? (t = e[h++], r = h < f ? e[h++] : 0, h < f ? e[h++] : 0) : (t = e.charCodeAt(h++), r = h < f ? e.charCodeAt(h++) : 0, h < f ? e.charCodeAt(h++) : 0), o = t >> 2, a = (3 & t) << 4 | r >> 4, l = 1 < d ? (15 & r) << 2 | i >> 6 : 64, c = 2 < d ? 63 & i : 64, u.push(s.charAt(o) + s.charAt(a) + s.charAt(l) + s.charAt(c));
                                            return u.join("");
                                        }, r.decode = function(e) {
                                            var t, r, n, o, a, l, c = 0, u = 0, h = "data:";
                                            if (e.substr(0, h.length) === h) throw new Error("Invalid base64 input, it looks like a data url.");
                                            var f, d = 3 * (e = e.replace(/[^A-Za-z0-9+/=]/g, "")).length / 4;
                                            if (e.charAt(e.length - 1) === s.charAt(64) && d--, e.charAt(e.length - 2) === s.charAt(64) && d--, d % 1 != 0) throw new Error("Invalid base64 input, bad content length.");
                                            for(f = i.uint8array ? new Uint8Array(0 | d) : new Array(0 | d); c < e.length;)t = s.indexOf(e.charAt(c++)) << 2 | (o = s.indexOf(e.charAt(c++))) >> 4, r = (15 & o) << 4 | (a = s.indexOf(e.charAt(c++))) >> 2, n = (3 & a) << 6 | (l = s.indexOf(e.charAt(c++))), f[u++] = t, 64 !== a && (f[u++] = r), 64 !== l && (f[u++] = n);
                                            return f;
                                        };
                                    },
                                    {
                                        "./support": 30,
                                        "./utils": 32
                                    }
                                ],
                                2: [
                                    function(e, t, r) {
                                        var n = e("./external"), i = e("./stream/DataWorker"), s = e("./stream/Crc32Probe"), o = e("./stream/DataLengthProbe");
                                        function a(e, t, r, n, i) {
                                            this.compressedSize = e, this.uncompressedSize = t, this.crc32 = r, this.compression = n, this.compressedContent = i;
                                        }
                                        a.prototype = {
                                            getContentWorker: function() {
                                                var e = new i(n.Promise.resolve(this.compressedContent)).pipe(this.compression.uncompressWorker()).pipe(new o("data_length")), t = this;
                                                return e.on("end", function() {
                                                    if (this.streamInfo.data_length !== t.uncompressedSize) throw new Error("Bug : uncompressed data size mismatch");
                                                }), e;
                                            },
                                            getCompressedWorker: function() {
                                                return new i(n.Promise.resolve(this.compressedContent)).withStreamInfo("compressedSize", this.compressedSize).withStreamInfo("uncompressedSize", this.uncompressedSize).withStreamInfo("crc32", this.crc32).withStreamInfo("compression", this.compression);
                                            }
                                        }, a.createWorkerFrom = function(e, t, r) {
                                            return e.pipe(new s).pipe(new o("uncompressedSize")).pipe(t.compressWorker(r)).pipe(new o("compressedSize")).withStreamInfo("compression", t);
                                        }, t.exports = a;
                                    },
                                    {
                                        "./external": 6,
                                        "./stream/Crc32Probe": 25,
                                        "./stream/DataLengthProbe": 26,
                                        "./stream/DataWorker": 27
                                    }
                                ],
                                3: [
                                    function(e, t, r) {
                                        var n = e("./stream/GenericWorker");
                                        r.STORE = {
                                            magic: "\0\0",
                                            compressWorker: function() {
                                                return new n("STORE compression");
                                            },
                                            uncompressWorker: function() {
                                                return new n("STORE decompression");
                                            }
                                        }, r.DEFLATE = e("./flate");
                                    },
                                    {
                                        "./flate": 7,
                                        "./stream/GenericWorker": 28
                                    }
                                ],
                                4: [
                                    function(e, t, r) {
                                        var n = e("./utils"), i = function() {
                                            for(var e, t = [], r = 0; r < 256; r++){
                                                e = r;
                                                for(var n = 0; n < 8; n++)e = 1 & e ? 3988292384 ^ e >>> 1 : e >>> 1;
                                                t[r] = e;
                                            }
                                            return t;
                                        }();
                                        t.exports = function(e, t) {
                                            return void 0 !== e && e.length ? "string" !== n.getTypeOf(e) ? function(e, t, r, n) {
                                                var s = i, o = 0 + r;
                                                e ^= -1;
                                                for(var a = 0; a < o; a++)e = e >>> 8 ^ s[255 & (e ^ t[a])];
                                                return -1 ^ e;
                                            }(0 | t, e, e.length) : function(e, t, r, n) {
                                                var s = i, o = 0 + r;
                                                e ^= -1;
                                                for(var a = 0; a < o; a++)e = e >>> 8 ^ s[255 & (e ^ t.charCodeAt(a))];
                                                return -1 ^ e;
                                            }(0 | t, e, e.length) : 0;
                                        };
                                    },
                                    {
                                        "./utils": 32
                                    }
                                ],
                                5: [
                                    function(e, t, r) {
                                        r.base64 = !1, r.binary = !1, r.dir = !1, r.createFolders = !0, r.date = null, r.compression = null, r.compressionOptions = null, r.comment = null, r.unixPermissions = null, r.dosPermissions = null;
                                    },
                                    {}
                                ],
                                6: [
                                    function(e, t, r) {
                                        var n;
                                        n = "undefined" != typeof Promise ? Promise : e("lie"), t.exports = {
                                            Promise: n
                                        };
                                    },
                                    {
                                        lie: 37
                                    }
                                ],
                                7: [
                                    function(e, t, r) {
                                        var n = "undefined" != typeof Uint8Array && "undefined" != typeof Uint16Array && "undefined" != typeof Uint32Array, i = e("pako"), s = e("./utils"), o = e("./stream/GenericWorker"), a = n ? "uint8array" : "array";
                                        function l(e, t) {
                                            o.call(this, "FlateWorker/" + e), this._pako = null, this._pakoAction = e, this._pakoOptions = t, this.meta = {};
                                        }
                                        r.magic = "\b\0", s.inherits(l, o), l.prototype.processChunk = function(e) {
                                            this.meta = e.meta, null === this._pako && this._createPako(), this._pako.push(s.transformTo(a, e.data), !1);
                                        }, l.prototype.flush = function() {
                                            o.prototype.flush.call(this), null === this._pako && this._createPako(), this._pako.push([], !0);
                                        }, l.prototype.cleanUp = function() {
                                            o.prototype.cleanUp.call(this), this._pako = null;
                                        }, l.prototype._createPako = function() {
                                            this._pako = new i[this._pakoAction]({
                                                raw: !0,
                                                level: this._pakoOptions.level || -1
                                            });
                                            var e = this;
                                            this._pako.onData = function(t) {
                                                e.push({
                                                    data: t,
                                                    meta: e.meta
                                                });
                                            };
                                        }, r.compressWorker = function(e) {
                                            return new l("Deflate", e);
                                        }, r.uncompressWorker = function() {
                                            return new l("Inflate", {});
                                        };
                                    },
                                    {
                                        "./stream/GenericWorker": 28,
                                        "./utils": 32,
                                        pako: 38
                                    }
                                ],
                                8: [
                                    function(e, t, r) {
                                        function n(e, t) {
                                            var r, n = "";
                                            for(r = 0; r < t; r++)n += String.fromCharCode(255 & e), e >>>= 8;
                                            return n;
                                        }
                                        function i(e, t, r, i, o, u) {
                                            var h, f, d = e.file, p = e.compression, m = u !== a.utf8encode, b = s.transformTo("string", u(d.name)), g = s.transformTo("string", a.utf8encode(d.name)), y = d.comment, v = s.transformTo("string", u(y)), w = s.transformTo("string", a.utf8encode(y)), _ = g.length !== d.name.length, x = w.length !== y.length, k = "", S = "", M = "", C = d.dir, T = d.date, E = {
                                                crc32: 0,
                                                compressedSize: 0,
                                                uncompressedSize: 0
                                            };
                                            t && !r || (E.crc32 = e.crc32, E.compressedSize = e.compressedSize, E.uncompressedSize = e.uncompressedSize);
                                            var A = 0;
                                            t && (A |= 8), m || !_ && !x || (A |= 2048);
                                            var R = 0, O = 0;
                                            C && (R |= 16), "UNIX" === o ? (O = 798, R |= function(e, t) {
                                                var r = e;
                                                return e || (r = t ? 16893 : 33204), (65535 & r) << 16;
                                            }(d.unixPermissions, C)) : (O = 20, R |= function(e) {
                                                return 63 & (e || 0);
                                            }(d.dosPermissions)), h = T.getUTCHours(), h <<= 6, h |= T.getUTCMinutes(), h <<= 5, h |= T.getUTCSeconds() / 2, f = T.getUTCFullYear() - 1980, f <<= 4, f |= T.getUTCMonth() + 1, f <<= 5, f |= T.getUTCDate(), _ && (S = n(1, 1) + n(l(b), 4) + g, k += "up" + n(S.length, 2) + S), x && (M = n(1, 1) + n(l(v), 4) + w, k += "uc" + n(M.length, 2) + M);
                                            var j = "";
                                            return j += "\n\0", j += n(A, 2), j += p.magic, j += n(h, 2), j += n(f, 2), j += n(E.crc32, 4), j += n(E.compressedSize, 4), j += n(E.uncompressedSize, 4), j += n(b.length, 2), j += n(k.length, 2), {
                                                fileRecord: c.LOCAL_FILE_HEADER + j + b + k,
                                                dirRecord: c.CENTRAL_FILE_HEADER + n(O, 2) + j + n(v.length, 2) + "\0\0\0\0" + n(R, 4) + n(i, 4) + b + k + v
                                            };
                                        }
                                        var s = e("../utils"), o = e("../stream/GenericWorker"), a = e("../utf8"), l = e("../crc32"), c = e("../signature");
                                        function u(e, t, r, n) {
                                            o.call(this, "ZipFileWorker"), this.bytesWritten = 0, this.zipComment = t, this.zipPlatform = r, this.encodeFileName = n, this.streamFiles = e, this.accumulate = !1, this.contentBuffer = [], this.dirRecords = [], this.currentSourceOffset = 0, this.entriesCount = 0, this.currentFile = null, this._sources = [];
                                        }
                                        s.inherits(u, o), u.prototype.push = function(e) {
                                            var t = e.meta.percent || 0, r = this.entriesCount, n = this._sources.length;
                                            this.accumulate ? this.contentBuffer.push(e) : (this.bytesWritten += e.data.length, o.prototype.push.call(this, {
                                                data: e.data,
                                                meta: {
                                                    currentFile: this.currentFile,
                                                    percent: r ? (t + 100 * (r - n - 1)) / r : 100
                                                }
                                            }));
                                        }, u.prototype.openedSource = function(e) {
                                            this.currentSourceOffset = this.bytesWritten, this.currentFile = e.file.name;
                                            var t = this.streamFiles && !e.file.dir;
                                            if (t) {
                                                var r = i(e, t, !1, this.currentSourceOffset, this.zipPlatform, this.encodeFileName);
                                                this.push({
                                                    data: r.fileRecord,
                                                    meta: {
                                                        percent: 0
                                                    }
                                                });
                                            } else this.accumulate = !0;
                                        }, u.prototype.closedSource = function(e) {
                                            this.accumulate = !1;
                                            var t = this.streamFiles && !e.file.dir, r = i(e, t, !0, this.currentSourceOffset, this.zipPlatform, this.encodeFileName);
                                            if (this.dirRecords.push(r.dirRecord), t) this.push({
                                                data: function(e) {
                                                    return c.DATA_DESCRIPTOR + n(e.crc32, 4) + n(e.compressedSize, 4) + n(e.uncompressedSize, 4);
                                                }(e),
                                                meta: {
                                                    percent: 100
                                                }
                                            });
                                            else for(this.push({
                                                data: r.fileRecord,
                                                meta: {
                                                    percent: 0
                                                }
                                            }); this.contentBuffer.length;)this.push(this.contentBuffer.shift());
                                            this.currentFile = null;
                                        }, u.prototype.flush = function() {
                                            for(var e = this.bytesWritten, t = 0; t < this.dirRecords.length; t++)this.push({
                                                data: this.dirRecords[t],
                                                meta: {
                                                    percent: 100
                                                }
                                            });
                                            var r = this.bytesWritten - e, i = function(e, t, r, i, o) {
                                                var a = s.transformTo("string", o(i));
                                                return c.CENTRAL_DIRECTORY_END + "\0\0\0\0" + n(e, 2) + n(e, 2) + n(t, 4) + n(r, 4) + n(a.length, 2) + a;
                                            }(this.dirRecords.length, r, e, this.zipComment, this.encodeFileName);
                                            this.push({
                                                data: i,
                                                meta: {
                                                    percent: 100
                                                }
                                            });
                                        }, u.prototype.prepareNextSource = function() {
                                            this.previous = this._sources.shift(), this.openedSource(this.previous.streamInfo), this.isPaused ? this.previous.pause() : this.previous.resume();
                                        }, u.prototype.registerPrevious = function(e) {
                                            this._sources.push(e);
                                            var t = this;
                                            return e.on("data", function(e) {
                                                t.processChunk(e);
                                            }), e.on("end", function() {
                                                t.closedSource(t.previous.streamInfo), t._sources.length ? t.prepareNextSource() : t.end();
                                            }), e.on("error", function(e) {
                                                t.error(e);
                                            }), this;
                                        }, u.prototype.resume = function() {
                                            return !!o.prototype.resume.call(this) && (!this.previous && this._sources.length ? (this.prepareNextSource(), !0) : this.previous || this._sources.length || this.generatedError ? void 0 : (this.end(), !0));
                                        }, u.prototype.error = function(e) {
                                            var t = this._sources;
                                            if (!o.prototype.error.call(this, e)) return !1;
                                            for(var r = 0; r < t.length; r++)try {
                                                t[r].error(e);
                                            } catch (e) {}
                                            return !0;
                                        }, u.prototype.lock = function() {
                                            o.prototype.lock.call(this);
                                            for(var e = this._sources, t = 0; t < e.length; t++)e[t].lock();
                                        }, t.exports = u;
                                    },
                                    {
                                        "../crc32": 4,
                                        "../signature": 23,
                                        "../stream/GenericWorker": 28,
                                        "../utf8": 31,
                                        "../utils": 32
                                    }
                                ],
                                9: [
                                    function(e, t, r) {
                                        var n = e("../compressions"), i = e("./ZipFileWorker");
                                        r.generateWorker = function(e, t, r) {
                                            var s = new i(t.streamFiles, r, t.platform, t.encodeFileName), o = 0;
                                            try {
                                                e.forEach(function(e, r) {
                                                    o++;
                                                    var i = function(e, t) {
                                                        var r = e || t, i = n[r];
                                                        if (!i) throw new Error(r + " is not a valid compression method !");
                                                        return i;
                                                    }(r.options.compression, t.compression), a = r.options.compressionOptions || t.compressionOptions || {}, l = r.dir, c = r.date;
                                                    r._compressWorker(i, a).withStreamInfo("file", {
                                                        name: e,
                                                        dir: l,
                                                        date: c,
                                                        comment: r.comment || "",
                                                        unixPermissions: r.unixPermissions,
                                                        dosPermissions: r.dosPermissions
                                                    }).pipe(s);
                                                }), s.entriesCount = o;
                                            } catch (e) {
                                                s.error(e);
                                            }
                                            return s;
                                        };
                                    },
                                    {
                                        "../compressions": 3,
                                        "./ZipFileWorker": 8
                                    }
                                ],
                                10: [
                                    function(e, t, r) {
                                        function n() {
                                            if (!(this instanceof n)) return new n;
                                            if (arguments.length) throw new Error("The constructor with parameters has been removed in JSZip 3.0, please check the upgrade guide.");
                                            this.files = Object.create(null), this.comment = null, this.root = "", this.clone = function() {
                                                var e = new n;
                                                for(var t in this)"function" != typeof this[t] && (e[t] = this[t]);
                                                return e;
                                            };
                                        }
                                        (n.prototype = e("./object")).loadAsync = e("./load"), n.support = e("./support"), n.defaults = e("./defaults"), n.version = "3.10.1", n.loadAsync = function(e, t) {
                                            return (new n).loadAsync(e, t);
                                        }, n.external = e("./external"), t.exports = n;
                                    },
                                    {
                                        "./defaults": 5,
                                        "./external": 6,
                                        "./load": 11,
                                        "./object": 15,
                                        "./support": 30
                                    }
                                ],
                                11: [
                                    function(e, t, r) {
                                        var n = e("./utils"), i = e("./external"), s = e("./utf8"), o = e("./zipEntries"), a = e("./stream/Crc32Probe"), l = e("./nodejsUtils");
                                        function c(e) {
                                            return new i.Promise(function(t, r) {
                                                var n = e.decompressed.getContentWorker().pipe(new a);
                                                n.on("error", function(e) {
                                                    r(e);
                                                }).on("end", function() {
                                                    n.streamInfo.crc32 !== e.decompressed.crc32 ? r(new Error("Corrupted zip : CRC32 mismatch")) : t();
                                                }).resume();
                                            });
                                        }
                                        t.exports = function(e, t) {
                                            var r = this;
                                            return t = n.extend(t || {}, {
                                                base64: !1,
                                                checkCRC32: !1,
                                                optimizedBinaryString: !1,
                                                createFolders: !1,
                                                decodeFileName: s.utf8decode
                                            }), l.isNode && l.isStream(e) ? i.Promise.reject(new Error("JSZip can't accept a stream when loading a zip file.")) : n.prepareContent("the loaded zip file", e, !0, t.optimizedBinaryString, t.base64).then(function(e) {
                                                var r = new o(t);
                                                return r.load(e), r;
                                            }).then(function(e) {
                                                var r = [
                                                    i.Promise.resolve(e)
                                                ], n = e.files;
                                                if (t.checkCRC32) for(var s = 0; s < n.length; s++)r.push(c(n[s]));
                                                return i.Promise.all(r);
                                            }).then(function(e) {
                                                for(var i = e.shift(), s = i.files, o = 0; o < s.length; o++){
                                                    var a = s[o], l = a.fileNameStr, c = n.resolve(a.fileNameStr);
                                                    r.file(c, a.decompressed, {
                                                        binary: !0,
                                                        optimizedBinaryString: !0,
                                                        date: a.date,
                                                        dir: a.dir,
                                                        comment: a.fileCommentStr.length ? a.fileCommentStr : null,
                                                        unixPermissions: a.unixPermissions,
                                                        dosPermissions: a.dosPermissions,
                                                        createFolders: t.createFolders
                                                    }), a.dir || (r.file(c).unsafeOriginalName = l);
                                                }
                                                return i.zipComment.length && (r.comment = i.zipComment), r;
                                            });
                                        };
                                    },
                                    {
                                        "./external": 6,
                                        "./nodejsUtils": 14,
                                        "./stream/Crc32Probe": 25,
                                        "./utf8": 31,
                                        "./utils": 32,
                                        "./zipEntries": 33
                                    }
                                ],
                                12: [
                                    function(e, t, r) {
                                        var n = e("../utils"), i = e("../stream/GenericWorker");
                                        function s(e, t) {
                                            i.call(this, "Nodejs stream input adapter for " + e), this._upstreamEnded = !1, this._bindStream(t);
                                        }
                                        n.inherits(s, i), s.prototype._bindStream = function(e) {
                                            var t = this;
                                            (this._stream = e).pause(), e.on("data", function(e) {
                                                t.push({
                                                    data: e,
                                                    meta: {
                                                        percent: 0
                                                    }
                                                });
                                            }).on("error", function(e) {
                                                t.isPaused ? this.generatedError = e : t.error(e);
                                            }).on("end", function() {
                                                t.isPaused ? t._upstreamEnded = !0 : t.end();
                                            });
                                        }, s.prototype.pause = function() {
                                            return !!i.prototype.pause.call(this) && (this._stream.pause(), !0);
                                        }, s.prototype.resume = function() {
                                            return !!i.prototype.resume.call(this) && (this._upstreamEnded ? this.end() : this._stream.resume(), !0);
                                        }, t.exports = s;
                                    },
                                    {
                                        "../stream/GenericWorker": 28,
                                        "../utils": 32
                                    }
                                ],
                                13: [
                                    function(e, t, r) {
                                        var n = e("readable-stream").Readable;
                                        function i(e, t, r) {
                                            n.call(this, t), this._helper = e;
                                            var i = this;
                                            e.on("data", function(e, t) {
                                                i.push(e) || i._helper.pause(), r && r(t);
                                            }).on("error", function(e) {
                                                i.emit("error", e);
                                            }).on("end", function() {
                                                i.push(null);
                                            });
                                        }
                                        e("../utils").inherits(i, n), i.prototype._read = function() {
                                            this._helper.resume();
                                        }, t.exports = i;
                                    },
                                    {
                                        "../utils": 32,
                                        "readable-stream": 16
                                    }
                                ],
                                14: [
                                    function(e, t, r) {
                                        t.exports = {
                                            isNode: void 0 !== s,
                                            newBufferFrom: function(e, t) {
                                                if (s.from && s.from !== Uint8Array.from) return s.from(e, t);
                                                if ("number" == typeof e) throw new Error('The "data" argument must not be a number');
                                                return new s(e, t);
                                            },
                                            allocBuffer: function(e) {
                                                if (s.alloc) return s.alloc(e);
                                                var t = new s(e);
                                                return t.fill(0), t;
                                            },
                                            isBuffer: function(e) {
                                                return s.isBuffer(e);
                                            },
                                            isStream: function(e) {
                                                return e && "function" == typeof e.on && "function" == typeof e.pause && "function" == typeof e.resume;
                                            }
                                        };
                                    },
                                    {}
                                ],
                                15: [
                                    function(e, t, r) {
                                        function n(e, t, r) {
                                            var n, i = s.getTypeOf(t), a = s.extend(r || {}, l);
                                            a.date = a.date || new Date, null !== a.compression && (a.compression = a.compression.toUpperCase()), "string" == typeof a.unixPermissions && (a.unixPermissions = parseInt(a.unixPermissions, 8)), a.unixPermissions && 16384 & a.unixPermissions && (a.dir = !0), a.dosPermissions && 16 & a.dosPermissions && (a.dir = !0), a.dir && (e = m(e)), a.createFolders && (n = p(e)) && b.call(this, n, !0);
                                            var h = "string" === i && !1 === a.binary && !1 === a.base64;
                                            r && void 0 !== r.binary || (a.binary = !h), (t instanceof c && 0 === t.uncompressedSize || a.dir || !t || 0 === t.length) && (a.base64 = !1, a.binary = !0, t = "", a.compression = "STORE", i = "string");
                                            var g;
                                            g = t instanceof c || t instanceof o ? t : f.isNode && f.isStream(t) ? new d(e, t) : s.prepareContent(e, t, a.binary, a.optimizedBinaryString, a.base64);
                                            var y = new u(e, g, a);
                                            this.files[e] = y;
                                        }
                                        var i = e("./utf8"), s = e("./utils"), o = e("./stream/GenericWorker"), a = e("./stream/StreamHelper"), l = e("./defaults"), c = e("./compressedObject"), u = e("./zipObject"), h = e("./generate"), f = e("./nodejsUtils"), d = e("./nodejs/NodejsStreamInputAdapter"), p = function(e) {
                                            "/" === e.slice(-1) && (e = e.substring(0, e.length - 1));
                                            var t = e.lastIndexOf("/");
                                            return 0 < t ? e.substring(0, t) : "";
                                        }, m = function(e) {
                                            return "/" !== e.slice(-1) && (e += "/"), e;
                                        }, b = function(e, t) {
                                            return t = void 0 !== t ? t : l.createFolders, e = m(e), this.files[e] || n.call(this, e, null, {
                                                dir: !0,
                                                createFolders: t
                                            }), this.files[e];
                                        };
                                        function g(e) {
                                            return "[object RegExp]" === Object.prototype.toString.call(e);
                                        }
                                        var y = {
                                            load: function() {
                                                throw new Error("This method has been removed in JSZip 3.0, please check the upgrade guide.");
                                            },
                                            forEach: function(e) {
                                                var t, r, n;
                                                for(t in this.files)n = this.files[t], (r = t.slice(this.root.length, t.length)) && t.slice(0, this.root.length) === this.root && e(r, n);
                                            },
                                            filter: function(e) {
                                                var t = [];
                                                return this.forEach(function(r, n) {
                                                    e(r, n) && t.push(n);
                                                }), t;
                                            },
                                            file: function(e, t, r) {
                                                if (1 !== arguments.length) return e = this.root + e, n.call(this, e, t, r), this;
                                                if (g(e)) {
                                                    var i = e;
                                                    return this.filter(function(e, t) {
                                                        return !t.dir && i.test(e);
                                                    });
                                                }
                                                var s = this.files[this.root + e];
                                                return s && !s.dir ? s : null;
                                            },
                                            folder: function(e) {
                                                if (!e) return this;
                                                if (g(e)) return this.filter(function(t, r) {
                                                    return r.dir && e.test(t);
                                                });
                                                var t = this.root + e, r = b.call(this, t), n = this.clone();
                                                return n.root = r.name, n;
                                            },
                                            remove: function(e) {
                                                e = this.root + e;
                                                var t = this.files[e];
                                                if (t || ("/" !== e.slice(-1) && (e += "/"), t = this.files[e]), t && !t.dir) delete this.files[e];
                                                else for(var r = this.filter(function(t, r) {
                                                    return r.name.slice(0, e.length) === e;
                                                }), n = 0; n < r.length; n++)delete this.files[r[n].name];
                                                return this;
                                            },
                                            generate: function() {
                                                throw new Error("This method has been removed in JSZip 3.0, please check the upgrade guide.");
                                            },
                                            generateInternalStream: function(e) {
                                                var t, r = {};
                                                try {
                                                    if ((r = s.extend(e || {}, {
                                                        streamFiles: !1,
                                                        compression: "STORE",
                                                        compressionOptions: null,
                                                        type: "",
                                                        platform: "DOS",
                                                        comment: null,
                                                        mimeType: "application/zip",
                                                        encodeFileName: i.utf8encode
                                                    })).type = r.type.toLowerCase(), r.compression = r.compression.toUpperCase(), "binarystring" === r.type && (r.type = "string"), !r.type) throw new Error("No output type specified.");
                                                    s.checkSupport(r.type), "darwin" !== r.platform && "freebsd" !== r.platform && "linux" !== r.platform && "sunos" !== r.platform || (r.platform = "UNIX"), "win32" === r.platform && (r.platform = "DOS");
                                                    var n = r.comment || this.comment || "";
                                                    t = h.generateWorker(this, r, n);
                                                } catch (e) {
                                                    (t = new o("error")).error(e);
                                                }
                                                return new a(t, r.type || "string", r.mimeType);
                                            },
                                            generateAsync: function(e, t) {
                                                return this.generateInternalStream(e).accumulate(t);
                                            },
                                            generateNodeStream: function(e, t) {
                                                return (e = e || {}).type || (e.type = "nodebuffer"), this.generateInternalStream(e).toNodejsStream(t);
                                            }
                                        };
                                        t.exports = y;
                                    },
                                    {
                                        "./compressedObject": 2,
                                        "./defaults": 5,
                                        "./generate": 9,
                                        "./nodejs/NodejsStreamInputAdapter": 12,
                                        "./nodejsUtils": 14,
                                        "./stream/GenericWorker": 28,
                                        "./stream/StreamHelper": 29,
                                        "./utf8": 31,
                                        "./utils": 32,
                                        "./zipObject": 35
                                    }
                                ],
                                16: [
                                    function(e, t, r) {
                                        t.exports = e("stream");
                                    },
                                    {
                                        stream: void 0
                                    }
                                ],
                                17: [
                                    function(e, t, r) {
                                        var n = e("./DataReader");
                                        function i(e) {
                                            n.call(this, e);
                                            for(var t = 0; t < this.data.length; t++)e[t] = 255 & e[t];
                                        }
                                        e("../utils").inherits(i, n), i.prototype.byteAt = function(e) {
                                            return this.data[this.zero + e];
                                        }, i.prototype.lastIndexOfSignature = function(e) {
                                            for(var t = e.charCodeAt(0), r = e.charCodeAt(1), n = e.charCodeAt(2), i = e.charCodeAt(3), s = this.length - 4; 0 <= s; --s)if (this.data[s] === t && this.data[s + 1] === r && this.data[s + 2] === n && this.data[s + 3] === i) return s - this.zero;
                                            return -1;
                                        }, i.prototype.readAndCheckSignature = function(e) {
                                            var t = e.charCodeAt(0), r = e.charCodeAt(1), n = e.charCodeAt(2), i = e.charCodeAt(3), s = this.readData(4);
                                            return t === s[0] && r === s[1] && n === s[2] && i === s[3];
                                        }, i.prototype.readData = function(e) {
                                            if (this.checkOffset(e), 0 === e) return [];
                                            var t = this.data.slice(this.zero + this.index, this.zero + this.index + e);
                                            return this.index += e, t;
                                        }, t.exports = i;
                                    },
                                    {
                                        "../utils": 32,
                                        "./DataReader": 18
                                    }
                                ],
                                18: [
                                    function(e, t, r) {
                                        var n = e("../utils");
                                        function i(e) {
                                            this.data = e, this.length = e.length, this.index = 0, this.zero = 0;
                                        }
                                        i.prototype = {
                                            checkOffset: function(e) {
                                                this.checkIndex(this.index + e);
                                            },
                                            checkIndex: function(e) {
                                                if (this.length < this.zero + e || e < 0) throw new Error("End of data reached (data length = " + this.length + ", asked index = " + e + "). Corrupted zip ?");
                                            },
                                            setIndex: function(e) {
                                                this.checkIndex(e), this.index = e;
                                            },
                                            skip: function(e) {
                                                this.setIndex(this.index + e);
                                            },
                                            byteAt: function() {},
                                            readInt: function(e) {
                                                var t, r = 0;
                                                for(this.checkOffset(e), t = this.index + e - 1; t >= this.index; t--)r = (r << 8) + this.byteAt(t);
                                                return this.index += e, r;
                                            },
                                            readString: function(e) {
                                                return n.transformTo("string", this.readData(e));
                                            },
                                            readData: function() {},
                                            lastIndexOfSignature: function() {},
                                            readAndCheckSignature: function() {},
                                            readDate: function() {
                                                var e = this.readInt(4);
                                                return new Date(Date.UTC(1980 + (e >> 25 & 127), (e >> 21 & 15) - 1, e >> 16 & 31, e >> 11 & 31, e >> 5 & 63, (31 & e) << 1));
                                            }
                                        }, t.exports = i;
                                    },
                                    {
                                        "../utils": 32
                                    }
                                ],
                                19: [
                                    function(e, t, r) {
                                        var n = e("./Uint8ArrayReader");
                                        function i(e) {
                                            n.call(this, e);
                                        }
                                        e("../utils").inherits(i, n), i.prototype.readData = function(e) {
                                            this.checkOffset(e);
                                            var t = this.data.slice(this.zero + this.index, this.zero + this.index + e);
                                            return this.index += e, t;
                                        }, t.exports = i;
                                    },
                                    {
                                        "../utils": 32,
                                        "./Uint8ArrayReader": 21
                                    }
                                ],
                                20: [
                                    function(e, t, r) {
                                        var n = e("./DataReader");
                                        function i(e) {
                                            n.call(this, e);
                                        }
                                        e("../utils").inherits(i, n), i.prototype.byteAt = function(e) {
                                            return this.data.charCodeAt(this.zero + e);
                                        }, i.prototype.lastIndexOfSignature = function(e) {
                                            return this.data.lastIndexOf(e) - this.zero;
                                        }, i.prototype.readAndCheckSignature = function(e) {
                                            return e === this.readData(4);
                                        }, i.prototype.readData = function(e) {
                                            this.checkOffset(e);
                                            var t = this.data.slice(this.zero + this.index, this.zero + this.index + e);
                                            return this.index += e, t;
                                        }, t.exports = i;
                                    },
                                    {
                                        "../utils": 32,
                                        "./DataReader": 18
                                    }
                                ],
                                21: [
                                    function(e, t, r) {
                                        var n = e("./ArrayReader");
                                        function i(e) {
                                            n.call(this, e);
                                        }
                                        e("../utils").inherits(i, n), i.prototype.readData = function(e) {
                                            if (this.checkOffset(e), 0 === e) return new Uint8Array(0);
                                            var t = this.data.subarray(this.zero + this.index, this.zero + this.index + e);
                                            return this.index += e, t;
                                        }, t.exports = i;
                                    },
                                    {
                                        "../utils": 32,
                                        "./ArrayReader": 17
                                    }
                                ],
                                22: [
                                    function(e, t, r) {
                                        var n = e("../utils"), i = e("../support"), s = e("./ArrayReader"), o = e("./StringReader"), a = e("./NodeBufferReader"), l = e("./Uint8ArrayReader");
                                        t.exports = function(e) {
                                            var t = n.getTypeOf(e);
                                            return n.checkSupport(t), "string" !== t || i.uint8array ? "nodebuffer" === t ? new a(e) : i.uint8array ? new l(n.transformTo("uint8array", e)) : new s(n.transformTo("array", e)) : new o(e);
                                        };
                                    },
                                    {
                                        "../support": 30,
                                        "../utils": 32,
                                        "./ArrayReader": 17,
                                        "./NodeBufferReader": 19,
                                        "./StringReader": 20,
                                        "./Uint8ArrayReader": 21
                                    }
                                ],
                                23: [
                                    function(e, t, r) {
                                        r.LOCAL_FILE_HEADER = "PK\x03\x04", r.CENTRAL_FILE_HEADER = "PK\x01\x02", r.CENTRAL_DIRECTORY_END = "PK\x05\x06", r.ZIP64_CENTRAL_DIRECTORY_LOCATOR = "PK\x06\x07", r.ZIP64_CENTRAL_DIRECTORY_END = "PK\x06\x06", r.DATA_DESCRIPTOR = "PK\x07\b";
                                    },
                                    {}
                                ],
                                24: [
                                    function(e, t, r) {
                                        var n = e("./GenericWorker"), i = e("../utils");
                                        function s(e) {
                                            n.call(this, "ConvertWorker to " + e), this.destType = e;
                                        }
                                        i.inherits(s, n), s.prototype.processChunk = function(e) {
                                            this.push({
                                                data: i.transformTo(this.destType, e.data),
                                                meta: e.meta
                                            });
                                        }, t.exports = s;
                                    },
                                    {
                                        "../utils": 32,
                                        "./GenericWorker": 28
                                    }
                                ],
                                25: [
                                    function(e, t, r) {
                                        var n = e("./GenericWorker"), i = e("../crc32");
                                        function s() {
                                            n.call(this, "Crc32Probe"), this.withStreamInfo("crc32", 0);
                                        }
                                        e("../utils").inherits(s, n), s.prototype.processChunk = function(e) {
                                            this.streamInfo.crc32 = i(e.data, this.streamInfo.crc32 || 0), this.push(e);
                                        }, t.exports = s;
                                    },
                                    {
                                        "../crc32": 4,
                                        "../utils": 32,
                                        "./GenericWorker": 28
                                    }
                                ],
                                26: [
                                    function(e, t, r) {
                                        var n = e("../utils"), i = e("./GenericWorker");
                                        function s(e) {
                                            i.call(this, "DataLengthProbe for " + e), this.propName = e, this.withStreamInfo(e, 0);
                                        }
                                        n.inherits(s, i), s.prototype.processChunk = function(e) {
                                            if (e) {
                                                var t = this.streamInfo[this.propName] || 0;
                                                this.streamInfo[this.propName] = t + e.data.length;
                                            }
                                            i.prototype.processChunk.call(this, e);
                                        }, t.exports = s;
                                    },
                                    {
                                        "../utils": 32,
                                        "./GenericWorker": 28
                                    }
                                ],
                                27: [
                                    function(e, t, r) {
                                        var n = e("../utils"), i = e("./GenericWorker");
                                        function s(e) {
                                            i.call(this, "DataWorker");
                                            var t = this;
                                            this.dataIsReady = !1, this.index = 0, this.max = 0, this.data = null, this.type = "", this._tickScheduled = !1, e.then(function(e) {
                                                t.dataIsReady = !0, t.data = e, t.max = e && e.length || 0, t.type = n.getTypeOf(e), t.isPaused || t._tickAndRepeat();
                                            }, function(e) {
                                                t.error(e);
                                            });
                                        }
                                        n.inherits(s, i), s.prototype.cleanUp = function() {
                                            i.prototype.cleanUp.call(this), this.data = null;
                                        }, s.prototype.resume = function() {
                                            return !!i.prototype.resume.call(this) && (!this._tickScheduled && this.dataIsReady && (this._tickScheduled = !0, n.delay(this._tickAndRepeat, [], this)), !0);
                                        }, s.prototype._tickAndRepeat = function() {
                                            this._tickScheduled = !1, this.isPaused || this.isFinished || (this._tick(), this.isFinished || (n.delay(this._tickAndRepeat, [], this), this._tickScheduled = !0));
                                        }, s.prototype._tick = function() {
                                            if (this.isPaused || this.isFinished) return !1;
                                            var e = null, t = Math.min(this.max, this.index + 16384);
                                            if (this.index >= this.max) return this.end();
                                            switch(this.type){
                                                case "string":
                                                    e = this.data.substring(this.index, t);
                                                    break;
                                                case "uint8array":
                                                    e = this.data.subarray(this.index, t);
                                                    break;
                                                case "array":
                                                case "nodebuffer":
                                                    e = this.data.slice(this.index, t);
                                            }
                                            return this.index = t, this.push({
                                                data: e,
                                                meta: {
                                                    percent: this.max ? this.index / this.max * 100 : 0
                                                }
                                            });
                                        }, t.exports = s;
                                    },
                                    {
                                        "../utils": 32,
                                        "./GenericWorker": 28
                                    }
                                ],
                                28: [
                                    function(e, t, r) {
                                        function n(e) {
                                            this.name = e || "default", this.streamInfo = {}, this.generatedError = null, this.extraStreamInfo = {}, this.isPaused = !0, this.isFinished = !1, this.isLocked = !1, this._listeners = {
                                                data: [],
                                                end: [],
                                                error: []
                                            }, this.previous = null;
                                        }
                                        n.prototype = {
                                            push: function(e) {
                                                this.emit("data", e);
                                            },
                                            end: function() {
                                                if (this.isFinished) return !1;
                                                this.flush();
                                                try {
                                                    this.emit("end"), this.cleanUp(), this.isFinished = !0;
                                                } catch (e) {
                                                    this.emit("error", e);
                                                }
                                                return !0;
                                            },
                                            error: function(e) {
                                                return !this.isFinished && (this.isPaused ? this.generatedError = e : (this.isFinished = !0, this.emit("error", e), this.previous && this.previous.error(e), this.cleanUp()), !0);
                                            },
                                            on: function(e, t) {
                                                return this._listeners[e].push(t), this;
                                            },
                                            cleanUp: function() {
                                                this.streamInfo = this.generatedError = this.extraStreamInfo = null, this._listeners = [];
                                            },
                                            emit: function(e, t) {
                                                if (this._listeners[e]) for(var r = 0; r < this._listeners[e].length; r++)this._listeners[e][r].call(this, t);
                                            },
                                            pipe: function(e) {
                                                return e.registerPrevious(this);
                                            },
                                            registerPrevious: function(e) {
                                                if (this.isLocked) throw new Error("The stream '" + this + "' has already been used.");
                                                this.streamInfo = e.streamInfo, this.mergeStreamInfo(), this.previous = e;
                                                var t = this;
                                                return e.on("data", function(e) {
                                                    t.processChunk(e);
                                                }), e.on("end", function() {
                                                    t.end();
                                                }), e.on("error", function(e) {
                                                    t.error(e);
                                                }), this;
                                            },
                                            pause: function() {
                                                return !this.isPaused && !this.isFinished && (this.isPaused = !0, this.previous && this.previous.pause(), !0);
                                            },
                                            resume: function() {
                                                if (!this.isPaused || this.isFinished) return !1;
                                                var e = this.isPaused = !1;
                                                return this.generatedError && (this.error(this.generatedError), e = !0), this.previous && this.previous.resume(), !e;
                                            },
                                            flush: function() {},
                                            processChunk: function(e) {
                                                this.push(e);
                                            },
                                            withStreamInfo: function(e, t) {
                                                return this.extraStreamInfo[e] = t, this.mergeStreamInfo(), this;
                                            },
                                            mergeStreamInfo: function() {
                                                for(var e in this.extraStreamInfo)Object.prototype.hasOwnProperty.call(this.extraStreamInfo, e) && (this.streamInfo[e] = this.extraStreamInfo[e]);
                                            },
                                            lock: function() {
                                                if (this.isLocked) throw new Error("The stream '" + this + "' has already been used.");
                                                this.isLocked = !0, this.previous && this.previous.lock();
                                            },
                                            toString: function() {
                                                var e = "Worker " + this.name;
                                                return this.previous ? this.previous + " -> " + e : e;
                                            }
                                        }, t.exports = n;
                                    },
                                    {}
                                ],
                                29: [
                                    function(e, t, r) {
                                        var n = e("../utils"), i = e("./ConvertWorker"), o = e("./GenericWorker"), a = e("../base64"), l = e("../support"), c = e("../external"), u = null;
                                        if (l.nodestream) try {
                                            u = e("../nodejs/NodejsStreamOutputAdapter");
                                        } catch (e) {}
                                        function h(e, t, r) {
                                            var s = t;
                                            switch(t){
                                                case "blob":
                                                case "arraybuffer":
                                                    s = "uint8array";
                                                    break;
                                                case "base64":
                                                    s = "string";
                                            }
                                            try {
                                                this._internalType = s, this._outputType = t, this._mimeType = r, n.checkSupport(s), this._worker = e.pipe(new i(s)), e.lock();
                                            } catch (e) {
                                                this._worker = new o("error"), this._worker.error(e);
                                            }
                                        }
                                        h.prototype = {
                                            accumulate: function(e) {
                                                return function(e, t) {
                                                    return new c.Promise(function(r, i) {
                                                        var o = [], l = e._internalType, c = e._outputType, u = e._mimeType;
                                                        e.on("data", function(e, r) {
                                                            o.push(e), t && t(r);
                                                        }).on("error", function(e) {
                                                            o = [], i(e);
                                                        }).on("end", function() {
                                                            try {
                                                                var e = function(e, t, r) {
                                                                    switch(e){
                                                                        case "blob":
                                                                            return n.newBlob(n.transformTo("arraybuffer", t), r);
                                                                        case "base64":
                                                                            return a.encode(t);
                                                                        default:
                                                                            return n.transformTo(e, t);
                                                                    }
                                                                }(c, function(e, t) {
                                                                    var r, n = 0, i = null, o = 0;
                                                                    for(r = 0; r < t.length; r++)o += t[r].length;
                                                                    switch(e){
                                                                        case "string":
                                                                            return t.join("");
                                                                        case "array":
                                                                            return Array.prototype.concat.apply([], t);
                                                                        case "uint8array":
                                                                            for(i = new Uint8Array(o), r = 0; r < t.length; r++)i.set(t[r], n), n += t[r].length;
                                                                            return i;
                                                                        case "nodebuffer":
                                                                            return s.concat(t);
                                                                        default:
                                                                            throw new Error("concat : unsupported type '" + e + "'");
                                                                    }
                                                                }(l, o), u);
                                                                r(e);
                                                            } catch (e) {
                                                                i(e);
                                                            }
                                                            o = [];
                                                        }).resume();
                                                    });
                                                }(this, e);
                                            },
                                            on: function(e, t) {
                                                var r = this;
                                                return "data" === e ? this._worker.on(e, function(e) {
                                                    t.call(r, e.data, e.meta);
                                                }) : this._worker.on(e, function() {
                                                    n.delay(t, arguments, r);
                                                }), this;
                                            },
                                            resume: function() {
                                                return n.delay(this._worker.resume, [], this._worker), this;
                                            },
                                            pause: function() {
                                                return this._worker.pause(), this;
                                            },
                                            toNodejsStream: function(e) {
                                                if (n.checkSupport("nodestream"), "nodebuffer" !== this._outputType) throw new Error(this._outputType + " is not supported by this method");
                                                return new u(this, {
                                                    objectMode: "nodebuffer" !== this._outputType
                                                }, e);
                                            }
                                        }, t.exports = h;
                                    },
                                    {
                                        "../base64": 1,
                                        "../external": 6,
                                        "../nodejs/NodejsStreamOutputAdapter": 13,
                                        "../support": 30,
                                        "../utils": 32,
                                        "./ConvertWorker": 24,
                                        "./GenericWorker": 28
                                    }
                                ],
                                30: [
                                    function(e, t, r) {
                                        if (r.base64 = !0, r.array = !0, r.string = !0, r.arraybuffer = "undefined" != typeof ArrayBuffer && "undefined" != typeof Uint8Array, r.nodebuffer = void 0 !== s, r.uint8array = "undefined" != typeof Uint8Array, "undefined" == typeof ArrayBuffer) r.blob = !1;
                                        else {
                                            var n = new ArrayBuffer(0);
                                            try {
                                                r.blob = 0 === new Blob([
                                                    n
                                                ], {
                                                    type: "application/zip"
                                                }).size;
                                            } catch (e) {
                                                try {
                                                    var i = new (self.BlobBuilder || self.WebKitBlobBuilder || self.MozBlobBuilder || self.MSBlobBuilder);
                                                    i.append(n), r.blob = 0 === i.getBlob("application/zip").size;
                                                } catch (e) {
                                                    r.blob = !1;
                                                }
                                            }
                                        }
                                        try {
                                            r.nodestream = !!e("readable-stream").Readable;
                                        } catch (e) {
                                            r.nodestream = !1;
                                        }
                                    },
                                    {
                                        "readable-stream": 16
                                    }
                                ],
                                31: [
                                    function(e, t, r) {
                                        for(var n = e("./utils"), i = e("./support"), s = e("./nodejsUtils"), o = e("./stream/GenericWorker"), a = new Array(256), l = 0; l < 256; l++)a[l] = 252 <= l ? 6 : 248 <= l ? 5 : 240 <= l ? 4 : 224 <= l ? 3 : 192 <= l ? 2 : 1;
                                        function c() {
                                            o.call(this, "utf-8 decode"), this.leftOver = null;
                                        }
                                        function u() {
                                            o.call(this, "utf-8 encode");
                                        }
                                        a[254] = a[254] = 1, r.utf8encode = function(e) {
                                            return i.nodebuffer ? s.newBufferFrom(e, "utf-8") : function(e) {
                                                var t, r, n, s, o, a = e.length, l = 0;
                                                for(s = 0; s < a; s++)55296 == (64512 & (r = e.charCodeAt(s))) && s + 1 < a && 56320 == (64512 & (n = e.charCodeAt(s + 1))) && (r = 65536 + (r - 55296 << 10) + (n - 56320), s++), l += r < 128 ? 1 : r < 2048 ? 2 : r < 65536 ? 3 : 4;
                                                for(t = i.uint8array ? new Uint8Array(l) : new Array(l), s = o = 0; o < l; s++)55296 == (64512 & (r = e.charCodeAt(s))) && s + 1 < a && 56320 == (64512 & (n = e.charCodeAt(s + 1))) && (r = 65536 + (r - 55296 << 10) + (n - 56320), s++), r < 128 ? t[o++] = r : (r < 2048 ? t[o++] = 192 | r >>> 6 : (r < 65536 ? t[o++] = 224 | r >>> 12 : (t[o++] = 240 | r >>> 18, t[o++] = 128 | r >>> 12 & 63), t[o++] = 128 | r >>> 6 & 63), t[o++] = 128 | 63 & r);
                                                return t;
                                            }(e);
                                        }, r.utf8decode = function(e) {
                                            return i.nodebuffer ? n.transformTo("nodebuffer", e).toString("utf-8") : function(e) {
                                                var t, r, i, s, o = e.length, l = new Array(2 * o);
                                                for(t = r = 0; t < o;)if ((i = e[t++]) < 128) l[r++] = i;
                                                else if (4 < (s = a[i])) l[r++] = 65533, t += s - 1;
                                                else {
                                                    for(i &= 2 === s ? 31 : 3 === s ? 15 : 7; 1 < s && t < o;)i = i << 6 | 63 & e[t++], s--;
                                                    1 < s ? l[r++] = 65533 : i < 65536 ? l[r++] = i : (i -= 65536, l[r++] = 55296 | i >> 10 & 1023, l[r++] = 56320 | 1023 & i);
                                                }
                                                return l.length !== r && (l.subarray ? l = l.subarray(0, r) : l.length = r), n.applyFromCharCode(l);
                                            }(e = n.transformTo(i.uint8array ? "uint8array" : "array", e));
                                        }, n.inherits(c, o), c.prototype.processChunk = function(e) {
                                            var t = n.transformTo(i.uint8array ? "uint8array" : "array", e.data);
                                            if (this.leftOver && this.leftOver.length) {
                                                if (i.uint8array) {
                                                    var s = t;
                                                    (t = new Uint8Array(s.length + this.leftOver.length)).set(this.leftOver, 0), t.set(s, this.leftOver.length);
                                                } else t = this.leftOver.concat(t);
                                                this.leftOver = null;
                                            }
                                            var o = function(e, t) {
                                                var r;
                                                for((t = t || e.length) > e.length && (t = e.length), r = t - 1; 0 <= r && 128 == (192 & e[r]);)r--;
                                                return r < 0 || 0 === r ? t : r + a[e[r]] > t ? r : t;
                                            }(t), l = t;
                                            o !== t.length && (i.uint8array ? (l = t.subarray(0, o), this.leftOver = t.subarray(o, t.length)) : (l = t.slice(0, o), this.leftOver = t.slice(o, t.length))), this.push({
                                                data: r.utf8decode(l),
                                                meta: e.meta
                                            });
                                        }, c.prototype.flush = function() {
                                            this.leftOver && this.leftOver.length && (this.push({
                                                data: r.utf8decode(this.leftOver),
                                                meta: {}
                                            }), this.leftOver = null);
                                        }, r.Utf8DecodeWorker = c, n.inherits(u, o), u.prototype.processChunk = function(e) {
                                            this.push({
                                                data: r.utf8encode(e.data),
                                                meta: e.meta
                                            });
                                        }, r.Utf8EncodeWorker = u;
                                    },
                                    {
                                        "./nodejsUtils": 14,
                                        "./stream/GenericWorker": 28,
                                        "./support": 30,
                                        "./utils": 32
                                    }
                                ],
                                32: [
                                    function(e, t, r) {
                                        var n = e("./support"), i = e("./base64"), s = e("./nodejsUtils"), o = e("./external");
                                        function a(e) {
                                            return e;
                                        }
                                        function l(e, t) {
                                            for(var r = 0; r < e.length; ++r)t[r] = 255 & e.charCodeAt(r);
                                            return t;
                                        }
                                        e("setimmediate"), r.newBlob = function(e, t) {
                                            r.checkSupport("blob");
                                            try {
                                                return new Blob([
                                                    e
                                                ], {
                                                    type: t
                                                });
                                            } catch (r) {
                                                try {
                                                    var n = new (self.BlobBuilder || self.WebKitBlobBuilder || self.MozBlobBuilder || self.MSBlobBuilder);
                                                    return n.append(e), n.getBlob(t);
                                                } catch (e) {
                                                    throw new Error("Bug : can't construct the Blob.");
                                                }
                                            }
                                        };
                                        var c = {
                                            stringifyByChunk: function(e, t, r) {
                                                var n = [], i = 0, s = e.length;
                                                if (s <= r) return String.fromCharCode.apply(null, e);
                                                for(; i < s;)"array" === t || "nodebuffer" === t ? n.push(String.fromCharCode.apply(null, e.slice(i, Math.min(i + r, s)))) : n.push(String.fromCharCode.apply(null, e.subarray(i, Math.min(i + r, s)))), i += r;
                                                return n.join("");
                                            },
                                            stringifyByChar: function(e) {
                                                for(var t = "", r = 0; r < e.length; r++)t += String.fromCharCode(e[r]);
                                                return t;
                                            },
                                            applyCanBeUsed: {
                                                uint8array: function() {
                                                    try {
                                                        return n.uint8array && 1 === String.fromCharCode.apply(null, new Uint8Array(1)).length;
                                                    } catch (e) {
                                                        return !1;
                                                    }
                                                }(),
                                                nodebuffer: function() {
                                                    try {
                                                        return n.nodebuffer && 1 === String.fromCharCode.apply(null, s.allocBuffer(1)).length;
                                                    } catch (e) {
                                                        return !1;
                                                    }
                                                }()
                                            }
                                        };
                                        function h(e) {
                                            var t = 65536, n = r.getTypeOf(e), i = !0;
                                            if ("uint8array" === n ? i = c.applyCanBeUsed.uint8array : "nodebuffer" === n && (i = c.applyCanBeUsed.nodebuffer), i) for(; 1 < t;)try {
                                                return c.stringifyByChunk(e, n, t);
                                            } catch (e) {
                                                t = Math.floor(t / 2);
                                            }
                                            return c.stringifyByChar(e);
                                        }
                                        function f(e, t) {
                                            for(var r = 0; r < e.length; r++)t[r] = e[r];
                                            return t;
                                        }
                                        r.applyFromCharCode = h;
                                        var d = {};
                                        d.string = {
                                            string: a,
                                            array: function(e) {
                                                return l(e, new Array(e.length));
                                            },
                                            arraybuffer: function(e) {
                                                return d.string.uint8array(e).buffer;
                                            },
                                            uint8array: function(e) {
                                                return l(e, new Uint8Array(e.length));
                                            },
                                            nodebuffer: function(e) {
                                                return l(e, s.allocBuffer(e.length));
                                            }
                                        }, d.array = {
                                            string: h,
                                            array: a,
                                            arraybuffer: function(e) {
                                                return new Uint8Array(e).buffer;
                                            },
                                            uint8array: function(e) {
                                                return new Uint8Array(e);
                                            },
                                            nodebuffer: function(e) {
                                                return s.newBufferFrom(e);
                                            }
                                        }, d.arraybuffer = {
                                            string: function(e) {
                                                return h(new Uint8Array(e));
                                            },
                                            array: function(e) {
                                                return f(new Uint8Array(e), new Array(e.byteLength));
                                            },
                                            arraybuffer: a,
                                            uint8array: function(e) {
                                                return new Uint8Array(e);
                                            },
                                            nodebuffer: function(e) {
                                                return s.newBufferFrom(new Uint8Array(e));
                                            }
                                        }, d.uint8array = {
                                            string: h,
                                            array: function(e) {
                                                return f(e, new Array(e.length));
                                            },
                                            arraybuffer: function(e) {
                                                return e.buffer;
                                            },
                                            uint8array: a,
                                            nodebuffer: function(e) {
                                                return s.newBufferFrom(e);
                                            }
                                        }, d.nodebuffer = {
                                            string: h,
                                            array: function(e) {
                                                return f(e, new Array(e.length));
                                            },
                                            arraybuffer: function(e) {
                                                return d.nodebuffer.uint8array(e).buffer;
                                            },
                                            uint8array: function(e) {
                                                return f(e, new Uint8Array(e.length));
                                            },
                                            nodebuffer: a
                                        }, r.transformTo = function(e, t) {
                                            if (t = t || "", !e) return t;
                                            r.checkSupport(e);
                                            var n = r.getTypeOf(t);
                                            return d[n][e](t);
                                        }, r.resolve = function(e) {
                                            for(var t = e.split("/"), r = [], n = 0; n < t.length; n++){
                                                var i = t[n];
                                                "." === i || "" === i && 0 !== n && n !== t.length - 1 || (".." === i ? r.pop() : r.push(i));
                                            }
                                            return r.join("/");
                                        }, r.getTypeOf = function(e) {
                                            return "string" == typeof e ? "string" : "[object Array]" === Object.prototype.toString.call(e) ? "array" : n.nodebuffer && s.isBuffer(e) ? "nodebuffer" : n.uint8array && e instanceof Uint8Array ? "uint8array" : n.arraybuffer && e instanceof ArrayBuffer ? "arraybuffer" : void 0;
                                        }, r.checkSupport = function(e) {
                                            if (!n[e.toLowerCase()]) throw new Error(e + " is not supported by this platform");
                                        }, r.MAX_VALUE_16BITS = 65535, r.MAX_VALUE_32BITS = -1, r.pretty = function(e) {
                                            var t, r, n = "";
                                            for(r = 0; r < (e || "").length; r++)n += "\\x" + ((t = e.charCodeAt(r)) < 16 ? "0" : "") + t.toString(16).toUpperCase();
                                            return n;
                                        }, r.delay = function(e, t, r) {
                                            u(function() {
                                                e.apply(r || null, t || []);
                                            });
                                        }, r.inherits = function(e, t) {
                                            function r() {}
                                            r.prototype = t.prototype, e.prototype = new r;
                                        }, r.extend = function() {
                                            var e, t, r = {};
                                            for(e = 0; e < arguments.length; e++)for(t in arguments[e])Object.prototype.hasOwnProperty.call(arguments[e], t) && void 0 === r[t] && (r[t] = arguments[e][t]);
                                            return r;
                                        }, r.prepareContent = function(e, t, s, a, c) {
                                            return o.Promise.resolve(t).then(function(e) {
                                                return n.blob && (e instanceof Blob || -1 !== [
                                                    "[object File]",
                                                    "[object Blob]"
                                                ].indexOf(Object.prototype.toString.call(e))) && "undefined" != typeof FileReader ? new o.Promise(function(t, r) {
                                                    var n = new FileReader;
                                                    n.onload = function(e) {
                                                        t(e.target.result);
                                                    }, n.onerror = function(e) {
                                                        r(e.target.error);
                                                    }, n.readAsArrayBuffer(e);
                                                }) : e;
                                            }).then(function(t) {
                                                var u = r.getTypeOf(t);
                                                return u ? ("arraybuffer" === u ? t = r.transformTo("uint8array", t) : "string" === u && (c ? t = i.decode(t) : s && !0 !== a && (t = function(e) {
                                                    return l(e, n.uint8array ? new Uint8Array(e.length) : new Array(e.length));
                                                }(t))), t) : o.Promise.reject(new Error("Can't read the data of '" + e + "'. Is it in a supported JavaScript type (String, Blob, ArrayBuffer, etc) ?"));
                                            });
                                        };
                                    },
                                    {
                                        "./base64": 1,
                                        "./external": 6,
                                        "./nodejsUtils": 14,
                                        "./support": 30,
                                        setimmediate: 54
                                    }
                                ],
                                33: [
                                    function(e, t, r) {
                                        var n = e("./reader/readerFor"), i = e("./utils"), s = e("./signature"), o = e("./zipEntry"), a = e("./support");
                                        function l(e) {
                                            this.files = [], this.loadOptions = e;
                                        }
                                        l.prototype = {
                                            checkSignature: function(e) {
                                                if (!this.reader.readAndCheckSignature(e)) {
                                                    this.reader.index -= 4;
                                                    var t = this.reader.readString(4);
                                                    throw new Error("Corrupted zip or bug: unexpected signature (" + i.pretty(t) + ", expected " + i.pretty(e) + ")");
                                                }
                                            },
                                            isSignature: function(e, t) {
                                                var r = this.reader.index;
                                                this.reader.setIndex(e);
                                                var n = this.reader.readString(4) === t;
                                                return this.reader.setIndex(r), n;
                                            },
                                            readBlockEndOfCentral: function() {
                                                this.diskNumber = this.reader.readInt(2), this.diskWithCentralDirStart = this.reader.readInt(2), this.centralDirRecordsOnThisDisk = this.reader.readInt(2), this.centralDirRecords = this.reader.readInt(2), this.centralDirSize = this.reader.readInt(4), this.centralDirOffset = this.reader.readInt(4), this.zipCommentLength = this.reader.readInt(2);
                                                var e = this.reader.readData(this.zipCommentLength), t = a.uint8array ? "uint8array" : "array", r = i.transformTo(t, e);
                                                this.zipComment = this.loadOptions.decodeFileName(r);
                                            },
                                            readBlockZip64EndOfCentral: function() {
                                                this.zip64EndOfCentralSize = this.reader.readInt(8), this.reader.skip(4), this.diskNumber = this.reader.readInt(4), this.diskWithCentralDirStart = this.reader.readInt(4), this.centralDirRecordsOnThisDisk = this.reader.readInt(8), this.centralDirRecords = this.reader.readInt(8), this.centralDirSize = this.reader.readInt(8), this.centralDirOffset = this.reader.readInt(8), this.zip64ExtensibleData = {};
                                                for(var e, t, r, n = this.zip64EndOfCentralSize - 44; 0 < n;)e = this.reader.readInt(2), t = this.reader.readInt(4), r = this.reader.readData(t), this.zip64ExtensibleData[e] = {
                                                    id: e,
                                                    length: t,
                                                    value: r
                                                };
                                            },
                                            readBlockZip64EndOfCentralLocator: function() {
                                                if (this.diskWithZip64CentralDirStart = this.reader.readInt(4), this.relativeOffsetEndOfZip64CentralDir = this.reader.readInt(8), this.disksCount = this.reader.readInt(4), 1 < this.disksCount) throw new Error("Multi-volumes zip are not supported");
                                            },
                                            readLocalFiles: function() {
                                                var e, t;
                                                for(e = 0; e < this.files.length; e++)t = this.files[e], this.reader.setIndex(t.localHeaderOffset), this.checkSignature(s.LOCAL_FILE_HEADER), t.readLocalPart(this.reader), t.handleUTF8(), t.processAttributes();
                                            },
                                            readCentralDir: function() {
                                                var e;
                                                for(this.reader.setIndex(this.centralDirOffset); this.reader.readAndCheckSignature(s.CENTRAL_FILE_HEADER);)(e = new o({
                                                    zip64: this.zip64
                                                }, this.loadOptions)).readCentralPart(this.reader), this.files.push(e);
                                                if (this.centralDirRecords !== this.files.length && 0 !== this.centralDirRecords && 0 === this.files.length) throw new Error("Corrupted zip or bug: expected " + this.centralDirRecords + " records in central dir, got " + this.files.length);
                                            },
                                            readEndOfCentral: function() {
                                                var e = this.reader.lastIndexOfSignature(s.CENTRAL_DIRECTORY_END);
                                                if (e < 0) throw this.isSignature(0, s.LOCAL_FILE_HEADER) ? new Error("Corrupted zip: can't find end of central directory") : new Error("Can't find end of central directory : is this a zip file ? If it is, see https://stuk.github.io/jszip/documentation/howto/read_zip.html");
                                                this.reader.setIndex(e);
                                                var t = e;
                                                if (this.checkSignature(s.CENTRAL_DIRECTORY_END), this.readBlockEndOfCentral(), this.diskNumber === i.MAX_VALUE_16BITS || this.diskWithCentralDirStart === i.MAX_VALUE_16BITS || this.centralDirRecordsOnThisDisk === i.MAX_VALUE_16BITS || this.centralDirRecords === i.MAX_VALUE_16BITS || this.centralDirSize === i.MAX_VALUE_32BITS || this.centralDirOffset === i.MAX_VALUE_32BITS) {
                                                    if (this.zip64 = !0, (e = this.reader.lastIndexOfSignature(s.ZIP64_CENTRAL_DIRECTORY_LOCATOR)) < 0) throw new Error("Corrupted zip: can't find the ZIP64 end of central directory locator");
                                                    if (this.reader.setIndex(e), this.checkSignature(s.ZIP64_CENTRAL_DIRECTORY_LOCATOR), this.readBlockZip64EndOfCentralLocator(), !this.isSignature(this.relativeOffsetEndOfZip64CentralDir, s.ZIP64_CENTRAL_DIRECTORY_END) && (this.relativeOffsetEndOfZip64CentralDir = this.reader.lastIndexOfSignature(s.ZIP64_CENTRAL_DIRECTORY_END), this.relativeOffsetEndOfZip64CentralDir < 0)) throw new Error("Corrupted zip: can't find the ZIP64 end of central directory");
                                                    this.reader.setIndex(this.relativeOffsetEndOfZip64CentralDir), this.checkSignature(s.ZIP64_CENTRAL_DIRECTORY_END), this.readBlockZip64EndOfCentral();
                                                }
                                                var r = this.centralDirOffset + this.centralDirSize;
                                                this.zip64 && (r += 20, r += 12 + this.zip64EndOfCentralSize);
                                                var n = t - r;
                                                if (0 < n) this.isSignature(t, s.CENTRAL_FILE_HEADER) || (this.reader.zero = n);
                                                else if (n < 0) throw new Error("Corrupted zip: missing " + Math.abs(n) + " bytes.");
                                            },
                                            prepareReader: function(e) {
                                                this.reader = n(e);
                                            },
                                            load: function(e) {
                                                this.prepareReader(e), this.readEndOfCentral(), this.readCentralDir(), this.readLocalFiles();
                                            }
                                        }, t.exports = l;
                                    },
                                    {
                                        "./reader/readerFor": 22,
                                        "./signature": 23,
                                        "./support": 30,
                                        "./utils": 32,
                                        "./zipEntry": 34
                                    }
                                ],
                                34: [
                                    function(e, t, r) {
                                        var n = e("./reader/readerFor"), i = e("./utils"), s = e("./compressedObject"), o = e("./crc32"), a = e("./utf8"), l = e("./compressions"), c = e("./support");
                                        function u(e, t) {
                                            this.options = e, this.loadOptions = t;
                                        }
                                        u.prototype = {
                                            isEncrypted: function() {
                                                return 1 == (1 & this.bitFlag);
                                            },
                                            useUTF8: function() {
                                                return 2048 == (2048 & this.bitFlag);
                                            },
                                            readLocalPart: function(e) {
                                                var t, r;
                                                if (e.skip(22), this.fileNameLength = e.readInt(2), r = e.readInt(2), this.fileName = e.readData(this.fileNameLength), e.skip(r), -1 === this.compressedSize || -1 === this.uncompressedSize) throw new Error("Bug or corrupted zip : didn't get enough information from the central directory (compressedSize === -1 || uncompressedSize === -1)");
                                                if (null === (t = function(e) {
                                                    for(var t in l)if (Object.prototype.hasOwnProperty.call(l, t) && l[t].magic === e) return l[t];
                                                    return null;
                                                }(this.compressionMethod))) throw new Error("Corrupted zip : compression " + i.pretty(this.compressionMethod) + " unknown (inner file : " + i.transformTo("string", this.fileName) + ")");
                                                this.decompressed = new s(this.compressedSize, this.uncompressedSize, this.crc32, t, e.readData(this.compressedSize));
                                            },
                                            readCentralPart: function(e) {
                                                this.versionMadeBy = e.readInt(2), e.skip(2), this.bitFlag = e.readInt(2), this.compressionMethod = e.readString(2), this.date = e.readDate(), this.crc32 = e.readInt(4), this.compressedSize = e.readInt(4), this.uncompressedSize = e.readInt(4);
                                                var t = e.readInt(2);
                                                if (this.extraFieldsLength = e.readInt(2), this.fileCommentLength = e.readInt(2), this.diskNumberStart = e.readInt(2), this.internalFileAttributes = e.readInt(2), this.externalFileAttributes = e.readInt(4), this.localHeaderOffset = e.readInt(4), this.isEncrypted()) throw new Error("Encrypted zip are not supported");
                                                e.skip(t), this.readExtraFields(e), this.parseZIP64ExtraField(e), this.fileComment = e.readData(this.fileCommentLength);
                                            },
                                            processAttributes: function() {
                                                this.unixPermissions = null, this.dosPermissions = null;
                                                var e = this.versionMadeBy >> 8;
                                                this.dir = !!(16 & this.externalFileAttributes), 0 == e && (this.dosPermissions = 63 & this.externalFileAttributes), 3 == e && (this.unixPermissions = this.externalFileAttributes >> 16 & 65535), this.dir || "/" !== this.fileNameStr.slice(-1) || (this.dir = !0);
                                            },
                                            parseZIP64ExtraField: function() {
                                                if (this.extraFields[1]) {
                                                    var e = n(this.extraFields[1].value);
                                                    this.uncompressedSize === i.MAX_VALUE_32BITS && (this.uncompressedSize = e.readInt(8)), this.compressedSize === i.MAX_VALUE_32BITS && (this.compressedSize = e.readInt(8)), this.localHeaderOffset === i.MAX_VALUE_32BITS && (this.localHeaderOffset = e.readInt(8)), this.diskNumberStart === i.MAX_VALUE_32BITS && (this.diskNumberStart = e.readInt(4));
                                                }
                                            },
                                            readExtraFields: function(e) {
                                                var t, r, n, i = e.index + this.extraFieldsLength;
                                                for(this.extraFields || (this.extraFields = {}); e.index + 4 < i;)t = e.readInt(2), r = e.readInt(2), n = e.readData(r), this.extraFields[t] = {
                                                    id: t,
                                                    length: r,
                                                    value: n
                                                };
                                                e.setIndex(i);
                                            },
                                            handleUTF8: function() {
                                                var e = c.uint8array ? "uint8array" : "array";
                                                if (this.useUTF8()) this.fileNameStr = a.utf8decode(this.fileName), this.fileCommentStr = a.utf8decode(this.fileComment);
                                                else {
                                                    var t = this.findExtraFieldUnicodePath();
                                                    if (null !== t) this.fileNameStr = t;
                                                    else {
                                                        var r = i.transformTo(e, this.fileName);
                                                        this.fileNameStr = this.loadOptions.decodeFileName(r);
                                                    }
                                                    var n = this.findExtraFieldUnicodeComment();
                                                    if (null !== n) this.fileCommentStr = n;
                                                    else {
                                                        var s = i.transformTo(e, this.fileComment);
                                                        this.fileCommentStr = this.loadOptions.decodeFileName(s);
                                                    }
                                                }
                                            },
                                            findExtraFieldUnicodePath: function() {
                                                var e = this.extraFields[28789];
                                                if (e) {
                                                    var t = n(e.value);
                                                    return 1 !== t.readInt(1) || o(this.fileName) !== t.readInt(4) ? null : a.utf8decode(t.readData(e.length - 5));
                                                }
                                                return null;
                                            },
                                            findExtraFieldUnicodeComment: function() {
                                                var e = this.extraFields[25461];
                                                if (e) {
                                                    var t = n(e.value);
                                                    return 1 !== t.readInt(1) || o(this.fileComment) !== t.readInt(4) ? null : a.utf8decode(t.readData(e.length - 5));
                                                }
                                                return null;
                                            }
                                        }, t.exports = u;
                                    },
                                    {
                                        "./compressedObject": 2,
                                        "./compressions": 3,
                                        "./crc32": 4,
                                        "./reader/readerFor": 22,
                                        "./support": 30,
                                        "./utf8": 31,
                                        "./utils": 32
                                    }
                                ],
                                35: [
                                    function(e, t, r) {
                                        function n(e, t, r) {
                                            this.name = e, this.dir = r.dir, this.date = r.date, this.comment = r.comment, this.unixPermissions = r.unixPermissions, this.dosPermissions = r.dosPermissions, this._data = t, this._dataBinary = r.binary, this.options = {
                                                compression: r.compression,
                                                compressionOptions: r.compressionOptions
                                            };
                                        }
                                        var i = e("./stream/StreamHelper"), s = e("./stream/DataWorker"), o = e("./utf8"), a = e("./compressedObject"), l = e("./stream/GenericWorker");
                                        n.prototype = {
                                            internalStream: function(e) {
                                                var t = null, r = "string";
                                                try {
                                                    if (!e) throw new Error("No output type specified.");
                                                    var n = "string" === (r = e.toLowerCase()) || "text" === r;
                                                    "binarystring" !== r && "text" !== r || (r = "string"), t = this._decompressWorker();
                                                    var s = !this._dataBinary;
                                                    s && !n && (t = t.pipe(new o.Utf8EncodeWorker)), !s && n && (t = t.pipe(new o.Utf8DecodeWorker));
                                                } catch (e) {
                                                    (t = new l("error")).error(e);
                                                }
                                                return new i(t, r, "");
                                            },
                                            async: function(e, t) {
                                                return this.internalStream(e).accumulate(t);
                                            },
                                            nodeStream: function(e, t) {
                                                return this.internalStream(e || "nodebuffer").toNodejsStream(t);
                                            },
                                            _compressWorker: function(e, t) {
                                                if (this._data instanceof a && this._data.compression.magic === e.magic) return this._data.getCompressedWorker();
                                                var r = this._decompressWorker();
                                                return this._dataBinary || (r = r.pipe(new o.Utf8EncodeWorker)), a.createWorkerFrom(r, e, t);
                                            },
                                            _decompressWorker: function() {
                                                return this._data instanceof a ? this._data.getContentWorker() : this._data instanceof l ? this._data : new s(this._data);
                                            }
                                        };
                                        for(var c = [
                                            "asText",
                                            "asBinary",
                                            "asNodeBuffer",
                                            "asUint8Array",
                                            "asArrayBuffer"
                                        ], u = function() {
                                            throw new Error("This method has been removed in JSZip 3.0, please check the upgrade guide.");
                                        }, h = 0; h < c.length; h++)n.prototype[c[h]] = u;
                                        t.exports = n;
                                    },
                                    {
                                        "./compressedObject": 2,
                                        "./stream/DataWorker": 27,
                                        "./stream/GenericWorker": 28,
                                        "./stream/StreamHelper": 29,
                                        "./utf8": 31
                                    }
                                ],
                                36: [
                                    function(e, t, r) {
                                        (function(e) {
                                            var r, n, i = e.MutationObserver || e.WebKitMutationObserver;
                                            if (i) {
                                                var s = 0, o = new i(u), a = e.document.createTextNode("");
                                                o.observe(a, {
                                                    characterData: !0
                                                }), r = function() {
                                                    a.data = s = ++s % 2;
                                                };
                                            } else if (e.setImmediate || void 0 === e.MessageChannel) r = "document" in e && "onreadystatechange" in e.document.createElement("script") ? function() {
                                                var t = e.document.createElement("script");
                                                t.onreadystatechange = function() {
                                                    u(), t.onreadystatechange = null, t.parentNode.removeChild(t), t = null;
                                                }, e.document.documentElement.appendChild(t);
                                            } : function() {
                                                setTimeout(u, 0);
                                            };
                                            else {
                                                var l = new e.MessageChannel;
                                                l.port1.onmessage = u, r = function() {
                                                    l.port2.postMessage(0);
                                                };
                                            }
                                            var c = [];
                                            function u() {
                                                var e, t;
                                                n = !0;
                                                for(var r = c.length; r;){
                                                    for(t = c, c = [], e = -1; ++e < r;)t[e]();
                                                    r = c.length;
                                                }
                                                n = !1;
                                            }
                                            t.exports = function(e) {
                                                1 !== c.push(e) || n || r();
                                            };
                                        }).call(this, void 0 !== i ? i : "undefined" != typeof self ? self : "undefined" != typeof window ? window : {});
                                    },
                                    {}
                                ],
                                37: [
                                    function(e, t, r) {
                                        var n = e("immediate");
                                        function i() {}
                                        var s = {}, o = [
                                            "REJECTED"
                                        ], a = [
                                            "FULFILLED"
                                        ], l = [
                                            "PENDING"
                                        ];
                                        function c(e) {
                                            if ("function" != typeof e) throw new TypeError("resolver must be a function");
                                            this.state = l, this.queue = [], this.outcome = void 0, e !== i && d(this, e);
                                        }
                                        function u(e, t, r) {
                                            this.promise = e, "function" == typeof t && (this.onFulfilled = t, this.callFulfilled = this.otherCallFulfilled), "function" == typeof r && (this.onRejected = r, this.callRejected = this.otherCallRejected);
                                        }
                                        function h(e, t, r) {
                                            n(function() {
                                                var n;
                                                try {
                                                    n = t(r);
                                                } catch (n) {
                                                    return s.reject(e, n);
                                                }
                                                n === e ? s.reject(e, new TypeError("Cannot resolve promise with itself")) : s.resolve(e, n);
                                            });
                                        }
                                        function f(e) {
                                            var t = e && e.then;
                                            if (e && ("object" == typeof e || "function" == typeof e) && "function" == typeof t) return function() {
                                                t.apply(e, arguments);
                                            };
                                        }
                                        function d(e, t) {
                                            var r = !1;
                                            function n(t) {
                                                r || (r = !0, s.reject(e, t));
                                            }
                                            function i(t) {
                                                r || (r = !0, s.resolve(e, t));
                                            }
                                            var o = p(function() {
                                                t(i, n);
                                            });
                                            "error" === o.status && n(o.value);
                                        }
                                        function p(e, t) {
                                            var r = {};
                                            try {
                                                r.value = e(t), r.status = "success";
                                            } catch (e) {
                                                r.status = "error", r.value = e;
                                            }
                                            return r;
                                        }
                                        (t.exports = c).prototype.finally = function(e) {
                                            if ("function" != typeof e) return this;
                                            var t = this.constructor;
                                            return this.then(function(r) {
                                                return t.resolve(e()).then(function() {
                                                    return r;
                                                });
                                            }, function(r) {
                                                return t.resolve(e()).then(function() {
                                                    throw r;
                                                });
                                            });
                                        }, c.prototype.catch = function(e) {
                                            return this.then(null, e);
                                        }, c.prototype.then = function(e, t) {
                                            if ("function" != typeof e && this.state === a || "function" != typeof t && this.state === o) return this;
                                            var r = new this.constructor(i);
                                            return this.state !== l ? h(r, this.state === a ? e : t, this.outcome) : this.queue.push(new u(r, e, t)), r;
                                        }, u.prototype.callFulfilled = function(e) {
                                            s.resolve(this.promise, e);
                                        }, u.prototype.otherCallFulfilled = function(e) {
                                            h(this.promise, this.onFulfilled, e);
                                        }, u.prototype.callRejected = function(e) {
                                            s.reject(this.promise, e);
                                        }, u.prototype.otherCallRejected = function(e) {
                                            h(this.promise, this.onRejected, e);
                                        }, s.resolve = function(e, t) {
                                            var r = p(f, t);
                                            if ("error" === r.status) return s.reject(e, r.value);
                                            var n = r.value;
                                            if (n) d(e, n);
                                            else {
                                                e.state = a, e.outcome = t;
                                                for(var i = -1, o = e.queue.length; ++i < o;)e.queue[i].callFulfilled(t);
                                            }
                                            return e;
                                        }, s.reject = function(e, t) {
                                            e.state = o, e.outcome = t;
                                            for(var r = -1, n = e.queue.length; ++r < n;)e.queue[r].callRejected(t);
                                            return e;
                                        }, c.resolve = function(e) {
                                            return e instanceof this ? e : s.resolve(new this(i), e);
                                        }, c.reject = function(e) {
                                            var t = new this(i);
                                            return s.reject(t, e);
                                        }, c.all = function(e) {
                                            var t = this;
                                            if ("[object Array]" !== Object.prototype.toString.call(e)) return this.reject(new TypeError("must be an array"));
                                            var r = e.length, n = !1;
                                            if (!r) return this.resolve([]);
                                            for(var o = new Array(r), a = 0, l = -1, c = new this(i); ++l < r;)u(e[l], l);
                                            return c;
                                            function u(e, i) {
                                                t.resolve(e).then(function(e) {
                                                    o[i] = e, ++a !== r || n || (n = !0, s.resolve(c, o));
                                                }, function(e) {
                                                    n || (n = !0, s.reject(c, e));
                                                });
                                            }
                                        }, c.race = function(e) {
                                            if ("[object Array]" !== Object.prototype.toString.call(e)) return this.reject(new TypeError("must be an array"));
                                            var t = e.length, r = !1;
                                            if (!t) return this.resolve([]);
                                            for(var n, o = -1, a = new this(i); ++o < t;)n = e[o], this.resolve(n).then(function(e) {
                                                r || (r = !0, s.resolve(a, e));
                                            }, function(e) {
                                                r || (r = !0, s.reject(a, e));
                                            });
                                            return a;
                                        };
                                    },
                                    {
                                        immediate: 36
                                    }
                                ],
                                38: [
                                    function(e, t, r) {
                                        var n = {};
                                        (0, e("./lib/utils/common").assign)(n, e("./lib/deflate"), e("./lib/inflate"), e("./lib/zlib/constants")), t.exports = n;
                                    },
                                    {
                                        "./lib/deflate": 39,
                                        "./lib/inflate": 40,
                                        "./lib/utils/common": 41,
                                        "./lib/zlib/constants": 44
                                    }
                                ],
                                39: [
                                    function(e, t, r) {
                                        var n = e("./zlib/deflate"), i = e("./utils/common"), s = e("./utils/strings"), o = e("./zlib/messages"), a = e("./zlib/zstream"), l = Object.prototype.toString;
                                        function c(e) {
                                            if (!(this instanceof c)) return new c(e);
                                            this.options = i.assign({
                                                level: -1,
                                                method: 8,
                                                chunkSize: 16384,
                                                windowBits: 15,
                                                memLevel: 8,
                                                strategy: 0,
                                                to: ""
                                            }, e || {});
                                            var t = this.options;
                                            t.raw && 0 < t.windowBits ? t.windowBits = -t.windowBits : t.gzip && 0 < t.windowBits && t.windowBits < 16 && (t.windowBits += 16), this.err = 0, this.msg = "", this.ended = !1, this.chunks = [], this.strm = new a, this.strm.avail_out = 0;
                                            var r = n.deflateInit2(this.strm, t.level, t.method, t.windowBits, t.memLevel, t.strategy);
                                            if (0 !== r) throw new Error(o[r]);
                                            if (t.header && n.deflateSetHeader(this.strm, t.header), t.dictionary) {
                                                var u;
                                                if (u = "string" == typeof t.dictionary ? s.string2buf(t.dictionary) : "[object ArrayBuffer]" === l.call(t.dictionary) ? new Uint8Array(t.dictionary) : t.dictionary, 0 !== (r = n.deflateSetDictionary(this.strm, u))) throw new Error(o[r]);
                                                this._dict_set = !0;
                                            }
                                        }
                                        function u(e, t) {
                                            var r = new c(t);
                                            if (r.push(e, !0), r.err) throw r.msg || o[r.err];
                                            return r.result;
                                        }
                                        c.prototype.push = function(e, t) {
                                            var r, o, a = this.strm, c = this.options.chunkSize;
                                            if (this.ended) return !1;
                                            o = t === ~~t ? t : !0 === t ? 4 : 0, "string" == typeof e ? a.input = s.string2buf(e) : "[object ArrayBuffer]" === l.call(e) ? a.input = new Uint8Array(e) : a.input = e, a.next_in = 0, a.avail_in = a.input.length;
                                            do {
                                                if (0 === a.avail_out && (a.output = new i.Buf8(c), a.next_out = 0, a.avail_out = c), 1 !== (r = n.deflate(a, o)) && 0 !== r) return this.onEnd(r), this.ended = !0, false;
                                                0 !== a.avail_out && (0 !== a.avail_in || 4 !== o && 2 !== o) || ("string" === this.options.to ? this.onData(s.buf2binstring(i.shrinkBuf(a.output, a.next_out))) : this.onData(i.shrinkBuf(a.output, a.next_out)));
                                            }while ((0 < a.avail_in || 0 === a.avail_out) && 1 !== r);
                                            return 4 === o ? (r = n.deflateEnd(this.strm), this.onEnd(r), this.ended = !0, 0 === r) : 2 !== o || (this.onEnd(0), a.avail_out = 0, true);
                                        }, c.prototype.onData = function(e) {
                                            this.chunks.push(e);
                                        }, c.prototype.onEnd = function(e) {
                                            0 === e && ("string" === this.options.to ? this.result = this.chunks.join("") : this.result = i.flattenChunks(this.chunks)), this.chunks = [], this.err = e, this.msg = this.strm.msg;
                                        }, r.Deflate = c, r.deflate = u, r.deflateRaw = function(e, t) {
                                            return (t = t || {}).raw = !0, u(e, t);
                                        }, r.gzip = function(e, t) {
                                            return (t = t || {}).gzip = !0, u(e, t);
                                        };
                                    },
                                    {
                                        "./utils/common": 41,
                                        "./utils/strings": 42,
                                        "./zlib/deflate": 46,
                                        "./zlib/messages": 51,
                                        "./zlib/zstream": 53
                                    }
                                ],
                                40: [
                                    function(e, t, r) {
                                        var n = e("./zlib/inflate"), i = e("./utils/common"), s = e("./utils/strings"), o = e("./zlib/constants"), a = e("./zlib/messages"), l = e("./zlib/zstream"), c = e("./zlib/gzheader"), u = Object.prototype.toString;
                                        function h(e) {
                                            if (!(this instanceof h)) return new h(e);
                                            this.options = i.assign({
                                                chunkSize: 16384,
                                                windowBits: 0,
                                                to: ""
                                            }, e || {});
                                            var t = this.options;
                                            t.raw && 0 <= t.windowBits && t.windowBits < 16 && (t.windowBits = -t.windowBits, 0 === t.windowBits && (t.windowBits = -15)), !(0 <= t.windowBits && t.windowBits < 16) || e && e.windowBits || (t.windowBits += 32), 15 < t.windowBits && t.windowBits < 48 && 0 == (15 & t.windowBits) && (t.windowBits |= 15), this.err = 0, this.msg = "", this.ended = !1, this.chunks = [], this.strm = new l, this.strm.avail_out = 0;
                                            var r = n.inflateInit2(this.strm, t.windowBits);
                                            if (r !== o.Z_OK) throw new Error(a[r]);
                                            this.header = new c, n.inflateGetHeader(this.strm, this.header);
                                        }
                                        function f(e, t) {
                                            var r = new h(t);
                                            if (r.push(e, !0), r.err) throw r.msg || a[r.err];
                                            return r.result;
                                        }
                                        h.prototype.push = function(e, t) {
                                            var r, a, l, c, h, f, d = this.strm, p = this.options.chunkSize, m = this.options.dictionary, b = !1;
                                            if (this.ended) return !1;
                                            a = t === ~~t ? t : !0 === t ? o.Z_FINISH : o.Z_NO_FLUSH, "string" == typeof e ? d.input = s.binstring2buf(e) : "[object ArrayBuffer]" === u.call(e) ? d.input = new Uint8Array(e) : d.input = e, d.next_in = 0, d.avail_in = d.input.length;
                                            do {
                                                if (0 === d.avail_out && (d.output = new i.Buf8(p), d.next_out = 0, d.avail_out = p), (r = n.inflate(d, o.Z_NO_FLUSH)) === o.Z_NEED_DICT && m && (f = "string" == typeof m ? s.string2buf(m) : "[object ArrayBuffer]" === u.call(m) ? new Uint8Array(m) : m, r = n.inflateSetDictionary(this.strm, f)), r === o.Z_BUF_ERROR && !0 === b && (r = o.Z_OK, b = !1), r !== o.Z_STREAM_END && r !== o.Z_OK) return this.onEnd(r), this.ended = !0, false;
                                                d.next_out && (0 !== d.avail_out && r !== o.Z_STREAM_END && (0 !== d.avail_in || a !== o.Z_FINISH && a !== o.Z_SYNC_FLUSH) || ("string" === this.options.to ? (l = s.utf8border(d.output, d.next_out), c = d.next_out - l, h = s.buf2string(d.output, l), d.next_out = c, d.avail_out = p - c, c && i.arraySet(d.output, d.output, l, c, 0), this.onData(h)) : this.onData(i.shrinkBuf(d.output, d.next_out)))), 0 === d.avail_in && 0 === d.avail_out && (b = !0);
                                            }while ((0 < d.avail_in || 0 === d.avail_out) && r !== o.Z_STREAM_END);
                                            return r === o.Z_STREAM_END && (a = o.Z_FINISH), a === o.Z_FINISH ? (r = n.inflateEnd(this.strm), this.onEnd(r), this.ended = !0, r === o.Z_OK) : a !== o.Z_SYNC_FLUSH || (this.onEnd(o.Z_OK), d.avail_out = 0, true);
                                        }, h.prototype.onData = function(e) {
                                            this.chunks.push(e);
                                        }, h.prototype.onEnd = function(e) {
                                            e === o.Z_OK && ("string" === this.options.to ? this.result = this.chunks.join("") : this.result = i.flattenChunks(this.chunks)), this.chunks = [], this.err = e, this.msg = this.strm.msg;
                                        }, r.Inflate = h, r.inflate = f, r.inflateRaw = function(e, t) {
                                            return (t = t || {}).raw = !0, f(e, t);
                                        }, r.ungzip = f;
                                    },
                                    {
                                        "./utils/common": 41,
                                        "./utils/strings": 42,
                                        "./zlib/constants": 44,
                                        "./zlib/gzheader": 47,
                                        "./zlib/inflate": 49,
                                        "./zlib/messages": 51,
                                        "./zlib/zstream": 53
                                    }
                                ],
                                41: [
                                    function(e, t, r) {
                                        var n = "undefined" != typeof Uint8Array && "undefined" != typeof Uint16Array && "undefined" != typeof Int32Array;
                                        r.assign = function(e) {
                                            for(var t = Array.prototype.slice.call(arguments, 1); t.length;){
                                                var r = t.shift();
                                                if (r) {
                                                    if ("object" != typeof r) throw new TypeError(r + "must be non-object");
                                                    for(var n in r)r.hasOwnProperty(n) && (e[n] = r[n]);
                                                }
                                            }
                                            return e;
                                        }, r.shrinkBuf = function(e, t) {
                                            return e.length === t ? e : e.subarray ? e.subarray(0, t) : (e.length = t, e);
                                        };
                                        var i = {
                                            arraySet: function(e, t, r, n, i) {
                                                if (t.subarray && e.subarray) e.set(t.subarray(r, r + n), i);
                                                else for(var s = 0; s < n; s++)e[i + s] = t[r + s];
                                            },
                                            flattenChunks: function(e) {
                                                var t, r, n, i, s, o;
                                                for(t = n = 0, r = e.length; t < r; t++)n += e[t].length;
                                                for(o = new Uint8Array(n), t = i = 0, r = e.length; t < r; t++)s = e[t], o.set(s, i), i += s.length;
                                                return o;
                                            }
                                        }, s = {
                                            arraySet: function(e, t, r, n, i) {
                                                for(var s = 0; s < n; s++)e[i + s] = t[r + s];
                                            },
                                            flattenChunks: function(e) {
                                                return [].concat.apply([], e);
                                            }
                                        };
                                        r.setTyped = function(e) {
                                            e ? (r.Buf8 = Uint8Array, r.Buf16 = Uint16Array, r.Buf32 = Int32Array, r.assign(r, i)) : (r.Buf8 = Array, r.Buf16 = Array, r.Buf32 = Array, r.assign(r, s));
                                        }, r.setTyped(n);
                                    },
                                    {}
                                ],
                                42: [
                                    function(e, t, r) {
                                        var n = e("./common"), i = !0, s = !0;
                                        try {
                                            String.fromCharCode.apply(null, [
                                                0
                                            ]);
                                        } catch (e) {
                                            i = !1;
                                        }
                                        try {
                                            String.fromCharCode.apply(null, new Uint8Array(1));
                                        } catch (e) {
                                            s = !1;
                                        }
                                        for(var o = new n.Buf8(256), a = 0; a < 256; a++)o[a] = 252 <= a ? 6 : 248 <= a ? 5 : 240 <= a ? 4 : 224 <= a ? 3 : 192 <= a ? 2 : 1;
                                        function l(e, t) {
                                            if (t < 65537 && (e.subarray && s || !e.subarray && i)) return String.fromCharCode.apply(null, n.shrinkBuf(e, t));
                                            for(var r = "", o = 0; o < t; o++)r += String.fromCharCode(e[o]);
                                            return r;
                                        }
                                        o[254] = o[254] = 1, r.string2buf = function(e) {
                                            var t, r, i, s, o, a = e.length, l = 0;
                                            for(s = 0; s < a; s++)55296 == (64512 & (r = e.charCodeAt(s))) && s + 1 < a && 56320 == (64512 & (i = e.charCodeAt(s + 1))) && (r = 65536 + (r - 55296 << 10) + (i - 56320), s++), l += r < 128 ? 1 : r < 2048 ? 2 : r < 65536 ? 3 : 4;
                                            for(t = new n.Buf8(l), s = o = 0; o < l; s++)55296 == (64512 & (r = e.charCodeAt(s))) && s + 1 < a && 56320 == (64512 & (i = e.charCodeAt(s + 1))) && (r = 65536 + (r - 55296 << 10) + (i - 56320), s++), r < 128 ? t[o++] = r : (r < 2048 ? t[o++] = 192 | r >>> 6 : (r < 65536 ? t[o++] = 224 | r >>> 12 : (t[o++] = 240 | r >>> 18, t[o++] = 128 | r >>> 12 & 63), t[o++] = 128 | r >>> 6 & 63), t[o++] = 128 | 63 & r);
                                            return t;
                                        }, r.buf2binstring = function(e) {
                                            return l(e, e.length);
                                        }, r.binstring2buf = function(e) {
                                            for(var t = new n.Buf8(e.length), r = 0, i = t.length; r < i; r++)t[r] = e.charCodeAt(r);
                                            return t;
                                        }, r.buf2string = function(e, t) {
                                            var r, n, i, s, a = t || e.length, c = new Array(2 * a);
                                            for(r = n = 0; r < a;)if ((i = e[r++]) < 128) c[n++] = i;
                                            else if (4 < (s = o[i])) c[n++] = 65533, r += s - 1;
                                            else {
                                                for(i &= 2 === s ? 31 : 3 === s ? 15 : 7; 1 < s && r < a;)i = i << 6 | 63 & e[r++], s--;
                                                1 < s ? c[n++] = 65533 : i < 65536 ? c[n++] = i : (i -= 65536, c[n++] = 55296 | i >> 10 & 1023, c[n++] = 56320 | 1023 & i);
                                            }
                                            return l(c, n);
                                        }, r.utf8border = function(e, t) {
                                            var r;
                                            for((t = t || e.length) > e.length && (t = e.length), r = t - 1; 0 <= r && 128 == (192 & e[r]);)r--;
                                            return r < 0 || 0 === r ? t : r + o[e[r]] > t ? r : t;
                                        };
                                    },
                                    {
                                        "./common": 41
                                    }
                                ],
                                43: [
                                    function(e, t, r) {
                                        t.exports = function(e, t, r, n) {
                                            for(var i = 65535 & e | 0, s = e >>> 16 & 65535 | 0, o = 0; 0 !== r;){
                                                for(r -= o = 2e3 < r ? 2e3 : r; s = s + (i = i + t[n++] | 0) | 0, --o;);
                                                i %= 65521, s %= 65521;
                                            }
                                            return i | s << 16 | 0;
                                        };
                                    },
                                    {}
                                ],
                                44: [
                                    function(e, t, r) {
                                        t.exports = {
                                            Z_NO_FLUSH: 0,
                                            Z_PARTIAL_FLUSH: 1,
                                            Z_SYNC_FLUSH: 2,
                                            Z_FULL_FLUSH: 3,
                                            Z_FINISH: 4,
                                            Z_BLOCK: 5,
                                            Z_TREES: 6,
                                            Z_OK: 0,
                                            Z_STREAM_END: 1,
                                            Z_NEED_DICT: 2,
                                            Z_ERRNO: -1,
                                            Z_STREAM_ERROR: -2,
                                            Z_DATA_ERROR: -3,
                                            Z_BUF_ERROR: -5,
                                            Z_NO_COMPRESSION: 0,
                                            Z_BEST_SPEED: 1,
                                            Z_BEST_COMPRESSION: 9,
                                            Z_DEFAULT_COMPRESSION: -1,
                                            Z_FILTERED: 1,
                                            Z_HUFFMAN_ONLY: 2,
                                            Z_RLE: 3,
                                            Z_FIXED: 4,
                                            Z_DEFAULT_STRATEGY: 0,
                                            Z_BINARY: 0,
                                            Z_TEXT: 1,
                                            Z_UNKNOWN: 2,
                                            Z_DEFLATED: 8
                                        };
                                    },
                                    {}
                                ],
                                45: [
                                    function(e, t, r) {
                                        var n = function() {
                                            for(var e, t = [], r = 0; r < 256; r++){
                                                e = r;
                                                for(var n = 0; n < 8; n++)e = 1 & e ? 3988292384 ^ e >>> 1 : e >>> 1;
                                                t[r] = e;
                                            }
                                            return t;
                                        }();
                                        t.exports = function(e, t, r, i) {
                                            var s = n, o = i + r;
                                            e ^= -1;
                                            for(var a = i; a < o; a++)e = e >>> 8 ^ s[255 & (e ^ t[a])];
                                            return -1 ^ e;
                                        };
                                    },
                                    {}
                                ],
                                46: [
                                    function(e, t, r) {
                                        var n, i = e("../utils/common"), s = e("./trees"), o = e("./adler32"), a = e("./crc32"), l = e("./messages"), c = -2, u = 258, h = 262, f = 113;
                                        function d(e, t) {
                                            return e.msg = l[t], t;
                                        }
                                        function p(e) {
                                            return (e << 1) - (4 < e ? 9 : 0);
                                        }
                                        function m(e) {
                                            for(var t = e.length; 0 <= --t;)e[t] = 0;
                                        }
                                        function b(e) {
                                            var t = e.state, r = t.pending;
                                            r > e.avail_out && (r = e.avail_out), 0 !== r && (i.arraySet(e.output, t.pending_buf, t.pending_out, r, e.next_out), e.next_out += r, t.pending_out += r, e.total_out += r, e.avail_out -= r, t.pending -= r, 0 === t.pending && (t.pending_out = 0));
                                        }
                                        function g(e, t) {
                                            s._tr_flush_block(e, 0 <= e.block_start ? e.block_start : -1, e.strstart - e.block_start, t), e.block_start = e.strstart, b(e.strm);
                                        }
                                        function y(e, t) {
                                            e.pending_buf[e.pending++] = t;
                                        }
                                        function v(e, t) {
                                            e.pending_buf[e.pending++] = t >>> 8 & 255, e.pending_buf[e.pending++] = 255 & t;
                                        }
                                        function w(e, t) {
                                            var r, n, i = e.max_chain_length, s = e.strstart, o = e.prev_length, a = e.nice_match, l = e.strstart > e.w_size - h ? e.strstart - (e.w_size - h) : 0, c = e.window, f = e.w_mask, d = e.prev, p = e.strstart + u, m = c[s + o - 1], b = c[s + o];
                                            e.prev_length >= e.good_match && (i >>= 2), a > e.lookahead && (a = e.lookahead);
                                            do if (c[(r = t) + o] === b && c[r + o - 1] === m && c[r] === c[s] && c[++r] === c[s + 1]) {
                                                s += 2, r++;
                                                do ;
                                                while (c[++s] === c[++r] && c[++s] === c[++r] && c[++s] === c[++r] && c[++s] === c[++r] && c[++s] === c[++r] && c[++s] === c[++r] && c[++s] === c[++r] && c[++s] === c[++r] && s < p);
                                                if (n = u - (p - s), s = p - u, o < n) {
                                                    if (e.match_start = t, a <= (o = n)) break;
                                                    m = c[s + o - 1], b = c[s + o];
                                                }
                                            }
                                            while ((t = d[t & f]) > l && 0 != --i);
                                            return o <= e.lookahead ? o : e.lookahead;
                                        }
                                        function _(e) {
                                            var t, r, n, s, l, c, u, f, d, p, m = e.w_size;
                                            do {
                                                if (s = e.window_size - e.lookahead - e.strstart, e.strstart >= m + (m - h)) {
                                                    for(i.arraySet(e.window, e.window, m, m, 0), e.match_start -= m, e.strstart -= m, e.block_start -= m, t = r = e.hash_size; n = e.head[--t], e.head[t] = m <= n ? n - m : 0, --r;);
                                                    for(t = r = m; n = e.prev[--t], e.prev[t] = m <= n ? n - m : 0, --r;);
                                                    s += m;
                                                }
                                                if (0 === e.strm.avail_in) break;
                                                if (c = e.strm, u = e.window, f = e.strstart + e.lookahead, p = void 0, (d = s) < (p = c.avail_in) && (p = d), r = 0 === p ? 0 : (c.avail_in -= p, i.arraySet(u, c.input, c.next_in, p, f), 1 === c.state.wrap ? c.adler = o(c.adler, u, p, f) : 2 === c.state.wrap && (c.adler = a(c.adler, u, p, f)), c.next_in += p, c.total_in += p, p), e.lookahead += r, e.lookahead + e.insert >= 3) for(l = e.strstart - e.insert, e.ins_h = e.window[l], e.ins_h = (e.ins_h << e.hash_shift ^ e.window[l + 1]) & e.hash_mask; e.insert && (e.ins_h = (e.ins_h << e.hash_shift ^ e.window[l + 3 - 1]) & e.hash_mask, e.prev[l & e.w_mask] = e.head[e.ins_h], e.head[e.ins_h] = l, l++, e.insert--, !(e.lookahead + e.insert < 3)););
                                            }while (e.lookahead < h && 0 !== e.strm.avail_in);
                                        }
                                        function x(e, t) {
                                            for(var r, n;;){
                                                if (e.lookahead < h) {
                                                    if (_(e), e.lookahead < h && 0 === t) return 1;
                                                    if (0 === e.lookahead) break;
                                                }
                                                if (r = 0, e.lookahead >= 3 && (e.ins_h = (e.ins_h << e.hash_shift ^ e.window[e.strstart + 3 - 1]) & e.hash_mask, r = e.prev[e.strstart & e.w_mask] = e.head[e.ins_h], e.head[e.ins_h] = e.strstart), 0 !== r && e.strstart - r <= e.w_size - h && (e.match_length = w(e, r)), e.match_length >= 3) {
                                                    if (n = s._tr_tally(e, e.strstart - e.match_start, e.match_length - 3), e.lookahead -= e.match_length, e.match_length <= e.max_lazy_match && e.lookahead >= 3) {
                                                        for(e.match_length--; e.strstart++, e.ins_h = (e.ins_h << e.hash_shift ^ e.window[e.strstart + 3 - 1]) & e.hash_mask, r = e.prev[e.strstart & e.w_mask] = e.head[e.ins_h], e.head[e.ins_h] = e.strstart, 0 != --e.match_length;);
                                                        e.strstart++;
                                                    } else e.strstart += e.match_length, e.match_length = 0, e.ins_h = e.window[e.strstart], e.ins_h = (e.ins_h << e.hash_shift ^ e.window[e.strstart + 1]) & e.hash_mask;
                                                } else n = s._tr_tally(e, 0, e.window[e.strstart]), e.lookahead--, e.strstart++;
                                                if (n && (g(e, !1), 0 === e.strm.avail_out)) return 1;
                                            }
                                            return e.insert = e.strstart < 2 ? e.strstart : 2, 4 === t ? (g(e, !0), 0 === e.strm.avail_out ? 3 : 4) : e.last_lit && (g(e, !1), 0 === e.strm.avail_out) ? 1 : 2;
                                        }
                                        function k(e, t) {
                                            for(var r, n, i;;){
                                                if (e.lookahead < h) {
                                                    if (_(e), e.lookahead < h && 0 === t) return 1;
                                                    if (0 === e.lookahead) break;
                                                }
                                                if (r = 0, e.lookahead >= 3 && (e.ins_h = (e.ins_h << e.hash_shift ^ e.window[e.strstart + 3 - 1]) & e.hash_mask, r = e.prev[e.strstart & e.w_mask] = e.head[e.ins_h], e.head[e.ins_h] = e.strstart), e.prev_length = e.match_length, e.prev_match = e.match_start, e.match_length = 2, 0 !== r && e.prev_length < e.max_lazy_match && e.strstart - r <= e.w_size - h && (e.match_length = w(e, r), e.match_length <= 5 && (1 === e.strategy || 3 === e.match_length && 4096 < e.strstart - e.match_start) && (e.match_length = 2)), e.prev_length >= 3 && e.match_length <= e.prev_length) {
                                                    for(i = e.strstart + e.lookahead - 3, n = s._tr_tally(e, e.strstart - 1 - e.prev_match, e.prev_length - 3), e.lookahead -= e.prev_length - 1, e.prev_length -= 2; ++e.strstart <= i && (e.ins_h = (e.ins_h << e.hash_shift ^ e.window[e.strstart + 3 - 1]) & e.hash_mask, r = e.prev[e.strstart & e.w_mask] = e.head[e.ins_h], e.head[e.ins_h] = e.strstart), 0 != --e.prev_length;);
                                                    if (e.match_available = 0, e.match_length = 2, e.strstart++, n && (g(e, !1), 0 === e.strm.avail_out)) return 1;
                                                } else if (e.match_available) {
                                                    if ((n = s._tr_tally(e, 0, e.window[e.strstart - 1])) && g(e, !1), e.strstart++, e.lookahead--, 0 === e.strm.avail_out) return 1;
                                                } else e.match_available = 1, e.strstart++, e.lookahead--;
                                            }
                                            return e.match_available && (n = s._tr_tally(e, 0, e.window[e.strstart - 1]), e.match_available = 0), e.insert = e.strstart < 2 ? e.strstart : 2, 4 === t ? (g(e, !0), 0 === e.strm.avail_out ? 3 : 4) : e.last_lit && (g(e, !1), 0 === e.strm.avail_out) ? 1 : 2;
                                        }
                                        function S(e, t, r, n, i) {
                                            this.good_length = e, this.max_lazy = t, this.nice_length = r, this.max_chain = n, this.func = i;
                                        }
                                        function M() {
                                            this.strm = null, this.status = 0, this.pending_buf = null, this.pending_buf_size = 0, this.pending_out = 0, this.pending = 0, this.wrap = 0, this.gzhead = null, this.gzindex = 0, this.method = 8, this.last_flush = -1, this.w_size = 0, this.w_bits = 0, this.w_mask = 0, this.window = null, this.window_size = 0, this.prev = null, this.head = null, this.ins_h = 0, this.hash_size = 0, this.hash_bits = 0, this.hash_mask = 0, this.hash_shift = 0, this.block_start = 0, this.match_length = 0, this.prev_match = 0, this.match_available = 0, this.strstart = 0, this.match_start = 0, this.lookahead = 0, this.prev_length = 0, this.max_chain_length = 0, this.max_lazy_match = 0, this.level = 0, this.strategy = 0, this.good_match = 0, this.nice_match = 0, this.dyn_ltree = new i.Buf16(1146), this.dyn_dtree = new i.Buf16(122), this.bl_tree = new i.Buf16(78), m(this.dyn_ltree), m(this.dyn_dtree), m(this.bl_tree), this.l_desc = null, this.d_desc = null, this.bl_desc = null, this.bl_count = new i.Buf16(16), this.heap = new i.Buf16(573), m(this.heap), this.heap_len = 0, this.heap_max = 0, this.depth = new i.Buf16(573), m(this.depth), this.l_buf = 0, this.lit_bufsize = 0, this.last_lit = 0, this.d_buf = 0, this.opt_len = 0, this.static_len = 0, this.matches = 0, this.insert = 0, this.bi_buf = 0, this.bi_valid = 0;
                                        }
                                        function C(e) {
                                            var t;
                                            return e && e.state ? (e.total_in = e.total_out = 0, e.data_type = 2, (t = e.state).pending = 0, t.pending_out = 0, t.wrap < 0 && (t.wrap = -t.wrap), t.status = t.wrap ? 42 : f, e.adler = 2 === t.wrap ? 0 : 1, t.last_flush = 0, s._tr_init(t), 0) : d(e, c);
                                        }
                                        function T(e) {
                                            var t = C(e);
                                            return 0 === t && function(e) {
                                                e.window_size = 2 * e.w_size, m(e.head), e.max_lazy_match = n[e.level].max_lazy, e.good_match = n[e.level].good_length, e.nice_match = n[e.level].nice_length, e.max_chain_length = n[e.level].max_chain, e.strstart = 0, e.block_start = 0, e.lookahead = 0, e.insert = 0, e.match_length = e.prev_length = 2, e.match_available = 0, e.ins_h = 0;
                                            }(e.state), t;
                                        }
                                        function E(e, t, r, n, s, o) {
                                            if (!e) return c;
                                            var a = 1;
                                            if (-1 === t && (t = 6), n < 0 ? (a = 0, n = -n) : 15 < n && (a = 2, n -= 16), s < 1 || 9 < s || 8 !== r || n < 8 || 15 < n || t < 0 || 9 < t || o < 0 || 4 < o) return d(e, c);
                                            8 === n && (n = 9);
                                            var l = new M;
                                            return (e.state = l).strm = e, l.wrap = a, l.gzhead = null, l.w_bits = n, l.w_size = 1 << l.w_bits, l.w_mask = l.w_size - 1, l.hash_bits = s + 7, l.hash_size = 1 << l.hash_bits, l.hash_mask = l.hash_size - 1, l.hash_shift = ~~((l.hash_bits + 3 - 1) / 3), l.window = new i.Buf8(2 * l.w_size), l.head = new i.Buf16(l.hash_size), l.prev = new i.Buf16(l.w_size), l.lit_bufsize = 1 << s + 6, l.pending_buf_size = 4 * l.lit_bufsize, l.pending_buf = new i.Buf8(l.pending_buf_size), l.d_buf = 1 * l.lit_bufsize, l.l_buf = 3 * l.lit_bufsize, l.level = t, l.strategy = o, l.method = r, T(e);
                                        }
                                        n = [
                                            new S(0, 0, 0, 0, function(e, t) {
                                                var r = 65535;
                                                for(r > e.pending_buf_size - 5 && (r = e.pending_buf_size - 5);;){
                                                    if (e.lookahead <= 1) {
                                                        if (_(e), 0 === e.lookahead && 0 === t) return 1;
                                                        if (0 === e.lookahead) break;
                                                    }
                                                    e.strstart += e.lookahead, e.lookahead = 0;
                                                    var n = e.block_start + r;
                                                    if ((0 === e.strstart || e.strstart >= n) && (e.lookahead = e.strstart - n, e.strstart = n, g(e, !1), 0 === e.strm.avail_out)) return 1;
                                                    if (e.strstart - e.block_start >= e.w_size - h && (g(e, !1), 0 === e.strm.avail_out)) return 1;
                                                }
                                                return e.insert = 0, 4 === t ? (g(e, !0), 0 === e.strm.avail_out ? 3 : 4) : (e.strstart > e.block_start && (g(e, !1), e.strm.avail_out), 1);
                                            }),
                                            new S(4, 4, 8, 4, x),
                                            new S(4, 5, 16, 8, x),
                                            new S(4, 6, 32, 32, x),
                                            new S(4, 4, 16, 16, k),
                                            new S(8, 16, 32, 32, k),
                                            new S(8, 16, 128, 128, k),
                                            new S(8, 32, 128, 256, k),
                                            new S(32, 128, 258, 1024, k),
                                            new S(32, 258, 258, 4096, k)
                                        ], r.deflateInit = function(e, t) {
                                            return E(e, t, 8, 15, 8, 0);
                                        }, r.deflateInit2 = E, r.deflateReset = T, r.deflateResetKeep = C, r.deflateSetHeader = function(e, t) {
                                            return e && e.state ? 2 !== e.state.wrap ? c : (e.state.gzhead = t, 0) : c;
                                        }, r.deflate = function(e, t) {
                                            var r, i, o, l;
                                            if (!e || !e.state || 5 < t || t < 0) return e ? d(e, c) : c;
                                            if (i = e.state, !e.output || !e.input && 0 !== e.avail_in || 666 === i.status && 4 !== t) return d(e, 0 === e.avail_out ? -5 : c);
                                            if (i.strm = e, r = i.last_flush, i.last_flush = t, 42 === i.status) {
                                                if (2 === i.wrap) e.adler = 0, y(i, 31), y(i, 139), y(i, 8), i.gzhead ? (y(i, (i.gzhead.text ? 1 : 0) + (i.gzhead.hcrc ? 2 : 0) + (i.gzhead.extra ? 4 : 0) + (i.gzhead.name ? 8 : 0) + (i.gzhead.comment ? 16 : 0)), y(i, 255 & i.gzhead.time), y(i, i.gzhead.time >> 8 & 255), y(i, i.gzhead.time >> 16 & 255), y(i, i.gzhead.time >> 24 & 255), y(i, 9 === i.level ? 2 : 2 <= i.strategy || i.level < 2 ? 4 : 0), y(i, 255 & i.gzhead.os), i.gzhead.extra && i.gzhead.extra.length && (y(i, 255 & i.gzhead.extra.length), y(i, i.gzhead.extra.length >> 8 & 255)), i.gzhead.hcrc && (e.adler = a(e.adler, i.pending_buf, i.pending, 0)), i.gzindex = 0, i.status = 69) : (y(i, 0), y(i, 0), y(i, 0), y(i, 0), y(i, 0), y(i, 9 === i.level ? 2 : 2 <= i.strategy || i.level < 2 ? 4 : 0), y(i, 3), i.status = f);
                                                else {
                                                    var h = 8 + (i.w_bits - 8 << 4) << 8;
                                                    h |= (2 <= i.strategy || i.level < 2 ? 0 : i.level < 6 ? 1 : 6 === i.level ? 2 : 3) << 6, 0 !== i.strstart && (h |= 32), h += 31 - h % 31, i.status = f, v(i, h), 0 !== i.strstart && (v(i, e.adler >>> 16), v(i, 65535 & e.adler)), e.adler = 1;
                                                }
                                            }
                                            if (69 === i.status) {
                                                if (i.gzhead.extra) {
                                                    for(o = i.pending; i.gzindex < (65535 & i.gzhead.extra.length) && (i.pending !== i.pending_buf_size || (i.gzhead.hcrc && i.pending > o && (e.adler = a(e.adler, i.pending_buf, i.pending - o, o)), b(e), o = i.pending, i.pending !== i.pending_buf_size));)y(i, 255 & i.gzhead.extra[i.gzindex]), i.gzindex++;
                                                    i.gzhead.hcrc && i.pending > o && (e.adler = a(e.adler, i.pending_buf, i.pending - o, o)), i.gzindex === i.gzhead.extra.length && (i.gzindex = 0, i.status = 73);
                                                } else i.status = 73;
                                            }
                                            if (73 === i.status) {
                                                if (i.gzhead.name) {
                                                    o = i.pending;
                                                    do {
                                                        if (i.pending === i.pending_buf_size && (i.gzhead.hcrc && i.pending > o && (e.adler = a(e.adler, i.pending_buf, i.pending - o, o)), b(e), o = i.pending, i.pending === i.pending_buf_size)) {
                                                            l = 1;
                                                            break;
                                                        }
                                                        l = i.gzindex < i.gzhead.name.length ? 255 & i.gzhead.name.charCodeAt(i.gzindex++) : 0, y(i, l);
                                                    }while (0 !== l);
                                                    i.gzhead.hcrc && i.pending > o && (e.adler = a(e.adler, i.pending_buf, i.pending - o, o)), 0 === l && (i.gzindex = 0, i.status = 91);
                                                } else i.status = 91;
                                            }
                                            if (91 === i.status) {
                                                if (i.gzhead.comment) {
                                                    o = i.pending;
                                                    do {
                                                        if (i.pending === i.pending_buf_size && (i.gzhead.hcrc && i.pending > o && (e.adler = a(e.adler, i.pending_buf, i.pending - o, o)), b(e), o = i.pending, i.pending === i.pending_buf_size)) {
                                                            l = 1;
                                                            break;
                                                        }
                                                        l = i.gzindex < i.gzhead.comment.length ? 255 & i.gzhead.comment.charCodeAt(i.gzindex++) : 0, y(i, l);
                                                    }while (0 !== l);
                                                    i.gzhead.hcrc && i.pending > o && (e.adler = a(e.adler, i.pending_buf, i.pending - o, o)), 0 === l && (i.status = 103);
                                                } else i.status = 103;
                                            }
                                            if (103 === i.status && (i.gzhead.hcrc ? (i.pending + 2 > i.pending_buf_size && b(e), i.pending + 2 <= i.pending_buf_size && (y(i, 255 & e.adler), y(i, e.adler >> 8 & 255), e.adler = 0, i.status = f)) : i.status = f), 0 !== i.pending) {
                                                if (b(e), 0 === e.avail_out) return i.last_flush = -1, 0;
                                            } else if (0 === e.avail_in && p(t) <= p(r) && 4 !== t) return d(e, -5);
                                            if (666 === i.status && 0 !== e.avail_in) return d(e, -5);
                                            if (0 !== e.avail_in || 0 !== i.lookahead || 0 !== t && 666 !== i.status) {
                                                var w = 2 === i.strategy ? function(e, t) {
                                                    for(var r;;){
                                                        if (0 === e.lookahead && (_(e), 0 === e.lookahead)) {
                                                            if (0 === t) return 1;
                                                            break;
                                                        }
                                                        if (e.match_length = 0, r = s._tr_tally(e, 0, e.window[e.strstart]), e.lookahead--, e.strstart++, r && (g(e, !1), 0 === e.strm.avail_out)) return 1;
                                                    }
                                                    return e.insert = 0, 4 === t ? (g(e, !0), 0 === e.strm.avail_out ? 3 : 4) : e.last_lit && (g(e, !1), 0 === e.strm.avail_out) ? 1 : 2;
                                                }(i, t) : 3 === i.strategy ? function(e, t) {
                                                    for(var r, n, i, o, a = e.window;;){
                                                        if (e.lookahead <= u) {
                                                            if (_(e), e.lookahead <= u && 0 === t) return 1;
                                                            if (0 === e.lookahead) break;
                                                        }
                                                        if (e.match_length = 0, e.lookahead >= 3 && 0 < e.strstart && (n = a[i = e.strstart - 1]) === a[++i] && n === a[++i] && n === a[++i]) {
                                                            o = e.strstart + u;
                                                            do ;
                                                            while (n === a[++i] && n === a[++i] && n === a[++i] && n === a[++i] && n === a[++i] && n === a[++i] && n === a[++i] && n === a[++i] && i < o);
                                                            e.match_length = u - (o - i), e.match_length > e.lookahead && (e.match_length = e.lookahead);
                                                        }
                                                        if (e.match_length >= 3 ? (r = s._tr_tally(e, 1, e.match_length - 3), e.lookahead -= e.match_length, e.strstart += e.match_length, e.match_length = 0) : (r = s._tr_tally(e, 0, e.window[e.strstart]), e.lookahead--, e.strstart++), r && (g(e, !1), 0 === e.strm.avail_out)) return 1;
                                                    }
                                                    return e.insert = 0, 4 === t ? (g(e, !0), 0 === e.strm.avail_out ? 3 : 4) : e.last_lit && (g(e, !1), 0 === e.strm.avail_out) ? 1 : 2;
                                                }(i, t) : n[i.level].func(i, t);
                                                if (3 !== w && 4 !== w || (i.status = 666), 1 === w || 3 === w) return 0 === e.avail_out && (i.last_flush = -1), 0;
                                                if (2 === w && (1 === t ? s._tr_align(i) : 5 !== t && (s._tr_stored_block(i, 0, 0, !1), 3 === t && (m(i.head), 0 === i.lookahead && (i.strstart = 0, i.block_start = 0, i.insert = 0))), b(e), 0 === e.avail_out)) return i.last_flush = -1, 0;
                                            }
                                            return 4 !== t ? 0 : i.wrap <= 0 ? 1 : (2 === i.wrap ? (y(i, 255 & e.adler), y(i, e.adler >> 8 & 255), y(i, e.adler >> 16 & 255), y(i, e.adler >> 24 & 255), y(i, 255 & e.total_in), y(i, e.total_in >> 8 & 255), y(i, e.total_in >> 16 & 255), y(i, e.total_in >> 24 & 255)) : (v(i, e.adler >>> 16), v(i, 65535 & e.adler)), b(e), 0 < i.wrap && (i.wrap = -i.wrap), 0 !== i.pending ? 0 : 1);
                                        }, r.deflateEnd = function(e) {
                                            var t;
                                            return e && e.state ? 42 !== (t = e.state.status) && 69 !== t && 73 !== t && 91 !== t && 103 !== t && t !== f && 666 !== t ? d(e, c) : (e.state = null, t === f ? d(e, -3) : 0) : c;
                                        }, r.deflateSetDictionary = function(e, t) {
                                            var r, n, s, a, l, u, h, f, d = t.length;
                                            if (!e || !e.state) return c;
                                            if (2 === (a = (r = e.state).wrap) || 1 === a && 42 !== r.status || r.lookahead) return c;
                                            for(1 === a && (e.adler = o(e.adler, t, d, 0)), r.wrap = 0, d >= r.w_size && (0 === a && (m(r.head), r.strstart = 0, r.block_start = 0, r.insert = 0), f = new i.Buf8(r.w_size), i.arraySet(f, t, d - r.w_size, r.w_size, 0), t = f, d = r.w_size), l = e.avail_in, u = e.next_in, h = e.input, e.avail_in = d, e.next_in = 0, e.input = t, _(r); r.lookahead >= 3;){
                                                for(n = r.strstart, s = r.lookahead - 2; r.ins_h = (r.ins_h << r.hash_shift ^ r.window[n + 3 - 1]) & r.hash_mask, r.prev[n & r.w_mask] = r.head[r.ins_h], r.head[r.ins_h] = n, n++, --s;);
                                                r.strstart = n, r.lookahead = 2, _(r);
                                            }
                                            return r.strstart += r.lookahead, r.block_start = r.strstart, r.insert = r.lookahead, r.lookahead = 0, r.match_length = r.prev_length = 2, r.match_available = 0, e.next_in = u, e.input = h, e.avail_in = l, r.wrap = a, 0;
                                        }, r.deflateInfo = "pako deflate (from Nodeca project)";
                                    },
                                    {
                                        "../utils/common": 41,
                                        "./adler32": 43,
                                        "./crc32": 45,
                                        "./messages": 51,
                                        "./trees": 52
                                    }
                                ],
                                47: [
                                    function(e, t, r) {
                                        t.exports = function() {
                                            this.text = 0, this.time = 0, this.xflags = 0, this.os = 0, this.extra = null, this.extra_len = 0, this.name = "", this.comment = "", this.hcrc = 0, this.done = !1;
                                        };
                                    },
                                    {}
                                ],
                                48: [
                                    function(e, t, r) {
                                        t.exports = function(e, t) {
                                            var r, n, i, s, o, a, l, c, u, h, f, d, p, m, b, g, y, v, w, _, x, k, S, M, C;
                                            r = e.state, n = e.next_in, M = e.input, i = n + (e.avail_in - 5), s = e.next_out, C = e.output, o = s - (t - e.avail_out), a = s + (e.avail_out - 257), l = r.dmax, c = r.wsize, u = r.whave, h = r.wnext, f = r.window, d = r.hold, p = r.bits, m = r.lencode, b = r.distcode, g = (1 << r.lenbits) - 1, y = (1 << r.distbits) - 1;
                                            e: do {
                                                p < 15 && (d += M[n++] << p, p += 8, d += M[n++] << p, p += 8), v = m[d & g];
                                                t: for(;;){
                                                    if (d >>>= w = v >>> 24, p -= w, 0 == (w = v >>> 16 & 255)) C[s++] = 65535 & v;
                                                    else {
                                                        if (!(16 & w)) {
                                                            if (0 == (64 & w)) {
                                                                v = m[(65535 & v) + (d & (1 << w) - 1)];
                                                                continue t;
                                                            }
                                                            if (32 & w) {
                                                                r.mode = 12;
                                                                break e;
                                                            }
                                                            e.msg = "invalid literal/length code", r.mode = 30;
                                                            break e;
                                                        }
                                                        _ = 65535 & v, (w &= 15) && (p < w && (d += M[n++] << p, p += 8), _ += d & (1 << w) - 1, d >>>= w, p -= w), p < 15 && (d += M[n++] << p, p += 8, d += M[n++] << p, p += 8), v = b[d & y];
                                                        r: for(;;){
                                                            if (d >>>= w = v >>> 24, p -= w, !(16 & (w = v >>> 16 & 255))) {
                                                                if (0 == (64 & w)) {
                                                                    v = b[(65535 & v) + (d & (1 << w) - 1)];
                                                                    continue r;
                                                                }
                                                                e.msg = "invalid distance code", r.mode = 30;
                                                                break e;
                                                            }
                                                            if (x = 65535 & v, p < (w &= 15) && (d += M[n++] << p, (p += 8) < w && (d += M[n++] << p, p += 8)), l < (x += d & (1 << w) - 1)) {
                                                                e.msg = "invalid distance too far back", r.mode = 30;
                                                                break e;
                                                            }
                                                            if (d >>>= w, p -= w, (w = s - o) < x) {
                                                                if (u < (w = x - w) && r.sane) {
                                                                    e.msg = "invalid distance too far back", r.mode = 30;
                                                                    break e;
                                                                }
                                                                if (S = f, (k = 0) === h) {
                                                                    if (k += c - w, w < _) {
                                                                        for(_ -= w; C[s++] = f[k++], --w;);
                                                                        k = s - x, S = C;
                                                                    }
                                                                } else if (h < w) {
                                                                    if (k += c + h - w, (w -= h) < _) {
                                                                        for(_ -= w; C[s++] = f[k++], --w;);
                                                                        if (k = 0, h < _) {
                                                                            for(_ -= w = h; C[s++] = f[k++], --w;);
                                                                            k = s - x, S = C;
                                                                        }
                                                                    }
                                                                } else if (k += h - w, w < _) {
                                                                    for(_ -= w; C[s++] = f[k++], --w;);
                                                                    k = s - x, S = C;
                                                                }
                                                                for(; 2 < _;)C[s++] = S[k++], C[s++] = S[k++], C[s++] = S[k++], _ -= 3;
                                                                _ && (C[s++] = S[k++], 1 < _ && (C[s++] = S[k++]));
                                                            } else {
                                                                for(k = s - x; C[s++] = C[k++], C[s++] = C[k++], C[s++] = C[k++], 2 < (_ -= 3););
                                                                _ && (C[s++] = C[k++], 1 < _ && (C[s++] = C[k++]));
                                                            }
                                                            break;
                                                        }
                                                    }
                                                    break;
                                                }
                                            }while (n < i && s < a);
                                            n -= _ = p >> 3, d &= (1 << (p -= _ << 3)) - 1, e.next_in = n, e.next_out = s, e.avail_in = n < i ? i - n + 5 : 5 - (n - i), e.avail_out = s < a ? a - s + 257 : 257 - (s - a), r.hold = d, r.bits = p;
                                        };
                                    },
                                    {}
                                ],
                                49: [
                                    function(e, t, r) {
                                        var n = e("../utils/common"), i = e("./adler32"), s = e("./crc32"), o = e("./inffast"), a = e("./inftrees"), l = -2;
                                        function c(e) {
                                            return (e >>> 24 & 255) + (e >>> 8 & 65280) + ((65280 & e) << 8) + ((255 & e) << 24);
                                        }
                                        function u() {
                                            this.mode = 0, this.last = !1, this.wrap = 0, this.havedict = !1, this.flags = 0, this.dmax = 0, this.check = 0, this.total = 0, this.head = null, this.wbits = 0, this.wsize = 0, this.whave = 0, this.wnext = 0, this.window = null, this.hold = 0, this.bits = 0, this.length = 0, this.offset = 0, this.extra = 0, this.lencode = null, this.distcode = null, this.lenbits = 0, this.distbits = 0, this.ncode = 0, this.nlen = 0, this.ndist = 0, this.have = 0, this.next = null, this.lens = new n.Buf16(320), this.work = new n.Buf16(288), this.lendyn = null, this.distdyn = null, this.sane = 0, this.back = 0, this.was = 0;
                                        }
                                        function h(e) {
                                            var t;
                                            return e && e.state ? (t = e.state, e.total_in = e.total_out = t.total = 0, e.msg = "", t.wrap && (e.adler = 1 & t.wrap), t.mode = 1, t.last = 0, t.havedict = 0, t.dmax = 32768, t.head = null, t.hold = 0, t.bits = 0, t.lencode = t.lendyn = new n.Buf32(852), t.distcode = t.distdyn = new n.Buf32(592), t.sane = 1, t.back = -1, 0) : l;
                                        }
                                        function f(e) {
                                            var t;
                                            return e && e.state ? ((t = e.state).wsize = 0, t.whave = 0, t.wnext = 0, h(e)) : l;
                                        }
                                        function d(e, t) {
                                            var r, n;
                                            return e && e.state ? (n = e.state, t < 0 ? (r = 0, t = -t) : (r = 1 + (t >> 4), t < 48 && (t &= 15)), t && (t < 8 || 15 < t) ? l : (null !== n.window && n.wbits !== t && (n.window = null), n.wrap = r, n.wbits = t, f(e))) : l;
                                        }
                                        function p(e, t) {
                                            var r, n;
                                            return e ? (n = new u, (e.state = n).window = null, 0 !== (r = d(e, t)) && (e.state = null), r) : l;
                                        }
                                        var m, b, g = !0;
                                        function y(e) {
                                            if (g) {
                                                var t;
                                                for(m = new n.Buf32(512), b = new n.Buf32(32), t = 0; t < 144;)e.lens[t++] = 8;
                                                for(; t < 256;)e.lens[t++] = 9;
                                                for(; t < 280;)e.lens[t++] = 7;
                                                for(; t < 288;)e.lens[t++] = 8;
                                                for(a(1, e.lens, 0, 288, m, 0, e.work, {
                                                    bits: 9
                                                }), t = 0; t < 32;)e.lens[t++] = 5;
                                                a(2, e.lens, 0, 32, b, 0, e.work, {
                                                    bits: 5
                                                }), g = !1;
                                            }
                                            e.lencode = m, e.lenbits = 9, e.distcode = b, e.distbits = 5;
                                        }
                                        function v(e, t, r, i) {
                                            var s, o = e.state;
                                            return null === o.window && (o.wsize = 1 << o.wbits, o.wnext = 0, o.whave = 0, o.window = new n.Buf8(o.wsize)), i >= o.wsize ? (n.arraySet(o.window, t, r - o.wsize, o.wsize, 0), o.wnext = 0, o.whave = o.wsize) : (i < (s = o.wsize - o.wnext) && (s = i), n.arraySet(o.window, t, r - i, s, o.wnext), (i -= s) ? (n.arraySet(o.window, t, r - i, i, 0), o.wnext = i, o.whave = o.wsize) : (o.wnext += s, o.wnext === o.wsize && (o.wnext = 0), o.whave < o.wsize && (o.whave += s))), 0;
                                        }
                                        r.inflateReset = f, r.inflateReset2 = d, r.inflateResetKeep = h, r.inflateInit = function(e) {
                                            return p(e, 15);
                                        }, r.inflateInit2 = p, r.inflate = function(e, t) {
                                            var r, u, h, f, d, p, m, b, g, w, _, x, k, S, M, C, T, E, A, R, O, j, I, N, P = 0, B = new n.Buf8(4), D = [
                                                16,
                                                17,
                                                18,
                                                0,
                                                8,
                                                7,
                                                9,
                                                6,
                                                10,
                                                5,
                                                11,
                                                4,
                                                12,
                                                3,
                                                13,
                                                2,
                                                14,
                                                1,
                                                15
                                            ];
                                            if (!e || !e.state || !e.output || !e.input && 0 !== e.avail_in) return l;
                                            12 === (r = e.state).mode && (r.mode = 13), d = e.next_out, h = e.output, m = e.avail_out, f = e.next_in, u = e.input, p = e.avail_in, b = r.hold, g = r.bits, w = p, _ = m, j = 0;
                                            e: for(;;)switch(r.mode){
                                                case 1:
                                                    if (0 === r.wrap) {
                                                        r.mode = 13;
                                                        break;
                                                    }
                                                    for(; g < 16;){
                                                        if (0 === p) break e;
                                                        p--, b += u[f++] << g, g += 8;
                                                    }
                                                    if (2 & r.wrap && 35615 === b) {
                                                        B[r.check = 0] = 255 & b, B[1] = b >>> 8 & 255, r.check = s(r.check, B, 2, 0), g = b = 0, r.mode = 2;
                                                        break;
                                                    }
                                                    if (r.flags = 0, r.head && (r.head.done = !1), !(1 & r.wrap) || (((255 & b) << 8) + (b >> 8)) % 31) {
                                                        e.msg = "incorrect header check", r.mode = 30;
                                                        break;
                                                    }
                                                    if (8 != (15 & b)) {
                                                        e.msg = "unknown compression method", r.mode = 30;
                                                        break;
                                                    }
                                                    if (g -= 4, O = 8 + (15 & (b >>>= 4)), 0 === r.wbits) r.wbits = O;
                                                    else if (O > r.wbits) {
                                                        e.msg = "invalid window size", r.mode = 30;
                                                        break;
                                                    }
                                                    r.dmax = 1 << O, e.adler = r.check = 1, r.mode = 512 & b ? 10 : 12, g = b = 0;
                                                    break;
                                                case 2:
                                                    for(; g < 16;){
                                                        if (0 === p) break e;
                                                        p--, b += u[f++] << g, g += 8;
                                                    }
                                                    if (r.flags = b, 8 != (255 & r.flags)) {
                                                        e.msg = "unknown compression method", r.mode = 30;
                                                        break;
                                                    }
                                                    if (57344 & r.flags) {
                                                        e.msg = "unknown header flags set", r.mode = 30;
                                                        break;
                                                    }
                                                    r.head && (r.head.text = b >> 8 & 1), 512 & r.flags && (B[0] = 255 & b, B[1] = b >>> 8 & 255, r.check = s(r.check, B, 2, 0)), g = b = 0, r.mode = 3;
                                                case 3:
                                                    for(; g < 32;){
                                                        if (0 === p) break e;
                                                        p--, b += u[f++] << g, g += 8;
                                                    }
                                                    r.head && (r.head.time = b), 512 & r.flags && (B[0] = 255 & b, B[1] = b >>> 8 & 255, B[2] = b >>> 16 & 255, B[3] = b >>> 24 & 255, r.check = s(r.check, B, 4, 0)), g = b = 0, r.mode = 4;
                                                case 4:
                                                    for(; g < 16;){
                                                        if (0 === p) break e;
                                                        p--, b += u[f++] << g, g += 8;
                                                    }
                                                    r.head && (r.head.xflags = 255 & b, r.head.os = b >> 8), 512 & r.flags && (B[0] = 255 & b, B[1] = b >>> 8 & 255, r.check = s(r.check, B, 2, 0)), g = b = 0, r.mode = 5;
                                                case 5:
                                                    if (1024 & r.flags) {
                                                        for(; g < 16;){
                                                            if (0 === p) break e;
                                                            p--, b += u[f++] << g, g += 8;
                                                        }
                                                        r.length = b, r.head && (r.head.extra_len = b), 512 & r.flags && (B[0] = 255 & b, B[1] = b >>> 8 & 255, r.check = s(r.check, B, 2, 0)), g = b = 0;
                                                    } else r.head && (r.head.extra = null);
                                                    r.mode = 6;
                                                case 6:
                                                    if (1024 & r.flags && (p < (x = r.length) && (x = p), x && (r.head && (O = r.head.extra_len - r.length, r.head.extra || (r.head.extra = new Array(r.head.extra_len)), n.arraySet(r.head.extra, u, f, x, O)), 512 & r.flags && (r.check = s(r.check, u, x, f)), p -= x, f += x, r.length -= x), r.length)) break e;
                                                    r.length = 0, r.mode = 7;
                                                case 7:
                                                    if (2048 & r.flags) {
                                                        if (0 === p) break e;
                                                        for(x = 0; O = u[f + x++], r.head && O && r.length < 65536 && (r.head.name += String.fromCharCode(O)), O && x < p;);
                                                        if (512 & r.flags && (r.check = s(r.check, u, x, f)), p -= x, f += x, O) break e;
                                                    } else r.head && (r.head.name = null);
                                                    r.length = 0, r.mode = 8;
                                                case 8:
                                                    if (4096 & r.flags) {
                                                        if (0 === p) break e;
                                                        for(x = 0; O = u[f + x++], r.head && O && r.length < 65536 && (r.head.comment += String.fromCharCode(O)), O && x < p;);
                                                        if (512 & r.flags && (r.check = s(r.check, u, x, f)), p -= x, f += x, O) break e;
                                                    } else r.head && (r.head.comment = null);
                                                    r.mode = 9;
                                                case 9:
                                                    if (512 & r.flags) {
                                                        for(; g < 16;){
                                                            if (0 === p) break e;
                                                            p--, b += u[f++] << g, g += 8;
                                                        }
                                                        if (b !== (65535 & r.check)) {
                                                            e.msg = "header crc mismatch", r.mode = 30;
                                                            break;
                                                        }
                                                        g = b = 0;
                                                    }
                                                    r.head && (r.head.hcrc = r.flags >> 9 & 1, r.head.done = !0), e.adler = r.check = 0, r.mode = 12;
                                                    break;
                                                case 10:
                                                    for(; g < 32;){
                                                        if (0 === p) break e;
                                                        p--, b += u[f++] << g, g += 8;
                                                    }
                                                    e.adler = r.check = c(b), g = b = 0, r.mode = 11;
                                                case 11:
                                                    if (0 === r.havedict) return e.next_out = d, e.avail_out = m, e.next_in = f, e.avail_in = p, r.hold = b, r.bits = g, 2;
                                                    e.adler = r.check = 1, r.mode = 12;
                                                case 12:
                                                    if (5 === t || 6 === t) break e;
                                                case 13:
                                                    if (r.last) {
                                                        b >>>= 7 & g, g -= 7 & g, r.mode = 27;
                                                        break;
                                                    }
                                                    for(; g < 3;){
                                                        if (0 === p) break e;
                                                        p--, b += u[f++] << g, g += 8;
                                                    }
                                                    switch(r.last = 1 & b, g -= 1, 3 & (b >>>= 1)){
                                                        case 0:
                                                            r.mode = 14;
                                                            break;
                                                        case 1:
                                                            if (y(r), r.mode = 20, 6 !== t) break;
                                                            b >>>= 2, g -= 2;
                                                            break e;
                                                        case 2:
                                                            r.mode = 17;
                                                            break;
                                                        case 3:
                                                            e.msg = "invalid block type", r.mode = 30;
                                                    }
                                                    b >>>= 2, g -= 2;
                                                    break;
                                                case 14:
                                                    for(b >>>= 7 & g, g -= 7 & g; g < 32;){
                                                        if (0 === p) break e;
                                                        p--, b += u[f++] << g, g += 8;
                                                    }
                                                    if ((65535 & b) != (b >>> 16 ^ 65535)) {
                                                        e.msg = "invalid stored block lengths", r.mode = 30;
                                                        break;
                                                    }
                                                    if (r.length = 65535 & b, g = b = 0, r.mode = 15, 6 === t) break e;
                                                case 15:
                                                    r.mode = 16;
                                                case 16:
                                                    if (x = r.length) {
                                                        if (p < x && (x = p), m < x && (x = m), 0 === x) break e;
                                                        n.arraySet(h, u, f, x, d), p -= x, f += x, m -= x, d += x, r.length -= x;
                                                        break;
                                                    }
                                                    r.mode = 12;
                                                    break;
                                                case 17:
                                                    for(; g < 14;){
                                                        if (0 === p) break e;
                                                        p--, b += u[f++] << g, g += 8;
                                                    }
                                                    if (r.nlen = 257 + (31 & b), b >>>= 5, g -= 5, r.ndist = 1 + (31 & b), b >>>= 5, g -= 5, r.ncode = 4 + (15 & b), b >>>= 4, g -= 4, 286 < r.nlen || 30 < r.ndist) {
                                                        e.msg = "too many length or distance symbols", r.mode = 30;
                                                        break;
                                                    }
                                                    r.have = 0, r.mode = 18;
                                                case 18:
                                                    for(; r.have < r.ncode;){
                                                        for(; g < 3;){
                                                            if (0 === p) break e;
                                                            p--, b += u[f++] << g, g += 8;
                                                        }
                                                        r.lens[D[r.have++]] = 7 & b, b >>>= 3, g -= 3;
                                                    }
                                                    for(; r.have < 19;)r.lens[D[r.have++]] = 0;
                                                    if (r.lencode = r.lendyn, r.lenbits = 7, I = {
                                                        bits: r.lenbits
                                                    }, j = a(0, r.lens, 0, 19, r.lencode, 0, r.work, I), r.lenbits = I.bits, j) {
                                                        e.msg = "invalid code lengths set", r.mode = 30;
                                                        break;
                                                    }
                                                    r.have = 0, r.mode = 19;
                                                case 19:
                                                    for(; r.have < r.nlen + r.ndist;){
                                                        for(; C = (P = r.lencode[b & (1 << r.lenbits) - 1]) >>> 16 & 255, T = 65535 & P, !((M = P >>> 24) <= g);){
                                                            if (0 === p) break e;
                                                            p--, b += u[f++] << g, g += 8;
                                                        }
                                                        if (T < 16) b >>>= M, g -= M, r.lens[r.have++] = T;
                                                        else {
                                                            if (16 === T) {
                                                                for(N = M + 2; g < N;){
                                                                    if (0 === p) break e;
                                                                    p--, b += u[f++] << g, g += 8;
                                                                }
                                                                if (b >>>= M, g -= M, 0 === r.have) {
                                                                    e.msg = "invalid bit length repeat", r.mode = 30;
                                                                    break;
                                                                }
                                                                O = r.lens[r.have - 1], x = 3 + (3 & b), b >>>= 2, g -= 2;
                                                            } else if (17 === T) {
                                                                for(N = M + 3; g < N;){
                                                                    if (0 === p) break e;
                                                                    p--, b += u[f++] << g, g += 8;
                                                                }
                                                                g -= M, O = 0, x = 3 + (7 & (b >>>= M)), b >>>= 3, g -= 3;
                                                            } else {
                                                                for(N = M + 7; g < N;){
                                                                    if (0 === p) break e;
                                                                    p--, b += u[f++] << g, g += 8;
                                                                }
                                                                g -= M, O = 0, x = 11 + (127 & (b >>>= M)), b >>>= 7, g -= 7;
                                                            }
                                                            if (r.have + x > r.nlen + r.ndist) {
                                                                e.msg = "invalid bit length repeat", r.mode = 30;
                                                                break;
                                                            }
                                                            for(; x--;)r.lens[r.have++] = O;
                                                        }
                                                    }
                                                    if (30 === r.mode) break;
                                                    if (0 === r.lens[256]) {
                                                        e.msg = "invalid code -- missing end-of-block", r.mode = 30;
                                                        break;
                                                    }
                                                    if (r.lenbits = 9, I = {
                                                        bits: r.lenbits
                                                    }, j = a(1, r.lens, 0, r.nlen, r.lencode, 0, r.work, I), r.lenbits = I.bits, j) {
                                                        e.msg = "invalid literal/lengths set", r.mode = 30;
                                                        break;
                                                    }
                                                    if (r.distbits = 6, r.distcode = r.distdyn, I = {
                                                        bits: r.distbits
                                                    }, j = a(2, r.lens, r.nlen, r.ndist, r.distcode, 0, r.work, I), r.distbits = I.bits, j) {
                                                        e.msg = "invalid distances set", r.mode = 30;
                                                        break;
                                                    }
                                                    if (r.mode = 20, 6 === t) break e;
                                                case 20:
                                                    r.mode = 21;
                                                case 21:
                                                    if (6 <= p && 258 <= m) {
                                                        e.next_out = d, e.avail_out = m, e.next_in = f, e.avail_in = p, r.hold = b, r.bits = g, o(e, _), d = e.next_out, h = e.output, m = e.avail_out, f = e.next_in, u = e.input, p = e.avail_in, b = r.hold, g = r.bits, 12 === r.mode && (r.back = -1);
                                                        break;
                                                    }
                                                    for(r.back = 0; C = (P = r.lencode[b & (1 << r.lenbits) - 1]) >>> 16 & 255, T = 65535 & P, !((M = P >>> 24) <= g);){
                                                        if (0 === p) break e;
                                                        p--, b += u[f++] << g, g += 8;
                                                    }
                                                    if (C && 0 == (240 & C)) {
                                                        for(E = M, A = C, R = T; C = (P = r.lencode[R + ((b & (1 << E + A) - 1) >> E)]) >>> 16 & 255, T = 65535 & P, !(E + (M = P >>> 24) <= g);){
                                                            if (0 === p) break e;
                                                            p--, b += u[f++] << g, g += 8;
                                                        }
                                                        b >>>= E, g -= E, r.back += E;
                                                    }
                                                    if (b >>>= M, g -= M, r.back += M, r.length = T, 0 === C) {
                                                        r.mode = 26;
                                                        break;
                                                    }
                                                    if (32 & C) {
                                                        r.back = -1, r.mode = 12;
                                                        break;
                                                    }
                                                    if (64 & C) {
                                                        e.msg = "invalid literal/length code", r.mode = 30;
                                                        break;
                                                    }
                                                    r.extra = 15 & C, r.mode = 22;
                                                case 22:
                                                    if (r.extra) {
                                                        for(N = r.extra; g < N;){
                                                            if (0 === p) break e;
                                                            p--, b += u[f++] << g, g += 8;
                                                        }
                                                        r.length += b & (1 << r.extra) - 1, b >>>= r.extra, g -= r.extra, r.back += r.extra;
                                                    }
                                                    r.was = r.length, r.mode = 23;
                                                case 23:
                                                    for(; C = (P = r.distcode[b & (1 << r.distbits) - 1]) >>> 16 & 255, T = 65535 & P, !((M = P >>> 24) <= g);){
                                                        if (0 === p) break e;
                                                        p--, b += u[f++] << g, g += 8;
                                                    }
                                                    if (0 == (240 & C)) {
                                                        for(E = M, A = C, R = T; C = (P = r.distcode[R + ((b & (1 << E + A) - 1) >> E)]) >>> 16 & 255, T = 65535 & P, !(E + (M = P >>> 24) <= g);){
                                                            if (0 === p) break e;
                                                            p--, b += u[f++] << g, g += 8;
                                                        }
                                                        b >>>= E, g -= E, r.back += E;
                                                    }
                                                    if (b >>>= M, g -= M, r.back += M, 64 & C) {
                                                        e.msg = "invalid distance code", r.mode = 30;
                                                        break;
                                                    }
                                                    r.offset = T, r.extra = 15 & C, r.mode = 24;
                                                case 24:
                                                    if (r.extra) {
                                                        for(N = r.extra; g < N;){
                                                            if (0 === p) break e;
                                                            p--, b += u[f++] << g, g += 8;
                                                        }
                                                        r.offset += b & (1 << r.extra) - 1, b >>>= r.extra, g -= r.extra, r.back += r.extra;
                                                    }
                                                    if (r.offset > r.dmax) {
                                                        e.msg = "invalid distance too far back", r.mode = 30;
                                                        break;
                                                    }
                                                    r.mode = 25;
                                                case 25:
                                                    if (0 === m) break e;
                                                    if (x = _ - m, r.offset > x) {
                                                        if ((x = r.offset - x) > r.whave && r.sane) {
                                                            e.msg = "invalid distance too far back", r.mode = 30;
                                                            break;
                                                        }
                                                        k = x > r.wnext ? (x -= r.wnext, r.wsize - x) : r.wnext - x, x > r.length && (x = r.length), S = r.window;
                                                    } else S = h, k = d - r.offset, x = r.length;
                                                    for(m < x && (x = m), m -= x, r.length -= x; h[d++] = S[k++], --x;);
                                                    0 === r.length && (r.mode = 21);
                                                    break;
                                                case 26:
                                                    if (0 === m) break e;
                                                    h[d++] = r.length, m--, r.mode = 21;
                                                    break;
                                                case 27:
                                                    if (r.wrap) {
                                                        for(; g < 32;){
                                                            if (0 === p) break e;
                                                            p--, b |= u[f++] << g, g += 8;
                                                        }
                                                        if (_ -= m, e.total_out += _, r.total += _, _ && (e.adler = r.check = r.flags ? s(r.check, h, _, d - _) : i(r.check, h, _, d - _)), _ = m, (r.flags ? b : c(b)) !== r.check) {
                                                            e.msg = "incorrect data check", r.mode = 30;
                                                            break;
                                                        }
                                                        g = b = 0;
                                                    }
                                                    r.mode = 28;
                                                case 28:
                                                    if (r.wrap && r.flags) {
                                                        for(; g < 32;){
                                                            if (0 === p) break e;
                                                            p--, b += u[f++] << g, g += 8;
                                                        }
                                                        if (b !== (4294967295 & r.total)) {
                                                            e.msg = "incorrect length check", r.mode = 30;
                                                            break;
                                                        }
                                                        g = b = 0;
                                                    }
                                                    r.mode = 29;
                                                case 29:
                                                    j = 1;
                                                    break e;
                                                case 30:
                                                    j = -3;
                                                    break e;
                                                case 31:
                                                    return -4;
                                                case 32:
                                                default:
                                                    return l;
                                            }
                                            return e.next_out = d, e.avail_out = m, e.next_in = f, e.avail_in = p, r.hold = b, r.bits = g, (r.wsize || _ !== e.avail_out && r.mode < 30 && (r.mode < 27 || 4 !== t)) && v(e, e.output, e.next_out, _ - e.avail_out) ? (r.mode = 31, -4) : (w -= e.avail_in, _ -= e.avail_out, e.total_in += w, e.total_out += _, r.total += _, r.wrap && _ && (e.adler = r.check = r.flags ? s(r.check, h, _, e.next_out - _) : i(r.check, h, _, e.next_out - _)), e.data_type = r.bits + (r.last ? 64 : 0) + (12 === r.mode ? 128 : 0) + (20 === r.mode || 15 === r.mode ? 256 : 0), (0 == w && 0 === _ || 4 === t) && 0 === j && (j = -5), j);
                                        }, r.inflateEnd = function(e) {
                                            if (!e || !e.state) return l;
                                            var t = e.state;
                                            return t.window && (t.window = null), e.state = null, 0;
                                        }, r.inflateGetHeader = function(e, t) {
                                            var r;
                                            return e && e.state ? 0 == (2 & (r = e.state).wrap) ? l : ((r.head = t).done = !1, 0) : l;
                                        }, r.inflateSetDictionary = function(e, t) {
                                            var r, n = t.length;
                                            return e && e.state ? 0 !== (r = e.state).wrap && 11 !== r.mode ? l : 11 === r.mode && i(1, t, n, 0) !== r.check ? -3 : v(e, t, n, n) ? (r.mode = 31, -4) : (r.havedict = 1, 0) : l;
                                        }, r.inflateInfo = "pako inflate (from Nodeca project)";
                                    },
                                    {
                                        "../utils/common": 41,
                                        "./adler32": 43,
                                        "./crc32": 45,
                                        "./inffast": 48,
                                        "./inftrees": 50
                                    }
                                ],
                                50: [
                                    function(e, t, r) {
                                        var n = e("../utils/common"), i = [
                                            3,
                                            4,
                                            5,
                                            6,
                                            7,
                                            8,
                                            9,
                                            10,
                                            11,
                                            13,
                                            15,
                                            17,
                                            19,
                                            23,
                                            27,
                                            31,
                                            35,
                                            43,
                                            51,
                                            59,
                                            67,
                                            83,
                                            99,
                                            115,
                                            131,
                                            163,
                                            195,
                                            227,
                                            258,
                                            0,
                                            0
                                        ], s = [
                                            16,
                                            16,
                                            16,
                                            16,
                                            16,
                                            16,
                                            16,
                                            16,
                                            17,
                                            17,
                                            17,
                                            17,
                                            18,
                                            18,
                                            18,
                                            18,
                                            19,
                                            19,
                                            19,
                                            19,
                                            20,
                                            20,
                                            20,
                                            20,
                                            21,
                                            21,
                                            21,
                                            21,
                                            16,
                                            72,
                                            78
                                        ], o = [
                                            1,
                                            2,
                                            3,
                                            4,
                                            5,
                                            7,
                                            9,
                                            13,
                                            17,
                                            25,
                                            33,
                                            49,
                                            65,
                                            97,
                                            129,
                                            193,
                                            257,
                                            385,
                                            513,
                                            769,
                                            1025,
                                            1537,
                                            2049,
                                            3073,
                                            4097,
                                            6145,
                                            8193,
                                            12289,
                                            16385,
                                            24577,
                                            0,
                                            0
                                        ], a = [
                                            16,
                                            16,
                                            16,
                                            16,
                                            17,
                                            17,
                                            18,
                                            18,
                                            19,
                                            19,
                                            20,
                                            20,
                                            21,
                                            21,
                                            22,
                                            22,
                                            23,
                                            23,
                                            24,
                                            24,
                                            25,
                                            25,
                                            26,
                                            26,
                                            27,
                                            27,
                                            28,
                                            28,
                                            29,
                                            29,
                                            64,
                                            64
                                        ];
                                        t.exports = function(e, t, r, l, c, u, h, f) {
                                            var d, p, m, b, g, y, v, w, _, x = f.bits, k = 0, S = 0, M = 0, C = 0, T = 0, E = 0, A = 0, R = 0, O = 0, j = 0, I = null, N = 0, P = new n.Buf16(16), B = new n.Buf16(16), D = null, F = 0;
                                            for(k = 0; k <= 15; k++)P[k] = 0;
                                            for(S = 0; S < l; S++)P[t[r + S]]++;
                                            for(T = x, C = 15; 1 <= C && 0 === P[C]; C--);
                                            if (C < T && (T = C), 0 === C) return c[u++] = 20971520, c[u++] = 20971520, f.bits = 1, 0;
                                            for(M = 1; M < C && 0 === P[M]; M++);
                                            for(T < M && (T = M), k = R = 1; k <= 15; k++)if (R <<= 1, (R -= P[k]) < 0) return -1;
                                            if (0 < R && (0 === e || 1 !== C)) return -1;
                                            for(B[1] = 0, k = 1; k < 15; k++)B[k + 1] = B[k] + P[k];
                                            for(S = 0; S < l; S++)0 !== t[r + S] && (h[B[t[r + S]]++] = S);
                                            if (y = 0 === e ? (I = D = h, 19) : 1 === e ? (I = i, N -= 257, D = s, F -= 257, 256) : (I = o, D = a, -1), k = M, g = u, A = S = j = 0, m = -1, b = (O = 1 << (E = T)) - 1, 1 === e && 852 < O || 2 === e && 592 < O) return 1;
                                            for(;;){
                                                for(v = k - A, _ = h[S] < y ? (w = 0, h[S]) : h[S] > y ? (w = D[F + h[S]], I[N + h[S]]) : (w = 96, 0), d = 1 << k - A, M = p = 1 << E; c[g + (j >> A) + (p -= d)] = v << 24 | w << 16 | _ | 0, 0 !== p;);
                                                for(d = 1 << k - 1; j & d;)d >>= 1;
                                                if (0 !== d ? (j &= d - 1, j += d) : j = 0, S++, 0 == --P[k]) {
                                                    if (k === C) break;
                                                    k = t[r + h[S]];
                                                }
                                                if (T < k && (j & b) !== m) {
                                                    for(0 === A && (A = T), g += M, R = 1 << (E = k - A); E + A < C && !((R -= P[E + A]) <= 0);)E++, R <<= 1;
                                                    if (O += 1 << E, 1 === e && 852 < O || 2 === e && 592 < O) return 1;
                                                    c[m = j & b] = T << 24 | E << 16 | g - u | 0;
                                                }
                                            }
                                            return 0 !== j && (c[g + j] = k - A << 24 | 4194304), f.bits = T, 0;
                                        };
                                    },
                                    {
                                        "../utils/common": 41
                                    }
                                ],
                                51: [
                                    function(e, t, r) {
                                        t.exports = {
                                            2: "need dictionary",
                                            1: "stream end",
                                            0: "",
                                            "-1": "file error",
                                            "-2": "stream error",
                                            "-3": "data error",
                                            "-4": "insufficient memory",
                                            "-5": "buffer error",
                                            "-6": "incompatible version"
                                        };
                                    },
                                    {}
                                ],
                                52: [
                                    function(e, t, r) {
                                        var n = e("../utils/common");
                                        function i(e) {
                                            for(var t = e.length; 0 <= --t;)e[t] = 0;
                                        }
                                        var s = 256, o = 286, a = 30, l = 15, c = [
                                            0,
                                            0,
                                            0,
                                            0,
                                            0,
                                            0,
                                            0,
                                            0,
                                            1,
                                            1,
                                            1,
                                            1,
                                            2,
                                            2,
                                            2,
                                            2,
                                            3,
                                            3,
                                            3,
                                            3,
                                            4,
                                            4,
                                            4,
                                            4,
                                            5,
                                            5,
                                            5,
                                            5,
                                            0
                                        ], u = [
                                            0,
                                            0,
                                            0,
                                            0,
                                            1,
                                            1,
                                            2,
                                            2,
                                            3,
                                            3,
                                            4,
                                            4,
                                            5,
                                            5,
                                            6,
                                            6,
                                            7,
                                            7,
                                            8,
                                            8,
                                            9,
                                            9,
                                            10,
                                            10,
                                            11,
                                            11,
                                            12,
                                            12,
                                            13,
                                            13
                                        ], h = [
                                            0,
                                            0,
                                            0,
                                            0,
                                            0,
                                            0,
                                            0,
                                            0,
                                            0,
                                            0,
                                            0,
                                            0,
                                            0,
                                            0,
                                            0,
                                            0,
                                            2,
                                            3,
                                            7
                                        ], f = [
                                            16,
                                            17,
                                            18,
                                            0,
                                            8,
                                            7,
                                            9,
                                            6,
                                            10,
                                            5,
                                            11,
                                            4,
                                            12,
                                            3,
                                            13,
                                            2,
                                            14,
                                            1,
                                            15
                                        ], d = new Array(576);
                                        i(d);
                                        var p = new Array(60);
                                        i(p);
                                        var m = new Array(512);
                                        i(m);
                                        var b = new Array(256);
                                        i(b);
                                        var g = new Array(29);
                                        i(g);
                                        var y, v, w, _ = new Array(a);
                                        function x(e, t, r, n, i) {
                                            this.static_tree = e, this.extra_bits = t, this.extra_base = r, this.elems = n, this.max_length = i, this.has_stree = e && e.length;
                                        }
                                        function k(e, t) {
                                            this.dyn_tree = e, this.max_code = 0, this.stat_desc = t;
                                        }
                                        function S(e) {
                                            return e < 256 ? m[e] : m[256 + (e >>> 7)];
                                        }
                                        function M(e, t) {
                                            e.pending_buf[e.pending++] = 255 & t, e.pending_buf[e.pending++] = t >>> 8 & 255;
                                        }
                                        function C(e, t, r) {
                                            e.bi_valid > 16 - r ? (e.bi_buf |= t << e.bi_valid & 65535, M(e, e.bi_buf), e.bi_buf = t >> 16 - e.bi_valid, e.bi_valid += r - 16) : (e.bi_buf |= t << e.bi_valid & 65535, e.bi_valid += r);
                                        }
                                        function T(e, t, r) {
                                            C(e, r[2 * t], r[2 * t + 1]);
                                        }
                                        function E(e, t) {
                                            for(var r = 0; r |= 1 & e, e >>>= 1, r <<= 1, 0 < --t;);
                                            return r >>> 1;
                                        }
                                        function A(e, t, r) {
                                            var n, i, s = new Array(16), o = 0;
                                            for(n = 1; n <= l; n++)s[n] = o = o + r[n - 1] << 1;
                                            for(i = 0; i <= t; i++){
                                                var a = e[2 * i + 1];
                                                0 !== a && (e[2 * i] = E(s[a]++, a));
                                            }
                                        }
                                        function R(e) {
                                            var t;
                                            for(t = 0; t < o; t++)e.dyn_ltree[2 * t] = 0;
                                            for(t = 0; t < a; t++)e.dyn_dtree[2 * t] = 0;
                                            for(t = 0; t < 19; t++)e.bl_tree[2 * t] = 0;
                                            e.dyn_ltree[512] = 1, e.opt_len = e.static_len = 0, e.last_lit = e.matches = 0;
                                        }
                                        function O(e) {
                                            8 < e.bi_valid ? M(e, e.bi_buf) : 0 < e.bi_valid && (e.pending_buf[e.pending++] = e.bi_buf), e.bi_buf = 0, e.bi_valid = 0;
                                        }
                                        function j(e, t, r, n) {
                                            var i = 2 * t, s = 2 * r;
                                            return e[i] < e[s] || e[i] === e[s] && n[t] <= n[r];
                                        }
                                        function I(e, t, r) {
                                            for(var n = e.heap[r], i = r << 1; i <= e.heap_len && (i < e.heap_len && j(t, e.heap[i + 1], e.heap[i], e.depth) && i++, !j(t, n, e.heap[i], e.depth));)e.heap[r] = e.heap[i], r = i, i <<= 1;
                                            e.heap[r] = n;
                                        }
                                        function N(e, t, r) {
                                            var n, i, o, a, l = 0;
                                            if (0 !== e.last_lit) for(; n = e.pending_buf[e.d_buf + 2 * l] << 8 | e.pending_buf[e.d_buf + 2 * l + 1], i = e.pending_buf[e.l_buf + l], l++, 0 === n ? T(e, i, t) : (T(e, (o = b[i]) + s + 1, t), 0 !== (a = c[o]) && C(e, i -= g[o], a), T(e, o = S(--n), r), 0 !== (a = u[o]) && C(e, n -= _[o], a)), l < e.last_lit;);
                                            T(e, 256, t);
                                        }
                                        function P(e, t) {
                                            var r, n, i, s = t.dyn_tree, o = t.stat_desc.static_tree, a = t.stat_desc.has_stree, c = t.stat_desc.elems, u = -1;
                                            for(e.heap_len = 0, e.heap_max = 573, r = 0; r < c; r++)0 !== s[2 * r] ? (e.heap[++e.heap_len] = u = r, e.depth[r] = 0) : s[2 * r + 1] = 0;
                                            for(; e.heap_len < 2;)s[2 * (i = e.heap[++e.heap_len] = u < 2 ? ++u : 0)] = 1, e.depth[i] = 0, e.opt_len--, a && (e.static_len -= o[2 * i + 1]);
                                            for(t.max_code = u, r = e.heap_len >> 1; 1 <= r; r--)I(e, s, r);
                                            for(i = c; r = e.heap[1], e.heap[1] = e.heap[e.heap_len--], I(e, s, 1), n = e.heap[1], e.heap[--e.heap_max] = r, e.heap[--e.heap_max] = n, s[2 * i] = s[2 * r] + s[2 * n], e.depth[i] = (e.depth[r] >= e.depth[n] ? e.depth[r] : e.depth[n]) + 1, s[2 * r + 1] = s[2 * n + 1] = i, e.heap[1] = i++, I(e, s, 1), 2 <= e.heap_len;);
                                            e.heap[--e.heap_max] = e.heap[1], function(e, t) {
                                                var r, n, i, s, o, a, c = t.dyn_tree, u = t.max_code, h = t.stat_desc.static_tree, f = t.stat_desc.has_stree, d = t.stat_desc.extra_bits, p = t.stat_desc.extra_base, m = t.stat_desc.max_length, b = 0;
                                                for(s = 0; s <= l; s++)e.bl_count[s] = 0;
                                                for(c[2 * e.heap[e.heap_max] + 1] = 0, r = e.heap_max + 1; r < 573; r++)m < (s = c[2 * c[2 * (n = e.heap[r]) + 1] + 1] + 1) && (s = m, b++), c[2 * n + 1] = s, u < n || (e.bl_count[s]++, o = 0, p <= n && (o = d[n - p]), a = c[2 * n], e.opt_len += a * (s + o), f && (e.static_len += a * (h[2 * n + 1] + o)));
                                                if (0 !== b) {
                                                    do {
                                                        for(s = m - 1; 0 === e.bl_count[s];)s--;
                                                        e.bl_count[s]--, e.bl_count[s + 1] += 2, e.bl_count[m]--, b -= 2;
                                                    }while (0 < b);
                                                    for(s = m; 0 !== s; s--)for(n = e.bl_count[s]; 0 !== n;)u < (i = e.heap[--r]) || (c[2 * i + 1] !== s && (e.opt_len += (s - c[2 * i + 1]) * c[2 * i], c[2 * i + 1] = s), n--);
                                                }
                                            }(e, t), A(s, u, e.bl_count);
                                        }
                                        function B(e, t, r) {
                                            var n, i, s = -1, o = t[1], a = 0, l = 7, c = 4;
                                            for(0 === o && (l = 138, c = 3), t[2 * (r + 1) + 1] = 65535, n = 0; n <= r; n++)i = o, o = t[2 * (n + 1) + 1], ++a < l && i === o || (a < c ? e.bl_tree[2 * i] += a : 0 !== i ? (i !== s && e.bl_tree[2 * i]++, e.bl_tree[32]++) : a <= 10 ? e.bl_tree[34]++ : e.bl_tree[36]++, s = i, c = (a = 0) === o ? (l = 138, 3) : i === o ? (l = 6, 3) : (l = 7, 4));
                                        }
                                        function D(e, t, r) {
                                            var n, i, s = -1, o = t[1], a = 0, l = 7, c = 4;
                                            for(0 === o && (l = 138, c = 3), n = 0; n <= r; n++)if (i = o, o = t[2 * (n + 1) + 1], !(++a < l && i === o)) {
                                                if (a < c) for(; T(e, i, e.bl_tree), 0 != --a;);
                                                else 0 !== i ? (i !== s && (T(e, i, e.bl_tree), a--), T(e, 16, e.bl_tree), C(e, a - 3, 2)) : a <= 10 ? (T(e, 17, e.bl_tree), C(e, a - 3, 3)) : (T(e, 18, e.bl_tree), C(e, a - 11, 7));
                                                s = i, c = (a = 0) === o ? (l = 138, 3) : i === o ? (l = 6, 3) : (l = 7, 4);
                                            }
                                        }
                                        i(_);
                                        var F = !1;
                                        function L(e, t, r, i) {
                                            C(e, 0 + (i ? 1 : 0), 3), function(e, t, r, i) {
                                                O(e), M(e, r), M(e, ~r), n.arraySet(e.pending_buf, e.window, t, r, e.pending), e.pending += r;
                                            }(e, t, r);
                                        }
                                        r._tr_init = function(e) {
                                            F || (function() {
                                                var e, t, r, n, i, s = new Array(16);
                                                for(n = r = 0; n < 28; n++)for(g[n] = r, e = 0; e < 1 << c[n]; e++)b[r++] = n;
                                                for(b[r - 1] = n, n = i = 0; n < 16; n++)for(_[n] = i, e = 0; e < 1 << u[n]; e++)m[i++] = n;
                                                for(i >>= 7; n < a; n++)for(_[n] = i << 7, e = 0; e < 1 << u[n] - 7; e++)m[256 + i++] = n;
                                                for(t = 0; t <= l; t++)s[t] = 0;
                                                for(e = 0; e <= 143;)d[2 * e + 1] = 8, e++, s[8]++;
                                                for(; e <= 255;)d[2 * e + 1] = 9, e++, s[9]++;
                                                for(; e <= 279;)d[2 * e + 1] = 7, e++, s[7]++;
                                                for(; e <= 287;)d[2 * e + 1] = 8, e++, s[8]++;
                                                for(A(d, 287, s), e = 0; e < a; e++)p[2 * e + 1] = 5, p[2 * e] = E(e, 5);
                                                y = new x(d, c, 257, o, l), v = new x(p, u, 0, a, l), w = new x(new Array(0), h, 0, 19, 7);
                                            }(), F = !0), e.l_desc = new k(e.dyn_ltree, y), e.d_desc = new k(e.dyn_dtree, v), e.bl_desc = new k(e.bl_tree, w), e.bi_buf = 0, e.bi_valid = 0, R(e);
                                        }, r._tr_stored_block = L, r._tr_flush_block = function(e, t, r, n) {
                                            var i, o, a = 0;
                                            0 < e.level ? (2 === e.strm.data_type && (e.strm.data_type = function(e) {
                                                var t, r = 4093624447;
                                                for(t = 0; t <= 31; t++, r >>>= 1)if (1 & r && 0 !== e.dyn_ltree[2 * t]) return 0;
                                                if (0 !== e.dyn_ltree[18] || 0 !== e.dyn_ltree[20] || 0 !== e.dyn_ltree[26]) return 1;
                                                for(t = 32; t < s; t++)if (0 !== e.dyn_ltree[2 * t]) return 1;
                                                return 0;
                                            }(e)), P(e, e.l_desc), P(e, e.d_desc), a = function(e) {
                                                var t;
                                                for(B(e, e.dyn_ltree, e.l_desc.max_code), B(e, e.dyn_dtree, e.d_desc.max_code), P(e, e.bl_desc), t = 18; 3 <= t && 0 === e.bl_tree[2 * f[t] + 1]; t--);
                                                return e.opt_len += 3 * (t + 1) + 5 + 5 + 4, t;
                                            }(e), i = e.opt_len + 3 + 7 >>> 3, (o = e.static_len + 3 + 7 >>> 3) <= i && (i = o)) : i = o = r + 5, r + 4 <= i && -1 !== t ? L(e, t, r, n) : 4 === e.strategy || o === i ? (C(e, 2 + (n ? 1 : 0), 3), N(e, d, p)) : (C(e, 4 + (n ? 1 : 0), 3), function(e, t, r, n) {
                                                var i;
                                                for(C(e, t - 257, 5), C(e, r - 1, 5), C(e, n - 4, 4), i = 0; i < n; i++)C(e, e.bl_tree[2 * f[i] + 1], 3);
                                                D(e, e.dyn_ltree, t - 1), D(e, e.dyn_dtree, r - 1);
                                            }(e, e.l_desc.max_code + 1, e.d_desc.max_code + 1, a + 1), N(e, e.dyn_ltree, e.dyn_dtree)), R(e), n && O(e);
                                        }, r._tr_tally = function(e, t, r) {
                                            return e.pending_buf[e.d_buf + 2 * e.last_lit] = t >>> 8 & 255, e.pending_buf[e.d_buf + 2 * e.last_lit + 1] = 255 & t, e.pending_buf[e.l_buf + e.last_lit] = 255 & r, e.last_lit++, 0 === t ? e.dyn_ltree[2 * r]++ : (e.matches++, t--, e.dyn_ltree[2 * (b[r] + s + 1)]++, e.dyn_dtree[2 * S(t)]++), e.last_lit === e.lit_bufsize - 1;
                                        }, r._tr_align = function(e) {
                                            C(e, 2, 3), T(e, 256, d), function(e) {
                                                16 === e.bi_valid ? (M(e, e.bi_buf), e.bi_buf = 0, e.bi_valid = 0) : 8 <= e.bi_valid && (e.pending_buf[e.pending++] = 255 & e.bi_buf, e.bi_buf >>= 8, e.bi_valid -= 8);
                                            }(e);
                                        };
                                    },
                                    {
                                        "../utils/common": 41
                                    }
                                ],
                                53: [
                                    function(e, t, r) {
                                        t.exports = function() {
                                            this.input = null, this.next_in = 0, this.avail_in = 0, this.total_in = 0, this.output = null, this.next_out = 0, this.avail_out = 0, this.total_out = 0, this.msg = "", this.state = null, this.data_type = 2, this.adler = 0;
                                        };
                                    },
                                    {}
                                ],
                                54: [
                                    function(e, t, r) {
                                        (function(e) {
                                            !function(e, t) {
                                                if (!e.setImmediate) {
                                                    var r, i, s, o, a = 1, l = {}, c = !1, u = e.document, h = Object.getPrototypeOf && Object.getPrototypeOf(e);
                                                    h = h && h.setTimeout ? h : e, r = "[object process]" === ({}).toString.call(e.process) ? function(e) {
                                                        n.nextTick(function() {
                                                            d(e);
                                                        });
                                                    } : function() {
                                                        if (e.postMessage && !e.importScripts) {
                                                            var t = !0, r = e.onmessage;
                                                            return e.onmessage = function() {
                                                                t = !1;
                                                            }, e.postMessage("", "*"), e.onmessage = r, t;
                                                        }
                                                    }() ? (o = "setImmediate$" + Math.random() + "$", e.addEventListener ? e.addEventListener("message", p, !1) : e.attachEvent("onmessage", p), function(t) {
                                                        e.postMessage(o + t, "*");
                                                    }) : e.MessageChannel ? ((s = new MessageChannel).port1.onmessage = function(e) {
                                                        d(e.data);
                                                    }, function(e) {
                                                        s.port2.postMessage(e);
                                                    }) : u && "onreadystatechange" in u.createElement("script") ? (i = u.documentElement, function(e) {
                                                        var t = u.createElement("script");
                                                        t.onreadystatechange = function() {
                                                            d(e), t.onreadystatechange = null, i.removeChild(t), t = null;
                                                        }, i.appendChild(t);
                                                    }) : function(e) {
                                                        setTimeout(d, 0, e);
                                                    }, h.setImmediate = function(e) {
                                                        "function" != typeof e && (e = new Function("" + e));
                                                        for(var t = new Array(arguments.length - 1), n = 0; n < t.length; n++)t[n] = arguments[n + 1];
                                                        var i = {
                                                            callback: e,
                                                            args: t
                                                        };
                                                        return l[a] = i, r(a), a++;
                                                    }, h.clearImmediate = f;
                                                }
                                                function f(e) {
                                                    delete l[e];
                                                }
                                                function d(e) {
                                                    if (c) setTimeout(d, 0, e);
                                                    else {
                                                        var t = l[e];
                                                        if (t) {
                                                            c = !0;
                                                            try {
                                                                !function(e) {
                                                                    var t = e.callback, r = e.args;
                                                                    switch(r.length){
                                                                        case 0:
                                                                            t();
                                                                            break;
                                                                        case 1:
                                                                            t(r[0]);
                                                                            break;
                                                                        case 2:
                                                                            t(r[0], r[1]);
                                                                            break;
                                                                        case 3:
                                                                            t(r[0], r[1], r[2]);
                                                                            break;
                                                                        default:
                                                                            t.apply(void 0, r);
                                                                    }
                                                                }(t);
                                                            } finally{
                                                                f(e), c = !1;
                                                            }
                                                        }
                                                    }
                                                }
                                                function p(t) {
                                                    t.source === e && "string" == typeof t.data && 0 === t.data.indexOf(o) && d(+t.data.slice(o.length));
                                                }
                                            }("undefined" == typeof self ? void 0 === e ? this : e : self);
                                        }).call(this, void 0 !== i ? i : "undefined" != typeof self ? self : "undefined" != typeof window ? window : {});
                                    },
                                    {}
                                ]
                            }, {}, [
                                10
                            ])(10);
                        });
                    }).call(this);
                }).call(this, e("_process"), "undefined" != typeof $parcel$global ? $parcel$global : "undefined" != typeof self ? self : "undefined" != typeof window ? window : {}, e("buffer").Buffer, arguments[3], arguments[4], arguments[5], arguments[6], e("timers").setImmediate);
            },
            {
                _process: 467,
                buffer: 220,
                timers: 523
            }
        ],
        442: [
            function(e, t, r) {
                (function(e) {
                    (function() {
                        "use strict";
                        var r = /[\\^$.*+?()[\]{}|]/g, n = RegExp(r.source), i = "object" == typeof e && e && e.Object === Object && e, s = "object" == typeof self && self && self.Object === Object && self, o = i || s || Function("return this")(), a = Object.prototype.toString, l = o.Symbol, c = l ? l.prototype : void 0, u = c ? c.toString : void 0;
                        function h(e) {
                            if ("string" == typeof e) return e;
                            if (function(e) {
                                return "symbol" == typeof e || function(e) {
                                    return !!e && "object" == typeof e;
                                }(e) && "[object Symbol]" == a.call(e);
                            }(e)) return u ? u.call(e) : "";
                            var t = e + "";
                            return "0" == t && 1 / e == -1 / 0 ? "-0" : t;
                        }
                        t.exports = function(e) {
                            var t;
                            return (e = null == (t = e) ? "" : h(t)) && n.test(e) ? e.replace(r, "\\$&") : e;
                        };
                    }).call(this);
                }).call(this, "undefined" != typeof $parcel$global ? $parcel$global : "undefined" != typeof self ? self : "undefined" != typeof window ? window : {});
            },
            {}
        ],
        443: [
            function(e, t, r) {
                (function(e) {
                    (function() {
                        "use strict";
                        var n = "[object Arguments]", i = "[object Map]", s = "[object Object]", o = "[object Set]", a = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, l = /^\w*$/, c = /^\./, u = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, h = /\\(\\)?/g, f = /^\[object .+?Constructor\]$/, d = /^(?:0|[1-9]\d*)$/, p = {};
                        p["[object Float32Array]"] = p["[object Float64Array]"] = p["[object Int8Array]"] = p["[object Int16Array]"] = p["[object Int32Array]"] = p["[object Uint8Array]"] = p["[object Uint8ClampedArray]"] = p["[object Uint16Array]"] = p["[object Uint32Array]"] = !0, p[n] = p["[object Array]"] = p["[object ArrayBuffer]"] = p["[object Boolean]"] = p["[object DataView]"] = p["[object Date]"] = p["[object Error]"] = p["[object Function]"] = p[i] = p["[object Number]"] = p[s] = p["[object RegExp]"] = p[o] = p["[object String]"] = p["[object WeakMap]"] = !1;
                        var m = "object" == typeof e && e && e.Object === Object && e, b = "object" == typeof self && self && self.Object === Object && self, g = m || b || Function("return this")(), y = "object" == typeof r && r && !r.nodeType && r, v = y && "object" == typeof t && t && !t.nodeType && t, w = v && v.exports === y && m.process, _ = function() {
                            try {
                                return w && w.binding("util");
                            } catch (e) {}
                        }(), x = _ && _.isTypedArray;
                        function k(e, t, r, n) {
                            for(var i = -1, s = e ? e.length : 0; ++i < s;){
                                var o = e[i];
                                t(n, o, r(o), e);
                            }
                            return n;
                        }
                        function S(e, t) {
                            for(var r = -1, n = e ? e.length : 0; ++r < n;)if (t(e[r], r, e)) return !0;
                            return !1;
                        }
                        function M(e) {
                            var t = !1;
                            if (null != e && "function" != typeof e.toString) try {
                                t = !!(e + "");
                            } catch (e) {}
                            return t;
                        }
                        function C(e) {
                            var t = -1, r = Array(e.size);
                            return e.forEach(function(e, n) {
                                r[++t] = [
                                    n,
                                    e
                                ];
                            }), r;
                        }
                        function T(e) {
                            var t = -1, r = Array(e.size);
                            return e.forEach(function(e) {
                                r[++t] = e;
                            }), r;
                        }
                        var E, A, R, O = Array.prototype, j = Function.prototype, I = Object.prototype, N = g["__core-js_shared__"], P = (E = /[^.]+$/.exec(N && N.keys && N.keys.IE_PROTO || "")) ? "Symbol(src)_1." + E : "", B = j.toString, D = I.hasOwnProperty, F = I.toString, L = RegExp("^" + B.call(D).replace(/[\\^$.*+?()[\]{}|]/g, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"), z = g.Symbol, U = g.Uint8Array, $ = I.propertyIsEnumerable, H = O.splice, V = (A = Object.keys, R = Object, function(e) {
                            return A(R(e));
                        }), q = Ce(g, "DataView"), W = Ce(g, "Map"), X = Ce(g, "Promise"), K = Ce(g, "Set"), Y = Ce(g, "WeakMap"), Z = Ce(Object, "create"), G = Ne(q), J = Ne(W), Q = Ne(X), ee = Ne(K), te = Ne(Y), re = z ? z.prototype : void 0, ne = re ? re.valueOf : void 0, ie = re ? re.toString : void 0;
                        function se(e) {
                            var t = -1, r = e ? e.length : 0;
                            for(this.clear(); ++t < r;){
                                var n = e[t];
                                this.set(n[0], n[1]);
                            }
                        }
                        function oe(e) {
                            var t = -1, r = e ? e.length : 0;
                            for(this.clear(); ++t < r;){
                                var n = e[t];
                                this.set(n[0], n[1]);
                            }
                        }
                        function ae(e) {
                            var t = -1, r = e ? e.length : 0;
                            for(this.clear(); ++t < r;){
                                var n = e[t];
                                this.set(n[0], n[1]);
                            }
                        }
                        function le(e) {
                            var t = -1, r = e ? e.length : 0;
                            for(this.__data__ = new ae; ++t < r;)this.add(e[t]);
                        }
                        function ce(e) {
                            this.__data__ = new oe(e);
                        }
                        function ue(e, t) {
                            var r = Ue(e) || ze(e) ? function(e, t) {
                                for(var r = -1, n = Array(e); ++r < e;)n[r] = t(r);
                                return n;
                            }(e.length, String) : [], n = r.length, i = !!n;
                            for(var s in e)!t && !D.call(e, s) || i && ("length" == s || Ee(s, n)) || r.push(s);
                            return r;
                        }
                        function he(e, t) {
                            for(var r = e.length; r--;)if (Le(e[r][0], t)) return r;
                            return -1;
                        }
                        function fe(e, t, r, n) {
                            return me(e, function(e, i, s) {
                                t(n, e, r(e), s);
                            }), n;
                        }
                        se.prototype.clear = function() {
                            this.__data__ = Z ? Z(null) : {};
                        }, se.prototype.delete = function(e) {
                            return this.has(e) && delete this.__data__[e];
                        }, se.prototype.get = function(e) {
                            var t = this.__data__;
                            if (Z) {
                                var r = t[e];
                                return "__lodash_hash_undefined__" === r ? void 0 : r;
                            }
                            return D.call(t, e) ? t[e] : void 0;
                        }, se.prototype.has = function(e) {
                            var t = this.__data__;
                            return Z ? void 0 !== t[e] : D.call(t, e);
                        }, se.prototype.set = function(e, t) {
                            return this.__data__[e] = Z && void 0 === t ? "__lodash_hash_undefined__" : t, this;
                        }, oe.prototype.clear = function() {
                            this.__data__ = [];
                        }, oe.prototype.delete = function(e) {
                            var t = this.__data__, r = he(t, e);
                            return !(r < 0) && (r == t.length - 1 ? t.pop() : H.call(t, r, 1), !0);
                        }, oe.prototype.get = function(e) {
                            var t = this.__data__, r = he(t, e);
                            return r < 0 ? void 0 : t[r][1];
                        }, oe.prototype.has = function(e) {
                            return he(this.__data__, e) > -1;
                        }, oe.prototype.set = function(e, t) {
                            var r = this.__data__, n = he(r, e);
                            return n < 0 ? r.push([
                                e,
                                t
                            ]) : r[n][1] = t, this;
                        }, ae.prototype.clear = function() {
                            this.__data__ = {
                                hash: new se,
                                map: new (W || oe),
                                string: new se
                            };
                        }, ae.prototype.delete = function(e) {
                            return Me(this, e).delete(e);
                        }, ae.prototype.get = function(e) {
                            return Me(this, e).get(e);
                        }, ae.prototype.has = function(e) {
                            return Me(this, e).has(e);
                        }, ae.prototype.set = function(e, t) {
                            return Me(this, e).set(e, t), this;
                        }, le.prototype.add = le.prototype.push = function(e) {
                            return this.__data__.set(e, "__lodash_hash_undefined__"), this;
                        }, le.prototype.has = function(e) {
                            return this.__data__.has(e);
                        }, ce.prototype.clear = function() {
                            this.__data__ = new oe;
                        }, ce.prototype.delete = function(e) {
                            return this.__data__.delete(e);
                        }, ce.prototype.get = function(e) {
                            return this.__data__.get(e);
                        }, ce.prototype.has = function(e) {
                            return this.__data__.has(e);
                        }, ce.prototype.set = function(e, t) {
                            var r = this.__data__;
                            if (r instanceof oe) {
                                var n = r.__data__;
                                if (!W || n.length < 199) return n.push([
                                    e,
                                    t
                                ]), this;
                                r = this.__data__ = new ae(n);
                            }
                            return r.set(e, t), this;
                        };
                        var de, pe, me = (de = function(e, t) {
                            return e && be(e, t, Ye);
                        }, function(e, t) {
                            if (null == e) return e;
                            if (!$e(e)) return de(e, t);
                            for(var r = e.length, n = pe ? r : -1, i = Object(e); (pe ? n-- : ++n < r) && !1 !== t(i[n], n, i););
                            return e;
                        }), be = function(e) {
                            return function(t, r, n) {
                                for(var i = -1, s = Object(t), o = n(t), a = o.length; a--;){
                                    var l = o[e ? a : ++i];
                                    if (!1 === r(s[l], l, s)) break;
                                }
                                return t;
                            };
                        }();
                        function ge(e, t) {
                            for(var r = 0, n = (t = Ae(t, e) ? [
                                t
                            ] : ke(t)).length; null != e && r < n;)e = e[Ie(t[r++])];
                            return r && r == n ? e : void 0;
                        }
                        function ye(e, t) {
                            return null != e && t in Object(e);
                        }
                        function ve(e, t, r, a, l) {
                            return e === t || (null == e || null == t || !qe(e) && !We(t) ? e != e && t != t : function(e, t, r, a, l, c) {
                                var u = Ue(e), h = Ue(t), f = "[object Array]", d = "[object Array]";
                                u || (f = (f = Te(e)) == n ? s : f);
                                h || (d = (d = Te(t)) == n ? s : d);
                                var p = f == s && !M(e), m = d == s && !M(t), b = f == d;
                                if (b && !p) return c || (c = new ce), u || Ke(e) ? Se(e, t, r, a, l, c) : function(e, t, r, n, s, a, l) {
                                    switch(r){
                                        case "[object DataView]":
                                            if (e.byteLength != t.byteLength || e.byteOffset != t.byteOffset) return !1;
                                            e = e.buffer, t = t.buffer;
                                        case "[object ArrayBuffer]":
                                            return !(e.byteLength != t.byteLength || !n(new U(e), new U(t)));
                                        case "[object Boolean]":
                                        case "[object Date]":
                                        case "[object Number]":
                                            return Le(+e, +t);
                                        case "[object Error]":
                                            return e.name == t.name && e.message == t.message;
                                        case "[object RegExp]":
                                        case "[object String]":
                                            return e == t + "";
                                        case i:
                                            var c = C;
                                        case o:
                                            var u = 2 & a;
                                            if (c || (c = T), e.size != t.size && !u) return !1;
                                            var h = l.get(e);
                                            if (h) return h == t;
                                            a |= 1, l.set(e, t);
                                            var f = Se(c(e), c(t), n, s, a, l);
                                            return l.delete(e), f;
                                        case "[object Symbol]":
                                            if (ne) return ne.call(e) == ne.call(t);
                                    }
                                    return !1;
                                }(e, t, f, r, a, l, c);
                                if (!(2 & l)) {
                                    var g = p && D.call(e, "__wrapped__"), y = m && D.call(t, "__wrapped__");
                                    if (g || y) {
                                        var v = g ? e.value() : e, w = y ? t.value() : t;
                                        return c || (c = new ce), r(v, w, a, l, c);
                                    }
                                }
                                if (!b) return !1;
                                return c || (c = new ce), function(e, t, r, n, i, s) {
                                    var o = 2 & i, a = Ye(e), l = a.length, c = Ye(t).length;
                                    if (l != c && !o) return !1;
                                    var u = l;
                                    for(; u--;){
                                        var h = a[u];
                                        if (!(o ? h in t : D.call(t, h))) return !1;
                                    }
                                    var f = s.get(e);
                                    if (f && s.get(t)) return f == t;
                                    var d = !0;
                                    s.set(e, t), s.set(t, e);
                                    var p = o;
                                    for(; ++u < l;){
                                        h = a[u];
                                        var m = e[h], b = t[h];
                                        if (n) var g = o ? n(b, m, h, t, e, s) : n(m, b, h, e, t, s);
                                        if (!(void 0 === g ? m === b || r(m, b, n, i, s) : g)) {
                                            d = !1;
                                            break;
                                        }
                                        p || (p = "constructor" == h);
                                    }
                                    if (d && !p) {
                                        var y = e.constructor, v = t.constructor;
                                        y == v || !("constructor" in e) || !("constructor" in t) || "function" == typeof y && y instanceof y && "function" == typeof v && v instanceof v || (d = !1);
                                    }
                                    return s.delete(e), s.delete(t), d;
                                }(e, t, r, a, l, c);
                            }(e, t, ve, r, a, l));
                        }
                        function we(e) {
                            return !(!qe(e) || function(e) {
                                return !!P && P in e;
                            }(e)) && (He(e) || M(e) ? L : f).test(Ne(e));
                        }
                        function _e(e) {
                            var t, r;
                            return "function" == typeof e ? e : null == e ? Ze : "object" == typeof e ? Ue(e) ? function(e, t) {
                                if (Ae(e) && Re(t)) return Oe(Ie(e), t);
                                return function(r) {
                                    var n = function(e, t, r) {
                                        var n = null == e ? void 0 : ge(e, t);
                                        return void 0 === n ? r : n;
                                    }(r, e);
                                    return void 0 === n && n === t ? function(e, t) {
                                        return null != e && function(e, t, r) {
                                            t = Ae(t, e) ? [
                                                t
                                            ] : ke(t);
                                            var n, i = -1, s = t.length;
                                            for(; ++i < s;){
                                                var o = Ie(t[i]);
                                                if (!(n = null != e && r(e, o))) break;
                                                e = e[o];
                                            }
                                            if (n) return n;
                                            return !!(s = e ? e.length : 0) && Ve(s) && Ee(o, s) && (Ue(e) || ze(e));
                                        }(e, t, ye);
                                    }(r, e) : ve(t, n, void 0, 3);
                                };
                            }(e[0], e[1]) : function(e) {
                                var t = function(e) {
                                    var t = Ye(e), r = t.length;
                                    for(; r--;){
                                        var n = t[r], i = e[n];
                                        t[r] = [
                                            n,
                                            i,
                                            Re(i)
                                        ];
                                    }
                                    return t;
                                }(e);
                                if (1 == t.length && t[0][2]) return Oe(t[0][0], t[0][1]);
                                return function(r) {
                                    return r === e || function(e, t, r, n) {
                                        var i = r.length, s = i, o = !n;
                                        if (null == e) return !s;
                                        for(e = Object(e); i--;){
                                            var a = r[i];
                                            if (o && a[2] ? a[1] !== e[a[0]] : !(a[0] in e)) return !1;
                                        }
                                        for(; ++i < s;){
                                            var l = (a = r[i])[0], c = e[l], u = a[1];
                                            if (o && a[2]) {
                                                if (void 0 === c && !(l in e)) return !1;
                                            } else {
                                                var h = new ce;
                                                if (n) var f = n(c, u, l, e, t, h);
                                                if (!(void 0 === f ? ve(u, c, n, 3, h) : f)) return !1;
                                            }
                                        }
                                        return !0;
                                    }(r, e, t);
                                };
                            }(e) : Ae(t = e) ? (r = Ie(t), function(e) {
                                return null == e ? void 0 : e[r];
                            }) : function(e) {
                                return function(t) {
                                    return ge(t, e);
                                };
                            }(t);
                        }
                        function xe(e) {
                            if (r = (t = e) && t.constructor, n = "function" == typeof r && r.prototype || I, t !== n) return V(e);
                            var t, r, n, i = [];
                            for(var s in Object(e))D.call(e, s) && "constructor" != s && i.push(s);
                            return i;
                        }
                        function ke(e) {
                            return Ue(e) ? e : je(e);
                        }
                        function Se(e, t, r, n, i, s) {
                            var o = 2 & i, a = e.length, l = t.length;
                            if (a != l && !(o && l > a)) return !1;
                            var c = s.get(e);
                            if (c && s.get(t)) return c == t;
                            var u = -1, h = !0, f = 1 & i ? new le : void 0;
                            for(s.set(e, t), s.set(t, e); ++u < a;){
                                var d = e[u], p = t[u];
                                if (n) var m = o ? n(p, d, u, t, e, s) : n(d, p, u, e, t, s);
                                if (void 0 !== m) {
                                    if (m) continue;
                                    h = !1;
                                    break;
                                }
                                if (f) {
                                    if (!S(t, function(e, t) {
                                        if (!f.has(t) && (d === e || r(d, e, n, i, s))) return f.add(t);
                                    })) {
                                        h = !1;
                                        break;
                                    }
                                } else if (d !== p && !r(d, p, n, i, s)) {
                                    h = !1;
                                    break;
                                }
                            }
                            return s.delete(e), s.delete(t), h;
                        }
                        function Me(e, t) {
                            var r, n, i = e.__data__;
                            return ("string" == (n = typeof (r = t)) || "number" == n || "symbol" == n || "boolean" == n ? "__proto__" !== r : null === r) ? i["string" == typeof t ? "string" : "hash"] : i.map;
                        }
                        function Ce(e, t) {
                            var r = function(e, t) {
                                return null == e ? void 0 : e[t];
                            }(e, t);
                            return we(r) ? r : void 0;
                        }
                        var Te = function(e) {
                            return F.call(e);
                        };
                        function Ee(e, t) {
                            return !!(t = null == t ? 9007199254740991 : t) && ("number" == typeof e || d.test(e)) && e > -1 && e % 1 == 0 && e < t;
                        }
                        function Ae(e, t) {
                            if (Ue(e)) return !1;
                            var r = typeof e;
                            return !("number" != r && "symbol" != r && "boolean" != r && null != e && !Xe(e)) || l.test(e) || !a.test(e) || null != t && e in Object(t);
                        }
                        function Re(e) {
                            return e == e && !qe(e);
                        }
                        function Oe(e, t) {
                            return function(r) {
                                return null != r && r[e] === t && (void 0 !== t || e in Object(r));
                            };
                        }
                        (q && "[object DataView]" != Te(new q(new ArrayBuffer(1))) || W && Te(new W) != i || X && "[object Promise]" != Te(X.resolve()) || K && Te(new K) != o || Y && "[object WeakMap]" != Te(new Y)) && (Te = function(e) {
                            var t = F.call(e), r = t == s ? e.constructor : void 0, n = r ? Ne(r) : void 0;
                            if (n) switch(n){
                                case G:
                                    return "[object DataView]";
                                case J:
                                    return i;
                                case Q:
                                    return "[object Promise]";
                                case ee:
                                    return o;
                                case te:
                                    return "[object WeakMap]";
                            }
                            return t;
                        });
                        var je = Fe(function(e) {
                            var t;
                            e = null == (t = e) ? "" : function(e) {
                                if ("string" == typeof e) return e;
                                if (Xe(e)) return ie ? ie.call(e) : "";
                                var t = e + "";
                                return "0" == t && 1 / e == -1 / 0 ? "-0" : t;
                            }(t);
                            var r = [];
                            return c.test(e) && r.push(""), e.replace(u, function(e, t, n, i) {
                                r.push(n ? i.replace(h, "$1") : t || e);
                            }), r;
                        });
                        function Ie(e) {
                            if ("string" == typeof e || Xe(e)) return e;
                            var t = e + "";
                            return "0" == t && 1 / e == -1 / 0 ? "-0" : t;
                        }
                        function Ne(e) {
                            if (null != e) {
                                try {
                                    return B.call(e);
                                } catch (e) {}
                                try {
                                    return e + "";
                                } catch (e) {}
                            }
                            return "";
                        }
                        var Pe, Be, De = (Pe = function(e, t, r) {
                            D.call(e, r) ? e[r].push(t) : e[r] = [
                                t
                            ];
                        }, function(e, t) {
                            var r = Ue(e) ? k : fe, n = Be ? Be() : {};
                            return r(e, Pe, _e(t), n);
                        });
                        function Fe(e, t) {
                            if ("function" != typeof e || t && "function" != typeof t) throw new TypeError("Expected a function");
                            var r = function() {
                                var n = arguments, i = t ? t.apply(this, n) : n[0], s = r.cache;
                                if (s.has(i)) return s.get(i);
                                var o = e.apply(this, n);
                                return r.cache = s.set(i, o), o;
                            };
                            return r.cache = new (Fe.Cache || ae), r;
                        }
                        function Le(e, t) {
                            return e === t || e != e && t != t;
                        }
                        function ze(e) {
                            return function(e) {
                                return We(e) && $e(e);
                            }(e) && D.call(e, "callee") && (!$.call(e, "callee") || F.call(e) == n);
                        }
                        Fe.Cache = ae;
                        var Ue = Array.isArray;
                        function $e(e) {
                            return null != e && Ve(e.length) && !He(e);
                        }
                        function He(e) {
                            var t = qe(e) ? F.call(e) : "";
                            return "[object Function]" == t || "[object GeneratorFunction]" == t;
                        }
                        function Ve(e) {
                            return "number" == typeof e && e > -1 && e % 1 == 0 && e <= 9007199254740991;
                        }
                        function qe(e) {
                            var t = typeof e;
                            return !!e && ("object" == t || "function" == t);
                        }
                        function We(e) {
                            return !!e && "object" == typeof e;
                        }
                        function Xe(e) {
                            return "symbol" == typeof e || We(e) && "[object Symbol]" == F.call(e);
                        }
                        var Ke = x ? function(e) {
                            return function(t) {
                                return e(t);
                            };
                        }(x) : function(e) {
                            return We(e) && Ve(e.length) && !!p[F.call(e)];
                        };
                        function Ye(e) {
                            return $e(e) ? ue(e) : xe(e);
                        }
                        function Ze(e) {
                            return e;
                        }
                        t.exports = De;
                    }).call(this);
                }).call(this, "undefined" != typeof $parcel$global ? $parcel$global : "undefined" != typeof self ? self : "undefined" != typeof window ? window : {});
            },
            {}
        ],
        444: [
            function(e, t, r) {
                "use strict";
                var n = Object.prototype.toString;
                t.exports = function(e) {
                    return !0 === e || !1 === e || function(e) {
                        return !!e && "object" == typeof e;
                    }(e) && "[object Boolean]" == n.call(e);
                };
            },
            {}
        ],
        445: [
            function(e, t, r) {
                (function(e) {
                    (function() {
                        "use strict";
                        var n = "[object Arguments]", i = "[object Map]", s = "[object Object]", o = "[object Set]", a = /^\[object .+?Constructor\]$/, l = /^(?:0|[1-9]\d*)$/, c = {};
                        c["[object Float32Array]"] = c["[object Float64Array]"] = c["[object Int8Array]"] = c["[object Int16Array]"] = c["[object Int32Array]"] = c["[object Uint8Array]"] = c["[object Uint8ClampedArray]"] = c["[object Uint16Array]"] = c["[object Uint32Array]"] = !0, c[n] = c["[object Array]"] = c["[object ArrayBuffer]"] = c["[object Boolean]"] = c["[object DataView]"] = c["[object Date]"] = c["[object Error]"] = c["[object Function]"] = c[i] = c["[object Number]"] = c[s] = c["[object RegExp]"] = c[o] = c["[object String]"] = c["[object WeakMap]"] = !1;
                        var u = "object" == typeof e && e && e.Object === Object && e, h = "object" == typeof self && self && self.Object === Object && self, f = u || h || Function("return this")(), d = "object" == typeof r && r && !r.nodeType && r, p = d && "object" == typeof t && t && !t.nodeType && t, m = p && p.exports === d, b = m && u.process, g = function() {
                            try {
                                return b && b.binding && b.binding("util");
                            } catch (e) {}
                        }(), y = g && g.isTypedArray;
                        function v(e, t) {
                            for(var r = -1, n = null == e ? 0 : e.length; ++r < n;)if (t(e[r], r, e)) return !0;
                            return !1;
                        }
                        function w(e) {
                            var t = -1, r = Array(e.size);
                            return e.forEach(function(e, n) {
                                r[++t] = [
                                    n,
                                    e
                                ];
                            }), r;
                        }
                        function _(e) {
                            var t = -1, r = Array(e.size);
                            return e.forEach(function(e) {
                                r[++t] = e;
                            }), r;
                        }
                        var x, k, S, M = Array.prototype, C = Function.prototype, T = Object.prototype, E = f["__core-js_shared__"], A = C.toString, R = T.hasOwnProperty, O = (x = /[^.]+$/.exec(E && E.keys && E.keys.IE_PROTO || "")) ? "Symbol(src)_1." + x : "", j = T.toString, I = RegExp("^" + A.call(R).replace(/[\\^$.*+?()[\]{}|]/g, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"), N = m ? f.Buffer : void 0, P = f.Symbol, B = f.Uint8Array, D = T.propertyIsEnumerable, F = M.splice, L = P ? P.toStringTag : void 0, z = Object.getOwnPropertySymbols, U = N ? N.isBuffer : void 0, $ = (k = Object.keys, S = Object, function(e) {
                            return k(S(e));
                        }), H = ge(f, "DataView"), V = ge(f, "Map"), q = ge(f, "Promise"), W = ge(f, "Set"), X = ge(f, "WeakMap"), K = ge(Object, "create"), Y = _e(H), Z = _e(V), G = _e(q), J = _e(W), Q = _e(X), ee = P ? P.prototype : void 0, te = ee ? ee.valueOf : void 0;
                        function re(e) {
                            var t = -1, r = null == e ? 0 : e.length;
                            for(this.clear(); ++t < r;){
                                var n = e[t];
                                this.set(n[0], n[1]);
                            }
                        }
                        function ne(e) {
                            var t = -1, r = null == e ? 0 : e.length;
                            for(this.clear(); ++t < r;){
                                var n = e[t];
                                this.set(n[0], n[1]);
                            }
                        }
                        function ie(e) {
                            var t = -1, r = null == e ? 0 : e.length;
                            for(this.clear(); ++t < r;){
                                var n = e[t];
                                this.set(n[0], n[1]);
                            }
                        }
                        function se(e) {
                            var t = -1, r = null == e ? 0 : e.length;
                            for(this.__data__ = new ie; ++t < r;)this.add(e[t]);
                        }
                        function oe(e) {
                            var t = this.__data__ = new ne(e);
                            this.size = t.size;
                        }
                        function ae(e, t) {
                            var r = Se(e), n = !r && ke(e), i = !r && !n && Me(e), s = !r && !n && !i && Re(e), o = r || n || i || s, a = o ? function(e, t) {
                                for(var r = -1, n = Array(e); ++r < e;)n[r] = t(r);
                                return n;
                            }(e.length, String) : [], l = a.length;
                            for(var c in e)!t && !R.call(e, c) || o && ("length" == c || i && ("offset" == c || "parent" == c) || s && ("buffer" == c || "byteLength" == c || "byteOffset" == c) || we(c, l)) || a.push(c);
                            return a;
                        }
                        function le(e, t) {
                            for(var r = e.length; r--;)if (xe(e[r][0], t)) return r;
                            return -1;
                        }
                        function ce(e) {
                            return null == e ? void 0 === e ? "[object Undefined]" : "[object Null]" : L && L in Object(e) ? function(e) {
                                var t = R.call(e, L), r = e[L];
                                try {
                                    e[L] = void 0;
                                    var n = !0;
                                } catch (e) {}
                                var i = j.call(e);
                                n && (t ? e[L] = r : delete e[L]);
                                return i;
                            }(e) : function(e) {
                                return j.call(e);
                            }(e);
                        }
                        function ue(e) {
                            return Ae(e) && ce(e) == n;
                        }
                        function he(e, t, r, a, l) {
                            return e === t || (null == e || null == t || !Ae(e) && !Ae(t) ? e != e && t != t : function(e, t, r, a, l, c) {
                                var u = Se(e), h = Se(t), f = u ? "[object Array]" : ve(e), d = h ? "[object Array]" : ve(t), p = (f = f == n ? s : f) == s, m = (d = d == n ? s : d) == s, b = f == d;
                                if (b && Me(e)) {
                                    if (!Me(t)) return !1;
                                    u = !0, p = !1;
                                }
                                if (b && !p) return c || (c = new oe), u || Re(e) ? pe(e, t, r, a, l, c) : function(e, t, r, n, s, a, l) {
                                    switch(r){
                                        case "[object DataView]":
                                            if (e.byteLength != t.byteLength || e.byteOffset != t.byteOffset) return !1;
                                            e = e.buffer, t = t.buffer;
                                        case "[object ArrayBuffer]":
                                            return !(e.byteLength != t.byteLength || !a(new B(e), new B(t)));
                                        case "[object Boolean]":
                                        case "[object Date]":
                                        case "[object Number]":
                                            return xe(+e, +t);
                                        case "[object Error]":
                                            return e.name == t.name && e.message == t.message;
                                        case "[object RegExp]":
                                        case "[object String]":
                                            return e == t + "";
                                        case i:
                                            var c = w;
                                        case o:
                                            var u = 1 & n;
                                            if (c || (c = _), e.size != t.size && !u) return !1;
                                            var h = l.get(e);
                                            if (h) return h == t;
                                            n |= 2, l.set(e, t);
                                            var f = pe(c(e), c(t), n, s, a, l);
                                            return l.delete(e), f;
                                        case "[object Symbol]":
                                            if (te) return te.call(e) == te.call(t);
                                    }
                                    return !1;
                                }(e, t, f, r, a, l, c);
                                if (!(1 & r)) {
                                    var g = p && R.call(e, "__wrapped__"), y = m && R.call(t, "__wrapped__");
                                    if (g || y) {
                                        var v = g ? e.value() : e, x = y ? t.value() : t;
                                        return c || (c = new oe), l(v, x, r, a, c);
                                    }
                                }
                                if (!b) return !1;
                                return c || (c = new oe), function(e, t, r, n, i, s) {
                                    var o = 1 & r, a = me(e), l = a.length, c = me(t).length;
                                    if (l != c && !o) return !1;
                                    var u = l;
                                    for(; u--;){
                                        var h = a[u];
                                        if (!(o ? h in t : R.call(t, h))) return !1;
                                    }
                                    var f = s.get(e);
                                    if (f && s.get(t)) return f == t;
                                    var d = !0;
                                    s.set(e, t), s.set(t, e);
                                    var p = o;
                                    for(; ++u < l;){
                                        h = a[u];
                                        var m = e[h], b = t[h];
                                        if (n) var g = o ? n(b, m, h, t, e, s) : n(m, b, h, e, t, s);
                                        if (!(void 0 === g ? m === b || i(m, b, r, n, s) : g)) {
                                            d = !1;
                                            break;
                                        }
                                        p || (p = "constructor" == h);
                                    }
                                    if (d && !p) {
                                        var y = e.constructor, v = t.constructor;
                                        y == v || !("constructor" in e) || !("constructor" in t) || "function" == typeof y && y instanceof y && "function" == typeof v && v instanceof v || (d = !1);
                                    }
                                    return s.delete(e), s.delete(t), d;
                                }(e, t, r, a, l, c);
                            }(e, t, r, a, he, l));
                        }
                        function fe(e) {
                            return !(!Ee(e) || function(e) {
                                return !!O && O in e;
                            }(e)) && (Ce(e) ? I : a).test(_e(e));
                        }
                        function de(e) {
                            if (r = (t = e) && t.constructor, n = "function" == typeof r && r.prototype || T, t !== n) return $(e);
                            var t, r, n, i = [];
                            for(var s in Object(e))R.call(e, s) && "constructor" != s && i.push(s);
                            return i;
                        }
                        function pe(e, t, r, n, i, s) {
                            var o = 1 & r, a = e.length, l = t.length;
                            if (a != l && !(o && l > a)) return !1;
                            var c = s.get(e);
                            if (c && s.get(t)) return c == t;
                            var u = -1, h = !0, f = 2 & r ? new se : void 0;
                            for(s.set(e, t), s.set(t, e); ++u < a;){
                                var d = e[u], p = t[u];
                                if (n) var m = o ? n(p, d, u, t, e, s) : n(d, p, u, e, t, s);
                                if (void 0 !== m) {
                                    if (m) continue;
                                    h = !1;
                                    break;
                                }
                                if (f) {
                                    if (!v(t, function(e, t) {
                                        if (o = t, !f.has(o) && (d === e || i(d, e, r, n, s))) return f.push(t);
                                        var o;
                                    })) {
                                        h = !1;
                                        break;
                                    }
                                } else if (d !== p && !i(d, p, r, n, s)) {
                                    h = !1;
                                    break;
                                }
                            }
                            return s.delete(e), s.delete(t), h;
                        }
                        function me(e) {
                            return function(e, t, r) {
                                var n = t(e);
                                return Se(e) ? n : function(e, t) {
                                    for(var r = -1, n = t.length, i = e.length; ++r < n;)e[i + r] = t[r];
                                    return e;
                                }(n, r(e));
                            }(e, Oe, ye);
                        }
                        function be(e, t) {
                            var r, n, i = e.__data__;
                            return ("string" == (n = typeof (r = t)) || "number" == n || "symbol" == n || "boolean" == n ? "__proto__" !== r : null === r) ? i["string" == typeof t ? "string" : "hash"] : i.map;
                        }
                        function ge(e, t) {
                            var r = function(e, t) {
                                return null == e ? void 0 : e[t];
                            }(e, t);
                            return fe(r) ? r : void 0;
                        }
                        re.prototype.clear = function() {
                            this.__data__ = K ? K(null) : {}, this.size = 0;
                        }, re.prototype.delete = function(e) {
                            var t = this.has(e) && delete this.__data__[e];
                            return this.size -= t ? 1 : 0, t;
                        }, re.prototype.get = function(e) {
                            var t = this.__data__;
                            if (K) {
                                var r = t[e];
                                return "__lodash_hash_undefined__" === r ? void 0 : r;
                            }
                            return R.call(t, e) ? t[e] : void 0;
                        }, re.prototype.has = function(e) {
                            var t = this.__data__;
                            return K ? void 0 !== t[e] : R.call(t, e);
                        }, re.prototype.set = function(e, t) {
                            var r = this.__data__;
                            return this.size += this.has(e) ? 0 : 1, r[e] = K && void 0 === t ? "__lodash_hash_undefined__" : t, this;
                        }, ne.prototype.clear = function() {
                            this.__data__ = [], this.size = 0;
                        }, ne.prototype.delete = function(e) {
                            var t = this.__data__, r = le(t, e);
                            return !(r < 0) && (r == t.length - 1 ? t.pop() : F.call(t, r, 1), --this.size, !0);
                        }, ne.prototype.get = function(e) {
                            var t = this.__data__, r = le(t, e);
                            return r < 0 ? void 0 : t[r][1];
                        }, ne.prototype.has = function(e) {
                            return le(this.__data__, e) > -1;
                        }, ne.prototype.set = function(e, t) {
                            var r = this.__data__, n = le(r, e);
                            return n < 0 ? (++this.size, r.push([
                                e,
                                t
                            ])) : r[n][1] = t, this;
                        }, ie.prototype.clear = function() {
                            this.size = 0, this.__data__ = {
                                hash: new re,
                                map: new (V || ne),
                                string: new re
                            };
                        }, ie.prototype.delete = function(e) {
                            var t = be(this, e).delete(e);
                            return this.size -= t ? 1 : 0, t;
                        }, ie.prototype.get = function(e) {
                            return be(this, e).get(e);
                        }, ie.prototype.has = function(e) {
                            return be(this, e).has(e);
                        }, ie.prototype.set = function(e, t) {
                            var r = be(this, e), n = r.size;
                            return r.set(e, t), this.size += r.size == n ? 0 : 1, this;
                        }, se.prototype.add = se.prototype.push = function(e) {
                            return this.__data__.set(e, "__lodash_hash_undefined__"), this;
                        }, se.prototype.has = function(e) {
                            return this.__data__.has(e);
                        }, oe.prototype.clear = function() {
                            this.__data__ = new ne, this.size = 0;
                        }, oe.prototype.delete = function(e) {
                            var t = this.__data__, r = t.delete(e);
                            return this.size = t.size, r;
                        }, oe.prototype.get = function(e) {
                            return this.__data__.get(e);
                        }, oe.prototype.has = function(e) {
                            return this.__data__.has(e);
                        }, oe.prototype.set = function(e, t) {
                            var r = this.__data__;
                            if (r instanceof ne) {
                                var n = r.__data__;
                                if (!V || n.length < 199) return n.push([
                                    e,
                                    t
                                ]), this.size = ++r.size, this;
                                r = this.__data__ = new ie(n);
                            }
                            return r.set(e, t), this.size = r.size, this;
                        };
                        var ye = z ? function(e) {
                            return null == e ? [] : (e = Object(e), function(e, t) {
                                for(var r = -1, n = null == e ? 0 : e.length, i = 0, s = []; ++r < n;){
                                    var o = e[r];
                                    t(o, r, e) && (s[i++] = o);
                                }
                                return s;
                            }(z(e), function(t) {
                                return D.call(e, t);
                            }));
                        } : function() {
                            return [];
                        }, ve = ce;
                        function we(e, t) {
                            return !!(t = null == t ? 9007199254740991 : t) && ("number" == typeof e || l.test(e)) && e > -1 && e % 1 == 0 && e < t;
                        }
                        function _e(e) {
                            if (null != e) {
                                try {
                                    return A.call(e);
                                } catch (e) {}
                                try {
                                    return e + "";
                                } catch (e) {}
                            }
                            return "";
                        }
                        function xe(e, t) {
                            return e === t || e != e && t != t;
                        }
                        (H && "[object DataView]" != ve(new H(new ArrayBuffer(1))) || V && ve(new V) != i || q && "[object Promise]" != ve(q.resolve()) || W && ve(new W) != o || X && "[object WeakMap]" != ve(new X)) && (ve = function(e) {
                            var t = ce(e), r = t == s ? e.constructor : void 0, n = r ? _e(r) : "";
                            if (n) switch(n){
                                case Y:
                                    return "[object DataView]";
                                case Z:
                                    return i;
                                case G:
                                    return "[object Promise]";
                                case J:
                                    return o;
                                case Q:
                                    return "[object WeakMap]";
                            }
                            return t;
                        });
                        var ke = ue(function() {
                            return arguments;
                        }()) ? ue : function(e) {
                            return Ae(e) && R.call(e, "callee") && !D.call(e, "callee");
                        }, Se = Array.isArray;
                        var Me = U || function() {
                            return !1;
                        };
                        function Ce(e) {
                            if (!Ee(e)) return !1;
                            var t = ce(e);
                            return "[object Function]" == t || "[object GeneratorFunction]" == t || "[object AsyncFunction]" == t || "[object Proxy]" == t;
                        }
                        function Te(e) {
                            return "number" == typeof e && e > -1 && e % 1 == 0 && e <= 9007199254740991;
                        }
                        function Ee(e) {
                            var t = typeof e;
                            return null != e && ("object" == t || "function" == t);
                        }
                        function Ae(e) {
                            return null != e && "object" == typeof e;
                        }
                        var Re = y ? function(e) {
                            return function(t) {
                                return e(t);
                            };
                        }(y) : function(e) {
                            return Ae(e) && Te(e.length) && !!c[ce(e)];
                        };
                        function Oe(e) {
                            var t;
                            return null != (t = e) && Te(t.length) && !Ce(t) ? ae(e) : de(e);
                        }
                        t.exports = function(e, t) {
                            return he(e, t);
                        };
                    }).call(this);
                }).call(this, "undefined" != typeof $parcel$global ? $parcel$global : "undefined" != typeof self ? self : "undefined" != typeof window ? window : {});
            },
            {}
        ],
        446: [
            function(e, t, r) {
                (function(e) {
                    (function() {
                        "use strict";
                        var r = "object" == typeof e && e && e.Object === Object && e, n = "object" == typeof self && self && self.Object === Object && self, i = r || n || Function("return this")(), s = Object.prototype, o = s.hasOwnProperty, a = s.toString, l = i.Symbol, c = l ? l.toStringTag : void 0;
                        function u(e) {
                            return null == e ? void 0 === e ? "[object Undefined]" : "[object Null]" : c && c in Object(e) ? function(e) {
                                var t = o.call(e, c), r = e[c];
                                try {
                                    e[c] = void 0;
                                    var n = !0;
                                } catch (e) {}
                                var i = a.call(e);
                                n && (t ? e[c] = r : delete e[c]);
                                return i;
                            }(e) : function(e) {
                                return a.call(e);
                            }(e);
                        }
                        t.exports = function(e) {
                            if (!function(e) {
                                var t = typeof e;
                                return null != e && ("object" == t || "function" == t);
                            }(e)) return !1;
                            var t = u(e);
                            return "[object Function]" == t || "[object GeneratorFunction]" == t || "[object AsyncFunction]" == t || "[object Proxy]" == t;
                        };
                    }).call(this);
                }).call(this, "undefined" != typeof $parcel$global ? $parcel$global : "undefined" != typeof self ? self : "undefined" != typeof window ? window : {});
            },
            {}
        ],
        447: [
            function(e, t, r) {
                "use strict";
                t.exports = function(e) {
                    return null == e;
                };
            },
            {}
        ],
        448: [
            function(e, t, r) {
                "use strict";
                t.exports = function(e) {
                    return void 0 === e;
                };
            },
            {}
        ],
        449: [
            function(e, t, r) {
                (function(e) {
                    (function() {
                        "use strict";
                        var r = /^\[object .+?Constructor\]$/, n = "object" == typeof e && e && e.Object === Object && e, i = "object" == typeof self && self && self.Object === Object && self, s = n || i || Function("return this")();
                        function o(e, t) {
                            return !!(e ? e.length : 0) && function(e, t, r) {
                                if (t != t) return function(e, t, r, n) {
                                    var i = e.length, s = r + (n ? 1 : -1);
                                    for(; n ? s-- : ++s < i;)if (t(e[s], s, e)) return s;
                                    return -1;
                                }(e, l, r);
                                var n = r - 1, i = e.length;
                                for(; ++n < i;)if (e[n] === t) return n;
                                return -1;
                            }(e, t, 0) > -1;
                        }
                        function a(e, t, r) {
                            for(var n = -1, i = e ? e.length : 0; ++n < i;)if (r(t, e[n])) return !0;
                            return !1;
                        }
                        function l(e) {
                            return e != e;
                        }
                        function c(e, t) {
                            return e.has(t);
                        }
                        function u(e) {
                            var t = -1, r = Array(e.size);
                            return e.forEach(function(e) {
                                r[++t] = e;
                            }), r;
                        }
                        var h, f = Array.prototype, d = Function.prototype, p = Object.prototype, m = s["__core-js_shared__"], b = (h = /[^.]+$/.exec(m && m.keys && m.keys.IE_PROTO || "")) ? "Symbol(src)_1." + h : "", g = d.toString, y = p.hasOwnProperty, v = p.toString, w = RegExp("^" + g.call(y).replace(/[\\^$.*+?()[\]{}|]/g, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"), _ = f.splice, x = I(s, "Map"), k = I(s, "Set"), S = I(Object, "create");
                        function M(e) {
                            var t = -1, r = e ? e.length : 0;
                            for(this.clear(); ++t < r;){
                                var n = e[t];
                                this.set(n[0], n[1]);
                            }
                        }
                        function C(e) {
                            var t = -1, r = e ? e.length : 0;
                            for(this.clear(); ++t < r;){
                                var n = e[t];
                                this.set(n[0], n[1]);
                            }
                        }
                        function T(e) {
                            var t = -1, r = e ? e.length : 0;
                            for(this.clear(); ++t < r;){
                                var n = e[t];
                                this.set(n[0], n[1]);
                            }
                        }
                        function E(e) {
                            var t = -1, r = e ? e.length : 0;
                            for(this.__data__ = new T; ++t < r;)this.add(e[t]);
                        }
                        function A(e, t) {
                            for(var r, n, i = e.length; i--;)if ((r = e[i][0]) === (n = t) || r != r && n != n) return i;
                            return -1;
                        }
                        function R(e) {
                            var t;
                            return !(!N(e) || (t = e, b && b in t)) && ((function(e) {
                                var t = N(e) ? v.call(e) : "";
                                return "[object Function]" == t || "[object GeneratorFunction]" == t;
                            })(e) || function(e) {
                                var t = !1;
                                if (null != e && "function" != typeof e.toString) try {
                                    t = !!(e + "");
                                } catch (e) {}
                                return t;
                            }(e) ? w : r).test(function(e) {
                                if (null != e) {
                                    try {
                                        return g.call(e);
                                    } catch (e) {}
                                    try {
                                        return e + "";
                                    } catch (e) {}
                                }
                                return "";
                            }(e));
                        }
                        M.prototype.clear = function() {
                            this.__data__ = S ? S(null) : {};
                        }, M.prototype.delete = function(e) {
                            return this.has(e) && delete this.__data__[e];
                        }, M.prototype.get = function(e) {
                            var t = this.__data__;
                            if (S) {
                                var r = t[e];
                                return "__lodash_hash_undefined__" === r ? void 0 : r;
                            }
                            return y.call(t, e) ? t[e] : void 0;
                        }, M.prototype.has = function(e) {
                            var t = this.__data__;
                            return S ? void 0 !== t[e] : y.call(t, e);
                        }, M.prototype.set = function(e, t) {
                            return this.__data__[e] = S && void 0 === t ? "__lodash_hash_undefined__" : t, this;
                        }, C.prototype.clear = function() {
                            this.__data__ = [];
                        }, C.prototype.delete = function(e) {
                            var t = this.__data__, r = A(t, e);
                            return !(r < 0) && (r == t.length - 1 ? t.pop() : _.call(t, r, 1), !0);
                        }, C.prototype.get = function(e) {
                            var t = this.__data__, r = A(t, e);
                            return r < 0 ? void 0 : t[r][1];
                        }, C.prototype.has = function(e) {
                            return A(this.__data__, e) > -1;
                        }, C.prototype.set = function(e, t) {
                            var r = this.__data__, n = A(r, e);
                            return n < 0 ? r.push([
                                e,
                                t
                            ]) : r[n][1] = t, this;
                        }, T.prototype.clear = function() {
                            this.__data__ = {
                                hash: new M,
                                map: new (x || C),
                                string: new M
                            };
                        }, T.prototype.delete = function(e) {
                            return j(this, e).delete(e);
                        }, T.prototype.get = function(e) {
                            return j(this, e).get(e);
                        }, T.prototype.has = function(e) {
                            return j(this, e).has(e);
                        }, T.prototype.set = function(e, t) {
                            return j(this, e).set(e, t), this;
                        }, E.prototype.add = E.prototype.push = function(e) {
                            return this.__data__.set(e, "__lodash_hash_undefined__"), this;
                        }, E.prototype.has = function(e) {
                            return this.__data__.has(e);
                        };
                        var O = k && 1 / u(new k([
                            ,
                            -0
                        ]))[1] == 1 / 0 ? function(e) {
                            return new k(e);
                        } : function() {};
                        function j(e, t) {
                            var r, n, i = e.__data__;
                            return ("string" == (n = typeof (r = t)) || "number" == n || "symbol" == n || "boolean" == n ? "__proto__" !== r : null === r) ? i["string" == typeof t ? "string" : "hash"] : i.map;
                        }
                        function I(e, t) {
                            var r = function(e, t) {
                                return null == e ? void 0 : e[t];
                            }(e, t);
                            return R(r) ? r : void 0;
                        }
                        function N(e) {
                            var t = typeof e;
                            return !!e && ("object" == t || "function" == t);
                        }
                        t.exports = function(e) {
                            return e && e.length ? function(e, t, r) {
                                var n = -1, i = o, s = e.length, l = !0, h = [], f = h;
                                if (r) l = !1, i = a;
                                else if (s >= 200) {
                                    var d = t ? null : O(e);
                                    if (d) return u(d);
                                    l = !1, i = c, f = new E;
                                } else f = t ? [] : h;
                                e: for(; ++n < s;){
                                    var p = e[n], m = t ? t(p) : p;
                                    if (p = r || 0 !== p ? p : 0, l && m == m) {
                                        for(var b = f.length; b--;)if (f[b] === m) continue e;
                                        t && f.push(m), h.push(p);
                                    } else i(f, m, r) || (f !== h && f.push(m), h.push(p));
                                }
                                return h;
                            }(e) : [];
                        };
                    }).call(this);
                }).call(this, "undefined" != typeof $parcel$global ? $parcel$global : "undefined" != typeof self ? self : "undefined" != typeof window ? window : {});
            },
            {}
        ],
        450: [
            function(e, t, r) {
                "use strict";
                var n = e("inherits"), i = e("hash-base"), s = e("safe-buffer").Buffer, o = new Array(16);
                function a() {
                    i.call(this, 64), this._a = 1732584193, this._b = 4023233417, this._c = 2562383102, this._d = 271733878;
                }
                function l(e, t) {
                    return e << t | e >>> 32 - t;
                }
                function c(e, t, r, n, i, s, o) {
                    return l(e + (t & r | ~t & n) + i + s | 0, o) + t | 0;
                }
                function u(e, t, r, n, i, s, o) {
                    return l(e + (t & n | r & ~n) + i + s | 0, o) + t | 0;
                }
                function h(e, t, r, n, i, s, o) {
                    return l(e + (t ^ r ^ n) + i + s | 0, o) + t | 0;
                }
                function f(e, t, r, n, i, s, o) {
                    return l(e + (r ^ (t | ~n)) + i + s | 0, o) + t | 0;
                }
                n(a, i), a.prototype._update = function() {
                    for(var e = o, t = 0; t < 16; ++t)e[t] = this._block.readInt32LE(4 * t);
                    var r = this._a, n = this._b, i = this._c, s = this._d;
                    r = c(r, n, i, s, e[0], 3614090360, 7), s = c(s, r, n, i, e[1], 3905402710, 12), i = c(i, s, r, n, e[2], 606105819, 17), n = c(n, i, s, r, e[3], 3250441966, 22), r = c(r, n, i, s, e[4], 4118548399, 7), s = c(s, r, n, i, e[5], 1200080426, 12), i = c(i, s, r, n, e[6], 2821735955, 17), n = c(n, i, s, r, e[7], 4249261313, 22), r = c(r, n, i, s, e[8], 1770035416, 7), s = c(s, r, n, i, e[9], 2336552879, 12), i = c(i, s, r, n, e[10], 4294925233, 17), n = c(n, i, s, r, e[11], 2304563134, 22), r = c(r, n, i, s, e[12], 1804603682, 7), s = c(s, r, n, i, e[13], 4254626195, 12), i = c(i, s, r, n, e[14], 2792965006, 17), r = u(r, n = c(n, i, s, r, e[15], 1236535329, 22), i, s, e[1], 4129170786, 5), s = u(s, r, n, i, e[6], 3225465664, 9), i = u(i, s, r, n, e[11], 643717713, 14), n = u(n, i, s, r, e[0], 3921069994, 20), r = u(r, n, i, s, e[5], 3593408605, 5), s = u(s, r, n, i, e[10], 38016083, 9), i = u(i, s, r, n, e[15], 3634488961, 14), n = u(n, i, s, r, e[4], 3889429448, 20), r = u(r, n, i, s, e[9], 568446438, 5), s = u(s, r, n, i, e[14], 3275163606, 9), i = u(i, s, r, n, e[3], 4107603335, 14), n = u(n, i, s, r, e[8], 1163531501, 20), r = u(r, n, i, s, e[13], 2850285829, 5), s = u(s, r, n, i, e[2], 4243563512, 9), i = u(i, s, r, n, e[7], 1735328473, 14), r = h(r, n = u(n, i, s, r, e[12], 2368359562, 20), i, s, e[5], 4294588738, 4), s = h(s, r, n, i, e[8], 2272392833, 11), i = h(i, s, r, n, e[11], 1839030562, 16), n = h(n, i, s, r, e[14], 4259657740, 23), r = h(r, n, i, s, e[1], 2763975236, 4), s = h(s, r, n, i, e[4], 1272893353, 11), i = h(i, s, r, n, e[7], 4139469664, 16), n = h(n, i, s, r, e[10], 3200236656, 23), r = h(r, n, i, s, e[13], 681279174, 4), s = h(s, r, n, i, e[0], 3936430074, 11), i = h(i, s, r, n, e[3], 3572445317, 16), n = h(n, i, s, r, e[6], 76029189, 23), r = h(r, n, i, s, e[9], 3654602809, 4), s = h(s, r, n, i, e[12], 3873151461, 11), i = h(i, s, r, n, e[15], 530742520, 16), r = f(r, n = h(n, i, s, r, e[2], 3299628645, 23), i, s, e[0], 4096336452, 6), s = f(s, r, n, i, e[7], 1126891415, 10), i = f(i, s, r, n, e[14], 2878612391, 15), n = f(n, i, s, r, e[5], 4237533241, 21), r = f(r, n, i, s, e[12], 1700485571, 6), s = f(s, r, n, i, e[3], 2399980690, 10), i = f(i, s, r, n, e[10], 4293915773, 15), n = f(n, i, s, r, e[1], 2240044497, 21), r = f(r, n, i, s, e[8], 1873313359, 6), s = f(s, r, n, i, e[15], 4264355552, 10), i = f(i, s, r, n, e[6], 2734768916, 15), n = f(n, i, s, r, e[13], 1309151649, 21), r = f(r, n, i, s, e[4], 4149444226, 6), s = f(s, r, n, i, e[11], 3174756917, 10), i = f(i, s, r, n, e[2], 718787259, 15), n = f(n, i, s, r, e[9], 3951481745, 21), this._a = this._a + r | 0, this._b = this._b + n | 0, this._c = this._c + i | 0, this._d = this._d + s | 0;
                }, a.prototype._digest = function() {
                    this._block[this._blockOffset++] = 128, this._blockOffset > 56 && (this._block.fill(0, this._blockOffset, 64), this._update(), this._blockOffset = 0), this._block.fill(0, this._blockOffset, 56), this._block.writeUInt32LE(this._length[0], 56), this._block.writeUInt32LE(this._length[1], 60), this._update();
                    var e = s.allocUnsafe(16);
                    return e.writeInt32LE(this._a, 0), e.writeInt32LE(this._b, 4), e.writeInt32LE(this._c, 8), e.writeInt32LE(this._d, 12), e;
                }, t.exports = a;
            },
            {
                "hash-base": 425,
                inherits: 440,
                "safe-buffer": 494
            }
        ],
        451: [
            function(e, t, r) {
                "use strict";
                var n = e("bn.js"), i = e("brorand");
                function s(e) {
                    this.rand = e || new i.Rand;
                }
                t.exports = s, s.create = function(e) {
                    return new s(e);
                }, s.prototype._randbelow = function(e) {
                    var t = e.bitLength(), r = Math.ceil(t / 8);
                    do var i = new n(this.rand.generate(r));
                    while (i.cmp(e) >= 0);
                    return i;
                }, s.prototype._randrange = function(e, t) {
                    var r = t.sub(e);
                    return e.add(this._randbelow(r));
                }, s.prototype.test = function(e, t, r) {
                    var i = e.bitLength(), s = n.mont(e), o = new n(1).toRed(s);
                    t || (t = Math.max(1, i / 48 | 0));
                    for(var a = e.subn(1), l = 0; !a.testn(l); l++);
                    for(var c = e.shrn(l), u = a.toRed(s); t > 0; t--){
                        var h = this._randrange(new n(2), a);
                        r && r(h);
                        var f = h.toRed(s).redPow(c);
                        if (0 !== f.cmp(o) && 0 !== f.cmp(u)) {
                            for(var d = 1; d < l; d++){
                                if (0 === (f = f.redSqr()).cmp(o)) return !1;
                                if (0 === f.cmp(u)) break;
                            }
                            if (d === l) return !1;
                        }
                    }
                    return !0;
                }, s.prototype.getDivisor = function(e, t) {
                    var r = e.bitLength(), i = n.mont(e), s = new n(1).toRed(i);
                    t || (t = Math.max(1, r / 48 | 0));
                    for(var o = e.subn(1), a = 0; !o.testn(a); a++);
                    for(var l = e.shrn(a), c = o.toRed(i); t > 0; t--){
                        var u = this._randrange(new n(2), o), h = e.gcd(u);
                        if (0 !== h.cmpn(1)) return h;
                        var f = u.toRed(i).redPow(l);
                        if (0 !== f.cmp(s) && 0 !== f.cmp(c)) {
                            for(var d = 1; d < a; d++){
                                if (0 === (f = f.redSqr()).cmp(s)) return f.fromRed().subn(1).gcd(e);
                                if (0 === f.cmp(c)) break;
                            }
                            if (d === a) return (f = f.redSqr()).fromRed().subn(1).gcd(e);
                        }
                    }
                    return !1;
                };
            },
            {
                "bn.js": 452,
                brorand: 187
            }
        ],
        452: [
            function(e, t, r) {
                arguments[4][184][0].apply(r, arguments);
            },
            {
                buffer: 188,
                dup: 184
            }
        ],
        453: [
            function(e, t, r) {
                "use strict";
                function n(e, t) {
                    if (!e) throw new Error(t || "Assertion failed");
                }
                t.exports = n, n.equal = function(e, t, r) {
                    if (e != t) throw new Error(r || "Assertion failed: " + e + " != " + t);
                };
            },
            {}
        ],
        454: [
            function(e, t, r) {
                "use strict";
                var n = r;
                function i(e) {
                    return 1 === e.length ? "0" + e : e;
                }
                function s(e) {
                    for(var t = "", r = 0; r < e.length; r++)t += i(e[r].toString(16));
                    return t;
                }
                n.toArray = function(e, t) {
                    if (Array.isArray(e)) return e.slice();
                    if (!e) return [];
                    var r = [];
                    if ("string" != typeof e) {
                        for(var n = 0; n < e.length; n++)r[n] = 0 | e[n];
                        return r;
                    }
                    if ("hex" === t) {
                        (e = e.replace(/[^a-z0-9]+/gi, "")).length % 2 != 0 && (e = "0" + e);
                        for(n = 0; n < e.length; n += 2)r.push(parseInt(e[n] + e[n + 1], 16));
                    } else for(n = 0; n < e.length; n++){
                        var i = e.charCodeAt(n), s = i >> 8, o = 255 & i;
                        s ? r.push(s, o) : r.push(o);
                    }
                    return r;
                }, n.zero2 = i, n.toHex = s, n.encode = function(e, t) {
                    return "hex" === t ? s(e) : e;
                };
            },
            {}
        ],
        455: [
            function(e, t, r) {
                t.exports = {
                    "2.16.840.1.101.3.4.1.1": "aes-128-ecb",
                    "2.16.840.1.101.3.4.1.2": "aes-128-cbc",
                    "2.16.840.1.101.3.4.1.3": "aes-128-ofb",
                    "2.16.840.1.101.3.4.1.4": "aes-128-cfb",
                    "2.16.840.1.101.3.4.1.21": "aes-192-ecb",
                    "2.16.840.1.101.3.4.1.22": "aes-192-cbc",
                    "2.16.840.1.101.3.4.1.23": "aes-192-ofb",
                    "2.16.840.1.101.3.4.1.24": "aes-192-cfb",
                    "2.16.840.1.101.3.4.1.41": "aes-256-ecb",
                    "2.16.840.1.101.3.4.1.42": "aes-256-cbc",
                    "2.16.840.1.101.3.4.1.43": "aes-256-ofb",
                    "2.16.840.1.101.3.4.1.44": "aes-256-cfb"
                };
            },
            {}
        ],
        456: [
            function(e, t, r) {
                "use strict";
                var n = e("asn1.js");
                r.certificate = e("./certificate");
                var i = n.define("RSAPrivateKey", function() {
                    this.seq().obj(this.key("version").int(), this.key("modulus").int(), this.key("publicExponent").int(), this.key("privateExponent").int(), this.key("prime1").int(), this.key("prime2").int(), this.key("exponent1").int(), this.key("exponent2").int(), this.key("coefficient").int());
                });
                r.RSAPrivateKey = i;
                var s = n.define("RSAPublicKey", function() {
                    this.seq().obj(this.key("modulus").int(), this.key("publicExponent").int());
                });
                r.RSAPublicKey = s;
                var o = n.define("SubjectPublicKeyInfo", function() {
                    this.seq().obj(this.key("algorithm").use(a), this.key("subjectPublicKey").bitstr());
                });
                r.PublicKey = o;
                var a = n.define("AlgorithmIdentifier", function() {
                    this.seq().obj(this.key("algorithm").objid(), this.key("none").null_().optional(), this.key("curve").objid().optional(), this.key("params").seq().obj(this.key("p").int(), this.key("q").int(), this.key("g").int()).optional());
                }), l = n.define("PrivateKeyInfo", function() {
                    this.seq().obj(this.key("version").int(), this.key("algorithm").use(a), this.key("subjectPrivateKey").octstr());
                });
                r.PrivateKey = l;
                var c = n.define("EncryptedPrivateKeyInfo", function() {
                    this.seq().obj(this.key("algorithm").seq().obj(this.key("id").objid(), this.key("decrypt").seq().obj(this.key("kde").seq().obj(this.key("id").objid(), this.key("kdeparams").seq().obj(this.key("salt").octstr(), this.key("iters").int())), this.key("cipher").seq().obj(this.key("algo").objid(), this.key("iv").octstr()))), this.key("subjectPrivateKey").octstr());
                });
                r.EncryptedPrivateKey = c;
                var u = n.define("DSAPrivateKey", function() {
                    this.seq().obj(this.key("version").int(), this.key("p").int(), this.key("q").int(), this.key("g").int(), this.key("pub_key").int(), this.key("priv_key").int());
                });
                r.DSAPrivateKey = u, r.DSAparam = n.define("DSAparam", function() {
                    this.int();
                });
                var h = n.define("ECPrivateKey", function() {
                    this.seq().obj(this.key("version").int(), this.key("privateKey").octstr(), this.key("parameters").optional().explicit(0).use(f), this.key("publicKey").optional().explicit(1).bitstr());
                });
                r.ECPrivateKey = h;
                var f = n.define("ECParameters", function() {
                    this.choice({
                        namedCurve: this.objid()
                    });
                });
                r.signature = n.define("signature", function() {
                    this.seq().obj(this.key("r").int(), this.key("s").int());
                });
            },
            {
                "./certificate": 457,
                "asn1.js": 170
            }
        ],
        457: [
            function(e, t, r) {
                "use strict";
                var n = e("asn1.js"), i = n.define("Time", function() {
                    this.choice({
                        utcTime: this.utctime(),
                        generalTime: this.gentime()
                    });
                }), s = n.define("AttributeTypeValue", function() {
                    this.seq().obj(this.key("type").objid(), this.key("value").any());
                }), o = n.define("AlgorithmIdentifier", function() {
                    this.seq().obj(this.key("algorithm").objid(), this.key("parameters").optional(), this.key("curve").objid().optional());
                }), a = n.define("SubjectPublicKeyInfo", function() {
                    this.seq().obj(this.key("algorithm").use(o), this.key("subjectPublicKey").bitstr());
                }), l = n.define("RelativeDistinguishedName", function() {
                    this.setof(s);
                }), c = n.define("RDNSequence", function() {
                    this.seqof(l);
                }), u = n.define("Name", function() {
                    this.choice({
                        rdnSequence: this.use(c)
                    });
                }), h = n.define("Validity", function() {
                    this.seq().obj(this.key("notBefore").use(i), this.key("notAfter").use(i));
                }), f = n.define("Extension", function() {
                    this.seq().obj(this.key("extnID").objid(), this.key("critical").bool().def(!1), this.key("extnValue").octstr());
                }), d = n.define("TBSCertificate", function() {
                    this.seq().obj(this.key("version").explicit(0).int().optional(), this.key("serialNumber").int(), this.key("signature").use(o), this.key("issuer").use(u), this.key("validity").use(h), this.key("subject").use(u), this.key("subjectPublicKeyInfo").use(a), this.key("issuerUniqueID").implicit(1).bitstr().optional(), this.key("subjectUniqueID").implicit(2).bitstr().optional(), this.key("extensions").explicit(3).seqof(f).optional());
                }), p = n.define("X509Certificate", function() {
                    this.seq().obj(this.key("tbsCertificate").use(d), this.key("signatureAlgorithm").use(o), this.key("signatureValue").bitstr());
                });
                t.exports = p;
            },
            {
                "asn1.js": 170
            }
        ],
        458: [
            function(e, t, r) {
                "use strict";
                var n = /Proc-Type: 4,ENCRYPTED[\n\r]+DEK-Info: AES-((?:128)|(?:192)|(?:256))-CBC,([0-9A-H]+)[\n\r]+([0-9A-z\n\r+/=]+)[\n\r]+/m, i = /^-----BEGIN ((?:.*? KEY)|CERTIFICATE)-----/m, s = /^-----BEGIN ((?:.*? KEY)|CERTIFICATE)-----([0-9A-z\n\r+/=]+)-----END \1-----$/m, o = e("evp_bytestokey"), a = e("browserify-aes"), l = e("safe-buffer").Buffer;
                t.exports = function(e, t) {
                    var r, c = e.toString(), u = c.match(n);
                    if (u) {
                        var h = "aes" + u[1], f = l.from(u[2], "hex"), d = l.from(u[3].replace(/[\r\n]/g, ""), "base64"), p = o(t, f.slice(0, 8), parseInt(u[1], 10)).key, m = [], b = a.createDecipheriv(h, p, f);
                        m.push(b.update(d)), m.push(b.final()), r = l.concat(m);
                    } else {
                        var g = c.match(s);
                        r = l.from(g[2].replace(/[\r\n]/g, ""), "base64");
                    }
                    return {
                        tag: c.match(i)[1],
                        data: r
                    };
                };
            },
            {
                "browserify-aes": 191,
                evp_bytestokey: 423,
                "safe-buffer": 494
            }
        ],
        459: [
            function(e, t, r) {
                "use strict";
                var n = e("./asn1"), i = e("./aesid.json"), s = e("./fixProc"), o = e("browserify-aes"), a = e("pbkdf2"), l = e("safe-buffer").Buffer;
                function c(e) {
                    var t;
                    "object" != typeof e || l.isBuffer(e) || (t = e.passphrase, e = e.key), "string" == typeof e && (e = l.from(e));
                    var r, c, u = s(e, t), h = u.tag, f = u.data;
                    switch(h){
                        case "CERTIFICATE":
                            c = n.certificate.decode(f, "der").tbsCertificate.subjectPublicKeyInfo;
                        case "PUBLIC KEY":
                            switch(c || (c = n.PublicKey.decode(f, "der")), r = c.algorithm.algorithm.join(".")){
                                case "1.2.840.113549.1.1.1":
                                    return n.RSAPublicKey.decode(c.subjectPublicKey.data, "der");
                                case "1.2.840.10045.2.1":
                                    return c.subjectPrivateKey = c.subjectPublicKey, {
                                        type: "ec",
                                        data: c
                                    };
                                case "1.2.840.10040.4.1":
                                    return c.algorithm.params.pub_key = n.DSAparam.decode(c.subjectPublicKey.data, "der"), {
                                        type: "dsa",
                                        data: c.algorithm.params
                                    };
                                default:
                                    throw new Error("unknown key id " + r);
                            }
                        case "ENCRYPTED PRIVATE KEY":
                            f = function(e, t) {
                                var r = e.algorithm.decrypt.kde.kdeparams.salt, n = parseInt(e.algorithm.decrypt.kde.kdeparams.iters.toString(), 10), s = i[e.algorithm.decrypt.cipher.algo.join(".")], c = e.algorithm.decrypt.cipher.iv, u = e.subjectPrivateKey, h = parseInt(s.split("-")[1], 10) / 8, f = a.pbkdf2Sync(t, r, n, h, "sha1"), d = o.createDecipheriv(s, f, c), p = [];
                                return p.push(d.update(u)), p.push(d.final()), l.concat(p);
                            }(f = n.EncryptedPrivateKey.decode(f, "der"), t);
                        case "PRIVATE KEY":
                            switch(r = (c = n.PrivateKey.decode(f, "der")).algorithm.algorithm.join(".")){
                                case "1.2.840.113549.1.1.1":
                                    return n.RSAPrivateKey.decode(c.subjectPrivateKey, "der");
                                case "1.2.840.10045.2.1":
                                    return {
                                        curve: c.algorithm.curve,
                                        privateKey: n.ECPrivateKey.decode(c.subjectPrivateKey, "der").privateKey
                                    };
                                case "1.2.840.10040.4.1":
                                    return c.algorithm.params.priv_key = n.DSAparam.decode(c.subjectPrivateKey, "der"), {
                                        type: "dsa",
                                        params: c.algorithm.params
                                    };
                                default:
                                    throw new Error("unknown key id " + r);
                            }
                        case "RSA PUBLIC KEY":
                            return n.RSAPublicKey.decode(f, "der");
                        case "RSA PRIVATE KEY":
                            return n.RSAPrivateKey.decode(f, "der");
                        case "DSA PRIVATE KEY":
                            return {
                                type: "dsa",
                                params: n.DSAPrivateKey.decode(f, "der")
                            };
                        case "EC PRIVATE KEY":
                            return {
                                curve: (f = n.ECPrivateKey.decode(f, "der")).parameters.value,
                                privateKey: f.privateKey
                            };
                        default:
                            throw new Error("unknown key type " + h);
                    }
                }
                t.exports = c, c.signature = n.signature;
            },
            {
                "./aesid.json": 455,
                "./asn1": 456,
                "./fixProc": 458,
                "browserify-aes": 191,
                pbkdf2: 460,
                "safe-buffer": 494
            }
        ],
        460: [
            function(e, t, r) {
                "use strict";
                r.pbkdf2 = e("./lib/async"), r.pbkdf2Sync = e("./lib/sync");
            },
            {
                "./lib/async": 461,
                "./lib/sync": 464
            }
        ],
        461: [
            function(e, t, r) {
                (function(r) {
                    (function() {
                        "use strict";
                        var n, i, s = e("safe-buffer").Buffer, o = e("./precondition"), a = e("./default-encoding"), l = e("./sync"), c = e("./to-buffer"), u = r.crypto && r.crypto.subtle, h = {
                            sha: "SHA-1",
                            "sha-1": "SHA-1",
                            sha1: "SHA-1",
                            sha256: "SHA-256",
                            "sha-256": "SHA-256",
                            sha384: "SHA-384",
                            "sha-384": "SHA-384",
                            "sha-512": "SHA-512",
                            sha512: "SHA-512"
                        }, f = [];
                        function d() {
                            return i || (i = r.process && r.process.nextTick ? r.process.nextTick : r.queueMicrotask ? r.queueMicrotask : r.setImmediate ? r.setImmediate : r.setTimeout);
                        }
                        function p(e, t, r, n, i) {
                            return u.importKey("raw", e, {
                                name: "PBKDF2"
                            }, !1, [
                                "deriveBits"
                            ]).then(function(e) {
                                return u.deriveBits({
                                    name: "PBKDF2",
                                    salt: t,
                                    iterations: r,
                                    hash: {
                                        name: i
                                    }
                                }, e, n << 3);
                            }).then(function(e) {
                                return s.from(e);
                            });
                        }
                        t.exports = function(e, t, i, m, b, g) {
                            "function" == typeof b && (g = b, b = void 0);
                            var y = h[(b = b || "sha1").toLowerCase()];
                            if (y && "function" == typeof r.Promise) {
                                if (o(i, m), e = c(e, a, "Password"), t = c(t, a, "Salt"), "function" != typeof g) throw new Error("No callback provided to pbkdf2");
                                !function(e, t) {
                                    e.then(function(e) {
                                        d()(function() {
                                            t(null, e);
                                        });
                                    }, function(e) {
                                        d()(function() {
                                            t(e);
                                        });
                                    });
                                }((function(e) {
                                    if (r.process && !r.process.browser) return Promise.resolve(!1);
                                    if (!u || !u.importKey || !u.deriveBits) return Promise.resolve(!1);
                                    if (void 0 !== f[e]) return f[e];
                                    var t = p(n = n || s.alloc(8), n, 10, 128, e).then(function() {
                                        return !0;
                                    }).catch(function() {
                                        return !1;
                                    });
                                    return f[e] = t, t;
                                })(y).then(function(r) {
                                    return r ? p(e, t, i, m, y) : l(e, t, i, m, b);
                                }), g);
                            } else d()(function() {
                                var r;
                                try {
                                    r = l(e, t, i, m, b);
                                } catch (e) {
                                    return g(e);
                                }
                                g(null, r);
                            });
                        };
                    }).call(this);
                }).call(this, "undefined" != typeof $parcel$global ? $parcel$global : "undefined" != typeof self ? self : "undefined" != typeof window ? window : {});
            },
            {
                "./default-encoding": 462,
                "./precondition": 463,
                "./sync": 464,
                "./to-buffer": 465,
                "safe-buffer": 494
            }
        ],
        462: [
            function(e, t, r) {
                (function(e, r) {
                    (function() {
                        "use strict";
                        var n;
                        if (r.process && r.process.browser) n = "utf-8";
                        else if (r.process && r.process.version) n = parseInt(e.version.split(".")[0].slice(1), 10) >= 6 ? "utf-8" : "binary";
                        else n = "utf-8";
                        t.exports = n;
                    }).call(this);
                }).call(this, e("_process"), "undefined" != typeof $parcel$global ? $parcel$global : "undefined" != typeof self ? self : "undefined" != typeof window ? window : {});
            },
            {
                _process: 467
            }
        ],
        463: [
            function(e, t, r) {
                "use strict";
                var n = Math.pow(2, 30) - 1;
                t.exports = function(e, t) {
                    if ("number" != typeof e) throw new TypeError("Iterations not a number");
                    if (e < 0) throw new TypeError("Bad iterations");
                    if ("number" != typeof t) throw new TypeError("Key length not a number");
                    if (t < 0 || t > n || t != t) throw new TypeError("Bad key length");
                };
            },
            {}
        ],
        464: [
            function(e, t, r) {
                "use strict";
                var n = e("create-hash/md5"), i = e("ripemd160"), s = e("sha.js"), o = e("safe-buffer").Buffer, a = e("./precondition"), l = e("./default-encoding"), c = e("./to-buffer"), u = o.alloc(128), h = {
                    md5: 16,
                    sha1: 20,
                    sha224: 28,
                    sha256: 32,
                    sha384: 48,
                    sha512: 64,
                    rmd160: 20,
                    ripemd160: 20
                };
                function f(e, t, r) {
                    var a = function(e) {
                        function t(t) {
                            return s(e).update(t).digest();
                        }
                        return "rmd160" === e || "ripemd160" === e ? function(e) {
                            return (new i).update(e).digest();
                        } : "md5" === e ? n : t;
                    }(e), l = "sha512" === e || "sha384" === e ? 128 : 64;
                    t.length > l ? t = a(t) : t.length < l && (t = o.concat([
                        t,
                        u
                    ], l));
                    for(var c = o.allocUnsafe(l + h[e]), f = o.allocUnsafe(l + h[e]), d = 0; d < l; d++)c[d] = 54 ^ t[d], f[d] = 92 ^ t[d];
                    var p = o.allocUnsafe(l + r + 4);
                    c.copy(p, 0, 0, l), this.ipad1 = p, this.ipad2 = c, this.opad = f, this.alg = e, this.blocksize = l, this.hash = a, this.size = h[e];
                }
                f.prototype.run = function(e, t) {
                    return e.copy(t, this.blocksize), this.hash(t).copy(this.opad, this.blocksize), this.hash(this.opad);
                }, t.exports = function(e, t, r, n, i) {
                    a(r, n);
                    var s = new f(i = i || "sha1", e = c(e, l, "Password"), (t = c(t, l, "Salt")).length), u = o.allocUnsafe(n), d = o.allocUnsafe(t.length + 4);
                    t.copy(d, 0, 0, t.length);
                    for(var p = 0, m = h[i], b = Math.ceil(n / m), g = 1; g <= b; g++){
                        d.writeUInt32BE(g, t.length);
                        for(var y = s.run(d, s.ipad1), v = y, w = 1; w < r; w++){
                            v = s.run(v, s.ipad2);
                            for(var _ = 0; _ < m; _++)y[_] ^= v[_];
                        }
                        y.copy(u, p), p += m;
                    }
                    return u;
                };
            },
            {
                "./default-encoding": 462,
                "./precondition": 463,
                "./to-buffer": 465,
                "create-hash/md5": 387,
                ripemd160: 493,
                "safe-buffer": 494,
                "sha.js": 498
            }
        ],
        465: [
            function(e, t, r) {
                "use strict";
                var n = e("safe-buffer").Buffer;
                t.exports = function(e, t, r) {
                    if (n.isBuffer(e)) return e;
                    if ("string" == typeof e) return n.from(e, t);
                    if (ArrayBuffer.isView(e)) return n.from(e.buffer);
                    throw new TypeError(r + " must be a string, a Buffer, a typed array or a DataView");
                };
            },
            {
                "safe-buffer": 494
            }
        ],
        466: [
            function(e, t, r) {
                (function(e) {
                    (function() {
                        "use strict";
                        void 0 === e || !e.version || 0 === e.version.indexOf("v0.") || 0 === e.version.indexOf("v1.") && 0 !== e.version.indexOf("v1.8.") ? t.exports = {
                            nextTick: function(t, r, n, i) {
                                if ("function" != typeof t) throw new TypeError('"callback" argument must be a function');
                                var s, o, a = arguments.length;
                                switch(a){
                                    case 0:
                                    case 1:
                                        return e.nextTick(t);
                                    case 2:
                                        return e.nextTick(function() {
                                            t.call(null, r);
                                        });
                                    case 3:
                                        return e.nextTick(function() {
                                            t.call(null, r, n);
                                        });
                                    case 4:
                                        return e.nextTick(function() {
                                            t.call(null, r, n, i);
                                        });
                                    default:
                                        for(s = new Array(a - 1), o = 0; o < s.length;)s[o++] = arguments[o];
                                        return e.nextTick(function() {
                                            t.apply(null, s);
                                        });
                                }
                            }
                        } : t.exports = e;
                    }).call(this);
                }).call(this, e("_process"));
            },
            {
                _process: 467
            }
        ],
        467: [
            function(e, t, r) {
                "use strict";
                var n, i, s = t.exports = {};
                function o() {
                    throw new Error("setTimeout has not been defined");
                }
                function a() {
                    throw new Error("clearTimeout has not been defined");
                }
                function l(e) {
                    if (n === setTimeout) return setTimeout(e, 0);
                    if ((n === o || !n) && setTimeout) return n = setTimeout, setTimeout(e, 0);
                    try {
                        return n(e, 0);
                    } catch (t) {
                        try {
                            return n.call(null, e, 0);
                        } catch (t) {
                            return n.call(this, e, 0);
                        }
                    }
                }
                !function() {
                    try {
                        n = "function" == typeof setTimeout ? setTimeout : o;
                    } catch (e) {
                        n = o;
                    }
                    try {
                        i = "function" == typeof clearTimeout ? clearTimeout : a;
                    } catch (e) {
                        i = a;
                    }
                }();
                var c, u = [], h = !1, f = -1;
                function d() {
                    h && c && (h = !1, c.length ? u = c.concat(u) : f = -1, u.length && p());
                }
                function p() {
                    if (!h) {
                        var e = l(d);
                        h = !0;
                        for(var t = u.length; t;){
                            for(c = u, u = []; ++f < t;)c && c[f].run();
                            f = -1, t = u.length;
                        }
                        c = null, h = !1, function(e) {
                            if (i === clearTimeout) return clearTimeout(e);
                            if ((i === a || !i) && clearTimeout) return i = clearTimeout, clearTimeout(e);
                            try {
                                i(e);
                            } catch (t) {
                                try {
                                    return i.call(null, e);
                                } catch (t) {
                                    return i.call(this, e);
                                }
                            }
                        }(e);
                    }
                }
                function m(e, t) {
                    this.fun = e, this.array = t;
                }
                function b() {}
                s.nextTick = function(e) {
                    var t = new Array(arguments.length - 1);
                    if (arguments.length > 1) for(var r = 1; r < arguments.length; r++)t[r - 1] = arguments[r];
                    u.push(new m(e, t)), 1 !== u.length || h || l(p);
                }, m.prototype.run = function() {
                    this.fun.apply(null, this.array);
                }, s.title = "browser", s.browser = !0, s.env = {}, s.argv = [], s.version = "", s.versions = {}, s.on = b, s.addListener = b, s.once = b, s.off = b, s.removeListener = b, s.removeAllListeners = b, s.emit = b, s.prependListener = b, s.prependOnceListener = b, s.listeners = function(e) {
                    return [];
                }, s.binding = function(e) {
                    throw new Error("process.binding is not supported");
                }, s.cwd = function() {
                    return "/";
                }, s.chdir = function(e) {
                    throw new Error("process.chdir is not supported");
                }, s.umask = function() {
                    return 0;
                };
            },
            {}
        ],
        468: [
            function(e, t, r) {
                "use strict";
                r.publicEncrypt = e("./publicEncrypt"), r.privateDecrypt = e("./privateDecrypt"), r.privateEncrypt = function(e, t) {
                    return r.publicEncrypt(e, t, !0);
                }, r.publicDecrypt = function(e, t) {
                    return r.privateDecrypt(e, t, !0);
                };
            },
            {
                "./privateDecrypt": 471,
                "./publicEncrypt": 472
            }
        ],
        469: [
            function(e, t, r) {
                "use strict";
                var n = e("create-hash"), i = e("safe-buffer").Buffer;
                function s(e) {
                    var t = i.allocUnsafe(4);
                    return t.writeUInt32BE(e, 0), t;
                }
                t.exports = function(e, t) {
                    for(var r, o = i.alloc(0), a = 0; o.length < t;)r = s(a++), o = i.concat([
                        o,
                        n("sha1").update(e).update(r).digest()
                    ]);
                    return o.slice(0, t);
                };
            },
            {
                "create-hash": 386,
                "safe-buffer": 494
            }
        ],
        470: [
            function(e, t, r) {
                arguments[4][184][0].apply(r, arguments);
            },
            {
                buffer: 188,
                dup: 184
            }
        ],
        471: [
            function(e, t, r) {
                "use strict";
                var n = e("parse-asn1"), i = e("./mgf"), s = e("./xor"), o = e("bn.js"), a = e("browserify-rsa"), l = e("create-hash"), c = e("./withPublic"), u = e("safe-buffer").Buffer;
                t.exports = function(e, t, r) {
                    var h;
                    h = e.padding ? e.padding : r ? 1 : 4;
                    var f, d = n(e), p = d.modulus.byteLength();
                    if (t.length > p || new o(t).cmp(d.modulus) >= 0) throw new Error("decryption error");
                    f = r ? c(new o(t), d) : a(t, d);
                    var m = u.alloc(p - f.length);
                    if (f = u.concat([
                        m,
                        f
                    ], p), 4 === h) return function(e, t) {
                        var r = e.modulus.byteLength(), n = l("sha1").update(u.alloc(0)).digest(), o = n.length;
                        if (0 !== t[0]) throw new Error("decryption error");
                        var a = t.slice(1, o + 1), c = t.slice(o + 1), h = s(a, i(c, o)), f = s(c, i(h, r - o - 1));
                        if (function(e, t) {
                            e = u.from(e), t = u.from(t);
                            var r = 0, n = e.length;
                            e.length !== t.length && (r++, n = Math.min(e.length, t.length));
                            var i = -1;
                            for(; ++i < n;)r += e[i] ^ t[i];
                            return r;
                        }(n, f.slice(0, o))) throw new Error("decryption error");
                        var d = o;
                        for(; 0 === f[d];)d++;
                        if (1 !== f[d++]) throw new Error("decryption error");
                        return f.slice(d);
                    }(d, f);
                    if (1 === h) return function(e, t, r) {
                        var n = t.slice(0, 2), i = 2, s = 0;
                        for(; 0 !== t[i++];)if (i >= t.length) {
                            s++;
                            break;
                        }
                        var o = t.slice(2, i - 1);
                        ("0002" !== n.toString("hex") && !r || "0001" !== n.toString("hex") && r) && s++;
                        o.length < 8 && s++;
                        if (s) throw new Error("decryption error");
                        return t.slice(i);
                    }(0, f, r);
                    if (3 === h) return f;
                    throw new Error("unknown padding");
                };
            },
            {
                "./mgf": 469,
                "./withPublic": 473,
                "./xor": 474,
                "bn.js": 470,
                "browserify-rsa": 209,
                "create-hash": 386,
                "parse-asn1": 459,
                "safe-buffer": 494
            }
        ],
        472: [
            function(e, t, r) {
                "use strict";
                var n = e("parse-asn1"), i = e("randombytes"), s = e("create-hash"), o = e("./mgf"), a = e("./xor"), l = e("bn.js"), c = e("./withPublic"), u = e("browserify-rsa"), h = e("safe-buffer").Buffer;
                t.exports = function(e, t, r) {
                    var f;
                    f = e.padding ? e.padding : r ? 1 : 4;
                    var d, p = n(e);
                    if (4 === f) d = function(e, t) {
                        var r = e.modulus.byteLength(), n = t.length, c = s("sha1").update(h.alloc(0)).digest(), u = c.length, f = 2 * u;
                        if (n > r - f - 2) throw new Error("message too long");
                        var d = h.alloc(r - n - f - 2), p = r - u - 1, m = i(u), b = a(h.concat([
                            c,
                            d,
                            h.alloc(1, 1),
                            t
                        ], p), o(m, p)), g = a(m, o(b, u));
                        return new l(h.concat([
                            h.alloc(1),
                            g,
                            b
                        ], r));
                    }(p, t);
                    else if (1 === f) d = function(e, t, r) {
                        var n, s = t.length, o = e.modulus.byteLength();
                        if (s > o - 11) throw new Error("message too long");
                        n = r ? h.alloc(o - s - 3, 255) : function(e) {
                            var t, r = h.allocUnsafe(e), n = 0, s = i(2 * e), o = 0;
                            for(; n < e;)o === s.length && (s = i(2 * e), o = 0), (t = s[o++]) && (r[n++] = t);
                            return r;
                        }(o - s - 3);
                        return new l(h.concat([
                            h.from([
                                0,
                                r ? 1 : 2
                            ]),
                            n,
                            h.alloc(1),
                            t
                        ], o));
                    }(p, t, r);
                    else {
                        if (3 !== f) throw new Error("unknown padding");
                        if ((d = new l(t)).cmp(p.modulus) >= 0) throw new Error("data too long for modulus");
                    }
                    return r ? u(d, p) : c(d, p);
                };
            },
            {
                "./mgf": 469,
                "./withPublic": 473,
                "./xor": 474,
                "bn.js": 470,
                "browserify-rsa": 209,
                "create-hash": 386,
                "parse-asn1": 459,
                randombytes: 475,
                "safe-buffer": 494
            }
        ],
        473: [
            function(e, t, r) {
                "use strict";
                var n = e("bn.js"), i = e("safe-buffer").Buffer;
                t.exports = function(e, t) {
                    return i.from(e.toRed(n.mont(t.modulus)).redPow(new n(t.publicExponent)).fromRed().toArray());
                };
            },
            {
                "bn.js": 470,
                "safe-buffer": 494
            }
        ],
        474: [
            function(e, t, r) {
                "use strict";
                t.exports = function(e, t) {
                    for(var r = e.length, n = -1; ++n < r;)e[n] ^= t[n];
                    return e;
                };
            },
            {}
        ],
        475: [
            function(e, t, r) {
                (function(r, n) {
                    (function() {
                        "use strict";
                        var i = e("safe-buffer").Buffer, s = n.crypto || n.msCrypto;
                        s && s.getRandomValues ? t.exports = function(e, t) {
                            if (e > 4294967295) throw new RangeError("requested too many random bytes");
                            var n = i.allocUnsafe(e);
                            if (e > 0) {
                                if (e > 65536) for(var o = 0; o < e; o += 65536)s.getRandomValues(n.slice(o, o + 65536));
                                else s.getRandomValues(n);
                            }
                            if ("function" == typeof t) return r.nextTick(function() {
                                t(null, n);
                            });
                            return n;
                        } : t.exports = function() {
                            throw new Error("Secure random number generation is not supported by this browser.\nUse Chrome, Firefox or Internet Explorer 11");
                        };
                    }).call(this);
                }).call(this, e("_process"), "undefined" != typeof $parcel$global ? $parcel$global : "undefined" != typeof self ? self : "undefined" != typeof window ? window : {});
            },
            {
                _process: 467,
                "safe-buffer": 494
            }
        ],
        476: [
            function(e, t, r) {
                (function(t, n) {
                    (function() {
                        "use strict";
                        function i() {
                            throw new Error("secure random number generation not supported by this browser\nuse chrome, FireFox or Internet Explorer 11");
                        }
                        var s = e("safe-buffer"), o = e("randombytes"), a = s.Buffer, l = s.kMaxLength, c = n.crypto || n.msCrypto, u = Math.pow(2, 32) - 1;
                        function h(e, t) {
                            if ("number" != typeof e || e != e) throw new TypeError("offset must be a number");
                            if (e > u || e < 0) throw new TypeError("offset must be a uint32");
                            if (e > l || e > t) throw new RangeError("offset out of range");
                        }
                        function f(e, t, r) {
                            if ("number" != typeof e || e != e) throw new TypeError("size must be a number");
                            if (e > u || e < 0) throw new TypeError("size must be a uint32");
                            if (e + t > r || e > l) throw new RangeError("buffer too small");
                        }
                        function d(e, r, n, i) {
                            if (t.browser) {
                                var s = e.buffer, a = new Uint8Array(s, r, n);
                                return c.getRandomValues(a), i ? void t.nextTick(function() {
                                    i(null, e);
                                }) : e;
                            }
                            if (!i) return o(n).copy(e, r), e;
                            o(n, function(t, n) {
                                if (t) return i(t);
                                n.copy(e, r), i(null, e);
                            });
                        }
                        c && c.getRandomValues || !t.browser ? (r.randomFill = function(e, t, r, i) {
                            if (!(a.isBuffer(e) || e instanceof n.Uint8Array)) throw new TypeError('"buf" argument must be a Buffer or Uint8Array');
                            if ("function" == typeof t) i = t, t = 0, r = e.length;
                            else if ("function" == typeof r) i = r, r = e.length - t;
                            else if ("function" != typeof i) throw new TypeError('"cb" argument must be a function');
                            return h(t, e.length), f(r, t, e.length), d(e, t, r, i);
                        }, r.randomFillSync = function(e, t, r) {
                            void 0 === t && (t = 0);
                            if (!(a.isBuffer(e) || e instanceof n.Uint8Array)) throw new TypeError('"buf" argument must be a Buffer or Uint8Array');
                            h(t, e.length), void 0 === r && (r = e.length - t);
                            return f(r, t, e.length), d(e, t, r);
                        }) : (r.randomFill = i, r.randomFillSync = i);
                    }).call(this);
                }).call(this, e("_process"), "undefined" != typeof $parcel$global ? $parcel$global : "undefined" != typeof self ? self : "undefined" != typeof window ? window : {});
            },
            {
                _process: 467,
                randombytes: 475,
                "safe-buffer": 494
            }
        ],
        477: [
            function(e, t, r) {
                "use strict";
                var n = {};
                function i(e, t, r) {
                    r || (r = Error);
                    var i = function(e) {
                        var r, n;
                        function i(r, n, i) {
                            return e.call(this, function(e, r, n) {
                                return "string" == typeof t ? t : t(e, r, n);
                            }(r, n, i)) || this;
                        }
                        return n = e, (r = i).prototype = Object.create(n.prototype), r.prototype.constructor = r, r.__proto__ = n, i;
                    }(r);
                    i.prototype.name = r.name, i.prototype.code = e, n[e] = i;
                }
                function s(e, t) {
                    if (Array.isArray(e)) {
                        var r = e.length;
                        return e = e.map(function(e) {
                            return String(e);
                        }), r > 2 ? "one of ".concat(t, " ").concat(e.slice(0, r - 1).join(", "), ", or ") + e[r - 1] : 2 === r ? "one of ".concat(t, " ").concat(e[0], " or ").concat(e[1]) : "of ".concat(t, " ").concat(e[0]);
                    }
                    return "of ".concat(t, " ").concat(String(e));
                }
                i("ERR_INVALID_OPT_VALUE", function(e, t) {
                    return 'The value "' + t + '" is invalid for option "' + e + '"';
                }, TypeError), i("ERR_INVALID_ARG_TYPE", function(e, t, r) {
                    var n, i, o, a;
                    if ("string" == typeof t && (i = "not ", t.substr(!o || o < 0 ? 0 : +o, i.length) === i) ? (n = "must not be", t = t.replace(/^not /, "")) : n = "must be", function(e, t, r) {
                        return (void 0 === r || r > e.length) && (r = e.length), e.substring(r - t.length, r) === t;
                    }(e, " argument")) a = "The ".concat(e, " ").concat(n, " ").concat(s(t, "type"));
                    else {
                        var l = function(e, t, r) {
                            return "number" != typeof r && (r = 0), !(r + t.length > e.length) && -1 !== e.indexOf(t, r);
                        }(e, ".") ? "property" : "argument";
                        a = 'The "'.concat(e, '" ').concat(l, " ").concat(n, " ").concat(s(t, "type"));
                    }
                    return a += ". Received type ".concat(typeof r);
                }, TypeError), i("ERR_STREAM_PUSH_AFTER_EOF", "stream.push() after EOF"), i("ERR_METHOD_NOT_IMPLEMENTED", function(e) {
                    return "The " + e + " method is not implemented";
                }), i("ERR_STREAM_PREMATURE_CLOSE", "Premature close"), i("ERR_STREAM_DESTROYED", function(e) {
                    return "Cannot call " + e + " after a stream was destroyed";
                }), i("ERR_MULTIPLE_CALLBACK", "Callback called multiple times"), i("ERR_STREAM_CANNOT_PIPE", "Cannot pipe, not readable"), i("ERR_STREAM_WRITE_AFTER_END", "write after end"), i("ERR_STREAM_NULL_VALUES", "May not write null values to stream", TypeError), i("ERR_UNKNOWN_ENCODING", function(e) {
                    return "Unknown encoding: " + e;
                }, TypeError), i("ERR_STREAM_UNSHIFT_AFTER_END_EVENT", "stream.unshift() after end event"), t.exports.codes = n;
            },
            {}
        ],
        478: [
            function(e, t, r) {
                (function(r) {
                    (function() {
                        "use strict";
                        var n = Object.keys || function(e) {
                            var t = [];
                            for(var r in e)t.push(r);
                            return t;
                        };
                        t.exports = c;
                        var i = e("./_stream_readable"), s = e("./_stream_writable");
                        e("inherits")(c, i);
                        for(var o = n(s.prototype), a = 0; a < o.length; a++){
                            var l = o[a];
                            c.prototype[l] || (c.prototype[l] = s.prototype[l]);
                        }
                        function c(e) {
                            if (!(this instanceof c)) return new c(e);
                            i.call(this, e), s.call(this, e), this.allowHalfOpen = !0, e && (!1 === e.readable && (this.readable = !1), !1 === e.writable && (this.writable = !1), !1 === e.allowHalfOpen && (this.allowHalfOpen = !1, this.once("end", u)));
                        }
                        function u() {
                            this._writableState.ended || r.nextTick(h, this);
                        }
                        function h(e) {
                            e.end();
                        }
                        Object.defineProperty(c.prototype, "writableHighWaterMark", {
                            enumerable: !1,
                            get: function() {
                                return this._writableState.highWaterMark;
                            }
                        }), Object.defineProperty(c.prototype, "writableBuffer", {
                            enumerable: !1,
                            get: function() {
                                return this._writableState && this._writableState.getBuffer();
                            }
                        }), Object.defineProperty(c.prototype, "writableLength", {
                            enumerable: !1,
                            get: function() {
                                return this._writableState.length;
                            }
                        }), Object.defineProperty(c.prototype, "destroyed", {
                            enumerable: !1,
                            get: function() {
                                return void 0 !== this._readableState && void 0 !== this._writableState && this._readableState.destroyed && this._writableState.destroyed;
                            },
                            set: function(e) {
                                void 0 !== this._readableState && void 0 !== this._writableState && (this._readableState.destroyed = e, this._writableState.destroyed = e);
                            }
                        });
                    }).call(this);
                }).call(this, e("_process"));
            },
            {
                "./_stream_readable": 480,
                "./_stream_writable": 482,
                _process: 467,
                inherits: 440
            }
        ],
        479: [
            function(e, t, r) {
                "use strict";
                t.exports = i;
                var n = e("./_stream_transform");
                function i(e) {
                    if (!(this instanceof i)) return new i(e);
                    n.call(this, e);
                }
                e("inherits")(i, n), i.prototype._transform = function(e, t, r) {
                    r(null, e);
                };
            },
            {
                "./_stream_transform": 481,
                inherits: 440
            }
        ],
        480: [
            function(e, t, r) {
                (function(r, n) {
                    (function() {
                        "use strict";
                        var i;
                        t.exports = M, M.ReadableState = S;
                        e("events").EventEmitter;
                        var s = function(e, t) {
                            return e.listeners(t).length;
                        }, o = e("./internal/streams/stream"), a = e("buffer").Buffer, l = (void 0 !== n ? n : "undefined" != typeof window ? window : "undefined" != typeof self ? self : {}).Uint8Array || function() {};
                        var c, u = e("util");
                        c = u && u.debuglog ? u.debuglog("stream") : function() {};
                        var h, f, d, p = e("./internal/streams/buffer_list"), m = e("./internal/streams/destroy"), b = e("./internal/streams/state").getHighWaterMark, g = e("../errors").codes, y = g.ERR_INVALID_ARG_TYPE, v = g.ERR_STREAM_PUSH_AFTER_EOF, w = g.ERR_METHOD_NOT_IMPLEMENTED, _ = g.ERR_STREAM_UNSHIFT_AFTER_END_EVENT;
                        e("inherits")(M, o);
                        var x = m.errorOrDestroy, k = [
                            "error",
                            "close",
                            "destroy",
                            "pause",
                            "resume"
                        ];
                        function S(t, r, n) {
                            i = i || e("./_stream_duplex"), t = t || {}, "boolean" != typeof n && (n = r instanceof i), this.objectMode = !!t.objectMode, n && (this.objectMode = this.objectMode || !!t.readableObjectMode), this.highWaterMark = b(this, t, "readableHighWaterMark", n), this.buffer = new p, this.length = 0, this.pipes = null, this.pipesCount = 0, this.flowing = null, this.ended = !1, this.endEmitted = !1, this.reading = !1, this.sync = !0, this.needReadable = !1, this.emittedReadable = !1, this.readableListening = !1, this.resumeScheduled = !1, this.paused = !0, this.emitClose = !1 !== t.emitClose, this.autoDestroy = !!t.autoDestroy, this.destroyed = !1, this.defaultEncoding = t.defaultEncoding || "utf8", this.awaitDrain = 0, this.readingMore = !1, this.decoder = null, this.encoding = null, t.encoding && (h || (h = e("string_decoder/").StringDecoder), this.decoder = new h(t.encoding), this.encoding = t.encoding);
                        }
                        function M(t) {
                            if (i = i || e("./_stream_duplex"), !(this instanceof M)) return new M(t);
                            var r = this instanceof i;
                            this._readableState = new S(t, this, r), this.readable = !0, t && ("function" == typeof t.read && (this._read = t.read), "function" == typeof t.destroy && (this._destroy = t.destroy)), o.call(this);
                        }
                        function C(e, t, r, n, i) {
                            c("readableAddChunk", t);
                            var s, o = e._readableState;
                            if (null === t) o.reading = !1, function(e, t) {
                                if (c("onEofChunk"), t.ended) return;
                                if (t.decoder) {
                                    var r = t.decoder.end();
                                    r && r.length && (t.buffer.push(r), t.length += t.objectMode ? 1 : r.length);
                                }
                                t.ended = !0, t.sync ? A(e) : (t.needReadable = !1, t.emittedReadable || (t.emittedReadable = !0, R(e)));
                            }(e, o);
                            else if (i || (s = function(e, t) {
                                var r;
                                n = t, a.isBuffer(n) || n instanceof l || "string" == typeof t || void 0 === t || e.objectMode || (r = new y("chunk", [
                                    "string",
                                    "Buffer",
                                    "Uint8Array"
                                ], t));
                                var n;
                                return r;
                            }(o, t)), s) x(e, s);
                            else if (o.objectMode || t && t.length > 0) {
                                if ("string" == typeof t || o.objectMode || Object.getPrototypeOf(t) === a.prototype || (t = function(e) {
                                    return a.from(e);
                                }(t)), n) o.endEmitted ? x(e, new _) : T(e, o, t, !0);
                                else if (o.ended) x(e, new v);
                                else {
                                    if (o.destroyed) return !1;
                                    o.reading = !1, o.decoder && !r ? (t = o.decoder.write(t), o.objectMode || 0 !== t.length ? T(e, o, t, !1) : O(e, o)) : T(e, o, t, !1);
                                }
                            } else n || (o.reading = !1, O(e, o));
                            return !o.ended && (o.length < o.highWaterMark || 0 === o.length);
                        }
                        function T(e, t, r, n) {
                            t.flowing && 0 === t.length && !t.sync ? (t.awaitDrain = 0, e.emit("data", r)) : (t.length += t.objectMode ? 1 : r.length, n ? t.buffer.unshift(r) : t.buffer.push(r), t.needReadable && A(e)), O(e, t);
                        }
                        Object.defineProperty(M.prototype, "destroyed", {
                            enumerable: !1,
                            get: function() {
                                return void 0 !== this._readableState && this._readableState.destroyed;
                            },
                            set: function(e) {
                                this._readableState && (this._readableState.destroyed = e);
                            }
                        }), M.prototype.destroy = m.destroy, M.prototype._undestroy = m.undestroy, M.prototype._destroy = function(e, t) {
                            t(e);
                        }, M.prototype.push = function(e, t) {
                            var r, n = this._readableState;
                            return n.objectMode ? r = !0 : "string" == typeof e && ((t = t || n.defaultEncoding) !== n.encoding && (e = a.from(e, t), t = ""), r = !0), C(this, e, t, !1, r);
                        }, M.prototype.unshift = function(e) {
                            return C(this, e, null, !0, !1);
                        }, M.prototype.isPaused = function() {
                            return !1 === this._readableState.flowing;
                        }, M.prototype.setEncoding = function(t) {
                            h || (h = e("string_decoder/").StringDecoder);
                            var r = new h(t);
                            this._readableState.decoder = r, this._readableState.encoding = this._readableState.decoder.encoding;
                            for(var n = this._readableState.buffer.head, i = ""; null !== n;)i += r.write(n.data), n = n.next;
                            return this._readableState.buffer.clear(), "" !== i && this._readableState.buffer.push(i), this._readableState.length = i.length, this;
                        };
                        function E(e, t) {
                            return e <= 0 || 0 === t.length && t.ended ? 0 : t.objectMode ? 1 : e != e ? t.flowing && t.length ? t.buffer.head.data.length : t.length : (e > t.highWaterMark && (t.highWaterMark = function(e) {
                                return e >= 1073741824 ? e = 1073741824 : (e--, e |= e >>> 1, e |= e >>> 2, e |= e >>> 4, e |= e >>> 8, e |= e >>> 16, e++), e;
                            }(e)), e <= t.length ? e : t.ended ? t.length : (t.needReadable = !0, 0));
                        }
                        function A(e) {
                            var t = e._readableState;
                            c("emitReadable", t.needReadable, t.emittedReadable), t.needReadable = !1, t.emittedReadable || (c("emitReadable", t.flowing), t.emittedReadable = !0, r.nextTick(R, e));
                        }
                        function R(e) {
                            var t = e._readableState;
                            c("emitReadable_", t.destroyed, t.length, t.ended), t.destroyed || !t.length && !t.ended || (e.emit("readable"), t.emittedReadable = !1), t.needReadable = !t.flowing && !t.ended && t.length <= t.highWaterMark, B(e);
                        }
                        function O(e, t) {
                            t.readingMore || (t.readingMore = !0, r.nextTick(j, e, t));
                        }
                        function j(e, t) {
                            for(; !t.reading && !t.ended && (t.length < t.highWaterMark || t.flowing && 0 === t.length);){
                                var r = t.length;
                                if (c("maybeReadMore read 0"), e.read(0), r === t.length) break;
                            }
                            t.readingMore = !1;
                        }
                        function I(e) {
                            var t = e._readableState;
                            t.readableListening = e.listenerCount("readable") > 0, t.resumeScheduled && !t.paused ? t.flowing = !0 : e.listenerCount("data") > 0 && e.resume();
                        }
                        function N(e) {
                            c("readable nexttick read 0"), e.read(0);
                        }
                        function P(e, t) {
                            c("resume", t.reading), t.reading || e.read(0), t.resumeScheduled = !1, e.emit("resume"), B(e), t.flowing && !t.reading && e.read(0);
                        }
                        function B(e) {
                            var t = e._readableState;
                            for(c("flow", t.flowing); t.flowing && null !== e.read(););
                        }
                        function D(e, t) {
                            var r;
                            return 0 === t.length ? null : (t.objectMode ? r = t.buffer.shift() : !e || e >= t.length ? (r = t.decoder ? t.buffer.join("") : 1 === t.buffer.length ? t.buffer.first() : t.buffer.concat(t.length), t.buffer.clear()) : r = t.buffer.consume(e, t.decoder), r);
                        }
                        function F(e) {
                            var t = e._readableState;
                            c("endReadable", t.endEmitted), t.endEmitted || (t.ended = !0, r.nextTick(L, t, e));
                        }
                        function L(e, t) {
                            if (c("endReadableNT", e.endEmitted, e.length), !e.endEmitted && 0 === e.length && (e.endEmitted = !0, t.readable = !1, t.emit("end"), e.autoDestroy)) {
                                var r = t._writableState;
                                (!r || r.autoDestroy && r.finished) && t.destroy();
                            }
                        }
                        function z(e, t) {
                            for(var r = 0, n = e.length; r < n; r++)if (e[r] === t) return r;
                            return -1;
                        }
                        M.prototype.read = function(e) {
                            c("read", e), e = parseInt(e, 10);
                            var t = this._readableState, r = e;
                            if (0 !== e && (t.emittedReadable = !1), 0 === e && t.needReadable && ((0 !== t.highWaterMark ? t.length >= t.highWaterMark : t.length > 0) || t.ended)) return c("read: emitReadable", t.length, t.ended), 0 === t.length && t.ended ? F(this) : A(this), null;
                            if (0 === (e = E(e, t)) && t.ended) return 0 === t.length && F(this), null;
                            var n, i = t.needReadable;
                            return c("need readable", i), (0 === t.length || t.length - e < t.highWaterMark) && c("length less than watermark", i = !0), t.ended || t.reading ? c("reading or ended", i = !1) : i && (c("do read"), t.reading = !0, t.sync = !0, 0 === t.length && (t.needReadable = !0), this._read(t.highWaterMark), t.sync = !1, t.reading || (e = E(r, t))), null === (n = e > 0 ? D(e, t) : null) ? (t.needReadable = t.length <= t.highWaterMark, e = 0) : (t.length -= e, t.awaitDrain = 0), 0 === t.length && (t.ended || (t.needReadable = !0), r !== e && t.ended && F(this)), null !== n && this.emit("data", n), n;
                        }, M.prototype._read = function(e) {
                            x(this, new w("_read()"));
                        }, M.prototype.pipe = function(e, t) {
                            var n = this, i = this._readableState;
                            switch(i.pipesCount){
                                case 0:
                                    i.pipes = e;
                                    break;
                                case 1:
                                    i.pipes = [
                                        i.pipes,
                                        e
                                    ];
                                    break;
                                default:
                                    i.pipes.push(e);
                            }
                            i.pipesCount += 1, c("pipe count=%d opts=%j", i.pipesCount, t);
                            var o = (!t || !1 !== t.end) && e !== r.stdout && e !== r.stderr ? l : b;
                            function a(t, r) {
                                c("onunpipe"), t === n && r && !1 === r.hasUnpiped && (r.hasUnpiped = !0, c("cleanup"), e.removeListener("close", p), e.removeListener("finish", m), e.removeListener("drain", u), e.removeListener("error", d), e.removeListener("unpipe", a), n.removeListener("end", l), n.removeListener("end", b), n.removeListener("data", f), h = !0, !i.awaitDrain || e._writableState && !e._writableState.needDrain || u());
                            }
                            function l() {
                                c("onend"), e.end();
                            }
                            i.endEmitted ? r.nextTick(o) : n.once("end", o), e.on("unpipe", a);
                            var u = function(e) {
                                return function() {
                                    var t = e._readableState;
                                    c("pipeOnDrain", t.awaitDrain), t.awaitDrain && t.awaitDrain--, 0 === t.awaitDrain && s(e, "data") && (t.flowing = !0, B(e));
                                };
                            }(n);
                            e.on("drain", u);
                            var h = !1;
                            function f(t) {
                                c("ondata");
                                var r = e.write(t);
                                c("dest.write", r), !1 === r && ((1 === i.pipesCount && i.pipes === e || i.pipesCount > 1 && -1 !== z(i.pipes, e)) && !h && (c("false write response, pause", i.awaitDrain), i.awaitDrain++), n.pause());
                            }
                            function d(t) {
                                c("onerror", t), b(), e.removeListener("error", d), 0 === s(e, "error") && x(e, t);
                            }
                            function p() {
                                e.removeListener("finish", m), b();
                            }
                            function m() {
                                c("onfinish"), e.removeListener("close", p), b();
                            }
                            function b() {
                                c("unpipe"), n.unpipe(e);
                            }
                            return n.on("data", f), function(e, t, r) {
                                if ("function" == typeof e.prependListener) return e.prependListener(t, r);
                                e._events && e._events[t] ? Array.isArray(e._events[t]) ? e._events[t].unshift(r) : e._events[t] = [
                                    r,
                                    e._events[t]
                                ] : e.on(t, r);
                            }(e, "error", d), e.once("close", p), e.once("finish", m), e.emit("pipe", n), i.flowing || (c("pipe resume"), n.resume()), e;
                        }, M.prototype.unpipe = function(e) {
                            var t = this._readableState, r = {
                                hasUnpiped: !1
                            };
                            if (0 === t.pipesCount) return this;
                            if (1 === t.pipesCount) return e && e !== t.pipes || (e || (e = t.pipes), t.pipes = null, t.pipesCount = 0, t.flowing = !1, e && e.emit("unpipe", this, r)), this;
                            if (!e) {
                                var n = t.pipes, i = t.pipesCount;
                                t.pipes = null, t.pipesCount = 0, t.flowing = !1;
                                for(var s = 0; s < i; s++)n[s].emit("unpipe", this, {
                                    hasUnpiped: !1
                                });
                                return this;
                            }
                            var o = z(t.pipes, e);
                            return -1 === o || (t.pipes.splice(o, 1), t.pipesCount -= 1, 1 === t.pipesCount && (t.pipes = t.pipes[0]), e.emit("unpipe", this, r)), this;
                        }, M.prototype.on = function(e, t) {
                            var n = o.prototype.on.call(this, e, t), i = this._readableState;
                            return "data" === e ? (i.readableListening = this.listenerCount("readable") > 0, !1 !== i.flowing && this.resume()) : "readable" === e && (i.endEmitted || i.readableListening || (i.readableListening = i.needReadable = !0, i.flowing = !1, i.emittedReadable = !1, c("on readable", i.length, i.reading), i.length ? A(this) : i.reading || r.nextTick(N, this))), n;
                        }, M.prototype.addListener = M.prototype.on, M.prototype.removeListener = function(e, t) {
                            var n = o.prototype.removeListener.call(this, e, t);
                            return "readable" === e && r.nextTick(I, this), n;
                        }, M.prototype.removeAllListeners = function(e) {
                            var t = o.prototype.removeAllListeners.apply(this, arguments);
                            return "readable" !== e && void 0 !== e || r.nextTick(I, this), t;
                        }, M.prototype.resume = function() {
                            var e = this._readableState;
                            return e.flowing || (c("resume"), e.flowing = !e.readableListening, function(e, t) {
                                t.resumeScheduled || (t.resumeScheduled = !0, r.nextTick(P, e, t));
                            }(this, e)), e.paused = !1, this;
                        }, M.prototype.pause = function() {
                            return c("call pause flowing=%j", this._readableState.flowing), !1 !== this._readableState.flowing && (c("pause"), this._readableState.flowing = !1, this.emit("pause")), this._readableState.paused = !0, this;
                        }, M.prototype.wrap = function(e) {
                            var t = this, r = this._readableState, n = !1;
                            for(var i in e.on("end", function() {
                                if (c("wrapped end"), r.decoder && !r.ended) {
                                    var e = r.decoder.end();
                                    e && e.length && t.push(e);
                                }
                                t.push(null);
                            }), e.on("data", function(i) {
                                (c("wrapped data"), r.decoder && (i = r.decoder.write(i)), r.objectMode && null == i) || (r.objectMode || i && i.length) && (t.push(i) || (n = !0, e.pause()));
                            }), e)void 0 === this[i] && "function" == typeof e[i] && (this[i] = function(t) {
                                return function() {
                                    return e[t].apply(e, arguments);
                                };
                            }(i));
                            for(var s = 0; s < k.length; s++)e.on(k[s], this.emit.bind(this, k[s]));
                            return this._read = function(t) {
                                c("wrapped _read", t), n && (n = !1, e.resume());
                            }, this;
                        }, "function" == typeof Symbol && (M.prototype[Symbol.asyncIterator] = function() {
                            return void 0 === f && (f = e("./internal/streams/async_iterator")), f(this);
                        }), Object.defineProperty(M.prototype, "readableHighWaterMark", {
                            enumerable: !1,
                            get: function() {
                                return this._readableState.highWaterMark;
                            }
                        }), Object.defineProperty(M.prototype, "readableBuffer", {
                            enumerable: !1,
                            get: function() {
                                return this._readableState && this._readableState.buffer;
                            }
                        }), Object.defineProperty(M.prototype, "readableFlowing", {
                            enumerable: !1,
                            get: function() {
                                return this._readableState.flowing;
                            },
                            set: function(e) {
                                this._readableState && (this._readableState.flowing = e);
                            }
                        }), M._fromList = D, Object.defineProperty(M.prototype, "readableLength", {
                            enumerable: !1,
                            get: function() {
                                return this._readableState.length;
                            }
                        }), "function" == typeof Symbol && (M.from = function(t, r) {
                            return void 0 === d && (d = e("./internal/streams/from")), d(M, t, r);
                        });
                    }).call(this);
                }).call(this, e("_process"), "undefined" != typeof $parcel$global ? $parcel$global : "undefined" != typeof self ? self : "undefined" != typeof window ? window : {});
            },
            {
                "../errors": 477,
                "./_stream_duplex": 478,
                "./internal/streams/async_iterator": 483,
                "./internal/streams/buffer_list": 484,
                "./internal/streams/destroy": 485,
                "./internal/streams/from": 487,
                "./internal/streams/state": 489,
                "./internal/streams/stream": 490,
                _process: 467,
                buffer: 220,
                events: 422,
                inherits: 440,
                "string_decoder/": 522,
                util: 188
            }
        ],
        481: [
            function(e, t, r) {
                "use strict";
                t.exports = u;
                var n = e("../errors").codes, i = n.ERR_METHOD_NOT_IMPLEMENTED, s = n.ERR_MULTIPLE_CALLBACK, o = n.ERR_TRANSFORM_ALREADY_TRANSFORMING, a = n.ERR_TRANSFORM_WITH_LENGTH_0, l = e("./_stream_duplex");
                function c(e, t) {
                    var r = this._transformState;
                    r.transforming = !1;
                    var n = r.writecb;
                    if (null === n) return this.emit("error", new s);
                    r.writechunk = null, r.writecb = null, null != t && this.push(t), n(e);
                    var i = this._readableState;
                    i.reading = !1, (i.needReadable || i.length < i.highWaterMark) && this._read(i.highWaterMark);
                }
                function u(e) {
                    if (!(this instanceof u)) return new u(e);
                    l.call(this, e), this._transformState = {
                        afterTransform: c.bind(this),
                        needTransform: !1,
                        transforming: !1,
                        writecb: null,
                        writechunk: null,
                        writeencoding: null
                    }, this._readableState.needReadable = !0, this._readableState.sync = !1, e && ("function" == typeof e.transform && (this._transform = e.transform), "function" == typeof e.flush && (this._flush = e.flush)), this.on("prefinish", h);
                }
                function h() {
                    var e = this;
                    "function" != typeof this._flush || this._readableState.destroyed ? f(this, null, null) : this._flush(function(t, r) {
                        f(e, t, r);
                    });
                }
                function f(e, t, r) {
                    if (t) return e.emit("error", t);
                    if (null != r && e.push(r), e._writableState.length) throw new a;
                    if (e._transformState.transforming) throw new o;
                    return e.push(null);
                }
                e("inherits")(u, l), u.prototype.push = function(e, t) {
                    return this._transformState.needTransform = !1, l.prototype.push.call(this, e, t);
                }, u.prototype._transform = function(e, t, r) {
                    r(new i("_transform()"));
                }, u.prototype._write = function(e, t, r) {
                    var n = this._transformState;
                    if (n.writecb = r, n.writechunk = e, n.writeencoding = t, !n.transforming) {
                        var i = this._readableState;
                        (n.needTransform || i.needReadable || i.length < i.highWaterMark) && this._read(i.highWaterMark);
                    }
                }, u.prototype._read = function(e) {
                    var t = this._transformState;
                    null === t.writechunk || t.transforming ? t.needTransform = !0 : (t.transforming = !0, this._transform(t.writechunk, t.writeencoding, t.afterTransform));
                }, u.prototype._destroy = function(e, t) {
                    l.prototype._destroy.call(this, e, function(e) {
                        t(e);
                    });
                };
            },
            {
                "../errors": 477,
                "./_stream_duplex": 478,
                inherits: 440
            }
        ],
        482: [
            function(e, t, r) {
                (function(r, n) {
                    (function() {
                        "use strict";
                        function i(e) {
                            var t = this;
                            this.next = null, this.entry = null, this.finish = function() {
                                !function(e, t, r) {
                                    var n = e.entry;
                                    e.entry = null;
                                    for(; n;){
                                        var i = n.callback;
                                        t.pendingcb--, i(r), n = n.next;
                                    }
                                    t.corkedRequestsFree.next = e;
                                }(t, e);
                            };
                        }
                        var s;
                        t.exports = M, M.WritableState = S;
                        var o = {
                            deprecate: e("util-deprecate")
                        }, a = e("./internal/streams/stream"), l = e("buffer").Buffer, c = (void 0 !== n ? n : "undefined" != typeof window ? window : "undefined" != typeof self ? self : {}).Uint8Array || function() {};
                        var u, h = e("./internal/streams/destroy"), f = e("./internal/streams/state").getHighWaterMark, d = e("../errors").codes, p = d.ERR_INVALID_ARG_TYPE, m = d.ERR_METHOD_NOT_IMPLEMENTED, b = d.ERR_MULTIPLE_CALLBACK, g = d.ERR_STREAM_CANNOT_PIPE, y = d.ERR_STREAM_DESTROYED, v = d.ERR_STREAM_NULL_VALUES, w = d.ERR_STREAM_WRITE_AFTER_END, _ = d.ERR_UNKNOWN_ENCODING, x = h.errorOrDestroy;
                        function k() {}
                        function S(t, n, o) {
                            s = s || e("./_stream_duplex"), t = t || {}, "boolean" != typeof o && (o = n instanceof s), this.objectMode = !!t.objectMode, o && (this.objectMode = this.objectMode || !!t.writableObjectMode), this.highWaterMark = f(this, t, "writableHighWaterMark", o), this.finalCalled = !1, this.needDrain = !1, this.ending = !1, this.ended = !1, this.finished = !1, this.destroyed = !1;
                            var a = !1 === t.decodeStrings;
                            this.decodeStrings = !a, this.defaultEncoding = t.defaultEncoding || "utf8", this.length = 0, this.writing = !1, this.corked = 0, this.sync = !0, this.bufferProcessing = !1, this.onwrite = function(e) {
                                !function(e, t) {
                                    var n = e._writableState, i = n.sync, s = n.writecb;
                                    if ("function" != typeof s) throw new b;
                                    if (function(e) {
                                        e.writing = !1, e.writecb = null, e.length -= e.writelen, e.writelen = 0;
                                    }(n), t) !function(e, t, n, i, s) {
                                        --t.pendingcb, n ? (r.nextTick(s, i), r.nextTick(O, e, t), e._writableState.errorEmitted = !0, x(e, i)) : (s(i), e._writableState.errorEmitted = !0, x(e, i), O(e, t));
                                    }(e, n, i, t, s);
                                    else {
                                        var o = A(n) || e.destroyed;
                                        o || n.corked || n.bufferProcessing || !n.bufferedRequest || E(e, n), i ? r.nextTick(T, e, n, o, s) : T(e, n, o, s);
                                    }
                                }(n, e);
                            }, this.writecb = null, this.writelen = 0, this.bufferedRequest = null, this.lastBufferedRequest = null, this.pendingcb = 0, this.prefinished = !1, this.errorEmitted = !1, this.emitClose = !1 !== t.emitClose, this.autoDestroy = !!t.autoDestroy, this.bufferedRequestCount = 0, this.corkedRequestsFree = new i(this);
                        }
                        function M(t) {
                            var r = this instanceof (s = s || e("./_stream_duplex"));
                            if (!r && !u.call(M, this)) return new M(t);
                            this._writableState = new S(t, this, r), this.writable = !0, t && ("function" == typeof t.write && (this._write = t.write), "function" == typeof t.writev && (this._writev = t.writev), "function" == typeof t.destroy && (this._destroy = t.destroy), "function" == typeof t.final && (this._final = t.final)), a.call(this);
                        }
                        function C(e, t, r, n, i, s, o) {
                            t.writelen = n, t.writecb = o, t.writing = !0, t.sync = !0, t.destroyed ? t.onwrite(new y("write")) : r ? e._writev(i, t.onwrite) : e._write(i, s, t.onwrite), t.sync = !1;
                        }
                        function T(e, t, r, n) {
                            r || function(e, t) {
                                0 === t.length && t.needDrain && (t.needDrain = !1, e.emit("drain"));
                            }(e, t), t.pendingcb--, n(), O(e, t);
                        }
                        function E(e, t) {
                            t.bufferProcessing = !0;
                            var r = t.bufferedRequest;
                            if (e._writev && r && r.next) {
                                var n = t.bufferedRequestCount, s = new Array(n), o = t.corkedRequestsFree;
                                o.entry = r;
                                for(var a = 0, l = !0; r;)s[a] = r, r.isBuf || (l = !1), r = r.next, a += 1;
                                s.allBuffers = l, C(e, t, !0, t.length, s, "", o.finish), t.pendingcb++, t.lastBufferedRequest = null, o.next ? (t.corkedRequestsFree = o.next, o.next = null) : t.corkedRequestsFree = new i(t), t.bufferedRequestCount = 0;
                            } else {
                                for(; r;){
                                    var c = r.chunk, u = r.encoding, h = r.callback;
                                    if (C(e, t, !1, t.objectMode ? 1 : c.length, c, u, h), r = r.next, t.bufferedRequestCount--, t.writing) break;
                                }
                                null === r && (t.lastBufferedRequest = null);
                            }
                            t.bufferedRequest = r, t.bufferProcessing = !1;
                        }
                        function A(e) {
                            return e.ending && 0 === e.length && null === e.bufferedRequest && !e.finished && !e.writing;
                        }
                        function R(e, t) {
                            e._final(function(r) {
                                t.pendingcb--, r && x(e, r), t.prefinished = !0, e.emit("prefinish"), O(e, t);
                            });
                        }
                        function O(e, t) {
                            var n = A(t);
                            if (n && (function(e, t) {
                                t.prefinished || t.finalCalled || ("function" != typeof e._final || t.destroyed ? (t.prefinished = !0, e.emit("prefinish")) : (t.pendingcb++, t.finalCalled = !0, r.nextTick(R, e, t)));
                            }(e, t), 0 === t.pendingcb && (t.finished = !0, e.emit("finish"), t.autoDestroy))) {
                                var i = e._readableState;
                                (!i || i.autoDestroy && i.endEmitted) && e.destroy();
                            }
                            return n;
                        }
                        e("inherits")(M, a), S.prototype.getBuffer = function() {
                            for(var e = this.bufferedRequest, t = []; e;)t.push(e), e = e.next;
                            return t;
                        }, function() {
                            try {
                                Object.defineProperty(S.prototype, "buffer", {
                                    get: o.deprecate(function() {
                                        return this.getBuffer();
                                    }, "_writableState.buffer is deprecated. Use _writableState.getBuffer instead.", "DEP0003")
                                });
                            } catch (e) {}
                        }(), "function" == typeof Symbol && Symbol.hasInstance && "function" == typeof Function.prototype[Symbol.hasInstance] ? (u = Function.prototype[Symbol.hasInstance], Object.defineProperty(M, Symbol.hasInstance, {
                            value: function(e) {
                                return !!u.call(this, e) || this === M && e && e._writableState instanceof S;
                            }
                        })) : u = function(e) {
                            return e instanceof this;
                        }, M.prototype.pipe = function() {
                            x(this, new g);
                        }, M.prototype.write = function(e, t, n) {
                            var i, s = this._writableState, o = !1, a = !s.objectMode && (i = e, l.isBuffer(i) || i instanceof c);
                            return a && !l.isBuffer(e) && (e = function(e) {
                                return l.from(e);
                            }(e)), "function" == typeof t && (n = t, t = null), a ? t = "buffer" : t || (t = s.defaultEncoding), "function" != typeof n && (n = k), s.ending ? function(e, t) {
                                var n = new w;
                                x(e, n), r.nextTick(t, n);
                            }(this, n) : (a || function(e, t, n, i) {
                                var s;
                                return null === n ? s = new v : "string" == typeof n || t.objectMode || (s = new p("chunk", [
                                    "string",
                                    "Buffer"
                                ], n)), !s || (x(e, s), r.nextTick(i, s), !1);
                            }(this, s, e, n)) && (s.pendingcb++, o = function(e, t, r, n, i, s) {
                                if (!r) {
                                    var o = function(e, t, r) {
                                        e.objectMode || !1 === e.decodeStrings || "string" != typeof t || (t = l.from(t, r));
                                        return t;
                                    }(t, n, i);
                                    n !== o && (r = !0, i = "buffer", n = o);
                                }
                                var a = t.objectMode ? 1 : n.length;
                                t.length += a;
                                var c = t.length < t.highWaterMark;
                                c || (t.needDrain = !0);
                                if (t.writing || t.corked) {
                                    var u = t.lastBufferedRequest;
                                    t.lastBufferedRequest = {
                                        chunk: n,
                                        encoding: i,
                                        isBuf: r,
                                        callback: s,
                                        next: null
                                    }, u ? u.next = t.lastBufferedRequest : t.bufferedRequest = t.lastBufferedRequest, t.bufferedRequestCount += 1;
                                } else C(e, t, !1, a, n, i, s);
                                return c;
                            }(this, s, a, e, t, n)), o;
                        }, M.prototype.cork = function() {
                            this._writableState.corked++;
                        }, M.prototype.uncork = function() {
                            var e = this._writableState;
                            e.corked && (e.corked--, e.writing || e.corked || e.bufferProcessing || !e.bufferedRequest || E(this, e));
                        }, M.prototype.setDefaultEncoding = function(e) {
                            if ("string" == typeof e && (e = e.toLowerCase()), !([
                                "hex",
                                "utf8",
                                "utf-8",
                                "ascii",
                                "binary",
                                "base64",
                                "ucs2",
                                "ucs-2",
                                "utf16le",
                                "utf-16le",
                                "raw"
                            ].indexOf((e + "").toLowerCase()) > -1)) throw new _(e);
                            return this._writableState.defaultEncoding = e, this;
                        }, Object.defineProperty(M.prototype, "writableBuffer", {
                            enumerable: !1,
                            get: function() {
                                return this._writableState && this._writableState.getBuffer();
                            }
                        }), Object.defineProperty(M.prototype, "writableHighWaterMark", {
                            enumerable: !1,
                            get: function() {
                                return this._writableState.highWaterMark;
                            }
                        }), M.prototype._write = function(e, t, r) {
                            r(new m("_write()"));
                        }, M.prototype._writev = null, M.prototype.end = function(e, t, n) {
                            var i = this._writableState;
                            return "function" == typeof e ? (n = e, e = null, t = null) : "function" == typeof t && (n = t, t = null), null != e && this.write(e, t), i.corked && (i.corked = 1, this.uncork()), i.ending || function(e, t, n) {
                                t.ending = !0, O(e, t), n && (t.finished ? r.nextTick(n) : e.once("finish", n));
                                t.ended = !0, e.writable = !1;
                            }(this, i, n), this;
                        }, Object.defineProperty(M.prototype, "writableLength", {
                            enumerable: !1,
                            get: function() {
                                return this._writableState.length;
                            }
                        }), Object.defineProperty(M.prototype, "destroyed", {
                            enumerable: !1,
                            get: function() {
                                return void 0 !== this._writableState && this._writableState.destroyed;
                            },
                            set: function(e) {
                                this._writableState && (this._writableState.destroyed = e);
                            }
                        }), M.prototype.destroy = h.destroy, M.prototype._undestroy = h.undestroy, M.prototype._destroy = function(e, t) {
                            t(e);
                        };
                    }).call(this);
                }).call(this, e("_process"), "undefined" != typeof $parcel$global ? $parcel$global : "undefined" != typeof self ? self : "undefined" != typeof window ? window : {});
            },
            {
                "../errors": 477,
                "./_stream_duplex": 478,
                "./internal/streams/destroy": 485,
                "./internal/streams/state": 489,
                "./internal/streams/stream": 490,
                _process: 467,
                buffer: 220,
                inherits: 440,
                "util-deprecate": 524
            }
        ],
        483: [
            function(e, t, r) {
                (function(r) {
                    (function() {
                        "use strict";
                        var n;
                        function i(e, t, r) {
                            return (t = function(e) {
                                var t = function(e, t) {
                                    if ("object" != typeof e || null === e) return e;
                                    var r = e[Symbol.toPrimitive];
                                    if (void 0 !== r) {
                                        var n = r.call(e, t || "default");
                                        if ("object" != typeof n) return n;
                                        throw new TypeError("@@toPrimitive must return a primitive value.");
                                    }
                                    return ("string" === t ? String : Number)(e);
                                }(e, "string");
                                return "symbol" == typeof t ? t : String(t);
                            }(t)) in e ? Object.defineProperty(e, t, {
                                value: r,
                                enumerable: !0,
                                configurable: !0,
                                writable: !0
                            }) : e[t] = r, e;
                        }
                        var s = e("./end-of-stream"), o = Symbol("lastResolve"), a = Symbol("lastReject"), l = Symbol("error"), c = Symbol("ended"), u = Symbol("lastPromise"), h = Symbol("handlePromise"), f = Symbol("stream");
                        function d(e, t) {
                            return {
                                value: e,
                                done: t
                            };
                        }
                        function p(e) {
                            var t = e[o];
                            if (null !== t) {
                                var r = e[f].read();
                                null !== r && (e[u] = null, e[o] = null, e[a] = null, t(d(r, !1)));
                            }
                        }
                        function m(e) {
                            r.nextTick(p, e);
                        }
                        var b = Object.getPrototypeOf(function() {}), g = Object.setPrototypeOf((i(n = {
                            get stream () {
                                return this[f];
                            },
                            next: function() {
                                var e = this, t = this[l];
                                if (null !== t) return Promise.reject(t);
                                if (this[c]) return Promise.resolve(d(void 0, !0));
                                if (this[f].destroyed) return new Promise(function(t, n) {
                                    r.nextTick(function() {
                                        e[l] ? n(e[l]) : t(d(void 0, !0));
                                    });
                                });
                                var n, i = this[u];
                                if (i) n = new Promise(function(e, t) {
                                    return function(r, n) {
                                        e.then(function() {
                                            t[c] ? r(d(void 0, !0)) : t[h](r, n);
                                        }, n);
                                    };
                                }(i, this));
                                else {
                                    var s = this[f].read();
                                    if (null !== s) return Promise.resolve(d(s, !1));
                                    n = new Promise(this[h]);
                                }
                                return this[u] = n, n;
                            }
                        }, Symbol.asyncIterator, function() {
                            return this;
                        }), i(n, "return", function() {
                            var e = this;
                            return new Promise(function(t, r) {
                                e[f].destroy(null, function(e) {
                                    e ? r(e) : t(d(void 0, !0));
                                });
                            });
                        }), n), b);
                        t.exports = function(e) {
                            var t, r = Object.create(g, (i(t = {}, f, {
                                value: e,
                                writable: !0
                            }), i(t, o, {
                                value: null,
                                writable: !0
                            }), i(t, a, {
                                value: null,
                                writable: !0
                            }), i(t, l, {
                                value: null,
                                writable: !0
                            }), i(t, c, {
                                value: e._readableState.endEmitted,
                                writable: !0
                            }), i(t, h, {
                                value: function(e, t) {
                                    var n = r[f].read();
                                    n ? (r[u] = null, r[o] = null, r[a] = null, e(d(n, !1))) : (r[o] = e, r[a] = t);
                                },
                                writable: !0
                            }), t));
                            return r[u] = null, s(e, function(e) {
                                if (e && "ERR_STREAM_PREMATURE_CLOSE" !== e.code) {
                                    var t = r[a];
                                    return null !== t && (r[u] = null, r[o] = null, r[a] = null, t(e)), void (r[l] = e);
                                }
                                var n = r[o];
                                null !== n && (r[u] = null, r[o] = null, r[a] = null, n(d(void 0, !0))), r[c] = !0;
                            }), e.on("readable", m.bind(null, r)), r;
                        };
                    }).call(this);
                }).call(this, e("_process"));
            },
            {
                "./end-of-stream": 486,
                _process: 467
            }
        ],
        484: [
            function(e, t, r) {
                "use strict";
                function n(e, t) {
                    var r = Object.keys(e);
                    if (Object.getOwnPropertySymbols) {
                        var n = Object.getOwnPropertySymbols(e);
                        t && (n = n.filter(function(t) {
                            return Object.getOwnPropertyDescriptor(e, t).enumerable;
                        })), r.push.apply(r, n);
                    }
                    return r;
                }
                function i(e) {
                    for(var t = 1; t < arguments.length; t++){
                        var r = null != arguments[t] ? arguments[t] : {};
                        t % 2 ? n(Object(r), !0).forEach(function(t) {
                            s(e, t, r[t]);
                        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : n(Object(r)).forEach(function(t) {
                            Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
                        });
                    }
                    return e;
                }
                function s(e, t, r) {
                    return (t = a(t)) in e ? Object.defineProperty(e, t, {
                        value: r,
                        enumerable: !0,
                        configurable: !0,
                        writable: !0
                    }) : e[t] = r, e;
                }
                function o(e, t) {
                    for(var r = 0; r < t.length; r++){
                        var n = t[r];
                        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, a(n.key), n);
                    }
                }
                function a(e) {
                    var t = function(e, t) {
                        if ("object" != typeof e || null === e) return e;
                        var r = e[Symbol.toPrimitive];
                        if (void 0 !== r) {
                            var n = r.call(e, t || "default");
                            if ("object" != typeof n) return n;
                            throw new TypeError("@@toPrimitive must return a primitive value.");
                        }
                        return ("string" === t ? String : Number)(e);
                    }(e, "string");
                    return "symbol" == typeof t ? t : String(t);
                }
                var l = e("buffer").Buffer, c = e("util").inspect, u = c && c.custom || "inspect";
                t.exports = function() {
                    function e() {
                        !function(e, t) {
                            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                        }(this, e), this.head = null, this.tail = null, this.length = 0;
                    }
                    var t, r, n;
                    return t = e, r = [
                        {
                            key: "push",
                            value: function(e) {
                                var t = {
                                    data: e,
                                    next: null
                                };
                                this.length > 0 ? this.tail.next = t : this.head = t, this.tail = t, ++this.length;
                            }
                        },
                        {
                            key: "unshift",
                            value: function(e) {
                                var t = {
                                    data: e,
                                    next: this.head
                                };
                                0 === this.length && (this.tail = t), this.head = t, ++this.length;
                            }
                        },
                        {
                            key: "shift",
                            value: function() {
                                if (0 !== this.length) {
                                    var e = this.head.data;
                                    return 1 === this.length ? this.head = this.tail = null : this.head = this.head.next, --this.length, e;
                                }
                            }
                        },
                        {
                            key: "clear",
                            value: function() {
                                this.head = this.tail = null, this.length = 0;
                            }
                        },
                        {
                            key: "join",
                            value: function(e) {
                                if (0 === this.length) return "";
                                for(var t = this.head, r = "" + t.data; t = t.next;)r += e + t.data;
                                return r;
                            }
                        },
                        {
                            key: "concat",
                            value: function(e) {
                                if (0 === this.length) return l.alloc(0);
                                for(var t, r, n, i = l.allocUnsafe(e >>> 0), s = this.head, o = 0; s;)t = s.data, r = i, n = o, l.prototype.copy.call(t, r, n), o += s.data.length, s = s.next;
                                return i;
                            }
                        },
                        {
                            key: "consume",
                            value: function(e, t) {
                                var r;
                                return e < this.head.data.length ? (r = this.head.data.slice(0, e), this.head.data = this.head.data.slice(e)) : r = e === this.head.data.length ? this.shift() : t ? this._getString(e) : this._getBuffer(e), r;
                            }
                        },
                        {
                            key: "first",
                            value: function() {
                                return this.head.data;
                            }
                        },
                        {
                            key: "_getString",
                            value: function(e) {
                                var t = this.head, r = 1, n = t.data;
                                for(e -= n.length; t = t.next;){
                                    var i = t.data, s = e > i.length ? i.length : e;
                                    if (s === i.length ? n += i : n += i.slice(0, e), 0 == (e -= s)) {
                                        s === i.length ? (++r, t.next ? this.head = t.next : this.head = this.tail = null) : (this.head = t, t.data = i.slice(s));
                                        break;
                                    }
                                    ++r;
                                }
                                return this.length -= r, n;
                            }
                        },
                        {
                            key: "_getBuffer",
                            value: function(e) {
                                var t = l.allocUnsafe(e), r = this.head, n = 1;
                                for(r.data.copy(t), e -= r.data.length; r = r.next;){
                                    var i = r.data, s = e > i.length ? i.length : e;
                                    if (i.copy(t, t.length - e, 0, s), 0 == (e -= s)) {
                                        s === i.length ? (++n, r.next ? this.head = r.next : this.head = this.tail = null) : (this.head = r, r.data = i.slice(s));
                                        break;
                                    }
                                    ++n;
                                }
                                return this.length -= n, t;
                            }
                        },
                        {
                            key: u,
                            value: function(e, t) {
                                return c(this, i(i({}, t), {}, {
                                    depth: 0,
                                    customInspect: !1
                                }));
                            }
                        }
                    ], o(t.prototype, r), n && o(t, n), Object.defineProperty(t, "prototype", {
                        writable: !1
                    }), e;
                }();
            },
            {
                buffer: 220,
                util: 188
            }
        ],
        485: [
            function(e, t, r) {
                (function(e) {
                    (function() {
                        "use strict";
                        function r(e, t) {
                            i(e, t), n(e);
                        }
                        function n(e) {
                            e._writableState && !e._writableState.emitClose || e._readableState && !e._readableState.emitClose || e.emit("close");
                        }
                        function i(e, t) {
                            e.emit("error", t);
                        }
                        t.exports = {
                            destroy: function(t, s) {
                                var o = this, a = this._readableState && this._readableState.destroyed, l = this._writableState && this._writableState.destroyed;
                                return a || l ? (s ? s(t) : t && (this._writableState ? this._writableState.errorEmitted || (this._writableState.errorEmitted = !0, e.nextTick(i, this, t)) : e.nextTick(i, this, t)), this) : (this._readableState && (this._readableState.destroyed = !0), this._writableState && (this._writableState.destroyed = !0), this._destroy(t || null, function(t) {
                                    !s && t ? o._writableState ? o._writableState.errorEmitted ? e.nextTick(n, o) : (o._writableState.errorEmitted = !0, e.nextTick(r, o, t)) : e.nextTick(r, o, t) : s ? (e.nextTick(n, o), s(t)) : e.nextTick(n, o);
                                }), this);
                            },
                            undestroy: function() {
                                this._readableState && (this._readableState.destroyed = !1, this._readableState.reading = !1, this._readableState.ended = !1, this._readableState.endEmitted = !1), this._writableState && (this._writableState.destroyed = !1, this._writableState.ended = !1, this._writableState.ending = !1, this._writableState.finalCalled = !1, this._writableState.prefinished = !1, this._writableState.finished = !1, this._writableState.errorEmitted = !1);
                            },
                            errorOrDestroy: function(e, t) {
                                var r = e._readableState, n = e._writableState;
                                r && r.autoDestroy || n && n.autoDestroy ? e.destroy(t) : e.emit("error", t);
                            }
                        };
                    }).call(this);
                }).call(this, e("_process"));
            },
            {
                _process: 467
            }
        ],
        486: [
            function(e, t, r) {
                "use strict";
                var n = e("../../../errors").codes.ERR_STREAM_PREMATURE_CLOSE;
                function i() {}
                t.exports = function e(t, r, s) {
                    if ("function" == typeof r) return e(t, null, r);
                    r || (r = {}), s = function(e) {
                        var t = !1;
                        return function() {
                            if (!t) {
                                t = !0;
                                for(var r = arguments.length, n = new Array(r), i = 0; i < r; i++)n[i] = arguments[i];
                                e.apply(this, n);
                            }
                        };
                    }(s || i);
                    var o = r.readable || !1 !== r.readable && t.readable, a = r.writable || !1 !== r.writable && t.writable, l = function() {
                        t.writable || u();
                    }, c = t._writableState && t._writableState.finished, u = function() {
                        a = !1, c = !0, o || s.call(t);
                    }, h = t._readableState && t._readableState.endEmitted, f = function() {
                        o = !1, h = !0, a || s.call(t);
                    }, d = function(e) {
                        s.call(t, e);
                    }, p = function() {
                        var e;
                        return o && !h ? (t._readableState && t._readableState.ended || (e = new n), s.call(t, e)) : a && !c ? (t._writableState && t._writableState.ended || (e = new n), s.call(t, e)) : void 0;
                    }, m = function() {
                        t.req.on("finish", u);
                    };
                    return !function(e) {
                        return e.setHeader && "function" == typeof e.abort;
                    }(t) ? a && !t._writableState && (t.on("end", l), t.on("close", l)) : (t.on("complete", u), t.on("abort", p), t.req ? m() : t.on("request", m)), t.on("end", f), t.on("finish", u), !1 !== r.error && t.on("error", d), t.on("close", p), function() {
                        t.removeListener("complete", u), t.removeListener("abort", p), t.removeListener("request", m), t.req && t.req.removeListener("finish", u), t.removeListener("end", l), t.removeListener("close", l), t.removeListener("finish", u), t.removeListener("end", f), t.removeListener("error", d), t.removeListener("close", p);
                    };
                };
            },
            {
                "../../../errors": 477
            }
        ],
        487: [
            function(e, t, r) {
                "use strict";
                t.exports = function() {
                    throw new Error("Readable.from is not available in the browser");
                };
            },
            {}
        ],
        488: [
            function(e, t, r) {
                "use strict";
                var n;
                var i = e("../../../errors").codes, s = i.ERR_MISSING_ARGS, o = i.ERR_STREAM_DESTROYED;
                function a(e) {
                    if (e) throw e;
                }
                function l(t, r, i, s) {
                    s = function(e) {
                        var t = !1;
                        return function() {
                            t || (t = !0, e.apply(void 0, arguments));
                        };
                    }(s);
                    var a = !1;
                    t.on("close", function() {
                        a = !0;
                    }), void 0 === n && (n = e("./end-of-stream")), n(t, {
                        readable: r,
                        writable: i
                    }, function(e) {
                        if (e) return s(e);
                        a = !0, s();
                    });
                    var l = !1;
                    return function(e) {
                        if (!a && !l) return l = !0, function(e) {
                            return e.setHeader && "function" == typeof e.abort;
                        }(t) ? t.abort() : "function" == typeof t.destroy ? t.destroy() : void s(e || new o("pipe"));
                    };
                }
                function c(e) {
                    e();
                }
                function u(e, t) {
                    return e.pipe(t);
                }
                function h(e) {
                    return e.length ? "function" != typeof e[e.length - 1] ? a : e.pop() : a;
                }
                t.exports = function() {
                    for(var e = arguments.length, t = new Array(e), r = 0; r < e; r++)t[r] = arguments[r];
                    var n, i = h(t);
                    if (Array.isArray(t[0]) && (t = t[0]), t.length < 2) throw new s("streams");
                    var o = t.map(function(e, r) {
                        var s = r < t.length - 1;
                        return l(e, s, r > 0, function(e) {
                            n || (n = e), e && o.forEach(c), s || (o.forEach(c), i(n));
                        });
                    });
                    return t.reduce(u);
                };
            },
            {
                "../../../errors": 477,
                "./end-of-stream": 486
            }
        ],
        489: [
            function(e, t, r) {
                "use strict";
                var n = e("../../../errors").codes.ERR_INVALID_OPT_VALUE;
                t.exports = {
                    getHighWaterMark: function(e, t, r, i) {
                        var s = function(e, t, r) {
                            return null != e.highWaterMark ? e.highWaterMark : t ? e[r] : null;
                        }(t, i, r);
                        if (null != s) {
                            if (!isFinite(s) || Math.floor(s) !== s || s < 0) throw new n(i ? r : "highWaterMark", s);
                            return Math.floor(s);
                        }
                        return e.objectMode ? 16 : 16384;
                    }
                };
            },
            {
                "../../../errors": 477
            }
        ],
        490: [
            function(e, t, r) {
                "use strict";
                t.exports = e("events").EventEmitter;
            },
            {
                events: 422
            }
        ],
        491: [
            function(e, t, r) {
                "use strict";
                (r = t.exports = e("./lib/_stream_readable.js")).Stream = r, r.Readable = r, r.Writable = e("./lib/_stream_writable.js"), r.Duplex = e("./lib/_stream_duplex.js"), r.Transform = e("./lib/_stream_transform.js"), r.PassThrough = e("./lib/_stream_passthrough.js"), r.finished = e("./lib/internal/streams/end-of-stream.js"), r.pipeline = e("./lib/internal/streams/pipeline.js");
            },
            {
                "./lib/_stream_duplex.js": 478,
                "./lib/_stream_passthrough.js": 479,
                "./lib/_stream_readable.js": 480,
                "./lib/_stream_transform.js": 481,
                "./lib/_stream_writable.js": 482,
                "./lib/internal/streams/end-of-stream.js": 486,
                "./lib/internal/streams/pipeline.js": 488
            }
        ],
        492: [
            function(e, t, r) {
                "use strict";
                var n = function(e) {
                    var t = Object.prototype, r = t.hasOwnProperty, n = Object.defineProperty || function(e, t, r) {
                        e[t] = r.value;
                    }, i = "function" == typeof Symbol ? Symbol : {}, s = i.iterator || "@@iterator", o = i.asyncIterator || "@@asyncIterator", a = i.toStringTag || "@@toStringTag";
                    function l(e, t, r) {
                        return Object.defineProperty(e, t, {
                            value: r,
                            enumerable: !0,
                            configurable: !0,
                            writable: !0
                        }), e[t];
                    }
                    try {
                        l({}, "");
                    } catch (e) {
                        l = function(e, t, r) {
                            return e[t] = r;
                        };
                    }
                    function c(e, t, r, i) {
                        var s = t && t.prototype instanceof f ? t : f, o = Object.create(s.prototype), a = new M(i || []);
                        return n(o, "_invoke", {
                            value: _(e, r, a)
                        }), o;
                    }
                    function u(e, t, r) {
                        try {
                            return {
                                type: "normal",
                                arg: e.call(t, r)
                            };
                        } catch (e) {
                            return {
                                type: "throw",
                                arg: e
                            };
                        }
                    }
                    e.wrap = c;
                    var h = {};
                    function f() {}
                    function d() {}
                    function p() {}
                    var m = {};
                    l(m, s, function() {
                        return this;
                    });
                    var b = Object.getPrototypeOf, g = b && b(b(C([])));
                    g && g !== t && r.call(g, s) && (m = g);
                    var y = p.prototype = f.prototype = Object.create(m);
                    function v(e) {
                        [
                            "next",
                            "throw",
                            "return"
                        ].forEach(function(t) {
                            l(e, t, function(e) {
                                return this._invoke(t, e);
                            });
                        });
                    }
                    function w(e, t) {
                        var i;
                        n(this, "_invoke", {
                            value: function(n, s) {
                                function o() {
                                    return new t(function(i, o) {
                                        !function n(i, s, o, a) {
                                            var l = u(e[i], e, s);
                                            if ("throw" !== l.type) {
                                                var c = l.arg, h = c.value;
                                                return h && "object" == typeof h && r.call(h, "__await") ? t.resolve(h.__await).then(function(e) {
                                                    n("next", e, o, a);
                                                }, function(e) {
                                                    n("throw", e, o, a);
                                                }) : t.resolve(h).then(function(e) {
                                                    c.value = e, o(c);
                                                }, function(e) {
                                                    return n("throw", e, o, a);
                                                });
                                            }
                                            a(l.arg);
                                        }(n, s, i, o);
                                    });
                                }
                                return i = i ? i.then(o, o) : o();
                            }
                        });
                    }
                    function _(e, t, r) {
                        var n = "suspendedStart";
                        return function(i, s) {
                            if ("executing" === n) throw new Error("Generator is already running");
                            if ("completed" === n) {
                                if ("throw" === i) throw s;
                                return T();
                            }
                            for(r.method = i, r.arg = s;;){
                                var o = r.delegate;
                                if (o) {
                                    var a = x(o, r);
                                    if (a) {
                                        if (a === h) continue;
                                        return a;
                                    }
                                }
                                if ("next" === r.method) r.sent = r._sent = r.arg;
                                else if ("throw" === r.method) {
                                    if ("suspendedStart" === n) throw n = "completed", r.arg;
                                    r.dispatchException(r.arg);
                                } else "return" === r.method && r.abrupt("return", r.arg);
                                n = "executing";
                                var l = u(e, t, r);
                                if ("normal" === l.type) {
                                    if (n = r.done ? "completed" : "suspendedYield", l.arg === h) continue;
                                    return {
                                        value: l.arg,
                                        done: r.done
                                    };
                                }
                                "throw" === l.type && (n = "completed", r.method = "throw", r.arg = l.arg);
                            }
                        };
                    }
                    function x(e, t) {
                        var r = t.method, n = e.iterator[r];
                        if (void 0 === n) return t.delegate = null, "throw" === r && e.iterator.return && (t.method = "return", t.arg = void 0, x(e, t), "throw" === t.method) || "return" !== r && (t.method = "throw", t.arg = new TypeError("The iterator does not provide a '" + r + "' method")), h;
                        var i = u(n, e.iterator, t.arg);
                        if ("throw" === i.type) return t.method = "throw", t.arg = i.arg, t.delegate = null, h;
                        var s = i.arg;
                        return s ? s.done ? (t[e.resultName] = s.value, t.next = e.nextLoc, "return" !== t.method && (t.method = "next", t.arg = void 0), t.delegate = null, h) : s : (t.method = "throw", t.arg = new TypeError("iterator result is not an object"), t.delegate = null, h);
                    }
                    function k(e) {
                        var t = {
                            tryLoc: e[0]
                        };
                        1 in e && (t.catchLoc = e[1]), 2 in e && (t.finallyLoc = e[2], t.afterLoc = e[3]), this.tryEntries.push(t);
                    }
                    function S(e) {
                        var t = e.completion || {};
                        t.type = "normal", delete t.arg, e.completion = t;
                    }
                    function M(e) {
                        this.tryEntries = [
                            {
                                tryLoc: "root"
                            }
                        ], e.forEach(k, this), this.reset(!0);
                    }
                    function C(e) {
                        if (e) {
                            var t = e[s];
                            if (t) return t.call(e);
                            if ("function" == typeof e.next) return e;
                            if (!isNaN(e.length)) {
                                var n = -1, i = function t() {
                                    for(; ++n < e.length;)if (r.call(e, n)) return t.value = e[n], t.done = !1, t;
                                    return t.value = void 0, t.done = !0, t;
                                };
                                return i.next = i;
                            }
                        }
                        return {
                            next: T
                        };
                    }
                    function T() {
                        return {
                            value: void 0,
                            done: !0
                        };
                    }
                    return d.prototype = p, n(y, "constructor", {
                        value: p,
                        configurable: !0
                    }), n(p, "constructor", {
                        value: d,
                        configurable: !0
                    }), d.displayName = l(p, a, "GeneratorFunction"), e.isGeneratorFunction = function(e) {
                        var t = "function" == typeof e && e.constructor;
                        return !!t && (t === d || "GeneratorFunction" === (t.displayName || t.name));
                    }, e.mark = function(e) {
                        return Object.setPrototypeOf ? Object.setPrototypeOf(e, p) : (e.__proto__ = p, l(e, a, "GeneratorFunction")), e.prototype = Object.create(y), e;
                    }, e.awrap = function(e) {
                        return {
                            __await: e
                        };
                    }, v(w.prototype), l(w.prototype, o, function() {
                        return this;
                    }), e.AsyncIterator = w, e.async = function(t, r, n, i, s) {
                        void 0 === s && (s = Promise);
                        var o = new w(c(t, r, n, i), s);
                        return e.isGeneratorFunction(r) ? o : o.next().then(function(e) {
                            return e.done ? e.value : o.next();
                        });
                    }, v(y), l(y, a, "Generator"), l(y, s, function() {
                        return this;
                    }), l(y, "toString", function() {
                        return "[object Generator]";
                    }), e.keys = function(e) {
                        var t = Object(e), r = [];
                        for(var n in t)r.push(n);
                        return r.reverse(), function e() {
                            for(; r.length;){
                                var n = r.pop();
                                if (n in t) return e.value = n, e.done = !1, e;
                            }
                            return e.done = !0, e;
                        };
                    }, e.values = C, M.prototype = {
                        constructor: M,
                        reset: function(e) {
                            if (this.prev = 0, this.next = 0, this.sent = this._sent = void 0, this.done = !1, this.delegate = null, this.method = "next", this.arg = void 0, this.tryEntries.forEach(S), !e) for(var t in this)"t" === t.charAt(0) && r.call(this, t) && !isNaN(+t.slice(1)) && (this[t] = void 0);
                        },
                        stop: function() {
                            this.done = !0;
                            var e = this.tryEntries[0].completion;
                            if ("throw" === e.type) throw e.arg;
                            return this.rval;
                        },
                        dispatchException: function(e) {
                            if (this.done) throw e;
                            var t = this;
                            function n(r, n) {
                                return o.type = "throw", o.arg = e, t.next = r, n && (t.method = "next", t.arg = void 0), !!n;
                            }
                            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                                var s = this.tryEntries[i], o = s.completion;
                                if ("root" === s.tryLoc) return n("end");
                                if (s.tryLoc <= this.prev) {
                                    var a = r.call(s, "catchLoc"), l = r.call(s, "finallyLoc");
                                    if (a && l) {
                                        if (this.prev < s.catchLoc) return n(s.catchLoc, !0);
                                        if (this.prev < s.finallyLoc) return n(s.finallyLoc);
                                    } else if (a) {
                                        if (this.prev < s.catchLoc) return n(s.catchLoc, !0);
                                    } else {
                                        if (!l) throw new Error("try statement without catch or finally");
                                        if (this.prev < s.finallyLoc) return n(s.finallyLoc);
                                    }
                                }
                            }
                        },
                        abrupt: function(e, t) {
                            for(var n = this.tryEntries.length - 1; n >= 0; --n){
                                var i = this.tryEntries[n];
                                if (i.tryLoc <= this.prev && r.call(i, "finallyLoc") && this.prev < i.finallyLoc) {
                                    var s = i;
                                    break;
                                }
                            }
                            s && ("break" === e || "continue" === e) && s.tryLoc <= t && t <= s.finallyLoc && (s = null);
                            var o = s ? s.completion : {};
                            return o.type = e, o.arg = t, s ? (this.method = "next", this.next = s.finallyLoc, h) : this.complete(o);
                        },
                        complete: function(e, t) {
                            if ("throw" === e.type) throw e.arg;
                            return "break" === e.type || "continue" === e.type ? this.next = e.arg : "return" === e.type ? (this.rval = this.arg = e.arg, this.method = "return", this.next = "end") : "normal" === e.type && t && (this.next = t), h;
                        },
                        finish: function(e) {
                            for(var t = this.tryEntries.length - 1; t >= 0; --t){
                                var r = this.tryEntries[t];
                                if (r.finallyLoc === e) return this.complete(r.completion, r.afterLoc), S(r), h;
                            }
                        },
                        catch: function(e) {
                            for(var t = this.tryEntries.length - 1; t >= 0; --t){
                                var r = this.tryEntries[t];
                                if (r.tryLoc === e) {
                                    var n = r.completion;
                                    if ("throw" === n.type) {
                                        var i = n.arg;
                                        S(r);
                                    }
                                    return i;
                                }
                            }
                            throw new Error("illegal catch attempt");
                        },
                        delegateYield: function(e, t, r) {
                            return this.delegate = {
                                iterator: C(e),
                                resultName: t,
                                nextLoc: r
                            }, "next" === this.method && (this.arg = void 0), h;
                        }
                    }, e;
                }("object" == typeof t ? t.exports : {});
                try {
                    regeneratorRuntime = n;
                } catch (e) {
                    "object" == typeof globalThis ? globalThis.regeneratorRuntime = n : Function("r", "regeneratorRuntime = r")(n);
                }
            },
            {}
        ],
        493: [
            function(e, t, r) {
                "use strict";
                var n = e("buffer").Buffer, i = e("inherits"), s = e("hash-base"), o = new Array(16), a = [
                    0,
                    1,
                    2,
                    3,
                    4,
                    5,
                    6,
                    7,
                    8,
                    9,
                    10,
                    11,
                    12,
                    13,
                    14,
                    15,
                    7,
                    4,
                    13,
                    1,
                    10,
                    6,
                    15,
                    3,
                    12,
                    0,
                    9,
                    5,
                    2,
                    14,
                    11,
                    8,
                    3,
                    10,
                    14,
                    4,
                    9,
                    15,
                    8,
                    1,
                    2,
                    7,
                    0,
                    6,
                    13,
                    11,
                    5,
                    12,
                    1,
                    9,
                    11,
                    10,
                    0,
                    8,
                    12,
                    4,
                    13,
                    3,
                    7,
                    15,
                    14,
                    5,
                    6,
                    2,
                    4,
                    0,
                    5,
                    9,
                    7,
                    12,
                    2,
                    10,
                    14,
                    1,
                    3,
                    8,
                    11,
                    6,
                    15,
                    13
                ], l = [
                    5,
                    14,
                    7,
                    0,
                    9,
                    2,
                    11,
                    4,
                    13,
                    6,
                    15,
                    8,
                    1,
                    10,
                    3,
                    12,
                    6,
                    11,
                    3,
                    7,
                    0,
                    13,
                    5,
                    10,
                    14,
                    15,
                    8,
                    12,
                    4,
                    9,
                    1,
                    2,
                    15,
                    5,
                    1,
                    3,
                    7,
                    14,
                    6,
                    9,
                    11,
                    8,
                    12,
                    2,
                    10,
                    0,
                    4,
                    13,
                    8,
                    6,
                    4,
                    1,
                    3,
                    11,
                    15,
                    0,
                    5,
                    12,
                    2,
                    13,
                    9,
                    7,
                    10,
                    14,
                    12,
                    15,
                    10,
                    4,
                    1,
                    5,
                    8,
                    7,
                    6,
                    2,
                    13,
                    14,
                    0,
                    3,
                    9,
                    11
                ], c = [
                    11,
                    14,
                    15,
                    12,
                    5,
                    8,
                    7,
                    9,
                    11,
                    13,
                    14,
                    15,
                    6,
                    7,
                    9,
                    8,
                    7,
                    6,
                    8,
                    13,
                    11,
                    9,
                    7,
                    15,
                    7,
                    12,
                    15,
                    9,
                    11,
                    7,
                    13,
                    12,
                    11,
                    13,
                    6,
                    7,
                    14,
                    9,
                    13,
                    15,
                    14,
                    8,
                    13,
                    6,
                    5,
                    12,
                    7,
                    5,
                    11,
                    12,
                    14,
                    15,
                    14,
                    15,
                    9,
                    8,
                    9,
                    14,
                    5,
                    6,
                    8,
                    6,
                    5,
                    12,
                    9,
                    15,
                    5,
                    11,
                    6,
                    8,
                    13,
                    12,
                    5,
                    12,
                    13,
                    14,
                    11,
                    8,
                    5,
                    6
                ], u = [
                    8,
                    9,
                    9,
                    11,
                    13,
                    15,
                    15,
                    5,
                    7,
                    7,
                    8,
                    11,
                    14,
                    14,
                    12,
                    6,
                    9,
                    13,
                    15,
                    7,
                    12,
                    8,
                    9,
                    11,
                    7,
                    7,
                    12,
                    7,
                    6,
                    15,
                    13,
                    11,
                    9,
                    7,
                    15,
                    11,
                    8,
                    6,
                    6,
                    14,
                    12,
                    13,
                    5,
                    14,
                    13,
                    13,
                    7,
                    5,
                    15,
                    5,
                    8,
                    11,
                    14,
                    14,
                    6,
                    14,
                    6,
                    9,
                    12,
                    9,
                    12,
                    5,
                    15,
                    8,
                    8,
                    5,
                    12,
                    9,
                    12,
                    5,
                    14,
                    6,
                    8,
                    13,
                    6,
                    5,
                    15,
                    13,
                    11,
                    11
                ], h = [
                    0,
                    1518500249,
                    1859775393,
                    2400959708,
                    2840853838
                ], f = [
                    1352829926,
                    1548603684,
                    1836072691,
                    2053994217,
                    0
                ];
                function d() {
                    s.call(this, 64), this._a = 1732584193, this._b = 4023233417, this._c = 2562383102, this._d = 271733878, this._e = 3285377520;
                }
                function p(e, t) {
                    return e << t | e >>> 32 - t;
                }
                function m(e, t, r, n, i, s, o, a) {
                    return p(e + (t ^ r ^ n) + s + o | 0, a) + i | 0;
                }
                function b(e, t, r, n, i, s, o, a) {
                    return p(e + (t & r | ~t & n) + s + o | 0, a) + i | 0;
                }
                function g(e, t, r, n, i, s, o, a) {
                    return p(e + ((t | ~r) ^ n) + s + o | 0, a) + i | 0;
                }
                function y(e, t, r, n, i, s, o, a) {
                    return p(e + (t & n | r & ~n) + s + o | 0, a) + i | 0;
                }
                function v(e, t, r, n, i, s, o, a) {
                    return p(e + (t ^ (r | ~n)) + s + o | 0, a) + i | 0;
                }
                i(d, s), d.prototype._update = function() {
                    for(var e = o, t = 0; t < 16; ++t)e[t] = this._block.readInt32LE(4 * t);
                    for(var r = 0 | this._a, n = 0 | this._b, i = 0 | this._c, s = 0 | this._d, d = 0 | this._e, w = 0 | this._a, _ = 0 | this._b, x = 0 | this._c, k = 0 | this._d, S = 0 | this._e, M = 0; M < 80; M += 1){
                        var C, T;
                        M < 16 ? (C = m(r, n, i, s, d, e[a[M]], h[0], c[M]), T = v(w, _, x, k, S, e[l[M]], f[0], u[M])) : M < 32 ? (C = b(r, n, i, s, d, e[a[M]], h[1], c[M]), T = y(w, _, x, k, S, e[l[M]], f[1], u[M])) : M < 48 ? (C = g(r, n, i, s, d, e[a[M]], h[2], c[M]), T = g(w, _, x, k, S, e[l[M]], f[2], u[M])) : M < 64 ? (C = y(r, n, i, s, d, e[a[M]], h[3], c[M]), T = b(w, _, x, k, S, e[l[M]], f[3], u[M])) : (C = v(r, n, i, s, d, e[a[M]], h[4], c[M]), T = m(w, _, x, k, S, e[l[M]], f[4], u[M])), r = d, d = s, s = p(i, 10), i = n, n = C, w = S, S = k, k = p(x, 10), x = _, _ = T;
                    }
                    var E = this._b + i + k | 0;
                    this._b = this._c + s + S | 0, this._c = this._d + d + w | 0, this._d = this._e + r + _ | 0, this._e = this._a + n + x | 0, this._a = E;
                }, d.prototype._digest = function() {
                    this._block[this._blockOffset++] = 128, this._blockOffset > 56 && (this._block.fill(0, this._blockOffset, 64), this._update(), this._blockOffset = 0), this._block.fill(0, this._blockOffset, 56), this._block.writeUInt32LE(this._length[0], 56), this._block.writeUInt32LE(this._length[1], 60), this._update();
                    var e = n.alloc ? n.alloc(20) : new n(20);
                    return e.writeInt32LE(this._a, 0), e.writeInt32LE(this._b, 4), e.writeInt32LE(this._c, 8), e.writeInt32LE(this._d, 12), e.writeInt32LE(this._e, 16), e;
                }, t.exports = d;
            },
            {
                buffer: 220,
                "hash-base": 425,
                inherits: 440
            }
        ],
        494: [
            function(e, t, r) {
                "use strict";
                /*! safe-buffer. MIT License. Feross Aboukhadijeh <https://feross.org/opensource> */ var n = e("buffer"), i = n.Buffer;
                function s(e, t) {
                    for(var r in e)t[r] = e[r];
                }
                function o(e, t, r) {
                    return i(e, t, r);
                }
                i.from && i.alloc && i.allocUnsafe && i.allocUnsafeSlow ? t.exports = n : (s(n, r), r.Buffer = o), o.prototype = Object.create(i.prototype), s(i, o), o.from = function(e, t, r) {
                    if ("number" == typeof e) throw new TypeError("Argument must not be a number");
                    return i(e, t, r);
                }, o.alloc = function(e, t, r) {
                    if ("number" != typeof e) throw new TypeError("Argument must be a number");
                    var n = i(e);
                    return void 0 !== t ? "string" == typeof r ? n.fill(t, r) : n.fill(t) : n.fill(0), n;
                }, o.allocUnsafe = function(e) {
                    if ("number" != typeof e) throw new TypeError("Argument must be a number");
                    return i(e);
                }, o.allocUnsafeSlow = function(e) {
                    if ("number" != typeof e) throw new TypeError("Argument must be a number");
                    return n.SlowBuffer(e);
                };
            },
            {
                buffer: 220
            }
        ],
        495: [
            function(e, t, r) {
                (function(r) {
                    (function() {
                        "use strict";
                        var n, i = e("buffer"), s = i.Buffer, o = {};
                        for(n in i)i.hasOwnProperty(n) && "SlowBuffer" !== n && "Buffer" !== n && (o[n] = i[n]);
                        var a = o.Buffer = {};
                        for(n in s)s.hasOwnProperty(n) && "allocUnsafe" !== n && "allocUnsafeSlow" !== n && (a[n] = s[n]);
                        if (o.Buffer.prototype = s.prototype, a.from && a.from !== Uint8Array.from || (a.from = function(e, t, r) {
                            if ("number" == typeof e) throw new TypeError('The "value" argument must not be of type number. Received type ' + typeof e);
                            if (e && void 0 === e.length) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof e);
                            return s(e, t, r);
                        }), a.alloc || (a.alloc = function(e, t, r) {
                            if ("number" != typeof e) throw new TypeError('The "size" argument must be of type number. Received type ' + typeof e);
                            if (e < 0 || e >= 2 * 1073741824) throw new RangeError('The value "' + e + '" is invalid for option "size"');
                            var n = s(e);
                            return t && 0 !== t.length ? "string" == typeof r ? n.fill(t, r) : n.fill(t) : n.fill(0), n;
                        }), !o.kStringMaxLength) try {
                            o.kStringMaxLength = r.binding("buffer").kStringMaxLength;
                        } catch (e) {}
                        o.constants || (o.constants = {
                            MAX_LENGTH: o.kMaxLength
                        }, o.kStringMaxLength && (o.constants.MAX_STRING_LENGTH = o.kStringMaxLength)), t.exports = o;
                    }).call(this);
                }).call(this, e("_process"));
            },
            {
                _process: 467,
                buffer: 220
            }
        ],
        496: [
            function(e, t, r) {
                "use strict";
                Object.defineProperty(r, "__esModule", {
                    value: !0
                });
                const n = e("xmlchars/xml/1.0/ed5"), i = e("xmlchars/xml/1.1/ed2"), s = e("xmlchars/xmlns/1.0/ed3");
                var o = n.isS, a = n.isChar, l = n.isNameStartChar, c = n.isNameChar, u = n.S_LIST, h = n.NAME_RE, f = i.isChar, d = s.isNCNameStartChar, p = s.isNCNameChar, m = s.NC_NAME_RE;
                const b = "http://www.w3.org/XML/1998/namespace", g = "http://www.w3.org/2000/xmlns/", y = {
                    __proto__: null,
                    xml: b,
                    xmlns: g
                }, v = {
                    __proto__: null,
                    amp: "&",
                    gt: ">",
                    lt: "<",
                    quot: '"',
                    apos: "'"
                }, w = (e)=>34 === e || 39 === e, _ = [
                    34,
                    39
                ], x = [
                    ..._,
                    91,
                    62
                ], k = [
                    ..._,
                    60,
                    93
                ], S = [
                    61,
                    63,
                    ...u
                ], M = [
                    ...u,
                    62,
                    38,
                    60
                ];
                function C(e, t, r) {
                    switch(t){
                        case "xml":
                            r !== b && e.fail(`xml prefix must be bound to ${b}.`);
                            break;
                        case "xmlns":
                            r !== g && e.fail(`xmlns prefix must be bound to ${g}.`);
                    }
                    switch(r){
                        case g:
                            e.fail("" === t ? `the default namespace may not be set to ${r}.` : `may not assign a prefix (even "xmlns") to the URI ${g}.`);
                            break;
                        case b:
                            switch(t){
                                case "xml":
                                    break;
                                case "":
                                    e.fail(`the default namespace may not be set to ${r}.`);
                                    break;
                                default:
                                    e.fail("may not assign the xml namespace to another prefix.");
                            }
                    }
                }
                const T = (e)=>m.test(e), E = (e)=>h.test(e);
                r.EVENTS = [
                    "xmldecl",
                    "text",
                    "processinginstruction",
                    "doctype",
                    "comment",
                    "opentagstart",
                    "attribute",
                    "opentag",
                    "closetag",
                    "cdata",
                    "error",
                    "end",
                    "ready"
                ];
                const A = {
                    xmldecl: "xmldeclHandler",
                    text: "textHandler",
                    processinginstruction: "piHandler",
                    doctype: "doctypeHandler",
                    comment: "commentHandler",
                    opentagstart: "openTagStartHandler",
                    attribute: "attributeHandler",
                    opentag: "openTagHandler",
                    closetag: "closeTagHandler",
                    cdata: "cdataHandler",
                    error: "errorHandler",
                    end: "endHandler",
                    ready: "readyHandler"
                };
                r.SaxesParser = class {
                    constructor(e){
                        this.opt = null != e ? e : {}, this.fragmentOpt = !!this.opt.fragment;
                        const t = this.xmlnsOpt = !!this.opt.xmlns;
                        if (this.trackPosition = !1 !== this.opt.position, this.fileName = this.opt.fileName, t) {
                            this.nameStartCheck = d, this.nameCheck = p, this.isName = T, this.processAttribs = this.processAttribsNS, this.pushAttrib = this.pushAttribNS, this.ns = Object.assign({
                                __proto__: null
                            }, y);
                            const e = this.opt.additionalNamespaces;
                            null != e && (!function(e, t) {
                                for (const r of Object.keys(t))C(e, r, t[r]);
                            }(this, e), Object.assign(this.ns, e));
                        } else this.nameStartCheck = l, this.nameCheck = c, this.isName = E, this.processAttribs = this.processAttribsPlain, this.pushAttrib = this.pushAttribPlain;
                        this.stateTable = [
                            this.sBegin,
                            this.sBeginWhitespace,
                            this.sDoctype,
                            this.sDoctypeQuote,
                            this.sDTD,
                            this.sDTDQuoted,
                            this.sDTDOpenWaka,
                            this.sDTDOpenWakaBang,
                            this.sDTDComment,
                            this.sDTDCommentEnding,
                            this.sDTDCommentEnded,
                            this.sDTDPI,
                            this.sDTDPIEnding,
                            this.sText,
                            this.sEntity,
                            this.sOpenWaka,
                            this.sOpenWakaBang,
                            this.sComment,
                            this.sCommentEnding,
                            this.sCommentEnded,
                            this.sCData,
                            this.sCDataEnding,
                            this.sCDataEnding2,
                            this.sPIFirstChar,
                            this.sPIRest,
                            this.sPIBody,
                            this.sPIEnding,
                            this.sXMLDeclNameStart,
                            this.sXMLDeclName,
                            this.sXMLDeclEq,
                            this.sXMLDeclValueStart,
                            this.sXMLDeclValue,
                            this.sXMLDeclSeparator,
                            this.sXMLDeclEnding,
                            this.sOpenTag,
                            this.sOpenTagSlash,
                            this.sAttrib,
                            this.sAttribName,
                            this.sAttribNameSawWhite,
                            this.sAttribValue,
                            this.sAttribValueQuoted,
                            this.sAttribValueClosed,
                            this.sAttribValueUnquoted,
                            this.sCloseTag,
                            this.sCloseTagSawWhite
                        ], this._init();
                    }
                    get closed() {
                        return this._closed;
                    }
                    _init() {
                        var e;
                        this.openWakaBang = "", this.text = "", this.name = "", this.piTarget = "", this.entity = "", this.q = null, this.tags = [], this.tag = null, this.topNS = null, this.chunk = "", this.chunkPosition = 0, this.i = 0, this.prevI = 0, this.carriedFromPrevious = void 0, this.forbiddenState = 0, this.attribList = [];
                        const { fragmentOpt: t } = this;
                        this.state = t ? 13 : 0, this.reportedTextBeforeRoot = this.reportedTextAfterRoot = this.closedRoot = this.sawRoot = t, this.xmlDeclPossible = !t, this.xmlDeclExpects = [
                            "version"
                        ], this.entityReturnState = void 0;
                        let { defaultXMLVersion: r } = this.opt;
                        if (void 0 === r) {
                            if (!0 === this.opt.forceXMLVersion) throw new Error("forceXMLVersion set but defaultXMLVersion is not set");
                            r = "1.0";
                        }
                        this.setXMLVersion(r), this.positionAtNewLine = 0, this.doctype = !1, this._closed = !1, this.xmlDecl = {
                            version: void 0,
                            encoding: void 0,
                            standalone: void 0
                        }, this.line = 1, this.column = 0, this.ENTITIES = Object.create(v), null === (e = this.readyHandler) || void 0 === e || e.call(this);
                    }
                    get position() {
                        return this.chunkPosition + this.i;
                    }
                    get columnIndex() {
                        return this.position - this.positionAtNewLine;
                    }
                    on(e, t) {
                        this[A[e]] = t;
                    }
                    off(e) {
                        this[A[e]] = void 0;
                    }
                    makeError(e) {
                        var t;
                        let r = null !== (t = this.fileName) && void 0 !== t ? t : "";
                        return this.trackPosition && (r.length > 0 && (r += ":"), r += `${this.line}:${this.column}`), r.length > 0 && (r += ": "), new Error(r + e);
                    }
                    fail(e) {
                        const t = this.makeError(e), r = this.errorHandler;
                        if (void 0 === r) throw t;
                        return r(t), this;
                    }
                    write(e) {
                        if (this.closed) return this.fail("cannot write after close; assign an onready handler.");
                        let t = !1;
                        null === e ? (t = !0, e = "") : "object" == typeof e && (e = e.toString()), void 0 !== this.carriedFromPrevious && (e = `${this.carriedFromPrevious}${e}`, this.carriedFromPrevious = void 0);
                        let r = e.length;
                        const n = e.charCodeAt(r - 1);
                        !t && (13 === n || n >= 55296 && n <= 56319) && (this.carriedFromPrevious = e[r - 1], r--, e = e.slice(0, r));
                        const { stateTable: i } = this;
                        for(this.chunk = e, this.i = 0; this.i < r;)i[this.state].call(this);
                        return this.chunkPosition += r, t ? this.end() : this;
                    }
                    close() {
                        return this.write(null);
                    }
                    getCode10() {
                        const { chunk: e, i: t } = this;
                        if (this.prevI = t, this.i = t + 1, t >= e.length) return -1;
                        const r = e.charCodeAt(t);
                        if (this.column++, r < 55296) {
                            if (r >= 32 || 9 === r) return r;
                            switch(r){
                                case 10:
                                    return this.line++, this.column = 0, this.positionAtNewLine = this.position, 10;
                                case 13:
                                    return 10 === e.charCodeAt(t + 1) && (this.i = t + 2), this.line++, this.column = 0, this.positionAtNewLine = this.position, -2;
                                default:
                                    return this.fail("disallowed character."), r;
                            }
                        }
                        if (r > 56319) return r >= 57344 && r <= 65533 || this.fail("disallowed character."), r;
                        const n = 65536 + 1024 * (r - 55296) + (e.charCodeAt(t + 1) - 56320);
                        return this.i = t + 2, n > 1114111 && this.fail("disallowed character."), n;
                    }
                    getCode11() {
                        const { chunk: e, i: t } = this;
                        if (this.prevI = t, this.i = t + 1, t >= e.length) return -1;
                        const r = e.charCodeAt(t);
                        if (this.column++, r < 55296) {
                            if (r > 31 && r < 127 || r > 159 && 8232 !== r || 9 === r) return r;
                            switch(r){
                                case 10:
                                    return this.line++, this.column = 0, this.positionAtNewLine = this.position, 10;
                                case 13:
                                    {
                                        const r = e.charCodeAt(t + 1);
                                        10 !== r && 133 !== r || (this.i = t + 2);
                                    }
                                case 133:
                                case 8232:
                                    return this.line++, this.column = 0, this.positionAtNewLine = this.position, -2;
                                default:
                                    return this.fail("disallowed character."), r;
                            }
                        }
                        if (r > 56319) return r >= 57344 && r <= 65533 || this.fail("disallowed character."), r;
                        const n = 65536 + 1024 * (r - 55296) + (e.charCodeAt(t + 1) - 56320);
                        return this.i = t + 2, n > 1114111 && this.fail("disallowed character."), n;
                    }
                    getCodeNorm() {
                        const e = this.getCode();
                        return -2 === e ? 10 : e;
                    }
                    unget() {
                        this.i = this.prevI, this.column--;
                    }
                    captureTo(e) {
                        let { i: t } = this;
                        const { chunk: r } = this;
                        for(;;){
                            const n = this.getCode(), i = -2 === n, s = i ? 10 : n;
                            if (-1 === s || e.includes(s)) return this.text += r.slice(t, this.prevI), s;
                            i && (this.text += r.slice(t, this.prevI) + "\n", t = this.i);
                        }
                    }
                    captureToChar(e) {
                        let { i: t } = this;
                        const { chunk: r } = this;
                        for(;;){
                            let n = this.getCode();
                            switch(n){
                                case -2:
                                    this.text += r.slice(t, this.prevI) + "\n", t = this.i, n = 10;
                                    break;
                                case -1:
                                    return this.text += r.slice(t), !1;
                            }
                            if (n === e) return this.text += r.slice(t, this.prevI), !0;
                        }
                    }
                    captureNameChars() {
                        const { chunk: e, i: t } = this;
                        for(;;){
                            const r = this.getCode();
                            if (-1 === r) return this.name += e.slice(t), -1;
                            if (!c(r)) return this.name += e.slice(t, this.prevI), -2 === r ? 10 : r;
                        }
                    }
                    skipSpaces() {
                        for(;;){
                            const e = this.getCodeNorm();
                            if (-1 === e || !o(e)) return e;
                        }
                    }
                    setXMLVersion(e) {
                        this.currentXMLVersion = e, "1.0" === e ? (this.isChar = a, this.getCode = this.getCode10) : (this.isChar = f, this.getCode = this.getCode11);
                    }
                    sBegin() {
                        65279 === this.chunk.charCodeAt(0) && (this.i++, this.column++), this.state = 1;
                    }
                    sBeginWhitespace() {
                        const e = this.i, t = this.skipSpaces();
                        switch(this.prevI !== e && (this.xmlDeclPossible = !1), t){
                            case 60:
                                if (this.state = 15, 0 !== this.text.length) throw new Error("no-empty text at start");
                                break;
                            case -1:
                                break;
                            default:
                                this.unget(), this.state = 13, this.xmlDeclPossible = !1;
                        }
                    }
                    sDoctype() {
                        var e;
                        const t = this.captureTo(x);
                        switch(t){
                            case 62:
                                null === (e = this.doctypeHandler) || void 0 === e || e.call(this, this.text), this.text = "", this.state = 13, this.doctype = !0;
                                break;
                            case -1:
                                break;
                            default:
                                this.text += String.fromCodePoint(t), 91 === t ? this.state = 4 : w(t) && (this.state = 3, this.q = t);
                        }
                    }
                    sDoctypeQuote() {
                        const e = this.q;
                        this.captureToChar(e) && (this.text += String.fromCodePoint(e), this.q = null, this.state = 2);
                    }
                    sDTD() {
                        const e = this.captureTo(k);
                        -1 !== e && (this.text += String.fromCodePoint(e), 93 === e ? this.state = 2 : 60 === e ? this.state = 6 : w(e) && (this.state = 5, this.q = e));
                    }
                    sDTDQuoted() {
                        const e = this.q;
                        this.captureToChar(e) && (this.text += String.fromCodePoint(e), this.state = 4, this.q = null);
                    }
                    sDTDOpenWaka() {
                        const e = this.getCodeNorm();
                        switch(this.text += String.fromCodePoint(e), e){
                            case 33:
                                this.state = 7, this.openWakaBang = "";
                                break;
                            case 63:
                                this.state = 11;
                                break;
                            default:
                                this.state = 4;
                        }
                    }
                    sDTDOpenWakaBang() {
                        const e = String.fromCodePoint(this.getCodeNorm()), t = this.openWakaBang += e;
                        this.text += e, "-" !== t && (this.state = "--" === t ? 8 : 4, this.openWakaBang = "");
                    }
                    sDTDComment() {
                        this.captureToChar(45) && (this.text += "-", this.state = 9);
                    }
                    sDTDCommentEnding() {
                        const e = this.getCodeNorm();
                        this.text += String.fromCodePoint(e), this.state = 45 === e ? 10 : 8;
                    }
                    sDTDCommentEnded() {
                        const e = this.getCodeNorm();
                        this.text += String.fromCodePoint(e), 62 === e ? this.state = 4 : (this.fail("malformed comment."), this.state = 8);
                    }
                    sDTDPI() {
                        this.captureToChar(63) && (this.text += "?", this.state = 12);
                    }
                    sDTDPIEnding() {
                        const e = this.getCodeNorm();
                        this.text += String.fromCodePoint(e), 62 === e && (this.state = 4);
                    }
                    sText() {
                        0 !== this.tags.length ? this.handleTextInRoot() : this.handleTextOutsideRoot();
                    }
                    sEntity() {
                        let { i: e } = this;
                        const { chunk: t } = this;
                        e: for(;;)switch(this.getCode()){
                            case -2:
                                this.entity += t.slice(e, this.prevI) + "\n", e = this.i;
                                break;
                            case 59:
                                {
                                    const { entityReturnState: r } = this, n = this.entity + t.slice(e, this.prevI);
                                    let i;
                                    this.state = r, "" === n ? (this.fail("empty entity name."), i = "&;") : (i = this.parseEntity(n), this.entity = ""), 13 === r && void 0 === this.textHandler || (this.text += i);
                                    break e;
                                }
                            case -1:
                                this.entity += t.slice(e);
                                break e;
                        }
                    }
                    sOpenWaka() {
                        const e = this.getCode();
                        if (l(e)) this.state = 34, this.unget(), this.xmlDeclPossible = !1;
                        else switch(e){
                            case 47:
                                this.state = 43, this.xmlDeclPossible = !1;
                                break;
                            case 33:
                                this.state = 16, this.openWakaBang = "", this.xmlDeclPossible = !1;
                                break;
                            case 63:
                                this.state = 23;
                                break;
                            default:
                                this.fail("disallowed character in tag name"), this.state = 13, this.xmlDeclPossible = !1;
                        }
                    }
                    sOpenWakaBang() {
                        switch(this.openWakaBang += String.fromCodePoint(this.getCodeNorm()), this.openWakaBang){
                            case "[CDATA[":
                                this.sawRoot || this.reportedTextBeforeRoot || (this.fail("text data outside of root node."), this.reportedTextBeforeRoot = !0), this.closedRoot && !this.reportedTextAfterRoot && (this.fail("text data outside of root node."), this.reportedTextAfterRoot = !0), this.state = 20, this.openWakaBang = "";
                                break;
                            case "--":
                                this.state = 17, this.openWakaBang = "";
                                break;
                            case "DOCTYPE":
                                this.state = 2, (this.doctype || this.sawRoot) && this.fail("inappropriately located doctype declaration."), this.openWakaBang = "";
                                break;
                            default:
                                this.openWakaBang.length >= 7 && this.fail("incorrect syntax.");
                        }
                    }
                    sComment() {
                        this.captureToChar(45) && (this.state = 18);
                    }
                    sCommentEnding() {
                        var e;
                        const t = this.getCodeNorm();
                        45 === t ? (this.state = 19, null === (e = this.commentHandler) || void 0 === e || e.call(this, this.text), this.text = "") : (this.text += "-" + String.fromCodePoint(t), this.state = 17);
                    }
                    sCommentEnded() {
                        const e = this.getCodeNorm();
                        62 !== e ? (this.fail("malformed comment."), this.text += "--" + String.fromCodePoint(e), this.state = 17) : this.state = 13;
                    }
                    sCData() {
                        this.captureToChar(93) && (this.state = 21);
                    }
                    sCDataEnding() {
                        const e = this.getCodeNorm();
                        93 === e ? this.state = 22 : (this.text += "]" + String.fromCodePoint(e), this.state = 20);
                    }
                    sCDataEnding2() {
                        var e;
                        const t = this.getCodeNorm();
                        switch(t){
                            case 62:
                                null === (e = this.cdataHandler) || void 0 === e || e.call(this, this.text), this.text = "", this.state = 13;
                                break;
                            case 93:
                                this.text += "]";
                                break;
                            default:
                                this.text += "]]" + String.fromCodePoint(t), this.state = 20;
                        }
                    }
                    sPIFirstChar() {
                        const e = this.getCodeNorm();
                        this.nameStartCheck(e) ? (this.piTarget += String.fromCodePoint(e), this.state = 24) : 63 === e || o(e) ? (this.fail("processing instruction without a target."), this.state = 63 === e ? 26 : 25) : (this.fail("disallowed character in processing instruction name."), this.piTarget += String.fromCodePoint(e), this.state = 24);
                    }
                    sPIRest() {
                        const { chunk: e, i: t } = this;
                        for(;;){
                            const r = this.getCodeNorm();
                            if (-1 === r) return void (this.piTarget += e.slice(t));
                            if (!this.nameCheck(r)) {
                                this.piTarget += e.slice(t, this.prevI);
                                const n = 63 === r;
                                n || o(r) ? "xml" === this.piTarget ? (this.xmlDeclPossible || this.fail("an XML declaration must be at the start of the document."), this.state = n ? 33 : 27) : this.state = n ? 26 : 25 : (this.fail("disallowed character in processing instruction name."), this.piTarget += String.fromCodePoint(r));
                                break;
                            }
                        }
                    }
                    sPIBody() {
                        if (0 === this.text.length) {
                            const e = this.getCodeNorm();
                            63 === e ? this.state = 26 : o(e) || (this.text = String.fromCodePoint(e));
                        } else this.captureToChar(63) && (this.state = 26);
                    }
                    sPIEnding() {
                        var e;
                        const t = this.getCodeNorm();
                        if (62 === t) {
                            const { piTarget: t } = this;
                            "xml" === t.toLowerCase() && this.fail("the XML declaration must appear at the start of the document."), null === (e = this.piHandler) || void 0 === e || e.call(this, {
                                target: t,
                                body: this.text
                            }), this.piTarget = this.text = "", this.state = 13;
                        } else 63 === t ? this.text += "?" : (this.text += "?" + String.fromCodePoint(t), this.state = 25);
                        this.xmlDeclPossible = !1;
                    }
                    sXMLDeclNameStart() {
                        const e = this.skipSpaces();
                        63 !== e ? -1 !== e && (this.state = 28, this.name = String.fromCodePoint(e)) : this.state = 33;
                    }
                    sXMLDeclName() {
                        const e = this.captureTo(S);
                        if (63 === e) return this.state = 33, this.name += this.text, this.text = "", void this.fail("XML declaration is incomplete.");
                        if (o(e) || 61 === e) {
                            if (this.name += this.text, this.text = "", !this.xmlDeclExpects.includes(this.name)) switch(this.name.length){
                                case 0:
                                    this.fail("did not expect any more name/value pairs.");
                                    break;
                                case 1:
                                    this.fail(`expected the name ${this.xmlDeclExpects[0]}.`);
                                    break;
                                default:
                                    this.fail("expected one of " + this.xmlDeclExpects.join(", "));
                            }
                            this.state = 61 === e ? 30 : 29;
                        }
                    }
                    sXMLDeclEq() {
                        const e = this.getCodeNorm();
                        if (63 === e) return this.state = 33, void this.fail("XML declaration is incomplete.");
                        o(e) || (61 !== e && this.fail("value required."), this.state = 30);
                    }
                    sXMLDeclValueStart() {
                        const e = this.getCodeNorm();
                        if (63 === e) return this.state = 33, void this.fail("XML declaration is incomplete.");
                        o(e) || (w(e) ? this.q = e : (this.fail("value must be quoted."), this.q = 32), this.state = 31);
                    }
                    sXMLDeclValue() {
                        const e = this.captureTo([
                            this.q,
                            63
                        ]);
                        if (63 === e) return this.state = 33, this.text = "", void this.fail("XML declaration is incomplete.");
                        if (-1 === e) return;
                        const t = this.text;
                        switch(this.text = "", this.name){
                            case "version":
                                {
                                    this.xmlDeclExpects = [
                                        "encoding",
                                        "standalone"
                                    ];
                                    const e = t;
                                    this.xmlDecl.version = e, /^1\.[0-9]+$/.test(e) ? this.opt.forceXMLVersion || this.setXMLVersion(e) : this.fail("version number must match /^1\\.[0-9]+$/.");
                                    break;
                                }
                            case "encoding":
                                /^[A-Za-z][A-Za-z0-9._-]*$/.test(t) || this.fail("encoding value must match /^[A-Za-z0-9][A-Za-z0-9._-]*$/."), this.xmlDeclExpects = [
                                    "standalone"
                                ], this.xmlDecl.encoding = t;
                                break;
                            case "standalone":
                                "yes" !== t && "no" !== t && this.fail('standalone value must match "yes" or "no".'), this.xmlDeclExpects = [], this.xmlDecl.standalone = t;
                        }
                        this.name = "", this.state = 32;
                    }
                    sXMLDeclSeparator() {
                        const e = this.getCodeNorm();
                        63 !== e ? (o(e) || (this.fail("whitespace required."), this.unget()), this.state = 27) : this.state = 33;
                    }
                    sXMLDeclEnding() {
                        var e;
                        62 === this.getCodeNorm() ? ("xml" !== this.piTarget ? this.fail("processing instructions are not allowed before root.") : "version" !== this.name && this.xmlDeclExpects.includes("version") && this.fail("XML declaration must contain a version."), null === (e = this.xmldeclHandler) || void 0 === e || e.call(this, this.xmlDecl), this.name = "", this.piTarget = this.text = "", this.state = 13) : this.fail("The character ? is disallowed anywhere in XML declarations."), this.xmlDeclPossible = !1;
                    }
                    sOpenTag() {
                        var e;
                        const t = this.captureNameChars();
                        if (-1 === t) return;
                        const r = this.tag = {
                            name: this.name,
                            attributes: Object.create(null)
                        };
                        switch(this.name = "", this.xmlnsOpt && (this.topNS = r.ns = Object.create(null)), null === (e = this.openTagStartHandler) || void 0 === e || e.call(this, r), this.sawRoot = !0, !this.fragmentOpt && this.closedRoot && this.fail("documents may contain only one root."), t){
                            case 62:
                                this.openTag();
                                break;
                            case 47:
                                this.state = 35;
                                break;
                            default:
                                o(t) || this.fail("disallowed character in tag name."), this.state = 36;
                        }
                    }
                    sOpenTagSlash() {
                        62 === this.getCode() ? this.openSelfClosingTag() : (this.fail("forward-slash in opening tag not followed by >."), this.state = 36);
                    }
                    sAttrib() {
                        const e = this.skipSpaces();
                        -1 !== e && (l(e) ? (this.unget(), this.state = 37) : 62 === e ? this.openTag() : 47 === e ? this.state = 35 : this.fail("disallowed character in attribute name."));
                    }
                    sAttribName() {
                        const e = this.captureNameChars();
                        61 === e ? this.state = 39 : o(e) ? this.state = 38 : 62 === e ? (this.fail("attribute without value."), this.pushAttrib(this.name, this.name), this.name = this.text = "", this.openTag()) : -1 !== e && this.fail("disallowed character in attribute name.");
                    }
                    sAttribNameSawWhite() {
                        const e = this.skipSpaces();
                        switch(e){
                            case -1:
                                return;
                            case 61:
                                this.state = 39;
                                break;
                            default:
                                this.fail("attribute without value."), this.text = "", this.name = "", 62 === e ? this.openTag() : l(e) ? (this.unget(), this.state = 37) : (this.fail("disallowed character in attribute name."), this.state = 36);
                        }
                    }
                    sAttribValue() {
                        const e = this.getCodeNorm();
                        w(e) ? (this.q = e, this.state = 40) : o(e) || (this.fail("unquoted attribute value."), this.state = 42, this.unget());
                    }
                    sAttribValueQuoted() {
                        const { q: e, chunk: t } = this;
                        let { i: r } = this;
                        for(;;)switch(this.getCode()){
                            case e:
                                return this.pushAttrib(this.name, this.text + t.slice(r, this.prevI)), this.name = this.text = "", this.q = null, void (this.state = 41);
                            case 38:
                                return this.text += t.slice(r, this.prevI), this.state = 14, void (this.entityReturnState = 40);
                            case 10:
                            case -2:
                            case 9:
                                this.text += t.slice(r, this.prevI) + " ", r = this.i;
                                break;
                            case 60:
                                return this.text += t.slice(r, this.prevI), void this.fail("disallowed character.");
                            case -1:
                                return void (this.text += t.slice(r));
                        }
                    }
                    sAttribValueClosed() {
                        const e = this.getCodeNorm();
                        o(e) ? this.state = 36 : 62 === e ? this.openTag() : 47 === e ? this.state = 35 : l(e) ? (this.fail("no whitespace between attributes."), this.unget(), this.state = 37) : this.fail("disallowed character in attribute name.");
                    }
                    sAttribValueUnquoted() {
                        const e = this.captureTo(M);
                        switch(e){
                            case 38:
                                this.state = 14, this.entityReturnState = 42;
                                break;
                            case 60:
                                this.fail("disallowed character.");
                                break;
                            case -1:
                                break;
                            default:
                                this.text.includes("]]>") && this.fail('the string "]]>" is disallowed in char data.'), this.pushAttrib(this.name, this.text), this.name = this.text = "", 62 === e ? this.openTag() : this.state = 36;
                        }
                    }
                    sCloseTag() {
                        const e = this.captureNameChars();
                        62 === e ? this.closeTag() : o(e) ? this.state = 44 : -1 !== e && this.fail("disallowed character in closing tag.");
                    }
                    sCloseTagSawWhite() {
                        switch(this.skipSpaces()){
                            case 62:
                                this.closeTag();
                                break;
                            case -1:
                                break;
                            default:
                                this.fail("disallowed character in closing tag.");
                        }
                    }
                    handleTextInRoot() {
                        let { i: e, forbiddenState: t } = this;
                        const { chunk: r, textHandler: n } = this;
                        e: for(;;)switch(this.getCode()){
                            case 60:
                                if (this.state = 15, void 0 !== n) {
                                    const { text: t } = this, i = r.slice(e, this.prevI);
                                    0 !== t.length ? (n(t + i), this.text = "") : 0 !== i.length && n(i);
                                }
                                t = 0;
                                break e;
                            case 38:
                                this.state = 14, this.entityReturnState = 13, void 0 !== n && (this.text += r.slice(e, this.prevI)), t = 0;
                                break e;
                            case 93:
                                switch(t){
                                    case 0:
                                        t = 1;
                                        break;
                                    case 1:
                                        t = 2;
                                        break;
                                    case 2:
                                        break;
                                    default:
                                        throw new Error("impossible state");
                                }
                                break;
                            case 62:
                                2 === t && this.fail('the string "]]>" is disallowed in char data.'), t = 0;
                                break;
                            case -2:
                                void 0 !== n && (this.text += r.slice(e, this.prevI) + "\n"), e = this.i, t = 0;
                                break;
                            case -1:
                                void 0 !== n && (this.text += r.slice(e));
                                break e;
                            default:
                                t = 0;
                        }
                        this.forbiddenState = t;
                    }
                    handleTextOutsideRoot() {
                        let { i: e } = this;
                        const { chunk: t, textHandler: r } = this;
                        let n = !1;
                        e: for(;;){
                            const i = this.getCode();
                            switch(i){
                                case 60:
                                    if (this.state = 15, void 0 !== r) {
                                        const { text: n } = this, i = t.slice(e, this.prevI);
                                        0 !== n.length ? (r(n + i), this.text = "") : 0 !== i.length && r(i);
                                    }
                                    break e;
                                case 38:
                                    this.state = 14, this.entityReturnState = 13, void 0 !== r && (this.text += t.slice(e, this.prevI)), n = !0;
                                    break e;
                                case -2:
                                    void 0 !== r && (this.text += t.slice(e, this.prevI) + "\n"), e = this.i;
                                    break;
                                case -1:
                                    void 0 !== r && (this.text += t.slice(e));
                                    break e;
                                default:
                                    o(i) || (n = !0);
                            }
                        }
                        n && (this.sawRoot || this.reportedTextBeforeRoot || (this.fail("text data outside of root node."), this.reportedTextBeforeRoot = !0), this.closedRoot && !this.reportedTextAfterRoot && (this.fail("text data outside of root node."), this.reportedTextAfterRoot = !0));
                    }
                    pushAttribNS(e, t) {
                        var r;
                        const { prefix: n, local: i } = this.qname(e), s = {
                            name: e,
                            prefix: n,
                            local: i,
                            value: t
                        };
                        if (this.attribList.push(s), null === (r = this.attributeHandler) || void 0 === r || r.call(this, s), "xmlns" === n) {
                            const e = t.trim();
                            "1.0" === this.currentXMLVersion && "" === e && this.fail("invalid attempt to undefine prefix in XML 1.0"), this.topNS[i] = e, C(this, i, e);
                        } else if ("xmlns" === e) {
                            const e = t.trim();
                            this.topNS[""] = e, C(this, "", e);
                        }
                    }
                    pushAttribPlain(e, t) {
                        var r;
                        const n = {
                            name: e,
                            value: t
                        };
                        this.attribList.push(n), null === (r = this.attributeHandler) || void 0 === r || r.call(this, n);
                    }
                    end() {
                        var e, t;
                        this.sawRoot || this.fail("document must contain a root element.");
                        const { tags: r } = this;
                        for(; r.length > 0;){
                            const e = r.pop();
                            this.fail("unclosed tag: " + e.name);
                        }
                        0 !== this.state && 13 !== this.state && this.fail("unexpected end.");
                        const { text: n } = this;
                        return 0 !== n.length && (null === (e = this.textHandler) || void 0 === e || e.call(this, n), this.text = ""), this._closed = !0, null === (t = this.endHandler) || void 0 === t || t.call(this), this._init(), this;
                    }
                    resolve(e) {
                        var t, r;
                        let n = this.topNS[e];
                        if (void 0 !== n) return n;
                        const { tags: i } = this;
                        for(let t = i.length - 1; t >= 0; t--)if (n = i[t].ns[e], void 0 !== n) return n;
                        return n = this.ns[e], void 0 !== n ? n : null === (r = (t = this.opt).resolvePrefix) || void 0 === r ? void 0 : r.call(t, e);
                    }
                    qname(e) {
                        const t = e.indexOf(":");
                        if (-1 === t) return {
                            prefix: "",
                            local: e
                        };
                        const r = e.slice(t + 1), n = e.slice(0, t);
                        return ("" === n || "" === r || r.includes(":")) && this.fail(`malformed name: ${e}.`), {
                            prefix: n,
                            local: r
                        };
                    }
                    processAttribsNS() {
                        var e;
                        const { attribList: t } = this, r = this.tag;
                        {
                            const { prefix: t, local: n } = this.qname(r.name);
                            r.prefix = t, r.local = n;
                            const i = r.uri = null !== (e = this.resolve(t)) && void 0 !== e ? e : "";
                            "" !== t && ("xmlns" === t && this.fail('tags may not have "xmlns" as prefix.'), "" === i && (this.fail(`unbound namespace prefix: ${JSON.stringify(t)}.`), r.uri = t));
                        }
                        if (0 === t.length) return;
                        const { attributes: n } = r, i = new Set;
                        for (const e of t){
                            const { name: t, prefix: r, local: s } = e;
                            let o, a;
                            "" === r ? (o = "xmlns" === t ? g : "", a = t) : (o = this.resolve(r), void 0 === o && (this.fail(`unbound namespace prefix: ${JSON.stringify(r)}.`), o = r), a = `{${o}}${s}`), i.has(a) && this.fail(`duplicate attribute: ${a}.`), i.add(a), e.uri = o, n[t] = e;
                        }
                        this.attribList = [];
                    }
                    processAttribsPlain() {
                        const { attribList: e } = this, t = this.tag.attributes;
                        for (const { name: r, value: n } of e)void 0 !== t[r] && this.fail(`duplicate attribute: ${r}.`), t[r] = n;
                        this.attribList = [];
                    }
                    openTag() {
                        var e;
                        this.processAttribs();
                        const { tags: t } = this, r = this.tag;
                        r.isSelfClosing = !1, null === (e = this.openTagHandler) || void 0 === e || e.call(this, r), t.push(r), this.state = 13, this.name = "";
                    }
                    openSelfClosingTag() {
                        var e, t, r;
                        this.processAttribs();
                        const { tags: n } = this, i = this.tag;
                        i.isSelfClosing = !0, null === (e = this.openTagHandler) || void 0 === e || e.call(this, i), null === (t = this.closeTagHandler) || void 0 === t || t.call(this, i);
                        null === (this.tag = null !== (r = n[n.length - 1]) && void 0 !== r ? r : null) && (this.closedRoot = !0), this.state = 13, this.name = "";
                    }
                    closeTag() {
                        const { tags: e, name: t } = this;
                        if (this.state = 13, this.name = "", "" === t) return this.fail("weird empty close tag."), void (this.text += "</>");
                        const r = this.closeTagHandler;
                        let n = e.length;
                        for(; n-- > 0;){
                            const n = this.tag = e.pop();
                            if (this.topNS = n.ns, null == r || r(n), n.name === t) break;
                            this.fail("unexpected close tag.");
                        }
                        0 === n ? this.closedRoot = !0 : n < 0 && (this.fail(`unmatched closing tag: ${t}.`), this.text += `</${t}>`);
                    }
                    parseEntity(e) {
                        if ("#" !== e[0]) {
                            const t = this.ENTITIES[e];
                            return void 0 !== t ? t : (this.fail(this.isName(e) ? "undefined entity." : "disallowed character in entity name."), `&${e};`);
                        }
                        let t = NaN;
                        return "x" === e[1] && /^#x[0-9a-f]+$/i.test(e) ? t = parseInt(e.slice(2), 16) : /^#[0-9]+$/.test(e) && (t = parseInt(e.slice(1), 10)), this.isChar(t) ? String.fromCodePoint(t) : (this.fail("malformed character entity."), `&${e};`);
                    }
                };
            },
            {
                "xmlchars/xml/1.0/ed5": 543,
                "xmlchars/xml/1.1/ed2": 544,
                "xmlchars/xmlns/1.0/ed3": 545
            }
        ],
        497: [
            function(e, t, r) {
                "use strict";
                var n = e("safe-buffer").Buffer;
                function i(e, t) {
                    this._block = n.alloc(e), this._finalSize = t, this._blockSize = e, this._len = 0;
                }
                i.prototype.update = function(e, t) {
                    "string" == typeof e && (t = t || "utf8", e = n.from(e, t));
                    for(var r = this._block, i = this._blockSize, s = e.length, o = this._len, a = 0; a < s;){
                        for(var l = o % i, c = Math.min(s - a, i - l), u = 0; u < c; u++)r[l + u] = e[a + u];
                        a += c, (o += c) % i == 0 && this._update(r);
                    }
                    return this._len += s, this;
                }, i.prototype.digest = function(e) {
                    var t = this._len % this._blockSize;
                    this._block[t] = 128, this._block.fill(0, t + 1), t >= this._finalSize && (this._update(this._block), this._block.fill(0));
                    var r = 8 * this._len;
                    if (r <= 4294967295) this._block.writeUInt32BE(r, this._blockSize - 4);
                    else {
                        var n = (4294967295 & r) >>> 0, i = (r - n) / 4294967296;
                        this._block.writeUInt32BE(i, this._blockSize - 8), this._block.writeUInt32BE(n, this._blockSize - 4);
                    }
                    this._update(this._block);
                    var s = this._hash();
                    return e ? s.toString(e) : s;
                }, i.prototype._update = function() {
                    throw new Error("_update must be implemented by subclass");
                }, t.exports = i;
            },
            {
                "safe-buffer": 494
            }
        ],
        498: [
            function(e, t, r) {
                "use strict";
                var n = t.exports = function(e) {
                    e = e.toLowerCase();
                    var t = n[e];
                    if (!t) throw new Error(e + " is not supported (we accept pull requests)");
                    return new t;
                };
                n.sha = e("./sha"), n.sha1 = e("./sha1"), n.sha224 = e("./sha224"), n.sha256 = e("./sha256"), n.sha384 = e("./sha384"), n.sha512 = e("./sha512");
            },
            {
                "./sha": 499,
                "./sha1": 500,
                "./sha224": 501,
                "./sha256": 502,
                "./sha384": 503,
                "./sha512": 504
            }
        ],
        499: [
            function(e, t, r) {
                "use strict";
                var n = e("inherits"), i = e("./hash"), s = e("safe-buffer").Buffer, o = [
                    1518500249,
                    1859775393,
                    -1894007588,
                    -899497514
                ], a = new Array(80);
                function l() {
                    this.init(), this._w = a, i.call(this, 64, 56);
                }
                function c(e) {
                    return e << 30 | e >>> 2;
                }
                function u(e, t, r, n) {
                    return 0 === e ? t & r | ~t & n : 2 === e ? t & r | t & n | r & n : t ^ r ^ n;
                }
                n(l, i), l.prototype.init = function() {
                    return this._a = 1732584193, this._b = 4023233417, this._c = 2562383102, this._d = 271733878, this._e = 3285377520, this;
                }, l.prototype._update = function(e) {
                    for(var t, r = this._w, n = 0 | this._a, i = 0 | this._b, s = 0 | this._c, a = 0 | this._d, l = 0 | this._e, h = 0; h < 16; ++h)r[h] = e.readInt32BE(4 * h);
                    for(; h < 80; ++h)r[h] = r[h - 3] ^ r[h - 8] ^ r[h - 14] ^ r[h - 16];
                    for(var f = 0; f < 80; ++f){
                        var d = ~~(f / 20), p = 0 | ((t = n) << 5 | t >>> 27) + u(d, i, s, a) + l + r[f] + o[d];
                        l = a, a = s, s = c(i), i = n, n = p;
                    }
                    this._a = n + this._a | 0, this._b = i + this._b | 0, this._c = s + this._c | 0, this._d = a + this._d | 0, this._e = l + this._e | 0;
                }, l.prototype._hash = function() {
                    var e = s.allocUnsafe(20);
                    return e.writeInt32BE(0 | this._a, 0), e.writeInt32BE(0 | this._b, 4), e.writeInt32BE(0 | this._c, 8), e.writeInt32BE(0 | this._d, 12), e.writeInt32BE(0 | this._e, 16), e;
                }, t.exports = l;
            },
            {
                "./hash": 497,
                inherits: 440,
                "safe-buffer": 494
            }
        ],
        500: [
            function(e, t, r) {
                "use strict";
                var n = e("inherits"), i = e("./hash"), s = e("safe-buffer").Buffer, o = [
                    1518500249,
                    1859775393,
                    -1894007588,
                    -899497514
                ], a = new Array(80);
                function l() {
                    this.init(), this._w = a, i.call(this, 64, 56);
                }
                function c(e) {
                    return e << 5 | e >>> 27;
                }
                function u(e) {
                    return e << 30 | e >>> 2;
                }
                function h(e, t, r, n) {
                    return 0 === e ? t & r | ~t & n : 2 === e ? t & r | t & n | r & n : t ^ r ^ n;
                }
                n(l, i), l.prototype.init = function() {
                    return this._a = 1732584193, this._b = 4023233417, this._c = 2562383102, this._d = 271733878, this._e = 3285377520, this;
                }, l.prototype._update = function(e) {
                    for(var t, r = this._w, n = 0 | this._a, i = 0 | this._b, s = 0 | this._c, a = 0 | this._d, l = 0 | this._e, f = 0; f < 16; ++f)r[f] = e.readInt32BE(4 * f);
                    for(; f < 80; ++f)r[f] = (t = r[f - 3] ^ r[f - 8] ^ r[f - 14] ^ r[f - 16]) << 1 | t >>> 31;
                    for(var d = 0; d < 80; ++d){
                        var p = ~~(d / 20), m = c(n) + h(p, i, s, a) + l + r[d] + o[p] | 0;
                        l = a, a = s, s = u(i), i = n, n = m;
                    }
                    this._a = n + this._a | 0, this._b = i + this._b | 0, this._c = s + this._c | 0, this._d = a + this._d | 0, this._e = l + this._e | 0;
                }, l.prototype._hash = function() {
                    var e = s.allocUnsafe(20);
                    return e.writeInt32BE(0 | this._a, 0), e.writeInt32BE(0 | this._b, 4), e.writeInt32BE(0 | this._c, 8), e.writeInt32BE(0 | this._d, 12), e.writeInt32BE(0 | this._e, 16), e;
                }, t.exports = l;
            },
            {
                "./hash": 497,
                inherits: 440,
                "safe-buffer": 494
            }
        ],
        501: [
            function(e, t, r) {
                "use strict";
                var n = e("inherits"), i = e("./sha256"), s = e("./hash"), o = e("safe-buffer").Buffer, a = new Array(64);
                function l() {
                    this.init(), this._w = a, s.call(this, 64, 56);
                }
                n(l, i), l.prototype.init = function() {
                    return this._a = 3238371032, this._b = 914150663, this._c = 812702999, this._d = 4144912697, this._e = 4290775857, this._f = 1750603025, this._g = 1694076839, this._h = 3204075428, this;
                }, l.prototype._hash = function() {
                    var e = o.allocUnsafe(28);
                    return e.writeInt32BE(this._a, 0), e.writeInt32BE(this._b, 4), e.writeInt32BE(this._c, 8), e.writeInt32BE(this._d, 12), e.writeInt32BE(this._e, 16), e.writeInt32BE(this._f, 20), e.writeInt32BE(this._g, 24), e;
                }, t.exports = l;
            },
            {
                "./hash": 497,
                "./sha256": 502,
                inherits: 440,
                "safe-buffer": 494
            }
        ],
        502: [
            function(e, t, r) {
                "use strict";
                var n = e("inherits"), i = e("./hash"), s = e("safe-buffer").Buffer, o = [
                    1116352408,
                    1899447441,
                    3049323471,
                    3921009573,
                    961987163,
                    1508970993,
                    2453635748,
                    2870763221,
                    3624381080,
                    310598401,
                    607225278,
                    1426881987,
                    1925078388,
                    2162078206,
                    2614888103,
                    3248222580,
                    3835390401,
                    4022224774,
                    264347078,
                    604807628,
                    770255983,
                    1249150122,
                    1555081692,
                    1996064986,
                    2554220882,
                    2821834349,
                    2952996808,
                    3210313671,
                    3336571891,
                    3584528711,
                    113926993,
                    338241895,
                    666307205,
                    773529912,
                    1294757372,
                    1396182291,
                    1695183700,
                    1986661051,
                    2177026350,
                    2456956037,
                    2730485921,
                    2820302411,
                    3259730800,
                    3345764771,
                    3516065817,
                    3600352804,
                    4094571909,
                    275423344,
                    430227734,
                    506948616,
                    659060556,
                    883997877,
                    958139571,
                    1322822218,
                    1537002063,
                    1747873779,
                    1955562222,
                    2024104815,
                    2227730452,
                    2361852424,
                    2428436474,
                    2756734187,
                    3204031479,
                    3329325298
                ], a = new Array(64);
                function l() {
                    this.init(), this._w = a, i.call(this, 64, 56);
                }
                function c(e, t, r) {
                    return r ^ e & (t ^ r);
                }
                function u(e, t, r) {
                    return e & t | r & (e | t);
                }
                function h(e) {
                    return (e >>> 2 | e << 30) ^ (e >>> 13 | e << 19) ^ (e >>> 22 | e << 10);
                }
                function f(e) {
                    return (e >>> 6 | e << 26) ^ (e >>> 11 | e << 21) ^ (e >>> 25 | e << 7);
                }
                function d(e) {
                    return (e >>> 7 | e << 25) ^ (e >>> 18 | e << 14) ^ e >>> 3;
                }
                n(l, i), l.prototype.init = function() {
                    return this._a = 1779033703, this._b = 3144134277, this._c = 1013904242, this._d = 2773480762, this._e = 1359893119, this._f = 2600822924, this._g = 528734635, this._h = 1541459225, this;
                }, l.prototype._update = function(e) {
                    for(var t, r = this._w, n = 0 | this._a, i = 0 | this._b, s = 0 | this._c, a = 0 | this._d, l = 0 | this._e, p = 0 | this._f, m = 0 | this._g, b = 0 | this._h, g = 0; g < 16; ++g)r[g] = e.readInt32BE(4 * g);
                    for(; g < 64; ++g)r[g] = 0 | (((t = r[g - 2]) >>> 17 | t << 15) ^ (t >>> 19 | t << 13) ^ t >>> 10) + r[g - 7] + d(r[g - 15]) + r[g - 16];
                    for(var y = 0; y < 64; ++y){
                        var v = b + f(l) + c(l, p, m) + o[y] + r[y] | 0, w = h(n) + u(n, i, s) | 0;
                        b = m, m = p, p = l, l = a + v | 0, a = s, s = i, i = n, n = v + w | 0;
                    }
                    this._a = n + this._a | 0, this._b = i + this._b | 0, this._c = s + this._c | 0, this._d = a + this._d | 0, this._e = l + this._e | 0, this._f = p + this._f | 0, this._g = m + this._g | 0, this._h = b + this._h | 0;
                }, l.prototype._hash = function() {
                    var e = s.allocUnsafe(32);
                    return e.writeInt32BE(this._a, 0), e.writeInt32BE(this._b, 4), e.writeInt32BE(this._c, 8), e.writeInt32BE(this._d, 12), e.writeInt32BE(this._e, 16), e.writeInt32BE(this._f, 20), e.writeInt32BE(this._g, 24), e.writeInt32BE(this._h, 28), e;
                }, t.exports = l;
            },
            {
                "./hash": 497,
                inherits: 440,
                "safe-buffer": 494
            }
        ],
        503: [
            function(e, t, r) {
                "use strict";
                var n = e("inherits"), i = e("./sha512"), s = e("./hash"), o = e("safe-buffer").Buffer, a = new Array(160);
                function l() {
                    this.init(), this._w = a, s.call(this, 128, 112);
                }
                n(l, i), l.prototype.init = function() {
                    return this._ah = 3418070365, this._bh = 1654270250, this._ch = 2438529370, this._dh = 355462360, this._eh = 1731405415, this._fh = 2394180231, this._gh = 3675008525, this._hh = 1203062813, this._al = 3238371032, this._bl = 914150663, this._cl = 812702999, this._dl = 4144912697, this._el = 4290775857, this._fl = 1750603025, this._gl = 1694076839, this._hl = 3204075428, this;
                }, l.prototype._hash = function() {
                    var e = o.allocUnsafe(48);
                    function t(t, r, n) {
                        e.writeInt32BE(t, n), e.writeInt32BE(r, n + 4);
                    }
                    return t(this._ah, this._al, 0), t(this._bh, this._bl, 8), t(this._ch, this._cl, 16), t(this._dh, this._dl, 24), t(this._eh, this._el, 32), t(this._fh, this._fl, 40), e;
                }, t.exports = l;
            },
            {
                "./hash": 497,
                "./sha512": 504,
                inherits: 440,
                "safe-buffer": 494
            }
        ],
        504: [
            function(e, t, r) {
                "use strict";
                var n = e("inherits"), i = e("./hash"), s = e("safe-buffer").Buffer, o = [
                    1116352408,
                    3609767458,
                    1899447441,
                    602891725,
                    3049323471,
                    3964484399,
                    3921009573,
                    2173295548,
                    961987163,
                    4081628472,
                    1508970993,
                    3053834265,
                    2453635748,
                    2937671579,
                    2870763221,
                    3664609560,
                    3624381080,
                    2734883394,
                    310598401,
                    1164996542,
                    607225278,
                    1323610764,
                    1426881987,
                    3590304994,
                    1925078388,
                    4068182383,
                    2162078206,
                    991336113,
                    2614888103,
                    633803317,
                    3248222580,
                    3479774868,
                    3835390401,
                    2666613458,
                    4022224774,
                    944711139,
                    264347078,
                    2341262773,
                    604807628,
                    2007800933,
                    770255983,
                    1495990901,
                    1249150122,
                    1856431235,
                    1555081692,
                    3175218132,
                    1996064986,
                    2198950837,
                    2554220882,
                    3999719339,
                    2821834349,
                    766784016,
                    2952996808,
                    2566594879,
                    3210313671,
                    3203337956,
                    3336571891,
                    1034457026,
                    3584528711,
                    2466948901,
                    113926993,
                    3758326383,
                    338241895,
                    168717936,
                    666307205,
                    1188179964,
                    773529912,
                    1546045734,
                    1294757372,
                    1522805485,
                    1396182291,
                    2643833823,
                    1695183700,
                    2343527390,
                    1986661051,
                    1014477480,
                    2177026350,
                    1206759142,
                    2456956037,
                    344077627,
                    2730485921,
                    1290863460,
                    2820302411,
                    3158454273,
                    3259730800,
                    3505952657,
                    3345764771,
                    106217008,
                    3516065817,
                    3606008344,
                    3600352804,
                    1432725776,
                    4094571909,
                    1467031594,
                    275423344,
                    851169720,
                    430227734,
                    3100823752,
                    506948616,
                    1363258195,
                    659060556,
                    3750685593,
                    883997877,
                    3785050280,
                    958139571,
                    3318307427,
                    1322822218,
                    3812723403,
                    1537002063,
                    2003034995,
                    1747873779,
                    3602036899,
                    1955562222,
                    1575990012,
                    2024104815,
                    1125592928,
                    2227730452,
                    2716904306,
                    2361852424,
                    442776044,
                    2428436474,
                    593698344,
                    2756734187,
                    3733110249,
                    3204031479,
                    2999351573,
                    3329325298,
                    3815920427,
                    3391569614,
                    3928383900,
                    3515267271,
                    566280711,
                    3940187606,
                    3454069534,
                    4118630271,
                    4000239992,
                    116418474,
                    1914138554,
                    174292421,
                    2731055270,
                    289380356,
                    3203993006,
                    460393269,
                    320620315,
                    685471733,
                    587496836,
                    852142971,
                    1086792851,
                    1017036298,
                    365543100,
                    1126000580,
                    2618297676,
                    1288033470,
                    3409855158,
                    1501505948,
                    4234509866,
                    1607167915,
                    987167468,
                    1816402316,
                    1246189591
                ], a = new Array(160);
                function l() {
                    this.init(), this._w = a, i.call(this, 128, 112);
                }
                function c(e, t, r) {
                    return r ^ e & (t ^ r);
                }
                function u(e, t, r) {
                    return e & t | r & (e | t);
                }
                function h(e, t) {
                    return (e >>> 28 | t << 4) ^ (t >>> 2 | e << 30) ^ (t >>> 7 | e << 25);
                }
                function f(e, t) {
                    return (e >>> 14 | t << 18) ^ (e >>> 18 | t << 14) ^ (t >>> 9 | e << 23);
                }
                function d(e, t) {
                    return (e >>> 1 | t << 31) ^ (e >>> 8 | t << 24) ^ e >>> 7;
                }
                function p(e, t) {
                    return (e >>> 1 | t << 31) ^ (e >>> 8 | t << 24) ^ (e >>> 7 | t << 25);
                }
                function m(e, t) {
                    return (e >>> 19 | t << 13) ^ (t >>> 29 | e << 3) ^ e >>> 6;
                }
                function b(e, t) {
                    return (e >>> 19 | t << 13) ^ (t >>> 29 | e << 3) ^ (e >>> 6 | t << 26);
                }
                function g(e, t) {
                    return e >>> 0 < t >>> 0 ? 1 : 0;
                }
                n(l, i), l.prototype.init = function() {
                    return this._ah = 1779033703, this._bh = 3144134277, this._ch = 1013904242, this._dh = 2773480762, this._eh = 1359893119, this._fh = 2600822924, this._gh = 528734635, this._hh = 1541459225, this._al = 4089235720, this._bl = 2227873595, this._cl = 4271175723, this._dl = 1595750129, this._el = 2917565137, this._fl = 725511199, this._gl = 4215389547, this._hl = 327033209, this;
                }, l.prototype._update = function(e) {
                    for(var t = this._w, r = 0 | this._ah, n = 0 | this._bh, i = 0 | this._ch, s = 0 | this._dh, a = 0 | this._eh, l = 0 | this._fh, y = 0 | this._gh, v = 0 | this._hh, w = 0 | this._al, _ = 0 | this._bl, x = 0 | this._cl, k = 0 | this._dl, S = 0 | this._el, M = 0 | this._fl, C = 0 | this._gl, T = 0 | this._hl, E = 0; E < 32; E += 2)t[E] = e.readInt32BE(4 * E), t[E + 1] = e.readInt32BE(4 * E + 4);
                    for(; E < 160; E += 2){
                        var A = t[E - 30], R = t[E - 30 + 1], O = d(A, R), j = p(R, A), I = m(A = t[E - 4], R = t[E - 4 + 1]), N = b(R, A), P = t[E - 14], B = t[E - 14 + 1], D = t[E - 32], F = t[E - 32 + 1], L = j + B | 0, z = O + P + g(L, j) | 0;
                        z = (z = z + I + g(L = L + N | 0, N) | 0) + D + g(L = L + F | 0, F) | 0, t[E] = z, t[E + 1] = L;
                    }
                    for(var U = 0; U < 160; U += 2){
                        z = t[U], L = t[U + 1];
                        var $ = u(r, n, i), H = u(w, _, x), V = h(r, w), q = h(w, r), W = f(a, S), X = f(S, a), K = o[U], Y = o[U + 1], Z = c(a, l, y), G = c(S, M, C), J = T + X | 0, Q = v + W + g(J, T) | 0;
                        Q = (Q = (Q = Q + Z + g(J = J + G | 0, G) | 0) + K + g(J = J + Y | 0, Y) | 0) + z + g(J = J + L | 0, L) | 0;
                        var ee = q + H | 0, te = V + $ + g(ee, q) | 0;
                        v = y, T = C, y = l, C = M, l = a, M = S, a = s + Q + g(S = k + J | 0, k) | 0, s = i, k = x, i = n, x = _, n = r, _ = w, r = Q + te + g(w = J + ee | 0, J) | 0;
                    }
                    this._al = this._al + w | 0, this._bl = this._bl + _ | 0, this._cl = this._cl + x | 0, this._dl = this._dl + k | 0, this._el = this._el + S | 0, this._fl = this._fl + M | 0, this._gl = this._gl + C | 0, this._hl = this._hl + T | 0, this._ah = this._ah + r + g(this._al, w) | 0, this._bh = this._bh + n + g(this._bl, _) | 0, this._ch = this._ch + i + g(this._cl, x) | 0, this._dh = this._dh + s + g(this._dl, k) | 0, this._eh = this._eh + a + g(this._el, S) | 0, this._fh = this._fh + l + g(this._fl, M) | 0, this._gh = this._gh + y + g(this._gl, C) | 0, this._hh = this._hh + v + g(this._hl, T) | 0;
                }, l.prototype._hash = function() {
                    var e = s.allocUnsafe(64);
                    function t(t, r, n) {
                        e.writeInt32BE(t, n), e.writeInt32BE(r, n + 4);
                    }
                    return t(this._ah, this._al, 0), t(this._bh, this._bl, 8), t(this._ch, this._cl, 16), t(this._dh, this._dl, 24), t(this._eh, this._el, 32), t(this._fh, this._fl, 40), t(this._gh, this._gl, 48), t(this._hh, this._hl, 56), e;
                }, t.exports = l;
            },
            {
                "./hash": 497,
                inherits: 440,
                "safe-buffer": 494
            }
        ],
        505: [
            function(e, t, r) {
                "use strict";
                t.exports = i;
                var n = e("events").EventEmitter;
                function i() {
                    n.call(this);
                }
                e("inherits")(i, n), i.Readable = e("readable-stream/readable.js"), i.Writable = e("readable-stream/writable.js"), i.Duplex = e("readable-stream/duplex.js"), i.Transform = e("readable-stream/transform.js"), i.PassThrough = e("readable-stream/passthrough.js"), i.Stream = i, i.prototype.pipe = function(e, t) {
                    var r = this;
                    function i(t) {
                        e.writable && !1 === e.write(t) && r.pause && r.pause();
                    }
                    function s() {
                        r.readable && r.resume && r.resume();
                    }
                    r.on("data", i), e.on("drain", s), e._isStdio || t && !1 === t.end || (r.on("end", a), r.on("close", l));
                    var o = !1;
                    function a() {
                        o || (o = !0, e.end());
                    }
                    function l() {
                        o || (o = !0, "function" == typeof e.destroy && e.destroy());
                    }
                    function c(e) {
                        if (u(), 0 === n.listenerCount(this, "error")) throw e;
                    }
                    function u() {
                        r.removeListener("data", i), e.removeListener("drain", s), r.removeListener("end", a), r.removeListener("close", l), r.removeListener("error", c), e.removeListener("error", c), r.removeListener("end", u), r.removeListener("close", u), e.removeListener("close", u);
                    }
                    return r.on("error", c), e.on("error", c), r.on("end", u), r.on("close", u), e.on("close", u), e.emit("pipe", r), e;
                };
            },
            {
                events: 422,
                inherits: 440,
                "readable-stream/duplex.js": 507,
                "readable-stream/passthrough.js": 516,
                "readable-stream/readable.js": 517,
                "readable-stream/transform.js": 518,
                "readable-stream/writable.js": 519
            }
        ],
        506: [
            function(e, t, r) {
                "use strict";
                var n = {}.toString;
                t.exports = Array.isArray || function(e) {
                    return "[object Array]" == n.call(e);
                };
            },
            {}
        ],
        507: [
            function(e, t, r) {
                "use strict";
                t.exports = e("./lib/_stream_duplex.js");
            },
            {
                "./lib/_stream_duplex.js": 508
            }
        ],
        508: [
            function(e, t, r) {
                "use strict";
                var n = e("process-nextick-args"), i = Object.keys || function(e) {
                    var t = [];
                    for(var r in e)t.push(r);
                    return t;
                };
                t.exports = h;
                var s = Object.create(e("core-util-is"));
                s.inherits = e("inherits");
                var o = e("./_stream_readable"), a = e("./_stream_writable");
                s.inherits(h, o);
                for(var l = i(a.prototype), c = 0; c < l.length; c++){
                    var u = l[c];
                    h.prototype[u] || (h.prototype[u] = a.prototype[u]);
                }
                function h(e) {
                    if (!(this instanceof h)) return new h(e);
                    o.call(this, e), a.call(this, e), e && !1 === e.readable && (this.readable = !1), e && !1 === e.writable && (this.writable = !1), this.allowHalfOpen = !0, e && !1 === e.allowHalfOpen && (this.allowHalfOpen = !1), this.once("end", f);
                }
                function f() {
                    this.allowHalfOpen || this._writableState.ended || n.nextTick(d, this);
                }
                function d(e) {
                    e.end();
                }
                Object.defineProperty(h.prototype, "writableHighWaterMark", {
                    enumerable: !1,
                    get: function() {
                        return this._writableState.highWaterMark;
                    }
                }), Object.defineProperty(h.prototype, "destroyed", {
                    get: function() {
                        return void 0 !== this._readableState && void 0 !== this._writableState && this._readableState.destroyed && this._writableState.destroyed;
                    },
                    set: function(e) {
                        void 0 !== this._readableState && void 0 !== this._writableState && (this._readableState.destroyed = e, this._writableState.destroyed = e);
                    }
                }), h.prototype._destroy = function(e, t) {
                    this.push(null), this.end(), n.nextTick(t, e);
                };
            },
            {
                "./_stream_readable": 510,
                "./_stream_writable": 512,
                "core-util-is": 383,
                inherits: 440,
                "process-nextick-args": 466
            }
        ],
        509: [
            function(e, t, r) {
                "use strict";
                t.exports = s;
                var n = e("./_stream_transform"), i = Object.create(e("core-util-is"));
                function s(e) {
                    if (!(this instanceof s)) return new s(e);
                    n.call(this, e);
                }
                i.inherits = e("inherits"), i.inherits(s, n), s.prototype._transform = function(e, t, r) {
                    r(null, e);
                };
            },
            {
                "./_stream_transform": 511,
                "core-util-is": 383,
                inherits: 440
            }
        ],
        510: [
            function(e, t, r) {
                (function(r, n) {
                    (function() {
                        "use strict";
                        var i = e("process-nextick-args");
                        t.exports = v;
                        var s, o = e("isarray");
                        v.ReadableState = y;
                        e("events").EventEmitter;
                        var a = function(e, t) {
                            return e.listeners(t).length;
                        }, l = e("./internal/streams/stream"), c = e("safe-buffer").Buffer, u = (void 0 !== n ? n : "undefined" != typeof window ? window : "undefined" != typeof self ? self : {}).Uint8Array || function() {};
                        var h = Object.create(e("core-util-is"));
                        h.inherits = e("inherits");
                        var f = e("util"), d = void 0;
                        d = f && f.debuglog ? f.debuglog("stream") : function() {};
                        var p, m = e("./internal/streams/BufferList"), b = e("./internal/streams/destroy");
                        h.inherits(v, l);
                        var g = [
                            "error",
                            "close",
                            "destroy",
                            "pause",
                            "resume"
                        ];
                        function y(t, r) {
                            t = t || {};
                            var n = r instanceof (s = s || e("./_stream_duplex"));
                            this.objectMode = !!t.objectMode, n && (this.objectMode = this.objectMode || !!t.readableObjectMode);
                            var i = t.highWaterMark, o = t.readableHighWaterMark, a = this.objectMode ? 16 : 16384;
                            this.highWaterMark = i || 0 === i ? i : n && (o || 0 === o) ? o : a, this.highWaterMark = Math.floor(this.highWaterMark), this.buffer = new m, this.length = 0, this.pipes = null, this.pipesCount = 0, this.flowing = null, this.ended = !1, this.endEmitted = !1, this.reading = !1, this.sync = !0, this.needReadable = !1, this.emittedReadable = !1, this.readableListening = !1, this.resumeScheduled = !1, this.destroyed = !1, this.defaultEncoding = t.defaultEncoding || "utf8", this.awaitDrain = 0, this.readingMore = !1, this.decoder = null, this.encoding = null, t.encoding && (p || (p = e("string_decoder/").StringDecoder), this.decoder = new p(t.encoding), this.encoding = t.encoding);
                        }
                        function v(t) {
                            if (s = s || e("./_stream_duplex"), !(this instanceof v)) return new v(t);
                            this._readableState = new y(t, this), this.readable = !0, t && ("function" == typeof t.read && (this._read = t.read), "function" == typeof t.destroy && (this._destroy = t.destroy)), l.call(this);
                        }
                        function w(e, t, r, n, i) {
                            var s, o = e._readableState;
                            null === t ? (o.reading = !1, function(e, t) {
                                if (t.ended) return;
                                if (t.decoder) {
                                    var r = t.decoder.end();
                                    r && r.length && (t.buffer.push(r), t.length += t.objectMode ? 1 : r.length);
                                }
                                t.ended = !0, k(e);
                            }(e, o)) : (i || (s = function(e, t) {
                                var r;
                                n = t, c.isBuffer(n) || n instanceof u || "string" == typeof t || void 0 === t || e.objectMode || (r = new TypeError("Invalid non-string/buffer chunk"));
                                var n;
                                return r;
                            }(o, t)), s ? e.emit("error", s) : o.objectMode || t && t.length > 0 ? ("string" == typeof t || o.objectMode || Object.getPrototypeOf(t) === c.prototype || (t = function(e) {
                                return c.from(e);
                            }(t)), n ? o.endEmitted ? e.emit("error", new Error("stream.unshift() after end event")) : _(e, o, t, !0) : o.ended ? e.emit("error", new Error("stream.push() after EOF")) : (o.reading = !1, o.decoder && !r ? (t = o.decoder.write(t), o.objectMode || 0 !== t.length ? _(e, o, t, !1) : M(e, o)) : _(e, o, t, !1))) : n || (o.reading = !1));
                            return function(e) {
                                return !e.ended && (e.needReadable || e.length < e.highWaterMark || 0 === e.length);
                            }(o);
                        }
                        function _(e, t, r, n) {
                            t.flowing && 0 === t.length && !t.sync ? (e.emit("data", r), e.read(0)) : (t.length += t.objectMode ? 1 : r.length, n ? t.buffer.unshift(r) : t.buffer.push(r), t.needReadable && k(e)), M(e, t);
                        }
                        Object.defineProperty(v.prototype, "destroyed", {
                            get: function() {
                                return void 0 !== this._readableState && this._readableState.destroyed;
                            },
                            set: function(e) {
                                this._readableState && (this._readableState.destroyed = e);
                            }
                        }), v.prototype.destroy = b.destroy, v.prototype._undestroy = b.undestroy, v.prototype._destroy = function(e, t) {
                            this.push(null), t(e);
                        }, v.prototype.push = function(e, t) {
                            var r, n = this._readableState;
                            return n.objectMode ? r = !0 : "string" == typeof e && ((t = t || n.defaultEncoding) !== n.encoding && (e = c.from(e, t), t = ""), r = !0), w(this, e, t, !1, r);
                        }, v.prototype.unshift = function(e) {
                            return w(this, e, null, !0, !1);
                        }, v.prototype.isPaused = function() {
                            return !1 === this._readableState.flowing;
                        }, v.prototype.setEncoding = function(t) {
                            return p || (p = e("string_decoder/").StringDecoder), this._readableState.decoder = new p(t), this._readableState.encoding = t, this;
                        };
                        function x(e, t) {
                            return e <= 0 || 0 === t.length && t.ended ? 0 : t.objectMode ? 1 : e != e ? t.flowing && t.length ? t.buffer.head.data.length : t.length : (e > t.highWaterMark && (t.highWaterMark = function(e) {
                                return e >= 8388608 ? e = 8388608 : (e--, e |= e >>> 1, e |= e >>> 2, e |= e >>> 4, e |= e >>> 8, e |= e >>> 16, e++), e;
                            }(e)), e <= t.length ? e : t.ended ? t.length : (t.needReadable = !0, 0));
                        }
                        function k(e) {
                            var t = e._readableState;
                            t.needReadable = !1, t.emittedReadable || (d("emitReadable", t.flowing), t.emittedReadable = !0, t.sync ? i.nextTick(S, e) : S(e));
                        }
                        function S(e) {
                            d("emit readable"), e.emit("readable"), A(e);
                        }
                        function M(e, t) {
                            t.readingMore || (t.readingMore = !0, i.nextTick(C, e, t));
                        }
                        function C(e, t) {
                            for(var r = t.length; !t.reading && !t.flowing && !t.ended && t.length < t.highWaterMark && (d("maybeReadMore read 0"), e.read(0), r !== t.length);)r = t.length;
                            t.readingMore = !1;
                        }
                        function T(e) {
                            d("readable nexttick read 0"), e.read(0);
                        }
                        function E(e, t) {
                            t.reading || (d("resume read 0"), e.read(0)), t.resumeScheduled = !1, t.awaitDrain = 0, e.emit("resume"), A(e), t.flowing && !t.reading && e.read(0);
                        }
                        function A(e) {
                            var t = e._readableState;
                            for(d("flow", t.flowing); t.flowing && null !== e.read(););
                        }
                        function R(e, t) {
                            var r;
                            return 0 === t.length ? null : (t.objectMode ? r = t.buffer.shift() : !e || e >= t.length ? (r = t.decoder ? t.buffer.join("") : 1 === t.buffer.length ? t.buffer.head.data : t.buffer.concat(t.length), t.buffer.clear()) : r = function(e, t, r) {
                                var n;
                                e < t.head.data.length ? (n = t.head.data.slice(0, e), t.head.data = t.head.data.slice(e)) : n = e === t.head.data.length ? t.shift() : r ? function(e, t) {
                                    var r = t.head, n = 1, i = r.data;
                                    e -= i.length;
                                    for(; r = r.next;){
                                        var s = r.data, o = e > s.length ? s.length : e;
                                        if (o === s.length ? i += s : i += s.slice(0, e), 0 === (e -= o)) {
                                            o === s.length ? (++n, r.next ? t.head = r.next : t.head = t.tail = null) : (t.head = r, r.data = s.slice(o));
                                            break;
                                        }
                                        ++n;
                                    }
                                    return t.length -= n, i;
                                }(e, t) : function(e, t) {
                                    var r = c.allocUnsafe(e), n = t.head, i = 1;
                                    n.data.copy(r), e -= n.data.length;
                                    for(; n = n.next;){
                                        var s = n.data, o = e > s.length ? s.length : e;
                                        if (s.copy(r, r.length - e, 0, o), 0 === (e -= o)) {
                                            o === s.length ? (++i, n.next ? t.head = n.next : t.head = t.tail = null) : (t.head = n, n.data = s.slice(o));
                                            break;
                                        }
                                        ++i;
                                    }
                                    return t.length -= i, r;
                                }(e, t);
                                return n;
                            }(e, t.buffer, t.decoder), r);
                        }
                        function O(e) {
                            var t = e._readableState;
                            if (t.length > 0) throw new Error('"endReadable()" called on non-empty stream');
                            t.endEmitted || (t.ended = !0, i.nextTick(j, t, e));
                        }
                        function j(e, t) {
                            e.endEmitted || 0 !== e.length || (e.endEmitted = !0, t.readable = !1, t.emit("end"));
                        }
                        function I(e, t) {
                            for(var r = 0, n = e.length; r < n; r++)if (e[r] === t) return r;
                            return -1;
                        }
                        v.prototype.read = function(e) {
                            d("read", e), e = parseInt(e, 10);
                            var t = this._readableState, r = e;
                            if (0 !== e && (t.emittedReadable = !1), 0 === e && t.needReadable && (t.length >= t.highWaterMark || t.ended)) return d("read: emitReadable", t.length, t.ended), 0 === t.length && t.ended ? O(this) : k(this), null;
                            if (0 === (e = x(e, t)) && t.ended) return 0 === t.length && O(this), null;
                            var n, i = t.needReadable;
                            return d("need readable", i), (0 === t.length || t.length - e < t.highWaterMark) && d("length less than watermark", i = !0), t.ended || t.reading ? d("reading or ended", i = !1) : i && (d("do read"), t.reading = !0, t.sync = !0, 0 === t.length && (t.needReadable = !0), this._read(t.highWaterMark), t.sync = !1, t.reading || (e = x(r, t))), null === (n = e > 0 ? R(e, t) : null) ? (t.needReadable = !0, e = 0) : t.length -= e, 0 === t.length && (t.ended || (t.needReadable = !0), r !== e && t.ended && O(this)), null !== n && this.emit("data", n), n;
                        }, v.prototype._read = function(e) {
                            this.emit("error", new Error("_read() is not implemented"));
                        }, v.prototype.pipe = function(e, t) {
                            var n = this, s = this._readableState;
                            switch(s.pipesCount){
                                case 0:
                                    s.pipes = e;
                                    break;
                                case 1:
                                    s.pipes = [
                                        s.pipes,
                                        e
                                    ];
                                    break;
                                default:
                                    s.pipes.push(e);
                            }
                            s.pipesCount += 1, d("pipe count=%d opts=%j", s.pipesCount, t);
                            var l = (!t || !1 !== t.end) && e !== r.stdout && e !== r.stderr ? u : v;
                            function c(t, r) {
                                d("onunpipe"), t === n && r && !1 === r.hasUnpiped && (r.hasUnpiped = !0, d("cleanup"), e.removeListener("close", g), e.removeListener("finish", y), e.removeListener("drain", h), e.removeListener("error", b), e.removeListener("unpipe", c), n.removeListener("end", u), n.removeListener("end", v), n.removeListener("data", m), f = !0, !s.awaitDrain || e._writableState && !e._writableState.needDrain || h());
                            }
                            function u() {
                                d("onend"), e.end();
                            }
                            s.endEmitted ? i.nextTick(l) : n.once("end", l), e.on("unpipe", c);
                            var h = function(e) {
                                return function() {
                                    var t = e._readableState;
                                    d("pipeOnDrain", t.awaitDrain), t.awaitDrain && t.awaitDrain--, 0 === t.awaitDrain && a(e, "data") && (t.flowing = !0, A(e));
                                };
                            }(n);
                            e.on("drain", h);
                            var f = !1;
                            var p = !1;
                            function m(t) {
                                d("ondata"), p = !1, !1 !== e.write(t) || p || ((1 === s.pipesCount && s.pipes === e || s.pipesCount > 1 && -1 !== I(s.pipes, e)) && !f && (d("false write response, pause", s.awaitDrain), s.awaitDrain++, p = !0), n.pause());
                            }
                            function b(t) {
                                d("onerror", t), v(), e.removeListener("error", b), 0 === a(e, "error") && e.emit("error", t);
                            }
                            function g() {
                                e.removeListener("finish", y), v();
                            }
                            function y() {
                                d("onfinish"), e.removeListener("close", g), v();
                            }
                            function v() {
                                d("unpipe"), n.unpipe(e);
                            }
                            return n.on("data", m), function(e, t, r) {
                                if ("function" == typeof e.prependListener) return e.prependListener(t, r);
                                e._events && e._events[t] ? o(e._events[t]) ? e._events[t].unshift(r) : e._events[t] = [
                                    r,
                                    e._events[t]
                                ] : e.on(t, r);
                            }(e, "error", b), e.once("close", g), e.once("finish", y), e.emit("pipe", n), s.flowing || (d("pipe resume"), n.resume()), e;
                        }, v.prototype.unpipe = function(e) {
                            var t = this._readableState, r = {
                                hasUnpiped: !1
                            };
                            if (0 === t.pipesCount) return this;
                            if (1 === t.pipesCount) return e && e !== t.pipes || (e || (e = t.pipes), t.pipes = null, t.pipesCount = 0, t.flowing = !1, e && e.emit("unpipe", this, r)), this;
                            if (!e) {
                                var n = t.pipes, i = t.pipesCount;
                                t.pipes = null, t.pipesCount = 0, t.flowing = !1;
                                for(var s = 0; s < i; s++)n[s].emit("unpipe", this, {
                                    hasUnpiped: !1
                                });
                                return this;
                            }
                            var o = I(t.pipes, e);
                            return -1 === o || (t.pipes.splice(o, 1), t.pipesCount -= 1, 1 === t.pipesCount && (t.pipes = t.pipes[0]), e.emit("unpipe", this, r)), this;
                        }, v.prototype.on = function(e, t) {
                            var r = l.prototype.on.call(this, e, t);
                            if ("data" === e) !1 !== this._readableState.flowing && this.resume();
                            else if ("readable" === e) {
                                var n = this._readableState;
                                n.endEmitted || n.readableListening || (n.readableListening = n.needReadable = !0, n.emittedReadable = !1, n.reading ? n.length && k(this) : i.nextTick(T, this));
                            }
                            return r;
                        }, v.prototype.addListener = v.prototype.on, v.prototype.resume = function() {
                            var e = this._readableState;
                            return e.flowing || (d("resume"), e.flowing = !0, function(e, t) {
                                t.resumeScheduled || (t.resumeScheduled = !0, i.nextTick(E, e, t));
                            }(this, e)), this;
                        }, v.prototype.pause = function() {
                            return d("call pause flowing=%j", this._readableState.flowing), !1 !== this._readableState.flowing && (d("pause"), this._readableState.flowing = !1, this.emit("pause")), this;
                        }, v.prototype.wrap = function(e) {
                            var t = this, r = this._readableState, n = !1;
                            for(var i in e.on("end", function() {
                                if (d("wrapped end"), r.decoder && !r.ended) {
                                    var e = r.decoder.end();
                                    e && e.length && t.push(e);
                                }
                                t.push(null);
                            }), e.on("data", function(i) {
                                (d("wrapped data"), r.decoder && (i = r.decoder.write(i)), r.objectMode && null == i) || (r.objectMode || i && i.length) && (t.push(i) || (n = !0, e.pause()));
                            }), e)void 0 === this[i] && "function" == typeof e[i] && (this[i] = function(t) {
                                return function() {
                                    return e[t].apply(e, arguments);
                                };
                            }(i));
                            for(var s = 0; s < g.length; s++)e.on(g[s], this.emit.bind(this, g[s]));
                            return this._read = function(t) {
                                d("wrapped _read", t), n && (n = !1, e.resume());
                            }, this;
                        }, Object.defineProperty(v.prototype, "readableHighWaterMark", {
                            enumerable: !1,
                            get: function() {
                                return this._readableState.highWaterMark;
                            }
                        }), v._fromList = R;
                    }).call(this);
                }).call(this, e("_process"), "undefined" != typeof $parcel$global ? $parcel$global : "undefined" != typeof self ? self : "undefined" != typeof window ? window : {});
            },
            {
                "./_stream_duplex": 508,
                "./internal/streams/BufferList": 513,
                "./internal/streams/destroy": 514,
                "./internal/streams/stream": 515,
                _process: 467,
                "core-util-is": 383,
                events: 422,
                inherits: 440,
                isarray: 506,
                "process-nextick-args": 466,
                "safe-buffer": 520,
                "string_decoder/": 521,
                util: 188
            }
        ],
        511: [
            function(e, t, r) {
                "use strict";
                t.exports = o;
                var n = e("./_stream_duplex"), i = Object.create(e("core-util-is"));
                function s(e, t) {
                    var r = this._transformState;
                    r.transforming = !1;
                    var n = r.writecb;
                    if (!n) return this.emit("error", new Error("write callback called multiple times"));
                    r.writechunk = null, r.writecb = null, null != t && this.push(t), n(e);
                    var i = this._readableState;
                    i.reading = !1, (i.needReadable || i.length < i.highWaterMark) && this._read(i.highWaterMark);
                }
                function o(e) {
                    if (!(this instanceof o)) return new o(e);
                    n.call(this, e), this._transformState = {
                        afterTransform: s.bind(this),
                        needTransform: !1,
                        transforming: !1,
                        writecb: null,
                        writechunk: null,
                        writeencoding: null
                    }, this._readableState.needReadable = !0, this._readableState.sync = !1, e && ("function" == typeof e.transform && (this._transform = e.transform), "function" == typeof e.flush && (this._flush = e.flush)), this.on("prefinish", a);
                }
                function a() {
                    var e = this;
                    "function" == typeof this._flush ? this._flush(function(t, r) {
                        l(e, t, r);
                    }) : l(this, null, null);
                }
                function l(e, t, r) {
                    if (t) return e.emit("error", t);
                    if (null != r && e.push(r), e._writableState.length) throw new Error("Calling transform done when ws.length != 0");
                    if (e._transformState.transforming) throw new Error("Calling transform done when still transforming");
                    return e.push(null);
                }
                i.inherits = e("inherits"), i.inherits(o, n), o.prototype.push = function(e, t) {
                    return this._transformState.needTransform = !1, n.prototype.push.call(this, e, t);
                }, o.prototype._transform = function(e, t, r) {
                    throw new Error("_transform() is not implemented");
                }, o.prototype._write = function(e, t, r) {
                    var n = this._transformState;
                    if (n.writecb = r, n.writechunk = e, n.writeencoding = t, !n.transforming) {
                        var i = this._readableState;
                        (n.needTransform || i.needReadable || i.length < i.highWaterMark) && this._read(i.highWaterMark);
                    }
                }, o.prototype._read = function(e) {
                    var t = this._transformState;
                    null !== t.writechunk && t.writecb && !t.transforming ? (t.transforming = !0, this._transform(t.writechunk, t.writeencoding, t.afterTransform)) : t.needTransform = !0;
                }, o.prototype._destroy = function(e, t) {
                    var r = this;
                    n.prototype._destroy.call(this, e, function(e) {
                        t(e), r.emit("close");
                    });
                };
            },
            {
                "./_stream_duplex": 508,
                "core-util-is": 383,
                inherits: 440
            }
        ],
        512: [
            function(e, t, r) {
                (function(r, n, i) {
                    (function() {
                        "use strict";
                        var s = e("process-nextick-args");
                        function o(e) {
                            var t = this;
                            this.next = null, this.entry = null, this.finish = function() {
                                !function(e, t, r) {
                                    var n = e.entry;
                                    e.entry = null;
                                    for(; n;){
                                        var i = n.callback;
                                        t.pendingcb--, i(r), n = n.next;
                                    }
                                    t.corkedRequestsFree.next = e;
                                }(t, e);
                            };
                        }
                        t.exports = y;
                        var a, l = !r.browser && [
                            "v0.10",
                            "v0.9."
                        ].indexOf(r.version.slice(0, 5)) > -1 ? i : s.nextTick;
                        y.WritableState = g;
                        var c = Object.create(e("core-util-is"));
                        c.inherits = e("inherits");
                        var u = {
                            deprecate: e("util-deprecate")
                        }, h = e("./internal/streams/stream"), f = e("safe-buffer").Buffer, d = (void 0 !== n ? n : "undefined" != typeof window ? window : "undefined" != typeof self ? self : {}).Uint8Array || function() {};
                        var p, m = e("./internal/streams/destroy");
                        function b() {}
                        function g(t, r) {
                            a = a || e("./_stream_duplex"), t = t || {};
                            var n = r instanceof a;
                            this.objectMode = !!t.objectMode, n && (this.objectMode = this.objectMode || !!t.writableObjectMode);
                            var i = t.highWaterMark, c = t.writableHighWaterMark, u = this.objectMode ? 16 : 16384;
                            this.highWaterMark = i || 0 === i ? i : n && (c || 0 === c) ? c : u, this.highWaterMark = Math.floor(this.highWaterMark), this.finalCalled = !1, this.needDrain = !1, this.ending = !1, this.ended = !1, this.finished = !1, this.destroyed = !1;
                            var h = !1 === t.decodeStrings;
                            this.decodeStrings = !h, this.defaultEncoding = t.defaultEncoding || "utf8", this.length = 0, this.writing = !1, this.corked = 0, this.sync = !0, this.bufferProcessing = !1, this.onwrite = function(e) {
                                !function(e, t) {
                                    var r = e._writableState, n = r.sync, i = r.writecb;
                                    if (function(e) {
                                        e.writing = !1, e.writecb = null, e.length -= e.writelen, e.writelen = 0;
                                    }(r), t) !function(e, t, r, n, i) {
                                        --t.pendingcb, r ? (s.nextTick(i, n), s.nextTick(S, e, t), e._writableState.errorEmitted = !0, e.emit("error", n)) : (i(n), e._writableState.errorEmitted = !0, e.emit("error", n), S(e, t));
                                    }(e, r, n, t, i);
                                    else {
                                        var o = x(r);
                                        o || r.corked || r.bufferProcessing || !r.bufferedRequest || _(e, r), n ? l(w, e, r, o, i) : w(e, r, o, i);
                                    }
                                }(r, e);
                            }, this.writecb = null, this.writelen = 0, this.bufferedRequest = null, this.lastBufferedRequest = null, this.pendingcb = 0, this.prefinished = !1, this.errorEmitted = !1, this.bufferedRequestCount = 0, this.corkedRequestsFree = new o(this);
                        }
                        function y(t) {
                            if (a = a || e("./_stream_duplex"), !(p.call(y, this) || this instanceof a)) return new y(t);
                            this._writableState = new g(t, this), this.writable = !0, t && ("function" == typeof t.write && (this._write = t.write), "function" == typeof t.writev && (this._writev = t.writev), "function" == typeof t.destroy && (this._destroy = t.destroy), "function" == typeof t.final && (this._final = t.final)), h.call(this);
                        }
                        function v(e, t, r, n, i, s, o) {
                            t.writelen = n, t.writecb = o, t.writing = !0, t.sync = !0, r ? e._writev(i, t.onwrite) : e._write(i, s, t.onwrite), t.sync = !1;
                        }
                        function w(e, t, r, n) {
                            r || function(e, t) {
                                0 === t.length && t.needDrain && (t.needDrain = !1, e.emit("drain"));
                            }(e, t), t.pendingcb--, n(), S(e, t);
                        }
                        function _(e, t) {
                            t.bufferProcessing = !0;
                            var r = t.bufferedRequest;
                            if (e._writev && r && r.next) {
                                var n = t.bufferedRequestCount, i = new Array(n), s = t.corkedRequestsFree;
                                s.entry = r;
                                for(var a = 0, l = !0; r;)i[a] = r, r.isBuf || (l = !1), r = r.next, a += 1;
                                i.allBuffers = l, v(e, t, !0, t.length, i, "", s.finish), t.pendingcb++, t.lastBufferedRequest = null, s.next ? (t.corkedRequestsFree = s.next, s.next = null) : t.corkedRequestsFree = new o(t), t.bufferedRequestCount = 0;
                            } else {
                                for(; r;){
                                    var c = r.chunk, u = r.encoding, h = r.callback;
                                    if (v(e, t, !1, t.objectMode ? 1 : c.length, c, u, h), r = r.next, t.bufferedRequestCount--, t.writing) break;
                                }
                                null === r && (t.lastBufferedRequest = null);
                            }
                            t.bufferedRequest = r, t.bufferProcessing = !1;
                        }
                        function x(e) {
                            return e.ending && 0 === e.length && null === e.bufferedRequest && !e.finished && !e.writing;
                        }
                        function k(e, t) {
                            e._final(function(r) {
                                t.pendingcb--, r && e.emit("error", r), t.prefinished = !0, e.emit("prefinish"), S(e, t);
                            });
                        }
                        function S(e, t) {
                            var r = x(t);
                            return r && (!function(e, t) {
                                t.prefinished || t.finalCalled || ("function" == typeof e._final ? (t.pendingcb++, t.finalCalled = !0, s.nextTick(k, e, t)) : (t.prefinished = !0, e.emit("prefinish")));
                            }(e, t), 0 === t.pendingcb && (t.finished = !0, e.emit("finish"))), r;
                        }
                        c.inherits(y, h), g.prototype.getBuffer = function() {
                            for(var e = this.bufferedRequest, t = []; e;)t.push(e), e = e.next;
                            return t;
                        }, function() {
                            try {
                                Object.defineProperty(g.prototype, "buffer", {
                                    get: u.deprecate(function() {
                                        return this.getBuffer();
                                    }, "_writableState.buffer is deprecated. Use _writableState.getBuffer instead.", "DEP0003")
                                });
                            } catch (e) {}
                        }(), "function" == typeof Symbol && Symbol.hasInstance && "function" == typeof Function.prototype[Symbol.hasInstance] ? (p = Function.prototype[Symbol.hasInstance], Object.defineProperty(y, Symbol.hasInstance, {
                            value: function(e) {
                                return !!p.call(this, e) || this === y && e && e._writableState instanceof g;
                            }
                        })) : p = function(e) {
                            return e instanceof this;
                        }, y.prototype.pipe = function() {
                            this.emit("error", new Error("Cannot pipe, not readable"));
                        }, y.prototype.write = function(e, t, r) {
                            var n, i = this._writableState, o = !1, a = !i.objectMode && (n = e, f.isBuffer(n) || n instanceof d);
                            return a && !f.isBuffer(e) && (e = function(e) {
                                return f.from(e);
                            }(e)), "function" == typeof t && (r = t, t = null), a ? t = "buffer" : t || (t = i.defaultEncoding), "function" != typeof r && (r = b), i.ended ? function(e, t) {
                                var r = new Error("write after end");
                                e.emit("error", r), s.nextTick(t, r);
                            }(this, r) : (a || function(e, t, r, n) {
                                var i = !0, o = !1;
                                return null === r ? o = new TypeError("May not write null values to stream") : "string" == typeof r || void 0 === r || t.objectMode || (o = new TypeError("Invalid non-string/buffer chunk")), o && (e.emit("error", o), s.nextTick(n, o), i = !1), i;
                            }(this, i, e, r)) && (i.pendingcb++, o = function(e, t, r, n, i, s) {
                                if (!r) {
                                    var o = function(e, t, r) {
                                        e.objectMode || !1 === e.decodeStrings || "string" != typeof t || (t = f.from(t, r));
                                        return t;
                                    }(t, n, i);
                                    n !== o && (r = !0, i = "buffer", n = o);
                                }
                                var a = t.objectMode ? 1 : n.length;
                                t.length += a;
                                var l = t.length < t.highWaterMark;
                                l || (t.needDrain = !0);
                                if (t.writing || t.corked) {
                                    var c = t.lastBufferedRequest;
                                    t.lastBufferedRequest = {
                                        chunk: n,
                                        encoding: i,
                                        isBuf: r,
                                        callback: s,
                                        next: null
                                    }, c ? c.next = t.lastBufferedRequest : t.bufferedRequest = t.lastBufferedRequest, t.bufferedRequestCount += 1;
                                } else v(e, t, !1, a, n, i, s);
                                return l;
                            }(this, i, a, e, t, r)), o;
                        }, y.prototype.cork = function() {
                            this._writableState.corked++;
                        }, y.prototype.uncork = function() {
                            var e = this._writableState;
                            e.corked && (e.corked--, e.writing || e.corked || e.bufferProcessing || !e.bufferedRequest || _(this, e));
                        }, y.prototype.setDefaultEncoding = function(e) {
                            if ("string" == typeof e && (e = e.toLowerCase()), !([
                                "hex",
                                "utf8",
                                "utf-8",
                                "ascii",
                                "binary",
                                "base64",
                                "ucs2",
                                "ucs-2",
                                "utf16le",
                                "utf-16le",
                                "raw"
                            ].indexOf((e + "").toLowerCase()) > -1)) throw new TypeError("Unknown encoding: " + e);
                            return this._writableState.defaultEncoding = e, this;
                        }, Object.defineProperty(y.prototype, "writableHighWaterMark", {
                            enumerable: !1,
                            get: function() {
                                return this._writableState.highWaterMark;
                            }
                        }), y.prototype._write = function(e, t, r) {
                            r(new Error("_write() is not implemented"));
                        }, y.prototype._writev = null, y.prototype.end = function(e, t, r) {
                            var n = this._writableState;
                            "function" == typeof e ? (r = e, e = null, t = null) : "function" == typeof t && (r = t, t = null), null != e && this.write(e, t), n.corked && (n.corked = 1, this.uncork()), n.ending || function(e, t, r) {
                                t.ending = !0, S(e, t), r && (t.finished ? s.nextTick(r) : e.once("finish", r));
                                t.ended = !0, e.writable = !1;
                            }(this, n, r);
                        }, Object.defineProperty(y.prototype, "destroyed", {
                            get: function() {
                                return void 0 !== this._writableState && this._writableState.destroyed;
                            },
                            set: function(e) {
                                this._writableState && (this._writableState.destroyed = e);
                            }
                        }), y.prototype.destroy = m.destroy, y.prototype._undestroy = m.undestroy, y.prototype._destroy = function(e, t) {
                            this.end(), t(e);
                        };
                    }).call(this);
                }).call(this, e("_process"), "undefined" != typeof $parcel$global ? $parcel$global : "undefined" != typeof self ? self : "undefined" != typeof window ? window : {}, e("timers").setImmediate);
            },
            {
                "./_stream_duplex": 508,
                "./internal/streams/destroy": 514,
                "./internal/streams/stream": 515,
                _process: 467,
                "core-util-is": 383,
                inherits: 440,
                "process-nextick-args": 466,
                "safe-buffer": 520,
                timers: 523,
                "util-deprecate": 524
            }
        ],
        513: [
            function(e, t, r) {
                "use strict";
                var n = e("safe-buffer").Buffer, i = e("util");
                t.exports = function() {
                    function e() {
                        !function(e, t) {
                            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                        }(this, e), this.head = null, this.tail = null, this.length = 0;
                    }
                    return e.prototype.push = function(e) {
                        var t = {
                            data: e,
                            next: null
                        };
                        this.length > 0 ? this.tail.next = t : this.head = t, this.tail = t, ++this.length;
                    }, e.prototype.unshift = function(e) {
                        var t = {
                            data: e,
                            next: this.head
                        };
                        0 === this.length && (this.tail = t), this.head = t, ++this.length;
                    }, e.prototype.shift = function() {
                        if (0 !== this.length) {
                            var e = this.head.data;
                            return 1 === this.length ? this.head = this.tail = null : this.head = this.head.next, --this.length, e;
                        }
                    }, e.prototype.clear = function() {
                        this.head = this.tail = null, this.length = 0;
                    }, e.prototype.join = function(e) {
                        if (0 === this.length) return "";
                        for(var t = this.head, r = "" + t.data; t = t.next;)r += e + t.data;
                        return r;
                    }, e.prototype.concat = function(e) {
                        if (0 === this.length) return n.alloc(0);
                        for(var t, r, i, s = n.allocUnsafe(e >>> 0), o = this.head, a = 0; o;)t = o.data, r = s, i = a, t.copy(r, i), a += o.data.length, o = o.next;
                        return s;
                    }, e;
                }(), i && i.inspect && i.inspect.custom && (t.exports.prototype[i.inspect.custom] = function() {
                    var e = i.inspect({
                        length: this.length
                    });
                    return this.constructor.name + " " + e;
                });
            },
            {
                "safe-buffer": 520,
                util: 188
            }
        ],
        514: [
            function(e, t, r) {
                "use strict";
                var n = e("process-nextick-args");
                function i(e, t) {
                    e.emit("error", t);
                }
                t.exports = {
                    destroy: function(e, t) {
                        var r = this, s = this._readableState && this._readableState.destroyed, o = this._writableState && this._writableState.destroyed;
                        return s || o ? (t ? t(e) : e && (this._writableState ? this._writableState.errorEmitted || (this._writableState.errorEmitted = !0, n.nextTick(i, this, e)) : n.nextTick(i, this, e)), this) : (this._readableState && (this._readableState.destroyed = !0), this._writableState && (this._writableState.destroyed = !0), this._destroy(e || null, function(e) {
                            !t && e ? r._writableState ? r._writableState.errorEmitted || (r._writableState.errorEmitted = !0, n.nextTick(i, r, e)) : n.nextTick(i, r, e) : t && t(e);
                        }), this);
                    },
                    undestroy: function() {
                        this._readableState && (this._readableState.destroyed = !1, this._readableState.reading = !1, this._readableState.ended = !1, this._readableState.endEmitted = !1), this._writableState && (this._writableState.destroyed = !1, this._writableState.ended = !1, this._writableState.ending = !1, this._writableState.finalCalled = !1, this._writableState.prefinished = !1, this._writableState.finished = !1, this._writableState.errorEmitted = !1);
                    }
                };
            },
            {
                "process-nextick-args": 466
            }
        ],
        515: [
            function(e, t, r) {
                arguments[4][490][0].apply(r, arguments);
            },
            {
                dup: 490,
                events: 422
            }
        ],
        516: [
            function(e, t, r) {
                "use strict";
                t.exports = e("./readable").PassThrough;
            },
            {
                "./readable": 517
            }
        ],
        517: [
            function(e, t, r) {
                "use strict";
                (r = t.exports = e("./lib/_stream_readable.js")).Stream = r, r.Readable = r, r.Writable = e("./lib/_stream_writable.js"), r.Duplex = e("./lib/_stream_duplex.js"), r.Transform = e("./lib/_stream_transform.js"), r.PassThrough = e("./lib/_stream_passthrough.js");
            },
            {
                "./lib/_stream_duplex.js": 508,
                "./lib/_stream_passthrough.js": 509,
                "./lib/_stream_readable.js": 510,
                "./lib/_stream_transform.js": 511,
                "./lib/_stream_writable.js": 512
            }
        ],
        518: [
            function(e, t, r) {
                "use strict";
                t.exports = e("./readable").Transform;
            },
            {
                "./readable": 517
            }
        ],
        519: [
            function(e, t, r) {
                "use strict";
                t.exports = e("./lib/_stream_writable.js");
            },
            {
                "./lib/_stream_writable.js": 512
            }
        ],
        520: [
            function(e, t, r) {
                arguments[4][217][0].apply(r, arguments);
            },
            {
                buffer: 220,
                dup: 217
            }
        ],
        521: [
            function(e, t, r) {
                arguments[4][218][0].apply(r, arguments);
            },
            {
                dup: 218,
                "safe-buffer": 520
            }
        ],
        522: [
            function(e, t, r) {
                arguments[4][218][0].apply(r, arguments);
            },
            {
                dup: 218,
                "safe-buffer": 494
            }
        ],
        523: [
            function(e, t, r) {
                (function(t, n) {
                    (function() {
                        "use strict";
                        var i = e("process/browser.js").nextTick, s = Function.prototype.apply, o = Array.prototype.slice, a = {}, l = 0;
                        function c(e, t) {
                            this._id = e, this._clearFn = t;
                        }
                        r.setTimeout = function() {
                            return new c(s.call(setTimeout, window, arguments), clearTimeout);
                        }, r.setInterval = function() {
                            return new c(s.call(setInterval, window, arguments), clearInterval);
                        }, r.clearTimeout = r.clearInterval = function(e) {
                            e.close();
                        }, c.prototype.unref = c.prototype.ref = function() {}, c.prototype.close = function() {
                            this._clearFn.call(window, this._id);
                        }, r.enroll = function(e, t) {
                            clearTimeout(e._idleTimeoutId), e._idleTimeout = t;
                        }, r.unenroll = function(e) {
                            clearTimeout(e._idleTimeoutId), e._idleTimeout = -1;
                        }, r._unrefActive = r.active = function(e) {
                            clearTimeout(e._idleTimeoutId);
                            var t = e._idleTimeout;
                            t >= 0 && (e._idleTimeoutId = setTimeout(function() {
                                e._onTimeout && e._onTimeout();
                            }, t));
                        }, r.setImmediate = "function" == typeof t ? t : function(e) {
                            var t = l++, n = !(arguments.length < 2) && o.call(arguments, 1);
                            return a[t] = !0, i(function() {
                                a[t] && (n ? e.apply(null, n) : e.call(null), r.clearImmediate(t));
                            }), t;
                        }, r.clearImmediate = "function" == typeof n ? n : function(e) {
                            delete a[e];
                        };
                    }).call(this);
                }).call(this, e("timers").setImmediate, e("timers").clearImmediate);
            },
            {
                "process/browser.js": 467,
                timers: 523
            }
        ],
        524: [
            function(e, t, r) {
                (function(e) {
                    (function() {
                        "use strict";
                        function r(t) {
                            try {
                                if (!e.localStorage) return !1;
                            } catch (e) {
                                return !1;
                            }
                            var r = e.localStorage[t];
                            return null != r && "true" === String(r).toLowerCase();
                        }
                        t.exports = function(e, t) {
                            if (r("noDeprecation")) return e;
                            var n = !1;
                            return function() {
                                if (!n) {
                                    if (r("throwDeprecation")) throw new Error(t);
                                    r("traceDeprecation") ? console.trace(t) : console.warn(t), n = !0;
                                }
                                return e.apply(this, arguments);
                            };
                        };
                    }).call(this);
                }).call(this, "undefined" != typeof $parcel$global ? $parcel$global : "undefined" != typeof self ? self : "undefined" != typeof window ? window : {});
            },
            {}
        ],
        525: [
            function(e, t, r) {
                "use strict";
                "function" == typeof Object.create ? t.exports = function(e, t) {
                    e.super_ = t, e.prototype = Object.create(t.prototype, {
                        constructor: {
                            value: e,
                            enumerable: !1,
                            writable: !0,
                            configurable: !0
                        }
                    });
                } : t.exports = function(e, t) {
                    e.super_ = t;
                    var r = function() {};
                    r.prototype = t.prototype, e.prototype = new r, e.prototype.constructor = e;
                };
            },
            {}
        ],
        526: [
            function(e, t, r) {
                "use strict";
                t.exports = function(e) {
                    return e && "object" == typeof e && "function" == typeof e.copy && "function" == typeof e.fill && "function" == typeof e.readUInt8;
                };
            },
            {}
        ],
        527: [
            function(e, t, r) {
                (function(t, n) {
                    (function() {
                        "use strict";
                        var i = /%[sdj%]/g;
                        r.format = function(e) {
                            if (!g(e)) {
                                for(var t = [], r = 0; r < arguments.length; r++)t.push(a(arguments[r]));
                                return t.join(" ");
                            }
                            r = 1;
                            for(var n = arguments, s = n.length, o = String(e).replace(i, function(e) {
                                if ("%%" === e) return "%";
                                if (r >= s) return e;
                                switch(e){
                                    case "%s":
                                        return String(n[r++]);
                                    case "%d":
                                        return Number(n[r++]);
                                    case "%j":
                                        try {
                                            return JSON.stringify(n[r++]);
                                        } catch (e) {
                                            return "[Circular]";
                                        }
                                    default:
                                        return e;
                                }
                            }), l = n[r]; r < s; l = n[++r])m(l) || !w(l) ? o += " " + l : o += " " + a(l);
                            return o;
                        }, r.deprecate = function(e, i) {
                            if (y(n.process)) return function() {
                                return r.deprecate(e, i).apply(this, arguments);
                            };
                            if (!0 === t.noDeprecation) return e;
                            var s = !1;
                            return function() {
                                if (!s) {
                                    if (t.throwDeprecation) throw new Error(i);
                                    t.traceDeprecation ? console.trace(i) : console.error(i), s = !0;
                                }
                                return e.apply(this, arguments);
                            };
                        };
                        var s, o = {};
                        function a(e, t) {
                            var n = {
                                seen: [],
                                stylize: c
                            };
                            return arguments.length >= 3 && (n.depth = arguments[2]), arguments.length >= 4 && (n.colors = arguments[3]), p(t) ? n.showHidden = t : t && r._extend(n, t), y(n.showHidden) && (n.showHidden = !1), y(n.depth) && (n.depth = 2), y(n.colors) && (n.colors = !1), y(n.customInspect) && (n.customInspect = !0), n.colors && (n.stylize = l), u(n, e, n.depth);
                        }
                        function l(e, t) {
                            var r = a.styles[t];
                            return r ? "\x1b[" + a.colors[r][0] + "m" + e + "\x1b[" + a.colors[r][1] + "m" : e;
                        }
                        function c(e, t) {
                            return e;
                        }
                        function u(e, t, n) {
                            if (e.customInspect && t && k(t.inspect) && t.inspect !== r.inspect && (!t.constructor || t.constructor.prototype !== t)) {
                                var i = t.inspect(n, e);
                                return g(i) || (i = u(e, i, n)), i;
                            }
                            var s = function(e, t) {
                                if (y(t)) return e.stylize("undefined", "undefined");
                                if (g(t)) {
                                    var r = "'" + JSON.stringify(t).replace(/^"|"$/g, "").replace(/'/g, "\\'").replace(/\\"/g, '"') + "'";
                                    return e.stylize(r, "string");
                                }
                                if (b(t)) return e.stylize("" + t, "number");
                                if (p(t)) return e.stylize("" + t, "boolean");
                                if (m(t)) return e.stylize("null", "null");
                            }(e, t);
                            if (s) return s;
                            var o = Object.keys(t), a = function(e) {
                                var t = {};
                                return e.forEach(function(e, r) {
                                    t[e] = !0;
                                }), t;
                            }(o);
                            if (e.showHidden && (o = Object.getOwnPropertyNames(t)), x(t) && (o.indexOf("message") >= 0 || o.indexOf("description") >= 0)) return h(t);
                            if (0 === o.length) {
                                if (k(t)) {
                                    var l = t.name ? ": " + t.name : "";
                                    return e.stylize("[Function" + l + "]", "special");
                                }
                                if (v(t)) return e.stylize(RegExp.prototype.toString.call(t), "regexp");
                                if (_(t)) return e.stylize(Date.prototype.toString.call(t), "date");
                                if (x(t)) return h(t);
                            }
                            var c, w = "", S = !1, M = [
                                "{",
                                "}"
                            ];
                            (d(t) && (S = !0, M = [
                                "[",
                                "]"
                            ]), k(t)) && (w = " [Function" + (t.name ? ": " + t.name : "") + "]");
                            return v(t) && (w = " " + RegExp.prototype.toString.call(t)), _(t) && (w = " " + Date.prototype.toUTCString.call(t)), x(t) && (w = " " + h(t)), 0 !== o.length || S && 0 != t.length ? n < 0 ? v(t) ? e.stylize(RegExp.prototype.toString.call(t), "regexp") : e.stylize("[Object]", "special") : (e.seen.push(t), c = S ? function(e, t, r, n, i) {
                                for(var s = [], o = 0, a = t.length; o < a; ++o)E(t, String(o)) ? s.push(f(e, t, r, n, String(o), !0)) : s.push("");
                                return i.forEach(function(i) {
                                    i.match(/^\d+$/) || s.push(f(e, t, r, n, i, !0));
                                }), s;
                            }(e, t, n, a, o) : o.map(function(r) {
                                return f(e, t, n, a, r, S);
                            }), e.seen.pop(), function(e, t, r) {
                                if (e.reduce(function(e, t) {
                                    return t.indexOf("\n"), e + t.replace(/\u001b\[\d\d?m/g, "").length + 1;
                                }, 0) > 60) return r[0] + ("" === t ? "" : t + "\n ") + " " + e.join(",\n  ") + " " + r[1];
                                return r[0] + t + " " + e.join(", ") + " " + r[1];
                            }(c, w, M)) : M[0] + w + M[1];
                        }
                        function h(e) {
                            return "[" + Error.prototype.toString.call(e) + "]";
                        }
                        function f(e, t, r, n, i, s) {
                            var o, a, l;
                            if ((l = Object.getOwnPropertyDescriptor(t, i) || {
                                value: t[i]
                            }).get ? a = l.set ? e.stylize("[Getter/Setter]", "special") : e.stylize("[Getter]", "special") : l.set && (a = e.stylize("[Setter]", "special")), E(n, i) || (o = "[" + i + "]"), a || (e.seen.indexOf(l.value) < 0 ? (a = m(r) ? u(e, l.value, null) : u(e, l.value, r - 1)).indexOf("\n") > -1 && (a = s ? a.split("\n").map(function(e) {
                                return "  " + e;
                            }).join("\n").substr(2) : "\n" + a.split("\n").map(function(e) {
                                return "   " + e;
                            }).join("\n")) : a = e.stylize("[Circular]", "special")), y(o)) {
                                if (s && i.match(/^\d+$/)) return a;
                                (o = JSON.stringify("" + i)).match(/^"([a-zA-Z_][a-zA-Z_0-9]*)"$/) ? (o = o.substr(1, o.length - 2), o = e.stylize(o, "name")) : (o = o.replace(/'/g, "\\'").replace(/\\"/g, '"').replace(/(^"|"$)/g, "'"), o = e.stylize(o, "string"));
                            }
                            return o + ": " + a;
                        }
                        function d(e) {
                            return Array.isArray(e);
                        }
                        function p(e) {
                            return "boolean" == typeof e;
                        }
                        function m(e) {
                            return null === e;
                        }
                        function b(e) {
                            return "number" == typeof e;
                        }
                        function g(e) {
                            return "string" == typeof e;
                        }
                        function y(e) {
                            return void 0 === e;
                        }
                        function v(e) {
                            return w(e) && "[object RegExp]" === S(e);
                        }
                        function w(e) {
                            return "object" == typeof e && null !== e;
                        }
                        function _(e) {
                            return w(e) && "[object Date]" === S(e);
                        }
                        function x(e) {
                            return w(e) && ("[object Error]" === S(e) || e instanceof Error);
                        }
                        function k(e) {
                            return "function" == typeof e;
                        }
                        function S(e) {
                            return Object.prototype.toString.call(e);
                        }
                        function M(e) {
                            return e < 10 ? "0" + e.toString(10) : e.toString(10);
                        }
                        r.debuglog = function(e) {
                            if (y(s) && (s = t.env.NODE_DEBUG || ""), e = e.toUpperCase(), !o[e]) {
                                if (new RegExp("\\b" + e + "\\b", "i").test(s)) {
                                    var n = t.pid;
                                    o[e] = function() {
                                        var t = r.format.apply(r, arguments);
                                        console.error("%s %d: %s", e, n, t);
                                    };
                                } else o[e] = function() {};
                            }
                            return o[e];
                        }, r.inspect = a, a.colors = {
                            bold: [
                                1,
                                22
                            ],
                            italic: [
                                3,
                                23
                            ],
                            underline: [
                                4,
                                24
                            ],
                            inverse: [
                                7,
                                27
                            ],
                            white: [
                                37,
                                39
                            ],
                            grey: [
                                90,
                                39
                            ],
                            black: [
                                30,
                                39
                            ],
                            blue: [
                                34,
                                39
                            ],
                            cyan: [
                                36,
                                39
                            ],
                            green: [
                                32,
                                39
                            ],
                            magenta: [
                                35,
                                39
                            ],
                            red: [
                                31,
                                39
                            ],
                            yellow: [
                                33,
                                39
                            ]
                        }, a.styles = {
                            special: "cyan",
                            number: "yellow",
                            boolean: "yellow",
                            undefined: "grey",
                            null: "bold",
                            string: "green",
                            date: "magenta",
                            regexp: "red"
                        }, r.isArray = d, r.isBoolean = p, r.isNull = m, r.isNullOrUndefined = function(e) {
                            return null == e;
                        }, r.isNumber = b, r.isString = g, r.isSymbol = function(e) {
                            return "symbol" == typeof e;
                        }, r.isUndefined = y, r.isRegExp = v, r.isObject = w, r.isDate = _, r.isError = x, r.isFunction = k, r.isPrimitive = function(e) {
                            return null === e || "boolean" == typeof e || "number" == typeof e || "string" == typeof e || "symbol" == typeof e || void 0 === e;
                        }, r.isBuffer = e("./support/isBuffer");
                        var C = [
                            "Jan",
                            "Feb",
                            "Mar",
                            "Apr",
                            "May",
                            "Jun",
                            "Jul",
                            "Aug",
                            "Sep",
                            "Oct",
                            "Nov",
                            "Dec"
                        ];
                        function T() {
                            var e = new Date, t = [
                                M(e.getHours()),
                                M(e.getMinutes()),
                                M(e.getSeconds())
                            ].join(":");
                            return [
                                e.getDate(),
                                C[e.getMonth()],
                                t
                            ].join(" ");
                        }
                        function E(e, t) {
                            return Object.prototype.hasOwnProperty.call(e, t);
                        }
                        r.log = function() {
                            console.log("%s - %s", T(), r.format.apply(r, arguments));
                        }, r.inherits = e("inherits"), r._extend = function(e, t) {
                            if (!t || !w(t)) return e;
                            for(var r = Object.keys(t), n = r.length; n--;)e[r[n]] = t[r[n]];
                            return e;
                        };
                    }).call(this);
                }).call(this, e("_process"), "undefined" != typeof $parcel$global ? $parcel$global : "undefined" != typeof self ? self : "undefined" != typeof window ? window : {});
            },
            {
                "./support/isBuffer": 526,
                _process: 467,
                inherits: 525
            }
        ],
        528: [
            function(e, t, r) {
                "use strict";
                Object.defineProperty(r, "__esModule", {
                    value: !0
                }), Object.defineProperty(r, "v1", {
                    enumerable: !0,
                    get: function() {
                        return n.default;
                    }
                }), Object.defineProperty(r, "v3", {
                    enumerable: !0,
                    get: function() {
                        return i.default;
                    }
                }), Object.defineProperty(r, "v4", {
                    enumerable: !0,
                    get: function() {
                        return s.default;
                    }
                }), Object.defineProperty(r, "v5", {
                    enumerable: !0,
                    get: function() {
                        return o.default;
                    }
                }), Object.defineProperty(r, "NIL", {
                    enumerable: !0,
                    get: function() {
                        return a.default;
                    }
                }), Object.defineProperty(r, "version", {
                    enumerable: !0,
                    get: function() {
                        return l.default;
                    }
                }), Object.defineProperty(r, "validate", {
                    enumerable: !0,
                    get: function() {
                        return c.default;
                    }
                }), Object.defineProperty(r, "stringify", {
                    enumerable: !0,
                    get: function() {
                        return u.default;
                    }
                }), Object.defineProperty(r, "parse", {
                    enumerable: !0,
                    get: function() {
                        return h.default;
                    }
                });
                var n = f(e("./v1.js")), i = f(e("./v3.js")), s = f(e("./v4.js")), o = f(e("./v5.js")), a = f(e("./nil.js")), l = f(e("./version.js")), c = f(e("./validate.js")), u = f(e("./stringify.js")), h = f(e("./parse.js"));
                function f(e) {
                    return e && e.__esModule ? e : {
                        default: e
                    };
                }
            },
            {
                "./nil.js": 530,
                "./parse.js": 531,
                "./stringify.js": 535,
                "./v1.js": 536,
                "./v3.js": 537,
                "./v4.js": 539,
                "./v5.js": 540,
                "./validate.js": 541,
                "./version.js": 542
            }
        ],
        529: [
            function(e, t, r) {
                "use strict";
                function n(e) {
                    return 14 + (e + 64 >>> 9 << 4) + 1;
                }
                function i(e, t) {
                    const r = (65535 & e) + (65535 & t);
                    return (e >> 16) + (t >> 16) + (r >> 16) << 16 | 65535 & r;
                }
                function s(e, t, r, n, s, o) {
                    var a, l;
                    return i((a = i(i(t, e), i(n, o))) << (l = s) | a >>> 32 - l, r);
                }
                function o(e, t, r, n, i, o, a) {
                    return s(t & r | ~t & n, e, t, i, o, a);
                }
                function a(e, t, r, n, i, o, a) {
                    return s(t & n | r & ~n, e, t, i, o, a);
                }
                function l(e, t, r, n, i, o, a) {
                    return s(t ^ r ^ n, e, t, i, o, a);
                }
                function c(e, t, r, n, i, o, a) {
                    return s(r ^ (t | ~n), e, t, i, o, a);
                }
                Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.default = void 0;
                var u = function(e) {
                    if ("string" == typeof e) {
                        const t = unescape(encodeURIComponent(e));
                        e = new Uint8Array(t.length);
                        for(let r = 0; r < t.length; ++r)e[r] = t.charCodeAt(r);
                    }
                    return function(e) {
                        const t = [], r = 32 * e.length;
                        for(let n = 0; n < r; n += 8){
                            const r = e[n >> 5] >>> n % 32 & 255, i = parseInt("0123456789abcdef".charAt(r >>> 4 & 15) + "0123456789abcdef".charAt(15 & r), 16);
                            t.push(i);
                        }
                        return t;
                    }(function(e, t) {
                        e[t >> 5] |= 128 << t % 32, e[n(t) - 1] = t;
                        let r = 1732584193, s = -271733879, u = -1732584194, h = 271733878;
                        for(let t = 0; t < e.length; t += 16){
                            const n = r, f = s, d = u, p = h;
                            r = o(r, s, u, h, e[t], 7, -680876936), h = o(h, r, s, u, e[t + 1], 12, -389564586), u = o(u, h, r, s, e[t + 2], 17, 606105819), s = o(s, u, h, r, e[t + 3], 22, -1044525330), r = o(r, s, u, h, e[t + 4], 7, -176418897), h = o(h, r, s, u, e[t + 5], 12, 1200080426), u = o(u, h, r, s, e[t + 6], 17, -1473231341), s = o(s, u, h, r, e[t + 7], 22, -45705983), r = o(r, s, u, h, e[t + 8], 7, 1770035416), h = o(h, r, s, u, e[t + 9], 12, -1958414417), u = o(u, h, r, s, e[t + 10], 17, -42063), s = o(s, u, h, r, e[t + 11], 22, -1990404162), r = o(r, s, u, h, e[t + 12], 7, 1804603682), h = o(h, r, s, u, e[t + 13], 12, -40341101), u = o(u, h, r, s, e[t + 14], 17, -1502002290), s = o(s, u, h, r, e[t + 15], 22, 1236535329), r = a(r, s, u, h, e[t + 1], 5, -165796510), h = a(h, r, s, u, e[t + 6], 9, -1069501632), u = a(u, h, r, s, e[t + 11], 14, 643717713), s = a(s, u, h, r, e[t], 20, -373897302), r = a(r, s, u, h, e[t + 5], 5, -701558691), h = a(h, r, s, u, e[t + 10], 9, 38016083), u = a(u, h, r, s, e[t + 15], 14, -660478335), s = a(s, u, h, r, e[t + 4], 20, -405537848), r = a(r, s, u, h, e[t + 9], 5, 568446438), h = a(h, r, s, u, e[t + 14], 9, -1019803690), u = a(u, h, r, s, e[t + 3], 14, -187363961), s = a(s, u, h, r, e[t + 8], 20, 1163531501), r = a(r, s, u, h, e[t + 13], 5, -1444681467), h = a(h, r, s, u, e[t + 2], 9, -51403784), u = a(u, h, r, s, e[t + 7], 14, 1735328473), s = a(s, u, h, r, e[t + 12], 20, -1926607734), r = l(r, s, u, h, e[t + 5], 4, -378558), h = l(h, r, s, u, e[t + 8], 11, -2022574463), u = l(u, h, r, s, e[t + 11], 16, 1839030562), s = l(s, u, h, r, e[t + 14], 23, -35309556), r = l(r, s, u, h, e[t + 1], 4, -1530992060), h = l(h, r, s, u, e[t + 4], 11, 1272893353), u = l(u, h, r, s, e[t + 7], 16, -155497632), s = l(s, u, h, r, e[t + 10], 23, -1094730640), r = l(r, s, u, h, e[t + 13], 4, 681279174), h = l(h, r, s, u, e[t], 11, -358537222), u = l(u, h, r, s, e[t + 3], 16, -722521979), s = l(s, u, h, r, e[t + 6], 23, 76029189), r = l(r, s, u, h, e[t + 9], 4, -640364487), h = l(h, r, s, u, e[t + 12], 11, -421815835), u = l(u, h, r, s, e[t + 15], 16, 530742520), s = l(s, u, h, r, e[t + 2], 23, -995338651), r = c(r, s, u, h, e[t], 6, -198630844), h = c(h, r, s, u, e[t + 7], 10, 1126891415), u = c(u, h, r, s, e[t + 14], 15, -1416354905), s = c(s, u, h, r, e[t + 5], 21, -57434055), r = c(r, s, u, h, e[t + 12], 6, 1700485571), h = c(h, r, s, u, e[t + 3], 10, -1894986606), u = c(u, h, r, s, e[t + 10], 15, -1051523), s = c(s, u, h, r, e[t + 1], 21, -2054922799), r = c(r, s, u, h, e[t + 8], 6, 1873313359), h = c(h, r, s, u, e[t + 15], 10, -30611744), u = c(u, h, r, s, e[t + 6], 15, -1560198380), s = c(s, u, h, r, e[t + 13], 21, 1309151649), r = c(r, s, u, h, e[t + 4], 6, -145523070), h = c(h, r, s, u, e[t + 11], 10, -1120210379), u = c(u, h, r, s, e[t + 2], 15, 718787259), s = c(s, u, h, r, e[t + 9], 21, -343485551), r = i(r, n), s = i(s, f), u = i(u, d), h = i(h, p);
                        }
                        return [
                            r,
                            s,
                            u,
                            h
                        ];
                    }(function(e) {
                        if (0 === e.length) return [];
                        const t = 8 * e.length, r = new Uint32Array(n(t));
                        for(let n = 0; n < t; n += 8)r[n >> 5] |= (255 & e[n / 8]) << n % 32;
                        return r;
                    }(e), 8 * e.length));
                };
                r.default = u;
            },
            {}
        ],
        530: [
            function(e, t, r) {
                "use strict";
                Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.default = void 0;
                r.default = "00000000-0000-0000-0000-000000000000";
            },
            {}
        ],
        531: [
            function(e, t, r) {
                "use strict";
                Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.default = void 0;
                var n, i = (n = e("./validate.js")) && n.__esModule ? n : {
                    default: n
                };
                var s = function(e) {
                    if (!(0, i.default)(e)) throw TypeError("Invalid UUID");
                    let t;
                    const r = new Uint8Array(16);
                    return r[0] = (t = parseInt(e.slice(0, 8), 16)) >>> 24, r[1] = t >>> 16 & 255, r[2] = t >>> 8 & 255, r[3] = 255 & t, r[4] = (t = parseInt(e.slice(9, 13), 16)) >>> 8, r[5] = 255 & t, r[6] = (t = parseInt(e.slice(14, 18), 16)) >>> 8, r[7] = 255 & t, r[8] = (t = parseInt(e.slice(19, 23), 16)) >>> 8, r[9] = 255 & t, r[10] = (t = parseInt(e.slice(24, 36), 16)) / 1099511627776 & 255, r[11] = t / 4294967296 & 255, r[12] = t >>> 24 & 255, r[13] = t >>> 16 & 255, r[14] = t >>> 8 & 255, r[15] = 255 & t, r;
                };
                r.default = s;
            },
            {
                "./validate.js": 541
            }
        ],
        532: [
            function(e, t, r) {
                "use strict";
                Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.default = void 0;
                r.default = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i;
            },
            {}
        ],
        533: [
            function(e, t, r) {
                "use strict";
                let n;
                Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.default = function() {
                    if (!n && (n = "undefined" != typeof crypto && crypto.getRandomValues && crypto.getRandomValues.bind(crypto) || "undefined" != typeof msCrypto && "function" == typeof msCrypto.getRandomValues && msCrypto.getRandomValues.bind(msCrypto), !n)) throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
                    return n(i);
                };
                const i = new Uint8Array(16);
            },
            {}
        ],
        534: [
            function(e, t, r) {
                "use strict";
                function n(e, t, r, n) {
                    switch(e){
                        case 0:
                            return t & r ^ ~t & n;
                        case 1:
                            return t ^ r ^ n;
                        case 2:
                            return t & r ^ t & n ^ r & n;
                        case 3:
                            return t ^ r ^ n;
                    }
                }
                function i(e, t) {
                    return e << t | e >>> 32 - t;
                }
                Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.default = void 0;
                var s = function(e) {
                    const t = [
                        1518500249,
                        1859775393,
                        2400959708,
                        3395469782
                    ], r = [
                        1732584193,
                        4023233417,
                        2562383102,
                        271733878,
                        3285377520
                    ];
                    if ("string" == typeof e) {
                        const t = unescape(encodeURIComponent(e));
                        e = [];
                        for(let r = 0; r < t.length; ++r)e.push(t.charCodeAt(r));
                    } else Array.isArray(e) || (e = Array.prototype.slice.call(e));
                    e.push(128);
                    const s = e.length / 4 + 2, o = Math.ceil(s / 16), a = new Array(o);
                    for(let t = 0; t < o; ++t){
                        const r = new Uint32Array(16);
                        for(let n = 0; n < 16; ++n)r[n] = e[64 * t + 4 * n] << 24 | e[64 * t + 4 * n + 1] << 16 | e[64 * t + 4 * n + 2] << 8 | e[64 * t + 4 * n + 3];
                        a[t] = r;
                    }
                    a[o - 1][14] = 8 * (e.length - 1) / Math.pow(2, 32), a[o - 1][14] = Math.floor(a[o - 1][14]), a[o - 1][15] = 8 * (e.length - 1) & 4294967295;
                    for(let e = 0; e < o; ++e){
                        const s = new Uint32Array(80);
                        for(let t = 0; t < 16; ++t)s[t] = a[e][t];
                        for(let e = 16; e < 80; ++e)s[e] = i(s[e - 3] ^ s[e - 8] ^ s[e - 14] ^ s[e - 16], 1);
                        let o = r[0], l = r[1], c = r[2], u = r[3], h = r[4];
                        for(let e = 0; e < 80; ++e){
                            const r = Math.floor(e / 20), a = i(o, 5) + n(r, l, c, u) + h + t[r] + s[e] >>> 0;
                            h = u, u = c, c = i(l, 30) >>> 0, l = o, o = a;
                        }
                        r[0] = r[0] + o >>> 0, r[1] = r[1] + l >>> 0, r[2] = r[2] + c >>> 0, r[3] = r[3] + u >>> 0, r[4] = r[4] + h >>> 0;
                    }
                    return [
                        r[0] >> 24 & 255,
                        r[0] >> 16 & 255,
                        r[0] >> 8 & 255,
                        255 & r[0],
                        r[1] >> 24 & 255,
                        r[1] >> 16 & 255,
                        r[1] >> 8 & 255,
                        255 & r[1],
                        r[2] >> 24 & 255,
                        r[2] >> 16 & 255,
                        r[2] >> 8 & 255,
                        255 & r[2],
                        r[3] >> 24 & 255,
                        r[3] >> 16 & 255,
                        r[3] >> 8 & 255,
                        255 & r[3],
                        r[4] >> 24 & 255,
                        r[4] >> 16 & 255,
                        r[4] >> 8 & 255,
                        255 & r[4]
                    ];
                };
                r.default = s;
            },
            {}
        ],
        535: [
            function(e, t, r) {
                "use strict";
                Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.default = void 0;
                var n, i = (n = e("./validate.js")) && n.__esModule ? n : {
                    default: n
                };
                const s = [];
                for(let e = 0; e < 256; ++e)s.push((e + 256).toString(16).substr(1));
                var o = function(e) {
                    let t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0;
                    const r = (s[e[t + 0]] + s[e[t + 1]] + s[e[t + 2]] + s[e[t + 3]] + "-" + s[e[t + 4]] + s[e[t + 5]] + "-" + s[e[t + 6]] + s[e[t + 7]] + "-" + s[e[t + 8]] + s[e[t + 9]] + "-" + s[e[t + 10]] + s[e[t + 11]] + s[e[t + 12]] + s[e[t + 13]] + s[e[t + 14]] + s[e[t + 15]]).toLowerCase();
                    if (!(0, i.default)(r)) throw TypeError("Stringified UUID is invalid");
                    return r;
                };
                r.default = o;
            },
            {
                "./validate.js": 541
            }
        ],
        536: [
            function(e, t, r) {
                "use strict";
                Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.default = void 0;
                var n = s(e("./rng.js")), i = s(e("./stringify.js"));
                function s(e) {
                    return e && e.__esModule ? e : {
                        default: e
                    };
                }
                let o, a, l = 0, c = 0;
                var u = function(e, t, r) {
                    let s = t && r || 0;
                    const u = t || new Array(16);
                    let h = (e = e || {}).node || o, f = void 0 !== e.clockseq ? e.clockseq : a;
                    if (null == h || null == f) {
                        const t = e.random || (e.rng || n.default)();
                        null == h && (h = o = [
                            1 | t[0],
                            t[1],
                            t[2],
                            t[3],
                            t[4],
                            t[5]
                        ]), null == f && (f = a = 16383 & (t[6] << 8 | t[7]));
                    }
                    let d = void 0 !== e.msecs ? e.msecs : Date.now(), p = void 0 !== e.nsecs ? e.nsecs : c + 1;
                    const m = d - l + (p - c) / 1e4;
                    if (m < 0 && void 0 === e.clockseq && (f = f + 1 & 16383), (m < 0 || d > l) && void 0 === e.nsecs && (p = 0), p >= 1e4) throw new Error("uuid.v1(): Can't create more than 10M uuids/sec");
                    l = d, c = p, a = f, d += 122192928e5;
                    const b = (1e4 * (268435455 & d) + p) % 4294967296;
                    u[s++] = b >>> 24 & 255, u[s++] = b >>> 16 & 255, u[s++] = b >>> 8 & 255, u[s++] = 255 & b;
                    const g = d / 4294967296 * 1e4 & 268435455;
                    u[s++] = g >>> 8 & 255, u[s++] = 255 & g, u[s++] = g >>> 24 & 15 | 16, u[s++] = g >>> 16 & 255, u[s++] = f >>> 8 | 128, u[s++] = 255 & f;
                    for(let e = 0; e < 6; ++e)u[s + e] = h[e];
                    return t || (0, i.default)(u);
                };
                r.default = u;
            },
            {
                "./rng.js": 533,
                "./stringify.js": 535
            }
        ],
        537: [
            function(e, t, r) {
                "use strict";
                Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.default = void 0;
                var n = s(e("./v35.js")), i = s(e("./md5.js"));
                function s(e) {
                    return e && e.__esModule ? e : {
                        default: e
                    };
                }
                var o = (0, n.default)("v3", 48, i.default);
                r.default = o;
            },
            {
                "./md5.js": 529,
                "./v35.js": 538
            }
        ],
        538: [
            function(e, t, r) {
                "use strict";
                Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.default = function(e, t, r) {
                    function s(e, s, o, a) {
                        if ("string" == typeof e && (e = function(e) {
                            e = unescape(encodeURIComponent(e));
                            const t = [];
                            for(let r = 0; r < e.length; ++r)t.push(e.charCodeAt(r));
                            return t;
                        }(e)), "string" == typeof s && (s = (0, i.default)(s)), 16 !== s.length) throw TypeError("Namespace must be array-like (16 iterable integer values, 0-255)");
                        let l = new Uint8Array(16 + e.length);
                        if (l.set(s), l.set(e, s.length), l = r(l), l[6] = 15 & l[6] | t, l[8] = 63 & l[8] | 128, o) {
                            a = a || 0;
                            for(let e = 0; e < 16; ++e)o[a + e] = l[e];
                            return o;
                        }
                        return (0, n.default)(l);
                    }
                    try {
                        s.name = e;
                    } catch (e) {}
                    return s.DNS = o, s.URL = a, s;
                }, r.URL = r.DNS = void 0;
                var n = s(e("./stringify.js")), i = s(e("./parse.js"));
                function s(e) {
                    return e && e.__esModule ? e : {
                        default: e
                    };
                }
                const o = "6ba7b810-9dad-11d1-80b4-00c04fd430c8";
                r.DNS = o;
                const a = "6ba7b811-9dad-11d1-80b4-00c04fd430c8";
                r.URL = a;
            },
            {
                "./parse.js": 531,
                "./stringify.js": 535
            }
        ],
        539: [
            function(e, t, r) {
                "use strict";
                Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.default = void 0;
                var n = s(e("./rng.js")), i = s(e("./stringify.js"));
                function s(e) {
                    return e && e.__esModule ? e : {
                        default: e
                    };
                }
                var o = function(e, t, r) {
                    const s = (e = e || {}).random || (e.rng || n.default)();
                    if (s[6] = 15 & s[6] | 64, s[8] = 63 & s[8] | 128, t) {
                        r = r || 0;
                        for(let e = 0; e < 16; ++e)t[r + e] = s[e];
                        return t;
                    }
                    return (0, i.default)(s);
                };
                r.default = o;
            },
            {
                "./rng.js": 533,
                "./stringify.js": 535
            }
        ],
        540: [
            function(e, t, r) {
                "use strict";
                Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.default = void 0;
                var n = s(e("./v35.js")), i = s(e("./sha1.js"));
                function s(e) {
                    return e && e.__esModule ? e : {
                        default: e
                    };
                }
                var o = (0, n.default)("v5", 80, i.default);
                r.default = o;
            },
            {
                "./sha1.js": 534,
                "./v35.js": 538
            }
        ],
        541: [
            function(e, t, r) {
                "use strict";
                Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.default = void 0;
                var n, i = (n = e("./regex.js")) && n.__esModule ? n : {
                    default: n
                };
                var s = function(e) {
                    return "string" == typeof e && i.default.test(e);
                };
                r.default = s;
            },
            {
                "./regex.js": 532
            }
        ],
        542: [
            function(e, t, r) {
                "use strict";
                Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.default = void 0;
                var n, i = (n = e("./validate.js")) && n.__esModule ? n : {
                    default: n
                };
                var s = function(e) {
                    if (!(0, i.default)(e)) throw TypeError("Invalid UUID");
                    return parseInt(e.substr(14, 1), 16);
                };
                r.default = s;
            },
            {
                "./validate.js": 541
            }
        ],
        543: [
            function(e, t, r) {
                "use strict";
                /**
 * Character classes and associated utilities for the 5th edition of XML 1.0.
 *
 * @author Louis-Dominique Dubeau
 * @license MIT
 * @copyright Louis-Dominique Dubeau
 */ Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.CHAR = "\t\n\r -\ud7ff\ue000-\ufffd\ud800\udc00-\udbff\udfff", r.S = " \t\r\n", r.NAME_START_CHAR = ":A-Z_a-z\xc0-\xd6\xd8-\xf6\xf8-\u02ff\u0370-\u037d\u037f-\u1fff\u200c\u200d\u2070-\u218f\u2c00-\u2fef\u3001-\ud7ff\uf900-\ufdcf\ufdf0-\ufffd\ud800\udc00-\udb7f\udfff", r.NAME_CHAR = "-" + r.NAME_START_CHAR + ".0-9\xb7\u0300-\u036f\u203f-\u2040", r.CHAR_RE = new RegExp("^[" + r.CHAR + "]$", "u"), r.S_RE = new RegExp("^[" + r.S + "]+$", "u"), r.NAME_START_CHAR_RE = new RegExp("^[" + r.NAME_START_CHAR + "]$", "u"), r.NAME_CHAR_RE = new RegExp("^[" + r.NAME_CHAR + "]$", "u"), r.NAME_RE = new RegExp("^[" + r.NAME_START_CHAR + "][" + r.NAME_CHAR + "]*$", "u"), r.NMTOKEN_RE = new RegExp("^[" + r.NAME_CHAR + "]+$", "u");
                function n(e) {
                    return e >= 65 && e <= 90 || e >= 97 && e <= 122 || 58 === e || 95 === e || 8204 === e || 8205 === e || e >= 192 && e <= 214 || e >= 216 && e <= 246 || e >= 248 && e <= 767 || e >= 880 && e <= 893 || e >= 895 && e <= 8191 || e >= 8304 && e <= 8591 || e >= 11264 && e <= 12271 || e >= 12289 && e <= 55295 || e >= 63744 && e <= 64975 || e >= 65008 && e <= 65533 || e >= 65536 && e <= 983039;
                }
                r.S_LIST = [
                    32,
                    10,
                    13,
                    9
                ], r.isChar = function(e) {
                    return e >= 32 && e <= 55295 || 10 === e || 13 === e || 9 === e || e >= 57344 && e <= 65533 || e >= 65536 && e <= 1114111;
                }, r.isS = function(e) {
                    return 32 === e || 10 === e || 13 === e || 9 === e;
                }, r.isNameStartChar = n, r.isNameChar = function(e) {
                    return n(e) || e >= 48 && e <= 57 || 45 === e || 46 === e || 183 === e || e >= 768 && e <= 879 || e >= 8255 && e <= 8256;
                };
            },
            {}
        ],
        544: [
            function(e, t, r) {
                "use strict";
                /**
 * Character classes and associated utilities for the 2nd edition of XML 1.1.
 *
 * @author Louis-Dominique Dubeau
 * @license MIT
 * @copyright Louis-Dominique Dubeau
 */ Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.CHAR = "\x01-\ud7ff\ue000-\ufffd\ud800\udc00-\udbff\udfff", r.RESTRICTED_CHAR = "\x01-\b\v\f\x0e-\x1f\x7f-\x84\x86-\x9f", r.S = " \t\r\n", r.NAME_START_CHAR = ":A-Z_a-z\xc0-\xd6\xd8-\xf6\xf8-\u02ff\u0370-\u037d\u037f-\u1fff\u200c\u200d\u2070-\u218f\u2c00-\u2fef\u3001-\ud7ff\uf900-\ufdcf\ufdf0-\ufffd\ud800\udc00-\udb7f\udfff", r.NAME_CHAR = "-" + r.NAME_START_CHAR + ".0-9\xb7\u0300-\u036f\u203f-\u2040", r.CHAR_RE = new RegExp("^[" + r.CHAR + "]$", "u"), r.RESTRICTED_CHAR_RE = new RegExp("^[" + r.RESTRICTED_CHAR + "]$", "u"), r.S_RE = new RegExp("^[" + r.S + "]+$", "u"), r.NAME_START_CHAR_RE = new RegExp("^[" + r.NAME_START_CHAR + "]$", "u"), r.NAME_CHAR_RE = new RegExp("^[" + r.NAME_CHAR + "]$", "u"), r.NAME_RE = new RegExp("^[" + r.NAME_START_CHAR + "][" + r.NAME_CHAR + "]*$", "u"), r.NMTOKEN_RE = new RegExp("^[" + r.NAME_CHAR + "]+$", "u");
                function n(e) {
                    return e >= 65 && e <= 90 || e >= 97 && e <= 122 || 58 === e || 95 === e || 8204 === e || 8205 === e || e >= 192 && e <= 214 || e >= 216 && e <= 246 || e >= 248 && e <= 767 || e >= 880 && e <= 893 || e >= 895 && e <= 8191 || e >= 8304 && e <= 8591 || e >= 11264 && e <= 12271 || e >= 12289 && e <= 55295 || e >= 63744 && e <= 64975 || e >= 65008 && e <= 65533 || e >= 65536 && e <= 983039;
                }
                r.S_LIST = [
                    32,
                    10,
                    13,
                    9
                ], r.isChar = function(e) {
                    return e >= 1 && e <= 55295 || e >= 57344 && e <= 65533 || e >= 65536 && e <= 1114111;
                }, r.isRestrictedChar = function(e) {
                    return e >= 1 && e <= 8 || 11 === e || 12 === e || e >= 14 && e <= 31 || e >= 127 && e <= 132 || e >= 134 && e <= 159;
                }, r.isCharAndNotRestricted = function(e) {
                    return 9 === e || 10 === e || 13 === e || e > 31 && e < 127 || 133 === e || e > 159 && e <= 55295 || e >= 57344 && e <= 65533 || e >= 65536 && e <= 1114111;
                }, r.isS = function(e) {
                    return 32 === e || 10 === e || 13 === e || 9 === e;
                }, r.isNameStartChar = n, r.isNameChar = function(e) {
                    return n(e) || e >= 48 && e <= 57 || 45 === e || 46 === e || 183 === e || e >= 768 && e <= 879 || e >= 8255 && e <= 8256;
                };
            },
            {}
        ],
        545: [
            function(e, t, r) {
                "use strict";
                /**
 * Character class utilities for XML NS 1.0 edition 3.
 *
 * @author Louis-Dominique Dubeau
 * @license MIT
 * @copyright Louis-Dominique Dubeau
 */ function n(e) {
                    return e >= 65 && e <= 90 || 95 === e || e >= 97 && e <= 122 || e >= 192 && e <= 214 || e >= 216 && e <= 246 || e >= 248 && e <= 767 || e >= 880 && e <= 893 || e >= 895 && e <= 8191 || e >= 8204 && e <= 8205 || e >= 8304 && e <= 8591 || e >= 11264 && e <= 12271 || e >= 12289 && e <= 55295 || e >= 63744 && e <= 64975 || e >= 65008 && e <= 65533 || e >= 65536 && e <= 983039;
                }
                Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.NC_NAME_START_CHAR = "A-Z_a-z\xc0-\xd6\xd8-\xf6\xf8-\u02ff\u0370-\u037d\u037f-\u1fff\u200c-\u200d\u2070-\u218f\u2c00-\u2fef\u3001-\ud7ff\uf900-\ufdcf\ufdf0-\ufffd\ud800\udc00-\udb7f\udfff", r.NC_NAME_CHAR = "-" + r.NC_NAME_START_CHAR + ".0-9\xb7\u0300-\u036f\u203f-\u2040", r.NC_NAME_START_CHAR_RE = new RegExp("^[" + r.NC_NAME_START_CHAR + "]$", "u"), r.NC_NAME_CHAR_RE = new RegExp("^[" + r.NC_NAME_CHAR + "]$", "u"), r.NC_NAME_RE = new RegExp("^[" + r.NC_NAME_START_CHAR + "][" + r.NC_NAME_CHAR + "]*$", "u"), r.isNCNameStartChar = n, r.isNCNameChar = function(e) {
                    return n(e) || 45 === e || 46 === e || e >= 48 && e <= 57 || 183 === e || e >= 768 && e <= 879 || e >= 8255 && e <= 8256;
                };
            },
            {}
        ]
    }, {}, [
        15
    ])(15);
});


function $78b00d0027f221e5$var$parseDelimitedText(text) {
    const result = $8f784678e653c95f$exports.parse(text, {
        header: true,
        skipEmptyLines: "greedy",
        transform: (value)=>value == null ? "" : value
    });
    const fields = result.meta.fields;
    if (!fields || fields.length === 0) return {
        headers: [],
        rows: []
    };
    const headers = fields.map((field)=>String(field ?? "").trim());
    const rows = result.data.map((row)=>fields.map((field)=>String(row[field] ?? "")));
    return {
        headers: headers,
        rows: rows
    };
}
async function $78b00d0027f221e5$var$parseXlsxWorkbook(buffer) {
    const workbook = new $c5a62d48f5fefafb$exports.Workbook();
    await workbook.xlsx.load(buffer);
    const sheets = [];
    workbook.eachSheet((worksheet)=>{
        const matrix = [];
        let maxCols = 0;
        worksheet.eachRow((row)=>{
            const cells = [];
            row.eachCell({
                includeEmpty: true
            }, (cell)=>{
                cells.push(cell.text ?? "");
            });
            matrix.push(cells);
            maxCols = Math.max(maxCols, cells.length);
        });
        if (matrix.length === 0) {
            sheets.push({
                name: worksheet.name,
                headers: [],
                rows: []
            });
            return;
        }
        const padRow = (r)=>{
            const result = r.map((c)=>String(c ?? ""));
            while(result.length < maxCols)result.push("");
            return result;
        };
        const headers = padRow(matrix[0]).map((h)=>h.trim());
        const rows = matrix.slice(1).map(padRow);
        sheets.push({
            name: worksheet.name,
            headers: headers,
            rows: rows
        });
    });
    return sheets;
}
const $78b00d0027f221e5$var$SpreadsheetPreviewPort = {
    add: function(app) {
        if (!app.ports.requestSpreadsheetPreview || !app.ports.spreadsheetPreviewResult) return;
        app.ports.requestSpreadsheetPreview.subscribe(async ({ requestId: requestId, url: url, kind: kind })=>{
            const sendFail = ()=>{
                app.ports.spreadsheetPreviewResult.send({
                    requestId: requestId,
                    ok: false,
                    kind: kind
                });
            };
            try {
                const res = await fetch(url);
                if (!res.ok) {
                    sendFail();
                    return;
                }
                if (kind === "csv") {
                    const text = await res.text();
                    const grid = $78b00d0027f221e5$var$parseDelimitedText(text);
                    app.ports.spreadsheetPreviewResult.send({
                        requestId: requestId,
                        ok: true,
                        kind: "csv",
                        grid: grid
                    });
                } else if (kind === "xlsx") {
                    const buffer = await res.arrayBuffer();
                    const sheets = await $78b00d0027f221e5$var$parseXlsxWorkbook(buffer);
                    app.ports.spreadsheetPreviewResult.send({
                        requestId: requestId,
                        ok: true,
                        kind: "xlsx",
                        sheets: sheets
                    });
                } else sendFail();
            } catch  {
                sendFail();
            }
        });
    }
};
$78b00d0027f221e5$exports = $78b00d0027f221e5$var$SpreadsheetPreviewPort;


const $736c28728eccce35$var$sentryDsn = `https://${CONFIGURATION.sentryKey}@${CONFIGURATION.sentryOrganizationId}.ingest.sentry.io/${CONFIGURATION.sentryProjectId}`;
$776bdb0abf297828$export$2cd8252107eb640b({
    dsn: $736c28728eccce35$var$sentryDsn,
    environment: CONFIGURATION.sentryEnvironment,
    release: CONFIGURATION.sentryReleaseVersion,
    maxValueLength: 1000,
    ignoreErrors: [
        "Cannot resolve iframe with unknown index"
    ],
    denyUrls: [
        /extensions\//i
    ]
});
$5125ad3d1e13a914$export$8e8e7789d42ed61d("api_version", CONFIGURATION.apiVersion);
// Initial data passed to Elm (should match `Flags` defined in `Shared.elm`)
// https://guide.elm-lang.org/interop/flags.html
var $736c28728eccce35$var$flags = {
    locationHref: location.href,
    accountToken: $36331f456e6baed0$exports.getItem("accountToken") || null,
    bustCacheRandom: Math.random().toString(36).slice(2),
    accountPracticeId: $f2086779cc7dd10e$exports.getItem("accountPracticeId"),
    apiUrl: CONFIGURATION.apiUrl,
    apiVersion: CONFIGURATION.apiVersion || null,
    emrNotesUrl: CONFIGURATION.emrNotesUrl,
    emrNotesVersion: CONFIGURATION.emrNotesVersion || null,
    emrCalendarsUrl: CONFIGURATION.emrCalendarsUrl,
    emrCalendarsVersion: CONFIGURATION.emrCalendarsVersion || null,
    emrMessagingUrl: CONFIGURATION.emrMessagingUrl,
    emrMessagingVersion: CONFIGURATION.emrMessagingVersion || null,
    release: CONFIGURATION.release || null,
    currentTime: new Date().getTime(),
    language: $f2086779cc7dd10e$exports.getItem("hint-language") || navigator.language,
    hintEnv: CONFIGURATION.hintEnv || null
};
// Start our Elm application
const $736c28728eccce35$var$app = (0, $b9e750d20bbc1f0f$exports.Elm).Main.init({
    node: document.getElementById("elm-main"),
    flags: $736c28728eccce35$var$flags
});
// Ports go here
// https://guide.elm-lang.org/interop/ports.html
$397bcf58b99e38b9$exports.add($736c28728eccce35$var$app);
$085e3b96bb7da772$exports.add($736c28728eccce35$var$app, CONFIGURATION.fullStoryOrgId);
$0d34a6c94bf1f37e$exports.add($736c28728eccce35$var$app, CONFIGURATION.googleMapsKey);
$44d2ba25a7bfecb2$exports.add($736c28728eccce35$var$app);
$f2086779cc7dd10e$exports.add($736c28728eccce35$var$app);
$1e586fe0a96f962b$exports.add($736c28728eccce35$var$app);
$3cef90824005e2d6$exports.add($736c28728eccce35$var$app, CONFIGURATION.env);
$d5d5137484b98c41$exports.add($736c28728eccce35$var$app, CONFIGURATION.stripePublishableKey);
$b78de99e3cb6b90b$exports.add($736c28728eccce35$var$app);
$72eb1b7e8424fce8$exports.add($736c28728eccce35$var$app);
$f4b7f13ee09e6363$exports.add($736c28728eccce35$var$app);
$53030c4d0d659628$exports.add($736c28728eccce35$var$app);
$88841e90a30ba512$exports.add($736c28728eccce35$var$app);
$13a1730e1cbf1cc4$exports.add($736c28728eccce35$var$app);
$b28e419d9143a3c3$exports.add($736c28728eccce35$var$app);
$f2c7c3c854a3894f$exports.add($736c28728eccce35$var$app, CONFIGURATION.intercomAppId);
$15ca76013f461cc0$exports.add($736c28728eccce35$var$app);
$d13a3aa875c41ca7$exports.add($736c28728eccce35$var$app);
$d2be32b72d8b955d$exports.add($736c28728eccce35$var$app);
$a8ede6276a337434$exports.initFileSelection($736c28728eccce35$var$app);
$70bed06a98643566$exports.add($736c28728eccce35$var$app);
$ba7a6a20ab3b4d24$exports.add($736c28728eccce35$var$app);
$36331f456e6baed0$exports.add($736c28728eccce35$var$app);
$3b9526d384f0dd3d$exports.add($736c28728eccce35$var$app);
$8e7e1145409c40a4$exports.add($736c28728eccce35$var$app);
$5ce5aeca99e3b2a2$exports.add($736c28728eccce35$var$app);
$73cbf435bf470aed$exports.add($736c28728eccce35$var$app);
$78b00d0027f221e5$exports.add($736c28728eccce35$var$app);
(0, $5b09ccb12fff0951$export$2e2bcd8739ae039).add($736c28728eccce35$var$app);
(0, $b25dfe2ee2c25921$export$2e2bcd8739ae039).add($736c28728eccce35$var$app);
if (CONFIGURATION.statuspageEmbedCode) window.setupStatusPage(CONFIGURATION.statuspageEmbedCode);
if (CONFIGURATION.newRelicAccountId && CONFIGURATION.newRelicLicenseKey && CONFIGURATION.newRelicApplicationId && typeof setupNewRelic !== "undefined") setupNewRelic(CONFIGURATION.newRelicAccountId, CONFIGURATION.newRelicLicenseKey, CONFIGURATION.newRelicApplicationId);
// detect if device is an iOS device and disable auto-zoom when clicking into elements
// https://stackoverflow.com/a/57527009
if (/iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream) {
    const el = document.querySelector("meta[name=viewport]");
    if (el !== null) {
        let content = el.getAttribute("content");
        let re = /maximum-scale=[0-9.]+/g;
        if (re.test(content)) content = content.replace(re, "maximum-scale=1.0");
        else content = [
            content,
            "maximum-scale=1.0"
        ].join(", ");
        el.setAttribute("content", content);
    }
}


//# sourceMappingURL=member-portal-elm.d8e91627.js.map
